/*!
 * PSPDFKit for Web 2024.5.0 (https://pspdfkit.com/web)
 *
 * Copyright (c) 2016-2024 PSPDFKit GmbH. All rights reserved.
 *
 * THIS SOURCE CODE AND ANY ACCOMPANYING DOCUMENTATION ARE PROTECTED BY INTERNATIONAL COPYRIGHT LAW
 * AND MAY NOT BE RESOLD OR REDISTRIBUTED. USAGE IS BOUND TO THE PSPDFKIT LICENSE AGREEMENT.
 * UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS SUBJECT TO CIVIL AND CRIMINAL PENALTIES.
 * This notice may not be removed from this file.
 *
 * PSPDFKit uses several open source third-party components: https://pspdfkit.com/acknowledgements/web/
 */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.PSPDFKit = t() : e.PSPDFKit = t();
}(self, () => (() => {
  var e,
    t,
    n,
    r,
    o = {
      96156: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(27350);
        function o(e, t, n) {
          return (t = (0, r.Z)(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
      },
      22122: (e, t, n) => {
        "use strict";

        function r() {
          return r = Object.assign ? Object.assign.bind() : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, r.apply(this, arguments);
        }
        n.d(t, {
          Z: () => r
        });
      },
      17375: (e, t, n) => {
        "use strict";

        function r(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        n.d(t, {
          Z: () => r
        });
      },
      30585: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(90484);
        function o(e, t) {
          if ("object" !== (0, r.Z)(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var o = n.call(e, t || "default");
            if ("object" !== (0, r.Z)(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return ("string" === t ? String : Number)(e);
        }
      },
      27350: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(90484),
          o = n(30585);
        function i(e) {
          var t = (0, o.Z)(e, "string");
          return "symbol" === (0, r.Z)(t) ? t : String(t);
        }
      },
      90484: (e, t, n) => {
        "use strict";

        function r(e) {
          return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, r(e);
        }
        n.d(t, {
          Z: () => r
        });
      },
      2252: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          Comment: () => K,
          Devtools: () => M,
          SignatureTextInput: () => P,
          Stamp: () => R
        });
        var r = n(98502),
          o = n(67294),
          i = n(8840),
          a = n(70799),
          s = n(85893),
          l = n(20770),
          u = n(43098),
          c = n(45071),
          d = n(99666),
          p = n(85816),
          h = n(73935),
          f = n(83034),
          m = n(36590),
          g = n.n(m);
        function v(e) {
          var t = function (e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : String(t);
        }
        function y(e, t, n) {
          return (t = v(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function b(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function w(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function x(e, t) {
          var n = {};
          for (var r in e) n[r] = t(e[r], r);
          return n;
        }
        var D = (e, t, n) => {
            for (var r of Object.keys(e)) {
              var o;
              if (e[r] !== (null !== (o = t[r]) && void 0 !== o ? o : n[r])) return !1;
            }
            return !0;
          },
          C = e => {
            var t = t => {
              var n = e.defaultClassName,
                r = w(w({}, e.defaultVariants), t);
              for (var o in r) {
                var i,
                  a = null !== (i = r[o]) && void 0 !== i ? i : e.defaultVariants[o];
                if (null != a) {
                  var s = a;
                  "boolean" == typeof s && (s = !0 === s ? "true" : "false");
                  var l = e.variantClassNames[o][s];
                  l && (n += " " + l);
                }
              }
              for (var [u, c] of e.compoundVariants) D(u, r, e.defaultVariants) && (n += " " + c);
              return n;
            };
            return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
              get base() {
                return e.defaultClassName.split(" ")[0];
              },
              get variants() {
                return x(e.variantClassNames, e => x(e, e => e.split(" ")[0]));
              }
            }, t;
          },
          S = C({
            defaultClassName: "_96lriw3",
            variantClassNames: {
              isFocusVisible: {
                true: "_96lriw4"
              },
              isDisabled: {
                true: "_1yep5z6da"
              },
              isInline: {
                false: "_96lriw6 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z6kv _1yep5z6g5",
                true: "_96lriw7 _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6gq _1yep5z6g3"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          E = C({
            defaultClassName: "_96lriw8 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6dy _1yep5z6f9",
            variantClassNames: {
              isInline: {
                false: "_96lriw9",
                true: "_96lriwa"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          _ = C({
            defaultClassName: "_96lriw0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              isInline: {
                false: "_96lriw1",
                true: "_1yep5z69o _1yep5z69p _1yep5z69q"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          P = o.forwardRef(({
            className: e,
            style: t,
            inputStyle: n,
            inputClassName: l,
            clearLabel: u,
            defaultValue: c,
            value: d,
            "data-block-id": p,
            isInline: h = !0,
            label: f,
            footerStyle: m,
            footerClassName: g,
            ...v
          }, y) => {
            let b = o.useRef(null),
              [w, x] = o.useState(d || c || ""),
              {
                inputProps: D,
                labelProps: C
              } = (0, a.hR)({
                ...v,
                value: d || w,
                onChange: e => {
                  v.onChange?.(e), x(e);
                },
                "aria-label": f
              }, b),
              {
                isFocusVisible: P,
                focusProps: k
              } = (0, a.Fx)({
                isTextInput: !0
              });
            return (0, s.jsxs)(r.Group, {
              className: (0, i.AK)(_({
                isInline: h
              }), "BaselineUI-SignatureTextInput", e),
              style: t,
              ref: y,
              "data-block-id": p,
              children: [(0, s.jsx)("input", {
                ...(0, a.dG)(D, k),
                className: (0, i.AK)(S({
                  isFocusVisible: P,
                  isDisabled: v.isDisabled,
                  isInline: h
                }), l),
                ref: b,
                style: n
              }), (0, s.jsx)("div", {
                className: (0, i.AK)(h ? void 0 : "_1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6fu _1yep5z6kv _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jl _1yep5z6jm _1yep5z6jn", g),
                style: m,
                children: b.current?.value ? (0, s.jsx)(r.ActionButton, {
                  label: u,
                  variant: "ghost",
                  size: h ? "md" : "sm",
                  isDisabled: v.isDisabled || !w,
                  onPress: () => {
                    x(""), v.onChange?.("");
                  }
                }) : (0, s.jsx)("label", {
                  ...C,
                  "aria-disabled": "true",
                  className: E({
                    isInline: h
                  }),
                  children: f
                })
              })]
            });
          });
        P.displayName = "SignatureTextInput";
        var k = C({
            defaultClassName: "jzfzia3",
            variantClassNames: {
              isFocusVisible: {
                true: "jzfzia4"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          A = ({
            children: e
          }) => {
            let t = o.useRef(null),
              {
                focusProps: n,
                isFocusVisible: i
              } = (0, a.Fx)(),
              [p, h] = (0, r.useLocalStorage)("bui-devtools", {
                x: 0,
                y: 0
              }),
              {
                buttonProps: f
              } = (0, a.UW)({}, t),
              [m, g] = (0, u.q_)(() => ({
                left: p.x,
                top: p.y,
                config: {
                  tension: 600,
                  friction: 30
                }
              })),
              v = o.useRef(null),
              y = (0, l.nP)(),
              {
                size: b = {
                  width: 0,
                  height: 0
                }
              } = (0, r.useResizeObserver)({
                ref: v
              }),
              {
                moveProps: w
              } = (0, a.r_)({
                onMove: e => {
                  h(({
                    x: t,
                    y: n
                  }) => {
                    "keyboard" === e.pointerType && (t = (0, l.uZ)(t, 0, y.width), n = (0, l.uZ)(n, 0, y.height));
                    let r = e.shiftKey ? 10 : 1;
                    return {
                      x: t += e.deltaX * r,
                      y: n += e.deltaY * r
                    };
                  });
                }
              });
            return (0, c.useGranularLayoutEffect)(() => {
              g.start({
                left: (0, l.uZ)(p.x, 0, y.width - b.width),
                top: (0, l.uZ)(p.y, 0, y.height - b.height)
              });
            }, [p], [g, y, b]), (0, s.jsx)(r.Portal, {
              children: (0, s.jsxs)(u.q.div, {
                role: "toolbar",
                ref: v,
                className: "jzfzia1 _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6d7 _1yep5z6gq _1yep5z6fs _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6f0",
                style: m,
                children: [(0, s.jsx)("button", {
                  ...(0, a.dG)(w, n, f),
                  className: k({
                    isFocusVisible: i
                  }),
                  ref: t,
                  "aria-label": "Drag to move",
                  children: (0, s.jsx)(d.YAN, {
                    className: "jzfzia5",
                    size: 20
                  })
                }), (0, s.jsx)(r.Separator, {
                  orientation: "vertical"
                }), e]
              })
            });
          };
        function z(e, t) {
          return Math.floor(Math.random() * (t - e + 1) + e);
        }
        function T() {
          let e = z(180, 255),
            t = z(180, 255),
            n = z(180, 255);
          return `#${e.toString(16).padStart(2, "0")}${t.toString(16).padStart(2, "0")}${n.toString(16).padStart(2, "0")}`;
        }
        var O = [{
            id: "none",
            label: "None"
          }, {
            id: "blockid",
            label: "Block ID"
          }, {
            id: "classnames",
            label: "Class Names"
          }],
          I = ({
            classStartsWith: e,
            onForceUpdate: t
          }) => {
            let n = o.useRef("none"),
              a = o.useRef(null),
              u = o.useRef(null),
              c = (0, o.useCallback)(() => {
                let t,
                  r = (0, l.r3)(a.current);
                if ("blockid" === n.current) t = r.body.querySelectorAll("[data-block-id]");else {
                  let n = r.body.querySelectorAll(`[class*="${e}"]`),
                    o = u.current?.closest("[role='toolbar']");
                  t = [...n].filter(t => !o?.contains(t) && [...t.classList].filter(t => t.startsWith(e)));
                }
                return [...t];
              }, [e]),
              p = (0, o.useCallback)(() => {
                if (a.current && (a.current.innerHTML = "", "none" !== n.current)) for (let t of c()) {
                  let r = T();
                  t.style.outline = `2px solid ${r}`, t.style.outlineOffset = "-2px";
                  let o = "blockid" === n.current ? t.dataset.blockId : [...t.classList.values()].filter(t => t.startsWith(e)).join(" "),
                    i = t.getBoundingClientRect(),
                    u = (0, l.r3)(t).createElement("div");
                  h.render((0, s.jsx)(F, {
                    container: a.current || void 0,
                    blockId: o || "",
                    style: {
                      top: `${i.top}px`,
                      left: `${i.left}px`,
                      backgroundColor: r
                    }
                  }), u), a.current?.append(u);
                }
              }, [e, c]);
            return (0, o.useLayoutEffect)(() => {
              let e = (0, l.r3)(a.current),
                t = (0, l.kR)(a.current);
              return a.current = e.createElement("div"), e.body.append(a.current), t.addEventListener("resize", p), () => {
                a.current?.remove(), t.removeEventListener("resize", p);
              };
            }, [p]), (0, s.jsxs)(s.Fragment, {
              children: [(0, s.jsx)(r.Select, {
                placement: "bottom start",
                onSelectionChange: e => {
                  (0, i.kG)(a.current, "containerRef.current"), a.current.innerHTML = "", n.current = e, "none" === e ? t() : p();
                },
                defaultSelectedKey: "none",
                items: O,
                ref: u,
                "aria-label": "Select debug type"
              }), (0, s.jsx)(r.ActionIconButton, {
                icon: d.Pnb,
                size: "md",
                onPress: p,
                "aria-label": "Refresh"
              })]
            });
          };
        function F({
          blockId: e,
          style: t,
          container: n
        }) {
          return (0, s.jsx)(r.Portal, {
            portalContainer: n,
            children: (0, s.jsx)("div", {
              style: t,
              className: "jzfzia0",
              children: (0, s.jsx)(r.Text, {
                className: (0, p.Kj)({
                  padding: "xs"
                }),
                style: {
                  color: "black"
                },
                type: "value",
                size: "sm",
                children: e
              })
            })
          });
        }
        var M = o.forwardRef(({
          className: e,
          style: t,
          children: n,
          classStartsWith: r = "BaselineUI"
        }, i) => {
          let [a, l] = o.useState(0),
            u = (0, o.useMemo)(() => () => {
              l(e => e + 1);
            }, []);
          return (0, s.jsxs)("div", {
            className: e,
            style: t,
            ref: i,
            children: [(0, s.jsx)(A, {
              children: (0, s.jsx)("div", {
                className: "jzfzia2 _1yep5z63l _1yep5z63m _1yep5z63n _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
                children: (0, s.jsx)(I, {
                  classStartsWith: r,
                  onForceUpdate: u
                })
              })
            }), (0, s.jsx)(o.Fragment, {
              children: n
            }, a)]
          });
        });
        M.displayName = "Devtools";
        var R = o.forwardRef(({
          className: e,
          minWidth: t = 10,
          maxWidth: n = Number.MAX_SAFE_INTEGER,
          height: a = 96,
          strokeWidth: l = 1,
          strokeColor: u = "#3F87EA",
          fillColor: d = "#AFFCFE",
          fontColor: p = "#3F87EA",
          fontFamily: h = "Arial",
          text: f,
          subText: m,
          style: g,
          label: v = (0, s.jsx)(r.MessageFormat, {
            id: "preview",
            defaultMessage: "Preview"
          }),
          "data-block-id": y,
          onDimensionsChange: b,
          ...w
        }, x) => {
          let D = (m ? .6 : .7) * a,
            [C, S] = o.useState(D),
            [E, _] = o.useState(Math.min(t, n)),
            P = o.useRef(null);
          return (0, c.useGranularLayoutEffect)(() => {
            if (!f || !P.current) return;
            let e = 48 + (0, i.Zw)({
                text: f,
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: C
              }).width,
              r = 48 + (0, i.Zw)({
                text: f,
                fontFamily: "Arial",
                fontWeight: "bold",
                fontSize: D
              }).width,
              o = D,
              s = Math.max(e, t);
            (e > n || r > n) && (o = (0, i.TI)({
              text: f,
              maxWidth: n - 48,
              fontFamily: "Arial",
              fontWeight: "bold",
              initialFontSize: D
            }), s = o < D ? n : r), S(o), _(s), b?.({
              width: s,
              height: a
            });
          }, [f], [C, t, b]), (0, s.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            version: "1.2",
            width: E,
            height: Math.round(a),
            viewBox: `0 0 ${E} ${Math.round(a)}`,
            className: (0, i.AK)("BaselineUI-Stamp", e),
            style: g,
            ref: x,
            role: "img",
            fontFamily: h,
            "data-block-id": y,
            ...w,
            children: [(0, s.jsx)("title", {
              children: v
            }), (0, s.jsx)("rect", {
              width: E - 2 * l,
              height: a - 2 * l,
              fill: d,
              rx: 7,
              ry: 7,
              strokeWidth: l,
              stroke: u,
              x: l,
              y: l
            }), (0, s.jsx)("text", {
              x: E / 2,
              textAnchor: "middle",
              fontWeight: "bold",
              fontSize: C,
              fill: p,
              dominantBaseline: "central",
              y: m ? .4 * a : a / 2,
              ref: P,
              children: f
            }), m ? (0, s.jsx)("text", {
              x: E / 2,
              textAnchor: "middle",
              fontSize: .175 * a,
              fill: p,
              dominantBaseline: "central",
              y: .85 * a,
              children: m
            }) : null]
          });
        });
        R.displayName = "Stamp";
        var j = C({
            defaultClassName: "oub0v60 _1yep5z69 _1yep5z6a _1yep5z6b _1yep5z62l _1yep5z62m _1yep5z62n _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie",
            variantClassNames: {
              hasName: {
                true: "_1yep5z6ut _1yep5z6uu _1yep5z6uv"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          B = "oub0v67",
          N = C({
            defaultClassName: "oub0v62 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z69i _1yep5z69j _1yep5z69k",
            variantClassNames: {
              isInline: {
                true: "_1yep5z6142 _1yep5z6143 _1yep5z6144"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          L = C({
            defaultClassName: "oub0v64 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z69l _1yep5z69m _1yep5z69n",
            variantClassNames: {
              isInline: {
                true: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6142 _1yep5z6143 _1yep5z6144",
                false: "_1yep5z613n _1yep5z613o _1yep5z613p _1yep5z614w _1yep5z614x _1yep5z614y"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          V = "_1yep5z6e3 _1yep5z6eu",
          K = o.forwardRef(({
            className: e,
            style: t,
            reactions: n,
            name: o,
            content: a,
            description: l,
            menuProps: u,
            avatarProps: c,
            isInline: d = !0,
            children: p,
            contentStringType: h = "text",
            "data-block-id": m,
            "data-comment-id": v
          }, y) => (0, s.jsxs)("div", {
            className: (0, i.AK)(j({
              hasName: !!o
            }), "BaselineUI-Comment", e),
            style: t,
            ref: y,
            "data-block-id": m,
            "data-comment-id": v,
            children: [(0, s.jsxs)("div", {
              className: N({
                isInline: d
              }),
              children: [(0, s.jsxs)("div", {
                className: L({
                  isInline: d
                }),
                children: [c ? (0, s.jsx)(r.Avatar, {
                  ...c,
                  size: "md"
                }) : null, (0, s.jsxs)(r.Box, {
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                  justifyContent: "center",
                  children: [o ? (0, s.jsx)(r.Text, {
                    type: "subtitle",
                    size: "sm",
                    className: "BaselineUI-Comment-Name",
                    children: o
                  }) : null, (0, s.jsx)(r.Text, {
                    type: "helper",
                    size: "sm",
                    className: "BaselineUI-Comment-Description",
                    children: l
                  })]
                })]
              }), u ? (0, s.jsx)(r.Menu, {
                placement: "bottom end",
                renderTrigger: ({
                  buttonProps: e,
                  ref: t
                }) => (0, s.jsx)(r.ActionIconButton, {
                  ...e,
                  size: "sm",
                  variant: "secondary",
                  icon: f.nX,
                  "aria-label": u["aria-label"],
                  ref: t
                }),
                ...u
              }) : null]
            }), (0, s.jsx)(r.Box, {
              paddingLeft: d && c ? "2xl" : void 0,
              children: (0, s.jsxs)(r.Box, {
                paddingLeft: d && c ? "lg" : void 0,
                display: "flex",
                gap: "md",
                flexDirection: "column",
                children: ["string" == typeof a && "html" === h ? (0, s.jsx)("div", {
                  className: (0, i.AK)(V, B),
                  dangerouslySetInnerHTML: {
                    __html: g().sanitize(a)
                  }
                }) : (0, s.jsx)("div", {
                  className: (0, i.AK)(V, B),
                  children: a
                }), !!n?.length && (0, s.jsx)("div", {
                  className: N({
                    isInline: !0
                  }),
                  children: n.map(e => (0, s.jsx)(r.Reaction, {
                    ...e
                  }, e.id))
                }), p]
              })
            })]
          }));
        K.displayName = "Comment";
      },
      36590: function (e) {
        e.exports = function () {
          "use strict";

          const {
            entries: e,
            setPrototypeOf: t,
            isFrozen: n,
            getPrototypeOf: r,
            getOwnPropertyDescriptor: o
          } = Object;
          let {
              freeze: i,
              seal: a,
              create: s
            } = Object,
            {
              apply: l,
              construct: u
            } = "undefined" != typeof Reflect && Reflect;
          i || (i = function (e) {
            return e;
          }), a || (a = function (e) {
            return e;
          }), l || (l = function (e, t, n) {
            return e.apply(t, n);
          }), u || (u = function (e, t) {
            return new e(...t);
          });
          const c = D(Array.prototype.forEach),
            d = D(Array.prototype.pop),
            p = D(Array.prototype.push),
            h = D(String.prototype.toLowerCase),
            f = D(String.prototype.toString),
            m = D(String.prototype.match),
            g = D(String.prototype.replace),
            v = D(String.prototype.indexOf),
            y = D(String.prototype.trim),
            b = D(Object.prototype.hasOwnProperty),
            w = D(RegExp.prototype.test),
            x = C(TypeError);
          function D(e) {
            return function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
              return l(e, t, r);
            };
          }
          function C(e) {
            return function () {
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return u(e, n);
            };
          }
          function S(e, r) {
            let o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h;
            t && t(e, null);
            let i = r.length;
            for (; i--;) {
              let t = r[i];
              if ("string" == typeof t) {
                const e = o(t);
                e !== t && (n(r) || (r[i] = e), t = e);
              }
              e[t] = !0;
            }
            return e;
          }
          function E(e) {
            for (let t = 0; t < e.length; t++) b(e, t) || (e[t] = null);
            return e;
          }
          function _(t) {
            const n = s(null);
            for (const [r, o] of e(t)) b(t, r) && (Array.isArray(o) ? n[r] = E(o) : o && "object" == typeof o && o.constructor === Object ? n[r] = _(o) : n[r] = o);
            return n;
          }
          function P(e, t) {
            for (; null !== e;) {
              const n = o(e, t);
              if (n) {
                if (n.get) return D(n.get);
                if ("function" == typeof n.value) return D(n.value);
              }
              e = r(e);
            }
            function n() {
              return null;
            }
            return n;
          }
          const k = i(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
            A = i(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
            z = i(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
            T = i(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
            O = i(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
            I = i(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
            F = i(["#text"]),
            M = i(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
            R = i(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
            j = i(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
            B = i(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
            N = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            L = a(/<%[\w\W]*|[\w\W]*%>/gm),
            V = a(/\${[\w\W]*}/gm),
            K = a(/^data-[\-\w.\u00B7-\uFFFF]/),
            q = a(/^aria-[\-\w]+$/),
            H = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            U = a(/^(?:\w+script|data):/i),
            Z = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            $ = a(/^html$/i),
            G = a(/^[a-z][.\w]*(-[.\w]+)+$/i);
          var W = Object.freeze({
            __proto__: null,
            MUSTACHE_EXPR: N,
            ERB_EXPR: L,
            TMPLIT_EXPR: V,
            DATA_ATTR: K,
            ARIA_ATTR: q,
            IS_ALLOWED_URI: H,
            IS_SCRIPT_OR_DATA: U,
            ATTR_WHITESPACE: Z,
            DOCTYPE_NAME: $,
            CUSTOM_ELEMENT: G
          });
          const Y = function () {
              return "undefined" == typeof window ? null : window;
            },
            X = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let n = null;
              const r = "data-tt-policy-suffix";
              t && t.hasAttribute(r) && (n = t.getAttribute(r));
              const o = "dompurify" + (n ? "#" + n : "");
              try {
                return e.createPolicy(o, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + o + " could not be created."), null;
              }
            };
          function Q() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Y();
            const n = e => Q(e);
            if (n.version = "3.1.0", n.removed = [], !t || !t.document || 9 !== t.document.nodeType) return n.isSupported = !1, n;
            let {
              document: r
            } = t;
            const o = r,
              a = o.currentScript,
              {
                DocumentFragment: l,
                HTMLTemplateElement: u,
                Node: D,
                Element: C,
                NodeFilter: E,
                NamedNodeMap: N = t.NamedNodeMap || t.MozNamedAttrMap,
                HTMLFormElement: L,
                DOMParser: V,
                trustedTypes: K
              } = t,
              q = C.prototype,
              U = P(q, "cloneNode"),
              Z = P(q, "nextSibling"),
              G = P(q, "childNodes"),
              J = P(q, "parentNode");
            if ("function" == typeof u) {
              const e = r.createElement("template");
              e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
            }
            let ee,
              te = "";
            const {
                implementation: ne,
                createNodeIterator: re,
                createDocumentFragment: oe,
                getElementsByTagName: ie
              } = r,
              {
                importNode: ae
              } = o;
            let se = {};
            n.isSupported = "function" == typeof e && "function" == typeof J && ne && void 0 !== ne.createHTMLDocument;
            const {
              MUSTACHE_EXPR: le,
              ERB_EXPR: ue,
              TMPLIT_EXPR: ce,
              DATA_ATTR: de,
              ARIA_ATTR: pe,
              IS_SCRIPT_OR_DATA: he,
              ATTR_WHITESPACE: fe,
              CUSTOM_ELEMENT: me
            } = W;
            let {
                IS_ALLOWED_URI: ge
              } = W,
              ve = null;
            const ye = S({}, [...k, ...A, ...z, ...O, ...F]);
            let be = null;
            const we = S({}, [...M, ...R, ...j, ...B]);
            let xe = Object.seal(s(null, {
                tagNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                attributeNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: !1
                }
              })),
              De = null,
              Ce = null,
              Se = !0,
              Ee = !0,
              _e = !1,
              Pe = !0,
              ke = !1,
              Ae = !0,
              ze = !1,
              Te = !1,
              Oe = !1,
              Ie = !1,
              Fe = !1,
              Me = !1,
              Re = !0,
              je = !1;
            const Be = "user-content-";
            let Ne = !0,
              Le = !1,
              Ve = {},
              Ke = null;
            const qe = S({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
            let He = null;
            const Ue = S({}, ["audio", "video", "img", "source", "image", "track"]);
            let Ze = null;
            const $e = S({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
              Ge = "http://www.w3.org/1998/Math/MathML",
              We = "http://www.w3.org/2000/svg",
              Ye = "http://www.w3.org/1999/xhtml";
            let Xe = Ye,
              Qe = !1,
              Je = null;
            const et = S({}, [Ge, We, Ye], f);
            let tt = null;
            const nt = ["application/xhtml+xml", "text/html"],
              rt = "text/html";
            let ot = null,
              it = null;
            const at = r.createElement("form"),
              st = function (e) {
                return e instanceof RegExp || e instanceof Function;
              },
              lt = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!it || it !== e) {
                  if (e && "object" == typeof e || (e = {}), e = _(e), tt = -1 === nt.indexOf(e.PARSER_MEDIA_TYPE) ? rt : e.PARSER_MEDIA_TYPE, ot = "application/xhtml+xml" === tt ? f : h, ve = b(e, "ALLOWED_TAGS") ? S({}, e.ALLOWED_TAGS, ot) : ye, be = b(e, "ALLOWED_ATTR") ? S({}, e.ALLOWED_ATTR, ot) : we, Je = b(e, "ALLOWED_NAMESPACES") ? S({}, e.ALLOWED_NAMESPACES, f) : et, Ze = b(e, "ADD_URI_SAFE_ATTR") ? S(_($e), e.ADD_URI_SAFE_ATTR, ot) : $e, He = b(e, "ADD_DATA_URI_TAGS") ? S(_(Ue), e.ADD_DATA_URI_TAGS, ot) : Ue, Ke = b(e, "FORBID_CONTENTS") ? S({}, e.FORBID_CONTENTS, ot) : qe, De = b(e, "FORBID_TAGS") ? S({}, e.FORBID_TAGS, ot) : {}, Ce = b(e, "FORBID_ATTR") ? S({}, e.FORBID_ATTR, ot) : {}, Ve = !!b(e, "USE_PROFILES") && e.USE_PROFILES, Se = !1 !== e.ALLOW_ARIA_ATTR, Ee = !1 !== e.ALLOW_DATA_ATTR, _e = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Pe = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, ke = e.SAFE_FOR_TEMPLATES || !1, Ae = !1 !== e.SAFE_FOR_XML, ze = e.WHOLE_DOCUMENT || !1, Ie = e.RETURN_DOM || !1, Fe = e.RETURN_DOM_FRAGMENT || !1, Me = e.RETURN_TRUSTED_TYPE || !1, Oe = e.FORCE_BODY || !1, Re = !1 !== e.SANITIZE_DOM, je = e.SANITIZE_NAMED_PROPS || !1, Ne = !1 !== e.KEEP_CONTENT, Le = e.IN_PLACE || !1, ge = e.ALLOWED_URI_REGEXP || H, Xe = e.NAMESPACE || Ye, xe = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && st(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (xe.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && st(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (xe.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (xe.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ke && (Ee = !1), Fe && (Ie = !0), Ve && (ve = S({}, F), be = [], !0 === Ve.html && (S(ve, k), S(be, M)), !0 === Ve.svg && (S(ve, A), S(be, R), S(be, B)), !0 === Ve.svgFilters && (S(ve, z), S(be, R), S(be, B)), !0 === Ve.mathMl && (S(ve, O), S(be, j), S(be, B))), e.ADD_TAGS && (ve === ye && (ve = _(ve)), S(ve, e.ADD_TAGS, ot)), e.ADD_ATTR && (be === we && (be = _(be)), S(be, e.ADD_ATTR, ot)), e.ADD_URI_SAFE_ATTR && S(Ze, e.ADD_URI_SAFE_ATTR, ot), e.FORBID_CONTENTS && (Ke === qe && (Ke = _(Ke)), S(Ke, e.FORBID_CONTENTS, ot)), Ne && (ve["#text"] = !0), ze && S(ve, ["html", "head", "body"]), ve.table && (S(ve, ["tbody"]), delete De.tbody), e.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    ee = e.TRUSTED_TYPES_POLICY, te = ee.createHTML("");
                  } else void 0 === ee && (ee = X(K, a)), null !== ee && "string" == typeof te && (te = ee.createHTML(""));
                  i && i(e), it = e;
                }
              },
              ut = S({}, ["mi", "mo", "mn", "ms", "mtext"]),
              ct = S({}, ["foreignobject", "desc", "title", "annotation-xml"]),
              dt = S({}, ["title", "style", "font", "a", "script"]),
              pt = S({}, [...A, ...z, ...T]),
              ht = S({}, [...O, ...I]),
              ft = function (e) {
                let t = J(e);
                t && t.tagName || (t = {
                  namespaceURI: Xe,
                  tagName: "template"
                });
                const n = h(e.tagName),
                  r = h(t.tagName);
                return !!Je[e.namespaceURI] && (e.namespaceURI === We ? t.namespaceURI === Ye ? "svg" === n : t.namespaceURI === Ge ? "svg" === n && ("annotation-xml" === r || ut[r]) : Boolean(pt[n]) : e.namespaceURI === Ge ? t.namespaceURI === Ye ? "math" === n : t.namespaceURI === We ? "math" === n && ct[r] : Boolean(ht[n]) : e.namespaceURI === Ye ? !(t.namespaceURI === We && !ct[r]) && !(t.namespaceURI === Ge && !ut[r]) && !ht[n] && (dt[n] || !pt[n]) : !("application/xhtml+xml" !== tt || !Je[e.namespaceURI]));
              },
              mt = function (e) {
                p(n.removed, {
                  element: e
                });
                try {
                  e.parentNode.removeChild(e);
                } catch (t) {
                  e.remove();
                }
              },
              gt = function (e, t) {
                try {
                  p(n.removed, {
                    attribute: t.getAttributeNode(e),
                    from: t
                  });
                } catch (e) {
                  p(n.removed, {
                    attribute: null,
                    from: t
                  });
                }
                if (t.removeAttribute(e), "is" === e && !be[e]) if (Ie || Fe) try {
                  mt(t);
                } catch (e) {} else try {
                  t.setAttribute(e, "");
                } catch (e) {}
              },
              vt = function (e) {
                let t = null,
                  n = null;
                if (Oe) e = "<remove></remove>" + e;else {
                  const t = m(e, /^[\r\n\t ]+/);
                  n = t && t[0];
                }
                "application/xhtml+xml" === tt && Xe === Ye && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                const o = ee ? ee.createHTML(e) : e;
                if (Xe === Ye) try {
                  t = new V().parseFromString(o, tt);
                } catch (e) {}
                if (!t || !t.documentElement) {
                  t = ne.createDocument(Xe, "template", null);
                  try {
                    t.documentElement.innerHTML = Qe ? te : o;
                  } catch (e) {}
                }
                const i = t.body || t.documentElement;
                return e && n && i.insertBefore(r.createTextNode(n), i.childNodes[0] || null), Xe === Ye ? ie.call(t, ze ? "html" : "body")[0] : ze ? t.documentElement : i;
              },
              yt = function (e) {
                return re.call(e.ownerDocument || e, e, E.SHOW_ELEMENT | E.SHOW_COMMENT | E.SHOW_TEXT | E.SHOW_PROCESSING_INSTRUCTION | E.SHOW_CDATA_SECTION, null);
              },
              bt = function (e) {
                return e instanceof L && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof N) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
              },
              wt = function (e) {
                return "function" == typeof D && e instanceof D;
              },
              xt = function (e, t, r) {
                se[e] && c(se[e], e => {
                  e.call(n, t, r, it);
                });
              },
              Dt = function (e) {
                let t = null;
                if (xt("beforeSanitizeElements", e, null), bt(e)) return mt(e), !0;
                const r = ot(e.nodeName);
                if (xt("uponSanitizeElement", e, {
                  tagName: r,
                  allowedTags: ve
                }), e.hasChildNodes() && !wt(e.firstElementChild) && w(/<[/\w]/g, e.innerHTML) && w(/<[/\w]/g, e.textContent)) return mt(e), !0;
                if (7 === e.nodeType) return mt(e), !0;
                if (Ae && 8 === e.nodeType && w(/<[/\w]/g, e.data)) return mt(e), !0;
                if (!ve[r] || De[r]) {
                  if (!De[r] && St(r)) {
                    if (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, r)) return !1;
                    if (xe.tagNameCheck instanceof Function && xe.tagNameCheck(r)) return !1;
                  }
                  if (Ne && !Ke[r]) {
                    const t = J(e) || e.parentNode,
                      n = G(e) || e.childNodes;
                    if (n && t) for (let r = n.length - 1; r >= 0; --r) t.insertBefore(U(n[r], !0), Z(e));
                  }
                  return mt(e), !0;
                }
                return e instanceof C && !ft(e) ? (mt(e), !0) : "noscript" !== r && "noembed" !== r && "noframes" !== r || !w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (ke && 3 === e.nodeType && (t = e.textContent, c([le, ue, ce], e => {
                  t = g(t, e, " ");
                }), e.textContent !== t && (p(n.removed, {
                  element: e.cloneNode()
                }), e.textContent = t)), xt("afterSanitizeElements", e, null), !1) : (mt(e), !0);
              },
              Ct = function (e, t, n) {
                if (Re && ("id" === t || "name" === t) && (n in r || n in at)) return !1;
                if (Ee && !Ce[t] && w(de, t)) ;else if (Se && w(pe, t)) ;else if (!be[t] || Ce[t]) {
                  if (!(St(e) && (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, e) || xe.tagNameCheck instanceof Function && xe.tagNameCheck(e)) && (xe.attributeNameCheck instanceof RegExp && w(xe.attributeNameCheck, t) || xe.attributeNameCheck instanceof Function && xe.attributeNameCheck(t)) || "is" === t && xe.allowCustomizedBuiltInElements && (xe.tagNameCheck instanceof RegExp && w(xe.tagNameCheck, n) || xe.tagNameCheck instanceof Function && xe.tagNameCheck(n)))) return !1;
                } else if (Ze[t]) ;else if (w(ge, g(n, fe, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(n, "data:") || !He[e]) if (_e && !w(he, g(n, fe, ""))) ;else if (n) return !1;
                return !0;
              },
              St = function (e) {
                return "annotation-xml" !== e && m(e, me);
              },
              Et = function (e) {
                xt("beforeSanitizeAttributes", e, null);
                const {
                  attributes: t
                } = e;
                if (!t) return;
                const r = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: be
                };
                let o = t.length;
                for (; o--;) {
                  const i = t[o],
                    {
                      name: a,
                      namespaceURI: s,
                      value: l
                    } = i,
                    u = ot(a);
                  let p = "value" === a ? l : y(l);
                  if (r.attrName = u, r.attrValue = p, r.keepAttr = !0, r.forceKeepAttr = void 0, xt("uponSanitizeAttribute", e, r), p = r.attrValue, r.forceKeepAttr) continue;
                  if (gt(a, e), !r.keepAttr) continue;
                  if (!Pe && w(/\/>/i, p)) {
                    gt(a, e);
                    continue;
                  }
                  ke && c([le, ue, ce], e => {
                    p = g(p, e, " ");
                  });
                  const h = ot(e.nodeName);
                  if (Ct(h, u, p)) {
                    if (!je || "id" !== u && "name" !== u || (gt(a, e), p = Be + p), ee && "object" == typeof K && "function" == typeof K.getAttributeType) if (s) ;else switch (K.getAttributeType(h, u)) {
                      case "TrustedHTML":
                        p = ee.createHTML(p);
                        break;
                      case "TrustedScriptURL":
                        p = ee.createScriptURL(p);
                    }
                    try {
                      s ? e.setAttributeNS(s, a, p) : e.setAttribute(a, p), d(n.removed);
                    } catch (e) {}
                  }
                }
                xt("afterSanitizeAttributes", e, null);
              },
              _t = function e(t) {
                let n = null;
                const r = yt(t);
                for (xt("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) xt("uponSanitizeShadowNode", n, null), Dt(n) || (n.content instanceof l && e(n.content), Et(n));
                xt("afterSanitizeShadowDOM", t, null);
              };
            return n.sanitize = function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = null,
                i = null,
                a = null,
                s = null;
              if (Qe = !e, Qe && (e = "\x3c!--\x3e"), "string" != typeof e && !wt(e)) {
                if ("function" != typeof e.toString) throw x("toString is not a function");
                if ("string" != typeof (e = e.toString())) throw x("dirty is not a string, aborting");
              }
              if (!n.isSupported) return e;
              if (Te || lt(t), n.removed = [], "string" == typeof e && (Le = !1), Le) {
                if (e.nodeName) {
                  const t = ot(e.nodeName);
                  if (!ve[t] || De[t]) throw x("root node is forbidden and cannot be sanitized in-place");
                }
              } else if (e instanceof D) r = vt("\x3c!----\x3e"), i = r.ownerDocument.importNode(e, !0), 1 === i.nodeType && "BODY" === i.nodeName || "HTML" === i.nodeName ? r = i : r.appendChild(i);else {
                if (!Ie && !ke && !ze && -1 === e.indexOf("<")) return ee && Me ? ee.createHTML(e) : e;
                if (r = vt(e), !r) return Ie ? null : Me ? te : "";
              }
              r && Oe && mt(r.firstChild);
              const u = yt(Le ? e : r);
              for (; a = u.nextNode();) Dt(a) || (a.content instanceof l && _t(a.content), Et(a));
              if (Le) return e;
              if (Ie) {
                if (Fe) for (s = oe.call(r.ownerDocument); r.firstChild;) s.appendChild(r.firstChild);else s = r;
                return (be.shadowroot || be.shadowrootmode) && (s = ae.call(o, s, !0)), s;
              }
              let d = ze ? r.outerHTML : r.innerHTML;
              return ze && ve["!doctype"] && r.ownerDocument && r.ownerDocument.doctype && r.ownerDocument.doctype.name && w($, r.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + r.ownerDocument.doctype.name + ">\n" + d), ke && c([le, ue, ce], e => {
                d = g(d, e, " ");
              }), ee && Me ? ee.createHTML(d) : d;
            }, n.setConfig = function () {
              lt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Te = !0;
            }, n.clearConfig = function () {
              it = null, Te = !1;
            }, n.isValidAttribute = function (e, t, n) {
              it || lt({});
              const r = ot(e),
                o = ot(t);
              return Ct(r, o, n);
            }, n.addHook = function (e, t) {
              "function" == typeof t && (se[e] = se[e] || [], p(se[e], t));
            }, n.removeHook = function (e) {
              if (se[e]) return d(se[e]);
            }, n.removeHooks = function (e) {
              se[e] && (se[e] = []);
            }, n.removeAllHooks = function () {
              se = {};
            }, n;
          }
          return Q();
        }();
      },
      8716: (e, t, n) => {
        "use strict";

        n.d(t, {
          j: () => c
        });
        var r = n(8840),
          o = n(67294),
          i = n(73935),
          a = n(85893),
          s = "data-block-id";
        function l(e) {
          (0, r.kG)(!e || e.filter(Boolean).every(e => e instanceof u || "string" == typeof e || "number" == typeof e || "function" == typeof e || o.isValidElement(e)), "The children must be an array of Block instances, React elements, strings, function or numbers.");
        }
        var u = class e {
          id;
          _container;
          _component;
          _props;
          _children = [];
          parent;
          constructor(e, t, n = {}) {
            n?.container ? this._container = n.container : (this._container = (n.ownerDocument || document).createElement("div"), this._container.style.display = "contents");
            const {
              children: r,
              ...o
            } = t;
            this._component = e, this._props = o, this.id = t[s] || `__@Block@__${crypto.getRandomValues(new Uint32Array(1))[0].toString(16)}`, this.children = r?.flat() || [];
          }
          _setParent(e) {
            this.parent = e;
          }
          get props() {
            return this._props;
          }
          set props(e) {
            if (e.children) throw new Error("Do not pass children in the props. Use the `children` setter instead.");
            this._props = e, this.id = this._props[s] || this.id;
          }
          createComponent(t) {
            const n = this._component,
              o = this._children.map((t, n) => t instanceof e ? t.createComponent(n) : t) ?? [];
            o.some(e => "function" == typeof e) && (0, r.kG)(1 === o.length, "The children must be a single function.");
            const {
                children: i,
                ...s
              } = this._props,
              l = !o.length,
              u = 1 === o.length ? o[0] : o,
              c = this._props.key || t;
            return l ? (0, a.jsx)(n, {
              ...s
            }, c) : (0, a.jsx)(n, {
              ...s,
              children: u
            }, c);
          }
          get children() {
            return this._children;
          }
          set children(t) {
            const n = Array.isArray(t) ? t : [t],
              r = n.flat();
            l(r);
            for (const t of r) t instanceof e && t._setParent(this);
            this._children = n;
          }
          prependChildren(...e) {
            const t = e.flat();
            return l(t), this._children = [...t, ...this._children], this;
          }
          appendChildren(...e) {
            const t = e.flat();
            return l(t), this._children = [...this._children, ...t], this;
          }
          insertBefore(t, ...n) {
            const o = "string" == typeof t ? t : t.id;
            (0, r.kG)(o, "The block must have an id.");
            const i = this.getBlockById(o);
            if (i instanceof e) {
              const t = i.parent;
              if (t) {
                const r = t.children.findIndex(t => t instanceof e && t.id && t.id === o);
                t.children.splice(r, 0, ...n);
              }
            }
            return this;
          }
          insertAfter(t, ...n) {
            const o = "string" == typeof t ? t : t.id;
            (0, r.kG)(o, "The block must have an id.");
            const i = this.getBlockById(o);
            if (i instanceof e) {
              const t = i.parent;
              if (t) {
                const r = t.children.findIndex(t => t instanceof e && t.id && t.id === o);
                t.children.splice(r + 1, 0, ...n);
              }
            }
            return this;
          }
          replace(t, ...n) {
            const o = "string" == typeof t ? t : t.id;
            (0, r.kG)(o, "The block must have an id.");
            const i = this.getBlockById(o);
            if (i instanceof e) {
              const t = i.parent;
              if (t) {
                const r = t.children.findIndex(t => t instanceof e && t.id && t.id === o);
                t.children.splice(r, 1, ...n);
              }
            }
            return this;
          }
          getBlockById(t) {
            const n = this._getChild(t);
            if (n instanceof e) return n;
            for (const n of this._children) if (n instanceof e) {
              const e = n.getBlockById(t);
              if (e) return e;
            }
          }
          getBlocksByComponent(t) {
            const n = [];
            this._component === t && n.push(this);
            for (const r of this._children) if (r instanceof e) {
              const e = r.getBlocksByComponent(t);
              e && n.push(...e);
            }
            return n;
          }
          _getChild(t) {
            return t instanceof e ? this._children.find(n => n instanceof e && n === t) : this._children.find(n => n instanceof e && n.id === t);
          }
          _removeChild(t) {
            const n = this._children.findIndex(n => n instanceof e && n.id === t);
            -1 !== n && this._children.splice(n, 1);
          }
          removeChildById(t) {
            this._removeChild(t);
            for (const n of this.children) n instanceof e && n.removeChildById(t);
          }
          createDOMNode(e) {
            const t = this.createComponent();
            return i.render(t, e || this._container), this._container;
          }
          mergeProps(e) {
            return this._props = {
              ...this._props,
              ...e
            }, this.id = this._props[s] || this.id, this;
          }
          setProp(e, t) {
            return this._props = {
              ...this._props,
              [e]: t
            }, this.id = this._props[s] || this.id, this;
          }
          toJS() {
            const t = "string" == typeof this._component ? this._component : this._component.displayName;
            return {
              id: this.id,
              component: t,
              props: this._props,
              children: this.children.map(t => t instanceof e ? t.toJS() : {
                value: t
              })
            };
          }
        };
        function c(e, t = {}, ...n) {
          return new u(e, {
            ...t,
            children: n
          });
        }
      },
      98502: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          Accordion: () => $y,
          AccordionItem: () => Wy,
          ActionButton: () => Bg,
          ActionIconButton: () => nv,
          AlertDialog: () => rD,
          AudioPlayer: () => cD,
          Avatar: () => tb,
          Box: () => wg,
          Checkbox: () => ky,
          ColorInput: () => Dw,
          ColorPresetInlineInput: () => Gw,
          ColorSwatch: () => rw,
          ComboBox: () => _D,
          DateFormat: () => My,
          Dialog: () => Fb,
          DialogTitle: () => Mb,
          DomNodeRenderer: () => Kg,
          Drawer: () => Cb,
          Editor: () => Xx,
          FileUpload: () => oy,
          FreehandCanvas: () => zw,
          Group: () => $w,
          I18nProvider: () => zv,
          IconColorInputButton: () => xw,
          ImageDropZone: () => Rw,
          ImageGallery: () => vD,
          InlineAlert: () => bb,
          Link: () => Qv,
          ListBox: () => Pg,
          Markdown: () => aD,
          Menu: () => Yv,
          MessageFormat: () => Zw,
          Modal: () => Pb,
          ModalClose: () => Bb,
          ModalContent: () => Tb,
          ModalTrigger: () => jb,
          NumberFormat: () => cy,
          NumberInput: () => rv,
          Pagination: () => Fy,
          Popover: () => Tg,
          PopoverContent: () => Nb,
          PopoverTrigger: () => Ig,
          Portal: () => Vv,
          PortalContainerProvider: () => bv,
          Preview: () => Nw,
          ProgressBar: () => sy,
          ProgressSpinner: () => xy,
          RadioGroup: () => Uw,
          Reaction: () => fy,
          ScrollControlButton: () => eD,
          SearchInput: () => hv,
          Select: () => Qy,
          Separator: () => yg,
          Slider: () => ov,
          Switch: () => cv,
          TabItem: () => ub,
          Tabs: () => lb,
          TagGroup: () => Ly,
          Text: () => xb,
          TextInput: () => uy,
          ThemeProvider: () => vv,
          ToggleButton: () => Sy,
          ToggleIconButton: () => dx,
          Toolbar: () => ox,
          Tooltip: () => yy,
          Transform: () => Fw,
          Transition: () => Jx,
          defineMessages: () => Ov,
          isInsideOverlayContent: () => PD,
          useCollator: () => Le.Xe,
          useDateFormatter: () => Le.aQ,
          useDevice: () => Rv,
          useI18n: () => Tv,
          useImage: () => Dv,
          useIntersectionObserver: () => wv,
          useIsFirstRender: () => Cv,
          useLocalStorage: () => Fv,
          useMutationObserver: () => Iv,
          useNumberFormatter: () => Le.Ux,
          usePortalContainer: () => jv,
          useResizeObserver: () => xv,
          useTextSelection: () => Mv,
          useUndoRedo: () => kv,
          useUserPreferences: () => fv
        });
        var r = {};
        n.r(r), n.d(r, {
          decode: () => th,
          encode: () => oh,
          format: () => ih,
          parse: () => yh
        });
        var o = {};
        n.r(o), n.d(o, {
          Any: () => bh,
          Cc: () => wh,
          Cf: () => xh,
          P: () => Dh,
          S: () => Ch,
          Z: () => Sh
        });
        var i = {};
        n.r(i), n.d(i, {
          arrayReplaceAt: () => $h,
          assign: () => Zh,
          escapeHtml: () => af,
          escapeRE: () => lf,
          fromCodePoint: () => Wh,
          has: () => Uh,
          isMdAsciiPunct: () => pf,
          isPunctChar: () => df,
          isSpace: () => uf,
          isString: () => qh,
          isValidEntityCode: () => Gh,
          isWhiteSpace: () => cf,
          lib: () => ff,
          normalizeReference: () => hf,
          unescapeAll: () => ef,
          unescapeMd: () => Jh
        });
        var a = {};
        n.r(a), n.d(a, {
          parseLinkDestination: () => gf,
          parseLinkLabel: () => mf,
          parseLinkTitle: () => vf
        });
        var s = n(67294),
          l = (n(41473), n(85010));
        var u = n(38947);
        var c = n(45861);
        class d extends Set {
          constructor(e, t, n) {
            super(e), e instanceof d ? (this.anchorKey = t || e.anchorKey, this.currentKey = n || e.currentKey) : (this.anchorKey = t, this.currentKey = n);
          }
        }
        function p(e) {
          let {
              selectionMode: t = "none",
              disallowEmptySelection: n,
              allowDuplicateSelectionEvents: r,
              selectionBehavior: o = "toggle",
              disabledBehavior: i = "all"
            } = e,
            a = (0, s.useRef)(!1),
            [, u] = (0, s.useState)(!1),
            c = (0, s.useRef)(null),
            p = (0, s.useRef)(null),
            [, f] = (0, s.useState)(null),
            m = (0, s.useMemo)(() => h(e.selectedKeys), [e.selectedKeys]),
            g = (0, s.useMemo)(() => h(e.defaultSelectedKeys, new d()), [e.defaultSelectedKeys]),
            [v, y] = (0, l.zk)(m, g, e.onSelectionChange),
            b = (0, s.useMemo)(() => e.disabledKeys ? new Set(e.disabledKeys) : new Set(), [e.disabledKeys]),
            [w, x] = (0, s.useState)(o);
          "replace" === o && "toggle" === w && "object" == typeof v && 0 === v.size && x("replace");
          let D = (0, s.useRef)(o);
          return (0, s.useEffect)(() => {
            o !== D.current && (x(o), D.current = o);
          }, [o]), {
            selectionMode: t,
            disallowEmptySelection: n,
            selectionBehavior: w,
            setSelectionBehavior: x,
            get isFocused() {
              return a.current;
            },
            setFocused(e) {
              a.current = e, u(e);
            },
            get focusedKey() {
              return c.current;
            },
            get childFocusStrategy() {
              return p.current;
            },
            setFocusedKey(e, t = "first") {
              c.current = e, p.current = t, f(e);
            },
            selectedKeys: v,
            setSelectedKeys(e) {
              !r && function (e, t) {
                if (e.size !== t.size) return !1;
                for (let n of e) if (!t.has(n)) return !1;
                return !0;
              }(e, v) || y(e);
            },
            disabledKeys: b,
            disabledBehavior: i
          };
        }
        function h(e, t) {
          return e ? "all" === e ? "all" : new d(e) : t;
        }
        class f {
          get selectionMode() {
            return this.state.selectionMode;
          }
          get disallowEmptySelection() {
            return this.state.disallowEmptySelection;
          }
          get selectionBehavior() {
            return this.state.selectionBehavior;
          }
          setSelectionBehavior(e) {
            this.state.setSelectionBehavior(e);
          }
          get isFocused() {
            return this.state.isFocused;
          }
          setFocused(e) {
            this.state.setFocused(e);
          }
          get focusedKey() {
            return this.state.focusedKey;
          }
          get childFocusStrategy() {
            return this.state.childFocusStrategy;
          }
          setFocusedKey(e, t) {
            (null == e || this.collection.getItem(e)) && this.state.setFocusedKey(e, t);
          }
          get selectedKeys() {
            return "all" === this.state.selectedKeys ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
          }
          get rawSelection() {
            return this.state.selectedKeys;
          }
          isSelected(e) {
            return "none" !== this.state.selectionMode && (e = this.getKey(e), "all" === this.state.selectedKeys ? this.canSelectItem(e) : this.state.selectedKeys.has(e));
          }
          get isEmpty() {
            return "all" !== this.state.selectedKeys && 0 === this.state.selectedKeys.size;
          }
          get isSelectAll() {
            if (this.isEmpty) return !1;
            if ("all" === this.state.selectedKeys) return !0;
            if (null != this._isSelectAll) return this._isSelectAll;
            let e = this.getSelectAllKeys(),
              t = this.state.selectedKeys;
            return this._isSelectAll = e.every(e => t.has(e)), this._isSelectAll;
          }
          get firstSelectedKey() {
            let e = null;
            for (let t of this.state.selectedKeys) {
              let n = this.collection.getItem(t);
              (!e || n && (0, c.eg)(this.collection, n, e) < 0) && (e = n);
            }
            return null == e ? void 0 : e.key;
          }
          get lastSelectedKey() {
            let e = null;
            for (let t of this.state.selectedKeys) {
              let n = this.collection.getItem(t);
              (!e || n && (0, c.eg)(this.collection, n, e) > 0) && (e = n);
            }
            return null == e ? void 0 : e.key;
          }
          get disabledKeys() {
            return this.state.disabledKeys;
          }
          get disabledBehavior() {
            return this.state.disabledBehavior;
          }
          extendSelection(e) {
            if ("none" === this.selectionMode) return;
            if ("single" === this.selectionMode) return void this.replaceSelection(e);
            let t;
            if (e = this.getKey(e), "all" === this.state.selectedKeys) t = new d([e], e, e);else {
              let n = this.state.selectedKeys,
                r = n.anchorKey || e;
              t = new d(n, r, e);
              for (let o of this.getKeyRange(r, n.currentKey || e)) t.delete(o);
              for (let n of this.getKeyRange(e, r)) this.canSelectItem(n) && t.add(n);
            }
            this.state.setSelectedKeys(t);
          }
          getKeyRange(e, t) {
            let n = this.collection.getItem(e),
              r = this.collection.getItem(t);
            return n && r ? (0, c.eg)(this.collection, n, r) <= 0 ? this.getKeyRangeInternal(e, t) : this.getKeyRangeInternal(t, e) : [];
          }
          getKeyRangeInternal(e, t) {
            let n = [],
              r = e;
            for (; r;) {
              let e = this.collection.getItem(r);
              if ((e && "item" === e.type || "cell" === e.type && this.allowsCellSelection) && n.push(r), r === t) return n;
              r = this.collection.getKeyAfter(r);
            }
            return [];
          }
          getKey(e) {
            let t = this.collection.getItem(e);
            if (!t) return e;
            if ("cell" === t.type && this.allowsCellSelection) return e;
            for (; "item" !== t.type && null != t.parentKey;) t = this.collection.getItem(t.parentKey);
            return t && "item" === t.type ? t.key : null;
          }
          toggleSelection(e) {
            if ("none" === this.selectionMode) return;
            if ("single" === this.selectionMode && !this.isSelected(e)) return void this.replaceSelection(e);
            if (null == (e = this.getKey(e))) return;
            let t = new d("all" === this.state.selectedKeys ? this.getSelectAllKeys() : this.state.selectedKeys);
            t.has(e) ? t.delete(e) : this.canSelectItem(e) && (t.add(e), t.anchorKey = e, t.currentKey = e), this.disallowEmptySelection && 0 === t.size || this.state.setSelectedKeys(t);
          }
          replaceSelection(e) {
            if ("none" === this.selectionMode) return;
            if (null == (e = this.getKey(e))) return;
            let t = this.canSelectItem(e) ? new d([e], e, e) : new d();
            this.state.setSelectedKeys(t);
          }
          setSelectedKeys(e) {
            if ("none" === this.selectionMode) return;
            let t = new d();
            for (let n of e) if (n = this.getKey(n), null != n && (t.add(n), "single" === this.selectionMode)) break;
            this.state.setSelectedKeys(t);
          }
          getSelectAllKeys() {
            let e = [],
              t = n => {
                for (; n;) {
                  if (this.canSelectItem(n)) {
                    let r = this.collection.getItem(n);
                    "item" === r.type && e.push(n), r.hasChildNodes && (this.allowsCellSelection || "item" !== r.type) && t((0, c.l8)((0, c._P)(r, this.collection)).key);
                  }
                  n = this.collection.getKeyAfter(n);
                }
              };
            return t(this.collection.getFirstKey()), e;
          }
          selectAll() {
            this.isSelectAll || "multiple" !== this.selectionMode || this.state.setSelectedKeys("all");
          }
          clearSelection() {
            !this.disallowEmptySelection && ("all" === this.state.selectedKeys || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new d());
          }
          toggleSelectAll() {
            this.isSelectAll ? this.clearSelection() : this.selectAll();
          }
          select(e, t) {
            "none" !== this.selectionMode && ("single" === this.selectionMode ? this.isSelected(e) && !this.disallowEmptySelection ? this.toggleSelection(e) : this.replaceSelection(e) : "toggle" === this.selectionBehavior || t && ("touch" === t.pointerType || "virtual" === t.pointerType) ? this.toggleSelection(e) : this.replaceSelection(e));
          }
          isSelectionEqual(e) {
            if (e === this.state.selectedKeys) return !0;
            let t = this.selectedKeys;
            if (e.size !== t.size) return !1;
            for (let n of e) if (!t.has(n)) return !1;
            for (let n of t) if (!e.has(n)) return !1;
            return !0;
          }
          canSelectItem(e) {
            if ("none" === this.state.selectionMode || this.state.disabledKeys.has(e)) return !1;
            let t = this.collection.getItem(e);
            return !(!t || "cell" === t.type && !this.allowsCellSelection);
          }
          isDisabled(e) {
            return this.state.disabledKeys.has(e) && "all" === this.state.disabledBehavior;
          }
          isLink(e) {
            var t, n;
            return !!(null === (n = this.collection.getItem(e)) || void 0 === n || null === (t = n.props) || void 0 === t ? void 0 : t.href);
          }
          constructor(e, t, n) {
            var r;
            this.collection = e, this.state = t, this.allowsCellSelection = null !== (r = null == n ? void 0 : n.allowsCellSelection) && void 0 !== r && r, this._isSelectAll = null;
          }
        }
        class m {
          *[Symbol.iterator]() {
            yield* this.iterable;
          }
          get size() {
            return this.keyMap.size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            return this.firstKey;
          }
          getLastKey() {
            return this.lastKey;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getChildren(e) {
            let t = this.keyMap.get(e);
            return (null == t ? void 0 : t.childNodes) || [];
          }
          constructor(e) {
            this.keyMap = new Map(), this.iterable = e;
            let t,
              n = e => {
                if (this.keyMap.set(e.key, e), e.childNodes && "section" === e.type) for (let t of e.childNodes) n(t);
              };
            for (let t of e) n(t);
            let r = 0;
            for (let [e, n] of this.keyMap) t ? (t.nextKey = e, n.prevKey = t.key) : (this.firstKey = e, n.prevKey = void 0), "item" === n.type && (n.index = r++), t = n, t.nextKey = void 0;
            this.lastKey = null == t ? void 0 : t.key;
          }
        }
        function g(e) {
          let {
              filter: t
            } = e,
            n = p(e),
            r = (0, s.useMemo)(() => e.disabledKeys ? new Set(e.disabledKeys) : new Set(), [e.disabledKeys]),
            o = (0, s.useCallback)(e => new m(t ? t(e) : e), [t]),
            i = (0, s.useMemo)(() => ({
              suppressTextValueWarning: e.suppressTextValueWarning
            }), [e.suppressTextValueWarning]),
            a = (0, c.Kx)(e, o, i),
            l = (0, s.useMemo)(() => new f(a, n), [a, n]);
          const u = (0, s.useRef)(null);
          return (0, s.useEffect)(() => {
            if (null != n.focusedKey && !a.getItem(n.focusedKey)) {
              const e = u.current.getItem(n.focusedKey),
                t = [...u.current.getKeys()].map(e => {
                  const t = u.current.getItem(e);
                  return "item" === t.type ? t : null;
                }).filter(e => null !== e),
                r = [...a.getKeys()].map(e => {
                  const t = a.getItem(e);
                  return "item" === t.type ? t : null;
                }).filter(e => null !== e),
                o = t.length - r.length;
              let i,
                s = Math.min(o > 1 ? Math.max(e.index - o + 1, 0) : e.index, r.length - 1);
              for (; s >= 0;) {
                if (!l.isDisabled(r[s].key)) {
                  i = r[s];
                  break;
                }
                s < r.length - 1 ? s++ : (s > e.index && (s = e.index), s--);
              }
              n.setFocusedKey(i ? i.key : null);
            }
            u.current = a;
          }, [a, l, n, n.focusedKey]), {
            collection: a,
            disabledKeys: r,
            selectionManager: l
          };
        }
        function v(e) {
          var t;
          let [n, r] = (0, l.zk)(e.selectedKey, null !== (t = e.defaultSelectedKey) && void 0 !== t ? t : null, e.onSelectionChange),
            o = (0, s.useMemo)(() => null != n ? [n] : [], [n]),
            {
              collection: i,
              disabledKeys: a,
              selectionManager: u
            } = g({
              ...e,
              selectionMode: "single",
              disallowEmptySelection: !0,
              allowDuplicateSelectionEvents: !0,
              selectedKeys: o,
              onSelectionChange: t => {
                var o;
                let i = null !== (o = t.values().next().value) && void 0 !== o ? o : null;
                i === n && e.onSelectionChange && e.onSelectionChange(i), r(i);
              }
            }),
            c = null != n ? i.getItem(n) : null;
          return {
            collection: i,
            disabledKeys: a,
            selectionManager: u,
            selectedKey: n,
            setSelectedKey: r,
            selectedItem: c
          };
        }
        function y(e) {
          let [t, n] = (0, l.zk)(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
          const r = (0, s.useCallback)(() => {
              n(!0);
            }, [n]),
            o = (0, s.useCallback)(() => {
              n(!1);
            }, [n]),
            i = (0, s.useCallback)(() => {
              n(!t);
            }, [n, t]);
          return {
            isOpen: t,
            setOpen: n,
            open: r,
            close: o,
            toggle: i
          };
        }
        function b(e) {
          var t, n;
          let {
              defaultFilter: r,
              menuTrigger: o = "input",
              allowsEmptyCollection: i = !1,
              allowsCustomValue: a,
              shouldCloseOnBlur: c = !0
            } = e,
            [d, p] = (0, s.useState)(!1),
            [h, f] = (0, s.useState)(!1),
            [g, b] = (0, s.useState)(null);
          var x;
          let {
            collection: D,
            selectionManager: C,
            selectedKey: S,
            setSelectedKey: E,
            selectedItem: _,
            disabledKeys: P
          } = v({
            ...e,
            onSelectionChange: t => {
              e.onSelectionChange && e.onSelectionChange(t), t === S && (H(), V());
            },
            items: null !== (x = e.items) && void 0 !== x ? x : e.defaultItems
          });
          var k, A;
          let [z, T] = (0, l.zk)(e.inputValue, null !== (A = null !== (k = e.defaultInputValue) && void 0 !== k ? k : null === (t = D.getItem(S)) || void 0 === t ? void 0 : t.textValue) && void 0 !== A ? A : "", e.onInputChange),
            O = D,
            I = (0, s.useMemo)(() => null == e.items && r ? function (e, t, n) {
              return new m(w(e, e, t, n));
            }(D, z, r) : D, [D, z, r, e.items]),
            [F, M] = (0, s.useState)(I),
            R = (0, s.useRef)("focus"),
            j = y({
              ...e,
              onOpenChange: t => {
                e.onOpenChange && e.onOpenChange(t, t ? R.current : void 0), C.setFocused(t), t || C.setFocusedKey(null);
              },
              isOpen: void 0,
              defaultOpen: void 0
            }),
            B = (t = null, n) => {
              let r = "manual" === n || "focus" === n && "focus" === o;
              (i || I.size > 0 || r && O.size > 0 || e.items) && (r && !j.isOpen && void 0 === e.items && p(!0), R.current = n, b(t), j.open());
            },
            N = (0, s.useCallback)(() => {
              M(d ? O : I);
            }, [d, O, I]),
            L = (0, s.useCallback)((e = null) => {
              j.isOpen && N(), b(e), j.toggle();
            }, [j, N]),
            V = (0, s.useCallback)(() => {
              j.isOpen && (N(), j.close());
            }, [j, N]),
            [K, q] = (0, s.useState)(z),
            H = () => {
              var e, t;
              let n = null !== (t = null === (e = D.getItem(S)) || void 0 === e ? void 0 : e.textValue) && void 0 !== t ? t : "";
              q(n), T(n);
            };
          var U, Z;
          let $ = (0, s.useRef)(null !== (Z = null !== (U = e.selectedKey) && void 0 !== U ? U : e.defaultSelectedKey) && void 0 !== Z ? Z : null);
          var G;
          let W = (0, s.useRef)(null !== (G = null === (n = D.getItem(S)) || void 0 === n ? void 0 : n.textValue) && void 0 !== G ? G : "");
          (0, s.useEffect)(() => {
            var t, n;
            h && (I.size > 0 || i) && !j.isOpen && z !== K && "manual" !== o && B(null, "input"), d || i || !j.isOpen || 0 !== I.size || V(), null != S && S !== $.current && V(), z !== K && (C.setFocusedKey(null), p(!1), "" !== z || void 0 !== e.inputValue && void 0 !== e.selectedKey || E(null)), S === $.current || void 0 !== e.inputValue && void 0 !== e.selectedKey ? K !== z && q(z) : H();
            let r = null !== (n = null === (t = D.getItem(S)) || void 0 === t ? void 0 : t.textValue) && void 0 !== n ? n : "";
            h || null == S || void 0 !== e.inputValue || S !== $.current || W.current !== r && (q(r), T(r)), $.current = S, W.current = r;
          });
          let Y = (0, u.Q3)({
              ...e,
              value: (0, s.useMemo)(() => ({
                inputValue: z,
                selectedKey: S
              }), [z, S])
            }),
            X = () => {
              $.current = null, E(null), V();
            },
            Q = () => {
              if (void 0 !== e.selectedKey && void 0 !== e.inputValue) {
                var t, n;
                e.onSelectionChange(S);
                let r = null !== (n = null === (t = D.getItem(S)) || void 0 === t ? void 0 : t.textValue) && void 0 !== n ? n : "";
                q(r), V();
              } else H(), V();
            };
          const J = () => {
            if (a) {
              var e, t;
              const n = null !== (t = null === (e = D.getItem(S)) || void 0 === e ? void 0 : e.textValue) && void 0 !== t ? t : "";
              z === n ? Q() : X();
            } else Q();
          };
          let ee = (0, s.useRef)(z),
            te = (0, s.useMemo)(() => j.isOpen ? d ? O : I : F, [j.isOpen, O, I, d, F]);
          return {
            ...Y,
            ...j,
            focusStrategy: g,
            toggle: (t = null, n) => {
              let r = "manual" === n || "focus" === n && "focus" === o;
              (i || I.size > 0 || r && O.size > 0 || e.items || j.isOpen) && (r && !j.isOpen && void 0 === e.items && p(!0), j.isOpen || (R.current = n), L(t));
            },
            open: B,
            close: J,
            selectionManager: C,
            selectedKey: S,
            setSelectedKey: E,
            disabledKeys: P,
            isFocused: h,
            setFocused: e => {
              e ? (ee.current = z, "focus" === o && B(null, "focus")) : (c && J(), z !== ee.current && Y.commitValidation()), f(e);
            },
            selectedItem: _,
            collection: te,
            inputValue: z,
            setInputValue: T,
            commit: () => {
              j.isOpen && null != C.focusedKey ? S === C.focusedKey ? Q() : E(C.focusedKey) : J();
            },
            revert: () => {
              a && null == S ? X() : Q();
            }
          };
        }
        function w(e, t, n, r) {
          let o = [];
          for (let i of t) if ("section" === i.type && i.hasChildNodes) {
            let t = w(e, (0, c._P)(i, e), n, r);
            [...t].some(e => "item" === e.type) && o.push({
              ...i,
              childNodes: t
            });
          } else ("item" === i.type && r(i.textValue, n) || "item" !== i.type) && o.push({
            ...i
          });
          return o;
        }
        var x;
        x = {
          rangeOverflow: e => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
          rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
          rangeUnderflow: e => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
          unavailableDate: "البيانات المحددة غير متاحة."
        };
        var D;
        D = {
          rangeOverflow: e => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
          rangeReversed: "Началната дата трябва да е преди крайната.",
          rangeUnderflow: e => `Стойността трябва да е ${e.minValue} или по-късно.`,
          unavailableDate: "Избраната дата не е налична."
        };
        var C;
        C = {
          rangeOverflow: e => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
          rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
          rangeUnderflow: e => `Hodnota musí být ${e.minValue} nebo pozdější.`,
          unavailableDate: "Vybrané datum není k dispozici."
        };
        var S;
        S = {
          rangeOverflow: e => `Værdien skal være ${e.maxValue} eller tidligere.`,
          rangeReversed: "Startdatoen skal være før slutdatoen.",
          rangeUnderflow: e => `Værdien skal være ${e.minValue} eller nyere.`,
          unavailableDate: "Den valgte dato er ikke tilgængelig."
        };
        var E;
        E = {
          rangeOverflow: e => `Der Wert muss ${e.maxValue} oder früher sein.`,
          rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
          rangeUnderflow: e => `Der Wert muss ${e.minValue} oder später sein.`,
          unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
        };
        var _;
        _ = {
          rangeOverflow: e => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
          rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
          rangeUnderflow: e => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
          unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
        };
        var P;
        P = {
          rangeUnderflow: e => `Value must be ${e.minValue} or later.`,
          rangeOverflow: e => `Value must be ${e.maxValue} or earlier.`,
          rangeReversed: "Start date must be before end date.",
          unavailableDate: "Selected date unavailable."
        };
        var k;
        k = {
          rangeOverflow: e => `El valor debe ser ${e.maxValue} o anterior.`,
          rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
          rangeUnderflow: e => `El valor debe ser ${e.minValue} o posterior.`,
          unavailableDate: "Fecha seleccionada no disponible."
        };
        var A;
        A = {
          rangeOverflow: e => `Väärtus peab olema ${e.maxValue} või varasem.`,
          rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
          rangeUnderflow: e => `Väärtus peab olema ${e.minValue} või hilisem.`,
          unavailableDate: "Valitud kuupäev pole saadaval."
        };
        var z;
        z = {
          rangeOverflow: e => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
          rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
          rangeUnderflow: e => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
          unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
        };
        var T;
        T = {
          rangeOverflow: e => `La valeur doit être ${e.maxValue} ou antérieure.`,
          rangeReversed: "La date de début doit être antérieure à la date de fin.",
          rangeUnderflow: e => `La valeur doit être ${e.minValue} ou ultérieure.`,
          unavailableDate: "La date sélectionnée n’est pas disponible."
        };
        var O;
        O = {
          rangeOverflow: e => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
          rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
          rangeUnderflow: e => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
          unavailableDate: "התאריך הנבחר אינו זמין."
        };
        var I;
        I = {
          rangeOverflow: e => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
          rangeReversed: "Datum početka mora biti prije datuma završetka.",
          rangeUnderflow: e => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
          unavailableDate: "Odabrani datum nije dostupan."
        };
        var F;
        F = {
          rangeOverflow: e => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
          rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
          rangeUnderflow: e => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
          unavailableDate: "A kiválasztott dátum nem érhető el."
        };
        var M;
        M = {
          rangeOverflow: e => `Il valore deve essere ${e.maxValue} o precedente.`,
          rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
          rangeUnderflow: e => `Il valore deve essere ${e.minValue} o successivo.`,
          unavailableDate: "Data selezionata non disponibile."
        };
        var R;
        R = {
          rangeOverflow: e => `値は ${e.maxValue} 以下にする必要があります。`,
          rangeReversed: "開始日は終了日より前にする必要があります。",
          rangeUnderflow: e => `値は ${e.minValue} 以上にする必要があります。`,
          unavailableDate: "選択した日付は使用できません。"
        };
        var j;
        j = {
          rangeOverflow: e => `값은 ${e.maxValue} 이전이어야 합니다.`,
          rangeReversed: "시작일은 종료일 이전이어야 합니다.",
          rangeUnderflow: e => `값은 ${e.minValue} 이상이어야 합니다.`,
          unavailableDate: "선택한 날짜를 사용할 수 없습니다."
        };
        var B;
        B = {
          rangeOverflow: e => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
          rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
          rangeUnderflow: e => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
          unavailableDate: "Pasirinkta data nepasiekiama."
        };
        var N;
        N = {
          rangeOverflow: e => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
          rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
          rangeUnderflow: e => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
          unavailableDate: "Atlasītais datums nav pieejams."
        };
        var L;
        L = {
          rangeOverflow: e => `Verdien må være ${e.maxValue} eller tidligere.`,
          rangeReversed: "Startdatoen må være før sluttdatoen.",
          rangeUnderflow: e => `Verdien må være ${e.minValue} eller senere.`,
          unavailableDate: "Valgt dato utilgjengelig."
        };
        var V;
        V = {
          rangeOverflow: e => `Waarde moet ${e.maxValue} of eerder zijn.`,
          rangeReversed: "De startdatum moet voor de einddatum liggen.",
          rangeUnderflow: e => `Waarde moet ${e.minValue} of later zijn.`,
          unavailableDate: "Geselecteerde datum niet beschikbaar."
        };
        var K;
        K = {
          rangeOverflow: e => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
          rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
          rangeUnderflow: e => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
          unavailableDate: "Wybrana data jest niedostępna."
        };
        var q;
        q = {
          rangeOverflow: e => `O valor deve ser ${e.maxValue} ou anterior.`,
          rangeReversed: "A data inicial deve ser anterior à data final.",
          rangeUnderflow: e => `O valor deve ser ${e.minValue} ou posterior.`,
          unavailableDate: "Data selecionada indisponível."
        };
        var H;
        H = {
          rangeOverflow: e => `O valor tem de ser ${e.maxValue} ou anterior.`,
          rangeReversed: "A data de início deve ser anterior à data de fim.",
          rangeUnderflow: e => `O valor tem de ser ${e.minValue} ou posterior.`,
          unavailableDate: "Data selecionada indisponível."
        };
        var U;
        U = {
          rangeOverflow: e => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
          rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
          rangeUnderflow: e => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
          unavailableDate: "Data selectată nu este disponibilă."
        };
        var Z;
        Z = {
          rangeOverflow: e => `Значение должно быть не позже ${e.maxValue}.`,
          rangeReversed: "Дата начала должна предшествовать дате окончания.",
          rangeUnderflow: e => `Значение должно быть не раньше ${e.minValue}.`,
          unavailableDate: "Выбранная дата недоступна."
        };
        var $;
        $ = {
          rangeOverflow: e => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
          rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
          rangeUnderflow: e => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
          unavailableDate: "Vybratý dátum je nedostupný."
        };
        var G;
        G = {
          rangeOverflow: e => `Vrednost mora biti ${e.maxValue} ali starejša.`,
          rangeReversed: "Začetni datum mora biti pred končnim datumom.",
          rangeUnderflow: e => `Vrednost mora biti ${e.minValue} ali novejša.`,
          unavailableDate: "Izbrani datum ni na voljo."
        };
        var W;
        W = {
          rangeOverflow: e => `Vrednost mora da bude ${e.maxValue} ili starija.`,
          rangeReversed: "Datum početka mora biti pre datuma završetka.",
          rangeUnderflow: e => `Vrednost mora da bude ${e.minValue} ili novija.`,
          unavailableDate: "Izabrani datum nije dostupan."
        };
        var Y;
        Y = {
          rangeOverflow: e => `Värdet måste vara ${e.maxValue} eller tidigare.`,
          rangeReversed: "Startdatumet måste vara före slutdatumet.",
          rangeUnderflow: e => `Värdet måste vara ${e.minValue} eller senare.`,
          unavailableDate: "Det valda datumet är inte tillgängligt."
        };
        var X;
        X = {
          rangeOverflow: e => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
          rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
          rangeUnderflow: e => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
          unavailableDate: "Seçilen tarih kullanılamıyor."
        };
        var Q;
        Q = {
          rangeOverflow: e => `Значення має бути не пізніше ${e.maxValue}.`,
          rangeReversed: "Дата початку має передувати даті завершення.",
          rangeUnderflow: e => `Значення має бути не раніше ${e.minValue}.`,
          unavailableDate: "Вибрана дата недоступна."
        };
        var J;
        J = {
          rangeOverflow: e => `值必须是 ${e.maxValue} 或更早日期。`,
          rangeReversed: "开始日期必须早于结束日期。",
          rangeUnderflow: e => `值必须是 ${e.minValue} 或更晚日期。`,
          unavailableDate: "所选日期不可用。"
        };
        var ee;
        ee = {
          rangeOverflow: e => `值必須是 ${e.maxValue} 或更早。`,
          rangeReversed: "開始日期必須在結束日期之前。",
          rangeUnderflow: e => `值必須是 ${e.minValue} 或更晚。`,
          unavailableDate: "所選日期無法使用。"
        };
        var te = n(46050);
        function ne(e) {
          return e && e.__esModule ? e.default : e;
        }
        var re;
        re = {
          "ar-AE": x,
          "bg-BG": D,
          "cs-CZ": C,
          "da-DK": S,
          "de-DE": E,
          "el-GR": _,
          "en-US": P,
          "es-ES": k,
          "et-EE": A,
          "fi-FI": z,
          "fr-FR": T,
          "he-IL": O,
          "hr-HR": I,
          "hu-HU": F,
          "it-IT": M,
          "ja-JP": R,
          "ko-KR": j,
          "lt-LT": B,
          "lv-LV": N,
          "nb-NO": L,
          "nl-NL": V,
          "pl-PL": K,
          "pt-BR": q,
          "pt-PT": H,
          "ro-RO": U,
          "ru-RU": Z,
          "sk-SK": $,
          "sl-SI": G,
          "sr-SP": W,
          "sv-SE": Y,
          "tr-TR": X,
          "uk-UA": Q,
          "zh-CN": J,
          "zh-TW": ee
        };
        new (0, te.J)(ne(re));
        new (0, te.J)({
          ach: {
            year: "mwaka",
            month: "dwe",
            day: "nino"
          },
          af: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          am: {
            year: "ዓዓዓዓ",
            month: "ሚሜ",
            day: "ቀቀ"
          },
          an: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          ar: {
            year: "سنة",
            month: "شهر",
            day: "يوم"
          },
          ast: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          az: {
            year: "iiii",
            month: "aa",
            day: "gg"
          },
          be: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          bg: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          bn: {
            year: "yyyy",
            month: "মিমি",
            day: "dd"
          },
          br: {
            year: "bbbb",
            month: "mm",
            day: "dd"
          },
          bs: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          ca: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          cak: {
            year: "jjjj",
            month: "ii",
            day: "q'q'"
          },
          ckb: {
            year: "ساڵ",
            month: "مانگ",
            day: "ڕۆژ"
          },
          cs: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          cy: {
            year: "bbbb",
            month: "mm",
            day: "dd"
          },
          da: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          de: {
            year: "jjjj",
            month: "mm",
            day: "tt"
          },
          dsb: {
            year: "llll",
            month: "mm",
            day: "źź"
          },
          el: {
            year: "εεεε",
            month: "μμ",
            day: "ηη"
          },
          en: {
            year: "yyyy",
            month: "mm",
            day: "dd"
          },
          eo: {
            year: "jjjj",
            month: "mm",
            day: "tt"
          },
          es: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          et: {
            year: "aaaa",
            month: "kk",
            day: "pp"
          },
          eu: {
            year: "uuuu",
            month: "hh",
            day: "ee"
          },
          fa: {
            year: "سال",
            month: "ماه",
            day: "روز"
          },
          ff: {
            year: "hhhh",
            month: "ll",
            day: "ññ"
          },
          fi: {
            year: "vvvv",
            month: "kk",
            day: "pp"
          },
          fr: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          fy: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          ga: {
            year: "bbbb",
            month: "mm",
            day: "ll"
          },
          gd: {
            year: "bbbb",
            month: "mm",
            day: "ll"
          },
          gl: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          he: {
            year: "שנה",
            month: "חודש",
            day: "יום"
          },
          hr: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          hsb: {
            year: "llll",
            month: "mm",
            day: "dd"
          },
          hu: {
            year: "éééé",
            month: "hh",
            day: "nn"
          },
          ia: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          id: {
            year: "tttt",
            month: "bb",
            day: "hh"
          },
          it: {
            year: "aaaa",
            month: "mm",
            day: "gg"
          },
          ja: {
            year: " 年 ",
            month: "月",
            day: "日"
          },
          ka: {
            year: "წწწწ",
            month: "თთ",
            day: "რრ"
          },
          kk: {
            year: "жжжж",
            month: "аа",
            day: "кк"
          },
          kn: {
            year: "ವವವವ",
            month: "ಮಿಮೀ",
            day: "ದಿದಿ"
          },
          ko: {
            year: "연도",
            month: "월",
            day: "일"
          },
          lb: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          lo: {
            year: "ປປປປ",
            month: "ດດ",
            day: "ວວ"
          },
          lt: {
            year: "mmmm",
            month: "mm",
            day: "dd"
          },
          lv: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          meh: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          ml: {
            year: "വർഷം",
            month: "മാസം",
            day: "തീയതി"
          },
          ms: {
            year: "tttt",
            month: "mm",
            day: "hh"
          },
          nl: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          nn: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          no: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          oc: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          pl: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          pt: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          rm: {
            year: "oooo",
            month: "mm",
            day: "dd"
          },
          ro: {
            year: "aaaa",
            month: "ll",
            day: "zz"
          },
          ru: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          sc: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          scn: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          sk: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          sl: {
            year: "llll",
            month: "mm",
            day: "dd"
          },
          sr: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          sv: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          szl: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          tg: {
            year: "сссс",
            month: "мм",
            day: "рр"
          },
          th: {
            year: "ปปปป",
            month: "ดด",
            day: "วว"
          },
          tr: {
            year: "yyyy",
            month: "aa",
            day: "gg"
          },
          uk: {
            year: "рррр",
            month: "мм",
            day: "дд"
          },
          "zh-CN": {
            year: "年",
            month: "月",
            day: "日"
          },
          "zh-TW": {
            year: "年",
            month: "月",
            day: "日"
          }
        }, "en");
        function oe(e, t) {
          if (!e) return !t;
          switch (e.type) {
            case "root":
              return "root" === (null == t ? void 0 : t.type);
            case "item":
              return "item" === (null == t ? void 0 : t.type) && (null == t ? void 0 : t.key) === e.key && (null == t ? void 0 : t.dropPosition) === e.dropPosition;
          }
        }
        function ie(e, t) {
          let {
            cursor: n,
            getKey: r
          } = e;
          return {
            setSelectedKeys(e) {
              t(t => ({
                ...t,
                selectedKeys: e
              }));
            },
            setFilterText(e) {
              t(t => ({
                ...t,
                filterText: e
              }));
            },
            insert(e, ...n) {
              t(t => ae(t, e, ...n));
            },
            insertBefore(e, ...n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                if (-1 === o) {
                  if (0 !== t.items.length) return t;
                  o = 0;
                }
                return ae(t, o, ...n);
              });
            },
            insertAfter(e, ...n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                if (-1 === o) {
                  if (0 !== t.items.length) return t;
                  o = 0;
                }
                return ae(t, o + 1, ...n);
              });
            },
            prepend(...e) {
              t(t => ae(t, 0, ...e));
            },
            append(...e) {
              t(t => ae(t, t.items.length, ...e));
            },
            remove(...e) {
              t(t => {
                let o = new Set(e),
                  i = t.items.filter(e => !o.has(r(e))),
                  a = "all";
                if ("all" !== t.selectedKeys) {
                  a = new Set(t.selectedKeys);
                  for (let t of e) a.delete(t);
                }
                return null == n && 0 === i.length && (a = new Set()), {
                  ...t,
                  items: i,
                  selectedKeys: a
                };
              });
            },
            removeSelectedItems() {
              t(e => {
                if ("all" === e.selectedKeys) return {
                  ...e,
                  items: [],
                  selectedKeys: new Set()
                };
                let t = e.selectedKeys,
                  n = e.items.filter(e => !t.has(r(e)));
                return {
                  ...e,
                  items: n,
                  selectedKeys: new Set()
                };
              });
            },
            move(e, n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                if (-1 === o) return t;
                let i = t.items.slice(),
                  [a] = i.splice(o, 1);
                return i.splice(n, 0, a), {
                  ...t,
                  items: i
                };
              });
            },
            moveBefore(e, n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                if (-1 === o) return t;
                let i = (Array.isArray(n) ? n : [...n]).map(e => t.items.findIndex(t => r(t) === e)).sort((e, t) => e - t);
                return se(t, i, o);
              });
            },
            moveAfter(e, n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                if (-1 === o) return t;
                let i = (Array.isArray(n) ? n : [...n]).map(e => t.items.findIndex(t => r(t) === e)).sort((e, t) => e - t);
                return se(t, i, o + 1);
              });
            },
            update(e, n) {
              t(t => {
                let o = t.items.findIndex(t => r(t) === e);
                return -1 === o ? t : {
                  ...t,
                  items: [...t.items.slice(0, o), n, ...t.items.slice(o + 1)]
                };
              });
            }
          };
        }
        function ae(e, t, ...n) {
          return {
            ...e,
            items: [...e.items.slice(0, t), ...n, ...e.items.slice(t)]
          };
        }
        function se(e, t, n) {
          n -= t.filter(e => e < n).length;
          let r = t.map(e => ({
            from: e,
            to: n++
          }));
          for (let e = 0; e < r.length; e++) {
            let t = r[e].from;
            for (let n = e; n < r.length; n++) {
              r[n].from > t && r[n].from--;
            }
          }
          for (let e = 0; e < r.length; e++) {
            let t = r[e];
            for (let n = r.length - 1; n > e; n--) {
              let e = r[n];
              e.from < t.to ? t.to++ : e.from++;
            }
          }
          let o = e.items.slice();
          for (let e of r) {
            let [t] = o.splice(e.from, 1);
            o.splice(e.to, 0, t);
          }
          return {
            ...e,
            items: o
          };
        }
        function le(e) {
          let t = y(e),
            [n, r] = (0, s.useState)(null),
            [o, i] = (0, s.useState)([]);
          return {
            focusStrategy: n,
            ...t,
            open(e = null) {
              r(e), t.open();
            },
            toggle(e = null) {
              r(e), t.toggle();
            },
            close() {
              i([]), t.close();
            },
            UNSTABLE_expandedKeysStack: o,
            UNSTABLE_openSubmenu: (e, t) => {
              i(n => t > n.length ? n : [...n.slice(0, t), e]);
            },
            UNSTABLE_closeSubmenu: (e, t) => {
              i(n => n[t] === e ? n.slice(0, t) : n);
            }
          };
        }
        var ue = n(96041);
        function ce(e) {
          let {
            minValue: t,
            maxValue: n,
            step: r,
            formatOptions: o,
            value: i,
            defaultValue: a = NaN,
            onChange: c,
            locale: d,
            isDisabled: p,
            isReadOnly: h
          } = e;
          null === i && (i = NaN), void 0 === i || isNaN(i) || (i = void 0 === r || isNaN(r) ? (0, l.uZ)(i, t, n) : (0, l.N4)(i, t, n, r)), isNaN(a) || (a = void 0 === r || isNaN(r) ? (0, l.uZ)(a, t, n) : (0, l.N4)(a, t, n, r));
          let [f, m] = (0, l.zk)(i, isNaN(a) ? NaN : a, c),
            [g, v] = (0, s.useState)(() => isNaN(f) ? "" : new (0, ue.e)(d, o).format(f)),
            y = (0, s.useMemo)(() => new (0, ue.d)(d, o), [d, o]),
            b = (0, s.useMemo)(() => y.getNumberingSystem(g), [y, g]),
            w = (0, s.useMemo)(() => new (0, ue.e)(d, {
              ...o,
              numberingSystem: b
            }), [d, o, b]),
            x = (0, s.useMemo)(() => w.resolvedOptions(), [w]),
            D = (0, s.useCallback)(e => isNaN(e) || null === e ? "" : w.format(e), [w]),
            C = (0, u.Q3)({
              ...e,
              value: f
            }),
            S = void 0 === r || isNaN(r) ? 1 : r;
          "percent" !== x.style || void 0 !== r && !isNaN(r) || (S = .01);
          let [E, _] = (0, s.useState)(f),
            [P, k] = (0, s.useState)(d),
            [A, z] = (0, s.useState)(o);
          Object.is(f, E) && d === P && o === A || (v(D(f)), _(f), k(d), z(o));
          let T = (0, s.useMemo)(() => y.parse(g), [y, g]),
            O = (e, r = 0) => {
              let o = T;
              if (isNaN(o)) {
                let e = isNaN(r) ? 0 : r;
                return (0, l.N4)(e, t, n, S);
              }
              {
                let r = (0, l.N4)(o, t, n, S);
                return "+" === e && r > o || "-" === e && r < o ? r : (0, l.N4)(de(e, o, S), t, n, S);
              }
            },
            I = (0, s.useMemo)(() => !p && !h && (isNaN(T) || void 0 === n || isNaN(n) || (0, l.N4)(T, t, n, S) > T || de("+", T, S) <= n), [p, h, t, n, S, T]),
            F = (0, s.useMemo)(() => !p && !h && (isNaN(T) || void 0 === t || isNaN(t) || (0, l.N4)(T, t, n, S) < T || de("-", T, S) >= t), [p, h, t, n, S, T]);
          return {
            ...C,
            validate: e => y.isValidPartialNumber(e, t, n),
            increment: () => {
              let e = O("+", t);
              e === f && v(D(e)), m(e), C.commitValidation();
            },
            incrementToMax: () => {
              null != n && (m((0, l.N4)(n, t, n, S)), C.commitValidation());
            },
            decrement: () => {
              let e = O("-", n);
              e === f && v(D(e)), m(e), C.commitValidation();
            },
            decrementToMin: () => {
              null != t && (m(t), C.commitValidation());
            },
            canIncrement: I,
            canDecrement: F,
            minValue: t,
            maxValue: n,
            numberValue: T,
            setNumberValue: m,
            setInputValue: v,
            inputValue: g,
            commit: () => {
              if (!g.length) return m(NaN), void v(void 0 === i ? "" : D(f));
              if (isNaN(T)) return void v(D(f));
              let e;
              e = void 0 === r || isNaN(r) ? (0, l.uZ)(T, t, n) : (0, l.N4)(T, t, n, r), e = y.parse(D(e)), m(e), v(D(void 0 === i ? e : f));
            }
          };
        }
        function de(e, t, n) {
          let r = "+" === e ? t + n : t - n;
          if (t % 1 != 0 || n % 1 != 0) {
            const o = t.toString().split("."),
              i = n.toString().split("."),
              a = o[1] && o[1].length || 0,
              s = i[1] && i[1].length || 0,
              l = Math.pow(10, Math.max(a, s));
            t = Math.round(t * l), n = Math.round(n * l), r = "+" === e ? t + n : t - n, r /= l;
          }
          return r;
        }
        let pe = Math.round(1e10 * Math.random()),
          he = 0;
        function fe(e) {
          if (null != e) return e.toString();
        }
        var me = n(31397);
        class ge {
          *[Symbol.iterator]() {
            yield* [...this.rows];
          }
          get size() {
            return [...this.rows].length;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            var e;
            return null === [...this.rows][0] || void 0 === e ? void 0 : e.key;
          }
          getLastKey() {
            var e;
            let t = [...this.rows];
            return null === t[t.length - 1] || void 0 === e ? void 0 : e.key;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getChildren(e) {
            let t = this.keyMap.get(e);
            return (null == t ? void 0 : t.childNodes) || [];
          }
          constructor(e) {
            this.keyMap = new Map(), this.keyMap = new Map(), this.columnCount = null == e ? void 0 : e.columnCount, this.rows = [];
            let t,
              n = t => {
                let o = this.keyMap.get(t.key);
                e.visitNode && e.visitNode(t), this.keyMap.set(t.key, t);
                let i,
                  a = new Set();
                for (let e of t.childNodes) "cell" === e.type && null == e.parentKey && (e.parentKey = t.key), a.add(e.key), i ? (i.nextKey = e.key, e.prevKey = i.key) : e.prevKey = null, n(e), e;
                if (i && (i.nextKey = null), o) for (let e of o.childNodes) a.has(e.key) || r(e);
              },
              r = e => {
                this.keyMap.delete(e.key);
                for (let t of e.childNodes) this.keyMap.get(t.key) === t && r(t);
              };
            e.items.forEach((e, r) => {
              let o = {
                level: 0,
                key: "row-" + r,
                type: "row",
                value: void 0,
                hasChildNodes: !0,
                childNodes: [...e.childNodes],
                rendered: void 0,
                textValue: void 0,
                ...e
              };
              t ? (t.nextKey = o.key, o.prevKey = t.key) : o.prevKey = null, this.rows.push(o), n(o), o;
            }), t && (t.nextKey = null);
          }
        }
        n(62651);
        const ve = "row-header-column-" + Math.random().toString(36).slice(2);
        let ye = "row-header-column-" + Math.random().toString(36).slice(2);
        for (; ve === ye;) ye = "row-header-column-" + Math.random().toString(36).slice(2);
        class be extends ge {
          *[Symbol.iterator]() {
            yield* this.body.childNodes;
          }
          get size() {
            return this._size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            var e;
            return null === (0, c.l8)(this.body.childNodes) || void 0 === e ? void 0 : e.key;
          }
          getLastKey() {
            var e;
            return null === (0, c.s)(this.body.childNodes) || void 0 === e ? void 0 : e.key;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getTextValue(e) {
            let t = this.getItem(e);
            if (!t) return "";
            if (t.textValue) return t.textValue;
            let n = this.rowHeaderColumnKeys;
            if (n) {
              let e = [];
              for (let r of t.childNodes) {
                let t = this.columns[r.index];
                if (n.has(t.key) && r.textValue && e.push(r.textValue), e.length === n.size) break;
              }
              return e.join(" ");
            }
            return "";
          }
          constructor(e, t, n) {
            let r,
              o = new Set(),
              i = [];
            if (null == n ? void 0 : n.showSelectionCheckboxes) {
              let e = {
                type: "column",
                key: ve,
                value: null,
                textValue: "",
                level: 0,
                index: (null == n ? void 0 : n.showDragButtons) ? 1 : 0,
                hasChildNodes: !1,
                rendered: null,
                childNodes: [],
                props: {
                  isSelectionCell: !0
                }
              };
              i.unshift(e);
            }
            if (null == n ? void 0 : n.showDragButtons) {
              let e = {
                type: "column",
                key: ye,
                value: null,
                textValue: "",
                level: 0,
                index: 0,
                hasChildNodes: !1,
                rendered: null,
                childNodes: [],
                props: {
                  isDragButtonCell: !0
                }
              };
              i.unshift(e);
            }
            let a = [],
              s = new Map(),
              l = e => {
                switch (e.type) {
                  case "body":
                    e;
                    break;
                  case "column":
                    s.set(e.key, e), e.hasChildNodes || (i.push(e), e.props.isRowHeader && o.add(e.key));
                    break;
                  case "item":
                    return void a.push(e);
                }
                for (let t of e.childNodes) l(t);
              };
            for (let t of e) l(t);
            let u = function (e, t) {
              if (0 === t.length) return [];
              let n = [],
                r = new Map();
              for (let o of t) {
                let t = o.parentKey,
                  i = [o];
                for (; t;) {
                  let n = e.get(t);
                  if (!n) break;
                  if (r.has(n)) {
                    n.colspan++;
                    let {
                      column: e,
                      index: t
                    } = r.get(n);
                    if (t > i.length) break;
                    for (let n = t; n < i.length; n++) e.splice(n, 0, null);
                    for (let t = i.length; t < e.length; t++) e[t] && r.has(e[t]) && (r.get(e[t]).index = t);
                  } else n.colspan = 1, i.push(n), r.set(n, {
                    column: i,
                    index: i.length - 1
                  });
                  n.parentKey;
                }
                n.push(i), o.index = n.length - 1;
              }
              let o = Math.max(...n.map(e => e.length)),
                i = Array(o).fill(0).map(() => []),
                a = 0;
              for (let e of n) {
                let t = o - 1;
                for (let n of e) {
                  if (n) {
                    let e = i[t],
                      r = e.reduce((e, t) => e + t.colspan, 0);
                    if (r < a) {
                      let o = {
                        type: "placeholder",
                        key: "placeholder-" + n.key,
                        colspan: a - r,
                        index: r,
                        value: null,
                        rendered: null,
                        level: t,
                        hasChildNodes: !1,
                        childNodes: [],
                        textValue: null
                      };
                      e.length > 0 && (e[e.length - 1].nextKey = o.key, o.prevKey = e[e.length - 1].key), e.push(o);
                    }
                    e.length > 0 && (e[e.length - 1].nextKey = n.key, n.prevKey = e[e.length - 1].key), n.level = t, n.colIndex = a, e.push(n);
                  }
                  0;
                }
                0;
              }
              let s = 0;
              for (let e of i) {
                let n = e.reduce((e, t) => e + t.colspan, 0);
                if (n < t.length) {
                  let r = {
                    type: "placeholder",
                    key: "placeholder-" + e[e.length - 1].key,
                    colspan: t.length - n,
                    index: n,
                    value: null,
                    rendered: null,
                    level: s,
                    hasChildNodes: !1,
                    childNodes: [],
                    textValue: null,
                    prevKey: e[e.length - 1].key
                  };
                  e.push(r);
                }
                0;
              }
              return i.map((e, t) => ({
                type: "headerrow",
                key: "headerrow-" + t,
                index: t,
                value: null,
                rendered: null,
                level: 0,
                hasChildNodes: !0,
                childNodes: e,
                textValue: null
              }));
            }(s, i);
            u.forEach((e, t) => a.splice(t, 0, e)), super({
              columnCount: i.length,
              items: a,
              visitNode: e => (e.column = i[e.index], e)
            }), this._size = 0, this.columns = i, this.rowHeaderColumnKeys = o, this.body = r, this.headerRows = u, this._size = [...r.childNodes].length, 0 === this.rowHeaderColumnKeys.size && this.rowHeaderColumnKeys.add(this.columns.find(e => {
              var t, n;
              return !(null === e.props || void 0 === t ? void 0 : t.isDragButtonCell) && !(null === e.props || void 0 === n ? void 0 : n.isSelectionCell);
            }).key);
          }
        }
        function we(e) {
          return null;
        }
        we.getCollectionNode = function* (e, t) {
          let {
            children: n,
            columns: r
          } = e;
          if (t.columns = [], "function" == typeof n) {
            if (!r) throw new Error("props.children was a function but props.columns is missing");
            for (let e of r) yield {
              type: "column",
              value: e,
              renderer: n
            };
          } else {
            let e = [];
            s.Children.forEach(n, t => {
              e.push({
                type: "column",
                element: t
              });
            }), yield* e;
          }
        };
        function xe(e) {
          return null;
        }
        xe.getCollectionNode = function* (e) {
          let {
            children: t,
            items: n
          } = e;
          yield {
            type: "body",
            hasChildNodes: !0,
            props: e,
            *childNodes() {
              if ("function" == typeof t) {
                if (!n) throw new Error("props.children was a function but props.items is missing");
                for (let e of n) yield {
                  type: "item",
                  value: e,
                  renderer: t
                };
              } else {
                let e = [];
                s.Children.forEach(t, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        function De(e) {
          return null;
        }
        De.getCollectionNode = function* (e, t) {
          let {
              title: n,
              children: r,
              childColumns: o
            } = e,
            i = n || r,
            a = e.textValue || ("string" == typeof i ? i : "") || e["aria-label"],
            l = yield {
              type: "column",
              hasChildNodes: !!o || n && s.Children.count(r) > 0,
              rendered: i,
              textValue: a,
              props: e,
              *childNodes() {
                if (o) for (let e of o) yield {
                  type: "column",
                  value: e
                };else if (n) {
                  let e = [];
                  s.Children.forEach(r, t => {
                    e.push({
                      type: "column",
                      element: t
                    });
                  }), yield* e;
                }
              },
              shouldInvalidate: e => (u(e), !1)
            },
            u = e => {
              for (let t of l) t.hasChildNodes || e.columns.push(t);
            };
          u(t);
        };
        function Ce(e) {
          return null;
        }
        Ce.getCollectionNode = function* (e, t) {
          let {
            children: n,
            textValue: r,
            UNSTABLE_childItems: o
          } = e;
          yield {
            type: "item",
            props: e,
            textValue: r,
            "aria-label": e["aria-label"],
            hasChildNodes: !0,
            *childNodes() {
              if (t.showDragButtons && (yield {
                type: "cell",
                key: "header-drag",
                props: {
                  isDragButtonCell: !0
                }
              }), t.showSelectionCheckboxes && "none" !== t.selectionMode && (yield {
                type: "cell",
                key: "header",
                props: {
                  isSelectionCell: !0
                }
              }), "function" == typeof n) {
                for (let e of t.columns) yield {
                  type: "cell",
                  element: n(e.key),
                  key: e.key
                };
                if (o) for (let e of o) yield {
                  type: "item",
                  value: e
                };
              } else {
                let e = [],
                  r = [];
                if (s.Children.forEach(n, n => {
                  if (n.type === Ce) {
                    if (e.length < t.columns.length) throw new Error("All of a Row's child Cells must be positioned before any child Rows.");
                    r.push({
                      type: "item",
                      element: n
                    });
                  } else e.push({
                    type: "cell",
                    element: n
                  });
                }), e.length !== t.columns.length) throw new Error(`Cell count must match column count. Found ${e.length} cells and ${t.columns.length} columns.`);
                yield* e, yield* r;
              }
            },
            shouldInvalidate: e => e.columns.length !== t.columns.length || e.columns.some((e, n) => e.key !== t.columns[n].key) || e.showSelectionCheckboxes !== t.showSelectionCheckboxes || e.showDragButtons !== t.showDragButtons || e.selectionMode !== t.selectionMode
          };
        };
        function Se(e) {
          return null;
        }
        Se.getCollectionNode = function* (e) {
          let {
              children: t
            } = e,
            n = e.textValue || ("string" == typeof t ? t : "") || e["aria-label"] || "";
          yield {
            type: "cell",
            props: e,
            rendered: t,
            textValue: n,
            "aria-label": e["aria-label"],
            hasChildNodes: !1
          };
        };
        function Ee(e, t) {
          let n = null;
          if (e) {
            for (n = e.getFirstKey(); t.has(n) && n !== e.getLastKey();) n = e.getKeyAfter(n);
            t.has(n) && n === e.getLastKey() && (n = e.getFirstKey());
          }
          return n;
        }
        var _e = n(21946);
        const Pe = 1500,
          ke = 500;
        let Ae = {},
          ze = 0,
          Te = !1,
          Oe = null,
          Ie = null;
        function Fe(e = {}) {
          let {
              delay: t = Pe,
              closeDelay: n = ke
            } = e,
            {
              isOpen: r,
              open: o,
              close: i
            } = y(e),
            a = (0, s.useMemo)(() => "" + ++ze, []),
            l = (0, s.useRef)(),
            u = () => {
              Ae[a] = p;
            },
            c = () => {
              for (let e in Ae) e !== a && (Ae[e](!0), delete Ae[e]);
            },
            d = () => {
              clearTimeout(l.current), l.current = null, c(), u(), Te = !0, o(), Oe && (clearTimeout(Oe), Oe = null), Ie && (clearTimeout(Ie), Ie = null);
            },
            p = e => {
              e || n <= 0 ? (clearTimeout(l.current), l.current = null, i()) : l.current || (l.current = setTimeout(() => {
                l.current = null, i();
              }, n)), Oe && (clearTimeout(Oe), Oe = null), Te && (Ie && clearTimeout(Ie), Ie = setTimeout(() => {
                delete Ae[a], Ie = null, Te = !1;
              }, Math.max(ke, n)));
            };
          return (0, s.useEffect)(() => () => {
            clearTimeout(l.current), Ae[a] && delete Ae[a];
          }, [a]), {
            isOpen: r,
            open: e => {
              !e && t > 0 && !l.current ? (c(), u(), r || Oe || Te ? r || d() : Oe = setTimeout(() => {
                Oe = null, Te = !0, d();
              }, t)) : d();
            },
            close: p
          };
        }
        class Me {
          *[Symbol.iterator]() {
            yield* this.iterable;
          }
          get size() {
            return this.keyMap.size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            return this.firstKey;
          }
          getLastKey() {
            return this.lastKey;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          constructor(e, {
            expandedKeys: t
          } = {}) {
            this.keyMap = new Map(), this.iterable = e, t = t || new Set();
            let n,
              r = e => {
                if (this.keyMap.set(e.key, e), e.childNodes && ("section" === e.type || t.has(e.key))) for (let t of e.childNodes) r(t);
              };
            for (let t of e) r(t);
            let o = 0;
            for (let [e, t] of this.keyMap) n ? (n.nextKey = e, t.prevKey = n.key) : (this.firstKey = e, t.prevKey = void 0), "item" === t.type && (t.index = o++), n = t, n.nextKey = void 0;
            this.lastKey = null == n ? void 0 : n.key;
          }
        }
        function Re(e) {
          let [t, n] = (0, l.zk)(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : new Set(), e.onExpandedChange),
            r = p(e),
            o = (0, s.useMemo)(() => e.disabledKeys ? new Set(e.disabledKeys) : new Set(), [e.disabledKeys]),
            i = (0, c.Kx)(e, (0, s.useCallback)(e => new Me(e, {
              expandedKeys: t
            }), [t]), null);
          (0, s.useEffect)(() => {
            null == r.focusedKey || i.getItem(r.focusedKey) || r.setFocusedKey(null);
          }, [i, r.focusedKey]);
          return {
            collection: i,
            expandedKeys: t,
            disabledKeys: o,
            toggleKey: e => {
              n(function (e, t) {
                let n = new Set(e);
                n.has(t) ? n.delete(t) : n.add(t);
                return n;
              }(t, e));
            },
            setExpandedKeys: n,
            selectionManager: new f(i, r)
          };
        }
        var je = n(8840),
          Be = n(20770),
          Ne = n(43098),
          Le = n(70799),
          Ve = n(85893),
          Ke = n(99666),
          qe = n(85816),
          He = n(23652),
          Ue = n(83034),
          Ze = n(31108),
          $e = n(56479);
        function Ge(e) {
          var t = e.match(/^var\((.*)\)$/);
          return t ? t[1] : e;
        }
        function We(e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : [],
            r = e.constructor();
          for (var o in e) {
            var i = e[o],
              a = [...n, o];
            "string" == typeof i || "number" == typeof i || null == i ? r[o] = t(i, a) : "object" != typeof i || Array.isArray(i) ? console.warn('Skipping invalid key "'.concat(a.join("."), '". Should be a string, number, null or object. Received: "').concat(Array.isArray(i) ? "Array" : typeof i, '"')) : r[o] = We(i, t, a);
          }
          return r;
        }
        function Ye(e, t) {
          var n = {};
          if ("object" == typeof t) {
            var r = e;
            We(t, (e, t) => {
              if (null != e) {
                var o = function (e, t) {
                  var n = e;
                  for (var r of t) {
                    if (!(r in n)) throw new Error("Path ".concat(t.join(" -> "), " does not exist in object"));
                    n = n[r];
                  }
                  return n;
                }(r, t);
                n[Ge(o)] = String(e);
              }
            });
          } else {
            var o = e;
            for (var i in o) {
              var a = o[i];
              null != a && (n[Ge(i)] = a);
            }
          }
          return Object.defineProperty(n, "toString", {
            value: function () {
              return Object.keys(this).map(e => "".concat(e, ":").concat(this[e])).join(";");
            },
            writable: !1
          }), n;
        }
        function Xe() {
          return Xe = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, Xe.apply(this, arguments);
        }
        function Qe(...e) {
          return t => e.forEach(e => function (e, t) {
            "function" == typeof e ? e(t) : null != e && (e.current = t);
          }(e, t));
        }
        const Je = (0, s.forwardRef)((e, t) => {
          const {
              children: n,
              ...r
            } = e,
            o = s.Children.toArray(n),
            i = o.find(nt);
          if (i) {
            const e = i.props.children,
              n = o.map(t => t === i ? s.Children.count(e) > 1 ? s.Children.only(null) : (0, s.isValidElement)(e) ? e.props.children : null : t);
            return (0, s.createElement)(et, Xe({}, r, {
              ref: t
            }), (0, s.isValidElement)(e) ? (0, s.cloneElement)(e, void 0, n) : null);
          }
          return (0, s.createElement)(et, Xe({}, r, {
            ref: t
          }), n);
        });
        Je.displayName = "Slot";
        const et = (0, s.forwardRef)((e, t) => {
          const {
            children: n,
            ...r
          } = e;
          return (0, s.isValidElement)(n) ? (0, s.cloneElement)(n, {
            ...rt(r, n.props),
            ref: t ? Qe(t, n.ref) : n.ref
          }) : s.Children.count(n) > 1 ? s.Children.only(null) : null;
        });
        et.displayName = "SlotClone";
        const tt = ({
          children: e
        }) => (0, s.createElement)(s.Fragment, null, e);
        function nt(e) {
          return (0, s.isValidElement)(e) && e.type === tt;
        }
        function rt(e, t) {
          const n = {
            ...t
          };
          for (const r in t) {
            const o = e[r],
              i = t[r];
            /^on[A-Z]/.test(r) ? o && i ? n[r] = (...e) => {
              i(...e), o(...e);
            } : o && (n[r] = o) : "style" === r ? n[r] = {
              ...o,
              ...i
            } : "className" === r && (n[r] = [o, i].filter(Boolean).join(" "));
          }
          return {
            ...e,
            ...n
          };
        }
        var ot,
          it = n(45071),
          at = n(41609),
          st = n.n(at),
          lt = n(88786),
          ut = n(58197);
        ot = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "أداة انتقاء اللون",
          twoDimensionalSlider: "مُنزلق 2D"
        };
        var ct;
        ct = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Средство за избиране на цвят",
          twoDimensionalSlider: "2D плъзгач"
        };
        var dt;
        dt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Výběr barvy",
          twoDimensionalSlider: "2D posuvník"
        };
        var pt;
        pt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Farvevælger",
          twoDimensionalSlider: "2D-skyder"
        };
        var ht;
        ht = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Farbwähler",
          twoDimensionalSlider: "2D-Schieberegler"
        };
        var ft;
        ft = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Επιλογέας χρωμάτων",
          twoDimensionalSlider: "Ρυθμιστικό 2D"
        };
        var mt;
        mt = {
          colorPicker: "Color picker",
          twoDimensionalSlider: "2D slider",
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`
        };
        var gt;
        gt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Selector de color",
          twoDimensionalSlider: "Regulador 2D"
        };
        var vt;
        vt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Värvivalija",
          twoDimensionalSlider: "2D-liugur"
        };
        var yt;
        yt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Värimuokkain",
          twoDimensionalSlider: "2D-liukusäädin"
        };
        var bt;
        bt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name} : ${e.value}`,
          colorPicker: "Sélecteur de couleurs",
          twoDimensionalSlider: "Curseur 2D"
        };
        var wt;
        wt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "בוחר הצבעים",
          twoDimensionalSlider: "מחוון דו מימדי"
        };
        var xt;
        xt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Odabir boje",
          twoDimensionalSlider: "2D klizač"
        };
        var Dt;
        Dt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Színválasztó",
          twoDimensionalSlider: "2D-csúszka"
        };
        var Ct;
        Ct = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Selettore colore",
          twoDimensionalSlider: "Cursore 2D"
        };
        var St;
        St = {
          colorInputLabel: e => `${e.label}、${e.channelLabel}`,
          colorNameAndValue: e => `${e.name} : ${e.value}`,
          colorPicker: "カラーピッカー",
          twoDimensionalSlider: "2D スライダー"
        };
        var Et;
        Et = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "색상 피커",
          twoDimensionalSlider: "2D 슬라이더"
        };
        var _t;
        _t = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Spalvų parinkiklis",
          twoDimensionalSlider: "2D slankiklis"
        };
        var Pt;
        Pt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Krāsu atlasītājs",
          twoDimensionalSlider: "2D slīdnis"
        };
        var kt;
        kt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Fargevelger",
          twoDimensionalSlider: "2D-glidebryter"
        };
        var At;
        At = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Kleurkiezer",
          twoDimensionalSlider: "2D-schuifregelaar"
        };
        var zt;
        zt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Próbnik kolorów",
          twoDimensionalSlider: "Suwak 2D"
        };
        var Tt;
        Tt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Seletor de cores",
          twoDimensionalSlider: "Controle deslizante 2D"
        };
        var Ot;
        Ot = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Seletor de cores",
          twoDimensionalSlider: "Controle deslizante 2D"
        };
        var It;
        It = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Selector de culori",
          twoDimensionalSlider: "Glisor 2D"
        };
        var Ft;
        Ft = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Палитра цветов",
          twoDimensionalSlider: "Ползунок 2D"
        };
        var Mt;
        Mt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Výber farieb",
          twoDimensionalSlider: "2D jazdec"
        };
        var Rt;
        Rt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Izbirnik barv",
          twoDimensionalSlider: "2D drsnik"
        };
        var jt;
        jt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Birač boja",
          twoDimensionalSlider: "2D klizač"
        };
        var Bt;
        Bt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Färgväljaren",
          twoDimensionalSlider: "2D-reglage"
        };
        var Nt;
        Nt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Renk Seçici",
          twoDimensionalSlider: "2D sürgü"
        };
        var Lt;
        Lt = {
          colorInputLabel: e => `${e.label}, ${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}: ${e.value}`,
          colorPicker: "Палітра кольорів",
          twoDimensionalSlider: "Повзунок 2D"
        };
        var Vt;
        Vt = {
          colorInputLabel: e => `${e.label}、${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}：${e.value}`,
          colorPicker: "拾色器",
          twoDimensionalSlider: "2D 滑块"
        };
        var Kt;
        Kt = {
          colorInputLabel: e => `${e.label}，${e.channelLabel}`,
          colorNameAndValue: e => `${e.name}：${e.value}`,
          colorPicker: "檢色器",
          twoDimensionalSlider: "2D 滑桿"
        };
        var qt = n(49987),
          Ht = n(18383),
          Ut = n(55387),
          Zt = n(13607),
          $t = n(91788),
          Gt = n(59292);
        function Wt(e) {
          return e && e.__esModule ? e.default : e;
        }
        var Yt;
        Yt = {
          "ar-AE": ot,
          "bg-BG": ct,
          "cs-CZ": dt,
          "da-DK": pt,
          "de-DE": ht,
          "el-GR": ft,
          "en-US": mt,
          "es-ES": gt,
          "et-EE": vt,
          "fi-FI": yt,
          "fr-FR": bt,
          "he-IL": wt,
          "hr-HR": xt,
          "hu-HU": Dt,
          "it-IT": Ct,
          "ja-JP": St,
          "ko-KR": Et,
          "lt-LT": _t,
          "lv-LV": Pt,
          "nb-NO": kt,
          "nl-NL": At,
          "pl-PL": zt,
          "pt-BR": Tt,
          "pt-PT": Ot,
          "ro-RO": It,
          "ru-RU": Ft,
          "sk-SK": Mt,
          "sl-SI": Rt,
          "sr-SP": jt,
          "sv-SE": Bt,
          "tr-TR": Nt,
          "uk-UA": Lt,
          "zh-CN": Vt,
          "zh-TW": Kt
        };
        function Xt({
          direction: e,
          state: t,
          zChannel: n,
          xChannel: r,
          isDisabled: o
        }) {
          return (0, s.useMemo)(() => {
            let i = ["top", "rtl" === e ? "left" : "right"],
              a = !1,
              s = {
                colorAreaStyles: {},
                gradientStyles: {}
              },
              l = t.value.getChannelValue(n),
              {
                minValue: u,
                maxValue: c
              } = t.value.getChannelRange(n),
              d = (l - u) / (c - u),
              p = "hsl" === t.value.getColorSpace();
            if (!o) switch (n) {
              case "red":
                a = "green" === r, s = ((e, t, n) => {
                  let r = `linear-gradient(to ${e[Number(!t)]}, transparent, #000)`;
                  return {
                    colorAreaStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(${n},0,0),rgb(${n},255,0))`
                    },
                    gradientStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(${n},0,255),rgb(${n},255,255))`,
                      WebkitMaskImage: r,
                      maskImage: r
                    }
                  };
                })(i, a, l);
                break;
              case "green":
                a = "red" === r, s = ((e, t, n) => {
                  let r = `linear-gradient(to ${e[Number(!t)]}, transparent, #000)`;
                  return {
                    colorAreaStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(0,${n},0),rgb(255,${n},0))`
                    },
                    gradientStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(0,${n},255),rgb(255,${n},255))`,
                      WebkitMaskImage: r,
                      maskImage: r
                    }
                  };
                })(i, a, l);
                break;
              case "blue":
                a = "red" === r, s = ((e, t, n) => {
                  let r = `linear-gradient(to ${e[Number(!t)]}, transparent, #000)`;
                  return {
                    colorAreaStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(0,0,${n}),rgb(255,0,${n}))`
                    },
                    gradientStyles: {
                      backgroundImage: `linear-gradient(to ${e[Number(t)]},rgb(0,255,${n}),rgb(255,255,${n}))`,
                      WebkitMaskImage: r,
                      maskImage: r
                    }
                  };
                })(i, a, l);
                break;
              case "hue":
                a = "saturation" !== r, s = p ? ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    background: [`linear-gradient(to ${e[Number(t)]}, hsla(0,0%,0%,1) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,1) 100%)`, `linear-gradient(to ${e[Number(!t)]},hsl(0,0%,50%),hsla(0,0%,50%,0))`, `hsl(${n}, 100%, 50%)`].join(",")
                  }
                }))(i, a, l) : ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    background: [`linear-gradient(to ${e[Number(t)]},hsl(0,0%,0%),hsla(0,0%,0%,0))`, `linear-gradient(to ${e[Number(!t)]},hsl(0,0%,100%),hsla(0,0%,100%,0))`, `hsl(${n}, 100%, 50%)`].join(",")
                  }
                }))(i, a, l);
                break;
              case "saturation":
                a = "hue" === r, s = p ? ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    background: [`linear-gradient(to ${e[Number(!t)]}, hsla(0,0%,0%,${n}) 0%, hsla(0,0%,0%,0) 50%, hsla(0,0%,100%,0) 50%, hsla(0,0%,100%,${n}) 100%)`, `linear-gradient(to ${e[Number(t)]},hsla(0,100%,50%,${n}),hsla(60,100%,50%,${n}),hsla(120,100%,50%,${n}),hsla(180,100%,50%,${n}),hsla(240,100%,50%,${n}),hsla(300,100%,50%,${n}),hsla(359,100%,50%,${n}))`, "hsl(0, 0%, 50%)"].join(",")
                  }
                }))(i, a, d) : ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    background: [`linear-gradient(to ${e[Number(!t)]},hsla(0,0%,0%,${n}),hsla(0,0%,0%,0))`, `linear-gradient(to ${e[Number(t)]},hsla(0,100%,50%,${n}),hsla(60,100%,50%,${n}),hsla(120,100%,50%,${n}),hsla(180,100%,50%,${n}),hsla(240,100%,50%,${n}),hsla(300,100%,50%,${n}),hsla(359,100%,50%,${n}))`, `linear-gradient(to ${e[Number(!t)]},hsl(0,0%,0%),hsl(0,0%,100%))`].join(",")
                  }
                }))(i, a, d);
                break;
              case "brightness":
                a = "hue" === r, s = ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    background: [`linear-gradient(to ${e[Number(!t)]},hsla(0,0%,100%,${n}),hsla(0,0%,100%,0))`, `linear-gradient(to ${e[Number(t)]},hsla(0,100%,50%,${n}),hsla(60,100%,50%,${n}),hsla(120,100%,50%,${n}),hsla(180,100%,50%,${n}),hsla(240,100%,50%,${n}),hsla(300,100%,50%,${n}),hsla(359,100%,50%,${n}))`, "#000"].join(",")
                  }
                }))(i, a, d);
                break;
              case "lightness":
                a = "hue" === r, s = ((e, t, n) => ({
                  colorAreaStyles: {},
                  gradientStyles: {
                    backgroundImage: [`linear-gradient(to ${e[Number(!t)]},hsl(0,0%,${n}%),hsla(0,0%,${n}%,0))`, `linear-gradient(to ${e[Number(t)]},hsl(0,100%,${n}%),hsl(60,100%,${n}%),hsl(120,100%,${n}%),hsl(180,100%,${n}%),hsl(240,100%,${n}%),hsl(300,100%,${n}%),hsl(360,100%,${n}%))`].join(",")
                  }
                }))(i, a, l);
            }
            let {
              x: h,
              y: f
            } = t.getThumbPosition();
            "rtl" === e && (h = 1 - h);
            let m = {
              forcedColorAdjust: "none"
            };
            return {
              colorAreaStyleProps: {
                style: {
                  position: "relative",
                  touchAction: "none",
                  ...m,
                  ...s.colorAreaStyles
                }
              },
              gradientStyleProps: {
                style: {
                  touchAction: "none",
                  ...m,
                  ...s.gradientStyles
                }
              },
              thumbStyleProps: {
                style: {
                  position: "absolute",
                  left: 100 * h + "%",
                  top: 100 * f + "%",
                  transform: "translate(0%, 0%)",
                  touchAction: "none",
                  ...m
                }
              }
            };
          }, [e, t, n, r, o]);
        }
        function Qt(e, t, n, r = e => e) {
          return e * r(.5 - t * (.5 - n));
        }
        function Jt(e, t) {
          return [e[0] + t[0], e[1] + t[1]];
        }
        function en(e, t) {
          return [e[0] - t[0], e[1] - t[1]];
        }
        function tn(e, t) {
          return [e[0] * t, e[1] * t];
        }
        function nn(e) {
          return [e[1], -e[0]];
        }
        function rn(e, t) {
          return e[0] * t[0] + e[1] * t[1];
        }
        function on(e, t) {
          return e[0] === t[0] && e[1] === t[1];
        }
        function an(e, t) {
          return function (e) {
            return e[0] * e[0] + e[1] * e[1];
          }(en(e, t));
        }
        function sn(e) {
          return function (e, t) {
            return [e[0] / t, e[1] / t];
          }(e, function (e) {
            return Math.hypot(e[0], e[1]);
          }(e));
        }
        function ln(e, t) {
          return Math.hypot(e[1] - t[1], e[0] - t[0]);
        }
        function un(e, t, n) {
          let r = Math.sin(n),
            o = Math.cos(n),
            i = e[0] - t[0],
            a = e[1] - t[1],
            s = i * r + a * o;
          return [i * o - a * r + t[0], s + t[1]];
        }
        function cn(e, t, n) {
          return Jt(e, tn(en(t, e), n));
        }
        function dn(e, t, n) {
          return Jt(e, tn(t, n));
        }
        var {
            min: pn,
            PI: hn
          } = Math,
          fn = hn + 1e-4;
        function mn(e, t = {}) {
          return function (e, t = {}) {
            let {
                size: n = 16,
                smoothing: r = .5,
                thinning: o = .5,
                simulatePressure: i = !0,
                easing: a = e => e,
                start: s = {},
                end: l = {},
                last: u = !1
              } = t,
              {
                cap: c = !0,
                easing: d = e => e * (2 - e)
              } = s,
              {
                cap: p = !0,
                easing: h = e => --e * e * e + 1
              } = l;
            if (0 === e.length || n <= 0) return [];
            let f,
              m = e[e.length - 1].runningLength,
              g = !1 === s.taper ? 0 : !0 === s.taper ? Math.max(n, m) : s.taper,
              v = !1 === l.taper ? 0 : !0 === l.taper ? Math.max(n, m) : l.taper,
              y = Math.pow(n * r, 2),
              b = [],
              w = [],
              x = e.slice(0, 10).reduce((e, t) => {
                let r = t.pressure;
                if (i) {
                  let o = pn(1, t.distance / n),
                    i = pn(1, 1 - o);
                  r = pn(1, e + .275 * o * (i - e));
                }
                return (e + r) / 2;
              }, e[0].pressure),
              D = Qt(n, o, e[e.length - 1].pressure, a),
              C = e[0].vector,
              S = e[0].point,
              E = S,
              _ = S,
              P = E,
              k = !1;
            for (let t = 0; t < e.length; t++) {
              let {
                  pressure: r
                } = e[t],
                {
                  point: s,
                  vector: l,
                  distance: u,
                  runningLength: c
                } = e[t];
              if (t < e.length - 1 && m - c < 3) continue;
              if (o) {
                if (i) {
                  let e = pn(1, u / n),
                    t = pn(1, 1 - e);
                  r = pn(1, x + .275 * e * (t - x));
                }
                D = Qt(n, o, r, a);
              } else D = n / 2;
              void 0 === f && (f = D);
              let p = c < g ? d(c / g) : 1,
                A = m - c < v ? h((m - c) / v) : 1;
              D = Math.max(.01, D * Math.min(p, A));
              let z = (t < e.length - 1 ? e[t + 1] : e[t]).vector,
                T = t < e.length - 1 ? rn(l, z) : 1,
                O = null !== T && T < 0;
              if (rn(l, C) < 0 && !k || O) {
                let e = tn(nn(C), D);
                for (let t = 1 / 13, n = 0; n <= 1; n += t) _ = un(en(s, e), s, fn * n), b.push(_), P = un(Jt(s, e), s, fn * -n), w.push(P);
                S = _, E = P, O && (k = !0);
                continue;
              }
              if (k = !1, t === e.length - 1) {
                let e = tn(nn(l), D);
                b.push(en(s, e)), w.push(Jt(s, e));
                continue;
              }
              let I = tn(nn(cn(z, l, T)), D);
              _ = en(s, I), (t <= 1 || an(S, _) > y) && (b.push(_), S = _), P = Jt(s, I), (t <= 1 || an(E, P) > y) && (w.push(P), E = P), x = r, C = l;
            }
            let A = e[0].point.slice(0, 2),
              z = e.length > 1 ? e[e.length - 1].point.slice(0, 2) : Jt(e[0].point, [1, 1]),
              T = [],
              O = [];
            if (1 === e.length) {
              if (!g && !v || u) {
                let e = dn(A, sn(nn(en(A, z))), -(f || D)),
                  t = [];
                for (let n = 1 / 13, r = n; r <= 1; r += n) t.push(un(e, A, 2 * fn * r));
                return t;
              }
            } else {
              if (!(g || v && 1 === e.length)) if (c) for (let e = 1 / 13, t = e; t <= 1; t += e) {
                let e = un(w[0], A, fn * t);
                T.push(e);
              } else {
                let e = en(b[0], w[0]),
                  t = tn(e, .5),
                  n = tn(e, .51);
                T.push(en(A, t), en(A, n), Jt(A, n), Jt(A, t));
              }
              let t = nn(function (e) {
                return [-e[0], -e[1]];
              }(e[e.length - 1].vector));
              if (v || g && 1 === e.length) O.push(z);else if (p) {
                let e = dn(z, t, D);
                for (let t = 1 / 29, n = t; n < 1; n += t) O.push(un(e, z, 3 * fn * n));
              } else O.push(Jt(z, tn(t, D)), Jt(z, tn(t, .99 * D)), en(z, tn(t, .99 * D)), en(z, tn(t, D)));
            }
            return b.concat(O, w.reverse(), T);
          }(function (e, t = {}) {
            var n;
            let {
              streamline: r = .5,
              size: o = 16,
              last: i = !1
            } = t;
            if (0 === e.length) return [];
            let a = .15 + .85 * (1 - r),
              s = Array.isArray(e[0]) ? e : e.map(({
                x: e,
                y: t,
                pressure: n = .5
              }) => [e, t, n]);
            if (2 === s.length) {
              let e = s[1];
              s = s.slice(0, -1);
              for (let t = 1; t < 5; t++) s.push(cn(s[0], e, t / 4));
            }
            1 === s.length && (s = [...s, [...Jt(s[0], [1, 1]), ...s[0].slice(2)]]);
            let l = [{
                point: [s[0][0], s[0][1]],
                pressure: s[0][2] >= 0 ? s[0][2] : .25,
                vector: [1, 1],
                distance: 0,
                runningLength: 0
              }],
              u = !1,
              c = 0,
              d = l[0],
              p = s.length - 1;
            for (let e = 1; e < s.length; e++) {
              let t = i && e === p ? s[e].slice(0, 2) : cn(d.point, s[e], a);
              if (on(d.point, t)) continue;
              let n = ln(t, d.point);
              if (c += n, e < p && !u) {
                if (c < o) continue;
                u = !0;
              }
              d = {
                point: t,
                pressure: s[e][2] >= 0 ? s[e][2] : .5,
                vector: sn(en(d.point, t)),
                distance: n,
                runningLength: c
              }, l.push(d);
            }
            return l[0].vector = (null == (n = l[1]) ? void 0 : n.vector) || [0, 0], l;
          }(e, t), t);
        }
        var gn = n(73935);
        function vn(e, t) {
          for (var n = e.length, r = 0; r < n; ++r) if (t(e[r], r)) return !0;
          return !1;
        }
        function yn(e, t) {
          for (var n = e.length, r = 0; r < n; ++r) if (t(e[r], r)) return e[r];
          return null;
        }
        function bn(e) {
          var t = e;
          if (void 0 === t) {
            if ("undefined" == typeof navigator || !navigator) return "";
            t = navigator.userAgent || "";
          }
          return t.toLowerCase();
        }
        function wn(e, t) {
          try {
            return new RegExp(e, "g").exec(t);
          } catch (e) {
            return null;
          }
        }
        function xn() {
          if ("undefined" == typeof navigator || !navigator || !navigator.userAgentData) return !1;
          var e = navigator.userAgentData,
            t = e.brands || e.uaList;
          return !(!t || !t.length);
        }
        function Dn(e) {
          return e.replace(/_/g, ".");
        }
        function Cn(e, t) {
          var n = null,
            r = "-1";
          return vn(e, function (e) {
            var o = wn("(" + e.test + ")((?:\\/|\\s|:)([0-9|\\.|_]+))?", t);
            return !(!o || e.brand) && (n = e, r = o[3] || "-1", e.versionAlias ? r = e.versionAlias : e.versionTest && (r = function (e, t) {
              var n = wn("(" + e + ")((?:\\/|\\s|:)([0-9|\\.|_]+))", t);
              return n ? n[3] : "";
            }(e.versionTest.toLowerCase(), t) || r), r = Dn(r), !0);
          }), {
            preset: n,
            version: r
          };
        }
        function Sn(e, t) {
          var n = {
            brand: "",
            version: "-1"
          };
          return vn(e, function (e) {
            var r = En(t, e);
            return !!r && (n.brand = e.id, n.version = e.versionAlias || r.version, "-1" !== n.version);
          }), n;
        }
        function En(e, t) {
          return yn(e, function (e) {
            var n = e.brand;
            return wn("" + t.test, n.toLowerCase());
          });
        }
        var _n = [{
            test: "phantomjs",
            id: "phantomjs"
          }, {
            test: "whale",
            id: "whale"
          }, {
            test: "edgios|edge|edg",
            id: "edge"
          }, {
            test: "msie|trident|windows phone",
            id: "ie",
            versionTest: "iemobile|msie|rv"
          }, {
            test: "miuibrowser",
            id: "miui browser"
          }, {
            test: "samsungbrowser",
            id: "samsung internet"
          }, {
            test: "samsung",
            id: "samsung internet",
            versionTest: "version"
          }, {
            test: "chrome|crios",
            id: "chrome"
          }, {
            test: "firefox|fxios",
            id: "firefox"
          }, {
            test: "android",
            id: "android browser",
            versionTest: "version"
          }, {
            test: "safari|iphone|ipad|ipod",
            id: "safari",
            versionTest: "version"
          }],
          Pn = [{
            test: "(?=.*applewebkit/(53[0-7]|5[0-2]|[0-4]))(?=.*\\schrome)",
            id: "chrome",
            versionTest: "chrome"
          }, {
            test: "chromium",
            id: "chrome"
          }, {
            test: "whale",
            id: "chrome",
            versionAlias: "-1",
            brand: !0
          }],
          kn = [{
            test: "applewebkit",
            id: "webkit",
            versionTest: "applewebkit|safari"
          }],
          An = [{
            test: "(?=(iphone|ipad))(?!(.*version))",
            id: "webview"
          }, {
            test: "(?=(android|iphone|ipad))(?=.*(naver|daum|; wv))",
            id: "webview"
          }, {
            test: "webview",
            id: "webview"
          }],
          zn = [{
            test: "windows phone",
            id: "windows phone"
          }, {
            test: "windows 2000",
            id: "window",
            versionAlias: "5.0"
          }, {
            test: "windows nt",
            id: "window"
          }, {
            test: "win32|windows",
            id: "window"
          }, {
            test: "iphone|ipad|ipod",
            id: "ios",
            versionTest: "iphone os|cpu os"
          }, {
            test: "macos|macintel|mac os x",
            id: "mac"
          }, {
            test: "android|linux armv81",
            id: "android"
          }, {
            test: "tizen",
            id: "tizen"
          }, {
            test: "webos|web0s",
            id: "webos"
          }];
        function Tn(e) {
          return !!Cn(An, e).preset;
        }
        function On(e) {
          var t = navigator.userAgentData,
            n = (t.uaList || t.brands).slice(),
            r = e && e.fullVersionList,
            o = t.mobile || !1,
            i = n[0],
            a = (e && e.platform || t.platform || navigator.platform).toLowerCase(),
            s = {
              name: i.brand,
              version: i.version,
              majorVersion: -1,
              webkit: !1,
              webkitVersion: "-1",
              chromium: !1,
              chromiumVersion: "-1",
              webview: !!Sn(An, n).brand || Tn(bn())
            },
            l = {
              name: "unknown",
              version: "-1",
              majorVersion: -1
            };
          s.webkit = !s.chromium && vn(kn, function (e) {
            return En(n, e);
          });
          var u = Sn(Pn, n);
          if (s.chromium = !!u.brand, s.chromiumVersion = u.version, !s.chromium) {
            var c = Sn(kn, n);
            s.webkit = !!c.brand, s.webkitVersion = c.version;
          }
          var d = yn(zn, function (e) {
            return new RegExp("" + e.test, "g").exec(a);
          });
          if (l.name = d ? d.id : "", e && (l.version = e.platformVersion), r && r.length) {
            var p = Sn(_n, r);
            s.name = p.brand || s.name, s.version = p.version || s.version;
          } else {
            var h = Sn(_n, n);
            s.name = h.brand || s.name, s.version = h.brand && e ? e.uaFullVersion : h.version;
          }
          return s.webkit && (l.name = o ? "ios" : "mac"), "ios" === l.name && s.webview && (s.version = "-1"), l.version = Dn(l.version), s.version = Dn(s.version), l.majorVersion = parseInt(l.version, 10), s.majorVersion = parseInt(s.version, 10), {
            browser: s,
            os: l,
            isMobile: o,
            isHints: !0
          };
        }
        function In(e) {
          return void 0 === e && xn() ? On() : function (e) {
            var t = bn(e),
              n = !!/mobi/g.exec(t),
              r = {
                name: "unknown",
                version: "-1",
                majorVersion: -1,
                webview: Tn(t),
                chromium: !1,
                chromiumVersion: "-1",
                webkit: !1,
                webkitVersion: "-1"
              },
              o = {
                name: "unknown",
                version: "-1",
                majorVersion: -1
              },
              i = Cn(_n, t),
              a = i.preset,
              s = i.version,
              l = Cn(zn, t),
              u = l.preset,
              c = l.version,
              d = Cn(Pn, t);
            if (r.chromium = !!d.preset, r.chromiumVersion = d.version, !r.chromium) {
              var p = Cn(kn, t);
              r.webkit = !!p.preset, r.webkitVersion = p.version;
            }
            return u && (o.name = u.id, o.version = c, o.majorVersion = parseInt(c, 10)), a && (r.name = a.id, r.version = s, r.webview && "ios" === o.name && "safari" !== r.name && (r.webview = !1)), r.majorVersion = parseInt(r.version, 10), {
              browser: r,
              os: o,
              isMobile: n,
              isHints: !1
            };
          }(e);
        }
        const Fn = In;
        function Mn(e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          return t.map(function (t) {
            return t.split(" ").map(function (t) {
              return t ? "" + e + t : "";
            }).join(" ");
          }).join(" ");
        }
        function Rn(e, t) {
          return function (n) {
            n && (e[t] = n);
          };
        }
        function jn(e, t, n) {
          return function (r) {
            r && (e[t][n] = r);
          };
        }
        var Bn = "undefined",
          Nn = typeof window !== Bn,
          Ln = typeof document !== Bn && document,
          Vn = [{
            open: "(",
            close: ")"
          }, {
            open: '"',
            close: '"'
          }, {
            open: "'",
            close: "'"
          }, {
            open: '\\"',
            close: '\\"'
          }, {
            open: "\\'",
            close: "\\'"
          }],
          Kn = 1e-7,
          qn = {
            cm: function (e) {
              return 96 * e / 2.54;
            },
            mm: function (e) {
              return 96 * e / 254;
            },
            in: function (e) {
              return 96 * e;
            },
            pt: function (e) {
              return 96 * e / 72;
            },
            pc: function (e) {
              return 96 * e / 6;
            },
            "%": function (e, t) {
              return e * t / 100;
            },
            vw: function (e, t) {
              return void 0 === t && (t = window.innerWidth), e / 100 * t;
            },
            vh: function (e, t) {
              return void 0 === t && (t = window.innerHeight), e / 100 * t;
            },
            vmax: function (e, t) {
              return void 0 === t && (t = Math.max(window.innerWidth, window.innerHeight)), e / 100 * t;
            },
            vmin: function (e, t) {
              return void 0 === t && (t = Math.min(window.innerWidth, window.innerHeight)), e / 100 * t;
            }
          };
        function Hn(e, t, n, r) {
          return (e * r + t * n) / (n + r);
        }
        function Un(e) {
          return typeof e === Bn;
        }
        function Zn(e) {
          return e && "object" == typeof e;
        }
        function $n(e) {
          return Array.isArray(e);
        }
        function Gn(e) {
          return "string" == typeof e;
        }
        function Wn(e) {
          return "number" == typeof e;
        }
        function Yn(e) {
          return "function" == typeof e;
        }
        function Xn(e, t, n, r, o) {
          return Qn(e, t, n) ? n : function (e, t, n, r, o) {
            for (var i, a = function (n) {
                var a = t[n].trim();
                if (a === e.close && !Qn(e, t, n)) return {
                  value: n
                };
                var s = n,
                  l = ar(o, function (e) {
                    return e.open === a;
                  });
                if (l && (s = Xn(l, t, n, r, o)), -1 === s) return i = n, "break";
                i = n = s;
              }, s = n; s < r; ++s) {
              var l = a(s);
              if (s = i, "object" == typeof l) return l.value;
              if ("break" === l) break;
            }
            return -1;
          }(e, t, n + 1, r, o);
        }
        function Qn(e, t, n) {
          if (!e.ignore) return null;
          var r = t.slice(Math.max(n - 3, 0), n + 3).join("");
          return new RegExp(e.ignore).exec(r);
        }
        function Jn(e, t) {
          var n = Gn(t) ? {
              separator: t
            } : t,
            r = n.separator,
            o = void 0 === r ? "," : r,
            i = n.isSeparateFirst,
            a = n.isSeparateOnlyOpenClose,
            s = n.isSeparateOpenClose,
            l = void 0 === s ? a : s,
            u = n.openCloseCharacters,
            c = void 0 === u ? Vn : u,
            d = c.map(function (e) {
              var t = e.open,
                n = e.close;
              return t === n ? t : t + "|" + n;
            }).join("|"),
            p = new RegExp("(\\s*" + o + "\\s*|" + d + "|\\s+)", "g"),
            h = e.split(p).filter(function (e) {
              return e && "undefined" !== e;
            }),
            f = h.length,
            m = [],
            g = [];
          function v() {
            return !!g.length && (m.push(g.join("")), g = [], !0);
          }
          for (var y, b = function (t) {
              var n = h[t].trim(),
                r = t,
                s = ar(c, function (e) {
                  return e.open === n;
                }),
                u = ar(c, function (e) {
                  return e.close === n;
                });
              if (s) {
                if (-1 !== (r = Xn(s, h, t, f, c)) && l) return v() && i ? (y = t, "break") : (m.push(h.slice(t, r + 1).join("")), t = r, i ? (y = t, "break") : (y = t, "continue"));
              } else {
                if (u && !Qn(u, h, t)) {
                  var d = function () {
                    for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
                    var r = Array(e),
                      o = 0;
                    for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
                    return r;
                  }(c);
                  return d.splice(c.indexOf(u), 1), {
                    value: Jn(e, {
                      separator: o,
                      isSeparateFirst: i,
                      isSeparateOnlyOpenClose: a,
                      isSeparateOpenClose: l,
                      openCloseCharacters: d
                    })
                  };
                }
                if (function (e, t) {
                  return ("" === t || " " == t) && ("" === e || " " == e) || e === t;
                }(n, o) && !a) return v(), i ? (y = t, "break") : (y = t, "continue");
              }
              -1 === r && (r = f - 1), g.push(h.slice(t, r + 1).join("")), y = t = r;
            }, w = 0; w < f; ++w) {
            var x = b(w);
            if (w = y, "object" == typeof x) return x.value;
            if ("break" === x) break;
          }
          return g.length && m.push(g.join("")), m;
        }
        function er(e) {
          return Jn(e, "");
        }
        function tr(e) {
          return Jn(e, ",");
        }
        function nr(e) {
          var t = /([^(]*)\(([\s\S]*)\)([\s\S]*)/g.exec(e);
          return !t || t.length < 4 ? {} : {
            prefix: t[1],
            value: t[2],
            suffix: t[3]
          };
        }
        function rr(e) {
          var t = /^([^\d|e|\-|\+]*)((?:\d|\.|-|e-|e\+)+)(\S*)$/g.exec(e);
          if (!t) return {
            prefix: "",
            unit: "",
            value: NaN
          };
          var n = t[1],
            r = t[2];
          return {
            prefix: n,
            unit: t[3],
            value: parseFloat(r)
          };
        }
        function or() {
          return Date.now ? Date.now() : new Date().getTime();
        }
        function ir(e, t, n) {
          void 0 === n && (n = -1);
          for (var r = e.length, o = 0; o < r; ++o) if (t(e[o], o, e)) return o;
          return n;
        }
        function ar(e, t, n) {
          var r = ir(e, t);
          return r > -1 ? e[r] : n;
        }
        var sr = function () {
            var e = or(),
              t = Nn && (window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame);
            return t ? t.bind(window) : function (t) {
              var n = or();
              return setTimeout(function () {
                t(n - e);
              }, 1e3 / 60);
            };
          }(),
          lr = function () {
            var e = Nn && (window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || window.msCancelAnimationFrame);
            return e ? e.bind(window) : function (e) {
              clearTimeout(e);
            };
          }();
        function ur(e) {
          return Object.keys(e);
        }
        function cr(e, t) {
          var n = rr(e),
            r = n.value,
            o = n.unit;
          if (Zn(t)) {
            var i = t[o];
            if (i) {
              if (Yn(i)) return i(r);
              if (qn[o]) return qn[o](r, i);
            }
          } else if ("%" === o) return r * t / 100;
          return qn[o] ? qn[o](r) : r;
        }
        function dr(e, t, n) {
          return Math.max(t, Math.min(e, n));
        }
        function pr(e, t, n, r) {
          return void 0 === r && (r = e[0] / e[1]), [[yr(t[0], Kn), yr(t[0] / r, Kn)], [yr(t[1] * r, Kn), yr(t[1], Kn)]].filter(function (e) {
            return e.every(function (e, r) {
              var o = t[r],
                i = yr(o, Kn);
              return n ? e <= o || e <= i : e >= o || e >= i;
            });
          })[0] || e;
        }
        function hr(e, t, n, r) {
          if (!r) return e.map(function (e, r) {
            return dr(e, t[r], n[r]);
          });
          var o = e[0],
            i = e[1],
            a = !0 === r ? o / i : r,
            s = pr(e, t, !1, a),
            l = s[0],
            u = s[1],
            c = pr(e, n, !0, a),
            d = c[0],
            p = c[1];
          return o < l || i < u ? (o = l, i = u) : (o > d || i > p) && (o = d, i = p), [o, i];
        }
        function fr(e) {
          for (var t = e.length, n = 0, r = t - 1; r >= 0; --r) n += e[r];
          return t ? n / t : 0;
        }
        function mr(e, t) {
          var n = t[0] - e[0],
            r = t[1] - e[1],
            o = Math.atan2(r, n);
          return o >= 0 ? o : o + 2 * Math.PI;
        }
        function gr(e) {
          var t = function (e) {
              return [0, 1].map(function (t) {
                return fr(e.map(function (e) {
                  return e[t];
                }));
              });
            }(e),
            n = mr(t, e[0]),
            r = mr(t, e[1]);
          return n < r && r - n < Math.PI || n > r && r - n < -Math.PI ? 1 : -1;
        }
        function vr(e, t) {
          return Math.sqrt(Math.pow((t ? t[0] : 0) - e[0], 2) + Math.pow((t ? t[1] : 0) - e[1], 2));
        }
        function yr(e, t) {
          if (!t) return e;
          var n = 1 / t;
          return Math.round(e / t) / n;
        }
        function br(e, t) {
          return e.forEach(function (n, r) {
            e[r] = yr(e[r], t);
          }), e;
        }
        function wr(e, t) {
          return e.classList ? e.classList.contains(t) : !!e.className.match(new RegExp("(\\s|^)" + t + "(\\s|$)"));
        }
        function xr(e, t) {
          e.classList ? e.classList.add(t) : e.className += " " + t;
        }
        function Dr(e, t) {
          if (e.classList) e.classList.remove(t);else {
            var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
            e.className = e.className.replace(n, " ");
          }
        }
        function Cr(e, t, n, r) {
          e.addEventListener(t, n, r);
        }
        function Sr(e, t, n, r) {
          e.removeEventListener(t, n, r);
        }
        function Er(e) {
          return (null == e ? void 0 : e.ownerDocument) || Ln;
        }
        function _r(e) {
          return Er(e).documentElement;
        }
        function Pr(e) {
          return Er(e).body;
        }
        function kr(e) {
          var t;
          return (null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t ? void 0 : t.defaultView) || window;
        }
        function Ar(e) {
          return e && "postMessage" in e && "blur" in e && "self" in e;
        }
        function zr(e) {
          return Zn(e) && e.nodeName && e.nodeType && "ownerDocument" in e;
        }
        function Tr(e, t, n, r, o, i) {
          for (var a = 0; a < o; ++a) {
            var s = n + a * o,
              l = r + a * o;
            e[s] += e[l] * i, t[s] += t[l] * i;
          }
        }
        function Or(e, t, n, r, o) {
          for (var i = 0; i < o; ++i) {
            var a = n + i * o,
              s = r + i * o,
              l = e[a],
              u = t[a];
            e[a] = e[s], e[s] = l, t[a] = t[s], t[s] = u;
          }
        }
        function Ir(e, t, n, r, o) {
          for (var i = 0; i < r; ++i) {
            var a = n + i * r;
            e[a] /= o, t[a] /= o;
          }
        }
        function Fr(e, t, n) {
          void 0 === n && (n = Math.sqrt(e.length));
          for (var r = e.slice(), o = 0; o < n; ++o) r[o * n + t - 1] = 0, r[(t - 1) * n + o] = 0;
          return r[(t - 1) * (n + 1)] = 1, r;
        }
        function Mr(e, t) {
          void 0 === t && (t = Math.sqrt(e.length));
          for (var n = e.slice(), r = eo(t), o = 0; o < t; ++o) {
            var i = t * o + o;
            if (!yr(n[i], Kn)) for (var a = o + 1; a < t; ++a) if (n[t * o + a]) {
              Or(n, r, o, a, t);
              break;
            }
            if (!yr(n[i], Kn)) return [];
            Ir(n, r, o, t, n[i]);
            for (a = 0; a < t; ++a) {
              var s = a,
                l = n[a + o * t];
              yr(l, Kn) && o !== a && Tr(n, r, s, o, t, -l);
            }
          }
          return r;
        }
        function Rr(e, t) {
          void 0 === t && (t = Math.sqrt(e.length));
          for (var n = [], r = e[t * t - 1], o = 0; o < t - 1; ++o) n[o] = e[t * (t - 1) + o] / r;
          return n[t - 1] = 0, n;
        }
        function jr(e, t) {
          for (var n = e.slice(), r = e.length; r < t - 1; ++r) n[r] = 0;
          return n[t - 1] = 1, n;
        }
        function Br(e, t, n) {
          if (void 0 === t && (t = Math.sqrt(e.length)), t === n) return e;
          for (var r = eo(n), o = Math.min(t, n), i = 0; i < o - 1; ++i) {
            for (var a = 0; a < o - 1; ++a) r[i * n + a] = e[i * t + a];
            r[(i + 1) * n - 1] = e[(i + 1) * t - 1], r[(n - 1) * n + i] = e[(t - 1) * t + i];
          }
          return r[n * n - 1] = e[t * t - 1], r;
        }
        function Nr(e) {
          for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
          var r = eo(e);
          return t.forEach(function (t) {
            r = Lr(r, t, e);
          }), r;
        }
        function Lr(e, t, n) {
          void 0 === n && (n = Math.sqrt(e.length));
          var r = [],
            o = e.length / n,
            i = t.length / o;
          if (!o) return t;
          if (!i) return e;
          for (var a = 0; a < n; ++a) for (var s = 0; s < i; ++s) {
            r[s * n + a] = 0;
            for (var l = 0; l < o; ++l) r[s * n + a] += e[l * n + a] * t[s * o + l];
          }
          return r;
        }
        function Vr(e, t) {
          for (var n = Math.min(e.length, t.length), r = e.slice(), o = 0; o < n; ++o) r[o] = r[o] + t[o];
          return r;
        }
        function Kr(e, t) {
          for (var n = Math.min(e.length, t.length), r = e.slice(), o = 0; o < n; ++o) r[o] = r[o] - t[o];
          return r;
        }
        function qr(e, t) {
          return void 0 === t && (t = 6 === e.length), t ? [e[0], e[1], 0, e[2], e[3], 0, e[4], e[5], 1] : e;
        }
        function Hr(e, t) {
          return void 0 === t && (t = 9 === e.length), t ? [e[0], e[1], e[3], e[4], e[6], e[7]] : e;
        }
        function Ur(e, t, n) {
          void 0 === n && (n = t.length);
          var r = Lr(e, t, n),
            o = r[n - 1];
          return r.map(function (e) {
            return e / o;
          });
        }
        function Zr(e, t) {
          return Lr(e, [1, 0, 0, 0, 0, Math.cos(t), Math.sin(t), 0, 0, -Math.sin(t), Math.cos(t), 0, 0, 0, 0, 1], 4);
        }
        function $r(e, t) {
          return Lr(e, [Math.cos(t), 0, -Math.sin(t), 0, 0, 1, 0, 0, Math.sin(t), 0, Math.cos(t), 0, 0, 0, 0, 1], 4);
        }
        function Gr(e, t) {
          return Lr(e, Jr(t, 4));
        }
        function Wr(e, t) {
          var n = t[0],
            r = void 0 === n ? 1 : n,
            o = t[1],
            i = void 0 === o ? 1 : o,
            a = t[2];
          return Lr(e, [r, 0, 0, 0, 0, i, 0, 0, 0, 0, void 0 === a ? 1 : a, 0, 0, 0, 0, 1], 4);
        }
        function Yr(e, t) {
          return Ur(Jr(t, 3), jr(e, 3));
        }
        function Xr(e, t) {
          var n = t[0],
            r = void 0 === n ? 0 : n,
            o = t[1],
            i = void 0 === o ? 0 : o,
            a = t[2];
          return Lr(e, [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, r, i, void 0 === a ? 0 : a, 1], 4);
        }
        function Qr(e, t) {
          return Lr(e, t, 4);
        }
        function Jr(e, t) {
          var n = Math.cos(e),
            r = Math.sin(e),
            o = eo(t);
          return o[0] = n, o[1] = r, o[t] = -r, o[t + 1] = n, o;
        }
        function eo(e) {
          for (var t = e * e, n = [], r = 0; r < t; ++r) n[r] = r % (e + 1) ? 0 : 1;
          return n;
        }
        function to(e, t) {
          for (var n = eo(t), r = Math.min(e.length, t - 1), o = 0; o < r; ++o) n[(t + 1) * o] = e[o];
          return n;
        }
        function no(e, t) {
          for (var n = eo(t), r = Math.min(e.length, t - 1), o = 0; o < r; ++o) n[t * (t - 1) + o] = e[o];
          return n;
        }
        function ro(e, t, n, r, o, i, a, s) {
          var l = e[0],
            u = e[1],
            c = t[0],
            d = t[1],
            p = n[0],
            h = n[1],
            f = r[0],
            m = r[1],
            g = o[0],
            v = o[1],
            y = i[0],
            b = i[1],
            w = a[0],
            x = a[1],
            D = s[0],
            C = s[1],
            S = Mr([l, 0, c, 0, p, 0, f, 0, u, 0, d, 0, h, 0, m, 0, 1, 0, 1, 0, 1, 0, 1, 0, 0, l, 0, c, 0, p, 0, f, 0, u, 0, d, 0, h, 0, m, 0, 1, 0, 1, 0, 1, 0, 1, -g * l, -v * l, -y * c, -b * c, -w * p, -x * p, -D * f, -C * f, -g * u, -v * u, -y * d, -b * d, -w * h, -x * h, -D * m, -C * m], 8);
          if (!S.length) return [];
          var E = Lr(S, [g, v, y, b, w, x, D, C], 8);
          return E[8] = 1, Br(function (e, t) {
            void 0 === t && (t = Math.sqrt(e.length));
            for (var n = [], r = 0; r < t; ++r) for (var o = 0; o < t; ++o) n[o * t + r] = e[t * r + o];
            return n;
          }(E), 3, 4);
        }
        var oo = function () {
          return oo = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, oo.apply(this, arguments);
        };
        function io(e, t) {
          return void 0 === t && (t = 0), ao(so(e, t));
        }
        function ao(e) {
          var t = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
          return e.forEach(function (e) {
            var n = e.matrixFunction,
              r = e.functionValue;
            n && (t = n(t, r));
          }), t;
        }
        function so(e, t) {
          return void 0 === t && (t = 0), ($n(e) ? e : er(e)).map(function (e) {
            var n = nr(e),
              r = n.prefix,
              o = n.value,
              i = null,
              a = r,
              s = "";
            if ("translate" === r || "translateX" === r || "translate3d" === r) {
              var l = Zn(t) ? oo(oo({}, t), {
                  "o%": t["%"]
                }) : {
                  "%": t,
                  "o%": t
                },
                u = tr(o).map(function (e, n) {
                  return l["%"] = 0 === n && "x%" in l ? t["x%"] : 1 === n && "y%" in l ? t["y%"] : t["o%"], cr(e, l);
                }),
                c = u[0],
                d = u[1],
                p = void 0 === d ? 0 : d,
                h = u[2];
              i = Xr, s = [c, p, void 0 === h ? 0 : h];
            } else if ("translateY" === r) {
              i = Xr, s = [0, p = cr(o, Zn(t) ? oo({
                "%": t["y%"]
              }, t) : {
                "%": t
              }), 0];
            } else if ("translateZ" === r) {
              i = Xr, s = [0, 0, parseFloat(o)];
            } else if ("scale" === r || "scale3d" === r) {
              var f = tr(o).map(function (e) {
                  return parseFloat(e);
                }),
                m = f[0],
                g = f[1],
                v = void 0 === g ? m : g,
                y = f[2];
              i = Wr, s = [m, v, void 0 === y ? 1 : y];
            } else if ("scaleX" === r) {
              i = Wr, s = [m = parseFloat(o), 1, 1];
            } else if ("scaleY" === r) {
              i = Wr, s = [1, v = parseFloat(o), 1];
            } else if ("scaleZ" === r) {
              i = Wr, s = [1, 1, parseFloat(o)];
            } else if ("rotate" === r || "rotateZ" === r || "rotateX" === r || "rotateY" === r) {
              var b = rr(o),
                w = b.unit,
                x = b.value;
              "rotate" === r || "rotateZ" === r ? (a = "rotateZ", i = Gr) : "rotateX" === r ? i = Zr : "rotateY" === r && (i = $r), s = "rad" === w ? x : x * Math.PI / 180;
            } else if ("matrix3d" === r) i = Qr, s = tr(o).map(function (e) {
              return parseFloat(e);
            });else if ("matrix" === r) {
              var D = tr(o).map(function (e) {
                return parseFloat(e);
              });
              i = Qr, s = [D[0], D[1], 0, 0, D[2], D[3], 0, 0, 0, 0, 1, 0, D[4], D[5], 0, 1];
            } else a = "";
            return {
              name: r,
              functionName: a,
              value: o,
              matrixFunction: i,
              functionValue: s
            };
          });
        }
        var lo = function () {
            function e() {
              this.keys = [], this.values = [];
            }
            var t = e.prototype;
            return t.get = function (e) {
              return this.values[this.keys.indexOf(e)];
            }, t.set = function (e, t) {
              var n = this.keys,
                r = this.values,
                o = n.indexOf(e),
                i = -1 === o ? n.length : o;
              n[i] = e, r[i] = t;
            }, e;
          }(),
          uo = function () {
            function e() {
              this.object = {};
            }
            var t = e.prototype;
            return t.get = function (e) {
              return this.object[e];
            }, t.set = function (e, t) {
              this.object[e] = t;
            }, e;
          }(),
          co = "function" == typeof Map,
          po = function () {
            function e() {}
            var t = e.prototype;
            return t.connect = function (e, t) {
              this.prev = e, this.next = t, e && (e.next = this), t && (t.prev = this);
            }, t.disconnect = function () {
              var e = this.prev,
                t = this.next;
              e && (e.next = t), t && (t.prev = e);
            }, t.getIndex = function () {
              for (var e = this, t = -1; e;) e = e.prev, ++t;
              return t;
            }, e;
          }();
        var ho = function () {
          function e(e, t, n, r, o, i, a, s) {
            this.prevList = e, this.list = t, this.added = n, this.removed = r, this.changed = o, this.maintained = i, this.changedBeforeAdded = a, this.fixed = s;
          }
          var t = e.prototype;
          return Object.defineProperty(t, "ordered", {
            get: function () {
              return this.cacheOrdered || this.caculateOrdered(), this.cacheOrdered;
            },
            enumerable: !0,
            configurable: !0
          }), Object.defineProperty(t, "pureChanged", {
            get: function () {
              return this.cachePureChanged || this.caculateOrdered(), this.cachePureChanged;
            },
            enumerable: !0,
            configurable: !0
          }), t.caculateOrdered = function () {
            var e = function (e, t) {
                var n = [],
                  r = [];
                return e.forEach(function (e) {
                  var t = e[0],
                    o = e[1],
                    i = new po();
                  n[t] = i, r[o] = i;
                }), n.forEach(function (e, t) {
                  e.connect(n[t - 1]);
                }), e.filter(function (e, n) {
                  return !t[n];
                }).map(function (e, t) {
                  var o = e[0],
                    i = e[1];
                  if (o === i) return [0, 0];
                  var a = n[o],
                    s = r[i - 1],
                    l = a.getIndex();
                  return a.disconnect(), s ? a.connect(s, s.next) : a.connect(void 0, n[0]), [l, a.getIndex()];
                });
              }(this.changedBeforeAdded, this.fixed),
              t = this.changed,
              n = [];
            this.cacheOrdered = e.filter(function (e, r) {
              var o = e[0],
                i = e[1],
                a = t[r],
                s = a[0],
                l = a[1];
              if (o !== i) return n.push([s, l]), !0;
            }), this.cachePureChanged = n;
          }, e;
        }();
        function fo(e, t, n) {
          var r = co ? Map : n ? uo : lo,
            o = n || function (e) {
              return e;
            },
            i = [],
            a = [],
            s = [],
            l = e.map(o),
            u = t.map(o),
            c = new r(),
            d = new r(),
            p = [],
            h = [],
            f = {},
            m = [],
            g = 0,
            v = 0;
          return l.forEach(function (e, t) {
            c.set(e, t);
          }), u.forEach(function (e, t) {
            d.set(e, t);
          }), l.forEach(function (e, t) {
            var n = d.get(e);
            void 0 === n ? (++v, a.push(t)) : f[n] = v;
          }), u.forEach(function (e, t) {
            var n = c.get(e);
            void 0 === n ? (i.push(t), ++g) : (s.push([n, t]), v = f[t] || 0, p.push([n - v, t - g]), h.push(t === n), n !== t && m.push([n, t]));
          }), a.reverse(), new ho(e, t, i, a, m, s, p, h);
        }
        var mo = function () {
          function e(e, t) {
            void 0 === e && (e = []), this.findKeyCallback = t, this.list = [].slice.call(e);
          }
          return e.prototype.update = function (e) {
            var t = [].slice.call(e),
              n = fo(this.list, t, this.findKeyCallback);
            return this.list = t, n;
          }, e;
        }();
        var go = function (e, t) {
          return go = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          }, go(e, t);
        };
        var vo,
          yo = "function" == typeof Map ? void 0 : (vo = 0, function (e) {
            return e.__DIFF_KEY__ || (e.__DIFF_KEY__ = ++vo);
          }),
          bo = function (e) {
            function t(t) {
              return void 0 === t && (t = []), e.call(this, t, yo) || this;
            }
            return function (e, t) {
              function n() {
                this.constructor = e;
              }
              go(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
            }(t, e), t;
          }(mo);
        const wo = bo;
        var xo = function () {
          return xo = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, xo.apply(this, arguments);
        };
        var Do = function () {
          function e() {
            this._events = {};
          }
          var t = e.prototype;
          return t.on = function (e, t) {
            if (Zn(e)) for (var n in e) this.on(n, e[n]);else this._addEvent(e, t, {});
            return this;
          }, t.off = function (e, t) {
            if (e) {
              if (Zn(e)) for (var n in e) this.off(n);else if (t) {
                var r = this._events[e];
                if (r) {
                  var o = ir(r, function (e) {
                    return e.listener === t;
                  });
                  o > -1 && r.splice(o, 1);
                }
              } else this._events[e] = [];
            } else this._events = {};
            return this;
          }, t.once = function (e, t) {
            var n = this;
            return t && this._addEvent(e, t, {
              once: !0
            }), new Promise(function (t) {
              n._addEvent(e, t, {
                once: !0
              });
            });
          }, t.emit = function (e, t) {
            var n = this;
            void 0 === t && (t = {});
            var r = this._events[e];
            if (!e || !r) return !0;
            var o = !1;
            return t.eventType = e, t.stop = function () {
              o = !0;
            }, t.currentTarget = this, function () {
              for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
              var r = Array(e),
                o = 0;
              for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
              return r;
            }(r).forEach(function (r) {
              r.listener(t), r.once && n.off(e, r.listener);
            }), !o;
          }, t.trigger = function (e, t) {
            return void 0 === t && (t = {}), this.emit(e, t);
          }, t._addEvent = function (e, t, n) {
            var r = this._events;
            r[e] = r[e] || [], r[e].push(xo({
              listener: t
            }, n));
          }, e;
        }();
        const Co = Do;
        function So() {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
          var r = Array(e),
            o = 0;
          for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
          return r;
        }
        function Eo(e) {
          return yr(e, Kn);
        }
        function _o(e) {
          return e.length < 3 ? 0 : Math.abs(function (e) {
            for (var t = 0, n = e.length - 1; n >= 0; --n) t += e[n];
            return t;
          }(e.map(function (t, n) {
            var r = e[n + 1] || e[0];
            return t[0] * r[1] - r[0] * t[1];
          }))) / 2;
        }
        function Po(e, t) {
          var n = t.width,
            r = t.height,
            o = t.left,
            i = t.top,
            a = ko(e),
            s = a.minX,
            l = a.minY,
            u = a.maxX,
            c = a.maxY,
            d = n / (u - s),
            p = r / (c - l);
          return e.map(function (e) {
            return [o + (e[0] - s) * d, i + (e[1] - l) * p];
          });
        }
        function ko(e) {
          var t = e.map(function (e) {
              return e[0];
            }),
            n = e.map(function (e) {
              return e[1];
            });
          return {
            minX: Math.min.apply(Math, t),
            minY: Math.min.apply(Math, n),
            maxX: Math.max.apply(Math, t),
            maxY: Math.max.apply(Math, n)
          };
        }
        function Ao(e, t, n) {
          var r = e[0],
            o = e[1],
            i = ko(t),
            a = i.minX,
            s = i.maxX,
            l = [[a, o], [s, o]],
            u = zo(l[0], l[1]),
            c = Io(t),
            d = [];
          if (c.forEach(function (t) {
            var n,
              r = zo(t[0], t[1]),
              i = t[0];
            (n = r, u.every(function (e, t) {
              return 0 === Eo(e - n[t]);
            })) ? d.push({
              pos: e,
              line: t,
              type: "line"
            }) : Oo(To(u, r), [l, t]).forEach(function (e) {
              t.some(function (t) {
                return r = e, !Eo((n = t)[0] - r[0]) && !Eo(n[1] - r[1]);
                var n, r;
              }) ? d.push({
                pos: e,
                line: t,
                type: "point"
              }) : 0 !== Eo(i[1] - o) && d.push({
                pos: e,
                line: t,
                type: "intersection"
              });
            });
          }), !n && ar(d, function (e) {
            return e[0] === r;
          })) return !0;
          var p = 0,
            h = {};
          return d.forEach(function (e) {
            var t = e.pos,
              n = e.type,
              i = e.line;
            if (!(t[0] > r)) if ("intersection" === n) ++p;else {
              if ("line" === n) return;
              if ("point" === n) {
                var a = ar(i, function (e) {
                    return e[1] !== o;
                  }),
                  s = h[t[0]],
                  l = a[1] > o ? 1 : -1;
                s ? s !== l && ++p : h[t[0]] = l;
              }
            }
          }), p % 2 == 1;
        }
        function zo(e, t) {
          var n = e[0],
            r = e[1],
            o = t[0] - n,
            i = t[1] - r;
          Math.abs(o) < Kn && (o = 0), Math.abs(i) < Kn && (i = 0);
          var a = 0,
            s = 0,
            l = 0;
          return o ? i ? (s = 1, l = -(a = -i / o) * n - r) : (s = 1, l = -r) : i && (a = -1, l = n), [a, s, l];
        }
        function To(e, t) {
          var n = e[0],
            r = e[1],
            o = e[2],
            i = t[0],
            a = t[1],
            s = t[2],
            l = 0 === n && 0 === i,
            u = 0 === r && 0 === a,
            c = [];
          if (l && u) return [];
          if (l) {
            var d = -o / r;
            return d !== -s / a ? [] : [[-1 / 0, d], [1 / 0, d]];
          }
          if (u) {
            var p = -o / n;
            return p !== -s / i ? [] : [[p, -1 / 0], [p, 1 / 0]];
          }
          if (0 === n) c = [[h = -(a * (f = -o / r) + s) / i, f]];else if (0 === i) {
            c = [[h = -(r * (f = -s / a) + o) / n, f]];
          } else if (0 === r) {
            c = [[h = -o / n, f = -(i * h + s) / a]];
          } else if (0 === a) {
            c = [[h = -s / i, f = -(n * h + o) / r]];
          } else {
            var h, f;
            c = [[h = (r * s - a * o) / (a * n - r * i), f = -(n * h + o) / r]];
          }
          return c.map(function (e) {
            return [e[0], e[1]];
          });
        }
        function Oo(e, t) {
          var n = t.map(function (e) {
              return [0, 1].map(function (t) {
                return [Math.min(e[0][t], e[1][t]), Math.max(e[0][t], e[1][t])];
              });
            }),
            r = [];
          if (2 === e.length) {
            var o = e[0],
              i = o[0],
              a = o[1];
            if (Eo(i - e[1][0])) {
              if (!Eo(a - e[1][1])) {
                var s = Math.max.apply(Math, n.map(function (e) {
                    return e[0][0];
                  })),
                  l = Math.min.apply(Math, n.map(function (e) {
                    return e[0][1];
                  }));
                if (Eo(s - l) > 0) return [];
                r = [[s, a], [l, a]];
              }
            } else {
              var u = Math.max.apply(Math, n.map(function (e) {
                  return e[1][0];
                })),
                c = Math.min.apply(Math, n.map(function (e) {
                  return e[1][1];
                }));
              if (Eo(u - c) > 0) return [];
              r = [[i, u], [i, c]];
            }
          }
          return r.length || (r = e.filter(function (e) {
            var t = e[0],
              r = e[1];
            return n.every(function (e) {
              return 0 <= Eo(t - e[0][0]) && 0 <= Eo(e[0][1] - t) && 0 <= Eo(r - e[1][0]) && 0 <= Eo(e[1][1] - r);
            });
          })), r.map(function (e) {
            return [Eo(e[0]), Eo(e[1])];
          });
        }
        function Io(e) {
          return So(e.slice(1), [e[0]]).map(function (t, n) {
            return [e[n], t];
          });
        }
        function Fo(e, t) {
          var n = e.slice(),
            r = t.slice();
          -1 === gr(n) && n.reverse(), -1 === gr(r) && r.reverse();
          var o = Io(n),
            i = Io(r),
            a = o.map(function (e) {
              return zo(e[0], e[1]);
            }),
            s = i.map(function (e) {
              return zo(e[0], e[1]);
            }),
            l = [];
          a.forEach(function (e, t) {
            var n = o[t],
              a = [];
            s.forEach(function (r, o) {
              var s = Oo(To(e, r), [n, i[o]]);
              a.push.apply(a, s.map(function (e) {
                return {
                  index1: t,
                  index2: o,
                  pos: e,
                  type: "intersection"
                };
              }));
            }), a.sort(function (e, t) {
              return vr(n[0], e.pos) - vr(n[0], t.pos);
            }), l.push.apply(l, a), Ao(n[1], r) && l.push({
              index1: t,
              index2: -1,
              pos: n[1],
              type: "inside"
            });
          }), i.forEach(function (e, t) {
            if (Ao(e[1], n)) {
              var r = !1,
                o = ir(l, function (e) {
                  return e.index2 === t ? (r = !0, !1) : !!r;
                });
              -1 === o && (r = !1, o = ir(l, function (e) {
                var n = e.index1,
                  o = e.index2;
                return -1 === n && o + 1 === t ? (r = !0, !1) : !!r;
              })), -1 === o ? l.push({
                index1: -1,
                index2: t,
                pos: e[1],
                type: "inside"
              }) : l.splice(o, 0, {
                index1: -1,
                index2: t,
                pos: e[1],
                type: "inside"
              });
            }
          });
          var u = {};
          return l.filter(function (e) {
            var t = e.pos,
              n = t[0] + "x" + t[1];
            return !u[n] && (u[n] = !0, !0);
          });
        }
        function Mo(e, t) {
          var n = function (e, t) {
            return Fo(e, t).map(function (e) {
              return e.pos;
            });
          }(e, t);
          return _o(n);
        }
        var Ro = function (e, t) {
          return Ro = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
          }, Ro(e, t);
        };
        var jo = function () {
          return jo = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, jo.apply(this, arguments);
        };
        function Bo(e) {
          return 180 * (t = [e[0].clientX, e[0].clientY], n = [e[1].clientX, e[1].clientY], r = n[0] - t[0], o = n[1] - t[1], ((i = Math.atan2(o, r)) >= 0 ? i : i + 2 * Math.PI) / Math.PI);
          var t, n, r, o, i;
        }
        function No(e) {
          return e ? e.touches ? function (e) {
            for (var t = Math.min(e.length, 2), n = [], r = 0; r < t; ++r) n.push(Ko(e[r]));
            return n;
          }(e.touches) : [Ko(e)] : [];
        }
        function Lo(e, t, n) {
          var r = n.length,
            o = qo(e, r),
            i = o.clientX,
            a = o.clientY,
            s = o.originalClientX,
            l = o.originalClientY,
            u = qo(t, r),
            c = u.clientX,
            d = u.clientY,
            p = qo(n, r);
          return {
            clientX: s,
            clientY: l,
            deltaX: i - c,
            deltaY: a - d,
            distX: i - p.clientX,
            distY: a - p.clientY
          };
        }
        function Vo(e) {
          return Math.sqrt(Math.pow(e[0].clientX - e[1].clientX, 2) + Math.pow(e[0].clientY - e[1].clientY, 2));
        }
        function Ko(e) {
          return {
            clientX: e.clientX,
            clientY: e.clientY
          };
        }
        function qo(e, t) {
          void 0 === t && (t = e.length);
          for (var n = {
              clientX: 0,
              clientY: 0,
              originalClientX: 0,
              originalClientY: 0
            }, r = Math.min(e.length, t), o = 0; o < r; ++o) {
            var i = e[o];
            n.originalClientX += "originalClientX" in i ? i.originalClientX : i.clientX, n.originalClientY += "originalClientY" in i ? i.originalClientY : i.clientY, n.clientX += i.clientX, n.clientY += i.clientY;
          }
          return t ? {
            clientX: n.clientX / t,
            clientY: n.clientY / t,
            originalClientX: n.originalClientX / t,
            originalClientY: n.originalClientY / t
          } : n;
        }
        var Ho = function () {
            function e(e) {
              this.prevClients = [], this.startClients = [], this.movement = 0, this.length = 0, this.startClients = e, this.prevClients = e, this.length = e.length;
            }
            return e.prototype.getAngle = function (e) {
              return void 0 === e && (e = this.prevClients), Bo(e);
            }, e.prototype.getRotation = function (e) {
              return void 0 === e && (e = this.prevClients), Bo(e) - Bo(this.startClients);
            }, e.prototype.getPosition = function (e, t) {
              void 0 === e && (e = this.prevClients);
              var n = Lo(e || this.prevClients, this.prevClients, this.startClients),
                r = n.deltaX,
                o = n.deltaY;
              return this.movement += Math.sqrt(r * r + o * o), this.prevClients = e, n;
            }, e.prototype.getPositions = function (e) {
              void 0 === e && (e = this.prevClients);
              for (var t = this.prevClients, n = this.startClients, r = Math.min(this.length, t.length), o = [], i = 0; i < r; ++i) o[i] = Lo([e[i]], [t[i]], [n[i]]);
              return o;
            }, e.prototype.getMovement = function (e) {
              var t = this.movement;
              if (!e) return t;
              var n = qo(e, this.length),
                r = qo(this.prevClients, this.length),
                o = n.clientX - r.clientX,
                i = n.clientY - r.clientY;
              return Math.sqrt(o * o + i * i) + t;
            }, e.prototype.getDistance = function (e) {
              return void 0 === e && (e = this.prevClients), Vo(e);
            }, e.prototype.getScale = function (e) {
              return void 0 === e && (e = this.prevClients), Vo(e) / Vo(this.startClients);
            }, e.prototype.move = function (e, t) {
              this.startClients.forEach(function (n) {
                n.clientX -= e, n.clientY -= t;
              }), this.prevClients.forEach(function (n) {
                n.clientX -= e, n.clientY -= t;
              });
            }, e;
          }(),
          Uo = ["textarea", "input"],
          Zo = function (e) {
            function t(t, n) {
              void 0 === n && (n = {});
              var r = e.call(this) || this;
              r.options = {}, r.flag = !1, r.pinchFlag = !1, r.data = {}, r.isDrag = !1, r.isPinch = !1, r.clientStores = [], r.targets = [], r.prevTime = 0, r.doubleFlag = !1, r._useMouse = !1, r._useTouch = !1, r._useDrag = !1, r._dragFlag = !1, r._isTrusted = !1, r._isMouseEvent = !1, r._isSecondaryButton = !1, r._preventMouseEvent = !1, r._prevInputEvent = null, r._isDragAPI = !1, r._isIdle = !0, r._preventMouseEventId = 0, r._window = window, r.onDragStart = function (e, t) {
                if (void 0 === t && (t = !0), r.flag || !1 !== e.cancelable) {
                  var n = e.type.indexOf("drag") >= -1;
                  if (!r.flag || !n) {
                    r._isDragAPI = !0;
                    var o = r.options,
                      i = o.container,
                      a = o.pinchOutside,
                      s = o.preventWheelClick,
                      l = o.preventRightClick,
                      u = o.preventDefault,
                      c = o.checkInput,
                      d = o.dragFocusedInput,
                      p = o.preventClickEventOnDragStart,
                      h = o.preventClickEventOnDrag,
                      f = o.preventClickEventByCondition,
                      m = r._useTouch,
                      g = !r.flag;
                    if (r._isSecondaryButton = 3 === e.which || 2 === e.button, s && (2 === e.which || 1 === e.button) || l && (3 === e.which || 2 === e.button)) return r.stop(), !1;
                    if (g) {
                      var v = r._window.document.activeElement,
                        y = e.target;
                      if (y) {
                        var b = y.tagName.toLowerCase(),
                          w = Uo.indexOf(b) > -1,
                          x = y.isContentEditable;
                        if (w || x) {
                          if (c || !d && v === y) return !1;
                          if (v && (v === y || x && v.isContentEditable && v.contains(y))) {
                            if (!d) return !1;
                            y.blur();
                          }
                        } else if ((u || "touchstart" === e.type) && v) {
                          var D = v.tagName.toLowerCase();
                          (v.isContentEditable || Uo.indexOf(D) > -1) && v.blur();
                        }
                        (p || h || f) && Cr(r._window, "click", r._onClick, !0);
                      }
                      r.clientStores = [new Ho(No(e))], r._isIdle = !1, r.flag = !0, r.isDrag = !1, r._isTrusted = t, r._dragFlag = !0, r._prevInputEvent = e, r.data = {}, r.doubleFlag = or() - r.prevTime < 200, r._isMouseEvent = function (e) {
                        return e && (e.type.indexOf("mouse") > -1 || "button" in e);
                      }(e), !r._isMouseEvent && r._preventMouseEvent && r._allowMouseEvent(), !1 === (r._preventMouseEvent || r.emit("dragStart", jo(jo({
                        data: r.data,
                        datas: r.data,
                        inputEvent: e,
                        isMouseEvent: r._isMouseEvent,
                        isSecondaryButton: r._isSecondaryButton,
                        isTrusted: t,
                        isDouble: r.doubleFlag
                      }, r.getCurrentStore().getPosition()), {
                        preventDefault: function () {
                          e.preventDefault();
                        },
                        preventDrag: function () {
                          r._dragFlag = !1;
                        }
                      }))) && r.stop(), r._isMouseEvent && r.flag && u && e.preventDefault();
                    }
                    if (!r.flag) return !1;
                    var C = 0;
                    if (g ? (r._attchDragEvent(), m && a && (C = setTimeout(function () {
                      Cr(i, "touchstart", r.onDragStart, {
                        passive: !1
                      });
                    }))) : m && a && Sr(i, "touchstart", r.onDragStart), r.flag && function (e) {
                      return e.touches && e.touches.length >= 2;
                    }(e)) {
                      if (clearTimeout(C), g && e.touches.length !== e.changedTouches.length) return;
                      r.pinchFlag || r.onPinchStart(e);
                    }
                  }
                }
              }, r.onDrag = function (e, t) {
                if (r.flag) {
                  var n = r.options.preventDefault;
                  !r._isMouseEvent && n && e.preventDefault(), r._prevInputEvent = e;
                  var o = No(e),
                    i = r.moveClients(o, e, !1);
                  if (r._dragFlag) {
                    if (r.pinchFlag || i.deltaX || i.deltaY) if (!1 === (r._preventMouseEvent || r.emit("drag", jo(jo({}, i), {
                      isScroll: !!t,
                      inputEvent: e
                    })))) return void r.stop();
                    r.pinchFlag && r.onPinch(e, o);
                  }
                  r.getCurrentStore().getPosition(o, !0);
                }
              }, r.onDragEnd = function (e) {
                if (r.flag) {
                  var t = r.options,
                    n = t.pinchOutside,
                    o = t.container,
                    i = t.preventClickEventOnDrag,
                    a = t.preventClickEventOnDragStart,
                    s = t.preventClickEventByCondition,
                    l = r.isDrag;
                  (i || a || s) && requestAnimationFrame(function () {
                    r._allowClickEvent();
                  }), s || a || !i || l || r._allowClickEvent(), r._useTouch && n && Sr(o, "touchstart", r.onDragStart), r.pinchFlag && r.onPinchEnd(e);
                  var u = (null == e ? void 0 : e.touches) ? No(e) : [];
                  0 !== u.length && r.options.keepDragging ? r._addStore(new Ho(u)) : r.flag = !1;
                  var c = r._getPosition(),
                    d = or(),
                    p = !l && r.doubleFlag;
                  r._prevInputEvent = null, r.prevTime = l || p ? 0 : d, r.flag || (r._dettachDragEvent(), r._preventMouseEvent || r.emit("dragEnd", jo({
                    data: r.data,
                    datas: r.data,
                    isDouble: p,
                    isDrag: l,
                    isClick: !l,
                    isMouseEvent: r._isMouseEvent,
                    isSecondaryButton: r._isSecondaryButton,
                    inputEvent: e,
                    isTrusted: r._isTrusted
                  }, c)), r.clientStores = [], r._isMouseEvent || (r._preventMouseEvent = !0, clearTimeout(r._preventMouseEventId), r._preventMouseEventId = setTimeout(function () {
                    r._preventMouseEvent = !1;
                  }, 200)), r._isIdle = !0);
                }
              }, r.onBlur = function () {
                r.onDragEnd();
              }, r._allowClickEvent = function () {
                Sr(r._window, "click", r._onClick, !0);
              }, r._onClick = function (e) {
                r._allowClickEvent(), r._allowMouseEvent();
                var t = r.options.preventClickEventByCondition;
                (null == t ? void 0 : t(e)) || (e.stopPropagation(), e.preventDefault());
              }, r._onContextMenu = function (e) {
                r.options.preventRightClick ? r.onDragEnd(e) : e.preventDefault();
              }, r._passCallback = function () {};
              var o = [].concat(t),
                i = o[0];
              r._window = Ar(i) ? i : kr(i), r.options = jo({
                checkInput: !1,
                container: i && !("document" in i) ? kr(i) : i,
                preventRightClick: !0,
                preventWheelClick: !0,
                preventClickEventOnDragStart: !1,
                preventClickEventOnDrag: !1,
                preventClickEventByCondition: null,
                preventDefault: !0,
                checkWindowBlur: !1,
                keepDragging: !1,
                pinchThreshold: 0,
                events: ["touch", "mouse"]
              }, n);
              var a = r.options,
                s = a.container,
                l = a.events,
                u = a.checkWindowBlur;
              if (r._useDrag = l.indexOf("drag") > -1, r._useTouch = l.indexOf("touch") > -1, r._useMouse = l.indexOf("mouse") > -1, r.targets = o, r._useDrag && o.forEach(function (e) {
                Cr(e, "dragstart", r.onDragStart);
              }), r._useMouse && (o.forEach(function (e) {
                Cr(e, "mousedown", r.onDragStart), Cr(e, "mousemove", r._passCallback);
              }), Cr(s, "contextmenu", r._onContextMenu)), u && Cr(kr(), "blur", r.onBlur), r._useTouch) {
                var c = {
                  passive: !1
                };
                o.forEach(function (e) {
                  Cr(e, "touchstart", r.onDragStart, c), Cr(e, "touchmove", r._passCallback, c);
                });
              }
              return r;
            }
            return function (e, t) {
              function n() {
                this.constructor = e;
              }
              Ro(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
            }(t, e), t.prototype.stop = function () {
              this.isDrag = !1, this.data = {}, this.clientStores = [], this.pinchFlag = !1, this.doubleFlag = !1, this.prevTime = 0, this.flag = !1, this._isIdle = !0, this._allowClickEvent(), this._dettachDragEvent(), this._isDragAPI = !1;
            }, t.prototype.getMovement = function (e) {
              return this.getCurrentStore().getMovement(e) + this.clientStores.slice(1).reduce(function (e, t) {
                return e + t.movement;
              }, 0);
            }, t.prototype.isDragging = function () {
              return this.isDrag;
            }, t.prototype.isIdle = function () {
              return this._isIdle;
            }, t.prototype.isFlag = function () {
              return this.flag;
            }, t.prototype.isPinchFlag = function () {
              return this.pinchFlag;
            }, t.prototype.isDoubleFlag = function () {
              return this.doubleFlag;
            }, t.prototype.isPinching = function () {
              return this.isPinch;
            }, t.prototype.scrollBy = function (e, t, n, r) {
              void 0 === r && (r = !0), this.flag && (this.clientStores[0].move(e, t), r && this.onDrag(n, !0));
            }, t.prototype.move = function (e, t) {
              var n = e[0],
                r = e[1],
                o = this.getCurrentStore().prevClients;
              return this.moveClients(o.map(function (e) {
                var t = e.clientX,
                  o = e.clientY;
                return {
                  clientX: t + n,
                  clientY: o + r,
                  originalClientX: t,
                  originalClientY: o
                };
              }), t, !0);
            }, t.prototype.triggerDragStart = function (e) {
              this.onDragStart(e, !1);
            }, t.prototype.setEventData = function (e) {
              var t = this.data;
              for (var n in e) t[n] = e[n];
              return this;
            }, t.prototype.setEventDatas = function (e) {
              return this.setEventData(e);
            }, t.prototype.getCurrentEvent = function (e) {
              return void 0 === e && (e = this._prevInputEvent), jo(jo({
                data: this.data,
                datas: this.data
              }, this._getPosition()), {
                movement: this.getMovement(),
                isDrag: this.isDrag,
                isPinch: this.isPinch,
                isScroll: !1,
                inputEvent: e
              });
            }, t.prototype.getEventData = function () {
              return this.data;
            }, t.prototype.getEventDatas = function () {
              return this.data;
            }, t.prototype.unset = function () {
              var e = this,
                t = this.targets,
                n = this.options.container;
              this.off(), Sr(this._window, "blur", this.onBlur), this._useDrag && t.forEach(function (t) {
                Sr(t, "dragstart", e.onDragStart);
              }), this._useMouse && (t.forEach(function (t) {
                Sr(t, "mousedown", e.onDragStart);
              }), Sr(n, "contextmenu", this._onContextMenu)), this._useTouch && (t.forEach(function (t) {
                Sr(t, "touchstart", e.onDragStart);
              }), Sr(n, "touchstart", this.onDragStart)), this._prevInputEvent = null, this._allowClickEvent(), this._dettachDragEvent();
            }, t.prototype.onPinchStart = function (e) {
              var t = this,
                n = this.options.pinchThreshold;
              if (!(this.isDrag && this.getMovement() > n)) {
                var r = new Ho(No(e));
                this.pinchFlag = !0, this._addStore(r), !1 === this.emit("pinchStart", jo(jo({
                  data: this.data,
                  datas: this.data,
                  angle: r.getAngle(),
                  touches: this.getCurrentStore().getPositions()
                }, r.getPosition()), {
                  inputEvent: e,
                  isTrusted: this._isTrusted,
                  preventDefault: function () {
                    e.preventDefault();
                  },
                  preventDrag: function () {
                    t._dragFlag = !1;
                  }
                })) && (this.pinchFlag = !1);
              }
            }, t.prototype.onPinch = function (e, t) {
              if (this.flag && this.pinchFlag && !(t.length < 2)) {
                var n = this.getCurrentStore();
                this.isPinch = !0, this.emit("pinch", jo(jo({
                  data: this.data,
                  datas: this.data,
                  movement: this.getMovement(t),
                  angle: n.getAngle(t),
                  rotation: n.getRotation(t),
                  touches: n.getPositions(t),
                  scale: n.getScale(t),
                  distance: n.getDistance(t)
                }, n.getPosition(t)), {
                  inputEvent: e,
                  isTrusted: this._isTrusted
                }));
              }
            }, t.prototype.onPinchEnd = function (e) {
              if (this.pinchFlag) {
                var t = this.isPinch;
                this.isPinch = !1, this.pinchFlag = !1;
                var n = this.getCurrentStore();
                this.emit("pinchEnd", jo(jo({
                  data: this.data,
                  datas: this.data,
                  isPinch: t,
                  touches: n.getPositions()
                }, n.getPosition()), {
                  inputEvent: e
                }));
              }
            }, t.prototype.getCurrentStore = function () {
              return this.clientStores[0];
            }, t.prototype.moveClients = function (e, t, n) {
              var r = this._getPosition(e, n),
                o = this.isDrag;
              (r.deltaX || r.deltaY) && (this.isDrag = !0);
              var i = !1;
              return !o && this.isDrag && (i = !0), jo(jo({
                data: this.data,
                datas: this.data
              }, r), {
                movement: this.getMovement(e),
                isDrag: this.isDrag,
                isPinch: this.isPinch,
                isScroll: !1,
                isMouseEvent: this._isMouseEvent,
                isSecondaryButton: this._isSecondaryButton,
                inputEvent: t,
                isTrusted: this._isTrusted,
                isFirstDrag: i
              });
            }, t.prototype._addStore = function (e) {
              this.clientStores.splice(0, 0, e);
            }, t.prototype._getPosition = function (e, t) {
              var n = this.getCurrentStore().getPosition(e, t),
                r = this.clientStores.slice(1).reduce(function (e, t) {
                  var n = t.getPosition();
                  return e.distX += n.distX, e.distY += n.distY, e;
                }, n),
                o = r.distX,
                i = r.distY;
              return jo(jo({}, n), {
                distX: o,
                distY: i
              });
            }, t.prototype._attchDragEvent = function () {
              var e = this._window,
                t = this.options.container,
                n = {
                  passive: !1
                };
              this._isDragAPI && (Cr(t, "dragover", this.onDrag, n), Cr(e, "dragend", this.onDragEnd)), this._useMouse && (Cr(t, "mousemove", this.onDrag), Cr(e, "mouseup", this.onDragEnd)), this._useTouch && (Cr(t, "touchmove", this.onDrag, n), Cr(e, "touchend", this.onDragEnd, n), Cr(e, "touchcancel", this.onDragEnd, n));
            }, t.prototype._dettachDragEvent = function () {
              var e = this._window,
                t = this.options.container;
              this._isDragAPI && (Sr(t, "dragover", this.onDrag), Sr(e, "dragend", this.onDragEnd)), this._useMouse && (Sr(t, "mousemove", this.onDrag), Sr(e, "mouseup", this.onDragEnd)), this._useTouch && (Sr(t, "touchstart", this.onDragStart), Sr(t, "touchmove", this.onDrag), Sr(e, "touchend", this.onDragEnd), Sr(e, "touchcancel", this.onDragEnd));
            }, t.prototype._allowMouseEvent = function () {
              this._preventMouseEvent = !1, clearTimeout(this._preventMouseEventId);
            }, t;
          }(Co);
        var $o = function (e) {
          for (var t = 5381, n = e.length; n;) t = 33 * t ^ e.charCodeAt(--n);
          return t >>> 0;
        };
        function Go(e, t, n, r, o) {
          var i = Er(r),
            a = i.createElement("style");
          return a.setAttribute("type", "text/css"), a.setAttribute("data-styled-id", e), a.setAttribute("data-styled-count", "1"), n.nonce && a.setAttribute("nonce", n.nonce), a.innerHTML = function (e, t, n) {
            return n.original ? t : t.replace(/([^};{\s}][^};{]*|^\s*){/gm, function (t, n) {
              var r = n.trim();
              return (r ? tr(r) : [""]).map(function (t) {
                var n = t.trim();
                return 0 === n.indexOf("@") ? n : n.indexOf(":global") > -1 ? n.replace(/\:global/g, "") : n.indexOf(":host") > -1 ? "".concat(n.replace(/\:host/g, ".".concat(e))) : n ? ".".concat(e, " ").concat(n) : ".".concat(e);
              }).join(", ") + " {";
            });
          }(e, t, n), (o || i.head || i.body).appendChild(a), a;
        }
        const Wo = function (e) {
          var t = "rCS" + $o(e).toString(36);
          return {
            className: t,
            inject: function (n, r) {
              void 0 === r && (r = {});
              var o = function (e) {
                  if (e && e.getRootNode) {
                    var t = e.getRootNode();
                    if (11 === t.nodeType) return t;
                  }
                }(n),
                i = (o || n.ownerDocument || document).querySelector('style[data-styled-id="'.concat(t, '"]'));
              if (i) {
                var a = parseFloat(i.getAttribute("data-styled-count")) || 0;
                i.setAttribute("data-styled-count", "".concat(a + 1));
              } else i = Go(t, e, r, n, o);
              return {
                destroy: function () {
                  var e,
                    t = parseFloat(i.getAttribute("data-styled-count")) || 0;
                  t <= 1 ? (i.remove ? i.remove() : null === (e = i.parentNode) || void 0 === e || e.removeChild(i), i = null) : i.setAttribute("data-styled-count", "".concat(t - 1));
                }
              };
            }
          };
        };
        var Yo = function () {
          return Yo = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, Yo.apply(this, arguments);
        };
        function Xo(e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        }
        function Qo(e, t) {
          var n = Wo(t),
            r = n.className;
          return (0, s.forwardRef)(function (t, o) {
            var i = t.className,
              a = void 0 === i ? "" : i,
              l = (t.cspNonce, Xo(t, ["className", "cspNonce"])),
              u = (0, s.useRef)();
            return (0, s.useImperativeHandle)(o, function () {
              return u.current;
            }, []), (0, s.useEffect)(function () {
              var e = n.inject(u.current, {
                nonce: t.cspNonce
              });
              return function () {
                e.destroy();
              };
            }, []), (0, s.createElement)(e, Yo({
              ref: u,
              "data-styled-id": r,
              className: "".concat(a, " ").concat(r)
            }, l));
          });
        }
        var Jo = function (e, t) {
          return Jo = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, Jo(e, t);
        };
        function ei(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          Jo(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var ti = function () {
          return ti = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, ti.apply(this, arguments);
        };
        function ni(e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            o,
            i = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = i.return) && n.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        }
        function ri(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || Array.prototype.slice.call(t));
        }
        function oi(e, t) {
          return ti({
            events: [],
            props: [],
            name: e
          }, t);
        }
        var ii = ["n", "w", "s", "e"],
          ai = ["n", "w", "s", "e", "nw", "ne", "sw", "se"];
        var si,
          li,
          ui = Fn(),
          ci = ui.browser.webkit,
          di = ci && (si = "undefined" == typeof window ? {
            userAgent: ""
          } : window.navigator, !!(li = /applewebkit\/([^\s]+)/g.exec(si.userAgent.toLowerCase())) && parseFloat(li[1]) < 605),
          pi = ui.browser.name,
          hi = parseInt(ui.browser.version, 10),
          fi = "chrome" === pi,
          mi = ui.browser.chromium,
          gi = parseInt(ui.browser.chromiumVersion, 10) || 0,
          vi = fi && hi >= 109 || mi && gi >= 109,
          yi = "firefox" === pi,
          bi = parseInt(ui.browser.webkitVersion, 10) >= 612 || hi >= 15,
          wi = "moveable-",
          xi = ai.map(function (e) {
            var t = "",
              n = "",
              r = "center",
              o = "center",
              i = "calc(var(--moveable-control-padding, 20) * -1px)";
            return e.indexOf("n") > -1 && (t = "top: ".concat(i, ";"), o = "bottom"), e.indexOf("s") > -1 && (t = "top: 0px;", o = "top"), e.indexOf("w") > -1 && (n = "left: ".concat(i, ";"), r = "right"), e.indexOf("e") > -1 && (n = "left: 0px;", r = "left"), '.around-control[data-direction*="'.concat(e, '"] {\n        ').concat(n).concat(t, "\n        transform-origin: ").concat(r, " ").concat(o, ";\n    }");
          }).join("\n"),
          Di = "\n{\nposition: absolute;\nwidth: 1px;\nheight: 1px;\nleft: 0;\ntop: 0;\nz-index: 3000;\n--moveable-color: #4af;\n--zoom: 1;\n--zoompx: 1px;\n--moveable-line-padding: 0;\n--moveable-control-padding: 0;\nwill-change: transform;\noutline: 1px solid transparent;\n}\n.control-box {\nz-index: 0;\n}\n.line, .control {\nposition: absolute;\nleft: 0;\ntop: 0;\nwill-change: transform;\n}\n.control {\nwidth: 14px;\nheight: 14px;\nborder-radius: 50%;\nborder: 2px solid #fff;\nbox-sizing: border-box;\nbackground: #4af;\nbackground: var(--moveable-color);\nmargin-top: -7px;\nmargin-left: -7px;\nborder: 2px solid #fff;\nz-index: 10;\n}\n.around-control {\nposition: absolute;\nwill-change: transform;\nwidth: calc(var(--moveable-control-padding, 20) * 1px);\nheight: calc(var(--moveable-control-padding, 20) * 1px);\nleft: calc(var(--moveable-control-padding, 20) * -0.5px);\ntop: calc(var(--moveable-control-padding, 20) * -0.5px);\nbox-sizing: border-box;\nbackground: transparent;\nz-index: 8;\ncursor: alias;\ntransform-origin: center center;\n}\n".concat(xi, "\n.padding {\nposition: absolute;\ntop: 0px;\nleft: 0px;\nwidth: 100px;\nheight: 100px;\ntransform-origin: 0 0;\n}\n.line {\nwidth: 1px;\nheight: 1px;\nbackground: #4af;\nbackground: var(--moveable-color);\ntransform-origin: 0px 50%;\n}\n.line.edge {\nz-index: 1;\nbackground: transparent;\n}\n.line.dashed {\nbox-sizing: border-box;\nbackground: transparent;\n}\n.line.dashed.horizontal {\nborder-top: 1px dashed #4af;\nborder-top-color: #4af;\nborder-top-color: var(--moveable-color);\n}\n.line.dashed.vertical {\nborder-left: 1px dashed #4af;\nborder-left-color: #4af;\nborder-left-color: var(--moveable-color);\n}\n.line.vertical {\ntransform: translateX(-50%);\n}\n.line.horizontal {\ntransform: translateY(-50%);\n}\n.line.vertical.bold {\nwidth: 2px;\n}\n.line.horizontal.bold {\nheight: 2px;\n}\n\n.control.origin {\nborder-color: #f55;\nbackground: #fff;\nwidth: 12px;\nheight: 12px;\nmargin-top: -6px;\nmargin-left: -6px;\npointer-events: none;\n}\n").concat([0, 15, 30, 45, 60, 75, 90, 105, 120, 135, 150, 165].map(function (e) {
            return '\n.direction[data-rotation="'.concat(e, '"], :global .view-control-rotation').concat(e, " {\n").concat(function (e) {
              var t = function (e, t) {
                  return 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="'.concat(32 * e, 'px" height="').concat(32 * e, 'px" viewBox="0 0 32 32" ><path d="M 16,5 L 12,10 L 14.5,10 L 14.5,22 L 12,22 L 16,27 L 20,22 L 17.5,22 L 17.5,10 L 20, 10 L 16,5 Z" stroke-linejoin="round" stroke-width="1.2" fill="black" stroke="white" style="transform:rotate(').concat(t, 'deg);transform-origin: 16px 16px"></path></svg>');
                }(1, e),
                n = 45 * Math.round(e / 45) % 180,
                r = "ns-resize";
              return 135 === n ? r = "nwse-resize" : 45 === n ? r = "nesw-resize" : 90 === n && (r = "ew-resize"), "cursor:".concat(r, ";cursor: url('").concat(t, "') 16 16, ").concat(r, ";");
            }(e), "\n}\n");
          }).join("\n"), '\n\n.line.direction:before {\ncontent: "";\nposition: absolute;\nwidth: 100%;\nheight: calc(var(--moveable-line-padding, 0) * 1px);\nbottom: 0;\nleft: 0;\n}\n.group {\nz-index: -1;\n}\n.area {\nposition: absolute;\n}\n.area-pieces {\nposition: absolute;\ntop: 0;\nleft: 0;\ndisplay: none;\n}\n.area.avoid, .area.pass {\npointer-events: none;\n}\n.area.avoid+.area-pieces {\ndisplay: block;\n}\n.area-piece {\nposition: absolute;\n}\n\n').concat(di ? ':global svg *:before {\ncontent:"";\ntransform-origin: inherit;\n}' : "", "\n"),
          Ci = [[0, 1, 2], [1, 0, 3], [2, 0, 3], [3, 1, 2]],
          Si = 1e-4,
          Ei = 1e-7,
          _i = 1e-9,
          Pi = Math.pow(10, 10),
          ki = -Pi,
          Ai = {
            n: [0, -1],
            e: [1, 0],
            s: [0, 1],
            w: [-1, 0],
            nw: [-1, -1],
            ne: [1, -1],
            sw: [-1, 1],
            se: [1, 1]
          },
          zi = {
            n: [0, 1],
            e: [1, 3],
            s: [3, 2],
            w: [2, 0],
            nw: [0],
            ne: [1],
            sw: [2],
            se: [3]
          },
          Ti = {
            n: 0,
            s: 180,
            w: 270,
            e: 90,
            nw: 315,
            ne: 45,
            sw: 225,
            se: 135
          },
          Oi = ["isMoveableElement", "updateRect", "updateTarget", "destroy", "dragStart", "isInside", "hitTest", "setState", "getRect", "request", "isDragging", "getManager", "forceUpdate", "waitToChangeTarget", "updateSelectors", "getTargets", "stopDrag", "getControlBoxElement", "getMoveables", "getDragElement"];
        function Ii(e, t, n, r, o, i) {
          var a, s;
          void 0 === i && (i = "draggable");
          var l = null !== (s = null === (a = t.gestos[i]) || void 0 === a ? void 0 : a.move(n, e.inputEvent)) && void 0 !== s ? s : {},
            u = l.originalDatas || l.datas,
            c = u[i] || (u[i] = {});
          return ti(ti({}, o ? Vl(t, l) : l), {
            isPinch: !!r,
            parentEvent: !0,
            datas: c,
            originalDatas: e.originalDatas
          });
        }
        var Fi = function () {
          function e(e) {
            var t;
            void 0 === e && (e = "draggable"), this.ableName = e, this.prevX = 0, this.prevY = 0, this.startX = 0, this.startY = 0, this.isDrag = !1, this.isFlag = !1, this.datas = {
              draggable: {}
            }, this.datas = ((t = {})[e] = {}, t);
          }
          return e.prototype.dragStart = function (e, t) {
            this.isDrag = !1, this.isFlag = !1;
            var n = t.originalDatas;
            return this.datas = n, n[this.ableName] || (n[this.ableName] = {}), ti(ti({}, this.move(e, t.inputEvent)), {
              type: "dragstart"
            });
          }, e.prototype.drag = function (e, t) {
            return this.move([e[0] - this.prevX, e[1] - this.prevY], t);
          }, e.prototype.move = function (e, t) {
            var n,
              r,
              o = !1;
            if (this.isFlag) {
              var i = this.isDrag;
              n = this.prevX + e[0], r = this.prevY + e[1], (e[0] || e[1]) && (this.isDrag = !0), !i && this.isDrag && (o = !0);
            } else this.prevX = e[0], this.prevY = e[1], this.startX = e[0], this.startY = e[1], n = e[0], r = e[1], this.isFlag = !0;
            return this.prevX = n, this.prevY = r, {
              type: "drag",
              clientX: n,
              clientY: r,
              inputEvent: t,
              isFirstDrag: o,
              isDrag: this.isDrag,
              distX: n - this.startX,
              distY: r - this.startY,
              deltaX: e[0],
              deltaY: e[1],
              datas: this.datas[this.ableName],
              originalDatas: this.datas,
              parentEvent: !0,
              parentGesto: this
            };
          }, e;
        }();
        function Mi(e, t, n, r) {
          var o = 16 === e.length ? 4 : 3,
            i = ni(ll(e, n, r, o), 4),
            a = ni(i[0], 2),
            s = a[0],
            l = a[1],
            u = ni(i[1], 2),
            c = u[0],
            d = u[1],
            p = ni(i[2], 2),
            h = p[0],
            f = p[1],
            m = ni(i[3], 2),
            g = m[0],
            v = m[1],
            y = ni(sl(e, t, o), 2),
            b = y[0],
            w = y[1],
            x = Math.min(s, c, h, g),
            D = Math.min(l, d, f, v),
            C = Math.max(s, c, h, g);
          return s = s - x || 0, {
            left: x,
            top: D,
            right: C,
            bottom: Math.max(l, d, f, v),
            origin: [b = b - x || 0, w = w - D || 0],
            pos1: [s, l = l - D || 0],
            pos2: [c = c - x || 0, d = d - D || 0],
            pos3: [h = h - x || 0, f = f - D || 0],
            pos4: [g = g - x || 0, v = v - D || 0],
            direction: tu(e[0] * e[o + 1])
          };
        }
        function Ri(e, t) {
          var n = t.datas,
            r = e.state,
            o = r.allMatrix,
            i = r.beforeMatrix,
            a = r.is3d,
            s = r.left,
            l = r.top,
            u = r.origin,
            c = r.offsetMatrix,
            d = r.targetMatrix,
            p = r.transformOrigin,
            h = a ? 4 : 3;
          n.is3d = a, n.matrix = o, n.targetMatrix = d, n.beforeMatrix = i, n.offsetMatrix = c, n.transformOrigin = p, n.inverseMatrix = Mr(o, h), n.inverseBeforeMatrix = Mr(i, h), n.absoluteOrigin = jr(Vr([s, l], u), h), n.startDragBeforeDist = Ur(n.inverseBeforeMatrix, n.absoluteOrigin, h), n.startDragDist = Ur(n.inverseMatrix, n.absoluteOrigin, h);
        }
        function ji(e, t, n) {
          var r = t.datas,
            o = t.originalDatas.beforeRenderable,
            i = r.transformIndex,
            a = o.nextTransforms,
            s = a.length,
            l = o.nextTransformAppendedIndexes,
            u = -1;
          -1 === i ? ("translate" === n ? u = 0 : "rotate" === n && (u = ir(a, function (e) {
            return e.match(/scale\(/g);
          })), -1 === u && (u = a.length), r.transformIndex = u) : u = ar(l, function (e) {
            return e.index === i && e.functionName === n;
          }) ? i : i + l.filter(function (e) {
            return e.index < i;
          }).length;
          var c = function (e, t, n) {
              var r,
                o = so(e, {
                  "x%": function (e) {
                    return e / 100 * t.offsetWidth;
                  },
                  "y%": function (e) {
                    return e / 100 * t.offsetHeight;
                  }
                }),
                i = e.slice(0, n < 0 ? void 0 : n),
                a = e.slice(0, n < 0 ? void 0 : n + 1),
                s = e[n] || "",
                l = n < 0 ? [] : e.slice(n),
                u = n < 0 ? [] : e.slice(n + 1),
                c = o.slice(0, n < 0 ? void 0 : n),
                d = o.slice(0, n < 0 ? void 0 : n + 1),
                p = null !== (r = o[n]) && void 0 !== r ? r : so([""])[0],
                h = n < 0 ? [] : o.slice(n),
                f = n < 0 ? [] : o.slice(n + 1),
                m = p ? [p] : [],
                g = ao(c),
                v = ao(d),
                y = ao(h),
                b = ao(f),
                w = Lr(g, y, 4);
              return {
                transforms: e,
                beforeFunctionMatrix: g,
                beforeFunctionMatrix2: v,
                targetFunctionMatrix: ao(m),
                afterFunctionMatrix: y,
                afterFunctionMatrix2: b,
                allFunctionMatrix: w,
                beforeFunctions: c,
                beforeFunctions2: d,
                targetFunction: m[0],
                afterFunctions: h,
                afterFunctions2: f,
                beforeFunctionTexts: i,
                beforeFunctionTexts2: a,
                targetFunctionText: s,
                afterFunctionTexts: l,
                afterFunctionTexts2: u
              };
            }(a, e.state, u),
            d = c.targetFunction,
            p = "rotate" === n ? "rotateZ" : n;
          r.beforeFunctionTexts = c.beforeFunctionTexts, r.afterFunctionTexts = c.afterFunctionTexts, r.beforeTransform = c.beforeFunctionMatrix, r.beforeTransform2 = c.beforeFunctionMatrix2, r.targetTansform = c.targetFunctionMatrix, r.afterTransform = c.afterFunctionMatrix, r.afterTransform2 = c.afterFunctionMatrix2, r.targetAllTransform = c.allFunctionMatrix, d.functionName === p ? (r.afterFunctionTexts.splice(0, 1), r.isAppendTransform = !1) : s > u && (r.isAppendTransform = !0, o.nextTransformAppendedIndexes = ri(ri([], ni(l), !1), [{
            functionName: n,
            index: u,
            isAppend: !0
          }], !1));
        }
        function Bi(e, t, n) {
          return "".concat(e.beforeFunctionTexts.join(" "), " ").concat(e.isAppendTransform ? n : t, " ").concat(e.afterFunctionTexts.join(" "));
        }
        function Ni(e) {
          var t = e.datas,
            n = ni(Vi({
              datas: t,
              distX: e.distX,
              distY: e.distY
            }), 2),
            r = Li(t, function (e, t) {
              for (var n = eo(t), r = 0; r < t - 1; ++r) n[t * (t - 1) + r] = e[r] || 0;
              return n;
            }([n[0], n[1]], 4));
          return Ur(r, jr([0, 0, 0], 4), 4);
        }
        function Li(e, t, n) {
          var r = e.beforeTransform,
            o = e.afterTransform,
            i = e.beforeTransform2,
            a = e.afterTransform2,
            s = e.targetAllTransform,
            l = n ? Lr(s, t, 4) : Lr(t, s, 4),
            u = Lr(Mr(n ? i : r, 4), l, 4);
          return Lr(u, Mr(n ? a : o, 4), 4);
        }
        function Vi(e) {
          var t = e.datas,
            n = e.distX,
            r = e.distY,
            o = t.inverseBeforeMatrix,
            i = t.is3d,
            a = t.startDragBeforeDist,
            s = i ? 4 : 3;
          return Kr(Ur(o, Vr(t.absoluteOrigin, [n, r]), s), a);
        }
        function Ki(e, t) {
          var n = e.datas,
            r = e.distX,
            o = e.distY,
            i = n.inverseBeforeMatrix,
            a = n.inverseMatrix,
            s = n.is3d,
            l = n.startDragBeforeDist,
            u = n.startDragDist,
            c = s ? 4 : 3;
          return Kr(Ur(t ? i : a, Vr(n.absoluteOrigin, [r, o]), c), t ? l : u);
        }
        function qi(e) {
          var t = [];
          return e[1] >= 0 && (e[0] >= 0 && t.push(3), e[0] <= 0 && t.push(2)), e[1] <= 0 && (e[0] >= 0 && t.push(1), e[0] <= 0 && t.push(0)), t;
        }
        function Hi(e, t) {
          var n = (t + 1) / 2;
          return [Hn(e[0][0], e[1][0], n, 1 - n), Hn(e[0][1], e[1][1], n, 1 - n)];
        }
        function Ui(e, t) {
          var n = Hi([e[0], e[1]], t[0]),
            r = Hi([e[2], e[3]], t[0]);
          return Hi([n, r], t[1]);
        }
        function Zi(e, t, n, r) {
          return Lr(e, Ws(t, r, n), r);
        }
        function $i(e, t) {
          var n = Xi(t);
          return {
            setTransform: function (r, o) {
              void 0 === o && (o = -1), n.startTransforms = $n(r) ? r : er(r), Wi(e, t, o);
            },
            setTransformIndex: function (n) {
              Wi(e, t, n);
            }
          };
        }
        function Gi(e, t, n) {
          Wi(e, t, ir(Xi(t).startTransforms, function (e) {
            return 0 === e.indexOf("".concat(n, "("));
          }));
        }
        function Wi(e, t, n) {
          var r = Xi(t),
            o = t.datas;
          if (o.transformIndex = n, -1 !== n) {
            var i = r.startTransforms[n];
            if (i) {
              var a = e.state,
                s = so([i], {
                  "x%": function (e) {
                    return e / 100 * a.offsetWidth;
                  },
                  "y%": function (e) {
                    return e / 100 * a.offsetHeight;
                  }
                });
              o.startValue = s[0].functionValue;
            }
          }
        }
        function Yi(e, t) {
          Xi(e).nextTransforms = er(t);
        }
        function Xi(e) {
          return e.originalDatas.beforeRenderable;
        }
        function Qi(e) {
          return e.originalDatas.beforeRenderable.nextTransforms;
        }
        function Ji(e) {
          return (Qi(e) || []).join(" ");
        }
        function ea(e) {
          return Xi(e).nextStyle;
        }
        function ta(e, t, n, r, o) {
          Yi(o, t);
          var i = ps.drag(e, Ii(o, e.state, n, r, !1)),
            a = i ? i.transform : t;
          return ti(ti({
            transform: t,
            drag: i
          }, Pl({
            transform: a
          }, o)), {
            afterTransform: a
          });
        }
        function na(e, t, n, r, o, i) {
          var a = function (e, t, n, r) {
              var o,
                i = e.transformOrigin,
                a = e.offsetMatrix,
                s = e.is3d ? 4 : 3;
              if (Gn(n)) {
                var l = t.beforeTransform,
                  u = t.afterTransform;
                o = Br(r ? io(n) : Lr(Lr(l, io([n]), 4), u, 4), 4, s);
              } else o = n;
              return Zi(a, o, i, s);
            }(e.state, o, t, i),
            s = function (e, t, n, r) {
              void 0 === r && (r = e.state.allMatrix);
              var o = e.state,
                i = o.width,
                a = o.height,
                s = o.is3d ? 4 : 3,
                l = [i / 2 * (1 + t[0]) + n[0], a / 2 * (1 + t[1]) + n[1]];
              return sl(r, l, s);
            }(e, n, r, a);
          return s;
        }
        function ra(e, t, n, r, o, i, a) {
          var s = na(e, t, n, o, i, a),
            l = e.state,
            u = l.left,
            c = l.top,
            d = e.props.groupable,
            p = d ? u : 0,
            h = d ? c : 0,
            f = Kr(r, s);
          return Kr(f, [p, h]);
        }
        function oa(e, t, n, r, o, i) {
          var a = e.props.groupable,
            s = e.state,
            l = s.transformOrigin,
            u = s.offsetMatrix,
            c = s.is3d,
            d = s.width,
            p = s.height,
            h = s.left,
            f = s.top,
            m = i.fixedDirection,
            g = i.nextTargetMatrix || s.targetMatrix,
            v = c ? 4 : 3,
            y = function (e, t, n, r, o, i) {
              return void 0 === r && (r = t), void 0 === o && (o = n), void 0 === i && (i = [0, 0]), e ? e.map(function (e, a) {
                var s = rr(e),
                  l = s.value,
                  u = s.unit,
                  c = a ? o : r,
                  d = a ? n : t;
                return "%" === e || isNaN(l) ? d * (c ? i[a] / c : 0) : "%" !== u ? l : d * l / 100;
              }) : i;
            }(o, t, n, d, p, l),
            b = a ? h : 0,
            w = a ? f : 0,
            x = function (e, t, n, r, o, i) {
              var a = Ui(ll(t, n, r, o), i);
              return [e[0] - a[0], e[1] - a[1]];
            }(r, Zi(u, g, y, v), t, n, v, m);
          return Kr(x, [b, w]);
        }
        function ia(e) {
          if (e && e.getRootNode) {
            var t = e.getRootNode();
            if (11 === t.nodeType) return t;
          }
        }
        function aa(e) {
          var t = e("scale"),
            n = e("rotate"),
            r = e("translate"),
            o = [];
          return r && "0px" !== r && "none" !== r && o.push("translate(".concat(r.split(/\s+/).join(","), ")")), n && "1" !== n && "none" !== n && o.push("rotate(".concat(n, ")")), t && "1" !== t && "none" !== t && o.push("scale(".concat(t.split(/\s+/).join(","), ")")), o;
        }
        function sa(e, t, n) {
          for (var r, o, i, a = e, s = [], l = _r(e) || Pr(e), u = !n && e === t || e === l, c = u, d = !1, p = 3, h = !1, f = Js(t, t, !0).offsetParent, m = 1; a && !c;) {
            c = u;
            var g = pa(a),
              v = g("position"),
              y = Qs(a),
              b = "fixed" === v,
              w = aa(g),
              x = qr(Gs(y)),
              D = void 0,
              C = !1,
              S = !1,
              E = 0,
              _ = 0,
              P = 0,
              k = 0,
              A = {
                hasTransform: !1,
                fixedContainer: null
              };
            b && (h = !0, f = (A = rl(a)).fixedContainer);
            var z = x.length;
            d || 16 !== z && !w.length || (d = !0, p = 4, nl(s), i && (i = Br(i, 3, 4))), d && 9 === z && (x = Br(x, 3, 4));
            var T = el(a, e),
              O = T.tagName,
              I = T.hasOffset,
              F = T.isSVG,
              M = T.origin,
              R = T.targetOrigin,
              j = ni(T.offset, 2),
              B = j[0],
              N = j[1];
            "svg" === O && !a.ownerSVGElement && i && (s.push({
              type: "target",
              target: a,
              matrix: al(a, p)
            }), s.push({
              type: "offset",
              target: a,
              matrix: eo(p)
            }));
            var L = parseFloat(g("zoom")) || 1;
            if (b) D = A.fixedContainer, C = !0;else {
              var V = Js(a, t, !1, !0, g),
                K = V.offsetZoom;
              if (D = V.offsetParent, C = V.isEnd, S = V.isStatic, m *= K, (V.isCustomElement || 1 !== K) && S) B -= D.offsetLeft, N -= D.offsetTop;else if (yi || vi) {
                if (V.parentSlotElement) {
                  for (var q = D, H = 0, U = 0; q && ia(q);) H += q.offsetLeft, U += q.offsetTop, q = q.offsetParent;
                  B -= H, N -= U;
                }
              }
            }
            if (!ci || bi || !I || F || !S || "relative" !== v && "static" !== v || (B -= D.offsetLeft, N -= D.offsetTop, u = u || C), b) I && A.hasTransform && (P = D.clientLeft, k = D.clientTop);else if (I && f !== D && (E = D.clientLeft, _ = D.clientTop), I && D === l) {
              var Z = tl(a, !1);
              B += Z[0], N += Z[1];
            }
            if (s.push({
              type: "target",
              target: a,
              matrix: Ws(x, p, M)
            }), w.length && (s.push({
              type: "offset",
              target: a,
              matrix: eo(p)
            }), s.push({
              type: "target",
              target: a,
              matrix: Ws(io(w), p, M)
            })), I) {
              var $ = a === e,
                G = $ ? 0 : a.scrollLeft,
                W = $ ? 0 : a.scrollTop;
              s.push({
                type: "offset",
                target: a,
                matrix: no([B - G + E - P, N - W + _ - k], p)
              });
            } else s.push({
              type: "offset",
              target: a,
              origin: M
            });
            if (1 !== L && s.push({
              type: "zoom",
              target: a,
              matrix: Ws(to([L, L], p), p, [0, 0])
            }), i || (i = x), r || (r = M), o || (o = R), c || b) break;
            a = D, u = C, n && a !== l || (c = u);
          }
          return i || (i = eo(p)), r || (r = [0, 0]), o || (o = [0, 0]), {
            zoom: m,
            offsetContainer: f,
            matrixes: s,
            targetMatrix: i,
            transformOrigin: r,
            targetOrigin: o,
            is3d: d,
            hasFixed: h
          };
        }
        var la = null,
          ua = null,
          ca = null;
        function da(e) {
          e ? (window.Map && (la = new Map(), ua = new Map()), ca = []) : (la = null, ca = null, ua = null);
        }
        function pa(e) {
          var t = null == la ? void 0 : la.get(e);
          if (!t) {
            var n = kr(e).getComputedStyle(e);
            if (!la) return function (e) {
              return n[e];
            };
            t = {
              style: n,
              cached: {}
            }, la.set(e, t);
          }
          var r = t.cached,
            o = t.style;
          return function (e) {
            return e in r || (r[e] = o[e]), r[e];
          };
        }
        function ha(e, t, n) {
          var r = n.originalDatas;
          r.groupable = r.groupable || {};
          var o = r.groupable;
          o.childDatas = o.childDatas || [];
          var i = o.childDatas;
          return e.moveables.map(function (e, r) {
            return i[r] = i[r] || {}, i[r][t] = i[r][t] || {}, ti(ti({}, n), {
              isRequestChild: !0,
              datas: i[r][t],
              originalDatas: i[r]
            });
          });
        }
        function fa(e, t, n, r, o, i, a) {
          var s = !!n.match(/Start$/g),
            l = !!n.match(/End$/g),
            u = o.isPinch,
            c = o.datas,
            d = ha(e, t.name, o),
            p = e.moveables,
            h = [],
            f = d.map(function (e, o) {
              var d = p[o],
                f = d.state,
                m = f.gestos,
                g = e;
              if (s) g = new Fi(a).dragStart(r, e), h.push(g);else {
                if (m[a] || (m[a] = c.childGestos[o]), !m[a]) return;
                g = Ii(e, f, r, u, i, a), h.push(g);
              }
              var v = t[n](d, ti(ti({}, g), {
                parentFlag: !0
              }));
              return l && (m[a] = null), v;
            });
          return s && (c.childGestos = p.map(function (e) {
            return e.state.gestos[a];
          })), {
            eventParams: f,
            childEvents: h
          };
        }
        function ma(e, t, n, r, o, i) {
          void 0 === o && (o = function (e, t) {
            return t;
          });
          var a = !!n.match(/End$/g),
            s = ha(e, t.name, r),
            l = e.moveables;
          return s.map(function (e, r) {
            var s,
              u = l[r];
            s = o(u, e);
            var c = t[n](u, ti(ti({}, s), {
              parentFlag: !0
            }));
            return c && i && i(u, e, c, r), a && (u.state.gestos = {}), c;
          });
        }
        function ga(e, t, n, r) {
          var o = n.fixedDirection,
            i = n.fixedPosition,
            a = Ui(r.datas.startPositions || Sl(t.state), o),
            s = ni(Ur(Jr(-e.rotation / 180 * Math.PI, 3), [a[0] - i[0], a[1] - i[1], 1], 3), 2),
            l = s[0],
            u = s[1];
          return r.datas.originalX = l, r.datas.originalY = u, r;
        }
        function va(e, t, n, r) {
          var o = e.getState(),
            i = o.renderPoses,
            a = o.rotation,
            s = o.direction,
            l = ml(e.props, t).zoom,
            u = Bs(a / Math.PI * 180),
            c = {},
            d = e.renderState;
          d.renderDirectionMap || (d.renderDirectionMap = {});
          var p = d.renderDirectionMap;
          n.forEach(function (e) {
            var t = e.dir;
            c[t] = !0;
          });
          var h = tu(s);
          return n.map(function (e) {
            var n = e.data,
              o = e.classNames,
              s = e.dir,
              d = zi[s];
            if (!d || !c[s]) return null;
            p[s] = !0;
            var f = (yr(u, 15) + h * Ti[s] + 720) % 180,
              m = {};
            return ur(n).forEach(function (e) {
              m["data-".concat(e)] = n[e];
            }), r.createElement("div", ti({
              className: Zs.apply(void 0, ri(["control", "direction", s, t], ni(o), !1)),
              "data-rotation": f,
              "data-direction": s
            }, m, {
              key: "direction-".concat(s),
              style: fl.apply(void 0, ri([a, l], ni(d.map(function (e) {
                return i[e];
              })), !1))
            }));
          });
        }
        function ya(e, t, n, r) {
          var o = ml(e.props, n),
            i = o.renderDirections,
            a = void 0 === i ? t : i,
            s = o.displayAroundControls;
          if (!a) return [];
          var l = !0 === a ? ai : a;
          return ri(ri([], ni(s ? Ca(e, r, n, l) : []), !1), ni(va(e, n, l.map(function (e) {
            return {
              data: {},
              classNames: [],
              dir: e
            };
          }), r)), !1);
        }
        function ba(e, t, n, r, o, i) {
          for (var a = [], s = 6; s < arguments.length; s++) a[s - 6] = arguments[s];
          var l = mr(n, r),
            u = t ? yr(l / Math.PI * 180, 15) % 180 : -1;
          return e.createElement("div", {
            key: "line-".concat(i),
            className: Zs.apply(void 0, ri(["line", "direction", t ? "edge" : "", t], ni(a), !1)),
            "data-rotation": u,
            "data-line-key": i,
            "data-direction": t,
            style: hl(n, r, o, l)
          });
        }
        function wa(e, t, n, r, o) {
          return (!0 === n ? ii : n).map(function (n, i) {
            var a = ni(zi[n], 2),
              s = a[0],
              l = a[1];
            if (null != l) return ba(e, n, r[s], r[l], o, "".concat(t, "Edge").concat(i), t);
          }).filter(Boolean);
        }
        function xa(e) {
          return function (t, n) {
            var r = ml(t.props, e).edge;
            return r && (!0 === r || r.length) ? ri(ri([], ni(wa(n, e, r, t.getState().renderPoses, t.props.zoom)), !1), ni(function (e, t, n) {
              return ya(e, ["nw", "ne", "sw", "se"], t, n);
            }(t, e, n)), !1) : Da(t, e, n);
          };
        }
        function Da(e, t, n) {
          return ya(e, ai, t, n);
        }
        function Ca(e, t, n, r) {
          var o = e.renderState;
          o.renderDirectionMap || (o.renderDirectionMap = {});
          var i = e.getState(),
            a = i.renderPoses,
            s = i.rotation,
            l = i.direction,
            u = o.renderDirectionMap,
            c = e.props.zoom,
            d = tu(l),
            p = s / Math.PI * 180;
          return (r || ur(u)).map(function (e) {
            var r = zi[e];
            if (!r) return null;
            var o = (yr(p, 15) + d * Ti[e] + 720) % 180,
              i = ["around-control"];
            return n && i.push("direction", n), t.createElement("div", {
              className: Zs.apply(void 0, ri([], ni(i), !1)),
              "data-rotation": o,
              "data-direction": e,
              key: "direction-around-".concat(e),
              style: fl.apply(void 0, ri([s, c], ni(r.map(function (e) {
                return a[e];
              })), !1))
            });
          });
        }
        function Sa(e, t, n) {
          var r = e || {},
            o = r.position,
            i = void 0 === o ? "client" : o,
            a = r.left,
            s = void 0 === a ? -1 / 0 : a,
            l = r.top,
            u = void 0 === l ? -1 / 0 : l,
            c = r.right,
            d = void 0 === c ? 1 / 0 : c,
            p = r.bottom,
            h = {
              position: i,
              left: s,
              top: u,
              right: d,
              bottom: void 0 === p ? 1 / 0 : p
            };
          return {
            vertical: _a(h, t, !0),
            horizontal: _a(h, n, !1)
          };
        }
        function Ea(e, t) {
          var n = e.state,
            r = n.containerClientRect,
            o = r.clientHeight,
            i = r.clientWidth,
            a = r.clientLeft,
            s = r.clientTop,
            l = n.snapOffset,
            u = l.left,
            c = l.top,
            d = l.right,
            p = l.bottom,
            h = t || e.props.bounds || {},
            f = "css" === (h.position || "client"),
            m = h.left,
            g = void 0 === m ? -1 / 0 : m,
            v = h.top,
            y = void 0 === v ? -1 / 0 : v,
            b = h.right,
            w = void 0 === b ? f ? -1 / 0 : 1 / 0 : b,
            x = h.bottom,
            D = void 0 === x ? f ? -1 / 0 : 1 / 0 : x;
          return f && (w = i + d - u - w, D = o + p - c - D), {
            left: g + u - a,
            right: w + u - a,
            top: y + c - s,
            bottom: D + c - s
          };
        }
        function _a(e, t, n) {
          var r = e[n ? "left" : "top"],
            o = e[n ? "right" : "bottom"],
            i = Math.min.apply(Math, ri([], ni(t), !1)),
            a = Math.max.apply(Math, ri([], ni(t), !1)),
            s = [];
          return r + 1 > i && s.push({
            direction: "start",
            isBound: !0,
            offset: i - r,
            pos: r
          }), o - 1 < a && s.push({
            direction: "end",
            isBound: !0,
            offset: a - o,
            pos: o
          }), s.length || s.push({
            isBound: !1,
            offset: 0,
            pos: 0
          }), s.sort(function (e, t) {
            return nu(t.offset) - nu(e.offset);
          });
        }
        function Pa(e, t, n) {
          return (n ? e.map(function (e) {
            return Yr(e, n);
          }) : e).some(function (e) {
            return e[0] < t.left && nu(e[0] - t.left) > .1 || e[0] > t.right && nu(e[0] - t.right) > .1 || e[1] < t.top && nu(e[1] - t.top) > .1 || e[1] > t.bottom && nu(e[1] - t.bottom) > .1;
          });
        }
        function ka(e, t, n, r, o) {
          if (!e.props.bounds) return [];
          var i = o * Math.PI / 180,
            a = Ea(e),
            s = a.left,
            l = a.top,
            u = a.right,
            c = a.bottom,
            d = s - r[0],
            p = u - r[0],
            h = l - r[1],
            f = c - r[1],
            m = {
              left: d,
              top: h,
              right: p,
              bottom: f
            };
          if (!Pa(n, m, 0)) return [];
          var g = [];
          return [[d, 0], [p, 0], [h, 1], [f, 1]].forEach(function (e) {
            var r = ni(e, 2),
              o = r[0],
              a = r[1];
            n.forEach(function (e) {
              var n = mr([0, 0], e);
              g.push.apply(g, ri([], ni(function (e, t, n) {
                var r = dl(e),
                  o = Math.sqrt(r * r - t * t) || 0;
                return [o, -o].sort(function (t, r) {
                  return nu(t - e[n ? 0 : 1]) - nu(r - e[n ? 0 : 1]);
                }).map(function (e) {
                  return mr([0, 0], n ? [e, t] : [t, e]);
                });
              }(e, o, a).map(function (e) {
                return i + e - n;
              }).filter(function (e) {
                return !Pa(t, m, e);
              }).map(function (e) {
                return yr(180 * e / Math.PI, Ei);
              })), !1));
            });
          }), g;
        }
        var Aa = ["left", "right", "center"],
          za = ["top", "bottom", "middle"],
          Ta = {
            left: "start",
            right: "end",
            center: "center",
            top: "start",
            bottom: "end",
            middle: "center"
          },
          Oa = {
            start: "left",
            end: "right",
            center: "center"
          },
          Ia = {
            start: "top",
            end: "bottom",
            center: "middle"
          };
        function Fa(e, t) {
          var n = e.props,
            r = n.snappable,
            o = n.bounds,
            i = n.innerBounds,
            a = n.verticalGuidelines,
            s = n.horizontalGuidelines,
            l = n.snapGridWidth,
            u = n.snapGridHeight,
            c = e.state,
            d = c.guidelines,
            p = c.enableSnap;
          return !(!r || !p || t && !0 !== r && r.indexOf(t) < 0) && !!(l || u || o || i || d && d.length || a && a.length || s && s.length);
        }
        function Ma(e) {
          return !1 === e ? {} : !0 !== e && e ? e : {
            left: !0,
            right: !0,
            top: !0,
            bottom: !0
          };
        }
        function Ra(e, t) {
          var n = function (e, t) {
              var n = Ma(e),
                r = {};
              for (var o in n) o in t && n[o] && (r[o] = t[o]);
              return r;
            }(e, t),
            r = za.filter(function (e) {
              return e in n;
            }),
            o = Aa.filter(function (e) {
              return e in n;
            });
          return {
            horizontalNames: r,
            verticalNames: o,
            horizontal: r.map(function (e) {
              return n[e];
            }),
            vertical: o.map(function (e) {
              return n[e];
            })
          };
        }
        var ja = "snapRotationThreshold",
          Ba = "snapRotationDegrees",
          Na = "snapHorizontalThreshold",
          La = "snapVerticalThreshold";
        function Va(e, t, n, r, o, i, a) {
          var s;
          void 0 === r && (r = []), void 0 === o && (o = []);
          var l = e.props,
            u = (null === (s = e.state.snapThresholdInfo) || void 0 === s ? void 0 : s.multiples) || [1, 1],
            c = Rl(a, l.snapHorizontalThreshold, 5),
            d = Rl(i, l.snapVerticalThreshold, 5);
          return Ka(e.state.guidelines, t, n, r, o, c, d, u);
        }
        function Ka(e, t, n, r, o, i, a, s) {
          return {
            vertical: Za(e, "vertical", t, a * s[0], r),
            horizontal: Za(e, "horizontal", n, i * s[1], o)
          };
        }
        function qa(e) {
          var t = "";
          return -1 === e || "top" === e || "left" === e ? t = "start" : 0 === e || "center" === e || "middle" === e ? t = "center" : 1 !== e && "right" !== e && "bottom" !== e || (t = "end"), t;
        }
        function Ha(e, t, n, r) {
          var o = Ra(e.props.snapDirections, t),
            i = Va(e, o.vertical, o.horizontal, o.verticalNames.map(function (e) {
              return qa(e);
            }), o.horizontalNames.map(function (e) {
              return qa(e);
            }), n, r),
            a = qa(o.horizontalNames[i.horizontal.index]),
            s = qa(o.verticalNames[i.vertical.index]);
          return {
            vertical: ti(ti({}, i.vertical), {
              direction: s
            }),
            horizontal: ti(ti({}, i.horizontal), {
              direction: a
            })
          };
        }
        function Ua(e) {
          var t = e.isSnap;
          if (!t) return {
            isSnap: !1,
            offset: 0,
            dist: -1,
            pos: 0,
            guideline: null
          };
          var n = e.posInfos[0],
            r = n.guidelineInfos[0],
            o = r.offset,
            i = r.dist,
            a = r.guideline;
          return {
            isSnap: t,
            offset: o,
            dist: i,
            pos: n.pos,
            guideline: a
          };
        }
        function Za(e, t, n, r, o) {
          var i, a;
          if (void 0 === o && (o = []), !e || !e.length) return {
            isSnap: !1,
            index: -1,
            direction: "",
            posInfos: []
          };
          var s = "vertical" === t ? 0 : 1,
            l = n.map(function (n, i) {
              var a = o[i] || "",
                l = e.map(function (e) {
                  var t = e.pos,
                    r = n - t[s];
                  return {
                    offset: r,
                    dist: nu(r),
                    guideline: e,
                    direction: a
                  };
                }).filter(function (e) {
                  var n = e.guideline,
                    o = e.dist;
                  return !(n.type !== t || o > r);
                }).sort(function (e, t) {
                  return e.dist - t.dist;
                });
              return {
                pos: n,
                index: i,
                guidelineInfos: l,
                direction: a
              };
            }).filter(function (e) {
              return e.guidelineInfos.length > 0;
            }).sort(function (e, t) {
              return e.guidelineInfos[0].dist - t.guidelineInfos[0].dist;
            }),
            u = l.length > 0;
          return {
            isSnap: u,
            index: u ? l[0].index : -1,
            direction: null !== (a = null === (i = l[0]) || void 0 === i ? void 0 : i.direction) && void 0 !== a ? a : "",
            posInfos: l
          };
        }
        function $a(e, t, n, r, o) {
          var i = [];
          n[0] && n[1] ? i = [n, [-n[0], n[1]], [n[0], -n[1]]] : n[0] || n[1] ? e.props.keepRatio ? i.push([-1, -1], [-1, 1], [1, -1], [1, 1], n) : (i.push.apply(i, ri([], ni(function (e, t) {
            return qi(t).map(function (t) {
              return e[t];
            });
          }([[-1, -1], [1, -1], [-1, -1], [1, 1]], n)), !1)), i.length > 1 && i.push([(i[0][0] + i[1][0]) / 2, (i[0][1] + i[1][1]) / 2])) : [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(function (e, t, n) {
            var r = n[t + 1] || n[0];
            i.push(e), i.push([(e[0] + r[0]) / 2, (e[1] + r[1]) / 2]);
          });
          var a = i.map(function (e) {
              return Ui(t, e);
            }),
            s = Va(e, a.map(function (e) {
              return e[0];
            }), a.map(function (e) {
              return e[1];
            }), i.map(function (e) {
              return qa(e[0]);
            }), i.map(function (e) {
              return qa(e[1]);
            }), r, o),
            l = qa(i.map(function (e) {
              return e[0];
            })[s.vertical.index]),
            u = qa(i.map(function (e) {
              return e[1];
            })[s.horizontal.index]);
          return {
            vertical: ti(ti({}, s.vertical), {
              direction: l
            }),
            horizontal: ti(ti({}, s.horizontal), {
              direction: u
            })
          };
        }
        function Ga(e, t) {
          var n = nu(e.offset),
            r = nu(t.offset);
          return e.isBound && t.isBound ? r - n : e.isBound ? -1 : t.isBound ? 1 : e.isSnap && t.isSnap ? r - n : e.isSnap ? -1 : t.isSnap || n < Ei ? 1 : r < Ei ? -1 : n - r;
        }
        function Wa(e, t) {
          return e.slice().sort(function (e, n) {
            var r = e.sign[t],
              o = n.sign[t],
              i = e.offset[t],
              a = n.offset[t];
            return r ? o ? Ga({
              isBound: e.isBound,
              isSnap: e.isSnap,
              offset: i
            }, {
              isBound: n.isBound,
              isSnap: n.isSnap,
              offset: a
            }) : -1 : 1;
          })[0];
        }
        function Ya(e, t) {
          var n = fr([t[0][0], t[1][0]]),
            r = fr([t[0][1], t[1][1]]);
          return {
            vertical: n <= e[0],
            horizontal: r <= e[1]
          };
        }
        function Xa(e, t) {
          var n,
            r,
            o = ni(t, 2),
            i = o[0],
            a = o[1],
            s = a[0] - i[0],
            l = a[1] - i[1];
          if (nu(s) < Ei && (s = 0), nu(l) < Ei && (l = 0), s) {
            if (l) {
              n = l / s * (e[0] - i[0]) + i[1], r = e[1];
            } else n = i[1], r = e[1];
          } else n = i[0], r = e[0];
          return n - r;
        }
        function Qa(e, t, n, r) {
          return void 0 === r && (r = Ei), e.every(function (e) {
            var o = Xa(e, t);
            return o <= 0 === n || nu(o) <= r;
          });
        }
        function Ja(e, t, n, r, o) {
          return void 0 === o && (o = 0), r && t - o <= e || !r && e <= n + o ? {
            isBound: !0,
            offset: r ? t - e : n - e
          } : {
            isBound: !1,
            offset: 0
          };
        }
        function es(e, t, n, r, o, i) {
          var a,
            s,
            l = ni(t, 2),
            u = l[0],
            c = l[1],
            d = e[0],
            p = n[0],
            h = n[1],
            f = ql(h[1] - p[1]),
            m = c,
            g = u,
            v = -u / c;
          return ql(h[0] - p[0]) ? f || i && !m ? {
            isBound: !1,
            offset: 0
          } : g ? Ja((p[1] - d[1]) / v + d[0], p[0], h[0], r, o) : {
            isBound: s = nu(a = p[1] - d[1]) <= (o || 0),
            offset: s ? a : 0
          } : i && !g ? {
            isBound: !1,
            offset: 0
          } : m ? Ja(v * (p[0] - d[0]) + d[1], p[1], h[1], r, o) : {
            isBound: s = nu(a = p[0] - d[0]) <= (o || 0),
            offset: s ? a : 0
          };
        }
        function ts(e, t, n) {
          return t.map(function (t) {
            var r = function (e, t) {
                var n = t.line,
                  r = t.centerSign,
                  o = t.verticalSign,
                  i = t.horizontalSign,
                  a = t.lineConstants,
                  s = e.props.innerBounds;
                if (!s) return {
                  isAllBound: !1,
                  isBound: !1,
                  isVerticalBound: !1,
                  isHorizontalBound: !1,
                  offset: [0, 0]
                };
                var l = s.left,
                  u = s.top,
                  c = s.width,
                  d = s.height,
                  p = [[l, u], [l, u + d]],
                  h = [[l, u], [l + c, u]],
                  f = [[l + c, u], [l + c, u + d]],
                  m = [[l, u + d], [l + c, u + d]];
                if (Qa([[l, u], [l + c, u], [l, u + d], [l + c, u + d]], n, r)) return {
                  isAllBound: !1,
                  isBound: !1,
                  isVerticalBound: !1,
                  isHorizontalBound: !1,
                  offset: [0, 0]
                };
                var g = es(n, a, h, o),
                  v = es(n, a, m, o),
                  y = es(n, a, p, i),
                  b = es(n, a, f, i),
                  w = g.isBound && v.isBound,
                  x = g.isBound || v.isBound,
                  D = y.isBound && b.isBound,
                  C = y.isBound || b.isBound,
                  S = Nl(g.offset, v.offset),
                  E = Nl(y.offset, b.offset),
                  _ = [0, 0],
                  P = !1,
                  k = !1;
                return nu(E) < nu(S) ? (_ = [S, 0], P = x, k = w) : (_ = [0, E], P = C, k = D), {
                  isAllBound: k,
                  isVerticalBound: x,
                  isHorizontalBound: C,
                  isBound: P,
                  offset: _
                };
              }(e, t),
              o = r.isBound,
              i = r.offset,
              a = r.isVerticalBound,
              s = r.isHorizontalBound,
              l = t.multiple,
              u = Ki({
                datas: n,
                distX: i[0],
                distY: i[1]
              }).map(function (e, t) {
                return e * (l[t] ? 2 / l[t] : 0);
              });
            return {
              sign: l,
              isBound: o,
              isVerticalBound: a,
              isHorizontalBound: s,
              isSnap: !1,
              offset: u
            };
          });
        }
        function ns(e, t, n) {
          var r,
            o = ts(e, rs(e, t, [0, 0], !1).map(function (e) {
              return ti(ti({}, e), {
                multiple: e.multiple.map(function (e) {
                  return 2 * nu(e);
                })
              });
            }), n),
            i = Wa(o, 0),
            a = Wa(o, 1),
            s = 0,
            l = 0,
            u = i.isVerticalBound || a.isVerticalBound,
            c = i.isHorizontalBound || a.isHorizontalBound;
          return (u || c) && (r = ni(function (e, t) {
            var n = e.datas,
              r = e.distX,
              o = e.distY,
              i = n.beforeMatrix,
              a = n.matrix,
              s = n.is3d,
              l = n.startDragBeforeDist,
              u = n.startDragDist,
              c = n.absoluteOrigin,
              d = s ? 4 : 3;
            return Kr(Ur(t ? i : a, Vr(t ? l : u, [r, o]), d), c);
          }({
            datas: n,
            distX: -i.offset[0],
            distY: -a.offset[1]
          }), 2), s = r[0], l = r[1]), {
            vertical: {
              isBound: u,
              offset: s
            },
            horizontal: {
              isBound: c,
              offset: l
            }
          };
        }
        function rs(e, t, n, r) {
          var o = e.state,
            i = ll(o.allMatrix, 100, 100, o.is3d ? 4 : 3),
            a = Ui(i, [0, 0]);
          return function (e, t) {
            var n = [],
              r = e[0],
              o = e[1];
            return r && o ? n.push([[0, 2 * o], e, [-r, o]], [[2 * r, 0], e, [r, -o]]) : r ? (n.push([[2 * r, 0], [r, 1], [r, -1]]), t && n.push([[0, -1], [r, -1], [-r, -1]], [[0, 1], [r, 1], [-r, 1]])) : o ? (n.push([[0, 2 * o], [1, o], [-1, o]]), t && n.push([[-1, 0], [-1, o], [-1, -o]], [[1, 0], [1, o], [1, -o]])) : n.push([[-1, 0], [-1, -1], [-1, 1]], [[1, 0], [1, -1], [1, 1]], [[0, -1], [-1, -1], [1, -1]], [[0, 1], [-1, 1], [1, 1]]), n;
          }(n, r).map(function (e) {
            var n = ni(e, 3),
              r = n[0],
              o = n[1],
              s = n[2],
              l = [Ui(i, o), Ui(i, s)],
              u = function (e) {
                var t = ni(e, 2),
                  n = t[0],
                  r = t[1],
                  o = r[0] - n[0],
                  i = r[1] - n[1];
                Math.abs(o) < Kn && (o = 0), Math.abs(i) < Kn && (i = 0);
                var a = 0,
                  s = 0,
                  l = 0;
                return o ? i ? (s = 1, l = (a = -i / o) * n[0] - n[1]) : (s = 1, l = -n[1]) : (a = -1, l = n[0]), [a, s, l].map(function (e) {
                  return yr(e, Kn);
                });
              }(l),
              c = Ya(a, l),
              d = c.vertical,
              p = c.horizontal;
            return {
              multiple: r,
              centerSign: Xa(a, l) <= 0,
              verticalSign: d,
              horizontalSign: p,
              lineConstants: u,
              line: [Ui(t, o), Ui(t, s)]
            };
          });
        }
        function os(e, t, n, r) {
          var o = r ? e.map(function (e) {
            return Yr(e, r);
          }) : e;
          return [[o[0], o[1]], [o[1], o[3]], [o[3], o[2]], [o[2], o[0]]].some(function (e) {
            var r = Xa(n, e) <= 0;
            return !Qa(t, e, r);
          });
        }
        function is(e, t, n, r, o) {
          var i = e.props.innerBounds,
            a = o * Math.PI / 180;
          if (!i) return [];
          var s = i.left,
            l = i.top,
            u = i.width,
            c = i.height,
            d = s - r[0],
            p = s + u - r[0],
            h = l - r[1],
            f = l + c - r[1],
            m = [[d, h], [p, h], [d, f], [p, f]],
            g = Ui(n, [0, 0]);
          if (!os(n, m, g, 0)) return [];
          var v = [],
            y = m.map(function (e) {
              return [dl(e), mr([0, 0], e)];
            });
          return [[n[0], n[1]], [n[1], n[3]], [n[3], n[2]], [n[2], n[0]]].forEach(function (e) {
            var n = mr([0, 0], function (e) {
                var t = ni(e, 2),
                  n = t[0],
                  r = t[1],
                  o = r[0] - n[0],
                  i = r[1] - n[1];
                if (!o) return [n[0], 0];
                if (!i) return [0, n[1]];
                var a = i / o,
                  s = -a * n[0] + n[1];
                return [-s / (a + 1 / a), s / (a * a + 1)];
              }(e)),
              r = function (e) {
                var t = ni(e, 2),
                  n = t[0],
                  r = t[1],
                  o = r[0] - n[0],
                  i = r[1] - n[1];
                if (!o) return nu(n[0]);
                if (!i) return nu(n[1]);
                var a = i / o;
                return nu((-a * n[0] + n[1]) / Math.sqrt(Math.pow(a, 2) + 1));
              }(e);
            v.push.apply(v, ri([], ni(y.filter(function (e) {
              var t = ni(e, 1)[0];
              return t && r <= t;
            }).map(function (e) {
              var t = ni(e, 2),
                o = t[0],
                i = t[1],
                s = Math.acos(o ? r / o : 0);
              return [a + (i + s) - n, a + (i - s) - n];
            }).reduce(function (e, t) {
              return e.push.apply(e, ri([], ni(t), !1)), e;
            }, []).filter(function (e) {
              return !os(t, m, g, e);
            }).map(function (e) {
              return yr(180 * e / Math.PI, Ei);
            })), !1));
          }), v;
        }
        function as(e, t, n, r, o) {
          var i = function (e, t, n, r) {
            var o = t[0] - e[0],
              i = t[1] - e[1];
            if (nu(o) < Kn && (o = 0), nu(i) < Kn && (i = 0), !o) return r ? [0, 0] : [0, n];
            if (!i) return r ? [n, 0] : [0, 0];
            var a = i / o,
              s = e[1] - a * e[0];
            return r ? [n, a * (t[0] + n) + s - t[1]] : [(t[1] + n - s) / a - t[0], n];
          }(e, t, n, r);
          if (!i) return {
            isOutside: !1,
            offset: [0, 0]
          };
          var a = vr(e, t),
            s = vr(i, e),
            l = vr(i, t),
            u = s > a || l > a,
            c = ni(Ki({
              datas: o,
              distX: i[0],
              distY: i[1]
            }), 2);
          return {
            offset: [c[0], c[1]],
            isOutside: u
          };
        }
        function ss(e, t) {
          return e.isBound ? e.offset : t.isSnap ? Ua(t).offset : 0;
        }
        function ls(e, t, n, r, o, i) {
          if (!Fa(e, "draggable")) return [{
            isSnap: !1,
            isBound: !1,
            offset: 0
          }, {
            isSnap: !1,
            isBound: !1,
            offset: 0
          }];
          var a = Cl(i.absolutePoses, [t, n]),
            s = ul(a),
            l = s.left,
            u = s.right,
            c = s.top,
            d = s.bottom,
            p = {
              horizontal: a.map(function (e) {
                return e[1];
              }),
              vertical: a.map(function (e) {
                return e[0];
              })
            },
            h = us(e, o, Ra(Ma(e.props.snapDirections), {
              left: l,
              right: u,
              top: c,
              bottom: d,
              center: (l + u) / 2,
              middle: (c + d) / 2
            }), p),
            f = h.vertical,
            m = h.horizontal,
            g = ns(e, a, i),
            v = g.vertical,
            y = g.horizontal,
            b = f.isSnap,
            w = m.isSnap,
            x = f.isBound || v.isBound,
            D = m.isBound || y.isBound,
            C = ni(function (e, t, n, r, o) {
              var i = ni(t, 2),
                a = i[0],
                s = i[1],
                l = ni(n, 2),
                u = l[0],
                c = l[1],
                d = ni(r, 2),
                p = d[0],
                h = d[1],
                f = ni(o, 2),
                m = f[0],
                g = f[1],
                v = -m,
                y = -g;
              if (e && a && s) {
                v = 0, y = 0;
                var b = [];
                if (u && c ? b.push([0, g], [m, 0]) : u ? b.push([m, 0]) : c ? b.push([0, g]) : p && h ? b.push([0, g], [m, 0]) : p ? b.push([m, 0]) : h && b.push([0, g]), b.length) {
                  b.sort(function (e, t) {
                    return dl(Kr([a, s], e)) - dl(Kr([a, s], t));
                  });
                  var w = b[0];
                  if (w[0] && nu(a) > Kn) v = -w[0], y = s * nu(a + v) / nu(a) - s;else if (w[1] && nu(s) > Kn) {
                    var x = s;
                    y = -w[1], v = a * nu(s + y) / nu(x) - a;
                  }
                  if (e && c && u) if (nu(v) > Kn && nu(v) < nu(m)) v *= D = nu(m) / nu(v), y *= D;else if (nu(y) > Kn && nu(y) < nu(g)) {
                    var D;
                    v *= D = nu(g) / nu(y), y *= D;
                  } else v = Nl(-m, v), y = Nl(-g, y);
                }
              } else v = a || u ? -m : 0, y = s || c ? -g : 0;
              return [v, y];
            }(r, [t, n], [x, D], [b, w], [Nl(f.offset, v.offset), Nl(m.offset, y.offset)]), 2);
          return [{
            isBound: x,
            isSnap: b,
            offset: C[0]
          }, {
            isBound: D,
            isSnap: w,
            offset: C[1]
          }];
        }
        function us(e, t, n, r) {
          void 0 === r && (r = n);
          var o = Sa(Ea(e), r.vertical, r.horizontal),
            i = o.horizontal,
            a = o.vertical,
            s = t ? {
              horizontal: {
                isSnap: !1,
                index: -1
              },
              vertical: {
                isSnap: !1,
                index: -1
              }
            } : Va(e, n.vertical, n.horizontal, void 0, void 0, void 0, void 0),
            l = s.horizontal,
            u = s.vertical,
            c = ss(i[0], l),
            d = ss(a[0], u),
            p = nu(c),
            h = nu(d);
          return {
            horizontal: {
              isBound: i[0].isBound,
              isSnap: l.isSnap,
              snapIndex: l.index,
              offset: c,
              dist: p,
              bounds: i,
              snap: l
            },
            vertical: {
              isBound: a[0].isBound,
              isSnap: u.isSnap,
              snapIndex: u.index,
              offset: d,
              dist: h,
              bounds: a,
              snap: u
            }
          };
        }
        function cs(e, t, n, r, o, i) {
          return n.map(function (n) {
            var a = ni(n, 2),
              s = a[0],
              l = a[1],
              u = Ui(t, s),
              c = Ui(t, l),
              d = r ? function (e, t, n, r) {
                var o = function (e, t, n) {
                    var r = Ea(e),
                      o = r.left,
                      i = r.top,
                      a = r.right,
                      s = r.bottom,
                      l = ni(n, 2),
                      u = l[0],
                      c = l[1],
                      d = ni(Kr(n, t), 2),
                      p = d[0],
                      h = d[1];
                    nu(p) < Ei && (p = 0), nu(h) < Ei && (h = 0);
                    var f = h > 0,
                      m = p > 0,
                      g = {
                        isBound: !1,
                        offset: 0,
                        pos: 0
                      },
                      v = {
                        isBound: !1,
                        offset: 0,
                        pos: 0
                      };
                    if (0 === p && 0 === h) return {
                      vertical: g,
                      horizontal: v
                    };
                    if (0 === p) f ? s < c && (v.pos = s, v.offset = c - s) : i > c && (v.pos = i, v.offset = c - i);else if (0 === h) m ? a < u && (g.pos = a, g.offset = u - a) : o > u && (g.pos = o, g.offset = u - o);else {
                      var y = h / p,
                        b = n[1] - y * u,
                        w = 0,
                        x = 0,
                        D = !1;
                      m && a <= u ? (w = y * a + b, x = a, D = !0) : !m && u <= o && (w = y * o + b, x = o, D = !0), D && (w < i || w > s) && (D = !1), D || (f && s <= c ? (x = ((w = s) - b) / y, D = !0) : !f && c <= i && (x = ((w = i) - b) / y, D = !0)), D && (g.isBound = !0, g.pos = x, g.offset = u - x, v.isBound = !0, v.pos = w, v.offset = c - w);
                    }
                    return {
                      vertical: g,
                      horizontal: v
                    };
                  }(e, t, n),
                  i = o.horizontal,
                  a = o.vertical,
                  s = r ? {
                    horizontal: {
                      isSnap: !1
                    },
                    vertical: {
                      isSnap: !1
                    }
                  } : function (e, t, n) {
                    var r = ni(n, 2),
                      o = r[0],
                      i = r[1],
                      a = ni(t, 2),
                      s = a[0],
                      l = a[1],
                      u = ni(Kr(n, t), 2),
                      c = u[0],
                      d = u[1],
                      p = d > 0,
                      h = c > 0;
                    c = ql(c), d = ql(d);
                    var f = {
                        isSnap: !1,
                        offset: 0,
                        pos: 0
                      },
                      m = {
                        isSnap: !1,
                        offset: 0,
                        pos: 0
                      };
                    if (0 === c && 0 === d) return {
                      vertical: f,
                      horizontal: m
                    };
                    var g = Va(e, c ? [o] : [], d ? [i] : [], [], [], void 0, void 0),
                      v = g.vertical,
                      y = g.horizontal;
                    v.posInfos.filter(function (e) {
                      var t = e.pos;
                      return h ? t >= s : t <= s;
                    }), y.posInfos.filter(function (e) {
                      var t = e.pos;
                      return p ? t >= l : t <= l;
                    }), v.isSnap = v.posInfos.length > 0, y.isSnap = y.posInfos.length > 0;
                    var b = Ua(v),
                      w = b.isSnap,
                      x = b.guideline,
                      D = Ua(y),
                      C = D.isSnap,
                      S = D.guideline,
                      E = C ? S.pos[1] : 0,
                      _ = w ? x.pos[0] : 0;
                    if (0 === c) C && (m.isSnap = !0, m.pos = S.pos[1], m.offset = i - m.pos);else if (0 === d) w && (f.isSnap = !0, f.pos = _, f.offset = o - _);else {
                      var P = d / c,
                        k = n[1] - P * o,
                        A = 0,
                        z = 0,
                        T = !1;
                      w ? (A = P * (z = _) + k, T = !0) : C && (z = ((A = E) - k) / P, T = !0), T && (f.isSnap = !0, f.pos = z, f.offset = o - z, m.isSnap = !0, m.pos = A, m.offset = i - A);
                    }
                    return {
                      vertical: f,
                      horizontal: m
                    };
                  }(e, t, n),
                  l = s.horizontal,
                  u = s.vertical,
                  c = ds(i, l),
                  d = ds(a, u),
                  p = nu(c),
                  h = nu(d);
                return {
                  horizontal: {
                    isBound: i.isBound,
                    isSnap: l.isSnap,
                    offset: c,
                    dist: p
                  },
                  vertical: {
                    isBound: a.isBound,
                    isSnap: u.isSnap,
                    offset: d,
                    dist: h
                  }
                };
              }(e, u, c, o) : us(e, o, {
                vertical: [c[0]],
                horizontal: [c[1]]
              }),
              p = d.horizontal,
              h = p.offset,
              f = p.isBound,
              m = p.isSnap,
              g = d.vertical,
              v = g.offset,
              y = g.isBound,
              b = g.isSnap,
              w = Kr(l, s);
            if (!v && !h) return {
              isBound: y || f,
              isSnap: b || m,
              sign: w,
              offset: [0, 0]
            };
            var x = function (e, t, n, r) {
              var o = mr(e, t) / Math.PI * 180,
                i = n.vertical,
                a = i.isBound,
                s = i.isSnap,
                l = i.dist,
                u = n.horizontal,
                c = u.isBound,
                d = u.isSnap,
                p = o % 180,
                h = p < 3 || p > 177,
                f = p > 87 && p < 93;
              return u.dist < l && (a || s && !f && (!r || !h)) ? "vertical" : !c && (!d || h || r && f) ? "" : "horizontal";
            }(u, c, d, r);
            if (!x) return {
              sign: w,
              isBound: !1,
              isSnap: !1,
              offset: [0, 0]
            };
            var D = "vertical" === x,
              C = [0, 0];
            return C = (C = r || 1 !== nu(l[0]) || 1 !== nu(l[1]) || s[0] === l[0] || s[1] === l[1] ? as(u, c, -(D ? v : h), D, i).offset : Ki({
              datas: i,
              distX: -v,
              distY: -h
            })).map(function (e, t) {
              return e * (w[t] ? 2 / w[t] : 0);
            }), {
              sign: w,
              isBound: D ? y : f,
              isSnap: D ? b : m,
              offset: C
            };
          });
        }
        function ds(e, t) {
          return e.isBound ? e.offset : t.isSnap ? t.offset : 0;
        }
        var ps = {
          name: "draggable",
          props: ["draggable", "throttleDrag", "throttleDragRotate", "hideThrottleDragRotateLine", "startDragRotate", "edgeDraggable"],
          events: ["dragStart", "drag", "dragEnd", "dragGroupStart", "dragGroup", "dragGroupEnd"],
          requestStyle: function () {
            return ["left", "top", "right", "bottom"];
          },
          requestChildStyle: function () {
            return ["left", "top", "right", "bottom"];
          },
          render: function (e, t) {
            var n = e.props,
              r = n.hideThrottleDragRotateLine,
              o = n.throttleDragRotate,
              i = n.zoom,
              a = e.getState(),
              s = a.dragInfo,
              l = a.beforeOrigin;
            if (r || !o || !s) return [];
            var u = s.dist;
            if (!u[0] && !u[1]) return [];
            var c = dl(u),
              d = mr(u, [0, 0]);
            return [t.createElement("div", {
              className: Zs("line", "horizontal", "dragline", "dashed"),
              key: "dragRotateGuideline",
              style: {
                width: "".concat(c, "px"),
                transform: "translate(".concat(l[0], "px, ").concat(l[1], "px) rotate(").concat(d, "rad) scaleY(").concat(i, ")")
              }
            })];
          },
          dragStart: function (e, t) {
            var n = t.datas,
              r = t.parentEvent,
              o = t.parentGesto,
              i = e.state,
              a = i.gestos,
              s = i.style;
            if (a.draggable) return !1;
            a.draggable = o || e.targetGesto, n.datas = {}, n.left = parseFloat(s.left || "") || 0, n.top = parseFloat(s.top || "") || 0, n.bottom = parseFloat(s.bottom || "") || 0, n.right = parseFloat(s.right || "") || 0, n.startValue = [0, 0], Ri(e, t), Gi(e, t, "translate"), function (e, t) {
              t.absolutePoses = Sl(e.state);
            }(e, n), n.prevDist = [0, 0], n.prevBeforeDist = [0, 0], n.isDrag = !1, n.deltaOffset = [0, 0];
            var l = Al(e, t, ti({
              set: function (e) {
                n.startValue = e;
              }
            }, $i(e, t)));
            return !1 !== (r || Ol(e, "onDragStart", l)) ? (n.isDrag = !0, e.state.dragInfo = {
              startRect: e.getRect(),
              dist: [0, 0]
            }) : (a.draggable = null, n.isPinch = !1), !!n.isDrag && l;
          },
          drag: function (e, t) {
            if (t) {
              ji(e, t, "translate");
              var n = t.datas,
                r = t.parentEvent,
                o = t.parentFlag,
                i = t.isPinch,
                a = t.deltaOffset,
                s = t.useSnap,
                l = t.isRequest,
                u = t.isGroup,
                c = t.parentThrottleDrag,
                d = t.distX,
                p = t.distY,
                h = n.isDrag,
                f = n.prevDist,
                m = n.prevBeforeDist,
                g = n.startValue;
              if (h) {
                a && (d += a[0], p += a[1]);
                var v = e.props,
                  y = v.parentMoveable,
                  b = u ? 0 : v.throttleDrag || c || 0,
                  w = r ? 0 : v.throttleDragRotate || 0,
                  x = 0,
                  D = !1,
                  C = !1,
                  S = !1,
                  E = !1;
                if (!r && w > 0 && (d || p)) {
                  var _ = v.startDragRotate || 0,
                    P = yr(_ + 180 * mr([0, 0], [d, p]) / Math.PI, w) - _,
                    k = p * Math.abs(Math.cos((P - 90) / 180 * Math.PI)),
                    A = dl([d * Math.abs(Math.cos(P / 180 * Math.PI)), k]);
                  x = P * Math.PI / 180, d = A * Math.cos(x), p = A * Math.sin(x);
                }
                if (!i && !r && !o) {
                  var z = ni(ls(e, d, p, w, !s && l || a, n), 2),
                    T = z[0],
                    O = z[1];
                  D = T.isSnap, C = T.isBound, S = O.isSnap, E = O.isBound, d += T.offset, p += O.offset;
                }
                var I = Vr(Vi({
                    datas: n,
                    distX: d,
                    distY: p
                  }), g),
                  F = Vr(Ni({
                    datas: n,
                    distX: d,
                    distY: p
                  }), g);
                br(F, Ei), br(I, Ei), w || (D || C || (F[0] = yr(F[0], b), I[0] = yr(I[0], b)), S || E || (F[1] = yr(F[1], b), I[1] = yr(I[1], b)));
                var M = Kr(I, g),
                  R = Kr(F, g),
                  j = Kr(R, f),
                  B = Kr(M, m);
                n.prevDist = R, n.prevBeforeDist = M, n.passDelta = j, n.passDist = R;
                var N = n.left + M[0],
                  L = n.top + M[1],
                  V = n.right - M[0],
                  K = n.bottom - M[1],
                  q = Bi(n, "translate(".concat(F[0], "px, ").concat(F[1], "px)"), "translate(".concat(R[0], "px, ").concat(R[1], "px)"));
                if (Yi(t, q), e.state.dragInfo.dist = r ? [0, 0] : R, r || y || !j.every(function (e) {
                  return !e;
                }) || !B.some(function (e) {
                  return !e;
                })) {
                  var H = e.state,
                    U = H.width,
                    Z = H.height,
                    $ = Al(e, t, ti({
                      transform: q,
                      dist: R,
                      delta: j,
                      translate: F,
                      beforeDist: M,
                      beforeDelta: B,
                      beforeTranslate: I,
                      left: N,
                      top: L,
                      right: V,
                      bottom: K,
                      width: U,
                      height: Z,
                      isPinch: i
                    }, Pl({
                      transform: q
                    }, t)));
                  return !r && Ol(e, "onDrag", $), $;
                }
              }
            }
          },
          dragAfter: function (e, t) {
            var n = t.datas,
              r = n.deltaOffset;
            return !(!r[0] && !r[1]) && (n.deltaOffset = [0, 0], this.drag(e, ti(ti({}, t), {
              deltaOffset: r
            })));
          },
          dragEnd: function (e, t) {
            var n = t.parentEvent,
              r = t.datas;
            if (e.state.dragInfo = null, r.isDrag) {
              r.isDrag = !1;
              var o = zl(e, t, {});
              return !n && Ol(e, "onDragEnd", o), o;
            }
          },
          dragGroupStart: function (e, t) {
            var n,
              r,
              o = t.datas,
              i = t.clientX,
              a = t.clientY,
              s = this.dragStart(e, t);
            if (!s) return !1;
            var l = fa(e, this, "dragStart", [i || 0, a || 0], t, !1, "draggable"),
              u = l.childEvents,
              c = l.eventParams,
              d = Ol(e, "onDragGroupStart", ti(ti({}, s), {
                targets: e.props.targets,
                events: c
              }));
            o.isDrag = !1 !== d;
            var p = null !== (r = null === (n = u[0]) || void 0 === n ? void 0 : n.datas.startValue) && void 0 !== r ? r : [0, 0];
            return o.throttleOffset = [p[0] % 1, p[1] % 1], !!o.isDrag && s;
          },
          dragGroup: function (e, t) {
            if (t.datas.isDrag) {
              var n = this.drag(e, ti(ti({}, t), {
                  parentThrottleDrag: e.props.throttleDrag
                })),
                r = fa(e, this, "drag", t.datas.passDelta, t, !1, "draggable").eventParams;
              if (n) {
                var o = ti({
                  targets: e.props.targets,
                  events: r
                }, n);
                return Ol(e, "onDragGroup", o), o;
              }
            }
          },
          dragGroupEnd: function (e, t) {
            var n = t.isDrag;
            if (t.datas.isDrag) {
              this.dragEnd(e, t);
              var r = fa(e, this, "dragEnd", [0, 0], t, !1, "draggable").eventParams;
              return Ol(e, "onDragGroupEnd", zl(e, t, {
                targets: e.props.targets,
                events: r
              })), n;
            }
          },
          request: function (e) {
            var t = {},
              n = e.getRect(),
              r = 0,
              o = 0,
              i = !1;
            return {
              isControl: !1,
              requestStart: function (e) {
                return i = e.useSnap, {
                  datas: t,
                  useSnap: i
                };
              },
              request: function (e) {
                return "x" in e ? r = e.x - n.left : "deltaX" in e && (r += e.deltaX), "y" in e ? o = e.y - n.top : "deltaY" in e && (o += e.deltaY), {
                  datas: t,
                  distX: r,
                  distY: o,
                  useSnap: i
                };
              },
              requestEnd: function () {
                return {
                  datas: t,
                  isDrag: !0,
                  useSnap: i
                };
              }
            };
          },
          unset: function (e) {
            e.state.gestos.draggable = null, e.state.dragInfo = null;
          }
        };
        function hs(e, t) {
          return {
            fixedPosition: Ui(e, t),
            fixedDirection: t,
            fixedOffset: [0, 0]
          };
        }
        function fs(e, t) {
          var n = e.allMatrix,
            r = e.is3d,
            o = e.width,
            i = e.height,
            a = r ? 4 : 3,
            s = function (e, t, n) {
              return [t ? e[0] / (t / 2) - 1 : 0, n ? e[1] / (n / 2) - 1 : 0];
            }(t, o, i);
          return {
            fixedPosition: sl(n, t, a),
            fixedDirection: s,
            fixedOffset: [o ? 0 : t[0], i ? 0 : t[1]]
          };
        }
        var ms = Ul("resizable"),
          gs = {
            name: "resizable",
            ableGroup: "size",
            canPinch: !0,
            props: ["resizable", "throttleResize", "renderDirections", "displayAroundControls", "keepRatio", "resizeFormat", "keepRatioFinally", "edge", "checkResizableError"],
            events: ["resizeStart", "beforeResize", "resize", "resizeEnd", "resizeGroupStart", "beforeResizeGroup", "resizeGroup", "resizeGroupEnd"],
            render: xa("resizable"),
            dragControlCondition: ms,
            viewClassName: Hl("resizable"),
            dragControlStart: function (e, t) {
              var n,
                r = t.inputEvent,
                o = t.isPinch,
                i = t.isGroup,
                a = t.parentDirection,
                s = t.parentGesto,
                l = t.datas,
                u = t.parentFixedDirection,
                c = t.parentEvent,
                d = xl(a, o, r, l),
                p = e.state,
                h = p.target,
                f = p.width,
                m = p.height,
                g = p.gestos;
              if (!d || !h) return !1;
              if (g.resizable) return !1;
              g.resizable = s || e.controlGesto, !o && Ri(e, t), l.datas = {}, l.direction = d, l.startOffsetWidth = f, l.startOffsetHeight = m, l.prevWidth = 0, l.prevHeight = 0, l.minSize = [0, 0], l.startWidth = p.inlineCSSWidth || p.cssWidth, l.startHeight = p.inlineCSSHeight || p.cssHeight, l.maxSize = [1 / 0, 1 / 0], i || (l.minSize = [p.minOffsetWidth, p.minOffsetHeight], l.maxSize = [p.maxOffsetWidth, p.maxOffsetHeight]);
              var v = e.props.transformOrigin || "% %";
              function y(e) {
                l.ratio = e && isFinite(e) ? e : 0;
              }
              function b(e) {
                var t = hs(l.startPositions, e);
                l.fixedDirection = t.fixedDirection, l.fixedPosition = t.fixedPosition, l.fixedOffset = t.fixedOffset;
              }
              function w(t) {
                var n = fs(e.state, t);
                l.fixedDirection = n.fixedDirection, l.fixedPosition = n.fixedPosition, l.fixedOffset = n.fixedOffset;
              }
              function x(e) {
                l.minSize = [cr("".concat(e[0]), 0) || 0, cr("".concat(e[1]), 0) || 0];
              }
              function D(e) {
                var t = [e[0] || 1 / 0, e[1] || 1 / 0];
                Wn(t[0]) && !isFinite(t[0]) || (t[0] = cr("".concat(t[0]), 0) || 1 / 0), Wn(t[1]) && !isFinite(t[1]) || (t[1] = cr("".concat(t[1]), 0) || 1 / 0), l.maxSize = t;
              }
              l.transformOrigin = v && Gn(v) ? v.split(" ") : v, l.startOffsetMatrix = p.offsetMatrix, l.startTransformOrigin = p.transformOrigin, l.isWidth = null !== (n = null == t ? void 0 : t.parentIsWidth) && void 0 !== n ? n : !d[0] && !d[1] || d[0] || !d[1], l.startPositions = Sl(e.state), y(f / m), b(u || [-d[0], -d[1]]), l.setFixedDirection = b, l.setFixedPosition = w, l.setMin = x, l.setMax = D;
              var C = Al(e, t, {
                  direction: d,
                  startRatio: l.ratio,
                  set: function (e) {
                    var t = ni(e, 2),
                      n = t[0],
                      r = t[1];
                    l.startWidth = n, l.startHeight = r;
                  },
                  setMin: x,
                  setMax: D,
                  setRatio: y,
                  setFixedDirection: b,
                  setFixedPosition: w,
                  setOrigin: function (e) {
                    l.transformOrigin = e;
                  },
                  dragStart: ps.dragStart(e, new Fi().dragStart([0, 0], t))
                }),
                S = c || Ol(e, "onResizeStart", C);
              return l.startFixedDirection = l.fixedDirection, l.startFixedPosition = l.fixedPosition, !1 !== S && (l.isResize = !0, e.state.snapRenderInfo = {
                request: t.isRequest,
                direction: d
              }), !!l.isResize && C;
            },
            dragControl: function (e, t) {
              var n,
                r = t.datas,
                o = t.parentFlag,
                i = t.isPinch,
                a = t.parentKeepRatio,
                s = t.dragClient,
                l = t.parentDist,
                u = t.useSnap,
                c = t.isRequest,
                d = t.isGroup,
                p = t.parentEvent,
                h = t.resolveMatrix,
                f = r.isResize,
                m = r.transformOrigin,
                g = r.startWidth,
                v = r.startHeight,
                y = r.prevWidth,
                b = r.prevHeight,
                w = r.minSize,
                x = r.maxSize,
                D = r.ratio,
                C = r.startOffsetWidth,
                S = r.startOffsetHeight,
                E = r.isWidth;
              if (f) {
                if (h) {
                  var _ = e.state.is3d,
                    P = r.startOffsetMatrix,
                    k = r.startTransformOrigin,
                    A = _ ? 4 : 3,
                    z = io(Qi(t)),
                    T = Math.sqrt(z.length);
                  A !== T && (z = Br(z, T, A));
                  var O = Zi(P, z, k, A),
                    I = ll(O, C, S, A);
                  r.startPositions = I, r.nextTargetMatrix = z, r.nextAllMatrix = O;
                }
                var F = ml(e.props, "resizable"),
                  M = F.resizeFormat,
                  R = F.throttleResize,
                  j = void 0 === R ? o ? 0 : 1 : R,
                  B = F.parentMoveable,
                  N = F.keepRatioFinally,
                  L = r.direction,
                  V = L,
                  K = 0,
                  q = 0;
                L[0] || L[1] || (V = [1, 1]);
                var H = D && (null != a ? a : F.keepRatio) || !1,
                  U = ni(oe(), 2),
                  Z = U[0],
                  $ = U[1];
                p || (r.setFixedDirection(r.fixedDirection), Ol(e, "onBeforeResize", Al(e, t, {
                  startFixedDirection: r.startFixedDirection,
                  startFixedPosition: r.startFixedPosition,
                  setFixedDirection: function (e) {
                    var t;
                    return r.setFixedDirection(e), t = ni(oe(), 2), Z = t[0], $ = t[1], [Z, $];
                  },
                  setFixedPosition: function (e) {
                    var t;
                    return r.setFixedPosition(e), t = ni(oe(), 2), Z = t[0], $ = t[1], [Z, $];
                  },
                  boundingWidth: Z,
                  boundingHeight: $,
                  setSize: function (e) {
                    var t;
                    t = ni(e, 2), Z = t[0], $ = t[1];
                  }
                }, !0)));
                var G = s;
                s || (G = !o && i ? function (e, t) {
                  return Ui(Sl(e.state), t);
                }(e, [0, 0]) : r.fixedPosition);
                var W = [0, 0];
                if (i || (W = function (e, t, n, r, o, i, a) {
                  if (!Fa(e, "resizable")) return [0, 0];
                  var s = a.fixedDirection,
                    l = a.nextAllMatrix,
                    u = e.state,
                    c = u.allMatrix,
                    d = u.is3d;
                  return js(e, function (e, r) {
                    return Fs(l || c, t + e, n + r, s, o, d);
                  }, t, n, r, o, i, a);
                }(e, Z, $, L, G, !u && c, r)), l && (!l[0] && (W[0] = 0), !l[1] && (W[1] = 0)), H) {
                  V[0] && V[1] && W[0] && W[1] && (nu(W[0]) > nu(W[1]) ? W[1] = 0 : W[0] = 0);
                  var Y = !W[0] && !W[1];
                  Y && ie(), V[0] && !V[1] || W[0] && !W[1] || Y && E ? (Z += W[0], $ = Z / D) : (!V[0] && V[1] || !W[0] && W[1] || Y && !E) && ($ += W[1], Z = $ * D);
                } else Z += W[0], $ += W[1], Z = Math.max(0, Z), $ = Math.max(0, $);
                n = ni(hr([Z, $], w, x, !!H && D), 2), Z = n[0], $ = n[1], ie(), H && (d || N) && (E ? $ = Z / D : Z = $ * D);
                var X = [(K = Z - C) - y, (q = $ - S) - b];
                r.prevWidth = K, r.prevHeight = q;
                var Q = oa(e, Z, $, G, m, r);
                if (B || !X.every(function (e) {
                  return !e;
                }) || !Q.every(function (e) {
                  return !e;
                })) {
                  var J = ps.drag(e, Ii(t, e.state, Q, !!i, !1, "draggable")),
                    ee = J.transform,
                    te = g + K,
                    ne = v + q,
                    re = Al(e, t, ti({
                      width: te,
                      height: ne,
                      offsetWidth: Math.round(Z),
                      offsetHeight: Math.round($),
                      startRatio: D,
                      boundingWidth: Z,
                      boundingHeight: $,
                      direction: L,
                      dist: [K, q],
                      delta: X,
                      isPinch: !!i,
                      drag: J
                    }, kl({
                      style: {
                        width: "".concat(te, "px"),
                        height: "".concat(ne, "px")
                      },
                      transform: ee
                    }, J, t)));
                  return !p && Ol(e, "onResize", re), re;
                }
              }
              function oe() {
                var e = r.fixedDirection,
                  n = Yl(V, H, r, t);
                K = n.distWidth, q = n.distHeight;
                var o = V[0] - e[0] || H ? Math.max(C + K, Ei) : C,
                  i = V[1] - e[1] || H ? Math.max(S + q, Ei) : S;
                return H && C && S && (E ? i = o / D : o = i * D), [o, i];
              }
              function ie() {
                var e;
                M && (e = ni(M([Z, $]), 2), Z = e[0], $ = e[1]), Z = yr(Z, j), $ = yr($, j);
              }
            },
            dragControlAfter: function (e, t) {
              var n = t.datas,
                r = n.isResize,
                o = n.startOffsetWidth,
                i = n.startOffsetHeight,
                a = n.prevWidth,
                s = n.prevHeight;
              if (r && !1 !== e.props.checkResizableError) {
                var l = e.state,
                  u = l.width - (o + a),
                  c = l.height - (i + s),
                  d = nu(u) > 3,
                  p = nu(c) > 3;
                return d && (n.startWidth += u, n.startOffsetWidth += u, n.prevWidth += u), p && (n.startHeight += c, n.startOffsetHeight += c, n.prevHeight += c), d || p ? this.dragControl(e, t) : void 0;
              }
            },
            dragControlEnd: function (e, t) {
              var n = t.datas,
                r = t.parentEvent;
              if (n.isResize) {
                n.isResize = !1;
                var o = zl(e, t, {});
                return !r && Ol(e, "onResizeEnd", o), o;
              }
            },
            dragGroupControlCondition: ms,
            dragGroupControlStart: function (e, t) {
              var n = t.datas,
                r = this.dragControlStart(e, ti(ti({}, t), {
                  isGroup: !0
                }));
              if (!r) return !1;
              var o = ha(e, "resizable", t),
                i = n.startOffsetWidth,
                a = n.startOffsetHeight;
              function s() {
                var e = n.minSize;
                o.forEach(function (t) {
                  var n = t.datas,
                    r = n.minSize,
                    o = n.startOffsetWidth,
                    s = n.startOffsetHeight,
                    l = i * (o ? r[0] / o : 0),
                    u = a * (s ? r[1] / s : 0);
                  e[0] = Math.max(e[0], l), e[1] = Math.max(e[1], u);
                });
              }
              function l() {
                var e = n.maxSize;
                o.forEach(function (t) {
                  var n = t.datas,
                    r = n.maxSize,
                    o = n.startOffsetWidth,
                    s = n.startOffsetHeight,
                    l = i * (o ? r[0] / o : 0),
                    u = a * (s ? r[1] / s : 0);
                  e[0] = Math.min(e[0], l), e[1] = Math.min(e[1], u);
                });
              }
              var u = ma(e, this, "dragControlStart", t, function (t, r) {
                return ga(e, t, n, r);
              });
              s(), l();
              var c = function (t) {
                r.setFixedDirection(t), u.forEach(function (r, i) {
                  r.setFixedDirection(t), ga(e, r.moveable, n, o[i]);
                });
              };
              n.setFixedDirection = c;
              var d = ti(ti({}, r), {
                  targets: e.props.targets,
                  events: u.map(function (e) {
                    return ti(ti({}, e), {
                      setMin: function (t) {
                        e.setMin(t), s();
                      },
                      setMax: function (t) {
                        e.setMax(t), l();
                      }
                    });
                  }),
                  setFixedDirection: c,
                  setMin: function (e) {
                    r.setMin(e), s();
                  },
                  setMax: function (e) {
                    r.setMax(e), l();
                  }
                }),
                p = Ol(e, "onResizeGroupStart", d);
              return n.isResize = !1 !== p, !!n.isResize && r;
            },
            dragGroupControl: function (e, t) {
              var n = t.datas;
              if (n.isResize) {
                var r = ml(e.props, "resizable");
                Tl(e, "onBeforeResize", function (n) {
                  Ol(e, "onBeforeResizeGroup", Al(e, t, ti(ti({}, n), {
                    targets: r.targets
                  }), !0));
                });
                var o = this.dragControl(e, ti(ti({}, t), {
                  isGroup: !0
                }));
                if (o) {
                  var i = o.boundingWidth,
                    a = o.boundingHeight,
                    s = o.dist,
                    l = r.keepRatio,
                    u = [i / (i - s[0]), a / (a - s[1])],
                    c = n.fixedPosition,
                    d = ma(e, this, "dragControl", t, function (t, n) {
                      var r = ni(Ur(Jr(e.rotation / 180 * Math.PI, 3), [n.datas.originalX * u[0], n.datas.originalY * u[1], 1], 3), 2),
                        o = r[0],
                        i = r[1];
                      return ti(ti({}, n), {
                        parentDist: null,
                        parentScale: u,
                        dragClient: Vr(c, [o, i]),
                        parentKeepRatio: l
                      });
                    }),
                    p = ti({
                      targets: r.targets,
                      events: d
                    }, o);
                  return Ol(e, "onResizeGroup", p), p;
                }
              }
            },
            dragGroupControlEnd: function (e, t) {
              var n = t.isDrag;
              if (t.datas.isResize) {
                this.dragControlEnd(e, t);
                var r = ma(e, this, "dragControlEnd", t);
                return Ol(e, "onResizeGroupEnd", zl(e, t, {
                  targets: e.props.targets,
                  events: r
                })), n;
              }
            },
            request: function (e) {
              var t = {},
                n = 0,
                r = 0,
                o = !1,
                i = e.getRect();
              return {
                isControl: !0,
                requestStart: function (e) {
                  var n;
                  return o = e.useSnap, {
                    datas: t,
                    parentDirection: e.direction || [1, 1],
                    parentIsWidth: null === (n = null == e ? void 0 : e.horizontal) || void 0 === n || n,
                    useSnap: o
                  };
                },
                request: function (e) {
                  return "offsetWidth" in e ? n = e.offsetWidth - i.offsetWidth : "deltaWidth" in e && (n += e.deltaWidth), "offsetHeight" in e ? r = e.offsetHeight - i.offsetHeight : "deltaHeight" in e && (r += e.deltaHeight), {
                    datas: t,
                    parentDist: [n, r],
                    parentKeepRatio: e.keepRatio,
                    useSnap: o
                  };
                },
                requestEnd: function () {
                  return {
                    datas: t,
                    isDrag: !0,
                    useSnap: o
                  };
                }
              };
            },
            unset: function (e) {
              e.state.gestos.resizable = null;
            }
          };
        function vs(e, t, n, r, o) {
          var i = e.props.groupable,
            a = e.state,
            s = a.is3d ? 4 : 3,
            l = t.origin,
            u = sl(e.state.rootMatrix, Kr([l[0], l[1]], i ? [0, 0] : [a.left, a.top]), s),
            c = Vr([o.left, o.top], u);
          t.startAbsoluteOrigin = c, t.prevDeg = mr(c, [n, r]) / Math.PI * 180, t.defaultDeg = t.prevDeg, t.prevSnapDeg = 0, t.loop = 0, t.startDist = vr(c, [n, r]);
        }
        function ys(e, t, n) {
          var r = n.defaultDeg,
            o = n.prevDeg,
            i = o % 360,
            a = Math.floor(o / 360);
          i < 0 && (i += 360), i > e && i > 270 && e < 90 ? ++a : i < e && i < 90 && e > 270 && --a;
          var s = t * (360 * a + e - r);
          return n.prevDeg = r + s, s;
        }
        function bs(e, t, n, r) {
          return ys(mr(r.startAbsoluteOrigin, [e, t]) / Math.PI * 180, n, r);
        }
        function ws(e, t, n, r, o, i) {
          var a = e.props.throttleRotate,
            s = void 0 === a ? 0 : a,
            l = n.prevSnapDeg,
            u = 0,
            c = !1;
          if (i) {
            var d = function (e, t, n, r) {
              var o,
                i = e.props,
                a = null !== (o = i.snapRotationThreshold) && void 0 !== o ? o : 5,
                s = i.snapRotationDegrees;
              if (Fa(e, "rotatable")) {
                var l = t.pos1,
                  u = t.pos2,
                  c = t.pos3,
                  d = t.pos4,
                  p = t.origin,
                  h = n * Math.PI / 180,
                  f = [l, u, c, d].map(function (e) {
                    return Kr(e, p);
                  }),
                  m = f.map(function (e) {
                    return Yr(e, h);
                  }),
                  g = ri(ri([], ni(ka(e, f, m, p, n)), !1), ni(is(e, f, m, p, n)), !1);
                g.sort(function (e, t) {
                  return nu(e - n) - nu(t - n);
                });
                var v = g.length > 0;
                if (v) return {
                  isSnap: v,
                  dist: v ? g[0] : n
                };
              }
              if ((null == s ? void 0 : s.length) && a) {
                var y = s.slice().sort(function (e, t) {
                    return Ls(e, r) - Ls(t, r);
                  }),
                  b = y[0];
                if (Ls(b, r) <= a) return {
                  isSnap: !0,
                  dist: n + Ns(r, b) - r
                };
              }
              return {
                isSnap: !1,
                dist: n
              };
            }(e, t, r, o + r);
            c = d.isSnap, u = o + d.dist;
          }
          c || (u = yr(o + r, s));
          var p = u - o;
          return n.prevSnapDeg = p, [p - l, p, u];
        }
        function xs(e, t, n) {
          var r = ni(t, 4),
            o = r[0],
            i = r[1],
            a = r[2],
            s = r[3];
          if ("none" === e) return [];
          if ($n(e)) return e.map(function (e) {
            return xs(e, [o, i, a, s], n)[0];
          });
          var l = ni((e || "top").split("-"), 2),
            u = l[0],
            c = l[1],
            d = [o, i];
          "left" === u ? d = [a, o] : "right" === u ? d = [i, s] : "bottom" === u && (d = [s, a]);
          var p = [(d[0][0] + d[1][0]) / 2, (d[0][1] + d[1][1]) / 2],
            h = vl(d, n);
          if (c) {
            var f = "top" === c || "left" === c,
              m = "bottom" === u || "left" === u;
            p = d[f && !m || !f && m ? 0 : 1];
          }
          return [[p, h]];
        }
        function Ds(e, t) {
          if (t.isRequest) return "rotatable" === t.requestAble;
          var n = t.inputEvent.target;
          if (wr(n, Zs("rotation-control")) || e.props.rotateAroundControls && wr(n, Zs("around-control")) || wr(n, Zs("control")) && wr(n, Zs("rotatable"))) return !0;
          var r = e.props.rotationTarget;
          return !!r && $l(r, !0).some(function (e) {
            return !!e && (n === e || n.contains(e));
          });
        }
        var Cs = {
          name: "rotatable",
          canPinch: !0,
          props: ["rotatable", "rotationPosition", "throttleRotate", "renderDirections", "rotationTarget", "rotateAroundControls", "edge", "resolveAblesWithRotatable", "displayAroundControls"],
          events: ["rotateStart", "beforeRotate", "rotate", "rotateEnd", "rotateGroupStart", "beforeRotateGroup", "rotateGroup", "rotateGroupEnd"],
          css: [".rotation {\nposition: absolute;\nheight: 40px;\nwidth: 1px;\ntransform-origin: 50% 100%;\nheight: calc(40px * var(--zoom));\ntop: auto;\nleft: 0;\nbottom: 100%;\nwill-change: transform;\n}\n.rotation .rotation-line {\ndisplay: block;\nwidth: 100%;\nheight: 100%;\ntransform-origin: 50% 50%;\n}\n.rotation .rotation-control {\nborder-color: #4af;\nborder-color: var(--moveable-color);\nbackground:#fff;\ncursor: alias;\n}\n:global .view-rotation-dragging, .rotatable.direction.control {\ncursor: alias;\n}\n.rotatable.direction.control.move {\ncursor: move;\n}\n"],
          viewClassName: function (e) {
            return e.isDragging("rotatable") ? Zs("view-rotation-dragging") : "";
          },
          render: function (e, t) {
            var n = ml(e.props, "rotatable"),
              r = n.rotatable,
              o = n.rotationPosition,
              i = n.zoom,
              a = n.renderDirections,
              s = n.rotateAroundControls,
              l = n.resolveAblesWithRotatable,
              u = e.getState(),
              c = u.renderPoses,
              d = u.direction;
            if (!r) return null;
            var p = xs(o, c, d),
              h = [];
            if (p.forEach(function (e, n) {
              var r = ni(e, 2),
                o = r[0],
                a = r[1];
              h.push(t.createElement("div", {
                key: "rotation".concat(n),
                className: Zs("rotation"),
                style: {
                  transform: "translate(-50%) translate(".concat(o[0], "px, ").concat(o[1], "px) rotate(").concat(a, "rad)")
                }
              }, t.createElement("div", {
                className: Zs("line rotation-line"),
                style: {
                  transform: "scaleX(".concat(i, ")")
                }
              }), t.createElement("div", {
                className: Zs("control rotation-control"),
                style: {
                  transform: "translate(0.5px) scale(".concat(i, ")")
                }
              })));
            }), a) {
              var f = ur(l || {}),
                m = {};
              f.forEach(function (e) {
                l[e].forEach(function (t) {
                  m[t] = e;
                });
              });
              var g = [];
              $n(a) && (g = a.map(function (e) {
                var t = m[e];
                return {
                  data: t ? {
                    resolve: t
                  } : {},
                  classNames: t ? ["move"] : [],
                  dir: e
                };
              })), h.push.apply(h, ri([], ni(va(e, "rotatable", g, t)), !1));
            }
            return s && h.push.apply(h, ri([], ni(Ca(e, t)), !1)), h;
          },
          dragControlCondition: Ds,
          dragControlStart: function (e, t) {
            var n,
              r,
              o = t.datas,
              i = t.clientX,
              a = t.clientY,
              s = t.parentRotate,
              l = t.parentFlag,
              u = t.isPinch,
              c = t.isRequest,
              d = e.state,
              p = d.target,
              h = d.left,
              f = d.top,
              m = d.direction,
              g = d.beforeDirection,
              v = d.targetTransform,
              y = d.moveableClientRect,
              b = d.offsetMatrix,
              w = d.targetMatrix,
              x = d.allMatrix,
              D = d.width,
              C = d.height;
            if (!c && !p) return !1;
            var S = e.getRect();
            o.rect = S, o.transform = v, o.left = h, o.top = f;
            var E = function (t) {
                var n = fs(e.state, t);
                o.fixedDirection = n.fixedDirection, o.fixedOffset = n.fixedOffset, o.fixedPosition = n.fixedPosition, j && j.setFixedPosition(t);
              },
              _ = function (t) {
                var n = function (e, t) {
                  var n = e.allMatrix,
                    r = e.is3d,
                    o = e.width,
                    i = e.height,
                    a = r ? 4 : 3;
                  return {
                    fixedPosition: sl(n, [o / 2 * (1 + t[0]), i / 2 * (1 + t[1])], a),
                    fixedDirection: t,
                    fixedOffset: [0, 0]
                  };
                }(e.state, t);
                o.fixedDirection = n.fixedDirection, o.fixedOffset = n.fixedOffset, o.fixedPosition = n.fixedPosition, j && j.setFixedDirection(t);
              },
              P = i,
              k = a;
            if (c || u || l) {
              var A = s || 0;
              o.beforeInfo = {
                origin: S.beforeOrigin,
                prevDeg: A,
                defaultDeg: A,
                prevSnapDeg: 0,
                startDist: 0
              }, o.afterInfo = ti(ti({}, o.beforeInfo), {
                origin: S.origin
              }), o.absoluteInfo = ti(ti({}, o.beforeInfo), {
                origin: S.origin,
                startValue: A
              });
            } else {
              var z = null === (r = t.inputEvent) || void 0 === r ? void 0 : r.target;
              if (z) {
                var T = z.getAttribute("data-direction") || "",
                  O = Ai[T];
                if (O) {
                  o.isControl = !0, o.isAroundControl = wr(z, Zs("around-control")), o.controlDirection = O;
                  var I = z.getAttribute("data-resolve");
                  I && (o.resolveAble = I);
                  var F = function (e, t, n) {
                    var r = 16 === e.length ? 4 : 3,
                      o = t.map(function (t) {
                        return sl(e, t, r);
                      }),
                      i = n.left,
                      a = n.top;
                    return o.map(function (e) {
                      return [e[0] + i, e[1] + a];
                    });
                  }(d.rootMatrix, d.renderPoses, y);
                  n = ni(Ui(F, O), 2), P = n[0], k = n[1];
                }
              }
              o.beforeInfo = {
                origin: S.beforeOrigin
              }, o.afterInfo = {
                origin: S.origin
              }, o.absoluteInfo = {
                origin: S.origin,
                startValue: S.rotation
              };
              var M = E;
              E = function (t) {
                var n = d.is3d ? 4 : 3,
                  r = ni(Vr(Rr(w, n), t), 2),
                  i = r[0],
                  a = r[1],
                  s = Ur(b, jr([i, a], n)),
                  l = Ur(x, jr([t[0], t[1]], n));
                M(t);
                var u = d.posDelta;
                o.beforeInfo.origin = Kr(s, u), o.afterInfo.origin = Kr(l, u), o.absoluteInfo.origin = Kr(l, u), vs(e, o.beforeInfo, P, k, y), vs(e, o.afterInfo, P, k, y), vs(e, o.absoluteInfo, P, k, y);
              }, _ = function (e) {
                var t = Ui([[0, 0], [D, 0], [0, C], [D, C]], e);
                E(t);
              };
            }
            o.startClientX = P, o.startClientY = k, o.direction = m, o.beforeDirection = g, o.startValue = 0, o.datas = {}, Gi(e, t, "rotate");
            var R = !1,
              j = !1;
            o.isControl && o.resolveAble && "resizable" === o.resolveAble && (j = gs.dragControlStart(e, ti(ti({}, new Fi("resizable").dragStart([0, 0], t)), {
              parentPosition: o.controlPosition,
              parentFixedPosition: o.fixedPosition
            })));
            j || (R = ps.dragStart(e, new Fi().dragStart([0, 0], t))), E(function (e) {
              var t = e.props,
                n = t.groupable,
                r = t.svgOrigin,
                o = e.getState(),
                i = o.offsetWidth,
                a = o.offsetHeight,
                s = o.svg,
                l = o.transformOrigin;
              if (!n && s && r) return Ql(r, i, a);
              return l;
            }(e));
            var B = Al(e, t, ti(ti({
                set: function (e) {
                  o.startValue = e * Math.PI / 180;
                },
                setFixedDirection: _,
                setFixedPosition: E
              }, $i(e, t)), {
                dragStart: R,
                resizeStart: j
              })),
              N = Ol(e, "onRotateStart", B);
            return o.isRotate = !1 !== N, d.snapRenderInfo = {
              request: t.isRequest
            }, !!o.isRotate && B;
          },
          dragControl: function (e, t) {
            var n,
              r,
              o,
              i = t.datas,
              a = t.clientDistX,
              s = t.clientDistY,
              l = t.parentRotate,
              u = t.parentFlag,
              c = t.isPinch,
              d = t.groupDelta,
              p = t.resolveMatrix,
              h = i.beforeDirection,
              f = i.beforeInfo,
              m = i.afterInfo,
              g = i.absoluteInfo,
              v = i.isRotate,
              y = i.startValue,
              b = i.rect,
              w = i.startClientX,
              x = i.startClientY;
            if (v) {
              ji(e, t, "rotate");
              var D,
                C,
                S,
                E,
                _,
                P,
                k,
                A,
                z,
                T = function (e) {
                  return Mi(e.datas.beforeTransform, [50, 50], 100, 100).direction;
                }(t),
                O = h * T,
                I = e.props.parentMoveable,
                F = 180 / Math.PI * y,
                M = g.startValue,
                R = !1,
                j = w + a,
                B = x + s;
              if (!u && "parentDist" in t) {
                var N = t.parentDist;
                C = N, _ = N, A = N;
              } else c || u ? (C = ys(l, h, f), _ = ys(l, O, m), A = ys(l, O, g)) : (C = bs(j, B, h, f), _ = bs(j, B, O, m), A = bs(j, B, O, g), R = !0);
              if (Ol(e, "onBeforeRotate", Al(e, t, {
                beforeRotation: S = F + C,
                rotation: P = F + _,
                absoluteRotation: z = M + A,
                setRotation: function (e) {
                  C = _ = e - F, A = _;
                }
              }, !0)), D = (n = ni(ws(e, b, f, C, F, R), 3))[0], C = n[1], S = n[2], E = (r = ni(ws(e, b, m, _, F, R), 3))[0], _ = r[1], P = r[2], k = (o = ni(ws(e, b, g, A, M, R), 3))[0], A = o[1], z = o[2], k || E || D || I || p) {
                var L = Bi(i, "rotate(".concat(P, "deg)"), "rotate(".concat(_, "deg)"));
                p && (i.fixedPosition = na(e, i.targetAllTransform, i.fixedDirection, i.fixedOffset, i));
                var V = function (e, t, n) {
                    var r = n.fixedDirection,
                      o = n.fixedPosition,
                      i = n.fixedOffset;
                    return ra(e, "rotate(".concat(t, "deg)"), r, o, i, n);
                  }(e, _, i),
                  K = Kr(Vr(d || [0, 0], V), i.prevInverseDist || [0, 0]);
                i.prevInverseDist = V, i.requestValue = null;
                var q = ta(e, L, K, c, t),
                  H = q,
                  U = vr([j, B], g.startAbsoluteOrigin) - g.startDist,
                  Z = void 0;
                if ("resizable" === i.resolveAble) {
                  var $ = gs.dragControl(e, ti(ti({}, Ii(t, e.state, [t.deltaX, t.deltaY], !!c, !1, "resizable")), {
                    resolveMatrix: !0,
                    parentDistance: U
                  }));
                  $ && (Z = $, H = kl(H, $, t));
                }
                var G = Al(e, t, ti(ti({
                  delta: E,
                  dist: _,
                  rotate: P,
                  rotation: P,
                  beforeDist: C,
                  beforeDelta: D,
                  beforeRotate: S,
                  beforeRotation: S,
                  absoluteDist: A,
                  absoluteDelta: k,
                  absoluteRotate: z,
                  absoluteRotation: z,
                  isPinch: !!c,
                  resize: Z
                }, q), H));
                return Ol(e, "onRotate", G), G;
              }
            }
          },
          dragControlEnd: function (e, t) {
            var n = t.datas;
            if (n.isRotate) {
              n.isRotate = !1;
              var r = zl(e, t, {});
              return Ol(e, "onRotateEnd", r), r;
            }
          },
          dragGroupControlCondition: Ds,
          dragGroupControlStart: function (e, t) {
            var n = t.datas,
              r = e.state,
              o = r.left,
              i = r.top,
              a = r.beforeOrigin,
              s = this.dragControlStart(e, t);
            if (!s) return !1;
            s.set(n.beforeDirection * e.rotation);
            var l = ma(e, this, "dragControlStart", t, function (e, t) {
                var n = e.state,
                  r = n.left,
                  s = n.top,
                  l = n.beforeOrigin,
                  u = Vr(Kr([r, s], [o, i]), Kr(l, a));
                return t.datas.startGroupClient = u, t.datas.groupClient = u, ti(ti({}, t), {
                  parentRotate: 0
                });
              }),
              u = Ol(e, "onRotateGroupStart", ti(ti({}, s), {
                targets: e.props.targets,
                events: l
              }));
            return n.isRotate = !1 !== u, !!n.isRotate && s;
          },
          dragGroupControl: function (e, t) {
            var n = t.datas;
            if (n.isRotate) {
              Tl(e, "onBeforeRotate", function (n) {
                Ol(e, "onBeforeRotateGroup", Al(e, t, ti(ti({}, n), {
                  targets: e.props.targets
                }), !0));
              });
              var r = this.dragControl(e, t);
              if (r) {
                var o = n.beforeDirection,
                  i = r.beforeDist,
                  a = i / 180 * Math.PI,
                  s = ma(e, this, "dragControl", t, function (e, t) {
                    var n = t.datas.startGroupClient,
                      r = ni(t.datas.groupClient, 2),
                      s = r[0],
                      l = r[1],
                      u = ni(Yr(n, a * o), 2),
                      c = u[0],
                      d = u[1],
                      p = [c - s, d - l];
                    return t.datas.groupClient = [c, d], ti(ti({}, t), {
                      parentRotate: i,
                      groupDelta: p
                    });
                  });
                e.rotation = o * r.beforeRotation;
                var l = ti({
                  targets: e.props.targets,
                  events: s,
                  set: function (t) {
                    e.rotation = t;
                  },
                  setGroupRotation: function (t) {
                    e.rotation = t;
                  }
                }, r);
                return Ol(e, "onRotateGroup", l), l;
              }
            }
          },
          dragGroupControlEnd: function (e, t) {
            var n = t.isDrag;
            if (t.datas.isRotate) {
              this.dragControlEnd(e, t);
              var r = ma(e, this, "dragControlEnd", t);
              return Ol(e, "onRotateGroupEnd", zl(e, t, {
                targets: e.props.targets,
                events: r
              })), n;
            }
          },
          request: function (e) {
            var t = {},
              n = 0,
              r = e.getRotation();
            return {
              isControl: !0,
              requestStart: function () {
                return {
                  datas: t
                };
              },
              request: function (e) {
                return "deltaRotate" in e ? n += e.deltaRotate : "rotate" in e && (n = e.rotate - r), {
                  datas: t,
                  parentDist: n
                };
              },
              requestEnd: function () {
                return {
                  datas: t,
                  isDrag: !0
                };
              }
            };
          }
        };
        function Ss(e, t) {
          return function (e, t) {
            var n,
              r = e.direction,
              o = e.classNames,
              i = e.size,
              a = e.pos,
              s = e.zoom,
              l = e.key,
              u = "horizontal" === r,
              c = u ? "Y" : "X";
            return t.createElement("div", {
              key: l,
              className: o.join(" "),
              style: (n = {}, n[u ? "width" : "height"] = "".concat(i), n.transform = "translate(".concat(a[0], ", ").concat(a[1], ") translate").concat(c, "(-50%) scale").concat(c, "(").concat(s, ")"), n)
            });
          }(ti(ti({}, e), {
            classNames: ri([Zs("line", "guideline", e.direction)], ni(e.classNames), !1).filter(function (e) {
              return e;
            }),
            size: e.size || "".concat(e.sizeValue, "px"),
            pos: e.pos || e.posValue.map(function (e) {
              return "".concat(yr(e, .1), "px");
            })
          }), t);
        }
        function Es(e, t, n, r, o, i, a, s) {
          var l = e.props.zoom;
          return n.map(function (e, n) {
            var u = e.type,
              c = e.pos,
              d = [0, 0];
            return d[a] = r, d[a ? 0 : 1] = -o + c, Ss({
              key: "".concat(t, "TargetGuideline").concat(n),
              classNames: [Zs("target", "bold", u)],
              posValue: d,
              sizeValue: i,
              zoom: l,
              direction: t
            }, s);
          });
        }
        function _s(e, t, n, r, o, i) {
          var a = e.props,
            s = a.zoom,
            l = a.isDisplayInnerSnapDigit,
            u = "horizontal" === t ? Oa : Ia,
            c = o[u.start],
            d = o[u.end];
          return n.filter(function (e) {
            var t = e.hide,
              n = e.elementRect;
            if (t) return !1;
            if (l && n) {
              var r = n.rect;
              if (r[u.start] <= c && d <= r[u.end]) return !1;
            }
            return !0;
          }).map(function (e, n) {
            var o = e.pos,
              a = e.size,
              l = e.element,
              u = e.className,
              c = [-r[0] + o[0], -r[1] + o[1]];
            return Ss({
              key: "".concat(t, "-default-guideline-").concat(n),
              classNames: l ? [Zs("bold"), u] : [Zs("normal"), u],
              direction: t,
              posValue: c,
              sizeValue: a,
              zoom: s
            }, i);
          });
        }
        function Ps(e, t, n, r, o, i, a, s) {
          var l,
            u = e.props,
            c = u.snapDigit,
            d = void 0 === c ? 0 : c,
            p = u.isDisplaySnapDigit,
            h = void 0 === p || p,
            f = u.snapDistFormat,
            m = void 0 === f ? function (e, t) {
              return e;
            } : f,
            g = u.zoom,
            v = "horizontal" === t ? "X" : "Y",
            y = "vertical" === t ? "height" : "width",
            b = Math.abs(o),
            w = h ? parseFloat(b.toFixed(d)) : 0;
          return s.createElement("div", {
            key: "".concat(t, "-").concat(n, "-guideline-").concat(r),
            className: Zs("guideline-group", t),
            style: (l = {
              left: "".concat(i[0], "px"),
              top: "".concat(i[1], "px")
            }, l[y] = "".concat(b, "px"), l)
          }, Ss({
            direction: t,
            classNames: [Zs(n), a],
            size: "100%",
            posValue: [0, 0],
            sizeValue: b,
            zoom: g
          }, s), s.createElement("div", {
            className: Zs("size-value", "gap"),
            style: {
              transform: "translate".concat(v, "(-50%) scale(").concat(g, ")")
            }
          }, w > 0 ? m(w, t) : ""));
        }
        function ks(e, t, n, r, o) {
          var i = e.props.isDisplayInnerSnapDigit,
            a = [];
          return ["vertical", "horizontal"].forEach(function (s) {
            var l = t.filter(function (e) {
                return e.type === s;
              }),
              u = "vertical" === s ? 1 : 0,
              c = u ? 0 : 1,
              d = function (e, t, n, r) {
                var o = "vertical" === e ? 0 : 1,
                  i = "vertical" === e ? 1 : 0,
                  a = o ? Oa : Ia,
                  s = n[a.start],
                  l = n[a.end];
                return jl(t, function (e) {
                  return e.pos[o];
                }).map(function (t) {
                  var n = [],
                    u = [];
                  return t.forEach(function (t) {
                    var c,
                      d,
                      p = t.element,
                      h = t.elementRect.rect;
                    if (h[a.end] < s) n.push(t);else if (l < h[a.start]) u.push(t);else if (h[a.start] <= s && l <= h[a.end] && r) {
                      var f = t.pos,
                        m = {
                          element: p,
                          rect: ti(ti({}, h), (c = {}, c[a.end] = h[a.start], c))
                        },
                        g = {
                          element: p,
                          rect: ti(ti({}, h), (d = {}, d[a.start] = h[a.end], d))
                        },
                        v = [0, 0],
                        y = [0, 0];
                      v[o] = f[o], v[i] = f[i], y[o] = f[o], y[i] = f[i] + t.size, n.push({
                        type: e,
                        pos: v,
                        size: 0,
                        elementRect: m,
                        direction: "",
                        elementDirection: "end"
                      }), u.push({
                        type: e,
                        pos: y,
                        size: 0,
                        elementRect: g,
                        direction: "",
                        elementDirection: "start"
                      });
                    }
                  }), n.sort(function (e, t) {
                    return t.pos[i] - e.pos[i];
                  }), u.sort(function (e, t) {
                    return e.pos[i] - t.pos[i];
                  }), {
                    total: t,
                    start: n,
                    end: u,
                    inner: []
                  };
                });
              }(s, l, r, i),
              p = u ? Ia : Oa,
              h = u ? Oa : Ia,
              f = r[p.start],
              m = r[p.end];
            d.forEach(function (t) {
              var i = t.total,
                l = t.start,
                d = t.end,
                g = t.inner,
                v = n[c] + i[0].pos[c] - r[h.start],
                y = r;
              l.forEach(function (t) {
                var r = t.elementRect.rect,
                  i = y[p.start] - r[p.end];
                if (i > 0) {
                  var l = [0, 0];
                  l[u] = n[u] + y[p.start] - f - i, l[c] = v, a.push(Ps(e, s, "dashed", a.length, i, l, t.className, o));
                }
                y = r;
              }), y = r, d.forEach(function (t) {
                var r = t.elementRect.rect,
                  i = r[p.start] - y[p.end];
                if (i > 0) {
                  var l = [0, 0];
                  l[u] = n[u] + y[p.end] - f, l[c] = v, a.push(Ps(e, s, "dashed", a.length, i, l, t.className, o));
                }
                y = r;
              }), g.forEach(function (t) {
                var r = t.elementRect.rect,
                  i = f - r[p.start],
                  l = r[p.end] - m,
                  d = [0, 0],
                  h = [0, 0];
                d[u] = n[u] - i, d[c] = v, h[u] = n[u] + m - f, h[c] = v, a.push(Ps(e, s, "dashed", a.length, i, d, t.className, o)), a.push(Ps(e, s, "dashed", a.length, l, h, t.className, o));
              });
            });
          }), a;
        }
        function As(e) {
          var t,
            n,
            r = e.state,
            o = r.containerClientRect,
            i = r.hasFixed,
            a = o.overflow,
            s = o.scrollHeight,
            l = o.scrollWidth,
            u = o.clientHeight,
            c = o.clientWidth,
            d = o.clientLeft,
            p = o.clientTop,
            h = e.props,
            f = h.snapGap,
            m = void 0 === f || f,
            g = h.verticalGuidelines,
            v = h.horizontalGuidelines,
            y = h.snapThreshold,
            b = void 0 === y ? 5 : y,
            w = h.maxSnapElementGuidelineDistance,
            x = void 0 === w ? 1 / 0 : w,
            D = h.isDisplayGridGuidelines,
            C = ul(Sl(e.state)),
            S = C.top,
            E = C.left,
            _ = C.bottom,
            P = C.right,
            k = {
              top: S,
              left: E,
              bottom: _,
              right: P,
              center: (E + P) / 2,
              middle: (S + _) / 2
            },
            A = function (e) {
              var t = e.state,
                n = e.props.elementGuidelines,
                r = void 0 === n ? [] : n;
              if (!r.length) return t.elementRects = [], [];
              var o = (t.elementRects || []).filter(function (e) {
                  return !e.refresh;
                }),
                i = r.map(function (e) {
                  return Zn(e) && "element" in e ? ti(ti({}, e), {
                    element: Zl(e.element, !0)
                  }) : {
                    element: Zl(e, !0)
                  };
                }).filter(function (e) {
                  return e.element;
                }),
                a = function (e, t) {
                  return fo(e, t, yo);
                }(o.map(function (e) {
                  return e.element;
                }), i.map(function (e) {
                  return e.element;
                })),
                s = a.maintained,
                l = a.added,
                u = [];
              s.forEach(function (e) {
                var t = ni(e, 2),
                  n = t[0],
                  r = t[1];
                u[r] = o[n];
              }), function (e, t) {
                if (!t.length) return [];
                var n = e.props.groupable,
                  r = e.state,
                  o = r.containerClientRect,
                  i = r.rootMatrix,
                  a = r.is3d,
                  s = r.offsetDelta,
                  l = a ? 4 : 3,
                  u = ni(function (e, t, n) {
                    var r = sl(e, [t.clientLeft, t.clientTop], n);
                    return [t.left + r[0], t.top + r[1]];
                  }(i, o, l), 2),
                  c = u[0],
                  d = u[1],
                  p = n ? 0 : s[0],
                  h = n ? 0 : s[1];
                return t.map(function (e) {
                  var t = e.element.getBoundingClientRect(),
                    n = t.left - c - p,
                    r = t.top - d - h,
                    o = r + t.height,
                    a = n + t.width,
                    s = ni(Ll(i, [n, r], l), 2),
                    u = s[0],
                    f = s[1],
                    m = ni(Ll(i, [a, o], l), 2),
                    g = m[0],
                    v = m[1];
                  return ti(ti({}, e), {
                    rect: {
                      left: u,
                      right: g,
                      top: f,
                      bottom: v,
                      center: (u + g) / 2,
                      middle: (f + v) / 2
                    }
                  });
                });
              }(e, l.map(function (e) {
                return i[e];
              })).map(function (e, t) {
                u[l[t]] = e;
              }), t.elementRects = u;
              var c = Ma(e.props.elementSnapDirections),
                d = [];
              return u.forEach(function (e) {
                var t = e.element,
                  n = e.top,
                  r = void 0 === n ? c.top : n,
                  o = e.left,
                  i = void 0 === o ? c.left : o,
                  a = e.right,
                  s = void 0 === a ? c.right : a,
                  l = e.bottom,
                  u = void 0 === l ? c.bottom : l,
                  p = e.center,
                  h = void 0 === p ? c.center : p,
                  f = e.middle,
                  m = void 0 === f ? c.middle : f,
                  g = e.className,
                  v = e.rect,
                  y = Ra({
                    top: r,
                    right: s,
                    left: i,
                    bottom: u,
                    center: h,
                    middle: m
                  }, v),
                  b = y.horizontal,
                  w = y.vertical,
                  x = y.horizontalNames,
                  D = y.verticalNames,
                  C = v.top,
                  S = v.left,
                  E = v.right - S,
                  _ = v.bottom - C,
                  P = [E, _];
                w.forEach(function (n, r) {
                  d.push({
                    type: "vertical",
                    element: t,
                    pos: [yr(n, .1), C],
                    size: _,
                    sizes: P,
                    className: g,
                    elementRect: e,
                    elementDirection: Ta[D[r]] || D[r],
                    direction: ""
                  });
                }), b.forEach(function (n, r) {
                  d.push({
                    type: "horizontal",
                    element: t,
                    pos: [S, yr(n, .1)],
                    size: E,
                    sizes: P,
                    className: g,
                    elementRect: e,
                    elementDirection: Ta[x[r]] || x[r],
                    direction: ""
                  });
                });
              }), d;
            }(e),
            z = ri([], ni(A), !1),
            T = (null !== (n = null === (t = r.snapThresholdInfo) || void 0 === t ? void 0 : t.multiples) && void 0 !== n ? n : [1, 1]).map(function (e) {
              return e * b;
            });
          m && z.push.apply(z, ri([], ni(function (e, t, n) {
            var r = e.props,
              o = r.maxSnapElementGuidelineDistance,
              i = void 0 === o ? 1 / 0 : o,
              a = r.maxSnapElementGapDistance,
              s = void 0 === a ? 1 / 0 : a,
              l = e.state.elementRects,
              u = [];
            return [["vertical", Oa, Ia], ["horizontal", Ia, Oa]].forEach(function (e) {
              var r = ni(e, 3),
                o = r[0],
                a = r[1],
                c = r[2],
                d = t[a.start],
                p = t[a.end],
                h = t[a.center],
                f = t[c.start],
                m = t[c.end],
                g = {
                  left: n[0],
                  top: n[1]
                };
              function v(e) {
                var t = e.rect,
                  n = g[a.start];
                return t[a.end] < d + n ? d - t[a.end] : p - n < t[a.start] ? t[a.start] - p : -1;
              }
              var y = l.filter(function (e) {
                  var t = e.rect;
                  return !(t[c.start] > m || t[c.end] < f) && v(e) > 0;
                }).sort(function (e, t) {
                  return v(e) - v(t);
                }),
                b = [];
              y.forEach(function (e) {
                y.forEach(function (t) {
                  if (e !== t) {
                    var n = e.rect,
                      r = t.rect,
                      o = n[c.start],
                      i = n[c.end],
                      a = r[c.start];
                    o > r[c.end] || a > i || b.push([e, t]);
                  }
                });
              }), b.forEach(function (e) {
                var n = ni(e, 2),
                  r = n[0],
                  l = n[1],
                  c = r.rect,
                  f = l.rect,
                  m = c[a.start],
                  v = c[a.end],
                  y = f[a.start],
                  b = f[a.end],
                  w = g[a.start],
                  x = 0,
                  D = 0,
                  C = !1,
                  S = !1,
                  E = !1;
                if (v <= d && p <= y) {
                  if (S = !0, nu((D = v + (x = (y - v - (p - d)) / 2) + (p - d) / 2) - h) > w) return;
                } else if (v < y && b < d + w) {
                  if (C = !0, nu((D = b + (x = y - v)) - d) > w) return;
                } else {
                  if (!(v < y && p - w < m)) return;
                  if (E = !0, nu((D = m - (x = y - v)) - p) > w) return;
                }
                x && zs(t, f, o, i) && (x > s || u.push({
                  type: o,
                  pos: "vertical" === o ? [D, 0] : [0, D],
                  element: l.element,
                  size: 0,
                  className: l.className,
                  isStart: C,
                  isCenter: S,
                  isEnd: E,
                  gap: x,
                  hide: !0,
                  gapRects: [r, l],
                  direction: "",
                  elementDirection: ""
                }));
              });
            }), u;
          }(e, k, T)), !1));
          var O = ti({}, r.snapOffset || {
            left: 0,
            top: 0,
            bottom: 0,
            right: 0
          });
          if (z.push.apply(z, ri([], ni(function (e, t, n, r, o, i, a) {
            void 0 === r && (r = 0);
            void 0 === o && (o = 0);
            var s = e.props,
              l = e.state,
              u = s.snapGridWidth,
              c = void 0 === u ? 0 : u,
              d = s.snapGridHeight,
              p = void 0 === d ? 0 : d,
              h = [],
              f = i.left,
              m = i.top,
              g = [0, 0];
            !function (e, t, n, r) {
              var o,
                i,
                a = e.props,
                s = e.state,
                l = a.snapGridAll,
                u = a.snapGridWidth,
                c = void 0 === u ? 0 : u,
                d = a.snapGridHeight,
                p = void 0 === d ? 0 : d,
                h = s.snapRenderInfo,
                f = h && ((null === (o = h.direction) || void 0 === o ? void 0 : o[0]) || (null === (i = h.direction) || void 0 === i ? void 0 : i[1])),
                m = e.moveables;
              if (l && m && f && (c || p)) {
                if (s.snapThresholdInfo) return;
                s.snapThresholdInfo = {
                  multiples: [1, 1],
                  offset: [0, 0]
                };
                var g = e.getRect(),
                  v = g.children,
                  y = h.direction;
                if (v) {
                  var b = y.map(function (e, o) {
                      var i = 0 === o ? {
                          snapSize: c,
                          posName: "left",
                          sizeName: "width",
                          clientOffset: r.left - t
                        } : {
                          snapSize: p,
                          posName: "top",
                          sizeName: "height",
                          clientOffset: r.top - n
                        },
                        a = i.snapSize,
                        s = i.posName,
                        l = i.sizeName,
                        u = i.clientOffset;
                      if (!a) return {
                        dir: e,
                        multiple: 1,
                        snapSize: a,
                        snapOffset: 0
                      };
                      var d,
                        h = g[l],
                        f = g[s],
                        m = (d = v.map(function (e) {
                          return [e[s] - f, e[l], h - e[l] - e[s] + f];
                        }), d.reduce(function (e, t) {
                          return e.concat(t);
                        }, [])).filter(function (e) {
                          return e;
                        }).sort(function (e, t) {
                          return e - t;
                        }),
                        y = m[0],
                        b = m.map(function (e) {
                          return yr(e / y, .1) * a;
                        }),
                        w = 1,
                        x = yr(h / y, .1);
                      for (w = 1; w <= 10 && !b.every(function (e) {
                        return e * w % 1 == 0;
                      }); ++w);
                      var D = (1 - e) / 2,
                        C = Hn(f - u, f - u + h, D, 1 - D);
                      return {
                        multiple: x * w,
                        dir: e,
                        snapSize: a,
                        snapOffset: Math.round(C / a)
                      };
                    }),
                    w = b.map(function (e) {
                      return e.multiple || 1;
                    });
                  s.snapThresholdInfo.multiples = w, s.snapThresholdInfo.offset = b.map(function (e) {
                    return e.snapOffset;
                  }), b.forEach(function (e, t) {
                    e.snapSize;
                  });
                }
              } else s.snapThresholdInfo = null;
            }(e, r, o, i);
            var v = l.snapThresholdInfo,
              y = c,
              b = p;
            v && (c *= v.multiples[0] || 1, p *= v.multiples[1] || 1, g = v.offset);
            if (p) {
              for (var w = function (e) {
                  h.push({
                    type: "horizontal",
                    pos: [f, yr(g[1] * b + e - o + m, .1)],
                    className: Zs("grid-guideline"),
                    size: t,
                    hide: !a,
                    direction: "",
                    grid: !0
                  });
                }, x = 0; x <= 2 * n; x += p) w(x);
              for (x = -p; x >= -n; x -= p) w(x);
            }
            if (c) {
              for (w = function (e) {
                h.push({
                  type: "vertical",
                  pos: [yr(g[0] * y + e - r + f, .1), m],
                  className: Zs("grid-guideline"),
                  size: n,
                  hide: !a,
                  direction: "",
                  grid: !0
                });
              }, x = 0; x <= 2 * t; x += c) w(x);
              for (x = -c; x >= -t; x -= c) w(x);
            }
            return h;
          }(e, a ? l : c, a ? s : u, d, p, O, D)), !1)), i) {
            var I = o.left,
              F = o.top;
            O.left += I, O.top += F, O.right += I, O.bottom += F;
          }
          return z.push.apply(z, ri([], ni(Os(v || !1, g || !1, a ? l : c, a ? s : u, d, p, O)), !1)), z = z.filter(function (e) {
            var t = e.element,
              n = e.elementRect,
              r = e.type;
            if (!t || !n) return !0;
            var o = n.rect;
            return zs(k, o, r, x);
          }), z;
        }
        function zs(e, t, n, r) {
          return "horizontal" === n ? nu(e.right - t.left) <= r || nu(e.left - t.right) <= r || e.left <= t.right && t.left <= e.right : "vertical" !== n || nu(e.bottom - t.top) <= r || nu(e.top - t.bottom) <= r || e.top <= t.bottom && t.top <= e.bottom;
        }
        function Ts(e, t) {
          return e ? e.map(function (e) {
            var n = Zn(e) ? e : {
                pos: e
              },
              r = n.pos;
            return Wn(r) ? n : ti(ti({}, n), {
              pos: cr(r, t)
            });
          }) : [];
        }
        function Os(e, t, n, r, o, i, a) {
          void 0 === o && (o = 0), void 0 === i && (i = 0), void 0 === a && (a = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          });
          var s = [],
            l = a.left,
            u = a.top,
            c = a.bottom,
            d = n + a.right - l,
            p = r + c - u;
          return Ts(e, p).forEach(function (e) {
            s.push({
              type: "horizontal",
              pos: [l, yr(e.pos - i + u, .1)],
              size: d,
              className: e.className,
              direction: ""
            });
          }), Ts(t, d).forEach(function (e) {
            s.push({
              type: "vertical",
              pos: [yr(e.pos - o + l, .1), u],
              size: p,
              className: e.className,
              direction: ""
            });
          }), s;
        }
        function Is(e) {
          var t = e.state,
            n = t.container,
            r = e.props.snapContainer || n;
          if (t.snapContainer === r && t.guidelines && t.guidelines.length) return !1;
          var o = t.containerClientRect,
            i = {
              left: 0,
              top: 0,
              bottom: 0,
              right: 0
            };
          if (n !== r) {
            var a = Zl(r, !0);
            if (a) {
              var s = wl(a),
                l = Gl(t, [s.left - o.left, s.top - o.top]),
                u = Gl(t, [s.right - o.right, s.bottom - o.bottom]);
              i.left = yr(l[0], 1e-5), i.top = yr(l[1], 1e-5), i.right = yr(u[0], 1e-5), i.bottom = yr(u[1], 1e-5);
            }
          }
          return t.snapContainer = r, t.snapOffset = i, t.guidelines = As(e), t.enableSnap = !0, !0;
        }
        function Fs(e, t, n, r, o, i) {
          var a = ll(e, t, n, i ? 4 : 3);
          return Cl(a, Kr(o, Ui(a, r)));
        }
        function Ms(e) {
          return e ? e / nu(e) : 0;
        }
        function Rs(e, t, n, r, o, i) {
          var a = function (e, t, n) {
              var r = [];
              if (n) 1 !== nu(t[0]) || 1 !== nu(t[1]) ? r.push([t, [-1, -1]], [t, [-1, 1]], [t, [1, -1]], [t, [1, 1]]) : r.push([t, [e[0], -e[1]]], [t, [-e[0], e[1]]]), r.push([t, e]);else if (e[0] && e[1] || !e[0] && !e[1]) {
                var o = e[0] ? e : [1, 1];
                [1, -1].forEach(function (e) {
                  [1, -1].forEach(function (n) {
                    var i = [e * o[0], n * o[1]];
                    t[0] === i[0] && t[1] === i[1] || r.push([t, i]);
                  });
                });
              } else e[0] ? (1 === nu(t[0]) ? [1] : [1, -1]).forEach(function (n) {
                r.push([[t[0], -1], [n * e[0], -1]], [[t[0], 0], [n * e[0], 0]], [[t[0], 1], [n * e[0], 1]]);
              }) : e[1] && (1 === nu(t[1]) ? [1] : [1, -1]).forEach(function (n) {
                r.push([[-1, t[1]], [-1, n * e[1]]], [[0, t[1]], [0, n * e[1]]], [[1, t[1]], [1, n * e[1]]]);
              });
              return r;
            }(n, i.fixedDirection, r),
            s = rs(e, t, n, r),
            l = ri(ri([], ni(cs(e, t, a, r, o, i)), !1), ni(ts(e, s, i)), !1),
            u = Wa(l, 0),
            c = Wa(l, 1);
          return {
            width: {
              isBound: u.isBound,
              offset: u.offset[0]
            },
            height: {
              isBound: c.isBound,
              offset: c.offset[1]
            }
          };
        }
        function js(e, t, n, r, o, i, a, s) {
          for (var l = Sl(e.state), u = e.props.keepRatio, c = 0, d = 0, p = 0; p < 2; ++p) {
            var h = Rs(e, t(c, d), o, u, a, s),
              f = h.width,
              m = h.height,
              g = f.isBound,
              v = m.isBound,
              y = f.offset,
              b = m.offset;
            if (1 === p && (g || (y = 0), v || (b = 0)), 0 === p && a && !g && !v) return [0, 0];
            if (u) {
              var w = nu(y) * (n ? 1 / n : 1),
                x = nu(b) * (r ? 1 / r : 1);
              (g && v ? w < x : v || !g && w < x) ? y = n * b / r : b = r * y / n;
            }
            c += y, d += b;
          }
          if (!u && o[0] && o[1]) {
            var D = function (e, t, n, r, o) {
                var i = [-n[0], -n[1]],
                  a = e.state,
                  s = a.width,
                  l = a.height,
                  u = e.props.bounds,
                  c = 1 / 0,
                  d = 1 / 0;
                if (u) {
                  var p = [[n[0], -n[1]], [-n[0], n[1]]],
                    h = u.left,
                    f = void 0 === h ? -1 / 0 : h,
                    m = u.top,
                    g = void 0 === m ? -1 / 0 : m,
                    v = u.right,
                    y = void 0 === v ? 1 / 0 : v,
                    b = u.bottom,
                    w = void 0 === b ? 1 / 0 : b;
                  p.forEach(function (e) {
                    var n = e[0] !== i[0],
                      a = e[1] !== i[1],
                      u = Ui(t, e),
                      p = 360 * mr(r, u) / Math.PI;
                    if (a) {
                      var h = u.slice();
                      (nu(p - 360) < 2 || nu(p - 180) < 2) && (h[1] = r[1]);
                      var m = as(r, h, (r[1] < u[1] ? w : g) - u[1], !1, o),
                        v = ni(m.offset, 2)[1],
                        b = m.isOutside;
                      isNaN(v) || (d = l + (b ? 1 : -1) * nu(v));
                    }
                    if (n) {
                      h = u.slice(), (nu(p - 90) < 2 || nu(p - 270) < 2) && (h[0] = r[0]);
                      var x = as(r, h, (r[0] < u[0] ? y : f) - u[0], !0, o),
                        D = ni(x.offset, 1)[0],
                        C = x.isOutside;
                      isNaN(D) || (c = s + (C ? 1 : -1) * nu(D));
                    }
                  });
                }
                return {
                  maxWidth: c,
                  maxHeight: d
                };
              }(e, l, o, i, s),
              C = D.maxWidth,
              S = D.maxHeight,
              E = ni(function (e, t, n, r, o, i, a, s, l) {
                var u = Ui(t, a),
                  c = us(e, s, {
                    vertical: [u[0]],
                    horizontal: [u[1]]
                  }),
                  d = c.horizontal.offset,
                  p = c.vertical.offset;
                if (yr(p, Si) || yr(d, Si)) {
                  var h = ni(Ki({
                      datas: l,
                      distX: -p,
                      distY: -d
                    }), 2),
                    f = h[0],
                    m = h[1];
                  return [Math.min(o || 1 / 0, n + a[0] * f) - n, Math.min(i || 1 / 0, r + a[1] * m) - r];
                }
                return [0, 0];
              }(e, t(c, d).map(function (e) {
                return e.map(function (e) {
                  return yr(e, Si);
                });
              }), n + c, r + d, C, S, o, a, s), 2);
            c += y = E[0], d += b = E[1];
          }
          return [c, d];
        }
        function Bs(e) {
          return e < 0 && (e = e % 360 + 360), e %= 360;
        }
        function Ns(e, t) {
          t = Bs(t);
          var n = Math.floor(e / 360),
            r = 360 * n + 360 - t,
            o = 360 * n + t;
          return nu(e - r) < nu(e - o) ? r : o;
        }
        function Ls(e, t) {
          e = Bs(e), t = Bs(t);
          var n = Bs(e - t);
          return Math.min(n, 360 - n);
        }
        function Vs(e, t, n, r, o) {
          if (!Fa(e, "scalable")) return [0, 0];
          var i = o.startOffsetWidth,
            a = o.startOffsetHeight,
            s = o.fixedPosition,
            l = o.fixedDirection,
            u = o.is3d,
            c = js(e, function (e, n) {
              return Fs(function (e, t) {
                var n = e.transformOrigin,
                  r = e.offsetMatrix,
                  o = e.is3d,
                  i = e.targetMatrix,
                  a = o ? 4 : 3;
                return Zi(r, Lr(e.targetAllTransform || i, to(t, a), a), n, a);
              }(o, Vr(t, [e / i, n / a])), i, a, l, s, u);
            }, i, a, n, s, r, o);
          return [c[0] / i, c[1] / a];
        }
        function Ks(e) {
          var t = [];
          return e.forEach(function (e) {
            e.guidelineInfos.forEach(function (n) {
              var r = n.guideline;
              ar(t, function (e) {
                return e.guideline === r;
              }) || (r.direction = "", t.push({
                guideline: r,
                posInfo: e
              }));
            });
          }), t.map(function (e) {
            var t = e.guideline,
              n = e.posInfo;
            return ti(ti({}, t), {
              direction: n.direction
            });
          });
        }
        function qs(e, t, n, r, o, i) {
          var a = Sa(Ea(e, i), t, n),
            s = a.vertical,
            l = a.horizontal,
            u = {
              left: !1,
              top: !1,
              right: !1,
              bottom: !1
            };
          s.forEach(function (e) {
            e.isBound && ("start" === e.direction && (u.left = !0), "end" === e.direction && (u.right = !0), r.push({
              type: "bounds",
              pos: e.pos
            }));
          }), l.forEach(function (e) {
            e.isBound && ("start" === e.direction && (u.top = !0), "end" === e.direction && (u.bottom = !0), o.push({
              type: "bounds",
              pos: e.pos
            }));
          });
          var c = function (e) {
              var t = e.props.innerBounds,
                n = {
                  left: !1,
                  top: !1,
                  right: !1,
                  bottom: !1
                };
              if (!t) return {
                boundMap: n,
                vertical: [],
                horizontal: []
              };
              var r = e.getRect(),
                o = [r.pos1, r.pos2, r.pos3, r.pos4],
                i = Ui(o, [0, 0]),
                a = t.left,
                s = t.top,
                l = t.width,
                u = t.height,
                c = [[a, s], [a, s + u]],
                d = [[a, s], [a + l, s]],
                p = [[a + l, s], [a + l, s + u]],
                h = [[a, s + u], [a + l, s + u]],
                f = rs(e, o, [0, 0], !1),
                m = [],
                g = [];
              return f.forEach(function (e) {
                var t = e.line,
                  r = e.lineConstants,
                  o = Ya(i, t),
                  f = o.horizontal,
                  v = o.vertical,
                  y = es(t, r, d, v, 1, !0),
                  b = es(t, r, h, v, 1, !0),
                  w = es(t, r, c, f, 1, !0),
                  x = es(t, r, p, f, 1, !0);
                y.isBound && !n.top && (m.push(s), n.top = !0), b.isBound && !n.bottom && (m.push(s + u), n.bottom = !0), w.isBound && !n.left && (g.push(a), n.left = !0), x.isBound && !n.right && (g.push(a + l), n.right = !0);
              }), {
                boundMap: n,
                horizontal: m,
                vertical: g
              };
            }(e),
            d = c.boundMap,
            p = c.vertical,
            h = c.horizontal;
          return p.forEach(function (e) {
            ir(r, function (t) {
              var n = t.type,
                r = t.pos;
              return "bounds" === n && r === e;
            }) >= 0 || r.push({
              type: "bounds",
              pos: e
            });
          }), h.forEach(function (e) {
            ir(o, function (t) {
              var n = t.type,
                r = t.pos;
              return "bounds" === n && r === e;
            }) >= 0 || o.push({
              type: "bounds",
              pos: e
            });
          }), {
            boundMap: u,
            innerBoundMap: d
          };
        }
        var Hs = Ul("", ["resizable", "scalable"]),
          Us = {
            name: "snappable",
            dragRelation: "strong",
            props: ["snappable", "snapContainer", "snapDirections", "elementSnapDirections", "snapGap", "snapGridWidth", "snapGridHeight", "isDisplaySnapDigit", "isDisplayInnerSnapDigit", "isDisplayGridGuidelines", "snapDigit", "snapThreshold", "snapRenderThreshold", "snapGridAll", ja, Ba, Na, La, "horizontalGuidelines", "verticalGuidelines", "elementGuidelines", "bounds", "innerBounds", "snapDistFormat", "maxSnapElementGuidelineDistance", "maxSnapElementGapDistance"],
            events: ["snap", "bound"],
            css: [":host {\n--bounds-color: #d66;\n}\n.guideline {\npointer-events: none;\nz-index: 2;\n}\n.guideline.bounds {\nbackground: #d66;\nbackground: var(--bounds-color);\n}\n.guideline-group {\nposition: absolute;\ntop: 0;\nleft: 0;\n}\n.guideline-group .size-value {\nposition: absolute;\ncolor: #f55;\nfont-size: 12px;\nfont-size: calc(12px * var(--zoom));\nfont-weight: bold;\n}\n.guideline-group.horizontal .size-value {\ntransform-origin: 50% 100%;\ntransform: translateX(-50%);\nleft: 50%;\nbottom: 5px;\nbottom: calc(2px + 3px * var(--zoom));\n}\n.guideline-group.vertical .size-value {\ntransform-origin: 0% 50%;\ntop: 50%;\ntransform: translateY(-50%);\nleft: 5px;\nleft: calc(2px + 3px * var(--zoom));\n}\n.guideline.gap {\nbackground: #f55;\n}\n.size-value.gap {\ncolor: #f55;\n}\n"],
            render: function (e, t) {
              var n = e.state,
                r = n.top,
                o = n.left,
                i = n.pos1,
                a = n.pos2,
                s = n.pos3,
                l = n.pos4,
                u = n.snapRenderInfo,
                c = e.props.snapRenderThreshold,
                d = void 0 === c ? 1 : c;
              if (!u || !u.render || !Fa(e, "")) return eu(e, "boundMap", {
                left: !1,
                top: !1,
                right: !1,
                bottom: !1
              }, function (e) {
                return JSON.stringify(e);
              }), eu(e, "innerBoundMap", {
                left: !1,
                top: !1,
                right: !1,
                bottom: !1
              }, function (e) {
                return JSON.stringify(e);
              }), [];
              n.guidelines = As(e);
              var p = Math.min(i[0], a[0], s[0], l[0]),
                h = Math.min(i[1], a[1], s[1], l[1]),
                f = u.externalPoses || [],
                m = Sl(e.state),
                g = [],
                v = [],
                y = [],
                b = [],
                w = [],
                x = ul(m),
                D = x.width,
                C = x.height,
                S = x.top,
                E = x.left,
                _ = x.bottom,
                P = x.right,
                k = {
                  left: E,
                  right: P,
                  top: S,
                  bottom: _,
                  center: (E + P) / 2,
                  middle: (S + _) / 2
                },
                A = f.length > 0,
                z = A ? ul(f) : {};
              if (!u.request) {
                if (u.direction && w.push($a(e, m, u.direction, d, d)), u.snap) {
                  var T = ul(m);
                  u.center && (T.middle = (T.top + T.bottom) / 2, T.center = (T.left + T.right) / 2), w.push(Ha(e, T, d, d));
                }
                A && (u.center && (z.middle = (z.top + z.bottom) / 2, z.center = (z.left + z.right) / 2), w.push(Ha(e, z, d, d))), w.forEach(function (e) {
                  var t = e.vertical.posInfos,
                    n = e.horizontal.posInfos;
                  g.push.apply(g, ri([], ni(t.filter(function (e) {
                    return e.guidelineInfos.some(function (e) {
                      return !e.guideline.hide;
                    });
                  }).map(function (e) {
                    return {
                      type: "snap",
                      pos: e.pos
                    };
                  })), !1)), v.push.apply(v, ri([], ni(n.filter(function (e) {
                    return e.guidelineInfos.some(function (e) {
                      return !e.guideline.hide;
                    });
                  }).map(function (e) {
                    return {
                      type: "snap",
                      pos: e.pos
                    };
                  })), !1)), y.push.apply(y, ri([], ni(Ks(t)), !1)), b.push.apply(b, ri([], ni(Ks(n)), !1));
                });
              }
              var O = qs(e, [E, P], [S, _], g, v),
                I = O.boundMap,
                F = O.innerBoundMap;
              A && qs(e, [z.left, z.right], [z.top, z.bottom], g, v, u.externalBounds);
              var M = ri(ri([], ni(y), !1), ni(b), !1),
                R = M.filter(function (e) {
                  return e.element && !e.gapRects;
                }),
                j = M.filter(function (e) {
                  return e.gapRects;
                }).sort(function (e, t) {
                  return e.gap - t.gap;
                });
              Ol(e, "onSnap", {
                guidelines: M.filter(function (e) {
                  return !e.element;
                }),
                elements: R,
                gaps: j
              }, !0);
              var B = eu(e, "boundMap", I, function (e) {
                  return JSON.stringify(e);
                }, {
                  left: !1,
                  top: !1,
                  right: !1,
                  bottom: !1
                }),
                N = eu(e, "innerBoundMap", F, function (e) {
                  return JSON.stringify(e);
                }, {
                  left: !1,
                  top: !1,
                  right: !1,
                  bottom: !1
                });
              return I !== B && F !== N || Ol(e, "onBound", {
                bounds: I,
                innerBounds: F
              }, !0), ri(ri(ri(ri(ri(ri([], ni(ks(e, R, [p, h], k, t)), !1), ni(function (e, t, n, r, o) {
                var i = [];
                return ["horizontal", "vertical"].forEach(function (a) {
                  var s = t.filter(function (e) {
                      return e.type === a;
                    }).slice(0, 1),
                    l = "vertical" === a ? 0 : 1,
                    u = l ? 0 : 1,
                    c = l ? Ia : Oa,
                    d = l ? Oa : Ia,
                    p = r[c.start],
                    h = r[c.end],
                    f = r[d.start],
                    m = r[d.end];
                  s.forEach(function (t) {
                    var r = t.gap,
                      a = t.gapRects,
                      s = Math.max.apply(Math, ri([f], ni(a.map(function (e) {
                        return e.rect[d.start];
                      })), !1)),
                      g = Math.min.apply(Math, ri([m], ni(a.map(function (e) {
                        return e.rect[d.end];
                      })), !1)),
                      v = (s + g) / 2;
                    s !== g && v !== (f + m) / 2 && a.forEach(function (t) {
                      var a = t.rect,
                        s = t.className,
                        d = [n[0], n[1]];
                      if (a[c.end] < p) d[l] += a[c.end] - p;else {
                        if (!(h < a[c.start])) return;
                        d[l] += a[c.start] - p - r;
                      }
                      d[u] += v - f, i.push(Ps(e, l ? "vertical" : "horizontal", "gap", i.length, r, d, s, o));
                    });
                  });
                }), i;
              }(e, j, [p, h], k, t)), !1), ni(_s(e, "horizontal", b, [o, r], k, t)), !1), ni(_s(e, "vertical", y, [o, r], k, t)), !1), ni(Es(e, "horizontal", v, p, r, D, 0, t)), !1), ni(Es(e, "vertical", g, h, o, C, 1, t)), !1);
            },
            dragStart: function (e, t) {
              e.state.snapRenderInfo = {
                request: t.isRequest,
                snap: !0,
                center: !0
              }, Is(e);
            },
            drag: function (e) {
              var t = e.state;
              Is(e) || (t.guidelines = As(e)), t.snapRenderInfo && (t.snapRenderInfo.render = !0);
            },
            pinchStart: function (e) {
              this.unset(e);
            },
            dragEnd: function (e) {
              this.unset(e);
            },
            dragControlCondition: function (e, t) {
              return !(!Hs(e, t) && !Ds(e, t)) || (!t.isRequest && t.inputEvent ? wr(t.inputEvent.target, Zs("snap-control")) : void 0);
            },
            dragControlStart: function (e) {
              e.state.snapRenderInfo = null, Is(e);
            },
            dragControl: function (e) {
              this.drag(e);
            },
            dragControlEnd: function (e) {
              this.unset(e);
            },
            dragGroupStart: function (e, t) {
              this.dragStart(e, t);
            },
            dragGroup: function (e) {
              this.drag(e);
            },
            dragGroupEnd: function (e) {
              this.unset(e);
            },
            dragGroupControlStart: function (e) {
              e.state.snapRenderInfo = null, Is(e);
            },
            dragGroupControl: function (e) {
              this.drag(e);
            },
            dragGroupControlEnd: function (e) {
              this.unset(e);
            },
            unset: function (e) {
              var t = e.state;
              t.enableSnap = !1, t.guidelines = [], t.snapRenderInfo = null, t.elementRects = [];
            }
          };
        function Zs() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return Mn.apply(void 0, ri([wi], ni(e), !1));
        }
        function $s(e) {
          e();
        }
        function Gs(e) {
          return e && "none" !== e ? Zn(e) ? e : io(e) : [1, 0, 0, 1, 0, 0];
        }
        function Ws(e, t, n) {
          return Nr(t, no(n, t), e, no(n.map(function (e) {
            return -e;
          }), t));
        }
        function Ys(e) {
          return Xs(Il(e, ":before").transformOrigin).map(function (t, n) {
            var r = rr(t),
              o = r.value,
              i = r.unit;
            return o * function (e, t, n) {
              return "%" === t ? il(e.ownerSVGElement)[n ? "width" : "height"] / 100 : 1;
            }(e, i, 0 === n);
          });
        }
        function Xs(e) {
          return e ? e.split(" ") : ["0", "0"];
        }
        function Qs(e) {
          var t = pa(e)("transform");
          if (t && "none" !== t) return t;
          if ("transform" in e) {
            var n = e.transform.baseVal;
            if (!n) return "";
            var r = n.length;
            if (!r) return "";
            for (var o = [], i = function (e) {
                var t = n[e].matrix;
                o.push("matrix(".concat(["a", "b", "c", "d", "e", "f"].map(function (e) {
                  return t[e];
                }).join(", "), ")"));
              }, a = 0; a < r; ++a) i(a);
            return o.join(" ");
          }
          return "";
        }
        function Js(e, t, n, r, o) {
          var i,
            a,
            s,
            l,
            u = _r(e) || Pr(e),
            c = !1;
          if (!e || n) s = e;else {
            var d = null === (i = null == e ? void 0 : e.assignedSlot) || void 0 === i ? void 0 : i.parentElement,
              p = e.parentElement;
            d ? (c = !0, l = p, s = d) : s = p;
          }
          for (var h = !1, f = e === t || s === t, m = "relative", g = 1, v = parseFloat(null == o ? void 0 : o("zoom")) || 1, y = null == o ? void 0 : o("position"); s && s !== u;) {
            t === s && (f = !0);
            var b = pa(s),
              w = s.tagName.toLowerCase(),
              x = Qs(s),
              D = b("willChange"),
              C = parseFloat(b("zoom")) || 1;
            if (m = b("position"), r && 1 !== C) {
              g = C;
              break;
            }
            if (!n && r && 1 !== v && y && "absolute" !== y || "svg" === w || "foreignobject" === w || "static" !== m || x && "none" !== x || "transform" === D) break;
            var S = null === (a = null == e ? void 0 : e.assignedSlot) || void 0 === a ? void 0 : a.parentNode,
              E = s.parentNode;
            S && (c = !0, l = E);
            var _ = E;
            if (_ && 11 === _.nodeType) {
              h = !0, m = pa(s = _.host)("position");
              break;
            }
            s = _, m = "relative";
          }
          return {
            offsetZoom: g,
            hasSlot: c,
            parentSlotElement: l,
            isCustomElement: h,
            isStatic: "static" === m,
            isEnd: f || !s || s === u,
            offsetParent: s || u
          };
        }
        function el(e, t) {
          var n,
            r,
            o,
            i = e.tagName.toLowerCase(),
            a = e.offsetLeft,
            s = e.offsetTop,
            l = pa(e),
            u = Un(a),
            c = !u;
          return c || "svg" === i && !e.ownerSVGElement ? o = (r = Xs(l("transformOrigin")).map(function (e) {
            return parseFloat(e);
          })).slice() : (o = (r = di ? Ys(e) : Xs(l("transformOrigin")).map(function (e) {
            return parseFloat(e);
          })).slice(), c = !0, "svg" === i ? (a = 0, s = 0) : (n = ni(function (e, t, n) {
            var r = e.tagName.toLowerCase();
            if (!e.getBBox || !n && "g" === r) return [0, 0, 0, 0];
            var o = "fill-box" === pa(e)("transform-box"),
              i = e.getBBox(),
              a = il(e.ownerSVGElement),
              s = i.x,
              l = i.y;
            "foreignobject" !== r || s || l || (s = parseFloat(e.getAttribute("x")) || 0, l = parseFloat(e.getAttribute("y")) || 0);
            var u = s - a.x,
              c = l - a.y,
              d = o ? t[0] : t[0] - u,
              p = o ? t[1] : t[1] - c;
            return [u, c, d, p];
          }(e, r, e === t && "g" === t.tagName.toLowerCase()), 4), a = n[0], s = n[1], r[0] = n[2], r[1] = n[3])), {
            tagName: i,
            isSVG: u,
            hasOffset: c,
            offset: [a || 0, s || 0],
            origin: r,
            targetOrigin: o
          };
        }
        function tl(e, t) {
          var n = pa(e),
            r = pa(Pr(e)),
            o = r("position");
          if (!(t || o && "static" !== o)) return [0, 0];
          var i = parseInt(r("marginLeft"), 10),
            a = parseInt(r("marginTop"), 10);
          return "absolute" === n("position") && ("auto" === n("top") && "auto" === n("bottom") || (a = 0), "auto" === n("left") && "auto" === n("right") || (i = 0)), [i, a];
        }
        function nl(e) {
          e.forEach(function (e) {
            var t = e.matrix;
            t && (e.matrix = Br(t, 3, 4));
          });
        }
        function rl(e) {
          for (var t = e.parentElement, n = !1, r = Pr(e); t;) {
            var o = Il(t).transform;
            if (o && "none" !== o) {
              n = !0;
              break;
            }
            if (t === r) break;
            t = t.parentElement;
          }
          return {
            fixedContainer: t || r,
            hasTransform: n
          };
        }
        function ol(e, t) {
          return void 0 === t && (t = e.length > 9), "".concat(t ? "matrix3d" : "matrix", "(").concat(Hr(e, !t).join(","), ")");
        }
        function il(e) {
          var t = e.clientWidth,
            n = e.clientHeight;
          if (!e) return {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            clientWidth: t,
            clientHeight: n
          };
          var r = e.viewBox,
            o = r && r.baseVal || {
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };
          return {
            x: o.x,
            y: o.y,
            width: o.width || t,
            height: o.height || n,
            clientWidth: t,
            clientHeight: n
          };
        }
        function al(e, t) {
          var n,
            r = il(e),
            o = r.width,
            i = r.height,
            a = r.clientWidth,
            s = r.clientHeight,
            l = a / o,
            u = s / i,
            c = e.preserveAspectRatio.baseVal,
            d = c.align,
            p = c.meetOrSlice,
            h = [0, 0],
            f = [l, u],
            m = [0, 0];
          if (1 !== d) {
            var g = (d - 2) % 3,
              v = Math.floor((d - 2) / 3);
            h[0] = o * g / 2, h[1] = i * v / 2;
            var y = 2 === p ? Math.max(u, l) : Math.min(l, u);
            f[0] = y, f[1] = y, m[0] = (a - o) / 2 * g, m[1] = (s - i) / 2 * v;
          }
          var b = to(f, t);
          return n = ni(m, 2), b[t * (t - 1)] = n[0], b[t * (t - 1) + 1] = n[1], Ws(b, t, h);
        }
        function sl(e, t, n) {
          return Ur(e, jr(t, n), n);
        }
        function ll(e, t, n, r) {
          return [[0, 0], [t, 0], [0, n], [t, n]].map(function (t) {
            return sl(e, t, r);
          });
        }
        function ul(e) {
          var t = e.map(function (e) {
              return e[0];
            }),
            n = e.map(function (e) {
              return e[1];
            }),
            r = Math.min.apply(Math, ri([], ni(t), !1)),
            o = Math.min.apply(Math, ri([], ni(n), !1)),
            i = Math.max.apply(Math, ri([], ni(t), !1)),
            a = Math.max.apply(Math, ri([], ni(n), !1));
          return {
            left: r,
            top: o,
            right: i,
            bottom: a,
            width: i - r,
            height: a - o
          };
        }
        function cl(e, t, n, r) {
          return ul(ll(e, t, n, r));
        }
        function dl(e) {
          return Math.sqrt(e[0] * e[0] + e[1] * e[1]);
        }
        function pl(e, t) {
          return dl([t[0] - e[0], t[1] - e[1]]);
        }
        function hl(e, t, n, r) {
          void 0 === n && (n = 1), void 0 === r && (r = mr(e, t));
          var o = pl(e, t);
          return {
            transform: "translateY(-50%) translate(".concat(e[0], "px, ").concat(e[1], "px) rotate(").concat(r, "rad) scaleY(").concat(n, ")"),
            width: "".concat(o, "px")
          };
        }
        function fl(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n.length,
            i = n.reduce(function (e, t) {
              return e + t[0];
            }, 0) / o,
            a = n.reduce(function (e, t) {
              return e + t[1];
            }, 0) / o;
          return {
            transform: "translateZ(0px) translate(".concat(i, "px, ").concat(a, "px) rotate(").concat(e, "rad) scale(").concat(t, ")")
          };
        }
        function ml(e, t) {
          var n = e[t];
          return Zn(n) ? ti(ti({}, e), n) : e;
        }
        function gl(e) {
          var t = e && !Un(e.offsetWidth),
            n = 0,
            r = 0,
            o = 0,
            i = 0,
            a = 0,
            s = 0,
            l = 0,
            u = 0,
            c = 0,
            d = 0,
            p = 0,
            h = 0,
            f = 1 / 0,
            m = 1 / 0,
            g = 1 / 0,
            v = 1 / 0,
            y = 0,
            b = 0,
            w = !1;
          if (e) if (!t && e.ownerSVGElement) {
            var x = e.getBBox();
            w = !0, a = n = x.width, s = r = x.height, l = n, u = r, o = n, i = r;
          } else {
            var D = pa(e),
              C = e.style,
              S = "border-box" === D("boxSizing"),
              E = parseFloat(D("borderLeftWidth")) || 0,
              _ = parseFloat(D("borderRightWidth")) || 0,
              P = parseFloat(D("borderTopWidth")) || 0,
              k = parseFloat(D("borderBottomWidth")) || 0,
              A = (parseFloat(D("paddingLeft")) || 0) + (parseFloat(D("paddingRight")) || 0),
              z = (parseFloat(D("paddingTop")) || 0) + (parseFloat(D("paddingBottom")) || 0),
              T = A + (E + _),
              O = z + (P + k),
              I = D("position"),
              F = 0,
              M = 0;
            if ("clientLeft" in e) {
              var R = null;
              if ("absolute" === I) R = Js(e, Pr(e)).offsetParent;else R = e.parentElement;
              if (R) {
                var j = pa(R);
                F = parseFloat(j("width")), M = parseFloat(j("height"));
              }
            }
            c = Math.max(A, cr(D("minWidth"), F) || 0), d = Math.max(z, cr(D("minHeight"), M) || 0), f = cr(D("maxWidth"), F), m = cr(D("maxHeight"), M), isNaN(f) && (f = 1 / 0), isNaN(m) && (m = 1 / 0), y = cr(C.width, 0) || 0, b = cr(C.height, 0) || 0, a = parseFloat(D("width")) || 0, s = parseFloat(D("height")) || 0, n = l = nu(a - y) < 1 ? dr(c, y || a, f) : a, r = u = nu(s - b) < 1 ? dr(d, b || s, m) : s, o = l, i = u, S ? (g = f, v = m, p = c, h = d, l = n - T, u = r - O) : (g = f + T, v = m + O, p = c + T, h = d + O, n = l + T, r = u + O), o = l + A, i = u + z;
          }
          return {
            svg: w,
            offsetWidth: n,
            offsetHeight: r,
            clientWidth: o,
            clientHeight: i,
            contentWidth: l,
            contentHeight: u,
            inlineCSSWidth: y,
            inlineCSSHeight: b,
            cssWidth: a,
            cssHeight: s,
            minWidth: c,
            minHeight: d,
            maxWidth: f,
            maxHeight: m,
            minOffsetWidth: p,
            minOffsetHeight: h,
            maxOffsetWidth: g,
            maxOffsetHeight: v
          };
        }
        function vl(e, t) {
          return mr(t > 0 ? e[0] : e[1], t > 0 ? e[1] : e[0]);
        }
        function yl(e, t) {
          var n = e === Pr(e) || e === _r(e),
            r = {
              clientLeft: e.clientLeft,
              clientTop: e.clientTop,
              clientWidth: e.clientWidth,
              clientHeight: e.clientHeight,
              scrollWidth: e.scrollWidth,
              scrollHeight: e.scrollHeight,
              overflow: !1
            };
          return n && (r.clientHeight = Math.max(t.height, r.clientHeight), r.scrollHeight = Math.max(t.height, r.scrollHeight)), r.overflow = "visible" !== pa(e)("overflow"), ti(ti({}, t), r);
        }
        function bl(e, t, n, r) {
          var o = e.left,
            i = e.right,
            a = e.top,
            s = e.bottom,
            l = t.top,
            u = t.left,
            c = {
              left: u + o,
              top: l + a,
              right: u + i,
              bottom: l + s,
              width: i - o,
              height: s - a
            };
          return n && r ? yl(n, c) : c;
        }
        function wl(e, t) {
          var n = 0,
            r = 0,
            o = 0,
            i = 0;
          if (e) {
            var a = e.getBoundingClientRect();
            n = a.left, r = a.top, o = a.width, i = a.height;
          }
          var s = {
            left: n,
            top: r,
            width: o,
            height: i,
            right: n + o,
            bottom: r + i
          };
          return e && t ? yl(e, s) : s;
        }
        function xl(e, t, n, r) {
          var o;
          if (e) o = e;else if (t) o = [0, 0];else {
            o = Dl(n.target, r);
          }
          return o;
        }
        function Dl(e, t) {
          if (e) {
            var n = e.getAttribute("data-rotation") || "",
              r = e.getAttribute("data-direction");
            if (t.deg = n, r) {
              var o = [0, 0];
              return r.indexOf("w") > -1 && (o[0] = -1), r.indexOf("e") > -1 && (o[0] = 1), r.indexOf("n") > -1 && (o[1] = -1), r.indexOf("s") > -1 && (o[1] = 1), o;
            }
          }
        }
        function Cl(e, t) {
          return [Vr(t, e[0]), Vr(t, e[1]), Vr(t, e[2]), Vr(t, e[3])];
        }
        function Sl(e) {
          var t = e.left,
            n = e.top;
          return Cl([e.pos1, e.pos2, e.pos3, e.pos4], [t, n]);
        }
        function El(e, t) {
          e[t ? "controlAbles" : "targetAbles"].forEach(function (t) {
            t.unset && t.unset(e);
          });
        }
        function _l(e, t) {
          var n = t ? "controlGesto" : "targetGesto",
            r = e[n];
          !1 === (null == r ? void 0 : r.isIdle()) && El(e, t), null == r || r.unset(), e[n] = null;
        }
        function Pl(e, t) {
          if (t) {
            var n = Xi(t);
            n.nextStyle = ti(ti({}, n.nextStyle), e);
          }
          return {
            style: e,
            cssText: ur(e).map(function (t) {
              return "".concat((n = t, r = "-", void 0 === r && (r = "-"), n.replace(/([a-z])([A-Z])/g, function (e, t, n) {
                return "" + t + r + n.toLowerCase();
              })), ": ").concat(e[t], ";");
              var n, r;
            }).join("")
          };
        }
        function kl(e, t, n) {
          var r = t.afterTransform || t.transform;
          return ti(ti({}, Pl(ti(ti(ti({}, e.style), t.style), {
            transform: r
          }), n)), {
            afterTransform: r,
            transform: e.transform
          });
        }
        function Al(e, t, n, r) {
          var o = t.datas;
          o.datas || (o.datas = {});
          var i = ti(ti({}, n), {
            target: e.state.target,
            clientX: t.clientX,
            clientY: t.clientY,
            inputEvent: t.inputEvent,
            currentTarget: e,
            moveable: e,
            datas: o.datas,
            isRequest: t.isRequest,
            isRequestChild: t.isRequestChild,
            isFirstDrag: !!t.isFirstDrag,
            isTrusted: !1 !== t.isTrusted,
            stopAble: function () {
              o.isEventStart = !1;
            },
            stopDrag: function () {
              var e;
              null === (e = t.stop) || void 0 === e || e.call(t);
            }
          });
          return o.isStartEvent ? r || (o.lastEvent = i) : o.isStartEvent = !0, i;
        }
        function zl(e, t, n) {
          var r = t.datas,
            o = "isDrag" in n ? n.isDrag : t.isDrag;
          return r.datas || (r.datas = {}), ti(ti({
            isDrag: o
          }, n), {
            moveable: e,
            target: e.state.target,
            clientX: t.clientX,
            clientY: t.clientY,
            inputEvent: t.inputEvent,
            currentTarget: e,
            lastEvent: r.lastEvent,
            isDouble: t.isDouble,
            datas: r.datas,
            isFirstDrag: !!t.isFirstDrag
          });
        }
        function Tl(e, t, n) {
          e._emitter.on(t, n);
        }
        function Ol(e, t, n, r, o) {
          return e.triggerEvent(t, n, r, o);
        }
        function Il(e, t) {
          return kr(e).getComputedStyle(e, t);
        }
        function Fl(e, t, n) {
          var r = {},
            o = {};
          return e.filter(function (e) {
            var i = e.name;
            if (r[i] || !t.some(function (t) {
              return e[t];
            })) return !1;
            if (!n && e.ableGroup) {
              if (o[e.ableGroup]) return !1;
              o[e.ableGroup] = !0;
            }
            return r[i] = !0, !0;
          });
        }
        function Ml(e, t) {
          return e === t || null == e && null == t;
        }
        function Rl() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          for (var n = e.length - 1, r = 0; r < n; ++r) {
            var o = e[r];
            if (!Un(o)) return o;
          }
          return e[n];
        }
        function jl(e, t) {
          var n = [],
            r = [];
          return e.forEach(function (o, i) {
            var a = t(o, i, e),
              s = r.indexOf(a),
              l = n[s] || [];
            -1 === s && (r.push(a), n.push(l)), l.push(o);
          }), n;
        }
        function Bl(e) {
          return e.reduce(function (e, t) {
            return e.concat(t);
          }, []);
        }
        function Nl() {
          for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
          return e.sort(function (e, t) {
            return nu(t) - nu(e);
          }), e[0];
        }
        function Ll(e, t, n) {
          return Ur(Mr(e, n), jr(t, n), n);
        }
        function Vl(e, t) {
          var n,
            r = e.is3d ? 4 : 3;
          return n = ni(Ll(e.rootMatrix, [t.distX, t.distY], r), 2), t.distX = n[0], t.distY = n[1], t;
        }
        function Kl(e, t, n, r) {
          if (!n[0] && !n[1]) return t;
          var o = sl(e, [Ms(n[0] || 1), 0], r),
            i = sl(e, [0, Ms(n[1] || 1)], r);
          return Vr(t, sl(e, [n[0] / dl(o), n[1] / dl(i)], r));
        }
        function ql(e) {
          return nu(e) <= Ei ? 0 : e;
        }
        function Hl(e) {
          return function (t) {
            if (!t.isDragging(e)) return "";
            var n = function (e, t) {
                var n,
                  r = e.targetGesto,
                  o = e.controlGesto;
                return (null == r ? void 0 : r.isFlag()) && (n = r.getEventData()[t]), !n && (null == o ? void 0 : o.isFlag()) && (n = o.getEventData()[t]), n || {};
              }(t, e),
              r = n.deg;
            return r ? Zs("view-control-rotation".concat(r)) : "";
          };
        }
        function Ul(e, t) {
          return void 0 === t && (t = [e]), function (n, r) {
            if (r.isRequest) return !!t.some(function (e) {
              return r.requestAble === e;
            }) && r.parentDirection;
            var o = r.inputEvent.target;
            return wr(o, Zs("direction")) && (!e || wr(o, Zs(e)));
          };
        }
        function Zl(e, t) {
          return e ? zr(e) ? e : Gn(e) ? t ? document.querySelector(e) : e : Yn(e) ? e() : Ar(e) ? e : "current" in e ? e.current : e : null;
        }
        function $l(e, t) {
          return e ? ((n = e) && Zn(n) && !zr(n) && ($n(n) || "length" in n) ? [].slice.call(e) : [e]).reduce(function (e, n) {
            return Gn(n) && t ? ri(ri([], ni(e), !1), ni([].slice.call(document.querySelectorAll(n))), !1) : ($n(n) ? e.push($l(n, t)) : e.push(Zl(n, t)), e);
          }, []) : [];
          var n;
        }
        function Gl(e, t) {
          var n = e.rootMatrix,
            r = e.is3d,
            o = Mr(n, r ? 4 : 3);
          return r || (o = Br(o, 3, 4)), o[12] = 0, o[13] = 0, o[14] = 0, function (e, t) {
            var n = Ur(e, [t[0], t[1] || 0, t[2] || 0, 1], 4),
              r = n[3] || 1;
            return [n[0] / r, n[1] / r, n[2] / r];
          }(o, t);
        }
        function Wl(e, t, n, r, o) {
          var i = ni(e, 2),
            a = i[0],
            s = i[1],
            l = 0,
            u = 0;
          if (o && a && s) {
            var c = mr([0, 0], t),
              d = mr([0, 0], r),
              p = dl(t),
              h = Math.cos(c - d) * p;
            if (r[0]) {
              if (r[1]) {
                var f = r[0] * a,
                  m = r[1] * s,
                  g = Math.atan2(f + t[0], m + t[1]),
                  v = Math.atan2(f, m);
                g < 0 && (g += 2 * Math.PI), v < 0 && (v += 2 * Math.PI);
                var y = 0;
                (y = nu(g - v) < Math.PI / 2 || nu(g - v) > Math.PI / 2 * 3 ? g - v : g - (v += Math.PI)) > 2 * Math.PI ? y -= 2 * Math.PI : y > Math.PI ? y = 2 * Math.PI - y : y < -Math.PI && (y = -2 * Math.PI - y);
                var b = dl([f + t[0], m + t[1]]) * Math.cos(y);
                l = b * Math.sin(v) - f, u = b * Math.cos(v) - m, r[0] < 0 && (l *= -1), r[1] < 0 && (u *= -1);
              } else u = (l = h) / n;
            } else l = (u = h) * n;
          } else l = r[0] * t[0], u = r[1] * t[1];
          return [l, u];
        }
        function Yl(e, t, n, r) {
          var o,
            i = n.ratio,
            a = n.startOffsetWidth,
            s = n.startOffsetHeight,
            l = 0,
            u = 0,
            c = r.distX,
            d = r.distY,
            p = r.pinchScale,
            h = r.parentDistance,
            f = r.parentDist,
            m = r.parentScale,
            g = n.fixedDirection,
            v = [0, 1].map(function (t) {
              return nu(e[t] - g[t]);
            }),
            y = [0, 1].map(function (e) {
              var t = v[e];
              return 0 !== t && (t = 2 / t), t;
            });
          if (f) l = f[0], u = f[1], t && (l ? u || (u = l / i) : l = u * i);else if (Wn(p)) l = (p - 1) * a, u = (p - 1) * s;else if (m) l = (m[0] - 1) * a, u = (m[1] - 1) * s;else if (h) {
            var b = a * v[0],
              w = s * v[1],
              x = dl([b, w]);
            l = h / x * b * y[0], u = h / x * w * y[1];
          } else {
            var D = Ki({
              datas: n,
              distX: c,
              distY: d
            });
            D = y.map(function (e, t) {
              return D[t] * e;
            }), l = (o = ni(Wl([a, s], D, i, e, t), 2))[0], u = o[1];
          }
          return {
            distWidth: l,
            distHeight: u
          };
        }
        function Xl(e, t) {
          if (t) {
            if ("left" === e) return {
              x: "0%",
              y: "50%"
            };
            if ("top" === e) return {
              x: "50%",
              y: "50%"
            };
            if ("center" === e) return {
              x: "50%",
              y: "50%"
            };
            if ("right" === e) return {
              x: "100%",
              y: "50%"
            };
            if ("bottom" === e) return {
              x: "50%",
              y: "100%"
            };
            var n = ni(e.split(" "), 2),
              r = n[0],
              o = n[1],
              i = Xl(r || ""),
              a = Xl(o || ""),
              s = ti(ti({}, i), a),
              l = {
                x: "50%",
                y: "50%"
              };
            return s.x && (l.x = s.x), s.y && (l.y = s.y), s.value && (s.x && !s.y && (l.y = s.value), !s.x && s.y && (l.x = s.value)), l;
          }
          return "left" === e ? {
            x: "0%"
          } : "right" === e ? {
            x: "100%"
          } : "top" === e ? {
            y: "0%"
          } : "bottom" === e ? {
            y: "100%"
          } : e ? "center" === e ? {
            value: "50%"
          } : {
            value: e
          } : {};
        }
        function Ql(e, t, n) {
          var r = Xl(e, !0),
            o = r.x,
            i = r.y;
          return [cr(o, t) || 0, cr(i, n) || 0];
        }
        function Jl(e, t) {
          return e.length === t.length && e.every(function (e, n) {
            var r = t[n],
              o = $n(e),
              i = $n(r);
            return o && i ? Jl(e, r) : !o && !i && e === r;
          });
        }
        function eu(e, t, n, r, o) {
          var i = e._store,
            a = i[t];
          if (!(t in i)) {
            if (null == o) return i[t] = n, n;
            i[t] = o, a = o;
          }
          return a === n || r(a) === r(n) ? a : (i[t] = n, n);
        }
        function tu(e) {
          return e >= 0 ? 1 : -1;
        }
        function nu(e) {
          return Math.abs(e);
        }
        function ru(e, t) {
          return function (e) {
            for (var t = [], n = 0; n < e; ++n) t.push(n);
            return t;
          }(e).map(function (e) {
            return t(e);
          });
        }
        function ou(e) {
          return Wn(e) ? {
            top: e,
            left: e,
            right: e,
            bottom: e
          } : {
            left: e.left || 0,
            top: e.top || 0,
            right: e.right || 0,
            bottom: e.bottom || 0
          };
        }
        oi("pinchable", {
          props: ["pinchable"],
          events: ["pinchStart", "pinch", "pinchEnd", "pinchGroupStart", "pinchGroup", "pinchGroupEnd"],
          dragStart: function () {
            return !0;
          },
          pinchStart: function (e, t) {
            var n = t.datas,
              r = t.targets,
              o = t.angle,
              i = t.originalDatas,
              a = e.props,
              s = a.pinchable,
              l = a.ables;
            if (!s) return !1;
            var u = "onPinch".concat(r ? "Group" : "", "Start"),
              c = "drag".concat(r ? "Group" : "", "ControlStart"),
              d = (!0 === s ? e.controlAbles : l.filter(function (e) {
                return s.indexOf(e.name) > -1;
              })).filter(function (e) {
                return e.canPinch && e[c];
              }),
              p = Al(e, t, {});
            r && (p.targets = r);
            var h = Ol(e, u, p);
            n.isPinch = !1 !== h, n.ables = d;
            var f = n.isPinch;
            return !!f && (d.forEach(function (n) {
              if (i[n.name] = i[n.name] || {}, n[c]) {
                var r = ti(ti({}, t), {
                  datas: i[n.name],
                  parentRotate: o,
                  isPinch: !0
                });
                n[c](e, r);
              }
            }), e.state.snapRenderInfo = {
              request: t.isRequest,
              direction: [0, 0]
            }, f);
          },
          pinch: function (e, t) {
            var n = t.datas,
              r = t.scale,
              o = t.distance,
              i = t.originalDatas,
              a = t.inputEvent,
              s = t.targets,
              l = t.angle;
            if (n.isPinch) {
              var u = o * (1 - 1 / r),
                c = Al(e, t, {});
              s && (c.targets = s);
              var d = "onPinch".concat(s ? "Group" : "");
              Ol(e, d, c);
              var p = n.ables,
                h = "drag".concat(s ? "Group" : "", "Control");
              return p.forEach(function (n) {
                n[h] && n[h](e, ti(ti({}, t), {
                  datas: i[n.name],
                  inputEvent: a,
                  resolveMatrix: !0,
                  pinchScale: r,
                  parentDistance: u,
                  parentRotate: l,
                  isPinch: !0
                }));
              }), c;
            }
          },
          pinchEnd: function (e, t) {
            var n = t.datas,
              r = t.isPinch,
              o = t.inputEvent,
              i = t.targets,
              a = t.originalDatas;
            if (n.isPinch) {
              var s = "onPinch".concat(i ? "Group" : "", "End"),
                l = zl(e, t, {
                  isDrag: r
                });
              i && (l.targets = i), Ol(e, s, l);
              var u = n.ables,
                c = "drag".concat(i ? "Group" : "", "ControlEnd");
              return u.forEach(function (n) {
                n[c] && n[c](e, ti(ti({}, t), {
                  isDrag: r,
                  datas: a[n.name],
                  inputEvent: o,
                  isPinch: !0
                }));
              }), r;
            }
          },
          pinchGroupStart: function (e, t) {
            return this.pinchStart(e, ti(ti({}, t), {
              targets: e.props.targets
            }));
          },
          pinchGroup: function (e, t) {
            return this.pinch(e, ti(ti({}, t), {
              targets: e.props.targets
            }));
          },
          pinchGroupEnd: function (e, t) {
            return this.pinchEnd(e, ti(ti({}, t), {
              targets: e.props.targets
            }));
          }
        });
        var iu = Ul("scalable");
        xa("scalable"), Hl("scalable");
        function au(e, t) {
          return e.map(function (e, n) {
            return Hn(e, t[n], 1, 2);
          });
        }
        function su(e, t, n) {
          var r = mr(e, t),
            o = mr(e, n) - r;
          return o >= 0 ? o : o + 2 * Math.PI;
        }
        Hl("warpable");
        var lu = Zs("area-pieces"),
          uu = Zs("area-piece"),
          cu = Zs("avoid"),
          du = Zs("view-dragging");
        function pu(e) {
          var t = e.areaElement;
          if (t) {
            var n = e.state,
              r = n.width,
              o = n.height;
            Dr(t, cu), t.style.cssText += "left: 0px; top: 0px; width: ".concat(r, "px; height: ").concat(o, "px");
          }
        }
        function hu(e) {
          return e.createElement("div", {
            key: "area_pieces",
            className: lu
          }, e.createElement("div", {
            className: uu
          }), e.createElement("div", {
            className: uu
          }), e.createElement("div", {
            className: uu
          }), e.createElement("div", {
            className: uu
          }));
        }
        var fu = {
          name: "dragArea",
          props: ["dragArea", "passDragArea"],
          events: ["click", "clickGroup"],
          render: function (e, t) {
            var n = e.props,
              r = n.target,
              o = n.dragArea,
              i = n.groupable,
              a = n.passDragArea,
              s = e.getState(),
              l = s.width,
              u = s.height,
              c = s.renderPoses,
              d = a ? Zs("area", "pass") : Zs("area");
            if (i) return [t.createElement("div", {
              key: "area",
              ref: Rn(e, "areaElement"),
              className: d
            }), hu(t)];
            if (!r || !o) return [];
            var p = ro([0, 0], [l, 0], [0, u], [l, u], c[0], c[1], c[2], c[3]),
              h = p.length ? ol(p, !0) : "none";
            return [t.createElement("div", {
              key: "area",
              ref: Rn(e, "areaElement"),
              className: d,
              style: {
                top: "0px",
                left: "0px",
                width: "".concat(l, "px"),
                height: "".concat(u, "px"),
                transformOrigin: "0 0",
                transform: h
              }
            }), hu(t)];
          },
          dragStart: function (e, t) {
            var n = t.datas,
              r = t.clientX,
              o = t.clientY;
            if (!t.inputEvent) return !1;
            n.isDragArea = !1;
            var i = e.areaElement,
              a = e.state,
              s = a.moveableClientRect,
              l = a.renderPoses,
              u = a.rootMatrix,
              c = a.is3d,
              d = s.left,
              p = s.top,
              h = ul(l),
              f = h.left,
              m = h.top,
              g = h.width,
              v = h.height,
              y = ni(Ll(u, [r - d, o - p], c ? 4 : 3), 2),
              b = y[0],
              w = y[1],
              x = [{
                left: f,
                top: m,
                width: g,
                height: (w -= m) - 10
              }, {
                left: f,
                top: m,
                width: (b -= f) - 10,
                height: v
              }, {
                left: f,
                top: m + w + 10,
                width: g,
                height: v - w - 10
              }, {
                left: f + b + 10,
                top: m,
                width: g - b - 10,
                height: v
              }],
              D = [].slice.call(i.nextElementSibling.children);
            x.forEach(function (e, t) {
              D[t].style.cssText = "left: ".concat(e.left, "px;top: ").concat(e.top, "px; width: ").concat(e.width, "px; height: ").concat(e.height, "px;");
            }), xr(i, cu), a.disableNativeEvent = !0;
          },
          drag: function (e, t) {
            var n = t.datas,
              r = t.inputEvent;
            if (this.enableNativeEvent(e), !r) return !1;
            n.isDragArea || (n.isDragArea = !0, pu(e));
          },
          dragEnd: function (e, t) {
            this.enableNativeEvent(e);
            var n = t.inputEvent,
              r = t.datas;
            if (!n) return !1;
            r.isDragArea || pu(e);
          },
          dragGroupStart: function (e, t) {
            return this.dragStart(e, t);
          },
          dragGroup: function (e, t) {
            return this.drag(e, t);
          },
          dragGroupEnd: function (e, t) {
            return this.dragEnd(e, t);
          },
          unset: function (e) {
            pu(e), e.state.disableNativeEvent = !1;
          },
          enableNativeEvent: function (e) {
            var t = e.state;
            t.disableNativeEvent && sr(function () {
              t.disableNativeEvent = !1;
            });
          }
        };
        oi("origin", {
          props: ["origin", "svgOrigin"],
          render: function (e, t) {
            var n,
              r = e.props,
              o = r.zoom,
              i = r.svgOrigin,
              a = r.groupable,
              s = e.getState(),
              l = s.beforeOrigin,
              u = s.rotation,
              c = s.svg,
              d = s.allMatrix,
              p = s.is3d,
              h = s.left,
              f = s.top,
              m = s.offsetWidth,
              g = s.offsetHeight;
            if (!a && c && i) {
              var v = ni(Ql(i, m, g), 2);
              n = fl(u, o, Kr(sl(d, [v[0], v[1]], p ? 4 : 3), [h, f]));
            } else n = fl(u, o, l);
            return [t.createElement("div", {
              className: Zs("control", "origin"),
              style: n,
              key: "beforeOrigin"
            })];
          }
        });
        var mu = {
          name: "",
          props: ["target", "dragTargetSelf", "dragTarget", "dragContainer", "container", "warpSelf", "rootContainer", "useResizeObserver", "useMutationObserver", "zoom", "dragFocusedInput", "transformOrigin", "ables", "className", "pinchThreshold", "pinchOutside", "triggerAblesSimultaneously", "checkInput", "cspNonce", "translateZ", "hideDefaultLines", "props", "flushSync", "stopPropagation", "preventClickEventOnDrag", "preventClickDefault", "viewContainer", "persistData", "useAccuratePosition", "firstRenderState", "linePadding", "controlPadding", "preventDefault", "preventRightClick", "preventWheelClick", "requestStyles"],
          events: ["changeTargets"]
        };
        oi("padding", {
          props: ["padding"],
          render: function (e, t) {
            var n = e.props;
            if (n.dragArea) return [];
            var r = ou(n.padding || {}),
              o = r.left,
              i = r.top,
              a = r.right,
              s = r.bottom,
              l = e.getState(),
              u = l.renderPoses,
              c = [l.pos1, l.pos2, l.pos3, l.pos4],
              d = [];
            return o > 0 && d.push([0, 2]), i > 0 && d.push([0, 1]), a > 0 && d.push([1, 3]), s > 0 && d.push([2, 3]), d.map(function (e, n) {
              var r = ni(e, 2),
                o = r[0],
                i = r[1],
                a = ro([0, 0], [100, 0], [0, 100], [100, 100], c[o], c[i], u[o], u[i]);
              if (a.length) return t.createElement("div", {
                key: "padding".concat(n),
                className: Zs("padding"),
                style: {
                  transform: ol(a, !0)
                }
              });
            });
          }
        });
        var gu = {
            isPinch: !0,
            name: "beforeRenderable",
            props: [],
            events: ["beforeRenderStart", "beforeRender", "beforeRenderEnd", "beforeRenderGroupStart", "beforeRenderGroup", "beforeRenderGroupEnd"],
            dragRelation: "weak",
            setTransform: function (e, t) {
              var n = e.state,
                r = n.is3d,
                o = n.targetMatrix,
                i = n.inlineTransform,
                a = r ? "matrix3d(".concat(o.join(","), ")") : "matrix(".concat(Hr(o, !0), ")"),
                s = i && "none" !== i ? i : a;
              t.datas.startTransforms = function (e, t) {
                var n = eo(t ? 4 : 3);
                return e === "matrix".concat(t ? "3d" : "", "(").concat(n.join(","), ")") || "matrix(1,0,0,1,0,0)" === e;
              }(s, r) ? [] : er(s);
            },
            resetStyle: function (e) {
              var t = e.datas;
              t.nextStyle = {}, t.nextTransforms = e.datas.startTransforms, t.nextTransformAppendedIndexes = [];
            },
            fillDragStartParams: function (e, t) {
              return Al(e, t, {
                setTransform: function (e) {
                  t.datas.startTransforms = $n(e) ? e : er(e);
                },
                isPinch: !!t.isPinch
              });
            },
            fillDragParams: function (e, t) {
              return Al(e, t, {
                isPinch: !!t.isPinch
              });
            },
            dragStart: function (e, t) {
              this.setTransform(e, t), this.resetStyle(t), Ol(e, "onBeforeRenderStart", this.fillDragStartParams(e, t));
            },
            drag: function (e, t) {
              t.datas.startTransforms || this.setTransform(e, t), this.resetStyle(t), Ol(e, "onBeforeRender", Al(e, t, {
                isPinch: !!t.isPinch
              }));
            },
            dragEnd: function (e, t) {
              t.datas.startTransforms || (this.setTransform(e, t), this.resetStyle(t)), Ol(e, "onBeforeRenderEnd", Al(e, t, {
                isPinch: !!t.isPinch,
                isDrag: t.isDrag
              }));
            },
            dragGroupStart: function (e, t) {
              var n = this;
              this.dragStart(e, t);
              var r = ha(e, "beforeRenderable", t),
                o = e.moveables,
                i = r.map(function (e, t) {
                  var r = o[t];
                  return n.setTransform(r, e), n.resetStyle(e), n.fillDragStartParams(r, e);
                });
              Ol(e, "onBeforeRenderGroupStart", Al(e, t, {
                isPinch: !!t.isPinch,
                targets: e.props.targets,
                setTransform: function () {},
                events: i
              }));
            },
            dragGroup: function (e, t) {
              var n = this;
              this.drag(e, t);
              var r = ha(e, "beforeRenderable", t),
                o = e.moveables,
                i = r.map(function (e, t) {
                  var r = o[t];
                  return n.resetStyle(e), n.fillDragParams(r, e);
                });
              Ol(e, "onBeforeRenderGroup", Al(e, t, {
                isPinch: !!t.isPinch,
                targets: e.props.targets,
                events: i
              }));
            },
            dragGroupEnd: function (e, t) {
              this.dragEnd(e, t), Ol(e, "onBeforeRenderGroupEnd", Al(e, t, {
                isPinch: !!t.isPinch,
                isDrag: t.isDrag,
                targets: e.props.targets
              }));
            },
            dragControlStart: function (e, t) {
              return this.dragStart(e, t);
            },
            dragControl: function (e, t) {
              return this.drag(e, t);
            },
            dragControlEnd: function (e, t) {
              return this.dragEnd(e, t);
            },
            dragGroupControlStart: function (e, t) {
              return this.dragGroupStart(e, t);
            },
            dragGroupControl: function (e, t) {
              return this.dragGroup(e, t);
            },
            dragGroupControlEnd: function (e, t) {
              return this.dragGroupEnd(e, t);
            }
          },
          vu = {
            name: "renderable",
            props: [],
            events: ["renderStart", "render", "renderEnd", "renderGroupStart", "renderGroup", "renderGroupEnd"],
            dragRelation: "weak",
            dragStart: function (e, t) {
              Ol(e, "onRenderStart", Al(e, t, {
                isPinch: !!t.isPinch
              }));
            },
            drag: function (e, t) {
              Ol(e, "onRender", this.fillDragParams(e, t));
            },
            dragAfter: function (e, t) {
              return this.drag(e, t);
            },
            dragEnd: function (e, t) {
              Ol(e, "onRenderEnd", this.fillDragEndParams(e, t));
            },
            dragGroupStart: function (e, t) {
              Ol(e, "onRenderGroupStart", Al(e, t, {
                isPinch: !!t.isPinch,
                targets: e.props.targets
              }));
            },
            dragGroup: function (e, t) {
              var n = this,
                r = ha(e, "beforeRenderable", t),
                o = e.moveables,
                i = r.map(function (e, t) {
                  var r = o[t];
                  return n.fillDragParams(r, e);
                });
              Ol(e, "onRenderGroup", Al(e, t, ti(ti({
                isPinch: !!t.isPinch,
                targets: e.props.targets,
                transform: Ji(t),
                transformObject: {}
              }, Pl(ea(t))), {
                events: i
              })));
            },
            dragGroupEnd: function (e, t) {
              var n = this,
                r = ha(e, "beforeRenderable", t),
                o = e.moveables,
                i = r.map(function (e, t) {
                  var r = o[t];
                  return n.fillDragEndParams(r, e);
                });
              Ol(e, "onRenderGroupEnd", Al(e, t, ti({
                isPinch: !!t.isPinch,
                isDrag: t.isDrag,
                targets: e.props.targets,
                events: i,
                transformObject: {},
                transform: Ji(t)
              }, Pl(ea(t)))));
            },
            dragControlStart: function (e, t) {
              return this.dragStart(e, t);
            },
            dragControl: function (e, t) {
              return this.drag(e, t);
            },
            dragControlAfter: function (e, t) {
              return this.dragAfter(e, t);
            },
            dragControlEnd: function (e, t) {
              return this.dragEnd(e, t);
            },
            dragGroupControlStart: function (e, t) {
              return this.dragGroupStart(e, t);
            },
            dragGroupControl: function (e, t) {
              return this.dragGroup(e, t);
            },
            dragGroupControlEnd: function (e, t) {
              return this.dragGroupEnd(e, t);
            },
            fillDragParams: function (e, t) {
              var n = {};
              return so(Qi(t) || []).forEach(function (e) {
                n[e.name] = e.functionValue;
              }), Al(e, t, ti({
                isPinch: !!t.isPinch,
                transformObject: n,
                transform: Ji(t)
              }, Pl(ea(t))));
            },
            fillDragEndParams: function (e, t) {
              var n = {};
              return so(Qi(t) || []).forEach(function (e) {
                n[e.name] = e.functionValue;
              }), Al(e, t, ti({
                isPinch: !!t.isPinch,
                isDrag: t.isDrag,
                transformObject: n,
                transform: Ji(t)
              }, Pl(ea(t))));
            }
          };
        function yu(e, t, n, r, o, i, a) {
          i.clientDistX = i.distX, i.clientDistY = i.distY;
          var s = "Start" === o,
            l = "End" === o,
            u = "After" === o,
            c = e.state.target,
            d = i.isRequest,
            p = r.indexOf("Control") > -1;
          if (!c || s && p && !d && e.areaElement === i.inputEvent.target) return !1;
          var h = ri([], ni(t), !1);
          if (d) {
            var f = i.requestAble;
            h.some(function (e) {
              return e.name === f;
            }) || h.push.apply(h, ri([], ni(e.props.ables.filter(function (e) {
              return e.name === f;
            })), !1));
          }
          if (!h.length || h.every(function (e) {
            return e.dragRelation;
          })) return !1;
          var m,
            g = i.inputEvent;
          l && g && (m = document.elementFromPoint(i.clientX, i.clientY) || g.target);
          var v = !1,
            y = function () {
              var e;
              v = !0, null === (e = i.stop) || void 0 === e || e.call(i);
            },
            b = s && (!e.targetGesto || !e.controlGesto || !e.targetGesto.isFlag() || !e.controlGesto.isFlag());
          b && e.updateRect(o, !0, !1);
          var w = i.datas,
            x = p ? "controlGesto" : "targetGesto",
            D = e[x],
            C = function (t, n, r) {
              if (!(n in t) || D !== e[x]) return !1;
              var o = t.name,
                a = w[o] || (w[o] = {});
              if (s && (a.isEventStart = !r || !t[r] || t[r](e, i)), !a.isEventStart) return !1;
              var l = t[n](e, ti(ti({}, i), {
                stop: y,
                datas: a,
                originalDatas: w,
                inputTarget: m
              }));
              return e._emitter.off(), s && !1 === l && (a.isEventStart = !1), l;
            };
          b && h.forEach(function (t) {
            t.unset && t.unset(e);
          }), C(gu, "drag".concat(r).concat(o));
          var S = 0,
            E = 0;
          n.forEach(function (t) {
            if (v) return !1;
            var n = "".concat(t).concat(r).concat(o),
              a = "".concat(t).concat(r, "Condition");
            "" !== o || d || Vl(e.state, i);
            var l = h.filter(function (e) {
                return e[n];
              }),
              u = (l = l.filter(function (e, t) {
                return e.name && l.indexOf(e) === t;
              })).filter(function (e) {
                return C(e, n, a);
              }).length;
            v && ++S, u && ++E, !v && s && l.length && !u && (S += l.filter(function (e) {
              var t = e.name;
              return !!w[t].isEventStart && "strong" !== e.dragRelation;
            }).length ? 1 : 0);
          }), u && !E || C(vu, "drag".concat(r).concat(o));
          var _ = D !== e[x] || S === n.length;
          if ((l || v || _) && (e.state.gestos = {}, e.moveables && e.moveables.forEach(function (e) {
            e.state.gestos = {};
          }), h.forEach(function (t) {
            t.unset && t.unset(e);
          })), s && !_ && !d && E && e.props.preventDefault && (null == i || i.preventDefault()), e.isUnmounted || _) return !1;
          (!s && E && !a || l) && (e.props.flushSync || $s)(function () {
            e.updateRect(l ? o : "", !0, !1), e.forceUpdate();
          });
          return s || l || u || !E || a || yu(e, t, n, r, o + "After", i), !0;
        }
        function bu(e, t) {
          return function (n, r) {
            var o;
            void 0 === r && (r = n.inputEvent.target);
            var i = r,
              a = e.areaElement,
              s = e._dragTarget;
            return !(!s || !t && (null === (o = e.controlGesto) || void 0 === o ? void 0 : o.isFlag())) && (i === s || s.contains(i) || i === a || !e.isMoveableElement(i) && !e.controlBox.contains(i) || wr(i, "moveable-area") || wr(i, "moveable-padding") || wr(i, "moveable-edgeDraggable"));
          };
        }
        function wu(e, t, n) {
          var r = e.controlBox,
            o = [],
            i = e.props,
            a = i.dragArea,
            s = e.state.target,
            l = i.dragTarget;
          o.push(r), a && !l || o.push(t), !a && l && s && t !== s && i.dragTargetSelf && o.push(s);
          var u = bu(e);
          return Du(e, o, "targetAbles", n, {
            dragStart: u,
            pinchStart: u
          });
        }
        function xu(e, t) {
          var n = e.controlBox,
            r = [];
          r.push(n);
          var o = bu(e, !0),
            i = function (e, t) {
              return void 0 === t && (t = e.inputEvent.target), t === n || !o(e, t);
            };
          return Du(e, r, "controlAbles", t, {
            dragStart: i,
            pinchStart: i
          });
        }
        function Du(e, t, n, r, o) {
          void 0 === o && (o = {});
          var i = "targetAbles" === n,
            a = e.props,
            s = a.pinchOutside,
            l = a.pinchThreshold,
            u = a.preventClickEventOnDrag,
            c = a.preventClickDefault,
            d = a.checkInput,
            p = a.dragFocusedInput,
            h = a.preventDefault,
            f = void 0 === h || h,
            m = a.preventRightClick,
            g = void 0 === m || m,
            v = a.preventWheelClick,
            y = {
              preventDefault: f,
              preventRightClick: g,
              preventWheelClick: void 0 === v || v,
              container: Zl(a.dragContainer, !0) || kr(e.getControlBoxElement()),
              pinchThreshold: l,
              pinchOutside: s,
              preventClickEventOnDrag: !!i && u,
              preventClickEventOnDragStart: !!i && c,
              preventClickEventByCondition: i ? null : function (t) {
                return e.controlBox.contains(t.target);
              },
              checkInput: !!i && d,
              dragFocusedInput: p
            },
            b = new Zo(t, y),
            w = "Control" === r;
          return ["drag", "pinch"].forEach(function (t) {
            ["Start", "", "End"].forEach(function (i) {
              b.on("".concat(t).concat(i), function (a) {
                var s,
                  l = a.eventType,
                  u = "drag" === t && a.isPinch;
                if (!o[l] || o[l](a)) {
                  if (!u) {
                    var c = "drag" === t ? [t] : ["drag", t],
                      d = ri([], ni(e[n]), !1);
                    yu(e, d, c, r, i, a) ? (e.props.stopPropagation || "Start" === i && w) && (null === (s = null == a ? void 0 : a.inputEvent) || void 0 === s || s.stopPropagation()) : a.stop();
                  }
                } else a.stop();
              });
            });
          }), b;
        }
        var Cu = function () {
          function e(e, t, n) {
            var r = this;
            this.target = e, this.moveable = t, this.eventName = n, this.ables = [], this._onEvent = function (e) {
              var t = r.eventName,
                n = r.moveable;
              n.state.disableNativeEvent || r.ables.forEach(function (r) {
                r[t](n, {
                  inputEvent: e
                });
              });
            }, e.addEventListener(n.toLowerCase(), this._onEvent);
          }
          return e.prototype.setAbles = function (e) {
            this.ables = e;
          }, e.prototype.destroy = function () {
            this.target.removeEventListener(this.eventName.toLowerCase(), this._onEvent), this.target = null, this.moveable = null;
          }, e;
        }();
        function Su(e, t, n, r) {
          var o;
          void 0 === n && (n = t);
          var i = sa(e, t),
            a = i.matrixes,
            s = i.is3d,
            l = i.targetMatrix,
            u = i.transformOrigin,
            c = i.targetOrigin,
            d = i.offsetContainer,
            p = i.hasFixed,
            h = i.zoom,
            f = function (e, t) {
              if (ca) {
                var n = ar(ca, function (n) {
                  return n[0][0] == e && n[0][1] == t;
                });
                if (n) return n[1];
              }
              var r = sa(e, t, !0);
              return ca && ca.push([[e, t], r]), r;
            }(d, n),
            m = f.matrixes,
            g = f.is3d,
            v = f.offsetContainer,
            y = f.zoom,
            b = r || g || s,
            w = b ? 4 : 3,
            x = "svg" !== e.tagName.toLowerCase() && "ownerSVGElement" in e,
            D = l,
            C = eo(w),
            S = eo(w),
            E = eo(w),
            _ = eo(w),
            P = a.length,
            k = m.map(function (e) {
              return ti(ti({}, e), {
                matrix: e.matrix ? ri([], ni(e.matrix), !1) : void 0
              });
            }).reverse();
          a.reverse(), !s && b && (D = Br(D, 3, 4), nl(a)), !g && b && nl(k), k.forEach(function (e) {
            S = Lr(S, e.matrix, w);
          });
          var A = n || Pr(e),
            z = (null === (o = k[0]) || void 0 === o ? void 0 : o.target) || Js(A, A, !0).offsetParent,
            T = k.slice(1).reduce(function (e, t) {
              return Lr(e, t.matrix, w);
            }, eo(w));
          a.forEach(function (e, t) {
            if (P - 2 === t && (E = C.slice()), P - 1 === t && (_ = C.slice()), !e.matrix) {
              var n = function (e, t, n, r, o) {
                var i,
                  a = e.target,
                  s = e.origin,
                  l = t.matrix,
                  u = gl(a),
                  c = u.offsetWidth,
                  d = u.offsetHeight,
                  p = n.getBoundingClientRect(),
                  h = [0, 0];
                n === Pr(n) && (h = tl(a, !0));
                for (var f = a.getBoundingClientRect(), m = f.left - p.left + n.scrollLeft - (n.clientLeft || 0) + h[0], g = f.top - p.top + n.scrollTop - (n.clientTop || 0) + h[1], v = f.width, y = f.height, b = Nr(r, o, l), w = cl(b, c, d, r), x = w.left, D = w.top, C = w.width, S = w.height, E = sl(b, s, r), _ = Kr(E, [x, D]), P = [m + _[0] * v / C, g + _[1] * y / S], k = [0, 0], A = 0; ++A < 10;) {
                  var z = Mr(o, r);
                  i = ni(Kr(sl(z, P, r), sl(z, E, r)), 2), k[0] = i[0], k[1] = i[1];
                  var T = cl(Nr(r, o, no(k, r), l), c, d, r),
                    O = T.left - m,
                    I = T.top - g;
                  if (nu(O) < 2 && nu(I) < 2) break;
                  P[0] -= O, P[1] -= I;
                }
                return k.map(function (e) {
                  return Math.round(e);
                });
              }(e, a[t + 1], z, w, Lr(T, C, w));
              e.matrix = no(n, w);
            }
            C = Lr(C, e.matrix, w);
          });
          var O = !x && s;
          D || (D = eo(O ? 4 : 3));
          var I = ol(x && 16 === D.length ? Br(D, 4, 3) : D, O),
            F = S;
          return S = Fr(S, w, w), {
            hasZoom: 1 !== h || 1 !== y,
            hasFixed: p,
            matrixes: a,
            rootMatrix: S,
            originalRootMatrix: F,
            beforeMatrix: E,
            offsetMatrix: _,
            allMatrix: C,
            targetMatrix: D,
            targetTransform: I,
            inlineTransform: e.style.transform,
            transformOrigin: u,
            targetOrigin: c,
            is3d: b,
            offsetContainer: d,
            offsetRootContainer: v
          };
        }
        function Eu(e, t, n, r) {
          void 0 === n && (n = t);
          var o = 0,
            i = 0,
            a = 0,
            s = {},
            l = gl(e);
          if (e && (o = l.offsetWidth, i = l.offsetHeight), e) {
            var u = Su(e, t, n, r),
              c = Mi(u.allMatrix, u.transformOrigin, o, i);
            s = ti(ti({}, u), c);
            var d = Mi(u.allMatrix, [50, 50], 100, 100);
            a = vl([d.pos1, d.pos2], d.direction);
          }
          var p = r ? 4 : 3;
          return ti(ti(ti({
            hasZoom: !1,
            width: o,
            height: i,
            rotation: a
          }, l), {
            originalRootMatrix: eo(p),
            rootMatrix: eo(p),
            beforeMatrix: eo(p),
            offsetMatrix: eo(p),
            allMatrix: eo(p),
            targetMatrix: eo(p),
            targetTransform: "",
            inlineTransform: "",
            transformOrigin: [0, 0],
            targetOrigin: [0, 0],
            is3d: !!r,
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            origin: [0, 0],
            pos1: [0, 0],
            pos2: [0, 0],
            pos3: [0, 0],
            pos4: [0, 0],
            direction: 1,
            hasFixed: !1,
            offsetContainer: null,
            offsetRootContainer: null,
            matrixes: []
          }), s);
        }
        function _u(e, t, n, r, o, i) {
          void 0 === i && (i = []);
          var a = 1,
            s = [0, 0],
            l = {
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              right: 0,
              bottom: 0,
              clientLeft: 0,
              clientTop: 0,
              clientWidth: 0,
              clientHeight: 0,
              scrollWidth: 0,
              scrollHeight: 0
            },
            u = {
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              right: 0,
              bottom: 0,
              clientLeft: 0,
              clientTop: 0,
              clientWidth: 0,
              clientHeight: 0,
              scrollWidth: 0,
              scrollHeight: 0
            },
            c = {
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              right: 0,
              bottom: 0,
              clientLeft: 0,
              clientTop: 0,
              clientWidth: 0,
              clientHeight: 0,
              scrollWidth: 0,
              scrollHeight: 0
            },
            d = {
              left: 0,
              top: 0,
              width: 0,
              height: 0,
              right: 0,
              bottom: 0,
              clientLeft: 0,
              clientTop: 0,
              clientWidth: 0,
              clientHeight: 0,
              scrollWidth: 0,
              scrollHeight: 0
            },
            p = [0, 0],
            h = {},
            f = Eu(t, n, o, !0);
          if (t) {
            var m = pa(t);
            i.forEach(function (e) {
              h[e] = m(e);
            });
            var g = f.is3d ? 4 : 3,
              v = Mi(f.offsetMatrix, Vr(f.transformOrigin, Rr(f.targetMatrix, g)), f.width, f.height);
            a = v.direction, s = Vr(v.origin, [v.left - f.left, v.top - f.top]), d = wl(f.offsetRootContainer);
            var y = Js(r, r, !0).offsetParent || f.offsetRootContainer;
            if (f.hasZoom) {
              var b = Mi(Lr(f.originalRootMatrix, f.allMatrix), f.transformOrigin, f.width, f.height),
                w = Mi(f.originalRootMatrix, Xs(pa(y)("transformOrigin")).map(function (e) {
                  return parseFloat(e);
                }), y.offsetWidth, y.offsetHeight);
              if (l = bl(b, d), c = bl(w, d, y, !0), e) {
                var x = b.left,
                  D = b.top;
                u = bl({
                  left: x,
                  top: D,
                  bottom: D,
                  right: D
                }, d);
              }
            } else {
              l = wl(t), c = function (e) {
                var t = null == ua ? void 0 : ua.get(e);
                if (t) return t;
                var n = wl(e, !0);
                return ua && ua.set(e, n), n;
              }(y), e && (u = wl(e));
              var C = c.left,
                S = c.top,
                E = c.clientLeft,
                _ = c.clientTop,
                P = [l.left - C, l.top - S];
              p = Kr(Ll(f.rootMatrix, P, 4), [E + f.left, _ + f.top]);
            }
          }
          return ti({
            targetClientRect: l,
            containerClientRect: c,
            moveableClientRect: u,
            rootContainerClientRect: d,
            beforeDirection: a,
            beforeOrigin: s,
            originalBeforeOrigin: s,
            target: t,
            style: h,
            offsetDelta: p
          }, f);
        }
        function Pu(e) {
          var t = e.pos1,
            n = e.pos2,
            r = e.pos3,
            o = e.pos4;
          if (!(t && n && r && o)) return null;
          var i = ko([t, n, r, o]),
            a = [i.minX, i.minY],
            s = Kr(e.origin, a);
          return t = Kr(t, a), n = Kr(n, a), r = Kr(r, a), o = Kr(o, a), ti(ti({}, e), {
            left: e.left,
            top: e.top,
            posDelta: a,
            pos1: t,
            pos2: n,
            pos3: r,
            pos4: o,
            origin: s,
            beforeOrigin: s,
            isPersisted: !0
          });
        }
        var ku = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.state = ti({
                container: null,
                gestos: {},
                renderLines: [[[0, 0], [0, 0]], [[0, 0], [0, 0]], [[0, 0], [0, 0]], [[0, 0], [0, 0]]],
                renderPoses: [[0, 0], [0, 0], [0, 0], [0, 0]],
                disableNativeEvent: !1,
                posDelta: [0, 0]
              }, _u(null)), t.renderState = {}, t.enabledAbles = [], t.targetAbles = [], t.controlAbles = [], t.rotation = 0, t.scale = [1, 1], t.isMoveableMounted = !1, t.isUnmounted = !1, t.events = {
                mouseEnter: null,
                mouseLeave: null
              }, t._emitter = new Co(), t._prevOriginalDragTarget = null, t._originalDragTarget = null, t._prevDragTarget = null, t._dragTarget = null, t._prevPropTarget = null, t._propTarget = null, t._prevDragArea = !1, t._isPropTargetChanged = !1, t._hasFirstTarget = !1, t._reiszeObserver = null, t._observerId = 0, t._mutationObserver = null, t._rootContainer = null, t._viewContainer = null, t._viewClassNames = [], t._store = {}, t.checkUpdateRect = function () {
                if (!t.isDragging()) {
                  var e = t.props.parentMoveable;
                  e ? e.checkUpdateRect() : (lr(t._observerId), t._observerId = sr(function () {
                    t.isDragging() || t.updateRect();
                  }));
                }
              }, t._onPreventClick = function (e) {
                e.stopPropagation(), e.preventDefault();
              }, t;
            }
            return ei(t, e), t.prototype.render = function () {
              var e = this.props,
                t = this.getState(),
                n = e.parentPosition,
                r = e.className,
                o = e.target,
                i = e.zoom,
                a = e.cspNonce,
                l = e.translateZ,
                u = e.cssStyled,
                c = e.groupable,
                d = e.linePadding,
                p = e.controlPadding;
              this._checkUpdateRootContainer(), this.checkUpdate(), this.updateRenderPoses();
              var h = ni(n || [0, 0], 2),
                f = h[0],
                m = h[1],
                g = t.left,
                v = t.top,
                y = t.target,
                b = t.direction,
                w = t.hasFixed,
                x = t.offsetDelta,
                D = e.targets,
                C = this.isDragging(),
                S = {};
              this.getEnabledAbles().forEach(function (e) {
                S["data-able-".concat(e.name.toLowerCase())] = !0;
              });
              var E = this._getAbleClassName(),
                _ = D && D.length && (y || c) || o || !this._hasFirstTarget && this.state.isPersisted,
                P = this.controlBox || this.props.firstRenderState || this.props.persistData,
                k = [g - f, v - m];
              !c && e.useAccuratePosition && (k[0] += x[0], k[1] += x[1]);
              var A = {
                position: w ? "fixed" : "absolute",
                display: _ ? "block" : "none",
                visibility: P ? "visible" : "hidden",
                transform: "translate3d(".concat(k[0], "px, ").concat(k[1], "px, ").concat(l, ")"),
                "--zoom": i,
                "--zoompx": "".concat(i, "px")
              };
              return d && (A["--moveable-line-padding"] = d), p && (A["--moveable-control-padding"] = p), s.createElement(u, ti({
                cspNonce: a,
                ref: Rn(this, "controlBox"),
                className: "".concat(Zs("control-box", -1 === b ? "reverse" : "", C ? "dragging" : ""), " ").concat(E, " ").concat(r)
              }, S, {
                onClick: this._onPreventClick,
                style: A
              }), this.renderAbles(), this._renderLines());
            }, t.prototype.componentDidMount = function () {
              this.isMoveableMounted = !0, this.isUnmounted = !1;
              var e = this.props,
                t = e.parentMoveable,
                n = e.container;
              this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateTargets(), this._updateNativeEvents(), this._updateEvents(), this.updateCheckInput(), this._updateObserver(this.props), n || t || this.state.isPersisted || (this.updateRect("", !1, !1), this.forceUpdate());
            }, t.prototype.componentDidUpdate = function (e) {
              this._checkUpdateRootContainer(), this._checkUpdateViewContainer(), this._updateNativeEvents(), this._updateTargets(), this._updateEvents(), this.updateCheckInput(), this._updateObserver(e);
            }, t.prototype.componentWillUnmount = function () {
              var e, t;
              this.isMoveableMounted = !1, this.isUnmounted = !0, this._emitter.off(), null === (e = this._reiszeObserver) || void 0 === e || e.disconnect(), null === (t = this._mutationObserver) || void 0 === t || t.disconnect(), this._viewContainer && this._changeAbleViewClassNames([]), _l(this, !1), _l(this, !0);
              var n = this.events;
              for (var r in n) {
                var o = n[r];
                o && o.destroy();
              }
            }, t.prototype.getTargets = function () {
              var e = this.props.target;
              return e ? [e] : [];
            }, t.prototype.getAble = function (e) {
              return ar(this.props.ables || [], function (t) {
                return t.name === e;
              });
            }, t.prototype.getContainer = function () {
              var e = this.props,
                t = e.parentMoveable,
                n = e.wrapperMoveable;
              return e.container || n && n.getContainer() || t && t.getContainer() || this.controlBox.parentElement;
            }, t.prototype.getControlBoxElement = function () {
              return this.controlBox;
            }, t.prototype.getDragElement = function () {
              return this._dragTarget;
            }, t.prototype.isMoveableElement = function (e) {
              var t;
              return e && ((null === (t = e.getAttribute) || void 0 === t ? void 0 : t.call(e, "class")) || "").indexOf(wi) > -1;
            }, t.prototype.dragStart = function (e, t) {
              void 0 === t && (t = e.target);
              var n = this.targetGesto,
                r = this.controlGesto;
              return n && bu(this)({
                inputEvent: e
              }, t) ? n.isFlag() || n.triggerDragStart(e) : r && this.isMoveableElement(t) && (r.isFlag() || r.triggerDragStart(e)), this;
            }, t.prototype.hitTest = function (e) {
              var t,
                n = this.state,
                r = n.target,
                o = n.pos1,
                i = n.pos2,
                a = n.pos3,
                s = n.pos4,
                l = n.targetClientRect;
              if (!r) return 0;
              if (zr(e)) {
                var u = e.getBoundingClientRect();
                t = {
                  left: u.left,
                  top: u.top,
                  width: u.width,
                  height: u.height
                };
              } else t = ti({
                width: 0,
                height: 0
              }, e);
              var c = t.left,
                d = t.top,
                p = t.width,
                h = t.height,
                f = Po([o, i, s, a], l),
                m = Mo(f, [[c, d], [c + p, d], [c + p, d + h], [c, d + h]]),
                g = _o(f);
              return m && g ? Math.min(100, m / g * 100) : 0;
            }, t.prototype.isInside = function (e, t) {
              var n = this.state,
                r = n.target,
                o = n.pos1,
                i = n.pos2,
                a = n.pos3,
                s = n.pos4,
                l = n.targetClientRect;
              return !!r && Ao([e, t], Po([o, i, s, a], l));
            }, t.prototype.updateRect = function (e, t, n) {
              void 0 === n && (n = !0);
              var r = this.props,
                o = !r.parentPosition && !r.wrapperMoveable;
              o && da(!0);
              var i = r.parentMoveable,
                a = this.state.target || r.target,
                s = this.getContainer(),
                l = i ? i._rootContainer : this._rootContainer,
                u = _u(this.controlBox, a, s, s, l || s, this._getRequestStyles());
              if (!a && this._hasFirstTarget && r.persistData) {
                var c = Pu(r.persistData);
                for (var d in c) u[d] = c[d];
              }
              o && da(), this.updateState(u, !i && n);
            }, t.prototype.isDragging = function (e) {
              var t,
                n,
                r = this.targetGesto,
                o = this.controlGesto;
              return (null == r ? void 0 : r.isFlag()) ? !e || !!(null === (t = r.getEventData()[e]) || void 0 === t ? void 0 : t.isEventStart) : !!(null == o ? void 0 : o.isFlag()) && (!e || !!(null === (n = o.getEventData()[e]) || void 0 === n ? void 0 : n.isEventStart));
            }, t.prototype.updateTarget = function (e) {
              this.updateRect(e, !0);
            }, t.prototype.getRect = function () {
              var e = this.state,
                t = Sl(this.state),
                n = ni(t, 4),
                r = n[0],
                o = n[1],
                i = n[2],
                a = n[3],
                s = ul(t),
                l = e.width,
                u = e.height,
                c = s.width,
                d = s.height,
                p = s.left,
                h = s.top,
                f = [e.left, e.top],
                m = Vr(f, e.origin);
              return {
                width: c,
                height: d,
                left: p,
                top: h,
                pos1: r,
                pos2: o,
                pos3: i,
                pos4: a,
                offsetWidth: l,
                offsetHeight: u,
                beforeOrigin: Vr(f, e.beforeOrigin),
                origin: m,
                transformOrigin: e.transformOrigin,
                rotation: this.getRotation()
              };
            }, t.prototype.getManager = function () {
              return this;
            }, t.prototype.stopDrag = function (e) {
              var t;
              e && "target" !== e || (!1 === (null == (t = this.targetGesto) ? void 0 : t.isIdle()) && El(this, !1), null == t || t.stop());
              e && "control" !== e || (!1 === (null == (t = this.controlGesto) ? void 0 : t.isIdle()) && El(this, !0), null == t || t.stop());
            }, t.prototype.getRotation = function () {
              var e = this.state;
              return function (e, t, n) {
                var r = mr(e, t) / Math.PI * 180;
                return (r = n >= 0 ? r : 180 - r) >= 0 ? r : 360 + r;
              }(e.pos1, e.pos2, e.direction);
            }, t.prototype.request = function (e, t, n) {
              void 0 === t && (t = {});
              var r = this,
                o = r.props,
                i = o.parentMoveable || o.wrapperMoveable || r,
                a = i.props.ables,
                s = o.groupable,
                l = ar(a, function (t) {
                  return t.name === e;
                });
              if (this.isDragging() || !l || !l.request) return {
                request: function () {
                  return this;
                },
                requestEnd: function () {
                  return this;
                }
              };
              var u = l.request(r),
                c = n || t.isInstant,
                d = u.isControl ? "controlAbles" : "targetAbles",
                p = "".concat(s ? "Group" : "").concat(u.isControl ? "Control" : ""),
                h = ri([], ni(i[d]), !1),
                f = {
                  request: function (t) {
                    return yu(r, h, ["drag"], p, "", ti(ti({}, u.request(t)), {
                      requestAble: e,
                      isRequest: !0
                    }), c), f;
                  },
                  requestEnd: function () {
                    return yu(r, h, ["drag"], p, "End", ti(ti({}, u.requestEnd()), {
                      requestAble: e,
                      isRequest: !0
                    }), c), f;
                  }
                };
              return yu(r, h, ["drag"], p, "Start", ti(ti({}, u.requestStart(t)), {
                requestAble: e,
                isRequest: !0
              }), c), c ? f.request(t).requestEnd() : f;
            }, t.prototype.getMoveables = function () {
              return [this];
            }, t.prototype.destroy = function () {
              this.componentWillUnmount();
            }, t.prototype.updateRenderPoses = function () {
              var e = this.getState(),
                t = this.props,
                n = t.padding,
                r = e.originalBeforeOrigin,
                o = e.transformOrigin,
                i = e.allMatrix,
                a = e.is3d,
                s = e.pos1,
                l = e.pos2,
                u = e.pos3,
                c = e.pos4,
                d = e.left,
                p = e.top,
                h = e.isPersisted,
                f = t.zoom || 1;
              if (!n && f <= 1) return e.renderPoses = [s, l, u, c], void (e.renderLines = [[s, l], [l, c], [c, u], [u, s]]);
              var m = ou(n || {}),
                g = m.left,
                v = m.top,
                y = m.bottom,
                b = m.right,
                w = a ? 4 : 3,
                x = Nr(w, no((h ? o : this.controlBox && t.groupable ? r : Vr(r, [d, p])).map(function (e) {
                  return -e;
                }), w), i, no(o, w)),
                D = Kl(x, s, [-g, -v], w),
                C = Kl(x, l, [b, -v], w),
                S = Kl(x, u, [-g, y], w),
                E = Kl(x, c, [b, y], w);
              if (e.renderPoses = [D, C, S, E], e.renderLines = [[D, C], [C, E], [E, S], [S, D]], f) {
                var _ = f / 2;
                e.renderLines = [[Kl(x, s, [-g - _, -v], w), Kl(x, l, [b + _, -v], w)], [Kl(x, l, [b, -v - _], w), Kl(x, c, [b, y + _], w)], [Kl(x, c, [b + _, y], w), Kl(x, u, [-g - _, y], w)], [Kl(x, u, [-g, y + _], w), Kl(x, s, [-g, -v - _], w)]];
              }
            }, t.prototype.checkUpdate = function () {
              this._isPropTargetChanged = !1;
              var e = this.props,
                t = e.target,
                n = e.container,
                r = e.parentMoveable,
                o = this.state,
                i = o.target,
                a = o.container;
              if (i || t) {
                this.updateAbles();
                var s = !Ml(i, t);
                if (s || !Ml(a, n)) {
                  var l = n || this.controlBox;
                  l && this.unsetAbles(), this.updateState({
                    target: t,
                    container: n
                  }), !r && l && this.updateRect("End", !1, !1), this._isPropTargetChanged = s;
                }
              }
            }, t.prototype.waitToChangeTarget = function () {
              return new Promise(function () {});
            }, t.prototype.triggerEvent = function (e, t) {
              var n = this.props;
              if (this._emitter.trigger(e, t), n.parentMoveable && t.isRequest && !t.isRequestChild) return n.parentMoveable.triggerEvent(e, t, !0);
              var r = n[e];
              return r && r(t);
            }, t.prototype.useCSS = function (e, t) {
              var n = this.props.customStyledMap,
                r = e + t;
              return n[r] || (n[r] = Qo(e, t)), n[r];
            }, t.prototype.getState = function () {
              var e,
                t = this.props;
              (t.target || (null === (e = t.targets) || void 0 === e ? void 0 : e.length)) && (this._hasFirstTarget = !0);
              var n = this.controlBox,
                r = t.persistData,
                o = t.firstRenderState;
              if (o && !n) return o;
              if (!this._hasFirstTarget && r) {
                var i = Pu(r);
                if (i) return this.updateState(i, !1), this.state;
              }
              return this.state.isPersisted = !1, this.state;
            }, t.prototype.updateSelectors = function () {}, t.prototype.unsetAbles = function () {
              var e = this;
              this.targetAbles.forEach(function (t) {
                t.unset && t.unset(e);
              });
            }, t.prototype.updateAbles = function (e, t) {
              void 0 === e && (e = this.props.ables), void 0 === t && (t = "");
              var n = this.props.triggerAblesSimultaneously,
                r = this.getEnabledAbles(e),
                o = "drag".concat(t, "Start"),
                i = "pinch".concat(t, "Start"),
                a = "drag".concat(t, "ControlStart"),
                s = Fl(r, [o, i], n),
                l = Fl(r, [a], n);
              this.enabledAbles = r, this.targetAbles = s, this.controlAbles = l;
            }, t.prototype.updateState = function (e, t) {
              if (t) {
                if (this.isUnmounted) return;
                this.setState(e);
              } else {
                var n = this.state;
                for (var r in e) n[r] = e[r];
              }
            }, t.prototype.getEnabledAbles = function (e) {
              void 0 === e && (e = this.props.ables);
              var t = this.props;
              return e.filter(function (e) {
                return e && (e.always && !1 !== t[e.name] || t[e.name]);
              });
            }, t.prototype.renderAbles = function () {
              var e,
                t,
                n,
                r,
                o = this,
                i = this.props.triggerAblesSimultaneously,
                a = {
                  createElement: s.createElement
                };
              return this.renderState = {}, (e = Bl(Fl(this.getEnabledAbles(), ["render"], i).map(function (e) {
                return (0, e.render)(o, a) || [];
              })).filter(function (e) {
                return e;
              }), t = function (e) {
                return e.key;
              }, n = [], r = {}, e.forEach(function (o, i) {
                var a = t(o, i, e),
                  s = r[a];
                s || (s = [], r[a] = s, n.push(s)), s.push(o);
              }), n).map(function (e) {
                return e[0];
              });
            }, t.prototype.updateCheckInput = function () {
              this.targetGesto && (this.targetGesto.options.checkInput = this.props.checkInput);
            }, t.prototype._getRequestStyles = function () {
              var e = this.getEnabledAbles().reduce(function (e, t) {
                var n,
                  r,
                  o = null !== (r = null === (n = t.requestStyle) || void 0 === n ? void 0 : n.call(t)) && void 0 !== r ? r : [];
                return ri(ri([], ni(e), !1), ni(o), !1);
              }, ri([], ni(this.props.requestStyles || []), !1));
              return e;
            }, t.prototype._updateObserver = function (e) {
              this._updateResizeObserver(e), this._updateMutationObserver(e);
            }, t.prototype._updateEvents = function () {
              var e = this.targetAbles.length,
                t = this.controlAbles.length,
                n = this._dragTarget;
              (!e && this.targetGesto || this._isTargetChanged(!0)) && (_l(this, !1), this.updateState({
                gestos: {}
              })), t || _l(this, !0), n && e && !this.targetGesto && (this.targetGesto = wu(this, n, "")), !this.controlGesto && t && (this.controlGesto = xu(this, "Control"));
            }, t.prototype._updateTargets = function () {
              var e = this.props;
              this._prevPropTarget = this._propTarget, this._prevDragTarget = this._dragTarget, this._prevOriginalDragTarget = this._originalDragTarget, this._prevDragArea = e.dragArea, this._propTarget = e.target, this._originalDragTarget = e.dragTarget || e.target, this._dragTarget = Zl(this._originalDragTarget, !0);
            }, t.prototype._renderLines = function () {
              var e = this.props,
                t = e.zoom,
                n = e.hideDefaultLines,
                r = e.hideChildMoveableDefaultLines,
                o = e.parentMoveable;
              if (n || o && r) return [];
              var i = this.getState(),
                a = {
                  createElement: s.createElement
                };
              return i.renderLines.map(function (e, n) {
                return ba(a, "", e[0], e[1], t, "render-line-".concat(n));
              });
            }, t.prototype._isTargetChanged = function (e) {
              var t = this.props,
                n = t.dragTarget || t.target,
                r = this._prevOriginalDragTarget,
                o = this._prevDragArea,
                i = t.dragArea;
              return !i && r !== n || (e || i) && o !== i || this._prevPropTarget != this._propTarget;
            }, t.prototype._updateNativeEvents = function () {
              var e = this,
                t = this.props.dragArea ? this.areaElement : this.state.target,
                n = this.events,
                r = ur(n);
              if (this._isTargetChanged()) for (var o in n) {
                var i = n[o];
                i && i.destroy(), n[o] = null;
              }
              if (t) {
                var a = this.enabledAbles;
                r.forEach(function (r) {
                  var o = Fl(a, [r]),
                    i = o.length > 0,
                    s = n[r];
                  i ? (s || (s = new Cu(t, e, r), n[r] = s), s.setAbles(o)) : s && (s.destroy(), n[r] = null);
                });
              }
            }, t.prototype._checkUpdateRootContainer = function () {
              var e = this.props.rootContainer;
              !this._rootContainer && e && (this._rootContainer = Zl(e, !0));
            }, t.prototype._checkUpdateViewContainer = function () {
              var e = this.props.viewContainer;
              !this._viewContainer && e && (this._viewContainer = Zl(e, !0)), this._viewContainer && this._changeAbleViewClassNames(ri(ri([], ni(this._getAbleViewClassNames()), !1), [this.isDragging() ? du : ""], !1));
            }, t.prototype._changeAbleViewClassNames = function (e) {
              var t = this._viewContainer,
                n = jl(e.filter(Boolean), function (e) {
                  return e;
                }).map(function (e) {
                  return ni(e, 1)[0];
                }),
                r = this._viewClassNames,
                o = fo(r, n),
                i = o.removed,
                a = o.added;
              i.forEach(function (e) {
                Dr(t, r[e]);
              }), a.forEach(function (e) {
                xr(t, n[e]);
              }), this._viewClassNames = n;
            }, t.prototype._getAbleViewClassNames = function () {
              var e = this;
              return (this.getEnabledAbles().map(function (t) {
                var n;
                return (null === (n = t.viewClassName) || void 0 === n ? void 0 : n.call(t, e)) || "";
              }).join(" ") + " ".concat(this._getAbleClassName("-view"))).split(/\s+/g);
            }, t.prototype._getAbleClassName = function (e) {
              var t = this;
              void 0 === e && (e = "");
              var n = this.getEnabledAbles(),
                r = this.targetGesto,
                o = this.controlGesto,
                i = (null == r ? void 0 : r.isFlag()) ? r.getEventData() : {},
                a = (null == o ? void 0 : o.isFlag()) ? o.getEventData() : {};
              return n.map(function (n) {
                var r,
                  o,
                  s,
                  l = n.name,
                  u = (null === (r = n.className) || void 0 === r ? void 0 : r.call(n, t)) || "";
                return ((null === (o = i[l]) || void 0 === o ? void 0 : o.isEventStart) || (null === (s = a[l]) || void 0 === s ? void 0 : s.isEventStart)) && (u += " ".concat(Zs("".concat(l).concat(e, "-dragging")))), u.trim();
              }).filter(Boolean).join(" ");
            }, t.prototype._updateResizeObserver = function (e) {
              var t,
                n = this.props,
                r = n.target,
                o = kr(this.getControlBoxElement());
              if (o.ResizeObserver && r && n.useResizeObserver) {
                if (e.target !== r || !this._reiszeObserver) {
                  var i = new o.ResizeObserver(this.checkUpdateRect);
                  i.observe(r, {
                    box: "border-box"
                  }), this._reiszeObserver = i;
                }
              } else null === (t = this._reiszeObserver) || void 0 === t || t.disconnect();
            }, t.prototype._updateMutationObserver = function (e) {
              var t,
                n = this,
                r = this.props,
                o = r.target,
                i = kr(this.getControlBoxElement());
              if (i.MutationObserver && o && r.useMutationObserver) {
                if (e.target !== o || !this._mutationObserver) {
                  var a = new i.MutationObserver(function (e) {
                    var t, r;
                    try {
                      for (var o = function (e) {
                          var t = "function" == typeof Symbol && Symbol.iterator,
                            n = t && e[t],
                            r = 0;
                          if (n) return n.call(e);
                          if (e && "number" == typeof e.length) return {
                            next: function () {
                              return e && r >= e.length && (e = void 0), {
                                value: e && e[r++],
                                done: !e
                              };
                            }
                          };
                          throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
                        }(e), i = o.next(); !i.done; i = o.next()) {
                        var a = i.value;
                        "attributes" === a.type && "style" === a.attributeName && n.checkUpdateRect();
                      }
                    } catch (e) {
                      t = {
                        error: e
                      };
                    } finally {
                      try {
                        i && !i.done && (r = o.return) && r.call(o);
                      } finally {
                        if (t) throw t.error;
                      }
                    }
                  });
                  a.observe(o, {
                    attributes: !0
                  }), this._mutationObserver = a;
                }
              } else null === (t = this._mutationObserver) || void 0 === t || t.disconnect();
            }, t.defaultProps = {
              dragTargetSelf: !1,
              target: null,
              dragTarget: null,
              container: null,
              rootContainer: null,
              origin: !0,
              parentMoveable: null,
              wrapperMoveable: null,
              isWrapperMounted: !1,
              parentPosition: null,
              warpSelf: !1,
              svgOrigin: "",
              dragContainer: null,
              useResizeObserver: !1,
              useMutationObserver: !1,
              preventDefault: !0,
              preventRightClick: !0,
              preventWheelClick: !0,
              linePadding: 0,
              controlPadding: 0,
              ables: [],
              pinchThreshold: 20,
              dragArea: !1,
              passDragArea: !1,
              transformOrigin: "",
              className: "",
              zoom: 1,
              triggerAblesSimultaneously: !1,
              padding: {},
              pinchOutside: !0,
              checkInput: !1,
              dragFocusedInput: !1,
              groupable: !1,
              hideDefaultLines: !1,
              cspNonce: "",
              translateZ: 0,
              cssStyled: null,
              customStyledMap: {},
              props: {},
              stopPropagation: !1,
              preventClickDefault: !1,
              preventClickEventOnDrag: !0,
              flushSync: $s,
              firstRenderState: null,
              persistData: null,
              viewContainer: null,
              requestStyles: [],
              useAccuratePosition: !1
            }, t;
          }(s.PureComponent),
          Au = {
            name: "groupable",
            props: ["defaultGroupRotate", "useDefaultGroupRotate", "defaultGroupOrigin", "groupable", "groupableProps", "targetGroups", "hideChildMoveableDefaultLines"],
            events: [],
            render: function (e, t) {
              var n,
                r = e.props,
                o = r.targets || [],
                i = e.getState(),
                a = i.left,
                s = i.top,
                l = i.isPersisted,
                u = r.zoom || 1,
                c = e.renderGroupRects,
                d = (null === (n = r.persistData) || void 0 === n ? void 0 : n.children) || [];
              l ? o = d.map(function () {
                return null;
              }) : d = [];
              var p = eu(e, "parentPosition", [a, s], function (e) {
                  return e.join(",");
                }),
                h = eu(e, "requestStyles", e.getRequestChildStyles(), function (e) {
                  return e.join(",");
                });
              return e.moveables = e.moveables.slice(0, o.length), ri(ri([], ni(o.map(function (n, o) {
                return t.createElement(ku, {
                  key: "moveable" + o,
                  ref: jn(e, "moveables", o),
                  target: n,
                  origin: !1,
                  requestStyles: h,
                  cssStyled: r.cssStyled,
                  customStyledMap: r.customStyledMap,
                  useResizeObserver: r.useResizeObserver,
                  useMutationObserver: r.useMutationObserver,
                  hideChildMoveableDefaultLines: r.hideChildMoveableDefaultLines,
                  parentMoveable: e,
                  parentPosition: [a, s],
                  persistData: d[o],
                  zoom: u
                });
              })), !1), ni(Bl(c.map(function (e, n) {
                var r = [e.pos1, e.pos2, e.pos3, e.pos4];
                return [[0, 1], [1, 3], [3, 2], [2, 0]].map(function (e, o) {
                  var i = ni(e, 2),
                    a = i[0],
                    s = i[1];
                  return ba(t, "", Kr(r[a], p), Kr(r[s], p), u, "group-rect-".concat(n, "-").concat(o));
                });
              }))), !1);
            }
          };
        oi("clickable", {
          props: ["clickable"],
          events: ["click", "clickGroup"],
          always: !0,
          dragRelation: "weak",
          dragStart: function () {},
          dragControlStart: function () {},
          dragGroupStart: function (e, t) {
            t.datas.inputTarget = t.inputEvent && t.inputEvent.target;
          },
          dragEnd: function (e, t) {
            var n = e.props.target,
              r = t.inputEvent,
              o = t.inputTarget,
              i = !e.isMoveableElement(o) && e.controlBox.contains(o);
            if (r && o && !t.isDrag && !e.isMoveableElement(o) && !i) {
              var a = n.contains(o);
              Ol(e, "onClick", Al(e, t, {
                isDouble: t.isDouble,
                inputTarget: o,
                isTarget: n === o,
                moveableTarget: e.props.target,
                containsTarget: a
              }));
            }
          },
          dragGroupEnd: function (e, t) {
            var n = t.inputEvent,
              r = t.inputTarget;
            if (n && r && !t.isDrag && !e.isMoveableElement(r) && t.datas.inputTarget !== r) {
              var o = e.props.targets,
                i = o.indexOf(r),
                a = i > -1,
                s = !1;
              -1 === i && (s = (i = ir(o, function (e) {
                return e.contains(r);
              })) > -1), Ol(e, "onClickGroup", Al(e, t, {
                isDouble: t.isDouble,
                targets: o,
                inputTarget: r,
                targetIndex: i,
                isTarget: a,
                containsTarget: s,
                moveableTarget: o[i]
              }));
            }
          },
          dragControlEnd: function (e, t) {
            this.dragEnd(e, t);
          },
          dragGroupControlEnd: function (e, t) {
            this.dragEnd(e, t);
          }
        });
        function zu(e) {
          var t = e.originalDatas.draggable;
          return t || (e.originalDatas.draggable = {}, t = e.originalDatas.draggable), ti(ti({}, e), {
            datas: t
          });
        }
        oi("edgeDraggable", {
          css: [".edge.edgeDraggable.line {\ncursor: move;\n}"],
          render: function (e, t) {
            var n = e.props,
              r = n.edgeDraggable;
            return r ? wa(t, "edgeDraggable", r, e.getState().renderPoses, n.zoom) : [];
          },
          dragCondition: function (e, t) {
            var n,
              r = e.props,
              o = null === (n = t.inputEvent) || void 0 === n ? void 0 : n.target;
            return !(!r.edgeDraggable || !o) && !r.draggable && wr(o, Zs("direction")) && wr(o, Zs("edge")) && wr(o, Zs("edgeDraggable"));
          },
          dragStart: function (e, t) {
            return ps.dragStart(e, zu(t));
          },
          drag: function (e, t) {
            return ps.drag(e, zu(t));
          },
          dragEnd: function (e, t) {
            return ps.dragEnd(e, zu(t));
          },
          dragGroupCondition: function (e, t) {
            var n,
              r = e.props,
              o = null === (n = t.inputEvent) || void 0 === n ? void 0 : n.target;
            return !(!r.edgeDraggable || !o) && !r.draggable && wr(o, Zs("direction")) && wr(o, Zs("line"));
          },
          dragGroupStart: function (e, t) {
            return ps.dragGroupStart(e, zu(t));
          },
          dragGroup: function (e, t) {
            return ps.dragGroup(e, zu(t));
          },
          dragGroupEnd: function (e, t) {
            return ps.dragGroupEnd(e, zu(t));
          },
          unset: function (e) {
            return ps.unset(e);
          }
        });
        var Tu = {
          name: "individualGroupable",
          props: ["individualGroupable", "individualGroupableProps"],
          events: []
        };
        function Ou(e, t) {
          var n = ni(e, 3),
            r = n[0],
            o = n[1],
            i = n[2];
          return (r * t[0] + o * t[1] + i) / Math.sqrt(r * r + o * o);
        }
        function Iu(e, t) {
          var n = ni(e, 2),
            r = n[0],
            o = n[1];
          return -r * t[0] - o * t[1];
        }
        function Fu(e, t) {
          return Math.max.apply(Math, ri([], ni(e.map(function (e) {
            var n = ni(e, 4),
              r = n[0],
              o = n[1],
              i = n[2],
              a = n[3];
            return Math.max(r[t], o[t], i[t], a[t]);
          })), !1));
        }
        function Mu(e, t) {
          return Math.min.apply(Math, ri([], ni(e.map(function (e) {
            var n = ni(e, 4),
              r = n[0],
              o = n[1],
              i = n[2],
              a = n[3];
            return Math.min(r[t], o[t], i[t], a[t]);
          })), !1));
        }
        function Ru(e, t) {
          var n = t.map(function (t) {
            if ($n(t)) {
              var n = Ru(e, t),
                r = n.length;
              return r > 1 ? n : 1 === r ? n[0] : null;
            }
            var o = ar(e, function (e) {
              return e.manager.props.target === t;
            });
            return o ? (o.finded = !0, o.manager) : null;
          }).filter(Boolean);
          return 1 === n.length && $n(n[0]) ? n[0] : n;
        }
        var ju = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.differ = new wo(), t.moveables = [], t.transformOrigin = "50% 50%", t.renderGroupRects = [], t._targetGroups = [], t._hasFirstTargets = !1, t;
            }
            return ei(t, e), t.prototype.componentDidMount = function () {
              e.prototype.componentDidMount.call(this);
            }, t.prototype.checkUpdate = function () {
              this._isPropTargetChanged = !1, this.updateAbles();
            }, t.prototype.getTargets = function () {
              return this.props.targets;
            }, t.prototype.updateRect = function (e, t, n) {
              var r;
              void 0 === n && (n = !0);
              var o = this.state;
              if (this.controlBox && !o.isPersisted) {
                da(!0), this.moveables.forEach(function (t) {
                  t.updateRect(e, !1, !1);
                });
                var i = this.props,
                  a = this.moveables,
                  s = o.target || i.target,
                  l = a.map(function (e) {
                    return {
                      finded: !1,
                      manager: e
                    };
                  }),
                  u = this.props.targetGroups || [],
                  c = Ru(l, u),
                  d = i.useDefaultGroupRotate;
                c.push.apply(c, ri([], ni(l.filter(function (e) {
                  return !e.finded;
                }).map(function (e) {
                  return e.manager;
                })), !1));
                var p = [],
                  h = !t || "" !== e && i.updateGroup,
                  f = i.defaultGroupRotate || 0;
                if (!this._hasFirstTargets) {
                  var m = null === (r = i.persistData) || void 0 === r ? void 0 : r.rotation;
                  null != m && (f = m);
                }
                var g = function e(t, n, r) {
                  var o = t.map(function (t) {
                      if ($n(t)) {
                        var r = e(t, n),
                          o = [r.pos1, r.pos2, r.pos3, r.pos4];
                        return p.push(r), {
                          poses: o,
                          rotation: r.rotation
                        };
                      }
                      return {
                        poses: Sl(t.state),
                        rotation: t.getRotation()
                      };
                    }),
                    i = o.map(function (e) {
                      return e.rotation;
                    }),
                    a = 0,
                    s = i[0],
                    l = i.every(function (e) {
                      return Math.abs(s - e) < .1;
                    });
                  a = h ? !d && l ? s : f : d || r || !l ? n : s;
                  var u = o.map(function (e) {
                      return e.poses;
                    }),
                    c = function (e, t) {
                      var n,
                        r,
                        o,
                        i = [0, 0],
                        a = [0, 0],
                        s = [0, 0],
                        l = [0, 0],
                        u = 0,
                        c = 0;
                      if (!e.length) return {
                        pos1: i,
                        pos2: a,
                        pos3: s,
                        pos4: l,
                        minX: 0,
                        minY: 0,
                        maxX: 0,
                        maxY: 0,
                        width: u,
                        height: c,
                        rotation: t
                      };
                      var d = yr(t, Ei);
                      if (d % 90) {
                        var p = d / 180 * Math.PI,
                          h = Math.tan(p),
                          f = -1 / h,
                          m = [Pi, ki],
                          g = [[0, 0], [0, 0]],
                          v = [Pi, ki],
                          y = [[0, 0], [0, 0]];
                        e.forEach(function (e) {
                          e.forEach(function (e) {
                            var t = Ou([-h, 1, 0], e),
                              n = Ou([-f, 1, 0], e);
                            m[0] > t && (g[0] = e, m[0] = t), m[1] < t && (g[1] = e, m[1] = t), v[0] > n && (y[0] = e, v[0] = n), v[1] < n && (y[1] = e, v[1] = n);
                          });
                        });
                        var b = ni(g, 2),
                          w = b[0],
                          x = b[1],
                          D = ni(y, 2),
                          C = D[0],
                          S = D[1],
                          E = [-h, 1, Iu([-h, 1], w)],
                          _ = [-h, 1, Iu([-h, 1], x)],
                          P = [-f, 1, Iu([-f, 1], C)],
                          k = [-f, 1, Iu([-f, 1], S)];
                        n = ni([[E, P], [E, k], [_, P], [_, k]].map(function (e) {
                          var t = ni(e, 2);
                          return To(t[0], t[1])[0];
                        }), 4), i = n[0], a = n[1], s = n[2], l = n[3], u = v[1] - v[0], c = m[1] - m[0];
                      } else {
                        var A = Mu(e, 0),
                          z = Mu(e, 1),
                          T = Fu(e, 0),
                          O = Fu(e, 1);
                        i = [A, z], a = [T, z], s = [A, O], l = [T, O], u = T - A, c = O - z, d % 180 && (i = (r = ni([s, i, l, a], 4))[0], a = r[1], s = r[2], l = r[3], u = O - z, c = T - A);
                      }
                      d % 360 > 180 && (i = (o = ni([l, s, a, i], 4))[0], a = o[1], s = o[2], l = o[3]);
                      var I = ko([i, a, s, l]);
                      return {
                        pos1: i,
                        pos2: a,
                        pos3: s,
                        pos4: l,
                        width: u,
                        height: c,
                        minX: I.minX,
                        minY: I.minY,
                        maxX: I.maxX,
                        maxY: I.maxY,
                        rotation: t
                      };
                    }(u, a);
                  return c;
                }(c, this.rotation, !0);
                h && (this.rotation = g.rotation, this.transformOrigin = i.defaultGroupOrigin || "50% 50%", this.scale = [1, 1]), this._targetGroups = u, this.renderGroupRects = p;
                var v,
                  y,
                  b,
                  w,
                  x,
                  D = this.transformOrigin,
                  C = this.rotation,
                  S = this.scale,
                  E = g.width,
                  _ = g.height,
                  P = g.minX,
                  k = g.minY,
                  A = (v = [[0, 0], [E, 0], [0, _], [E, _]], y = Ql(D, E, _), b = this.rotation / 180 * Math.PI, w = v.map(function (e) {
                    return Kr(e, y);
                  }), x = w.map(function (e) {
                    return Yr(e, b);
                  }), {
                    prev: w,
                    next: x,
                    result: x.map(function (e) {
                      return Vr(e, y);
                    })
                  }),
                  z = ko(A.result),
                  T = z.minX,
                  O = z.minY,
                  I = " rotate(".concat(C, "deg)") + " scale(".concat(tu(S[0]), ", ").concat(tu(S[1]), ")"),
                  F = "translate(".concat(-T, "px, ").concat(-O, "px)").concat(I);
                this.controlBox.style.transform = "translate3d(".concat(P, "px, ").concat(k, "px, ").concat(this.props.translateZ || 0, ")"), s.style.cssText += "left:0px;top:0px;" + "transform-origin:".concat(D, ";") + "width:".concat(E, "px;height:").concat(_, "px;") + "transform: ".concat(F), o.width = E, o.height = _;
                var M = this.getContainer(),
                  R = _u(this.controlBox, s, this.controlBox, this.getContainer(), this._rootContainer || M, []),
                  j = [R.left, R.top],
                  B = ni(Sl(R), 4),
                  N = B[0],
                  L = B[1],
                  V = B[2],
                  K = B[3],
                  q = ko([N, L, V, K]),
                  H = [q.minX, q.minY],
                  U = tu(S[0] * S[1]);
                R.pos1 = Kr(N, H), R.pos2 = Kr(L, H), R.pos3 = Kr(V, H), R.pos4 = Kr(K, H), R.left = P - R.left + H[0], R.top = k - R.top + H[1], R.origin = Kr(Vr(j, R.origin), H), R.beforeOrigin = Kr(Vr(j, R.beforeOrigin), H), R.originalBeforeOrigin = Vr(j, R.originalBeforeOrigin), R.transformOrigin = Kr(Vr(j, R.transformOrigin), H), s.style.transform = "translate(".concat(-T - H[0], "px, ").concat(-O - H[1], "px)") + I, da(), this.updateState(ti(ti({}, R), {
                  posDelta: H,
                  direction: U,
                  beforeDirection: U
                }), n);
              }
            }, t.prototype.getRect = function () {
              return ti(ti({}, e.prototype.getRect.call(this)), {
                children: this.moveables.map(function (e) {
                  return e.getRect();
                })
              });
            }, t.prototype.triggerEvent = function (t, n, r) {
              if (r || t.indexOf("Group") > -1) return e.prototype.triggerEvent.call(this, t, n);
              this._emitter.trigger(t, n);
            }, t.prototype.getRequestChildStyles = function () {
              var e = this.getEnabledAbles().reduce(function (e, t) {
                var n,
                  r,
                  o = null !== (r = null === (n = t.requestChildStyle) || void 0 === n ? void 0 : n.call(t)) && void 0 !== r ? r : [];
                return ri(ri([], ni(e), !1), ni(o), !1);
              }, []);
              return e;
            }, t.prototype.getMoveables = function () {
              return ri([], ni(this.moveables), !1);
            }, t.prototype.updateAbles = function () {
              e.prototype.updateAbles.call(this, ri(ri([], ni(this.props.ables), !1), [Au], !1), "Group");
            }, t.prototype._updateTargets = function () {
              e.prototype._updateTargets.call(this), this._originalDragTarget = this.props.dragTarget || this.areaElement, this._dragTarget = Zl(this._originalDragTarget, !0);
            }, t.prototype._updateEvents = function () {
              var e = this.state,
                t = this.props,
                n = this._prevDragTarget,
                r = t.dragTarget || this.areaElement,
                o = t.targets,
                i = this.differ.update(o),
                a = i.added,
                s = i.changed,
                l = i.removed,
                u = a.length || l.length;
              (u || this._prevOriginalDragTarget !== this._originalDragTarget) && (_l(this, !1), _l(this, !0), this.updateState({
                gestos: {}
              })), n !== r && (e.target = null), e.target || (e.target = this.areaElement, this.controlBox.style.display = "block"), e.target && (this.targetGesto || (this.targetGesto = wu(this, this._dragTarget, "Group")), this.controlGesto || (this.controlGesto = xu(this, "GroupControl")));
              var c = !Ml(e.container, t.container);
              c && (e.container = t.container), (c || u || this.transformOrigin !== (t.defaultGroupOrigin || "50% 50%") || s.length || o.length && !Jl(this._targetGroups, t.targetGroups || [])) && (this.updateRect(), this._hasFirstTargets = !0), this._isPropTargetChanged = !!u;
            }, t.prototype._updateObserver = function () {}, t.defaultProps = ti(ti({}, ku.defaultProps), {
              transformOrigin: ["50%", "50%"],
              groupable: !0,
              dragArea: !0,
              keepRatio: !0,
              targets: [],
              defaultGroupRotate: 0,
              defaultGroupOrigin: "50% 50%"
            }), t;
          }(ku),
          Bu = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.moveables = [], t;
            }
            return ei(t, e), t.prototype.render = function () {
              var e,
                t = this,
                n = this.props,
                r = n.cspNonce,
                o = n.cssStyled,
                i = n.persistData,
                a = n.targets || [],
                l = a.length,
                u = this.isUnmounted || !l,
                c = null !== (e = null == i ? void 0 : i.children) && void 0 !== e ? e : [];
              return u && !l && c.length ? a = c.map(function () {
                return null;
              }) : u || (c = []), s.createElement(o, {
                cspNonce: r,
                ref: Rn(this, "controlBox"),
                className: Zs("control-box")
              }, a.map(function (e, r) {
                var o,
                  i,
                  a = null !== (i = null === (o = n.individualGroupableProps) || void 0 === o ? void 0 : o.call(n, e, r)) && void 0 !== i ? i : {};
                return s.createElement(ku, ti({
                  key: "moveable" + r,
                  ref: jn(t, "moveables", r)
                }, n, a, {
                  target: e,
                  wrapperMoveable: t,
                  isWrapperMounted: t.isMoveableMounted,
                  persistData: c[r]
                }));
              }));
            }, t.prototype.componentDidMount = function () {}, t.prototype.componentDidUpdate = function () {}, t.prototype.getTargets = function () {
              return this.props.targets;
            }, t.prototype.updateRect = function (e, t, n) {
              void 0 === n && (n = !0), da(!0), this.moveables.forEach(function (r) {
                r.updateRect(e, t, n);
              }), da();
            }, t.prototype.getRect = function () {
              return ti(ti({}, e.prototype.getRect.call(this)), {
                children: this.moveables.map(function (e) {
                  return e.getRect();
                })
              });
            }, t.prototype.request = function (e, t, n) {
              void 0 === t && (t = {});
              var r = this.moveables.map(function (n) {
                  return n.request(e, ti(ti({}, t), {
                    isInstant: !1
                  }), !1);
                }),
                o = {
                  request: function (e) {
                    return r.forEach(function (t) {
                      return t.request(e);
                    }), this;
                  },
                  requestEnd: function () {
                    return r.forEach(function (e) {
                      return e.requestEnd();
                    }), this;
                  }
                };
              return n || t.isInstant ? o.request(t).requestEnd() : o;
            }, t.prototype.dragStart = function (e, t) {
              void 0 === t && (t = e.target);
              var n = t,
                r = ar(this.moveables, function (e) {
                  var t = e.getTargets()[0],
                    r = e.getControlBoxElement(),
                    o = e.getDragElement();
                  return !(!t || !o) && (o === n || o.contains(n) || o !== t && t === n || t.contains(n) || r === n || r.contains(n));
                });
              return r && r.dragStart(e, t), this;
            }, t.prototype.hitTest = function () {
              return 0;
            }, t.prototype.isInside = function () {
              return !1;
            }, t.prototype.isDragging = function () {
              return !1;
            }, t.prototype.getDragElement = function () {
              return null;
            }, t.prototype.getMoveables = function () {
              return ri([], ni(this.moveables), !1);
            }, t.prototype.updateRenderPoses = function () {}, t.prototype.checkUpdate = function () {}, t.prototype.triggerEvent = function () {}, t.prototype.updateAbles = function () {}, t.prototype._updateEvents = function () {}, t.prototype._updateObserver = function () {}, t;
          }(ku);
        function Nu(e, t) {
          var n = [];
          return e.forEach(function (e) {
            e && (Gn(e) ? t[e] && n.push.apply(n, ri([], ni(t[e]), !1)) : $n(e) ? n.push.apply(n, ri([], ni(Nu(e, t)), !1)) : n.push(e));
          }), n;
        }
        function Lu(e, t) {
          var n = [];
          return e.forEach(function (e) {
            e && (Gn(e) ? t[e] && n.push.apply(n, ri([], ni(t[e]), !1)) : $n(e) ? n.push(Lu(e, t)) : n.push(e));
          }), n;
        }
        function Vu(e, t) {
          return e.length !== t.length || e.some(function (e, n) {
            var r = t[n];
            return !(!e && !r) && e != r && (!$n(e) || !$n(r) || Vu(e, r));
          });
        }
        var Ku = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.refTargets = [], t.selectorMap = {}, t._differ = new wo(), t._elementTargets = [], t._tmpRefTargets = [], t._tmpSelectorMap = {}, t._onChangeTargets = null, t;
          }
          var n, r;
          return ei(t, e), t.makeStyled = function () {
            var e = {};
            this.getTotalAbles().forEach(function (t) {
              var n = t.css;
              n && n.forEach(function (t) {
                e[t] = !0;
              });
            });
            var t = ur(e).join("\n");
            this.defaultStyled = Qo("div", function (e, t) {
              return t.replace(/([^}{]*){/gm, function (t, n) {
                return n.replace(/\.([^{,\s\d.]+)/g, "." + e + "$1") + "{";
              });
            }(wi, Di + t));
          }, t.getTotalAbles = function () {
            return ri([mu, Au, Tu, fu], ni(this.defaultAbles), !1);
          }, t.prototype.render = function () {
            var e,
              t = this.constructor;
            t.defaultStyled || t.makeStyled();
            var n = this.props,
              r = n.ables,
              o = n.props,
              i = function (e, t) {
                var n = {};
                for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                  var o = 0;
                  for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                }
                return n;
              }(n, ["ables", "props"]),
              a = ni(this._updateRefs(!0), 2),
              l = a[0],
              u = a[1],
              c = Nu(l, u),
              d = c.length > 1,
              p = ri(ri([], ni(t.getTotalAbles()), !1), ni(r || []), !1),
              h = ti(ti(ti({}, i), o || {}), {
                ables: p,
                cssStyled: t.defaultStyled,
                customStyledMap: t.customStyledMap
              });
            this._elementTargets = c;
            var f = null,
              m = this.moveable,
              g = i.persistData;
            if ((null == g ? void 0 : g.children) && (d = !0), i.individualGroupable) return s.createElement(Bu, ti({
              key: "individual-group",
              ref: Rn(this, "moveable")
            }, h, {
              target: null,
              targets: c
            }));
            if (d) {
              var v = Lu(l, u);
              if (m && !m.props.groupable && !m.props.individualGroupable) {
                var y = m.props.target;
                y && c.indexOf(y) > -1 && (f = ti({}, m.state));
              }
              return s.createElement(ju, ti({
                key: "group",
                ref: Rn(this, "moveable")
              }, h, null !== (e = i.groupableProps) && void 0 !== e ? e : {}, {
                target: null,
                targets: c,
                targetGroups: v,
                firstRenderState: f
              }));
            }
            var b = c[0];
            if (m && (m.props.groupable || m.props.individualGroupable)) {
              var w = ar(m.moveables || [], function (e) {
                return e.props.target === b;
              });
              w && (f = ti({}, w.state));
            }
            return s.createElement(ku, ti({
              key: "single",
              ref: Rn(this, "moveable")
            }, h, {
              target: b,
              firstRenderState: f
            }));
          }, t.prototype.componentDidMount = function () {
            this._checkChangeTargets();
          }, t.prototype.componentDidUpdate = function () {
            this._checkChangeTargets();
          }, t.prototype.componentWillUnmount = function () {
            this.selectorMap = {}, this.refTargets = [];
          }, t.prototype.getTargets = function () {
            var e, t;
            return null !== (t = null === (e = this.moveable) || void 0 === e ? void 0 : e.getTargets()) && void 0 !== t ? t : [];
          }, t.prototype.updateSelectors = function () {
            this.selectorMap = {}, this._updateRefs(), this.forceUpdate();
          }, t.prototype.waitToChangeTarget = function () {
            var e,
              t = this;
            return this._onChangeTargets = function () {
              t._onChangeTargets = null, e();
            }, new Promise(function (t) {
              e = t;
            });
          }, t.prototype.waitToChangeTargets = function () {
            return this.waitToChangeTarget();
          }, t.prototype.getManager = function () {
            return this.moveable;
          }, t.prototype.getMoveables = function () {
            return this.moveable.getMoveables();
          }, t.prototype.getDragElement = function () {
            return this.moveable.getDragElement();
          }, t.prototype._updateRefs = function (e) {
            var t = this.refTargets,
              n = $l(this.props.target || this.props.targets),
              r = "undefined" != typeof document,
              o = Vu(t, n),
              i = this.selectorMap,
              a = {};
            return this.refTargets.forEach(function e(t) {
              Gn(t) ? i[t] ? a[t] = i[t] : r && (o = !0, a[t] = [].slice.call(document.querySelectorAll(t))) : $n(t) && t.forEach(e);
            }), this._tmpRefTargets = n, this._tmpSelectorMap = a, [n, a, !e && o];
          }, t.prototype._checkChangeTargets = function () {
            var e, t, n;
            this.refTargets = this._tmpRefTargets, this.selectorMap = this._tmpSelectorMap;
            var r = this._differ.update(this._elementTargets),
              o = r.added,
              i = r.removed;
            (o.length || i.length) && (null === (t = (e = this.props).onChangeTargets) || void 0 === t || t.call(e, {
              moveable: this.moveable,
              targets: this._elementTargets
            }), null === (n = this._onChangeTargets) || void 0 === n || n.call(this));
            var a = ni(this._updateRefs(), 3),
              s = a[0],
              l = a[1],
              u = a[2];
            this.refTargets = s, this.selectorMap = l, u && this.forceUpdate();
          }, t.defaultAbles = [], t.customStyledMap = {}, t.defaultStyled = null, function (e, t, n, r) {
            var o,
              i = arguments.length,
              a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
            if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
            i > 3 && a && Object.defineProperty(t, n, a);
          }([(n = Oi, void 0 === r && (r = {}), function (e, t) {
            n.forEach(function (n) {
              var o = r[n] || n;
              o in e || (e[o] = function () {
                for (var e, r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
                var i = (e = this[t])[n].apply(e, r);
                return i === this[t] ? this : i;
              });
            });
          })], t.prototype, "moveable", void 0), t;
        }(s.PureComponent);
        function qu(e, t) {
          const {
            "aria-label": n,
            "aria-labelledby": r,
            orientation: o = "horizontal"
          } = e;
          let [i, a] = (0, s.useState)(!1);
          (0, Be.bt)(() => {
            var e;
            a(!(!t.current || !(null === (e = t.current.parentElement) || void 0 === e ? void 0 : e.closest('[role="toolbar"]'))));
          });
          const {
              direction: l
            } = (0, Ht.bU)(),
            u = "rtl" === l && "horizontal" === o;
          let c = (0, lt.E7)(t);
          const d = (0, s.useRef)(null);
          return {
            toolbarProps: {
              role: i ? "group" : "toolbar",
              "aria-orientation": o,
              "aria-label": n,
              "aria-labelledby": null == n ? r : void 0,
              onKeyDownCapture: i ? void 0 : e => {
                if (e.currentTarget.contains(e.target)) {
                  if ("horizontal" === o && "ArrowRight" === e.key || "vertical" === o && "ArrowDown" === e.key) u ? c.focusPrevious() : c.focusNext();else {
                    if (!("horizontal" === o && "ArrowLeft" === e.key || "vertical" === o && "ArrowUp" === e.key)) return "Tab" === e.key ? (e.stopPropagation(), d.current = document.activeElement, void (e.shiftKey ? c.focusFirst() : c.focusLast())) : void 0;
                    u ? c.focusNext() : c.focusPrevious();
                  }
                  e.stopPropagation(), e.preventDefault();
                }
              },
              onFocusCapture: i ? void 0 : e => {
                var n, r;
                d.current && !e.currentTarget.contains(e.relatedTarget) && (null === (n = t.current) || void 0 === n ? void 0 : n.contains(e.target)) && (null === (r = d.current) || void 0 === r || r.focus(), d.current = null);
              },
              onBlurCapture: i ? void 0 : e => {
                e.currentTarget.contains(e.relatedTarget) || d.current || (d.current = e.target);
              }
            }
          };
        }
        !function (e, t, n, r) {
          Object.defineProperty(e, t, {
            get: n,
            set: r,
            enumerable: !0,
            configurable: !0
          });
        }({}, "useToolbar", () => qu);
        var Hu = n(96486),
          Uu = n(77493),
          Zu = n(6907),
          $u = n.n(Zu),
          Gu = n(23279),
          Wu = n.n(Gu),
          Yu = n(23493),
          Xu = n.n(Yu);
        const Qu = e => "object" == typeof e && null != e && 1 === e.nodeType,
          Ju = (e, t) => (!t || "hidden" !== e) && "visible" !== e && "clip" !== e,
          ec = (e, t) => {
            if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
              const n = getComputedStyle(e, null);
              return Ju(n.overflowY, t) || Ju(n.overflowX, t) || (e => {
                const t = (e => {
                  if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
                  try {
                    return e.ownerDocument.defaultView.frameElement;
                  } catch (e) {
                    return null;
                  }
                })(e);
                return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
              })(e);
            }
            return !1;
          },
          tc = (e, t, n, r, o, i, a, s) => i < e && a > t || i > e && a < t ? 0 : i <= e && s <= n || a >= t && s >= n ? i - e - r : a > t && s < n || i < e && s > n ? a - t + o : 0,
          nc = e => {
            const t = e.parentElement;
            return null == t ? e.getRootNode().host || null : t;
          },
          rc = (e, t) => {
            var n, r, o, i;
            if ("undefined" == typeof document) return [];
            const {
                scrollMode: a,
                block: s,
                inline: l,
                boundary: u,
                skipOverflowHiddenElements: c
              } = t,
              d = "function" == typeof u ? u : e => e !== u;
            if (!Qu(e)) throw new TypeError("Invalid target");
            const p = document.scrollingElement || document.documentElement,
              h = [];
            let f = e;
            for (; Qu(f) && d(f);) {
              if (f = nc(f), f === p) {
                h.push(f);
                break;
              }
              null != f && f === document.body && ec(f) && !ec(document.documentElement) || null != f && ec(f, c) && h.push(f);
            }
            const m = null != (r = null == (n = window.visualViewport) ? void 0 : n.width) ? r : innerWidth,
              g = null != (i = null == (o = window.visualViewport) ? void 0 : o.height) ? i : innerHeight,
              {
                scrollX: v,
                scrollY: y
              } = window,
              {
                height: b,
                width: w,
                top: x,
                right: D,
                bottom: C,
                left: S
              } = e.getBoundingClientRect(),
              {
                top: E,
                right: _,
                bottom: P,
                left: k
              } = (e => {
                const t = window.getComputedStyle(e);
                return {
                  top: parseFloat(t.scrollMarginTop) || 0,
                  right: parseFloat(t.scrollMarginRight) || 0,
                  bottom: parseFloat(t.scrollMarginBottom) || 0,
                  left: parseFloat(t.scrollMarginLeft) || 0
                };
              })(e);
            let A = "start" === s || "nearest" === s ? x - E : "end" === s ? C + P : x + b / 2 - E + P,
              z = "center" === l ? S + w / 2 - k + _ : "end" === l ? D + _ : S - k;
            const T = [];
            for (let e = 0; e < h.length; e++) {
              const t = h[e],
                {
                  height: n,
                  width: r,
                  top: o,
                  right: i,
                  bottom: u,
                  left: c
                } = t.getBoundingClientRect();
              if ("if-needed" === a && x >= 0 && S >= 0 && C <= g && D <= m && x >= o && C <= u && S >= c && D <= i) return T;
              const d = getComputedStyle(t),
                f = parseInt(d.borderLeftWidth, 10),
                E = parseInt(d.borderTopWidth, 10),
                _ = parseInt(d.borderRightWidth, 10),
                P = parseInt(d.borderBottomWidth, 10);
              let k = 0,
                O = 0;
              const I = "offsetWidth" in t ? t.offsetWidth - t.clientWidth - f - _ : 0,
                F = "offsetHeight" in t ? t.offsetHeight - t.clientHeight - E - P : 0,
                M = "offsetWidth" in t ? 0 === t.offsetWidth ? 0 : r / t.offsetWidth : 0,
                R = "offsetHeight" in t ? 0 === t.offsetHeight ? 0 : n / t.offsetHeight : 0;
              if (p === t) k = "start" === s ? A : "end" === s ? A - g : "nearest" === s ? tc(y, y + g, g, E, P, y + A, y + A + b, b) : A - g / 2, O = "start" === l ? z : "center" === l ? z - m / 2 : "end" === l ? z - m : tc(v, v + m, m, f, _, v + z, v + z + w, w), k = Math.max(0, k + y), O = Math.max(0, O + v);else {
                k = "start" === s ? A - o - E : "end" === s ? A - u + P + F : "nearest" === s ? tc(o, u, n, E, P + F, A, A + b, b) : A - (o + n / 2) + F / 2, O = "start" === l ? z - c - f : "center" === l ? z - (c + r / 2) + I / 2 : "end" === l ? z - i + _ + I : tc(c, i, r, f, _ + I, z, z + w, w);
                const {
                  scrollLeft: e,
                  scrollTop: a
                } = t;
                k = 0 === R ? 0 : Math.max(0, Math.min(a + k / R, t.scrollHeight - n / R + F)), O = 0 === M ? 0 : Math.max(0, Math.min(e + O / M, t.scrollWidth - r / M + I)), A += a - k, z += e - O;
              }
              T.push({
                el: t,
                top: k,
                left: O
              });
            }
            return T;
          };
        function oc(e, t) {
          if (!e.isConnected || !(e => {
            let t = e;
            for (; t && t.parentNode;) {
              if (t.parentNode === document) return !0;
              t = t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
            }
            return !1;
          })(e)) return;
          const n = (e => {
            const t = window.getComputedStyle(e);
            return {
              top: parseFloat(t.scrollMarginTop) || 0,
              right: parseFloat(t.scrollMarginRight) || 0,
              bottom: parseFloat(t.scrollMarginBottom) || 0,
              left: parseFloat(t.scrollMarginLeft) || 0
            };
          })(e);
          if ((e => "object" == typeof e && "function" == typeof e.behavior)(t)) return t.behavior(rc(e, t));
          const r = "boolean" == typeof t || null == t ? void 0 : t.behavior;
          for (const {
            el: o,
            top: i,
            left: a
          } of rc(e, (e => !1 === e ? {
            block: "end",
            inline: "nearest"
          } : (e => e === Object(e) && 0 !== Object.keys(e).length)(e) ? e : {
            block: "start",
            inline: "nearest"
          })(t))) {
            const e = i - n.top + n.bottom,
              t = a - n.left + n.right;
            o.scroll({
              top: e,
              left: t,
              behavior: r
            });
          }
        }
        var ic = n(86254),
          ac = n(59619);
        function sc(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        function lc(e) {
          return lc = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, lc(e);
        }
        function uc(e) {
          var t = function (e, t) {
            if ("object" !== lc(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" !== lc(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" === lc(t) ? t : String(t);
        }
        function cc(e, t, n) {
          return (t = uc(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var dc,
          pc,
          hc = (0, s.createContext)(null),
          fc = () => {
            var e = (0, s.useContext)(hc);
            if (!e) throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
            return e;
          },
          mc = parseInt(s.version.split(".")[0], 10),
          gc = "undefined" != typeof navigator && "undefined" != typeof window && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
          vc = "undefined" != typeof navigator && /Mac OS X/.test(navigator.userAgent),
          yc = "undefined" != typeof navigator && /Android/.test(navigator.userAgent),
          bc = "undefined" != typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),
          wc = "undefined" != typeof navigator && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent),
          xc = "undefined" != typeof navigator && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent),
          Dc = "undefined" != typeof navigator && /Chrome/i.test(navigator.userAgent),
          Cc = "undefined" != typeof navigator && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent),
          Sc = yc && "undefined" != typeof navigator && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent),
          Ec = "undefined" != typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent),
          _c = "undefined" != typeof navigator && /.*UCBrowser/.test(navigator.userAgent),
          Pc = "undefined" != typeof navigator && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent),
          kc = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement);
        "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && /Version\/(\d+)/.test(navigator.userAgent) && null !== (dc = navigator.userAgent.match(/Version\/(\d+)/)) && void 0 !== dc && dc[1] && parseInt(null === (pc = navigator.userAgent.match(/Version\/(\d+)/)) || void 0 === pc ? void 0 : pc[1], 10);
        var Ac = (!Cc || !Sc) && !xc && "undefined" != typeof globalThis && globalThis.InputEvent && "function" == typeof globalThis.InputEvent.prototype.getTargetRanges,
          zc = new WeakMap(),
          Tc = new WeakMap(),
          Oc = new WeakMap(),
          Ic = new WeakMap(),
          Fc = new WeakMap(),
          Mc = new WeakMap(),
          Rc = new WeakMap(),
          jc = new WeakMap(),
          Bc = new WeakMap(),
          Nc = new WeakMap(),
          Lc = new WeakMap(),
          Vc = new WeakMap(),
          Kc = new WeakMap(),
          qc = new WeakMap(),
          Hc = new WeakMap(),
          Uc = new WeakMap(),
          Zc = new WeakMap(),
          $c = new WeakMap(),
          Gc = new WeakMap(),
          Wc = new WeakMap(),
          Yc = new WeakMap(),
          Xc = Symbol("placeholder"),
          Qc = Symbol("mark-placeholder"),
          Jc = globalThis.Text,
          ed = e => e && e.ownerDocument && e.ownerDocument.defaultView || null,
          td = e => nd(e) && 1 === e.nodeType,
          nd = e => {
            var t = ed(e);
            return !!t && e instanceof t.Node;
          },
          rd = e => {
            var t = e && e.anchorNode && ed(e.anchorNode);
            return !!t && e instanceof t.Selection;
          },
          od = e => nd(e) && 3 === e.nodeType,
          id = (e, t, n) => {
            for (var r, {
                childNodes: o
              } = e, i = o[t], a = t, s = !1, l = !1; (nd(r = i) && 8 === r.nodeType || td(i) && 0 === i.childNodes.length || td(i) && "false" === i.getAttribute("contenteditable")) && (!s || !l);) a >= o.length ? (s = !0, a = t - 1, n = "backward") : a < 0 ? (l = !0, a = t + 1, n = "forward") : (i = o[a], t = a, a += "forward" === n ? 1 : -1);
            return [i, t];
          },
          ad = (e, t, n) => {
            var [r] = id(e, t, n);
            return r;
          },
          sd = e => {
            var t = "";
            if (od(e) && e.nodeValue) return e.nodeValue;
            if (td(e)) {
              for (var n of Array.from(e.childNodes)) t += sd(n);
              var r = getComputedStyle(e).getPropertyValue("display");
              "block" !== r && "list" !== r && "BR" !== e.tagName || (t += "\n");
            }
            return t;
          },
          ld = /data-slate-fragment="(.+?)"/m,
          ud = e => {
            var t = e.getData("text/html"),
              [, n] = t.match(ld) || [];
            return n;
          },
          cd = (e, t, n) => {
            var {
              target: r
            } = t;
            if (td(r) && r.matches('[contentEditable="false"]')) return !1;
            var {
              document: o
            } = hd.getWindow(e);
            if (o.contains(r)) return hd.hasDOMNode(e, r, {
              editable: !0
            });
            var i = n.find(e => {
              var {
                addedNodes: t,
                removedNodes: n
              } = e;
              for (var o of t) if (o === r || o.contains(r)) return !0;
              for (var i of n) if (i === r || i.contains(r)) return !0;
            });
            return !(!i || i === t) && cd(e, i, n);
          },
          dd = 0;
        class pd {
          constructor() {
            cc(this, "id", void 0), this.id = "".concat(dd++);
          }
        }
        var hd = {
          androidPendingDiffs: e => $c.get(e),
          androidScheduleFlush: e => {
            var t;
            null === (t = Hc.get(e)) || void 0 === t || t();
          },
          blur: e => {
            var t = hd.toDOMNode(e, e),
              n = hd.findDocumentOrShadowRoot(e);
            Lc.set(e, !1), n.activeElement === t && t.blur();
          },
          deselect: e => {
            var {
                selection: t
              } = e,
              n = hd.findDocumentOrShadowRoot(e).getSelection();
            n && n.rangeCount > 0 && n.removeAllRanges(), t && Uu.YR.deselect(e);
          },
          findDocumentOrShadowRoot: e => {
            var t = hd.toDOMNode(e, e),
              n = t.getRootNode();
            return (n instanceof Document || n instanceof ShadowRoot) && null != n.getSelection ? n : t.ownerDocument;
          },
          findEventRange: (e, t) => {
            "nativeEvent" in t && (t = t.nativeEvent);
            var {
              clientX: n,
              clientY: r,
              target: o
            } = t;
            if (null == n || null == r) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
            var i,
              a = hd.toSlateNode(e, t.target),
              s = hd.findPath(e, a);
            if (Uu.W_.isElement(a) && Uu.ML.isVoid(e, a)) {
              var l = o.getBoundingClientRect(),
                u = e.isInline(a) ? n - l.left < l.left + l.width - n : r - l.top < l.top + l.height - r,
                c = Uu.ML.point(e, s, {
                  edge: u ? "start" : "end"
                }),
                d = u ? Uu.ML.before(e, c) : Uu.ML.after(e, c);
              if (d) return Uu.ML.range(e, d);
            }
            var {
              document: p
            } = hd.getWindow(e);
            if (p.caretRangeFromPoint) i = p.caretRangeFromPoint(n, r);else {
              var h = p.caretPositionFromPoint(n, r);
              h && ((i = p.createRange()).setStart(h.offsetNode, h.offset), i.setEnd(h.offsetNode, h.offset));
            }
            if (!i) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
            return hd.toSlateRange(e, i, {
              exactMatch: !1,
              suppressThrow: !1
            });
          },
          findKey: (e, t) => {
            var n = jc.get(t);
            return n || (n = new pd(), jc.set(t, n)), n;
          },
          findPath: (e, t) => {
            for (var n = [], r = t;;) {
              var o = Tc.get(r);
              if (null == o) {
                if (Uu.ML.isEditor(r)) return n;
                break;
              }
              var i = zc.get(r);
              if (null == i) break;
              n.unshift(i), r = o;
            }
            throw new Error("Unable to find the path for Slate node: ".concat(Uu.o4.stringify(t)));
          },
          focus: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              retries: 5
            };
            if (!Lc.get(e)) {
              if (t.retries <= 0) throw new Error("Could not set focus, editor seems stuck with pending operations");
              if (e.operations.length > 0) setTimeout(() => {
                hd.focus(e, {
                  retries: t.retries - 1
                });
              }, 10);else {
                var n = hd.toDOMNode(e, e),
                  r = hd.findDocumentOrShadowRoot(e);
                if (r.activeElement !== n) {
                  if (e.selection && r instanceof Document) {
                    var o = r.getSelection(),
                      i = hd.toDOMRange(e, e.selection);
                    null == o || o.removeAllRanges(), null == o || o.addRange(i);
                  }
                  e.selection || (Uu.YR.select(e, Uu.ML.start(e, [])), e.onChange()), Lc.set(e, !0), n.focus({
                    preventScroll: !0
                  });
                }
              }
            }
          },
          getWindow: e => {
            var t = Oc.get(e);
            if (!t) throw new Error("Unable to find a host window element for this editor");
            return t;
          },
          hasDOMNode: function (e, t) {
            var n,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                editable: o = !1
              } = r,
              i = hd.toDOMNode(e, e);
            try {
              n = td(t) ? t : t.parentElement;
            } catch (e) {
              if (e instanceof Error && !e.message.includes('Permission denied to access property "nodeType"')) throw e;
            }
            return !!n && !(n.closest("[data-slate-editor]") !== i || o && !n.isContentEditable && ("boolean" != typeof n.isContentEditable || n.closest('[contenteditable="false"]') !== i) && !n.getAttribute("data-slate-zero-width"));
          },
          hasEditableTarget: (e, t) => nd(t) && hd.hasDOMNode(e, t, {
            editable: !0
          }),
          hasRange: (e, t) => {
            var {
              anchor: n,
              focus: r
            } = t;
            return Uu.ML.hasPath(e, n.path) && Uu.ML.hasPath(e, r.path);
          },
          hasSelectableTarget: (e, t) => hd.hasEditableTarget(e, t) || hd.isTargetInsideNonReadonlyVoid(e, t),
          hasTarget: (e, t) => nd(t) && hd.hasDOMNode(e, t),
          insertData: (e, t) => {
            e.insertData(t);
          },
          insertFragmentData: (e, t) => e.insertFragmentData(t),
          insertTextData: (e, t) => e.insertTextData(t),
          isComposing: e => !!Vc.get(e),
          isFocused: e => !!Lc.get(e),
          isReadOnly: e => !!Nc.get(e),
          isTargetInsideNonReadonlyVoid: (e, t) => {
            if (Nc.get(e)) return !1;
            var n = hd.hasTarget(e, t) && hd.toSlateNode(e, t);
            return Uu.W_.isElement(n) && Uu.ML.isVoid(e, n);
          },
          setFragmentData: (e, t, n) => e.setFragmentData(t, n),
          toDOMNode: (e, t) => {
            var n = Bc.get(e),
              r = Uu.ML.isEditor(t) ? Ic.get(e) : null == n ? void 0 : n.get(hd.findKey(e, t));
            if (!r) throw new Error("Cannot resolve a DOM node from Slate node: ".concat(Uu.o4.stringify(t)));
            return r;
          },
          toDOMPoint: (e, t) => {
            var n,
              [r] = Uu.ML.node(e, t.path),
              o = hd.toDOMNode(e, r);
            Uu.ML.void(e, {
              at: t
            }) && (t = {
              path: t.path,
              offset: 0
            });
            for (var i = Array.from(o.querySelectorAll("[data-slate-string], [data-slate-zero-width]")), a = 0, s = 0; s < i.length; s++) {
              var l = i[s],
                u = l.childNodes[0];
              if (null != u && null != u.textContent) {
                var {
                    length: c
                  } = u.textContent,
                  d = l.getAttribute("data-slate-length"),
                  p = a + (null == d ? c : parseInt(d, 10)),
                  h = i[s + 1];
                if (t.offset === p && null != h && h.hasAttribute("data-slate-mark-placeholder")) {
                  var f,
                    m = h.childNodes[0];
                  n = [m instanceof Jc ? m : h, null !== (f = h.textContent) && void 0 !== f && f.startsWith("\ufeff") ? 1 : 0];
                  break;
                }
                if (t.offset <= p) {
                  n = [u, Math.min(c, Math.max(0, t.offset - a))];
                  break;
                }
                a = p;
              }
            }
            if (!n) throw new Error("Cannot resolve a DOM point from Slate point: ".concat(Uu.o4.stringify(t)));
            return n;
          },
          toDOMRange: (e, t) => {
            var {
                anchor: n,
                focus: r
              } = t,
              o = Uu.e6.isBackward(t),
              i = hd.toDOMPoint(e, n),
              a = Uu.e6.isCollapsed(t) ? i : hd.toDOMPoint(e, r),
              s = hd.getWindow(e).document.createRange(),
              [l, u] = o ? a : i,
              [c, d] = o ? i : a,
              p = !!(td(l) ? l : l.parentElement).getAttribute("data-slate-zero-width"),
              h = !!(td(c) ? c : c.parentElement).getAttribute("data-slate-zero-width");
            return s.setStart(l, p ? 1 : u), s.setEnd(c, h ? 1 : d), s;
          },
          toSlateNode: (e, t) => {
            var n = td(t) ? t : t.parentElement;
            n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
            var r = n ? Mc.get(n) : null;
            if (!r) throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
            return r;
          },
          toSlatePoint: (e, t, n) => {
            var {
                exactMatch: r,
                suppressThrow: o
              } = n,
              [i, a] = r ? t : (e => {
                var [t, n] = e;
                if (td(t) && t.childNodes.length) {
                  var r = n === t.childNodes.length,
                    o = r ? n - 1 : n;
                  for ([t, o] = id(t, o, r ? "backward" : "forward"), r = o < n; td(t) && t.childNodes.length;) {
                    var i = r ? t.childNodes.length - 1 : 0;
                    t = ad(t, i, r ? "backward" : "forward");
                  }
                  n = r && null != t.textContent ? t.textContent.length : 0;
                }
                return [t, n];
              })(t),
              s = i.parentNode,
              l = null,
              u = 0;
            if (s) {
              var c,
                d,
                p = hd.toDOMNode(e, e),
                h = s.closest('[data-slate-void="true"]'),
                f = h && p.contains(h) ? h : null,
                m = s.closest("[data-slate-leaf]"),
                g = null;
              if (m) {
                if (l = m.closest('[data-slate-node="text"]')) {
                  var v = hd.getWindow(e).document.createRange();
                  v.setStart(l, 0), v.setEnd(i, a);
                  var y = v.cloneContents();
                  [...Array.prototype.slice.call(y.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(y.querySelectorAll("[contenteditable=false]"))].forEach(e => {
                    yc && !r && e.hasAttribute("data-slate-zero-width") && e.textContent.length > 0 && "\ufeff" !== e.textContext ? e.textContent.startsWith("\ufeff") && (e.textContent = e.textContent.slice(1)) : e.parentNode.removeChild(e);
                  }), u = y.textContent.length, g = l;
                }
              } else if (f) {
                for (var b = f.querySelectorAll("[data-slate-leaf]"), w = 0; w < b.length; w++) {
                  var x = b[w];
                  if (hd.hasDOMNode(e, x)) {
                    m = x;
                    break;
                  }
                }
                m ? (l = m.closest('[data-slate-node="text"]'), u = (g = m).textContent.length, g.querySelectorAll("[data-slate-zero-width]").forEach(e => {
                  u -= e.textContent.length;
                })) : u = 1;
              }
              g && u === g.textContent.length && yc && "z" === g.getAttribute("data-slate-zero-width") && null !== (c = g.textContent) && void 0 !== c && c.startsWith("\ufeff") && (s.hasAttribute("data-slate-zero-width") || bc && null !== (d = g.textContent) && void 0 !== d && d.endsWith("\n\n")) && u--;
            }
            if (yc && !l && !r) {
              var D = s.hasAttribute("data-slate-node") ? s : s.closest("[data-slate-node]");
              if (D && hd.hasDOMNode(e, D, {
                editable: !0
              })) {
                var C = hd.toSlateNode(e, D),
                  {
                    path: S,
                    offset: E
                  } = Uu.ML.start(e, hd.findPath(e, C));
                return D.querySelector("[data-slate-leaf]") || (E = a), {
                  path: S,
                  offset: E
                };
              }
            }
            if (!l) {
              if (o) return null;
              throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
            }
            var _ = hd.toSlateNode(e, l);
            return {
              path: hd.findPath(e, _),
              offset: u
            };
          },
          toSlateRange: (e, t, n) => {
            var r,
              o,
              i,
              a,
              s,
              l,
              u,
              {
                exactMatch: c,
                suppressThrow: d
              } = n;
            if (rd(t) ? t.anchorNode : t.startContainer) if (rd(t)) {
              if (bc && t.rangeCount > 1) {
                a = t.focusNode;
                var p = t.getRangeAt(0),
                  h = t.getRangeAt(t.rangeCount - 1);
                if (a instanceof HTMLTableRowElement && p.startContainer instanceof HTMLTableRowElement && h.startContainer instanceof HTMLTableRowElement) {
                  function x(e) {
                    return e.childElementCount > 0 ? x(e.children[0]) : e;
                  }
                  var f = p.startContainer,
                    m = h.startContainer,
                    g = x(f.children[p.startOffset]),
                    v = x(m.children[h.startOffset]);
                  s = 0, o = v.childNodes.length > 0 ? v.childNodes[0] : v, a = g.childNodes.length > 0 ? g.childNodes[0] : g, i = v instanceof HTMLElement ? v.innerHTML.length : 0;
                } else p.startContainer === a ? (o = h.endContainer, i = h.endOffset, s = p.startOffset) : (o = p.startContainer, i = p.endOffset, s = h.startOffset);
              } else o = t.anchorNode, i = t.anchorOffset, a = t.focusNode, s = t.focusOffset;
              l = Dc && (e => {
                for (var t = e && e.parentNode; t;) {
                  if ("[object ShadowRoot]" === t.toString()) return !0;
                  t = t.parentNode;
                }
                return !1;
              })(o) || bc ? t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : t.isCollapsed;
            } else o = t.startContainer, i = t.startOffset, a = t.endContainer, s = t.endOffset, l = t.collapsed;
            if (null == o || null == a || null == i || null == s) throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
            (bc && null !== (r = a.textContent) && void 0 !== r && r.endsWith("\n\n") && s === a.textContent.length && s--, "getAttribute" in a && "false" === a.getAttribute("contenteditable") && "true" !== a.getAttribute("data-slate-void")) && (a = o, s = (null === (u = o.textContent) || void 0 === u ? void 0 : u.length) || 0);
            var y = hd.toSlatePoint(e, [o, i], {
              exactMatch: c,
              suppressThrow: d
            });
            if (!y) return null;
            var b = l ? y : hd.toSlatePoint(e, [a, s], {
              exactMatch: c,
              suppressThrow: d
            });
            if (!b) return null;
            var w = {
              anchor: y,
              focus: b
            };
            return Uu.e6.isExpanded(w) && Uu.e6.isForward(w) && td(a) && Uu.ML.void(e, {
              at: w.focus,
              mode: "highest"
            }) && (w = Uu.ML.unhangRange(e, w, {
              voids: !0
            })), w;
          }
        };
        function fd(e, t) {
          var {
            path: n,
            diff: r
          } = t;
          if (!Uu.ML.hasPath(e, n)) return !1;
          var o = Uu.NB.get(e, n);
          if (!Uu.xv.isText(o)) return !1;
          if (r.start !== o.text.length || 0 === r.text.length) return o.text.slice(r.start, r.start + r.text.length) === r.text;
          var i = Uu.y$.next(n);
          if (!Uu.ML.hasPath(e, i)) return !1;
          var a = Uu.NB.get(e, i);
          return Uu.xv.isText(a) && a.text.startsWith(r.text);
        }
        function md(e) {
          for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          return n.reduce((e, t) => e.slice(0, t.start) + t.text + e.slice(t.end), e);
        }
        function gd(e, t) {
          var {
              start: n,
              end: r,
              text: o
            } = t,
            i = e.slice(n, r),
            a = function (e, t) {
              for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) if (e.charAt(r) !== t.charAt(r)) return r;
              return n;
            }(i, o),
            s = function (e, t, n) {
              for (var r = Math.min(e.length, t.length, n), o = 0; o < r; o++) if (e.charAt(e.length - o - 1) !== t.charAt(t.length - o - 1)) return o;
              return r;
            }(i, o, Math.min(i.length - a, o.length - a)),
            l = {
              start: n + a,
              end: r - s,
              text: o.slice(a, o.length - s)
            };
          return l.start === l.end && 0 === l.text.length ? null : l;
        }
        function vd(e) {
          var {
            path: t,
            diff: n
          } = e;
          return {
            anchor: {
              path: t,
              offset: n.start
            },
            focus: {
              path: t,
              offset: n.end
            }
          };
        }
        function yd(e, t) {
          var {
            path: n,
            offset: r
          } = t;
          if (!Uu.ML.hasPath(e, n)) return null;
          var o = Uu.NB.get(e, n);
          if (!Uu.xv.isText(o)) return null;
          var i = Uu.ML.above(e, {
            match: t => Uu.W_.isElement(t) && Uu.ML.isBlock(e, t),
            at: n
          });
          if (!i) return null;
          for (; r > o.text.length;) {
            var a = Uu.ML.next(e, {
              at: n,
              match: Uu.xv.isText
            });
            if (!a || !Uu.y$.isDescendant(a[1], i[1])) return null;
            r -= o.text.length, o = a[0], n = a[1];
          }
          return {
            path: n,
            offset: r
          };
        }
        function bd(e, t) {
          var n = yd(e, t.anchor);
          if (!n) return null;
          if (Uu.e6.isCollapsed(t)) return {
            anchor: n,
            focus: n
          };
          var r = yd(e, t.focus);
          return r ? {
            anchor: n,
            focus: r
          } : null;
        }
        function wd(e, t, n) {
          var r = $c.get(e),
            o = null == r ? void 0 : r.find(e => {
              var {
                path: n
              } = e;
              return Uu.y$.equals(n, t.path);
            });
          if (!o || t.offset <= o.diff.start) return Uu.E9.transform(t, n, {
            affinity: "backward"
          });
          var {
            diff: i
          } = o;
          if (t.offset <= i.start + i.text.length) {
            var a = {
                path: t.path,
                offset: i.start
              },
              s = Uu.E9.transform(a, n, {
                affinity: "backward"
              });
            return s ? {
              path: s.path,
              offset: s.offset + t.offset - i.start
            } : null;
          }
          var l = {
              path: t.path,
              offset: t.offset - i.text.length + i.end - i.start
            },
            u = Uu.E9.transform(l, n, {
              affinity: "backward"
            });
          return u ? "split_node" === n.type && Uu.y$.equals(n.path, t.path) && l.offset < n.position && i.start < n.position ? u : {
            path: u.path,
            offset: u.offset + i.text.length - i.end + i.start
          } : null;
        }
        function xd(e, t, n) {
          var r = wd(e, t.anchor, n);
          if (!r) return null;
          if (Uu.e6.isCollapsed(t)) return {
            anchor: r,
            focus: r
          };
          var o = wd(e, t.focus, n);
          return o ? {
            anchor: r,
            focus: o
          } : null;
        }
        function Dd(e, t) {
          var {
            path: n,
            diff: r,
            id: o
          } = e;
          switch (t.type) {
            case "insert_text":
              return !Uu.y$.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
                diff: {
                  start: t.text.length + r.start,
                  end: t.text.length + r.end,
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start,
                  end: r.end + t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              };
            case "remove_text":
              return !Uu.y$.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
                diff: {
                  start: r.start - t.text.length,
                  end: r.end - t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start,
                  end: r.end - t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              };
            case "split_node":
              return !Uu.y$.equals(t.path, n) || t.position >= r.end ? {
                diff: r,
                id: o,
                path: Uu.y$.transform(n, t, {
                  affinity: "backward"
                })
              } : t.position > r.start ? {
                diff: {
                  start: r.start,
                  end: Math.min(t.position, r.end),
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start - t.position,
                  end: r.end - t.position,
                  text: r.text
                },
                id: o,
                path: Uu.y$.transform(n, t, {
                  affinity: "forward"
                })
              };
            case "merge_node":
              return Uu.y$.equals(t.path, n) ? {
                diff: {
                  start: r.start + t.position,
                  end: r.end + t.position,
                  text: r.text
                },
                id: o,
                path: Uu.y$.transform(n, t)
              } : {
                diff: r,
                id: o,
                path: Uu.y$.transform(n, t)
              };
          }
          var i = Uu.y$.transform(n, t);
          return i ? {
            diff: r,
            path: i,
            id: o
          } : null;
        }
        function Cd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Sd(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Cd(Object(n), !0).forEach(function (t) {
              cc(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function Ed(e) {
          var {
              editor: t,
              scheduleOnDOMSelectionChange: n,
              onDOMSelectionChange: r
            } = e,
            o = !1,
            i = null,
            a = null,
            s = null,
            l = 0,
            u = !1,
            c = () => {
              var e = Wc.get(t);
              if (Wc.delete(t), e) {
                var {
                    selection: n
                  } = t,
                  r = bd(t, e);
                !r || n && Uu.e6.equals(r, n) || Uu.YR.select(t, r);
              }
            },
            d = () => {
              if (a && (clearTimeout(a), a = null), s && (clearTimeout(s), s = null), g() || m()) {
                o || (o = !0, setTimeout(() => o = !1)), m() && (o = "action");
                var e = t.selection && Uu.ML.rangeRef(t, t.selection, {
                  affinity: "forward"
                });
                Zc.set(t, t.marks), Gc.get(t), $c.get(t);
                for (var i, l = g(); i = null === (d = $c.get(t)) || void 0 === d ? void 0 : d[0];) {
                  var d,
                    p,
                    h = Uc.get(t);
                  void 0 !== h && (Uc.delete(t), t.marks = h), h && !1 === u && (u = null);
                  var f = vd(i);
                  t.selection && Uu.e6.equals(t.selection, f) || Uu.YR.select(t, f), i.diff.text ? Uu.ML.insertText(t, i.diff.text) : Uu.ML.deleteFragment(t), $c.set(t, null === (p = $c.get(t)) || void 0 === p ? void 0 : p.filter(e => {
                    var {
                      id: t
                    } = e;
                    return t !== i.id;
                  })), fd(t, i) || (l = !1, Gc.delete(t), Zc.delete(t), o = "action", Wc.delete(t), n.cancel(), r.cancel(), null == e || e.unref());
                }
                var v = null == e ? void 0 : e.unref();
                if (!v || Wc.get(t) || t.selection && Uu.e6.equals(v, t.selection) || Uu.YR.select(t, v), m()) (() => {
                  var e = Gc.get(t);
                  if (Gc.delete(t), e) {
                    if (e.at) {
                      var n = Uu.E9.isPoint(e.at) ? yd(t, e.at) : bd(t, e.at);
                      if (!n) return;
                      var r = Uu.ML.range(t, n);
                      t.selection && Uu.e6.equals(t.selection, r) || Uu.YR.select(t, n);
                    }
                    e.run();
                  }
                })();else {
                  l && n(), n.flush(), r.flush(), c();
                  var y = Zc.get(t);
                  Zc.delete(t), void 0 !== y && (t.marks = y, t.onChange());
                }
              } else c();
            },
            p = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                n = Fc.get(t);
              n && (g() || e ? n.style.display = "none" : n.style.removeProperty("display"));
            },
            h = (e, n) => {
              var r,
                o = null !== (r = $c.get(t)) && void 0 !== r ? r : [];
              $c.set(t, o);
              var i = Uu.NB.leaf(t, e),
                a = o.findIndex(t => Uu.y$.equals(t.path, e));
              if (a < 0) return gd(i.text, n) && o.push({
                path: e,
                diff: n,
                id: l++
              }), void p();
              var s = function (e, t, n) {
                var r = Math.min(t.start, n.start),
                  o = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start),
                  i = md(e, t, n),
                  a = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - o),
                  s = i.slice(r, a);
                return gd(e, {
                  start: r,
                  end: Math.max(t.end, n.end - t.text.length + (t.end - t.start)),
                  text: s
                });
              }(i.text, o[a].diff, n);
              if (!s) return o.splice(a, 1), void p();
              o[a] = Sd(Sd({}, o[a]), {}, {
                diff: s
              });
            },
            f = function (e) {
              var {
                at: o
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              u = !1, Wc.delete(t), n.cancel(), r.cancel(), m() && d(), Gc.set(t, {
                at: o,
                run: e
              }), s = setTimeout(d);
            },
            m = () => !!Gc.get(t),
            g = () => {
              var e;
              return !(null === (e = $c.get(t)) || void 0 === e || !e.length);
            },
            v = e => {
              Wc.set(t, e), a && (clearTimeout(a), a = null);
              var {
                selection: n
              } = t;
              if (e) {
                var r = !n || !Uu.y$.equals(n.anchor.path, e.anchor.path),
                  o = !n || !Uu.y$.equals(n.anchor.path.slice(0, -1), e.anchor.path.slice(0, -1));
                (r && u || o) && (u = !1), (r || g()) && (a = setTimeout(d, 200));
              }
            },
            y = () => {
              m() || (s = setTimeout(d));
            };
          return {
            flush: d,
            scheduleFlush: y,
            hasPendingDiffs: g,
            hasPendingAction: m,
            hasPendingChanges: () => m() || g(),
            isFlushing: () => o,
            handleUserSelect: v,
            handleCompositionEnd: e => {
              i && clearTimeout(i), i = setTimeout(() => {
                Vc.set(t, !1), d();
              }, 25);
            },
            handleCompositionStart: e => {
              Vc.set(t, !0), i && (clearTimeout(i), i = null);
            },
            handleDOMBeforeInput: e => {
              var n;
              a && (clearTimeout(a), a = null);
              var {
                  inputType: r
                } = e,
                o = null,
                i = e.dataTransfer || e.data || void 0;
              !1 !== u && "insertText" !== r && "insertCompositionText" !== r && (u = !1);
              var [s] = e.getTargetRanges();
              s && (o = hd.toSlateRange(t, s, {
                exactMatch: !1,
                suppressThrow: !0
              }));
              var l = hd.getWindow(t).getSelection();
              if (!o && l && (s = l, o = hd.toSlateRange(t, l, {
                exactMatch: !1,
                suppressThrow: !0
              })), o = null !== (n = o) && void 0 !== n ? n : t.selection) {
                var c,
                  d = !0;
                if (r.startsWith("delete")) {
                  if (Uu.e6.isExpanded(o)) {
                    var [p, m] = Uu.e6.edges(o);
                    if (Uu.NB.leaf(t, p.path).text.length === p.offset && 0 === m.offset) {
                      var g = Uu.ML.next(t, {
                        at: p.path,
                        match: Uu.xv.isText
                      });
                      g && Uu.y$.equals(g[1], m.path) && (o = {
                        anchor: m,
                        focus: m
                      });
                    }
                  }
                  var b = r.endsWith("Backward") ? "backward" : "forward",
                    [w, x] = Uu.e6.edges(o),
                    [D, C] = Uu.ML.leaf(t, w.path),
                    S = {
                      text: "",
                      start: w.offset,
                      end: x.offset
                    },
                    E = $c.get(t),
                    _ = null == E ? void 0 : E.find(e => Uu.y$.equals(e.path, C)),
                    P = _ ? [_.diff, S] : [S];
                  if (0 === md(D.text, ...P).length && (d = !1), Uu.e6.isExpanded(o)) {
                    if (d && Uu.y$.equals(o.anchor.path, o.focus.path)) {
                      var k = {
                          path: o.anchor.path,
                          offset: w.offset
                        },
                        A = Uu.ML.range(t, k, k);
                      return v(A), h(o.anchor.path, {
                        text: "",
                        end: x.offset,
                        start: w.offset
                      });
                    }
                    return f(() => Uu.ML.deleteFragment(t, {
                      direction: b
                    }), {
                      at: o
                    });
                  }
                }
                switch (r) {
                  case "deleteByComposition":
                  case "deleteByCut":
                  case "deleteByDrag":
                    return f(() => Uu.ML.deleteFragment(t), {
                      at: o
                    });
                  case "deleteContent":
                  case "deleteContentForward":
                    var {
                      anchor: z
                    } = o;
                    if (d && Uu.e6.isCollapsed(o)) {
                      var T = Uu.NB.leaf(t, z.path);
                      if (z.offset < T.text.length) return h(z.path, {
                        text: "",
                        start: z.offset,
                        end: z.offset + 1
                      });
                    }
                    return f(() => Uu.ML.deleteForward(t), {
                      at: o
                    });
                  case "deleteContentBackward":
                    var O,
                      {
                        anchor: I
                      } = o,
                      F = rd(s) ? s.isCollapsed : !(null === (O = s) || void 0 === O || !O.collapsed);
                    return d && F && Uu.e6.isCollapsed(o) && I.offset > 0 ? h(I.path, {
                      text: "",
                      start: I.offset - 1,
                      end: I.offset
                    }) : f(() => Uu.ML.deleteBackward(t), {
                      at: o
                    });
                  case "deleteEntireSoftLine":
                    return f(() => {
                      Uu.ML.deleteBackward(t, {
                        unit: "line"
                      }), Uu.ML.deleteForward(t, {
                        unit: "line"
                      });
                    }, {
                      at: o
                    });
                  case "deleteHardLineBackward":
                    return f(() => Uu.ML.deleteBackward(t, {
                      unit: "block"
                    }), {
                      at: o
                    });
                  case "deleteSoftLineBackward":
                    return f(() => Uu.ML.deleteBackward(t, {
                      unit: "line"
                    }), {
                      at: o
                    });
                  case "deleteHardLineForward":
                    return f(() => Uu.ML.deleteForward(t, {
                      unit: "block"
                    }), {
                      at: o
                    });
                  case "deleteSoftLineForward":
                    return f(() => Uu.ML.deleteForward(t, {
                      unit: "line"
                    }), {
                      at: o
                    });
                  case "deleteWordBackward":
                    return f(() => Uu.ML.deleteBackward(t, {
                      unit: "word"
                    }), {
                      at: o
                    });
                  case "deleteWordForward":
                    return f(() => Uu.ML.deleteForward(t, {
                      unit: "word"
                    }), {
                      at: o
                    });
                  case "insertLineBreak":
                    return f(() => Uu.ML.insertSoftBreak(t), {
                      at: o
                    });
                  case "insertParagraph":
                    return f(() => Uu.ML.insertBreak(t), {
                      at: o
                    });
                  case "insertCompositionText":
                  case "deleteCompositionText":
                  case "insertFromComposition":
                  case "insertFromDrop":
                  case "insertFromPaste":
                  case "insertFromYank":
                  case "insertReplacementText":
                  case "insertText":
                    if ("DataTransfer" === (null == (c = i) ? void 0 : c.constructor.name)) return f(() => hd.insertData(t, i), {
                      at: o
                    });
                    var M = null != i ? i : "";
                    if (Uc.get(t) && (M = M.replace("\ufeff", "")), "insertText" === r && /.*\n.*\n$/.test(M) && (M = M.slice(0, -1)), M.includes("\n")) return f(() => {
                      var e = M.split("\n");
                      e.forEach((n, r) => {
                        n && Uu.ML.insertText(t, n), r !== e.length - 1 && Uu.ML.insertSoftBreak(t);
                      });
                    }, {
                      at: o
                    });
                    if (Uu.y$.equals(o.anchor.path, o.focus.path)) {
                      var [R, j] = Uu.e6.edges(o),
                        B = {
                          start: R.offset,
                          end: j.offset,
                          text: M
                        };
                      if (M && u && "insertCompositionText" === r) {
                        var N = u.start + u.text.search(/\S|$/);
                        B.start + B.text.search(/\S|$/) === N + 1 && B.end === u.start + u.text.length ? (B.start -= 1, u = null, y()) : u = !1;
                      } else u = "insertText" === r && (null === u ? B : !(!u || !Uu.e6.isCollapsed(o) || u.end + u.text.length !== R.offset) && Sd(Sd({}, u), {}, {
                        text: u.text + M
                      }));
                      if (d) return void h(R.path, B);
                    }
                    return f(() => Uu.ML.insertText(t, M), {
                      at: o
                    });
                }
              }
            },
            handleKeyDown: e => {
              g() || (p(!0), setTimeout(p));
            },
            handleDomMutations: e => {
              var n;
              g() || m() || e.some(n => cd(t, n, e)) && (null === (n = Yc.get(t)) || void 0 === n || n());
            },
            handleInput: () => {
              !m() && g() || d();
            }
          };
        }
        var _d = kc ? s.useLayoutEffect : s.useEffect;
        var Pd = ["node"];
        function kd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Ad = {
            subtree: !0,
            childList: !0,
            characterData: !0
          },
          zd = yc ? e => {
            var {
                node: t
              } = e,
              n = sc(e, Pd);
            if (!yc) return null;
            var r,
              o = fc(),
              i = (r = (0, s.useRef)(!1), (0, s.useEffect)(() => (r.current = !0, () => {
                r.current = !1;
              }), []), r.current),
              [a] = (0, s.useState)(() => Ed(function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? kd(Object(n), !0).forEach(function (t) {
                    cc(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kd(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                editor: o
              }, n)));
            return function (e, t, n) {
              var [r] = (0, s.useState)(() => new MutationObserver(t));
              _d(() => {
                r.takeRecords();
              }), (0, s.useEffect)(() => {
                if (!e.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
                return r.observe(e.current, n), () => r.disconnect();
              }, [r, e, n]);
            }(t, a.handleDomMutations, Ad), Hc.set(o, a.scheduleFlush), i && a.flush(), a;
          } : () => null,
          Td = ["anchor", "focus"],
          Od = ["anchor", "focus"],
          Id = (e, t) => {
            var n,
              r,
              o = sc(e, Td),
              i = sc(t, Od);
            return e[Xc] === t[Xc] && (n = o, r = i, Object.keys(n).length === Object.keys(r).length && Object.keys(n).every(e => r.hasOwnProperty(e) && n[e] === r[e]));
          };
        function Fd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Md = e => {
            var {
                isLast: t,
                leaf: n,
                parent: r,
                text: o
              } = e,
              i = fc(),
              a = hd.findPath(i, o),
              l = Uu.y$.parent(a),
              u = Boolean(n[Qc]);
            return i.isVoid(r) ? s.createElement(Bd, {
              length: Uu.NB.string(r).length
            }) : "" !== n.text || r.children[r.children.length - 1] !== o || i.isInline(r) || "" !== Uu.ML.string(i, l) ? "" === n.text ? s.createElement(Bd, {
              isMarkPlaceholder: u
            }) : t && "\n" === n.text.slice(-1) ? s.createElement(Rd, {
              isTrailing: !0,
              text: n.text
            }) : s.createElement(Rd, {
              text: n.text
            }) : s.createElement(Bd, {
              isLineBreak: !0,
              isMarkPlaceholder: u
            });
          },
          Rd = e => {
            var {
                text: t,
                isTrailing: n = !1
              } = e,
              r = (0, s.useRef)(null),
              o = () => "".concat(null != t ? t : "").concat(n ? "\n" : ""),
              [i] = (0, s.useState)(o);
            return _d(() => {
              var e = o();
              r.current && r.current.textContent !== e && (r.current.textContent = e);
            }), s.createElement(jd, {
              ref: r
            }, i);
          },
          jd = (0, s.memo)((0, s.forwardRef)((e, t) => s.createElement("span", {
            "data-slate-string": !0,
            ref: t
          }, e.children))),
          Bd = e => {
            var {
                length: t = 0,
                isLineBreak: n = !1,
                isMarkPlaceholder: r = !1
              } = e,
              o = {
                "data-slate-zero-width": n ? "n" : "z",
                "data-slate-length": t
              };
            return r && (o["data-slate-mark-placeholder"] = !0), s.createElement("span", function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Fd(Object(n), !0).forEach(function (t) {
                  cc(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fd(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({}, o), (yc || gc) && n ? null : "\ufeff", n ? s.createElement("br", null) : null);
          };
        function Nd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ld(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Nd(Object(n), !0).forEach(function (t) {
              cc(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Vd = yc ? 300 : 0;
        function Kd(e) {
          e.current && (clearTimeout(e.current), e.current = null);
        }
        var qd = e => {
            var {
                leaf: t,
                isLast: n,
                text: r,
                parent: o,
                renderPlaceholder: i,
                renderLeaf: a = e => s.createElement(Ud, Ld({}, e))
              } = e,
              l = fc(),
              u = (0, s.useRef)(null),
              c = (0, s.useRef)(null),
              [d, p] = (0, s.useState)(!1),
              h = (0, s.useRef)(null),
              f = (0, s.useCallback)(e => {
                if (function (e, t) {
                  e.current && (e.current.disconnect(), t && (e.current = null));
                }(u, null == e), null == e) {
                  var n;
                  Fc.delete(l), null === (n = t.onPlaceholderResize) || void 0 === n || n.call(t, null);
                } else {
                  if (Fc.set(l, e), !u.current) {
                    var r = window.ResizeObserver || ic.do;
                    u.current = new r(() => {
                      var n;
                      null === (n = t.onPlaceholderResize) || void 0 === n || n.call(t, e);
                    });
                  }
                  u.current.observe(e), c.current = e;
                }
              }, [c, t, l]),
              m = s.createElement(Md, {
                isLast: n,
                leaf: t,
                parent: o,
                text: r
              }),
              g = Boolean(t[Xc]);
            if ((0, s.useEffect)(() => (g ? h.current || (h.current = setTimeout(() => {
              p(!0), h.current = null;
            }, Vd)) : (Kd(h), p(!1)), () => Kd(h)), [g, p]), g && d) {
              var v = {
                children: t.placeholder,
                attributes: {
                  "data-slate-placeholder": !0,
                  style: {
                    position: "absolute",
                    top: 0,
                    pointerEvents: "none",
                    width: "100%",
                    maxWidth: "100%",
                    display: "block",
                    opacity: "0.333",
                    userSelect: "none",
                    textDecoration: "none",
                    WebkitUserModify: wc ? "inherit" : void 0
                  },
                  contentEditable: !1,
                  ref: f
                }
              };
              m = s.createElement(s.Fragment, null, i(v), m);
            }
            return a({
              attributes: {
                "data-slate-leaf": !0
              },
              children: m,
              leaf: t,
              text: r
            });
          },
          Hd = s.memo(qd, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && Uu.xv.equals(t.leaf, e.leaf) && t.leaf[Xc] === e.leaf[Xc]),
          Ud = e => {
            var {
              attributes: t,
              children: n
            } = e;
            return s.createElement("span", Ld({}, t), n);
          },
          Zd = e => {
            for (var {
                decorations: t,
                isLast: n,
                parent: r,
                renderPlaceholder: o,
                renderLeaf: i,
                text: a
              } = e, l = fc(), u = (0, s.useRef)(null), c = Uu.xv.decorations(a, t), d = hd.findKey(l, a), p = [], h = 0; h < c.length; h++) {
              var f = c[h];
              p.push(s.createElement(Hd, {
                isLast: n && h === c.length - 1,
                key: "".concat(d.id, "-").concat(h),
                renderPlaceholder: o,
                leaf: f,
                text: a,
                parent: r,
                renderLeaf: i
              }));
            }
            var m = (0, s.useCallback)(e => {
              var t = Bc.get(l);
              e ? (null == t || t.set(d, e), Rc.set(a, e), Mc.set(e, a)) : (null == t || t.delete(d), Rc.delete(a), u.current && Mc.delete(u.current)), u.current = e;
            }, [u, l, d, a]);
            return s.createElement("span", {
              "data-slate-node": "text",
              ref: m
            }, p);
          },
          $d = s.memo(Zd, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && ((e, t) => {
            if (e.length !== t.length) return !1;
            for (var n = 0; n < e.length; n++) {
              var r = e[n],
                o = t[n];
              if (r.anchor.offset !== o.anchor.offset || r.focus.offset !== o.focus.offset || !Id(r, o)) return !1;
            }
            return !0;
          })(t.decorations, e.decorations));
        function Gd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Wd(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Gd(Object(n), !0).forEach(function (t) {
              cc(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Yd = e => {
            var {
                decorations: t,
                element: n,
                renderElement: r = e => s.createElement(Qd, Wd({}, e)),
                renderPlaceholder: o,
                renderLeaf: i,
                selection: a
              } = e,
              l = fc(),
              u = rp(),
              c = l.isInline(n),
              d = hd.findKey(l, n),
              p = (0, s.useCallback)(e => {
                var t = Bc.get(l);
                e ? (null == t || t.set(d, e), Rc.set(n, e), Mc.set(e, n)) : (null == t || t.delete(d), Rc.delete(n));
              }, [l, d, n]),
              h = tp({
                decorations: t,
                node: n,
                renderElement: r,
                renderPlaceholder: o,
                renderLeaf: i,
                selection: a
              }),
              f = {
                "data-slate-node": "element",
                ref: p
              };
            if (c && (f["data-slate-inline"] = !0), !c && Uu.ML.hasInlines(l, n)) {
              var m = Uu.NB.string(n),
                g = $u()(m);
              "rtl" === g && (f.dir = g);
            }
            if (Uu.ML.isVoid(l, n)) {
              f["data-slate-void"] = !0, !u && c && (f.contentEditable = !1);
              var v = c ? "span" : "div",
                [[y]] = Uu.NB.texts(n);
              h = s.createElement(v, {
                "data-slate-spacer": !0,
                style: {
                  height: "0",
                  color: "transparent",
                  outline: "none",
                  position: "absolute"
                }
              }, s.createElement($d, {
                renderPlaceholder: o,
                decorations: [],
                isLast: !1,
                parent: n,
                text: y
              })), zc.set(y, 0), Tc.set(y, n);
            }
            return r({
              attributes: f,
              children: h,
              element: n
            });
          },
          Xd = s.memo(Yd, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && ((e, t) => {
            if (e.length !== t.length) return !1;
            for (var n = 0; n < e.length; n++) {
              var r = e[n],
                o = t[n];
              if (!Uu.e6.equals(r, o) || !Id(r, o)) return !1;
            }
            return !0;
          })(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && Uu.e6.equals(e.selection, t.selection))),
          Qd = e => {
            var {
                attributes: t,
                children: n,
                element: r
              } = e,
              o = fc().isInline(r) ? "span" : "div";
            return s.createElement(o, Wd(Wd({}, t), {}, {
              style: {
                position: "relative"
              }
            }), n);
          },
          Jd = (0, s.createContext)(() => []),
          ep = (0, s.createContext)(!1),
          tp = e => {
            for (var {
                decorations: t,
                node: n,
                renderElement: r,
                renderPlaceholder: o,
                renderLeaf: i,
                selection: a
              } = e, l = (0, s.useContext)(Jd), u = fc(), c = hd.findPath(u, n), d = [], p = Uu.W_.isElement(n) && !u.isInline(n) && Uu.ML.hasInlines(u, n), h = 0; h < n.children.length; h++) {
              var f = c.concat(h),
                m = n.children[h],
                g = hd.findKey(u, m),
                v = Uu.ML.range(u, f),
                y = a && Uu.e6.intersection(v, a),
                b = l([m, f]);
              for (var w of t) {
                var x = Uu.e6.intersection(w, v);
                x && b.push(x);
              }
              Uu.W_.isElement(m) ? d.push(s.createElement(ep.Provider, {
                key: "provider-".concat(g.id),
                value: !!y
              }, s.createElement(Xd, {
                decorations: b,
                element: m,
                key: g.id,
                renderElement: r,
                renderPlaceholder: o,
                renderLeaf: i,
                selection: y
              }))) : d.push(s.createElement($d, {
                decorations: b,
                key: g.id,
                isLast: p && h === n.children.length - 1,
                parent: n,
                renderPlaceholder: o,
                renderLeaf: i,
                text: m
              })), zc.set(m, h), Tc.set(m, n);
            }
            return d;
          },
          np = (0, s.createContext)(!1),
          rp = () => (0, s.useContext)(np),
          op = (0, s.createContext)(null),
          ip = () => {
            var e = (0, s.useContext)(op);
            if (!e) throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
            var {
              editor: t
            } = e;
            return t;
          };
        var ap = {
            bold: "mod+b",
            compose: ["down", "left", "right", "up", "backspace", "enter"],
            moveBackward: "left",
            moveForward: "right",
            moveWordBackward: "ctrl+left",
            moveWordForward: "ctrl+right",
            deleteBackward: "shift?+backspace",
            deleteForward: "shift?+delete",
            extendBackward: "shift+left",
            extendForward: "shift+right",
            italic: "mod+i",
            insertSoftBreak: "shift+enter",
            splitBlock: "enter",
            undo: "mod+z"
          },
          sp = {
            moveLineBackward: "opt+up",
            moveLineForward: "opt+down",
            moveWordBackward: "opt+left",
            moveWordForward: "opt+right",
            deleteBackward: ["ctrl+backspace", "ctrl+h"],
            deleteForward: ["ctrl+delete", "ctrl+d"],
            deleteLineBackward: "cmd+shift?+backspace",
            deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
            deleteWordBackward: "opt+shift?+backspace",
            deleteWordForward: "opt+shift?+delete",
            extendLineBackward: "opt+shift+up",
            extendLineForward: "opt+shift+down",
            redo: "cmd+shift+z",
            transposeCharacter: "ctrl+t"
          },
          lp = {
            deleteWordBackward: "ctrl+shift?+backspace",
            deleteWordForward: "ctrl+shift?+delete",
            redo: ["ctrl+y", "ctrl+shift+z"]
          },
          up = e => {
            var t = ap[e],
              n = sp[e],
              r = lp[e],
              o = t && (0, ac.P6)(t),
              i = n && (0, ac.P6)(n),
              a = r && (0, ac.P6)(r);
            return e => !(!o || !o(e)) || !!(vc && i && i(e)) || !(vc || !a || !a(e));
          },
          cp = {
            isBold: up("bold"),
            isCompose: up("compose"),
            isMoveBackward: up("moveBackward"),
            isMoveForward: up("moveForward"),
            isDeleteBackward: up("deleteBackward"),
            isDeleteForward: up("deleteForward"),
            isDeleteLineBackward: up("deleteLineBackward"),
            isDeleteLineForward: up("deleteLineForward"),
            isDeleteWordBackward: up("deleteWordBackward"),
            isDeleteWordForward: up("deleteWordForward"),
            isExtendBackward: up("extendBackward"),
            isExtendForward: up("extendForward"),
            isExtendLineBackward: up("extendLineBackward"),
            isExtendLineForward: up("extendLineForward"),
            isItalic: up("italic"),
            isMoveLineBackward: up("moveLineBackward"),
            isMoveLineForward: up("moveLineForward"),
            isMoveWordBackward: up("moveWordBackward"),
            isMoveWordForward: up("moveWordForward"),
            isRedo: up("redo"),
            isSoftBreak: up("insertSoftBreak"),
            isSplitBlock: up("splitBlock"),
            isTransposeCharacter: up("transposeCharacter"),
            isUndo: up("undo")
          },
          dp = {
            subtree: !0,
            childList: !0,
            characterData: !0,
            characterDataOldValue: !0
          };
        class pp extends s.Component {
          constructor() {
            super(...arguments), cc(this, "context", null), cc(this, "manager", null), cc(this, "mutationObserver", null);
          }
          observe() {
            var e,
              {
                node: t
              } = this.props;
            if (!t.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
            null === (e = this.mutationObserver) || void 0 === e || e.observe(t.current, dp);
          }
          componentDidMount() {
            var {
                receivedUserInput: e
              } = this.props,
              t = this.context;
            this.manager = ((e, t) => {
              var n = [],
                r = () => {
                  n = [];
                };
              return {
                registerMutations: r => {
                  if (t.current) {
                    var o = r.filter(t => cd(e, t, r));
                    n.push(...o);
                  }
                },
                restoreDOM: function () {
                  n.length > 0 && (n.reverse().forEach(e => {
                    "characterData" !== e.type && (e.removedNodes.forEach(t => {
                      e.target.insertBefore(t, e.nextSibling);
                    }), e.addedNodes.forEach(t => {
                      e.target.removeChild(t);
                    }));
                  }), r());
                },
                clear: r
              };
            })(t, e), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
          }
          getSnapshotBeforeUpdate() {
            var e,
              t,
              n,
              r,
              o = null === (e = this.mutationObserver) || void 0 === e ? void 0 : e.takeRecords();
            null != o && o.length && (null === (r = this.manager) || void 0 === r || r.registerMutations(o));
            return null === (t = this.mutationObserver) || void 0 === t || t.disconnect(), null === (n = this.manager) || void 0 === n || n.restoreDOM(), null;
          }
          componentDidUpdate() {
            var e;
            null === (e = this.manager) || void 0 === e || e.clear(), this.observe();
          }
          componentWillUnmount() {
            var e;
            null === (e = this.mutationObserver) || void 0 === e || e.disconnect();
          }
          render() {
            return this.props.children;
          }
        }
        cc(pp, "contextType", hc);
        var hp = yc ? pp : e => {
            var {
              children: t
            } = e;
            return s.createElement(s.Fragment, null, t);
          },
          fp = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"],
          mp = ["text"];
        function gp(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function vp(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? gp(Object(n), !0).forEach(function (t) {
              cc(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gp(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var yp = e => s.createElement(s.Fragment, null, tp(e)),
          bp = e => {
            var t = (0, s.useCallback)(e => s.createElement(wp, vp({}, e)), []),
              {
                autoFocus: n,
                decorate: r = xp,
                onDOMBeforeInput: o,
                placeholder: i,
                readOnly: a = !1,
                renderElement: l,
                renderLeaf: u,
                renderPlaceholder: c = t,
                scrollSelectionIntoView: d = Dp,
                style: p = {},
                as: h = "div",
                disableDefaultStyles: f = !1
              } = e,
              m = sc(e, fp),
              g = ip(),
              [v, y] = (0, s.useState)(!1),
              b = (0, s.useRef)(null),
              w = (0, s.useRef)([]),
              [x, D] = (0, s.useState)(),
              C = (0, s.useRef)(!1),
              {
                onUserInput: S,
                receivedUserInput: E
              } = function () {
                var e = fc(),
                  t = (0, s.useRef)(!1),
                  n = (0, s.useRef)(0),
                  r = (0, s.useCallback)(() => {
                    if (!t.current) {
                      t.current = !0;
                      var r = hd.getWindow(e);
                      r.cancelAnimationFrame(n.current), n.current = r.requestAnimationFrame(() => {
                        t.current = !1;
                      });
                    }
                  }, [e]);
                return (0, s.useEffect)(() => () => cancelAnimationFrame(n.current), []), {
                  receivedUserInput: t,
                  onUserInput: r
                };
              }(),
              [, _] = (0, s.useReducer)(e => e + 1, 0);
            Yc.set(g, _), Nc.set(g, a);
            var P = (0, s.useMemo)(() => ({
              isDraggingInternally: !1,
              isUpdatingSelection: !1,
              latestElement: null,
              hasMarkPlaceholder: !1
            }), []);
            (0, s.useEffect)(() => {
              b.current && n && b.current.focus();
            }, [n]);
            var k = (0, s.useRef)(),
              A = (0, s.useMemo)(() => Xu()(() => {
                var e = hd.toDOMNode(g, g).getRootNode();
                if (!C.current && wc && e instanceof ShadowRoot) {
                  C.current = !0;
                  var t = (() => {
                    for (var e = document.activeElement; null !== (t = e) && void 0 !== t && t.shadowRoot && null !== (n = e.shadowRoot) && void 0 !== n && n.activeElement;) {
                      var t, n, r;
                      e = null === (r = e) || void 0 === r || null === (r = r.shadowRoot) || void 0 === r ? void 0 : r.activeElement;
                    }
                    return e;
                  })();
                  return t ? document.execCommand("indent") : Uu.YR.deselect(g), void (C.current = !1);
                }
                var n = k.current;
                if ((yc || !hd.isComposing(g)) && (!P.isUpdatingSelection || null != n && n.isFlushing()) && !P.isDraggingInternally) {
                  var r = hd.findDocumentOrShadowRoot(g),
                    {
                      activeElement: o
                    } = r,
                    i = hd.toDOMNode(g, g),
                    s = r.getSelection();
                  if (o === i ? (P.latestElement = o, Lc.set(g, !0)) : Lc.delete(g), !s) return Uu.YR.deselect(g);
                  var {
                      anchorNode: l,
                      focusNode: u
                    } = s,
                    c = hd.hasEditableTarget(g, l) || hd.isTargetInsideNonReadonlyVoid(g, l),
                    d = hd.hasEditableTarget(g, u) || hd.isTargetInsideNonReadonlyVoid(g, u);
                  if (c && d) {
                    var p = hd.toSlateRange(g, s, {
                      exactMatch: !1,
                      suppressThrow: !0
                    });
                    p && (hd.isComposing(g) || null != n && n.hasPendingChanges() || null != n && n.isFlushing() ? null == n || n.handleUserSelect(p) : Uu.YR.select(g, p));
                  }
                  !a || c && d || Uu.YR.deselect(g);
                }
              }, 100), [g, a, P]),
              z = (0, s.useMemo)(() => Wu()(A, 0), [A]);
            k.current = zd({
              node: b,
              onDOMSelectionChange: A,
              scheduleOnDOMSelectionChange: z
            }), _d(() => {
              var e, t, n;
              b.current && (n = ed(b.current)) ? (Oc.set(g, n), Ic.set(g, b.current), Rc.set(g, b.current), Mc.set(b.current, g)) : Rc.delete(g);
              var {
                  selection: r
                } = g,
                o = hd.findDocumentOrShadowRoot(g).getSelection();
              if (o && hd.isFocused(g) && (null === (e = k.current) || void 0 === e || !e.hasPendingAction())) {
                var i = e => {
                  var t = "None" !== o.type;
                  if (r || t) {
                    var n,
                      i = o.focusNode;
                    if (bc && o.rangeCount > 1) {
                      var a = o.getRangeAt(0),
                        s = o.getRangeAt(o.rangeCount - 1);
                      n = a.startContainer === i ? s.endContainer : a.startContainer;
                    } else n = o.anchorNode;
                    var l = Ic.get(g),
                      u = !1;
                    if (l.contains(n) && l.contains(i) && (u = !0), t && u && r && !e) {
                      var c = hd.toSlateRange(g, o, {
                        exactMatch: !0,
                        suppressThrow: !0
                      });
                      if (c && Uu.e6.equals(c, r)) {
                        var p;
                        if (!P.hasMarkPlaceholder) return;
                        if (null !== (p = n) && void 0 !== p && null !== (p = p.parentElement) && void 0 !== p && p.hasAttribute("data-slate-mark-placeholder")) return;
                      }
                    }
                    if (!r || hd.hasRange(g, r)) {
                      P.isUpdatingSelection = !0;
                      var h = r && hd.toDOMRange(g, r);
                      return h ? (hd.isComposing(g) && !yc ? o.collapseToEnd() : Uu.e6.isBackward(r) ? o.setBaseAndExtent(h.endContainer, h.endOffset, h.startContainer, h.startOffset) : o.setBaseAndExtent(h.startContainer, h.startOffset, h.endContainer, h.endOffset), d(g, h)) : o.removeAllRanges(), h;
                    }
                    g.selection = hd.toSlateRange(g, o, {
                      exactMatch: !1,
                      suppressThrow: !0
                    });
                  }
                };
                o.rangeCount <= 1 && i();
                var a = "action" === (null === (t = k.current) || void 0 === t ? void 0 : t.isFlushing());
                if (yc && a) {
                  var s = null,
                    l = requestAnimationFrame(() => {
                      if (a) {
                        var e = e => {
                          try {
                            hd.toDOMNode(g, g).focus(), i(e);
                          } catch (e) {}
                        };
                        e(), s = setTimeout(() => {
                          e(!0), P.isUpdatingSelection = !1;
                        });
                      }
                    });
                  return () => {
                    cancelAnimationFrame(l), s && clearTimeout(s);
                  };
                }
                setTimeout(() => {
                  P.isUpdatingSelection = !1;
                });
              }
            });
            var T = (0, s.useCallback)(e => {
                var t = hd.toDOMNode(g, g).getRootNode();
                if (null != C && C.current && wc && t instanceof ShadowRoot) {
                  var n = e.getTargetRanges()[0],
                    r = new window.Range();
                  r.setStart(n.startContainer, n.startOffset), r.setEnd(n.endContainer, n.endOffset);
                  var i = hd.toSlateRange(g, r, {
                    exactMatch: !1,
                    suppressThrow: !1
                  });
                  return Uu.YR.select(g, i), e.preventDefault(), void e.stopImmediatePropagation();
                }
                if (S(), !a && hd.hasEditableTarget(g, e.target) && !Ep(e, o)) {
                  var s;
                  if (k.current) return k.current.handleDOMBeforeInput(e);
                  z.flush(), A.flush();
                  var {
                      selection: l
                    } = g,
                    {
                      inputType: u
                    } = e,
                    c = e.dataTransfer || e.data || void 0,
                    d = "insertCompositionText" === u || "deleteCompositionText" === u;
                  if (d && hd.isComposing(g)) return;
                  var p = !1;
                  if ("insertText" === u && l && Uu.e6.isCollapsed(l) && e.data && 1 === e.data.length && /[a-z ]/i.test(e.data) && 0 !== l.anchor.offset) {
                    var h, f;
                    p = !0, g.marks && (p = !1);
                    var {
                        anchor: m
                      } = l,
                      [v, b] = hd.toDOMPoint(g, m),
                      x = null === (h = v.parentElement) || void 0 === h ? void 0 : h.closest("a"),
                      D = hd.getWindow(g);
                    if (p && x && hd.hasDOMNode(g, x)) {
                      var E,
                        _ = null == D ? void 0 : D.document.createTreeWalker(x, NodeFilter.SHOW_TEXT).lastChild();
                      _ === v && (null === (E = _.textContent) || void 0 === E ? void 0 : E.length) === b && (p = !1);
                    }
                    if (p && v.parentElement && "pre" === (null == D || null === (f = D.getComputedStyle(v.parentElement)) || void 0 === f ? void 0 : f.whiteSpace)) {
                      var P = Uu.ML.above(g, {
                        at: m.path,
                        match: e => Uu.W_.isElement(e) && Uu.ML.isBlock(g, e)
                      });
                      P && Uu.NB.string(P[0]).includes("\t") && (p = !1);
                    }
                  }
                  if (!u.startsWith("delete") || u.startsWith("deleteBy")) {
                    var [T] = e.getTargetRanges();
                    if (T) {
                      var O = hd.toSlateRange(g, T, {
                        exactMatch: !1,
                        suppressThrow: !1
                      });
                      if (!l || !Uu.e6.equals(l, O)) {
                        p = !1;
                        var I = !d && g.selection && Uu.ML.rangeRef(g, g.selection);
                        Uu.YR.select(g, O), I && Kc.set(g, I);
                      }
                    }
                  }
                  if (d) return;
                  if (p || e.preventDefault(), l && Uu.e6.isExpanded(l) && u.startsWith("delete")) {
                    var F = u.endsWith("Backward") ? "backward" : "forward";
                    return void Uu.ML.deleteFragment(g, {
                      direction: F
                    });
                  }
                  switch (u) {
                    case "deleteByComposition":
                    case "deleteByCut":
                    case "deleteByDrag":
                      Uu.ML.deleteFragment(g);
                      break;
                    case "deleteContent":
                    case "deleteContentForward":
                      Uu.ML.deleteForward(g);
                      break;
                    case "deleteContentBackward":
                      Uu.ML.deleteBackward(g);
                      break;
                    case "deleteEntireSoftLine":
                      Uu.ML.deleteBackward(g, {
                        unit: "line"
                      }), Uu.ML.deleteForward(g, {
                        unit: "line"
                      });
                      break;
                    case "deleteHardLineBackward":
                      Uu.ML.deleteBackward(g, {
                        unit: "block"
                      });
                      break;
                    case "deleteSoftLineBackward":
                      Uu.ML.deleteBackward(g, {
                        unit: "line"
                      });
                      break;
                    case "deleteHardLineForward":
                      Uu.ML.deleteForward(g, {
                        unit: "block"
                      });
                      break;
                    case "deleteSoftLineForward":
                      Uu.ML.deleteForward(g, {
                        unit: "line"
                      });
                      break;
                    case "deleteWordBackward":
                      Uu.ML.deleteBackward(g, {
                        unit: "word"
                      });
                      break;
                    case "deleteWordForward":
                      Uu.ML.deleteForward(g, {
                        unit: "word"
                      });
                      break;
                    case "insertLineBreak":
                      Uu.ML.insertSoftBreak(g);
                      break;
                    case "insertParagraph":
                      Uu.ML.insertBreak(g);
                      break;
                    case "insertFromComposition":
                    case "insertFromDrop":
                    case "insertFromPaste":
                    case "insertFromYank":
                    case "insertReplacementText":
                    case "insertText":
                      "insertFromComposition" === u && hd.isComposing(g) && (y(!1), Vc.set(g, !1)), "DataTransfer" === (null == c ? void 0 : c.constructor.name) ? hd.insertData(g, c) : "string" == typeof c && (p ? w.current.push(() => Uu.ML.insertText(g, c)) : Uu.ML.insertText(g, c));
                  }
                  var M = null === (s = Kc.get(g)) || void 0 === s ? void 0 : s.unref();
                  Kc.delete(g), !M || g.selection && Uu.e6.equals(g.selection, M) || Uu.YR.select(g, M);
                }
              }, [g, A, S, o, a, z]),
              O = (0, s.useCallback)(e => {
                null == e ? (A.cancel(), z.cancel(), Ic.delete(g), Rc.delete(g), b.current && Ac && b.current.removeEventListener("beforeinput", T)) : Ac && e.addEventListener("beforeinput", T), b.current = e;
              }, [A, z, g, T]);
            _d(() => {
              var e = hd.getWindow(g);
              return e.document.addEventListener("selectionchange", z), () => {
                e.document.removeEventListener("selectionchange", z);
              };
            }, [z]);
            var I = r([g, []]),
              F = i && 1 === g.children.length && 1 === Array.from(Uu.NB.texts(g)).length && "" === Uu.NB.string(g) && !v,
              M = (0, s.useCallback)(e => {
                var t;
                e && F ? D(null === (t = e.getBoundingClientRect()) || void 0 === t ? void 0 : t.height) : D(void 0);
              }, [F]);
            if (F) {
              var R = Uu.ML.start(g, []);
              I.push({
                [Xc]: !0,
                placeholder: i,
                onPlaceholderResize: M,
                anchor: R,
                focus: R
              });
            }
            var {
              marks: j
            } = g;
            if (P.hasMarkPlaceholder = !1, g.selection && Uu.e6.isCollapsed(g.selection) && j) {
              var {
                  anchor: B
                } = g.selection,
                N = Uu.NB.leaf(g, B.path),
                L = sc(N, mp);
              if (!Uu.xv.equals(N, j, {
                loose: !0
              })) {
                P.hasMarkPlaceholder = !0;
                var V = Object.fromEntries(Object.keys(L).map(e => [e, null]));
                I.push(vp(vp(vp({
                  [Qc]: !0
                }, V), j), {}, {
                  anchor: B,
                  focus: B
                }));
              }
            }
            return (0, s.useEffect)(() => {
              setTimeout(() => {
                var {
                  selection: e
                } = g;
                if (e) {
                  var {
                      anchor: t
                    } = e,
                    n = Uu.NB.leaf(g, t.path);
                  if (j && !Uu.xv.equals(n, j, {
                    loose: !0
                  })) return void Uc.set(g, j);
                }
                Uc.delete(g);
              });
            }), s.createElement(np.Provider, {
              value: a
            }, s.createElement(Jd.Provider, {
              value: r
            }, s.createElement(hp, {
              node: b,
              receivedUserInput: E
            }, s.createElement(h, vp(vp({
              role: a ? void 0 : "textbox",
              "aria-multiline": !a || void 0
            }, m), {}, {
              spellCheck: !(!Ac && kc) && m.spellCheck,
              autoCorrect: Ac || !kc ? m.autoCorrect : "false",
              autoCapitalize: Ac || !kc ? m.autoCapitalize : "false",
              "data-slate-editor": !0,
              "data-slate-node": "value",
              contentEditable: !a,
              zindex: -1,
              suppressContentEditableWarning: !0,
              ref: O,
              style: vp(vp({}, f ? {} : vp({
                position: "relative",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
              }, x ? {
                minHeight: x
              } : {})), p),
              onBeforeInput: (0, s.useCallback)(e => {
                if (!Ac && !a && !Cp(e, m.onBeforeInput) && hd.hasSelectableTarget(g, e.target) && (e.preventDefault(), !hd.isComposing(g))) {
                  var t = e.data;
                  Uu.ML.insertText(g, t);
                }
              }, [m.onBeforeInput, g, a]),
              onInput: (0, s.useCallback)(e => {
                if (!Cp(e, m.onInput)) if (k.current) k.current.handleInput();else {
                  for (var t of w.current) t();
                  w.current = [];
                }
              }, [m.onInput]),
              onBlur: (0, s.useCallback)(e => {
                if (!a && !P.isUpdatingSelection && hd.hasSelectableTarget(g, e.target) && !Cp(e, m.onBlur)) {
                  var t = hd.findDocumentOrShadowRoot(g);
                  if (P.latestElement !== t.activeElement) {
                    var {
                      relatedTarget: n
                    } = e;
                    if (!(n === hd.toDOMNode(g, g) || td(n) && n.hasAttribute("data-slate-spacer"))) {
                      if (null != n && nd(n) && hd.hasDOMNode(g, n)) {
                        var r = hd.toSlateNode(g, n);
                        if (Uu.W_.isElement(r) && !g.isVoid(r)) return;
                      }
                      if (wc) {
                        var o = t.getSelection();
                        null == o || o.removeAllRanges();
                      }
                      Lc.delete(g);
                    }
                  }
                }
              }, [a, P.isUpdatingSelection, P.latestElement, g, m.onBlur]),
              onClick: (0, s.useCallback)(e => {
                if (hd.hasTarget(g, e.target) && !Cp(e, m.onClick) && nd(e.target)) {
                  var t = hd.toSlateNode(g, e.target),
                    n = hd.findPath(g, t);
                  if (!Uu.ML.hasPath(g, n) || Uu.NB.get(g, n) !== t) return;
                  if (3 === e.detail && n.length >= 1) {
                    var r = n;
                    if (!Uu.W_.isElement(t) || !Uu.ML.isBlock(g, t)) {
                      var o,
                        i = Uu.ML.above(g, {
                          match: e => Uu.W_.isElement(e) && Uu.ML.isBlock(g, e),
                          at: n
                        });
                      r = null !== (o = null == i ? void 0 : i[1]) && void 0 !== o ? o : n.slice(0, 1);
                    }
                    var s = Uu.ML.range(g, r);
                    return void Uu.YR.select(g, s);
                  }
                  if (a) return;
                  var l = Uu.ML.start(g, n),
                    u = Uu.ML.end(g, n),
                    c = Uu.ML.void(g, {
                      at: l
                    }),
                    d = Uu.ML.void(g, {
                      at: u
                    });
                  if (c && d && Uu.y$.equals(c[1], d[1])) {
                    var p = Uu.ML.range(g, l);
                    Uu.YR.select(g, p);
                  }
                }
              }, [g, m.onClick, a]),
              onCompositionEnd: (0, s.useCallback)(e => {
                if (hd.hasSelectableTarget(g, e.target)) {
                  var t;
                  if (hd.isComposing(g) && Promise.resolve().then(() => {
                    y(!1), Vc.set(g, !1);
                  }), null === (t = k.current) || void 0 === t || t.handleCompositionEnd(e), Cp(e, m.onCompositionEnd) || yc) return;
                  if (!wc && !Ec && !gc && !Pc && !_c && e.data) {
                    var n = Uc.get(g);
                    Uc.delete(g), void 0 !== n && (Zc.set(g, g.marks), g.marks = n), Uu.ML.insertText(g, e.data);
                    var r = Zc.get(g);
                    Zc.delete(g), void 0 !== r && (g.marks = r);
                  }
                }
              }, [m.onCompositionEnd, g]),
              onCompositionUpdate: (0, s.useCallback)(e => {
                hd.hasSelectableTarget(g, e.target) && !Cp(e, m.onCompositionUpdate) && (hd.isComposing(g) || (y(!0), Vc.set(g, !0)));
              }, [m.onCompositionUpdate, g]),
              onCompositionStart: (0, s.useCallback)(e => {
                if (hd.hasSelectableTarget(g, e.target)) {
                  var t;
                  if (null === (t = k.current) || void 0 === t || t.handleCompositionStart(e), Cp(e, m.onCompositionStart) || yc) return;
                  y(!0);
                  var {
                    selection: n
                  } = g;
                  if (n && Uu.e6.isExpanded(n)) return void Uu.ML.deleteFragment(g);
                }
              }, [m.onCompositionStart, g]),
              onCopy: (0, s.useCallback)(e => {
                !hd.hasSelectableTarget(g, e.target) || Cp(e, m.onCopy) || Sp(e) || (e.preventDefault(), hd.setFragmentData(g, e.clipboardData, "copy"));
              }, [m.onCopy, g]),
              onCut: (0, s.useCallback)(e => {
                if (!a && hd.hasSelectableTarget(g, e.target) && !Cp(e, m.onCut) && !Sp(e)) {
                  e.preventDefault(), hd.setFragmentData(g, e.clipboardData, "cut");
                  var {
                    selection: t
                  } = g;
                  if (t) if (Uu.e6.isExpanded(t)) Uu.ML.deleteFragment(g);else {
                    var n = Uu.NB.parent(g, t.anchor.path);
                    Uu.ML.isVoid(g, n) && Uu.YR.delete(g);
                  }
                }
              }, [a, g, m.onCut]),
              onDragOver: (0, s.useCallback)(e => {
                if (hd.hasTarget(g, e.target) && !Cp(e, m.onDragOver)) {
                  var t = hd.toSlateNode(g, e.target);
                  Uu.W_.isElement(t) && Uu.ML.isVoid(g, t) && e.preventDefault();
                }
              }, [m.onDragOver, g]),
              onDragStart: (0, s.useCallback)(e => {
                if (!a && hd.hasTarget(g, e.target) && !Cp(e, m.onDragStart)) {
                  var t = hd.toSlateNode(g, e.target),
                    n = hd.findPath(g, t);
                  if (Uu.W_.isElement(t) && Uu.ML.isVoid(g, t) || Uu.ML.void(g, {
                    at: n,
                    voids: !0
                  })) {
                    var r = Uu.ML.range(g, n);
                    Uu.YR.select(g, r);
                  }
                  P.isDraggingInternally = !0, hd.setFragmentData(g, e.dataTransfer, "drag");
                }
              }, [a, g, m.onDragStart, P]),
              onDrop: (0, s.useCallback)(e => {
                if (!a && hd.hasTarget(g, e.target) && !Cp(e, m.onDrop)) {
                  e.preventDefault();
                  var t = g.selection,
                    n = hd.findEventRange(g, e),
                    r = e.dataTransfer;
                  Uu.YR.select(g, n), P.isDraggingInternally && (!t || Uu.e6.equals(t, n) || Uu.ML.void(g, {
                    at: n,
                    voids: !0
                  }) || Uu.YR.delete(g, {
                    at: t
                  })), hd.insertData(g, r), hd.isFocused(g) || hd.focus(g);
                }
                P.isDraggingInternally = !1;
              }, [a, g, m.onDrop, P]),
              onDragEnd: (0, s.useCallback)(e => {
                !a && P.isDraggingInternally && m.onDragEnd && hd.hasTarget(g, e.target) && m.onDragEnd(e), P.isDraggingInternally = !1;
              }, [a, P, m, g]),
              onFocus: (0, s.useCallback)(e => {
                if (!a && !P.isUpdatingSelection && hd.hasEditableTarget(g, e.target) && !Cp(e, m.onFocus)) {
                  var t = hd.toDOMNode(g, g),
                    n = hd.findDocumentOrShadowRoot(g);
                  if (P.latestElement = n.activeElement, bc && e.target !== t) return void t.focus();
                  Lc.set(g, !0);
                }
              }, [a, P, g, m.onFocus]),
              onKeyDown: (0, s.useCallback)(e => {
                if (!a && hd.hasEditableTarget(g, e.target)) {
                  var t;
                  null === (t = k.current) || void 0 === t || t.handleKeyDown(e);
                  var {
                    nativeEvent: n
                  } = e;
                  if (hd.isComposing(g) && !1 === n.isComposing && (Vc.set(g, !1), y(!1)), Cp(e, m.onKeyDown) || hd.isComposing(g)) return;
                  var {
                      selection: r
                    } = g,
                    o = g.children[null !== r ? r.focus.path[0] : 0],
                    i = "rtl" === $u()(Uu.NB.string(o));
                  if (cp.isRedo(n)) {
                    e.preventDefault();
                    var s = g;
                    return void ("function" == typeof s.redo && s.redo());
                  }
                  if (cp.isUndo(n)) {
                    e.preventDefault();
                    var l = g;
                    return void ("function" == typeof l.undo && l.undo());
                  }
                  if (cp.isMoveLineBackward(n)) return e.preventDefault(), void Uu.YR.move(g, {
                    unit: "line",
                    reverse: !0
                  });
                  if (cp.isMoveLineForward(n)) return e.preventDefault(), void Uu.YR.move(g, {
                    unit: "line"
                  });
                  if (cp.isExtendLineBackward(n)) return e.preventDefault(), void Uu.YR.move(g, {
                    unit: "line",
                    edge: "focus",
                    reverse: !0
                  });
                  if (cp.isExtendLineForward(n)) return e.preventDefault(), void Uu.YR.move(g, {
                    unit: "line",
                    edge: "focus"
                  });
                  if (cp.isMoveBackward(n)) return e.preventDefault(), void (r && Uu.e6.isCollapsed(r) ? Uu.YR.move(g, {
                    reverse: !i
                  }) : Uu.YR.collapse(g, {
                    edge: i ? "end" : "start"
                  }));
                  if (cp.isMoveForward(n)) return e.preventDefault(), void (r && Uu.e6.isCollapsed(r) ? Uu.YR.move(g, {
                    reverse: i
                  }) : Uu.YR.collapse(g, {
                    edge: i ? "start" : "end"
                  }));
                  if (cp.isMoveWordBackward(n)) return e.preventDefault(), r && Uu.e6.isExpanded(r) && Uu.YR.collapse(g, {
                    edge: "focus"
                  }), void Uu.YR.move(g, {
                    unit: "word",
                    reverse: !i
                  });
                  if (cp.isMoveWordForward(n)) return e.preventDefault(), r && Uu.e6.isExpanded(r) && Uu.YR.collapse(g, {
                    edge: "focus"
                  }), void Uu.YR.move(g, {
                    unit: "word",
                    reverse: i
                  });
                  if (Ac) {
                    if ((Dc || wc) && r && (cp.isDeleteBackward(n) || cp.isDeleteForward(n)) && Uu.e6.isCollapsed(r)) {
                      var u = Uu.NB.parent(g, r.anchor.path);
                      if (Uu.W_.isElement(u) && Uu.ML.isVoid(g, u) && (Uu.ML.isInline(g, u) || Uu.ML.isBlock(g, u))) return e.preventDefault(), void Uu.ML.deleteBackward(g, {
                        unit: "block"
                      });
                    }
                  } else {
                    if (cp.isBold(n) || cp.isItalic(n) || cp.isTransposeCharacter(n)) return void e.preventDefault();
                    if (cp.isSoftBreak(n)) return e.preventDefault(), void Uu.ML.insertSoftBreak(g);
                    if (cp.isSplitBlock(n)) return e.preventDefault(), void Uu.ML.insertBreak(g);
                    if (cp.isDeleteBackward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "backward"
                    }) : Uu.ML.deleteBackward(g));
                    if (cp.isDeleteForward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "forward"
                    }) : Uu.ML.deleteForward(g));
                    if (cp.isDeleteLineBackward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "backward"
                    }) : Uu.ML.deleteBackward(g, {
                      unit: "line"
                    }));
                    if (cp.isDeleteLineForward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "forward"
                    }) : Uu.ML.deleteForward(g, {
                      unit: "line"
                    }));
                    if (cp.isDeleteWordBackward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "backward"
                    }) : Uu.ML.deleteBackward(g, {
                      unit: "word"
                    }));
                    if (cp.isDeleteWordForward(n)) return e.preventDefault(), void (r && Uu.e6.isExpanded(r) ? Uu.ML.deleteFragment(g, {
                      direction: "forward"
                    }) : Uu.ML.deleteForward(g, {
                      unit: "word"
                    }));
                  }
                }
              }, [a, g, m.onKeyDown]),
              onPaste: (0, s.useCallback)(e => {
                a || !hd.hasEditableTarget(g, e.target) || Cp(e, m.onPaste) || (!Ac || (e => e.clipboardData && "" !== e.clipboardData.getData("text/plain") && 1 === e.clipboardData.types.length)(e.nativeEvent) || wc) && (e.preventDefault(), hd.insertData(g, e.clipboardData));
              }, [a, g, m.onPaste])
            }), s.createElement(yp, {
              decorations: I,
              node: g,
              renderElement: l,
              renderPlaceholder: c,
              renderLeaf: u,
              selection: g.selection
            })))));
          },
          wp = e => {
            var {
              attributes: t,
              children: n
            } = e;
            return s.createElement("span", vp({}, t), n, yc && s.createElement("br", null));
          },
          xp = () => [],
          Dp = (e, t) => {
            if (t.getBoundingClientRect && (!e.selection || e.selection && Uu.e6.isCollapsed(e.selection))) {
              var n = t.startContainer.parentElement;
              n.getBoundingClientRect = t.getBoundingClientRect.bind(t), oc(n, {
                scrollMode: "if-needed"
              }), delete n.getBoundingClientRect;
            }
          },
          Cp = (e, t) => {
            if (!t) return !1;
            var n = t(e);
            return null != n ? n : e.isDefaultPrevented() || e.isPropagationStopped();
          },
          Sp = e => nd(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement),
          Ep = (e, t) => {
            if (!t) return !1;
            var n = t(e);
            return null != n ? n : e.defaultPrevented;
          },
          _p = (0, s.createContext)(!1);
        var Pp = (0, s.createContext)({});
        var kp = ["editor", "children", "onChange", "onSelectionChange", "onValueChange", "initialValue"],
          Ap = e => {
            var {
                editor: t,
                children: n,
                onChange: r,
                onSelectionChange: o,
                onValueChange: i,
                initialValue: a
              } = e,
              l = sc(e, kp),
              [u, c] = s.useState(() => {
                if (!Uu.NB.isNodeList(a)) throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(Uu.o4.stringify(a)));
                if (!Uu.ML.isEditor(t)) throw new Error("[Slate] editor is invalid! You passed: ".concat(Uu.o4.stringify(t)));
                return t.children = a, Object.assign(t, l), {
                  v: 0,
                  editor: t
                };
              }),
              {
                selectorContext: d,
                onChange: p
              } = function (e) {
                var t = (0, s.useRef)([]).current,
                  n = (0, s.useRef)({
                    editor: e
                  }).current,
                  r = (0, s.useCallback)(e => {
                    n.editor = e, t.forEach(t => t(e));
                  }, [t, n]);
                return {
                  selectorContext: (0, s.useMemo)(() => ({
                    getSlate: () => n.editor,
                    addEventListener: e => (t.push(e), () => {
                      t.splice(t.indexOf(e), 1);
                    })
                  }), [t, n]),
                  onChange: r
                };
              }(t),
              h = (0, s.useCallback)(e => {
                var n;
                if (r && r(t.children), "set_selection" === (null == e || null === (n = e.operation) || void 0 === n ? void 0 : n.type)) null == o || o(t.selection);else null == i || i(t.children);
                c(e => ({
                  v: e.v + 1,
                  editor: t
                })), p(t);
              }, [t, p, r, o, i]);
            (0, s.useEffect)(() => (qc.set(t, h), () => {
              qc.set(t, () => {});
            }), [t, h]);
            var [f, m] = (0, s.useState)(hd.isFocused(t));
            return (0, s.useEffect)(() => {
              m(hd.isFocused(t));
            }, [t]), _d(() => {
              var e = () => m(hd.isFocused(t));
              return mc >= 17 ? (document.addEventListener("focusin", e), document.addEventListener("focusout", e), () => {
                document.removeEventListener("focusin", e), document.removeEventListener("focusout", e);
              }) : (document.addEventListener("focus", e, !0), document.addEventListener("blur", e, !0), () => {
                document.removeEventListener("focus", e, !0), document.removeEventListener("blur", e, !0);
              });
            }, []), s.createElement(Pp.Provider, {
              value: d
            }, s.createElement(op.Provider, {
              value: u
            }, s.createElement(hc.Provider, {
              value: u.editor
            }, s.createElement(_p.Provider, {
              value: f
            }, n))));
          },
          zp = (e, t) => {
            var n = (t.top + t.bottom) / 2;
            return e.top <= n && e.bottom >= n;
          },
          Tp = (e, t, n) => {
            var r = hd.toDOMRange(e, t).getBoundingClientRect(),
              o = hd.toDOMRange(e, n).getBoundingClientRect();
            return zp(r, o) && zp(o, r);
          },
          Op = (e, t) => {
            var n = Uu.ML.range(e, Uu.e6.end(t)),
              r = Array.from(Uu.ML.positions(e, {
                at: t
              })),
              o = 0,
              i = r.length,
              a = Math.floor(i / 2);
            if (Tp(e, Uu.ML.range(e, r[o]), n)) return Uu.ML.range(e, r[o], n);
            if (r.length < 2) return Uu.ML.range(e, r[r.length - 1], n);
            for (; a !== r.length && a !== o;) Tp(e, Uu.ML.range(e, r[a]), n) ? i = a : o = a, a = Math.floor((o + i) / 2);
            return Uu.ML.range(e, r[i], n);
          };
        function Ip(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Fp(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ip(Object(n), !0).forEach(function (t) {
              cc(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ip(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Mp,
          Rp = (e, t) => {
            var n = [];
            for (var [r, o] of Uu.ML.levels(e, {
              at: t
            })) {
              var i = hd.findKey(e, r);
              n.push([o, i]);
            }
            return n;
          },
          jp = n(57645),
          Bp = n(4286),
          Np = n.n(Bp);
        !function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(Mp || (Mp = {}));
        Mp.Root, Mp.Text, Mp.Directive, Mp.Comment, Mp.Script, Mp.Style, Mp.Tag, Mp.CDATA, Mp.Doctype;
        class Lp {
          constructor() {
            this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
          }
          get parentNode() {
            return this.parent;
          }
          set parentNode(e) {
            this.parent = e;
          }
          get previousSibling() {
            return this.prev;
          }
          set previousSibling(e) {
            this.prev = e;
          }
          get nextSibling() {
            return this.next;
          }
          set nextSibling(e) {
            this.next = e;
          }
          cloneNode(e = !1) {
            return Yp(this, e);
          }
        }
        class Vp extends Lp {
          constructor(e) {
            super(), this.data = e;
          }
          get nodeValue() {
            return this.data;
          }
          set nodeValue(e) {
            this.data = e;
          }
        }
        class Kp extends Vp {
          constructor() {
            super(...arguments), this.type = Mp.Text;
          }
          get nodeType() {
            return 3;
          }
        }
        class qp extends Vp {
          constructor() {
            super(...arguments), this.type = Mp.Comment;
          }
          get nodeType() {
            return 8;
          }
        }
        class Hp extends Vp {
          constructor(e, t) {
            super(t), this.name = e, this.type = Mp.Directive;
          }
          get nodeType() {
            return 1;
          }
        }
        class Up extends Lp {
          constructor(e) {
            super(), this.children = e;
          }
          get firstChild() {
            var e;
            return null !== (e = this.children[0]) && void 0 !== e ? e : null;
          }
          get lastChild() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
          }
          get childNodes() {
            return this.children;
          }
          set childNodes(e) {
            this.children = e;
          }
        }
        class Zp extends Up {
          constructor() {
            super(...arguments), this.type = Mp.CDATA;
          }
          get nodeType() {
            return 4;
          }
        }
        class $p extends Up {
          constructor() {
            super(...arguments), this.type = Mp.Root;
          }
          get nodeType() {
            return 9;
          }
        }
        class Gp extends Up {
          constructor(e, t, n = [], r = "script" === e ? Mp.Script : "style" === e ? Mp.Style : Mp.Tag) {
            super(n), this.name = e, this.attribs = t, this.type = r;
          }
          get nodeType() {
            return 1;
          }
          get tagName() {
            return this.name;
          }
          set tagName(e) {
            this.name = e;
          }
          get attributes() {
            return Object.keys(this.attribs).map(e => {
              var t, n;
              return {
                name: e,
                value: this.attribs[e],
                namespace: null === (t = this["x-attribsNamespace"]) || void 0 === t ? void 0 : t[e],
                prefix: null === (n = this["x-attribsPrefix"]) || void 0 === n ? void 0 : n[e]
              };
            });
          }
        }
        function Wp(e) {
          return (t = e).type === Mp.Tag || t.type === Mp.Script || t.type === Mp.Style;
          var t;
        }
        function Yp(e, t = !1) {
          let n;
          if (function (e) {
            return e.type === Mp.Text;
          }(e)) n = new Kp(e.data);else if (function (e) {
            return e.type === Mp.Comment;
          }(e)) n = new qp(e.data);else if (Wp(e)) {
            const r = t ? Xp(e.children) : [],
              o = new Gp(e.name, {
                ...e.attribs
              }, r);
            r.forEach(e => e.parent = o), null != e.namespace && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = {
              ...e["x-attribsNamespace"]
            }), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = {
              ...e["x-attribsPrefix"]
            }), n = o;
          } else if (function (e) {
            return e.type === Mp.CDATA;
          }(e)) {
            const r = t ? Xp(e.children) : [],
              o = new Zp(r);
            r.forEach(e => e.parent = o), n = o;
          } else if (function (e) {
            return e.type === Mp.Root;
          }(e)) {
            const r = t ? Xp(e.children) : [],
              o = new $p(r);
            r.forEach(e => e.parent = o), e["x-mode"] && (o["x-mode"] = e["x-mode"]), n = o;
          } else {
            if (!function (e) {
              return e.type === Mp.Directive;
            }(e)) throw new Error(`Not implemented yet: ${e.type}`);
            {
              const t = new Hp(e.name, e.data);
              null != e["x-name"] && (t["x-name"] = e["x-name"], t["x-publicId"] = e["x-publicId"], t["x-systemId"] = e["x-systemId"]), n = t;
            }
          }
          return n.startIndex = e.startIndex, n.endIndex = e.endIndex, null != e.sourceCodeLocation && (n.sourceCodeLocation = e.sourceCodeLocation), n;
        }
        function Xp(e) {
          const t = e.map(e => Yp(e, !0));
          for (let e = 1; e < t.length; e++) t[e].prev = t[e - 1], t[e - 1].next = t[e];
          return t;
        }
        var Qp = n(17855);
        const Jp = {};
        function eh(e, t) {
          "string" != typeof t && (t = eh.defaultChars);
          const n = function (e) {
            let t = Jp[e];
            if (t) return t;
            t = Jp[e] = [];
            for (let e = 0; e < 128; e++) {
              const n = String.fromCharCode(e);
              t.push(n);
            }
            for (let n = 0; n < e.length; n++) {
              const r = e.charCodeAt(n);
              t[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
            }
            return t;
          }(t);
          return e.replace(/(%[a-f0-9]{2})+/gi, function (e) {
            let t = "";
            for (let r = 0, o = e.length; r < o; r += 3) {
              const i = parseInt(e.slice(r + 1, r + 3), 16);
              if (i < 128) t += n[i];else {
                if (192 == (224 & i) && r + 3 < o) {
                  const n = parseInt(e.slice(r + 4, r + 6), 16);
                  if (128 == (192 & n)) {
                    const e = i << 6 & 1984 | 63 & n;
                    t += e < 128 ? "��" : String.fromCharCode(e), r += 3;
                    continue;
                  }
                }
                if (224 == (240 & i) && r + 6 < o) {
                  const n = parseInt(e.slice(r + 4, r + 6), 16),
                    o = parseInt(e.slice(r + 7, r + 9), 16);
                  if (128 == (192 & n) && 128 == (192 & o)) {
                    const e = i << 12 & 61440 | n << 6 & 4032 | 63 & o;
                    t += e < 2048 || e >= 55296 && e <= 57343 ? "���" : String.fromCharCode(e), r += 6;
                    continue;
                  }
                }
                if (240 == (248 & i) && r + 9 < o) {
                  const n = parseInt(e.slice(r + 4, r + 6), 16),
                    o = parseInt(e.slice(r + 7, r + 9), 16),
                    a = parseInt(e.slice(r + 10, r + 12), 16);
                  if (128 == (192 & n) && 128 == (192 & o) && 128 == (192 & a)) {
                    let e = i << 18 & 1835008 | n << 12 & 258048 | o << 6 & 4032 | 63 & a;
                    e < 65536 || e > 1114111 ? t += "����" : (e -= 65536, t += String.fromCharCode(55296 + (e >> 10), 56320 + (1023 & e))), r += 9;
                    continue;
                  }
                }
                t += "�";
              }
            }
            return t;
          });
        }
        eh.defaultChars = ";/?:@&=+$,#", eh.componentChars = "";
        const th = eh,
          nh = {};
        function rh(e, t, n) {
          "string" != typeof t && (n = t, t = rh.defaultChars), void 0 === n && (n = !0);
          const r = function (e) {
            let t = nh[e];
            if (t) return t;
            t = nh[e] = [];
            for (let e = 0; e < 128; e++) {
              const n = String.fromCharCode(e);
              /^[0-9a-z]$/i.test(n) ? t.push(n) : t.push("%" + ("0" + e.toString(16).toUpperCase()).slice(-2));
            }
            for (let n = 0; n < e.length; n++) t[e.charCodeAt(n)] = e[n];
            return t;
          }(t);
          let o = "";
          for (let t = 0, i = e.length; t < i; t++) {
            const a = e.charCodeAt(t);
            if (n && 37 === a && t + 2 < i && /^[0-9a-f]{2}$/i.test(e.slice(t + 1, t + 3))) o += e.slice(t, t + 3), t += 2;else if (a < 128) o += r[a];else if (a >= 55296 && a <= 57343) {
              if (a >= 55296 && a <= 56319 && t + 1 < i) {
                const n = e.charCodeAt(t + 1);
                if (n >= 56320 && n <= 57343) {
                  o += encodeURIComponent(e[t] + e[t + 1]), t++;
                  continue;
                }
              }
              o += "%EF%BF%BD";
            } else o += encodeURIComponent(e[t]);
          }
          return o;
        }
        rh.defaultChars = ";/?:@&=+$,-_.!~*'()#", rh.componentChars = "-_.!~*'()";
        const oh = rh;
        function ih(e) {
          let t = "";
          return t += e.protocol || "", t += e.slashes ? "//" : "", t += e.auth ? e.auth + "@" : "", e.hostname && -1 !== e.hostname.indexOf(":") ? t += "[" + e.hostname + "]" : t += e.hostname || "", t += e.port ? ":" + e.port : "", t += e.pathname || "", t += e.search || "", t += e.hash || "", t;
        }
        function ah() {
          this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
        }
        const sh = /^([a-z0-9.+-]+:)/i,
          lh = /:[0-9]*$/,
          uh = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
          ch = ["{", "}", "|", "\\", "^", "`"].concat(["<", ">", '"', "`", " ", "\r", "\n", "\t"]),
          dh = ["'"].concat(ch),
          ph = ["%", "/", "?", ";", "#"].concat(dh),
          hh = ["/", "?", "#"],
          fh = /^[+a-z0-9A-Z_-]{0,63}$/,
          mh = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
          gh = {
            javascript: !0,
            "javascript:": !0
          },
          vh = {
            http: !0,
            https: !0,
            ftp: !0,
            gopher: !0,
            file: !0,
            "http:": !0,
            "https:": !0,
            "ftp:": !0,
            "gopher:": !0,
            "file:": !0
          };
        ah.prototype.parse = function (e, t) {
          let n,
            r,
            o,
            i = e;
          if (i = i.trim(), !t && 1 === e.split("#").length) {
            const e = uh.exec(i);
            if (e) return this.pathname = e[1], e[2] && (this.search = e[2]), this;
          }
          let a = sh.exec(i);
          if (a && (a = a[0], n = a.toLowerCase(), this.protocol = a, i = i.substr(a.length)), (t || a || i.match(/^\/\/[^@\/]+@[^@\/]+/)) && (o = "//" === i.substr(0, 2), !o || a && gh[a] || (i = i.substr(2), this.slashes = !0)), !gh[a] && (o || a && !vh[a])) {
            let e,
              t,
              n = -1;
            for (let e = 0; e < hh.length; e++) r = i.indexOf(hh[e]), -1 !== r && (-1 === n || r < n) && (n = r);
            t = -1 === n ? i.lastIndexOf("@") : i.lastIndexOf("@", n), -1 !== t && (e = i.slice(0, t), i = i.slice(t + 1), this.auth = e), n = -1;
            for (let e = 0; e < ph.length; e++) r = i.indexOf(ph[e]), -1 !== r && (-1 === n || r < n) && (n = r);
            -1 === n && (n = i.length), ":" === i[n - 1] && n--;
            const o = i.slice(0, n);
            i = i.slice(n), this.parseHost(o), this.hostname = this.hostname || "";
            const a = "[" === this.hostname[0] && "]" === this.hostname[this.hostname.length - 1];
            if (!a) {
              const e = this.hostname.split(/\./);
              for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t];
                if (n && !n.match(fh)) {
                  let r = "";
                  for (let e = 0, t = n.length; e < t; e++) n.charCodeAt(e) > 127 ? r += "x" : r += n[e];
                  if (!r.match(fh)) {
                    const r = e.slice(0, t),
                      o = e.slice(t + 1),
                      a = n.match(mh);
                    a && (r.push(a[1]), o.unshift(a[2])), o.length && (i = o.join(".") + i), this.hostname = r.join(".");
                    break;
                  }
                }
              }
            }
            this.hostname.length > 255 && (this.hostname = ""), a && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
          }
          const s = i.indexOf("#");
          -1 !== s && (this.hash = i.substr(s), i = i.slice(0, s));
          const l = i.indexOf("?");
          return -1 !== l && (this.search = i.substr(l), i = i.slice(0, l)), i && (this.pathname = i), vh[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
        }, ah.prototype.parseHost = function (e) {
          let t = lh.exec(e);
          t && (t = t[0], ":" !== t && (this.port = t.substr(1)), e = e.substr(0, e.length - t.length)), e && (this.hostname = e);
        };
        const yh = function (e, t) {
            if (e && e instanceof ah) return e;
            const n = new ah();
            return n.parse(e, t), n;
          },
          bh = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/,
          wh = /[\0-\x1F\x7F-\x9F]/,
          xh = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/,
          Dh = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/,
          Ch = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/,
          Sh = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/,
          Eh = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(e => e.charCodeAt(0))),
          _h = new Uint16Array("Ȁaglq\tɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(e => e.charCodeAt(0)));
        var Ph;
        const kh = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]),
          Ah = null !== (Ph = String.fromCodePoint) && void 0 !== Ph ? Ph : function (e) {
            let t = "";
            return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += String.fromCharCode(e), t;
          };
        function zh(e) {
          return Ah(function (e) {
            var t;
            return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : null !== (t = kh.get(e)) && void 0 !== t ? t : e;
          }(e));
        }
        var Th, Oh;
        function Ih(e) {
          return function (t, n) {
            let r = "",
              o = 0,
              i = 0;
            for (; (i = t.indexOf("&", i)) >= 0;) {
              if (r += t.slice(o, i), o = i, i += 1, t.charCodeAt(i) === Th.NUM) {
                let e = i + 1,
                  a = 10,
                  s = t.charCodeAt(e);
                (s | Th.To_LOWER_BIT) === Th.LOWER_X && (a = 16, i += 1, e += 1);
                do {
                  s = t.charCodeAt(++i);
                } while (s >= Th.ZERO && s <= Th.NINE || 16 === a && (s | Th.To_LOWER_BIT) >= Th.LOWER_A && (s | Th.To_LOWER_BIT) <= Th.LOWER_F);
                if (e !== i) {
                  const s = t.substring(e, i),
                    l = parseInt(s, a);
                  if (t.charCodeAt(i) === Th.SEMI) i += 1;else if (n) continue;
                  r += zh(l), o = i;
                }
                continue;
              }
              let a = 0,
                s = 1,
                l = 0,
                u = e[l];
              for (; i < t.length && (l = Fh(e, u, l + 1, t.charCodeAt(i)), !(l < 0)); i++, s++) {
                u = e[l];
                const r = u & Oh.VALUE_LENGTH;
                if (r) {
                  n && t.charCodeAt(i) !== Th.SEMI || (a = l, s = 0);
                  const e = (r >> 14) - 1;
                  if (0 === e) break;
                  l += e;
                }
              }
              if (0 !== a) {
                const t = (e[a] & Oh.VALUE_LENGTH) >> 14;
                r += 1 === t ? String.fromCharCode(e[a] & ~Oh.VALUE_LENGTH) : 2 === t ? String.fromCharCode(e[a + 1]) : String.fromCharCode(e[a + 1], e[a + 2]), o = i - s + 1;
              }
            }
            return r + t.slice(o);
          };
        }
        function Fh(e, t, n, r) {
          const o = (t & Oh.BRANCH_LENGTH) >> 7,
            i = t & Oh.JUMP_TABLE;
          if (0 === o) return 0 !== i && r === i ? n : -1;
          if (i) {
            const t = r - i;
            return t < 0 || t >= o ? -1 : e[n + t] - 1;
          }
          let a = n,
            s = a + o - 1;
          for (; a <= s;) {
            const t = a + s >>> 1,
              n = e[t];
            if (n < r) a = t + 1;else {
              if (!(n > r)) return e[t + o];
              s = t - 1;
            }
          }
          return -1;
        }
        !function (e) {
          e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.To_LOWER_BIT = 32] = "To_LOWER_BIT";
        }(Th || (Th = {})), function (e) {
          e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
        }(Oh || (Oh = {}));
        const Mh = Ih(Eh);
        Ih(_h);
        function Rh(e) {
          return Mh(e, !1);
        }
        function jh(e) {
          for (let t = 1; t < e.length; t++) e[t][0] += e[t - 1][0] + 1;
          return e;
        }
        new Map(jh([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, {
          v: "&lt;",
          n: 8402,
          o: "&nvlt;"
        }], [0, {
          v: "&equals;",
          n: 8421,
          o: "&bne;"
        }], [0, {
          v: "&gt;",
          n: 8402,
          o: "&nvgt;"
        }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, {
          n: 106,
          o: "&fjlig;"
        }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, {
          v: "&MediumSpace;",
          n: 8202,
          o: "&ThickSpace;"
        }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, {
          v: "&rarrw;",
          n: 824,
          o: "&nrarrw;"
        }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, {
          v: "&part;",
          n: 824,
          o: "&npart;"
        }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, {
          v: "&ang;",
          n: 8402,
          o: "&nang;"
        }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, {
          v: "&cap;",
          n: 65024,
          o: "&caps;"
        }], [0, {
          v: "&cup;",
          n: 65024,
          o: "&cups;"
        }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, {
          v: "&sim;",
          n: 8402,
          o: "&nvsim;"
        }], [0, {
          v: "&backsim;",
          n: 817,
          o: "&race;"
        }], [0, {
          v: "&ac;",
          n: 819,
          o: "&acE;"
        }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, {
          v: "&eqsim;",
          n: 824,
          o: "&nesim;"
        }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, {
          v: "&apid;",
          n: 824,
          o: "&napid;"
        }], [0, "&backcong;"], [0, {
          v: "&asympeq;",
          n: 8402,
          o: "&nvap;"
        }], [0, {
          v: "&bump;",
          n: 824,
          o: "&nbump;"
        }], [0, {
          v: "&bumpe;",
          n: 824,
          o: "&nbumpe;"
        }], [0, {
          v: "&doteq;",
          n: 824,
          o: "&nedot;"
        }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, {
          v: "&Congruent;",
          n: 8421,
          o: "&bnequiv;"
        }], [0, "&nequiv;"], [1, {
          v: "&le;",
          n: 8402,
          o: "&nvle;"
        }], [0, {
          v: "&ge;",
          n: 8402,
          o: "&nvge;"
        }], [0, {
          v: "&lE;",
          n: 824,
          o: "&nlE;"
        }], [0, {
          v: "&gE;",
          n: 824,
          o: "&ngE;"
        }], [0, {
          v: "&lnE;",
          n: 65024,
          o: "&lvertneqq;"
        }], [0, {
          v: "&gnE;",
          n: 65024,
          o: "&gvertneqq;"
        }], [0, {
          v: "&ll;",
          n: new Map(jh([[824, "&nLtv;"], [7577, "&nLt;"]]))
        }], [0, {
          v: "&gg;",
          n: new Map(jh([[824, "&nGtv;"], [7577, "&nGt;"]]))
        }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, {
          v: "&scsim;",
          n: 824,
          o: "&NotSucceedsTilde;"
        }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, {
          v: "&sub;",
          n: 8402,
          o: "&NotSubset;"
        }], [0, {
          v: "&sup;",
          n: 8402,
          o: "&NotSuperset;"
        }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, {
          v: "&subne;",
          n: 65024,
          o: "&varsubsetneq;"
        }], [0, {
          v: "&supne;",
          n: 65024,
          o: "&varsupsetneq;"
        }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, {
          v: "&sqsub;",
          n: 824,
          o: "&NotSquareSubset;"
        }], [0, {
          v: "&sqsup;",
          n: 824,
          o: "&NotSquareSuperset;"
        }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, {
          v: "&sqcap;",
          n: 65024,
          o: "&sqcaps;"
        }], [0, {
          v: "&sqcup;",
          n: 65024,
          o: "&sqcups;"
        }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, {
          v: "&LeftTriangleEqual;",
          n: 8402,
          o: "&nvltrie;"
        }], [0, {
          v: "&RightTriangleEqual;",
          n: 8402,
          o: "&nvrtrie;"
        }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, {
          v: "&Ll;",
          n: 824,
          o: "&nLl;"
        }], [0, {
          v: "&Gg;",
          n: 824,
          o: "&nGg;"
        }], [0, {
          v: "&leg;",
          n: 65024,
          o: "&lesg;"
        }], [0, {
          v: "&gel;",
          n: 65024,
          o: "&gesl;"
        }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, {
          v: "&isindot;",
          n: 824,
          o: "&notindot;"
        }], [0, "&notinvc;"], [0, "&notinvb;"], [1, {
          v: "&isinE;",
          n: 824,
          o: "&notinE;"
        }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, {
          v: "&rarrc;",
          n: 824,
          o: "&nrarrc;"
        }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, {
          v: "&LeftTriangleBar;",
          n: 824,
          o: "&NotLeftTriangleBar;"
        }], [0, {
          v: "&RightTriangleBar;",
          n: 824,
          o: "&NotRightTriangleBar;"
        }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, {
          v: "&congdot;",
          n: 824,
          o: "&ncongdot;"
        }], [0, "&easter;"], [0, "&apacir;"], [0, {
          v: "&apE;",
          n: 824,
          o: "&napE;"
        }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, {
          v: "&leqslant;",
          n: 824,
          o: "&nleqslant;"
        }], [0, {
          v: "&geqslant;",
          n: 824,
          o: "&ngeqslant;"
        }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, {
          v: "&LessLess;",
          n: 824,
          o: "&NotNestedLessLess;"
        }], [0, {
          v: "&GreaterGreater;",
          n: 824,
          o: "&NotNestedGreaterGreater;"
        }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, {
          v: "&smte;",
          n: 65024,
          o: "&smtes;"
        }], [0, {
          v: "&late;",
          n: 65024,
          o: "&lates;"
        }], [0, "&bumpE;"], [0, {
          v: "&PrecedesEqual;",
          n: 824,
          o: "&NotPrecedesEqual;"
        }], [0, {
          v: "&sce;",
          n: 824,
          o: "&NotSucceedsEqual;"
        }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, {
          v: "&subE;",
          n: 824,
          o: "&nsubE;"
        }], [0, {
          v: "&supE;",
          n: 824,
          o: "&nsupE;"
        }], [0, "&subsim;"], [0, "&supsim;"], [2, {
          v: "&subnE;",
          n: 65024,
          o: "&varsubsetneqq;"
        }], [0, {
          v: "&supnE;",
          n: 65024,
          o: "&varsupsetneqq;"
        }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, {
          v: "&parsl;",
          n: 8421,
          o: "&nparsl;"
        }], [44343, {
          n: new Map(jh([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]]))
        }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
        const Bh = new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
        String.prototype.codePointAt;
        function Nh(e, t) {
          return function (n) {
            let r,
              o = 0,
              i = "";
            for (; r = e.exec(n);) o !== r.index && (i += n.substring(o, r.index)), i += t.get(r[0].charCodeAt(0)), o = r.index + 1;
            return i + n.substring(o);
          };
        }
        Nh(/[&<>'"]/g, Bh), Nh(/["&\u00A0]/g, new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), Nh(/[&<>\u00A0]/g, new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
        var Lh, Vh, Kh;
        function qh(e) {
          return "[object String]" === function (e) {
            return Object.prototype.toString.call(e);
          }(e);
        }
        !function (e) {
          e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
        }(Lh || (Lh = {})), function (e) {
          e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict";
        }(Vh || (Vh = {})), function (e) {
          e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
        }(Kh || (Kh = {}));
        const Hh = Object.prototype.hasOwnProperty;
        function Uh(e, t) {
          return Hh.call(e, t);
        }
        function Zh(e) {
          const t = Array.prototype.slice.call(arguments, 1);
          return t.forEach(function (t) {
            if (t) {
              if ("object" != typeof t) throw new TypeError(t + "must be object");
              Object.keys(t).forEach(function (n) {
                e[n] = t[n];
              });
            }
          }), e;
        }
        function $h(e, t, n) {
          return [].concat(e.slice(0, t), n, e.slice(t + 1));
        }
        function Gh(e) {
          return !(e >= 55296 && e <= 57343) && !(e >= 64976 && e <= 65007) && 65535 != (65535 & e) && 65534 != (65535 & e) && !(e >= 0 && e <= 8) && 11 !== e && !(e >= 14 && e <= 31) && !(e >= 127 && e <= 159) && !(e > 1114111);
        }
        function Wh(e) {
          if (e > 65535) {
            const t = 55296 + ((e -= 65536) >> 10),
              n = 56320 + (1023 & e);
            return String.fromCharCode(t, n);
          }
          return String.fromCharCode(e);
        }
        const Yh = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g,
          Xh = new RegExp(Yh.source + "|" + /&([a-z#][a-z0-9]{1,31});/gi.source, "gi"),
          Qh = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
        function Jh(e) {
          return e.indexOf("\\") < 0 ? e : e.replace(Yh, "$1");
        }
        function ef(e) {
          return e.indexOf("\\") < 0 && e.indexOf("&") < 0 ? e : e.replace(Xh, function (e, t, n) {
            return t || function (e, t) {
              if (35 === t.charCodeAt(0) && Qh.test(t)) {
                const n = "x" === t[1].toLowerCase() ? parseInt(t.slice(2), 16) : parseInt(t.slice(1), 10);
                return Gh(n) ? Wh(n) : e;
              }
              const n = Rh(e);
              return n !== e ? n : e;
            }(e, n);
          });
        }
        const tf = /[&<>"]/,
          nf = /[&<>"]/g,
          rf = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;"
          };
        function of(e) {
          return rf[e];
        }
        function af(e) {
          return tf.test(e) ? e.replace(nf, of) : e;
        }
        const sf = /[.?*+^$[\]\\(){}|-]/g;
        function lf(e) {
          return e.replace(sf, "\\$&");
        }
        function uf(e) {
          switch (e) {
            case 9:
            case 32:
              return !0;
          }
          return !1;
        }
        function cf(e) {
          if (e >= 8192 && e <= 8202) return !0;
          switch (e) {
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 32:
            case 160:
            case 5760:
            case 8239:
            case 8287:
            case 12288:
              return !0;
          }
          return !1;
        }
        function df(e) {
          return Dh.test(e) || Ch.test(e);
        }
        function pf(e) {
          switch (e) {
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 41:
            case 42:
            case 43:
            case 44:
            case 45:
            case 46:
            case 47:
            case 58:
            case 59:
            case 60:
            case 61:
            case 62:
            case 63:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 124:
            case 125:
            case 126:
              return !0;
            default:
              return !1;
          }
        }
        function hf(e) {
          return e = e.trim().replace(/\s+/g, " "), "Ṿ" === "ẞ".toLowerCase() && (e = e.replace(/ẞ/g, "ß")), e.toLowerCase().toUpperCase();
        }
        const ff = {
          mdurl: r,
          ucmicro: o
        };
        function mf(e, t, n) {
          let r, o, i, a;
          const s = e.posMax,
            l = e.pos;
          for (e.pos = t + 1, r = 1; e.pos < s;) {
            if (i = e.src.charCodeAt(e.pos), 93 === i && (r--, 0 === r)) {
              o = !0;
              break;
            }
            if (a = e.pos, e.md.inline.skipToken(e), 91 === i) if (a === e.pos - 1) r++;else if (n) return e.pos = l, -1;
          }
          let u = -1;
          return o && (u = e.pos), e.pos = l, u;
        }
        function gf(e, t, n) {
          let r,
            o = t;
          const i = {
            ok: !1,
            pos: 0,
            str: ""
          };
          if (60 === e.charCodeAt(o)) {
            for (o++; o < n;) {
              if (r = e.charCodeAt(o), 10 === r) return i;
              if (60 === r) return i;
              if (62 === r) return i.pos = o + 1, i.str = ef(e.slice(t + 1, o)), i.ok = !0, i;
              92 === r && o + 1 < n ? o += 2 : o++;
            }
            return i;
          }
          let a = 0;
          for (; o < n && (r = e.charCodeAt(o), 32 !== r) && !(r < 32 || 127 === r);) if (92 === r && o + 1 < n) {
            if (32 === e.charCodeAt(o + 1)) break;
            o += 2;
          } else {
            if (40 === r && (a++, a > 32)) return i;
            if (41 === r) {
              if (0 === a) break;
              a--;
            }
            o++;
          }
          return t === o || 0 !== a || (i.str = ef(e.slice(t, o)), i.pos = o, i.ok = !0), i;
        }
        function vf(e, t, n, r) {
          let o,
            i = t;
          const a = {
            ok: !1,
            can_continue: !1,
            pos: 0,
            str: "",
            marker: 0
          };
          if (r) a.str = r.str, a.marker = r.marker;else {
            if (i >= n) return a;
            let r = e.charCodeAt(i);
            if (34 !== r && 39 !== r && 40 !== r) return a;
            t++, i++, 40 === r && (r = 41), a.marker = r;
          }
          for (; i < n;) {
            if (o = e.charCodeAt(i), o === a.marker) return a.pos = i + 1, a.str += ef(e.slice(t, i)), a.ok = !0, a;
            if (40 === o && 41 === a.marker) return a;
            92 === o && i + 1 < n && i++, i++;
          }
          return a.can_continue = !0, a.str += ef(e.slice(t, i)), a;
        }
        const yf = {};
        function bf() {
          this.rules = Zh({}, yf);
        }
        yf.code_inline = function (e, t, n, r, o) {
          const i = e[t];
          return "<code" + o.renderAttrs(i) + ">" + af(i.content) + "</code>";
        }, yf.code_block = function (e, t, n, r, o) {
          const i = e[t];
          return "<pre" + o.renderAttrs(i) + "><code>" + af(e[t].content) + "</code></pre>\n";
        }, yf.fence = function (e, t, n, r, o) {
          const i = e[t],
            a = i.info ? ef(i.info).trim() : "";
          let s,
            l = "",
            u = "";
          if (a) {
            const e = a.split(/(\s+)/g);
            l = e[0], u = e.slice(2).join("");
          }
          if (s = n.highlight && n.highlight(i.content, l, u) || af(i.content), 0 === s.indexOf("<pre")) return s + "\n";
          if (a) {
            const e = i.attrIndex("class"),
              t = i.attrs ? i.attrs.slice() : [];
            e < 0 ? t.push(["class", n.langPrefix + l]) : (t[e] = t[e].slice(), t[e][1] += " " + n.langPrefix + l);
            const r = {
              attrs: t
            };
            return `<pre><code${o.renderAttrs(r)}>${s}</code></pre>\n`;
          }
          return `<pre><code${o.renderAttrs(i)}>${s}</code></pre>\n`;
        }, yf.image = function (e, t, n, r, o) {
          const i = e[t];
          return i.attrs[i.attrIndex("alt")][1] = o.renderInlineAsText(i.children, n, r), o.renderToken(e, t, n);
        }, yf.hardbreak = function (e, t, n) {
          return n.xhtmlOut ? "<br />\n" : "<br>\n";
        }, yf.softbreak = function (e, t, n) {
          return n.breaks ? n.xhtmlOut ? "<br />\n" : "<br>\n" : "\n";
        }, yf.text = function (e, t) {
          return af(e[t].content);
        }, yf.html_block = function (e, t) {
          return e[t].content;
        }, yf.html_inline = function (e, t) {
          return e[t].content;
        }, bf.prototype.renderAttrs = function (e) {
          let t, n, r;
          if (!e.attrs) return "";
          for (r = "", t = 0, n = e.attrs.length; t < n; t++) r += " " + af(e.attrs[t][0]) + '="' + af(e.attrs[t][1]) + '"';
          return r;
        }, bf.prototype.renderToken = function (e, t, n) {
          const r = e[t];
          let o = "";
          if (r.hidden) return "";
          r.block && -1 !== r.nesting && t && e[t - 1].hidden && (o += "\n"), o += (-1 === r.nesting ? "</" : "<") + r.tag, o += this.renderAttrs(r), 0 === r.nesting && n.xhtmlOut && (o += " /");
          let i = !1;
          if (r.block && (i = !0, 1 === r.nesting && t + 1 < e.length)) {
            const n = e[t + 1];
            ("inline" === n.type || n.hidden || -1 === n.nesting && n.tag === r.tag) && (i = !1);
          }
          return o += i ? ">\n" : ">", o;
        }, bf.prototype.renderInline = function (e, t, n) {
          let r = "";
          const o = this.rules;
          for (let i = 0, a = e.length; i < a; i++) {
            const a = e[i].type;
            void 0 !== o[a] ? r += o[a](e, i, t, n, this) : r += this.renderToken(e, i, t);
          }
          return r;
        }, bf.prototype.renderInlineAsText = function (e, t, n) {
          let r = "";
          for (let o = 0, i = e.length; o < i; o++) switch (e[o].type) {
            case "text":
            case "html_inline":
            case "html_block":
              r += e[o].content;
              break;
            case "image":
              r += this.renderInlineAsText(e[o].children, t, n);
              break;
            case "softbreak":
            case "hardbreak":
              r += "\n";
          }
          return r;
        }, bf.prototype.render = function (e, t, n) {
          let r = "";
          const o = this.rules;
          for (let i = 0, a = e.length; i < a; i++) {
            const a = e[i].type;
            "inline" === a ? r += this.renderInline(e[i].children, t, n) : void 0 !== o[a] ? r += o[a](e, i, t, n, this) : r += this.renderToken(e, i, t, n);
          }
          return r;
        };
        const wf = bf;
        function xf() {
          this.__rules__ = [], this.__cache__ = null;
        }
        xf.prototype.__find__ = function (e) {
          for (let t = 0; t < this.__rules__.length; t++) if (this.__rules__[t].name === e) return t;
          return -1;
        }, xf.prototype.__compile__ = function () {
          const e = this,
            t = [""];
          e.__rules__.forEach(function (e) {
            e.enabled && e.alt.forEach(function (e) {
              t.indexOf(e) < 0 && t.push(e);
            });
          }), e.__cache__ = {}, t.forEach(function (t) {
            e.__cache__[t] = [], e.__rules__.forEach(function (n) {
              n.enabled && (t && n.alt.indexOf(t) < 0 || e.__cache__[t].push(n.fn));
            });
          });
        }, xf.prototype.at = function (e, t, n) {
          const r = this.__find__(e),
            o = n || {};
          if (-1 === r) throw new Error("Parser rule not found: " + e);
          this.__rules__[r].fn = t, this.__rules__[r].alt = o.alt || [], this.__cache__ = null;
        }, xf.prototype.before = function (e, t, n, r) {
          const o = this.__find__(e),
            i = r || {};
          if (-1 === o) throw new Error("Parser rule not found: " + e);
          this.__rules__.splice(o, 0, {
            name: t,
            enabled: !0,
            fn: n,
            alt: i.alt || []
          }), this.__cache__ = null;
        }, xf.prototype.after = function (e, t, n, r) {
          const o = this.__find__(e),
            i = r || {};
          if (-1 === o) throw new Error("Parser rule not found: " + e);
          this.__rules__.splice(o + 1, 0, {
            name: t,
            enabled: !0,
            fn: n,
            alt: i.alt || []
          }), this.__cache__ = null;
        }, xf.prototype.push = function (e, t, n) {
          const r = n || {};
          this.__rules__.push({
            name: e,
            enabled: !0,
            fn: t,
            alt: r.alt || []
          }), this.__cache__ = null;
        }, xf.prototype.enable = function (e, t) {
          Array.isArray(e) || (e = [e]);
          const n = [];
          return e.forEach(function (e) {
            const r = this.__find__(e);
            if (r < 0) {
              if (t) return;
              throw new Error("Rules manager: invalid rule name " + e);
            }
            this.__rules__[r].enabled = !0, n.push(e);
          }, this), this.__cache__ = null, n;
        }, xf.prototype.enableOnly = function (e, t) {
          Array.isArray(e) || (e = [e]), this.__rules__.forEach(function (e) {
            e.enabled = !1;
          }), this.enable(e, t);
        }, xf.prototype.disable = function (e, t) {
          Array.isArray(e) || (e = [e]);
          const n = [];
          return e.forEach(function (e) {
            const r = this.__find__(e);
            if (r < 0) {
              if (t) return;
              throw new Error("Rules manager: invalid rule name " + e);
            }
            this.__rules__[r].enabled = !1, n.push(e);
          }, this), this.__cache__ = null, n;
        }, xf.prototype.getRules = function (e) {
          return null === this.__cache__ && this.__compile__(), this.__cache__[e] || [];
        };
        const Df = xf;
        function Cf(e, t, n) {
          this.type = e, this.tag = t, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
        }
        Cf.prototype.attrIndex = function (e) {
          if (!this.attrs) return -1;
          const t = this.attrs;
          for (let n = 0, r = t.length; n < r; n++) if (t[n][0] === e) return n;
          return -1;
        }, Cf.prototype.attrPush = function (e) {
          this.attrs ? this.attrs.push(e) : this.attrs = [e];
        }, Cf.prototype.attrSet = function (e, t) {
          const n = this.attrIndex(e),
            r = [e, t];
          n < 0 ? this.attrPush(r) : this.attrs[n] = r;
        }, Cf.prototype.attrGet = function (e) {
          const t = this.attrIndex(e);
          let n = null;
          return t >= 0 && (n = this.attrs[t][1]), n;
        }, Cf.prototype.attrJoin = function (e, t) {
          const n = this.attrIndex(e);
          n < 0 ? this.attrPush([e, t]) : this.attrs[n][1] = this.attrs[n][1] + " " + t;
        };
        const Sf = Cf;
        function Ef(e, t, n) {
          this.src = e, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = t;
        }
        Ef.prototype.Token = Sf;
        const _f = Ef,
          Pf = /\r\n?|\n/g,
          kf = /\0/g;
        function Af(e) {
          return /^<\/a\s*>/i.test(e);
        }
        const zf = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/,
          Tf = /\((c|tm|r)\)/i,
          Of = /\((c|tm|r)\)/gi,
          If = {
            c: "©",
            r: "®",
            tm: "™"
          };
        function Ff(e, t) {
          return If[t.toLowerCase()];
        }
        function Mf(e) {
          let t = 0;
          for (let n = e.length - 1; n >= 0; n--) {
            const r = e[n];
            "text" !== r.type || t || (r.content = r.content.replace(Of, Ff)), "link_open" === r.type && "auto" === r.info && t--, "link_close" === r.type && "auto" === r.info && t++;
          }
        }
        function Rf(e) {
          let t = 0;
          for (let n = e.length - 1; n >= 0; n--) {
            const r = e[n];
            "text" !== r.type || t || zf.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/gm, "$1—").replace(/(^|\s)--(?=\s|$)/gm, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/gm, "$1–")), "link_open" === r.type && "auto" === r.info && t--, "link_close" === r.type && "auto" === r.info && t++;
          }
        }
        const jf = /['"]/,
          Bf = /['"]/g;
        function Nf(e, t, n) {
          return e.slice(0, t) + n + e.slice(t + 1);
        }
        function Lf(e, t) {
          let n;
          const r = [];
          for (let o = 0; o < e.length; o++) {
            const i = e[o],
              a = e[o].level;
            for (n = r.length - 1; n >= 0 && !(r[n].level <= a); n--);
            if (r.length = n + 1, "text" !== i.type) continue;
            let s = i.content,
              l = 0,
              u = s.length;
            e: for (; l < u;) {
              Bf.lastIndex = l;
              const c = Bf.exec(s);
              if (!c) break;
              let d = !0,
                p = !0;
              l = c.index + 1;
              const h = "'" === c[0];
              let f = 32;
              if (c.index - 1 >= 0) f = s.charCodeAt(c.index - 1);else for (n = o - 1; n >= 0 && "softbreak" !== e[n].type && "hardbreak" !== e[n].type; n--) if (e[n].content) {
                f = e[n].content.charCodeAt(e[n].content.length - 1);
                break;
              }
              let m = 32;
              if (l < u) m = s.charCodeAt(l);else for (n = o + 1; n < e.length && "softbreak" !== e[n].type && "hardbreak" !== e[n].type; n++) if (e[n].content) {
                m = e[n].content.charCodeAt(0);
                break;
              }
              const g = pf(f) || df(String.fromCharCode(f)),
                v = pf(m) || df(String.fromCharCode(m)),
                y = cf(f),
                b = cf(m);
              if (b ? d = !1 : v && (y || g || (d = !1)), y ? p = !1 : g && (b || v || (p = !1)), 34 === m && '"' === c[0] && f >= 48 && f <= 57 && (p = d = !1), d && p && (d = g, p = v), d || p) {
                if (p) for (n = r.length - 1; n >= 0; n--) {
                  let d = r[n];
                  if (r[n].level < a) break;
                  if (d.single === h && r[n].level === a) {
                    let a, p;
                    d = r[n], h ? (a = t.md.options.quotes[2], p = t.md.options.quotes[3]) : (a = t.md.options.quotes[0], p = t.md.options.quotes[1]), i.content = Nf(i.content, c.index, p), e[d.token].content = Nf(e[d.token].content, d.pos, a), l += p.length - 1, d.token === o && (l += a.length - 1), s = i.content, u = s.length, r.length = n;
                    continue e;
                  }
                }
                d ? r.push({
                  token: o,
                  pos: c.index,
                  single: h,
                  level: a
                }) : p && h && (i.content = Nf(i.content, c.index, "’"));
              } else h && (i.content = Nf(i.content, c.index, "’"));
            }
          }
        }
        const Vf = [["normalize", function (e) {
          let t;
          t = e.src.replace(Pf, "\n"), t = t.replace(kf, "�"), e.src = t;
        }], ["block", function (e) {
          let t;
          e.inlineMode ? (t = new e.Token("inline", "", 0), t.content = e.src, t.map = [0, 1], t.children = [], e.tokens.push(t)) : e.md.block.parse(e.src, e.md, e.env, e.tokens);
        }], ["inline", function (e) {
          const t = e.tokens;
          for (let n = 0, r = t.length; n < r; n++) {
            const r = t[n];
            "inline" === r.type && e.md.inline.parse(r.content, e.md, e.env, r.children);
          }
        }], ["linkify", function (e) {
          const t = e.tokens;
          var n;
          if (e.md.options.linkify) for (let r = 0, o = t.length; r < o; r++) {
            if ("inline" !== t[r].type || !e.md.linkify.pretest(t[r].content)) continue;
            let o = t[r].children,
              i = 0;
            for (let a = o.length - 1; a >= 0; a--) {
              const s = o[a];
              if ("link_close" !== s.type) {
                if ("html_inline" === s.type && (n = s.content, /^<a[>\s]/i.test(n) && i > 0 && i--, Af(s.content) && i++), !(i > 0) && "text" === s.type && e.md.linkify.test(s.content)) {
                  const n = s.content;
                  let i = e.md.linkify.match(n);
                  const l = [];
                  let u = s.level,
                    c = 0;
                  i.length > 0 && 0 === i[0].index && a > 0 && "text_special" === o[a - 1].type && (i = i.slice(1));
                  for (let t = 0; t < i.length; t++) {
                    const r = i[t].url,
                      o = e.md.normalizeLink(r);
                    if (!e.md.validateLink(o)) continue;
                    let a = i[t].text;
                    a = i[t].schema ? "mailto:" !== i[t].schema || /^mailto:/i.test(a) ? e.md.normalizeLinkText(a) : e.md.normalizeLinkText("mailto:" + a).replace(/^mailto:/, "") : e.md.normalizeLinkText("http://" + a).replace(/^http:\/\//, "");
                    const s = i[t].index;
                    if (s > c) {
                      const t = new e.Token("text", "", 0);
                      t.content = n.slice(c, s), t.level = u, l.push(t);
                    }
                    const d = new e.Token("link_open", "a", 1);
                    d.attrs = [["href", o]], d.level = u++, d.markup = "linkify", d.info = "auto", l.push(d);
                    const p = new e.Token("text", "", 0);
                    p.content = a, p.level = u, l.push(p);
                    const h = new e.Token("link_close", "a", -1);
                    h.level = --u, h.markup = "linkify", h.info = "auto", l.push(h), c = i[t].lastIndex;
                  }
                  if (c < n.length) {
                    const t = new e.Token("text", "", 0);
                    t.content = n.slice(c), t.level = u, l.push(t);
                  }
                  t[r].children = o = $h(o, a, l);
                }
              } else for (a--; o[a].level !== s.level && "link_open" !== o[a].type;) a--;
            }
          }
        }], ["replacements", function (e) {
          let t;
          if (e.md.options.typographer) for (t = e.tokens.length - 1; t >= 0; t--) "inline" === e.tokens[t].type && (Tf.test(e.tokens[t].content) && Mf(e.tokens[t].children), zf.test(e.tokens[t].content) && Rf(e.tokens[t].children));
        }], ["smartquotes", function (e) {
          if (e.md.options.typographer) for (let t = e.tokens.length - 1; t >= 0; t--) "inline" === e.tokens[t].type && jf.test(e.tokens[t].content) && Lf(e.tokens[t].children, e);
        }], ["text_join", function (e) {
          let t, n;
          const r = e.tokens,
            o = r.length;
          for (let e = 0; e < o; e++) {
            if ("inline" !== r[e].type) continue;
            const o = r[e].children,
              i = o.length;
            for (t = 0; t < i; t++) "text_special" === o[t].type && (o[t].type = "text");
            for (t = n = 0; t < i; t++) "text" === o[t].type && t + 1 < i && "text" === o[t + 1].type ? o[t + 1].content = o[t].content + o[t + 1].content : (t !== n && (o[n] = o[t]), n++);
            t !== n && (o.length = n);
          }
        }]];
        function Kf() {
          this.ruler = new Df();
          for (let e = 0; e < Vf.length; e++) this.ruler.push(Vf[e][0], Vf[e][1]);
        }
        Kf.prototype.process = function (e) {
          const t = this.ruler.getRules("");
          for (let n = 0, r = t.length; n < r; n++) t[n](e);
        }, Kf.prototype.State = _f;
        const qf = Kf;
        function Hf(e, t, n, r) {
          this.src = e, this.md = t, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
          const o = this.src;
          for (let e = 0, t = 0, n = 0, r = 0, i = o.length, a = !1; t < i; t++) {
            const s = o.charCodeAt(t);
            if (!a) {
              if (uf(s)) {
                n++, 9 === s ? r += 4 - r % 4 : r++;
                continue;
              }
              a = !0;
            }
            10 !== s && t !== i - 1 || (10 !== s && t++, this.bMarks.push(e), this.eMarks.push(t), this.tShift.push(n), this.sCount.push(r), this.bsCount.push(0), a = !1, n = 0, r = 0, e = t + 1);
          }
          this.bMarks.push(o.length), this.eMarks.push(o.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
        }
        Hf.prototype.push = function (e, t, n) {
          const r = new Sf(e, t, n);
          return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
        }, Hf.prototype.isEmpty = function (e) {
          return this.bMarks[e] + this.tShift[e] >= this.eMarks[e];
        }, Hf.prototype.skipEmptyLines = function (e) {
          for (let t = this.lineMax; e < t && !(this.bMarks[e] + this.tShift[e] < this.eMarks[e]); e++);
          return e;
        }, Hf.prototype.skipSpaces = function (e) {
          for (let t = this.src.length; e < t; e++) {
            if (!uf(this.src.charCodeAt(e))) break;
          }
          return e;
        }, Hf.prototype.skipSpacesBack = function (e, t) {
          if (e <= t) return e;
          for (; e > t;) if (!uf(this.src.charCodeAt(--e))) return e + 1;
          return e;
        }, Hf.prototype.skipChars = function (e, t) {
          for (let n = this.src.length; e < n && this.src.charCodeAt(e) === t; e++);
          return e;
        }, Hf.prototype.skipCharsBack = function (e, t, n) {
          if (e <= n) return e;
          for (; e > n;) if (t !== this.src.charCodeAt(--e)) return e + 1;
          return e;
        }, Hf.prototype.getLines = function (e, t, n, r) {
          if (e >= t) return "";
          const o = new Array(t - e);
          for (let i = 0, a = e; a < t; a++, i++) {
            let e = 0;
            const s = this.bMarks[a];
            let l,
              u = s;
            for (l = a + 1 < t || r ? this.eMarks[a] + 1 : this.eMarks[a]; u < l && e < n;) {
              const t = this.src.charCodeAt(u);
              if (uf(t)) 9 === t ? e += 4 - (e + this.bsCount[a]) % 4 : e++;else {
                if (!(u - s < this.tShift[a])) break;
                e++;
              }
              u++;
            }
            o[i] = e > n ? new Array(e - n + 1).join(" ") + this.src.slice(u, l) : this.src.slice(u, l);
          }
          return o.join("");
        }, Hf.prototype.Token = Sf;
        const Uf = Hf;
        function Zf(e, t) {
          const n = e.bMarks[t] + e.tShift[t],
            r = e.eMarks[t];
          return e.src.slice(n, r);
        }
        function $f(e) {
          const t = [],
            n = e.length;
          let r = 0,
            o = e.charCodeAt(r),
            i = !1,
            a = 0,
            s = "";
          for (; r < n;) 124 === o && (i ? (s += e.substring(a, r - 1), a = r) : (t.push(s + e.substring(a, r)), s = "", a = r + 1)), i = 92 === o, r++, o = e.charCodeAt(r);
          return t.push(s + e.substring(a)), t;
        }
        function Gf(e, t) {
          const n = e.eMarks[t];
          let r = e.bMarks[t] + e.tShift[t];
          const o = e.src.charCodeAt(r++);
          if (42 !== o && 45 !== o && 43 !== o) return -1;
          if (r < n) {
            if (!uf(e.src.charCodeAt(r))) return -1;
          }
          return r;
        }
        function Wf(e, t) {
          const n = e.bMarks[t] + e.tShift[t],
            r = e.eMarks[t];
          let o = n;
          if (o + 1 >= r) return -1;
          let i = e.src.charCodeAt(o++);
          if (i < 48 || i > 57) return -1;
          for (;;) {
            if (o >= r) return -1;
            if (i = e.src.charCodeAt(o++), !(i >= 48 && i <= 57)) {
              if (41 === i || 46 === i) break;
              return -1;
            }
            if (o - n >= 10) return -1;
          }
          return o < r && (i = e.src.charCodeAt(o), !uf(i)) ? -1 : o;
        }
        const Yf = "<[A-Za-z][A-Za-z0-9\\-]*(?:\\s+[a-zA-Z_:][a-zA-Z0-9:._-]*(?:\\s*=\\s*(?:[^\"'=<>`\\x00-\\x20]+|'[^']*'|\"[^\"]*\"))?)*\\s*\\/?>",
          Xf = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>",
          Qf = new RegExp("^(?:" + Yf + "|" + Xf + "|\x3c!---?>|\x3c!--(?:[^-]|-[^-]|--[^>])*--\x3e|<[?][\\s\\S]*?[?]>|<![A-Za-z][^>]*>|<!\\[CDATA\\[[\\s\\S]*?\\]\\]>)"),
          Jf = new RegExp("^(?:" + Yf + "|" + Xf + ")"),
          em = [[/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0], [/^<!--/, /-->/, !0], [/^<\?/, /\?>/, !0], [/^<![A-Z]/, />/, !0], [/^<!\[CDATA\[/, /\]\]>/, !0], [new RegExp("^</?(" + ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"].join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0], [new RegExp(Jf.source + "\\s*$"), /^$/, !1]];
        const tm = [["table", function (e, t, n, r) {
          if (t + 2 > n) return !1;
          let o = t + 1;
          if (e.sCount[o] < e.blkIndent) return !1;
          if (e.sCount[o] - e.blkIndent >= 4) return !1;
          let i = e.bMarks[o] + e.tShift[o];
          if (i >= e.eMarks[o]) return !1;
          const a = e.src.charCodeAt(i++);
          if (124 !== a && 45 !== a && 58 !== a) return !1;
          if (i >= e.eMarks[o]) return !1;
          const s = e.src.charCodeAt(i++);
          if (124 !== s && 45 !== s && 58 !== s && !uf(s)) return !1;
          if (45 === a && uf(s)) return !1;
          for (; i < e.eMarks[o];) {
            const t = e.src.charCodeAt(i);
            if (124 !== t && 45 !== t && 58 !== t && !uf(t)) return !1;
            i++;
          }
          let l = Zf(e, t + 1),
            u = l.split("|");
          const c = [];
          for (let e = 0; e < u.length; e++) {
            const t = u[e].trim();
            if (!t) {
              if (0 === e || e === u.length - 1) continue;
              return !1;
            }
            if (!/^:?-+:?$/.test(t)) return !1;
            58 === t.charCodeAt(t.length - 1) ? c.push(58 === t.charCodeAt(0) ? "center" : "right") : 58 === t.charCodeAt(0) ? c.push("left") : c.push("");
          }
          if (l = Zf(e, t).trim(), -1 === l.indexOf("|")) return !1;
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          u = $f(l), u.length && "" === u[0] && u.shift(), u.length && "" === u[u.length - 1] && u.pop();
          const d = u.length;
          if (0 === d || d !== c.length) return !1;
          if (r) return !0;
          const p = e.parentType;
          e.parentType = "table";
          const h = e.md.block.ruler.getRules("blockquote"),
            f = [t, 0];
          e.push("table_open", "table", 1).map = f, e.push("thead_open", "thead", 1).map = [t, t + 1], e.push("tr_open", "tr", 1).map = [t, t + 1];
          for (let t = 0; t < u.length; t++) {
            const n = e.push("th_open", "th", 1);
            c[t] && (n.attrs = [["style", "text-align:" + c[t]]]);
            const r = e.push("inline", "", 0);
            r.content = u[t].trim(), r.children = [], e.push("th_close", "th", -1);
          }
          let m;
          e.push("tr_close", "tr", -1), e.push("thead_close", "thead", -1);
          let g = 0;
          for (o = t + 2; o < n && !(e.sCount[o] < e.blkIndent); o++) {
            let r = !1;
            for (let t = 0, i = h.length; t < i; t++) if (h[t](e, o, n, !0)) {
              r = !0;
              break;
            }
            if (r) break;
            if (l = Zf(e, o).trim(), !l) break;
            if (e.sCount[o] - e.blkIndent >= 4) break;
            if (u = $f(l), u.length && "" === u[0] && u.shift(), u.length && "" === u[u.length - 1] && u.pop(), g += d - u.length, g > 65536) break;
            if (o === t + 2) {
              e.push("tbody_open", "tbody", 1).map = m = [t + 2, 0];
            }
            e.push("tr_open", "tr", 1).map = [o, o + 1];
            for (let t = 0; t < d; t++) {
              const n = e.push("td_open", "td", 1);
              c[t] && (n.attrs = [["style", "text-align:" + c[t]]]);
              const r = e.push("inline", "", 0);
              r.content = u[t] ? u[t].trim() : "", r.children = [], e.push("td_close", "td", -1);
            }
            e.push("tr_close", "tr", -1);
          }
          return m && (e.push("tbody_close", "tbody", -1), m[1] = o), e.push("table_close", "table", -1), f[1] = o, e.parentType = p, e.line = o, !0;
        }, ["paragraph", "reference"]], ["code", function (e, t, n) {
          if (e.sCount[t] - e.blkIndent < 4) return !1;
          let r = t + 1,
            o = r;
          for (; r < n;) if (e.isEmpty(r)) r++;else {
            if (!(e.sCount[r] - e.blkIndent >= 4)) break;
            r++, o = r;
          }
          e.line = o;
          const i = e.push("code_block", "code", 0);
          return i.content = e.getLines(t, o, 4 + e.blkIndent, !1) + "\n", i.map = [t, e.line], !0;
        }], ["fence", function (e, t, n, r) {
          let o = e.bMarks[t] + e.tShift[t],
            i = e.eMarks[t];
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          if (o + 3 > i) return !1;
          const a = e.src.charCodeAt(o);
          if (126 !== a && 96 !== a) return !1;
          let s = o;
          o = e.skipChars(o, a);
          let l = o - s;
          if (l < 3) return !1;
          const u = e.src.slice(s, o),
            c = e.src.slice(o, i);
          if (96 === a && c.indexOf(String.fromCharCode(a)) >= 0) return !1;
          if (r) return !0;
          let d = t,
            p = !1;
          for (; (d++, !(d >= n)) && (o = s = e.bMarks[d] + e.tShift[d], i = e.eMarks[d], !(o < i && e.sCount[d] < e.blkIndent));) if (e.src.charCodeAt(o) === a && !(e.sCount[d] - e.blkIndent >= 4 || (o = e.skipChars(o, a), o - s < l || (o = e.skipSpaces(o), o < i)))) {
            p = !0;
            break;
          }
          l = e.sCount[t], e.line = d + (p ? 1 : 0);
          const h = e.push("fence", "code", 0);
          return h.info = c, h.content = e.getLines(t + 1, d, l, !0), h.markup = u, h.map = [t, e.line], !0;
        }, ["paragraph", "reference", "blockquote", "list"]], ["blockquote", function (e, t, n, r) {
          let o = e.bMarks[t] + e.tShift[t],
            i = e.eMarks[t];
          const a = e.lineMax;
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          if (62 !== e.src.charCodeAt(o)) return !1;
          if (r) return !0;
          const s = [],
            l = [],
            u = [],
            c = [],
            d = e.md.block.ruler.getRules("blockquote"),
            p = e.parentType;
          e.parentType = "blockquote";
          let h,
            f = !1;
          for (h = t; h < n; h++) {
            const t = e.sCount[h] < e.blkIndent;
            if (o = e.bMarks[h] + e.tShift[h], i = e.eMarks[h], o >= i) break;
            if (62 === e.src.charCodeAt(o++) && !t) {
              let t,
                n,
                r = e.sCount[h] + 1;
              32 === e.src.charCodeAt(o) ? (o++, r++, n = !1, t = !0) : 9 === e.src.charCodeAt(o) ? (t = !0, (e.bsCount[h] + r) % 4 == 3 ? (o++, r++, n = !1) : n = !0) : t = !1;
              let a = r;
              for (s.push(e.bMarks[h]), e.bMarks[h] = o; o < i;) {
                const t = e.src.charCodeAt(o);
                if (!uf(t)) break;
                9 === t ? a += 4 - (a + e.bsCount[h] + (n ? 1 : 0)) % 4 : a++, o++;
              }
              f = o >= i, l.push(e.bsCount[h]), e.bsCount[h] = e.sCount[h] + 1 + (t ? 1 : 0), u.push(e.sCount[h]), e.sCount[h] = a - r, c.push(e.tShift[h]), e.tShift[h] = o - e.bMarks[h];
              continue;
            }
            if (f) break;
            let r = !1;
            for (let t = 0, o = d.length; t < o; t++) if (d[t](e, h, n, !0)) {
              r = !0;
              break;
            }
            if (r) {
              e.lineMax = h, 0 !== e.blkIndent && (s.push(e.bMarks[h]), l.push(e.bsCount[h]), c.push(e.tShift[h]), u.push(e.sCount[h]), e.sCount[h] -= e.blkIndent);
              break;
            }
            s.push(e.bMarks[h]), l.push(e.bsCount[h]), c.push(e.tShift[h]), u.push(e.sCount[h]), e.sCount[h] = -1;
          }
          const m = e.blkIndent;
          e.blkIndent = 0;
          const g = e.push("blockquote_open", "blockquote", 1);
          g.markup = ">";
          const v = [t, 0];
          g.map = v, e.md.block.tokenize(e, t, h), e.push("blockquote_close", "blockquote", -1).markup = ">", e.lineMax = a, e.parentType = p, v[1] = e.line;
          for (let n = 0; n < c.length; n++) e.bMarks[n + t] = s[n], e.tShift[n + t] = c[n], e.sCount[n + t] = u[n], e.bsCount[n + t] = l[n];
          return e.blkIndent = m, !0;
        }, ["paragraph", "reference", "blockquote", "list"]], ["hr", function (e, t, n, r) {
          const o = e.eMarks[t];
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          let i = e.bMarks[t] + e.tShift[t];
          const a = e.src.charCodeAt(i++);
          if (42 !== a && 45 !== a && 95 !== a) return !1;
          let s = 1;
          for (; i < o;) {
            const t = e.src.charCodeAt(i++);
            if (t !== a && !uf(t)) return !1;
            t === a && s++;
          }
          if (s < 3) return !1;
          if (r) return !0;
          e.line = t + 1;
          const l = e.push("hr", "hr", 0);
          return l.map = [t, e.line], l.markup = Array(s + 1).join(String.fromCharCode(a)), !0;
        }, ["paragraph", "reference", "blockquote", "list"]], ["list", function (e, t, n, r) {
          let o,
            i,
            a,
            s,
            l = t,
            u = !0;
          if (e.sCount[l] - e.blkIndent >= 4) return !1;
          if (e.listIndent >= 0 && e.sCount[l] - e.listIndent >= 4 && e.sCount[l] < e.blkIndent) return !1;
          let c,
            d,
            p,
            h = !1;
          if (r && "paragraph" === e.parentType && e.sCount[l] >= e.blkIndent && (h = !0), (p = Wf(e, l)) >= 0) {
            if (c = !0, a = e.bMarks[l] + e.tShift[l], d = Number(e.src.slice(a, p - 1)), h && 1 !== d) return !1;
          } else {
            if (!((p = Gf(e, l)) >= 0)) return !1;
            c = !1;
          }
          if (h && e.skipSpaces(p) >= e.eMarks[l]) return !1;
          if (r) return !0;
          const f = e.src.charCodeAt(p - 1),
            m = e.tokens.length;
          c ? (s = e.push("ordered_list_open", "ol", 1), 1 !== d && (s.attrs = [["start", d]])) : s = e.push("bullet_list_open", "ul", 1);
          const g = [l, 0];
          s.map = g, s.markup = String.fromCharCode(f);
          let v = !1;
          const y = e.md.block.ruler.getRules("list"),
            b = e.parentType;
          for (e.parentType = "list"; l < n;) {
            i = p, o = e.eMarks[l];
            const t = e.sCount[l] + p - (e.bMarks[l] + e.tShift[l]);
            let r = t;
            for (; i < o;) {
              const t = e.src.charCodeAt(i);
              if (9 === t) r += 4 - (r + e.bsCount[l]) % 4;else {
                if (32 !== t) break;
                r++;
              }
              i++;
            }
            const d = i;
            let h;
            h = d >= o ? 1 : r - t, h > 4 && (h = 1);
            const m = t + h;
            s = e.push("list_item_open", "li", 1), s.markup = String.fromCharCode(f);
            const g = [l, 0];
            s.map = g, c && (s.info = e.src.slice(a, p - 1));
            const b = e.tight,
              w = e.tShift[l],
              x = e.sCount[l],
              D = e.listIndent;
            if (e.listIndent = e.blkIndent, e.blkIndent = m, e.tight = !0, e.tShift[l] = d - e.bMarks[l], e.sCount[l] = r, d >= o && e.isEmpty(l + 1) ? e.line = Math.min(e.line + 2, n) : e.md.block.tokenize(e, l, n, !0), e.tight && !v || (u = !1), v = e.line - l > 1 && e.isEmpty(e.line - 1), e.blkIndent = e.listIndent, e.listIndent = D, e.tShift[l] = w, e.sCount[l] = x, e.tight = b, s = e.push("list_item_close", "li", -1), s.markup = String.fromCharCode(f), l = e.line, g[1] = l, l >= n) break;
            if (e.sCount[l] < e.blkIndent) break;
            if (e.sCount[l] - e.blkIndent >= 4) break;
            let C = !1;
            for (let t = 0, r = y.length; t < r; t++) if (y[t](e, l, n, !0)) {
              C = !0;
              break;
            }
            if (C) break;
            if (c) {
              if (p = Wf(e, l), p < 0) break;
              a = e.bMarks[l] + e.tShift[l];
            } else if (p = Gf(e, l), p < 0) break;
            if (f !== e.src.charCodeAt(p - 1)) break;
          }
          return s = c ? e.push("ordered_list_close", "ol", -1) : e.push("bullet_list_close", "ul", -1), s.markup = String.fromCharCode(f), g[1] = l, e.line = l, e.parentType = b, u && function (e, t) {
            const n = e.level + 2;
            for (let r = t + 2, o = e.tokens.length - 2; r < o; r++) e.tokens[r].level === n && "paragraph_open" === e.tokens[r].type && (e.tokens[r + 2].hidden = !0, e.tokens[r].hidden = !0, r += 2);
          }(e, m), !0;
        }, ["paragraph", "reference", "blockquote"]], ["reference", function (e, t, n, r) {
          let o = e.bMarks[t] + e.tShift[t],
            i = e.eMarks[t],
            a = t + 1;
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          if (91 !== e.src.charCodeAt(o)) return !1;
          function s(t) {
            const n = e.lineMax;
            if (t >= n || e.isEmpty(t)) return null;
            let r = !1;
            if (e.sCount[t] - e.blkIndent > 3 && (r = !0), e.sCount[t] < 0 && (r = !0), !r) {
              const r = e.md.block.ruler.getRules("reference"),
                o = e.parentType;
              e.parentType = "reference";
              let i = !1;
              for (let o = 0, a = r.length; o < a; o++) if (r[o](e, t, n, !0)) {
                i = !0;
                break;
              }
              if (e.parentType = o, i) return null;
            }
            const o = e.bMarks[t] + e.tShift[t],
              i = e.eMarks[t];
            return e.src.slice(o, i + 1);
          }
          let l = e.src.slice(o, i + 1);
          i = l.length;
          let u = -1;
          for (o = 1; o < i; o++) {
            const e = l.charCodeAt(o);
            if (91 === e) return !1;
            if (93 === e) {
              u = o;
              break;
            }
            if (10 === e) {
              const e = s(a);
              null !== e && (l += e, i = l.length, a++);
            } else if (92 === e && (o++, o < i && 10 === l.charCodeAt(o))) {
              const e = s(a);
              null !== e && (l += e, i = l.length, a++);
            }
          }
          if (u < 0 || 58 !== l.charCodeAt(u + 1)) return !1;
          for (o = u + 2; o < i; o++) {
            const e = l.charCodeAt(o);
            if (10 === e) {
              const e = s(a);
              null !== e && (l += e, i = l.length, a++);
            } else if (!uf(e)) break;
          }
          const c = e.md.helpers.parseLinkDestination(l, o, i);
          if (!c.ok) return !1;
          const d = e.md.normalizeLink(c.str);
          if (!e.md.validateLink(d)) return !1;
          o = c.pos;
          const p = o,
            h = a,
            f = o;
          for (; o < i; o++) {
            const e = l.charCodeAt(o);
            if (10 === e) {
              const e = s(a);
              null !== e && (l += e, i = l.length, a++);
            } else if (!uf(e)) break;
          }
          let m,
            g = e.md.helpers.parseLinkTitle(l, o, i);
          for (; g.can_continue;) {
            const t = s(a);
            if (null === t) break;
            l += t, o = i, i = l.length, a++, g = e.md.helpers.parseLinkTitle(l, o, i, g);
          }
          for (o < i && f !== o && g.ok ? (m = g.str, o = g.pos) : (m = "", o = p, a = h); o < i;) {
            if (!uf(l.charCodeAt(o))) break;
            o++;
          }
          if (o < i && 10 !== l.charCodeAt(o) && m) for (m = "", o = p, a = h; o < i;) {
            if (!uf(l.charCodeAt(o))) break;
            o++;
          }
          if (o < i && 10 !== l.charCodeAt(o)) return !1;
          const v = hf(l.slice(1, u));
          return !!v && (r || (void 0 === e.env.references && (e.env.references = {}), void 0 === e.env.references[v] && (e.env.references[v] = {
            title: m,
            href: d
          }), e.line = a), !0);
        }], ["html_block", function (e, t, n, r) {
          let o = e.bMarks[t] + e.tShift[t],
            i = e.eMarks[t];
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          if (!e.md.options.html) return !1;
          if (60 !== e.src.charCodeAt(o)) return !1;
          let a = e.src.slice(o, i),
            s = 0;
          for (; s < em.length && !em[s][0].test(a); s++);
          if (s === em.length) return !1;
          if (r) return em[s][2];
          let l = t + 1;
          if (!em[s][1].test(a)) for (; l < n && !(e.sCount[l] < e.blkIndent); l++) if (o = e.bMarks[l] + e.tShift[l], i = e.eMarks[l], a = e.src.slice(o, i), em[s][1].test(a)) {
            0 !== a.length && l++;
            break;
          }
          e.line = l;
          const u = e.push("html_block", "", 0);
          return u.map = [t, l], u.content = e.getLines(t, l, e.blkIndent, !0), !0;
        }, ["paragraph", "reference", "blockquote"]], ["heading", function (e, t, n, r) {
          let o = e.bMarks[t] + e.tShift[t],
            i = e.eMarks[t];
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          let a = e.src.charCodeAt(o);
          if (35 !== a || o >= i) return !1;
          let s = 1;
          for (a = e.src.charCodeAt(++o); 35 === a && o < i && s <= 6;) s++, a = e.src.charCodeAt(++o);
          if (s > 6 || o < i && !uf(a)) return !1;
          if (r) return !0;
          i = e.skipSpacesBack(i, o);
          const l = e.skipCharsBack(i, 35, o);
          l > o && uf(e.src.charCodeAt(l - 1)) && (i = l), e.line = t + 1;
          const u = e.push("heading_open", "h" + String(s), 1);
          u.markup = "########".slice(0, s), u.map = [t, e.line];
          const c = e.push("inline", "", 0);
          return c.content = e.src.slice(o, i).trim(), c.map = [t, e.line], c.children = [], e.push("heading_close", "h" + String(s), -1).markup = "########".slice(0, s), !0;
        }, ["paragraph", "reference", "blockquote"]], ["lheading", function (e, t, n) {
          const r = e.md.block.ruler.getRules("paragraph");
          if (e.sCount[t] - e.blkIndent >= 4) return !1;
          const o = e.parentType;
          e.parentType = "paragraph";
          let i,
            a = 0,
            s = t + 1;
          for (; s < n && !e.isEmpty(s); s++) {
            if (e.sCount[s] - e.blkIndent > 3) continue;
            if (e.sCount[s] >= e.blkIndent) {
              let t = e.bMarks[s] + e.tShift[s];
              const n = e.eMarks[s];
              if (t < n && (i = e.src.charCodeAt(t), (45 === i || 61 === i) && (t = e.skipChars(t, i), t = e.skipSpaces(t), t >= n))) {
                a = 61 === i ? 1 : 2;
                break;
              }
            }
            if (e.sCount[s] < 0) continue;
            let t = !1;
            for (let o = 0, i = r.length; o < i; o++) if (r[o](e, s, n, !0)) {
              t = !0;
              break;
            }
            if (t) break;
          }
          if (!a) return !1;
          const l = e.getLines(t, s, e.blkIndent, !1).trim();
          e.line = s + 1;
          const u = e.push("heading_open", "h" + String(a), 1);
          u.markup = String.fromCharCode(i), u.map = [t, e.line];
          const c = e.push("inline", "", 0);
          return c.content = l, c.map = [t, e.line - 1], c.children = [], e.push("heading_close", "h" + String(a), -1).markup = String.fromCharCode(i), e.parentType = o, !0;
        }], ["paragraph", function (e, t, n) {
          const r = e.md.block.ruler.getRules("paragraph"),
            o = e.parentType;
          let i = t + 1;
          for (e.parentType = "paragraph"; i < n && !e.isEmpty(i); i++) {
            if (e.sCount[i] - e.blkIndent > 3) continue;
            if (e.sCount[i] < 0) continue;
            let t = !1;
            for (let o = 0, a = r.length; o < a; o++) if (r[o](e, i, n, !0)) {
              t = !0;
              break;
            }
            if (t) break;
          }
          const a = e.getLines(t, i, e.blkIndent, !1).trim();
          e.line = i, e.push("paragraph_open", "p", 1).map = [t, e.line];
          const s = e.push("inline", "", 0);
          return s.content = a, s.map = [t, e.line], s.children = [], e.push("paragraph_close", "p", -1), e.parentType = o, !0;
        }]];
        function nm() {
          this.ruler = new Df();
          for (let e = 0; e < tm.length; e++) this.ruler.push(tm[e][0], tm[e][1], {
            alt: (tm[e][2] || []).slice()
          });
        }
        nm.prototype.tokenize = function (e, t, n) {
          const r = this.ruler.getRules(""),
            o = r.length,
            i = e.md.options.maxNesting;
          let a = t,
            s = !1;
          for (; a < n && (e.line = a = e.skipEmptyLines(a), !(a >= n)) && !(e.sCount[a] < e.blkIndent);) {
            if (e.level >= i) {
              e.line = n;
              break;
            }
            const t = e.line;
            let l = !1;
            for (let i = 0; i < o; i++) if (l = r[i](e, a, n, !1), l) {
              if (t >= e.line) throw new Error("block rule didn't increment state.line");
              break;
            }
            if (!l) throw new Error("none of the block rules matched");
            e.tight = !s, e.isEmpty(e.line - 1) && (s = !0), a = e.line, a < n && e.isEmpty(a) && (s = !0, a++, e.line = a);
          }
        }, nm.prototype.parse = function (e, t, n, r) {
          if (!e) return;
          const o = new this.State(e, t, n, r);
          this.tokenize(o, o.line, o.lineMax);
        }, nm.prototype.State = Uf;
        const rm = nm;
        function om(e, t, n, r) {
          this.src = e, this.env = n, this.md = t, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
        }
        om.prototype.pushPending = function () {
          const e = new Sf("text", "", 0);
          return e.content = this.pending, e.level = this.pendingLevel, this.tokens.push(e), this.pending = "", e;
        }, om.prototype.push = function (e, t, n) {
          this.pending && this.pushPending();
          const r = new Sf(e, t, n);
          let o = null;
          return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], o = {
            delimiters: this.delimiters
          }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(o), r;
        }, om.prototype.scanDelims = function (e, t) {
          const n = this.posMax,
            r = this.src.charCodeAt(e),
            o = e > 0 ? this.src.charCodeAt(e - 1) : 32;
          let i = e;
          for (; i < n && this.src.charCodeAt(i) === r;) i++;
          const a = i - e,
            s = i < n ? this.src.charCodeAt(i) : 32,
            l = pf(o) || df(String.fromCharCode(o)),
            u = pf(s) || df(String.fromCharCode(s)),
            c = cf(o),
            d = cf(s),
            p = !d && (!u || c || l),
            h = !c && (!l || d || u);
          return {
            can_open: p && (t || !h || l),
            can_close: h && (t || !p || u),
            length: a
          };
        }, om.prototype.Token = Sf;
        const im = om;
        function am(e) {
          switch (e) {
            case 10:
            case 33:
            case 35:
            case 36:
            case 37:
            case 38:
            case 42:
            case 43:
            case 45:
            case 58:
            case 60:
            case 61:
            case 62:
            case 64:
            case 91:
            case 92:
            case 93:
            case 94:
            case 95:
            case 96:
            case 123:
            case 125:
            case 126:
              return !0;
            default:
              return !1;
          }
        }
        const sm = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
        const lm = [];
        for (let e = 0; e < 256; e++) lm.push(0);
        function um(e, t) {
          let n;
          const r = [],
            o = t.length;
          for (let i = 0; i < o; i++) {
            const o = t[i];
            if (126 !== o.marker) continue;
            if (-1 === o.end) continue;
            const a = t[o.end];
            n = e.tokens[o.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = e.tokens[a.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", "text" === e.tokens[a.token - 1].type && "~" === e.tokens[a.token - 1].content && r.push(a.token - 1);
          }
          for (; r.length;) {
            const t = r.pop();
            let o = t + 1;
            for (; o < e.tokens.length && "s_close" === e.tokens[o].type;) o++;
            o--, t !== o && (n = e.tokens[o], e.tokens[o] = e.tokens[t], e.tokens[t] = n);
          }
        }
        "\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function (e) {
          lm[e.charCodeAt(0)] = 1;
        });
        const cm = {
          tokenize: function (e, t) {
            const n = e.pos,
              r = e.src.charCodeAt(n);
            if (t) return !1;
            if (126 !== r) return !1;
            const o = e.scanDelims(e.pos, !0);
            let i = o.length;
            const a = String.fromCharCode(r);
            if (i < 2) return !1;
            let s;
            i % 2 && (s = e.push("text", "", 0), s.content = a, i--);
            for (let t = 0; t < i; t += 2) s = e.push("text", "", 0), s.content = a + a, e.delimiters.push({
              marker: r,
              length: 0,
              token: e.tokens.length - 1,
              end: -1,
              open: o.can_open,
              close: o.can_close
            });
            return e.pos += o.length, !0;
          },
          postProcess: function (e) {
            const t = e.tokens_meta,
              n = e.tokens_meta.length;
            um(e, e.delimiters);
            for (let r = 0; r < n; r++) t[r] && t[r].delimiters && um(e, t[r].delimiters);
          }
        };
        function dm(e, t) {
          for (let n = t.length - 1; n >= 0; n--) {
            const r = t[n];
            if (95 !== r.marker && 42 !== r.marker) continue;
            if (-1 === r.end) continue;
            const o = t[r.end],
              i = n > 0 && t[n - 1].end === r.end + 1 && t[n - 1].marker === r.marker && t[n - 1].token === r.token - 1 && t[r.end + 1].token === o.token + 1,
              a = String.fromCharCode(r.marker),
              s = e.tokens[r.token];
            s.type = i ? "strong_open" : "em_open", s.tag = i ? "strong" : "em", s.nesting = 1, s.markup = i ? a + a : a, s.content = "";
            const l = e.tokens[o.token];
            l.type = i ? "strong_close" : "em_close", l.tag = i ? "strong" : "em", l.nesting = -1, l.markup = i ? a + a : a, l.content = "", i && (e.tokens[t[n - 1].token].content = "", e.tokens[t[r.end + 1].token].content = "", n--);
          }
        }
        const pm = {
          tokenize: function (e, t) {
            const n = e.pos,
              r = e.src.charCodeAt(n);
            if (t) return !1;
            if (95 !== r && 42 !== r) return !1;
            const o = e.scanDelims(e.pos, 42 === r);
            for (let t = 0; t < o.length; t++) {
              e.push("text", "", 0).content = String.fromCharCode(r), e.delimiters.push({
                marker: r,
                length: o.length,
                token: e.tokens.length - 1,
                end: -1,
                open: o.can_open,
                close: o.can_close
              });
            }
            return e.pos += o.length, !0;
          },
          postProcess: function (e) {
            const t = e.tokens_meta,
              n = e.tokens_meta.length;
            dm(e, e.delimiters);
            for (let r = 0; r < n; r++) t[r] && t[r].delimiters && dm(e, t[r].delimiters);
          }
        };
        const hm = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/,
          fm = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
        const mm = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i,
          gm = /^&([a-z][a-z0-9]{1,31});/i;
        function vm(e) {
          const t = {},
            n = e.length;
          if (!n) return;
          let r = 0,
            o = -2;
          const i = [];
          for (let a = 0; a < n; a++) {
            const n = e[a];
            if (i.push(0), e[r].marker === n.marker && o === n.token - 1 || (r = a), o = n.token, n.length = n.length || 0, !n.close) continue;
            t.hasOwnProperty(n.marker) || (t[n.marker] = [-1, -1, -1, -1, -1, -1]);
            const s = t[n.marker][(n.open ? 3 : 0) + n.length % 3];
            let l = r - i[r] - 1,
              u = l;
            for (; l > s; l -= i[l] + 1) {
              const t = e[l];
              if (t.marker === n.marker && t.open && t.end < 0) {
                let r = !1;
                if ((t.close || n.open) && (t.length + n.length) % 3 == 0 && (t.length % 3 == 0 && n.length % 3 == 0 || (r = !0)), !r) {
                  const r = l > 0 && !e[l - 1].open ? i[l - 1] + 1 : 0;
                  i[a] = a - l + r, i[l] = r, n.open = !1, t.end = a, t.close = !1, u = -1, o = -2;
                  break;
                }
              }
            }
            -1 !== u && (t[n.marker][(n.open ? 3 : 0) + (n.length || 0) % 3] = u);
          }
        }
        const ym = [["text", function (e, t) {
            let n = e.pos;
            for (; n < e.posMax && !am(e.src.charCodeAt(n));) n++;
            return n !== e.pos && (t || (e.pending += e.src.slice(e.pos, n)), e.pos = n, !0);
          }], ["linkify", function (e, t) {
            if (!e.md.options.linkify) return !1;
            if (e.linkLevel > 0) return !1;
            const n = e.pos;
            if (n + 3 > e.posMax) return !1;
            if (58 !== e.src.charCodeAt(n)) return !1;
            if (47 !== e.src.charCodeAt(n + 1)) return !1;
            if (47 !== e.src.charCodeAt(n + 2)) return !1;
            const r = e.pending.match(sm);
            if (!r) return !1;
            const o = r[1],
              i = e.md.linkify.matchAtStart(e.src.slice(n - o.length));
            if (!i) return !1;
            let a = i.url;
            if (a.length <= o.length) return !1;
            a = a.replace(/\*+$/, "");
            const s = e.md.normalizeLink(a);
            if (!e.md.validateLink(s)) return !1;
            if (!t) {
              e.pending = e.pending.slice(0, -o.length);
              const t = e.push("link_open", "a", 1);
              t.attrs = [["href", s]], t.markup = "linkify", t.info = "auto";
              e.push("text", "", 0).content = e.md.normalizeLinkText(a);
              const n = e.push("link_close", "a", -1);
              n.markup = "linkify", n.info = "auto";
            }
            return e.pos += a.length - o.length, !0;
          }], ["newline", function (e, t) {
            let n = e.pos;
            if (10 !== e.src.charCodeAt(n)) return !1;
            const r = e.pending.length - 1,
              o = e.posMax;
            if (!t) if (r >= 0 && 32 === e.pending.charCodeAt(r)) {
              if (r >= 1 && 32 === e.pending.charCodeAt(r - 1)) {
                let t = r - 1;
                for (; t >= 1 && 32 === e.pending.charCodeAt(t - 1);) t--;
                e.pending = e.pending.slice(0, t), e.push("hardbreak", "br", 0);
              } else e.pending = e.pending.slice(0, -1), e.push("softbreak", "br", 0);
            } else e.push("softbreak", "br", 0);
            for (n++; n < o && uf(e.src.charCodeAt(n));) n++;
            return e.pos = n, !0;
          }], ["escape", function (e, t) {
            let n = e.pos;
            const r = e.posMax;
            if (92 !== e.src.charCodeAt(n)) return !1;
            if (n++, n >= r) return !1;
            let o = e.src.charCodeAt(n);
            if (10 === o) {
              for (t || e.push("hardbreak", "br", 0), n++; n < r && (o = e.src.charCodeAt(n), uf(o));) n++;
              return e.pos = n, !0;
            }
            let i = e.src[n];
            if (o >= 55296 && o <= 56319 && n + 1 < r) {
              const t = e.src.charCodeAt(n + 1);
              t >= 56320 && t <= 57343 && (i += e.src[n + 1], n++);
            }
            const a = "\\" + i;
            if (!t) {
              const t = e.push("text_special", "", 0);
              o < 256 && 0 !== lm[o] ? t.content = i : t.content = a, t.markup = a, t.info = "escape";
            }
            return e.pos = n + 1, !0;
          }], ["backticks", function (e, t) {
            let n = e.pos;
            if (96 !== e.src.charCodeAt(n)) return !1;
            const r = n;
            n++;
            const o = e.posMax;
            for (; n < o && 96 === e.src.charCodeAt(n);) n++;
            const i = e.src.slice(r, n),
              a = i.length;
            if (e.backticksScanned && (e.backticks[a] || 0) <= r) return t || (e.pending += i), e.pos += a, !0;
            let s,
              l = n;
            for (; -1 !== (s = e.src.indexOf("`", l));) {
              for (l = s + 1; l < o && 96 === e.src.charCodeAt(l);) l++;
              const r = l - s;
              if (r === a) {
                if (!t) {
                  const t = e.push("code_inline", "code", 0);
                  t.markup = i, t.content = e.src.slice(n, s).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
                }
                return e.pos = l, !0;
              }
              e.backticks[r] = s;
            }
            return e.backticksScanned = !0, t || (e.pending += i), e.pos += a, !0;
          }], ["strikethrough", cm.tokenize], ["emphasis", pm.tokenize], ["link", function (e, t) {
            let n,
              r,
              o,
              i,
              a = "",
              s = "",
              l = e.pos,
              u = !0;
            if (91 !== e.src.charCodeAt(e.pos)) return !1;
            const c = e.pos,
              d = e.posMax,
              p = e.pos + 1,
              h = e.md.helpers.parseLinkLabel(e, e.pos, !0);
            if (h < 0) return !1;
            let f = h + 1;
            if (f < d && 40 === e.src.charCodeAt(f)) {
              for (u = !1, f++; f < d && (n = e.src.charCodeAt(f), uf(n) || 10 === n); f++);
              if (f >= d) return !1;
              if (l = f, o = e.md.helpers.parseLinkDestination(e.src, f, e.posMax), o.ok) {
                for (a = e.md.normalizeLink(o.str), e.md.validateLink(a) ? f = o.pos : a = "", l = f; f < d && (n = e.src.charCodeAt(f), uf(n) || 10 === n); f++);
                if (o = e.md.helpers.parseLinkTitle(e.src, f, e.posMax), f < d && l !== f && o.ok) for (s = o.str, f = o.pos; f < d && (n = e.src.charCodeAt(f), uf(n) || 10 === n); f++);
              }
              (f >= d || 41 !== e.src.charCodeAt(f)) && (u = !0), f++;
            }
            if (u) {
              if (void 0 === e.env.references) return !1;
              if (f < d && 91 === e.src.charCodeAt(f) ? (l = f + 1, f = e.md.helpers.parseLinkLabel(e, f), f >= 0 ? r = e.src.slice(l, f++) : f = h + 1) : f = h + 1, r || (r = e.src.slice(p, h)), i = e.env.references[hf(r)], !i) return e.pos = c, !1;
              a = i.href, s = i.title;
            }
            if (!t) {
              e.pos = p, e.posMax = h;
              const t = [["href", a]];
              e.push("link_open", "a", 1).attrs = t, s && t.push(["title", s]), e.linkLevel++, e.md.inline.tokenize(e), e.linkLevel--, e.push("link_close", "a", -1);
            }
            return e.pos = f, e.posMax = d, !0;
          }], ["image", function (e, t) {
            let n,
              r,
              o,
              i,
              a,
              s,
              l,
              u,
              c = "";
            const d = e.pos,
              p = e.posMax;
            if (33 !== e.src.charCodeAt(e.pos)) return !1;
            if (91 !== e.src.charCodeAt(e.pos + 1)) return !1;
            const h = e.pos + 2,
              f = e.md.helpers.parseLinkLabel(e, e.pos + 1, !1);
            if (f < 0) return !1;
            if (i = f + 1, i < p && 40 === e.src.charCodeAt(i)) {
              for (i++; i < p && (n = e.src.charCodeAt(i), uf(n) || 10 === n); i++);
              if (i >= p) return !1;
              for (u = i, s = e.md.helpers.parseLinkDestination(e.src, i, e.posMax), s.ok && (c = e.md.normalizeLink(s.str), e.md.validateLink(c) ? i = s.pos : c = ""), u = i; i < p && (n = e.src.charCodeAt(i), uf(n) || 10 === n); i++);
              if (s = e.md.helpers.parseLinkTitle(e.src, i, e.posMax), i < p && u !== i && s.ok) for (l = s.str, i = s.pos; i < p && (n = e.src.charCodeAt(i), uf(n) || 10 === n); i++);else l = "";
              if (i >= p || 41 !== e.src.charCodeAt(i)) return e.pos = d, !1;
              i++;
            } else {
              if (void 0 === e.env.references) return !1;
              if (i < p && 91 === e.src.charCodeAt(i) ? (u = i + 1, i = e.md.helpers.parseLinkLabel(e, i), i >= 0 ? o = e.src.slice(u, i++) : i = f + 1) : i = f + 1, o || (o = e.src.slice(h, f)), a = e.env.references[hf(o)], !a) return e.pos = d, !1;
              c = a.href, l = a.title;
            }
            if (!t) {
              r = e.src.slice(h, f);
              const t = [];
              e.md.inline.parse(r, e.md, e.env, t);
              const n = e.push("image", "img", 0),
                o = [["src", c], ["alt", ""]];
              n.attrs = o, n.children = t, n.content = r, l && o.push(["title", l]);
            }
            return e.pos = i, e.posMax = p, !0;
          }], ["autolink", function (e, t) {
            let n = e.pos;
            if (60 !== e.src.charCodeAt(n)) return !1;
            const r = e.pos,
              o = e.posMax;
            for (;;) {
              if (++n >= o) return !1;
              const t = e.src.charCodeAt(n);
              if (60 === t) return !1;
              if (62 === t) break;
            }
            const i = e.src.slice(r + 1, n);
            if (fm.test(i)) {
              const n = e.md.normalizeLink(i);
              if (!e.md.validateLink(n)) return !1;
              if (!t) {
                const t = e.push("link_open", "a", 1);
                t.attrs = [["href", n]], t.markup = "autolink", t.info = "auto";
                e.push("text", "", 0).content = e.md.normalizeLinkText(i);
                const r = e.push("link_close", "a", -1);
                r.markup = "autolink", r.info = "auto";
              }
              return e.pos += i.length + 2, !0;
            }
            if (hm.test(i)) {
              const n = e.md.normalizeLink("mailto:" + i);
              if (!e.md.validateLink(n)) return !1;
              if (!t) {
                const t = e.push("link_open", "a", 1);
                t.attrs = [["href", n]], t.markup = "autolink", t.info = "auto";
                e.push("text", "", 0).content = e.md.normalizeLinkText(i);
                const r = e.push("link_close", "a", -1);
                r.markup = "autolink", r.info = "auto";
              }
              return e.pos += i.length + 2, !0;
            }
            return !1;
          }], ["html_inline", function (e, t) {
            if (!e.md.options.html) return !1;
            const n = e.posMax,
              r = e.pos;
            if (60 !== e.src.charCodeAt(r) || r + 2 >= n) return !1;
            const o = e.src.charCodeAt(r + 1);
            if (33 !== o && 63 !== o && 47 !== o && !function (e) {
              const t = 32 | e;
              return t >= 97 && t <= 122;
            }(o)) return !1;
            const i = e.src.slice(r).match(Qf);
            if (!i) return !1;
            if (!t) {
              const t = e.push("html_inline", "", 0);
              t.content = i[0], a = t.content, /^<a[>\s]/i.test(a) && e.linkLevel++, function (e) {
                return /^<\/a\s*>/i.test(e);
              }(t.content) && e.linkLevel--;
            }
            var a;
            return e.pos += i[0].length, !0;
          }], ["entity", function (e, t) {
            const n = e.pos,
              r = e.posMax;
            if (38 !== e.src.charCodeAt(n)) return !1;
            if (n + 1 >= r) return !1;
            if (35 === e.src.charCodeAt(n + 1)) {
              const r = e.src.slice(n).match(mm);
              if (r) {
                if (!t) {
                  const t = "x" === r[1][0].toLowerCase() ? parseInt(r[1].slice(1), 16) : parseInt(r[1], 10),
                    n = e.push("text_special", "", 0);
                  n.content = Gh(t) ? Wh(t) : Wh(65533), n.markup = r[0], n.info = "entity";
                }
                return e.pos += r[0].length, !0;
              }
            } else {
              const r = e.src.slice(n).match(gm);
              if (r) {
                const n = Rh(r[0]);
                if (n !== r[0]) {
                  if (!t) {
                    const t = e.push("text_special", "", 0);
                    t.content = n, t.markup = r[0], t.info = "entity";
                  }
                  return e.pos += r[0].length, !0;
                }
              }
            }
            return !1;
          }]],
          bm = [["balance_pairs", function (e) {
            const t = e.tokens_meta,
              n = e.tokens_meta.length;
            vm(e.delimiters);
            for (let e = 0; e < n; e++) t[e] && t[e].delimiters && vm(t[e].delimiters);
          }], ["strikethrough", cm.postProcess], ["emphasis", pm.postProcess], ["fragments_join", function (e) {
            let t,
              n,
              r = 0;
            const o = e.tokens,
              i = e.tokens.length;
            for (t = n = 0; t < i; t++) o[t].nesting < 0 && r--, o[t].level = r, o[t].nesting > 0 && r++, "text" === o[t].type && t + 1 < i && "text" === o[t + 1].type ? o[t + 1].content = o[t].content + o[t + 1].content : (t !== n && (o[n] = o[t]), n++);
            t !== n && (o.length = n);
          }]];
        function wm() {
          this.ruler = new Df();
          for (let e = 0; e < ym.length; e++) this.ruler.push(ym[e][0], ym[e][1]);
          this.ruler2 = new Df();
          for (let e = 0; e < bm.length; e++) this.ruler2.push(bm[e][0], bm[e][1]);
        }
        wm.prototype.skipToken = function (e) {
          const t = e.pos,
            n = this.ruler.getRules(""),
            r = n.length,
            o = e.md.options.maxNesting,
            i = e.cache;
          if (void 0 !== i[t]) return void (e.pos = i[t]);
          let a = !1;
          if (e.level < o) {
            for (let o = 0; o < r; o++) if (e.level++, a = n[o](e, !0), e.level--, a) {
              if (t >= e.pos) throw new Error("inline rule didn't increment state.pos");
              break;
            }
          } else e.pos = e.posMax;
          a || e.pos++, i[t] = e.pos;
        }, wm.prototype.tokenize = function (e) {
          const t = this.ruler.getRules(""),
            n = t.length,
            r = e.posMax,
            o = e.md.options.maxNesting;
          for (; e.pos < r;) {
            const i = e.pos;
            let a = !1;
            if (e.level < o) for (let r = 0; r < n; r++) if (a = t[r](e, !1), a) {
              if (i >= e.pos) throw new Error("inline rule didn't increment state.pos");
              break;
            }
            if (a) {
              if (e.pos >= r) break;
            } else e.pending += e.src[e.pos++];
          }
          e.pending && e.pushPending();
        }, wm.prototype.parse = function (e, t, n, r) {
          const o = new this.State(e, t, n, r);
          this.tokenize(o);
          const i = this.ruler2.getRules(""),
            a = i.length;
          for (let e = 0; e < a; e++) i[e](o);
        }, wm.prototype.State = im;
        const xm = wm;
        function Dm(e) {
          const t = Array.prototype.slice.call(arguments, 1);
          return t.forEach(function (t) {
            t && Object.keys(t).forEach(function (n) {
              e[n] = t[n];
            });
          }), e;
        }
        function Cm(e) {
          return Object.prototype.toString.call(e);
        }
        function Sm(e) {
          return "[object Function]" === Cm(e);
        }
        function Em(e) {
          return e.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
        }
        const _m = {
          fuzzyLink: !0,
          fuzzyEmail: !0,
          fuzzyIP: !1
        };
        const Pm = {
            "http:": {
              validate: function (e, t, n) {
                const r = e.slice(t);
                return n.re.http || (n.re.http = new RegExp("^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path, "i")), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
              }
            },
            "https:": "http:",
            "ftp:": "http:",
            "//": {
              validate: function (e, t, n) {
                const r = e.slice(t);
                return n.re.no_http || (n.re.no_http = new RegExp("^" + n.re.src_auth + "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path, "i")), n.re.no_http.test(r) ? t >= 3 && ":" === e[t - 3] || t >= 3 && "/" === e[t - 3] ? 0 : r.match(n.re.no_http)[0].length : 0;
              }
            },
            "mailto:": {
              validate: function (e, t, n) {
                const r = e.slice(t);
                return n.re.mailto || (n.re.mailto = new RegExp("^" + n.re.src_email_name + "@" + n.re.src_host_strict, "i")), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
              }
            }
          },
          km = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
        function Am(e) {
          const t = e.re = function (e) {
              const t = {};
              return e = e || {}, t.src_Any = bh.source, t.src_Cc = wh.source, t.src_Z = Sh.source, t.src_P = Dh.source, t.src_ZPCc = [t.src_Z, t.src_P, t.src_Cc].join("|"), t.src_ZCc = [t.src_Z, t.src_Cc].join("|"), t.src_pseudo_letter = "(?:(?![><｜]|" + t.src_ZPCc + ")" + t.src_Any + ")", t.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", t.src_auth = "(?:(?:(?!" + t.src_ZCc + "|[@/\\[\\]()]).)+@)?", t.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", t.src_host_terminator = "(?=$|[><｜]|" + t.src_ZPCc + ")(?!" + (e["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + t.src_ZPCc + "))", t.src_path = "(?:[/?#](?:(?!" + t.src_ZCc + "|[><｜]|[()[\\]{}.,\"'?!\\-;]).|\\[(?:(?!" + t.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + t.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + t.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + t.src_ZCc + '|["]).)+\\"|\\\'(?:(?!' + t.src_ZCc + "|[']).)+\\'|\\'(?=" + t.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + t.src_ZCc + "|[.]|$)|" + (e["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + ",(?!" + t.src_ZCc + "|$)|;(?!" + t.src_ZCc + "|$)|\\!+(?!" + t.src_ZCc + "|[!]|$)|\\?(?!" + t.src_ZCc + "|[?]|$))+|\\/)?", t.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', t.src_xn = "xn--[a-z0-9\\-]{1,59}", t.src_domain_root = "(?:" + t.src_xn + "|" + t.src_pseudo_letter + "{1,63})", t.src_domain = "(?:" + t.src_xn + "|(?:" + t.src_pseudo_letter + ")|(?:" + t.src_pseudo_letter + "(?:-|" + t.src_pseudo_letter + "){0,61}" + t.src_pseudo_letter + "))", t.src_host = "(?:(?:(?:(?:" + t.src_domain + ")\\.)*" + t.src_domain + "))", t.tpl_host_fuzzy = "(?:" + t.src_ip4 + "|(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%)))", t.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + t.src_domain + ")\\.)+(?:%TLDS%))", t.src_host_strict = t.src_host + t.src_host_terminator, t.tpl_host_fuzzy_strict = t.tpl_host_fuzzy + t.src_host_terminator, t.src_host_port_strict = t.src_host + t.src_port + t.src_host_terminator, t.tpl_host_port_fuzzy_strict = t.tpl_host_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_port_no_ip_fuzzy_strict = t.tpl_host_no_ip_fuzzy + t.src_port + t.src_host_terminator, t.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + t.src_ZPCc + "|>|$))", t.tpl_email_fuzzy = '(^|[><｜]|"|\\(|' + t.src_ZCc + ")(" + t.src_email_name + "@" + t.tpl_host_fuzzy_strict + ")", t.tpl_link_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_fuzzy_strict + t.src_path + ")", t.tpl_link_no_ip_fuzzy = "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + t.src_ZPCc + "))((?![$+<=>^`|｜])" + t.tpl_host_port_no_ip_fuzzy_strict + t.src_path + ")", t;
            }(e.__opts__),
            n = e.__tlds__.slice();
          function r(e) {
            return e.replace("%TLDS%", t.src_tlds);
          }
          e.onCompile(), e.__tlds_replaced__ || n.push("a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]"), n.push(t.src_xn), t.src_tlds = n.join("|"), t.email_fuzzy = RegExp(r(t.tpl_email_fuzzy), "i"), t.link_fuzzy = RegExp(r(t.tpl_link_fuzzy), "i"), t.link_no_ip_fuzzy = RegExp(r(t.tpl_link_no_ip_fuzzy), "i"), t.host_fuzzy_test = RegExp(r(t.tpl_host_fuzzy_test), "i");
          const o = [];
          function i(e, t) {
            throw new Error('(LinkifyIt) Invalid schema "' + e + '": ' + t);
          }
          e.__compiled__ = {}, Object.keys(e.__schemas__).forEach(function (t) {
            const n = e.__schemas__[t];
            if (null === n) return;
            const r = {
              validate: null,
              link: null
            };
            if (e.__compiled__[t] = r, "[object Object]" === Cm(n)) return !function (e) {
              return "[object RegExp]" === Cm(e);
            }(n.validate) ? Sm(n.validate) ? r.validate = n.validate : i(t, n) : r.validate = function (e) {
              return function (t, n) {
                const r = t.slice(n);
                return e.test(r) ? r.match(e)[0].length : 0;
              };
            }(n.validate), void (Sm(n.normalize) ? r.normalize = n.normalize : n.normalize ? i(t, n) : r.normalize = function (e, t) {
              t.normalize(e);
            });
            !function (e) {
              return "[object String]" === Cm(e);
            }(n) ? i(t, n) : o.push(t);
          }), o.forEach(function (t) {
            e.__compiled__[e.__schemas__[t]] && (e.__compiled__[t].validate = e.__compiled__[e.__schemas__[t]].validate, e.__compiled__[t].normalize = e.__compiled__[e.__schemas__[t]].normalize);
          }), e.__compiled__[""] = {
            validate: null,
            normalize: function (e, t) {
              t.normalize(e);
            }
          };
          const a = Object.keys(e.__compiled__).filter(function (t) {
            return t.length > 0 && e.__compiled__[t];
          }).map(Em).join("|");
          e.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "i"), e.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + t.src_ZPCc + "))(" + a + ")", "ig"), e.re.schema_at_start = RegExp("^" + e.re.schema_search.source, "i"), e.re.pretest = RegExp("(" + e.re.schema_test.source + ")|(" + e.re.host_fuzzy_test.source + ")|@", "i"), function (e) {
            e.__index__ = -1, e.__text_cache__ = "";
          }(e);
        }
        function zm(e, t) {
          const n = e.__index__,
            r = e.__last_index__,
            o = e.__text_cache__.slice(n, r);
          this.schema = e.__schema__.toLowerCase(), this.index = n + t, this.lastIndex = r + t, this.raw = o, this.text = o, this.url = o;
        }
        function Tm(e, t) {
          const n = new zm(e, t);
          return e.__compiled__[n.schema].normalize(n, e), n;
        }
        function Om(e, t) {
          if (!(this instanceof Om)) return new Om(e, t);
          var n;
          t || (n = e, Object.keys(n || {}).reduce(function (e, t) {
            return e || _m.hasOwnProperty(t);
          }, !1) && (t = e, e = {})), this.__opts__ = Dm({}, _m, t), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = Dm({}, Pm, e), this.__compiled__ = {}, this.__tlds__ = km, this.__tlds_replaced__ = !1, this.re = {}, Am(this);
        }
        Om.prototype.add = function (e, t) {
          return this.__schemas__[e] = t, Am(this), this;
        }, Om.prototype.set = function (e) {
          return this.__opts__ = Dm(this.__opts__, e), this;
        }, Om.prototype.test = function (e) {
          if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return !1;
          let t, n, r, o, i, a, s, l, u;
          if (this.re.schema_test.test(e)) for (s = this.re.schema_search, s.lastIndex = 0; null !== (t = s.exec(e));) if (o = this.testSchemaAt(e, t[2], s.lastIndex), o) {
            this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + o;
            break;
          }
          return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = e.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && null !== (n = e.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) && (i = n.index + n[1].length, (this.__index__ < 0 || i < this.__index__) && (this.__schema__ = "", this.__index__ = i, this.__last_index__ = n.index + n[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (u = e.indexOf("@"), u >= 0 && null !== (r = e.match(this.re.email_fuzzy)) && (i = r.index + r[1].length, a = r.index + r[0].length, (this.__index__ < 0 || i < this.__index__ || i === this.__index__ && a > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = i, this.__last_index__ = a))), this.__index__ >= 0;
        }, Om.prototype.pretest = function (e) {
          return this.re.pretest.test(e);
        }, Om.prototype.testSchemaAt = function (e, t, n) {
          return this.__compiled__[t.toLowerCase()] ? this.__compiled__[t.toLowerCase()].validate(e, n, this) : 0;
        }, Om.prototype.match = function (e) {
          const t = [];
          let n = 0;
          this.__index__ >= 0 && this.__text_cache__ === e && (t.push(Tm(this, n)), n = this.__last_index__);
          let r = n ? e.slice(n) : e;
          for (; this.test(r);) t.push(Tm(this, n)), r = r.slice(this.__last_index__), n += this.__last_index__;
          return t.length ? t : null;
        }, Om.prototype.matchAtStart = function (e) {
          if (this.__text_cache__ = e, this.__index__ = -1, !e.length) return null;
          const t = this.re.schema_at_start.exec(e);
          if (!t) return null;
          const n = this.testSchemaAt(e, t[2], t[0].length);
          return n ? (this.__schema__ = t[2], this.__index__ = t.index + t[1].length, this.__last_index__ = t.index + t[0].length + n, Tm(this, 0)) : null;
        }, Om.prototype.tlds = function (e, t) {
          return e = Array.isArray(e) ? e : [e], t ? (this.__tlds__ = this.__tlds__.concat(e).sort().filter(function (e, t, n) {
            return e !== n[t - 1];
          }).reverse(), Am(this), this) : (this.__tlds__ = e.slice(), this.__tlds_replaced__ = !0, Am(this), this);
        }, Om.prototype.normalize = function (e) {
          e.schema || (e.url = "http://" + e.url), "mailto:" !== e.schema || /^mailto:/i.test(e.url) || (e.url = "mailto:" + e.url);
        }, Om.prototype.onCompile = function () {};
        const Im = Om,
          Fm = 2147483647,
          Mm = 36,
          Rm = /^xn--/,
          jm = /[^\0-\x7F]/,
          Bm = /[\x2E\u3002\uFF0E\uFF61]/g,
          Nm = {
            overflow: "Overflow: input needs wider integers to process",
            "not-basic": "Illegal input >= 0x80 (not a basic code point)",
            "invalid-input": "Invalid input"
          },
          Lm = Math.floor,
          Vm = String.fromCharCode;
        function Km(e) {
          throw new RangeError(Nm[e]);
        }
        function qm(e, t) {
          const n = e.split("@");
          let r = "";
          n.length > 1 && (r = n[0] + "@", e = n[1]);
          const o = function (e, t) {
            const n = [];
            let r = e.length;
            for (; r--;) n[r] = t(e[r]);
            return n;
          }((e = e.replace(Bm, ".")).split("."), t).join(".");
          return r + o;
        }
        function Hm(e) {
          const t = [];
          let n = 0;
          const r = e.length;
          for (; n < r;) {
            const o = e.charCodeAt(n++);
            if (o >= 55296 && o <= 56319 && n < r) {
              const r = e.charCodeAt(n++);
              56320 == (64512 & r) ? t.push(((1023 & o) << 10) + (1023 & r) + 65536) : (t.push(o), n--);
            } else t.push(o);
          }
          return t;
        }
        const Um = function (e, t) {
            return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
          },
          Zm = function (e, t, n) {
            let r = 0;
            for (e = n ? Lm(e / 700) : e >> 1, e += Lm(e / t); e > 455; r += Mm) e = Lm(e / 35);
            return Lm(r + 36 * e / (e + 38));
          },
          $m = function (e) {
            const t = [],
              n = e.length;
            let r = 0,
              o = 128,
              i = 72,
              a = e.lastIndexOf("-");
            a < 0 && (a = 0);
            for (let n = 0; n < a; ++n) e.charCodeAt(n) >= 128 && Km("not-basic"), t.push(e.charCodeAt(n));
            for (let l = a > 0 ? a + 1 : 0; l < n;) {
              const a = r;
              for (let t = 1, o = Mm;; o += Mm) {
                l >= n && Km("invalid-input");
                const a = (s = e.charCodeAt(l++)) >= 48 && s < 58 ? s - 48 + 26 : s >= 65 && s < 91 ? s - 65 : s >= 97 && s < 123 ? s - 97 : Mm;
                a >= Mm && Km("invalid-input"), a > Lm((Fm - r) / t) && Km("overflow"), r += a * t;
                const u = o <= i ? 1 : o >= i + 26 ? 26 : o - i;
                if (a < u) break;
                const c = Mm - u;
                t > Lm(Fm / c) && Km("overflow"), t *= c;
              }
              const u = t.length + 1;
              i = Zm(r - a, u, 0 == a), Lm(r / u) > Fm - o && Km("overflow"), o += Lm(r / u), r %= u, t.splice(r++, 0, o);
            }
            var s;
            return String.fromCodePoint(...t);
          },
          Gm = function (e) {
            const t = [],
              n = (e = Hm(e)).length;
            let r = 128,
              o = 0,
              i = 72;
            for (const n of e) n < 128 && t.push(Vm(n));
            const a = t.length;
            let s = a;
            for (a && t.push("-"); s < n;) {
              let n = Fm;
              for (const t of e) t >= r && t < n && (n = t);
              const l = s + 1;
              n - r > Lm((Fm - o) / l) && Km("overflow"), o += (n - r) * l, r = n;
              for (const n of e) if (n < r && ++o > Fm && Km("overflow"), n === r) {
                let e = o;
                for (let n = Mm;; n += Mm) {
                  const r = n <= i ? 1 : n >= i + 26 ? 26 : n - i;
                  if (e < r) break;
                  const o = e - r,
                    a = Mm - r;
                  t.push(Vm(Um(r + o % a, 0))), e = Lm(o / a);
                }
                t.push(Vm(Um(e, 0))), i = Zm(o, l, s === a), o = 0, ++s;
              }
              ++o, ++r;
            }
            return t.join("");
          },
          Wm = {
            version: "2.3.1",
            ucs2: {
              decode: Hm,
              encode: e => String.fromCodePoint(...e)
            },
            decode: $m,
            encode: Gm,
            toASCII: function (e) {
              return qm(e, function (e) {
                return jm.test(e) ? "xn--" + Gm(e) : e;
              });
            },
            toUnicode: function (e) {
              return qm(e, function (e) {
                return Rm.test(e) ? $m(e.slice(4).toLowerCase()) : e;
              });
            }
          },
          Ym = {
            default: {
              options: {
                html: !1,
                xhtmlOut: !1,
                breaks: !1,
                langPrefix: "language-",
                linkify: !1,
                typographer: !1,
                quotes: "“”‘’",
                highlight: null,
                maxNesting: 100
              },
              components: {
                core: {},
                block: {},
                inline: {}
              }
            },
            zero: {
              options: {
                html: !1,
                xhtmlOut: !1,
                breaks: !1,
                langPrefix: "language-",
                linkify: !1,
                typographer: !1,
                quotes: "“”‘’",
                highlight: null,
                maxNesting: 20
              },
              components: {
                core: {
                  rules: ["normalize", "block", "inline", "text_join"]
                },
                block: {
                  rules: ["paragraph"]
                },
                inline: {
                  rules: ["text"],
                  rules2: ["balance_pairs", "fragments_join"]
                }
              }
            },
            commonmark: {
              options: {
                html: !0,
                xhtmlOut: !0,
                breaks: !1,
                langPrefix: "language-",
                linkify: !1,
                typographer: !1,
                quotes: "“”‘’",
                highlight: null,
                maxNesting: 20
              },
              components: {
                core: {
                  rules: ["normalize", "block", "inline", "text_join"]
                },
                block: {
                  rules: ["blockquote", "code", "fence", "heading", "hr", "html_block", "lheading", "list", "reference", "paragraph"]
                },
                inline: {
                  rules: ["autolink", "backticks", "emphasis", "entity", "escape", "html_inline", "image", "link", "newline", "text"],
                  rules2: ["balance_pairs", "emphasis", "fragments_join"]
                }
              }
            }
          },
          Xm = /^(vbscript|javascript|file|data):/,
          Qm = /^data:image\/(gif|png|jpeg|webp);/;
        function Jm(e) {
          const t = e.trim().toLowerCase();
          return !Xm.test(t) || Qm.test(t);
        }
        const eg = ["http:", "https:", "mailto:"];
        function tg(e) {
          const t = yh(e, !0);
          if (t.hostname && (!t.protocol || eg.indexOf(t.protocol) >= 0)) try {
            t.hostname = Wm.toASCII(t.hostname);
          } catch (e) {}
          return oh(ih(t));
        }
        function ng(e) {
          const t = yh(e, !0);
          if (t.hostname && (!t.protocol || eg.indexOf(t.protocol) >= 0)) try {
            t.hostname = Wm.toUnicode(t.hostname);
          } catch (e) {}
          return th(ih(t), th.defaultChars + "%");
        }
        function rg(e, t) {
          if (!(this instanceof rg)) return new rg(e, t);
          t || qh(e) || (t = e || {}, e = "default"), this.inline = new xm(), this.block = new rm(), this.core = new qf(), this.renderer = new wf(), this.linkify = new Im(), this.validateLink = Jm, this.normalizeLink = tg, this.normalizeLinkText = ng, this.utils = i, this.helpers = Zh({}, a), this.options = {}, this.configure(e), t && this.set(t);
        }
        rg.prototype.set = function (e) {
          return Zh(this.options, e), this;
        }, rg.prototype.configure = function (e) {
          const t = this;
          if (qh(e)) {
            const t = e;
            if (!(e = Ym[t])) throw new Error('Wrong `markdown-it` preset "' + t + '", check name');
          }
          if (!e) throw new Error("Wrong `markdown-it` preset, can't be empty");
          return e.options && t.set(e.options), e.components && Object.keys(e.components).forEach(function (n) {
            e.components[n].rules && t[n].ruler.enableOnly(e.components[n].rules), e.components[n].rules2 && t[n].ruler2.enableOnly(e.components[n].rules2);
          }), this;
        }, rg.prototype.enable = function (e, t) {
          let n = [];
          Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function (t) {
            n = n.concat(this[t].ruler.enable(e, !0));
          }, this), n = n.concat(this.inline.ruler2.enable(e, !0));
          const r = e.filter(function (e) {
            return n.indexOf(e) < 0;
          });
          if (r.length && !t) throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
          return this;
        }, rg.prototype.disable = function (e, t) {
          let n = [];
          Array.isArray(e) || (e = [e]), ["core", "block", "inline"].forEach(function (t) {
            n = n.concat(this[t].ruler.disable(e, !0));
          }, this), n = n.concat(this.inline.ruler2.disable(e, !0));
          const r = e.filter(function (e) {
            return n.indexOf(e) < 0;
          });
          if (r.length && !t) throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
          return this;
        }, rg.prototype.use = function (e) {
          const t = [this].concat(Array.prototype.slice.call(arguments, 1));
          return e.apply(e, t), this;
        }, rg.prototype.parse = function (e, t) {
          if ("string" != typeof e) throw new Error("Input data should be a String");
          const n = new this.core.State(e, this, t);
          return this.core.process(n), n.tokens;
        }, rg.prototype.render = function (e, t) {
          return t = t || {}, this.renderer.render(this.parse(e, t), this.options, t);
        }, rg.prototype.parseInline = function (e, t) {
          const n = new this.core.State(e, this, t);
          return n.inlineMode = !0, this.core.process(n), n.tokens;
        }, rg.prototype.renderInline = function (e, t) {
          return t = t || {}, this.renderer.render(this.parseInline(e, t), this.options, t);
        };
        const og = rg;
        var ig = n(80602);
        function ag(e, t, n) {
          let {
              direction: r
            } = (0, Le.bU)(),
            o = function (e) {
              let {
                  getItems: t,
                  collection: n,
                  selectionManager: r,
                  onDragStart: o,
                  onDragMove: i,
                  onDragEnd: a,
                  preview: l,
                  getAllowedDropOperations: u
                } = e,
                [, c] = (0, s.useState)(!1),
                d = (0, s.useRef)(new Set()),
                p = (0, s.useRef)(null),
                h = e => {
                  let t = new Set(r.isSelected(e) ? new Set([...r.selectedKeys].filter(e => !!n.getItem(e))) : []);
                  return t.add(e), t;
                };
              return {
                collection: n,
                selectionManager: r,
                get draggedKey() {
                  return p.current;
                },
                get draggingKeys() {
                  return d.current;
                },
                isDragging: e => d.current.has(e),
                getKeysForDrag: h,
                getItems: e => t(h(e)),
                preview: l,
                getAllowedDropOperations: u,
                startDrag(e, t) {
                  let n = h(e);
                  d.current = n, p.current = e, r.setFocused(!1), c(!0), "function" == typeof o && o({
                    ...t,
                    keys: n
                  });
                },
                moveDrag(e) {
                  "function" == typeof i && i({
                    ...e,
                    keys: d.current
                  });
                },
                endDrag(e) {
                  let {
                    isInternal: t
                  } = e;
                  "function" == typeof a && a({
                    ...e,
                    keys: d.current,
                    isInternal: t
                  }), d.current = new Set(), p.current = null, c(!1);
                }
              };
            }({
              ...e,
              collection: t.collection,
              selectionManager: t.selectionManager,
              getItems: e.getItems || (e => [...e].map(e => {
                let n = t.collection.getItem(e);
                return (0, je.kG)(n, "Expected item to be defined."), {
                  "text/plain": n.textValue
                };
              }))
            });
          (0, Le.Xu)(e, o, n);
          let i = function (e) {
              let {
                  acceptedDragTypes: t = "all",
                  onInsert: n,
                  onRootDrop: r,
                  onItemDrop: o,
                  onReorder: i,
                  shouldAcceptItemDrop: a,
                  collection: l,
                  selectionManager: u,
                  onDropEnter: c,
                  getDropOperation: d,
                  onDrop: p
                } = e,
                [h, f] = (0, s.useState)(null),
                m = (0, s.useRef)(null),
                g = e => {
                  if ("before" === e.dropPosition) {
                    let t = l.getKeyBefore(e.key);
                    return null != t ? {
                      type: "item",
                      key: t,
                      dropPosition: "after"
                    } : null;
                  }
                  if ("after" === e.dropPosition) {
                    let t = l.getKeyAfter(e.key);
                    return null != t ? {
                      type: "item",
                      key: t,
                      dropPosition: "before"
                    } : null;
                  }
                },
                v = (0, s.useCallback)(e => {
                  let {
                    target: s,
                    types: l,
                    allowedOperations: u,
                    isInternal: c,
                    draggingKeys: h
                  } = e;
                  if ("all" === t || t.some(e => l.has(e))) {
                    let e = n && "item" === s.type && !c && ("before" === s.dropPosition || "after" === s.dropPosition),
                      t = i && "item" === s.type && c && ("before" === s.dropPosition || "after" === s.dropPosition),
                      f = r && "root" === s.type && !c,
                      m = o && "item" === s.type && "on" === s.dropPosition && !(c && h.has(s.key)) && (!a || a(s, l));
                    if (p || e || t || f || m) return d ? d(s, l, u) : u[0];
                  }
                  return "cancel";
                }, [t, d, n, r, o, a, i, p]);
              return {
                collection: l,
                selectionManager: u,
                target: h,
                setTarget(t) {
                  if (this.isDropTarget(t)) return;
                  let n = m.current;
                  n && "function" == typeof e.onDropExit && e.onDropExit({
                    type: "dropexit",
                    x: 0,
                    y: 0,
                    target: n
                  }), t && "function" == typeof c && c({
                    type: "dropenter",
                    x: 0,
                    y: 0,
                    target: t
                  }), m.current = t, f(t);
                },
                isDropTarget(e) {
                  let t = m.current;
                  return !!oe(e, t) || "item" === (null == e ? void 0 : e.type) && "item" === (null == t ? void 0 : t.type) && e.key !== t.key && e.dropPosition !== t.dropPosition && "on" !== e.dropPosition && "on" !== t.dropPosition && (oe(g(e), t) || oe(e, g(t)));
                },
                getDropOperation: e => v(e)
              };
            }({
              ...e,
              collection: t.collection,
              selectionManager: t.selectionManager
            }),
            {
              collectionProps: a
            } = (0, Le.zw)({
              ...e,
              keyboardDelegate: new Le.dp({
                collection: t.collection,
                disabledKeys: t.disabledKeys,
                ref: n,
                orientation: e.orientation,
                layout: e.layout,
                direction: r
              }),
              dropTargetDelegate: new Le.hO(t.collection, n)
            }, i, n);
          return e.enableReorder ? {
            collectionProps: a,
            dragState: o,
            dropState: i
          } : {
            collectionProps: {},
            dropState: void 0,
            dragState: void 0
          };
        }
        function sg(e) {
          var t = function (e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : String(t);
        }
        function lg(e, t, n) {
          return (t = sg(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function ug(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function cg(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ug(Object(n), !0).forEach(function (t) {
              lg(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ug(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function dg(e, t) {
          var n = {};
          for (var r in e) n[r] = t(e[r], r);
          return n;
        }
        var pg = (e, t, n) => {
            for (var r of Object.keys(e)) {
              var o;
              if (e[r] !== (null !== (o = t[r]) && void 0 !== o ? o : n[r])) return !1;
            }
            return !0;
          },
          hg = e => {
            var t = t => {
              var n = e.defaultClassName,
                r = cg(cg({}, e.defaultVariants), t);
              for (var o in r) {
                var i,
                  a = null !== (i = r[o]) && void 0 !== i ? i : e.defaultVariants[o];
                if (null != a) {
                  var s = a;
                  "boolean" == typeof s && (s = !0 === s ? "true" : "false");
                  var l = e.variantClassNames[o][s];
                  l && (n += " " + l);
                }
              }
              for (var [u, c] of e.compoundVariants) pg(u, r, e.defaultVariants) && (n += " " + c);
              return n;
            };
            return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
              get base() {
                return e.defaultClassName.split(" ")[0];
              },
              get variants() {
                return dg(e.variantClassNames, e => dg(e, e => e.split(" ")[0]));
              }
            }, t;
          },
          fg = hg({
            defaultClassName: "_6n12k9b _1yep5z6l0 _1yep5z6kz _1yep5z6hk _1yep5z6ki",
            variantClassNames: {
              isDropTarget: {
                true: "_1yep5z612n"
              },
              orientation: {
                vertical: "_1yep5z6166",
                horizontal: "_1yep5z6167"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          mg = hg({
            defaultClassName: "_6n12k99 _1yep5z6ev _1yep5z6da _1yep5z6dv",
            variantClassNames: {
              isDisabled: {
                true: "_1yep5z6ey"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          gg = hg({
            defaultClassName: "_6n12k91 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z69l _1yep5z69m _1yep5z69n _1yep5z6dy _1yep5z6eu _1yep5z6ki _1yep5z6kl _1yep5z6ky _1yep5z6kx _1yep5z6kv _1yep5z6ks",
            variantClassNames: {
              isSelected: {},
              isFocused: {
                true: "_1yep5z612n _1yep5z616c _1yep5z616a _1yep5z616d _1yep5z612w _1yep5z612x _1yep5z612y"
              },
              isHovered: {
                true: "_1yep5z6114",
                false: "_1yep5z6113"
              },
              isFirstChild: {
                true: "_6n12k95"
              },
              isLastChild: {
                true: "_6n12k96"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z6109"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          vg = hg({
            defaultClassName: "gukncs0",
            variantClassNames: {
              isVertical: {
                true: "gukncs1"
              },
              isSecondary: {
                true: "gukncs2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          yg = s.forwardRef(({
            className: e,
            style: t,
            variant: n = "primary",
            orientation: r = "horizontal",
            UNSAFE_omitRole: o,
            elementType: i = "div",
            ...a
          }, s) => {
            let {
              separatorProps: l
            } = (0, Le.zA)({
              ...a,
              orientation: r,
              elementType: i
            });
            return (0, Ve.jsx)(i, {
              ...l,
              className: (0, je.AK)(vg({
                isVertical: "vertical" === r,
                isSecondary: "secondary" === n
              }), "BaselineUI-Separator", e),
              "data-orientation": r,
              "data-block-id": a["data-block-id"],
              style: t,
              role: o ? void 0 : l.role,
              ref: s
            });
          });
        function bg(e) {
          return qe.Kj.properties.has(e);
        }
        yg.displayName = "Separator";
        var wg = s.forwardRef(({
          elementType: e = "div",
          children: t,
          ...n
        }, r) => {
          let o = e,
            {
              sprinkleProps: i,
              domProps: a
            } = (0, s.useMemo)(() => {
              let e = {},
                t = {};
              for (let r in n) bg(r) ? e[r] = n[r] : t[r] = n[r];
              return {
                sprinkleProps: e,
                domProps: t
              };
            }, [n]);
          return (0, Ve.jsx)(o, {
            ...a,
            className: (0, je.AK)((0, qe.Kj)(i), "BaselineUI-Box", a.className),
            ref: r,
            children: t
          });
        });
        wg.displayName = "Box";
        var xg = s.forwardRef(({
          item: e,
          isDisabled: t,
          isFocusVisible: n,
          isSelected: r,
          liProps: o,
          showSelectedIcon: i,
          description: a,
          descriptionProps: s,
          labelProps: l,
          isFocused: u,
          isPressed: c,
          _state: d
        }, p) => {
          (0, je.kG)(e.value && ("option" === e.value.type || void 0 === e.value.type), "Item cannot be a section");
          let {
              icon: h,
              label: f
            } = e.value,
            {
              hoverProps: m,
              isHovered: g
            } = (0, Le.XI)({
              isDisabled: t
            }),
            v = (0, je.mS)({
              "data-selected": r,
              "data-disabled": t,
              "data-focused": u,
              "data-hovered": g,
              "data-pressed": c,
              "data-focus-visible": n,
              "data-selection-mode": d.selectionManager.selectionMode
            });
          return (0, Ve.jsxs)("li", {
            ...(0, Le.dG)(o, m, v),
            className: (0, je.AK)(gg({
              isHovered: g,
              isFocused: n,
              isFirstChild: d.collection.getFirstKey() === e.key,
              isLastChild: d.collection.getLastKey() === e.key,
              isDisabled: t
            }), "BaselineUI-ListBox-Option"),
            ref: p,
            children: [(0, Ve.jsxs)(wg, {
              display: "flex",
              alignItems: "center",
              gap: "lg",
              children: [i ? (0, Ve.jsx)("span", {
                "aria-hidden": !0,
                style: {
                  height: 24,
                  width: 24
                },
                children: r ? (0, Ve.jsx)(Ke.KML, {
                  size: 24
                }) : null
              }) : null, h ? (0, Ve.jsx)(h, {
                size: 24
              }) : null, (0, Ve.jsx)("span", {
                ...l,
                children: f
              })]
            }), a ? (0, Ve.jsx)("span", {
              className: mg({
                isDisabled: t
              }),
              ...s,
              children: a
            }) : null]
          });
        });
        xg.displayName = "DefaultRenderOption";
        var Dg = ({
            dropState: e,
            orientation: t = "vertical",
            dropIndicatorStyle: n,
            dropIndicatorClassName: r,
            renderDropIndicator: o = ({
              isDropTarget: e,
              isHidden: t,
              dropIndicatorProps: o,
              orientation: i
            }, a) => t ? null : (0, Ve.jsx)("li", {
              ...o,
              ref: a,
              "data-drop-target": e,
              className: (0, je.AK)(fg({
                isDropTarget: e,
                orientation: i
              }), "BaselineUI-DropIndicator", r),
              style: n
            }),
            ...i
          }) => {
            let a = s.useRef(null),
              {
                dropIndicatorProps: l,
                isHidden: u,
                isDropTarget: c
              } = (0, Le.Dr)(i, e, a);
            return o({
              dropIndicatorProps: {
                ...l,
                role: "option"
              },
              isHidden: u,
              isDropTarget: c,
              orientation: t
            }, a);
          },
          Cg = ({
            item: e,
            children: t,
            state: n,
            dragState: r,
            ...o
          }) => {
            let {
              dragProps: i
            } = (0, Le.J4)({
              key: e.key
            }, r);
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: [(0, Ve.jsx)(Dg, {
                target: {
                  type: "item",
                  key: e.key,
                  dropPosition: "before"
                },
                ...o
              }), t(i), null == n.collection.getKeyAfter(e.key) && (0, Ve.jsx)(Dg, {
                target: {
                  type: "item",
                  key: e.key,
                  dropPosition: "after"
                },
                ...o
              })]
            });
          };
        Cg.displayName = "DraggableListOption";
        var Sg = s.forwardRef(({
          item: e,
          renderOption: t = (e, t, n) => (0, Ve.jsx)(xg, {
            item: e,
            liProps: t.optionProps,
            ...t,
            ref: n
          }),
          showSelectedIcon: n,
          state: r,
          dragState: o,
          dropState: i,
          orientation: a,
          dropIndicatorStyle: l,
          dropIndicatorClassName: u,
          optionStyle: c,
          optionClassName: d
        }, p) => {
          let h = s.useRef(null),
            f = (0, Le.Fv)({
              key: e.key
            }, r, h),
            {
              value: m
            } = e;
          (0, je.kG)(!!m), (0, je.kG)(!("children" in e), "ListSection should not be passed to ListOption");
          let g = {
            style: "function" == typeof c ? c(m) : c,
            className: "function" == typeof d ? d(m) : d
          };
          return o && i ? (0, Ve.jsx)(Cg, {
            orientation: a,
            state: r,
            item: e,
            dropState: i,
            dragState: o,
            dropIndicatorStyle: l,
            dropIndicatorClassName: u,
            children: o => t(e, {
              ...f,
              showSelectedIcon: n,
              _state: r,
              optionProps: (0, Le.dG)(f.optionProps, o, g)
            }, (0, Be.lq)(h, p))
          }) : t(e, {
            ...f,
            showSelectedIcon: n,
            _state: r,
            optionProps: (0, Le.dG)(f.optionProps, g)
          }, (0, Be.lq)(h, p));
        });
        Sg.displayName = "Option";
        var Eg = ({
          section: e,
          state: t,
          sectionClassName: n,
          sectionStyle: r,
          ...o
        }) => {
          let {
              itemProps: i,
              groupProps: a
            } = (0, Le.TV)({
              heading: e.rendered,
              "aria-label": e["aria-label"]
            }),
            s = t.collection.getChildren?.(e.key);
          (0, je.kG)(s, "items with type `section` must have children");
          let {
              value: l
            } = e,
            u = "function" == typeof r ? r(l) : r,
            c = "function" == typeof n ? n(l) : n;
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [e.key !== t.collection.getFirstKey() && (0, Ve.jsx)(yg, {
              UNSAFE_omitRole: !0
            }), (0, Ve.jsx)("li", {
              ...i,
              style: {
                ...i.style,
                ...u
              },
              className: (0, je.AK)("_6n12k90", c, "BaselineUI-ListBox-Section"),
              children: (0, Ve.jsx)("ul", {
                ...a,
                children: [...s].map(e => (0, Ve.jsx)(Sg, {
                  item: e,
                  state: t,
                  ...o
                }, e.key))
              })
            })]
          });
        };
        Eg.displayName = "ListBoxSection";
        var _g = s.forwardRef(({
          className: e,
          layout: t = "stack",
          orientation: n = "vertical",
          showSelectedIcon: r = !0,
          UNSAFE_state: o,
          style: i,
          renderOption: a,
          enableReorder: l = !1,
          "data-block-id": u,
          renderDragPreview: c,
          onReorder: d,
          ...p
        }, h) => {
          let f = s.useRef(null),
            m = g(p),
            {
              direction: v
            } = (0, Le.bU)(),
            y = o || m,
            b = s.useRef(null),
            {
              listBoxProps: w
            } = (0, Le.co)({
              ...p,
              shouldSelectOnPressUp: l,
              keyboardDelegate: new Le.dp({
                collection: y.collection,
                ref: b,
                layout: t,
                orientation: n,
                direction: v,
                disabledKeys: y.disabledKeys
              })
            }, y, b),
            x = (0, Ne.JZ)(),
            D = (0, s.useCallback)(e => {
              let t = (0, Be.r3)(b.current);
              d && (!x && "startViewTransition" in t ? t.startViewTransition(() => {
                d(e);
              }) : d(e));
            }, [d, x]),
            {
              collectionProps: C,
              dragState: S,
              dropState: E
            } = ag({
              ...p,
              onReorder: D,
              layout: t,
              orientation: n,
              enableReorder: l,
              preview: f
            }, y, b),
            {
              isFocusVisible: _,
              isFocused: P,
              focusProps: k
            } = (0, Le.Fx)(),
            A = (0, je.mS)({
              "data-block-id": u,
              "data-layout": t,
              "data-empty": 0 === y.collection.size,
              "data-focused": P,
              "data-focus-visible": _,
              "data-orientation": n
            });
          return (0, Ve.jsxs)("ul", {
            ...(0, Le.dG)(w, k, A, C),
            className: (0, je.AK)("_6n12k98 _1yep5z6ky _1yep5z6i0 _1yep5z6i1 _1yep5z6i2", "BaselineUI-ListBox", e),
            style: i,
            ref: (0, Be.lq)(h, b),
            children: [[...y.collection].map(e => {
              let t = {
                key: e.key,
                state: y,
                dragState: S,
                dropState: E,
                renderOption: a,
                renderDropIndicator: p.renderDropIndicator,
                showSelectedIcon: r,
                orientation: n,
                dropIndicatorStyle: p.dropIndicatorStyle,
                dropIndicatorClassName: p.dropIndicatorClassName,
                optionStyle: p.optionStyle,
                optionClassName: p.optionClassName
              };
              return "section" === e.type ? (0, Ve.jsx)(Eg, {
                ...t,
                section: e
              }) : (0, Ve.jsx)(Sg, {
                ...t,
                item: e
              });
            }), c ? (0, Ve.jsx)(Le.vI, {
              ref: f,
              children: c
            }) : null]
          });
        });
        _g.displayName = "ListBoxBase";
        var Pg = s.forwardRef((e, t) => (0, Ve.jsx)(_g, {
          ...e,
          ref: t,
          children: e => "section" === e.type ? (0, Ve.jsx)(c.$0, {
            items: e.children,
            title: e.id,
            children: e => (0, Ve.jsx)(c.ck, {
              children: e.label
            }, e.id)
          }, e.id) : (0, Ve.jsx)(c.ck, {
            children: e.label
          }, e.id)
        }));
        Pg.displayName = "ListBox";
        var kg = "uf19bsg _1yep5z6ki",
          Ag = hg({
            defaultClassName: "uf19bs0 _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6f0 _1yep5z6kx _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6ks",
            variantClassNames: {
              size: {
                xxs: "uf19bs1",
                xs: "uf19bs2",
                sm: "uf19bs3",
                md: "uf19bs4",
                lg: "uf19bs5 _1yep5z6vw _1yep5z6vx _1yep5z6vy _1yep5z6wk _1yep5z6wl _1yep5z6wm _1yep5z6x8 _1yep5z6x9 _1yep5z6xa _1yep5z6xw _1yep5z6xx _1yep5z6xy"
              },
              isHovered: {
                true: "uf19bs6"
              },
              isDisabled: {
                true: "uf19bs7 _1yep5z610d"
              },
              isFocusVisible: {
                true: "uf19bs8"
              },
              variant: {
                primary: "uf19bs9",
                secondary: "uf19bsa",
                tertiary: "uf19bsb",
                ghost: "uf19bsc",
                toolbar: "_1yep5z6we _1yep5z6wf _1yep5z6wg _1yep5z6x2 _1yep5z6x3 _1yep5z6x4 _1yep5z6xq _1yep5z6xr _1yep5z6xs _1yep5z6ye _1yep5z6yf _1yep5z6yg",
                popover: "uf19bse _1yep5z6oz _1yep5z6p0 _1yep5z6p1 _1yep5z6mn _1yep5z6mo _1yep5z6mp _1yep5z6le _1yep5z6lf _1yep5z6lg _1yep5z6nq _1yep5z6nr _1yep5z6ns _1yep5z6uz _1yep5z6v0 _1yep5z6v1"
              },
              isPressed: {
                true: "uf19bsf"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "toolbar",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61mf"], [{
              variant: "primary",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61mf"], [{
              variant: "secondary",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61ln"], [{
              variant: "tertiary",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61lm _1yep5z61mg"], [{
              variant: "ghost",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61ls"], [{
              variant: "popover",
              isHovered: !0,
              isFocusVisible: !1
            }, "_1yep5z61o1 _1yep5z61rl _1yep5z61rp _1yep5z61rm"], [{
              variant: "toolbar",
              isPressed: !0
            }, "_1yep5z61mf"], [{
              variant: "primary",
              isPressed: !0
            }, "_1yep5z61mf"], [{
              variant: "secondary",
              isPressed: !0
            }, "_1yep5z61ln"], [{
              variant: "tertiary",
              isPressed: !0
            }, "_1yep5z61lq _1yep5z61mg"], [{
              variant: "ghost",
              isPressed: !0
            }, "_1yep5z61lt"], [{
              variant: "popover",
              isPressed: !0
            }, "_1yep5z61o1 _1yep5z61rl _1yep5z61rp _1yep5z61rm"], [{
              variant: "ghost",
              isDisabled: !1
            }, "_1yep5z61lr"], [{
              variant: "popover",
              size: "lg"
            }, "_1yep5z61h4 _1yep5z61h5 _1yep5z61h6 _1yep5z61hs _1yep5z61ht _1yep5z61hu _1yep5z61ig _1yep5z61ih _1yep5z61ii _1yep5z61j4 _1yep5z61j5 _1yep5z61j6"]]
          }),
          zg = s.createContext({
            state: null,
            overlayTriggerAria: {
              triggerProps: {},
              overlayProps: {}
            },
            triggerRef: void 0
          }),
          Tg = ({
            children: e,
            ...t
          }) => {
            let n = s.useRef(null),
              r = y(t),
              o = (0, Le.IB)(t, r),
              i = (0, s.useMemo)(() => ({
                state: r,
                overlayTriggerAria: o,
                triggerRef: n
              }), [r, o]);
            return (0, Ve.jsx)(zg.Provider, {
              value: i,
              children: "function" == typeof e ? e(r) : e
            });
          },
          Og = s.createContext({
            isSelected: !1,
            ref: void 0
          }),
          Ig = ({
            children: e
          }) => {
            let {
              state: t,
              overlayTriggerAria: n,
              triggerRef: r
            } = (0, s.useContext)(zg);
            (0, je.kG)(t, "PopoverTrigger must be used within a Popover");
            let {
                triggerProps: o
              } = n,
              i = (0, s.useMemo)(() => ({
                ...o,
                isSelected: t.isOpen,
                ref: r
              }), [o, t.isOpen, r]);
            return (0, Ve.jsx)(Og.Provider, {
              value: i,
              children: e
            });
          },
          Fg = e => {
            let t = s.useRef(null),
              {
                ref: n,
                ...r
              } = (0, s.useContext)(Og) || {},
              {
                buttonProps: o,
                isPressed: i
              } = (0, Le.UW)({
                ...e,
                ...r
              }, t);
            return {
              buttonProps: o,
              isPressed: i,
              ref: (0, Be.lq)(t, n || null)
            };
          },
          Mg = (e, t) => {
            let n = s.useRef(null),
              {
                ref: r,
                ...o
              } = (0, s.useContext)(Og) || {},
              {
                buttonProps: i,
                isPressed: a
              } = (0, Le.kI)({
                ...e,
                ...o
              }, t, n);
            return {
              buttonProps: i,
              isPressed: a,
              ref: (0, Be.lq)(n, r || null)
            };
          },
          Rg = hg({
            defaultClassName: "oom8bs0 _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z69i _1yep5z69j _1yep5z69k _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ks _1yep5z6dy _1yep5z6ki",
            variantClassNames: {
              variant: {
                primary: "oom8bs1",
                secondary: "oom8bs2",
                tertiary: "oom8bs3",
                ghost: "oom8bs4",
                popover: "oom8bs5",
                toolbar: "oom8bs6"
              },
              isDisabled: {
                true: "oom8bs7"
              },
              isFocusVisible: {
                true: "oom8bs8"
              },
              isHovered: {
                true: "oom8bs9"
              },
              size: {
                sm: "oom8bsa",
                md: "oom8bsb",
                lg: "oom8bsc"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "primary",
              isHovered: !0
            }, "oom8bsd"], [{
              variant: "secondary",
              isHovered: !0
            }, "oom8bse"], [{
              variant: "tertiary",
              isHovered: !0
            }, "oom8bsf"], [{
              variant: "popover",
              isHovered: !0
            }, "oom8bsg"], [{
              variant: "ghost",
              isHovered: !0
            }, "oom8bsh"], [{
              variant: "primary",
              isFocusVisible: !0
            }, "oom8bsi"], [{
              variant: "tertiary",
              isFocusVisible: !0
            }, "oom8bsj"]]
          }),
          jg = {
            sm: 16,
            md: 20,
            lg: 24
          },
          Bg = s.forwardRef(({
            label: e,
            style: t,
            className: n,
            iconStart: r,
            iconEnd: o,
            variant: i = "primary",
            elementType: a = "button",
            isDisabled: s,
            size: l = "sm",
            "data-block-id": u,
            ...c
          }, d) => {
            let {
                buttonProps: p,
                isPressed: h,
                ref: f
              } = Fg({
                ...c,
                elementType: a,
                isDisabled: s
              }),
              m = jg[l],
              {
                hoverProps: g,
                isHovered: v
              } = (0, Le.XI)({
                isDisabled: s
              }),
              {
                isFocusVisible: y,
                isFocused: b,
                focusProps: w
              } = (0, Le.Fx)(),
              x = (0, je.mS)({
                "data-block-id": u,
                "data-disabled": s,
                "data-focused": b,
                "data-focus-visible": y,
                "data-hovered": v,
                "data-pressed": h
              });
            return (0, Ve.jsxs)(a, {
              ...(0, Le.dG)(p, g, w, x),
              className: (0, je.AK)(Rg({
                isDisabled: !!s,
                isFocusVisible: y,
                isHovered: v,
                variant: i,
                size: l
              }), "BaselineUI-ActionButton", n),
              style: t,
              ref: (0, Be.lq)(d, f),
              children: [!!r && (0, Ve.jsx)(r, {
                size: m
              }), e, !!o && (0, Ve.jsx)(o, {
                size: m
              }), "popover" === i && (0, Ve.jsx)(He.v4, {
                size: 8,
                className: kg
              })]
            });
          });
        Bg.displayName = "ActionButton";
        var Ng = hg({
            defaultClassName: "z9nup84",
            variantClassNames: {
              size: {
                xs: "z9nup85",
                sm: "z9nup86"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Lg = "z9nup80",
          Vg = "z9nup83",
          Kg = s.forwardRef(({
            className: e,
            node: t
          }, n) => {
            let r = s.useRef(null);
            return s.useEffect(() => {
              let e = r.current;
              return e?.append(t), () => {
                e?.contains(t) && t.remove();
              };
            }, [t]), (0, Ve.jsx)("div", {
              className: (0, je.AK)(Lg, e),
              ref: (0, Be.lq)(n, r)
            });
          });
        Kg.displayName = "DomNodeRenderer";
        var qg = hg({
            defaultClassName: "_14uvjig4",
            variantClassNames: {
              isDisabled: {
                true: "_14uvjig5"
              },
              hasNumberInput: {
                false: "_14uvjig6"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Hg = hg({
            defaultClassName: "_14uvjige _14uvjig1",
            variantClassNames: {
              active: {
                true: "_14uvjigf _14uvjig2"
              },
              isDisabled: {
                true: "_14uvjigg"
              },
              isReadOnly: {
                true: "_14uvjigh"
              },
              isFocusVisible: {
                true: "_14uvjigi _14uvjig2"
              },
              isHovered: {
                true: "_14uvjigj _14uvjig2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Ug = hg({
            defaultClassName: "_14uvjig9 _14uvjig1",
            variantClassNames: {
              active: {
                true: "_14uvjig2"
              },
              isFocusVisible: {
                true: "_14uvjigb _14uvjig2"
              },
              isDisabled: {
                true: "_14uvjigc"
              },
              isHovered: {
                true: "_14uvjig2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Zg = hg({
            defaultClassName: "nrh1ehx",
            variantClassNames: {
              isDisabled: {
                true: "nrh1ehy"
              },
              hasError: {
                true: "nrh1ehz"
              },
              labelPosition: {
                start: "nrh1eh10",
                top: "nrh1eh11"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          $g = hg({
            defaultClassName: "nrh1eho",
            variantClassNames: {
              isDisabled: {
                true: "nrh1ehp"
              },
              labelPosition: {
                top: "nrh1ehq",
                start: "nrh1ehr"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Gg = hg({
            defaultClassName: "nrh1ehs",
            variantClassNames: {
              validationState: {
                valid: "nrh1eht",
                error: "nrh1ehu",
                warning: "nrh1ehv"
              },
              isReadOnly: {
                true: "nrh1ehw"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Wg = "nrh1eh3",
          Yg = hg({
            defaultClassName: "nrh1eh4",
            variantClassNames: {
              labelPosition: {
                top: "nrh1eh5",
                start: "nrh1eh6"
              },
              hasMessage: {
                true: "nrh1eh7"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              labelPosition: "start",
              hasMessage: !1
            }, "nrh1eh8"]]
          }),
          Xg = hg({
            defaultClassName: "nrh1eh0",
            variantClassNames: {
              labelPosition: {
                top: "z9nup81",
                start: "nrh1eh2 z9nup82"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Qg = hg({
            defaultClassName: "nrh1eh9 z9nup82",
            variantClassNames: {
              validationState: {
                valid: "nrh1eha",
                error: "nrh1ehb",
                warning: "nrh1ehc"
              },
              isHovered: {
                true: "nrh1ehd"
              },
              isFocused: {
                true: "nrh1ehe"
              },
              isDisabled: {
                true: "nrh1ehf"
              },
              variant: {
                primary: "nrh1ehg",
                ghost: "nrh1ehh"
              },
              isReadOnly: {
                true: "nrh1ehi"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "ghost",
              isHovered: !0,
              isFocused: !1,
              validationState: "valid"
            }, "nrh1ehj"], [{
              variant: "ghost",
              isFocused: !1,
              isHovered: !1,
              validationState: "valid"
            }, "nrh1ehk"], [{
              isHovered: !0,
              validationState: "valid",
              isDisabled: !1,
              isReadOnly: !1,
              isFocused: !1,
              variant: "primary"
            }, "nrh1ehl"], [{
              isHovered: !0,
              validationState: "warning",
              isDisabled: !1,
              isReadOnly: !1,
              isFocused: !1
            }, "nrh1ehm"], [{
              isReadOnly: !0,
              variant: "primary",
              isFocused: !1
            }, "nrh1ehn"]]
          });
        function Jg({
          description: e,
          errorMessageProps: t,
          descriptionProps: n,
          warningMessage: r,
          errorMessage: o,
          labelPosition: i,
          isDisabled: a
        }) {
          return e ? (0, Ve.jsx)("div", {
            ...n,
            className: Zg({
              isDisabled: a,
              labelPosition: i
            }),
            children: e
          }) : o ? (0, Ve.jsx)("div", {
            ...t,
            className: Zg({
              hasError: !0,
              labelPosition: i
            }),
            children: o
          }) : r ? (0, Ve.jsx)("div", {
            className: Zg({
              isDisabled: a,
              labelPosition: i
            }),
            children: r
          }) : null;
        }
        var ev = hg({
            defaultClassName: "_1lnwne1 z9nup82",
            variantClassNames: {
              isHoveredOrFocused: {
                true: "_1lnwne2"
              },
              isInteractive: {
                false: "z9nup83"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isHoveredOrFocused: !0,
              isInteractive: !0
            }, "_1lnwne4"]]
          }),
          tv = {
            xxs: 8,
            xs: 12,
            sm: 16,
            md: 20,
            lg: 24
          },
          nv = s.forwardRef(({
            className: e,
            style: t,
            icon: n,
            size: r = "md",
            variant: o = "primary",
            UNSAFE_NON_INTERACTIVE: i,
            elementType: a = i ? "div" : "button",
            ...s
          }, l) => {
            !s["aria-label"] && !s["aria-labelledby"] && console.warn("An `ActionIconButton` requires an aria-label or aria-labelledby prop.");
            let {
                buttonProps: u,
                isPressed: c,
                ref: d
              } = Fg({
                ...s,
                elementType: a
              }),
              {
                isFocusVisible: p,
                isFocused: h,
                focusProps: f
              } = (0, Le.Fx)(),
              {
                hoverProps: m,
                isHovered: g
              } = (0, Le.XI)({
                isDisabled: s.isDisabled
              }),
              v = (0, je.mS)({
                "data-block-id": s["data-block-id"],
                "data-focused": h,
                "data-focus-visible": p,
                "data-disabled": s.isDisabled,
                "data-hovered": g,
                "data-pressed": c
              });
            return (0, Ve.jsxs)(a, {
              ...(0, Le.dG)(u, m, f, v),
              className: (0, je.AK)(Ag({
                variant: o,
                size: r,
                isDisabled: !!s.isDisabled,
                isFocusVisible: p,
                isHovered: g,
                isPressed: c
              }), "BaselineUI-ActionIconButton", e),
              ref: (0, Be.lq)(l, d),
              style: t,
              ...(i && {
                tabIndex: void 0,
                role: void 0,
                "aria-label": void 0,
                "aria-labelledby": void 0,
                "aria-disabled": void 0
              }),
              children: [(0, Ve.jsx)(n, {
                role: "presentation",
                size: tv[r]
              }), "popover" === o && (0, Ve.jsx)(He.v4, {
                size: 8,
                className: kg
              })]
            });
          });
        nv.displayName = "ActionIconButton";
        var rv = s.forwardRef(({
          className: e,
          style: t,
          labelPosition: n = "top",
          variant: r = "primary",
          showStepper: o = !0,
          ...i
        }, a) => {
          let l = s.useRef(null),
            {
              locale: u
            } = (0, Le.bU)(),
            c = ce({
              ...i,
              locale: u
            }),
            {
              hoverProps: d,
              isHovered: p
            } = (0, Le.XI)({
              isDisabled: i.isDisabled
            }),
            {
              focusProps: h,
              isFocusVisible: f,
              isFocused: m
            } = (0, Le.Fx)(),
            {
              labelProps: g,
              decrementButtonProps: v,
              inputProps: y,
              incrementButtonProps: b,
              groupProps: w,
              descriptionProps: x,
              errorMessageProps: D
            } = (0, Le.IL)(i, c, l),
            C = (0, s.useMemo)(() => i.isReadOnly ? Ue.CP : i.isInvalid ? Ue.Rv : null, [i.isInvalid, i.isReadOnly]),
            S = Jg({
              description: i.description,
              errorMessageProps: D,
              descriptionProps: x,
              errorMessage: i.errorMessage,
              labelPosition: n,
              isDisabled: i.isDisabled
            }),
            E = (0, je.mS)({
              "data-disabled": i.isDisabled,
              "data-readonly": i.isReadOnly,
              "data-hovered": p,
              "data-focused": m,
              "data-focus-visible": f,
              "data-invalid": i.isInvalid,
              "data-block-id": i["data-block-id"]
            });
          return (0, Ve.jsxs)("div", {
            style: t,
            className: (0, je.AK)(Xg({
              labelPosition: n
            }), "BaselineUI-NumberInput", e),
            ...E,
            ref: a,
            children: [i.label ? (0, Ve.jsxs)("div", {
              className: Yg({
                labelPosition: n,
                hasMessage: !!S
              }),
              children: [(0, Ve.jsx)("label", {
                ...g,
                className: Wg,
                children: i.label
              }), "start" === n && S]
            }) : null, (0, Ve.jsxs)("div", {
              className: (0, je.AK)({
                [Vg]: i.isDisabled
              }),
              children: [(0, Ve.jsxs)("div", {
                ...(0, Le.dG)(w, d),
                className: (0, je.AK)(Qg({
                  isHovered: p,
                  isDisabled: !!i.isDisabled,
                  isReadOnly: !!i.isReadOnly,
                  validationState: i.isInvalid ? "error" : "valid",
                  isFocused: m,
                  variant: r
                }), {
                  _1lnwne0: "start" === n
                }, "BaselineUI-NumberInput-Container"),
                children: [(0, Ve.jsx)("input", {
                  ...(0, Le.dG)(y, h),
                  ref: l,
                  className: (0, je.AK)("BaselineUI-NumberInput-Input", $g({
                    isDisabled: i.isDisabled,
                    labelPosition: n
                  }))
                }), C ? (0, Ve.jsx)(C, {
                  className: Gg({
                    validationState: "error",
                    isReadOnly: i.isReadOnly
                  }),
                  size: 16
                }) : null, o ? (0, Ve.jsxs)("div", {
                  className: ev({
                    isHoveredOrFocused: p || m,
                    isInteractive: !i.isReadOnly && !i.isDisabled
                  }),
                  children: [(0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "xxs",
                    icon: He.V_,
                    ...v,
                    className: "BaselineUI-NumberInput-DecrementButton"
                  }), (0, Ve.jsx)(yg, {
                    style: {
                      height: 16
                    },
                    orientation: "vertical"
                  }), (0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "xxs",
                    icon: He.pO,
                    ...b,
                    className: "BaselineUI-NumberInput-DecrementButton"
                  })]
                }) : null]
              }), "top" === n && S]
            })]
          });
        });
        rv.displayName = "NumberInput";
        var ov = s.forwardRef(({
          className: e,
          style: t,
          onChange: n,
          onChangeEnd: r,
          numberFormatOptions: o,
          isDisabled: i,
          step: a,
          minValue: l,
          maxValue: u,
          value: c,
          "aria-label": d,
          "aria-labelledby": p,
          "aria-details": h,
          "aria-describedby": f,
          "data-block-id": m,
          defaultValue: g,
          isReadOnly: v,
          label: y,
          id: b,
          includeNumberInput: w
        }, x) => {
          let D = s.useRef(null),
            C = {
              onChange: void 0 === n ? void 0 : e => {
                n(e[0]);
              },
              isDisabled: i || v,
              step: a,
              minValue: l,
              maxValue: u,
              onChangeEnd: void 0 === r ? void 0 : e => {
                r(e[0]);
              },
              value: void 0 === c ? void 0 : [c],
              defaultValue: void 0 === g ? void 0 : [g],
              "aria-label": d,
              "aria-labelledby": p,
              "aria-details": h,
              "aria-describedby": f,
              id: b,
              label: y
            },
            S = (0, Le.Ux)(o),
            E = (0, me.x)({
              ...C,
              numberFormatter: S
            }),
            {
              trackProps: _,
              groupProps: P,
              labelProps: k
            } = (0, Le.oN)(C, E, D),
            A = (0, Ve.jsx)(rv, {
              variant: "ghost",
              showStepper: !1,
              "aria-label": d,
              "aria-labelledby": k.id,
              value: E.getThumbValue(0),
              formatOptions: o,
              onChange: e => {
                E.setThumbValue(0, e);
              },
              style: {
                width: 55,
                textAlign: "right",
                flexShrink: 0
              }
            });
          return (0, Ve.jsxs)("div", {
            ...P,
            style: t,
            "data-block-id": m,
            className: (0, je.AK)("_14uvjig0 z9nup81", "BaselineUI-Slider", e),
            children: [y ? (0, Ve.jsxs)("div", {
              className: "_14uvjig3",
              children: [(0, Ve.jsx)("label", {
                ...k,
                className: (0, je.AK)(qg({
                  isDisabled: i,
                  hasNumberInput: !!w
                }), "BaselineUI-Slider-Label"),
                children: y
              }), w ? A : null]
            }) : null, (0, Ve.jsxs)("div", {
              className: "_14uvjig7",
              children: [(0, Ve.jsx)("div", {
                ..._,
                className: (0, je.AK)("_14uvjig8", "BaselineUI-Slider-Track"),
                ref: (0, Be.lq)(D, x),
                "data-testid": "track",
                children: (0, Ve.jsx)(iv, {
                  state: E,
                  trackRef: D,
                  isDisabled: i,
                  isReadOnly: v
                })
              }), w && !y ? A : null]
            })]
          });
        });
        function iv({
          state: e,
          trackRef: t,
          isDisabled: n,
          isReadOnly: r
        }) {
          let o = s.useRef(null),
            {
              thumbProps: i,
              inputProps: a,
              isDragging: l
            } = (0, Le.pS)({
              trackRef: t,
              inputRef: o
            }, e),
            {
              focusProps: u,
              isFocused: c,
              isFocusVisible: d
            } = (0, Le.Fx)(),
            {
              hoverProps: p,
              isHovered: h
            } = (0, Le.XI)({
              isDisabled: n
            }),
            f = (0, je.mS)({
              "data-disabled": n,
              "data-readonly": r,
              "data-hovered": h,
              "data-focus-visible": d,
              "data-dragging": l,
              "data-focused": c
            });
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [(0, Ve.jsx)("div", {
              className: (0, je.AK)(Ug({
                isDisabled: n,
                isFocusVisible: d,
                active: l,
                isHovered: h
              }), "BaselineUI-Slider-TrackHighlight"),
              style: {
                width: i.style?.left
              },
              "data-testid": "track-highlight"
            }), (0, Ve.jsx)("div", {
              ...(0, Le.dG)(i, p, f),
              className: (0, je.AK)(Hg({
                isDisabled: n,
                isFocusVisible: d,
                active: l,
                isReadOnly: r,
                isHovered: h
              }), "BaselineUI-Slider-Thumb"),
              "data-testid": "thumb",
              children: (0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ref: o,
                  ...(0, Le.dG)(a, u)
                })
              })
            })]
          });
        }
        ov.displayName = "Slider";
        var av = hg({
            defaultClassName: "bpklwa7",
            variantClassNames: {
              isReadOnly: {
                true: "bpklwa8"
              },
              isDisabled: {
                true: "bpklwa9"
              },
              isSelected: {
                true: "bpklwaa"
              },
              isFocused: {
                true: "bpklwab"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isDisabled: !1,
              isReadOnly: !1
            }, "bpklwac"]]
          }),
          sv = hg({
            defaultClassName: "bpklwae",
            variantClassNames: {
              isDisabled: {
                true: "bpklwaf"
              },
              isSelected: {
                true: "bpklwag"
              },
              isReadOnly: {
                true: "bpklwah"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          lv = hg({
            defaultClassName: "bpklwa0",
            variantClassNames: {
              labelPosition: {
                top: "bpklwa1",
                left: "bpklwa2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          uv = hg({
            defaultClassName: "bpklwa3",
            variantClassNames: {
              labelPosition: {
                top: "bpklwa4",
                left: "bpklwa5"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          cv = s.forwardRef(({
            className: e,
            label: t,
            labelPosition: n = "top",
            statusLabel: r,
            style: o,
            "data-block-id": i,
            ...a
          }, l) => {
            let u = s.useRef(null),
              c = (0, _e.l)(a),
              {
                inputProps: d,
                isPressed: p
              } = (0, Le.h9)(a, c, u),
              {
                isFocusVisible: h,
                focusProps: f
              } = (0, Le.Fx)(),
              {
                hoverProps: m,
                isHovered: g
              } = (0, Le.XI)({
                isDisabled: a.isDisabled
              }),
              v = (0, je.mS)({
                "data-block-id": i,
                "data-focused": h,
                "data-disabled": a.isDisabled,
                "data-focus-visible": h,
                "data-selected": c.isSelected,
                "data-readonly": a.isReadOnly,
                "data-hovered": g,
                "data-pressed": p
              }),
              y = (0, Ve.jsx)("div", {
                className: (0, je.AK)(av({
                  isSelected: c.isSelected,
                  isDisabled: !!a.isDisabled,
                  isFocused: h,
                  isReadOnly: !!a.isReadOnly
                }), "BaselineUI-Switch-Track"),
                children: (0, Ve.jsx)("div", {
                  className: (0, je.AK)(sv({
                    isSelected: c.isSelected,
                    isDisabled: a.isDisabled,
                    isReadOnly: a.isReadOnly
                  }), "BaselineUI-Switch-Knob"),
                  "data-testid": "switch-knob"
                })
              });
            return (0, Ve.jsxs)("label", {
              ...(0, Le.dG)(v, m),
              className: (0, je.AK)(lv({
                labelPosition: n
              }), "BaselineUI-Switch", e),
              style: o,
              ref: l,
              children: [t ? (0, Ve.jsx)("span", {
                className: (0, je.AK)("bpklwad", "BaselineUI-Switch-Label"),
                children: t
              }) : null, (0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ...(0, Le.dG)(d, f),
                  ref: u
                })
              }), r ? (0, Ve.jsxs)("div", {
                className: uv({
                  labelPosition: n
                }),
                children: [(0, Ve.jsx)("span", {
                  className: (0, je.AK)("BaselineUI-Switch-Status-Label", "bpklwa6"),
                  children: c.isSelected ? r.on : r.off
                }), y]
              }) : y]
            });
          });
        cv.displayName = "Switch";
        var dv = hg({
            defaultClassName: "_19n40yy0",
            variantClassNames: {
              size: {
                lg: "_19n40yy1",
                md: "_19n40yy2",
                sm: "_19n40yy3"
              },
              variant: {
                primary: "_19n40yy4",
                ghost: "_19n40yy5"
              },
              isFocused: {
                true: "_19n40yy6"
              },
              hasText: {
                true: "_19n40yy7"
              },
              isDisabled: {
                true: "_19n40yy8"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          pv = {
            sm: $e.W1,
            md: Ke.W1M,
            lg: Ke.W1M
          },
          hv = s.forwardRef(({
            className: e,
            size: t = "md",
            variant: n = "primary",
            ...r
          }, o) => {
            let i = s.useRef(null),
              a = function (e) {
                let [t, n] = (0, l.zk)(fe(e.value), fe(e.defaultValue) || "", e.onChange);
                return {
                  value: t,
                  setValue: n
                };
              }(r),
              {
                inputProps: u,
                clearButtonProps: c
              } = (0, Le.tJ)({
                ...r,
                "aria-haspopup": !1,
                "aria-autocomplete": "none",
                type: "search"
              }, a, i),
              {
                focusProps: d,
                isFocusVisible: p,
                isFocused: h
              } = (0, Le.Fx)({
                within: !0,
                isTextInput: !0
              }),
              f = pv[t],
              m = "sm" === t ? Ze.b0 : Ue.b0,
              g = (0, je.mS)({
                "data-block-id": r["data-block-id"],
                "data-focused": h,
                "data-disabled": r.isDisabled,
                "data-focus-visible": p
              });
            return (0, Ve.jsxs)("div", {
              ...g,
              className: (0, je.AK)(dv({
                size: t,
                isFocused: h,
                variant: n,
                hasText: !!a.value,
                isDisabled: r.isDisabled
              }), "BaselineUI-SearchInput", e),
              ref: o,
              children: [(0, Ve.jsx)(f, {
                size: "sm" === t ? 20 : 24
              }), (0, Ve.jsx)("input", {
                ...(0, Le.dG)(u, d),
                className: "_19n40yy9",
                ref: i
              }), "" !== a.value && (0, Ve.jsx)(nv, {
                icon: m,
                ...c,
                size: "sm" === t ? "xs" : "sm",
                variant: "secondary"
              })]
            });
          });
        function fv(e = window) {
          let [t, n] = (0, s.useState)("light"),
            [r, o] = (0, s.useState)(!1),
            [i, a] = (0, s.useState)(!1),
            [l, u] = (0, s.useState)(!1);
          return (0, s.useEffect)(() => {
            let t = e.matchMedia("(prefers-color-scheme: dark)"),
              r = e => {
                n(e.matches ? "dark" : "light");
              };
            return t.matches && n("dark"), t.addEventListener("change", r), () => {
              t.addEventListener("change", r);
            };
          }, [e]), (0, s.useEffect)(() => {
            let t = e.matchMedia("(prefers-contrast: more)"),
              n = e => {
                o(e.matches);
              };
            return o(t.matches), t.addEventListener("change", n), () => {
              t.addEventListener("change", n);
            };
          }, [e]), (0, s.useEffect)(() => {
            let t = e.matchMedia("(prefers-reduced-motion: reduce)"),
              n = e => {
                a(e.matches);
              };
            return t.matches && a(!0), t.addEventListener("change", n), () => {
              t.addEventListener("change", n);
            };
          }, [e]), (0, s.useEffect)(() => {
            let t = e.matchMedia("(prefers-reduced-transparency: reduce)"),
              n = e => {
                u(e.matches);
              };
            return t.matches && u(!0), t.addEventListener("change", n), () => {
              t.addEventListener("change", n);
            };
          }, [e]), {
            colorScheme: t,
            highContrast: r,
            reducedMotion: i,
            transparency: l
          };
        }
        hv.displayName = "SearchInput";
        var mv = (0, s.createContext)({
            theme: qe.Wb,
            setTheme: () => {}
          }),
          gv = {
            LIGHT: {
              name: "light",
              theme: qe.Wb
            },
            DARK: {
              name: "dark",
              theme: qe.$_
            }
          },
          vv = s.forwardRef(({
            theme: e = "system",
            children: t,
            setTheme: n,
            className: r,
            style: o,
            UNSAFE_domProps: i,
            "data-block-id": a
          }, l) => {
            let {
                direction: u
              } = (0, Le.bU)(),
              {
                colorScheme: c,
                reducedMotion: d,
                highContrast: p,
                transparency: h
              } = fv(),
              {
                name: f,
                theme: m
              } = (0, s.useMemo)(() => {
                switch (e) {
                  case "system":
                    return "light" === c ? gv.LIGHT : gv.DARK;
                  case "light":
                    return gv.LIGHT;
                  case "dark":
                    return gv.DARK;
                  default:
                    return {
                      name: "custom",
                      theme: e
                    };
                }
              }, [c, e]),
              g = {
                "data-theme": f,
                "data-block-id": a,
                "data-reduced-motion": d,
                "data-high-contrast": p,
                "data-transparency": h
              },
              v = (0, s.useMemo)(() => ({
                theme: m,
                setTheme: n
              }), [m, n]);
            return (0, Ve.jsx)(mv.Provider, {
              value: v,
              children: (0, Ve.jsx)("div", {
                ...(0, Le.dG)(i, g),
                className: (0, je.AK)(Lg, "BaselineUI-ThemeProvider", r),
                style: {
                  ...Ye(qe.themeVars, m),
                  ...Ye({
                    "var(--hj25q10)": "rtl" === u ? "-1" : "1"
                  }),
                  ...o
                },
                ref: l,
                children: t
              })
            });
          });
        vv.displayName = "ThemeProvider";
        var yv = s.createContext(void 0),
          bv = ({
            portalContainer: e,
            children: t
          }) => (0, Ve.jsx)(yv.Provider, {
            value: e,
            children: t
          });
        function wv({
          ref: e,
          onIntersect: t,
          isDisabled: n,
          threshold: r,
          rootMargin: o,
          root: i
        }) {
          let a = s.useRef(null);
          (0, s.useEffect)(() => {
            if (n) return a.current?.disconnect(), void (a.current = null);
            a.current = new IntersectionObserver(([e]) => {
              t(e);
            }, {
              root: i?.current,
              rootMargin: o,
              threshold: r
            });
          }, [t, n, i, o, r]), (0, s.useEffect)(() => {
            let {
              current: t
            } = a;
            return e.current && t?.observe(e.current), () => t?.disconnect();
          }, [e]);
        }
        function xv({
          ref: e,
          onResize: t,
          isDisabled: n
        }) {
          let r = s.useRef(null),
            [o, i] = s.useState();
          return s.useEffect(() => {
            if (n) return r.current?.disconnect(), void (r.current = null);
            r.current = new ResizeObserver(([e]) => {
              i(e.contentRect), t?.(e);
            });
          }, [t, n, i]), s.useEffect(() => {
            let {
              current: t
            } = r;
            return e.current && t?.observe(e.current), () => t?.disconnect();
          }, [e]), {
            size: o
          };
        }
        function Dv({
          src: e,
          alt: t
        }) {
          let [n, r] = (0, s.useState)(!1),
            [o, i] = (0, s.useState)(!1),
            [a, l] = (0, s.useState)(!1),
            u = () => {
              r(!0), l(!1);
            },
            c = () => {
              i(!0), l(!1);
            };
          return (0, s.useEffect)(() => {
            if (!e) return;
            l(!0);
            let t = new Image();
            return t.src = e, t.addEventListener("load", u), t.addEventListener("error", c), () => {
              t.removeEventListener("load", u), t.removeEventListener("error", c);
            };
          }, [e]), {
            isLoaded: n,
            hasError: o,
            isLoading: a,
            imgProps: {
              src: n ? e : void 0,
              alt: t
            }
          };
        }
        function Cv() {
          let e = (0, s.useRef)(!0);
          return (0, s.useEffect)(() => {
            e.current = !1;
          }, []), e.current;
        }
        bv.displayName = "PortalContainerProvider";
        var Sv = "SET_STATE",
          Ev = "UNDO",
          _v = "REDO",
          Pv = (e, t) => {
            let {
              past: n,
              present: r,
              future: o
            } = e;
            switch (t.type) {
              case Sv:
                return {
                  past: [...n, r],
                  present: t.data,
                  future: []
                };
              case Ev:
                return {
                  past: n.slice(0, n?.length - 1),
                  present: n[n?.length - 1],
                  future: [r, ...o]
                };
              case _v:
                return {
                  past: [...n, r],
                  present: o[0],
                  future: o.slice(1)
                };
              default:
                throw new Error("Invalid action type");
            }
          },
          kv = (e = {}, {
            isDisabled: t,
            onAction: n
          }) => {
            let r = Cv(),
              [o, i] = (0, s.useReducer)(Pv, {
                past: [],
                present: e,
                future: []
              }),
              {
                past: a,
                present: l,
                future: u
              } = o,
              c = (0, s.useRef)(),
              d = !!a?.length,
              p = !!u?.length;
            return (0, it.useGranularEffect)(() => {
              (c.current === Ev || c.current === _v) && (n?.(l, c.current), c.current = void 0);
            }, [l], [n, r]), {
              state: l,
              push: t ? () => {} : e => {
                i({
                  type: Sv,
                  data: e
                });
              },
              undo: t ? () => {} : () => {
                c.current = Ev, i({
                  type: Ev
                });
              },
              redo: t ? () => {} : () => {
                c.current = _v, i({
                  type: _v
                });
              },
              pastStates: a,
              futureStates: u,
              canUndo: d,
              canRedo: p
            };
          },
          Av = s.createContext({
            messages: {}
          }),
          zv = ({
            children: e,
            messages: t = {},
            ...n
          }) => {
            let r = s.useMemo(() => ({
              messages: t
            }), [t]);
            return (0, Ve.jsx)(Le.bd, {
              ...n,
              children: (0, Ve.jsx)(Av.Provider, {
                value: r,
                children: e
              })
            });
          };
        function Tv(e) {
          let {
            messages: t
          } = (0, s.useContext)(Av);
          !e && st()(t) && console.warn("BUI 🌍: No messages object provided and no messages found in the `I18nProvider`. Please provide a messages object to the `useI18n` hook.");
          let n = (0, Le.hX)(e ? (0, je.gn)(e) : t);
          return {
            formatMessage: (e, t) => {
              if ("object" == typeof e) try {
                return n(e.id, t);
              } catch {
                return console.log(`BUI 🌍: Translation not found for key: \`${e.id.toString()}\`. The default message, i.e. \`${e.defaultMessage}\`, will be used instead.`), e.defaultMessage || e.id;
              } else try {
                return n(e, t);
              } catch {
                return console.log(`BUI 🌍: Translation not found for key: \`${e.toString()}\`. The default message, i.e. \`${e.toString()}\`, will be used instead.`), e;
              }
            },
            locale: (0, Le.bU)()
          };
        }
        zv.displayName = "I18nProvider";
        var Ov = e => e;
        function Iv(e, t, n) {
          let r = s.useRef(null);
          return s.useEffect(() => {
            if (e) return r.current = new MutationObserver(n), r.current.observe(e, t), () => {
              r.current && r.current.disconnect();
            };
          }, [e, t, n]), r.current;
        }
        function Fv(e, t) {
          let [n, r] = (0, s.useState)(() => {
            try {
              let n = window.localStorage.getItem(e);
              return n ? JSON.parse(n) : t;
            } catch (e) {
              return console.log(e), t;
            }
          });
          return [n, t => {
            try {
              let o = t instanceof Function ? t(n) : t;
              r(o), window.localStorage.setItem(e, JSON.stringify(o));
            } catch (e) {
              console.log(e);
            }
          }];
        }
        function Mv({
          ref: e,
          onSelectionChange: t,
          onSelectionEnd: n,
          isDisabled: r
        }) {
          let o = s.useRef(null);
          (0, Le.r7)({
            ref: e,
            isDisabled: r,
            onPressEnd() {
              let t = (0, Be.kR)(e.current).getSelection();
              t && e.current?.contains(t.anchorNode) && n?.(t);
            },
            onPressStart() {
              let t = (0, Be.kR)(e.current);
              o.current = t.getSelection(), o.current && o.current.removeAllRanges();
            }
          }), (0, s.useEffect)(() => {
            let n = e.current;
            if (!n || r) return;
            function o() {
              let r = (0, Be.kR)(n).getSelection();
              r && e.current?.contains(r.anchorNode) && t(r);
            }
            let i = (0, Be.r3)(n);
            return i.addEventListener("selectionchange", o), () => {
              i.removeEventListener("selectionchange", o);
            };
          }, [e, t, r]);
        }
        function Rv(e) {
          let t = (0, s.useCallback)(() => {
              let t = (0, Be.kR)(e ?? document.body),
                n = t.matchMedia(qe.o$.tablet),
                r = t.matchMedia(qe.o$.desktop);
              return n.matches ? "tablet" : r.matches ? "desktop" : "mobile";
            }, [e]),
            [n, r] = s.useState(t);
          return (0, Be.bt)(() => {
            let n = (0, Be.kR)(e),
              o = () => {
                r(t());
              };
            return n.addEventListener("resize", o), o(), () => {
              n.removeEventListener("resize", o);
            };
          }, [e, t]), n;
        }
        function jv(e) {
          let t = (0, s.useContext)(yv);
          return e || t;
        }
        var Bv = hg({
            defaultClassName: "_1mdhlqv3",
            variantClassNames: {
              isOpen: {
                true: "_1mdhlqv4"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Nv = "_1mdhlqv6 _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6d7",
          Lv = hg({
            defaultClassName: "_1mdhlqv0 _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69o _1yep5z69p _1yep5z69q _1yep5z6eu _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6dy",
            variantClassNames: {
              isFocused: {
                false: "_1mdhlqv1"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z6ey"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Vv = s.forwardRef(({
            className: e,
            style: t,
            children: n,
            ...r
          }, o) => {
            let {
              theme: i
            } = (0, s.useContext)(mv);
            return (0, Ve.jsx)(Le.aV, {
              ...r,
              children: (0, Ve.jsx)(vv, {
                ref: o,
                theme: i,
                style: t,
                className: (0, je.AK)("BaselineUI-Portal", e),
                children: n
              })
            });
          });
        Vv.displayName = "Portal";
        var Kv = {
            bottom: "_1gzftth2",
            top: "_1gzftth3",
            right: "_1gzftth4",
            left: "_1gzftth5"
          },
          {
            color: qv
          } = qe.themeVars,
          Hv = s.forwardRef(({
            className: e,
            style: t,
            state: n,
            overlayProps: r,
            underlayClassName: o,
            children: i,
            includeArrow: a = !1,
            offset: l = 2,
            portalContainer: u,
            contentContainerClassName: c,
            contentContainerStyle: d,
            ...p
          }, h) => {
            let f = s.useRef(null),
              m = jv(u),
              g = a ? 8 : 0,
              {
                underlayProps: v,
                popoverProps: y,
                placement: b,
                arrowProps: w
              } = (0, Le.Sv)({
                ...p,
                offset: l + g,
                popoverRef: f,
                containerPadding: p.containerPadding || 0
              }, n),
              x = function ({
                placement: e
              }) {
                let t = (0, Ne.JZ)();
                return (0, Ne.Yz)(!0, {
                  from: {
                    opacity: 0,
                    transform: `translate3d(${"bottom" === e ? "0, 4px, 0" : "0, -4px, 0"})`
                  },
                  enter: {
                    opacity: 1,
                    transform: "translate3d(0, 0, 0)"
                  },
                  immediate: !!t,
                  config: Ne.vc.stiff
                });
              }({
                placement: b
              }),
              D = "center" === b ? "bottom" : b;
            return x((s, l) => l && (0, Ve.jsxs)(Vv, {
              portalContainer: m,
              style: t,
              ref: h,
              children: [!p.isNonModal && (0, Ve.jsx)("div", {
                ...v,
                className: (0, je.AK)("_1gzftth7", o, "BaselineUI-Popover-Underlay")
              }), (0, Ve.jsxs)(Ne.q.div, {
                ...y,
                style: {
                  ...y.style,
                  ...s,
                  ...Ye({
                    "var(--_1gzftth0)": `${p.triggerRef?.current?.offsetWidth}px`
                  })
                },
                ref: (0, Be.lq)(f, h),
                className: (0, je.AK)("_1gzftth1 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2", "BaselineUI-Popover-Content", e),
                "data-placement": ["top", "bottom", "left", "right"].filter(e => b?.includes(e)),
                children: [a ? (0, Ve.jsxs)("svg", {
                  className: (0, je.AK)(Kv[D], "BaselineUI-PopoverContent-Arrow"),
                  ...w,
                  style: {
                    ...w.style,
                    position: "absolute"
                  },
                  width: "15",
                  height: "9",
                  viewBox: "0 0 15 9",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                  children: [(0, Ve.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M.019 0h1.228l6.272 7.237L13.791 0h1.228v1h-.772L7.519 8.763.791 1H.019V0Z",
                    fill: qv.border.medium
                  }), (0, Ve.jsx)("path", {
                    d: "M7.504 6.492 2.248.488h10.511L10.132 3.49 7.504 6.492Z",
                    fill: qv.background.primary.subtle,
                    stroke: qv.background.primary.subtle
                  })]
                }) : null, (0, Ve.jsx)(Le.U4, {
                  onDismiss: n.close
                }), (0, Ve.jsx)("div", {
                  ...r,
                  style: d,
                  className: (0, je.AK)("_1gzftth6", c),
                  children: i
                }), (0, Ve.jsx)(Le.U4, {
                  onDismiss: n.close
                })]
              })]
            }));
          });
        Hv.displayName = "PopoverContentCore";
        var Uv = ({
          section: e,
          showSelectedIcon: t,
          state: n
        }) => {
          let {
            itemProps: r,
            groupProps: o,
            headingProps: i
          } = (0, Le.x7)({
            heading: e.value?.title,
            "aria-label": e["aria-label"]
          });
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [e.key !== n.collection.getFirstKey() && (0, Ve.jsx)(yg, {
              elementType: "li"
            }), (0, Ve.jsxs)("li", {
              ...r,
              children: [e.value?.title ? (0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("span", {
                  ...i,
                  children: e.value.title
                })
              }) : null, (0, Ve.jsx)("ul", {
                ...o,
                className: "xyd2ss0 _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z64l _1yep5z64m _1yep5z64n _1yep5z629 _1yep5z62a _1yep5z62b",
                children: [...e.childNodes].map(e => ((0, je.kG)("item" === e.type), (0, Ve.jsx)(Zv, {
                  item: e,
                  state: n,
                  showSelectedIcon: t
                }, e.key)))
              })]
            })]
          });
        };
        Uv.displayName = "MenuSection";
        var Zv = ({
          item: e,
          state: t,
          className: n,
          showSelectedIcon: r
        }) => {
          let o = s.useRef(null),
            i = (0, Le.iX)({
              key: e.key
            }, t, o),
            {
              isFocusVisible: a,
              focusProps: l
            } = (0, Le.Fx)();
          return (0, Ve.jsx)(xg, {
            item: e,
            liProps: (0, Le.dG)(i.menuItemProps, l, {
              className: n
            }),
            ...i,
            isFocusVisible: a,
            ref: o,
            description: e.value?.keyboardShortcut,
            descriptionProps: i.keyboardShortcutProps,
            _state: t,
            showSelectedIcon: r
          });
        };
        Zv.displayName = "MenuItem";
        var $v = s.forwardRef(({
          className: e,
          itemClassName: t,
          onContentKeyDown: n,
          ...r
        }, o) => {
          let i = Re(r),
            a = s.useRef(null),
            {
              menuProps: l
            } = (0, Le.H9)(r, i, a),
            {
              keyboardProps: u
            } = (0, Le.v5)({
              onKeyDown: n
            });
          return (0, Ve.jsx)("ul", {
            ...(0, Le.dG)(l, u),
            className: (0, je.AK)("xyd2ss1 _1yep5z613 _1yep5z614 _1yep5z615 _1yep5z63f _1yep5z63g _1yep5z63h _1yep5z64l _1yep5z64m _1yep5z64n _1yep5z629 _1yep5z62a _1yep5z62b _1yep5z65r _1yep5z65s _1yep5z65t _1yep5z683 _1yep5z684 _1yep5z685 _1yep5z699 _1yep5z69a _1yep5z69b _1yep5z66x _1yep5z66y _1yep5z66z _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6l0 _1yep5z6kz _1yep5z6he _1yep5z6l3 _1yep5z6fs", e),
            ref: (0, Be.lq)(a, o),
            children: [...i.collection].map(e => "section" === e.type ? (0, Ve.jsx)(Uv, {
              section: e,
              state: i,
              showSelectedIcon: "multiple" === r.selectionMode || "single" === r.selectionMode
            }, e.key) : (0, Ve.jsx)(Zv, {
              item: e,
              state: i,
              className: t,
              showSelectedIcon: "multiple" === r.selectionMode || "single" === r.selectionMode
            }, e.key))
          });
        });
        $v.displayName = "MenuContent";
        var Gv = s.forwardRef(({
          isDisabled: e,
          contentClassName: t,
          state: n,
          placement: r = "bottom start",
          isNonModal: o,
          shouldFlip: i,
          shouldUpdatePosition: a,
          boundaryElement: l,
          crossOffset: u,
          offset: c,
          triggerButton: d,
          triggerLabel: p,
          renderTrigger: h = ({
            buttonProps: e,
            ref: t
          }) => (0, Ve.jsx)(Bg, {
            ...e,
            variant: "popover",
            ref: t
          }),
          portalContainer: f,
          ...m
        }, g) => {
          let v = s.useRef(null),
            y = jv(f),
            {
              menuTriggerProps: b,
              menuProps: w
            } = (0, Le.u4)({
              isDisabled: e,
              type: "menu"
            }, n, v),
            x = (0, s.useMemo)(() => (0, Le.dG)(b, {
              isDisabled: e,
              isSelected: n.isOpen,
              className: "BaselineUI-Menu-Trigger",
              label: p
            }), [b, e, n.isOpen, p]);
          return (0, s.useEffect)(() => {
            d && console.warn("The `children` prop to pass trigger button is deprecated. Use `renderTrigger` instead. The `children` prop will be removed in the next major version.");
          }, [d]), (0, s.useEffect)(() => {
            !p && !h && !d && console.warn("The `triggerLabel` prop is required when no `renderTrigger` or `children` is provided.");
          }, [h, d, p]), (0, Ve.jsxs)(Ve.Fragment, {
            children: [d ? (0, Ve.jsx)(Je, {
              ...x,
              ref: v,
              children: d
            }) : h({
              buttonProps: x,
              ref: v
            }), n.isOpen ? (0, Ve.jsx)(Hv, {
              triggerRef: v,
              state: n,
              placement: r,
              isNonModal: o,
              shouldFlip: i,
              shouldUpdatePosition: a,
              boundaryElement: l,
              crossOffset: u,
              offset: c || 2,
              className: (0, je.AK)(Nv, "BaselineUI-Menu-Popover"),
              portalContainer: y,
              children: (0, Ve.jsx)($v, {
                className: t,
                ...w,
                ...m,
                ref: g,
                autoFocus: n.focusStrategy || "first"
              })
            }) : null]
          });
        });
        Gv.displayName = "MenuRoot";
        var Wv = s.forwardRef((e, t) => {
          let n = e.children;
          return (0, Ve.jsx)(Gv, {
            ...e,
            ref: t,
            triggerButton: n,
            children: e => "type" in e && "section" === e.type ? (0, Ve.jsx)(c.$0, {
              items: e.children,
              title: e.title,
              children: e => (0, Ve.jsx)(c.ck, {
                children: e.label
              }, e.id)
            }, e.id) : ((0, je.kG)("label" in e, "Item doesn't have a label"), (0, Ve.jsx)(c.ck, {
              textValue: e.label,
              children: e.label
            }, e.id))
          });
        });
        Wv.displayName = "MenuBase";
        var Yv = s.forwardRef(({
          defaultOpen: e,
          isOpen: t,
          onOpenChange: n,
          ...r
        }, o) => {
          let i = le({
            defaultOpen: e,
            isOpen: t,
            onOpenChange: n
          });
          return (0, Ve.jsx)(Wv, {
            ...r,
            state: i,
            ref: o
          });
        });
        Yv.displayName = "Menu";
        var Xv = hg({
            defaultClassName: "_13f0naj0",
            variantClassNames: {
              variant: {
                default: "_13f0naj1",
                inline: "_13f0naj2"
              },
              isHovered: {
                true: "_13f0naj3"
              },
              isFocusVisible: {
                true: "_13f0naj4"
              },
              isDisabled: {
                true: "_13f0naj5"
              },
              size: {
                sm: "_13f0naj6",
                md: "_13f0naj7",
                lg: "_13f0naj8"
              },
              type: {
                body: "_13f0naj9",
                label: "_13f0naja"
              },
              isActive: {
                true: "_13f0najb"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isActive: !0,
              isDisabled: !1
            }, "_13f0najc"], [{
              type: "body",
              size: "sm"
            }, "_13f0najd"], [{
              type: "body",
              size: "md"
            }, "_13f0naje"], [{
              type: "body",
              size: "lg"
            }, "_13f0najf"], [{
              type: "label",
              size: "sm"
            }, "_13f0najg"], [{
              type: "label",
              size: "md"
            }, "_13f0najh"], [{
              type: "label",
              size: "lg"
            }, "_13f0naji"]]
          }),
          Qv = s.forwardRef(({
            className: e,
            style: t,
            children: n,
            variant: r = "default",
            size: o = "md",
            elementType: i = "a",
            type: a = "body",
            "data-block-id": l,
            title: u,
            ...c
          }, d) => {
            let p = s.useRef(null),
              {
                linkProps: h,
                isPressed: f
              } = (0, Le.nB)({
                ...c,
                elementType: c.onPress ? "span" : i
              }, p),
              {
                isFocusVisible: m,
                isFocused: g,
                focusProps: v
              } = (0, Le.Fx)(),
              {
                hoverProps: y,
                isHovered: b
              } = (0, Le.XI)({
                isDisabled: c.isDisabled
              }),
              w = i,
              x = (0, je.mS)({
                "data-block-id": l,
                "data-disabled": c.isDisabled,
                "data-focused": g,
                "data-pressed": f,
                "data-focus-visible": m,
                "data-hovered": b,
                title: u
              });
            return (0, Ve.jsx)(w, {
              ...(0, Le.dG)(h, v, y, x),
              className: (0, je.AK)(Xv({
                variant: r,
                isFocusVisible: m,
                isHovered: b,
                isDisabled: c.isDisabled,
                size: o,
                isActive: f,
                type: a
              }), "BaselineUI-Link", e),
              ref: (0, Be.lq)(p, d),
              style: t,
              children: n
            });
          });
        async function Jv({
          items: e
        }) {
          let t = e.filter(e => "file" === e.kind).map(async e => ((0, je.kG)("file" === e.kind), e.getFile()));
          return await Promise.all(t);
        }
        Qv.displayName = "Link";
        var ey = hg({
            defaultClassName: "_180w5ed0",
            variantClassNames: {
              variant: {
                default: "_180w5ed1",
                inline: "_180w5ed2"
              },
              hoveredOrFocusedOrActive: {
                true: "_180w5ed3"
              },
              disabled: {
                true: "_180w5ed4"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "inline",
              hoveredOrFocusedOrActive: !0
            }, "_180w5ed5"], [{
              variant: "default",
              hoveredOrFocusedOrActive: !0
            }, "_180w5ed6"], [{
              variant: "default",
              disabled: !0
            }, "_180w5ed7"], [{
              variant: "inline",
              disabled: !0
            }, "_180w5ed8"]]
          }),
          ty = hg({
            defaultClassName: "_180w5ede",
            variantClassNames: {
              disabled: {
                true: "_180w5edf"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ny = hg({
            defaultClassName: "_180w5ed9",
            variantClassNames: {
              disabled: {
                true: "_180w5eda"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ry = hg({
            defaultClassName: "_180w5edb",
            variantClassNames: {
              disabled: {
                true: "_180w5edc"
              },
              hovered: {
                true: "_180w5edd"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          oy = s.forwardRef(({
            className: e,
            label: t,
            description: n,
            icon: r,
            variant: o = "default",
            ...i
          }, a) => {
            let l = s.useRef(null),
              {
                inputProps: u,
                descriptionProps: c,
                labelProps: d
              } = function ({
                isDisabled: e,
                onValueChange: t,
                onChange: n,
                name: r,
                "aria-describedby": o,
                "aria-label": i,
                accept: a,
                multiple: s
              }) {
                let l = (0, Le.Me)(),
                  u = (0, Le.Me)(),
                  c = (0, Le.Me)();
                return {
                  inputProps: {
                    type: "file",
                    id: u,
                    disabled: !!e,
                    "aria-labelledby": i ? void 0 : l,
                    "aria-describedby": o || c,
                    "aria-label": i,
                    onChange: e => {
                      let r = [...(e.target.files || [])];
                      t?.(r), n?.(e);
                    },
                    name: r,
                    accept: a,
                    multiple: s
                  },
                  labelProps: {
                    htmlFor: u,
                    id: l
                  },
                  descriptionProps: {
                    id: c
                  }
                };
              }(i),
              {
                dropProps: p
              } = (0, Le.LW)({
                ref: l,
                onDrop: async ({
                  items: e
                }) => {
                  let t = e.filter(e => "file" === e.kind).map(async e => ((0, je.kG)("file" === e.kind), e.getFile())),
                    n = await Promise.all(t);
                  i.onValueChange?.(n);
                }
              }),
              {
                focusProps: h,
                isFocusVisible: f
              } = (0, Le.Fx)(),
              {
                hoverProps: m,
                isHovered: g
              } = (0, Le.XI)({
                isDisabled: i.isDisabled
              });
            return (0, Ve.jsxs)("label", {
              ...(0, Le.dG)(p, m, d),
              className: (0, je.AK)(ey({
                variant: o,
                disabled: i.isDisabled,
                hoveredOrFocusedOrActive: g || f
              }), e),
              ref: (0, Be.lq)(a, l),
              children: [(0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ...(0, Le.dG)(h, u)
                })
              }), r ? (0, Ve.jsx)(r, {
                size: 20,
                className: ny({
                  disabled: i.isDisabled
                })
              }) : null, (0, Ve.jsxs)("div", {
                children: [(0, Ve.jsx)("div", {
                  className: ry({
                    disabled: i.isDisabled,
                    hovered: g
                  }),
                  children: t
                }), n ? (0, Ve.jsx)("div", {
                  ...c,
                  className: ty({
                    disabled: i.isDisabled
                  }),
                  children: n
                }) : null]
              })]
            });
          });
        oy.displayName = "FileUpload";
        var iy = hg({
            defaultClassName: "_12vfhl48",
            variantClassNames: {
              variant: {
                success: "_12vfhl49",
                error: "_12vfhl4a",
                active: "_12vfhl4b"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ay = hg({
            defaultClassName: "_12vfhl43 _12vfhl42",
            variantClassNames: {
              hasLabel: {
                false: "_12vfhl44"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          sy = s.forwardRef(({
            className: e,
            variant: t = "active",
            showValue: n,
            description: r,
            errorMessage: o,
            ...i
          }, a) => {
            let s = (0, Le.Me)(),
              {
                labelProps: l,
                progressBarProps: u
              } = (0, Le.D6)({
                ...i,
                "aria-describedby": r ? s : i["aria-describedby"]
              }),
              {
                minValue: c = 0,
                maxValue: d = 100,
                value: p = 0,
                label: h
              } = i,
              f = (p - c) / (d - c),
              m = `${Math.round(100 * f)}%`,
              g = (0, Ve.jsx)("output", {
                className: ay({
                  hasLabel: !!h
                }),
                children: u["aria-valuetext"]
              }),
              v = "error" === t ? o : r;
            return (0, Ve.jsxs)("div", {
              ...u,
              className: (0, je.AK)("_12vfhl40 z9nup81", e),
              ref: a,
              children: [h ? (0, Ve.jsxs)("div", {
                className: "_12vfhl41 z9nup82",
                children: [(0, Ve.jsx)("label", {
                  ...l,
                  className: "_12vfhl42",
                  children: h
                }), n ? g : null]
              }) : null, (0, Ve.jsxs)("div", {
                className: "_12vfhl45",
                children: [(0, Ve.jsxs)("div", {
                  className: "_12vfhl46 z9nup82",
                  children: [(0, Ve.jsx)("div", {
                    className: "_12vfhl47",
                    children: (0, Ve.jsx)("div", {
                      style: {
                        width: m
                      },
                      className: iy({
                        variant: t
                      })
                    })
                  }), !h && n ? g : null]
                }), v ? (0, Ve.jsx)("div", {
                  className: Zg({
                    hasError: "error" === t
                  }),
                  id: s,
                  children: v
                }) : null]
              })]
            });
          });
        function ly({
          isReadOnly: e,
          validationState: t
        }) {
          return e ? Ue.CP : "error" === t ? Ue.Rv : "warning" === t ? Ue.av : null;
        }
        sy.displayName = "ProgressBar";
        var uy = s.forwardRef(({
          className: e,
          validationState: t = "valid",
          variant: n = "primary",
          style: r,
          labelPosition: o = "top",
          inputStyle: i,
          inputClassName: a,
          "data-block-id": l,
          ...u
        }, c) => {
          let d = s.useRef(null),
            {
              inputProps: p,
              labelProps: h,
              descriptionProps: f,
              errorMessageProps: m,
              validationErrors: g
            } = (0, Le.hR)({
              ...u,
              validationState: "error" === t ? "invalid" : "valid"
            }, d),
            v = u.errorMessage || g.join(" "),
            y = Jg({
              ...u,
              errorMessage: v,
              descriptionProps: f,
              errorMessageProps: m,
              labelPosition: o
            });
          v && (t = "error");
          let {
              hoverProps: b,
              isHovered: w
            } = (0, Le.XI)({
              isDisabled: u.isDisabled
            }),
            {
              isFocused: x,
              focusProps: D,
              isFocusVisible: C
            } = (0, Le.Fx)(),
            S = ly({
              isReadOnly: u.isReadOnly,
              validationState: t
            }),
            E = (0, je.mS)({
              "data-readonly": u.isReadOnly,
              "data-disabled": u.isDisabled,
              "data-validation-state": t,
              "data-focused": x,
              "data-focus-visible": C
            });
          return (0, Ve.jsxs)("div", {
            className: (0, je.AK)(Xg({
              labelPosition: o
            }), "BaselineUI-TextInput", e),
            "data-block-id": l,
            style: r,
            ref: c,
            children: [u.label || "start" === o && y ? (0, Ve.jsxs)("div", {
              className: Yg({
                labelPosition: o,
                hasMessage: !!y
              }),
              children: [(0, Ve.jsx)("label", {
                ...h,
                className: Wg,
                children: u.label
              }), "start" === o && y]
            }) : null, (0, Ve.jsxs)("div", {
              className: (0, je.AK)({
                [Vg]: u.isDisabled
              }),
              children: [(0, Ve.jsxs)("div", {
                ...b,
                className: Qg({
                  validationState: t,
                  isHovered: w,
                  isFocused: x,
                  variant: n,
                  isReadOnly: !!u.isReadOnly,
                  isDisabled: !!u.isDisabled
                }),
                children: [(0, Ve.jsx)("input", {
                  ...(0, Le.dG)(p, D, E),
                  className: (0, je.AK)($g({
                    isDisabled: u.isDisabled,
                    labelPosition: o
                  }), "BaselineUI-TextInput-Input", a),
                  style: i,
                  ref: d
                }), S ? (0, Ve.jsx)(S, {
                  className: Gg({
                    validationState: t,
                    isReadOnly: u.isReadOnly
                  }),
                  size: 16
                }) : null]
              }), "top" === o && y]
            })]
          });
        });
        uy.displayName = "TextInput";
        var cy = ({
          value: e,
          ...t
        }) => {
          let n = (0, Le.Ux)(t);
          return (0, Ve.jsx)(Ve.Fragment, {
            children: n.format(e)
          });
        };
        cy.displayName = "NumberFormat";
        var dy = hg({
            defaultClassName: "_9b1tml0",
            variantClassNames: {
              isSelected: {
                true: "_9b1tml1",
                false: "_9b1tml2"
              },
              isDisabled: {
                true: "z9nup83"
              },
              isHovered: {
                true: "_9b1tml4"
              },
              isFocusVisible: {
                true: "_9b1tml5"
              },
              isReadOnly: {
                true: "_9b1tml6"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isFocusVisible: !0,
              isReadOnly: !1
            }, "_9b1tml7"], [{
              isSelected: !0,
              isHovered: !0,
              isDisabled: !1,
              isReadOnly: !1
            }, "_9b1tml8"], [{
              isSelected: !1,
              isHovered: !0,
              isDisabled: !1,
              isReadOnly: !1
            }, "_9b1tml9"], [{
              isSelected: !0,
              isDisabled: !0
            }, "_9b1tmla"], [{
              isSelected: !0,
              isReadOnly: !0
            }, "_9b1tmlb"]]
          }),
          py = hg({
            defaultClassName: "_9b1tmlf",
            variantClassNames: {
              isSelected: {
                true: "_9b1tmlg"
              },
              size: {
                sm: "_9b1tmlh",
                md: "_9b1tmli"
              },
              isDisabled: {
                true: "_9b1tmlj"
              },
              isReadOnly: {
                true: "_9b1tmlk"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isDisabled: !1,
              isReadOnly: !1
            }, "_9b1tmll"], [{
              isSelected: !0,
              isDisabled: !0
            }, "_9b1tmlm"], [{
              isSelected: !1,
              isDisabled: !0
            }, "_9b1tmln"]]
          }),
          hy = hg({
            defaultClassName: "_9b1tmlc",
            variantClassNames: {
              isDisabled: {
                true: "_9b1tmld"
              },
              isReadOnly: {
                true: "_9b1tmle"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          fy = s.forwardRef(({
            className: e,
            count: t,
            style: n,
            size: r = "md",
            icon: o,
            ...i
          }, a) => {
            let l = {
                isRequired: !1
              },
              u = o || ("md" === r ? $e.KM : Ue.KM);
            !i["aria-label"] && !i["aria-labelledby"] && console.warn("You must provide either an `aria-label` or `aria-labelledby` prop to the `Reaction` component.");
            let c = s.useRef(null),
              d = (0, _e.l)({
                ...i,
                ...l
              }),
              {
                inputProps: p,
                isPressed: h,
                isDisabled: f,
                isReadOnly: m,
                isSelected: g
              } = (0, Le.h9)({
                ...i,
                ...l
              }, d, c),
              {
                focusProps: v,
                isFocused: y,
                isFocusVisible: b
              } = (0, Le.Fx)(),
              {
                hoverProps: w,
                isHovered: x
              } = (0, Le.XI)({});
            return (0, Ve.jsxs)("label", {
              ref: a,
              style: n,
              className: (0, je.AK)("_1yep5z6i3 _1yep5z6i4 _1yep5z6i5", "BaselineUI-Reaction", e),
              "data-block-id": i["data-block-id"],
              "data-focused": y,
              "data-focus-visible": b,
              "data-disabled": f,
              "data-hovered": x,
              "data-pressed": h,
              "data-selected": g,
              children: [(0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ...p,
                  ...v,
                  ref: c
                })
              }), (0, Ve.jsxs)("div", {
                ...w,
                className: dy({
                  isSelected: g,
                  isFocusVisible: b,
                  isHovered: x,
                  isReadOnly: m,
                  isDisabled: f
                }),
                children: [(0, Ve.jsx)("div", {
                  className: hy({
                    isDisabled: f,
                    isReadOnly: m
                  }),
                  children: (0, Ve.jsx)(u, {
                    size: "md" === r ? 20 : 16
                  })
                }), (0, Ve.jsx)("div", {
                  className: py({
                    isSelected: d.isSelected,
                    isDisabled: f,
                    isReadOnly: m,
                    size: r
                  }),
                  children: (0, Ve.jsx)(cy, {
                    value: t
                  })
                })]
              })]
            });
          });
        fy.displayName = "Reaction";
        var my = hg({
            defaultClassName: "_1jwycy80",
            variantClassNames: {
              placement: {
                bottom: "_1jwycy81",
                left: "_1jwycy82",
                right: "_1jwycy83",
                top: "_1jwycy84"
              },
              variant: {
                default: "_1jwycy85",
                inverse: "_1jwycy86"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          gy = hg({
            defaultClassName: "_1jwycy87 _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn",
            variantClassNames: {
              size: {
                md: "_1yep5z63u _1yep5z63v _1yep5z63w _1yep5z61i _1yep5z61j _1yep5z61k _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z6e7",
                sm: "_1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6dv"
              },
              variant: {
                default: "_1yep5z6g0 _1yep5z6ez",
                inverse: "_1yep5z6d7 _1yep5z6fs _1yep5z6eu"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          vy = s.forwardRef(({
            children: e,
            state: t,
            overlayProps: n,
            arrowProps: r,
            placement: o,
            variant: i,
            size: a,
            tooltipProps: l,
            includeArrow: u
          }, c) => {
            let {
                tooltipProps: d
              } = (0, Le.lL)({
                isOpen: t.isOpen
              }, t),
              p = (0, s.useMemo)(() => {
                switch (o) {
                  case "top":
                    return {
                      x: 0,
                      y: 4
                    };
                  case "bottom":
                    return {
                      x: 0,
                      y: -4
                    };
                  case "left":
                    return {
                      x: 4,
                      y: 0
                    };
                  case "right":
                    return {
                      x: -4,
                      y: 0
                    };
                  default:
                    return {
                      x: 0,
                      y: 0
                    };
                }
              }, [o]),
              h = (0, Ne.JZ)(),
              [f] = (0, Ne.q_)(() => ({
                from: {
                  opacity: 0,
                  transform: `translate(${p.x}px, ${p.y}px)`
                },
                to: {
                  opacity: 1,
                  transform: "translate(0, 0)"
                },
                immediate: !!h
              })),
              m = "center" === o ? "bottom" : o;
            return (0, Ve.jsxs)(Ne.q.span, {
              ...n,
              style: {
                ...f,
                ...n.style
              },
              ref: c,
              "data-placement": m,
              children: [u ? (0, Ve.jsx)("div", {
                className: my({
                  placement: m,
                  variant: i
                }),
                ...r
              }) : null, (0, Ve.jsx)("div", {
                ...(0, Le.dG)(d, l),
                className: gy({
                  variant: i,
                  size: a
                }),
                children: e
              })]
            });
          });
        vy.displayName = "TooltipContent";
        var yy = s.forwardRef(({
          children: e,
          placement: t = "bottom",
          delay: n = 1e3,
          closeDelay: r = 500,
          variant: o = "default",
          size: i = "md",
          includeArrow: a = !0,
          portalContainer: l,
          ...u
        }, c) => {
          let d = s.useRef(null),
            p = s.useRef(null),
            h = !u.text || u.isDisabled,
            f = Fe({
              ...u,
              delay: n,
              closeDelay: r,
              isDisabled: h
            }),
            {
              triggerProps: m,
              tooltipProps: g
            } = (0, Le.QM)({
              ...u,
              isDisabled: h,
              delay: n,
              closeDelay: r
            }, f, d),
            v = jv(l),
            {
              overlayProps: y,
              arrowProps: b,
              placement: w,
              updatePosition: x
            } = (0, Le.tN)({
              arrowSize: a ? 13 : 0,
              targetRef: d,
              arrowBoundaryOffset: a ? 8 : 0,
              offset: a ? 12 : 2,
              overlayRef: p,
              placement: t,
              isOpen: f.isOpen,
              ...u
            });
          return wv({
            ref: p,
            threshold: 1,
            onIntersect: x,
            isDisabled: !f.isOpen
          }), xv({
            ref: d,
            onResize: x,
            isDisabled: !f.isOpen
          }), (0, Ve.jsxs)(lt.tB, {
            ...m,
            ref: d,
            children: [e, f.isOpen ? (0, Ve.jsx)(Vv, {
              disableFocusManagement: !0,
              portalContainer: v,
              children: (0, Ve.jsx)(vy, {
                ref: (0, Be.lq)(c, p),
                state: f,
                arrowProps: b,
                overlayProps: y,
                placement: w,
                tooltipProps: g,
                variant: o,
                size: i,
                includeArrow: a,
                children: u.text
              })
            }) : null]
          });
        });
        yy.displayName = "Tooltip";
        var by = {
            sm: 16,
            md: 20
          },
          wy = {
            sm: [Ue.gq, Ue.rx],
            md: [$e.gq, $e.rx]
          },
          xy = s.forwardRef(({
            className: e,
            style: t,
            size: n = "md",
            variant: r = "active",
            ...o
          }, i) => {
            let {
                labelProps: a,
                progressBarProps: s
              } = (0, Le.D6)({
                ...o,
                isIndeterminate: !0
              }),
              l = by[n],
              u = l / 2 - 2,
              c = 2 * u * Math.PI,
              d = wy[n]["success" === r ? 0 : 1];
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)("_1azy5681 z9nup82", e),
              ref: i,
              style: {
                ...Ye({
                  "var(--_1azy5680)": `${c}px`
                }),
                ...t
              },
              children: [(0, Ve.jsxs)("div", {
                ...s,
                className: "_1azy5682",
                children: [("active" === r || "inactive" === r) && (0, Ve.jsxs)("svg", {
                  height: l,
                  width: l,
                  viewBox: `0 0 ${l} ${l}`,
                  children: [(0, Ve.jsx)("circle", {
                    role: "presentation",
                    className: "_1azy5686",
                    cx: l / 2,
                    cy: l / 2,
                    r: u
                  }), "active" === r && (0, Ve.jsx)("circle", {
                    role: "presentation",
                    className: "_1azy5685",
                    cx: l / 2,
                    cy: l / 2,
                    r: u
                  })]
                }), "success" === r && (0, Ve.jsx)(d, {
                  className: "_1azy5687",
                  size: l
                }), "error" === r && (0, Ve.jsx)(d, {
                  className: "_1azy5688",
                  size: l
                })]
              }), o.label ? (0, Ve.jsx)("span", {
                ...a,
                className: "_1azy5689",
                children: o.label
              }) : null]
            });
          });
        xy.displayName = "ProgressSpinner";
        var Dy = hg({
            defaultClassName: "_5uw3kp0 oom8bs0 z9nup82",
            variantClassNames: {
              isHovered: {
                true: "_5uw3kp1"
              },
              isFocusVisible: {
                true: "_5uw3kp2"
              },
              isDisabled: {
                true: "_5uw3kp3"
              },
              isSelected: {
                true: "_5uw3kp4"
              },
              size: {
                sm: "_5uw3kp5",
                md: "_5uw3kp6",
                lg: "_5uw3kp7"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isFocusVisible: !0
            }, "_5uw3kp8"], [{
              isSelected: !0,
              isDisabled: !0
            }, "_5uw3kp9"]]
          }),
          Cy = {
            sm: 16,
            md: 20,
            lg: 24
          },
          Sy = s.forwardRef(({
            className: e,
            style: t,
            iconStart: n,
            size: r = "md",
            elementType: o = "button",
            ...i
          }, a) => {
            let s = (0, _e.l)(i),
              {
                buttonProps: l,
                isPressed: u,
                ref: c
              } = Mg(i, s),
              {
                hoverProps: d,
                isHovered: p
              } = (0, Le.XI)({
                isDisabled: i.isDisabled
              }),
              {
                isFocusVisible: h,
                isFocused: f,
                focusProps: m
              } = (0, Le.Fx)(),
              g = (0, je.mS)({
                "data-block-id": i["data-block-id"],
                "data-focused": f,
                "data-focus-visible": h,
                "data-disabled": i.isDisabled,
                "data-hovered": p,
                "data-pressed": u,
                "data-selected": s.isSelected
              });
            return (0, Ve.jsxs)(o, {
              ...(0, Le.dG)(l, d, m, g),
              className: (0, je.AK)(Dy({
                isHovered: p,
                isFocusVisible: h,
                isSelected: s.isSelected,
                size: r,
                isDisabled: i.isDisabled
              }), "BaselineUI-ToggleButton", e),
              style: t,
              ref: (0, Be.lq)(c, a),
              children: [n ? (0, Ve.jsx)(n, {
                size: Cy[r]
              }) : null, i.label]
            });
          });
        Sy.displayName = "ToggleButton";
        var Ey = hg({
            defaultClassName: "_16vugd0e",
            variantClassNames: {
              isDisabled: {
                true: "_16vugd0f"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          _y = hg({
            defaultClassName: "_16vugd01 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              labelPosition: {
                end: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6ut _1yep5z6uu _1yep5z6uv",
                start: "_1yep5z613q _1yep5z613r _1yep5z613s _1yep5z6152 _1yep5z6153 _1yep5z6154"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Py = hg({
            defaultClassName: "_16vugd05",
            variantClassNames: {
              isIndeterminate: {
                true: "_16vugd04"
              },
              isSelected: {
                true: "_16vugd04"
              },
              isFocusVisible: {
                true: "_16vugd08"
              },
              isHovered: {
                true: "_16vugd09"
              },
              isDisabled: {
                true: "_16vugd0a"
              },
              isReadOnly: {
                true: "_16vugd0b"
              },
              hasError: {
                true: "_16vugd0c"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isDisabled: !0
            }, "_16vugd0d"]]
          }),
          ky = s.forwardRef(({
            className: e,
            style: t,
            label: n,
            labelPosition: r = "end",
            "data-block-id": o,
            ...i
          }, a) => {
            let l = s.useRef(null),
              u = (0, _e.l)(i),
              {
                isFocusVisible: c,
                isFocused: d,
                focusProps: p
              } = (0, Le.Fx)(),
              {
                inputProps: h,
                isPressed: f,
                isDisabled: m,
                isSelected: g,
                isReadOnly: v
              } = (0, Le.O)({
                ...i,
                children: n
              }, u, l),
              {
                hoverProps: y,
                isHovered: b
              } = (0, Le.XI)({
                isDisabled: m
              }),
              w = (0, je.mS)({
                "data-disabled": m,
                "data-readonly": v,
                "data-hovered": b,
                "data-selected": g,
                "data-pressed": f,
                "data-indeterminate": i.isIndeterminate,
                "data-invalid": i.isInvalid,
                "data-focus-visible": c,
                "data-focused": d,
                "data-block-id": o
              });
            return (0, Ve.jsxs)("label", {
              ...w,
              className: (0, je.AK)(_y({
                labelPosition: r
              }), "BaselineUI-Checkbox", e),
              style: t,
              ref: a,
              children: [(0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ...(0, Le.dG)(h, p),
                  ref: l
                })
              }), (0, Ve.jsxs)("div", {
                ...y,
                className: Py({
                  isSelected: g && !i.isIndeterminate,
                  isIndeterminate: i.isIndeterminate,
                  isFocusVisible: c,
                  isDisabled: m,
                  isReadOnly: v,
                  hasError: i.isInvalid,
                  isHovered: b
                }),
                children: [g && !i.isIndeterminate ? (0, Ve.jsx)(Ze.KM, {
                  size: 12
                }) : null, i.isIndeterminate ? (0, Ve.jsx)(Ze.V_, {
                  size: 12
                }) : null]
              }), n ? (0, Ve.jsx)("span", {
                className: Ey({
                  isDisabled: m
                }),
                children: n
              }) : null]
            });
          });
        ky.displayName = "Checkbox";
        var Ay = {
            ar: {
              goToPage: "انتقال إلى صفحة",
              nextPage: "الصفحة التالية",
              pageXofY: "صفحة {arg0} من {arg1}",
              prevPage: "الصفحة السابقة"
            },
            cs: {
              goToPage: "Přejít na stranu",
              nextPage: "Další stránka",
              pageXofY: "Strana {arg0} z {arg1}",
              prevPage: "Předchozí strana"
            },
            cy: {
              goToPage: "Mynd i Dudalen",
              nextPage: "Tudalen Nesaf",
              pageXofY: "Tudalen {arg0} o {arg1}",
              prevPage: "Tudalen Blaenorol"
            },
            da: {
              goToPage: "Gå til side",
              nextPage: "Næste side",
              pageXofY: "Side {arg0} af {arg1}",
              prevPage: "Forrige side"
            },
            de: {
              goToPage: "Zu Seite wechseln",
              nextPage: "Nächste Seite",
              pageXofY: "Seite {arg0} von {arg1}",
              prevPage: "Vorherige Seite"
            },
            el: {
              goToPage: "Μετάβαση στη σελίδα",
              nextPage: "Επόμενη σελίδα",
              pageXofY: "Σελίδα {arg0} από {arg1}",
              prevPage: "Προηγούμενη σελίδα"
            },
            "en-GB": {
              goToPage: "Go to Page",
              nextPage: "Next Page",
              pageXofY: "Page {arg0} of {arg1}",
              prevPage: "Previous Page"
            },
            en: {
              goToPage: "Go to Page",
              nextPage: "Next Page",
              pageXofY: "Page {arg0} of {arg1}",
              prevPage: "Previous Page"
            },
            es: {
              goToPage: "Ir a la página",
              nextPage: "Página siguiente",
              pageXofY: "Página {arg0} de {arg1}",
              prevPage: "Página anterior"
            },
            fi: {
              goToPage: "Mene sivulle",
              nextPage: "Seuraava sivu",
              pageXofY: "Sivu {arg0} / {arg1}",
              prevPage: "Edellinen sivu"
            },
            "fr-CA": {
              goToPage: "Aller à la page",
              nextPage: "Page suivante",
              pageXofY: "Page {arg0} sur {arg1}",
              prevPage: "Page précédente"
            },
            fr: {
              goToPage: "Aller à la page",
              nextPage: "Page suivante",
              pageXofY: "Page {arg0} sur {arg1}",
              prevPage: "Page précédente"
            },
            he: {
              goToPage: "מעבר לעמוד",
              nextPage: "העמוד הבא",
              pageXofY: "עמוד {arg0} מתוך {arg1}",
              prevPage: "העמוד הקודם"
            },
            hr: {
              goToPage: "Idi na stranicu",
              nextPage: "Slijedeća stranica",
              pageXofY: "Stranica {arg0} od {arg1}",
              prevPage: "Prethodna stranica"
            },
            id: {
              goToPage: "Buka halaman",
              nextPage: "Halaman Berikutnya",
              pageXofY: "Halaman {arg0} dari {arg1}",
              prevPage: "Halaman Sebelumnya"
            },
            it: {
              goToPage: "Vai a pagina",
              nextPage: "Pagina successiva",
              pageXofY: "Pagina {arg0} di {arg1}",
              prevPage: "Pagina precedente"
            },
            ja: {
              goToPage: "ページに移動",
              nextPage: "次のページ",
              pageXofY: "ページ {arg0}/{arg1}",
              prevPage: "前のページ"
            },
            ko: {
              goToPage: "페이지로 이동",
              nextPage: "다음 페이지",
              pageXofY: "{arg0}/{arg1} 페이지",
              prevPage: "이전 페이지"
            },
            ms: {
              goToPage: "Pergi ke Halaman",
              nextPage: "Halaman Seterusnya",
              pageXofY: "Halaman {arg0} daripada {arg1}",
              prevPage: "Halaman Sebelumnya"
            },
            "nb-NO": {
              goToPage: "Gå til side",
              nextPage: "Neste side",
              pageXofY: "Side {arg0} av {arg1}",
              prevPage: "Forrige side"
            },
            nl: {
              goToPage: "Ga naar pagina",
              nextPage: "Volgende pagina",
              pageXofY: "Pagina {arg0} van {arg1}",
              prevPage: "Vorige pagina"
            },
            pl: {
              goToPage: "Przejdź do strony",
              nextPage: "Następna strona",
              pageXofY: "Strona {arg0} z {arg1}",
              prevPage: "Poprzednia strona"
            },
            "pt-PT": {
              goToPage: "Ir para página",
              nextPage: "Página seguinte",
              pageXofY: "Página {arg0} de {arg1}",
              prevPage: "Página anterior"
            },
            pt: {
              goToPage: "Ir à Página",
              nextPage: "Página Seguinte",
              pageXofY: "Página {arg0} de {arg1}",
              prevPage: "Página Anterior"
            },
            ru: {
              goToPage: "Перейти к странице",
              nextPage: "Следующая страница",
              pageXofY: "Страница {arg0} из {arg1}",
              prevPage: "Предыдущая страница"
            },
            sk: {
              goToPage: "Ísť na stranu",
              nextPage: "Dalšia strana",
              pageXofY: "Strana {arg0} z {arg1}",
              prevPage: "Predchádzajúca strana"
            },
            sl: {
              goToPage: "Pojdi na stran",
              nextPage: "Naslednja stran",
              pageXofY: "Stran {arg0} od {arg1}",
              prevPage: "Prejšnja stran"
            },
            sv: {
              goToPage: "Gå till sida",
              nextPage: "Nästa sida",
              pageXofY: "Sida {arg0} av {arg1}",
              prevPage: "Föregående sida"
            },
            th: {
              goToPage: "ไปที่หน้า",
              nextPage: "หน้าถัดไป",
              pageXofY: "หน้า {arg0} จาก {arg1}",
              prevPage: "หน้าก่อนหน้า"
            },
            tr: {
              goToPage: "Sayfaya Git",
              nextPage: "Sonraki Sayfa",
              pageXofY: "Sayfa {arg0}/{arg1}",
              prevPage: "Önceki Sayfa"
            },
            uk: {
              goToPage: "Перейти на сторінку",
              nextPage: "Наступна сторінка",
              pageXofY: "Сторінка {arg0} з {arg1}",
              prevPage: "Попередня сторінка"
            },
            "zh-Hans": {
              goToPage: "前往页面",
              nextPage: "下一页",
              pageXofY: "第 {arg0}/{arg1} 页",
              prevPage: "上一页"
            },
            "zh-Hant": {
              goToPage: "到此頁",
              nextPage: "下一頁",
              pageXofY: "第{arg0}頁，共{arg1}頁",
              prevPage: "上一頁"
            }
          },
          zy = hg({
            defaultClassName: "_1nsi9h17",
            variantClassNames: {
              isFocusVisible: {
                true: "_1nsi9h18"
              },
              variant: {
                pinned: "_1nsi9h19",
                floating: "_1nsi9h1a"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Ty = hg({
            defaultClassName: "_1nsi9h10",
            variantClassNames: {
              size: {
                xs: "_1nsi9h11",
                sm: "_1nsi9h12",
                md: "_1nsi9h13",
                lg: "_1nsi9h14"
              },
              variant: {
                floating: "_1nsi9h15",
                pinned: "_1nsi9h16"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Oy = {
            style: "decimal"
          },
          Iy = {
            xs: [Ze.BN, Ze.QU],
            sm: [Ue.BN, Ue.QU],
            md: [$e.BN, $e.QU],
            lg: [Ke.BNd, Ke.QUb]
          },
          Fy = s.forwardRef(({
            className: e,
            style: t,
            minValue: n = 1,
            defaultValue: r = 1,
            incrementAriaLabel: o,
            decrementAriaLabel: i,
            "aria-label": a,
            size: l = "md",
            variant: u = "floating",
            ...c
          }, d) => {
            let {
                locale: p
              } = (0, Le.bU)(),
              h = Tv(Ay),
              f = {
                ...c,
                formatOptions: Oy,
                minValue: n,
                incrementAriaLabel: o || h.formatMessage("nextPage"),
                decrementAriaLabel: i || h.formatMessage("prevPage"),
                defaultValue: r,
                "aria-label": a || h.formatMessage("goToPage")
              },
              m = s.useRef(null),
              g = ce({
                ...f,
                locale: p
              }),
              {
                inputProps: v,
                decrementButtonProps: y,
                incrementButtonProps: b,
                groupProps: w
              } = (0, Le.IL)({
                ...f,
                onKeyDown: e => {
                  "Enter" === e.key && m.current?.blur(), c.onKeyDown?.(e);
                }
              }, g, m),
              {
                hoverProps: x,
                isHovered: D
              } = (0, Le.XI)({}),
              {
                focusProps: C,
                isFocused: S,
                isFocusVisible: E
              } = (0, Le.Fx)(),
              _ = "floating" === u,
              [P, k] = Iy[l],
              A = (0, je.mS)({
                "data-focus-visible": E,
                "data-focused": S,
                "data-hovered": D,
                "data-block-id": c["data-block-id"]
              });
            return (0, Ve.jsxs)("div", {
              ...(0, Le.dG)(w, x, A),
              className: (0, je.AK)(Ty({
                size: l,
                variant: u
              }), "BaselineUI-Pagination", e),
              style: t,
              ref: d,
              children: [(0, Ve.jsx)(nv, {
                icon: P,
                ...y,
                elementType: "div",
                size: l,
                style: {
                  height: "100%",
                  ...(_ && {
                    borderRadius: 0
                  })
                },
                className: "BaselineUI-Pagination-DecrementButton"
              }), "floating" === u && (0, Ve.jsx)(yg, {
                orientation: "vertical"
              }), (0, Ve.jsxs)("div", {
                className: zy({
                  isFocusVisible: E,
                  variant: u
                }),
                "aria-label": h.formatMessage("pageXofY", {
                  arg0: v.value,
                  arg1: g.maxValue
                }),
                children: [(0, Ve.jsx)("input", {
                  ...(0, Le.dG)(v, C),
                  ref: m,
                  className: (0, je.AK)("BaselineUI-Pagination-Input", "_1nsi9h1b"),
                  style: {
                    width: `${v.value?.toString().length || 1}ch`
                  }
                }), (0, Ve.jsxs)("span", {
                  className: "_1nsi9h1c",
                  children: ["/ ", (0, Ve.jsx)(cy, {
                    value: g.maxValue
                  })]
                })]
              }), "floating" === u && (0, Ve.jsx)(yg, {
                orientation: "vertical"
              }), (0, Ve.jsx)(nv, {
                icon: k,
                ...b,
                elementType: "div",
                size: l,
                style: {
                  height: "100%",
                  ...(_ && {
                    borderRadius: 0
                  })
                },
                className: "BaselineUI-Pagination-IncrementButton"
              })]
            });
          });
        Fy.displayName = "Pagination";
        var My = ({
          date: e,
          ...t
        }) => {
          let n = (0, Le.aQ)(t);
          return (0, Ve.jsx)(Ve.Fragment, {
            children: n.format(e)
          });
        };
        My.displayName = "DateFormat";
        var Ry = hg({
            defaultClassName: "_1f789qj1",
            variantClassNames: {
              isFocusVisible: {
                true: "_1f789qj2"
              },
              variant: {
                neutral: "_1f789qj3",
                red: "_1f789qj4",
                green: "_1f789qj5",
                blue: "_1f789qj6",
                "high-contrast": "_1f789qj7"
              },
              isDisabled: {
                true: "_1f789qj8"
              },
              allowsRemoving: {
                true: "_1f789qj9"
              },
              isSelected: {
                true: "_1f789qja"
              },
              allowsSelection: {
                true: "_1f789qjb"
              },
              isHovered: {
                true: "_1f789qjc"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              allowsSelection: !0,
              isHovered: !0,
              variant: "neutral"
            }, "_1f789qjd"], [{
              allowsSelection: !0,
              isHovered: !0,
              variant: "red"
            }, "_1f789qje"], [{
              allowsSelection: !0,
              isHovered: !0,
              variant: "blue"
            }, "_1f789qjf"], [{
              allowsSelection: !0,
              isHovered: !0,
              variant: "green"
            }, "_1f789qjg"], [{
              allowsSelection: !0,
              isHovered: !0,
              variant: "high-contrast"
            }, "_1f789qjh"], [{
              allowsSelection: !0,
              isSelected: !0,
              isHovered: !0
            }, "_1f789qji"]]
          }),
          jy = hg({
            defaultClassName: "_1f789qjk",
            variantClassNames: {
              variant: {
                neutral: "_1f789qjl",
                red: "_1f789qjm",
                green: "_1f789qjn",
                blue: "_1f789qjo",
                "high-contrast": "_1f789qjp"
              },
              isHovered: {
                true: "_1f789qjq"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isHovered: !0,
              variant: "neutral"
            }, "_1f789qjr"], [{
              isHovered: !0,
              variant: "red"
            }, "_1f789qjs"], [{
              isHovered: !0,
              variant: "blue"
            }, "_1f789qjt"], [{
              isHovered: !0,
              variant: "green"
            }, "_1f789qju"], [{
              isHovered: !0,
              variant: "high-contrast"
            }, "_1f789qjv"]]
          }),
          By = ({
            item: e,
            state: t,
            variant: n = "neutral"
          }) => {
            let r = s.useRef(null),
              {
                focusProps: o,
                isFocusVisible: i
              } = (0, Le.Fx)({
                within: !0
              }),
              {
                rowProps: a,
                gridCellProps: l,
                removeButtonProps: u,
                allowsRemoving: c,
                isDisabled: d,
                isSelected: p,
                allowsSelection: h
              } = (0, Le.E6)({
                item: e
              }, t, r),
              f = s.useRef(null),
              {
                buttonProps: m
              } = (0, Le.UW)(u, f),
              {
                hoverProps: g,
                isHovered: v
              } = (0, Le.XI)({
                isDisabled: d
              }),
              {
                hoverProps: y,
                isHovered: b
              } = (0, Le.XI)({
                isDisabled: d
              }),
              w = e.value?.icon,
              x = e.value?.variant ?? n;
            return (0, Ve.jsx)("div", {
              ...(0, Le.dG)(a, o, y),
              ref: r,
              className: Ry({
                isFocusVisible: i,
                variant: x,
                isDisabled: d,
                allowsRemoving: c,
                isSelected: p,
                allowsSelection: h,
                isHovered: b
              }),
              children: (0, Ve.jsxs)("div", {
                ...l,
                className: "_1f789qjj",
                children: [p ? (0, Ve.jsx)(Ue.KM, {
                  size: 16
                }) : null, !p && w ? (0, Ve.jsx)(w, {
                  size: 16
                }) : null, e.rendered, c ? (0, Ve.jsx)("button", {
                  ...(0, Le.dG)(m, g),
                  className: jy({
                    variant: x,
                    isHovered: v
                  }),
                  children: (0, Ve.jsx)(Ze.b0, {})
                }) : null]
              })
            });
          },
          Ny = s.forwardRef(({
            className: e,
            style: t,
            ...n
          }, r) => {
            let o = s.useRef(null),
              i = g(n),
              {
                gridProps: a
              } = (0, Le.Hb)(n, i, o);
            return (0, Ve.jsx)("div", {
              ...a,
              className: (0, je.AK)("_1f789qj0", e),
              style: t,
              ref: (0, Be.lq)(r, o),
              children: [...i.collection].map(e => (0, Ve.jsx)(By, {
                state: i,
                item: e,
                variant: n.variant
              }, e.key))
            });
          });
        Ny.displayName = "TagGroupBase";
        var Ly = s.forwardRef(({
          items: e,
          ...t
        }, n) => (0, Ve.jsx)(Ny, {
          ...t,
          items: e,
          ref: n,
          children: e => (0, Ve.jsx)(c.ck, {
            children: e.label
          })
        }));
        Ly.displayName = "TagGroup";
        var Vy = hg({
            defaultClassName: "_1kvz17db _1yep5z6ki _1yep5z6kk",
            variantClassNames: {
              showActionsOnTriggerOnly: {
                true: "_1kvz17dc"
              },
              isTriggered: {
                true: "_1kvz17dd"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Ky = hg({
            defaultClassName: "_1kvz17d0 _1yep5z64u _1yep5z64v _1yep5z64w _1yep5z676 _1yep5z677 _1yep5z678 _1yep5z68c _1yep5z68d _1yep5z68e _1yep5z660 _1yep5z661 _1yep5z662 _1yep5z6ki _1yep5z6kj",
            variantClassNames: {
              isExpanded: {
                true: "_1kvz17d1"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          qy = hg({
            defaultClassName: "_1kvz17d2 _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6ki _1yep5z6kl",
            variantClassNames: {
              isFocusVisible: {
                true: "_1kvz17d3"
              },
              isHovered: {
                true: "_1yep5z6ft",
                false: "_1yep5z6fu"
              },
              isDisabled: {
                true: "z9nup83"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Hy = hg({
            defaultClassName: "_1kvz17d7 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              isDisabled: {
                true: "_1yep5z6ey",
                false: "_1yep5z6eu"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Uy = s.forwardRef(({
            children: e,
            className: t,
            style: n
          }, r) => {
            let {
                headers: o
              } = (0, s.useContext)(Zy),
              {
                disabledKeys: i
              } = (0, s.useContext)(Zy),
              {
                keyboardProps: a
              } = (0, Le.v5)({
                onKeyDown: e => {
                  let t = (0, Be.k3)(e.target),
                    n = [...(o?.keys() || [])].findIndex(e => o?.get(e)?.current === t.activeElement),
                    r = o?.get(n || 0),
                    a = o?.size || 0,
                    s = e => {
                      let t = o.get(e - 1 < 0 ? a - 1 : e - 1);
                      i?.has(t?.current?.getAttribute("data-key") || "") ? s(e - 1) : t?.current?.focus();
                    },
                    l = e => {
                      let t = o.get((e + 1) % a);
                      i?.has(t?.current?.getAttribute("data-key") || "") ? l(e + 1) : t?.current?.focus();
                    };
                  if (r) switch (e.key) {
                    case "Home":
                      e.preventDefault(), l(-1);
                      break;
                    case "End":
                      e.preventDefault(), s(a);
                      break;
                    case "ArrowDown":
                      e.preventDefault(), l(n);
                      break;
                    case "ArrowUp":
                      e.preventDefault(), s(n);
                      break;
                    default:
                      e.continuePropagation();
                  }
                }
              });
            return (0, Ve.jsx)("div", {
              ...a,
              style: n,
              className: (0, je.AK)("_1yep5z6kv", t),
              ref: r,
              children: s.Children.map(e, (e, t) => s.cloneElement(e, {
                index: t
              }))
            });
          });
        Uy.displayName = "AccordionBase";
        var Zy = s.createContext({
            expandedKeys: new Set(),
            setExpandedKeys: () => {},
            disabledKeys: new Set(),
            headers: new Map(),
            expansionMode: "multiple"
          }),
          $y = s.forwardRef(({
            children: e,
            disabledKeys: t,
            defaultExpandedKeys: n = new Set(),
            expandedKeys: r,
            expansionMode: o = "multiple",
            onChange: i,
            className: a,
            style: l
          }, u) => {
            let [c, d] = s.useState(n),
              p = s.useRef(new Map()).current,
              [h, f] = s.useState(o);
            (0, s.useEffect)(() => {
              f(h);
            }, [h]), (0, s.useEffect)(() => {
              i?.(c);
            }, [c, i]);
            let m = (0, s.useMemo)(() => ({
              expandedKeys: r || c,
              setExpandedKeys: r ? () => {} : d,
              disabledKeys: t,
              headers: p,
              expansionMode: h
            }), [r, c, t, p, h]);
            return (0, Ve.jsx)(Zy.Provider, {
              value: m,
              children: (0, Ve.jsx)(Le.MT, {
                children: (0, Ve.jsx)(Uy, {
                  className: a,
                  style: l,
                  ref: u,
                  children: e
                })
              })
            });
          });
        $y.displayName = "Accordion";
        var Gy = s.forwardRef(({
          title: e,
          actions: t,
          controlId: n,
          value: r,
          id: o,
          index: i,
          subLabel: a,
          showActionsOnTriggerOnly: l
        }, u) => {
          let c = s.useRef(null),
            {
              expandedKeys: d,
              setExpandedKeys: p,
              expansionMode: h,
              disabledKeys: f,
              headers: m
            } = (0, s.useContext)(Zy),
            g = f?.has(r),
            v = (0, Le.bO)();
          (0, je.kG)(v);
          let {
              focusNext: y,
              focusPrevious: b
            } = v,
            {
              keyboardProps: w
            } = (0, Le.v5)({
              onKeyDown: e => {
                "ArrowRight" === e.key ? y({
                  wrap: !0
                }) : "ArrowLeft" === e.key ? b({
                  wrap: !0
                }) : e.continuePropagation();
              },
              isDisabled: g
            });
          (0, s.useEffect)(() => {
            (0, je.kG)("number" == typeof i, "AccordionItem must have an index"), m?.set(i, c);
          }, [i, m]);
          let x = () => {
              p(e => {
                let t = new Set(e);
                return t.has(r) ? t.delete(r) : ("single" === h && t.clear(), t.add(r)), t;
              });
            },
            {
              buttonProps: D
            } = (0, Le.UW)({
              "aria-expanded": d.has(r),
              "aria-controls": n,
              onPress: x,
              isDisabled: g
            }, c),
            {
              pressProps: C
            } = (0, Le.r7)({
              onPress: x,
              isDisabled: g
            }),
            {
              focusProps: S,
              isFocusVisible: E
            } = (0, Le.Fx)(),
            {
              hoverProps: _,
              isHovered: P
            } = (0, Le.XI)({
              isDisabled: g
            }),
            {
              focusProps: k,
              isFocusVisible: A
            } = (0, Le.Fx)({
              within: !0
            }),
            z = d.has(r);
          return (0, Ve.jsxs)("h3", {
            ...(0, Le.dG)(w, C, _, k),
            className: qy({
              isFocusVisible: E,
              isHovered: P,
              isDisabled: g
            }),
            ref: u,
            children: [(0, Ve.jsxs)("div", {
              className: Hy({
                isDisabled: !!g
              }),
              children: [(0, Ve.jsx)(He.XC, {
                className: Ky({
                  isExpanded: z
                }),
                size: 8
              }), (0, Ve.jsx)("button", {
                ...(0, Le.dG)(D, S),
                id: o,
                "data-key": r,
                className: "_1kvz17da _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z6dz",
                ref: c,
                children: e
              })]
            }), t?.length ? (0, Ve.jsx)("div", {
              "data-testid": "action-buttons",
              className: Vy({
                showActionsOnTriggerOnly: l,
                isTriggered: A || P
              }),
              children: t.map((e, t) => (0, Ve.jsx)(nv, {
                variant: "secondary",
                size: "sm",
                excludeFromTabOrder: !0,
                isDisabled: g,
                ...e
              }, t))
            }) : null, a ? (0, Ve.jsx)("div", {
              className: "_1yep5z6ev _1yep5z6dy",
              children: a
            }) : null]
          });
        });
        Gy.displayName = "AccordionHeader";
        var Wy = s.forwardRef(({
          title: e,
          actions: t,
          children: n,
          value: r,
          index: o,
          subLabel: i,
          style: a,
          className: l,
          showActionsOnTriggerOnly: u
        }, c) => {
          let d = (0, Le.Me)(),
            p = (0, Le.Me)(),
            {
              expandedKeys: h
            } = (0, s.useContext)(Zy),
            f = s.useRef(null),
            m = h.has(r),
            g = Cv(),
            v = (0, Ne.JZ)(),
            y = (0, Ne.Yz)(m ? [r] : [], {
              from: !g && !v && {
                height: 0,
                opacity: 0
              },
              enter: () => async e => {
                await e({
                  height: f.current?.scrollHeight,
                  opacity: 1
                });
              },
              leave: {
                height: 0,
                opacity: 0
              },
              keys: e => e
            });
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [(0, Ve.jsx)(Le.MT, {
              children: (0, Ve.jsx)(Gy, {
                value: r,
                actions: t,
                id: p,
                title: e,
                controlId: d,
                ref: c,
                index: o,
                subLabel: i,
                showActionsOnTriggerOnly: u
              })
            }), y(e => (0, Ve.jsx)(Ne.q.div, {
              role: "region",
              "aria-labelledby": p,
              id: d,
              style: {
                ...e,
                overflow: "hidden"
              },
              children: (0, Ve.jsx)("div", {
                ref: f,
                className: l,
                style: a,
                children: n
              })
            }))]
          });
        });
        Wy.displayName = "AccordionItem";
        var Yy = s.forwardRef(({
          variant: e,
          isOpen: t,
          validationState: n = "valid",
          ...r
        }, o) => {
          let i = s.useRef(null),
            {
              buttonProps: a,
              isPressed: l
            } = (0, Le.UW)({
              ...r,
              isDisabled: r.isDisabled || r.isReadOnly
            }, i),
            {
              hoverProps: u,
              isHovered: c
            } = (0, Le.XI)({
              isDisabled: r.isDisabled
            }),
            {
              focusProps: d,
              isFocused: p,
              isFocusVisible: h
            } = (0, Le.Fx)(),
            f = ly({
              isReadOnly: r.isReadOnly,
              validationState: n
            });
          r.isReadOnly && (a.disabled = !1);
          let m = (0, je.mS)({
            "data-disabled": r.isDisabled,
            "data-readonly": r.isReadOnly,
            "data-focused": p,
            "data-focus-visible": h,
            "data-hovered": c,
            "data-pressed": l,
            "data-open": t
          });
          return (0, Ve.jsxs)("button", {
            ...(0, Le.dG)(a, u, d, m),
            ref: (0, Be.lq)(o, i),
            className: (0, je.AK)(Lv({
              isFocused: h,
              isDisabled: r.isDisabled
            }), Qg({
              variant: e,
              isHovered: c,
              isFocused: h,
              validationState: n,
              isDisabled: !!r.isDisabled,
              isReadOnly: r.isReadOnly
            }), "BaselineUI-Select-Button"),
            children: [r.children, f ? (0, Ve.jsx)("span", {
              "aria-hidden": !0,
              className: (0, je.AK)(Gg({
                validationState: n,
                isReadOnly: !!r.isReadOnly
              }), "_1yep5z66x _1yep5z66y _1yep5z66z"),
              children: (0, Ve.jsx)(f, {
                size: 16
              })
            }) : null, (0, Ve.jsx)("span", {
              "aria-hidden": !0,
              children: (0, Ve.jsx)(He.v4, {
                size: 8,
                className: Bv({
                  isOpen: t
                })
              })
            })]
          });
        });
        Yy.displayName = "SelectButton";
        var Xy = s.forwardRef(({
          className: e,
          style: t,
          labelPosition: n = "top",
          variant: r = "primary",
          "data-block-id": o,
          optionStyle: i,
          optionClassName: a,
          placement: l = "bottom start",
          renderTrigger: c = ({
            buttonProps: e,
            selectedValue: t,
            valueProps: n,
            isOpen: o,
            ref: i
          }) => {
            let a = t && "icon" in t && t.icon;
            return (0, Ve.jsx)(Yy, {
              ...e,
              isOpen: o,
              isReadOnly: d.isReadOnly,
              ref: i,
              variant: r,
              validationState: d.validationState,
              children: (0, Ve.jsxs)("span", {
                className: "_1mdhlqv5 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69i _1yep5z69j _1yep5z69k",
                children: [a ? (0, Ve.jsx)(a, {
                  size: 24
                }) : null, (0, Ve.jsx)("span", {
                  ...n,
                  children: t ? "label" in t && t?.label : d.placeholder
                })]
              })
            });
          },
          ...d
        }, p) => {
          let h = s.useRef(null),
            f = function (e) {
              let t = y(e),
                [n, r] = (0, s.useState)(null),
                o = v({
                  ...e,
                  onSelectionChange: n => {
                    null != e.onSelectionChange && e.onSelectionChange(n), t.close(), i.commitValidation();
                  }
                }),
                i = (0, u.Q3)({
                  ...e,
                  value: o.selectedKey
                }),
                [a, l] = (0, s.useState)(!1);
              return {
                ...i,
                ...o,
                ...t,
                focusStrategy: n,
                open(e = null) {
                  0 !== o.collection.size && (r(e), t.open());
                },
                toggle(e = null) {
                  0 !== o.collection.size && (r(e), t.toggle());
                },
                isFocused: a,
                setFocused: l
              };
            }({
              ...d,
              validationState: "error" === d.validationState ? "invalid" : "valid"
            }),
            m = jv(d.portalContainer),
            {
              labelProps: g,
              triggerProps: b,
              valueProps: w,
              menuProps: x,
              descriptionProps: D,
              errorMessageProps: C
            } = (0, Le.L7)({
              ...d,
              validationState: "error" === d.validationState ? "invalid" : "valid"
            }, f, h),
            S = Jg({
              ...d,
              descriptionProps: D,
              errorMessageProps: C,
              labelPosition: n
            }),
            E = f.selectedItem?.value;
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [(0, Ve.jsxs)("div", {
              style: t,
              className: (0, je.AK)(Xg({
                labelPosition: n
              }), "BaselineUI-Select", e),
              "data-block-id": o,
              ref: p,
              children: [d.label || S ? (0, Ve.jsxs)("div", {
                className: Yg({
                  labelPosition: n,
                  hasMessage: !!S
                }),
                children: [d.label ? (0, Ve.jsx)("div", {
                  ...g,
                  className: (0, je.AK)(Wg, "BaselineUI-Select-Label"),
                  children: d.label
                }) : null, "start" === n && S]
              }) : null, (0, Ve.jsx)(Le.MG, {
                state: f,
                triggerRef: h,
                isDisabled: d.isDisabled,
                label: d.label,
                name: d.name
              }), c({
                buttonProps: b,
                selectedValue: E,
                valueProps: w,
                isOpen: f.isOpen,
                ref: h
              }), "top" === n && S]
            }), f.isOpen ? (0, Ve.jsx)(Hv, {
              placement: l,
              portalContainer: m,
              offset: 2,
              state: f,
              triggerRef: h,
              style: t,
              className: (0, je.AK)(Nv, "BaselineUI-Select-Popover"),
              ...d,
              children: (0, Ve.jsx)(Pg, {
                ...x,
                label: d.label,
                items: d.items,
                UNSAFE_state: f,
                showSelectedIcon: d.showSelectedIcon,
                className: "_1mdhlqv7 _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6fs",
                optionStyle: i,
                optionClassName: a
              })
            }) : null]
          });
        });
        Xy.displayName = "SelectBase";
        var Qy = s.forwardRef((e, t) => (0, Ve.jsx)(Xy, {
          ...e,
          ref: t,
          children: e => "section" === e.type ? (0, Ve.jsx)(c.$0, {
            items: e.children,
            title: e.id,
            children: e => (0, Ve.jsx)(c.ck, {
              children: e.label
            }, e.id)
          }, e.id) : (0, Ve.jsx)(c.ck, {
            textValue: e.label,
            children: e.label
          }, e.id)
        }));
        Qy.displayName = "Select";
        var Jy = hg({
            defaultClassName: "_1017q4c0",
            variantClassNames: {
              size: {
                md: "_1017q4c1",
                sm: "_1017q4c2"
              },
              isDisabled: {
                true: "_1017q4c3"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          eb = {
            sm: Ue.fM,
            md: Ke.fMw
          },
          tb = s.forwardRef(({
            className: e,
            style: t,
            size: n = "md",
            icon: r = eb[n],
            name: o,
            imgSrc: i,
            showInitials: a,
            isDisabled: s,
            hasNotifications: l,
            imgLoading: u,
            "data-block-id": c
          }, d) => {
            let {
                imgProps: p
              } = Dv({
                src: i,
                alt: o
              }),
              h = o?.split(" ").map(e => e[0]).join("");
            return (0, Ve.jsxs)("span", {
              className: (0, je.AK)(Jy({
                size: n,
                isDisabled: s
              }), "BaselineUI-Avatar", e),
              "data-disabled": s,
              ref: d,
              style: t,
              "aria-disabled": s,
              "data-block-id": c,
              children: [i ? (0, Ve.jsx)("img", {
                ...p,
                loading: u,
                className: "_1017q4c4"
              }) : null, !a && !i && (0, Ve.jsx)(r, {
                size: "sm" === n ? 16 : 24
              }), a && !i ? "sm" === n ? h[0] : h : null, l ? (0, Ve.jsx)("div", {
                "data-testid": "notification",
                className: "_1017q4c5"
              }) : null]
            });
          });
        tb.displayName = "Avatar";
        var nb = hg({
            defaultClassName: "_1x62fhb6 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ki _1yep5z6kl _1yep5z6ev _1yep5z69i _1yep5z69j _1yep5z69k",
            variantClassNames: {
              isHovered: {
                true: "_1yep5z6105"
              },
              isSelected: {
                true: "_1x62fhb8"
              },
              isFocusVisible: {
                true: "_1x62fhb9"
              },
              isDisabled: {
                true: "_1x62fhba _1yep5z6109"
              },
              variant: {
                primary: "_1x62fhbb _1yep5z6z6",
                ghost: "_1yep5z6z9"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "primary",
              isSelected: !0,
              isDisabled: !1
            }, "_1yep5z61lg"], [{
              variant: "primary",
              isSelected: !0
            }, "_1yep5z61me"], [{
              variant: "ghost",
              isSelected: !0,
              isFocusVisible: !1
            }, "_1x62fhbd"], [{
              variant: "ghost",
              isSelected: !0,
              isDisabled: !1
            }, "_1yep5z61lr"], [{
              variant: "ghost",
              isDisabled: !0,
              isSelected: !0
            }, "_1x62fhbe _1yep5z6ey"], [{
              variant: "primary",
              isHovered: !0
            }, "_1yep5z61mf"]]
          }),
          rb = hg({
            defaultClassName: "_1x62fhb3 _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
            variantClassNames: {
              variant: {
                primary: "_1x62fhb4",
                ghost: "_1yep5z6ut _1yep5z6uu _1yep5z6uv"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ob = hg({
            defaultClassName: "_1x62fhb0 _1yep5z6kv _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
            variantClassNames: {
              variant: {
                primary: "_1yep5z6115",
                ghost: "_1x62fhb2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ib = ({
            state: e,
            ...t
          }) => {
            let n = s.useRef(null),
              {
                tabPanelProps: r
              } = (0, Le.WE)(t, e, n),
              {
                selectedItem: o
              } = e,
              {
                focusProps: i,
                isFocusVisible: a
              } = (0, Le.Fx)();
            if (!o?.value) return null;
            let {
              className: l,
              style: u,
              "data-block-id": c
            } = o.value;
            return (0, Ve.jsx)("div", {
              ...(0, Le.dG)(r, i),
              ref: n,
              className: (0, je.AK)({
                "_1yep5z6l2 _1yep5z6kz _1yep5z6hc _1yep5z6l1": a
              }, "Baseline-Tabs-TabPanel", l),
              "data-block-id": c,
              style: u,
              children: o?.props.children
            });
          },
          ab = s.forwardRef(({
            className: e,
            style: t,
            tabHeaderStyle: n,
            tabHeaderClassName: r,
            variant: o = "primary",
            actions: i,
            onRemove: a,
            "data-block-id": l,
            ...u
          }, c) => {
            let d = function (e) {
                var t;
                let n = v({
                    ...e,
                    suppressTextValueWarning: !0,
                    defaultSelectedKey: null !== (t = e.defaultSelectedKey) && void 0 !== t ? t : Ee(e.collection, e.disabledKeys ? new Set(e.disabledKeys) : new Set())
                  }),
                  {
                    selectionManager: r,
                    collection: o,
                    selectedKey: i
                  } = n,
                  a = (0, s.useRef)(i);
                return (0, s.useEffect)(() => {
                  let e = i;
                  !r.isEmpty && o.getItem(e) || (e = Ee(o, n.disabledKeys), null != e && r.setSelectedKeys([e])), (null != e && null == r.focusedKey || !r.isFocused && e !== a.current) && r.setFocusedKey(e), a.current = e;
                }), {
                  ...n,
                  isDisabled: e.isDisabled || !1
                };
              }({
                ...u,
                selectedKey: u.selectedValue,
                defaultSelectedKey: u.defaultSelectedValue,
                disabledKeys: u.disabledValues
              }),
              p = s.useRef(null),
              {
                tabListProps: h
              } = (0, Le.HJ)({
                ...u,
                selectedKey: u.selectedValue,
                defaultSelectedKey: u.defaultSelectedValue,
                disabledKeys: u.disabledValues
              }, d, p);
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)("BaselineUI-Tabs", e),
              style: t,
              ref: c,
              "data-block-id": l,
              children: [(0, Ve.jsxs)("div", {
                className: (0, je.AK)(ob({
                  variant: o
                }), r),
                style: n,
                children: [(0, Ve.jsx)("div", {
                  ...h,
                  className: rb({
                    variant: o
                  }),
                  ref: p,
                  children: [...d.collection].map(e => ((0, je.kG)(e.value, "TabItem requires a value prop"), (0, Ve.jsx)(sb, {
                    item: e,
                    state: d,
                    onRemove: a,
                    variant: o
                  }, e.key)))
                }), i?.map((e, t) => (0, Ve.jsx)("div", {
                  className: "_1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z63l _1yep5z63m _1yep5z63n _1yep5z619 _1yep5z61a _1yep5z61b _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it",
                  children: (0, Ve.jsx)(nv, {
                    ...e,
                    variant: "secondary",
                    size: "sm",
                    className: (0, je.AK)("_1x62fhbf", e.className)
                  })
                }, t))]
              }), (0, Ve.jsx)(ib, {
                state: d
              }, d.selectedItem?.key)]
            });
          });
        ab.displayName = "TabsBase";
        var sb = ({
          item: e,
          onRemove: t,
          state: n,
          variant: r
        }) => {
          let {
              key: o,
              value: i
            } = e,
            a = s.useRef(null),
            {
              tabProps: l,
              isSelected: u,
              isDisabled: c
            } = (0, Le.xD)({
              key: o
            }, n, a),
            {
              hoverProps: d,
              isHovered: p
            } = (0, Le.XI)({});
          (0, je.kG)(i, "TabButton requires a value prop");
          let {
              title: h,
              icon: f,
              titleStyle: m,
              titleClassName: g
            } = i,
            {
              focusProps: v,
              isFocusVisible: y,
              isFocused: b
            } = (0, Le.Fx)(),
            {
              keyboardProps: w
            } = (0, Le.v5)({
              onKeyDown: e => {
                "Backspace" === e.key && t ? t(o) : e.continuePropagation();
              }
            }),
            x = (0, je.mS)({
              "data-selected": u,
              "data-disabled": c,
              "data-focused": b,
              "data-hovered": p,
              "data-focus-visible": y
            });
          return (0, Ve.jsxs)("div", {
            ...(0, Le.dG)(w, l, d, v, x),
            className: (0, je.AK)(nb({
              isHovered: p,
              isSelected: u,
              isFocusVisible: y,
              isDisabled: c,
              variant: r
            }), "BaselineUI-Tabs-TabButton", g),
            style: m,
            ref: a,
            children: [f ? (0, Ve.jsx)(f, {
              size: 20
            }) : null, h, t ? (0, Ve.jsx)(nv, {
              variant: "secondary",
              elementType: "div",
              icon: He.b0,
              size: "xxs",
              onPress: () => {
                t(o);
              },
              excludeFromTabOrder: !0,
              UNSAFE_NON_INTERACTIVE: !0,
              style: {
                display: "inline-flex",
                color: "inherit",
                opacity: u || b || p ? 1 : 0
              }
            }) : null]
          });
        };
        sb.displayName = "TabButton";
        var lb = s.forwardRef(({
          children: e,
          ...t
        }, n) => {
          let r = (0, s.useMemo)(() => s.Children.map(e, e => e && s.isValidElement(e) && "string" != typeof e.type ? {
            ...e.props,
            id: e.props.value
          } : null).filter(Boolean), [e]);
          return (0, Ve.jsx)(ab, {
            ...t,
            ref: n,
            items: r,
            children: e => (0, Ve.jsx)(c.ck, {
              title: e.title,
              children: e.children
            }, e.key)
          });
        });
        lb.displayName = "Tabs";
        var ub = ({
          children: e,
          title: t,
          value: n
        }) => ((0, je.kG)(n, "TabItem requires a value prop"), (0, je.kG)(t, "TabItem requires a title prop"), (0, je.kG)(e, "TabItem requires children"), e);
        ub.displayName = "TabItem";
        var cb = {
            ar: {
              close: "إغلاق"
            },
            cs: {
              close: "Zavřít"
            },
            cy: {
              close: "Cau"
            },
            da: {
              close: "Luk"
            },
            de: {
              close: "Schließen"
            },
            el: {
              close: "Κλείσιμο"
            },
            "en-GB": {
              close: "Close"
            },
            en: {
              close: "Close"
            },
            es: {
              close: "Cerrar"
            },
            fi: {
              close: "Sulje"
            },
            "fr-CA": {
              close: "Fermer"
            },
            fr: {
              close: "Fermer"
            },
            he: {
              close: "סגירה"
            },
            hr: {
              close: "Zatvori"
            },
            id: {
              close: "Tutup"
            },
            it: {
              close: "Chiudi"
            },
            ja: {
              close: "閉じる"
            },
            ko: {
              close: "닫기"
            },
            ms: {
              close: "Tutup"
            },
            "nb-NO": {
              close: "Lukk"
            },
            nl: {
              close: "Sluit"
            },
            pl: {
              close: "Zamknij"
            },
            "pt-PT": {
              close: "Fechar"
            },
            pt: {
              close: "Fechar"
            },
            ru: {
              close: "Закрыть"
            },
            sk: {
              close: "Zavrieť"
            },
            sl: {
              close: "Zapri"
            },
            sv: {
              close: "Stäng"
            },
            th: {
              close: "ปิด"
            },
            tr: {
              close: "Kapat"
            },
            uk: {
              close: "Закрити"
            },
            "zh-Hans": {
              close: "关闭"
            },
            "zh-Hant": {
              close: "關閉"
            }
          },
          db = hg({
            defaultClassName: "kfun6yw",
            variantClassNames: {
              arrangement: {
                single: "kfun6yx",
                multi: "kfun6yy",
                compact: "kfun6yz"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          pb = hg({
            defaultClassName: "kfun6y0 z9nup82",
            variantClassNames: {
              variant: {
                info: "kfun6y1",
                warning: "kfun6y2",
                error: "kfun6y3",
                success: "kfun6y4"
              },
              arrangement: {
                single: "kfun6y5",
                multi: "kfun6y6",
                compact: "kfun6y7"
              },
              hasButton: {
                true: "kfun6y8"
              },
              hasCloseButton: {
                true: "kfun6y9"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              hasButton: !1,
              arrangement: "single"
            }, "kfun6ya"], [{
              hasButton: !0,
              arrangement: "compact"
            }, "kfun6yb"], [{
              hasCloseButton: !0,
              arrangement: "compact"
            }, "kfun6yc"]]
          }),
          hb = hg({
            defaultClassName: "kfun6yt",
            variantClassNames: {
              size: {
                sm: "kfun6yu",
                md: "kfun6yv"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          fb = hg({
            defaultClassName: "kfun6yp",
            variantClassNames: {
              arrangement: {
                single: "kfun6yq",
                multi: "kfun6yr",
                compact: "kfun6ys"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          mb = hg({
            defaultClassName: "kfun6yk",
            variantClassNames: {
              variant: {
                info: "kfun6yl",
                warning: "kfun6ym",
                error: "kfun6yn",
                success: "kfun6yo"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          gb = hg({
            defaultClassName: "kfun6yh",
            variantClassNames: {
              size: {
                sm: "kfun6yi",
                md: "kfun6yj"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          vb = hg({
            defaultClassName: "kfun6yd z9nup82",
            variantClassNames: {
              arrangement: {
                single: "kfun6ye",
                multi: "kfun6yf",
                compact: "kfun6yg"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          yb = {
            error: {
              sm: Ue.rx,
              md: $e.rx
            },
            info: {
              sm: Ue.F3,
              md: $e.F3
            },
            success: {
              sm: Ue.gq,
              md: $e.gq
            },
            warning: {
              sm: Ue.av,
              md: $e.av
            }
          },
          bb = s.forwardRef(({
            className: e,
            description: t,
            actionLabel: n,
            onAction: r,
            style: o,
            variant: i = "info",
            title: a,
            arrangement: s = "single",
            onClose: l,
            size: u = "sm"
          }, c) => {
            let d = Tv(cb),
              p = n && (0, Ve.jsx)(Bg, {
                variant: "compact" === s ? "tertiary" : "ghost",
                label: n,
                onPress: r
              }),
              h = yb[i][u];
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)(pb({
                variant: i,
                arrangement: s,
                hasButton: !!n || !!l,
                hasCloseButton: !!l
              }), e),
              style: o,
              role: "alert",
              ref: c,
              children: [(0, Ve.jsxs)("div", {
                className: vb({
                  arrangement: s
                }),
                children: [(0, Ve.jsx)(h, {
                  className: mb({
                    variant: i
                  }),
                  size: 16
                }), (0, Ve.jsxs)("div", {
                  className: db({
                    arrangement: s
                  }),
                  children: [(0, Ve.jsx)("h3", {
                    className: gb({
                      size: u
                    }),
                    children: a
                  }), (0, Ve.jsx)("section", {
                    className: hb({
                      size: u
                    }),
                    children: t
                  })]
                }), "compact" === s && p]
              }), (0, Ve.jsxs)("div", {
                className: fb({
                  arrangement: s
                }),
                children: ["compact" !== s && p, l ? (0, Ve.jsx)(nv, {
                  variant: "secondary",
                  icon: Ue.Tw,
                  size: "sm",
                  onPress: l,
                  "aria-label": d.formatMessage("close")
                }) : null]
              })]
            });
          });
        bb.displayName = "InlineAlert";
        var wb = hg({
            defaultClassName: "_1tkzayn0 _1yep5z6dy",
            variantClassNames: {
              size: {
                sm: "_1tkzayn1",
                md: "_1tkzayn2",
                lg: "_1tkzayn3"
              },
              type: {
                subtitle: "_1yep5z6105",
                title: "_1yep5z6105",
                label: "_1yep5z6106",
                value: "_1yep5z6106",
                helper: "_1yep5z6107",
                body: "_1yep5z6105"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              type: "title",
              size: "sm"
            }, "_1yep5z61jz"], [{
              type: "title",
              size: "md"
            }, "_1yep5z61k2"], [{
              type: "title",
              size: "lg"
            }, "_1yep5z61k5"], [{
              type: "body",
              size: "sm"
            }, "_1yep5z61kp"], [{
              type: "body",
              size: "md"
            }, "_1yep5z61ks"], [{
              type: "body",
              size: "lg"
            }, "_1yep5z61ks"], [{
              type: "subtitle",
              size: "sm"
            }, "_1yep5z61kl"], [{
              type: "subtitle",
              size: "md"
            }, "_1yep5z61ko"], [{
              type: "subtitle",
              size: "lg"
            }, "_1yep5z61ko"], [{
              type: "label",
              size: "md"
            }, "_1yep5z61kn"], [{
              type: "label",
              size: "lg"
            }, "_1yep5z61kn"], [{
              type: "value",
              size: "md"
            }, "_1yep5z61kn"], [{
              type: "value",
              size: "lg"
            }, "_1yep5z61kn"], [{
              type: "helper",
              size: "sm"
            }, "_1yep5z61kh"]]
          }),
          xb = s.forwardRef(({
            elementType: e = "span",
            type: t = "title",
            children: n,
            size: r = "md",
            ...o
          }, i) => (0, Ve.jsx)(e, {
            ...o,
            className: (0, je.AK)(wb({
              size: r,
              type: t
            }), "BaselineUI-Text", o.className),
            ref: i,
            children: n
          }));
        xb.displayName = "Text";
        var Db = hg({
            defaultClassName: "siobe21 _1yep5z6ao _1yep5z6ap _1yep5z6aq _1yep5z6bc _1yep5z6bd _1yep5z6be _1yep5z6d7 _1yep5z6l9 _1yep5z6l7 _1yep5z6gq _1yep5z6ky _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie",
            variantClassNames: {
              background: {
                subtle: "_1yep5z6113",
                medium: "_1yep5z6114"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Cb = s.forwardRef(({
            className: e,
            style: t,
            children: n,
            background: r = "medium",
            title: o,
            action: i,
            "data-block-id": a,
            onCloseRequest: l,
            ...u
          }, c) => {
            let {
                formatMessage: d
              } = Tv(),
              p = s.useRef(null),
              {
                dialogProps: h,
                titleProps: f
              } = (0, Le.Rh)(u, p);
            return (0, Ve.jsxs)("div", {
              ...h,
              className: (0, je.AK)(Db({
                background: r
              }), "BaselineUI-Drawer", e),
              "data-block-id": a,
              style: t,
              ref: (0, Be.lq)(c, p),
              children: [(0, Ve.jsxs)(wg, {
                paddingLeft: "lg",
                paddingRight: "sm",
                backgroundColor: "background.primary.subtle",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "lg",
                className: "siobe24",
                children: [(0, Ve.jsx)(xb, {
                  type: "title",
                  size: "sm",
                  ...f,
                  className: "z9nup87",
                  children: o
                }), (0, Ve.jsxs)(wg, {
                  children: [i ? (0, Ve.jsx)(nv, {
                    ...i,
                    variant: "secondary"
                  }) : null, (0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "md",
                    icon: $e.b0,
                    onPress: l,
                    "aria-label": d(Sb.close)
                  })]
                })]
              }), (0, Ve.jsx)(yg, {
                variant: "subtle" === r ? "primary" : "secondary"
              }), n]
            });
          });
        Cb.displayName = "Drawer";
        var Sb = Ov({
          close: {
            id: "close",
            defaultMessage: "Close"
          }
        });
        var Eb = hg({
            defaultClassName: "aml2vl0 _1yep5z6ko _1yep5z6kp _1yep5z6kr _1yep5z6kq _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6hr _1yep5z6hs _1yep5z6ht",
            variantClassNames: {
              enableDrawer: {
                false: "_1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn",
                true: "aml2vl2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          _b = s.createContext({
            state: null,
            triggerProps: {},
            overlayProps: {}
          }),
          Pb = ({
            children: e,
            ...t
          }) => {
            let n = y(t),
              {
                triggerProps: r,
                overlayProps: o
              } = (0, Le.IB)({
                type: "dialog"
              }, n),
              i = (0, s.useMemo)(() => ({
                state: n,
                triggerProps: r,
                overlayProps: o
              }), [n, r, o]);
            return (0, Ve.jsx)(_b.Provider, {
              value: i,
              children: e
            });
          };
        Pb.displayName = "Modal";
        var kb = s.createContext({
            isDrawer: !1,
            closeDrawer: () => {}
          }),
          Ab = (0, Ne.q)(vv),
          zb = (0, Ne.q)(({
            children: e,
            className: t,
            style: n,
            isDismissable: r = !0,
            isKeyboardDismissDisabled: o = !1,
            portalContainer: i,
            disableAnimation: a,
            enableDrawer: l = !1,
            "data-block-id": u
          }) => {
            let {
                state: c
              } = s.useContext(_b),
              d = Rv(i),
              p = jv(i),
              h = "boolean" == typeof l && l || "auto" === l && "mobile" === d;
            (0, je.kG)(c, "ModalContent must be a child of Modal");
            let f = s.useRef(null),
              m = "function" == typeof r ? r(h) : r,
              g = "function" == typeof o ? o(h) : o,
              {
                underlayProps: v,
                overlayProps: y,
                close: b,
                containerHeight: w
              } = function (e, t, n) {
                let {
                    isDisabled: r
                  } = e,
                  o = (0, Ne.JZ)(),
                  [i, a] = s.useState("100vh");
                (0, s.useEffect)(() => {
                  if (!(0, Be.gn)() && !(0, Be.Dt)()) return;
                  let e = (0, Be.kR)(n.current);
                  function t() {
                    a(`${e?.visualViewport.height}px`);
                  }
                  return t(), e?.visualViewport.addEventListener("resize", t), () => {
                    e?.visualViewport.removeEventListener("resize", t);
                  };
                }, [n]);
                let [{
                    y: l
                  }, u] = (0, Ne.q_)(() => ({
                    y: 0,
                    immediate: o,
                    config: {
                      easing: Ne.Z5.easeOutCubic
                    }
                  })),
                  c = (0, s.useRef)(0),
                  d = (0, s.useCallback)(() => {
                    u.start({
                      y: c.current,
                      onRest: () => {
                        t.close();
                      }
                    });
                  }, [u, t]),
                  p = (0, s.useCallback)(e => {
                    e.target.closest("[data-drawer]") || d();
                  }, [d]);
                (0, it.useGranularLayoutEffect)(() => {
                  c.current = n.current?.offsetHeight || 0, u.set({
                    y: c.current
                  }), u.start({
                    y: 0,
                    immediate: !!o
                  });
                }, [], [u, o]);
                let h = l.to({
                  range: [0, c.current / 2, c.current],
                  output: [.5, .2, 0],
                  extrapolate: "clamp"
                }).to(e => `rgba(0,0,0,${e})`);
                return {
                  overlayProps: {
                    style: r ? void 0 : {
                      transform: l.to(e => `translateY(${e}px)`)
                    }
                  },
                  underlayProps: {
                    style: r ? void 0 : {
                      backgroundColor: h
                    },
                    onPointerDown: r ? void 0 : p
                  },
                  close: d,
                  containerHeight: r ? void 0 : i
                };
              }({
                isDisabled: !h,
                isDismissable: m
              }, c, f),
              {
                modalProps: x,
                underlayProps: D
              } = (0, Le.NE)({
                isDismissable: !h,
                isKeyboardDismissDisabled: g
              }, c, f),
              {
                theme: C
              } = (0, s.useContext)(mv),
              S = (0, Ne.JZ)(),
              E = (0, Ne.q_)({
                from: {
                  opacity: 0,
                  transform: "scale(0.95)"
                },
                to: {
                  opacity: 1,
                  transform: "scale(1)"
                },
                immediate: !!S || a,
                config: {
                  easing: Ne.Z5.easeInBounce
                }
              }),
              _ = (0, s.useMemo)(() => ({
                ...x.style,
                ...(h ? {
                  ...y.style,
                  width: "100%"
                } : E)
              }), [y.style, x.style, h, E]),
              P = (0, s.useMemo)(() => ({
                isDrawer: h,
                closeDrawer: b
              }), [h, b]);
            return (0, Ve.jsx)(Le.aV, {
              portalContainer: p,
              children: (0, Ve.jsx)(kb.Provider, {
                value: P,
                children: (0, Ve.jsxs)(Ab, {
                  className: (0, je.AK)(Eb({
                    enableDrawer: h
                  }), t),
                  theme: C,
                  "data-block-id": u,
                  style: {
                    ...n,
                    height: h ? w : "auto",
                    ...Ye({
                      "var(--siobe20)": w
                    })
                  },
                  children: [(0, Ve.jsx)(Ne.q.div, {
                    ...(0, Le.dG)(D, v),
                    onPointerDown: h ? v.onPointerDown : D.onPointerDown,
                    "data-testid": "underlay",
                    style: v.style,
                    className: (0, je.AK)("_1yep5z6ko _1yep5z6kp _1yep5z6kr _1yep5z6kq _1yep5z6g2 _1yep5z6hr _1yep5z6hs _1yep5z6ht", "BaselineUI-Modal-Underlay")
                  }), (0, Ve.jsx)(Ne.q.div, {
                    ...(0, Le.dG)(x, y),
                    style: _,
                    ref: f,
                    "data-drawer": h,
                    className: "BaselineUI-Modal-Content",
                    children: e
                  })]
                })
              })
            });
          }),
          Tb = ({
            children: e,
            style: t,
            ...n
          }) => {
            let {
              state: r
            } = s.useContext(_b);
            (0, je.kG)(r, "ModalContent must be a child of Modal");
            let o = (0, Ne.JZ)();
            return (0, Ne.Yz)(r.isOpen, {
              from: {
                opacity: 0
              },
              enter: {
                opacity: 1
              },
              immediate: !!o || n.disableAnimation
            })((o, i) => i && (0, Ve.jsx)(zb, {
              ...n,
              style: {
                ...t,
                ...o
              },
              children: "function" == typeof e ? e({
                close: r.close
              }) : e
            }));
          },
          Ob = hg({
            defaultClassName: "cjv3et0 _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6fs _1yep5z6d7",
            variantClassNames: {
              size: {
                sm: "cjv3et1",
                md: "cjv3et2",
                lg: "cjv3et3",
                content: "cjv3et4"
              },
              variant: {
                primary: "_1yep5z6121 _1yep5z616i _1yep5z616k",
                ghost: "cjv3et6"
              },
              isDrawer: {
                true: "cjv3et7 _1yep5z6xq _1yep5z6xr _1yep5z6xs _1yep5z6ye _1yep5z6yf _1yep5z6yg _1yep5z6166"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Ib = s.createContext({
            titleProps: {}
          }),
          Fb = s.forwardRef(({
            children: e,
            className: t,
            style: n,
            inheritDrawer: r,
            size: o = "md",
            variant: i = "primary",
            "data-block-id": a,
            drawerBackground: l,
            ...u
          }, c) => {
            let d = s.useRef(null),
              p = s.useRef(null),
              {
                isDrawer: h,
                closeDrawer: f
              } = (0, s.useContext)(kb),
              [m, g] = s.useState("");
            (0, s.useLayoutEffect)(() => {
              let e = p.current?.getRootNode(),
                t = u["aria-label"] || "";
              u["aria-labelledby"] && (t = e?.querySelector(`#${u["aria-labelledby"].replaceAll(":", "\\:")}`)?.textContent || ""), g(t);
            }, [u]);
            let {
                dialogProps: v,
                titleProps: y
              } = (0, Le.Rh)(u, d),
              b = (0, s.useMemo)(() => ({
                titleProps: y
              }), [y]);
            return h && r ? (0, Ve.jsx)(Cb, {
              title: m,
              onCloseRequest: f,
              className: t,
              ...u,
              "data-drawer": !0,
              "data-block-id": a,
              ref: (0, Be.lq)(p, c),
              background: l,
              children: e
            }) : (0, Ve.jsx)(Ib.Provider, {
              value: b,
              children: (0, Ve.jsx)("section", {
                ...v,
                "data-block-id": a,
                ref: (0, Be.lq)(d, c),
                style: n,
                className: (0, je.AK)(Ob({
                  size: h ? "content" : o,
                  variant: i,
                  isDrawer: h
                }), "BaselineUI-Dialog", t),
                children: e
              })
            });
          });
        Fb.displayName = "Dialog";
        var Mb = s.forwardRef(({
          children: e,
          className: t,
          style: n
        }, r) => {
          let {
              titleProps: o
            } = (0, s.useContext)(Ib),
            i = s.isValidElement(e) ? Je : "h3";
          return (0, Ve.jsx)(i, {
            ...o,
            ref: r,
            className: t,
            style: n,
            children: e
          });
        });
        Mb.displayName = "DialogTitle";
        var Rb = {
            ar: {
              add: "إضافة",
              addColor: "إضافة لون",
              cancel: "إلغاء",
              colorFormat: "تنسيق اللون",
              colorPresets: "الألوان المسبقة",
              customColors: "ألوان مخصصة",
              newColor: "لون مخصص جديد",
              noColor: "لا يوجد",
              removeColor: "إزالة اللون",
              transparent: "شفاف"
            },
            cs: {
              add: "Přidat",
              addColor: "Přidat barvu",
              cancel: "Zrušit",
              colorFormat: "Formát barvy",
              colorPresets: "Předvolby barev",
              customColors: "Vlastní barvy",
              newColor: "Vlastní barva",
              noColor: "Není",
              removeColor: "Odebrat barvu",
              transparent: "Průhledná"
            },
            cy: {
              add: "Ychwanegu",
              addColor: "Ychwanegu Lliw",
              cancel: "Canslo",
              colorFormat: "Fformat Lliw",
              colorPresets: "Rhagosodiadau Lliw",
              customColors: "Lliwiau Custom",
              newColor: "Lliw Personol Newydd",
              noColor: "Dim",
              removeColor: "Tynnu Lliw",
              transparent: "Tryloyw"
            },
            da: {
              add: "Tilføj",
              addColor: "Tilføj Farve",
              cancel: "Annuller",
              colorFormat: "Farveformat",
              colorPresets: "Farvevalg",
              customColors: "Brugerdefinerede farver",
              newColor: "Ny tilpasset farve",
              noColor: "Ingen",
              removeColor: "Fjern Farve",
              transparent: "Transparent"
            },
            de: {
              add: "Hinzufügen",
              addColor: "Farbe hinzufügen",
              cancel: "Abbrechen",
              colorFormat: "Farbformat",
              colorPresets: "Farbvorlagen",
              customColors: "Benutzerdefinierte Farben",
              newColor: "Neue benutzerdefinierte Farbe",
              noColor: "Kein",
              removeColor: "Farbe entfernen",
              transparent: "Transparent"
            },
            el: {
              add: "Προσθήκη",
              addColor: "Προσθήκη Χρώματος",
              cancel: "Ακύρωση",
              colorFormat: "Μορφή χρώματος",
              colorPresets: "Προεπιλογές χρωμάτων",
              customColors: "Προσαρμοσμένα Χρώματα",
              newColor: "Νέο προσαρμοσμένο χρώμα",
              noColor: "Κανένας",
              removeColor: "Αφαίρεση Χρώματος",
              transparent: "Ημιδιαφανής"
            },
            "en-GB": {
              add: "Add",
              addColor: "Add Colour",
              cancel: "Cancel",
              colorFormat: "Colour Format",
              colorPresets: "Colour Presets",
              customColors: "Custom Colours",
              newColor: "New Custom Colour",
              noColor: "None",
              removeColor: "Remove Colour",
              transparent: "Transparent"
            },
            en: {
              add: "Add",
              addColor: "Add Color",
              cancel: "Cancel",
              colorFormat: "Color Format",
              colorPresets: "Color Presets",
              customColors: "Custom Colors",
              newColor: "New Custom Color",
              noColor: "None",
              removeColor: "Remove Color",
              transparent: "Transparent"
            },
            es: {
              add: "Añadir",
              addColor: "Añadir color",
              cancel: "Cancelar",
              colorFormat: "Formato de color",
              colorPresets: "Preajustes de color",
              customColors: "Colores personalizados",
              newColor: "Nuevo color personalizado",
              noColor: "Ninguna",
              removeColor: "Eliminar color",
              transparent: "Transparente"
            },
            fi: {
              add: "Lisää",
              addColor: "Lisää väri",
              cancel: "Kumoa",
              colorFormat: "Värimuoto",
              colorPresets: "Värin esiasetukset",
              customColors: "Mukautetut värit",
              newColor: "Uusi muokattu väri",
              noColor: "Ei mitään",
              removeColor: "Poista väri",
              transparent: "Läpinäkyvä"
            },
            "fr-CA": {
              add: "Ajouter",
              addColor: "Ajouter une couleur",
              cancel: "Annuler",
              colorFormat: "Format de couleur",
              colorPresets: "Préréglages de couleur",
              customColors: "Couleurs personnalisées",
              newColor: "Nouvelle couleur personnalisée",
              noColor: "Aucune",
              removeColor: "Supprimer la couleur",
              transparent: "Transparent"
            },
            fr: {
              add: "Ajouter",
              addColor: "Ajouter une couleur",
              cancel: "Annuler",
              colorFormat: "Format de couleur",
              colorPresets: "Préréglages de couleur",
              customColors: "Couleurs personnalisées",
              newColor: "Nouvelle couleur personnalisée",
              noColor: "Aucune",
              removeColor: "Supprimer la couleur",
              transparent: "Transparent"
            },
            he: {
              add: "הוספה",
              addColor: "הוסף צבע",
              cancel: "ביטול",
              colorFormat: "פורמט צבע",
              colorPresets: "מצבי צבע מתוכנתים",
              customColors: "צבעים מותאמים אישית",
              newColor: "צבע מותאם אישית חדש",
              noColor: "ללא",
              removeColor: "הסר צבע",
              transparent: "שקוף"
            },
            hr: {
              add: "Dodati",
              addColor: "Dodaj boju",
              cancel: "Otkaži",
              colorFormat: "Format boje",
              colorPresets: "Prijedlozi boja",
              customColors: "Prilagođene boje",
              newColor: "Nova prilagođena boja",
              noColor: "Prazno",
              removeColor: "Ukloni boju",
              transparent: "Prozirna"
            },
            id: {
              add: "Tambah",
              addColor: "Tambah Warna",
              cancel: "Batalkan",
              colorFormat: "Format Warna",
              colorPresets: "Preset Warna",
              customColors: "Warna Kustom",
              newColor: "Warna Khusus Baru",
              noColor: "Tidak ada",
              removeColor: "Hapus Warna",
              transparent: "Transparan"
            },
            it: {
              add: "Aggiungi",
              addColor: "Aggiungi colore",
              cancel: "Annulla",
              colorFormat: "Formato del colore",
              colorPresets: "Colori predefiniti",
              customColors: "Colori personalizzati",
              newColor: "Nuovo colore personalizzato",
              noColor: "Nessuno",
              removeColor: "Rimuovi colore",
              transparent: "Trasparente"
            },
            ja: {
              add: "追加",
              addColor: "色を追加",
              cancel: "キャンセル",
              colorFormat: "カラーフォーマット",
              colorPresets: "カラープリセット",
              customColors: "カスタムカラー",
              newColor: "新規カスタムカラー",
              noColor: "なし",
              removeColor: "色を削除",
              transparent: "透明"
            },
            ko: {
              add: "추가",
              addColor: "색상 추가",
              cancel: "취소",
              colorFormat: "색상 형식",
              colorPresets: "색상 미리설정",
              customColors: "사용자 정의 색상",
              newColor: "새로운 사용자지정 색상",
              noColor: "없음",
              removeColor: "색상 제거",
              transparent: "투명"
            },
            ms: {
              add: "Tambah",
              addColor: "Tambah Warna",
              cancel: "Batal",
              colorFormat: "Format Warna",
              colorPresets: "Praset Warna",
              customColors: "Warna Kustom",
              newColor: "Warna Tersuai Baharu",
              noColor: "Tiada",
              removeColor: "Buang Warna",
              transparent: "Lut Sinar"
            },
            "nb-NO": {
              add: "Legg til",
              addColor: "Legg til farge",
              cancel: "Avbryt",
              colorFormat: "Fargeformat",
              colorPresets: "Fargeinnstillinger",
              customColors: "Egendefinerte farger",
              newColor: "Ny tilpasset farge",
              noColor: "Ingen",
              removeColor: "Fjern farge",
              transparent: "Gjennomsiktig"
            },
            nl: {
              add: "Voeg toe",
              addColor: "Kleur toevoegen",
              cancel: "Annuleer",
              colorFormat: "Kleurformaat",
              colorPresets: "Kleurvoorinstellingen",
              customColors: "Aangepaste kleuren",
              newColor: "Nieuwe aangepaste kleur",
              noColor: "Geen",
              removeColor: "Kleur verwijderen",
              transparent: "Doorzichtig"
            },
            pl: {
              add: "Dodaj",
              addColor: "Dodaj kolor",
              cancel: "Anuluj",
              colorFormat: "Format koloru",
              colorPresets: "Wstępnie ustawione kolory",
              customColors: "Niestandardowe kolory",
              newColor: "Nowy kolor niestandardowy",
              noColor: "Brak",
              removeColor: "Usuń kolor",
              transparent: "Przeświecające"
            },
            "pt-PT": {
              add: "Adicionar",
              addColor: "Adicionar cor",
              cancel: "Cancelar",
              colorFormat: "Formato de cor",
              colorPresets: "Predefinições de cor",
              customColors: "Cores personalizadas",
              newColor: "Nova cor personalizada",
              noColor: "Nenhum",
              removeColor: "Remover cor",
              transparent: "Transparente"
            },
            pt: {
              add: "Adicionar",
              addColor: "Adicionar cor",
              cancel: "Cancelar",
              colorFormat: "Formato de cor",
              colorPresets: "Pré-ajustes de Cores",
              customColors: "Cores personalizadas",
              newColor: "Nova Cor Personalizada",
              noColor: "Nenhum",
              removeColor: "Remover cor",
              transparent: "Transparente"
            },
            ru: {
              add: "Добавить",
              addColor: "Добавить цвет",
              cancel: "Отменить",
              colorFormat: "Формат цвета",
              colorPresets: "Библиотека цветов",
              customColors: "Пользовательские цвета",
              newColor: "Новый собственный цвет",
              noColor: "Нет",
              removeColor: "Удалить цвет",
              transparent: "Прозрачный"
            },
            sk: {
              add: "Pridať",
              addColor: "Pridať farbu",
              cancel: "Zrušiť",
              colorFormat: "Formát farby",
              colorPresets: "Predvoľby farieb",
              customColors: "Vlastné farby",
              newColor: "Vlastná farba",
              noColor: "Žiadny",
              removeColor: "Odstrániť farbu",
              transparent: "Priehľadná"
            },
            sl: {
              add: "Dodaj",
              addColor: "Dodaj barvo",
              cancel: "Prekliči",
              colorFormat: "Barvni format",
              colorPresets: "Barvne predloge",
              customColors: "Prilagojene barve",
              newColor: "Nova barva po meri",
              noColor: "Prazna stran",
              removeColor: "Odstrani barvo",
              transparent: "Prosojna"
            },
            sv: {
              add: "Lägg till",
              addColor: "Lägg till färg",
              cancel: "Avbryt",
              colorFormat: "Färgformat",
              colorPresets: "Förval för färger",
              customColors: "Anpassade färger",
              newColor: "Ny anpassad färg",
              noColor: "Ingen",
              removeColor: "Ta bort färg",
              transparent: "Genomskinligt"
            },
            th: {
              add: "เพิ่ม",
              addColor: "เพิ่มสี",
              cancel: "ยกเลิก",
              colorFormat: "รูปแบบสี",
              colorPresets: "ค่าสีที่ตั้งไว้ล่วงหน้า",
              customColors: "สีที่กำหนดเอง",
              newColor: "สีที่กำหนดเองใหม่",
              noColor: "ไม่มีเลย",
              removeColor: "ลบสี",
              transparent: "โปร่งใส"
            },
            tr: {
              add: "Ekle",
              addColor: "Renk Ekle",
              cancel: "Vazgeç",
              colorFormat: "Renk Formatı",
              colorPresets: "Renk Önayarları",
              customColors: "Özel Renkler",
              newColor: "Yeni özel renk",
              noColor: "Hiçbiri",
              removeColor: "Rengi Kaldır",
              transparent: "Şeffaf"
            },
            uk: {
              add: "Додати",
              addColor: "Додати колір",
              cancel: "Скасувати",
              colorFormat: "Формат кольору",
              colorPresets: "Бібліотека кольорів",
              customColors: "Користувацькі кольори",
              newColor: "Новий власний колір",
              noColor: "Немає",
              removeColor: "Видалити колір",
              transparent: "Прозорий"
            },
            "zh-Hans": {
              add: "添加",
              addColor: "添加颜色",
              cancel: "取消",
              colorFormat: "颜色格式",
              colorPresets: "颜色预设",
              customColors: "自定义颜色",
              newColor: "新自定义颜色",
              noColor: "无",
              removeColor: "移除颜色",
              transparent: "透明"
            },
            "zh-Hant": {
              add: "加入",
              addColor: "添加顏色",
              cancel: "取消",
              colorFormat: "顏色格式",
              colorPresets: "顏色預設項",
              customColors: "自訂顏色",
              newColor: "新自訂顏色",
              noColor: "無",
              removeColor: "移除顏色",
              transparent: "透明"
            }
          },
          jb = ({
            children: e
          }) => {
            let {
              triggerProps: t
            } = s.useContext(_b);
            return (0, Ve.jsx)(Je, {
              ...t,
              children: e
            });
          };
        jb.displayName = "ModalTrigger";
        var Bb = ({
            children: e
          }) => {
            let {
              state: t
            } = s.useContext(_b);
            return (0, Ve.jsx)(Je, {
              onPress: () => t?.close(),
              children: e
            });
          },
          Nb = s.forwardRef((e, t) => {
            let {
              state: n,
              overlayTriggerAria: {
                overlayProps: r
              },
              triggerRef: o
            } = (0, s.useContext)(zg);
            return (0, je.kG)(o), n?.isOpen ? (0, Ve.jsx)(Hv, {
              ref: t,
              ...e,
              triggerRef: e.triggerRef || o,
              overlayProps: r,
              state: n
            }) : null;
          });
        Nb.displayName = "PopoverContent";
        var Lb = hg({
            defaultClassName: "_1dbkl54 _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6l6 _1yep5z6ky _1yep5z69i _1yep5z69j _1yep5z69k _1yep5z6eu _1yep5z6kx _1yep5z6dy",
            variantClassNames: {
              isHovered: {
                true: "_1dbkl55"
              },
              isFocusVisible: {
                true: "_1dbkl56"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z6109"
              },
              labelPosition: {
                top: "_1dbkl58",
                start: "_1dbkl59"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Vb = hg({
            defaultClassName: "_1dbkl50 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6dy _1yep5z6ev",
            variantClassNames: {
              labelPosition: {
                top: "_1yep5z6nq _1yep5z6nr _1yep5z6ns",
                start: "_1dbkl52"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Kb = "_1dbkl5t _1yep5z6i6 _1yep5z6i7 _1yep5z6i8 _1yep5z69f _1yep5z69g _1yep5z69h",
          qb = "_1dbkl5u _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6hl _1yep5z6hm _1yep5z6hn",
          Hb = hg({
            defaultClassName: "_1dbkl5h _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6hl _1yep5z6hm _1yep5z6hn _1yep5z6kx _1yep5z6ks",
            variantClassNames: {
              isFocusVisible: {
                true: "_1dbkl5i _1dbkl5g"
              },
              isDisabled: {
                true: "_1yep5z6yl"
              },
              removeBlendMode: {
                true: "_1dbkl5k"
              },
              isSelected: {
                true: "_1dbkl5g"
              },
              isHovered: {
                true: "_1dbkl5g"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Ub = "_1dbkl5n _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6ko _1yep5z6kp _1yep5z6kr _1yep5z6kq _1yep5z6ho _1yep5z6hp _1yep5z6hq _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn",
          Zb = hg({
            defaultClassName: "_1dbkl5p _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6fs",
            variantClassNames: {
              includesCustomColorPicker: {
                true: "_1yep5z6me _1yep5z6mf _1yep5z6mg"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          $b = "_1dbkl514 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
          Gb = hg({
            defaultClassName: "_1dbkl5z _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6br _1yep5z6bs _1yep5z6bt _1yep5z6d3 _1yep5z6d4 _1yep5z6d5 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6l7 _1yep5z6gq _1yep5z6ky _1yep5z6eu _1yep5z6dy",
            variantClassNames: {
              isFocused: {
                true: "_1dbkl510 _1yep5z611y"
              },
              isHovered: {
                true: "_1dbkl511"
              },
              allowAlpha: {
                false: "_1yep5z6wh _1yep5z6wi _1yep5z6wj _1yep5z6xt _1yep5z6xu _1yep5z6xv _1yep5z6166"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isHovered: !0,
              isFocused: !1
            }, "_1yep5z61nd"]]
          }),
          Wb = hg({
            defaultClassName: "_1dbkl5a _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62c _1yep5z62d _1yep5z62e _1yep5z63i _1yep5z63j _1yep5z63k _1yep5z616 _1yep5z617 _1yep5z618 _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69c _1yep5z69d _1yep5z69e _1yep5z6f0 _1yep5z6kx _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6ki _1yep5z6kl",
            variantClassNames: {
              isHovered: {
                true: "_1yep5z6115"
              },
              isFocusVisible: {
                true: "_1yep5z616c _1yep5z616a _1yep5z616d _1yep5z612n"
              },
              isDisabled: {
                true: "_1yep5z610d"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Yb = "_1dbkl513",
          Xb = "_1dbkl5o _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6d7",
          Qb = "_1dbkl5r _1yep5z69 _1yep5z6a _1yep5z6b _1yep5z62l _1yep5z62m _1yep5z62n _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69f _1yep5z69g _1yep5z69h",
          Jb = "_1dbkl516",
          ew = "_1yep5z69 _1yep5z6a _1yep5z6b _1yep5z62l _1yep5z62m _1yep5z62n _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69l _1yep5z69m _1yep5z69n",
          tw = hg({
            defaultClassName: "_1dbkl5w _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6l2 _1yep5z6ho _1yep5z6hp _1yep5z6hq _1yep5z6l7 _1yep5z6la",
            variantClassNames: {
              isFocusVisible: {
                true: "_1dbkl5x _1yep5z616a _1yep5z612n _1yep5z616c"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          nw = "z9nup84 z9nup86 _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6ko _1yep5z6kp _1yep5z6kr _1yep5z6kq _1yep5z6ho _1yep5z6hp _1yep5z6hq",
          rw = ({
            color: e,
            isFocusVisible: t,
            isDisabled: n,
            isSelected: r,
            isPresentational: o
          }) => {
            let i = e && e !== uw && (0, ut.lu)(e),
              a = i && 0 === i.getChannelValue("alpha"),
              {
                hoverProps: s,
                isHovered: l
              } = (0, Le.XI)({
                isDisabled: n
              });
            return (0, Ve.jsx)("div", {
              ...s,
              className: (0, je.AK)(Hb({
                removeBlendMode: !i,
                isFocusVisible: t,
                isDisabled: n,
                isSelected: r,
                isHovered: l && !o && !n
              }), {
                [Ng({
                  size: "xs"
                })]: a
              }),
              children: i ? (0, Ve.jsxs)(Ve.Fragment, {
                children: [(0, Ve.jsx)("div", {
                  className: (0, je.AK)(Ub, Ng({
                    size: "xs"
                  }))
                }), (0, Ve.jsx)("div", {
                  className: Ub,
                  style: {
                    backgroundColor: a ? void 0 : i.toString("hexa")
                  }
                })]
              }) : (0, Ve.jsx)("div", {
                className: Ub,
                children: (0, Ve.jsx)(Ue.zs, {
                  size: 14
                })
              })
            });
          },
          ow = [{
            id: "hex",
            label: "HEX"
          }, {
            id: "rgb",
            label: "RGB"
          }],
          iw = (0, ut.lu)("#000000").toFormat("hsla"),
          aw = "hsla",
          sw = "hexa";
        function lw(e) {
          return "string" == typeof e ? (0, ut.lu)(e).toFormat(aw) : e ? e.toFormat(aw) : null;
        }
        var uw = "NONE";
        var cw = (e, {
            optionProps: t,
            isFocusVisible: n,
            isSelected: r
          }, o) => ((0, je.kG)(e.value && "label" in e.value, "Item must have label"), (0, Ve.jsx)("li", {
            ...t,
            ref: o,
            "aria-label": e.value?.label || void 0,
            className: "_1dbkl5s _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6ky",
            children: (0, Ve.jsx)(rw, {
              color: e.value.id,
              isFocusVisible: n,
              isSelected: r
            })
          })),
          dw = ({
            value: e,
            ...t
          }) => {
            let n = s.useRef(null),
              r = s.useRef(null),
              o = s.useRef(null),
              i = (0, ut.Eg)({
                ...t,
                value: e
              }),
              {
                colorAreaProps: a,
                gradientProps: l,
                xInputProps: u,
                yInputProps: c,
                thumbProps: d
              } = function (e, t) {
                let {
                    isDisabled: n,
                    inputXRef: r,
                    inputYRef: o,
                    containerRef: i,
                    "aria-label": a,
                    xName: l,
                    yName: u
                  } = e,
                  c = (0, Ht.qb)(Wt(Yt), "@react-aria/color"),
                  {
                    addGlobalListener: d,
                    removeGlobalListener: p
                  } = (0, Be.xi)(),
                  {
                    direction: h,
                    locale: f
                  } = (0, Ht.bU)(),
                  [m, g] = (0, s.useState)(null),
                  v = (0, s.useCallback)((e = r) => {
                    e.current && (0, Be.Ao)(e.current);
                  }, [r]);
                (0, Be.y$)(r, [t.xValue, t.yValue], ([e, n]) => {
                  let r = t.value.withChannelValue(t.channels.xChannel, e).withChannelValue(t.channels.yChannel, n);
                  t.setValue(r);
                });
                let [y, b] = (0, s.useState)(!1),
                  {
                    xChannel: w,
                    yChannel: x,
                    zChannel: D
                  } = t.channels,
                  C = t.xChannelStep,
                  S = t.yChannelStep,
                  E = (0, s.useRef)(null),
                  {
                    keyboardProps: _
                  } = (0, qt.v5)({
                    onKeyDown(e) {
                      if (!/^(PageUp|PageDown|Home|End)$/.test(e.key)) return void e.continuePropagation();
                      let n;
                      switch (e.preventDefault(), t.setDragging(!0), b(!0), e.key) {
                        case "PageUp":
                          t.incrementY(t.yChannelPageStep), n = "y";
                          break;
                        case "PageDown":
                          t.decrementY(t.yChannelPageStep), n = "y";
                          break;
                        case "Home":
                          "rtl" === h ? t.incrementX(t.xChannelPageStep) : t.decrementX(t.xChannelPageStep), n = "x";
                          break;
                        case "End":
                          "rtl" === h ? t.decrementX(t.xChannelPageStep) : t.incrementX(t.xChannelPageStep), n = "x";
                      }
                      t.setDragging(!1), n && (v("x" === n ? r : o), g(n));
                    }
                  }),
                  P = {
                    onMoveStart() {
                      E.current = null, t.setDragging(!0);
                    },
                    onMove({
                      deltaX: e,
                      deltaY: n,
                      pointerType: r,
                      shiftKey: o
                    }) {
                      var a;
                      let {
                        incrementX: s,
                        decrementX: l,
                        incrementY: u,
                        decrementY: c,
                        xChannelPageStep: d,
                        xChannelStep: p,
                        yChannelPageStep: f,
                        yChannelStep: v,
                        getThumbPosition: y,
                        setColorFromPoint: w
                      } = t;
                      null == E.current && (E.current = y());
                      let {
                          width: x,
                          height: D
                        } = (null === (a = i.current) || void 0 === a ? void 0 : a.getBoundingClientRect()) || {
                          width: 0,
                          height: 0
                        },
                        C = 0 !== e || 0 !== n;
                      if ("keyboard" === r) {
                        let t = o && d > p ? d : p,
                          r = o && f > v ? f : v;
                        e > 0 && "ltr" === h || e < 0 && "rtl" === h ? s(t) : e < 0 && "ltr" === h || e > 0 && "rtl" === h ? l(t) : n > 0 ? c(r) : n < 0 && u(r), b(C), m = C && Math.abs(n) > Math.abs(e) ? "y" : "x", g(m);
                      } else E.current.x += ("rtl" === h ? -1 : 1) * e / x, E.current.y += n / D, w(E.current.x, E.current.y);
                    },
                    onMoveEnd() {
                      T.current = !1, t.setDragging(!1), v("x" === m ? r : o);
                    }
                  },
                  {
                    moveProps: k
                  } = (0, qt.r_)(P),
                  {
                    focusWithinProps: A
                  } = (0, qt.L_)({
                    onFocusWithinChange: e => {
                      e || b(!1);
                    }
                  }),
                  z = (0, s.useRef)(void 0),
                  T = (0, s.useRef)(!1),
                  {
                    moveProps: O
                  } = (0, qt.r_)({
                    onMoveStart() {
                      T.current && P.onMoveStart();
                    },
                    onMove(e) {
                      T.current && P.onMove(e);
                    },
                    onMoveEnd() {
                      T.current && P.onMoveEnd();
                    }
                  }),
                  I = e => {
                    t.isDragging || (z.current = e, b(!1), v(), t.setDragging(!0), "undefined" != typeof PointerEvent ? d(window, "pointerup", F, !1) : (d(window, "mouseup", F, !1), d(window, "touchend", F, !1)));
                  },
                  F = e => {
                    var n, r;
                    (null !== (r = e.pointerId) && void 0 !== r ? r : null === (n = e.changedTouches) || void 0 === n ? void 0 : n[0].identifier) === z.current && (b(!1), v(), t.setDragging(!1), z.current = void 0, T.current = !1, "undefined" != typeof PointerEvent ? p(window, "pointerup", F, !1) : (p(window, "mouseup", F, !1), p(window, "touchend", F, !1)));
                  },
                  M = (e, n, r, o) => {
                    let i = e.getBoundingClientRect(),
                      {
                        width: a,
                        height: s
                      } = i,
                      l = (r - i.x) / a,
                      u = (o - i.y) / s;
                    "rtl" === h && (l = 1 - l), l >= 0 && l <= 1 && u >= 0 && u <= 1 && !t.isDragging && void 0 === z.current && (T.current = !0, b(!1), z.current = n, t.setColorFromPoint(l, u), v(), t.setDragging(!0), "undefined" != typeof PointerEvent ? d(window, "pointerup", R, !1) : (d(window, "mouseup", R, !1), d(window, "touchend", R, !1)));
                  },
                  R = e => {
                    var n, r;
                    let o = null !== (r = e.pointerId) && void 0 !== r ? r : null === (n = e.changedTouches) || void 0 === n ? void 0 : n[0].identifier;
                    T.current && o === z.current && (T.current = !1, b(!1), z.current = void 0, t.setDragging(!1), v(), "undefined" != typeof PointerEvent ? p(window, "pointerup", R, !1) : (p(window, "mouseup", R, !1), p(window, "touchend", R, !1)));
                  },
                  j = n ? {} : (0, Be.dG)({
                    ...("undefined" != typeof PointerEvent ? {
                      onPointerDown: e => {
                        "mouse" === e.pointerType && (0 !== e.button || e.altKey || e.ctrlKey || e.metaKey) || M(e.currentTarget, e.pointerId, e.clientX, e.clientY);
                      }
                    } : {
                      onMouseDown: e => {
                        0 !== e.button || e.altKey || e.ctrlKey || e.metaKey || M(e.currentTarget, void 0, e.clientX, e.clientY);
                      },
                      onTouchStart: e => {
                        M(e.currentTarget, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
                      }
                    })
                  }, O),
                  B = n ? {} : (0, Be.dG)({
                    ...("undefined" != typeof PointerEvent ? {
                      onPointerDown: e => {
                        "mouse" === e.pointerType && (0 !== e.button || e.altKey || e.ctrlKey || e.metaKey) || I(e.pointerId);
                      }
                    } : {
                      onMouseDown: e => {
                        0 !== e.button || e.altKey || e.ctrlKey || e.metaKey || I(void 0);
                      },
                      onTouchStart: e => {
                        I(e.changedTouches[0].identifier);
                      }
                    })
                  }, A, _, k),
                  {
                    focusProps: N
                  } = (0, qt.KK)({
                    onFocus: () => {
                      g("x");
                    }
                  }),
                  {
                    focusProps: L
                  } = (0, qt.KK)({
                    onFocus: () => {
                      g("y");
                    }
                  }),
                  V = (0, Be.gn)() || (0, Be.Dt)();
                function K(e) {
                  return y ? c.format("colorNameAndValue", {
                    name: t.value.getChannelName(e, f),
                    value: t.value.formatChannelValue(e, f)
                  }) : [c.format("colorNameAndValue", {
                    name: t.value.getChannelName(e, f),
                    value: t.value.formatChannelValue(e, f)
                  }), c.format("colorNameAndValue", {
                    name: t.value.getChannelName(e === x ? w : x, f),
                    value: t.value.formatChannelValue(e === x ? w : x, f)
                  })].join(", ");
                }
                let q = c.format("colorPicker"),
                  H = (0, Be.bE)({
                    ...e,
                    "aria-label": a ? c.format("colorInputLabel", {
                      label: a,
                      channelLabel: q
                    }) : q
                  }),
                  U = (0, Be.bE)({
                    ...e,
                    "aria-label": a ? c.format("colorInputLabel", {
                      label: a,
                      channelLabel: q
                    }) : q
                  }),
                  Z = (0, Be.bE)({
                    ...e,
                    "aria-label": a ? `${a}, ${q}` : void 0
                  }, V ? q : void 0),
                  $ = c.format("twoDimensionalSlider"),
                  {
                    visuallyHiddenProps: G
                  } = (0, Ut.S)({
                    style: {
                      opacity: "0.0001",
                      width: "100%",
                      height: "100%",
                      pointerEvents: "none"
                    }
                  }),
                  {
                    colorAreaStyleProps: W,
                    gradientStyleProps: Y,
                    thumbStyleProps: X
                  } = Xt({
                    direction: h,
                    state: t,
                    xChannel: w,
                    zChannel: D,
                    isDisabled: e.isDisabled
                  });
                return {
                  colorAreaProps: {
                    ...Z,
                    ...j,
                    ...W,
                    role: "group"
                  },
                  gradientProps: {
                    ...Y,
                    role: "presentation"
                  },
                  thumbProps: {
                    ...B,
                    ...X,
                    role: "presentation"
                  },
                  xInputProps: {
                    ...H,
                    ...G,
                    ...N,
                    type: "range",
                    min: t.value.getChannelRange(w).minValue,
                    max: t.value.getChannelRange(w).maxValue,
                    step: C,
                    "aria-roledescription": $,
                    "aria-valuetext": K(w),
                    disabled: n,
                    value: t.value.getChannelValue(w),
                    name: l,
                    tabIndex: V || !m || "x" === m ? void 0 : -1,
                    "aria-hidden": V || !m || "x" === m || y ? void 0 : "true",
                    onChange: e => {
                      t.setXValue(parseFloat(e.target.value));
                    }
                  },
                  yInputProps: {
                    ...U,
                    ...G,
                    ...L,
                    type: "range",
                    min: t.value.getChannelRange(x).minValue,
                    max: t.value.getChannelRange(x).maxValue,
                    step: S,
                    "aria-roledescription": $,
                    "aria-valuetext": K(x),
                    "aria-orientation": "vertical",
                    disabled: n,
                    value: t.value.getChannelValue(x),
                    name: u,
                    tabIndex: V || "y" === m ? void 0 : -1,
                    "aria-hidden": V || "y" === m || y ? void 0 : "true",
                    onChange: e => {
                      t.setYValue(parseFloat(e.target.value));
                    }
                  }
                };
              }({
                ...t,
                value: e,
                inputXRef: n,
                inputYRef: r,
                containerRef: o
              }, i);
            (0, s.useEffect)(() => {
              n.current?.focus();
            }, []);
            let {
              focusProps: p,
              isFocusVisible: h
            } = (0, Le.Fx)();
            return (0, Ve.jsxs)("div", {
              ref: o,
              ...a,
              className: (0, je.AK)("_1dbkl5v", "BaselineUI-ColorInput-ColorArea"),
              children: [(0, Ve.jsx)("div", {
                ...l,
                className: "_1dbkl53"
              }), (0, Ve.jsxs)("div", {
                ...d,
                className: (0, je.AK)(tw({
                  isFocusVisible: h
                }), "BaselineUI-ColorInput-ColorAreaThumb"),
                style: {
                  ...d.style,
                  transform: "translate(-50%, -50%)",
                  backgroundColor: lw(e)?.withChannelValue("alpha", 1).toString("css")
                },
                children: [(0, Ve.jsx)("input", {
                  ref: n,
                  ...u,
                  ...p
                }), (0, Ve.jsx)("input", {
                  ref: r,
                  ...c,
                  ...p
                })]
              })]
            });
          },
          pw = ({
            color: e,
            setColor: t,
            allowAlpha: n,
            ...r
          }) => {
            let o = (0, ut.jF)({
                value: e,
                onChange: n => {
                  t(lw(n)?.toFormat(aw).withChannelValue("alpha", e.getChannelValue("alpha") ?? 1) || iw);
                }
              }),
              i = s.useRef(null),
              {
                inputProps: a
              } = function (e, t, n) {
                let {
                    isDisabled: r,
                    isReadOnly: o,
                    isRequired: i,
                    isWheelDisabled: a,
                    validationBehavior: l = "aria"
                  } = e,
                  {
                    colorValue: c,
                    inputValue: d,
                    increment: p,
                    decrement: h,
                    incrementToMax: f,
                    decrementToMin: m,
                    commit: g
                  } = t,
                  v = (0, Be.Me)(),
                  {
                    spinButtonProps: y
                  } = (0, Gt.G)({
                    isDisabled: r,
                    isReadOnly: o,
                    isRequired: i,
                    maxValue: 16777215,
                    minValue: 0,
                    onIncrement: p,
                    onIncrementToMax: f,
                    onDecrement: h,
                    onDecrementToMin: m,
                    value: c ? c.toHexInt() : void 0,
                    textValue: c ? c.toString("hex") : void 0
                  }),
                  [b, w] = (0, s.useState)(!1),
                  {
                    focusWithinProps: x
                  } = (0, qt.L_)({
                    isDisabled: r,
                    onFocusWithinChange: w
                  }),
                  D = (0, s.useCallback)(e => {
                    Math.abs(e.deltaY) <= Math.abs(e.deltaX) || (e.deltaY > 0 ? p() : e.deltaY < 0 && h());
                  }, [h, p]),
                  C = a || r || o || !b;
                (0, qt.y0)({
                  onScroll: D,
                  isDisabled: C
                }, n);
                let {
                  inputProps: S,
                  ...E
                } = (0, $t.h)((0, Be.dG)(e, {
                  id: v,
                  value: d,
                  defaultValue: void 0,
                  validate: void 0,
                  [u.tL]: t,
                  type: "text",
                  autoComplete: "off",
                  onChange: e => {
                    t.validate(e) && t.setInputValue(e);
                  }
                }), t, n);
                return S = (0, Be.dG)(S, y, x, {
                  role: "textbox",
                  "aria-valuemax": null,
                  "aria-valuemin": null,
                  "aria-valuenow": null,
                  "aria-valuetext": null,
                  autoCorrect: "off",
                  spellCheck: "false",
                  onBlur: g
                }), "native" === l && (S["aria-required"] = void 0), {
                  inputProps: S,
                  ...E
                };
              }({
                ...r,
                "aria-label": "Hex"
              }, o, i),
              {
                focusProps: l,
                isFocused: c
              } = (0, Le.Fx)({
                isTextInput: !0
              }),
              {
                hoverProps: d,
                isHovered: p
              } = (0, Le.XI)({});
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)($b, "BaselineUI-ColorInput-FieldInput"),
              "data-color-mode": n ? "hexa" : "hex",
              children: [(0, Ve.jsx)("input", {
                ...(0, Le.dG)(a, l, d),
                ref: i,
                className: Gb({
                  isFocused: c,
                  isHovered: p,
                  allowAlpha: n
                })
              }), n ? (0, Ve.jsx)(mw, {
                color: e,
                setColor: t
              }) : null]
            });
          },
          hw = ({
            color: e,
            setColor: t,
            allowAlpha: n
          }) => {
            let r = e.toFormat("rgba"),
              {
                locale: o
              } = (0, Le.bU)();
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)($b, "BaselineUI-ColorInput-FieldInput"),
              "data-color-mode": n ? "rgba" : "rgb",
              children: [(0, Ve.jsx)(rv, {
                "aria-label": e.getChannelName("red", o),
                value: r.getChannelValue("red"),
                showStepper: !1,
                className: Yb,
                onChange: e => {
                  t(r.withChannelValue("red", e).toFormat(aw));
                },
                step: 1,
                minValue: 0,
                maxValue: 255
              }), (0, Ve.jsx)(rv, {
                "aria-label": e.getChannelName("green", o),
                value: r.getChannelValue("green"),
                showStepper: !1,
                className: Yb,
                onChange: e => {
                  t(r.withChannelValue("green", e).toFormat(aw));
                },
                step: 1,
                minValue: 0,
                maxValue: 255
              }), (0, Ve.jsx)(rv, {
                "aria-label": e.getChannelName("blue", o),
                value: r.getChannelValue("blue"),
                showStepper: !1,
                className: Yb,
                onChange: e => {
                  t(r.withChannelValue("blue", e).toFormat(aw));
                },
                step: 1,
                minValue: 0,
                maxValue: 255
              }), n ? (0, Ve.jsx)(mw, {
                color: e,
                setColor: t
              }) : null]
            });
          },
          fw = {
            style: "percent",
            maximumFractionDigits: 0
          },
          mw = ({
            color: e,
            setColor: t
          }) => {
            let {
                locale: n
              } = (0, Le.bU)(),
              r = (0, s.useCallback)(n => {
                t(e.withChannelValue("alpha", n));
              }, [e, t]);
            return (0, Ve.jsx)(rv, {
              "aria-label": e.getChannelName("alpha", n),
              value: e.getChannelValue("alpha"),
              formatOptions: fw,
              className: Yb,
              showStepper: !1,
              onChange: r,
              minValue: 0,
              maxValue: 1
            });
          },
          gw = ({
            channel: e,
            ...t
          }) => {
            let {
                locale: n
              } = (0, Le.bU)(),
              r = (0, ut.Y3)({
                ...t,
                channel: e,
                locale: n
              }),
              o = s.useRef(null),
              i = s.useRef(null),
              {
                trackProps: a,
                thumbProps: l,
                inputProps: u
              } = function (e, t) {
                let {
                    trackRef: n,
                    inputRef: r,
                    orientation: o,
                    channel: i,
                    "aria-label": a,
                    name: s
                  } = e,
                  {
                    locale: l,
                    direction: u
                  } = (0, Ht.bU)();
                e.label || a || e["aria-labelledby"] || (a = t.value.getChannelName(i, l));
                let {
                    groupProps: c,
                    trackProps: d,
                    labelProps: p,
                    outputProps: h
                  } = (0, Zt.o)({
                    ...e,
                    "aria-label": a
                  }, t, n),
                  {
                    inputProps: f,
                    thumbProps: m
                  } = (0, Zt.p)({
                    index: 0,
                    orientation: o,
                    isDisabled: e.isDisabled,
                    name: s,
                    trackRef: n,
                    inputRef: r
                  }, t),
                  g = {
                    forcedColorAdjust: "none"
                  };
                return {
                  trackProps: {
                    ...(0, Be.dG)(c, d),
                    style: {
                      ...d.style,
                      ...g,
                      background: (() => {
                        let e,
                          n = t.getDisplayColor();
                        switch (e = "vertical" === o ? "top" : "ltr" === u ? "right" : "left", i) {
                          case "hue":
                            return `linear-gradient(to ${e}, rgb(255, 0, 0) 0%, rgb(255, 255, 0) 17%, rgb(0, 255, 0) 33%, rgb(0, 255, 255) 50%, rgb(0, 0, 255) 67%, rgb(255, 0, 255) 83%, rgb(255, 0, 0) 100%)`;
                          case "lightness":
                            {
                              let r = t.getThumbMinValue(0),
                                o = t.getThumbMaxValue(0);
                              return `linear-gradient(to ${e}, ${n.withChannelValue(i, r).toString("css")}, ${n.withChannelValue(i, (o - r) / 2).toString("css")}, ${n.withChannelValue(i, o).toString("css")})`;
                            }
                          case "saturation":
                          case "brightness":
                          case "red":
                          case "green":
                          case "blue":
                          case "alpha":
                            return `linear-gradient(to ${e}, ${n.withChannelValue(i, t.getThumbMinValue(0)).toString("css")}, ${n.withChannelValue(i, t.getThumbMaxValue(0)).toString("css")})`;
                          default:
                            throw new Error("Unknown color channel: " + i);
                        }
                      })()
                    }
                  },
                  inputProps: f,
                  thumbProps: {
                    ...m,
                    style: {
                      ...m.style,
                      ...g
                    }
                  },
                  labelProps: p,
                  outputProps: h
                };
              }({
                ...t,
                channel: e,
                trackRef: o,
                inputRef: i,
                "aria-label": r.value.getChannelName(e, n)
              }, r),
              {
                focusProps: c,
                isFocusVisible: d
              } = (0, Le.Fx)();
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)(qb, {
                [Ng({
                  size: "xs"
                })]: "alpha" === e
              }, "BaselineUI-ColorInput-ColorSlider"),
              "data-channel": e,
              ...a,
              ref: o,
              children: ["alpha" === e && (0, Ve.jsx)("div", {
                className: nw
              }), (0, Ve.jsx)("div", {
                className: qb,
                style: a.style
              }), (0, Ve.jsxs)("div", {
                className: (0, je.AK)(tw({
                  isFocusVisible: d
                }), "BaselineUI-ColorInput-ColorSliderThumb"),
                ...l,
                children: [(0, Ve.jsx)("div", {
                  className: nw,
                  style: {
                    backgroundColor: "#ffffff"
                  }
                }), (0, Ve.jsx)("div", {
                  style: {
                    backgroundColor: r.getDisplayColor().toString("css"),
                    height: 8
                  },
                  className: qb
                }), (0, Ve.jsx)(Le.TX, {
                  children: (0, Ve.jsx)("input", {
                    ref: i,
                    ...u,
                    ...c
                  })
                })]
              })]
            });
          },
          vw = ({
            color: e,
            setColor: t,
            allowAlpha: n
          }) => {
            let [r, o] = s.useState("hex"),
              {
                formatMessage: i
              } = Tv(Rb);
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: [(0, Ve.jsx)(dw, {
                value: e,
                xChannel: "saturation",
                yChannel: "lightness",
                onChange: t
              }), (0, Ve.jsxs)("div", {
                className: ew,
                children: [(0, Ve.jsx)(gw, {
                  channel: "hue",
                  value: e,
                  onChange: t
                }), n ? (0, Ve.jsx)(gw, {
                  channel: "alpha",
                  value: e,
                  onChange: t
                }) : null]
              }), (0, Ve.jsxs)("div", {
                className: (0, je.AK)(ew, qe.Kj.variants({
                  paddingTop: "none",
                  gap: "sm"
                })),
                children: [(0, Ve.jsx)(Qy, {
                  label: i("colorFormat"),
                  labelPosition: "start",
                  variant: "ghost",
                  items: ow,
                  selectedKey: r,
                  onSelectionChange: e => {
                    o(e);
                  }
                }), "hex" === r && (0, Ve.jsx)(pw, {
                  color: e,
                  setColor: t,
                  allowAlpha: n
                }), "rgb" === r && (0, Ve.jsx)(hw, {
                  color: e,
                  setColor: t,
                  allowAlpha: n
                })]
              })]
            });
          },
          yw = ({
            color: e,
            setColor: t,
            storePickedColorKey: n,
            addColorButtonLabel: r,
            removeColorButtonLabel: o,
            customColorsLabel: i,
            pickerMode: a,
            allowAlpha: l
          }) => {
            let {
                formatMessage: u
              } = Tv(Rb),
              c = s.useRef(null),
              d = Rv(c.current),
              [p, h] = Fv(n, []),
              f = s.useRef(null),
              [m, g] = s.useState(e),
              v = s.useMemo(() => p.map(e => ({
                id: e,
                label: e,
                description: e
              })), [p]),
              y = (0, s.useCallback)(() => {
                let t = "active" === a ? e : m;
                p.includes(t.toString(aw)) ? f.current?.querySelector(`[data-key='${t.toString(aw)}']`)?.classList.add(Jb) : h([...p, t.toString(aw)]);
              }, [p, e, h, m, a]);
            (0, s.useEffect)(() => {
              let e = f.current;
              function t(e) {
                "_1dbkl515" === e.animationName && e.target?.classList.remove(Jb);
              }
              return e?.addEventListener("animationend", t), () => {
                e?.removeEventListener("animationend", t);
              };
            }, []);
            let b = (0, Le.Me)(),
              w = (0, Ve.jsx)(nv, {
                ref: c,
                variant: "secondary",
                size: "md",
                "aria-label": r,
                icon: $e.pO,
                onPress: "active" === a ? y : void 0
              }),
              x = (0, s.useCallback)(e => (0, Ve.jsxs)(Fb, {
                size: "content",
                className: Zb({
                  includesCustomColorPicker: !0
                }),
                style: {
                  paddingBlockEnd: 0
                },
                "aria-label": u("newColor"),
                children: [(0, Ve.jsx)(vw, {
                  color: m,
                  setColor: g,
                  allowAlpha: l
                }), (0, Ve.jsx)(yg, {}), (0, Ve.jsx)(wg, {
                  padding: "lg",
                  display: "flex",
                  flexDirection: "row-reverse",
                  children: (0, Ve.jsxs)(wg, {
                    display: "inline-flex",
                    gap: "lg",
                    children: [(0, Ve.jsx)(Bg, {
                      label: u("cancel"),
                      size: "sm",
                      variant: "secondary",
                      onPress: e
                    }), (0, Ve.jsx)(Bg, {
                      label: u("add"),
                      variant: "primary",
                      onPress: () => {
                        y(), e();
                      },
                      size: "sm"
                    })]
                  })
                })]
              }), [m, y, u, l]),
              D = (0, s.useCallback)(e => {
                (0, je.kG)(e instanceof Set, "Key must be a set");
                let n = [...e][0];
                n && t((0, ut.lu)(n).toFormat(aw));
              }, [t]);
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: [(0, Ve.jsx)(yg, {}), (0, Ve.jsxs)("div", {
                className: (0, je.AK)("_1yep5z63r _1yep5z63s _1yep5z63t _1yep5z619 _1yep5z61a _1yep5z61b _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6dy _1yep5z6ev _1yep5z69l _1yep5z69m _1yep5z69n _1yep5z6ir _1yep5z6is _1yep5z6it", "BaselineUI-ColorInput-CustomColors"),
                children: [(0, Ve.jsx)("span", {
                  id: b,
                  children: i
                }), (0, Ve.jsxs)(wg, {
                  display: "flex",
                  children: [!!p.length && p.includes(e.toString(aw)) && (0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "md",
                    elementType: "div",
                    icon: $e.V_,
                    "aria-label": o,
                    onPress: () => {
                      h(p.filter(t => t !== e.toString(aw)));
                    }
                  }), "active" === a && w, "lazy" === a && ("mobile" === d ? (0, Ve.jsxs)(Pb, {
                    children: [(0, Ve.jsx)(jb, {
                      children: w
                    }), (0, Ve.jsx)(Tb, {
                      style: {
                        zIndex: 1e5
                      },
                      children: ({
                        close: e
                      }) => x(e)
                    })]
                  }) : (0, Ve.jsx)(Tg, {
                    type: "dialog",
                    children: ({
                      close: e
                    }) => (0, Ve.jsxs)(Ve.Fragment, {
                      children: [(0, Ve.jsx)(Ig, {
                        children: w
                      }), (0, Ve.jsx)(Nb, {
                        placement: "right top",
                        className: Xb,
                        offset: 6,
                        children: x(e)
                      })]
                    })
                  }))]
                })]
              }), !!p.length && (0, Ve.jsx)(Pg, {
                items: v,
                layout: "grid",
                "aria-labelledby": b,
                className: (0, je.AK)(Kb, Qb, qe.Kj.variants({
                  paddingTop: "xs"
                }), "BaselineUI-ColorInput-CustomColorsListBox"),
                renderOption: cw,
                ref: f,
                autoFocus: !1,
                selectionMode: "single",
                selectedKeys: [e.toString(aw)],
                onSelectionChange: D
              })]
            });
          },
          bw = s.forwardRef(({
            setColor: e,
            color: t,
            triggerRef: n,
            autoFocus: r,
            presets: o,
            state: i
          }, a) => {
            let {
                formatMessage: l
              } = Tv(Rb),
              u = (0, s.useCallback)(t => {
                if (t instanceof Set && t.size) {
                  let n = [...t][0],
                    r = o.find(e => e.id === n);
                  (0, je.kG)(r, "Preset not found"), e(r.id === uw ? null : (0, ut.lu)(r.id).toFormat(aw)), i.close();
                }
              }, [i, o, e]);
            return (0, Ve.jsx)("div", {
              className: (0, je.AK)(Qb, "BaselineUI-ColorInput-Presets"),
              style: {
                minWidth: n.current?.offsetWidth
              },
              ref: a,
              children: (0, Ve.jsx)(Pg, {
                autoFocus: r,
                items: o,
                layout: "grid",
                "aria-label": l("colorPresets"),
                className: Kb,
                renderOption: cw,
                selectionMode: "single",
                selectedKeys: [t?.toString(sw) || uw],
                onSelectionChange: u
              })
            });
          });
        bw.displayName = "ColorPresetList";
        var ww = s.forwardRef((e, t) => {
          let n = s.useRef(null),
            {
              hoverProps: r,
              isHovered: o
            } = (0, Le.XI)({
              isDisabled: e.isDisabled
            }),
            {
              buttonProps: i,
              isPressed: a
            } = (0, Le.UW)(e, n),
            {
              isFocusVisible: l,
              focusProps: u
            } = (0, Le.Fx)(),
            c = (0, je.mS)({
              "data-block-id": e["data-block-id"],
              "data-focused": l,
              "data-focus-visible": l,
              "data-disabled": e.isDisabled,
              "data-hovered": o,
              "data-pressed": a
            });
          return (0, Ve.jsx)("button", {
            ...(0, Le.dG)(i, r, u, c),
            style: e.style,
            className: (0, je.AK)(Lb({
              isHovered: o,
              isFocusVisible: l || e.isOpen,
              isDisabled: e.isDisabled,
              labelPosition: e.labelPosition
            }), "BaselineUI-ColorInputButton", e.className),
            ref: (0, Be.lq)(t, n),
            children: e.children
          });
        });
        ww.displayName = "ColorInputButton";
        var xw = s.forwardRef(({
          className: e,
          style: t,
          icon: n,
          ...r
        }, o) => {
          let i = s.useRef(null),
            {
              hoverProps: a,
              isHovered: l
            } = (0, Le.XI)({
              isDisabled: r.isDisabled
            }),
            {
              buttonProps: u,
              isPressed: c
            } = (0, Le.UW)(r, i),
            {
              isFocusVisible: d,
              focusProps: p
            } = (0, Le.Fx)(),
            h = (0, je.mS)({
              "data-block-id": r["data-block-id"],
              "data-focused": d,
              "data-focus-visible": d,
              "data-disabled": r.isDisabled,
              "data-hovered": l,
              "data-pressed": c
            });
          return (0, Ve.jsxs)("button", {
            ...(0, Le.dG)(u, a, p, h),
            ref: (0, Be.lq)(o, i),
            style: t,
            className: (0, je.AK)(Wb({
              isHovered: l || c || r.isOpen,
              isFocusVisible: d,
              isDisabled: r.isDisabled
            }), "BaselineUI-IconColorInputButton", e),
            children: [(0, Ve.jsx)(n, {
              size: 16
            }), (0, Ve.jsx)("div", {
              className: "_1dbkl5e",
              style: {
                backgroundColor: r.color
              }
            })]
          });
        });
        xw.displayName = "IconColorInputButton";
        var Dw = s.forwardRef(({
          className: e,
          style: t,
          allowRemoval: n,
          allowAlpha: r = !0,
          presets: o,
          labelPosition: i = "top",
          colorLabel: a = !0,
          includePicker: u = !0,
          onChange: c,
          defaultValue: d,
          storePickedColorKey: p = "baselinePickedColor",
          value: h,
          addColorButtonLabel: f,
          removeColorButtonLabel: m,
          customColorsLabel: g,
          renderTriggerButton: v,
          pickerMode: b = "active",
          offset: w = 2,
          placement: x = "start" === i ? "bottom end" : "bottom start",
          "data-block-id": D,
          ...C
        }, S) => {
          let E = s.useRef(null),
            _ = s.useRef(null),
            P = y(C),
            {
              triggerProps: k,
              overlayProps: A
            } = (0, Le.IB)({
              type: "listbox"
            }, P, E),
            z = jv(C.portalContainer),
            [T, O] = (0, l.zk)(void 0 === h ? void 0 : lw(h), lw(d), e => c?.(e?.toFormat("rgba") || null)),
            {
              formatMessage: I
            } = Tv(Rb),
            F = (0, s.useMemo)(() => function (e, t) {
              let n = t?.map(e => ({
                id: (0, ut.lu)(e.color).toString(sw),
                label: e.label
              })) || [];
              return [...n, {
                id: uw,
                label: e
              }];
            }(I("noColor"), o), [o, I]),
            M = (0, s.useMemo)(() => F.find(e => e.id === uw ? !T : !!T && function (e, t) {
              return e?.getChannelValue("alpha") ? t?.toString(sw) === e.toString(sw) : !t?.getChannelValue("alpha");
            }(T, (0, ut.lu)(e.id))), [F, T]),
            R = (0, Le.Me)(),
            j = (0, s.useMemo)(() => "function" == typeof a ? a?.(T) : !!a && function (e, t, n) {
              return t ? t.label : 0 === e?.getChannelValue("alpha") ? n : e?.toString("rgba");
            }(T, M, I("transparent")), [T, a, I, M]),
            B = (0, s.useMemo)(() => F.filter(e => n || e.id !== uw), [F, n]),
            N = f || I("addColor"),
            L = m || I("removeColor"),
            V = g || I("customColors");
          return (0, Ve.jsxs)(Ve.Fragment, {
            children: [(0, Ve.jsxs)("div", {
              className: (0, je.AK)({
                "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z69l _1yep5z69m _1yep5z69n _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jr _1yep5z6js _1yep5z6jt": "start" === i
              }, "BaselineUI-ColorInput-Trigger", e),
              "data-block-id": D,
              style: t,
              ref: S,
              children: [C.label ? (0, Ve.jsx)("label", {
                id: R,
                className: Vb({
                  labelPosition: i
                }),
                children: C.label
              }) : null, v?.({
                isOpen: P.isOpen,
                color: T,
                ref: E,
                colorName: j,
                triggerProps: k
              }) || (0, Ve.jsxs)(ww, {
                ...(0, Le.dG)(k, {
                  ...(C.label ? {
                    "aria-labelledby": R
                  } : {
                    "aria-label": C["aria-label"]
                  })
                }),
                ref: E,
                isOpen: P.isOpen,
                isDisabled: C.isDisabled,
                labelPosition: i,
                children: [(0, Ve.jsx)(rw, {
                  isPresentational: !0,
                  color: T?.toString("hexa")
                }), a ? (0, Ve.jsx)("div", {
                  className: "_1dbkl5f z9nup87",
                  children: j
                }) : (0, Ve.jsx)(Le.TX, {
                  children: j
                })]
              })]
            }), P.isOpen ? (0, Ve.jsx)(Hv, {
              ...C,
              portalContainer: z,
              placement: x,
              state: P,
              offset: w,
              className: (0, je.AK)(Xb, "BaselineUI-ColorInput-Popover"),
              triggerRef: E,
              overlayProps: A,
              children: (0, Ve.jsxs)(Fb, {
                size: "content",
                className: Zb({
                  includesCustomColorPicker: u
                }),
                ref: _,
                "aria-labelledby": R,
                "aria-label": C["aria-label"],
                children: [u && "active" === b ? (0, Ve.jsxs)(Ve.Fragment, {
                  children: [(0, Ve.jsx)(vw, {
                    color: T || iw,
                    setColor: O,
                    allowAlpha: r
                  }), (0, Ve.jsx)(yw, {
                    color: T || iw,
                    setColor: O,
                    storePickedColorKey: p,
                    addColorButtonLabel: N,
                    removeColorButtonLabel: L,
                    customColorsLabel: V,
                    pickerMode: b,
                    allowAlpha: r
                  })]
                }) : null, !!B.length && (0, Ve.jsxs)(Ve.Fragment, {
                  children: [u && "active" === b ? (0, Ve.jsx)(yg, {}) : null, (0, Ve.jsx)(bw, {
                    autoFocus: (!u || "active" !== b) && "first",
                    state: P,
                    triggerRef: E,
                    presets: B,
                    color: T,
                    setColor: O
                  })]
                }), u && "lazy" === b ? (0, Ve.jsx)(yw, {
                  color: T || iw,
                  setColor: O,
                  storePickedColorKey: p,
                  addColorButtonLabel: N,
                  removeColorButtonLabel: L,
                  customColorsLabel: V,
                  pickerMode: b,
                  allowAlpha: r
                }) : null]
              })
            }) : null]
          });
        });
        Dw.displayName = "ColorInput";
        var Cw = {
            ar: {
              redo: "إعادة",
              undo: "تراجع"
            },
            cs: {
              redo: "Opakovat",
              undo: "Zrušit"
            },
            cy: {
              redo: "Ail-wneud",
              undo: "Dad-wneud"
            },
            da: {
              redo: "Gentag",
              undo: "Fortryd"
            },
            de: {
              redo: "Wiederholen",
              undo: "Rückgängig machen"
            },
            el: {
              redo: "Επανάληψη",
              undo: "Αναίρεση"
            },
            "en-GB": {
              redo: "Redo",
              undo: "Undo"
            },
            en: {
              redo: "Redo",
              undo: "Undo"
            },
            es: {
              redo: "Rehacer",
              undo: "Deshacer"
            },
            fi: {
              redo: "Tee sittenkin",
              undo: "Peru"
            },
            "fr-CA": {
              redo: "Rétablir",
              undo: "Annuler"
            },
            fr: {
              redo: "Rétablir",
              undo: "Annuler"
            },
            he: {
              redo: "ביצוע מחדש",
              undo: "ביטול פעולה"
            },
            hr: {
              redo: "Ponovi",
              undo: "Vrati"
            },
            id: {
              redo: "Ulangi",
              undo: "Kembalikan"
            },
            it: {
              redo: "Ripristina",
              undo: "Annulla"
            },
            ja: {
              redo: "やり直す",
              undo: "取り消す"
            },
            ko: {
              redo: "실행복귀",
              undo: "실행취소"
            },
            ms: {
              redo: "Buat Semula",
              undo: "Buat Asal"
            },
            "nb-NO": {
              redo: "Gjør om igjen",
              undo: "Angre"
            },
            nl: {
              redo: "Opnieuw",
              undo: "Herstel"
            },
            pl: {
              redo: "Ponów",
              undo: "Cofnij"
            },
            "pt-PT": {
              redo: "Refazer",
              undo: "Desfazer"
            },
            pt: {
              redo: "Refazer",
              undo: "Desfazer"
            },
            ru: {
              redo: "Повторить",
              undo: "Отменить"
            },
            sk: {
              redo: "Opakovať",
              undo: "Zrušiť"
            },
            sl: {
              redo: "Uveljavi",
              undo: "Razveljavi"
            },
            sv: {
              redo: "Gör om",
              undo: "Ångra"
            },
            th: {
              redo: "ทำซ้ำ",
              undo: "ถอนคำสั่งกลับ"
            },
            tr: {
              redo: "Yinele",
              undo: "Geri Al"
            },
            uk: {
              redo: "Повторити",
              undo: "Скасувати"
            },
            "zh-Hans": {
              redo: "重做",
              undo: "撤销"
            },
            "zh-Hant": {
              redo: "重作",
              undo: "復原"
            }
          },
          Sw = hg({
            defaultClassName: "mnnh5s1 _1yep5z6hl _1yep5z6hm _1yep5z6hn _1yep5z6ki _1yep5z6kl _1yep5z6kx _1yep5z6kw _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6kv",
            variantClassNames: {
              isInline: {
                true: "mnnh5s2 _1yep5z6vw _1yep5z6vx _1yep5z6vy _1yep5z6wk _1yep5z6wl _1yep5z6wm _1yep5z6x8 _1yep5z6x9 _1yep5z6xa _1yep5z6xw _1yep5z6xx _1yep5z6xy _1yep5z6122 _1yep5z616j _1yep5z616k",
                false: "_1yep5z6166 _1yep5z6116"
              },
              isHovered: {
                true: "mnnh5s4"
              },
              hasLoadedImage: {
                true: "_1yep5z6115"
              },
              includeCheckeredBackground: {
                true: "mnnh5s6"
              },
              showFocusRing: {
                true: "_1yep5z6126 _1yep5z616c _1yep5z616a _1yep5z612n _1yep5z616d"
              },
              isDisabled: {
                true: "mnnh5s8 _1yep5z6yl"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isHovered: !0,
              hasLoadedImage: !1
            }, "_1yep5z61mo"], [{
              isHovered: !0,
              hasLoadedImage: !0
            }, "mnnh5s9"], [{
              isInline: !0,
              isDisabled: !0
            }, "_1yep5z61nd"], [{
              hasLoadedImage: !0,
              includeCheckeredBackground: !0
            }, "_1yep5z61mg"]]
          }),
          Ew = hg({
            defaultClassName: "mnnh5sa",
            variantClassNames: {
              isInline: {
                true: "mnnh5sb",
                false: "mnnh5sc"
              },
              isDisabled: {
                true: "mnnh5sd"
              },
              hasLoadedImage: {
                true: "mnnh5s0"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          _w = hg({
            defaultClassName: "_1i0ytqa3 _1yep5z6hl _1yep5z6hm _1yep5z6hn _1yep5z6kv _1yep5z6kw _1yep5z6ky",
            variantClassNames: {
              isFocusVisible: {
                true: "_1i0ytqa4"
              },
              isInline: {
                true: "_1yep5z611e",
                false: "_1yep5z611g"
              },
              isDisabled: {
                true: "_1i0ytqa7 _1yep5z6yl",
                false: "_1i0ytqa8"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isInline: !0,
              isFocusVisible: !0
            }, "_1i0ytqa9 _1yep5z61n9 _1yep5z61rt _1yep5z61rv"], [{
              isInline: !1,
              isFocusVisible: !0
            }, "_1i0ytqaa"], [{
              isInline: !0,
              isDisabled: !0
            }, "_1yep5z61mp"], [{
              isInline: !1,
              isDisabled: !0
            }, "_1yep5z61mr"]]
          }),
          Pw = hg({
            defaultClassName: "_1i0ytqab _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6kv",
            variantClassNames: {
              isInline: {
                false: "_1yep5z6115"
              },
              isDisabled: {
                true: "_1i0ytqad _1yep5z6yl"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          kw = hg({
            defaultClassName: "_1i0ytqa1 _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kv",
            variantClassNames: {
              isInline: {
                false: "_1yep5z63r _1yep5z63s _1yep5z63t _1yep5z619 _1yep5z61a _1yep5z61b"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Aw = {
            size: 1,
            thinning: 0,
            smoothing: 0,
            streamline: 0,
            easing: e => e,
            start: {
              taper: 0,
              easing: e => e,
              cap: !0
            },
            end: {
              taper: 0,
              easing: e => e,
              cap: !0
            },
            simulatePressure: !1
          },
          zw = s.forwardRef(({
            className: e,
            style: t,
            canvasClassName: n,
            canvasStyle: r,
            isBound: o = !0,
            strokeWidth: i = 2,
            strokeColor: a = "#3A87FD",
            onChange: l,
            defaultValue: u,
            onChangeEnd: c,
            enableHistory: d = !1,
            isInline: p = !0,
            isDisabled: h,
            placeholder: f,
            clearLabel: m,
            undoLabel: g,
            redoLabel: v,
            footerClassName: y,
            canvasRef: b,
            value: w,
            footerStyle: x,
            "data-block-id": D,
            "aria-label": C = "Drawing canvas",
            description: S = "This is a canvas for drawing using a mouse or touch input.",
            ...E
          }, _) => {
            let P = Tv(Cw),
              k = s.useRef(null),
              [A, z] = s.useState(w ? Tw(w) : u ? Tw(u) : []),
              T = s.useRef((w?.length || u?.length || 0) - 1),
              [O, I] = s.useState(),
              F = (0, Le.Me)(),
              {
                labelProps: M,
                fieldProps: R
              } = (0, Le.NP)({
                ...E,
                "aria-label": C,
                labelElementType: "span"
              }),
              {
                isFocusVisible: j,
                focusProps: B
              } = (0, Le.Fx)({
                within: !0
              }),
              {
                hoverProps: N,
                isHovered: L
              } = (0, Le.XI)({
                isDisabled: h
              }),
              {
                undo: V,
                redo: K,
                canRedo: q,
                canUndo: H,
                push: U
              } = kv(A, {
                onAction: e => {
                  e && (z(e), T.current = e.length - 1, c?.(e.map(e => mn(e, $))));
                },
                isDisabled: !d
              }),
              {
                keyboardProps: Z
              } = (0, Le.v5)({
                onKeyDown: e => {
                  "Backspace" === e.key ? X() : "z" === e.key && (e.metaKey || e.ctrlKey) && (e.shiftKey ? q && K() : H && V());
                }
              }),
              $ = s.useMemo(() => ({
                ...Aw,
                ...E
              }), [E]),
              G = (0, s.useCallback)(e => {
                e.persist(), 1 === e.buttons && ((0, je.kG)(O, "svgCoordinates must be defined"), z(t => {
                  let n = [...t];
                  return n[T.current] = [...n[T.current], {
                    x: o ? (0, Be.uZ)(e.clientX - O.left, 0, O.width) : e.clientX - O.left,
                    y: o ? (0, Be.uZ)(e.clientY - O.top, 0, O.height) : e.clientY - O.top,
                    pressure: e.pressure
                  }], n;
                }));
              }, [O, o]),
              W = (0, s.useCallback)(e => {
                e.persist();
                let t = e.currentTarget.getBoundingClientRect();
                I(t), e.target.setPointerCapture(e.pointerId), T.current += 1, z(n => {
                  let r = [...n];
                  return r[T.current] = [{
                    x: e.clientX - t.x,
                    y: e.clientY - t.y,
                    pressure: e.pressure
                  }], r;
                });
              }, []),
              Y = Cv();
            (0, it.useGranularEffect)(() => {
              Y || l?.(A.map(e => mn(e, $)));
            }, [A], [l, $, Y]);
            let X = () => {
                z([]), T.current = -1, U([]);
              },
              Q = (0, s.useCallback)(() => {
                c?.(A.map(e => mn(e, $))), U(A);
              }, [A, c, $, U]);
            return (0, Ve.jsxs)("div", {
              ref: (0, Be.lq)(k, _),
              className: (0, je.AK)("_1i0ytqa0", "BaselineUI-FreehandCanvas", e),
              style: t,
              "aria-disabled": h,
              "data-block-id": D,
              children: [E.label || d ? (0, Ve.jsxs)("div", {
                className: kw({
                  isInline: p
                }),
                children: [E.label ? (0, Ve.jsx)(xb, {
                  type: "label",
                  size: "sm",
                  ...M,
                  children: E.label
                }) : (0, Ve.jsx)("span", {}), d ? (0, Ve.jsxs)("div", {
                  children: [(0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "sm",
                    isDisabled: !H || h,
                    icon: Ue.UE,
                    onPress: V,
                    "aria-label": g || P.formatMessage("undo")
                  }), (0, Ve.jsx)(nv, {
                    variant: "secondary",
                    size: "sm",
                    isDisabled: !q || h,
                    icon: Ue.zG,
                    onPress: K,
                    "aria-label": v || P.formatMessage("redo")
                  })]
                }) : null]
              }) : null, (0, Ve.jsxs)("div", {
                role: "application",
                ...(0, Le.dG)(B, Z, N, R),
                tabIndex: h ? void 0 : 0,
                className: (0, je.AK)(Sw({
                  isInline: p,
                  isHovered: L
                }), _w({
                  isFocusVisible: j,
                  isInline: p,
                  isDisabled: !!h
                }), n),
                "aria-describedby": E["aria-describedby"] || F,
                style: r,
                ref: b,
                children: [(0, Ve.jsx)(Le.TX, {
                  children: (0, Ve.jsx)("div", {
                    id: F,
                    children: S
                  })
                }), (0, Ve.jsx)("svg", {
                  width: r?.width || "100%",
                  height: r?.height || "100%",
                  onPointerDown: W,
                  onPointerMove: G,
                  onPointerUp: Q,
                  children: (w ? Tw(w) : A).map((e, t) => (0, Ve.jsx)("path", {
                    d: (0, je.US)(mn(e, $)),
                    stroke: a,
                    strokeWidth: i
                  }, t))
                })]
              }), f || m ? (0, Ve.jsx)("div", {
                style: x,
                className: (0, je.AK)(Pw({
                  isInline: p,
                  isDisabled: h
                }), y),
                children: !A.length && f || !m ? (0, Ve.jsx)(Bg, {
                  size: "sm",
                  variant: "ghost",
                  label: f,
                  isDisabled: !0
                }) : (0, Ve.jsx)(Bg, {
                  size: "sm",
                  variant: "ghost",
                  label: m,
                  isDisabled: h,
                  onPress: X
                })
              }) : null]
            });
          });
        zw.displayName = "FreehandCanvas";
        var Tw = e => e.map(e => e.map(([e, t]) => ({
            x: e,
            y: t,
            pressure: 0
          }))),
          Ow = hg({
            defaultClassName: "_1vac7ws1",
            variantClassNames: {
              isDragging: {
                true: "_1vac7ws2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          });
        var Iw = function (e) {
            var t;
            return t = function (e) {
              function t() {
                return null !== e && e.apply(this, arguments) || this;
              }
              return ei(t, e), t;
            }(Ku), t.defaultAbles = e, t;
          }([ps, gs, Cs, Us]),
          Fw = s.forwardRef(({
            className: e,
            children: t,
            isRotatable: n,
            isResizable: r,
            isDraggable: o,
            style: i,
            onTransform: a,
            onTransformStart: l,
            onTransformEnd: u,
            onDoubleClick: c,
            onDragStart: d,
            onDragEnd: p,
            onDrag: h,
            onResizeStart: f,
            onResizeEnd: m,
            onResize: g,
            onRotateStart: v,
            onRotateEnd: y,
            onRotate: b,
            onSnap: w,
            isSnappable: x,
            elementGuidelines: D,
            hideAnchorOnDrag: C = !0,
            title: S,
            rotationPosition: E,
            autoUpdate: _,
            bound: P,
            snapRotationDegrees: k,
            snapRotationThreshold: A,
            scrollableAncestor: z,
            renderDirections: T,
            stopPropagation: O,
            transformOrigin: I,
            preventDefault: F
          }, M) => {
            let R = (0, s.useRef)(null),
              j = (0, s.useRef)(null),
              [B, N] = (0, s.useState)(document),
              L = (0, s.useRef)(B.createElement("div")),
              [V, K] = (0, s.useState)({}),
              [q, H] = (0, s.useState)(!1),
              [U, Z] = (0, s.useState)(!1),
              [$, G] = (0, s.useState)(),
              W = function (e, t) {
                let [n, r] = (0, s.useState)([]),
                  o = () => e?.flatMap(e => [...t.querySelectorAll(e)]).map(e => ({
                    current: e
                  }));
                return (0, it.useGranularEffect)(() => {
                  r(o());
                }, [], [o]), (0, it.useGranularEffect)(() => {
                  let e = o();
                  r(e);
                }, [e], [o]), n;
              }(D, B);
            (0, s.useLayoutEffect)(() => {
              let e = L.current;
              return L.current = B.createElement("div"), () => {
                e.remove();
              };
            }, [B]);
            let {
              keyboardProps: Y
            } = (0, Le.v5)({
              onKeyDown: e => {
                let t = e.shiftKey ? 10 : 1,
                  n = e.metaKey || e.ctrlKey;
                function r(e, r = "x") {
                  n ? j.current?.request("rotatable", {
                    deltaRotate: e * t
                  }, !0) : j.current?.request("draggable", "x" === r ? {
                    deltaX: e * t
                  } : {
                    deltaY: e * t
                  }, !0);
                }
                switch (n && e.shiftKey && (t = 45), e.key) {
                  case "ArrowRight":
                    r(1);
                    break;
                  case "ArrowLeft":
                    r(-1);
                    break;
                  case "ArrowUp":
                    r(-1, "y");
                    break;
                  case "ArrowDown":
                    r(1, "y");
                }
                requestAnimationFrame(() => {
                  j.current?.updateRect();
                });
              }
            });
            (0, s.useEffect)(() => {
              let e = (0, Be.r3)(R.current);
              N(e);
              let t = L.current;
              function n(e) {
                Z(e.shiftKey);
              }
              function r() {
                Z(!1);
              }
              return e.body.append(L.current), e.addEventListener("keydown", n), e.addEventListener("keyup", r), () => {
                e.removeEventListener("keydown", n), e.removeEventListener("keyup", r), t.remove();
              };
            }, []), function (e) {
              let {
                scrollable: t,
                ownerDocument: n,
                onScroll: r
              } = e;
              (0, s.useEffect)(() => {
                let e = (0, je.SD)(t, n);
                if (e) return ("static" === e.style.position || !e.style.position) && console.warn("Scrollable ancestor passed to `Transform` component should not be statically positioned."), e.addEventListener("scroll", r), () => {
                  e.removeEventListener("scroll", r);
                };
              }, [t, r, n]);
            }({
              scrollable: z,
              onScroll: () => {
                j.current?.updateRect();
              },
              ownerDocument: B
            });
            let X = (0, s.useCallback)(e => {
                K(t => ({
                  ...t,
                  ...e.style
                })), a?.(e);
              }, [a]),
              Q = (0, s.useCallback)(e => {
                if (H(!0), R.current?.focus(), P) {
                  let e = (0, je.SD)(P, B)?.getBoundingClientRect();
                  G({
                    position: "client",
                    left: e?.left ?? 0,
                    top: e?.top ?? 0,
                    right: e?.right ?? 0,
                    bottom: e?.bottom ?? 0
                  });
                }
                d?.(e);
              }, [P, B, d]),
              J = (0, s.useCallback)(e => {
                H(!1), p?.(e);
              }, [p]),
              ee = t({
                style: {
                  ...(V.width && {
                    width: V.width
                  }),
                  ...(V.height && {
                    height: V.height
                  })
                }
              });
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: [(0, Ve.jsx)("div", {
                role: "button",
                ...Y,
                ref: (0, Be.lq)(R, M),
                style: {
                  display: "inline-block",
                  ...i,
                  ...V
                },
                className: (0, je.AK)("_1vac7ws0", e),
                onDoubleClick: c,
                tabIndex: 0,
                title: S,
                children: ee
              }), (0, gn.createPortal)((0, Ve.jsx)(Iw, {
                ref: j,
                target: R,
                draggable: o,
                resizable: r,
                rotatable: n,
                keepRatio: U,
                throttleDrag: 1,
                snappable: x || !!P,
                elementGuidelines: W,
                snapRenderThreshold: .9,
                className: Ow({
                  isDragging: q && C
                }),
                onRender: X,
                onDragStart: Q,
                onDragEnd: J,
                useResizeObserver: _,
                useMutationObserver: _,
                onRenderEnd: u,
                onDrag: h,
                onResizeStart: f,
                onResizeEnd: m,
                onResize: g,
                onRotateStart: v,
                onRotateEnd: y,
                onRotate: b,
                onRenderStart: l,
                onSnap: w,
                rotationPosition: E,
                bounds: $,
                snapRotationDegrees: k,
                snapRotationThreshold: A,
                renderDirections: T,
                stopPropagation: O,
                preventDefault: F,
                transformOrigin: I
              }), L.current)]
            });
          });
        Fw.displayName = "Transform";
        var Mw = {
            ar: {
              delete: "حذف",
              selectImage: "تحديد صورة"
            },
            cs: {
              delete: "Smazat",
              selectImage: "Vybrat obrázek"
            },
            cy: {
              delete: "Dileu",
              selectImage: "Dewiswch Ddelwedd"
            },
            da: {
              delete: "Slet",
              selectImage: "Vælg billede"
            },
            de: {
              delete: "Löschen",
              selectImage: "Bild auswählen"
            },
            el: {
              delete: "Διαγραφή",
              selectImage: "Επιλογή εικόνας"
            },
            "en-GB": {
              delete: "Delete",
              selectImage: "Select Image"
            },
            en: {
              delete: "Delete",
              selectImage: "Select Image"
            },
            es: {
              delete: "Eliminar",
              selectImage: "Seleccionar imagen"
            },
            fi: {
              delete: "Poista",
              selectImage: "Valitse kuva"
            },
            "fr-CA": {
              delete: "Supprimer",
              selectImage: "Sélectionner une image"
            },
            fr: {
              delete: "Supprimer",
              selectImage: "Sélectionner une image"
            },
            he: {
              delete: "מחיקה",
              selectImage: "בחירת תמונה"
            },
            hr: {
              delete: "Obriši",
              selectImage: "Odaberi sliku"
            },
            id: {
              delete: "Hapus",
              selectImage: "Pilih Gambar"
            },
            it: {
              delete: "Elimina",
              selectImage: "Seleziona immagine"
            },
            ja: {
              delete: "削除",
              selectImage: "イメージを選択"
            },
            ko: {
              delete: "삭제",
              selectImage: "이미지 선택"
            },
            ms: {
              delete: "Padam",
              selectImage: "Pilih Imej"
            },
            "nb-NO": {
              delete: "Slett",
              selectImage: "Velg bilde"
            },
            nl: {
              delete: "Verwijder",
              selectImage: "Selecteer afbeelding"
            },
            pl: {
              delete: "Usuń",
              selectImage: "Wybierz obraz"
            },
            "pt-PT": {
              delete: "Apagar",
              selectImage: "Selecionar imagem"
            },
            pt: {
              delete: "Apagar",
              selectImage: "Selecionar Imagem"
            },
            ru: {
              delete: "Удалить",
              selectImage: "Выбрать изобр."
            },
            sk: {
              delete: "Zmazať",
              selectImage: "Vybrať obrázok"
            },
            sl: {
              delete: "Izbriši",
              selectImage: "Izberi sliko"
            },
            sv: {
              delete: "Radera",
              selectImage: "Välj bild"
            },
            th: {
              delete: "ลบ",
              selectImage: "เลือกรูปภาพ"
            },
            tr: {
              delete: "Sil",
              selectImage: "Resim Seç"
            },
            uk: {
              delete: "Видалити",
              selectImage: "Обрати зображення"
            },
            "zh-Hans": {
              delete: "删除",
              selectImage: "选择图像"
            },
            "zh-Hant": {
              delete: "刪除",
              selectImage: "選取圖像"
            }
          },
          Rw = s.forwardRef(({
            className: e,
            style: t,
            isInline: n = !0,
            accept: r = "image/*",
            defaultImageSrc: o,
            imageSrc: i,
            imageAlt: a,
            pickerButtonLabel: u,
            isDisabled: c,
            onDrop: d,
            onPaste: p,
            includeCheckeredBackground: h = !0,
            "data-block-id": f,
            pickerButtonStyle: m,
            pickerButtonClassName: g,
            footerClassName: v,
            footerStyle: y,
            clearLabel: b,
            placeholder: w,
            labelStyle: x,
            labelClassName: D,
            ...C
          }, S) => {
            let E = s.useRef(null),
              _ = s.useRef(null),
              {
                formatMessage: P
              } = Tv(Mw),
              [k, A] = (0, l.zk)(i, o || null, e => {
                (0, je.kG)("string" != typeof e), C.onValueChange?.(e ? [e] : []);
              }),
              z = (0, s.useMemo)(() => function (e) {
                return e instanceof File ? URL.createObjectURL(e) : e;
              }(k || void 0), [k]),
              {
                fieldProps: T,
                labelProps: O
              } = (0, Le.U$)(C),
              {
                dropProps: I,
                isDropTarget: F
              } = (0, Le.LW)({
                ref: E,
                onDrop: async e => {
                  if (c) return;
                  let t = await Jv({
                    items: e.items
                  });
                  t.length && A(t[0]), d?.(e);
                },
                ...C
              }),
              {
                clipboardProps: M
              } = (0, Le.VP)({
                onPaste: async e => {
                  if (c) return;
                  let t = await Jv({
                    items: e
                  });
                  t.length && A(t[0]), p?.(e);
                },
                ...C
              }),
              R = {
                type: "file",
                onChange: e => {
                  let t = [...e.target.files];
                  A(t[0]), C.onChange?.(e);
                },
                accept: r,
                disabled: c
              },
              {
                focusProps: j,
                isFocused: B,
                isFocusVisible: N
              } = (0, Le.Fx)({
                within: !0
              }),
              {
                hoverProps: L,
                isHovered: V
              } = (0, Le.XI)({
                isDisabled: c
              }),
              {
                imgProps: K,
                isLoading: q,
                isLoaded: H
              } = Dv({
                src: z,
                alt: a || ""
              }),
              U = {
                label: u || P("selectImage"),
                onPress: () => E.current?.click(),
                variant: "secondary",
                isDisabled: c,
                excludeFromTabOrder: !0,
                className: (0, je.AK)(Rg({
                  isFocusVisible: N
                }), {
                  _1yep5z6d8: F && !c
                }, g),
                style: m
              },
              Z = (0, je.mS)({
                "data-loaded": H,
                "data-block-id": f,
                "data-hovered": V,
                "data-focused": B,
                "data-drop-target": F,
                "data-disabled": c,
                "data-focus-visible": N
              });
            return (0, Ve.jsxs)(wg, {
              ...Z,
              className: (0, je.AK)("BaselineUI-ImageDropZone", e),
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              style: t,
              ref: S,
              children: [(0, Ve.jsxs)("label", {
                ...(0, Le.dG)(I, L, j, O),
                className: (0, je.AK)(Sw({
                  isInline: n,
                  isHovered: V,
                  isDisabled: c,
                  hasLoadedImage: !!z && H,
                  showFocusRing: F || !!z && N
                }), D),
                style: x,
                ref: E,
                children: [(0, Ve.jsx)(Le.TX, {
                  children: (0, Ve.jsx)("input", {
                    ...(0, Le.dG)(T, M, R),
                    ref: _
                  })
                }), !z && (0, Ve.jsx)(Bg, {
                  ...U
                }), !!z && (q ? (0, Ve.jsx)(xy, {}) : (0, Ve.jsx)("img", {
                  className: Ew({
                    isInline: n,
                    isDisabled: c,
                    hasLoadedImage: !!z && H && h
                  }),
                  ...K
                }))]
              }), w || b ? (0, Ve.jsx)("div", {
                style: y,
                className: (0, je.AK)(Pw({
                  isInline: n,
                  isDisabled: c
                }), v),
                children: !z && w || !b ? (0, Ve.jsx)(Bg, {
                  size: "sm",
                  variant: "ghost",
                  label: w,
                  isDisabled: !0
                }) : (0, Ve.jsx)(Bg, {
                  size: "sm",
                  variant: "ghost",
                  label: b,
                  isDisabled: c,
                  onPress: () => {
                    A(null), _.current && (_.current.value = "");
                  }
                })
              }) : null]
            });
          });
        Rw.displayName = "ImageDropZone";
        var jw = "_1vm2oh48 _1yep5z6kw _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6jc _1yep5z6jd _1yep5z6je",
          Bw = hg({
            defaultClassName: "_1vm2oh40 mnnh5s1 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6l1 _1yep5z6kz _1yep5z6hk _1yep5z6l2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6ki _1yep5z6kx _1yep5z6hl _1yep5z6hm _1yep5z6hn",
            variantClassNames: {
              accent: {
                theme: "_1vm2oh41",
                positive: "_1vm2oh42"
              },
              isInline: {
                true: "mnnh5s2 _1yep5z6vt _1yep5z6vu _1yep5z6vv _1yep5z6wh _1yep5z6wi _1yep5z6wj _1yep5z6x5 _1yep5z6x6 _1yep5z6x7 _1yep5z6xt _1yep5z6xu _1yep5z6xv _1yep5z6121 _1yep5z616i _1yep5z616k",
                false: "_1yep5z611g"
              },
              isFocusVisible: {
                true: "_1yep5z6126 _1yep5z616c _1yep5z616a _1yep5z612n _1yep5z616d"
              },
              isDisabled: {
                true: "mnnh5s8 z9nup83 _1yep5z6yl"
              },
              isHovered: {
                true: "_1vm2oh47"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              accent: "positive",
              isInline: !0
            }, "_1yep5z61mp"], [{
              accent: "theme",
              isInline: !0
            }, "_1yep5z61me"], [{
              accent: "positive",
              isInline: !1
            }, "_1yep5z61mr"], [{
              accent: "theme",
              isInline: !1
            }, "_1yep5z61mg"], [{
              isFocusVisible: !0,
              isInline: !0
            }, "_1yep5z61ny _1yep5z61rl _1yep5z61rn _1yep5z61ro"], [{
              isHovered: !0,
              isInline: !0
            }, "_1yep5z61ro _1yep5z61ny _1yep5z61rl _1yep5z61rn"], [{
              isHovered: !0,
              isInline: !1,
              accent: "positive"
            }, "_1yep5z61mq"], [{
              isHovered: !0,
              isInline: !1,
              accent: "theme"
            }, "_1yep5z61mi"], [{
              isHovered: !0,
              isInline: !0,
              accent: "theme"
            }, "_1yep5z61mf"]]
          }),
          Nw = s.forwardRef(({
            className: e,
            style: t,
            isDisabled: n,
            isInline: r = !0,
            imageAlt: o,
            imageSrc: i,
            svgSrc: a,
            textValue: s,
            textStyle: l,
            onPress: u,
            onDelete: c,
            deleteAriaLabel: d,
            addAriaLabel: p,
            accent: h = "positive",
            "data-block-id": f,
            ...m
          }, g) => {
            let {
                focusProps: v,
                isFocused: y,
                isFocusVisible: b
              } = (0, Le.Fx)({
                within: !0
              }),
              {
                isHovered: w,
                hoverProps: x
              } = (0, Le.XI)({
                isDisabled: n
              }),
              {
                pressProps: D
              } = (0, Le.r7)({
                isDisabled: n,
                onPress: u
              });
            (0, je.kG)(i || a || s, "Preview must have content. You must provide either an `imageSrc`, `svgSrc`, or `textValue` prop.");
            let C = (0, je.mS)({
              "data-hovered": w,
              "data-focus-visible": b,
              "data-focused": y,
              "data-disabled": n
            });
            return (0, Ve.jsxs)("div", {
              ...m,
              className: (0, je.AK)(Bw({
                isInline: r,
                isFocusVisible: b,
                isDisabled: n,
                isHovered: w,
                accent: h
              }), "BaselineUI-Preview", e),
              "data-block-id": f,
              "aria-label": m["aria-label"] || o || s,
              style: t,
              ref: g,
              children: ["string" == typeof a ? (0, Ve.jsx)("button", {
                disabled: n,
                ...(0, Le.dG)(x, v, D, C),
                className: jw,
                "aria-label": p,
                dangerouslySetInnerHTML: {
                  __html: a
                }
              }) : (0, Ve.jsxs)("button", {
                ...(0, Le.dG)(x, v, D, C),
                disabled: n,
                style: l,
                "aria-label": p,
                className: jw,
                children: [i ? (0, Ve.jsx)("img", {
                  src: i,
                  alt: o,
                  className: Ew({
                    isInline: r,
                    isDisabled: n
                  })
                }) : null, !!a && "object" == typeof a && a, s]
              }), c ? (0, Ve.jsx)(nv, {
                isDisabled: n,
                className: "_1vm2oh49 _1yep5z6ho _1yep5z6hp _1yep5z6hq _1yep5z6fv",
                "aria-label": d,
                size: "xs",
                icon: Ue.XH,
                onPress: c
              }) : null]
            });
          });
        Nw.displayName = "Preview";
        var Lw = hg({
            defaultClassName: "cw3m0n8 _1yep5z6ew _1yep5z6dv",
            variantClassNames: {
              isDisabled: {
                true: "_1yep5z6109"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Vw = hg({
            defaultClassName: "cw3m0n0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
            variantClassNames: {
              labelPosition: {
                end: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6ut _1yep5z6uu _1yep5z6uv",
                start: "_1yep5z613q _1yep5z613r _1yep5z613s _1yep5z6152 _1yep5z6153 _1yep5z6154"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Kw = hg({
            defaultClassName: "cw3m0n3 _16vugd05",
            variantClassNames: {
              isFocusVisible: {
                true: "_16vugd08"
              },
              isSelected: {
                true: "_16vugd07"
              },
              isDisabled: {
                true: "_16vugd0a"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          qw = ({
            label: e,
            description: t
          }, {
            isSelected: n,
            isFocusVisible: r,
            isDisabled: o,
            optionLabelPosition: i
          }) => (0, Ve.jsxs)("div", {
            className: Vw({
              labelPosition: i
            }),
            children: [(0, Ve.jsx)("div", {
              className: Kw({
                isSelected: n,
                isFocusVisible: r,
                isDisabled: o
              }),
              children: n ? (0, Ve.jsx)("div", {
                className: "cw3m0n7"
              }) : null
            }), e ? (0, Ve.jsxs)("div", {
              className: "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69c _1yep5z69d _1yep5z69e",
              children: [(0, Ve.jsx)("span", {
                className: Ey({
                  isDisabled: o
                }),
                children: e
              }), t ? (0, Ve.jsx)("span", {
                className: Lw({
                  isDisabled: o
                }),
                children: t
              }) : null]
            }) : null]
          }),
          Hw = ({
            state: e,
            renderOption: t = qw,
            item: n,
            optionLabelPosition: r = "end",
            optionStyle: o,
            optionClassName: i,
            isReadOnly: a,
            ...l
          }) => {
            let u = !!l.isDisabled || !!l.disabledValues?.includes(n.id),
              c = s.useRef(null),
              {
                inputProps: d,
                isPressed: p,
                isSelected: h
              } = (0, Le.xL)({
                ...l,
                isDisabled: u,
                children: n.label,
                value: n.id
              }, e, c),
              {
                focusProps: f,
                isFocusVisible: m,
                isFocused: g
              } = (0, Le.Fx)(),
              {
                isHovered: v
              } = (0, Le.XI)({
                isDisabled: u
              }),
              y = (0, je.mS)({
                "data-selected": h,
                "data-focused": g,
                "data-focus-visible": m,
                "data-hovered": v,
                "data-disabled": u,
                "data-pressed": p,
                "data-read-only": a
              });
            return (0, Ve.jsxs)("label", {
              ...y,
              style: o,
              className: (0, je.AK)("BaselineUI-Radio-Item", i),
              children: [(0, Ve.jsx)(Le.TX, {
                children: (0, Ve.jsx)("input", {
                  ...(0, Le.dG)(d, f),
                  ref: c
                })
              }), t(n, {
                isFocusVisible: m,
                isSelected: h,
                isFocused: g,
                isHovered: v,
                isDisabled: u,
                optionLabelPosition: r,
                isReadOnly: a
              })]
            });
          },
          Uw = s.forwardRef(({
            className: e,
            style: t,
            optionsContainerClassName: n,
            optionsContainerStyle: r,
            items: o,
            labelPosition: i = "top",
            renderOption: a,
            "aria-label": c,
            "aria-labelledby": d,
            "aria-describedby": p,
            "aria-details": h,
            "data-block-id": f,
            ...m
          }, g) => {
            let v = function (e) {
                let t = (0, s.useMemo)(() => e.name || `radio-group-${pe}-${++he}`, [e.name]);
                var n;
                let [r, o] = (0, l.zk)(e.value, null !== (n = e.defaultValue) && void 0 !== n ? n : null, e.onChange),
                  [i, a] = (0, s.useState)(null),
                  c = (0, u.Q3)({
                    ...e,
                    value: r
                  }),
                  d = c.displayValidation.isInvalid;
                return {
                  ...c,
                  name: t,
                  selectedValue: r,
                  setSelectedValue: t => {
                    e.isReadOnly || e.isDisabled || (o(t), c.commitValidation());
                  },
                  lastFocusedValue: i,
                  setLastFocusedValue: a,
                  isDisabled: e.isDisabled || !1,
                  isReadOnly: e.isReadOnly || !1,
                  isRequired: e.isRequired || !1,
                  validationState: e.validationState || (d ? "invalid" : null),
                  isInvalid: d
                };
              }(m),
              {
                radioGroupProps: y,
                labelProps: b,
                descriptionProps: w,
                errorMessageProps: x
              } = (0, Le.ar)({
                ...m,
                "aria-label": c,
                "aria-labelledby": d,
                "aria-describedby": p,
                "aria-details": h
              }, v),
              D = Jg({
                ...m,
                descriptionProps: w,
                errorMessageProps: x,
                labelPosition: i
              }),
              C = (0, je.mS)({
                "data-orientation": m.orientation,
                "data-block-id": f,
                "data-disabled": m.isDisabled,
                "data-readonly": m.isReadOnly
              });
            return (0, Ve.jsxs)("div", {
              ...(0, Le.dG)(y, C),
              className: (0, je.AK)(Xg({
                labelPosition: i
              }), "BaselineUI-RadioGroup", e),
              style: t,
              ref: g,
              children: [m.label || D ? (0, Ve.jsxs)("div", {
                className: Yg({
                  labelPosition: i,
                  hasMessage: !!D
                }),
                children: [(0, Ve.jsx)("span", {
                  ...b,
                  className: (0, je.AK)(Wg, "BaselineUI-RadioGroup-Label"),
                  children: m.label
                }), "start" === i && D]
              }) : null, (0, Ve.jsxs)("div", {
                className: (0, je.AK)({
                  [Vg]: m.isDisabled
                }),
                children: [(0, Ve.jsx)("div", {
                  className: (0, je.AK)("_1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69i _1yep5z69j _1yep5z69k _1yep5z6ks", n),
                  style: r,
                  children: o.map(e => (0, Ve.jsx)(Hw, {
                    state: v,
                    renderOption: a,
                    item: e,
                    value: e.id,
                    ...m
                  }, e.id))
                }), "top" === i && D]
              })]
            });
          });
        Uw.displayName = "RadioGroup";
        var Zw = ({
          id: e,
          defaultMessage: t,
          elementType: n = s.Fragment
        }) => {
          (0, je.kG)(e || t, "`id` or `defaultMessage` is required.");
          let r = Tv();
          return (0, Ve.jsx)(n, {
            children: r.formatMessage(e) || t
          });
        };
        Zw.displayName = "MessageFormat";
        var $w = s.forwardRef(({
          className: e,
          style: t,
          children: n,
          role: r = "group",
          isDisabled: o,
          ...i
        }, a) => {
          let {
            hoverProps: s,
            isHovered: l
          } = (0, Le.XI)({
            isDisabled: o
          });
          return (0, Ve.jsx)("div", {
            ...s,
            role: r,
            "data-hovered": l,
            "data-disabled": o,
            className: e,
            style: t,
            ...i,
            ref: a,
            children: n
          });
        });
        $w.displayName = "Group";
        var Gw = s.forwardRef(({
          items: e,
          optionsContainerClassName: t,
          ...n
        }, r) => {
          let o = (0, s.useMemo)(() => e.map(e => ({
            id: e.color,
            label: e.label
          })), [e]);
          return (0, Ve.jsx)(Uw, {
            items: o,
            optionsContainerClassName: (0, je.AK)("_1yep5z61ov _1yep5z61ow _1yep5z61ox _1yep5z61g1 _1yep5z61g2 _1yep5z61g3", t),
            orientation: "horizontal",
            renderOption: ({
              label: e,
              id: t
            }, {
              isSelected: n,
              isFocusVisible: r
            }) => (0, Ve.jsxs)("div", {
              className: "_1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e",
              children: [(0, Ve.jsx)(rw, {
                isFocusVisible: r,
                color: t,
                isSelected: n
              }), (0, Ve.jsx)(Le.TX, {
                children: e
              })]
            }),
            ...n,
            className: (0, je.AK)(n.className, "BaselineUI-ColorPresetInput"),
            ref: r
          });
        });
        Gw.displayName = "ColorPresetInput";
        var Ww = "UNSUPPORTED_IN_MENU";
        function Yw(e, t) {
          return t ? (0, Hu.flatMapDeep)(s.Children.toArray(e), e => s.isValidElement(e) && e.props.children ? [e, ...s.Children.toArray(e.props.children)] : [e]).find(e => s.isValidElement(e) && e.type === t) : void 0;
        }
        function Xw(e) {
          return Yw(e, Bg) || Yw(e, nv);
        }
        var Qw = {
            horizontal: "xvr3wn0",
            vertical: "xvr3wn1"
          },
          Jw = s.forwardRef(({
            className: e,
            style: t,
            children: n,
            collapsibleMenuProps: r,
            collapsibleMenuTrigger: o,
            "data-block-id": i,
            renderSpacer: a,
            ...l
          }, u) => {
            let {
                formatMessage: d
              } = Tv(),
              [p, h] = (0, s.useState)(),
              f = function (e) {
                return (0, s.useMemo)(() => s.Children.toArray(e).map(e => {
                  let t,
                    n,
                    r = e,
                    o = (0, Hu.uniqueId)("item"),
                    i = Yw(r, Tg),
                    a = Xw(r);
                  if (i) {
                    let e = Yw(i, Ig);
                    (0, je.kG)(e), t = Xw(e), n = Yw(i, Nb).props.children;
                  } else t = a || r;
                  let {
                      onPress: l,
                      label: u,
                      "aria-label": d,
                      iconStart: p,
                      isDisabled: h,
                      icon: f
                    } = t.props,
                    m = u || d || Ww;
                  (0, je.kG)("string" == typeof m, "ActionGroup children must have a string label");
                  let g = `${o}-${m}`;
                  return (0, s.createElement)(c.ck, {
                    key: g,
                    onPress: l,
                    textValue: m,
                    "aria-label": d,
                    icon: p || f,
                    dialogContent: n,
                    isDisabled: h,
                    key: g
                  }, r);
                }), [e]);
              }(n),
              m = g({
                ...l,
                children: f
              }),
              v = (0, Be.B3)(u),
              y = (0, s.useRef)(null),
              [{
                visibleItems: b,
                isMeasuring: w
              }, x] = (0, Be.pl)({
                visibleItems: m.collection.size,
                isMeasuring: !1
              }),
              D = (0, s.useCallback)(() => {
                let e = e => {
                  if (y.current && v.current) {
                    let t = [...y.current.children],
                      n = v.current.getBoundingClientRect().width,
                      r = 0,
                      o = 0;
                    if (e < m.collection.size) {
                      let e = t.pop();
                      e && (r += ex(e, !1, !0));
                    }
                    for (let [e, i] of t.entries()) {
                      if (r += ex(i, 0 === e, e === t.length - 1), !(Math.round(r) <= Math.round(n))) break;
                      o++;
                    }
                    return o;
                  }
                  return e;
                };
                x(function* () {
                  yield {
                    visibleItems: m.collection.size,
                    isMeasuring: !0
                  };
                  let t = e(m.collection.size),
                    n = t < m.collection.size && t > 0;
                  yield {
                    visibleItems: t,
                    isMeasuring: n
                  }, n && (yield {
                    visibleItems: e(t),
                    isMeasuring: !1
                  });
                });
              }, [x, v, m.collection.size]),
              C = (0, s.useMemo)(() => ({
                get current() {
                  return v.current?.parentElement;
                }
              }), [v]);
            (0, Be.yU)({
              ref: C,
              onResize: D
            }), (0, Be.bt)(D, [m.collection, D]);
            let {
                toolbarProps: S
              } = qu(l, v),
              E = [...m.collection],
              _ = E.slice(0, b),
              P = E.slice(b).filter(e => e.textValue !== Ww),
              k = P.length > 0;
            return (0, s.useEffect)(() => {
              h(void 0);
            }, [P.length]), (0, s.useEffect)(() => {
              "vertical" === l.orientation && console.warn("Toolbar: Vertical orientation is not supported when `isCollapsible` is true.");
            }, [l.orientation]), (0, Ve.jsxs)(Le.MT, {
              children: [(0, Ve.jsx)("div", {
                ...S,
                className: e,
                "data-block-id": i,
                "data-collapse": !0,
                style: {
                  ...t,
                  flexBasis: w ? "100%" : void 0
                },
                ref: v,
                children: (0, Ve.jsxs)("div", {
                  ref: y,
                  className: "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6hl _1yep5z6hm _1yep5z6hn _1yep5z6kv _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6kn",
                  children: [_.map(e => e.rendered), k ? (0, Ve.jsxs)(Ve.Fragment, {
                    children: [!w && a?.(), (0, Ve.jsx)(Yv, {
                      placement: "bottom end",
                      ...r,
                      disabledKeys: P.filter(e => e.props?.isDisabled).map(e => e.key),
                      items: P.map(e => {
                        let t = e.textValue || e["aria-label"];
                        return (0, je.kG)(t, "ActionItem must have a label"), {
                          id: e.key,
                          label: t,
                          icon: e.props.icon
                        };
                      }),
                      onAction: e => {
                        let t = m.collection.getItem(e);
                        (0, je.kG)(t, "Item not found");
                        let {
                          onPress: n,
                          dialogContent: r
                        } = t.props;
                        n?.(), h(r);
                      },
                      children: o || (0, Ve.jsx)(nv, {
                        variant: "toolbar",
                        size: "md",
                        icon: Ke.nXP,
                        "aria-label": d(nx.more)
                      })
                    })]
                  }) : null]
                })
              }), (0, Ve.jsx)(Pb, {
                isOpen: !!p,
                onOpenChange: e => {
                  e || h(void 0);
                },
                children: (0, Ve.jsx)(Tb, {
                  enableDrawer: "auto",
                  style: {
                    zIndex: 1e5
                  },
                  children: p ? s.cloneElement(p, {
                    inheritDrawer: !0
                  }) : null
                })
              })]
            });
          });
        function ex(e, t, n) {
          let r = (0, Be.kR)(e).getComputedStyle(e);
          return e.getBoundingClientRect().width + (t ? 0 : tx(r.marginLeft)) + (n ? 0 : tx(r.marginRight));
        }
        function tx(e) {
          let t = Number.parseInt(e, 10);
          return Number.isNaN(t) ? 0 : t;
        }
        Jw.displayName = "CollapsibleToolbar";
        var nx = Ov({
            more: {
              id: "more",
              defaultMessage: "More"
            }
          }),
          rx = s.forwardRef(({
            className: e,
            style: t,
            "data-block-id": n,
            "aria-controls": r,
            ...o
          }, i) => {
            let a = s.useRef(null),
              {
                toolbarProps: l
              } = qu(o, a);
            return (0, Ve.jsx)("div", {
              ...l,
              "aria-controls": r,
              className: (0, je.AK)(Qw[o.orientation || "horizontal"], "BaselineUI-Toolbar", e),
              style: t,
              "data-block-id": n,
              ref: (0, Be.lq)(i, a),
              children: o.children
            });
          });
        rx.displayName = "WrappedToolbar";
        var ox = s.forwardRef((e, t) => {
          let n = e.isCollapsible ? Jw : rx;
          return (0, Ve.jsx)(n, {
            ...e,
            ref: t
          });
        });
        ox.displayName = "Toolbar";
        var ix = hg({
            defaultClassName: "_1j5skr71",
            variantClassNames: {
              size: {
                xxs: "_1j5skr72",
                xs: "_1j5skr73",
                sm: "_1j5skr74",
                md: "_1j5skr75",
                lg: "_1j5skr76"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          ax = hg({
            defaultClassName: "_1j5skr70 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ks _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6fs _1yep5z6f0",
            variantClassNames: {
              isHovered: {
                true: "_1j5skr7g"
              },
              isFocusVisible: {
                true: "_1j5skr7h"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z610d"
              },
              isSelected: {
                true: "_1j5skr7j"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isDisabled: !0
            }, "_1yep5z61ro _1yep5z61rn _1yep5z61rl _1yep5z61o5 _1yep5z61lo"], [{
              isSelected: !1,
              isHovered: !0,
              isDisabled: !1
            }, "_1yep5z6ft"], [{
              isSelected: !1,
              isFocusVisible: !0,
              isDisabled: !1
            }, "_1yep5z61ro _1yep5z61rn _1yep5z61ny _1yep5z61rl"], [{
              isSelected: !0,
              isFocusVisible: !0,
              isDisabled: !1
            }, "_1j5skr7k _1yep5z61rm _1yep5z61rl _1yep5z61nz _1yep5z61lp"], [{
              isSelected: !0,
              isFocusVisible: !1,
              isDisabled: !1
            }, "_1yep5z61rl _1yep5z61rn _1yep5z61ny _1yep5z61ro"]]
          }),
          sx = hg({
            defaultClassName: "_1j5skr70 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ks _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6f0",
            variantClassNames: {
              isHovered: {
                true: "_1j5skr7m"
              },
              isFocusVisible: {
                true: "_1yep5z616d _1yep5z616c _1yep5z612n _1yep5z616a"
              },
              isSelected: {
                true: "_1yep5z610c"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z610d"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !1,
              isHovered: !0
            }, "_1yep5z61ln"]]
          }),
          lx = hg({
            defaultClassName: "_1j5skr70 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ks _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6f0",
            variantClassNames: {
              isHovered: {
                true: "_1j5skr7r"
              },
              isFocusVisible: {
                true: "_1yep5z616d _1yep5z616c _1yep5z612n _1yep5z616a"
              },
              isSelected: {
                true: "_1j5skr7t"
              },
              isDisabled: {
                true: "z9nup83 _1yep5z610d"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !1,
              isHovered: !0
            }, "_1yep5z61mg"], [{
              isSelected: !0,
              isDisabled: !1
            }, "_1yep5z61mg _1yep5z61lq"], [{
              isSelected: !0,
              isDisabled: !0
            }, "_1yep5z61mg _1yep5z61lo"]]
          }),
          ux = hg({
            defaultClassName: "_1j5skr70 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kx _1yep5z6ky _1yep5z6ks _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6jl _1yep5z6jm _1yep5z6jn _1yep5z6fs _1yep5z6f0",
            variantClassNames: {
              isHovered: {
                true: "_1j5skr78"
              },
              isFocusVisible: {
                true: "_1j5skr79"
              },
              isSelected: {
                true: "_1j5skr7a"
              },
              isDisabled: {
                true: "_1j5skr7b z9nup83 _1yep5z610e"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isSelected: !0,
              isDisabled: !1
            }, "_1j5skr7c _1yep5z61lp"], [{
              isSelected: !1,
              isDisabled: !0
            }, "_1yep5z61lo _1yep5z61me"], [{
              isSelected: !1,
              isHovered: !0
            }, "_1yep5z61mf"], [{
              isSelected: !1,
              isFocusVisible: !0
            }, "_1yep5z61ro _1yep5z61rn _1yep5z61ny _1yep5z61rl"], [{
              isSelected: !0,
              isFocusVisible: !0
            }, "_1j5skr7e _1yep5z61rm _1yep5z61rl _1yep5z61nz"]]
          }),
          cx = {
            xxs: 8,
            xs: 12,
            sm: 16,
            md: 20,
            lg: 24
          },
          dx = s.forwardRef(({
            className: e,
            style: t,
            icon: n,
            size: r = "md",
            variant: o = "primary",
            "data-block-id": i,
            ...a
          }, l) => {
            let u = (0, _e.l)(a),
              {
                buttonProps: c,
                isPressed: d,
                ref: p
              } = Mg(a, u),
              {
                hoverProps: h,
                isHovered: f
              } = (0, Le.XI)({
                isDisabled: a.isDisabled
              }),
              {
                isFocusVisible: m,
                isFocused: g,
                focusProps: v
              } = (0, Le.Fx)(),
              y = (0, s.useMemo)(() => "function" == typeof n ? n : u.isSelected ? n.selected : n.unselected, [n, u.isSelected]),
              b = {
                isSelected: u.isSelected,
                isHovered: f,
                isFocusVisible: m,
                isDisabled: !!a.isDisabled
              },
              w = (0, je.mS)({
                "data-hovered": f,
                "data-selected": u.isSelected,
                "data-focus-visible": m,
                "data-disabled": a.isDisabled,
                "data-block-id": i,
                "data-focused": g,
                "data-pressed": d
              });
            return (0, Ve.jsx)("button", {
              ...(0, Le.dG)(c, h, v, w),
              className: (0, je.AK)("toolbar" === o && ux(b), "primary" === o && ax(b), "secondary" === o && sx(b), "tertiary" === o && lx(b), ix({
                size: r
              }), "BaselineUI-ToggleIconButton", e),
              style: t,
              ref: (0, Be.lq)(p, l),
              children: (0, Ve.jsx)(y, {
                size: cx[r]
              })
            });
          });
        dx.displayName = "ToggleIconButton";
        var px = "_1yep5z689 _1yep5z68a _1yep5z68b _1yep5z65x _1yep5z65y _1yep5z65z",
          hx = hg({
            defaultClassName: "f6jv6b0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6fs",
            variantClassNames: {
              isInline: {
                true: "f6jv6b1"
              },
              isMinimal: {
                true: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6uw _1yep5z6ux _1yep5z6uy _1yep5z6142 _1yep5z6143 _1yep5z6144",
                false: "_1yep5z613n _1yep5z613o _1yep5z613p"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isInline: !0,
              isMinimal: !1
            }, "_1yep5z61h7 _1yep5z61h8 _1yep5z61h9 _1yep5z61hv _1yep5z61hw _1yep5z61hx _1yep5z61ij _1yep5z61ik _1yep5z61il _1yep5z61j7 _1yep5z61j8 _1yep5z61j9 _1yep5z61rv _1yep5z61rt _1yep5z61nc"]]
          }),
          fx = hg({
            defaultClassName: "f6jv6b4 _1yep5z69 _1yep5z6a _1yep5z6b _1yep5z62l _1yep5z62m _1yep5z62n _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6e3 _1yep5z6eu _1yep5z6ky",
            variantClassNames: {
              isDisabled: {
                true: "f6jv6b5 _1yep5z6109"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          mx = hg({
            defaultClassName: "f6jv6bf _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69l _1yep5z69m _1yep5z69n _1yep5z6ky _1yep5z6ki _1yep5z6kl _1yep5z6kx",
            variantClassNames: {
              isHovered: {
                true: "_1yep5z6115"
              },
              isDisabled: {
                true: "_1yep5z6yl"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          gx = hg({
            defaultClassName: "f6jv6bb _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z69l _1yep5z69m _1yep5z69n _1yep5z6jc _1yep5z6jd _1yep5z6je",
            variantClassNames: {
              isInline: {
                true: "_1yep5z6oz _1yep5z6p0 _1yep5z6p1 _1yep5z616k _1yep5z616i _1yep5z6121",
                false: "_1yep5z6p2 _1yep5z6p3 _1yep5z6p4 _1yep5z6we _1yep5z6wf _1yep5z6wg _1yep5z6x2 _1yep5z6x3 _1yep5z6x4 _1yep5z6xq _1yep5z6xr _1yep5z6xs _1yep5z6ye _1yep5z6yf _1yep5z6yg"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          vx = hg({
            defaultClassName: "f6jv6b6",
            variantClassNames: {
              isInline: {
                true: "f6jv6b7",
                false: "f6jv6b8"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          yx = "f6jv6b9 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it",
          bx = [["Toolbar Focus", "Alt+F10"], ["Bold", "Ctrl+B"], ["Italic", "Ctrl+I"], ["Underline", "Ctrl+U"], ["Select All", "Ctrl+A"], ["Cut", "Ctrl+X"], ["Copy", "Ctrl+C"], ["Paste", "Ctrl+V"], ["Undo", "Ctrl+Z"], ["Redo", "Ctrl+Shift+Z"], ["Open Help Dialog", "Ctrl+Shift+H"]],
          {
            dialog: {
              row: wx
            }
          } = qe.layoutSprinkleValues,
          xx = ({
            isOpen: e,
            onClose: t
          }) => {
            let {
                formatMessage: n
              } = Tv(),
              r = (0, Le.Me)();
            return (0, Ve.jsx)(Pb, {
              isOpen: e,
              onOpenChange: e => {
                e || t();
              },
              children: (0, Ve.jsx)(Tb, {
                enableDrawer: "auto",
                style: {
                  zIndex: 999999
                },
                children: (0, Ve.jsxs)(Fb, {
                  "aria-labelledby": r,
                  className: "f6jv6bj _1yep5z6vz _1yep5z6w0 _1yep5z6w1 _1yep5z6wn _1yep5z6wo _1yep5z6wp _1yep5z6xb _1yep5z6xc _1yep5z6xd _1yep5z6xz _1yep5z6y0 _1yep5z6y1",
                  drawerBackground: "subtle",
                  children: [(0, Ve.jsxs)(wg, {
                    paddingLeft: wx.padding.horizontal.lg,
                    paddingRight: wx.padding.horizontal.sm,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    backgroundColor: "background.primary.subtle",
                    className: "f6jv6bk",
                    children: [(0, Ve.jsx)(xb, {
                      id: r,
                      elementType: "h3",
                      type: "title",
                      size: "md",
                      children: n(Dx.help)
                    }), (0, Ve.jsx)(nv, {
                      icon: $e.b0,
                      size: "md",
                      variant: "secondary",
                      "aria-label": n(Dx.close),
                      onPress: t
                    })]
                  }), (0, Ve.jsx)(yg, {
                    className: "f6jv6bl"
                  }), (0, Ve.jsxs)(wg, {
                    paddingX: wx.padding.horizontal.lg,
                    role: "table",
                    "aria-labelledby": r,
                    backgroundColor: "background.primary.subtle",
                    children: [(0, Ve.jsx)("div", {
                      role: "rowgroup",
                      children: (0, Ve.jsxs)(wg, {
                        role: "row",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingY: wx.padding.vertical.md,
                        color: "text.primary",
                        children: [(0, Ve.jsx)("h6", {
                          className: (0, qe.Kj)({
                            typography: "heading.h6.semibold"
                          }),
                          role: "columnheader",
                          children: n(Dx.action)
                        }), (0, Ve.jsx)("h6", {
                          className: (0, qe.Kj)({
                            typography: "heading.h6.semibold"
                          }),
                          role: "columnheader",
                          style: {
                            textTransform: "capitalize"
                          },
                          children: n(Dx.shortcut)
                        })]
                      })
                    }), (0, Ve.jsx)("div", {
                      role: "rowgroup",
                      children: bx.map(([e, t], r) => (0, Ve.jsxs)(s.Fragment, {
                        children: [(0, Ve.jsxs)(wg, {
                          role: "row",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: "center",
                          paddingY: wx.padding.vertical.xs,
                          style: {
                            minHeight: 40
                          },
                          children: [(0, Ve.jsx)(xb, {
                            type: "subtitle",
                            size: "sm",
                            role: "cell",
                            children: n(Dx[(0, Hu.camelCase)(e)])
                          }), (0, Ve.jsx)(xb, {
                            elementType: "kbd",
                            type: "subtitle",
                            size: "sm",
                            role: "cell",
                            children: (0, je._t)(t, !0)
                          })]
                        }), r !== bx.length - 1 && (0, Ve.jsx)(yg, {})]
                      }, e))
                    })]
                  })]
                })
              })
            });
          },
          Dx = Ov({
            toolbarFocus: {
              id: "toolbarFocus",
              defaultMessage: "Toolbar Focus"
            },
            help: {
              id: "help",
              defaultMessage: "Help"
            },
            close: {
              id: "close",
              defaultMessage: "Close"
            },
            action: {
              id: "action",
              defaultMessage: "Action"
            },
            shortcut: {
              id: "shortcut",
              defaultMessage: "Shortcut"
            },
            bold: {
              id: "bold",
              defaultMessage: "Bold"
            },
            italic: {
              id: "italic",
              defaultMessage: "Italic"
            },
            underline: {
              id: "underline",
              defaultMessage: "Underline"
            },
            selectAll: {
              id: "selectAll",
              defaultMessage: "Select All"
            },
            cut: {
              id: "cut",
              defaultMessage: "Cut"
            },
            copy: {
              id: "copy",
              defaultMessage: "Copy"
            },
            paste: {
              id: "paste",
              defaultMessage: "Paste"
            },
            undo: {
              id: "undo",
              defaultMessage: "Undo"
            },
            redo: {
              id: "redo",
              defaultMessage: "Redo"
            },
            openHelpDialog: {
              id: "openHelpDialog",
              defaultMessage: "Open Help Dialog"
            }
          }),
          Cx = s.forwardRef(({
            value: e,
            defaultValue: t,
            onChange: n,
            placeholder: r,
            spellCheck: o,
            textBoxRef: i,
            isInline: a,
            isMinimal: u,
            isDisabled: c,
            editableContentAriaLabel: d,
            editorHandle: p,
            autoFocus: h,
            saveOnEnter: f,
            onSave: m
          }, g) => {
            let v = s.useRef(null),
              [y, b] = (0, l.zk)(e, t || "", n),
              w = (0, s.useCallback)(e => {
                b(e.currentTarget.value || "");
              }, [b]),
              x = (0, s.useCallback)(e => {
                f && "Enter" === e.key && !e.shiftKey && (e.preventDefault(), m());
              }, [f, m]);
            (0, s.useImperativeHandle)(g, () => ({
              clear: () => {
                b("");
              }
            }));
            let D = (0, s.useCallback)(e => {
              e.currentTarget.style.height = "16px", e.currentTarget.style.height = e.currentTarget.scrollHeight + "px";
            }, []);
            (0, it.useGranularLayoutEffect)(() => {
              let e = v.current;
              e && (e.style.height = "16px", e.style.height = e.scrollHeight + "px");
            }, [u], [y]), (0, s.useImperativeHandle)(p, () => ({
              setCaretPosition: e => {
                v.current && (v.current.focus(), v.current.setSelectionRange(e, e));
              }
            }));
            let {
                focusProps: C,
                isFocused: S,
                isFocusVisible: E
              } = (0, Le.Fx)(),
              {
                hoverProps: _,
                isHovered: P
              } = (0, Le.XI)({}),
              k = (0, je.mS)({
                "data-focus-visible": E,
                "data-hovered": P,
                "data-focused": S
              });
            return (0, Ve.jsx)("textarea", {
              ...(0, Le.dG)(C, _, k),
              ref: (0, Be.lq)(v, i),
              className: (0, je.AK)(u ? "f6jv6be f6jv6ba _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6hx _1yep5z6hy _1yep5z6hz _1yep5z6eu _1yep5z6e3 _1yep5z6kv" : [fx(), vx({
                isInline: a
              }), "f6jv6ba _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6hx _1yep5z6hy _1yep5z6hz _1yep5z6eu"]),
              autoFocus: h,
              onChange: w,
              disabled: c,
              onInput: D,
              value: y,
              placeholder: r,
              spellCheck: o,
              "aria-label": d,
              onKeyDown: x
            });
          });
        Cx.displayName = "PlainEditor";
        var Sx = (e, t) => {
            let n = Uu.ML.marks(e);
            return !!n && !0 === n[t];
          },
          Ex = (e, t) => {
            Sx(e, t) ? Uu.ML.removeMark(e, t) : Uu.ML.addMark(e, t, !0);
          },
          _x = e => {
            hd.focus(e);
          };
        function Px(e, t) {
          let [n] = Uu.ML.nodes(e, {
            match: e => !Uu.ML.isEditor(e) && Uu.W_.isElement(e) && "type" in e && e.type === t
          });
          return n?.[0];
        }
        var kx = (e, t) => {
          Uu.YR.unwrapNodes(e, {
            match: e => !Uu.ML.isEditor(e) && Uu.W_.isElement(e) && "type" in e && e.type === t
          });
        };
        var Ax = (e, t) => {
          if (!e.selection) return;
          let n = Px(e, "link");
          if (n) {
            let t = function (e) {
              if (!e.selection) return;
              let {
                  selection: t
                } = e,
                [n] = Uu.e6.edges(t);
              return {
                anchor: Uu.ML.before(e, n, {
                  unit: "word"
                }) || n,
                focus: Uu.ML.after(e, n, {
                  unit: "word"
                }) || n
              };
            }(e);
            t && Uu.e6.isCollapsed(t) && Uu.YR.select(e, t), kx(e, "link");
          }
          let {
              selection: r
            } = e,
            o = r && Uu.e6.isCollapsed(r),
            i = n?.children?.[0],
            a = i && "text" in i ? i.text : t,
            s = {
              type: "link",
              url: t,
              children: o ? [{
                text: a
              }] : []
            };
          o ? Uu.YR.insertNodes(e, s) : (Uu.YR.wrapNodes(e, s, {
            split: !0
          }), Uu.YR.collapse(e, {
            edge: "end"
          }));
        };
        function zx(e) {
          return "type" in e && "span" === e.type;
        }
        function Tx(e, t, n) {
          let [r] = Uu.ML.nodes(e, {
            match: e => !Uu.ML.isEditor(e) && Uu.W_.isElement(e) && "type" in e && zx(e)
          });
          r ? Uu.YR.setNodes(e, {
            [t]: n
          }, {
            match: e => zx(e),
            split: !0
          }) : ((e, t, n) => {
            if (!e.selection) return;
            let r = {
              ...Px(e, "span"),
              type: "span",
              [t]: n,
              children: []
            };
            Uu.YR.wrapNodes(e, r, {
              split: !0
            }), Uu.YR.collapse(e, {
              edge: "end"
            });
          })(e, t, n);
        }
        var Ox = e => (0, Qp.slateToHtml)(e, {
          markMap: {
            bold: ["b"],
            underline: ["u"],
            italic: ["i"]
          },
          elementMap: {
            paragraph: "p"
          },
          elementTransforms: {
            link: ({
              node: e,
              children: t = []
            }) => new Gp("a", {
              href: e.url
            }, t),
            span: ({
              node: e,
              children: t = []
            }) => {
              let n = function (e) {
                return Object.entries(e).map(([e, t]) => `${(0, Hu.kebabCase)(e)}:${t}`).filter(([, e]) => !!e).join(";");
              }({
                ...(e.color && {
                  color: e.color
                }),
                ...(e.backgroundColor && {
                  backgroundColor: e.backgroundColor
                })
              });
              return new Gp("span", n ? {
                style: n
              } : {}, t);
            },
            mention: ({
              node: e
            }) => new Gp("span", {
              "data-user-id": e.userId
            }, [new Kp(e.displayName)])
          }
        });
        function Ix(e) {
          return e ? ((e = e.trim()).endsWith(";") && (e = e.slice(0, -1)), Object.fromEntries(e.split(";").map(e => e.split(":").map(e => e.trim())).map(([e, t]) => [(0, Hu.camelCase)(e), t]))) : {};
        }
        function Fx(e) {
          return e.startsWith("<p>") || (e = `<p>${e}</p>`), (0, Qp.htmlToSlate)(e, {
            convertBrToLineBreak: !0,
            filterWhitespaceNodes: !0,
            htmlPreProcessString: e => {
              let t = new DOMParser().parseFromString(Np().sanitize(e), "text/html"),
                n = t.querySelectorAll("[style]");
              for (let e of n) "underline" === e.style.textDecoration && (e.style.textDecoration = "", e.style.cssText || e.removeAttribute("style"), e.hasAttributes() ? e.innerHTML = `<u>${e.innerHTML}</u>` : e.outerHTML = `<u>${e.innerHTML}</u>`);
              return t.body.innerHTML;
            },
            textTags: {
              em: () => ({
                italic: !0
              }),
              i: () => ({
                italic: !0
              }),
              strong: () => ({
                bold: !0
              }),
              u: () => ({
                underline: !0
              }),
              b: () => ({
                bold: !0
              })
            },
            elementTags: {
              a: e => ({
                type: "link",
                url: e?.attribs.href || "",
                children: []
              }),
              p: () => ({
                type: "paragraph"
              }),
              span: e => {
                let t = e?.attribs["data-user-id"];
                return t ? {
                  type: "mention",
                  userId: t,
                  displayName: e?.children[0]?.data || ""
                } : {
                  type: "span",
                  ...Ix(e?.attribs.style || "")
                };
              }
            }
          });
        }
        function Mx(e, t = 1) {
          let {
            selection: n
          } = e;
          if (n) {
            let [r] = Uu.e6.edges(n),
              o = Uu.ML.before(e, r, {
                distance: t,
                unit: "character"
              }),
              i = o && Uu.ML.range(e, o, r);
            return {
              text: i && Uu.ML.string(e, i),
              range: i
            };
          }
          return null;
        }
        var Rx = ({
            isDisabled: e
          }) => {
            let {
                formatMessage: t
              } = Tv(),
              n = ip();
            return (0, Ve.jsx)(Tg, {
              type: "dialog",
              children: ({
                close: r
              }) => (0, Ve.jsxs)(Ve.Fragment, {
                children: [(0, Ve.jsx)(Ig, {
                  children: (0, Ve.jsx)(nv, {
                    icon: $e.xP,
                    size: "sm",
                    isDisabled: e,
                    "aria-label": t(Bx.addLink),
                    className: px,
                    preventFocusOnPress: !0
                  })
                }), (0, Ve.jsx)(Nb, {
                  className: (0, qe.Kj)({
                    boxShadow: "medium"
                  }),
                  placement: "top end",
                  children: (0, Ve.jsx)(Fb, {
                    size: "content",
                    style: {
                      minWidth: 240
                    },
                    children: (0, Ve.jsx)(jx, {
                      close: () => {
                        r(), setTimeout(() => {
                          _x(n);
                        }, 0);
                      }
                    })
                  })
                })]
              })
            });
          },
          jx = ({
            close: e
          }) => {
            let t = ip(),
              {
                formatMessage: n
              } = Tv(),
              r = Px(t, "link")?.url,
              [o, i] = s.useState(r ? "show" : "add"),
              [a, l] = s.useState(r || ""),
              u = (0, Ve.jsx)(wg, {
                padding: "lg",
                children: (0, Ve.jsx)(uy, {
                  label: n(Bx.link),
                  value: a,
                  autoFocus: !0,
                  onChange: l,
                  placeholder: "https://yourdomain.com"
                })
              });
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: ["add" === o && (0, Ve.jsxs)(Ve.Fragment, {
                children: [u, (0, Ve.jsx)(wg, {
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "lg",
                  className: "f6jv6bm",
                  children: (0, Ve.jsx)(Bg, {
                    isDisabled: !(0, je.CB)(a, !0),
                    label: n(Bx.addLink),
                    size: "sm",
                    onPress: () => {
                      Ax(t, a), e?.();
                    },
                    preventFocusOnPress: !0
                  })
                })]
              }), "show" === o && (0, Ve.jsxs)(Ve.Fragment, {
                children: [(0, Ve.jsx)(wg, {
                  padding: "lg",
                  children: (0, Ve.jsx)(xb, {
                    type: "subtitle",
                    size: "sm",
                    children: r
                  })
                }), (0, Ve.jsxs)(wg, {
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "lg",
                  gap: "lg",
                  borderColor: "border.subtle",
                  borderWidth: 1,
                  borderStyle: "solid",
                  children: [(0, Ve.jsx)(Bg, {
                    label: n(Bx.editLink),
                    size: "sm",
                    variant: "secondary",
                    onPress: () => {
                      i("edit");
                    },
                    style: {
                      flex: 1,
                      justifyContent: "center"
                    }
                  }), (0, Ve.jsx)(Bg, {
                    label: n(Bx.removeLink),
                    size: "sm",
                    onPress: () => {
                      kx(t, "link"), e?.();
                    },
                    style: {
                      flex: 1,
                      justifyContent: "center"
                    }
                  })]
                })]
              }), "edit" === o && (0, Ve.jsxs)(Ve.Fragment, {
                children: [u, (0, Ve.jsxs)(wg, {
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "lg",
                  gap: "lg",
                  borderColor: "border.subtle",
                  borderWidth: 1,
                  borderStyle: "solid",
                  children: [(0, Ve.jsx)(Bg, {
                    label: n(Bx.cancel),
                    size: "sm",
                    variant: "secondary",
                    onPress: () => {
                      i("show"), e?.();
                    }
                  }), (0, Ve.jsx)(Bg, {
                    label: n(Bx.save),
                    size: "sm",
                    onPress: () => {
                      Ax(t, a), e?.();
                    }
                  })]
                })]
              })]
            });
          },
          Bx = Ov({
            addLink: {
              id: "addLink",
              defaultMessage: "Add Link",
              description: "Add Link"
            },
            editLink: {
              id: "editLink",
              defaultMessage: "Edit Link",
              description: "Edit Link"
            },
            removeLink: {
              id: "removeLink",
              defaultMessage: "Remove Link",
              description: "Remove Link"
            },
            cancel: {
              id: "cancel",
              defaultMessage: "Cancel",
              description: "Cancel"
            },
            save: {
              id: "save",
              defaultMessage: "Save",
              description: "Save"
            },
            link: {
              id: "linkAnnotation",
              defaultMessage: "Link",
              description: "Link"
            }
          }),
          Nx = ((0, ut.lu)("#ffffff00").toString("hexa"), [{
            label: "Red",
            color: "#ff0000"
          }, {
            label: "Green",
            color: "#00ff00"
          }, {
            label: "Blue",
            color: "#0000ff"
          }, {
            label: "Yellow",
            color: "#ffff00"
          }, {
            label: "Cyan",
            color: "#00ffff"
          }, {
            label: "Magenta",
            color: "#ff00ff"
          }, {
            label: "Black",
            color: "#000000"
          }, {
            label: "White",
            color: "#ffffff"
          }, {
            label: "Gray",
            color: "#808080"
          }, {
            label: "Orange",
            color: "#ffa500"
          }, {
            label: "Brown",
            color: "#a52a2a"
          }, {
            label: "Purple",
            color: "#800080"
          }]),
          Lx = ({
            nodeType: e,
            icon: t,
            ariaLabel: n,
            isDisabled: r
          }) => {
            let o = ip(),
              i = Sx(o, e);
            return (0, Ve.jsx)(dx, {
              variant: "tertiary",
              isSelected: i,
              size: "sm",
              icon: t,
              "aria-label": n,
              isDisabled: r,
              onPress: () => {
                Ex(o, e);
              },
              preventFocusOnPress: !0
            });
          },
          Vx = ({
            nodeType: e,
            "aria-label": t,
            isDisabled: n
          }) => {
            let r = ip(),
              o = Px(r, "span")?.[e],
              i = (0, s.useCallback)(t => {
                r?.selection && (Uu.YR.setSelection(r, r.selection), _x(r), Tx(r, e, t), setTimeout(() => {
                  (0, je.kG)(r.selection), Uu.YR.setSelection(r, r.selection), _x(r);
                }, 0));
              }, [r, e]),
              a = (0, s.useCallback)(() => {
                r?.selection && (Uu.YR.setSelection(r, r.selection), _x(r), ((e, t) => {
                  let n = Px(e, "span"),
                    r = {};
                  if (n) {
                    let t = new Set(["type", "children"]);
                    r = Object.fromEntries(Object.keys(n).filter(e => !t.has(e)).filter(e => !!n[e]).map(e => [e, n[e]])), kx(e, "span");
                  }
                  let o = {
                    ...n,
                    type: "span",
                    ...r,
                    children: []
                  };
                  delete o[t], Uu.YR.wrapNodes(e, o, {
                    split: !0
                  }), Uu.YR.collapse(e, {
                    edge: "end"
                  });
                })(r, e), setTimeout(() => {
                  (0, je.kG)(r.selection), Uu.YR.setSelection(r, r.selection), _x(r);
                }, 0));
              }, [r, e]),
              l = (0, s.useCallback)(({
                ref: r,
                triggerProps: o
              }) => (0, Ve.jsx)(nv, {
                icon: "color" === e ? Ke.VL1 : Ke.mc$,
                "aria-label": t,
                size: "md",
                variant: "popover",
                isDisabled: n,
                className: px,
                preventFocusOnPress: !0,
                ...o,
                ref: r
              }), [e, t, n]),
              u = (0, s.useCallback)(e => {
                e ? i(e.toString("rgba")) : a();
              }, [a, i]);
            return (0, Ve.jsx)(Dw, {
              presets: Nx,
              allowRemoval: !0,
              pickerMode: "lazy",
              placement: "top end",
              colorLabel: !1,
              renderTriggerButton: l,
              value: o || "#000000",
              onChange: u,
              isDisabled: n
            });
          };
        var Kx = [{
            type: "paragraph",
            children: [{
              text: ""
            }]
          }],
          qx = (0, Be.gn)() || (0, Be.Dt)(),
          Hx = s.forwardRef(({
            editor: e,
            value: t,
            defaultValue: n,
            onChange: r,
            style: o,
            spellCheck: i,
            placeholder: a,
            isInline: u,
            isDisabled: c,
            editableContentAriaLabel: d,
            containerRef: p,
            onHelpDialogOpenRequest: h,
            mentionableUsers: f,
            editorHandle: m,
            maxMentionableUsersSuggestions: g,
            autoFocus: v,
            saveOnEnter: y,
            onSave: b
          }, w) => {
            let x = (0, s.useRef)(null),
              D = (0, Le.Me)(),
              C = (0, s.useCallback)(e => (0, Ve.jsx)(Ux, {
                ...e
              }), []),
              {
                formatMessage: S
              } = Tv(),
              E = (0, s.useRef)(null),
              _ = E.current,
              P = (0, s.useRef)(null),
              k = (0, s.useMemo)(() => _?.getRootNode() instanceof ShadowRoot, [_]),
              {
                onKeyDown: A,
                matchedUsers: z,
                activeIndex: T,
                insertMention: O,
                triggerMention: I,
                isMentionPopoverOpen: F,
                setActiveIndex: M
              } = function ({
                mentionableUsers: e,
                mentionPopoverRef: t,
                editor: n,
                maxMentionableUsersSuggestions: r = 10
              }) {
                let [o, i] = (0, s.useState)(null),
                  [a, l] = (0, s.useState)(0),
                  [u, c] = (0, s.useState)(""),
                  d = (0, qt.Kf)(),
                  p = (0, s.useMemo)(() => e?.map(e => ({
                    id: e.id,
                    label: e.displayName || e.name,
                    description: e.description,
                    value: e,
                    data: {
                      avatar: e.avatar
                    }
                  })), [e]),
                  {
                    contains: h
                  } = (0, Le.L0)({
                    sensitivity: "base"
                  }),
                  f = p?.filter(e => h(e.label, u)).slice(0, r),
                  m = (0, s.useCallback)(() => {
                    let {
                        selection: e
                      } = n,
                      t = Mx(n, 2);
                    if (e && Uu.e6.isCollapsed(e)) {
                      let [r] = Uu.e6.edges(e);
                      if ((t?.text?.startsWith(" ") || 1 === t?.text?.length) && t?.text?.endsWith("@")) {
                        (0, je.kG)(t, "lastTwoCharacters should be defined");
                        let e = Mx(n)?.range;
                        i(e || null), c("");
                      } else {
                        let e = Uu.ML.before(n, r, {
                            unit: "word"
                          }),
                          t = e && Uu.ML.before(n, e),
                          o = t && Uu.ML.range(n, t, r),
                          a = (o && Uu.ML.string(n, o))?.match(/^@(\w+)$/),
                          s = Uu.ML.after(n, r),
                          l = Uu.ML.range(n, r, s),
                          u = Uu.ML.string(n, l).match(/^(\s|$)/);
                        a && u && o && (i(o), c(a[1]));
                      }
                      return null;
                    }
                    i(null);
                  }, [n]),
                  g = (0, s.useCallback)((e = a) => {
                    let t = f?.[e];
                    if (t) {
                      let e = {
                        userId: t.id,
                        displayName: t.label,
                        children: [{
                          text: ""
                        }],
                        type: "mention"
                      };
                      (0, je.kG)(n, "Editor ref is not set"), (0, je.kG)(o, "Target is not set"), Uu.YR.select(n, o), Uu.YR.insertNodes(n, e), Uu.YR.move(n), Uu.YR.insertText(n, " "), l(0), i(null);
                    }
                  }, [f, a, n, o]),
                  v = (0, s.useCallback)(t => {
                    if (e?.length && o) switch (t.key) {
                      case "ArrowDown":
                        t.preventDefault(), l(e => (e + 1) % (f?.length || 1));
                        break;
                      case "ArrowUp":
                        t.preventDefault(), l(e => (e - 1 + (f?.length || 1)) % (f?.length || 1));
                        break;
                      case "Escape":
                        t.preventDefault(), i(null);
                        break;
                      case "Enter":
                        t.preventDefault(), g();
                    }
                  }, [f?.length, e?.length, o, g]);
                return (0, s.useLayoutEffect)(() => {
                  let e = t.current;
                  e && "keyboard" === d && e.querySelector("[data-active=true]")?.scrollIntoView({
                    block: "nearest",
                    behavior: "smooth"
                  });
                }, [a, t, d]), (0, Le.Fc)({
                  ref: t,
                  onInteractOutside: () => {
                    i(null);
                  }
                }), {
                  triggerMention: m,
                  matchedUsers: f,
                  onKeyDown: v,
                  insertMention: g,
                  activeIndex: a,
                  isMentionPopoverOpen: !!o && !!f?.length,
                  setActiveIndex: l
                };
              }({
                mentionableUsers: f,
                mentionPopoverRef: P,
                maxMentionableUsersSuggestions: g,
                editor: e
              }),
              [R, j] = (0, l.zk)(t ? Fx(t) : void 0, Fx(n || "<p></p>"), e => {
                r && r(Ox(e));
              }),
              {
                keyboardProps: B
              } = (0, Le.v5)({
                onKeyDown: t => {
                  y && "Enter" === t.key && !t.shiftKey && !F && (t.preventDefault(), b()), A(t), (t.metaKey || t.ctrlKey) && "b" === t.key ? (t.preventDefault(), Ex(e, "bold")) : (t.metaKey || t.ctrlKey) && "i" === t.key ? (t.preventDefault(), Ex(e, "italic")) : (t.metaKey || t.ctrlKey) && "u" === t.key ? (t.preventDefault(), Ex(e, "underline")) : t.altKey && "F10" === t.key ? (t.preventDefault(), x.current && x.current.querySelector("button")?.focus()) : t.continuePropagation(), (0, Be.vU)() && k && hd.focus(e);
                }
              });
            (0, s.useEffect)(() => {
              c && hd.deselect(e);
            }, [c, e]), (0, s.useEffect)(() => {
              let t = E.current?.querySelector("[contenteditable=true]");
              if (!t) return;
              let n = () => {
                hd.focus(e);
              };
              return Uu.YR.select(e, Uu.ML.end(e, [])), t.addEventListener("focus", n), () => {
                t.removeEventListener("focus", n);
              };
            }, [e]), (0, s.useImperativeHandle)(w, () => ({
              startMention: () => {
                let t = Mx(e, 1);
                Uu.YR.insertText(e, function (e) {
                  return e && (" " === e.text || !e.range);
                }(t) ? "@" : " @"), hd.focus(e);
              }
            })), (0, s.useImperativeHandle)(m, () => ({
              setCaretPosition: t => {
                hd.focus(e), Uu.YR.move(e, {
                  distance: t,
                  unit: "character"
                });
              }
            }));
            let {
              pressProps: N
            } = (0, Le.r7)({
              onPress: t => {
                hd.focus(e), t.continuePropagation();
              },
              allowTextSelectionOnPress: !0,
              isDisabled: c
            });
            return (0, Ve.jsxs)(Ap, {
              editor: e,
              initialValue: R || Kx,
              onValueChange: j,
              onChange: I,
              children: [(0, Ve.jsxs)(ox, {
                className: yx,
                "aria-controls": D,
                ref: x,
                children: [(0, Ve.jsxs)(wg, {
                  display: "flex",
                  flexDirection: "row",
                  role: "group",
                  gap: "xs",
                  paddingX: "sm",
                  children: [(0, Ve.jsx)(Lx, {
                    nodeType: "bold",
                    icon: $e.mY,
                    ariaLabel: S(Yx.bold),
                    isDisabled: c
                  }), (0, Ve.jsx)(Lx, {
                    nodeType: "italic",
                    icon: $e.h3,
                    ariaLabel: S(Yx.italic),
                    isDisabled: c
                  }), (0, Ve.jsx)(Lx, {
                    nodeType: "underline",
                    icon: $e.Ad,
                    ariaLabel: S(Yx.underline),
                    isDisabled: c
                  })]
                }), (0, Ve.jsx)(yg, {
                  orientation: "vertical"
                }), (0, Ve.jsx)(Vx, {
                  nodeType: "color",
                  "aria-label": S(Yx.fontColor),
                  isDisabled: c
                }), (0, Ve.jsx)(yg, {
                  orientation: "vertical"
                }), (0, Ve.jsx)(Vx, {
                  nodeType: "backgroundColor",
                  "aria-label": S(Yx.backgroundColor),
                  isDisabled: c
                }), (0, Ve.jsx)(yg, {
                  orientation: "vertical"
                }), (0, Ve.jsx)(Rx, {
                  isDisabled: c
                }), (0, Ve.jsx)(yg, {
                  orientation: "vertical"
                }), (0, Ve.jsx)(nv, {
                  className: px,
                  icon: Ke.hYA,
                  size: "sm",
                  "aria-label": S(Yx.help),
                  onPress: h
                })]
              }), (0, Ve.jsx)(yg, {
                variant: "secondary"
              }), (0, Ve.jsx)("div", {
                ref: E,
                onDragStart: Wx,
                onDragEnd: Wx,
                onKeyUp: Wx,
                children: (0, Ve.jsx)(bp, {
                  ...(0, Le.dG)(B, qx ? N : {}),
                  renderLeaf: C,
                  renderElement: $x,
                  readOnly: c,
                  disabled: c,
                  autoFocus: v,
                  "data-mention-open": F,
                  className: (0, je.AK)(fx({
                    isDisabled: c
                  }), vx({
                    isInline: u
                  })),
                  renderPlaceholder: ({
                    attributes: e,
                    children: t
                  }) => (0, Ve.jsx)("span", {
                    ...e,
                    className: (0, qe.Kj)({
                      paddingY: "lg"
                    }),
                    children: t
                  }),
                  style: o,
                  placeholder: a,
                  spellCheck: i,
                  id: D,
                  "aria-label": d
                })
              }), (0, Ve.jsxs)(Tg, {
                isOpen: F,
                type: "listbox",
                children: [(0, Ve.jsx)(Ig, {}), (0, Ve.jsx)(Nb, {
                  isNonModal: !0,
                  className: "f6jv6bi _1mdhlqv6 _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6d7 _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6fs _1yep5z6l0 _1yep5z6kz _1yep5z6hf _1yep5z6l3",
                  triggerRef: p,
                  placement: "bottom start",
                  children: (0, Ve.jsx)(Pg, {
                    ref: P,
                    items: z || [],
                    className: (0, qe.Kj)({
                      width: "full"
                    }),
                    renderOption: (...e) => Gx(...e, {
                      index: (z || []).findIndex(t => t.id === e[0].key),
                      setIndex: M,
                      activeIndex: T
                    }),
                    onAction: e => {
                      let t = z?.findIndex(t => t.id === e);
                      O(t);
                    }
                  })
                })]
              })]
            });
          });
        Hx.displayName = "RichEditor";
        var Ux = ({
            children: e,
            attributes: t,
            leaf: n
          }) => (n.bold && (e = (0, Ve.jsx)("strong", {
            children: e
          })), n.italic && (e = (0, Ve.jsx)("em", {
            children: e
          })), n.underline && (e = (0, Ve.jsx)("u", {
            children: e
          })), (0, Ve.jsx)("span", {
            ...t,
            children: e
          })),
          Zx = () => (0, Ve.jsxs)("span", {
            contentEditable: !1,
            style: {
              fontSize: 0
            },
            children: ["$", String.fromCodePoint(160)]
          }),
          $x = e => {
            let {
              attributes: t,
              children: n,
              element: r
            } = e;
            return "type" in r && "link" === r.type ? (0, Ve.jsxs)("a", {
              ...t,
              href: r.url,
              className: Xv({
                size: "sm"
              }),
              style: {
                cursor: "unset"
              },
              children: [(0, Ve.jsx)(Zx, {}), n, (0, Ve.jsx)(Zx, {})]
            }) : "type" in r && "span" === r.type ? (0, Ve.jsxs)("span", {
              ...t,
              style: {
                color: r.color,
                backgroundColor: r.backgroundColor
              },
              children: [(0, Ve.jsx)(Zx, {}), n, (0, Ve.jsx)(Zx, {})]
            }) : "type" in r && "mention" === r.type ? (0, Ve.jsxs)("span", {
              ...t,
              contentEditable: (0, Be.i7)() ? void 0 : t.contentEditable,
              "data-user-id": r.userId,
              children: [n, "@", r.displayName]
            }) : (0, Ve.jsx)("p", {
              ...t,
              children: n
            });
          },
          Gx = ({
            value: e,
            nextKey: t
          }, {
            optionProps: n,
            isDisabled: r
          }, o, {
            index: i,
            setIndex: a,
            activeIndex: s
          }) => {
            let {
              hoverProps: l
            } = (0, Le.XI)({
              isDisabled: r,
              onHoverStart: () => {
                a(i);
              }
            });
            (0, je.kG)(e, "Option value is not set");
            let {
              label: u,
              description: c,
              data: d
            } = e;
            return (0, Ve.jsxs)(Ve.Fragment, {
              children: [(0, Ve.jsxs)("li", {
                ...(0, Le.dG)(n, l),
                className: mx({
                  isDisabled: r,
                  isHovered: i === s
                }),
                "data-active": i === s,
                ref: o,
                children: [(0, Ve.jsx)(tb, {
                  name: u,
                  ...d?.avatar
                }), (0, Ve.jsxs)(wg, {
                  display: "flex",
                  flexDirection: "column",
                  children: [(0, Ve.jsx)(xb, {
                    type: "subtitle",
                    size: "sm",
                    children: u
                  }), (0, Ve.jsx)(xb, {
                    type: "helper",
                    size: "sm",
                    children: c
                  })]
                })]
              }), t ? (0, Ve.jsx)(yg, {}) : null]
            });
          };
        function Wx(e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        }
        var Yx = Ov({
            bold: {
              defaultMessage: "Bold",
              id: "bold"
            },
            italic: {
              defaultMessage: "Italic",
              id: "italic"
            },
            underline: {
              defaultMessage: "Underline",
              id: "underline"
            },
            backgroundColor: {
              defaultMessage: "Background color",
              id: "backgroundColor"
            },
            fontColor: {
              defaultMessage: "Font color",
              id: "fontColor"
            },
            help: {
              defaultMessage: "Help",
              id: "help"
            }
          }),
          Xx = s.memo(s.forwardRef(({
            className: e,
            style: t,
            "data-block-id": n,
            enableRichText: r = !1,
            onCancel: o,
            onSave: i,
            isInline: a = !0,
            submitButtonIcon: l = $e.TY,
            submitButtonAriaLabel: u,
            cancelButtonAriaLabel: c,
            "aria-label": d,
            "aria-describedby": p,
            "aria-labelledby": h,
            "aria-details": f,
            editableContentAriaLabel: m = "Editing Area",
            footerButtons: g,
            clearOnCancel: v,
            clearOnSave: y,
            ...b
          }, w) => {
            let x = (0, s.useMemo)(() => {
                let e = (e => {
                  let {
                    isInline: t
                  } = e;
                  return e.isInline = e => "type" in e && ("link" === e.type || "span" === e.type) || t(e), e;
                })(function (e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x-slate-fragment",
                    n = e,
                    {
                      apply: r,
                      onChange: o,
                      deleteBackward: i,
                      addMark: a,
                      removeMark: s
                    } = n;
                  return Bc.set(n, new WeakMap()), n.addMark = (e, t) => {
                    var r, o;
                    null === (r = Hc.get(n)) || void 0 === r || r(), !Uc.get(n) && null !== (o = $c.get(n)) && void 0 !== o && o.length && Uc.set(n, null), Zc.delete(n), a(e, t);
                  }, n.removeMark = e => {
                    var t;
                    !Uc.get(n) && null !== (t = $c.get(n)) && void 0 !== t && t.length && Uc.set(n, null), Zc.delete(n), s(e);
                  }, n.deleteBackward = e => {
                    if ("line" !== e) return i(e);
                    if (n.selection && Uu.e6.isCollapsed(n.selection)) {
                      var t = Uu.ML.above(n, {
                        match: e => Uu.W_.isElement(e) && Uu.ML.isBlock(n, e),
                        at: n.selection
                      });
                      if (t) {
                        var [, r] = t,
                          o = Uu.ML.range(n, r, n.selection.anchor),
                          a = Op(n, o);
                        Uu.e6.isCollapsed(a) || Uu.YR.delete(n, {
                          at: a
                        });
                      }
                    }
                  }, n.apply = t => {
                    var o = [],
                      i = [],
                      a = $c.get(n);
                    if (null != a && a.length) {
                      var s = a.map(e => Dd(e, t)).filter(Boolean);
                      $c.set(n, s);
                    }
                    var l = Wc.get(n);
                    l && Wc.set(n, xd(n, l, t));
                    var u = Gc.get(n);
                    if (null != u && u.at) {
                      var c = Uu.E9.isPoint(null == u ? void 0 : u.at) ? wd(n, u.at, t) : xd(n, u.at, t);
                      Gc.set(n, c ? Fp(Fp({}, u), {}, {
                        at: c
                      }) : null);
                    }
                    switch (t.type) {
                      case "insert_text":
                      case "remove_text":
                      case "set_node":
                      case "split_node":
                        o.push(...Rp(n, t.path));
                        break;
                      case "set_selection":
                        var d;
                        null === (d = Kc.get(n)) || void 0 === d || d.unref(), Kc.delete(n);
                        break;
                      case "insert_node":
                      case "remove_node":
                        o.push(...Rp(n, Uu.y$.parent(t.path)));
                        break;
                      case "merge_node":
                        var p = Uu.y$.previous(t.path);
                        o.push(...Rp(n, p));
                        break;
                      case "move_node":
                        var h,
                          f = Uu.y$.common(Uu.y$.parent(t.path), Uu.y$.parent(t.newPath));
                        o.push(...Rp(n, f)), Uu.y$.isBefore(t.path, t.newPath) ? (o.push(...Rp(n, Uu.y$.parent(t.path))), h = t.newPath) : (o.push(...Rp(n, Uu.y$.parent(t.newPath))), h = t.path);
                        var m = Uu.NB.get(e, Uu.y$.parent(h)),
                          g = hd.findKey(n, m),
                          v = Uu.ML.pathRef(n, Uu.y$.parent(h));
                        i.push([v, g]);
                    }
                    for (var [y, b] of (r(t), o)) {
                      var [w] = Uu.ML.node(n, y);
                      jc.set(w, b);
                    }
                    for (var [x, D] of i) if (x.current) {
                      var [C] = Uu.ML.node(n, x.current);
                      jc.set(C, D);
                    }
                  }, n.setFragmentData = e => {
                    var {
                      selection: r
                    } = n;
                    if (r) {
                      var [o, i] = Uu.e6.edges(r),
                        a = Uu.ML.void(n, {
                          at: o.path
                        }),
                        s = Uu.ML.void(n, {
                          at: i.path
                        });
                      if (!Uu.e6.isCollapsed(r) || a) {
                        var l = hd.toDOMRange(n, r),
                          u = l.cloneContents(),
                          c = u.childNodes[0];
                        if (u.childNodes.forEach(e => {
                          e.textContent && "" !== e.textContent.trim() && (c = e);
                        }), s) {
                          var [d] = s,
                            p = l.cloneRange(),
                            h = hd.toDOMNode(n, d);
                          p.setEndAfter(h), u = p.cloneContents();
                        }
                        if (a && (c = u.querySelector("[data-slate-spacer]")), Array.from(u.querySelectorAll("[data-slate-zero-width]")).forEach(e => {
                          var t = "n" === e.getAttribute("data-slate-zero-width");
                          e.textContent = t ? "\n" : "";
                        }), od(c)) {
                          var f = c.ownerDocument.createElement("span");
                          f.style.whiteSpace = "pre", f.appendChild(c), u.appendChild(f), c = f;
                        }
                        var m = n.getFragment(),
                          g = JSON.stringify(m),
                          v = window.btoa(encodeURIComponent(g));
                        c.setAttribute("data-slate-fragment", v), e.setData("application/".concat(t), v);
                        var y = u.ownerDocument.createElement("div");
                        return y.appendChild(u), y.setAttribute("hidden", "true"), u.ownerDocument.body.appendChild(y), e.setData("text/html", y.innerHTML), e.setData("text/plain", sd(y)), u.ownerDocument.body.removeChild(y), e;
                      }
                    }
                  }, n.insertData = e => {
                    n.insertFragmentData(e) || n.insertTextData(e);
                  }, n.insertFragmentData = e => {
                    var r = e.getData("application/".concat(t)) || ud(e);
                    if (r) {
                      var o = decodeURIComponent(window.atob(r)),
                        i = JSON.parse(o);
                      return n.insertFragment(i), !0;
                    }
                    return !1;
                  }, n.insertTextData = e => {
                    var t = e.getData("text/plain");
                    if (t) {
                      var r = t.split(/\r\n|\r|\n/),
                        o = !1;
                      for (var i of r) o && Uu.YR.splitNodes(n, {
                        always: !0
                      }), n.insertText(i), o = !0;
                      return !0;
                    }
                    return !1;
                  }, n.onChange = e => {
                    (mc < 18 ? gn.unstable_batchedUpdates : e => e())(() => {
                      var t = qc.get(n);
                      t && t(e), o(e);
                    });
                  }, n;
                }((0, jp.VC)((0, Uu.Jh)())));
                return b.mentionableUsers ? (e => {
                  let {
                    isInline: t,
                    isVoid: n,
                    markableVoid: r
                  } = e;
                  return e.isInline = e => "type" in e && "mention" === e.type || t(e), e.isVoid = e => "type" in e && "mention" === e.type || n(e), e.markableVoid = e => "type" in e && "mention" === e.type || r(e), e;
                })(e) : e;
              }, [b.mentionableUsers]),
              {
                formatMessage: D
              } = Tv(),
              C = (0, s.useRef)(null),
              S = (0, s.useRef)(null),
              E = (0, s.useRef)(null),
              _ = !r && "minimal" === b.variant,
              P = (0, s.useRef)(null),
              [k, A] = s.useState(b.value || b.defaultValue),
              z = b.isDisabled || b.isSaveDisabled || !(0, je.iT)(k || ""),
              {
                fieldProps: T
              } = (0, Le.NP)({
                "aria-label": d,
                "aria-labelledby": h,
                "aria-describedby": p,
                "aria-details": f,
                labelElementType: "div"
              });
            _ && !b.avatarName && console.warn("Editor: When using the minimal `variant` and `enableRichText` is `false`, you should provide an `avatarName`.");
            let O = (0, s.useCallback)(() => {
                A(""), r ? function (e) {
                  Uu.YR.delete(e, {
                    at: {
                      anchor: Uu.ML.start(e, []),
                      focus: Uu.ML.end(e, [])
                    }
                  });
                }(x) : S.current?.clear();
              }, [x, r]),
              I = (0, s.useCallback)(() => {
                z || (i?.(r ? Ox(x.children) : C.current.value), y && O());
              }, [O, y, x.children, r, i, z]),
              F = (0, Ve.jsx)(nv, {
                variant: "ghost",
                "aria-label": u || D(Qx.save),
                icon: l,
                isDisabled: z,
                size: "md",
                excludeFromTabOrder: _,
                className: _ ? "_1yep5z6j6 _1yep5z6j7 _1yep5z6j8" : void 0,
                onPress: I
              }),
              [M, R] = s.useState(!1),
              {
                keyboardProps: j
              } = (0, Le.v5)({
                onKeyDown: e => {
                  (e.metaKey || e.ctrlKey) && e.shiftKey && "h" === e.key && (e.preventDefault(), R(!0));
                }
              }),
              B = (0, s.useCallback)(e => {
                A(e), b.onChange?.(e);
              }, [b]);
            return (0, Ve.jsxs)("div", {
              ...(0, Le.dG)(T, r ? j : {}),
              role: "application",
              ref: (0, Be.lq)(E, w),
              style: t,
              "data-block-id": n,
              className: (0, je.AK)(hx({
                isInline: a,
                isMinimal: _
              }), "BaselineUI-Editor", e),
              "aria-disabled": b.isDisabled,
              children: [_ ? (0, Ve.jsxs)(Ve.Fragment, {
                children: [a ? (0, Ve.jsx)(tb, {
                  className: "_1yep5z64u _1yep5z64v _1yep5z64w _1yep5z676 _1yep5z677 _1yep5z678 _1yep5z6j0 _1yep5z6j1 _1yep5z6j2",
                  name: b.avatarName || ""
                }) : null, (0, Ve.jsxs)("div", {
                  className: gx({
                    isInline: a
                  }),
                  children: [(0, Ve.jsx)(Cx, {
                    isMinimal: _,
                    textBoxRef: C,
                    isInline: a,
                    editableContentAriaLabel: m,
                    ...b,
                    onChange: B,
                    onSave: I
                  }), F]
                })]
              }) : (0, Ve.jsxs)(Ve.Fragment, {
                children: [r ? (0, Ve.jsx)(Hx, {
                  containerRef: E,
                  ref: P,
                  editor: x,
                  isInline: a,
                  editableContentAriaLabel: m,
                  onHelpDialogOpenRequest: () => {
                    R(!0);
                  },
                  ...b,
                  onChange: B,
                  onSave: I
                }) : (0, Ve.jsxs)(Ve.Fragment, {
                  children: [!a && (0, Ve.jsx)(yg, {
                    variant: "secondary"
                  }), (0, Ve.jsx)(Cx, {
                    onCancel: o,
                    textBoxRef: C,
                    ref: S,
                    isInline: a,
                    editableContentAriaLabel: m,
                    ...b,
                    onChange: e => {
                      A(e), b.onChange?.(e);
                    },
                    onSave: I
                  })]
                }), (0, Ve.jsx)(yg, {
                  variant: "secondary"
                }), (0, Ve.jsxs)("div", {
                  className: (0, je.AK)(yx, (0, qe.Kj)({
                    justifyContent: "space-between"
                  })),
                  children: [(0, Ve.jsxs)(wg, {
                    paddingX: "sm",
                    gap: "sm",
                    display: "flex",
                    children: [r && b.mentionableUsers ? (0, Ve.jsx)(nv, {
                      icon: $e.lO,
                      size: "sm",
                      "aria-label": D(Qx.mention),
                      onPress: () => P.current?.startMention()
                    }) : null, g?.map(({
                      type: e,
                      props: t
                    }, n) => "action" === e ? (0, Ve.jsx)(nv, {
                      ...t,
                      size: "sm",
                      isDisabled: b.isDisabled || t.isDisabled
                    }, n) : (0, Ve.jsx)(dx, {
                      ...t,
                      size: "sm",
                      variant: "tertiary",
                      isDisabled: b.isDisabled || t.isDisabled
                    }, n))]
                  }), (0, Ve.jsxs)(wg, {
                    children: [!!o && (0, Ve.jsx)(nv, {
                      variant: "secondary",
                      icon: $e.Ni,
                      isDisabled: b.isDisabled,
                      size: "md",
                      onPress: () => {
                        o(), v && O();
                      },
                      "aria-label": c || D(Qx.cancel)
                    }), F]
                  })]
                })]
              }), (0, Ve.jsx)(xx, {
                isOpen: M,
                onClose: () => {
                  R(!1);
                }
              })]
            });
          }));
        Xx.displayName = "Editor";
        var Qx = Ov({
            cancel: {
              defaultMessage: "Cancel",
              id: "cancel"
            },
            save: {
              defaultMessage: "Save",
              id: "save"
            },
            mention: {
              defaultMessage: "Mention",
              id: "mention"
            }
          }),
          Jx = s.forwardRef(({
            className: e,
            style: t,
            "data-block-id": n,
            isMounted: r,
            children: o,
            transitions: i,
            elementType: a = "div",
            ...s
          }, l) => {
            let u = (0, Ne.Yz)(r, i),
              c = Ne.q[a];
            return u((r, i) => i && (0, Ve.jsx)(c, {
              className: e,
              "data-block-id": n,
              style: {
                ...t,
                ...r
              },
              ...s,
              ref: l,
              children: o
            }));
          });
        Jx.displayName = "Transition";
        var eD = s.forwardRef(({
          className: e,
          style: t,
          hideForKeyboard: n,
          scrollRef: r,
          label: o,
          delay: i = 1500,
          smoothScroll: a = !0,
          "data-block-id": l
        }, u) => {
          let c = s.useRef(null),
            d = (0, qt.Kf)(),
            [p, h] = s.useState(!1),
            f = (0, s.useCallback)(() => {
              let e = r?.current || (0, Be.r3)(c.current).body;
              return "column-reverse" === (0, Be.kR)(e).getComputedStyle(e).flexDirection ? e.scrollTop + 2 >= 0 : e.scrollTop + e.clientHeight + 2 >= e.scrollHeight;
            }, [r]),
            [m, g] = s.useState(f),
            v = Cv(),
            {
              buttonProps: y,
              isPressed: b
            } = (0, Le.UW)({
              onPress: () => {
                let e = r?.current || (0, Be.r3)(c.current).body;
                e.scrollTo({
                  top: e.scrollHeight,
                  behavior: a ? "smooth" : "auto"
                });
              }
            }, c),
            {
              focusProps: w,
              isFocused: x,
              isFocusVisible: D
            } = (0, Le.Fx)(),
            {
              hoverProps: C,
              isHovered: S
            } = (0, Le.XI)({}),
            E = (0, je.mS)({
              "data-block-id": l,
              "data-pressed": b,
              "data-focus-visible": D,
              "data-hovered": S,
              "data-focused": x
            });
          return (0, s.useEffect)(() => {
            g(f());
          }, [f]), (0, s.useEffect)(() => {
            let e = r?.current || (0, Be.r3)(c.current).body,
              t = "onscrollend" in (0, Be.kR)(e),
              n = () => {
                setTimeout(() => {
                  h(!1), g(f());
                }, i);
              },
              o = () => {
                h(!0), t || n();
              };
            return e.addEventListener("scroll", o), e.addEventListener("scrollend", n), () => {
              e.removeEventListener("scroll", o), e.removeEventListener("scrollend", n);
            };
          }, [r, i, f]), (0, Ve.jsxs)(Jx, {
            isMounted: !(n && "keyboard" === d || p || m),
            elementType: "button",
            transitions: {
              from: {
                opacity: 0,
                transform: "translateX(-50%) translateY(10px)"
              },
              enter: {
                opacity: 1,
                transform: "translateX(-50%) translateY(0)"
              },
              leave: {
                opacity: 0,
                transform: "translateX(-50%) translateY(10px)"
              },
              immediate: v
            },
            ...(0, Le.dG)(y, w, C, E),
            className: (0, je.AK)("_8kqf970 _1yep5z6ow _1yep5z6ox _1yep5z6oy _1yep5z613b _1yep5z613c _1yep5z613d _1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6142 _1yep5z6143 _1yep5z6144 _1yep5z6yh _1yep5z6uq _1yep5z6ur _1yep5z6us _1yep5z6168", Ry({
              isFocusVisible: D,
              variant: "high-contrast",
              isHovered: S
            }), "BaselineUI-ScrollControlButton", e),
            style: t,
            ref: (0, Be.lq)(u, c),
            children: [(0, Ve.jsx)(Ue.Ov, {
              size: 16
            }), o]
          });
        });
        eD.displayName = "ScrollControlButton";
        var tD = "_1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z6jl _1yep5z6jm _1yep5z6jn",
          nD = hg({
            defaultClassName: "_1v0p2z10 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z619 _1yep5z61a _1yep5z61b _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69f _1yep5z69g _1yep5z69h",
            variantClassNames: {
              hasTitleAndIcon: {
                true: "_1yep5z6le _1yep5z6lf _1yep5z6lg _1yep5z6nw _1yep5z6nx _1yep5z6ny"
              },
              hasNoCloseBtn: {
                true: "_1yep5z6lk _1yep5z6ll _1yep5z6lm _1yep5z6nw _1yep5z6nx _1yep5z6ny _1yep5z6p2 _1yep5z6p3 _1yep5z6p4 _1yep5z6mq _1yep5z6mr _1yep5z6ms"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              hasTitleAndIcon: !0,
              hasNoCloseBtn: !0
            }, "_1yep5z61g7 _1yep5z61g8 _1yep5z61g9"]]
          }),
          rD = s.forwardRef(({
            className: e,
            style: t,
            "data-block-id": n,
            message: r,
            title: o,
            primaryActionLabel: i,
            cancelLabel: a,
            textInputProps: s,
            icon: l,
            iconColor: u,
            showCloseButton: c = !0,
            onPrimaryAction: d,
            onCancel: p,
            autoFocusButton: h,
            isPrimaryActionDisabled: f
          }, m) => {
            let g = (0, Le.Me)(),
              {
                formatMessage: v
              } = Tv(),
              y = o && (0, Ve.jsx)(xb, {
                id: g,
                type: "title",
                size: "sm",
                elementType: "h3",
                children: o
              });
            return (0, Ve.jsxs)(Fb, {
              className: e,
              style: t,
              "data-block-id": n,
              size: "sm",
              variant: "primary",
              role: "alertdialog",
              ref: m,
              "aria-labelledby": g,
              children: [(0, Ve.jsxs)("div", {
                className: nD({
                  hasTitleAndIcon: !(!l || !o),
                  hasNoCloseBtn: !c
                }),
                children: [(0, Ve.jsxs)(wg, {
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  children: [l ? (0, Ve.jsx)(l, {
                    style: {
                      color: u
                    },
                    size: 24
                  }) : null, !l && y, c ? (0, Ve.jsx)(nv, {
                    icon: $e.b0,
                    variant: "secondary",
                    size: "md",
                    "aria-label": v(oD.close),
                    onPress: p
                  }) : null]
                }), l ? y : null]
              }), r ? (0, Ve.jsx)(wg, {
                elementType: "section",
                className: "_1v0p2z10",
                paddingX: "lg",
                paddingBottom: "lg",
                typography: "body.sm.regular",
                color: "text.primary",
                children: r
              }) : null, s ? (0, Ve.jsx)(wg, {
                paddingX: "lg",
                paddingBottom: "lg",
                children: (0, Ve.jsx)(uy, {
                  ...s
                })
              }) : null, a || i ? (0, Ve.jsxs)(Ve.Fragment, {
                children: [(0, Ve.jsx)(yg, {}), (0, Ve.jsxs)(wg, {
                  padding: "lg",
                  display: "flex",
                  gap: "xl",
                  children: [a ? (0, Ve.jsx)(Bg, {
                    variant: "secondary",
                    className: tD,
                    label: a,
                    onPress: p,
                    autoFocus: "cancel" === h
                  }) : null, i ? (0, Ve.jsx)(Bg, {
                    className: tD,
                    label: i,
                    onPress: d,
                    autoFocus: "primary" === h,
                    isDisabled: f
                  }) : null]
                })]
              }) : null]
            });
          });
        rD.displayName = "AlertDialog";
        var oD = Ov({
            close: {
              id: "close",
              defaultMessage: "Close",
              description: "Close button label"
            }
          }),
          iD = og(),
          aD = s.forwardRef(({
            className: e,
            style: t,
            children: n,
            "data-block-id": r,
            showCaret: o
          }, i) => {
            let a = (0, s.useMemo)(() => {
              let e = n;
              return (!n || Array.isArray(n) && 0 === n.length) && (e = ""), iD.render(e);
            }, [n]);
            return (0, Ve.jsx)("div", {
              className: (0, je.AK)("_1yep5z6e3 _1yep5z6eu _1yep5z6i6 _1yep5z6i7 _1yep5z6i8 _1yep5z69i _1yep5z69j _1yep5z69k", "_1t55bp70", {
                _1t55bp71: o
              }, "BaselineUI-Markdown", e),
              "data-block-id": r,
              style: t,
              ref: i,
              dangerouslySetInnerHTML: {
                __html: a
              }
            });
          });
        function sD(e) {
          let {
              formatMessage: t,
              locale: n
            } = Tv(),
            [r, o] = s.useState(!1),
            [i, a] = s.useState(0),
            [l, u] = s.useState(0),
            [c, d] = s.useState(!1);
          (0, s.useEffect)(() => {
            if (!e.current) return;
            let t = e.current,
              n = () => {
                o(!1), a(0);
              },
              r = () => {
                c || a(100 * t.currentTime / t.duration);
              },
              i = () => {
                u(t.duration);
              };
            return t.addEventListener("ended", n), t.addEventListener("timeupdate", r), t.addEventListener("loadedmetadata", i), () => {
              t.removeEventListener("ended", n), t.removeEventListener("timeupdate", r), t.removeEventListener("loadedmetadata", i);
            };
          }, [c, e]);
          let p = (0, s.useCallback)(() => {
              (async () => {
                e.current && (e.current.paused ? (await e.current.play(), o(!0), (0, ig.xQ)(t(lD.playing), "polite")) : (e.current.pause(), o(!1), (0, ig.xQ)(t(lD.paused), "polite")));
              })();
            }, [t, e]),
            h = (0, s.useCallback)(t => {
              e.current && (e.current.currentTime = t * e.current.duration / 100, (0, ig.xQ)(function (e, t) {
                let n = Math.floor(e / 3600),
                  r = Math.floor(e % 3600 / 60),
                  o = e % 60,
                  i = {
                    ...(n && {
                      hours: n
                    }),
                    ...(r && {
                      minutes: r
                    }),
                    seconds: Math.floor(o)
                  };
                return new Intl.DurationFormat(t, {
                  style: "long"
                }).format(i);
              }(e.current.currentTime, n.locale), "assertive"));
            }, [n.locale, e]);
          return {
            isPlaying: r,
            progress: i,
            duration: l,
            togglePlay: p,
            seek: h,
            setProgress: a,
            formattedCurrentTime: e.current?.currentTime ? uD(e.current?.currentTime) : "00:00",
            formattedDuration: l ? uD(l) : "00:00",
            setIsSliderDragging: d
          };
        }
        aD.displayName = "Markdown";
        var lD = Ov({
          playing: {
            id: "playing",
            defaultMessage: "Playing"
          },
          paused: {
            id: "paused",
            defaultMessage: "Paused"
          }
        });
        function uD(e) {
          return [Math.floor(e % 3600 / 60), Math.floor(e % 60)].map(e => e.toString().padStart(2, "0")).join(":");
        }
        var cD = s.forwardRef(({
          className: e,
          style: t,
          size: n = "lg",
          sources: r,
          "data-block-id": o,
          ...i
        }, a) => {
          let l = s.useRef(null),
            {
              isPlaying: u,
              progress: c,
              duration: d,
              togglePlay: p,
              seek: h,
              formattedDuration: f,
              formattedCurrentTime: m,
              setProgress: g,
              setIsSliderDragging: v
            } = sD(l),
            {
              formatMessage: y
            } = Tv(),
            b = (0, je.mS)({
              "data-block-id": o,
              "data-state": u ? "playing" : "paused",
              "data-loaded": d > 0
            });
          return (0, Ve.jsxs)("div", {
            ...b,
            ...i,
            className: (0, je.AK)("_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69o _1yep5z69p _1yep5z69q", "BaselineUI-AudioPlayer", e),
            role: "group",
            style: t,
            ref: a,
            children: [(0, Ve.jsx)(Le.TX, {
              children: (0, Ve.jsx)("audio", {
                ref: l,
                children: r.map(({
                  url: e,
                  type: t
                }) => (0, Ve.jsx)("source", {
                  src: e,
                  type: t
                }, e))
              })
            }), (0, Ve.jsx)(dx, {
              icon: u ? Ke.fpf : Ke.o1U,
              variant: "toolbar",
              isSelected: u,
              size: n,
              "aria-label": y(u ? dD.pause : dD.play),
              style: {
                borderRadius: "50%"
              },
              onPress: p
            }), (0, Ve.jsxs)("div", {
              className: "rta2n91 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69o _1yep5z69p _1yep5z69q _1yep5z6z9 _1yep5z6ut _1yep5z6uu _1yep5z6uv _1yep5z6166 _1yep5z6106",
              children: [(0, Ve.jsx)("span", {
                "aria-hidden": !0,
                children: m
              }), (0, Ve.jsx)(ov, {
                "aria-label": y(dD.audioTimeline),
                value: c,
                minValue: 0,
                maxValue: 100,
                className: "rta2n90",
                onChange: e => {
                  g(e), v(!0);
                },
                onChangeEnd: e => {
                  h(e), v(!1);
                }
              }), (0, Ve.jsx)("span", {
                "aria-hidden": !0,
                children: f
              })]
            })]
          });
        });
        cD.displayName = "AudioPlayer";
        var dD = Ov({
            play: {
              id: "play",
              defaultMessage: "Play"
            },
            pause: {
              id: "pause",
              defaultMessage: "Pause"
            },
            audioTimeline: {
              id: "audioTimeline",
              defaultMessage: "Audio timeline"
            }
          }),
          pD = hg({
            defaultClassName: "_1w920rn2 _1yep5z6d6 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6hl _1yep5z6hm _1yep5z6hn",
            variantClassNames: {
              isFocusVisible: {
                true: "_1yep5z6l1 _1yep5z6kz _1yep5z6hc"
              },
              isSelected: {
                true: "_1yep5z6l1 _1yep5z6kz _1yep5z6hc"
              },
              isLoading: {
                true: "_1yep5z614w _1yep5z614x _1yep5z614y"
              },
              size: {
                sm: "_1w920rn6",
                md: "_1w920rn7"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isFocusVisible: !0,
              isSelected: !0
            }, "_1w920rn8 _1yep5z6l1 _1yep5z6kz _1yep5z6hc"]]
          }),
          hD = hg({
            defaultClassName: "_1w920rn9 _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z6b0 _1yep5z6b1 _1yep5z6b2 _1yep5z6bo _1yep5z6bp _1yep5z6bq _1yep5z6cc _1yep5z6cd _1yep5z6ce _1yep5z6d0 _1yep5z6d1 _1yep5z6d2 _1yep5z6fw _1yep5z6eu _1yep5z6dy",
            variantClassNames: {
              isFocusVisible: {
                true: "_1w920rna _1yep5z6l1 _1yep5z6kz _1yep5z6hc"
              },
              isSelected: {
                true: "_1w920rnb"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isFocusVisible: !0,
              isSelected: !0
            }, "_1w920rnc _1yep5z61rm _1yep5z61rl _1yep5z61nz"]]
          }),
          fD = ({
            items: e,
            ulRef: t
          }) => {
            let {
                length: n
              } = e,
              r = s.useRef(null);
            return (0, s.useLayoutEffect)(() => {
              if (!r.current) return;
              let t = r.current.closest(".BaselineUI-ImageGallery")?.querySelector(`[data-image-key='${e?.at(-1)?.key}']`)?.cloneNode(!0);
              (0, je.kG)(t, "Node is not defined."), r.current?.prepend(t);
            }, [e, t]), (0, Ve.jsx)("div", {
              className: pD(),
              ref: r,
              children: (0, Ve.jsx)(wg, {
                backgroundColor: "background.secondary.medium",
                borderRadius: "full",
                typography: "label.md.medium",
                color: "text.primary",
                position: "absolute",
                paddingX: "md",
                className: "_1w920rne",
                children: n
              })
            });
          },
          mD = ({
            item: {
              value: e
            },
            options: {
              optionProps: t,
              isFocusVisible: n,
              isSelected: r
            },
            liRef: o,
            fit: i = "contain",
            size: a,
            onDelete: s,
            aspectRatio: l
          }) => {
            let u = (0, Le.Me)(),
              {
                formatMessage: c
              } = Tv();
            (0, je.kG)(e && ("option" === e?.type || void 0 === e?.type));
            let {
                imgProps: d,
                isLoading: p,
                isLoaded: h
              } = Dv({
                src: e.data?.src,
                alt: e.data?.alt
              }),
              f = (0, Ne.Yz)(h, {
                from: {
                  opacity: 0
                },
                enter: {
                  opacity: 1
                },
                leave: {
                  opacity: 0
                }
              });
            return (0, Ve.jsxs)("li", {
              ...t,
              ref: o,
              className: "_1w920rn1 _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69i _1yep5z69j _1yep5z69k",
              "aria-labelledby": u,
              children: [(0, Ve.jsx)("div", {
                className: pD({
                  isFocusVisible: n,
                  isSelected: r,
                  isLoading: !0,
                  size: a
                }),
                style: {
                  aspectRatio: l?.toString()
                },
                "data-image-key": e.id,
                children: p ? (0, Ve.jsx)(xy, {
                  "aria-label": c(yD.loading)
                }) : f((t, n) => n && (0, Ve.jsx)(Ne.q.div, {
                  role: "img",
                  "aria-label": d.alt,
                  style: {
                    ...t,
                    backgroundImage: `url(${d.src})`,
                    backgroundSize: i
                  },
                  className: "_1w920rnd _1yep5z6kw",
                  children: s ? (0, Ve.jsx)("div", {
                    className: "_1w920rnf _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6fs _1yep5z6ho _1yep5z6hp _1yep5z6hq",
                    children: (0, Ve.jsx)(nv, {
                      "aria-label": c(yD.delete),
                      size: "xs",
                      icon: Ze.b0,
                      onPress: () => {
                        s(e.id);
                      },
                      UNSAFE_NON_INTERACTIVE: !0
                    })
                  }) : null
                }))
              }), (0, Ve.jsx)("span", {
                id: u,
                className: hD({
                  isFocusVisible: n,
                  isSelected: r
                }),
                children: e.label
              })]
            });
          },
          gD = {
            width: 0,
            display: "block"
          },
          vD = s.forwardRef(({
            className: e,
            style: t,
            items: n,
            fit: r = "cover",
            onReorder: o,
            "data-block-id": i,
            onDelete: a,
            size: l = "sm",
            aspectRatio: u = 3 / 4,
            ...c
          }, d) => {
            let p = s.useRef(null),
              [h, f] = (0, s.useState)([]),
              [m, g] = (0, s.useState)(new Set()),
              {
                formatMessage: v
              } = Tv(),
              y = function (e) {
                let {
                    initialItems: t = [],
                    initialSelectedKeys: n,
                    getKey: r = e => e.id || e.key,
                    filter: o,
                    initialFilterText: i = ""
                  } = e,
                  [a, l] = (0, s.useState)({
                    items: t,
                    selectedKeys: "all" === n ? "all" : new Set(n || []),
                    filterText: i
                  }),
                  u = (0, s.useMemo)(() => o ? a.items.filter(e => o(e, a.filterText)) : a.items, [a.items, a.filterText, o]);
                return {
                  ...a,
                  items: u,
                  ...ie({
                    getKey: r
                  }, l),
                  getItem: e => a.items.find(t => r(t) === e)
                };
              }({
                initialItems: n.map(e => ({
                  id: e.id,
                  label: e.label,
                  data: {
                    src: e.src,
                    alt: e.alt
                  }
                }))
              }),
              b = (0, s.useCallback)(e => {
                "before" === e.target.dropPosition ? y.moveBefore(e.target.key, e.keys) : "after" === e.target.dropPosition && y.moveAfter(e.target.key, e.keys), o?.(e);
              }, [y, o]),
              w = (0, s.useCallback)(() => {
                a && h.length && (y.remove(...h), a(new Set(h)), f([]));
              }, [h, y, a]),
              x = (0, s.useCallback)((e, t, n) => (0, Ve.jsx)(mD, {
                item: e,
                options: t,
                liRef: n,
                fit: r,
                size: l,
                aspectRatio: u,
                onDelete: a ? e => {
                  f([e]);
                } : void 0
              }), [u, r, a, l]),
              {
                keyboardProps: D
              } = (0, Le.v5)({
                onKeyDown(e) {
                  if ("Backspace" === e.key || "Delete" === e.key) {
                    if (!a) return;
                    if ([...m].length) f([...m]);else {
                      let t = y.getItem(e.target.dataset.key).id;
                      f([t]);
                    }
                  }
                }
              });
            return (0, Ve.jsxs)("div", {
              ...D,
              ref: d,
              style: t,
              className: (0, je.AK)("BaselineUI-ImageGallery", e),
              "data-block-id": i,
              children: [(0, Ve.jsx)(Pg, {
                ...c,
                items: y.items,
                onReorder: b,
                layout: "grid",
                orientation: "vertical",
                className: "_1w920rn0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6km",
                ref: p,
                dropIndicatorStyle: gD,
                renderOption: x,
                renderDragPreview: e => (0, Ve.jsx)(fD, {
                  items: e,
                  ulRef: p
                }),
                onSelectionChange: g,
                getItems: e => [...e].map(e => ({
                  src: y.getItem(e).data.src,
                  alt: y.getItem(e).data.alt || "",
                  key: e
                }))
              }), (0, Ve.jsx)(Pb, {
                isOpen: !![...h].length,
                onOpenChange: e => {
                  e || f([]);
                },
                children: (0, Ve.jsx)(Tb, {
                  isDismissable: !0,
                  children: (0, Ve.jsx)(rD, {
                    showCloseButton: !1,
                    title: "Are you sure you want to delete this item?",
                    primaryActionLabel: v(yD.delete),
                    cancelLabel: v(yD.cancel),
                    onCancel: () => {
                      f([]);
                    },
                    onPrimaryAction: w,
                    autoFocusButton: "cancel"
                  })
                })
              })]
            });
          });
        vD.displayName = "ImageGallery";
        var yD = Ov({
            delete: {
              id: "delete",
              defaultMessage: "Delete"
            },
            cancel: {
              id: "cancel",
              defaultMessage: "Cancel"
            },
            loading: {
              id: "loading",
              defaultMessage: "Loading"
            }
          }),
          bD = hg({
            defaultClassName: "_18v88n10 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6kv",
            variantClassNames: {
              labelPosition: {
                top: "_1yep5z613n _1yep5z613o _1yep5z613p",
                start: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6152 _1yep5z6153 _1yep5z6154 _1yep5z6ut _1yep5z6uu _1yep5z6uv"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          wD = hg({
            defaultClassName: "_18v88n1p _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6eu _1yep5z6kv _1yep5z6l6 _1yep5z6ky _1yep5z6dy",
            variantClassNames: {
              isDisabled: {
                true: "_18v88n1q _1yep5z6109"
              },
              labelPosition: {
                top: "_18v88n1r",
                start: "_18v88n1s"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          xD = hg({
            defaultClassName: "_18v88n1t _1yep5z660 _1yep5z661 _1yep5z662 _1yep5z6i3 _1yep5z6i4 _1yep5z6i5 _1yep5z6ks",
            variantClassNames: {
              validationState: {
                valid: "_18v88n1u",
                error: "_1yep5z6zp",
                warning: "_1yep5z6zx"
              },
              isReadOnly: {
                true: "_1yep5z610b"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          DD = hg({
            defaultClassName: "_18v88n1d _1yep5z6ai _1yep5z6aj _1yep5z6ak _1yep5z6b6 _1yep5z6b7 _1yep5z6b8 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z6l9 _1yep5z6l7 _1yep5z6gq _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              validationState: {
                valid: "_18v88n1e",
                error: "_1yep5z611k",
                warning: "_18v88n1g"
              },
              isHovered: {
                true: "_18v88n1h"
              },
              isFocused: {
                true: "_1yep5z6vt _1yep5z6vu _1yep5z6vv _1yep5z6wh _1yep5z6wi _1yep5z6wj _1yep5z6x5 _1yep5z6x6 _1yep5z6x7 _1yep5z6xt _1yep5z6xu _1yep5z6xv _1yep5z616k _1yep5z616i _1yep5z611y _1yep5z616b _1yep5z616a _1yep5z612n _1yep5z616d"
              },
              isDisabled: {
                true: "_18v88n1j"
              },
              variant: {
                primary: "_18v88n1k",
                ghost: "_18v88n1l"
              },
              isReadOnly: {
                true: "_1yep5z612n"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              variant: "ghost",
              isHovered: !0,
              isFocused: !1,
              validationState: "valid"
            }, "_1yep5z61rv _1yep5z61rt _1yep5z61nc"], [{
              variant: "ghost",
              isFocused: !1,
              isHovered: !1,
              validationState: "valid"
            }, "_18v88n1n"], [{
              isHovered: !0,
              validationState: "valid",
              isDisabled: !1,
              isReadOnly: !1,
              isFocused: !1,
              variant: "primary"
            }, "_1yep5z61nd"], [{
              isHovered: !0,
              validationState: "warning",
              isDisabled: !1,
              isReadOnly: !1,
              isFocused: !1
            }, "_1yep5z61nd"], [{
              isReadOnly: !0,
              variant: "primary",
              isFocused: !1
            }, "_18v88n1o"]]
          }),
          CD = hg({
            defaultClassName: "_18v88n13 _1yep5z6dy _1yep5z6ev",
            variantClassNames: {
              isDisabled: {
                true: "_1yep5z6109"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          SD = hg({
            defaultClassName: "_18v88n19 _1yep5z6i3 _1yep5z6i4 _1yep5z6i5",
            variantClassNames: {
              labelPosition: {
                top: "_1yep5z6sh _1yep5z6si _1yep5z6sj",
                start: "_1yep5z6me _1yep5z6mf _1yep5z6mg _1yep5z613n _1yep5z613o _1yep5z613p"
              },
              hasMessage: {
                true: "_18v88n1c"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              labelPosition: "start",
              hasMessage: !1
            }, "_1yep5z61q7 _1yep5z61q8 _1yep5z61q9"]]
          }),
          ED = hg({
            defaultClassName: "_18v88n15 _1yep5z699 _1yep5z69a _1yep5z69b _1yep5z6ky",
            variantClassNames: {
              isFocusVisible: {
                true: "_1yep5z6116 _1yep5z612v _1yep5z6169"
              },
              isHovered: {
                true: "_1yep5z6116 _1yep5z612v _1yep5z6169"
              },
              isOpen: {
                true: "_1yep5z612v _1yep5z6169"
              }
            },
            defaultVariants: {},
            compoundVariants: [[{
              isFocusVisible: !0
            }, "_1yep5z61mh _1yep5z61o6 _1yep5z61rk"], [{
              isHovered: !0
            }, "_1yep5z61mh _1yep5z61o6 _1yep5z61rk"], [{
              isOpen: !0
            }, "_1yep5z61o6 _1yep5z61rk"]]
          }),
          _D = s.forwardRef(({
            className: e,
            style: t,
            inputStyle: n,
            inputClassName: r,
            "data-block-id": o,
            label: i,
            items: a,
            showSelectedIcon: l = !1,
            onSelectionChange: u,
            onInputChange: d,
            isInvalid: p = !1,
            labelPosition: h = "top",
            validationState: f = "valid",
            variant: m = "primary",
            toggleLabel: g,
            renderOption: v,
            showIcon: y = !0,
            filter: w,
            ...x
          }, D) => {
            let {
                contains: C
              } = (0, Le.L0)({
                sensitivity: "base"
              }),
              S = b({
                ...x,
                defaultFilter: w || C,
                defaultItems: a,
                onSelectionChange: u,
                onInputChange: d,
                children: e => "section" === e.type ? (0, Ve.jsx)(c.$0, {
                  items: e.children,
                  title: e.id,
                  children: e => (0, Ve.jsx)(c.ck, {
                    children: e.label
                  }, e.id)
                }, e.id) : (0, Ve.jsx)(c.ck, {
                  children: e.label
                }, e.id),
                validationState: p ? "invalid" : "valid"
              }),
              E = s.useRef(null),
              _ = s.useRef(null),
              P = s.useRef(null),
              k = s.useRef(null),
              A = s.useRef(null),
              {
                buttonProps: z,
                inputProps: T,
                listBoxProps: O,
                labelProps: I,
                errorMessageProps: F,
                descriptionProps: M,
                validationErrors: R
              } = (0, Le.E_)({
                ...x,
                inputRef: _,
                defaultItems: a,
                buttonRef: E,
                listBoxRef: P,
                popoverRef: k,
                validationState: "error" === f ? "invalid" : "valid"
              }, S),
              j = x.errorMessage || R.join(" "),
              B = Jg({
                ...x,
                errorMessage: j,
                descriptionProps: M,
                errorMessageProps: F,
                labelPosition: h
              });
            j && (f = "error");
            let {
                hoverProps: N,
                isHovered: L
              } = (0, Le.XI)({
                isDisabled: x.isDisabled
              }),
              {
                isFocused: V,
                focusProps: K,
                isFocusVisible: q
              } = (0, Le.Fx)(),
              H = ly({
                isReadOnly: x.isReadOnly,
                validationState: f
              }),
              U = (0, je.mS)({
                "data-read-only": x.isReadOnly,
                "data-disabled": x.isDisabled,
                "data-validation-state": f,
                "data-focused": V,
                "data-focus-visible": q
              }),
              {
                labelProps: Z,
                fieldProps: $
              } = (0, Le.NP)({
                label: i
              });
            return (0, Ve.jsxs)("div", {
              className: (0, je.AK)(bD({
                labelPosition: h
              }), e, "BaselineUI-ComboBox"),
              "data-block-id": o,
              style: t,
              ref: D,
              children: [i || "start" === h && B ? (0, Ve.jsxs)("div", {
                className: SD({
                  labelPosition: h,
                  hasMessage: !!B
                }),
                children: [(0, Ve.jsx)("label", {
                  ...(0, Le.dG)(I, Z),
                  className: CD({
                    isDisabled: x.isDisabled
                  }),
                  children: i
                }), "start" === h && B]
              }) : null, (0, Ve.jsxs)("div", {
                ...N,
                className: DD({
                  validationState: f,
                  isHovered: L,
                  isFocused: V,
                  variant: m,
                  isReadOnly: !!x.isReadOnly,
                  isDisabled: !!x.isDisabled
                }),
                ref: A,
                children: [(0, Ve.jsx)("input", {
                  ...(0, Le.dG)(T, K, U, $),
                  ref: _,
                  className: (0, je.AK)(wD({
                    isDisabled: x.isDisabled,
                    labelPosition: h
                  }), "BaselineUI-ComboBox-Input", r),
                  style: n
                }), H && y ? (0, Ve.jsx)(H, {
                  className: xD({
                    validationState: f,
                    isReadOnly: x.isReadOnly
                  }),
                  size: 16
                }) : null, (0, Ve.jsx)(Bg, {
                  ...z,
                  ref: E,
                  variant: "popover",
                  label: g,
                  className: ED({
                    isFocusVisible: !x.isDisabled && !x.isReadOnly && q,
                    isHovered: !x.isDisabled && !x.isReadOnly && L,
                    isOpen: S.isOpen
                  })
                })]
              }), S.isOpen ? (0, Ve.jsx)(Hv, {
                className: "_1yep5z6d7 _1yep5z6fs",
                ref: k,
                triggerRef: A,
                state: S,
                children: (0, Ve.jsx)(Pg, {
                  ...O,
                  items: a,
                  ref: P,
                  UNSAFE_state: S,
                  renderOption: v,
                  selectionMode: "single",
                  showSelectedIcon: l,
                  className: "_1yep5z6kv"
                })
              }) : null, "top" === h && B]
            });
          });
        function PD(e) {
          return e.closest(".BaselineUI-Portal") || e.closest(".BaselineUI-Popover-Content");
        }
        _D.displayName = "ComboBox";
      },
      4286: function (e) {
        e.exports = function () {
          "use strict";

          const {
            entries: e,
            setPrototypeOf: t,
            isFrozen: n,
            getPrototypeOf: r,
            getOwnPropertyDescriptor: o
          } = Object;
          let {
              freeze: i,
              seal: a,
              create: s
            } = Object,
            {
              apply: l,
              construct: u
            } = "undefined" != typeof Reflect && Reflect;
          i || (i = function (e) {
            return e;
          }), a || (a = function (e) {
            return e;
          }), l || (l = function (e, t, n) {
            return e.apply(t, n);
          }), u || (u = function (e, t) {
            return new e(...t);
          });
          const c = D(Array.prototype.forEach),
            d = D(Array.prototype.pop),
            p = D(Array.prototype.push),
            h = D(String.prototype.toLowerCase),
            f = D(String.prototype.toString),
            m = D(String.prototype.match),
            g = D(String.prototype.replace),
            v = D(String.prototype.indexOf),
            y = D(String.prototype.trim),
            b = D(Object.prototype.hasOwnProperty),
            w = D(RegExp.prototype.test),
            x = C(TypeError);
          function D(e) {
            return function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
              return l(e, t, r);
            };
          }
          function C(e) {
            return function () {
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return u(e, n);
            };
          }
          function S(e, r) {
            let o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h;
            t && t(e, null);
            let i = r.length;
            for (; i--;) {
              let t = r[i];
              if ("string" == typeof t) {
                const e = o(t);
                e !== t && (n(r) || (r[i] = e), t = e);
              }
              e[t] = !0;
            }
            return e;
          }
          function E(e) {
            for (let t = 0; t < e.length; t++) b(e, t) || (e[t] = null);
            return e;
          }
          function _(t) {
            const n = s(null);
            for (const [r, o] of e(t)) b(t, r) && (Array.isArray(o) ? n[r] = E(o) : o && "object" == typeof o && o.constructor === Object ? n[r] = _(o) : n[r] = o);
            return n;
          }
          function P(e, t) {
            for (; null !== e;) {
              const n = o(e, t);
              if (n) {
                if (n.get) return D(n.get);
                if ("function" == typeof n.value) return D(n.value);
              }
              e = r(e);
            }
            function n() {
              return null;
            }
            return n;
          }
          const k = i(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
            A = i(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
            z = i(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
            T = i(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
            O = i(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
            I = i(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
            F = i(["#text"]),
            M = i(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
            R = i(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
            j = i(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
            B = i(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
            N = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            L = a(/<%[\w\W]*|[\w\W]*%>/gm),
            V = a(/\${[\w\W]*}/gm),
            K = a(/^data-[\-\w.\u00B7-\uFFFF]/),
            q = a(/^aria-[\-\w]+$/),
            H = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            U = a(/^(?:\w+script|data):/i),
            Z = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            $ = a(/^html$/i),
            G = a(/^[a-z][.\w]*(-[.\w]+)+$/i);
          var W = Object.freeze({
            __proto__: null,
            MUSTACHE_EXPR: N,
            ERB_EXPR: L,
            TMPLIT_EXPR: V,
            DATA_ATTR: K,
            ARIA_ATTR: q,
            IS_ALLOWED_URI: H,
            IS_SCRIPT_OR_DATA: U,
            ATTR_WHITESPACE: Z,
            DOCTYPE_NAME: $,
            CUSTOM_ELEMENT: G
          });
          const Y = {
              element: 1,
              attribute: 2,
              text: 3,
              cdataSection: 4,
              entityReference: 5,
              entityNode: 6,
              progressingInstruction: 7,
              comment: 8,
              document: 9,
              documentType: 10,
              documentFragment: 11,
              notation: 12
            },
            X = function () {
              return "undefined" == typeof window ? null : window;
            },
            Q = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let n = null;
              const r = "data-tt-policy-suffix";
              t && t.hasAttribute(r) && (n = t.getAttribute(r));
              const o = "dompurify" + (n ? "#" + n : "");
              try {
                return e.createPolicy(o, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + o + " could not be created."), null;
              }
            };
          function J() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : X();
            const n = e => J(e);
            if (n.version = "3.1.5", n.removed = [], !t || !t.document || t.document.nodeType !== Y.document) return n.isSupported = !1, n;
            let {
              document: r
            } = t;
            const o = r,
              a = o.currentScript,
              {
                DocumentFragment: l,
                HTMLTemplateElement: u,
                Node: D,
                Element: C,
                NodeFilter: E,
                NamedNodeMap: N = t.NamedNodeMap || t.MozNamedAttrMap,
                HTMLFormElement: L,
                DOMParser: V,
                trustedTypes: K
              } = t,
              q = C.prototype,
              U = P(q, "cloneNode"),
              Z = P(q, "nextSibling"),
              G = P(q, "childNodes"),
              ee = P(q, "parentNode");
            if ("function" == typeof u) {
              const e = r.createElement("template");
              e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
            }
            let te,
              ne = "";
            const {
                implementation: re,
                createNodeIterator: oe,
                createDocumentFragment: ie,
                getElementsByTagName: ae
              } = r,
              {
                importNode: se
              } = o;
            let le = {};
            n.isSupported = "function" == typeof e && "function" == typeof ee && re && void 0 !== re.createHTMLDocument;
            const {
              MUSTACHE_EXPR: ue,
              ERB_EXPR: ce,
              TMPLIT_EXPR: de,
              DATA_ATTR: pe,
              ARIA_ATTR: he,
              IS_SCRIPT_OR_DATA: fe,
              ATTR_WHITESPACE: me,
              CUSTOM_ELEMENT: ge
            } = W;
            let {
                IS_ALLOWED_URI: ve
              } = W,
              ye = null;
            const be = S({}, [...k, ...A, ...z, ...O, ...F]);
            let we = null;
            const xe = S({}, [...M, ...R, ...j, ...B]);
            let De = Object.seal(s(null, {
                tagNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                attributeNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: !1
                }
              })),
              Ce = null,
              Se = null,
              Ee = !0,
              _e = !0,
              Pe = !1,
              ke = !0,
              Ae = !1,
              ze = !0,
              Te = !1,
              Oe = !1,
              Ie = !1,
              Fe = !1,
              Me = !1,
              Re = !1,
              je = !0,
              Be = !1;
            const Ne = "user-content-";
            let Le = !0,
              Ve = !1,
              Ke = {},
              qe = null;
            const He = S({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
            let Ue = null;
            const Ze = S({}, ["audio", "video", "img", "source", "image", "track"]);
            let $e = null;
            const Ge = S({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
              We = "http://www.w3.org/1998/Math/MathML",
              Ye = "http://www.w3.org/2000/svg",
              Xe = "http://www.w3.org/1999/xhtml";
            let Qe = Xe,
              Je = !1,
              et = null;
            const tt = S({}, [We, Ye, Xe], f);
            let nt = null;
            const rt = ["application/xhtml+xml", "text/html"],
              ot = "text/html";
            let it = null,
              at = null;
            const st = r.createElement("form"),
              lt = function (e) {
                return e instanceof RegExp || e instanceof Function;
              },
              ut = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!at || at !== e) {
                  if (e && "object" == typeof e || (e = {}), e = _(e), nt = -1 === rt.indexOf(e.PARSER_MEDIA_TYPE) ? ot : e.PARSER_MEDIA_TYPE, it = "application/xhtml+xml" === nt ? f : h, ye = b(e, "ALLOWED_TAGS") ? S({}, e.ALLOWED_TAGS, it) : be, we = b(e, "ALLOWED_ATTR") ? S({}, e.ALLOWED_ATTR, it) : xe, et = b(e, "ALLOWED_NAMESPACES") ? S({}, e.ALLOWED_NAMESPACES, f) : tt, $e = b(e, "ADD_URI_SAFE_ATTR") ? S(_(Ge), e.ADD_URI_SAFE_ATTR, it) : Ge, Ue = b(e, "ADD_DATA_URI_TAGS") ? S(_(Ze), e.ADD_DATA_URI_TAGS, it) : Ze, qe = b(e, "FORBID_CONTENTS") ? S({}, e.FORBID_CONTENTS, it) : He, Ce = b(e, "FORBID_TAGS") ? S({}, e.FORBID_TAGS, it) : {}, Se = b(e, "FORBID_ATTR") ? S({}, e.FORBID_ATTR, it) : {}, Ke = !!b(e, "USE_PROFILES") && e.USE_PROFILES, Ee = !1 !== e.ALLOW_ARIA_ATTR, _e = !1 !== e.ALLOW_DATA_ATTR, Pe = e.ALLOW_UNKNOWN_PROTOCOLS || !1, ke = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Ae = e.SAFE_FOR_TEMPLATES || !1, ze = !1 !== e.SAFE_FOR_XML, Te = e.WHOLE_DOCUMENT || !1, Fe = e.RETURN_DOM || !1, Me = e.RETURN_DOM_FRAGMENT || !1, Re = e.RETURN_TRUSTED_TYPE || !1, Ie = e.FORCE_BODY || !1, je = !1 !== e.SANITIZE_DOM, Be = e.SANITIZE_NAMED_PROPS || !1, Le = !1 !== e.KEEP_CONTENT, Ve = e.IN_PLACE || !1, ve = e.ALLOWED_URI_REGEXP || H, Qe = e.NAMESPACE || Xe, De = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && lt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (De.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && lt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (De.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (De.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ae && (_e = !1), Me && (Fe = !0), Ke && (ye = S({}, F), we = [], !0 === Ke.html && (S(ye, k), S(we, M)), !0 === Ke.svg && (S(ye, A), S(we, R), S(we, B)), !0 === Ke.svgFilters && (S(ye, z), S(we, R), S(we, B)), !0 === Ke.mathMl && (S(ye, O), S(we, j), S(we, B))), e.ADD_TAGS && (ye === be && (ye = _(ye)), S(ye, e.ADD_TAGS, it)), e.ADD_ATTR && (we === xe && (we = _(we)), S(we, e.ADD_ATTR, it)), e.ADD_URI_SAFE_ATTR && S($e, e.ADD_URI_SAFE_ATTR, it), e.FORBID_CONTENTS && (qe === He && (qe = _(qe)), S(qe, e.FORBID_CONTENTS, it)), Le && (ye["#text"] = !0), Te && S(ye, ["html", "head", "body"]), ye.table && (S(ye, ["tbody"]), delete Ce.tbody), e.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    te = e.TRUSTED_TYPES_POLICY, ne = te.createHTML("");
                  } else void 0 === te && (te = Q(K, a)), null !== te && "string" == typeof ne && (ne = te.createHTML(""));
                  i && i(e), at = e;
                }
              },
              ct = S({}, ["mi", "mo", "mn", "ms", "mtext"]),
              dt = S({}, ["foreignobject", "annotation-xml"]),
              pt = S({}, ["title", "style", "font", "a", "script"]),
              ht = S({}, [...A, ...z, ...T]),
              ft = S({}, [...O, ...I]),
              mt = function (e) {
                let t = ee(e);
                t && t.tagName || (t = {
                  namespaceURI: Qe,
                  tagName: "template"
                });
                const n = h(e.tagName),
                  r = h(t.tagName);
                return !!et[e.namespaceURI] && (e.namespaceURI === Ye ? t.namespaceURI === Xe ? "svg" === n : t.namespaceURI === We ? "svg" === n && ("annotation-xml" === r || ct[r]) : Boolean(ht[n]) : e.namespaceURI === We ? t.namespaceURI === Xe ? "math" === n : t.namespaceURI === Ye ? "math" === n && dt[r] : Boolean(ft[n]) : e.namespaceURI === Xe ? !(t.namespaceURI === Ye && !dt[r]) && !(t.namespaceURI === We && !ct[r]) && !ft[n] && (pt[n] || !ht[n]) : !("application/xhtml+xml" !== nt || !et[e.namespaceURI]));
              },
              gt = function (e) {
                p(n.removed, {
                  element: e
                });
                try {
                  e.parentNode.removeChild(e);
                } catch (t) {
                  e.remove();
                }
              },
              vt = function (e, t) {
                try {
                  p(n.removed, {
                    attribute: t.getAttributeNode(e),
                    from: t
                  });
                } catch (e) {
                  p(n.removed, {
                    attribute: null,
                    from: t
                  });
                }
                if (t.removeAttribute(e), "is" === e && !we[e]) if (Fe || Me) try {
                  gt(t);
                } catch (e) {} else try {
                  t.setAttribute(e, "");
                } catch (e) {}
              },
              yt = function (e) {
                let t = null,
                  n = null;
                if (Ie) e = "<remove></remove>" + e;else {
                  const t = m(e, /^[\r\n\t ]+/);
                  n = t && t[0];
                }
                "application/xhtml+xml" === nt && Qe === Xe && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                const o = te ? te.createHTML(e) : e;
                if (Qe === Xe) try {
                  t = new V().parseFromString(o, nt);
                } catch (e) {}
                if (!t || !t.documentElement) {
                  t = re.createDocument(Qe, "template", null);
                  try {
                    t.documentElement.innerHTML = Je ? ne : o;
                  } catch (e) {}
                }
                const i = t.body || t.documentElement;
                return e && n && i.insertBefore(r.createTextNode(n), i.childNodes[0] || null), Qe === Xe ? ae.call(t, Te ? "html" : "body")[0] : Te ? t.documentElement : i;
              },
              bt = function (e) {
                return oe.call(e.ownerDocument || e, e, E.SHOW_ELEMENT | E.SHOW_COMMENT | E.SHOW_TEXT | E.SHOW_PROCESSING_INSTRUCTION | E.SHOW_CDATA_SECTION, null);
              },
              wt = function (e) {
                return e instanceof L && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof N) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
              },
              xt = function (e) {
                return "function" == typeof D && e instanceof D;
              },
              Dt = function (e, t, r) {
                le[e] && c(le[e], e => {
                  e.call(n, t, r, at);
                });
              },
              Ct = function (e) {
                let t = null;
                if (Dt("beforeSanitizeElements", e, null), wt(e)) return gt(e), !0;
                const r = it(e.nodeName);
                if (Dt("uponSanitizeElement", e, {
                  tagName: r,
                  allowedTags: ye
                }), e.hasChildNodes() && !xt(e.firstElementChild) && w(/<[/\w]/g, e.innerHTML) && w(/<[/\w]/g, e.textContent)) return gt(e), !0;
                if (e.nodeType === Y.progressingInstruction) return gt(e), !0;
                if (ze && e.nodeType === Y.comment && w(/<[/\w]/g, e.data)) return gt(e), !0;
                if (!ye[r] || Ce[r]) {
                  if (!Ce[r] && Et(r)) {
                    if (De.tagNameCheck instanceof RegExp && w(De.tagNameCheck, r)) return !1;
                    if (De.tagNameCheck instanceof Function && De.tagNameCheck(r)) return !1;
                  }
                  if (Le && !qe[r]) {
                    const t = ee(e) || e.parentNode,
                      n = G(e) || e.childNodes;
                    if (n && t) for (let r = n.length - 1; r >= 0; --r) {
                      const o = U(n[r], !0);
                      o.__removalCount = (e.__removalCount || 0) + 1, t.insertBefore(o, Z(e));
                    }
                  }
                  return gt(e), !0;
                }
                return e instanceof C && !mt(e) ? (gt(e), !0) : "noscript" !== r && "noembed" !== r && "noframes" !== r || !w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Ae && e.nodeType === Y.text && (t = e.textContent, c([ue, ce, de], e => {
                  t = g(t, e, " ");
                }), e.textContent !== t && (p(n.removed, {
                  element: e.cloneNode()
                }), e.textContent = t)), Dt("afterSanitizeElements", e, null), !1) : (gt(e), !0);
              },
              St = function (e, t, n) {
                if (je && ("id" === t || "name" === t) && (n in r || n in st)) return !1;
                if (_e && !Se[t] && w(pe, t)) ;else if (Ee && w(he, t)) ;else if (!we[t] || Se[t]) {
                  if (!(Et(e) && (De.tagNameCheck instanceof RegExp && w(De.tagNameCheck, e) || De.tagNameCheck instanceof Function && De.tagNameCheck(e)) && (De.attributeNameCheck instanceof RegExp && w(De.attributeNameCheck, t) || De.attributeNameCheck instanceof Function && De.attributeNameCheck(t)) || "is" === t && De.allowCustomizedBuiltInElements && (De.tagNameCheck instanceof RegExp && w(De.tagNameCheck, n) || De.tagNameCheck instanceof Function && De.tagNameCheck(n)))) return !1;
                } else if ($e[t]) ;else if (w(ve, g(n, me, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(n, "data:") || !Ue[e]) if (Pe && !w(fe, g(n, me, ""))) ;else if (n) return !1;
                return !0;
              },
              Et = function (e) {
                return "annotation-xml" !== e && m(e, ge);
              },
              _t = function (e) {
                Dt("beforeSanitizeAttributes", e, null);
                const {
                  attributes: t
                } = e;
                if (!t) return;
                const r = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: we
                };
                let o = t.length;
                for (; o--;) {
                  const i = t[o],
                    {
                      name: a,
                      namespaceURI: s,
                      value: l
                    } = i,
                    u = it(a);
                  let p = "value" === a ? l : y(l);
                  if (r.attrName = u, r.attrValue = p, r.keepAttr = !0, r.forceKeepAttr = void 0, Dt("uponSanitizeAttribute", e, r), p = r.attrValue, r.forceKeepAttr) continue;
                  if (vt(a, e), !r.keepAttr) continue;
                  if (!ke && w(/\/>/i, p)) {
                    vt(a, e);
                    continue;
                  }
                  if (ze && w(/((--!?|])>)|<\/(style|title)/i, p)) {
                    vt(a, e);
                    continue;
                  }
                  Ae && c([ue, ce, de], e => {
                    p = g(p, e, " ");
                  });
                  const h = it(e.nodeName);
                  if (St(h, u, p)) {
                    if (!Be || "id" !== u && "name" !== u || (vt(a, e), p = Ne + p), te && "object" == typeof K && "function" == typeof K.getAttributeType) if (s) ;else switch (K.getAttributeType(h, u)) {
                      case "TrustedHTML":
                        p = te.createHTML(p);
                        break;
                      case "TrustedScriptURL":
                        p = te.createScriptURL(p);
                    }
                    try {
                      s ? e.setAttributeNS(s, a, p) : e.setAttribute(a, p), wt(e) ? gt(e) : d(n.removed);
                    } catch (e) {}
                  }
                }
                Dt("afterSanitizeAttributes", e, null);
              },
              Pt = function e(t) {
                let n = null;
                const r = bt(t);
                for (Dt("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) Dt("uponSanitizeShadowNode", n, null), Ct(n) || (n.content instanceof l && e(n.content), _t(n));
                Dt("afterSanitizeShadowDOM", t, null);
              };
            return n.sanitize = function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = null,
                i = null,
                a = null,
                s = null;
              if (Je = !e, Je && (e = "\x3c!--\x3e"), "string" != typeof e && !xt(e)) {
                if ("function" != typeof e.toString) throw x("toString is not a function");
                if ("string" != typeof (e = e.toString())) throw x("dirty is not a string, aborting");
              }
              if (!n.isSupported) return e;
              if (Oe || ut(t), n.removed = [], "string" == typeof e && (Ve = !1), Ve) {
                if (e.nodeName) {
                  const t = it(e.nodeName);
                  if (!ye[t] || Ce[t]) throw x("root node is forbidden and cannot be sanitized in-place");
                }
              } else if (e instanceof D) r = yt("\x3c!----\x3e"), i = r.ownerDocument.importNode(e, !0), i.nodeType === Y.element && "BODY" === i.nodeName || "HTML" === i.nodeName ? r = i : r.appendChild(i);else {
                if (!Fe && !Ae && !Te && -1 === e.indexOf("<")) return te && Re ? te.createHTML(e) : e;
                if (r = yt(e), !r) return Fe ? null : Re ? ne : "";
              }
              r && Ie && gt(r.firstChild);
              const u = bt(Ve ? e : r);
              for (; a = u.nextNode();) Ct(a) || (a.content instanceof l && Pt(a.content), _t(a));
              if (Ve) return e;
              if (Fe) {
                if (Me) for (s = ie.call(r.ownerDocument); r.firstChild;) s.appendChild(r.firstChild);else s = r;
                return (we.shadowroot || we.shadowrootmode) && (s = se.call(o, s, !0)), s;
              }
              let d = Te ? r.outerHTML : r.innerHTML;
              return Te && ye["!doctype"] && r.ownerDocument && r.ownerDocument.doctype && r.ownerDocument.doctype.name && w($, r.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + r.ownerDocument.doctype.name + ">\n" + d), Ae && c([ue, ce, de], e => {
                d = g(d, e, " ");
              }), te && Re ? te.createHTML(d) : d;
            }, n.setConfig = function () {
              ut(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Oe = !0;
            }, n.clearConfig = function () {
              at = null, Oe = !1;
            }, n.isValidAttribute = function (e, t, n) {
              at || ut({});
              const r = it(e),
                o = it(t);
              return St(r, o, n);
            }, n.addHook = function (e, t) {
              "function" == typeof t && (le[e] = le[e] || [], p(le[e], t));
            }, n.removeHook = function (e) {
              if (le[e]) return d(le[e]);
            }, n.removeHooks = function (e) {
              le[e] && (le[e] = []);
            }, n.removeAllHooks = function () {
              le = {};
            }, n;
          }
          return J();
        }();
      },
      31108: (e, t, n) => {
        "use strict";

        var r = n(85893),
          o = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8.03 9.53a.75.75 0 0 0 0-1.06L5.56 6l2.47-2.47a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          i = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3.97 2.47a.75.75 0 0 0 0 1.06L6.44 6 3.97 8.47a.75.75 0 0 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          a = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.47 8.03a.75.75 0 0 0 1.06 0L6 5.56l2.47 2.47a.75.75 0 0 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06",
              clipRule: "evenodd"
            })]
          }),
          s = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#checkmark-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M11.03 2.845a.75.75 0 0 1 0 1.06l-6.53 6.53-3.53-3.53a.75.75 0 0 1 1.06-1.06l2.47 2.47 5.47-5.47a.75.75 0 0 1 1.06 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "checkmark-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h12v12H0z"
                })
              })
            })]
          }),
          l = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6 10.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12",
              clipRule: "evenodd"
            })]
          }),
          u = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.75 3.5a1.25 1.25 0 1 1 2.5 0v.75h-2.5zm-1.5.75V3.5a2.75 2.75 0 0 1 5.5 0v.75H9c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0 1 9 10.75H3A1.75 1.75 0 0 1 1.25 9V6c0-.966.784-1.75 1.75-1.75z",
              clipRule: "evenodd"
            })]
          }),
          c = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.75 3.5a1.25 1.25 0 1 1 2.5 0v.75h-2.5zm-1.5.75V3.5a2.75 2.75 0 0 1 5.5 0v.75H9c.966 0 1.75.784 1.75 1.75v3A1.75 1.75 0 0 1 9 10.75H3A1.75 1.75 0 0 1 1.25 9V6c0-.966.784-1.75 1.75-1.75zM8 5.75H3a.25.25 0 0 0-.25.25v3c0 .138.112.25.25.25h6A.25.25 0 0 0 9.25 9V6A.25.25 0 0 0 9 5.75z",
              clipRule: "evenodd"
            })]
          }),
          d = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M11.75 6a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h10a.75.75 0 0 1 .75.75",
              clipRule: "evenodd"
            })]
          }),
          p = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.5 6A1.25 1.25 0 1 1 0 6a1.25 1.25 0 0 1 2.5 0m4.75 0a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m3.5 1.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
              clipRule: "evenodd"
            })]
          }),
          h = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.75 4.5a2.75 2.75 0 0 1 5.396-.75H5c-.69 0-1.25.56-1.25 1.25v2.146a2.75 2.75 0 0 1-2-2.646m2 4.184A4.251 4.251 0 1 1 8.684 3.75H10.5c.69 0 1.25.56 1.25 1.25v5.5c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25zm1.5 1.566v-5h5v5z",
              clipRule: "evenodd"
            })]
          }),
          f = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 .25a.75.75 0 0 1 .75.75v4.25H11a.75.75 0 0 1 0 1.5H6.75V11a.75.75 0 0 1-1.5 0V6.75H1a.75.75 0 0 1 0-1.5h4.25V1A.75.75 0 0 1 6 .25",
              clipRule: "evenodd"
            })]
          }),
          m = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 12 12",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.243 1.757a.75.75 0 0 1 0 1.061L7.061 6l3.182 3.182a.75.75 0 0 1-1.06 1.06L6 7.062l-3.182 3.182a.75.75 0 1 1-1.06-1.061L4.94 6 1.758 2.818a.75.75 0 1 1 1.06-1.06L6 4.938l3.182-3.182a.75.75 0 0 1 1.061 0",
              clipRule: "evenodd"
            })]
          });
        t.BN = o, t.QU = i, t.KM = s, t.V_ = d, t.b0 = m;
      },
      83034: (e, t, n) => {
        "use strict";

        var r = n(85893),
          o = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#anonymous-icon_svg__a)",
              children: [r.jsx("path", {
                fillRule: "evenodd",
                d: "M9.122.622a2.35 2.35 0 0 1 3.57.954l1.403 3.274H15.2a.75.75 0 0 1 0 1.5H.8a.75.75 0 0 1 0-1.5h1.106l1.403-3.274a2.35 2.35 0 0 1 3.57-.954l.611.458a.85.85 0 0 0 1.02 0zm2.19 1.545 1.15 2.683H3.539l1.15-2.683a.85.85 0 0 1 1.291-.345l.611.458a2.35 2.35 0 0 0 2.82 0l.612-.458a.85.85 0 0 1 1.29.345ZM2.45 6.85h11.1V8a2.75 2.75 0 0 1-5.478.35h-.144A2.75 2.75 0 0 1 2.45 8zM4 8.35a1.25 1.25 0 0 0 2.4 0zm5.6 0a1.25 1.25 0 0 0 2.4 0z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M1.6 11.25a.75.75 0 0 0-.624 1.166l1.128 1.693-.84.42a.75.75 0 1 0 .671 1.342l1.6-.8a.75.75 0 0 0 .289-1.087L3 12.75h4.25v2.45a.75.75 0 0 0 1.5 0v-2.45h4.248l-.822 1.234a.75.75 0 0 0 .288 1.087l1.6.8a.75.75 0 1 0 .671-1.342l-.84-.42 1.129-1.693a.75.75 0 0 0-.624-1.166z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "anonymous-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          i = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#arrow-down-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.75-11.6a.75.75 0 0 0-1.5 0v5.39L5.73 8.27a.75.75 0 1 0-1.06 1.06L8 12.66l3.33-3.33a.75.75 0 0 0-1.06-1.06L8.75 9.79z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "arrow-down-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          a = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7.136 2.47a.75.75 0 0 0 0 1.06l3.72 3.72h-8.19a.75.75 0 1 0 0 1.5h8.19l-3.72 3.72a.75.75 0 1 0 1.06 1.06L13.726 8l-5.53-5.53a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          s = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#attachments-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M12.285 2.697a1.75 1.75 0 0 0-2.475 0l-5.48 5.48a3 3 0 0 0 4.243 4.242L12.993 8a.75.75 0 0 1 1.06 1.062l-4.42 4.419A4.5 4.5 0 1 1 3.27 7.116l5.48-5.48a3.25 3.25 0 1 1 4.596 4.596l-5.48 5.48a2 2 0 0 1-2.829-2.828l4.42-4.42a.75.75 0 1 1 1.06 1.061l-4.419 4.42a.5.5 0 0 0 .707.707l5.48-5.48a1.75 1.75 0 0 0 0-2.475",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "attachments-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          l = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 8a2 2 0 1 0 .001-3.999A2 2 0 0 0 8 8m0 1c-1.335 0-4 .67-4 2v1h8v-1c0-1.33-2.665-2-4-2",
              clipRule: "evenodd"
            })]
          }),
          u = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3 12.992C3 13.548 3.451 14 4.008 14H8.64c2.657 0 4.286-1.269 4.286-3.377 0-1.44-.823-2.537-2.297-2.863 1.234-.463 1.834-1.354 1.834-2.657C12.463 3.234 11.074 2 8.777 2H4.008C3.451 2 3 2.451 3 3.008zM5.88 6.68V4.4h2.246c.908 0 1.405.446 1.405 1.114 0 .737-.548 1.166-1.354 1.166zm0 4.92V9.08h2.537c1.029 0 1.594.48 1.594 1.251 0 .823-.634 1.269-1.542 1.269z"
            })]
          }),
          c = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 .583c-1.15 0-2.083.933-2.083 2.084v12a.75.75 0 0 0 1.296.514L8 12.226l2.788 2.955a.75.75 0 0 0 1.296-.514v-12c0-1.15-.933-2.084-2.084-2.084z",
              clipRule: "evenodd"
            })]
          }),
          d = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 2.083a.583.583 0 0 0-.583.584v10.112l2.038-2.16a.75.75 0 0 1 1.09 0l2.039 2.16V2.667A.583.583 0 0 0 10 2.083zm-2.083.584C3.917 1.517 4.85.583 6 .583h4c1.15 0 2.084.933 2.084 2.084v12a.75.75 0 0 1-1.296.514L8 12.226l-2.787 2.955a.75.75 0 0 1-1.296-.514z",
              clipRule: "evenodd"
            })]
          }),
          p = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.53 12.53a.75.75 0 0 0 0-1.06L7.06 8l3.47-3.47a.75.75 0 1 0-1.06-1.06l-4 4a.75.75 0 0 0 0 1.06l4 4a.75.75 0 0 0 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          h = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M5.47 3.47a.75.75 0 0 0 0 1.06L8.94 8l-3.47 3.47a.75.75 0 1 0 1.06 1.06l4-4a.75.75 0 0 0 0-1.06l-4-4a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          f = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m3.33-8.32a.75.75 0 0 0-1.06-1.06L7.2 8.69 6.13 7.62a.75.75 0 1 0-1.06 1.06l2.13 2.13z",
              clipRule: "evenodd"
            })]
          }),
          m = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m3.33-8.32a.75.75 0 0 0-1.06-1.06L7.2 8.69 6.13 7.62a.75.75 0 1 0-1.06 1.06l2.13 2.13z",
              clipRule: "evenodd"
            })]
          }),
          g = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M14.53 3.97a.75.75 0 0 1 0 1.06L6 13.56 1.47 9.03a.75.75 0 0 1 1.06-1.06L6 11.44l7.47-7.47a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          v = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("circle", {
              cx: 8,
              cy: 8,
              r: 4
            })]
          }),
          y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.93-4.07a.75.75 0 0 1-1.06 0L8 9.06l-1.87 1.87a.75.75 0 1 1-1.06-1.06L6.938 8l-1.87-1.87a.75.75 0 0 1 1.06-1.06L8 6.94l1.87-1.87a.75.75 0 1 1 1.061 1.06L9.06 8l1.87 1.87a.75.75 0 0 1 0 1.06",
              clipRule: "evenodd"
            })]
          }),
          b = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M13.48 2.52a.75.75 0 0 1 0 1.06L9.062 8l4.42 4.42a.75.75 0 1 1-1.061 1.06L8 9.06l-4.419 4.42a.75.75 0 0 1-1.06-1.06L6.94 8 2.52 3.58a.75.75 0 0 1 1.061-1.06l4.42 4.42 4.419-4.42a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          w = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#copy-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M2.4.291A2.11 2.11 0 0 0 .29 2.4v7.7c0 1.165.944 2.109 2.109 2.109H3.79V13.6c0 1.165.944 2.109 2.109 2.109h7.7a2.11 2.11 0 0 0 2.109-2.109V5.9A2.11 2.11 0 0 0 13.6 3.791h-1.391V2.4A2.11 2.11 0 0 0 10.1.29zm8.391 3.5V2.4a.69.69 0 0 0-.691-.691H2.4a.69.69 0 0 0-.691.69V10.1c0 .382.309.691.69.691h1.392v-4.89c0-1.166.944-2.11 2.109-2.11zm-5.582 7.72V5.9c0-.382.309-.691.69-.691H13.6c.382 0 .691.31.691.691v7.7c0 .382-.31.691-.691.691H5.9a.69.69 0 0 1-.691-.69z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "copy-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          x = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#edit-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10.409 1.53a2.25 2.25 0 0 1 3.182 0l.879.879a2.25 2.25 0 0 1 0 3.182l-9.72 9.72a1.5 1.5 0 0 1-1.06.439H.25v-3.44c0-.397.158-.779.44-1.06zm2.121 1.061a.75.75 0 0 0-1.06 0L10.06 4 12 5.94l1.409-1.41a.75.75 0 0 0 0-1.06zM10.94 7 9 5.06l-7.25 7.25v1.94h1.94z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "edit-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          D = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14",
              clipRule: "evenodd"
            })]
          }),
          C = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#emoji-smile-icon_svg__a)",
              children: [r.jsx("path", {
                fillRule: "evenodd",
                d: "M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16",
                clipRule: "evenodd"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M4.522 8.904a.75.75 0 0 1 .974.418c.34.848 1.298 1.528 2.504 1.528s2.164-.68 2.504-1.528a.75.75 0 1 1 1.392.556C11.304 11.36 9.75 12.35 8 12.35s-3.304-.99-3.896-2.472a.75.75 0 0 1 .418-.974",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M6.8 6a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0m4.8 0a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "emoji-smile-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          S = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.93-8.87a.75.75 0 0 0-1.06-1.06l-4.8 4.8a.75.75 0 1 0 1.06 1.06z",
              clipRule: "evenodd"
            })]
          }),
          E = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m2.93-8.87a.75.75 0 0 0-1.06-1.06l-4.8 4.8a.75.75 0 1 0 1.06 1.06z",
              clipRule: "evenodd"
            })]
          }),
          _ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M8 4.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 8 4.25m0 7.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          P = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 13.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M8 4.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 8 4.25m0 7.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          k = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0M8 4.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V5A.75.75 0 0 1 8 4.25m0 7.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          A = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.47.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L8 2.06 4.53 5.53a.75.75 0 0 1-1.06-1.06zm-4 10a.75.75 0 0 1 1.06 0L8 13.94l3.47-3.47a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M.584 10c0 1.15.933 2.083 2.083 2.083h8a.75.75 0 0 0 .492-.184l3.833-3.333a.75.75 0 0 0 0-1.132L11.16 4.101a.75.75 0 0 0-.492-.184h-8A2.083 2.083 0 0 0 .584 6z"
            })]
          }),
          T = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M15.61 8.44c.24-.33.17-.8-.16-1.05a.75.75 0 0 0-1.05.16c-.03.04-2.75 3.69-6.39 3.69s-6.38-3.65-6.4-3.68A.75.75 0 0 0 .56 7.4.75.75 0 0 0 .4 8.45c.06.09.83 1.12 2.12 2.16l-1.35 1.93a.74.74 0 0 0 .18 1.04c.13.09.28.14.43.14.24 0 .47-.11.61-.32l1.35-1.92c1 .61 2.18 1.1 3.51 1.24v2.29c0 .41.34.75.75.75s.75-.34.75-.75v-2.29c1.33-.14 2.51-.64 3.51-1.24l1.35 1.92c.15.21.38.32.62.32.15 0 .3-.04.43-.14.34-.24.42-.71.18-1.04l-1.35-1.93c1.29-1.03 2.06-2.07 2.12-2.16z"
            })]
          }),
          O = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.762 2.177a1.75 1.75 0 0 1 2.475 0l1.586 1.586a1.75 1.75 0 0 1 0 2.474l-7.586 7.586a1.75 1.75 0 0 1-2.214.215l-.712.712H.189l2.773-2.773a1.75 1.75 0 0 1 .215-2.214zM5.83 12.769l-1.6-1.599a.25.25 0 0 1 .007-.347L7.5 7.561 9.44 9.5l-3.263 3.262a.25.25 0 0 1-.347.007",
              clipRule: "evenodd"
            })]
          }),
          I = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M2 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm2 2.75a.75.75 0 0 0 0 1.5h3.25v6.883a.75.75 0 0 0 1.5 0V5.25H12a.75.75 0 0 0 0-1.5H4",
              clipRule: "evenodd"
            })]
          }),
          F = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "m.04 8 2.53-2.53a.75.75 0 0 1 1.06 1.06l-.72.72H5a.75.75 0 0 1 0 1.5H2.91l.72.72a.75.75 0 1 1-1.06 1.06zm15.92 0-2.53 2.53a.75.75 0 0 1-1.06-1.06l.72-.72H11a.75.75 0 0 1 0-1.5h2.09l-.72-.72a.75.75 0 0 1 1.06-1.06zM7 8a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
            })]
          }),
          M = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2.75 3A.75.75 0 0 1 7 6.75h1.75v4H9a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1 0-1.5h.25v-2.5H7a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          R = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#info-filled-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-8.75-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.5 8.25a.75.75 0 0 0 0 1.5h.75v4.5H8.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "info-filled-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          j = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.05 3.5a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H9.398l-1.659 7.3H8.8a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1 0-1.5h1.402l1.66-7.3H6.8a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          B = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.1 3.545a1.25 1.25 0 0 0-1.767 0L7.504 6.373a1.25 1.25 0 0 0 0 1.768l.283.283a.75.75 0 0 1-1.06 1.06l-.283-.283a2.75 2.75 0 0 1 0-3.889l2.828-2.828a2.75 2.75 0 0 1 3.89 0l.565.566a2.75 2.75 0 0 1 0 3.889l-1.556 1.555a.75.75 0 0 1-1.06-1.06l1.555-1.556a1.25 1.25 0 0 0 0-1.768zM8.425 6.726a.75.75 0 0 1 1.06 0l.283.283a2.75 2.75 0 0 1 0 3.89L6.94 13.726a2.75 2.75 0 0 1-3.89 0l-.565-.566a2.75 2.75 0 0 1 0-3.889L3.947 7.81a.75.75 0 0 1 1.06 1.06l-1.461 1.462a1.25 1.25 0 0 0 0 1.768l.566.565a1.25 1.25 0 0 0 1.767 0l2.829-2.828a1.25 1.25 0 0 0 0-1.768l-.283-.283a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          N = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 4.333a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3.75-1.75a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zm0 4.667a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5zM6 12.667a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75M4 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-1 5.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          L = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8 8.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2A.75.75 0 0 1 8 8.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.75 5.75V4a3.25 3.25 0 1 1 6.5 0v1.75H12c.966 0 1.75.784 1.75 1.75v6A1.75 1.75 0 0 1 12 15.25H4a1.75 1.75 0 0 1-1.75-1.75v-6c0-.966.784-1.75 1.75-1.75zM6.25 4a1.75 1.75 0 1 1 3.5 0v1.75h-3.5zM12 7.25a.25.25 0 0 1 .25.25v6a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25v-6A.25.25 0 0 1 4 7.25z",
              clipRule: "evenodd"
            })]
          }),
          V = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#magic-icon_svg__a)",
              children: r.jsx("path", {
                d: "M8.627.853c-.104-.725-1.15-.725-1.254 0l-.149 1.038-1.038.149c-.725.103-.725 1.15 0 1.254l1.038.148.149 1.038c.103.725 1.15.725 1.254 0l.148-1.038 1.038-.148c.725-.104.725-1.15 0-1.254l-1.038-.15zM4.109 8.558 3.961 7.52c-.104-.725-1.15-.725-1.254 0l-.149 1.038-1.038.148c-.725.104-.725 1.15 0 1.254l1.038.149.149 1.038c.103.725 1.15.725 1.254 0l.148-1.038 1.038-.149c.725-.103.725-1.15 0-1.254L4.11 8.558Zm9.333 3.333-.148-1.038c-.104-.725-1.15-.725-1.254 0l-.148 1.038-1.039.149c-.725.103-.725 1.15 0 1.254l1.039.148.148 1.038c.103.725 1.15.725 1.254 0l.148-1.038 1.038-.148c.725-.104.725-1.15 0-1.254zM15 6.333a1 1 0 1 1-2 0 1 1 0 0 1 2 0M9.333 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-6-5.667a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 11.667a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "magic-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          K = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M14.75 8a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h12a.75.75 0 0 1 .75.75",
              clipRule: "evenodd"
            })]
          }),
          q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#monkey-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M8 .05a7.95 7.95 0 0 0 0 15.9h4a.75.75 0 1 0 0-1.5H8a6.45 6.45 0 1 1 0-12.9h1.092a5.36 5.36 0 0 1 5.358 5.358V9.4a1.45 1.45 0 1 1-2.9 0V4a.75.75 0 0 0-1.5 0v.4a3.75 3.75 0 0 0-6 3v1.2a3.75 3.75 0 0 0 6.541 2.504A2.95 2.95 0 0 0 15.95 9.4V6.908A6.86 6.86 0 0 0 9.093.05zm2.05 8.552V7.398a2.25 2.25 0 0 0-4.5.002v1.2a2.25 2.25 0 0 0 4.5.002",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "monkey-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          H = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M13 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
              clipRule: "evenodd"
            })]
          }),
          U = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5-5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
              clipRule: "evenodd"
            })]
          }),
          Z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 14 14",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("mask", {
              id: "none-icon_svg__a",
              width: 14,
              height: 14,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: r.jsx("circle", {
                cx: 7,
                cy: 7,
                r: 7,
                fill: "#2B2E36"
              })
            }), r.jsx("g", {
              mask: "url(#none-icon_svg__a)",
              children: r.jsx("path", {
                stroke: "#C83C29",
                strokeWidth: 2,
                d: "M15-1-1 15"
              })
            })]
          }),
          $ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.667 3C15.403 3 16 3.597 16 4.333v7.334c0 .736-.597 1.333-1.333 1.333H1.333A1.333 1.333 0 0 1 0 11.667V4.333C0 3.597.597 3 1.333 3zm-.917 1h.917c.184 0 .333.15.333.333v7.334c0 .184-.15.333-.333.333h-.917zm-10 0h8.5v8h-8.5zm-1.5 0h-.917A.333.333 0 0 0 1 4.333v7.334c0 .184.15.333.333.333h.917z",
              clipRule: "evenodd"
            })]
          }),
          G = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.667 3C15.403 3 16 3.597 16 4.333v7.334c0 .736-.597 1.333-1.333 1.333H1.333A1.333 1.333 0 0 1 0 11.667V4.333C0 3.597.597 3 1.333 3zM11.5 4h3.167c.184 0 .333.15.333.333v7.334c0 .184-.15.333-.333.333H11.5zm-7 8H1.333A.333.333 0 0 1 1 11.667V4.333C1 4.15 1.15 4 1.333 4H4.5zM6 4.5h4v7H6z",
              clipRule: "evenodd"
            })]
          }),
          W = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M0 3.75h1.25v8.5H0v1.5h1.333c.783 0 1.417-.634 1.417-1.417V3.667c0-.783-.634-1.417-1.417-1.417H0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 3.667c0-.783.634-1.417 1.417-1.417h4.666c.783 0 1.417.634 1.417 1.417v8.666c0 .783-.634 1.417-1.417 1.417H5.667a1.417 1.417 0 0 1-1.417-1.417zm1.5.083v8.5h4.5v-8.5z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M14.75 3.75H16v-1.5h-1.333c-.783 0-1.417.634-1.417 1.417v8.666c0 .783.634 1.417 1.417 1.417H16v-1.5h-1.25z"
            })]
          }),
          Y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.667 13.75A1.417 1.417 0 0 1 .25 12.333V3.667c0-.783.634-1.417 1.417-1.417h12.666c.783 0 1.417.634 1.417 1.417v8.666c0 .783-.634 1.417-1.417 1.417zm.083-1.5v-8.5h5.5v8.5zm7-8.5v8.5h5.5v-8.5z",
              clipRule: "evenodd"
            })]
          }),
          X = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.75 1.75v12.5h8.5V1.75zm-1.5-.083C2.25.884 2.884.25 3.667.25h8.666c.783 0 1.417.634 1.417 1.417v12.666c0 .783-.634 1.417-1.417 1.417H3.667a1.417 1.417 0 0 1-1.417-1.417z",
              clipRule: "evenodd"
            })]
          }),
          Q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3.75 0v2.25h8.5V0h1.5v2.333c0 .783-.634 1.417-1.417 1.417H3.667A1.417 1.417 0 0 1 2.25 2.333V0zm0 16V6.75h8.5V16h1.5V6.667c0-.783-.634-1.417-1.417-1.417H3.667c-.783 0-1.417.634-1.417 1.417V16z"
            })]
          }),
          J = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.04 6a3.96 3.96 0 0 1 7.859-.706H6.666c-.758 0-1.372.615-1.372 1.373v3.23A3.96 3.96 0 0 1 2.04 6m3.254 5.326a5.374 5.374 0 1 1 6.033-6.032H14c.758 0 1.372.615 1.372 1.373V14c0 .758-.614 1.373-1.372 1.373H6.667A1.373 1.373 0 0 1 5.293 14zm1.412 2.635V6.706h7.255v7.255z",
              clipRule: "evenodd"
            })]
          }),
          ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#plus-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8 .25a.75.75 0 0 1 .75.75v6.25H15a.75.75 0 0 1 0 1.5H8.75V15a.75.75 0 0 1-1.5 0V8.75H1a.75.75 0 0 1 0-1.5h6.25V1A.75.75 0 0 1 8 .25",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "plus-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          te = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              d: "M9 11c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1M7 6.18c0-.49.42-.93 1-.93s1 .44 1 .93c0 .37-.23.7-.6.85-.48.19-1.15.69-1.15 1.53v.14c0 .41.34.75.75.75s.75-.34.75-.75v-.13s0-.01.02-.02a.7.7 0 0 1 .2-.13c.89-.36 1.53-1.22 1.53-2.24 0-1.37-1.15-2.43-2.5-2.43S5.5 4.81 5.5 6.18c0 .41.34.75.75.75S7 6.59 7 6.18M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7m0 12.5c-3.04 0-5.5-2.46-5.5-5.5S4.96 2.5 8 2.5s5.5 2.46 5.5 5.5-2.46 5.5-5.5 5.5"
            })]
          }),
          ne = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.262 1.677a1.75 1.75 0 0 1 2.475 0l1.586 1.585a1.75 1.75 0 0 1 0 2.475L11.53 8.53l-1.06-1.06.969-.97-1.94-1.94-.969.97-1.06-1.06zM10.56 3.5l.763-.763a.25.25 0 0 1 .354 0l1.585 1.586a.25.25 0 0 1 0 .354l-.763.762zM1.97 1.971a.75.75 0 0 1 1.06 0l11 11a.75.75 0 1 1-1.06 1.06l-3.47-3.469-4.69 4.69H.75V11.19L5.438 6.5l-3.47-3.468a.75.75 0 0 1 0-1.06m4.53 5.59-4.25 4.25v1.94h1.94l4.25-4.25z",
              clipRule: "evenodd"
            })]
          }),
          re = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.136 2.136a.75.75 0 0 0 0 1.061l1.386 1.386H6.666a4.75 4.75 0 0 0 0 9.5H8a.75.75 0 0 0 0-1.5H6.666a3.25 3.25 0 0 1 0-6.5h4.856L10.136 7.47a.75.75 0 1 0 1.06 1.06l3.198-3.197-3.197-3.197a.75.75 0 0 0-1.061 0",
              clipRule: "evenodd"
            })]
          }),
          oe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "m9.526 3.75-1.09 2.997-1.14-1.255.633-1.742H5.713L4.35 2.25H14a.75.75 0 0 1 0 1.5zm-5.231 9.994 1.271-3.495 1.14 1.255-1.001 2.752a.75.75 0 1 1-1.41-.512M2.605 2.546a.75.75 0 1 0-1.11 1.009l9.949 10.95a.75.75 0 0 0 1.11-1.01l-9.95-10.95Z"
            })]
          }),
          ie = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.417 3a.75.75 0 0 1-.75.75H2.334a.75.75 0 0 1 0-1.5h11.333a.75.75 0 0 1 .75.75m0 10a.75.75 0 0 1-.75.75H2.334a.75.75 0 0 1 0-1.5h11.333a.75.75 0 0 1 .75.75m-.75-4.25a.75.75 0 0 0 0-1.5H2.334a.75.75 0 0 0 0 1.5z",
              clipRule: "evenodd"
            })]
          }),
          ae = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.172 1.898A.75.75 0 1 1 8.16.768l2.667 2.334a.75.75 0 0 1 0 1.129L8.16 6.564a.75.75 0 0 1-.988-1.128l1.32-1.155a3.917 3.917 0 1 0 3.424 3.886.75.75 0 0 1 1.5 0A5.417 5.417 0 1 1 8.15 2.752l-.977-.854Z"
            })]
          }),
          se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.828 1.898A.75.75 0 1 0 7.84.768L5.173 3.103a.75.75 0 0 0 0 1.129L7.84 6.564a.75.75 0 0 0 .988-1.128L7.508 4.28a3.917 3.917 0 1 1-3.424 3.886.75.75 0 1 0-1.5 0 5.417 5.417 0 1 0 5.268-5.415z"
            })]
          }),
          le = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              fillRule: "evenodd",
              clipPath: "url(#settings-icon_svg__a)",
              clipRule: "evenodd",
              children: [r.jsx("path", {
                d: "M5.096 8A2.91 2.91 0 0 1 8 5.097 2.91 2.91 0 0 1 10.903 8 2.91 2.91 0 0 1 8 10.903 2.91 2.91 0 0 1 5.096 8m1.452 0A1.45 1.45 0 0 0 8 9.452 1.45 1.45 0 0 0 9.45 8 1.45 1.45 0 0 0 8 6.548 1.45 1.45 0 0 0 6.548 8"
              }), r.jsx("path", {
                d: "m13.061 5.9 1.335.271A1.37 1.37 0 0 1 15.5 7.516v.978a1.37 1.37 0 0 1-1.104 1.345l-1.335.27.755 1.133c.358.542.29 1.268-.174 1.732l-.687.687a1.38 1.38 0 0 1-1.733.175l-1.132-.755-.27 1.335a1.37 1.37 0 0 1-1.346 1.103h-.977a1.37 1.37 0 0 1-1.346-1.103l-.27-1.335-1.133.755a1.38 1.38 0 0 1-1.732-.175l-.687-.687a1.38 1.38 0 0 1-.174-1.732l.754-1.132-1.335-.271A1.37 1.37 0 0 1 .47 8.494v-.978c0-.658.464-1.22 1.103-1.345L2.909 5.9l-.754-1.132a1.38 1.38 0 0 1 .174-1.732l.687-.688a1.38 1.38 0 0 1 1.732-.174l1.132.755.271-1.335A1.37 1.37 0 0 1 7.497.49h.977c.658 0 1.22.465 1.345 1.104l.271 1.335 1.132-.755a1.38 1.38 0 0 1 1.733.174l.687.688c.464.464.532 1.19.174 1.732zm-3.532 5.816a1.39 1.39 0 0 1 1.326.116l1.122.745.6-.6-.745-1.122a1.44 1.44 0 0 1-.116-1.326 1.41 1.41 0 0 1 1.016-.852l1.316-.26v-.843l-1.316-.261a1.39 1.39 0 0 1-1.016-.852 1.39 1.39 0 0 1 .116-1.325l.745-1.123-.6-.6-1.122.745c-.417.28-.92.28-1.326.116a1.41 1.41 0 0 1-.852-1.016l-.261-1.316h-.842l-.261 1.316a1.39 1.39 0 0 1-.852 1.016 1.39 1.39 0 0 1-1.326-.116l-1.122-.745-.6.6.745 1.123c.28.416.28.919.116 1.325a1.41 1.41 0 0 1-1.016.852l-1.316.261v.842l1.316.261c.493.097.851.446 1.016.852.174.407.164.91-.116 1.326l-.745 1.122.6.6 1.122-.745c.416-.27.92-.28 1.326-.116.397.165.755.523.852 1.016l.26 1.316h.843l.261-1.316a1.39 1.39 0 0 1 .852-1.016"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "settings-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          ue = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.039 8.167 2.913 8A11 11 0 0 1 4.2 6.546C5.211 5.596 6.534 4.75 8 4.75s2.788.845 3.798 1.796A11 11 0 0 1 13.087 8q-.058.078-.127.167c-.271.352-.667.82-1.162 1.287-1.01.95-2.332 1.796-3.798 1.796s-2.788-.845-3.799-1.796c-.495-.466-.89-.935-1.162-1.287M13.999 8c.637-.397.636-.398.636-.398zm.636-.398.25.398-.25.398L14 8l.635.398V8.4l-.003.004-.008.011-.026.04a11 11 0 0 1-.45.627c-.306.399-.755.93-1.322 1.464-1.114 1.05-2.792 2.204-4.826 2.204s-3.712-1.155-4.827-2.204a12.6 12.6 0 0 1-1.677-1.95l-.095-.14-.026-.04-.008-.012-.002-.004-.001-.002L1.999 8l-.635.398L1.115 8l.249-.397.635.397c-.636-.397-.635-.398-.635-.398l.001-.002.002-.004.008-.011.026-.04a11 11 0 0 1 .45-.627c.307-.399.755-.93 1.322-1.464C4.288 4.404 5.966 3.25 8 3.25s3.712 1.155 4.826 2.204a12.6 12.6 0 0 1 1.677 1.95l.095.14.026.04.008.012.002.004zM8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
              clipRule: "evenodd"
            })]
          }),
          ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M2.25 3A.75.75 0 0 1 3 2.25h10a.75.75 0 0 1 0 1.5H8.75v2h-1.5v-2H3A.75.75 0 0 1 2.25 3m5 11v-3.75h1.5V14a.75.75 0 0 1-1.5 0M1 7.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
            })]
          }),
          de = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 2.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm2 3.333a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zM1.25 9.667a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M4 12.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 2.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm0 3.333a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm-.75 4.084a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M2 12.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          he = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 2.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm0 3.333a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zm-.75 4.084a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M2 12.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          fe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 2.25a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm4 3.333a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5zM1.25 9.667a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M6 12.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          me = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M2.25 3A.75.75 0 0 1 3 2.25h10a.75.75 0 0 1 0 1.5H8.75V14a.75.75 0 0 1-1.5 0V3.75H3A.75.75 0 0 1 2.25 3",
              clipRule: "evenodd"
            })]
          }),
          ge = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.179 10.036h-.036a3.893 3.893 0 1 1 0-7.786h6.286a.75.75 0 0 1 0 1.5h-1.792V14a.75.75 0 0 1-1.5 0V3.75H7.679V14a.75.75 0 0 1-1.5 0zM3.75 6.143A2.393 2.393 0 0 1 6.143 3.75h.036v4.786h-.036A2.393 2.393 0 0 1 3.75 6.143",
              clipRule: "evenodd"
            })]
          }),
          ve = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.5 1.9a.6.6 0 0 0-.6.6v4a.6.6 0 0 0 .6.6h4a.6.6 0 0 0 .6-.6v-4a.6.6 0 0 0-.6-.6zm.6 4V3.1h2.8v2.8zm-.6 3a.6.6 0 0 0-.6.6v4a.6.6 0 0 0 .6.6h4a.6.6 0 0 0 .6-.6v-4a.6.6 0 0 0-.6-.6zm.6 4v-2.8h2.8v2.8zm5.8-3.4a.6.6 0 0 1 .6-.6h4a.6.6 0 0 1 .6.6v4a.6.6 0 0 1-.6.6h-4a.6.6 0 0 1-.6-.6zm1.2.6v2.8h2.8v-2.8zm-.6-8.2a.6.6 0 0 0-.6.6v4a.6.6 0 0 0 .6.6h4a.6.6 0 0 0 .6-.6v-4a.6.6 0 0 0-.6-.6zm.6 4V3.1h2.8v2.8z",
              clipRule: "evenodd"
            })]
          }),
          ye = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#thumbs-down-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M6.8 9.388c.85 1.035 1.965 2.398 3.13 4.723a.285.285 0 0 0 .345.136l.004-.001a.29.29 0 0 0 .186-.341l-1.113-2.697a1.56 1.56 0 0 1 1.441-2.158h2.39q.033 0 .064.003a.33.33 0 0 0 .184-.084.41.41 0 0 0 .085-.465c-.029-.049-.09-.118-.24-.164a.75.75 0 0 1 .122-1.462c.163-.02.224-.083.253-.125a.4.4 0 0 0 .053-.268.4.4 0 0 0-.118-.246c-.039-.034-.111-.078-.272-.058a.75.75 0 0 1-.188-1.488c.158-.02.218-.081.248-.126.042-.06.07-.16.055-.277a.4.4 0 0 0-.114-.245c-.035-.03-.102-.073-.26-.051h-.001a.75.75 0 0 1-.267-1.475.4.4 0 0 0-.034-.165c-.083-.205-.408-.604-1.337-.604H9.224c-2.469 0-4.046 1.928-4.046 4.096 0 .719.123 1.236.327 1.688.211.467.523.898.96 1.442l.336.412Zm6.376 1.17a1 1 0 0 1-.104-.008h-2.279a.06.06 0 0 0-.054.087l1.129 2.734.022.061a1.79 1.79 0 0 1-1.123 2.232 1.785 1.785 0 0 1-2.175-.875l-.002-.004c-1.088-2.172-2.108-3.419-2.949-4.445l-.253-.31H3.201c-.465 0-.851-.214-1.14-.488-.285-.27-.507-.627-.678-1.01C1.042 7.764.851 6.756.851 5.68s.191-2.085.532-2.852c.17-.383.393-.74.678-1.01.289-.274.675-.488 1.14-.488h2.678C6.769.66 7.902.25 9.224.25h2.192c1.404 0 2.366.653 2.726 1.538.14.342.186.723.107 1.083l.053.045c.364.318.563.759.616 1.19.046.374-.012.78-.204 1.141.275.3.431.678.478 1.051a1.9 1.9 0 0 1-.396 1.425c.23.383.305.836.235 1.26-.134.806-.805 1.574-1.855 1.574Zm-8.655-7.73H3.203a.3.3 0 0 0-.11.077c-.098.093-.22.262-.34.53-.236.534-.402 1.326-.402 2.243 0 .918.166 1.71.403 2.244.119.267.241.437.34.53a.3.3 0 0 0 .109.076h1.124a5 5 0 0 1-.189-.377c-.3-.665-.46-1.396-.46-2.306A5.8 5.8 0 0 1 4.52 2.83Z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "thumbs-down-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          be = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#thumbs-up-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M6.8 6.625c.85-1.035 1.965-2.398 3.13-4.723a.285.285 0 0 1 .345-.136l.004.001a.29.29 0 0 1 .186.341L9.351 4.806a1.56 1.56 0 0 0 1.442 2.157h2.39l.064-.003a.33.33 0 0 1 .184.084.41.41 0 0 1 .085.465c-.029.049-.09.118-.24.164a.75.75 0 0 0 .122 1.462c.163.02.224.083.253.125.04.057.067.153.053.267a.4.4 0 0 1-.118.247c-.039.034-.111.078-.272.058a.75.75 0 0 0-.188 1.488c.158.02.218.08.248.125.042.061.07.16.055.278a.4.4 0 0 1-.114.245c-.035.03-.103.073-.261.05a.75.75 0 0 0-.267 1.476.4.4 0 0 1-.034.165c-.083.205-.408.604-1.337.604H9.224c-2.469 0-4.046-1.928-4.046-4.096 0-.719.123-1.236.327-1.688.211-.467.523-.898.96-1.443l.336-.41Zm6.376-1.17a1 1 0 0 0-.104.008h-2.279c-.04 0-.073-.04-.054-.087l1.129-2.734A1.79 1.79 0 0 0 10.767.349a1.785 1.785 0 0 0-2.175.875l-.002.004C7.502 3.4 6.482 4.647 5.64 5.673l-.253.31H3.201c-.465 0-.851.214-1.14.488-.285.27-.507.627-.678 1.01-.341.767-.532 1.776-.532 2.852 0 1.077.191 2.085.532 2.853.17.383.393.739.678 1.01.289.274.675.487 1.14.487h2.678c.89.67 2.023 1.08 3.345 1.08h2.192c1.404 0 2.366-.653 2.726-1.538a1.84 1.84 0 0 0 .107-1.083l.053-.045a1.9 1.9 0 0 0 .616-1.19 1.93 1.93 0 0 0-.204-1.141c.275-.301.431-.678.478-1.051a1.9 1.9 0 0 0-.396-1.425c.23-.383.305-.836.235-1.26-.134-.806-.805-1.575-1.855-1.575m-8.655 7.728a5.8 5.8 0 0 1-.843-3.016c0-.91.16-1.64.46-2.306q.088-.194.19-.378H3.202a.3.3 0 0 0-.11.076c-.098.093-.22.263-.34.531-.236.534-.402 1.325-.402 2.243s.166 1.71.403 2.243c.119.268.241.438.34.531a.3.3 0 0 0 .109.076H4.52Z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "thumbs-up-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          we = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#trash-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M8 1.75c-.621 0-1.125.504-1.125 1.125v.375h2.25v-.375c0-.621-.504-1.125-1.125-1.125m0-1.5a2.625 2.625 0 0 1 2.625 2.625v.375H14.5a.75.75 0 0 1 0 1.5h-.75v8.583a2.417 2.417 0 0 1-2.417 2.417H4.667a2.417 2.417 0 0 1-2.417-2.417V4.75H1.5a.75.75 0 0 1 0-1.5h3.875v-.375A2.625 2.625 0 0 1 8 .25m-4.25 4.5v8.583c0 .507.41.917.917.917h6.666c.507 0 .917-.41.917-.917V4.75zm5.75 1.5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75M7.25 7a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "trash-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          }),
          xe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.55 3.2a.75.75 0 1 0-1.5 0v5.6a3.95 3.95 0 1 0 7.9 0V3.2a.75.75 0 0 0-1.5 0v5.6a2.45 2.45 0 0 1-4.9 0zM2.4 13.65a.75.75 0 0 0 0 1.5h11.2a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          De = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M5.864 2.136a.75.75 0 0 1 0 1.061L4.478 4.583h4.856a4.75 4.75 0 0 1 0 9.5H8a.75.75 0 0 1 0-1.5h1.334a3.25 3.25 0 0 0 0-6.5H4.478L5.864 7.47a.75.75 0 1 1-1.06 1.06L1.605 5.333l3.197-3.197a.75.75 0 0 1 1.061 0",
              clipRule: "evenodd"
            })]
          }),
          Ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.5 8.75a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.75 4a1.75 1.75 0 1 1 3.5 0v1a.75.75 0 0 0 1.5 0V4a3.25 3.25 0 0 0-6.5 0v1.75H3.5A1.75 1.75 0 0 0 1.75 7.5v6c0 .966.784 1.75 1.75 1.75h8a1.75 1.75 0 0 0 1.75-1.75v-6a1.75 1.75 0 0 0-1.75-1.75h-.75zM3.5 7.25a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h8a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          Se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "m8 .039 2.53 2.53a.75.75 0 1 1-1.06 1.06l-.72-.719V5a.75.75 0 0 1-1.5 0V2.91l-.72.72a.75.75 0 0 1-1.06-1.06L8 .038Zm0 15.922-2.53-2.53a.75.75 0 1 1 1.06-1.06l.72.719V11a.75.75 0 0 1 1.5 0v2.09l.72-.72a.75.75 0 1 1 1.06 1.06zM8 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
            })]
          }),
          Ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.75 5a.75.75 0 0 0-1.5 0v2.25H5.5a.75.75 0 0 0 0 1.5h3.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0",
              clipRule: "evenodd"
            })]
          }),
          _e = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "m6.55 3.537-5.122 8.965A1.67 1.67 0 0 0 2.878 15h10.244a1.67 1.67 0 0 0 1.45-2.498L9.45 3.537c-.641-1.122-2.259-1.122-2.9 0M8 5.75a.75.75 0 0 1 .75.75v3a.75.75 0 1 1-1.5 0v-3a.75.75 0 0 1 .75-.75m0 7.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          Pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.114 2.289.756 11.767C-.06 13.211.983 15 2.643 15h10.714c1.66 0 2.703-1.788 1.886-3.233L9.886 2.29C9.057.82 6.943.82 6.114 2.289m1.306.738-5.358 9.478a.667.667 0 0 0 .58.995h10.715c.51 0 .832-.55.58-.995L8.582 3.027a.667.667 0 0 0-1.161 0ZM8.75 6a.75.75 0 0 0-1.5 0v3a.75.75 0 0 0 1.5 0zM9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0",
              clipRule: "evenodd"
            })]
          }),
          ke = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 16 16",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#x-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M13.48 2.52a.75.75 0 0 1 0 1.06L9.06 8l4.42 4.42a.75.75 0 0 1-1.06 1.06L8 9.06l-4.42 4.42a.75.75 0 1 1-1.06-1.06L6.94 8 2.52 3.58a.75.75 0 0 1 1.06-1.06L8 6.94l4.42-4.42a.75.75 0 0 1 1.06 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "x-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h16v16H0z"
                })
              })
            })]
          });
        t.sp = o, t.Ov = i, t.LZ = a, t.fM = l, t.BN = p, t.QU = h, t.gq = f, t.KM = g, t.Tw = b, t.TI = w, t.rx = E, t.Rv = k, t.F3 = R, t.nX = H, t.zs = Z, t.CP = ne, t.zG = re, t.XH = we, t.UE = De, t.av = _e, t.b0 = ke;
      },
      56479: (e, t, n) => {
        "use strict";

        var r = n(85893),
          o = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#arrow-up-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m.53-15.03L10 4.44l-.53.53-3.5 3.5a.75.75 0 1 0 1.06 1.06l2.22-2.22v7.19a.75.75 0 0 0 1.5 0V7.31l2.22 2.22a.75.75 0 0 0 1.06-1.06z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "arrow-up-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          i = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10 .25C4.615.25.25 4.615.25 10s4.365 9.75 9.75 9.75h5a.75.75 0 0 0 0-1.5h-5a8.25 8.25 0 0 1 0-16.5h1.365a6.885 6.885 0 0 1 6.885 6.885v3.115a2 2 0 1 1-4 0V5a.75.75 0 0 0-1.5 0v.896a4.5 4.5 0 0 0-7.5 3.354v1.5a4.5 4.5 0 0 0 8.009 2.818 3.5 3.5 0 0 0 6.491-1.818V8.635A8.385 8.385 0 0 0 11.365.25zm2.75 10.5v-1.5a3 3 0 1 0-6 0v1.5a3 3 0 1 0 6 0",
              clipRule: "evenodd"
            })]
          }),
          a = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m2.5-12.5a2.5 2.5 0 1 1-4.999.001A2.5 2.5 0 0 1 12.5 7.5M5 13.75c0-1.662 3.331-2.5 5-2.5s5 .838 5 2.5V15H5z",
              clipRule: "evenodd"
            })]
          }),
          s = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M4 15.74c0 .696.564 1.26 1.26 1.26h5.79c3.321 0 5.357-1.586 5.357-4.221 0-1.8-1.028-3.172-2.871-3.579 1.543-.579 2.293-1.693 2.293-3.321C15.829 3.543 14.093 2 11.22 2H5.26A1.26 1.26 0 0 0 4 3.26zm3.6-7.89V5h2.807c1.136 0 1.757.557 1.757 1.393 0 .921-.685 1.457-1.693 1.457zm0 6.15v-3.15h3.171c1.286 0 1.993.6 1.993 1.564 0 1.029-.793 1.586-1.928 1.586z"
            })]
          }),
          l = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#callout-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M4.75 5A3.25 3.25 0 0 1 8 1.75h7A3.25 3.25 0 0 1 18.25 5v3A3.25 3.25 0 0 1 15 11.25H8A3.25 3.25 0 0 1 4.75 8zM8 .25A4.75 4.75 0 0 0 3.25 5v3A4.75 4.75 0 0 0 8 12.75h7A4.75 4.75 0 0 0 19.75 8V5A4.75 4.75 0 0 0 15 .25zm1 3a.75.75 0 0 0 0 1.5h1.75V9a.75.75 0 0 0 1.5 0V4.75H14a.75.75 0 0 0 0-1.5zm1.75 12.635V14.25h1.5v2.25a.75.75 0 0 1-.603.735L2.92 18.98a1.5 1.5 0 1 1-.294-1.47l8.123-1.625Z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "callout-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          u = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M13.03 15.53a.75.75 0 0 0 0-1.06L8.56 10l4.47-4.47a.75.75 0 0 0-1.06-1.06l-5 5a.75.75 0 0 0 0 1.06l5 5a.75.75 0 0 0 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          c = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6.97 4.47a.75.75 0 0 0 0 1.06L11.44 10l-4.47 4.47a.75.75 0 1 0 1.06 1.06l5-5a.75.75 0 0 0 0-1.06l-5-5a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          d = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#check-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m4.53-11.97a.75.75 0 1 0-1.06-1.06L9 11.44 7.03 9.47a.75.75 0 1 0-1.06 1.06L9 13.56z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "check-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          p = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#check-filled-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m4.53-11.97a.75.75 0 1 0-1.06-1.06L9 11.44 7.03 9.47a.75.75 0 1 0-1.06 1.06L9 13.56z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "check-filled-icon_svg__a",
                children: r.jsx("path", {
                  fill: "transparent",
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          h = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#checkmark-circle-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M18.5 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-5.47-1.97a.75.75 0 1 0-1.06-1.06L9 11.44 7.03 9.47a.75.75 0 1 0-1.06 1.06L9 13.56z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "checkmark-circle-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          f = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeWidth: 1.5,
              d: "m16 6-8 8-4-4"
            })]
          }),
          m = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M17.53 13.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06L14.06 10zM2.47 6.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L5.94 10z"
            })]
          }),
          g = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.667 2.25A2.417 2.417 0 0 0 1.25 4.667v8.666a2.417 2.417 0 0 0 2.417 2.417H5.25v2.75a.75.75 0 0 0 1.244.564l3.788-3.314h6.051a2.417 2.417 0 0 0 2.417-2.417V4.667a2.417 2.417 0 0 0-2.417-2.417zM2.75 4.667c0-.507.41-.917.917-.917h12.666c.507 0 .917.41.917.917v8.666c0 .507-.41.917-.917.917H10a.75.75 0 0 0-.494.186L6.75 16.847V15a.75.75 0 0 0-.75-.75H3.667a.917.917 0 0 1-.917-.917zM7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m7.667-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4.333 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          v = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#copy-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M3.334.917A2.417 2.417 0 0 0 .917 3.333V12.5a2.417 2.417 0 0 0 2.417 2.417h1.749v1.75A2.417 2.417 0 0 0 7.5 19.083h9.166a2.417 2.417 0 0 0 2.417-2.416V7.5a2.417 2.417 0 0 0-2.417-2.417h-1.749v-1.75A2.417 2.417 0 0 0 12.5.917zm10.083 4.166v-1.75a.917.917 0 0 0-.917-.916H3.334a.917.917 0 0 0-.917.916V12.5c0 .506.41.917.917.917h1.749V7.5A2.417 2.417 0 0 1 7.5 5.083zm-6.834 9.115V7.5c0-.506.41-.917.917-.917h9.166c.507 0 .917.41.917.917v9.167c0 .506-.41.916-.917.916H7.5a.917.917 0 0 1-.917-.916z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "copy-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#cross-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10M7.53 6.47a.75.75 0 0 0-1.06 1.06L8.94 10l-2.47 2.47a.75.75 0 1 0 1.06 1.06L10 11.06l2.47 2.47a.75.75 0 0 0 1.06-1.06L11.06 10l2.47-2.47a.75.75 0 0 0-1.06-1.06L10 8.94z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "cross-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          b = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#cross-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M16.894 3.106a.75.75 0 0 1 0 1.06L11.061 10l5.833 5.834a.75.75 0 0 1-1.06 1.06L10 11.061l-5.834 5.833a.75.75 0 1 1-1.06-1.06L8.939 10 3.106 4.166a.75.75 0 0 1 1.06-1.06L10 8.939l5.834-5.833a.75.75 0 0 1 1.06 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "cross-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          w = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#cut-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M5.263 13.281a2 2 0 1 1-3.464 2 2 2 0 0 1 3.464-2m1.6-.072A3.501 3.501 0 0 1 .5 16.031a3.5 3.5 0 0 1 5.609-4.118l2.364-1.353.13-.849a4.85 4.85 0 0 1 2.385-3.48l3.558-2.037a2.39 2.39 0 0 1 2.339-.02l2.897 1.59-10.25 5.918zm9.862-7.412L10.157 9.59a3.35 3.35 0 0 1 1.577-2.056l3.557-2.037a.89.89 0 0 1 .872-.008l.562.31Zm-9.862.994A3.501 3.501 0 0 0 .5 3.969a3.5 3.5 0 0 0 5.609 4.118l1.166.667c.135-.49.328-.96.572-1.4zm7.083 4.075 4.683 2.703 1.153.666-1.167.641-1.73.95a2.39 2.39 0 0 1-2.34-.02l-3.557-2.037a5 5 0 0 1-.909-.672l.198-.113.007-.004 1.183-.683q.128.09.267.17l3.557 2.037c.27.154.6.157.872.008l.562-.31-4.28-2.47 1.5-.866ZM5.263 6.719a2 2 0 1 0-3.464-2 2 2 0 0 0 3.464 2",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "cut-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          x = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 6.25a.75.75 0 0 1 .75.75v2.25h12.5V7a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0v-2.25H3.75V13a.75.75 0 0 1-1.5 0V7A.75.75 0 0 1 3 6.25",
              clipRule: "evenodd"
            })]
          }),
          D = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10 1.75a.75.75 0 0 1 .75.75v10.69l2.053-2.054a.75.75 0 0 1 1.06 1.061L10 16.061l-3.864-3.864a.75.75 0 0 1 1.061-1.06l2.053 2.052V2.5a.75.75 0 0 1 .75-.75M2.5 13.417a.75.75 0 0 1 .75.75v2.5c0 .506.41.916.917.916h11.666c.507 0 .917-.41.917-.916v-2.5a.75.75 0 0 1 1.5 0v2.5a2.417 2.417 0 0 1-2.417 2.416H4.167a2.417 2.417 0 0 1-2.417-2.416v-2.5a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            })]
          }),
          C = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("circle", {
              cx: 15.417,
              cy: 7.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 15.417 7.5)"
            }), r.jsx("circle", {
              cx: 10,
              cy: 7.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 10 7.5)"
            }), r.jsx("circle", {
              cx: 4.583,
              cy: 7.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 4.583 7.5)"
            }), r.jsx("circle", {
              cx: 15.417,
              cy: 12.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 15.417 12.5)"
            }), r.jsx("circle", {
              cx: 10,
              cy: 12.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 10 12.5)"
            }), r.jsx("circle", {
              cx: 4.583,
              cy: 12.5,
              r: 1.25,
              fill: "currentColor",
              transform: "rotate(90 4.583 12.5)"
            })]
          }),
          S = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#duplicate-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M12.833 9.583a.75.75 0 0 0-1.5 0v1.75h-1.75a.75.75 0 0 0 0 1.5h1.75v1.75a.75.75 0 0 0 1.5 0v-1.75h1.75a.75.75 0 0 0 0-1.5h-1.75z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M.917 3.333A2.417 2.417 0 0 1 3.334.917H12.5a2.417 2.417 0 0 1 2.417 2.416v1.75h1.75A2.417 2.417 0 0 1 19.082 7.5v9.167a2.417 2.417 0 0 1-2.417 2.416H7.5a2.417 2.417 0 0 1-2.417-2.416v-1.75h-1.75A2.417 2.417 0 0 1 .918 12.5V3.333Zm12.5 0v1.75H7.5A2.417 2.417 0 0 0 5.083 7.5v5.917h-1.75a.917.917 0 0 1-.916-.917V3.333c0-.506.41-.916.917-.916H12.5c.507 0 .917.41.917.916M6.584 14.167l-.001.031v2.469c0 .506.41.916.917.916h9.166c.507 0 .917-.41.917-.916V7.5a.917.917 0 0 0-.917-.917H7.5a.917.917 0 0 0-.917.917z",
                clipRule: "evenodd"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "duplicate-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          E = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.874 2.732a2.417 2.417 0 0 1 3.418 0l.976.976a2.417 2.417 0 0 1 0 3.417L6.608 17.787c-.297.297-.7.464-1.12.464H1.75v-3.738c0-.42.167-.823.464-1.12zm2.357 1.06a.917.917 0 0 0-1.296 0L12.727 5 15 7.273l1.208-1.208a.917.917 0 0 0 0-1.297zM13.94 8.333l-2.272-2.272-8.393 8.392a.08.08 0 0 0-.024.059v2.238h2.238a.08.08 0 0 0 .06-.024z",
              clipRule: "evenodd"
            })]
          }),
          _ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10 16.834a6.833 6.833 0 1 0 0-13.667 6.833 6.833 0 0 0 0 13.667m0 1.5a8.333 8.333 0 1 0 0-16.667 8.333 8.333 0 0 0 0 16.667",
              clipRule: "evenodd"
            })]
          }),
          P = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#emoji-smile-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M18.5 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10M6.697 11.722a.75.75 0 1 0-1.393.556C6.012 14.051 7.882 15.25 10 15.25s3.988-1.199 4.697-2.972a.75.75 0 1 0-1.393-.556c-.456 1.14-1.728 2.028-3.304 2.028s-2.848-.888-3.303-2.028M8.5 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M13 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "emoji-smile-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          k = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#error-alt-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m3.53-12.47a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "error-alt-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          A = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m3.53-12.47a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06z",
              clipRule: "evenodd"
            })]
          }),
          z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#error-alternative-circle-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M18.5 10a8.5 8.5 0 0 1-13.957 6.517L16.517 4.543A8.47 8.47 0 0 1 18.5 10M3.483 15.457 15.457 3.483A8.5 8.5 0 0 0 3.483 15.457M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "error-alternative-circle-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          T = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#error-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-8.75 4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10.75 5a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "error-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          O = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#error-circle-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m1.25-5.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M10.75 5a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "error-circle-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          I = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.53 13.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L3.06 10zm6.94-6.94a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L16.94 10z"
            })]
          }),
          F = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M15.833 14.583a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m0-4.166a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-4.583 4.166a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m0-4.166a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-4.583 4.166a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.166.833a.75.75 0 0 0-1.5 0v1H3.333A3.167 3.167 0 0 0 .166 5v10.833A3.167 3.167 0 0 0 3.333 19h13.333a3.167 3.167 0 0 0 3.167-3.167V5a3.167 3.167 0 0 0-3.167-3.167h-1.333v-1a.75.75 0 0 0-1.5 0v1H6.166zm-1.5 2.5V5a.75.75 0 1 0 1.5 0V3.333h7.667V5a.75.75 0 0 0 1.5 0V3.333h1.333c.92 0 1.667.746 1.667 1.667v1.333H1.666V5c0-.92.746-1.667 1.667-1.667zm-3 12.5v-8h16.667v8c0 .92-.746 1.667-1.667 1.667H3.333c-.92 0-1.667-.746-1.667-1.667",
              clipRule: "evenodd"
            })]
          }),
          M = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.989 15.833H1.667c-.92 0-1.667-.746-1.667-1.666V5.833c0-.92.746-1.666 1.667-1.666h16.666c.92 0 1.667.746 1.667 1.666v8.334c0 .92-.746 1.666-1.667 1.666H10.67c-.17.598-.358 1.16-.559 1.66-.246.614-.527 1.171-.844 1.59-.29.381-.751.834-1.389.834-.754 0-1.181-.59-1.392-1.025-.228-.472-.36-1.062-.43-1.627a9.5 9.5 0 0 1-.067-1.432M1.667 5.667h16.666c.092 0 .167.074.167.166v8.334a.167.167 0 0 1-.167.166h-7.285c.094-.426.178-.858.253-1.288.133-.77.236-1.55.298-2.289.374-.242.752-.458 1.123-.637q.045.117.105.266c.096.237.224.536.39.783.138.204.467.624 1.025.624.914 0 1.66-.522 2.175-1.205.516-.684.857-1.593.992-2.567a.75.75 0 0 0-1.486-.206c-.107.775-.372 1.43-.704 1.87-.267.354-.542.53-.794.587a4 4 0 0 1-.207-.448l-.08-.2a10 10 0 0 0-.194-.476 2 2 0 0 0-.2-.35c-.054-.072-.289-.38-.714-.38a.8.8 0 0 0-.27.05 10 10 0 0 0-1.098.51 11 11 0 0 0-.016-.402c-.037-.617-.13-1.207-.328-1.667-.194-.452-.596-.991-1.318-.991-.46 0-1.059.189-1.629.413a21 21 0 0 0-1.978.923c-1.355.712-2.782 1.604-3.557 2.29a.75.75 0 1 0 .994 1.123c.639-.565 1.94-1.391 3.26-2.085a19 19 0 0 1 1.83-.855c.473-.186.802-.276.984-.301l.036.075c.096.223.175.61.209 1.165.022.378.022.806 0 1.267-.423.307-.832.637-1.216.979-1.138 1.012-2.125 2.182-2.638 3.24a2 2 0 0 0-.076.182H1.667a.167.167 0 0 1-.167-.166V5.833c0-.092.075-.166.167-.166m7.438 10.166c-.122.397-.252.767-.386 1.101-.224.558-.446.977-.648 1.242a1.3 1.3 0 0 1-.165.188q-.03-.044-.07-.125c-.126-.262-.23-.67-.292-1.16a8 8 0 0 1-.054-1.246zm.404-1.5H7.908c.448-.717 1.16-1.535 2.022-2.301l.015-.014a27 27 0 0 1-.436 2.315m.359-6.963q0-.002.008.01zM7.97 18.44q0 .003-.01-.007.01.006.01.008Zm6.536-8.054-.013-.013z",
              clipRule: "evenodd"
            })]
          }),
          R = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#form-text-field-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M7.5.917a.75.75 0 0 0 0 1.5c.966 0 1.75.783 1.75 1.75H1.667C.747 4.167 0 4.913 0 5.833v8.334c0 .92.746 1.666 1.667 1.666H9.25a1.75 1.75 0 0 1-1.75 1.75.75.75 0 0 0 0 1.5A3.24 3.24 0 0 0 10 17.91a3.24 3.24 0 0 0 2.5 1.173.75.75 0 0 0 0-1.5 1.75 1.75 0 0 1-1.75-1.748v-.002h7.583c.92 0 1.667-.746 1.667-1.666V5.833c0-.92-.746-1.666-1.667-1.666H10.75c0-.967.784-1.75 1.75-1.75a.75.75 0 0 0 0-1.5A3.24 3.24 0 0 0 10 2.09 3.24 3.24 0 0 0 7.5.917m1.75 4.75H1.667a.167.167 0 0 0-.167.166v8.334c0 .092.075.166.167.166H9.25v-3.708h-1a.75.75 0 0 1 0-1.5h1zm1.5 8.666v-3.708h1a.75.75 0 0 0 0-1.5h-1V5.667h7.583c.092 0 .167.074.167.166v8.334a.167.167 0 0 1-.167.166z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "form-text-field-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          j = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 0a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3zm2 3.25a.75.75 0 0 0 0 1.5h4.25V15a.75.75 0 0 0 1.5 0V4.75H15a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          B = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.545 1.403a.75.75 0 0 1 .91 0l7 5.334a.75.75 0 0 1 .295.596V18a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V7.333a.75.75 0 0 1 .295-.596zm6.705 6.302L10 2.943 3.75 7.705v9.545h3.5V14a2.75 2.75 0 1 1 5.5 0v3.25h3.5zm-5 9.545V14a1.25 1.25 0 1 0-2.5 0v3.25z",
              clipRule: "evenodd"
            })]
          }),
          N = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#image-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M18.333 3.5H1.667a.167.167 0 0 0-.167.167v9.776l2.922-2.912a.75.75 0 0 1 1.059 0l2.104 2.098 5.178-5.16a.75.75 0 0 1 1.06 0L18.5 12.13V3.667a.167.167 0 0 0-.167-.167M-.06 14.998l.061-.06V3.667A1.666 1.666 0 0 1 1.667 2h16.666C19.253 2 20 2.746 20 3.667v9.958l.06.06-.06.062v2.586c0 .92-.746 1.667-1.667 1.667H1.667C.747 18 0 17.254 0 16.333V15.06L-.06 15Zm18.56 1.335v-2.085l-5.207-5.19-5.178 5.16a.75.75 0 0 1-1.059 0l-2.105-2.097-3.451 3.44v.772c0 .092.075.167.167.167h16.666a.167.167 0 0 0 .167-.167M5.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "image-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          L = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#info-circle-filled-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-8.75-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.5 8.25a.75.75 0 0 0 0 1.5h.75v4.5H8.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "info-circle-filled-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          V = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#info-circle-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 18.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m1.25-14.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.5 8.25a.75.75 0 0 0 0 1.5h.75v4.5H8.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "info-circle-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          K = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#info-filled-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-8.75-4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M8.5 8.25a.75.75 0 0 0 0 1.5h.75v4.5H8.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "info-filled-icon_svg__a",
                children: r.jsx("path", {
                  fill: "#fff",
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.75 4a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-1.901l-2.16 9.5H11a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.901l2.16-9.5H8.5A.75.75 0 0 1 7.75 4",
              clipRule: "evenodd"
            })]
          }),
          H = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "m17.026 8.54-1.944 1.945a.75.75 0 0 1-1.06-1.06l1.944-1.945a1.75 1.75 0 0 0 0-2.475l-.707-.707a1.75 1.75 0 0 0-2.475 0L9.248 7.834a1.75 1.75 0 0 0 0 2.475l.354.353a.75.75 0 1 1-1.06 1.06l-.354-.353a3.25 3.25 0 0 1 0-4.596l3.535-3.536a3.25 3.25 0 0 1 4.596 0l.707.708a3.25 3.25 0 0 1 0 4.596ZM5.065 9.897a.75.75 0 1 1 1.06 1.06L4.3 12.784a1.75 1.75 0 0 0 0 2.475l.707.707a1.75 1.75 0 0 0 2.475 0l3.535-3.535a1.75 1.75 0 0 0 0-2.475l-.354-.354a.75.75 0 1 1 1.061-1.06l.354.353a3.25 3.25 0 0 1 0 4.596L8.54 17.026a3.25 3.25 0 0 1-4.596 0l-.707-.707a3.25 3.25 0 0 1 0-4.596l1.827-1.827Z",
              clipRule: "evenodd"
            })]
          }),
          U = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.75 5.417a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5m4.167-2a.75.75 0 1 0 0 1.5h9.167a.75.75 0 0 0 0-1.5zm0 5.833a.75.75 0 0 0 0 1.5h9.167a.75.75 0 0 0 0-1.5zm-.75 6.583a.75.75 0 0 1 .75-.75h9.167a.75.75 0 0 1 0 1.5H7.917a.75.75 0 0 1-.75-.75M5 10a1.25 1.25 0 1 1-2.5 0A1.25 1.25 0 0 1 5 10m-1.25 7.083a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
              clipRule: "evenodd"
            })]
          }),
          Z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.75 5a3.25 3.25 0 1 1 6.5 0v2.5h-6.5zm-1.5 2.5V5a4.75 4.75 0 0 1 9.5 0v2.5H15a3.5 3.5 0 0 1 3.5 3.5v5a3.5 3.5 0 0 1-3.5 3.5H5A3.5 3.5 0 0 1 1.5 16v-5A3.5 3.5 0 0 1 5 7.5zM5 9a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2zm6.5 3.5a1.5 1.5 0 0 1-.75 1.3V15a.75.75 0 0 1-1.5 0v-1.2a1.5 1.5 0 1 1 2.25-1.3",
              clipRule: "evenodd"
            })]
          }),
          $ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.667 1.833a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0m3.673.251c.109-.763 1.21-.763 1.32 0l.657 4.6 4.599.656c.763.109.763 1.21 0 1.32l-4.6.657-.656 4.599c-.11.763-1.211.763-1.32 0l-.657-4.6-4.599-.656c-.763-.11-.763-1.21 0-1.32l4.599-.657zM2.832 14.142c.11-.773 1.226-.773 1.336 0l.212 1.479 1.478.21c.773.111.773 1.227 0 1.337l-1.478.211-.212 1.479c-.11.773-1.226.773-1.336 0l-.211-1.479-1.479-.21c-.773-.111-.773-1.227 0-1.337l1.479-.212zm-.999-3.475a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667m12.667 8.5a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
            })]
          }),
          G = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3.25 10A.75.75 0 0 1 4 9.25h12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          W = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#monkey-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10 .25C4.615.25.25 4.615.25 10s4.365 9.75 9.75 9.75h5a.75.75 0 0 0 0-1.5h-5a8.25 8.25 0 0 1 0-16.5h1.365a6.885 6.885 0 0 1 6.885 6.885v3.115a2 2 0 1 1-4 0V5a.75.75 0 0 0-1.5 0v.896a4.5 4.5 0 0 0-7.5 3.354v1.5a4.5 4.5 0 0 0 8.009 2.818 3.5 3.5 0 0 0 6.491-1.818V8.635A8.385 8.385 0 0 0 11.365.25zm2.75 10.5v-1.5a3 3 0 1 0-6 0v1.5a3 3 0 1 0 6 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "monkey-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          Y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.5 8.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m5 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
              clipRule: "evenodd"
            })]
          }),
          X = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M10 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-13a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
            })]
          }),
          Q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.637 2.803a.75.75 0 1 1 1.06 1.061l-1.22 1.22H5a5.75 5.75 0 0 1 5 2.908 5.75 5.75 0 0 1 5-2.908h1.523l-1.22-1.22a.75.75 0 1 1 1.061-1.06l3.03 3.03-3.03 3.03a.75.75 0 0 1-1.06-1.06l1.22-1.22H15a4.25 4.25 0 0 0-4.25 4.25V17.5a.75.75 0 0 1-1.5 0v-6.666A4.25 4.25 0 0 0 5 6.584H3.478l1.22 1.22a.75.75 0 1 1-1.061 1.06l-3.03-3.03z",
              clipRule: "evenodd"
            })]
          }),
          J = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#paste-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M14.5 14.5h4v-13h-10v1H7V1a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4.5zm-3 4h-10v-13H8V8a1 1 0 0 0 1 1h2.5zM0 19V5a1 1 0 0 1 1-1h7.586a1 1 0 0 1 .707.293l3.414 3.414a1 1 0 0 1 .293.707V19a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1M11.5 2.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "paste-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "m16.256 9.773-1.179 1.179a.833.833 0 0 1-1.178 0l-.59-.59L6.42 17.25a3.2 3.2 0 0 1-1.785.9l-.203.032a2.58 2.58 0 0 0-1.437.725L1.23 17.139c.389-.389.643-.892.725-1.436l.03-.204a3.2 3.2 0 0 1 .902-1.785l6.887-6.887-.589-.59a.833.833 0 0 1 0-1.178l1.179-1.178a.833.833 0 0 1 1.178 0 .833.833 0 0 0 1.179 0l1.768-1.768a2.5 2.5 0 1 1 3.535 3.536l-1.767 1.767a.833.833 0 0 0 0 1.179.833.833 0 0 1 0 1.178Zm-1.061-3.417a2.33 2.33 0 0 0-.403 2.76l-.304.304-3.771-3.771.304-.305a2.33 2.33 0 0 0 2.76-.403l1.767-1.767a1 1 0 0 1 1.415 1.414zM4.209 16.698c-.35.053-.69.15-1.01.29l-.052-.051q.21-.483.29-1.01l.03-.204a1.7 1.7 0 0 1 .48-.948l6.879-6.88L12.24 9.31l-6.88 6.88a1.7 1.7 0 0 1-.948.479l-.203.03Z",
              clipRule: "evenodd"
            })]
          }),
          te = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9.25 16a.75.75 0 0 0 1.5 0v-5.25H16a.75.75 0 0 0 0-1.5h-5.25V4a.75.75 0 0 0-1.5 0v5.25H4a.75.75 0 0 0 0 1.5h5.25z",
              clipRule: "evenodd"
            })]
          }),
          ne = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 2.917c0-.875.709-1.584 1.583-1.584h8.334c.874 0 1.583.71 1.583 1.584V4.25h1.75a2.417 2.417 0 0 1 2.416 2.417v6.666A2.417 2.417 0 0 1 17.5 15.75h-1.75v2.583c0 .875-.709 1.584-1.583 1.584H5.833a1.583 1.583 0 0 1-1.583-1.584V15.75H2.5a2.417 2.417 0 0 1-2.417-2.417V6.667A2.417 2.417 0 0 1 2.5 4.25h1.75zM15 5.75H2.5a.917.917 0 0 0-.917.917v6.666c0 .507.41.917.917.917h1.75v-3.417c0-.874.709-1.583 1.583-1.583h8.334c.874 0 1.583.709 1.583 1.583v3.417h1.75c.506 0 .916-.41.916-.917V6.667a.917.917 0 0 0-.916-.917zm-.75-2.833V4.25h-8.5V2.917c0-.046.037-.084.083-.084h8.334c.046 0 .083.038.083.084m0 7.916v7.5a.083.083 0 0 1-.083.084H5.833a.083.083 0 0 1-.083-.084v-7.5c0-.046.037-.083.083-.083h8.334c.046 0 .083.037.083.083m-.5-2.5a.833.833 0 1 0 0-1.666.833.833 0 0 0 0 1.666m-5.417 4.25a.75.75 0 0 0 0 1.5h3.333a.75.75 0 1 0 0-1.5zm0 2.5a.75.75 0 0 0 0 1.5h3.333a.75.75 0 1 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          re = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.09 2.231a.75.75 0 1 1 .987-1.129l3.979 3.481-3.979 3.481a.75.75 0 0 1-.987-1.128l1.948-1.705a5.083 5.083 0 1 0 4.046 4.978.75.75 0 1 1 1.5 0 6.583 6.583 0 1 1-5.856-6.544z",
              clipRule: "evenodd"
            })]
          }),
          oe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M2.78 8.5a5.72 5.72 0 1 1 11.44 0 5.72 5.72 0 0 1-11.44 0M8.5 1.22a7.28 7.28 0 1 0 4.59 12.93l3.88 3.88a.75.75 0 0 0 1.06-1.06l-3.88-3.88A7.28 7.28 0 0 0 8.5 1.22",
              clipRule: "evenodd"
            })]
          }),
          ie = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              fillRule: "evenodd",
              clipPath: "url(#settings-icon_svg__a)",
              clipRule: "evenodd",
              children: [r.jsx("path", {
                d: "M13.334 10a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m-1.5 0a1.833 1.833 0 1 1-3.667 0 1.833 1.833 0 0 1 3.667 0"
              }), r.jsx("path", {
                d: "M9.433.917c-.755 0-1.405.532-1.553 1.273l-.334 1.67s-.001.007-.011.018a.2.2 0 0 1-.057.04.14.14 0 0 1-.064.011.04.04 0 0 1-.021-.005l-1.418-.945a1.58 1.58 0 0 0-1.998.197l-.801.802a1.58 1.58 0 0 0-.198 1.998l.945 1.417a.04.04 0 0 1 .005.022.14.14 0 0 1-.012.064.2.2 0 0 1-.038.056q-.018.013-.019.012l-1.67.334A1.58 1.58 0 0 0 .916 9.433v1.134c0 .755.533 1.405 1.273 1.553l1.67.334s.007 0 .018.01a.16.16 0 0 1 .052.122.04.04 0 0 1-.006.021l-.945 1.417a1.58 1.58 0 0 0 .198 1.998l.802.802c.533.533 1.37.616 1.997.198l1.418-.945q.002-.004.021-.006a.14.14 0 0 1 .064.012.2.2 0 0 1 .057.039c.01.012.01.018.01.018l.335 1.67c.148.74.798 1.273 1.553 1.273h1.133c.755 0 1.405-.532 1.553-1.272l.334-1.67s0-.007.011-.02a.2.2 0 0 1 .057-.038.15.15 0 0 1 .064-.012q.02.002.021.006l1.418.945a1.58 1.58 0 0 0 1.998-.198l.801-.802c.534-.533.617-1.37.198-1.998l-.945-1.417a.04.04 0 0 1-.006-.022.14.14 0 0 1 .012-.063.2.2 0 0 1 .04-.057q.016-.013.018-.011l1.67-.335a1.58 1.58 0 0 0 1.273-1.552V9.433c0-.754-.533-1.404-1.273-1.552l-1.67-.334s-.007-.001-.019-.012a.2.2 0 0 1-.039-.056.14.14 0 0 1-.012-.064q.003-.02.006-.021l.945-1.418a1.58 1.58 0 0 0-.198-1.998l-.801-.802a1.58 1.58 0 0 0-1.998-.197l-1.418.945a.04.04 0 0 1-.021.005.14.14 0 0 1-.064-.012.2.2 0 0 1-.057-.039q-.013-.017-.011-.018l-.334-1.67A1.58 1.58 0 0 0 10.566.917zM9.35 2.484a.08.08 0 0 1 .082-.067h1.133c.04 0 .074.028.082.067l.334 1.67c.11.552.506.959.964 1.149a1.59 1.59 0 0 0 1.492-.131l1.418-.945a.08.08 0 0 1 .105.01l.802.802a.08.08 0 0 1 .01.105l-.945 1.418a1.59 1.59 0 0 0-.131 1.492c.19.457.596.853 1.148.963l1.67.335a.08.08 0 0 1 .068.081v1.134c0 .04-.028.074-.067.082l-1.67.334c-.553.11-.96.506-1.15.964a1.59 1.59 0 0 0 .132 1.492l.945 1.417a.08.08 0 0 1-.01.105l-.802.802a.084.084 0 0 1-.105.01l-1.418-.944a1.59 1.59 0 0 0-1.492-.131c-.458.19-.854.596-.964 1.148l-.334 1.67a.08.08 0 0 1-.082.067H9.433a.08.08 0 0 1-.082-.067l-.334-1.67a1.6 1.6 0 0 0-.964-1.148 1.59 1.59 0 0 0-1.492.13l-1.418.946a.08.08 0 0 1-.105-.01l-.801-.803a.08.08 0 0 1-.01-.105l.944-1.417c.31-.466.322-1.03.13-1.492a1.6 1.6 0 0 0-1.148-.964l-1.67-.334a.08.08 0 0 1-.067-.082V9.433c0-.04.028-.074.067-.081l1.67-.335c.553-.11.959-.506 1.149-.964a1.59 1.59 0 0 0-.131-1.492l-.945-1.417a.08.08 0 0 1 .01-.105l.802-.802a.08.08 0 0 1 .105-.01l1.417.945c.467.31 1.031.322 1.493.13.457-.19.853-.596.964-1.148z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "settings-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          ae = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.417 7.5a5.083 5.083 0 0 1 10.112-.75H8.333c-.874 0-1.583.709-1.583 1.583v4.195A5.084 5.084 0 0 1 2.417 7.5m4.333 6.541a6.584 6.584 0 1 1 7.291-7.29H17.5c.875 0 1.583.708 1.583 1.582V17.5c0 .875-.709 1.583-1.583 1.583H8.333A1.583 1.583 0 0 1 6.75 17.5zm1.5-5.708c0-.046.037-.083.083-.083H17.5c.046 0 .083.037.083.083V17.5a.083.083 0 0 1-.083.083H8.333a.083.083 0 0 1-.083-.083z",
              clipRule: "evenodd"
            })]
          }),
          se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15.417 6.5a2.75 2.75 0 1 0-2.667-2.077L6.5 8.028a2.75 2.75 0 1 0 0 3.943l6.25 3.606A2.752 2.752 0 0 0 15.417 19a2.75 2.75 0 1 0-1.917-4.722l-6.25-3.605a2.76 2.76 0 0 0 0-1.346l6.25-3.605a2.74 2.74 0 0 0 1.917.778M4.583 8.75c.306 0 .586.11.803.292l.428.742a1.3 1.3 0 0 1 0 .432l-.428.742a1.25 1.25 0 1 1-.803-2.208m12.084-5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m0 12.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
              clipRule: "evenodd"
            })]
          }),
          le = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.07 2.813c1.006-.966 2.68-.253 2.68 1.142v12.09c0 1.395-1.674 2.108-2.68 1.142l-4.598-4.414a.08.08 0 0 0-.057-.023H1.833A1.583 1.583 0 0 1 .25 11.167V8.433c0-.874.709-1.583 1.583-1.583h2.998a.08.08 0 0 0 .058-.023zm1.08 1.058c-.007.001-.02.004-.041.024L5.928 7.909a1.58 1.58 0 0 1-1.097.441H1.833a.083.083 0 0 0-.083.083v2.734c0 .046.037.083.083.083h2.582c.408 0 .801.158 1.096.441l4.598 4.414c.02.02.034.023.042.024q.018.003.048-.008a.1.1 0 0 0 .04-.03c.004-.006.011-.018.011-.046V3.955c0-.028-.007-.04-.011-.047a.1.1 0 0 0-.04-.03.1.1 0 0 0-.048-.007Z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M13.005 6.005a.75.75 0 0 1 1.06 0 5.995 5.995 0 0 1 0 8.478.75.75 0 0 1-1.06-1.06 4.495 4.495 0 0 0 0-6.358.75.75 0 0 1 0-1.06"
            }), r.jsx("path", {
              d: "M16.834 4.47a.75.75 0 1 0-1.06 1.06 6.75 6.75 0 0 1 0 9.546.75.75 0 1 0 1.06 1.06 8.25 8.25 0 0 0 0-11.666"
            })]
          }),
          ue = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10 .25A3.75 3.75 0 0 0 6.25 4v6a3.75 3.75 0 1 0 7.5 0V4A3.75 3.75 0 0 0 10 .25M7.75 4a2.25 2.25 0 0 1 4.5 0v6a2.25 2.25 0 0 1-4.5 0zm-3 3a.75.75 0 0 0-1.5 0v3a6.75 6.75 0 0 0 6 6.709v1.541H7a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5h-2.25v-1.541a6.75 6.75 0 0 0 6-6.709V7a.75.75 0 0 0-1.5 0v3a5.25 5.25 0 1 1-10.5 0z",
              clipRule: "evenodd"
            })]
          }),
          ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10 .5a.75.75 0 0 1 .693.462l2.249 5.406 5.836.468a.75.75 0 0 1 .428 1.318l-4.447 3.809 1.359 5.696a.75.75 0 0 1-1.12.814L10 15.42l-4.997 3.052a.75.75 0 0 1-1.12-.814l1.358-5.696-4.447-3.81a.75.75 0 0 1 .428-1.317l5.837-.468L9.308.962A.75.75 0 0 1 10 .5m0 2.703L8.268 7.367a.75.75 0 0 1-.632.46l-4.496.36 3.425 2.935a.75.75 0 0 1 .242.743L5.76 16.253l3.85-2.351a.75.75 0 0 1 .781 0l3.85 2.35-1.047-4.387a.75.75 0 0 1 .241-.743l3.426-2.934-4.496-.36a.75.75 0 0 1-.633-.46z",
              clipRule: "evenodd"
            })]
          }),
          de = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.842 15.206c.6-.6.621-1.559.063-2.183l3.232-3.232c.95-.95.95-2.49 0-3.44L12.255.47a.75.75 0 0 0-1.25.32v.002l-.003.006-.008.03a15 15 0 0 1-.194.582c-.14.394-.351.947-.634 1.57-.48 1.06-1.15 2.287-2.004 3.303a1.59 1.59 0 0 0-2.158.084l-.932.932a1.59 1.59 0 0 0 0 2.25l1.767 1.768a.09.09 0 0 1-.015.14L2.893 13.96a3.156 3.156 0 1 0 4.357 4.358l2.502-3.93a.09.09 0 0 1 .14-.016l1.769 1.767a1.59 1.59 0 0 0 2.25 0l.931-.932ZM7.66 7.894l-.01-.01-.456-.456a.09.09 0 0 0-.129 0l-.932.932a.09.09 0 0 0 0 .129L7.9 10.256a1.59 1.59 0 0 1-.271 2.467l-3.931 2.502a1.656 1.656 0 1 0 2.287 2.287l2.501-3.931a1.59 1.59 0 0 1 2.468-.27l1.767 1.767a.09.09 0 0 0 .129 0l.932-.932a.09.09 0 0 0 0-.129l-.456-.455-.01-.01zM11.532 3.6c-.519 1.144-1.28 2.555-2.303 3.743l4.617 4.617 3.23-3.23a.93.93 0 0 0 0-1.318l-.402-.402-1.945 1.945a.75.75 0 1 1-1.06-1.06c.732-.733 1.025-1.48 1.14-2.03a3 3 0 0 0 .072-.648l-2.84-2.84c-.135.355-.304.771-.51 1.223ZM5.183 16.026a.75.75 0 1 0-1.06 1.06.75.75 0 0 0 1.06-1.06",
              clipRule: "evenodd"
            })]
          }),
          pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.75 3.75A.75.75 0 0 1 2.5 3h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m2.5 4.167a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m-2.5 4.166a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m2.5 4.167A.75.75 0 0 1 5 15.5h10a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          he = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.75 3.75A.75.75 0 0 1 2.5 3h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m0 4.167a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m0 4.166a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m0 4.167a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          fe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M2.5 3a.75.75 0 0 0 0 1.5h15a.75.75 0 0 0 0-1.5zm0 4.167a.75.75 0 1 0 0 1.5h10a.75.75 0 0 0 0-1.5zm-.75 4.916a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75M2.5 15.5a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5z"
            })]
          }),
          me = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.75 3.75A.75.75 0 0 1 2.5 3h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m5 4.167a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1-.75-.75m-5 4.166a.75.75 0 0 1 .75-.75h15a.75.75 0 0 1 0 1.5h-15a.75.75 0 0 1-.75-.75m5 4.167a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5h-10a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          ge = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 4A.75.75 0 0 1 5 3.25h10a.75.75 0 0 1 0 1.5h-4.25V15a.75.75 0 0 1-1.5 0V4.75H5A.75.75 0 0 1 4.25 4",
              clipRule: "evenodd"
            })]
          }),
          ve = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.167 3.417a.75.75 0 0 0-.75.75v4.166c0 .415.336.75.75.75h4.167a.75.75 0 0 0 .75-.75V4.167a.75.75 0 0 0-.75-.75zm.75 4.166V4.917h2.667v2.666zm-.75 3.334a.75.75 0 0 0-.75.75v4.166c0 .414.336.75.75.75h4.167a.75.75 0 0 0 .75-.75v-4.166a.75.75 0 0 0-.75-.75zm.75 4.166v-2.666h2.667v2.666zm6-3.416a.75.75 0 0 1 .75-.75h4.167a.75.75 0 0 1 .75.75v4.166a.75.75 0 0 1-.75.75h-4.167a.75.75 0 0 1-.75-.75zm1.5.75v2.666h2.667v-2.666zm-.75-9a.75.75 0 0 0-.75.75v4.166c0 .415.336.75.75.75h4.167a.75.75 0 0 0 .75-.75V4.167a.75.75 0 0 0-.75-.75zm.75 4.166V4.917h2.667v2.666z",
              clipRule: "evenodd"
            })]
          }),
          ye = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.75.98h2.74l-.02.01c2.22 0 3.32 1.29 3.4 2.49.02.24-.01.46-.07.67.15.11.3.25.42.41.48.62.59 1.49.29 2.22q-.06.165-.15.3c.08.07.15.15.22.24.47.62.58 1.48.28 2.2q-.15.345-.39.6c.3.42.43.95.35 1.52a2.123 2.123 0 0 1-2.14 1.85H13.7c-.13 0-.19.07-.22.11l-.003.005a.28.28 0 0 0-.017.245l1.43 3.48c.34 1.06-.24 2.21-1.28 2.56-.96.33-2.03-.1-2.48-1.01-1.37-2.73-2.67-4.32-3.71-5.59q-.227-.277-.44-.54H4c-.52 0-.959-.24-1.296-.559-.333-.316-.598-.738-.804-1.202-.414-.93-.65-2.164-.65-3.49 0-1.325.236-2.559.65-3.49.206-.463.472-.885.804-1.201.337-.32.777-.559 1.296-.559h3.5q.1.001.193.026C8.806 1.455 10.2.979 11.75.979Zm-5.5 2.77c-.787 1.115-1.24 2.503-1.24 4.04 0 1.477.339 2.515.897 3.46H4c-.034 0-.121-.013-.263-.147-.146-.139-.311-.374-.467-.723-.31-.697-.52-1.713-.52-2.88 0-1.168.21-2.184.52-2.88.156-.35.321-.586.467-.724.142-.134.23-.147.263-.147h2.25Zm6.68 14.75a.54.54 0 0 1-.47-.29c-1.44-2.88-2.8-4.54-3.89-5.87C7.23 10.71 6.5 9.81 6.5 7.79c0-2.57 1.84-5.31 5.24-5.31h2.74c1.34 0 1.87.66 1.9 1.1 0 .08 0 .21-.09.22-.41.06-.7.44-.64.85s.44.7.85.64q.36-.045.54.18c.15.19.19.5.09.73-.08.2-.24.3-.5.34-.38.05-.66.37-.66.74v.1c.05.41.42.71.84.65.25-.03.44.03.56.2.15.19.18.49.09.71-.08.19-.24.3-.5.33-.35.04-.62.33-.65.68s.19.68.53.78c.5.15.5.54.48.69-.04.26-.23.57-.65.57h-2.98c-.59 0-1.14.28-1.47.77s-.39 1.11-.16 1.66l1.41 3.42c.07.22-.09.53-.37.63a.6.6 0 0 1-.17.03",
              clipRule: "evenodd"
            })]
          }),
          be = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#thumbs-up-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M11.75 19.02h2.74l-.02-.01c2.22 0 3.32-1.29 3.4-2.49.02-.24-.01-.46-.07-.67.15-.11.3-.25.42-.41.48-.62.59-1.49.29-2.22q-.06-.165-.15-.3c.08-.07.15-.15.22-.24.47-.62.58-1.48.28-2.2q-.15-.345-.39-.6c.3-.42.43-.95.35-1.52a2.123 2.123 0 0 0-2.14-1.85H13.7c-.13 0-.19-.07-.22-.11l-.003-.005c-.021-.042-.065-.13-.017-.245l1.43-3.48c.34-1.06-.24-2.21-1.28-2.56-.96-.33-2.03.1-2.48 1.01-1.37 2.73-2.67 4.32-3.71 5.59q-.227.277-.44.54H4c-.52 0-.959.239-1.296.559-.333.315-.598.737-.804 1.201-.414.93-.65 2.164-.65 3.49s.236 2.56.65 3.49c.206.464.472.886.804 1.202.337.32.777.558 1.296.558h3.5a.8.8 0 0 0 .193-.025c1.113.82 2.507 1.295 4.057 1.295m-5.5-2.77c-.787-1.116-1.24-2.503-1.24-4.04 0-1.478.339-2.516.897-3.46H4c-.034 0-.121.012-.263.147-.146.138-.311.374-.467.723-.31.696-.52 1.713-.52 2.88s.21 2.184.52 2.88c.156.35.321.585.467.723.142.135.23.147.263.147zM12.93 1.5a.54.54 0 0 0-.47.29c-1.44 2.88-2.8 4.54-3.89 5.87-1.34 1.63-2.07 2.53-2.07 4.55 0 2.57 1.84 5.31 5.24 5.31h2.74c1.34 0 1.87-.66 1.9-1.1 0-.08 0-.21-.09-.22a.754.754 0 0 1-.64-.85c.06-.41.44-.7.85-.64q.36.045.54-.18c.15-.19.19-.5.09-.73-.08-.2-.24-.3-.5-.34a.75.75 0 0 1-.66-.74v-.1a.74.74 0 0 1 .84-.65c.25.03.44-.03.56-.2.15-.19.18-.49.09-.71-.08-.19-.24-.3-.5-.33a.746.746 0 0 1-.65-.68c-.03-.35.19-.68.53-.78.5-.15.5-.54.48-.69-.04-.26-.23-.57-.65-.57h-2.98c-.59 0-1.14-.28-1.47-.77s-.39-1.11-.16-1.66l1.41-3.42c.07-.22-.09-.53-.37-.63a.6.6 0 0 0-.17-.03",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "thumbs-up-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          we = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.25 3.5a1.75 1.75 0 1 1 3.5 0v.25h-3.5zm5 0a3.25 3.25 0 0 0-6.5 0v.25H2a.75.75 0 0 0 0 1.5h1.25v12.083a2.417 2.417 0 0 0 2.417 2.417h8.666a2.417 2.417 0 0 0 2.417-2.417V5.25H18a.75.75 0 0 0 0-1.5h-4.75zm-8.5 13.833V5.25h10.5v12.083c0 .507-.41.917-.917.917H5.667a.917.917 0 0 1-.917-.917m6-9.333a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0zM7 7.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 7 7.25m6.75.75a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0z",
              clipRule: "evenodd"
            })]
          }),
          xe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.75 4a.75.75 0 0 0-1.5 0v7a4.75 4.75 0 1 0 9.5 0V4a.75.75 0 0 0-1.5 0v7a3.25 3.25 0 0 1-6.5 0zM3 17.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          De = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10.75 13a.75.75 0 0 1-1.5 0V4.844L7.537 6.6a.75.75 0 1 1-1.074-1.048L10 1.926l3.537 3.627a.75.75 0 1 1-1.074 1.048L10.75 4.844zm-8 0a.75.75 0 0 0-1.5 0v3c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 18.75 16v-3a.75.75 0 0 0-1.5 0v3a.25.25 0 0 1-.25.25H3a.25.25 0 0 1-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          Ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M19.527 14.966 11.999 2.419l-.932.559.932-.559c-.906-1.51-3.095-1.51-4.002 0L.47 14.966c-.933 1.555.187 3.534 2 3.534h15.057c1.814 0 2.934-1.979 2-3.534M9.998 6.25a.75.75 0 0 1 .75.75v4a.75.75 0 1 1-1.5 0V7a.75.75 0 0 1 .75-.75m0 9.25a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
              clipRule: "evenodd"
            })]
          }),
          Se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "m12.001 2.42 7.528 12.546c.933 1.555-.187 3.534-2.001 3.534H2.472C.658 18.5-.462 16.521.47 14.966L7.999 2.42c.907-1.51 3.096-1.51 4.002 0l-1.276.766zM1.757 15.737 9.286 3.19a.833.833 0 0 1 1.429 0l7.528 12.547A.833.833 0 0 1 17.528 17H2.472a.833.833 0 0 1-.715-1.262ZM10 6.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m-1.25 8a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0",
              clipRule: "evenodd"
            })]
          }),
          Ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10M7.53 6.47a.75.75 0 0 0-1.06 1.06L8.94 10l-2.47 2.47a.75.75 0 1 0 1.06 1.06L10 11.06l2.47 2.47a.75.75 0 0 0 1.06-1.06L11.06 10l2.47-2.47a.75.75 0 0 0-1.06-1.06L10 8.94z",
              clipRule: "evenodd"
            })]
          }),
          _e = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#x-circle-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M18.5 10a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10M7.53 6.47a.75.75 0 1 0-1.06 1.06L8.94 10l-2.47 2.47a.75.75 0 0 0 1.06 1.06L10 11.06l2.47 2.47a.75.75 0 0 0 1.06-1.06L11.06 10l2.47-2.47a.75.75 0 1 0-1.06-1.06L10 8.94z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "x-circle-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          }),
          Pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#x-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M16.894 3.106a.75.75 0 0 1 0 1.06L11.061 10l5.833 5.834a.75.75 0 0 1-1.06 1.06L10 11.061l-5.834 5.833a.75.75 0 1 1-1.06-1.06L8.939 10 3.106 4.166a.75.75 0 0 1 1.06-1.06L10 8.939l5.834-5.833a.75.75 0 0 1 1.06 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "x-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h20v20H0z"
                })
              })
            })]
          });
        t.TY = o, t.lO = i, t.mY = s, t.BN = u, t.QU = c, t.gq = p, t.KM = f, t.Ni = y, t.aM = b, t.rx = A, t.F3 = K, t.h3 = q, t.xP = H, t.V_ = G, t.pO = te, t.W1 = oe, t.Ad = xe, t.av = Ce, t.b0 = Pe;
      },
      99666: (e, t, n) => {
        "use strict";

        var r = n(85893),
          o = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M9.75 7a.75.75 0 0 0-1.5 0v2.25H6a.75.75 0 0 0 0 1.5h2.25V13a.75.75 0 0 0 1.5 0v-2.25H12a.75.75 0 0 0 0-1.5H9.75z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 3.25A2.75 2.75 0 0 0 2.25 6v12A2.75 2.75 0 0 0 5 20.75h9.172a2.75 2.75 0 0 0 1.73-.613 1 1 0 0 0 .14-.119l4.976-4.976q.068-.066.12-.14a2.75 2.75 0 0 0 .612-1.73V6A2.75 2.75 0 0 0 19 3.25zm11 10h4.247l.003-.078V6c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h9.172q.039 0 .078-.003V15c0-.966.784-1.75 1.75-1.75",
              clipRule: "evenodd"
            })]
          }),
          i = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M4 4.25a.75.75 0 0 0-.75.75v2.727a.75.75 0 1 0 1.5 0V5.75h5.5v13.5H8.2a.75.75 0 0 0 0 1.5h5.6a.75.75 0 0 0 0-1.5h-2.05V5.75h5.5v1.977a.75.75 0 0 0 1.5 0V5a.75.75 0 0 0-.75-.75zM20.75 17a.75.75 0 0 0-1.5 0v2.25H17a.75.75 0 0 0 0 1.5h2.25V23a.75.75 0 0 0 1.5 0v-2.25H23a.75.75 0 0 0 0-1.5h-2.25z"
            })]
          }),
          a = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.61 3.95a1.75 1.75 0 0 1 1.692-2.2H11.4c.646 0 1.24.356 1.544.926l3.435 6.442a.25.25 0 0 0 .221.132H21a2.75 2.75 0 1 1 0 5.5h-4.4a.25.25 0 0 0-.22.132l-3.436 6.441a1.75 1.75 0 0 1-1.544.927h-1.098a1.75 1.75 0 0 1-1.691-2.2l1.353-5.074a.25.25 0 0 0-.224-.314L4.675 14.3a.25.25 0 0 0-.25.157l-.477 1.193a1.75 1.75 0 0 1-1.625 1.1H2A1.75 1.75 0 0 1 .25 15V9c0-.966.784-1.75 1.75-1.75h.323a1.75 1.75 0 0 1 1.625 1.1l.477 1.193a.25.25 0 0 0 .25.157l5.065-.362a.25.25 0 0 0 .224-.314L8.61 3.951Zm1.692-.7a.25.25 0 0 0-.242.314l1.353 5.074a1.75 1.75 0 0 1-1.566 2.196l-5.065.362a1.75 1.75 0 0 1-1.75-1.096l-.477-1.193a.25.25 0 0 0-.232-.157H2a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25h.323a.25.25 0 0 0 .232-.157l.477-1.193a1.75 1.75 0 0 1 1.75-1.096l5.065.362a1.75 1.75 0 0 1 1.566 2.196l-1.353 5.074a.25.25 0 0 0 .242.314H11.4a.25.25 0 0 0 .22-.132l3.436-6.441a1.75 1.75 0 0 1 1.544-.927H21a1.25 1.25 0 1 0 0-2.5h-4.4a1.75 1.75 0 0 1-1.544-.926L11.62 3.382a.25.25 0 0 0-.221-.132h-1.098Z",
              clipRule: "evenodd"
            })]
          }),
          s = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.25 4a.75.75 0 0 1 1.5 0v10.156l1.713-1.757a.75.75 0 1 1 1.074 1.048L12 17.074l-3.537-3.627A.75.75 0 0 1 9.537 12.4l1.713 1.756zm9.25 16.25a.75.75 0 0 0 0-1.5h-17a.75.75 0 0 0 0 1.5z",
              clipRule: "evenodd"
            })]
          }),
          l = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 2.25a.75.75 0 0 1 .75.75v17a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75m7.53 6.22a.75.75 0 0 1 0 1.06l-1.22 1.22H23a.75.75 0 0 1 0 1.5h-4.69l1.22 1.22a.75.75 0 1 1-1.06 1.06l-3.03-3.03 3.03-3.03a.75.75 0 0 1 1.06 0M4.47 9.53a.75.75 0 0 1 1.06-1.06l3.03 3.03-3.03 3.03a.75.75 0 0 1-1.06-1.06l1.22-1.22H1a.75.75 0 0 1 0-1.5h4.69z"
            })]
          }),
          u = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.5 3.75a.75.75 0 0 0 0 1.5h17a.75.75 0 0 0 0-1.5zM12.75 20a.75.75 0 0 1-1.5 0V9.844L9.537 11.6a.75.75 0 1 1-1.074-1.048L12 6.926l3.537 3.627a.75.75 0 1 1-1.074 1.047L12.75 9.845z",
              clipRule: "evenodd"
            })]
          }),
          c = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.97 5.47a.75.75 0 0 1 1.06 0l1.22 1.22V2a.75.75 0 0 1 1.5 0v4.69l1.22-1.22a.75.75 0 1 1 1.06 1.06L12 9.56 8.97 6.53a.75.75 0 0 1 0-1.06M2.75 12a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1-.75-.75m7.28 6.53a.75.75 0 1 1-1.06-1.06L12 14.44l3.03 3.03a.75.75 0 1 1-1.06 1.06l-1.22-1.22V22a.75.75 0 0 1-1.5 0v-4.69z",
              clipRule: "evenodd"
            })]
          }),
          d = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#anonymous-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M14.115 1.104a3.15 3.15 0 0 1 4.72 1.381L20.94 7.6h1.56a.9.9 0 1 1 0 1.8h-21a.9.9 0 0 1 0-1.8h1.56l2.106-5.115a3.15 3.15 0 0 1 4.719-1.381l1.169.818a1.65 1.65 0 0 0 1.892 0l1.17-.818Zm3.333 1.952 1.87 4.544H4.683l1.87-4.544a1.65 1.65 0 0 1 2.473-.723l1.169.818a3.15 3.15 0 0 0 3.613 0l1.169-.818a1.65 1.65 0 0 1 2.472.723ZM3.75 10.75h16.5v1a4 4 0 0 1-7.969.5h-.562a4 4 0 0 1-7.969-.5zm1.55 1.5a2.5 2.5 0 0 0 4.9 0zm8.5 0a2.5 2.5 0 0 0 4.9 0zm-11.8 5a.75.75 0 0 0-.61 1.186l2.028 2.839-1.804 1.082a.75.75 0 1 0 .772 1.286l2.5-1.5a.75.75 0 0 0 .224-1.079L3.458 18.75h7.792V23a.75.75 0 0 0 1.5 0v-4.25h7.793l-1.653 2.314a.75.75 0 0 0 .224 1.08l2.5 1.5a.75.75 0 1 0 .772-1.287l-1.803-1.082 2.027-2.84A.75.75 0 0 0 22 17.25z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "anonymous-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          p = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M19.53 11.47a.75.75 0 0 0-1.06 0l-6.22 6.22V4.5a.75.75 0 0 0-1.5 0v13.19l-6.22-6.22a.75.75 0 0 0-1.06 1.06l8.03 8.03 8.03-8.03a.75.75 0 0 0 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          h = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15.25 2a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V3.81L2.53 22.53a.75.75 0 0 1-1.06-1.06L20.19 2.75H16a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          f = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.03 3.97a.75.75 0 0 1 0 1.06l-6.22 6.22H19a.75.75 0 0 1 0 1.5H5.81l6.22 6.22a.75.75 0 1 1-1.06 1.06L2.94 12l8.03-8.03a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          m = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.97 3.97a.75.75 0 0 1 1.06 0L20.06 12l-8.03 8.03a.75.75 0 1 1-1.06-1.06l6.22-6.22H4a.75.75 0 0 1 0-1.5h13.19l-6.22-6.22a.75.75 0 0 1 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          g = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.47 12.53a.75.75 0 0 0 1.06 0l6.22-6.22V19.5a.75.75 0 0 0 1.5 0V6.31l6.22 6.22a.75.75 0 1 0 1.06-1.06L11.5 3.44l-8.03 8.03a.75.75 0 0 0 0 1.06",
              clipRule: "evenodd"
            })]
          }),
          v = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.98 4.399a2.25 2.25 0 0 0-3.181 0l-8.84 8.838a3.75 3.75 0 1 0 5.304 5.304l6.717-6.718a.75.75 0 0 1 1.061 1.06l-6.717 6.718a5.25 5.25 0 0 1-7.425-7.424l8.839-8.84a3.75 3.75 0 0 1 5.303 5.304l-8.839 8.839a2.25 2.25 0 1 1-3.182-3.182l6.718-6.717a.75.75 0 1 1 1.06 1.06L8.082 15.36a.75.75 0 0 0 1.06 1.06l8.84-8.838a2.25 2.25 0 0 0 0-3.182Z",
              clipRule: "evenodd"
            })]
          }),
          y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m3-15a3 3 0 1 1-6 0 3 3 0 1 1 6 0m-9 7.5c0-1.995 3.998-3 6-3s6 1.005 6 3V18H6z",
              clipRule: "evenodd"
            })]
          }),
          b = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12 12a3 3 0 1 0 0-6 3 3 0 1 0 0 6m0 1.5c-2.002 0-6 1.005-6 3V18h12v-1.5c0-1.995-3.998-3-6-3",
              clipRule: "evenodd"
            })]
          }),
          w = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("mask", {
              id: "bin-icon_svg__a",
              fill: "#fff",
              children: r.jsx("path", {
                d: "M6 17V7h12v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2"
              })
            }), r.jsx("path", {
              fill: "currentColor",
              d: "M6 7V6H5v1zm12 0h1V6h-1zM5 7v10h2V7zm3 13h8v-2H8zm11-3V7h-2v10zM18 6H6v2h12zm-2 14a3 3 0 0 0 3-3h-2a1 1 0 0 1-1 1zM5 17a3 3 0 0 0 3 3v-2a1 1 0 0 1-1-1z",
              mask: "url(#bin-icon_svg__a)"
            }), r.jsx("path", {
              stroke: "currentColor",
              d: "M5.5 7V6a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5Z"
            }), r.jsx("path", {
              fill: "currentColor",
              d: "M11 5v-.5h-1V5zm.5-1h1V3h-1zm1.5.5V5h1v-.5zm-.5-.5a.5.5 0 0 1 .5.5h1A1.5 1.5 0 0 0 12.5 3zm-1.5.5a.5.5 0 0 1 .5-.5V3A1.5 1.5 0 0 0 10 4.5z"
            }), r.jsx("path", {
              stroke: "currentColor",
              d: "M9.5 10v6M12 10v6M14.5 10v6"
            })]
          }),
          x = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.5 3.5v12H7V8a1 1 0 0 1 1-1h7.5V3.5zM3 17h4v4a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1m17.5-8.5H17V16a1 1 0 0 1-1 1H8.5v3.5h12zm-5 1.94V8.5h-1.94zm0 2.06-.03.03-4-4 .03-.03H9.56l5.94 5.94zm-1.06 3L8.5 9.56v1.94l.03-.03 4 4-.03.03zm-4 0L8.5 13.56v1.94z",
              clipRule: "evenodd"
            })]
          }),
          D = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6 18.74c0 .696.564 1.26 1.26 1.26h5.79c3.321 0 5.357-1.586 5.357-4.221 0-1.8-1.028-3.172-2.871-3.579 1.543-.579 2.293-1.693 2.293-3.321C17.829 6.543 16.093 5 13.22 5H7.26A1.26 1.26 0 0 0 6 6.26zm3.6-7.89V8h2.807c1.136 0 1.757.557 1.757 1.393 0 .921-.685 1.457-1.693 1.457zm0 6.15v-3.15h3.171c1.286 0 1.993.6 1.993 1.564 0 1.029-.793 1.586-1.928 1.586z"
            })]
          }),
          C = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M9 1.25A2.75 2.75 0 0 0 6.25 4v18a.75.75 0 0 0 1.296.515L12 17.793l4.454 4.722A.75.75 0 0 0 17.75 22V4A2.75 2.75 0 0 0 15 1.25z"
            })]
          }),
          S = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9 2.75c-.69 0-1.25.56-1.25 1.25v16.112l3.704-3.927a.75.75 0 0 1 1.091 0l3.705 3.927V4c0-.69-.56-1.25-1.25-1.25zM6.25 4A2.75 2.75 0 0 1 9 1.25h6A2.75 2.75 0 0 1 17.75 4v18a.75.75 0 0 1-1.296.515L12 17.793l-4.454 4.722A.75.75 0 0 1 6.25 22z",
              clipRule: "evenodd"
            })]
          }),
          E = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.5 14.5v-11h11v11zM2 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm13 14.5a2.5 2.5 0 0 0 2.5-2.5V8H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3.5z",
              clipRule: "evenodd"
            })]
          }),
          _ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M4.5 6.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m5-2.25a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zm0 7a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zM8.75 19a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75M6 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
            })]
          }),
          P = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 5.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 2 5.25m8 0a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75m8.75.75a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0zM6 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 6 9.25m8.75.75a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0zM22 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75M15.584 21H8.416a.2.2 0 0 1-.156-.325l3.584-4.48a.2.2 0 0 1 .312 0l3.584 4.48a.2.2 0 0 1-.156.325",
              clipRule: "evenodd"
            })]
          }),
          k = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M18.53 8.22a.75.75 0 0 0-1.06 0L12 13.69 6.53 8.22a.75.75 0 0 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          A = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.5 4.75a.25.25 0 0 0-.25.25v5a6.75 6.75 0 0 1-6.75 6.75H2a.25.25 0 0 0-.25.25v1c0 .138.112.25.25.25h20a.25.25 0 0 0 .25-.25v-1a.25.25 0 0 0-.25-.25h-2.5A6.75 6.75 0 0 1 12.75 10V5a.25.25 0 0 0-.25-.25zM9.75 5c0-.966.784-1.75 1.75-1.75h1c.966 0 1.75.784 1.75 1.75v5c0 2.9 2.35 5.25 5.25 5.25H22c.966 0 1.75.784 1.75 1.75v1A1.75 1.75 0 0 1 22 19.75H2A1.75 1.75 0 0 1 .25 18v-1c0-.966.784-1.75 1.75-1.75h2.5c2.9 0 5.25-2.35 5.25-5.25z",
              clipRule: "evenodd"
            })]
          }),
          z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M15.53 18.53a.75.75 0 0 0 0-1.06L10.06 12l5.47-5.47a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 0 0 0 1.06l6 6a.75.75 0 0 0 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          T = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8.47 5.47a.75.75 0 0 0 0 1.06L13.94 12l-5.47 5.47a.75.75 0 1 0 1.06 1.06l6-6a.75.75 0 0 0 0-1.06l-6-6a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          O = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.47 15.28a.75.75 0 0 0 1.06 0L12 9.81l5.47 5.47a.75.75 0 1 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 0l-6 6a.75.75 0 0 0 0 1.06",
              clipRule: "evenodd"
            })]
          }),
          I = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m5.07-13.512a.75.75 0 0 0-1.14-.976l-5.422 6.326-1.932-2.318a.75.75 0 0 0-1.152.96l2.374 2.849a.917.917 0 0 0 1.4.01l5.872-6.85Z",
              clipRule: "evenodd"
            })]
          }),
          F = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M17.07 9.488a.75.75 0 0 0-1.14-.976l-5.422 6.326-1.932-2.318a.75.75 0 0 0-1.152.96l2.374 2.849a.917.917 0 0 0 1.4.01l5.872-6.85Z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          M = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M19.688 6.802a.75.75 0 0 1 0 1.06L9.332 18.219 4.47 13.355a.75.75 0 0 1 1.06-1.06l3.802 3.802 9.295-9.295a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          R = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3 6.57V3.43a.25.25 0 0 1 .374-.216L6.12 4.783a.25.25 0 0 1 0 .434l-2.746 1.57A.25.25 0 0 1 3 6.568Zm6.5-2.32a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zm0 7a.75.75 0 0 0 0 1.5h11a.75.75 0 0 0 0-1.5zM8.75 19a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5h-11a.75.75 0 0 1-.75-.75M3 20.57v-3.14a.25.25 0 0 1 .374-.216l2.746 1.569a.25.25 0 0 1 0 .434l-2.746 1.57A.25.25 0 0 1 3 20.568Zm0-10.14v3.14a.25.25 0 0 0 .374.216l2.746-1.569a.25.25 0 0 0 0-.434l-2.746-1.57a.25.25 0 0 0-.374.218Z"
            })]
          }),
          j = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.5 9.75a2.75 2.75 0 0 0-2.75 2.75.75.75 0 0 1-1.5 0 4.25 4.25 0 0 1 7-3.24A4.24 4.24 0 0 1 12 8.25a4.23 4.23 0 0 1 2.75 1.01 4.25 4.25 0 0 1 5.724 6.276.75.75 0 1 1-1.05-1.072 2.75 2.75 0 0 0-3.72-4.048 4.23 4.23 0 0 1 .546 2.084 4.24 4.24 0 0 1-1.275 3.036.75.75 0 1 1-1.05-1.072c.51-.5.825-1.194.825-1.964 0-.612-.2-1.177-.538-1.634a.8.8 0 0 1-.104-.132A2.74 2.74 0 0 0 12 9.75c-.686 0-1.313.25-1.795.666a4.23 4.23 0 0 1 .545 2.084 4.24 4.24 0 0 1-1.276 3.036.75.75 0 1 1-1.05-1.072c.51-.5.826-1.194.826-1.964 0-.572-.175-1.103-.474-1.543l-.005-.004a.75.75 0 0 1-.229-.294A2.74 2.74 0 0 0 6.5 9.75"
            })]
          }),
          B = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M19.53 15.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 1 1 1.06 1.06L16.06 12zM4.47 8.53a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06L7.94 12z"
            })]
          }),
          N = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 3.25A2.75 2.75 0 0 0 2.25 6v10A2.75 2.75 0 0 0 5 18.75h1.25V22a.75.75 0 0 0 1.248.56l4.287-3.81H19A2.75 2.75 0 0 0 21.75 16V6A2.75 2.75 0 0 0 19 3.25zM3.75 6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-7.5a.75.75 0 0 0-.498.19L7.75 20.33V18a.75.75 0 0 0-.75-.75H5c-.69 0-1.25-.56-1.25-1.25zM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
              clipRule: "evenodd"
            })]
          }),
          L = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.5 19.75A1.75 1.75 0 0 0 11.25 18v-3h-1.5v3a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25V6A.25.25 0 0 1 2 5.75h7.5a.25.25 0 0 1 .25.25v3h1.5V6A1.75 1.75 0 0 0 9.5 4.25H2A1.75 1.75 0 0 0 .25 6v12c0 .966.784 1.75 1.75 1.75zM12.75 6c0-.966.784-1.75 1.75-1.75H22c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 22 19.75h-7.5A1.75 1.75 0 0 1 12.75 18v-3h1.5v3c0 .138.112.25.25.25H22a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v3h-1.5zM7.53 8.47a.75.75 0 0 1 0 1.06l-1.72 1.72h12.38l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H5.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          V = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4 1.25A2.75 2.75 0 0 0 1.25 4v11A2.75 2.75 0 0 0 4 17.75h2.25V20A2.75 2.75 0 0 0 9 22.75h11A2.75 2.75 0 0 0 22.75 20V9A2.75 2.75 0 0 0 20 6.25h-2.25V4A2.75 2.75 0 0 0 15 1.25zm12.25 5V4c0-.69-.56-1.25-1.25-1.25H4c-.69 0-1.25.56-1.25 1.25v11c0 .69.56 1.25 1.25 1.25h2.25V9A2.75 2.75 0 0 1 9 6.25zM7.75 20c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25H9c-.69 0-1.25.56-1.25 1.25z",
              clipRule: "evenodd"
            })]
          }),
          K = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.5 2A1.5 1.5 0 0 1 9 .5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 22.5 6v12a1.5 1.5 0 0 1-1.5 1.5h-3V18h3V6h-3a1 1 0 0 1-1-1V2H9v1H7.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 4.5A1.5 1.5 0 0 0 1.5 6v16A1.5 1.5 0 0 0 3 23.5h12a1.5 1.5 0 0 0 1.5-1.5V10a1.5 1.5 0 0 0-.44-1.06l-4-4A1.5 1.5 0 0 0 11 4.5zM3 6v16h12V10h-3a1 1 0 0 1-1-1V6z",
              clipRule: "evenodd"
            })]
          }),
          q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7 3a.75.75 0 0 0-1.5 0v13.5c0 .966.784 1.75 1.75 1.75H16v-1.5H7.25A.25.25 0 0 1 7 16.5zm10.5 17.5a.75.75 0 0 0 1.5 0V7a1.75 1.75 0 0 0-1.75-1.75H8.5v1.5h8.75a.25.25 0 0 1 .25.25zm5.5-2.25h-2.5v-1.5H23a.75.75 0 0 1 0 1.5m-19-13H1a.75.75 0 0 0 0 1.5h3z",
              clipRule: "evenodd"
            })]
          }),
          H = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.405 5.75a3.001 3.001 0 0 1-5.81 0H2a.75.75 0 0 1 0-1.5h2.595a3.001 3.001 0 0 1 5.81 0H22a.75.75 0 0 1 0 1.5zM9 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-7 6.25a.75.75 0 0 0 0 1.5h12.595a3.001 3.001 0 0 0 5.81 0H22a.75.75 0 0 0 0-1.5h-1.595a3.001 3.001 0 0 0-5.81 0zm15.5 2.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1.25 19a.75.75 0 0 1 .75-.75h3.595a3.001 3.001 0 0 1 5.81 0H22a.75.75 0 0 1 0 1.5H11.405a3.001 3.001 0 0 1-5.81 0H2a.75.75 0 0 1-.75-.75M10 19a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
              clipRule: "evenodd"
            })]
          }),
          U = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.925 8.746A4.001 4.001 0 0 0 .671 5.464a4 4 0 0 0 6.516 4.588l1.765 1.019c.094-.51.243-1.006.44-1.478zm-1.624-.032a2.5 2.5 0 1 0-4.33-2.5 2.5 2.5 0 0 0 4.33 2.5",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M12.45 16.555a4.1 4.1 0 0 1-1.22-1.077l1.315-.76c.185.211.406.394.655.538l5.306 3.063a1.25 1.25 0 0 0 1.18.038l1.016-.502-6.794-3.923 1.5-.866 8.471 4.891-3.529 1.745a2.75 2.75 0 0 1-2.594-.084z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.344 12.018a5.75 5.75 0 0 1 2.863-4.61l4.55-2.626a2.75 2.75 0 0 1 2.593-.084l3.53 1.745-15.955 9.21a4.001 4.001 0 0 1-7.254 3.283 4 4 0 0 1 6.516-4.588l3.122-1.803zm1.556-.391 8.802-5.082-1.017-.502a1.25 1.25 0 0 0-1.179.038l-4.55 2.627a4.25 4.25 0 0 0-2.056 2.919m-5.6 4.059a2.5 2.5 0 1 1-4.33 2.5 2.5 2.5 0 0 1 4.33-2.5",
              clipRule: "evenodd"
            })]
          }),
          Z = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.667 3.092a.75.75 0 0 1 .09.838A8.6 8.6 0 0 0 9.75 8c0 4.597 3.51 8.25 7.75 8.25 1.137 0 2.216-.26 3.19-.729a.75.75 0 0 1 .992 1.018A9.75 9.75 0 0 1 13 21.85c-5.385 0-9.75-4.366-9.75-9.75 0-4.286 2.764-7.923 6.604-9.232a.75.75 0 0 1 .813.225Zm-1.992 1.98a8.25 8.25 0 1 0 10.478 12.523 9 9 0 0 1-1.653.155c-5.148 0-9.25-4.406-9.25-9.75 0-1.02.149-2.003.425-2.929Z",
              clipRule: "evenodd"
            })]
          }),
          $ = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M17.25 15a1.25 1.25 0 1 1-2.124-.893 3.251 3.251 0 0 0-5.549-1.273.75.75 0 1 1-1.117-1 4.752 4.752 0 0 1 8.166 2.085c.373.215.624.619.624 1.081m-10.5 0a1.25 1.25 0 1 1 2.124.893 3.251 3.251 0 0 0 5.549 1.273.75.75 0 1 1 1.117 1 4.752 4.752 0 0 1-8.167-2.085A1.25 1.25 0 0 1 6.75 15"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 4.5A1.5 1.5 0 0 0 .5 6v15A1.5 1.5 0 0 0 2 22.5h20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 22 4.5h-2.25V2a.75.75 0 0 0-1.5 0v2.5H5.75V2a.75.75 0 0 0-1.5 0v2.5zM2 9h20v12H2z",
              clipRule: "evenodd"
            })]
          }),
          G = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.75 2a.75.75 0 0 0-1.5 0v2.5H2A1.5 1.5 0 0 0 .5 6v15A1.5 1.5 0 0 0 2 22.5h20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 22 4.5h-2.25V2a.75.75 0 0 0-1.5 0v2.5H5.75zM2 9v12h20V9z",
              clipRule: "evenodd"
            })]
          }),
          W = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.75 5.25h.337c.643 0 1.163.52 1.163 1.163v4.24c0 .507.308.963.778 1.15a2.74 2.74 0 0 1 1.722 2.543v5.246a4.16 4.16 0 0 1-4.158 4.158H7.408a4.16 4.16 0 0 1-4.158-4.158v-5.246c0-1.12.682-2.127 1.721-2.542a1.24 1.24 0 0 0 .779-1.15V6.413c0-.642.52-1.163 1.163-1.163h.337V1.5C7.25.81 7.81.25 8.5.25h3c.69 0 1.25.56 1.25 1.25v.25h.75a1.25 1.25 0 1 1 0 2.5h-.75zm-4-3.5v3.5h2.5v-3.5zm5.722 11.446a2.74 2.74 0 0 1-1.722-2.542V6.75h-5.5v3.904c0 1.12-.682 2.127-1.721 2.542a1.24 1.24 0 0 0-.779 1.15v5.246a2.66 2.66 0 0 0 2.658 2.658h5.184a2.66 2.66 0 0 0 2.658-2.658v-5.246c0-.506-.308-.962-.778-1.15",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M16.97 3.97a.75.75 0 0 1 1.06 0l.5.5c.26.26.68.26.94 0a2.164 2.164 0 0 1 3.06 0l.5.5a.75.75 0 0 1-1.06 1.06l-.5-.5a.664.664 0 0 0-.94 0 2.164 2.164 0 0 1-3.06 0l-.5-.5a.75.75 0 0 1 0-1.06m1.06-3a.75.75 0 1 0-1.06 1.06l.5.5a2.164 2.164 0 0 0 3.06 0c.26-.26.68-.26.94 0l.5.5a.75.75 0 1 0 1.06-1.06l-.5-.5a2.164 2.164 0 0 0-3.06 0c-.26.26-.68.26-.94 0z"
            })]
          }),
          Y = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1zM18 5.25a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5zm0 4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5zm-6 4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          X = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M2.5 3A1.5 1.5 0 0 1 4 1.5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 17.5 7v1.776a4.7 4.7 0 0 0-1.5.414V7h-3a1 1 0 0 1-1-1V3H4v16h7.5v1.5H4A1.5 1.5 0 0 1 2.5 19z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.75 15v-1.5a3.25 3.25 0 0 1 6.5 0V15H22a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm1.5-1.5a1.75 1.75 0 1 1 3.5 0V15h-3.5zm-1.75 8v-5h7v5z",
              clipRule: "evenodd"
            })]
          }),
          Q = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M9.834 12.912v1.435h1.134c.595 0 .917-.3.917-.728 0-.413-.322-.707-.917-.707zm4.744.028v3.22h.791c1.008 0 1.673-.693 1.673-1.61s-.665-1.61-1.673-1.61z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M20.75 10V6.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22H5A1.75 1.75 0 0 0 3.25 2v20c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 20.75 22v-3H23a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1zM5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25v-3H8a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h11.25V7.25H14.5a.75.75 0 0 1-.75-.75V1.75zM9.834 17h-.98v-4.9h2.212c1.127 0 1.799.651 1.799 1.526 0 .89-.707 1.54-1.799 1.54H9.834zm5.668 0h-1.897v-4.9h1.897c1.484 0 2.52 1.078 2.52 2.45S16.986 17 15.502 17m3.332 0h.98v-1.995h2.422v-.854h-2.422v-1.197h2.52V12.1h-3.5z",
              clipRule: "evenodd"
            })]
          }),
          J = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 2.25a.75.75 0 0 1 .75.75v13.19l2.72-2.72a.75.75 0 1 1 1.06 1.06L12 19.06l-4.53-4.53a.75.75 0 1 1 1.06-1.06l2.72 2.72V3a.75.75 0 0 1 .75-.75m-9 14a.75.75 0 0 1 .75.75v3c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-3a.75.75 0 0 1 1.5 0v3A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-3a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            })]
          }),
          ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7 9a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m0 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m6.5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m5-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-6.5-6a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M20 9a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
              clipRule: "evenodd"
            })]
          }),
          te = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M15.25 11.5a.75.75 0 0 0-1.5 0v2.25H11.5a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25h2.25a.75.75 0 0 0 0-1.5h-2.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.25 4A2.75 2.75 0 0 1 4 1.25h11A2.75 2.75 0 0 1 17.75 4v2.25H20A2.75 2.75 0 0 1 22.75 9v11A2.75 2.75 0 0 1 20 22.75H9A2.75 2.75 0 0 1 6.25 20v-2.25H4A2.75 2.75 0 0 1 1.25 15zm15 0v2.25H9A2.75 2.75 0 0 0 6.25 9v7.25H4c-.69 0-1.25-.56-1.25-1.25V4c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25m-8.5 16V9c0-.69.56-1.25 1.25-1.25h11c.69 0 1.25.56 1.25 1.25v11c0 .69-.56 1.25-1.25 1.25H9c-.69 0-1.25-.56-1.25-1.25",
              clipRule: "evenodd"
            })]
          }),
          ne = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M19.445 4.384a2.75 2.75 0 0 0-3.89 0L2.764 17.177a1.75 1.75 0 0 0-.513 1.237v3.336h4.336c.464 0 .909-.184 1.237-.513L20.116 8.945a2.75 2.75 0 0 0 0-3.89zm-2.829 1.06a1.25 1.25 0 0 1 1.768 0l.671.672a1.25 1.25 0 0 1 0 1.768L17.5 9.439 15.06 7l1.556-1.555ZM14 8.062l2.44 2.439-9.677 9.677a.25.25 0 0 1-.177.073H3.75v-1.836a.25.25 0 0 1 .073-.177z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M23 21.75H9.432l1.5-1.5H23a.75.75 0 0 1 0 1.5"
            })]
          }),
          re = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3.5 6H2V2h4v1.5H3.5zm2.75 2A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8m0 4a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75M7 15.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM18 2v1.5h2.5V6H22V2zM3.5 18H2v4h4v-1.5H3.5zM18 22v-1.5h2.5V18H22v4zm-9 0v-1.5h6V22zM9 2v1.5h6V2zM2 9h1.5v6H2zm20 0h-1.5v6H22z"
            })]
          }),
          oe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.5 2A1.5 1.5 0 0 1 4 .5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 17.5 6v.366a4 4 0 0 0-.293.266L16 7.84V6h-3a1 1 0 0 1-1-1V2H4v16h2.093c-.22.463-.325.979-.298 1.5H4A1.5 1.5 0 0 1 2.5 18zm20.363 6.782a2.48 2.48 0 0 1 0 3.507L12.32 22.833a1.62 1.62 0 0 1-1.142.473H7.25V19.38c0-.428.17-.839.473-1.142L18.267 7.693a2.48 2.48 0 0 1 3.507 0l1.09 1.09Zm-1.06 2.446a.98.98 0 0 0 0-1.385l-1.09-1.09a.98.98 0 0 0-1.385 0l-1.075 1.075 2.475 2.475zm-2.136 2.136-2.475-2.475-8.408 8.409a.12.12 0 0 0-.034.081v2.427h2.427a.12.12 0 0 0 .082-.033z",
              clipRule: "evenodd"
            })]
          }),
          ie = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15.556 3.384a2.75 2.75 0 0 1 3.889 0l1.171 1.171a2.75 2.75 0 0 1 0 3.89L7.823 21.237a1.75 1.75 0 0 1-1.237.513H2.25v-4.336c0-.464.184-.909.513-1.237zm2.828 1.06a1.25 1.25 0 0 0-1.768 0L15.061 6 18 8.94l1.555-1.556a1.25 1.25 0 0 0 0-1.768zM16.939 10 14 7.06 3.823 17.238a.25.25 0 0 0-.073.177v2.836h2.836a.25.25 0 0 0 .177-.073z",
              clipRule: "evenodd"
            })]
          }),
          ae = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.02 5.97a.75.75 0 0 0 0 1.06l4.95 4.95a.75.75 0 0 0 1.06 0l4.95-4.95a.75.75 0 0 0 0-1.06l-4.95-4.95a.75.75 0 0 0-1.06 0zm5.48 4.42L13.61 6.5l3.89-3.89 3.889 3.89-3.89 3.89ZM3 2.25a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75zm.75 7v-5.5h5.5v5.5zM2.25 14a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75zm1.5.75v5.5h5.5v-5.5zM14 13.25a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75zm.75 7v-5.5h5.5v5.5z",
              clipRule: "evenodd"
            })]
          }),
          se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2.003 2.889a8.5 8.5 0 0 1-9.492 5.48zm.367-1.367-11.23 6.483a8.5 8.5 0 0 1-2.92-1.778l14.073-8.125a8.5 8.5 0 0 1 .077 3.42m-.366-4.408L5.504 17.482a8.5 8.5 0 0 1-1.502-2.597l14.494-8.368a8.5 8.5 0 0 1 1.502 2.597m-2.212-3.341L3.713 13.898a8.5 8.5 0 0 1-.077-3.42l11.229-6.483a8.5 8.5 0 0 1 2.92 1.778ZM13.495 3.63a8.5 8.5 0 0 0-9.491 5.48z",
              clipRule: "evenodd"
            })]
          }),
          le = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 26 26",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.021 2.148a3.6 3.6 0 0 1 1.487-1.136 3.6 3.6 0 0 1 1.38-.262 3.45 3.45 0 0 1 2.846 1.414 3.6 3.6 0 0 1 2.585-.146 3.61 3.61 0 0 1 2.486 3.05 3.67 3.67 0 0 1 2.663 1.713 3.49 3.49 0 0 1 .173 3.189 3.56 3.56 0 0 1 1.2 1.538c.178.438.266.908.26 1.381a3.45 3.45 0 0 1-1.479 2.886 3.62 3.62 0 0 1-2.835 4.99 3.62 3.62 0 0 1-4.982 2.926 3.56 3.56 0 0 1-1.504 1.145 3.55 3.55 0 0 1-1.39.254 3.62 3.62 0 0 1-2.89-1.464 3.67 3.67 0 0 1-3.179-.203l-.003-.001a3.61 3.61 0 0 1-1.787-2.64 3.62 3.62 0 0 1-2.894-4.976A3.57 3.57 0 0 1 .75 12.92a3.46 3.46 0 0 1 1.453-2.87 3.67 3.67 0 0 1 .182-3.206l.004-.006a3.61 3.61 0 0 1 2.68-1.792l.012-.085a3.62 3.62 0 0 1 4.94-2.813m2.885.102a1.95 1.95 0 0 1 1.618.8 3.6 3.6 0 0 0-.445.619.75.75 0 1 0 1.303.742q.181-.316.453-.551a.8.8 0 0 0 .166-.13 2.11 2.11 0 0 1 3.308 1.458 3.7 3.7 0 0 0-.754.317.75.75 0 1 0 .732 1.31 2.17 2.17 0 0 1 2.892.733 1.99 1.99 0 0 1 .09 1.815 3.6 3.6 0 0 0-.795-.073.75.75 0 0 0 .032 1.5 2.05 2.05 0 0 1 2.095 2.115 1.95 1.95 0 0 1-.835 1.638 3.6 3.6 0 0 0-.595-.453.75.75 0 0 0-.781 1.28 2.12 2.12 0 0 1-.743 3.9 3.6 3.6 0 0 0-.316-.723.75.75 0 1 0-1.3.746c.134.235.222.492.26.757q0 .072.014.141a2.123 2.123 0 0 1-1.946 2.27 2.1 2.1 0 0 1-.917-.13 3.6 3.6 0 0 0 .089-.854.75.75 0 0 0-1.5.027 2.05 2.05 0 0 1-2.094 2.086h-.014a2.12 2.12 0 0 1-1.654-.801 3.7 3.7 0 0 0 .488-.622.75.75 0 0 0-1.273-.794 2.17 2.17 0 0 1-2.903.744 2.11 2.11 0 0 1-1.03-1.462 3.6 3.6 0 0 0 .752-.324.75.75 0 0 0-.746-1.302 2.1 2.1 0 0 1-.648.242.75.75 0 0 0-.398.04 2.13 2.13 0 0 1-1.56-.676 2.12 2.12 0 0 1-.432-2.193q.422.095.855.088a.75.75 0 0 0-.027-1.5 2.06 2.06 0 0 1-2.097-2.124 1.96 1.96 0 0 1 .803-1.619q.269.257.59.459a.75.75 0 1 0 .795-1.272 2.17 2.17 0 0 1-.745-2.895 2.11 2.11 0 0 1 1.5-1.036q.119.396.327.76a.75.75 0 0 0 1.3-.746 2.12 2.12 0 0 1 2.561-3.048 3.6 3.6 0 0 0-.09.864.75.75 0 1 0 1.5-.026 2.06 2.06 0 0 1 2.115-2.097",
              clipRule: "evenodd"
            })]
          }),
          ue = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "m21.878 13.565-1.482-.233a8.6 8.6 0 0 0 0-2.664l1.482-.233a10 10 0 0 1 0 3.13m-.54-5.15-1.4.538a8.5 8.5 0 0 0-1.331-2.302l1.165-.944a10 10 0 0 1 1.566 2.708m-3.045-4.187-.944 1.165a8.5 8.5 0 0 0-2.302-1.331l.538-1.4c.988.38 1.9.911 2.708 1.566m-4.728-2.106-.233 1.482a8.6 8.6 0 0 0-2.664 0l-.233-1.482a10 10 0 0 1 3.13 0m-5.15.54.538 1.4a8.5 8.5 0 0 0-2.302 1.331l-.944-1.165a10 10 0 0 1 2.708-1.566M4.228 5.707l1.165.944a8.5 8.5 0 0 0-1.331 2.302l-1.4-.538a10 10 0 0 1 1.566-2.708m-2.106 4.728a10 10 0 0 0 0 3.13l1.482-.233a8.6 8.6 0 0 1 0-2.664zm.54 5.15 1.4-.538a8.5 8.5 0 0 0 1.331 2.302l-1.165.944a10 10 0 0 1-1.566-2.708m3.045 4.187.944-1.165a8.5 8.5 0 0 0 2.302 1.331l-.538 1.4a10 10 0 0 1-2.708-1.566m4.728 2.106.233-1.482a8.6 8.6 0 0 0 2.664 0l.233 1.482a10 10 0 0 1-3.13 0m5.15-.54-.538-1.4a8.5 8.5 0 0 0 2.302-1.331l.944 1.165a10 10 0 0 1-2.708 1.566m4.187-3.045-1.165-.944a8.5 8.5 0 0 0 1.331-2.302l1.4.538c-.38.988-.911 1.9-1.566 2.708",
              clipRule: "evenodd"
            })]
          }),
          ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17m0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
              clipRule: "evenodd"
            })]
          }),
          de = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.707 13.748a.75.75 0 0 0-1.413.504A6.05 6.05 0 0 0 12 18.25a6.05 6.05 0 0 0 5.707-3.998.75.75 0 0 0-1.413-.504A4.55 4.55 0 0 1 12 16.75a4.55 4.55 0 0 1-4.293-3.002M10 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.994 22H5.499l-3.535-3.535a3 3 0 0 1 0-4.243L13.984 2.2a1 1 0 0 1 1.415 0l6.364 6.364a1 1 0 0 1 0 1.414L9.743 22zm-3.672-9.016 5.657 5.657L9.12 20.5h-3l-3.096-3.096a1.5 1.5 0 0 1 0-2.121zm6.718 4.597-5.657-5.657 8.309-8.309 5.656 5.657z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "m11.864 22 1.5-1.5H18a.75.75 0 1 1 0 1.5zm8.386-.75a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75"
            })]
          }),
          he = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m4.03-13.97a.75.75 0 0 0-1.06-1.06l-7 7a.75.75 0 1 0 1.06 1.06z",
              clipRule: "evenodd"
            })]
          }),
          fe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M21.5 12a9.5 9.5 0 0 1-9.5 9.5 9.46 9.46 0 0 1-6.166-2.273L19.227 5.834A9.46 9.46 0 0 1 21.5 12M4.773 18.166 18.166 4.773A9.46 9.46 0 0 0 12 2.5 9.5 9.5 0 0 0 2.5 12c0 2.353.856 4.507 2.273 6.166M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11",
              clipRule: "evenodd"
            })]
          }),
          me = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11M12 6.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V7a.75.75 0 0 1 .75-.75m0 11.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5",
              clipRule: "evenodd"
            })]
          }),
          ge = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.53 15.47a.75.75 0 1 1-1.06 1.06l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L5.06 12zm6.94-6.94a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L18.94 12z"
            })]
          }),
          ve = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.53 8.53a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L12 5.06zm6.94 6.94a.75.75 0 1 1 1.06 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 1 1 1.06-1.06L12 18.94z"
            })]
          }),
          ye = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 19v-3.5h1.5v3h11v-11h-3V8H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1",
              clipRule: "evenodd"
            })]
          }),
          be = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.25 3A.75.75 0 0 1 3 2.25h18a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.22.53l-6.78 6.78V22a.75.75 0 0 1-1.2.6l-4-3a.75.75 0 0 1-.3-.6v-5.69L2.47 6.53A.75.75 0 0 1 2.25 6zm1.5.75v1.94l6.78 6.78c.141.14.22.331.22.53v5.625l2.5 1.875V13a.75.75 0 0 1 .22-.53l6.78-6.78V3.75z",
              clipRule: "evenodd"
            })]
          }),
          we = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#fit-to-height-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M12 .25a.75.75 0 0 1 .75.75v4.19l1.72-1.72a.75.75 0 1 1 1.06 1.06L12 8.06 8.47 4.53a.75.75 0 0 1 1.06-1.06l1.72 1.72V1A.75.75 0 0 1 12 .25"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M21 8.5a2.5 2.5 0 0 1 2.5 2.5v2a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 13v-2A2.5 2.5 0 0 1 3 8.5zM3 10a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M11.25 23a.75.75 0 0 0 1.5 0v-4.19l1.72 1.72a.75.75 0 1 0 1.06-1.06L12 15.94l-3.53 3.53a.75.75 0 1 0 1.06 1.06l1.72-1.72z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "fit-to-height-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          xe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.25 6A2.75 2.75 0 0 1 4 3.25h4.276a2.75 2.75 0 0 1 1.76.637l1.888 1.573c.225.187.508.29.8.29H20a2.75 2.75 0 0 1 2.75 2.75V18A2.75 2.75 0 0 1 20 20.75H4A2.75 2.75 0 0 1 1.25 18zm1.5 0c0-.69.56-1.25 1.25-1.25h4.276c.292 0 .575.103.8.29l1.888 1.573a2.75 2.75 0 0 0 1.76.637H20c.69 0 1.25.56 1.25 1.25v.75H2.75zm18.5 4.75V18c0 .69-.56 1.25-1.25 1.25H4c-.69 0-1.25-.56-1.25-1.25v-7.25z",
              clipRule: "evenodd"
            })]
          }),
          De = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M1 3.25a.75.75 0 0 0 0 1.5h5.25V15a.75.75 0 0 0 1.5 0V4.75H13a.75.75 0 0 0 0-1.5zm21.75 7h-11.5V14a.75.75 0 0 0 1.5 0v-2.25h3.5v8.5H14.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-1.75v-8.5h3.5V14a.75.75 0 0 0 1.5 0z"
            })]
          }),
          Ce = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.69 5.705a.75.75 0 0 0-1.38 0l-6 14a.75.75 0 0 0 1.38.59l2.376-5.545h5.868l2.377 5.545a.75.75 0 0 0 1.379-.59zm1.601 7.545-2.29-5.346-2.292 5.346zM5.2 10.728a.75.75 0 0 0-1.399 0l-3.5 9a.75.75 0 1 0 1.398.544l.787-2.022h4.029l.786 2.022a.75.75 0 0 0 1.398-.544l-3.5-9Zm-.7 2.341 1.432 3.681H3.069z",
              clipRule: "evenodd"
            })]
          }),
          Se = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M22 6.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5M2 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M8.274 15.112c-1.68 0-2.84-1.304-2.84-2.912s1.16-2.912 2.84-2.912 2.84 1.304 2.84 2.912-1.16 2.912-2.84 2.912m0-1.2c.976 0 1.464-.888 1.464-1.712s-.488-1.712-1.464-1.712-1.464.888-1.464 1.712.488 1.712 1.464 1.712M12.754 15V9.4h1.376v2.136L16.178 9.4h1.664l-2.056 2.184L17.922 15H16.33l-1.528-2.48-.672.72V15z"
            })]
          }),
          Ee = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M16.53 10.03a.75.75 0 1 0-1.06-1.06L11 13.44l-1.97-1.97a.75.75 0 0 0-1.06 1.06l2.382 2.383a.917.917 0 0 0 1.296 0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-.5h12a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5",
              clipRule: "evenodd"
            })]
          }),
          _e = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M5 8.25a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V9A.75.75 0 0 1 5 8.25m9.207 2.25h5.586a.5.5 0 0 1 .353.854l-2.793 2.792a.5.5 0 0 1-.707 0l-2.793-2.792a.5.5 0 0 1 .354-.854"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm20 1.5H2a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5",
              clipRule: "evenodd"
            })]
          }),
          Pe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M19 17.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-5.5 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.25 1a.75.75 0 0 0-1.5 0v1.5H4A3.5 3.5 0 0 0 .5 6v13A3.5 3.5 0 0 0 4 22.5h16a3.5 3.5 0 0 0 3.5-3.5V6A3.5 3.5 0 0 0 20 2.5h-1.75V1a.75.75 0 0 0-1.5 0v1.5h-9.5zm-1.5 3v2a.75.75 0 0 0 1.5 0V4h9.5v2a.75.75 0 0 0 1.5 0V4H20a2 2 0 0 1 2 2v1.75H2V6a2 2 0 0 1 2-2zM2 19V9.25h20V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2",
              clipRule: "evenodd"
            })]
          }),
          ke = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M19.75 7a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75M19 17.75a.75.75 0 0 0 0-1.5h-9a.75.75 0 0 0 0 1.5zm.75-5.75a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75M5.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M7 17a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1.5-3.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm20 1.5H2a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5",
              clipRule: "evenodd"
            })]
          }),
          Ae = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M6 16a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2zm1.5 0a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 .25A1.75 1.75 0 0 0 3.25 2v20c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 20.75 22V6.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22zM4.75 2A.25.25 0 0 1 5 1.75h8.75V6.5c0 .414.336.75.75.75h4.75V22a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          ze = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-1.5 0a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0",
              clipRule: "evenodd"
            })]
          }),
          Te = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.337 19H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.351c-.2.698-.42 1.353-.655 1.936-.293.73-.624 1.386-.993 1.872-.341.45-.856.942-1.546.942-.816 0-1.29-.637-1.536-1.145-.264-.545-.419-1.235-.503-1.905a11 11 0 0 1-.079-1.7M2 6.5h20a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-8.964a35 35 0 0 0 .378-1.872c.164-.947.288-1.902.361-2.806a13 13 0 0 1 1.573-.884l.056.143.128.325c.114.284.264.63.454.911.161.24.517.683 1.105.683 1.035 0 1.89-.59 2.49-1.386.6-.797 1.003-1.862 1.162-3.011a.75.75 0 1 0-1.486-.206c-.132.95-.457 1.76-.874 2.314-.37.49-.768.73-1.145.78l-.008-.011a3.7 3.7 0 0 1-.307-.636l-.098-.248a12 12 0 0 0-.228-.557 2 2 0 0 0-.224-.392c-.062-.083-.304-.397-.737-.397a.8.8 0 0 0-.27.05 12 12 0 0 0-1.517.723q-.003-.377-.023-.724c-.044-.734-.155-1.422-.382-1.95-.223-.52-.667-1.099-1.444-1.099-.52 0-1.215.217-1.9.486-.718.282-1.539.67-2.358 1.1-1.623.853-3.322 1.917-4.239 2.727a.75.75 0 1 0 .994 1.124c.78-.69 2.353-1.688 3.943-2.523a23 23 0 0 1 2.21-1.032c.646-.255 1.088-.368 1.31-.38a.7.7 0 0 1 .106.188c.125.292.222.776.262 1.449.03.48.027 1.023-.002 1.609-.524.377-1.03.785-1.506 1.207-1.358 1.207-2.527 2.596-3.131 3.843a2.6 2.6 0 0 0-.163.452H2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5M11.084 19c-.152.496-.314.96-.482 1.377-.27.675-.543 1.192-.796 1.526-.183.24-.299.315-.343.337-.035-.027-.104-.102-.194-.288-.162-.335-.29-.842-.364-1.439A10 10 0 0 1 8.838 19zm.41-1.5H9.142c.518-.964 1.48-2.113 2.675-3.174q.158-.14.32-.278a32 32 0 0 1-.643 3.452m.442-8.77s.006.002.016.012q-.016-.009-.016-.011ZM9.488 22.257s-.003 0-.008-.003q.008.002.008.003m7.811-9.69-.01-.01z",
              clipRule: "evenodd"
            })]
          }),
          Oe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.25 2A.75.75 0 0 1 9 1.25c1.227 0 2.316.589 3 1.5a3.74 3.74 0 0 1 3-1.5.75.75 0 0 1 0 1.5A2.25 2.25 0 0 0 12.75 5H22a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.25v.002A2.25 2.25 0 0 0 15 21.25a.75.75 0 0 1 0 1.5 3.74 3.74 0 0 1-3-1.5 3.74 3.74 0 0 1-3 1.5.75.75 0 0 1 0-1.5A2.25 2.25 0 0 0 11.25 19H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h9.25A2.25 2.25 0 0 0 9 2.75.75.75 0 0 1 8.25 2M2 6.5h9.25v4.75h-1.5a.75.75 0 0 0 0 1.5h1.5v4.75H2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5m10.75 6.25v4.75H22a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5h-9.25v4.75h1.5a.75.75 0 0 1 0 1.5z",
              clipRule: "evenodd"
            })]
          }),
          Ie = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8M12 24a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-1.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
              clipRule: "evenodd"
            })]
          }),
          Fe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              fillRule: "evenodd",
              clipPath: "url(#group-icon_svg__a)",
              clipRule: "evenodd",
              children: [r.jsx("path", {
                d: "M11.25 5a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-6.25V19a.75.75 0 0 1-.75.75H5a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75h6.25zm1.5.75v5.5h5.5v-5.5zm-7 7v5.5h5.5v-5.5z"
              }), r.jsx("path", {
                d: "M1.25 3.855A2 2 0 1 1 3.855 1.25h16.29a2 2 0 1 1 2.605 2.605v16.29a2 2 0 1 1-2.605 2.605H3.855a2 2 0 1 1-2.605-2.605zm20 16.29a2 2 0 0 0-1.105 1.105H3.855a2 2 0 0 0-1.105-1.105V3.855A2 2 0 0 0 3.855 2.75h16.29a2 2 0 0 0 1.105 1.105z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "group-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Me = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 6A.75.75 0 0 1 5 5.25h14a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 6m0 6a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75M5 17.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          Re = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.75 3.5a2.25 2.25 0 0 1 4.256-1.02A2.25 2.25 0 0 1 17.25 4.5v.878a2.25 2.25 0 0 1 3 2.122V16a6.75 6.75 0 0 1-6.75 6.75h-1.115a6.75 6.75 0 0 1-4.634-1.843l-5.92-5.59a2.55 2.55 0 0 1 3.43-3.773l1.489 1.303V6a2.25 2.25 0 0 1 3-2.122zm1.5 7.5a.75.75 0 0 1-1.5 0V6a.75.75 0 0 0-1.5 0v7.735c0 .942-1.11 1.446-1.82.825l-2.157-1.887a1.05 1.05 0 0 0-1.412 1.553l5.92 5.59a5.25 5.25 0 0 0 3.604 1.434H13.5c2.9 0 5.25-2.35 5.25-5.25V7.5a.75.75 0 0 0-1.5 0V11a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 0-1.5 0V11a.75.75 0 0 1-1.5 0V3.5a.75.75 0 0 0-1.5 0z",
              clipRule: "evenodd"
            })]
          }),
          je = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.807 2.302c2.647.375 4.943 2.717 4.943 6.146 0 1.554-.718 3.156-1.686 4.63-.977 1.488-2.267 2.931-3.537 4.185a48 48 0 0 1-5.057 4.322l-.023.017-.008.006L12 21c-.438.609-.439.608-.439.608l-.002-.001-.006-.005-.023-.017-.088-.064a48 48 0 0 1-1.476-1.146 49 49 0 0 1-3.492-3.102c-1.27-1.25-2.56-2.686-3.537-4.164-.967-1.462-1.687-3.052-1.687-4.59 0-3.46 2.29-5.821 4.94-6.207a5.22 5.22 0 0 1 3.907 1.002c.749.56 1.4 1.335 1.903 2.329.504-.994 1.154-1.77 1.902-2.33a5.24 5.24 0 0 1 3.905-1.01ZM12 21l-.439.608a.75.75 0 0 0 .877 0zm0-.935a47 47 0 0 1-4.474-3.86c-1.23-1.212-2.44-2.566-3.338-3.923C3.28 10.909 2.75 9.619 2.75 8.519c0-2.746 1.774-4.449 3.657-4.723a3.72 3.72 0 0 1 2.793.72c.861.644 1.639 1.752 2.073 3.473a.75.75 0 0 0 1.454 0c.434-1.721 1.212-2.83 2.074-3.474a3.74 3.74 0 0 1 2.795-.727c1.886.267 3.654 1.955 3.654 4.66 0 1.12-.532 2.424-1.44 3.806-.897 1.366-2.107 2.727-3.337 3.942A47 47 0 0 1 12 20.065",
              clipRule: "evenodd"
            })]
          }),
          Be = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M21.53 3.53a.75.75 0 0 0-1.06-1.06l-18 18a.75.75 0 1 0 1.06 1.06zM12 4.25c1.364 0 2.643.29 3.815.753l-1.173 1.173A8.6 8.6 0 0 0 12 5.75c-2.937 0-5.513 1.608-7.405 3.308A20.3 20.3 0 0 0 1.918 12a20.3 20.3 0 0 0 2.677 2.942q.332.299.691.59L4.22 16.598a19 19 0 0 1-.627-.54A21.8 21.8 0 0 1 .6 12.739a13 13 0 0 1-.21-.302l-.013-.018-.004-.005v-.002S.372 12.41 1 12l-.627-.411.001-.003.004-.005.012-.018.044-.066q.058-.083.167-.236a21.8 21.8 0 0 1 2.992-3.319C5.596 6.142 8.52 4.25 12 4.25"
            }), r.jsx("path", {
              d: "m1 12-.627.41-.27-.41.27-.411zm11-5c.547 0 1.074.088 1.567.25l-1.262 1.263a3.5 3.5 0 0 0-3.792 3.792l-1.262 1.262A5 5 0 0 1 12 7m4.75 3.433-1.263 1.262a3.5 3.5 0 0 1-3.792 3.792l-1.262 1.262a5 5 0 0 0 6.317-6.317Z"
            }), r.jsx("path", {
              d: "M12 18.25c-.92 0-1.803-.158-2.642-.426l-1.173 1.173c1.172.462 2.45.753 3.815.753 3.48 0 6.404-1.892 8.407-3.692a21.8 21.8 0 0 0 2.992-3.319q.109-.151.167-.236l.03-.044.014-.022.012-.018.004-.005v-.002S23.628 12.41 23 12l.627.41.27-.41-.27-.41L23 12l.627-.41v-.002l-.001-.002-.004-.005-.012-.018a19 19 0 0 0-.843-1.128 22 22 0 0 0-2.36-2.493q-.3-.27-.627-.54l-1.066 1.066q.36.291.691.59A20.3 20.3 0 0 1 22.082 12a20.3 20.3 0 0 1-2.677 2.942c-1.892 1.7-4.468 3.308-7.405 3.308"
            })]
          }),
          Ne = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8.5v17a8.5 8.5 0 0 0 0-17",
              clipRule: "evenodd"
            })]
          }),
          Le = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4 2.5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-13a3 3 0 0 0-3-3zm3 3.75a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H17a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          Ve = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.55 2.4a.75.75 0 0 1 .9 0l8 6a.75.75 0 0 1 .3.6v12a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 .3-.6zm7.7 6.975L12 3.938 4.75 9.375V20.25h4.5V16a2.75 2.75 0 1 1 5.5 0v4.25h4.5zm-6 10.875V16a1.25 1.25 0 1 0-2.5 0v4.25z",
              clipRule: "evenodd"
            })]
          }),
          Ke = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#horizontal-scroll-icon_svg__a)",
              children: r.jsx("path", {
                d: "m24.06 12-.522.523-.015.015-2.993 2.992a.75.75 0 1 1-1.06-1.06l1.72-1.72H17a.75.75 0 0 1 0-1.5h4.19l-1.72-1.72a.75.75 0 0 1 1.06-1.06l2.992 2.992.01.009.006.006.523.523ZM.478 11.462 3.47 8.47a.75.75 0 0 1 1.06 1.06l-1.72 1.72H7a.75.75 0 0 1 0 1.5H2.81l1.72 1.72a.75.75 0 1 1-1.06 1.06L.477 12.538l-.015-.015L-.061 12l.523-.523zM10.5 12a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "horizontal-scroll-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          qe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.5 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 18v-2l.03-.03-.03-.03V6a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2M21 5.5H3a.5.5 0 0 0-.5.5v10.44l3.47-3.47a.75.75 0 0 1 1.06 0l2.47 2.47 5.97-5.97a.75.75 0 0 1 1.06 0l4.97 4.97V6a.5.5 0 0 0-.5-.5m-18 13a.5.5 0 0 1-.322-.117L6.5 14.56l2.47 2.47a.75.75 0 0 0 1.06 0L16 11.06l5.5 5.5V18a.5.5 0 0 1-.5.5z",
              clipRule: "evenodd"
            })]
          }),
          He = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m1-15.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m-3.5 3.5a.75.75 0 0 0 0 1.5h1.75v4H9.5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-1.75v-5.5z",
              clipRule: "evenodd"
            })]
          }),
          Ue = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M9.75 7a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-1.901l-2.16 9.5H13a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h1.901l2.16-9.5H10.5A.75.75 0 0 1 9.75 7"
            })]
          }),
          Ze = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.752.292a.75.75 0 0 1 .496 0l10 3.5a.75.75 0 0 1 0 1.416L17.128 7l5.12 1.792a.75.75 0 0 1 0 1.416L17.128 12l5.12 1.792a.75.75 0 0 1 0 1.416l-10 3.5a.75.75 0 0 1-.496 0l-10-3.5a.75.75 0 0 1 0-1.416L6.87 12l-5.118-1.792a.75.75 0 0 1 0-1.416L6.87 7 1.752 5.208a.75.75 0 0 1 0-1.416zm.495 8.416 2.613-.913L19.73 9.5 12 12.206 4.27 9.5l4.87-1.705 2.612.913a.75.75 0 0 0 .495 0M4.27 4.5 12 7.205 19.73 4.5 12 1.795z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "m3 24-3-5h6z"
            })]
          }),
          $e = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.248.292a.75.75 0 0 0-.496 0l-10 3.5a.75.75 0 0 0 0 1.416L6.87 7 1.752 8.792a.75.75 0 0 0 0 1.416L6.872 12l-5.12 1.792a.75.75 0 0 0 0 1.416l10 3.5a.75.75 0 0 0 .496 0l10-3.5a.75.75 0 0 0 0-1.416L17.128 12l5.12-1.792a.75.75 0 0 0 0-1.416L17.128 7l5.12-1.792a.75.75 0 0 0 0-1.416zM4.27 4.5 12 1.795 19.73 4.5 12 7.205zm7.482 9.208-2.61-.913L4.27 14.5 12 17.205l7.73-2.705-4.873-1.705-2.61.913a.75.75 0 0 1-.495 0",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "m0 19 3 5 3-5z"
            })]
          }),
          Ge = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3 0 0 5h6z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m6.873 12-5.12-1.792a.75.75 0 0 1 0-1.416l10-3.5a.75.75 0 0 1 .495 0l10 3.5a.75.75 0 0 1 0 1.416L17.128 12l5.12 1.792a.75.75 0 0 1 0 1.416L17.128 17l5.12 1.792a.75.75 0 0 1 0 1.416l-10 3.5a.75.75 0 0 1-.496 0l-10-3.5a.75.75 0 0 1 0-1.416L6.87 17l-5.118-1.792a.75.75 0 0 1 0-1.416L6.872 12Zm2.27.795L4.27 14.5 12 17.206l7.73-2.706-4.873-1.705-2.61.913a.75.75 0 0 1-.495 0zm-.003 5 2.612.913a.75.75 0 0 0 .495 0l2.613-.913 4.87 1.705L12 22.205 4.27 19.5z",
              clipRule: "evenodd"
            })]
          }),
          We = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3 0 0 5h6z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.752 5.292a.75.75 0 0 1 .496 0l10 3.5a.75.75 0 0 1 0 1.416L17.128 12l5.12 1.792a.75.75 0 0 1 0 1.416L17.128 17l5.12 1.792a.75.75 0 0 1 0 1.416l-10 3.5a.75.75 0 0 1-.496 0l-10-3.5a.75.75 0 0 1 0-1.416L6.872 17l-5.12-1.792a.75.75 0 0 1 0-1.416L6.87 12l-5.118-1.792a.75.75 0 0 1 0-1.416zM4.27 9.5 12 12.206 19.73 9.5 12 6.795zm4.873 8.295 2.61.913a.75.75 0 0 0 .495 0l2.61-.913L19.73 19.5 12 22.205 4.27 19.5z",
              clipRule: "evenodd"
            })]
          }),
          Ye = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.248 3.292a.75.75 0 0 0-.496 0l-10 3.5a.75.75 0 0 0 0 1.416L6.874 10l-5.122 1.793a.75.75 0 0 0 0 1.416L6.87 15l-5.117 1.792a.75.75 0 0 0 0 1.416l10 3.5a.75.75 0 0 0 .496 0l10-3.5a.75.75 0 0 0 0-1.416L17.13 15l5.118-1.791a.75.75 0 0 0 0-1.416L17.126 10l5.122-1.792a.75.75 0 0 0 0-1.416zm2.608 7.503-2.608.913a.75.75 0 0 1-.496 0l-2.608-.913-4.874 1.706 5.086 1.78.032.011 2.612.914 7.73-2.705zM12 10.205 4.27 7.5 12 4.795 19.73 7.5zm-.248 6.504-2.613-.914L4.27 17.5 12 20.205l7.73-2.705-4.87-1.705-2.612.914a.75.75 0 0 1-.495 0Z",
              clipRule: "evenodd"
            })]
          }),
          Xe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.25 20.25V22c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 20.75 22V6.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22H5A1.75 1.75 0 0 0 3.25 2v1.75H1.5a.75.75 0 0 0 0 1.5h1.75v3.5H1.5a.75.75 0 0 0 0 1.5h1.75v3.5H1.5a.75.75 0 0 0 0 1.5h1.75v3.5H1.5a.75.75 0 0 0 0 1.5zM5 1.75a.25.25 0 0 0-.25.25v1.75H6.5a.75.75 0 0 1 0 1.5H4.75v3.5H6.5a.75.75 0 0 1 0 1.5H4.75v3.5H6.5a.75.75 0 0 1 0 1.5H4.75v3.5H6.5a.75.75 0 0 1 0 1.5H4.75V22c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V7.25H14.5a.75.75 0 0 1-.75-.75V1.75z",
              clipRule: "evenodd"
            })]
          }),
          Qe = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.25 2a.75.75 0 0 1 1.5 0v4.25H21a.75.75 0 0 1 0 1.5H3.75V12a.75.75 0 0 1-1.5 0zm14.28 9.47a.75.75 0 1 0-1.06 1.06l3.72 3.72H3a.75.75 0 0 0 0 1.5h16.19l-3.72 3.72a.75.75 0 1 0 1.06 1.06L22.06 17z",
              clipRule: "evenodd"
            })]
          }),
          Je = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M22.53 1.47a.75.75 0 0 1 0 1.06l-20 20a.75.75 0 0 1-1.06-1.06l20-20a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          et = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.53 9.03a.75.75 0 0 1-1.06 0L6.25 7.81v8.88l1.22-1.22a.75.75 0 0 1 1.06 1.06L5.5 19.56l-3.03-3.03a.75.75 0 0 1 1.06-1.06l1.22 1.22V7.81L3.53 9.03a.75.75 0 0 1-1.06-1.06L5.5 4.94l3.03 3.03a.75.75 0 0 1 0 1.06M21 7.75a.75.75 0 0 0 0-1.5h-9a.75.75 0 0 0 0 1.5zm.75 4.25a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75m0 5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h9a.75.75 0 0 1 .75.75"
            })]
          }),
          tt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 5.75h1.579v-1.5H2zm3.684 0h1.58v-1.5h-1.58zm3.684 0h1.58v-1.5h-1.58zm3.685 0h1.579v-1.5h-1.58zm3.684 0h1.579v-1.5h-1.58zm3.684 0H22v-1.5h-1.579zm-1.421 7h3v-1.5h-3zm-17 7h20v-1.5H2zm15-7h-4v-1.5h4zm-10 0h4v-1.5H7zm-2 0H2v-1.5h3z",
              clipRule: "evenodd"
            })]
          }),
          nt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M22 5.5H2v-1h20zm0 6.5H2v-2h20zM2 19.5h20v-3H2z",
              clipRule: "evenodd"
            })]
          }),
          rt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.834 11.677a.75.75 0 0 1-1.06-1.06l2.12-2.122a2.25 2.25 0 0 0 0-3.182l-.706-.707a2.25 2.25 0 0 0-3.182 0l-4.243 4.242a2.25 2.25 0 0 0 0 3.182l.354.354a.75.75 0 0 1-1.061 1.06l-.354-.353a3.75 3.75 0 0 1 0-5.303l4.243-4.243a3.75 3.75 0 0 1 5.303 0l.707.707a3.75 3.75 0 0 1 0 5.303zm-11.667-.354a.75.75 0 0 1 1.06 1.06l-2.12 2.122a2.25 2.25 0 0 0 0 3.182l.706.707a2.25 2.25 0 0 0 3.182 0l4.243-4.242a2.25 2.25 0 0 0 0-3.182l-.354-.354a.75.75 0 0 1 1.061-1.06l.354.353a3.75 3.75 0 0 1 0 5.303l-4.243 4.243a3.75 3.75 0 0 1-5.303 0l-.707-.707a3.75 3.75 0 0 1 0-5.303z",
              clipRule: "evenodd"
            })]
          }),
          ot = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7.25 6a4.75 4.75 0 0 1 9.5 0v3H18a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h1.25zm8 0v3h-6.5V6a3.25 3.25 0 0 1 6.5 0m-1.75 8.5a1.5 1.5 0 0 1-.75 1.3V18a.75.75 0 0 1-1.5 0v-2.2a1.5 1.5 0 1 1 2.25-1.3",
              clipRule: "evenodd"
            })]
          }),
          it = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 15.8a1.5 1.5 0 1 0-1.5 0V18a.75.75 0 0 0 1.5 0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 1.25A4.75 4.75 0 0 0 7.25 6v3H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1.25V6A4.75 4.75 0 0 0 12 1.25M15.25 9V6a3.25 3.25 0 0 0-6.5 0v3zM4.5 12A1.5 1.5 0 0 1 6 10.5h12a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 20z",
              clipRule: "evenodd"
            })]
          }),
          at = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.693 1.315c-.115-.801-1.272-.801-1.386 0l-.25 1.743-1.742.249c-.801.115-.801 1.271 0 1.386l1.743.249.249 1.743c.114.801 1.271.801 1.386 0l.249-1.743 1.742-.249c.802-.114.802-1.271 0-1.386l-1.742-.249zm-7 10c-.115-.801-1.272-.801-1.386 0l-.25 1.743-1.742.249c-.801.114-.801 1.271 0 1.386l1.743.249.249 1.743c.114.801 1.271.801 1.386 0l.249-1.743 1.742-.249c.802-.114.802-1.271 0-1.386l-1.742-.249-.25-1.743Zm14 5c-.115-.801-1.272-.801-1.386 0l-.25 1.743-1.742.249c-.801.115-.802 1.271 0 1.386l1.743.249.249 1.743c.114.801 1.271.801 1.386 0l.249-1.743 1.742-.249c.802-.115.802-1.271 0-1.386l-1.742-.249-.25-1.743ZM20 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-8 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M4 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m5 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
            })]
          }),
          st = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#magic-pen-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M12.964 1a.964.964 0 1 0-1.929 0v4a.964.964 0 1 0 1.929 0z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "m9.731 9.646-.086.086a2.5 2.5 0 0 0 0 3.536l9.586 9.585a2.5 2.5 0 0 0 3.535 0l.086-.085a2.5 2.5 0 0 0 0-3.536l-9.585-9.586a2.5 2.5 0 0 0-3.536 0m1.06 1.061-.085.086a1 1 0 0 0 0 1.414l9.586 9.586a1 1 0 0 0 1.414 0l.086-.086a1 1 0 0 0 0-1.414l-9.586-9.586a1 1 0 0 0-1.414 0Z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M12 18.036c.532 0 .964.431.964.964v4a.964.964 0 1 1-1.929 0v-4c0-.533.432-.964.964-.964Zm11-5.072a.964.964 0 1 0 0-1.928h-4a.964.964 0 0 0 0 1.928zM5.964 12a.964.964 0 0 1-.965.964H1a.964.964 0 1 1 0-1.928h4c.533 0 .965.431.965.964ZM20.46 4.904a.964.964 0 0 0-1.365-1.364l-2.592 2.593a.964.964 0 1 0 1.363 1.363zm-12.965 11.6a.964.964 0 0 1 0 1.363L4.902 20.46a.964.964 0 1 1-1.363-1.364l2.592-2.592a.964.964 0 0 1 1.364 0M6.132 7.496a.964.964 0 1 0 1.364-1.363L4.903 3.54a.964.964 0 0 0-1.364 1.364z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "magic-pen-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          lt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 3.5h18A2.5 2.5 0 0 1 23.5 6v11a2.5 2.5 0 0 1-2.5 2.5H3A2.5 2.5 0 0 1 .5 17V6A2.5 2.5 0 0 1 3 3.5M2 16.94V6.06l5.44 5.44zM3.06 18h17.88l-5.44-5.44-.848.849a3.75 3.75 0 0 1-5.304 0l-.848-.848zm13.5-6.5L22 16.94V6.06zM3.06 5h17.88l-7.349 7.348a2.25 2.25 0 0 1-3.182 0z",
              clipRule: "evenodd"
            })]
          }),
          ut = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.358 12.58c-.456.464-.9.916-1.328 1.343a.75.75 0 1 1-1.06-1.06c.405-.406.833-.842 1.28-1.296 1.72-1.75 3.694-3.761 5.556-5.24 1.17-.928 2.36-1.704 3.474-2.061 1.139-.366 2.329-.325 3.25.596.537.537.746 1.184.651 1.867-.087.63-.422 1.226-.823 1.761-.732.98-1.893 2.019-2.999 3.008l-.296.265c-1.237 1.111-2.357 2.152-2.972 3.106-.303.47-.435.849-.444 1.148-.008.265.077.539.383.845.165.165.314.21.484.203.207-.009.494-.1.875-.32.77-.449 1.64-1.255 2.6-2.15l.044-.043c.904-.843 1.891-1.765 2.824-2.308.48-.278 1.013-.5 1.567-.523a2.1 2.1 0 0 1 1.606.641c.365.365.573.797.603 1.276.03.457-.108.882-.29 1.246-.343.686-.963 1.374-1.492 1.962l-.043.048c-.587.651-1.067 1.195-1.31 1.678-.114.23-.14.382-.134.48.005.076.031.175.166.31.172.172.526.298 1.3-.034.751-.322 1.673-.999 2.64-1.966a.75.75 0 1 1 1.06 1.06c-1.033 1.034-2.111 1.857-3.11 2.285-.976.419-2.122.544-2.95-.284-.365-.365-.573-.797-.603-1.276-.03-.457.108-.882.29-1.246.343-.686.963-1.374 1.492-1.962l.043-.048c.587-.651 1.067-1.194 1.309-1.678.115-.229.141-.382.135-.48-.005-.076-.031-.175-.166-.31-.165-.165-.314-.21-.484-.203-.207.009-.494.1-.875.32-.77.449-1.64 1.255-2.6 2.15l-.044.043c-.904.843-1.891 1.765-2.824 2.308-.48.278-1.013.5-1.567.523a2.1 2.1 0 0 1-1.606-.641c-.569-.569-.844-1.232-.822-1.95.02-.683.306-1.332.682-1.917.745-1.155 2.032-2.333 3.232-3.41l.262-.235c1.147-1.027 2.195-1.967 2.833-2.82.342-.456.503-.809.538-1.068.029-.205-.012-.387-.225-.6-.383-.383-.907-.494-1.731-.229-.85.273-1.87.91-3 1.808-1.781 1.414-3.666 3.332-5.381 5.077Z",
              clipRule: "evenodd"
            })]
          }),
          ct = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M.5 4H2V2h2V.5H2A1.5 1.5 0 0 0 .5 2zm23 0H22V2h-2V.5h2A1.5 1.5 0 0 1 23.5 2zm0 3H22v3.5h1.5zm0 6.5H22V17h1.5zM.5 7H2v3.5H.5zm0 6.5H2V17H.5zm0 6.5H2v2h2v1.5H2A1.5 1.5 0 0 1 .5 22zM7 23.5V22h3.5v1.5zm6.5 0V22H17v1.5zM17 .5V2h-3.5V.5zm-6.5 0V2H7V.5zM12 8.75a.75.75 0 0 1 .75.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H9.5a.75.75 0 0 1 0-1.5h1.75V9.5a.75.75 0 0 1 .75-.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.807 16.747a7.5 7.5 0 1 0-1.06 1.06l4.723 4.723a.75.75 0 1 0 1.06-1.06zM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0",
              clipRule: "evenodd"
            })]
          }),
          dt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M.75 5.25A.75.75 0 0 1 1.5 6v5.996l4.466-4.523a.75.75 0 1 1 1.068 1.054l-2.69 2.723h15.311l-2.689-2.723a.75.75 0 1 1 1.068-1.054l4.466 4.523V6A.75.75 0 0 1 24 6v12a.75.75 0 0 1-1.5 0v-5.996l-4.466 4.523a.75.75 0 0 1-1.067-1.054l2.689-2.723H4.345l2.689 2.723a.75.75 0 0 1-1.068 1.054L1.5 12.004V18A.75.75 0 0 1 0 18V6a.75.75 0 0 1 .75-.75"
            })]
          }),
          pt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#mentions-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M12 .45C5.621.45.45 5.621.45 12S5.621 23.55 12 23.55h6a.75.75 0 0 0 0-1.5h-6c-5.55 0-10.05-4.5-10.05-10.05S6.45 1.95 12 1.95h1.638a8.41 8.41 0 0 1 8.412 8.412V14.1a2.55 2.55 0 0 1-5.1 0V6a.75.75 0 0 0-1.5 0v1.426a5.25 5.25 0 0 0-9 3.674v1.8a5.25 5.25 0 0 0 9.479 3.112A4.05 4.05 0 0 0 23.55 14.1v-3.738c0-5.474-4.438-9.912-9.912-9.912zm3.45 12.45v-1.8a3.75 3.75 0 1 0-7.5 0v1.8a3.75 3.75 0 0 0 7.5 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "mentions-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          ht = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M11.25 12A8.25 8.25 0 0 0 3 3.75H2a.75.75 0 0 1 0-1.5h1a9.75 9.75 0 0 1 9 5.993 9.75 9.75 0 0 1 9-5.993h1a.75.75 0 0 1 0 1.5h-1A8.25 8.25 0 0 0 12.75 12v7.19l2.72-2.72a.75.75 0 1 1 1.06 1.06L12 22.06l-4.53-4.53a.75.75 0 1 1 1.06-1.06l2.72 2.72z"
            })]
          }),
          ft = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.25 4A2.75 2.75 0 0 1 4 1.25h16A2.75 2.75 0 0 1 22.75 4v12A2.75 2.75 0 0 1 20 18.75h-7.21l-5.285 4.805A.75.75 0 0 1 6.25 23v-4.25H4A2.75 2.75 0 0 1 1.25 16zM4 2.75c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25h3a.75.75 0 0 1 .75.75v3.305l4.245-3.86a.75.75 0 0 1 .505-.195H20c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25z",
              clipRule: "evenodd"
            })]
          }),
          mt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 12a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          gt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M8 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m9.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          vt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3",
              clipRule: "evenodd"
            })]
          }),
          yt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m-1.5 5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0"
            })]
          }),
          bt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#move-all-directions-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "m12 .94 3.53 3.53a.75.75 0 0 1-1.06 1.06l-1.72-1.72v7.44h7.44l-1.72-1.72a.75.75 0 0 1 1.06-1.06L23.06 12l-3.53 3.53a.75.75 0 1 1-1.06-1.06l1.72-1.72h-7.44v7.44l1.72-1.72a.75.75 0 1 1 1.06 1.06L12 23.06l-3.53-3.53a.75.75 0 1 1 1.06-1.06l1.72 1.72v-7.44H3.81l1.72 1.72a.75.75 0 1 1-1.06 1.06L.94 12l3.53-3.53a.75.75 0 0 1 1.06 1.06l-1.72 1.72h7.44V3.81L9.53 5.53a.75.75 0 0 1-1.06-1.06z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "move-all-directions-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          wt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M18 7.25a.75.75 0 0 0-.75.75v3.25H7.81l2.72-2.72a.75.75 0 0 0-1.06-1.06L4.94 12l4.53 4.53a.75.75 0 1 0 1.06-1.06l-2.72-2.72h9.44V16a.75.75 0 0 0 1.5 0V8a.75.75 0 0 0-.75-.75",
              clipRule: "evenodd"
            })]
          }),
          xt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M18.53 7.47a.75.75 0 1 0-1.06 1.06l2.72 2.72H3.81l2.72-2.72a.75.75 0 1 0-1.06-1.06L.94 12l4.53 4.53a.75.75 0 0 0 1.06-1.06l-2.72-2.72h16.38l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23.06 12z"
            })]
          }),
          Dt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 7.25a.75.75 0 0 1 .75.75v3.25h9.44l-2.72-2.72a.75.75 0 0 1 1.06-1.06L19.06 12l-4.53 4.53a.75.75 0 1 1-1.06-1.06l2.72-2.72H6.75V16a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 6 7.25",
              clipRule: "evenodd"
            })]
          }),
          Ct = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#multiple-pages-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M10.5 2A1.5 1.5 0 0 1 12 .5h6a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 23.5 6v10a1.5 1.5 0 0 1-1.5 1.5H12a1.5 1.5 0 0 1-1.5-1.5zM12 16V2h6v3a1 1 0 0 0 1 1h3v10zM7 3.5h2V5H7v14h11.5a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 19V5A1.5 1.5 0 0 1 7 3.5m-5 3h2V8H2v14h11.5a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 22V8A1.5 1.5 0 0 1 2 6.5",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "multiple-pages-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          St = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.22 3.28a.75.75 0 0 1 1.06-1.06l18 18a.75.75 0 1 1-1.06 1.06l-6.47-6.47-6.177 6.177a1.75 1.75 0 0 1-1.237.513H2v-4.336c0-.464.184-.909.513-1.237L8.689 9.75zm7.53 7.53-6.177 6.177a.25.25 0 0 0-.073.177V20h2.836a.25.25 0 0 0 .177-.073l6.176-6.177zm9.445-7.676a2.75 2.75 0 0 0-3.89 0L10.72 7.72l1.06 1.06 1.97-1.97 2.94 2.94-1.97 1.97 1.06 1.06 4.586-4.585a2.75 2.75 0 0 0 0-3.89zM17.75 8.689 14.81 5.75l1.556-1.555a1.25 1.25 0 0 1 1.768 0l1.171 1.171a1.25 1.25 0 0 1 0 1.768z",
              clipRule: "evenodd"
            })]
          }),
          Et = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.25 9A.75.75 0 0 1 8 8.25h8a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 9M8 12.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v10A2.75 2.75 0 0 1 19 18.75h-3.08c-.365 0-.712.16-.95.436L13.4 21.02a1.75 1.75 0 0 1-2.752-.122l-1.16-1.623a1.25 1.25 0 0 0-1.017-.524H5A2.75 2.75 0 0 1 2.25 16zM5 4.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h3.47a2.75 2.75 0 0 1 2.239 1.152l1.16 1.623a.25.25 0 0 0 .393.018l1.57-1.833a2.75 2.75 0 0 1 2.088-.96H19c.69 0 1.25-.56 1.25-1.25V6c0-.69-.56-1.25-1.25-1.25z",
              clipRule: "evenodd"
            })]
          }),
          _t = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.25 9A.75.75 0 0 1 7 8.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 9M7 12.25a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.25 6A2.75 2.75 0 0 1 5 3.25h14A2.75 2.75 0 0 1 21.75 6v7.172a2.75 2.75 0 0 1-.613 1.73 1 1 0 0 1-.119.14l-4.976 4.976a1 1 0 0 1-.14.12 2.75 2.75 0 0 1-1.73.612H5A2.75 2.75 0 0 1 2.25 18zm17.997 7.25H16A1.75 1.75 0 0 0 14.25 15v4.247l-.078.003H5c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v7.172q0 .039-.003.078",
              clipRule: "evenodd"
            })]
          }),
          Pt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3.5 6H2V2h4v1.5H3.5zM7 7.25a.75.75 0 0 0 0 1.5h4.25V17a.75.75 0 0 0 1.5 0V8.75H17a.75.75 0 0 0 0-1.5zM18 2v1.5h2.5V6H22V2zM3.5 18H2v4h4v-1.5H3.5zM18 22v-1.5h2.5V18H22v4z"
            })]
          }),
          kt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.5 12c0 5.799 4.701 10.5 10.5 10.5S22.5 17.799 22.5 12 17.799 1.5 12 1.5 1.5 6.201 1.5 12M3 12a9 9 0 0 1 9-9h.005v18h.019H12a9 9 0 0 1-9-9m10.505 8.875a9 9 0 0 0 1.49-.385V3.51a9 9 0 0 0-1.49-.385zM16.495 4.2v15.598a9 9 0 0 0 1.5-1.086V5.287a9 9 0 0 0-1.5-1.086Zm3 2.814v9.97A8.96 8.96 0 0 0 21 12a8.96 8.96 0 0 0-1.505-4.985Z",
              clipRule: "evenodd"
            })]
          }),
          At = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.25 2c0-.966.784-1.75 1.75-1.75h9.5a.75.75 0 0 1 .53.22l5.5 5.5c.141.14.22.331.22.53V22A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22zM5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V7.25H14.5a.75.75 0 0 1-.75-.75V1.75z",
              clipRule: "evenodd"
            })]
          }),
          zt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.25 4c0-.968.784-1.747 1.747-1.751 3.193-.014 6.301-.164 9.677-1.673 1.14-.51 2.576.259 2.576 1.62v.054H19c.966 0 1.75.784 1.75 1.75v18A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22zm12.036-2.054a.35.35 0 0 1 .327.022.26.26 0 0 1 .137.229v16.685c0 .072-.03.124-.07.157-3.026 2.412-7.087 3.1-10.701 3.198a.22.22 0 0 1-.172-.078A.25.25 0 0 1 4.75 22V4c0-.137.111-.25.253-.251 3.234-.014 6.607-.16 10.283-1.803M13.075 22.25H19a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25h-1.75v15.132c0 .509-.222 1-.635 1.33a14.1 14.1 0 0 1-3.54 2.038",
              clipRule: "evenodd"
            })]
          }),
          Tt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M10 .5A1.5 1.5 0 0 0 8.5 2v1H10V2h8v3a1 1 0 0 0 1 1h3v12h-3v1.5h3a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-.44-1.06l-4-4A1.5 1.5 0 0 0 18 .5zm.75 12.5a.75.75 0 0 0-1.5 0v2.25H7a.75.75 0 0 0 0 1.5h2.25V19a.75.75 0 0 0 1.5 0v-2.25H13a.75.75 0 0 0 0-1.5h-2.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.5 6A1.5 1.5 0 0 1 4 4.5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 17.5 10v12a1.5 1.5 0 0 1-1.5 1.5H4A1.5 1.5 0 0 1 2.5 22zM4 22V6h8v3a1 1 0 0 0 1 1h3v12z",
              clipRule: "evenodd"
            })]
          }),
          Ot = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm20.75-1H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1.25zm-1.5 0H4.75v14h14.5zm-16 14V5H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1z",
              clipRule: "evenodd"
            })]
          }),
          It = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M21 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm-4 1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4zM7 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4zM8.5 6.5h7v11h-7z",
              clipRule: "evenodd"
            })]
          }),
          Ft = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M0 3.75h1a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25H0v1.5h1A1.75 1.75 0 0 0 2.75 20V4A1.75 1.75 0 0 0 1 2.25H0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 4c0-.966.784-1.75 1.75-1.75h12c.966 0 1.75.784 1.75 1.75v16A1.75 1.75 0 0 1 18 21.75H6A1.75 1.75 0 0 1 4.25 20zM6 3.75a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25V4a.25.25 0 0 0-.25-.25z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M23 3.75a.25.25 0 0 0-.25.25v16c0 .138.112.25.25.25h1v1.5h-1A1.75 1.75 0 0 1 21.25 20V4c0-.966.784-1.75 1.75-1.75h1v1.5z"
            })]
          }),
          Mt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M23.75 19A1.75 1.75 0 0 1 22 20.75H2A1.75 1.75 0 0 1 .25 19V5c0-.966.784-1.75 1.75-1.75h15.5a.75.75 0 0 1 .53.22l5.5 5.5c.141.14.22.331.22.53zm-1.75.25a.25.25 0 0 0 .25-.25v-8.75H17.5a.75.75 0 0 1-.75-.75V4.75H2a.25.25 0 0 0-.25.25v14c0 .138.112.25.25.25z",
              clipRule: "evenodd"
            })]
          }),
          Rt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 20.75A1.75 1.75 0 0 1 .25 19V5c0-.966.784-1.75 1.75-1.75h20c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 22 20.75zM1.75 5A.25.25 0 0 1 2 4.75h9.25v14.5H2a.25.25 0 0 1-.25-.25zm11-.25v14.5H22a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          jt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25zM3.25 2c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v20A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22z",
              clipRule: "evenodd"
            })]
          }),
          Bt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#page-move-left-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M23.5 4A1.5 1.5 0 0 0 22 2.5h-7a1.5 1.5 0 0 0-1.06.44l-4 4A1.5 1.5 0 0 0 9.5 8v2H11V8h4V4h7v16H11v-2H9.5v2a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5z"
              }), r.jsx("path", {
                d: "M5.53 9.47a.75.75 0 0 0-1.06 0L-.06 14l4.53 4.53a.75.75 0 0 0 1.06-1.06l-2.72-2.72H16a.75.75 0 0 0 0-1.5H2.81l2.72-2.72a.75.75 0 0 0 0-1.06"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "page-move-left-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Nt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#page-move-right-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M.5 4A1.5 1.5 0 0 1 2 2.5h7a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 14.5 8v2H13V8H9V4H2v16h11v-2h1.5v2a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 20z"
              }), r.jsx("path", {
                d: "M18.47 9.47a.75.75 0 0 1 1.06 0L24.06 14l-4.53 4.53a.75.75 0 1 1-1.06-1.06l2.72-2.72H8a.75.75 0 0 1 0-1.5h13.19l-2.72-2.72a.75.75 0 0 1 0-1.06"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "page-move-right-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Lt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.656 8.182a.75.75 0 1 0-1.455-.364L9.843 9.25H8.5a.75.75 0 0 0 0 1.5h.968l-.625 2.5H7.43a.75.75 0 0 0 0 1.5h1.04l-.27 1.068a.75.75 0 0 0 1.455.364l.358-1.432h2.454l-.267 1.068a.75.75 0 0 0 1.455.364l.358-1.432h1.415a.75.75 0 0 0 0-1.5h-1.04l.625-2.5h1.415a.75.75 0 0 0 0-1.5h-1.04l.267-1.068a.75.75 0 1 0-1.455-.364l-.358 1.432H11.39zm1.187 5.068H10.39l.625-2.5h2.454l-.625 2.5Z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          Vt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.635 11.279a.75.75 0 0 1 .515.927l-.299 1.044h1.44l.416-1.456a.75.75 0 0 1 1.443.412l-.299 1.044h1.006a.75.75 0 1 1 0 1.5h-1.434l-.429 1.5H15a.75.75 0 0 1 0 1.5h-1.434l-.416 1.456a.75.75 0 0 1-1.443-.412l.299-1.044h-1.44l-.416 1.456a.75.75 0 0 1-1.443-.412l.299-1.044H8a.75.75 0 0 1 0-1.5h1.434l.429-1.5H8.857a.75.75 0 0 1 0-1.5h1.434l.416-1.456a.75.75 0 0 1 .928-.515m-.212 3.471-.429 1.5h1.44l.429-1.5z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.25 2c0-.966.784-1.75 1.75-1.75h9.5a.75.75 0 0 1 .53.22l5.5 5.5c.141.14.22.331.22.53V22A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22zM5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V7.25H14.5a.75.75 0 0 1-.75-.75V1.75z",
              clipRule: "evenodd"
            })]
          }),
          Kt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 .25A1.75 1.75 0 0 0 3.25 2v20c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 20.75 22V6.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22zM4.75 2A.25.25 0 0 1 5 1.75h8.75V6.5c0 .414.336.75.75.75h4.75V22a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          qt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.25 15a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.25 2c0-.966.784-1.75 1.75-1.75h9.5a.75.75 0 0 1 .53.22l5.5 5.5c.141.14.22.331.22.53V22A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22zM5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V7.25H14.5a.75.75 0 0 1-.75-.75V1.75z",
              clipRule: "evenodd"
            })]
          }),
          Ht = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M5.75 4V0h-1.5v4c0 .966.784 1.75 1.75 1.75h12A1.75 1.75 0 0 0 19.75 4V0h-1.5v4a.25.25 0 0 1-.25.25H6A.25.25 0 0 1 5.75 4m0 5A.25.25 0 0 1 6 8.75h12a.25.25 0 0 1 .25.25v15h1.5V9A1.75 1.75 0 0 0 18 7.25H6A1.75 1.75 0 0 0 4.25 9v15h1.5z"
            })]
          }),
          Ut = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#pages-insert-alt-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M4 0H3a1.5 1.5 0 0 0-1.5 1.5v12A1.5 1.5 0 0 0 3 15h1v-1.5H3v-12h1zm3.5 0H9v1.5H7.5v12H9V15H7.5A1.5 1.5 0 0 1 6 13.5v-12A1.5 1.5 0 0 1 7.5 0"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M11 1.5A1.5 1.5 0 0 1 12.5 0h5a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 23 5.5v8a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5zm1.5 12v-12h5v3a1 1 0 0 0 1 1h3v8z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M8.47 20.53a.75.75 0 1 1 1.06-1.06l1.72 1.72V17a.75.75 0 0 1 1.5 0v4.19l1.72-1.72a.75.75 0 1 1 1.06 1.06L12 24.06z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-insert-alt-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Zt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#pages-insert-icon_svg__a)",
              children: [r.jsx("path", {
                fillRule: "evenodd",
                d: "M2 .25A1.75 1.75 0 0 0 .25 2v5c0 .966.784 1.75 1.75 1.75h3A1.75 1.75 0 0 0 6.75 7V2A1.75 1.75 0 0 0 5 .25zM1.75 2A.25.25 0 0 1 2 1.75h3a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25H2A.25.25 0 0 1 1.75 7z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M.25 11a.75.75 0 0 1 1.5 0v2c0 .69.56 1.25 1.25 1.25h18c.69 0 1.25-.56 1.25-1.25v-2a.75.75 0 0 1 1.5 0v2A2.75 2.75 0 0 1 21 15.75h-8.25v5.44l1.72-1.72a.75.75 0 0 1 1.06 1.06L12 24.06l-3.53-3.53a.75.75 0 1 1 1.06-1.06l1.72 1.72v-5.44H3A2.75 2.75 0 0 1 .25 13z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M8.75 2c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v5a1.75 1.75 0 0 1-1.75 1.75h-3A1.75 1.75 0 0 1 8.75 7zm1.75-.25a.25.25 0 0 0-.25.25v5c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25zM19 .25A1.75 1.75 0 0 0 17.25 2v5c0 .966.784 1.75 1.75 1.75h3A1.75 1.75 0 0 0 23.75 7V2A1.75 1.75 0 0 0 22 .25zM18.75 2a.25.25 0 0 1 .25-.25h3a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25h-3a.25.25 0 0 1-.25-.25z",
                clipRule: "evenodd"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-insert-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          $t = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#pages-new-from-selection-alt-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M15.53 4.53a.75.75 0 0 0 0-1.06L12-.06 8.47 3.47a.75.75 0 0 0 1.06 1.06l1.72-1.72V7a.75.75 0 0 0 1.5 0V2.81l1.72 1.72a.75.75 0 0 0 1.06 0"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M11 10.5A1.5 1.5 0 0 1 12.5 9h5a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 23 14.5v8a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5zm1.5 12v-12h5v3a1 1 0 0 0 1 1h3v8z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M9 9H7.5A1.5 1.5 0 0 0 6 10.5v12A1.5 1.5 0 0 0 7.5 24H9v-1.5H7.5v-12H9zM3 9h1v1.5H3v12h1V24H3a1.5 1.5 0 0 1-1.5-1.5v-12A1.5 1.5 0 0 1 3 9"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-new-from-selection-alt-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Gt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#pages-new-from-selection-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M.25 13a.75.75 0 0 0 1.5 0v-2c0-.69.56-1.25 1.25-1.25h18c.69 0 1.25.56 1.25 1.25v2a.75.75 0 0 0 1.5 0v-2A2.75 2.75 0 0 0 21 8.25h-8.25V2.81l1.72 1.72a.75.75 0 0 0 1.06-1.06L12-.06 8.47 3.47a.75.75 0 0 0 1.06 1.06l1.72-1.72v5.44H3A2.75 2.75 0 0 0 .25 11z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M2 23.75A1.75 1.75 0 0 1 .25 22v-5c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 5 23.75zM1.75 22c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25H2a.25.25 0 0 0-.25.25zm7 0c0 .966.784 1.75 1.75 1.75h3A1.75 1.75 0 0 0 15.25 22v-5a1.75 1.75 0 0 0-1.75-1.75h-3A1.75 1.75 0 0 0 8.75 17zm1.75.25a.25.25 0 0 1-.25-.25v-5a.25.25 0 0 1 .25-.25h3a.25.25 0 0 1 .25.25v5a.25.25 0 0 1-.25.25zm8.5 1.5A1.75 1.75 0 0 1 17.25 22v-5c0-.966.784-1.75 1.75-1.75h3c.966 0 1.75.784 1.75 1.75v5A1.75 1.75 0 0 1 22 23.75zM18.75 22c0 .138.112.25.25.25h3a.25.25 0 0 0 .25-.25v-5a.25.25 0 0 0-.25-.25h-3a.25.25 0 0 0-.25.25z",
                clipRule: "evenodd"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-new-from-selection-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Wt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#pages-select-all-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M.5 4H2V2h2V.5H2A1.5 1.5 0 0 0 .5 2zm23 0H22V2h-2V.5h2A1.5 1.5 0 0 1 23.5 2zm0 3H22v3.5h1.5zm0 6.5H22V17h1.5zm0 6.5H22v2h-2v1.5h2a1.5 1.5 0 0 0 1.5-1.5zM.5 7H2v3.5H.5zm0 6.5H2V17H.5zm0 6.5H2v2h2v1.5H2A1.5 1.5 0 0 1 .5 22zM7 23.5V22h3.5v1.5zm6.5 0V22H17v1.5zM17 .5V2h-3.5V.5zm-6.5 0V2H7V.5z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M4 5.5A1.5 1.5 0 0 1 5.5 4h4A1.5 1.5 0 0 1 11 5.5v4A1.5 1.5 0 0 1 9.5 11h-4A1.5 1.5 0 0 1 4 9.5zm1.5 0v4h4v-4zm-1.5 9A1.5 1.5 0 0 1 5.5 13h4a1.5 1.5 0 0 1 1.5 1.5v4A1.5 1.5 0 0 1 9.5 20h-4A1.5 1.5 0 0 1 4 18.5zm1.5 0v4h4v-4zm9-10.5A1.5 1.5 0 0 0 13 5.5v4a1.5 1.5 0 0 0 1.5 1.5h4A1.5 1.5 0 0 0 20 9.5v-4A1.5 1.5 0 0 0 18.5 4zm0 5.5v-4h4v4zm-1.5 5a1.5 1.5 0 0 1 1.5-1.5h4a1.5 1.5 0 0 1 1.5 1.5v4a1.5 1.5 0 0 1-1.5 1.5h-4a1.5 1.5 0 0 1-1.5-1.5zm1.5 0v4h4v-4z",
                clipRule: "evenodd"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-select-all-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Yt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#pages-select-none-icon_svg__a)",
              children: r.jsx("path", {
                d: "M.5 4H2V2h2V.5H2A1.5 1.5 0 0 0 .5 2zm23 0H22V2h-2V.5h2A1.5 1.5 0 0 1 23.5 2zm0 3H22v3.5h1.5zm0 6.5H22V17h1.5zm0 6.5H22v2h-2v1.5h2a1.5 1.5 0 0 0 1.5-1.5zM.5 7H2v3.5H.5zm0 6.5H2V17H.5zm0 6.5H2v2h2v1.5H2A1.5 1.5 0 0 1 .5 22zM7 23.5V22h3.5v1.5zm6.5 0V22H17v1.5zM17 .5V2h-3.5V.5zm-6.5 0V2H7V.5zm6.03 8.03a.75.75 0 0 0-1.06-1.06l-8 8a.75.75 0 1 0 1.06 1.06z"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "pages-select-none-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Xt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M14.5 4.25h-5a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 1.25h14c.966 0 1.75.784 1.75 1.75v18A1.75 1.75 0 0 1 19 22.75H5A1.75 1.75 0 0 1 3.25 21V3c0-.966.784-1.75 1.75-1.75m14 1.5H5a.25.25 0 0 0-.25.25v18c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V3a.25.25 0 0 0-.25-.25",
              clipRule: "evenodd"
            })]
          }),
          Qt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M10 1.75h12a.25.25 0 0 1 .25.25v16a.25.25 0 0 1-.25.25h-4v1.5h4A1.75 1.75 0 0 0 23.75 18V2A1.75 1.75 0 0 0 22 .25H10A1.75 1.75 0 0 0 8.25 2v1h1.5V2a.25.25 0 0 1 .25-.25"
            }), r.jsx("path", {
              d: "M14 3.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M1.5 6A1.5 1.5 0 0 1 3 4.5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 16.5 10v12a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 22zM3 22V6h8v3a1 1 0 0 0 1 1h3v12z",
              clipRule: "evenodd"
            })]
          }),
          Jt = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9 5.25a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 9 5.25m6 0a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            })]
          }),
          en = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M14.75 3.5a.75.75 0 0 0-1.085-.67l-4 2a.75.75 0 0 0-.415.67v2.75H9a.75.75 0 0 0-.75.75v2a7.25 7.25 0 0 1-2.9 5.8l-.8.6a.75.75 0 0 0-.3.6v4a.75.75 0 0 0 1.5 0v-3.625l.5-.375a8.75 8.75 0 0 0 3.5-7V9.75h4.5V11a8.75 8.75 0 0 0 3.5 7l.5.375V22a.75.75 0 0 0 1.5 0v-4a.75.75 0 0 0-.3-.6l-.8-.6a7.25 7.25 0 0 1-2.9-5.8V9a.75.75 0 0 0-.75-.75h-.25z"
            })]
          }),
          tn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M13 4a1 1 0 1 0-2 0v2.25h-1a.75.75 0 0 0-.75.75v2.671c0 1.357-.957 2.577-2.157 3.8A6.4 6.4 0 0 0 5.25 18v3a.75.75 0 0 0 1.5 0v-3c0-1.386.536-2.586 1.413-3.479 1.175-1.196 2.587-2.816 2.587-4.85V7.75h2.5v1.921c0 2.035 1.412 3.654 2.587 4.85A4.9 4.9 0 0 1 17.25 18v3a.75.75 0 0 0 1.5 0v-3a6.4 6.4 0 0 0-1.843-4.53c-1.2-1.222-2.157-2.442-2.157-3.799V7a.75.75 0 0 0-.75-.75h-1z"
            })]
          }),
          nn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M4.735 1.693A1.5 1.5 0 0 0 2.5 3v5.5H.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H4V3l16 9-16 9v-6.33l1.002.89a.75.75 0 0 0 .996-1.12L3.25 11.995.502 14.44a.75.75 0 0 0 .996 1.122l1.002-.89V21a1.5 1.5 0 0 0 2.235 1.307l16-9a1.5 1.5 0 0 0 0-2.614z"
            })]
          }),
          rn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.25 6.5a6.25 6.25 0 1 1 7 6.206V22l-.75 1.75-.75-1.75v-9.294A6.25 6.25 0 0 1 5.25 6.5m6.25-3.25a.75.75 0 0 0 0 1.5c.966 0 1.75.784 1.75 1.75a.75.75 0 0 0 1.5 0 3.25 3.25 0 0 0-3.25-3.25",
              clipRule: "evenodd"
            })]
          }),
          on = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M10.75 4a.75.75 0 0 1 .75-.75 3.25 3.25 0 0 1 3.25 3.25.75.75 0 0 1-1.5 0 1.75 1.75 0 0 0-1.75-1.75.75.75 0 0 1-.75-.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.25 6.5a6.25 6.25 0 1 1 7 6.206V22l-.75 1.75-.75-1.75v-9.294A6.25 6.25 0 0 1 5.25 6.5m6.25-4.75a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5",
              clipRule: "evenodd"
            })]
          }),
          an = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "m19.506 11.728-1.414 1.414a1 1 0 0 1-1.414 0l-.708-.707-8.308 8.309a3.75 3.75 0 0 1-2.122 1.06l-.247.036a3 3 0 0 0-1.697.848l-2.121-2.121a3 3 0 0 0 .848-1.697l.035-.248a3.75 3.75 0 0 1 1.061-2.121l8.309-8.309-.707-.707a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0 1 1 0 0 0 1.415 0l2.12-2.122a3 3 0 0 1 4.244 4.243L19.506 8.9a1 1 0 0 0 0 1.415 1 1 0 0 1 0 1.414Zm-1.06-3.89a2.5 2.5 0 0 0-.319 3.147l-.742.743-4.95-4.95.743-.742a2.5 2.5 0 0 0 3.146-.319l2.122-2.12a1.5 1.5 0 1 1 2.12 2.12zM3.414 20.386l.364.364c.41-.196.848-.33 1.303-.394l.247-.036a2.25 2.25 0 0 0 1.273-.636l8.309-8.309-2.122-2.121-8.308 8.308a2.25 2.25 0 0 0-.637 1.273l-.035.248a4.5 4.5 0 0 1-.394 1.303",
              clipRule: "evenodd"
            })]
          }),
          sn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M8 18.865 19.562 12 8 5.135zM6.5 4.257v15.486a1 1 0 0 0 1.51.86l13.042-7.743a1 1 0 0 0 0-1.72L8.01 3.397a1 1 0 0 0-1.511.86",
              clipRule: "evenodd"
            })]
          }),
          ln = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m.75-16a.75.75 0 0 0-1.5 0v4.25H7a.75.75 0 0 0 0 1.5h4.25V17a.75.75 0 0 0 1.5 0v-4.25H17a.75.75 0 0 0 0-1.5h-4.25z",
              clipRule: "evenodd"
            })]
          }),
          un = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 7a.75.75 0 0 0-1.5 0v4.25H7a.75.75 0 0 0 0 1.5h4.25V17a.75.75 0 0 0 1.5 0v-4.25H17a.75.75 0 0 0 0-1.5h-4.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          cn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 4.25a.75.75 0 0 1 .75.75v6.25H19a.75.75 0 0 1 0 1.5h-6.25V19a.75.75 0 0 1-1.5 0v-6.25H5a.75.75 0 0 1 0-1.5h6.25V5a.75.75 0 0 1 .75-.75",
              clipRule: "evenodd"
            })]
          }),
          dn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3.168 3.91v.002l5.686 17.046.001.002a.587.587 0 0 0 1.111-.01v-.003l2.582-8.397 8.4-2.576a.583.583 0 0 0 .305-.898.6.6 0 0 0-.292-.217L3.907 3.171a.585.585 0 0 0-.739.74Zm8.23 17.484a2.084 2.084 0 0 1-3.965.043L1.746 4.387a2.085 2.085 0 0 1 2.638-2.638l17.05 5.687a2.087 2.087 0 0 1 1.01 3.23 2.1 2.1 0 0 1-1.06.743l-7.636 2.342z",
              clipRule: "evenodd"
            })]
          }),
          pn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.735 1.693A1.5 1.5 0 0 0 2.5 3v18a1.5 1.5 0 0 0 2.235 1.307l16-9a1.5 1.5 0 0 0 0-2.614zM20 12 4 21v-3.34l12.861-7.426zm-4.152-2.335L4 16.505v-3.464l8.81-5.086zm-4.052-2.28L4 11.887V8.423l4.757-2.747 3.04 1.71ZM4 7.268l3.744-2.162L4 3z",
              clipRule: "evenodd"
            })]
          }),
          hn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M21.79 11.552c-.08-.77-.42-1.51-.95-2.08-.53-.56-1.24-.95-2-1.08-.45-.08-.92-.06-1.36.03-.09-.27-.22-.54-.38-.78-.32-.5-.75-.91-1.25-1.19-.51-.3-1.08-.47-1.67-.49-.28-.01-.55.01-.82.06-.09-.26-.2-.52-.34-.76-.32-.48-.75-.9-1.26-1.19s-1.08-.46-1.67-.49c-.3-.02-.6.01-.9.07a3.54 3.54 0 0 0-1.9-2.06c-.62-.3-1.3-.4-1.97-.31-.66.09-1.29.36-1.81.78-.53.43-.92.99-1.14 1.63-.21.64-.25 1.33-.1 1.98.13.57.4 1.09.81 1.57-.17.2-.32.43-.45.66-.26.52-.4 1.1-.4 1.68s.14 1.16.42 1.71c.14.24.3.47.49.67-.19.21-.36.44-.5.7-.26.52-.4 1.1-.4 1.68s.14 1.16.41 1.7c.14.25.3.48.5.69-.22.24-.41.51-.56.81-.3.61-.43 1.29-.36 1.98.07.67.32 1.3.73 1.84s.97.96 1.6 1.2c.41.16.84.23 1.28.23.24 0 .48-.02.72-.07.65-.14 1.26-.45 1.75-.9.45-.42.78-.95.98-1.55.23.05.47.08.71.08h.17c.58-.03 1.15-.2 1.67-.5.51-.31.94-.74 1.24-1.24.14-.22.25-.46.34-.71.22.04.44.07.66.07h.16c.59-.03 1.16-.2 1.67-.49a3.7 3.7 0 0 0 1.62-1.96c.23.04.45.07.68.07.31 0 .63-.04.94-.12.84-.23 1.56-.75 2.05-1.47s.7-1.59.61-2.44zm-1.85 1.6c-.29.42-.72.73-1.2.86-.44.12-.9.09-1.33-.08s-.78-.46-1.03-.84a.747.747 0 0 0-1.04-.22c-.35.22-.45.69-.22 1.04.26.41.6.75 1 1.02-.06.2-.13.39-.25.56-.19.29-.44.53-.74.71-.3.17-.64.27-.98.29-.27.01-.54-.04-.8-.13-.03-.03-.06-.06-.1-.08 0 0-.02-.01-.03-.02-.38-.21-.71-.51-.93-.88a.748.748 0 0 0-1.29.76c.26.46.62.86 1.04 1.16-.06.19-.14.37-.25.55-.19.3-.45.56-.73.74-.3.17-.64.27-.98.29-.34.01-.68-.05-.99-.2-.25-.14-.48-.32-.67-.53a.746.746 0 0 0-1.06-.06c-.31.27-.34.75-.06 1.06.18.21.39.39.61.56v.04c-.11.39-.32.73-.61 1s-.66.46-1.04.54c-.39.08-.79.04-1.17-.1-.37-.14-.7-.38-.94-.7s-.39-.7-.43-1.09c-.04-.4.04-.8.21-1.15.18-.36.46-.65.8-.86s.73-.32 1.13-.32c.41 0 .75-.34.75-.75 0-.02-.01-.04-.01-.06v-.02c0-.41-.33-.74-.74-.75-.53 0-1.06.1-1.54.32-.13-.13-.24-.28-.33-.44-.16-.31-.24-.66-.24-1 0-.35.08-.69.22-.97.17-.3.4-.56.68-.75.05-.04.08-.08.12-.13.34-.18.7-.29 1.09-.3.41 0 .74-.35.73-.76 0-.41-.34-.74-.75-.74-.53 0-1.05.11-1.53.33-.13-.14-.25-.28-.33-.44a2.2 2.2 0 0 1-.24-1.01c0-.35.08-.69.24-.99.15-.29.37-.54.63-.74.25-.14.52-.25.8-.29a.76.76 0 0 0 .62-.86.76.76 0 0 0-.86-.62c-.31.05-.61.14-.89.26-.26-.28-.45-.62-.53-1-.09-.39-.07-.79.06-1.16s.36-.7.66-.95a2.14 2.14 0 0 1 2.22-.29c.36.16.66.42.89.76.22.32.34.7.35 1.11 0 .19-.01.37-.06.55-.02.09-.06.17-.09.25-.04.1-.07.21-.13.31a.752.752 0 1 0 1.3.76l.03-.06s.01 0 .01-.02c.02-.04.04-.09.06-.13.06-.12.11-.23.16-.35.13-.32.23-.65.26-1 .19-.04.38-.06.57-.05.35.02.69.12.99.29.3.18.56.42.73.69.17.29.27.62.29.95 0 .44-.1.87-.31 1.25-.2.36-.07.81.29 1.01s.81.08 1.02-.28c.26-.46.43-.96.48-1.48.19-.05.4-.07.6-.06.34.01.68.11.98.29.3.17.55.41.74.7.18.29.29.61.33.95 0 .3-.05.59-.13.87a.75.75 0 0 0 .72.97c.32 0 .62-.21.72-.53.08-.25.12-.5.16-.76.31-.09.63-.14.95-.08.45.08.86.31 1.17.63.31.33.5.76.55 1.21a2.1 2.1 0 0 1-.36 1.44z"
            })]
          }),
          fn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              d: "m6.72 4.59.73-1.3-2.713-1.53A1.5 1.5 0 0 0 2.5 3.068V6.06H4v-3zM11.07 7.04 8.46 5.57l.74-1.31 2.61 1.47zM20.747 10.765a1.5 1.5 0 0 1 .002 2.614l-2.84 1.601-.73-1.31 2.84-1.59-2.84-1.6.73-1.31zM16.17 15.96l-2.61 1.47-.74-1.31 2.61-1.47zM9.2 19.88l2.61-1.47-.74-1.31-2.61 1.47zM7.45 20.86l-2.713 1.53A1.5 1.5 0 0 1 2.5 21.082V18.06H4v3.02l2.72-1.53zM12.82 8.03l2.61 1.47.74-1.31-2.61-1.47zM4 16.06v-3H2.5v3zM4 8.06v3H2.5v-3z"
            })]
          }),
          mn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3.243 1.705a1.5 1.5 0 0 1 1.492-.012l16 9a1.5 1.5 0 0 1 0 2.614l-16 9A1.5 1.5 0 0 1 2.5 21V3a1.5 1.5 0 0 1 .743-1.295M4 21l16-9L4 3z",
              clipRule: "evenodd"
            })]
          }),
          gn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M22.427 3.383a.75.75 0 0 1 .19 1.044l-7.62 11a.75.75 0 0 1-1.16.09l-4.126-4.333-7.094 10.243a.75.75 0 0 1-1.233-.854l7.619-11a.75.75 0 0 1 1.16-.09l4.126 4.333 7.095-10.243a.75.75 0 0 1 1.043-.19",
              clipRule: "evenodd"
            })]
          }),
          vn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#precision-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M12.75 1a.75.75 0 0 0-1.5 0v.777a10.25 10.25 0 0 0-9.473 9.473H1a.75.75 0 0 0 0 1.5h.777a10.25 10.25 0 0 0 9.473 9.473V23a.75.75 0 0 0 1.5 0v-.777a10.25 10.25 0 0 0 9.473-9.473H23a.75.75 0 0 0 0-1.5h-.777a10.25 10.25 0 0 0-9.473-9.473zm-1.5 2.282V4a.75.75 0 0 0 1.5 0v-.718a8.75 8.75 0 0 1 7.968 7.968H20a.75.75 0 0 0 0 1.5h.718a8.75 8.75 0 0 1-7.968 7.968V20a.75.75 0 0 0-1.5 0v.718a8.75 8.75 0 0 1-7.968-7.968H4a.75.75 0 0 0 0-1.5h-.718a8.75 8.75 0 0 1 7.968-7.968M12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "precision-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          yn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M17.5 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0M10 15.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zm0 3a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M7 1.75A1.75 1.75 0 0 0 5.25 3.5v1.75H3A2.75 2.75 0 0 0 .25 8v8A2.75 2.75 0 0 0 3 18.75h2.25V22c0 .966.784 1.75 1.75 1.75h10A1.75 1.75 0 0 0 18.75 22v-3.25H21A2.75 2.75 0 0 0 23.75 16V8A2.75 2.75 0 0 0 21 5.25h-2.25V3.5A1.75 1.75 0 0 0 17 1.75zm10.25 3.5V3.5a.25.25 0 0 0-.25-.25H7a.25.25 0 0 0-.25.25v1.75zm1.5 12H21c.69 0 1.25-.56 1.25-1.25V8c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25 1.25h2.25V13c0-.966.784-1.75 1.75-1.75h10c.966 0 1.75.784 1.75 1.75zM6.75 22c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-9a.25.25 0 0 0-.25-.25H7a.25.25 0 0 0-.25.25z",
              clipRule: "evenodd"
            })]
          }),
          bn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.4 9.623A18 18 0 0 1 1.918 9a20.3 20.3 0 0 1 2.677-2.942C6.487 4.358 9.063 2.75 12 2.75s5.513 1.608 7.405 3.308a20.3 20.3 0 0 1 2.777 3.08q.098.136.146.207l.017.024.018.028.008.012.002.002a.75.75 0 0 0 1.254-.822L23 9c.627-.41.627-.412.627-.412l-.001-.002-.004-.005-.012-.018a7 7 0 0 0-.21-.302 21.8 21.8 0 0 0-2.992-3.319C18.403 3.142 15.48 1.25 12 1.25S5.596 3.142 3.592 4.942A21.8 21.8 0 0 0 .601 8.261a13 13 0 0 0-.21.302l-.013.018-.004.005-.001.003L.103 9l.27.41L1 9c-.627.41-.627.412-.627.412l.001.002.004.005.012.018a7 7 0 0 0 .21.302 21.8 21.8 0 0 0 2.992 3.319C5.597 14.858 8.52 16.75 12 16.75a.75.75 0 0 0 0-1.5c-2.937 0-5.513-1.608-7.405-3.308A20 20 0 0 1 2.4 9.622ZM.373 8.589 1 9z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M14 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 14a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m4.75 4.015A2 2 0 0 0 15 18.5V22a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-3.5a2 2 0 0 0-1.75-1.985V15a2.75 2.75 0 1 0-5.5 0zM22.5 18.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5V22a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5zm-4.25-2h2.5V15a1.25 1.25 0 1 0-2.5 0z",
              clipRule: "evenodd"
            })]
          }),
          wn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7 2.25a.75.75 0 0 0-.75.75v.558a2.75 2.75 0 0 0 1.88 2.61l.789.262a.25.25 0 0 1 .165.288l-.752 3.615A6.75 6.75 0 0 0 5.25 16c0 .414.336.75.75.75h5.25V22l.75 1.75.75-1.75v-5.25H18a.75.75 0 0 0 .75-.75 6.75 6.75 0 0 0-3.082-5.667l-.752-3.615a.25.25 0 0 1 .165-.288l.789-.263a2.75 2.75 0 0 0 1.88-2.609V3a.75.75 0 0 0-.75-.75zm10.197 13a5.253 5.253 0 0 0-7.821-3.798 5.25 5.25 0 0 0-2.573 3.798zM12 9.25a6.8 6.8 0 0 0-1.972.293l.525-2.519a1.75 1.75 0 0 0-1.16-2.017l-.788-.263a1.25 1.25 0 0 1-.84-.994h8.47a1.25 1.25 0 0 1-.84.994l-.788.263a1.75 1.75 0 0 0-1.16 2.017l.525 2.519A6.8 6.8 0 0 0 12 9.25",
              clipRule: "evenodd"
            })]
          }),
          xn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11m1.25-5.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M9.75 9a2.25 2.25 0 1 1 2.986 2.127c-.678.235-1.486.87-1.486 1.873v.5a.75.75 0 0 0 1.5 0V13c0-.056.02-.13.102-.219a.9.9 0 0 1 .375-.237A3.751 3.751 0 0 0 12 5.25 3.75 3.75 0 0 0 8.25 9a.75.75 0 0 0 1.5 0",
              clipRule: "evenodd"
            })]
          }),
          Dn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M14 3.25a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5zM13.25 8a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m4.964 9.75-1.293 2.585a.75.75 0 1 1-1.342-.67l4-8a.75.75 0 0 1 1.342 0l4 8a.75.75 0 1 1-1.342.67L9.036 9.75zm3.323-1.5H5.714L7 5.677z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M13.25 12a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75M3 15.25a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zM2.25 20a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75"
            })]
          }),
          Cn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1.5 3.554V4.5h5.553zm0 1.141v2.86L17.326 4.5h-5.198zM19.4 4.5 4.5 12.695v2.86l15-8.25V4.5zm.1 3.945-15 8.25V19.5h.099L19.5 11.304zm0 4L6.674 19.5h5.197l7.629-4.196zm0 4L13.946 19.5H19.5z",
              clipRule: "evenodd"
            })]
          }),
          Sn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M19.143 1.25a3.74 3.74 0 0 0-2.381.86 3.74 3.74 0 0 0-2.38-.86c-.854 0-1.726.306-2.382.86a3.74 3.74 0 0 0-2.38-.86c-.854 0-1.726.306-2.382.86a3.74 3.74 0 0 0-2.38-.86c-2.034 0-3.608 1.574-3.608 3.607 0 .853.306 1.726.86 2.381a3.74 3.74 0 0 0-.86 2.381c0 .853.306 1.725.86 2.381a3.74 3.74 0 0 0-.86 2.38c0 .854.306 1.726.86 2.382a3.74 3.74 0 0 0-.86 2.38c0 2.034 1.574 3.608 3.607 3.608.853 0 1.726-.306 2.381-.86.656.554 1.528.86 2.381.86s1.726-.306 2.381-.86c.656.554 1.528.86 2.381.86s1.725-.306 2.38-.86c.657.554 1.529.86 2.382.86 2.033 0 3.607-1.574 3.607-3.607a3.74 3.74 0 0 0-.861-2.381c.555-.656.86-1.528.86-2.381s-.305-1.725-.86-2.381c.555-.656.86-1.528.86-2.38 0-.854-.305-1.726-.86-2.382.555-.655.86-1.528.86-2.38 0-2.034-1.573-3.608-3.606-3.608m-3.024 2.375c-.323-.508-1.013-.875-1.738-.875-.572 0-1.121.228-1.486.573.2.436.331.924.331 1.534a.75.75 0 0 1-1.5 0c0-.41-.139-.85-.368-1.232-.324-.508-1.013-.875-1.739-.875a2.2 2.2 0 0 0-1.486.573c.2.436.332.924.332 1.534a.75.75 0 1 1-1.5 0c0-.405-.136-.839-.36-1.218l-.003-.003c-.32-.514-1.015-.886-1.745-.886-1.205 0-2.107.902-2.107 2.107 0 .572.228 1.121.573 1.487.436-.2.924-.332 1.534-.332a.75.75 0 1 1 0 1.5c-.408 0-.845.138-1.227.366-.51.322-.88 1.013-.88 1.741 0 .572.228 1.121.573 1.487.436-.2.924-.332 1.534-.332a.75.75 0 0 1 0 1.5c-.408 0-.845.138-1.227.366-.51.322-.88 1.013-.88 1.74 0 .573.228 1.122.573 1.487.436-.2.924-.331 1.534-.331a.75.75 0 0 1 0 1.5c-.408 0-.845.138-1.227.365-.51.323-.88 1.014-.88 1.742 0 1.205.902 2.107 2.107 2.107a2.2 2.2 0 0 0 1.487-.573 3.56 3.56 0 0 1-.332-1.534.75.75 0 0 1 1.5 0c0 .405.136.839.36 1.219l.002.002c.321.514 1.015.886 1.745.886a2.2 2.2 0 0 0 1.487-.573 3.56 3.56 0 0 1-.332-1.534.75.75 0 1 1 1.5 0c0 .41.14.85.369 1.232.323.508 1.013.875 1.738.875a2.2 2.2 0 0 0 1.487-.573 3.56 3.56 0 0 1-.332-1.534.75.75 0 1 1 1.5 0c0 .41.14.85.369 1.232.323.508 1.012.875 1.738.875 1.205 0 2.107-.902 2.107-2.107 0-.572-.228-1.121-.574-1.487-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.407 0 .842-.137 1.223-.363.512-.322.884-1.015.884-1.744 0-.572-.228-1.121-.574-1.487-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.408 0 .845-.138 1.227-.366.51-.322.88-1.013.88-1.74 0-.573-.228-1.122-.574-1.488-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.41 0 .848-.138 1.23-.367.509-.324.877-1.014.877-1.74 0-1.205-.902-2.107-2.107-2.107a2.2 2.2 0 0 0-1.487.573c.2.436.332.924.332 1.534a.75.75 0 0 1-1.5 0c0-.41-.14-.85-.369-1.232",
              clipRule: "evenodd"
            })]
          }),
          En = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              d: "M21 6h-1.5V4.5H18V3h2a1 1 0 0 1 1 1zM3 18h1.5v1.5H6V21H4a1 1 0 0 1-1-1zM4.5 6H3V4a1 1 0 0 1 1-1h2v1.5H4.5zM21 18h-1.5v1.5H18V21h2a1 1 0 0 0 1-1zM8 4.5V3h3v1.5zM8 19.5V21h3v-1.5zM3 8h1.5v3H3zM21 8h-1.5v3H21zM13 4.5V3h3v1.5zM13 19.5V21h3v-1.5zM3 13h1.5v3H3zM21 13h-1.5v3H21z"
            })]
          }),
          _n = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3.53 1.47a.75.75 0 0 0-1.06 1.06L4.44 4.5 2.47 6.47a.75.75 0 0 0 1.06 1.06L5.5 5.56l1.97 1.97a.75.75 0 0 0 1.06-1.06L6.56 4.5l1.97-1.97a.75.75 0 0 0-1.06-1.06L5.5 3.44z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M21.102 3.47a.75.75 0 0 1 0 1.06l-8.486 8.486a1.75 1.75 0 0 0 2.467 2.483l4.958-4.958a.75.75 0 0 1 1.06 1.06l-7.778 7.779a.75.75 0 0 1-.324.19L3.1 22.4a.75.75 0 0 1-.736-1.252L20.041 3.47a.75.75 0 0 1 1.06 0ZM5.47 20.16l5.208-5.209c.129.586.421 1.144.877 1.6a3.24 3.24 0 0 0 1.598.875l-.754.755-6.93 1.98Z",
              clipRule: "evenodd"
            })]
          }),
          Pn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.75 1.25h-9.5v9.5h9.5zm-8 8v-6.5h6.5v6.5zm18.352-5.78a.75.75 0 0 1 0 1.06l-8.486 8.486a1.75 1.75 0 0 0 2.468 2.482l4.957-4.957a.75.75 0 0 1 1.06 1.06l-7.778 7.779a.75.75 0 0 1-.324.19L3.1 22.4a.75.75 0 0 1-.736-1.252L20.041 3.47a.75.75 0 0 1 1.06 0ZM5.47 20.16l5.209-5.209c.128.586.42 1.144.876 1.6a3.24 3.24 0 0 0 1.598.875l-.754.755-6.93 1.98Z",
              clipRule: "evenodd"
            })]
          }),
          kn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.75 1.25h-9.5V4a.75.75 0 0 0 1.5 0V2.75h2.5v6.5H4.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6.5h2.5V4a.75.75 0 0 0 1.5 0zm10.352 2.22a.75.75 0 0 1 0 1.06l-8.486 8.486a1.75 1.75 0 0 0 2.468 2.482l4.957-4.957a.75.75 0 0 1 1.06 1.06l-4.95 4.95-.01.01-2.818 2.819a.75.75 0 0 1-.324.19L3.1 22.4a.75.75 0 0 1-.736-1.252L20.041 3.47a.75.75 0 0 1 1.06 0ZM5.47 20.16l5.209-5.209c.128.586.42 1.144.876 1.6a3.24 3.24 0 0 0 1.598.875l-.754.755-6.93 1.98Z",
              clipRule: "evenodd"
            })]
          }),
          An = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1zM1 14a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm11.496-9.74h-1.222L9.01 10h1.205l.46-1.263h2.418L13.545 10h1.206zm-.615 1.132.852 2.337h-1.697zm6.845-1.132h-1.222L15.241 10h1.205l.46-1.263h2.418L19.775 10h1.206zm-.615 1.132.853 2.337h-1.698zm-.492 8.868h1.222L21.096 20H19.89l-.45-1.263h-2.42L16.561 20h-1.205zm1.46 3.469-.853-2.337-.845 2.337h1.697ZM12.61 14.26h-1.222L9.126 20h1.205l.46-1.263h2.418L13.66 20h1.206l-2.255-5.74Zm-.615 1.132.852 2.337H11.15zM5.159 14.26H6.38L8.636 20H7.43l-.45-1.263H4.56L4.1 20H2.897l2.263-5.74Zm1.46 3.469-.853-2.337-.845 2.337z",
              clipRule: "evenodd"
            })]
          }),
          zn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10.726 1.26h-1.222L15.241 10h1.205l.46-1.263h2.418L19.775 10h1.206zm-.615 1.132.853 2.337h-1.698zM11.274 4.26h1.222L14.75 10h-1.206l-.45-1.263h-2.42L10.216 10H9.011zm1.46 3.469-.853-2.337-.845 2.337h1.697ZM2 13a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1z",
              clipRule: "evenodd"
            })]
          }),
          Tn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M17.47 3.47a.75.75 0 0 0 0 1.06l2.72 2.72H17a.75.75 0 0 0 0 1.5h3.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23.06 8l-4.53-4.53a.75.75 0 0 0-1.06 0m-8 0a.75.75 0 0 0 0 1.06l2.72 2.72H10a6.75 6.75 0 0 0 0 13.5h2a.75.75 0 0 0 0-1.5h-2a5.25 5.25 0 1 1 0-10.5h2.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06L15.06 8l-4.53-4.53a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          On = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15.47 3.47a.75.75 0 0 0 0 1.06l2.72 2.72H10a6.75 6.75 0 0 0 0 13.5h2a.75.75 0 0 0 0-1.5h-2a5.25 5.25 0 1 1 0-10.5h8.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06L21.06 8l-4.53-4.53a.75.75 0 0 0-1.06 0",
              clipRule: "evenodd"
            })]
          }),
          In = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M20.75 20.25V22A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22V6.5a.75.75 0 0 1 .22-.53l5.5-5.5A.75.75 0 0 1 9.5.25H19c.966 0 1.75.784 1.75 1.75v1.75h1.75a.75.75 0 0 1 0 1.5h-1.75v3.5h1.75a.75.75 0 0 1 0 1.5h-1.75v3.5h1.75a.75.75 0 0 1 0 1.5h-1.75v3.5h1.75a.75.75 0 0 1 0 1.5zM19 1.75a.25.25 0 0 1 .25.25v1.75H17.5a.75.75 0 0 0 0 1.5h1.75v3.5H17.5a.75.75 0 0 0 0 1.5h1.75v3.5H17.5a.75.75 0 0 0 0 1.5h1.75v3.5H17.5a.75.75 0 0 0 0 1.5h1.75V22a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25V7.25H9.5a.75.75 0 0 0 .75-.75V1.75z",
              clipRule: "evenodd"
            })]
          }),
          Fn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M11.006 2.564a.75.75 0 0 1 .988-1.128l4 3.5a.75.75 0 0 1 0 1.128l-4 3.5a.75.75 0 0 1-.988-1.128l2.558-2.239a6.25 6.25 0 1 0 4.686 6.053.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.397-7.632z"
            })]
          }),
          Mn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              d: "M12.994 2.564a.75.75 0 0 0-.988-1.128l-4 3.5a.75.75 0 0 0 0 1.128l4 3.5a.75.75 0 0 0 .988-1.128l-2.558-2.239A6.25 6.25 0 1 1 5.75 12.25a.75.75 0 0 0-1.5 0 7.75 7.75 0 1 0 6.397-7.632z"
            })]
          }),
          Rn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M19.25 9A4.25 4.25 0 0 0 15 4.75h-4a.75.75 0 0 1 0-1.5h4A5.75 5.75 0 0 1 20.75 9v3.19l1.72-1.72a.75.75 0 1 1 1.06 1.06L20 15.06l-3.53-3.53a.75.75 0 1 1 1.06-1.06l1.72 1.72z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M4 9.25h9c.966 0 1.75.784 1.75 1.75v9A1.75 1.75 0 0 1 13 21.75H4A1.75 1.75 0 0 1 2.25 20v-9c0-.966.784-1.75 1.75-1.75m9 1.5H4a.25.25 0 0 0-.25.25v9c0 .138.112.25.25.25h9a.25.25 0 0 0 .25-.25v-9a.25.25 0 0 0-.25-.25",
              clipRule: "evenodd"
            })]
          }),
          jn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M4.75 9A4.25 4.25 0 0 1 9 4.75h4a.75.75 0 0 0 0-1.5H9A5.75 5.75 0 0 0 3.25 9v3.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06L4 15.06l3.53-3.53a.75.75 0 1 0-1.06-1.06l-1.72 1.72z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M20 9.25h-9A1.75 1.75 0 0 0 9.25 11v9c0 .966.784 1.75 1.75 1.75h9A1.75 1.75 0 0 0 21.75 20v-9A1.75 1.75 0 0 0 20 9.25m-9 1.5h9a.25.25 0 0 1 .25.25v9a.25.25 0 0 1-.25.25h-9a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25",
              clipRule: "evenodd"
            })]
          }),
          Bn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 6H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1M1.5 16.5v-9h3.75V11a.75.75 0 0 0 1.5 0V7.5h1.5V13a.75.75 0 0 0 1.5 0V7.5h1.5V11a.75.75 0 0 0 1.5 0V7.5h1.5V13a.75.75 0 0 0 1.5 0V7.5h1.5V11a.75.75 0 0 0 1.5 0V7.5h3.75v9z",
              clipRule: "evenodd"
            })]
          }),
          Nn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#scale-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M7.25 1A.75.75 0 0 1 8 .25h15a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1 0-1.5h6.75V1.75H8.75V9a.75.75 0 0 1-1.5 0zm-7 12a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5H1.75v8.5h8.5V18a.75.75 0 0 1 1.5 0v5a.75.75 0 0 1-.75.75H1A.75.75 0 0 1 .25 23zM12.5 4.75a.75.75 0 0 0 0 1.5h4.19L4.47 18.47a.75.75 0 1 0 1.06 1.06L17.75 7.31v4.19a.75.75 0 0 0 1.5 0V4.75z",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "scale-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Ln = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.309 13.248a4 4 0 1 0-1.06 1.06l2.22 2.222a.75.75 0 1 0 1.061-1.06zM11 13.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m0-1.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17",
              clipRule: "evenodd"
            })]
          }),
          Vn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M3.75 10.5a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0m6.75-8.25a8.25 8.25 0 1 0 5.28 14.59l4.69 4.69a.75.75 0 0 0 1.06-1.06l-4.69-4.69A8.25 8.25 0 0 0 10.5 2.25",
              clipRule: "evenodd"
            })]
          }),
          Kn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M5.75 8.5a.75.75 0 0 1 .75-.75H14a.75.75 0 0 1 0 1.5H6.5a.75.75 0 0 1-.75-.75m.75 2.25a.75.75 0 0 0 0 1.5H11a.75.75 0 0 0 0-1.5z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M14.532 16.593a8 8 0 1 1 1.155-.967l5.843 5.844a.75.75 0 1 1-1.06 1.06zM16.5 10a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0",
              clipRule: "evenodd"
            })]
          }),
          qn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M3.25 5A2.75 2.75 0 0 1 6 2.25h9A2.75 2.75 0 0 1 17.75 5h-1.5c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25v1.5A2.75 2.75 0 0 1 3.25 14zm14.857 6.441a.75.75 0 0 0-1.213-.882l-3.422 4.705-1.386-1.732a.75.75 0 1 0-1.172.937l2 2.5a.75.75 0 0 0 1.193-.028z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.25 9A2.75 2.75 0 0 1 10 6.25h9A2.75 2.75 0 0 1 21.75 9v9A2.75 2.75 0 0 1 19 20.75h-9A2.75 2.75 0 0 1 7.25 18zM10 7.75c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h9c.69 0 1.25-.56 1.25-1.25V9c0-.69-.56-1.25-1.25-1.25z",
              clipRule: "evenodd"
            })]
          }),
          Hn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 4H.5V2A1.5 1.5 0 0 1 2 .5h2V2H2zm20 0h1.5V2A1.5 1.5 0 0 0 22 .5h-2V2h2zm0 3h1.5v3.5H22zm0 6.5h1.5V17H22zm0 6.5h1.5v2a1.5 1.5 0 0 1-1.5 1.5h-2V22h2zM2 7H.5v3.5H2zm0 6.5H.5V17H2zM2 20H.5v2A1.5 1.5 0 0 0 2 23.5h2V22H2zm5 2v1.5h3.5V22zm6.5 0v1.5H17V22zM17 2V.5h-3.5V2zm-6.5 0V.5H7V2z",
              clipRule: "evenodd"
            })]
          }),
          Un = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.5 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.32 1.25a1.75 1.75 0 0 0-1.716 1.407L9.203 4.66c-.01.053-.06.132-.171.178-.109.045-.196.025-.243-.006L7.088 3.699a1.75 1.75 0 0 0-2.208.219l-.962.962a1.75 1.75 0 0 0-.219 2.208l1.134 1.7c.031.048.051.135.006.244-.046.111-.125.16-.178.17l-2.004.402A1.75 1.75 0 0 0 1.25 11.32v1.36a1.75 1.75 0 0 0 1.407 1.716l2.004.401c.053.01.132.06.178.171.045.109.025.196-.006.243l-1.134 1.701a1.75 1.75 0 0 0 .219 2.208l.962.962a1.75 1.75 0 0 0 2.208.219l1.7-1.134c.048-.031.135-.051.244-.006.112.046.16.125.171.178l.4 2.004a1.75 1.75 0 0 0 1.717 1.407h1.36a1.75 1.75 0 0 0 1.716-1.407l.401-2.004c.01-.053.06-.132.171-.178.109-.045.196-.025.243.006l1.701 1.134a1.75 1.75 0 0 0 2.208-.219l.962-.962a1.75 1.75 0 0 0 .219-2.208l-1.134-1.7c-.031-.048-.051-.135-.006-.244.046-.111.125-.16.178-.17l2.004-.402a1.75 1.75 0 0 0 1.407-1.716v-1.36a1.75 1.75 0 0 0-1.407-1.716l-2.004-.401c-.053-.01-.131-.06-.178-.171-.045-.109-.025-.196.006-.243l1.134-1.701a1.75 1.75 0 0 0-.219-2.208l-.962-.962a1.75 1.75 0 0 0-2.208-.219l-1.7 1.134c-.048.031-.135.051-.244.006-.111-.046-.16-.125-.17-.178l-.402-2.004A1.75 1.75 0 0 0 12.68 1.25zm-.245 1.701a.25.25 0 0 1 .245-.201h1.36a.25.25 0 0 1 .245.201l.401 2.004c.122.608.558 1.058 1.067 1.27a1.76 1.76 0 0 0 1.65-.144l1.701-1.134a.25.25 0 0 1 .316.031l.962.962a.25.25 0 0 1 .03.316l-1.133 1.7a1.76 1.76 0 0 0-.143 1.65c.211.51.661.946 1.269 1.068l2.004.4a.25.25 0 0 1 .201.246v1.36a.25.25 0 0 1-.201.245l-2.004.401c-.608.122-1.058.558-1.27 1.067a1.76 1.76 0 0 0 .144 1.65l1.134 1.701a.25.25 0 0 1-.031.316l-.962.962a.25.25 0 0 1-.316.03l-1.7-1.133a1.76 1.76 0 0 0-1.65-.143c-.51.211-.946.661-1.068 1.269l-.4 2.004a.25.25 0 0 1-.246.201h-1.36a.25.25 0 0 1-.245-.201l-.401-2.004c-.122-.608-.558-1.058-1.067-1.27a1.76 1.76 0 0 0-1.65.144l-1.701 1.134a.25.25 0 0 1-.316-.031l-.962-.962a.25.25 0 0 1-.03-.316l1.133-1.7a1.76 1.76 0 0 0 .144-1.65c-.212-.51-.662-.946-1.27-1.068l-2.004-.4a.25.25 0 0 1-.201-.246v-1.36a.25.25 0 0 1 .201-.245l2.004-.401c.608-.122 1.058-.558 1.27-1.067a1.76 1.76 0 0 0-.144-1.65L4.947 6.256a.25.25 0 0 1 .031-.316l.962-.962a.25.25 0 0 1 .316-.03l1.7 1.133a1.76 1.76 0 0 0 1.65.143c.51-.211.946-.661 1.068-1.269z",
              clipRule: "evenodd"
            })]
          }),
          Zn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M2.75 9a6.25 6.25 0 0 1 12.456-.75H10A1.75 1.75 0 0 0 8.25 10v5.206A6.25 6.25 0 0 1 2.75 9m5.5 7.714a7.751 7.751 0 1 1 8.464-8.464H21c.966 0 1.75.784 1.75 1.75v11A1.75 1.75 0 0 1 21 22.75H10A1.75 1.75 0 0 1 8.25 21zM9.75 10a.25.25 0 0 1 .25-.25h11a.25.25 0 0 1 .25.25v11a.25.25 0 0 1-.25.25H10a.25.25 0 0 1-.25-.25z",
              clipRule: "evenodd"
            })]
          }),
          $n = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "m12 .94 3.53 3.53a.75.75 0 0 1-1.06 1.06l-1.72-1.72V14a.75.75 0 0 1-1.5 0V3.81L9.53 5.53a.75.75 0 0 1-1.06-1.06zM6 8.75c-.69 0-1.25.56-1.25 1.25v10c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25V10c0-.69-.56-1.25-1.25-1.25h-3v-1.5h3A2.75 2.75 0 0 1 20.75 10v10A2.75 2.75 0 0 1 18 22.75H6A2.75 2.75 0 0 1 3.25 20V10A2.75 2.75 0 0 1 6 7.25h3v1.5z",
              clipRule: "evenodd"
            })]
          }),
          Gn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M18.5 7.5a3 3 0 1 0-2.892-2.198L7.641 9.9a3 3 0 1 0 0 4.202l7.967 4.597A3.004 3.004 0 0 0 18.5 22.5a3 3 0 1 0-2.141-5.101l-7.967-4.597a3 3 0 0 0 0-1.604L16.359 6.6a3 3 0 0 0 2.141.9m1.5-3a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M7 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m13 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
              clipRule: "evenodd"
            })]
          }),
          Wn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 8a.75.75 0 0 0-1.5 0v3.25H8a.75.75 0 0 0 0 1.5h3.25V16a.75.75 0 0 0 1.5 0v-3.25H16a.75.75 0 0 0 0-1.5h-3.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m12.45 1.4.006.004.028.021.123.086c.11.076.276.187.492.32.431.268 1.06.628 1.84.988C16.505 3.542 18.645 4.25 21 4.25a.75.75 0 0 1 .75.75v5.201a12.75 12.75 0 0 1-7.572 11.652l-1.873.832a.75.75 0 0 1-.61 0l-1.873-.832A12.75 12.75 0 0 1 2.25 10.2V5A.75.75 0 0 1 3 4.25c2.355 0 4.495-.708 6.06-1.431.78-.36 1.41-.72 1.841-.987a13 13 0 0 0 .615-.407l.028-.02.006-.005a.75.75 0 0 1 .9 0m-.758 1.706q.173-.107.308-.196a19 19 0 0 0 2.31 1.27c1.524.704 3.6 1.419 5.94 1.549v4.472a11.25 11.25 0 0 1-6.68 10.28L12 21.18l-1.57-.697a11.25 11.25 0 0 1-6.68-10.28V5.728c2.34-.13 4.416-.845 5.94-1.548.844-.39 1.528-.78 2.002-1.075Z",
              clipRule: "evenodd"
            })]
          }),
          Yn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M16.53 10.53a.75.75 0 0 0-1.06-1.06L11 13.94l-1.97-1.97a.75.75 0 1 0-1.06 1.06l2.382 2.382a.917.917 0 0 0 1.296 0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m12.45 1.4.006.004.028.021.123.086c.11.076.276.187.492.32.431.268 1.06.628 1.84.988C16.505 3.542 18.645 4.25 21 4.25a.75.75 0 0 1 .75.75v5.201a12.75 12.75 0 0 1-7.572 11.652l-1.873.832a.75.75 0 0 1-.61 0l-1.873-.832A12.75 12.75 0 0 1 2.25 10.2V5A.75.75 0 0 1 3 4.25c2.355 0 4.495-.708 6.06-1.431.78-.36 1.41-.72 1.841-.987a13 13 0 0 0 .615-.407l.028-.02.006-.005a.75.75 0 0 1 .9 0m-.758 1.706q.173-.107.308-.196a19 19 0 0 0 2.31 1.27c1.524.704 3.6 1.419 5.94 1.549v4.472a11.25 11.25 0 0 1-6.68 10.28L12 21.18l-1.57-.697a11.25 11.25 0 0 1-6.68-10.28V5.728c2.34-.13 4.416-.845 5.94-1.548.844-.39 1.528-.78 2.002-1.075Z",
              clipRule: "evenodd"
            })]
          }),
          Xn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M13.25 15.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12.75 7a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12.45 1.4a.75.75 0 0 0-.9 0l-.006.004-.028.021a13 13 0 0 1-.614.406 17 17 0 0 1-1.841.988C7.495 3.542 5.355 4.25 3 4.25a.75.75 0 0 0-.75.75v5.201a12.75 12.75 0 0 0 7.572 11.652l1.873.832a.75.75 0 0 0 .61 0l1.873-.832A12.75 12.75 0 0 0 21.75 10.2V5a.75.75 0 0 0-.75-.75c-2.355 0-4.495-.708-6.06-1.431a17 17 0 0 1-1.841-.987 13 13 0 0 1-.615-.407l-.028-.02zM12 2.91a19 19 0 0 1-2.31 1.27c-1.525.705-3.6 1.42-5.94 1.55v4.472a11.25 11.25 0 0 0 6.68 10.28l1.57.698 1.57-.697a11.25 11.25 0 0 0 6.68-10.28V5.728c-2.34-.13-4.416-.845-5.94-1.548A19 19 0 0 1 12 2.91",
              clipRule: "evenodd"
            })]
          }),
          Qn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M15.359 9.702a.75.75 0 1 0-1.06-1.06L12 10.938 9.702 8.641a.75.75 0 0 0-1.06 1.06L10.938 12 8.64 14.298a.75.75 0 1 0 1.06 1.06l2.3-2.296 2.298 2.298a.75.75 0 0 0 1.06-1.06L13.062 12z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m12.45 1.4.006.004.028.021.123.086c.11.076.276.187.492.32.431.268 1.06.628 1.84.988C16.505 3.542 18.645 4.25 21 4.25a.75.75 0 0 1 .75.75v5.201a12.75 12.75 0 0 1-7.572 11.652l-1.873.832a.75.75 0 0 1-.61 0l-1.873-.832A12.75 12.75 0 0 1 2.25 10.2V5A.75.75 0 0 1 3 4.25c2.355 0 4.495-.708 6.06-1.431.78-.36 1.41-.72 1.841-.987a13 13 0 0 0 .615-.407l.028-.02.006-.005a.75.75 0 0 1 .9 0m-.758 1.706q.173-.107.308-.196a19 19 0 0 0 2.31 1.27c1.524.704 3.6 1.419 5.94 1.549v4.472a11.25 11.25 0 0 1-6.68 10.28L12 21.18l-1.57-.697a11.25 11.25 0 0 1-6.68-10.28V5.728c2.34-.13 4.416-.845 5.94-1.548.844-.39 1.528-.78 2.002-1.075Z",
              clipRule: "evenodd"
            })]
          }),
          Jn = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-1.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7",
              clipRule: "evenodd"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m23.627 11.589.27.411-.27.41L23 12c.627.41.627.412.627.412l-.001.002-.004.005-.012.018-.044.066q-.058.083-.167.236a21.8 21.8 0 0 1-2.992 3.319c-2.003 1.8-4.927 3.692-8.407 3.692s-6.404-1.892-8.408-3.692a21.8 21.8 0 0 1-2.991-3.319 13 13 0 0 1-.21-.302l-.013-.018-.004-.005-.001-.003L1 12c-.627-.41-.627-.412-.627-.412l.001-.002.004-.005.012-.018.044-.066q.058-.083.167-.236a21.8 21.8 0 0 1 2.992-3.319C5.596 6.142 8.52 4.25 12 4.25s6.404 1.892 8.407 3.692a21.8 21.8 0 0 1 2.992 3.319 13 13 0 0 1 .21.302l.013.018.004.005zM2.4 12.623A18 18 0 0 1 1.918 12a20.3 20.3 0 0 1 2.677-2.942C6.487 7.358 9.063 5.75 12 5.75s5.513 1.608 7.405 3.308A20.3 20.3 0 0 1 22.082 12a20.3 20.3 0 0 1-2.677 2.942c-1.892 1.7-4.468 3.308-7.405 3.308s-5.513-1.608-7.405-3.308a20 20 0 0 1-2.195-2.32ZM23 12l.627-.411z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M.373 12.41.103 12l.27-.41L1 12z"
            })]
          }),
          er = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.345 11.595a.75.75 0 0 0 0 1.5h13.19l-2.72 2.72a.75.75 0 0 0 1.06 1.06l4.53-4.53-4.53-4.53a.75.75 0 0 0-1.06 1.06l2.72 2.72z"
            }), r.jsx("path", {
              d: "M7.345 4.095a.75.75 0 0 0 0-1.5h-3a2.75 2.75 0 0 0-2.75 2.75v14a2.75 2.75 0 0 0 2.75 2.75h3a.75.75 0 0 0 0-1.5h-3c-.69 0-1.25-.56-1.25-1.25v-14c0-.69.56-1.25 1.25-1.25z"
            })]
          }),
          tr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M16.322 10.322A.75.75 0 0 0 15.26 9.26l-4.72 4.72-2.26-2.262a.75.75 0 1 0-1.06 1.06l3.32 3.323 5.78-5.78Z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M13.217 1.134a1.75 1.75 0 0 0-2.434 0L9.111 2.752a.25.25 0 0 1-.21.068l-2.304-.326a1.75 1.75 0 0 0-1.968 1.43l-.403 2.292a.25.25 0 0 1-.129.178l-2.056 1.09A1.75 1.75 0 0 0 1.29 9.8l1.023 2.091a.25.25 0 0 1 0 .22L1.289 14.2a1.75 1.75 0 0 0 .752 2.315l2.056 1.09a.25.25 0 0 1 .13.179l.402 2.292a1.75 1.75 0 0 0 1.968 1.43l2.305-.326a.25.25 0 0 1 .209.068l1.672 1.618a1.75 1.75 0 0 0 2.434 0l1.672-1.618a.25.25 0 0 1 .21-.068l2.304.326a1.75 1.75 0 0 0 1.969-1.43l.402-2.292a.25.25 0 0 1 .129-.178l2.056-1.09a1.75 1.75 0 0 0 .752-2.315l-1.022-2.091a.25.25 0 0 1 0-.22L22.71 9.8a1.75 1.75 0 0 0-.752-2.315l-2.056-1.09a.25.25 0 0 1-.13-.179l-.401-2.292a1.75 1.75 0 0 0-1.97-1.43l-2.304.326a.25.25 0 0 1-.209-.068zm-1.39 1.078a.25.25 0 0 1 .347 0l1.673 1.618c.388.375.927.55 1.461.475l2.305-.326a.25.25 0 0 1 .281.204l.402 2.293c.094.531.427.99.904 1.243l2.056 1.09a.25.25 0 0 1 .107.332l-1.022 2.09a1.75 1.75 0 0 0 0 1.537l1.022 2.091a.25.25 0 0 1-.107.331L19.2 16.28a1.75 1.75 0 0 0-.904 1.244l-.402 2.293a.25.25 0 0 1-.281.204l-2.305-.326a1.75 1.75 0 0 0-1.461.475l-1.673 1.618a.25.25 0 0 1-.348 0l-1.673-1.618a1.75 1.75 0 0 0-1.461-.475l-2.305.326a.25.25 0 0 1-.281-.204l-.402-2.293a1.75 1.75 0 0 0-.904-1.243l-2.056-1.09a.25.25 0 0 1-.107-.332l1.022-2.09a1.75 1.75 0 0 0 0-1.537L2.637 9.14a.25.25 0 0 1 .107-.331L4.8 7.72a1.75 1.75 0 0 0 .904-1.244l.402-2.293a.25.25 0 0 1 .281-.204l2.305.326a1.75 1.75 0 0 0 1.461-.475z",
              clipRule: "evenodd"
            })]
          }),
          nr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.965 4.668C5.773 5.785 3.587 7.128 2.488 8.07a.75.75 0 1 1-.976-1.14C2.747 5.873 5.06 4.466 7.285 3.333a34 34 0 0 1 3.213-1.455c.942-.359 1.85-.627 2.502-.627.888 0 1.43.64 1.724 1.306.296.668.446 1.553.505 2.523.032.501.04 1.043.026 1.613a17 17 0 0 1 1.982-.894.8.8 0 0 1 .263-.048c.307 0 .52.16.634.28.11.116.176.244.217.334.082.184.14.404.186.604.064.289.126.655.188 1.022q.037.225.076.442c.079.444.163.867.264 1.22.834-1.237 1.904-3.237 2.193-5.258a.75.75 0 1 1 1.485.212c-.428 2.993-2.288 5.82-3.167 6.874a.75.75 0 0 1-.911.19c-.3-.149-.5-.396-.635-.614a3.6 3.6 0 0 1-.327-.733c-.168-.502-.285-1.097-.38-1.63l-.085-.501q-.067-.406-.13-.726c-.656.283-1.311.62-1.952 1a43 43 0 0 1-1.295 7.285H22.5a.75.75 0 0 1 0 1.499h-9.079c-.218.682-.45 1.325-.693 1.912-.4.966-.845 1.817-1.332 2.44-.463.592-1.096 1.148-1.896 1.148-.94 0-1.523-.714-1.854-1.378-.346-.693-.555-1.584-.67-2.467a14 14 0 0 1-.112-1.655H2a.75.75 0 0 1 0-1.5h4.934c.07-.61.193-1.18.395-1.585.81-1.618 2.26-3.32 3.997-4.798a22 22 0 0 1 2.39-1.776c.053-.883.06-1.703.016-2.42-.056-.905-.191-1.582-.38-2.008-.184-.416-.322-.413-.35-.413H13c-.348 0-1.024.17-1.967.529a33 33 0 0 0-3.068 1.39Zm.399 12.582c.005.48.038.98.1 1.463.104.806.285 1.51.524 1.99.254.51.451.547.512.547.075 0 .32-.069.714-.571.367-.47.752-1.182 1.128-2.091.172-.415.34-.864.5-1.338zm3.941-1.5H8.446c.06-.438.143-.75.225-.915.69-1.382 1.99-2.93 3.628-4.327q.597-.509 1.24-.977a41 41 0 0 1-.35 2.337 41 41 0 0 1-.884 3.882m4.676-8.774.002.004z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M1.97 9.97a.75.75 0 0 1 1.06 0l.97.97.97-.97a.75.75 0 0 1 1.06 1.06l-.97.97.97.97a.75.75 0 1 1-1.06 1.06L4 13.06l-.97.97a.75.75 0 0 1-1.06-1.06l.97-.97-.97-.97a.75.75 0 0 1 0-1.06"
            })]
          }),
          rr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.763 3.177c1.102-1.103 2.987-.322 2.987 1.237v15.172c0 1.559-1.885 2.34-2.987 1.237l-5.5-5.5a.25.25 0 0 0-.177-.073H2A1.75 1.75 0 0 1 .25 13.5V10c0-.966.784-1.75 1.75-1.75h3.586a.25.25 0 0 0 .177-.073zm1.487 1.237a.25.25 0 0 0-.427-.177l-5 5a1.75 1.75 0 0 1-1.237.513H2a.25.25 0 0 0-.25.25v3.5c0 .138.112.25.25.25h3.086c.464 0 .909.184 1.237.513l5.5 5.5a.25.25 0 0 0 .427-.177z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M15.712 8.227a.75.75 0 0 1 1.06 0 5.75 5.75 0 0 1 0 8.132.75.75 0 1 1-1.06-1.06 4.25 4.25 0 0 0 0-6.011.75.75 0 0 1 0-1.061"
            }), r.jsx("path", {
              d: "M20.03 5.47a.75.75 0 1 0-1.06 1.06 8.25 8.25 0 0 1 0 11.668.75.75 0 0 0 1.06 1.06c3.808-3.807 3.808-9.98 0-13.788"
            })]
          }),
          or = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 1.25A4.75 4.75 0 0 0 7.25 6v6a4.75 4.75 0 1 0 9.5 0V6A4.75 4.75 0 0 0 12 1.25M8.75 6a3.25 3.25 0 0 1 6.5 0v6a3.25 3.25 0 0 1-6.5 0z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M5.75 9a.75.75 0 0 0-1.5 0v3a7.75 7.75 0 0 0 7 7.714v2.536H8.5a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5h-2.75v-2.536a7.75 7.75 0 0 0 7-7.714V9a.75.75 0 0 0-1.5 0v3a6.25 6.25 0 1 1-12.5 0z"
            })]
          }),
          ir = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4.5 4.5v15h15v-15zM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z",
              clipRule: "evenodd"
            })]
          }),
          ar = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7 6.25a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H17a.75.75 0 0 0 0-1.5zm1.088 15.216c.457-.61 1.37-.606 1.812-.016 1.05 1.4 3.15 1.4 4.2 0 .443-.59 1.355-.593 1.812.016 1.035 1.38 3.119 1.446 4.21.082l.464-.58a.75.75 0 0 0-1.172-.936l-.463.579c-.465.58-1.379.569-1.839-.045-1.042-1.39-3.155-1.426-4.212-.016-.45.6-1.35.6-1.8 0-1.057-1.41-3.17-1.374-4.212.016-.46.614-1.374.626-1.839.045l-.463-.58a.75.75 0 1 0-1.172.938l.464.579c1.091 1.364 3.175 1.298 4.21-.082"
            })]
          }),
          sr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M11.75 1A4.749 4.749 0 0 0 9 9.62V15H4.767a2.75 2.75 0 0 0-2.75 2.704L2 18.738a.75.75 0 0 0 .75.762h18a.75.75 0 0 0 .75-.75v-1A2.75 2.75 0 0 0 18.75 15H14.5V9.62A4.749 4.749 0 0 0 11.75 1M8.5 5.75a3.25 3.25 0 0 1 3.25-3.25 3.249 3.249 0 0 1 1.626 6.06.75.75 0 0 0-.376.65v6.54c0 .414.336.75.75.75h5c.69 0 1.25.56 1.25 1.25V18H3.513l.004-.27a1.25 1.25 0 0 1 1.25-1.23H9.75a.75.75 0 0 0 .75-.75V9.21a.75.75 0 0 0-.376-.65A3.23 3.23 0 0 1 8.5 5.75",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M2.75 21a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5z"
            })]
          }),
          lr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 .75a.75.75 0 0 1 .692.462l2.734 6.572 7.095.57a.75.75 0 0 1 .428 1.316l-5.406 4.631 1.652 6.924a.75.75 0 0 1-1.12.814L12 18.33l-6.075 3.71a.75.75 0 0 1-1.12-.814l1.651-6.924-5.406-4.63a.75.75 0 0 1 .428-1.318l7.096-.569 2.733-6.572A.75.75 0 0 1 12 .75m0 2.703-2.217 5.33a.75.75 0 0 1-.633.46l-5.755.461L7.78 13.46a.75.75 0 0 1 .242.744l-1.34 5.615 4.927-3.01a.75.75 0 0 1 .782 0l4.926 3.01-1.34-5.615a.75.75 0 0 1 .243-.744l4.384-3.756-5.755-.461a.75.75 0 0 1-.632-.46z",
              clipRule: "evenodd"
            })]
          }),
          ur = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 0 1 0 1.5h-4.25v2h-1.5v-2H7A.75.75 0 0 1 6.25 7m5 11v-3.75h1.5V18a.75.75 0 0 1-1.5 0M5 11.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
            })]
          }),
          cr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "m18.59 14.99 3.02-3.01h-.01a2.76 2.76 0 0 0 0-3.89l-.53-.53-3.36 3.36c-.3.28-.76.3-1.06 0s-.29-.77 0-1.06c1.24-1.24 1.51-2.89 1.33-4.22-.12-.93-.6-1.77-1.26-2.43L14.17.66a.76.76 0 0 0-.74-.18.7.7 0 0 0-.52.55v.04c-.02.03-.03.08-.03.14-.046.11-.091.277-.145.473l-.015.057c-.13.46-.35 1.1-.65 1.82-.43 1.05-1.03 2.26-1.83 3.34-.28.38-.22.93.12 1.27l6.82 6.82c.39.39 1.02.39 1.41 0"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "m8.35 8.27 8.84 8.84c.39.39.39 1.02 0 1.41l-.53.53c-.68.69-1.78.69-2.47 0l-1.96-1.96c-.12-.1-.3-.09-.39.04L8.8 21.68c-1.25 1.9-3.94 2.17-5.56.56s-1.36-4.31.54-5.56l4.56-3.05c.13-.09.15-.28.04-.39l-1.97-1.95c-.68-.69-.68-1.81 0-2.49l.53-.53a.996.996 0 0 1 1.41 0m-3.19 10.6a.996.996 0 0 0 0 1.41c.39.4 1.02.38 1.41 0s.38-1.02 0-1.41-1.02-.38-1.41 0",
              clipRule: "evenodd"
            })]
          }),
          dr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.58 18.877a1 1 0 1 0-1.414 1.414 1 1 0 0 0 1.414-1.414"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M7.465 7.74a1.75 1.75 0 0 1 2.262-.182c1.055-1.231 1.823-2.722 2.347-3.992a20 20 0 0 0 .8-2.355q.025-.092.036-.139l.01-.042a.75.75 0 0 1 1.263-.36l4.93 4.931.02.018 1.414 1.415.018.018 1.042 1.043a2.75 2.75 0 0 1 0 3.889l-3.724 3.724a1.75 1.75 0 0 1-.164 2.286l-1.06 1.06a1.75 1.75 0 0 1-2.476 0l-1.965-1.965a.25.25 0 0 0-.385.038l-3.039 4.558a3.62 3.62 0 1 1-5.019-5.02l4.558-3.038a.25.25 0 0 0 .038-.385l-1.966-1.966a1.75 1.75 0 0 1 0-2.475l1.061-1.06Zm6.553-5.113 3.89 3.89.01.089c.02.193.032.476-.01.813-.084.667-.375 1.566-1.251 2.442a.75.75 0 0 0 1.06 1.06l2.298-2.297.53.53a1.25 1.25 0 0 1 0 1.768l-3.711 3.712-6.03-6.03C12.04 7.187 12.9 5.5 13.462 4.138c.232-.565.416-1.08.557-1.51Zm2.64 13.952-.328-.328-.027-.026-7.071-7.07-.026-.028L8.88 8.8a.25.25 0 0 0-.353 0L7.465 9.861a.25.25 0 0 0 0 .354l1.966 1.966a1.75 1.75 0 0 1-.267 2.693l-4.558 3.039a2.12 2.12 0 1 0 2.939 2.939l3.039-4.558a1.75 1.75 0 0 1 2.693-.267l1.966 1.966a.25.25 0 0 0 .354 0l1.06-1.06a.25.25 0 0 0 0-.354Z",
              clipRule: "evenodd"
            })]
          }),
          pr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.013 2.747c.093 2.94.689 9.343 2.195 11.063a.6.6 0 0 0 .463.19h6.657a.6.6 0 0 0 .464-.19c1.505-1.72 2.101-8.122 2.194-11.063A.73.73 0 0 0 17.25 2H6.75a.73.73 0 0 0-.737.747M9 16h6l-2.064 5.503c-.324.865-1.548.865-1.872 0z"
            })]
          }),
          hr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7.75 2a.75.75 0 0 0-1.5 0c0 1.225.116 3.704.402 6.128.143 1.213.33 2.428.571 3.472.235 1.018.54 1.97.964 2.587.292.424.755.563 1.124.563h5.378c.37 0 .832-.14 1.124-.563.423-.617.729-1.57.963-2.587.241-1.044.429-2.259.572-3.472.286-2.424.402-4.903.402-6.128a.75.75 0 0 0-1.5 0c0 1.164-.112 3.584-.392 5.953-.14 1.183-.32 2.339-.543 3.31-.213.925-.45 1.602-.682 1.987H9.367c-.233-.385-.47-1.062-.683-1.987-.224-.971-.404-2.127-.543-3.31-.28-2.37-.392-4.79-.392-5.953Z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.5 15.25a.75.75 0 0 0-.716.974l1.546 4.945c.511 1.638 2.829 1.638 3.34 0l1.546-4.945a.75.75 0 0 0-.716-.974zm2.261 5.472-1.24-3.972h2.959l-1.241 3.972a.25.25 0 0 1-.478 0",
              clipRule: "evenodd"
            })]
          }),
          fr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zm3 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zM2.25 14.5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M6 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          mr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zm-.75 5.75a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M3 18.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          gr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zm0 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zm-.75 5.75a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M3 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          vr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5zm6 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5zM2.25 14.5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75M9 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          }),
          yr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M18.75 3a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25V9a.75.75 0 0 0 1.5 0V6.75H21a.75.75 0 0 0 0-1.5h-2.25z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M9.18 4.684a.75.75 0 0 0-1.36 0l-6.5 14a.75.75 0 1 0 1.36.632l2.342-5.044h6.956l2.342 5.044a.75.75 0 0 0 1.36-.632zM8.5 6.781l2.782 5.99H5.719L8.5 6.782Z",
              clipRule: "evenodd"
            })]
          }),
          br = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsxs("g", {
              clipPath: "url(#text-callout-icon_svg__a)",
              children: [r.jsx("path", {
                d: "M11 4.25a.75.75 0 0 0 0 1.5h2.25V11a.75.75 0 0 0 1.5 0V5.75H17a.75.75 0 0 0 0-1.5z"
              }), r.jsx("path", {
                fillRule: "evenodd",
                d: "M9 .25A4.75 4.75 0 0 0 4.25 5v6A4.75 4.75 0 0 0 9 15.75h10A4.75 4.75 0 0 0 23.75 11V5A4.75 4.75 0 0 0 19 .25zM5.75 5A3.25 3.25 0 0 1 9 1.75h10A3.25 3.25 0 0 1 22.25 5v6A3.25 3.25 0 0 1 19 14.25H9A3.25 3.25 0 0 1 5.75 11z",
                clipRule: "evenodd"
              }), r.jsx("path", {
                d: "M13.25 19.365V17h1.5v3a.75.75 0 0 1-.626.74L3.953 22.435a2 2 0 1 1-.247-1.48z"
              })]
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "text-callout-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          wr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4 3.25a.75.75 0 0 0 0 1.5h4.25V15a.75.75 0 0 0 1.5 0V4.75H14a.75.75 0 0 0 0-1.5zM8 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-9.75v7A2.25 2.25 0 0 1 8 17.016z",
              clipRule: "evenodd"
            })]
          }),
          xr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 0 1 0 1.5h-4.25V18a.75.75 0 0 1-1.5 0V7.75H7A.75.75 0 0 1 6.25 7",
              clipRule: "evenodd"
            })]
          }),
          Dr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 13.75h.25V19a.75.75 0 0 0 1.5 0V5.75h2.265V19a.75.75 0 0 0 1.5 0V5.75H14a.75.75 0 0 0 0-1.5H6a4.75 4.75 0 0 0 0 9.5m0-8a3.25 3.25 0 1 0 0 6.5h.25v-6.5z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M15.53 9.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06L18 11.94z"
            })]
          }),
          Cr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6 13.75h.25V19a.75.75 0 0 0 1.5 0V5.75h2.265V19a.75.75 0 0 0 1.5 0V5.75H14a.75.75 0 0 0 0-1.5H6a4.75 4.75 0 0 0 0 9.5m0-8a3.25 3.25 0 1 0 0 6.5h.25v-6.5z",
              clipRule: "evenodd"
            }), r.jsx("path", {
              d: "M15.53 13.53a.75.75 0 1 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06L18 11.06z"
            })]
          }),
          Sr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M4.25 5A.75.75 0 0 1 5 4.25h14a.75.75 0 0 1 .75.75v2.727a.75.75 0 0 1-1.5 0V5.75h-5.5v13.5h2.05a.75.75 0 0 1 0 1.5H9.2a.75.75 0 0 1 0-1.5h2.05V5.75h-5.5v1.977a.75.75 0 1 1-1.5 0z",
              clipRule: "evenodd"
            })]
          }),
          Er = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M15 5.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM9.184 8.692a.75.75 0 0 0-1.368 0l-4.5 10a.75.75 0 1 0 1.368.616l1.562-3.471h4.508l1.562 3.47a.75.75 0 0 0 1.368-.615zM8.5 10.828l1.58 3.509H6.92z",
              clipRule: "evenodd"
            })]
          }),
          _r = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5 4.25a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75V5a.75.75 0 0 0-.75-.75zm.75 5v-3.5h3.5v3.5zm-.75 4a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75v-5a.75.75 0 0 0-.75-.75zm.75 5v-3.5h3.5v3.5zm7.5-4.25a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-.75.75h-5a.75.75 0 0 1-.75-.75zm1.5.75v3.5h3.5v-3.5zM14 4.25a.75.75 0 0 0-.75.75v5c0 .414.336.75.75.75h5a.75.75 0 0 0 .75-.75V5a.75.75 0 0 0-.75-.75zm.75 5v-3.5h3.5v3.5z",
              clipRule: "evenodd"
            })]
          }),
          Pr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M21.26 8.978c.1.09.19.19.27.29.5.66.61 1.57.29 2.33-.11.26-.26.49-.45.68.37.5.48 1.11.4 1.66-.17 1.15-1.1 1.96-2.27 1.96h-3.25a.3.3 0 0 0-.29.15.34.34 0 0 0-.03.34l1.56 3.79c.35 1.11-.26 2.33-1.36 2.7-1.02.36-2.15-.1-2.64-1.06-1.5-2.99-2.92-4.72-4.05-6.11-.07-.09-.14-.17-.21-.26-.02 0-.03.01-.05.01H6.45c-1.2 0-2.15-.8-2.77-1.83-.62-1.04-.98-2.43-.98-3.92s.36-2.89.98-3.92 1.57-1.82 2.76-1.83h3s.04.01.06.01c1.17-.96 2.71-1.57 4.61-1.57h2.99c2.37 0 3.55 1.38 3.64 2.66.02.27-.01.53-.08.76.18.12.34.28.48.46.51.66.63 1.58.31 2.35-.05.13-.12.25-.19.36zM6.45 5.458c-.46 0-1.01.32-1.48 1.1-.46.77-.77 1.88-.77 3.15s.31 2.38.77 3.15c.47.78 1.02 1.1 1.48 1.1H8.1c-.78-1.15-1.27-2.36-1.27-4.2 0-1.49.45-3.02 1.32-4.3zm13.89 4.73c-.15-.2-.38-.28-.67-.24a.753.753 0 0 1-.84-.65v-.1c0-.37.28-.69.66-.74.3-.04.5-.18.59-.41.11-.28.07-.63-.11-.86-.15-.19-.36-.26-.66-.22-.4.07-.79-.23-.85-.64s.23-.79.64-.85c.14-.02.16-.18.15-.32-.04-.51-.63-1.26-2.14-1.26h-2.99c-3.76 0-5.79 3.02-5.79 5.86 0 2.22.86 3.27 2.28 5 1.19 1.45 2.66 3.25 4.23 6.39a.66.66 0 0 0 .81.32c.34-.12.53-.49.44-.77l-1.54-3.73c-.24-.58-.17-1.23.17-1.74s.92-.82 1.54-.82h3.25c.5 0 .73-.36.78-.67.03-.19.03-.65-.57-.83a.75.75 0 0 1-.53-.78c.03-.35.3-.64.65-.68.3-.04.5-.17.6-.4.11-.27.07-.62-.11-.85z"
            })]
          }),
          kr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M20.56 15.022c.1-.09.19-.19.27-.29.5-.66.61-1.57.29-2.33-.11-.26-.26-.49-.45-.68.37-.5.48-1.11.4-1.66-.17-1.15-1.1-1.96-2.27-1.96h-3.25a.3.3 0 0 1-.29-.15.34.34 0 0 1-.03-.34l1.56-3.79c.35-1.11-.26-2.33-1.36-2.7-1.02-.36-2.15.1-2.64 1.06-1.5 2.99-2.92 4.72-4.05 6.11-.07.09-.14.17-.21.26-.02 0-.03-.01-.05-.01H5.75c-1.2 0-2.15.8-2.77 1.83-.62 1.04-.98 2.43-.98 3.92s.36 2.89.98 3.92 1.57 1.82 2.76 1.83h3s.04-.01.06-.01c1.17.96 2.71 1.57 4.61 1.57h2.99c2.37 0 3.55-1.38 3.64-2.66.02-.27-.01-.53-.08-.76.18-.12.34-.28.48-.46.51-.66.63-1.58.31-2.35-.05-.13-.12-.25-.19-.36zm-14.81 3.52c-.46 0-1.01-.32-1.48-1.1-.46-.77-.77-1.88-.77-3.15s.31-2.38.77-3.15c.47-.78 1.02-1.1 1.48-1.1H7.4c-.78 1.15-1.27 2.36-1.27 4.2 0 1.49.45 3.02 1.32 4.3zm13.89-4.73c-.15.2-.38.28-.67.24a.753.753 0 0 0-.84.65v.1c0 .37.28.69.66.74.3.04.5.18.59.41.11.28.07.63-.11.86-.15.19-.36.26-.66.22-.4-.07-.79.23-.85.64s.23.79.64.85c.14.02.16.18.15.32-.04.51-.63 1.26-2.14 1.26h-2.99c-3.76 0-5.79-3.02-5.79-5.86 0-2.22.86-3.27 2.28-5 1.19-1.45 2.66-3.25 4.23-6.39a.66.66 0 0 1 .81-.32c.34.12.53.49.44.77l-1.54 3.73c-.24.58-.17 1.23.17 1.74s.92.82 1.54.82h3.25c.5 0 .73.36.78.67.03.19.03.65-.57.83-.34.1-.56.43-.53.78s.3.64.65.68c.3.04.5.17.6.4.11.27.07.62-.11.85z"
            })]
          }),
          Ar = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M9.75 4a2.25 2.25 0 0 1 4.5 0v.25h-4.5zm6 0a3.75 3.75 0 1 0-7.5 0v.25H3a.75.75 0 0 0 0 1.5h1.25V20A2.75 2.75 0 0 0 7 22.75h10A2.75 2.75 0 0 0 19.75 20V5.75H21a.75.75 0 0 0 0-1.5h-5.25zm-10 16V5.75h12.5V20c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25m7-11a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0zM8.5 8.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m7.75.75a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0z",
              clipRule: "evenodd"
            })]
          }),
          zr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M19.75 3a.75.75 0 0 0-1.5 0v18a.75.75 0 0 0 1.5 0zM5 6.25a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H15a.75.75 0 0 0 0-1.5z"
            })]
          }),
          Tr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M8.75 7a.75.75 0 0 0-1.5 0v7a4.75 4.75 0 1 0 9.5 0V7a.75.75 0 0 0-1.5 0v7a3.25 3.25 0 0 1-6.5 0zM5 20.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
            })]
          }),
          Or = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M7 6.25a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H17a.75.75 0 0 0 0-1.5zm-2 14a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5z"
            })]
          }),
          Ir = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M6.53 3.47a.75.75 0 0 1 0 1.06L3.81 7.25H7a.75.75 0 1 1 0 1.5H3.81l2.72 2.72a.75.75 0 1 1-1.06 1.06L.94 8l4.53-4.53a.75.75 0 0 1 1.06 0m8 0a.75.75 0 0 1 0 1.06l-2.72 2.72H14a6.75 6.75 0 0 1 0 13.5h-2a.75.75 0 0 1 0-1.5h2a5.25 5.25 0 1 0 0-10.5h-2.19l2.72 2.72a.75.75 0 1 1-1.06 1.06L8.94 8l4.53-4.53a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          Fr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.53 3.47a.75.75 0 0 1 0 1.06L5.81 7.25H14a6.75 6.75 0 0 1 0 13.5h-2a.75.75 0 0 1 0-1.5h2a5.25 5.25 0 1 0 0-10.5H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06L2.94 8l4.53-4.53a.75.75 0 0 1 1.06 0",
              clipRule: "evenodd"
            })]
          }),
          Mr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#undo-redo-icon_svg__a)",
              children: r.jsx("path", {
                d: "M5.78 1.53A.75.75 0 1 0 4.72.47L.94 4.25l3.78 3.78a.75.75 0 0 0 1.06-1.06L3.81 5h6.315a4.125 4.125 0 1 1 0 8.25H8.5a.75.75 0 0 0 0 1.5h1.625a5.625 5.625 0 0 0 0-11.25H3.811zm13.69 14a.75.75 0 1 1 1.06-1.06L23.06 17l-2.53 2.53a.75.75 0 1 1-1.06-1.06l.72-.72H17a2.25 2.25 0 1 0 0 4.5h1a.75.75 0 0 1 0 1.5h-1a3.75 3.75 0 1 1 0-7.5h3.19z"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "undo-redo-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Rr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M13 3.25a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75V4a.75.75 0 0 0-.75-.75zm.75 7v-5.5h5.5v5.5zm-9.75 2a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h7a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75zm.75 7v-5.5h5.5v5.5z",
              clipRule: "evenodd"
            })]
          }),
          jr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12.75 15.8a1.5 1.5 0 1 0-1.5 0V18a.75.75 0 0 0 1.5 0z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 .25A4.75 4.75 0 0 0 7.25 5v.5a.75.75 0 0 0 1.5 0V5a3.25 3.25 0 0 1 6.5 0v4H6a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3h-1.25V5A4.75 4.75 0 0 0 12 .25M4.5 12A1.5 1.5 0 0 1 6 10.5h12a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 20z",
              clipRule: "evenodd"
            })]
          }),
          Br = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M11.25 18a.75.75 0 0 0 1.5 0V4.81l2.72 2.72a.75.75 0 1 0 1.06-1.06L12 1.94 7.47 6.47a.75.75 0 0 0 1.06 1.06l2.72-2.72z"
            }), r.jsx("path", {
              d: "M3.75 17a.75.75 0 0 0-1.5 0v3A2.75 2.75 0 0 0 5 22.75h14A2.75 2.75 0 0 0 21.75 20v-3a.75.75 0 0 0-1.5 0v3c0 .69-.56 1.25-1.25 1.25H5c-.69 0-1.25-.56-1.25-1.25z"
            })]
          }),
          Nr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M8.25 8.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m6.78 4.289a5.25 5.25 0 1 0-6.058 0A8.75 8.75 0 0 0 3.249 21a.75.75 0 0 0 1.5 0 7.25 7.25 0 1 1 14.5 0 .75.75 0 0 0 1.5 0 8.75 8.75 0 0 0-5.72-8.211Z",
              clipRule: "evenodd"
            })]
          }),
          Lr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#vertical-scroll-icon_svg__a)",
              children: r.jsx("path", {
                d: "m12-.06.528.528h-1.056L12-.061Zm.528.528-1.06.004L8.47 3.47a.75.75 0 0 0 1.06 1.06l1.72-1.72V7a.75.75 0 0 0 1.5 0V2.81l1.72 1.72a.75.75 0 1 0 1.06-1.06zm-1.06 23.06L8.47 20.53a.75.75 0 1 1 1.06-1.06l1.72 1.72V17a.75.75 0 0 1 1.5 0v4.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.998 2.998-.004.004-.528.529-.528-.529zM12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "vertical-scroll-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h24v24H0z"
                })
              })
            })]
          }),
          Vr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M15.25 12.433a.5.5 0 0 0 0-.866l-4.5-2.598a.5.5 0 0 0-.75.433v5.196a.5.5 0 0 0 .75.433z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M1 6a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5h18a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V6a.5.5 0 0 1 .5-.5",
              clipRule: "evenodd"
            })]
          }),
          Kr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m1.5 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M11.25 7a.75.75 0 0 1 1.5 0v5.75H8a.75.75 0 0 1 0-1.5h3.25z",
              clipRule: "evenodd"
            })]
          }),
          qr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M13.5 3.043a1.75 1.75 0 0 0-3 0L.266 20.1c-.7 1.166.14 2.65 1.5 2.65h20.468c1.36 0 2.2-1.484 1.5-2.65L13.502 3.043ZM12.75 9a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0zm.5 8.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0",
              clipRule: "evenodd"
            })]
          }),
          Hr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M12 8.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75m0 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M10.5 3.043a1.75 1.75 0 0 1 3 0L23.736 20.1c.7 1.166-.14 2.65-1.501 2.65H1.766c-1.36 0-2.2-1.484-1.5-2.65zm1.715.772a.25.25 0 0 0-.43 0L1.553 20.871a.25.25 0 0 0 .214.379h20.468a.25.25 0 0 0 .214-.379z",
              clipRule: "evenodd"
            })]
          }),
          Ur = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M6.136 7.607a.75.75 0 0 0-.772 1.286l2.5 1.5a.75.75 0 0 0 .772-1.286zm12.5 1.286a.75.75 0 1 0-.772-1.286l-2.5 1.5a.75.75 0 0 0 .772 1.286zm-7.5 1.714a.75.75 0 1 0-.772 1.286l.178.107-.178.107a.75.75 0 1 0 .772 1.286l.864-.518.864.518a.75.75 0 0 0 .772-1.286L13.458 12l.178-.107a.75.75 0 1 0-.772-1.286l-.864.518zm-2.5 4.286a.75.75 0 1 0-.772-1.286l-2.5 1.5a.75.75 0 1 0 .772 1.286zm7.5-1.286a.75.75 0 1 0-.772 1.286l2.5 1.5a.75.75 0 0 0 .772-1.286z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M2 4.5A1.5 1.5 0 0 0 .5 6v12A1.5 1.5 0 0 0 2 19.5h20a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 22 4.5zm0 2.375v10.25l.864-.518a.75.75 0 1 1 .772 1.286L3.458 18h17.084l-.178-.107a.75.75 0 1 1 .772-1.286l.864.518V6.875l-.864.518a.75.75 0 1 1-.772-1.286L20.542 6H3.458l.178.107a.75.75 0 1 1-.772 1.286z",
              clipRule: "evenodd"
            })]
          }),
          Zr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11M9.03 7.97a.75.75 0 0 0-1.06 1.06L10.94 12l-2.97 2.97a.75.75 0 1 0 1.06 1.06L12 13.06l2.97 2.97a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0-1.06-1.06L12 10.94z",
              clipRule: "evenodd"
            })]
          }),
          $r = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M9.03 7.97a.75.75 0 0 0-1.06 1.06L10.94 12l-2.97 2.97a.75.75 0 1 0 1.06 1.06L12 13.06l2.97 2.97a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0-1.06-1.06L12 10.94z"
            }), r.jsx("path", {
              fillRule: "evenodd",
              d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11m-1.5 0a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0",
              clipRule: "evenodd"
            })]
          }),
          Gr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M5.105 18.894a.75.75 0 0 1 0-1.06L10.94 12 5.105 6.166a.75.75 0 0 1 1.061-1.06L12 10.939l5.833-5.833a.75.75 0 0 1 1.061 1.06L13.06 12l5.834 5.834a.75.75 0 0 1-1.06 1.06L12 13.061l-5.834 5.833a.75.75 0 0 1-1.06 0Z",
              clipRule: "evenodd"
            })]
          }),
          Wr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14m.75-10a.75.75 0 0 0-1.5 0v2.25H7a.75.75 0 0 0 0 1.5h2.25V13a.75.75 0 0 0 1.5 0v-2.25H13a.75.75 0 0 0 0-1.5h-2.25z",
              clipRule: "evenodd"
            })]
          }),
          Yr = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 24 24",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fillRule: "evenodd",
              d: "M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14M7 9.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5z",
              clipRule: "evenodd"
            })]
          });
        t.fMw = b, t.BNd = z, t.QUb = T, t.KML = M, t.YAN = ee, t.mc$ = Le, t.nXP = vt, t.fpf = Jt, t.o1U = sn, t.hYA = xn, t.Pnb = Mn, t.W1M = Vn, t.VL1 = xr;
      },
      23652: (e, t, n) => {
        "use strict";

        var r = n(85893),
          o = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M6.53 2.47a.75.75 0 0 0-1.06 0L4 3.94 2.53 2.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l2-2a.75.75 0 0 0 0-1.06",
              clipRule: "evenodd"
            })]
          }),
          i = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              d: "M1 8V0l6 4z"
            })]
          }),
          a = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              d: "M1 8V0l6 4z"
            })]
          }),
          s = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "currentColor",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#close-icon_svg__a)",
              children: r.jsx("path", {
                fillRule: "evenodd",
                d: "M.288 7.712a.75.75 0 0 1 0-1.06L2.939 4 .288 1.348a.75.75 0 1 1 1.06-1.06L4 2.939 6.652.288a.75.75 0 0 1 1.06 1.06L5.061 4l2.651 2.652a.75.75 0 1 1-1.06 1.06L4 5.061 1.348 7.712a.75.75 0 0 1-1.06 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "close-icon_svg__a",
                children: r.jsx("path", {
                  d: "M0 0h8v8H0z"
                })
              })
            })]
          }),
          l = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4 6.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M4 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
              clipRule: "evenodd"
            })]
          }),
          u = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M7.75 4a.75.75 0 0 1-.75.75H1a.75.75 0 0 1 0-1.5h6a.75.75 0 0 1 .75.75",
              clipRule: "evenodd"
            })]
          }),
          c = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("path", {
              fill: "currentColor",
              fillRule: "evenodd",
              d: "M4 .25a.75.75 0 0 1 .75.75v2.25H7a.75.75 0 0 1 0 1.5H4.75V7a.75.75 0 0 1-1.5 0V4.75H1a.75.75 0 0 1 0-1.5h2.25V1A.75.75 0 0 1 4 .25",
              clipRule: "evenodd"
            })]
          }),
          d = ({
            title: e,
            titleId: t,
            ...n
          }) => r.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: n.size || "1em",
            height: n.size || "1em",
            fill: "none",
            viewBox: "0 0 8 8",
            "aria-labelledby": t,
            ...n,
            children: [e ? r.jsx("title", {
              id: t,
              children: e
            }) : null, r.jsx("g", {
              clipPath: "url(#x-icon_svg__a)",
              children: r.jsx("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                d: "M.288 7.712a.75.75 0 0 1 0-1.06L2.94 4 .288 1.348a.75.75 0 1 1 1.06-1.06L4 2.939 6.652.288a.75.75 0 0 1 1.06 1.06L5.062 4l2.652 2.652a.75.75 0 0 1-1.061 1.06L4 5.061 1.35 7.712a.75.75 0 0 1-1.061 0",
                clipRule: "evenodd"
              })
            }), r.jsx("defs", {
              children: r.jsx("clipPath", {
                id: "x-icon_svg__a",
                children: r.jsx("path", {
                  fill: "transparent",
                  d: "M0 0h8v8H0z"
                })
              })
            })]
          });
        t.v4 = o, t.XC = a, t.V_ = u, t.pO = c, t.b0 = d;
      },
      73571: (e, t, n) => {
        "use strict";

        n.d(t, {
          BL: () => Z,
          VY: () => ye,
          xg: () => Se,
          lQ: () => W,
          t7: () => te,
          $H: () => T,
          Sq: () => ne
        });
        var r = n(20770),
          o = n(67294),
          i = n(98502),
          a = n(8840),
          s = n(56479),
          l = n(8716);
        function u(e, t) {
          const {
            children: n,
            ...r
          } = t;
          return n ? (0, l.j)(e, r, ...(Array.isArray(n) ? n : [n])) : (0, l.j)(e, r);
        }
        var c = u,
          d = o.Fragment,
          p = n(2252),
          h = n(85816),
          f = n(85893),
          m = n(70799),
          g = n(83034),
          v = n(43098),
          y = n(45071);
        function b({
          state: e,
          initialState: t = {},
          onChange: n,
          ref: r
        }) {
          let [s, l] = o.useState({
              ...t,
              ...e
            }),
            u = (0, i.useI18n)(),
            c = (0, i.useDevice)(r?.current || void 0),
            d = (0, o.useRef)(Object.fromEntries(Object.entries(e || {}).map(([e, t]) => [e, void 0 !== t]))),
            p = (0, o.useMemo)(() => Object.fromEntries(Object.entries(e || {}).map(([e, t]) => [e, void 0 !== t])), [e]);
          return (0, o.useEffect)(() => {
            for (let e in d.current) {
              let t = d.current[e];
              t !== p[e] && console.warn(`WARN: A component changed from ${t ? "controlled" : "uncontrolled"} to ${p[e] ? "controlled" : "uncontrolled"}.`), d.current[e] = p[e];
            }
          }, [p]), {
            intl: u,
            state: o.useMemo(() => ({
              get: t => p[t] ? e?.[t] : s[t],
              set: (t, r) => {
                if ((p[t] ? e?.[t] : s[t]) === r) return;
                n?.({
                  [t]: r
                }), p[t] ? (0, a.kG)(n, "If you provide a controlled state, you must also provide an onChange handler.") : l({
                  ...s,
                  [t]: r
                });
              },
              toJS: () => ({
                ...s,
                ...e
              })
            }), [e, p, n, s]),
            device: c
          };
        }
        function w(e) {
          var t = function (e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : String(t);
        }
        function x(e, t, n) {
          return (t = w(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function D(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function C(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? D(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function S(e, t) {
          var n = {};
          for (var r in e) n[r] = t(e[r], r);
          return n;
        }
        var E = (e, t, n) => {
            for (var r of Object.keys(e)) {
              var o;
              if (e[r] !== (null !== (o = t[r]) && void 0 !== o ? o : n[r])) return !1;
            }
            return !0;
          },
          _ = e => {
            var t = t => {
              var n = e.defaultClassName,
                r = C(C({}, e.defaultVariants), t);
              for (var o in r) {
                var i,
                  a = null !== (i = r[o]) && void 0 !== i ? i : e.defaultVariants[o];
                if (null != a) {
                  var s = a;
                  "boolean" == typeof s && (s = !0 === s ? "true" : "false");
                  var l = e.variantClassNames[o][s];
                  l && (n += " " + l);
                }
              }
              for (var [u, c] of e.compoundVariants) E(u, r, e.defaultVariants) && (n += " " + c);
              return n;
            };
            return t.variants = () => Object.keys(e.variantClassNames), t.classNames = {
              get base() {
                return e.defaultClassName.split(" ")[0];
              },
              get variants() {
                return S(e.variantClassNames, e => S(e, e => e.split(" ")[0]));
              }
            }, t;
          },
          P = _({
            defaultClassName: "x0o33h6 _1yep5z6i6 _1yep5z6i7 _1yep5z6i8 _1yep5z6fs",
            variantClassNames: {
              variant: {
                wide: "x0o33h7 _1yep5z69 _1yep5z6g _1yep5z6h _1yep5z62l _1yep5z62s _1yep5z62t _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69l _1yep5z69p _1yep5z69q",
                narrow: "x0o33h8 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z62f _1yep5z62g _1yep5z62h _1yep5z69i _1yep5z69j _1yep5z69k"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          k = _({
            defaultClassName: "x0o33h3 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              variant: {
                wide: "x0o33h4 _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z6fu",
                narrow: "x0o33h5 _1yep5z63 _1yep5z64 _1yep5z65 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          A = _({
            defaultClassName: "x0o33h0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie",
            variantClassNames: {
              variant: {
                narrow: "_1yep5z6fs",
                wide: "x0o33h2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          z = (0, i.defineMessages)({
            signatures: {
              defaultMessage: "Signatures",
              id: "signatures"
            },
            addSignature: {
              defaultMessage: "Add Signature",
              id: "addSignature"
            },
            cancel: {
              defaultMessage: "Cancel",
              id: "cancel"
            },
            delete: {
              defaultMessage: "Delete",
              id: "delete"
            }
          }),
          T = o.forwardRef(({
            children: e,
            state: t,
            onStateChange: n,
            initialState: l,
            ...d
          }, p) => {
            let h = o.useRef(null),
              f = {
                ...d,
                ...b({
                  ref: h,
                  initialState: l,
                  state: t,
                  onChange: n
                }),
                ref: (0, r.lq)(p, h)
              },
              m = (({
                className: e,
                style: t,
                titleId: n,
                items: r,
                ref: o,
                onAdd: l,
                onAddFromPreview: d,
                onRemoveFromPreview: p,
                onCancel: h,
                variant: f = "wide",
                intl: {
                  formatMessage: m
                }
              }) => {
                let g = "narrow" === f,
                  v = u(i.Separator, {
                    className: "_1yep5z64r _1yep5z64s _1yep5z64t _1yep5z673 _1yep5z674 _1yep5z675"
                  });
                return c("div", {
                  style: t,
                  className: (0, a.AK)(A({
                    variant: f
                  }), e),
                  ref: o,
                  "data-block-id": "signatures-list",
                  children: [c("div", {
                    className: k({
                      variant: f
                    }),
                    "data-block-id": "header",
                    children: [u(i.Text, {
                      id: n,
                      type: "title",
                      size: g ? "sm" : "md",
                      "data-block-id": "title",
                      className: "PSPDFKit-Electronic-Signatures-Signature-Heading",
                      children: m(z.signatures)
                    }), "wide" === f && u(i.ActionButton, {
                      id: "add-signature",
                      size: "md",
                      label: m(z.addSignature),
                      "data-block-id": "add-signature",
                      onPress: l,
                      className: "PSPDFKit-Electronic-Signatures-Add-Signature-Button"
                    })]
                  }), g ? c("div", {
                    children: [v, c("div", {
                      className: "_1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6ir _1yep5z6is _1yep5z6it",
                      children: [u(i.Text, {
                        type: "subtitle",
                        size: "sm",
                        children: m(z.addSignature)
                      }), u(i.ActionIconButton, {
                        variant: "secondary",
                        size: "md",
                        icon: s.pO,
                        onPress: l,
                        "data-block-id": "add-signature",
                        "aria-label": m(z.addSignature)
                      })]
                    })]
                  }) : null, u("div", {
                    className: (0, a.AK)(P({
                      variant: f
                    }), "PSPDFKit-Signature-Picker PSPDFKit-Signature-Dialog-Picker"),
                    "data-block-id": "body",
                    children: r.map(({
                      id: e,
                      ...t
                    }) => u(i.Preview, {
                      className: "PSPDFKit-Signature-Dialog-Picker-Item-Button",
                      ...t,
                      "data-block-id": e,
                      addAriaLabel: m(z.addSignature),
                      onPress: () => d?.(e),
                      onDelete: p ? () => {
                        p(e);
                      } : void 0,
                      deleteAriaLabel: m(z.delete)
                    }))
                  }), !g && u("div", {
                    className: "_1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69 _1yep5z6d _1yep5z6e _1yep5z62l _1yep5z62p _1yep5z62q _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jo _1yep5z6jp _1yep5z6jq _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6fu",
                    "data-block-id": "footer",
                    children: u(i.ActionButton, {
                      variant: "secondary",
                      size: "md",
                      label: m(z.cancel),
                      onPress: h,
                      "data-block-id": "cancel",
                      className: "PSPDFKit-Signature-Dialog-Cancel-Button"
                    })
                  }), g ? v : null]
                });
              })(f);
            return e ? e({
              ...f,
              ui: m
            }) : m.createComponent();
          });
        T.displayName = "SignaturesList";
        var O,
          I = _({
            defaultClassName: "_1pebngc18 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2",
            variantClassNames: {
              variant: {
                wide: "_1pebngc19",
                narrow: "_1yep5z63r _1yep5z63y _1yep5z63z _1yep5z619 _1yep5z61j _1yep5z61k _1yep5z63 _1yep5z67 _1yep5z68 _1yep5z62f _1yep5z62j _1yep5z62k _1yep5z6fs"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          F = _({
            defaultClassName: "_1pebngc6 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie",
            variantClassNames: {
              variant: {
                wide: "_1pebngc7",
                narrow: "_1pebngc8"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          M = _({
            defaultClassName: "_1pebngc0",
            variantClassNames: {
              variant: {
                wide: "_1pebngc1",
                narrow: "_1pebngc2"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          R = _({
            defaultClassName: "_1pebngc15 _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69 _1yep5z6d _1yep5z6e _1yep5z62l _1yep5z62p _1yep5z62q _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jr _1yep5z6js _1yep5z6jt",
            variantClassNames: {
              variant: {
                wide: "_1yep5z6fu",
                narrow: "_1yep5z6fs"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          j = _({
            defaultClassName: "_1pebngc3 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jr _1yep5z6js _1yep5z6jt _1yep5z6ir _1yep5z6is _1yep5z6it",
            variantClassNames: {
              variant: {
                narrow: "_1pebngc4 _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z619 _1yep5z61g _1yep5z61h _1yep5z6fs",
                wide: "_1pebngc5 _1yep5z69 _1yep5z6g _1yep5z6h _1yep5z62l _1yep5z62s _1yep5z62t _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z6fu"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          B = _({
            defaultClassName: "_1pebngcs _1pebngch _1yep5z6kv",
            variantClassNames: {
              variant: {
                wide: "_1pebngct",
                narrow: "_1pebngcu"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          N = _({
            defaultClassName: "_1pebngcm",
            variantClassNames: {
              variant: {
                wide: "_1pebngcn",
                narrow: "_1pebngco"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          L = _({
            defaultClassName: "_1pebngch _1yep5z6kv _1yep5z6kw",
            variantClassNames: {
              variant: {
                wide: "_1yep5z65c _1yep5z65d _1yep5z65e",
                narrow: "_1pebngcr"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          V = _({
            defaultClassName: "_1pebngcv _1pebngch _1yep5z6kv",
            variantClassNames: {
              variant: {
                wide: "_1pebngct",
                narrow: "_1pebngcx"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          K = _({
            defaultClassName: "_1pebngcy _1pebngch _1yep5z6kv",
            variantClassNames: {
              variant: {
                wide: "_1pebngcz",
                narrow: "_1pebngc10"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          q = _({
            defaultClassName: "_1pebngci _1pebngch _1yep5z6kv",
            variantClassNames: {
              variant: {
                wide: "_1pebngcj",
                narrow: "_1yep5z6af _1yep5z6ag _1yep5z6ah"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          H = _({
            defaultClassName: "_1pebngc9 _1yep5z6ks",
            variantClassNames: {
              variant: {
                wide: "_1pebngca _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z6fu",
                narrow: "_1pebngcb _1yep5z64l _1yep5z63s _1yep5z63t _1yep5z629 _1yep5z61g _1yep5z61h _1yep5z6fs"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          U = _({
            defaultClassName: "_1pebngcc _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6kw",
            variantClassNames: {
              type: {
                image: "_1yep5z6c _1yep5z6d _1yep5z6e _1yep5z62o _1yep5z62p _1yep5z62q _1yep5z6jl _1yep5z6jm _1yep5z6jn",
                type: "_1pebngce"
              },
              variant: {
                wide: "_1yep5z6c _1yep5z6d _1yep5z6e _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69o _1yep5z69p _1yep5z69q",
                narrow: "_1yep5z613 _1yep5z614 _1yep5z615 _1yep5z63f _1yep5z63g _1yep5z63h"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          Z = ((O = Z || {}).DRAW = "DRAW", O.TYPE = "TYPE", O.IMAGE = "IMAGE", O);
        _({
          defaultClassName: "yje7uq8 _1yep5z6ew _1yep5z6dv",
          variantClassNames: {
            isDisabled: {
              true: "_1yep5z6109"
            }
          },
          defaultVariants: {},
          compoundVariants: []
        });
        _({
          defaultClassName: "yje7uq0 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6i9 _1yep5z6ia _1yep5z6ib",
          variantClassNames: {
            labelPosition: {
              end: "_1yep5z613k _1yep5z613l _1yep5z613m _1yep5z6ut _1yep5z6uu _1yep5z6uv",
              start: "_1yep5z613q _1yep5z613r _1yep5z613s _1yep5z6152 _1yep5z6153 _1yep5z6154"
            }
          },
          defaultVariants: {},
          compoundVariants: []
        });
        var $ = _({
            defaultClassName: "yje7uq3 _1dlrtbb5",
            variantClassNames: {
              isFocusVisible: {
                true: "_1dlrtbb8"
              },
              isSelected: {
                true: "_1dlrtbb7"
              },
              isDisabled: {
                true: "_1dlrtbba"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          G = ({
            item: {
              id: e,
              label: t
            },
            options: {
              isSelected: n,
              isFocusVisible: r,
              isDisabled: o
            }
          }) => (0, f.jsxs)("div", {
            className: (0, a.AK)("_1pebngc12 _1yep5z63x _1yep5z63y _1yep5z63z _1yep5z61l _1yep5z61m _1yep5z61n _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6ev _1yep5z69i _1yep5z69j _1yep5z69k _1yep5z6kx", "PSPDFKit-Electronic-Signatures-Font-Family-Wrapper"),
            "aria-label": e,
            style: {
              fontFamily: e
            },
            children: [(0, f.jsx)("div", {
              className: $({
                isSelected: n,
                isFocusVisible: r,
                isDisabled: o
              }),
              children: n ? (0, f.jsx)("div", {
                className: (0, a.AK)("yje7uq7", "PSPDFKit-Electronic-Signatures-Font-Family-Radio-Input")
              }) : null
            }), (0, f.jsx)("span", {
              className: "PSPDFKit-Electronic-Signatures-Font-Family-Label",
              children: t
            })]
          }),
          W = o.forwardRef(({
            children: e,
            initialState: t,
            state: n,
            onStateChange: r,
            ...l
          }, d) => {
            let f = b({
                initialState: {
                  selectedFont: l.fonts[0],
                  color: l.colorPresets[0].color || "#000000",
                  shouldStoreSignature: !1,
                  currentTab: l.allowedTabs?.[0] || "DRAW",
                  ...t
                },
                state: n,
                onChange: r
              }),
              m = {
                ...l,
                ...f,
                ref: d
              },
              g = (({
                className: e,
                style: t,
                colorPresets: n,
                state: r,
                ref: l,
                intl: {
                  formatMessage: d
                },
                titleId: f,
                fonts: m,
                onCloseRequest: g,
                onAdd: v,
                variant: y = "wide",
                allowedTabs: b = ["DRAW", "IMAGE", "TYPE"],
                allowStoringSignature: w = !0,
                "data-block-id": x = "create-signature"
              }) => {
                let D = "narrow" === y,
                  C = o.useRef(null),
                  S = o.useCallback(e => {
                    r.set("ink", e.length ? e : void 0);
                  }, [r]),
                  E = o.useCallback(e => {
                    r.set("image", e?.[0] || null);
                  }, [r]),
                  _ = (0, o.useMemo)(() => u(i.ColorPresetInlineInput, {
                    items: n || [],
                    "aria-label": D ? void 0 : d("color"),
                    className: (0, a.AK)(I({
                      variant: y
                    }), "PSPDFKit-Input-ColorPicker"),
                    value: r.get("color"),
                    onChange: e => {
                      r.set("color", e);
                    },
                    "data-block-id": "color-selector",
                    label: D ? d("color") : void 0,
                    labelPosition: "start",
                    optionClassName: "PSPDFKit-Input-ColorPicker-Swatch PSPDFKit-Input-ColorPicker-Label"
                  }), [n, d, D, r, y]),
                  P = (0, o.useCallback)(e => {
                    switch (e) {
                      case "DRAW":
                        return c(i.TabItem, {
                          title: d("draw"),
                          value: "DRAW",
                          titleClassName: "PSPDFKit-Electronic-Signatures-Tab PSPDFKit-Electronic-Signatures-Tab-Draw",
                          className: U({
                            variant: y
                          }),
                          "data-block-id": "draw-tab",
                          children: [!D && _, u(i.FreehandCanvas, {
                            "data-block-id": "freehand-canvas",
                            placeholder: d("signHere"),
                            clearLabel: d("clearSignature"),
                            strokeColor: r.get("color"),
                            className: "_1pebngch _1yep5z6kv _1yep5z6kw",
                            isInline: !D,
                            value: r.get("ink"),
                            canvasRef: C,
                            canvasClassName: (0, a.AK)(B({
                              variant: y
                            }), "PSPDFKit-Electronic-Signatures-Canvas"),
                            footerClassName: (0, a.AK)(N({
                              variant: y
                            }), {
                              "PSPDFKit-Electronic-Signatures-Sign-Here-Label": !r.get("ink"),
                              "PSPDFKit-Electronic-Signatures-Clear-Signature-Button": r.get("ink")
                            }),
                            onChange: S
                          }), D ? _ : null]
                        }, e);
                      case "IMAGE":
                        return u(i.TabItem, {
                          title: d("image"),
                          value: "IMAGE",
                          titleClassName: "PSPDFKit-Electronic-Signatures-Tab PSPDFKit-Electronic-Signatures-Tab-Image",
                          className: U({
                            type: "image",
                            variant: y
                          }),
                          "data-block-id": "image-tab",
                          children: u(i.ImageDropZone, {
                            className: (0, a.AK)(L({
                              variant: y
                            }), "PSPDFKit-Electronic-Signatures-Image-Dropzone"),
                            pickerButtonClassName: r.get("image") ? "PSPDFKit-Electronic-Signatures-Replace-Image-Button" : "PSPDFKit-Electronic-Signatures-Add-Image-Button",
                            labelClassName: V({
                              variant: y
                            }),
                            isInline: !D,
                            "data-block-id": "image-drop-zone",
                            onValueChange: E,
                            imageSrc: r.get("image"),
                            placeholder: d("selectDragImage"),
                            footerClassName: N({
                              variant: y
                            }),
                            clearLabel: d("clearSignature")
                          })
                        });
                      case "TYPE":
                        return c(i.TabItem, {
                          title: d("type"),
                          value: "TYPE",
                          titleClassName: "PSPDFKit-Electronic-Signatures-Tab PSPDFKit-Electronic-Signatures-Tab-Type",
                          "data-block-id": "type-tab",
                          children: [c("div", {
                            className: U({
                              type: "type",
                              variant: y
                            }),
                            children: [!D && _, u(p.SignatureTextInput, {
                              inputStyle: {
                                color: r.get("color"),
                                fontFamily: r.get("selectedFont")
                              },
                              placeholder: d("signature"),
                              onChange: e => {
                                r.set("text", e);
                              },
                              label: d("signHere"),
                              "data-block-id": "signature-text-input",
                              value: r.get("text"),
                              inputClassName: (0, a.AK)(K({
                                variant: y
                              }), "PSPDFKit-Electronic-Signatures-Text-Input"),
                              className: (0, a.AK)(q({
                                variant: y
                              }), "PSPDFKit-Text-Input"),
                              clearLabel: d("clearSignature"),
                              isInline: !D,
                              footerStyle: {
                                padding: D ? h.themeVars.spacing.sm : void 0
                              },
                              footerClassName: "PSPDFKit-Electronic-Signatures-Clear-Signature-Button"
                            })]
                          }), !D && 1 !== m.length && u(i.RadioGroup, {
                            optionsContainerClassName: (0, a.AK)("_1pebngc14", "PSPDFKit-Electronic-Signatures-Font-Families-Container"),
                            orientation: "horizontal",
                            className: "_1pebngc11 _1yep5z650 _1yep5z651 _1yep5z652 _1yep5z6fu",
                            items: m.map(e => ({
                              id: e,
                              label: r.get("text") || d("signature")
                            })),
                            "data-block-id": "font-selector",
                            value: r.get("selectedFont"),
                            onChange: e => {
                              r.set("selectedFont", e);
                            },
                            optionClassName: "_1pebngc13 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it",
                            "aria-label": d("fonts"),
                            renderOption: (e, t) => u(G, {
                              item: e,
                              options: t
                            }).createComponent()
                          }), D ? _ : null, D ? u(i.Select, {
                            isReadOnly: 1 === m.length,
                            labelPosition: "start",
                            label: "Font",
                            "data-block-id": "font-selector",
                            className: I({
                              variant: y
                            }),
                            placement: "bottom end",
                            selectedKey: r.get("selectedFont"),
                            onSelectionChange: e => {
                              r.set("selectedFont", e);
                            },
                            style: {
                              fontFamily: r.get("selectedFont")
                            },
                            variant: "ghost",
                            items: m.map(e => ({
                              id: e,
                              label: r.get("text") || d("signature")
                            }))
                          }) : null]
                        }, e);
                    }
                  }, [d, y, D, _, r, S, E, m]),
                  k = r.get("currentTab"),
                  A = (0, o.useCallback)(() => {
                    switch (k) {
                      case "DRAW":
                        return {
                          type: "DRAW",
                          value: r.get("ink")
                        };
                      case "IMAGE":
                        return {
                          type: "IMAGE",
                          value: r.get("image")
                        };
                      case "TYPE":
                        return {
                          type: "TYPE",
                          value: r.get("text")
                        };
                    }
                  }, [k, r]);
                return c("div", {
                  className: (0, a.AK)(M({
                    variant: y
                  }), e),
                  style: t,
                  "data-block-id": x,
                  ref: l,
                  children: [c("div", {
                    "data-block-id": "header",
                    className: j({
                      variant: y
                    }),
                    children: [u(i.Text, {
                      elementType: "h3",
                      type: "title",
                      size: D ? "sm" : "md",
                      "data-block-id": "title",
                      id: f,
                      children: d("addSignature")
                    }), D ? u(i.ActionIconButton, {
                      variant: "secondary",
                      "data-block-id": "close-button",
                      size: "md",
                      icon: s.aM,
                      onPress: g,
                      "aria-label": d("close")
                    }) : null]
                  }), D ? u(i.Separator, {}) : null, u("div", {
                    "data-block-id": "body",
                    className: (0, a.AK)(F({
                      variant: y
                    }), "PSPDFKit-Electronic-Signatures-Tabs-Container"),
                    children: u(i.Tabs, {
                      variant: "ghost",
                      "data-block-id": "tabs",
                      className: "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6jc _1yep5z6jd _1yep5z6je",
                      tabHeaderClassName: (0, a.AK)(H({
                        variant: y
                      }), "PSPDFKit-Electronic-Signatures-Tabs-List"),
                      onSelectionChange: e => {
                        r.set("currentTab", e);
                      },
                      children: b.map(e => P(e))
                    })
                  }), D ? u(i.Separator, {}) : null, c("div", {
                    "data-block-id": "footer",
                    className: R({
                      variant: y
                    }),
                    children: [w ? u(i.Checkbox, {
                      isSelected: r.get("shouldStoreSignature"),
                      "data-block-id": "save-signature-checkbox",
                      label: d("saveSignature"),
                      className: "PSPDFKit-Electronic-Signatures-Store-Signature-Checkbox",
                      onChange: e => {
                        r.set("shouldStoreSignature", e);
                      }
                    }) : u("div", {}), c("div", {
                      className: "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z69l _1yep5z69m _1yep5z69n",
                      children: [!D && u(i.ActionButton, {
                        "data-block-id": "cancel-button",
                        variant: "secondary",
                        size: "md",
                        label: d("cancel"),
                        onPress: g,
                        className: "PSPDFKit-Electronic-Signatures-Cancel-Button"
                      }), u(i.ActionButton, {
                        "data-block-id": "done-button",
                        onPress: () => {
                          v({
                            ...r.toJS(),
                            signature: A(),
                            canvasSize: {
                              width: C.current?.clientWidth || 0,
                              height: C.current?.clientHeight || 0
                            }
                          });
                        },
                        label: d("done"),
                        isDisabled: !A()?.value,
                        size: "md",
                        className: "PSPDFKit-Electronic-Signatures-Done-Button"
                      })]
                    })]
                  })]
                });
              })(m);
            return e ? e({
              ...m,
              ui: g
            }) : g.createComponent();
          });
        W.displayName = "CreateSignature";
        var Y = "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6i9 _1yep5z6ia _1yep5z6ib _1yep5z69l _1yep5z69m _1yep5z69n",
          X = "dabjfd2 dabjfd0 _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z6c _1yep5z6d _1yep5z6e _1yep5z62o _1yep5z62p _1yep5z62q _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jl _1yep5z6js _1yep5z6jt _1yep5z6io _1yep5z6is _1yep5z6it _1yep5z6fu _1yep5z6ic _1yep5z6ia _1yep5z6ib _1yep5z69l _1yep5z6ag _1yep5z6ah _1yep5z6le _1yep5z6nq _1yep5z614z _1yep5z6150 _1yep5z6151 _1yep5z6142 _1yep5z6143 _1yep5z6144 _1yep5z613k _1yep5z613l _1yep5z613m",
          Q = "dabjfd0 _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z6c _1yep5z6d _1yep5z6e _1yep5z62o _1yep5z62p _1yep5z62q _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jl _1yep5z6js _1yep5z6jt _1yep5z6io _1yep5z6is _1yep5z6it _1yep5z6fu _1yep5z6ic _1yep5z6ia _1yep5z6ib _1yep5z69l _1yep5z6ag _1yep5z6ah",
          J = "_1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69 _1yep5z6d _1yep5z6e _1yep5z62l _1yep5z62p _1yep5z62q";
        function ee(e) {
          return (0, a.tG)(e, 80);
        }
        var te = o.forwardRef(({
          children: e,
          initialState: t = {},
          state: n,
          onStateChange: s,
          ...l
        }, d) => {
          let h = o.useRef(null),
            f = b({
              ref: h,
              initialState: {
                color: l.colorPresets[0].color,
                includeDate: !0,
                includeTime: !1,
                ...t
              },
              state: n,
              onChange: s
            }),
            g = {
              ...l,
              ...f,
              ref: (0, r.lq)(d, h)
            },
            v = (({
              intl: {
                formatMessage: e
              },
              titleId: t,
              className: n,
              state: r,
              device: s,
              onCloseRequest: l,
              ref: d,
              onCreate: h,
              colorPresets: f,
              onExistingStampPress: g,
              getLighterVariant: v = ee,
              "data-block-id": y = "create-stamp"
            }) => {
              let b = (0, m.aQ)({
                  ...(r.get("includeDate") ? {
                    year: "2-digit",
                    month: "2-digit",
                    day: "2-digit"
                  } : {}),
                  ...(r.get("includeTime") ? {
                    hour: "2-digit",
                    minute: "2-digit"
                  } : {})
                }),
                w = r.get("includeDate") || r.get("includeTime"),
                x = (0, o.useRef)(190);
              return c("div", {
                ref: d,
                className: n,
                "data-block-id": y,
                children: [c("div", {
                  "data-block-id": "header",
                  className: (0, a.AK)(Q, "PSPDFKit-Modal-Section"),
                  children: [u(i.Text, {
                    elementType: "h3",
                    id: t,
                    "data-block-id": "title",
                    children: e("customStamp")
                  }), u(i.ActionButton, {
                    size: "md",
                    "data-block-id": "stamp-presets-button",
                    label: e("useAnExistingStampDesign"),
                    variant: "tertiary",
                    className: "PSPDFKit-Stamp-Dialog-Existing-Stamp-Button",
                    onPress: g
                  })]
                }), c("div", {
                  "data-block-id": "body",
                  className: "_1yep5z69 _1yep5z6g _1yep5z6h _1yep5z6fs",
                  children: [u("div", {
                    className: (0, a.AK)("dabjfd1 _1yep5z63r _1yep5z63s _1yep5z63t _1yep5z61f _1yep5z61g _1yep5z61h _1yep5z68f _1yep5z68m _1yep5z68n _1yep5z663 _1yep5z66a _1yep5z66b _1yep5z6al _1yep5z6am _1yep5z6an _1yep5z6b9 _1yep5z6ba _1yep5z6bb _1yep5z6bx _1yep5z6by _1yep5z6bz _1yep5z6cl _1yep5z6cm _1yep5z6cn _1yep5z6l9 _1yep5z6l7 _1yep5z6gq _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6jl _1yep5z6jm _1yep5z6jn", "PSPDFKit-Stamp-Editor"),
                    children: u(p.Stamp, {
                      "data-block-id": "stamp-preview",
                      strokeColor: r.get("color"),
                      fontColor: r.get("color"),
                      fillColor: v(r.get("color")),
                      text: r.get("text"),
                      subText: w ? b.format(new Date()) : void 0,
                      height: 94,
                      minWidth: 190,
                      maxWidth: 408,
                      onDimensionsChange: e => {
                        x.current = e.width;
                      }
                    })
                  }), u(i.TextInput, {
                    "data-block-id": "stamp-text-input",
                    value: r.get("text"),
                    className: J,
                    label: e("stampText"),
                    onChange: e => {
                      r.set("text", e?.toUpperCase());
                    }
                  }), u(i.Checkbox, {
                    "data-block-id": "include-date-checkbox",
                    label: e("date"),
                    className: J,
                    labelPosition: "start",
                    defaultSelected: r.get("includeDate"),
                    onChange: e => {
                      r.set("includeDate", e);
                    }
                  }), u(i.Checkbox, {
                    "data-block-id": "include-time-checkbox",
                    label: e("time"),
                    className: J,
                    labelPosition: "start",
                    defaultSelected: r.get("includeTime"),
                    onChange: e => {
                      r.set("includeTime", e);
                    }
                  }), u(i.ColorPresetInlineInput, {
                    "data-block-id": "color-selector",
                    items: f,
                    defaultValue: r.get("color"),
                    className: (0, a.AK)("_1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61j _1yep5z61k _1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k", "PSPDFKit-Input-ColorPicker"),
                    optionClassName: "PSPDFKit-Input-ColorPicker-Label PSPDFKit-Input-ColorPicker-Swatch",
                    onChange: e => {
                      r.set("color", e);
                    },
                    optionsContainerClassName: "dabjfd3",
                    labelPosition: "mobile" === s ? "top" : "start",
                    label: e("chooseColor")
                  })]
                }), u("div", {
                  "data-block-id": "footer",
                  className: (0, a.AK)(X, "PSPDFKit-Modal-Section"),
                  children: c("div", {
                    className: Y,
                    children: [u(i.ActionButton, {
                      size: "md",
                      label: e("cancel"),
                      variant: "secondary",
                      "data-block-id": "cancel-button",
                      onPress: () => l?.()
                    }), u(i.ActionButton, {
                      label: e("createStamp"),
                      "data-block-id": "done-button",
                      size: "md",
                      onPress: () => {
                        h({
                          text: r.get("text"),
                          subText: w ? b.format(new Date()) : void 0,
                          width: x.current,
                          color: r.get("color")
                        });
                      }
                    })]
                  })
                })]
              });
            })(g);
          return e ? e({
            ...g,
            ui: v
          }) : v.createComponent();
        });
        te.displayName = "CreateStamp";
        var ne = o.forwardRef(({
          children: e,
          initialState: t = {},
          state: n,
          onStateChange: s,
          ...l
        }, d) => {
          let p = o.useRef(null),
            h = {
              ...l,
              ...b({
                ref: p,
                initialState: t,
                state: n,
                onChange: s
              }),
              ref: (0, r.lq)(d, p)
            },
            f = (({
              intl: {
                formatMessage: e
              },
              titleId: t,
              ref: n,
              items: r,
              className: o,
              onAdd: s,
              onCancel: l,
              onCustomStampPress: d,
              "data-block-id": p = "stamps-list"
            }) => c("div", {
              ref: n,
              className: o,
              "data-block-id": p,
              children: [c("div", {
                "data-block-id": "header",
                className: (0, a.AK)(Q, "PSPDFKit-Modal-Section"),
                children: [u(i.Text, {
                  elementType: "h3",
                  id: t,
                  "data-block-id": "title",
                  children: e("useAnExistingStampDesign")
                }), u(i.ActionButton, {
                  onPress: d,
                  size: "md",
                  "data-block-id": "stamp-presets-button",
                  label: e("customStamp"),
                  variant: "tertiary",
                  className: "PSPDFKit-Stamp-Dialog-Custom-Stamp-Button"
                })]
              }), u("div", {
                "data-block-id": "body",
                className: (0, a.AK)("_1dk00840 x0o33h6 _1yep5z6i6 _1yep5z6i7 _1yep5z6i8 _1yep5z6fs x0o33h7 _1yep5z69 _1yep5z6g _1yep5z6h _1yep5z62l _1yep5z62s _1yep5z62t _1yep5z63r _1yep5z63y _1yep5z63z _1yep5z61f _1yep5z61m _1yep5z61n _1yep5z69l _1yep5z69p _1yep5z69q", "PSPDFKit-Stamp-Picker"),
                children: r.map(({
                  id: e,
                  ...t
                }) => u(i.Preview, {
                  ...t,
                  addAriaLabel: t["aria-label"],
                  "data-block-id": `preview-${e}`,
                  onPress: () => s?.(e)
                }))
              }), u("div", {
                "data-block-id": "footer",
                className: (0, a.AK)(X, "PSPDFKit-Modal-Section"),
                children: u("div", {
                  className: Y,
                  children: u(i.ActionButton, {
                    onPress: l,
                    size: "md",
                    label: e("cancel"),
                    variant: "secondary",
                    "data-block-id": "cancel-button"
                  })
                })
              })]
            }))(h);
          return e ? e({
            ...h,
            ui: f
          }) : f.createComponent();
        });
        ne.displayName = "StampsList";
        var re = "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z69i _1yep5z69j _1yep5z69k _1yep5z6km",
          oe = "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z69i _1yep5z69j _1yep5z69k",
          ie = "_443wcr6";
        function ae({
          error: e
        }) {
          return (0, f.jsx)(i.InlineAlert, {
            title: e.title,
            description: e.description,
            variant: "error",
            arrangement: "compact",
            actionLabel: e.action?.text,
            onAction: e.action?.onPress
          });
        }
        function se({
          actions: e
        }) {
          return (0, f.jsx)("div", {
            className: re,
            children: e.map(({
              text: e,
              onPress: t
            }, n) => (0, f.jsx)(i.ActionButton, {
              variant: "tertiary",
              label: e,
              onPress: t,
              size: "sm"
            }, n))
          });
        }
        function le({
          additionalContext: e,
          linkToAdditionalContext: t,
          actions: n
        }) {
          return (0, f.jsxs)(f.Fragment, {
            children: [(0, f.jsx)("div", {
              className: "_1yep5z66 _1yep5z67 _1yep5z68 _1yep5z62i _1yep5z62j _1yep5z62k _1yep5z63o _1yep5z63p _1yep5z63q _1yep5z61c _1yep5z61d _1yep5z61e _1yep5z6fn",
              children: (0, f.jsx)(i.Text, {
                type: "body",
                size: "sm",
                className: "_443wcr5",
                children: e
              })
            }), (0, f.jsx)(i.Link, {
              onPress: t.onPress,
              size: "sm",
              children: t.text
            }), (0, f.jsx)("div", {
              className: re,
              children: n.map(({
                text: e,
                onPress: t
              }, n) => (0, f.jsx)(i.ActionButton, {
                variant: "tertiary",
                label: e,
                onPress: t,
                size: "sm"
              }, n))
            })]
          });
        }
        function ue({
          suggestions: e
        }) {
          return (0, f.jsx)("div", {
            className: oe,
            children: e.map(({
              text: e,
              onPress: t
            }, n) => (0, f.jsx)(i.Link, {
              variant: "inline",
              onPress: t,
              size: "sm",
              children: e
            }, n))
          });
        }
        function ce({
          links: e,
          actions: t,
          actionsText: n
        }) {
          let [r, a] = (0, o.useState)(1),
            {
              formatMessage: s
            } = (0, i.useI18n)(),
            l = e.length <= 15,
            u = l ? 0 : 15 * (r - 1),
            c = l ? Math.min(e.length, 5 * r) : 15 * r;
          return (0, f.jsxs)(f.Fragment, {
            children: [(0, f.jsxs)("div", {
              className: oe,
              children: [e.slice(u, c).map(({
                text: e,
                onPress: t
              }, n) => (0, f.jsxs)(i.Box, {
                display: "flex",
                alignItems: "center",
                gap: "sm",
                color: "icon.primary",
                children: [(0, f.jsx)(i.Box, {
                  display: "flex",
                  alignItems: "center",
                  children: (0, f.jsx)(g.LZ, {
                    size: 16
                  })
                }), (0, f.jsx)(i.Link, {
                  variant: "inline",
                  onPress: t,
                  size: "sm",
                  title: e,
                  style: {
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: e
                })]
              }, n)), e.length > 15 && (0, f.jsx)(i.Pagination, {
                "aria-label": s(de.viewMoreResults),
                variant: "pinned",
                maxValue: Math.ceil(e.length / 15),
                onChange: a,
                size: "xs"
              }), l && c < e.length ? (0, f.jsx)(i.Link, {
                onPress: () => {
                  a(e => e + 1);
                },
                size: "sm",
                children: s("showMore")
              }) : null]
            }), (0, f.jsx)(i.Text, {
              type: "body",
              size: "sm",
              children: n
            }), (0, f.jsx)("div", {
              className: re,
              children: t.map(({
                text: e,
                onPress: t
              }, n) => (0, f.jsx)(i.ActionButton, {
                variant: "tertiary",
                label: e,
                onPress: t,
                size: "sm"
              }, n))
            })]
          });
        }
        var de = (0, i.defineMessages)({
            viewMoreResults: {
              id: "viewMoreResults",
              defaultMessage: "View More Results"
            }
          }),
          pe = "ACTIONS",
          he = "ERROR",
          fe = "SUGGESTIONS",
          me = "ADDITIONAL_CONTEXT",
          ge = "QUERY_RESULT",
          ve = (0, i.defineMessages)({
            chat: {
              id: "chat",
              defaultMessage: "Chat"
            },
            readMore: {
              id: "readMore",
              defaultMessage: "Read More"
            },
            typeSomething: {
              id: "typeSomething",
              defaultMessage: "Type something..."
            }
          }),
          ye = o.forwardRef(({
            children: e,
            initialState: t = {},
            ...n
          }, s) => {
            let l = o.useRef(null),
              d = {
                ...n,
                ...b({
                  ref: l,
                  initialState: t
                }),
                ref: (0, r.lq)(s, l)
              },
              h = (({
                intl: {
                  formatMessage: e
                },
                className: t,
                titleId: n,
                "data-block-id": r = "chat-dialog",
                messages: s,
                onMessageSubmit: l,
                onInputChanged: d,
                isLoading: h,
                isDisabled: f,
                isSubmitDisabled: m,
                variant: v = "default",
                inputValue: y,
                style: b,
                editorHandle: w
              }) => {
                let x = (0, o.useRef)(null);
                return c("div", {
                  role: "log",
                  "data-block-id": r,
                  className: (0, a.AK)("_1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ir _1yep5z6is _1yep5z6it _1yep5z6ic _1yep5z6id _1yep5z6ie", t),
                  style: b,
                  "aria-labelledby": n,
                  children: [h ? u(i.ProgressSpinner, {
                    className: "_1yep5z6kv _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z6ft _1yep5z6jl _1yep5z6jm _1yep5z6jn",
                    "aria-label": e("loading")
                  }) : null, Array.isArray(s) && !h && u("div", {
                    className: "_443wcr1 _1yep5z6kv _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ii _1yep5z6ij _1yep5z6ik _1yep5z69f _1yep5z69g _1yep5z69h _1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z6ft",
                    ref: x,
                    children: u("div", {
                      className: "_443wcr2",
                      children: s.map(({
                        id: t,
                        type: n,
                        isComplete: r,
                        canCopy: l,
                        text: d,
                        ...h
                      }, f) => {
                        let m;
                        switch (n) {
                          case he:
                            {
                              let {
                                error: e
                              } = h;
                              m = u(ae, {
                                error: e
                              });
                              break;
                            }
                          case pe:
                            {
                              let {
                                actions: e
                              } = h;
                              m = u(se, {
                                actions: e
                              });
                              break;
                            }
                          case fe:
                            {
                              let {
                                suggestions: e
                              } = h;
                              m = u(ue, {
                                suggestions: e
                              });
                              break;
                            }
                          case me:
                            {
                              let {
                                additionalContext: e,
                                linkToAdditionalContext: t,
                                actions: n
                              } = h;
                              m = u(le, {
                                actions: n,
                                additionalContext: e,
                                linkToAdditionalContext: t
                              });
                              break;
                            }
                          case ge:
                            {
                              let {
                                links: e,
                                actionsText: t,
                                actions: n
                              } = h;
                              m = u(ce, {
                                links: e,
                                actionsText: t,
                                actions: n
                              });
                              break;
                            }
                          default:
                            m = null;
                        }
                        let y = u(i.Markdown, {
                          showCaret: !r,
                          className: "_443wcr8",
                          children: d
                        });
                        return c(o.Fragment, {
                          children: [c(p.Comment, {
                            avatarProps: {
                              name: h.sender,
                              showInitials: !0
                            },
                            content: y.createComponent(),
                            name: h.sender,
                            isInline: "full-width" !== v,
                            children: [m, l ? u(i.Box, {
                              children: u(i.ActionIconButton, {
                                variant: "secondary",
                                icon: g.TI,
                                onPress: () => {
                                  navigator.clipboard.writeText(d);
                                },
                                size: "sm",
                                "aria-label": e("copy")
                              })
                            }) : null]
                          }), f !== s.length - 1 && u(i.Separator, {
                            className: (0, a.AK)(ie, {
                              "_443wcr7 _1yep5z68u _1yep5z68v _1yep5z68w": "default" === v
                            })
                          })]
                        }, t);
                      })
                    })
                  }), u(i.Box, {
                    position: "relative",
                    width: "full",
                    children: u(i.ScrollControlButton, {
                      "data-block-id": "scroll-control-button",
                      className: "_443wcr4",
                      label: e(ve.readMore),
                      scrollRef: x
                    })
                  }), u(i.Separator, {
                    className: ie
                  }), u(i.Editor, {
                    isDisabled: f,
                    isSaveDisabled: m,
                    onChange: d,
                    onSave: l,
                    placeholder: e(ve.typeSomething),
                    variant: "minimal",
                    isInline: !1,
                    className: "_443wcr3 _1yep5z6c0 _1yep5z6c1 _1yep5z6c2 _1yep5z6co _1yep5z6cp _1yep5z6cq _1yep5z6kv",
                    value: y,
                    editorHandle: w,
                    saveOnEnter: !0
                  })]
                });
              })(d);
            return e ? e({
              ...d,
              ui: h
            }) : h.createComponent();
          });
        ye.displayName = "ChatDialog";
        var be = _({
            defaultClassName: "_1aicd310 _1yep5z6b3 _1yep5z6ap _1yep5z6aq _1yep5z6br _1yep5z6bd _1yep5z6be _1yep5z6cf _1yep5z6c1 _1yep5z6c2 _1yep5z6d3 _1yep5z6cp _1yep5z6cq _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6ft _1yep5z6hl _1yep5z6hm _1yep5z6hn",
            variantClassNames: {
              variant: {
                popover: "_1yep5z613b _1yep5z613c _1yep5z613d _1yep5z613n _1yep5z613o _1yep5z613p _1yep5z614n _1yep5z614o _1yep5z614p",
                sidebar: "_1aicd312"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          }),
          we = _({
            defaultClassName: "_1aicd313 _1yep5z6bu _1yep5z6bv _1yep5z6bw _1yep5z6ci _1yep5z6cj _1yep5z6ck _1yep5z6d7",
            variantClassNames: {
              isEmpty: {
                true: "_1aicd314",
                false: "_1aicd315"
              }
            },
            defaultVariants: {},
            compoundVariants: []
          });
        var xe = {
            from: {
              opacity: 0
            },
            enter: {
              opacity: 1
            },
            leave: {
              opacity: 0
            }
          },
          De = ({
            ref: e,
            className: t,
            style: n,
            state: s,
            comments: l,
            intl: {
              formatMessage: f
            },
            "data-block-id": g = "comment-thread",
            titleId: b,
            variant: w = "sidebar",
            onEditorValueChange: x,
            onCommentAdd: D,
            onCommentUpdate: C,
            onDelete: S,
            device: E,
            portalContainer: _,
            mentionableUsers: P,
            editorFooterButtons: k,
            onAnonymousToggle: A,
            maxMentionableUsersSuggestions: z,
            onPress: T,
            allowCommentCreation: O = !0,
            defaultEditorValue: I,
            ...F
          }) => {
            let M = o.useRef(null),
              [R, j] = o.useState(new Set()),
              B = s.get("isExpanded"),
              N = 0 === l.length,
              L = (0, a.mS)({
                "data-block-id": g,
                "data-expanded": B,
                "data-empty": N
              }),
              V = function ({
                initialHeight: e,
                finalHeight: t,
                isExpanded: n
              }) {
                let [r, o] = (0, v.q_)(() => ({
                  from: {
                    height: "auto"
                  }
                }));
                return (0, y.useGranularLayoutEffect)(() => {
                  n ? o.start({
                    height: t(),
                    onRest: () => {
                      o.start({
                        height: "auto",
                        immediate: !0
                      });
                    }
                  }) : o.start({
                    height: e()
                  });
                }, [n], [o, t, e]), r;
              }({
                initialHeight: () => (M.current?.offsetHeight || 0) + 2,
                finalHeight: () => (q.current?.offsetHeight || 0) + 2,
                isExpanded: B
              }),
              K = O ? u(i.Editor, {
                className: (0, a.AK)(we({
                  isEmpty: N
                }), "PSPDFKit-Comment-Editor"),
                enableRichText: !0,
                isInline: !1,
                mentionableUsers: P,
                maxMentionableUsersSuggestions: z,
                footerButtons: k,
                placeholder: f(Ce.commentEditorLabel),
                onSave: D,
                "data-block-id": "editor",
                onChange: x,
                clearOnSave: !0,
                autoFocus: !l.length,
                "aria-label": f(Ce.commentEditorLabel),
                defaultValue: I
              }) : null,
              {
                ref: q,
                ...H
              } = function (e) {
                let t = o.useRef(null),
                  [n, r] = (0, o.useState)(!1),
                  i = (0, o.useCallback)(() => {
                    r(!0);
                  }, []),
                  a = (0, o.useCallback)(t => {
                    r(!1), e && e(t);
                  }, [e]),
                  s = (0, o.useCallback)(e => {
                    ("Enter" === e.key || " " === e.key) && r(!0);
                  }, []),
                  l = (0, o.useCallback)(t => {
                    ("Enter" === t.key || " " === t.key) && (r(!1), e && e(t));
                  }, [e]);
                return (0, o.useEffect)(() => {
                  let e = t.current;
                  if (e) return e.addEventListener("pointerdown", i), e.addEventListener("pointerup", a), e.addEventListener("keydown", s), e.addEventListener("keyup", l), () => {
                    e.removeEventListener("pointerdown", i), e.removeEventListener("pointerup", a), e.removeEventListener("keydown", s), e.removeEventListener("keyup", l);
                  };
                }, [i, a, s, l, t]), {
                  ref: t,
                  tabIndex: 0,
                  role: "button",
                  "aria-pressed": n,
                  "aria-disabled": !1
                };
              }(T),
              U = (0, m.Me)(b),
              Z = (0, o.useMemo)(() => ({
                canEdit: {
                  id: "edit",
                  label: f(Ce.editContent)
                },
                canDelete: {
                  id: "delete",
                  label: f(Ce.deleteComment)
                },
                canBeAnonymous: {
                  id: "anonymous",
                  label: f(Ce.anonymous)
                }
              }), [f]),
              $ = (0, o.useCallback)(e => Object.entries(Z).filter(([t]) => !!e[t]).map(([, e]) => e), [Z]),
              G = (0, o.useCallback)(e => function (e) {
                return e.canEdit || e.canDelete || e.canBeAnonymous;
              }(e) && (B || "sidebar" !== w) ? {
                items: $(e),
                "aria-label": f(Ce.commentOptions),
                selectionMode: "single",
                selectedKeys: e.isAnonymous ? ["anonymous"] : [],
                onAction: t => {
                  switch (t) {
                    case "edit":
                      j(t => new Set(t.add(e.id)));
                      break;
                    case "delete":
                      s.set("toDelete", e.id);
                      break;
                    case "anonymous":
                      A?.(e.id, !e.isAnonymous);
                  }
                }
              } : void 0, [f, $, B, A, s, w]),
              W = (0, o.useCallback)(e => {
                let t = R.has(e.id),
                  n = !e.avatarProps;
                return {
                  ...e,
                  "data-comment-id": e.id,
                  "data-block-id": "comment",
                  className: (0, a.AK)(e.className, {
                    "_1yep5z646 _1yep5z647 _1yep5z648": n
                  }, "PSPDFKit-Comment"),
                  menuProps: G(e),
                  content: t ? u(i.Editor, {
                    style: {
                      marginInlineStart: -36
                    },
                    spellCheck: !1,
                    defaultValue: e.content,
                    mentionableUsers: P,
                    maxMentionableUsersSuggestions: z,
                    enableRichText: !0,
                    autoFocus: !0,
                    onCancel: () => {
                      j(t => new Set([...t].filter(t => t !== e.id)));
                    },
                    onSave: t => {
                      C?.(e.id, t), j(t => new Set([...t].filter(t => t !== e.id)));
                    },
                    submitButtonAriaLabel: f(Ce.edit),
                    onChange: t => x?.(t, e.id),
                    clearOnSave: !0,
                    cancelButtonAriaLabel: f(Ce.discardChanges),
                    "aria-label": f(Ce.commentEditorLabel)
                  }).createComponent() : e.content
                };
              }, [R, f, G, z, P, C, x]),
              [Y, ...X] = l,
              Q = c(d, {
                children: [u(i.Box, {
                  backgroundColor: "background.primary.subtle",
                  paddingY: "md",
                  paddingX: "lg",
                  display: "flex",
                  alignItems: "center",
                  "data-block-id": "header",
                  style: {
                    minHeight: 48
                  },
                  children: u(i.Text, {
                    id: U,
                    type: "title",
                    size: "sm",
                    elementType: "h3",
                    "data-blockid": "title",
                    children: f(Ce.comments)
                  })
                }), u(i.Separator, {
                  variant: "secondary"
                })]
              }),
              J = Y ? u(p.Comment, {
                "data-blockid": "comment",
                ...W(Y),
                children: "sidebar" === w && !B && u(i.Link, {
                  size: "sm",
                  onPress: B ? void 0 : () => {
                    s.set("isExpanded", !0);
                  },
                  children: B || !X.length ? void 0 : f(Ce.nMoreComments, {
                    arg0: X.length
                  })
                })
              }) : K,
              ee = X.map((e, t) => c(o.Fragment, {
                children: [u("div", {
                  className: (0, h.Kj)({
                    paddingLeft: "5xl"
                  }),
                  children: u(i.Separator, {
                    variant: "secondary"
                  })
                }), u(p.Comment, {
                  ...W(e)
                })]
              }, t));
            return (0, o.useEffect)(() => {
              l.length || s.set("isExpanded", !0);
            }, [l, s]), (0, o.useEffect)(() => {
              B || j(new Set());
            }, [B]), c(d, {
              children: [u(v.q.div, {
                "aria-labelledby": U,
                ...(0, m.dG)((0, r.zL)(F), L),
                role: "complementary",
                ref: e,
                style: {
                  ...n,
                  height: "popover" === w || N ? "auto" : V.height
                },
                className: (0, a.AK)(be({
                  variant: w
                }), {
                  "PSPDFKit-Comment-Thread-Wrapper": !0,
                  "PSPDFKit-Comment-Thread-Wrapper-Expanded": B,
                  "PSPDFKit-Comment-Thread-Expanded": B
                }, t),
                children: u("div", {
                  ...(T ? H : {}),
                  ref: q,
                  className: (0, a.AK)({
                    _1aicd319: "sidebar" === w,
                    "_1aicd318 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie _1yep5z6jc _1yep5z6jd _1yep5z6je": "sidebar" !== w,
                    "_1aicd317 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6ic _1yep5z6id _1yep5z6ie": "mobile" === E && "sidebar" !== w
                  }),
                  children: c(d, "sidebar" === w ? {
                    children: [u("div", {
                      ref: M,
                      children: J
                    }), (X.length > 0 || !!Y) && c(i.Transition, {
                      isMounted: B,
                      transitions: xe,
                      children: [ee, K]
                    })]
                  } : {
                    children: ["mobile" === E ? u(m.TX, {
                      children: Q
                    }) : Q, u("div", {
                      className: "_1aicd316 _1yep5z6i0 _1yep5z6i1 _1yep5z6i2 _1yep5z6jc _1yep5z6jd _1yep5z6je _1yep5z6hl _1yep5z6hm _1yep5z6hn _1yep5z6ii _1yep5z6ij _1yep5z6ik _1yep5z6iu _1yep5z6iv _1yep5z6iw",
                      children: c("div", {
                        className: (0, h.Kj)({
                          display: "flex",
                          flexDirection: "column",
                          width: "full"
                        }),
                        children: [J, ee]
                      })
                    }), l.length ? K : null]
                  })
                })
              }), u(i.Modal, {
                isOpen: !!s.get("toDelete"),
                onOpenChange: () => {
                  s.set("toDelete", null);
                },
                children: u(i.ModalContent, {
                  portalContainer: _,
                  style: {
                    zIndex: 999999
                  },
                  children: u(i.AlertDialog, {
                    title: f(Ce.deleteComment),
                    message: f(Ce.deleteCommentConfirmMessage),
                    onCancel: () => {
                      s.set("toDelete", null);
                    },
                    cancelLabel: f(Ce.cancel),
                    primaryActionLabel: f(Ce.delete),
                    onPrimaryAction: () => {
                      S?.(s.get("toDelete")), s.set("toDelete", null);
                    }
                  })
                })
              })]
            });
          };
        var Ce = (0, i.defineMessages)({
            comments: {
              id: "comments",
              defaultMessage: "Comments"
            },
            nMoreComments: {
              id: "nMoreComments",
              defaultMessage: "{n, plural, one {1 more comment} other {# more comments}}"
            },
            edit: {
              id: "edit",
              defaultMessage: "Edit"
            },
            delete: {
              id: "delete",
              defaultMessage: "Delete"
            },
            cancel: {
              id: "cancel",
              defaultMessage: "Cancel"
            },
            deleteComment: {
              id: "deleteComment",
              defaultMessage: "Delete Comment"
            },
            anonymous: {
              id: "anonymous",
              defaultMessage: "Anonymous"
            },
            commentOptions: {
              id: "commentOptions",
              defaultMessage: "Comment Options"
            },
            commentEditorLabel: {
              id: "commentEditorLabel",
              defaultMessage: "Comment Editor"
            },
            save: {
              id: "save",
              defaultMessage: "Save"
            },
            deleteCommentConfirmMessage: {
              id: "deleteCommentConfirmMessage",
              defaultMessage: "Are you sure you want to delete this comment?"
            },
            discardChanges: {
              id: "discardChanges",
              defaultMessage: "Discard Changes"
            },
            editContent: {
              id: "editContent",
              defaultMessage: "Edit Content"
            }
          }),
          Se = o.forwardRef(({
            children: e,
            initialState: t = {},
            onStateChange: n,
            state: i,
            ...a
          }, s) => {
            let l = o.useRef(null),
              u = {
                ...a,
                ...b({
                  ref: l,
                  initialState: t,
                  state: i,
                  onChange: n
                }),
                ref: (0, r.lq)(s, l)
              },
              c = De(u);
            return e ? e({
              ...u,
              ui: c
            }) : c.createComponent();
          });
        Se.displayName = "CommentThread";
      },
      85816: (e, t, n) => {
        "use strict";

        n.d(t, {
          $_: () => g,
          Kj: () => x,
          Wb: () => m,
          layoutSprinkleValues: () => w,
          o$: () => y,
          themeVars: () => v
        });
        var r = n(96486);
        function o(e) {
          var t = function (e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : String(t);
        }
        function i(e, t, n) {
          return (t = o(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function a(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function s(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(n), !0).forEach(function (t) {
              i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var l,
          u = e => function () {
            for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            var o = Object.assign({}, ...n.map(e => e.styles)),
              i = Object.keys(o),
              a = i.filter(e => "mappings" in o[e]),
              l = t => {
                var n = [],
                  r = {},
                  i = s({}, t),
                  l = !1;
                for (var u of a) {
                  var c = t[u];
                  if (null != c) {
                    var d = o[u];
                    for (var p of (l = !0, d.mappings)) r[p] = c, null == i[p] && delete i[p];
                  }
                }
                var h = l ? s(s({}, r), i) : t,
                  f = function () {
                    var e = h[m],
                      t = o[m];
                    try {
                      if (t.mappings) return "continue";
                      if ("string" == typeof e || "number" == typeof e) n.push(t.values[e].defaultClass);else if (Array.isArray(e)) for (var r = 0; r < e.length; r++) {
                        var i = e[r];
                        if (null != i) {
                          var a = t.responsiveArray[r];
                          0, n.push(t.values[i].conditions[a]);
                        }
                      } else for (var s in e) {
                        var l = e[s];
                        null != l && n.push(t.values[l].conditions[s]);
                      }
                    } catch (e) {
                      throw e;
                    }
                  };
                for (var m in h) f();
                return e(n.join(" "));
              };
            return Object.assign(l, {
              properties: new Set(i)
            });
          },
          c = e => e,
          d = function () {
            return u(c)(...arguments);
          },
          p = d(((l = {
            conditions: {
              defaultCondition: ["mobile", "tablet", "desktop"],
              conditionNames: ["mobile", "tablet", "desktop"],
              responsiveArray: ["mobile", "tablet", "desktop"]
            },
            styles: {
              paddingLeft: {
                mappings: ["paddingInlineStart"]
              },
              paddingRight: {
                mappings: ["paddingInlineEnd"]
              },
              paddingTop: {
                mappings: ["paddingBlockStart"]
              },
              paddingBottom: {
                mappings: ["paddingBlockEnd"]
              },
              padding: {
                mappings: ["paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd"]
              },
              paddingX: {
                mappings: ["paddingInlineStart", "paddingInlineEnd"]
              },
              paddingY: {
                mappings: ["paddingBlockStart", "paddingBlockEnd"]
              },
              marginLeft: {
                mappings: ["marginInlineStart"]
              },
              marginRight: {
                mappings: ["marginInlineEnd"]
              },
              marginTop: {
                mappings: ["marginBlockStart"]
              },
              marginBottom: {
                mappings: ["marginBlockEnd"]
              },
              margin: {
                mappings: ["marginBlockStart", "marginBlockEnd", "marginInlineStart", "marginInlineEnd"]
              },
              marginX: {
                mappings: ["marginInlineStart", "marginInlineEnd"]
              },
              marginY: {
                mappings: ["marginBlockStart", "marginBlockEnd"]
              },
              paddingBlockStart: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z60",
                      tablet: "_1yep5z61",
                      desktop: "_1yep5z62"
                    },
                    defaultClass: "_1yep5z60 _1yep5z61 _1yep5z62"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z63",
                      tablet: "_1yep5z64",
                      desktop: "_1yep5z65"
                    },
                    defaultClass: "_1yep5z63 _1yep5z64 _1yep5z65"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z66",
                      tablet: "_1yep5z67",
                      desktop: "_1yep5z68"
                    },
                    defaultClass: "_1yep5z66 _1yep5z67 _1yep5z68"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z69",
                      tablet: "_1yep5z6a",
                      desktop: "_1yep5z6b"
                    },
                    defaultClass: "_1yep5z69 _1yep5z6a _1yep5z6b"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z6c",
                      tablet: "_1yep5z6d",
                      desktop: "_1yep5z6e"
                    },
                    defaultClass: "_1yep5z6c _1yep5z6d _1yep5z6e"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z6f",
                      tablet: "_1yep5z6g",
                      desktop: "_1yep5z6h"
                    },
                    defaultClass: "_1yep5z6f _1yep5z6g _1yep5z6h"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z6i",
                      tablet: "_1yep5z6j",
                      desktop: "_1yep5z6k"
                    },
                    defaultClass: "_1yep5z6i _1yep5z6j _1yep5z6k"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z6l",
                      tablet: "_1yep5z6m",
                      desktop: "_1yep5z6n"
                    },
                    defaultClass: "_1yep5z6l _1yep5z6m _1yep5z6n"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z6o",
                      tablet: "_1yep5z6p",
                      desktop: "_1yep5z6q"
                    },
                    defaultClass: "_1yep5z6o _1yep5z6p _1yep5z6q"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z6r",
                      tablet: "_1yep5z6s",
                      desktop: "_1yep5z6t"
                    },
                    defaultClass: "_1yep5z6r _1yep5z6s _1yep5z6t"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z6u",
                      tablet: "_1yep5z6v",
                      desktop: "_1yep5z6w"
                    },
                    defaultClass: "_1yep5z6u _1yep5z6v _1yep5z6w"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z6x",
                      tablet: "_1yep5z6y",
                      desktop: "_1yep5z6z"
                    },
                    defaultClass: "_1yep5z6x _1yep5z6y _1yep5z6z"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z610",
                      tablet: "_1yep5z611",
                      desktop: "_1yep5z612"
                    },
                    defaultClass: "_1yep5z610 _1yep5z611 _1yep5z612"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z613",
                      tablet: "_1yep5z614",
                      desktop: "_1yep5z615"
                    },
                    defaultClass: "_1yep5z613 _1yep5z614 _1yep5z615"
                  }
                },
                responsiveArray: void 0
              },
              paddingInlineEnd: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z616",
                      tablet: "_1yep5z617",
                      desktop: "_1yep5z618"
                    },
                    defaultClass: "_1yep5z616 _1yep5z617 _1yep5z618"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z619",
                      tablet: "_1yep5z61a",
                      desktop: "_1yep5z61b"
                    },
                    defaultClass: "_1yep5z619 _1yep5z61a _1yep5z61b"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z61c",
                      tablet: "_1yep5z61d",
                      desktop: "_1yep5z61e"
                    },
                    defaultClass: "_1yep5z61c _1yep5z61d _1yep5z61e"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z61f",
                      tablet: "_1yep5z61g",
                      desktop: "_1yep5z61h"
                    },
                    defaultClass: "_1yep5z61f _1yep5z61g _1yep5z61h"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z61i",
                      tablet: "_1yep5z61j",
                      desktop: "_1yep5z61k"
                    },
                    defaultClass: "_1yep5z61i _1yep5z61j _1yep5z61k"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z61l",
                      tablet: "_1yep5z61m",
                      desktop: "_1yep5z61n"
                    },
                    defaultClass: "_1yep5z61l _1yep5z61m _1yep5z61n"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z61o",
                      tablet: "_1yep5z61p",
                      desktop: "_1yep5z61q"
                    },
                    defaultClass: "_1yep5z61o _1yep5z61p _1yep5z61q"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z61r",
                      tablet: "_1yep5z61s",
                      desktop: "_1yep5z61t"
                    },
                    defaultClass: "_1yep5z61r _1yep5z61s _1yep5z61t"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z61u",
                      tablet: "_1yep5z61v",
                      desktop: "_1yep5z61w"
                    },
                    defaultClass: "_1yep5z61u _1yep5z61v _1yep5z61w"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z61x",
                      tablet: "_1yep5z61y",
                      desktop: "_1yep5z61z"
                    },
                    defaultClass: "_1yep5z61x _1yep5z61y _1yep5z61z"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z620",
                      tablet: "_1yep5z621",
                      desktop: "_1yep5z622"
                    },
                    defaultClass: "_1yep5z620 _1yep5z621 _1yep5z622"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z623",
                      tablet: "_1yep5z624",
                      desktop: "_1yep5z625"
                    },
                    defaultClass: "_1yep5z623 _1yep5z624 _1yep5z625"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z626",
                      tablet: "_1yep5z627",
                      desktop: "_1yep5z628"
                    },
                    defaultClass: "_1yep5z626 _1yep5z627 _1yep5z628"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z629",
                      tablet: "_1yep5z62a",
                      desktop: "_1yep5z62b"
                    },
                    defaultClass: "_1yep5z629 _1yep5z62a _1yep5z62b"
                  }
                },
                responsiveArray: void 0
              },
              paddingBlockEnd: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z62c",
                      tablet: "_1yep5z62d",
                      desktop: "_1yep5z62e"
                    },
                    defaultClass: "_1yep5z62c _1yep5z62d _1yep5z62e"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z62f",
                      tablet: "_1yep5z62g",
                      desktop: "_1yep5z62h"
                    },
                    defaultClass: "_1yep5z62f _1yep5z62g _1yep5z62h"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z62i",
                      tablet: "_1yep5z62j",
                      desktop: "_1yep5z62k"
                    },
                    defaultClass: "_1yep5z62i _1yep5z62j _1yep5z62k"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z62l",
                      tablet: "_1yep5z62m",
                      desktop: "_1yep5z62n"
                    },
                    defaultClass: "_1yep5z62l _1yep5z62m _1yep5z62n"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z62o",
                      tablet: "_1yep5z62p",
                      desktop: "_1yep5z62q"
                    },
                    defaultClass: "_1yep5z62o _1yep5z62p _1yep5z62q"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z62r",
                      tablet: "_1yep5z62s",
                      desktop: "_1yep5z62t"
                    },
                    defaultClass: "_1yep5z62r _1yep5z62s _1yep5z62t"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z62u",
                      tablet: "_1yep5z62v",
                      desktop: "_1yep5z62w"
                    },
                    defaultClass: "_1yep5z62u _1yep5z62v _1yep5z62w"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z62x",
                      tablet: "_1yep5z62y",
                      desktop: "_1yep5z62z"
                    },
                    defaultClass: "_1yep5z62x _1yep5z62y _1yep5z62z"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z630",
                      tablet: "_1yep5z631",
                      desktop: "_1yep5z632"
                    },
                    defaultClass: "_1yep5z630 _1yep5z631 _1yep5z632"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z633",
                      tablet: "_1yep5z634",
                      desktop: "_1yep5z635"
                    },
                    defaultClass: "_1yep5z633 _1yep5z634 _1yep5z635"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z636",
                      tablet: "_1yep5z637",
                      desktop: "_1yep5z638"
                    },
                    defaultClass: "_1yep5z636 _1yep5z637 _1yep5z638"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z639",
                      tablet: "_1yep5z63a",
                      desktop: "_1yep5z63b"
                    },
                    defaultClass: "_1yep5z639 _1yep5z63a _1yep5z63b"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z63c",
                      tablet: "_1yep5z63d",
                      desktop: "_1yep5z63e"
                    },
                    defaultClass: "_1yep5z63c _1yep5z63d _1yep5z63e"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z63f",
                      tablet: "_1yep5z63g",
                      desktop: "_1yep5z63h"
                    },
                    defaultClass: "_1yep5z63f _1yep5z63g _1yep5z63h"
                  }
                },
                responsiveArray: void 0
              },
              paddingInlineStart: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z63i",
                      tablet: "_1yep5z63j",
                      desktop: "_1yep5z63k"
                    },
                    defaultClass: "_1yep5z63i _1yep5z63j _1yep5z63k"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z63l",
                      tablet: "_1yep5z63m",
                      desktop: "_1yep5z63n"
                    },
                    defaultClass: "_1yep5z63l _1yep5z63m _1yep5z63n"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z63o",
                      tablet: "_1yep5z63p",
                      desktop: "_1yep5z63q"
                    },
                    defaultClass: "_1yep5z63o _1yep5z63p _1yep5z63q"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z63r",
                      tablet: "_1yep5z63s",
                      desktop: "_1yep5z63t"
                    },
                    defaultClass: "_1yep5z63r _1yep5z63s _1yep5z63t"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z63u",
                      tablet: "_1yep5z63v",
                      desktop: "_1yep5z63w"
                    },
                    defaultClass: "_1yep5z63u _1yep5z63v _1yep5z63w"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z63x",
                      tablet: "_1yep5z63y",
                      desktop: "_1yep5z63z"
                    },
                    defaultClass: "_1yep5z63x _1yep5z63y _1yep5z63z"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z640",
                      tablet: "_1yep5z641",
                      desktop: "_1yep5z642"
                    },
                    defaultClass: "_1yep5z640 _1yep5z641 _1yep5z642"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z643",
                      tablet: "_1yep5z644",
                      desktop: "_1yep5z645"
                    },
                    defaultClass: "_1yep5z643 _1yep5z644 _1yep5z645"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z646",
                      tablet: "_1yep5z647",
                      desktop: "_1yep5z648"
                    },
                    defaultClass: "_1yep5z646 _1yep5z647 _1yep5z648"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z649",
                      tablet: "_1yep5z64a",
                      desktop: "_1yep5z64b"
                    },
                    defaultClass: "_1yep5z649 _1yep5z64a _1yep5z64b"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z64c",
                      tablet: "_1yep5z64d",
                      desktop: "_1yep5z64e"
                    },
                    defaultClass: "_1yep5z64c _1yep5z64d _1yep5z64e"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z64f",
                      tablet: "_1yep5z64g",
                      desktop: "_1yep5z64h"
                    },
                    defaultClass: "_1yep5z64f _1yep5z64g _1yep5z64h"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z64i",
                      tablet: "_1yep5z64j",
                      desktop: "_1yep5z64k"
                    },
                    defaultClass: "_1yep5z64i _1yep5z64j _1yep5z64k"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z64l",
                      tablet: "_1yep5z64m",
                      desktop: "_1yep5z64n"
                    },
                    defaultClass: "_1yep5z64l _1yep5z64m _1yep5z64n"
                  }
                },
                responsiveArray: void 0
              },
              marginBlockStart: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z64o",
                      tablet: "_1yep5z64p",
                      desktop: "_1yep5z64q"
                    },
                    defaultClass: "_1yep5z64o _1yep5z64p _1yep5z64q"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z64r",
                      tablet: "_1yep5z64s",
                      desktop: "_1yep5z64t"
                    },
                    defaultClass: "_1yep5z64r _1yep5z64s _1yep5z64t"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z64u",
                      tablet: "_1yep5z64v",
                      desktop: "_1yep5z64w"
                    },
                    defaultClass: "_1yep5z64u _1yep5z64v _1yep5z64w"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z64x",
                      tablet: "_1yep5z64y",
                      desktop: "_1yep5z64z"
                    },
                    defaultClass: "_1yep5z64x _1yep5z64y _1yep5z64z"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z650",
                      tablet: "_1yep5z651",
                      desktop: "_1yep5z652"
                    },
                    defaultClass: "_1yep5z650 _1yep5z651 _1yep5z652"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z653",
                      tablet: "_1yep5z654",
                      desktop: "_1yep5z655"
                    },
                    defaultClass: "_1yep5z653 _1yep5z654 _1yep5z655"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z656",
                      tablet: "_1yep5z657",
                      desktop: "_1yep5z658"
                    },
                    defaultClass: "_1yep5z656 _1yep5z657 _1yep5z658"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z659",
                      tablet: "_1yep5z65a",
                      desktop: "_1yep5z65b"
                    },
                    defaultClass: "_1yep5z659 _1yep5z65a _1yep5z65b"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z65c",
                      tablet: "_1yep5z65d",
                      desktop: "_1yep5z65e"
                    },
                    defaultClass: "_1yep5z65c _1yep5z65d _1yep5z65e"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z65f",
                      tablet: "_1yep5z65g",
                      desktop: "_1yep5z65h"
                    },
                    defaultClass: "_1yep5z65f _1yep5z65g _1yep5z65h"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z65i",
                      tablet: "_1yep5z65j",
                      desktop: "_1yep5z65k"
                    },
                    defaultClass: "_1yep5z65i _1yep5z65j _1yep5z65k"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z65l",
                      tablet: "_1yep5z65m",
                      desktop: "_1yep5z65n"
                    },
                    defaultClass: "_1yep5z65l _1yep5z65m _1yep5z65n"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z65o",
                      tablet: "_1yep5z65p",
                      desktop: "_1yep5z65q"
                    },
                    defaultClass: "_1yep5z65o _1yep5z65p _1yep5z65q"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z65r",
                      tablet: "_1yep5z65s",
                      desktop: "_1yep5z65t"
                    },
                    defaultClass: "_1yep5z65r _1yep5z65s _1yep5z65t"
                  }
                },
                responsiveArray: void 0
              },
              marginInlineEnd: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z65u",
                      tablet: "_1yep5z65v",
                      desktop: "_1yep5z65w"
                    },
                    defaultClass: "_1yep5z65u _1yep5z65v _1yep5z65w"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z65x",
                      tablet: "_1yep5z65y",
                      desktop: "_1yep5z65z"
                    },
                    defaultClass: "_1yep5z65x _1yep5z65y _1yep5z65z"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z660",
                      tablet: "_1yep5z661",
                      desktop: "_1yep5z662"
                    },
                    defaultClass: "_1yep5z660 _1yep5z661 _1yep5z662"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z663",
                      tablet: "_1yep5z664",
                      desktop: "_1yep5z665"
                    },
                    defaultClass: "_1yep5z663 _1yep5z664 _1yep5z665"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z666",
                      tablet: "_1yep5z667",
                      desktop: "_1yep5z668"
                    },
                    defaultClass: "_1yep5z666 _1yep5z667 _1yep5z668"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z669",
                      tablet: "_1yep5z66a",
                      desktop: "_1yep5z66b"
                    },
                    defaultClass: "_1yep5z669 _1yep5z66a _1yep5z66b"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z66c",
                      tablet: "_1yep5z66d",
                      desktop: "_1yep5z66e"
                    },
                    defaultClass: "_1yep5z66c _1yep5z66d _1yep5z66e"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z66f",
                      tablet: "_1yep5z66g",
                      desktop: "_1yep5z66h"
                    },
                    defaultClass: "_1yep5z66f _1yep5z66g _1yep5z66h"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z66i",
                      tablet: "_1yep5z66j",
                      desktop: "_1yep5z66k"
                    },
                    defaultClass: "_1yep5z66i _1yep5z66j _1yep5z66k"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z66l",
                      tablet: "_1yep5z66m",
                      desktop: "_1yep5z66n"
                    },
                    defaultClass: "_1yep5z66l _1yep5z66m _1yep5z66n"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z66o",
                      tablet: "_1yep5z66p",
                      desktop: "_1yep5z66q"
                    },
                    defaultClass: "_1yep5z66o _1yep5z66p _1yep5z66q"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z66r",
                      tablet: "_1yep5z66s",
                      desktop: "_1yep5z66t"
                    },
                    defaultClass: "_1yep5z66r _1yep5z66s _1yep5z66t"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z66u",
                      tablet: "_1yep5z66v",
                      desktop: "_1yep5z66w"
                    },
                    defaultClass: "_1yep5z66u _1yep5z66v _1yep5z66w"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z66x",
                      tablet: "_1yep5z66y",
                      desktop: "_1yep5z66z"
                    },
                    defaultClass: "_1yep5z66x _1yep5z66y _1yep5z66z"
                  }
                },
                responsiveArray: void 0
              },
              marginBlockEnd: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z670",
                      tablet: "_1yep5z671",
                      desktop: "_1yep5z672"
                    },
                    defaultClass: "_1yep5z670 _1yep5z671 _1yep5z672"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z673",
                      tablet: "_1yep5z674",
                      desktop: "_1yep5z675"
                    },
                    defaultClass: "_1yep5z673 _1yep5z674 _1yep5z675"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z676",
                      tablet: "_1yep5z677",
                      desktop: "_1yep5z678"
                    },
                    defaultClass: "_1yep5z676 _1yep5z677 _1yep5z678"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z679",
                      tablet: "_1yep5z67a",
                      desktop: "_1yep5z67b"
                    },
                    defaultClass: "_1yep5z679 _1yep5z67a _1yep5z67b"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z67c",
                      tablet: "_1yep5z67d",
                      desktop: "_1yep5z67e"
                    },
                    defaultClass: "_1yep5z67c _1yep5z67d _1yep5z67e"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z67f",
                      tablet: "_1yep5z67g",
                      desktop: "_1yep5z67h"
                    },
                    defaultClass: "_1yep5z67f _1yep5z67g _1yep5z67h"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z67i",
                      tablet: "_1yep5z67j",
                      desktop: "_1yep5z67k"
                    },
                    defaultClass: "_1yep5z67i _1yep5z67j _1yep5z67k"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z67l",
                      tablet: "_1yep5z67m",
                      desktop: "_1yep5z67n"
                    },
                    defaultClass: "_1yep5z67l _1yep5z67m _1yep5z67n"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z67o",
                      tablet: "_1yep5z67p",
                      desktop: "_1yep5z67q"
                    },
                    defaultClass: "_1yep5z67o _1yep5z67p _1yep5z67q"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z67r",
                      tablet: "_1yep5z67s",
                      desktop: "_1yep5z67t"
                    },
                    defaultClass: "_1yep5z67r _1yep5z67s _1yep5z67t"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z67u",
                      tablet: "_1yep5z67v",
                      desktop: "_1yep5z67w"
                    },
                    defaultClass: "_1yep5z67u _1yep5z67v _1yep5z67w"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z67x",
                      tablet: "_1yep5z67y",
                      desktop: "_1yep5z67z"
                    },
                    defaultClass: "_1yep5z67x _1yep5z67y _1yep5z67z"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z680",
                      tablet: "_1yep5z681",
                      desktop: "_1yep5z682"
                    },
                    defaultClass: "_1yep5z680 _1yep5z681 _1yep5z682"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z683",
                      tablet: "_1yep5z684",
                      desktop: "_1yep5z685"
                    },
                    defaultClass: "_1yep5z683 _1yep5z684 _1yep5z685"
                  }
                },
                responsiveArray: void 0
              },
              marginInlineStart: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z686",
                      tablet: "_1yep5z687",
                      desktop: "_1yep5z688"
                    },
                    defaultClass: "_1yep5z686 _1yep5z687 _1yep5z688"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z689",
                      tablet: "_1yep5z68a",
                      desktop: "_1yep5z68b"
                    },
                    defaultClass: "_1yep5z689 _1yep5z68a _1yep5z68b"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z68c",
                      tablet: "_1yep5z68d",
                      desktop: "_1yep5z68e"
                    },
                    defaultClass: "_1yep5z68c _1yep5z68d _1yep5z68e"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z68f",
                      tablet: "_1yep5z68g",
                      desktop: "_1yep5z68h"
                    },
                    defaultClass: "_1yep5z68f _1yep5z68g _1yep5z68h"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z68i",
                      tablet: "_1yep5z68j",
                      desktop: "_1yep5z68k"
                    },
                    defaultClass: "_1yep5z68i _1yep5z68j _1yep5z68k"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z68l",
                      tablet: "_1yep5z68m",
                      desktop: "_1yep5z68n"
                    },
                    defaultClass: "_1yep5z68l _1yep5z68m _1yep5z68n"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z68o",
                      tablet: "_1yep5z68p",
                      desktop: "_1yep5z68q"
                    },
                    defaultClass: "_1yep5z68o _1yep5z68p _1yep5z68q"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z68r",
                      tablet: "_1yep5z68s",
                      desktop: "_1yep5z68t"
                    },
                    defaultClass: "_1yep5z68r _1yep5z68s _1yep5z68t"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z68u",
                      tablet: "_1yep5z68v",
                      desktop: "_1yep5z68w"
                    },
                    defaultClass: "_1yep5z68u _1yep5z68v _1yep5z68w"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z68x",
                      tablet: "_1yep5z68y",
                      desktop: "_1yep5z68z"
                    },
                    defaultClass: "_1yep5z68x _1yep5z68y _1yep5z68z"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z690",
                      tablet: "_1yep5z691",
                      desktop: "_1yep5z692"
                    },
                    defaultClass: "_1yep5z690 _1yep5z691 _1yep5z692"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z693",
                      tablet: "_1yep5z694",
                      desktop: "_1yep5z695"
                    },
                    defaultClass: "_1yep5z693 _1yep5z694 _1yep5z695"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z696",
                      tablet: "_1yep5z697",
                      desktop: "_1yep5z698"
                    },
                    defaultClass: "_1yep5z696 _1yep5z697 _1yep5z698"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z699",
                      tablet: "_1yep5z69a",
                      desktop: "_1yep5z69b"
                    },
                    defaultClass: "_1yep5z699 _1yep5z69a _1yep5z69b"
                  }
                },
                responsiveArray: void 0
              },
              gap: {
                values: {
                  xs: {
                    conditions: {
                      mobile: "_1yep5z69c",
                      tablet: "_1yep5z69d",
                      desktop: "_1yep5z69e"
                    },
                    defaultClass: "_1yep5z69c _1yep5z69d _1yep5z69e"
                  },
                  sm: {
                    conditions: {
                      mobile: "_1yep5z69f",
                      tablet: "_1yep5z69g",
                      desktop: "_1yep5z69h"
                    },
                    defaultClass: "_1yep5z69f _1yep5z69g _1yep5z69h"
                  },
                  md: {
                    conditions: {
                      mobile: "_1yep5z69i",
                      tablet: "_1yep5z69j",
                      desktop: "_1yep5z69k"
                    },
                    defaultClass: "_1yep5z69i _1yep5z69j _1yep5z69k"
                  },
                  lg: {
                    conditions: {
                      mobile: "_1yep5z69l",
                      tablet: "_1yep5z69m",
                      desktop: "_1yep5z69n"
                    },
                    defaultClass: "_1yep5z69l _1yep5z69m _1yep5z69n"
                  },
                  xl: {
                    conditions: {
                      mobile: "_1yep5z69o",
                      tablet: "_1yep5z69p",
                      desktop: "_1yep5z69q"
                    },
                    defaultClass: "_1yep5z69o _1yep5z69p _1yep5z69q"
                  },
                  "2xl": {
                    conditions: {
                      mobile: "_1yep5z69r",
                      tablet: "_1yep5z69s",
                      desktop: "_1yep5z69t"
                    },
                    defaultClass: "_1yep5z69r _1yep5z69s _1yep5z69t"
                  },
                  "3xl": {
                    conditions: {
                      mobile: "_1yep5z69u",
                      tablet: "_1yep5z69v",
                      desktop: "_1yep5z69w"
                    },
                    defaultClass: "_1yep5z69u _1yep5z69v _1yep5z69w"
                  },
                  "4xl": {
                    conditions: {
                      mobile: "_1yep5z69x",
                      tablet: "_1yep5z69y",
                      desktop: "_1yep5z69z"
                    },
                    defaultClass: "_1yep5z69x _1yep5z69y _1yep5z69z"
                  },
                  "5xl": {
                    conditions: {
                      mobile: "_1yep5z6a0",
                      tablet: "_1yep5z6a1",
                      desktop: "_1yep5z6a2"
                    },
                    defaultClass: "_1yep5z6a0 _1yep5z6a1 _1yep5z6a2"
                  },
                  "6xl": {
                    conditions: {
                      mobile: "_1yep5z6a3",
                      tablet: "_1yep5z6a4",
                      desktop: "_1yep5z6a5"
                    },
                    defaultClass: "_1yep5z6a3 _1yep5z6a4 _1yep5z6a5"
                  },
                  "7xl": {
                    conditions: {
                      mobile: "_1yep5z6a6",
                      tablet: "_1yep5z6a7",
                      desktop: "_1yep5z6a8"
                    },
                    defaultClass: "_1yep5z6a6 _1yep5z6a7 _1yep5z6a8"
                  },
                  "8xl": {
                    conditions: {
                      mobile: "_1yep5z6a9",
                      tablet: "_1yep5z6aa",
                      desktop: "_1yep5z6ab"
                    },
                    defaultClass: "_1yep5z6a9 _1yep5z6aa _1yep5z6ab"
                  },
                  "9xl": {
                    conditions: {
                      mobile: "_1yep5z6ac",
                      tablet: "_1yep5z6ad",
                      desktop: "_1yep5z6ae"
                    },
                    defaultClass: "_1yep5z6ac _1yep5z6ad _1yep5z6ae"
                  },
                  none: {
                    conditions: {
                      mobile: "_1yep5z6af",
                      tablet: "_1yep5z6ag",
                      desktop: "_1yep5z6ah"
                    },
                    defaultClass: "_1yep5z6af _1yep5z6ag _1yep5z6ah"
                  }
                },
                responsiveArray: void 0
              }
            }
          }).styles.paddingBlockStart.responsiveArray = l.conditions.responsiveArray, l.styles.paddingInlineEnd.responsiveArray = l.conditions.responsiveArray, l.styles.paddingBlockEnd.responsiveArray = l.conditions.responsiveArray, l.styles.paddingInlineStart.responsiveArray = l.conditions.responsiveArray, l.styles.marginBlockStart.responsiveArray = l.conditions.responsiveArray, l.styles.marginInlineEnd.responsiveArray = l.conditions.responsiveArray, l.styles.marginBlockEnd.responsiveArray = l.conditions.responsiveArray, l.styles.marginInlineStart.responsiveArray = l.conditions.responsiveArray, l.styles.gap.responsiveArray = l.conditions.responsiveArray, l), function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                borderRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius", "borderEndStartRadius", "borderEndEndRadius"]
                },
                borderTopRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius"]
                },
                borderBottomRadius: {
                  mappings: ["borderEndStartRadius", "borderEndEndRadius"]
                },
                borderLeftRadius: {
                  mappings: ["borderStartStartRadius", "borderEndStartRadius"]
                },
                borderRightRadius: {
                  mappings: ["borderStartEndRadius", "borderEndEndRadius"]
                },
                borderStartStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6ai",
                        tablet: "_1yep5z6aj",
                        desktop: "_1yep5z6ak"
                      },
                      defaultClass: "_1yep5z6ai _1yep5z6aj _1yep5z6ak"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6al",
                        tablet: "_1yep5z6am",
                        desktop: "_1yep5z6an"
                      },
                      defaultClass: "_1yep5z6al _1yep5z6am _1yep5z6an"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6ao",
                        tablet: "_1yep5z6ap",
                        desktop: "_1yep5z6aq"
                      },
                      defaultClass: "_1yep5z6ao _1yep5z6ap _1yep5z6aq"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6ar",
                        tablet: "_1yep5z6as",
                        desktop: "_1yep5z6at"
                      },
                      defaultClass: "_1yep5z6ar _1yep5z6as _1yep5z6at"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6au",
                        tablet: "_1yep5z6av",
                        desktop: "_1yep5z6aw"
                      },
                      defaultClass: "_1yep5z6au _1yep5z6av _1yep5z6aw"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6ax",
                        tablet: "_1yep5z6ay",
                        desktop: "_1yep5z6az"
                      },
                      defaultClass: "_1yep5z6ax _1yep5z6ay _1yep5z6az"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6b0",
                        tablet: "_1yep5z6b1",
                        desktop: "_1yep5z6b2"
                      },
                      defaultClass: "_1yep5z6b0 _1yep5z6b1 _1yep5z6b2"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6b3",
                        tablet: "_1yep5z6b4",
                        desktop: "_1yep5z6b5"
                      },
                      defaultClass: "_1yep5z6b3 _1yep5z6b4 _1yep5z6b5"
                    }
                  },
                  responsiveArray: void 0
                },
                borderStartEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6b6",
                        tablet: "_1yep5z6b7",
                        desktop: "_1yep5z6b8"
                      },
                      defaultClass: "_1yep5z6b6 _1yep5z6b7 _1yep5z6b8"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6b9",
                        tablet: "_1yep5z6ba",
                        desktop: "_1yep5z6bb"
                      },
                      defaultClass: "_1yep5z6b9 _1yep5z6ba _1yep5z6bb"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6bc",
                        tablet: "_1yep5z6bd",
                        desktop: "_1yep5z6be"
                      },
                      defaultClass: "_1yep5z6bc _1yep5z6bd _1yep5z6be"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6bf",
                        tablet: "_1yep5z6bg",
                        desktop: "_1yep5z6bh"
                      },
                      defaultClass: "_1yep5z6bf _1yep5z6bg _1yep5z6bh"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6bi",
                        tablet: "_1yep5z6bj",
                        desktop: "_1yep5z6bk"
                      },
                      defaultClass: "_1yep5z6bi _1yep5z6bj _1yep5z6bk"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6bl",
                        tablet: "_1yep5z6bm",
                        desktop: "_1yep5z6bn"
                      },
                      defaultClass: "_1yep5z6bl _1yep5z6bm _1yep5z6bn"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6bo",
                        tablet: "_1yep5z6bp",
                        desktop: "_1yep5z6bq"
                      },
                      defaultClass: "_1yep5z6bo _1yep5z6bp _1yep5z6bq"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6br",
                        tablet: "_1yep5z6bs",
                        desktop: "_1yep5z6bt"
                      },
                      defaultClass: "_1yep5z6br _1yep5z6bs _1yep5z6bt"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6bu",
                        tablet: "_1yep5z6bv",
                        desktop: "_1yep5z6bw"
                      },
                      defaultClass: "_1yep5z6bu _1yep5z6bv _1yep5z6bw"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6bx",
                        tablet: "_1yep5z6by",
                        desktop: "_1yep5z6bz"
                      },
                      defaultClass: "_1yep5z6bx _1yep5z6by _1yep5z6bz"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6c0",
                        tablet: "_1yep5z6c1",
                        desktop: "_1yep5z6c2"
                      },
                      defaultClass: "_1yep5z6c0 _1yep5z6c1 _1yep5z6c2"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6c3",
                        tablet: "_1yep5z6c4",
                        desktop: "_1yep5z6c5"
                      },
                      defaultClass: "_1yep5z6c3 _1yep5z6c4 _1yep5z6c5"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6c6",
                        tablet: "_1yep5z6c7",
                        desktop: "_1yep5z6c8"
                      },
                      defaultClass: "_1yep5z6c6 _1yep5z6c7 _1yep5z6c8"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6c9",
                        tablet: "_1yep5z6ca",
                        desktop: "_1yep5z6cb"
                      },
                      defaultClass: "_1yep5z6c9 _1yep5z6ca _1yep5z6cb"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6cc",
                        tablet: "_1yep5z6cd",
                        desktop: "_1yep5z6ce"
                      },
                      defaultClass: "_1yep5z6cc _1yep5z6cd _1yep5z6ce"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6cf",
                        tablet: "_1yep5z6cg",
                        desktop: "_1yep5z6ch"
                      },
                      defaultClass: "_1yep5z6cf _1yep5z6cg _1yep5z6ch"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6ci",
                        tablet: "_1yep5z6cj",
                        desktop: "_1yep5z6ck"
                      },
                      defaultClass: "_1yep5z6ci _1yep5z6cj _1yep5z6ck"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6cl",
                        tablet: "_1yep5z6cm",
                        desktop: "_1yep5z6cn"
                      },
                      defaultClass: "_1yep5z6cl _1yep5z6cm _1yep5z6cn"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6co",
                        tablet: "_1yep5z6cp",
                        desktop: "_1yep5z6cq"
                      },
                      defaultClass: "_1yep5z6co _1yep5z6cp _1yep5z6cq"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6cr",
                        tablet: "_1yep5z6cs",
                        desktop: "_1yep5z6ct"
                      },
                      defaultClass: "_1yep5z6cr _1yep5z6cs _1yep5z6ct"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6cu",
                        tablet: "_1yep5z6cv",
                        desktop: "_1yep5z6cw"
                      },
                      defaultClass: "_1yep5z6cu _1yep5z6cv _1yep5z6cw"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6cx",
                        tablet: "_1yep5z6cy",
                        desktop: "_1yep5z6cz"
                      },
                      defaultClass: "_1yep5z6cx _1yep5z6cy _1yep5z6cz"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6d0",
                        tablet: "_1yep5z6d1",
                        desktop: "_1yep5z6d2"
                      },
                      defaultClass: "_1yep5z6d0 _1yep5z6d1 _1yep5z6d2"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6d3",
                        tablet: "_1yep5z6d4",
                        desktop: "_1yep5z6d5"
                      },
                      defaultClass: "_1yep5z6d3 _1yep5z6d4 _1yep5z6d5"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.borderStartStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderStartEndRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndEndRadius.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              boxShadow: {
                values: {
                  low: {
                    defaultClass: "_1yep5z6d6"
                  },
                  medium: {
                    defaultClass: "_1yep5z6d7"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              opacity: {
                values: {
                  none: {
                    defaultClass: "_1yep5z6d8"
                  },
                  low: {
                    defaultClass: "_1yep5z6d9"
                  },
                  medium: {
                    defaultClass: "_1yep5z6da"
                  },
                  high: {
                    defaultClass: "_1yep5z6db"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              typography: {
                values: {
                  "heading.h6.regular": {
                    defaultClass: "_1yep5z6dc"
                  },
                  "heading.h6.medium": {
                    defaultClass: "_1yep5z6dd"
                  },
                  "heading.h6.semibold": {
                    defaultClass: "_1yep5z6de"
                  },
                  "heading.h5.regular": {
                    defaultClass: "_1yep5z6df"
                  },
                  "heading.h5.medium": {
                    defaultClass: "_1yep5z6dg"
                  },
                  "heading.h5.semibold": {
                    defaultClass: "_1yep5z6dh"
                  },
                  "heading.h4.regular": {
                    defaultClass: "_1yep5z6di"
                  },
                  "heading.h4.medium": {
                    defaultClass: "_1yep5z6dj"
                  },
                  "heading.h4.semibold": {
                    defaultClass: "_1yep5z6dk"
                  },
                  "heading.h3.regular": {
                    defaultClass: "_1yep5z6dl"
                  },
                  "heading.h3.medium": {
                    defaultClass: "_1yep5z6dm"
                  },
                  "heading.h3.semibold": {
                    defaultClass: "_1yep5z6dn"
                  },
                  "heading.h2.regular": {
                    defaultClass: "_1yep5z6do"
                  },
                  "heading.h2.medium": {
                    defaultClass: "_1yep5z6dp"
                  },
                  "heading.h2.semibold": {
                    defaultClass: "_1yep5z6dq"
                  },
                  "heading.h1.regular": {
                    defaultClass: "_1yep5z6dr"
                  },
                  "heading.h1.medium": {
                    defaultClass: "_1yep5z6ds"
                  },
                  "heading.h1.semibold": {
                    defaultClass: "_1yep5z6dt"
                  },
                  "label.sm.regular": {
                    defaultClass: "_1yep5z6du"
                  },
                  "label.sm.medium": {
                    defaultClass: "_1yep5z6dv"
                  },
                  "label.sm.semibold": {
                    defaultClass: "_1yep5z6dw"
                  },
                  "label.md.regular": {
                    defaultClass: "_1yep5z6dx"
                  },
                  "label.md.medium": {
                    defaultClass: "_1yep5z6dy"
                  },
                  "label.md.semibold": {
                    defaultClass: "_1yep5z6dz"
                  },
                  "label.lg.regular": {
                    defaultClass: "_1yep5z6e0"
                  },
                  "label.lg.medium": {
                    defaultClass: "_1yep5z6e1"
                  },
                  "label.lg.semibold": {
                    defaultClass: "_1yep5z6e2"
                  },
                  "body.sm.regular": {
                    defaultClass: "_1yep5z6e3"
                  },
                  "body.sm.medium": {
                    defaultClass: "_1yep5z6e4"
                  },
                  "body.sm.semibold": {
                    defaultClass: "_1yep5z6e5"
                  },
                  "body.md.regular": {
                    defaultClass: "_1yep5z6e6"
                  },
                  "body.md.medium": {
                    defaultClass: "_1yep5z6e7"
                  },
                  "body.md.semibold": {
                    defaultClass: "_1yep5z6e8"
                  },
                  "body.lg.regular": {
                    defaultClass: "_1yep5z6e9"
                  },
                  "body.lg.medium": {
                    defaultClass: "_1yep5z6ea"
                  },
                  "body.lg.semibold": {
                    defaultClass: "_1yep5z6eb"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              color: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6ec"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6ed"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6ee"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z6ef"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z6eg"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z6eh"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z6ei"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z6ej"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z6ek"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z6el"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z6em"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z6en"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z6eo"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z6ep"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z6eq"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6er"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6es"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6et"
                  },
                  "text.primary": {
                    defaultClass: "_1yep5z6eu"
                  },
                  "text.secondary": {
                    defaultClass: "_1yep5z6ev"
                  },
                  "text.helper": {
                    defaultClass: "_1yep5z6ew"
                  },
                  "text.placeholder": {
                    defaultClass: "_1yep5z6ex"
                  },
                  "text.disabled": {
                    defaultClass: "_1yep5z6ey"
                  },
                  "text.inverse": {
                    defaultClass: "_1yep5z6ez"
                  },
                  "icon.primary": {
                    defaultClass: "_1yep5z6f0"
                  },
                  "icon.secondary": {
                    defaultClass: "_1yep5z6f1"
                  },
                  "icon.disabled": {
                    defaultClass: "_1yep5z6f2"
                  },
                  "icon.inverse": {
                    defaultClass: "_1yep5z6f3"
                  },
                  "icon.interactive": {
                    defaultClass: "_1yep5z6f4"
                  },
                  "interactive.primary": {
                    defaultClass: "_1yep5z6f5"
                  },
                  "interactive.hovered": {
                    defaultClass: "_1yep5z6f6"
                  },
                  "interactive.active": {
                    defaultClass: "_1yep5z6f7"
                  },
                  "interactive.visited": {
                    defaultClass: "_1yep5z6f8"
                  },
                  "interactive.disabled": {
                    defaultClass: "_1yep5z6f9"
                  }
                }
              },
              backgroundColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6fa"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6fb"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6fc"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z6fd"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z6fe"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z6ff"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z6fg"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z6fh"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z6fi"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z6fj"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z6fk"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z6fl"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z6fm"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z6fn"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z6fo"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6fp"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6fq"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6fr"
                  },
                  "background.primary.subtle": {
                    defaultClass: "_1yep5z6fs"
                  },
                  "background.primary.medium": {
                    defaultClass: "_1yep5z6ft"
                  },
                  "background.primary.strong": {
                    defaultClass: "_1yep5z6fu"
                  },
                  "background.secondary.subtle": {
                    defaultClass: "_1yep5z6fv"
                  },
                  "background.secondary.medium": {
                    defaultClass: "_1yep5z6fw"
                  },
                  "background.secondary.strong": {
                    defaultClass: "_1yep5z6fx"
                  },
                  "background.inverse.subtle": {
                    defaultClass: "_1yep5z6fy"
                  },
                  "background.inverse.medium": {
                    defaultClass: "_1yep5z6fz"
                  },
                  "background.inverse.strong": {
                    defaultClass: "_1yep5z6g0"
                  },
                  "background.overlay.subtle": {
                    defaultClass: "_1yep5z6g1"
                  },
                  "background.overlay.medium": {
                    defaultClass: "_1yep5z6g2"
                  },
                  "positive.subtle": {
                    defaultClass: "_1yep5z6g3"
                  },
                  "positive.medium": {
                    defaultClass: "_1yep5z6g4"
                  },
                  "positive.strong": {
                    defaultClass: "_1yep5z6g5"
                  },
                  "positive.interactive": {
                    defaultClass: "_1yep5z6g6"
                  }
                }
              },
              borderColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6g7"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6g8"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6g9"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z6ga"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z6gb"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z6gc"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z6gd"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z6ge"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z6gf"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z6gg"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z6gh"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z6gi"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z6gj"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z6gk"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z6gl"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6gm"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6gn"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6go"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z6gp"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z6gq"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z6gr"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z6gs"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z6gt"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z6gu"
                  },
                  transparent: {
                    defaultClass: "_1yep5z6gv"
                  }
                }
              },
              outlineColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6gw"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6gx"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6gy"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z6gz"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z6h0"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z6h1"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z6h2"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z6h3"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z6h4"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z6h5"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z6h6"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z6h7"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z6h8"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z6h9"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z6ha"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6hb"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6hc"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6hd"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z6he"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z6hf"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z6hg"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z6hh"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z6hi"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z6hj"
                  },
                  transparent: {
                    defaultClass: "_1yep5z6hk"
                  }
                }
              }
            }
          }, function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                position: {
                  values: {
                    relative: {
                      conditions: {
                        mobile: "_1yep5z6hl",
                        tablet: "_1yep5z6hm",
                        desktop: "_1yep5z6hn"
                      },
                      defaultClass: "_1yep5z6hl _1yep5z6hm _1yep5z6hn"
                    },
                    absolute: {
                      conditions: {
                        mobile: "_1yep5z6ho",
                        tablet: "_1yep5z6hp",
                        desktop: "_1yep5z6hq"
                      },
                      defaultClass: "_1yep5z6ho _1yep5z6hp _1yep5z6hq"
                    },
                    fixed: {
                      conditions: {
                        mobile: "_1yep5z6hr",
                        tablet: "_1yep5z6hs",
                        desktop: "_1yep5z6ht"
                      },
                      defaultClass: "_1yep5z6hr _1yep5z6hs _1yep5z6ht"
                    }
                  },
                  responsiveArray: void 0
                },
                display: {
                  values: {
                    none: {
                      conditions: {
                        mobile: "_1yep5z6hu",
                        tablet: "_1yep5z6hv",
                        desktop: "_1yep5z6hw"
                      },
                      defaultClass: "_1yep5z6hu _1yep5z6hv _1yep5z6hw"
                    },
                    block: {
                      conditions: {
                        mobile: "_1yep5z6hx",
                        tablet: "_1yep5z6hy",
                        desktop: "_1yep5z6hz"
                      },
                      defaultClass: "_1yep5z6hx _1yep5z6hy _1yep5z6hz"
                    },
                    flex: {
                      conditions: {
                        mobile: "_1yep5z6i0",
                        tablet: "_1yep5z6i1",
                        desktop: "_1yep5z6i2"
                      },
                      defaultClass: "_1yep5z6i0 _1yep5z6i1 _1yep5z6i2"
                    },
                    "inline-flex": {
                      conditions: {
                        mobile: "_1yep5z6i3",
                        tablet: "_1yep5z6i4",
                        desktop: "_1yep5z6i5"
                      },
                      defaultClass: "_1yep5z6i3 _1yep5z6i4 _1yep5z6i5"
                    },
                    grid: {
                      conditions: {
                        mobile: "_1yep5z6i6",
                        tablet: "_1yep5z6i7",
                        desktop: "_1yep5z6i8"
                      },
                      defaultClass: "_1yep5z6i6 _1yep5z6i7 _1yep5z6i8"
                    }
                  },
                  responsiveArray: void 0
                },
                flexDirection: {
                  values: {
                    row: {
                      conditions: {
                        mobile: "_1yep5z6i9",
                        tablet: "_1yep5z6ia",
                        desktop: "_1yep5z6ib"
                      },
                      defaultClass: "_1yep5z6i9 _1yep5z6ia _1yep5z6ib"
                    },
                    column: {
                      conditions: {
                        mobile: "_1yep5z6ic",
                        tablet: "_1yep5z6id",
                        desktop: "_1yep5z6ie"
                      },
                      defaultClass: "_1yep5z6ic _1yep5z6id _1yep5z6ie"
                    },
                    "row-reverse": {
                      conditions: {
                        mobile: "_1yep5z6if",
                        tablet: "_1yep5z6ig",
                        desktop: "_1yep5z6ih"
                      },
                      defaultClass: "_1yep5z6if _1yep5z6ig _1yep5z6ih"
                    },
                    "column-reverse": {
                      conditions: {
                        mobile: "_1yep5z6ii",
                        tablet: "_1yep5z6ij",
                        desktop: "_1yep5z6ik"
                      },
                      defaultClass: "_1yep5z6ii _1yep5z6ij _1yep5z6ik"
                    }
                  },
                  responsiveArray: void 0
                },
                alignItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6il",
                        tablet: "_1yep5z6im",
                        desktop: "_1yep5z6in"
                      },
                      defaultClass: "_1yep5z6il _1yep5z6im _1yep5z6in"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6io",
                        tablet: "_1yep5z6ip",
                        desktop: "_1yep5z6iq"
                      },
                      defaultClass: "_1yep5z6io _1yep5z6ip _1yep5z6iq"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6ir",
                        tablet: "_1yep5z6is",
                        desktop: "_1yep5z6it"
                      },
                      defaultClass: "_1yep5z6ir _1yep5z6is _1yep5z6it"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6iu",
                        tablet: "_1yep5z6iv",
                        desktop: "_1yep5z6iw"
                      },
                      defaultClass: "_1yep5z6iu _1yep5z6iv _1yep5z6iw"
                    }
                  },
                  responsiveArray: void 0
                },
                alignSelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6ix",
                        tablet: "_1yep5z6iy",
                        desktop: "_1yep5z6iz"
                      },
                      defaultClass: "_1yep5z6ix _1yep5z6iy _1yep5z6iz"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6j0",
                        tablet: "_1yep5z6j1",
                        desktop: "_1yep5z6j2"
                      },
                      defaultClass: "_1yep5z6j0 _1yep5z6j1 _1yep5z6j2"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6j3",
                        tablet: "_1yep5z6j4",
                        desktop: "_1yep5z6j5"
                      },
                      defaultClass: "_1yep5z6j3 _1yep5z6j4 _1yep5z6j5"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6j6",
                        tablet: "_1yep5z6j7",
                        desktop: "_1yep5z6j8"
                      },
                      defaultClass: "_1yep5z6j6 _1yep5z6j7 _1yep5z6j8"
                    }
                  },
                  responsiveArray: void 0
                },
                flex: {
                  values: {
                    0: {
                      conditions: {
                        mobile: "_1yep5z6j9",
                        tablet: "_1yep5z6ja",
                        desktop: "_1yep5z6jb"
                      },
                      defaultClass: "_1yep5z6j9 _1yep5z6ja _1yep5z6jb"
                    },
                    1: {
                      conditions: {
                        mobile: "_1yep5z6jc",
                        tablet: "_1yep5z6jd",
                        desktop: "_1yep5z6je"
                      },
                      defaultClass: "_1yep5z6jc _1yep5z6jd _1yep5z6je"
                    }
                  },
                  responsiveArray: void 0
                },
                justifyContent: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6jf",
                        tablet: "_1yep5z6jg",
                        desktop: "_1yep5z6jh"
                      },
                      defaultClass: "_1yep5z6jf _1yep5z6jg _1yep5z6jh"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6ji",
                        tablet: "_1yep5z6jj",
                        desktop: "_1yep5z6jk"
                      },
                      defaultClass: "_1yep5z6ji _1yep5z6jj _1yep5z6jk"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6jl",
                        tablet: "_1yep5z6jm",
                        desktop: "_1yep5z6jn"
                      },
                      defaultClass: "_1yep5z6jl _1yep5z6jm _1yep5z6jn"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6jo",
                        tablet: "_1yep5z6jp",
                        desktop: "_1yep5z6jq"
                      },
                      defaultClass: "_1yep5z6jo _1yep5z6jp _1yep5z6jq"
                    },
                    "space-between": {
                      conditions: {
                        mobile: "_1yep5z6jr",
                        tablet: "_1yep5z6js",
                        desktop: "_1yep5z6jt"
                      },
                      defaultClass: "_1yep5z6jr _1yep5z6js _1yep5z6jt"
                    }
                  },
                  responsiveArray: void 0
                },
                justifySelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6ju",
                        tablet: "_1yep5z6jv",
                        desktop: "_1yep5z6jw"
                      },
                      defaultClass: "_1yep5z6ju _1yep5z6jv _1yep5z6jw"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6jx",
                        tablet: "_1yep5z6jy",
                        desktop: "_1yep5z6jz"
                      },
                      defaultClass: "_1yep5z6jx _1yep5z6jy _1yep5z6jz"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6k0",
                        tablet: "_1yep5z6k1",
                        desktop: "_1yep5z6k2"
                      },
                      defaultClass: "_1yep5z6k0 _1yep5z6k1 _1yep5z6k2"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6k3",
                        tablet: "_1yep5z6k4",
                        desktop: "_1yep5z6k5"
                      },
                      defaultClass: "_1yep5z6k3 _1yep5z6k4 _1yep5z6k5"
                    }
                  },
                  responsiveArray: void 0
                },
                placeItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6k6",
                        tablet: "_1yep5z6k7",
                        desktop: "_1yep5z6k8"
                      },
                      defaultClass: "_1yep5z6k6 _1yep5z6k7 _1yep5z6k8"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6k9",
                        tablet: "_1yep5z6ka",
                        desktop: "_1yep5z6kb"
                      },
                      defaultClass: "_1yep5z6k9 _1yep5z6ka _1yep5z6kb"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6kc",
                        tablet: "_1yep5z6kd",
                        desktop: "_1yep5z6ke"
                      },
                      defaultClass: "_1yep5z6kc _1yep5z6kd _1yep5z6ke"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6kf",
                        tablet: "_1yep5z6kg",
                        desktop: "_1yep5z6kh"
                      },
                      defaultClass: "_1yep5z6kf _1yep5z6kg _1yep5z6kh"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.position.responsiveArray = e.conditions.responsiveArray, e.styles.display.responsiveArray = e.conditions.responsiveArray, e.styles.flexDirection.responsiveArray = e.conditions.responsiveArray, e.styles.alignItems.responsiveArray = e.conditions.responsiveArray, e.styles.alignSelf.responsiveArray = e.conditions.responsiveArray, e.styles.flex.responsiveArray = e.conditions.responsiveArray, e.styles.justifyContent.responsiveArray = e.conditions.responsiveArray, e.styles.justifySelf.responsiveArray = e.conditions.responsiveArray, e.styles.placeItems.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              transition: {
                values: {
                  "transition.medium": {
                    defaultClass: "_1yep5z6ki"
                  }
                }
              },
              transitionProperty: {
                values: {
                  transform: {
                    defaultClass: "_1yep5z6kj"
                  },
                  opacity: {
                    defaultClass: "_1yep5z6kk"
                  },
                  "background-color": {
                    defaultClass: "_1yep5z6kl"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              inset: {
                mappings: ["insetBlockStart", "insetBlockEnd", "insetInlineEnd", "insetInlineStart"]
              },
              flexWrap: {
                values: {
                  wrap: {
                    defaultClass: "_1yep5z6km"
                  },
                  nowrap: {
                    defaultClass: "_1yep5z6kn"
                  }
                }
              },
              insetBlockStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6ko"
                  }
                }
              },
              insetBlockEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6kp"
                  }
                }
              },
              insetInlineStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6kq"
                  }
                }
              },
              insetInlineEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6kr"
                  }
                }
              },
              flexShrink: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6ks"
                  }
                }
              },
              flexGrow: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6kt"
                  },
                  1: {
                    defaultClass: "_1yep5z6ku"
                  }
                }
              },
              width: {
                values: {
                  full: {
                    defaultClass: "_1yep5z6kv"
                  }
                }
              },
              height: {
                values: {
                  full: {
                    defaultClass: "_1yep5z6kw"
                  }
                }
              },
              cursor: {
                values: {
                  pointer: {
                    defaultClass: "_1yep5z6kx"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              outline: {
                values: {
                  none: {
                    defaultClass: "_1yep5z6ky"
                  }
                }
              },
              outlineStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z6kz"
                  }
                }
              },
              outlineWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z6l0"
                  },
                  2: {
                    defaultClass: "_1yep5z6l1"
                  }
                }
              },
              outlineOffset: {
                values: {
                  1: {
                    defaultClass: "_1yep5z6l4"
                  },
                  2: {
                    defaultClass: "_1yep5z6l5"
                  },
                  "-2": {
                    defaultClass: "_1yep5z6l2"
                  },
                  "-1": {
                    defaultClass: "_1yep5z6l3"
                  }
                }
              },
              border: {
                values: {
                  none: {
                    defaultClass: "_1yep5z6l6"
                  }
                }
              },
              borderStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z6l7"
                  },
                  dashed: {
                    defaultClass: "_1yep5z6l8"
                  }
                }
              },
              borderWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z6l9"
                  },
                  2: {
                    defaultClass: "_1yep5z6la"
                  }
                }
              }
            }
          }),
          h = d(function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                paddingLeft: {
                  mappings: ["paddingInlineStart"]
                },
                paddingRight: {
                  mappings: ["paddingInlineEnd"]
                },
                paddingTop: {
                  mappings: ["paddingBlockStart"]
                },
                paddingBottom: {
                  mappings: ["paddingBlockEnd"]
                },
                padding: {
                  mappings: ["paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd"]
                },
                paddingX: {
                  mappings: ["paddingInlineStart", "paddingInlineEnd"]
                },
                paddingY: {
                  mappings: ["paddingBlockStart", "paddingBlockEnd"]
                },
                marginLeft: {
                  mappings: ["marginInlineStart"]
                },
                marginRight: {
                  mappings: ["marginInlineEnd"]
                },
                marginTop: {
                  mappings: ["marginBlockStart"]
                },
                marginBottom: {
                  mappings: ["marginBlockEnd"]
                },
                margin: {
                  mappings: ["marginBlockStart", "marginBlockEnd", "marginInlineStart", "marginInlineEnd"]
                },
                marginX: {
                  mappings: ["marginInlineStart", "marginInlineEnd"]
                },
                marginY: {
                  mappings: ["marginBlockStart", "marginBlockEnd"]
                },
                paddingBlockStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z616m",
                        tablet: "_1yep5z616n",
                        desktop: "_1yep5z616o"
                      },
                      defaultClass: "_1yep5z616m _1yep5z616n _1yep5z616o"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z616p",
                        tablet: "_1yep5z616q",
                        desktop: "_1yep5z616r"
                      },
                      defaultClass: "_1yep5z616p _1yep5z616q _1yep5z616r"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z616s",
                        tablet: "_1yep5z616t",
                        desktop: "_1yep5z616u"
                      },
                      defaultClass: "_1yep5z616s _1yep5z616t _1yep5z616u"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z616v",
                        tablet: "_1yep5z616w",
                        desktop: "_1yep5z616x"
                      },
                      defaultClass: "_1yep5z616v _1yep5z616w _1yep5z616x"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z616y",
                        tablet: "_1yep5z616z",
                        desktop: "_1yep5z6170"
                      },
                      defaultClass: "_1yep5z616y _1yep5z616z _1yep5z6170"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6171",
                        tablet: "_1yep5z6172",
                        desktop: "_1yep5z6173"
                      },
                      defaultClass: "_1yep5z6171 _1yep5z6172 _1yep5z6173"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6174",
                        tablet: "_1yep5z6175",
                        desktop: "_1yep5z6176"
                      },
                      defaultClass: "_1yep5z6174 _1yep5z6175 _1yep5z6176"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6177",
                        tablet: "_1yep5z6178",
                        desktop: "_1yep5z6179"
                      },
                      defaultClass: "_1yep5z6177 _1yep5z6178 _1yep5z6179"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z617a",
                        tablet: "_1yep5z617b",
                        desktop: "_1yep5z617c"
                      },
                      defaultClass: "_1yep5z617a _1yep5z617b _1yep5z617c"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z617d",
                        tablet: "_1yep5z617e",
                        desktop: "_1yep5z617f"
                      },
                      defaultClass: "_1yep5z617d _1yep5z617e _1yep5z617f"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z617g",
                        tablet: "_1yep5z617h",
                        desktop: "_1yep5z617i"
                      },
                      defaultClass: "_1yep5z617g _1yep5z617h _1yep5z617i"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z617j",
                        tablet: "_1yep5z617k",
                        desktop: "_1yep5z617l"
                      },
                      defaultClass: "_1yep5z617j _1yep5z617k _1yep5z617l"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z617m",
                        tablet: "_1yep5z617n",
                        desktop: "_1yep5z617o"
                      },
                      defaultClass: "_1yep5z617m _1yep5z617n _1yep5z617o"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z617p",
                        tablet: "_1yep5z617q",
                        desktop: "_1yep5z617r"
                      },
                      defaultClass: "_1yep5z617p _1yep5z617q _1yep5z617r"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingInlineEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z617s",
                        tablet: "_1yep5z617t",
                        desktop: "_1yep5z617u"
                      },
                      defaultClass: "_1yep5z617s _1yep5z617t _1yep5z617u"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z617v",
                        tablet: "_1yep5z617w",
                        desktop: "_1yep5z617x"
                      },
                      defaultClass: "_1yep5z617v _1yep5z617w _1yep5z617x"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z617y",
                        tablet: "_1yep5z617z",
                        desktop: "_1yep5z6180"
                      },
                      defaultClass: "_1yep5z617y _1yep5z617z _1yep5z6180"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6181",
                        tablet: "_1yep5z6182",
                        desktop: "_1yep5z6183"
                      },
                      defaultClass: "_1yep5z6181 _1yep5z6182 _1yep5z6183"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6184",
                        tablet: "_1yep5z6185",
                        desktop: "_1yep5z6186"
                      },
                      defaultClass: "_1yep5z6184 _1yep5z6185 _1yep5z6186"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6187",
                        tablet: "_1yep5z6188",
                        desktop: "_1yep5z6189"
                      },
                      defaultClass: "_1yep5z6187 _1yep5z6188 _1yep5z6189"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z618a",
                        tablet: "_1yep5z618b",
                        desktop: "_1yep5z618c"
                      },
                      defaultClass: "_1yep5z618a _1yep5z618b _1yep5z618c"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z618d",
                        tablet: "_1yep5z618e",
                        desktop: "_1yep5z618f"
                      },
                      defaultClass: "_1yep5z618d _1yep5z618e _1yep5z618f"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z618g",
                        tablet: "_1yep5z618h",
                        desktop: "_1yep5z618i"
                      },
                      defaultClass: "_1yep5z618g _1yep5z618h _1yep5z618i"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z618j",
                        tablet: "_1yep5z618k",
                        desktop: "_1yep5z618l"
                      },
                      defaultClass: "_1yep5z618j _1yep5z618k _1yep5z618l"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z618m",
                        tablet: "_1yep5z618n",
                        desktop: "_1yep5z618o"
                      },
                      defaultClass: "_1yep5z618m _1yep5z618n _1yep5z618o"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z618p",
                        tablet: "_1yep5z618q",
                        desktop: "_1yep5z618r"
                      },
                      defaultClass: "_1yep5z618p _1yep5z618q _1yep5z618r"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z618s",
                        tablet: "_1yep5z618t",
                        desktop: "_1yep5z618u"
                      },
                      defaultClass: "_1yep5z618s _1yep5z618t _1yep5z618u"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z618v",
                        tablet: "_1yep5z618w",
                        desktop: "_1yep5z618x"
                      },
                      defaultClass: "_1yep5z618v _1yep5z618w _1yep5z618x"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingBlockEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z618y",
                        tablet: "_1yep5z618z",
                        desktop: "_1yep5z6190"
                      },
                      defaultClass: "_1yep5z618y _1yep5z618z _1yep5z6190"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6191",
                        tablet: "_1yep5z6192",
                        desktop: "_1yep5z6193"
                      },
                      defaultClass: "_1yep5z6191 _1yep5z6192 _1yep5z6193"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6194",
                        tablet: "_1yep5z6195",
                        desktop: "_1yep5z6196"
                      },
                      defaultClass: "_1yep5z6194 _1yep5z6195 _1yep5z6196"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6197",
                        tablet: "_1yep5z6198",
                        desktop: "_1yep5z6199"
                      },
                      defaultClass: "_1yep5z6197 _1yep5z6198 _1yep5z6199"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z619a",
                        tablet: "_1yep5z619b",
                        desktop: "_1yep5z619c"
                      },
                      defaultClass: "_1yep5z619a _1yep5z619b _1yep5z619c"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z619d",
                        tablet: "_1yep5z619e",
                        desktop: "_1yep5z619f"
                      },
                      defaultClass: "_1yep5z619d _1yep5z619e _1yep5z619f"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z619g",
                        tablet: "_1yep5z619h",
                        desktop: "_1yep5z619i"
                      },
                      defaultClass: "_1yep5z619g _1yep5z619h _1yep5z619i"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z619j",
                        tablet: "_1yep5z619k",
                        desktop: "_1yep5z619l"
                      },
                      defaultClass: "_1yep5z619j _1yep5z619k _1yep5z619l"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z619m",
                        tablet: "_1yep5z619n",
                        desktop: "_1yep5z619o"
                      },
                      defaultClass: "_1yep5z619m _1yep5z619n _1yep5z619o"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z619p",
                        tablet: "_1yep5z619q",
                        desktop: "_1yep5z619r"
                      },
                      defaultClass: "_1yep5z619p _1yep5z619q _1yep5z619r"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z619s",
                        tablet: "_1yep5z619t",
                        desktop: "_1yep5z619u"
                      },
                      defaultClass: "_1yep5z619s _1yep5z619t _1yep5z619u"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z619v",
                        tablet: "_1yep5z619w",
                        desktop: "_1yep5z619x"
                      },
                      defaultClass: "_1yep5z619v _1yep5z619w _1yep5z619x"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z619y",
                        tablet: "_1yep5z619z",
                        desktop: "_1yep5z61a0"
                      },
                      defaultClass: "_1yep5z619y _1yep5z619z _1yep5z61a0"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61a1",
                        tablet: "_1yep5z61a2",
                        desktop: "_1yep5z61a3"
                      },
                      defaultClass: "_1yep5z61a1 _1yep5z61a2 _1yep5z61a3"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingInlineStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61a4",
                        tablet: "_1yep5z61a5",
                        desktop: "_1yep5z61a6"
                      },
                      defaultClass: "_1yep5z61a4 _1yep5z61a5 _1yep5z61a6"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61a7",
                        tablet: "_1yep5z61a8",
                        desktop: "_1yep5z61a9"
                      },
                      defaultClass: "_1yep5z61a7 _1yep5z61a8 _1yep5z61a9"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61aa",
                        tablet: "_1yep5z61ab",
                        desktop: "_1yep5z61ac"
                      },
                      defaultClass: "_1yep5z61aa _1yep5z61ab _1yep5z61ac"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61ad",
                        tablet: "_1yep5z61ae",
                        desktop: "_1yep5z61af"
                      },
                      defaultClass: "_1yep5z61ad _1yep5z61ae _1yep5z61af"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61ag",
                        tablet: "_1yep5z61ah",
                        desktop: "_1yep5z61ai"
                      },
                      defaultClass: "_1yep5z61ag _1yep5z61ah _1yep5z61ai"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61aj",
                        tablet: "_1yep5z61ak",
                        desktop: "_1yep5z61al"
                      },
                      defaultClass: "_1yep5z61aj _1yep5z61ak _1yep5z61al"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61am",
                        tablet: "_1yep5z61an",
                        desktop: "_1yep5z61ao"
                      },
                      defaultClass: "_1yep5z61am _1yep5z61an _1yep5z61ao"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61ap",
                        tablet: "_1yep5z61aq",
                        desktop: "_1yep5z61ar"
                      },
                      defaultClass: "_1yep5z61ap _1yep5z61aq _1yep5z61ar"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61as",
                        tablet: "_1yep5z61at",
                        desktop: "_1yep5z61au"
                      },
                      defaultClass: "_1yep5z61as _1yep5z61at _1yep5z61au"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61av",
                        tablet: "_1yep5z61aw",
                        desktop: "_1yep5z61ax"
                      },
                      defaultClass: "_1yep5z61av _1yep5z61aw _1yep5z61ax"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61ay",
                        tablet: "_1yep5z61az",
                        desktop: "_1yep5z61b0"
                      },
                      defaultClass: "_1yep5z61ay _1yep5z61az _1yep5z61b0"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61b1",
                        tablet: "_1yep5z61b2",
                        desktop: "_1yep5z61b3"
                      },
                      defaultClass: "_1yep5z61b1 _1yep5z61b2 _1yep5z61b3"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61b4",
                        tablet: "_1yep5z61b5",
                        desktop: "_1yep5z61b6"
                      },
                      defaultClass: "_1yep5z61b4 _1yep5z61b5 _1yep5z61b6"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61b7",
                        tablet: "_1yep5z61b8",
                        desktop: "_1yep5z61b9"
                      },
                      defaultClass: "_1yep5z61b7 _1yep5z61b8 _1yep5z61b9"
                    }
                  },
                  responsiveArray: void 0
                },
                marginBlockStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61ba",
                        tablet: "_1yep5z61bb",
                        desktop: "_1yep5z61bc"
                      },
                      defaultClass: "_1yep5z61ba _1yep5z61bb _1yep5z61bc"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61bd",
                        tablet: "_1yep5z61be",
                        desktop: "_1yep5z61bf"
                      },
                      defaultClass: "_1yep5z61bd _1yep5z61be _1yep5z61bf"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61bg",
                        tablet: "_1yep5z61bh",
                        desktop: "_1yep5z61bi"
                      },
                      defaultClass: "_1yep5z61bg _1yep5z61bh _1yep5z61bi"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61bj",
                        tablet: "_1yep5z61bk",
                        desktop: "_1yep5z61bl"
                      },
                      defaultClass: "_1yep5z61bj _1yep5z61bk _1yep5z61bl"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61bm",
                        tablet: "_1yep5z61bn",
                        desktop: "_1yep5z61bo"
                      },
                      defaultClass: "_1yep5z61bm _1yep5z61bn _1yep5z61bo"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61bp",
                        tablet: "_1yep5z61bq",
                        desktop: "_1yep5z61br"
                      },
                      defaultClass: "_1yep5z61bp _1yep5z61bq _1yep5z61br"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61bs",
                        tablet: "_1yep5z61bt",
                        desktop: "_1yep5z61bu"
                      },
                      defaultClass: "_1yep5z61bs _1yep5z61bt _1yep5z61bu"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61bv",
                        tablet: "_1yep5z61bw",
                        desktop: "_1yep5z61bx"
                      },
                      defaultClass: "_1yep5z61bv _1yep5z61bw _1yep5z61bx"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61by",
                        tablet: "_1yep5z61bz",
                        desktop: "_1yep5z61c0"
                      },
                      defaultClass: "_1yep5z61by _1yep5z61bz _1yep5z61c0"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61c1",
                        tablet: "_1yep5z61c2",
                        desktop: "_1yep5z61c3"
                      },
                      defaultClass: "_1yep5z61c1 _1yep5z61c2 _1yep5z61c3"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61c4",
                        tablet: "_1yep5z61c5",
                        desktop: "_1yep5z61c6"
                      },
                      defaultClass: "_1yep5z61c4 _1yep5z61c5 _1yep5z61c6"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61c7",
                        tablet: "_1yep5z61c8",
                        desktop: "_1yep5z61c9"
                      },
                      defaultClass: "_1yep5z61c7 _1yep5z61c8 _1yep5z61c9"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61ca",
                        tablet: "_1yep5z61cb",
                        desktop: "_1yep5z61cc"
                      },
                      defaultClass: "_1yep5z61ca _1yep5z61cb _1yep5z61cc"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61cd",
                        tablet: "_1yep5z61ce",
                        desktop: "_1yep5z61cf"
                      },
                      defaultClass: "_1yep5z61cd _1yep5z61ce _1yep5z61cf"
                    }
                  },
                  responsiveArray: void 0
                },
                marginInlineEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61cg",
                        tablet: "_1yep5z61ch",
                        desktop: "_1yep5z61ci"
                      },
                      defaultClass: "_1yep5z61cg _1yep5z61ch _1yep5z61ci"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61cj",
                        tablet: "_1yep5z61ck",
                        desktop: "_1yep5z61cl"
                      },
                      defaultClass: "_1yep5z61cj _1yep5z61ck _1yep5z61cl"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61cm",
                        tablet: "_1yep5z61cn",
                        desktop: "_1yep5z61co"
                      },
                      defaultClass: "_1yep5z61cm _1yep5z61cn _1yep5z61co"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61cp",
                        tablet: "_1yep5z61cq",
                        desktop: "_1yep5z61cr"
                      },
                      defaultClass: "_1yep5z61cp _1yep5z61cq _1yep5z61cr"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61cs",
                        tablet: "_1yep5z61ct",
                        desktop: "_1yep5z61cu"
                      },
                      defaultClass: "_1yep5z61cs _1yep5z61ct _1yep5z61cu"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61cv",
                        tablet: "_1yep5z61cw",
                        desktop: "_1yep5z61cx"
                      },
                      defaultClass: "_1yep5z61cv _1yep5z61cw _1yep5z61cx"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61cy",
                        tablet: "_1yep5z61cz",
                        desktop: "_1yep5z61d0"
                      },
                      defaultClass: "_1yep5z61cy _1yep5z61cz _1yep5z61d0"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61d1",
                        tablet: "_1yep5z61d2",
                        desktop: "_1yep5z61d3"
                      },
                      defaultClass: "_1yep5z61d1 _1yep5z61d2 _1yep5z61d3"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61d4",
                        tablet: "_1yep5z61d5",
                        desktop: "_1yep5z61d6"
                      },
                      defaultClass: "_1yep5z61d4 _1yep5z61d5 _1yep5z61d6"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61d7",
                        tablet: "_1yep5z61d8",
                        desktop: "_1yep5z61d9"
                      },
                      defaultClass: "_1yep5z61d7 _1yep5z61d8 _1yep5z61d9"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61da",
                        tablet: "_1yep5z61db",
                        desktop: "_1yep5z61dc"
                      },
                      defaultClass: "_1yep5z61da _1yep5z61db _1yep5z61dc"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61dd",
                        tablet: "_1yep5z61de",
                        desktop: "_1yep5z61df"
                      },
                      defaultClass: "_1yep5z61dd _1yep5z61de _1yep5z61df"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61dg",
                        tablet: "_1yep5z61dh",
                        desktop: "_1yep5z61di"
                      },
                      defaultClass: "_1yep5z61dg _1yep5z61dh _1yep5z61di"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61dj",
                        tablet: "_1yep5z61dk",
                        desktop: "_1yep5z61dl"
                      },
                      defaultClass: "_1yep5z61dj _1yep5z61dk _1yep5z61dl"
                    }
                  },
                  responsiveArray: void 0
                },
                marginBlockEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61dm",
                        tablet: "_1yep5z61dn",
                        desktop: "_1yep5z61do"
                      },
                      defaultClass: "_1yep5z61dm _1yep5z61dn _1yep5z61do"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61dp",
                        tablet: "_1yep5z61dq",
                        desktop: "_1yep5z61dr"
                      },
                      defaultClass: "_1yep5z61dp _1yep5z61dq _1yep5z61dr"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61ds",
                        tablet: "_1yep5z61dt",
                        desktop: "_1yep5z61du"
                      },
                      defaultClass: "_1yep5z61ds _1yep5z61dt _1yep5z61du"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61dv",
                        tablet: "_1yep5z61dw",
                        desktop: "_1yep5z61dx"
                      },
                      defaultClass: "_1yep5z61dv _1yep5z61dw _1yep5z61dx"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61dy",
                        tablet: "_1yep5z61dz",
                        desktop: "_1yep5z61e0"
                      },
                      defaultClass: "_1yep5z61dy _1yep5z61dz _1yep5z61e0"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61e1",
                        tablet: "_1yep5z61e2",
                        desktop: "_1yep5z61e3"
                      },
                      defaultClass: "_1yep5z61e1 _1yep5z61e2 _1yep5z61e3"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61e4",
                        tablet: "_1yep5z61e5",
                        desktop: "_1yep5z61e6"
                      },
                      defaultClass: "_1yep5z61e4 _1yep5z61e5 _1yep5z61e6"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61e7",
                        tablet: "_1yep5z61e8",
                        desktop: "_1yep5z61e9"
                      },
                      defaultClass: "_1yep5z61e7 _1yep5z61e8 _1yep5z61e9"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61ea",
                        tablet: "_1yep5z61eb",
                        desktop: "_1yep5z61ec"
                      },
                      defaultClass: "_1yep5z61ea _1yep5z61eb _1yep5z61ec"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61ed",
                        tablet: "_1yep5z61ee",
                        desktop: "_1yep5z61ef"
                      },
                      defaultClass: "_1yep5z61ed _1yep5z61ee _1yep5z61ef"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61eg",
                        tablet: "_1yep5z61eh",
                        desktop: "_1yep5z61ei"
                      },
                      defaultClass: "_1yep5z61eg _1yep5z61eh _1yep5z61ei"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61ej",
                        tablet: "_1yep5z61ek",
                        desktop: "_1yep5z61el"
                      },
                      defaultClass: "_1yep5z61ej _1yep5z61ek _1yep5z61el"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61em",
                        tablet: "_1yep5z61en",
                        desktop: "_1yep5z61eo"
                      },
                      defaultClass: "_1yep5z61em _1yep5z61en _1yep5z61eo"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61ep",
                        tablet: "_1yep5z61eq",
                        desktop: "_1yep5z61er"
                      },
                      defaultClass: "_1yep5z61ep _1yep5z61eq _1yep5z61er"
                    }
                  },
                  responsiveArray: void 0
                },
                marginInlineStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61es",
                        tablet: "_1yep5z61et",
                        desktop: "_1yep5z61eu"
                      },
                      defaultClass: "_1yep5z61es _1yep5z61et _1yep5z61eu"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61ev",
                        tablet: "_1yep5z61ew",
                        desktop: "_1yep5z61ex"
                      },
                      defaultClass: "_1yep5z61ev _1yep5z61ew _1yep5z61ex"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61ey",
                        tablet: "_1yep5z61ez",
                        desktop: "_1yep5z61f0"
                      },
                      defaultClass: "_1yep5z61ey _1yep5z61ez _1yep5z61f0"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61f1",
                        tablet: "_1yep5z61f2",
                        desktop: "_1yep5z61f3"
                      },
                      defaultClass: "_1yep5z61f1 _1yep5z61f2 _1yep5z61f3"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61f4",
                        tablet: "_1yep5z61f5",
                        desktop: "_1yep5z61f6"
                      },
                      defaultClass: "_1yep5z61f4 _1yep5z61f5 _1yep5z61f6"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61f7",
                        tablet: "_1yep5z61f8",
                        desktop: "_1yep5z61f9"
                      },
                      defaultClass: "_1yep5z61f7 _1yep5z61f8 _1yep5z61f9"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61fa",
                        tablet: "_1yep5z61fb",
                        desktop: "_1yep5z61fc"
                      },
                      defaultClass: "_1yep5z61fa _1yep5z61fb _1yep5z61fc"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61fd",
                        tablet: "_1yep5z61fe",
                        desktop: "_1yep5z61ff"
                      },
                      defaultClass: "_1yep5z61fd _1yep5z61fe _1yep5z61ff"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61fg",
                        tablet: "_1yep5z61fh",
                        desktop: "_1yep5z61fi"
                      },
                      defaultClass: "_1yep5z61fg _1yep5z61fh _1yep5z61fi"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61fj",
                        tablet: "_1yep5z61fk",
                        desktop: "_1yep5z61fl"
                      },
                      defaultClass: "_1yep5z61fj _1yep5z61fk _1yep5z61fl"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61fm",
                        tablet: "_1yep5z61fn",
                        desktop: "_1yep5z61fo"
                      },
                      defaultClass: "_1yep5z61fm _1yep5z61fn _1yep5z61fo"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61fp",
                        tablet: "_1yep5z61fq",
                        desktop: "_1yep5z61fr"
                      },
                      defaultClass: "_1yep5z61fp _1yep5z61fq _1yep5z61fr"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61fs",
                        tablet: "_1yep5z61ft",
                        desktop: "_1yep5z61fu"
                      },
                      defaultClass: "_1yep5z61fs _1yep5z61ft _1yep5z61fu"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61fv",
                        tablet: "_1yep5z61fw",
                        desktop: "_1yep5z61fx"
                      },
                      defaultClass: "_1yep5z61fv _1yep5z61fw _1yep5z61fx"
                    }
                  },
                  responsiveArray: void 0
                },
                gap: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61fy",
                        tablet: "_1yep5z61fz",
                        desktop: "_1yep5z61g0"
                      },
                      defaultClass: "_1yep5z61fy _1yep5z61fz _1yep5z61g0"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61g1",
                        tablet: "_1yep5z61g2",
                        desktop: "_1yep5z61g3"
                      },
                      defaultClass: "_1yep5z61g1 _1yep5z61g2 _1yep5z61g3"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61g4",
                        tablet: "_1yep5z61g5",
                        desktop: "_1yep5z61g6"
                      },
                      defaultClass: "_1yep5z61g4 _1yep5z61g5 _1yep5z61g6"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61g7",
                        tablet: "_1yep5z61g8",
                        desktop: "_1yep5z61g9"
                      },
                      defaultClass: "_1yep5z61g7 _1yep5z61g8 _1yep5z61g9"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61ga",
                        tablet: "_1yep5z61gb",
                        desktop: "_1yep5z61gc"
                      },
                      defaultClass: "_1yep5z61ga _1yep5z61gb _1yep5z61gc"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61gd",
                        tablet: "_1yep5z61ge",
                        desktop: "_1yep5z61gf"
                      },
                      defaultClass: "_1yep5z61gd _1yep5z61ge _1yep5z61gf"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z61gg",
                        tablet: "_1yep5z61gh",
                        desktop: "_1yep5z61gi"
                      },
                      defaultClass: "_1yep5z61gg _1yep5z61gh _1yep5z61gi"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z61gj",
                        tablet: "_1yep5z61gk",
                        desktop: "_1yep5z61gl"
                      },
                      defaultClass: "_1yep5z61gj _1yep5z61gk _1yep5z61gl"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z61gm",
                        tablet: "_1yep5z61gn",
                        desktop: "_1yep5z61go"
                      },
                      defaultClass: "_1yep5z61gm _1yep5z61gn _1yep5z61go"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z61gp",
                        tablet: "_1yep5z61gq",
                        desktop: "_1yep5z61gr"
                      },
                      defaultClass: "_1yep5z61gp _1yep5z61gq _1yep5z61gr"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z61gs",
                        tablet: "_1yep5z61gt",
                        desktop: "_1yep5z61gu"
                      },
                      defaultClass: "_1yep5z61gs _1yep5z61gt _1yep5z61gu"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z61gv",
                        tablet: "_1yep5z61gw",
                        desktop: "_1yep5z61gx"
                      },
                      defaultClass: "_1yep5z61gv _1yep5z61gw _1yep5z61gx"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z61gy",
                        tablet: "_1yep5z61gz",
                        desktop: "_1yep5z61h0"
                      },
                      defaultClass: "_1yep5z61gy _1yep5z61gz _1yep5z61h0"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61h1",
                        tablet: "_1yep5z61h2",
                        desktop: "_1yep5z61h3"
                      },
                      defaultClass: "_1yep5z61h1 _1yep5z61h2 _1yep5z61h3"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.paddingBlockStart.responsiveArray = e.conditions.responsiveArray, e.styles.paddingInlineEnd.responsiveArray = e.conditions.responsiveArray, e.styles.paddingBlockEnd.responsiveArray = e.conditions.responsiveArray, e.styles.paddingInlineStart.responsiveArray = e.conditions.responsiveArray, e.styles.marginBlockStart.responsiveArray = e.conditions.responsiveArray, e.styles.marginInlineEnd.responsiveArray = e.conditions.responsiveArray, e.styles.marginBlockEnd.responsiveArray = e.conditions.responsiveArray, e.styles.marginInlineStart.responsiveArray = e.conditions.responsiveArray, e.styles.gap.responsiveArray = e.conditions.responsiveArray, e;
          }(), function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                borderRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius", "borderEndStartRadius", "borderEndEndRadius"]
                },
                borderTopRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius"]
                },
                borderBottomRadius: {
                  mappings: ["borderEndStartRadius", "borderEndEndRadius"]
                },
                borderLeftRadius: {
                  mappings: ["borderStartStartRadius", "borderEndStartRadius"]
                },
                borderRightRadius: {
                  mappings: ["borderStartEndRadius", "borderEndEndRadius"]
                },
                borderStartStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61h4",
                        tablet: "_1yep5z61h5",
                        desktop: "_1yep5z61h6"
                      },
                      defaultClass: "_1yep5z61h4 _1yep5z61h5 _1yep5z61h6"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61h7",
                        tablet: "_1yep5z61h8",
                        desktop: "_1yep5z61h9"
                      },
                      defaultClass: "_1yep5z61h7 _1yep5z61h8 _1yep5z61h9"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61ha",
                        tablet: "_1yep5z61hb",
                        desktop: "_1yep5z61hc"
                      },
                      defaultClass: "_1yep5z61ha _1yep5z61hb _1yep5z61hc"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61hd",
                        tablet: "_1yep5z61he",
                        desktop: "_1yep5z61hf"
                      },
                      defaultClass: "_1yep5z61hd _1yep5z61he _1yep5z61hf"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61hg",
                        tablet: "_1yep5z61hh",
                        desktop: "_1yep5z61hi"
                      },
                      defaultClass: "_1yep5z61hg _1yep5z61hh _1yep5z61hi"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61hj",
                        tablet: "_1yep5z61hk",
                        desktop: "_1yep5z61hl"
                      },
                      defaultClass: "_1yep5z61hj _1yep5z61hk _1yep5z61hl"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z61hm",
                        tablet: "_1yep5z61hn",
                        desktop: "_1yep5z61ho"
                      },
                      defaultClass: "_1yep5z61hm _1yep5z61hn _1yep5z61ho"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61hp",
                        tablet: "_1yep5z61hq",
                        desktop: "_1yep5z61hr"
                      },
                      defaultClass: "_1yep5z61hp _1yep5z61hq _1yep5z61hr"
                    }
                  },
                  responsiveArray: void 0
                },
                borderStartEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61hs",
                        tablet: "_1yep5z61ht",
                        desktop: "_1yep5z61hu"
                      },
                      defaultClass: "_1yep5z61hs _1yep5z61ht _1yep5z61hu"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61hv",
                        tablet: "_1yep5z61hw",
                        desktop: "_1yep5z61hx"
                      },
                      defaultClass: "_1yep5z61hv _1yep5z61hw _1yep5z61hx"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61hy",
                        tablet: "_1yep5z61hz",
                        desktop: "_1yep5z61i0"
                      },
                      defaultClass: "_1yep5z61hy _1yep5z61hz _1yep5z61i0"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61i1",
                        tablet: "_1yep5z61i2",
                        desktop: "_1yep5z61i3"
                      },
                      defaultClass: "_1yep5z61i1 _1yep5z61i2 _1yep5z61i3"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61i4",
                        tablet: "_1yep5z61i5",
                        desktop: "_1yep5z61i6"
                      },
                      defaultClass: "_1yep5z61i4 _1yep5z61i5 _1yep5z61i6"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61i7",
                        tablet: "_1yep5z61i8",
                        desktop: "_1yep5z61i9"
                      },
                      defaultClass: "_1yep5z61i7 _1yep5z61i8 _1yep5z61i9"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z61ia",
                        tablet: "_1yep5z61ib",
                        desktop: "_1yep5z61ic"
                      },
                      defaultClass: "_1yep5z61ia _1yep5z61ib _1yep5z61ic"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61id",
                        tablet: "_1yep5z61ie",
                        desktop: "_1yep5z61if"
                      },
                      defaultClass: "_1yep5z61id _1yep5z61ie _1yep5z61if"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61ig",
                        tablet: "_1yep5z61ih",
                        desktop: "_1yep5z61ii"
                      },
                      defaultClass: "_1yep5z61ig _1yep5z61ih _1yep5z61ii"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61ij",
                        tablet: "_1yep5z61ik",
                        desktop: "_1yep5z61il"
                      },
                      defaultClass: "_1yep5z61ij _1yep5z61ik _1yep5z61il"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61im",
                        tablet: "_1yep5z61in",
                        desktop: "_1yep5z61io"
                      },
                      defaultClass: "_1yep5z61im _1yep5z61in _1yep5z61io"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61ip",
                        tablet: "_1yep5z61iq",
                        desktop: "_1yep5z61ir"
                      },
                      defaultClass: "_1yep5z61ip _1yep5z61iq _1yep5z61ir"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61is",
                        tablet: "_1yep5z61it",
                        desktop: "_1yep5z61iu"
                      },
                      defaultClass: "_1yep5z61is _1yep5z61it _1yep5z61iu"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61iv",
                        tablet: "_1yep5z61iw",
                        desktop: "_1yep5z61ix"
                      },
                      defaultClass: "_1yep5z61iv _1yep5z61iw _1yep5z61ix"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z61iy",
                        tablet: "_1yep5z61iz",
                        desktop: "_1yep5z61j0"
                      },
                      defaultClass: "_1yep5z61iy _1yep5z61iz _1yep5z61j0"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61j1",
                        tablet: "_1yep5z61j2",
                        desktop: "_1yep5z61j3"
                      },
                      defaultClass: "_1yep5z61j1 _1yep5z61j2 _1yep5z61j3"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z61j4",
                        tablet: "_1yep5z61j5",
                        desktop: "_1yep5z61j6"
                      },
                      defaultClass: "_1yep5z61j4 _1yep5z61j5 _1yep5z61j6"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z61j7",
                        tablet: "_1yep5z61j8",
                        desktop: "_1yep5z61j9"
                      },
                      defaultClass: "_1yep5z61j7 _1yep5z61j8 _1yep5z61j9"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z61ja",
                        tablet: "_1yep5z61jb",
                        desktop: "_1yep5z61jc"
                      },
                      defaultClass: "_1yep5z61ja _1yep5z61jb _1yep5z61jc"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z61jd",
                        tablet: "_1yep5z61je",
                        desktop: "_1yep5z61jf"
                      },
                      defaultClass: "_1yep5z61jd _1yep5z61je _1yep5z61jf"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z61jg",
                        tablet: "_1yep5z61jh",
                        desktop: "_1yep5z61ji"
                      },
                      defaultClass: "_1yep5z61jg _1yep5z61jh _1yep5z61ji"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z61jj",
                        tablet: "_1yep5z61jk",
                        desktop: "_1yep5z61jl"
                      },
                      defaultClass: "_1yep5z61jj _1yep5z61jk _1yep5z61jl"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z61jm",
                        tablet: "_1yep5z61jn",
                        desktop: "_1yep5z61jo"
                      },
                      defaultClass: "_1yep5z61jm _1yep5z61jn _1yep5z61jo"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z61jp",
                        tablet: "_1yep5z61jq",
                        desktop: "_1yep5z61jr"
                      },
                      defaultClass: "_1yep5z61jp _1yep5z61jq _1yep5z61jr"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.borderStartStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderStartEndRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndEndRadius.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              boxShadow: {
                values: {
                  low: {
                    defaultClass: "_1yep5z61js"
                  },
                  medium: {
                    defaultClass: "_1yep5z61jt"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              opacity: {
                values: {
                  none: {
                    defaultClass: "_1yep5z61ju"
                  },
                  low: {
                    defaultClass: "_1yep5z61jv"
                  },
                  medium: {
                    defaultClass: "_1yep5z61jw"
                  },
                  high: {
                    defaultClass: "_1yep5z61jx"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              typography: {
                values: {
                  "heading.h6.regular": {
                    defaultClass: "_1yep5z61jy"
                  },
                  "heading.h6.medium": {
                    defaultClass: "_1yep5z61jz"
                  },
                  "heading.h6.semibold": {
                    defaultClass: "_1yep5z61k0"
                  },
                  "heading.h5.regular": {
                    defaultClass: "_1yep5z61k1"
                  },
                  "heading.h5.medium": {
                    defaultClass: "_1yep5z61k2"
                  },
                  "heading.h5.semibold": {
                    defaultClass: "_1yep5z61k3"
                  },
                  "heading.h4.regular": {
                    defaultClass: "_1yep5z61k4"
                  },
                  "heading.h4.medium": {
                    defaultClass: "_1yep5z61k5"
                  },
                  "heading.h4.semibold": {
                    defaultClass: "_1yep5z61k6"
                  },
                  "heading.h3.regular": {
                    defaultClass: "_1yep5z61k7"
                  },
                  "heading.h3.medium": {
                    defaultClass: "_1yep5z61k8"
                  },
                  "heading.h3.semibold": {
                    defaultClass: "_1yep5z61k9"
                  },
                  "heading.h2.regular": {
                    defaultClass: "_1yep5z61ka"
                  },
                  "heading.h2.medium": {
                    defaultClass: "_1yep5z61kb"
                  },
                  "heading.h2.semibold": {
                    defaultClass: "_1yep5z61kc"
                  },
                  "heading.h1.regular": {
                    defaultClass: "_1yep5z61kd"
                  },
                  "heading.h1.medium": {
                    defaultClass: "_1yep5z61ke"
                  },
                  "heading.h1.semibold": {
                    defaultClass: "_1yep5z61kf"
                  },
                  "label.sm.regular": {
                    defaultClass: "_1yep5z61kg"
                  },
                  "label.sm.medium": {
                    defaultClass: "_1yep5z61kh"
                  },
                  "label.sm.semibold": {
                    defaultClass: "_1yep5z61ki"
                  },
                  "label.md.regular": {
                    defaultClass: "_1yep5z61kj"
                  },
                  "label.md.medium": {
                    defaultClass: "_1yep5z61kk"
                  },
                  "label.md.semibold": {
                    defaultClass: "_1yep5z61kl"
                  },
                  "label.lg.regular": {
                    defaultClass: "_1yep5z61km"
                  },
                  "label.lg.medium": {
                    defaultClass: "_1yep5z61kn"
                  },
                  "label.lg.semibold": {
                    defaultClass: "_1yep5z61ko"
                  },
                  "body.sm.regular": {
                    defaultClass: "_1yep5z61kp"
                  },
                  "body.sm.medium": {
                    defaultClass: "_1yep5z61kq"
                  },
                  "body.sm.semibold": {
                    defaultClass: "_1yep5z61kr"
                  },
                  "body.md.regular": {
                    defaultClass: "_1yep5z61ks"
                  },
                  "body.md.medium": {
                    defaultClass: "_1yep5z61kt"
                  },
                  "body.md.semibold": {
                    defaultClass: "_1yep5z61ku"
                  },
                  "body.lg.regular": {
                    defaultClass: "_1yep5z61kv"
                  },
                  "body.lg.medium": {
                    defaultClass: "_1yep5z61kw"
                  },
                  "body.lg.semibold": {
                    defaultClass: "_1yep5z61kx"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              color: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z61ky"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z61kz"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z61l0"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z61l1"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z61l2"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z61l3"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z61l4"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z61l5"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z61l6"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z61l7"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z61l8"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z61l9"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z61la"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z61lb"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z61lc"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z61ld"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z61le"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z61lf"
                  },
                  "text.primary": {
                    defaultClass: "_1yep5z61lg"
                  },
                  "text.secondary": {
                    defaultClass: "_1yep5z61lh"
                  },
                  "text.helper": {
                    defaultClass: "_1yep5z61li"
                  },
                  "text.placeholder": {
                    defaultClass: "_1yep5z61lj"
                  },
                  "text.disabled": {
                    defaultClass: "_1yep5z61lk"
                  },
                  "text.inverse": {
                    defaultClass: "_1yep5z61ll"
                  },
                  "icon.primary": {
                    defaultClass: "_1yep5z61lm"
                  },
                  "icon.secondary": {
                    defaultClass: "_1yep5z61ln"
                  },
                  "icon.disabled": {
                    defaultClass: "_1yep5z61lo"
                  },
                  "icon.inverse": {
                    defaultClass: "_1yep5z61lp"
                  },
                  "icon.interactive": {
                    defaultClass: "_1yep5z61lq"
                  },
                  "interactive.primary": {
                    defaultClass: "_1yep5z61lr"
                  },
                  "interactive.hovered": {
                    defaultClass: "_1yep5z61ls"
                  },
                  "interactive.active": {
                    defaultClass: "_1yep5z61lt"
                  },
                  "interactive.visited": {
                    defaultClass: "_1yep5z61lu"
                  },
                  "interactive.disabled": {
                    defaultClass: "_1yep5z61lv"
                  }
                }
              },
              backgroundColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z61lw"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z61lx"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z61ly"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z61lz"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z61m0"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z61m1"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z61m2"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z61m3"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z61m4"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z61m5"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z61m6"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z61m7"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z61m8"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z61m9"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z61ma"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z61mb"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z61mc"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z61md"
                  },
                  "background.primary.subtle": {
                    defaultClass: "_1yep5z61me"
                  },
                  "background.primary.medium": {
                    defaultClass: "_1yep5z61mf"
                  },
                  "background.primary.strong": {
                    defaultClass: "_1yep5z61mg"
                  },
                  "background.secondary.subtle": {
                    defaultClass: "_1yep5z61mh"
                  },
                  "background.secondary.medium": {
                    defaultClass: "_1yep5z61mi"
                  },
                  "background.secondary.strong": {
                    defaultClass: "_1yep5z61mj"
                  },
                  "background.inverse.subtle": {
                    defaultClass: "_1yep5z61mk"
                  },
                  "background.inverse.medium": {
                    defaultClass: "_1yep5z61ml"
                  },
                  "background.inverse.strong": {
                    defaultClass: "_1yep5z61mm"
                  },
                  "background.overlay.subtle": {
                    defaultClass: "_1yep5z61mn"
                  },
                  "background.overlay.medium": {
                    defaultClass: "_1yep5z61mo"
                  },
                  "positive.subtle": {
                    defaultClass: "_1yep5z61mp"
                  },
                  "positive.medium": {
                    defaultClass: "_1yep5z61mq"
                  },
                  "positive.strong": {
                    defaultClass: "_1yep5z61mr"
                  },
                  "positive.interactive": {
                    defaultClass: "_1yep5z61ms"
                  }
                }
              },
              borderColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z61mt"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z61mu"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z61mv"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z61mw"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z61mx"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z61my"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z61mz"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z61n0"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z61n1"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z61n2"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z61n3"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z61n4"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z61n5"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z61n6"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z61n7"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z61n8"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z61n9"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z61na"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z61nb"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z61nc"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z61nd"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z61ne"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z61nf"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z61ng"
                  },
                  transparent: {
                    defaultClass: "_1yep5z61nh"
                  }
                }
              },
              outlineColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z61ni"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z61nj"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z61nk"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z61nl"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z61nm"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z61nn"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z61no"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z61np"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z61nq"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z61nr"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z61ns"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z61nt"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z61nu"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z61nv"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z61nw"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z61nx"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z61ny"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z61nz"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z61o0"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z61o1"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z61o2"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z61o3"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z61o4"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z61o5"
                  },
                  transparent: {
                    defaultClass: "_1yep5z61o6"
                  }
                }
              }
            }
          }, function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                position: {
                  values: {
                    relative: {
                      conditions: {
                        mobile: "_1yep5z61o7",
                        tablet: "_1yep5z61o8",
                        desktop: "_1yep5z61o9"
                      },
                      defaultClass: "_1yep5z61o7 _1yep5z61o8 _1yep5z61o9"
                    },
                    absolute: {
                      conditions: {
                        mobile: "_1yep5z61oa",
                        tablet: "_1yep5z61ob",
                        desktop: "_1yep5z61oc"
                      },
                      defaultClass: "_1yep5z61oa _1yep5z61ob _1yep5z61oc"
                    },
                    fixed: {
                      conditions: {
                        mobile: "_1yep5z61od",
                        tablet: "_1yep5z61oe",
                        desktop: "_1yep5z61of"
                      },
                      defaultClass: "_1yep5z61od _1yep5z61oe _1yep5z61of"
                    }
                  },
                  responsiveArray: void 0
                },
                display: {
                  values: {
                    none: {
                      conditions: {
                        mobile: "_1yep5z61og",
                        tablet: "_1yep5z61oh",
                        desktop: "_1yep5z61oi"
                      },
                      defaultClass: "_1yep5z61og _1yep5z61oh _1yep5z61oi"
                    },
                    block: {
                      conditions: {
                        mobile: "_1yep5z61oj",
                        tablet: "_1yep5z61ok",
                        desktop: "_1yep5z61ol"
                      },
                      defaultClass: "_1yep5z61oj _1yep5z61ok _1yep5z61ol"
                    },
                    flex: {
                      conditions: {
                        mobile: "_1yep5z61om",
                        tablet: "_1yep5z61on",
                        desktop: "_1yep5z61oo"
                      },
                      defaultClass: "_1yep5z61om _1yep5z61on _1yep5z61oo"
                    },
                    "inline-flex": {
                      conditions: {
                        mobile: "_1yep5z61op",
                        tablet: "_1yep5z61oq",
                        desktop: "_1yep5z61or"
                      },
                      defaultClass: "_1yep5z61op _1yep5z61oq _1yep5z61or"
                    },
                    grid: {
                      conditions: {
                        mobile: "_1yep5z61os",
                        tablet: "_1yep5z61ot",
                        desktop: "_1yep5z61ou"
                      },
                      defaultClass: "_1yep5z61os _1yep5z61ot _1yep5z61ou"
                    }
                  },
                  responsiveArray: void 0
                },
                flexDirection: {
                  values: {
                    row: {
                      conditions: {
                        mobile: "_1yep5z61ov",
                        tablet: "_1yep5z61ow",
                        desktop: "_1yep5z61ox"
                      },
                      defaultClass: "_1yep5z61ov _1yep5z61ow _1yep5z61ox"
                    },
                    column: {
                      conditions: {
                        mobile: "_1yep5z61oy",
                        tablet: "_1yep5z61oz",
                        desktop: "_1yep5z61p0"
                      },
                      defaultClass: "_1yep5z61oy _1yep5z61oz _1yep5z61p0"
                    },
                    "row-reverse": {
                      conditions: {
                        mobile: "_1yep5z61p1",
                        tablet: "_1yep5z61p2",
                        desktop: "_1yep5z61p3"
                      },
                      defaultClass: "_1yep5z61p1 _1yep5z61p2 _1yep5z61p3"
                    },
                    "column-reverse": {
                      conditions: {
                        mobile: "_1yep5z61p4",
                        tablet: "_1yep5z61p5",
                        desktop: "_1yep5z61p6"
                      },
                      defaultClass: "_1yep5z61p4 _1yep5z61p5 _1yep5z61p6"
                    }
                  },
                  responsiveArray: void 0
                },
                alignItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z61p7",
                        tablet: "_1yep5z61p8",
                        desktop: "_1yep5z61p9"
                      },
                      defaultClass: "_1yep5z61p7 _1yep5z61p8 _1yep5z61p9"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z61pa",
                        tablet: "_1yep5z61pb",
                        desktop: "_1yep5z61pc"
                      },
                      defaultClass: "_1yep5z61pa _1yep5z61pb _1yep5z61pc"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z61pd",
                        tablet: "_1yep5z61pe",
                        desktop: "_1yep5z61pf"
                      },
                      defaultClass: "_1yep5z61pd _1yep5z61pe _1yep5z61pf"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z61pg",
                        tablet: "_1yep5z61ph",
                        desktop: "_1yep5z61pi"
                      },
                      defaultClass: "_1yep5z61pg _1yep5z61ph _1yep5z61pi"
                    }
                  },
                  responsiveArray: void 0
                },
                alignSelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z61pj",
                        tablet: "_1yep5z61pk",
                        desktop: "_1yep5z61pl"
                      },
                      defaultClass: "_1yep5z61pj _1yep5z61pk _1yep5z61pl"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z61pm",
                        tablet: "_1yep5z61pn",
                        desktop: "_1yep5z61po"
                      },
                      defaultClass: "_1yep5z61pm _1yep5z61pn _1yep5z61po"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z61pp",
                        tablet: "_1yep5z61pq",
                        desktop: "_1yep5z61pr"
                      },
                      defaultClass: "_1yep5z61pp _1yep5z61pq _1yep5z61pr"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z61ps",
                        tablet: "_1yep5z61pt",
                        desktop: "_1yep5z61pu"
                      },
                      defaultClass: "_1yep5z61ps _1yep5z61pt _1yep5z61pu"
                    }
                  },
                  responsiveArray: void 0
                },
                flex: {
                  values: {
                    0: {
                      conditions: {
                        mobile: "_1yep5z61pv",
                        tablet: "_1yep5z61pw",
                        desktop: "_1yep5z61px"
                      },
                      defaultClass: "_1yep5z61pv _1yep5z61pw _1yep5z61px"
                    },
                    1: {
                      conditions: {
                        mobile: "_1yep5z61py",
                        tablet: "_1yep5z61pz",
                        desktop: "_1yep5z61q0"
                      },
                      defaultClass: "_1yep5z61py _1yep5z61pz _1yep5z61q0"
                    }
                  },
                  responsiveArray: void 0
                },
                justifyContent: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z61q1",
                        tablet: "_1yep5z61q2",
                        desktop: "_1yep5z61q3"
                      },
                      defaultClass: "_1yep5z61q1 _1yep5z61q2 _1yep5z61q3"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z61q4",
                        tablet: "_1yep5z61q5",
                        desktop: "_1yep5z61q6"
                      },
                      defaultClass: "_1yep5z61q4 _1yep5z61q5 _1yep5z61q6"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z61q7",
                        tablet: "_1yep5z61q8",
                        desktop: "_1yep5z61q9"
                      },
                      defaultClass: "_1yep5z61q7 _1yep5z61q8 _1yep5z61q9"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z61qa",
                        tablet: "_1yep5z61qb",
                        desktop: "_1yep5z61qc"
                      },
                      defaultClass: "_1yep5z61qa _1yep5z61qb _1yep5z61qc"
                    },
                    "space-between": {
                      conditions: {
                        mobile: "_1yep5z61qd",
                        tablet: "_1yep5z61qe",
                        desktop: "_1yep5z61qf"
                      },
                      defaultClass: "_1yep5z61qd _1yep5z61qe _1yep5z61qf"
                    }
                  },
                  responsiveArray: void 0
                },
                justifySelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z61qg",
                        tablet: "_1yep5z61qh",
                        desktop: "_1yep5z61qi"
                      },
                      defaultClass: "_1yep5z61qg _1yep5z61qh _1yep5z61qi"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z61qj",
                        tablet: "_1yep5z61qk",
                        desktop: "_1yep5z61ql"
                      },
                      defaultClass: "_1yep5z61qj _1yep5z61qk _1yep5z61ql"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z61qm",
                        tablet: "_1yep5z61qn",
                        desktop: "_1yep5z61qo"
                      },
                      defaultClass: "_1yep5z61qm _1yep5z61qn _1yep5z61qo"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z61qp",
                        tablet: "_1yep5z61qq",
                        desktop: "_1yep5z61qr"
                      },
                      defaultClass: "_1yep5z61qp _1yep5z61qq _1yep5z61qr"
                    }
                  },
                  responsiveArray: void 0
                },
                placeItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z61qs",
                        tablet: "_1yep5z61qt",
                        desktop: "_1yep5z61qu"
                      },
                      defaultClass: "_1yep5z61qs _1yep5z61qt _1yep5z61qu"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z61qv",
                        tablet: "_1yep5z61qw",
                        desktop: "_1yep5z61qx"
                      },
                      defaultClass: "_1yep5z61qv _1yep5z61qw _1yep5z61qx"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z61qy",
                        tablet: "_1yep5z61qz",
                        desktop: "_1yep5z61r0"
                      },
                      defaultClass: "_1yep5z61qy _1yep5z61qz _1yep5z61r0"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z61r1",
                        tablet: "_1yep5z61r2",
                        desktop: "_1yep5z61r3"
                      },
                      defaultClass: "_1yep5z61r1 _1yep5z61r2 _1yep5z61r3"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.position.responsiveArray = e.conditions.responsiveArray, e.styles.display.responsiveArray = e.conditions.responsiveArray, e.styles.flexDirection.responsiveArray = e.conditions.responsiveArray, e.styles.alignItems.responsiveArray = e.conditions.responsiveArray, e.styles.alignSelf.responsiveArray = e.conditions.responsiveArray, e.styles.flex.responsiveArray = e.conditions.responsiveArray, e.styles.justifyContent.responsiveArray = e.conditions.responsiveArray, e.styles.justifySelf.responsiveArray = e.conditions.responsiveArray, e.styles.placeItems.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              transition: {
                values: {
                  "transition.medium": {
                    defaultClass: "_1yep5z61r4"
                  }
                }
              },
              transitionProperty: {
                values: {
                  transform: {
                    defaultClass: "_1yep5z61r5"
                  },
                  opacity: {
                    defaultClass: "_1yep5z61r6"
                  },
                  "background-color": {
                    defaultClass: "_1yep5z61r7"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              inset: {
                mappings: ["insetBlockStart", "insetBlockEnd", "insetInlineEnd", "insetInlineStart"]
              },
              flexWrap: {
                values: {
                  wrap: {
                    defaultClass: "_1yep5z61r8"
                  },
                  nowrap: {
                    defaultClass: "_1yep5z61r9"
                  }
                }
              },
              insetBlockStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61ra"
                  }
                }
              },
              insetBlockEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61rb"
                  }
                }
              },
              insetInlineStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61rc"
                  }
                }
              },
              insetInlineEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61rd"
                  }
                }
              },
              flexShrink: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61re"
                  }
                }
              },
              flexGrow: {
                values: {
                  0: {
                    defaultClass: "_1yep5z61rf"
                  },
                  1: {
                    defaultClass: "_1yep5z61rg"
                  }
                }
              },
              width: {
                values: {
                  full: {
                    defaultClass: "_1yep5z61rh"
                  }
                }
              },
              height: {
                values: {
                  full: {
                    defaultClass: "_1yep5z61ri"
                  }
                }
              },
              cursor: {
                values: {
                  pointer: {
                    defaultClass: "_1yep5z61rj"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              outline: {
                values: {
                  none: {
                    defaultClass: "_1yep5z61rk"
                  }
                }
              },
              outlineStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z61rl"
                  }
                }
              },
              outlineWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z61rm"
                  },
                  2: {
                    defaultClass: "_1yep5z61rn"
                  }
                }
              },
              outlineOffset: {
                values: {
                  1: {
                    defaultClass: "_1yep5z61rq"
                  },
                  2: {
                    defaultClass: "_1yep5z61rr"
                  },
                  "-2": {
                    defaultClass: "_1yep5z61ro"
                  },
                  "-1": {
                    defaultClass: "_1yep5z61rp"
                  }
                }
              },
              border: {
                values: {
                  none: {
                    defaultClass: "_1yep5z61rs"
                  }
                }
              },
              borderStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z61rt"
                  },
                  dashed: {
                    defaultClass: "_1yep5z61ru"
                  }
                }
              },
              borderWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z61rv"
                  },
                  2: {
                    defaultClass: "_1yep5z61rw"
                  }
                }
              }
            }
          }),
          f = d(function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                paddingLeft: {
                  mappings: ["paddingInlineStart"]
                },
                paddingRight: {
                  mappings: ["paddingInlineEnd"]
                },
                paddingTop: {
                  mappings: ["paddingBlockStart"]
                },
                paddingBottom: {
                  mappings: ["paddingBlockEnd"]
                },
                padding: {
                  mappings: ["paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd"]
                },
                paddingX: {
                  mappings: ["paddingInlineStart", "paddingInlineEnd"]
                },
                paddingY: {
                  mappings: ["paddingBlockStart", "paddingBlockEnd"]
                },
                marginLeft: {
                  mappings: ["marginInlineStart"]
                },
                marginRight: {
                  mappings: ["marginInlineEnd"]
                },
                marginTop: {
                  mappings: ["marginBlockStart"]
                },
                marginBottom: {
                  mappings: ["marginBlockEnd"]
                },
                margin: {
                  mappings: ["marginBlockStart", "marginBlockEnd", "marginInlineStart", "marginInlineEnd"]
                },
                marginX: {
                  mappings: ["marginInlineStart", "marginInlineEnd"]
                },
                marginY: {
                  mappings: ["marginBlockStart", "marginBlockEnd"]
                },
                paddingBlockStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6lb",
                        tablet: "_1yep5z6lc",
                        desktop: "_1yep5z6ld"
                      },
                      defaultClass: "_1yep5z6lb _1yep5z6lc _1yep5z6ld"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6le",
                        tablet: "_1yep5z6lf",
                        desktop: "_1yep5z6lg"
                      },
                      defaultClass: "_1yep5z6le _1yep5z6lf _1yep5z6lg"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6lh",
                        tablet: "_1yep5z6li",
                        desktop: "_1yep5z6lj"
                      },
                      defaultClass: "_1yep5z6lh _1yep5z6li _1yep5z6lj"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6lk",
                        tablet: "_1yep5z6ll",
                        desktop: "_1yep5z6lm"
                      },
                      defaultClass: "_1yep5z6lk _1yep5z6ll _1yep5z6lm"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6ln",
                        tablet: "_1yep5z6lo",
                        desktop: "_1yep5z6lp"
                      },
                      defaultClass: "_1yep5z6ln _1yep5z6lo _1yep5z6lp"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6lq",
                        tablet: "_1yep5z6lr",
                        desktop: "_1yep5z6ls"
                      },
                      defaultClass: "_1yep5z6lq _1yep5z6lr _1yep5z6ls"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6lt",
                        tablet: "_1yep5z6lu",
                        desktop: "_1yep5z6lv"
                      },
                      defaultClass: "_1yep5z6lt _1yep5z6lu _1yep5z6lv"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6lw",
                        tablet: "_1yep5z6lx",
                        desktop: "_1yep5z6ly"
                      },
                      defaultClass: "_1yep5z6lw _1yep5z6lx _1yep5z6ly"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6lz",
                        tablet: "_1yep5z6m0",
                        desktop: "_1yep5z6m1"
                      },
                      defaultClass: "_1yep5z6lz _1yep5z6m0 _1yep5z6m1"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6m2",
                        tablet: "_1yep5z6m3",
                        desktop: "_1yep5z6m4"
                      },
                      defaultClass: "_1yep5z6m2 _1yep5z6m3 _1yep5z6m4"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6m5",
                        tablet: "_1yep5z6m6",
                        desktop: "_1yep5z6m7"
                      },
                      defaultClass: "_1yep5z6m5 _1yep5z6m6 _1yep5z6m7"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6m8",
                        tablet: "_1yep5z6m9",
                        desktop: "_1yep5z6ma"
                      },
                      defaultClass: "_1yep5z6m8 _1yep5z6m9 _1yep5z6ma"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6mb",
                        tablet: "_1yep5z6mc",
                        desktop: "_1yep5z6md"
                      },
                      defaultClass: "_1yep5z6mb _1yep5z6mc _1yep5z6md"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6me",
                        tablet: "_1yep5z6mf",
                        desktop: "_1yep5z6mg"
                      },
                      defaultClass: "_1yep5z6me _1yep5z6mf _1yep5z6mg"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingInlineEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6mh",
                        tablet: "_1yep5z6mi",
                        desktop: "_1yep5z6mj"
                      },
                      defaultClass: "_1yep5z6mh _1yep5z6mi _1yep5z6mj"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6mk",
                        tablet: "_1yep5z6ml",
                        desktop: "_1yep5z6mm"
                      },
                      defaultClass: "_1yep5z6mk _1yep5z6ml _1yep5z6mm"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6mn",
                        tablet: "_1yep5z6mo",
                        desktop: "_1yep5z6mp"
                      },
                      defaultClass: "_1yep5z6mn _1yep5z6mo _1yep5z6mp"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6mq",
                        tablet: "_1yep5z6mr",
                        desktop: "_1yep5z6ms"
                      },
                      defaultClass: "_1yep5z6mq _1yep5z6mr _1yep5z6ms"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6mt",
                        tablet: "_1yep5z6mu",
                        desktop: "_1yep5z6mv"
                      },
                      defaultClass: "_1yep5z6mt _1yep5z6mu _1yep5z6mv"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6mw",
                        tablet: "_1yep5z6mx",
                        desktop: "_1yep5z6my"
                      },
                      defaultClass: "_1yep5z6mw _1yep5z6mx _1yep5z6my"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6mz",
                        tablet: "_1yep5z6n0",
                        desktop: "_1yep5z6n1"
                      },
                      defaultClass: "_1yep5z6mz _1yep5z6n0 _1yep5z6n1"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6n2",
                        tablet: "_1yep5z6n3",
                        desktop: "_1yep5z6n4"
                      },
                      defaultClass: "_1yep5z6n2 _1yep5z6n3 _1yep5z6n4"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6n5",
                        tablet: "_1yep5z6n6",
                        desktop: "_1yep5z6n7"
                      },
                      defaultClass: "_1yep5z6n5 _1yep5z6n6 _1yep5z6n7"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6n8",
                        tablet: "_1yep5z6n9",
                        desktop: "_1yep5z6na"
                      },
                      defaultClass: "_1yep5z6n8 _1yep5z6n9 _1yep5z6na"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6nb",
                        tablet: "_1yep5z6nc",
                        desktop: "_1yep5z6nd"
                      },
                      defaultClass: "_1yep5z6nb _1yep5z6nc _1yep5z6nd"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6ne",
                        tablet: "_1yep5z6nf",
                        desktop: "_1yep5z6ng"
                      },
                      defaultClass: "_1yep5z6ne _1yep5z6nf _1yep5z6ng"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6nh",
                        tablet: "_1yep5z6ni",
                        desktop: "_1yep5z6nj"
                      },
                      defaultClass: "_1yep5z6nh _1yep5z6ni _1yep5z6nj"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6nk",
                        tablet: "_1yep5z6nl",
                        desktop: "_1yep5z6nm"
                      },
                      defaultClass: "_1yep5z6nk _1yep5z6nl _1yep5z6nm"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingBlockEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6nn",
                        tablet: "_1yep5z6no",
                        desktop: "_1yep5z6np"
                      },
                      defaultClass: "_1yep5z6nn _1yep5z6no _1yep5z6np"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6nq",
                        tablet: "_1yep5z6nr",
                        desktop: "_1yep5z6ns"
                      },
                      defaultClass: "_1yep5z6nq _1yep5z6nr _1yep5z6ns"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6nt",
                        tablet: "_1yep5z6nu",
                        desktop: "_1yep5z6nv"
                      },
                      defaultClass: "_1yep5z6nt _1yep5z6nu _1yep5z6nv"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6nw",
                        tablet: "_1yep5z6nx",
                        desktop: "_1yep5z6ny"
                      },
                      defaultClass: "_1yep5z6nw _1yep5z6nx _1yep5z6ny"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6nz",
                        tablet: "_1yep5z6o0",
                        desktop: "_1yep5z6o1"
                      },
                      defaultClass: "_1yep5z6nz _1yep5z6o0 _1yep5z6o1"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6o2",
                        tablet: "_1yep5z6o3",
                        desktop: "_1yep5z6o4"
                      },
                      defaultClass: "_1yep5z6o2 _1yep5z6o3 _1yep5z6o4"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6o5",
                        tablet: "_1yep5z6o6",
                        desktop: "_1yep5z6o7"
                      },
                      defaultClass: "_1yep5z6o5 _1yep5z6o6 _1yep5z6o7"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6o8",
                        tablet: "_1yep5z6o9",
                        desktop: "_1yep5z6oa"
                      },
                      defaultClass: "_1yep5z6o8 _1yep5z6o9 _1yep5z6oa"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6ob",
                        tablet: "_1yep5z6oc",
                        desktop: "_1yep5z6od"
                      },
                      defaultClass: "_1yep5z6ob _1yep5z6oc _1yep5z6od"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6oe",
                        tablet: "_1yep5z6of",
                        desktop: "_1yep5z6og"
                      },
                      defaultClass: "_1yep5z6oe _1yep5z6of _1yep5z6og"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6oh",
                        tablet: "_1yep5z6oi",
                        desktop: "_1yep5z6oj"
                      },
                      defaultClass: "_1yep5z6oh _1yep5z6oi _1yep5z6oj"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6ok",
                        tablet: "_1yep5z6ol",
                        desktop: "_1yep5z6om"
                      },
                      defaultClass: "_1yep5z6ok _1yep5z6ol _1yep5z6om"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6on",
                        tablet: "_1yep5z6oo",
                        desktop: "_1yep5z6op"
                      },
                      defaultClass: "_1yep5z6on _1yep5z6oo _1yep5z6op"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6oq",
                        tablet: "_1yep5z6or",
                        desktop: "_1yep5z6os"
                      },
                      defaultClass: "_1yep5z6oq _1yep5z6or _1yep5z6os"
                    }
                  },
                  responsiveArray: void 0
                },
                paddingInlineStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6ot",
                        tablet: "_1yep5z6ou",
                        desktop: "_1yep5z6ov"
                      },
                      defaultClass: "_1yep5z6ot _1yep5z6ou _1yep5z6ov"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6ow",
                        tablet: "_1yep5z6ox",
                        desktop: "_1yep5z6oy"
                      },
                      defaultClass: "_1yep5z6ow _1yep5z6ox _1yep5z6oy"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6oz",
                        tablet: "_1yep5z6p0",
                        desktop: "_1yep5z6p1"
                      },
                      defaultClass: "_1yep5z6oz _1yep5z6p0 _1yep5z6p1"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6p2",
                        tablet: "_1yep5z6p3",
                        desktop: "_1yep5z6p4"
                      },
                      defaultClass: "_1yep5z6p2 _1yep5z6p3 _1yep5z6p4"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6p5",
                        tablet: "_1yep5z6p6",
                        desktop: "_1yep5z6p7"
                      },
                      defaultClass: "_1yep5z6p5 _1yep5z6p6 _1yep5z6p7"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6p8",
                        tablet: "_1yep5z6p9",
                        desktop: "_1yep5z6pa"
                      },
                      defaultClass: "_1yep5z6p8 _1yep5z6p9 _1yep5z6pa"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6pb",
                        tablet: "_1yep5z6pc",
                        desktop: "_1yep5z6pd"
                      },
                      defaultClass: "_1yep5z6pb _1yep5z6pc _1yep5z6pd"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6pe",
                        tablet: "_1yep5z6pf",
                        desktop: "_1yep5z6pg"
                      },
                      defaultClass: "_1yep5z6pe _1yep5z6pf _1yep5z6pg"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6ph",
                        tablet: "_1yep5z6pi",
                        desktop: "_1yep5z6pj"
                      },
                      defaultClass: "_1yep5z6ph _1yep5z6pi _1yep5z6pj"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6pk",
                        tablet: "_1yep5z6pl",
                        desktop: "_1yep5z6pm"
                      },
                      defaultClass: "_1yep5z6pk _1yep5z6pl _1yep5z6pm"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6pn",
                        tablet: "_1yep5z6po",
                        desktop: "_1yep5z6pp"
                      },
                      defaultClass: "_1yep5z6pn _1yep5z6po _1yep5z6pp"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6pq",
                        tablet: "_1yep5z6pr",
                        desktop: "_1yep5z6ps"
                      },
                      defaultClass: "_1yep5z6pq _1yep5z6pr _1yep5z6ps"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6pt",
                        tablet: "_1yep5z6pu",
                        desktop: "_1yep5z6pv"
                      },
                      defaultClass: "_1yep5z6pt _1yep5z6pu _1yep5z6pv"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6pw",
                        tablet: "_1yep5z6px",
                        desktop: "_1yep5z6py"
                      },
                      defaultClass: "_1yep5z6pw _1yep5z6px _1yep5z6py"
                    }
                  },
                  responsiveArray: void 0
                },
                marginBlockStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6pz",
                        tablet: "_1yep5z6q0",
                        desktop: "_1yep5z6q1"
                      },
                      defaultClass: "_1yep5z6pz _1yep5z6q0 _1yep5z6q1"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6q2",
                        tablet: "_1yep5z6q3",
                        desktop: "_1yep5z6q4"
                      },
                      defaultClass: "_1yep5z6q2 _1yep5z6q3 _1yep5z6q4"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6q5",
                        tablet: "_1yep5z6q6",
                        desktop: "_1yep5z6q7"
                      },
                      defaultClass: "_1yep5z6q5 _1yep5z6q6 _1yep5z6q7"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6q8",
                        tablet: "_1yep5z6q9",
                        desktop: "_1yep5z6qa"
                      },
                      defaultClass: "_1yep5z6q8 _1yep5z6q9 _1yep5z6qa"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6qb",
                        tablet: "_1yep5z6qc",
                        desktop: "_1yep5z6qd"
                      },
                      defaultClass: "_1yep5z6qb _1yep5z6qc _1yep5z6qd"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6qe",
                        tablet: "_1yep5z6qf",
                        desktop: "_1yep5z6qg"
                      },
                      defaultClass: "_1yep5z6qe _1yep5z6qf _1yep5z6qg"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6qh",
                        tablet: "_1yep5z6qi",
                        desktop: "_1yep5z6qj"
                      },
                      defaultClass: "_1yep5z6qh _1yep5z6qi _1yep5z6qj"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6qk",
                        tablet: "_1yep5z6ql",
                        desktop: "_1yep5z6qm"
                      },
                      defaultClass: "_1yep5z6qk _1yep5z6ql _1yep5z6qm"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6qn",
                        tablet: "_1yep5z6qo",
                        desktop: "_1yep5z6qp"
                      },
                      defaultClass: "_1yep5z6qn _1yep5z6qo _1yep5z6qp"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6qq",
                        tablet: "_1yep5z6qr",
                        desktop: "_1yep5z6qs"
                      },
                      defaultClass: "_1yep5z6qq _1yep5z6qr _1yep5z6qs"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6qt",
                        tablet: "_1yep5z6qu",
                        desktop: "_1yep5z6qv"
                      },
                      defaultClass: "_1yep5z6qt _1yep5z6qu _1yep5z6qv"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6qw",
                        tablet: "_1yep5z6qx",
                        desktop: "_1yep5z6qy"
                      },
                      defaultClass: "_1yep5z6qw _1yep5z6qx _1yep5z6qy"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6qz",
                        tablet: "_1yep5z6r0",
                        desktop: "_1yep5z6r1"
                      },
                      defaultClass: "_1yep5z6qz _1yep5z6r0 _1yep5z6r1"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6r2",
                        tablet: "_1yep5z6r3",
                        desktop: "_1yep5z6r4"
                      },
                      defaultClass: "_1yep5z6r2 _1yep5z6r3 _1yep5z6r4"
                    }
                  },
                  responsiveArray: void 0
                },
                marginInlineEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6r5",
                        tablet: "_1yep5z6r6",
                        desktop: "_1yep5z6r7"
                      },
                      defaultClass: "_1yep5z6r5 _1yep5z6r6 _1yep5z6r7"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6r8",
                        tablet: "_1yep5z6r9",
                        desktop: "_1yep5z6ra"
                      },
                      defaultClass: "_1yep5z6r8 _1yep5z6r9 _1yep5z6ra"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6rb",
                        tablet: "_1yep5z6rc",
                        desktop: "_1yep5z6rd"
                      },
                      defaultClass: "_1yep5z6rb _1yep5z6rc _1yep5z6rd"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6re",
                        tablet: "_1yep5z6rf",
                        desktop: "_1yep5z6rg"
                      },
                      defaultClass: "_1yep5z6re _1yep5z6rf _1yep5z6rg"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6rh",
                        tablet: "_1yep5z6ri",
                        desktop: "_1yep5z6rj"
                      },
                      defaultClass: "_1yep5z6rh _1yep5z6ri _1yep5z6rj"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6rk",
                        tablet: "_1yep5z6rl",
                        desktop: "_1yep5z6rm"
                      },
                      defaultClass: "_1yep5z6rk _1yep5z6rl _1yep5z6rm"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6rn",
                        tablet: "_1yep5z6ro",
                        desktop: "_1yep5z6rp"
                      },
                      defaultClass: "_1yep5z6rn _1yep5z6ro _1yep5z6rp"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6rq",
                        tablet: "_1yep5z6rr",
                        desktop: "_1yep5z6rs"
                      },
                      defaultClass: "_1yep5z6rq _1yep5z6rr _1yep5z6rs"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6rt",
                        tablet: "_1yep5z6ru",
                        desktop: "_1yep5z6rv"
                      },
                      defaultClass: "_1yep5z6rt _1yep5z6ru _1yep5z6rv"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6rw",
                        tablet: "_1yep5z6rx",
                        desktop: "_1yep5z6ry"
                      },
                      defaultClass: "_1yep5z6rw _1yep5z6rx _1yep5z6ry"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6rz",
                        tablet: "_1yep5z6s0",
                        desktop: "_1yep5z6s1"
                      },
                      defaultClass: "_1yep5z6rz _1yep5z6s0 _1yep5z6s1"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6s2",
                        tablet: "_1yep5z6s3",
                        desktop: "_1yep5z6s4"
                      },
                      defaultClass: "_1yep5z6s2 _1yep5z6s3 _1yep5z6s4"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6s5",
                        tablet: "_1yep5z6s6",
                        desktop: "_1yep5z6s7"
                      },
                      defaultClass: "_1yep5z6s5 _1yep5z6s6 _1yep5z6s7"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6s8",
                        tablet: "_1yep5z6s9",
                        desktop: "_1yep5z6sa"
                      },
                      defaultClass: "_1yep5z6s8 _1yep5z6s9 _1yep5z6sa"
                    }
                  },
                  responsiveArray: void 0
                },
                marginBlockEnd: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6sb",
                        tablet: "_1yep5z6sc",
                        desktop: "_1yep5z6sd"
                      },
                      defaultClass: "_1yep5z6sb _1yep5z6sc _1yep5z6sd"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6se",
                        tablet: "_1yep5z6sf",
                        desktop: "_1yep5z6sg"
                      },
                      defaultClass: "_1yep5z6se _1yep5z6sf _1yep5z6sg"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6sh",
                        tablet: "_1yep5z6si",
                        desktop: "_1yep5z6sj"
                      },
                      defaultClass: "_1yep5z6sh _1yep5z6si _1yep5z6sj"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6sk",
                        tablet: "_1yep5z6sl",
                        desktop: "_1yep5z6sm"
                      },
                      defaultClass: "_1yep5z6sk _1yep5z6sl _1yep5z6sm"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6sn",
                        tablet: "_1yep5z6so",
                        desktop: "_1yep5z6sp"
                      },
                      defaultClass: "_1yep5z6sn _1yep5z6so _1yep5z6sp"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6sq",
                        tablet: "_1yep5z6sr",
                        desktop: "_1yep5z6ss"
                      },
                      defaultClass: "_1yep5z6sq _1yep5z6sr _1yep5z6ss"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6st",
                        tablet: "_1yep5z6su",
                        desktop: "_1yep5z6sv"
                      },
                      defaultClass: "_1yep5z6st _1yep5z6su _1yep5z6sv"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6sw",
                        tablet: "_1yep5z6sx",
                        desktop: "_1yep5z6sy"
                      },
                      defaultClass: "_1yep5z6sw _1yep5z6sx _1yep5z6sy"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6sz",
                        tablet: "_1yep5z6t0",
                        desktop: "_1yep5z6t1"
                      },
                      defaultClass: "_1yep5z6sz _1yep5z6t0 _1yep5z6t1"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6t2",
                        tablet: "_1yep5z6t3",
                        desktop: "_1yep5z6t4"
                      },
                      defaultClass: "_1yep5z6t2 _1yep5z6t3 _1yep5z6t4"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6t5",
                        tablet: "_1yep5z6t6",
                        desktop: "_1yep5z6t7"
                      },
                      defaultClass: "_1yep5z6t5 _1yep5z6t6 _1yep5z6t7"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6t8",
                        tablet: "_1yep5z6t9",
                        desktop: "_1yep5z6ta"
                      },
                      defaultClass: "_1yep5z6t8 _1yep5z6t9 _1yep5z6ta"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6tb",
                        tablet: "_1yep5z6tc",
                        desktop: "_1yep5z6td"
                      },
                      defaultClass: "_1yep5z6tb _1yep5z6tc _1yep5z6td"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6te",
                        tablet: "_1yep5z6tf",
                        desktop: "_1yep5z6tg"
                      },
                      defaultClass: "_1yep5z6te _1yep5z6tf _1yep5z6tg"
                    }
                  },
                  responsiveArray: void 0
                },
                marginInlineStart: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6th",
                        tablet: "_1yep5z6ti",
                        desktop: "_1yep5z6tj"
                      },
                      defaultClass: "_1yep5z6th _1yep5z6ti _1yep5z6tj"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6tk",
                        tablet: "_1yep5z6tl",
                        desktop: "_1yep5z6tm"
                      },
                      defaultClass: "_1yep5z6tk _1yep5z6tl _1yep5z6tm"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6tn",
                        tablet: "_1yep5z6to",
                        desktop: "_1yep5z6tp"
                      },
                      defaultClass: "_1yep5z6tn _1yep5z6to _1yep5z6tp"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6tq",
                        tablet: "_1yep5z6tr",
                        desktop: "_1yep5z6ts"
                      },
                      defaultClass: "_1yep5z6tq _1yep5z6tr _1yep5z6ts"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6tt",
                        tablet: "_1yep5z6tu",
                        desktop: "_1yep5z6tv"
                      },
                      defaultClass: "_1yep5z6tt _1yep5z6tu _1yep5z6tv"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6tw",
                        tablet: "_1yep5z6tx",
                        desktop: "_1yep5z6ty"
                      },
                      defaultClass: "_1yep5z6tw _1yep5z6tx _1yep5z6ty"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6tz",
                        tablet: "_1yep5z6u0",
                        desktop: "_1yep5z6u1"
                      },
                      defaultClass: "_1yep5z6tz _1yep5z6u0 _1yep5z6u1"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6u2",
                        tablet: "_1yep5z6u3",
                        desktop: "_1yep5z6u4"
                      },
                      defaultClass: "_1yep5z6u2 _1yep5z6u3 _1yep5z6u4"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6u5",
                        tablet: "_1yep5z6u6",
                        desktop: "_1yep5z6u7"
                      },
                      defaultClass: "_1yep5z6u5 _1yep5z6u6 _1yep5z6u7"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6u8",
                        tablet: "_1yep5z6u9",
                        desktop: "_1yep5z6ua"
                      },
                      defaultClass: "_1yep5z6u8 _1yep5z6u9 _1yep5z6ua"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6ub",
                        tablet: "_1yep5z6uc",
                        desktop: "_1yep5z6ud"
                      },
                      defaultClass: "_1yep5z6ub _1yep5z6uc _1yep5z6ud"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6ue",
                        tablet: "_1yep5z6uf",
                        desktop: "_1yep5z6ug"
                      },
                      defaultClass: "_1yep5z6ue _1yep5z6uf _1yep5z6ug"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6uh",
                        tablet: "_1yep5z6ui",
                        desktop: "_1yep5z6uj"
                      },
                      defaultClass: "_1yep5z6uh _1yep5z6ui _1yep5z6uj"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6uk",
                        tablet: "_1yep5z6ul",
                        desktop: "_1yep5z6um"
                      },
                      defaultClass: "_1yep5z6uk _1yep5z6ul _1yep5z6um"
                    }
                  },
                  responsiveArray: void 0
                },
                gap: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6un",
                        tablet: "_1yep5z6uo",
                        desktop: "_1yep5z6up"
                      },
                      defaultClass: "_1yep5z6un _1yep5z6uo _1yep5z6up"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6uq",
                        tablet: "_1yep5z6ur",
                        desktop: "_1yep5z6us"
                      },
                      defaultClass: "_1yep5z6uq _1yep5z6ur _1yep5z6us"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6ut",
                        tablet: "_1yep5z6uu",
                        desktop: "_1yep5z6uv"
                      },
                      defaultClass: "_1yep5z6ut _1yep5z6uu _1yep5z6uv"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6uw",
                        tablet: "_1yep5z6ux",
                        desktop: "_1yep5z6uy"
                      },
                      defaultClass: "_1yep5z6uw _1yep5z6ux _1yep5z6uy"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6uz",
                        tablet: "_1yep5z6v0",
                        desktop: "_1yep5z6v1"
                      },
                      defaultClass: "_1yep5z6uz _1yep5z6v0 _1yep5z6v1"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6v2",
                        tablet: "_1yep5z6v3",
                        desktop: "_1yep5z6v4"
                      },
                      defaultClass: "_1yep5z6v2 _1yep5z6v3 _1yep5z6v4"
                    },
                    "3xl": {
                      conditions: {
                        mobile: "_1yep5z6v5",
                        tablet: "_1yep5z6v6",
                        desktop: "_1yep5z6v7"
                      },
                      defaultClass: "_1yep5z6v5 _1yep5z6v6 _1yep5z6v7"
                    },
                    "4xl": {
                      conditions: {
                        mobile: "_1yep5z6v8",
                        tablet: "_1yep5z6v9",
                        desktop: "_1yep5z6va"
                      },
                      defaultClass: "_1yep5z6v8 _1yep5z6v9 _1yep5z6va"
                    },
                    "5xl": {
                      conditions: {
                        mobile: "_1yep5z6vb",
                        tablet: "_1yep5z6vc",
                        desktop: "_1yep5z6vd"
                      },
                      defaultClass: "_1yep5z6vb _1yep5z6vc _1yep5z6vd"
                    },
                    "6xl": {
                      conditions: {
                        mobile: "_1yep5z6ve",
                        tablet: "_1yep5z6vf",
                        desktop: "_1yep5z6vg"
                      },
                      defaultClass: "_1yep5z6ve _1yep5z6vf _1yep5z6vg"
                    },
                    "7xl": {
                      conditions: {
                        mobile: "_1yep5z6vh",
                        tablet: "_1yep5z6vi",
                        desktop: "_1yep5z6vj"
                      },
                      defaultClass: "_1yep5z6vh _1yep5z6vi _1yep5z6vj"
                    },
                    "8xl": {
                      conditions: {
                        mobile: "_1yep5z6vk",
                        tablet: "_1yep5z6vl",
                        desktop: "_1yep5z6vm"
                      },
                      defaultClass: "_1yep5z6vk _1yep5z6vl _1yep5z6vm"
                    },
                    "9xl": {
                      conditions: {
                        mobile: "_1yep5z6vn",
                        tablet: "_1yep5z6vo",
                        desktop: "_1yep5z6vp"
                      },
                      defaultClass: "_1yep5z6vn _1yep5z6vo _1yep5z6vp"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6vq",
                        tablet: "_1yep5z6vr",
                        desktop: "_1yep5z6vs"
                      },
                      defaultClass: "_1yep5z6vq _1yep5z6vr _1yep5z6vs"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.paddingBlockStart.responsiveArray = e.conditions.responsiveArray, e.styles.paddingInlineEnd.responsiveArray = e.conditions.responsiveArray, e.styles.paddingBlockEnd.responsiveArray = e.conditions.responsiveArray, e.styles.paddingInlineStart.responsiveArray = e.conditions.responsiveArray, e.styles.marginBlockStart.responsiveArray = e.conditions.responsiveArray, e.styles.marginInlineEnd.responsiveArray = e.conditions.responsiveArray, e.styles.marginBlockEnd.responsiveArray = e.conditions.responsiveArray, e.styles.marginInlineStart.responsiveArray = e.conditions.responsiveArray, e.styles.gap.responsiveArray = e.conditions.responsiveArray, e;
          }(), function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                borderRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius", "borderEndStartRadius", "borderEndEndRadius"]
                },
                borderTopRadius: {
                  mappings: ["borderStartStartRadius", "borderStartEndRadius"]
                },
                borderBottomRadius: {
                  mappings: ["borderEndStartRadius", "borderEndEndRadius"]
                },
                borderLeftRadius: {
                  mappings: ["borderStartStartRadius", "borderEndStartRadius"]
                },
                borderRightRadius: {
                  mappings: ["borderStartEndRadius", "borderEndEndRadius"]
                },
                borderStartStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6vt",
                        tablet: "_1yep5z6vu",
                        desktop: "_1yep5z6vv"
                      },
                      defaultClass: "_1yep5z6vt _1yep5z6vu _1yep5z6vv"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6vw",
                        tablet: "_1yep5z6vx",
                        desktop: "_1yep5z6vy"
                      },
                      defaultClass: "_1yep5z6vw _1yep5z6vx _1yep5z6vy"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6vz",
                        tablet: "_1yep5z6w0",
                        desktop: "_1yep5z6w1"
                      },
                      defaultClass: "_1yep5z6vz _1yep5z6w0 _1yep5z6w1"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6w2",
                        tablet: "_1yep5z6w3",
                        desktop: "_1yep5z6w4"
                      },
                      defaultClass: "_1yep5z6w2 _1yep5z6w3 _1yep5z6w4"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6w5",
                        tablet: "_1yep5z6w6",
                        desktop: "_1yep5z6w7"
                      },
                      defaultClass: "_1yep5z6w5 _1yep5z6w6 _1yep5z6w7"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6w8",
                        tablet: "_1yep5z6w9",
                        desktop: "_1yep5z6wa"
                      },
                      defaultClass: "_1yep5z6w8 _1yep5z6w9 _1yep5z6wa"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6wb",
                        tablet: "_1yep5z6wc",
                        desktop: "_1yep5z6wd"
                      },
                      defaultClass: "_1yep5z6wb _1yep5z6wc _1yep5z6wd"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6we",
                        tablet: "_1yep5z6wf",
                        desktop: "_1yep5z6wg"
                      },
                      defaultClass: "_1yep5z6we _1yep5z6wf _1yep5z6wg"
                    }
                  },
                  responsiveArray: void 0
                },
                borderStartEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6wh",
                        tablet: "_1yep5z6wi",
                        desktop: "_1yep5z6wj"
                      },
                      defaultClass: "_1yep5z6wh _1yep5z6wi _1yep5z6wj"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6wk",
                        tablet: "_1yep5z6wl",
                        desktop: "_1yep5z6wm"
                      },
                      defaultClass: "_1yep5z6wk _1yep5z6wl _1yep5z6wm"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6wn",
                        tablet: "_1yep5z6wo",
                        desktop: "_1yep5z6wp"
                      },
                      defaultClass: "_1yep5z6wn _1yep5z6wo _1yep5z6wp"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6wq",
                        tablet: "_1yep5z6wr",
                        desktop: "_1yep5z6ws"
                      },
                      defaultClass: "_1yep5z6wq _1yep5z6wr _1yep5z6ws"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6wt",
                        tablet: "_1yep5z6wu",
                        desktop: "_1yep5z6wv"
                      },
                      defaultClass: "_1yep5z6wt _1yep5z6wu _1yep5z6wv"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6ww",
                        tablet: "_1yep5z6wx",
                        desktop: "_1yep5z6wy"
                      },
                      defaultClass: "_1yep5z6ww _1yep5z6wx _1yep5z6wy"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6wz",
                        tablet: "_1yep5z6x0",
                        desktop: "_1yep5z6x1"
                      },
                      defaultClass: "_1yep5z6wz _1yep5z6x0 _1yep5z6x1"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6x2",
                        tablet: "_1yep5z6x3",
                        desktop: "_1yep5z6x4"
                      },
                      defaultClass: "_1yep5z6x2 _1yep5z6x3 _1yep5z6x4"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndStartRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6x5",
                        tablet: "_1yep5z6x6",
                        desktop: "_1yep5z6x7"
                      },
                      defaultClass: "_1yep5z6x5 _1yep5z6x6 _1yep5z6x7"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6x8",
                        tablet: "_1yep5z6x9",
                        desktop: "_1yep5z6xa"
                      },
                      defaultClass: "_1yep5z6x8 _1yep5z6x9 _1yep5z6xa"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6xb",
                        tablet: "_1yep5z6xc",
                        desktop: "_1yep5z6xd"
                      },
                      defaultClass: "_1yep5z6xb _1yep5z6xc _1yep5z6xd"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6xe",
                        tablet: "_1yep5z6xf",
                        desktop: "_1yep5z6xg"
                      },
                      defaultClass: "_1yep5z6xe _1yep5z6xf _1yep5z6xg"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6xh",
                        tablet: "_1yep5z6xi",
                        desktop: "_1yep5z6xj"
                      },
                      defaultClass: "_1yep5z6xh _1yep5z6xi _1yep5z6xj"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6xk",
                        tablet: "_1yep5z6xl",
                        desktop: "_1yep5z6xm"
                      },
                      defaultClass: "_1yep5z6xk _1yep5z6xl _1yep5z6xm"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6xn",
                        tablet: "_1yep5z6xo",
                        desktop: "_1yep5z6xp"
                      },
                      defaultClass: "_1yep5z6xn _1yep5z6xo _1yep5z6xp"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6xq",
                        tablet: "_1yep5z6xr",
                        desktop: "_1yep5z6xs"
                      },
                      defaultClass: "_1yep5z6xq _1yep5z6xr _1yep5z6xs"
                    }
                  },
                  responsiveArray: void 0
                },
                borderEndEndRadius: {
                  values: {
                    xs: {
                      conditions: {
                        mobile: "_1yep5z6xt",
                        tablet: "_1yep5z6xu",
                        desktop: "_1yep5z6xv"
                      },
                      defaultClass: "_1yep5z6xt _1yep5z6xu _1yep5z6xv"
                    },
                    sm: {
                      conditions: {
                        mobile: "_1yep5z6xw",
                        tablet: "_1yep5z6xx",
                        desktop: "_1yep5z6xy"
                      },
                      defaultClass: "_1yep5z6xw _1yep5z6xx _1yep5z6xy"
                    },
                    md: {
                      conditions: {
                        mobile: "_1yep5z6xz",
                        tablet: "_1yep5z6y0",
                        desktop: "_1yep5z6y1"
                      },
                      defaultClass: "_1yep5z6xz _1yep5z6y0 _1yep5z6y1"
                    },
                    lg: {
                      conditions: {
                        mobile: "_1yep5z6y2",
                        tablet: "_1yep5z6y3",
                        desktop: "_1yep5z6y4"
                      },
                      defaultClass: "_1yep5z6y2 _1yep5z6y3 _1yep5z6y4"
                    },
                    xl: {
                      conditions: {
                        mobile: "_1yep5z6y5",
                        tablet: "_1yep5z6y6",
                        desktop: "_1yep5z6y7"
                      },
                      defaultClass: "_1yep5z6y5 _1yep5z6y6 _1yep5z6y7"
                    },
                    "2xl": {
                      conditions: {
                        mobile: "_1yep5z6y8",
                        tablet: "_1yep5z6y9",
                        desktop: "_1yep5z6ya"
                      },
                      defaultClass: "_1yep5z6y8 _1yep5z6y9 _1yep5z6ya"
                    },
                    full: {
                      conditions: {
                        mobile: "_1yep5z6yb",
                        tablet: "_1yep5z6yc",
                        desktop: "_1yep5z6yd"
                      },
                      defaultClass: "_1yep5z6yb _1yep5z6yc _1yep5z6yd"
                    },
                    none: {
                      conditions: {
                        mobile: "_1yep5z6ye",
                        tablet: "_1yep5z6yf",
                        desktop: "_1yep5z6yg"
                      },
                      defaultClass: "_1yep5z6ye _1yep5z6yf _1yep5z6yg"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.borderStartStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderStartEndRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndStartRadius.responsiveArray = e.conditions.responsiveArray, e.styles.borderEndEndRadius.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              boxShadow: {
                values: {
                  low: {
                    defaultClass: "_1yep5z6yh"
                  },
                  medium: {
                    defaultClass: "_1yep5z6yi"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              opacity: {
                values: {
                  none: {
                    defaultClass: "_1yep5z6yj"
                  },
                  low: {
                    defaultClass: "_1yep5z6yk"
                  },
                  medium: {
                    defaultClass: "_1yep5z6yl"
                  },
                  high: {
                    defaultClass: "_1yep5z6ym"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              typography: {
                values: {
                  "heading.h6.regular": {
                    defaultClass: "_1yep5z6yn"
                  },
                  "heading.h6.medium": {
                    defaultClass: "_1yep5z6yo"
                  },
                  "heading.h6.semibold": {
                    defaultClass: "_1yep5z6yp"
                  },
                  "heading.h5.regular": {
                    defaultClass: "_1yep5z6yq"
                  },
                  "heading.h5.medium": {
                    defaultClass: "_1yep5z6yr"
                  },
                  "heading.h5.semibold": {
                    defaultClass: "_1yep5z6ys"
                  },
                  "heading.h4.regular": {
                    defaultClass: "_1yep5z6yt"
                  },
                  "heading.h4.medium": {
                    defaultClass: "_1yep5z6yu"
                  },
                  "heading.h4.semibold": {
                    defaultClass: "_1yep5z6yv"
                  },
                  "heading.h3.regular": {
                    defaultClass: "_1yep5z6yw"
                  },
                  "heading.h3.medium": {
                    defaultClass: "_1yep5z6yx"
                  },
                  "heading.h3.semibold": {
                    defaultClass: "_1yep5z6yy"
                  },
                  "heading.h2.regular": {
                    defaultClass: "_1yep5z6yz"
                  },
                  "heading.h2.medium": {
                    defaultClass: "_1yep5z6z0"
                  },
                  "heading.h2.semibold": {
                    defaultClass: "_1yep5z6z1"
                  },
                  "heading.h1.regular": {
                    defaultClass: "_1yep5z6z2"
                  },
                  "heading.h1.medium": {
                    defaultClass: "_1yep5z6z3"
                  },
                  "heading.h1.semibold": {
                    defaultClass: "_1yep5z6z4"
                  },
                  "label.sm.regular": {
                    defaultClass: "_1yep5z6z5"
                  },
                  "label.sm.medium": {
                    defaultClass: "_1yep5z6z6"
                  },
                  "label.sm.semibold": {
                    defaultClass: "_1yep5z6z7"
                  },
                  "label.md.regular": {
                    defaultClass: "_1yep5z6z8"
                  },
                  "label.md.medium": {
                    defaultClass: "_1yep5z6z9"
                  },
                  "label.md.semibold": {
                    defaultClass: "_1yep5z6za"
                  },
                  "label.lg.regular": {
                    defaultClass: "_1yep5z6zb"
                  },
                  "label.lg.medium": {
                    defaultClass: "_1yep5z6zc"
                  },
                  "label.lg.semibold": {
                    defaultClass: "_1yep5z6zd"
                  },
                  "body.sm.regular": {
                    defaultClass: "_1yep5z6ze"
                  },
                  "body.sm.medium": {
                    defaultClass: "_1yep5z6zf"
                  },
                  "body.sm.semibold": {
                    defaultClass: "_1yep5z6zg"
                  },
                  "body.md.regular": {
                    defaultClass: "_1yep5z6zh"
                  },
                  "body.md.medium": {
                    defaultClass: "_1yep5z6zi"
                  },
                  "body.md.semibold": {
                    defaultClass: "_1yep5z6zj"
                  },
                  "body.lg.regular": {
                    defaultClass: "_1yep5z6zk"
                  },
                  "body.lg.medium": {
                    defaultClass: "_1yep5z6zl"
                  },
                  "body.lg.semibold": {
                    defaultClass: "_1yep5z6zm"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              color: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6zn"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6zo"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6zp"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z6zq"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z6zr"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z6zs"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z6zt"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z6zu"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z6zv"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z6zw"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z6zx"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z6zy"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z6zz"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z6100"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z6101"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6102"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6103"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6104"
                  },
                  "text.primary": {
                    defaultClass: "_1yep5z6105"
                  },
                  "text.secondary": {
                    defaultClass: "_1yep5z6106"
                  },
                  "text.helper": {
                    defaultClass: "_1yep5z6107"
                  },
                  "text.placeholder": {
                    defaultClass: "_1yep5z6108"
                  },
                  "text.disabled": {
                    defaultClass: "_1yep5z6109"
                  },
                  "text.inverse": {
                    defaultClass: "_1yep5z610a"
                  },
                  "icon.primary": {
                    defaultClass: "_1yep5z610b"
                  },
                  "icon.secondary": {
                    defaultClass: "_1yep5z610c"
                  },
                  "icon.disabled": {
                    defaultClass: "_1yep5z610d"
                  },
                  "icon.inverse": {
                    defaultClass: "_1yep5z610e"
                  },
                  "icon.interactive": {
                    defaultClass: "_1yep5z610f"
                  },
                  "interactive.primary": {
                    defaultClass: "_1yep5z610g"
                  },
                  "interactive.hovered": {
                    defaultClass: "_1yep5z610h"
                  },
                  "interactive.active": {
                    defaultClass: "_1yep5z610i"
                  },
                  "interactive.visited": {
                    defaultClass: "_1yep5z610j"
                  },
                  "interactive.disabled": {
                    defaultClass: "_1yep5z610k"
                  }
                }
              },
              backgroundColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z610l"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z610m"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z610n"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z610o"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z610p"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z610q"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z610r"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z610s"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z610t"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z610u"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z610v"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z610w"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z610x"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z610y"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z610z"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z6110"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z6111"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z6112"
                  },
                  "background.primary.subtle": {
                    defaultClass: "_1yep5z6113"
                  },
                  "background.primary.medium": {
                    defaultClass: "_1yep5z6114"
                  },
                  "background.primary.strong": {
                    defaultClass: "_1yep5z6115"
                  },
                  "background.secondary.subtle": {
                    defaultClass: "_1yep5z6116"
                  },
                  "background.secondary.medium": {
                    defaultClass: "_1yep5z6117"
                  },
                  "background.secondary.strong": {
                    defaultClass: "_1yep5z6118"
                  },
                  "background.inverse.subtle": {
                    defaultClass: "_1yep5z6119"
                  },
                  "background.inverse.medium": {
                    defaultClass: "_1yep5z611a"
                  },
                  "background.inverse.strong": {
                    defaultClass: "_1yep5z611b"
                  },
                  "background.overlay.subtle": {
                    defaultClass: "_1yep5z611c"
                  },
                  "background.overlay.medium": {
                    defaultClass: "_1yep5z611d"
                  },
                  "positive.subtle": {
                    defaultClass: "_1yep5z611e"
                  },
                  "positive.medium": {
                    defaultClass: "_1yep5z611f"
                  },
                  "positive.strong": {
                    defaultClass: "_1yep5z611g"
                  },
                  "positive.interactive": {
                    defaultClass: "_1yep5z611h"
                  }
                }
              },
              borderColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z611i"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z611j"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z611k"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z611l"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z611m"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z611n"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z611o"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z611p"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z611q"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z611r"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z611s"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z611t"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z611u"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z611v"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z611w"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z611x"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z611y"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z611z"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z6120"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z6121"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z6122"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z6123"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z6124"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z6125"
                  },
                  transparent: {
                    defaultClass: "_1yep5z6126"
                  }
                }
              },
              outlineColor: {
                values: {
                  "support.error.subtler": {
                    defaultClass: "_1yep5z6127"
                  },
                  "support.error.subtle": {
                    defaultClass: "_1yep5z6128"
                  },
                  "support.error.medium": {
                    defaultClass: "_1yep5z6129"
                  },
                  "support.error.strong": {
                    defaultClass: "_1yep5z612a"
                  },
                  "support.success.subtler": {
                    defaultClass: "_1yep5z612b"
                  },
                  "support.success.subtle": {
                    defaultClass: "_1yep5z612c"
                  },
                  "support.success.medium": {
                    defaultClass: "_1yep5z612d"
                  },
                  "support.success.strong": {
                    defaultClass: "_1yep5z612e"
                  },
                  "support.warning.subtler": {
                    defaultClass: "_1yep5z612f"
                  },
                  "support.warning.subtle": {
                    defaultClass: "_1yep5z612g"
                  },
                  "support.warning.medium": {
                    defaultClass: "_1yep5z612h"
                  },
                  "support.warning.strong": {
                    defaultClass: "_1yep5z612i"
                  },
                  "support.info.subtler": {
                    defaultClass: "_1yep5z612j"
                  },
                  "support.info.subtle": {
                    defaultClass: "_1yep5z612k"
                  },
                  "support.info.medium": {
                    defaultClass: "_1yep5z612l"
                  },
                  "support.info.strong": {
                    defaultClass: "_1yep5z612m"
                  },
                  "focused.primary": {
                    defaultClass: "_1yep5z612n"
                  },
                  "focused.inset": {
                    defaultClass: "_1yep5z612o"
                  },
                  "border.subtle": {
                    defaultClass: "_1yep5z612p"
                  },
                  "border.medium": {
                    defaultClass: "_1yep5z612q"
                  },
                  "border.strong": {
                    defaultClass: "_1yep5z612r"
                  },
                  "border.inverse": {
                    defaultClass: "_1yep5z612s"
                  },
                  "border.interactive": {
                    defaultClass: "_1yep5z612t"
                  },
                  "border.disabled": {
                    defaultClass: "_1yep5z612u"
                  },
                  transparent: {
                    defaultClass: "_1yep5z612v"
                  }
                }
              }
            }
          }, function () {
            var e = {
              conditions: {
                defaultCondition: ["mobile", "tablet", "desktop"],
                conditionNames: ["mobile", "tablet", "desktop"],
                responsiveArray: ["mobile", "tablet", "desktop"]
              },
              styles: {
                position: {
                  values: {
                    relative: {
                      conditions: {
                        mobile: "_1yep5z612w",
                        tablet: "_1yep5z612x",
                        desktop: "_1yep5z612y"
                      },
                      defaultClass: "_1yep5z612w _1yep5z612x _1yep5z612y"
                    },
                    absolute: {
                      conditions: {
                        mobile: "_1yep5z612z",
                        tablet: "_1yep5z6130",
                        desktop: "_1yep5z6131"
                      },
                      defaultClass: "_1yep5z612z _1yep5z6130 _1yep5z6131"
                    },
                    fixed: {
                      conditions: {
                        mobile: "_1yep5z6132",
                        tablet: "_1yep5z6133",
                        desktop: "_1yep5z6134"
                      },
                      defaultClass: "_1yep5z6132 _1yep5z6133 _1yep5z6134"
                    }
                  },
                  responsiveArray: void 0
                },
                display: {
                  values: {
                    none: {
                      conditions: {
                        mobile: "_1yep5z6135",
                        tablet: "_1yep5z6136",
                        desktop: "_1yep5z6137"
                      },
                      defaultClass: "_1yep5z6135 _1yep5z6136 _1yep5z6137"
                    },
                    block: {
                      conditions: {
                        mobile: "_1yep5z6138",
                        tablet: "_1yep5z6139",
                        desktop: "_1yep5z613a"
                      },
                      defaultClass: "_1yep5z6138 _1yep5z6139 _1yep5z613a"
                    },
                    flex: {
                      conditions: {
                        mobile: "_1yep5z613b",
                        tablet: "_1yep5z613c",
                        desktop: "_1yep5z613d"
                      },
                      defaultClass: "_1yep5z613b _1yep5z613c _1yep5z613d"
                    },
                    "inline-flex": {
                      conditions: {
                        mobile: "_1yep5z613e",
                        tablet: "_1yep5z613f",
                        desktop: "_1yep5z613g"
                      },
                      defaultClass: "_1yep5z613e _1yep5z613f _1yep5z613g"
                    },
                    grid: {
                      conditions: {
                        mobile: "_1yep5z613h",
                        tablet: "_1yep5z613i",
                        desktop: "_1yep5z613j"
                      },
                      defaultClass: "_1yep5z613h _1yep5z613i _1yep5z613j"
                    }
                  },
                  responsiveArray: void 0
                },
                flexDirection: {
                  values: {
                    row: {
                      conditions: {
                        mobile: "_1yep5z613k",
                        tablet: "_1yep5z613l",
                        desktop: "_1yep5z613m"
                      },
                      defaultClass: "_1yep5z613k _1yep5z613l _1yep5z613m"
                    },
                    column: {
                      conditions: {
                        mobile: "_1yep5z613n",
                        tablet: "_1yep5z613o",
                        desktop: "_1yep5z613p"
                      },
                      defaultClass: "_1yep5z613n _1yep5z613o _1yep5z613p"
                    },
                    "row-reverse": {
                      conditions: {
                        mobile: "_1yep5z613q",
                        tablet: "_1yep5z613r",
                        desktop: "_1yep5z613s"
                      },
                      defaultClass: "_1yep5z613q _1yep5z613r _1yep5z613s"
                    },
                    "column-reverse": {
                      conditions: {
                        mobile: "_1yep5z613t",
                        tablet: "_1yep5z613u",
                        desktop: "_1yep5z613v"
                      },
                      defaultClass: "_1yep5z613t _1yep5z613u _1yep5z613v"
                    }
                  },
                  responsiveArray: void 0
                },
                alignItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z613w",
                        tablet: "_1yep5z613x",
                        desktop: "_1yep5z613y"
                      },
                      defaultClass: "_1yep5z613w _1yep5z613x _1yep5z613y"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z613z",
                        tablet: "_1yep5z6140",
                        desktop: "_1yep5z6141"
                      },
                      defaultClass: "_1yep5z613z _1yep5z6140 _1yep5z6141"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z6142",
                        tablet: "_1yep5z6143",
                        desktop: "_1yep5z6144"
                      },
                      defaultClass: "_1yep5z6142 _1yep5z6143 _1yep5z6144"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z6145",
                        tablet: "_1yep5z6146",
                        desktop: "_1yep5z6147"
                      },
                      defaultClass: "_1yep5z6145 _1yep5z6146 _1yep5z6147"
                    }
                  },
                  responsiveArray: void 0
                },
                alignSelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6148",
                        tablet: "_1yep5z6149",
                        desktop: "_1yep5z614a"
                      },
                      defaultClass: "_1yep5z6148 _1yep5z6149 _1yep5z614a"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z614b",
                        tablet: "_1yep5z614c",
                        desktop: "_1yep5z614d"
                      },
                      defaultClass: "_1yep5z614b _1yep5z614c _1yep5z614d"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z614e",
                        tablet: "_1yep5z614f",
                        desktop: "_1yep5z614g"
                      },
                      defaultClass: "_1yep5z614e _1yep5z614f _1yep5z614g"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z614h",
                        tablet: "_1yep5z614i",
                        desktop: "_1yep5z614j"
                      },
                      defaultClass: "_1yep5z614h _1yep5z614i _1yep5z614j"
                    }
                  },
                  responsiveArray: void 0
                },
                flex: {
                  values: {
                    0: {
                      conditions: {
                        mobile: "_1yep5z614k",
                        tablet: "_1yep5z614l",
                        desktop: "_1yep5z614m"
                      },
                      defaultClass: "_1yep5z614k _1yep5z614l _1yep5z614m"
                    },
                    1: {
                      conditions: {
                        mobile: "_1yep5z614n",
                        tablet: "_1yep5z614o",
                        desktop: "_1yep5z614p"
                      },
                      defaultClass: "_1yep5z614n _1yep5z614o _1yep5z614p"
                    }
                  },
                  responsiveArray: void 0
                },
                justifyContent: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z614q",
                        tablet: "_1yep5z614r",
                        desktop: "_1yep5z614s"
                      },
                      defaultClass: "_1yep5z614q _1yep5z614r _1yep5z614s"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z614t",
                        tablet: "_1yep5z614u",
                        desktop: "_1yep5z614v"
                      },
                      defaultClass: "_1yep5z614t _1yep5z614u _1yep5z614v"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z614w",
                        tablet: "_1yep5z614x",
                        desktop: "_1yep5z614y"
                      },
                      defaultClass: "_1yep5z614w _1yep5z614x _1yep5z614y"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z614z",
                        tablet: "_1yep5z6150",
                        desktop: "_1yep5z6151"
                      },
                      defaultClass: "_1yep5z614z _1yep5z6150 _1yep5z6151"
                    },
                    "space-between": {
                      conditions: {
                        mobile: "_1yep5z6152",
                        tablet: "_1yep5z6153",
                        desktop: "_1yep5z6154"
                      },
                      defaultClass: "_1yep5z6152 _1yep5z6153 _1yep5z6154"
                    }
                  },
                  responsiveArray: void 0
                },
                justifySelf: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z6155",
                        tablet: "_1yep5z6156",
                        desktop: "_1yep5z6157"
                      },
                      defaultClass: "_1yep5z6155 _1yep5z6156 _1yep5z6157"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z6158",
                        tablet: "_1yep5z6159",
                        desktop: "_1yep5z615a"
                      },
                      defaultClass: "_1yep5z6158 _1yep5z6159 _1yep5z615a"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z615b",
                        tablet: "_1yep5z615c",
                        desktop: "_1yep5z615d"
                      },
                      defaultClass: "_1yep5z615b _1yep5z615c _1yep5z615d"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z615e",
                        tablet: "_1yep5z615f",
                        desktop: "_1yep5z615g"
                      },
                      defaultClass: "_1yep5z615e _1yep5z615f _1yep5z615g"
                    }
                  },
                  responsiveArray: void 0
                },
                placeItems: {
                  values: {
                    stretch: {
                      conditions: {
                        mobile: "_1yep5z615h",
                        tablet: "_1yep5z615i",
                        desktop: "_1yep5z615j"
                      },
                      defaultClass: "_1yep5z615h _1yep5z615i _1yep5z615j"
                    },
                    "flex-start": {
                      conditions: {
                        mobile: "_1yep5z615k",
                        tablet: "_1yep5z615l",
                        desktop: "_1yep5z615m"
                      },
                      defaultClass: "_1yep5z615k _1yep5z615l _1yep5z615m"
                    },
                    center: {
                      conditions: {
                        mobile: "_1yep5z615n",
                        tablet: "_1yep5z615o",
                        desktop: "_1yep5z615p"
                      },
                      defaultClass: "_1yep5z615n _1yep5z615o _1yep5z615p"
                    },
                    "flex-end": {
                      conditions: {
                        mobile: "_1yep5z615q",
                        tablet: "_1yep5z615r",
                        desktop: "_1yep5z615s"
                      },
                      defaultClass: "_1yep5z615q _1yep5z615r _1yep5z615s"
                    }
                  },
                  responsiveArray: void 0
                }
              }
            };
            return e.styles.position.responsiveArray = e.conditions.responsiveArray, e.styles.display.responsiveArray = e.conditions.responsiveArray, e.styles.flexDirection.responsiveArray = e.conditions.responsiveArray, e.styles.alignItems.responsiveArray = e.conditions.responsiveArray, e.styles.alignSelf.responsiveArray = e.conditions.responsiveArray, e.styles.flex.responsiveArray = e.conditions.responsiveArray, e.styles.justifyContent.responsiveArray = e.conditions.responsiveArray, e.styles.justifySelf.responsiveArray = e.conditions.responsiveArray, e.styles.placeItems.responsiveArray = e.conditions.responsiveArray, e;
          }(), {
            conditions: void 0,
            styles: {
              transition: {
                values: {
                  "transition.medium": {
                    defaultClass: "_1yep5z615t"
                  }
                }
              },
              transitionProperty: {
                values: {
                  transform: {
                    defaultClass: "_1yep5z615u"
                  },
                  opacity: {
                    defaultClass: "_1yep5z615v"
                  },
                  "background-color": {
                    defaultClass: "_1yep5z615w"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              inset: {
                mappings: ["insetBlockStart", "insetBlockEnd", "insetInlineEnd", "insetInlineStart"]
              },
              flexWrap: {
                values: {
                  wrap: {
                    defaultClass: "_1yep5z615x"
                  },
                  nowrap: {
                    defaultClass: "_1yep5z615y"
                  }
                }
              },
              insetBlockStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z615z"
                  }
                }
              },
              insetBlockEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6160"
                  }
                }
              },
              insetInlineStart: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6161"
                  }
                }
              },
              insetInlineEnd: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6162"
                  }
                }
              },
              flexShrink: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6163"
                  }
                }
              },
              flexGrow: {
                values: {
                  0: {
                    defaultClass: "_1yep5z6164"
                  },
                  1: {
                    defaultClass: "_1yep5z6165"
                  }
                }
              },
              width: {
                values: {
                  full: {
                    defaultClass: "_1yep5z6166"
                  }
                }
              },
              height: {
                values: {
                  full: {
                    defaultClass: "_1yep5z6167"
                  }
                }
              },
              cursor: {
                values: {
                  pointer: {
                    defaultClass: "_1yep5z6168"
                  }
                }
              }
            }
          }, {
            conditions: void 0,
            styles: {
              outline: {
                values: {
                  none: {
                    defaultClass: "_1yep5z6169"
                  }
                }
              },
              outlineStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z616a"
                  }
                }
              },
              outlineWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z616b"
                  },
                  2: {
                    defaultClass: "_1yep5z616c"
                  }
                }
              },
              outlineOffset: {
                values: {
                  1: {
                    defaultClass: "_1yep5z616f"
                  },
                  2: {
                    defaultClass: "_1yep5z616g"
                  },
                  "-2": {
                    defaultClass: "_1yep5z616d"
                  },
                  "-1": {
                    defaultClass: "_1yep5z616e"
                  }
                }
              },
              border: {
                values: {
                  none: {
                    defaultClass: "_1yep5z616h"
                  }
                }
              },
              borderStyle: {
                values: {
                  solid: {
                    defaultClass: "_1yep5z616i"
                  },
                  dashed: {
                    defaultClass: "_1yep5z616j"
                  }
                }
              },
              borderWidth: {
                values: {
                  1: {
                    defaultClass: "_1yep5z616k"
                  },
                  2: {
                    defaultClass: "_1yep5z616l"
                  }
                }
              }
            }
          }),
          m = {
            elevation: {
              low: "0 0 4px 0 rgba(0, 0, 0, 0.4)",
              medium: "0 4px 16px 0 rgba(0, 0, 0, 0.15)"
            },
            opacity: {
              none: "0",
              low: "0.1",
              medium: "0.5",
              high: "0.9"
            },
            rounded: {
              xs: "2px",
              sm: "4px",
              md: "8px",
              lg: "12px",
              xl: "16px",
              "2xl": "24px",
              full: "9999px"
            },
            spacing: {
              xs: "2px",
              sm: "4px",
              md: "8px",
              lg: "12px",
              xl: "16px",
              "2xl": "24px",
              "3xl": "32px",
              "4xl": "40px",
              "5xl": "48px",
              "6xl": "64px",
              "7xl": "80px",
              "8xl": "96px",
              "9xl": "160px"
            },
            color: {
              support: {
                error: {
                  subtler: "#ffebe9",
                  subtle: "#ffd4ce",
                  medium: "#c83c29",
                  strong: "#8a2100"
                },
                success: {
                  subtler: "#ecfeda",
                  subtle: "#d4fcac",
                  medium: "#4B8017",
                  strong: "#2D4D0E"
                },
                warning: {
                  subtler: "#ffecd4",
                  subtle: "#ffd4a1",
                  medium: "#bd5a00",
                  strong: "#9f4c00"
                },
                info: {
                  subtler: "#eff4fb",
                  subtle: "#d3dcff",
                  medium: "#4537de",
                  strong: "#2b1cc1"
                }
              },
              focused: {
                primary: "#4537de",
                inset: "#ffffff"
              },
              background: {
                primary: {
                  subtle: "#ffffff",
                  medium: "#f6f9fd",
                  strong: "#f0f3f9"
                },
                inverse: {
                  subtle: "#717885",
                  medium: "#3d434e",
                  strong: "#2b2e36"
                },
                overlay: {
                  subtle: "rgb(100% 100% 100% / 0.25)",
                  medium: "rgb(5.49% 7.06% 9.41% / 0.5)",
                  interactive: "rgb(27.1% 21.6% 87.1% / 0.25)"
                },
                secondary: {
                  subtle: "#f0f3f9",
                  medium: "#d7dce4",
                  strong: "#a9aeb7"
                }
              },
              text: {
                primary: "#2b2e36",
                secondary: "#4d525d",
                helper: "#606671",
                placeholder: "#717885",
                inverse: "#ffffff",
                disabled: "rgb(16.9% 18% 21.2% / 0.5)"
              },
              icon: {
                primary: "#2b2e36",
                secondary: "#606671",
                inverse: "#ffffff",
                interactive: "#4537de",
                disabled: "rgb(16.9% 18% 21.2% / 0.5)"
              },
              border: {
                subtle: "#f0f3f9",
                medium: "#d7dce4",
                strong: "#a9aeb7",
                inverse: "#2b2e36",
                interactive: "#4537de",
                disabled: "#a9aeb7"
              },
              interactive: {
                primary: "#4537de",
                hovered: "#2b1cc1",
                active: "#190d94",
                visited: "#190d94",
                disabled: "#a9aeb7"
              },
              positive: {
                subtle: "#ffffff",
                medium: "#f6f9fd",
                strong: "#f0f3f9",
                interactive: "#4537de"
              }
            },
            typography: {
              heading: {
                h6: {
                  regular: {
                    font: '400 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                h5: {
                  regular: {
                    font: '400 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                h4: {
                  regular: {
                    font: '400 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h3: {
                  regular: {
                    font: '400 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h2: {
                  regular: {
                    font: '400 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h1: {
                  regular: {
                    font: '400 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                }
              },
              label: {
                sm: {
                  regular: {
                    font: '400 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  medium: {
                    font: '500 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  semibold: {
                    font: '600 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  }
                },
                md: {
                  regular: {
                    font: '400 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                lg: {
                  regular: {
                    font: '400 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                }
              },
              body: {
                sm: {
                  regular: {
                    font: '400 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  medium: {
                    font: '500 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  semibold: {
                    font: '600 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  }
                },
                md: {
                  regular: {
                    font: '400 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                lg: {
                  regular: {
                    font: '400 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                }
              }
            }
          },
          g = {
            elevation: {
              low: "0 0 4px 0 rgba(0, 0, 0, 0.4)",
              medium: "0 4px 16px 0 rgba(0, 0, 0, 0.15)"
            },
            opacity: {
              none: "0",
              low: "0.1",
              medium: "0.5",
              high: "0.9"
            },
            rounded: {
              xs: "2px",
              sm: "4px",
              md: "8px",
              lg: "12px",
              xl: "16px",
              "2xl": "24px",
              full: "9999px"
            },
            spacing: {
              xs: "2px",
              sm: "4px",
              md: "8px",
              lg: "12px",
              xl: "16px",
              "2xl": "24px",
              "3xl": "32px",
              "4xl": "40px",
              "5xl": "48px",
              "6xl": "64px",
              "7xl": "80px",
              "8xl": "96px",
              "9xl": "160px"
            },
            color: {
              support: {
                error: {
                  subtler: "#711b00",
                  subtle: "#b53007",
                  medium: "#fe7a68",
                  strong: "#ffd4ce"
                },
                success: {
                  subtler: "#223a03",
                  subtle: "#3C6612",
                  medium: "#80CC34",
                  strong: "#ecfeda"
                },
                warning: {
                  subtler: "#562800",
                  subtle: "#bd5a00",
                  medium: "#eb7f00",
                  strong: "#ffd4a1"
                },
                info: {
                  subtler: "#190d94",
                  subtle: "#4537de",
                  medium: "#777cf0",
                  strong: "#d3dcff"
                }
              },
              focused: {
                primary: "#a8bbf8",
                inset: "#2b2e36"
              },
              background: {
                primary: {
                  subtle: "#2b2e36",
                  medium: "#21242c",
                  strong: "#0e1218"
                },
                inverse: {
                  subtle: "#717885",
                  medium: "#f0f3f9",
                  strong: "#ffffff"
                },
                secondary: {
                  subtle: "#3d434e",
                  medium: "#4d525d",
                  strong: "#606671"
                },
                overlay: {
                  subtle: "rgb(100% 100% 100% / 0.25)",
                  medium: "rgb(5.49% 7.06% 9.41% / 0.5)",
                  interactive: "rgb(65.9% 73.3% 97.3% / 0.25)"
                }
              },
              text: {
                primary: "#ffffff",
                secondary: "#d7dce4",
                helper: "#a9aeb7",
                placeholder: "#717885",
                inverse: "#2b2e36",
                disabled: "rgb(100% 100% 100% / 0.5)"
              },
              icon: {
                primary: "#ffffff",
                secondary: "#a9aeb7",
                inverse: "#2b2e36",
                interactive: "#a8bbf8",
                disabled: "rgb(100% 100% 100% / 0.5)"
              },
              border: {
                subtle: "#3d434e",
                medium: "#4d525d",
                strong: "#606671",
                inverse: "#ffffff",
                interactive: "#a8bbf8",
                disabled: "#606671"
              },
              interactive: {
                primary: "#a8bbf8",
                hovered: "#d3dcff",
                active: "#eff4fb",
                visited: "#eff4fb",
                disabled: "#606671"
              },
              positive: {
                subtle: "#f0f3f9",
                medium: "#f6f9fd",
                strong: "#ffffff",
                interactive: "#4537de"
              }
            },
            typography: {
              heading: {
                h6: {
                  regular: {
                    font: '400 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                h5: {
                  regular: {
                    font: '400 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                h4: {
                  regular: {
                    font: '400 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.375rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h3: {
                  regular: {
                    font: '400 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.5rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h2: {
                  regular: {
                    font: '400 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 1.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                },
                h1: {
                  regular: {
                    font: '400 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  medium: {
                    font: '500 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  },
                  semibold: {
                    font: '600 2rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0"
                  }
                }
              },
              label: {
                sm: {
                  regular: {
                    font: '400 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  medium: {
                    font: '500 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  semibold: {
                    font: '600 0.688rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  }
                },
                md: {
                  regular: {
                    font: '400 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.75rem/1.25 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                lg: {
                  regular: {
                    font: '400 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                }
              },
              body: {
                sm: {
                  regular: {
                    font: '400 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  medium: {
                    font: '500 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  },
                  semibold: {
                    font: '600 0.75rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.05px"
                  }
                },
                md: {
                  regular: {
                    font: '400 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 0.875rem/1.375 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                },
                lg: {
                  regular: {
                    font: '400 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  medium: {
                    font: '500 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  },
                  semibold: {
                    font: '600 1rem/1.5 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
                    letterSpacing: "0.1px"
                  }
                }
              }
            }
          },
          v = {
            elevation: {
              low: "var(--bui-elevation-low)",
              medium: "var(--bui-elevation-medium)"
            },
            opacity: {
              none: "var(--bui-opacity-none)",
              low: "var(--bui-opacity-low)",
              medium: "var(--bui-opacity-medium)",
              high: "var(--bui-opacity-high)"
            },
            rounded: {
              xs: "var(--bui-rounded-xs)",
              sm: "var(--bui-rounded-sm)",
              md: "var(--bui-rounded-md)",
              lg: "var(--bui-rounded-lg)",
              xl: "var(--bui-rounded-xl)",
              "2xl": "var(--bui-rounded-2-xl)",
              full: "var(--bui-rounded-full)"
            },
            spacing: {
              xs: "var(--bui-spacing-xs)",
              sm: "var(--bui-spacing-sm)",
              md: "var(--bui-spacing-md)",
              lg: "var(--bui-spacing-lg)",
              xl: "var(--bui-spacing-xl)",
              "2xl": "var(--bui-spacing-2-xl)",
              "3xl": "var(--bui-spacing-3-xl)",
              "4xl": "var(--bui-spacing-4-xl)",
              "5xl": "var(--bui-spacing-5-xl)",
              "6xl": "var(--bui-spacing-6-xl)",
              "7xl": "var(--bui-spacing-7-xl)",
              "8xl": "var(--bui-spacing-8-xl)",
              "9xl": "var(--bui-spacing-9-xl)"
            },
            color: {
              support: {
                error: {
                  subtler: "var(--bui-color-support-error-subtler)",
                  subtle: "var(--bui-color-support-error-subtle)",
                  medium: "var(--bui-color-support-error-medium)",
                  strong: "var(--bui-color-support-error-strong)"
                },
                success: {
                  subtler: "var(--bui-color-support-success-subtler)",
                  subtle: "var(--bui-color-support-success-subtle)",
                  medium: "var(--bui-color-support-success-medium)",
                  strong: "var(--bui-color-support-success-strong)"
                },
                warning: {
                  subtler: "var(--bui-color-support-warning-subtler)",
                  subtle: "var(--bui-color-support-warning-subtle)",
                  medium: "var(--bui-color-support-warning-medium)",
                  strong: "var(--bui-color-support-warning-strong)"
                },
                info: {
                  subtler: "var(--bui-color-support-info-subtler)",
                  subtle: "var(--bui-color-support-info-subtle)",
                  medium: "var(--bui-color-support-info-medium)",
                  strong: "var(--bui-color-support-info-strong)"
                }
              },
              focused: {
                primary: "var(--bui-color-focused-primary)",
                inset: "var(--bui-color-focused-inset)"
              },
              background: {
                primary: {
                  subtle: "var(--bui-color-background-primary-subtle)",
                  medium: "var(--bui-color-background-primary-medium)",
                  strong: "var(--bui-color-background-primary-strong)"
                },
                inverse: {
                  subtle: "var(--bui-color-background-inverse-subtle)",
                  medium: "var(--bui-color-background-inverse-medium)",
                  strong: "var(--bui-color-background-inverse-strong)"
                },
                secondary: {
                  subtle: "var(--bui-color-background-secondary-subtle)",
                  medium: "var(--bui-color-background-secondary-medium)",
                  strong: "var(--bui-color-background-secondary-strong)"
                },
                overlay: {
                  subtle: "var(--bui-color-background-overlay-subtle)",
                  medium: "var(--bui-color-background-overlay-medium)",
                  interactive: "var(--bui-color-background-overlay-interactive)"
                }
              },
              text: {
                primary: "var(--bui-color-text-primary)",
                secondary: "var(--bui-color-text-secondary)",
                helper: "var(--bui-color-text-helper)",
                placeholder: "var(--bui-color-text-placeholder)",
                inverse: "var(--bui-color-text-inverse)",
                disabled: "var(--bui-color-text-disabled)"
              },
              icon: {
                primary: "var(--bui-color-icon-primary)",
                secondary: "var(--bui-color-icon-secondary)",
                inverse: "var(--bui-color-icon-inverse)",
                interactive: "var(--bui-color-icon-interactive)",
                disabled: "var(--bui-color-icon-disabled)"
              },
              border: {
                subtle: "var(--bui-color-border-subtle)",
                medium: "var(--bui-color-border-medium)",
                strong: "var(--bui-color-border-strong)",
                inverse: "var(--bui-color-border-inverse)",
                interactive: "var(--bui-color-border-interactive)",
                disabled: "var(--bui-color-border-disabled)"
              },
              interactive: {
                primary: "var(--bui-color-interactive-primary)",
                hovered: "var(--bui-color-interactive-hovered)",
                active: "var(--bui-color-interactive-active)",
                visited: "var(--bui-color-interactive-visited)",
                disabled: "var(--bui-color-interactive-disabled)"
              },
              positive: {
                subtle: "var(--bui-color-positive-subtle)",
                medium: "var(--bui-color-positive-medium)",
                strong: "var(--bui-color-positive-strong)",
                interactive: "var(--bui-color-positive-interactive)"
              }
            },
            typography: {
              heading: {
                h6: {
                  regular: {
                    font: "var(--bui-typography-heading-h-6-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-6-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-6-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-6-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-6-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-6-semibold-letter-spacing)"
                  }
                },
                h5: {
                  regular: {
                    font: "var(--bui-typography-heading-h-5-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-5-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-5-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-5-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-5-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-5-semibold-letter-spacing)"
                  }
                },
                h4: {
                  regular: {
                    font: "var(--bui-typography-heading-h-4-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-4-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-4-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-4-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-4-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-4-semibold-letter-spacing)"
                  }
                },
                h3: {
                  regular: {
                    font: "var(--bui-typography-heading-h-3-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-3-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-3-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-3-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-3-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-3-semibold-letter-spacing)"
                  }
                },
                h2: {
                  regular: {
                    font: "var(--bui-typography-heading-h-2-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-2-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-2-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-2-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-2-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-2-semibold-letter-spacing)"
                  }
                },
                h1: {
                  regular: {
                    font: "var(--bui-typography-heading-h-1-regular-font)",
                    letterSpacing: "var(--bui-typography-heading-h-1-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-heading-h-1-medium-font)",
                    letterSpacing: "var(--bui-typography-heading-h-1-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-heading-h-1-semibold-font)",
                    letterSpacing: "var(--bui-typography-heading-h-1-semibold-letter-spacing)"
                  }
                }
              },
              label: {
                sm: {
                  regular: {
                    font: "var(--bui-typography-label-sm-regular-font)",
                    letterSpacing: "var(--bui-typography-label-sm-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-label-sm-medium-font)",
                    letterSpacing: "var(--bui-typography-label-sm-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-label-sm-semibold-font)",
                    letterSpacing: "var(--bui-typography-label-sm-semibold-letter-spacing)"
                  }
                },
                md: {
                  regular: {
                    font: "var(--bui-typography-label-md-regular-font)",
                    letterSpacing: "var(--bui-typography-label-md-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-label-md-medium-font)",
                    letterSpacing: "var(--bui-typography-label-md-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-label-md-semibold-font)",
                    letterSpacing: "var(--bui-typography-label-md-semibold-letter-spacing)"
                  }
                },
                lg: {
                  regular: {
                    font: "var(--bui-typography-label-lg-regular-font)",
                    letterSpacing: "var(--bui-typography-label-lg-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-label-lg-medium-font)",
                    letterSpacing: "var(--bui-typography-label-lg-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-label-lg-semibold-font)",
                    letterSpacing: "var(--bui-typography-label-lg-semibold-letter-spacing)"
                  }
                }
              },
              body: {
                sm: {
                  regular: {
                    font: "var(--bui-typography-body-sm-regular-font)",
                    letterSpacing: "var(--bui-typography-body-sm-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-body-sm-medium-font)",
                    letterSpacing: "var(--bui-typography-body-sm-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-body-sm-semibold-font)",
                    letterSpacing: "var(--bui-typography-body-sm-semibold-letter-spacing)"
                  }
                },
                md: {
                  regular: {
                    font: "var(--bui-typography-body-md-regular-font)",
                    letterSpacing: "var(--bui-typography-body-md-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-body-md-medium-font)",
                    letterSpacing: "var(--bui-typography-body-md-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-body-md-semibold-font)",
                    letterSpacing: "var(--bui-typography-body-md-semibold-letter-spacing)"
                  }
                },
                lg: {
                  regular: {
                    font: "var(--bui-typography-body-lg-regular-font)",
                    letterSpacing: "var(--bui-typography-body-lg-regular-letter-spacing)"
                  },
                  medium: {
                    font: "var(--bui-typography-body-lg-medium-font)",
                    letterSpacing: "var(--bui-typography-body-lg-medium-letter-spacing)"
                  },
                  semibold: {
                    font: "var(--bui-typography-body-lg-semibold-font)",
                    letterSpacing: "var(--bui-typography-body-lg-semibold-letter-spacing)"
                  }
                }
              }
            }
          },
          y = (0, r.mapValues)((0, r.omit)({
            mobile: 0,
            tablet: 768,
            desktop: 1280
          }, "mobile"), e => `screen and (min-width: ${e}px)`),
          b = e => t => t && 0 !== Object.keys(t).length ? {
            [y[e]]: t
          } : {},
          w = (b("tablet"), b("desktop"), {
            dialog: {
              row: {
                padding: {
                  vertical: {
                    xs: ["xs", "sm", "sm"],
                    sm: ["sm", "md", "md"],
                    md: ["md", "lg", "lg"],
                    lg: ["lg", "xl", "xl"],
                    xl: ["lg", "2xl", "2xl"]
                  },
                  horizontal: {
                    lg: ["lg", "2xl", "2xl"],
                    md: ["sm", "xl", "xl"],
                    sm: ["sm", "lg", "lg"]
                  }
                }
              }
            }
          });
        var x = p;
        x.base = p, x.variants = f, x.compoundVariants = h;
      },
      8840: (e, t, n) => {
        "use strict";

        n.d(t, {
          AK: () => l,
          CB: () => y,
          SD: () => u,
          TI: () => d,
          US: () => h,
          Zw: () => c,
          _t: () => b,
          gn: () => m,
          iT: () => w,
          kG: () => s,
          mS: () => g,
          tG: () => v
        });
        var r = n(58197),
          o = n(20770),
          i = n(25235),
          a = n.n(i);
        function s(e, t) {
          if (!e) throw new Error(t || "Invariant failed");
        }
        function l(...e) {
          let t = e.filter(Boolean),
            n = [];
          for (let e of t) if (Array.isArray(e)) n.push(l(...e));else if ("object" == typeof e) {
            let t = Object.keys(e);
            for (let r of t) e[r] && n.push(r);
          } else "string" == typeof e && n.push(e);
          return n.join(" ");
        }
        function u(e, t) {
          return e ? "string" == typeof e ? t.querySelector(e) : e instanceof HTMLElement ? e : "current" in e ? e.current : void 0 : null;
        }
        function c({
          text: e,
          fontSize: t,
          fontFamily: n = "Arial",
          fontWeight: r = "normal",
          fontStyle: o = "normal"
        }) {
          let i = document.createElement("canvas").getContext("2d");
          if (!i) return {
            width: 0,
            height: 0
          };
          i.font = `${o} ${r} ${t}px ${n}`;
          let a = i.measureText(e);
          return {
            width: a.width,
            height: a.actualBoundingBoxAscent + a.actualBoundingBoxDescent
          };
        }
        function d({
          text: e,
          maxWidth: t,
          initialFontSize: n = 50,
          fontFamily: r = "Arial",
          fontWeight: o = "normal",
          fontStyle: i = "normal"
        }) {
          let {
              width: a
            } = c({
              text: e,
              fontSize: n,
              fontFamily: r,
              fontWeight: o,
              fontStyle: i
            }),
            s = n,
            l = a;
          for (; l > t;) s -= .5, l = c({
            text: e,
            fontSize: s,
            fontFamily: r,
            fontWeight: o,
            fontStyle: i
          }).width;
          return Math.max(s, 1);
        }
        function p(e, t, n, r) {
          return [(e + n) / 2, (t + r) / 2];
        }
        function h(e) {
          if (!e.length) return "";
          let t = ["M", ...e[0], "Q"];
          for (let n = 0; n < e.length; n++) {
            let [r, o] = e[n],
              [i, a] = e[(n + 1) % e.length],
              s = p(r, o, i, a);
            t = [...t, r, o, ...s];
          }
          return t.push("Z"), t.join(" ");
        }
        function f(e) {
          return e.split("/").pop()?.split(".").shift();
        }
        function m(e) {
          let t = {};
          for (let n of Object.keys(e)) {
            t[f(n) ?? ""] = e[n];
          }
          return t;
        }
        function g(e) {
          return Object.fromEntries(Object.entries(e).filter(([, e]) => !!e));
        }
        function v(e, t) {
          s(t >= 0 && t <= 100, "Percent must be between 0 and 100");
          let n = (0, r.lu)(e),
            o = n.getChannelValue("red"),
            i = n.getChannelValue("green"),
            a = n.getChannelValue("blue"),
            l = Math.round(o + (255 - o) * t / 100),
            u = Math.round(i + (255 - i) * t / 100),
            c = Math.round(a + (255 - a) * t / 100);
          return `#${l.toString(16)}${u.toString(16)}${c.toString(16)}`;
        }
        function y(e, t) {
          if ((e = e.trim()).includes(" ")) return !1;
          try {
            return new URL(e), !0;
          } catch {
            return !!t && y(`https://${e}`);
          }
        }
        function b(e, t = !1) {
          return (0, o.V5)() ? e.replace("Ctrl+", t ? "⌘" : "Cmd+").replace("Alt+", t ? "⌥" : "Option+").replace("Shift+", t ? "⇧" : "Shift+").replace("Enter+", t ? "↩" : "Enter+").replace("Space+", t ? "␣" : "Space+").replace("Enter", t ? "↩" : "Enter") : e;
        }
        var w = e => new DOMParser().parseFromString(a().sanitize(e), "text/html").body.textContent || "";
      },
      25235: function (e) {
        e.exports = function () {
          "use strict";

          const {
            entries: e,
            setPrototypeOf: t,
            isFrozen: n,
            getPrototypeOf: r,
            getOwnPropertyDescriptor: o
          } = Object;
          let {
              freeze: i,
              seal: a,
              create: s
            } = Object,
            {
              apply: l,
              construct: u
            } = "undefined" != typeof Reflect && Reflect;
          i || (i = function (e) {
            return e;
          }), a || (a = function (e) {
            return e;
          }), l || (l = function (e, t, n) {
            return e.apply(t, n);
          }), u || (u = function (e, t) {
            return new e(...t);
          });
          const c = C(Array.prototype.forEach),
            d = C(Array.prototype.pop),
            p = C(Array.prototype.push),
            h = C(String.prototype.toLowerCase),
            f = C(String.prototype.toString),
            m = C(String.prototype.match),
            g = C(String.prototype.replace),
            v = C(String.prototype.indexOf),
            y = C(String.prototype.trim),
            b = C(Object.prototype.hasOwnProperty),
            w = C(RegExp.prototype.test),
            x = S(TypeError);
          function D(e) {
            return "number" == typeof e && isNaN(e);
          }
          function C(e) {
            return function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
              return l(e, t, r);
            };
          }
          function S(e) {
            return function () {
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return u(e, n);
            };
          }
          function E(e, r) {
            let o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : h;
            t && t(e, null);
            let i = r.length;
            for (; i--;) {
              let t = r[i];
              if ("string" == typeof t) {
                const e = o(t);
                e !== t && (n(r) || (r[i] = e), t = e);
              }
              e[t] = !0;
            }
            return e;
          }
          function _(e) {
            for (let t = 0; t < e.length; t++) b(e, t) || (e[t] = null);
            return e;
          }
          function P(t) {
            const n = s(null);
            for (const [r, o] of e(t)) b(t, r) && (Array.isArray(o) ? n[r] = _(o) : o && "object" == typeof o && o.constructor === Object ? n[r] = P(o) : n[r] = o);
            return n;
          }
          function k(e, t) {
            for (; null !== e;) {
              const n = o(e, t);
              if (n) {
                if (n.get) return C(n.get);
                if ("function" == typeof n.value) return C(n.value);
              }
              e = r(e);
            }
            function n() {
              return null;
            }
            return n;
          }
          const A = i(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
            z = i(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
            T = i(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
            O = i(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
            I = i(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
            F = i(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
            M = i(["#text"]),
            R = i(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]),
            j = i(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
            B = i(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
            N = i(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
            L = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            V = a(/<%[\w\W]*|[\w\W]*%>/gm),
            K = a(/\${[\w\W]*}/gm),
            q = a(/^data-[\-\w.\u00B7-\uFFFF]/),
            H = a(/^aria-[\-\w]+$/),
            U = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            Z = a(/^(?:\w+script|data):/i),
            $ = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            G = a(/^html$/i),
            W = a(/^[a-z][.\w]*(-[.\w]+)+$/i);
          var Y = Object.freeze({
            __proto__: null,
            MUSTACHE_EXPR: L,
            ERB_EXPR: V,
            TMPLIT_EXPR: K,
            DATA_ATTR: q,
            ARIA_ATTR: H,
            IS_ALLOWED_URI: U,
            IS_SCRIPT_OR_DATA: Z,
            ATTR_WHITESPACE: $,
            DOCTYPE_NAME: G,
            CUSTOM_ELEMENT: W
          });
          const X = {
              element: 1,
              attribute: 2,
              text: 3,
              cdataSection: 4,
              entityReference: 5,
              entityNode: 6,
              progressingInstruction: 7,
              comment: 8,
              document: 9,
              documentType: 10,
              documentFragment: 11,
              notation: 12
            },
            Q = function () {
              return "undefined" == typeof window ? null : window;
            },
            J = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let n = null;
              const r = "data-tt-policy-suffix";
              t && t.hasAttribute(r) && (n = t.getAttribute(r));
              const o = "dompurify" + (n ? "#" + n : "");
              try {
                return e.createPolicy(o, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + o + " could not be created."), null;
              }
            };
          function ee() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Q();
            const n = e => ee(e);
            if (n.version = "3.1.4", n.removed = [], !t || !t.document || t.document.nodeType !== X.document) return n.isSupported = !1, n;
            let {
              document: r
            } = t;
            const o = r,
              a = o.currentScript,
              {
                DocumentFragment: l,
                HTMLTemplateElement: u,
                Node: C,
                Element: S,
                NodeFilter: _,
                NamedNodeMap: L = t.NamedNodeMap || t.MozNamedAttrMap,
                HTMLFormElement: V,
                DOMParser: K,
                trustedTypes: q
              } = t,
              H = S.prototype,
              Z = k(H, "cloneNode"),
              $ = k(H, "nextSibling"),
              W = k(H, "childNodes"),
              te = k(H, "parentNode");
            if ("function" == typeof u) {
              const e = r.createElement("template");
              e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
            }
            let ne,
              re = "";
            const {
                implementation: oe,
                createNodeIterator: ie,
                createDocumentFragment: ae,
                getElementsByTagName: se
              } = r,
              {
                importNode: le
              } = o;
            let ue = {};
            n.isSupported = "function" == typeof e && "function" == typeof te && oe && void 0 !== oe.createHTMLDocument;
            const {
              MUSTACHE_EXPR: ce,
              ERB_EXPR: de,
              TMPLIT_EXPR: pe,
              DATA_ATTR: he,
              ARIA_ATTR: fe,
              IS_SCRIPT_OR_DATA: me,
              ATTR_WHITESPACE: ge,
              CUSTOM_ELEMENT: ve
            } = Y;
            let {
                IS_ALLOWED_URI: ye
              } = Y,
              be = null;
            const we = E({}, [...A, ...z, ...T, ...I, ...M]);
            let xe = null;
            const De = E({}, [...R, ...j, ...B, ...N]);
            let Ce = Object.seal(s(null, {
                tagNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                attributeNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: !1
                }
              })),
              Se = null,
              Ee = null,
              _e = !0,
              Pe = !0,
              ke = !1,
              Ae = !0,
              ze = !1,
              Te = !0,
              Oe = !1,
              Ie = !1,
              Fe = !1,
              Me = !1,
              Re = !1,
              je = !1,
              Be = !0,
              Ne = !1;
            const Le = "user-content-";
            let Ve = !0,
              Ke = !1,
              qe = {},
              He = null;
            const Ue = E({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
            let Ze = null;
            const $e = E({}, ["audio", "video", "img", "source", "image", "track"]);
            let Ge = null;
            const We = E({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
              Ye = "http://www.w3.org/1998/Math/MathML",
              Xe = "http://www.w3.org/2000/svg",
              Qe = "http://www.w3.org/1999/xhtml";
            let Je = Qe,
              et = !1,
              tt = null;
            const nt = E({}, [Ye, Xe, Qe], f);
            let rt = null;
            const ot = ["application/xhtml+xml", "text/html"],
              it = "text/html";
            let at = null,
              st = null;
            const lt = 255,
              ut = r.createElement("form"),
              ct = function (e) {
                return e instanceof RegExp || e instanceof Function;
              },
              dt = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                if (!st || st !== e) {
                  if (e && "object" == typeof e || (e = {}), e = P(e), rt = -1 === ot.indexOf(e.PARSER_MEDIA_TYPE) ? it : e.PARSER_MEDIA_TYPE, at = "application/xhtml+xml" === rt ? f : h, be = b(e, "ALLOWED_TAGS") ? E({}, e.ALLOWED_TAGS, at) : we, xe = b(e, "ALLOWED_ATTR") ? E({}, e.ALLOWED_ATTR, at) : De, tt = b(e, "ALLOWED_NAMESPACES") ? E({}, e.ALLOWED_NAMESPACES, f) : nt, Ge = b(e, "ADD_URI_SAFE_ATTR") ? E(P(We), e.ADD_URI_SAFE_ATTR, at) : We, Ze = b(e, "ADD_DATA_URI_TAGS") ? E(P($e), e.ADD_DATA_URI_TAGS, at) : $e, He = b(e, "FORBID_CONTENTS") ? E({}, e.FORBID_CONTENTS, at) : Ue, Se = b(e, "FORBID_TAGS") ? E({}, e.FORBID_TAGS, at) : {}, Ee = b(e, "FORBID_ATTR") ? E({}, e.FORBID_ATTR, at) : {}, qe = !!b(e, "USE_PROFILES") && e.USE_PROFILES, _e = !1 !== e.ALLOW_ARIA_ATTR, Pe = !1 !== e.ALLOW_DATA_ATTR, ke = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Ae = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, ze = e.SAFE_FOR_TEMPLATES || !1, Te = !1 !== e.SAFE_FOR_XML, Oe = e.WHOLE_DOCUMENT || !1, Me = e.RETURN_DOM || !1, Re = e.RETURN_DOM_FRAGMENT || !1, je = e.RETURN_TRUSTED_TYPE || !1, Fe = e.FORCE_BODY || !1, Be = !1 !== e.SANITIZE_DOM, Ne = e.SANITIZE_NAMED_PROPS || !1, Ve = !1 !== e.KEEP_CONTENT, Ke = e.IN_PLACE || !1, ye = e.ALLOWED_URI_REGEXP || U, Je = e.NAMESPACE || Qe, Ce = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && ct(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (Ce.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && ct(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (Ce.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (Ce.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), ze && (Pe = !1), Re && (Me = !0), qe && (be = E({}, M), xe = [], !0 === qe.html && (E(be, A), E(xe, R)), !0 === qe.svg && (E(be, z), E(xe, j), E(xe, N)), !0 === qe.svgFilters && (E(be, T), E(xe, j), E(xe, N)), !0 === qe.mathMl && (E(be, I), E(xe, B), E(xe, N))), e.ADD_TAGS && (be === we && (be = P(be)), E(be, e.ADD_TAGS, at)), e.ADD_ATTR && (xe === De && (xe = P(xe)), E(xe, e.ADD_ATTR, at)), e.ADD_URI_SAFE_ATTR && E(Ge, e.ADD_URI_SAFE_ATTR, at), e.FORBID_CONTENTS && (He === Ue && (He = P(He)), E(He, e.FORBID_CONTENTS, at)), Ve && (be["#text"] = !0), Oe && E(be, ["html", "head", "body"]), be.table && (E(be, ["tbody"]), delete Se.tbody), e.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    ne = e.TRUSTED_TYPES_POLICY, re = ne.createHTML("");
                  } else void 0 === ne && (ne = J(q, a)), null !== ne && "string" == typeof re && (re = ne.createHTML(""));
                  i && i(e), st = e;
                }
              },
              pt = E({}, ["mi", "mo", "mn", "ms", "mtext"]),
              ht = E({}, ["foreignobject", "annotation-xml"]),
              ft = E({}, ["title", "style", "font", "a", "script"]),
              mt = E({}, [...z, ...T, ...O]),
              gt = E({}, [...I, ...F]),
              vt = function (e) {
                let t = te(e);
                t && t.tagName || (t = {
                  namespaceURI: Je,
                  tagName: "template"
                });
                const n = h(e.tagName),
                  r = h(t.tagName);
                return !!tt[e.namespaceURI] && (e.namespaceURI === Xe ? t.namespaceURI === Qe ? "svg" === n : t.namespaceURI === Ye ? "svg" === n && ("annotation-xml" === r || pt[r]) : Boolean(mt[n]) : e.namespaceURI === Ye ? t.namespaceURI === Qe ? "math" === n : t.namespaceURI === Xe ? "math" === n && ht[r] : Boolean(gt[n]) : e.namespaceURI === Qe ? !(t.namespaceURI === Xe && !ht[r]) && !(t.namespaceURI === Ye && !pt[r]) && !gt[n] && (ft[n] || !mt[n]) : !("application/xhtml+xml" !== rt || !tt[e.namespaceURI]));
              },
              yt = function (e) {
                p(n.removed, {
                  element: e
                });
                try {
                  e.parentNode.removeChild(e);
                } catch (t) {
                  e.remove();
                }
              },
              bt = function (e, t) {
                try {
                  p(n.removed, {
                    attribute: t.getAttributeNode(e),
                    from: t
                  });
                } catch (e) {
                  p(n.removed, {
                    attribute: null,
                    from: t
                  });
                }
                if (t.removeAttribute(e), "is" === e && !xe[e]) if (Me || Re) try {
                  yt(t);
                } catch (e) {} else try {
                  t.setAttribute(e, "");
                } catch (e) {}
              },
              wt = function (e) {
                let t = null,
                  n = null;
                if (Fe) e = "<remove></remove>" + e;else {
                  const t = m(e, /^[\r\n\t ]+/);
                  n = t && t[0];
                }
                "application/xhtml+xml" === rt && Je === Qe && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                const o = ne ? ne.createHTML(e) : e;
                if (Je === Qe) try {
                  t = new K().parseFromString(o, rt);
                } catch (e) {}
                if (!t || !t.documentElement) {
                  t = oe.createDocument(Je, "template", null);
                  try {
                    t.documentElement.innerHTML = et ? re : o;
                  } catch (e) {}
                }
                const i = t.body || t.documentElement;
                return e && n && i.insertBefore(r.createTextNode(n), i.childNodes[0] || null), Je === Qe ? se.call(t, Oe ? "html" : "body")[0] : Oe ? t.documentElement : i;
              },
              xt = function (e) {
                return ie.call(e.ownerDocument || e, e, _.SHOW_ELEMENT | _.SHOW_COMMENT | _.SHOW_TEXT | _.SHOW_PROCESSING_INSTRUCTION | _.SHOW_CDATA_SECTION, null);
              },
              Dt = function (e) {
                return e instanceof V && (void 0 !== e.__depth && "number" != typeof e.__depth || void 0 !== e.__removalCount && "number" != typeof e.__removalCount || "string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof L) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
              },
              Ct = function (e) {
                return "function" == typeof C && e instanceof C;
              },
              St = function (e, t, r) {
                ue[e] && c(ue[e], e => {
                  e.call(n, t, r, st);
                });
              },
              Et = function (e) {
                let t = null;
                if (St("beforeSanitizeElements", e, null), Dt(e)) return yt(e), !0;
                const r = at(e.nodeName);
                if (St("uponSanitizeElement", e, {
                  tagName: r,
                  allowedTags: be
                }), e.hasChildNodes() && !Ct(e.firstElementChild) && w(/<[/\w]/g, e.innerHTML) && w(/<[/\w]/g, e.textContent)) return yt(e), !0;
                if (e.nodeType === X.progressingInstruction) return yt(e), !0;
                if (Te && e.nodeType === X.comment && w(/<[/\w]/g, e.data)) return yt(e), !0;
                if (!be[r] || Se[r]) {
                  if (!Se[r] && Pt(r)) {
                    if (Ce.tagNameCheck instanceof RegExp && w(Ce.tagNameCheck, r)) return !1;
                    if (Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(r)) return !1;
                  }
                  if (Ve && !He[r]) {
                    const t = te(e) || e.parentNode,
                      n = W(e) || e.childNodes;
                    if (n && t) for (let r = n.length - 1; r >= 0; --r) {
                      const o = Z(n[r], !0);
                      o.__removalCount = (e.__removalCount || 0) + 1, t.insertBefore(o, $(e));
                    }
                  }
                  return yt(e), !0;
                }
                return e instanceof S && !vt(e) ? (yt(e), !0) : "noscript" !== r && "noembed" !== r && "noframes" !== r || !w(/<\/no(script|embed|frames)/i, e.innerHTML) ? (ze && e.nodeType === X.text && (t = e.textContent, c([ce, de, pe], e => {
                  t = g(t, e, " ");
                }), e.textContent !== t && (p(n.removed, {
                  element: e.cloneNode()
                }), e.textContent = t)), St("afterSanitizeElements", e, null), !1) : (yt(e), !0);
              },
              _t = function (e, t, n) {
                if (Be && ("id" === t || "name" === t) && (n in r || n in ut || "__depth" === n || "__removalCount" === n)) return !1;
                if (Pe && !Ee[t] && w(he, t)) ;else if (_e && w(fe, t)) ;else if (!xe[t] || Ee[t]) {
                  if (!(Pt(e) && (Ce.tagNameCheck instanceof RegExp && w(Ce.tagNameCheck, e) || Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(e)) && (Ce.attributeNameCheck instanceof RegExp && w(Ce.attributeNameCheck, t) || Ce.attributeNameCheck instanceof Function && Ce.attributeNameCheck(t)) || "is" === t && Ce.allowCustomizedBuiltInElements && (Ce.tagNameCheck instanceof RegExp && w(Ce.tagNameCheck, n) || Ce.tagNameCheck instanceof Function && Ce.tagNameCheck(n)))) return !1;
                } else if (Ge[t]) ;else if (w(ye, g(n, ge, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(n, "data:") || !Ze[e]) if (ke && !w(me, g(n, ge, ""))) ;else if (n) return !1;
                return !0;
              },
              Pt = function (e) {
                return "annotation-xml" !== e && m(e, ve);
              },
              kt = function (e) {
                St("beforeSanitizeAttributes", e, null);
                const {
                  attributes: t
                } = e;
                if (!t) return;
                const r = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: xe
                };
                let o = t.length;
                for (; o--;) {
                  const i = t[o],
                    {
                      name: a,
                      namespaceURI: s,
                      value: l
                    } = i,
                    u = at(a);
                  let p = "value" === a ? l : y(l);
                  if (r.attrName = u, r.attrValue = p, r.keepAttr = !0, r.forceKeepAttr = void 0, St("uponSanitizeAttribute", e, r), p = r.attrValue, r.forceKeepAttr) continue;
                  if (bt(a, e), !r.keepAttr) continue;
                  if (!Ae && w(/\/>/i, p)) {
                    bt(a, e);
                    continue;
                  }
                  if (Te && w(/((--!?|])>)|<\/(style|title)/i, p)) {
                    bt(a, e);
                    continue;
                  }
                  ze && c([ce, de, pe], e => {
                    p = g(p, e, " ");
                  });
                  const h = at(e.nodeName);
                  if (_t(h, u, p)) {
                    if (!Ne || "id" !== u && "name" !== u || (bt(a, e), p = Le + p), ne && "object" == typeof q && "function" == typeof q.getAttributeType) if (s) ;else switch (q.getAttributeType(h, u)) {
                      case "TrustedHTML":
                        p = ne.createHTML(p);
                        break;
                      case "TrustedScriptURL":
                        p = ne.createScriptURL(p);
                    }
                    try {
                      s ? e.setAttributeNS(s, a, p) : e.setAttribute(a, p), Dt(e) ? yt(e) : d(n.removed);
                    } catch (e) {}
                  }
                }
                St("afterSanitizeAttributes", e, null);
              },
              At = function e(t) {
                let n = null;
                const r = xt(t);
                for (St("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) {
                  if (St("uponSanitizeShadowNode", n, null), Et(n)) continue;
                  const t = te(n);
                  n.nodeType === X.element && (t && t.__depth ? n.__depth = (n.__removalCount || 0) + t.__depth + 1 : n.__depth = 1), (n.__depth >= lt || n.__depth < 0 || D(n.__depth)) && yt(n), n.content instanceof l && (n.content.__depth = n.__depth, e(n.content)), kt(n);
                }
                St("afterSanitizeShadowDOM", t, null);
              };
            return n.sanitize = function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = null,
                i = null,
                a = null,
                s = null;
              if (et = !e, et && (e = "\x3c!--\x3e"), "string" != typeof e && !Ct(e)) {
                if ("function" != typeof e.toString) throw x("toString is not a function");
                if ("string" != typeof (e = e.toString())) throw x("dirty is not a string, aborting");
              }
              if (!n.isSupported) return e;
              if (Ie || dt(t), n.removed = [], "string" == typeof e && (Ke = !1), Ke) {
                if (e.nodeName) {
                  const t = at(e.nodeName);
                  if (!be[t] || Se[t]) throw x("root node is forbidden and cannot be sanitized in-place");
                }
              } else if (e instanceof C) r = wt("\x3c!----\x3e"), i = r.ownerDocument.importNode(e, !0), i.nodeType === X.element && "BODY" === i.nodeName || "HTML" === i.nodeName ? r = i : r.appendChild(i);else {
                if (!Me && !ze && !Oe && -1 === e.indexOf("<")) return ne && je ? ne.createHTML(e) : e;
                if (r = wt(e), !r) return Me ? null : je ? re : "";
              }
              r && Fe && yt(r.firstChild);
              const u = xt(Ke ? e : r);
              for (; a = u.nextNode();) {
                if (Et(a)) continue;
                const e = te(a);
                a.nodeType === X.element && (e && e.__depth ? a.__depth = (a.__removalCount || 0) + e.__depth + 1 : a.__depth = 1), (a.__depth >= lt || a.__depth < 0 || D(a.__depth)) && yt(a), a.content instanceof l && (a.content.__depth = a.__depth, At(a.content)), kt(a);
              }
              if (Ke) return e;
              if (Me) {
                if (Re) for (s = ae.call(r.ownerDocument); r.firstChild;) s.appendChild(r.firstChild);else s = r;
                return (xe.shadowroot || xe.shadowrootmode) && (s = le.call(o, s, !0)), s;
              }
              let d = Oe ? r.outerHTML : r.innerHTML;
              return Oe && be["!doctype"] && r.ownerDocument && r.ownerDocument.doctype && r.ownerDocument.doctype.name && w(G, r.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + r.ownerDocument.doctype.name + ">\n" + d), ze && c([ce, de, pe], e => {
                d = g(d, e, " ");
              }), ne && je ? ne.createHTML(d) : d;
            }, n.setConfig = function () {
              dt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), Ie = !0;
            }, n.clearConfig = function () {
              st = null, Ie = !1;
            }, n.isValidAttribute = function (e, t, n) {
              st || dt({});
              const r = at(e),
                o = at(t);
              return _t(r, o, n);
            }, n.addHook = function (e, t) {
              "function" == typeof t && (ue[e] = ue[e] || [], p(ue[e], t));
            }, n.removeHook = function (e) {
              if (ue[e]) return d(ue[e]);
            }, n.removeHooks = function (e) {
              ue[e] && (ue[e] = []);
            }, n.removeAllHooks = function () {
              ue = {};
            }, n;
          }
          return ee();
        }();
      },
      41473: (e, t, n) => {
        "use strict";

        n.d(t, {
          CN: () => i
        });
        n(2278);
        new Map();
        new Map();
        const r = ["hours", "minutes", "seconds"];
        let o = new Map();
        class i {
          format(e) {
            return this.formatter.format(e);
          }
          formatToParts(e) {
            return this.formatter.formatToParts(e);
          }
          formatRange(e, t) {
            if ("function" == typeof this.formatter.formatRange) return this.formatter.formatRange(e, t);
            if (t < e) throw new RangeError("End date must be >= start date");
            return `${this.formatter.format(e)} – ${this.formatter.format(t)}`;
          }
          formatRangeToParts(e, t) {
            if ("function" == typeof this.formatter.formatRangeToParts) return this.formatter.formatRangeToParts(e, t);
            if (t < e) throw new RangeError("End date must be >= start date");
            let n = this.formatter.formatToParts(e),
              r = this.formatter.formatToParts(t);
            return [...n.map(e => ({
              ...e,
              source: "startRange"
            })), {
              type: "literal",
              value: " – ",
              source: "shared"
            }, ...r.map(e => ({
              ...e,
              source: "endRange"
            }))];
          }
          resolvedOptions() {
            let e = this.formatter.resolvedOptions();
            return function () {
              null == u && (u = "h12" === new Intl.DateTimeFormat("fr", {
                hour: "numeric",
                hour12: !1
              }).resolvedOptions().hourCycle);
              return u;
            }() && (this.resolvedHourCycle || (this.resolvedHourCycle = function (e, t) {
              if (!t.timeStyle && !t.hour) return;
              e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, "");
              let n = s(e += (e.includes("-u-") ? "" : "-u") + "-nu-latn", {
                  ...t,
                  timeZone: void 0
                }),
                r = parseInt(n.formatToParts(new Date(2020, 2, 3, 0)).find(e => "hour" === e.type).value, 10),
                o = parseInt(n.formatToParts(new Date(2020, 2, 3, 23)).find(e => "hour" === e.type).value, 10);
              if (0 === r && 23 === o) return "h23";
              if (24 === r && 23 === o) return "h24";
              if (0 === r && 11 === o) return "h11";
              if (12 === r && 11 === o) return "h12";
              throw new Error("Unexpected hour cycle result");
            }(e.locale, this.options)), e.hourCycle = this.resolvedHourCycle, e.hour12 = "h11" === this.resolvedHourCycle || "h12" === this.resolvedHourCycle), "ethiopic-amete-alem" === e.calendar && (e.calendar = "ethioaa"), e;
          }
          constructor(e, t = {}) {
            this.formatter = s(e, t), this.options = t;
          }
        }
        const a = {
          true: {
            ja: "h11"
          },
          false: {}
        };
        function s(e, t = {}) {
          if ("boolean" == typeof t.hour12 && function () {
            null == l && (l = "24" === new Intl.DateTimeFormat("en-US", {
              hour: "numeric",
              hour12: !1
            }).format(new Date(2020, 2, 3, 0)));
            return l;
          }()) {
            t = {
              ...t
            };
            let n = a[String(t.hour12)][e.split("-")[0]],
              r = t.hour12 ? "h12" : "h23";
            t.hourCycle = null != n ? n : r, delete t.hour12;
          }
          let n = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
          if (o.has(n)) return o.get(n);
          let r = new Intl.DateTimeFormat(e, t);
          return o.set(n, r), r;
        }
        let l = null;
        let u = null;
      },
      96041: (e, t, n) => {
        "use strict";

        n.d(t, {
          d: () => c,
          e: () => s
        });
        let r = new Map(),
          o = !1;
        try {
          o = "exceptZero" === new Intl.NumberFormat("de-DE", {
            signDisplay: "exceptZero"
          }).resolvedOptions().signDisplay;
        } catch (e) {}
        let i = !1;
        try {
          i = "unit" === new Intl.NumberFormat("de-DE", {
            style: "unit",
            unit: "degree"
          }).resolvedOptions().style;
        } catch (e) {}
        const a = {
          degree: {
            narrow: {
              default: "°",
              "ja-JP": " 度",
              "zh-TW": "度",
              "sl-SI": " °"
            }
          }
        };
        class s {
          format(e) {
            let t = "";
            if (t = o || null == this.options.signDisplay ? this.numberFormatter.format(e) : function (e, t, n) {
              if ("auto" === t) return e.format(n);
              if ("never" === t) return e.format(Math.abs(n));
              {
                let r = !1;
                if ("always" === t ? r = n > 0 || Object.is(n, 0) : "exceptZero" === t && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
                  let t = e.format(-n),
                    r = e.format(n),
                    o = t.replace(r, "").replace(/\u200e|\u061C/, "");
                  return 1 !== [...o].length && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), t.replace(r, "!!!").replace(o, "+").replace("!!!", r);
                }
                return e.format(n);
              }
            }(this.numberFormatter, this.options.signDisplay, e), "unit" === this.options.style && !i) {
              var n;
              let {
                unit: e,
                unitDisplay: r = "short",
                locale: o
              } = this.resolvedOptions();
              if (!e) return t;
              let i = null === (n = a[e]) || void 0 === n ? void 0 : n[r];
              t += i[o] || i.default;
            }
            return t;
          }
          formatToParts(e) {
            return this.numberFormatter.formatToParts(e);
          }
          formatRange(e, t) {
            if ("function" == typeof this.numberFormatter.formatRange) return this.numberFormatter.formatRange(e, t);
            if (t < e) throw new RangeError("End date must be >= start date");
            return `${this.format(e)} – ${this.format(t)}`;
          }
          formatRangeToParts(e, t) {
            if ("function" == typeof this.numberFormatter.formatRangeToParts) return this.numberFormatter.formatRangeToParts(e, t);
            if (t < e) throw new RangeError("End date must be >= start date");
            let n = this.numberFormatter.formatToParts(e),
              r = this.numberFormatter.formatToParts(t);
            return [...n.map(e => ({
              ...e,
              source: "startRange"
            })), {
              type: "literal",
              value: " – ",
              source: "shared"
            }, ...r.map(e => ({
              ...e,
              source: "endRange"
            }))];
          }
          resolvedOptions() {
            let e = this.numberFormatter.resolvedOptions();
            return o || null == this.options.signDisplay || (e = {
              ...e,
              signDisplay: this.options.signDisplay
            }), i || "unit" !== this.options.style || (e = {
              ...e,
              style: "unit",
              unit: this.options.unit,
              unitDisplay: this.options.unitDisplay
            }), e;
          }
          constructor(e, t = {}) {
            this.numberFormatter = function (e, t = {}) {
              let {
                numberingSystem: n
              } = t;
              n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`);
              if ("unit" === t.style && !i) {
                var o;
                let {
                  unit: e,
                  unitDisplay: n = "short"
                } = t;
                if (!e) throw new Error('unit option must be provided with style: "unit"');
                if (!(null === (o = a[e]) || void 0 === o ? void 0 : o[n])) throw new Error(`Unsupported unit ${e} with unitDisplay = ${n}`);
                t = {
                  ...t,
                  style: "decimal"
                };
              }
              let s = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
              if (r.has(s)) return r.get(s);
              let l = new Intl.NumberFormat(e, t);
              return r.set(s, l), l;
            }(e, t), this.options = t;
          }
        }
        const l = new RegExp("^.*\\(.*\\).*$"),
          u = ["latn", "arab", "hanidec"];
        class c {
          parse(e) {
            return p(this.locale, this.options, e).parse(e);
          }
          isValidPartialNumber(e, t, n) {
            return p(this.locale, this.options, e).isValidPartialNumber(e, t, n);
          }
          getNumberingSystem(e) {
            return p(this.locale, this.options, e).options.numberingSystem;
          }
          constructor(e, t = {}) {
            this.locale = e, this.options = t;
          }
        }
        const d = new Map();
        function p(e, t, n) {
          let r = h(e, t);
          if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) for (let o of u) if (o !== r.options.numberingSystem) {
            let r = h(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + o, t);
            if (r.isValidPartialNumber(n)) return r;
          }
          return r;
        }
        function h(e, t) {
          let n = e + (t ? Object.entries(t).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : ""),
            r = d.get(n);
          return r || (r = new f(e, t), d.set(n, r)), r;
        }
        class f {
          parse(e) {
            let t = this.sanitize(e);
            if (this.symbols.group && (t = v(t, this.symbols.group, "")), this.symbols.decimal && (t = t.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (t = t.replace(this.symbols.minusSign, "-")), t = t.replace(this.symbols.numeral, this.symbols.index), "percent" === this.options.style) {
              let e = t.indexOf("-");
              t = t.replace("-", "");
              let n = t.indexOf(".");
              -1 === n && (n = t.length), t = t.replace(".", ""), t = n - 2 == 0 ? `0.${t}` : n - 2 == -1 ? `0.0${t}` : n - 2 == -2 ? "0.00" : `${t.slice(0, n - 2)}.${t.slice(n - 2)}`, e > -1 && (t = `-${t}`);
            }
            let n = t ? +t : NaN;
            if (isNaN(n)) return NaN;
            if ("percent" === this.options.style) {
              let e = {
                ...this.options,
                style: "decimal",
                minimumFractionDigits: Math.min(this.options.minimumFractionDigits + 2, 20),
                maximumFractionDigits: Math.min(this.options.maximumFractionDigits + 2, 20)
              };
              return new c(this.locale, e).parse(new s(this.locale, e).format(n));
            }
            return "accounting" === this.options.currencySign && l.test(e) && (n *= -1), n;
          }
          sanitize(e) {
            return e = e.replace(this.symbols.literals, ""), this.symbols.minusSign && (e = e.replace("-", this.symbols.minusSign)), "arab" === this.options.numberingSystem && (this.symbols.decimal && (e = (e = e.replace(",", this.symbols.decimal)).replace(String.fromCharCode(1548), this.symbols.decimal)), this.symbols.group && (e = v(e, ".", this.symbols.group))), "fr-FR" === this.options.locale && (e = v(e, ".", String.fromCharCode(8239))), e;
          }
          isValidPartialNumber(e, t = -1 / 0, n = 1 / 0) {
            return e = this.sanitize(e), this.symbols.minusSign && e.startsWith(this.symbols.minusSign) && t < 0 ? e = e.slice(this.symbols.minusSign.length) : this.symbols.plusSign && e.startsWith(this.symbols.plusSign) && n > 0 && (e = e.slice(this.symbols.plusSign.length)), (!this.symbols.group || !e.startsWith(this.symbols.group)) && !(this.symbols.decimal && e.indexOf(this.symbols.decimal) > -1 && 0 === this.options.maximumFractionDigits) && (this.symbols.group && (e = v(e, this.symbols.group, "")), e = e.replace(this.symbols.numeral, ""), this.symbols.decimal && (e = e.replace(this.symbols.decimal, "")), 0 === e.length);
          }
          constructor(e, t = {}) {
            var n, r;
            this.locale = e, this.formatter = new Intl.NumberFormat(e, t), this.options = this.formatter.resolvedOptions(), this.symbols = function (e, t, n, r) {
              var o, i, a, s;
              let l = new Intl.NumberFormat(e, {
                  ...n,
                  minimumSignificantDigits: 1,
                  maximumSignificantDigits: 21
                }),
                u = l.formatToParts(-10000.111),
                c = l.formatToParts(10000.111),
                d = g.map(e => l.formatToParts(e));
              var p;
              let h = null !== (p = null === (o = u.find(e => "minusSign" === e.type)) || void 0 === o ? void 0 : o.value) && void 0 !== p ? p : "-",
                f = null === (i = c.find(e => "plusSign" === e.type)) || void 0 === i ? void 0 : i.value;
              f || "exceptZero" !== (null == r ? void 0 : r.signDisplay) && "always" !== (null == r ? void 0 : r.signDisplay) || (f = "+");
              let v = new Intl.NumberFormat(e, {
                  ...n,
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }).formatToParts(.001),
                b = null === (a = v.find(e => "decimal" === e.type)) || void 0 === a ? void 0 : a.value,
                w = null === (s = u.find(e => "group" === e.type)) || void 0 === s ? void 0 : s.value,
                x = u.filter(e => !m.has(e.type)).map(e => y(e.value)),
                D = d.flatMap(e => e.filter(e => !m.has(e.type)).map(e => y(e.value))),
                C = [...new Set([...x, ...D])].sort((e, t) => t.length - e.length),
                S = 0 === C.length ? new RegExp("[\\p{White_Space}]", "gu") : new RegExp(`${C.join("|")}|[\\p{White_Space}]`, "gu"),
                E = [...new Intl.NumberFormat(n.locale, {
                  useGrouping: !1
                }).format(9876543210)].reverse(),
                _ = new Map(E.map((e, t) => [e, t])),
                P = new RegExp(`[${E.join("")}]`, "g");
              return {
                minusSign: h,
                plusSign: f,
                decimal: b,
                group: w,
                literals: S,
                numeral: P,
                index: e => String(_.get(e))
              };
            }(e, this.formatter, this.options, t), "percent" === this.options.style && ((null !== (n = this.options.minimumFractionDigits) && void 0 !== n ? n : 0) > 18 || (null !== (r = this.options.maximumFractionDigits) && void 0 !== r ? r : 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
          }
        }
        const m = new Set(["decimal", "fraction", "integer", "minusSign", "plusSign", "group"]),
          g = [0, 4, 2, 1, 11, 20, 3, 7, 100, 21, .1, 1.1];
        function v(e, t, n) {
          return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
        }
        function y(e) {
          return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        }
      },
      46050: (e, t, n) => {
        "use strict";

        n.d(t, {
          E: () => u,
          J: () => a
        });
        const r = Symbol.for("react-aria.i18n.locale"),
          o = Symbol.for("react-aria.i18n.strings");
        let i;
        class a {
          getStringForLocale(e, t) {
            let n = this.getStringsForLocale(t)[e];
            if (!n) throw new Error(`Could not find intl message ${e} in ${t} locale`);
            return n;
          }
          getStringsForLocale(e) {
            let t = this.strings[e];
            return t || (t = function (e, t, n = "en-US") {
              if (t[e]) return t[e];
              let r = function (e) {
                return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
              }(e);
              if (t[r]) return t[r];
              for (let e in t) if (e.startsWith(r + "-")) return t[e];
              return t[n];
            }(e, this.strings, this.defaultLocale), this.strings[e] = t), t;
          }
          static getGlobalDictionaryForPackage(e) {
            if ("undefined" == typeof window) return null;
            let t = window[r];
            if (void 0 === i) {
              let e = window[o];
              if (!e) return null;
              i = {};
              for (let n in e) i[n] = new a({
                [t]: e[n]
              }, t);
            }
            let n = null == i ? void 0 : i[e];
            if (!n) throw new Error(`Strings for package "${e}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
            return n;
          }
          constructor(e, t = "en-US") {
            this.strings = {
              ...e
            }, this.defaultLocale = t;
          }
        }
        const s = new Map(),
          l = new Map();
        class u {
          format(e, t) {
            let n = this.strings.getStringForLocale(e, this.locale);
            return "function" == typeof n ? n(t, this) : n;
          }
          plural(e, t, n = "cardinal") {
            let r = t["=" + e];
            if (r) return "function" == typeof r ? r() : r;
            let o = this.locale + ":" + n,
              i = s.get(o);
            return i || (i = new Intl.PluralRules(this.locale, {
              type: n
            }), s.set(o, i)), r = t[i.select(e)] || t.other, "function" == typeof r ? r() : r;
          }
          number(e) {
            let t = l.get(this.locale);
            return t || (t = new Intl.NumberFormat(this.locale), l.set(this.locale, t)), t.format(e);
          }
          select(e, t) {
            let n = e[t] || e.other;
            return "function" == typeof n ? n() : n;
          }
          constructor(e, t) {
            this.locale = e, this.strings = t;
          }
        }
      },
      86254: (e, t, n) => {
        "use strict";

        n.d(t, {
          do: () => K
        });
        var r,
          o = [],
          i = "ResizeObserver loop completed with undelivered notifications.";
        !function (e) {
          e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
        }(r || (r = {}));
        var a,
          s = function (e) {
            return Object.freeze(e);
          },
          l = function (e, t) {
            this.inlineSize = e, this.blockSize = t, s(this);
          },
          u = function () {
            function e(e, t, n, r) {
              return this.x = e, this.y = t, this.width = n, this.height = r, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, s(this);
            }
            return e.prototype.toJSON = function () {
              var e = this;
              return {
                x: e.x,
                y: e.y,
                top: e.top,
                right: e.right,
                bottom: e.bottom,
                left: e.left,
                width: e.width,
                height: e.height
              };
            }, e.fromRect = function (t) {
              return new e(t.x, t.y, t.width, t.height);
            }, e;
          }(),
          c = function (e) {
            return e instanceof SVGElement && "getBBox" in e;
          },
          d = function (e) {
            if (c(e)) {
              var t = e.getBBox(),
                n = t.width,
                r = t.height;
              return !n && !r;
            }
            var o = e,
              i = o.offsetWidth,
              a = o.offsetHeight;
            return !(i || a || e.getClientRects().length);
          },
          p = function (e) {
            var t;
            if (e instanceof Element) return !0;
            var n = null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t ? void 0 : t.defaultView;
            return !!(n && e instanceof n.Element);
          },
          h = "undefined" != typeof window ? window : {},
          f = new WeakMap(),
          m = /auto|scroll/,
          g = /^tb|vertical/,
          v = /msie|trident/i.test(h.navigator && h.navigator.userAgent),
          y = function (e) {
            return parseFloat(e || "0");
          },
          b = function (e, t, n) {
            return void 0 === e && (e = 0), void 0 === t && (t = 0), void 0 === n && (n = !1), new l((n ? t : e) || 0, (n ? e : t) || 0);
          },
          w = s({
            devicePixelContentBoxSize: b(),
            borderBoxSize: b(),
            contentBoxSize: b(),
            contentRect: new u(0, 0, 0, 0)
          }),
          x = function (e, t) {
            if (void 0 === t && (t = !1), f.has(e) && !t) return f.get(e);
            if (d(e)) return f.set(e, w), w;
            var n = getComputedStyle(e),
              r = c(e) && e.ownerSVGElement && e.getBBox(),
              o = !v && "border-box" === n.boxSizing,
              i = g.test(n.writingMode || ""),
              a = !r && m.test(n.overflowY || ""),
              l = !r && m.test(n.overflowX || ""),
              p = r ? 0 : y(n.paddingTop),
              h = r ? 0 : y(n.paddingRight),
              x = r ? 0 : y(n.paddingBottom),
              D = r ? 0 : y(n.paddingLeft),
              C = r ? 0 : y(n.borderTopWidth),
              S = r ? 0 : y(n.borderRightWidth),
              E = r ? 0 : y(n.borderBottomWidth),
              _ = D + h,
              P = p + x,
              k = (r ? 0 : y(n.borderLeftWidth)) + S,
              A = C + E,
              z = l ? e.offsetHeight - A - e.clientHeight : 0,
              T = a ? e.offsetWidth - k - e.clientWidth : 0,
              O = o ? _ + k : 0,
              I = o ? P + A : 0,
              F = r ? r.width : y(n.width) - O - T,
              M = r ? r.height : y(n.height) - I - z,
              R = F + _ + T + k,
              j = M + P + z + A,
              B = s({
                devicePixelContentBoxSize: b(Math.round(F * devicePixelRatio), Math.round(M * devicePixelRatio), i),
                borderBoxSize: b(R, j, i),
                contentBoxSize: b(F, M, i),
                contentRect: new u(D, p, F, M)
              });
            return f.set(e, B), B;
          },
          D = function (e, t, n) {
            var o = x(e, n),
              i = o.borderBoxSize,
              a = o.contentBoxSize,
              s = o.devicePixelContentBoxSize;
            switch (t) {
              case r.DEVICE_PIXEL_CONTENT_BOX:
                return s;
              case r.BORDER_BOX:
                return i;
              default:
                return a;
            }
          },
          C = function (e) {
            var t = x(e);
            this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = s([t.borderBoxSize]), this.contentBoxSize = s([t.contentBoxSize]), this.devicePixelContentBoxSize = s([t.devicePixelContentBoxSize]);
          },
          S = function (e) {
            if (d(e)) return 1 / 0;
            for (var t = 0, n = e.parentNode; n;) t += 1, n = n.parentNode;
            return t;
          },
          E = function () {
            var e = 1 / 0,
              t = [];
            o.forEach(function (n) {
              if (0 !== n.activeTargets.length) {
                var r = [];
                n.activeTargets.forEach(function (t) {
                  var n = new C(t.target),
                    o = S(t.target);
                  r.push(n), t.lastReportedSize = D(t.target, t.observedBox), o < e && (e = o);
                }), t.push(function () {
                  n.callback.call(n.observer, r, n.observer);
                }), n.activeTargets.splice(0, n.activeTargets.length);
              }
            });
            for (var n = 0, r = t; n < r.length; n++) {
              (0, r[n])();
            }
            return e;
          },
          _ = function (e) {
            o.forEach(function (t) {
              t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (n) {
                n.isActive() && (S(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
              });
            });
          },
          P = function () {
            var e,
              t = 0;
            for (_(t); o.some(function (e) {
              return e.activeTargets.length > 0;
            });) t = E(), _(t);
            return o.some(function (e) {
              return e.skippedTargets.length > 0;
            }) && ("function" == typeof ErrorEvent ? e = new ErrorEvent("error", {
              message: i
            }) : ((e = document.createEvent("Event")).initEvent("error", !1, !1), e.message = i), window.dispatchEvent(e)), t > 0;
          },
          k = [],
          A = function (e) {
            if (!a) {
              var t = 0,
                n = document.createTextNode("");
              new MutationObserver(function () {
                return k.splice(0).forEach(function (e) {
                  return e();
                });
              }).observe(n, {
                characterData: !0
              }), a = function () {
                n.textContent = "".concat(t ? t-- : t++);
              };
            }
            k.push(e), a();
          },
          z = 0,
          T = {
            attributes: !0,
            characterData: !0,
            childList: !0,
            subtree: !0
          },
          O = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
          I = function (e) {
            return void 0 === e && (e = 0), Date.now() + e;
          },
          F = !1,
          M = new (function () {
            function e() {
              var e = this;
              this.stopped = !0, this.listener = function () {
                return e.schedule();
              };
            }
            return e.prototype.run = function (e) {
              var t = this;
              if (void 0 === e && (e = 250), !F) {
                F = !0;
                var n,
                  r = I(e);
                n = function () {
                  var n = !1;
                  try {
                    n = P();
                  } finally {
                    if (F = !1, e = r - I(), !z) return;
                    n ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
                  }
                }, A(function () {
                  requestAnimationFrame(n);
                });
              }
            }, e.prototype.schedule = function () {
              this.stop(), this.run();
            }, e.prototype.observe = function () {
              var e = this,
                t = function () {
                  return e.observer && e.observer.observe(document.body, T);
                };
              document.body ? t() : h.addEventListener("DOMContentLoaded", t);
            }, e.prototype.start = function () {
              var e = this;
              this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), O.forEach(function (t) {
                return h.addEventListener(t, e.listener, !0);
              }));
            }, e.prototype.stop = function () {
              var e = this;
              this.stopped || (this.observer && this.observer.disconnect(), O.forEach(function (t) {
                return h.removeEventListener(t, e.listener, !0);
              }), this.stopped = !0);
            }, e;
          }())(),
          R = function (e) {
            !z && e > 0 && M.start(), !(z += e) && M.stop();
          },
          j = function () {
            function e(e, t) {
              this.target = e, this.observedBox = t || r.CONTENT_BOX, this.lastReportedSize = {
                inlineSize: 0,
                blockSize: 0
              };
            }
            return e.prototype.isActive = function () {
              var e,
                t = D(this.target, this.observedBox, !0);
              return e = this.target, c(e) || function (e) {
                switch (e.tagName) {
                  case "INPUT":
                    if ("image" !== e.type) break;
                  case "VIDEO":
                  case "AUDIO":
                  case "EMBED":
                  case "OBJECT":
                  case "CANVAS":
                  case "IFRAME":
                  case "IMG":
                    return !0;
                }
                return !1;
              }(e) || "inline" !== getComputedStyle(e).display || (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
            }, e;
          }(),
          B = function (e, t) {
            this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
          },
          N = new WeakMap(),
          L = function (e, t) {
            for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
            return -1;
          },
          V = function () {
            function e() {}
            return e.connect = function (e, t) {
              var n = new B(e, t);
              N.set(e, n);
            }, e.observe = function (e, t, n) {
              var r = N.get(e),
                i = 0 === r.observationTargets.length;
              L(r.observationTargets, t) < 0 && (i && o.push(r), r.observationTargets.push(new j(t, n && n.box)), R(1), M.schedule());
            }, e.unobserve = function (e, t) {
              var n = N.get(e),
                r = L(n.observationTargets, t),
                i = 1 === n.observationTargets.length;
              r >= 0 && (i && o.splice(o.indexOf(n), 1), n.observationTargets.splice(r, 1), R(-1));
            }, e.disconnect = function (e) {
              var t = this,
                n = N.get(e);
              n.observationTargets.slice().forEach(function (n) {
                return t.unobserve(e, n.target);
              }), n.activeTargets.splice(0, n.activeTargets.length);
            }, e;
          }(),
          K = function () {
            function e(e) {
              if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
              if ("function" != typeof e) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
              V.connect(this, e);
            }
            return e.prototype.observe = function (e, t) {
              if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
              if (!p(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
              V.observe(this, e, t);
            }, e.prototype.unobserve = function (e) {
              if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
              if (!p(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
              V.unobserve(this, e);
            }, e.prototype.disconnect = function () {
              V.disconnect(this);
            }, e.toString = function () {
              return "function ResizeObserver () { [polyfill code] }";
            }, e;
          }();
      },
      88786: (e, t, n) => {
        "use strict";

        n.d(t, {
          E7: () => E,
          Fx: () => z,
          MT: () => c,
          QL: () => S,
          bO: () => d,
          cW: () => w,
          ex: () => a,
          kc: () => F,
          pu: () => M,
          tB: () => I
        });
        var r = n(20770),
          o = n(67294),
          i = n(49987);
        n(1410);
        function a(e) {
          const t = (0, r.k3)(e);
          if ("virtual" === (0, i.Jz)()) {
            let n = t.activeElement;
            (0, r.QB)(() => {
              t.activeElement === n && e.isConnected && (0, r.Ao)(e);
            });
          } else (0, r.Ao)(e);
        }
        function s(e, t) {
          return "#comment" !== e.nodeName && function (e) {
            const t = (0, r.kR)(e);
            if (!(e instanceof t.HTMLElement || e instanceof t.SVGElement)) return !1;
            let {
                display: n,
                visibility: o
              } = e.style,
              i = "none" !== n && "hidden" !== o && "collapse" !== o;
            if (i) {
              const {
                getComputedStyle: t
              } = e.ownerDocument.defaultView;
              let {
                display: n,
                visibility: r
              } = t(e);
              i = "none" !== n && "hidden" !== r && "collapse" !== r;
            }
            return i;
          }(e) && function (e, t) {
            return !e.hasAttribute("hidden") && ("DETAILS" !== e.nodeName || !t || "SUMMARY" === t.nodeName || e.hasAttribute("open"));
          }(e, t) && (!e.parentElement || s(e.parentElement, e));
        }
        const l = o.createContext(null);
        let u = null;
        function c(e) {
          let {
              children: t,
              contain: n,
              restoreFocus: i,
              autoFocus: a
            } = e,
            s = (0, o.useRef)(null),
            c = (0, o.useRef)(null),
            d = (0, o.useRef)([]),
            {
              parentNode: p
            } = (0, o.useContext)(l) || {},
            h = (0, o.useMemo)(() => new k({
              scopeRef: d
            }), [d]);
          (0, r.bt)(() => {
            let e = p || A.root;
            if (A.getTreeNode(e.scopeRef) && u && !x(u, e.scopeRef)) {
              let t = A.getTreeNode(u);
              t && (e = t);
            }
            e.addChild(h), A.addNode(h);
          }, [h, p]), (0, r.bt)(() => {
            let e = A.getTreeNode(d);
            e && (e.contain = !!n);
          }, [n]), (0, r.bt)(() => {
            var e;
            let t = null === (e = s.current) || void 0 === e ? void 0 : e.nextSibling,
              n = [];
            for (; t && t !== c.current;) n.push(t), t = t.nextSibling;
            d.current = n;
          }, [t]), function (e, t, n) {
            (0, r.bt)(() => {
              if (t || n) return;
              let o = e.current;
              const i = (0, r.k3)(o ? o[0] : void 0);
              let a = t => {
                let n = t.target;
                y(n, e.current) ? u = e : v(n) || (u = null);
              };
              return i.addEventListener("focusin", a, !1), null == o || o.forEach(e => e.addEventListener("focusin", a, !1)), () => {
                i.removeEventListener("focusin", a, !1), null == o || o.forEach(e => e.removeEventListener("focusin", a, !1));
              };
            }, [e, t, n]);
          }(d, i, n), function (e, t) {
            let n = (0, o.useRef)(),
              i = (0, o.useRef)();
            (0, r.bt)(() => {
              let o = e.current;
              if (!t) return void (i.current && (cancelAnimationFrame(i.current), i.current = void 0));
              const a = (0, r.k3)(o ? o[0] : void 0);
              let s = t => {
                  if ("Tab" !== t.key || t.altKey || t.ctrlKey || t.metaKey || !g(e) || t.isComposing) return;
                  let n = a.activeElement,
                    r = e.current;
                  if (!r || !y(n, r)) return;
                  let o = S(m(r), {
                    tabbable: !0
                  }, r);
                  if (!n) return;
                  o.currentNode = n;
                  let i = t.shiftKey ? o.previousNode() : o.nextNode();
                  i || (o.currentNode = t.shiftKey ? r[r.length - 1].nextElementSibling : r[0].previousElementSibling, i = t.shiftKey ? o.previousNode() : o.nextNode()), t.preventDefault(), i && D(i, !0);
                },
                l = t => {
                  u && !x(u, e) || !y(t.target, e.current) ? g(e) && !b(t.target, e) ? n.current ? n.current.focus() : u && u.current && C(u.current) : g(e) && (n.current = t.target) : (u = e, n.current = t.target);
                },
                c = t => {
                  i.current && cancelAnimationFrame(i.current), i.current = requestAnimationFrame(() => {
                    var o;
                    a.activeElement && g(e) && !b(a.activeElement, e) && (u = e, (0, r.Q5)(a).contains(t.target) ? (n.current = t.target, null === (o = n.current) || void 0 === o || o.focus()) : u.current && C(u.current));
                  });
                };
              return a.addEventListener("keydown", s, !1), a.addEventListener("focusin", l, !1), null == o || o.forEach(e => e.addEventListener("focusin", l, !1)), null == o || o.forEach(e => e.addEventListener("focusout", c, !1)), () => {
                a.removeEventListener("keydown", s, !1), a.removeEventListener("focusin", l, !1), null == o || o.forEach(e => e.removeEventListener("focusin", l, !1)), null == o || o.forEach(e => e.removeEventListener("focusout", c, !1));
              };
            }, [e, t]), (0, r.bt)(() => () => {
              i.current && cancelAnimationFrame(i.current);
            }, [i]);
          }(d, n), function (e, t, n) {
            const i = (0, o.useRef)("undefined" != typeof document ? (0, r.r3)(e.current ? e.current[0] : void 0).activeElement : null);
            (0, r.bt)(() => {
              let o = e.current;
              const i = (0, r.k3)(o ? o[0] : void 0);
              if (!t || n) return;
              let a = () => {
                u && !x(u, e) || !y(i.activeElement, e.current) || (u = e);
              };
              return i.addEventListener("focusin", a, !1), null == o || o.forEach(e => e.addEventListener("focusin", a, !1)), () => {
                i.removeEventListener("focusin", a, !1), null == o || o.forEach(e => e.removeEventListener("focusin", a, !1));
              };
            }, [e, n]), (0, r.bt)(() => {
              const o = (0, r.k3)(e.current ? e.current[0] : void 0);
              if (!t) return;
              let i = t => {
                if ("Tab" !== t.key || t.altKey || t.ctrlKey || t.metaKey || !g(e) || t.isComposing) return;
                let n = o.activeElement;
                if (!y(n, e.current)) return;
                let i = A.getTreeNode(e);
                if (!i) return;
                let a = i.nodeToRestore;
                const s = (0, r.Q5)(o);
                let l = S(s, {
                  tabbable: !0
                });
                l.currentNode = n;
                let u = t.shiftKey ? l.previousNode() : l.nextNode();
                if (a && s.contains(a) && a !== s || (a = void 0, i.nodeToRestore = void 0), (!u || !y(u, e.current)) && a) {
                  l.currentNode = a;
                  do {
                    u = t.shiftKey ? l.previousNode() : l.nextNode();
                  } while (y(u, e.current));
                  t.preventDefault(), t.stopPropagation(), u ? D(u, !0) : v(a) ? D(a, !0) : n.blur();
                }
              };
              return n || o.addEventListener("keydown", i, !0), () => {
                n || o.removeEventListener("keydown", i, !0);
              };
            }, [e, t, n]), (0, r.bt)(() => {
              const n = (0, r.k3)(e.current ? e.current[0] : void 0),
                o = (0, r.Q5)(n);
              if (!t) return;
              let a = A.getTreeNode(e);
              var s;
              return a ? (a.nodeToRestore = null !== (s = i.current) && void 0 !== s ? s : void 0, () => {
                let r = A.getTreeNode(e);
                if (!r) return;
                let i = r.nodeToRestore;
                if (t && i && (y(n.activeElement, e.current) || n.activeElement === o && function (e) {
                  let t = A.getTreeNode(u);
                  for (; t && t.scopeRef !== e;) {
                    if (t.nodeToRestore) return !1;
                    t = t.parent;
                  }
                  return (null == t ? void 0 : t.scopeRef) === e;
                }(e))) {
                  let t = A.clone();
                  requestAnimationFrame(() => {
                    if (n.activeElement === o) {
                      let n = t.getTreeNode(e);
                      for (; n;) {
                        if (n.nodeToRestore && n.nodeToRestore.isConnected) return void D(n.nodeToRestore);
                        n = n.parent;
                      }
                      for (n = t.getTreeNode(e); n;) {
                        if (n.scopeRef && n.scopeRef.current && A.getTreeNode(n.scopeRef)) return void C(n.scopeRef.current, !0);
                        n = n.parent;
                      }
                    }
                  });
                }
              }) : void 0;
            }, [e, t]);
          }(d, i, n), function (e, t) {
            const n = o.useRef(t);
            (0, o.useEffect)(() => {
              if (n.current) {
                u = e;
                !y((0, r.r3)(e.current ? e.current[0] : void 0).activeElement, u.current) && e.current && C(e.current);
              }
              n.current = !1;
            }, [e]);
          }(d, a), (0, o.useEffect)(() => {
            const e = (0, r.k3)(d.current ? d.current[0] : void 0).activeElement;
            let t = null;
            if (y(e, d.current)) {
              for (let n of A.traverse()) n.scopeRef && y(e, n.scopeRef.current) && (t = n);
              t === A.getTreeNode(d) && (u = t.scopeRef);
            }
          }, [d]), (0, r.bt)(() => () => {
            var e, t, n;
            let r = null !== (n = null === (t = A.getTreeNode(d)) || void 0 === t || null === (e = t.parent) || void 0 === e ? void 0 : e.scopeRef) && void 0 !== n ? n : null;
            d !== u && !x(d, u) || r && !A.getTreeNode(r) || (u = r), A.removeTreeNode(d);
          }, [d]);
          let f = (0, o.useMemo)(() => function (e) {
              return {
                focusNext(t = {}) {
                  let n = e.current,
                    {
                      from: o,
                      tabbable: i,
                      wrap: a,
                      accept: s
                    } = t,
                    l = o || (0, r.k3)(n[0]).activeElement,
                    u = n[0].previousElementSibling,
                    c = S(m(n), {
                      tabbable: i,
                      accept: s
                    }, n);
                  c.currentNode = y(l, n) ? l : u;
                  let d = c.nextNode();
                  return !d && a && (c.currentNode = u, d = c.nextNode()), d && D(d, !0), d;
                },
                focusPrevious(t = {}) {
                  let n = e.current,
                    {
                      from: o,
                      tabbable: i,
                      wrap: a,
                      accept: s
                    } = t,
                    l = o || (0, r.k3)(n[0]).activeElement,
                    u = n[n.length - 1].nextElementSibling,
                    c = S(m(n), {
                      tabbable: i,
                      accept: s
                    }, n);
                  c.currentNode = y(l, n) ? l : u;
                  let d = c.previousNode();
                  return !d && a && (c.currentNode = u, d = c.previousNode()), d && D(d, !0), d;
                },
                focusFirst(t = {}) {
                  let n = e.current,
                    {
                      tabbable: r,
                      accept: o
                    } = t,
                    i = S(m(n), {
                      tabbable: r,
                      accept: o
                    }, n);
                  i.currentNode = n[0].previousElementSibling;
                  let a = i.nextNode();
                  return a && D(a, !0), a;
                },
                focusLast(t = {}) {
                  let n = e.current,
                    {
                      tabbable: r,
                      accept: o
                    } = t,
                    i = S(m(n), {
                      tabbable: r,
                      accept: o
                    }, n);
                  i.currentNode = n[n.length - 1].nextElementSibling;
                  let a = i.previousNode();
                  return a && D(a, !0), a;
                }
              };
            }(d), []),
            w = (0, o.useMemo)(() => ({
              focusManager: f,
              parentNode: h
            }), [h, f]);
          return o.createElement(l.Provider, {
            value: w
          }, o.createElement("span", {
            "data-focus-scope-start": !0,
            hidden: !0,
            ref: s
          }), t, o.createElement("span", {
            "data-focus-scope-end": !0,
            hidden: !0,
            ref: c
          }));
        }
        function d() {
          var e;
          return null === (e = (0, o.useContext)(l)) || void 0 === e ? void 0 : e.focusManager;
        }
        const p = ["input:not([disabled]):not([type=hidden])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", "[contenteditable]"],
          h = p.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
        p.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
        const f = p.join(':not([hidden]):not([tabindex="-1"]),');
        function m(e) {
          return e[0].parentElement;
        }
        function g(e) {
          let t = A.getTreeNode(u);
          for (; t && t.scopeRef !== e;) {
            if (t.contain) return !1;
            t = t.parent;
          }
          return !0;
        }
        function v(e) {
          return b(e);
        }
        function y(e, t) {
          return !!e && !!t && t.some(t => t.contains(e));
        }
        function b(e, t = null) {
          if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
          for (let {
            scopeRef: n
          } of A.traverse(A.getTreeNode(t))) if (n && y(e, n.current)) return !0;
          return !1;
        }
        function w(e) {
          return b(e, u);
        }
        function x(e, t) {
          var n;
          let r = null === (n = A.getTreeNode(t)) || void 0 === n ? void 0 : n.parent;
          for (; r;) {
            if (r.scopeRef === e) return !0;
            r = r.parent;
          }
          return !1;
        }
        function D(e, t = !1) {
          if (null == e || t) {
            if (null != e) try {
              e.focus();
            } catch (e) {}
          } else try {
            a(e);
          } catch (e) {}
        }
        function C(e, t = !0) {
          let n = e[0].previousElementSibling,
            r = m(e),
            o = S(r, {
              tabbable: t
            }, e);
          o.currentNode = n;
          let i = o.nextNode();
          t && !i && (r = m(e), o = S(r, {
            tabbable: !1
          }, e), o.currentNode = n, i = o.nextNode()), D(i);
        }
        function S(e, t, n) {
          let o = (null == t ? void 0 : t.tabbable) ? f : h,
            i = e instanceof ShadowRoot ? e : (0, r.k3)(e),
            a = (i instanceof ShadowRoot ? i.ownerDocument : i).createTreeWalker(e || i, NodeFilter.SHOW_ELEMENT, {
              acceptNode(e) {
                var r;
                return (null == t || null === (r = t.from) || void 0 === r ? void 0 : r.contains(e)) ? NodeFilter.FILTER_REJECT : !e.matches(o) || !s(e) || n && !y(e, n) || (null == t ? void 0 : t.accept) && !t.accept(e) ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
              }
            });
          return (null == t ? void 0 : t.from) && (a.currentNode = t.from), a;
        }
        function E(e, t = {}) {
          return {
            focusNext(n = {}) {
              let o = e.current;
              if (!o) return null;
              let {
                  from: i,
                  tabbable: a = t.tabbable,
                  wrap: s = t.wrap,
                  accept: l = t.accept
                } = n,
                u = i || (0, r.k3)(o).activeElement,
                c = S(o, {
                  tabbable: a,
                  accept: l
                });
              o.contains(u) && (c.currentNode = u);
              let d = c.nextNode();
              return !d && s && (c.currentNode = o, d = c.nextNode()), d && D(d, !0), d;
            },
            focusPrevious(n = t) {
              let o = e.current;
              if (!o) return null;
              let {
                  from: i,
                  tabbable: a = t.tabbable,
                  wrap: s = t.wrap,
                  accept: l = t.accept
                } = n,
                u = i || (0, r.k3)(o).activeElement,
                c = S(o, {
                  tabbable: a,
                  accept: l
                });
              if (!o.contains(u)) {
                let e = _(c);
                return e && D(e, !0), null != e ? e : null;
              }
              c.currentNode = u;
              let d = c.previousNode();
              if (!d && s) {
                c.currentNode = o;
                let e = _(c);
                if (!e) return null;
                d = e;
              }
              return d && D(d, !0), null != d ? d : null;
            },
            focusFirst(n = t) {
              let r = e.current;
              if (!r) return null;
              let {
                  tabbable: o = t.tabbable,
                  accept: i = t.accept
                } = n,
                a = S(r, {
                  tabbable: o,
                  accept: i
                }).nextNode();
              return a && D(a, !0), a;
            },
            focusLast(n = t) {
              let r = e.current;
              if (!r) return null;
              let {
                  tabbable: o = t.tabbable,
                  accept: i = t.accept
                } = n,
                a = _(S(r, {
                  tabbable: o,
                  accept: i
                }));
              return a && D(a, !0), null != a ? a : null;
            }
          };
        }
        function _(e) {
          let t, n;
          do {
            n = e.lastChild(), n && (t = n);
          } while (n);
          return t;
        }
        class P {
          get size() {
            return this.fastMap.size;
          }
          getTreeNode(e) {
            return this.fastMap.get(e);
          }
          addTreeNode(e, t, n) {
            let r = this.fastMap.get(null != t ? t : null);
            if (!r) return;
            let o = new k({
              scopeRef: e
            });
            r.addChild(o), o.parent = r, this.fastMap.set(e, o), n && (o.nodeToRestore = n);
          }
          addNode(e) {
            this.fastMap.set(e.scopeRef, e);
          }
          removeTreeNode(e) {
            if (null === e) return;
            let t = this.fastMap.get(e);
            if (!t) return;
            let n = t.parent;
            for (let e of this.traverse()) e !== t && t.nodeToRestore && e.nodeToRestore && t.scopeRef && t.scopeRef.current && y(e.nodeToRestore, t.scopeRef.current) && (e.nodeToRestore = t.nodeToRestore);
            let r = t.children;
            n && (n.removeChild(t), r.size > 0 && r.forEach(e => n && n.addChild(e))), this.fastMap.delete(t.scopeRef);
          }
          *traverse(e = this.root) {
            if (null != e.scopeRef && (yield e), e.children.size > 0) for (let t of e.children) yield* this.traverse(t);
          }
          clone() {
            var e;
            let t = new P();
            var n;
            for (let r of this.traverse()) t.addTreeNode(r.scopeRef, null !== (n = null === (e = r.parent) || void 0 === e ? void 0 : e.scopeRef) && void 0 !== n ? n : null, r.nodeToRestore);
            return t;
          }
          constructor() {
            this.fastMap = new Map(), this.root = new k({
              scopeRef: null
            }), this.fastMap.set(null, this.root);
          }
        }
        class k {
          addChild(e) {
            this.children.add(e), e.parent = this;
          }
          removeChild(e) {
            this.children.delete(e), e.parent = void 0;
          }
          constructor(e) {
            this.children = new Set(), this.contain = !1, this.scopeRef = e.scopeRef;
          }
        }
        let A = new P();
        function z(e = {}) {
          let {
              autoFocus: t = !1,
              isTextInput: n,
              within: r
            } = e,
            a = (0, o.useRef)({
              isFocused: !1,
              isFocusVisible: t || (0, i.E)()
            }),
            [s, l] = (0, o.useState)(!1),
            [u, c] = (0, o.useState)(() => a.current.isFocused && a.current.isFocusVisible),
            d = (0, o.useCallback)(() => c(a.current.isFocused && a.current.isFocusVisible), []),
            p = (0, o.useCallback)(e => {
              a.current.isFocused = e, l(e), d();
            }, [d]);
          (0, i.mG)(e => {
            a.current.isFocusVisible = e, d();
          }, [], {
            isTextInput: n
          });
          let {
              focusProps: h
            } = (0, i.KK)({
              isDisabled: r,
              onFocusChange: p
            }),
            {
              focusWithinProps: f
            } = (0, i.L_)({
              isDisabled: !r,
              onFocusWithinChange: p
            });
          return {
            isFocused: s,
            isFocusVisible: u,
            focusProps: r ? f : h
          };
        }
        let T = o.createContext(null);
        function O(e, t) {
          let {
              children: n,
              ...i
            } = e,
            a = {
              ...i,
              ref: (0, r.B3)(t)
            };
          return o.createElement(T.Provider, {
            value: a
          }, n);
        }
        let I = o.forwardRef(O);
        function F(e, t) {
          let {
              focusProps: n
            } = (0, i.KK)(e),
            {
              keyboardProps: s
            } = (0, i.v5)(e),
            l = (0, r.dG)(n, s),
            u = function (e) {
              let t = (0, o.useContext)(T) || {};
              (0, r.lE)(t, e);
              let {
                ref: n,
                ...i
              } = t;
              return i;
            }(t),
            c = e.isDisabled ? {} : u,
            d = (0, o.useRef)(e.autoFocus);
          return (0, o.useEffect)(() => {
            d.current && t.current && a(t.current), d.current = !1;
          }, [t]), {
            focusableProps: (0, r.dG)({
              ...l,
              tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
            }, c)
          };
        }
        function M(e, t) {
          let n = null == t ? void 0 : t.isDisabled,
            [i, a] = (0, o.useState)(!1);
          return (0, r.bt)(() => {
            if ((null == e ? void 0 : e.current) && !n) {
              let t = () => {
                if (e.current) {
                  let t = S(e.current, {
                    tabbable: !0
                  });
                  a(!!t.nextNode());
                }
              };
              t();
              let n = new MutationObserver(t);
              return n.observe(e.current, {
                subtree: !0,
                childList: !0,
                attributes: !0,
                attributeFilter: ["tabIndex", "disabled"]
              }), () => {
                n.disconnect();
              };
            }
          }), !n && i;
        }
      },
      86838: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q: () => a
        });
        var r = n(67294),
          o = n(49987),
          i = n(20770);
        function a(e, t, n) {
          let {
            validationBehavior: a,
            focus: l
          } = e;
          (0, i.bt)(() => {
            if ("native" === a && (null == n ? void 0 : n.current)) {
              let r = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
              n.current.setCustomValidity(r), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation({
                isInvalid: !(e = n.current).validity.valid,
                validationDetails: s(e),
                validationErrors: e.validationMessage ? [e.validationMessage] : []
              });
            }
            var e;
          });
          let u = (0, i.iW)(() => {
              t.resetValidation();
            }),
            c = (0, i.iW)(e => {
              var r;
              t.displayValidation.isInvalid || t.commitValidation();
              let i = null == n || null === (r = n.current) || void 0 === r ? void 0 : r.form;
              var a;
              !e.defaultPrevented && n && i && function (e) {
                for (let t = 0; t < e.elements.length; t++) {
                  let n = e.elements[t];
                  if (!n.validity.valid) return n;
                }
                return null;
              }(i) === n.current && (l ? l() : null === (a = n.current) || void 0 === a || a.focus(), (0, o._w)("keyboard"));
              e.preventDefault();
            }),
            d = (0, i.iW)(() => {
              t.commitValidation();
            });
          (0, r.useEffect)(() => {
            let e = null == n ? void 0 : n.current;
            if (!e) return;
            let t = e.form;
            return e.addEventListener("invalid", c), e.addEventListener("change", d), null == t || t.addEventListener("reset", u), () => {
              e.removeEventListener("invalid", c), e.removeEventListener("change", d), null == t || t.removeEventListener("reset", u);
            };
          }, [n, c, d, u, a]);
        }
        function s(e) {
          let t = e.validity;
          return {
            badInput: t.badInput,
            customError: t.customError,
            patternMismatch: t.patternMismatch,
            rangeOverflow: t.rangeOverflow,
            rangeUnderflow: t.rangeUnderflow,
            stepMismatch: t.stepMismatch,
            tooLong: t.tooLong,
            tooShort: t.tooShort,
            typeMismatch: t.typeMismatch,
            valueMissing: t.valueMissing,
            valid: t.valid
          };
        }
      },
      18383: (e, t, n) => {
        "use strict";

        n.d(t, {
          bd: () => b,
          Xe: () => k,
          aQ: () => S,
          L0: () => A,
          bU: () => w,
          qb: () => C,
          hX: () => at,
          Ux: () => _
        });
        var r = n(67294),
          o = n(16021),
          i = n(46050),
          a = n(41473),
          s = n(20770),
          l = n(96041);
        const u = new Set(["Arab", "Syrc", "Samr", "Mand", "Thaa", "Mend", "Nkoo", "Adlm", "Rohg", "Hebr"]),
          c = new Set(["ae", "ar", "arc", "bcc", "bqi", "ckb", "dv", "fa", "glk", "he", "ku", "mzn", "nqo", "pnb", "ps", "sd", "ug", "ur", "yi"]);
        function d(e) {
          if (Intl.Locale) {
            let t = new Intl.Locale(e).maximize(),
              n = "function" == typeof t.getTextInfo ? t.getTextInfo() : t.textInfo;
            if (n) return "rtl" === n.direction;
            if (t.script) return u.has(t.script);
          }
          let t = e.split("-")[0];
          return c.has(t);
        }
        const p = Symbol.for("react-aria.i18n.locale");
        function h() {
          let e = "undefined" != typeof window && window[p] || "undefined" != typeof navigator && (navigator.language || navigator.userLanguage) || "en-US";
          try {
            Intl.DateTimeFormat.supportedLocalesOf([e]);
          } catch (t) {
            e = "en-US";
          }
          return {
            locale: e,
            direction: d(e) ? "rtl" : "ltr"
          };
        }
        let f = h(),
          m = new Set();
        function g() {
          f = h();
          for (let e of m) e(f);
        }
        function v() {
          let e = (0, o.Av)(),
            [t, n] = (0, r.useState)(f);
          return (0, r.useEffect)(() => (0 === m.size && window.addEventListener("languagechange", g), m.add(n), () => {
            m.delete(n), 0 === m.size && window.removeEventListener("languagechange", g);
          }), []), e ? {
            locale: "en-US",
            direction: "ltr"
          } : t;
        }
        const y = r.createContext(null);
        function b(e) {
          let {
              locale: t,
              children: n
            } = e,
            o = v(),
            i = t ? {
              locale: t,
              direction: d(t) ? "rtl" : "ltr"
            } : o;
          return r.createElement(y.Provider, {
            value: i
          }, n);
        }
        function w() {
          let e = v();
          return (0, r.useContext)(y) || e;
        }
        const x = new WeakMap();
        function D(e, t) {
          return t && i.J.getGlobalDictionaryForPackage(t) || function (e) {
            let t = x.get(e);
            return t || (t = new (0, i.J)(e), x.set(e, t)), t;
          }(e);
        }
        function C(e, t) {
          let {
              locale: n
            } = w(),
            o = D(e, t);
          return (0, r.useMemo)(() => new (0, i.E)(n, o), [n, o]);
        }
        function S(e) {
          e = (0, s.vE)(null != e ? e : {}, E);
          let {
            locale: t
          } = w();
          return (0, r.useMemo)(() => new (0, a.CN)(t, e), [t, e]);
        }
        function E(e, t) {
          if (e === t) return !0;
          let n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (let r of n) if (t[r] !== e[r]) return !1;
          return !0;
        }
        function _(e = {}) {
          let {
            locale: t
          } = w();
          return (0, r.useMemo)(() => new (0, l.e)(t, e), [t, e]);
        }
        let P = new Map();
        function k(e) {
          let {
              locale: t
            } = w(),
            n = t + (e ? Object.entries(e).sort((e, t) => e[0] < t[0] ? -1 : 1).join() : "");
          if (P.has(n)) return P.get(n);
          let r = new Intl.Collator(t, e);
          return P.set(n, r), r;
        }
        function A(e) {
          let t = k({
              usage: "search",
              ...e
            }),
            n = (0, r.useCallback)((e, n) => 0 === n.length || (e = e.normalize("NFC"), n = n.normalize("NFC"), 0 === t.compare(e.slice(0, n.length), n)), [t]),
            o = (0, r.useCallback)((e, n) => 0 === n.length || (e = e.normalize("NFC"), n = n.normalize("NFC"), 0 === t.compare(e.slice(-n.length), n)), [t]),
            i = (0, r.useCallback)((e, n) => {
              if (0 === n.length) return !0;
              e = e.normalize("NFC");
              let r = 0,
                o = (n = n.normalize("NFC")).length;
              for (; r + o <= e.length; r++) {
                let i = e.slice(r, r + o);
                if (0 === t.compare(n, i)) return !0;
              }
              return !1;
            }, [t]);
          return (0, r.useMemo)(() => ({
            startsWith: n,
            endsWith: o,
            contains: i
          }), [n, o, i]);
        }
        var z = function (e, t) {
          return z = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, z(e, t);
        };
        function T(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          z(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var O = function () {
          return O = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, O.apply(this, arguments);
        };
        Object.create;
        function I(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || Array.prototype.slice.call(t));
        }
        var F, M, R;
        Object.create;
        function j(e) {
          return e.type === M.literal;
        }
        function B(e) {
          return e.type === M.argument;
        }
        function N(e) {
          return e.type === M.number;
        }
        function L(e) {
          return e.type === M.date;
        }
        function V(e) {
          return e.type === M.time;
        }
        function K(e) {
          return e.type === M.select;
        }
        function q(e) {
          return e.type === M.plural;
        }
        function H(e) {
          return e.type === M.pound;
        }
        function U(e) {
          return e.type === M.tag;
        }
        function Z(e) {
          return !(!e || "object" != typeof e || e.type !== R.number);
        }
        function $(e) {
          return !(!e || "object" != typeof e || e.type !== R.dateTime);
        }
        !function (e) {
          e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
        }(F || (F = {})), function (e) {
          e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
        }(M || (M = {})), function (e) {
          e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
        }(R || (R = {}));
        var G = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
          W = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
        function Y(e) {
          var t = {};
          return e.replace(W, function (e) {
            var n = e.length;
            switch (e[0]) {
              case "G":
                t.era = 4 === n ? "long" : 5 === n ? "narrow" : "short";
                break;
              case "y":
                t.year = 2 === n ? "2-digit" : "numeric";
                break;
              case "Y":
              case "u":
              case "U":
              case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
              case "q":
              case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
              case "M":
              case "L":
                t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
                break;
              case "w":
              case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
              case "d":
                t.day = ["numeric", "2-digit"][n - 1];
                break;
              case "D":
              case "F":
              case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
              case "E":
                t.weekday = 4 === n ? "long" : 5 === n ? "narrow" : "short";
                break;
              case "e":
                if (n < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                t.weekday = ["short", "long", "narrow", "short"][n - 4];
                break;
              case "c":
                if (n < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                t.weekday = ["short", "long", "narrow", "short"][n - 4];
                break;
              case "a":
                t.hour12 = !0;
                break;
              case "b":
              case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
              case "h":
                t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "H":
                t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "K":
                t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "k":
                t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "j":
              case "J":
              case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
              case "m":
                t.minute = ["numeric", "2-digit"][n - 1];
                break;
              case "s":
                t.second = ["numeric", "2-digit"][n - 1];
                break;
              case "S":
              case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
              case "z":
                t.timeZoneName = n < 4 ? "short" : "long";
                break;
              case "Z":
              case "O":
              case "v":
              case "V":
              case "X":
              case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
            }
            return "";
          }), t;
        }
        var X = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
        var Q = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g,
          J = /^(@+)?(\+|#+)?[rs]?$/g,
          ee = /(\*)(0+)|(#+)(0+)|(0+)/g,
          te = /^(0+)$/;
        function ne(e) {
          var t = {};
          return "r" === e[e.length - 1] ? t.roundingPriority = "morePrecision" : "s" === e[e.length - 1] && (t.roundingPriority = "lessPrecision"), e.replace(J, function (e, n, r) {
            return "string" != typeof r ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : "+" === r ? t.minimumSignificantDigits = n.length : "#" === n[0] ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + ("string" == typeof r ? r.length : 0)), "";
          }), t;
        }
        function re(e) {
          switch (e) {
            case "sign-auto":
              return {
                signDisplay: "auto"
              };
            case "sign-accounting":
            case "()":
              return {
                currencySign: "accounting"
              };
            case "sign-always":
            case "+!":
              return {
                signDisplay: "always"
              };
            case "sign-accounting-always":
            case "()!":
              return {
                signDisplay: "always",
                currencySign: "accounting"
              };
            case "sign-except-zero":
            case "+?":
              return {
                signDisplay: "exceptZero"
              };
            case "sign-accounting-except-zero":
            case "()?":
              return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
              };
            case "sign-never":
            case "+_":
              return {
                signDisplay: "never"
              };
          }
        }
        function oe(e) {
          var t;
          if ("E" === e[0] && "E" === e[1] ? (t = {
            notation: "engineering"
          }, e = e.slice(2)) : "E" === e[0] && (t = {
            notation: "scientific"
          }, e = e.slice(1)), t) {
            var n = e.slice(0, 2);
            if ("+!" === n ? (t.signDisplay = "always", e = e.slice(2)) : "+?" === n && (t.signDisplay = "exceptZero", e = e.slice(2)), !te.test(e)) throw new Error("Malformed concise eng/scientific notation");
            t.minimumIntegerDigits = e.length;
          }
          return t;
        }
        function ie(e) {
          var t = re(e);
          return t || {};
        }
        function ae(e) {
          for (var t = {}, n = 0, r = e; n < r.length; n++) {
            var o = r[n];
            switch (o.stem) {
              case "percent":
              case "%":
                t.style = "percent";
                continue;
              case "%x100":
                t.style = "percent", t.scale = 100;
                continue;
              case "currency":
                t.style = "currency", t.currency = o.options[0];
                continue;
              case "group-off":
              case ",_":
                t.useGrouping = !1;
                continue;
              case "precision-integer":
              case ".":
                t.maximumFractionDigits = 0;
                continue;
              case "measure-unit":
              case "unit":
                t.style = "unit", t.unit = o.options[0].replace(/^(.*?)-/, "");
                continue;
              case "compact-short":
              case "K":
                t.notation = "compact", t.compactDisplay = "short";
                continue;
              case "compact-long":
              case "KK":
                t.notation = "compact", t.compactDisplay = "long";
                continue;
              case "scientific":
                t = O(O(O({}, t), {
                  notation: "scientific"
                }), o.options.reduce(function (e, t) {
                  return O(O({}, e), ie(t));
                }, {}));
                continue;
              case "engineering":
                t = O(O(O({}, t), {
                  notation: "engineering"
                }), o.options.reduce(function (e, t) {
                  return O(O({}, e), ie(t));
                }, {}));
                continue;
              case "notation-simple":
                t.notation = "standard";
                continue;
              case "unit-width-narrow":
                t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
                continue;
              case "unit-width-short":
                t.currencyDisplay = "code", t.unitDisplay = "short";
                continue;
              case "unit-width-full-name":
                t.currencyDisplay = "name", t.unitDisplay = "long";
                continue;
              case "unit-width-iso-code":
                t.currencyDisplay = "symbol";
                continue;
              case "scale":
                t.scale = parseFloat(o.options[0]);
                continue;
              case "integer-width":
                if (o.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                o.options[0].replace(ee, function (e, n, r, o, i, a) {
                  if (n) t.minimumIntegerDigits = r.length;else {
                    if (o && i) throw new Error("We currently do not support maximum integer digits");
                    if (a) throw new Error("We currently do not support exact integer digits");
                  }
                  return "";
                });
                continue;
            }
            if (te.test(o.stem)) t.minimumIntegerDigits = o.stem.length;else if (Q.test(o.stem)) {
              if (o.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
              o.stem.replace(Q, function (e, n, r, o, i, a) {
                return "*" === r ? t.minimumFractionDigits = n.length : o && "#" === o[0] ? t.maximumFractionDigits = o.length : i && a ? (t.minimumFractionDigits = i.length, t.maximumFractionDigits = i.length + a.length) : (t.minimumFractionDigits = n.length, t.maximumFractionDigits = n.length), "";
              });
              var i = o.options[0];
              "w" === i ? t = O(O({}, t), {
                trailingZeroDisplay: "stripIfInteger"
              }) : i && (t = O(O({}, t), ne(i)));
            } else if (J.test(o.stem)) t = O(O({}, t), ne(o.stem));else {
              var a = re(o.stem);
              a && (t = O(O({}, t), a));
              var s = oe(o.stem);
              s && (t = O(O({}, t), s));
            }
          }
          return t;
        }
        var se,
          le = {
            "001": ["H", "h"],
            AC: ["H", "h", "hb", "hB"],
            AD: ["H", "hB"],
            AE: ["h", "hB", "hb", "H"],
            AF: ["H", "hb", "hB", "h"],
            AG: ["h", "hb", "H", "hB"],
            AI: ["H", "h", "hb", "hB"],
            AL: ["h", "H", "hB"],
            AM: ["H", "hB"],
            AO: ["H", "hB"],
            AR: ["H", "h", "hB", "hb"],
            AS: ["h", "H"],
            AT: ["H", "hB"],
            AU: ["h", "hb", "H", "hB"],
            AW: ["H", "hB"],
            AX: ["H"],
            AZ: ["H", "hB", "h"],
            BA: ["H", "hB", "h"],
            BB: ["h", "hb", "H", "hB"],
            BD: ["h", "hB", "H"],
            BE: ["H", "hB"],
            BF: ["H", "hB"],
            BG: ["H", "hB", "h"],
            BH: ["h", "hB", "hb", "H"],
            BI: ["H", "h"],
            BJ: ["H", "hB"],
            BL: ["H", "hB"],
            BM: ["h", "hb", "H", "hB"],
            BN: ["hb", "hB", "h", "H"],
            BO: ["H", "hB", "h", "hb"],
            BQ: ["H"],
            BR: ["H", "hB"],
            BS: ["h", "hb", "H", "hB"],
            BT: ["h", "H"],
            BW: ["H", "h", "hb", "hB"],
            BY: ["H", "h"],
            BZ: ["H", "h", "hb", "hB"],
            CA: ["h", "hb", "H", "hB"],
            CC: ["H", "h", "hb", "hB"],
            CD: ["hB", "H"],
            CF: ["H", "h", "hB"],
            CG: ["H", "hB"],
            CH: ["H", "hB", "h"],
            CI: ["H", "hB"],
            CK: ["H", "h", "hb", "hB"],
            CL: ["H", "h", "hB", "hb"],
            CM: ["H", "h", "hB"],
            CN: ["H", "hB", "hb", "h"],
            CO: ["h", "H", "hB", "hb"],
            CP: ["H"],
            CR: ["H", "h", "hB", "hb"],
            CU: ["H", "h", "hB", "hb"],
            CV: ["H", "hB"],
            CW: ["H", "hB"],
            CX: ["H", "h", "hb", "hB"],
            CY: ["h", "H", "hb", "hB"],
            CZ: ["H"],
            DE: ["H", "hB"],
            DG: ["H", "h", "hb", "hB"],
            DJ: ["h", "H"],
            DK: ["H"],
            DM: ["h", "hb", "H", "hB"],
            DO: ["h", "H", "hB", "hb"],
            DZ: ["h", "hB", "hb", "H"],
            EA: ["H", "h", "hB", "hb"],
            EC: ["H", "hB", "h", "hb"],
            EE: ["H", "hB"],
            EG: ["h", "hB", "hb", "H"],
            EH: ["h", "hB", "hb", "H"],
            ER: ["h", "H"],
            ES: ["H", "hB", "h", "hb"],
            ET: ["hB", "hb", "h", "H"],
            FI: ["H"],
            FJ: ["h", "hb", "H", "hB"],
            FK: ["H", "h", "hb", "hB"],
            FM: ["h", "hb", "H", "hB"],
            FO: ["H", "h"],
            FR: ["H", "hB"],
            GA: ["H", "hB"],
            GB: ["H", "h", "hb", "hB"],
            GD: ["h", "hb", "H", "hB"],
            GE: ["H", "hB", "h"],
            GF: ["H", "hB"],
            GG: ["H", "h", "hb", "hB"],
            GH: ["h", "H"],
            GI: ["H", "h", "hb", "hB"],
            GL: ["H", "h"],
            GM: ["h", "hb", "H", "hB"],
            GN: ["H", "hB"],
            GP: ["H", "hB"],
            GQ: ["H", "hB", "h", "hb"],
            GR: ["h", "H", "hb", "hB"],
            GT: ["H", "h", "hB", "hb"],
            GU: ["h", "hb", "H", "hB"],
            GW: ["H", "hB"],
            GY: ["h", "hb", "H", "hB"],
            HK: ["h", "hB", "hb", "H"],
            HN: ["H", "h", "hB", "hb"],
            HR: ["H", "hB"],
            HU: ["H", "h"],
            IC: ["H", "h", "hB", "hb"],
            ID: ["H"],
            IE: ["H", "h", "hb", "hB"],
            IL: ["H", "hB"],
            IM: ["H", "h", "hb", "hB"],
            IN: ["h", "H"],
            IO: ["H", "h", "hb", "hB"],
            IQ: ["h", "hB", "hb", "H"],
            IR: ["hB", "H"],
            IS: ["H"],
            IT: ["H", "hB"],
            JE: ["H", "h", "hb", "hB"],
            JM: ["h", "hb", "H", "hB"],
            JO: ["h", "hB", "hb", "H"],
            JP: ["H", "K", "h"],
            KE: ["hB", "hb", "H", "h"],
            KG: ["H", "h", "hB", "hb"],
            KH: ["hB", "h", "H", "hb"],
            KI: ["h", "hb", "H", "hB"],
            KM: ["H", "h", "hB", "hb"],
            KN: ["h", "hb", "H", "hB"],
            KP: ["h", "H", "hB", "hb"],
            KR: ["h", "H", "hB", "hb"],
            KW: ["h", "hB", "hb", "H"],
            KY: ["h", "hb", "H", "hB"],
            KZ: ["H", "hB"],
            LA: ["H", "hb", "hB", "h"],
            LB: ["h", "hB", "hb", "H"],
            LC: ["h", "hb", "H", "hB"],
            LI: ["H", "hB", "h"],
            LK: ["H", "h", "hB", "hb"],
            LR: ["h", "hb", "H", "hB"],
            LS: ["h", "H"],
            LT: ["H", "h", "hb", "hB"],
            LU: ["H", "h", "hB"],
            LV: ["H", "hB", "hb", "h"],
            LY: ["h", "hB", "hb", "H"],
            MA: ["H", "h", "hB", "hb"],
            MC: ["H", "hB"],
            MD: ["H", "hB"],
            ME: ["H", "hB", "h"],
            MF: ["H", "hB"],
            MG: ["H", "h"],
            MH: ["h", "hb", "H", "hB"],
            MK: ["H", "h", "hb", "hB"],
            ML: ["H"],
            MM: ["hB", "hb", "H", "h"],
            MN: ["H", "h", "hb", "hB"],
            MO: ["h", "hB", "hb", "H"],
            MP: ["h", "hb", "H", "hB"],
            MQ: ["H", "hB"],
            MR: ["h", "hB", "hb", "H"],
            MS: ["H", "h", "hb", "hB"],
            MT: ["H", "h"],
            MU: ["H", "h"],
            MV: ["H", "h"],
            MW: ["h", "hb", "H", "hB"],
            MX: ["H", "h", "hB", "hb"],
            MY: ["hb", "hB", "h", "H"],
            MZ: ["H", "hB"],
            NA: ["h", "H", "hB", "hb"],
            NC: ["H", "hB"],
            NE: ["H"],
            NF: ["H", "h", "hb", "hB"],
            NG: ["H", "h", "hb", "hB"],
            NI: ["H", "h", "hB", "hb"],
            NL: ["H", "hB"],
            NO: ["H", "h"],
            NP: ["H", "h", "hB"],
            NR: ["H", "h", "hb", "hB"],
            NU: ["H", "h", "hb", "hB"],
            NZ: ["h", "hb", "H", "hB"],
            OM: ["h", "hB", "hb", "H"],
            PA: ["h", "H", "hB", "hb"],
            PE: ["H", "hB", "h", "hb"],
            PF: ["H", "h", "hB"],
            PG: ["h", "H"],
            PH: ["h", "hB", "hb", "H"],
            PK: ["h", "hB", "H"],
            PL: ["H", "h"],
            PM: ["H", "hB"],
            PN: ["H", "h", "hb", "hB"],
            PR: ["h", "H", "hB", "hb"],
            PS: ["h", "hB", "hb", "H"],
            PT: ["H", "hB"],
            PW: ["h", "H"],
            PY: ["H", "h", "hB", "hb"],
            QA: ["h", "hB", "hb", "H"],
            RE: ["H", "hB"],
            RO: ["H", "hB"],
            RS: ["H", "hB", "h"],
            RU: ["H"],
            RW: ["H", "h"],
            SA: ["h", "hB", "hb", "H"],
            SB: ["h", "hb", "H", "hB"],
            SC: ["H", "h", "hB"],
            SD: ["h", "hB", "hb", "H"],
            SE: ["H"],
            SG: ["h", "hb", "H", "hB"],
            SH: ["H", "h", "hb", "hB"],
            SI: ["H", "hB"],
            SJ: ["H"],
            SK: ["H"],
            SL: ["h", "hb", "H", "hB"],
            SM: ["H", "h", "hB"],
            SN: ["H", "h", "hB"],
            SO: ["h", "H"],
            SR: ["H", "hB"],
            SS: ["h", "hb", "H", "hB"],
            ST: ["H", "hB"],
            SV: ["H", "h", "hB", "hb"],
            SX: ["H", "h", "hb", "hB"],
            SY: ["h", "hB", "hb", "H"],
            SZ: ["h", "hb", "H", "hB"],
            TA: ["H", "h", "hb", "hB"],
            TC: ["h", "hb", "H", "hB"],
            TD: ["h", "H", "hB"],
            TF: ["H", "h", "hB"],
            TG: ["H", "hB"],
            TH: ["H", "h"],
            TJ: ["H", "h"],
            TL: ["H", "hB", "hb", "h"],
            TM: ["H", "h"],
            TN: ["h", "hB", "hb", "H"],
            TO: ["h", "H"],
            TR: ["H", "hB"],
            TT: ["h", "hb", "H", "hB"],
            TW: ["hB", "hb", "h", "H"],
            TZ: ["hB", "hb", "H", "h"],
            UA: ["H", "hB", "h"],
            UG: ["hB", "hb", "H", "h"],
            UM: ["h", "hb", "H", "hB"],
            US: ["h", "hb", "H", "hB"],
            UY: ["H", "h", "hB", "hb"],
            UZ: ["H", "hB", "h"],
            VA: ["H", "h", "hB"],
            VC: ["h", "hb", "H", "hB"],
            VE: ["h", "H", "hB", "hb"],
            VG: ["h", "hb", "H", "hB"],
            VI: ["h", "hb", "H", "hB"],
            VN: ["H", "h"],
            VU: ["h", "H"],
            WF: ["H", "hB"],
            WS: ["h", "H"],
            XK: ["H", "hB", "h"],
            YE: ["h", "hB", "hb", "H"],
            YT: ["H", "hB"],
            ZA: ["H", "h", "hb", "hB"],
            ZM: ["h", "hb", "H", "hB"],
            ZW: ["H", "h"],
            "af-ZA": ["H", "h", "hB", "hb"],
            "ar-001": ["h", "hB", "hb", "H"],
            "ca-ES": ["H", "h", "hB"],
            "en-001": ["h", "hb", "H", "hB"],
            "es-BO": ["H", "h", "hB", "hb"],
            "es-BR": ["H", "h", "hB", "hb"],
            "es-EC": ["H", "h", "hB", "hb"],
            "es-ES": ["H", "h", "hB", "hb"],
            "es-GQ": ["H", "h", "hB", "hb"],
            "es-PE": ["H", "h", "hB", "hb"],
            "fr-CA": ["H", "h", "hB"],
            "gl-ES": ["H", "h", "hB"],
            "gu-IN": ["hB", "hb", "h", "H"],
            "hi-IN": ["hB", "h", "H"],
            "it-CH": ["H", "h", "hB"],
            "it-IT": ["H", "h", "hB"],
            "kn-IN": ["hB", "h", "H"],
            "ml-IN": ["hB", "h", "H"],
            "mr-IN": ["hB", "hb", "h", "H"],
            "pa-IN": ["hB", "hb", "h", "H"],
            "ta-IN": ["hB", "h", "hb", "H"],
            "te-IN": ["hB", "h", "H"],
            "zu-ZA": ["H", "hB", "hb", "h"]
          };
        function ue(e) {
          var t = e.hourCycle;
          if (void 0 === t && e.hourCycles && e.hourCycles.length && (t = e.hourCycles[0]), t) switch (t) {
            case "h24":
              return "k";
            case "h23":
              return "H";
            case "h12":
              return "h";
            case "h11":
              return "K";
            default:
              throw new Error("Invalid hourCycle");
          }
          var n,
            r = e.language;
          return "root" !== r && (n = e.maximize().region), (le[n || ""] || le[r || ""] || le["".concat(r, "-001")] || le["001"])[0];
        }
        var ce = new RegExp("^".concat(G.source, "*")),
          de = new RegExp("".concat(G.source, "*$"));
        function pe(e, t) {
          return {
            start: e,
            end: t
          };
        }
        var he = !!String.prototype.startsWith && "_a".startsWith("a", 1),
          fe = !!String.fromCodePoint,
          me = !!Object.fromEntries,
          ge = !!String.prototype.codePointAt,
          ve = !!String.prototype.trimStart,
          ye = !!String.prototype.trimEnd,
          be = !!Number.isSafeInteger ? Number.isSafeInteger : function (e) {
            return "number" == typeof e && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
          },
          we = !0;
        try {
          we = "a" === (null === (se = ke("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu").exec("a")) || void 0 === se ? void 0 : se[0]);
        } catch (e) {
          we = !1;
        }
        var xe,
          De = he ? function (e, t, n) {
            return e.startsWith(t, n);
          } : function (e, t, n) {
            return e.slice(n, n + t.length) === t;
          },
          Ce = fe ? String.fromCodePoint : function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            for (var n, r = "", o = e.length, i = 0; o > i;) {
              if ((n = e[i++]) > 1114111) throw RangeError(n + " is not a valid code point");
              r += n < 65536 ? String.fromCharCode(n) : String.fromCharCode(55296 + ((n -= 65536) >> 10), n % 1024 + 56320);
            }
            return r;
          },
          Se = me ? Object.fromEntries : function (e) {
            for (var t = {}, n = 0, r = e; n < r.length; n++) {
              var o = r[n],
                i = o[0],
                a = o[1];
              t[i] = a;
            }
            return t;
          },
          Ee = ge ? function (e, t) {
            return e.codePointAt(t);
          } : function (e, t) {
            var n = e.length;
            if (!(t < 0 || t >= n)) {
              var r,
                o = e.charCodeAt(t);
              return o < 55296 || o > 56319 || t + 1 === n || (r = e.charCodeAt(t + 1)) < 56320 || r > 57343 ? o : r - 56320 + (o - 55296 << 10) + 65536;
            }
          },
          _e = ve ? function (e) {
            return e.trimStart();
          } : function (e) {
            return e.replace(ce, "");
          },
          Pe = ye ? function (e) {
            return e.trimEnd();
          } : function (e) {
            return e.replace(de, "");
          };
        function ke(e, t) {
          return new RegExp(e, t);
        }
        if (we) {
          var Ae = ke("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
          xe = function (e, t) {
            var n;
            return Ae.lastIndex = t, null !== (n = Ae.exec(e)[1]) && void 0 !== n ? n : "";
          };
        } else xe = function (e, t) {
          for (var n = [];;) {
            var r = Ee(e, t);
            if (void 0 === r || Oe(r) || Ie(r)) break;
            n.push(r), t += r >= 65536 ? 2 : 1;
          }
          return Ce.apply(void 0, n);
        };
        var ze = function () {
          function e(e, t) {
            void 0 === t && (t = {}), this.message = e, this.position = {
              offset: 0,
              line: 1,
              column: 1
            }, this.ignoreTag = !!t.ignoreTag, this.locale = t.locale, this.requiresOtherClause = !!t.requiresOtherClause, this.shouldParseSkeletons = !!t.shouldParseSkeletons;
          }
          return e.prototype.parse = function () {
            if (0 !== this.offset()) throw Error("parser can only be used once");
            return this.parseMessage(0, "", !1);
          }, e.prototype.parseMessage = function (e, t, n) {
            for (var r = []; !this.isEOF();) {
              var o = this.char();
              if (123 === o) {
                if ((i = this.parseArgument(e, n)).err) return i;
                r.push(i.val);
              } else {
                if (125 === o && e > 0) break;
                if (35 !== o || "plural" !== t && "selectordinal" !== t) {
                  if (60 === o && !this.ignoreTag && 47 === this.peek()) {
                    if (n) break;
                    return this.error(F.UNMATCHED_CLOSING_TAG, pe(this.clonePosition(), this.clonePosition()));
                  }
                  if (60 === o && !this.ignoreTag && Te(this.peek() || 0)) {
                    if ((i = this.parseTag(e, t)).err) return i;
                    r.push(i.val);
                  } else {
                    var i;
                    if ((i = this.parseLiteral(e, t)).err) return i;
                    r.push(i.val);
                  }
                } else {
                  var a = this.clonePosition();
                  this.bump(), r.push({
                    type: M.pound,
                    location: pe(a, this.clonePosition())
                  });
                }
              }
            }
            return {
              val: r,
              err: null
            };
          }, e.prototype.parseTag = function (e, t) {
            var n = this.clonePosition();
            this.bump();
            var r = this.parseTagName();
            if (this.bumpSpace(), this.bumpIf("/>")) return {
              val: {
                type: M.literal,
                value: "<".concat(r, "/>"),
                location: pe(n, this.clonePosition())
              },
              err: null
            };
            if (this.bumpIf(">")) {
              var o = this.parseMessage(e + 1, t, !0);
              if (o.err) return o;
              var i = o.val,
                a = this.clonePosition();
              if (this.bumpIf("</")) {
                if (this.isEOF() || !Te(this.char())) return this.error(F.INVALID_TAG, pe(a, this.clonePosition()));
                var s = this.clonePosition();
                return r !== this.parseTagName() ? this.error(F.UNMATCHED_CLOSING_TAG, pe(s, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
                  val: {
                    type: M.tag,
                    value: r,
                    children: i,
                    location: pe(n, this.clonePosition())
                  },
                  err: null
                } : this.error(F.INVALID_TAG, pe(a, this.clonePosition())));
              }
              return this.error(F.UNCLOSED_TAG, pe(n, this.clonePosition()));
            }
            return this.error(F.INVALID_TAG, pe(n, this.clonePosition()));
          }, e.prototype.parseTagName = function () {
            var e,
              t = this.offset();
            for (this.bump(); !this.isEOF() && (45 === (e = this.char()) || 46 === e || e >= 48 && e <= 57 || 95 === e || e >= 97 && e <= 122 || e >= 65 && e <= 90 || 183 == e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039);) this.bump();
            return this.message.slice(t, this.offset());
          }, e.prototype.parseLiteral = function (e, t) {
            for (var n = this.clonePosition(), r = "";;) {
              var o = this.tryParseQuote(t);
              if (o) r += o;else {
                var i = this.tryParseUnquoted(e, t);
                if (i) r += i;else {
                  var a = this.tryParseLeftAngleBracket();
                  if (!a) break;
                  r += a;
                }
              }
            }
            var s = pe(n, this.clonePosition());
            return {
              val: {
                type: M.literal,
                value: r,
                location: s
              },
              err: null
            };
          }, e.prototype.tryParseLeftAngleBracket = function () {
            return this.isEOF() || 60 !== this.char() || !this.ignoreTag && (Te(e = this.peek() || 0) || 47 === e) ? null : (this.bump(), "<");
            var e;
          }, e.prototype.tryParseQuote = function (e) {
            if (this.isEOF() || 39 !== this.char()) return null;
            switch (this.peek()) {
              case 39:
                return this.bump(), this.bump(), "'";
              case 123:
              case 60:
              case 62:
              case 125:
                break;
              case 35:
                if ("plural" === e || "selectordinal" === e) break;
                return null;
              default:
                return null;
            }
            this.bump();
            var t = [this.char()];
            for (this.bump(); !this.isEOF();) {
              var n = this.char();
              if (39 === n) {
                if (39 !== this.peek()) {
                  this.bump();
                  break;
                }
                t.push(39), this.bump();
              } else t.push(n);
              this.bump();
            }
            return Ce.apply(void 0, t);
          }, e.prototype.tryParseUnquoted = function (e, t) {
            if (this.isEOF()) return null;
            var n = this.char();
            return 60 === n || 123 === n || 35 === n && ("plural" === t || "selectordinal" === t) || 125 === n && e > 0 ? null : (this.bump(), Ce(n));
          }, e.prototype.parseArgument = function (e, t) {
            var n = this.clonePosition();
            if (this.bump(), this.bumpSpace(), this.isEOF()) return this.error(F.EXPECT_ARGUMENT_CLOSING_BRACE, pe(n, this.clonePosition()));
            if (125 === this.char()) return this.bump(), this.error(F.EMPTY_ARGUMENT, pe(n, this.clonePosition()));
            var r = this.parseIdentifierIfPossible().value;
            if (!r) return this.error(F.MALFORMED_ARGUMENT, pe(n, this.clonePosition()));
            if (this.bumpSpace(), this.isEOF()) return this.error(F.EXPECT_ARGUMENT_CLOSING_BRACE, pe(n, this.clonePosition()));
            switch (this.char()) {
              case 125:
                return this.bump(), {
                  val: {
                    type: M.argument,
                    value: r,
                    location: pe(n, this.clonePosition())
                  },
                  err: null
                };
              case 44:
                return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(F.EXPECT_ARGUMENT_CLOSING_BRACE, pe(n, this.clonePosition())) : this.parseArgumentOptions(e, t, r, n);
              default:
                return this.error(F.MALFORMED_ARGUMENT, pe(n, this.clonePosition()));
            }
          }, e.prototype.parseIdentifierIfPossible = function () {
            var e = this.clonePosition(),
              t = this.offset(),
              n = xe(this.message, t),
              r = t + n.length;
            return this.bumpTo(r), {
              value: n,
              location: pe(e, this.clonePosition())
            };
          }, e.prototype.parseArgumentOptions = function (e, t, n, r) {
            var o,
              i = this.clonePosition(),
              a = this.parseIdentifierIfPossible().value,
              s = this.clonePosition();
            switch (a) {
              case "":
                return this.error(F.EXPECT_ARGUMENT_TYPE, pe(i, s));
              case "number":
              case "date":
              case "time":
                this.bumpSpace();
                var l = null;
                if (this.bumpIf(",")) {
                  this.bumpSpace();
                  var u = this.clonePosition();
                  if ((v = this.parseSimpleArgStyleIfPossible()).err) return v;
                  if (0 === (h = Pe(v.val)).length) return this.error(F.EXPECT_ARGUMENT_STYLE, pe(this.clonePosition(), this.clonePosition()));
                  l = {
                    style: h,
                    styleLocation: pe(u, this.clonePosition())
                  };
                }
                if ((y = this.tryParseArgumentClose(r)).err) return y;
                var c = pe(r, this.clonePosition());
                if (l && De(null == l ? void 0 : l.style, "::", 0)) {
                  var d = _e(l.style.slice(2));
                  if ("number" === a) return (v = this.parseNumberSkeletonFromString(d, l.styleLocation)).err ? v : {
                    val: {
                      type: M.number,
                      value: n,
                      location: c,
                      style: v.val
                    },
                    err: null
                  };
                  if (0 === d.length) return this.error(F.EXPECT_DATE_TIME_SKELETON, c);
                  var p = d;
                  this.locale && (p = function (e, t) {
                    for (var n = "", r = 0; r < e.length; r++) {
                      var o = e.charAt(r);
                      if ("j" === o) {
                        for (var i = 0; r + 1 < e.length && e.charAt(r + 1) === o;) i++, r++;
                        var a = 1 + (1 & i),
                          s = i < 2 ? 1 : 3 + (i >> 1),
                          l = ue(t);
                        for ("H" != l && "k" != l || (s = 0); s-- > 0;) n += "a";
                        for (; a-- > 0;) n = l + n;
                      } else n += "J" === o ? "H" : o;
                    }
                    return n;
                  }(d, this.locale));
                  var h = {
                    type: R.dateTime,
                    pattern: p,
                    location: l.styleLocation,
                    parsedOptions: this.shouldParseSkeletons ? Y(p) : {}
                  };
                  return {
                    val: {
                      type: "date" === a ? M.date : M.time,
                      value: n,
                      location: c,
                      style: h
                    },
                    err: null
                  };
                }
                return {
                  val: {
                    type: "number" === a ? M.number : "date" === a ? M.date : M.time,
                    value: n,
                    location: c,
                    style: null !== (o = null == l ? void 0 : l.style) && void 0 !== o ? o : null
                  },
                  err: null
                };
              case "plural":
              case "selectordinal":
              case "select":
                var f = this.clonePosition();
                if (this.bumpSpace(), !this.bumpIf(",")) return this.error(F.EXPECT_SELECT_ARGUMENT_OPTIONS, pe(f, O({}, f)));
                this.bumpSpace();
                var m = this.parseIdentifierIfPossible(),
                  g = 0;
                if ("select" !== a && "offset" === m.value) {
                  if (!this.bumpIf(":")) return this.error(F.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, pe(this.clonePosition(), this.clonePosition()));
                  var v;
                  if (this.bumpSpace(), (v = this.tryParseDecimalInteger(F.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, F.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE)).err) return v;
                  this.bumpSpace(), m = this.parseIdentifierIfPossible(), g = v.val;
                }
                var y,
                  b = this.tryParsePluralOrSelectOptions(e, a, t, m);
                if (b.err) return b;
                if ((y = this.tryParseArgumentClose(r)).err) return y;
                var w = pe(r, this.clonePosition());
                return "select" === a ? {
                  val: {
                    type: M.select,
                    value: n,
                    options: Se(b.val),
                    location: w
                  },
                  err: null
                } : {
                  val: {
                    type: M.plural,
                    value: n,
                    options: Se(b.val),
                    offset: g,
                    pluralType: "plural" === a ? "cardinal" : "ordinal",
                    location: w
                  },
                  err: null
                };
              default:
                return this.error(F.INVALID_ARGUMENT_TYPE, pe(i, s));
            }
          }, e.prototype.tryParseArgumentClose = function (e) {
            return this.isEOF() || 125 !== this.char() ? this.error(F.EXPECT_ARGUMENT_CLOSING_BRACE, pe(e, this.clonePosition())) : (this.bump(), {
              val: !0,
              err: null
            });
          }, e.prototype.parseSimpleArgStyleIfPossible = function () {
            for (var e = 0, t = this.clonePosition(); !this.isEOF();) {
              switch (this.char()) {
                case 39:
                  this.bump();
                  var n = this.clonePosition();
                  if (!this.bumpUntil("'")) return this.error(F.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, pe(n, this.clonePosition()));
                  this.bump();
                  break;
                case 123:
                  e += 1, this.bump();
                  break;
                case 125:
                  if (!(e > 0)) return {
                    val: this.message.slice(t.offset, this.offset()),
                    err: null
                  };
                  e -= 1;
                  break;
                default:
                  this.bump();
              }
            }
            return {
              val: this.message.slice(t.offset, this.offset()),
              err: null
            };
          }, e.prototype.parseNumberSkeletonFromString = function (e, t) {
            var n = [];
            try {
              n = function (e) {
                if (0 === e.length) throw new Error("Number skeleton cannot be empty");
                for (var t = [], n = 0, r = e.split(X).filter(function (e) {
                    return e.length > 0;
                  }); n < r.length; n++) {
                  var o = r[n].split("/");
                  if (0 === o.length) throw new Error("Invalid number skeleton");
                  for (var i = o[0], a = o.slice(1), s = 0, l = a; s < l.length; s++) if (0 === l[s].length) throw new Error("Invalid number skeleton");
                  t.push({
                    stem: i,
                    options: a
                  });
                }
                return t;
              }(e);
            } catch (e) {
              return this.error(F.INVALID_NUMBER_SKELETON, t);
            }
            return {
              val: {
                type: R.number,
                tokens: n,
                location: t,
                parsedOptions: this.shouldParseSkeletons ? ae(n) : {}
              },
              err: null
            };
          }, e.prototype.tryParsePluralOrSelectOptions = function (e, t, n, r) {
            for (var o, i = !1, a = [], s = new Set(), l = r.value, u = r.location;;) {
              if (0 === l.length) {
                var c = this.clonePosition();
                if ("select" === t || !this.bumpIf("=")) break;
                var d = this.tryParseDecimalInteger(F.EXPECT_PLURAL_ARGUMENT_SELECTOR, F.INVALID_PLURAL_ARGUMENT_SELECTOR);
                if (d.err) return d;
                u = pe(c, this.clonePosition()), l = this.message.slice(c.offset, this.offset());
              }
              if (s.has(l)) return this.error("select" === t ? F.DUPLICATE_SELECT_ARGUMENT_SELECTOR : F.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
              "other" === l && (i = !0), this.bumpSpace();
              var p = this.clonePosition();
              if (!this.bumpIf("{")) return this.error("select" === t ? F.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : F.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, pe(this.clonePosition(), this.clonePosition()));
              var h = this.parseMessage(e + 1, t, n);
              if (h.err) return h;
              var f = this.tryParseArgumentClose(p);
              if (f.err) return f;
              a.push([l, {
                value: h.val,
                location: pe(p, this.clonePosition())
              }]), s.add(l), this.bumpSpace(), l = (o = this.parseIdentifierIfPossible()).value, u = o.location;
            }
            return 0 === a.length ? this.error("select" === t ? F.EXPECT_SELECT_ARGUMENT_SELECTOR : F.EXPECT_PLURAL_ARGUMENT_SELECTOR, pe(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !i ? this.error(F.MISSING_OTHER_CLAUSE, pe(this.clonePosition(), this.clonePosition())) : {
              val: a,
              err: null
            };
          }, e.prototype.tryParseDecimalInteger = function (e, t) {
            var n = 1,
              r = this.clonePosition();
            this.bumpIf("+") || this.bumpIf("-") && (n = -1);
            for (var o = !1, i = 0; !this.isEOF();) {
              var a = this.char();
              if (!(a >= 48 && a <= 57)) break;
              o = !0, i = 10 * i + (a - 48), this.bump();
            }
            var s = pe(r, this.clonePosition());
            return o ? be(i *= n) ? {
              val: i,
              err: null
            } : this.error(t, s) : this.error(e, s);
          }, e.prototype.offset = function () {
            return this.position.offset;
          }, e.prototype.isEOF = function () {
            return this.offset() === this.message.length;
          }, e.prototype.clonePosition = function () {
            return {
              offset: this.position.offset,
              line: this.position.line,
              column: this.position.column
            };
          }, e.prototype.char = function () {
            var e = this.position.offset;
            if (e >= this.message.length) throw Error("out of bound");
            var t = Ee(this.message, e);
            if (void 0 === t) throw Error("Offset ".concat(e, " is at invalid UTF-16 code unit boundary"));
            return t;
          }, e.prototype.error = function (e, t) {
            return {
              val: null,
              err: {
                kind: e,
                message: this.message,
                location: t
              }
            };
          }, e.prototype.bump = function () {
            if (!this.isEOF()) {
              var e = this.char();
              10 === e ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += e < 65536 ? 1 : 2);
            }
          }, e.prototype.bumpIf = function (e) {
            if (De(this.message, e, this.offset())) {
              for (var t = 0; t < e.length; t++) this.bump();
              return !0;
            }
            return !1;
          }, e.prototype.bumpUntil = function (e) {
            var t = this.offset(),
              n = this.message.indexOf(e, t);
            return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
          }, e.prototype.bumpTo = function (e) {
            if (this.offset() > e) throw Error("targetOffset ".concat(e, " must be greater than or equal to the current offset ").concat(this.offset()));
            for (e = Math.min(e, this.message.length);;) {
              var t = this.offset();
              if (t === e) break;
              if (t > e) throw Error("targetOffset ".concat(e, " is at invalid UTF-16 code unit boundary"));
              if (this.bump(), this.isEOF()) break;
            }
          }, e.prototype.bumpSpace = function () {
            for (; !this.isEOF() && Oe(this.char());) this.bump();
          }, e.prototype.peek = function () {
            if (this.isEOF()) return null;
            var e = this.char(),
              t = this.offset(),
              n = this.message.charCodeAt(t + (e >= 65536 ? 2 : 1));
            return null != n ? n : null;
          }, e;
        }();
        function Te(e) {
          return e >= 97 && e <= 122 || e >= 65 && e <= 90;
        }
        function Oe(e) {
          return e >= 9 && e <= 13 || 32 === e || 133 === e || e >= 8206 && e <= 8207 || 8232 === e || 8233 === e;
        }
        function Ie(e) {
          return e >= 33 && e <= 35 || 36 === e || e >= 37 && e <= 39 || 40 === e || 41 === e || 42 === e || 43 === e || 44 === e || 45 === e || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || 91 === e || 92 === e || 93 === e || 94 === e || 96 === e || 123 === e || 124 === e || 125 === e || 126 === e || 161 === e || e >= 162 && e <= 165 || 166 === e || 167 === e || 169 === e || 171 === e || 172 === e || 174 === e || 176 === e || 177 === e || 182 === e || 187 === e || 191 === e || 215 === e || 247 === e || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || 8216 === e || 8217 === e || 8218 === e || e >= 8219 && e <= 8220 || 8221 === e || 8222 === e || 8223 === e || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || 8249 === e || 8250 === e || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || 8260 === e || 8261 === e || 8262 === e || e >= 8263 && e <= 8273 || 8274 === e || 8275 === e || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || 8608 === e || e >= 8609 && e <= 8610 || 8611 === e || e >= 8612 && e <= 8613 || 8614 === e || e >= 8615 && e <= 8621 || 8622 === e || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || 8658 === e || 8659 === e || 8660 === e || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || 8968 === e || 8969 === e || 8970 === e || 8971 === e || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || 9001 === e || 9002 === e || e >= 9003 && e <= 9083 || 9084 === e || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || 9655 === e || e >= 9656 && e <= 9664 || 9665 === e || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || 9839 === e || e >= 9840 && e <= 10087 || 10088 === e || 10089 === e || 10090 === e || 10091 === e || 10092 === e || 10093 === e || 10094 === e || 10095 === e || 10096 === e || 10097 === e || 10098 === e || 10099 === e || 10100 === e || 10101 === e || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || 10181 === e || 10182 === e || e >= 10183 && e <= 10213 || 10214 === e || 10215 === e || 10216 === e || 10217 === e || 10218 === e || 10219 === e || 10220 === e || 10221 === e || 10222 === e || 10223 === e || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || 10627 === e || 10628 === e || 10629 === e || 10630 === e || 10631 === e || 10632 === e || 10633 === e || 10634 === e || 10635 === e || 10636 === e || 10637 === e || 10638 === e || 10639 === e || 10640 === e || 10641 === e || 10642 === e || 10643 === e || 10644 === e || 10645 === e || 10646 === e || 10647 === e || 10648 === e || e >= 10649 && e <= 10711 || 10712 === e || 10713 === e || 10714 === e || 10715 === e || e >= 10716 && e <= 10747 || 10748 === e || 10749 === e || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || 11158 === e || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || 11778 === e || 11779 === e || 11780 === e || 11781 === e || e >= 11782 && e <= 11784 || 11785 === e || 11786 === e || 11787 === e || 11788 === e || 11789 === e || e >= 11790 && e <= 11798 || 11799 === e || e >= 11800 && e <= 11801 || 11802 === e || 11803 === e || 11804 === e || 11805 === e || e >= 11806 && e <= 11807 || 11808 === e || 11809 === e || 11810 === e || 11811 === e || 11812 === e || 11813 === e || 11814 === e || 11815 === e || 11816 === e || 11817 === e || e >= 11818 && e <= 11822 || 11823 === e || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || 11840 === e || 11841 === e || 11842 === e || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || 11858 === e || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || 12296 === e || 12297 === e || 12298 === e || 12299 === e || 12300 === e || 12301 === e || 12302 === e || 12303 === e || 12304 === e || 12305 === e || e >= 12306 && e <= 12307 || 12308 === e || 12309 === e || 12310 === e || 12311 === e || 12312 === e || 12313 === e || 12314 === e || 12315 === e || 12316 === e || 12317 === e || e >= 12318 && e <= 12319 || 12320 === e || 12336 === e || 64830 === e || 64831 === e || e >= 65093 && e <= 65094;
        }
        function Fe(e) {
          e.forEach(function (e) {
            if (delete e.location, K(e) || q(e)) for (var t in e.options) delete e.options[t].location, Fe(e.options[t].value);else N(e) && Z(e.style) || (L(e) || V(e)) && $(e.style) ? delete e.style.location : U(e) && Fe(e.children);
          });
        }
        function Me(e, t) {
          void 0 === t && (t = {}), t = O({
            shouldParseSkeletons: !0,
            requiresOtherClause: !0
          }, t);
          var n = new ze(e, t).parse();
          if (n.err) {
            var r = SyntaxError(F[n.err.kind]);
            throw r.location = n.err.location, r.originalMessage = n.err.message, r;
          }
          return (null == t ? void 0 : t.captureLocation) || Fe(n.val), n.val;
        }
        function Re(e, t) {
          var n = t && t.cache ? t.cache : He,
            r = t && t.serializer ? t.serializer : Ve;
          return (t && t.strategy ? t.strategy : Le)(e, {
            cache: n,
            serializer: r
          });
        }
        function je(e, t, n, r) {
          var o,
            i = null == (o = r) || "number" == typeof o || "boolean" == typeof o ? r : n(r),
            a = t.get(i);
          return void 0 === a && (a = e.call(this, r), t.set(i, a)), a;
        }
        function Be(e, t, n) {
          var r = Array.prototype.slice.call(arguments, 3),
            o = n(r),
            i = t.get(o);
          return void 0 === i && (i = e.apply(this, r), t.set(o, i)), i;
        }
        function Ne(e, t, n, r, o) {
          return n.bind(t, e, r, o);
        }
        function Le(e, t) {
          return Ne(e, this, 1 === e.length ? je : Be, t.cache.create(), t.serializer);
        }
        var Ve = function () {
          return JSON.stringify(arguments);
        };
        function Ke() {
          this.cache = Object.create(null);
        }
        Ke.prototype.get = function (e) {
          return this.cache[e];
        }, Ke.prototype.set = function (e, t) {
          this.cache[e] = t;
        };
        var qe,
          He = {
            create: function () {
              return new Ke();
            }
          },
          Ue = {
            variadic: function (e, t) {
              return Ne(e, this, Be, t.cache.create(), t.serializer);
            },
            monadic: function (e, t) {
              return Ne(e, this, je, t.cache.create(), t.serializer);
            }
          };
        !function (e) {
          e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
        }(qe || (qe = {}));
        var Ze,
          $e = function (e) {
            function t(t, n, r) {
              var o = e.call(this, t) || this;
              return o.code = n, o.originalMessage = r, o;
            }
            return T(t, e), t.prototype.toString = function () {
              return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
            }, t;
          }(Error),
          Ge = function (e) {
            function t(t, n, r, o) {
              return e.call(this, 'Invalid values for "'.concat(t, '": "').concat(n, '". Options are "').concat(Object.keys(r).join('", "'), '"'), qe.INVALID_VALUE, o) || this;
            }
            return T(t, e), t;
          }($e),
          We = function (e) {
            function t(t, n, r) {
              return e.call(this, 'Value for "'.concat(t, '" must be of type ').concat(n), qe.INVALID_VALUE, r) || this;
            }
            return T(t, e), t;
          }($e),
          Ye = function (e) {
            function t(t, n) {
              return e.call(this, 'The intl string context variable "'.concat(t, '" was not provided to the string "').concat(n, '"'), qe.MISSING_VALUE, n) || this;
            }
            return T(t, e), t;
          }($e);
        function Xe(e) {
          return "function" == typeof e;
        }
        function Qe(e, t, n, r, o, i, a) {
          if (1 === e.length && j(e[0])) return [{
            type: Ze.literal,
            value: e[0].value
          }];
          for (var s = [], l = 0, u = e; l < u.length; l++) {
            var c = u[l];
            if (j(c)) s.push({
              type: Ze.literal,
              value: c.value
            });else if (H(c)) "number" == typeof i && s.push({
              type: Ze.literal,
              value: n.getNumberFormat(t).format(i)
            });else {
              var d = c.value;
              if (!o || !(d in o)) throw new Ye(d, a);
              var p = o[d];
              if (B(c)) p && "string" != typeof p && "number" != typeof p || (p = "string" == typeof p || "number" == typeof p ? String(p) : ""), s.push({
                type: "string" == typeof p ? Ze.literal : Ze.object,
                value: p
              });else if (L(c)) {
                var h = "string" == typeof c.style ? r.date[c.style] : $(c.style) ? c.style.parsedOptions : void 0;
                s.push({
                  type: Ze.literal,
                  value: n.getDateTimeFormat(t, h).format(p)
                });
              } else if (V(c)) {
                h = "string" == typeof c.style ? r.time[c.style] : $(c.style) ? c.style.parsedOptions : r.time.medium;
                s.push({
                  type: Ze.literal,
                  value: n.getDateTimeFormat(t, h).format(p)
                });
              } else if (N(c)) {
                (h = "string" == typeof c.style ? r.number[c.style] : Z(c.style) ? c.style.parsedOptions : void 0) && h.scale && (p *= h.scale || 1), s.push({
                  type: Ze.literal,
                  value: n.getNumberFormat(t, h).format(p)
                });
              } else {
                if (U(c)) {
                  var f = c.children,
                    m = c.value,
                    g = o[m];
                  if (!Xe(g)) throw new We(m, "function", a);
                  var v = g(Qe(f, t, n, r, o, i).map(function (e) {
                    return e.value;
                  }));
                  Array.isArray(v) || (v = [v]), s.push.apply(s, v.map(function (e) {
                    return {
                      type: "string" == typeof e ? Ze.literal : Ze.object,
                      value: e
                    };
                  }));
                }
                if (K(c)) {
                  if (!(y = c.options[p] || c.options.other)) throw new Ge(c.value, p, Object.keys(c.options), a);
                  s.push.apply(s, Qe(y.value, t, n, r, o));
                } else if (q(c)) {
                  var y;
                  if (!(y = c.options["=".concat(p)])) {
                    if (!Intl.PluralRules) throw new $e('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', qe.MISSING_INTL_API, a);
                    var b = n.getPluralRules(t, {
                      type: c.pluralType
                    }).select(p - (c.offset || 0));
                    y = c.options[b] || c.options.other;
                  }
                  if (!y) throw new Ge(c.value, p, Object.keys(c.options), a);
                  s.push.apply(s, Qe(y.value, t, n, r, o, p - (c.offset || 0)));
                } else ;
              }
            }
          }
          return function (e) {
            return e.length < 2 ? e : e.reduce(function (e, t) {
              var n = e[e.length - 1];
              return n && n.type === Ze.literal && t.type === Ze.literal ? n.value += t.value : e.push(t), e;
            }, []);
          }(s);
        }
        function Je(e, t) {
          return t ? Object.keys(e).reduce(function (n, r) {
            var o, i;
            return n[r] = (o = e[r], (i = t[r]) ? O(O(O({}, o || {}), i || {}), Object.keys(o).reduce(function (e, t) {
              return e[t] = O(O({}, o[t]), i[t] || {}), e;
            }, {})) : o), n;
          }, O({}, e)) : e;
        }
        function et(e) {
          return {
            create: function () {
              return {
                get: function (t) {
                  return e[t];
                },
                set: function (t, n) {
                  e[t] = n;
                }
              };
            }
          };
        }
        !function (e) {
          e[e.literal = 0] = "literal", e[e.object = 1] = "object";
        }(Ze || (Ze = {}));
        var tt = function () {
          function e(t, n, r, o) {
            var i = this;
            if (void 0 === n && (n = e.defaultLocale), this.formatterCache = {
              number: {},
              dateTime: {},
              pluralRules: {}
            }, this.format = function (e) {
              var t = i.formatToParts(e);
              if (1 === t.length) return t[0].value;
              var n = t.reduce(function (e, t) {
                return e.length && t.type === Ze.literal && "string" == typeof e[e.length - 1] ? e[e.length - 1] += t.value : e.push(t.value), e;
              }, []);
              return n.length <= 1 ? n[0] || "" : n;
            }, this.formatToParts = function (e) {
              return Qe(i.ast, i.locales, i.formatters, i.formats, e, void 0, i.message);
            }, this.resolvedOptions = function () {
              var e;
              return {
                locale: (null === (e = i.resolvedLocale) || void 0 === e ? void 0 : e.toString()) || Intl.NumberFormat.supportedLocalesOf(i.locales)[0]
              };
            }, this.getAst = function () {
              return i.ast;
            }, this.locales = n, this.resolvedLocale = e.resolveLocale(n), "string" == typeof t) {
              if (this.message = t, !e.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
              var a = o || {},
                s = (a.formatters, function (e, t) {
                  var n = {};
                  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
                  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
                    var o = 0;
                    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
                  }
                  return n;
                }(a, ["formatters"]));
              this.ast = e.__parse(t, O(O({}, s), {
                locale: this.resolvedLocale
              }));
            } else this.ast = t;
            if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
            this.formats = Je(e.formats, r), this.formatters = o && o.formatters || function (e) {
              return void 0 === e && (e = {
                number: {},
                dateTime: {},
                pluralRules: {}
              }), {
                getNumberFormat: Re(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.NumberFormat).bind.apply(e, I([void 0], t, !1)))();
                }, {
                  cache: et(e.number),
                  strategy: Ue.variadic
                }),
                getDateTimeFormat: Re(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.DateTimeFormat).bind.apply(e, I([void 0], t, !1)))();
                }, {
                  cache: et(e.dateTime),
                  strategy: Ue.variadic
                }),
                getPluralRules: Re(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.PluralRules).bind.apply(e, I([void 0], t, !1)))();
                }, {
                  cache: et(e.pluralRules),
                  strategy: Ue.variadic
                })
              };
            }(this.formatterCache);
          }
          return Object.defineProperty(e, "defaultLocale", {
            get: function () {
              return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
            },
            enumerable: !1,
            configurable: !0
          }), e.memoizedDefaultLocale = null, e.resolveLocale = function (e) {
            if (void 0 !== Intl.Locale) {
              var t = Intl.NumberFormat.supportedLocalesOf(e);
              return t.length > 0 ? new Intl.Locale(t[0]) : new Intl.Locale("string" == typeof e ? e : e[0]);
            }
          }, e.__parse = Me, e.formats = {
            number: {
              integer: {
                maximumFractionDigits: 0
              },
              currency: {
                style: "currency"
              },
              percent: {
                style: "percent"
              }
            },
            date: {
              short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
              },
              medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
              },
              long: {
                month: "long",
                day: "numeric",
                year: "numeric"
              },
              full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
              }
            },
            time: {
              short: {
                hour: "numeric",
                minute: "numeric"
              },
              medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
              },
              long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
              },
              full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
              }
            }
          }, e;
        }();
        const nt = tt;
        class rt {
          getStringForLocale(e, t) {
            let n = this.messages[t];
            n || (n = function (e, t, n = "en-US") {
              if (t[e]) return t[e];
              let r = function (e) {
                return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
              }(e);
              if (t[r]) return t[r];
              for (let e in t) if (e.startsWith(r + "-")) return t[e];
              return t[n];
            }(t, this.messages, this.defaultLocale), this.messages[t] = n);
            let r = n[e];
            if (!r) throw new Error(`Could not find intl message ${e} in ${t} locale`);
            return r;
          }
          constructor(e, t = "en-US") {
            this.messages = {
              ...e
            }, this.defaultLocale = t;
          }
        }
        class ot {
          format(e, t) {
            let n,
              r = this.cache[e];
            if (!r) {
              let t = this.messages.getStringForLocale(e, this.locale);
              if (!t) throw new Error(`Could not find intl message ${e} in ${this.locale} locale`);
              r = new nt(t, this.locale), this.cache[e] = r;
            }
            return t && (n = Object.keys(t).reduce((e, n) => (e[n] = null != t[n] && t[n], e), {})), r.format(n);
          }
          constructor(e, t) {
            this.locale = e, this.messages = t, this.cache = {};
          }
        }
        const it = new WeakMap();
        function at(e) {
          let {
              locale: t
            } = w(),
            n = (0, r.useMemo)(() => function (e) {
              let t = it.get(e);
              return t || (t = new rt(e), it.set(e, t)), t;
            }(e), [e]),
            o = (0, r.useMemo)(() => new ot(t, n), [t, n]);
          return (0, r.useCallback)((e, t) => o.format(e, t), [o]);
        }
      },
      49987: (e, t, n) => {
        "use strict";

        n.d(t, {
          mk: () => k,
          Jz: () => $,
          E: () => Z,
          _w: () => G,
          KK: () => T,
          mG: () => X,
          L_: () => Q,
          XI: () => oe,
          Fc: () => ie,
          Kf: () => W,
          v5: () => le,
          TA: () => pe,
          r_: () => ue,
          r7: () => y,
          y0: () => ce
        });
        var r = n(20770),
          o = n(67294);
        function i(e, t, n) {
          if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
          return t.get(e);
        }
        var a = n(2278);
        function s(e, t, n) {
          return function (e, t, n) {
            if (t.set) t.set.call(e, n);else {
              if (!t.writable) throw new TypeError("attempted to set read only private field");
              t.value = n;
            }
          }(e, i(e, t, "set"), n), n;
        }
        var l = n(16021);
        let u = "default",
          c = "",
          d = new WeakMap();
        function p(e) {
          if ((0, r.gn)()) {
            if ("default" === u) {
              const t = (0, r.r3)(e);
              c = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
            }
            u = "disabled";
          } else (e instanceof HTMLElement || e instanceof SVGElement) && (d.set(e, e.style.userSelect), e.style.userSelect = "none");
        }
        function h(e) {
          if ((0, r.gn)()) {
            if ("disabled" !== u) return;
            u = "restoring", setTimeout(() => {
              (0, r.QB)(() => {
                if ("restoring" === u) {
                  const t = (0, r.r3)(e);
                  "none" === t.documentElement.style.webkitUserSelect && (t.documentElement.style.webkitUserSelect = c || ""), c = "", u = "default";
                }
              });
            }, 300);
          } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && d.has(e)) {
            let t = d.get(e);
            "none" === e.style.userSelect && (e.style.userSelect = t), "" === e.getAttribute("style") && e.removeAttribute("style"), d.delete(e);
          }
        }
        const f = o.createContext({
          register: () => {}
        });
        f.displayName = "PressResponderContext";
        var m = new WeakMap();
        class g {
          continuePropagation() {
            s(this, m, !1);
          }
          get shouldStopPropagation() {
            return function (e, t) {
              return t.get ? t.get.call(e) : t.value;
            }(e = this, i(e, m, "get"));
            var e;
          }
          constructor(e, t, n) {
            (0, a._)(this, m, {
              writable: !0,
              value: void 0
            }), s(this, m, !0), this.type = e, this.pointerType = t, this.target = n.currentTarget, this.shiftKey = n.shiftKey, this.metaKey = n.metaKey, this.ctrlKey = n.ctrlKey, this.altKey = n.altKey;
          }
        }
        const v = Symbol("linkClicked");
        function y(e) {
          let {
              onPress: t,
              onPressChange: n,
              onPressStart: i,
              onPressEnd: a,
              onPressUp: s,
              isDisabled: l,
              isPressed: u,
              preventFocusOnPress: c,
              shouldCancelOnPointerExit: d,
              allowTextSelectionOnPress: m,
              ref: y,
              ..._
            } = function (e) {
              let t = (0, o.useContext)(f);
              if (t) {
                let {
                  register: n,
                  ...o
                } = t;
                e = (0, r.dG)(o, e), n();
              }
              return (0, r.lE)(t, e.ref), e;
            }(e),
            [P, k] = (0, o.useState)(!1),
            A = (0, o.useRef)({
              isPressed: !1,
              ignoreEmulatedMouseEvents: !1,
              ignoreClickAfterPress: !1,
              didFirePressStart: !1,
              isTriggeringEvent: !1,
              activePointerId: null,
              target: null,
              isOverTarget: !1,
              pointerType: null
            }),
            {
              addGlobalListener: z,
              removeAllGlobalListeners: T
            } = (0, r.xi)(),
            O = (0, r.iW)((e, t) => {
              let r = A.current;
              if (l || r.didFirePressStart) return !1;
              let o = !0;
              if (r.isTriggeringEvent = !0, i) {
                let n = new g("pressstart", t, e);
                i(n), o = n.shouldStopPropagation;
              }
              return n && n(!0), r.isTriggeringEvent = !1, r.didFirePressStart = !0, k(!0), o;
            }),
            I = (0, r.iW)((e, r, o = !0) => {
              let i = A.current;
              if (!i.didFirePressStart) return !1;
              i.ignoreClickAfterPress = !0, i.didFirePressStart = !1, i.isTriggeringEvent = !0;
              let s = !0;
              if (a) {
                let t = new g("pressend", r, e);
                a(t), s = t.shouldStopPropagation;
              }
              if (n && n(!1), k(!1), t && o && !l) {
                let n = new g("press", r, e);
                t(n), s && (s = n.shouldStopPropagation);
              }
              return i.isTriggeringEvent = !1, s;
            }),
            F = (0, r.iW)((e, t) => {
              let n = A.current;
              if (l) return !1;
              if (s) {
                n.isTriggeringEvent = !0;
                let r = new g("pressup", t, e);
                return s(r), n.isTriggeringEvent = !1, r.shouldStopPropagation;
              }
              return !0;
            }),
            M = (0, r.iW)(e => {
              let t = A.current;
              t.isPressed && t.target && (t.isOverTarget && null != t.pointerType && I(D(t.target, e), t.pointerType, !1), t.isPressed = !1, t.isOverTarget = !1, t.activePointerId = null, t.pointerType = null, T(), m || h(t.target));
            }),
            R = (0, r.iW)(e => {
              d && M(e);
            }),
            j = (0, o.useMemo)(() => {
              let e = A.current,
                t = {
                  onKeyDown(t) {
                    if (w(t.nativeEvent, t.currentTarget) && t.currentTarget.contains(t.target)) {
                      var o;
                      E(t.target, t.key) && t.preventDefault();
                      let i = !0;
                      if (!e.isPressed && !t.repeat) {
                        e.target = t.currentTarget, e.isPressed = !0, i = O(t, "keyboard");
                        let o = t.currentTarget,
                          a = t => {
                            w(t, o) && !t.repeat && o.contains(t.target) && e.target && F(D(e.target, t), "keyboard");
                          };
                        z((0, r.k3)(t.currentTarget), "keyup", (0, r.tS)(a, n), !0);
                      }
                      i && t.stopPropagation(), t.metaKey && (0, r.V5)() && (null === (o = e.metaKeyEvents) || void 0 === o || o.set(t.key, t.nativeEvent));
                    } else "Meta" === t.key && (e.metaKeyEvents = new Map());
                  },
                  onClick(t) {
                    if ((!t || t.currentTarget.contains(t.target)) && t && 0 === t.button && !e.isTriggeringEvent && !r.nG.isOpening) {
                      let n = !0;
                      if (l && t.preventDefault(), !e.ignoreClickAfterPress && !e.ignoreEmulatedMouseEvents && !e.isPressed && ("virtual" === e.pointerType || (0, r.Zj)(t.nativeEvent))) {
                        l || c || (0, r.Ao)(t.currentTarget);
                        let e = O(t, "virtual"),
                          o = F(t, "virtual"),
                          i = I(t, "virtual");
                        n = e && o && i;
                      }
                      e.ignoreEmulatedMouseEvents = !1, e.ignoreClickAfterPress = !1, n && t.stopPropagation();
                    }
                  }
                },
                n = t => {
                  var n;
                  if (e.isPressed && e.target && w(t, e.target)) {
                    var o;
                    E(t.target, t.key) && t.preventDefault();
                    let n = t.target;
                    I(D(e.target, t), "keyboard", e.target.contains(n)), T(), "Enter" !== t.key && b(e.target) && e.target.contains(n) && !t[v] && (t[v] = !0, (0, r.nG)(e.target, t, !1)), e.isPressed = !1, null === (o = e.metaKeyEvents) || void 0 === o || o.delete(t.key);
                  } else if ("Meta" === t.key && (null === (n = e.metaKeyEvents) || void 0 === n ? void 0 : n.size)) {
                    var i;
                    let t = e.metaKeyEvents;
                    e.metaKeyEvents = void 0;
                    for (let n of t.values()) null === (i = e.target) || void 0 === i || i.dispatchEvent(new KeyboardEvent("keyup", n));
                  }
                };
              if ("undefined" != typeof PointerEvent) {
                t.onPointerDown = t => {
                  if (0 !== t.button || !t.currentTarget.contains(t.target)) return;
                  if ((0, r.cr)(t.nativeEvent)) return void (e.pointerType = "virtual");
                  S(t.currentTarget) && t.preventDefault(), e.pointerType = t.pointerType;
                  let a = !0;
                  e.isPressed || (e.isPressed = !0, e.isOverTarget = !0, e.activePointerId = t.pointerId, e.target = t.currentTarget, l || c || (0, r.Ao)(t.currentTarget), m || p(e.target), a = O(t, e.pointerType), z((0, r.k3)(t.currentTarget), "pointermove", n, !1), z((0, r.k3)(t.currentTarget), "pointerup", o, !1), z((0, r.k3)(t.currentTarget), "pointercancel", i, !1)), a && t.stopPropagation();
                }, t.onMouseDown = e => {
                  e.currentTarget.contains(e.target) && 0 === e.button && (S(e.currentTarget) && e.preventDefault(), e.stopPropagation());
                }, t.onPointerUp = t => {
                  t.currentTarget.contains(t.target) && "virtual" !== e.pointerType && 0 === t.button && C(t, t.currentTarget) && F(t, e.pointerType || t.pointerType);
                };
                let n = t => {
                    t.pointerId === e.activePointerId && (e.target && C(t, e.target) ? e.isOverTarget || null == e.pointerType || (e.isOverTarget = !0, O(D(e.target, t), e.pointerType)) : e.target && e.isOverTarget && null != e.pointerType && (e.isOverTarget = !1, I(D(e.target, t), e.pointerType, !1), R(t)));
                  },
                  o = t => {
                    t.pointerId === e.activePointerId && e.isPressed && 0 === t.button && e.target && (C(t, e.target) && null != e.pointerType ? I(D(e.target, t), e.pointerType) : e.isOverTarget && null != e.pointerType && I(D(e.target, t), e.pointerType, !1), e.isPressed = !1, e.isOverTarget = !1, e.activePointerId = null, e.pointerType = null, T(), m || h(e.target));
                  },
                  i = e => {
                    M(e);
                  };
                t.onDragStart = e => {
                  e.currentTarget.contains(e.target) && M(e);
                };
              } else {
                t.onMouseDown = t => {
                  if (0 !== t.button || !t.currentTarget.contains(t.target)) return;
                  if (S(t.currentTarget) && t.preventDefault(), e.ignoreEmulatedMouseEvents) return void t.stopPropagation();
                  e.isPressed = !0, e.isOverTarget = !0, e.target = t.currentTarget, e.pointerType = (0, r.Zj)(t.nativeEvent) ? "virtual" : "mouse", l || c || (0, r.Ao)(t.currentTarget), O(t, e.pointerType) && t.stopPropagation(), z((0, r.k3)(t.currentTarget), "mouseup", n, !1);
                }, t.onMouseEnter = t => {
                  if (!t.currentTarget.contains(t.target)) return;
                  let n = !0;
                  e.isPressed && !e.ignoreEmulatedMouseEvents && null != e.pointerType && (e.isOverTarget = !0, n = O(t, e.pointerType)), n && t.stopPropagation();
                }, t.onMouseLeave = t => {
                  if (!t.currentTarget.contains(t.target)) return;
                  let n = !0;
                  e.isPressed && !e.ignoreEmulatedMouseEvents && null != e.pointerType && (e.isOverTarget = !1, n = I(t, e.pointerType, !1), R(t)), n && t.stopPropagation();
                }, t.onMouseUp = t => {
                  t.currentTarget.contains(t.target) && (e.ignoreEmulatedMouseEvents || 0 !== t.button || F(t, e.pointerType || "mouse"));
                };
                let n = t => {
                  0 === t.button && (e.isPressed = !1, T(), e.ignoreEmulatedMouseEvents ? e.ignoreEmulatedMouseEvents = !1 : (e.target && C(t, e.target) && null != e.pointerType ? I(D(e.target, t), e.pointerType) : e.target && e.isOverTarget && null != e.pointerType && I(D(e.target, t), e.pointerType, !1), e.isOverTarget = !1));
                };
                t.onTouchStart = t => {
                  if (!t.currentTarget.contains(t.target)) return;
                  let n = function (e) {
                    const {
                      targetTouches: t
                    } = e;
                    return t.length > 0 ? t[0] : null;
                  }(t.nativeEvent);
                  n && (e.activePointerId = n.identifier, e.ignoreEmulatedMouseEvents = !0, e.isOverTarget = !0, e.isPressed = !0, e.target = t.currentTarget, e.pointerType = "touch", l || c || (0, r.Ao)(t.currentTarget), m || p(e.target), O(t, e.pointerType) && t.stopPropagation(), z((0, r.kR)(t.currentTarget), "scroll", o, !0));
                }, t.onTouchMove = t => {
                  if (!t.currentTarget.contains(t.target)) return;
                  if (!e.isPressed) return void t.stopPropagation();
                  let n = x(t.nativeEvent, e.activePointerId),
                    r = !0;
                  n && C(n, t.currentTarget) ? e.isOverTarget || null == e.pointerType || (e.isOverTarget = !0, r = O(t, e.pointerType)) : e.isOverTarget && null != e.pointerType && (e.isOverTarget = !1, r = I(t, e.pointerType, !1), R(t)), r && t.stopPropagation();
                }, t.onTouchEnd = t => {
                  if (!t.currentTarget.contains(t.target)) return;
                  if (!e.isPressed) return void t.stopPropagation();
                  let n = x(t.nativeEvent, e.activePointerId),
                    r = !0;
                  n && C(n, t.currentTarget) && null != e.pointerType ? (F(t, e.pointerType), r = I(t, e.pointerType)) : e.isOverTarget && null != e.pointerType && (r = I(t, e.pointerType, !1)), r && t.stopPropagation(), e.isPressed = !1, e.activePointerId = null, e.isOverTarget = !1, e.ignoreEmulatedMouseEvents = !0, e.target && !m && h(e.target), T();
                }, t.onTouchCancel = t => {
                  t.currentTarget.contains(t.target) && (t.stopPropagation(), e.isPressed && M(t));
                };
                let o = t => {
                  e.isPressed && t.target.contains(e.target) && M({
                    currentTarget: e.target,
                    shiftKey: !1,
                    ctrlKey: !1,
                    metaKey: !1,
                    altKey: !1
                  });
                };
                t.onDragStart = e => {
                  e.currentTarget.contains(e.target) && M(e);
                };
              }
              return t;
            }, [z, l, c, T, m, M, R, I, O, F]);
          return (0, o.useEffect)(() => () => {
            var e;
            m || h(null !== (e = A.current.target) && void 0 !== e ? e : void 0);
          }, [m]), {
            isPressed: u || P,
            pressProps: (0, r.dG)(_, j)
          };
        }
        function b(e) {
          return "A" === e.tagName && e.hasAttribute("href");
        }
        function w(e, t) {
          const {
              key: n,
              code: o
            } = e,
            i = t,
            a = i.getAttribute("role");
          return !("Enter" !== n && " " !== n && "Spacebar" !== n && "Space" !== o || i instanceof (0, r.kR)(i).HTMLInputElement && !P(i, n) || i instanceof (0, r.kR)(i).HTMLTextAreaElement || i.isContentEditable || ("link" === a || !a && b(i)) && "Enter" !== n);
        }
        function x(e, t) {
          const n = e.changedTouches;
          for (let e = 0; e < n.length; e++) {
            const r = n[e];
            if (r.identifier === t) return r;
          }
          return null;
        }
        function D(e, t) {
          return {
            currentTarget: e,
            shiftKey: t.shiftKey,
            ctrlKey: t.ctrlKey,
            metaKey: t.metaKey,
            altKey: t.altKey
          };
        }
        function C(e, t) {
          let n = t.getBoundingClientRect(),
            r = function (e) {
              let t = 0,
                n = 0;
              return void 0 !== e.width ? t = e.width / 2 : void 0 !== e.radiusX && (t = e.radiusX), void 0 !== e.height ? n = e.height / 2 : void 0 !== e.radiusY && (n = e.radiusY), {
                top: e.clientY - n,
                right: e.clientX + t,
                bottom: e.clientY + n,
                left: e.clientX - t
              };
            }(e);
          return i = r, !((o = n).left > i.right || i.left > o.right || o.top > i.bottom || i.top > o.bottom);
          var o, i;
        }
        function S(e) {
          return !(e instanceof HTMLElement && e.hasAttribute("draggable"));
        }
        function E(e, t) {
          return e instanceof HTMLInputElement ? !P(e, t) : e instanceof HTMLButtonElement ? "submit" !== e.type && "reset" !== e.type : !b(e);
        }
        const _ = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);
        function P(e, t) {
          return "checkbox" === e.type || "radio" === e.type ? " " === t : _.has(e.type);
        }
        function k({
          children: e
        }) {
          let t = (0, o.useMemo)(() => ({
            register: () => {}
          }), []);
          return o.createElement(f.Provider, {
            value: t
          }, e);
        }
        class A {
          isDefaultPrevented() {
            return this.nativeEvent.defaultPrevented;
          }
          preventDefault() {
            this.defaultPrevented = !0, this.nativeEvent.preventDefault();
          }
          stopPropagation() {
            this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
          }
          isPropagationStopped() {
            return !1;
          }
          persist() {}
          constructor(e, t) {
            this.nativeEvent = t, this.target = t.target, this.currentTarget = t.currentTarget, this.relatedTarget = t.relatedTarget, this.bubbles = t.bubbles, this.cancelable = t.cancelable, this.defaultPrevented = t.defaultPrevented, this.eventPhase = t.eventPhase, this.isTrusted = t.isTrusted, this.timeStamp = t.timeStamp, this.type = e;
          }
        }
        function z(e) {
          let t = (0, o.useRef)({
            isFocused: !1,
            observer: null
          });
          (0, r.bt)(() => {
            const e = t.current;
            return () => {
              e.observer && (e.observer.disconnect(), e.observer = null);
            };
          }, []);
          let n = (0, r.iW)(t => {
            null == e || e(t);
          });
          return (0, o.useCallback)(e => {
            if (e.target instanceof HTMLButtonElement || e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLSelectElement) {
              t.current.isFocused = !0;
              let r = e.target,
                o = e => {
                  t.current.isFocused = !1, r.disabled && n(new A("blur", e)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
                };
              r.addEventListener("focusout", o, {
                once: !0
              }), t.current.observer = new MutationObserver(() => {
                if (t.current.isFocused && r.disabled) {
                  var e;
                  null === (e = t.current.observer) || void 0 === e || e.disconnect();
                  let n = r === document.activeElement ? null : document.activeElement;
                  r.dispatchEvent(new FocusEvent("blur", {
                    relatedTarget: n
                  })), r.dispatchEvent(new FocusEvent("focusout", {
                    bubbles: !0,
                    relatedTarget: n
                  }));
                }
              }), t.current.observer.observe(r, {
                attributes: !0,
                attributeFilter: ["disabled"]
              });
            }
          }, [n]);
        }
        function T(e) {
          let {
            isDisabled: t,
            onFocus: n,
            onBlur: i,
            onFocusChange: a
          } = e;
          const s = (0, o.useCallback)(e => {
              if (e.target === e.currentTarget) return i && i(e), a && a(!1), !0;
            }, [i, a]),
            l = z(s),
            u = (0, o.useCallback)(e => {
              const t = (0, r.k3)(e.target),
                o = t instanceof ShadowRoot ? (0, r.Gf)() : t.activeElement;
              e.target === e.currentTarget && o === e.target && (n && n(e), a && a(!0), l(e));
            }, [a, n, l]);
          return {
            focusProps: {
              onFocus: !t && (n || a || i) ? u : void 0,
              onBlur: t || !i && !a ? void 0 : s
            }
          };
        }
        let O = null,
          I = new Set(),
          F = new Map(),
          M = !1,
          R = !1;
        const j = {
          Tab: !0,
          Escape: !0
        };
        function B(e, t) {
          for (let n of I) n(e, t);
        }
        function N(e) {
          M = !0, function (e) {
            return !(e.metaKey || !(0, r.V5)() && e.altKey || e.ctrlKey || "Control" === e.key || "Shift" === e.key || "Meta" === e.key);
          }(e) && (O = "keyboard", B("keyboard", e));
        }
        function L(e) {
          O = "pointer", "mousedown" !== e.type && "pointerdown" !== e.type || (M = !0, B("pointer", e));
        }
        function V(e) {
          (0, r.Zj)(e) && (M = !0, O = "virtual");
        }
        function K(e) {
          e.target !== window && e.target !== document && (M || R || (O = "virtual", B("virtual", e)), M = !1, R = !1);
        }
        function q() {
          M = !1, R = !0;
        }
        function H(e) {
          if ("undefined" == typeof window || F.get((0, r.kR)(e))) return;
          const t = (0, r.kR)(e),
            n = (0, r.k3)(e);
          let o = t.HTMLElement.prototype.focus;
          t.HTMLElement.prototype.focus = function () {
            M = !0, o.apply(this, arguments);
          }, n.addEventListener("keydown", N, !0), n.addEventListener("keyup", N, !0), n.addEventListener("click", V, !0), t.addEventListener("focus", K, !0), t.addEventListener("blur", q, !1), "undefined" != typeof PointerEvent ? (n.addEventListener("pointerdown", L, !0), n.addEventListener("pointermove", L, !0), n.addEventListener("pointerup", L, !0)) : (n.addEventListener("mousedown", L, !0), n.addEventListener("mousemove", L, !0), n.addEventListener("mouseup", L, !0)), t.addEventListener("beforeunload", () => {
            U(e);
          }, {
            once: !0
          }), F.set(t, {
            focus: o
          });
        }
        const U = (e, t) => {
          const n = (0, r.kR)(e),
            o = (0, r.k3)(e);
          t && o.removeEventListener("DOMContentLoaded", t), F.has(n) && (n.HTMLElement.prototype.focus = F.get(n).focus, o.removeEventListener("keydown", N, !0), o.removeEventListener("keyup", N, !0), o.removeEventListener("click", V, !0), n.removeEventListener("focus", K, !0), n.removeEventListener("blur", q, !1), "undefined" != typeof PointerEvent ? (o.removeEventListener("pointerdown", L, !0), o.removeEventListener("pointermove", L, !0), o.removeEventListener("pointerup", L, !0)) : (o.removeEventListener("mousedown", L, !0), o.removeEventListener("mousemove", L, !0), o.removeEventListener("mouseup", L, !0)), F.delete(n));
        };
        function Z() {
          return "pointer" !== O;
        }
        function $() {
          return O;
        }
        function G(e) {
          O = e, B(e, null);
        }
        function W() {
          H();
          let [e, t] = (0, o.useState)(O);
          return (0, o.useEffect)(() => {
            let e = () => {
              t(O);
            };
            return I.add(e), () => {
              I.delete(e);
            };
          }, []), (0, l.Av)() ? null : e;
        }
        "undefined" != typeof document && function (e) {
          const t = (0, r.k3)(e);
          let n;
          t instanceof ShadowRoot || "loading" !== t.readyState ? H(e) : (n = () => {
            H(e);
          }, t.addEventListener("DOMContentLoaded", n));
        }();
        const Y = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);
        function X(e, t, n) {
          H(), (0, o.useEffect)(() => {
            let t = (t, o) => {
              (function (e, t, n) {
                var o;
                const i = "undefined" != typeof window ? (0, r.kR)(null == n ? void 0 : n.target).HTMLInputElement : HTMLInputElement,
                  a = "undefined" != typeof window ? (0, r.kR)(null == n ? void 0 : n.target).HTMLTextAreaElement : HTMLTextAreaElement,
                  s = "undefined" != typeof window ? (0, r.kR)(null == n ? void 0 : n.target).HTMLElement : HTMLElement,
                  l = "undefined" != typeof window ? (0, r.kR)(null == n ? void 0 : n.target).KeyboardEvent : KeyboardEvent;
                return !((e = e || (null == n ? void 0 : n.target) instanceof i && !Y.has(null == n || null === (o = n.target) || void 0 === o ? void 0 : o.type) || (null == n ? void 0 : n.target) instanceof a || (null == n ? void 0 : n.target) instanceof s && (null == n ? void 0 : n.target.isContentEditable)) && "keyboard" === t && n instanceof l && !j[n.key]);
              })(!!(null == n ? void 0 : n.isTextInput), t, o) && e(Z());
            };
            return I.add(t), () => {
              I.delete(t);
            };
          }, t);
        }
        function Q(e) {
          let {
              isDisabled: t,
              onBlurWithin: n,
              onFocusWithin: i,
              onFocusWithinChange: a
            } = e,
            s = (0, o.useRef)({
              isFocusWithin: !1
            }),
            l = (0, o.useCallback)(e => {
              s.current.isFocusWithin && !e.currentTarget.contains(e.relatedTarget) && (s.current.isFocusWithin = !1, n && n(e), a && a(!1));
            }, [n, a, s]),
            u = z(l),
            c = (0, o.useCallback)(e => {
              s.current.isFocusWithin || (0, r.Gf)() !== e.target || (i && i(e), a && a(!0), s.current.isFocusWithin = !0, u(e));
            }, [i, a, u]);
          return t ? {
            focusWithinProps: {
              onFocus: void 0,
              onBlur: void 0
            }
          } : {
            focusWithinProps: {
              onFocus: c,
              onBlur: l
            }
          };
        }
        let J = !1,
          ee = 0;
        function te() {
          J = !0, setTimeout(() => {
            J = !1;
          }, 50);
        }
        function ne(e) {
          "touch" === e.pointerType && te();
        }
        function re() {
          if ("undefined" != typeof document) return "undefined" != typeof PointerEvent ? document.addEventListener("pointerup", ne) : document.addEventListener("touchend", te), ee++, () => {
            ee--, ee > 0 || ("undefined" != typeof PointerEvent ? document.removeEventListener("pointerup", ne) : document.removeEventListener("touchend", te));
          };
        }
        function oe(e) {
          let {
              onHoverStart: t,
              onHoverChange: n,
              onHoverEnd: r,
              isDisabled: i
            } = e,
            [a, s] = (0, o.useState)(!1),
            l = (0, o.useRef)({
              isHovered: !1,
              ignoreEmulatedMouseEvents: !1,
              pointerType: "",
              target: null
            }).current;
          (0, o.useEffect)(re, []);
          let {
            hoverProps: u,
            triggerHoverEnd: c
          } = (0, o.useMemo)(() => {
            let e = (e, r) => {
                if (l.pointerType = r, i || "touch" === r || l.isHovered || !e.currentTarget.contains(e.target)) return;
                l.isHovered = !0;
                let o = e.currentTarget;
                l.target = o, t && t({
                  type: "hoverstart",
                  target: o,
                  pointerType: r
                }), n && n(!0), s(!0);
              },
              o = (e, t) => {
                if (l.pointerType = "", l.target = null, "touch" === t || !l.isHovered) return;
                l.isHovered = !1;
                let o = e.currentTarget;
                r && r({
                  type: "hoverend",
                  target: o,
                  pointerType: t
                }), n && n(!1), s(!1);
              },
              a = {};
            return "undefined" != typeof PointerEvent ? (a.onPointerEnter = t => {
              J && "mouse" === t.pointerType || e(t, t.pointerType);
            }, a.onPointerLeave = e => {
              !i && e.currentTarget.contains(e.target) && o(e, e.pointerType);
            }) : (a.onTouchStart = () => {
              l.ignoreEmulatedMouseEvents = !0;
            }, a.onMouseEnter = t => {
              l.ignoreEmulatedMouseEvents || J || e(t, "mouse"), l.ignoreEmulatedMouseEvents = !1;
            }, a.onMouseLeave = e => {
              !i && e.currentTarget.contains(e.target) && o(e, "mouse");
            }), {
              hoverProps: a,
              triggerHoverEnd: o
            };
          }, [t, n, r, i, l]);
          return (0, o.useEffect)(() => {
            i && c({
              currentTarget: l.target
            }, l.pointerType);
          }, [i]), {
            hoverProps: u,
            isHovered: a
          };
        }
        function ie(e) {
          let {
              ref: t,
              onInteractOutside: n,
              isDisabled: i,
              onInteractOutsideStart: a
            } = e,
            s = (0, o.useRef)({
              isPointerDown: !1,
              ignoreEmulatedMouseEvents: !1
            }),
            l = (0, r.iW)(e => {
              n && ae(e, t) && (a && a(e), s.current.isPointerDown = !0);
            }),
            u = (0, r.iW)(e => {
              n && n(e);
            });
          (0, o.useEffect)(() => {
            let e = s.current;
            if (i) return;
            const n = t.current,
              o = (0, r.r3)(n);
            if ("undefined" != typeof PointerEvent) {
              let n = n => {
                e.isPointerDown && ae(n, t) && u(n), e.isPointerDown = !1;
              };
              return o.addEventListener("pointerdown", l, !0), o.addEventListener("pointerup", n, !0), () => {
                o.removeEventListener("pointerdown", l, !0), o.removeEventListener("pointerup", n, !0);
              };
            }
            {
              let n = n => {
                  e.ignoreEmulatedMouseEvents ? e.ignoreEmulatedMouseEvents = !1 : e.isPointerDown && ae(n, t) && u(n), e.isPointerDown = !1;
                },
                r = n => {
                  e.ignoreEmulatedMouseEvents = !0, e.isPointerDown && ae(n, t) && u(n), e.isPointerDown = !1;
                };
              return o.addEventListener("mousedown", l, !0), o.addEventListener("mouseup", n, !0), o.addEventListener("touchstart", l, !0), o.addEventListener("touchend", r, !0), () => {
                o.removeEventListener("mousedown", l, !0), o.removeEventListener("mouseup", n, !0), o.removeEventListener("touchstart", l, !0), o.removeEventListener("touchend", r, !0);
              };
            }
          }, [t, i, l, u]);
        }
        function ae(e, t) {
          if (e.button > 0) return !1;
          if (e.target) {
            const t = e.target.ownerDocument;
            if (!t || !t.documentElement.contains(e.target)) return !1;
            if (e.target.closest("[data-react-aria-top-layer]")) return !1;
          }
          return !!t.current && !e.composedPath().includes(t.current);
        }
        function se(e) {
          if (!e) return;
          let t = !0;
          return n => {
            let r = {
              ...n,
              preventDefault() {
                n.preventDefault();
              },
              isDefaultPrevented: () => n.isDefaultPrevented(),
              stopPropagation() {
                console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
              },
              continuePropagation() {
                t = !1;
              }
            };
            e(r), t && n.stopPropagation();
          };
        }
        function le(e) {
          return {
            keyboardProps: e.isDisabled ? {} : {
              onKeyDown: se(e.onKeyDown),
              onKeyUp: se(e.onKeyUp)
            }
          };
        }
        function ue(e) {
          let {
              onMoveStart: t,
              onMove: n,
              onMoveEnd: i
            } = e,
            a = (0, o.useRef)({
              didMove: !1,
              lastPosition: null,
              id: null
            }),
            {
              addGlobalListener: s,
              removeGlobalListener: l
            } = (0, r.xi)(),
            u = (0, r.iW)((e, r, o, i) => {
              0 === o && 0 === i || (a.current.didMove || (a.current.didMove = !0, null == t || t({
                type: "movestart",
                pointerType: r,
                shiftKey: e.shiftKey,
                metaKey: e.metaKey,
                ctrlKey: e.ctrlKey,
                altKey: e.altKey
              })), null == n || n({
                type: "move",
                pointerType: r,
                deltaX: o,
                deltaY: i,
                shiftKey: e.shiftKey,
                metaKey: e.metaKey,
                ctrlKey: e.ctrlKey,
                altKey: e.altKey
              }));
            }),
            c = (0, r.iW)((e, t) => {
              h(), a.current.didMove && (null == i || i({
                type: "moveend",
                pointerType: t,
                shiftKey: e.shiftKey,
                metaKey: e.metaKey,
                ctrlKey: e.ctrlKey,
                altKey: e.altKey
              }));
            });
          return {
            moveProps: (0, o.useMemo)(() => {
              let e = {},
                t = () => {
                  p(), a.current.didMove = !1;
                };
              if ("undefined" == typeof PointerEvent) {
                let n = e => {
                    var t, n, r, o;
                    0 === e.button && (u(e, "mouse", e.pageX - (null !== (r = null === (t = a.current.lastPosition) || void 0 === t ? void 0 : t.pageX) && void 0 !== r ? r : 0), e.pageY - (null !== (o = null === (n = a.current.lastPosition) || void 0 === n ? void 0 : n.pageY) && void 0 !== o ? o : 0)), a.current.lastPosition = {
                      pageX: e.pageX,
                      pageY: e.pageY
                    });
                  },
                  r = e => {
                    0 === e.button && (c(e, "mouse"), l(window, "mousemove", n, !1), l(window, "mouseup", r, !1));
                  };
                e.onMouseDown = e => {
                  0 === e.button && (t(), e.stopPropagation(), e.preventDefault(), a.current.lastPosition = {
                    pageX: e.pageX,
                    pageY: e.pageY
                  }, s(window, "mousemove", n, !1), s(window, "mouseup", r, !1));
                };
                let o = e => {
                    let t = [...e.changedTouches].findIndex(({
                      identifier: e
                    }) => e === a.current.id);
                    if (t >= 0) {
                      var n, r;
                      let {
                        pageX: s,
                        pageY: l
                      } = e.changedTouches[t];
                      var o, i;
                      u(e, "touch", s - (null !== (o = null === (n = a.current.lastPosition) || void 0 === n ? void 0 : n.pageX) && void 0 !== o ? o : 0), l - (null !== (i = null === (r = a.current.lastPosition) || void 0 === r ? void 0 : r.pageY) && void 0 !== i ? i : 0)), a.current.lastPosition = {
                        pageX: s,
                        pageY: l
                      };
                    }
                  },
                  i = e => {
                    [...e.changedTouches].findIndex(({
                      identifier: e
                    }) => e === a.current.id) >= 0 && (c(e, "touch"), a.current.id = null, l(window, "touchmove", o), l(window, "touchend", i), l(window, "touchcancel", i));
                  };
                e.onTouchStart = e => {
                  if (0 === e.changedTouches.length || null != a.current.id) return;
                  let {
                    pageX: n,
                    pageY: r,
                    identifier: l
                  } = e.changedTouches[0];
                  t(), e.stopPropagation(), e.preventDefault(), a.current.lastPosition = {
                    pageX: n,
                    pageY: r
                  }, a.current.id = l, s(window, "touchmove", o, !1), s(window, "touchend", i, !1), s(window, "touchcancel", i, !1);
                };
              } else {
                let n = e => {
                    if (e.pointerId === a.current.id) {
                      var t, n;
                      let i = e.pointerType || "mouse";
                      var r, o;
                      u(e, i, e.pageX - (null !== (r = null === (t = a.current.lastPosition) || void 0 === t ? void 0 : t.pageX) && void 0 !== r ? r : 0), e.pageY - (null !== (o = null === (n = a.current.lastPosition) || void 0 === n ? void 0 : n.pageY) && void 0 !== o ? o : 0)), a.current.lastPosition = {
                        pageX: e.pageX,
                        pageY: e.pageY
                      };
                    }
                  },
                  r = e => {
                    if (e.pointerId === a.current.id) {
                      let t = e.pointerType || "mouse";
                      c(e, t), a.current.id = null, l(window, "pointermove", n, !1), l(window, "pointerup", r, !1), l(window, "pointercancel", r, !1);
                    }
                  };
                e.onPointerDown = e => {
                  0 === e.button && null == a.current.id && (t(), e.stopPropagation(), e.preventDefault(), a.current.lastPosition = {
                    pageX: e.pageX,
                    pageY: e.pageY
                  }, a.current.id = e.pointerId, s(window, "pointermove", n, !1), s(window, "pointerup", r, !1), s(window, "pointercancel", r, !1));
                };
              }
              let n = (e, n, r) => {
                t(), u(e, "keyboard", n, r), c(e, "keyboard");
              };
              return e.onKeyDown = e => {
                switch (e.key) {
                  case "Left":
                  case "ArrowLeft":
                    e.preventDefault(), e.stopPropagation(), n(e, -1, 0);
                    break;
                  case "Right":
                  case "ArrowRight":
                    e.preventDefault(), e.stopPropagation(), n(e, 1, 0);
                    break;
                  case "Up":
                  case "ArrowUp":
                    e.preventDefault(), e.stopPropagation(), n(e, 0, -1);
                    break;
                  case "Down":
                  case "ArrowDown":
                    e.preventDefault(), e.stopPropagation(), n(e, 0, 1);
                }
              }, e;
            }, [a, s, l, u, c])
          };
        }
        function ce(e, t) {
          let {
              onScroll: n,
              isDisabled: i
            } = e,
            a = (0, o.useCallback)(e => {
              e.ctrlKey || (e.preventDefault(), e.stopPropagation(), n && n({
                deltaX: e.deltaX,
                deltaY: e.deltaY
              }));
            }, [n]);
          (0, r.zX)(t, "wheel", i ? void 0 : a);
        }
        const de = 500;
        function pe(e) {
          let {
            isDisabled: t,
            onLongPressStart: n,
            onLongPressEnd: i,
            onLongPress: a,
            threshold: s = de,
            accessibilityDescription: l
          } = e;
          const u = (0, o.useRef)();
          let {
              addGlobalListener: c,
              removeGlobalListener: d
            } = (0, r.xi)(),
            {
              pressProps: p
            } = y({
              isDisabled: t,
              onPressStart(e) {
                if (e.continuePropagation(), ("mouse" === e.pointerType || "touch" === e.pointerType) && (n && n({
                  ...e,
                  type: "longpressstart"
                }), u.current = setTimeout(() => {
                  e.target.dispatchEvent(new PointerEvent("pointercancel", {
                    bubbles: !0
                  })), a && a({
                    ...e,
                    type: "longpress"
                  }), u.current = void 0;
                }, s), "touch" === e.pointerType)) {
                  let t = e => {
                    e.preventDefault();
                  };
                  c(e.target, "contextmenu", t, {
                    once: !0
                  }), c(window, "pointerup", () => {
                    setTimeout(() => {
                      d(e.target, "contextmenu", t);
                    }, 30);
                  }, {
                    once: !0
                  });
                }
              },
              onPressEnd(e) {
                u.current && clearTimeout(u.current), !i || "mouse" !== e.pointerType && "touch" !== e.pointerType || i({
                  ...e,
                  type: "longpressend"
                });
              }
            }),
            h = (0, r.PK)(a && !t ? l : void 0);
          return {
            longPressProps: (0, r.dG)(p, h)
          };
        }
      },
      41217: (e, t, n) => {
        "use strict";

        n.d(t, {
          N: () => o,
          U: () => i
        });
        var r = n(20770);
        function o(e) {
          let {
            id: t,
            label: n,
            "aria-labelledby": o,
            "aria-label": i,
            labelElementType: a = "label"
          } = e;
          t = (0, r.Me)(t);
          let s = (0, r.Me)(),
            l = {};
          return n ? (o = o ? `${s} ${o}` : s, l = {
            id: s,
            htmlFor: "label" === a ? t : void 0
          }) : o || i || console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"), {
            labelProps: l,
            fieldProps: (0, r.bE)({
              id: t,
              "aria-label": i,
              "aria-labelledby": o
            })
          };
        }
        function i(e) {
          let {
              description: t,
              errorMessage: n,
              isInvalid: i,
              validationState: a
            } = e,
            {
              labelProps: s,
              fieldProps: l
            } = o(e),
            u = (0, r.mp)([Boolean(t), Boolean(n), i, a]),
            c = (0, r.mp)([Boolean(t), Boolean(n), i, a]);
          return l = (0, r.dG)(l, {
            "aria-describedby": [u, c, e["aria-describedby"]].filter(Boolean).join(" ") || void 0
          }), {
            labelProps: s,
            fieldProps: l,
            descriptionProps: {
              id: u
            },
            errorMessageProps: {
              id: c
            }
          };
        }
      },
      80602: (e, t, n) => {
        "use strict";

        n.d(t, {
          gb: () => i,
          xQ: () => o
        });
        let r = null;
        function o(e, t = "assertive", n = 7e3) {
          r || (r = new a()), r.announce(e, t, n);
        }
        function i(e) {
          r && r.clear(e);
        }
        class a {
          createLog(e) {
            let t = document.createElement("div");
            return t.setAttribute("role", "log"), t.setAttribute("aria-live", e), t.setAttribute("aria-relevant", "additions"), t;
          }
          destroy() {
            this.node && (document.body.removeChild(this.node), this.node = null);
          }
          announce(e, t = "assertive", n = 7e3) {
            if (!this.node) return;
            let r = document.createElement("div");
            r.textContent = e, "assertive" === t ? this.assertiveLog.appendChild(r) : this.politeLog.appendChild(r), "" !== e && setTimeout(() => {
              r.remove();
            }, n);
          }
          clear(e) {
            this.node && (e && "assertive" !== e || (this.assertiveLog.innerHTML = ""), e && "polite" !== e || (this.politeLog.innerHTML = ""));
          }
          constructor() {
            this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
              border: 0,
              clip: "rect(0 0 0 0)",
              clipPath: "inset(50%)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap"
            }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
          }
        }
      },
      13607: (e, t, n) => {
        "use strict";

        n.d(t, {
          o: () => d,
          p: () => p
        });
        var r = n(20770),
          o = n(67294),
          i = n(49987),
          a = n(41217),
          s = n(18383),
          l = n(88786);
        const u = new WeakMap();
        function c(e, t) {
          let n = u.get(e);
          if (!n) throw new Error("Unknown slider state");
          return `${n.id}-${t}`;
        }
        function d(e, t, n) {
          let {
              labelProps: l,
              fieldProps: d
            } = (0, a.N)(e),
            p = "vertical" === e.orientation;
          var h;
          u.set(t, {
            id: null !== (h = l.id) && void 0 !== h ? h : d.id,
            "aria-describedby": e["aria-describedby"],
            "aria-details": e["aria-details"]
          });
          let {
              direction: f
            } = (0, s.bU)(),
            {
              addGlobalListener: m,
              removeGlobalListener: g
            } = (0, r.xi)();
          const v = (0, o.useRef)(null),
            y = "rtl" === f,
            b = (0, o.useRef)(null),
            {
              moveProps: w
            } = (0, i.r_)({
              onMoveStart() {
                b.current = null;
              },
              onMove({
                deltaX: e,
                deltaY: o
              }) {
                let {
                    height: i,
                    width: a
                  } = n.current.getBoundingClientRect(),
                  s = p ? i : a;
                null == b.current && (b.current = t.getThumbPercent(v.current) * s);
                let l = p ? o : e;
                if ((p || y) && (l = -l), b.current += l, null != v.current && n.current) {
                  const e = (0, r.uZ)(b.current / s, 0, 1);
                  t.setThumbPercent(v.current, e);
                }
              },
              onMoveEnd() {
                null != v.current && (t.setThumbDragging(v.current, !1), v.current = null);
              }
            });
          let x = (0, o.useRef)(void 0),
            D = (r, o, i, a) => {
              if (n.current && !e.isDisabled && t.values.every((e, n) => !t.isThumbDragging(n))) {
                let {
                  height: e,
                  width: s,
                  top: l,
                  left: u
                } = n.current.getBoundingClientRect();
                let c = ((p ? a : i) - (p ? l : u)) / (p ? e : s);
                ("rtl" === f || p) && (c = 1 - c);
                let d,
                  h = t.getPercentValue(c),
                  g = t.values.findIndex(e => h - e < 0);
                if (0 === g) d = g;else if (-1 === g) d = t.values.length - 1;else {
                  let e = t.values[g - 1],
                    n = t.values[g];
                  d = Math.abs(e - h) < Math.abs(n - h) ? g - 1 : g;
                }
                d >= 0 && t.isThumbEditable(d) ? (r.preventDefault(), v.current = d, t.setFocusedThumb(d), x.current = o, t.setThumbDragging(v.current, !0), t.setThumbValue(d, h), m(window, "mouseup", C, !1), m(window, "touchend", C, !1), m(window, "pointerup", C, !1)) : v.current = null;
              }
            },
            C = e => {
              var n, r;
              (null !== (r = e.pointerId) && void 0 !== r ? r : null === (n = e.changedTouches) || void 0 === n ? void 0 : n[0].identifier) === x.current && (null != v.current && (t.setThumbDragging(v.current, !1), v.current = null), g(window, "mouseup", C, !1), g(window, "touchend", C, !1), g(window, "pointerup", C, !1));
            };
          return "htmlFor" in l && l.htmlFor && (delete l.htmlFor, l.onClick = () => {
            var e;
            null === (e = document.getElementById(c(t, 0))) || void 0 === e || e.focus(), (0, i._w)("keyboard");
          }), {
            labelProps: l,
            groupProps: {
              role: "group",
              ...d
            },
            trackProps: (0, r.dG)({
              onMouseDown(e) {
                0 !== e.button || e.altKey || e.ctrlKey || e.metaKey || D(e, void 0, e.clientX, e.clientY);
              },
              onPointerDown(e) {
                "mouse" === e.pointerType && (0 !== e.button || e.altKey || e.ctrlKey || e.metaKey) || D(e, e.pointerId, e.clientX, e.clientY);
              },
              onTouchStart(e) {
                D(e, e.changedTouches[0].identifier, e.changedTouches[0].clientX, e.changedTouches[0].clientY);
              },
              style: {
                position: "relative",
                touchAction: "none"
              }
            }, w),
            outputProps: {
              htmlFor: t.values.map((e, n) => c(t, n)).join(" "),
              "aria-live": "off"
            }
          };
        }
        function p(e, t) {
          let {
              index: n = 0,
              isRequired: d,
              validationState: p,
              isInvalid: h,
              trackRef: f,
              inputRef: m,
              orientation: g = t.orientation,
              name: v
            } = e,
            y = e.isDisabled || t.isDisabled,
            b = "vertical" === g,
            {
              direction: w
            } = (0, s.bU)(),
            {
              addGlobalListener: x,
              removeGlobalListener: D
            } = (0, r.xi)(),
            C = u.get(t);
          var S;
          const {
              labelProps: E,
              fieldProps: _
            } = (0, a.N)({
              ...e,
              id: c(t, n),
              "aria-labelledby": `${C.id} ${null !== (S = e["aria-labelledby"]) && void 0 !== S ? S : ""}`.trim()
            }),
            P = t.values[n],
            k = (0, o.useCallback)(() => {
              m.current && (0, r.Ao)(m.current);
            }, [m]),
            A = t.focusedThumb === n;
          (0, o.useEffect)(() => {
            A && k();
          }, [A, k]);
          let z = "rtl" === w,
            T = (0, o.useRef)(null),
            {
              keyboardProps: O
            } = (0, i.v5)({
              onKeyDown(e) {
                let {
                  getThumbMaxValue: r,
                  getThumbMinValue: o,
                  decrementThumb: i,
                  incrementThumb: a,
                  setThumbValue: s,
                  setThumbDragging: l,
                  pageSize: u
                } = t;
                if (/^(PageUp|PageDown|Home|End)$/.test(e.key)) {
                  switch (e.preventDefault(), l(n, !0), e.key) {
                    case "PageUp":
                      a(n, u);
                      break;
                    case "PageDown":
                      i(n, u);
                      break;
                    case "Home":
                      s(n, o(n));
                      break;
                    case "End":
                      s(n, r(n));
                  }
                  l(n, !1);
                } else e.continuePropagation();
              }
            }),
            {
              moveProps: I
            } = (0, i.r_)({
              onMoveStart() {
                T.current = null, t.setThumbDragging(n, !0);
              },
              onMove({
                deltaX: e,
                deltaY: o,
                pointerType: i,
                shiftKey: a
              }) {
                const {
                  getThumbPercent: s,
                  setThumbPercent: l,
                  decrementThumb: u,
                  incrementThumb: c,
                  step: d,
                  pageSize: p
                } = t;
                let {
                    width: h,
                    height: m
                  } = f.current.getBoundingClientRect(),
                  g = b ? m : h;
                if (null == T.current && (T.current = s(n) * g), "keyboard" === i) e > 0 && z || e < 0 && !z || o > 0 ? u(n, a ? p : d) : c(n, a ? p : d);else {
                  let t = b ? o : e;
                  (b || z) && (t = -t), T.current += t, l(n, (0, r.uZ)(T.current / g, 0, 1));
                }
              },
              onMoveEnd() {
                t.setThumbDragging(n, !1);
              }
            });
          t.setThumbEditable(n, !y);
          const {
            focusableProps: F
          } = (0, l.kc)((0, r.dG)(e, {
            onFocus: () => t.setFocusedThumb(n),
            onBlur: () => t.setFocusedThumb(void 0)
          }), m);
          let M = (0, o.useRef)(void 0),
            R = e => {
              k(), M.current = e, t.setThumbDragging(n, !0), x(window, "mouseup", j, !1), x(window, "touchend", j, !1), x(window, "pointerup", j, !1);
            },
            j = e => {
              var r, o;
              (null !== (o = e.pointerId) && void 0 !== o ? o : null === (r = e.changedTouches) || void 0 === r ? void 0 : r[0].identifier) === M.current && (k(), t.setThumbDragging(n, !1), D(window, "mouseup", j, !1), D(window, "touchend", j, !1), D(window, "pointerup", j, !1));
            },
            B = t.getThumbPercent(n);
          (b || "rtl" === w) && (B = 1 - B);
          let N = y ? {} : (0, r.dG)(O, I, {
            onMouseDown: e => {
              0 !== e.button || e.altKey || e.ctrlKey || e.metaKey || R();
            },
            onPointerDown: e => {
              0 !== e.button || e.altKey || e.ctrlKey || e.metaKey || R(e.pointerId);
            },
            onTouchStart: e => {
              R(e.changedTouches[0].identifier);
            }
          });
          return (0, r.y$)(m, P, e => {
            t.setThumbValue(n, e);
          }), {
            inputProps: (0, r.dG)(F, _, {
              type: "range",
              tabIndex: y ? void 0 : 0,
              min: t.getThumbMinValue(n),
              max: t.getThumbMaxValue(n),
              step: t.step,
              value: P,
              name: v,
              disabled: y,
              "aria-orientation": g,
              "aria-valuetext": t.getThumbValueLabel(n),
              "aria-required": d || void 0,
              "aria-invalid": h || "invalid" === p || void 0,
              "aria-errormessage": e["aria-errormessage"],
              "aria-describedby": [C["aria-describedby"], e["aria-describedby"]].filter(Boolean).join(" "),
              "aria-details": [C["aria-details"], e["aria-details"]].filter(Boolean).join(" "),
              onChange: e => {
                t.setThumbValue(n, parseFloat(e.target.value));
              }
            }),
            thumbProps: {
              ...N,
              style: {
                position: "absolute",
                [b ? "top" : "left"]: 100 * B + "%",
                transform: "translate(-50%, -50%)",
                touchAction: "none"
              }
            },
            labelProps: E,
            isDragging: t.isThumbDragging(n),
            isDisabled: y,
            isFocused: A
          };
        }
      },
      59292: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => q
        });
        var r;
        r = {
          Empty: "فارغ"
        };
        var o;
        o = {
          Empty: "Изпразни"
        };
        var i;
        i = {
          Empty: "Prázdné"
        };
        var a;
        a = {
          Empty: "Tom"
        };
        var s;
        s = {
          Empty: "Leer"
        };
        var l;
        l = {
          Empty: "Άδειο"
        };
        var u;
        u = {
          Empty: "Empty"
        };
        var c;
        c = {
          Empty: "Vacío"
        };
        var d;
        d = {
          Empty: "Tühjenda"
        };
        var p;
        p = {
          Empty: "Tyhjä"
        };
        var h;
        h = {
          Empty: "Vide"
        };
        var f;
        f = {
          Empty: "ריק"
        };
        var m;
        m = {
          Empty: "Prazno"
        };
        var g;
        g = {
          Empty: "Üres"
        };
        var v;
        v = {
          Empty: "Vuoto"
        };
        var y;
        y = {
          Empty: "空"
        };
        var b;
        b = {
          Empty: "비어 있음"
        };
        var w;
        w = {
          Empty: "Tuščias"
        };
        var x;
        x = {
          Empty: "Tukšs"
        };
        var D;
        D = {
          Empty: "Tom"
        };
        var C;
        C = {
          Empty: "Leeg"
        };
        var S;
        S = {
          Empty: "Pusty"
        };
        var E;
        E = {
          Empty: "Vazio"
        };
        var _;
        _ = {
          Empty: "Vazio"
        };
        var P;
        P = {
          Empty: "Gol"
        };
        var k;
        k = {
          Empty: "Не заполнено"
        };
        var A;
        A = {
          Empty: "Prázdne"
        };
        var z;
        z = {
          Empty: "Prazen"
        };
        var T;
        T = {
          Empty: "Prazno"
        };
        var O;
        O = {
          Empty: "Tomt"
        };
        var I;
        I = {
          Empty: "Boş"
        };
        var F;
        F = {
          Empty: "Пусто"
        };
        var M;
        M = {
          Empty: "空"
        };
        var R;
        R = {
          Empty: "空白"
        };
        var j = n(80602),
          B = n(67294),
          N = n(20770),
          L = n(18383);
        function V(e) {
          return e && e.__esModule ? e.default : e;
        }
        var K;
        function q(e) {
          const t = (0, B.useRef)();
          let {
            value: n,
            textValue: r,
            minValue: o,
            maxValue: i,
            isDisabled: a,
            isReadOnly: s,
            isRequired: l,
            onIncrement: u,
            onIncrementPage: c,
            onDecrement: d,
            onDecrementPage: p,
            onDecrementToMin: h,
            onIncrementToMax: f
          } = e;
          const m = (0, L.qb)(V(K), "@react-aria/spinbutton"),
            g = () => clearTimeout(t.current);
          (0, B.useEffect)(() => () => g(), []);
          let v = (0, B.useRef)(!1),
            y = () => {
              v.current = !0;
            },
            b = () => {
              v.current = !1;
            },
            w = "" === r ? m.format("Empty") : (r || `${n}`).replace("-", "−");
          (0, B.useEffect)(() => {
            v.current && ((0, j.gb)("assertive"), (0, j.xQ)(w, "assertive"));
          }, [w]);
          const x = (0, N.iW)(e => {
              g(), null == u || u(), t.current = window.setTimeout(() => {
                (void 0 === i || isNaN(i) || void 0 === n || isNaN(n) || n < i) && x(60);
              }, e);
            }),
            D = (0, N.iW)(e => {
              g(), null == d || d(), t.current = window.setTimeout(() => {
                (void 0 === o || isNaN(o) || void 0 === n || isNaN(n) || n > o) && D(60);
              }, e);
            });
          let C = e => {
              e.preventDefault();
            },
            {
              addGlobalListener: S,
              removeAllGlobalListeners: E
            } = (0, N.xi)();
          return {
            spinButtonProps: {
              role: "spinbutton",
              "aria-valuenow": void 0 === n || isNaN(n) ? void 0 : n,
              "aria-valuetext": w,
              "aria-valuemin": o,
              "aria-valuemax": i,
              "aria-disabled": a || void 0,
              "aria-readonly": s || void 0,
              "aria-required": l || void 0,
              onKeyDown: e => {
                if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || s)) switch (e.key) {
                  case "PageUp":
                    if (c) {
                      e.preventDefault(), null == c || c();
                      break;
                    }
                  case "ArrowUp":
                  case "Up":
                    u && (e.preventDefault(), null == u || u());
                    break;
                  case "PageDown":
                    if (p) {
                      e.preventDefault(), null == p || p();
                      break;
                    }
                  case "ArrowDown":
                  case "Down":
                    d && (e.preventDefault(), null == d || d());
                    break;
                  case "Home":
                    h && (e.preventDefault(), null == h || h());
                    break;
                  case "End":
                    f && (e.preventDefault(), null == f || f());
                }
              },
              onFocus: y,
              onBlur: b
            },
            incrementButtonProps: {
              onPressStart: () => {
                x(400), S(window, "contextmenu", C);
              },
              onPressEnd: () => {
                g(), E();
              },
              onFocus: y,
              onBlur: b
            },
            decrementButtonProps: {
              onPressStart: () => {
                D(400), S(window, "contextmenu", C);
              },
              onPressEnd: () => {
                g(), E();
              },
              onFocus: y,
              onBlur: b
            }
          };
        }
        K = {
          "ar-AE": r,
          "bg-BG": o,
          "cs-CZ": i,
          "da-DK": a,
          "de-DE": s,
          "el-GR": l,
          "en-US": u,
          "es-ES": c,
          "et-EE": d,
          "fi-FI": p,
          "fr-FR": h,
          "he-IL": f,
          "hr-HR": m,
          "hu-HU": g,
          "it-IT": v,
          "ja-JP": y,
          "ko-KR": b,
          "lt-LT": w,
          "lv-LV": x,
          "nb-NO": D,
          "nl-NL": C,
          "pl-PL": S,
          "pt-BR": E,
          "pt-PT": _,
          "ro-RO": P,
          "ru-RU": k,
          "sk-SK": A,
          "sl-SI": z,
          "sr-SP": T,
          "sv-SE": O,
          "tr-TR": I,
          "uk-UA": F,
          "zh-CN": M,
          "zh-TW": R
        };
      },
      16021: (e, t, n) => {
        "use strict";

        n.d(t, {
          Av: () => f,
          gP: () => c
        });
        var r = n(67294);
        const o = {
            prefix: String(Math.round(1e10 * Math.random())),
            current: 0
          },
          i = r.createContext(o),
          a = r.createContext(!1);
        let s = Boolean("undefined" != typeof window && window.document && window.document.createElement),
          l = new WeakMap();
        function u(e = !1) {
          let t = (0, r.useContext)(i),
            n = (0, r.useRef)(null);
          if (null === n.current && !e) {
            var o, a;
            let e = null === (a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) || void 0 === a || null === (o = a.ReactCurrentOwner) || void 0 === o ? void 0 : o.current;
            if (e) {
              let n = l.get(e);
              null == n ? l.set(e, {
                id: t.current,
                state: e.memoizedState
              }) : e.memoizedState !== n.state && (t.current = n.id, l.delete(e));
            }
            n.current = ++t.current;
          }
          return n.current;
        }
        const c = "function" == typeof r.useId ? function (e) {
          let t = r.useId(),
            [n] = (0, r.useState)(f());
          return e || `${n ? "react-aria" : `react-aria${o.prefix}`}-${t}`;
        } : function (e) {
          let t = (0, r.useContext)(i);
          t !== o || s || console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
          let n = u(!!e),
            a = `react-aria${t.prefix}`;
          return e || `${a}-${n}`;
        };
        function d() {
          return !1;
        }
        function p() {
          return !0;
        }
        function h(e) {
          return () => {};
        }
        function f() {
          return "function" == typeof r.useSyncExternalStore ? r.useSyncExternalStore(h, d, p) : (0, r.useContext)(a);
        }
      },
      91788: (e, t, n) => {
        "use strict";

        n.d(t, {
          E: () => c,
          h: () => p
        });
        var r = n(67294),
          o = n(20770),
          i = n(85010),
          a = n(41217),
          s = n(88786),
          l = n(86838),
          u = n(38947);
        function c(e, t) {
          let {
              inputElementType: n = "input",
              isDisabled: c = !1,
              isRequired: d = !1,
              isReadOnly: p = !1,
              type: h = "text",
              validationBehavior: f = "aria"
            } = e,
            [m, g] = (0, i.zk)(e.value, e.defaultValue || "", e.onChange),
            {
              focusableProps: v
            } = (0, s.kc)(e, t),
            y = (0, u.Q3)({
              ...e,
              value: m
            }),
            {
              isInvalid: b,
              validationErrors: w,
              validationDetails: x
            } = y.displayValidation,
            {
              labelProps: D,
              fieldProps: C,
              descriptionProps: S,
              errorMessageProps: E
            } = (0, a.U)({
              ...e,
              isInvalid: b,
              errorMessage: e.errorMessage || w
            }),
            _ = (0, o.zL)(e, {
              labelable: !0
            });
          const P = {
            type: h,
            pattern: e.pattern
          };
          return (0, o.y$)(t, m, g), (0, l.Q)(e, y, t), (0, r.useEffect)(() => {
            if (t.current instanceof (0, o.kR)(t.current).HTMLTextAreaElement) {
              let e = t.current;
              Object.defineProperty(e, "defaultValue", {
                get: () => e.value,
                set: () => {},
                configurable: !0
              });
            }
          }, [t]), {
            labelProps: D,
            inputProps: (0, o.dG)(_, "input" === n && P, {
              disabled: c,
              readOnly: p,
              required: d && "native" === f,
              "aria-required": d && "aria" === f || void 0,
              "aria-invalid": b || void 0,
              "aria-errormessage": e["aria-errormessage"],
              "aria-activedescendant": e["aria-activedescendant"],
              "aria-autocomplete": e["aria-autocomplete"],
              "aria-haspopup": e["aria-haspopup"],
              value: m,
              onChange: e => g(e.target.value),
              autoComplete: e.autoComplete,
              autoCapitalize: e.autoCapitalize,
              maxLength: e.maxLength,
              minLength: e.minLength,
              name: e.name,
              placeholder: e.placeholder,
              inputMode: e.inputMode,
              onCopy: e.onCopy,
              onCut: e.onCut,
              onPaste: e.onPaste,
              onCompositionEnd: e.onCompositionEnd,
              onCompositionStart: e.onCompositionStart,
              onCompositionUpdate: e.onCompositionUpdate,
              onSelect: e.onSelect,
              onBeforeInput: e.onBeforeInput,
              onInput: e.onInput,
              ...v,
              ...C
            }),
            descriptionProps: S,
            errorMessageProps: E,
            isInvalid: b,
            validationErrors: w,
            validationDetails: x
          };
        }
        function d() {
          return "undefined" != typeof window && window.InputEvent && "function" == typeof InputEvent.prototype.getTargetRanges;
        }
        function p(e, t, n) {
          let i = (0, o.iW)(e => {
            let r,
              o = n.current;
            switch (e.inputType) {
              case "historyUndo":
              case "historyRedo":
                return;
              case "deleteContent":
              case "deleteByCut":
              case "deleteByDrag":
                r = o.value.slice(0, o.selectionStart) + o.value.slice(o.selectionEnd);
                break;
              case "deleteContentForward":
                r = o.selectionEnd === o.selectionStart ? o.value.slice(0, o.selectionStart) + o.value.slice(o.selectionEnd + 1) : o.value.slice(0, o.selectionStart) + o.value.slice(o.selectionEnd);
                break;
              case "deleteContentBackward":
                r = o.selectionEnd === o.selectionStart ? o.value.slice(0, o.selectionStart - 1) + o.value.slice(o.selectionStart) : o.value.slice(0, o.selectionStart) + o.value.slice(o.selectionEnd);
                break;
              case "deleteSoftLineBackward":
              case "deleteHardLineBackward":
                r = o.value.slice(o.selectionStart);
                break;
              default:
                null != e.data && (r = o.value.slice(0, o.selectionStart) + e.data + o.value.slice(o.selectionEnd));
            }
            null != r && t.validate(r) || e.preventDefault();
          });
          (0, r.useEffect)(() => {
            if (!d()) return;
            let e = n.current;
            return e.addEventListener("beforeinput", i, !1), () => {
              e.removeEventListener("beforeinput", i, !1);
            };
          }, [n, i]);
          let a = d() ? null : e => {
              let n = e.target.value.slice(0, e.target.selectionStart) + e.data + e.target.value.slice(e.target.selectionEnd);
              t.validate(n) || e.preventDefault();
            },
            {
              labelProps: s,
              inputProps: l,
              descriptionProps: u,
              errorMessageProps: p,
              ...h
            } = c(e, n),
            f = (0, r.useRef)(null);
          return {
            inputProps: (0, o.dG)(l, {
              onBeforeInput: a,
              onCompositionStart() {
                let {
                  value: e,
                  selectionStart: t,
                  selectionEnd: r
                } = n.current;
                f.current = {
                  value: e,
                  selectionStart: t,
                  selectionEnd: r
                };
              },
              onCompositionEnd() {
                if (!t.validate(n.current.value)) {
                  let {
                    value: e,
                    selectionStart: r,
                    selectionEnd: o
                  } = f.current;
                  n.current.value = e, n.current.setSelectionRange(r, o), t.setInputValue(e);
                }
              }
            }),
            labelProps: s,
            descriptionProps: u,
            errorMessageProps: p,
            ...h
          };
        }
      },
      20770: (e, t, n) => {
        "use strict";

        n.d(t, {
          Ao: () => k,
          B3: () => J,
          Dt: () => N,
          Gf: () => w,
          Gt: () => fe,
          IN: () => I,
          Me: () => p,
          PK: () => ce,
          Pf: () => j,
          Q5: () => b,
          QB: () => Y,
          V5: () => O,
          Zj: () => me,
          a9: () => oe,
          ad: () => R,
          b0: () => q,
          bE: () => Q,
          bt: () => s,
          cr: () => ge,
          dG: () => x,
          gn: () => M,
          i7: () => B,
          iW: () => l,
          ib: () => Z,
          k3: () => y,
          kR: () => v,
          lE: () => ne,
          lq: () => D,
          mp: () => f,
          nG: () => H,
          nP: () => ae,
          pl: () => u,
          r3: () => g,
          rP: () => re,
          rf: () => ee,
          tS: () => m,
          tv: () => K,
          uZ: () => r.uZ,
          vE: () => ve,
          vU: () => L,
          xi: () => X,
          y$: () => ye,
          yU: () => te,
          zL: () => P,
          zT: () => pe,
          zX: () => de,
          zc: () => F
        });
        var r = n(85010),
          o = n(67294),
          i = n(16021),
          a = n(1410);
        const s = "undefined" != typeof document ? o.useLayoutEffect : () => {};
        function l(e) {
          const t = (0, o.useRef)(null);
          return s(() => {
            t.current = e;
          }, [e]), (0, o.useCallback)((...e) => {
            const n = t.current;
            return null == n ? void 0 : n(...e);
          }, []);
        }
        function u(e) {
          let [t, n] = (0, o.useState)(e),
            r = (0, o.useRef)(null),
            i = l(() => {
              if (!r.current) return;
              let e = r.current.next();
              e.done ? r.current = null : t === e.value ? i() : n(e.value);
            });
          s(() => {
            r.current && i();
          });
          let a = l(e => {
            r.current = e(t), i();
          });
          return [t, a];
        }
        let c = Boolean("undefined" != typeof window && window.document && window.document.createElement),
          d = new Map();
        function p(e) {
          let [t, n] = (0, o.useState)(e),
            r = (0, o.useRef)(null),
            a = (0, i.gP)(t),
            l = (0, o.useCallback)(e => {
              r.current = e;
            }, []);
          return c && d.set(a, l), s(() => {
            let e = a;
            return () => {
              d.delete(e);
            };
          }, [a]), (0, o.useEffect)(() => {
            let e = r.current;
            e && (r.current = null, n(e));
          }), a;
        }
        function h(e, t) {
          if (e === t) return e;
          let n = d.get(e);
          if (n) return n(t), t;
          let r = d.get(t);
          return r ? (r(e), e) : t;
        }
        function f(e = []) {
          let t = p(),
            [n, r] = u(t),
            i = (0, o.useCallback)(() => {
              r(function* () {
                yield t, yield document.getElementById(t) ? t : void 0;
              });
            }, [t, r]);
          return s(i, [t, i, ...e]), n;
        }
        function m(...e) {
          return (...t) => {
            for (let n of e) "function" == typeof n && n(...t);
          };
        }
        const g = e => {
            var t;
            return null !== (t = null == e ? void 0 : e.ownerDocument) && void 0 !== t ? t : document;
          },
          v = e => {
            if (e && "window" in e && e.window === e) return e;
            const t = y(e);
            return t instanceof ShadowRoot ? t.ownerDocument.defaultView || window : t.defaultView || window;
          },
          y = e => {
            if (!e) return document;
            const t = e.getRootNode ? e.getRootNode() : document;
            return t instanceof Document || !e.isConnected ? document : t;
          },
          b = e => {
            var t;
            return e instanceof ShadowRoot ? null === (t = e.ownerDocument) || void 0 === t ? void 0 : t.body : e.body;
          },
          w = () => {
            var e, t;
            let n = document.activeElement;
            for (; (null == n ? void 0 : n.shadowRoot) && (null === (e = n.shadowRoot) || void 0 === e ? void 0 : e.activeElement);) n = null == n || null === (t = n.shadowRoot) || void 0 === t ? void 0 : t.activeElement;
            return n;
          };
        function x(...e) {
          let t = {
            ...e[0]
          };
          for (let n = 1; n < e.length; n++) {
            let r = e[n];
            for (let e in r) {
              let n = t[e],
                o = r[e];
              "function" == typeof n && "function" == typeof o && "o" === e[0] && "n" === e[1] && e.charCodeAt(2) >= 65 && e.charCodeAt(2) <= 90 ? t[e] = m(n, o) : "className" !== e && "UNSAFE_className" !== e || "string" != typeof n || "string" != typeof o ? "id" === e && n && o ? t.id = h(n, o) : t[e] = void 0 !== o ? o : n : t[e] = (0, a.Z)(n, o);
            }
          }
          return t;
        }
        function D(...e) {
          return 1 === e.length ? e[0] : t => {
            for (let n of e) "function" == typeof n ? n(t) : null != n && (n.current = t);
          };
        }
        const C = new Set(["id"]),
          S = new Set(["aria-label", "aria-labelledby", "aria-describedby", "aria-details"]),
          E = new Set(["href", "hrefLang", "target", "rel", "download", "ping", "referrerPolicy"]),
          _ = /^(data-.*)$/;
        function P(e, t = {}) {
          let {
              labelable: n,
              isLink: r,
              propNames: o
            } = t,
            i = {};
          for (const t in e) Object.prototype.hasOwnProperty.call(e, t) && (C.has(t) || n && S.has(t) || r && E.has(t) || (null == o ? void 0 : o.has(t)) || _.test(t)) && (i[t] = e[t]);
          return i;
        }
        function k(e) {
          if (function () {
            if (null == A) {
              A = !1;
              try {
                document.createElement("div").focus({
                  get preventScroll() {
                    return A = !0, !0;
                  }
                });
              } catch (e) {}
            }
            return A;
          }()) e.focus({
            preventScroll: !0
          });else {
            let t = function (e) {
              let t = e.parentNode,
                n = [],
                r = document.scrollingElement || document.documentElement;
              for (; t instanceof HTMLElement && t !== r;) (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
                element: t,
                scrollTop: t.scrollTop,
                scrollLeft: t.scrollLeft
              }), t = t.parentNode;
              r instanceof HTMLElement && n.push({
                element: r,
                scrollTop: r.scrollTop,
                scrollLeft: r.scrollLeft
              });
              return n;
            }(e);
            e.focus(), function (e) {
              for (let {
                element: t,
                scrollTop: n,
                scrollLeft: r
              } of e) t.scrollTop = n, t.scrollLeft = r;
            }(t);
          }
        }
        let A = null;
        function z(e) {
          var t;
          return "undefined" != typeof window && null != window.navigator && ((null === (t = window.navigator.userAgentData) || void 0 === t ? void 0 : t.brands.some(t => e.test(t.brand))) || e.test(window.navigator.userAgent));
        }
        function T(e) {
          var t;
          return "undefined" != typeof window && null != window.navigator && e.test((null === (t = window.navigator.userAgentData) || void 0 === t ? void 0 : t.platform) || window.navigator.platform);
        }
        function O() {
          return T(/^Mac/i);
        }
        function I() {
          return T(/^iPhone/i);
        }
        function F() {
          return T(/^iPad/i) || O() && navigator.maxTouchPoints > 1;
        }
        function M() {
          return I() || F();
        }
        function R() {
          return O() || M();
        }
        function j() {
          return z(/AppleWebKit/i) && !B();
        }
        function B() {
          return z(/Chrome/i);
        }
        function N() {
          return z(/Android/i);
        }
        function L() {
          return z(/Firefox/i);
        }
        const V = (0, o.createContext)({
          isNative: !0,
          open: function (e, t) {
            U(e, e => H(e, t));
          }
        });
        function K() {
          return (0, o.useContext)(V);
        }
        function q(e, t) {
          let n = e.getAttribute("target");
          return !(n && "_self" !== n || e.origin !== location.origin || e.hasAttribute("download") || t.metaKey || t.ctrlKey || t.altKey || t.shiftKey);
        }
        function H(e, t, n = !0) {
          var r, o;
          let {
            metaKey: i,
            ctrlKey: a,
            altKey: s,
            shiftKey: l
          } = t;
          L() && (null === (o = window.event) || void 0 === o || null === (r = o.type) || void 0 === r ? void 0 : r.startsWith("key")) && "_blank" === e.target && (O() ? i = !0 : a = !0);
          let u = j() && O() && !F() ? new KeyboardEvent("keydown", {
            keyIdentifier: "Enter",
            metaKey: i,
            ctrlKey: a,
            altKey: s,
            shiftKey: l
          }) : new MouseEvent("click", {
            metaKey: i,
            ctrlKey: a,
            altKey: s,
            shiftKey: l,
            bubbles: !0,
            cancelable: !0
          });
          H.isOpening = n, k(e), e.dispatchEvent(u), H.isOpening = !1;
        }
        function U(e, t) {
          if (e instanceof HTMLAnchorElement) t(e);else if (e.hasAttribute("data-href")) {
            let n = document.createElement("a");
            n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
          }
        }
        function Z(e) {
          return {
            "data-href": e.href,
            "data-target": e.target,
            "data-rel": e.rel,
            "data-download": e.download,
            "data-ping": e.ping,
            "data-referrer-policy": e.referrerPolicy
          };
        }
        H.isOpening = !1;
        let $ = new Map(),
          G = new Set();
        function W() {
          if ("undefined" == typeof window) return;
          function e(e) {
            return "propertyName" in e;
          }
          let t = n => {
            if (!e(n) || !n.target) return;
            let r = $.get(n.target);
            if (r && (r.delete(n.propertyName), 0 === r.size && (n.target.removeEventListener("transitioncancel", t), $.delete(n.target)), 0 === $.size)) {
              for (let e of G) e();
              G.clear();
            }
          };
          document.body.addEventListener("transitionrun", n => {
            if (!e(n) || !n.target) return;
            let r = $.get(n.target);
            r || (r = new Set(), $.set(n.target, r), n.target.addEventListener("transitioncancel", t, {
              once: !0
            })), r.add(n.propertyName);
          }), document.body.addEventListener("transitionend", t);
        }
        function Y(e) {
          requestAnimationFrame(() => {
            0 === $.size ? e() : G.add(e);
          });
        }
        "undefined" != typeof document && ("loading" !== document.readyState ? W() : document.addEventListener("DOMContentLoaded", W));
        function X() {
          let e = (0, o.useRef)(new Map()),
            t = (0, o.useCallback)((t, n, r, o) => {
              let i = (null == o ? void 0 : o.once) ? (...t) => {
                e.current.delete(r), r(...t);
              } : r;
              e.current.set(r, {
                type: n,
                eventTarget: t,
                fn: i,
                options: o
              }), t.addEventListener(n, r, o);
            }, []),
            n = (0, o.useCallback)((t, n, r, o) => {
              var i;
              let a = (null === (i = e.current.get(r)) || void 0 === i ? void 0 : i.fn) || r;
              t.removeEventListener(n, a, o), e.current.delete(r);
            }, []),
            r = (0, o.useCallback)(() => {
              e.current.forEach((e, t) => {
                n(e.eventTarget, e.type, t, e.options);
              });
            }, [n]);
          return (0, o.useEffect)(() => r, [r]), {
            addGlobalListener: t,
            removeGlobalListener: n,
            removeAllGlobalListeners: r
          };
        }
        function Q(e, t) {
          let {
            id: n,
            "aria-label": r,
            "aria-labelledby": o
          } = e;
          if (n = p(n), o && r) {
            let e = new Set([n, ...o.trim().split(/\s+/)]);
            o = [...e].join(" ");
          } else o && (o = o.trim().split(/\s+/).join(" "));
          return r || o || !t || (r = t), {
            id: n,
            "aria-label": r,
            "aria-labelledby": o
          };
        }
        function J(e) {
          const t = (0, o.useRef)(null);
          return (0, o.useMemo)(() => ({
            get current() {
              return t.current;
            },
            set current(n) {
              t.current = n, "function" == typeof e ? e(n) : e && (e.current = n);
            }
          }), [e]);
        }
        function ee(e, t) {
          const n = (0, o.useRef)(!0),
            r = (0, o.useRef)(null);
          (0, o.useEffect)(() => (n.current = !0, () => {
            n.current = !1;
          }), []), (0, o.useEffect)(() => {
            n.current ? n.current = !1 : r.current && !t.some((e, t) => !Object.is(e, r[t])) || e(), r.current = t;
          }, t);
        }
        function te(e) {
          const {
            ref: t,
            onResize: n
          } = e;
          (0, o.useEffect)(() => {
            let e = null == t ? void 0 : t.current;
            if (e) {
              if (void 0 === window.ResizeObserver) return window.addEventListener("resize", n, !1), () => {
                window.removeEventListener("resize", n, !1);
              };
              {
                const t = new window.ResizeObserver(e => {
                  e.length && n();
                });
                return t.observe(e), () => {
                  e && t.unobserve(e);
                };
              }
            }
          }, [n, t]);
        }
        function ne(e, t) {
          s(() => {
            if (e && e.ref && t) return e.ref.current = t.current, () => {
              e.ref && (e.ref.current = null);
            };
          });
        }
        function re(e, t) {
          let n = e;
          for (oe(n, t) && (n = n.parentElement); n && !oe(n, t);) n = n.parentElement;
          return n || document.scrollingElement || document.documentElement;
        }
        function oe(e, t) {
          let n = window.getComputedStyle(e),
            r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
          return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
        }
        let ie = "undefined" != typeof document && window.visualViewport;
        function ae() {
          let e = (0, i.Av)(),
            [t, n] = (0, o.useState)(() => e ? {
              width: 0,
              height: 0
            } : se());
          return (0, o.useEffect)(() => {
            let e = () => {
              n(e => {
                let t = se();
                return t.width === e.width && t.height === e.height ? e : t;
              });
            };
            return ie ? ie.addEventListener("resize", e) : window.addEventListener("resize", e), () => {
              ie ? ie.removeEventListener("resize", e) : window.removeEventListener("resize", e);
            };
          }, []), t;
        }
        function se() {
          return {
            width: ie && (null == ie ? void 0 : ie.width) || window.innerWidth,
            height: ie && (null == ie ? void 0 : ie.height) || window.innerHeight
          };
        }
        let le = 0;
        const ue = new Map();
        function ce(e) {
          let [t, n] = (0, o.useState)();
          return s(() => {
            if (!e) return;
            let t = ue.get(e);
            if (t) n(t.element.id);else {
              let r = "react-aria-description-" + le++;
              n(r);
              let o = document.createElement("div");
              o.id = r, o.style.display = "none", o.textContent = e, document.body.appendChild(o), t = {
                refCount: 0,
                element: o
              }, ue.set(e, t);
            }
            return t.refCount++, () => {
              t && 0 == --t.refCount && (t.element.remove(), ue.delete(e));
            };
          }, [e]), {
            "aria-describedby": e ? t : void 0
          };
        }
        function de(e, t, n, r) {
          let i = l(n),
            a = null == n;
          (0, o.useEffect)(() => {
            if (a || !e.current) return;
            let n = e.current;
            return n.addEventListener(t, i, r), () => {
              n.removeEventListener(t, i, r);
            };
          }, [e, t, r, a, i]);
        }
        function pe(e, t) {
          let n = he(e, t, "left"),
            r = he(e, t, "top"),
            o = t.offsetWidth,
            i = t.offsetHeight,
            a = e.scrollLeft,
            s = e.scrollTop,
            {
              borderTopWidth: l,
              borderLeftWidth: u
            } = getComputedStyle(e),
            c = e.scrollLeft + parseInt(u, 10),
            d = e.scrollTop + parseInt(l, 10),
            p = c + e.clientWidth,
            h = d + e.clientHeight;
          n <= a ? a = n - parseInt(u, 10) : n + o > p && (a += n + o - p), r <= d ? s = r - parseInt(l, 10) : r + i > h && (s += r + i - h), e.scrollLeft = a, e.scrollTop = s;
        }
        function he(e, t, n) {
          const r = "left" === n ? "offsetLeft" : "offsetTop";
          let o = 0;
          for (; t.offsetParent && (o += t[r], t.offsetParent !== e);) {
            if (t.offsetParent.contains(e)) {
              o -= e[r];
              break;
            }
            t = t.offsetParent;
          }
          return o;
        }
        function fe(e, t) {
          if (document.contains(e)) {
            let a = document.scrollingElement || document.documentElement;
            if ("hidden" === window.getComputedStyle(a).overflow) {
              let t = re(e);
              for (; e && t && e !== a && t !== a;) pe(t, e), t = re(e = t);
            } else {
              var n;
              let {
                left: a,
                top: s
              } = e.getBoundingClientRect();
              null == e || null === (n = e.scrollIntoView) || void 0 === n || n.call(e, {
                block: "nearest"
              });
              let {
                left: l,
                top: u
              } = e.getBoundingClientRect();
              var r, o, i;
              if (Math.abs(a - l) > 1 || Math.abs(s - u) > 1) null == t || null === (o = t.containingElement) || void 0 === o || null === (r = o.scrollIntoView) || void 0 === r || r.call(o, {
                block: "center",
                inline: "center"
              }), null === (i = e.scrollIntoView) || void 0 === i || i.call(e, {
                block: "nearest"
              });
            }
          }
        }
        function me(e) {
          return !(0 !== e.mozInputSource || !e.isTrusted) || (N() && e.pointerType ? "click" === e.type && 1 === e.buttons : 0 === e.detail && !e.pointerType);
        }
        function ge(e) {
          return !N() && 0 === e.width && 0 === e.height || 1 === e.width && 1 === e.height && 0 === e.pressure && 0 === e.detail && "mouse" === e.pointerType;
        }
        function ve(e, t) {
          let n = (0, o.useRef)(null);
          return e && n.current && t(e, n.current) && (e = n.current), n.current = e, e;
        }
        function ye(e, t, n) {
          let r = (0, o.useRef)(t),
            i = l(() => {
              n && n(r.current);
            });
          (0, o.useEffect)(() => {
            var t;
            let n = null == e || null === (t = e.current) || void 0 === t ? void 0 : t.form;
            return null == n || n.addEventListener("reset", i), () => {
              null == n || n.removeEventListener("reset", i);
            };
          }, [e, i]);
        }
      },
      55387: (e, t, n) => {
        "use strict";

        n.d(t, {
          S: () => s,
          T: () => l
        });
        var r = n(20770),
          o = n(67294),
          i = n(49987);
        const a = {
          border: 0,
          clip: "rect(0 0 0 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "-1px",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        };
        function s(e = {}) {
          let {
              style: t,
              isFocusable: n
            } = e,
            [r, s] = (0, o.useState)(!1),
            {
              focusWithinProps: l
            } = (0, i.L_)({
              isDisabled: !n,
              onFocusWithinChange: e => s(e)
            });
          return {
            visuallyHiddenProps: {
              ...l,
              style: (0, o.useMemo)(() => r ? t : t ? {
                ...a,
                ...t
              } : a, [r])
            }
          };
        }
        function l(e) {
          let {
              children: t,
              elementType: n = "div",
              isFocusable: i,
              style: a,
              ...l
            } = e,
            {
              visuallyHiddenProps: u
            } = s(e);
          return o.createElement(n, (0, r.dG)(l, u), t);
        }
      },
      43098: (e, t, n) => {
        "use strict";

        n.d(t, {
          q: () => Hn,
          vc: () => kt,
          Z5: () => be,
          JZ: () => Xe,
          q_: () => Dn,
          Yz: () => Cn
        });
        var r = n(67294),
          o = Object.defineProperty,
          i = {};
        ((e, t) => {
          for (var n in t) o(e, n, {
            get: t[n],
            enumerable: !0
          });
        })(i, {
          assign: () => B,
          colors: () => M,
          createStringInterpolator: () => T,
          skipAnimation: () => R,
          to: () => O,
          willAdvance: () => j
        });
        var a = D(),
          s = e => y(e, a),
          l = D();
        s.write = e => y(e, l);
        var u = D();
        s.onStart = e => y(e, u);
        var c = D();
        s.onFrame = e => y(e, c);
        var d = D();
        s.onFinish = e => y(e, d);
        var p = [];
        s.setTimeout = (e, t) => {
          const n = s.now() + t,
            r = () => {
              const e = p.findIndex(e => e.cancel == r);
              ~e && p.splice(e, 1), g -= ~e ? 1 : 0;
            },
            o = {
              time: n,
              handler: e,
              cancel: r
            };
          return p.splice(h(n), 0, o), g += 1, b(), o;
        };
        var h = e => ~(~p.findIndex(t => t.time > e) || ~p.length);
        s.cancel = e => {
          u.delete(e), c.delete(e), d.delete(e), a.delete(e), l.delete(e);
        }, s.sync = e => {
          v = !0, s.batchedUpdates(e), v = !1;
        }, s.throttle = e => {
          let t;
          function n() {
            try {
              e(...t);
            } finally {
              t = null;
            }
          }
          function r(...e) {
            t = e, s.onStart(n);
          }
          return r.handler = e, r.cancel = () => {
            u.delete(n), t = null;
          }, r;
        };
        var f = "undefined" != typeof window ? window.requestAnimationFrame : () => {};
        s.use = e => f = e, s.now = "undefined" != typeof performance ? () => performance.now() : Date.now, s.batchedUpdates = e => e(), s.catch = console.error, s.frameLoop = "always", s.advance = () => {
          "demand" !== s.frameLoop ? console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand") : x();
        };
        var m = -1,
          g = 0,
          v = !1;
        function y(e, t) {
          v ? (t.delete(e), e(0)) : (t.add(e), b());
        }
        function b() {
          m < 0 && (m = 0, "demand" !== s.frameLoop && f(w));
        }
        function w() {
          ~m && (f(w), s.batchedUpdates(x));
        }
        function x() {
          const e = m;
          m = s.now();
          const t = h(m);
          t && (C(p.splice(0, t), e => e.handler()), g -= t), g ? (u.flush(), a.flush(e ? Math.min(64, m - e) : 16.667), c.flush(), l.flush(), d.flush()) : m = -1;
        }
        function D() {
          let e = new Set(),
            t = e;
          return {
            add(n) {
              g += t != e || e.has(n) ? 0 : 1, e.add(n);
            },
            delete: n => (g -= t == e && e.has(n) ? 1 : 0, e.delete(n)),
            flush(n) {
              t.size && (e = new Set(), g -= t.size, C(t, t => t(n) && e.add(t)), g += e.size, t = e);
            }
          };
        }
        function C(e, t) {
          e.forEach(e => {
            try {
              t(e);
            } catch (e) {
              s.catch(e);
            }
          });
        }
        function S() {}
        var E = {
          arr: Array.isArray,
          obj: e => !!e && "Object" === e.constructor.name,
          fun: e => "function" == typeof e,
          str: e => "string" == typeof e,
          num: e => "number" == typeof e,
          und: e => void 0 === e
        };
        function _(e, t) {
          if (E.arr(e)) {
            if (!E.arr(t) || e.length !== t.length) return !1;
            for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
            return !0;
          }
          return e === t;
        }
        var P = (e, t) => e.forEach(t);
        function k(e, t, n) {
          if (E.arr(e)) for (let r = 0; r < e.length; r++) t.call(n, e[r], `${r}`);else for (const r in e) e.hasOwnProperty(r) && t.call(n, e[r], r);
        }
        var A = e => E.und(e) ? [] : E.arr(e) ? e : [e];
        function z(e, t) {
          if (e.size) {
            const n = Array.from(e);
            e.clear(), P(n, t);
          }
        }
        var T,
          O,
          I = (e, ...t) => z(e, e => e(...t)),
          F = () => "undefined" == typeof window || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent),
          M = null,
          R = !1,
          j = S,
          B = e => {
            e.to && (O = e.to), e.now && (s.now = e.now), void 0 !== e.colors && (M = e.colors), null != e.skipAnimation && (R = e.skipAnimation), e.createStringInterpolator && (T = e.createStringInterpolator), e.requestAnimationFrame && s.use(e.requestAnimationFrame), e.batchedUpdates && (s.batchedUpdates = e.batchedUpdates), e.willAdvance && (j = e.willAdvance), e.frameLoop && (s.frameLoop = e.frameLoop);
          },
          N = new Set(),
          L = [],
          V = [],
          K = 0,
          q = {
            get idle() {
              return !N.size && !L.length;
            },
            start(e) {
              K > e.priority ? (N.add(e), s.onStart(H)) : (U(e), s($));
            },
            advance: $,
            sort(e) {
              if (K) s.onFrame(() => q.sort(e));else {
                const t = L.indexOf(e);
                ~t && (L.splice(t, 1), Z(e));
              }
            },
            clear() {
              L = [], N.clear();
            }
          };
        function H() {
          N.forEach(U), N.clear(), s($);
        }
        function U(e) {
          L.includes(e) || Z(e);
        }
        function Z(e) {
          L.splice(function (e, t) {
            const n = e.findIndex(t);
            return n < 0 ? e.length : n;
          }(L, t => t.priority > e.priority), 0, e);
        }
        function $(e) {
          const t = V;
          for (let n = 0; n < L.length; n++) {
            const r = L[n];
            K = r.priority, r.idle || (j(r), r.advance(e), r.idle || t.push(r));
          }
          return K = 0, (V = L).length = 0, (L = t).length > 0;
        }
        var G = "[-+]?\\d*\\.?\\d+",
          W = G + "%";
        function Y(...e) {
          return "\\(\\s*(" + e.join(")\\s*,\\s*(") + ")\\s*\\)";
        }
        var X = new RegExp("rgb" + Y(G, G, G)),
          Q = new RegExp("rgba" + Y(G, G, G, G)),
          J = new RegExp("hsl" + Y(G, W, W)),
          ee = new RegExp("hsla" + Y(G, W, W, G)),
          te = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          ne = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
          re = /^#([0-9a-fA-F]{6})$/,
          oe = /^#([0-9a-fA-F]{8})$/;
        function ie(e, t, n) {
          return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
        }
        function ae(e, t, n) {
          const r = n < .5 ? n * (1 + t) : n + t - n * t,
            o = 2 * n - r,
            i = ie(o, r, e + 1 / 3),
            a = ie(o, r, e),
            s = ie(o, r, e - 1 / 3);
          return Math.round(255 * i) << 24 | Math.round(255 * a) << 16 | Math.round(255 * s) << 8;
        }
        function se(e) {
          const t = parseInt(e, 10);
          return t < 0 ? 0 : t > 255 ? 255 : t;
        }
        function le(e) {
          return (parseFloat(e) % 360 + 360) % 360 / 360;
        }
        function ue(e) {
          const t = parseFloat(e);
          return t < 0 ? 0 : t > 1 ? 255 : Math.round(255 * t);
        }
        function ce(e) {
          const t = parseFloat(e);
          return t < 0 ? 0 : t > 100 ? 1 : t / 100;
        }
        function de(e) {
          let t = function (e) {
            let t;
            return "number" == typeof e ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = re.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : M && void 0 !== M[e] ? M[e] : (t = X.exec(e)) ? (se(t[1]) << 24 | se(t[2]) << 16 | se(t[3]) << 8 | 255) >>> 0 : (t = Q.exec(e)) ? (se(t[1]) << 24 | se(t[2]) << 16 | se(t[3]) << 8 | ue(t[4])) >>> 0 : (t = te.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + "ff", 16) >>> 0 : (t = oe.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = ne.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + t[4] + t[4], 16) >>> 0 : (t = J.exec(e)) ? (255 | ae(le(t[1]), ce(t[2]), ce(t[3]))) >>> 0 : (t = ee.exec(e)) ? (ae(le(t[1]), ce(t[2]), ce(t[3])) | ue(t[4])) >>> 0 : null;
          }(e);
          if (null === t) return e;
          t = t || 0;
          return `rgba(${(4278190080 & t) >>> 24}, ${(16711680 & t) >>> 16}, ${(65280 & t) >>> 8}, ${(255 & t) / 255})`;
        }
        var pe = (e, t, n) => {
          if (E.fun(e)) return e;
          if (E.arr(e)) return pe({
            range: e,
            output: t,
            extrapolate: n
          });
          if (E.str(e.output[0])) return T(e);
          const r = e,
            o = r.output,
            i = r.range || [0, 1],
            a = r.extrapolateLeft || r.extrapolate || "extend",
            s = r.extrapolateRight || r.extrapolate || "extend",
            l = r.easing || (e => e);
          return e => {
            const t = function (e, t) {
              for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n);
              return n - 1;
            }(e, i);
            return function (e, t, n, r, o, i, a, s, l) {
              let u = l ? l(e) : e;
              if (u < t) {
                if ("identity" === a) return u;
                "clamp" === a && (u = t);
              }
              if (u > n) {
                if ("identity" === s) return u;
                "clamp" === s && (u = n);
              }
              if (r === o) return r;
              if (t === n) return e <= t ? r : o;
              t === -1 / 0 ? u = -u : n === 1 / 0 ? u -= t : u = (u - t) / (n - t);
              u = i(u), r === -1 / 0 ? u = -u : o === 1 / 0 ? u += r : u = u * (o - r) + r;
              return u;
            }(e, i[t], i[t + 1], o[t], o[t + 1], l, a, s, r.map);
          };
        };
        var he = 1.70158,
          fe = 1.525 * he,
          me = he + 1,
          ge = 2 * Math.PI / 3,
          ve = 2 * Math.PI / 4.5,
          ye = e => {
            const t = 7.5625,
              n = 2.75;
            return e < 1 / n ? t * e * e : e < 2 / n ? t * (e -= 1.5 / n) * e + .75 : e < 2.5 / n ? t * (e -= 2.25 / n) * e + .9375 : t * (e -= 2.625 / n) * e + .984375;
          },
          be = {
            linear: e => e,
            easeInQuad: e => e * e,
            easeOutQuad: e => 1 - (1 - e) * (1 - e),
            easeInOutQuad: e => e < .5 ? 2 * e * e : 1 - Math.pow(-2 * e + 2, 2) / 2,
            easeInCubic: e => e * e * e,
            easeOutCubic: e => 1 - Math.pow(1 - e, 3),
            easeInOutCubic: e => e < .5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2,
            easeInQuart: e => e * e * e * e,
            easeOutQuart: e => 1 - Math.pow(1 - e, 4),
            easeInOutQuart: e => e < .5 ? 8 * e * e * e * e : 1 - Math.pow(-2 * e + 2, 4) / 2,
            easeInQuint: e => e * e * e * e * e,
            easeOutQuint: e => 1 - Math.pow(1 - e, 5),
            easeInOutQuint: e => e < .5 ? 16 * e * e * e * e * e : 1 - Math.pow(-2 * e + 2, 5) / 2,
            easeInSine: e => 1 - Math.cos(e * Math.PI / 2),
            easeOutSine: e => Math.sin(e * Math.PI / 2),
            easeInOutSine: e => -(Math.cos(Math.PI * e) - 1) / 2,
            easeInExpo: e => 0 === e ? 0 : Math.pow(2, 10 * e - 10),
            easeOutExpo: e => 1 === e ? 1 : 1 - Math.pow(2, -10 * e),
            easeInOutExpo: e => 0 === e ? 0 : 1 === e ? 1 : e < .5 ? Math.pow(2, 20 * e - 10) / 2 : (2 - Math.pow(2, -20 * e + 10)) / 2,
            easeInCirc: e => 1 - Math.sqrt(1 - Math.pow(e, 2)),
            easeOutCirc: e => Math.sqrt(1 - Math.pow(e - 1, 2)),
            easeInOutCirc: e => e < .5 ? (1 - Math.sqrt(1 - Math.pow(2 * e, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * e + 2, 2)) + 1) / 2,
            easeInBack: e => me * e * e * e - he * e * e,
            easeOutBack: e => 1 + me * Math.pow(e - 1, 3) + he * Math.pow(e - 1, 2),
            easeInOutBack: e => e < .5 ? Math.pow(2 * e, 2) * (7.189819 * e - fe) / 2 : (Math.pow(2 * e - 2, 2) * ((fe + 1) * (2 * e - 2) + fe) + 2) / 2,
            easeInElastic: e => 0 === e ? 0 : 1 === e ? 1 : -Math.pow(2, 10 * e - 10) * Math.sin((10 * e - 10.75) * ge),
            easeOutElastic: e => 0 === e ? 0 : 1 === e ? 1 : Math.pow(2, -10 * e) * Math.sin((10 * e - .75) * ge) + 1,
            easeInOutElastic: e => 0 === e ? 0 : 1 === e ? 1 : e < .5 ? -Math.pow(2, 20 * e - 10) * Math.sin((20 * e - 11.125) * ve) / 2 : Math.pow(2, -20 * e + 10) * Math.sin((20 * e - 11.125) * ve) / 2 + 1,
            easeInBounce: e => 1 - ye(1 - e),
            easeOutBounce: ye,
            easeInOutBounce: e => e < .5 ? (1 - ye(1 - 2 * e)) / 2 : (1 + ye(2 * e - 1)) / 2,
            steps: (e, t = "end") => n => {
              const r = (n = "end" === t ? Math.min(n, .999) : Math.max(n, .001)) * e;
              return ((e, t, n) => Math.min(Math.max(n, e), t))(0, 1, ("end" === t ? Math.floor(r) : Math.ceil(r)) / e);
            }
          },
          we = Symbol.for("FluidValue.get"),
          xe = Symbol.for("FluidValue.observers"),
          De = e => Boolean(e && e[we]),
          Ce = e => e && e[we] ? e[we]() : e,
          Se = e => e[xe] || null;
        function Ee(e, t) {
          const n = e[xe];
          n && n.forEach(e => {
            !function (e, t) {
              e.eventObserved ? e.eventObserved(t) : e(t);
            }(e, t);
          });
        }
        var _e = class {
            constructor(e) {
              if (!e && !(e = this.get)) throw Error("Unknown getter");
              Pe(this, e);
            }
          },
          Pe = (e, t) => Te(e, we, t);
        function ke(e, t) {
          if (e[we]) {
            let n = e[xe];
            n || Te(e, xe, n = new Set()), n.has(t) || (n.add(t), e.observerAdded && e.observerAdded(n.size, t));
          }
          return t;
        }
        function Ae(e, t) {
          const n = e[xe];
          if (n && n.has(t)) {
            const r = n.size - 1;
            r ? n.delete(t) : e[xe] = null, e.observerRemoved && e.observerRemoved(r, t);
          }
        }
        var ze,
          Te = (e, t, n) => Object.defineProperty(e, t, {
            value: n,
            writable: !0,
            configurable: !0
          }),
          Oe = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
          Ie = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
          Fe = new RegExp(`(${Oe.source})(%|[a-z]+)`, "i"),
          Me = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi,
          Re = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/,
          je = e => {
            const [t, n] = Be(e);
            if (!t || F()) return e;
            const r = window.getComputedStyle(document.documentElement).getPropertyValue(t);
            if (r) return r.trim();
            if (n && n.startsWith("--")) {
              const t = window.getComputedStyle(document.documentElement).getPropertyValue(n);
              return t || e;
            }
            return n && Re.test(n) ? je(n) : n || e;
          },
          Be = e => {
            const t = Re.exec(e);
            if (!t) return [,];
            const [, n, r] = t;
            return [n, r];
          },
          Ne = (e, t, n, r, o) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${o})`,
          Le = e => {
            ze || (ze = M ? new RegExp(`(${Object.keys(M).join("|")})(?!\\w)`, "g") : /^\b$/);
            const t = e.output.map(e => Ce(e).replace(Re, je).replace(Ie, de).replace(ze, de)),
              n = t.map(e => e.match(Oe).map(Number)),
              r = n[0].map((e, t) => n.map(e => {
                if (!(t in e)) throw Error('The arity of each "output" value must be equal');
                return e[t];
              })).map(t => pe({
                ...e,
                output: t
              }));
            return e => {
              const n = !Fe.test(t[0]) && t.find(e => Fe.test(e))?.replace(Oe, "");
              let o = 0;
              return t[0].replace(Oe, () => `${r[o++](e)}${n || ""}`).replace(Me, Ne);
            };
          },
          Ve = "react-spring: ",
          Ke = e => {
            const t = e;
            let n = !1;
            if ("function" != typeof t) throw new TypeError(`${Ve}once requires a function parameter`);
            return (...e) => {
              n || (t(...e), n = !0);
            };
          },
          qe = Ke(console.warn);
        var He = Ke(console.warn);
        function Ue(e) {
          return E.str(e) && ("#" == e[0] || /\d/.test(e) || !F() && Re.test(e) || e in (M || {}));
        }
        var Ze = F() ? r.useEffect : r.useLayoutEffect;
        function $e() {
          const e = (0, r.useState)()[1],
            t = (() => {
              const e = (0, r.useRef)(!1);
              return Ze(() => (e.current = !0, () => {
                e.current = !1;
              }), []), e;
            })();
          return () => {
            t.current && e(Math.random());
          };
        }
        var Ge = e => (0, r.useEffect)(e, We),
          We = [];
        function Ye(e) {
          const t = (0, r.useRef)();
          return (0, r.useEffect)(() => {
            t.current = e;
          }), t.current;
        }
        var Xe = () => {
            const [e, t] = (0, r.useState)(null);
            return Ze(() => {
              const e = window.matchMedia("(prefers-reduced-motion)"),
                n = e => {
                  t(e.matches), B({
                    skipAnimation: e.matches
                  });
                };
              return n(e), e.addEventListener("change", n), () => {
                e.removeEventListener("change", n);
              };
            }, []), e;
          },
          Qe = Symbol.for("Animated:node"),
          Je = e => e && e[Qe],
          et = (e, t) => {
            return n = e, r = Qe, o = t, Object.defineProperty(n, r, {
              value: o,
              writable: !0,
              configurable: !0
            });
            var n, r, o;
          },
          tt = e => e && e[Qe] && e[Qe].getPayload(),
          nt = class {
            constructor() {
              et(this, this);
            }
            getPayload() {
              return this.payload || [];
            }
          },
          rt = class extends nt {
            constructor(e) {
              super(), this._value = e, this.done = !0, this.durationProgress = 0, E.num(this._value) && (this.lastPosition = this._value);
            }
            static create(e) {
              return new rt(e);
            }
            getPayload() {
              return [this];
            }
            getValue() {
              return this._value;
            }
            setValue(e, t) {
              return E.num(e) && (this.lastPosition = e, t && (e = Math.round(e / t) * t, this.done && (this.lastPosition = e))), this._value !== e && (this._value = e, !0);
            }
            reset() {
              const {
                done: e
              } = this;
              this.done = !1, E.num(this._value) && (this.elapsedTime = 0, this.durationProgress = 0, this.lastPosition = this._value, e && (this.lastVelocity = null), this.v0 = null);
            }
          },
          ot = class extends rt {
            constructor(e) {
              super(0), this._string = null, this._toString = pe({
                output: [e, e]
              });
            }
            static create(e) {
              return new ot(e);
            }
            getValue() {
              const e = this._string;
              return null == e ? this._string = this._toString(this._value) : e;
            }
            setValue(e) {
              if (E.str(e)) {
                if (e == this._string) return !1;
                this._string = e, this._value = 1;
              } else {
                if (!super.setValue(e)) return !1;
                this._string = null;
              }
              return !0;
            }
            reset(e) {
              e && (this._toString = pe({
                output: [this.getValue(), e]
              })), this._value = 0, super.reset();
            }
          },
          it = {
            dependencies: null
          },
          at = class extends nt {
            constructor(e) {
              super(), this.source = e, this.setValue(e);
            }
            getValue(e) {
              const t = {};
              return k(this.source, (n, r) => {
                var o;
                (o = n) && o[Qe] === o ? t[r] = n.getValue(e) : De(n) ? t[r] = Ce(n) : e || (t[r] = n);
              }), t;
            }
            setValue(e) {
              this.source = e, this.payload = this._makePayload(e);
            }
            reset() {
              this.payload && P(this.payload, e => e.reset());
            }
            _makePayload(e) {
              if (e) {
                const t = new Set();
                return k(e, this._addToPayload, t), Array.from(t);
              }
            }
            _addToPayload(e) {
              it.dependencies && De(e) && it.dependencies.add(e);
              const t = tt(e);
              t && P(t, e => this.add(e));
            }
          },
          st = class extends at {
            constructor(e) {
              super(e);
            }
            static create(e) {
              return new st(e);
            }
            getValue() {
              return this.source.map(e => e.getValue());
            }
            setValue(e) {
              const t = this.getPayload();
              return e.length == t.length ? t.map((t, n) => t.setValue(e[n])).some(Boolean) : (super.setValue(e.map(lt)), !0);
            }
          };
        function lt(e) {
          return (Ue(e) ? ot : rt).create(e);
        }
        function ut(e) {
          const t = Je(e);
          return t ? t.constructor : E.arr(e) ? st : Ue(e) ? ot : rt;
        }
        var ct = (e, t) => {
            const n = !E.fun(e) || e.prototype && e.prototype.isReactComponent;
            return (0, r.forwardRef)((o, i) => {
              const a = (0, r.useRef)(null),
                l = n && (0, r.useCallback)(e => {
                  a.current = function (e, t) {
                    e && (E.fun(e) ? e(t) : e.current = t);
                    return t;
                  }(i, e);
                }, [i]),
                [u, c] = function (e, t) {
                  const n = new Set();
                  it.dependencies = n, e.style && (e = {
                    ...e,
                    style: t.createAnimatedStyle(e.style)
                  });
                  return e = new at(e), it.dependencies = null, [e, n];
                }(o, t),
                d = $e(),
                p = () => {
                  const e = a.current;
                  if (n && !e) return;
                  !1 === (!!e && t.applyAnimatedValues(e, u.getValue(!0))) && d();
                },
                h = new dt(p, c),
                f = (0, r.useRef)();
              Ze(() => (f.current = h, P(c, e => ke(e, h)), () => {
                f.current && (P(f.current.deps, e => Ae(e, f.current)), s.cancel(f.current.update));
              })), (0, r.useEffect)(p, []), Ge(() => () => {
                const e = f.current;
                P(e.deps, t => Ae(t, e));
              });
              const m = t.getComponentProps(u.getValue());
              return r.createElement(e, {
                ...m,
                ref: l
              });
            });
          },
          dt = class {
            constructor(e, t) {
              this.update = e, this.deps = t;
            }
            eventObserved(e) {
              "change" == e.type && s.write(this.update);
            }
          };
        var pt = Symbol.for("AnimatedComponent"),
          ht = e => E.str(e) ? e : e && E.str(e.displayName) ? e.displayName : E.fun(e) && e.name || null;
        function ft(e, ...t) {
          return E.fun(e) ? e(...t) : e;
        }
        var mt = (e, t) => !0 === e || !!(t && e && (E.fun(e) ? e(t) : A(e).includes(t))),
          gt = (e, t) => E.obj(e) ? t && e[t] : e,
          vt = (e, t) => !0 === e.default ? e[t] : e.default ? e.default[t] : void 0,
          yt = e => e,
          bt = (e, t = yt) => {
            let n = wt;
            e.default && !0 !== e.default && (e = e.default, n = Object.keys(e));
            const r = {};
            for (const o of n) {
              const n = t(e[o], o);
              E.und(n) || (r[o] = n);
            }
            return r;
          },
          wt = ["config", "onProps", "onStart", "onChange", "onPause", "onResume", "onRest"],
          xt = {
            config: 1,
            from: 1,
            to: 1,
            ref: 1,
            loop: 1,
            reset: 1,
            pause: 1,
            cancel: 1,
            reverse: 1,
            immediate: 1,
            default: 1,
            delay: 1,
            onProps: 1,
            onStart: 1,
            onChange: 1,
            onPause: 1,
            onResume: 1,
            onRest: 1,
            onResolve: 1,
            items: 1,
            trail: 1,
            sort: 1,
            expires: 1,
            initial: 1,
            enter: 1,
            update: 1,
            leave: 1,
            children: 1,
            onDestroyed: 1,
            keys: 1,
            callId: 1,
            parentId: 1
          };
        function Dt(e) {
          const t = function (e) {
            const t = {};
            let n = 0;
            if (k(e, (e, r) => {
              xt[r] || (t[r] = e, n++);
            }), n) return t;
          }(e);
          if (t) {
            const n = {
              to: t
            };
            return k(e, (e, r) => r in t || (n[r] = e)), n;
          }
          return {
            ...e
          };
        }
        function Ct(e) {
          return e = Ce(e), E.arr(e) ? e.map(Ct) : Ue(e) ? i.createStringInterpolator({
            range: [0, 1],
            output: [e, e]
          })(1) : e;
        }
        function St(e) {
          for (const t in e) return !0;
          return !1;
        }
        function Et(e) {
          return E.fun(e) || E.arr(e) && E.obj(e[0]);
        }
        function _t(e, t) {
          e.ref?.delete(e), t?.delete(e);
        }
        function Pt(e, t) {
          t && e.ref !== t && (e.ref?.delete(e), t.add(e), e.ref = t);
        }
        var kt = {
            default: {
              tension: 170,
              friction: 26
            },
            gentle: {
              tension: 120,
              friction: 14
            },
            wobbly: {
              tension: 180,
              friction: 12
            },
            stiff: {
              tension: 210,
              friction: 20
            },
            slow: {
              tension: 280,
              friction: 60
            },
            molasses: {
              tension: 280,
              friction: 120
            }
          },
          At = {
            ...kt.default,
            mass: 1,
            damping: 1,
            easing: be.linear,
            clamp: !1
          };
        function zt(e, t) {
          if (E.und(t.decay)) {
            const n = !E.und(t.tension) || !E.und(t.friction);
            !n && E.und(t.frequency) && E.und(t.damping) && E.und(t.mass) || (e.duration = void 0, e.decay = void 0), n && (e.frequency = void 0);
          } else e.duration = void 0;
        }
        var Tt = [];
        function Ot(e, {
          key: t,
          props: n,
          defaultProps: r,
          state: o,
          actions: a
        }) {
          return new Promise((l, u) => {
            let c,
              d,
              p = mt(n.cancel ?? r?.cancel, t);
            if (p) m();else {
              E.und(n.pause) || (o.paused = mt(n.pause, t));
              let e = r?.pause;
              !0 !== e && (e = o.paused || mt(e, t)), c = ft(n.delay || 0, t), e ? (o.resumeQueue.add(f), a.pause()) : (a.resume(), f());
            }
            function h() {
              o.resumeQueue.add(f), o.timeouts.delete(d), d.cancel(), c = d.time - s.now();
            }
            function f() {
              c > 0 && !i.skipAnimation ? (o.delayed = !0, d = s.setTimeout(m, c), o.pauseQueue.add(h), o.timeouts.add(d)) : m();
            }
            function m() {
              o.delayed && (o.delayed = !1), o.pauseQueue.delete(h), o.timeouts.delete(d), e <= (o.cancelId || 0) && (p = !0);
              try {
                a.start({
                  ...n,
                  callId: e,
                  cancel: p
                }, l);
              } catch (e) {
                u(e);
              }
            }
          });
        }
        var It = (e, t) => 1 == t.length ? t[0] : t.some(e => e.cancelled) ? Rt(e.get()) : t.every(e => e.noop) ? Ft(e.get()) : Mt(e.get(), t.every(e => e.finished)),
          Ft = e => ({
            value: e,
            noop: !0,
            finished: !0,
            cancelled: !1
          }),
          Mt = (e, t, n = !1) => ({
            value: e,
            finished: t,
            cancelled: n
          }),
          Rt = e => ({
            value: e,
            cancelled: !0,
            finished: !1
          });
        function jt(e, t, n, r) {
          const {
              callId: o,
              parentId: a,
              onRest: l
            } = t,
            {
              asyncTo: u,
              promise: c
            } = n;
          return a || e !== u || t.reset ? n.promise = (async () => {
            n.asyncId = o, n.asyncTo = e;
            const d = bt(t, (e, t) => "onRest" === t ? void 0 : e);
            let p, h;
            const f = new Promise((e, t) => (p = e, h = t)),
              m = e => {
                const t = o <= (n.cancelId || 0) && Rt(r) || o !== n.asyncId && Mt(r, !1);
                if (t) throw e.result = t, h(e), e;
              },
              g = (e, t) => {
                const a = new Nt(),
                  s = new Lt();
                return (async () => {
                  if (i.skipAnimation) throw Bt(n), s.result = Mt(r, !1), h(s), s;
                  m(a);
                  const l = E.obj(e) ? {
                    ...e
                  } : {
                    ...t,
                    to: e
                  };
                  l.parentId = o, k(d, (e, t) => {
                    E.und(l[t]) && (l[t] = e);
                  });
                  const u = await r.start(l);
                  return m(a), n.paused && (await new Promise(e => {
                    n.resumeQueue.add(e);
                  })), u;
                })();
              };
            let v;
            if (i.skipAnimation) return Bt(n), Mt(r, !1);
            try {
              let t;
              t = E.arr(e) ? (async e => {
                for (const t of e) await g(t);
              })(e) : Promise.resolve(e(g, r.stop.bind(r))), await Promise.all([t.then(p), f]), v = Mt(r.get(), !0, !1);
            } catch (e) {
              if (e instanceof Nt) v = e.result;else {
                if (!(e instanceof Lt)) throw e;
                v = e.result;
              }
            } finally {
              o == n.asyncId && (n.asyncId = a, n.asyncTo = a ? u : void 0, n.promise = a ? c : void 0);
            }
            return E.fun(l) && s.batchedUpdates(() => {
              l(v, r, r.item);
            }), v;
          })() : c;
        }
        function Bt(e, t) {
          z(e.timeouts, e => e.cancel()), e.pauseQueue.clear(), e.resumeQueue.clear(), e.asyncId = e.asyncTo = e.promise = void 0, t && (e.cancelId = t);
        }
        var Nt = class extends Error {
            constructor() {
              super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
            }
          },
          Lt = class extends Error {
            constructor() {
              super("SkipAnimationSignal");
            }
          },
          Vt = e => e instanceof qt,
          Kt = 1,
          qt = class extends _e {
            constructor() {
              super(...arguments), this.id = Kt++, this._priority = 0;
            }
            get priority() {
              return this._priority;
            }
            set priority(e) {
              this._priority != e && (this._priority = e, this._onPriorityChange(e));
            }
            get() {
              const e = Je(this);
              return e && e.getValue();
            }
            to(...e) {
              return i.to(this, e);
            }
            interpolate(...e) {
              return qe(`${Ve}The "interpolate" function is deprecated in v9 (use "to" instead)`), i.to(this, e);
            }
            toJSON() {
              return this.get();
            }
            observerAdded(e) {
              1 == e && this._attach();
            }
            observerRemoved(e) {
              0 == e && this._detach();
            }
            _attach() {}
            _detach() {}
            _onChange(e, t = !1) {
              Ee(this, {
                type: "change",
                parent: this,
                value: e,
                idle: t
              });
            }
            _onPriorityChange(e) {
              this.idle || q.sort(this), Ee(this, {
                type: "priority",
                parent: this,
                priority: e
              });
            }
          },
          Ht = Symbol.for("SpringPhase"),
          Ut = e => (1 & e[Ht]) > 0,
          Zt = e => (2 & e[Ht]) > 0,
          $t = e => (4 & e[Ht]) > 0,
          Gt = (e, t) => t ? e[Ht] |= 3 : e[Ht] &= -3,
          Wt = (e, t) => t ? e[Ht] |= 4 : e[Ht] &= -5,
          Yt = class extends qt {
            constructor(e, t) {
              if (super(), this.animation = new class {
                constructor() {
                  this.changed = !1, this.values = Tt, this.toValues = null, this.fromValues = Tt, this.config = new class {
                    constructor() {
                      this.velocity = 0, Object.assign(this, At);
                    }
                  }(), this.immediate = !1;
                }
              }(), this.defaultProps = {}, this._state = {
                paused: !1,
                delayed: !1,
                pauseQueue: new Set(),
                resumeQueue: new Set(),
                timeouts: new Set()
              }, this._pendingCalls = new Set(), this._lastCallId = 0, this._lastToId = 0, this._memoizedDuration = 0, !E.und(e) || !E.und(t)) {
                const n = E.obj(e) ? {
                  ...e
                } : {
                  ...t,
                  from: e
                };
                E.und(n.default) && (n.default = !0), this.start(n);
              }
            }
            get idle() {
              return !(Zt(this) || this._state.asyncTo) || $t(this);
            }
            get goal() {
              return Ce(this.animation.to);
            }
            get velocity() {
              const e = Je(this);
              return e instanceof rt ? e.lastVelocity || 0 : e.getPayload().map(e => e.lastVelocity || 0);
            }
            get hasAnimated() {
              return Ut(this);
            }
            get isAnimating() {
              return Zt(this);
            }
            get isPaused() {
              return $t(this);
            }
            get isDelayed() {
              return this._state.delayed;
            }
            advance(e) {
              let t = !0,
                n = !1;
              const r = this.animation;
              let {
                toValues: o
              } = r;
              const {
                  config: i
                } = r,
                a = tt(r.to);
              !a && De(r.to) && (o = A(Ce(r.to))), r.values.forEach((s, l) => {
                if (s.done) return;
                const u = s.constructor == ot ? 1 : a ? a[l].lastPosition : o[l];
                let c = r.immediate,
                  d = u;
                if (!c) {
                  if (d = s.lastPosition, i.tension <= 0) return void (s.done = !0);
                  let t = s.elapsedTime += e;
                  const n = r.fromValues[l],
                    o = null != s.v0 ? s.v0 : s.v0 = E.arr(i.velocity) ? i.velocity[l] : i.velocity;
                  let a;
                  const p = i.precision || (n == u ? .005 : Math.min(1, .001 * Math.abs(u - n)));
                  if (E.und(i.duration)) {
                    if (i.decay) {
                      const e = !0 === i.decay ? .998 : i.decay,
                        r = Math.exp(-(1 - e) * t);
                      d = n + o / (1 - e) * (1 - r), c = Math.abs(s.lastPosition - d) <= p, a = o * r;
                    } else {
                      a = null == s.lastVelocity ? o : s.lastVelocity;
                      const t = i.restVelocity || p / 10,
                        r = i.clamp ? 0 : i.bounce,
                        l = !E.und(r),
                        h = n == u ? s.v0 > 0 : n < u;
                      let f,
                        m = !1;
                      const g = 1,
                        v = Math.ceil(e / g);
                      for (let e = 0; e < v && (f = Math.abs(a) > t, f || (c = Math.abs(u - d) <= p, !c)); ++e) {
                        l && (m = d == u || d > u == h, m && (a = -a * r, d = u));
                        a += (1e-6 * -i.tension * (d - u) + .001 * -i.friction * a) / i.mass * g, d += a * g;
                      }
                    }
                  } else {
                    let r = 1;
                    i.duration > 0 && (this._memoizedDuration !== i.duration && (this._memoizedDuration = i.duration, s.durationProgress > 0 && (s.elapsedTime = i.duration * s.durationProgress, t = s.elapsedTime += e)), r = (i.progress || 0) + t / this._memoizedDuration, r = r > 1 ? 1 : r < 0 ? 0 : r, s.durationProgress = r), d = n + i.easing(r) * (u - n), a = (d - s.lastPosition) / e, c = 1 == r;
                  }
                  s.lastVelocity = a, Number.isNaN(d) && (console.warn("Got NaN while animating:", this), c = !0);
                }
                a && !a[l].done && (c = !1), c ? s.done = !0 : t = !1, s.setValue(d, i.round) && (n = !0);
              });
              const s = Je(this),
                l = s.getValue();
              if (t) {
                const e = Ce(r.to);
                l === e && !n || i.decay ? n && i.decay && this._onChange(l) : (s.setValue(e), this._onChange(e)), this._stop();
              } else n && this._onChange(l);
            }
            set(e) {
              return s.batchedUpdates(() => {
                this._stop(), this._focus(e), this._set(e);
              }), this;
            }
            pause() {
              this._update({
                pause: !0
              });
            }
            resume() {
              this._update({
                pause: !1
              });
            }
            finish() {
              if (Zt(this)) {
                const {
                  to: e,
                  config: t
                } = this.animation;
                s.batchedUpdates(() => {
                  this._onStart(), t.decay || this._set(e, !1), this._stop();
                });
              }
              return this;
            }
            update(e) {
              return (this.queue || (this.queue = [])).push(e), this;
            }
            start(e, t) {
              let n;
              return E.und(e) ? (n = this.queue || [], this.queue = []) : n = [E.obj(e) ? e : {
                ...t,
                to: e
              }], Promise.all(n.map(e => this._update(e))).then(e => It(this, e));
            }
            stop(e) {
              const {
                to: t
              } = this.animation;
              return this._focus(this.get()), Bt(this._state, e && this._lastCallId), s.batchedUpdates(() => this._stop(t, e)), this;
            }
            reset() {
              this._update({
                reset: !0
              });
            }
            eventObserved(e) {
              "change" == e.type ? this._start() : "priority" == e.type && (this.priority = e.priority + 1);
            }
            _prepareNode(e) {
              const t = this.key || "";
              let {
                to: n,
                from: r
              } = e;
              n = E.obj(n) ? n[t] : n, (null == n || Et(n)) && (n = void 0), r = E.obj(r) ? r[t] : r, null == r && (r = void 0);
              const o = {
                to: n,
                from: r
              };
              return Ut(this) || (e.reverse && ([n, r] = [r, n]), r = Ce(r), E.und(r) ? Je(this) || this._set(n) : this._set(r)), o;
            }
            _update({
              ...e
            }, t) {
              const {
                key: n,
                defaultProps: r
              } = this;
              e.default && Object.assign(r, bt(e, (e, t) => /^on/.test(t) ? gt(e, n) : e)), rn(this, e, "onProps"), on(this, "onProps", e, this);
              const o = this._prepareNode(e);
              if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
              const i = this._state;
              return Ot(++this._lastCallId, {
                key: n,
                props: e,
                defaultProps: r,
                state: i,
                actions: {
                  pause: () => {
                    $t(this) || (Wt(this, !0), I(i.pauseQueue), on(this, "onPause", Mt(this, Xt(this, this.animation.to)), this));
                  },
                  resume: () => {
                    $t(this) && (Wt(this, !1), Zt(this) && this._resume(), I(i.resumeQueue), on(this, "onResume", Mt(this, Xt(this, this.animation.to)), this));
                  },
                  start: this._merge.bind(this, o)
                }
              }).then(n => {
                if (e.loop && n.finished && (!t || !n.noop)) {
                  const t = Qt(e);
                  if (t) return this._update(t, !0);
                }
                return n;
              });
            }
            _merge(e, t, n) {
              if (t.cancel) return this.stop(!0), n(Rt(this));
              const r = !E.und(e.to),
                o = !E.und(e.from);
              if (r || o) {
                if (!(t.callId > this._lastToId)) return n(Rt(this));
                this._lastToId = t.callId;
              }
              const {
                  key: i,
                  defaultProps: a,
                  animation: l
                } = this,
                {
                  to: u,
                  from: c
                } = l;
              let {
                to: d = u,
                from: p = c
              } = e;
              !o || r || t.default && !E.und(d) || (d = p), t.reverse && ([d, p] = [p, d]);
              const h = !_(p, c);
              h && (l.from = p), p = Ce(p);
              const f = !_(d, u);
              f && this._focus(d);
              const m = Et(t.to),
                {
                  config: g
                } = l,
                {
                  decay: v,
                  velocity: y
                } = g;
              (r || o) && (g.velocity = 0), t.config && !m && function (e, t, n) {
                n && (zt(n = {
                  ...n
                }, t), t = {
                  ...n,
                  ...t
                }), zt(e, t), Object.assign(e, t);
                for (const t in At) null == e[t] && (e[t] = At[t]);
                let {
                  frequency: r,
                  damping: o
                } = e;
                const {
                  mass: i
                } = e;
                E.und(r) || (r < .01 && (r = .01), o < 0 && (o = 0), e.tension = Math.pow(2 * Math.PI / r, 2) * i, e.friction = 4 * Math.PI * o * i / r);
              }(g, ft(t.config, i), t.config !== a.config ? ft(a.config, i) : void 0);
              let b = Je(this);
              if (!b || E.und(d)) return n(Mt(this, !0));
              const w = E.und(t.reset) ? o && !t.default : !E.und(p) && mt(t.reset, i),
                x = w ? p : this.get(),
                D = Ct(d),
                C = E.num(D) || E.arr(D) || Ue(D),
                S = !m && (!C || mt(a.immediate || t.immediate, i));
              if (f) {
                const e = ut(d);
                if (e !== b.constructor) {
                  if (!S) throw Error(`Cannot animate between ${b.constructor.name} and ${e.name}, as the "to" prop suggests`);
                  b = this._set(D);
                }
              }
              const k = b.constructor;
              let z = De(d),
                T = !1;
              if (!z) {
                const e = w || !Ut(this) && h;
                (f || e) && (T = _(Ct(x), D), z = !T), (_(l.immediate, S) || S) && _(g.decay, v) && _(g.velocity, y) || (z = !0);
              }
              if (T && Zt(this) && (l.changed && !w ? z = !0 : z || this._stop(u)), !m && ((z || De(u)) && (l.values = b.getPayload(), l.toValues = De(d) ? null : k == ot ? [1] : A(D)), l.immediate != S && (l.immediate = S, S || w || this._set(u)), z)) {
                const {
                  onRest: e
                } = l;
                P(nn, e => rn(this, t, e));
                const r = Mt(this, Xt(this, u));
                I(this._pendingCalls, r), this._pendingCalls.add(n), l.changed && s.batchedUpdates(() => {
                  l.changed = !w, e?.(r, this), w ? ft(a.onRest, r) : l.onStart?.(r, this);
                });
              }
              w && this._set(x), m ? n(jt(t.to, t, this._state, this)) : z ? this._start() : Zt(this) && !f ? this._pendingCalls.add(n) : n(Ft(x));
            }
            _focus(e) {
              const t = this.animation;
              e !== t.to && (Se(this) && this._detach(), t.to = e, Se(this) && this._attach());
            }
            _attach() {
              let e = 0;
              const {
                to: t
              } = this.animation;
              De(t) && (ke(t, this), Vt(t) && (e = t.priority + 1)), this.priority = e;
            }
            _detach() {
              const {
                to: e
              } = this.animation;
              De(e) && Ae(e, this);
            }
            _set(e, t = !0) {
              const n = Ce(e);
              if (!E.und(n)) {
                const e = Je(this);
                if (!e || !_(n, e.getValue())) {
                  const r = ut(n);
                  e && e.constructor == r ? e.setValue(n) : et(this, r.create(n)), e && s.batchedUpdates(() => {
                    this._onChange(n, t);
                  });
                }
              }
              return Je(this);
            }
            _onStart() {
              const e = this.animation;
              e.changed || (e.changed = !0, on(this, "onStart", Mt(this, Xt(this, e.to)), this));
            }
            _onChange(e, t) {
              t || (this._onStart(), ft(this.animation.onChange, e, this)), ft(this.defaultProps.onChange, e, this), super._onChange(e, t);
            }
            _start() {
              const e = this.animation;
              Je(this).reset(Ce(e.to)), e.immediate || (e.fromValues = e.values.map(e => e.lastPosition)), Zt(this) || (Gt(this, !0), $t(this) || this._resume());
            }
            _resume() {
              i.skipAnimation ? this.finish() : q.start(this);
            }
            _stop(e, t) {
              if (Zt(this)) {
                Gt(this, !1);
                const n = this.animation;
                P(n.values, e => {
                  e.done = !0;
                }), n.toValues && (n.onChange = n.onPause = n.onResume = void 0), Ee(this, {
                  type: "idle",
                  parent: this
                });
                const r = t ? Rt(this.get()) : Mt(this.get(), Xt(this, e ?? n.to));
                I(this._pendingCalls, r), n.changed && (n.changed = !1, on(this, "onRest", r, this));
              }
            }
          };
        function Xt(e, t) {
          const n = Ct(t);
          return _(Ct(e.get()), n);
        }
        function Qt(e, t = e.loop, n = e.to) {
          const r = ft(t);
          if (r) {
            const o = !0 !== r && Dt(r),
              i = (o || e).reverse,
              a = !o || o.reset;
            return Jt({
              ...e,
              loop: t,
              default: !1,
              pause: void 0,
              to: !i || Et(n) ? n : void 0,
              from: a ? e.from : void 0,
              reset: a,
              ...o
            });
          }
        }
        function Jt(e) {
          const {
              to: t,
              from: n
            } = e = Dt(e),
            r = new Set();
          return E.obj(t) && tn(t, r), E.obj(n) && tn(n, r), e.keys = r.size ? Array.from(r) : null, e;
        }
        function en(e) {
          const t = Jt(e);
          return E.und(t.default) && (t.default = bt(t)), t;
        }
        function tn(e, t) {
          k(e, (e, n) => null != e && t.add(n));
        }
        var nn = ["onStart", "onRest", "onChange", "onPause", "onResume"];
        function rn(e, t, n) {
          e.animation[n] = t[n] !== vt(t, n) ? gt(t[n], e.key) : void 0;
        }
        function on(e, t, ...n) {
          e.animation[t]?.(...n), e.defaultProps[t]?.(...n);
        }
        var an = ["onStart", "onChange", "onRest"],
          sn = 1,
          ln = class {
            constructor(e, t) {
              this.id = sn++, this.springs = {}, this.queue = [], this._lastAsyncId = 0, this._active = new Set(), this._changed = new Set(), this._started = !1, this._state = {
                paused: !1,
                pauseQueue: new Set(),
                resumeQueue: new Set(),
                timeouts: new Set()
              }, this._events = {
                onStart: new Map(),
                onChange: new Map(),
                onRest: new Map()
              }, this._onFrame = this._onFrame.bind(this), t && (this._flush = t), e && this.start({
                default: !0,
                ...e
              });
            }
            get idle() {
              return !this._state.asyncTo && Object.values(this.springs).every(e => e.idle && !e.isDelayed && !e.isPaused);
            }
            get item() {
              return this._item;
            }
            set item(e) {
              this._item = e;
            }
            get() {
              const e = {};
              return this.each((t, n) => e[n] = t.get()), e;
            }
            set(e) {
              for (const t in e) {
                const n = e[t];
                E.und(n) || this.springs[t].set(n);
              }
            }
            update(e) {
              return e && this.queue.push(Jt(e)), this;
            }
            start(e) {
              let {
                queue: t
              } = this;
              return e ? t = A(e).map(Jt) : this.queue = [], this._flush ? this._flush(this, t) : (mn(this, t), un(this, t));
            }
            stop(e, t) {
              if (e !== !!e && (t = e), t) {
                const n = this.springs;
                P(A(t), t => n[t].stop(!!e));
              } else Bt(this._state, this._lastAsyncId), this.each(t => t.stop(!!e));
              return this;
            }
            pause(e) {
              if (E.und(e)) this.start({
                pause: !0
              });else {
                const t = this.springs;
                P(A(e), e => t[e].pause());
              }
              return this;
            }
            resume(e) {
              if (E.und(e)) this.start({
                pause: !1
              });else {
                const t = this.springs;
                P(A(e), e => t[e].resume());
              }
              return this;
            }
            each(e) {
              k(this.springs, e);
            }
            _onFrame() {
              const {
                  onStart: e,
                  onChange: t,
                  onRest: n
                } = this._events,
                r = this._active.size > 0,
                o = this._changed.size > 0;
              (r && !this._started || o && !this._started) && (this._started = !0, z(e, ([e, t]) => {
                t.value = this.get(), e(t, this, this._item);
              }));
              const i = !r && this._started,
                a = o || i && n.size ? this.get() : null;
              o && t.size && z(t, ([e, t]) => {
                t.value = a, e(t, this, this._item);
              }), i && (this._started = !1, z(n, ([e, t]) => {
                t.value = a, e(t, this, this._item);
              }));
            }
            eventObserved(e) {
              if ("change" == e.type) this._changed.add(e.parent), e.idle || this._active.add(e.parent);else {
                if ("idle" != e.type) return;
                this._active.delete(e.parent);
              }
              s.onFrame(this._onFrame);
            }
          };
        function un(e, t) {
          return Promise.all(t.map(t => cn(e, t))).then(t => It(e, t));
        }
        async function cn(e, t, n) {
          const {
              keys: r,
              to: o,
              from: i,
              loop: a,
              onRest: l,
              onResolve: u
            } = t,
            c = E.obj(t.default) && t.default;
          a && (t.loop = !1), !1 === o && (t.to = null), !1 === i && (t.from = null);
          const d = E.arr(o) || E.fun(o) ? o : void 0;
          d ? (t.to = void 0, t.onRest = void 0, c && (c.onRest = void 0)) : P(an, n => {
            const r = t[n];
            if (E.fun(r)) {
              const o = e._events[n];
              t[n] = ({
                finished: e,
                cancelled: t
              }) => {
                const n = o.get(r);
                n ? (e || (n.finished = !1), t && (n.cancelled = !0)) : o.set(r, {
                  value: null,
                  finished: e || !1,
                  cancelled: t || !1
                });
              }, c && (c[n] = t[n]);
            }
          });
          const p = e._state;
          t.pause === !p.paused ? (p.paused = t.pause, I(t.pause ? p.pauseQueue : p.resumeQueue)) : p.paused && (t.pause = !0);
          const h = (r || Object.keys(e.springs)).map(n => e.springs[n].start(t)),
            f = !0 === t.cancel || !0 === vt(t, "cancel");
          (d || f && p.asyncId) && h.push(Ot(++e._lastAsyncId, {
            props: t,
            state: p,
            actions: {
              pause: S,
              resume: S,
              start(t, n) {
                f ? (Bt(p, e._lastAsyncId), n(Rt(e))) : (t.onRest = l, n(jt(d, t, p, e)));
              }
            }
          })), p.paused && (await new Promise(e => {
            p.resumeQueue.add(e);
          }));
          const m = It(e, await Promise.all(h));
          if (a && m.finished && (!n || !m.noop)) {
            const n = Qt(t, a, o);
            if (n) return mn(e, [n]), cn(e, n, !0);
          }
          return u && s.batchedUpdates(() => u(m, e, e.item)), m;
        }
        function dn(e, t) {
          const n = {
            ...e.springs
          };
          return t && P(A(t), e => {
            E.und(e.keys) && (e = Jt(e)), E.obj(e.to) || (e = {
              ...e,
              to: void 0
            }), fn(n, e, e => hn(e));
          }), pn(e, n), n;
        }
        function pn(e, t) {
          k(t, (t, n) => {
            e.springs[n] || (e.springs[n] = t, ke(t, e));
          });
        }
        function hn(e, t) {
          const n = new Yt();
          return n.key = e, t && ke(n, t), n;
        }
        function fn(e, t, n) {
          t.keys && P(t.keys, r => {
            (e[r] || (e[r] = n(r)))._prepareNode(t);
          });
        }
        function mn(e, t) {
          P(t, t => {
            fn(e.springs, t, t => hn(t, e));
          });
        }
        var gn,
          vn,
          yn = ({
            children: e,
            ...t
          }) => {
            const n = (0, r.useContext)(bn),
              o = t.pause || !!n.pause,
              i = t.immediate || !!n.immediate;
            t = function (e, t) {
              const [n] = (0, r.useState)(() => ({
                  inputs: t,
                  result: e()
                })),
                o = (0, r.useRef)(),
                i = o.current;
              let a = i;
              a ? Boolean(t && a.inputs && function (e, t) {
                if (e.length !== t.length) return !1;
                for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
                return !0;
              }(t, a.inputs)) || (a = {
                inputs: t,
                result: e()
              }) : a = n;
              return (0, r.useEffect)(() => {
                o.current = a, i == n && (n.inputs = n.result = void 0);
              }, [a]), a.result;
            }(() => ({
              pause: o,
              immediate: i
            }), [o, i]);
            const {
              Provider: a
            } = bn;
            return r.createElement(a, {
              value: t
            }, e);
          },
          bn = (gn = yn, vn = {}, Object.assign(gn, r.createContext(vn)), gn.Provider._context = gn, gn.Consumer._context = gn, gn);
        yn.Provider = bn.Provider, yn.Consumer = bn.Consumer;
        var wn = () => {
          const e = [],
            t = function (t) {
              He(`${Ve}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
              const r = [];
              return P(e, (e, o) => {
                if (E.und(t)) r.push(e.start());else {
                  const i = n(t, e, o);
                  i && r.push(e.start(i));
                }
              }), r;
            };
          t.current = e, t.add = function (t) {
            e.includes(t) || e.push(t);
          }, t.delete = function (t) {
            const n = e.indexOf(t);
            ~n && e.splice(n, 1);
          }, t.pause = function () {
            return P(e, e => e.pause(...arguments)), this;
          }, t.resume = function () {
            return P(e, e => e.resume(...arguments)), this;
          }, t.set = function (t) {
            P(e, (e, n) => {
              const r = E.fun(t) ? t(n, e) : t;
              r && e.set(r);
            });
          }, t.start = function (t) {
            const n = [];
            return P(e, (e, r) => {
              if (E.und(t)) n.push(e.start());else {
                const o = this._getProps(t, e, r);
                o && n.push(e.start(o));
              }
            }), n;
          }, t.stop = function () {
            return P(e, e => e.stop(...arguments)), this;
          }, t.update = function (t) {
            return P(e, (e, n) => e.update(this._getProps(t, e, n))), this;
          };
          const n = function (e, t, n) {
            return E.fun(e) ? e(n, t) : e;
          };
          return t._getProps = n, t;
        };
        function xn(e, t, n) {
          const o = E.fun(t) && t;
          o && !n && (n = []);
          const i = (0, r.useMemo)(() => o || 3 == arguments.length ? wn() : void 0, []),
            a = (0, r.useRef)(0),
            s = $e(),
            l = (0, r.useMemo)(() => ({
              ctrls: [],
              queue: [],
              flush(e, t) {
                const n = dn(e, t);
                return a.current > 0 && !l.queue.length && !Object.keys(n).some(t => !e.springs[t]) ? un(e, t) : new Promise(r => {
                  pn(e, n), l.queue.push(() => {
                    r(un(e, t));
                  }), s();
                });
              }
            }), []),
            u = (0, r.useRef)([...l.ctrls]),
            c = [],
            d = Ye(e) || 0;
          function p(e, n) {
            for (let r = e; r < n; r++) {
              const e = u.current[r] || (u.current[r] = new ln(null, l.flush)),
                n = o ? o(r, e) : t[r];
              n && (c[r] = en(n));
            }
          }
          (0, r.useMemo)(() => {
            P(u.current.slice(e, d), e => {
              _t(e, i), e.stop(!0);
            }), u.current.length = e, p(d, e);
          }, [e]), (0, r.useMemo)(() => {
            p(0, Math.min(d, e));
          }, n);
          const h = u.current.map((e, t) => dn(e, c[t])),
            f = (0, r.useContext)(yn),
            m = Ye(f),
            g = f !== m && St(f);
          Ze(() => {
            a.current++, l.ctrls = u.current;
            const {
              queue: e
            } = l;
            e.length && (l.queue = [], P(e, e => e())), P(u.current, (e, t) => {
              i?.add(e), g && e.start({
                default: f
              });
              const n = c[t];
              n && (Pt(e, n.ref), e.ref ? e.queue.push(n) : e.start(n));
            });
          }), Ge(() => () => {
            P(l.ctrls, e => e.stop(!0));
          });
          const v = h.map(e => ({
            ...e
          }));
          return i ? [v, i] : v;
        }
        function Dn(e, t) {
          const n = E.fun(e),
            [[r], o] = xn(1, n ? e : [e], n ? t || [] : t);
          return n || 2 == arguments.length ? [r, o] : r;
        }
        function Cn(e, t, n) {
          const o = E.fun(t) && t,
            {
              reset: i,
              sort: a,
              trail: s = 0,
              expires: l = !0,
              exitBeforeEnter: u = !1,
              onDestroyed: c,
              ref: d,
              config: p
            } = o ? o() : t,
            h = (0, r.useMemo)(() => o || 3 == arguments.length ? wn() : void 0, []),
            f = A(e),
            m = [],
            g = (0, r.useRef)(null),
            v = i ? null : g.current;
          Ze(() => {
            g.current = m;
          }), Ge(() => (P(m, e => {
            h?.add(e.ctrl), e.ctrl.ref = h;
          }), () => {
            P(g.current, e => {
              e.expired && clearTimeout(e.expirationId), _t(e.ctrl, h), e.ctrl.stop(!0);
            });
          }));
          const y = En(f, o ? o() : t, v),
            b = i && g.current || [];
          Ze(() => P(b, ({
            ctrl: e,
            item: t,
            key: n
          }) => {
            _t(e, h), ft(c, t, n);
          }));
          const w = [];
          if (v && P(v, (e, t) => {
            e.expired ? (clearTimeout(e.expirationId), b.push(e)) : ~(t = w[t] = y.indexOf(e.key)) && (m[t] = e);
          }), P(f, (e, t) => {
            m[t] || (m[t] = {
              key: y[t],
              item: e,
              phase: "mount",
              ctrl: new ln()
            }, m[t].ctrl.item = e);
          }), w.length) {
            let e = -1;
            const {
              leave: n
            } = o ? o() : t;
            P(w, (t, r) => {
              const o = v[r];
              ~t ? (e = m.indexOf(o), m[e] = {
                ...o,
                item: f[t]
              }) : n && m.splice(++e, 0, o);
            });
          }
          E.fun(a) && m.sort((e, t) => a(e.item, t.item));
          let x = -s;
          const D = $e(),
            C = bt(t),
            S = new Map(),
            _ = (0, r.useRef)(new Map()),
            k = (0, r.useRef)(!1);
          P(m, (e, n) => {
            const r = e.key,
              i = e.phase,
              a = o ? o() : t;
            let c, h;
            const f = ft(a.delay || 0, r);
            if ("mount" == i) c = a.enter, h = "enter";else {
              const e = y.indexOf(r) < 0;
              if ("leave" != i) {
                if (e) c = a.leave, h = "leave";else {
                  if (!(c = a.update)) return;
                  h = "update";
                }
              } else {
                if (e) return;
                c = a.enter, h = "enter";
              }
            }
            if (c = ft(c, e.item, n), c = E.obj(c) ? Dt(c) : {
              to: c
            }, !c.config) {
              const t = p || C.config;
              c.config = ft(t, e.item, n, h);
            }
            x += s;
            const m = {
              ...C,
              delay: f + x,
              ref: d,
              immediate: a.immediate,
              reset: !1,
              ...c
            };
            if ("enter" == h && E.und(m.from)) {
              const r = o ? o() : t,
                i = E.und(r.initial) || v ? r.from : r.initial;
              m.from = ft(i, e.item, n);
            }
            const {
              onResolve: b
            } = m;
            m.onResolve = e => {
              ft(b, e);
              const t = g.current,
                n = t.find(e => e.key === r);
              if (n && (!e.cancelled || "update" == n.phase) && n.ctrl.idle) {
                const e = t.every(e => e.ctrl.idle);
                if ("leave" == n.phase) {
                  const t = ft(l, n.item);
                  if (!1 !== t) {
                    const r = !0 === t ? 0 : t;
                    if (n.expired = !0, !e && r > 0) return void (r <= 2147483647 && (n.expirationId = setTimeout(D, r)));
                  }
                }
                e && t.some(e => e.expired) && (_.current.delete(n), u && (k.current = !0), D());
              }
            };
            const w = dn(e.ctrl, m);
            "leave" === h && u ? _.current.set(e, {
              phase: h,
              springs: w,
              payload: m
            }) : S.set(e, {
              phase: h,
              springs: w,
              payload: m
            });
          });
          const z = (0, r.useContext)(yn),
            T = Ye(z),
            O = z !== T && St(z);
          Ze(() => {
            O && P(m, e => {
              e.ctrl.start({
                default: z
              });
            });
          }, [z]), P(S, (e, t) => {
            if (_.current.size) {
              const e = m.findIndex(e => e.key === t.key);
              m.splice(e, 1);
            }
          }), Ze(() => {
            P(_.current.size ? _.current : S, ({
              phase: e,
              payload: t
            }, n) => {
              const {
                ctrl: r
              } = n;
              n.phase = e, h?.add(r), O && "enter" == e && r.start({
                default: z
              }), t && (Pt(r, t.ref), !r.ref && !h || k.current ? (r.start(t), k.current && (k.current = !1)) : r.update(t));
            });
          }, i ? void 0 : n);
          const I = e => r.createElement(r.Fragment, null, m.map((t, n) => {
            const {
                springs: o
              } = S.get(t) || t.ctrl,
              i = e({
                ...o
              }, t.item, t, n);
            return i && i.type ? r.createElement(i.type, {
              ...i.props,
              key: E.str(t.key) || E.num(t.key) ? t.key : t.ctrl.id,
              ref: i.ref
            }) : i;
          }));
          return h ? [I, h] : I;
        }
        var Sn = 1;
        function En(e, {
          key: t,
          keys: n = t
        }, r) {
          if (null === n) {
            const t = new Set();
            return e.map(e => {
              const n = r && r.find(n => n.item === e && "leave" !== n.phase && !t.has(n));
              return n ? (t.add(n), n.key) : Sn++;
            });
          }
          return E.und(n) ? e : E.fun(n) ? e.map(n) : A(n);
        }
        var _n = class extends qt {
          constructor(e, t) {
            super(), this.source = e, this.idle = !0, this._active = new Set(), this.calc = pe(...t);
            const n = this._get(),
              r = ut(n);
            et(this, r.create(n));
          }
          advance(e) {
            const t = this._get();
            _(t, this.get()) || (Je(this).setValue(t), this._onChange(t, this.idle)), !this.idle && kn(this._active) && An(this);
          }
          _get() {
            const e = E.arr(this.source) ? this.source.map(Ce) : A(Ce(this.source));
            return this.calc(...e);
          }
          _start() {
            this.idle && !kn(this._active) && (this.idle = !1, P(tt(this), e => {
              e.done = !1;
            }), i.skipAnimation ? (s.batchedUpdates(() => this.advance()), An(this)) : q.start(this));
          }
          _attach() {
            let e = 1;
            P(A(this.source), t => {
              De(t) && ke(t, this), Vt(t) && (t.idle || this._active.add(t), e = Math.max(e, t.priority + 1));
            }), this.priority = e, this._start();
          }
          _detach() {
            P(A(this.source), e => {
              De(e) && Ae(e, this);
            }), this._active.clear(), An(this);
          }
          eventObserved(e) {
            "change" == e.type ? e.idle ? this.advance() : (this._active.add(e.parent), this._start()) : "idle" == e.type ? this._active.delete(e.parent) : "priority" == e.type && (this.priority = A(this.source).reduce((e, t) => Math.max(e, (Vt(t) ? t.priority : 0) + 1), 0));
          }
        };
        function Pn(e) {
          return !1 !== e.idle;
        }
        function kn(e) {
          return !e.size || Array.from(e).every(Pn);
        }
        function An(e) {
          e.idle || (e.idle = !0, P(tt(e), e => {
            e.done = !0;
          }), Ee(e, {
            type: "idle",
            parent: e
          }));
        }
        i.assign({
          createStringInterpolator: Le,
          to: (e, t) => new _n(e, t)
        });
        q.advance;
        var zn = n(73935),
          Tn = /^--/;
        function On(e, t) {
          return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || Tn.test(e) || Fn.hasOwnProperty(e) && Fn[e] ? ("" + t).trim() : t + "px";
        }
        var In = {};
        var Fn = {
            animationIterationCount: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0
          },
          Mn = ["Webkit", "Ms", "Moz", "O"];
        Fn = Object.keys(Fn).reduce((e, t) => (Mn.forEach(n => e[((e, t) => e + t.charAt(0).toUpperCase() + t.substring(1))(n, t)] = e[t]), e), Fn);
        var Rn = /^(matrix|translate|scale|rotate|skew)/,
          jn = /^(translate)/,
          Bn = /^(rotate|skew)/,
          Nn = (e, t) => E.num(e) && 0 !== e ? e + t : e,
          Ln = (e, t) => E.arr(e) ? e.every(e => Ln(e, t)) : E.num(e) ? e === t : parseFloat(e) === t,
          Vn = class extends at {
            constructor({
              x: e,
              y: t,
              z: n,
              ...r
            }) {
              const o = [],
                i = [];
              (e || t || n) && (o.push([e || 0, t || 0, n || 0]), i.push(e => [`translate3d(${e.map(e => Nn(e, "px")).join(",")})`, Ln(e, 0)])), k(r, (e, t) => {
                if ("transform" === t) o.push([e || ""]), i.push(e => [e, "" === e]);else if (Rn.test(t)) {
                  if (delete r[t], E.und(e)) return;
                  const n = jn.test(t) ? "px" : Bn.test(t) ? "deg" : "";
                  o.push(A(e)), i.push("rotate3d" === t ? ([e, t, r, o]) => [`rotate3d(${e},${t},${r},${Nn(o, n)})`, Ln(o, 0)] : e => [`${t}(${e.map(e => Nn(e, n)).join(",")})`, Ln(e, t.startsWith("scale") ? 1 : 0)]);
                }
              }), o.length && (r.transform = new Kn(o, i)), super(r);
            }
          },
          Kn = class extends _e {
            constructor(e, t) {
              super(), this.inputs = e, this.transforms = t, this._value = null;
            }
            get() {
              return this._value || (this._value = this._get());
            }
            _get() {
              let e = "",
                t = !0;
              return P(this.inputs, (n, r) => {
                const o = Ce(n[0]),
                  [i, a] = this.transforms[r](E.arr(o) ? o : n.map(Ce));
                e += " " + i, t = t && a;
              }), t ? "none" : e;
            }
            observerAdded(e) {
              1 == e && P(this.inputs, e => P(e, e => De(e) && ke(e, this)));
            }
            observerRemoved(e) {
              0 == e && P(this.inputs, e => P(e, e => De(e) && Ae(e, this)));
            }
            eventObserved(e) {
              "change" == e.type && (this._value = null), Ee(this, e);
            }
          };
        i.assign({
          batchedUpdates: zn.unstable_batchedUpdates,
          createStringInterpolator: Le,
          colors: {
            transparent: 0,
            aliceblue: 4042850303,
            antiquewhite: 4209760255,
            aqua: 16777215,
            aquamarine: 2147472639,
            azure: 4043309055,
            beige: 4126530815,
            bisque: 4293182719,
            black: 255,
            blanchedalmond: 4293643775,
            blue: 65535,
            blueviolet: 2318131967,
            brown: 2771004159,
            burlywood: 3736635391,
            burntsienna: 3934150143,
            cadetblue: 1604231423,
            chartreuse: 2147418367,
            chocolate: 3530104575,
            coral: 4286533887,
            cornflowerblue: 1687547391,
            cornsilk: 4294499583,
            crimson: 3692313855,
            cyan: 16777215,
            darkblue: 35839,
            darkcyan: 9145343,
            darkgoldenrod: 3095792639,
            darkgray: 2846468607,
            darkgreen: 6553855,
            darkgrey: 2846468607,
            darkkhaki: 3182914559,
            darkmagenta: 2332068863,
            darkolivegreen: 1433087999,
            darkorange: 4287365375,
            darkorchid: 2570243327,
            darkred: 2332033279,
            darksalmon: 3918953215,
            darkseagreen: 2411499519,
            darkslateblue: 1211993087,
            darkslategray: 793726975,
            darkslategrey: 793726975,
            darkturquoise: 13554175,
            darkviolet: 2483082239,
            deeppink: 4279538687,
            deepskyblue: 12582911,
            dimgray: 1768516095,
            dimgrey: 1768516095,
            dodgerblue: 512819199,
            firebrick: 2988581631,
            floralwhite: 4294635775,
            forestgreen: 579543807,
            fuchsia: 4278255615,
            gainsboro: 3705462015,
            ghostwhite: 4177068031,
            gold: 4292280575,
            goldenrod: 3668254975,
            gray: 2155905279,
            green: 8388863,
            greenyellow: 2919182335,
            grey: 2155905279,
            honeydew: 4043305215,
            hotpink: 4285117695,
            indianred: 3445382399,
            indigo: 1258324735,
            ivory: 4294963455,
            khaki: 4041641215,
            lavender: 3873897215,
            lavenderblush: 4293981695,
            lawngreen: 2096890111,
            lemonchiffon: 4294626815,
            lightblue: 2916673279,
            lightcoral: 4034953471,
            lightcyan: 3774873599,
            lightgoldenrodyellow: 4210742015,
            lightgray: 3553874943,
            lightgreen: 2431553791,
            lightgrey: 3553874943,
            lightpink: 4290167295,
            lightsalmon: 4288707327,
            lightseagreen: 548580095,
            lightskyblue: 2278488831,
            lightslategray: 2005441023,
            lightslategrey: 2005441023,
            lightsteelblue: 2965692159,
            lightyellow: 4294959359,
            lime: 16711935,
            limegreen: 852308735,
            linen: 4210091775,
            magenta: 4278255615,
            maroon: 2147483903,
            mediumaquamarine: 1724754687,
            mediumblue: 52735,
            mediumorchid: 3126187007,
            mediumpurple: 2473647103,
            mediumseagreen: 1018393087,
            mediumslateblue: 2070474495,
            mediumspringgreen: 16423679,
            mediumturquoise: 1221709055,
            mediumvioletred: 3340076543,
            midnightblue: 421097727,
            mintcream: 4127193855,
            mistyrose: 4293190143,
            moccasin: 4293178879,
            navajowhite: 4292783615,
            navy: 33023,
            oldlace: 4260751103,
            olive: 2155872511,
            olivedrab: 1804477439,
            orange: 4289003775,
            orangered: 4282712319,
            orchid: 3664828159,
            palegoldenrod: 4008225535,
            palegreen: 2566625535,
            paleturquoise: 2951671551,
            palevioletred: 3681588223,
            papayawhip: 4293907967,
            peachpuff: 4292524543,
            peru: 3448061951,
            pink: 4290825215,
            plum: 3718307327,
            powderblue: 2967529215,
            purple: 2147516671,
            rebeccapurple: 1714657791,
            red: 4278190335,
            rosybrown: 3163525119,
            royalblue: 1097458175,
            saddlebrown: 2336560127,
            salmon: 4202722047,
            sandybrown: 4104413439,
            seagreen: 780883967,
            seashell: 4294307583,
            sienna: 2689740287,
            silver: 3233857791,
            skyblue: 2278484991,
            slateblue: 1784335871,
            slategray: 1887473919,
            slategrey: 1887473919,
            snow: 4294638335,
            springgreen: 16744447,
            steelblue: 1182971135,
            tan: 3535047935,
            teal: 8421631,
            thistle: 3636451583,
            tomato: 4284696575,
            turquoise: 1088475391,
            violet: 4001558271,
            wheat: 4125012991,
            white: 4294967295,
            whitesmoke: 4126537215,
            yellow: 4294902015,
            yellowgreen: 2597139199
          }
        });
        var qn = ((e, {
            applyAnimatedValues: t = () => !1,
            createAnimatedStyle: n = e => new at(e),
            getComponentProps: r = e => e
          } = {}) => {
            const o = {
                applyAnimatedValues: t,
                createAnimatedStyle: n,
                getComponentProps: r
              },
              i = e => {
                const t = ht(e) || "Anonymous";
                return (e = E.str(e) ? i[e] || (i[e] = ct(e, o)) : e[pt] || (e[pt] = ct(e, o))).displayName = `Animated(${t})`, e;
              };
            return k(e, (t, n) => {
              E.arr(e) && (n = ht(t)), i[n] = i(t);
            }), {
              animated: i
            };
          })(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"], {
            applyAnimatedValues: function (e, t) {
              if (!e.nodeType || !e.setAttribute) return !1;
              const n = "filter" === e.nodeName || e.parentNode && "filter" === e.parentNode.nodeName,
                {
                  style: r,
                  children: o,
                  scrollTop: i,
                  scrollLeft: a,
                  viewBox: s,
                  ...l
                } = t,
                u = Object.values(l),
                c = Object.keys(l).map(t => n || e.hasAttribute(t) ? t : In[t] || (In[t] = t.replace(/([A-Z])/g, e => "-" + e.toLowerCase())));
              void 0 !== o && (e.textContent = o);
              for (const t in r) if (r.hasOwnProperty(t)) {
                const n = On(t, r[t]);
                Tn.test(t) ? e.style.setProperty(t, n) : e.style[t] = n;
              }
              c.forEach((t, n) => {
                e.setAttribute(t, u[n]);
              }), void 0 !== i && (e.scrollTop = i), void 0 !== a && (e.scrollLeft = a), void 0 !== s && e.setAttribute("viewBox", s);
            },
            createAnimatedStyle: e => new Vn(e),
            getComponentProps: ({
              scrollTop: e,
              scrollLeft: t,
              ...n
            }) => n
          }),
          Hn = qn.animated;
      },
      45861: (e, t, n) => {
        "use strict";

        n.d(t, {
          $0: () => l,
          Kx: () => h,
          _P: () => f,
          ck: () => a,
          eg: () => v,
          is: () => w,
          l8: () => m,
          s: () => g
        });
        var r = n(67294);
        function o(e) {
          return null;
        }
        function i(e) {
          return null != e.hasChildItems ? e.hasChildItems : !!e.childItems || !!(e.title && r.Children.count(e.children) > 0);
        }
        o.getCollectionNode = function* (e, t) {
          let {
              childItems: n,
              title: o,
              children: a
            } = e,
            s = e.title || e.children,
            l = e.textValue || ("string" == typeof s ? s : "") || e["aria-label"] || "";
          l || (null == t ? void 0 : t.suppressTextValueWarning) || console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop."), yield {
            type: "item",
            props: e,
            rendered: s,
            textValue: l,
            "aria-label": e["aria-label"],
            hasChildNodes: i(e),
            *childNodes() {
              if (n) for (let e of n) yield {
                type: "item",
                value: e
              };else if (o) {
                let e = [];
                r.Children.forEach(a, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        let a = o;
        function s(e) {
          return null;
        }
        s.getCollectionNode = function* (e) {
          let {
            children: t,
            title: n,
            items: o
          } = e;
          yield {
            type: "section",
            props: e,
            hasChildNodes: !0,
            rendered: n,
            "aria-label": e["aria-label"],
            *childNodes() {
              if ("function" == typeof t) {
                if (!o) throw new Error("props.children was a function but props.items is missing");
                for (let e of o) yield {
                  type: "item",
                  value: e,
                  renderer: t
                };
              } else {
                let e = [];
                r.Children.forEach(t, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        let l = s;
        class u {
          build(e, t) {
            return this.context = t, c(() => this.iterateCollection(e));
          }
          *iterateCollection(e) {
            let {
              children: t,
              items: n
            } = e;
            if ("function" == typeof t) {
              if (!n) throw new Error("props.children was a function but props.items is missing");
              for (let n of e.items) yield* this.getFullNode({
                value: n
              }, {
                renderer: t
              });
            } else {
              let e = [];
              r.Children.forEach(t, t => {
                e.push(t);
              });
              let n = 0;
              for (let t of e) {
                let e = this.getFullNode({
                  element: t,
                  index: n
                }, {});
                for (let t of e) n++, yield t;
              }
            }
          }
          getKey(e, t, n, r) {
            if (null != e.key) return e.key;
            if ("cell" === t.type && null != t.key) return `${r}${t.key}`;
            let o = t.value;
            if (null != o) {
              var i;
              let e = null !== (i = o.key) && void 0 !== i ? i : o.id;
              if (null == e) throw new Error("No key found for item");
              return e;
            }
            return r ? `${r}.${t.index}` : `$.${t.index}`;
          }
          getChildState(e, t) {
            return {
              renderer: t.renderer || e.renderer
            };
          }
          *getFullNode(e, t, n, o) {
            let i = e.element;
            if (!i && e.value && t && t.renderer) {
              let n = this.cache.get(e.value);
              if (n && (!n.shouldInvalidate || !n.shouldInvalidate(this.context))) return n.index = e.index, n.parentKey = o ? o.key : null, void (yield n);
              i = t.renderer(e.value);
            }
            if (r.isValidElement(i)) {
              let r = i.type;
              if ("function" != typeof r && "function" != typeof r.getCollectionNode) {
                let e = "function" == typeof i.type ? i.type.name : i.type;
                throw new Error(`Unknown element <${e}> in collection.`);
              }
              let a = r.getCollectionNode(i.props, this.context),
                s = e.index,
                l = a.next();
              for (; !l.done && l.value;) {
                let r = l.value;
                e.index = s;
                let u = r.key;
                u || (u = r.element ? null : this.getKey(i, e, t, n));
                let c = [...this.getFullNode({
                  ...r,
                  key: u,
                  index: s,
                  wrapper: d(e.wrapper, r.wrapper)
                }, this.getChildState(t, r), n ? `${n}${i.key}` : i.key, o)];
                for (let t of c) {
                  if (t.value = r.value || e.value, t.value && this.cache.set(t.value, t), e.type && t.type !== e.type) throw new Error(`Unsupported type <${p(t.type)}> in <${p(o.type)}>. Only <${p(e.type)}> is supported.`);
                  s++, yield t;
                }
                l = a.next(c);
              }
              return;
            }
            if (null == e.key) return;
            let a = this,
              s = {
                type: e.type,
                props: e.props,
                key: e.key,
                parentKey: o ? o.key : null,
                value: e.value,
                level: o ? o.level + 1 : 0,
                index: e.index,
                rendered: e.rendered,
                textValue: e.textValue,
                "aria-label": e["aria-label"],
                wrapper: e.wrapper,
                shouldInvalidate: e.shouldInvalidate,
                hasChildNodes: e.hasChildNodes,
                childNodes: c(function* () {
                  if (!e.hasChildNodes) return;
                  let n = 0;
                  for (let r of e.childNodes()) {
                    null != r.key && (r.key = `${s.key}${r.key}`), r.index = n;
                    let e = a.getFullNode(r, a.getChildState(t, r), s.key, s);
                    for (let t of e) n++, yield t;
                  }
                })
              };
            yield s;
          }
          constructor() {
            this.cache = new WeakMap();
          }
        }
        function c(e) {
          let t = [],
            n = null;
          return {
            *[Symbol.iterator]() {
              for (let e of t) yield e;
              n || (n = e());
              for (let e of n) t.push(e), yield e;
            }
          };
        }
        function d(e, t) {
          return e && t ? n => e(t(n)) : e || t || void 0;
        }
        function p(e) {
          return e[0].toUpperCase() + e.slice(1);
        }
        function h(e, t, n) {
          let o = (0, r.useMemo)(() => new u(), []),
            {
              children: i,
              items: a,
              collection: s
            } = e;
          return (0, r.useMemo)(() => {
            if (s) return s;
            let e = o.build({
              children: i,
              items: a
            }, n);
            return t(e);
          }, [o, i, a, s, n, t]);
        }
        function f(e, t) {
          return "function" == typeof t.getChildren ? t.getChildren(e.key) : e.childNodes;
        }
        function m(e) {
          return function (e, t) {
            if (t < 0) return;
            let n = 0;
            for (let r of e) {
              if (n === t) return r;
              n++;
            }
          }(e, 0);
        }
        function g(e) {
          let t;
          for (let n of e) t = n;
          return t;
        }
        function v(e, t, n) {
          if (t.parentKey === n.parentKey) return t.index - n.index;
          let r = [...y(e, t), t],
            o = [...y(e, n), n],
            i = r.slice(0, o.length).findIndex((e, t) => e !== o[t]);
          return -1 !== i ? (t = r[i], n = o[i], t.index - n.index) : r.findIndex(e => e === n) >= 0 ? 1 : (o.findIndex(e => e === t), -1);
        }
        function y(e, t) {
          let n = [];
          for (; null != (null == t ? void 0 : t.parentKey);) t = e.getItem(t.parentKey), n.unshift(t);
          return n;
        }
        const b = new WeakMap();
        function w(e) {
          let t = b.get(e);
          if (null != t) return t;
          t = 0;
          let n = r => {
            for (let o of r) "section" === o.type ? n(f(o, e)) : t++;
          };
          return n(e), b.set(e, t), t;
        }
      },
      58197: (e, t, n) => {
        "use strict";

        n.d(t, {
          lu: () => Z,
          Eg: () => ne,
          jF: () => ue,
          Y3: () => re
        });
        var r;
        r = {
          alpha: "ألفا",
          blue: "أزرق",
          brightness: "السطوع",
          green: "أخضر",
          hue: "درجة اللون",
          lightness: "الإضاءة",
          red: "أحمر",
          saturation: "التشبع"
        };
        var o;
        o = {
          alpha: "Алфа",
          blue: "Синьо",
          brightness: "Яркост",
          green: "Зелено",
          hue: "Оттенък",
          lightness: "Лекота",
          red: "Червено",
          saturation: "Наситеност"
        };
        var i;
        i = {
          alpha: "Alfa",
          blue: "Modrá",
          brightness: "Jas",
          green: "Zelená",
          hue: "Odstín",
          lightness: "Světlost",
          red: "Červená",
          saturation: "Sytost"
        };
        var a;
        a = {
          alpha: "Alfa",
          blue: "Blå",
          brightness: "Lysstyrke",
          green: "Grøn",
          hue: "Tone",
          lightness: "Lyshed",
          red: "Rød",
          saturation: "Farvemætning"
        };
        var s;
        s = {
          alpha: "Alpha",
          blue: "Blau",
          brightness: "Helligkeit",
          green: "Grün",
          hue: "Farbton",
          lightness: "Leuchtkraft",
          red: "Rot",
          saturation: "Sättigung"
        };
        var l;
        l = {
          alpha: "Άλφα",
          blue: "Μπλε",
          brightness: "Φωτεινότητα",
          green: "Πράσινο",
          hue: "Τόνος",
          lightness: "Φωτεινότητα",
          red: "Κόκκινο",
          saturation: "Κορεσμός"
        };
        var u;
        u = {
          hue: "Hue",
          saturation: "Saturation",
          lightness: "Lightness",
          brightness: "Brightness",
          red: "Red",
          green: "Green",
          blue: "Blue",
          alpha: "Alpha"
        };
        var c;
        c = {
          alpha: "Alpha",
          blue: "Azul",
          brightness: "Brillo",
          green: "Verde",
          hue: "Tono",
          lightness: "Luminosidad",
          red: "Rojo",
          saturation: "Saturación"
        };
        var d;
        d = {
          alpha: "Alfa",
          blue: "Sinine",
          brightness: "Heledus",
          green: "Roheline",
          hue: "Värv",
          lightness: "Valgus",
          red: "Punane",
          saturation: "Küllastus"
        };
        var p;
        p = {
          alpha: "Alpha",
          blue: "Sininen",
          brightness: "Kirkkaus",
          green: "Vihreä",
          hue: "Sävy",
          lightness: "Valomäärä",
          red: "Punainen",
          saturation: "Värikylläisyys"
        };
        var h;
        h = {
          alpha: "Alpha",
          blue: "Bleu",
          brightness: "Luminosité",
          green: "Vert",
          hue: "Teinte",
          lightness: "Luminosité",
          red: "Rouge",
          saturation: "Saturation"
        };
        var f;
        f = {
          alpha: "אלפא",
          blue: "כחול",
          brightness: "בהירות",
          green: "ירוק",
          hue: "גוון",
          lightness: "כמות אור",
          red: "אדום",
          saturation: "רוויה"
        };
        var m;
        m = {
          alpha: "Alfa",
          blue: "Plava",
          brightness: "Svjetlina",
          green: "Zelena",
          hue: "Nijansa",
          lightness: "Osvijetljenost",
          red: "Crvena",
          saturation: "Zasićenost"
        };
        var g;
        g = {
          alpha: "Alfa",
          blue: "Kék",
          brightness: "Fényesség",
          green: "Zöld",
          hue: "Színárnyalat",
          lightness: "Világosság",
          red: "Piros",
          saturation: "Telítettség"
        };
        var v;
        v = {
          alpha: "Alfa",
          blue: "Blu",
          brightness: "Luminosità",
          green: "Verde",
          hue: "Tonalità",
          lightness: "Luminosità",
          red: "Rosso",
          saturation: "Saturazione"
        };
        var y;
        y = {
          alpha: "アルファ",
          blue: "青",
          brightness: "明るさ",
          green: "緑",
          hue: "色相",
          lightness: "明度",
          red: "赤",
          saturation: "彩度"
        };
        var b;
        b = {
          alpha: "알파",
          blue: "파랑",
          brightness: "명도",
          green: "초록",
          hue: "색조",
          lightness: "밝기",
          red: "빨강",
          saturation: "채도"
        };
        var w;
        w = {
          alpha: "Alfa",
          blue: "Mėlyna",
          brightness: "Ryškumas",
          green: "Žalia",
          hue: "Atspalvis",
          lightness: "Šviesumas",
          red: "Raudona",
          saturation: "Įsotinimas"
        };
        var x;
        x = {
          alpha: "Alfa",
          blue: "Zila",
          brightness: "Spilgtums",
          green: "Zaļa",
          hue: "Nokrāsa",
          lightness: "Gaišums",
          red: "Sarkana",
          saturation: "Piesātinājums"
        };
        var D;
        D = {
          alpha: "Alfa",
          blue: "Blå",
          brightness: "Lysstyrke",
          green: "Grønn",
          hue: "Fargetone",
          lightness: "Lyshet",
          red: "Rød",
          saturation: "Metning"
        };
        var C;
        C = {
          alpha: "Alfa",
          blue: "Blauw",
          brightness: "Helderheid",
          green: "Groen",
          hue: "Kleurtoon",
          lightness: "Lichtsterkte",
          red: "Rood",
          saturation: "Verzadiging"
        };
        var S;
        S = {
          alpha: "Alfa",
          blue: "Niebieski",
          brightness: "Jasność",
          green: "Zielony",
          hue: "Odcień",
          lightness: "Jaskrawość",
          red: "Czerwony",
          saturation: "Nasycenie"
        };
        var E;
        E = {
          alpha: "Alfa",
          blue: "Azul",
          brightness: "Brilho",
          green: "Verde",
          hue: "Matiz",
          lightness: "Luminosidade",
          red: "Vermelho",
          saturation: "Saturação"
        };
        var _;
        _ = {
          alpha: "Alfa",
          blue: "Azul",
          brightness: "Luminosidade",
          green: "Verde",
          hue: "Tonalidade",
          lightness: "Claridade",
          red: "Vermelho",
          saturation: "Saturação"
        };
        var P;
        P = {
          alpha: "Alfa",
          blue: "Albastru",
          brightness: "Luminozitate",
          green: "Verde",
          hue: "Nuanță",
          lightness: "Luminozitate",
          red: "Roșu",
          saturation: "Saturație"
        };
        var k;
        k = {
          alpha: "Альфа",
          blue: "Синий",
          brightness: "Яркость",
          green: "Зеленый",
          hue: "Оттенок",
          lightness: "Освещенность",
          red: "Красный",
          saturation: "Насыщенность"
        };
        var A;
        A = {
          alpha: "Alfa",
          blue: "Modrá",
          brightness: "Jas",
          green: "Zelená",
          hue: "Odtieň",
          lightness: "Svetlosť",
          red: "Červená",
          saturation: "Sýtosť"
        };
        var z;
        z = {
          alpha: "Alfa",
          blue: "Modra",
          brightness: "Svetlost",
          green: "Zelena",
          hue: "Barva",
          lightness: "Lahkost",
          red: "Rdeča",
          saturation: "Nasičenost"
        };
        var T;
        T = {
          alpha: "Alfa",
          blue: "Plava",
          brightness: "Osvetljenost",
          green: "Zelena",
          hue: "Nijansa",
          lightness: "Osvetljenje",
          red: "Crvena",
          saturation: "Zasićenje"
        };
        var O;
        O = {
          alpha: "Alfa",
          blue: "Blått",
          brightness: "Ljusstyrka",
          green: "Grönt",
          hue: "Nyans",
          lightness: "Ljushet",
          red: "Rött",
          saturation: "Mättnad"
        };
        var I;
        I = {
          alpha: "Alfa",
          blue: "Mavi",
          brightness: "Parlaklık",
          green: "Yeşil",
          hue: "Ton",
          lightness: "Canlılık",
          red: "Kırmızı",
          saturation: "Doygunluk"
        };
        var F;
        F = {
          alpha: "Альфа",
          blue: "Синій",
          brightness: "Яскравість",
          green: "Зелений",
          hue: "Тон",
          lightness: "Освітленість",
          red: "Червоний",
          saturation: "Насиченість"
        };
        var M;
        M = {
          alpha: "Alpha",
          blue: "蓝色",
          brightness: "亮度",
          green: "绿色",
          hue: "色相",
          lightness: "明亮度",
          red: "红色",
          saturation: "饱和度"
        };
        var R;
        R = {
          alpha: "Alpha",
          blue: "藍色",
          brightness: "亮度",
          green: "綠色",
          hue: "色相",
          lightness: "明亮",
          red: "紅色",
          saturation: "飽和度"
        };
        var j = n(85010),
          B = n(46050),
          N = n(96041),
          L = n(67294),
          V = n(31397),
          K = n(38947);
        function q(e) {
          return e && e.__esModule ? e.default : e;
        }
        var H;
        H = {
          "ar-AE": r,
          "bg-BG": o,
          "cs-CZ": i,
          "da-DK": a,
          "de-DE": s,
          "el-GR": l,
          "en-US": u,
          "es-ES": c,
          "et-EE": d,
          "fi-FI": p,
          "fr-FR": h,
          "he-IL": f,
          "hr-HR": m,
          "hu-HU": g,
          "it-IT": v,
          "ja-JP": y,
          "ko-KR": b,
          "lt-LT": w,
          "lv-LV": x,
          "nb-NO": D,
          "nl-NL": C,
          "pl-PL": S,
          "pt-BR": E,
          "pt-PT": _,
          "ro-RO": P,
          "ru-RU": k,
          "sk-SK": A,
          "sl-SI": z,
          "sr-SP": T,
          "sv-SE": O,
          "tr-TR": I,
          "uk-UA": F,
          "zh-CN": M,
          "zh-TW": R
        };
        let U = new (0, B.J)(q(H));
        function Z(e) {
          let t = W.parse(e) || X.parse(e) || ee.parse(e);
          if (t) return t;
          throw new Error("Invalid color value: " + e);
        }
        function $(e) {
          return "string" == typeof e ? Z(e) : e;
        }
        class G {
          toHexInt() {
            return this.toFormat("rgb").toHexInt();
          }
          getChannelValue(e) {
            if (e in this) return this[e];
            throw new Error("Unsupported color channel: " + e);
          }
          withChannelValue(e, t) {
            if (e in this) {
              let n = this.clone();
              return n[e] = t, n;
            }
            throw new Error("Unsupported color channel: " + e);
          }
          getChannelName(e, t) {
            return (B.J.getGlobalDictionaryForPackage("@react-stately/color") || U).getStringForLocale(e, t);
          }
          getColorSpaceAxes(e) {
            let {
                xChannel: t,
                yChannel: n
              } = e,
              r = t || this.getColorChannels().find(e => e !== n),
              o = n || this.getColorChannels().find(e => e !== r),
              i = this.getColorChannels().find(e => e !== r && e !== o);
            return {
              xChannel: r,
              yChannel: o,
              zChannel: i
            };
          }
        }
        let W = /*#__PURE__*/(() => {
          class W extends G {
            static parse(e) {
              let t = [];
              if (/^#[\da-f]+$/i.test(e) && [4, 5, 7, 9].includes(e.length)) {
                const n = (e.length < 6 ? e.replace(/[^#]/gi, "$&$&") : e).slice(1).split("");
                for (; n.length > 0;) t.push(parseInt(n.splice(0, 2).join(""), 16));
                t[3] = void 0 !== t[3] ? t[3] / 255 : void 0;
              }
              const n = e.match(/^rgba?\((.*)\)$/);
              var r;
              return (null == n ? void 0 : n[1]) && (t = n[1].split(",").map(e => Number(e.trim())), t = t.map((e, t) => (0, j.uZ)(e, 0, t < 3 ? 255 : 1))), t.length < 3 ? void 0 : new W(t[0], t[1], t[2], null !== (r = t[3]) && void 0 !== r ? r : 1);
            }
            toString(e) {
              switch (e) {
                case "hex":
                  return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
                case "hexa":
                  return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(255 * this.alpha).toString(16).padStart(2, "0")).toUpperCase();
                case "rgb":
                  return `rgb(${this.red}, ${this.green}, ${this.blue})`;
                case "css":
                case "rgba":
                  return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
                default:
                  return this.toFormat(e).toString(e);
              }
            }
            toFormat(e) {
              switch (e) {
                case "hex":
                case "hexa":
                case "rgb":
                case "rgba":
                  return this;
                case "hsb":
                case "hsba":
                  return this.toHSB();
                case "hsl":
                case "hsla":
                  return this.toHSL();
                default:
                  throw new Error("Unsupported color conversion: rgb -> " + e);
              }
            }
            toHexInt() {
              return this.red << 16 | this.green << 8 | this.blue;
            }
            toHSB() {
              const e = this.red / 255,
                t = this.green / 255,
                n = this.blue / 255,
                r = Math.min(e, t, n),
                o = Math.max(e, t, n),
                i = o - r,
                a = 0 === o ? 0 : i / o;
              let s = 0;
              if (0 !== i) {
                switch (o) {
                  case e:
                    s = (t - n) / i + (t < n ? 6 : 0);
                    break;
                  case t:
                    s = (n - e) / i + 2;
                    break;
                  case n:
                    s = (e - t) / i + 4;
                }
                s /= 6;
              }
              return new X((0, j.lt)(360 * s, 2), (0, j.lt)(100 * a, 2), (0, j.lt)(100 * o, 2), this.alpha);
            }
            toHSL() {
              const e = this.red / 255,
                t = this.green / 255,
                n = this.blue / 255,
                r = Math.min(e, t, n),
                o = Math.max(e, t, n),
                i = (o + r) / 2,
                a = o - r;
              let s, l;
              if (0 === a) s = l = 0;else {
                switch (l = a / (i < .5 ? o + r : 2 - o - r), o) {
                  case e:
                    s = (t - n) / a + (t < n ? 6 : 0);
                    break;
                  case t:
                    s = (n - e) / a + 2;
                    break;
                  case n:
                    s = (e - t) / a + 4;
                }
                s /= 6;
              }
              return new ee((0, j.lt)(360 * s, 2), (0, j.lt)(100 * l, 2), (0, j.lt)(100 * i, 2), this.alpha);
            }
            clone() {
              return new W(this.red, this.green, this.blue, this.alpha);
            }
            getChannelRange(e) {
              switch (e) {
                case "red":
                case "green":
                case "blue":
                  return {
                    minValue: 0,
                    maxValue: 255,
                    step: 1,
                    pageSize: 17
                  };
                case "alpha":
                  return {
                    minValue: 0,
                    maxValue: 1,
                    step: .01,
                    pageSize: .1
                  };
                default:
                  throw new Error("Unknown color channel: " + e);
              }
            }
            formatChannelValue(e, t) {
              let n,
                r = this.getChannelValue(e);
              switch (e) {
                case "red":
                case "green":
                case "blue":
                  n = {
                    style: "decimal"
                  };
                  break;
                case "alpha":
                  n = {
                    style: "percent"
                  };
                  break;
                default:
                  throw new Error("Unknown color channel: " + e);
              }
              return new (0, N.e)(t, n).format(r);
            }
            getColorSpace() {
              return "rgb";
            }
            getColorChannels() {
              return W.colorChannels;
            }
            constructor(e, t, n, r) {
              super(), this.red = e, this.green = t, this.blue = n, this.alpha = r;
            }
          }
          W.colorChannels = ["red", "green", "blue"];
          return W;
        })();
        const Y = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
        let X = /*#__PURE__*/(() => {
          class X extends G {
            static parse(e) {
              let t;
              if (t = e.match(Y)) {
                var n;
                const [e, r, o, i] = (null !== (n = t[1]) && void 0 !== n ? n : t[2]).split(",").map(e => Number(e.trim().replace("%", "")));
                return new X(J(e, 360), (0, j.uZ)(r, 0, 100), (0, j.uZ)(o, 0, 100), (0, j.uZ)(null != i ? i : 1, 0, 1));
              }
            }
            toString(e) {
              switch (e) {
                case "css":
                  return this.toHSL().toString("css");
                case "hex":
                  return this.toRGB().toString("hex");
                case "hexa":
                  return this.toRGB().toString("hexa");
                case "hsb":
                  return `hsb(${this.hue}, ${(0, j.lt)(this.saturation, 2)}%, ${(0, j.lt)(this.brightness, 2)}%)`;
                case "hsba":
                  return `hsba(${this.hue}, ${(0, j.lt)(this.saturation, 2)}%, ${(0, j.lt)(this.brightness, 2)}%, ${this.alpha})`;
                default:
                  return this.toFormat(e).toString(e);
              }
            }
            toFormat(e) {
              switch (e) {
                case "hsb":
                case "hsba":
                  return this;
                case "hsl":
                case "hsla":
                  return this.toHSL();
                case "rgb":
                case "rgba":
                  return this.toRGB();
                default:
                  throw new Error("Unsupported color conversion: hsb -> " + e);
              }
            }
            toHSL() {
              let e = this.saturation / 100,
                t = this.brightness / 100,
                n = t * (1 - e / 2);
              return e = 0 === n || 1 === n ? 0 : (t - n) / Math.min(n, 1 - n), new ee((0, j.lt)(this.hue, 2), (0, j.lt)(100 * e, 2), (0, j.lt)(100 * n, 2), this.alpha);
            }
            toRGB() {
              let e = this.hue,
                t = this.saturation / 100,
                n = this.brightness / 100,
                r = (r, o = (r + e / 60) % 6) => n - t * n * Math.max(Math.min(o, 4 - o, 1), 0);
              return new W(Math.round(255 * r(5)), Math.round(255 * r(3)), Math.round(255 * r(1)), this.alpha);
            }
            clone() {
              return new X(this.hue, this.saturation, this.brightness, this.alpha);
            }
            getChannelRange(e) {
              switch (e) {
                case "hue":
                  return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                  };
                case "saturation":
                case "brightness":
                  return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                  };
                case "alpha":
                  return {
                    minValue: 0,
                    maxValue: 1,
                    step: .01,
                    pageSize: .1
                  };
                default:
                  throw new Error("Unknown color channel: " + e);
              }
            }
            formatChannelValue(e, t) {
              let n,
                r = this.getChannelValue(e);
              switch (e) {
                case "hue":
                  n = {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                  };
                  break;
                case "saturation":
                case "brightness":
                  n = {
                    style: "percent"
                  }, r /= 100;
                  break;
                case "alpha":
                  n = {
                    style: "percent"
                  };
                  break;
                default:
                  throw new Error("Unknown color channel: " + e);
              }
              return new (0, N.e)(t, n).format(r);
            }
            getColorSpace() {
              return "hsb";
            }
            getColorChannels() {
              return X.colorChannels;
            }
            constructor(e, t, n, r) {
              super(), this.hue = e, this.saturation = t, this.brightness = n, this.alpha = r;
            }
          }
          X.colorChannels = ["hue", "saturation", "brightness"];
          return X;
        })();
        const Q = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/;
        function J(e, t) {
          return (e % t + t) % t;
        }
        let ee = /*#__PURE__*/(() => {
          class ee extends G {
            static parse(e) {
              let t;
              if (t = e.match(Q)) {
                var n;
                const [e, r, o, i] = (null !== (n = t[1]) && void 0 !== n ? n : t[2]).split(",").map(e => Number(e.trim().replace("%", "")));
                return new ee(J(e, 360), (0, j.uZ)(r, 0, 100), (0, j.uZ)(o, 0, 100), (0, j.uZ)(null != i ? i : 1, 0, 1));
              }
            }
            toString(e) {
              switch (e) {
                case "hex":
                  return this.toRGB().toString("hex");
                case "hexa":
                  return this.toRGB().toString("hexa");
                case "hsl":
                  return `hsl(${this.hue}, ${(0, j.lt)(this.saturation, 2)}%, ${(0, j.lt)(this.lightness, 2)}%)`;
                case "css":
                case "hsla":
                  return `hsla(${this.hue}, ${(0, j.lt)(this.saturation, 2)}%, ${(0, j.lt)(this.lightness, 2)}%, ${this.alpha})`;
                default:
                  return this.toFormat(e).toString(e);
              }
            }
            toFormat(e) {
              switch (e) {
                case "hsl":
                case "hsla":
                  return this;
                case "hsb":
                case "hsba":
                  return this.toHSB();
                case "rgb":
                case "rgba":
                  return this.toRGB();
                default:
                  throw new Error("Unsupported color conversion: hsl -> " + e);
              }
            }
            toHSB() {
              let e = this.saturation / 100,
                t = this.lightness / 100,
                n = t + e * Math.min(t, 1 - t);
              return e = 0 === n ? 0 : 2 * (1 - t / n), new X((0, j.lt)(this.hue, 2), (0, j.lt)(100 * e, 2), (0, j.lt)(100 * n, 2), this.alpha);
            }
            toRGB() {
              let e = this.hue,
                t = this.saturation / 100,
                n = this.lightness / 100,
                r = t * Math.min(n, 1 - n),
                o = (t, o = (t + e / 30) % 12) => n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
              return new W(Math.round(255 * o(0)), Math.round(255 * o(8)), Math.round(255 * o(4)), this.alpha);
            }
            clone() {
              return new ee(this.hue, this.saturation, this.lightness, this.alpha);
            }
            getChannelRange(e) {
              switch (e) {
                case "hue":
                  return {
                    minValue: 0,
                    maxValue: 360,
                    step: 1,
                    pageSize: 15
                  };
                case "saturation":
                case "lightness":
                  return {
                    minValue: 0,
                    maxValue: 100,
                    step: 1,
                    pageSize: 10
                  };
                case "alpha":
                  return {
                    minValue: 0,
                    maxValue: 1,
                    step: .01,
                    pageSize: .1
                  };
                default:
                  throw new Error("Unknown color channel: " + e);
              }
            }
            formatChannelValue(e, t) {
              let n,
                r = this.getChannelValue(e);
              switch (e) {
                case "hue":
                  n = {
                    style: "unit",
                    unit: "degree",
                    unitDisplay: "narrow"
                  };
                  break;
                case "saturation":
                case "lightness":
                  n = {
                    style: "percent"
                  }, r /= 100;
                  break;
                case "alpha":
                  n = {
                    style: "percent"
                  };
                  break;
                default:
                  throw new Error("Unknown color channel: " + e);
              }
              return new (0, N.e)(t, n).format(r);
            }
            getColorSpace() {
              return "hsl";
            }
            getColorChannels() {
              return ee.colorChannels;
            }
            constructor(e, t, n, r) {
              super(), this.hue = e, this.saturation = t, this.lightness = n, this.alpha = r;
            }
          }
          ee.colorChannels = ["hue", "saturation", "lightness"];
          return ee;
        })();
        const te = Z("#ffffff");
        function ne(e) {
          let {
            value: t,
            defaultValue: n,
            xChannel: r,
            yChannel: o,
            onChange: i,
            onChangeEnd: a
          } = e;
          t || n || (n = te);
          let [s, l] = (0, j.zk)(t && $(t), n && $(n), i),
            u = (0, L.useRef)(s),
            c = e => {
              u.current = e, l(e);
            },
            d = (0, L.useMemo)(() => s.getColorSpaceAxes({
              xChannel: r,
              yChannel: o
            }), [s, r, o]),
            p = s.getChannelRange(d.xChannel),
            h = s.getChannelRange(d.yChannel),
            {
              minValue: f,
              maxValue: m,
              step: g,
              pageSize: v
            } = p,
            {
              minValue: y,
              maxValue: b,
              step: w,
              pageSize: x
            } = h,
            [D, C] = (0, L.useState)(!1),
            S = (0, L.useRef)(!1),
            E = s.getChannelValue(d.xChannel),
            _ = s.getChannelValue(d.yChannel),
            P = e => {
              if (e === E) return;
              let t = s.withChannelValue(d.xChannel, e);
              c(t);
            },
            k = e => {
              if (e === _) return;
              let t = s.withChannelValue(d.yChannel, e);
              c(t);
            };
          return {
            channels: d,
            xChannelStep: g,
            yChannelStep: w,
            xChannelPageStep: v,
            yChannelPageStep: x,
            value: s,
            setValue(e) {
              c($(e));
            },
            xValue: E,
            setXValue: P,
            yValue: _,
            setYValue: k,
            setColorFromPoint(e, t) {
              let n,
                r = f + (0, j.uZ)(e, 0, 1) * (m - f),
                o = y + (1 - (0, j.uZ)(t, 0, 1)) * (b - y);
              r !== E && (r = (0, j.N4)(r, f, m, g), n = s.withChannelValue(d.xChannel, r)), o !== _ && (o = (0, j.N4)(o, y, b, w), n = (n || s).withChannelValue(d.yChannel, o)), n && c(n);
            },
            getThumbPosition: () => ({
              x: (E - f) / (m - f),
              y: 1 - (_ - y) / (b - y)
            }),
            incrementX(e) {
              P(E + e > m ? m : (0, j.N4)(E + e, f, m, g));
            },
            incrementY(e) {
              k(_ + e > b ? b : (0, j.N4)(_ + e, y, b, w));
            },
            decrementX(e) {
              P((0, j.N4)(E - e, f, m, g));
            },
            decrementY(e) {
              k((0, j.N4)(_ - e, y, b, w));
            },
            setDragging(e) {
              let t = S.current;
              S.current = e, a && !e && t && a(u.current), C(e);
            },
            isDragging: D,
            getDisplayColor: () => s.withChannelValue("alpha", 1)
          };
        }
        function re(e) {
          let {
            channel: t,
            value: n,
            defaultValue: r,
            onChange: o,
            locale: i,
            ...a
          } = e;
          if (null == n && null == r) throw new Error("useColorSliderState requires a value or defaultValue");
          let [s, l] = (0, j.zk)(n && $(n), r && $(r), o),
            u = (0, V.x)({
              ...s.getChannelRange(t),
              ...a,
              numberFormatter: null,
              value: s.getChannelValue(t),
              onChange(e) {
                l(s.withChannelValue(t, e));
              },
              onChangeEnd(n) {
                e.onChangeEnd && e.onChangeEnd(s.withChannelValue(t, n));
              }
            }),
            {
              step: c,
              pageSize: d
            } = s.getChannelRange(t);
          return {
            ...u,
            value: s,
            setValue(e) {
              l($(e));
            },
            getDisplayColor() {
              switch (t) {
                case "hue":
                  return Z(`hsl(${s.getChannelValue("hue")}, 100%, 50%)`);
                case "lightness":
                case "brightness":
                case "saturation":
                case "red":
                case "green":
                case "blue":
                  return s.withChannelValue("alpha", 1);
                case "alpha":
                  return s;
                default:
                  throw new Error("Unknown color channel: " + t);
              }
            },
            getThumbValueLabel: () => s.formatChannelValue(t, i),
            step: c,
            pageSize: d
          };
        }
        Z("hsl(0, 100%, 50%)");
        function oe(e) {
          return (0, L.useMemo)(() => {
            if ("string" == typeof e) try {
              return Z(e);
            } catch (e) {
              return;
            }
            return e;
          }, [e]);
        }
        const ie = Z("#000000"),
          ae = Z("#FFFFFF"),
          se = ie.toHexInt(),
          le = ae.toHexInt();
        function ue(e) {
          let {
              value: t,
              defaultValue: n,
              onChange: r
            } = e,
            {
              step: o
            } = ie.getChannelRange("red"),
            i = oe(t),
            a = oe(n),
            [s, l] = (0, j.zk)(i, a, r),
            [u, c] = (0, L.useState)(() => (t || n) && s ? s.toString("hex") : ""),
            d = (0, K.Q3)({
              ...e,
              value: s
            }),
            p = e => {
              s && e && e.toHexInt() === s.toHexInt() || l(e);
            },
            [h, f] = (0, L.useState)(s);
          h !== s && (c(s ? s.toString("hex") : ""), f(s));
          let m = (0, L.useMemo)(() => {
            let e;
            try {
              e = Z(u.startsWith("#") ? u : `#${u}`);
            } catch (t) {
              e = null;
            }
            return e;
          }, [u]);
          return {
            ...d,
            validate: e => {
              var t;
              return "" === e || !!(null === (t = e.match(/^#?[0-9a-f]{0,6}$/i)) || void 0 === t ? void 0 : t[0]);
            },
            colorValue: s,
            inputValue: u,
            setInputValue: c,
            commit: () => {
              if (!u.length) return p(null), void c(void 0 === t ? "" : s.toString("hex"));
              if (null == m) return void c(s ? s.toString("hex") : "");
              p(m);
              let e = "";
              s && (e = s.toString("hex")), c(e);
            },
            increment: () => {
              let e = ce(m, o);
              e === s && c(e.toString("hex")), p(e), d.commitValidation();
            },
            incrementToMax: () => p(ae),
            decrement: () => {
              let e = ce(m, -o);
              e === s && c(e.toString("hex")), p(e), d.commitValidation();
            },
            decrementToMin: () => p(ie)
          };
        }
        function ce(e, t) {
          let n = e || ie,
            r = n.toHexInt(),
            o = Math.min(Math.max(r + t, se), le);
          if (o !== r) {
            n = Z(`#${o.toString(16).padStart(6, "0").toUpperCase()}`);
          }
          return n;
        }
      },
      62651: (e, t, n) => {
        "use strict";
      },
      38947: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q3: () => u,
          tL: () => l
        });
        var r = n(67294);
        const o = {
            badInput: !1,
            customError: !1,
            patternMismatch: !1,
            rangeOverflow: !1,
            rangeUnderflow: !1,
            stepMismatch: !1,
            tooLong: !1,
            tooShort: !1,
            typeMismatch: !1,
            valueMissing: !1,
            valid: !0
          },
          i = {
            ...o,
            customError: !0,
            valid: !1
          },
          a = {
            isInvalid: !1,
            validationDetails: o,
            validationErrors: []
          },
          s = (0, r.createContext)({}),
          l = "__formValidationState" + Date.now();
        function u(e) {
          if (e[l]) {
            let {
              realtimeValidation: t,
              displayValidation: n,
              updateValidation: r,
              resetValidation: o,
              commitValidation: i
            } = e[l];
            return {
              realtimeValidation: t,
              displayValidation: n,
              updateValidation: r,
              resetValidation: o,
              commitValidation: i
            };
          }
          return function (e) {
            let {
              isInvalid: t,
              validationState: n,
              name: o,
              value: l,
              builtinValidation: u,
              validate: h,
              validationBehavior: f = "aria"
            } = e;
            n && (t || (t = "invalid" === n));
            let m = t ? {
                isInvalid: !0,
                validationErrors: [],
                validationDetails: i
              } : null,
              g = (0, r.useMemo)(() => d(function (e, t) {
                if ("function" == typeof e) {
                  let n = e(t);
                  if (n && "boolean" != typeof n) return c(n);
                }
                return [];
              }(h, l)), [h, l]);
            (null == u ? void 0 : u.validationDetails.valid) && (u = null);
            let v = (0, r.useContext)(s),
              y = (0, r.useMemo)(() => o ? Array.isArray(o) ? o.flatMap(e => c(v[e])) : c(v[o]) : [], [v, o]),
              [b, w] = (0, r.useState)(v),
              [x, D] = (0, r.useState)(!1);
            v !== b && (w(v), D(!1));
            let C = (0, r.useMemo)(() => d(x ? [] : y), [x, y]),
              S = (0, r.useRef)(a),
              [E, _] = (0, r.useState)(a),
              P = (0, r.useRef)(a),
              k = () => {
                if (!A) return;
                z(!1);
                let e = g || u || S.current;
                p(e, P.current) || (P.current = e, _(e));
              },
              [A, z] = (0, r.useState)(!1);
            return (0, r.useEffect)(k), {
              realtimeValidation: m || C || g || u || a,
              displayValidation: "native" === f ? m || C || E : m || C || g || u || E,
              updateValidation(e) {
                "aria" !== f || p(E, e) ? S.current = e : _(e);
              },
              resetValidation() {
                let e = a;
                p(e, P.current) || (P.current = e, _(e)), "native" === f && z(!1), D(!0);
              },
              commitValidation() {
                "native" === f && z(!0), D(!0);
              }
            };
          }(e);
        }
        function c(e) {
          return e ? Array.isArray(e) ? e : [e] : [];
        }
        function d(e) {
          return e.length ? {
            isInvalid: !0,
            validationErrors: e,
            validationDetails: i
          } : null;
        }
        function p(e, t) {
          return e === t || e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((e, n) => e === t.validationErrors[n]) && Object.entries(e.validationDetails).every(([e, n]) => t.validationDetails[e] === n);
        }
      },
      31397: (e, t, n) => {
        "use strict";

        n.d(t, {
          x: () => l
        });
        var r = n(85010),
          o = n(67294);
        const i = 0,
          a = 100,
          s = 1;
        function l(e) {
          const {
            isDisabled: t = !1,
            minValue: n = i,
            maxValue: l = a,
            numberFormatter: p,
            step: h = s,
            orientation: f = "horizontal"
          } = e;
          let m = (0, o.useMemo)(() => {
              let e = (l - n) / 10;
              return e = (0, r.N4)(e, 0, e + h, h), Math.max(e, h);
            }, [h, l, n]),
            g = (0, o.useCallback)(e => null == e ? void 0 : e.map((t, o) => {
              let i = 0 === o ? n : t[o - 1],
                a = o === e.length - 1 ? l : t[o + 1];
              return (0, r.N4)(t, i, a, h);
            }), [n, l, h]),
            v = (0, o.useMemo)(() => g(c(e.value)), [e.value]),
            y = (0, o.useMemo)(() => {
              var t;
              return g(null !== (t = c(e.defaultValue)) && void 0 !== t ? t : [n]);
            }, [e.defaultValue, n]),
            b = d(e.value, e.defaultValue, e.onChange),
            w = d(e.value, e.defaultValue, e.onChangeEnd);
          const [x, D] = (0, r.zk)(v, y, b),
            [C, S] = (0, o.useState)(new Array(x.length).fill(!1)),
            E = (0, o.useRef)(new Array(x.length).fill(!0)),
            [_, P] = (0, o.useState)(void 0),
            k = (0, o.useRef)(x),
            A = (0, o.useRef)(C);
          function z(e) {
            return (e - n) / (l - n);
          }
          function T(e) {
            return 0 === e ? n : x[e - 1];
          }
          function O(e) {
            return e === x.length - 1 ? l : x[e + 1];
          }
          function I(e) {
            return E.current[e];
          }
          function F(e, n) {
            if (t || !I(e)) return;
            const o = T(e),
              i = O(e);
            n = (0, r.N4)(n, o, i, h), (e => {
              k.current = e, D(e);
            })(u(k.current, e, n));
          }
          function M(e) {
            return p.format(e);
          }
          function R(e) {
            const t = e * (l - n) + n;
            return (0, r.uZ)(function (e) {
              return Math.round((e - n) / h) * h + n;
            }(t), n, l);
          }
          return {
            values: x,
            getThumbValue: e => x[e],
            setThumbValue: F,
            setThumbPercent: function (e, t) {
              F(e, R(t));
            },
            isThumbDragging: e => C[e],
            setThumbDragging: function (e, n) {
              if (t || !I(e)) return;
              n && (k.current = x);
              const r = A.current[e];
              var o;
              A.current = u(A.current, e, n), o = A.current, A.current = o, S(o), w && r && !A.current.some(Boolean) && w(k.current);
            },
            focusedThumb: _,
            setFocusedThumb: P,
            getThumbPercent: e => z(x[e]),
            getValuePercent: z,
            getThumbValueLabel: e => M(x[e]),
            getFormattedValue: M,
            getThumbMinValue: T,
            getThumbMaxValue: O,
            getPercentValue: R,
            isThumbEditable: I,
            setThumbEditable: function (e, t) {
              E.current[e] = t;
            },
            incrementThumb: function (e, t = 1) {
              let o = Math.max(t, h);
              F(e, (0, r.N4)(x[e] + o, n, l, h));
            },
            decrementThumb: function (e, t = 1) {
              let o = Math.max(t, h);
              F(e, (0, r.N4)(x[e] - o, n, l, h));
            },
            step: h,
            pageSize: m,
            orientation: f,
            isDisabled: t
          };
        }
        function u(e, t, n) {
          return e[t] === n ? e : [...e.slice(0, t), n, ...e.slice(t + 1)];
        }
        function c(e) {
          if (null != e) return Array.isArray(e) ? e : [e];
        }
        function d(e, t, n) {
          return r => {
            "number" == typeof e || "number" == typeof t ? null == n || n(r[0]) : null == n || n(r);
          };
        }
      },
      21946: (e, t, n) => {
        "use strict";

        n.d(t, {
          l: () => o
        });
        var r = n(85010);
        function o(e = {}) {
          let {
              isReadOnly: t
            } = e,
            [n, o] = (0, r.zk)(e.isSelected, e.defaultSelected || !1, e.onChange);
          return {
            isSelected: n,
            setSelected: function (e) {
              t || o(e);
            },
            toggle: function () {
              t || o(!n);
            }
          };
        }
      },
      85010: (e, t, n) => {
        "use strict";

        n.d(t, {
          N4: () => a,
          lt: () => s,
          uZ: () => i,
          zk: () => o
        });
        var r = n(67294);
        function o(e, t, n) {
          let [o, i] = (0, r.useState)(e || t),
            a = (0, r.useRef)(void 0 !== e),
            s = void 0 !== e;
          (0, r.useEffect)(() => {
            let e = a.current;
            e !== s && console.warn(`WARN: A component changed from ${e ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}.`), a.current = s;
          }, [s]);
          let l = s ? e : o,
            u = (0, r.useCallback)((e, ...t) => {
              let r = (e, ...t) => {
                n && (Object.is(l, e) || n(e, ...t)), s || (l = e);
              };
              if ("function" == typeof e) {
                console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), i((n, ...o) => {
                  let i = e(s ? l : n, ...o);
                  return r(i, ...t), s ? n : i;
                });
              } else s || i(e), r(e, ...t);
            }, [s, l, n]);
          return [l, u];
        }
        function i(e, t = -1 / 0, n = 1 / 0) {
          return Math.min(Math.max(e, t), n);
        }
        function a(e, t, n, r) {
          t = Number(t), n = Number(n);
          let o = (e - (isNaN(t) ? 0 : t)) % r,
            i = 2 * Math.abs(o) >= r ? e + Math.sign(o) * (r - Math.abs(o)) : e - o;
          isNaN(t) ? !isNaN(n) && i > n && (i = Math.floor(n / r) * r) : i < t ? i = t : !isNaN(n) && i > n && (i = t + Math.floor((n - t) / r) * r);
          let a = r.toString(),
            s = a.indexOf("."),
            l = s >= 0 ? a.length - s : 0;
          if (l > 0) {
            let e = Math.pow(10, l);
            i = Math.round(i * e) / e;
          }
          return i;
        }
        function s(e, t, n = 10) {
          const r = Math.pow(n, t);
          return Math.round(e * r) / r;
        }
      },
      44228: (e, t, n) => {
        "use strict";

        n.d(t, {
          xC: () => E,
          oM: () => z
        });
        var r = n(76438),
          o = n(28623);
        function i(e, t = "expected a function, instead received " + typeof e) {
          if ("function" != typeof e) throw new TypeError(t);
        }
        var a = e => Array.isArray(e) ? e : [e];
        function s(e) {
          const t = Array.isArray(e[0]) ? e[0] : e;
          return function (e, t = "expected all items to be functions, instead received the following types: ") {
            if (!e.every(e => "function" == typeof e)) {
              const n = e.map(e => "function" == typeof e ? `function ${e.name || "unnamed"}()` : typeof e).join(", ");
              throw new TypeError(`${t}[${n}]`);
            }
          }(t, "createSelector expects all input-selectors to be functions, but received the following types: "), t;
        }
        function l(e, t) {
          const n = [],
            {
              length: r
            } = e;
          for (let o = 0; o < r; o++) n.push(e[o].apply(null, t));
          return n;
        }
        Symbol(), Object.getPrototypeOf({});
        var u = "undefined" != typeof WeakRef ? WeakRef : class {
          constructor(e) {
            this.value = e;
          }
          deref() {
            return this.value;
          }
        };
        function c(e, t = {}) {
          let n = {
            s: 0,
            v: void 0,
            o: null,
            p: null
          };
          const {
            resultEqualityCheck: r
          } = t;
          let o,
            i = 0;
          function a() {
            let t = n;
            const {
              length: a
            } = arguments;
            for (let e = 0, n = a; e < n; e++) {
              const n = arguments[e];
              if ("function" == typeof n || "object" == typeof n && null !== n) {
                let e = t.o;
                null === e && (t.o = e = new WeakMap());
                const r = e.get(n);
                void 0 === r ? (t = {
                  s: 0,
                  v: void 0,
                  o: null,
                  p: null
                }, e.set(n, t)) : t = r;
              } else {
                let e = t.p;
                null === e && (t.p = e = new Map());
                const r = e.get(n);
                void 0 === r ? (t = {
                  s: 0,
                  v: void 0,
                  o: null,
                  p: null
                }, e.set(n, t)) : t = r;
              }
            }
            const s = t;
            let l;
            if (1 === t.s ? l = t.v : (l = e.apply(null, arguments), i++), s.s = 1, r) {
              const e = o?.deref?.() ?? o;
              null != e && r(e, l) && (l = e, 0 !== i && i--);
              o = "object" == typeof l && null !== l || "function" == typeof l ? new u(l) : l;
            }
            return s.v = l, l;
          }
          return a.clearCache = () => {
            n = {
              s: 0,
              v: void 0,
              o: null,
              p: null
            }, a.resetResultsCount();
          }, a.resultsCount = () => i, a.resetResultsCount = () => {
            i = 0;
          }, a;
        }
        function d(e, ...t) {
          const n = "function" == typeof e ? {
              memoize: e,
              memoizeOptions: t
            } : e,
            r = (...e) => {
              let t,
                r = 0,
                o = 0,
                u = {},
                d = e.pop();
              "object" == typeof d && (u = d, d = e.pop()), i(d, `createSelector expects an output function after the inputs, but received: [${typeof d}]`);
              const p = {
                  ...n,
                  ...u
                },
                {
                  memoize: h,
                  memoizeOptions: f = [],
                  argsMemoize: m = c,
                  argsMemoizeOptions: g = [],
                  devModeChecks: v = {}
                } = p,
                y = a(f),
                b = a(g),
                w = s(e),
                x = h(function () {
                  return r++, d.apply(null, arguments);
                }, ...y);
              const D = m(function () {
                o++;
                const e = l(w, arguments);
                return t = x.apply(null, e), t;
              }, ...b);
              return Object.assign(D, {
                resultFunc: d,
                memoizedResultFunc: x,
                dependencies: w,
                dependencyRecomputations: () => o,
                resetDependencyRecomputations: () => {
                  o = 0;
                },
                lastResult: () => t,
                recomputations: () => r,
                resetRecomputations: () => {
                  r = 0;
                },
                memoize: h,
                argsMemoize: m
              });
            };
          return Object.assign(r, {
            withTypes: () => r
          }), r;
        }
        var p = d(c),
          h = Object.assign((e, t = p) => {
            !function (e, t = "expected an object, instead received " + typeof e) {
              if ("object" != typeof e) throw new TypeError(t);
            }(e, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a " + typeof e);
            const n = Object.keys(e);
            return t(n.map(t => e[t]), (...e) => e.reduce((e, t, r) => (e[n[r]] = t, e), {}));
          }, {
            withTypes: () => h
          });
        function f(e) {
          return ({
            dispatch: t,
            getState: n
          }) => r => o => "function" == typeof o ? o(t, n, e) : r(o);
        }
        var m = f(),
          g = f,
          v = (((...e) => {
            const t = d(...e);
          })(c), "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
            if (0 !== arguments.length) return "object" == typeof arguments[0] ? r.qC : r.qC.apply(null, arguments);
          });
        "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__;
        function y(e, t) {
          function n(...n) {
            if (t) {
              let r = t(...n);
              if (!r) throw new Error(F(0));
              return {
                type: e,
                payload: r.payload,
                ...("meta" in r && {
                  meta: r.meta
                }),
                ...("error" in r && {
                  error: r.error
                })
              };
            }
            return {
              type: e,
              payload: n[0]
            };
          }
          return n.toString = () => `${e}`, n.type = e, n.match = t => (0, r.LG)(t) && t.type === e, n;
        }
        var b = class e extends Array {
          constructor(...t) {
            super(...t), Object.setPrototypeOf(this, e.prototype);
          }
          static get [Symbol.species]() {
            return e;
          }
          concat(...e) {
            return super.concat.apply(this, e);
          }
          prepend(...t) {
            return 1 === t.length && Array.isArray(t[0]) ? new e(...t[0].concat(this)) : new e(...t.concat(this));
          }
        };
        function w(e) {
          return (0, o.o$)(e) ? (0, o.Uy)(e, () => {}) : e;
        }
        function x(e, t, n) {
          if (e.has(t)) {
            let r = e.get(t);
            return n.update && (r = n.update(r, t, e), e.set(t, r)), r;
          }
          if (!n.insert) throw new Error(F(10));
          const r = n.insert(t, e);
          return e.set(t, r), r;
        }
        var D = e => t => {
            setTimeout(t, e);
          },
          C = "undefined" != typeof window && window.requestAnimationFrame ? window.requestAnimationFrame : D(10),
          S = e => function (t) {
            const {
              autoBatch: n = !0
            } = t ?? {};
            let r = new b(e);
            return n && r.push(((e = {
              type: "raf"
            }) => t => (...n) => {
              const r = t(...n);
              let o = !0,
                i = !1,
                a = !1;
              const s = new Set(),
                l = "tick" === e.type ? queueMicrotask : "raf" === e.type ? C : "callback" === e.type ? e.queueNotification : D(e.timeout),
                u = () => {
                  a = !1, i && (i = !1, s.forEach(e => e()));
                };
              return Object.assign({}, r, {
                subscribe(e) {
                  const t = r.subscribe(() => o && e());
                  return s.add(e), () => {
                    t(), s.delete(e);
                  };
                },
                dispatch(e) {
                  try {
                    return o = !e?.meta?.RTK_autoBatch, i = !o, i && (a || (a = !0, l(u))), r.dispatch(e);
                  } finally {
                    o = !0;
                  }
                }
              });
            })("object" == typeof n ? n : void 0)), r;
          };
        function E(e) {
          const t = function (e) {
              const {
                thunk: t = !0,
                immutableCheck: n = !0,
                serializableCheck: r = !0,
                actionCreatorCheck: o = !0
              } = e ?? {};
              let i = new b();
              return t && ("boolean" == typeof t ? i.push(m) : i.push(g(t.extraArgument))), i;
            },
            {
              reducer: n,
              middleware: o,
              devTools: i = !0,
              preloadedState: a,
              enhancers: s
            } = e || {};
          let l, u;
          if ("function" == typeof n) l = n;else {
            if (!(0, r.PO)(n)) throw new Error(F(1));
            l = (0, r.UY)(n);
          }
          u = "function" == typeof o ? o(t) : t();
          let c = r.qC;
          i && (c = v({
            trace: !1,
            ...("object" == typeof i && i)
          }));
          const d = (0, r.md)(...u),
            p = S(d);
          let h = "function" == typeof s ? s(p) : p();
          const f = c(...h);
          return (0, r.MT)(l, a, f);
        }
        function _(e) {
          const t = {},
            n = [];
          let r;
          const o = {
            addCase(e, n) {
              const r = "string" == typeof e ? e : e.type;
              if (!r) throw new Error(F(28));
              if (r in t) throw new Error(F(29));
              return t[r] = n, o;
            },
            addMatcher: (e, t) => (n.push({
              matcher: e,
              reducer: t
            }), o),
            addDefaultCase: e => (r = e, o)
          };
          return e(o), [t, n, r];
        }
        var P = Symbol.for("rtk-slice-createasyncthunk");
        function k(e, t) {
          return `${e}/${t}`;
        }
        function A(e, t, n, r) {
          function o(o, ...i) {
            let a = n.call(e, o);
            return void 0 === a && r && (a = e.getInitialState()), t(a, ...i);
          }
          return o.unwrapped = t, o;
        }
        var z = function ({
          creators: e
        } = {}) {
          const t = e?.asyncThunk?.[P];
          return function (e) {
            const {
              name: n,
              reducerPath: r = n
            } = e;
            if (!n) throw new Error(F(11));
            const i = ("function" == typeof e.reducers ? e.reducers(function () {
                function e(e, t) {
                  return {
                    _reducerDefinitionType: "asyncThunk",
                    payloadCreator: e,
                    ...t
                  };
                }
                return e.withTypes = () => e, {
                  reducer: e => Object.assign({
                    [e.name]: (...t) => e(...t)
                  }[e.name], {
                    _reducerDefinitionType: "reducer"
                  }),
                  preparedReducer: (e, t) => ({
                    _reducerDefinitionType: "reducerWithPrepare",
                    prepare: e,
                    reducer: t
                  }),
                  asyncThunk: e
                };
              }()) : e.reducers) || {},
              a = Object.keys(i),
              s = {
                sliceCaseReducersByName: {},
                sliceCaseReducersByType: {},
                actionCreators: {},
                sliceMatchers: []
              },
              l = {
                addCase(e, t) {
                  const n = "string" == typeof e ? e : e.type;
                  if (!n) throw new Error(F(12));
                  if (n in s.sliceCaseReducersByType) throw new Error(F(13));
                  return s.sliceCaseReducersByType[n] = t, l;
                },
                addMatcher: (e, t) => (s.sliceMatchers.push({
                  matcher: e,
                  reducer: t
                }), l),
                exposeAction: (e, t) => (s.actionCreators[e] = t, l),
                exposeCaseReducer: (e, t) => (s.sliceCaseReducersByName[e] = t, l)
              };
            function u() {
              const [t = {}, n = [], r] = "function" == typeof e.extraReducers ? _(e.extraReducers) : [e.extraReducers],
                i = {
                  ...t,
                  ...s.sliceCaseReducersByType
                };
              return function (e, t) {
                let n,
                  [r, i, a] = _(t);
                if ("function" == typeof e) n = () => w(e());else {
                  const t = w(e);
                  n = () => t;
                }
                function s(e = n(), t) {
                  let s = [r[t.type], ...i.filter(({
                    matcher: e
                  }) => e(t)).map(({
                    reducer: e
                  }) => e)];
                  return 0 === s.filter(e => !!e).length && (s = [a]), s.reduce((e, n) => {
                    if (n) {
                      if ((0, o.mv)(e)) {
                        const r = n(e, t);
                        return void 0 === r ? e : r;
                      }
                      if ((0, o.o$)(e)) return (0, o.Uy)(e, e => n(e, t));
                      {
                        const r = n(e, t);
                        if (void 0 === r) {
                          if (null === e) return e;
                          throw new Error(F(9));
                        }
                        return r;
                      }
                    }
                    return e;
                  }, e);
                }
                return s.getInitialState = n, s;
              }(e.initialState, e => {
                for (let t in i) e.addCase(t, i[t]);
                for (let t of s.sliceMatchers) e.addMatcher(t.matcher, t.reducer);
                for (let t of n) e.addMatcher(t.matcher, t.reducer);
                r && e.addDefaultCase(r);
              });
            }
            a.forEach(r => {
              const o = i[r],
                a = {
                  reducerName: r,
                  type: k(n, r),
                  createNotation: "function" == typeof e.reducers
                };
              !function (e) {
                return "asyncThunk" === e._reducerDefinitionType;
              }(o) ? function ({
                type: e,
                reducerName: t,
                createNotation: n
              }, r, o) {
                let i, a;
                if ("reducer" in r) {
                  if (n && !function (e) {
                    return "reducerWithPrepare" === e._reducerDefinitionType;
                  }(r)) throw new Error(F(17));
                  i = r.reducer, a = r.prepare;
                } else i = r;
                o.addCase(e, i).exposeCaseReducer(t, i).exposeAction(t, a ? y(e, a) : y(e));
              }(a, o, l) : function ({
                type: e,
                reducerName: t
              }, n, r, o) {
                if (!o) throw new Error(F(18));
                const {
                    payloadCreator: i,
                    fulfilled: a,
                    pending: s,
                    rejected: l,
                    settled: u,
                    options: c
                  } = n,
                  d = o(e, i, c);
                r.exposeAction(t, d), a && r.addCase(d.fulfilled, a);
                s && r.addCase(d.pending, s);
                l && r.addCase(d.rejected, l);
                u && r.addMatcher(d.settled, u);
                r.exposeCaseReducer(t, {
                  fulfilled: a || T,
                  pending: s || T,
                  rejected: l || T,
                  settled: u || T
                });
              }(a, o, l, t);
            });
            const c = e => e,
              d = new WeakMap();
            let p;
            const h = {
              name: n,
              reducerPath: r,
              reducer: (e, t) => (p || (p = u()), p(e, t)),
              actions: s.actionCreators,
              caseReducers: s.sliceCaseReducersByName,
              getInitialState: () => (p || (p = u()), p.getInitialState()),
              getSelectors(t = c) {
                const n = x(d, this, {
                  insert: () => new WeakMap()
                });
                return x(n, t, {
                  insert: () => {
                    const n = {};
                    for (const [r, o] of Object.entries(e.selectors ?? {})) n[r] = A(this, o, t, this !== h);
                    return n;
                  }
                });
              },
              selectSlice(e) {
                let t = e[this.reducerPath];
                return void 0 === t && this !== h && (t = this.getInitialState()), t;
              },
              get selectors() {
                return this.getSelectors(this.selectSlice);
              },
              injectInto(e, {
                reducerPath: t,
                ...n
              } = {}) {
                const r = t ?? this.reducerPath;
                return e.inject({
                  reducerPath: r,
                  reducer: this.reducer
                }, n), {
                  ...this,
                  reducerPath: r
                };
              }
            };
            return h;
          };
        }();
        function T() {}
        var {
            assign: O
          } = Object,
          I = "listenerMiddleware";
        y(`${I}/add`), y(`${I}/removeAll`), y(`${I}/remove`);
        Symbol.for("rtk-state-proxy-original");
        function F(e) {
          return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
        }
      },
      2053: function (e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
          return r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, r.apply(this, arguments);
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = n(97654),
          i = n(79103),
          a = n(59339),
          s = r(r({}, o.namedReferences), {
            all: o.namedReferences.html5
          });
        function l(e, t, n) {
          t.lastIndex = 0;
          var r,
            o = t.exec(e);
          if (o) {
            r = "";
            var i = 0;
            do {
              i !== o.index && (r += e.substring(i, o.index));
              var a = o[0];
              r += n(a), i = o.index + a.length;
            } while (o = t.exec(e));
            i !== e.length && (r += e.substring(i));
          } else r = e;
          return r;
        }
        var u = {
            specialChars: /[<>'"&]/g,
            nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
            nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
            nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
            extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g
          },
          c = {
            mode: "specialChars",
            level: "all",
            numeric: "decimal"
          };
        t.encode = function (e, t) {
          var n = void 0 === t ? c : t,
            r = n.mode,
            o = void 0 === r ? "specialChars" : r,
            i = n.numeric,
            d = void 0 === i ? "decimal" : i,
            p = n.level;
          if (!e) return "";
          var h = u[o],
            f = s[void 0 === p ? "all" : p].characters,
            m = "hexadecimal" === d;
          return l(e, h, function (e) {
            var t = f[e];
            if (!t) {
              var n = e.length > 1 ? a.getCodePoint(e, 0) : e.charCodeAt(0);
              t = (m ? "&#x" + n.toString(16) : "&#" + n) + ";";
            }
            return t;
          });
        };
        var d = {
            scope: "body",
            level: "all"
          },
          p = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g,
          h = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g,
          f = {
            xml: {
              strict: p,
              attribute: h,
              body: o.bodyRegExps.xml
            },
            html4: {
              strict: p,
              attribute: h,
              body: o.bodyRegExps.html4
            },
            html5: {
              strict: p,
              attribute: h,
              body: o.bodyRegExps.html5
            }
          },
          m = r(r({}, f), {
            all: f.html5
          }),
          g = String.fromCharCode,
          v = g(65533),
          y = {
            level: "all"
          };
        function b(e, t, n, r) {
          var o = e,
            s = e[e.length - 1];
          if (n && "=" === s) o = e;else if (r && ";" !== s) o = e;else {
            var l = t[e];
            if (l) o = l;else if ("&" === e[0] && "#" === e[1]) {
              var u = e[2],
                c = "x" == u || "X" == u ? parseInt(e.substr(3), 16) : parseInt(e.substr(2));
              o = c >= 1114111 ? v : c > 65535 ? a.fromCodePoint(c) : g(i.numericUnicodeMap[c] || c);
            }
          }
          return o;
        }
        t.decodeEntity = function (e, t) {
          var n = (void 0 === t ? y : t).level;
          return e ? b(e, s[void 0 === n ? "all" : n].entities, !1, !1) : "";
        }, t.decode = function (e, t) {
          var n = void 0 === t ? d : t,
            r = n.level,
            o = void 0 === r ? "all" : r,
            i = n.scope,
            a = void 0 === i ? "xml" === o ? "strict" : "body" : i;
          if (!e) return "";
          var u = m[o][a],
            c = s[o].entities,
            p = "attribute" === a,
            h = "strict" === a;
          return l(e, u, function (e) {
            return b(e, c, p, h);
          });
        };
      },
      97654: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.bodyRegExps = {
          xml: /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
          html4: /&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,
          html5: /&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g
        }, t.namedReferences = {
          xml: {
            entities: {
              "&lt;": "<",
              "&gt;": ">",
              "&quot;": '"',
              "&apos;": "'",
              "&amp;": "&"
            },
            characters: {
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&apos;",
              "&": "&amp;"
            }
          },
          html4: {
            entities: {
              "&apos;": "'",
              "&nbsp": " ",
              "&nbsp;": " ",
              "&iexcl": "¡",
              "&iexcl;": "¡",
              "&cent": "¢",
              "&cent;": "¢",
              "&pound": "£",
              "&pound;": "£",
              "&curren": "¤",
              "&curren;": "¤",
              "&yen": "¥",
              "&yen;": "¥",
              "&brvbar": "¦",
              "&brvbar;": "¦",
              "&sect": "§",
              "&sect;": "§",
              "&uml": "¨",
              "&uml;": "¨",
              "&copy": "©",
              "&copy;": "©",
              "&ordf": "ª",
              "&ordf;": "ª",
              "&laquo": "«",
              "&laquo;": "«",
              "&not": "¬",
              "&not;": "¬",
              "&shy": "­",
              "&shy;": "­",
              "&reg": "®",
              "&reg;": "®",
              "&macr": "¯",
              "&macr;": "¯",
              "&deg": "°",
              "&deg;": "°",
              "&plusmn": "±",
              "&plusmn;": "±",
              "&sup2": "²",
              "&sup2;": "²",
              "&sup3": "³",
              "&sup3;": "³",
              "&acute": "´",
              "&acute;": "´",
              "&micro": "µ",
              "&micro;": "µ",
              "&para": "¶",
              "&para;": "¶",
              "&middot": "·",
              "&middot;": "·",
              "&cedil": "¸",
              "&cedil;": "¸",
              "&sup1": "¹",
              "&sup1;": "¹",
              "&ordm": "º",
              "&ordm;": "º",
              "&raquo": "»",
              "&raquo;": "»",
              "&frac14": "¼",
              "&frac14;": "¼",
              "&frac12": "½",
              "&frac12;": "½",
              "&frac34": "¾",
              "&frac34;": "¾",
              "&iquest": "¿",
              "&iquest;": "¿",
              "&Agrave": "À",
              "&Agrave;": "À",
              "&Aacute": "Á",
              "&Aacute;": "Á",
              "&Acirc": "Â",
              "&Acirc;": "Â",
              "&Atilde": "Ã",
              "&Atilde;": "Ã",
              "&Auml": "Ä",
              "&Auml;": "Ä",
              "&Aring": "Å",
              "&Aring;": "Å",
              "&AElig": "Æ",
              "&AElig;": "Æ",
              "&Ccedil": "Ç",
              "&Ccedil;": "Ç",
              "&Egrave": "È",
              "&Egrave;": "È",
              "&Eacute": "É",
              "&Eacute;": "É",
              "&Ecirc": "Ê",
              "&Ecirc;": "Ê",
              "&Euml": "Ë",
              "&Euml;": "Ë",
              "&Igrave": "Ì",
              "&Igrave;": "Ì",
              "&Iacute": "Í",
              "&Iacute;": "Í",
              "&Icirc": "Î",
              "&Icirc;": "Î",
              "&Iuml": "Ï",
              "&Iuml;": "Ï",
              "&ETH": "Ð",
              "&ETH;": "Ð",
              "&Ntilde": "Ñ",
              "&Ntilde;": "Ñ",
              "&Ograve": "Ò",
              "&Ograve;": "Ò",
              "&Oacute": "Ó",
              "&Oacute;": "Ó",
              "&Ocirc": "Ô",
              "&Ocirc;": "Ô",
              "&Otilde": "Õ",
              "&Otilde;": "Õ",
              "&Ouml": "Ö",
              "&Ouml;": "Ö",
              "&times": "×",
              "&times;": "×",
              "&Oslash": "Ø",
              "&Oslash;": "Ø",
              "&Ugrave": "Ù",
              "&Ugrave;": "Ù",
              "&Uacute": "Ú",
              "&Uacute;": "Ú",
              "&Ucirc": "Û",
              "&Ucirc;": "Û",
              "&Uuml": "Ü",
              "&Uuml;": "Ü",
              "&Yacute": "Ý",
              "&Yacute;": "Ý",
              "&THORN": "Þ",
              "&THORN;": "Þ",
              "&szlig": "ß",
              "&szlig;": "ß",
              "&agrave": "à",
              "&agrave;": "à",
              "&aacute": "á",
              "&aacute;": "á",
              "&acirc": "â",
              "&acirc;": "â",
              "&atilde": "ã",
              "&atilde;": "ã",
              "&auml": "ä",
              "&auml;": "ä",
              "&aring": "å",
              "&aring;": "å",
              "&aelig": "æ",
              "&aelig;": "æ",
              "&ccedil": "ç",
              "&ccedil;": "ç",
              "&egrave": "è",
              "&egrave;": "è",
              "&eacute": "é",
              "&eacute;": "é",
              "&ecirc": "ê",
              "&ecirc;": "ê",
              "&euml": "ë",
              "&euml;": "ë",
              "&igrave": "ì",
              "&igrave;": "ì",
              "&iacute": "í",
              "&iacute;": "í",
              "&icirc": "î",
              "&icirc;": "î",
              "&iuml": "ï",
              "&iuml;": "ï",
              "&eth": "ð",
              "&eth;": "ð",
              "&ntilde": "ñ",
              "&ntilde;": "ñ",
              "&ograve": "ò",
              "&ograve;": "ò",
              "&oacute": "ó",
              "&oacute;": "ó",
              "&ocirc": "ô",
              "&ocirc;": "ô",
              "&otilde": "õ",
              "&otilde;": "õ",
              "&ouml": "ö",
              "&ouml;": "ö",
              "&divide": "÷",
              "&divide;": "÷",
              "&oslash": "ø",
              "&oslash;": "ø",
              "&ugrave": "ù",
              "&ugrave;": "ù",
              "&uacute": "ú",
              "&uacute;": "ú",
              "&ucirc": "û",
              "&ucirc;": "û",
              "&uuml": "ü",
              "&uuml;": "ü",
              "&yacute": "ý",
              "&yacute;": "ý",
              "&thorn": "þ",
              "&thorn;": "þ",
              "&yuml": "ÿ",
              "&yuml;": "ÿ",
              "&quot": '"',
              "&quot;": '"',
              "&amp": "&",
              "&amp;": "&",
              "&lt": "<",
              "&lt;": "<",
              "&gt": ">",
              "&gt;": ">",
              "&OElig;": "Œ",
              "&oelig;": "œ",
              "&Scaron;": "Š",
              "&scaron;": "š",
              "&Yuml;": "Ÿ",
              "&circ;": "ˆ",
              "&tilde;": "˜",
              "&ensp;": " ",
              "&emsp;": " ",
              "&thinsp;": " ",
              "&zwnj;": "‌",
              "&zwj;": "‍",
              "&lrm;": "‎",
              "&rlm;": "‏",
              "&ndash;": "–",
              "&mdash;": "—",
              "&lsquo;": "‘",
              "&rsquo;": "’",
              "&sbquo;": "‚",
              "&ldquo;": "“",
              "&rdquo;": "”",
              "&bdquo;": "„",
              "&dagger;": "†",
              "&Dagger;": "‡",
              "&permil;": "‰",
              "&lsaquo;": "‹",
              "&rsaquo;": "›",
              "&euro;": "€",
              "&fnof;": "ƒ",
              "&Alpha;": "Α",
              "&Beta;": "Β",
              "&Gamma;": "Γ",
              "&Delta;": "Δ",
              "&Epsilon;": "Ε",
              "&Zeta;": "Ζ",
              "&Eta;": "Η",
              "&Theta;": "Θ",
              "&Iota;": "Ι",
              "&Kappa;": "Κ",
              "&Lambda;": "Λ",
              "&Mu;": "Μ",
              "&Nu;": "Ν",
              "&Xi;": "Ξ",
              "&Omicron;": "Ο",
              "&Pi;": "Π",
              "&Rho;": "Ρ",
              "&Sigma;": "Σ",
              "&Tau;": "Τ",
              "&Upsilon;": "Υ",
              "&Phi;": "Φ",
              "&Chi;": "Χ",
              "&Psi;": "Ψ",
              "&Omega;": "Ω",
              "&alpha;": "α",
              "&beta;": "β",
              "&gamma;": "γ",
              "&delta;": "δ",
              "&epsilon;": "ε",
              "&zeta;": "ζ",
              "&eta;": "η",
              "&theta;": "θ",
              "&iota;": "ι",
              "&kappa;": "κ",
              "&lambda;": "λ",
              "&mu;": "μ",
              "&nu;": "ν",
              "&xi;": "ξ",
              "&omicron;": "ο",
              "&pi;": "π",
              "&rho;": "ρ",
              "&sigmaf;": "ς",
              "&sigma;": "σ",
              "&tau;": "τ",
              "&upsilon;": "υ",
              "&phi;": "φ",
              "&chi;": "χ",
              "&psi;": "ψ",
              "&omega;": "ω",
              "&thetasym;": "ϑ",
              "&upsih;": "ϒ",
              "&piv;": "ϖ",
              "&bull;": "•",
              "&hellip;": "…",
              "&prime;": "′",
              "&Prime;": "″",
              "&oline;": "‾",
              "&frasl;": "⁄",
              "&weierp;": "℘",
              "&image;": "ℑ",
              "&real;": "ℜ",
              "&trade;": "™",
              "&alefsym;": "ℵ",
              "&larr;": "←",
              "&uarr;": "↑",
              "&rarr;": "→",
              "&darr;": "↓",
              "&harr;": "↔",
              "&crarr;": "↵",
              "&lArr;": "⇐",
              "&uArr;": "⇑",
              "&rArr;": "⇒",
              "&dArr;": "⇓",
              "&hArr;": "⇔",
              "&forall;": "∀",
              "&part;": "∂",
              "&exist;": "∃",
              "&empty;": "∅",
              "&nabla;": "∇",
              "&isin;": "∈",
              "&notin;": "∉",
              "&ni;": "∋",
              "&prod;": "∏",
              "&sum;": "∑",
              "&minus;": "−",
              "&lowast;": "∗",
              "&radic;": "√",
              "&prop;": "∝",
              "&infin;": "∞",
              "&ang;": "∠",
              "&and;": "∧",
              "&or;": "∨",
              "&cap;": "∩",
              "&cup;": "∪",
              "&int;": "∫",
              "&there4;": "∴",
              "&sim;": "∼",
              "&cong;": "≅",
              "&asymp;": "≈",
              "&ne;": "≠",
              "&equiv;": "≡",
              "&le;": "≤",
              "&ge;": "≥",
              "&sub;": "⊂",
              "&sup;": "⊃",
              "&nsub;": "⊄",
              "&sube;": "⊆",
              "&supe;": "⊇",
              "&oplus;": "⊕",
              "&otimes;": "⊗",
              "&perp;": "⊥",
              "&sdot;": "⋅",
              "&lceil;": "⌈",
              "&rceil;": "⌉",
              "&lfloor;": "⌊",
              "&rfloor;": "⌋",
              "&lang;": "〈",
              "&rang;": "〉",
              "&loz;": "◊",
              "&spades;": "♠",
              "&clubs;": "♣",
              "&hearts;": "♥",
              "&diams;": "♦"
            },
            characters: {
              "'": "&apos;",
              " ": "&nbsp;",
              "¡": "&iexcl;",
              "¢": "&cent;",
              "£": "&pound;",
              "¤": "&curren;",
              "¥": "&yen;",
              "¦": "&brvbar;",
              "§": "&sect;",
              "¨": "&uml;",
              "©": "&copy;",
              ª: "&ordf;",
              "«": "&laquo;",
              "¬": "&not;",
              "­": "&shy;",
              "®": "&reg;",
              "¯": "&macr;",
              "°": "&deg;",
              "±": "&plusmn;",
              "²": "&sup2;",
              "³": "&sup3;",
              "´": "&acute;",
              µ: "&micro;",
              "¶": "&para;",
              "·": "&middot;",
              "¸": "&cedil;",
              "¹": "&sup1;",
              º: "&ordm;",
              "»": "&raquo;",
              "¼": "&frac14;",
              "½": "&frac12;",
              "¾": "&frac34;",
              "¿": "&iquest;",
              À: "&Agrave;",
              Á: "&Aacute;",
              Â: "&Acirc;",
              Ã: "&Atilde;",
              Ä: "&Auml;",
              Å: "&Aring;",
              Æ: "&AElig;",
              Ç: "&Ccedil;",
              È: "&Egrave;",
              É: "&Eacute;",
              Ê: "&Ecirc;",
              Ë: "&Euml;",
              Ì: "&Igrave;",
              Í: "&Iacute;",
              Î: "&Icirc;",
              Ï: "&Iuml;",
              Ð: "&ETH;",
              Ñ: "&Ntilde;",
              Ò: "&Ograve;",
              Ó: "&Oacute;",
              Ô: "&Ocirc;",
              Õ: "&Otilde;",
              Ö: "&Ouml;",
              "×": "&times;",
              Ø: "&Oslash;",
              Ù: "&Ugrave;",
              Ú: "&Uacute;",
              Û: "&Ucirc;",
              Ü: "&Uuml;",
              Ý: "&Yacute;",
              Þ: "&THORN;",
              ß: "&szlig;",
              à: "&agrave;",
              á: "&aacute;",
              â: "&acirc;",
              ã: "&atilde;",
              ä: "&auml;",
              å: "&aring;",
              æ: "&aelig;",
              ç: "&ccedil;",
              è: "&egrave;",
              é: "&eacute;",
              ê: "&ecirc;",
              ë: "&euml;",
              ì: "&igrave;",
              í: "&iacute;",
              î: "&icirc;",
              ï: "&iuml;",
              ð: "&eth;",
              ñ: "&ntilde;",
              ò: "&ograve;",
              ó: "&oacute;",
              ô: "&ocirc;",
              õ: "&otilde;",
              ö: "&ouml;",
              "÷": "&divide;",
              ø: "&oslash;",
              ù: "&ugrave;",
              ú: "&uacute;",
              û: "&ucirc;",
              ü: "&uuml;",
              ý: "&yacute;",
              þ: "&thorn;",
              ÿ: "&yuml;",
              '"': "&quot;",
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              Œ: "&OElig;",
              œ: "&oelig;",
              Š: "&Scaron;",
              š: "&scaron;",
              Ÿ: "&Yuml;",
              ˆ: "&circ;",
              "˜": "&tilde;",
              " ": "&ensp;",
              " ": "&emsp;",
              " ": "&thinsp;",
              "‌": "&zwnj;",
              "‍": "&zwj;",
              "‎": "&lrm;",
              "‏": "&rlm;",
              "–": "&ndash;",
              "—": "&mdash;",
              "‘": "&lsquo;",
              "’": "&rsquo;",
              "‚": "&sbquo;",
              "“": "&ldquo;",
              "”": "&rdquo;",
              "„": "&bdquo;",
              "†": "&dagger;",
              "‡": "&Dagger;",
              "‰": "&permil;",
              "‹": "&lsaquo;",
              "›": "&rsaquo;",
              "€": "&euro;",
              ƒ: "&fnof;",
              Α: "&Alpha;",
              Β: "&Beta;",
              Γ: "&Gamma;",
              Δ: "&Delta;",
              Ε: "&Epsilon;",
              Ζ: "&Zeta;",
              Η: "&Eta;",
              Θ: "&Theta;",
              Ι: "&Iota;",
              Κ: "&Kappa;",
              Λ: "&Lambda;",
              Μ: "&Mu;",
              Ν: "&Nu;",
              Ξ: "&Xi;",
              Ο: "&Omicron;",
              Π: "&Pi;",
              Ρ: "&Rho;",
              Σ: "&Sigma;",
              Τ: "&Tau;",
              Υ: "&Upsilon;",
              Φ: "&Phi;",
              Χ: "&Chi;",
              Ψ: "&Psi;",
              Ω: "&Omega;",
              α: "&alpha;",
              β: "&beta;",
              γ: "&gamma;",
              δ: "&delta;",
              ε: "&epsilon;",
              ζ: "&zeta;",
              η: "&eta;",
              θ: "&theta;",
              ι: "&iota;",
              κ: "&kappa;",
              λ: "&lambda;",
              μ: "&mu;",
              ν: "&nu;",
              ξ: "&xi;",
              ο: "&omicron;",
              π: "&pi;",
              ρ: "&rho;",
              ς: "&sigmaf;",
              σ: "&sigma;",
              τ: "&tau;",
              υ: "&upsilon;",
              φ: "&phi;",
              χ: "&chi;",
              ψ: "&psi;",
              ω: "&omega;",
              ϑ: "&thetasym;",
              ϒ: "&upsih;",
              ϖ: "&piv;",
              "•": "&bull;",
              "…": "&hellip;",
              "′": "&prime;",
              "″": "&Prime;",
              "‾": "&oline;",
              "⁄": "&frasl;",
              ℘: "&weierp;",
              ℑ: "&image;",
              ℜ: "&real;",
              "™": "&trade;",
              ℵ: "&alefsym;",
              "←": "&larr;",
              "↑": "&uarr;",
              "→": "&rarr;",
              "↓": "&darr;",
              "↔": "&harr;",
              "↵": "&crarr;",
              "⇐": "&lArr;",
              "⇑": "&uArr;",
              "⇒": "&rArr;",
              "⇓": "&dArr;",
              "⇔": "&hArr;",
              "∀": "&forall;",
              "∂": "&part;",
              "∃": "&exist;",
              "∅": "&empty;",
              "∇": "&nabla;",
              "∈": "&isin;",
              "∉": "&notin;",
              "∋": "&ni;",
              "∏": "&prod;",
              "∑": "&sum;",
              "−": "&minus;",
              "∗": "&lowast;",
              "√": "&radic;",
              "∝": "&prop;",
              "∞": "&infin;",
              "∠": "&ang;",
              "∧": "&and;",
              "∨": "&or;",
              "∩": "&cap;",
              "∪": "&cup;",
              "∫": "&int;",
              "∴": "&there4;",
              "∼": "&sim;",
              "≅": "&cong;",
              "≈": "&asymp;",
              "≠": "&ne;",
              "≡": "&equiv;",
              "≤": "&le;",
              "≥": "&ge;",
              "⊂": "&sub;",
              "⊃": "&sup;",
              "⊄": "&nsub;",
              "⊆": "&sube;",
              "⊇": "&supe;",
              "⊕": "&oplus;",
              "⊗": "&otimes;",
              "⊥": "&perp;",
              "⋅": "&sdot;",
              "⌈": "&lceil;",
              "⌉": "&rceil;",
              "⌊": "&lfloor;",
              "⌋": "&rfloor;",
              "〈": "&lang;",
              "〉": "&rang;",
              "◊": "&loz;",
              "♠": "&spades;",
              "♣": "&clubs;",
              "♥": "&hearts;",
              "♦": "&diams;"
            }
          },
          html5: {
            entities: {
              "&AElig": "Æ",
              "&AElig;": "Æ",
              "&AMP": "&",
              "&AMP;": "&",
              "&Aacute": "Á",
              "&Aacute;": "Á",
              "&Abreve;": "Ă",
              "&Acirc": "Â",
              "&Acirc;": "Â",
              "&Acy;": "А",
              "&Afr;": "𝔄",
              "&Agrave": "À",
              "&Agrave;": "À",
              "&Alpha;": "Α",
              "&Amacr;": "Ā",
              "&And;": "⩓",
              "&Aogon;": "Ą",
              "&Aopf;": "𝔸",
              "&ApplyFunction;": "⁡",
              "&Aring": "Å",
              "&Aring;": "Å",
              "&Ascr;": "𝒜",
              "&Assign;": "≔",
              "&Atilde": "Ã",
              "&Atilde;": "Ã",
              "&Auml": "Ä",
              "&Auml;": "Ä",
              "&Backslash;": "∖",
              "&Barv;": "⫧",
              "&Barwed;": "⌆",
              "&Bcy;": "Б",
              "&Because;": "∵",
              "&Bernoullis;": "ℬ",
              "&Beta;": "Β",
              "&Bfr;": "𝔅",
              "&Bopf;": "𝔹",
              "&Breve;": "˘",
              "&Bscr;": "ℬ",
              "&Bumpeq;": "≎",
              "&CHcy;": "Ч",
              "&COPY": "©",
              "&COPY;": "©",
              "&Cacute;": "Ć",
              "&Cap;": "⋒",
              "&CapitalDifferentialD;": "ⅅ",
              "&Cayleys;": "ℭ",
              "&Ccaron;": "Č",
              "&Ccedil": "Ç",
              "&Ccedil;": "Ç",
              "&Ccirc;": "Ĉ",
              "&Cconint;": "∰",
              "&Cdot;": "Ċ",
              "&Cedilla;": "¸",
              "&CenterDot;": "·",
              "&Cfr;": "ℭ",
              "&Chi;": "Χ",
              "&CircleDot;": "⊙",
              "&CircleMinus;": "⊖",
              "&CirclePlus;": "⊕",
              "&CircleTimes;": "⊗",
              "&ClockwiseContourIntegral;": "∲",
              "&CloseCurlyDoubleQuote;": "”",
              "&CloseCurlyQuote;": "’",
              "&Colon;": "∷",
              "&Colone;": "⩴",
              "&Congruent;": "≡",
              "&Conint;": "∯",
              "&ContourIntegral;": "∮",
              "&Copf;": "ℂ",
              "&Coproduct;": "∐",
              "&CounterClockwiseContourIntegral;": "∳",
              "&Cross;": "⨯",
              "&Cscr;": "𝒞",
              "&Cup;": "⋓",
              "&CupCap;": "≍",
              "&DD;": "ⅅ",
              "&DDotrahd;": "⤑",
              "&DJcy;": "Ђ",
              "&DScy;": "Ѕ",
              "&DZcy;": "Џ",
              "&Dagger;": "‡",
              "&Darr;": "↡",
              "&Dashv;": "⫤",
              "&Dcaron;": "Ď",
              "&Dcy;": "Д",
              "&Del;": "∇",
              "&Delta;": "Δ",
              "&Dfr;": "𝔇",
              "&DiacriticalAcute;": "´",
              "&DiacriticalDot;": "˙",
              "&DiacriticalDoubleAcute;": "˝",
              "&DiacriticalGrave;": "`",
              "&DiacriticalTilde;": "˜",
              "&Diamond;": "⋄",
              "&DifferentialD;": "ⅆ",
              "&Dopf;": "𝔻",
              "&Dot;": "¨",
              "&DotDot;": "⃜",
              "&DotEqual;": "≐",
              "&DoubleContourIntegral;": "∯",
              "&DoubleDot;": "¨",
              "&DoubleDownArrow;": "⇓",
              "&DoubleLeftArrow;": "⇐",
              "&DoubleLeftRightArrow;": "⇔",
              "&DoubleLeftTee;": "⫤",
              "&DoubleLongLeftArrow;": "⟸",
              "&DoubleLongLeftRightArrow;": "⟺",
              "&DoubleLongRightArrow;": "⟹",
              "&DoubleRightArrow;": "⇒",
              "&DoubleRightTee;": "⊨",
              "&DoubleUpArrow;": "⇑",
              "&DoubleUpDownArrow;": "⇕",
              "&DoubleVerticalBar;": "∥",
              "&DownArrow;": "↓",
              "&DownArrowBar;": "⤓",
              "&DownArrowUpArrow;": "⇵",
              "&DownBreve;": "̑",
              "&DownLeftRightVector;": "⥐",
              "&DownLeftTeeVector;": "⥞",
              "&DownLeftVector;": "↽",
              "&DownLeftVectorBar;": "⥖",
              "&DownRightTeeVector;": "⥟",
              "&DownRightVector;": "⇁",
              "&DownRightVectorBar;": "⥗",
              "&DownTee;": "⊤",
              "&DownTeeArrow;": "↧",
              "&Downarrow;": "⇓",
              "&Dscr;": "𝒟",
              "&Dstrok;": "Đ",
              "&ENG;": "Ŋ",
              "&ETH": "Ð",
              "&ETH;": "Ð",
              "&Eacute": "É",
              "&Eacute;": "É",
              "&Ecaron;": "Ě",
              "&Ecirc": "Ê",
              "&Ecirc;": "Ê",
              "&Ecy;": "Э",
              "&Edot;": "Ė",
              "&Efr;": "𝔈",
              "&Egrave": "È",
              "&Egrave;": "È",
              "&Element;": "∈",
              "&Emacr;": "Ē",
              "&EmptySmallSquare;": "◻",
              "&EmptyVerySmallSquare;": "▫",
              "&Eogon;": "Ę",
              "&Eopf;": "𝔼",
              "&Epsilon;": "Ε",
              "&Equal;": "⩵",
              "&EqualTilde;": "≂",
              "&Equilibrium;": "⇌",
              "&Escr;": "ℰ",
              "&Esim;": "⩳",
              "&Eta;": "Η",
              "&Euml": "Ë",
              "&Euml;": "Ë",
              "&Exists;": "∃",
              "&ExponentialE;": "ⅇ",
              "&Fcy;": "Ф",
              "&Ffr;": "𝔉",
              "&FilledSmallSquare;": "◼",
              "&FilledVerySmallSquare;": "▪",
              "&Fopf;": "𝔽",
              "&ForAll;": "∀",
              "&Fouriertrf;": "ℱ",
              "&Fscr;": "ℱ",
              "&GJcy;": "Ѓ",
              "&GT": ">",
              "&GT;": ">",
              "&Gamma;": "Γ",
              "&Gammad;": "Ϝ",
              "&Gbreve;": "Ğ",
              "&Gcedil;": "Ģ",
              "&Gcirc;": "Ĝ",
              "&Gcy;": "Г",
              "&Gdot;": "Ġ",
              "&Gfr;": "𝔊",
              "&Gg;": "⋙",
              "&Gopf;": "𝔾",
              "&GreaterEqual;": "≥",
              "&GreaterEqualLess;": "⋛",
              "&GreaterFullEqual;": "≧",
              "&GreaterGreater;": "⪢",
              "&GreaterLess;": "≷",
              "&GreaterSlantEqual;": "⩾",
              "&GreaterTilde;": "≳",
              "&Gscr;": "𝒢",
              "&Gt;": "≫",
              "&HARDcy;": "Ъ",
              "&Hacek;": "ˇ",
              "&Hat;": "^",
              "&Hcirc;": "Ĥ",
              "&Hfr;": "ℌ",
              "&HilbertSpace;": "ℋ",
              "&Hopf;": "ℍ",
              "&HorizontalLine;": "─",
              "&Hscr;": "ℋ",
              "&Hstrok;": "Ħ",
              "&HumpDownHump;": "≎",
              "&HumpEqual;": "≏",
              "&IEcy;": "Е",
              "&IJlig;": "Ĳ",
              "&IOcy;": "Ё",
              "&Iacute": "Í",
              "&Iacute;": "Í",
              "&Icirc": "Î",
              "&Icirc;": "Î",
              "&Icy;": "И",
              "&Idot;": "İ",
              "&Ifr;": "ℑ",
              "&Igrave": "Ì",
              "&Igrave;": "Ì",
              "&Im;": "ℑ",
              "&Imacr;": "Ī",
              "&ImaginaryI;": "ⅈ",
              "&Implies;": "⇒",
              "&Int;": "∬",
              "&Integral;": "∫",
              "&Intersection;": "⋂",
              "&InvisibleComma;": "⁣",
              "&InvisibleTimes;": "⁢",
              "&Iogon;": "Į",
              "&Iopf;": "𝕀",
              "&Iota;": "Ι",
              "&Iscr;": "ℐ",
              "&Itilde;": "Ĩ",
              "&Iukcy;": "І",
              "&Iuml": "Ï",
              "&Iuml;": "Ï",
              "&Jcirc;": "Ĵ",
              "&Jcy;": "Й",
              "&Jfr;": "𝔍",
              "&Jopf;": "𝕁",
              "&Jscr;": "𝒥",
              "&Jsercy;": "Ј",
              "&Jukcy;": "Є",
              "&KHcy;": "Х",
              "&KJcy;": "Ќ",
              "&Kappa;": "Κ",
              "&Kcedil;": "Ķ",
              "&Kcy;": "К",
              "&Kfr;": "𝔎",
              "&Kopf;": "𝕂",
              "&Kscr;": "𝒦",
              "&LJcy;": "Љ",
              "&LT": "<",
              "&LT;": "<",
              "&Lacute;": "Ĺ",
              "&Lambda;": "Λ",
              "&Lang;": "⟪",
              "&Laplacetrf;": "ℒ",
              "&Larr;": "↞",
              "&Lcaron;": "Ľ",
              "&Lcedil;": "Ļ",
              "&Lcy;": "Л",
              "&LeftAngleBracket;": "⟨",
              "&LeftArrow;": "←",
              "&LeftArrowBar;": "⇤",
              "&LeftArrowRightArrow;": "⇆",
              "&LeftCeiling;": "⌈",
              "&LeftDoubleBracket;": "⟦",
              "&LeftDownTeeVector;": "⥡",
              "&LeftDownVector;": "⇃",
              "&LeftDownVectorBar;": "⥙",
              "&LeftFloor;": "⌊",
              "&LeftRightArrow;": "↔",
              "&LeftRightVector;": "⥎",
              "&LeftTee;": "⊣",
              "&LeftTeeArrow;": "↤",
              "&LeftTeeVector;": "⥚",
              "&LeftTriangle;": "⊲",
              "&LeftTriangleBar;": "⧏",
              "&LeftTriangleEqual;": "⊴",
              "&LeftUpDownVector;": "⥑",
              "&LeftUpTeeVector;": "⥠",
              "&LeftUpVector;": "↿",
              "&LeftUpVectorBar;": "⥘",
              "&LeftVector;": "↼",
              "&LeftVectorBar;": "⥒",
              "&Leftarrow;": "⇐",
              "&Leftrightarrow;": "⇔",
              "&LessEqualGreater;": "⋚",
              "&LessFullEqual;": "≦",
              "&LessGreater;": "≶",
              "&LessLess;": "⪡",
              "&LessSlantEqual;": "⩽",
              "&LessTilde;": "≲",
              "&Lfr;": "𝔏",
              "&Ll;": "⋘",
              "&Lleftarrow;": "⇚",
              "&Lmidot;": "Ŀ",
              "&LongLeftArrow;": "⟵",
              "&LongLeftRightArrow;": "⟷",
              "&LongRightArrow;": "⟶",
              "&Longleftarrow;": "⟸",
              "&Longleftrightarrow;": "⟺",
              "&Longrightarrow;": "⟹",
              "&Lopf;": "𝕃",
              "&LowerLeftArrow;": "↙",
              "&LowerRightArrow;": "↘",
              "&Lscr;": "ℒ",
              "&Lsh;": "↰",
              "&Lstrok;": "Ł",
              "&Lt;": "≪",
              "&Map;": "⤅",
              "&Mcy;": "М",
              "&MediumSpace;": " ",
              "&Mellintrf;": "ℳ",
              "&Mfr;": "𝔐",
              "&MinusPlus;": "∓",
              "&Mopf;": "𝕄",
              "&Mscr;": "ℳ",
              "&Mu;": "Μ",
              "&NJcy;": "Њ",
              "&Nacute;": "Ń",
              "&Ncaron;": "Ň",
              "&Ncedil;": "Ņ",
              "&Ncy;": "Н",
              "&NegativeMediumSpace;": "​",
              "&NegativeThickSpace;": "​",
              "&NegativeThinSpace;": "​",
              "&NegativeVeryThinSpace;": "​",
              "&NestedGreaterGreater;": "≫",
              "&NestedLessLess;": "≪",
              "&NewLine;": "\n",
              "&Nfr;": "𝔑",
              "&NoBreak;": "⁠",
              "&NonBreakingSpace;": " ",
              "&Nopf;": "ℕ",
              "&Not;": "⫬",
              "&NotCongruent;": "≢",
              "&NotCupCap;": "≭",
              "&NotDoubleVerticalBar;": "∦",
              "&NotElement;": "∉",
              "&NotEqual;": "≠",
              "&NotEqualTilde;": "≂̸",
              "&NotExists;": "∄",
              "&NotGreater;": "≯",
              "&NotGreaterEqual;": "≱",
              "&NotGreaterFullEqual;": "≧̸",
              "&NotGreaterGreater;": "≫̸",
              "&NotGreaterLess;": "≹",
              "&NotGreaterSlantEqual;": "⩾̸",
              "&NotGreaterTilde;": "≵",
              "&NotHumpDownHump;": "≎̸",
              "&NotHumpEqual;": "≏̸",
              "&NotLeftTriangle;": "⋪",
              "&NotLeftTriangleBar;": "⧏̸",
              "&NotLeftTriangleEqual;": "⋬",
              "&NotLess;": "≮",
              "&NotLessEqual;": "≰",
              "&NotLessGreater;": "≸",
              "&NotLessLess;": "≪̸",
              "&NotLessSlantEqual;": "⩽̸",
              "&NotLessTilde;": "≴",
              "&NotNestedGreaterGreater;": "⪢̸",
              "&NotNestedLessLess;": "⪡̸",
              "&NotPrecedes;": "⊀",
              "&NotPrecedesEqual;": "⪯̸",
              "&NotPrecedesSlantEqual;": "⋠",
              "&NotReverseElement;": "∌",
              "&NotRightTriangle;": "⋫",
              "&NotRightTriangleBar;": "⧐̸",
              "&NotRightTriangleEqual;": "⋭",
              "&NotSquareSubset;": "⊏̸",
              "&NotSquareSubsetEqual;": "⋢",
              "&NotSquareSuperset;": "⊐̸",
              "&NotSquareSupersetEqual;": "⋣",
              "&NotSubset;": "⊂⃒",
              "&NotSubsetEqual;": "⊈",
              "&NotSucceeds;": "⊁",
              "&NotSucceedsEqual;": "⪰̸",
              "&NotSucceedsSlantEqual;": "⋡",
              "&NotSucceedsTilde;": "≿̸",
              "&NotSuperset;": "⊃⃒",
              "&NotSupersetEqual;": "⊉",
              "&NotTilde;": "≁",
              "&NotTildeEqual;": "≄",
              "&NotTildeFullEqual;": "≇",
              "&NotTildeTilde;": "≉",
              "&NotVerticalBar;": "∤",
              "&Nscr;": "𝒩",
              "&Ntilde": "Ñ",
              "&Ntilde;": "Ñ",
              "&Nu;": "Ν",
              "&OElig;": "Œ",
              "&Oacute": "Ó",
              "&Oacute;": "Ó",
              "&Ocirc": "Ô",
              "&Ocirc;": "Ô",
              "&Ocy;": "О",
              "&Odblac;": "Ő",
              "&Ofr;": "𝔒",
              "&Ograve": "Ò",
              "&Ograve;": "Ò",
              "&Omacr;": "Ō",
              "&Omega;": "Ω",
              "&Omicron;": "Ο",
              "&Oopf;": "𝕆",
              "&OpenCurlyDoubleQuote;": "“",
              "&OpenCurlyQuote;": "‘",
              "&Or;": "⩔",
              "&Oscr;": "𝒪",
              "&Oslash": "Ø",
              "&Oslash;": "Ø",
              "&Otilde": "Õ",
              "&Otilde;": "Õ",
              "&Otimes;": "⨷",
              "&Ouml": "Ö",
              "&Ouml;": "Ö",
              "&OverBar;": "‾",
              "&OverBrace;": "⏞",
              "&OverBracket;": "⎴",
              "&OverParenthesis;": "⏜",
              "&PartialD;": "∂",
              "&Pcy;": "П",
              "&Pfr;": "𝔓",
              "&Phi;": "Φ",
              "&Pi;": "Π",
              "&PlusMinus;": "±",
              "&Poincareplane;": "ℌ",
              "&Popf;": "ℙ",
              "&Pr;": "⪻",
              "&Precedes;": "≺",
              "&PrecedesEqual;": "⪯",
              "&PrecedesSlantEqual;": "≼",
              "&PrecedesTilde;": "≾",
              "&Prime;": "″",
              "&Product;": "∏",
              "&Proportion;": "∷",
              "&Proportional;": "∝",
              "&Pscr;": "𝒫",
              "&Psi;": "Ψ",
              "&QUOT": '"',
              "&QUOT;": '"',
              "&Qfr;": "𝔔",
              "&Qopf;": "ℚ",
              "&Qscr;": "𝒬",
              "&RBarr;": "⤐",
              "&REG": "®",
              "&REG;": "®",
              "&Racute;": "Ŕ",
              "&Rang;": "⟫",
              "&Rarr;": "↠",
              "&Rarrtl;": "⤖",
              "&Rcaron;": "Ř",
              "&Rcedil;": "Ŗ",
              "&Rcy;": "Р",
              "&Re;": "ℜ",
              "&ReverseElement;": "∋",
              "&ReverseEquilibrium;": "⇋",
              "&ReverseUpEquilibrium;": "⥯",
              "&Rfr;": "ℜ",
              "&Rho;": "Ρ",
              "&RightAngleBracket;": "⟩",
              "&RightArrow;": "→",
              "&RightArrowBar;": "⇥",
              "&RightArrowLeftArrow;": "⇄",
              "&RightCeiling;": "⌉",
              "&RightDoubleBracket;": "⟧",
              "&RightDownTeeVector;": "⥝",
              "&RightDownVector;": "⇂",
              "&RightDownVectorBar;": "⥕",
              "&RightFloor;": "⌋",
              "&RightTee;": "⊢",
              "&RightTeeArrow;": "↦",
              "&RightTeeVector;": "⥛",
              "&RightTriangle;": "⊳",
              "&RightTriangleBar;": "⧐",
              "&RightTriangleEqual;": "⊵",
              "&RightUpDownVector;": "⥏",
              "&RightUpTeeVector;": "⥜",
              "&RightUpVector;": "↾",
              "&RightUpVectorBar;": "⥔",
              "&RightVector;": "⇀",
              "&RightVectorBar;": "⥓",
              "&Rightarrow;": "⇒",
              "&Ropf;": "ℝ",
              "&RoundImplies;": "⥰",
              "&Rrightarrow;": "⇛",
              "&Rscr;": "ℛ",
              "&Rsh;": "↱",
              "&RuleDelayed;": "⧴",
              "&SHCHcy;": "Щ",
              "&SHcy;": "Ш",
              "&SOFTcy;": "Ь",
              "&Sacute;": "Ś",
              "&Sc;": "⪼",
              "&Scaron;": "Š",
              "&Scedil;": "Ş",
              "&Scirc;": "Ŝ",
              "&Scy;": "С",
              "&Sfr;": "𝔖",
              "&ShortDownArrow;": "↓",
              "&ShortLeftArrow;": "←",
              "&ShortRightArrow;": "→",
              "&ShortUpArrow;": "↑",
              "&Sigma;": "Σ",
              "&SmallCircle;": "∘",
              "&Sopf;": "𝕊",
              "&Sqrt;": "√",
              "&Square;": "□",
              "&SquareIntersection;": "⊓",
              "&SquareSubset;": "⊏",
              "&SquareSubsetEqual;": "⊑",
              "&SquareSuperset;": "⊐",
              "&SquareSupersetEqual;": "⊒",
              "&SquareUnion;": "⊔",
              "&Sscr;": "𝒮",
              "&Star;": "⋆",
              "&Sub;": "⋐",
              "&Subset;": "⋐",
              "&SubsetEqual;": "⊆",
              "&Succeeds;": "≻",
              "&SucceedsEqual;": "⪰",
              "&SucceedsSlantEqual;": "≽",
              "&SucceedsTilde;": "≿",
              "&SuchThat;": "∋",
              "&Sum;": "∑",
              "&Sup;": "⋑",
              "&Superset;": "⊃",
              "&SupersetEqual;": "⊇",
              "&Supset;": "⋑",
              "&THORN": "Þ",
              "&THORN;": "Þ",
              "&TRADE;": "™",
              "&TSHcy;": "Ћ",
              "&TScy;": "Ц",
              "&Tab;": "\t",
              "&Tau;": "Τ",
              "&Tcaron;": "Ť",
              "&Tcedil;": "Ţ",
              "&Tcy;": "Т",
              "&Tfr;": "𝔗",
              "&Therefore;": "∴",
              "&Theta;": "Θ",
              "&ThickSpace;": "  ",
              "&ThinSpace;": " ",
              "&Tilde;": "∼",
              "&TildeEqual;": "≃",
              "&TildeFullEqual;": "≅",
              "&TildeTilde;": "≈",
              "&Topf;": "𝕋",
              "&TripleDot;": "⃛",
              "&Tscr;": "𝒯",
              "&Tstrok;": "Ŧ",
              "&Uacute": "Ú",
              "&Uacute;": "Ú",
              "&Uarr;": "↟",
              "&Uarrocir;": "⥉",
              "&Ubrcy;": "Ў",
              "&Ubreve;": "Ŭ",
              "&Ucirc": "Û",
              "&Ucirc;": "Û",
              "&Ucy;": "У",
              "&Udblac;": "Ű",
              "&Ufr;": "𝔘",
              "&Ugrave": "Ù",
              "&Ugrave;": "Ù",
              "&Umacr;": "Ū",
              "&UnderBar;": "_",
              "&UnderBrace;": "⏟",
              "&UnderBracket;": "⎵",
              "&UnderParenthesis;": "⏝",
              "&Union;": "⋃",
              "&UnionPlus;": "⊎",
              "&Uogon;": "Ų",
              "&Uopf;": "𝕌",
              "&UpArrow;": "↑",
              "&UpArrowBar;": "⤒",
              "&UpArrowDownArrow;": "⇅",
              "&UpDownArrow;": "↕",
              "&UpEquilibrium;": "⥮",
              "&UpTee;": "⊥",
              "&UpTeeArrow;": "↥",
              "&Uparrow;": "⇑",
              "&Updownarrow;": "⇕",
              "&UpperLeftArrow;": "↖",
              "&UpperRightArrow;": "↗",
              "&Upsi;": "ϒ",
              "&Upsilon;": "Υ",
              "&Uring;": "Ů",
              "&Uscr;": "𝒰",
              "&Utilde;": "Ũ",
              "&Uuml": "Ü",
              "&Uuml;": "Ü",
              "&VDash;": "⊫",
              "&Vbar;": "⫫",
              "&Vcy;": "В",
              "&Vdash;": "⊩",
              "&Vdashl;": "⫦",
              "&Vee;": "⋁",
              "&Verbar;": "‖",
              "&Vert;": "‖",
              "&VerticalBar;": "∣",
              "&VerticalLine;": "|",
              "&VerticalSeparator;": "❘",
              "&VerticalTilde;": "≀",
              "&VeryThinSpace;": " ",
              "&Vfr;": "𝔙",
              "&Vopf;": "𝕍",
              "&Vscr;": "𝒱",
              "&Vvdash;": "⊪",
              "&Wcirc;": "Ŵ",
              "&Wedge;": "⋀",
              "&Wfr;": "𝔚",
              "&Wopf;": "𝕎",
              "&Wscr;": "𝒲",
              "&Xfr;": "𝔛",
              "&Xi;": "Ξ",
              "&Xopf;": "𝕏",
              "&Xscr;": "𝒳",
              "&YAcy;": "Я",
              "&YIcy;": "Ї",
              "&YUcy;": "Ю",
              "&Yacute": "Ý",
              "&Yacute;": "Ý",
              "&Ycirc;": "Ŷ",
              "&Ycy;": "Ы",
              "&Yfr;": "𝔜",
              "&Yopf;": "𝕐",
              "&Yscr;": "𝒴",
              "&Yuml;": "Ÿ",
              "&ZHcy;": "Ж",
              "&Zacute;": "Ź",
              "&Zcaron;": "Ž",
              "&Zcy;": "З",
              "&Zdot;": "Ż",
              "&ZeroWidthSpace;": "​",
              "&Zeta;": "Ζ",
              "&Zfr;": "ℨ",
              "&Zopf;": "ℤ",
              "&Zscr;": "𝒵",
              "&aacute": "á",
              "&aacute;": "á",
              "&abreve;": "ă",
              "&ac;": "∾",
              "&acE;": "∾̳",
              "&acd;": "∿",
              "&acirc": "â",
              "&acirc;": "â",
              "&acute": "´",
              "&acute;": "´",
              "&acy;": "а",
              "&aelig": "æ",
              "&aelig;": "æ",
              "&af;": "⁡",
              "&afr;": "𝔞",
              "&agrave": "à",
              "&agrave;": "à",
              "&alefsym;": "ℵ",
              "&aleph;": "ℵ",
              "&alpha;": "α",
              "&amacr;": "ā",
              "&amalg;": "⨿",
              "&amp": "&",
              "&amp;": "&",
              "&and;": "∧",
              "&andand;": "⩕",
              "&andd;": "⩜",
              "&andslope;": "⩘",
              "&andv;": "⩚",
              "&ang;": "∠",
              "&ange;": "⦤",
              "&angle;": "∠",
              "&angmsd;": "∡",
              "&angmsdaa;": "⦨",
              "&angmsdab;": "⦩",
              "&angmsdac;": "⦪",
              "&angmsdad;": "⦫",
              "&angmsdae;": "⦬",
              "&angmsdaf;": "⦭",
              "&angmsdag;": "⦮",
              "&angmsdah;": "⦯",
              "&angrt;": "∟",
              "&angrtvb;": "⊾",
              "&angrtvbd;": "⦝",
              "&angsph;": "∢",
              "&angst;": "Å",
              "&angzarr;": "⍼",
              "&aogon;": "ą",
              "&aopf;": "𝕒",
              "&ap;": "≈",
              "&apE;": "⩰",
              "&apacir;": "⩯",
              "&ape;": "≊",
              "&apid;": "≋",
              "&apos;": "'",
              "&approx;": "≈",
              "&approxeq;": "≊",
              "&aring": "å",
              "&aring;": "å",
              "&ascr;": "𝒶",
              "&ast;": "*",
              "&asymp;": "≈",
              "&asympeq;": "≍",
              "&atilde": "ã",
              "&atilde;": "ã",
              "&auml": "ä",
              "&auml;": "ä",
              "&awconint;": "∳",
              "&awint;": "⨑",
              "&bNot;": "⫭",
              "&backcong;": "≌",
              "&backepsilon;": "϶",
              "&backprime;": "‵",
              "&backsim;": "∽",
              "&backsimeq;": "⋍",
              "&barvee;": "⊽",
              "&barwed;": "⌅",
              "&barwedge;": "⌅",
              "&bbrk;": "⎵",
              "&bbrktbrk;": "⎶",
              "&bcong;": "≌",
              "&bcy;": "б",
              "&bdquo;": "„",
              "&becaus;": "∵",
              "&because;": "∵",
              "&bemptyv;": "⦰",
              "&bepsi;": "϶",
              "&bernou;": "ℬ",
              "&beta;": "β",
              "&beth;": "ℶ",
              "&between;": "≬",
              "&bfr;": "𝔟",
              "&bigcap;": "⋂",
              "&bigcirc;": "◯",
              "&bigcup;": "⋃",
              "&bigodot;": "⨀",
              "&bigoplus;": "⨁",
              "&bigotimes;": "⨂",
              "&bigsqcup;": "⨆",
              "&bigstar;": "★",
              "&bigtriangledown;": "▽",
              "&bigtriangleup;": "△",
              "&biguplus;": "⨄",
              "&bigvee;": "⋁",
              "&bigwedge;": "⋀",
              "&bkarow;": "⤍",
              "&blacklozenge;": "⧫",
              "&blacksquare;": "▪",
              "&blacktriangle;": "▴",
              "&blacktriangledown;": "▾",
              "&blacktriangleleft;": "◂",
              "&blacktriangleright;": "▸",
              "&blank;": "␣",
              "&blk12;": "▒",
              "&blk14;": "░",
              "&blk34;": "▓",
              "&block;": "█",
              "&bne;": "=⃥",
              "&bnequiv;": "≡⃥",
              "&bnot;": "⌐",
              "&bopf;": "𝕓",
              "&bot;": "⊥",
              "&bottom;": "⊥",
              "&bowtie;": "⋈",
              "&boxDL;": "╗",
              "&boxDR;": "╔",
              "&boxDl;": "╖",
              "&boxDr;": "╓",
              "&boxH;": "═",
              "&boxHD;": "╦",
              "&boxHU;": "╩",
              "&boxHd;": "╤",
              "&boxHu;": "╧",
              "&boxUL;": "╝",
              "&boxUR;": "╚",
              "&boxUl;": "╜",
              "&boxUr;": "╙",
              "&boxV;": "║",
              "&boxVH;": "╬",
              "&boxVL;": "╣",
              "&boxVR;": "╠",
              "&boxVh;": "╫",
              "&boxVl;": "╢",
              "&boxVr;": "╟",
              "&boxbox;": "⧉",
              "&boxdL;": "╕",
              "&boxdR;": "╒",
              "&boxdl;": "┐",
              "&boxdr;": "┌",
              "&boxh;": "─",
              "&boxhD;": "╥",
              "&boxhU;": "╨",
              "&boxhd;": "┬",
              "&boxhu;": "┴",
              "&boxminus;": "⊟",
              "&boxplus;": "⊞",
              "&boxtimes;": "⊠",
              "&boxuL;": "╛",
              "&boxuR;": "╘",
              "&boxul;": "┘",
              "&boxur;": "└",
              "&boxv;": "│",
              "&boxvH;": "╪",
              "&boxvL;": "╡",
              "&boxvR;": "╞",
              "&boxvh;": "┼",
              "&boxvl;": "┤",
              "&boxvr;": "├",
              "&bprime;": "‵",
              "&breve;": "˘",
              "&brvbar": "¦",
              "&brvbar;": "¦",
              "&bscr;": "𝒷",
              "&bsemi;": "⁏",
              "&bsim;": "∽",
              "&bsime;": "⋍",
              "&bsol;": "\\",
              "&bsolb;": "⧅",
              "&bsolhsub;": "⟈",
              "&bull;": "•",
              "&bullet;": "•",
              "&bump;": "≎",
              "&bumpE;": "⪮",
              "&bumpe;": "≏",
              "&bumpeq;": "≏",
              "&cacute;": "ć",
              "&cap;": "∩",
              "&capand;": "⩄",
              "&capbrcup;": "⩉",
              "&capcap;": "⩋",
              "&capcup;": "⩇",
              "&capdot;": "⩀",
              "&caps;": "∩︀",
              "&caret;": "⁁",
              "&caron;": "ˇ",
              "&ccaps;": "⩍",
              "&ccaron;": "č",
              "&ccedil": "ç",
              "&ccedil;": "ç",
              "&ccirc;": "ĉ",
              "&ccups;": "⩌",
              "&ccupssm;": "⩐",
              "&cdot;": "ċ",
              "&cedil": "¸",
              "&cedil;": "¸",
              "&cemptyv;": "⦲",
              "&cent": "¢",
              "&cent;": "¢",
              "&centerdot;": "·",
              "&cfr;": "𝔠",
              "&chcy;": "ч",
              "&check;": "✓",
              "&checkmark;": "✓",
              "&chi;": "χ",
              "&cir;": "○",
              "&cirE;": "⧃",
              "&circ;": "ˆ",
              "&circeq;": "≗",
              "&circlearrowleft;": "↺",
              "&circlearrowright;": "↻",
              "&circledR;": "®",
              "&circledS;": "Ⓢ",
              "&circledast;": "⊛",
              "&circledcirc;": "⊚",
              "&circleddash;": "⊝",
              "&cire;": "≗",
              "&cirfnint;": "⨐",
              "&cirmid;": "⫯",
              "&cirscir;": "⧂",
              "&clubs;": "♣",
              "&clubsuit;": "♣",
              "&colon;": ":",
              "&colone;": "≔",
              "&coloneq;": "≔",
              "&comma;": ",",
              "&commat;": "@",
              "&comp;": "∁",
              "&compfn;": "∘",
              "&complement;": "∁",
              "&complexes;": "ℂ",
              "&cong;": "≅",
              "&congdot;": "⩭",
              "&conint;": "∮",
              "&copf;": "𝕔",
              "&coprod;": "∐",
              "&copy": "©",
              "&copy;": "©",
              "&copysr;": "℗",
              "&crarr;": "↵",
              "&cross;": "✗",
              "&cscr;": "𝒸",
              "&csub;": "⫏",
              "&csube;": "⫑",
              "&csup;": "⫐",
              "&csupe;": "⫒",
              "&ctdot;": "⋯",
              "&cudarrl;": "⤸",
              "&cudarrr;": "⤵",
              "&cuepr;": "⋞",
              "&cuesc;": "⋟",
              "&cularr;": "↶",
              "&cularrp;": "⤽",
              "&cup;": "∪",
              "&cupbrcap;": "⩈",
              "&cupcap;": "⩆",
              "&cupcup;": "⩊",
              "&cupdot;": "⊍",
              "&cupor;": "⩅",
              "&cups;": "∪︀",
              "&curarr;": "↷",
              "&curarrm;": "⤼",
              "&curlyeqprec;": "⋞",
              "&curlyeqsucc;": "⋟",
              "&curlyvee;": "⋎",
              "&curlywedge;": "⋏",
              "&curren": "¤",
              "&curren;": "¤",
              "&curvearrowleft;": "↶",
              "&curvearrowright;": "↷",
              "&cuvee;": "⋎",
              "&cuwed;": "⋏",
              "&cwconint;": "∲",
              "&cwint;": "∱",
              "&cylcty;": "⌭",
              "&dArr;": "⇓",
              "&dHar;": "⥥",
              "&dagger;": "†",
              "&daleth;": "ℸ",
              "&darr;": "↓",
              "&dash;": "‐",
              "&dashv;": "⊣",
              "&dbkarow;": "⤏",
              "&dblac;": "˝",
              "&dcaron;": "ď",
              "&dcy;": "д",
              "&dd;": "ⅆ",
              "&ddagger;": "‡",
              "&ddarr;": "⇊",
              "&ddotseq;": "⩷",
              "&deg": "°",
              "&deg;": "°",
              "&delta;": "δ",
              "&demptyv;": "⦱",
              "&dfisht;": "⥿",
              "&dfr;": "𝔡",
              "&dharl;": "⇃",
              "&dharr;": "⇂",
              "&diam;": "⋄",
              "&diamond;": "⋄",
              "&diamondsuit;": "♦",
              "&diams;": "♦",
              "&die;": "¨",
              "&digamma;": "ϝ",
              "&disin;": "⋲",
              "&div;": "÷",
              "&divide": "÷",
              "&divide;": "÷",
              "&divideontimes;": "⋇",
              "&divonx;": "⋇",
              "&djcy;": "ђ",
              "&dlcorn;": "⌞",
              "&dlcrop;": "⌍",
              "&dollar;": "$",
              "&dopf;": "𝕕",
              "&dot;": "˙",
              "&doteq;": "≐",
              "&doteqdot;": "≑",
              "&dotminus;": "∸",
              "&dotplus;": "∔",
              "&dotsquare;": "⊡",
              "&doublebarwedge;": "⌆",
              "&downarrow;": "↓",
              "&downdownarrows;": "⇊",
              "&downharpoonleft;": "⇃",
              "&downharpoonright;": "⇂",
              "&drbkarow;": "⤐",
              "&drcorn;": "⌟",
              "&drcrop;": "⌌",
              "&dscr;": "𝒹",
              "&dscy;": "ѕ",
              "&dsol;": "⧶",
              "&dstrok;": "đ",
              "&dtdot;": "⋱",
              "&dtri;": "▿",
              "&dtrif;": "▾",
              "&duarr;": "⇵",
              "&duhar;": "⥯",
              "&dwangle;": "⦦",
              "&dzcy;": "џ",
              "&dzigrarr;": "⟿",
              "&eDDot;": "⩷",
              "&eDot;": "≑",
              "&eacute": "é",
              "&eacute;": "é",
              "&easter;": "⩮",
              "&ecaron;": "ě",
              "&ecir;": "≖",
              "&ecirc": "ê",
              "&ecirc;": "ê",
              "&ecolon;": "≕",
              "&ecy;": "э",
              "&edot;": "ė",
              "&ee;": "ⅇ",
              "&efDot;": "≒",
              "&efr;": "𝔢",
              "&eg;": "⪚",
              "&egrave": "è",
              "&egrave;": "è",
              "&egs;": "⪖",
              "&egsdot;": "⪘",
              "&el;": "⪙",
              "&elinters;": "⏧",
              "&ell;": "ℓ",
              "&els;": "⪕",
              "&elsdot;": "⪗",
              "&emacr;": "ē",
              "&empty;": "∅",
              "&emptyset;": "∅",
              "&emptyv;": "∅",
              "&emsp13;": " ",
              "&emsp14;": " ",
              "&emsp;": " ",
              "&eng;": "ŋ",
              "&ensp;": " ",
              "&eogon;": "ę",
              "&eopf;": "𝕖",
              "&epar;": "⋕",
              "&eparsl;": "⧣",
              "&eplus;": "⩱",
              "&epsi;": "ε",
              "&epsilon;": "ε",
              "&epsiv;": "ϵ",
              "&eqcirc;": "≖",
              "&eqcolon;": "≕",
              "&eqsim;": "≂",
              "&eqslantgtr;": "⪖",
              "&eqslantless;": "⪕",
              "&equals;": "=",
              "&equest;": "≟",
              "&equiv;": "≡",
              "&equivDD;": "⩸",
              "&eqvparsl;": "⧥",
              "&erDot;": "≓",
              "&erarr;": "⥱",
              "&escr;": "ℯ",
              "&esdot;": "≐",
              "&esim;": "≂",
              "&eta;": "η",
              "&eth": "ð",
              "&eth;": "ð",
              "&euml": "ë",
              "&euml;": "ë",
              "&euro;": "€",
              "&excl;": "!",
              "&exist;": "∃",
              "&expectation;": "ℰ",
              "&exponentiale;": "ⅇ",
              "&fallingdotseq;": "≒",
              "&fcy;": "ф",
              "&female;": "♀",
              "&ffilig;": "ﬃ",
              "&fflig;": "ﬀ",
              "&ffllig;": "ﬄ",
              "&ffr;": "𝔣",
              "&filig;": "ﬁ",
              "&fjlig;": "fj",
              "&flat;": "♭",
              "&fllig;": "ﬂ",
              "&fltns;": "▱",
              "&fnof;": "ƒ",
              "&fopf;": "𝕗",
              "&forall;": "∀",
              "&fork;": "⋔",
              "&forkv;": "⫙",
              "&fpartint;": "⨍",
              "&frac12": "½",
              "&frac12;": "½",
              "&frac13;": "⅓",
              "&frac14": "¼",
              "&frac14;": "¼",
              "&frac15;": "⅕",
              "&frac16;": "⅙",
              "&frac18;": "⅛",
              "&frac23;": "⅔",
              "&frac25;": "⅖",
              "&frac34": "¾",
              "&frac34;": "¾",
              "&frac35;": "⅗",
              "&frac38;": "⅜",
              "&frac45;": "⅘",
              "&frac56;": "⅚",
              "&frac58;": "⅝",
              "&frac78;": "⅞",
              "&frasl;": "⁄",
              "&frown;": "⌢",
              "&fscr;": "𝒻",
              "&gE;": "≧",
              "&gEl;": "⪌",
              "&gacute;": "ǵ",
              "&gamma;": "γ",
              "&gammad;": "ϝ",
              "&gap;": "⪆",
              "&gbreve;": "ğ",
              "&gcirc;": "ĝ",
              "&gcy;": "г",
              "&gdot;": "ġ",
              "&ge;": "≥",
              "&gel;": "⋛",
              "&geq;": "≥",
              "&geqq;": "≧",
              "&geqslant;": "⩾",
              "&ges;": "⩾",
              "&gescc;": "⪩",
              "&gesdot;": "⪀",
              "&gesdoto;": "⪂",
              "&gesdotol;": "⪄",
              "&gesl;": "⋛︀",
              "&gesles;": "⪔",
              "&gfr;": "𝔤",
              "&gg;": "≫",
              "&ggg;": "⋙",
              "&gimel;": "ℷ",
              "&gjcy;": "ѓ",
              "&gl;": "≷",
              "&glE;": "⪒",
              "&gla;": "⪥",
              "&glj;": "⪤",
              "&gnE;": "≩",
              "&gnap;": "⪊",
              "&gnapprox;": "⪊",
              "&gne;": "⪈",
              "&gneq;": "⪈",
              "&gneqq;": "≩",
              "&gnsim;": "⋧",
              "&gopf;": "𝕘",
              "&grave;": "`",
              "&gscr;": "ℊ",
              "&gsim;": "≳",
              "&gsime;": "⪎",
              "&gsiml;": "⪐",
              "&gt": ">",
              "&gt;": ">",
              "&gtcc;": "⪧",
              "&gtcir;": "⩺",
              "&gtdot;": "⋗",
              "&gtlPar;": "⦕",
              "&gtquest;": "⩼",
              "&gtrapprox;": "⪆",
              "&gtrarr;": "⥸",
              "&gtrdot;": "⋗",
              "&gtreqless;": "⋛",
              "&gtreqqless;": "⪌",
              "&gtrless;": "≷",
              "&gtrsim;": "≳",
              "&gvertneqq;": "≩︀",
              "&gvnE;": "≩︀",
              "&hArr;": "⇔",
              "&hairsp;": " ",
              "&half;": "½",
              "&hamilt;": "ℋ",
              "&hardcy;": "ъ",
              "&harr;": "↔",
              "&harrcir;": "⥈",
              "&harrw;": "↭",
              "&hbar;": "ℏ",
              "&hcirc;": "ĥ",
              "&hearts;": "♥",
              "&heartsuit;": "♥",
              "&hellip;": "…",
              "&hercon;": "⊹",
              "&hfr;": "𝔥",
              "&hksearow;": "⤥",
              "&hkswarow;": "⤦",
              "&hoarr;": "⇿",
              "&homtht;": "∻",
              "&hookleftarrow;": "↩",
              "&hookrightarrow;": "↪",
              "&hopf;": "𝕙",
              "&horbar;": "―",
              "&hscr;": "𝒽",
              "&hslash;": "ℏ",
              "&hstrok;": "ħ",
              "&hybull;": "⁃",
              "&hyphen;": "‐",
              "&iacute": "í",
              "&iacute;": "í",
              "&ic;": "⁣",
              "&icirc": "î",
              "&icirc;": "î",
              "&icy;": "и",
              "&iecy;": "е",
              "&iexcl": "¡",
              "&iexcl;": "¡",
              "&iff;": "⇔",
              "&ifr;": "𝔦",
              "&igrave": "ì",
              "&igrave;": "ì",
              "&ii;": "ⅈ",
              "&iiiint;": "⨌",
              "&iiint;": "∭",
              "&iinfin;": "⧜",
              "&iiota;": "℩",
              "&ijlig;": "ĳ",
              "&imacr;": "ī",
              "&image;": "ℑ",
              "&imagline;": "ℐ",
              "&imagpart;": "ℑ",
              "&imath;": "ı",
              "&imof;": "⊷",
              "&imped;": "Ƶ",
              "&in;": "∈",
              "&incare;": "℅",
              "&infin;": "∞",
              "&infintie;": "⧝",
              "&inodot;": "ı",
              "&int;": "∫",
              "&intcal;": "⊺",
              "&integers;": "ℤ",
              "&intercal;": "⊺",
              "&intlarhk;": "⨗",
              "&intprod;": "⨼",
              "&iocy;": "ё",
              "&iogon;": "į",
              "&iopf;": "𝕚",
              "&iota;": "ι",
              "&iprod;": "⨼",
              "&iquest": "¿",
              "&iquest;": "¿",
              "&iscr;": "𝒾",
              "&isin;": "∈",
              "&isinE;": "⋹",
              "&isindot;": "⋵",
              "&isins;": "⋴",
              "&isinsv;": "⋳",
              "&isinv;": "∈",
              "&it;": "⁢",
              "&itilde;": "ĩ",
              "&iukcy;": "і",
              "&iuml": "ï",
              "&iuml;": "ï",
              "&jcirc;": "ĵ",
              "&jcy;": "й",
              "&jfr;": "𝔧",
              "&jmath;": "ȷ",
              "&jopf;": "𝕛",
              "&jscr;": "𝒿",
              "&jsercy;": "ј",
              "&jukcy;": "є",
              "&kappa;": "κ",
              "&kappav;": "ϰ",
              "&kcedil;": "ķ",
              "&kcy;": "к",
              "&kfr;": "𝔨",
              "&kgreen;": "ĸ",
              "&khcy;": "х",
              "&kjcy;": "ќ",
              "&kopf;": "𝕜",
              "&kscr;": "𝓀",
              "&lAarr;": "⇚",
              "&lArr;": "⇐",
              "&lAtail;": "⤛",
              "&lBarr;": "⤎",
              "&lE;": "≦",
              "&lEg;": "⪋",
              "&lHar;": "⥢",
              "&lacute;": "ĺ",
              "&laemptyv;": "⦴",
              "&lagran;": "ℒ",
              "&lambda;": "λ",
              "&lang;": "⟨",
              "&langd;": "⦑",
              "&langle;": "⟨",
              "&lap;": "⪅",
              "&laquo": "«",
              "&laquo;": "«",
              "&larr;": "←",
              "&larrb;": "⇤",
              "&larrbfs;": "⤟",
              "&larrfs;": "⤝",
              "&larrhk;": "↩",
              "&larrlp;": "↫",
              "&larrpl;": "⤹",
              "&larrsim;": "⥳",
              "&larrtl;": "↢",
              "&lat;": "⪫",
              "&latail;": "⤙",
              "&late;": "⪭",
              "&lates;": "⪭︀",
              "&lbarr;": "⤌",
              "&lbbrk;": "❲",
              "&lbrace;": "{",
              "&lbrack;": "[",
              "&lbrke;": "⦋",
              "&lbrksld;": "⦏",
              "&lbrkslu;": "⦍",
              "&lcaron;": "ľ",
              "&lcedil;": "ļ",
              "&lceil;": "⌈",
              "&lcub;": "{",
              "&lcy;": "л",
              "&ldca;": "⤶",
              "&ldquo;": "“",
              "&ldquor;": "„",
              "&ldrdhar;": "⥧",
              "&ldrushar;": "⥋",
              "&ldsh;": "↲",
              "&le;": "≤",
              "&leftarrow;": "←",
              "&leftarrowtail;": "↢",
              "&leftharpoondown;": "↽",
              "&leftharpoonup;": "↼",
              "&leftleftarrows;": "⇇",
              "&leftrightarrow;": "↔",
              "&leftrightarrows;": "⇆",
              "&leftrightharpoons;": "⇋",
              "&leftrightsquigarrow;": "↭",
              "&leftthreetimes;": "⋋",
              "&leg;": "⋚",
              "&leq;": "≤",
              "&leqq;": "≦",
              "&leqslant;": "⩽",
              "&les;": "⩽",
              "&lescc;": "⪨",
              "&lesdot;": "⩿",
              "&lesdoto;": "⪁",
              "&lesdotor;": "⪃",
              "&lesg;": "⋚︀",
              "&lesges;": "⪓",
              "&lessapprox;": "⪅",
              "&lessdot;": "⋖",
              "&lesseqgtr;": "⋚",
              "&lesseqqgtr;": "⪋",
              "&lessgtr;": "≶",
              "&lesssim;": "≲",
              "&lfisht;": "⥼",
              "&lfloor;": "⌊",
              "&lfr;": "𝔩",
              "&lg;": "≶",
              "&lgE;": "⪑",
              "&lhard;": "↽",
              "&lharu;": "↼",
              "&lharul;": "⥪",
              "&lhblk;": "▄",
              "&ljcy;": "љ",
              "&ll;": "≪",
              "&llarr;": "⇇",
              "&llcorner;": "⌞",
              "&llhard;": "⥫",
              "&lltri;": "◺",
              "&lmidot;": "ŀ",
              "&lmoust;": "⎰",
              "&lmoustache;": "⎰",
              "&lnE;": "≨",
              "&lnap;": "⪉",
              "&lnapprox;": "⪉",
              "&lne;": "⪇",
              "&lneq;": "⪇",
              "&lneqq;": "≨",
              "&lnsim;": "⋦",
              "&loang;": "⟬",
              "&loarr;": "⇽",
              "&lobrk;": "⟦",
              "&longleftarrow;": "⟵",
              "&longleftrightarrow;": "⟷",
              "&longmapsto;": "⟼",
              "&longrightarrow;": "⟶",
              "&looparrowleft;": "↫",
              "&looparrowright;": "↬",
              "&lopar;": "⦅",
              "&lopf;": "𝕝",
              "&loplus;": "⨭",
              "&lotimes;": "⨴",
              "&lowast;": "∗",
              "&lowbar;": "_",
              "&loz;": "◊",
              "&lozenge;": "◊",
              "&lozf;": "⧫",
              "&lpar;": "(",
              "&lparlt;": "⦓",
              "&lrarr;": "⇆",
              "&lrcorner;": "⌟",
              "&lrhar;": "⇋",
              "&lrhard;": "⥭",
              "&lrm;": "‎",
              "&lrtri;": "⊿",
              "&lsaquo;": "‹",
              "&lscr;": "𝓁",
              "&lsh;": "↰",
              "&lsim;": "≲",
              "&lsime;": "⪍",
              "&lsimg;": "⪏",
              "&lsqb;": "[",
              "&lsquo;": "‘",
              "&lsquor;": "‚",
              "&lstrok;": "ł",
              "&lt": "<",
              "&lt;": "<",
              "&ltcc;": "⪦",
              "&ltcir;": "⩹",
              "&ltdot;": "⋖",
              "&lthree;": "⋋",
              "&ltimes;": "⋉",
              "&ltlarr;": "⥶",
              "&ltquest;": "⩻",
              "&ltrPar;": "⦖",
              "&ltri;": "◃",
              "&ltrie;": "⊴",
              "&ltrif;": "◂",
              "&lurdshar;": "⥊",
              "&luruhar;": "⥦",
              "&lvertneqq;": "≨︀",
              "&lvnE;": "≨︀",
              "&mDDot;": "∺",
              "&macr": "¯",
              "&macr;": "¯",
              "&male;": "♂",
              "&malt;": "✠",
              "&maltese;": "✠",
              "&map;": "↦",
              "&mapsto;": "↦",
              "&mapstodown;": "↧",
              "&mapstoleft;": "↤",
              "&mapstoup;": "↥",
              "&marker;": "▮",
              "&mcomma;": "⨩",
              "&mcy;": "м",
              "&mdash;": "—",
              "&measuredangle;": "∡",
              "&mfr;": "𝔪",
              "&mho;": "℧",
              "&micro": "µ",
              "&micro;": "µ",
              "&mid;": "∣",
              "&midast;": "*",
              "&midcir;": "⫰",
              "&middot": "·",
              "&middot;": "·",
              "&minus;": "−",
              "&minusb;": "⊟",
              "&minusd;": "∸",
              "&minusdu;": "⨪",
              "&mlcp;": "⫛",
              "&mldr;": "…",
              "&mnplus;": "∓",
              "&models;": "⊧",
              "&mopf;": "𝕞",
              "&mp;": "∓",
              "&mscr;": "𝓂",
              "&mstpos;": "∾",
              "&mu;": "μ",
              "&multimap;": "⊸",
              "&mumap;": "⊸",
              "&nGg;": "⋙̸",
              "&nGt;": "≫⃒",
              "&nGtv;": "≫̸",
              "&nLeftarrow;": "⇍",
              "&nLeftrightarrow;": "⇎",
              "&nLl;": "⋘̸",
              "&nLt;": "≪⃒",
              "&nLtv;": "≪̸",
              "&nRightarrow;": "⇏",
              "&nVDash;": "⊯",
              "&nVdash;": "⊮",
              "&nabla;": "∇",
              "&nacute;": "ń",
              "&nang;": "∠⃒",
              "&nap;": "≉",
              "&napE;": "⩰̸",
              "&napid;": "≋̸",
              "&napos;": "ŉ",
              "&napprox;": "≉",
              "&natur;": "♮",
              "&natural;": "♮",
              "&naturals;": "ℕ",
              "&nbsp": " ",
              "&nbsp;": " ",
              "&nbump;": "≎̸",
              "&nbumpe;": "≏̸",
              "&ncap;": "⩃",
              "&ncaron;": "ň",
              "&ncedil;": "ņ",
              "&ncong;": "≇",
              "&ncongdot;": "⩭̸",
              "&ncup;": "⩂",
              "&ncy;": "н",
              "&ndash;": "–",
              "&ne;": "≠",
              "&neArr;": "⇗",
              "&nearhk;": "⤤",
              "&nearr;": "↗",
              "&nearrow;": "↗",
              "&nedot;": "≐̸",
              "&nequiv;": "≢",
              "&nesear;": "⤨",
              "&nesim;": "≂̸",
              "&nexist;": "∄",
              "&nexists;": "∄",
              "&nfr;": "𝔫",
              "&ngE;": "≧̸",
              "&nge;": "≱",
              "&ngeq;": "≱",
              "&ngeqq;": "≧̸",
              "&ngeqslant;": "⩾̸",
              "&nges;": "⩾̸",
              "&ngsim;": "≵",
              "&ngt;": "≯",
              "&ngtr;": "≯",
              "&nhArr;": "⇎",
              "&nharr;": "↮",
              "&nhpar;": "⫲",
              "&ni;": "∋",
              "&nis;": "⋼",
              "&nisd;": "⋺",
              "&niv;": "∋",
              "&njcy;": "њ",
              "&nlArr;": "⇍",
              "&nlE;": "≦̸",
              "&nlarr;": "↚",
              "&nldr;": "‥",
              "&nle;": "≰",
              "&nleftarrow;": "↚",
              "&nleftrightarrow;": "↮",
              "&nleq;": "≰",
              "&nleqq;": "≦̸",
              "&nleqslant;": "⩽̸",
              "&nles;": "⩽̸",
              "&nless;": "≮",
              "&nlsim;": "≴",
              "&nlt;": "≮",
              "&nltri;": "⋪",
              "&nltrie;": "⋬",
              "&nmid;": "∤",
              "&nopf;": "𝕟",
              "&not": "¬",
              "&not;": "¬",
              "&notin;": "∉",
              "&notinE;": "⋹̸",
              "&notindot;": "⋵̸",
              "&notinva;": "∉",
              "&notinvb;": "⋷",
              "&notinvc;": "⋶",
              "&notni;": "∌",
              "&notniva;": "∌",
              "&notnivb;": "⋾",
              "&notnivc;": "⋽",
              "&npar;": "∦",
              "&nparallel;": "∦",
              "&nparsl;": "⫽⃥",
              "&npart;": "∂̸",
              "&npolint;": "⨔",
              "&npr;": "⊀",
              "&nprcue;": "⋠",
              "&npre;": "⪯̸",
              "&nprec;": "⊀",
              "&npreceq;": "⪯̸",
              "&nrArr;": "⇏",
              "&nrarr;": "↛",
              "&nrarrc;": "⤳̸",
              "&nrarrw;": "↝̸",
              "&nrightarrow;": "↛",
              "&nrtri;": "⋫",
              "&nrtrie;": "⋭",
              "&nsc;": "⊁",
              "&nsccue;": "⋡",
              "&nsce;": "⪰̸",
              "&nscr;": "𝓃",
              "&nshortmid;": "∤",
              "&nshortparallel;": "∦",
              "&nsim;": "≁",
              "&nsime;": "≄",
              "&nsimeq;": "≄",
              "&nsmid;": "∤",
              "&nspar;": "∦",
              "&nsqsube;": "⋢",
              "&nsqsupe;": "⋣",
              "&nsub;": "⊄",
              "&nsubE;": "⫅̸",
              "&nsube;": "⊈",
              "&nsubset;": "⊂⃒",
              "&nsubseteq;": "⊈",
              "&nsubseteqq;": "⫅̸",
              "&nsucc;": "⊁",
              "&nsucceq;": "⪰̸",
              "&nsup;": "⊅",
              "&nsupE;": "⫆̸",
              "&nsupe;": "⊉",
              "&nsupset;": "⊃⃒",
              "&nsupseteq;": "⊉",
              "&nsupseteqq;": "⫆̸",
              "&ntgl;": "≹",
              "&ntilde": "ñ",
              "&ntilde;": "ñ",
              "&ntlg;": "≸",
              "&ntriangleleft;": "⋪",
              "&ntrianglelefteq;": "⋬",
              "&ntriangleright;": "⋫",
              "&ntrianglerighteq;": "⋭",
              "&nu;": "ν",
              "&num;": "#",
              "&numero;": "№",
              "&numsp;": " ",
              "&nvDash;": "⊭",
              "&nvHarr;": "⤄",
              "&nvap;": "≍⃒",
              "&nvdash;": "⊬",
              "&nvge;": "≥⃒",
              "&nvgt;": ">⃒",
              "&nvinfin;": "⧞",
              "&nvlArr;": "⤂",
              "&nvle;": "≤⃒",
              "&nvlt;": "<⃒",
              "&nvltrie;": "⊴⃒",
              "&nvrArr;": "⤃",
              "&nvrtrie;": "⊵⃒",
              "&nvsim;": "∼⃒",
              "&nwArr;": "⇖",
              "&nwarhk;": "⤣",
              "&nwarr;": "↖",
              "&nwarrow;": "↖",
              "&nwnear;": "⤧",
              "&oS;": "Ⓢ",
              "&oacute": "ó",
              "&oacute;": "ó",
              "&oast;": "⊛",
              "&ocir;": "⊚",
              "&ocirc": "ô",
              "&ocirc;": "ô",
              "&ocy;": "о",
              "&odash;": "⊝",
              "&odblac;": "ő",
              "&odiv;": "⨸",
              "&odot;": "⊙",
              "&odsold;": "⦼",
              "&oelig;": "œ",
              "&ofcir;": "⦿",
              "&ofr;": "𝔬",
              "&ogon;": "˛",
              "&ograve": "ò",
              "&ograve;": "ò",
              "&ogt;": "⧁",
              "&ohbar;": "⦵",
              "&ohm;": "Ω",
              "&oint;": "∮",
              "&olarr;": "↺",
              "&olcir;": "⦾",
              "&olcross;": "⦻",
              "&oline;": "‾",
              "&olt;": "⧀",
              "&omacr;": "ō",
              "&omega;": "ω",
              "&omicron;": "ο",
              "&omid;": "⦶",
              "&ominus;": "⊖",
              "&oopf;": "𝕠",
              "&opar;": "⦷",
              "&operp;": "⦹",
              "&oplus;": "⊕",
              "&or;": "∨",
              "&orarr;": "↻",
              "&ord;": "⩝",
              "&order;": "ℴ",
              "&orderof;": "ℴ",
              "&ordf": "ª",
              "&ordf;": "ª",
              "&ordm": "º",
              "&ordm;": "º",
              "&origof;": "⊶",
              "&oror;": "⩖",
              "&orslope;": "⩗",
              "&orv;": "⩛",
              "&oscr;": "ℴ",
              "&oslash": "ø",
              "&oslash;": "ø",
              "&osol;": "⊘",
              "&otilde": "õ",
              "&otilde;": "õ",
              "&otimes;": "⊗",
              "&otimesas;": "⨶",
              "&ouml": "ö",
              "&ouml;": "ö",
              "&ovbar;": "⌽",
              "&par;": "∥",
              "&para": "¶",
              "&para;": "¶",
              "&parallel;": "∥",
              "&parsim;": "⫳",
              "&parsl;": "⫽",
              "&part;": "∂",
              "&pcy;": "п",
              "&percnt;": "%",
              "&period;": ".",
              "&permil;": "‰",
              "&perp;": "⊥",
              "&pertenk;": "‱",
              "&pfr;": "𝔭",
              "&phi;": "φ",
              "&phiv;": "ϕ",
              "&phmmat;": "ℳ",
              "&phone;": "☎",
              "&pi;": "π",
              "&pitchfork;": "⋔",
              "&piv;": "ϖ",
              "&planck;": "ℏ",
              "&planckh;": "ℎ",
              "&plankv;": "ℏ",
              "&plus;": "+",
              "&plusacir;": "⨣",
              "&plusb;": "⊞",
              "&pluscir;": "⨢",
              "&plusdo;": "∔",
              "&plusdu;": "⨥",
              "&pluse;": "⩲",
              "&plusmn": "±",
              "&plusmn;": "±",
              "&plussim;": "⨦",
              "&plustwo;": "⨧",
              "&pm;": "±",
              "&pointint;": "⨕",
              "&popf;": "𝕡",
              "&pound": "£",
              "&pound;": "£",
              "&pr;": "≺",
              "&prE;": "⪳",
              "&prap;": "⪷",
              "&prcue;": "≼",
              "&pre;": "⪯",
              "&prec;": "≺",
              "&precapprox;": "⪷",
              "&preccurlyeq;": "≼",
              "&preceq;": "⪯",
              "&precnapprox;": "⪹",
              "&precneqq;": "⪵",
              "&precnsim;": "⋨",
              "&precsim;": "≾",
              "&prime;": "′",
              "&primes;": "ℙ",
              "&prnE;": "⪵",
              "&prnap;": "⪹",
              "&prnsim;": "⋨",
              "&prod;": "∏",
              "&profalar;": "⌮",
              "&profline;": "⌒",
              "&profsurf;": "⌓",
              "&prop;": "∝",
              "&propto;": "∝",
              "&prsim;": "≾",
              "&prurel;": "⊰",
              "&pscr;": "𝓅",
              "&psi;": "ψ",
              "&puncsp;": " ",
              "&qfr;": "𝔮",
              "&qint;": "⨌",
              "&qopf;": "𝕢",
              "&qprime;": "⁗",
              "&qscr;": "𝓆",
              "&quaternions;": "ℍ",
              "&quatint;": "⨖",
              "&quest;": "?",
              "&questeq;": "≟",
              "&quot": '"',
              "&quot;": '"',
              "&rAarr;": "⇛",
              "&rArr;": "⇒",
              "&rAtail;": "⤜",
              "&rBarr;": "⤏",
              "&rHar;": "⥤",
              "&race;": "∽̱",
              "&racute;": "ŕ",
              "&radic;": "√",
              "&raemptyv;": "⦳",
              "&rang;": "⟩",
              "&rangd;": "⦒",
              "&range;": "⦥",
              "&rangle;": "⟩",
              "&raquo": "»",
              "&raquo;": "»",
              "&rarr;": "→",
              "&rarrap;": "⥵",
              "&rarrb;": "⇥",
              "&rarrbfs;": "⤠",
              "&rarrc;": "⤳",
              "&rarrfs;": "⤞",
              "&rarrhk;": "↪",
              "&rarrlp;": "↬",
              "&rarrpl;": "⥅",
              "&rarrsim;": "⥴",
              "&rarrtl;": "↣",
              "&rarrw;": "↝",
              "&ratail;": "⤚",
              "&ratio;": "∶",
              "&rationals;": "ℚ",
              "&rbarr;": "⤍",
              "&rbbrk;": "❳",
              "&rbrace;": "}",
              "&rbrack;": "]",
              "&rbrke;": "⦌",
              "&rbrksld;": "⦎",
              "&rbrkslu;": "⦐",
              "&rcaron;": "ř",
              "&rcedil;": "ŗ",
              "&rceil;": "⌉",
              "&rcub;": "}",
              "&rcy;": "р",
              "&rdca;": "⤷",
              "&rdldhar;": "⥩",
              "&rdquo;": "”",
              "&rdquor;": "”",
              "&rdsh;": "↳",
              "&real;": "ℜ",
              "&realine;": "ℛ",
              "&realpart;": "ℜ",
              "&reals;": "ℝ",
              "&rect;": "▭",
              "&reg": "®",
              "&reg;": "®",
              "&rfisht;": "⥽",
              "&rfloor;": "⌋",
              "&rfr;": "𝔯",
              "&rhard;": "⇁",
              "&rharu;": "⇀",
              "&rharul;": "⥬",
              "&rho;": "ρ",
              "&rhov;": "ϱ",
              "&rightarrow;": "→",
              "&rightarrowtail;": "↣",
              "&rightharpoondown;": "⇁",
              "&rightharpoonup;": "⇀",
              "&rightleftarrows;": "⇄",
              "&rightleftharpoons;": "⇌",
              "&rightrightarrows;": "⇉",
              "&rightsquigarrow;": "↝",
              "&rightthreetimes;": "⋌",
              "&ring;": "˚",
              "&risingdotseq;": "≓",
              "&rlarr;": "⇄",
              "&rlhar;": "⇌",
              "&rlm;": "‏",
              "&rmoust;": "⎱",
              "&rmoustache;": "⎱",
              "&rnmid;": "⫮",
              "&roang;": "⟭",
              "&roarr;": "⇾",
              "&robrk;": "⟧",
              "&ropar;": "⦆",
              "&ropf;": "𝕣",
              "&roplus;": "⨮",
              "&rotimes;": "⨵",
              "&rpar;": ")",
              "&rpargt;": "⦔",
              "&rppolint;": "⨒",
              "&rrarr;": "⇉",
              "&rsaquo;": "›",
              "&rscr;": "𝓇",
              "&rsh;": "↱",
              "&rsqb;": "]",
              "&rsquo;": "’",
              "&rsquor;": "’",
              "&rthree;": "⋌",
              "&rtimes;": "⋊",
              "&rtri;": "▹",
              "&rtrie;": "⊵",
              "&rtrif;": "▸",
              "&rtriltri;": "⧎",
              "&ruluhar;": "⥨",
              "&rx;": "℞",
              "&sacute;": "ś",
              "&sbquo;": "‚",
              "&sc;": "≻",
              "&scE;": "⪴",
              "&scap;": "⪸",
              "&scaron;": "š",
              "&sccue;": "≽",
              "&sce;": "⪰",
              "&scedil;": "ş",
              "&scirc;": "ŝ",
              "&scnE;": "⪶",
              "&scnap;": "⪺",
              "&scnsim;": "⋩",
              "&scpolint;": "⨓",
              "&scsim;": "≿",
              "&scy;": "с",
              "&sdot;": "⋅",
              "&sdotb;": "⊡",
              "&sdote;": "⩦",
              "&seArr;": "⇘",
              "&searhk;": "⤥",
              "&searr;": "↘",
              "&searrow;": "↘",
              "&sect": "§",
              "&sect;": "§",
              "&semi;": ";",
              "&seswar;": "⤩",
              "&setminus;": "∖",
              "&setmn;": "∖",
              "&sext;": "✶",
              "&sfr;": "𝔰",
              "&sfrown;": "⌢",
              "&sharp;": "♯",
              "&shchcy;": "щ",
              "&shcy;": "ш",
              "&shortmid;": "∣",
              "&shortparallel;": "∥",
              "&shy": "­",
              "&shy;": "­",
              "&sigma;": "σ",
              "&sigmaf;": "ς",
              "&sigmav;": "ς",
              "&sim;": "∼",
              "&simdot;": "⩪",
              "&sime;": "≃",
              "&simeq;": "≃",
              "&simg;": "⪞",
              "&simgE;": "⪠",
              "&siml;": "⪝",
              "&simlE;": "⪟",
              "&simne;": "≆",
              "&simplus;": "⨤",
              "&simrarr;": "⥲",
              "&slarr;": "←",
              "&smallsetminus;": "∖",
              "&smashp;": "⨳",
              "&smeparsl;": "⧤",
              "&smid;": "∣",
              "&smile;": "⌣",
              "&smt;": "⪪",
              "&smte;": "⪬",
              "&smtes;": "⪬︀",
              "&softcy;": "ь",
              "&sol;": "/",
              "&solb;": "⧄",
              "&solbar;": "⌿",
              "&sopf;": "𝕤",
              "&spades;": "♠",
              "&spadesuit;": "♠",
              "&spar;": "∥",
              "&sqcap;": "⊓",
              "&sqcaps;": "⊓︀",
              "&sqcup;": "⊔",
              "&sqcups;": "⊔︀",
              "&sqsub;": "⊏",
              "&sqsube;": "⊑",
              "&sqsubset;": "⊏",
              "&sqsubseteq;": "⊑",
              "&sqsup;": "⊐",
              "&sqsupe;": "⊒",
              "&sqsupset;": "⊐",
              "&sqsupseteq;": "⊒",
              "&squ;": "□",
              "&square;": "□",
              "&squarf;": "▪",
              "&squf;": "▪",
              "&srarr;": "→",
              "&sscr;": "𝓈",
              "&ssetmn;": "∖",
              "&ssmile;": "⌣",
              "&sstarf;": "⋆",
              "&star;": "☆",
              "&starf;": "★",
              "&straightepsilon;": "ϵ",
              "&straightphi;": "ϕ",
              "&strns;": "¯",
              "&sub;": "⊂",
              "&subE;": "⫅",
              "&subdot;": "⪽",
              "&sube;": "⊆",
              "&subedot;": "⫃",
              "&submult;": "⫁",
              "&subnE;": "⫋",
              "&subne;": "⊊",
              "&subplus;": "⪿",
              "&subrarr;": "⥹",
              "&subset;": "⊂",
              "&subseteq;": "⊆",
              "&subseteqq;": "⫅",
              "&subsetneq;": "⊊",
              "&subsetneqq;": "⫋",
              "&subsim;": "⫇",
              "&subsub;": "⫕",
              "&subsup;": "⫓",
              "&succ;": "≻",
              "&succapprox;": "⪸",
              "&succcurlyeq;": "≽",
              "&succeq;": "⪰",
              "&succnapprox;": "⪺",
              "&succneqq;": "⪶",
              "&succnsim;": "⋩",
              "&succsim;": "≿",
              "&sum;": "∑",
              "&sung;": "♪",
              "&sup1": "¹",
              "&sup1;": "¹",
              "&sup2": "²",
              "&sup2;": "²",
              "&sup3": "³",
              "&sup3;": "³",
              "&sup;": "⊃",
              "&supE;": "⫆",
              "&supdot;": "⪾",
              "&supdsub;": "⫘",
              "&supe;": "⊇",
              "&supedot;": "⫄",
              "&suphsol;": "⟉",
              "&suphsub;": "⫗",
              "&suplarr;": "⥻",
              "&supmult;": "⫂",
              "&supnE;": "⫌",
              "&supne;": "⊋",
              "&supplus;": "⫀",
              "&supset;": "⊃",
              "&supseteq;": "⊇",
              "&supseteqq;": "⫆",
              "&supsetneq;": "⊋",
              "&supsetneqq;": "⫌",
              "&supsim;": "⫈",
              "&supsub;": "⫔",
              "&supsup;": "⫖",
              "&swArr;": "⇙",
              "&swarhk;": "⤦",
              "&swarr;": "↙",
              "&swarrow;": "↙",
              "&swnwar;": "⤪",
              "&szlig": "ß",
              "&szlig;": "ß",
              "&target;": "⌖",
              "&tau;": "τ",
              "&tbrk;": "⎴",
              "&tcaron;": "ť",
              "&tcedil;": "ţ",
              "&tcy;": "т",
              "&tdot;": "⃛",
              "&telrec;": "⌕",
              "&tfr;": "𝔱",
              "&there4;": "∴",
              "&therefore;": "∴",
              "&theta;": "θ",
              "&thetasym;": "ϑ",
              "&thetav;": "ϑ",
              "&thickapprox;": "≈",
              "&thicksim;": "∼",
              "&thinsp;": " ",
              "&thkap;": "≈",
              "&thksim;": "∼",
              "&thorn": "þ",
              "&thorn;": "þ",
              "&tilde;": "˜",
              "&times": "×",
              "&times;": "×",
              "&timesb;": "⊠",
              "&timesbar;": "⨱",
              "&timesd;": "⨰",
              "&tint;": "∭",
              "&toea;": "⤨",
              "&top;": "⊤",
              "&topbot;": "⌶",
              "&topcir;": "⫱",
              "&topf;": "𝕥",
              "&topfork;": "⫚",
              "&tosa;": "⤩",
              "&tprime;": "‴",
              "&trade;": "™",
              "&triangle;": "▵",
              "&triangledown;": "▿",
              "&triangleleft;": "◃",
              "&trianglelefteq;": "⊴",
              "&triangleq;": "≜",
              "&triangleright;": "▹",
              "&trianglerighteq;": "⊵",
              "&tridot;": "◬",
              "&trie;": "≜",
              "&triminus;": "⨺",
              "&triplus;": "⨹",
              "&trisb;": "⧍",
              "&tritime;": "⨻",
              "&trpezium;": "⏢",
              "&tscr;": "𝓉",
              "&tscy;": "ц",
              "&tshcy;": "ћ",
              "&tstrok;": "ŧ",
              "&twixt;": "≬",
              "&twoheadleftarrow;": "↞",
              "&twoheadrightarrow;": "↠",
              "&uArr;": "⇑",
              "&uHar;": "⥣",
              "&uacute": "ú",
              "&uacute;": "ú",
              "&uarr;": "↑",
              "&ubrcy;": "ў",
              "&ubreve;": "ŭ",
              "&ucirc": "û",
              "&ucirc;": "û",
              "&ucy;": "у",
              "&udarr;": "⇅",
              "&udblac;": "ű",
              "&udhar;": "⥮",
              "&ufisht;": "⥾",
              "&ufr;": "𝔲",
              "&ugrave": "ù",
              "&ugrave;": "ù",
              "&uharl;": "↿",
              "&uharr;": "↾",
              "&uhblk;": "▀",
              "&ulcorn;": "⌜",
              "&ulcorner;": "⌜",
              "&ulcrop;": "⌏",
              "&ultri;": "◸",
              "&umacr;": "ū",
              "&uml": "¨",
              "&uml;": "¨",
              "&uogon;": "ų",
              "&uopf;": "𝕦",
              "&uparrow;": "↑",
              "&updownarrow;": "↕",
              "&upharpoonleft;": "↿",
              "&upharpoonright;": "↾",
              "&uplus;": "⊎",
              "&upsi;": "υ",
              "&upsih;": "ϒ",
              "&upsilon;": "υ",
              "&upuparrows;": "⇈",
              "&urcorn;": "⌝",
              "&urcorner;": "⌝",
              "&urcrop;": "⌎",
              "&uring;": "ů",
              "&urtri;": "◹",
              "&uscr;": "𝓊",
              "&utdot;": "⋰",
              "&utilde;": "ũ",
              "&utri;": "▵",
              "&utrif;": "▴",
              "&uuarr;": "⇈",
              "&uuml": "ü",
              "&uuml;": "ü",
              "&uwangle;": "⦧",
              "&vArr;": "⇕",
              "&vBar;": "⫨",
              "&vBarv;": "⫩",
              "&vDash;": "⊨",
              "&vangrt;": "⦜",
              "&varepsilon;": "ϵ",
              "&varkappa;": "ϰ",
              "&varnothing;": "∅",
              "&varphi;": "ϕ",
              "&varpi;": "ϖ",
              "&varpropto;": "∝",
              "&varr;": "↕",
              "&varrho;": "ϱ",
              "&varsigma;": "ς",
              "&varsubsetneq;": "⊊︀",
              "&varsubsetneqq;": "⫋︀",
              "&varsupsetneq;": "⊋︀",
              "&varsupsetneqq;": "⫌︀",
              "&vartheta;": "ϑ",
              "&vartriangleleft;": "⊲",
              "&vartriangleright;": "⊳",
              "&vcy;": "в",
              "&vdash;": "⊢",
              "&vee;": "∨",
              "&veebar;": "⊻",
              "&veeeq;": "≚",
              "&vellip;": "⋮",
              "&verbar;": "|",
              "&vert;": "|",
              "&vfr;": "𝔳",
              "&vltri;": "⊲",
              "&vnsub;": "⊂⃒",
              "&vnsup;": "⊃⃒",
              "&vopf;": "𝕧",
              "&vprop;": "∝",
              "&vrtri;": "⊳",
              "&vscr;": "𝓋",
              "&vsubnE;": "⫋︀",
              "&vsubne;": "⊊︀",
              "&vsupnE;": "⫌︀",
              "&vsupne;": "⊋︀",
              "&vzigzag;": "⦚",
              "&wcirc;": "ŵ",
              "&wedbar;": "⩟",
              "&wedge;": "∧",
              "&wedgeq;": "≙",
              "&weierp;": "℘",
              "&wfr;": "𝔴",
              "&wopf;": "𝕨",
              "&wp;": "℘",
              "&wr;": "≀",
              "&wreath;": "≀",
              "&wscr;": "𝓌",
              "&xcap;": "⋂",
              "&xcirc;": "◯",
              "&xcup;": "⋃",
              "&xdtri;": "▽",
              "&xfr;": "𝔵",
              "&xhArr;": "⟺",
              "&xharr;": "⟷",
              "&xi;": "ξ",
              "&xlArr;": "⟸",
              "&xlarr;": "⟵",
              "&xmap;": "⟼",
              "&xnis;": "⋻",
              "&xodot;": "⨀",
              "&xopf;": "𝕩",
              "&xoplus;": "⨁",
              "&xotime;": "⨂",
              "&xrArr;": "⟹",
              "&xrarr;": "⟶",
              "&xscr;": "𝓍",
              "&xsqcup;": "⨆",
              "&xuplus;": "⨄",
              "&xutri;": "△",
              "&xvee;": "⋁",
              "&xwedge;": "⋀",
              "&yacute": "ý",
              "&yacute;": "ý",
              "&yacy;": "я",
              "&ycirc;": "ŷ",
              "&ycy;": "ы",
              "&yen": "¥",
              "&yen;": "¥",
              "&yfr;": "𝔶",
              "&yicy;": "ї",
              "&yopf;": "𝕪",
              "&yscr;": "𝓎",
              "&yucy;": "ю",
              "&yuml": "ÿ",
              "&yuml;": "ÿ",
              "&zacute;": "ź",
              "&zcaron;": "ž",
              "&zcy;": "з",
              "&zdot;": "ż",
              "&zeetrf;": "ℨ",
              "&zeta;": "ζ",
              "&zfr;": "𝔷",
              "&zhcy;": "ж",
              "&zigrarr;": "⇝",
              "&zopf;": "𝕫",
              "&zscr;": "𝓏",
              "&zwj;": "‍",
              "&zwnj;": "‌"
            },
            characters: {
              Æ: "&AElig;",
              "&": "&amp;",
              Á: "&Aacute;",
              Ă: "&Abreve;",
              Â: "&Acirc;",
              А: "&Acy;",
              𝔄: "&Afr;",
              À: "&Agrave;",
              Α: "&Alpha;",
              Ā: "&Amacr;",
              "⩓": "&And;",
              Ą: "&Aogon;",
              𝔸: "&Aopf;",
              "⁡": "&af;",
              Å: "&angst;",
              𝒜: "&Ascr;",
              "≔": "&coloneq;",
              Ã: "&Atilde;",
              Ä: "&Auml;",
              "∖": "&ssetmn;",
              "⫧": "&Barv;",
              "⌆": "&doublebarwedge;",
              Б: "&Bcy;",
              "∵": "&because;",
              ℬ: "&bernou;",
              Β: "&Beta;",
              𝔅: "&Bfr;",
              𝔹: "&Bopf;",
              "˘": "&breve;",
              "≎": "&bump;",
              Ч: "&CHcy;",
              "©": "&copy;",
              Ć: "&Cacute;",
              "⋒": "&Cap;",
              ⅅ: "&DD;",
              ℭ: "&Cfr;",
              Č: "&Ccaron;",
              Ç: "&Ccedil;",
              Ĉ: "&Ccirc;",
              "∰": "&Cconint;",
              Ċ: "&Cdot;",
              "¸": "&cedil;",
              "·": "&middot;",
              Χ: "&Chi;",
              "⊙": "&odot;",
              "⊖": "&ominus;",
              "⊕": "&oplus;",
              "⊗": "&otimes;",
              "∲": "&cwconint;",
              "”": "&rdquor;",
              "’": "&rsquor;",
              "∷": "&Proportion;",
              "⩴": "&Colone;",
              "≡": "&equiv;",
              "∯": "&DoubleContourIntegral;",
              "∮": "&oint;",
              ℂ: "&complexes;",
              "∐": "&coprod;",
              "∳": "&awconint;",
              "⨯": "&Cross;",
              𝒞: "&Cscr;",
              "⋓": "&Cup;",
              "≍": "&asympeq;",
              "⤑": "&DDotrahd;",
              Ђ: "&DJcy;",
              Ѕ: "&DScy;",
              Џ: "&DZcy;",
              "‡": "&ddagger;",
              "↡": "&Darr;",
              "⫤": "&DoubleLeftTee;",
              Ď: "&Dcaron;",
              Д: "&Dcy;",
              "∇": "&nabla;",
              Δ: "&Delta;",
              𝔇: "&Dfr;",
              "´": "&acute;",
              "˙": "&dot;",
              "˝": "&dblac;",
              "`": "&grave;",
              "˜": "&tilde;",
              "⋄": "&diamond;",
              ⅆ: "&dd;",
              𝔻: "&Dopf;",
              "¨": "&uml;",
              "⃜": "&DotDot;",
              "≐": "&esdot;",
              "⇓": "&dArr;",
              "⇐": "&lArr;",
              "⇔": "&iff;",
              "⟸": "&xlArr;",
              "⟺": "&xhArr;",
              "⟹": "&xrArr;",
              "⇒": "&rArr;",
              "⊨": "&vDash;",
              "⇑": "&uArr;",
              "⇕": "&vArr;",
              "∥": "&spar;",
              "↓": "&downarrow;",
              "⤓": "&DownArrowBar;",
              "⇵": "&duarr;",
              "̑": "&DownBreve;",
              "⥐": "&DownLeftRightVector;",
              "⥞": "&DownLeftTeeVector;",
              "↽": "&lhard;",
              "⥖": "&DownLeftVectorBar;",
              "⥟": "&DownRightTeeVector;",
              "⇁": "&rightharpoondown;",
              "⥗": "&DownRightVectorBar;",
              "⊤": "&top;",
              "↧": "&mapstodown;",
              𝒟: "&Dscr;",
              Đ: "&Dstrok;",
              Ŋ: "&ENG;",
              Ð: "&ETH;",
              É: "&Eacute;",
              Ě: "&Ecaron;",
              Ê: "&Ecirc;",
              Э: "&Ecy;",
              Ė: "&Edot;",
              𝔈: "&Efr;",
              È: "&Egrave;",
              "∈": "&isinv;",
              Ē: "&Emacr;",
              "◻": "&EmptySmallSquare;",
              "▫": "&EmptyVerySmallSquare;",
              Ę: "&Eogon;",
              𝔼: "&Eopf;",
              Ε: "&Epsilon;",
              "⩵": "&Equal;",
              "≂": "&esim;",
              "⇌": "&rlhar;",
              ℰ: "&expectation;",
              "⩳": "&Esim;",
              Η: "&Eta;",
              Ë: "&Euml;",
              "∃": "&exist;",
              ⅇ: "&exponentiale;",
              Ф: "&Fcy;",
              𝔉: "&Ffr;",
              "◼": "&FilledSmallSquare;",
              "▪": "&squf;",
              𝔽: "&Fopf;",
              "∀": "&forall;",
              ℱ: "&Fscr;",
              Ѓ: "&GJcy;",
              ">": "&gt;",
              Γ: "&Gamma;",
              Ϝ: "&Gammad;",
              Ğ: "&Gbreve;",
              Ģ: "&Gcedil;",
              Ĝ: "&Gcirc;",
              Г: "&Gcy;",
              Ġ: "&Gdot;",
              𝔊: "&Gfr;",
              "⋙": "&ggg;",
              𝔾: "&Gopf;",
              "≥": "&geq;",
              "⋛": "&gtreqless;",
              "≧": "&geqq;",
              "⪢": "&GreaterGreater;",
              "≷": "&gtrless;",
              "⩾": "&ges;",
              "≳": "&gtrsim;",
              𝒢: "&Gscr;",
              "≫": "&gg;",
              Ъ: "&HARDcy;",
              ˇ: "&caron;",
              "^": "&Hat;",
              Ĥ: "&Hcirc;",
              ℌ: "&Poincareplane;",
              ℋ: "&hamilt;",
              ℍ: "&quaternions;",
              "─": "&boxh;",
              Ħ: "&Hstrok;",
              "≏": "&bumpeq;",
              Е: "&IEcy;",
              Ĳ: "&IJlig;",
              Ё: "&IOcy;",
              Í: "&Iacute;",
              Î: "&Icirc;",
              И: "&Icy;",
              İ: "&Idot;",
              ℑ: "&imagpart;",
              Ì: "&Igrave;",
              Ī: "&Imacr;",
              ⅈ: "&ii;",
              "∬": "&Int;",
              "∫": "&int;",
              "⋂": "&xcap;",
              "⁣": "&ic;",
              "⁢": "&it;",
              Į: "&Iogon;",
              𝕀: "&Iopf;",
              Ι: "&Iota;",
              ℐ: "&imagline;",
              Ĩ: "&Itilde;",
              І: "&Iukcy;",
              Ï: "&Iuml;",
              Ĵ: "&Jcirc;",
              Й: "&Jcy;",
              𝔍: "&Jfr;",
              𝕁: "&Jopf;",
              𝒥: "&Jscr;",
              Ј: "&Jsercy;",
              Є: "&Jukcy;",
              Х: "&KHcy;",
              Ќ: "&KJcy;",
              Κ: "&Kappa;",
              Ķ: "&Kcedil;",
              К: "&Kcy;",
              𝔎: "&Kfr;",
              𝕂: "&Kopf;",
              𝒦: "&Kscr;",
              Љ: "&LJcy;",
              "<": "&lt;",
              Ĺ: "&Lacute;",
              Λ: "&Lambda;",
              "⟪": "&Lang;",
              ℒ: "&lagran;",
              "↞": "&twoheadleftarrow;",
              Ľ: "&Lcaron;",
              Ļ: "&Lcedil;",
              Л: "&Lcy;",
              "⟨": "&langle;",
              "←": "&slarr;",
              "⇤": "&larrb;",
              "⇆": "&lrarr;",
              "⌈": "&lceil;",
              "⟦": "&lobrk;",
              "⥡": "&LeftDownTeeVector;",
              "⇃": "&downharpoonleft;",
              "⥙": "&LeftDownVectorBar;",
              "⌊": "&lfloor;",
              "↔": "&leftrightarrow;",
              "⥎": "&LeftRightVector;",
              "⊣": "&dashv;",
              "↤": "&mapstoleft;",
              "⥚": "&LeftTeeVector;",
              "⊲": "&vltri;",
              "⧏": "&LeftTriangleBar;",
              "⊴": "&trianglelefteq;",
              "⥑": "&LeftUpDownVector;",
              "⥠": "&LeftUpTeeVector;",
              "↿": "&upharpoonleft;",
              "⥘": "&LeftUpVectorBar;",
              "↼": "&lharu;",
              "⥒": "&LeftVectorBar;",
              "⋚": "&lesseqgtr;",
              "≦": "&leqq;",
              "≶": "&lg;",
              "⪡": "&LessLess;",
              "⩽": "&les;",
              "≲": "&lsim;",
              𝔏: "&Lfr;",
              "⋘": "&Ll;",
              "⇚": "&lAarr;",
              Ŀ: "&Lmidot;",
              "⟵": "&xlarr;",
              "⟷": "&xharr;",
              "⟶": "&xrarr;",
              𝕃: "&Lopf;",
              "↙": "&swarrow;",
              "↘": "&searrow;",
              "↰": "&lsh;",
              Ł: "&Lstrok;",
              "≪": "&ll;",
              "⤅": "&Map;",
              М: "&Mcy;",
              " ": "&MediumSpace;",
              ℳ: "&phmmat;",
              𝔐: "&Mfr;",
              "∓": "&mp;",
              𝕄: "&Mopf;",
              Μ: "&Mu;",
              Њ: "&NJcy;",
              Ń: "&Nacute;",
              Ň: "&Ncaron;",
              Ņ: "&Ncedil;",
              Н: "&Ncy;",
              "​": "&ZeroWidthSpace;",
              "\n": "&NewLine;",
              𝔑: "&Nfr;",
              "⁠": "&NoBreak;",
              " ": "&nbsp;",
              ℕ: "&naturals;",
              "⫬": "&Not;",
              "≢": "&nequiv;",
              "≭": "&NotCupCap;",
              "∦": "&nspar;",
              "∉": "&notinva;",
              "≠": "&ne;",
              "≂̸": "&nesim;",
              "∄": "&nexists;",
              "≯": "&ngtr;",
              "≱": "&ngeq;",
              "≧̸": "&ngeqq;",
              "≫̸": "&nGtv;",
              "≹": "&ntgl;",
              "⩾̸": "&nges;",
              "≵": "&ngsim;",
              "≎̸": "&nbump;",
              "≏̸": "&nbumpe;",
              "⋪": "&ntriangleleft;",
              "⧏̸": "&NotLeftTriangleBar;",
              "⋬": "&ntrianglelefteq;",
              "≮": "&nlt;",
              "≰": "&nleq;",
              "≸": "&ntlg;",
              "≪̸": "&nLtv;",
              "⩽̸": "&nles;",
              "≴": "&nlsim;",
              "⪢̸": "&NotNestedGreaterGreater;",
              "⪡̸": "&NotNestedLessLess;",
              "⊀": "&nprec;",
              "⪯̸": "&npreceq;",
              "⋠": "&nprcue;",
              "∌": "&notniva;",
              "⋫": "&ntriangleright;",
              "⧐̸": "&NotRightTriangleBar;",
              "⋭": "&ntrianglerighteq;",
              "⊏̸": "&NotSquareSubset;",
              "⋢": "&nsqsube;",
              "⊐̸": "&NotSquareSuperset;",
              "⋣": "&nsqsupe;",
              "⊂⃒": "&vnsub;",
              "⊈": "&nsubseteq;",
              "⊁": "&nsucc;",
              "⪰̸": "&nsucceq;",
              "⋡": "&nsccue;",
              "≿̸": "&NotSucceedsTilde;",
              "⊃⃒": "&vnsup;",
              "⊉": "&nsupseteq;",
              "≁": "&nsim;",
              "≄": "&nsimeq;",
              "≇": "&ncong;",
              "≉": "&napprox;",
              "∤": "&nsmid;",
              𝒩: "&Nscr;",
              Ñ: "&Ntilde;",
              Ν: "&Nu;",
              Œ: "&OElig;",
              Ó: "&Oacute;",
              Ô: "&Ocirc;",
              О: "&Ocy;",
              Ő: "&Odblac;",
              𝔒: "&Ofr;",
              Ò: "&Ograve;",
              Ō: "&Omacr;",
              Ω: "&ohm;",
              Ο: "&Omicron;",
              𝕆: "&Oopf;",
              "“": "&ldquo;",
              "‘": "&lsquo;",
              "⩔": "&Or;",
              𝒪: "&Oscr;",
              Ø: "&Oslash;",
              Õ: "&Otilde;",
              "⨷": "&Otimes;",
              Ö: "&Ouml;",
              "‾": "&oline;",
              "⏞": "&OverBrace;",
              "⎴": "&tbrk;",
              "⏜": "&OverParenthesis;",
              "∂": "&part;",
              П: "&Pcy;",
              𝔓: "&Pfr;",
              Φ: "&Phi;",
              Π: "&Pi;",
              "±": "&pm;",
              ℙ: "&primes;",
              "⪻": "&Pr;",
              "≺": "&prec;",
              "⪯": "&preceq;",
              "≼": "&preccurlyeq;",
              "≾": "&prsim;",
              "″": "&Prime;",
              "∏": "&prod;",
              "∝": "&vprop;",
              𝒫: "&Pscr;",
              Ψ: "&Psi;",
              '"': "&quot;",
              𝔔: "&Qfr;",
              ℚ: "&rationals;",
              𝒬: "&Qscr;",
              "⤐": "&drbkarow;",
              "®": "&reg;",
              Ŕ: "&Racute;",
              "⟫": "&Rang;",
              "↠": "&twoheadrightarrow;",
              "⤖": "&Rarrtl;",
              Ř: "&Rcaron;",
              Ŗ: "&Rcedil;",
              Р: "&Rcy;",
              ℜ: "&realpart;",
              "∋": "&niv;",
              "⇋": "&lrhar;",
              "⥯": "&duhar;",
              Ρ: "&Rho;",
              "⟩": "&rangle;",
              "→": "&srarr;",
              "⇥": "&rarrb;",
              "⇄": "&rlarr;",
              "⌉": "&rceil;",
              "⟧": "&robrk;",
              "⥝": "&RightDownTeeVector;",
              "⇂": "&downharpoonright;",
              "⥕": "&RightDownVectorBar;",
              "⌋": "&rfloor;",
              "⊢": "&vdash;",
              "↦": "&mapsto;",
              "⥛": "&RightTeeVector;",
              "⊳": "&vrtri;",
              "⧐": "&RightTriangleBar;",
              "⊵": "&trianglerighteq;",
              "⥏": "&RightUpDownVector;",
              "⥜": "&RightUpTeeVector;",
              "↾": "&upharpoonright;",
              "⥔": "&RightUpVectorBar;",
              "⇀": "&rightharpoonup;",
              "⥓": "&RightVectorBar;",
              ℝ: "&reals;",
              "⥰": "&RoundImplies;",
              "⇛": "&rAarr;",
              ℛ: "&realine;",
              "↱": "&rsh;",
              "⧴": "&RuleDelayed;",
              Щ: "&SHCHcy;",
              Ш: "&SHcy;",
              Ь: "&SOFTcy;",
              Ś: "&Sacute;",
              "⪼": "&Sc;",
              Š: "&Scaron;",
              Ş: "&Scedil;",
              Ŝ: "&Scirc;",
              С: "&Scy;",
              𝔖: "&Sfr;",
              "↑": "&uparrow;",
              Σ: "&Sigma;",
              "∘": "&compfn;",
              𝕊: "&Sopf;",
              "√": "&radic;",
              "□": "&square;",
              "⊓": "&sqcap;",
              "⊏": "&sqsubset;",
              "⊑": "&sqsubseteq;",
              "⊐": "&sqsupset;",
              "⊒": "&sqsupseteq;",
              "⊔": "&sqcup;",
              𝒮: "&Sscr;",
              "⋆": "&sstarf;",
              "⋐": "&Subset;",
              "⊆": "&subseteq;",
              "≻": "&succ;",
              "⪰": "&succeq;",
              "≽": "&succcurlyeq;",
              "≿": "&succsim;",
              "∑": "&sum;",
              "⋑": "&Supset;",
              "⊃": "&supset;",
              "⊇": "&supseteq;",
              Þ: "&THORN;",
              "™": "&trade;",
              Ћ: "&TSHcy;",
              Ц: "&TScy;",
              "\t": "&Tab;",
              Τ: "&Tau;",
              Ť: "&Tcaron;",
              Ţ: "&Tcedil;",
              Т: "&Tcy;",
              𝔗: "&Tfr;",
              "∴": "&therefore;",
              Θ: "&Theta;",
              "  ": "&ThickSpace;",
              " ": "&thinsp;",
              "∼": "&thksim;",
              "≃": "&simeq;",
              "≅": "&cong;",
              "≈": "&thkap;",
              𝕋: "&Topf;",
              "⃛": "&tdot;",
              𝒯: "&Tscr;",
              Ŧ: "&Tstrok;",
              Ú: "&Uacute;",
              "↟": "&Uarr;",
              "⥉": "&Uarrocir;",
              Ў: "&Ubrcy;",
              Ŭ: "&Ubreve;",
              Û: "&Ucirc;",
              У: "&Ucy;",
              Ű: "&Udblac;",
              𝔘: "&Ufr;",
              Ù: "&Ugrave;",
              Ū: "&Umacr;",
              _: "&lowbar;",
              "⏟": "&UnderBrace;",
              "⎵": "&bbrk;",
              "⏝": "&UnderParenthesis;",
              "⋃": "&xcup;",
              "⊎": "&uplus;",
              Ų: "&Uogon;",
              𝕌: "&Uopf;",
              "⤒": "&UpArrowBar;",
              "⇅": "&udarr;",
              "↕": "&varr;",
              "⥮": "&udhar;",
              "⊥": "&perp;",
              "↥": "&mapstoup;",
              "↖": "&nwarrow;",
              "↗": "&nearrow;",
              ϒ: "&upsih;",
              Υ: "&Upsilon;",
              Ů: "&Uring;",
              𝒰: "&Uscr;",
              Ũ: "&Utilde;",
              Ü: "&Uuml;",
              "⊫": "&VDash;",
              "⫫": "&Vbar;",
              В: "&Vcy;",
              "⊩": "&Vdash;",
              "⫦": "&Vdashl;",
              "⋁": "&xvee;",
              "‖": "&Vert;",
              "∣": "&smid;",
              "|": "&vert;",
              "❘": "&VerticalSeparator;",
              "≀": "&wreath;",
              " ": "&hairsp;",
              𝔙: "&Vfr;",
              𝕍: "&Vopf;",
              𝒱: "&Vscr;",
              "⊪": "&Vvdash;",
              Ŵ: "&Wcirc;",
              "⋀": "&xwedge;",
              𝔚: "&Wfr;",
              𝕎: "&Wopf;",
              𝒲: "&Wscr;",
              𝔛: "&Xfr;",
              Ξ: "&Xi;",
              𝕏: "&Xopf;",
              𝒳: "&Xscr;",
              Я: "&YAcy;",
              Ї: "&YIcy;",
              Ю: "&YUcy;",
              Ý: "&Yacute;",
              Ŷ: "&Ycirc;",
              Ы: "&Ycy;",
              𝔜: "&Yfr;",
              𝕐: "&Yopf;",
              𝒴: "&Yscr;",
              Ÿ: "&Yuml;",
              Ж: "&ZHcy;",
              Ź: "&Zacute;",
              Ž: "&Zcaron;",
              З: "&Zcy;",
              Ż: "&Zdot;",
              Ζ: "&Zeta;",
              ℨ: "&zeetrf;",
              ℤ: "&integers;",
              𝒵: "&Zscr;",
              á: "&aacute;",
              ă: "&abreve;",
              "∾": "&mstpos;",
              "∾̳": "&acE;",
              "∿": "&acd;",
              â: "&acirc;",
              а: "&acy;",
              æ: "&aelig;",
              𝔞: "&afr;",
              à: "&agrave;",
              ℵ: "&aleph;",
              α: "&alpha;",
              ā: "&amacr;",
              "⨿": "&amalg;",
              "∧": "&wedge;",
              "⩕": "&andand;",
              "⩜": "&andd;",
              "⩘": "&andslope;",
              "⩚": "&andv;",
              "∠": "&angle;",
              "⦤": "&ange;",
              "∡": "&measuredangle;",
              "⦨": "&angmsdaa;",
              "⦩": "&angmsdab;",
              "⦪": "&angmsdac;",
              "⦫": "&angmsdad;",
              "⦬": "&angmsdae;",
              "⦭": "&angmsdaf;",
              "⦮": "&angmsdag;",
              "⦯": "&angmsdah;",
              "∟": "&angrt;",
              "⊾": "&angrtvb;",
              "⦝": "&angrtvbd;",
              "∢": "&angsph;",
              "⍼": "&angzarr;",
              ą: "&aogon;",
              𝕒: "&aopf;",
              "⩰": "&apE;",
              "⩯": "&apacir;",
              "≊": "&approxeq;",
              "≋": "&apid;",
              "'": "&apos;",
              å: "&aring;",
              𝒶: "&ascr;",
              "*": "&midast;",
              ã: "&atilde;",
              ä: "&auml;",
              "⨑": "&awint;",
              "⫭": "&bNot;",
              "≌": "&bcong;",
              "϶": "&bepsi;",
              "‵": "&bprime;",
              "∽": "&bsim;",
              "⋍": "&bsime;",
              "⊽": "&barvee;",
              "⌅": "&barwedge;",
              "⎶": "&bbrktbrk;",
              б: "&bcy;",
              "„": "&ldquor;",
              "⦰": "&bemptyv;",
              β: "&beta;",
              ℶ: "&beth;",
              "≬": "&twixt;",
              𝔟: "&bfr;",
              "◯": "&xcirc;",
              "⨀": "&xodot;",
              "⨁": "&xoplus;",
              "⨂": "&xotime;",
              "⨆": "&xsqcup;",
              "★": "&starf;",
              "▽": "&xdtri;",
              "△": "&xutri;",
              "⨄": "&xuplus;",
              "⤍": "&rbarr;",
              "⧫": "&lozf;",
              "▴": "&utrif;",
              "▾": "&dtrif;",
              "◂": "&ltrif;",
              "▸": "&rtrif;",
              "␣": "&blank;",
              "▒": "&blk12;",
              "░": "&blk14;",
              "▓": "&blk34;",
              "█": "&block;",
              "=⃥": "&bne;",
              "≡⃥": "&bnequiv;",
              "⌐": "&bnot;",
              𝕓: "&bopf;",
              "⋈": "&bowtie;",
              "╗": "&boxDL;",
              "╔": "&boxDR;",
              "╖": "&boxDl;",
              "╓": "&boxDr;",
              "═": "&boxH;",
              "╦": "&boxHD;",
              "╩": "&boxHU;",
              "╤": "&boxHd;",
              "╧": "&boxHu;",
              "╝": "&boxUL;",
              "╚": "&boxUR;",
              "╜": "&boxUl;",
              "╙": "&boxUr;",
              "║": "&boxV;",
              "╬": "&boxVH;",
              "╣": "&boxVL;",
              "╠": "&boxVR;",
              "╫": "&boxVh;",
              "╢": "&boxVl;",
              "╟": "&boxVr;",
              "⧉": "&boxbox;",
              "╕": "&boxdL;",
              "╒": "&boxdR;",
              "┐": "&boxdl;",
              "┌": "&boxdr;",
              "╥": "&boxhD;",
              "╨": "&boxhU;",
              "┬": "&boxhd;",
              "┴": "&boxhu;",
              "⊟": "&minusb;",
              "⊞": "&plusb;",
              "⊠": "&timesb;",
              "╛": "&boxuL;",
              "╘": "&boxuR;",
              "┘": "&boxul;",
              "└": "&boxur;",
              "│": "&boxv;",
              "╪": "&boxvH;",
              "╡": "&boxvL;",
              "╞": "&boxvR;",
              "┼": "&boxvh;",
              "┤": "&boxvl;",
              "├": "&boxvr;",
              "¦": "&brvbar;",
              𝒷: "&bscr;",
              "⁏": "&bsemi;",
              "\\": "&bsol;",
              "⧅": "&bsolb;",
              "⟈": "&bsolhsub;",
              "•": "&bullet;",
              "⪮": "&bumpE;",
              ć: "&cacute;",
              "∩": "&cap;",
              "⩄": "&capand;",
              "⩉": "&capbrcup;",
              "⩋": "&capcap;",
              "⩇": "&capcup;",
              "⩀": "&capdot;",
              "∩︀": "&caps;",
              "⁁": "&caret;",
              "⩍": "&ccaps;",
              č: "&ccaron;",
              ç: "&ccedil;",
              ĉ: "&ccirc;",
              "⩌": "&ccups;",
              "⩐": "&ccupssm;",
              ċ: "&cdot;",
              "⦲": "&cemptyv;",
              "¢": "&cent;",
              𝔠: "&cfr;",
              ч: "&chcy;",
              "✓": "&checkmark;",
              χ: "&chi;",
              "○": "&cir;",
              "⧃": "&cirE;",
              ˆ: "&circ;",
              "≗": "&cire;",
              "↺": "&olarr;",
              "↻": "&orarr;",
              "Ⓢ": "&oS;",
              "⊛": "&oast;",
              "⊚": "&ocir;",
              "⊝": "&odash;",
              "⨐": "&cirfnint;",
              "⫯": "&cirmid;",
              "⧂": "&cirscir;",
              "♣": "&clubsuit;",
              ":": "&colon;",
              ",": "&comma;",
              "@": "&commat;",
              "∁": "&complement;",
              "⩭": "&congdot;",
              𝕔: "&copf;",
              "℗": "&copysr;",
              "↵": "&crarr;",
              "✗": "&cross;",
              𝒸: "&cscr;",
              "⫏": "&csub;",
              "⫑": "&csube;",
              "⫐": "&csup;",
              "⫒": "&csupe;",
              "⋯": "&ctdot;",
              "⤸": "&cudarrl;",
              "⤵": "&cudarrr;",
              "⋞": "&curlyeqprec;",
              "⋟": "&curlyeqsucc;",
              "↶": "&curvearrowleft;",
              "⤽": "&cularrp;",
              "∪": "&cup;",
              "⩈": "&cupbrcap;",
              "⩆": "&cupcap;",
              "⩊": "&cupcup;",
              "⊍": "&cupdot;",
              "⩅": "&cupor;",
              "∪︀": "&cups;",
              "↷": "&curvearrowright;",
              "⤼": "&curarrm;",
              "⋎": "&cuvee;",
              "⋏": "&cuwed;",
              "¤": "&curren;",
              "∱": "&cwint;",
              "⌭": "&cylcty;",
              "⥥": "&dHar;",
              "†": "&dagger;",
              ℸ: "&daleth;",
              "‐": "&hyphen;",
              "⤏": "&rBarr;",
              ď: "&dcaron;",
              д: "&dcy;",
              "⇊": "&downdownarrows;",
              "⩷": "&eDDot;",
              "°": "&deg;",
              δ: "&delta;",
              "⦱": "&demptyv;",
              "⥿": "&dfisht;",
              𝔡: "&dfr;",
              "♦": "&diams;",
              ϝ: "&gammad;",
              "⋲": "&disin;",
              "÷": "&divide;",
              "⋇": "&divonx;",
              ђ: "&djcy;",
              "⌞": "&llcorner;",
              "⌍": "&dlcrop;",
              $: "&dollar;",
              𝕕: "&dopf;",
              "≑": "&eDot;",
              "∸": "&minusd;",
              "∔": "&plusdo;",
              "⊡": "&sdotb;",
              "⌟": "&lrcorner;",
              "⌌": "&drcrop;",
              𝒹: "&dscr;",
              ѕ: "&dscy;",
              "⧶": "&dsol;",
              đ: "&dstrok;",
              "⋱": "&dtdot;",
              "▿": "&triangledown;",
              "⦦": "&dwangle;",
              џ: "&dzcy;",
              "⟿": "&dzigrarr;",
              é: "&eacute;",
              "⩮": "&easter;",
              ě: "&ecaron;",
              "≖": "&eqcirc;",
              ê: "&ecirc;",
              "≕": "&eqcolon;",
              э: "&ecy;",
              ė: "&edot;",
              "≒": "&fallingdotseq;",
              𝔢: "&efr;",
              "⪚": "&eg;",
              è: "&egrave;",
              "⪖": "&eqslantgtr;",
              "⪘": "&egsdot;",
              "⪙": "&el;",
              "⏧": "&elinters;",
              ℓ: "&ell;",
              "⪕": "&eqslantless;",
              "⪗": "&elsdot;",
              ē: "&emacr;",
              "∅": "&varnothing;",
              " ": "&emsp13;",
              " ": "&emsp14;",
              " ": "&emsp;",
              ŋ: "&eng;",
              " ": "&ensp;",
              ę: "&eogon;",
              𝕖: "&eopf;",
              "⋕": "&epar;",
              "⧣": "&eparsl;",
              "⩱": "&eplus;",
              ε: "&epsilon;",
              ϵ: "&varepsilon;",
              "=": "&equals;",
              "≟": "&questeq;",
              "⩸": "&equivDD;",
              "⧥": "&eqvparsl;",
              "≓": "&risingdotseq;",
              "⥱": "&erarr;",
              ℯ: "&escr;",
              η: "&eta;",
              ð: "&eth;",
              ë: "&euml;",
              "€": "&euro;",
              "!": "&excl;",
              ф: "&fcy;",
              "♀": "&female;",
              ﬃ: "&ffilig;",
              ﬀ: "&fflig;",
              ﬄ: "&ffllig;",
              𝔣: "&ffr;",
              ﬁ: "&filig;",
              fj: "&fjlig;",
              "♭": "&flat;",
              ﬂ: "&fllig;",
              "▱": "&fltns;",
              ƒ: "&fnof;",
              𝕗: "&fopf;",
              "⋔": "&pitchfork;",
              "⫙": "&forkv;",
              "⨍": "&fpartint;",
              "½": "&half;",
              "⅓": "&frac13;",
              "¼": "&frac14;",
              "⅕": "&frac15;",
              "⅙": "&frac16;",
              "⅛": "&frac18;",
              "⅔": "&frac23;",
              "⅖": "&frac25;",
              "¾": "&frac34;",
              "⅗": "&frac35;",
              "⅜": "&frac38;",
              "⅘": "&frac45;",
              "⅚": "&frac56;",
              "⅝": "&frac58;",
              "⅞": "&frac78;",
              "⁄": "&frasl;",
              "⌢": "&sfrown;",
              𝒻: "&fscr;",
              "⪌": "&gtreqqless;",
              ǵ: "&gacute;",
              γ: "&gamma;",
              "⪆": "&gtrapprox;",
              ğ: "&gbreve;",
              ĝ: "&gcirc;",
              г: "&gcy;",
              ġ: "&gdot;",
              "⪩": "&gescc;",
              "⪀": "&gesdot;",
              "⪂": "&gesdoto;",
              "⪄": "&gesdotol;",
              "⋛︀": "&gesl;",
              "⪔": "&gesles;",
              𝔤: "&gfr;",
              ℷ: "&gimel;",
              ѓ: "&gjcy;",
              "⪒": "&glE;",
              "⪥": "&gla;",
              "⪤": "&glj;",
              "≩": "&gneqq;",
              "⪊": "&gnapprox;",
              "⪈": "&gneq;",
              "⋧": "&gnsim;",
              𝕘: "&gopf;",
              ℊ: "&gscr;",
              "⪎": "&gsime;",
              "⪐": "&gsiml;",
              "⪧": "&gtcc;",
              "⩺": "&gtcir;",
              "⋗": "&gtrdot;",
              "⦕": "&gtlPar;",
              "⩼": "&gtquest;",
              "⥸": "&gtrarr;",
              "≩︀": "&gvnE;",
              ъ: "&hardcy;",
              "⥈": "&harrcir;",
              "↭": "&leftrightsquigarrow;",
              ℏ: "&plankv;",
              ĥ: "&hcirc;",
              "♥": "&heartsuit;",
              "…": "&mldr;",
              "⊹": "&hercon;",
              𝔥: "&hfr;",
              "⤥": "&searhk;",
              "⤦": "&swarhk;",
              "⇿": "&hoarr;",
              "∻": "&homtht;",
              "↩": "&larrhk;",
              "↪": "&rarrhk;",
              𝕙: "&hopf;",
              "―": "&horbar;",
              𝒽: "&hscr;",
              ħ: "&hstrok;",
              "⁃": "&hybull;",
              í: "&iacute;",
              î: "&icirc;",
              и: "&icy;",
              е: "&iecy;",
              "¡": "&iexcl;",
              𝔦: "&ifr;",
              ì: "&igrave;",
              "⨌": "&qint;",
              "∭": "&tint;",
              "⧜": "&iinfin;",
              "℩": "&iiota;",
              ĳ: "&ijlig;",
              ī: "&imacr;",
              ı: "&inodot;",
              "⊷": "&imof;",
              Ƶ: "&imped;",
              "℅": "&incare;",
              "∞": "&infin;",
              "⧝": "&infintie;",
              "⊺": "&intercal;",
              "⨗": "&intlarhk;",
              "⨼": "&iprod;",
              ё: "&iocy;",
              į: "&iogon;",
              𝕚: "&iopf;",
              ι: "&iota;",
              "¿": "&iquest;",
              𝒾: "&iscr;",
              "⋹": "&isinE;",
              "⋵": "&isindot;",
              "⋴": "&isins;",
              "⋳": "&isinsv;",
              ĩ: "&itilde;",
              і: "&iukcy;",
              ï: "&iuml;",
              ĵ: "&jcirc;",
              й: "&jcy;",
              𝔧: "&jfr;",
              ȷ: "&jmath;",
              𝕛: "&jopf;",
              𝒿: "&jscr;",
              ј: "&jsercy;",
              є: "&jukcy;",
              κ: "&kappa;",
              ϰ: "&varkappa;",
              ķ: "&kcedil;",
              к: "&kcy;",
              𝔨: "&kfr;",
              ĸ: "&kgreen;",
              х: "&khcy;",
              ќ: "&kjcy;",
              𝕜: "&kopf;",
              𝓀: "&kscr;",
              "⤛": "&lAtail;",
              "⤎": "&lBarr;",
              "⪋": "&lesseqqgtr;",
              "⥢": "&lHar;",
              ĺ: "&lacute;",
              "⦴": "&laemptyv;",
              λ: "&lambda;",
              "⦑": "&langd;",
              "⪅": "&lessapprox;",
              "«": "&laquo;",
              "⤟": "&larrbfs;",
              "⤝": "&larrfs;",
              "↫": "&looparrowleft;",
              "⤹": "&larrpl;",
              "⥳": "&larrsim;",
              "↢": "&leftarrowtail;",
              "⪫": "&lat;",
              "⤙": "&latail;",
              "⪭": "&late;",
              "⪭︀": "&lates;",
              "⤌": "&lbarr;",
              "❲": "&lbbrk;",
              "{": "&lcub;",
              "[": "&lsqb;",
              "⦋": "&lbrke;",
              "⦏": "&lbrksld;",
              "⦍": "&lbrkslu;",
              ľ: "&lcaron;",
              ļ: "&lcedil;",
              л: "&lcy;",
              "⤶": "&ldca;",
              "⥧": "&ldrdhar;",
              "⥋": "&ldrushar;",
              "↲": "&ldsh;",
              "≤": "&leq;",
              "⇇": "&llarr;",
              "⋋": "&lthree;",
              "⪨": "&lescc;",
              "⩿": "&lesdot;",
              "⪁": "&lesdoto;",
              "⪃": "&lesdotor;",
              "⋚︀": "&lesg;",
              "⪓": "&lesges;",
              "⋖": "&ltdot;",
              "⥼": "&lfisht;",
              𝔩: "&lfr;",
              "⪑": "&lgE;",
              "⥪": "&lharul;",
              "▄": "&lhblk;",
              љ: "&ljcy;",
              "⥫": "&llhard;",
              "◺": "&lltri;",
              ŀ: "&lmidot;",
              "⎰": "&lmoustache;",
              "≨": "&lneqq;",
              "⪉": "&lnapprox;",
              "⪇": "&lneq;",
              "⋦": "&lnsim;",
              "⟬": "&loang;",
              "⇽": "&loarr;",
              "⟼": "&xmap;",
              "↬": "&rarrlp;",
              "⦅": "&lopar;",
              𝕝: "&lopf;",
              "⨭": "&loplus;",
              "⨴": "&lotimes;",
              "∗": "&lowast;",
              "◊": "&lozenge;",
              "(": "&lpar;",
              "⦓": "&lparlt;",
              "⥭": "&lrhard;",
              "‎": "&lrm;",
              "⊿": "&lrtri;",
              "‹": "&lsaquo;",
              𝓁: "&lscr;",
              "⪍": "&lsime;",
              "⪏": "&lsimg;",
              "‚": "&sbquo;",
              ł: "&lstrok;",
              "⪦": "&ltcc;",
              "⩹": "&ltcir;",
              "⋉": "&ltimes;",
              "⥶": "&ltlarr;",
              "⩻": "&ltquest;",
              "⦖": "&ltrPar;",
              "◃": "&triangleleft;",
              "⥊": "&lurdshar;",
              "⥦": "&luruhar;",
              "≨︀": "&lvnE;",
              "∺": "&mDDot;",
              "¯": "&strns;",
              "♂": "&male;",
              "✠": "&maltese;",
              "▮": "&marker;",
              "⨩": "&mcomma;",
              м: "&mcy;",
              "—": "&mdash;",
              𝔪: "&mfr;",
              "℧": "&mho;",
              µ: "&micro;",
              "⫰": "&midcir;",
              "−": "&minus;",
              "⨪": "&minusdu;",
              "⫛": "&mlcp;",
              "⊧": "&models;",
              𝕞: "&mopf;",
              𝓂: "&mscr;",
              μ: "&mu;",
              "⊸": "&mumap;",
              "⋙̸": "&nGg;",
              "≫⃒": "&nGt;",
              "⇍": "&nlArr;",
              "⇎": "&nhArr;",
              "⋘̸": "&nLl;",
              "≪⃒": "&nLt;",
              "⇏": "&nrArr;",
              "⊯": "&nVDash;",
              "⊮": "&nVdash;",
              ń: "&nacute;",
              "∠⃒": "&nang;",
              "⩰̸": "&napE;",
              "≋̸": "&napid;",
              ŉ: "&napos;",
              "♮": "&natural;",
              "⩃": "&ncap;",
              ň: "&ncaron;",
              ņ: "&ncedil;",
              "⩭̸": "&ncongdot;",
              "⩂": "&ncup;",
              н: "&ncy;",
              "–": "&ndash;",
              "⇗": "&neArr;",
              "⤤": "&nearhk;",
              "≐̸": "&nedot;",
              "⤨": "&toea;",
              𝔫: "&nfr;",
              "↮": "&nleftrightarrow;",
              "⫲": "&nhpar;",
              "⋼": "&nis;",
              "⋺": "&nisd;",
              њ: "&njcy;",
              "≦̸": "&nleqq;",
              "↚": "&nleftarrow;",
              "‥": "&nldr;",
              𝕟: "&nopf;",
              "¬": "&not;",
              "⋹̸": "&notinE;",
              "⋵̸": "&notindot;",
              "⋷": "&notinvb;",
              "⋶": "&notinvc;",
              "⋾": "&notnivb;",
              "⋽": "&notnivc;",
              "⫽⃥": "&nparsl;",
              "∂̸": "&npart;",
              "⨔": "&npolint;",
              "↛": "&nrightarrow;",
              "⤳̸": "&nrarrc;",
              "↝̸": "&nrarrw;",
              𝓃: "&nscr;",
              "⊄": "&nsub;",
              "⫅̸": "&nsubseteqq;",
              "⊅": "&nsup;",
              "⫆̸": "&nsupseteqq;",
              ñ: "&ntilde;",
              ν: "&nu;",
              "#": "&num;",
              "№": "&numero;",
              " ": "&numsp;",
              "⊭": "&nvDash;",
              "⤄": "&nvHarr;",
              "≍⃒": "&nvap;",
              "⊬": "&nvdash;",
              "≥⃒": "&nvge;",
              ">⃒": "&nvgt;",
              "⧞": "&nvinfin;",
              "⤂": "&nvlArr;",
              "≤⃒": "&nvle;",
              "<⃒": "&nvlt;",
              "⊴⃒": "&nvltrie;",
              "⤃": "&nvrArr;",
              "⊵⃒": "&nvrtrie;",
              "∼⃒": "&nvsim;",
              "⇖": "&nwArr;",
              "⤣": "&nwarhk;",
              "⤧": "&nwnear;",
              ó: "&oacute;",
              ô: "&ocirc;",
              о: "&ocy;",
              ő: "&odblac;",
              "⨸": "&odiv;",
              "⦼": "&odsold;",
              œ: "&oelig;",
              "⦿": "&ofcir;",
              𝔬: "&ofr;",
              "˛": "&ogon;",
              ò: "&ograve;",
              "⧁": "&ogt;",
              "⦵": "&ohbar;",
              "⦾": "&olcir;",
              "⦻": "&olcross;",
              "⧀": "&olt;",
              ō: "&omacr;",
              ω: "&omega;",
              ο: "&omicron;",
              "⦶": "&omid;",
              𝕠: "&oopf;",
              "⦷": "&opar;",
              "⦹": "&operp;",
              "∨": "&vee;",
              "⩝": "&ord;",
              ℴ: "&oscr;",
              ª: "&ordf;",
              º: "&ordm;",
              "⊶": "&origof;",
              "⩖": "&oror;",
              "⩗": "&orslope;",
              "⩛": "&orv;",
              ø: "&oslash;",
              "⊘": "&osol;",
              õ: "&otilde;",
              "⨶": "&otimesas;",
              ö: "&ouml;",
              "⌽": "&ovbar;",
              "¶": "&para;",
              "⫳": "&parsim;",
              "⫽": "&parsl;",
              п: "&pcy;",
              "%": "&percnt;",
              ".": "&period;",
              "‰": "&permil;",
              "‱": "&pertenk;",
              𝔭: "&pfr;",
              φ: "&phi;",
              ϕ: "&varphi;",
              "☎": "&phone;",
              π: "&pi;",
              ϖ: "&varpi;",
              ℎ: "&planckh;",
              "+": "&plus;",
              "⨣": "&plusacir;",
              "⨢": "&pluscir;",
              "⨥": "&plusdu;",
              "⩲": "&pluse;",
              "⨦": "&plussim;",
              "⨧": "&plustwo;",
              "⨕": "&pointint;",
              𝕡: "&popf;",
              "£": "&pound;",
              "⪳": "&prE;",
              "⪷": "&precapprox;",
              "⪹": "&prnap;",
              "⪵": "&prnE;",
              "⋨": "&prnsim;",
              "′": "&prime;",
              "⌮": "&profalar;",
              "⌒": "&profline;",
              "⌓": "&profsurf;",
              "⊰": "&prurel;",
              𝓅: "&pscr;",
              ψ: "&psi;",
              " ": "&puncsp;",
              𝔮: "&qfr;",
              𝕢: "&qopf;",
              "⁗": "&qprime;",
              𝓆: "&qscr;",
              "⨖": "&quatint;",
              "?": "&quest;",
              "⤜": "&rAtail;",
              "⥤": "&rHar;",
              "∽̱": "&race;",
              ŕ: "&racute;",
              "⦳": "&raemptyv;",
              "⦒": "&rangd;",
              "⦥": "&range;",
              "»": "&raquo;",
              "⥵": "&rarrap;",
              "⤠": "&rarrbfs;",
              "⤳": "&rarrc;",
              "⤞": "&rarrfs;",
              "⥅": "&rarrpl;",
              "⥴": "&rarrsim;",
              "↣": "&rightarrowtail;",
              "↝": "&rightsquigarrow;",
              "⤚": "&ratail;",
              "∶": "&ratio;",
              "❳": "&rbbrk;",
              "}": "&rcub;",
              "]": "&rsqb;",
              "⦌": "&rbrke;",
              "⦎": "&rbrksld;",
              "⦐": "&rbrkslu;",
              ř: "&rcaron;",
              ŗ: "&rcedil;",
              р: "&rcy;",
              "⤷": "&rdca;",
              "⥩": "&rdldhar;",
              "↳": "&rdsh;",
              "▭": "&rect;",
              "⥽": "&rfisht;",
              𝔯: "&rfr;",
              "⥬": "&rharul;",
              ρ: "&rho;",
              ϱ: "&varrho;",
              "⇉": "&rrarr;",
              "⋌": "&rthree;",
              "˚": "&ring;",
              "‏": "&rlm;",
              "⎱": "&rmoustache;",
              "⫮": "&rnmid;",
              "⟭": "&roang;",
              "⇾": "&roarr;",
              "⦆": "&ropar;",
              𝕣: "&ropf;",
              "⨮": "&roplus;",
              "⨵": "&rotimes;",
              ")": "&rpar;",
              "⦔": "&rpargt;",
              "⨒": "&rppolint;",
              "›": "&rsaquo;",
              𝓇: "&rscr;",
              "⋊": "&rtimes;",
              "▹": "&triangleright;",
              "⧎": "&rtriltri;",
              "⥨": "&ruluhar;",
              "℞": "&rx;",
              ś: "&sacute;",
              "⪴": "&scE;",
              "⪸": "&succapprox;",
              š: "&scaron;",
              ş: "&scedil;",
              ŝ: "&scirc;",
              "⪶": "&succneqq;",
              "⪺": "&succnapprox;",
              "⋩": "&succnsim;",
              "⨓": "&scpolint;",
              с: "&scy;",
              "⋅": "&sdot;",
              "⩦": "&sdote;",
              "⇘": "&seArr;",
              "§": "&sect;",
              ";": "&semi;",
              "⤩": "&tosa;",
              "✶": "&sext;",
              𝔰: "&sfr;",
              "♯": "&sharp;",
              щ: "&shchcy;",
              ш: "&shcy;",
              "­": "&shy;",
              σ: "&sigma;",
              ς: "&varsigma;",
              "⩪": "&simdot;",
              "⪞": "&simg;",
              "⪠": "&simgE;",
              "⪝": "&siml;",
              "⪟": "&simlE;",
              "≆": "&simne;",
              "⨤": "&simplus;",
              "⥲": "&simrarr;",
              "⨳": "&smashp;",
              "⧤": "&smeparsl;",
              "⌣": "&ssmile;",
              "⪪": "&smt;",
              "⪬": "&smte;",
              "⪬︀": "&smtes;",
              ь: "&softcy;",
              "/": "&sol;",
              "⧄": "&solb;",
              "⌿": "&solbar;",
              𝕤: "&sopf;",
              "♠": "&spadesuit;",
              "⊓︀": "&sqcaps;",
              "⊔︀": "&sqcups;",
              𝓈: "&sscr;",
              "☆": "&star;",
              "⊂": "&subset;",
              "⫅": "&subseteqq;",
              "⪽": "&subdot;",
              "⫃": "&subedot;",
              "⫁": "&submult;",
              "⫋": "&subsetneqq;",
              "⊊": "&subsetneq;",
              "⪿": "&subplus;",
              "⥹": "&subrarr;",
              "⫇": "&subsim;",
              "⫕": "&subsub;",
              "⫓": "&subsup;",
              "♪": "&sung;",
              "¹": "&sup1;",
              "²": "&sup2;",
              "³": "&sup3;",
              "⫆": "&supseteqq;",
              "⪾": "&supdot;",
              "⫘": "&supdsub;",
              "⫄": "&supedot;",
              "⟉": "&suphsol;",
              "⫗": "&suphsub;",
              "⥻": "&suplarr;",
              "⫂": "&supmult;",
              "⫌": "&supsetneqq;",
              "⊋": "&supsetneq;",
              "⫀": "&supplus;",
              "⫈": "&supsim;",
              "⫔": "&supsub;",
              "⫖": "&supsup;",
              "⇙": "&swArr;",
              "⤪": "&swnwar;",
              ß: "&szlig;",
              "⌖": "&target;",
              τ: "&tau;",
              ť: "&tcaron;",
              ţ: "&tcedil;",
              т: "&tcy;",
              "⌕": "&telrec;",
              𝔱: "&tfr;",
              θ: "&theta;",
              ϑ: "&vartheta;",
              þ: "&thorn;",
              "×": "&times;",
              "⨱": "&timesbar;",
              "⨰": "&timesd;",
              "⌶": "&topbot;",
              "⫱": "&topcir;",
              𝕥: "&topf;",
              "⫚": "&topfork;",
              "‴": "&tprime;",
              "▵": "&utri;",
              "≜": "&trie;",
              "◬": "&tridot;",
              "⨺": "&triminus;",
              "⨹": "&triplus;",
              "⧍": "&trisb;",
              "⨻": "&tritime;",
              "⏢": "&trpezium;",
              𝓉: "&tscr;",
              ц: "&tscy;",
              ћ: "&tshcy;",
              ŧ: "&tstrok;",
              "⥣": "&uHar;",
              ú: "&uacute;",
              ў: "&ubrcy;",
              ŭ: "&ubreve;",
              û: "&ucirc;",
              у: "&ucy;",
              ű: "&udblac;",
              "⥾": "&ufisht;",
              𝔲: "&ufr;",
              ù: "&ugrave;",
              "▀": "&uhblk;",
              "⌜": "&ulcorner;",
              "⌏": "&ulcrop;",
              "◸": "&ultri;",
              ū: "&umacr;",
              ų: "&uogon;",
              𝕦: "&uopf;",
              υ: "&upsilon;",
              "⇈": "&uuarr;",
              "⌝": "&urcorner;",
              "⌎": "&urcrop;",
              ů: "&uring;",
              "◹": "&urtri;",
              𝓊: "&uscr;",
              "⋰": "&utdot;",
              ũ: "&utilde;",
              ü: "&uuml;",
              "⦧": "&uwangle;",
              "⫨": "&vBar;",
              "⫩": "&vBarv;",
              "⦜": "&vangrt;",
              "⊊︀": "&vsubne;",
              "⫋︀": "&vsubnE;",
              "⊋︀": "&vsupne;",
              "⫌︀": "&vsupnE;",
              в: "&vcy;",
              "⊻": "&veebar;",
              "≚": "&veeeq;",
              "⋮": "&vellip;",
              𝔳: "&vfr;",
              𝕧: "&vopf;",
              𝓋: "&vscr;",
              "⦚": "&vzigzag;",
              ŵ: "&wcirc;",
              "⩟": "&wedbar;",
              "≙": "&wedgeq;",
              ℘: "&wp;",
              𝔴: "&wfr;",
              𝕨: "&wopf;",
              𝓌: "&wscr;",
              𝔵: "&xfr;",
              ξ: "&xi;",
              "⋻": "&xnis;",
              𝕩: "&xopf;",
              𝓍: "&xscr;",
              ý: "&yacute;",
              я: "&yacy;",
              ŷ: "&ycirc;",
              ы: "&ycy;",
              "¥": "&yen;",
              𝔶: "&yfr;",
              ї: "&yicy;",
              𝕪: "&yopf;",
              𝓎: "&yscr;",
              ю: "&yucy;",
              ÿ: "&yuml;",
              ź: "&zacute;",
              ž: "&zcaron;",
              з: "&zcy;",
              ż: "&zdot;",
              ζ: "&zeta;",
              𝔷: "&zfr;",
              ж: "&zhcy;",
              "⇝": "&zigrarr;",
              𝕫: "&zopf;",
              𝓏: "&zscr;",
              "‍": "&zwj;",
              "‌": "&zwnj;"
            }
          }
        };
      },
      79103: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.numericUnicodeMap = {
          0: 65533,
          128: 8364,
          130: 8218,
          131: 402,
          132: 8222,
          133: 8230,
          134: 8224,
          135: 8225,
          136: 710,
          137: 8240,
          138: 352,
          139: 8249,
          140: 338,
          142: 381,
          145: 8216,
          146: 8217,
          147: 8220,
          148: 8221,
          149: 8226,
          150: 8211,
          151: 8212,
          152: 732,
          153: 8482,
          154: 353,
          155: 8250,
          156: 339,
          158: 382,
          159: 376
        };
      },
      59339: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.fromCodePoint = String.fromCodePoint || function (e) {
          return String.fromCharCode(Math.floor((e - 65536) / 1024) + 55296, (e - 65536) % 1024 + 56320);
        }, t.getCodePoint = String.prototype.codePointAt ? function (e, t) {
          return e.codePointAt(t);
        } : function (e, t) {
          return 1024 * (e.charCodeAt(t) - 55296) + e.charCodeAt(t + 1) - 56320 + 65536;
        }, t.highSurrogateFrom = 55296, t.highSurrogateTo = 56319;
      },
      23151: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          Editor: () => je,
          Element: () => Pe,
          Location: () => Be,
          Node: () => Te,
          Operation: () => Fe,
          Path: () => fe,
          PathRef: () => oe,
          Point: () => Ke,
          PointRef: () => ie,
          Range: () => Ee,
          RangeRef: () => ae,
          Scrubber: () => He,
          Span: () => Ne,
          Text: () => Ye,
          Transforms: () => At,
          above: () => Mt,
          addMark: () => Bt,
          after: () => Vt,
          apply: () => zt,
          before: () => Ht,
          collapse: () => Qn,
          createEditor: () => Dr,
          deleteBackward: () => Ut,
          deleteForward: () => Zt,
          deleteFragment: () => $t,
          deleteText: () => Yn,
          deselect: () => Jn,
          edges: () => Gt,
          elementReadOnly: () => Xt,
          end: () => Qt,
          first: () => Jt,
          fragment: () => en,
          getDirtyPaths: () => Tt,
          getFragment: () => Ot,
          getVoid: () => rn,
          hasBlocks: () => on,
          hasInlines: () => an,
          hasPath: () => sn,
          hasTexts: () => ln,
          insertBreak: () => un,
          insertFragment: () => Xn,
          insertNode: () => cn,
          insertNodes: () => ar,
          insertSoftBreak: () => dn,
          insertText: () => fn,
          isBlock: () => mn,
          isEdge: () => gn,
          isEditor: () => Re,
          isEmpty: () => vn,
          isEnd: () => yn,
          isNormalizing: () => bn,
          isStart: () => wn,
          last: () => xn,
          leaf: () => Dn,
          levels: () => Cn,
          liftNodes: () => sr,
          marks: () => _n,
          mergeNodes: () => dr,
          move: () => er,
          moveNodes: () => pr,
          next: () => Pn,
          node: () => kn,
          nodes: () => An,
          normalize: () => zn,
          normalizeNode: () => It,
          parent: () => Tn,
          path: () => Fn,
          pathRef: () => On,
          pathRefs: () => In,
          point: () => jn,
          pointRef: () => Mn,
          pointRefs: () => Rn,
          positions: () => Bn,
          previous: () => Nn,
          range: () => Kn,
          rangeRef: () => Ln,
          rangeRefs: () => Vn,
          removeMark: () => Hn,
          removeNodes: () => hr,
          select: () => tr,
          setNodes: () => fr,
          setNormalizing: () => Un,
          setPoint: () => or,
          setSelection: () => ir,
          shouldNormalize: () => Ft,
          splitNodes: () => gr,
          start: () => Zn,
          string: () => $n,
          unhangRange: () => Gn,
          unsetNodes: () => vr,
          unwrapNodes: () => yr,
          withoutNormalizing: () => Wn,
          wrapNodes: () => xr
        });
        var r = n(35583);
        function o(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function (e) {
            return "'" + e + "'";
          }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
        }
        function i(e) {
          return !!e && !!e[Z];
        }
        function a(e) {
          var t;
          return !!e && (function (e) {
            if (!e || "object" != typeof e) return !1;
            var t = Object.getPrototypeOf(e);
            if (null === t) return !0;
            var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
            return n === Object || "function" == typeof n && Function.toString.call(n) === $;
          }(e) || Array.isArray(e) || !!e[U] || !!(null === (t = e.constructor) || void 0 === t ? void 0 : t[U]) || h(e) || f(e));
        }
        function s(e, t, n) {
          void 0 === n && (n = !1), 0 === l(e) ? (n ? Object.keys : G)(e).forEach(function (r) {
            n && "symbol" == typeof r || t(r, e[r], e);
          }) : e.forEach(function (n, r) {
            return t(r, n, e);
          });
        }
        function l(e) {
          var t = e[Z];
          return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : h(e) ? 2 : f(e) ? 3 : 0;
        }
        function u(e, t) {
          return 2 === l(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
        }
        function c(e, t) {
          return 2 === l(e) ? e.get(t) : e[t];
        }
        function d(e, t, n) {
          var r = l(e);
          2 === r ? e.set(t, n) : 3 === r ? (e.delete(t), e.add(n)) : e[t] = n;
        }
        function p(e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
        }
        function h(e) {
          return V && e instanceof Map;
        }
        function f(e) {
          return K && e instanceof Set;
        }
        function m(e) {
          return e.o || e.t;
        }
        function g(e) {
          if (Array.isArray(e)) return Array.prototype.slice.call(e);
          var t = W(e);
          delete t[Z];
          for (var n = G(t), r = 0; r < n.length; r++) {
            var o = n[r],
              i = t[o];
            !1 === i.writable && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = {
              configurable: !0,
              writable: !0,
              enumerable: i.enumerable,
              value: e[o]
            });
          }
          return Object.create(Object.getPrototypeOf(e), t);
        }
        function v(e, t) {
          return void 0 === t && (t = !1), b(e) || i(e) || !a(e) || (l(e) > 1 && (e.set = e.add = e.clear = e.delete = y), Object.freeze(e), t && s(e, function (e, t) {
            return v(t, !0);
          }, !0)), e;
        }
        function y() {
          o(2);
        }
        function b(e) {
          return null == e || "object" != typeof e || Object.isFrozen(e);
        }
        function w(e) {
          var t = Y[e];
          return t || o(18, e), t;
        }
        function x() {
          return N;
        }
        function D(e, t) {
          t && (w("Patches"), e.u = [], e.s = [], e.v = t);
        }
        function C(e) {
          S(e), e.p.forEach(_), e.p = null;
        }
        function S(e) {
          e === N && (N = e.l);
        }
        function E(e) {
          return N = {
            p: [],
            l: N,
            h: e,
            m: !0,
            _: 0
          };
        }
        function _(e) {
          var t = e[Z];
          0 === t.i || 1 === t.i ? t.j() : t.O = !0;
        }
        function P(e, t) {
          t._ = t.p.length;
          var n = t.p[0],
            r = void 0 !== e && e !== n;
          return t.h.g || w("ES5").S(t, e, r), r ? (n[Z].P && (C(t), o(4)), a(e) && (e = k(t, e), t.l || z(t, e)), t.u && w("Patches").M(n[Z].t, e, t.u, t.s)) : e = k(t, n, []), C(t), t.u && t.v(t.u, t.s), e !== H ? e : void 0;
        }
        function k(e, t, n) {
          if (b(t)) return t;
          var r = t[Z];
          if (!r) return s(t, function (o, i) {
            return A(e, r, t, o, i, n);
          }, !0), t;
          if (r.A !== e) return t;
          if (!r.P) return z(e, r.t, !0), r.t;
          if (!r.I) {
            r.I = !0, r.A._--;
            var o = 4 === r.i || 5 === r.i ? r.o = g(r.k) : r.o;
            s(3 === r.i ? new Set(o) : o, function (t, i) {
              return A(e, r, o, t, i, n);
            }), z(e, o, !1), n && e.u && w("Patches").R(r, n, e.u, e.s);
          }
          return r.o;
        }
        function A(e, t, n, r, o, s) {
          if (i(o)) {
            var l = k(e, o, s && t && 3 !== t.i && !u(t.D, r) ? s.concat(r) : void 0);
            if (d(n, r, l), !i(l)) return;
            e.m = !1;
          }
          if (a(o) && !b(o)) {
            if (!e.h.F && e._ < 1) return;
            k(e, o), t && t.A.l || z(e, o);
          }
        }
        function z(e, t, n) {
          void 0 === n && (n = !1), e.h.F && e.m && v(t, n);
        }
        function T(e, t) {
          var n = e[Z];
          return (n ? m(n) : e)[t];
        }
        function O(e, t) {
          if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
            var r = Object.getOwnPropertyDescriptor(n, t);
            if (r) return r;
            n = Object.getPrototypeOf(n);
          }
        }
        function I(e) {
          e.P || (e.P = !0, e.l && I(e.l));
        }
        function F(e) {
          e.o || (e.o = g(e.t));
        }
        function M(e, t, n) {
          var r = h(t) ? w("MapSet").N(t, n) : f(t) ? w("MapSet").T(t, n) : e.g ? function (e, t) {
            var n = Array.isArray(e),
              r = {
                i: n ? 1 : 0,
                A: t ? t.A : x(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: e,
                k: null,
                o: null,
                j: null,
                C: !1
              },
              o = r,
              i = X;
            n && (o = [r], i = Q);
            var a = Proxy.revocable(o, i),
              s = a.revoke,
              l = a.proxy;
            return r.k = l, r.j = s, l;
          }(t, n) : w("ES5").J(t, n);
          return (n ? n.A : x()).p.push(r), r;
        }
        function R(e) {
          return i(e) || o(22, e), function e(t) {
            if (!a(t)) return t;
            var n,
              r = t[Z],
              o = l(t);
            if (r) {
              if (!r.P && (r.i < 4 || !w("ES5").K(r))) return r.t;
              r.I = !0, n = j(t, o), r.I = !1;
            } else n = j(t, o);
            return s(n, function (t, o) {
              r && c(r.t, t) === o || d(n, t, e(o));
            }), 3 === o ? new Set(n) : n;
          }(e);
        }
        function j(e, t) {
          switch (t) {
            case 2:
              return new Map(e);
            case 3:
              return Array.from(e);
          }
          return g(e);
        }
        var B,
          N,
          L = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
          V = "undefined" != typeof Map,
          K = "undefined" != typeof Set,
          q = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
          H = L ? Symbol.for("immer-nothing") : ((B = {})["immer-nothing"] = !0, B),
          U = L ? Symbol.for("immer-draftable") : "__$immer_draftable",
          Z = L ? Symbol.for("immer-state") : "__$immer_state",
          $ = ("undefined" != typeof Symbol && Symbol.iterator, "" + Object.prototype.constructor),
          G = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : Object.getOwnPropertyNames,
          W = Object.getOwnPropertyDescriptors || function (e) {
            var t = {};
            return G(e).forEach(function (n) {
              t[n] = Object.getOwnPropertyDescriptor(e, n);
            }), t;
          },
          Y = {},
          X = {
            get: function (e, t) {
              if (t === Z) return e;
              var n = m(e);
              if (!u(n, t)) return function (e, t, n) {
                var r,
                  o = O(t, n);
                return o ? "value" in o ? o.value : null === (r = o.get) || void 0 === r ? void 0 : r.call(e.k) : void 0;
              }(e, n, t);
              var r = n[t];
              return e.I || !a(r) ? r : r === T(e.t, t) ? (F(e), e.o[t] = M(e.A.h, r, e)) : r;
            },
            has: function (e, t) {
              return t in m(e);
            },
            ownKeys: function (e) {
              return Reflect.ownKeys(m(e));
            },
            set: function (e, t, n) {
              var r = O(m(e), t);
              if (null == r ? void 0 : r.set) return r.set.call(e.k, n), !0;
              if (!e.P) {
                var o = T(m(e), t),
                  i = null == o ? void 0 : o[Z];
                if (i && i.t === n) return e.o[t] = n, e.D[t] = !1, !0;
                if (p(n, o) && (void 0 !== n || u(e.t, t))) return !0;
                F(e), I(e);
              }
              return e.o[t] === n && "number" != typeof n && (void 0 !== n || t in e.o) || (e.o[t] = n, e.D[t] = !0, !0);
            },
            deleteProperty: function (e, t) {
              return void 0 !== T(e.t, t) || t in e.t ? (e.D[t] = !1, F(e), I(e)) : delete e.D[t], e.o && delete e.o[t], !0;
            },
            getOwnPropertyDescriptor: function (e, t) {
              var n = m(e),
                r = Reflect.getOwnPropertyDescriptor(n, t);
              return r ? {
                writable: !0,
                configurable: 1 !== e.i || "length" !== t,
                enumerable: r.enumerable,
                value: n[t]
              } : r;
            },
            defineProperty: function () {
              o(11);
            },
            getPrototypeOf: function (e) {
              return Object.getPrototypeOf(e.t);
            },
            setPrototypeOf: function () {
              o(12);
            }
          },
          Q = {};
        s(X, function (e, t) {
          Q[e] = function () {
            return arguments[0] = arguments[0][0], t.apply(this, arguments);
          };
        }), Q.deleteProperty = function (e, t) {
          return Q.set.call(this, e, t, void 0);
        }, Q.set = function (e, t, n) {
          return X.set.call(this, e[0], t, n, e[0]);
        };
        var J = function () {
            function e(e) {
              var t = this;
              this.g = q, this.F = !0, this.produce = function (e, n, r) {
                if ("function" == typeof e && "function" != typeof n) {
                  var i = n;
                  n = e;
                  var s = t;
                  return function (e) {
                    var t = this;
                    void 0 === e && (e = i);
                    for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) o[a - 1] = arguments[a];
                    return s.produce(e, function (e) {
                      var r;
                      return (r = n).call.apply(r, [t, e].concat(o));
                    });
                  };
                }
                var l;
                if ("function" != typeof n && o(6), void 0 !== r && "function" != typeof r && o(7), a(e)) {
                  var u = E(t),
                    c = M(t, e, void 0),
                    d = !0;
                  try {
                    l = n(c), d = !1;
                  } finally {
                    d ? C(u) : S(u);
                  }
                  return "undefined" != typeof Promise && l instanceof Promise ? l.then(function (e) {
                    return D(u, r), P(e, u);
                  }, function (e) {
                    throw C(u), e;
                  }) : (D(u, r), P(l, u));
                }
                if (!e || "object" != typeof e) {
                  if (void 0 === (l = n(e)) && (l = e), l === H && (l = void 0), t.F && v(l, !0), r) {
                    var p = [],
                      h = [];
                    w("Patches").M(e, l, p, h), r(p, h);
                  }
                  return l;
                }
                o(21, e);
              }, this.produceWithPatches = function (e, n) {
                if ("function" == typeof e) return function (n) {
                  for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) o[i - 1] = arguments[i];
                  return t.produceWithPatches(n, function (t) {
                    return e.apply(void 0, [t].concat(o));
                  });
                };
                var r,
                  o,
                  i = t.produce(e, n, function (e, t) {
                    r = e, o = t;
                  });
                return "undefined" != typeof Promise && i instanceof Promise ? i.then(function (e) {
                  return [e, r, o];
                }) : [i, r, o];
              }, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze);
            }
            var t = e.prototype;
            return t.createDraft = function (e) {
              a(e) || o(8), i(e) && (e = R(e));
              var t = E(this),
                n = M(this, e, void 0);
              return n[Z].C = !0, S(t), n;
            }, t.finishDraft = function (e, t) {
              var n = (e && e[Z]).A;
              return D(n, t), P(void 0, n);
            }, t.setAutoFreeze = function (e) {
              this.F = e;
            }, t.setUseProxies = function (e) {
              e && !q && o(20), this.g = e;
            }, t.applyPatches = function (e, t) {
              var n;
              for (n = t.length - 1; n >= 0; n--) {
                var r = t[n];
                if (0 === r.path.length && "replace" === r.op) {
                  e = r.value;
                  break;
                }
              }
              n > -1 && (t = t.slice(n + 1));
              var o = w("Patches").$;
              return i(e) ? o(e, t) : this.produce(e, function (e) {
                return o(e, t);
              });
            }, e;
          }(),
          ee = new J(),
          te = ee.produce,
          ne = (ee.produceWithPatches.bind(ee), ee.setAutoFreeze.bind(ee), ee.setUseProxies.bind(ee), ee.applyPatches.bind(ee), ee.createDraft.bind(ee)),
          re = ee.finishDraft.bind(ee);
        var oe = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = fe.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          ie = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = Ke.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          ae = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = Ee.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          se = new WeakMap(),
          le = new WeakMap(),
          ue = new WeakMap(),
          ce = new WeakMap(),
          de = new WeakMap(),
          pe = new WeakMap(),
          he = new WeakMap(),
          fe = {
            ancestors(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                r = fe.levels(e, t);
              return r = n ? r.slice(1) : r.slice(0, -1);
            },
            common(e, t) {
              for (var n = [], r = 0; r < e.length && r < t.length; r++) {
                var o = e[r];
                if (o !== t[r]) break;
                n.push(o);
              }
              return n;
            },
            compare(e, t) {
              for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
                if (e[r] < t[r]) return -1;
                if (e[r] > t[r]) return 1;
              }
              return 0;
            },
            endsAfter(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return fe.equals(r, o) && i > a;
            },
            endsAt(e, t) {
              var n = e.length,
                r = e.slice(0, n),
                o = t.slice(0, n);
              return fe.equals(r, o);
            },
            endsBefore(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return fe.equals(r, o) && i < a;
            },
            equals: (e, t) => e.length === t.length && e.every((e, n) => e === t[n]),
            hasPrevious: e => e[e.length - 1] > 0,
            isAfter: (e, t) => 1 === fe.compare(e, t),
            isAncestor: (e, t) => e.length < t.length && 0 === fe.compare(e, t),
            isBefore: (e, t) => -1 === fe.compare(e, t),
            isChild: (e, t) => e.length === t.length + 1 && 0 === fe.compare(e, t),
            isCommon: (e, t) => e.length <= t.length && 0 === fe.compare(e, t),
            isDescendant: (e, t) => e.length > t.length && 0 === fe.compare(e, t),
            isParent: (e, t) => e.length + 1 === t.length && 0 === fe.compare(e, t),
            isPath: e => Array.isArray(e) && (0 === e.length || "number" == typeof e[0]),
            isSibling(e, t) {
              if (e.length !== t.length) return !1;
              var n = e.slice(0, -1),
                r = t.slice(0, -1);
              return e[e.length - 1] !== t[t.length - 1] && fe.equals(n, r);
            },
            levels(e) {
              for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
                  reverse: n = !1
                } = t, r = [], o = 0; o <= e.length; o++) r.push(e.slice(0, o));
              return n && r.reverse(), r;
            },
            next(e) {
              if (0 === e.length) throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
              var t = e[e.length - 1];
              return e.slice(0, -1).concat(t + 1);
            },
            operationCanTransformPath(e) {
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                case "merge_node":
                case "split_node":
                case "move_node":
                  return !0;
                default:
                  return !1;
              }
            },
            parent(e) {
              if (0 === e.length) throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
              return e.slice(0, -1);
            },
            previous(e) {
              if (0 === e.length) throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
              var t = e[e.length - 1];
              if (t <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
              return e.slice(0, -1).concat(t - 1);
            },
            relative(e, t) {
              if (!fe.isAncestor(t, e) && !fe.equals(e, t)) throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
              return e.slice(t.length);
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (!e) return null;
              var r = [...e],
                {
                  affinity: o = "forward"
                } = n;
              if (0 === e.length) return r;
              switch (t.type) {
                case "insert_node":
                  var {
                    path: i
                  } = t;
                  (fe.equals(i, r) || fe.endsBefore(i, r) || fe.isAncestor(i, r)) && (r[i.length - 1] += 1);
                  break;
                case "remove_node":
                  var {
                    path: a
                  } = t;
                  if (fe.equals(a, r) || fe.isAncestor(a, r)) return null;
                  fe.endsBefore(a, r) && (r[a.length - 1] -= 1);
                  break;
                case "merge_node":
                  var {
                    path: s,
                    position: l
                  } = t;
                  fe.equals(s, r) || fe.endsBefore(s, r) ? r[s.length - 1] -= 1 : fe.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += l);
                  break;
                case "split_node":
                  var {
                    path: u,
                    position: c
                  } = t;
                  if (fe.equals(u, r)) {
                    if ("forward" === o) r[r.length - 1] += 1;else if ("backward" !== o) return null;
                  } else fe.endsBefore(u, r) ? r[u.length - 1] += 1 : fe.isAncestor(u, r) && e[u.length] >= c && (r[u.length - 1] += 1, r[u.length] -= c);
                  break;
                case "move_node":
                  var {
                    path: d,
                    newPath: p
                  } = t;
                  if (fe.equals(d, p)) return r;
                  if (fe.isAncestor(d, r) || fe.equals(d, r)) {
                    var h = p.slice();
                    return fe.endsBefore(d, p) && d.length < p.length && (h[d.length - 1] -= 1), h.concat(r.slice(d.length));
                  }
                  fe.isSibling(d, p) && (fe.isAncestor(p, r) || fe.equals(p, r)) ? fe.endsBefore(d, r) ? r[d.length - 1] -= 1 : r[d.length - 1] += 1 : fe.endsBefore(p, r) || fe.equals(p, r) || fe.isAncestor(p, r) ? (fe.endsBefore(d, r) && (r[d.length - 1] -= 1), r[p.length - 1] += 1) : fe.endsBefore(d, r) && (fe.equals(p, r) && (r[p.length - 1] += 1), r[d.length - 1] -= 1);
              }
              return r;
            }
          };
        function me(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function ge(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ve(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ge(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ge(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var ye = {
            transform(e, t) {
              e.children = ne(e.children);
              var n = e.selection && ne(e.selection);
              try {
                n = ((e, t, n) => {
                  switch (n.type) {
                    case "insert_node":
                      var {
                          path: r,
                          node: o
                        } = n,
                        i = Te.parent(e, r),
                        a = r[r.length - 1];
                      if (a > i.children.length) throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
                      if (i.children.splice(a, 0, o), t) for (var [s, l] of Ee.points(t)) t[l] = Ke.transform(s, n);
                      break;
                    case "insert_text":
                      var {
                        path: u,
                        offset: c,
                        text: d
                      } = n;
                      if (0 === d.length) break;
                      var p = Te.leaf(e, u),
                        h = p.text.slice(0, c),
                        f = p.text.slice(c);
                      if (p.text = h + d + f, t) for (var [m, g] of Ee.points(t)) t[g] = Ke.transform(m, n);
                      break;
                    case "merge_node":
                      var {
                          path: v
                        } = n,
                        y = Te.get(e, v),
                        b = fe.previous(v),
                        w = Te.get(e, b),
                        x = Te.parent(e, v),
                        D = v[v.length - 1];
                      if (Ye.isText(y) && Ye.isText(w)) w.text += y.text;else {
                        if (Ye.isText(y) || Ye.isText(w)) throw new Error('Cannot apply a "merge_node" operation at path ['.concat(v, "] to nodes of different interfaces: ").concat(He.stringify(y), " ").concat(He.stringify(w)));
                        w.children.push(...y.children);
                      }
                      if (x.children.splice(D, 1), t) for (var [C, S] of Ee.points(t)) t[S] = Ke.transform(C, n);
                      break;
                    case "move_node":
                      var {
                        path: E,
                        newPath: _
                      } = n;
                      if (fe.isAncestor(E, _)) throw new Error("Cannot move a path [".concat(E, "] to new path [").concat(_, "] because the destination is inside itself."));
                      var P = Te.get(e, E),
                        k = Te.parent(e, E),
                        A = E[E.length - 1];
                      k.children.splice(A, 1);
                      var z = fe.transform(E, n),
                        T = Te.get(e, fe.parent(z)),
                        O = z[z.length - 1];
                      if (T.children.splice(O, 0, P), t) for (var [I, F] of Ee.points(t)) t[F] = Ke.transform(I, n);
                      break;
                    case "remove_node":
                      var {
                          path: M
                        } = n,
                        R = M[M.length - 1];
                      if (Te.parent(e, M).children.splice(R, 1), t) for (var [j, B] of Ee.points(t)) {
                        var N = Ke.transform(j, n);
                        if (null != t && null != N) t[B] = N;else {
                          var L = void 0,
                            V = void 0;
                          for (var [K, q] of Te.texts(e)) {
                            if (-1 !== fe.compare(q, M)) {
                              V = [K, q];
                              break;
                            }
                            L = [K, q];
                          }
                          var H = !1;
                          L && V && (H = fe.equals(V[1], M) ? !fe.hasPrevious(V[1]) : fe.common(L[1], M).length < fe.common(V[1], M).length), L && !H ? (j.path = L[1], j.offset = L[0].text.length) : V ? (j.path = V[1], j.offset = 0) : t = null;
                        }
                      }
                      break;
                    case "remove_text":
                      var {
                        path: U,
                        offset: Z,
                        text: $
                      } = n;
                      if (0 === $.length) break;
                      var G = Te.leaf(e, U),
                        W = G.text.slice(0, Z),
                        Y = G.text.slice(Z + $.length);
                      if (G.text = W + Y, t) for (var [X, Q] of Ee.points(t)) t[Q] = Ke.transform(X, n);
                      break;
                    case "set_node":
                      var {
                        path: J,
                        properties: ee,
                        newProperties: te
                      } = n;
                      if (0 === J.length) throw new Error("Cannot set properties on the root node!");
                      var ne = Te.get(e, J);
                      for (var re in te) {
                        if ("children" === re || "text" === re) throw new Error('Cannot set the "'.concat(re, '" property of nodes!'));
                        var oe = te[re];
                        null == oe ? delete ne[re] : ne[re] = oe;
                      }
                      for (var ie in ee) te.hasOwnProperty(ie) || delete ne[ie];
                      break;
                    case "set_selection":
                      var {
                        newProperties: ae
                      } = n;
                      if (null == ae) t = ae;else {
                        if (null == t) {
                          if (!Ee.isRange(ae)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(He.stringify(ae), " when there is no current selection."));
                          t = ve({}, ae);
                        }
                        for (var se in ae) {
                          var le = ae[se];
                          if (null == le) {
                            if ("anchor" === se || "focus" === se) throw new Error('Cannot remove the "'.concat(se, '" selection property'));
                            delete t[se];
                          } else t[se] = le;
                        }
                      }
                      break;
                    case "split_node":
                      var {
                        path: ue,
                        position: ce,
                        properties: de
                      } = n;
                      if (0 === ue.length) throw new Error('Cannot apply a "split_node" operation at path ['.concat(ue, "] because the root node cannot be split."));
                      var pe,
                        he = Te.get(e, ue),
                        me = Te.parent(e, ue),
                        ge = ue[ue.length - 1];
                      if (Ye.isText(he)) {
                        var ye = he.text.slice(0, ce),
                          be = he.text.slice(ce);
                        he.text = ye, pe = ve(ve({}, de), {}, {
                          text: be
                        });
                      } else {
                        var we = he.children.slice(0, ce),
                          xe = he.children.slice(ce);
                        he.children = we, pe = ve(ve({}, de), {}, {
                          children: xe
                        });
                      }
                      if (me.children.splice(ge + 1, 0, pe), t) for (var [De, Ce] of Ee.points(t)) t[Ce] = Ke.transform(De, n);
                  }
                  return t;
                })(e, n, t);
              } finally {
                e.children = re(e.children), e.selection = n ? i(n) ? re(n) : n : null;
              }
            }
          },
          be = {
            insertNodes(e, t, n) {
              e.insertNodes(t, n);
            },
            liftNodes(e, t) {
              e.liftNodes(t);
            },
            mergeNodes(e, t) {
              e.mergeNodes(t);
            },
            moveNodes(e, t) {
              e.moveNodes(t);
            },
            removeNodes(e, t) {
              e.removeNodes(t);
            },
            setNodes(e, t, n) {
              e.setNodes(t, n);
            },
            splitNodes(e, t) {
              e.splitNodes(t);
            },
            unsetNodes(e, t, n) {
              e.unsetNodes(t, n);
            },
            unwrapNodes(e, t) {
              e.unwrapNodes(t);
            },
            wrapNodes(e, t, n) {
              e.wrapNodes(t, n);
            }
          },
          we = {
            collapse(e, t) {
              e.collapse(t);
            },
            deselect(e) {
              e.deselect();
            },
            move(e, t) {
              e.move(t);
            },
            select(e, t) {
              e.select(t);
            },
            setPoint(e, t, n) {
              e.setPoint(t, n);
            },
            setSelection(e, t) {
              e.setSelection(t);
            }
          },
          xe = (e, t) => {
            for (var n in e) {
              var o = e[n],
                i = t[n];
              if ((0, r.P)(o) && (0, r.P)(i)) {
                if (!xe(o, i)) return !1;
              } else if (Array.isArray(o) && Array.isArray(i)) {
                if (o.length !== i.length) return !1;
                for (var a = 0; a < o.length; a++) if (o[a] !== i[a]) return !1;
              } else if (o !== i) return !1;
            }
            for (var s in t) if (void 0 === e[s] && void 0 !== t[s]) return !1;
            return !0;
          };
        function De(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        var Ce = ["anchor", "focus"];
        function Se(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Ee = {
            edges(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                {
                  anchor: r,
                  focus: o
                } = e;
              return Ee.isBackward(e) === n ? [r, o] : [o, r];
            },
            end(e) {
              var [, t] = Ee.edges(e);
              return t;
            },
            equals: (e, t) => Ke.equals(e.anchor, t.anchor) && Ke.equals(e.focus, t.focus),
            includes(e, t) {
              if (Ee.isRange(t)) {
                if (Ee.includes(e, t.anchor) || Ee.includes(e, t.focus)) return !0;
                var [n, r] = Ee.edges(e),
                  [o, i] = Ee.edges(t);
                return Ke.isBefore(n, o) && Ke.isAfter(r, i);
              }
              var [a, s] = Ee.edges(e),
                l = !1,
                u = !1;
              return Ke.isPoint(t) ? (l = Ke.compare(t, a) >= 0, u = Ke.compare(t, s) <= 0) : (l = fe.compare(t, a.path) >= 0, u = fe.compare(t, s.path) <= 0), l && u;
            },
            intersection(e, t) {
              var n = De(e, Ce),
                [r, o] = Ee.edges(e),
                [i, a] = Ee.edges(t),
                s = Ke.isBefore(r, i) ? i : r,
                l = Ke.isBefore(o, a) ? o : a;
              return Ke.isBefore(l, s) ? null : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? Se(Object(n), !0).forEach(function (t) {
                    me(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Se(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                anchor: s,
                focus: l
              }, n);
            },
            isBackward(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return Ke.isAfter(t, n);
            },
            isCollapsed(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return Ke.equals(t, n);
            },
            isExpanded: e => !Ee.isCollapsed(e),
            isForward: e => !Ee.isBackward(e),
            isRange: e => (0, r.P)(e) && Ke.isPoint(e.anchor) && Ke.isPoint(e.focus),
            *points(e) {
              yield [e.anchor, "anchor"], yield [e.focus, "focus"];
            },
            start(e) {
              var [t] = Ee.edges(e);
              return t;
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return te(e, e => {
                if (null === e) return null;
                var r,
                  o,
                  {
                    affinity: i = "inward"
                  } = n;
                if ("inward" === i) {
                  var a = Ee.isCollapsed(e);
                  Ee.isForward(e) ? (r = "forward", o = a ? r : "backward") : (r = "backward", o = a ? r : "forward");
                } else "outward" === i ? Ee.isForward(e) ? (r = "backward", o = "forward") : (r = "forward", o = "backward") : (r = i, o = i);
                var s = Ke.transform(e.anchor, t, {
                    affinity: r
                  }),
                  l = Ke.transform(e.focus, t, {
                    affinity: o
                  });
                if (!s || !l) return null;
                e.anchor = s, e.focus = l;
              });
            }
          },
          _e = e => (0, r.P)(e) && Te.isNodeList(e.children) && !je.isEditor(e),
          Pe = {
            isAncestor: e => (0, r.P)(e) && Te.isNodeList(e.children),
            isElement: _e,
            isElementList: e => Array.isArray(e) && e.every(e => Pe.isElement(e)),
            isElementProps: e => void 0 !== e.children,
            isElementType: function (e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "type";
              return _e(e) && e[n] === t;
            },
            matches(e, t) {
              for (var n in t) if ("children" !== n && e[n] !== t[n]) return !1;
              return !0;
            }
          },
          ke = ["children"],
          Ae = ["text"],
          ze = new WeakMap(),
          Te = {
            ancestor(e, t) {
              var n = Te.get(e, t);
              if (Ye.isText(n)) throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(He.stringify(n)));
              return n;
            },
            *ancestors(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              for (var r of fe.ancestors(t, n)) {
                var o = [Te.ancestor(e, r), r];
                yield o;
              }
            },
            child(e, t) {
              if (Ye.isText(e)) throw new Error("Cannot get the child of a text node: ".concat(He.stringify(e)));
              var n = e.children[t];
              if (null == n) throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(He.stringify(e)));
              return n;
            },
            *children(e, t) {
              for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, {
                  reverse: r = !1
                } = n, o = Te.ancestor(e, t), {
                  children: i
                } = o, a = r ? i.length - 1 : 0; r ? a >= 0 : a < i.length;) {
                var s = Te.child(o, a),
                  l = t.concat(a);
                yield [s, l], a = r ? a - 1 : a + 1;
              }
            },
            common(e, t, n) {
              var r = fe.common(t, n);
              return [Te.get(e, r), r];
            },
            descendant(e, t) {
              var n = Te.get(e, t);
              if (je.isEditor(n)) throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(He.stringify(n)));
              return n;
            },
            *descendants(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) 0 !== r.length && (yield [n, r]);
            },
            *elements(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) Pe.isElement(n) && (yield [n, r]);
            },
            extractProps: e => Pe.isAncestor(e) ? De(e, ke) : De(e, Ae),
            first(e, t) {
              for (var n = t.slice(), r = Te.get(e, n); r && !Ye.isText(r) && 0 !== r.children.length;) r = r.children[0], n.push(0);
              return [r, n];
            },
            fragment(e, t) {
              if (Ye.isText(e)) throw new Error("Cannot get a fragment starting from a root text node: ".concat(He.stringify(e)));
              var n = te({
                children: e.children
              }, e => {
                var [n, r] = Ee.edges(t),
                  o = Te.nodes(e, {
                    reverse: !0,
                    pass: e => {
                      var [, n] = e;
                      return !Ee.includes(t, n);
                    }
                  });
                for (var [, i] of o) {
                  if (!Ee.includes(t, i)) {
                    var a = Te.parent(e, i),
                      s = i[i.length - 1];
                    a.children.splice(s, 1);
                  }
                  if (fe.equals(i, r.path)) {
                    var l = Te.leaf(e, i);
                    l.text = l.text.slice(0, r.offset);
                  }
                  if (fe.equals(i, n.path)) {
                    var u = Te.leaf(e, i);
                    u.text = u.text.slice(n.offset);
                  }
                }
                je.isEditor(e) && (e.selection = null);
              });
              return n.children;
            },
            get(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (Ye.isText(n) || !n.children[o]) throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(He.stringify(e)));
                n = n.children[o];
              }
              return n;
            },
            has(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (Ye.isText(n) || !n.children[o]) return !1;
                n = n.children[o];
              }
              return !0;
            },
            isNode: e => Ye.isText(e) || Pe.isElement(e) || je.isEditor(e),
            isNodeList(e) {
              if (!Array.isArray(e)) return !1;
              var t = ze.get(e);
              if (void 0 !== t) return t;
              var n = e.every(e => Te.isNode(e));
              return ze.set(e, n), n;
            },
            last(e, t) {
              for (var n = t.slice(), r = Te.get(e, n); r && !Ye.isText(r) && 0 !== r.children.length;) {
                var o = r.children.length - 1;
                r = r.children[o], n.push(o);
              }
              return [r, n];
            },
            leaf(e, t) {
              var n = Te.get(e, t);
              if (!Ye.isText(n)) throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(He.stringify(n)));
              return n;
            },
            *levels(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              for (var r of fe.levels(t, n)) {
                var o = Te.get(e, r);
                yield [o, r];
              }
            },
            matches: (e, t) => Pe.isElement(e) && Pe.isElementProps(t) && Pe.matches(e, t) || Ye.isText(e) && Ye.isTextProps(t) && Ye.matches(e, t),
            *nodes(e) {
              for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
                  pass: n,
                  reverse: r = !1
                } = t, {
                  from: o = [],
                  to: i
                } = t, a = new Set(), s = [], l = e; !i || !(r ? fe.isBefore(s, i) : fe.isAfter(s, i));) if (a.has(l) || (yield [l, s]), a.has(l) || Ye.isText(l) || 0 === l.children.length || null != n && !1 !== n([l, s])) {
                if (0 === s.length) break;
                if (!r) {
                  var u = fe.next(s);
                  if (Te.has(e, u)) {
                    s = u, l = Te.get(e, s);
                    continue;
                  }
                }
                if (r && 0 !== s[s.length - 1]) s = fe.previous(s), l = Te.get(e, s);else s = fe.parent(s), l = Te.get(e, s), a.add(l);
              } else {
                a.add(l);
                var c = r ? l.children.length - 1 : 0;
                fe.isAncestor(s, o) && (c = o[s.length]), s = s.concat(c), l = Te.get(e, s);
              }
            },
            parent(e, t) {
              var n = fe.parent(t),
                r = Te.get(e, n);
              if (Ye.isText(r)) throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
              return r;
            },
            string: e => Ye.isText(e) ? e.text : e.children.map(Te.string).join(""),
            *texts(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) Ye.isText(n) && (yield [n, r]);
            }
          };
        function Oe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ie(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Oe(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Oe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Fe = {
            isNodeOperation: e => Fe.isOperation(e) && e.type.endsWith("_node"),
            isOperation(e) {
              if (!(0, r.P)(e)) return !1;
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                  return fe.isPath(e.path) && Te.isNode(e.node);
                case "insert_text":
                case "remove_text":
                  return "number" == typeof e.offset && "string" == typeof e.text && fe.isPath(e.path);
                case "merge_node":
                  return "number" == typeof e.position && fe.isPath(e.path) && (0, r.P)(e.properties);
                case "move_node":
                  return fe.isPath(e.path) && fe.isPath(e.newPath);
                case "set_node":
                  return fe.isPath(e.path) && (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "set_selection":
                  return null === e.properties && Ee.isRange(e.newProperties) || null === e.newProperties && Ee.isRange(e.properties) || (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "split_node":
                  return fe.isPath(e.path) && "number" == typeof e.position && (0, r.P)(e.properties);
                default:
                  return !1;
              }
            },
            isOperationList: e => Array.isArray(e) && e.every(e => Fe.isOperation(e)),
            isSelectionOperation: e => Fe.isOperation(e) && e.type.endsWith("_selection"),
            isTextOperation: e => Fe.isOperation(e) && e.type.endsWith("_text"),
            inverse(e) {
              switch (e.type) {
                case "insert_node":
                  return Ie(Ie({}, e), {}, {
                    type: "remove_node"
                  });
                case "insert_text":
                  return Ie(Ie({}, e), {}, {
                    type: "remove_text"
                  });
                case "merge_node":
                  return Ie(Ie({}, e), {}, {
                    type: "split_node",
                    path: fe.previous(e.path)
                  });
                case "move_node":
                  var {
                    newPath: t,
                    path: n
                  } = e;
                  if (fe.equals(t, n)) return e;
                  if (fe.isSibling(n, t)) return Ie(Ie({}, e), {}, {
                    path: t,
                    newPath: n
                  });
                  var r = fe.transform(n, e),
                    o = fe.transform(fe.next(n), e);
                  return Ie(Ie({}, e), {}, {
                    path: r,
                    newPath: o
                  });
                case "remove_node":
                  return Ie(Ie({}, e), {}, {
                    type: "insert_node"
                  });
                case "remove_text":
                  return Ie(Ie({}, e), {}, {
                    type: "insert_text"
                  });
                case "set_node":
                  var {
                    properties: i,
                    newProperties: a
                  } = e;
                  return Ie(Ie({}, e), {}, {
                    properties: a,
                    newProperties: i
                  });
                case "set_selection":
                  var {
                    properties: s,
                    newProperties: l
                  } = e;
                  return Ie(Ie({}, e), {}, null == s ? {
                    properties: l,
                    newProperties: null
                  } : null == l ? {
                    properties: null,
                    newProperties: s
                  } : {
                    properties: l,
                    newProperties: s
                  });
                case "split_node":
                  return Ie(Ie({}, e), {}, {
                    type: "merge_node",
                    path: fe.next(e.path)
                  });
              }
            }
          },
          Me = new WeakMap(),
          Re = e => {
            var t = Me.get(e);
            if (void 0 !== t) return t;
            if (!(0, r.P)(e)) return !1;
            var n = "function" == typeof e.addMark && "function" == typeof e.apply && "function" == typeof e.deleteFragment && "function" == typeof e.insertBreak && "function" == typeof e.insertSoftBreak && "function" == typeof e.insertFragment && "function" == typeof e.insertNode && "function" == typeof e.insertText && "function" == typeof e.isElementReadOnly && "function" == typeof e.isInline && "function" == typeof e.isSelectable && "function" == typeof e.isVoid && "function" == typeof e.normalizeNode && "function" == typeof e.onChange && "function" == typeof e.removeMark && "function" == typeof e.getDirtyPaths && (null === e.marks || (0, r.P)(e.marks)) && (null === e.selection || Ee.isRange(e.selection)) && Te.isNodeList(e.children) && Fe.isOperationList(e.operations);
            return Me.set(e, n), n;
          },
          je = {
            above: (e, t) => e.above(t),
            addMark(e, t, n) {
              e.addMark(t, n);
            },
            after: (e, t, n) => e.after(t, n),
            before: (e, t, n) => e.before(t, n),
            deleteBackward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteBackward(n);
            },
            deleteForward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteForward(n);
            },
            deleteFragment(e, t) {
              e.deleteFragment(t);
            },
            edges: (e, t) => e.edges(t),
            elementReadOnly(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return e.elementReadOnly(t);
            },
            end: (e, t) => e.end(t),
            first: (e, t) => e.first(t),
            fragment: (e, t) => e.fragment(t),
            hasBlocks: (e, t) => e.hasBlocks(t),
            hasInlines: (e, t) => e.hasInlines(t),
            hasPath: (e, t) => e.hasPath(t),
            hasTexts: (e, t) => e.hasTexts(t),
            insertBreak(e) {
              e.insertBreak();
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertNode(e, t) {
              e.insertNode(t);
            },
            insertSoftBreak(e) {
              e.insertSoftBreak();
            },
            insertText(e, t) {
              e.insertText(t);
            },
            isBlock: (e, t) => e.isBlock(t),
            isEdge: (e, t, n) => e.isEdge(t, n),
            isEditor: e => Re(e),
            isElementReadOnly: (e, t) => e.isElementReadOnly(t),
            isEmpty: (e, t) => e.isEmpty(t),
            isEnd: (e, t, n) => e.isEnd(t, n),
            isInline: (e, t) => e.isInline(t),
            isNormalizing: e => e.isNormalizing(),
            isSelectable: (e, t) => e.isSelectable(t),
            isStart: (e, t, n) => e.isStart(t, n),
            isVoid: (e, t) => e.isVoid(t),
            last: (e, t) => e.last(t),
            leaf: (e, t, n) => e.leaf(t, n),
            levels: (e, t) => e.levels(t),
            marks: e => e.getMarks(),
            next: (e, t) => e.next(t),
            node: (e, t, n) => e.node(t, n),
            nodes: (e, t) => e.nodes(t),
            normalize(e, t) {
              e.normalize(t);
            },
            parent: (e, t, n) => e.parent(t, n),
            path: (e, t, n) => e.path(t, n),
            pathRef: (e, t, n) => e.pathRef(t, n),
            pathRefs: e => e.pathRefs(),
            point: (e, t, n) => e.point(t, n),
            pointRef: (e, t, n) => e.pointRef(t, n),
            pointRefs: e => e.pointRefs(),
            positions: (e, t) => e.positions(t),
            previous: (e, t) => e.previous(t),
            range: (e, t, n) => e.range(t, n),
            rangeRef: (e, t, n) => e.rangeRef(t, n),
            rangeRefs: e => e.rangeRefs(),
            removeMark(e, t) {
              e.removeMark(t);
            },
            setNormalizing(e, t) {
              e.setNormalizing(t);
            },
            start: (e, t) => e.start(t),
            string: (e, t, n) => e.string(t, n),
            unhangRange: (e, t, n) => e.unhangRange(t, n),
            void: (e, t) => e.void(t),
            withoutNormalizing(e, t) {
              e.withoutNormalizing(t);
            }
          },
          Be = {
            isLocation: e => fe.isPath(e) || Ke.isPoint(e) || Ee.isRange(e)
          },
          Ne = {
            isSpan: e => Array.isArray(e) && 2 === e.length && e.every(fe.isPath)
          };
        function Le(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ve(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Le(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Le(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ke = {
            compare(e, t) {
              var n = fe.compare(e.path, t.path);
              return 0 === n ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
            },
            isAfter: (e, t) => 1 === Ke.compare(e, t),
            isBefore: (e, t) => -1 === Ke.compare(e, t),
            equals: (e, t) => e.offset === t.offset && fe.equals(e.path, t.path),
            isPoint: e => (0, r.P)(e) && "number" == typeof e.offset && fe.isPath(e.path),
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return te(e, e => {
                if (null === e) return null;
                var {
                    affinity: r = "forward"
                  } = n,
                  {
                    path: o,
                    offset: i
                  } = e;
                switch (t.type) {
                  case "insert_node":
                  case "move_node":
                    e.path = fe.transform(o, t, n);
                    break;
                  case "insert_text":
                    fe.equals(t.path, o) && (t.offset < i || t.offset === i && "forward" === r) && (e.offset += t.text.length);
                    break;
                  case "merge_node":
                    fe.equals(t.path, o) && (e.offset += t.position), e.path = fe.transform(o, t, n);
                    break;
                  case "remove_text":
                    fe.equals(t.path, o) && t.offset <= i && (e.offset -= Math.min(i - t.offset, t.text.length));
                    break;
                  case "remove_node":
                    if (fe.equals(t.path, o) || fe.isAncestor(t.path, o)) return null;
                    e.path = fe.transform(o, t, n);
                    break;
                  case "split_node":
                    if (fe.equals(t.path, o)) {
                      if (t.position === i && null == r) return null;
                      (t.position < i || t.position === i && "forward" === r) && (e.offset -= t.position, e.path = fe.transform(o, t, Ve(Ve({}, n), {}, {
                        affinity: "forward"
                      })));
                    } else e.path = fe.transform(o, t, n);
                }
              });
            }
          },
          qe = void 0,
          He = {
            setScrubber(e) {
              qe = e;
            },
            stringify: e => JSON.stringify(e, qe)
          },
          Ue = ["text"],
          Ze = ["anchor", "focus"];
        function $e(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ge(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? $e(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $e(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var We,
          Ye = {
            equals(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                {
                  loose: r = !1
                } = n;
              function o(e) {
                return De(e, Ue);
              }
              return xe(r ? o(e) : e, r ? o(t) : t);
            },
            isText: e => (0, r.P)(e) && "string" == typeof e.text,
            isTextList: e => Array.isArray(e) && e.every(e => Ye.isText(e)),
            isTextProps: e => void 0 !== e.text,
            matches(e, t) {
              for (var n in t) if ("text" !== n && (!e.hasOwnProperty(n) || e[n] !== t[n])) return !1;
              return !0;
            },
            decorations(e, t) {
              var n = [Ge({}, e)];
              for (var r of t) {
                var o = De(r, Ze),
                  [i, a] = Ee.edges(r),
                  s = [],
                  l = 0,
                  u = i.offset,
                  c = a.offset;
                for (var d of n) {
                  var {
                      length: p
                    } = d.text,
                    h = l;
                  if (l += p, u <= h && l <= c) Object.assign(d, o), s.push(d);else if (u !== c && (u === l || c === h) || u > l || c < h || c === h && 0 !== h) s.push(d);else {
                    var f = d,
                      m = void 0,
                      g = void 0;
                    if (c < l) {
                      var v = c - h;
                      g = Ge(Ge({}, f), {}, {
                        text: f.text.slice(v)
                      }), f = Ge(Ge({}, f), {}, {
                        text: f.text.slice(0, v)
                      });
                    }
                    if (u > h) {
                      var y = u - h;
                      m = Ge(Ge({}, f), {}, {
                        text: f.text.slice(0, y)
                      }), f = Ge(Ge({}, f), {}, {
                        text: f.text.slice(y)
                      });
                    }
                    Object.assign(f, o), m && s.push(m), s.push(f), g && s.push(g);
                  }
                }
                n = s;
              }
              return n;
            }
          },
          Xe = e => e.selection ? e.selection : e.children.length > 0 ? je.end(e, []) : [0],
          Qe = (e, t) => {
            var [n] = je.node(e, t);
            return e => e === n;
          },
          Je = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = !t,
              r = t ? at(e) : e,
              o = We.None,
              i = We.None,
              a = 0,
              s = null;
            for (var l of r) {
              var u = l.codePointAt(0);
              if (!u) break;
              var c = yt(l, u);
              if ([o, i] = n ? [i, c] : [c, o], bt(o, We.ZWJ) && bt(i, We.ExtPict) && !Ct(n ? e.substring(0, a) : e.substring(0, e.length - a))) break;
              if (bt(o, We.RI) && bt(i, We.RI) && !(s = null !== s ? !s : !!n || Et(e.substring(0, e.length - a)))) break;
              if (o !== We.None && i !== We.None && xt(o, i)) break;
              a += l.length;
            }
            return a || 1;
          },
          et = /\s/,
          tt = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/,
          nt = /['\u2018\u2019]/,
          rt = function (e) {
            for (var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = 0, r = !1; e.length > 0;) {
              var o = Je(e, t),
                [i, a] = ot(e, o, t);
              if (it(i, a, t)) r = !0, n += o;else {
                if (r) break;
                n += o;
              }
              e = a;
            }
            return n;
          },
          ot = (e, t, n) => {
            if (n) {
              var r = e.length - t;
              return [e.slice(r, e.length), e.slice(0, r)];
            }
            return [e.slice(0, t), e.slice(t)];
          },
          it = function e(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if (et.test(t)) return !1;
            if (nt.test(t)) {
              var o = Je(n, r),
                [i, a] = ot(n, o, r);
              if (e(i, a, r)) return !0;
            }
            return !tt.test(t);
          },
          at = function* (e) {
            for (var t = e.length - 1, n = 0; n < e.length; n++) {
              var r = e.charAt(t - n);
              if (lt(r.charCodeAt(0))) {
                var o = e.charAt(t - n - 1);
                if (st(o.charCodeAt(0))) {
                  yield o + r, n++;
                  continue;
                }
              }
              yield r;
            }
          },
          st = e => e >= 55296 && e <= 56319,
          lt = e => e >= 56320 && e <= 57343;
        !function (e) {
          e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
        }(We || (We = {}));
        var ut = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/,
          ct = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/,
          dt = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/,
          pt = /^[\u1100-\u115F\uA960-\uA97C]$/,
          ht = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/,
          ft = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/,
          mt = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/,
          gt = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/,
          vt = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/,
          yt = (e, t) => {
            var n = We.Any;
            return -1 !== e.search(ut) && (n |= We.Extend), 8205 === t && (n |= We.ZWJ), t >= 127462 && t <= 127487 && (n |= We.RI), -1 !== e.search(ct) && (n |= We.Prepend), -1 !== e.search(dt) && (n |= We.SpacingMark), -1 !== e.search(pt) && (n |= We.L), -1 !== e.search(ht) && (n |= We.V), -1 !== e.search(ft) && (n |= We.T), -1 !== e.search(mt) && (n |= We.LV), -1 !== e.search(gt) && (n |= We.LVT), -1 !== e.search(vt) && (n |= We.ExtPict), n;
          };
        function bt(e, t) {
          return 0 != (e & t);
        }
        var wt = [[We.L, We.L | We.V | We.LV | We.LVT], [We.LV | We.V, We.V | We.T], [We.LVT | We.T, We.T], [We.Any, We.Extend | We.ZWJ], [We.Any, We.SpacingMark], [We.Prepend, We.Any], [We.ZWJ, We.ExtPict], [We.RI, We.RI]];
        function xt(e, t) {
          return -1 === wt.findIndex(n => bt(e, n[0]) && bt(t, n[1]));
        }
        var Dt = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/,
          Ct = e => -1 !== e.search(Dt),
          St = /(?:\uD83C[\uDDE6-\uDDFF])+$/g,
          Et = e => {
            var t = e.match(St);
            return null !== t && t[0].length / 2 % 2 == 1;
          },
          _t = {
            delete(e, t) {
              e.delete(t);
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertText(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              je.withoutNormalizing(e, () => {
                var {
                    voids: r = !1
                  } = n,
                  {
                    at: o = Xe(e)
                  } = n;
                if (fe.isPath(o) && (o = je.range(e, o)), Ee.isRange(o)) if (Ee.isCollapsed(o)) o = o.anchor;else {
                  var i = Ee.end(o);
                  if (!r && je.void(e, {
                    at: i
                  })) return;
                  var a = Ee.start(o),
                    s = je.pointRef(e, a),
                    l = je.pointRef(e, i);
                  At.delete(e, {
                    at: o,
                    voids: r
                  });
                  var u = s.unref(),
                    c = l.unref();
                  o = u || c, At.setSelection(e, {
                    anchor: o,
                    focus: o
                  });
                }
                if (!(!r && je.void(e, {
                  at: o
                }) || je.elementReadOnly(e, {
                  at: o
                }))) {
                  var {
                    path: d,
                    offset: p
                  } = o;
                  t.length > 0 && e.apply({
                    type: "insert_text",
                    path: d,
                    offset: p,
                    text: t
                  });
                }
              });
            }
          };
        function Pt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function kt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var At = kt(kt(kt(kt({}, ye), be), we), _t),
          zt = (e, t) => {
            for (var n of je.pathRefs(e)) oe.transform(n, t);
            for (var r of je.pointRefs(e)) ie.transform(r, t);
            for (var o of je.rangeRefs(e)) ae.transform(o, t);
            var i,
              a,
              s = se.get(e) || [],
              l = le.get(e) || new Set(),
              u = e => {
                if (e) {
                  var t = e.join(",");
                  a.has(t) || (a.add(t), i.push(e));
                }
              };
            if (fe.operationCanTransformPath(t)) for (var c of (i = [], a = new Set(), s)) {
              u(fe.transform(c, t));
            } else i = s, a = l;
            var d = e.getDirtyPaths(t);
            for (var p of d) u(p);
            se.set(e, i), le.set(e, a), At.transform(e, t), e.operations.push(t), je.normalize(e, {
              operation: t
            }), "set_selection" === t.type && (e.marks = null), ue.get(e) || (ue.set(e, !0), Promise.resolve().then(() => {
              ue.set(e, !1), e.onChange({
                operation: t
              }), e.operations = [];
            }));
          },
          Tt = (e, t) => {
            switch (t.type) {
              case "insert_text":
              case "remove_text":
              case "set_node":
                var {
                  path: n
                } = t;
                return fe.levels(n);
              case "insert_node":
                var {
                    node: r,
                    path: o
                  } = t,
                  i = fe.levels(o),
                  a = Ye.isText(r) ? [] : Array.from(Te.nodes(r), e => {
                    var [, t] = e;
                    return o.concat(t);
                  });
                return [...i, ...a];
              case "merge_node":
                var {
                  path: s
                } = t;
                return [...fe.ancestors(s), fe.previous(s)];
              case "move_node":
                var {
                  path: l,
                  newPath: u
                } = t;
                if (fe.equals(l, u)) return [];
                var c = [],
                  d = [];
                for (var p of fe.ancestors(l)) {
                  var h = fe.transform(p, t);
                  c.push(h);
                }
                for (var f of fe.ancestors(u)) {
                  var m = fe.transform(f, t);
                  d.push(m);
                }
                var g = d[d.length - 1],
                  v = u[u.length - 1],
                  y = g.concat(v);
                return [...c, ...d, y];
              case "remove_node":
                var {
                  path: b
                } = t;
                return [...fe.ancestors(b)];
              case "split_node":
                var {
                  path: w
                } = t;
                return [...fe.levels(w), fe.next(w)];
              default:
                return [];
            }
          },
          Ot = e => {
            var {
              selection: t
            } = e;
            return t ? Te.fragment(e, t) : [];
          },
          It = (e, t) => {
            var [n, r] = t;
            if (!Ye.isText(n)) if (Pe.isElement(n) && 0 === n.children.length) {
              At.insertNodes(e, {
                text: ""
              }, {
                at: r.concat(0),
                voids: !0
              });
            } else for (var o = !je.isEditor(n) && Pe.isElement(n) && (e.isInline(n) || 0 === n.children.length || Ye.isText(n.children[0]) || e.isInline(n.children[0])), i = 0, a = 0; a < n.children.length; a++, i++) {
              var s = Te.get(e, r);
              if (!Ye.isText(s)) {
                var l = s.children[i],
                  u = s.children[i - 1],
                  c = a === n.children.length - 1;
                if ((Ye.isText(l) || Pe.isElement(l) && e.isInline(l)) !== o) At.removeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--;else if (Pe.isElement(l)) {
                  if (e.isInline(l)) if (null != u && Ye.isText(u)) {
                    if (c) {
                      At.insertNodes(e, {
                        text: ""
                      }, {
                        at: r.concat(i + 1),
                        voids: !0
                      }), i++;
                    }
                  } else {
                    At.insertNodes(e, {
                      text: ""
                    }, {
                      at: r.concat(i),
                      voids: !0
                    }), i++;
                  }
                } else null != u && Ye.isText(u) && (Ye.equals(l, u, {
                  loose: !0
                }) ? (At.mergeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--) : "" === u.text ? (At.removeNodes(e, {
                  at: r.concat(i - 1),
                  voids: !0
                }), i--) : "" === l.text && (At.removeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--));
              }
            }
          },
          Ft = (e, t) => {
            var {
                iteration: n,
                initialDirtyPathsLength: r
              } = t,
              o = 42 * r;
            if (n > o) throw new Error("Could not completely normalize the editor after ".concat(o, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
            return !0;
          },
          Mt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                voids: n = !1,
                mode: r = "lowest",
                at: o = e.selection,
                match: i
              } = t;
            if (o) {
              var a = je.path(e, o),
                s = "lowest" === r;
              for (var [l, u] of je.levels(e, {
                at: a,
                voids: n,
                match: i,
                reverse: s
              })) if (!Ye.isText(l)) if (Ee.isRange(o)) {
                if (fe.isAncestor(u, o.anchor.path) && fe.isAncestor(u, o.focus.path)) return [l, u];
              } else if (!fe.equals(a, u)) return [l, u];
            }
          };
        function Rt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function jt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Rt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Bt = (e, t, n) => {
          var {
            selection: r
          } = e;
          if (r) {
            var o = (t, n) => {
                if (!Ye.isText(t)) return !1;
                var [r, o] = je.parent(e, n);
                return !e.isVoid(r) || e.markableVoid(r);
              },
              i = Ee.isExpanded(r),
              a = !1;
            if (!i) {
              var [s, l] = je.node(e, r);
              if (s && o(s, l)) {
                var [u] = je.parent(e, l);
                a = u && e.markableVoid(u);
              }
            }
            if (i || a) At.setNodes(e, {
              [t]: n
            }, {
              match: o,
              split: !0,
              voids: !0
            });else {
              var c = jt(jt({}, je.marks(e) || {}), {}, {
                [t]: n
              });
              e.marks = c, ue.get(e) || e.onChange();
            }
          }
        };
        function Nt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Lt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Nt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Vt = function (e, t) {
          var n,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = je.point(e, t, {
              edge: "end"
            }),
            i = je.end(e, []),
            a = {
              anchor: o,
              focus: i
            },
            {
              distance: s = 1
            } = r,
            l = 0;
          for (var u of je.positions(e, Lt(Lt({}, r), {}, {
            at: a
          }))) {
            if (l > s) break;
            0 !== l && (n = u), l++;
          }
          return n;
        };
        function Kt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function qt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Kt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ht = function (e, t) {
            var n,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = je.start(e, []),
              i = je.point(e, t, {
                edge: "start"
              }),
              a = {
                anchor: o,
                focus: i
              },
              {
                distance: s = 1
              } = r,
              l = 0;
            for (var u of je.positions(e, qt(qt({}, r), {}, {
              at: a,
              reverse: !0
            }))) {
              if (l > s) break;
              0 !== l && (n = u), l++;
            }
            return n;
          },
          Ut = (e, t) => {
            var {
              selection: n
            } = e;
            n && Ee.isCollapsed(n) && At.delete(e, {
              unit: t,
              reverse: !0
            });
          },
          Zt = (e, t) => {
            var {
              selection: n
            } = e;
            n && Ee.isCollapsed(n) && At.delete(e, {
              unit: t
            });
          },
          $t = function (e) {
            var {
                direction: t = "forward"
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e;
            n && Ee.isExpanded(n) && At.delete(e, {
              reverse: "backward" === t
            });
          },
          Gt = (e, t) => [je.start(e, t), je.end(e, t)];
        function Wt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Yt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Wt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Xt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return je.above(e, Yt(Yt({}, t), {}, {
              match: t => Pe.isElement(t) && je.isElementReadOnly(e, t)
            }));
          },
          Qt = (e, t) => je.point(e, t, {
            edge: "end"
          }),
          Jt = (e, t) => {
            var n = je.path(e, t, {
              edge: "start"
            });
            return je.node(e, n);
          },
          en = (e, t) => {
            var n = je.range(e, t);
            return Te.fragment(e, n);
          };
        function tn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function nn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? tn(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var rn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return je.above(e, nn(nn({}, t), {}, {
              match: t => Pe.isElement(t) && je.isVoid(e, t)
            }));
          },
          on = (e, t) => t.children.some(t => Pe.isElement(t) && je.isBlock(e, t)),
          an = (e, t) => t.children.some(t => Ye.isText(t) || je.isInline(e, t)),
          sn = (e, t) => Te.has(e, t),
          ln = (e, t) => t.children.every(e => Ye.isText(e)),
          un = e => {
            At.splitNodes(e, {
              always: !0
            });
          },
          cn = (e, t, n) => {
            At.insertNodes(e, t, n);
          },
          dn = e => {
            At.splitNodes(e, {
              always: !0
            });
          };
        function pn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function hn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? pn(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var fn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r,
                marks: o
              } = e;
            if (r) {
              if (o) {
                var i = hn({
                  text: t
                }, o);
                At.insertNodes(e, i, {
                  at: n.at,
                  voids: n.voids
                });
              } else At.insertText(e, t, n);
              e.marks = null;
            }
          },
          mn = (e, t) => !e.isInline(t),
          gn = (e, t, n) => je.isStart(e, t, n) || je.isEnd(e, t, n),
          vn = (e, t) => {
            var {
                children: n
              } = t,
              [r] = n;
            return 0 === n.length || 1 === n.length && Ye.isText(r) && "" === r.text && !e.isVoid(t);
          },
          yn = (e, t, n) => {
            var r = je.end(e, n);
            return Ke.equals(t, r);
          },
          bn = e => {
            var t = ce.get(e);
            return void 0 === t || t;
          },
          wn = (e, t, n) => {
            if (0 !== t.offset) return !1;
            var r = je.start(e, n);
            return Ke.equals(t, r);
          },
          xn = (e, t) => {
            var n = je.path(e, t, {
              edge: "end"
            });
            return je.node(e, n);
          },
          Dn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = je.path(e, t, n),
              o = Te.leaf(e, r);
            return [o, r];
          };
        function* Cn(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              reverse: r = !1,
              voids: o = !1
            } = t,
            {
              match: i
            } = t;
          if (null == i && (i = () => !0), n) {
            var a = [],
              s = je.path(e, n);
            for (var [l, u] of Te.levels(e, s)) if (i(l, u) && (a.push([l, u]), !o && Pe.isElement(l) && je.isVoid(e, l))) break;
            r && a.reverse(), yield* a;
          }
        }
        var Sn = ["text"],
          En = ["text"],
          _n = function (e) {
            var {
              marks: t,
              selection: n
            } = e;
            if (!n) return null;
            if (t) return t;
            if (Ee.isExpanded(n)) {
              var [r] = je.nodes(e, {
                match: Ye.isText
              });
              if (r) {
                var [o] = r;
                return De(o, Sn);
              }
              return {};
            }
            var {
                anchor: i
              } = n,
              {
                path: a
              } = i,
              [s] = je.leaf(e, a);
            if (0 === i.offset) {
              var l = je.previous(e, {
                  at: a,
                  match: Ye.isText
                }),
                u = je.above(e, {
                  match: t => Pe.isElement(t) && je.isVoid(e, t) && e.markableVoid(t)
                });
              if (!u) {
                var c = je.above(e, {
                  match: t => Pe.isElement(t) && je.isBlock(e, t)
                });
                if (l && c) {
                  var [d, p] = l,
                    [, h] = c;
                  fe.isAncestor(h, p) && (s = d);
                }
              }
            }
            return De(s, En);
          },
          Pn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = je.after(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = je.last(e, []),
                  l = [a.path, s];
                if (fe.isPath(i) && 0 === i.length) throw new Error("Cannot get the next node from the root node!");
                if (null == o) if (fe.isPath(i)) {
                  var [u] = je.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = je.nodes(e, {
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          kn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = je.path(e, t, n),
              o = Te.get(e, r);
            return [o, r];
          };
        function* An(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              mode: r = "all",
              universal: o = !1,
              reverse: i = !1,
              voids: a = !1,
              ignoreNonSelectable: s = !1
            } = t,
            {
              match: l
            } = t;
          if (l || (l = () => !0), n) {
            var u, c;
            if (Ne.isSpan(n)) u = n[0], c = n[1];else {
              var d = je.path(e, n, {
                  edge: "start"
                }),
                p = je.path(e, n, {
                  edge: "end"
                });
              u = i ? p : d, c = i ? d : p;
            }
            var h,
              f = Te.nodes(e, {
                reverse: i,
                from: u,
                to: c,
                pass: t => {
                  var [n] = t;
                  return !!Pe.isElement(n) && (!(a || !je.isVoid(e, n) && !je.isElementReadOnly(e, n)) || !(!s || je.isSelectable(e, n)));
                }
              }),
              m = [];
            for (var [g, v] of f) if (!s || !Pe.isElement(g) || je.isSelectable(e, g)) {
              var y = h && 0 === fe.compare(v, h[1]);
              if ("highest" !== r || !y) if (l(g, v)) {
                if ("lowest" === r && y) h = [g, v];else {
                  var b = "lowest" === r ? h : [g, v];
                  b && (o ? m.push(b) : yield b), h = [g, v];
                }
              } else if (o && !y && Ye.isText(g)) return;
            }
            "lowest" === r && h && (o ? m.push(h) : yield h), o && (yield* m);
          }
        }
        var zn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                force: n = !1,
                operation: r
              } = t,
              o = e => se.get(e) || [],
              i = e => le.get(e) || new Set(),
              a = e => {
                var t = o(e).pop(),
                  n = t.join(",");
                return i(e).delete(n), t;
              };
            if (je.isNormalizing(e)) {
              if (n) {
                var s = Array.from(Te.nodes(e), e => {
                    var [, t] = e;
                    return t;
                  }),
                  l = new Set(s.map(e => e.join(",")));
                se.set(e, s), le.set(e, l);
              }
              0 !== o(e).length && je.withoutNormalizing(e, () => {
                for (var t of o(e)) if (Te.has(e, t)) {
                  var n = je.node(e, t),
                    [i, s] = n;
                  Pe.isElement(i) && 0 === i.children.length && e.normalizeNode(n, {
                    operation: r
                  });
                }
                for (var l = o(e), u = l.length, c = 0; 0 !== l.length;) {
                  if (!e.shouldNormalize({
                    dirtyPaths: l,
                    iteration: c,
                    initialDirtyPathsLength: u,
                    operation: r
                  })) return;
                  var d = a(e);
                  if (Te.has(e, d)) {
                    var p = je.node(e, d);
                    e.normalizeNode(p, {
                      operation: r
                    });
                  }
                  c++, l = o(e);
                }
              });
            }
          },
          Tn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = je.path(e, t, n),
              o = fe.parent(r),
              i = je.node(e, o);
            return i;
          },
          On = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return je.pathRefs(e).delete(o), o.current = null, t;
                }
              },
              i = je.pathRefs(e);
            return i.add(o), o;
          },
          In = e => {
            var t = de.get(e);
            return t || (t = new Set(), de.set(e, t)), t;
          },
          Fn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                depth: r,
                edge: o
              } = n;
            if (fe.isPath(t)) if ("start" === o) {
              var [, i] = Te.first(e, t);
              t = i;
            } else if ("end" === o) {
              var [, a] = Te.last(e, t);
              t = a;
            }
            return Ee.isRange(t) && (t = "start" === o ? Ee.start(t) : "end" === o ? Ee.end(t) : fe.common(t.anchor.path, t.focus.path)), Ke.isPoint(t) && (t = t.path), null != r && (t = t.slice(0, r)), t;
          },
          Mn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return je.pointRefs(e).delete(o), o.current = null, t;
                }
              },
              i = je.pointRefs(e);
            return i.add(o), o;
          },
          Rn = e => {
            var t = pe.get(e);
            return t || (t = new Set(), pe.set(e, t)), t;
          },
          jn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                edge: r = "start"
              } = n;
            if (fe.isPath(t)) {
              var o;
              if ("end" === r) {
                var [, i] = Te.last(e, t);
                o = i;
              } else {
                var [, a] = Te.first(e, t);
                o = a;
              }
              var s = Te.get(e, o);
              if (!Ye.isText(s)) throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
              return {
                path: o,
                offset: "end" === r ? s.text.length : 0
              };
            }
            if (Ee.isRange(t)) {
              var [l, u] = Ee.edges(t);
              return "start" === r ? l : u;
            }
            return t;
          };
        function* Bn(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              unit: r = "offset",
              reverse: o = !1,
              voids: i = !1,
              ignoreNonSelectable: a = !1
            } = t;
          if (n) {
            var s = je.range(e, n),
              [l, u] = Ee.edges(s),
              c = o ? u : l,
              d = !1,
              p = "",
              h = 0,
              f = 0,
              m = 0;
            for (var [g, v] of je.nodes(e, {
              at: n,
              reverse: o,
              voids: i,
              ignoreNonSelectable: a
            })) {
              if (Pe.isElement(g)) {
                if (!i && (e.isVoid(g) || e.isElementReadOnly(g))) {
                  yield je.start(e, v);
                  continue;
                }
                if (e.isInline(g)) continue;
                if (je.hasInlines(e, g)) {
                  var y = fe.isAncestor(v, u.path) ? u : je.end(e, v),
                    b = fe.isAncestor(v, l.path) ? l : je.start(e, v);
                  p = je.string(e, {
                    anchor: b,
                    focus: y
                  }, {
                    voids: i
                  }), d = !0;
                }
              }
              if (Ye.isText(g)) {
                var w = fe.equals(v, c.path);
                for (w ? (f = o ? c.offset : g.text.length - c.offset, m = c.offset) : (f = g.text.length, m = o ? f : 0), (w || d || "offset" === r) && (yield {
                  path: v,
                  offset: m
                }, d = !1);;) {
                  if (0 === h) {
                    if ("" === p) break;
                    h = x(p, r, o), p = ot(p, h, o)[1];
                  }
                  if (m = o ? m - h : m + h, (f -= h) < 0) {
                    h = -f;
                    break;
                  }
                  h = 0, yield {
                    path: v,
                    offset: m
                  };
                }
              }
            }
          }
          function x(e, t, n) {
            return "character" === t ? Je(e, n) : "word" === t ? rt(e, n) : "line" === t || "block" === t ? e.length : 1;
          }
        }
        var Nn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = je.before(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = je.first(e, []),
                  l = [a.path, s];
                if (fe.isPath(i) && 0 === i.length) throw new Error("Cannot get the previous node from the root node!");
                if (null == o) if (fe.isPath(i)) {
                  var [u] = je.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = je.nodes(e, {
                  reverse: !0,
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          Ln = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return je.rangeRefs(e).delete(o), o.current = null, t;
                }
              },
              i = je.rangeRefs(e);
            return i.add(o), o;
          },
          Vn = e => {
            var t = he.get(e);
            return t || (t = new Set(), he.set(e, t)), t;
          },
          Kn = (e, t, n) => Ee.isRange(t) && !n ? t : {
            anchor: je.start(e, t),
            focus: je.end(e, n || t)
          };
        function qn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Hn = (e, t) => {
            var {
              selection: n
            } = e;
            if (n) {
              var r = (t, n) => {
                  if (!Ye.isText(t)) return !1;
                  var [r, o] = je.parent(e, n);
                  return !e.isVoid(r) || e.markableVoid(r);
                },
                o = Ee.isExpanded(n),
                i = !1;
              if (!o) {
                var [a, s] = je.node(e, n);
                if (a && r(a, s)) {
                  var [l] = je.parent(e, s);
                  i = l && e.markableVoid(l);
                }
              }
              if (o || i) At.unsetNodes(e, t, {
                match: r,
                split: !0,
                voids: !0
              });else {
                var u = function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? qn(Object(n), !0).forEach(function (t) {
                      me(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qn(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                  }
                  return e;
                }({}, je.marks(e) || {});
                delete u[t], e.marks = u, ue.get(e) || e.onChange();
              }
            }
          },
          Un = (e, t) => {
            ce.set(e, t);
          },
          Zn = (e, t) => je.point(e, t, {
            edge: "start"
          }),
          $n = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              o = je.range(e, t),
              [i, a] = Ee.edges(o),
              s = "";
            for (var [l, u] of je.nodes(e, {
              at: o,
              match: Ye.isText,
              voids: r
            })) {
              var c = l.text;
              fe.equals(u, a.path) && (c = c.slice(0, a.offset)), fe.equals(u, i.path) && (c = c.slice(i.offset)), s += c;
            }
            return s;
          },
          Gn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              [o, i] = Ee.edges(t);
            if (0 !== o.offset || 0 !== i.offset || Ee.isCollapsed(t) || fe.hasPrevious(i.path)) return t;
            var a = je.above(e, {
                at: i,
                match: t => Pe.isElement(t) && je.isBlock(e, t),
                voids: r
              }),
              s = a ? a[1] : [],
              l = je.start(e, o),
              u = {
                anchor: l,
                focus: i
              },
              c = !0;
            for (var [d, p] of je.nodes(e, {
              at: u,
              match: Ye.isText,
              reverse: !0,
              voids: r
            })) if (c) c = !1;else if ("" !== d.text || fe.isBefore(p, s)) {
              i = {
                path: p,
                offset: d.text.length
              };
              break;
            }
            return {
              anchor: o,
              focus: i
            };
          },
          Wn = (e, t) => {
            var n = je.isNormalizing(e);
            je.setNormalizing(e, !1);
            try {
              t();
            } finally {
              je.setNormalizing(e, n);
            }
            je.normalize(e);
          },
          Yn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var n,
                r,
                {
                  reverse: o = !1,
                  unit: i = "character",
                  distance: a = 1,
                  voids: s = !1
                } = t,
                {
                  at: l = e.selection,
                  hanging: u = !1
                } = t;
              if (l) {
                var c = !1;
                if (Ee.isRange(l) && Ee.isCollapsed(l) && (c = !0, l = l.anchor), Ke.isPoint(l)) {
                  var d = je.void(e, {
                    at: l,
                    mode: "highest"
                  });
                  if (!s && d) {
                    var [, p] = d;
                    l = p;
                  } else {
                    var h = {
                      unit: i,
                      distance: a
                    };
                    l = {
                      anchor: l,
                      focus: o ? je.before(e, l, h) || je.start(e, []) : je.after(e, l, h) || je.end(e, [])
                    }, u = !0;
                  }
                }
                if (fe.isPath(l)) At.removeNodes(e, {
                  at: l,
                  voids: s
                });else if (!Ee.isCollapsed(l)) {
                  if (!u) {
                    var [, f] = Ee.edges(l),
                      m = je.end(e, []);
                    Ke.equals(f, m) || (l = je.unhangRange(e, l, {
                      voids: s
                    }));
                  }
                  var [g, v] = Ee.edges(l),
                    y = je.above(e, {
                      match: t => Pe.isElement(t) && je.isBlock(e, t),
                      at: g,
                      voids: s
                    }),
                    b = je.above(e, {
                      match: t => Pe.isElement(t) && je.isBlock(e, t),
                      at: v,
                      voids: s
                    }),
                    w = y && b && !fe.equals(y[1], b[1]),
                    x = fe.equals(g.path, v.path),
                    D = s ? null : null !== (n = je.void(e, {
                      at: g,
                      mode: "highest"
                    })) && void 0 !== n ? n : je.elementReadOnly(e, {
                      at: g,
                      mode: "highest"
                    }),
                    C = s ? null : null !== (r = je.void(e, {
                      at: v,
                      mode: "highest"
                    })) && void 0 !== r ? r : je.elementReadOnly(e, {
                      at: v,
                      mode: "highest"
                    });
                  if (D) {
                    var S = je.before(e, g);
                    S && y && fe.isAncestor(y[1], S.path) && (g = S);
                  }
                  if (C) {
                    var E = je.after(e, v);
                    E && b && fe.isAncestor(b[1], E.path) && (v = E);
                  }
                  var _,
                    P = [];
                  for (var k of je.nodes(e, {
                    at: l,
                    voids: s
                  })) {
                    var [A, z] = k;
                    _ && 0 === fe.compare(z, _) || (!s && Pe.isElement(A) && (je.isVoid(e, A) || je.isElementReadOnly(e, A)) || !fe.isCommon(z, g.path) && !fe.isCommon(z, v.path)) && (P.push(k), _ = z);
                  }
                  var T = Array.from(P, t => {
                      var [, n] = t;
                      return je.pathRef(e, n);
                    }),
                    O = je.pointRef(e, g),
                    I = je.pointRef(e, v),
                    F = "";
                  if (!x && !D) {
                    var M = O.current,
                      [R] = je.leaf(e, M),
                      {
                        path: j
                      } = M,
                      {
                        offset: B
                      } = g,
                      N = R.text.slice(B);
                    N.length > 0 && (e.apply({
                      type: "remove_text",
                      path: j,
                      offset: B,
                      text: N
                    }), F = N);
                  }
                  if (T.reverse().map(e => e.unref()).filter(e => null !== e).forEach(t => At.removeNodes(e, {
                    at: t,
                    voids: s
                  })), !C) {
                    var L = I.current,
                      [V] = je.leaf(e, L),
                      {
                        path: K
                      } = L,
                      q = x ? g.offset : 0,
                      H = V.text.slice(q, v.offset);
                    H.length > 0 && (e.apply({
                      type: "remove_text",
                      path: K,
                      offset: q,
                      text: H
                    }), F = H);
                  }
                  !x && w && I.current && O.current && At.mergeNodes(e, {
                    at: I.current,
                    hanging: !0,
                    voids: s
                  }), c && o && "character" === i && F.length > 1 && F.match(/[\u0E00-\u0E7F]+/) && At.insertText(e, F.slice(0, F.length - a));
                  var U = O.unref(),
                    Z = I.unref(),
                    $ = o ? U || Z : Z || U;
                  null == t.at && $ && At.select(e, $);
                }
              }
            });
          },
          Xn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            je.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1
                } = n,
                {
                  at: i = Xe(e)
                } = n;
              if (t.length) {
                if (Ee.isRange(i)) {
                  if (r || (i = je.unhangRange(e, i, {
                    voids: o
                  })), Ee.isCollapsed(i)) i = i.anchor;else {
                    var [, a] = Ee.edges(i);
                    if (!o && je.void(e, {
                      at: a
                    })) return;
                    var s = je.pointRef(e, a);
                    At.delete(e, {
                      at: i
                    }), i = s.unref();
                  }
                } else fe.isPath(i) && (i = je.start(e, i));
                if (o || !je.void(e, {
                  at: i
                })) {
                  var l = je.above(e, {
                    at: i,
                    match: t => Pe.isElement(t) && je.isInline(e, t),
                    mode: "highest",
                    voids: o
                  });
                  if (l) {
                    var [, u] = l;
                    if (je.isEnd(e, i, u)) i = je.after(e, u);else if (je.isStart(e, i, u)) {
                      i = je.before(e, u);
                    }
                  }
                  var c = je.above(e, {
                      match: t => Pe.isElement(t) && je.isBlock(e, t),
                      at: i,
                      voids: o
                    }),
                    [, d] = c,
                    p = je.isStart(e, i, d),
                    h = je.isEnd(e, i, d),
                    f = p && h,
                    m = !p || p && h,
                    g = !h,
                    [, v] = Te.first({
                      children: t
                    }, []),
                    [, y] = Te.last({
                      children: t
                    }, []),
                    b = [],
                    w = t => {
                      var [n, r] = t;
                      return !(0 === r.length) && (!!f || !(m && fe.isAncestor(r, v) && Pe.isElement(n) && !e.isVoid(n) && !e.isInline(n)) && !(g && fe.isAncestor(r, y) && Pe.isElement(n) && !e.isVoid(n) && !e.isInline(n)));
                    };
                  for (var x of Te.nodes({
                    children: t
                  }, {
                    pass: w
                  })) w(x) && b.push(x);
                  var D = [],
                    C = [],
                    S = [],
                    E = !0,
                    _ = !1;
                  for (var [P] of b) Pe.isElement(P) && !e.isInline(P) ? (E = !1, _ = !0, C.push(P)) : E ? D.push(P) : S.push(P);
                  var [k] = je.nodes(e, {
                      at: i,
                      match: t => Ye.isText(t) || je.isInline(e, t),
                      mode: "highest",
                      voids: o
                    }),
                    [, A] = k,
                    z = je.isStart(e, i, A),
                    T = je.isEnd(e, i, A),
                    O = je.pathRef(e, h && !S.length ? fe.next(d) : d),
                    I = je.pathRef(e, T ? fe.next(A) : A);
                  At.splitNodes(e, {
                    at: i,
                    match: t => _ ? Pe.isElement(t) && je.isBlock(e, t) : Ye.isText(t) || je.isInline(e, t),
                    mode: _ ? "lowest" : "highest",
                    always: _ && (!p || D.length > 0) && (!h || S.length > 0),
                    voids: o
                  });
                  var F,
                    M = je.pathRef(e, !z || z && T ? fe.next(A) : A);
                  if (At.insertNodes(e, D, {
                    at: M.current,
                    match: t => Ye.isText(t) || je.isInline(e, t),
                    mode: "highest",
                    voids: o
                  }), f && !D.length && C.length && !S.length && At.delete(e, {
                    at: d,
                    voids: o
                  }), At.insertNodes(e, C, {
                    at: O.current,
                    match: t => Pe.isElement(t) && je.isBlock(e, t),
                    mode: "lowest",
                    voids: o
                  }), At.insertNodes(e, S, {
                    at: I.current,
                    match: t => Ye.isText(t) || je.isInline(e, t),
                    mode: "highest",
                    voids: o
                  }), !n.at) if (S.length > 0 && I.current ? F = fe.previous(I.current) : C.length > 0 && O.current ? F = fe.previous(O.current) : M.current && (F = fe.previous(M.current)), F) {
                    var R = je.end(e, F);
                    At.select(e, R);
                  }
                  M.unref(), O.unref(), I.unref();
                }
              }
            });
          },
          Qn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                edge: n = "anchor"
              } = t,
              {
                selection: r
              } = e;
            if (r) if ("anchor" === n) At.select(e, r.anchor);else if ("focus" === n) At.select(e, r.focus);else if ("start" === n) {
              var [o] = Ee.edges(r);
              At.select(e, o);
            } else if ("end" === n) {
              var [, i] = Ee.edges(r);
              At.select(e, i);
            }
          },
          Jn = e => {
            var {
              selection: t
            } = e;
            t && e.apply({
              type: "set_selection",
              properties: t,
              newProperties: null
            });
          },
          er = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e,
              {
                distance: r = 1,
                unit: o = "character",
                reverse: i = !1
              } = t,
              {
                edge: a = null
              } = t;
            if (n) {
              "start" === a && (a = Ee.isBackward(n) ? "focus" : "anchor"), "end" === a && (a = Ee.isBackward(n) ? "anchor" : "focus");
              var {
                  anchor: s,
                  focus: l
                } = n,
                u = {
                  distance: r,
                  unit: o,
                  ignoreNonSelectable: !0
                },
                c = {};
              if (null == a || "anchor" === a) {
                var d = i ? je.before(e, s, u) : je.after(e, s, u);
                d && (c.anchor = d);
              }
              if (null == a || "focus" === a) {
                var p = i ? je.before(e, l, u) : je.after(e, l, u);
                p && (c.focus = p);
              }
              At.setSelection(e, c);
            }
          },
          tr = (e, t) => {
            var {
              selection: n
            } = e;
            if (t = je.range(e, t), n) At.setSelection(e, t);else {
              if (!Ee.isRange(t)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(He.stringify(t)));
              e.apply({
                type: "set_selection",
                properties: n,
                newProperties: t
              });
            }
          };
        function nr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function rr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? nr(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var or = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r
              } = e,
              {
                edge: o = "both"
              } = n;
            if (r) {
              "start" === o && (o = Ee.isBackward(r) ? "focus" : "anchor"), "end" === o && (o = Ee.isBackward(r) ? "anchor" : "focus");
              var {
                  anchor: i,
                  focus: a
                } = r,
                s = "anchor" === o ? i : a;
              At.setSelection(e, {
                ["anchor" === o ? "anchor" : "focus"]: rr(rr({}, s), t)
              });
            }
          },
          ir = (e, t) => {
            var {
                selection: n
              } = e,
              r = {},
              o = {};
            if (n) {
              for (var i in t) ("anchor" === i && null != t.anchor && !Ke.equals(t.anchor, n.anchor) || "focus" === i && null != t.focus && !Ke.equals(t.focus, n.focus) || "anchor" !== i && "focus" !== i && t[i] !== n[i]) && (r[i] = n[i], o[i] = t[i]);
              Object.keys(r).length > 0 && e.apply({
                type: "set_selection",
                properties: r,
                newProperties: o
              });
            }
          },
          ar = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            je.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1,
                  mode: i = "lowest"
                } = n,
                {
                  at: a,
                  match: s,
                  select: l
                } = n;
              if (Te.isNode(t) && (t = [t]), 0 !== t.length) {
                var [u] = t;
                if (a || (a = Xe(e), l = !0), null == l && (l = !1), Ee.isRange(a)) if (r || (a = je.unhangRange(e, a, {
                  voids: o
                })), Ee.isCollapsed(a)) a = a.anchor;else {
                  var [, c] = Ee.edges(a),
                    d = je.pointRef(e, c);
                  At.delete(e, {
                    at: a
                  }), a = d.unref();
                }
                if (Ke.isPoint(a)) {
                  null == s && (s = Ye.isText(u) ? e => Ye.isText(e) : e.isInline(u) ? t => Ye.isText(t) || je.isInline(e, t) : t => Pe.isElement(t) && je.isBlock(e, t));
                  var [p] = je.nodes(e, {
                    at: a.path,
                    match: s,
                    mode: i,
                    voids: o
                  });
                  if (!p) return;
                  var [, h] = p,
                    f = je.pathRef(e, h),
                    m = je.isEnd(e, a, h);
                  At.splitNodes(e, {
                    at: a,
                    match: s,
                    mode: i,
                    voids: o
                  });
                  var g = f.unref();
                  a = m ? fe.next(g) : g;
                }
                var v = fe.parent(a),
                  y = a[a.length - 1];
                if (o || !je.void(e, {
                  at: v
                })) {
                  for (var b of t) {
                    var w = v.concat(y);
                    y++, e.apply({
                      type: "insert_node",
                      path: w,
                      node: b
                    }), a = fe.next(a);
                  }
                  if (a = fe.previous(a), l) {
                    var x = je.end(e, a);
                    x && At.select(e, x);
                  }
                }
              }
            });
          },
          sr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var {
                  at: n = e.selection,
                  mode: r = "lowest",
                  voids: o = !1
                } = t,
                {
                  match: i
                } = t;
              if (null == i && (i = fe.isPath(n) ? Qe(e, n) : t => Pe.isElement(t) && je.isBlock(e, t)), n) {
                var a = je.nodes(e, {
                    at: n,
                    match: i,
                    mode: r,
                    voids: o
                  }),
                  s = Array.from(a, t => {
                    var [, n] = t;
                    return je.pathRef(e, n);
                  });
                for (var l of s) {
                  var u = l.unref();
                  if (u.length < 2) throw new Error("Cannot lift node at a path [".concat(u, "] because it has a depth of less than `2`."));
                  var c = je.node(e, fe.parent(u)),
                    [d, p] = c,
                    h = u[u.length - 1],
                    {
                      length: f
                    } = d.children;
                  if (1 === f) {
                    var m = fe.next(p);
                    At.moveNodes(e, {
                      at: u,
                      to: m,
                      voids: o
                    }), At.removeNodes(e, {
                      at: p,
                      voids: o
                    });
                  } else if (0 === h) At.moveNodes(e, {
                    at: u,
                    to: p,
                    voids: o
                  });else if (h === f - 1) {
                    var g = fe.next(p);
                    At.moveNodes(e, {
                      at: u,
                      to: g,
                      voids: o
                    });
                  } else {
                    var v = fe.next(u),
                      y = fe.next(p);
                    At.splitNodes(e, {
                      at: v,
                      voids: o
                    }), At.moveNodes(e, {
                      at: u,
                      to: y,
                      voids: o
                    });
                  }
                }
              }
            });
          },
          lr = ["text"],
          ur = ["children"],
          cr = (e, t) => {
            if (Pe.isElement(t)) {
              var n = t;
              return !!je.isVoid(e, t) || 1 === n.children.length && cr(e, n.children[0]);
            }
            return !je.isEditor(t);
          },
          dr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var {
                  match: n,
                  at: r = e.selection
                } = t,
                {
                  hanging: o = !1,
                  voids: i = !1,
                  mode: a = "lowest"
                } = t;
              if (r) {
                if (null == n) if (fe.isPath(r)) {
                  var [s] = je.parent(e, r);
                  n = e => s.children.includes(e);
                } else n = t => Pe.isElement(t) && je.isBlock(e, t);
                if (!o && Ee.isRange(r) && (r = je.unhangRange(e, r, {
                  voids: i
                })), Ee.isRange(r)) if (Ee.isCollapsed(r)) r = r.anchor;else {
                  var [, l] = Ee.edges(r),
                    u = je.pointRef(e, l);
                  At.delete(e, {
                    at: r
                  }), r = u.unref(), null == t.at && At.select(e, r);
                }
                var [c] = je.nodes(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  }),
                  d = je.previous(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  });
                if (c && d) {
                  var [p, h] = c,
                    [f, m] = d;
                  if (0 !== h.length && 0 !== m.length) {
                    var g,
                      v,
                      y = fe.next(m),
                      b = fe.common(h, m),
                      w = fe.isSibling(h, m),
                      x = Array.from(je.levels(e, {
                        at: h
                      }), e => {
                        var [t] = e;
                        return t;
                      }).slice(b.length).slice(0, -1),
                      D = je.above(e, {
                        at: h,
                        mode: "highest",
                        match: t => x.includes(t) && cr(e, t)
                      }),
                      C = D && je.pathRef(e, D[1]);
                    if (Ye.isText(p) && Ye.isText(f)) {
                      var S = De(p, lr);
                      v = f.text.length, g = S;
                    } else {
                      if (!Pe.isElement(p) || !Pe.isElement(f)) throw new Error("Cannot merge the node at path [".concat(h, "] with the previous sibling because it is not the same kind: ").concat(He.stringify(p), " ").concat(He.stringify(f)));
                      S = De(p, ur);
                      v = f.children.length, g = S;
                    }
                    w || At.moveNodes(e, {
                      at: h,
                      to: y,
                      voids: i
                    }), C && At.removeNodes(e, {
                      at: C.current,
                      voids: i
                    }), Pe.isElement(f) && je.isEmpty(e, f) || Ye.isText(f) && "" === f.text && 0 !== m[m.length - 1] ? At.removeNodes(e, {
                      at: m,
                      voids: i
                    }) : e.apply({
                      type: "merge_node",
                      path: y,
                      position: v,
                      properties: g
                    }), C && C.unref();
                  }
                }
              }
            });
          },
          pr = (e, t) => {
            je.withoutNormalizing(e, () => {
              var {
                  to: n,
                  at: r = e.selection,
                  mode: o = "lowest",
                  voids: i = !1
                } = t,
                {
                  match: a
                } = t;
              if (r) {
                null == a && (a = fe.isPath(r) ? Qe(e, r) : t => Pe.isElement(t) && je.isBlock(e, t));
                var s = je.pathRef(e, n),
                  l = je.nodes(e, {
                    at: r,
                    match: a,
                    mode: o,
                    voids: i
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return je.pathRef(e, n);
                  });
                for (var c of u) {
                  var d = c.unref(),
                    p = s.current;
                  0 !== d.length && e.apply({
                    type: "move_node",
                    path: d,
                    newPath: p
                  }), s.current && fe.isSibling(p, d) && fe.isAfter(p, d) && (s.current = fe.next(s.current));
                }
                s.unref();
              }
            });
          },
          hr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var {
                  hanging: n = !1,
                  voids: r = !1,
                  mode: o = "lowest"
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = fe.isPath(i) ? Qe(e, i) : t => Pe.isElement(t) && je.isBlock(e, t)), !n && Ee.isRange(i) && (i = je.unhangRange(e, i, {
                  voids: r
                }));
                var s = je.nodes(e, {
                    at: i,
                    match: a,
                    mode: o,
                    voids: r
                  }),
                  l = Array.from(s, t => {
                    var [, n] = t;
                    return je.pathRef(e, n);
                  });
                for (var u of l) {
                  var c = u.unref();
                  if (c) {
                    var [d] = je.node(e, c);
                    e.apply({
                      type: "remove_node",
                      path: c,
                      node: d
                    });
                  }
                }
              }
            });
          },
          fr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            je.withoutNormalizing(e, () => {
              var {
                  match: r,
                  at: o = e.selection,
                  compare: i,
                  merge: a
                } = n,
                {
                  hanging: s = !1,
                  mode: l = "lowest",
                  split: u = !1,
                  voids: c = !1
                } = n;
              if (o) {
                if (null == r && (r = fe.isPath(o) ? Qe(e, o) : t => Pe.isElement(t) && je.isBlock(e, t)), !s && Ee.isRange(o) && (o = je.unhangRange(e, o, {
                  voids: c
                })), u && Ee.isRange(o)) {
                  if (Ee.isCollapsed(o) && je.leaf(e, o.anchor)[0].text.length > 0) return;
                  var d = je.rangeRef(e, o, {
                      affinity: "inward"
                    }),
                    [p, h] = Ee.edges(o),
                    f = "lowest" === l ? "lowest" : "highest",
                    m = je.isEnd(e, h, h.path);
                  At.splitNodes(e, {
                    at: h,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !m
                  });
                  var g = je.isStart(e, p, p.path);
                  At.splitNodes(e, {
                    at: p,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !g
                  }), o = d.unref(), null == n.at && At.select(e, o);
                }
                for (var [v, y] of (i || (i = (e, t) => e !== t), je.nodes(e, {
                  at: o,
                  match: r,
                  mode: l,
                  voids: c
                }))) {
                  var b = {},
                    w = {};
                  if (0 !== y.length) {
                    var x = !1;
                    for (var D in t) "children" !== D && "text" !== D && i(t[D], v[D]) && (x = !0, v.hasOwnProperty(D) && (b[D] = v[D]), a ? null != t[D] && (w[D] = a(v[D], t[D])) : null != t[D] && (w[D] = t[D]));
                    x && e.apply({
                      type: "set_node",
                      path: y,
                      properties: b,
                      newProperties: w
                    });
                  }
                }
              }
            });
          },
          mr = (e, t) => {
            if (Ee.isCollapsed(t)) return t.anchor;
            var [, n] = Ee.edges(t),
              r = je.pointRef(e, n);
            return At.delete(e, {
              at: t
            }), r.unref();
          },
          gr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  voids: r = !1
                } = t,
                {
                  match: o,
                  at: i = e.selection,
                  height: a = 0,
                  always: s = !1
                } = t;
              if (null == o && (o = t => Pe.isElement(t) && je.isBlock(e, t)), Ee.isRange(i) && (i = mr(e, i)), fe.isPath(i)) {
                var l = i,
                  u = je.point(e, l),
                  [c] = je.parent(e, l);
                o = e => e === c, a = u.path.length - l.length + 1, i = u, s = !0;
              }
              if (i) {
                var d,
                  p = je.pointRef(e, i, {
                    affinity: "backward"
                  });
                try {
                  var [h] = je.nodes(e, {
                    at: i,
                    match: o,
                    mode: n,
                    voids: r
                  });
                  if (!h) return;
                  var f = je.void(e, {
                    at: i,
                    mode: "highest"
                  });
                  if (!r && f) {
                    var [m, g] = f;
                    if (Pe.isElement(m) && e.isInline(m)) {
                      var v = je.after(e, g);
                      if (!v) {
                        var y = fe.next(g);
                        At.insertNodes(e, {
                          text: ""
                        }, {
                          at: y,
                          voids: r
                        }), v = je.point(e, y);
                      }
                      i = v, s = !0;
                    }
                    a = i.path.length - g.length + 1, s = !0;
                  }
                  d = je.pointRef(e, i);
                  var b = i.path.length - a,
                    [, w] = h,
                    x = i.path.slice(0, b),
                    D = 0 === a ? i.offset : i.path[b] + 0;
                  for (var [C, S] of je.levels(e, {
                    at: x,
                    reverse: !0,
                    voids: r
                  })) {
                    var E = !1;
                    if (S.length < w.length || 0 === S.length || !r && Pe.isElement(C) && je.isVoid(e, C)) break;
                    var _ = p.current,
                      P = je.isEnd(e, _, S);
                    if (s || !p || !je.isEdge(e, _, S)) {
                      E = !0;
                      var k = Te.extractProps(C);
                      e.apply({
                        type: "split_node",
                        path: S,
                        position: D,
                        properties: k
                      });
                    }
                    D = S[S.length - 1] + (E || P ? 1 : 0);
                  }
                  if (null == t.at) {
                    var A = d.current || je.end(e, []);
                    At.select(e, A);
                  }
                } finally {
                  var z;
                  p.unref(), null === (z = d) || void 0 === z || z.unref();
                }
              }
            });
          },
          vr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Array.isArray(t) || (t = [t]);
            var r = {};
            for (var o of t) r[o] = null;
            At.setNodes(e, r, n);
          },
          yr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            je.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  split: r = !1,
                  voids: o = !1
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = fe.isPath(i) ? Qe(e, i) : t => Pe.isElement(t) && je.isBlock(e, t)), fe.isPath(i) && (i = je.range(e, i));
                var s = Ee.isRange(i) ? je.rangeRef(e, i) : null,
                  l = je.nodes(e, {
                    at: i,
                    match: a,
                    mode: n,
                    voids: o
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return je.pathRef(e, n);
                  }).reverse(),
                  c = function (t) {
                    var n = t.unref(),
                      [i] = je.node(e, n),
                      a = je.range(e, n);
                    r && s && (a = Ee.intersection(s.current, a)), At.liftNodes(e, {
                      at: a,
                      match: e => Pe.isAncestor(i) && i.children.includes(e),
                      voids: o
                    });
                  };
                for (var d of u) c(d);
                s && s.unref();
              }
            });
          };
        function br(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function wr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? br(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : br(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var xr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            je.withoutNormalizing(e, () => {
              var {
                  mode: r = "lowest",
                  split: o = !1,
                  voids: i = !1
                } = n,
                {
                  match: a,
                  at: s = e.selection
                } = n;
              if (s) {
                if (null == a && (a = fe.isPath(s) ? Qe(e, s) : e.isInline(t) ? t => Pe.isElement(t) && je.isInline(e, t) || Ye.isText(t) : t => Pe.isElement(t) && je.isBlock(e, t)), o && Ee.isRange(s)) {
                  var [l, u] = Ee.edges(s),
                    c = je.rangeRef(e, s, {
                      affinity: "inward"
                    });
                  At.splitNodes(e, {
                    at: u,
                    match: a,
                    voids: i
                  }), At.splitNodes(e, {
                    at: l,
                    match: a,
                    voids: i
                  }), s = c.unref(), null == n.at && At.select(e, s);
                }
                var d = Array.from(je.nodes(e, {
                  at: s,
                  match: e.isInline(t) ? t => Pe.isElement(t) && je.isBlock(e, t) : e => je.isEditor(e),
                  mode: "lowest",
                  voids: i
                }));
                for (var [, p] of d) {
                  var h = Ee.isRange(s) ? Ee.intersection(s, je.range(e, p)) : s;
                  if (h) {
                    var f = Array.from(je.nodes(e, {
                      at: h,
                      match: a,
                      mode: r,
                      voids: i
                    }));
                    if (f.length > 0) {
                      var m = function () {
                        var [n] = f,
                          r = f[f.length - 1],
                          [, o] = n,
                          [, a] = r;
                        if (0 === o.length && 0 === a.length) return "continue";
                        var s = fe.equals(o, a) ? fe.parent(o) : fe.common(o, a),
                          l = je.range(e, o, a),
                          u = je.node(e, s),
                          [c] = u,
                          d = s.length + 1,
                          p = fe.next(a.slice(0, d)),
                          h = wr(wr({}, t), {}, {
                            children: []
                          });
                        At.insertNodes(e, h, {
                          at: p,
                          voids: i
                        }), At.moveNodes(e, {
                          at: l,
                          match: e => Pe.isAncestor(c) && c.children.includes(e),
                          to: p.concat(0),
                          voids: i
                        });
                      }();
                      if ("continue" === m) continue;
                    }
                  }
                }
              }
            });
          },
          Dr = () => {
            var e = {
              children: [],
              operations: [],
              selection: null,
              marks: null,
              isElementReadOnly: () => !1,
              isInline: () => !1,
              isSelectable: () => !0,
              isVoid: () => !1,
              markableVoid: () => !1,
              onChange: () => {},
              apply: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return zt(e, ...n);
              },
              addMark: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Bt(e, ...n);
              },
              deleteBackward: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ut(e, ...n);
              },
              deleteForward: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Zt(e, ...n);
              },
              deleteFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return $t(e, ...n);
              },
              getFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ot(e, ...n);
              },
              insertBreak: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return un(e, ...n);
              },
              insertSoftBreak: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return dn(e, ...n);
              },
              insertFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Xn(e, ...n);
              },
              insertNode: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return cn(e, ...n);
              },
              insertText: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return fn(e, ...n);
              },
              normalizeNode: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return It(e, ...n);
              },
              removeMark: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Hn(e, ...n);
              },
              getDirtyPaths: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Tt(e, ...n);
              },
              shouldNormalize: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ft(e, ...n);
              },
              above: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Mt(e, ...n);
              },
              after: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Vt(e, ...n);
              },
              before: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ht(e, ...n);
              },
              collapse: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Qn(e, ...n);
              },
              delete: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Yn(e, ...n);
              },
              deselect: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Jn(e, ...n);
              },
              edges: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Gt(e, ...n);
              },
              elementReadOnly: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Xt(e, ...n);
              },
              end: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Qt(e, ...n);
              },
              first: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Jt(e, ...n);
              },
              fragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return en(e, ...n);
              },
              getMarks: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return _n(e, ...n);
              },
              hasBlocks: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return on(e, ...n);
              },
              hasInlines: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return an(e, ...n);
              },
              hasPath: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return sn(e, ...n);
              },
              hasTexts: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ln(e, ...n);
              },
              insertNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ar(e, ...n);
              },
              isBlock: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return mn(e, ...n);
              },
              isEdge: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return gn(e, ...n);
              },
              isEmpty: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return vn(e, ...n);
              },
              isEnd: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return yn(e, ...n);
              },
              isNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return bn(e, ...n);
              },
              isStart: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return wn(e, ...n);
              },
              last: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return xn(e, ...n);
              },
              leaf: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Dn(e, ...n);
              },
              levels: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Cn(e, ...n);
              },
              liftNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return sr(e, ...n);
              },
              mergeNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return dr(e, ...n);
              },
              move: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return er(e, ...n);
              },
              moveNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return pr(e, ...n);
              },
              next: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Pn(e, ...n);
              },
              node: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return kn(e, ...n);
              },
              nodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return An(e, ...n);
              },
              normalize: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return zn(e, ...n);
              },
              parent: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Tn(e, ...n);
              },
              path: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Fn(e, ...n);
              },
              pathRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return On(e, ...n);
              },
              pathRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return In(e, ...n);
              },
              point: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return jn(e, ...n);
              },
              pointRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Mn(e, ...n);
              },
              pointRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Rn(e, ...n);
              },
              positions: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Bn(e, ...n);
              },
              previous: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Nn(e, ...n);
              },
              range: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Kn(e, ...n);
              },
              rangeRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ln(e, ...n);
              },
              rangeRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Vn(e, ...n);
              },
              removeNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return hr(e, ...n);
              },
              select: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return tr(e, ...n);
              },
              setNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return fr(e, ...n);
              },
              setNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Un(e, ...n);
              },
              setPoint: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return or(e, ...n);
              },
              setSelection: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ir(e, ...n);
              },
              splitNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return gr(e, ...n);
              },
              start: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Zn(e, ...n);
              },
              string: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return $n(e, ...n);
              },
              unhangRange: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Gn(e, ...n);
              },
              unsetNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return vr(e, ...n);
              },
              unwrapNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return yr(e, ...n);
              },
              void: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return rn(e, ...n);
              },
              withoutNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Wn(e, ...n);
              },
              wrapNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return xr(e, ...n);
              }
            };
            return e;
          };
      },
      93125: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          __assign: () => i,
          __asyncDelegator: () => E,
          __asyncGenerator: () => S,
          __asyncValues: () => _,
          __await: () => C,
          __awaiter: () => f,
          __classPrivateFieldGet: () => T,
          __classPrivateFieldIn: () => I,
          __classPrivateFieldSet: () => O,
          __createBinding: () => g,
          __decorate: () => s,
          __esDecorate: () => u,
          __exportStar: () => v,
          __extends: () => o,
          __generator: () => m,
          __importDefault: () => z,
          __importStar: () => A,
          __makeTemplateObject: () => P,
          __metadata: () => h,
          __param: () => l,
          __propKey: () => d,
          __read: () => b,
          __rest: () => a,
          __runInitializers: () => c,
          __setFunctionName: () => p,
          __spread: () => w,
          __spreadArray: () => D,
          __spreadArrays: () => x,
          __values: () => y
        });
        var r = function (e, t) {
          return r = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, r(e, t);
        };
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var i = function () {
          return i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, i.apply(this, arguments);
        };
        function a(e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        }
        function s(e, t, n, r) {
          var o,
            i = arguments.length,
            a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
          return i > 3 && a && Object.defineProperty(t, n, a), a;
        }
        function l(e, t) {
          return function (n, r) {
            t(n, r, e);
          };
        }
        function u(e, t, n, r, o, i) {
          function a(e) {
            if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
            return e;
          }
          for (var s, l = r.kind, u = "getter" === l ? "get" : "setter" === l ? "set" : "value", c = !t && e ? r.static ? e : e.prototype : null, d = t || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), p = !1, h = n.length - 1; h >= 0; h--) {
            var f = {};
            for (var m in r) f[m] = "access" === m ? {} : r[m];
            for (var m in r.access) f.access[m] = r.access[m];
            f.addInitializer = function (e) {
              if (p) throw new TypeError("Cannot add initializers after decoration has completed");
              i.push(a(e || null));
            };
            var g = (0, n[h])("accessor" === l ? {
              get: d.get,
              set: d.set
            } : d[u], f);
            if ("accessor" === l) {
              if (void 0 === g) continue;
              if (null === g || "object" != typeof g) throw new TypeError("Object expected");
              (s = a(g.get)) && (d.get = s), (s = a(g.set)) && (d.set = s), (s = a(g.init)) && o.push(s);
            } else (s = a(g)) && ("field" === l ? o.push(s) : d[u] = s);
          }
          c && Object.defineProperty(c, r.name, d), p = !0;
        }
        function c(e, t, n) {
          for (var r = arguments.length > 2, o = 0; o < t.length; o++) n = r ? t[o].call(e, n) : t[o].call(e);
          return r ? n : void 0;
        }
        function d(e) {
          return "symbol" == typeof e ? e : "".concat(e);
        }
        function p(e, t, n) {
          return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
            configurable: !0,
            value: n ? "".concat(n, " ", t) : t
          });
        }
        function h(e, t) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
        }
        function f(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        }
        function m(e, t) {
          var n,
            r,
            o,
            i,
            a = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
          return i = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;
          function s(s) {
            return function (l) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                  if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
                  switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                    case 0:
                    case 1:
                      o = s;
                      break;
                    case 4:
                      return a.label++, {
                        value: s[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                        a.label = s[1];
                        break;
                      }
                      if (6 === s[0] && a.label < o[1]) {
                        a.label = o[1], o = s;
                        break;
                      }
                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(s);
                        break;
                      }
                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  s = t.call(e, a);
                } catch (e) {
                  s = [6, e], r = 0;
                } finally {
                  n = o = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                  value: s[0] ? s[1] : void 0,
                  done: !0
                };
              }([s, l]);
            };
          }
        }
        var g = Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n);
          var o = Object.getOwnPropertyDescriptor(t, n);
          o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
            enumerable: !0,
            get: function () {
              return t[n];
            }
          }), Object.defineProperty(e, r, o);
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        };
        function v(e, t) {
          for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || g(t, e, n);
        }
        function y(e) {
          var t = "function" == typeof Symbol && Symbol.iterator,
            n = t && e[t],
            r = 0;
          if (n) return n.call(e);
          if (e && "number" == typeof e.length) return {
            next: function () {
              return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
              };
            }
          };
          throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function b(e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            o,
            i = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = i.return) && n.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        }
        function w() {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(b(arguments[t]));
          return e;
        }
        function x() {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
          var r = Array(e),
            o = 0;
          for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
          return r;
        }
        function D(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || Array.prototype.slice.call(t));
        }
        function C(e) {
          return this instanceof C ? (this.v = e, this) : new C(e);
        }
        function S(e, t, n) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var r,
            o = n.apply(e, t || []),
            i = [];
          return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
            return this;
          }, r;
          function a(e) {
            o[e] && (r[e] = function (t) {
              return new Promise(function (n, r) {
                i.push([e, t, n, r]) > 1 || s(e, t);
              });
            });
          }
          function s(e, t) {
            try {
              (n = o[e](t)).value instanceof C ? Promise.resolve(n.value.v).then(l, u) : c(i[0][2], n);
            } catch (e) {
              c(i[0][3], e);
            }
            var n;
          }
          function l(e) {
            s("next", e);
          }
          function u(e) {
            s("throw", e);
          }
          function c(e, t) {
            e(t), i.shift(), i.length && s(i[0][0], i[0][1]);
          }
        }
        function E(e) {
          var t, n;
          return t = {}, r("next"), r("throw", function (e) {
            throw e;
          }), r("return"), t[Symbol.iterator] = function () {
            return this;
          }, t;
          function r(r, o) {
            t[r] = e[r] ? function (t) {
              return (n = !n) ? {
                value: C(e[r](t)),
                done: !1
              } : o ? o(t) : t;
            } : o;
          }
        }
        function _(e) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var t,
            n = e[Symbol.asyncIterator];
          return n ? n.call(e) : (e = y(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
            return this;
          }, t);
          function r(n) {
            t[n] = e[n] && function (t) {
              return new Promise(function (r, o) {
                (function (e, t, n, r) {
                  Promise.resolve(r).then(function (t) {
                    e({
                      value: t,
                      done: n
                    });
                  }, t);
                })(r, o, (t = e[n](t)).done, t.value);
              });
            };
          }
        }
        function P(e, t) {
          return Object.defineProperty ? Object.defineProperty(e, "raw", {
            value: t
          }) : e.raw = t, e;
        }
        var k = Object.create ? function (e, t) {
          Object.defineProperty(e, "default", {
            enumerable: !0,
            value: t
          });
        } : function (e, t) {
          e.default = t;
        };
        function A(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && g(t, e, n);
          return k(t, e), t;
        }
        function z(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function T(e, t, n, r) {
          if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
          if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
          return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
        }
        function O(e, t, n, r, o) {
          if ("m" === r) throw new TypeError("Private method is not writable");
          if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
          if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
          return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
        }
        function I(e, t) {
          if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
          return "function" == typeof e ? t === e : e.has(t);
        }
      },
      83511: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        n(93125).__exportStar(n(57757), t);
      },
      18617: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(47915),
          o = n(15191);
        t.config = {
          markMap: {
            strikethrough: ["s"],
            bold: ["strong"],
            underline: ["u"],
            italic: ["i"],
            code: ["pre", "code"]
          },
          elementMap: {
            p: "p",
            paragraph: "p",
            h1: "h1",
            h2: "h2",
            h3: "h3",
            h4: "h4",
            h5: "h5",
            h6: "h6",
            ul: "ul",
            ol: "ol",
            li: "li",
            blockquote: "blockquote"
          },
          elementAttributeTransform: ({
            node: e
          }) => {
            if (e.align) return {
              style: (0, o.styleToString)({
                "text-align": e.align
              })
            };
          },
          elementTransforms: {
            quote: ({
              children: e = []
            }) => {
              const t = [new r.Element("p", {}, e)];
              return new r.Element("blockquote", {}, t);
            },
            link: ({
              node: e,
              children: t = []
            }) => {
              const n = {};
              return e.newTab && (n.target = "_blank"), new r.Element("a", Object.assign({
                href: e.url
              }, n), t);
            }
          },
          encodeEntities: !1,
          alwaysEncodeBreakingEntities: !0,
          alwaysEncodeCodeEntities: !1,
          convertLineBreakToBr: !1
        };
      },
      21222: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(47915),
          o = n(18617);
        t.config = Object.assign(Object.assign({}, o.config), {
          elementTransforms: Object.assign(Object.assign({}, o.config.elementTransforms), {
            link: ({
              node: e,
              children: t = []
            }) => {
              const n = {};
              return e.linkType && (n["data-link-type"] = e.linkType), e.newTab && (n.target = "_blank"), new r.Element("a", Object.assign({
                href: e.url
              }, n), t);
            },
            upload: ({
              node: e
            }) => {
              var t, n, o, i, a, s;
              if ((null === (t = e.value) || void 0 === t ? void 0 : t.mimeType) && (null === (n = e.value) || void 0 === n ? void 0 : n.url)) return (null === (o = e.value) || void 0 === o ? void 0 : o.mimeType.match(/^image/)) ? new r.Element("img", {
                src: null === (i = e.value) || void 0 === i ? void 0 : i.url
              }) : new r.Element("a", {
                href: null === (a = e.value) || void 0 === a ? void 0 : a.url
              }, [new r.Text(null === (s = e.value) || void 0 === s ? void 0 : s.filename)]);
            }
          }),
          defaultTag: "p"
        });
      },
      18193: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(15191),
          o = {
            "block-quote": "blockquote",
            "heading-one": "h1",
            "heading-two": "h2",
            "list-item": "li",
            "numbered-list": "ol",
            "bulleted-list": "ul",
            paragraph: "p"
          };
        t.config = {
          markMap: {
            strikethrough: ["s"],
            bold: ["strong"],
            underline: ["u"],
            italic: ["i"],
            code: ["pre", "code"]
          },
          elementMap: o,
          elementTransforms: {},
          elementAttributeTransform: ({
            node: e
          }) => {
            const t = (0, r.styleMapToAttribs)({
              elementStyleMap: {
                align: "textAlign"
              },
              node: e
            });
            return (0, r.isEmptyObject)(t) ? {} : t;
          },
          encodeEntities: !0
        };
      },
      57757: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.extractCssFromStyle = t.convertSlate = t.slateDemoSlateToDomConfig = t.payloadSlateToDomConfig = t.slateToDomConfig = t.slateToDom = void 0;
        var r = n(97103);
        Object.defineProperty(t, "slateToDom", {
          enumerable: !0,
          get: function () {
            return r.slateToDom;
          }
        });
        var o = n(18617);
        Object.defineProperty(t, "slateToDomConfig", {
          enumerable: !0,
          get: function () {
            return o.config;
          }
        });
        var i = n(21222);
        Object.defineProperty(t, "payloadSlateToDomConfig", {
          enumerable: !0,
          get: function () {
            return i.config;
          }
        });
        var a = n(18193);
        Object.defineProperty(t, "slateDemoSlateToDomConfig", {
          enumerable: !0,
          get: function () {
            return a.config;
          }
        });
        var s = n(85511);
        Object.defineProperty(t, "convertSlate", {
          enumerable: !0,
          get: function () {
            return s.convertSlate;
          }
        });
        var l = n(28272);
        Object.defineProperty(t, "extractCssFromStyle", {
          enumerable: !0,
          get: function () {
            return l.extractCssFromStyle;
          }
        });
      },
      97103: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.slateToDom = void 0;
        const r = n(47915),
          o = n(18617),
          i = n(85511);
        t.slateToDom = (e, t = o.config) => {
          if (!Array.isArray(e)) return new r.Document([]);
          return e.map((n, r) => (0, i.convertSlate)({
            node: n,
            config: t,
            isLastNodeInDocument: r === e.length - 1
          }));
        };
      },
      85511: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.convertSlate = void 0;
        const r = n(47915),
          o = n(89432),
          i = n(2053),
          a = n(23151),
          s = n(18617),
          l = n(28272),
          u = n(15191),
          c = n(15191);
        t.convertSlate = ({
          node: e,
          config: n = s.config,
          isLastNodeInDocument: d = !1,
          customElementTransforms: p,
          transformText: h = e => e,
          transformElement: f = e => e,
          wrapChildren: m = e => new r.Document(e)
        }) => {
          if (a.Text.isText(e)) {
            const t = n.alwaysEncodeBreakingEntities && !n.encodeEntities ? (0, u.encodeBreakingEntities)(e.text) : e.text,
              a = n.convertLineBreakToBr ? t.split("\n") : [t],
              s = [];
            return a.forEach((t, d) => {
              const p = [];
              (0, c.intersection)(n.markTransforms || {}, e).forEach(t => {
                var r;
                if (null === (r = n.markTransforms) || void 0 === r ? void 0 : r[t]) {
                  const r = n.markTransforms[t]({
                    node: e,
                    attribs: {}
                  });
                  r && p.push(r);
                }
              }), Object.keys(n.markMap).forEach(t => {
                if (e[t]) {
                  const o = n.markMap[t].map(t => {
                    var o;
                    return (null === (o = n.markTransforms) || void 0 === o ? void 0 : o[t]) ? n.markTransforms[t]({
                      node: e,
                      attribs: {}
                    }) : new r.Element(t, {}, []);
                  }).filter(e => void 0 !== e);
                  p.push(...o);
                }
              });
              const h = [...p],
                m = (0, l.nestedMarkElements)(p, new r.Text(t));
              n.alwaysEncodeCodeEntities && !n.encodeEntities && (0, r.isTag)(m) && "pre" === (0, o.getName)(m) ? (n.alwaysEncodeBreakingEntities && (t = (0, u.decodeBreakingEntities)(t)), s.push((0, l.nestedMarkElements)(h, new r.Text((0, i.encode)(t))))) : s.push(m), d < a.length - 1 && s.push(f(new r.Element("br", {})));
            }), m(s.map(e => h(e)));
          }
          const g = e.children ? e.children.map(e => (0, t.convertSlate)({
            node: e,
            config: n,
            customElementTransforms: p,
            transformText: h,
            transformElement: f,
            wrapChildren: m
          })) : [];
          let v = {};
          n.elementAttributeTransform && (v = Object.assign(Object.assign({}, v), n.elementAttributeTransform({
            node: e
          })));
          let y = null;
          return p && p[e.type] ? y = p[e.type]({
            node: e,
            attribs: v,
            children: g
          }) : n.elementTransforms[e.type] && (y = f(n.elementTransforms[e.type]({
            node: e,
            attribs: v,
            children: g
          }))), !y && n.elementMap[e.type] && (y = f(new r.Element(n.elementMap[e.type], v, g))), y || !n.defaultTag || e.type || (y = f(new r.Element(n.defaultTag, {}, g))), y || (n.convertLineBreakToBr && !d && g.push(f(new r.Element("br", {}))), m(g));
        };
      },
      28272: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.extractCssFromStyle = t.nestedMarkElements = t.nestedMarkElementsString = void 0;
        const r = n(89432),
          o = n(47915),
          i = n(97220),
          a = n(15191);
        t.nestedMarkElementsString = (e, n) => (0, i.default)((0, t.nestedMarkElements)(e, new o.Text(n)));
        t.nestedMarkElements = (e, t) => {
          if (0 === e.length) return t;
          const n = e.pop();
          if (n && (n.children = [t], t = n), !e || 0 === e.length) return t;
          const r = e.pop();
          if (r && (r.children = [t], t = r), !e || 0 === e.length) return t;
          const o = e.pop();
          if (o && (o.children = [t], t = o), !e || 0 === e.length) return t;
          const i = e.pop();
          if (i && (i.children = [t], t = i), !e || 0 === e.length) return t;
          const a = e.pop();
          return a && (a.children = [t], t = a), e && e.length, t;
        };
        t.extractCssFromStyle = (e, t) => {
          const n = e && (0, r.getAttributeValue)(e, "style");
          if (n) {
            const e = (0, a.parseStyleCssText)(n);
            if (e[t]) return e[t];
          }
          return null;
        };
      },
      93282: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.attributeRules = void 0;
        var o = r(n(11073)),
          i = /[-[\]{}()*+?.,\\^$|#\s]/g;
        function a(e) {
          return e.replace(i, "\\$&");
        }
        var s = new Set(["accept", "accept-charset", "align", "alink", "axis", "bgcolor", "charset", "checked", "clear", "codetype", "color", "compact", "declare", "defer", "dir", "direction", "disabled", "enctype", "face", "frame", "hreflang", "http-equiv", "lang", "language", "link", "media", "method", "multiple", "nohref", "noresize", "noshade", "nowrap", "readonly", "rel", "rev", "rules", "scope", "scrolling", "selected", "shape", "target", "text", "type", "valign", "valuetype", "vlink"]);
        function l(e, t) {
          return "boolean" == typeof e.ignoreCase ? e.ignoreCase : "quirks" === e.ignoreCase ? !!t.quirksMode : !t.xmlMode && s.has(e.name);
        }
        t.attributeRules = {
          equals: function (e, t, n) {
            var r = n.adapter,
              o = t.name,
              i = t.value;
            return l(t, n) ? (i = i.toLowerCase(), function (t) {
              var n = r.getAttributeValue(t, o);
              return null != n && n.length === i.length && n.toLowerCase() === i && e(t);
            }) : function (t) {
              return r.getAttributeValue(t, o) === i && e(t);
            };
          },
          hyphen: function (e, t, n) {
            var r = n.adapter,
              o = t.name,
              i = t.value,
              a = i.length;
            return l(t, n) ? (i = i.toLowerCase(), function (t) {
              var n = r.getAttributeValue(t, o);
              return null != n && (n.length === a || "-" === n.charAt(a)) && n.substr(0, a).toLowerCase() === i && e(t);
            }) : function (t) {
              var n = r.getAttributeValue(t, o);
              return null != n && (n.length === a || "-" === n.charAt(a)) && n.substr(0, a) === i && e(t);
            };
          },
          element: function (e, t, n) {
            var r = n.adapter,
              i = t.name,
              s = t.value;
            if (/\s/.test(s)) return o.default.falseFunc;
            var u = new RegExp("(?:^|\\s)".concat(a(s), "(?:$|\\s)"), l(t, n) ? "i" : "");
            return function (t) {
              var n = r.getAttributeValue(t, i);
              return null != n && n.length >= s.length && u.test(n) && e(t);
            };
          },
          exists: function (e, t, n) {
            var r = t.name,
              o = n.adapter;
            return function (t) {
              return o.hasAttrib(t, r) && e(t);
            };
          },
          start: function (e, t, n) {
            var r = n.adapter,
              i = t.name,
              a = t.value,
              s = a.length;
            return 0 === s ? o.default.falseFunc : l(t, n) ? (a = a.toLowerCase(), function (t) {
              var n = r.getAttributeValue(t, i);
              return null != n && n.length >= s && n.substr(0, s).toLowerCase() === a && e(t);
            }) : function (t) {
              var n;
              return !!(null === (n = r.getAttributeValue(t, i)) || void 0 === n ? void 0 : n.startsWith(a)) && e(t);
            };
          },
          end: function (e, t, n) {
            var r = n.adapter,
              i = t.name,
              a = t.value,
              s = -a.length;
            return 0 === s ? o.default.falseFunc : l(t, n) ? (a = a.toLowerCase(), function (t) {
              var n;
              return (null === (n = r.getAttributeValue(t, i)) || void 0 === n ? void 0 : n.substr(s).toLowerCase()) === a && e(t);
            }) : function (t) {
              var n;
              return !!(null === (n = r.getAttributeValue(t, i)) || void 0 === n ? void 0 : n.endsWith(a)) && e(t);
            };
          },
          any: function (e, t, n) {
            var r = n.adapter,
              i = t.name,
              s = t.value;
            if ("" === s) return o.default.falseFunc;
            if (l(t, n)) {
              var u = new RegExp(a(s), "i");
              return function (t) {
                var n = r.getAttributeValue(t, i);
                return null != n && n.length >= s.length && u.test(n) && e(t);
              };
            }
            return function (t) {
              var n;
              return !!(null === (n = r.getAttributeValue(t, i)) || void 0 === n ? void 0 : n.includes(s)) && e(t);
            };
          },
          not: function (e, t, n) {
            var r = n.adapter,
              o = t.name,
              i = t.value;
            return "" === i ? function (t) {
              return !!r.getAttributeValue(t, o) && e(t);
            } : l(t, n) ? (i = i.toLowerCase(), function (t) {
              var n = r.getAttributeValue(t, o);
              return (null == n || n.length !== i.length || n.toLowerCase() !== i) && e(t);
            }) : function (t) {
              return r.getAttributeValue(t, o) !== i && e(t);
            };
          }
        };
      },
      61495: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          i = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
            return o(t, e), t;
          },
          a = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.compileToken = t.compileUnsafe = t.compile = void 0;
        var s = n(57763),
          l = a(n(11073)),
          u = i(n(56415)),
          c = n(37729),
          d = n(72283);
        function p(e, t, n) {
          return v("string" == typeof e ? (0, s.parse)(e) : e, t, n);
        }
        function h(e) {
          return e.type === s.SelectorType.Pseudo && ("scope" === e.name || Array.isArray(e.data) && e.data.some(function (e) {
            return e.some(h);
          }));
        }
        t.compile = function (e, t, n) {
          var r = p(e, t, n);
          return (0, d.ensureIsTag)(r, t.adapter);
        }, t.compileUnsafe = p;
        var f = {
            type: s.SelectorType.Descendant
          },
          m = {
            type: "_flexibleDescendant"
          },
          g = {
            type: s.SelectorType.Pseudo,
            name: "scope",
            data: null
          };
        function v(e, t, n) {
          var r;
          e.forEach(u.default), n = null !== (r = t.context) && void 0 !== r ? r : n;
          var o = Array.isArray(n),
            i = n && (Array.isArray(n) ? n : [n]);
          if (!1 !== t.relativeSelector) !function (e, t, n) {
            for (var r = t.adapter, o = !!(null == n ? void 0 : n.every(function (e) {
                var t = r.isTag(e) && r.getParent(e);
                return e === d.PLACEHOLDER_ELEMENT || t && r.isTag(t);
              })), i = 0, a = e; i < a.length; i++) {
              var l = a[i];
              if (l.length > 0 && (0, u.isTraversal)(l[0]) && l[0].type !== s.SelectorType.Descendant) ;else {
                if (!o || l.some(h)) continue;
                l.unshift(f);
              }
              l.unshift(g);
            }
          }(e, t, i);else if (e.some(function (e) {
            return e.length > 0 && (0, u.isTraversal)(e[0]);
          })) throw new Error("Relative selectors are not allowed when the `relativeSelector` option is disabled");
          var a = !1,
            p = e.map(function (e) {
              if (e.length >= 2) {
                var n = e[0],
                  r = e[1];
                n.type !== s.SelectorType.Pseudo || "scope" !== n.name || (o && r.type === s.SelectorType.Descendant ? e[1] = m : r.type !== s.SelectorType.Adjacent && r.type !== s.SelectorType.Sibling || (a = !0));
              }
              return function (e, t, n) {
                var r;
                return e.reduce(function (e, r) {
                  return e === l.default.falseFunc ? l.default.falseFunc : (0, c.compileGeneralSelector)(e, r, t, n, v);
                }, null !== (r = t.rootFunc) && void 0 !== r ? r : l.default.trueFunc);
              }(e, t, i);
            }).reduce(y, l.default.falseFunc);
          return p.shouldTestNextSiblings = a, p;
        }
        function y(e, t) {
          return t === l.default.falseFunc || e === l.default.trueFunc ? e : e === l.default.falseFunc || t === l.default.trueFunc ? t : function (n) {
            return e(n) || t(n);
          };
        }
        t.compileToken = v;
      },
      37729: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.compileGeneralSelector = void 0;
        var r = n(93282),
          o = n(21607),
          i = n(57763);
        function a(e, t) {
          var n = t.getParent(e);
          return n && t.isTag(n) ? n : null;
        }
        t.compileGeneralSelector = function (e, t, n, s, l) {
          var u = n.adapter,
            c = n.equals;
          switch (t.type) {
            case i.SelectorType.PseudoElement:
              throw new Error("Pseudo-elements are not supported by css-select");
            case i.SelectorType.ColumnCombinator:
              throw new Error("Column combinators are not yet supported by css-select");
            case i.SelectorType.Attribute:
              if (null != t.namespace) throw new Error("Namespaced attributes are not yet supported by css-select");
              return n.xmlMode && !n.lowerCaseAttributeNames || (t.name = t.name.toLowerCase()), r.attributeRules[t.action](e, t, n);
            case i.SelectorType.Pseudo:
              return (0, o.compilePseudoSelector)(e, t, n, s, l);
            case i.SelectorType.Tag:
              if (null != t.namespace) throw new Error("Namespaced tag names are not yet supported by css-select");
              var d = t.name;
              return n.xmlMode && !n.lowerCaseTags || (d = d.toLowerCase()), function (t) {
                return u.getName(t) === d && e(t);
              };
            case i.SelectorType.Descendant:
              if (!1 === n.cacheResults || "undefined" == typeof WeakSet) return function (t) {
                for (var n = t; n = a(n, u);) if (e(n)) return !0;
                return !1;
              };
              var p = new WeakSet();
              return function (t) {
                for (var n = t; n = a(n, u);) if (!p.has(n)) {
                  if (u.isTag(n) && e(n)) return !0;
                  p.add(n);
                }
                return !1;
              };
            case "_flexibleDescendant":
              return function (t) {
                var n = t;
                do {
                  if (e(n)) return !0;
                } while (n = a(n, u));
                return !1;
              };
            case i.SelectorType.Parent:
              return function (t) {
                return u.getChildren(t).some(function (t) {
                  return u.isTag(t) && e(t);
                });
              };
            case i.SelectorType.Child:
              return function (t) {
                var n = u.getParent(t);
                return null != n && u.isTag(n) && e(n);
              };
            case i.SelectorType.Sibling:
              return function (t) {
                for (var n = u.getSiblings(t), r = 0; r < n.length; r++) {
                  var o = n[r];
                  if (c(t, o)) break;
                  if (u.isTag(o) && e(o)) return !0;
                }
                return !1;
              };
            case i.SelectorType.Adjacent:
              return u.prevElementSibling ? function (t) {
                var n = u.prevElementSibling(t);
                return null != n && e(n);
              } : function (t) {
                for (var n, r = u.getSiblings(t), o = 0; o < r.length; o++) {
                  var i = r[o];
                  if (c(t, i)) break;
                  u.isTag(i) && (n = i);
                }
                return !!n && e(n);
              };
            case i.SelectorType.Universal:
              if (null != t.namespace && "*" !== t.namespace) throw new Error("Namespaced universal selectors are not yet supported by css-select");
              return e;
          }
        };
      },
      58480: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          i = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
            return o(t, e), t;
          },
          a = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.aliases = t.pseudos = t.filters = t.is = t.selectOne = t.selectAll = t.prepareContext = t._compileToken = t._compileUnsafe = t.compile = void 0;
        var s = i(n(89432)),
          l = a(n(11073)),
          u = n(61495),
          c = n(72283),
          d = function (e, t) {
            return e === t;
          },
          p = {
            adapter: s,
            equals: d
          };
        function h(e) {
          var t,
            n,
            r,
            o,
            i = null != e ? e : p;
          return null !== (t = i.adapter) && void 0 !== t || (i.adapter = s), null !== (n = i.equals) && void 0 !== n || (i.equals = null !== (o = null === (r = i.adapter) || void 0 === r ? void 0 : r.equals) && void 0 !== o ? o : d), i;
        }
        function f(e) {
          return function (t, n, r) {
            var o = h(n);
            return e(t, o, r);
          };
        }
        function m(e) {
          return function (t, n, r) {
            var o = h(r);
            "function" != typeof t && (t = (0, u.compileUnsafe)(t, o, n));
            var i = g(n, o.adapter, t.shouldTestNextSiblings);
            return e(t, i, o);
          };
        }
        function g(e, t, n) {
          return void 0 === n && (n = !1), n && (e = function (e, t) {
            for (var n = Array.isArray(e) ? e.slice(0) : [e], r = n.length, o = 0; o < r; o++) {
              var i = (0, c.getNextSiblings)(n[o], t);
              n.push.apply(n, i);
            }
            return n;
          }(e, t)), Array.isArray(e) ? t.removeSubsets(e) : t.getChildren(e);
        }
        t.compile = f(u.compile), t._compileUnsafe = f(u.compileUnsafe), t._compileToken = f(u.compileToken), t.prepareContext = g, t.selectAll = m(function (e, t, n) {
          return e !== l.default.falseFunc && t && 0 !== t.length ? n.adapter.findAll(e, t) : [];
        }), t.selectOne = m(function (e, t, n) {
          return e !== l.default.falseFunc && t && 0 !== t.length ? n.adapter.findOne(e, t) : null;
        }), t.is = function (e, t, n) {
          var r = h(n);
          return ("function" == typeof t ? t : (0, u.compile)(t, r))(e);
        }, t.default = t.selectAll;
        var v = n(21607);
        Object.defineProperty(t, "filters", {
          enumerable: !0,
          get: function () {
            return v.filters;
          }
        }), Object.defineProperty(t, "pseudos", {
          enumerable: !0,
          get: function () {
            return v.pseudos;
          }
        }), Object.defineProperty(t, "aliases", {
          enumerable: !0,
          get: function () {
            return v.aliases;
          }
        });
      },
      26279: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.aliases = void 0, t.aliases = {
          "any-link": ":is(a, area, link)[href]",
          link: ":any-link:not(:visited)",
          disabled: ":is(\n        :is(button, input, select, textarea, optgroup, option)[disabled],\n        optgroup[disabled] > option,\n        fieldset[disabled]:not(fieldset[disabled] legend:first-of-type *)\n    )",
          enabled: ":not(:disabled)",
          checked: ":is(:is(input[type=radio], input[type=checkbox])[checked], option:selected)",
          required: ":is(input, select, textarea)[required]",
          optional: ":is(input, select, textarea):not([required])",
          selected: "option:is([selected], select:not([multiple]):not(:has(> option[selected])) > :first-of-type)",
          checkbox: "[type=checkbox]",
          file: "[type=file]",
          password: "[type=password]",
          radio: "[type=radio]",
          reset: "[type=reset]",
          image: "[type=image]",
          submit: "[type=submit]",
          parent: ":not(:empty)",
          header: ":is(h1, h2, h3, h4, h5, h6)",
          button: ":is(button, input[type=button])",
          input: ":is(input, textarea, select, button)",
          text: "input:is(:not([type!='']), [type=text])"
        };
      },
      45609: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.filters = void 0;
        var o = r(n(97540)),
          i = r(n(11073));
        function a(e, t) {
          return function (n) {
            var r = t.getParent(n);
            return null != r && t.isTag(r) && e(n);
          };
        }
        function s(e) {
          return function (t, n, r) {
            var o = r.adapter[e];
            return "function" != typeof o ? i.default.falseFunc : function (e) {
              return o(e) && t(e);
            };
          };
        }
        t.filters = {
          contains: function (e, t, n) {
            var r = n.adapter;
            return function (n) {
              return e(n) && r.getText(n).includes(t);
            };
          },
          icontains: function (e, t, n) {
            var r = n.adapter,
              o = t.toLowerCase();
            return function (t) {
              return e(t) && r.getText(t).toLowerCase().includes(o);
            };
          },
          "nth-child": function (e, t, n) {
            var r = n.adapter,
              s = n.equals,
              l = (0, o.default)(t);
            return l === i.default.falseFunc ? i.default.falseFunc : l === i.default.trueFunc ? a(e, r) : function (t) {
              for (var n = r.getSiblings(t), o = 0, i = 0; i < n.length && !s(t, n[i]); i++) r.isTag(n[i]) && o++;
              return l(o) && e(t);
            };
          },
          "nth-last-child": function (e, t, n) {
            var r = n.adapter,
              s = n.equals,
              l = (0, o.default)(t);
            return l === i.default.falseFunc ? i.default.falseFunc : l === i.default.trueFunc ? a(e, r) : function (t) {
              for (var n = r.getSiblings(t), o = 0, i = n.length - 1; i >= 0 && !s(t, n[i]); i--) r.isTag(n[i]) && o++;
              return l(o) && e(t);
            };
          },
          "nth-of-type": function (e, t, n) {
            var r = n.adapter,
              s = n.equals,
              l = (0, o.default)(t);
            return l === i.default.falseFunc ? i.default.falseFunc : l === i.default.trueFunc ? a(e, r) : function (t) {
              for (var n = r.getSiblings(t), o = 0, i = 0; i < n.length; i++) {
                var a = n[i];
                if (s(t, a)) break;
                r.isTag(a) && r.getName(a) === r.getName(t) && o++;
              }
              return l(o) && e(t);
            };
          },
          "nth-last-of-type": function (e, t, n) {
            var r = n.adapter,
              s = n.equals,
              l = (0, o.default)(t);
            return l === i.default.falseFunc ? i.default.falseFunc : l === i.default.trueFunc ? a(e, r) : function (t) {
              for (var n = r.getSiblings(t), o = 0, i = n.length - 1; i >= 0; i--) {
                var a = n[i];
                if (s(t, a)) break;
                r.isTag(a) && r.getName(a) === r.getName(t) && o++;
              }
              return l(o) && e(t);
            };
          },
          root: function (e, t, n) {
            var r = n.adapter;
            return function (t) {
              var n = r.getParent(t);
              return (null == n || !r.isTag(n)) && e(t);
            };
          },
          scope: function (e, n, r, o) {
            var i = r.equals;
            return o && 0 !== o.length ? 1 === o.length ? function (t) {
              return i(o[0], t) && e(t);
            } : function (t) {
              return o.includes(t) && e(t);
            } : t.filters.root(e, n, r);
          },
          hover: s("isHovered"),
          visited: s("isVisited"),
          active: s("isActive")
        };
      },
      21607: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.compilePseudoSelector = t.aliases = t.pseudos = t.filters = void 0;
        var r = n(57763),
          o = n(45609);
        Object.defineProperty(t, "filters", {
          enumerable: !0,
          get: function () {
            return o.filters;
          }
        });
        var i = n(22593);
        Object.defineProperty(t, "pseudos", {
          enumerable: !0,
          get: function () {
            return i.pseudos;
          }
        });
        var a = n(26279);
        Object.defineProperty(t, "aliases", {
          enumerable: !0,
          get: function () {
            return a.aliases;
          }
        });
        var s = n(72283);
        t.compilePseudoSelector = function (e, t, n, l, u) {
          var c,
            d = t.name,
            p = t.data;
          if (Array.isArray(p)) {
            if (!(d in s.subselects)) throw new Error("Unknown pseudo-class :".concat(d, "(").concat(p, ")"));
            return s.subselects[d](e, p, n, l, u);
          }
          var h = null === (c = n.pseudos) || void 0 === c ? void 0 : c[d],
            f = "string" == typeof h ? h : a.aliases[d];
          if ("string" == typeof f) {
            if (null != p) throw new Error("Pseudo ".concat(d, " doesn't have any arguments"));
            var m = (0, r.parse)(f);
            return s.subselects.is(e, m, n, l, u);
          }
          if ("function" == typeof h) return (0, i.verifyPseudoArgs)(h, d, p, 1), function (t) {
            return h(t, p) && e(t);
          };
          if (d in o.filters) return o.filters[d](e, p, n, l);
          if (d in i.pseudos) {
            var g = i.pseudos[d];
            return (0, i.verifyPseudoArgs)(g, d, p, 2), function (t) {
              return g(t, n, p) && e(t);
            };
          }
          throw new Error("Unknown pseudo-class :".concat(d));
        };
      },
      22593: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.verifyPseudoArgs = t.pseudos = void 0, t.pseudos = {
          empty: function (e, t) {
            var n = t.adapter;
            return !n.getChildren(e).some(function (e) {
              return n.isTag(e) || "" !== n.getText(e);
            });
          },
          "first-child": function (e, t) {
            var n = t.adapter,
              r = t.equals;
            if (n.prevElementSibling) return null == n.prevElementSibling(e);
            var o = n.getSiblings(e).find(function (e) {
              return n.isTag(e);
            });
            return null != o && r(e, o);
          },
          "last-child": function (e, t) {
            for (var n = t.adapter, r = t.equals, o = n.getSiblings(e), i = o.length - 1; i >= 0; i--) {
              if (r(e, o[i])) return !0;
              if (n.isTag(o[i])) break;
            }
            return !1;
          },
          "first-of-type": function (e, t) {
            for (var n = t.adapter, r = t.equals, o = n.getSiblings(e), i = n.getName(e), a = 0; a < o.length; a++) {
              var s = o[a];
              if (r(e, s)) return !0;
              if (n.isTag(s) && n.getName(s) === i) break;
            }
            return !1;
          },
          "last-of-type": function (e, t) {
            for (var n = t.adapter, r = t.equals, o = n.getSiblings(e), i = n.getName(e), a = o.length - 1; a >= 0; a--) {
              var s = o[a];
              if (r(e, s)) return !0;
              if (n.isTag(s) && n.getName(s) === i) break;
            }
            return !1;
          },
          "only-of-type": function (e, t) {
            var n = t.adapter,
              r = t.equals,
              o = n.getName(e);
            return n.getSiblings(e).every(function (t) {
              return r(e, t) || !n.isTag(t) || n.getName(t) !== o;
            });
          },
          "only-child": function (e, t) {
            var n = t.adapter,
              r = t.equals;
            return n.getSiblings(e).every(function (t) {
              return r(e, t) || !n.isTag(t);
            });
          }
        }, t.verifyPseudoArgs = function (e, t, n, r) {
          if (null === n) {
            if (e.length > r) throw new Error("Pseudo-class :".concat(t, " requires an argument"));
          } else if (e.length === r) throw new Error("Pseudo-class :".concat(t, " doesn't have any arguments"));
        };
      },
      72283: function (e, t, n) {
        "use strict";

        var r = this && this.__spreadArray || function (e, t, n) {
            if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
            return e.concat(r || Array.prototype.slice.call(t));
          },
          o = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.subselects = t.getNextSiblings = t.ensureIsTag = t.PLACEHOLDER_ELEMENT = void 0;
        var i = o(n(11073)),
          a = n(56415);
        function s(e, t) {
          return e === i.default.falseFunc ? i.default.falseFunc : function (n) {
            return t.isTag(n) && e(n);
          };
        }
        function l(e, t) {
          var n = t.getSiblings(e);
          if (n.length <= 1) return [];
          var r = n.indexOf(e);
          return r < 0 || r === n.length - 1 ? [] : n.slice(r + 1).filter(t.isTag);
        }
        function u(e) {
          return {
            xmlMode: !!e.xmlMode,
            lowerCaseAttributeNames: !!e.lowerCaseAttributeNames,
            lowerCaseTags: !!e.lowerCaseTags,
            quirksMode: !!e.quirksMode,
            cacheResults: !!e.cacheResults,
            pseudos: e.pseudos,
            adapter: e.adapter,
            equals: e.equals
          };
        }
        t.PLACEHOLDER_ELEMENT = {}, t.ensureIsTag = s, t.getNextSiblings = l;
        var c = function (e, t, n, r, o) {
          var a = o(t, u(n), r);
          return a === i.default.trueFunc ? e : a === i.default.falseFunc ? i.default.falseFunc : function (t) {
            return a(t) && e(t);
          };
        };
        t.subselects = {
          is: c,
          matches: c,
          where: c,
          not: function (e, t, n, r, o) {
            var a = o(t, u(n), r);
            return a === i.default.falseFunc ? e : a === i.default.trueFunc ? i.default.falseFunc : function (t) {
              return !a(t) && e(t);
            };
          },
          has: function (e, n, o, c, d) {
            var p = o.adapter,
              h = u(o);
            h.relativeSelector = !0;
            var f = n.some(function (e) {
                return e.some(a.isTraversal);
              }) ? [t.PLACEHOLDER_ELEMENT] : void 0,
              m = d(n, h, f);
            if (m === i.default.falseFunc) return i.default.falseFunc;
            var g = s(m, p);
            if (f && m !== i.default.trueFunc) {
              var v = m.shouldTestNextSiblings,
                y = void 0 !== v && v;
              return function (t) {
                if (!e(t)) return !1;
                f[0] = t;
                var n = p.getChildren(t),
                  o = y ? r(r([], n, !0), l(t, p), !0) : n;
                return p.existsOne(g, o);
              };
            }
            return function (t) {
              return e(t) && p.existsOne(g, p.getChildren(t));
            };
          }
        };
      },
      56415: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isTraversal = void 0;
        var r = n(57763),
          o = new Map([[r.SelectorType.Universal, 50], [r.SelectorType.Tag, 30], [r.SelectorType.Attribute, 1], [r.SelectorType.Pseudo, 0]]);
        t.isTraversal = function (e) {
          return !o.has(e.type);
        };
        var i = new Map([[r.AttributeAction.Exists, 10], [r.AttributeAction.Equals, 8], [r.AttributeAction.Not, 7], [r.AttributeAction.Start, 6], [r.AttributeAction.End, 6], [r.AttributeAction.Any, 5]]);
        function a(e) {
          var t,
            n,
            s = null !== (t = o.get(e.type)) && void 0 !== t ? t : -1;
          return e.type === r.SelectorType.Attribute ? (s = null !== (n = i.get(e.action)) && void 0 !== n ? n : 4, e.action === r.AttributeAction.Equals && "id" === e.name && (s = 9), e.ignoreCase && (s >>= 1)) : e.type === r.SelectorType.Pseudo && (e.data ? "has" === e.name || "contains" === e.name ? s = 0 : Array.isArray(e.data) ? (s = Math.min.apply(Math, e.data.map(function (e) {
            return Math.min.apply(Math, e.map(a));
          }))) < 0 && (s = 0) : s = 2 : s = 3), s;
        }
        t.default = function (e) {
          for (var t = e.map(a), n = 1; n < e.length; n++) {
            var r = t[n];
            if (!(r < 0)) for (var o = n - 1; o >= 0 && r < t[o]; o--) {
              var i = e[o + 1];
              e[o + 1] = e[o], e[o] = i, t[o + 1] = t[o], t[o] = r;
            }
          }
        };
      },
      26934: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTML = t.determineBranch = t.JUMP_OFFSET_BASE = t.BinTrieFlags = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
        var o = r(n(81792));
        t.htmlDecodeTree = o.default;
        var i = r(n(33727));
        t.xmlDecodeTree = i.default;
        var a,
          s = r(n(35102));
        function l(e) {
          return function (t, n) {
            for (var r = "", o = 0, i = 0; (i = t.indexOf("&", i)) >= 0;) if (r += t.slice(o, i), o = i, i += 1, 35 !== t.charCodeAt(i)) {
              for (var l = null, c = 1, d = 0, p = e[d]; i < t.length && !((d = u(e, p, d + 1, t.charCodeAt(i))) < 0); i++, c++) (p = e[d]) & a.HAS_VALUE && (n && 59 !== t.charCodeAt(i) ? d += 1 : (l = p & a.MULTI_BYTE ? String.fromCharCode(e[++d], e[++d]) : String.fromCharCode(e[++d]), c = 0));
              null != l && (r += l, o = i - c + 1);
            } else {
              var h = i + 1,
                f = 10,
                m = t.charCodeAt(h);
              for (120 == (32 | m) && (f = 16, i += 1, h += 1); (m = t.charCodeAt(++i)) >= 48 && m <= 57 || 16 === f && (32 | m) >= 97 && (32 | m) <= 102;);
              if (h !== i) {
                var g = t.substring(h, i),
                  v = parseInt(g, f);
                if (59 === t.charCodeAt(i)) i += 1;else if (n) continue;
                r += s.default(v), o = i;
              }
            }
            return r + t.slice(o);
          };
        }
        function u(e, n, r, o) {
          if (n <= 128) return o === n ? r : -1;
          var i = (n & a.BRANCH_LENGTH) >> 8;
          if (0 === i) return -1;
          if (1 === i) return o === e[r] ? r + 1 : -1;
          var s = n & a.JUMP_TABLE;
          if (s) {
            var l = o - t.JUMP_OFFSET_BASE - s;
            return l < 0 || l > i ? -1 : e[r + l] - 1;
          }
          for (var u = r, c = u + i - 1; u <= c;) {
            var d = u + c >>> 1,
              p = e[d];
            if (p < o) u = d + 1;else {
              if (!(p > o)) return e[d + i];
              c = d - 1;
            }
          }
          return -1;
        }
        !function (e) {
          e[e.HAS_VALUE = 32768] = "HAS_VALUE", e[e.BRANCH_LENGTH = 32512] = "BRANCH_LENGTH", e[e.MULTI_BYTE = 128] = "MULTI_BYTE", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
        }(a = t.BinTrieFlags || (t.BinTrieFlags = {})), t.JUMP_OFFSET_BASE = 47, t.determineBranch = u;
        var c = l(o.default),
          d = l(i.default);
        t.decodeHTML = function (e) {
          return c(e, !1);
        }, t.decodeHTMLStrict = function (e) {
          return c(e, !0);
        }, t.decodeXML = function (e) {
          return d(e, !0);
        };
      },
      35102: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var n = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]),
          r = String.fromCodePoint || function (e) {
            var t = "";
            return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += String.fromCharCode(e);
          };
        t.default = function (e) {
          var t;
          return e >= 55296 && e <= 57343 || e > 1114111 ? "�" : r(null !== (t = n.get(e)) && void 0 !== t ? t : e);
        };
      },
      81792: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array([14866, 60, 237, 340, 721, 1312, 1562, 1654, 1838, 1957, 2183, 2239, 2301, 2958, 3037, 3893, 4123, 4298, 4330, 4801, 5191, 5395, 5752, 5903, 5943, 5972, 6050, 0, 0, 0, 0, 0, 0, 6135, 6565, 7422, 8183, 8738, 9242, 9503, 9938, 10189, 10573, 10637, 10715, 11950, 12246, 13539, 13950, 14445, 14533, 15364, 16514, 16980, 17390, 17763, 17849, 18036, 18125, 4096, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 92, 100, 106, 115, 122, 137, 142, 151, 157, 163, 167, 182, 196, 204, 220, 229, 108, 105, 103, 33024, 198, 59, 32768, 198, 80, 33024, 38, 59, 32768, 38, 99, 117, 116, 101, 33024, 193, 59, 32768, 193, 114, 101, 118, 101, 59, 32768, 258, 512, 105, 121, 127, 134, 114, 99, 33024, 194, 59, 32768, 194, 59, 32768, 1040, 114, 59, 32896, 55349, 56580, 114, 97, 118, 101, 33024, 192, 59, 32768, 192, 112, 104, 97, 59, 32768, 913, 97, 99, 114, 59, 32768, 256, 100, 59, 32768, 10835, 512, 103, 112, 172, 177, 111, 110, 59, 32768, 260, 102, 59, 32896, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 32768, 8289, 105, 110, 103, 33024, 197, 59, 32768, 197, 512, 99, 115, 209, 214, 114, 59, 32896, 55349, 56476, 105, 103, 110, 59, 32768, 8788, 105, 108, 100, 101, 33024, 195, 59, 32768, 195, 109, 108, 33024, 196, 59, 32768, 196, 2048, 97, 99, 101, 102, 111, 114, 115, 117, 253, 278, 282, 310, 315, 321, 327, 332, 512, 99, 114, 258, 267, 107, 115, 108, 97, 115, 104, 59, 32768, 8726, 583, 271, 274, 59, 32768, 10983, 101, 100, 59, 32768, 8966, 121, 59, 32768, 1041, 768, 99, 114, 116, 289, 296, 306, 97, 117, 115, 101, 59, 32768, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 32768, 8492, 97, 59, 32768, 914, 114, 59, 32896, 55349, 56581, 112, 102, 59, 32896, 55349, 56633, 101, 118, 101, 59, 32768, 728, 99, 114, 59, 32768, 8492, 109, 112, 101, 113, 59, 32768, 8782, 3584, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 368, 373, 380, 426, 461, 466, 487, 491, 495, 533, 593, 695, 701, 707, 99, 121, 59, 32768, 1063, 80, 89, 33024, 169, 59, 32768, 169, 768, 99, 112, 121, 387, 393, 419, 117, 116, 101, 59, 32768, 262, 512, 59, 105, 398, 400, 32768, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8517, 108, 101, 121, 115, 59, 32768, 8493, 1024, 97, 101, 105, 111, 435, 441, 449, 454, 114, 111, 110, 59, 32768, 268, 100, 105, 108, 33024, 199, 59, 32768, 199, 114, 99, 59, 32768, 264, 110, 105, 110, 116, 59, 32768, 8752, 111, 116, 59, 32768, 266, 512, 100, 110, 471, 478, 105, 108, 108, 97, 59, 32768, 184, 116, 101, 114, 68, 111, 116, 59, 32768, 183, 114, 59, 32768, 8493, 105, 59, 32768, 935, 114, 99, 108, 101, 1024, 68, 77, 80, 84, 508, 513, 520, 526, 111, 116, 59, 32768, 8857, 105, 110, 117, 115, 59, 32768, 8854, 108, 117, 115, 59, 32768, 8853, 105, 109, 101, 115, 59, 32768, 8855, 111, 512, 99, 115, 539, 562, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8754, 101, 67, 117, 114, 108, 121, 512, 68, 81, 573, 586, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8221, 117, 111, 116, 101, 59, 32768, 8217, 1024, 108, 110, 112, 117, 602, 614, 648, 664, 111, 110, 512, 59, 101, 609, 611, 32768, 8759, 59, 32768, 10868, 768, 103, 105, 116, 621, 629, 634, 114, 117, 101, 110, 116, 59, 32768, 8801, 110, 116, 59, 32768, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8750, 512, 102, 114, 653, 656, 59, 32768, 8450, 111, 100, 117, 99, 116, 59, 32768, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8755, 111, 115, 115, 59, 32768, 10799, 99, 114, 59, 32896, 55349, 56478, 112, 512, 59, 67, 713, 715, 32768, 8915, 97, 112, 59, 32768, 8781, 2816, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 743, 758, 763, 768, 773, 795, 809, 821, 826, 910, 1295, 512, 59, 111, 748, 750, 32768, 8517, 116, 114, 97, 104, 100, 59, 32768, 10513, 99, 121, 59, 32768, 1026, 99, 121, 59, 32768, 1029, 99, 121, 59, 32768, 1039, 768, 103, 114, 115, 780, 786, 790, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8609, 104, 118, 59, 32768, 10980, 512, 97, 121, 800, 806, 114, 111, 110, 59, 32768, 270, 59, 32768, 1044, 108, 512, 59, 116, 815, 817, 32768, 8711, 97, 59, 32768, 916, 114, 59, 32896, 55349, 56583, 512, 97, 102, 831, 897, 512, 99, 109, 836, 891, 114, 105, 116, 105, 99, 97, 108, 1024, 65, 68, 71, 84, 852, 859, 877, 884, 99, 117, 116, 101, 59, 32768, 180, 111, 581, 864, 867, 59, 32768, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 32768, 733, 114, 97, 118, 101, 59, 32768, 96, 105, 108, 100, 101, 59, 32768, 732, 111, 110, 100, 59, 32768, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 32768, 8518, 2113, 920, 0, 0, 0, 925, 946, 0, 1139, 102, 59, 32896, 55349, 56635, 768, 59, 68, 69, 931, 933, 938, 32768, 168, 111, 116, 59, 32768, 8412, 113, 117, 97, 108, 59, 32768, 8784, 98, 108, 101, 1536, 67, 68, 76, 82, 85, 86, 961, 978, 996, 1080, 1101, 1125, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 32768, 8751, 111, 1093, 985, 0, 0, 988, 59, 32768, 168, 110, 65, 114, 114, 111, 119, 59, 32768, 8659, 512, 101, 111, 1001, 1034, 102, 116, 768, 65, 82, 84, 1010, 1017, 1029, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8660, 101, 101, 59, 32768, 10980, 110, 103, 512, 76, 82, 1041, 1068, 101, 102, 116, 512, 65, 82, 1049, 1056, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10233, 105, 103, 104, 116, 512, 65, 84, 1089, 1096, 114, 114, 111, 119, 59, 32768, 8658, 101, 101, 59, 32768, 8872, 112, 1042, 1108, 0, 0, 1115, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8741, 110, 1536, 65, 66, 76, 82, 84, 97, 1152, 1179, 1186, 1236, 1272, 1288, 114, 114, 111, 119, 768, 59, 66, 85, 1163, 1165, 1170, 32768, 8595, 97, 114, 59, 32768, 10515, 112, 65, 114, 114, 111, 119, 59, 32768, 8693, 114, 101, 118, 101, 59, 32768, 785, 101, 102, 116, 1315, 1196, 0, 1209, 0, 1220, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 32768, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10590, 101, 99, 116, 111, 114, 512, 59, 66, 1229, 1231, 32768, 8637, 97, 114, 59, 32768, 10582, 105, 103, 104, 116, 805, 1245, 0, 1256, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10591, 101, 99, 116, 111, 114, 512, 59, 66, 1265, 1267, 32768, 8641, 97, 114, 59, 32768, 10583, 101, 101, 512, 59, 65, 1279, 1281, 32768, 8868, 114, 114, 111, 119, 59, 32768, 8615, 114, 114, 111, 119, 59, 32768, 8659, 512, 99, 116, 1300, 1305, 114, 59, 32896, 55349, 56479, 114, 111, 107, 59, 32768, 272, 4096, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1344, 1348, 1354, 1363, 1386, 1391, 1396, 1405, 1413, 1460, 1475, 1483, 1514, 1527, 1531, 1538, 71, 59, 32768, 330, 72, 33024, 208, 59, 32768, 208, 99, 117, 116, 101, 33024, 201, 59, 32768, 201, 768, 97, 105, 121, 1370, 1376, 1383, 114, 111, 110, 59, 32768, 282, 114, 99, 33024, 202, 59, 32768, 202, 59, 32768, 1069, 111, 116, 59, 32768, 278, 114, 59, 32896, 55349, 56584, 114, 97, 118, 101, 33024, 200, 59, 32768, 200, 101, 109, 101, 110, 116, 59, 32768, 8712, 512, 97, 112, 1418, 1423, 99, 114, 59, 32768, 274, 116, 121, 1060, 1431, 0, 0, 1444, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9643, 512, 103, 112, 1465, 1470, 111, 110, 59, 32768, 280, 102, 59, 32896, 55349, 56636, 115, 105, 108, 111, 110, 59, 32768, 917, 117, 512, 97, 105, 1489, 1504, 108, 512, 59, 84, 1495, 1497, 32768, 10869, 105, 108, 100, 101, 59, 32768, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8652, 512, 99, 105, 1519, 1523, 114, 59, 32768, 8496, 109, 59, 32768, 10867, 97, 59, 32768, 919, 109, 108, 33024, 203, 59, 32768, 203, 512, 105, 112, 1543, 1549, 115, 116, 115, 59, 32768, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 32768, 8519, 1280, 99, 102, 105, 111, 115, 1572, 1576, 1581, 1620, 1648, 121, 59, 32768, 1060, 114, 59, 32896, 55349, 56585, 108, 108, 101, 100, 1060, 1591, 0, 0, 1604, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 32768, 9642, 1601, 1628, 0, 1633, 0, 0, 1639, 102, 59, 32896, 55349, 56637, 65, 108, 108, 59, 32768, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 32768, 8497, 99, 114, 59, 32768, 8497, 3072, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1678, 1683, 1688, 1701, 1708, 1729, 1734, 1739, 1742, 1748, 1828, 1834, 99, 121, 59, 32768, 1027, 33024, 62, 59, 32768, 62, 109, 109, 97, 512, 59, 100, 1696, 1698, 32768, 915, 59, 32768, 988, 114, 101, 118, 101, 59, 32768, 286, 768, 101, 105, 121, 1715, 1721, 1726, 100, 105, 108, 59, 32768, 290, 114, 99, 59, 32768, 284, 59, 32768, 1043, 111, 116, 59, 32768, 288, 114, 59, 32896, 55349, 56586, 59, 32768, 8921, 112, 102, 59, 32896, 55349, 56638, 101, 97, 116, 101, 114, 1536, 69, 70, 71, 76, 83, 84, 1766, 1783, 1794, 1803, 1809, 1821, 113, 117, 97, 108, 512, 59, 76, 1775, 1777, 32768, 8805, 101, 115, 115, 59, 32768, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8807, 114, 101, 97, 116, 101, 114, 59, 32768, 10914, 101, 115, 115, 59, 32768, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10878, 105, 108, 100, 101, 59, 32768, 8819, 99, 114, 59, 32896, 55349, 56482, 59, 32768, 8811, 2048, 65, 97, 99, 102, 105, 111, 115, 117, 1854, 1861, 1874, 1880, 1884, 1897, 1919, 1934, 82, 68, 99, 121, 59, 32768, 1066, 512, 99, 116, 1866, 1871, 101, 107, 59, 32768, 711, 59, 32768, 94, 105, 114, 99, 59, 32768, 292, 114, 59, 32768, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 32768, 8459, 833, 1902, 0, 1906, 102, 59, 32768, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 32768, 9472, 512, 99, 116, 1924, 1928, 114, 59, 32768, 8459, 114, 111, 107, 59, 32768, 294, 109, 112, 533, 1940, 1950, 111, 119, 110, 72, 117, 109, 112, 59, 32768, 8782, 113, 117, 97, 108, 59, 32768, 8783, 3584, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 1985, 1990, 1996, 2001, 2010, 2025, 2030, 2034, 2043, 2077, 2134, 2155, 2160, 2167, 99, 121, 59, 32768, 1045, 108, 105, 103, 59, 32768, 306, 99, 121, 59, 32768, 1025, 99, 117, 116, 101, 33024, 205, 59, 32768, 205, 512, 105, 121, 2015, 2022, 114, 99, 33024, 206, 59, 32768, 206, 59, 32768, 1048, 111, 116, 59, 32768, 304, 114, 59, 32768, 8465, 114, 97, 118, 101, 33024, 204, 59, 32768, 204, 768, 59, 97, 112, 2050, 2052, 2070, 32768, 8465, 512, 99, 103, 2057, 2061, 114, 59, 32768, 298, 105, 110, 97, 114, 121, 73, 59, 32768, 8520, 108, 105, 101, 115, 59, 32768, 8658, 837, 2082, 0, 2110, 512, 59, 101, 2086, 2088, 32768, 8748, 512, 103, 114, 2093, 2099, 114, 97, 108, 59, 32768, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8898, 105, 115, 105, 98, 108, 101, 512, 67, 84, 2120, 2127, 111, 109, 109, 97, 59, 32768, 8291, 105, 109, 101, 115, 59, 32768, 8290, 768, 103, 112, 116, 2141, 2146, 2151, 111, 110, 59, 32768, 302, 102, 59, 32896, 55349, 56640, 97, 59, 32768, 921, 99, 114, 59, 32768, 8464, 105, 108, 100, 101, 59, 32768, 296, 828, 2172, 0, 2177, 99, 121, 59, 32768, 1030, 108, 33024, 207, 59, 32768, 207, 1280, 99, 102, 111, 115, 117, 2193, 2206, 2211, 2217, 2232, 512, 105, 121, 2198, 2203, 114, 99, 59, 32768, 308, 59, 32768, 1049, 114, 59, 32896, 55349, 56589, 112, 102, 59, 32896, 55349, 56641, 820, 2222, 0, 2227, 114, 59, 32896, 55349, 56485, 114, 99, 121, 59, 32768, 1032, 107, 99, 121, 59, 32768, 1028, 1792, 72, 74, 97, 99, 102, 111, 115, 2253, 2258, 2263, 2269, 2283, 2288, 2294, 99, 121, 59, 32768, 1061, 99, 121, 59, 32768, 1036, 112, 112, 97, 59, 32768, 922, 512, 101, 121, 2274, 2280, 100, 105, 108, 59, 32768, 310, 59, 32768, 1050, 114, 59, 32896, 55349, 56590, 112, 102, 59, 32896, 55349, 56642, 99, 114, 59, 32896, 55349, 56486, 2816, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2323, 2328, 2333, 2374, 2396, 2775, 2780, 2797, 2804, 2934, 2954, 99, 121, 59, 32768, 1033, 33024, 60, 59, 32768, 60, 1280, 99, 109, 110, 112, 114, 2344, 2350, 2356, 2360, 2370, 117, 116, 101, 59, 32768, 313, 98, 100, 97, 59, 32768, 923, 103, 59, 32768, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 32768, 8466, 114, 59, 32768, 8606, 768, 97, 101, 121, 2381, 2387, 2393, 114, 111, 110, 59, 32768, 317, 100, 105, 108, 59, 32768, 315, 59, 32768, 1051, 512, 102, 115, 2401, 2702, 116, 2560, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2423, 2470, 2479, 2530, 2537, 2561, 2618, 2666, 2683, 2690, 512, 110, 114, 2428, 2441, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10216, 114, 111, 119, 768, 59, 66, 82, 2451, 2453, 2458, 32768, 8592, 97, 114, 59, 32768, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8646, 101, 105, 108, 105, 110, 103, 59, 32768, 8968, 111, 838, 2485, 0, 2498, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10214, 110, 805, 2503, 0, 2514, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10593, 101, 99, 116, 111, 114, 512, 59, 66, 2523, 2525, 32768, 8643, 97, 114, 59, 32768, 10585, 108, 111, 111, 114, 59, 32768, 8970, 105, 103, 104, 116, 512, 65, 86, 2546, 2553, 114, 114, 111, 119, 59, 32768, 8596, 101, 99, 116, 111, 114, 59, 32768, 10574, 512, 101, 114, 2566, 2591, 101, 768, 59, 65, 86, 2574, 2576, 2583, 32768, 8867, 114, 114, 111, 119, 59, 32768, 8612, 101, 99, 116, 111, 114, 59, 32768, 10586, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 2604, 2606, 2611, 32768, 8882, 97, 114, 59, 32768, 10703, 113, 117, 97, 108, 59, 32768, 8884, 112, 768, 68, 84, 86, 2626, 2638, 2649, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10592, 101, 99, 116, 111, 114, 512, 59, 66, 2659, 2661, 32768, 8639, 97, 114, 59, 32768, 10584, 101, 99, 116, 111, 114, 512, 59, 66, 2676, 2678, 32768, 8636, 97, 114, 59, 32768, 10578, 114, 114, 111, 119, 59, 32768, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8660, 115, 1536, 69, 70, 71, 76, 83, 84, 2716, 2730, 2741, 2750, 2756, 2768, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8806, 114, 101, 97, 116, 101, 114, 59, 32768, 8822, 101, 115, 115, 59, 32768, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 10877, 105, 108, 100, 101, 59, 32768, 8818, 114, 59, 32896, 55349, 56591, 512, 59, 101, 2785, 2787, 32768, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8666, 105, 100, 111, 116, 59, 32768, 319, 768, 110, 112, 119, 2811, 2899, 2904, 103, 1024, 76, 82, 108, 114, 2821, 2848, 2860, 2887, 101, 102, 116, 512, 65, 82, 2829, 2836, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 10230, 101, 102, 116, 512, 97, 114, 2868, 2875, 114, 114, 111, 119, 59, 32768, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10233, 102, 59, 32896, 55349, 56643, 101, 114, 512, 76, 82, 2911, 2922, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8600, 768, 99, 104, 116, 2941, 2945, 2948, 114, 59, 32768, 8466, 59, 32768, 8624, 114, 111, 107, 59, 32768, 321, 59, 32768, 8810, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 2974, 2978, 2982, 3007, 3012, 3022, 3028, 3033, 112, 59, 32768, 10501, 121, 59, 32768, 1052, 512, 100, 108, 2987, 2998, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8287, 108, 105, 110, 116, 114, 102, 59, 32768, 8499, 114, 59, 32896, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 32768, 8723, 112, 102, 59, 32896, 55349, 56644, 99, 114, 59, 32768, 8499, 59, 32768, 924, 2304, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3055, 3060, 3067, 3089, 3201, 3206, 3874, 3880, 3889, 99, 121, 59, 32768, 1034, 99, 117, 116, 101, 59, 32768, 323, 768, 97, 101, 121, 3074, 3080, 3086, 114, 111, 110, 59, 32768, 327, 100, 105, 108, 59, 32768, 325, 59, 32768, 1053, 768, 103, 115, 119, 3096, 3160, 3194, 97, 116, 105, 118, 101, 768, 77, 84, 86, 3108, 3121, 3145, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 32768, 8203, 104, 105, 512, 99, 110, 3128, 3137, 107, 83, 112, 97, 99, 101, 59, 32768, 8203, 83, 112, 97, 99, 101, 59, 32768, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8203, 116, 101, 100, 512, 71, 76, 3168, 3184, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32768, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 32768, 8810, 76, 105, 110, 101, 59, 32768, 10, 114, 59, 32896, 55349, 56593, 1024, 66, 110, 112, 116, 3215, 3222, 3238, 3242, 114, 101, 97, 107, 59, 32768, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 32768, 160, 102, 59, 32768, 8469, 3328, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3269, 3271, 3293, 3312, 3352, 3430, 3455, 3551, 3589, 3625, 3678, 3821, 3861, 32768, 10988, 512, 111, 117, 3276, 3286, 110, 103, 114, 117, 101, 110, 116, 59, 32768, 8802, 112, 67, 97, 112, 59, 32768, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8742, 768, 108, 113, 120, 3319, 3327, 3345, 101, 109, 101, 110, 116, 59, 32768, 8713, 117, 97, 108, 512, 59, 84, 3335, 3337, 32768, 8800, 105, 108, 100, 101, 59, 32896, 8770, 824, 105, 115, 116, 115, 59, 32768, 8708, 114, 101, 97, 116, 101, 114, 1792, 59, 69, 70, 71, 76, 83, 84, 3373, 3375, 3382, 3394, 3404, 3410, 3423, 32768, 8815, 113, 117, 97, 108, 59, 32768, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32896, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 32896, 8811, 824, 101, 115, 115, 59, 32768, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10878, 824, 105, 108, 100, 101, 59, 32768, 8821, 117, 109, 112, 533, 3437, 3448, 111, 119, 110, 72, 117, 109, 112, 59, 32896, 8782, 824, 113, 117, 97, 108, 59, 32896, 8783, 824, 101, 512, 102, 115, 3461, 3492, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3477, 3479, 3485, 32768, 8938, 97, 114, 59, 32896, 10703, 824, 113, 117, 97, 108, 59, 32768, 8940, 115, 1536, 59, 69, 71, 76, 83, 84, 3506, 3508, 3515, 3524, 3531, 3544, 32768, 8814, 113, 117, 97, 108, 59, 32768, 8816, 114, 101, 97, 116, 101, 114, 59, 32768, 8824, 101, 115, 115, 59, 32896, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32896, 10877, 824, 105, 108, 100, 101, 59, 32768, 8820, 101, 115, 116, 101, 100, 512, 71, 76, 3561, 3578, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 32896, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 32896, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 768, 59, 69, 83, 3603, 3605, 3613, 32768, 8832, 113, 117, 97, 108, 59, 32896, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8928, 512, 101, 105, 3630, 3645, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 32768, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 3663, 3665, 3671, 32768, 8939, 97, 114, 59, 32896, 10704, 824, 113, 117, 97, 108, 59, 32768, 8941, 512, 113, 117, 3683, 3732, 117, 97, 114, 101, 83, 117, 512, 98, 112, 3694, 3712, 115, 101, 116, 512, 59, 69, 3702, 3705, 32896, 8847, 824, 113, 117, 97, 108, 59, 32768, 8930, 101, 114, 115, 101, 116, 512, 59, 69, 3722, 3725, 32896, 8848, 824, 113, 117, 97, 108, 59, 32768, 8931, 768, 98, 99, 112, 3739, 3757, 3801, 115, 101, 116, 512, 59, 69, 3747, 3750, 32896, 8834, 8402, 113, 117, 97, 108, 59, 32768, 8840, 99, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 3771, 3773, 3781, 3793, 32768, 8833, 113, 117, 97, 108, 59, 32896, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8929, 105, 108, 100, 101, 59, 32896, 8831, 824, 101, 114, 115, 101, 116, 512, 59, 69, 3811, 3814, 32896, 8835, 8402, 113, 117, 97, 108, 59, 32768, 8841, 105, 108, 100, 101, 1024, 59, 69, 70, 84, 3834, 3836, 3843, 3854, 32768, 8769, 113, 117, 97, 108, 59, 32768, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8775, 105, 108, 100, 101, 59, 32768, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 32768, 8740, 99, 114, 59, 32896, 55349, 56489, 105, 108, 100, 101, 33024, 209, 59, 32768, 209, 59, 32768, 925, 3584, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 3921, 3927, 3936, 3951, 3958, 3963, 3972, 3996, 4002, 4034, 4037, 4055, 4071, 4078, 108, 105, 103, 59, 32768, 338, 99, 117, 116, 101, 33024, 211, 59, 32768, 211, 512, 105, 121, 3941, 3948, 114, 99, 33024, 212, 59, 32768, 212, 59, 32768, 1054, 98, 108, 97, 99, 59, 32768, 336, 114, 59, 32896, 55349, 56594, 114, 97, 118, 101, 33024, 210, 59, 32768, 210, 768, 97, 101, 105, 3979, 3984, 3989, 99, 114, 59, 32768, 332, 103, 97, 59, 32768, 937, 99, 114, 111, 110, 59, 32768, 927, 112, 102, 59, 32896, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 512, 68, 81, 4014, 4027, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 32768, 8220, 117, 111, 116, 101, 59, 32768, 8216, 59, 32768, 10836, 512, 99, 108, 4042, 4047, 114, 59, 32896, 55349, 56490, 97, 115, 104, 33024, 216, 59, 32768, 216, 105, 573, 4060, 4067, 100, 101, 33024, 213, 59, 32768, 213, 101, 115, 59, 32768, 10807, 109, 108, 33024, 214, 59, 32768, 214, 101, 114, 512, 66, 80, 4085, 4109, 512, 97, 114, 4090, 4094, 114, 59, 32768, 8254, 97, 99, 512, 101, 107, 4101, 4104, 59, 32768, 9182, 101, 116, 59, 32768, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9180, 2304, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4141, 4150, 4154, 4159, 4163, 4166, 4176, 4198, 4284, 114, 116, 105, 97, 108, 68, 59, 32768, 8706, 121, 59, 32768, 1055, 114, 59, 32896, 55349, 56595, 105, 59, 32768, 934, 59, 32768, 928, 117, 115, 77, 105, 110, 117, 115, 59, 32768, 177, 512, 105, 112, 4181, 4194, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 32768, 8460, 102, 59, 32768, 8473, 1024, 59, 101, 105, 111, 4207, 4209, 4251, 4256, 32768, 10939, 99, 101, 100, 101, 115, 1024, 59, 69, 83, 84, 4223, 4225, 4232, 4244, 32768, 8826, 113, 117, 97, 108, 59, 32768, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8828, 105, 108, 100, 101, 59, 32768, 8830, 109, 101, 59, 32768, 8243, 512, 100, 112, 4261, 4267, 117, 99, 116, 59, 32768, 8719, 111, 114, 116, 105, 111, 110, 512, 59, 97, 4278, 4280, 32768, 8759, 108, 59, 32768, 8733, 512, 99, 105, 4289, 4294, 114, 59, 32896, 55349, 56491, 59, 32768, 936, 1024, 85, 102, 111, 115, 4306, 4313, 4318, 4323, 79, 84, 33024, 34, 59, 32768, 34, 114, 59, 32896, 55349, 56596, 112, 102, 59, 32768, 8474, 99, 114, 59, 32896, 55349, 56492, 3072, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4354, 4360, 4366, 4395, 4417, 4473, 4477, 4481, 4743, 4764, 4776, 4788, 97, 114, 114, 59, 32768, 10512, 71, 33024, 174, 59, 32768, 174, 768, 99, 110, 114, 4373, 4379, 4383, 117, 116, 101, 59, 32768, 340, 103, 59, 32768, 10219, 114, 512, 59, 116, 4389, 4391, 32768, 8608, 108, 59, 32768, 10518, 768, 97, 101, 121, 4402, 4408, 4414, 114, 111, 110, 59, 32768, 344, 100, 105, 108, 59, 32768, 342, 59, 32768, 1056, 512, 59, 118, 4422, 4424, 32768, 8476, 101, 114, 115, 101, 512, 69, 85, 4433, 4458, 512, 108, 113, 4438, 4446, 101, 109, 101, 110, 116, 59, 32768, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10607, 114, 59, 32768, 8476, 111, 59, 32768, 929, 103, 104, 116, 2048, 65, 67, 68, 70, 84, 85, 86, 97, 4501, 4547, 4556, 4607, 4614, 4671, 4719, 4736, 512, 110, 114, 4506, 4519, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10217, 114, 111, 119, 768, 59, 66, 76, 4529, 4531, 4536, 32768, 8594, 97, 114, 59, 32768, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8644, 101, 105, 108, 105, 110, 103, 59, 32768, 8969, 111, 838, 4562, 0, 4575, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 32768, 10215, 110, 805, 4580, 0, 4591, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10589, 101, 99, 116, 111, 114, 512, 59, 66, 4600, 4602, 32768, 8642, 97, 114, 59, 32768, 10581, 108, 111, 111, 114, 59, 32768, 8971, 512, 101, 114, 4619, 4644, 101, 768, 59, 65, 86, 4627, 4629, 4636, 32768, 8866, 114, 114, 111, 119, 59, 32768, 8614, 101, 99, 116, 111, 114, 59, 32768, 10587, 105, 97, 110, 103, 108, 101, 768, 59, 66, 69, 4657, 4659, 4664, 32768, 8883, 97, 114, 59, 32768, 10704, 113, 117, 97, 108, 59, 32768, 8885, 112, 768, 68, 84, 86, 4679, 4691, 4702, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 32768, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 32768, 10588, 101, 99, 116, 111, 114, 512, 59, 66, 4712, 4714, 32768, 8638, 97, 114, 59, 32768, 10580, 101, 99, 116, 111, 114, 512, 59, 66, 4729, 4731, 32768, 8640, 97, 114, 59, 32768, 10579, 114, 114, 111, 119, 59, 32768, 8658, 512, 112, 117, 4748, 4752, 102, 59, 32768, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 32768, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8667, 512, 99, 104, 4781, 4785, 114, 59, 32768, 8475, 59, 32768, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 32768, 10740, 3328, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 4827, 4842, 4849, 4856, 4889, 4894, 4949, 4955, 4967, 4973, 5059, 5065, 5070, 512, 67, 99, 4832, 4838, 72, 99, 121, 59, 32768, 1065, 121, 59, 32768, 1064, 70, 84, 99, 121, 59, 32768, 1068, 99, 117, 116, 101, 59, 32768, 346, 1280, 59, 97, 101, 105, 121, 4867, 4869, 4875, 4881, 4886, 32768, 10940, 114, 111, 110, 59, 32768, 352, 100, 105, 108, 59, 32768, 350, 114, 99, 59, 32768, 348, 59, 32768, 1057, 114, 59, 32896, 55349, 56598, 111, 114, 116, 1024, 68, 76, 82, 85, 4906, 4917, 4928, 4940, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8594, 112, 65, 114, 114, 111, 119, 59, 32768, 8593, 103, 109, 97, 59, 32768, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 32768, 8728, 112, 102, 59, 32896, 55349, 56650, 1091, 4979, 0, 0, 4983, 116, 59, 32768, 8730, 97, 114, 101, 1024, 59, 73, 83, 85, 4994, 4996, 5010, 5052, 32768, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 32768, 8851, 117, 512, 98, 112, 5016, 5033, 115, 101, 116, 512, 59, 69, 5024, 5026, 32768, 8847, 113, 117, 97, 108, 59, 32768, 8849, 101, 114, 115, 101, 116, 512, 59, 69, 5043, 5045, 32768, 8848, 113, 117, 97, 108, 59, 32768, 8850, 110, 105, 111, 110, 59, 32768, 8852, 99, 114, 59, 32896, 55349, 56494, 97, 114, 59, 32768, 8902, 1024, 98, 99, 109, 112, 5079, 5102, 5155, 5158, 512, 59, 115, 5084, 5086, 32768, 8912, 101, 116, 512, 59, 69, 5093, 5095, 32768, 8912, 113, 117, 97, 108, 59, 32768, 8838, 512, 99, 104, 5107, 5148, 101, 101, 100, 115, 1024, 59, 69, 83, 84, 5120, 5122, 5129, 5141, 32768, 8827, 113, 117, 97, 108, 59, 32768, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 32768, 8829, 105, 108, 100, 101, 59, 32768, 8831, 84, 104, 97, 116, 59, 32768, 8715, 59, 32768, 8721, 768, 59, 101, 115, 5165, 5167, 5185, 32768, 8913, 114, 115, 101, 116, 512, 59, 69, 5176, 5178, 32768, 8835, 113, 117, 97, 108, 59, 32768, 8839, 101, 116, 59, 32768, 8913, 2816, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5213, 5221, 5227, 5241, 5252, 5274, 5279, 5323, 5362, 5368, 5378, 79, 82, 78, 33024, 222, 59, 32768, 222, 65, 68, 69, 59, 32768, 8482, 512, 72, 99, 5232, 5237, 99, 121, 59, 32768, 1035, 121, 59, 32768, 1062, 512, 98, 117, 5246, 5249, 59, 32768, 9, 59, 32768, 932, 768, 97, 101, 121, 5259, 5265, 5271, 114, 111, 110, 59, 32768, 356, 100, 105, 108, 59, 32768, 354, 59, 32768, 1058, 114, 59, 32896, 55349, 56599, 512, 101, 105, 5284, 5300, 835, 5289, 0, 5297, 101, 102, 111, 114, 101, 59, 32768, 8756, 97, 59, 32768, 920, 512, 99, 110, 5305, 5315, 107, 83, 112, 97, 99, 101, 59, 32896, 8287, 8202, 83, 112, 97, 99, 101, 59, 32768, 8201, 108, 100, 101, 1024, 59, 69, 70, 84, 5335, 5337, 5344, 5355, 32768, 8764, 113, 117, 97, 108, 59, 32768, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 32768, 8773, 105, 108, 100, 101, 59, 32768, 8776, 112, 102, 59, 32896, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 32768, 8411, 512, 99, 116, 5383, 5388, 114, 59, 32896, 55349, 56495, 114, 111, 107, 59, 32768, 358, 5426, 5417, 5444, 5458, 5473, 0, 5480, 5485, 0, 0, 0, 0, 0, 5494, 5500, 5564, 5579, 0, 5726, 5732, 5738, 5745, 512, 99, 114, 5421, 5429, 117, 116, 101, 33024, 218, 59, 32768, 218, 114, 512, 59, 111, 5435, 5437, 32768, 8607, 99, 105, 114, 59, 32768, 10569, 114, 820, 5449, 0, 5453, 121, 59, 32768, 1038, 118, 101, 59, 32768, 364, 512, 105, 121, 5462, 5469, 114, 99, 33024, 219, 59, 32768, 219, 59, 32768, 1059, 98, 108, 97, 99, 59, 32768, 368, 114, 59, 32896, 55349, 56600, 114, 97, 118, 101, 33024, 217, 59, 32768, 217, 97, 99, 114, 59, 32768, 362, 512, 100, 105, 5504, 5548, 101, 114, 512, 66, 80, 5511, 5535, 512, 97, 114, 5516, 5520, 114, 59, 32768, 95, 97, 99, 512, 101, 107, 5527, 5530, 59, 32768, 9183, 101, 116, 59, 32768, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 32768, 9181, 111, 110, 512, 59, 80, 5555, 5557, 32768, 8899, 108, 117, 115, 59, 32768, 8846, 512, 103, 112, 5568, 5573, 111, 110, 59, 32768, 370, 102, 59, 32896, 55349, 56652, 2048, 65, 68, 69, 84, 97, 100, 112, 115, 5595, 5624, 5635, 5648, 5664, 5671, 5682, 5712, 114, 114, 111, 119, 768, 59, 66, 68, 5606, 5608, 5613, 32768, 8593, 97, 114, 59, 32768, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 32768, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 32768, 10606, 101, 101, 512, 59, 65, 5655, 5657, 32768, 8869, 114, 114, 111, 119, 59, 32768, 8613, 114, 114, 111, 119, 59, 32768, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8661, 101, 114, 512, 76, 82, 5689, 5700, 101, 102, 116, 65, 114, 114, 111, 119, 59, 32768, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 32768, 8599, 105, 512, 59, 108, 5718, 5720, 32768, 978, 111, 110, 59, 32768, 933, 105, 110, 103, 59, 32768, 366, 99, 114, 59, 32896, 55349, 56496, 105, 108, 100, 101, 59, 32768, 360, 109, 108, 33024, 220, 59, 32768, 220, 2304, 68, 98, 99, 100, 101, 102, 111, 115, 118, 5770, 5776, 5781, 5785, 5798, 5878, 5883, 5889, 5895, 97, 115, 104, 59, 32768, 8875, 97, 114, 59, 32768, 10987, 121, 59, 32768, 1042, 97, 115, 104, 512, 59, 108, 5793, 5795, 32768, 8873, 59, 32768, 10982, 512, 101, 114, 5803, 5806, 59, 32768, 8897, 768, 98, 116, 121, 5813, 5818, 5866, 97, 114, 59, 32768, 8214, 512, 59, 105, 5823, 5825, 32768, 8214, 99, 97, 108, 1024, 66, 76, 83, 84, 5837, 5842, 5848, 5859, 97, 114, 59, 32768, 8739, 105, 110, 101, 59, 32768, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 32768, 10072, 105, 108, 100, 101, 59, 32768, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 32768, 8202, 114, 59, 32896, 55349, 56601, 112, 102, 59, 32896, 55349, 56653, 99, 114, 59, 32896, 55349, 56497, 100, 97, 115, 104, 59, 32768, 8874, 1280, 99, 101, 102, 111, 115, 5913, 5919, 5925, 5930, 5936, 105, 114, 99, 59, 32768, 372, 100, 103, 101, 59, 32768, 8896, 114, 59, 32896, 55349, 56602, 112, 102, 59, 32896, 55349, 56654, 99, 114, 59, 32896, 55349, 56498, 1024, 102, 105, 111, 115, 5951, 5956, 5959, 5965, 114, 59, 32896, 55349, 56603, 59, 32768, 926, 112, 102, 59, 32896, 55349, 56655, 99, 114, 59, 32896, 55349, 56499, 2304, 65, 73, 85, 97, 99, 102, 111, 115, 117, 5990, 5995, 6e3, 6005, 6014, 6027, 6032, 6038, 6044, 99, 121, 59, 32768, 1071, 99, 121, 59, 32768, 1031, 99, 121, 59, 32768, 1070, 99, 117, 116, 101, 33024, 221, 59, 32768, 221, 512, 105, 121, 6019, 6024, 114, 99, 59, 32768, 374, 59, 32768, 1067, 114, 59, 32896, 55349, 56604, 112, 102, 59, 32896, 55349, 56656, 99, 114, 59, 32896, 55349, 56500, 109, 108, 59, 32768, 376, 2048, 72, 97, 99, 100, 101, 102, 111, 115, 6066, 6071, 6078, 6092, 6097, 6119, 6123, 6128, 99, 121, 59, 32768, 1046, 99, 117, 116, 101, 59, 32768, 377, 512, 97, 121, 6083, 6089, 114, 111, 110, 59, 32768, 381, 59, 32768, 1047, 111, 116, 59, 32768, 379, 835, 6102, 0, 6116, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 32768, 8203, 97, 59, 32768, 918, 114, 59, 32768, 8488, 112, 102, 59, 32768, 8484, 99, 114, 59, 32896, 55349, 56501, 5938, 6159, 6168, 6175, 0, 6214, 6222, 6233, 0, 0, 0, 0, 6242, 6267, 6290, 6429, 6444, 0, 6495, 6503, 6531, 6540, 0, 6547, 99, 117, 116, 101, 33024, 225, 59, 32768, 225, 114, 101, 118, 101, 59, 32768, 259, 1536, 59, 69, 100, 105, 117, 121, 6187, 6189, 6193, 6196, 6203, 6210, 32768, 8766, 59, 32896, 8766, 819, 59, 32768, 8767, 114, 99, 33024, 226, 59, 32768, 226, 116, 101, 33024, 180, 59, 32768, 180, 59, 32768, 1072, 108, 105, 103, 33024, 230, 59, 32768, 230, 512, 59, 114, 6226, 6228, 32768, 8289, 59, 32896, 55349, 56606, 114, 97, 118, 101, 33024, 224, 59, 32768, 224, 512, 101, 112, 6246, 6261, 512, 102, 112, 6251, 6257, 115, 121, 109, 59, 32768, 8501, 104, 59, 32768, 8501, 104, 97, 59, 32768, 945, 512, 97, 112, 6271, 6284, 512, 99, 108, 6276, 6280, 114, 59, 32768, 257, 103, 59, 32768, 10815, 33024, 38, 59, 32768, 38, 1077, 6295, 0, 0, 6326, 1280, 59, 97, 100, 115, 118, 6305, 6307, 6312, 6315, 6322, 32768, 8743, 110, 100, 59, 32768, 10837, 59, 32768, 10844, 108, 111, 112, 101, 59, 32768, 10840, 59, 32768, 10842, 1792, 59, 101, 108, 109, 114, 115, 122, 6340, 6342, 6345, 6349, 6391, 6410, 6422, 32768, 8736, 59, 32768, 10660, 101, 59, 32768, 8736, 115, 100, 512, 59, 97, 6356, 6358, 32768, 8737, 2098, 6368, 6371, 6374, 6377, 6380, 6383, 6386, 6389, 59, 32768, 10664, 59, 32768, 10665, 59, 32768, 10666, 59, 32768, 10667, 59, 32768, 10668, 59, 32768, 10669, 59, 32768, 10670, 59, 32768, 10671, 116, 512, 59, 118, 6397, 6399, 32768, 8735, 98, 512, 59, 100, 6405, 6407, 32768, 8894, 59, 32768, 10653, 512, 112, 116, 6415, 6419, 104, 59, 32768, 8738, 59, 32768, 197, 97, 114, 114, 59, 32768, 9084, 512, 103, 112, 6433, 6438, 111, 110, 59, 32768, 261, 102, 59, 32896, 55349, 56658, 1792, 59, 69, 97, 101, 105, 111, 112, 6458, 6460, 6463, 6469, 6472, 6476, 6480, 32768, 8776, 59, 32768, 10864, 99, 105, 114, 59, 32768, 10863, 59, 32768, 8778, 100, 59, 32768, 8779, 115, 59, 32768, 39, 114, 111, 120, 512, 59, 101, 6488, 6490, 32768, 8776, 113, 59, 32768, 8778, 105, 110, 103, 33024, 229, 59, 32768, 229, 768, 99, 116, 121, 6509, 6514, 6517, 114, 59, 32896, 55349, 56502, 59, 32768, 42, 109, 112, 512, 59, 101, 6524, 6526, 32768, 8776, 113, 59, 32768, 8781, 105, 108, 100, 101, 33024, 227, 59, 32768, 227, 109, 108, 33024, 228, 59, 32768, 228, 512, 99, 105, 6551, 6559, 111, 110, 105, 110, 116, 59, 32768, 8755, 110, 116, 59, 32768, 10769, 4096, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 6597, 6602, 6673, 6688, 6701, 6707, 6768, 6773, 6891, 6898, 6999, 7023, 7309, 7316, 7334, 7383, 111, 116, 59, 32768, 10989, 512, 99, 114, 6607, 6652, 107, 1024, 99, 101, 112, 115, 6617, 6623, 6632, 6639, 111, 110, 103, 59, 32768, 8780, 112, 115, 105, 108, 111, 110, 59, 32768, 1014, 114, 105, 109, 101, 59, 32768, 8245, 105, 109, 512, 59, 101, 6646, 6648, 32768, 8765, 113, 59, 32768, 8909, 583, 6656, 6661, 101, 101, 59, 32768, 8893, 101, 100, 512, 59, 103, 6667, 6669, 32768, 8965, 101, 59, 32768, 8965, 114, 107, 512, 59, 116, 6680, 6682, 32768, 9141, 98, 114, 107, 59, 32768, 9142, 512, 111, 121, 6693, 6698, 110, 103, 59, 32768, 8780, 59, 32768, 1073, 113, 117, 111, 59, 32768, 8222, 1280, 99, 109, 112, 114, 116, 6718, 6731, 6738, 6743, 6749, 97, 117, 115, 512, 59, 101, 6726, 6728, 32768, 8757, 59, 32768, 8757, 112, 116, 121, 118, 59, 32768, 10672, 115, 105, 59, 32768, 1014, 110, 111, 117, 59, 32768, 8492, 768, 97, 104, 119, 6756, 6759, 6762, 59, 32768, 946, 59, 32768, 8502, 101, 101, 110, 59, 32768, 8812, 114, 59, 32896, 55349, 56607, 103, 1792, 99, 111, 115, 116, 117, 118, 119, 6789, 6809, 6834, 6850, 6872, 6879, 6884, 768, 97, 105, 117, 6796, 6800, 6805, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 768, 100, 112, 116, 6816, 6821, 6827, 111, 116, 59, 32768, 10752, 108, 117, 115, 59, 32768, 10753, 105, 109, 101, 115, 59, 32768, 10754, 1090, 6840, 0, 0, 6846, 99, 117, 112, 59, 32768, 10758, 97, 114, 59, 32768, 9733, 114, 105, 97, 110, 103, 108, 101, 512, 100, 117, 6862, 6868, 111, 119, 110, 59, 32768, 9661, 112, 59, 32768, 9651, 112, 108, 117, 115, 59, 32768, 10756, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 97, 114, 111, 119, 59, 32768, 10509, 768, 97, 107, 111, 6905, 6976, 6994, 512, 99, 110, 6910, 6972, 107, 768, 108, 115, 116, 6918, 6927, 6935, 111, 122, 101, 110, 103, 101, 59, 32768, 10731, 113, 117, 97, 114, 101, 59, 32768, 9642, 114, 105, 97, 110, 103, 108, 101, 1024, 59, 100, 108, 114, 6951, 6953, 6959, 6965, 32768, 9652, 111, 119, 110, 59, 32768, 9662, 101, 102, 116, 59, 32768, 9666, 105, 103, 104, 116, 59, 32768, 9656, 107, 59, 32768, 9251, 770, 6981, 0, 6991, 771, 6985, 0, 6988, 59, 32768, 9618, 59, 32768, 9617, 52, 59, 32768, 9619, 99, 107, 59, 32768, 9608, 512, 101, 111, 7004, 7019, 512, 59, 113, 7009, 7012, 32896, 61, 8421, 117, 105, 118, 59, 32896, 8801, 8421, 116, 59, 32768, 8976, 1024, 112, 116, 119, 120, 7032, 7037, 7049, 7055, 102, 59, 32896, 55349, 56659, 512, 59, 116, 7042, 7044, 32768, 8869, 111, 109, 59, 32768, 8869, 116, 105, 101, 59, 32768, 8904, 3072, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7080, 7101, 7126, 7147, 7182, 7187, 7208, 7233, 7240, 7246, 7253, 7274, 1024, 76, 82, 108, 114, 7089, 7092, 7095, 7098, 59, 32768, 9559, 59, 32768, 9556, 59, 32768, 9558, 59, 32768, 9555, 1280, 59, 68, 85, 100, 117, 7112, 7114, 7117, 7120, 7123, 32768, 9552, 59, 32768, 9574, 59, 32768, 9577, 59, 32768, 9572, 59, 32768, 9575, 1024, 76, 82, 108, 114, 7135, 7138, 7141, 7144, 59, 32768, 9565, 59, 32768, 9562, 59, 32768, 9564, 59, 32768, 9561, 1792, 59, 72, 76, 82, 104, 108, 114, 7162, 7164, 7167, 7170, 7173, 7176, 7179, 32768, 9553, 59, 32768, 9580, 59, 32768, 9571, 59, 32768, 9568, 59, 32768, 9579, 59, 32768, 9570, 59, 32768, 9567, 111, 120, 59, 32768, 10697, 1024, 76, 82, 108, 114, 7196, 7199, 7202, 7205, 59, 32768, 9557, 59, 32768, 9554, 59, 32768, 9488, 59, 32768, 9484, 1280, 59, 68, 85, 100, 117, 7219, 7221, 7224, 7227, 7230, 32768, 9472, 59, 32768, 9573, 59, 32768, 9576, 59, 32768, 9516, 59, 32768, 9524, 105, 110, 117, 115, 59, 32768, 8863, 108, 117, 115, 59, 32768, 8862, 105, 109, 101, 115, 59, 32768, 8864, 1024, 76, 82, 108, 114, 7262, 7265, 7268, 7271, 59, 32768, 9563, 59, 32768, 9560, 59, 32768, 9496, 59, 32768, 9492, 1792, 59, 72, 76, 82, 104, 108, 114, 7289, 7291, 7294, 7297, 7300, 7303, 7306, 32768, 9474, 59, 32768, 9578, 59, 32768, 9569, 59, 32768, 9566, 59, 32768, 9532, 59, 32768, 9508, 59, 32768, 9500, 114, 105, 109, 101, 59, 32768, 8245, 512, 101, 118, 7321, 7326, 118, 101, 59, 32768, 728, 98, 97, 114, 33024, 166, 59, 32768, 166, 1024, 99, 101, 105, 111, 7343, 7348, 7353, 7364, 114, 59, 32896, 55349, 56503, 109, 105, 59, 32768, 8271, 109, 512, 59, 101, 7359, 7361, 32768, 8765, 59, 32768, 8909, 108, 768, 59, 98, 104, 7372, 7374, 7377, 32768, 92, 59, 32768, 10693, 115, 117, 98, 59, 32768, 10184, 573, 7387, 7399, 108, 512, 59, 101, 7392, 7394, 32768, 8226, 116, 59, 32768, 8226, 112, 768, 59, 69, 101, 7406, 7408, 7411, 32768, 8782, 59, 32768, 10926, 512, 59, 113, 7416, 7418, 32768, 8783, 59, 32768, 8783, 6450, 7448, 0, 7523, 7571, 7576, 7613, 0, 7618, 7647, 0, 0, 7764, 0, 0, 7779, 0, 0, 7899, 7914, 7949, 7955, 0, 8158, 0, 8176, 768, 99, 112, 114, 7454, 7460, 7509, 117, 116, 101, 59, 32768, 263, 1536, 59, 97, 98, 99, 100, 115, 7473, 7475, 7480, 7487, 7500, 7505, 32768, 8745, 110, 100, 59, 32768, 10820, 114, 99, 117, 112, 59, 32768, 10825, 512, 97, 117, 7492, 7496, 112, 59, 32768, 10827, 112, 59, 32768, 10823, 111, 116, 59, 32768, 10816, 59, 32896, 8745, 65024, 512, 101, 111, 7514, 7518, 116, 59, 32768, 8257, 110, 59, 32768, 711, 1024, 97, 101, 105, 117, 7531, 7544, 7552, 7557, 833, 7536, 0, 7540, 115, 59, 32768, 10829, 111, 110, 59, 32768, 269, 100, 105, 108, 33024, 231, 59, 32768, 231, 114, 99, 59, 32768, 265, 112, 115, 512, 59, 115, 7564, 7566, 32768, 10828, 109, 59, 32768, 10832, 111, 116, 59, 32768, 267, 768, 100, 109, 110, 7582, 7589, 7596, 105, 108, 33024, 184, 59, 32768, 184, 112, 116, 121, 118, 59, 32768, 10674, 116, 33280, 162, 59, 101, 7603, 7605, 32768, 162, 114, 100, 111, 116, 59, 32768, 183, 114, 59, 32896, 55349, 56608, 768, 99, 101, 105, 7624, 7628, 7643, 121, 59, 32768, 1095, 99, 107, 512, 59, 109, 7635, 7637, 32768, 10003, 97, 114, 107, 59, 32768, 10003, 59, 32768, 967, 114, 1792, 59, 69, 99, 101, 102, 109, 115, 7662, 7664, 7667, 7742, 7745, 7752, 7757, 32768, 9675, 59, 32768, 10691, 768, 59, 101, 108, 7674, 7676, 7680, 32768, 710, 113, 59, 32768, 8791, 101, 1074, 7687, 0, 0, 7709, 114, 114, 111, 119, 512, 108, 114, 7695, 7701, 101, 102, 116, 59, 32768, 8634, 105, 103, 104, 116, 59, 32768, 8635, 1280, 82, 83, 97, 99, 100, 7719, 7722, 7725, 7730, 7736, 59, 32768, 174, 59, 32768, 9416, 115, 116, 59, 32768, 8859, 105, 114, 99, 59, 32768, 8858, 97, 115, 104, 59, 32768, 8861, 59, 32768, 8791, 110, 105, 110, 116, 59, 32768, 10768, 105, 100, 59, 32768, 10991, 99, 105, 114, 59, 32768, 10690, 117, 98, 115, 512, 59, 117, 7771, 7773, 32768, 9827, 105, 116, 59, 32768, 9827, 1341, 7785, 7804, 7850, 0, 7871, 111, 110, 512, 59, 101, 7791, 7793, 32768, 58, 512, 59, 113, 7798, 7800, 32768, 8788, 59, 32768, 8788, 1086, 7809, 0, 0, 7820, 97, 512, 59, 116, 7814, 7816, 32768, 44, 59, 32768, 64, 768, 59, 102, 108, 7826, 7828, 7832, 32768, 8705, 110, 59, 32768, 8728, 101, 512, 109, 120, 7838, 7844, 101, 110, 116, 59, 32768, 8705, 101, 115, 59, 32768, 8450, 824, 7854, 0, 7866, 512, 59, 100, 7858, 7860, 32768, 8773, 111, 116, 59, 32768, 10861, 110, 116, 59, 32768, 8750, 768, 102, 114, 121, 7877, 7881, 7886, 59, 32896, 55349, 56660, 111, 100, 59, 32768, 8720, 33280, 169, 59, 115, 7892, 7894, 32768, 169, 114, 59, 32768, 8471, 512, 97, 111, 7903, 7908, 114, 114, 59, 32768, 8629, 115, 115, 59, 32768, 10007, 512, 99, 117, 7918, 7923, 114, 59, 32896, 55349, 56504, 512, 98, 112, 7928, 7938, 512, 59, 101, 7933, 7935, 32768, 10959, 59, 32768, 10961, 512, 59, 101, 7943, 7945, 32768, 10960, 59, 32768, 10962, 100, 111, 116, 59, 32768, 8943, 1792, 100, 101, 108, 112, 114, 118, 119, 7969, 7983, 7996, 8009, 8057, 8147, 8152, 97, 114, 114, 512, 108, 114, 7977, 7980, 59, 32768, 10552, 59, 32768, 10549, 1089, 7989, 0, 0, 7993, 114, 59, 32768, 8926, 99, 59, 32768, 8927, 97, 114, 114, 512, 59, 112, 8004, 8006, 32768, 8630, 59, 32768, 10557, 1536, 59, 98, 99, 100, 111, 115, 8022, 8024, 8031, 8044, 8049, 8053, 32768, 8746, 114, 99, 97, 112, 59, 32768, 10824, 512, 97, 117, 8036, 8040, 112, 59, 32768, 10822, 112, 59, 32768, 10826, 111, 116, 59, 32768, 8845, 114, 59, 32768, 10821, 59, 32896, 8746, 65024, 1024, 97, 108, 114, 118, 8066, 8078, 8116, 8123, 114, 114, 512, 59, 109, 8073, 8075, 32768, 8631, 59, 32768, 10556, 121, 768, 101, 118, 119, 8086, 8104, 8109, 113, 1089, 8093, 0, 0, 8099, 114, 101, 99, 59, 32768, 8926, 117, 99, 99, 59, 32768, 8927, 101, 101, 59, 32768, 8910, 101, 100, 103, 101, 59, 32768, 8911, 101, 110, 33024, 164, 59, 32768, 164, 101, 97, 114, 114, 111, 119, 512, 108, 114, 8134, 8140, 101, 102, 116, 59, 32768, 8630, 105, 103, 104, 116, 59, 32768, 8631, 101, 101, 59, 32768, 8910, 101, 100, 59, 32768, 8911, 512, 99, 105, 8162, 8170, 111, 110, 105, 110, 116, 59, 32768, 8754, 110, 116, 59, 32768, 8753, 108, 99, 116, 121, 59, 32768, 9005, 4864, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8221, 8226, 8231, 8267, 8282, 8296, 8327, 8351, 8366, 8379, 8466, 8471, 8487, 8621, 8647, 8676, 8697, 8712, 8720, 114, 114, 59, 32768, 8659, 97, 114, 59, 32768, 10597, 1024, 103, 108, 114, 115, 8240, 8246, 8252, 8256, 103, 101, 114, 59, 32768, 8224, 101, 116, 104, 59, 32768, 8504, 114, 59, 32768, 8595, 104, 512, 59, 118, 8262, 8264, 32768, 8208, 59, 32768, 8867, 572, 8271, 8278, 97, 114, 111, 119, 59, 32768, 10511, 97, 99, 59, 32768, 733, 512, 97, 121, 8287, 8293, 114, 111, 110, 59, 32768, 271, 59, 32768, 1076, 768, 59, 97, 111, 8303, 8305, 8320, 32768, 8518, 512, 103, 114, 8310, 8316, 103, 101, 114, 59, 32768, 8225, 114, 59, 32768, 8650, 116, 115, 101, 113, 59, 32768, 10871, 768, 103, 108, 109, 8334, 8339, 8344, 33024, 176, 59, 32768, 176, 116, 97, 59, 32768, 948, 112, 116, 121, 118, 59, 32768, 10673, 512, 105, 114, 8356, 8362, 115, 104, 116, 59, 32768, 10623, 59, 32896, 55349, 56609, 97, 114, 512, 108, 114, 8373, 8376, 59, 32768, 8643, 59, 32768, 8642, 1280, 97, 101, 103, 115, 118, 8390, 8418, 8421, 8428, 8433, 109, 768, 59, 111, 115, 8398, 8400, 8415, 32768, 8900, 110, 100, 512, 59, 115, 8407, 8409, 32768, 8900, 117, 105, 116, 59, 32768, 9830, 59, 32768, 9830, 59, 32768, 168, 97, 109, 109, 97, 59, 32768, 989, 105, 110, 59, 32768, 8946, 768, 59, 105, 111, 8440, 8442, 8461, 32768, 247, 100, 101, 33280, 247, 59, 111, 8450, 8452, 32768, 247, 110, 116, 105, 109, 101, 115, 59, 32768, 8903, 110, 120, 59, 32768, 8903, 99, 121, 59, 32768, 1106, 99, 1088, 8478, 0, 0, 8483, 114, 110, 59, 32768, 8990, 111, 112, 59, 32768, 8973, 1280, 108, 112, 116, 117, 119, 8498, 8504, 8509, 8556, 8570, 108, 97, 114, 59, 32768, 36, 102, 59, 32896, 55349, 56661, 1280, 59, 101, 109, 112, 115, 8520, 8522, 8535, 8542, 8548, 32768, 729, 113, 512, 59, 100, 8528, 8530, 32768, 8784, 111, 116, 59, 32768, 8785, 105, 110, 117, 115, 59, 32768, 8760, 108, 117, 115, 59, 32768, 8724, 113, 117, 97, 114, 101, 59, 32768, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 32768, 8966, 110, 768, 97, 100, 104, 8578, 8585, 8597, 114, 114, 111, 119, 59, 32768, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 32768, 8650, 97, 114, 112, 111, 111, 110, 512, 108, 114, 8608, 8614, 101, 102, 116, 59, 32768, 8643, 105, 103, 104, 116, 59, 32768, 8642, 563, 8625, 8633, 107, 97, 114, 111, 119, 59, 32768, 10512, 1088, 8638, 0, 0, 8643, 114, 110, 59, 32768, 8991, 111, 112, 59, 32768, 8972, 768, 99, 111, 116, 8654, 8666, 8670, 512, 114, 121, 8659, 8663, 59, 32896, 55349, 56505, 59, 32768, 1109, 108, 59, 32768, 10742, 114, 111, 107, 59, 32768, 273, 512, 100, 114, 8681, 8686, 111, 116, 59, 32768, 8945, 105, 512, 59, 102, 8692, 8694, 32768, 9663, 59, 32768, 9662, 512, 97, 104, 8702, 8707, 114, 114, 59, 32768, 8693, 97, 114, 59, 32768, 10607, 97, 110, 103, 108, 101, 59, 32768, 10662, 512, 99, 105, 8725, 8729, 121, 59, 32768, 1119, 103, 114, 97, 114, 114, 59, 32768, 10239, 4608, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 8774, 8788, 8807, 8844, 8849, 8852, 8866, 8895, 8929, 8977, 8989, 9004, 9046, 9136, 9151, 9171, 9184, 9199, 512, 68, 111, 8779, 8784, 111, 116, 59, 32768, 10871, 116, 59, 32768, 8785, 512, 99, 115, 8793, 8801, 117, 116, 101, 33024, 233, 59, 32768, 233, 116, 101, 114, 59, 32768, 10862, 1024, 97, 105, 111, 121, 8816, 8822, 8835, 8841, 114, 111, 110, 59, 32768, 283, 114, 512, 59, 99, 8828, 8830, 32768, 8790, 33024, 234, 59, 32768, 234, 108, 111, 110, 59, 32768, 8789, 59, 32768, 1101, 111, 116, 59, 32768, 279, 59, 32768, 8519, 512, 68, 114, 8857, 8862, 111, 116, 59, 32768, 8786, 59, 32896, 55349, 56610, 768, 59, 114, 115, 8873, 8875, 8883, 32768, 10906, 97, 118, 101, 33024, 232, 59, 32768, 232, 512, 59, 100, 8888, 8890, 32768, 10902, 111, 116, 59, 32768, 10904, 1024, 59, 105, 108, 115, 8904, 8906, 8914, 8917, 32768, 10905, 110, 116, 101, 114, 115, 59, 32768, 9191, 59, 32768, 8467, 512, 59, 100, 8922, 8924, 32768, 10901, 111, 116, 59, 32768, 10903, 768, 97, 112, 115, 8936, 8941, 8960, 99, 114, 59, 32768, 275, 116, 121, 768, 59, 115, 118, 8950, 8952, 8957, 32768, 8709, 101, 116, 59, 32768, 8709, 59, 32768, 8709, 112, 512, 49, 59, 8966, 8975, 516, 8970, 8973, 59, 32768, 8196, 59, 32768, 8197, 32768, 8195, 512, 103, 115, 8982, 8985, 59, 32768, 331, 112, 59, 32768, 8194, 512, 103, 112, 8994, 8999, 111, 110, 59, 32768, 281, 102, 59, 32896, 55349, 56662, 768, 97, 108, 115, 9011, 9023, 9028, 114, 512, 59, 115, 9017, 9019, 32768, 8917, 108, 59, 32768, 10723, 117, 115, 59, 32768, 10865, 105, 768, 59, 108, 118, 9036, 9038, 9043, 32768, 949, 111, 110, 59, 32768, 949, 59, 32768, 1013, 1024, 99, 115, 117, 118, 9055, 9071, 9099, 9128, 512, 105, 111, 9060, 9065, 114, 99, 59, 32768, 8790, 108, 111, 110, 59, 32768, 8789, 1082, 9077, 0, 0, 9081, 109, 59, 32768, 8770, 97, 110, 116, 512, 103, 108, 9088, 9093, 116, 114, 59, 32768, 10902, 101, 115, 115, 59, 32768, 10901, 768, 97, 101, 105, 9106, 9111, 9116, 108, 115, 59, 32768, 61, 115, 116, 59, 32768, 8799, 118, 512, 59, 68, 9122, 9124, 32768, 8801, 68, 59, 32768, 10872, 112, 97, 114, 115, 108, 59, 32768, 10725, 512, 68, 97, 9141, 9146, 111, 116, 59, 32768, 8787, 114, 114, 59, 32768, 10609, 768, 99, 100, 105, 9158, 9162, 9167, 114, 59, 32768, 8495, 111, 116, 59, 32768, 8784, 109, 59, 32768, 8770, 512, 97, 104, 9176, 9179, 59, 32768, 951, 33024, 240, 59, 32768, 240, 512, 109, 114, 9189, 9195, 108, 33024, 235, 59, 32768, 235, 111, 59, 32768, 8364, 768, 99, 105, 112, 9206, 9210, 9215, 108, 59, 32768, 33, 115, 116, 59, 32768, 8707, 512, 101, 111, 9220, 9230, 99, 116, 97, 116, 105, 111, 110, 59, 32768, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 32768, 8519, 4914, 9262, 0, 9276, 0, 9280, 9287, 0, 0, 9318, 9324, 0, 9331, 0, 9352, 9357, 9386, 0, 9395, 9497, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8786, 121, 59, 32768, 1092, 109, 97, 108, 101, 59, 32768, 9792, 768, 105, 108, 114, 9293, 9299, 9313, 108, 105, 103, 59, 32768, 64259, 1082, 9305, 0, 0, 9309, 103, 59, 32768, 64256, 105, 103, 59, 32768, 64260, 59, 32896, 55349, 56611, 108, 105, 103, 59, 32768, 64257, 108, 105, 103, 59, 32896, 102, 106, 768, 97, 108, 116, 9337, 9341, 9346, 116, 59, 32768, 9837, 105, 103, 59, 32768, 64258, 110, 115, 59, 32768, 9649, 111, 102, 59, 32768, 402, 833, 9361, 0, 9366, 102, 59, 32896, 55349, 56663, 512, 97, 107, 9370, 9375, 108, 108, 59, 32768, 8704, 512, 59, 118, 9380, 9382, 32768, 8916, 59, 32768, 10969, 97, 114, 116, 105, 110, 116, 59, 32768, 10765, 512, 97, 111, 9399, 9491, 512, 99, 115, 9404, 9487, 1794, 9413, 9443, 9453, 9470, 9474, 0, 9484, 1795, 9421, 9426, 9429, 9434, 9437, 0, 9440, 33024, 189, 59, 32768, 189, 59, 32768, 8531, 33024, 188, 59, 32768, 188, 59, 32768, 8533, 59, 32768, 8537, 59, 32768, 8539, 772, 9447, 0, 9450, 59, 32768, 8532, 59, 32768, 8534, 1285, 9459, 9464, 0, 0, 9467, 33024, 190, 59, 32768, 190, 59, 32768, 8535, 59, 32768, 8540, 53, 59, 32768, 8536, 775, 9478, 0, 9481, 59, 32768, 8538, 59, 32768, 8541, 56, 59, 32768, 8542, 108, 59, 32768, 8260, 119, 110, 59, 32768, 8994, 99, 114, 59, 32896, 55349, 56507, 4352, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 9537, 9547, 9575, 9582, 9595, 9600, 9679, 9684, 9694, 9700, 9705, 9725, 9773, 9779, 9785, 9810, 9917, 512, 59, 108, 9542, 9544, 32768, 8807, 59, 32768, 10892, 768, 99, 109, 112, 9554, 9560, 9572, 117, 116, 101, 59, 32768, 501, 109, 97, 512, 59, 100, 9567, 9569, 32768, 947, 59, 32768, 989, 59, 32768, 10886, 114, 101, 118, 101, 59, 32768, 287, 512, 105, 121, 9587, 9592, 114, 99, 59, 32768, 285, 59, 32768, 1075, 111, 116, 59, 32768, 289, 1024, 59, 108, 113, 115, 9609, 9611, 9614, 9633, 32768, 8805, 59, 32768, 8923, 768, 59, 113, 115, 9621, 9623, 9626, 32768, 8805, 59, 32768, 8807, 108, 97, 110, 116, 59, 32768, 10878, 1024, 59, 99, 100, 108, 9642, 9644, 9648, 9667, 32768, 10878, 99, 59, 32768, 10921, 111, 116, 512, 59, 111, 9655, 9657, 32768, 10880, 512, 59, 108, 9662, 9664, 32768, 10882, 59, 32768, 10884, 512, 59, 101, 9672, 9675, 32896, 8923, 65024, 115, 59, 32768, 10900, 114, 59, 32896, 55349, 56612, 512, 59, 103, 9689, 9691, 32768, 8811, 59, 32768, 8921, 109, 101, 108, 59, 32768, 8503, 99, 121, 59, 32768, 1107, 1024, 59, 69, 97, 106, 9714, 9716, 9719, 9722, 32768, 8823, 59, 32768, 10898, 59, 32768, 10917, 59, 32768, 10916, 1024, 69, 97, 101, 115, 9734, 9737, 9751, 9768, 59, 32768, 8809, 112, 512, 59, 112, 9743, 9745, 32768, 10890, 114, 111, 120, 59, 32768, 10890, 512, 59, 113, 9756, 9758, 32768, 10888, 512, 59, 113, 9763, 9765, 32768, 10888, 59, 32768, 8809, 105, 109, 59, 32768, 8935, 112, 102, 59, 32896, 55349, 56664, 97, 118, 101, 59, 32768, 96, 512, 99, 105, 9790, 9794, 114, 59, 32768, 8458, 109, 768, 59, 101, 108, 9802, 9804, 9807, 32768, 8819, 59, 32768, 10894, 59, 32768, 10896, 34304, 62, 59, 99, 100, 108, 113, 114, 9824, 9826, 9838, 9843, 9849, 9856, 32768, 62, 512, 99, 105, 9831, 9834, 59, 32768, 10919, 114, 59, 32768, 10874, 111, 116, 59, 32768, 8919, 80, 97, 114, 59, 32768, 10645, 117, 101, 115, 116, 59, 32768, 10876, 1280, 97, 100, 101, 108, 115, 9867, 9882, 9887, 9906, 9912, 833, 9872, 0, 9879, 112, 114, 111, 120, 59, 32768, 10886, 114, 59, 32768, 10616, 111, 116, 59, 32768, 8919, 113, 512, 108, 113, 9893, 9899, 101, 115, 115, 59, 32768, 8923, 108, 101, 115, 115, 59, 32768, 10892, 101, 115, 115, 59, 32768, 8823, 105, 109, 59, 32768, 8819, 512, 101, 110, 9922, 9932, 114, 116, 110, 101, 113, 113, 59, 32896, 8809, 65024, 69, 59, 32896, 8809, 65024, 2560, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 9958, 9963, 10015, 10020, 10026, 10060, 10065, 10085, 10147, 10171, 114, 114, 59, 32768, 8660, 1024, 105, 108, 109, 114, 9972, 9978, 9982, 9988, 114, 115, 112, 59, 32768, 8202, 102, 59, 32768, 189, 105, 108, 116, 59, 32768, 8459, 512, 100, 114, 9993, 9998, 99, 121, 59, 32768, 1098, 768, 59, 99, 119, 10005, 10007, 10012, 32768, 8596, 105, 114, 59, 32768, 10568, 59, 32768, 8621, 97, 114, 59, 32768, 8463, 105, 114, 99, 59, 32768, 293, 768, 97, 108, 114, 10033, 10048, 10054, 114, 116, 115, 512, 59, 117, 10041, 10043, 32768, 9829, 105, 116, 59, 32768, 9829, 108, 105, 112, 59, 32768, 8230, 99, 111, 110, 59, 32768, 8889, 114, 59, 32896, 55349, 56613, 115, 512, 101, 119, 10071, 10078, 97, 114, 111, 119, 59, 32768, 10533, 97, 114, 111, 119, 59, 32768, 10534, 1280, 97, 109, 111, 112, 114, 10096, 10101, 10107, 10136, 10141, 114, 114, 59, 32768, 8703, 116, 104, 116, 59, 32768, 8763, 107, 512, 108, 114, 10113, 10124, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8618, 102, 59, 32896, 55349, 56665, 98, 97, 114, 59, 32768, 8213, 768, 99, 108, 116, 10154, 10159, 10165, 114, 59, 32896, 55349, 56509, 97, 115, 104, 59, 32768, 8463, 114, 111, 107, 59, 32768, 295, 512, 98, 112, 10176, 10182, 117, 108, 108, 59, 32768, 8259, 104, 101, 110, 59, 32768, 8208, 5426, 10211, 0, 10220, 0, 10239, 10255, 10267, 0, 10276, 10312, 0, 0, 10318, 10371, 10458, 10485, 10491, 0, 10500, 10545, 10558, 99, 117, 116, 101, 33024, 237, 59, 32768, 237, 768, 59, 105, 121, 10226, 10228, 10235, 32768, 8291, 114, 99, 33024, 238, 59, 32768, 238, 59, 32768, 1080, 512, 99, 120, 10243, 10247, 121, 59, 32768, 1077, 99, 108, 33024, 161, 59, 32768, 161, 512, 102, 114, 10259, 10262, 59, 32768, 8660, 59, 32896, 55349, 56614, 114, 97, 118, 101, 33024, 236, 59, 32768, 236, 1024, 59, 105, 110, 111, 10284, 10286, 10300, 10306, 32768, 8520, 512, 105, 110, 10291, 10296, 110, 116, 59, 32768, 10764, 116, 59, 32768, 8749, 102, 105, 110, 59, 32768, 10716, 116, 97, 59, 32768, 8489, 108, 105, 103, 59, 32768, 307, 768, 97, 111, 112, 10324, 10361, 10365, 768, 99, 103, 116, 10331, 10335, 10357, 114, 59, 32768, 299, 768, 101, 108, 112, 10342, 10345, 10351, 59, 32768, 8465, 105, 110, 101, 59, 32768, 8464, 97, 114, 116, 59, 32768, 8465, 104, 59, 32768, 305, 102, 59, 32768, 8887, 101, 100, 59, 32768, 437, 1280, 59, 99, 102, 111, 116, 10381, 10383, 10389, 10403, 10409, 32768, 8712, 97, 114, 101, 59, 32768, 8453, 105, 110, 512, 59, 116, 10396, 10398, 32768, 8734, 105, 101, 59, 32768, 10717, 100, 111, 116, 59, 32768, 305, 1280, 59, 99, 101, 108, 112, 10420, 10422, 10427, 10444, 10451, 32768, 8747, 97, 108, 59, 32768, 8890, 512, 103, 114, 10432, 10438, 101, 114, 115, 59, 32768, 8484, 99, 97, 108, 59, 32768, 8890, 97, 114, 104, 107, 59, 32768, 10775, 114, 111, 100, 59, 32768, 10812, 1024, 99, 103, 112, 116, 10466, 10470, 10475, 10480, 121, 59, 32768, 1105, 111, 110, 59, 32768, 303, 102, 59, 32896, 55349, 56666, 97, 59, 32768, 953, 114, 111, 100, 59, 32768, 10812, 117, 101, 115, 116, 33024, 191, 59, 32768, 191, 512, 99, 105, 10504, 10509, 114, 59, 32896, 55349, 56510, 110, 1280, 59, 69, 100, 115, 118, 10521, 10523, 10526, 10531, 10541, 32768, 8712, 59, 32768, 8953, 111, 116, 59, 32768, 8949, 512, 59, 118, 10536, 10538, 32768, 8948, 59, 32768, 8947, 59, 32768, 8712, 512, 59, 105, 10549, 10551, 32768, 8290, 108, 100, 101, 59, 32768, 297, 828, 10562, 0, 10567, 99, 121, 59, 32768, 1110, 108, 33024, 239, 59, 32768, 239, 1536, 99, 102, 109, 111, 115, 117, 10585, 10598, 10603, 10609, 10615, 10630, 512, 105, 121, 10590, 10595, 114, 99, 59, 32768, 309, 59, 32768, 1081, 114, 59, 32896, 55349, 56615, 97, 116, 104, 59, 32768, 567, 112, 102, 59, 32896, 55349, 56667, 820, 10620, 0, 10625, 114, 59, 32896, 55349, 56511, 114, 99, 121, 59, 32768, 1112, 107, 99, 121, 59, 32768, 1108, 2048, 97, 99, 102, 103, 104, 106, 111, 115, 10653, 10666, 10680, 10685, 10692, 10697, 10702, 10708, 112, 112, 97, 512, 59, 118, 10661, 10663, 32768, 954, 59, 32768, 1008, 512, 101, 121, 10671, 10677, 100, 105, 108, 59, 32768, 311, 59, 32768, 1082, 114, 59, 32896, 55349, 56616, 114, 101, 101, 110, 59, 32768, 312, 99, 121, 59, 32768, 1093, 99, 121, 59, 32768, 1116, 112, 102, 59, 32896, 55349, 56668, 99, 114, 59, 32896, 55349, 56512, 5888, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 10761, 10783, 10789, 10799, 10804, 10957, 11011, 11047, 11094, 11349, 11372, 11382, 11409, 11414, 11451, 11478, 11526, 11698, 11711, 11755, 11823, 11910, 11929, 768, 97, 114, 116, 10768, 10773, 10777, 114, 114, 59, 32768, 8666, 114, 59, 32768, 8656, 97, 105, 108, 59, 32768, 10523, 97, 114, 114, 59, 32768, 10510, 512, 59, 103, 10794, 10796, 32768, 8806, 59, 32768, 10891, 97, 114, 59, 32768, 10594, 4660, 10824, 0, 10830, 0, 10838, 0, 0, 0, 0, 0, 10844, 10850, 0, 10867, 10870, 10877, 0, 10933, 117, 116, 101, 59, 32768, 314, 109, 112, 116, 121, 118, 59, 32768, 10676, 114, 97, 110, 59, 32768, 8466, 98, 100, 97, 59, 32768, 955, 103, 768, 59, 100, 108, 10857, 10859, 10862, 32768, 10216, 59, 32768, 10641, 101, 59, 32768, 10216, 59, 32768, 10885, 117, 111, 33024, 171, 59, 32768, 171, 114, 2048, 59, 98, 102, 104, 108, 112, 115, 116, 10894, 10896, 10907, 10911, 10915, 10919, 10923, 10928, 32768, 8592, 512, 59, 102, 10901, 10903, 32768, 8676, 115, 59, 32768, 10527, 115, 59, 32768, 10525, 107, 59, 32768, 8617, 112, 59, 32768, 8619, 108, 59, 32768, 10553, 105, 109, 59, 32768, 10611, 108, 59, 32768, 8610, 768, 59, 97, 101, 10939, 10941, 10946, 32768, 10923, 105, 108, 59, 32768, 10521, 512, 59, 115, 10951, 10953, 32768, 10925, 59, 32896, 10925, 65024, 768, 97, 98, 114, 10964, 10969, 10974, 114, 114, 59, 32768, 10508, 114, 107, 59, 32768, 10098, 512, 97, 107, 10979, 10991, 99, 512, 101, 107, 10985, 10988, 59, 32768, 123, 59, 32768, 91, 512, 101, 115, 10996, 10999, 59, 32768, 10635, 108, 512, 100, 117, 11005, 11008, 59, 32768, 10639, 59, 32768, 10637, 1024, 97, 101, 117, 121, 11020, 11026, 11040, 11044, 114, 111, 110, 59, 32768, 318, 512, 100, 105, 11031, 11036, 105, 108, 59, 32768, 316, 108, 59, 32768, 8968, 98, 59, 32768, 123, 59, 32768, 1083, 1024, 99, 113, 114, 115, 11056, 11060, 11072, 11090, 97, 59, 32768, 10550, 117, 111, 512, 59, 114, 11067, 11069, 32768, 8220, 59, 32768, 8222, 512, 100, 117, 11077, 11083, 104, 97, 114, 59, 32768, 10599, 115, 104, 97, 114, 59, 32768, 10571, 104, 59, 32768, 8626, 1280, 59, 102, 103, 113, 115, 11105, 11107, 11228, 11231, 11250, 32768, 8804, 116, 1280, 97, 104, 108, 114, 116, 11119, 11136, 11157, 11169, 11216, 114, 114, 111, 119, 512, 59, 116, 11128, 11130, 32768, 8592, 97, 105, 108, 59, 32768, 8610, 97, 114, 112, 111, 111, 110, 512, 100, 117, 11147, 11153, 111, 119, 110, 59, 32768, 8637, 112, 59, 32768, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8647, 105, 103, 104, 116, 768, 97, 104, 115, 11180, 11194, 11204, 114, 114, 111, 119, 512, 59, 115, 11189, 11191, 32768, 8596, 59, 32768, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8907, 59, 32768, 8922, 768, 59, 113, 115, 11238, 11240, 11243, 32768, 8804, 59, 32768, 8806, 108, 97, 110, 116, 59, 32768, 10877, 1280, 59, 99, 100, 103, 115, 11261, 11263, 11267, 11286, 11298, 32768, 10877, 99, 59, 32768, 10920, 111, 116, 512, 59, 111, 11274, 11276, 32768, 10879, 512, 59, 114, 11281, 11283, 32768, 10881, 59, 32768, 10883, 512, 59, 101, 11291, 11294, 32896, 8922, 65024, 115, 59, 32768, 10899, 1280, 97, 100, 101, 103, 115, 11309, 11317, 11322, 11339, 11344, 112, 112, 114, 111, 120, 59, 32768, 10885, 111, 116, 59, 32768, 8918, 113, 512, 103, 113, 11328, 11333, 116, 114, 59, 32768, 8922, 103, 116, 114, 59, 32768, 10891, 116, 114, 59, 32768, 8822, 105, 109, 59, 32768, 8818, 768, 105, 108, 114, 11356, 11362, 11368, 115, 104, 116, 59, 32768, 10620, 111, 111, 114, 59, 32768, 8970, 59, 32896, 55349, 56617, 512, 59, 69, 11377, 11379, 32768, 8822, 59, 32768, 10897, 562, 11386, 11405, 114, 512, 100, 117, 11391, 11394, 59, 32768, 8637, 512, 59, 108, 11399, 11401, 32768, 8636, 59, 32768, 10602, 108, 107, 59, 32768, 9604, 99, 121, 59, 32768, 1113, 1280, 59, 97, 99, 104, 116, 11425, 11427, 11432, 11440, 11446, 32768, 8810, 114, 114, 59, 32768, 8647, 111, 114, 110, 101, 114, 59, 32768, 8990, 97, 114, 100, 59, 32768, 10603, 114, 105, 59, 32768, 9722, 512, 105, 111, 11456, 11462, 100, 111, 116, 59, 32768, 320, 117, 115, 116, 512, 59, 97, 11470, 11472, 32768, 9136, 99, 104, 101, 59, 32768, 9136, 1024, 69, 97, 101, 115, 11487, 11490, 11504, 11521, 59, 32768, 8808, 112, 512, 59, 112, 11496, 11498, 32768, 10889, 114, 111, 120, 59, 32768, 10889, 512, 59, 113, 11509, 11511, 32768, 10887, 512, 59, 113, 11516, 11518, 32768, 10887, 59, 32768, 8808, 105, 109, 59, 32768, 8934, 2048, 97, 98, 110, 111, 112, 116, 119, 122, 11543, 11556, 11561, 11616, 11640, 11660, 11667, 11680, 512, 110, 114, 11548, 11552, 103, 59, 32768, 10220, 114, 59, 32768, 8701, 114, 107, 59, 32768, 10214, 103, 768, 108, 109, 114, 11569, 11596, 11604, 101, 102, 116, 512, 97, 114, 11577, 11584, 114, 114, 111, 119, 59, 32768, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10231, 97, 112, 115, 116, 111, 59, 32768, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 10230, 112, 97, 114, 114, 111, 119, 512, 108, 114, 11627, 11633, 101, 102, 116, 59, 32768, 8619, 105, 103, 104, 116, 59, 32768, 8620, 768, 97, 102, 108, 11647, 11651, 11655, 114, 59, 32768, 10629, 59, 32896, 55349, 56669, 117, 115, 59, 32768, 10797, 105, 109, 101, 115, 59, 32768, 10804, 562, 11671, 11676, 115, 116, 59, 32768, 8727, 97, 114, 59, 32768, 95, 768, 59, 101, 102, 11687, 11689, 11695, 32768, 9674, 110, 103, 101, 59, 32768, 9674, 59, 32768, 10731, 97, 114, 512, 59, 108, 11705, 11707, 32768, 40, 116, 59, 32768, 10643, 1280, 97, 99, 104, 109, 116, 11722, 11727, 11735, 11747, 11750, 114, 114, 59, 32768, 8646, 111, 114, 110, 101, 114, 59, 32768, 8991, 97, 114, 512, 59, 100, 11742, 11744, 32768, 8651, 59, 32768, 10605, 59, 32768, 8206, 114, 105, 59, 32768, 8895, 1536, 97, 99, 104, 105, 113, 116, 11768, 11774, 11779, 11782, 11798, 11817, 113, 117, 111, 59, 32768, 8249, 114, 59, 32896, 55349, 56513, 59, 32768, 8624, 109, 768, 59, 101, 103, 11790, 11792, 11795, 32768, 8818, 59, 32768, 10893, 59, 32768, 10895, 512, 98, 117, 11803, 11806, 59, 32768, 91, 111, 512, 59, 114, 11812, 11814, 32768, 8216, 59, 32768, 8218, 114, 111, 107, 59, 32768, 322, 34816, 60, 59, 99, 100, 104, 105, 108, 113, 114, 11841, 11843, 11855, 11860, 11866, 11872, 11878, 11885, 32768, 60, 512, 99, 105, 11848, 11851, 59, 32768, 10918, 114, 59, 32768, 10873, 111, 116, 59, 32768, 8918, 114, 101, 101, 59, 32768, 8907, 109, 101, 115, 59, 32768, 8905, 97, 114, 114, 59, 32768, 10614, 117, 101, 115, 116, 59, 32768, 10875, 512, 80, 105, 11890, 11895, 97, 114, 59, 32768, 10646, 768, 59, 101, 102, 11902, 11904, 11907, 32768, 9667, 59, 32768, 8884, 59, 32768, 9666, 114, 512, 100, 117, 11916, 11923, 115, 104, 97, 114, 59, 32768, 10570, 104, 97, 114, 59, 32768, 10598, 512, 101, 110, 11934, 11944, 114, 116, 110, 101, 113, 113, 59, 32896, 8808, 65024, 69, 59, 32896, 8808, 65024, 3584, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 11978, 11984, 12061, 12075, 12081, 12095, 12100, 12104, 12170, 12181, 12188, 12204, 12207, 12223, 68, 111, 116, 59, 32768, 8762, 1024, 99, 108, 112, 114, 11993, 11999, 12019, 12055, 114, 33024, 175, 59, 32768, 175, 512, 101, 116, 12004, 12007, 59, 32768, 9794, 512, 59, 101, 12012, 12014, 32768, 10016, 115, 101, 59, 32768, 10016, 512, 59, 115, 12024, 12026, 32768, 8614, 116, 111, 1024, 59, 100, 108, 117, 12037, 12039, 12045, 12051, 32768, 8614, 111, 119, 110, 59, 32768, 8615, 101, 102, 116, 59, 32768, 8612, 112, 59, 32768, 8613, 107, 101, 114, 59, 32768, 9646, 512, 111, 121, 12066, 12072, 109, 109, 97, 59, 32768, 10793, 59, 32768, 1084, 97, 115, 104, 59, 32768, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 32768, 8737, 114, 59, 32896, 55349, 56618, 111, 59, 32768, 8487, 768, 99, 100, 110, 12111, 12118, 12146, 114, 111, 33024, 181, 59, 32768, 181, 1024, 59, 97, 99, 100, 12127, 12129, 12134, 12139, 32768, 8739, 115, 116, 59, 32768, 42, 105, 114, 59, 32768, 10992, 111, 116, 33024, 183, 59, 32768, 183, 117, 115, 768, 59, 98, 100, 12155, 12157, 12160, 32768, 8722, 59, 32768, 8863, 512, 59, 117, 12165, 12167, 32768, 8760, 59, 32768, 10794, 564, 12174, 12178, 112, 59, 32768, 10971, 114, 59, 32768, 8230, 112, 108, 117, 115, 59, 32768, 8723, 512, 100, 112, 12193, 12199, 101, 108, 115, 59, 32768, 8871, 102, 59, 32896, 55349, 56670, 59, 32768, 8723, 512, 99, 116, 12212, 12217, 114, 59, 32896, 55349, 56514, 112, 111, 115, 59, 32768, 8766, 768, 59, 108, 109, 12230, 12232, 12240, 32768, 956, 116, 105, 109, 97, 112, 59, 32768, 8888, 97, 112, 59, 32768, 8888, 6144, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 12294, 12315, 12364, 12376, 12393, 12472, 12496, 12547, 12553, 12636, 12641, 12703, 12725, 12747, 12752, 12876, 12881, 12957, 13033, 13089, 13294, 13359, 13384, 13499, 512, 103, 116, 12299, 12303, 59, 32896, 8921, 824, 512, 59, 118, 12308, 12311, 32896, 8811, 8402, 59, 32896, 8811, 824, 768, 101, 108, 116, 12322, 12348, 12352, 102, 116, 512, 97, 114, 12329, 12336, 114, 114, 111, 119, 59, 32768, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8654, 59, 32896, 8920, 824, 512, 59, 118, 12357, 12360, 32896, 8810, 8402, 59, 32896, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8655, 512, 68, 100, 12381, 12387, 97, 115, 104, 59, 32768, 8879, 97, 115, 104, 59, 32768, 8878, 1280, 98, 99, 110, 112, 116, 12404, 12409, 12415, 12420, 12452, 108, 97, 59, 32768, 8711, 117, 116, 101, 59, 32768, 324, 103, 59, 32896, 8736, 8402, 1280, 59, 69, 105, 111, 112, 12431, 12433, 12437, 12442, 12446, 32768, 8777, 59, 32896, 10864, 824, 100, 59, 32896, 8779, 824, 115, 59, 32768, 329, 114, 111, 120, 59, 32768, 8777, 117, 114, 512, 59, 97, 12459, 12461, 32768, 9838, 108, 512, 59, 115, 12467, 12469, 32768, 9838, 59, 32768, 8469, 836, 12477, 0, 12483, 112, 33024, 160, 59, 32768, 160, 109, 112, 512, 59, 101, 12489, 12492, 32896, 8782, 824, 59, 32896, 8783, 824, 1280, 97, 101, 111, 117, 121, 12507, 12519, 12525, 12540, 12544, 833, 12512, 0, 12515, 59, 32768, 10819, 111, 110, 59, 32768, 328, 100, 105, 108, 59, 32768, 326, 110, 103, 512, 59, 100, 12532, 12534, 32768, 8775, 111, 116, 59, 32896, 10861, 824, 112, 59, 32768, 10818, 59, 32768, 1085, 97, 115, 104, 59, 32768, 8211, 1792, 59, 65, 97, 100, 113, 115, 120, 12568, 12570, 12575, 12596, 12602, 12608, 12623, 32768, 8800, 114, 114, 59, 32768, 8663, 114, 512, 104, 114, 12581, 12585, 107, 59, 32768, 10532, 512, 59, 111, 12590, 12592, 32768, 8599, 119, 59, 32768, 8599, 111, 116, 59, 32896, 8784, 824, 117, 105, 118, 59, 32768, 8802, 512, 101, 105, 12613, 12618, 97, 114, 59, 32768, 10536, 109, 59, 32896, 8770, 824, 105, 115, 116, 512, 59, 115, 12631, 12633, 32768, 8708, 59, 32768, 8708, 114, 59, 32896, 55349, 56619, 1024, 69, 101, 115, 116, 12650, 12654, 12688, 12693, 59, 32896, 8807, 824, 768, 59, 113, 115, 12661, 12663, 12684, 32768, 8817, 768, 59, 113, 115, 12670, 12672, 12676, 32768, 8817, 59, 32896, 8807, 824, 108, 97, 110, 116, 59, 32896, 10878, 824, 59, 32896, 10878, 824, 105, 109, 59, 32768, 8821, 512, 59, 114, 12698, 12700, 32768, 8815, 59, 32768, 8815, 768, 65, 97, 112, 12710, 12715, 12720, 114, 114, 59, 32768, 8654, 114, 114, 59, 32768, 8622, 97, 114, 59, 32768, 10994, 768, 59, 115, 118, 12732, 12734, 12744, 32768, 8715, 512, 59, 100, 12739, 12741, 32768, 8956, 59, 32768, 8954, 59, 32768, 8715, 99, 121, 59, 32768, 1114, 1792, 65, 69, 97, 100, 101, 115, 116, 12767, 12772, 12776, 12781, 12785, 12853, 12858, 114, 114, 59, 32768, 8653, 59, 32896, 8806, 824, 114, 114, 59, 32768, 8602, 114, 59, 32768, 8229, 1024, 59, 102, 113, 115, 12794, 12796, 12821, 12842, 32768, 8816, 116, 512, 97, 114, 12802, 12809, 114, 114, 111, 119, 59, 32768, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8622, 768, 59, 113, 115, 12828, 12830, 12834, 32768, 8816, 59, 32896, 8806, 824, 108, 97, 110, 116, 59, 32896, 10877, 824, 512, 59, 115, 12847, 12850, 32896, 10877, 824, 59, 32768, 8814, 105, 109, 59, 32768, 8820, 512, 59, 114, 12863, 12865, 32768, 8814, 105, 512, 59, 101, 12871, 12873, 32768, 8938, 59, 32768, 8940, 105, 100, 59, 32768, 8740, 512, 112, 116, 12886, 12891, 102, 59, 32896, 55349, 56671, 33536, 172, 59, 105, 110, 12899, 12901, 12936, 32768, 172, 110, 1024, 59, 69, 100, 118, 12911, 12913, 12917, 12923, 32768, 8713, 59, 32896, 8953, 824, 111, 116, 59, 32896, 8949, 824, 818, 12928, 12931, 12934, 59, 32768, 8713, 59, 32768, 8951, 59, 32768, 8950, 105, 512, 59, 118, 12942, 12944, 32768, 8716, 818, 12949, 12952, 12955, 59, 32768, 8716, 59, 32768, 8958, 59, 32768, 8957, 768, 97, 111, 114, 12964, 12992, 12999, 114, 1024, 59, 97, 115, 116, 12974, 12976, 12983, 12988, 32768, 8742, 108, 108, 101, 108, 59, 32768, 8742, 108, 59, 32896, 11005, 8421, 59, 32896, 8706, 824, 108, 105, 110, 116, 59, 32768, 10772, 768, 59, 99, 101, 13006, 13008, 13013, 32768, 8832, 117, 101, 59, 32768, 8928, 512, 59, 99, 13018, 13021, 32896, 10927, 824, 512, 59, 101, 13026, 13028, 32768, 8832, 113, 59, 32896, 10927, 824, 1024, 65, 97, 105, 116, 13042, 13047, 13066, 13077, 114, 114, 59, 32768, 8655, 114, 114, 768, 59, 99, 119, 13056, 13058, 13062, 32768, 8603, 59, 32896, 10547, 824, 59, 32896, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8603, 114, 105, 512, 59, 101, 13084, 13086, 32768, 8939, 59, 32768, 8941, 1792, 99, 104, 105, 109, 112, 113, 117, 13104, 13128, 13151, 13169, 13174, 13179, 13194, 1024, 59, 99, 101, 114, 13113, 13115, 13120, 13124, 32768, 8833, 117, 101, 59, 32768, 8929, 59, 32896, 10928, 824, 59, 32896, 55349, 56515, 111, 114, 116, 1086, 13137, 0, 0, 13142, 105, 100, 59, 32768, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8742, 109, 512, 59, 101, 13157, 13159, 32768, 8769, 512, 59, 113, 13164, 13166, 32768, 8772, 59, 32768, 8772, 105, 100, 59, 32768, 8740, 97, 114, 59, 32768, 8742, 115, 117, 512, 98, 112, 13186, 13190, 101, 59, 32768, 8930, 101, 59, 32768, 8931, 768, 98, 99, 112, 13201, 13241, 13254, 1024, 59, 69, 101, 115, 13210, 13212, 13216, 13219, 32768, 8836, 59, 32896, 10949, 824, 59, 32768, 8840, 101, 116, 512, 59, 101, 13226, 13229, 32896, 8834, 8402, 113, 512, 59, 113, 13235, 13237, 32768, 8840, 59, 32896, 10949, 824, 99, 512, 59, 101, 13247, 13249, 32768, 8833, 113, 59, 32896, 10928, 824, 1024, 59, 69, 101, 115, 13263, 13265, 13269, 13272, 32768, 8837, 59, 32896, 10950, 824, 59, 32768, 8841, 101, 116, 512, 59, 101, 13279, 13282, 32896, 8835, 8402, 113, 512, 59, 113, 13288, 13290, 32768, 8841, 59, 32896, 10950, 824, 1024, 103, 105, 108, 114, 13303, 13307, 13315, 13319, 108, 59, 32768, 8825, 108, 100, 101, 33024, 241, 59, 32768, 241, 103, 59, 32768, 8824, 105, 97, 110, 103, 108, 101, 512, 108, 114, 13330, 13344, 101, 102, 116, 512, 59, 101, 13338, 13340, 32768, 8938, 113, 59, 32768, 8940, 105, 103, 104, 116, 512, 59, 101, 13353, 13355, 32768, 8939, 113, 59, 32768, 8941, 512, 59, 109, 13364, 13366, 32768, 957, 768, 59, 101, 115, 13373, 13375, 13380, 32768, 35, 114, 111, 59, 32768, 8470, 112, 59, 32768, 8199, 2304, 68, 72, 97, 100, 103, 105, 108, 114, 115, 13403, 13409, 13415, 13420, 13426, 13439, 13446, 13476, 13493, 97, 115, 104, 59, 32768, 8877, 97, 114, 114, 59, 32768, 10500, 112, 59, 32896, 8781, 8402, 97, 115, 104, 59, 32768, 8876, 512, 101, 116, 13431, 13435, 59, 32896, 8805, 8402, 59, 32896, 62, 8402, 110, 102, 105, 110, 59, 32768, 10718, 768, 65, 101, 116, 13453, 13458, 13462, 114, 114, 59, 32768, 10498, 59, 32896, 8804, 8402, 512, 59, 114, 13467, 13470, 32896, 60, 8402, 105, 101, 59, 32896, 8884, 8402, 512, 65, 116, 13481, 13486, 114, 114, 59, 32768, 10499, 114, 105, 101, 59, 32896, 8885, 8402, 105, 109, 59, 32896, 8764, 8402, 768, 65, 97, 110, 13506, 13511, 13532, 114, 114, 59, 32768, 8662, 114, 512, 104, 114, 13517, 13521, 107, 59, 32768, 10531, 512, 59, 111, 13526, 13528, 32768, 8598, 119, 59, 32768, 8598, 101, 97, 114, 59, 32768, 10535, 9252, 13576, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 13579, 0, 13596, 13617, 13653, 13659, 13673, 13695, 13708, 0, 0, 13713, 13750, 0, 13788, 13794, 0, 13815, 13890, 13913, 13937, 13944, 59, 32768, 9416, 512, 99, 115, 13583, 13591, 117, 116, 101, 33024, 243, 59, 32768, 243, 116, 59, 32768, 8859, 512, 105, 121, 13600, 13613, 114, 512, 59, 99, 13606, 13608, 32768, 8858, 33024, 244, 59, 32768, 244, 59, 32768, 1086, 1280, 97, 98, 105, 111, 115, 13627, 13632, 13638, 13642, 13646, 115, 104, 59, 32768, 8861, 108, 97, 99, 59, 32768, 337, 118, 59, 32768, 10808, 116, 59, 32768, 8857, 111, 108, 100, 59, 32768, 10684, 108, 105, 103, 59, 32768, 339, 512, 99, 114, 13663, 13668, 105, 114, 59, 32768, 10687, 59, 32896, 55349, 56620, 1600, 13680, 0, 0, 13684, 0, 13692, 110, 59, 32768, 731, 97, 118, 101, 33024, 242, 59, 32768, 242, 59, 32768, 10689, 512, 98, 109, 13699, 13704, 97, 114, 59, 32768, 10677, 59, 32768, 937, 110, 116, 59, 32768, 8750, 1024, 97, 99, 105, 116, 13721, 13726, 13741, 13746, 114, 114, 59, 32768, 8634, 512, 105, 114, 13731, 13735, 114, 59, 32768, 10686, 111, 115, 115, 59, 32768, 10683, 110, 101, 59, 32768, 8254, 59, 32768, 10688, 768, 97, 101, 105, 13756, 13761, 13766, 99, 114, 59, 32768, 333, 103, 97, 59, 32768, 969, 768, 99, 100, 110, 13773, 13779, 13782, 114, 111, 110, 59, 32768, 959, 59, 32768, 10678, 117, 115, 59, 32768, 8854, 112, 102, 59, 32896, 55349, 56672, 768, 97, 101, 108, 13800, 13804, 13809, 114, 59, 32768, 10679, 114, 112, 59, 32768, 10681, 117, 115, 59, 32768, 8853, 1792, 59, 97, 100, 105, 111, 115, 118, 13829, 13831, 13836, 13869, 13875, 13879, 13886, 32768, 8744, 114, 114, 59, 32768, 8635, 1024, 59, 101, 102, 109, 13845, 13847, 13859, 13864, 32768, 10845, 114, 512, 59, 111, 13853, 13855, 32768, 8500, 102, 59, 32768, 8500, 33024, 170, 59, 32768, 170, 33024, 186, 59, 32768, 186, 103, 111, 102, 59, 32768, 8886, 114, 59, 32768, 10838, 108, 111, 112, 101, 59, 32768, 10839, 59, 32768, 10843, 768, 99, 108, 111, 13896, 13900, 13908, 114, 59, 32768, 8500, 97, 115, 104, 33024, 248, 59, 32768, 248, 108, 59, 32768, 8856, 105, 573, 13917, 13924, 100, 101, 33024, 245, 59, 32768, 245, 101, 115, 512, 59, 97, 13930, 13932, 32768, 8855, 115, 59, 32768, 10806, 109, 108, 33024, 246, 59, 32768, 246, 98, 97, 114, 59, 32768, 9021, 5426, 13972, 0, 14013, 0, 14017, 14053, 0, 14058, 14086, 0, 0, 14107, 14199, 0, 14202, 0, 0, 14229, 14425, 0, 14438, 114, 1024, 59, 97, 115, 116, 13981, 13983, 13997, 14009, 32768, 8741, 33280, 182, 59, 108, 13989, 13991, 32768, 182, 108, 101, 108, 59, 32768, 8741, 1082, 14003, 0, 0, 14007, 109, 59, 32768, 10995, 59, 32768, 11005, 59, 32768, 8706, 121, 59, 32768, 1087, 114, 1280, 99, 105, 109, 112, 116, 14028, 14033, 14038, 14043, 14046, 110, 116, 59, 32768, 37, 111, 100, 59, 32768, 46, 105, 108, 59, 32768, 8240, 59, 32768, 8869, 101, 110, 107, 59, 32768, 8241, 114, 59, 32896, 55349, 56621, 768, 105, 109, 111, 14064, 14074, 14080, 512, 59, 118, 14069, 14071, 32768, 966, 59, 32768, 981, 109, 97, 116, 59, 32768, 8499, 110, 101, 59, 32768, 9742, 768, 59, 116, 118, 14092, 14094, 14103, 32768, 960, 99, 104, 102, 111, 114, 107, 59, 32768, 8916, 59, 32768, 982, 512, 97, 117, 14111, 14132, 110, 512, 99, 107, 14117, 14128, 107, 512, 59, 104, 14123, 14125, 32768, 8463, 59, 32768, 8462, 118, 59, 32768, 8463, 115, 2304, 59, 97, 98, 99, 100, 101, 109, 115, 116, 14152, 14154, 14160, 14163, 14168, 14179, 14182, 14188, 14193, 32768, 43, 99, 105, 114, 59, 32768, 10787, 59, 32768, 8862, 105, 114, 59, 32768, 10786, 512, 111, 117, 14173, 14176, 59, 32768, 8724, 59, 32768, 10789, 59, 32768, 10866, 110, 33024, 177, 59, 32768, 177, 105, 109, 59, 32768, 10790, 119, 111, 59, 32768, 10791, 59, 32768, 177, 768, 105, 112, 117, 14208, 14216, 14221, 110, 116, 105, 110, 116, 59, 32768, 10773, 102, 59, 32896, 55349, 56673, 110, 100, 33024, 163, 59, 32768, 163, 2560, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 14249, 14251, 14254, 14258, 14263, 14336, 14348, 14367, 14413, 14418, 32768, 8826, 59, 32768, 10931, 112, 59, 32768, 10935, 117, 101, 59, 32768, 8828, 512, 59, 99, 14268, 14270, 32768, 10927, 1536, 59, 97, 99, 101, 110, 115, 14283, 14285, 14293, 14302, 14306, 14331, 32768, 8826, 112, 112, 114, 111, 120, 59, 32768, 10935, 117, 114, 108, 121, 101, 113, 59, 32768, 8828, 113, 59, 32768, 10927, 768, 97, 101, 115, 14313, 14321, 14326, 112, 112, 114, 111, 120, 59, 32768, 10937, 113, 113, 59, 32768, 10933, 105, 109, 59, 32768, 8936, 105, 109, 59, 32768, 8830, 109, 101, 512, 59, 115, 14343, 14345, 32768, 8242, 59, 32768, 8473, 768, 69, 97, 115, 14355, 14358, 14362, 59, 32768, 10933, 112, 59, 32768, 10937, 105, 109, 59, 32768, 8936, 768, 100, 102, 112, 14374, 14377, 14402, 59, 32768, 8719, 768, 97, 108, 115, 14384, 14390, 14396, 108, 97, 114, 59, 32768, 9006, 105, 110, 101, 59, 32768, 8978, 117, 114, 102, 59, 32768, 8979, 512, 59, 116, 14407, 14409, 32768, 8733, 111, 59, 32768, 8733, 105, 109, 59, 32768, 8830, 114, 101, 108, 59, 32768, 8880, 512, 99, 105, 14429, 14434, 114, 59, 32896, 55349, 56517, 59, 32768, 968, 110, 99, 115, 112, 59, 32768, 8200, 1536, 102, 105, 111, 112, 115, 117, 14457, 14462, 14467, 14473, 14480, 14486, 114, 59, 32896, 55349, 56622, 110, 116, 59, 32768, 10764, 112, 102, 59, 32896, 55349, 56674, 114, 105, 109, 101, 59, 32768, 8279, 99, 114, 59, 32896, 55349, 56518, 768, 97, 101, 111, 14493, 14513, 14526, 116, 512, 101, 105, 14499, 14508, 114, 110, 105, 111, 110, 115, 59, 32768, 8461, 110, 116, 59, 32768, 10774, 115, 116, 512, 59, 101, 14520, 14522, 32768, 63, 113, 59, 32768, 8799, 116, 33024, 34, 59, 32768, 34, 5376, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 14575, 14597, 14603, 14608, 14775, 14829, 14865, 14901, 14943, 14966, 15e3, 15139, 15159, 15176, 15182, 15236, 15261, 15267, 15309, 15352, 15360, 768, 97, 114, 116, 14582, 14587, 14591, 114, 114, 59, 32768, 8667, 114, 59, 32768, 8658, 97, 105, 108, 59, 32768, 10524, 97, 114, 114, 59, 32768, 10511, 97, 114, 59, 32768, 10596, 1792, 99, 100, 101, 110, 113, 114, 116, 14623, 14637, 14642, 14650, 14672, 14679, 14751, 512, 101, 117, 14628, 14632, 59, 32896, 8765, 817, 116, 101, 59, 32768, 341, 105, 99, 59, 32768, 8730, 109, 112, 116, 121, 118, 59, 32768, 10675, 103, 1024, 59, 100, 101, 108, 14660, 14662, 14665, 14668, 32768, 10217, 59, 32768, 10642, 59, 32768, 10661, 101, 59, 32768, 10217, 117, 111, 33024, 187, 59, 32768, 187, 114, 2816, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 14703, 14705, 14709, 14720, 14723, 14727, 14731, 14735, 14739, 14744, 14748, 32768, 8594, 112, 59, 32768, 10613, 512, 59, 102, 14714, 14716, 32768, 8677, 115, 59, 32768, 10528, 59, 32768, 10547, 115, 59, 32768, 10526, 107, 59, 32768, 8618, 112, 59, 32768, 8620, 108, 59, 32768, 10565, 105, 109, 59, 32768, 10612, 108, 59, 32768, 8611, 59, 32768, 8605, 512, 97, 105, 14756, 14761, 105, 108, 59, 32768, 10522, 111, 512, 59, 110, 14767, 14769, 32768, 8758, 97, 108, 115, 59, 32768, 8474, 768, 97, 98, 114, 14782, 14787, 14792, 114, 114, 59, 32768, 10509, 114, 107, 59, 32768, 10099, 512, 97, 107, 14797, 14809, 99, 512, 101, 107, 14803, 14806, 59, 32768, 125, 59, 32768, 93, 512, 101, 115, 14814, 14817, 59, 32768, 10636, 108, 512, 100, 117, 14823, 14826, 59, 32768, 10638, 59, 32768, 10640, 1024, 97, 101, 117, 121, 14838, 14844, 14858, 14862, 114, 111, 110, 59, 32768, 345, 512, 100, 105, 14849, 14854, 105, 108, 59, 32768, 343, 108, 59, 32768, 8969, 98, 59, 32768, 125, 59, 32768, 1088, 1024, 99, 108, 113, 115, 14874, 14878, 14885, 14897, 97, 59, 32768, 10551, 100, 104, 97, 114, 59, 32768, 10601, 117, 111, 512, 59, 114, 14892, 14894, 32768, 8221, 59, 32768, 8221, 104, 59, 32768, 8627, 768, 97, 99, 103, 14908, 14934, 14938, 108, 1024, 59, 105, 112, 115, 14918, 14920, 14925, 14931, 32768, 8476, 110, 101, 59, 32768, 8475, 97, 114, 116, 59, 32768, 8476, 59, 32768, 8477, 116, 59, 32768, 9645, 33024, 174, 59, 32768, 174, 768, 105, 108, 114, 14950, 14956, 14962, 115, 104, 116, 59, 32768, 10621, 111, 111, 114, 59, 32768, 8971, 59, 32896, 55349, 56623, 512, 97, 111, 14971, 14990, 114, 512, 100, 117, 14977, 14980, 59, 32768, 8641, 512, 59, 108, 14985, 14987, 32768, 8640, 59, 32768, 10604, 512, 59, 118, 14995, 14997, 32768, 961, 59, 32768, 1009, 768, 103, 110, 115, 15007, 15123, 15127, 104, 116, 1536, 97, 104, 108, 114, 115, 116, 15022, 15039, 15060, 15086, 15099, 15111, 114, 114, 111, 119, 512, 59, 116, 15031, 15033, 32768, 8594, 97, 105, 108, 59, 32768, 8611, 97, 114, 112, 111, 111, 110, 512, 100, 117, 15050, 15056, 111, 119, 110, 59, 32768, 8641, 112, 59, 32768, 8640, 101, 102, 116, 512, 97, 104, 15068, 15076, 114, 114, 111, 119, 115, 59, 32768, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 32768, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 32768, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 32768, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 32768, 8908, 103, 59, 32768, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 32768, 8787, 768, 97, 104, 109, 15146, 15151, 15156, 114, 114, 59, 32768, 8644, 97, 114, 59, 32768, 8652, 59, 32768, 8207, 111, 117, 115, 116, 512, 59, 97, 15168, 15170, 32768, 9137, 99, 104, 101, 59, 32768, 9137, 109, 105, 100, 59, 32768, 10990, 1024, 97, 98, 112, 116, 15191, 15204, 15209, 15229, 512, 110, 114, 15196, 15200, 103, 59, 32768, 10221, 114, 59, 32768, 8702, 114, 107, 59, 32768, 10215, 768, 97, 102, 108, 15216, 15220, 15224, 114, 59, 32768, 10630, 59, 32896, 55349, 56675, 117, 115, 59, 32768, 10798, 105, 109, 101, 115, 59, 32768, 10805, 512, 97, 112, 15241, 15253, 114, 512, 59, 103, 15247, 15249, 32768, 41, 116, 59, 32768, 10644, 111, 108, 105, 110, 116, 59, 32768, 10770, 97, 114, 114, 59, 32768, 8649, 1024, 97, 99, 104, 113, 15276, 15282, 15287, 15290, 113, 117, 111, 59, 32768, 8250, 114, 59, 32896, 55349, 56519, 59, 32768, 8625, 512, 98, 117, 15295, 15298, 59, 32768, 93, 111, 512, 59, 114, 15304, 15306, 32768, 8217, 59, 32768, 8217, 768, 104, 105, 114, 15316, 15322, 15328, 114, 101, 101, 59, 32768, 8908, 109, 101, 115, 59, 32768, 8906, 105, 1024, 59, 101, 102, 108, 15338, 15340, 15343, 15346, 32768, 9657, 59, 32768, 8885, 59, 32768, 9656, 116, 114, 105, 59, 32768, 10702, 108, 117, 104, 97, 114, 59, 32768, 10600, 59, 32768, 8478, 6706, 15391, 15398, 15404, 15499, 15516, 15592, 0, 15606, 15660, 0, 0, 15752, 15758, 0, 15827, 15863, 15886, 16e3, 16006, 16038, 16086, 0, 16467, 0, 0, 16506, 99, 117, 116, 101, 59, 32768, 347, 113, 117, 111, 59, 32768, 8218, 2560, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 15424, 15426, 15429, 15441, 15446, 15458, 15463, 15482, 15490, 15495, 32768, 8827, 59, 32768, 10932, 833, 15434, 0, 15437, 59, 32768, 10936, 111, 110, 59, 32768, 353, 117, 101, 59, 32768, 8829, 512, 59, 100, 15451, 15453, 32768, 10928, 105, 108, 59, 32768, 351, 114, 99, 59, 32768, 349, 768, 69, 97, 115, 15470, 15473, 15477, 59, 32768, 10934, 112, 59, 32768, 10938, 105, 109, 59, 32768, 8937, 111, 108, 105, 110, 116, 59, 32768, 10771, 105, 109, 59, 32768, 8831, 59, 32768, 1089, 111, 116, 768, 59, 98, 101, 15507, 15509, 15512, 32768, 8901, 59, 32768, 8865, 59, 32768, 10854, 1792, 65, 97, 99, 109, 115, 116, 120, 15530, 15535, 15556, 15562, 15566, 15572, 15587, 114, 114, 59, 32768, 8664, 114, 512, 104, 114, 15541, 15545, 107, 59, 32768, 10533, 512, 59, 111, 15550, 15552, 32768, 8600, 119, 59, 32768, 8600, 116, 33024, 167, 59, 32768, 167, 105, 59, 32768, 59, 119, 97, 114, 59, 32768, 10537, 109, 512, 105, 110, 15578, 15584, 110, 117, 115, 59, 32768, 8726, 59, 32768, 8726, 116, 59, 32768, 10038, 114, 512, 59, 111, 15597, 15600, 32896, 55349, 56624, 119, 110, 59, 32768, 8994, 1024, 97, 99, 111, 121, 15614, 15619, 15632, 15654, 114, 112, 59, 32768, 9839, 512, 104, 121, 15624, 15629, 99, 121, 59, 32768, 1097, 59, 32768, 1096, 114, 116, 1086, 15640, 0, 0, 15645, 105, 100, 59, 32768, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 32768, 8741, 33024, 173, 59, 32768, 173, 512, 103, 109, 15664, 15681, 109, 97, 768, 59, 102, 118, 15673, 15675, 15678, 32768, 963, 59, 32768, 962, 59, 32768, 962, 2048, 59, 100, 101, 103, 108, 110, 112, 114, 15698, 15700, 15705, 15715, 15725, 15735, 15739, 15745, 32768, 8764, 111, 116, 59, 32768, 10858, 512, 59, 113, 15710, 15712, 32768, 8771, 59, 32768, 8771, 512, 59, 69, 15720, 15722, 32768, 10910, 59, 32768, 10912, 512, 59, 69, 15730, 15732, 32768, 10909, 59, 32768, 10911, 101, 59, 32768, 8774, 108, 117, 115, 59, 32768, 10788, 97, 114, 114, 59, 32768, 10610, 97, 114, 114, 59, 32768, 8592, 1024, 97, 101, 105, 116, 15766, 15788, 15796, 15808, 512, 108, 115, 15771, 15783, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 32768, 8726, 104, 112, 59, 32768, 10803, 112, 97, 114, 115, 108, 59, 32768, 10724, 512, 100, 108, 15801, 15804, 59, 32768, 8739, 101, 59, 32768, 8995, 512, 59, 101, 15813, 15815, 32768, 10922, 512, 59, 115, 15820, 15822, 32768, 10924, 59, 32896, 10924, 65024, 768, 102, 108, 112, 15833, 15839, 15857, 116, 99, 121, 59, 32768, 1100, 512, 59, 98, 15844, 15846, 32768, 47, 512, 59, 97, 15851, 15853, 32768, 10692, 114, 59, 32768, 9023, 102, 59, 32896, 55349, 56676, 97, 512, 100, 114, 15868, 15882, 101, 115, 512, 59, 117, 15875, 15877, 32768, 9824, 105, 116, 59, 32768, 9824, 59, 32768, 8741, 768, 99, 115, 117, 15892, 15921, 15977, 512, 97, 117, 15897, 15909, 112, 512, 59, 115, 15903, 15905, 32768, 8851, 59, 32896, 8851, 65024, 112, 512, 59, 115, 15915, 15917, 32768, 8852, 59, 32896, 8852, 65024, 117, 512, 98, 112, 15927, 15952, 768, 59, 101, 115, 15934, 15936, 15939, 32768, 8847, 59, 32768, 8849, 101, 116, 512, 59, 101, 15946, 15948, 32768, 8847, 113, 59, 32768, 8849, 768, 59, 101, 115, 15959, 15961, 15964, 32768, 8848, 59, 32768, 8850, 101, 116, 512, 59, 101, 15971, 15973, 32768, 8848, 113, 59, 32768, 8850, 768, 59, 97, 102, 15984, 15986, 15996, 32768, 9633, 114, 566, 15991, 15994, 59, 32768, 9633, 59, 32768, 9642, 59, 32768, 9642, 97, 114, 114, 59, 32768, 8594, 1024, 99, 101, 109, 116, 16014, 16019, 16025, 16031, 114, 59, 32896, 55349, 56520, 116, 109, 110, 59, 32768, 8726, 105, 108, 101, 59, 32768, 8995, 97, 114, 102, 59, 32768, 8902, 512, 97, 114, 16042, 16053, 114, 512, 59, 102, 16048, 16050, 32768, 9734, 59, 32768, 9733, 512, 97, 110, 16058, 16081, 105, 103, 104, 116, 512, 101, 112, 16067, 16076, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 104, 105, 59, 32768, 981, 115, 59, 32768, 175, 1280, 98, 99, 109, 110, 112, 16096, 16221, 16288, 16291, 16295, 2304, 59, 69, 100, 101, 109, 110, 112, 114, 115, 16115, 16117, 16120, 16125, 16137, 16143, 16154, 16160, 16166, 32768, 8834, 59, 32768, 10949, 111, 116, 59, 32768, 10941, 512, 59, 100, 16130, 16132, 32768, 8838, 111, 116, 59, 32768, 10947, 117, 108, 116, 59, 32768, 10945, 512, 69, 101, 16148, 16151, 59, 32768, 10955, 59, 32768, 8842, 108, 117, 115, 59, 32768, 10943, 97, 114, 114, 59, 32768, 10617, 768, 101, 105, 117, 16173, 16206, 16210, 116, 768, 59, 101, 110, 16181, 16183, 16194, 32768, 8834, 113, 512, 59, 113, 16189, 16191, 32768, 8838, 59, 32768, 10949, 101, 113, 512, 59, 113, 16201, 16203, 32768, 8842, 59, 32768, 10955, 109, 59, 32768, 10951, 512, 98, 112, 16215, 16218, 59, 32768, 10965, 59, 32768, 10963, 99, 1536, 59, 97, 99, 101, 110, 115, 16235, 16237, 16245, 16254, 16258, 16283, 32768, 8827, 112, 112, 114, 111, 120, 59, 32768, 10936, 117, 114, 108, 121, 101, 113, 59, 32768, 8829, 113, 59, 32768, 10928, 768, 97, 101, 115, 16265, 16273, 16278, 112, 112, 114, 111, 120, 59, 32768, 10938, 113, 113, 59, 32768, 10934, 105, 109, 59, 32768, 8937, 105, 109, 59, 32768, 8831, 59, 32768, 8721, 103, 59, 32768, 9834, 3328, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 16322, 16327, 16332, 16337, 16339, 16342, 16356, 16368, 16382, 16388, 16394, 16405, 16411, 33024, 185, 59, 32768, 185, 33024, 178, 59, 32768, 178, 33024, 179, 59, 32768, 179, 32768, 8835, 59, 32768, 10950, 512, 111, 115, 16347, 16351, 116, 59, 32768, 10942, 117, 98, 59, 32768, 10968, 512, 59, 100, 16361, 16363, 32768, 8839, 111, 116, 59, 32768, 10948, 115, 512, 111, 117, 16374, 16378, 108, 59, 32768, 10185, 98, 59, 32768, 10967, 97, 114, 114, 59, 32768, 10619, 117, 108, 116, 59, 32768, 10946, 512, 69, 101, 16399, 16402, 59, 32768, 10956, 59, 32768, 8843, 108, 117, 115, 59, 32768, 10944, 768, 101, 105, 117, 16418, 16451, 16455, 116, 768, 59, 101, 110, 16426, 16428, 16439, 32768, 8835, 113, 512, 59, 113, 16434, 16436, 32768, 8839, 59, 32768, 10950, 101, 113, 512, 59, 113, 16446, 16448, 32768, 8843, 59, 32768, 10956, 109, 59, 32768, 10952, 512, 98, 112, 16460, 16463, 59, 32768, 10964, 59, 32768, 10966, 768, 65, 97, 110, 16473, 16478, 16499, 114, 114, 59, 32768, 8665, 114, 512, 104, 114, 16484, 16488, 107, 59, 32768, 10534, 512, 59, 111, 16493, 16495, 32768, 8601, 119, 59, 32768, 8601, 119, 97, 114, 59, 32768, 10538, 108, 105, 103, 33024, 223, 59, 32768, 223, 5938, 16538, 16552, 16557, 16579, 16584, 16591, 0, 16596, 16692, 0, 0, 0, 0, 0, 16731, 16780, 0, 16787, 16908, 0, 0, 0, 16938, 1091, 16543, 0, 0, 16549, 103, 101, 116, 59, 32768, 8982, 59, 32768, 964, 114, 107, 59, 32768, 9140, 768, 97, 101, 121, 16563, 16569, 16575, 114, 111, 110, 59, 32768, 357, 100, 105, 108, 59, 32768, 355, 59, 32768, 1090, 111, 116, 59, 32768, 8411, 108, 114, 101, 99, 59, 32768, 8981, 114, 59, 32896, 55349, 56625, 1024, 101, 105, 107, 111, 16604, 16641, 16670, 16684, 835, 16609, 0, 16624, 101, 512, 52, 102, 16614, 16617, 59, 32768, 8756, 111, 114, 101, 59, 32768, 8756, 97, 768, 59, 115, 118, 16631, 16633, 16638, 32768, 952, 121, 109, 59, 32768, 977, 59, 32768, 977, 512, 99, 110, 16646, 16665, 107, 512, 97, 115, 16652, 16660, 112, 112, 114, 111, 120, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 115, 112, 59, 32768, 8201, 512, 97, 115, 16675, 16679, 112, 59, 32768, 8776, 105, 109, 59, 32768, 8764, 114, 110, 33024, 254, 59, 32768, 254, 829, 16696, 16701, 16727, 100, 101, 59, 32768, 732, 101, 115, 33536, 215, 59, 98, 100, 16710, 16712, 16723, 32768, 215, 512, 59, 97, 16717, 16719, 32768, 8864, 114, 59, 32768, 10801, 59, 32768, 10800, 116, 59, 32768, 8749, 768, 101, 112, 115, 16737, 16741, 16775, 97, 59, 32768, 10536, 1024, 59, 98, 99, 102, 16750, 16752, 16757, 16762, 32768, 8868, 111, 116, 59, 32768, 9014, 105, 114, 59, 32768, 10993, 512, 59, 111, 16767, 16770, 32896, 55349, 56677, 114, 107, 59, 32768, 10970, 97, 59, 32768, 10537, 114, 105, 109, 101, 59, 32768, 8244, 768, 97, 105, 112, 16793, 16798, 16899, 100, 101, 59, 32768, 8482, 1792, 97, 100, 101, 109, 112, 115, 116, 16813, 16868, 16873, 16876, 16883, 16889, 16893, 110, 103, 108, 101, 1280, 59, 100, 108, 113, 114, 16828, 16830, 16836, 16850, 16853, 32768, 9653, 111, 119, 110, 59, 32768, 9663, 101, 102, 116, 512, 59, 101, 16844, 16846, 32768, 9667, 113, 59, 32768, 8884, 59, 32768, 8796, 105, 103, 104, 116, 512, 59, 101, 16862, 16864, 32768, 9657, 113, 59, 32768, 8885, 111, 116, 59, 32768, 9708, 59, 32768, 8796, 105, 110, 117, 115, 59, 32768, 10810, 108, 117, 115, 59, 32768, 10809, 98, 59, 32768, 10701, 105, 109, 101, 59, 32768, 10811, 101, 122, 105, 117, 109, 59, 32768, 9186, 768, 99, 104, 116, 16914, 16926, 16931, 512, 114, 121, 16919, 16923, 59, 32896, 55349, 56521, 59, 32768, 1094, 99, 121, 59, 32768, 1115, 114, 111, 107, 59, 32768, 359, 512, 105, 111, 16942, 16947, 120, 116, 59, 32768, 8812, 104, 101, 97, 100, 512, 108, 114, 16956, 16967, 101, 102, 116, 97, 114, 114, 111, 119, 59, 32768, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 32768, 8608, 4608, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 17016, 17021, 17026, 17043, 17057, 17072, 17095, 17110, 17119, 17139, 17172, 17187, 17202, 17290, 17330, 17336, 17365, 17381, 114, 114, 59, 32768, 8657, 97, 114, 59, 32768, 10595, 512, 99, 114, 17031, 17039, 117, 116, 101, 33024, 250, 59, 32768, 250, 114, 59, 32768, 8593, 114, 820, 17049, 0, 17053, 121, 59, 32768, 1118, 118, 101, 59, 32768, 365, 512, 105, 121, 17062, 17069, 114, 99, 33024, 251, 59, 32768, 251, 59, 32768, 1091, 768, 97, 98, 104, 17079, 17084, 17090, 114, 114, 59, 32768, 8645, 108, 97, 99, 59, 32768, 369, 97, 114, 59, 32768, 10606, 512, 105, 114, 17100, 17106, 115, 104, 116, 59, 32768, 10622, 59, 32896, 55349, 56626, 114, 97, 118, 101, 33024, 249, 59, 32768, 249, 562, 17123, 17135, 114, 512, 108, 114, 17128, 17131, 59, 32768, 8639, 59, 32768, 8638, 108, 107, 59, 32768, 9600, 512, 99, 116, 17144, 17167, 1088, 17150, 0, 0, 17163, 114, 110, 512, 59, 101, 17156, 17158, 32768, 8988, 114, 59, 32768, 8988, 111, 112, 59, 32768, 8975, 114, 105, 59, 32768, 9720, 512, 97, 108, 17177, 17182, 99, 114, 59, 32768, 363, 33024, 168, 59, 32768, 168, 512, 103, 112, 17192, 17197, 111, 110, 59, 32768, 371, 102, 59, 32896, 55349, 56678, 1536, 97, 100, 104, 108, 115, 117, 17215, 17222, 17233, 17257, 17262, 17280, 114, 114, 111, 119, 59, 32768, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 32768, 8597, 97, 114, 112, 111, 111, 110, 512, 108, 114, 17244, 17250, 101, 102, 116, 59, 32768, 8639, 105, 103, 104, 116, 59, 32768, 8638, 117, 115, 59, 32768, 8846, 105, 768, 59, 104, 108, 17270, 17272, 17275, 32768, 965, 59, 32768, 978, 111, 110, 59, 32768, 965, 112, 97, 114, 114, 111, 119, 115, 59, 32768, 8648, 768, 99, 105, 116, 17297, 17320, 17325, 1088, 17303, 0, 0, 17316, 114, 110, 512, 59, 101, 17309, 17311, 32768, 8989, 114, 59, 32768, 8989, 111, 112, 59, 32768, 8974, 110, 103, 59, 32768, 367, 114, 105, 59, 32768, 9721, 99, 114, 59, 32896, 55349, 56522, 768, 100, 105, 114, 17343, 17348, 17354, 111, 116, 59, 32768, 8944, 108, 100, 101, 59, 32768, 361, 105, 512, 59, 102, 17360, 17362, 32768, 9653, 59, 32768, 9652, 512, 97, 109, 17370, 17375, 114, 114, 59, 32768, 8648, 108, 33024, 252, 59, 32768, 252, 97, 110, 103, 108, 101, 59, 32768, 10663, 3840, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 17420, 17425, 17437, 17443, 17613, 17617, 17623, 17667, 17672, 17678, 17693, 17699, 17705, 17711, 17754, 114, 114, 59, 32768, 8661, 97, 114, 512, 59, 118, 17432, 17434, 32768, 10984, 59, 32768, 10985, 97, 115, 104, 59, 32768, 8872, 512, 110, 114, 17448, 17454, 103, 114, 116, 59, 32768, 10652, 1792, 101, 107, 110, 112, 114, 115, 116, 17469, 17478, 17485, 17494, 17515, 17526, 17578, 112, 115, 105, 108, 111, 110, 59, 32768, 1013, 97, 112, 112, 97, 59, 32768, 1008, 111, 116, 104, 105, 110, 103, 59, 32768, 8709, 768, 104, 105, 114, 17501, 17505, 17508, 105, 59, 32768, 981, 59, 32768, 982, 111, 112, 116, 111, 59, 32768, 8733, 512, 59, 104, 17520, 17522, 32768, 8597, 111, 59, 32768, 1009, 512, 105, 117, 17531, 17537, 103, 109, 97, 59, 32768, 962, 512, 98, 112, 17542, 17560, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17553, 17556, 32896, 8842, 65024, 59, 32896, 10955, 65024, 115, 101, 116, 110, 101, 113, 512, 59, 113, 17571, 17574, 32896, 8843, 65024, 59, 32896, 10956, 65024, 512, 104, 114, 17583, 17589, 101, 116, 97, 59, 32768, 977, 105, 97, 110, 103, 108, 101, 512, 108, 114, 17600, 17606, 101, 102, 116, 59, 32768, 8882, 105, 103, 104, 116, 59, 32768, 8883, 121, 59, 32768, 1074, 97, 115, 104, 59, 32768, 8866, 768, 101, 108, 114, 17630, 17648, 17654, 768, 59, 98, 101, 17637, 17639, 17644, 32768, 8744, 97, 114, 59, 32768, 8891, 113, 59, 32768, 8794, 108, 105, 112, 59, 32768, 8942, 512, 98, 116, 17659, 17664, 97, 114, 59, 32768, 124, 59, 32768, 124, 114, 59, 32896, 55349, 56627, 116, 114, 105, 59, 32768, 8882, 115, 117, 512, 98, 112, 17685, 17689, 59, 32896, 8834, 8402, 59, 32896, 8835, 8402, 112, 102, 59, 32896, 55349, 56679, 114, 111, 112, 59, 32768, 8733, 116, 114, 105, 59, 32768, 8883, 512, 99, 117, 17716, 17721, 114, 59, 32896, 55349, 56523, 512, 98, 112, 17726, 17740, 110, 512, 69, 101, 17732, 17736, 59, 32896, 10955, 65024, 59, 32896, 8842, 65024, 110, 512, 69, 101, 17746, 17750, 59, 32896, 10956, 65024, 59, 32896, 8843, 65024, 105, 103, 122, 97, 103, 59, 32768, 10650, 1792, 99, 101, 102, 111, 112, 114, 115, 17777, 17783, 17815, 17820, 17826, 17829, 17842, 105, 114, 99, 59, 32768, 373, 512, 100, 105, 17788, 17809, 512, 98, 103, 17793, 17798, 97, 114, 59, 32768, 10847, 101, 512, 59, 113, 17804, 17806, 32768, 8743, 59, 32768, 8793, 101, 114, 112, 59, 32768, 8472, 114, 59, 32896, 55349, 56628, 112, 102, 59, 32896, 55349, 56680, 59, 32768, 8472, 512, 59, 101, 17834, 17836, 32768, 8768, 97, 116, 104, 59, 32768, 8768, 99, 114, 59, 32896, 55349, 56524, 5428, 17871, 17891, 0, 17897, 0, 17902, 17917, 0, 0, 17920, 17935, 17940, 17945, 0, 0, 17977, 17992, 0, 18008, 18024, 18029, 768, 97, 105, 117, 17877, 17881, 17886, 112, 59, 32768, 8898, 114, 99, 59, 32768, 9711, 112, 59, 32768, 8899, 116, 114, 105, 59, 32768, 9661, 114, 59, 32896, 55349, 56629, 512, 65, 97, 17906, 17911, 114, 114, 59, 32768, 10234, 114, 114, 59, 32768, 10231, 59, 32768, 958, 512, 65, 97, 17924, 17929, 114, 114, 59, 32768, 10232, 114, 114, 59, 32768, 10229, 97, 112, 59, 32768, 10236, 105, 115, 59, 32768, 8955, 768, 100, 112, 116, 17951, 17956, 17970, 111, 116, 59, 32768, 10752, 512, 102, 108, 17961, 17965, 59, 32896, 55349, 56681, 117, 115, 59, 32768, 10753, 105, 109, 101, 59, 32768, 10754, 512, 65, 97, 17981, 17986, 114, 114, 59, 32768, 10233, 114, 114, 59, 32768, 10230, 512, 99, 113, 17996, 18001, 114, 59, 32896, 55349, 56525, 99, 117, 112, 59, 32768, 10758, 512, 112, 116, 18012, 18018, 108, 117, 115, 59, 32768, 10756, 114, 105, 59, 32768, 9651, 101, 101, 59, 32768, 8897, 101, 100, 103, 101, 59, 32768, 8896, 2048, 97, 99, 101, 102, 105, 111, 115, 117, 18052, 18068, 18081, 18087, 18092, 18097, 18103, 18109, 99, 512, 117, 121, 18058, 18065, 116, 101, 33024, 253, 59, 32768, 253, 59, 32768, 1103, 512, 105, 121, 18073, 18078, 114, 99, 59, 32768, 375, 59, 32768, 1099, 110, 33024, 165, 59, 32768, 165, 114, 59, 32896, 55349, 56630, 99, 121, 59, 32768, 1111, 112, 102, 59, 32896, 55349, 56682, 99, 114, 59, 32896, 55349, 56526, 512, 99, 109, 18114, 18118, 121, 59, 32768, 1102, 108, 33024, 255, 59, 32768, 255, 2560, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 18145, 18152, 18166, 18171, 18186, 18191, 18196, 18204, 18210, 18216, 99, 117, 116, 101, 59, 32768, 378, 512, 97, 121, 18157, 18163, 114, 111, 110, 59, 32768, 382, 59, 32768, 1079, 111, 116, 59, 32768, 380, 512, 101, 116, 18176, 18182, 116, 114, 102, 59, 32768, 8488, 97, 59, 32768, 950, 114, 59, 32896, 55349, 56631, 99, 121, 59, 32768, 1078, 103, 114, 97, 114, 114, 59, 32768, 8669, 112, 102, 59, 32896, 55349, 56683, 99, 114, 59, 32896, 55349, 56527, 512, 106, 110, 18221, 18224, 59, 32768, 8205, 106, 59, 32768, 8204]);
      },
      33727: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array([1024, 97, 103, 108, 113, 9, 23, 27, 31, 1086, 15, 0, 0, 19, 112, 59, 32768, 38, 111, 115, 59, 32768, 39, 116, 59, 32768, 62, 116, 59, 32768, 60, 117, 111, 116, 59, 32768, 34]);
      },
      36415: function (e, t, n) {
        "use strict";

        var r,
          o = this && this.__extends || (r = function (e, t) {
            return r = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }, r(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              this.constructor = e;
            }
            r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          i = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.parseFeed = t.FeedHandler = t.getFeed = void 0;
        var a = i(n(60677)),
          s = n(73425);
        Object.defineProperty(t, "getFeed", {
          enumerable: !0,
          get: function () {
            return s.getFeed;
          }
        });
        var l = n(63077),
          u = function (e) {
            function t(t, n) {
              return "object" == typeof t && (n = t = void 0), e.call(this, t, n) || this;
            }
            return o(t, e), t.prototype.onend = function () {
              var e = (0, s.getFeed)(this.dom);
              e ? (this.feed = e, this.handleCallback(null)) : this.handleCallback(new Error("couldn't find root of feed"));
            }, t;
          }(a.default);
        t.FeedHandler = u, t.parseFeed = function (e, t) {
          void 0 === t && (t = {
            xmlMode: !0
          });
          var n = new a.default(null, t);
          return new l.Parser(n, t).end(e), (0, s.getFeed)(n.dom);
        };
      },
      63077: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Parser = void 0;
        var o = r(n(71722)),
          i = new Set(["input", "option", "optgroup", "select", "button", "datalist", "textarea"]),
          a = new Set(["p"]),
          s = new Set(["thead", "tbody"]),
          l = new Set(["dd", "dt"]),
          u = new Set(["rt", "rp"]),
          c = new Map([["tr", new Set(["tr", "th", "td"])], ["th", new Set(["th"])], ["td", new Set(["thead", "th", "td"])], ["body", new Set(["head", "link", "script"])], ["li", new Set(["li"])], ["p", a], ["h1", a], ["h2", a], ["h3", a], ["h4", a], ["h5", a], ["h6", a], ["select", i], ["input", i], ["output", i], ["button", i], ["datalist", i], ["textarea", i], ["option", new Set(["option"])], ["optgroup", new Set(["optgroup", "option"])], ["dd", l], ["dt", l], ["address", a], ["article", a], ["aside", a], ["blockquote", a], ["details", a], ["div", a], ["dl", a], ["fieldset", a], ["figcaption", a], ["figure", a], ["footer", a], ["form", a], ["header", a], ["hr", a], ["main", a], ["nav", a], ["ol", a], ["pre", a], ["section", a], ["table", a], ["ul", a], ["rt", u], ["rp", u], ["tbody", s], ["tfoot", s]]),
          d = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]),
          p = new Set(["math", "svg"]),
          h = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignobject", "desc", "title"]),
          f = /\s|\//,
          m = function () {
            function e(e, t) {
              var n, r, i, a, s;
              void 0 === t && (t = {}), this.options = t, this.startIndex = 0, this.endIndex = 0, this.openTagStart = 0, this.tagname = "", this.attribname = "", this.attribvalue = "", this.attribs = null, this.stack = [], this.foreignContext = [], this.cbs = null != e ? e : {}, this.lowerCaseTagNames = null !== (n = t.lowerCaseTags) && void 0 !== n ? n : !t.xmlMode, this.lowerCaseAttributeNames = null !== (r = t.lowerCaseAttributeNames) && void 0 !== r ? r : !t.xmlMode, this.tokenizer = new (null !== (i = t.Tokenizer) && void 0 !== i ? i : o.default)(this.options, this), null === (s = (a = this.cbs).onparserinit) || void 0 === s || s.call(a, this);
            }
            return e.prototype.ontext = function (e) {
              var t,
                n,
                r = this.tokenizer.getAbsoluteIndex();
              this.endIndex = r - 1, null === (n = (t = this.cbs).ontext) || void 0 === n || n.call(t, e), this.startIndex = r;
            }, e.prototype.isVoidElement = function (e) {
              return !this.options.xmlMode && d.has(e);
            }, e.prototype.onopentagname = function (e) {
              this.endIndex = this.tokenizer.getAbsoluteIndex(), this.lowerCaseTagNames && (e = e.toLowerCase()), this.emitOpenTag(e);
            }, e.prototype.emitOpenTag = function (e) {
              var t, n, r, o;
              this.openTagStart = this.startIndex, this.tagname = e;
              var i = !this.options.xmlMode && c.get(e);
              if (i) for (; this.stack.length > 0 && i.has(this.stack[this.stack.length - 1]);) {
                var a = this.stack.pop();
                null === (n = (t = this.cbs).onclosetag) || void 0 === n || n.call(t, a, !0);
              }
              this.isVoidElement(e) || (this.stack.push(e), p.has(e) ? this.foreignContext.push(!0) : h.has(e) && this.foreignContext.push(!1)), null === (o = (r = this.cbs).onopentagname) || void 0 === o || o.call(r, e), this.cbs.onopentag && (this.attribs = {});
            }, e.prototype.endOpenTag = function (e) {
              var t, n;
              this.startIndex = this.openTagStart, this.endIndex = this.tokenizer.getAbsoluteIndex(), this.attribs && (null === (n = (t = this.cbs).onopentag) || void 0 === n || n.call(t, this.tagname, this.attribs, e), this.attribs = null), this.cbs.onclosetag && this.isVoidElement(this.tagname) && this.cbs.onclosetag(this.tagname, !0), this.tagname = "";
            }, e.prototype.onopentagend = function () {
              this.endOpenTag(!1), this.startIndex = this.endIndex + 1;
            }, e.prototype.onclosetag = function (e) {
              var t, n, r, o, i, a;
              if (this.endIndex = this.tokenizer.getAbsoluteIndex(), this.lowerCaseTagNames && (e = e.toLowerCase()), (p.has(e) || h.has(e)) && this.foreignContext.pop(), this.isVoidElement(e)) this.options.xmlMode || "br" !== e || (null === (n = (t = this.cbs).onopentagname) || void 0 === n || n.call(t, e), null === (o = (r = this.cbs).onopentag) || void 0 === o || o.call(r, e, {}, !0), null === (a = (i = this.cbs).onclosetag) || void 0 === a || a.call(i, e, !1));else {
                var s = this.stack.lastIndexOf(e);
                if (-1 !== s) {
                  if (this.cbs.onclosetag) for (var l = this.stack.length - s; l--;) this.cbs.onclosetag(this.stack.pop(), 0 !== l);else this.stack.length = s;
                } else this.options.xmlMode || "p" !== e || (this.emitOpenTag(e), this.closeCurrentTag(!0));
              }
              this.startIndex = this.endIndex + 1;
            }, e.prototype.onselfclosingtag = function () {
              this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1] ? (this.closeCurrentTag(!1), this.startIndex = this.endIndex + 1) : this.onopentagend();
            }, e.prototype.closeCurrentTag = function (e) {
              var t,
                n,
                r = this.tagname;
              this.endOpenTag(e), this.stack[this.stack.length - 1] === r && (null === (n = (t = this.cbs).onclosetag) || void 0 === n || n.call(t, r, !e), this.stack.pop());
            }, e.prototype.onattribname = function (e) {
              this.startIndex = this.tokenizer.getAbsoluteSectionStart(), this.lowerCaseAttributeNames && (e = e.toLowerCase()), this.attribname = e;
            }, e.prototype.onattribdata = function (e) {
              this.attribvalue += e;
            }, e.prototype.onattribend = function (e) {
              var t, n;
              this.endIndex = this.tokenizer.getAbsoluteIndex(), null === (n = (t = this.cbs).onattribute) || void 0 === n || n.call(t, this.attribname, this.attribvalue, e), this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname) && (this.attribs[this.attribname] = this.attribvalue), this.attribname = "", this.attribvalue = "";
            }, e.prototype.getInstructionName = function (e) {
              var t = e.search(f),
                n = t < 0 ? e : e.substr(0, t);
              return this.lowerCaseTagNames && (n = n.toLowerCase()), n;
            }, e.prototype.ondeclaration = function (e) {
              if (this.endIndex = this.tokenizer.getAbsoluteIndex(), this.cbs.onprocessinginstruction) {
                var t = this.getInstructionName(e);
                this.cbs.onprocessinginstruction("!" + t, "!" + e);
              }
              this.startIndex = this.endIndex + 1;
            }, e.prototype.onprocessinginstruction = function (e) {
              if (this.endIndex = this.tokenizer.getAbsoluteIndex(), this.cbs.onprocessinginstruction) {
                var t = this.getInstructionName(e);
                this.cbs.onprocessinginstruction("?" + t, "?" + e);
              }
              this.startIndex = this.endIndex + 1;
            }, e.prototype.oncomment = function (e) {
              var t, n, r, o;
              this.endIndex = this.tokenizer.getAbsoluteIndex(), null === (n = (t = this.cbs).oncomment) || void 0 === n || n.call(t, e), null === (o = (r = this.cbs).oncommentend) || void 0 === o || o.call(r), this.startIndex = this.endIndex + 1;
            }, e.prototype.oncdata = function (e) {
              var t, n, r, o, i, a, s, l, u, c;
              this.endIndex = this.tokenizer.getAbsoluteIndex(), this.options.xmlMode || this.options.recognizeCDATA ? (null === (n = (t = this.cbs).oncdatastart) || void 0 === n || n.call(t), null === (o = (r = this.cbs).ontext) || void 0 === o || o.call(r, e), null === (a = (i = this.cbs).oncdataend) || void 0 === a || a.call(i)) : (null === (l = (s = this.cbs).oncomment) || void 0 === l || l.call(s, "[CDATA[" + e + "]]"), null === (c = (u = this.cbs).oncommentend) || void 0 === c || c.call(u)), this.startIndex = this.endIndex + 1;
            }, e.prototype.onerror = function (e) {
              var t, n;
              null === (n = (t = this.cbs).onerror) || void 0 === n || n.call(t, e);
            }, e.prototype.onend = function () {
              var e, t;
              if (this.cbs.onclosetag) {
                this.endIndex = this.startIndex;
                for (var n = this.stack.length; n > 0; this.cbs.onclosetag(this.stack[--n], !0));
              }
              null === (t = (e = this.cbs).onend) || void 0 === t || t.call(e);
            }, e.prototype.reset = function () {
              var e, t, n, r;
              null === (t = (e = this.cbs).onreset) || void 0 === t || t.call(e), this.tokenizer.reset(), this.tagname = "", this.attribname = "", this.attribs = null, this.stack = [], this.startIndex = 0, this.endIndex = 0, null === (r = (n = this.cbs).onparserinit) || void 0 === r || r.call(n, this);
            }, e.prototype.parseComplete = function (e) {
              this.reset(), this.end(e);
            }, e.prototype.write = function (e) {
              this.tokenizer.write(e);
            }, e.prototype.end = function (e) {
              this.tokenizer.end(e);
            }, e.prototype.pause = function () {
              this.tokenizer.pause();
            }, e.prototype.resume = function () {
              this.tokenizer.resume();
            }, e.prototype.parseChunk = function (e) {
              this.write(e);
            }, e.prototype.done = function (e) {
              this.end(e);
            }, e;
          }();
        t.Parser = m;
      },
      71722: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = r(n(35102)),
          i = n(26934);
        function a(e) {
          return 32 === e || 10 === e || 9 === e || 12 === e || 13 === e;
        }
        function s(e) {
          return 47 === e || 62 === e || a(e);
        }
        function l(e) {
          return e >= 48 && e <= 57;
        }
        var u = {
            Cdata: new Uint16Array([67, 68, 65, 84, 65, 91]),
            CdataEnd: new Uint16Array([93, 93, 62]),
            CommentEnd: new Uint16Array([45, 45, 62]),
            ScriptEnd: new Uint16Array([60, 47, 115, 99, 114, 105, 112, 116]),
            StyleEnd: new Uint16Array([60, 47, 115, 116, 121, 108, 101]),
            TitleEnd: new Uint16Array([60, 47, 116, 105, 116, 108, 101])
          },
          c = function () {
            function e(e, t) {
              var n = e.xmlMode,
                r = void 0 !== n && n,
                o = e.decodeEntities,
                a = void 0 === o || o;
              this.cbs = t, this._state = 1, this.buffer = "", this.sectionStart = 0, this._index = 0, this.bufferOffset = 0, this.baseState = 1, this.isSpecial = !1, this.running = !0, this.ended = !1, this.sequenceIndex = 0, this.trieIndex = 0, this.trieCurrent = 0, this.trieResult = null, this.entityExcess = 0, this.xmlMode = r, this.decodeEntities = a, this.entityTrie = r ? i.xmlDecodeTree : i.htmlDecodeTree;
            }
            return e.prototype.reset = function () {
              this._state = 1, this.buffer = "", this.sectionStart = 0, this._index = 0, this.bufferOffset = 0, this.baseState = 1, this.currentSequence = void 0, this.running = !0, this.ended = !1;
            }, e.prototype.write = function (e) {
              if (this.ended) return this.cbs.onerror(Error(".write() after done!"));
              this.buffer += e, this.parse();
            }, e.prototype.end = function (e) {
              if (this.ended) return this.cbs.onerror(Error(".end() after done!"));
              e && this.write(e), this.ended = !0, this.running && this.finish();
            }, e.prototype.pause = function () {
              this.running = !1;
            }, e.prototype.resume = function () {
              this.running = !0, this._index < this.buffer.length && this.parse(), this.ended && this.finish();
            }, e.prototype.getAbsoluteSectionStart = function () {
              return this.sectionStart + this.bufferOffset;
            }, e.prototype.getAbsoluteIndex = function () {
              return this.bufferOffset + this._index;
            }, e.prototype.stateText = function (e) {
              60 === e || !this.decodeEntities && this.fastForwardTo(60) ? (this._index > this.sectionStart && this.cbs.ontext(this.getSection()), this._state = 2, this.sectionStart = this._index) : this.decodeEntities && 38 === e && (this._state = 25);
            }, e.prototype.stateSpecialStartSequence = function (e) {
              var t = this.sequenceIndex === this.currentSequence.length;
              if (t ? s(e) : (32 | e) === this.currentSequence[this.sequenceIndex]) {
                if (!t) return void this.sequenceIndex++;
              } else this.isSpecial = !1;
              this.sequenceIndex = 0, this._state = 3, this.stateInTagName(e);
            }, e.prototype.stateInSpecialTag = function (e) {
              if (this.sequenceIndex === this.currentSequence.length) {
                if (62 === e || a(e)) {
                  var t = this._index - this.currentSequence.length;
                  if (this.sectionStart < t) {
                    var n = this._index;
                    this._index = t, this.cbs.ontext(this.getSection()), this._index = n;
                  }
                  return this.isSpecial = !1, this.sectionStart = t + 2, void this.stateInClosingTagName(e);
                }
                this.sequenceIndex = 0;
              }
              (32 | e) === this.currentSequence[this.sequenceIndex] ? this.sequenceIndex += 1 : 0 === this.sequenceIndex ? this.currentSequence === u.TitleEnd ? this.decodeEntities && 38 === e && (this._state = 25) : this.fastForwardTo(60) && (this.sequenceIndex = 1) : this.sequenceIndex = Number(60 === e);
            }, e.prototype.stateCDATASequence = function (e) {
              e === u.Cdata[this.sequenceIndex] ? ++this.sequenceIndex === u.Cdata.length && (this._state = 21, this.currentSequence = u.CdataEnd, this.sequenceIndex = 0, this.sectionStart = this._index + 1) : (this.sequenceIndex = 0, this._state = 16, this.stateInDeclaration(e));
            }, e.prototype.fastForwardTo = function (e) {
              for (; ++this._index < this.buffer.length;) if (this.buffer.charCodeAt(this._index) === e) return !0;
              return this._index = this.buffer.length - 1, !1;
            }, e.prototype.stateInCommentLike = function (e) {
              if (e === this.currentSequence[this.sequenceIndex]) {
                if (++this.sequenceIndex === this.currentSequence.length) {
                  var t = this.buffer.slice(this.sectionStart, this._index - 2);
                  this.currentSequence === u.CdataEnd ? this.cbs.oncdata(t) : this.cbs.oncomment(t), this.sequenceIndex = 0, this.sectionStart = this._index + 1, this._state = 1;
                }
              } else 0 === this.sequenceIndex ? this.fastForwardTo(this.currentSequence[0]) && (this.sequenceIndex = 1) : e !== this.currentSequence[this.sequenceIndex - 1] && (this.sequenceIndex = 0);
            }, e.prototype.isTagStartChar = function (e) {
              return this.xmlMode ? !s(e) : function (e) {
                return e >= 97 && e <= 122 || e >= 65 && e <= 90;
              }(e);
            }, e.prototype.startSpecial = function (e, t) {
              this.isSpecial = !0, this.currentSequence = e, this.sequenceIndex = t, this._state = 23;
            }, e.prototype.stateBeforeTagName = function (e) {
              if (33 === e) this._state = 15, this.sectionStart = this._index + 1;else if (63 === e) this._state = 17, this.sectionStart = this._index + 1;else if (this.isTagStartChar(e)) {
                var t = 32 | e;
                this.sectionStart = this._index, this.xmlMode || t !== u.TitleEnd[2] ? this._state = this.xmlMode || t !== u.ScriptEnd[2] ? 3 : 22 : this.startSpecial(u.TitleEnd, 3);
              } else 47 === e ? this._state = 5 : (this._state = 1, this.stateText(e));
            }, e.prototype.stateInTagName = function (e) {
              s(e) && (this.cbs.onopentagname(this.getSection()), this.sectionStart = -1, this._state = 8, this.stateBeforeAttributeName(e));
            }, e.prototype.stateBeforeClosingTagName = function (e) {
              a(e) || (62 === e ? this._state = 1 : (this._state = this.isTagStartChar(e) ? 6 : 20, this.sectionStart = this._index));
            }, e.prototype.stateInClosingTagName = function (e) {
              (62 === e || a(e)) && (this.cbs.onclosetag(this.getSection()), this.sectionStart = -1, this._state = 7, this.stateAfterClosingTagName(e));
            }, e.prototype.stateAfterClosingTagName = function (e) {
              (62 === e || this.fastForwardTo(62)) && (this._state = 1, this.sectionStart = this._index + 1);
            }, e.prototype.stateBeforeAttributeName = function (e) {
              62 === e ? (this.cbs.onopentagend(), this.isSpecial ? (this._state = 24, this.sequenceIndex = 0) : this._state = 1, this.baseState = this._state, this.sectionStart = this._index + 1) : 47 === e ? this._state = 4 : a(e) || (this._state = 9, this.sectionStart = this._index);
            }, e.prototype.stateInSelfClosingTag = function (e) {
              62 === e ? (this.cbs.onselfclosingtag(), this._state = 1, this.baseState = 1, this.sectionStart = this._index + 1, this.isSpecial = !1) : a(e) || (this._state = 8, this.stateBeforeAttributeName(e));
            }, e.prototype.stateInAttributeName = function (e) {
              (61 === e || s(e)) && (this.cbs.onattribname(this.getSection()), this.sectionStart = -1, this._state = 10, this.stateAfterAttributeName(e));
            }, e.prototype.stateAfterAttributeName = function (e) {
              61 === e ? this._state = 11 : 47 === e || 62 === e ? (this.cbs.onattribend(void 0), this._state = 8, this.stateBeforeAttributeName(e)) : a(e) || (this.cbs.onattribend(void 0), this._state = 9, this.sectionStart = this._index);
            }, e.prototype.stateBeforeAttributeValue = function (e) {
              34 === e ? (this._state = 12, this.sectionStart = this._index + 1) : 39 === e ? (this._state = 13, this.sectionStart = this._index + 1) : a(e) || (this.sectionStart = this._index, this._state = 14, this.stateInAttributeValueNoQuotes(e));
            }, e.prototype.handleInAttributeValue = function (e, t) {
              e === t || !this.decodeEntities && this.fastForwardTo(t) ? (this.cbs.onattribdata(this.getSection()), this.sectionStart = -1, this.cbs.onattribend(String.fromCharCode(t)), this._state = 8) : this.decodeEntities && 38 === e && (this.baseState = this._state, this._state = 25);
            }, e.prototype.stateInAttributeValueDoubleQuotes = function (e) {
              this.handleInAttributeValue(e, 34);
            }, e.prototype.stateInAttributeValueSingleQuotes = function (e) {
              this.handleInAttributeValue(e, 39);
            }, e.prototype.stateInAttributeValueNoQuotes = function (e) {
              a(e) || 62 === e ? (this.cbs.onattribdata(this.getSection()), this.sectionStart = -1, this.cbs.onattribend(null), this._state = 8, this.stateBeforeAttributeName(e)) : this.decodeEntities && 38 === e && (this.baseState = this._state, this._state = 25);
            }, e.prototype.stateBeforeDeclaration = function (e) {
              91 === e ? (this._state = 19, this.sequenceIndex = 0) : this._state = 45 === e ? 18 : 16;
            }, e.prototype.stateInDeclaration = function (e) {
              (62 === e || this.fastForwardTo(62)) && (this.cbs.ondeclaration(this.getSection()), this._state = 1, this.sectionStart = this._index + 1);
            }, e.prototype.stateInProcessingInstruction = function (e) {
              (62 === e || this.fastForwardTo(62)) && (this.cbs.onprocessinginstruction(this.getSection()), this._state = 1, this.sectionStart = this._index + 1);
            }, e.prototype.stateBeforeComment = function (e) {
              45 === e ? (this._state = 21, this.currentSequence = u.CommentEnd, this.sequenceIndex = 2, this.sectionStart = this._index + 1) : this._state = 16;
            }, e.prototype.stateInSpecialComment = function (e) {
              (62 === e || this.fastForwardTo(62)) && (this.cbs.oncomment(this.getSection()), this._state = 1, this.sectionStart = this._index + 1);
            }, e.prototype.stateBeforeSpecialS = function (e) {
              var t = 32 | e;
              t === u.ScriptEnd[3] ? this.startSpecial(u.ScriptEnd, 4) : t === u.StyleEnd[3] ? this.startSpecial(u.StyleEnd, 4) : (this._state = 3, this.stateInTagName(e));
            }, e.prototype.stateBeforeEntity = function (e) {
              this.entityExcess = 1, 35 === e ? this._state = 26 : 38 === e || (this.trieIndex = 0, this.trieCurrent = this.entityTrie[0], this.trieResult = null, this._state = 27, this.stateInNamedEntity(e));
            }, e.prototype.stateInNamedEntity = function (e) {
              if (this.entityExcess += 1, this.trieIndex = (0, i.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, e), this.trieIndex < 0) return this.emitNamedEntity(), void this._index--;
              if (this.trieCurrent = this.entityTrie[this.trieIndex], this.trieCurrent & i.BinTrieFlags.HAS_VALUE) if (this.allowLegacyEntity() || 59 === e) {
                var t = this._index - this.entityExcess + 1;
                t > this.sectionStart && this.emitPartial(this.buffer.substring(this.sectionStart, t)), this.trieResult = this.trieCurrent & i.BinTrieFlags.MULTI_BYTE ? String.fromCharCode(this.entityTrie[++this.trieIndex], this.entityTrie[++this.trieIndex]) : String.fromCharCode(this.entityTrie[++this.trieIndex]), this.entityExcess = 0, this.sectionStart = this._index + 1;
              } else this.trieIndex += 1;
            }, e.prototype.emitNamedEntity = function () {
              this.trieResult && this.emitPartial(this.trieResult), this._state = this.baseState;
            }, e.prototype.stateBeforeNumericEntity = function (e) {
              120 == (32 | e) ? (this.entityExcess++, this._state = 29) : (this._state = 28, this.stateInNumericEntity(e));
            }, e.prototype.decodeNumericEntity = function (e, t) {
              var n = this._index - this.entityExcess - 1,
                r = n + 2 + (e >> 4);
              if (r !== this._index) {
                n > this.sectionStart && this.emitPartial(this.buffer.substring(this.sectionStart, n));
                var i = this.buffer.substring(r, this._index),
                  a = parseInt(i, e);
                this.emitPartial((0, o.default)(a)), this.sectionStart = this._index + Number(t);
              }
              this._state = this.baseState;
            }, e.prototype.stateInNumericEntity = function (e) {
              59 === e ? this.decodeNumericEntity(10, !0) : l(e) ? this.entityExcess++ : (this.allowLegacyEntity() ? this.decodeNumericEntity(10, !1) : this._state = this.baseState, this._index--);
            }, e.prototype.stateInHexEntity = function (e) {
              59 === e ? this.decodeNumericEntity(16, !0) : (e < 97 || e > 102) && (e < 65 || e > 70) && !l(e) ? (this.allowLegacyEntity() ? this.decodeNumericEntity(16, !1) : this._state = this.baseState, this._index--) : this.entityExcess++;
            }, e.prototype.allowLegacyEntity = function () {
              return !this.xmlMode && (1 === this.baseState || 24 === this.baseState);
            }, e.prototype.cleanup = function () {
              this.running && this.sectionStart !== this._index && (1 === this._state || 24 === this._state && 0 === this.sequenceIndex) && (this.cbs.ontext(this.buffer.substr(this.sectionStart)), this.sectionStart = this._index);
              var e = this.sectionStart < 0 ? this._index : this.sectionStart;
              this.buffer = e === this.buffer.length ? "" : this.buffer.substr(e), this._index -= e, this.bufferOffset += e, this.sectionStart > 0 && (this.sectionStart = 0);
            }, e.prototype.shouldContinue = function () {
              return this._index < this.buffer.length && this.running;
            }, e.prototype.parse = function () {
              for (; this.shouldContinue();) {
                var e = this.buffer.charCodeAt(this._index);
                1 === this._state ? this.stateText(e) : 23 === this._state ? this.stateSpecialStartSequence(e) : 24 === this._state ? this.stateInSpecialTag(e) : 19 === this._state ? this.stateCDATASequence(e) : 12 === this._state ? this.stateInAttributeValueDoubleQuotes(e) : 9 === this._state ? this.stateInAttributeName(e) : 21 === this._state ? this.stateInCommentLike(e) : 20 === this._state ? this.stateInSpecialComment(e) : 8 === this._state ? this.stateBeforeAttributeName(e) : 3 === this._state ? this.stateInTagName(e) : 6 === this._state ? this.stateInClosingTagName(e) : 2 === this._state ? this.stateBeforeTagName(e) : 10 === this._state ? this.stateAfterAttributeName(e) : 13 === this._state ? this.stateInAttributeValueSingleQuotes(e) : 11 === this._state ? this.stateBeforeAttributeValue(e) : 5 === this._state ? this.stateBeforeClosingTagName(e) : 7 === this._state ? this.stateAfterClosingTagName(e) : 22 === this._state ? this.stateBeforeSpecialS(e) : 14 === this._state ? this.stateInAttributeValueNoQuotes(e) : 4 === this._state ? this.stateInSelfClosingTag(e) : 16 === this._state ? this.stateInDeclaration(e) : 15 === this._state ? this.stateBeforeDeclaration(e) : 18 === this._state ? this.stateBeforeComment(e) : 17 === this._state ? this.stateInProcessingInstruction(e) : 27 === this._state ? this.stateInNamedEntity(e) : 25 === this._state ? this.stateBeforeEntity(e) : 29 === this._state ? this.stateInHexEntity(e) : 28 === this._state ? this.stateInNumericEntity(e) : this.stateBeforeNumericEntity(e), this._index++;
              }
              this.cleanup();
            }, e.prototype.finish = function () {
              27 === this._state && this.emitNamedEntity(), this.sectionStart < this._index && this.handleTrailingData(), this.cbs.onend();
            }, e.prototype.handleTrailingData = function () {
              var e = this.buffer.substr(this.sectionStart);
              21 === this._state ? this.currentSequence === u.CdataEnd ? this.cbs.oncdata(e) : this.cbs.oncomment(e) : 28 === this._state && this.allowLegacyEntity() ? this.decodeNumericEntity(10, !1) : 29 === this._state && this.allowLegacyEntity() ? this.decodeNumericEntity(16, !1) : 3 === this._state || 8 === this._state || 11 === this._state || 10 === this._state || 9 === this._state || 13 === this._state || 12 === this._state || 14 === this._state || 6 === this._state || this.cbs.ontext(e);
            }, e.prototype.getSection = function () {
              return this.buffer.substring(this.sectionStart, this._index);
            }, e.prototype.emitPartial = function (e) {
              1 !== this.baseState && 24 !== this.baseState ? this.cbs.onattribdata(e) : this.cbs.ontext(e);
            }, e;
          }();
        t.default = c;
      },
      77479: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n), Object.defineProperty(e, r, {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            });
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          i = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
            return o(t, e), t;
          },
          a = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          },
          s = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.RssHandler = t.DefaultHandler = t.DomUtils = t.ElementType = t.Tokenizer = t.createDomStream = t.parseDOM = t.parseDocument = t.DomHandler = t.Parser = void 0;
        var l = n(63077);
        Object.defineProperty(t, "Parser", {
          enumerable: !0,
          get: function () {
            return l.Parser;
          }
        });
        var u = n(60677);
        function c(e, t) {
          var n = new u.DomHandler(void 0, t);
          return new l.Parser(n, t).end(e), n.root;
        }
        Object.defineProperty(t, "DomHandler", {
          enumerable: !0,
          get: function () {
            return u.DomHandler;
          }
        }), Object.defineProperty(t, "DefaultHandler", {
          enumerable: !0,
          get: function () {
            return u.DomHandler;
          }
        }), t.parseDocument = c, t.parseDOM = function (e, t) {
          return c(e, t).children;
        }, t.createDomStream = function (e, t, n) {
          var r = new u.DomHandler(e, t, n);
          return new l.Parser(r, t);
        };
        var d = n(71722);
        Object.defineProperty(t, "Tokenizer", {
          enumerable: !0,
          get: function () {
            return s(d).default;
          }
        });
        var p = i(n(99960));
        t.ElementType = p, a(n(36415), t), t.DomUtils = i(n(73425));
        var h = n(36415);
        Object.defineProperty(t, "RssHandler", {
          enumerable: !0,
          get: function () {
            return h.FeedHandler;
          }
        });
      },
      92407: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.attributeNames = t.elementNames = void 0, t.elementNames = new Map([["altglyph", "altGlyph"], ["altglyphdef", "altGlyphDef"], ["altglyphitem", "altGlyphItem"], ["animatecolor", "animateColor"], ["animatemotion", "animateMotion"], ["animatetransform", "animateTransform"], ["clippath", "clipPath"], ["feblend", "feBlend"], ["fecolormatrix", "feColorMatrix"], ["fecomponenttransfer", "feComponentTransfer"], ["fecomposite", "feComposite"], ["feconvolvematrix", "feConvolveMatrix"], ["fediffuselighting", "feDiffuseLighting"], ["fedisplacementmap", "feDisplacementMap"], ["fedistantlight", "feDistantLight"], ["fedropshadow", "feDropShadow"], ["feflood", "feFlood"], ["fefunca", "feFuncA"], ["fefuncb", "feFuncB"], ["fefuncg", "feFuncG"], ["fefuncr", "feFuncR"], ["fegaussianblur", "feGaussianBlur"], ["feimage", "feImage"], ["femerge", "feMerge"], ["femergenode", "feMergeNode"], ["femorphology", "feMorphology"], ["feoffset", "feOffset"], ["fepointlight", "fePointLight"], ["fespecularlighting", "feSpecularLighting"], ["fespotlight", "feSpotLight"], ["fetile", "feTile"], ["feturbulence", "feTurbulence"], ["foreignobject", "foreignObject"], ["glyphref", "glyphRef"], ["lineargradient", "linearGradient"], ["radialgradient", "radialGradient"], ["textpath", "textPath"]]), t.attributeNames = new Map([["definitionurl", "definitionURL"], ["attributename", "attributeName"], ["attributetype", "attributeType"], ["basefrequency", "baseFrequency"], ["baseprofile", "baseProfile"], ["calcmode", "calcMode"], ["clippathunits", "clipPathUnits"], ["diffuseconstant", "diffuseConstant"], ["edgemode", "edgeMode"], ["filterunits", "filterUnits"], ["glyphref", "glyphRef"], ["gradienttransform", "gradientTransform"], ["gradientunits", "gradientUnits"], ["kernelmatrix", "kernelMatrix"], ["kernelunitlength", "kernelUnitLength"], ["keypoints", "keyPoints"], ["keysplines", "keySplines"], ["keytimes", "keyTimes"], ["lengthadjust", "lengthAdjust"], ["limitingconeangle", "limitingConeAngle"], ["markerheight", "markerHeight"], ["markerunits", "markerUnits"], ["markerwidth", "markerWidth"], ["maskcontentunits", "maskContentUnits"], ["maskunits", "maskUnits"], ["numoctaves", "numOctaves"], ["pathlength", "pathLength"], ["patterncontentunits", "patternContentUnits"], ["patterntransform", "patternTransform"], ["patternunits", "patternUnits"], ["pointsatx", "pointsAtX"], ["pointsaty", "pointsAtY"], ["pointsatz", "pointsAtZ"], ["preservealpha", "preserveAlpha"], ["preserveaspectratio", "preserveAspectRatio"], ["primitiveunits", "primitiveUnits"], ["refx", "refX"], ["refy", "refY"], ["repeatcount", "repeatCount"], ["repeatdur", "repeatDur"], ["requiredextensions", "requiredExtensions"], ["requiredfeatures", "requiredFeatures"], ["specularconstant", "specularConstant"], ["specularexponent", "specularExponent"], ["spreadmethod", "spreadMethod"], ["startoffset", "startOffset"], ["stddeviation", "stdDeviation"], ["stitchtiles", "stitchTiles"], ["surfacescale", "surfaceScale"], ["systemlanguage", "systemLanguage"], ["tablevalues", "tableValues"], ["targetx", "targetX"], ["targety", "targetY"], ["textlength", "textLength"], ["viewbox", "viewBox"], ["viewtarget", "viewTarget"], ["xchannelselector", "xChannelSelector"], ["ychannelselector", "yChannelSelector"], ["zoomandpan", "zoomAndPan"]]);
      },
      47125: function (e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
            return r = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, r.apply(this, arguments);
          },
          o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n), Object.defineProperty(e, r, {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            });
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          a = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
            return i(t, e), t;
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var s = a(n(99960)),
          l = n(98613),
          u = n(92407),
          c = new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
        var d = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
        function p(e, t) {
          void 0 === t && (t = {});
          for (var n = ("length" in e) ? e : [e], r = "", o = 0; o < n.length; o++) r += h(n[o], t);
          return r;
        }
        function h(e, t) {
          switch (e.type) {
            case s.Root:
              return p(e.children, t);
            case s.Directive:
            case s.Doctype:
              return "<" + e.data + ">";
            case s.Comment:
              return function (e) {
                return "\x3c!--" + e.data + "--\x3e";
              }(e);
            case s.CDATA:
              return function (e) {
                return "<![CDATA[" + e.children[0].data + "]]>";
              }(e);
            case s.Script:
            case s.Style:
            case s.Tag:
              return function (e, t) {
                var n;
                "foreign" === t.xmlMode && (e.name = null !== (n = u.elementNames.get(e.name)) && void 0 !== n ? n : e.name, e.parent && f.has(e.parent.name) && (t = r(r({}, t), {
                  xmlMode: !1
                })));
                !t.xmlMode && m.has(e.name) && (t = r(r({}, t), {
                  xmlMode: "foreign"
                }));
                var o = "<" + e.name,
                  i = function (e, t) {
                    if (e) return Object.keys(e).map(function (n) {
                      var r,
                        o,
                        i = null !== (r = e[n]) && void 0 !== r ? r : "";
                      return "foreign" === t.xmlMode && (n = null !== (o = u.attributeNames.get(n)) && void 0 !== o ? o : n), t.emptyAttrs || t.xmlMode || "" !== i ? n + '="' + (!1 !== t.decodeEntities ? l.encodeXML(i) : i.replace(/"/g, "&quot;")) + '"' : n;
                    }).join(" ");
                  }(e.attribs, t);
                i && (o += " " + i);
                0 === e.children.length && (t.xmlMode ? !1 !== t.selfClosingTags : t.selfClosingTags && d.has(e.name)) ? (t.xmlMode || (o += " "), o += "/>") : (o += ">", e.children.length > 0 && (o += p(e.children, t)), !t.xmlMode && d.has(e.name) || (o += "</" + e.name + ">"));
                return o;
              }(e, t);
            case s.Text:
              return function (e, t) {
                var n = e.data || "";
                !1 === t.decodeEntities || !t.xmlMode && e.parent && c.has(e.parent.name) || (n = l.encodeXML(n));
                return n;
              }(e, t);
          }
        }
        t.default = p;
        var f = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]),
          m = new Set(["svg", "math"]);
      },
      58455: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeHTML = t.decodeHTMLStrict = t.decodeXML = void 0;
        var o = r(n(88295)),
          i = r(n(12221)),
          a = r(n(88016)),
          s = r(n(93869)),
          l = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
        function u(e) {
          var t = d(e);
          return function (e) {
            return String(e).replace(l, t);
          };
        }
        t.decodeXML = u(a.default), t.decodeHTMLStrict = u(o.default);
        var c = function (e, t) {
          return e < t ? 1 : -1;
        };
        function d(e) {
          return function (t) {
            if ("#" === t.charAt(1)) {
              var n = t.charAt(2);
              return "X" === n || "x" === n ? s.default(parseInt(t.substr(3), 16)) : s.default(parseInt(t.substr(2), 10));
            }
            return e[t.slice(1, -1)] || t;
          };
        }
        t.decodeHTML = function () {
          for (var e = Object.keys(i.default).sort(c), t = Object.keys(o.default).sort(c), n = 0, r = 0; n < t.length; n++) e[r] === t[n] ? (t[n] += ";?", r++) : t[n] += ";";
          var a = new RegExp("&(?:" + t.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
            s = d(o.default);
          function l(e) {
            return ";" !== e.substr(-1) && (e += ";"), s(e);
          }
          return function (e) {
            return String(e).replace(a, l);
          };
        }();
      },
      93869: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var o = r(n(32823)),
          i = String.fromCodePoint || function (e) {
            var t = "";
            return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += String.fromCharCode(e);
          };
        t.default = function (e) {
          return e >= 55296 && e <= 57343 || e > 1114111 ? "�" : (e in o.default && (e = o.default[e]), i(e));
        };
      },
      87198: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.escapeUTF8 = t.escape = t.encodeNonAsciiHTML = t.encodeHTML = t.encodeXML = void 0;
        var o = c(r(n(88016)).default),
          i = d(o);
        t.encodeXML = g(o);
        var a,
          s,
          l = c(r(n(88295)).default),
          u = d(l);
        function c(e) {
          return Object.keys(e).sort().reduce(function (t, n) {
            return t[e[n]] = "&" + n + ";", t;
          }, {});
        }
        function d(e) {
          for (var t = [], n = [], r = 0, o = Object.keys(e); r < o.length; r++) {
            var i = o[r];
            1 === i.length ? t.push("\\" + i) : n.push(i);
          }
          t.sort();
          for (var a = 0; a < t.length - 1; a++) {
            for (var s = a; s < t.length - 1 && t[s].charCodeAt(1) + 1 === t[s + 1].charCodeAt(1);) s += 1;
            var l = 1 + s - a;
            l < 3 || t.splice(a, l, t[a] + "-" + t[s]);
          }
          return n.unshift("[" + t.join("") + "]"), new RegExp(n.join("|"), "g");
        }
        t.encodeHTML = (a = l, s = u, function (e) {
          return e.replace(s, function (e) {
            return a[e];
          }).replace(p, f);
        }), t.encodeNonAsciiHTML = g(l);
        var p = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g,
          h = null != String.prototype.codePointAt ? function (e) {
            return e.codePointAt(0);
          } : function (e) {
            return 1024 * (e.charCodeAt(0) - 55296) + e.charCodeAt(1) - 56320 + 65536;
          };
        function f(e) {
          return "&#x" + (e.length > 1 ? h(e) : e.charCodeAt(0)).toString(16).toUpperCase() + ";";
        }
        var m = new RegExp(i.source + "|" + p.source, "g");
        function g(e) {
          return function (t) {
            return t.replace(m, function (t) {
              return e[t] || f(t);
            });
          };
        }
        t.escape = function (e) {
          return e.replace(m, f);
        }, t.escapeUTF8 = function (e) {
          return e.replace(i, f);
        };
      },
      98613: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.encodeHTML5 = t.encodeHTML4 = t.escapeUTF8 = t.escape = t.encodeNonAsciiHTML = t.encodeHTML = t.encodeXML = t.encode = t.decodeStrict = t.decode = void 0;
        var r = n(58455),
          o = n(87198);
        t.decode = function (e, t) {
          return (!t || t <= 0 ? r.decodeXML : r.decodeHTML)(e);
        }, t.decodeStrict = function (e, t) {
          return (!t || t <= 0 ? r.decodeXML : r.decodeHTMLStrict)(e);
        }, t.encode = function (e, t) {
          return (!t || t <= 0 ? o.encodeXML : o.encodeHTML)(e);
        };
        var i = n(87198);
        Object.defineProperty(t, "encodeXML", {
          enumerable: !0,
          get: function () {
            return i.encodeXML;
          }
        }), Object.defineProperty(t, "encodeHTML", {
          enumerable: !0,
          get: function () {
            return i.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeNonAsciiHTML", {
          enumerable: !0,
          get: function () {
            return i.encodeNonAsciiHTML;
          }
        }), Object.defineProperty(t, "escape", {
          enumerable: !0,
          get: function () {
            return i.escape;
          }
        }), Object.defineProperty(t, "escapeUTF8", {
          enumerable: !0,
          get: function () {
            return i.escapeUTF8;
          }
        }), Object.defineProperty(t, "encodeHTML4", {
          enumerable: !0,
          get: function () {
            return i.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeHTML5", {
          enumerable: !0,
          get: function () {
            return i.encodeHTML;
          }
        });
        var a = n(58455);
        Object.defineProperty(t, "decodeXML", {
          enumerable: !0,
          get: function () {
            return a.decodeXML;
          }
        }), Object.defineProperty(t, "decodeHTML", {
          enumerable: !0,
          get: function () {
            return a.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTMLStrict", {
          enumerable: !0,
          get: function () {
            return a.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTML4", {
          enumerable: !0,
          get: function () {
            return a.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML5", {
          enumerable: !0,
          get: function () {
            return a.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML4Strict", {
          enumerable: !0,
          get: function () {
            return a.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTML5Strict", {
          enumerable: !0,
          get: function () {
            return a.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeXMLStrict", {
          enumerable: !0,
          get: function () {
            return a.decodeXML;
          }
        });
      },
      60677: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DomHandler = void 0;
        var i = n(99960),
          a = n(70834);
        o(n(70834), t);
        var s = /\s+/g,
          l = {
            normalizeWhitespace: !1,
            withStartIndices: !1,
            withEndIndices: !1,
            xmlMode: !1
          },
          u = function () {
            function e(e, t, n) {
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, "function" == typeof t && (n = t, t = l), "object" == typeof e && (t = e, e = void 0), this.callback = null != e ? e : null, this.options = null != t ? t : l, this.elementCB = null != n ? n : null;
            }
            return e.prototype.onparserinit = function (e) {
              this.parser = e;
            }, e.prototype.onreset = function () {
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
            }, e.prototype.onend = function () {
              this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
            }, e.prototype.onerror = function (e) {
              this.handleCallback(e);
            }, e.prototype.onclosetag = function () {
              this.lastNode = null;
              var e = this.tagStack.pop();
              this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
            }, e.prototype.onopentag = function (e, t) {
              var n = this.options.xmlMode ? i.ElementType.Tag : void 0,
                r = new a.Element(e, t, void 0, n);
              this.addNode(r), this.tagStack.push(r);
            }, e.prototype.ontext = function (e) {
              var t = this.options.normalizeWhitespace,
                n = this.lastNode;
              if (n && n.type === i.ElementType.Text) t ? n.data = (n.data + e).replace(s, " ") : n.data += e, this.options.withEndIndices && (n.endIndex = this.parser.endIndex);else {
                t && (e = e.replace(s, " "));
                var r = new a.Text(e);
                this.addNode(r), this.lastNode = r;
              }
            }, e.prototype.oncomment = function (e) {
              if (this.lastNode && this.lastNode.type === i.ElementType.Comment) this.lastNode.data += e;else {
                var t = new a.Comment(e);
                this.addNode(t), this.lastNode = t;
              }
            }, e.prototype.oncommentend = function () {
              this.lastNode = null;
            }, e.prototype.oncdatastart = function () {
              var e = new a.Text(""),
                t = new a.NodeWithChildren(i.ElementType.CDATA, [e]);
              this.addNode(t), e.parent = t, this.lastNode = e;
            }, e.prototype.oncdataend = function () {
              this.lastNode = null;
            }, e.prototype.onprocessinginstruction = function (e, t) {
              var n = new a.ProcessingInstruction(e, t);
              this.addNode(n);
            }, e.prototype.handleCallback = function (e) {
              if ("function" == typeof this.callback) this.callback(e, this.dom);else if (e) throw e;
            }, e.prototype.addNode = function (e) {
              var t = this.tagStack[this.tagStack.length - 1],
                n = t.children[t.children.length - 1];
              this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), n && (e.prev = n, n.next = e), e.parent = t, this.lastNode = null;
            }, e;
          }();
        t.DomHandler = u, t.default = u;
      },
      70834: function (e, t, n) {
        "use strict";

        var r,
          o = this && this.__extends || (r = function (e, t) {
            return r = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }, r(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              this.constructor = e;
            }
            r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.cloneNode = t.hasChildren = t.isDocument = t.isDirective = t.isComment = t.isText = t.isCDATA = t.isTag = t.Element = t.Document = t.NodeWithChildren = t.ProcessingInstruction = t.Comment = t.Text = t.DataNode = t.Node = void 0;
        var a = n(99960),
          s = new Map([[a.ElementType.Tag, 1], [a.ElementType.Script, 1], [a.ElementType.Style, 1], [a.ElementType.Directive, 1], [a.ElementType.Text, 3], [a.ElementType.CDATA, 4], [a.ElementType.Comment, 8], [a.ElementType.Root, 9]]),
          l = function () {
            function e(e) {
              this.type = e, this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
            }
            return Object.defineProperty(e.prototype, "nodeType", {
              get: function () {
                var e;
                return null !== (e = s.get(this.type)) && void 0 !== e ? e : 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "parentNode", {
              get: function () {
                return this.parent;
              },
              set: function (e) {
                this.parent = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "previousSibling", {
              get: function () {
                return this.prev;
              },
              set: function (e) {
                this.prev = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "nextSibling", {
              get: function () {
                return this.next;
              },
              set: function (e) {
                this.next = e;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.cloneNode = function (e) {
              return void 0 === e && (e = !1), D(this, e);
            }, e;
          }();
        t.Node = l;
        var u = function (e) {
          function t(t, n) {
            var r = e.call(this, t) || this;
            return r.data = n, r;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeValue", {
            get: function () {
              return this.data;
            },
            set: function (e) {
              this.data = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.DataNode = u;
        var c = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Text, t) || this;
          }
          return o(t, e), t;
        }(u);
        t.Text = c;
        var d = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Comment, t) || this;
          }
          return o(t, e), t;
        }(u);
        t.Comment = d;
        var p = function (e) {
          function t(t, n) {
            var r = e.call(this, a.ElementType.Directive, n) || this;
            return r.name = t, r;
          }
          return o(t, e), t;
        }(u);
        t.ProcessingInstruction = p;
        var h = function (e) {
          function t(t, n) {
            var r = e.call(this, t) || this;
            return r.children = n, r;
          }
          return o(t, e), Object.defineProperty(t.prototype, "firstChild", {
            get: function () {
              var e;
              return null !== (e = this.children[0]) && void 0 !== e ? e : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "lastChild", {
            get: function () {
              return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "childNodes", {
            get: function () {
              return this.children;
            },
            set: function (e) {
              this.children = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.NodeWithChildren = h;
        var f = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Root, t) || this;
          }
          return o(t, e), t;
        }(h);
        t.Document = f;
        var m = function (e) {
          function t(t, n, r, o) {
            void 0 === r && (r = []), void 0 === o && (o = "script" === t ? a.ElementType.Script : "style" === t ? a.ElementType.Style : a.ElementType.Tag);
            var i = e.call(this, o, r) || this;
            return i.name = t, i.attribs = n, i;
          }
          return o(t, e), Object.defineProperty(t.prototype, "tagName", {
            get: function () {
              return this.name;
            },
            set: function (e) {
              this.name = e;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function () {
              var e = this;
              return Object.keys(this.attribs).map(function (t) {
                var n, r;
                return {
                  name: t,
                  value: e.attribs[t],
                  namespace: null === (n = e["x-attribsNamespace"]) || void 0 === n ? void 0 : n[t],
                  prefix: null === (r = e["x-attribsPrefix"]) || void 0 === r ? void 0 : r[t]
                };
              });
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(h);
        function g(e) {
          return (0, a.isTag)(e);
        }
        function v(e) {
          return e.type === a.ElementType.CDATA;
        }
        function y(e) {
          return e.type === a.ElementType.Text;
        }
        function b(e) {
          return e.type === a.ElementType.Comment;
        }
        function w(e) {
          return e.type === a.ElementType.Directive;
        }
        function x(e) {
          return e.type === a.ElementType.Root;
        }
        function D(e, t) {
          var n;
          if (void 0 === t && (t = !1), y(e)) n = new c(e.data);else if (b(e)) n = new d(e.data);else if (g(e)) {
            var r = t ? C(e.children) : [],
              o = new m(e.name, i({}, e.attribs), r);
            r.forEach(function (e) {
              return e.parent = o;
            }), null != e.namespace && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = i({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = i({}, e["x-attribsPrefix"])), n = o;
          } else if (v(e)) {
            r = t ? C(e.children) : [];
            var s = new h(a.ElementType.CDATA, r);
            r.forEach(function (e) {
              return e.parent = s;
            }), n = s;
          } else if (x(e)) {
            r = t ? C(e.children) : [];
            var l = new f(r);
            r.forEach(function (e) {
              return e.parent = l;
            }), e["x-mode"] && (l["x-mode"] = e["x-mode"]), n = l;
          } else {
            if (!w(e)) throw new Error("Not implemented yet: ".concat(e.type));
            var u = new p(e.name, e.data);
            null != e["x-name"] && (u["x-name"] = e["x-name"], u["x-publicId"] = e["x-publicId"], u["x-systemId"] = e["x-systemId"]), n = u;
          }
          return n.startIndex = e.startIndex, n.endIndex = e.endIndex, null != e.sourceCodeLocation && (n.sourceCodeLocation = e.sourceCodeLocation), n;
        }
        function C(e) {
          for (var t = e.map(function (e) {
              return D(e, !0);
            }), n = 1; n < t.length; n++) t[n].prev = t[n - 1], t[n - 1].next = t[n];
          return t;
        }
        t.Element = m, t.isTag = g, t.isCDATA = v, t.isText = y, t.isComment = b, t.isDirective = w, t.isDocument = x, t.hasChildren = function (e) {
          return Object.prototype.hasOwnProperty.call(e, "children");
        }, t.cloneNode = D;
      },
      43876: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFeed = void 0;
        var r = n(40378),
          o = n(6914);
        t.getFeed = function (e) {
          var t = l(d, e);
          return t ? "feed" === t.name ? function (e) {
            var t,
              n = e.children,
              r = {
                type: "atom",
                items: (0, o.getElementsByTagName)("entry", n).map(function (e) {
                  var t,
                    n = e.children,
                    r = {
                      media: s(n)
                    };
                  c(r, "id", "id", n), c(r, "title", "title", n);
                  var o = null === (t = l("link", n)) || void 0 === t ? void 0 : t.attribs.href;
                  o && (r.link = o);
                  var i = u("summary", n) || u("content", n);
                  i && (r.description = i);
                  var a = u("updated", n);
                  return a && (r.pubDate = new Date(a)), r;
                })
              };
            c(r, "id", "id", n), c(r, "title", "title", n);
            var i = null === (t = l("link", n)) || void 0 === t ? void 0 : t.attribs.href;
            i && (r.link = i);
            c(r, "description", "subtitle", n);
            var a = u("updated", n);
            a && (r.updated = new Date(a));
            return c(r, "author", "email", n, !0), r;
          }(t) : function (e) {
            var t,
              n,
              r = null !== (n = null === (t = l("channel", e.children)) || void 0 === t ? void 0 : t.children) && void 0 !== n ? n : [],
              i = {
                type: e.name.substr(0, 3),
                id: "",
                items: (0, o.getElementsByTagName)("item", e.children).map(function (e) {
                  var t = e.children,
                    n = {
                      media: s(t)
                    };
                  c(n, "id", "guid", t), c(n, "title", "title", t), c(n, "link", "link", t), c(n, "description", "description", t);
                  var r = u("pubDate", t);
                  return r && (n.pubDate = new Date(r)), n;
                })
              };
            c(i, "title", "title", r), c(i, "link", "link", r), c(i, "description", "description", r);
            var a = u("lastBuildDate", r);
            a && (i.updated = new Date(a));
            return c(i, "author", "managingEditor", r, !0), i;
          }(t) : null;
        };
        var i = ["url", "type", "lang"],
          a = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
        function s(e) {
          return (0, o.getElementsByTagName)("media:content", e).map(function (e) {
            for (var t = e.attribs, n = {
                medium: t.medium,
                isDefault: !!t.isDefault
              }, r = 0, o = i; r < o.length; r++) {
              t[u = o[r]] && (n[u] = t[u]);
            }
            for (var s = 0, l = a; s < l.length; s++) {
              var u;
              t[u = l[s]] && (n[u] = parseInt(t[u], 10));
            }
            return t.expression && (n.expression = t.expression), n;
          });
        }
        function l(e, t) {
          return (0, o.getElementsByTagName)(e, t, !0, 1)[0];
        }
        function u(e, t, n) {
          return void 0 === n && (n = !1), (0, r.textContent)((0, o.getElementsByTagName)(e, t, n, 1)).trim();
        }
        function c(e, t, n, r, o) {
          void 0 === o && (o = !1);
          var i = u(n, r, o);
          i && (e[t] = i);
        }
        function d(e) {
          return "rss" === e || "feed" === e || "rdf:RDF" === e;
        }
      },
      2283: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.uniqueSort = t.compareDocumentPosition = t.removeSubsets = void 0;
        var r = n(83202);
        function o(e, t) {
          var n = [],
            o = [];
          if (e === t) return 0;
          for (var i = (0, r.hasChildren)(e) ? e : e.parent; i;) n.unshift(i), i = i.parent;
          for (i = (0, r.hasChildren)(t) ? t : t.parent; i;) o.unshift(i), i = i.parent;
          for (var a = Math.min(n.length, o.length), s = 0; s < a && n[s] === o[s];) s++;
          if (0 === s) return 1;
          var l = n[s - 1],
            u = l.children,
            c = n[s],
            d = o[s];
          return u.indexOf(c) > u.indexOf(d) ? l === t ? 20 : 4 : l === e ? 10 : 2;
        }
        t.removeSubsets = function (e) {
          for (var t = e.length; --t >= 0;) {
            var n = e[t];
            if (t > 0 && e.lastIndexOf(n, t - 1) >= 0) e.splice(t, 1);else for (var r = n.parent; r; r = r.parent) if (e.includes(r)) {
              e.splice(t, 1);
              break;
            }
          }
          return e;
        }, t.compareDocumentPosition = o, t.uniqueSort = function (e) {
          return (e = e.filter(function (e, t, n) {
            return !n.includes(e, t + 1);
          })).sort(function (e, t) {
            var n = o(e, t);
            return 2 & n ? -1 : 4 & n ? 1 : 0;
          }), e;
        };
      },
      73425: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n), Object.defineProperty(e, r, {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            });
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, o(n(40378), t), o(n(95536), t), o(n(88191), t), o(n(76643), t), o(n(6914), t), o(n(2283), t), o(n(43876), t);
        var i = n(83202);
        Object.defineProperty(t, "isTag", {
          enumerable: !0,
          get: function () {
            return i.isTag;
          }
        }), Object.defineProperty(t, "isCDATA", {
          enumerable: !0,
          get: function () {
            return i.isCDATA;
          }
        }), Object.defineProperty(t, "isText", {
          enumerable: !0,
          get: function () {
            return i.isText;
          }
        }), Object.defineProperty(t, "isComment", {
          enumerable: !0,
          get: function () {
            return i.isComment;
          }
        }), Object.defineProperty(t, "isDocument", {
          enumerable: !0,
          get: function () {
            return i.isDocument;
          }
        }), Object.defineProperty(t, "hasChildren", {
          enumerable: !0,
          get: function () {
            return i.hasChildren;
          }
        });
      },
      6914: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getElementsByTagType = t.getElementsByTagName = t.getElementById = t.getElements = t.testElement = void 0;
        var r = n(83202),
          o = n(76643),
          i = {
            tag_name: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, r.isTag)(t) && e(t.name);
              } : "*" === e ? r.isTag : function (t) {
                return (0, r.isTag)(t) && t.name === e;
              };
            },
            tag_type: function (e) {
              return "function" == typeof e ? function (t) {
                return e(t.type);
              } : function (t) {
                return t.type === e;
              };
            },
            tag_contains: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, r.isText)(t) && e(t.data);
              } : function (t) {
                return (0, r.isText)(t) && t.data === e;
              };
            }
          };
        function a(e, t) {
          return "function" == typeof t ? function (n) {
            return (0, r.isTag)(n) && t(n.attribs[e]);
          } : function (n) {
            return (0, r.isTag)(n) && n.attribs[e] === t;
          };
        }
        function s(e, t) {
          return function (n) {
            return e(n) || t(n);
          };
        }
        function l(e) {
          var t = Object.keys(e).map(function (t) {
            var n = e[t];
            return Object.prototype.hasOwnProperty.call(i, t) ? i[t](n) : a(t, n);
          });
          return 0 === t.length ? null : t.reduce(s);
        }
        t.testElement = function (e, t) {
          var n = l(e);
          return !n || n(t);
        }, t.getElements = function (e, t, n, r) {
          void 0 === r && (r = 1 / 0);
          var i = l(e);
          return i ? (0, o.filter)(i, t, n, r) : [];
        }, t.getElementById = function (e, t, n) {
          return void 0 === n && (n = !0), Array.isArray(t) || (t = [t]), (0, o.findOne)(a("id", e), t, n);
        }, t.getElementsByTagName = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), (0, o.filter)(i.tag_name(e), t, n, r);
        }, t.getElementsByTagType = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), (0, o.filter)(i.tag_type(e), t, n, r);
        };
      },
      88191: (e, t) => {
        "use strict";

        function n(e) {
          if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
            var t = e.parent.children;
            t.splice(t.lastIndexOf(e), 1);
          }
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prepend = t.prependChild = t.append = t.appendChild = t.replaceElement = t.removeElement = void 0, t.removeElement = n, t.replaceElement = function (e, t) {
          var n = t.prev = e.prev;
          n && (n.next = t);
          var r = t.next = e.next;
          r && (r.prev = t);
          var o = t.parent = e.parent;
          if (o) {
            var i = o.children;
            i[i.lastIndexOf(e)] = t;
          }
        }, t.appendChild = function (e, t) {
          if (n(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
            var r = e.children[e.children.length - 2];
            r.next = t, t.prev = r;
          } else t.prev = null;
        }, t.append = function (e, t) {
          n(t);
          var r = e.parent,
            o = e.next;
          if (t.next = o, t.prev = e, e.next = t, t.parent = r, o) {
            if (o.prev = t, r) {
              var i = r.children;
              i.splice(i.lastIndexOf(o), 0, t);
            }
          } else r && r.children.push(t);
        }, t.prependChild = function (e, t) {
          if (n(t), t.parent = e, t.prev = null, 1 !== e.children.unshift(t)) {
            var r = e.children[1];
            r.prev = t, t.next = r;
          } else t.next = null;
        }, t.prepend = function (e, t) {
          n(t);
          var r = e.parent;
          if (r) {
            var o = r.children;
            o.splice(o.indexOf(e), 0, t);
          }
          e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
        };
      },
      76643: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.findAll = t.existsOne = t.findOne = t.findOneChild = t.find = t.filter = void 0;
        var r = n(83202);
        function o(e, t, n, i) {
          for (var a = [], s = 0, l = t; s < l.length; s++) {
            var u = l[s];
            if (e(u) && (a.push(u), --i <= 0)) break;
            if (n && (0, r.hasChildren)(u) && u.children.length > 0) {
              var c = o(e, u.children, n, i);
              if (a.push.apply(a, c), (i -= c.length) <= 0) break;
            }
          }
          return a;
        }
        t.filter = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), Array.isArray(t) || (t = [t]), o(e, t, n, r);
        }, t.find = o, t.findOneChild = function (e, t) {
          return t.find(e);
        }, t.findOne = function e(t, n, o) {
          void 0 === o && (o = !0);
          for (var i = null, a = 0; a < n.length && !i; a++) {
            var s = n[a];
            (0, r.isTag)(s) && (t(s) ? i = s : o && s.children.length > 0 && (i = e(t, s.children)));
          }
          return i;
        }, t.existsOne = function e(t, n) {
          return n.some(function (n) {
            return (0, r.isTag)(n) && (t(n) || n.children.length > 0 && e(t, n.children));
          });
        }, t.findAll = function (e, t) {
          for (var n, o, i = [], a = t.filter(r.isTag); o = a.shift();) {
            var s = null === (n = o.children) || void 0 === n ? void 0 : n.filter(r.isTag);
            s && s.length > 0 && a.unshift.apply(a, s), e(o) && i.push(o);
          }
          return i;
        };
      },
      40378: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.innerText = t.textContent = t.getText = t.getInnerHTML = t.getOuterHTML = void 0;
        var o = n(83202),
          i = r(n(47125)),
          a = n(99960);
        function s(e, t) {
          return (0, i.default)(e, t);
        }
        t.getOuterHTML = s, t.getInnerHTML = function (e, t) {
          return (0, o.hasChildren)(e) ? e.children.map(function (e) {
            return s(e, t);
          }).join("") : "";
        }, t.getText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.isTag)(t) ? "br" === t.name ? "\n" : e(t.children) : (0, o.isCDATA)(t) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        }, t.textContent = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.hasChildren)(t) && !(0, o.isComment)(t) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        }, t.innerText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.hasChildren)(t) && (t.type === a.ElementType.Tag || (0, o.isCDATA)(t)) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        };
      },
      95536: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prevElementSibling = t.nextElementSibling = t.getName = t.hasAttrib = t.getAttributeValue = t.getSiblings = t.getParent = t.getChildren = void 0;
        var r = n(83202),
          o = [];
        function i(e) {
          var t;
          return null !== (t = e.children) && void 0 !== t ? t : o;
        }
        function a(e) {
          return e.parent || null;
        }
        t.getChildren = i, t.getParent = a, t.getSiblings = function (e) {
          var t = a(e);
          if (null != t) return i(t);
          for (var n = [e], r = e.prev, o = e.next; null != r;) n.unshift(r), r = r.prev;
          for (; null != o;) n.push(o), o = o.next;
          return n;
        }, t.getAttributeValue = function (e, t) {
          var n;
          return null === (n = e.attribs) || void 0 === n ? void 0 : n[t];
        }, t.hasAttrib = function (e, t) {
          return null != e.attribs && Object.prototype.hasOwnProperty.call(e.attribs, t) && null != e.attribs[t];
        }, t.getName = function (e) {
          return e.name;
        }, t.nextElementSibling = function (e) {
          for (var t = e.next; null !== t && !(0, r.isTag)(t);) t = t.next;
          return t;
        }, t.prevElementSibling = function (e) {
          for (var t = e.prev; null !== t && !(0, r.isTag)(t);) t = t.prev;
          return t;
        };
      },
      83202: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n), Object.defineProperty(e, r, {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            });
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DomHandler = void 0;
        var i = n(99960),
          a = n(59303);
        o(n(59303), t);
        var s = /\s+/g,
          l = {
            normalizeWhitespace: !1,
            withStartIndices: !1,
            withEndIndices: !1
          },
          u = function () {
            function e(e, t, n) {
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, "function" == typeof t && (n = t, t = l), "object" == typeof e && (t = e, e = void 0), this.callback = null != e ? e : null, this.options = null != t ? t : l, this.elementCB = null != n ? n : null;
            }
            return e.prototype.onparserinit = function (e) {
              this.parser = e;
            }, e.prototype.onreset = function () {
              var e;
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null !== (e = this.parser) && void 0 !== e ? e : null;
            }, e.prototype.onend = function () {
              this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
            }, e.prototype.onerror = function (e) {
              this.handleCallback(e);
            }, e.prototype.onclosetag = function () {
              this.lastNode = null;
              var e = this.tagStack.pop();
              this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
            }, e.prototype.onopentag = function (e, t) {
              var n = this.options.xmlMode ? i.ElementType.Tag : void 0,
                r = new a.Element(e, t, void 0, n);
              this.addNode(r), this.tagStack.push(r);
            }, e.prototype.ontext = function (e) {
              var t = this.options.normalizeWhitespace,
                n = this.lastNode;
              if (n && n.type === i.ElementType.Text) t ? n.data = (n.data + e).replace(s, " ") : n.data += e;else {
                t && (e = e.replace(s, " "));
                var r = new a.Text(e);
                this.addNode(r), this.lastNode = r;
              }
            }, e.prototype.oncomment = function (e) {
              if (this.lastNode && this.lastNode.type === i.ElementType.Comment) this.lastNode.data += e;else {
                var t = new a.Comment(e);
                this.addNode(t), this.lastNode = t;
              }
            }, e.prototype.oncommentend = function () {
              this.lastNode = null;
            }, e.prototype.oncdatastart = function () {
              var e = new a.Text(""),
                t = new a.NodeWithChildren(i.ElementType.CDATA, [e]);
              this.addNode(t), e.parent = t, this.lastNode = e;
            }, e.prototype.oncdataend = function () {
              this.lastNode = null;
            }, e.prototype.onprocessinginstruction = function (e, t) {
              var n = new a.ProcessingInstruction(e, t);
              this.addNode(n);
            }, e.prototype.handleCallback = function (e) {
              if ("function" == typeof this.callback) this.callback(e, this.dom);else if (e) throw e;
            }, e.prototype.addNode = function (e) {
              var t = this.tagStack[this.tagStack.length - 1],
                n = t.children[t.children.length - 1];
              this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), n && (e.prev = n, n.next = e), e.parent = t, this.lastNode = null;
            }, e;
          }();
        t.DomHandler = u, t.default = u;
      },
      59303: function (e, t, n) {
        "use strict";

        var r,
          o = this && this.__extends || (r = function (e, t) {
            return r = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }, r(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              this.constructor = e;
            }
            r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.cloneNode = t.hasChildren = t.isDocument = t.isDirective = t.isComment = t.isText = t.isCDATA = t.isTag = t.Element = t.Document = t.NodeWithChildren = t.ProcessingInstruction = t.Comment = t.Text = t.DataNode = t.Node = void 0;
        var a = n(99960),
          s = new Map([[a.ElementType.Tag, 1], [a.ElementType.Script, 1], [a.ElementType.Style, 1], [a.ElementType.Directive, 1], [a.ElementType.Text, 3], [a.ElementType.CDATA, 4], [a.ElementType.Comment, 8], [a.ElementType.Root, 9]]),
          l = function () {
            function e(e) {
              this.type = e, this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
            }
            return Object.defineProperty(e.prototype, "nodeType", {
              get: function () {
                var e;
                return null !== (e = s.get(this.type)) && void 0 !== e ? e : 1;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "parentNode", {
              get: function () {
                return this.parent;
              },
              set: function (e) {
                this.parent = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "previousSibling", {
              get: function () {
                return this.prev;
              },
              set: function (e) {
                this.prev = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "nextSibling", {
              get: function () {
                return this.next;
              },
              set: function (e) {
                this.next = e;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.cloneNode = function (e) {
              return void 0 === e && (e = !1), D(this, e);
            }, e;
          }();
        t.Node = l;
        var u = function (e) {
          function t(t, n) {
            var r = e.call(this, t) || this;
            return r.data = n, r;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeValue", {
            get: function () {
              return this.data;
            },
            set: function (e) {
              this.data = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.DataNode = u;
        var c = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Text, t) || this;
          }
          return o(t, e), t;
        }(u);
        t.Text = c;
        var d = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Comment, t) || this;
          }
          return o(t, e), t;
        }(u);
        t.Comment = d;
        var p = function (e) {
          function t(t, n) {
            var r = e.call(this, a.ElementType.Directive, n) || this;
            return r.name = t, r;
          }
          return o(t, e), t;
        }(u);
        t.ProcessingInstruction = p;
        var h = function (e) {
          function t(t, n) {
            var r = e.call(this, t) || this;
            return r.children = n, r;
          }
          return o(t, e), Object.defineProperty(t.prototype, "firstChild", {
            get: function () {
              var e;
              return null !== (e = this.children[0]) && void 0 !== e ? e : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "lastChild", {
            get: function () {
              return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "childNodes", {
            get: function () {
              return this.children;
            },
            set: function (e) {
              this.children = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.NodeWithChildren = h;
        var f = function (e) {
          function t(t) {
            return e.call(this, a.ElementType.Root, t) || this;
          }
          return o(t, e), t;
        }(h);
        t.Document = f;
        var m = function (e) {
          function t(t, n, r, o) {
            void 0 === r && (r = []), void 0 === o && (o = "script" === t ? a.ElementType.Script : "style" === t ? a.ElementType.Style : a.ElementType.Tag);
            var i = e.call(this, o, r) || this;
            return i.name = t, i.attribs = n, i;
          }
          return o(t, e), Object.defineProperty(t.prototype, "tagName", {
            get: function () {
              return this.name;
            },
            set: function (e) {
              this.name = e;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function () {
              var e = this;
              return Object.keys(this.attribs).map(function (t) {
                var n, r;
                return {
                  name: t,
                  value: e.attribs[t],
                  namespace: null === (n = e["x-attribsNamespace"]) || void 0 === n ? void 0 : n[t],
                  prefix: null === (r = e["x-attribsPrefix"]) || void 0 === r ? void 0 : r[t]
                };
              });
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(h);
        function g(e) {
          return a.isTag(e);
        }
        function v(e) {
          return e.type === a.ElementType.CDATA;
        }
        function y(e) {
          return e.type === a.ElementType.Text;
        }
        function b(e) {
          return e.type === a.ElementType.Comment;
        }
        function w(e) {
          return e.type === a.ElementType.Directive;
        }
        function x(e) {
          return e.type === a.ElementType.Root;
        }
        function D(e, t) {
          var n;
          if (void 0 === t && (t = !1), y(e)) n = new c(e.data);else if (b(e)) n = new d(e.data);else if (g(e)) {
            var r = t ? C(e.children) : [],
              o = new m(e.name, i({}, e.attribs), r);
            r.forEach(function (e) {
              return e.parent = o;
            }), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = i({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = i({}, e["x-attribsPrefix"])), n = o;
          } else if (v(e)) {
            r = t ? C(e.children) : [];
            var s = new h(a.ElementType.CDATA, r);
            r.forEach(function (e) {
              return e.parent = s;
            }), n = s;
          } else if (x(e)) {
            r = t ? C(e.children) : [];
            var l = new f(r);
            r.forEach(function (e) {
              return e.parent = l;
            }), e["x-mode"] && (l["x-mode"] = e["x-mode"]), n = l;
          } else {
            if (!w(e)) throw new Error("Not implemented yet: " + e.type);
            var u = new p(e.name, e.data);
            null != e["x-name"] && (u["x-name"] = e["x-name"], u["x-publicId"] = e["x-publicId"], u["x-systemId"] = e["x-systemId"]), n = u;
          }
          return n.startIndex = e.startIndex, n.endIndex = e.endIndex, n;
        }
        function C(e) {
          for (var t = e.map(function (e) {
              return D(e, !0);
            }), n = 1; n < t.length; n++) t[n].prev = t[n - 1], t[n - 1].next = t[n];
          return t;
        }
        t.Element = m, t.isTag = g, t.isCDATA = v, t.isText = y, t.isComment = b, t.isDirective = w, t.isDocument = x, t.hasChildren = function (e) {
          return Object.prototype.hasOwnProperty.call(e, "children");
        }, t.cloneNode = D;
      },
      38911: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          createEditor: () => Ir,
          createHyperscript: () => jr,
          createText: () => Or,
          jsx: () => Lr
        });
        var r = n(35583);
        function o(e) {
          for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
          throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function (e) {
            return "'" + e + "'";
          }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
        }
        function i(e) {
          return !!e && !!e[Z];
        }
        function a(e) {
          var t;
          return !!e && (function (e) {
            if (!e || "object" != typeof e) return !1;
            var t = Object.getPrototypeOf(e);
            if (null === t) return !0;
            var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
            return n === Object || "function" == typeof n && Function.toString.call(n) === $;
          }(e) || Array.isArray(e) || !!e[U] || !!(null === (t = e.constructor) || void 0 === t ? void 0 : t[U]) || h(e) || f(e));
        }
        function s(e, t, n) {
          void 0 === n && (n = !1), 0 === l(e) ? (n ? Object.keys : G)(e).forEach(function (r) {
            n && "symbol" == typeof r || t(r, e[r], e);
          }) : e.forEach(function (n, r) {
            return t(r, n, e);
          });
        }
        function l(e) {
          var t = e[Z];
          return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : h(e) ? 2 : f(e) ? 3 : 0;
        }
        function u(e, t) {
          return 2 === l(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
        }
        function c(e, t) {
          return 2 === l(e) ? e.get(t) : e[t];
        }
        function d(e, t, n) {
          var r = l(e);
          2 === r ? e.set(t, n) : 3 === r ? (e.delete(t), e.add(n)) : e[t] = n;
        }
        function p(e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
        }
        function h(e) {
          return V && e instanceof Map;
        }
        function f(e) {
          return K && e instanceof Set;
        }
        function m(e) {
          return e.o || e.t;
        }
        function g(e) {
          if (Array.isArray(e)) return Array.prototype.slice.call(e);
          var t = W(e);
          delete t[Z];
          for (var n = G(t), r = 0; r < n.length; r++) {
            var o = n[r],
              i = t[o];
            !1 === i.writable && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[o] = {
              configurable: !0,
              writable: !0,
              enumerable: i.enumerable,
              value: e[o]
            });
          }
          return Object.create(Object.getPrototypeOf(e), t);
        }
        function v(e, t) {
          return void 0 === t && (t = !1), b(e) || i(e) || !a(e) || (l(e) > 1 && (e.set = e.add = e.clear = e.delete = y), Object.freeze(e), t && s(e, function (e, t) {
            return v(t, !0);
          }, !0)), e;
        }
        function y() {
          o(2);
        }
        function b(e) {
          return null == e || "object" != typeof e || Object.isFrozen(e);
        }
        function w(e) {
          var t = Y[e];
          return t || o(18, e), t;
        }
        function x() {
          return N;
        }
        function D(e, t) {
          t && (w("Patches"), e.u = [], e.s = [], e.v = t);
        }
        function C(e) {
          S(e), e.p.forEach(_), e.p = null;
        }
        function S(e) {
          e === N && (N = e.l);
        }
        function E(e) {
          return N = {
            p: [],
            l: N,
            h: e,
            m: !0,
            _: 0
          };
        }
        function _(e) {
          var t = e[Z];
          0 === t.i || 1 === t.i ? t.j() : t.O = !0;
        }
        function P(e, t) {
          t._ = t.p.length;
          var n = t.p[0],
            r = void 0 !== e && e !== n;
          return t.h.g || w("ES5").S(t, e, r), r ? (n[Z].P && (C(t), o(4)), a(e) && (e = k(t, e), t.l || z(t, e)), t.u && w("Patches").M(n[Z].t, e, t.u, t.s)) : e = k(t, n, []), C(t), t.u && t.v(t.u, t.s), e !== H ? e : void 0;
        }
        function k(e, t, n) {
          if (b(t)) return t;
          var r = t[Z];
          if (!r) return s(t, function (o, i) {
            return A(e, r, t, o, i, n);
          }, !0), t;
          if (r.A !== e) return t;
          if (!r.P) return z(e, r.t, !0), r.t;
          if (!r.I) {
            r.I = !0, r.A._--;
            var o = 4 === r.i || 5 === r.i ? r.o = g(r.k) : r.o;
            s(3 === r.i ? new Set(o) : o, function (t, i) {
              return A(e, r, o, t, i, n);
            }), z(e, o, !1), n && e.u && w("Patches").R(r, n, e.u, e.s);
          }
          return r.o;
        }
        function A(e, t, n, r, o, s) {
          if (i(o)) {
            var l = k(e, o, s && t && 3 !== t.i && !u(t.D, r) ? s.concat(r) : void 0);
            if (d(n, r, l), !i(l)) return;
            e.m = !1;
          }
          if (a(o) && !b(o)) {
            if (!e.h.F && e._ < 1) return;
            k(e, o), t && t.A.l || z(e, o);
          }
        }
        function z(e, t, n) {
          void 0 === n && (n = !1), e.h.F && e.m && v(t, n);
        }
        function T(e, t) {
          var n = e[Z];
          return (n ? m(n) : e)[t];
        }
        function O(e, t) {
          if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
            var r = Object.getOwnPropertyDescriptor(n, t);
            if (r) return r;
            n = Object.getPrototypeOf(n);
          }
        }
        function I(e) {
          e.P || (e.P = !0, e.l && I(e.l));
        }
        function F(e) {
          e.o || (e.o = g(e.t));
        }
        function M(e, t, n) {
          var r = h(t) ? w("MapSet").N(t, n) : f(t) ? w("MapSet").T(t, n) : e.g ? function (e, t) {
            var n = Array.isArray(e),
              r = {
                i: n ? 1 : 0,
                A: t ? t.A : x(),
                P: !1,
                I: !1,
                D: {},
                l: t,
                t: e,
                k: null,
                o: null,
                j: null,
                C: !1
              },
              o = r,
              i = X;
            n && (o = [r], i = Q);
            var a = Proxy.revocable(o, i),
              s = a.revoke,
              l = a.proxy;
            return r.k = l, r.j = s, l;
          }(t, n) : w("ES5").J(t, n);
          return (n ? n.A : x()).p.push(r), r;
        }
        function R(e) {
          return i(e) || o(22, e), function e(t) {
            if (!a(t)) return t;
            var n,
              r = t[Z],
              o = l(t);
            if (r) {
              if (!r.P && (r.i < 4 || !w("ES5").K(r))) return r.t;
              r.I = !0, n = j(t, o), r.I = !1;
            } else n = j(t, o);
            return s(n, function (t, o) {
              r && c(r.t, t) === o || d(n, t, e(o));
            }), 3 === o ? new Set(n) : n;
          }(e);
        }
        function j(e, t) {
          switch (t) {
            case 2:
              return new Map(e);
            case 3:
              return Array.from(e);
          }
          return g(e);
        }
        var B,
          N,
          L = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"),
          V = "undefined" != typeof Map,
          K = "undefined" != typeof Set,
          q = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect,
          H = L ? Symbol.for("immer-nothing") : ((B = {})["immer-nothing"] = !0, B),
          U = L ? Symbol.for("immer-draftable") : "__$immer_draftable",
          Z = L ? Symbol.for("immer-state") : "__$immer_state",
          $ = ("undefined" != typeof Symbol && Symbol.iterator, "" + Object.prototype.constructor),
          G = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function (e) {
            return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
          } : Object.getOwnPropertyNames,
          W = Object.getOwnPropertyDescriptors || function (e) {
            var t = {};
            return G(e).forEach(function (n) {
              t[n] = Object.getOwnPropertyDescriptor(e, n);
            }), t;
          },
          Y = {},
          X = {
            get: function (e, t) {
              if (t === Z) return e;
              var n = m(e);
              if (!u(n, t)) return function (e, t, n) {
                var r,
                  o = O(t, n);
                return o ? "value" in o ? o.value : null === (r = o.get) || void 0 === r ? void 0 : r.call(e.k) : void 0;
              }(e, n, t);
              var r = n[t];
              return e.I || !a(r) ? r : r === T(e.t, t) ? (F(e), e.o[t] = M(e.A.h, r, e)) : r;
            },
            has: function (e, t) {
              return t in m(e);
            },
            ownKeys: function (e) {
              return Reflect.ownKeys(m(e));
            },
            set: function (e, t, n) {
              var r = O(m(e), t);
              if (null == r ? void 0 : r.set) return r.set.call(e.k, n), !0;
              if (!e.P) {
                var o = T(m(e), t),
                  i = null == o ? void 0 : o[Z];
                if (i && i.t === n) return e.o[t] = n, e.D[t] = !1, !0;
                if (p(n, o) && (void 0 !== n || u(e.t, t))) return !0;
                F(e), I(e);
              }
              return e.o[t] === n && "number" != typeof n && (void 0 !== n || t in e.o) || (e.o[t] = n, e.D[t] = !0, !0);
            },
            deleteProperty: function (e, t) {
              return void 0 !== T(e.t, t) || t in e.t ? (e.D[t] = !1, F(e), I(e)) : delete e.D[t], e.o && delete e.o[t], !0;
            },
            getOwnPropertyDescriptor: function (e, t) {
              var n = m(e),
                r = Reflect.getOwnPropertyDescriptor(n, t);
              return r ? {
                writable: !0,
                configurable: 1 !== e.i || "length" !== t,
                enumerable: r.enumerable,
                value: n[t]
              } : r;
            },
            defineProperty: function () {
              o(11);
            },
            getPrototypeOf: function (e) {
              return Object.getPrototypeOf(e.t);
            },
            setPrototypeOf: function () {
              o(12);
            }
          },
          Q = {};
        s(X, function (e, t) {
          Q[e] = function () {
            return arguments[0] = arguments[0][0], t.apply(this, arguments);
          };
        }), Q.deleteProperty = function (e, t) {
          return Q.set.call(this, e, t, void 0);
        }, Q.set = function (e, t, n) {
          return X.set.call(this, e[0], t, n, e[0]);
        };
        var J = function () {
            function e(e) {
              var t = this;
              this.g = q, this.F = !0, this.produce = function (e, n, r) {
                if ("function" == typeof e && "function" != typeof n) {
                  var i = n;
                  n = e;
                  var s = t;
                  return function (e) {
                    var t = this;
                    void 0 === e && (e = i);
                    for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++) o[a - 1] = arguments[a];
                    return s.produce(e, function (e) {
                      var r;
                      return (r = n).call.apply(r, [t, e].concat(o));
                    });
                  };
                }
                var l;
                if ("function" != typeof n && o(6), void 0 !== r && "function" != typeof r && o(7), a(e)) {
                  var u = E(t),
                    c = M(t, e, void 0),
                    d = !0;
                  try {
                    l = n(c), d = !1;
                  } finally {
                    d ? C(u) : S(u);
                  }
                  return "undefined" != typeof Promise && l instanceof Promise ? l.then(function (e) {
                    return D(u, r), P(e, u);
                  }, function (e) {
                    throw C(u), e;
                  }) : (D(u, r), P(l, u));
                }
                if (!e || "object" != typeof e) {
                  if (void 0 === (l = n(e)) && (l = e), l === H && (l = void 0), t.F && v(l, !0), r) {
                    var p = [],
                      h = [];
                    w("Patches").M(e, l, p, h), r(p, h);
                  }
                  return l;
                }
                o(21, e);
              }, this.produceWithPatches = function (e, n) {
                if ("function" == typeof e) return function (n) {
                  for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) o[i - 1] = arguments[i];
                  return t.produceWithPatches(n, function (t) {
                    return e.apply(void 0, [t].concat(o));
                  });
                };
                var r,
                  o,
                  i = t.produce(e, n, function (e, t) {
                    r = e, o = t;
                  });
                return "undefined" != typeof Promise && i instanceof Promise ? i.then(function (e) {
                  return [e, r, o];
                }) : [i, r, o];
              }, "boolean" == typeof (null == e ? void 0 : e.useProxies) && this.setUseProxies(e.useProxies), "boolean" == typeof (null == e ? void 0 : e.autoFreeze) && this.setAutoFreeze(e.autoFreeze);
            }
            var t = e.prototype;
            return t.createDraft = function (e) {
              a(e) || o(8), i(e) && (e = R(e));
              var t = E(this),
                n = M(this, e, void 0);
              return n[Z].C = !0, S(t), n;
            }, t.finishDraft = function (e, t) {
              var n = (e && e[Z]).A;
              return D(n, t), P(void 0, n);
            }, t.setAutoFreeze = function (e) {
              this.F = e;
            }, t.setUseProxies = function (e) {
              e && !q && o(20), this.g = e;
            }, t.applyPatches = function (e, t) {
              var n;
              for (n = t.length - 1; n >= 0; n--) {
                var r = t[n];
                if (0 === r.path.length && "replace" === r.op) {
                  e = r.value;
                  break;
                }
              }
              n > -1 && (t = t.slice(n + 1));
              var o = w("Patches").$;
              return i(e) ? o(e, t) : this.produce(e, function (e) {
                return o(e, t);
              });
            }, e;
          }(),
          ee = new J(),
          te = ee.produce,
          ne = (ee.produceWithPatches.bind(ee), ee.setAutoFreeze.bind(ee), ee.setUseProxies.bind(ee), ee.applyPatches.bind(ee), ee.createDraft.bind(ee)),
          re = ee.finishDraft.bind(ee);
        var oe = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = fe.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          ie = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = Le.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          ae = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = Ee.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          se = new WeakMap(),
          le = new WeakMap(),
          ue = new WeakMap(),
          ce = new WeakMap(),
          de = new WeakMap(),
          pe = new WeakMap(),
          he = new WeakMap(),
          fe = {
            ancestors(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                r = fe.levels(e, t);
              return r = n ? r.slice(1) : r.slice(0, -1);
            },
            common(e, t) {
              for (var n = [], r = 0; r < e.length && r < t.length; r++) {
                var o = e[r];
                if (o !== t[r]) break;
                n.push(o);
              }
              return n;
            },
            compare(e, t) {
              for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
                if (e[r] < t[r]) return -1;
                if (e[r] > t[r]) return 1;
              }
              return 0;
            },
            endsAfter(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return fe.equals(r, o) && i > a;
            },
            endsAt(e, t) {
              var n = e.length,
                r = e.slice(0, n),
                o = t.slice(0, n);
              return fe.equals(r, o);
            },
            endsBefore(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return fe.equals(r, o) && i < a;
            },
            equals: (e, t) => e.length === t.length && e.every((e, n) => e === t[n]),
            hasPrevious: e => e[e.length - 1] > 0,
            isAfter: (e, t) => 1 === fe.compare(e, t),
            isAncestor: (e, t) => e.length < t.length && 0 === fe.compare(e, t),
            isBefore: (e, t) => -1 === fe.compare(e, t),
            isChild: (e, t) => e.length === t.length + 1 && 0 === fe.compare(e, t),
            isCommon: (e, t) => e.length <= t.length && 0 === fe.compare(e, t),
            isDescendant: (e, t) => e.length > t.length && 0 === fe.compare(e, t),
            isParent: (e, t) => e.length + 1 === t.length && 0 === fe.compare(e, t),
            isPath: e => Array.isArray(e) && (0 === e.length || "number" == typeof e[0]),
            isSibling(e, t) {
              if (e.length !== t.length) return !1;
              var n = e.slice(0, -1),
                r = t.slice(0, -1);
              return e[e.length - 1] !== t[t.length - 1] && fe.equals(n, r);
            },
            levels(e) {
              for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
                  reverse: n = !1
                } = t, r = [], o = 0; o <= e.length; o++) r.push(e.slice(0, o));
              return n && r.reverse(), r;
            },
            next(e) {
              if (0 === e.length) throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
              var t = e[e.length - 1];
              return e.slice(0, -1).concat(t + 1);
            },
            operationCanTransformPath(e) {
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                case "merge_node":
                case "split_node":
                case "move_node":
                  return !0;
                default:
                  return !1;
              }
            },
            parent(e) {
              if (0 === e.length) throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
              return e.slice(0, -1);
            },
            previous(e) {
              if (0 === e.length) throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
              var t = e[e.length - 1];
              if (t <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
              return e.slice(0, -1).concat(t - 1);
            },
            relative(e, t) {
              if (!fe.isAncestor(t, e) && !fe.equals(e, t)) throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
              return e.slice(t.length);
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (!e) return null;
              var r = [...e],
                {
                  affinity: o = "forward"
                } = n;
              if (0 === e.length) return r;
              switch (t.type) {
                case "insert_node":
                  var {
                    path: i
                  } = t;
                  (fe.equals(i, r) || fe.endsBefore(i, r) || fe.isAncestor(i, r)) && (r[i.length - 1] += 1);
                  break;
                case "remove_node":
                  var {
                    path: a
                  } = t;
                  if (fe.equals(a, r) || fe.isAncestor(a, r)) return null;
                  fe.endsBefore(a, r) && (r[a.length - 1] -= 1);
                  break;
                case "merge_node":
                  var {
                    path: s,
                    position: l
                  } = t;
                  fe.equals(s, r) || fe.endsBefore(s, r) ? r[s.length - 1] -= 1 : fe.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += l);
                  break;
                case "split_node":
                  var {
                    path: u,
                    position: c
                  } = t;
                  if (fe.equals(u, r)) {
                    if ("forward" === o) r[r.length - 1] += 1;else if ("backward" !== o) return null;
                  } else fe.endsBefore(u, r) ? r[u.length - 1] += 1 : fe.isAncestor(u, r) && e[u.length] >= c && (r[u.length - 1] += 1, r[u.length] -= c);
                  break;
                case "move_node":
                  var {
                    path: d,
                    newPath: p
                  } = t;
                  if (fe.equals(d, p)) return r;
                  if (fe.isAncestor(d, r) || fe.equals(d, r)) {
                    var h = p.slice();
                    return fe.endsBefore(d, p) && d.length < p.length && (h[d.length - 1] -= 1), h.concat(r.slice(d.length));
                  }
                  fe.isSibling(d, p) && (fe.isAncestor(p, r) || fe.equals(p, r)) ? fe.endsBefore(d, r) ? r[d.length - 1] -= 1 : r[d.length - 1] += 1 : fe.endsBefore(p, r) || fe.equals(p, r) || fe.isAncestor(p, r) ? (fe.endsBefore(d, r) && (r[d.length - 1] -= 1), r[p.length - 1] += 1) : fe.endsBefore(d, r) && (fe.equals(p, r) && (r[p.length - 1] += 1), r[d.length - 1] -= 1);
              }
              return r;
            }
          };
        function me(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function ge(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ve(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ge(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ge(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var ye = {
            transform(e, t) {
              e.children = ne(e.children);
              var n = e.selection && ne(e.selection);
              try {
                n = ((e, t, n) => {
                  switch (n.type) {
                    case "insert_node":
                      var {
                          path: r,
                          node: o
                        } = n,
                        i = Te.parent(e, r),
                        a = r[r.length - 1];
                      if (a > i.children.length) throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
                      if (i.children.splice(a, 0, o), t) for (var [s, l] of Ee.points(t)) t[l] = Le.transform(s, n);
                      break;
                    case "insert_text":
                      var {
                        path: u,
                        offset: c,
                        text: d
                      } = n;
                      if (0 === d.length) break;
                      var p = Te.leaf(e, u),
                        h = p.text.slice(0, c),
                        f = p.text.slice(c);
                      if (p.text = h + d + f, t) for (var [m, g] of Ee.points(t)) t[g] = Le.transform(m, n);
                      break;
                    case "merge_node":
                      var {
                          path: v
                        } = n,
                        y = Te.get(e, v),
                        b = fe.previous(v),
                        w = Te.get(e, b),
                        x = Te.parent(e, v),
                        D = v[v.length - 1];
                      if (Ge.isText(y) && Ge.isText(w)) w.text += y.text;else {
                        if (Ge.isText(y) || Ge.isText(w)) throw new Error('Cannot apply a "merge_node" operation at path ['.concat(v, "] to nodes of different interfaces: ").concat(Ke.stringify(y), " ").concat(Ke.stringify(w)));
                        w.children.push(...y.children);
                      }
                      if (x.children.splice(D, 1), t) for (var [C, S] of Ee.points(t)) t[S] = Le.transform(C, n);
                      break;
                    case "move_node":
                      var {
                        path: E,
                        newPath: _
                      } = n;
                      if (fe.isAncestor(E, _)) throw new Error("Cannot move a path [".concat(E, "] to new path [").concat(_, "] because the destination is inside itself."));
                      var P = Te.get(e, E),
                        k = Te.parent(e, E),
                        A = E[E.length - 1];
                      k.children.splice(A, 1);
                      var z = fe.transform(E, n),
                        T = Te.get(e, fe.parent(z)),
                        O = z[z.length - 1];
                      if (T.children.splice(O, 0, P), t) for (var [I, F] of Ee.points(t)) t[F] = Le.transform(I, n);
                      break;
                    case "remove_node":
                      var {
                          path: M
                        } = n,
                        R = M[M.length - 1];
                      if (Te.parent(e, M).children.splice(R, 1), t) for (var [j, B] of Ee.points(t)) {
                        var N = Le.transform(j, n);
                        if (null != t && null != N) t[B] = N;else {
                          var L = void 0,
                            V = void 0;
                          for (var [K, q] of Te.texts(e)) {
                            if (-1 !== fe.compare(q, M)) {
                              V = [K, q];
                              break;
                            }
                            L = [K, q];
                          }
                          var H = !1;
                          L && V && (H = fe.equals(V[1], M) ? !fe.hasPrevious(V[1]) : fe.common(L[1], M).length < fe.common(V[1], M).length), L && !H ? (j.path = L[1], j.offset = L[0].text.length) : V ? (j.path = V[1], j.offset = 0) : t = null;
                        }
                      }
                      break;
                    case "remove_text":
                      var {
                        path: U,
                        offset: Z,
                        text: $
                      } = n;
                      if (0 === $.length) break;
                      var G = Te.leaf(e, U),
                        W = G.text.slice(0, Z),
                        Y = G.text.slice(Z + $.length);
                      if (G.text = W + Y, t) for (var [X, Q] of Ee.points(t)) t[Q] = Le.transform(X, n);
                      break;
                    case "set_node":
                      var {
                        path: J,
                        properties: ee,
                        newProperties: te
                      } = n;
                      if (0 === J.length) throw new Error("Cannot set properties on the root node!");
                      var ne = Te.get(e, J);
                      for (var re in te) {
                        if ("children" === re || "text" === re) throw new Error('Cannot set the "'.concat(re, '" property of nodes!'));
                        var oe = te[re];
                        null == oe ? delete ne[re] : ne[re] = oe;
                      }
                      for (var ie in ee) te.hasOwnProperty(ie) || delete ne[ie];
                      break;
                    case "set_selection":
                      var {
                        newProperties: ae
                      } = n;
                      if (null == ae) t = ae;else {
                        if (null == t) {
                          if (!Ee.isRange(ae)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(Ke.stringify(ae), " when there is no current selection."));
                          t = ve({}, ae);
                        }
                        for (var se in ae) {
                          var le = ae[se];
                          if (null == le) {
                            if ("anchor" === se || "focus" === se) throw new Error('Cannot remove the "'.concat(se, '" selection property'));
                            delete t[se];
                          } else t[se] = le;
                        }
                      }
                      break;
                    case "split_node":
                      var {
                        path: ue,
                        position: ce,
                        properties: de
                      } = n;
                      if (0 === ue.length) throw new Error('Cannot apply a "split_node" operation at path ['.concat(ue, "] because the root node cannot be split."));
                      var pe,
                        he = Te.get(e, ue),
                        me = Te.parent(e, ue),
                        ge = ue[ue.length - 1];
                      if (Ge.isText(he)) {
                        var ye = he.text.slice(0, ce),
                          be = he.text.slice(ce);
                        he.text = ye, pe = ve(ve({}, de), {}, {
                          text: be
                        });
                      } else {
                        var we = he.children.slice(0, ce),
                          xe = he.children.slice(ce);
                        he.children = we, pe = ve(ve({}, de), {}, {
                          children: xe
                        });
                      }
                      if (me.children.splice(ge + 1, 0, pe), t) for (var [De, Ce] of Ee.points(t)) t[Ce] = Le.transform(De, n);
                  }
                  return t;
                })(e, n, t);
              } finally {
                e.children = re(e.children), e.selection = n ? i(n) ? re(n) : n : null;
              }
            }
          },
          be = {
            insertNodes(e, t, n) {
              e.insertNodes(t, n);
            },
            liftNodes(e, t) {
              e.liftNodes(t);
            },
            mergeNodes(e, t) {
              e.mergeNodes(t);
            },
            moveNodes(e, t) {
              e.moveNodes(t);
            },
            removeNodes(e, t) {
              e.removeNodes(t);
            },
            setNodes(e, t, n) {
              e.setNodes(t, n);
            },
            splitNodes(e, t) {
              e.splitNodes(t);
            },
            unsetNodes(e, t, n) {
              e.unsetNodes(t, n);
            },
            unwrapNodes(e, t) {
              e.unwrapNodes(t);
            },
            wrapNodes(e, t, n) {
              e.wrapNodes(t, n);
            }
          },
          we = {
            collapse(e, t) {
              e.collapse(t);
            },
            deselect(e) {
              e.deselect();
            },
            move(e, t) {
              e.move(t);
            },
            select(e, t) {
              e.select(t);
            },
            setPoint(e, t, n) {
              e.setPoint(t, n);
            },
            setSelection(e, t) {
              e.setSelection(t);
            }
          },
          xe = (e, t) => {
            for (var n in e) {
              var o = e[n],
                i = t[n];
              if ((0, r.P)(o) && (0, r.P)(i)) {
                if (!xe(o, i)) return !1;
              } else if (Array.isArray(o) && Array.isArray(i)) {
                if (o.length !== i.length) return !1;
                for (var a = 0; a < o.length; a++) if (o[a] !== i[a]) return !1;
              } else if (o !== i) return !1;
            }
            for (var s in t) if (void 0 === e[s] && void 0 !== t[s]) return !1;
            return !0;
          };
        function De(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        var Ce = ["anchor", "focus"];
        function Se(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Ee = {
            edges(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                {
                  anchor: r,
                  focus: o
                } = e;
              return Ee.isBackward(e) === n ? [r, o] : [o, r];
            },
            end(e) {
              var [, t] = Ee.edges(e);
              return t;
            },
            equals: (e, t) => Le.equals(e.anchor, t.anchor) && Le.equals(e.focus, t.focus),
            includes(e, t) {
              if (Ee.isRange(t)) {
                if (Ee.includes(e, t.anchor) || Ee.includes(e, t.focus)) return !0;
                var [n, r] = Ee.edges(e),
                  [o, i] = Ee.edges(t);
                return Le.isBefore(n, o) && Le.isAfter(r, i);
              }
              var [a, s] = Ee.edges(e),
                l = !1,
                u = !1;
              return Le.isPoint(t) ? (l = Le.compare(t, a) >= 0, u = Le.compare(t, s) <= 0) : (l = fe.compare(t, a.path) >= 0, u = fe.compare(t, s.path) <= 0), l && u;
            },
            intersection(e, t) {
              var n = De(e, Ce),
                [r, o] = Ee.edges(e),
                [i, a] = Ee.edges(t),
                s = Le.isBefore(r, i) ? i : r,
                l = Le.isBefore(o, a) ? o : a;
              return Le.isBefore(l, s) ? null : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? Se(Object(n), !0).forEach(function (t) {
                    me(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Se(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                anchor: s,
                focus: l
              }, n);
            },
            isBackward(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return Le.isAfter(t, n);
            },
            isCollapsed(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return Le.equals(t, n);
            },
            isExpanded: e => !Ee.isCollapsed(e),
            isForward: e => !Ee.isBackward(e),
            isRange: e => (0, r.P)(e) && Le.isPoint(e.anchor) && Le.isPoint(e.focus),
            *points(e) {
              yield [e.anchor, "anchor"], yield [e.focus, "focus"];
            },
            start(e) {
              var [t] = Ee.edges(e);
              return t;
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return te(e, e => {
                if (null === e) return null;
                var r,
                  o,
                  {
                    affinity: i = "inward"
                  } = n;
                if ("inward" === i) {
                  var a = Ee.isCollapsed(e);
                  Ee.isForward(e) ? (r = "forward", o = a ? r : "backward") : (r = "backward", o = a ? r : "forward");
                } else "outward" === i ? Ee.isForward(e) ? (r = "backward", o = "forward") : (r = "forward", o = "backward") : (r = i, o = i);
                var s = Le.transform(e.anchor, t, {
                    affinity: r
                  }),
                  l = Le.transform(e.focus, t, {
                    affinity: o
                  });
                if (!s || !l) return null;
                e.anchor = s, e.focus = l;
              });
            }
          },
          _e = e => (0, r.P)(e) && Te.isNodeList(e.children) && !Re.isEditor(e),
          Pe = {
            isAncestor: e => (0, r.P)(e) && Te.isNodeList(e.children),
            isElement: _e,
            isElementList: e => Array.isArray(e) && e.every(e => Pe.isElement(e)),
            isElementProps: e => void 0 !== e.children,
            isElementType: function (e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "type";
              return _e(e) && e[n] === t;
            },
            matches(e, t) {
              for (var n in t) if ("children" !== n && e[n] !== t[n]) return !1;
              return !0;
            }
          },
          ke = ["children"],
          Ae = ["text"],
          ze = new WeakMap(),
          Te = {
            ancestor(e, t) {
              var n = Te.get(e, t);
              if (Ge.isText(n)) throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(Ke.stringify(n)));
              return n;
            },
            *ancestors(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              for (var r of fe.ancestors(t, n)) {
                var o = [Te.ancestor(e, r), r];
                yield o;
              }
            },
            child(e, t) {
              if (Ge.isText(e)) throw new Error("Cannot get the child of a text node: ".concat(Ke.stringify(e)));
              var n = e.children[t];
              if (null == n) throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(Ke.stringify(e)));
              return n;
            },
            *children(e, t) {
              for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, {
                  reverse: r = !1
                } = n, o = Te.ancestor(e, t), {
                  children: i
                } = o, a = r ? i.length - 1 : 0; r ? a >= 0 : a < i.length;) {
                var s = Te.child(o, a),
                  l = t.concat(a);
                yield [s, l], a = r ? a - 1 : a + 1;
              }
            },
            common(e, t, n) {
              var r = fe.common(t, n);
              return [Te.get(e, r), r];
            },
            descendant(e, t) {
              var n = Te.get(e, t);
              if (Re.isEditor(n)) throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(Ke.stringify(n)));
              return n;
            },
            *descendants(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) 0 !== r.length && (yield [n, r]);
            },
            *elements(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) Pe.isElement(n) && (yield [n, r]);
            },
            extractProps: e => Pe.isAncestor(e) ? De(e, ke) : De(e, Ae),
            first(e, t) {
              for (var n = t.slice(), r = Te.get(e, n); r && !Ge.isText(r) && 0 !== r.children.length;) r = r.children[0], n.push(0);
              return [r, n];
            },
            fragment(e, t) {
              if (Ge.isText(e)) throw new Error("Cannot get a fragment starting from a root text node: ".concat(Ke.stringify(e)));
              var n = te({
                children: e.children
              }, e => {
                var [n, r] = Ee.edges(t),
                  o = Te.nodes(e, {
                    reverse: !0,
                    pass: e => {
                      var [, n] = e;
                      return !Ee.includes(t, n);
                    }
                  });
                for (var [, i] of o) {
                  if (!Ee.includes(t, i)) {
                    var a = Te.parent(e, i),
                      s = i[i.length - 1];
                    a.children.splice(s, 1);
                  }
                  if (fe.equals(i, r.path)) {
                    var l = Te.leaf(e, i);
                    l.text = l.text.slice(0, r.offset);
                  }
                  if (fe.equals(i, n.path)) {
                    var u = Te.leaf(e, i);
                    u.text = u.text.slice(n.offset);
                  }
                }
                Re.isEditor(e) && (e.selection = null);
              });
              return n.children;
            },
            get(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (Ge.isText(n) || !n.children[o]) throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(Ke.stringify(e)));
                n = n.children[o];
              }
              return n;
            },
            has(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (Ge.isText(n) || !n.children[o]) return !1;
                n = n.children[o];
              }
              return !0;
            },
            isNode: e => Ge.isText(e) || Pe.isElement(e) || Re.isEditor(e),
            isNodeList(e) {
              if (!Array.isArray(e)) return !1;
              var t = ze.get(e);
              if (void 0 !== t) return t;
              var n = e.every(e => Te.isNode(e));
              return ze.set(e, n), n;
            },
            last(e, t) {
              for (var n = t.slice(), r = Te.get(e, n); r && !Ge.isText(r) && 0 !== r.children.length;) {
                var o = r.children.length - 1;
                r = r.children[o], n.push(o);
              }
              return [r, n];
            },
            leaf(e, t) {
              var n = Te.get(e, t);
              if (!Ge.isText(n)) throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(Ke.stringify(n)));
              return n;
            },
            *levels(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              for (var r of fe.levels(t, n)) {
                var o = Te.get(e, r);
                yield [o, r];
              }
            },
            matches: (e, t) => Pe.isElement(e) && Pe.isElementProps(t) && Pe.matches(e, t) || Ge.isText(e) && Ge.isTextProps(t) && Ge.matches(e, t),
            *nodes(e) {
              for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
                  pass: n,
                  reverse: r = !1
                } = t, {
                  from: o = [],
                  to: i
                } = t, a = new Set(), s = [], l = e; !i || !(r ? fe.isBefore(s, i) : fe.isAfter(s, i));) if (a.has(l) || (yield [l, s]), a.has(l) || Ge.isText(l) || 0 === l.children.length || null != n && !1 !== n([l, s])) {
                if (0 === s.length) break;
                if (!r) {
                  var u = fe.next(s);
                  if (Te.has(e, u)) {
                    s = u, l = Te.get(e, s);
                    continue;
                  }
                }
                if (r && 0 !== s[s.length - 1]) s = fe.previous(s), l = Te.get(e, s);else s = fe.parent(s), l = Te.get(e, s), a.add(l);
              } else {
                a.add(l);
                var c = r ? l.children.length - 1 : 0;
                fe.isAncestor(s, o) && (c = o[s.length]), s = s.concat(c), l = Te.get(e, s);
              }
            },
            parent(e, t) {
              var n = fe.parent(t),
                r = Te.get(e, n);
              if (Ge.isText(r)) throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
              return r;
            },
            string: e => Ge.isText(e) ? e.text : e.children.map(Te.string).join(""),
            *texts(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              for (var [n, r] of Te.nodes(e, t)) Ge.isText(n) && (yield [n, r]);
            }
          };
        function Oe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ie(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Oe(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Oe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Fe = {
            isNodeOperation: e => Fe.isOperation(e) && e.type.endsWith("_node"),
            isOperation(e) {
              if (!(0, r.P)(e)) return !1;
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                  return fe.isPath(e.path) && Te.isNode(e.node);
                case "insert_text":
                case "remove_text":
                  return "number" == typeof e.offset && "string" == typeof e.text && fe.isPath(e.path);
                case "merge_node":
                  return "number" == typeof e.position && fe.isPath(e.path) && (0, r.P)(e.properties);
                case "move_node":
                  return fe.isPath(e.path) && fe.isPath(e.newPath);
                case "set_node":
                  return fe.isPath(e.path) && (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "set_selection":
                  return null === e.properties && Ee.isRange(e.newProperties) || null === e.newProperties && Ee.isRange(e.properties) || (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "split_node":
                  return fe.isPath(e.path) && "number" == typeof e.position && (0, r.P)(e.properties);
                default:
                  return !1;
              }
            },
            isOperationList: e => Array.isArray(e) && e.every(e => Fe.isOperation(e)),
            isSelectionOperation: e => Fe.isOperation(e) && e.type.endsWith("_selection"),
            isTextOperation: e => Fe.isOperation(e) && e.type.endsWith("_text"),
            inverse(e) {
              switch (e.type) {
                case "insert_node":
                  return Ie(Ie({}, e), {}, {
                    type: "remove_node"
                  });
                case "insert_text":
                  return Ie(Ie({}, e), {}, {
                    type: "remove_text"
                  });
                case "merge_node":
                  return Ie(Ie({}, e), {}, {
                    type: "split_node",
                    path: fe.previous(e.path)
                  });
                case "move_node":
                  var {
                    newPath: t,
                    path: n
                  } = e;
                  if (fe.equals(t, n)) return e;
                  if (fe.isSibling(n, t)) return Ie(Ie({}, e), {}, {
                    path: t,
                    newPath: n
                  });
                  var r = fe.transform(n, e),
                    o = fe.transform(fe.next(n), e);
                  return Ie(Ie({}, e), {}, {
                    path: r,
                    newPath: o
                  });
                case "remove_node":
                  return Ie(Ie({}, e), {}, {
                    type: "insert_node"
                  });
                case "remove_text":
                  return Ie(Ie({}, e), {}, {
                    type: "insert_text"
                  });
                case "set_node":
                  var {
                    properties: i,
                    newProperties: a
                  } = e;
                  return Ie(Ie({}, e), {}, {
                    properties: a,
                    newProperties: i
                  });
                case "set_selection":
                  var {
                    properties: s,
                    newProperties: l
                  } = e;
                  return Ie(Ie({}, e), {}, null == s ? {
                    properties: l,
                    newProperties: null
                  } : null == l ? {
                    properties: null,
                    newProperties: s
                  } : {
                    properties: l,
                    newProperties: s
                  });
                case "split_node":
                  return Ie(Ie({}, e), {}, {
                    type: "merge_node",
                    path: fe.next(e.path)
                  });
              }
            }
          },
          Me = new WeakMap(),
          Re = {
            above: (e, t) => e.above(t),
            addMark(e, t, n) {
              e.addMark(t, n);
            },
            after: (e, t, n) => e.after(t, n),
            before: (e, t, n) => e.before(t, n),
            deleteBackward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteBackward(n);
            },
            deleteForward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteForward(n);
            },
            deleteFragment(e, t) {
              e.deleteFragment(t);
            },
            edges: (e, t) => e.edges(t),
            elementReadOnly(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return e.elementReadOnly(t);
            },
            end: (e, t) => e.end(t),
            first: (e, t) => e.first(t),
            fragment: (e, t) => e.fragment(t),
            hasBlocks: (e, t) => e.hasBlocks(t),
            hasInlines: (e, t) => e.hasInlines(t),
            hasPath: (e, t) => e.hasPath(t),
            hasTexts: (e, t) => e.hasTexts(t),
            insertBreak(e) {
              e.insertBreak();
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertNode(e, t) {
              e.insertNode(t);
            },
            insertSoftBreak(e) {
              e.insertSoftBreak();
            },
            insertText(e, t) {
              e.insertText(t);
            },
            isBlock: (e, t) => e.isBlock(t),
            isEdge: (e, t, n) => e.isEdge(t, n),
            isEditor: e => (e => {
              var t = Me.get(e);
              if (void 0 !== t) return t;
              if (!(0, r.P)(e)) return !1;
              var n = "function" == typeof e.addMark && "function" == typeof e.apply && "function" == typeof e.deleteFragment && "function" == typeof e.insertBreak && "function" == typeof e.insertSoftBreak && "function" == typeof e.insertFragment && "function" == typeof e.insertNode && "function" == typeof e.insertText && "function" == typeof e.isElementReadOnly && "function" == typeof e.isInline && "function" == typeof e.isSelectable && "function" == typeof e.isVoid && "function" == typeof e.normalizeNode && "function" == typeof e.onChange && "function" == typeof e.removeMark && "function" == typeof e.getDirtyPaths && (null === e.marks || (0, r.P)(e.marks)) && (null === e.selection || Ee.isRange(e.selection)) && Te.isNodeList(e.children) && Fe.isOperationList(e.operations);
              return Me.set(e, n), n;
            })(e),
            isElementReadOnly: (e, t) => e.isElementReadOnly(t),
            isEmpty: (e, t) => e.isEmpty(t),
            isEnd: (e, t, n) => e.isEnd(t, n),
            isInline: (e, t) => e.isInline(t),
            isNormalizing: e => e.isNormalizing(),
            isSelectable: (e, t) => e.isSelectable(t),
            isStart: (e, t, n) => e.isStart(t, n),
            isVoid: (e, t) => e.isVoid(t),
            last: (e, t) => e.last(t),
            leaf: (e, t, n) => e.leaf(t, n),
            levels: (e, t) => e.levels(t),
            marks: e => e.getMarks(),
            next: (e, t) => e.next(t),
            node: (e, t, n) => e.node(t, n),
            nodes: (e, t) => e.nodes(t),
            normalize(e, t) {
              e.normalize(t);
            },
            parent: (e, t, n) => e.parent(t, n),
            path: (e, t, n) => e.path(t, n),
            pathRef: (e, t, n) => e.pathRef(t, n),
            pathRefs: e => e.pathRefs(),
            point: (e, t, n) => e.point(t, n),
            pointRef: (e, t, n) => e.pointRef(t, n),
            pointRefs: e => e.pointRefs(),
            positions: (e, t) => e.positions(t),
            previous: (e, t) => e.previous(t),
            range: (e, t, n) => e.range(t, n),
            rangeRef: (e, t, n) => e.rangeRef(t, n),
            rangeRefs: e => e.rangeRefs(),
            removeMark(e, t) {
              e.removeMark(t);
            },
            setNormalizing(e, t) {
              e.setNormalizing(t);
            },
            start: (e, t) => e.start(t),
            string: (e, t, n) => e.string(t, n),
            unhangRange: (e, t, n) => e.unhangRange(t, n),
            void: (e, t) => e.void(t),
            withoutNormalizing(e, t) {
              e.withoutNormalizing(t);
            }
          },
          je = {
            isSpan: e => Array.isArray(e) && 2 === e.length && e.every(fe.isPath)
          };
        function Be(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ne(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Be(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Be(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Le = {
            compare(e, t) {
              var n = fe.compare(e.path, t.path);
              return 0 === n ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
            },
            isAfter: (e, t) => 1 === Le.compare(e, t),
            isBefore: (e, t) => -1 === Le.compare(e, t),
            equals: (e, t) => e.offset === t.offset && fe.equals(e.path, t.path),
            isPoint: e => (0, r.P)(e) && "number" == typeof e.offset && fe.isPath(e.path),
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return te(e, e => {
                if (null === e) return null;
                var {
                    affinity: r = "forward"
                  } = n,
                  {
                    path: o,
                    offset: i
                  } = e;
                switch (t.type) {
                  case "insert_node":
                  case "move_node":
                    e.path = fe.transform(o, t, n);
                    break;
                  case "insert_text":
                    fe.equals(t.path, o) && (t.offset < i || t.offset === i && "forward" === r) && (e.offset += t.text.length);
                    break;
                  case "merge_node":
                    fe.equals(t.path, o) && (e.offset += t.position), e.path = fe.transform(o, t, n);
                    break;
                  case "remove_text":
                    fe.equals(t.path, o) && t.offset <= i && (e.offset -= Math.min(i - t.offset, t.text.length));
                    break;
                  case "remove_node":
                    if (fe.equals(t.path, o) || fe.isAncestor(t.path, o)) return null;
                    e.path = fe.transform(o, t, n);
                    break;
                  case "split_node":
                    if (fe.equals(t.path, o)) {
                      if (t.position === i && null == r) return null;
                      (t.position < i || t.position === i && "forward" === r) && (e.offset -= t.position, e.path = fe.transform(o, t, Ne(Ne({}, n), {}, {
                        affinity: "forward"
                      })));
                    } else e.path = fe.transform(o, t, n);
                }
              });
            }
          },
          Ve = void 0,
          Ke = {
            setScrubber(e) {
              Ve = e;
            },
            stringify: e => JSON.stringify(e, Ve)
          },
          qe = ["text"],
          He = ["anchor", "focus"];
        function Ue(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ze(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ue(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ue(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var $e,
          Ge = {
            equals(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                {
                  loose: r = !1
                } = n;
              function o(e) {
                return De(e, qe);
              }
              return xe(r ? o(e) : e, r ? o(t) : t);
            },
            isText: e => (0, r.P)(e) && "string" == typeof e.text,
            isTextList: e => Array.isArray(e) && e.every(e => Ge.isText(e)),
            isTextProps: e => void 0 !== e.text,
            matches(e, t) {
              for (var n in t) if ("text" !== n && (!e.hasOwnProperty(n) || e[n] !== t[n])) return !1;
              return !0;
            },
            decorations(e, t) {
              var n = [Ze({}, e)];
              for (var r of t) {
                var o = De(r, He),
                  [i, a] = Ee.edges(r),
                  s = [],
                  l = 0,
                  u = i.offset,
                  c = a.offset;
                for (var d of n) {
                  var {
                      length: p
                    } = d.text,
                    h = l;
                  if (l += p, u <= h && l <= c) Object.assign(d, o), s.push(d);else if (u !== c && (u === l || c === h) || u > l || c < h || c === h && 0 !== h) s.push(d);else {
                    var f = d,
                      m = void 0,
                      g = void 0;
                    if (c < l) {
                      var v = c - h;
                      g = Ze(Ze({}, f), {}, {
                        text: f.text.slice(v)
                      }), f = Ze(Ze({}, f), {}, {
                        text: f.text.slice(0, v)
                      });
                    }
                    if (u > h) {
                      var y = u - h;
                      m = Ze(Ze({}, f), {}, {
                        text: f.text.slice(0, y)
                      }), f = Ze(Ze({}, f), {}, {
                        text: f.text.slice(y)
                      });
                    }
                    Object.assign(f, o), m && s.push(m), s.push(f), g && s.push(g);
                  }
                }
                n = s;
              }
              return n;
            }
          },
          We = e => e.selection ? e.selection : e.children.length > 0 ? Re.end(e, []) : [0],
          Ye = (e, t) => {
            var [n] = Re.node(e, t);
            return e => e === n;
          },
          Xe = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = !t,
              r = t ? ot(e) : e,
              o = $e.None,
              i = $e.None,
              a = 0,
              s = null;
            for (var l of r) {
              var u = l.codePointAt(0);
              if (!u) break;
              var c = gt(l, u);
              if ([o, i] = n ? [i, c] : [c, o], vt(o, $e.ZWJ) && vt(i, $e.ExtPict) && !xt(n ? e.substring(0, a) : e.substring(0, e.length - a))) break;
              if (vt(o, $e.RI) && vt(i, $e.RI) && !(s = null !== s ? !s : !!n || Ct(e.substring(0, e.length - a)))) break;
              if (o !== $e.None && i !== $e.None && bt(o, i)) break;
              a += l.length;
            }
            return a || 1;
          },
          Qe = /\s/,
          Je = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/,
          et = /['\u2018\u2019]/,
          tt = function (e) {
            for (var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = 0, r = !1; e.length > 0;) {
              var o = Xe(e, t),
                [i, a] = nt(e, o, t);
              if (rt(i, a, t)) r = !0, n += o;else {
                if (r) break;
                n += o;
              }
              e = a;
            }
            return n;
          },
          nt = (e, t, n) => {
            if (n) {
              var r = e.length - t;
              return [e.slice(r, e.length), e.slice(0, r)];
            }
            return [e.slice(0, t), e.slice(t)];
          },
          rt = function e(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if (Qe.test(t)) return !1;
            if (et.test(t)) {
              var o = Xe(n, r),
                [i, a] = nt(n, o, r);
              if (e(i, a, r)) return !0;
            }
            return !Je.test(t);
          },
          ot = function* (e) {
            for (var t = e.length - 1, n = 0; n < e.length; n++) {
              var r = e.charAt(t - n);
              if (at(r.charCodeAt(0))) {
                var o = e.charAt(t - n - 1);
                if (it(o.charCodeAt(0))) {
                  yield o + r, n++;
                  continue;
                }
              }
              yield r;
            }
          },
          it = e => e >= 55296 && e <= 56319,
          at = e => e >= 56320 && e <= 57343;
        !function (e) {
          e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
        }($e || ($e = {}));
        var st = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/,
          lt = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/,
          ut = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/,
          ct = /^[\u1100-\u115F\uA960-\uA97C]$/,
          dt = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/,
          pt = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/,
          ht = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/,
          ft = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/,
          mt = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/,
          gt = (e, t) => {
            var n = $e.Any;
            return -1 !== e.search(st) && (n |= $e.Extend), 8205 === t && (n |= $e.ZWJ), t >= 127462 && t <= 127487 && (n |= $e.RI), -1 !== e.search(lt) && (n |= $e.Prepend), -1 !== e.search(ut) && (n |= $e.SpacingMark), -1 !== e.search(ct) && (n |= $e.L), -1 !== e.search(dt) && (n |= $e.V), -1 !== e.search(pt) && (n |= $e.T), -1 !== e.search(ht) && (n |= $e.LV), -1 !== e.search(ft) && (n |= $e.LVT), -1 !== e.search(mt) && (n |= $e.ExtPict), n;
          };
        function vt(e, t) {
          return 0 != (e & t);
        }
        var yt = [[$e.L, $e.L | $e.V | $e.LV | $e.LVT], [$e.LV | $e.V, $e.V | $e.T], [$e.LVT | $e.T, $e.T], [$e.Any, $e.Extend | $e.ZWJ], [$e.Any, $e.SpacingMark], [$e.Prepend, $e.Any], [$e.ZWJ, $e.ExtPict], [$e.RI, $e.RI]];
        function bt(e, t) {
          return -1 === yt.findIndex(n => vt(e, n[0]) && vt(t, n[1]));
        }
        var wt = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/,
          xt = e => -1 !== e.search(wt),
          Dt = /(?:\uD83C[\uDDE6-\uDDFF])+$/g,
          Ct = e => {
            var t = e.match(Dt);
            return null !== t && t[0].length / 2 % 2 == 1;
          },
          St = {
            delete(e, t) {
              e.delete(t);
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertText(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              Re.withoutNormalizing(e, () => {
                var {
                    voids: r = !1
                  } = n,
                  {
                    at: o = We(e)
                  } = n;
                if (fe.isPath(o) && (o = Re.range(e, o)), Ee.isRange(o)) if (Ee.isCollapsed(o)) o = o.anchor;else {
                  var i = Ee.end(o);
                  if (!r && Re.void(e, {
                    at: i
                  })) return;
                  var a = Ee.start(o),
                    s = Re.pointRef(e, a),
                    l = Re.pointRef(e, i);
                  Pt.delete(e, {
                    at: o,
                    voids: r
                  });
                  var u = s.unref(),
                    c = l.unref();
                  o = u || c, Pt.setSelection(e, {
                    anchor: o,
                    focus: o
                  });
                }
                if (!(!r && Re.void(e, {
                  at: o
                }) || Re.elementReadOnly(e, {
                  at: o
                }))) {
                  var {
                    path: d,
                    offset: p
                  } = o;
                  t.length > 0 && e.apply({
                    type: "insert_text",
                    path: d,
                    offset: p,
                    text: t
                  });
                }
              });
            }
          };
        function Et(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function _t(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Et(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Et(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Pt = _t(_t(_t(_t({}, ye), be), we), St),
          kt = (e, t) => {
            for (var n of Re.pathRefs(e)) oe.transform(n, t);
            for (var r of Re.pointRefs(e)) ie.transform(r, t);
            for (var o of Re.rangeRefs(e)) ae.transform(o, t);
            var i,
              a,
              s = se.get(e) || [],
              l = le.get(e) || new Set(),
              u = e => {
                if (e) {
                  var t = e.join(",");
                  a.has(t) || (a.add(t), i.push(e));
                }
              };
            if (fe.operationCanTransformPath(t)) for (var c of (i = [], a = new Set(), s)) {
              u(fe.transform(c, t));
            } else i = s, a = l;
            var d = e.getDirtyPaths(t);
            for (var p of d) u(p);
            se.set(e, i), le.set(e, a), Pt.transform(e, t), e.operations.push(t), Re.normalize(e, {
              operation: t
            }), "set_selection" === t.type && (e.marks = null), ue.get(e) || (ue.set(e, !0), Promise.resolve().then(() => {
              ue.set(e, !1), e.onChange({
                operation: t
              }), e.operations = [];
            }));
          },
          At = (e, t) => {
            switch (t.type) {
              case "insert_text":
              case "remove_text":
              case "set_node":
                var {
                  path: n
                } = t;
                return fe.levels(n);
              case "insert_node":
                var {
                    node: r,
                    path: o
                  } = t,
                  i = fe.levels(o),
                  a = Ge.isText(r) ? [] : Array.from(Te.nodes(r), e => {
                    var [, t] = e;
                    return o.concat(t);
                  });
                return [...i, ...a];
              case "merge_node":
                var {
                  path: s
                } = t;
                return [...fe.ancestors(s), fe.previous(s)];
              case "move_node":
                var {
                  path: l,
                  newPath: u
                } = t;
                if (fe.equals(l, u)) return [];
                var c = [],
                  d = [];
                for (var p of fe.ancestors(l)) {
                  var h = fe.transform(p, t);
                  c.push(h);
                }
                for (var f of fe.ancestors(u)) {
                  var m = fe.transform(f, t);
                  d.push(m);
                }
                var g = d[d.length - 1],
                  v = u[u.length - 1],
                  y = g.concat(v);
                return [...c, ...d, y];
              case "remove_node":
                var {
                  path: b
                } = t;
                return [...fe.ancestors(b)];
              case "split_node":
                var {
                  path: w
                } = t;
                return [...fe.levels(w), fe.next(w)];
              default:
                return [];
            }
          },
          zt = e => {
            var {
              selection: t
            } = e;
            return t ? Te.fragment(e, t) : [];
          },
          Tt = (e, t) => {
            var [n, r] = t;
            if (!Ge.isText(n)) if (Pe.isElement(n) && 0 === n.children.length) {
              Pt.insertNodes(e, {
                text: ""
              }, {
                at: r.concat(0),
                voids: !0
              });
            } else for (var o = !Re.isEditor(n) && Pe.isElement(n) && (e.isInline(n) || 0 === n.children.length || Ge.isText(n.children[0]) || e.isInline(n.children[0])), i = 0, a = 0; a < n.children.length; a++, i++) {
              var s = Te.get(e, r);
              if (!Ge.isText(s)) {
                var l = s.children[i],
                  u = s.children[i - 1],
                  c = a === n.children.length - 1;
                if ((Ge.isText(l) || Pe.isElement(l) && e.isInline(l)) !== o) Pt.removeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--;else if (Pe.isElement(l)) {
                  if (e.isInline(l)) if (null != u && Ge.isText(u)) {
                    if (c) {
                      Pt.insertNodes(e, {
                        text: ""
                      }, {
                        at: r.concat(i + 1),
                        voids: !0
                      }), i++;
                    }
                  } else {
                    Pt.insertNodes(e, {
                      text: ""
                    }, {
                      at: r.concat(i),
                      voids: !0
                    }), i++;
                  }
                } else null != u && Ge.isText(u) && (Ge.equals(l, u, {
                  loose: !0
                }) ? (Pt.mergeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--) : "" === u.text ? (Pt.removeNodes(e, {
                  at: r.concat(i - 1),
                  voids: !0
                }), i--) : "" === l.text && (Pt.removeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--));
              }
            }
          },
          Ot = (e, t) => {
            var {
                iteration: n,
                initialDirtyPathsLength: r
              } = t,
              o = 42 * r;
            if (n > o) throw new Error("Could not completely normalize the editor after ".concat(o, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
            return !0;
          },
          It = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                voids: n = !1,
                mode: r = "lowest",
                at: o = e.selection,
                match: i
              } = t;
            if (o) {
              var a = Re.path(e, o),
                s = "lowest" === r;
              for (var [l, u] of Re.levels(e, {
                at: a,
                voids: n,
                match: i,
                reverse: s
              })) if (!Ge.isText(l)) if (Ee.isRange(o)) {
                if (fe.isAncestor(u, o.anchor.path) && fe.isAncestor(u, o.focus.path)) return [l, u];
              } else if (!fe.equals(a, u)) return [l, u];
            }
          };
        function Ft(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Mt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ft(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ft(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Rt = (e, t, n) => {
          var {
            selection: r
          } = e;
          if (r) {
            var o = (t, n) => {
                if (!Ge.isText(t)) return !1;
                var [r, o] = Re.parent(e, n);
                return !e.isVoid(r) || e.markableVoid(r);
              },
              i = Ee.isExpanded(r),
              a = !1;
            if (!i) {
              var [s, l] = Re.node(e, r);
              if (s && o(s, l)) {
                var [u] = Re.parent(e, l);
                a = u && e.markableVoid(u);
              }
            }
            if (i || a) Pt.setNodes(e, {
              [t]: n
            }, {
              match: o,
              split: !0,
              voids: !0
            });else {
              var c = Mt(Mt({}, Re.marks(e) || {}), {}, {
                [t]: n
              });
              e.marks = c, ue.get(e) || e.onChange();
            }
          }
        };
        function jt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Bt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? jt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Nt = function (e, t) {
          var n,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = Re.point(e, t, {
              edge: "end"
            }),
            i = Re.end(e, []),
            a = {
              anchor: o,
              focus: i
            },
            {
              distance: s = 1
            } = r,
            l = 0;
          for (var u of Re.positions(e, Bt(Bt({}, r), {}, {
            at: a
          }))) {
            if (l > s) break;
            0 !== l && (n = u), l++;
          }
          return n;
        };
        function Lt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Vt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Lt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Kt = function (e, t) {
            var n,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = Re.start(e, []),
              i = Re.point(e, t, {
                edge: "start"
              }),
              a = {
                anchor: o,
                focus: i
              },
              {
                distance: s = 1
              } = r,
              l = 0;
            for (var u of Re.positions(e, Vt(Vt({}, r), {}, {
              at: a,
              reverse: !0
            }))) {
              if (l > s) break;
              0 !== l && (n = u), l++;
            }
            return n;
          },
          qt = (e, t) => {
            var {
              selection: n
            } = e;
            n && Ee.isCollapsed(n) && Pt.delete(e, {
              unit: t,
              reverse: !0
            });
          },
          Ht = (e, t) => {
            var {
              selection: n
            } = e;
            n && Ee.isCollapsed(n) && Pt.delete(e, {
              unit: t
            });
          },
          Ut = function (e) {
            var {
                direction: t = "forward"
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e;
            n && Ee.isExpanded(n) && Pt.delete(e, {
              reverse: "backward" === t
            });
          },
          Zt = (e, t) => [Re.start(e, t), Re.end(e, t)];
        function $t(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Gt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? $t(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $t(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Wt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return Re.above(e, Gt(Gt({}, t), {}, {
              match: t => Pe.isElement(t) && Re.isElementReadOnly(e, t)
            }));
          },
          Yt = (e, t) => Re.point(e, t, {
            edge: "end"
          }),
          Xt = (e, t) => {
            var n = Re.path(e, t, {
              edge: "start"
            });
            return Re.node(e, n);
          },
          Qt = (e, t) => {
            var n = Re.range(e, t);
            return Te.fragment(e, n);
          };
        function Jt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function en(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Jt(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var tn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return Re.above(e, en(en({}, t), {}, {
              match: t => Pe.isElement(t) && Re.isVoid(e, t)
            }));
          },
          nn = (e, t) => t.children.some(t => Pe.isElement(t) && Re.isBlock(e, t)),
          rn = (e, t) => t.children.some(t => Ge.isText(t) || Re.isInline(e, t)),
          on = (e, t) => Te.has(e, t),
          an = (e, t) => t.children.every(e => Ge.isText(e)),
          sn = e => {
            Pt.splitNodes(e, {
              always: !0
            });
          },
          ln = (e, t, n) => {
            Pt.insertNodes(e, t, n);
          },
          un = e => {
            Pt.splitNodes(e, {
              always: !0
            });
          };
        function cn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function dn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? cn(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var pn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r,
                marks: o
              } = e;
            if (r) {
              if (o) {
                var i = dn({
                  text: t
                }, o);
                Pt.insertNodes(e, i, {
                  at: n.at,
                  voids: n.voids
                });
              } else Pt.insertText(e, t, n);
              e.marks = null;
            }
          },
          hn = (e, t) => !e.isInline(t),
          fn = (e, t, n) => Re.isStart(e, t, n) || Re.isEnd(e, t, n),
          mn = (e, t) => {
            var {
                children: n
              } = t,
              [r] = n;
            return 0 === n.length || 1 === n.length && Ge.isText(r) && "" === r.text && !e.isVoid(t);
          },
          gn = (e, t, n) => {
            var r = Re.end(e, n);
            return Le.equals(t, r);
          },
          vn = e => {
            var t = ce.get(e);
            return void 0 === t || t;
          },
          yn = (e, t, n) => {
            if (0 !== t.offset) return !1;
            var r = Re.start(e, n);
            return Le.equals(t, r);
          },
          bn = (e, t) => {
            var n = Re.path(e, t, {
              edge: "end"
            });
            return Re.node(e, n);
          },
          wn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = Re.path(e, t, n),
              o = Te.leaf(e, r);
            return [o, r];
          };
        function* xn(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              reverse: r = !1,
              voids: o = !1
            } = t,
            {
              match: i
            } = t;
          if (null == i && (i = () => !0), n) {
            var a = [],
              s = Re.path(e, n);
            for (var [l, u] of Te.levels(e, s)) if (i(l, u) && (a.push([l, u]), !o && Pe.isElement(l) && Re.isVoid(e, l))) break;
            r && a.reverse(), yield* a;
          }
        }
        var Dn = ["text"],
          Cn = ["text"],
          Sn = function (e) {
            var {
              marks: t,
              selection: n
            } = e;
            if (!n) return null;
            if (t) return t;
            if (Ee.isExpanded(n)) {
              var [r] = Re.nodes(e, {
                match: Ge.isText
              });
              if (r) {
                var [o] = r;
                return De(o, Dn);
              }
              return {};
            }
            var {
                anchor: i
              } = n,
              {
                path: a
              } = i,
              [s] = Re.leaf(e, a);
            if (0 === i.offset) {
              var l = Re.previous(e, {
                  at: a,
                  match: Ge.isText
                }),
                u = Re.above(e, {
                  match: t => Pe.isElement(t) && Re.isVoid(e, t) && e.markableVoid(t)
                });
              if (!u) {
                var c = Re.above(e, {
                  match: t => Pe.isElement(t) && Re.isBlock(e, t)
                });
                if (l && c) {
                  var [d, p] = l,
                    [, h] = c;
                  fe.isAncestor(h, p) && (s = d);
                }
              }
            }
            return De(s, Cn);
          },
          En = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = Re.after(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = Re.last(e, []),
                  l = [a.path, s];
                if (fe.isPath(i) && 0 === i.length) throw new Error("Cannot get the next node from the root node!");
                if (null == o) if (fe.isPath(i)) {
                  var [u] = Re.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = Re.nodes(e, {
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          _n = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = Re.path(e, t, n),
              o = Te.get(e, r);
            return [o, r];
          };
        function* Pn(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              mode: r = "all",
              universal: o = !1,
              reverse: i = !1,
              voids: a = !1,
              ignoreNonSelectable: s = !1
            } = t,
            {
              match: l
            } = t;
          if (l || (l = () => !0), n) {
            var u, c;
            if (je.isSpan(n)) u = n[0], c = n[1];else {
              var d = Re.path(e, n, {
                  edge: "start"
                }),
                p = Re.path(e, n, {
                  edge: "end"
                });
              u = i ? p : d, c = i ? d : p;
            }
            var h,
              f = Te.nodes(e, {
                reverse: i,
                from: u,
                to: c,
                pass: t => {
                  var [n] = t;
                  return !!Pe.isElement(n) && (!(a || !Re.isVoid(e, n) && !Re.isElementReadOnly(e, n)) || !(!s || Re.isSelectable(e, n)));
                }
              }),
              m = [];
            for (var [g, v] of f) if (!s || !Pe.isElement(g) || Re.isSelectable(e, g)) {
              var y = h && 0 === fe.compare(v, h[1]);
              if ("highest" !== r || !y) if (l(g, v)) {
                if ("lowest" === r && y) h = [g, v];else {
                  var b = "lowest" === r ? h : [g, v];
                  b && (o ? m.push(b) : yield b), h = [g, v];
                }
              } else if (o && !y && Ge.isText(g)) return;
            }
            "lowest" === r && h && (o ? m.push(h) : yield h), o && (yield* m);
          }
        }
        var kn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                force: n = !1,
                operation: r
              } = t,
              o = e => se.get(e) || [],
              i = e => le.get(e) || new Set(),
              a = e => {
                var t = o(e).pop(),
                  n = t.join(",");
                return i(e).delete(n), t;
              };
            if (Re.isNormalizing(e)) {
              if (n) {
                var s = Array.from(Te.nodes(e), e => {
                    var [, t] = e;
                    return t;
                  }),
                  l = new Set(s.map(e => e.join(",")));
                se.set(e, s), le.set(e, l);
              }
              0 !== o(e).length && Re.withoutNormalizing(e, () => {
                for (var t of o(e)) if (Te.has(e, t)) {
                  var n = Re.node(e, t),
                    [i, s] = n;
                  Pe.isElement(i) && 0 === i.children.length && e.normalizeNode(n, {
                    operation: r
                  });
                }
                for (var l = o(e), u = l.length, c = 0; 0 !== l.length;) {
                  if (!e.shouldNormalize({
                    dirtyPaths: l,
                    iteration: c,
                    initialDirtyPathsLength: u,
                    operation: r
                  })) return;
                  var d = a(e);
                  if (Te.has(e, d)) {
                    var p = Re.node(e, d);
                    e.normalizeNode(p, {
                      operation: r
                    });
                  }
                  c++, l = o(e);
                }
              });
            }
          },
          An = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = Re.path(e, t, n),
              o = fe.parent(r),
              i = Re.node(e, o);
            return i;
          },
          zn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return Re.pathRefs(e).delete(o), o.current = null, t;
                }
              },
              i = Re.pathRefs(e);
            return i.add(o), o;
          },
          Tn = e => {
            var t = de.get(e);
            return t || (t = new Set(), de.set(e, t)), t;
          },
          On = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                depth: r,
                edge: o
              } = n;
            if (fe.isPath(t)) if ("start" === o) {
              var [, i] = Te.first(e, t);
              t = i;
            } else if ("end" === o) {
              var [, a] = Te.last(e, t);
              t = a;
            }
            return Ee.isRange(t) && (t = "start" === o ? Ee.start(t) : "end" === o ? Ee.end(t) : fe.common(t.anchor.path, t.focus.path)), Le.isPoint(t) && (t = t.path), null != r && (t = t.slice(0, r)), t;
          },
          In = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return Re.pointRefs(e).delete(o), o.current = null, t;
                }
              },
              i = Re.pointRefs(e);
            return i.add(o), o;
          },
          Fn = e => {
            var t = pe.get(e);
            return t || (t = new Set(), pe.set(e, t)), t;
          },
          Mn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                edge: r = "start"
              } = n;
            if (fe.isPath(t)) {
              var o;
              if ("end" === r) {
                var [, i] = Te.last(e, t);
                o = i;
              } else {
                var [, a] = Te.first(e, t);
                o = a;
              }
              var s = Te.get(e, o);
              if (!Ge.isText(s)) throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
              return {
                path: o,
                offset: "end" === r ? s.text.length : 0
              };
            }
            if (Ee.isRange(t)) {
              var [l, u] = Ee.edges(t);
              return "start" === r ? l : u;
            }
            return t;
          };
        function* Rn(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              at: n = e.selection,
              unit: r = "offset",
              reverse: o = !1,
              voids: i = !1,
              ignoreNonSelectable: a = !1
            } = t;
          if (n) {
            var s = Re.range(e, n),
              [l, u] = Ee.edges(s),
              c = o ? u : l,
              d = !1,
              p = "",
              h = 0,
              f = 0,
              m = 0;
            for (var [g, v] of Re.nodes(e, {
              at: n,
              reverse: o,
              voids: i,
              ignoreNonSelectable: a
            })) {
              if (Pe.isElement(g)) {
                if (!i && (e.isVoid(g) || e.isElementReadOnly(g))) {
                  yield Re.start(e, v);
                  continue;
                }
                if (e.isInline(g)) continue;
                if (Re.hasInlines(e, g)) {
                  var y = fe.isAncestor(v, u.path) ? u : Re.end(e, v),
                    b = fe.isAncestor(v, l.path) ? l : Re.start(e, v);
                  p = Re.string(e, {
                    anchor: b,
                    focus: y
                  }, {
                    voids: i
                  }), d = !0;
                }
              }
              if (Ge.isText(g)) {
                var w = fe.equals(v, c.path);
                for (w ? (f = o ? c.offset : g.text.length - c.offset, m = c.offset) : (f = g.text.length, m = o ? f : 0), (w || d || "offset" === r) && (yield {
                  path: v,
                  offset: m
                }, d = !1);;) {
                  if (0 === h) {
                    if ("" === p) break;
                    h = x(p, r, o), p = nt(p, h, o)[1];
                  }
                  if (m = o ? m - h : m + h, (f -= h) < 0) {
                    h = -f;
                    break;
                  }
                  h = 0, yield {
                    path: v,
                    offset: m
                  };
                }
              }
            }
          }
          function x(e, t, n) {
            return "character" === t ? Xe(e, n) : "word" === t ? tt(e, n) : "line" === t || "block" === t ? e.length : 1;
          }
        }
        var jn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = Re.before(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = Re.first(e, []),
                  l = [a.path, s];
                if (fe.isPath(i) && 0 === i.length) throw new Error("Cannot get the previous node from the root node!");
                if (null == o) if (fe.isPath(i)) {
                  var [u] = Re.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = Re.nodes(e, {
                  reverse: !0,
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          Bn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return Re.rangeRefs(e).delete(o), o.current = null, t;
                }
              },
              i = Re.rangeRefs(e);
            return i.add(o), o;
          },
          Nn = e => {
            var t = he.get(e);
            return t || (t = new Set(), he.set(e, t)), t;
          },
          Ln = (e, t, n) => Ee.isRange(t) && !n ? t : {
            anchor: Re.start(e, t),
            focus: Re.end(e, n || t)
          };
        function Vn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var Kn = (e, t) => {
            var {
              selection: n
            } = e;
            if (n) {
              var r = (t, n) => {
                  if (!Ge.isText(t)) return !1;
                  var [r, o] = Re.parent(e, n);
                  return !e.isVoid(r) || e.markableVoid(r);
                },
                o = Ee.isExpanded(n),
                i = !1;
              if (!o) {
                var [a, s] = Re.node(e, n);
                if (a && r(a, s)) {
                  var [l] = Re.parent(e, s);
                  i = l && e.markableVoid(l);
                }
              }
              if (o || i) Pt.unsetNodes(e, t, {
                match: r,
                split: !0,
                voids: !0
              });else {
                var u = function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Vn(Object(n), !0).forEach(function (t) {
                      me(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vn(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                  }
                  return e;
                }({}, Re.marks(e) || {});
                delete u[t], e.marks = u, ue.get(e) || e.onChange();
              }
            }
          },
          qn = (e, t) => {
            ce.set(e, t);
          },
          Hn = (e, t) => Re.point(e, t, {
            edge: "start"
          }),
          Un = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              o = Re.range(e, t),
              [i, a] = Ee.edges(o),
              s = "";
            for (var [l, u] of Re.nodes(e, {
              at: o,
              match: Ge.isText,
              voids: r
            })) {
              var c = l.text;
              fe.equals(u, a.path) && (c = c.slice(0, a.offset)), fe.equals(u, i.path) && (c = c.slice(i.offset)), s += c;
            }
            return s;
          },
          Zn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              [o, i] = Ee.edges(t);
            if (0 !== o.offset || 0 !== i.offset || Ee.isCollapsed(t) || fe.hasPrevious(i.path)) return t;
            var a = Re.above(e, {
                at: i,
                match: t => Pe.isElement(t) && Re.isBlock(e, t),
                voids: r
              }),
              s = a ? a[1] : [],
              l = Re.start(e, o),
              u = {
                anchor: l,
                focus: i
              },
              c = !0;
            for (var [d, p] of Re.nodes(e, {
              at: u,
              match: Ge.isText,
              reverse: !0,
              voids: r
            })) if (c) c = !1;else if ("" !== d.text || fe.isBefore(p, s)) {
              i = {
                path: p,
                offset: d.text.length
              };
              break;
            }
            return {
              anchor: o,
              focus: i
            };
          },
          $n = (e, t) => {
            var n = Re.isNormalizing(e);
            Re.setNormalizing(e, !1);
            try {
              t();
            } finally {
              Re.setNormalizing(e, n);
            }
            Re.normalize(e);
          },
          Gn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var n,
                r,
                {
                  reverse: o = !1,
                  unit: i = "character",
                  distance: a = 1,
                  voids: s = !1
                } = t,
                {
                  at: l = e.selection,
                  hanging: u = !1
                } = t;
              if (l) {
                var c = !1;
                if (Ee.isRange(l) && Ee.isCollapsed(l) && (c = !0, l = l.anchor), Le.isPoint(l)) {
                  var d = Re.void(e, {
                    at: l,
                    mode: "highest"
                  });
                  if (!s && d) {
                    var [, p] = d;
                    l = p;
                  } else {
                    var h = {
                      unit: i,
                      distance: a
                    };
                    l = {
                      anchor: l,
                      focus: o ? Re.before(e, l, h) || Re.start(e, []) : Re.after(e, l, h) || Re.end(e, [])
                    }, u = !0;
                  }
                }
                if (fe.isPath(l)) Pt.removeNodes(e, {
                  at: l,
                  voids: s
                });else if (!Ee.isCollapsed(l)) {
                  if (!u) {
                    var [, f] = Ee.edges(l),
                      m = Re.end(e, []);
                    Le.equals(f, m) || (l = Re.unhangRange(e, l, {
                      voids: s
                    }));
                  }
                  var [g, v] = Ee.edges(l),
                    y = Re.above(e, {
                      match: t => Pe.isElement(t) && Re.isBlock(e, t),
                      at: g,
                      voids: s
                    }),
                    b = Re.above(e, {
                      match: t => Pe.isElement(t) && Re.isBlock(e, t),
                      at: v,
                      voids: s
                    }),
                    w = y && b && !fe.equals(y[1], b[1]),
                    x = fe.equals(g.path, v.path),
                    D = s ? null : null !== (n = Re.void(e, {
                      at: g,
                      mode: "highest"
                    })) && void 0 !== n ? n : Re.elementReadOnly(e, {
                      at: g,
                      mode: "highest"
                    }),
                    C = s ? null : null !== (r = Re.void(e, {
                      at: v,
                      mode: "highest"
                    })) && void 0 !== r ? r : Re.elementReadOnly(e, {
                      at: v,
                      mode: "highest"
                    });
                  if (D) {
                    var S = Re.before(e, g);
                    S && y && fe.isAncestor(y[1], S.path) && (g = S);
                  }
                  if (C) {
                    var E = Re.after(e, v);
                    E && b && fe.isAncestor(b[1], E.path) && (v = E);
                  }
                  var _,
                    P = [];
                  for (var k of Re.nodes(e, {
                    at: l,
                    voids: s
                  })) {
                    var [A, z] = k;
                    _ && 0 === fe.compare(z, _) || (!s && Pe.isElement(A) && (Re.isVoid(e, A) || Re.isElementReadOnly(e, A)) || !fe.isCommon(z, g.path) && !fe.isCommon(z, v.path)) && (P.push(k), _ = z);
                  }
                  var T = Array.from(P, t => {
                      var [, n] = t;
                      return Re.pathRef(e, n);
                    }),
                    O = Re.pointRef(e, g),
                    I = Re.pointRef(e, v),
                    F = "";
                  if (!x && !D) {
                    var M = O.current,
                      [R] = Re.leaf(e, M),
                      {
                        path: j
                      } = M,
                      {
                        offset: B
                      } = g,
                      N = R.text.slice(B);
                    N.length > 0 && (e.apply({
                      type: "remove_text",
                      path: j,
                      offset: B,
                      text: N
                    }), F = N);
                  }
                  if (T.reverse().map(e => e.unref()).filter(e => null !== e).forEach(t => Pt.removeNodes(e, {
                    at: t,
                    voids: s
                  })), !C) {
                    var L = I.current,
                      [V] = Re.leaf(e, L),
                      {
                        path: K
                      } = L,
                      q = x ? g.offset : 0,
                      H = V.text.slice(q, v.offset);
                    H.length > 0 && (e.apply({
                      type: "remove_text",
                      path: K,
                      offset: q,
                      text: H
                    }), F = H);
                  }
                  !x && w && I.current && O.current && Pt.mergeNodes(e, {
                    at: I.current,
                    hanging: !0,
                    voids: s
                  }), c && o && "character" === i && F.length > 1 && F.match(/[\u0E00-\u0E7F]+/) && Pt.insertText(e, F.slice(0, F.length - a));
                  var U = O.unref(),
                    Z = I.unref(),
                    $ = o ? U || Z : Z || U;
                  null == t.at && $ && Pt.select(e, $);
                }
              }
            });
          },
          Wn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1
                } = n,
                {
                  at: i = We(e)
                } = n;
              if (t.length) {
                if (Ee.isRange(i)) {
                  if (r || (i = Re.unhangRange(e, i, {
                    voids: o
                  })), Ee.isCollapsed(i)) i = i.anchor;else {
                    var [, a] = Ee.edges(i);
                    if (!o && Re.void(e, {
                      at: a
                    })) return;
                    var s = Re.pointRef(e, a);
                    Pt.delete(e, {
                      at: i
                    }), i = s.unref();
                  }
                } else fe.isPath(i) && (i = Re.start(e, i));
                if (o || !Re.void(e, {
                  at: i
                })) {
                  var l = Re.above(e, {
                    at: i,
                    match: t => Pe.isElement(t) && Re.isInline(e, t),
                    mode: "highest",
                    voids: o
                  });
                  if (l) {
                    var [, u] = l;
                    if (Re.isEnd(e, i, u)) i = Re.after(e, u);else if (Re.isStart(e, i, u)) {
                      i = Re.before(e, u);
                    }
                  }
                  var c = Re.above(e, {
                      match: t => Pe.isElement(t) && Re.isBlock(e, t),
                      at: i,
                      voids: o
                    }),
                    [, d] = c,
                    p = Re.isStart(e, i, d),
                    h = Re.isEnd(e, i, d),
                    f = p && h,
                    m = !p || p && h,
                    g = !h,
                    [, v] = Te.first({
                      children: t
                    }, []),
                    [, y] = Te.last({
                      children: t
                    }, []),
                    b = [],
                    w = t => {
                      var [n, r] = t;
                      return !(0 === r.length) && (!!f || !(m && fe.isAncestor(r, v) && Pe.isElement(n) && !e.isVoid(n) && !e.isInline(n)) && !(g && fe.isAncestor(r, y) && Pe.isElement(n) && !e.isVoid(n) && !e.isInline(n)));
                    };
                  for (var x of Te.nodes({
                    children: t
                  }, {
                    pass: w
                  })) w(x) && b.push(x);
                  var D = [],
                    C = [],
                    S = [],
                    E = !0,
                    _ = !1;
                  for (var [P] of b) Pe.isElement(P) && !e.isInline(P) ? (E = !1, _ = !0, C.push(P)) : E ? D.push(P) : S.push(P);
                  var [k] = Re.nodes(e, {
                      at: i,
                      match: t => Ge.isText(t) || Re.isInline(e, t),
                      mode: "highest",
                      voids: o
                    }),
                    [, A] = k,
                    z = Re.isStart(e, i, A),
                    T = Re.isEnd(e, i, A),
                    O = Re.pathRef(e, h && !S.length ? fe.next(d) : d),
                    I = Re.pathRef(e, T ? fe.next(A) : A);
                  Pt.splitNodes(e, {
                    at: i,
                    match: t => _ ? Pe.isElement(t) && Re.isBlock(e, t) : Ge.isText(t) || Re.isInline(e, t),
                    mode: _ ? "lowest" : "highest",
                    always: _ && (!p || D.length > 0) && (!h || S.length > 0),
                    voids: o
                  });
                  var F,
                    M = Re.pathRef(e, !z || z && T ? fe.next(A) : A);
                  if (Pt.insertNodes(e, D, {
                    at: M.current,
                    match: t => Ge.isText(t) || Re.isInline(e, t),
                    mode: "highest",
                    voids: o
                  }), f && !D.length && C.length && !S.length && Pt.delete(e, {
                    at: d,
                    voids: o
                  }), Pt.insertNodes(e, C, {
                    at: O.current,
                    match: t => Pe.isElement(t) && Re.isBlock(e, t),
                    mode: "lowest",
                    voids: o
                  }), Pt.insertNodes(e, S, {
                    at: I.current,
                    match: t => Ge.isText(t) || Re.isInline(e, t),
                    mode: "highest",
                    voids: o
                  }), !n.at) if (S.length > 0 && I.current ? F = fe.previous(I.current) : C.length > 0 && O.current ? F = fe.previous(O.current) : M.current && (F = fe.previous(M.current)), F) {
                    var R = Re.end(e, F);
                    Pt.select(e, R);
                  }
                  M.unref(), O.unref(), I.unref();
                }
              }
            });
          },
          Yn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                edge: n = "anchor"
              } = t,
              {
                selection: r
              } = e;
            if (r) if ("anchor" === n) Pt.select(e, r.anchor);else if ("focus" === n) Pt.select(e, r.focus);else if ("start" === n) {
              var [o] = Ee.edges(r);
              Pt.select(e, o);
            } else if ("end" === n) {
              var [, i] = Ee.edges(r);
              Pt.select(e, i);
            }
          },
          Xn = e => {
            var {
              selection: t
            } = e;
            t && e.apply({
              type: "set_selection",
              properties: t,
              newProperties: null
            });
          },
          Qn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e,
              {
                distance: r = 1,
                unit: o = "character",
                reverse: i = !1
              } = t,
              {
                edge: a = null
              } = t;
            if (n) {
              "start" === a && (a = Ee.isBackward(n) ? "focus" : "anchor"), "end" === a && (a = Ee.isBackward(n) ? "anchor" : "focus");
              var {
                  anchor: s,
                  focus: l
                } = n,
                u = {
                  distance: r,
                  unit: o,
                  ignoreNonSelectable: !0
                },
                c = {};
              if (null == a || "anchor" === a) {
                var d = i ? Re.before(e, s, u) : Re.after(e, s, u);
                d && (c.anchor = d);
              }
              if (null == a || "focus" === a) {
                var p = i ? Re.before(e, l, u) : Re.after(e, l, u);
                p && (c.focus = p);
              }
              Pt.setSelection(e, c);
            }
          },
          Jn = (e, t) => {
            var {
              selection: n
            } = e;
            if (t = Re.range(e, t), n) Pt.setSelection(e, t);else {
              if (!Ee.isRange(t)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(Ke.stringify(t)));
              e.apply({
                type: "set_selection",
                properties: n,
                newProperties: t
              });
            }
          };
        function er(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function tr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? er(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : er(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var nr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r
              } = e,
              {
                edge: o = "both"
              } = n;
            if (r) {
              "start" === o && (o = Ee.isBackward(r) ? "focus" : "anchor"), "end" === o && (o = Ee.isBackward(r) ? "anchor" : "focus");
              var {
                  anchor: i,
                  focus: a
                } = r,
                s = "anchor" === o ? i : a;
              Pt.setSelection(e, {
                ["anchor" === o ? "anchor" : "focus"]: tr(tr({}, s), t)
              });
            }
          },
          rr = (e, t) => {
            var {
                selection: n
              } = e,
              r = {},
              o = {};
            if (n) {
              for (var i in t) ("anchor" === i && null != t.anchor && !Le.equals(t.anchor, n.anchor) || "focus" === i && null != t.focus && !Le.equals(t.focus, n.focus) || "anchor" !== i && "focus" !== i && t[i] !== n[i]) && (r[i] = n[i], o[i] = t[i]);
              Object.keys(r).length > 0 && e.apply({
                type: "set_selection",
                properties: r,
                newProperties: o
              });
            }
          },
          or = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1,
                  mode: i = "lowest"
                } = n,
                {
                  at: a,
                  match: s,
                  select: l
                } = n;
              if (Te.isNode(t) && (t = [t]), 0 !== t.length) {
                var [u] = t;
                if (a || (a = We(e), l = !0), null == l && (l = !1), Ee.isRange(a)) if (r || (a = Re.unhangRange(e, a, {
                  voids: o
                })), Ee.isCollapsed(a)) a = a.anchor;else {
                  var [, c] = Ee.edges(a),
                    d = Re.pointRef(e, c);
                  Pt.delete(e, {
                    at: a
                  }), a = d.unref();
                }
                if (Le.isPoint(a)) {
                  null == s && (s = Ge.isText(u) ? e => Ge.isText(e) : e.isInline(u) ? t => Ge.isText(t) || Re.isInline(e, t) : t => Pe.isElement(t) && Re.isBlock(e, t));
                  var [p] = Re.nodes(e, {
                    at: a.path,
                    match: s,
                    mode: i,
                    voids: o
                  });
                  if (!p) return;
                  var [, h] = p,
                    f = Re.pathRef(e, h),
                    m = Re.isEnd(e, a, h);
                  Pt.splitNodes(e, {
                    at: a,
                    match: s,
                    mode: i,
                    voids: o
                  });
                  var g = f.unref();
                  a = m ? fe.next(g) : g;
                }
                var v = fe.parent(a),
                  y = a[a.length - 1];
                if (o || !Re.void(e, {
                  at: v
                })) {
                  for (var b of t) {
                    var w = v.concat(y);
                    y++, e.apply({
                      type: "insert_node",
                      path: w,
                      node: b
                    }), a = fe.next(a);
                  }
                  if (a = fe.previous(a), l) {
                    var x = Re.end(e, a);
                    x && Pt.select(e, x);
                  }
                }
              }
            });
          },
          ir = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  at: n = e.selection,
                  mode: r = "lowest",
                  voids: o = !1
                } = t,
                {
                  match: i
                } = t;
              if (null == i && (i = fe.isPath(n) ? Ye(e, n) : t => Pe.isElement(t) && Re.isBlock(e, t)), n) {
                var a = Re.nodes(e, {
                    at: n,
                    match: i,
                    mode: r,
                    voids: o
                  }),
                  s = Array.from(a, t => {
                    var [, n] = t;
                    return Re.pathRef(e, n);
                  });
                for (var l of s) {
                  var u = l.unref();
                  if (u.length < 2) throw new Error("Cannot lift node at a path [".concat(u, "] because it has a depth of less than `2`."));
                  var c = Re.node(e, fe.parent(u)),
                    [d, p] = c,
                    h = u[u.length - 1],
                    {
                      length: f
                    } = d.children;
                  if (1 === f) {
                    var m = fe.next(p);
                    Pt.moveNodes(e, {
                      at: u,
                      to: m,
                      voids: o
                    }), Pt.removeNodes(e, {
                      at: p,
                      voids: o
                    });
                  } else if (0 === h) Pt.moveNodes(e, {
                    at: u,
                    to: p,
                    voids: o
                  });else if (h === f - 1) {
                    var g = fe.next(p);
                    Pt.moveNodes(e, {
                      at: u,
                      to: g,
                      voids: o
                    });
                  } else {
                    var v = fe.next(u),
                      y = fe.next(p);
                    Pt.splitNodes(e, {
                      at: v,
                      voids: o
                    }), Pt.moveNodes(e, {
                      at: u,
                      to: y,
                      voids: o
                    });
                  }
                }
              }
            });
          },
          ar = ["text"],
          sr = ["children"],
          lr = (e, t) => {
            if (Pe.isElement(t)) {
              var n = t;
              return !!Re.isVoid(e, t) || 1 === n.children.length && lr(e, n.children[0]);
            }
            return !Re.isEditor(t);
          },
          ur = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  match: n,
                  at: r = e.selection
                } = t,
                {
                  hanging: o = !1,
                  voids: i = !1,
                  mode: a = "lowest"
                } = t;
              if (r) {
                if (null == n) if (fe.isPath(r)) {
                  var [s] = Re.parent(e, r);
                  n = e => s.children.includes(e);
                } else n = t => Pe.isElement(t) && Re.isBlock(e, t);
                if (!o && Ee.isRange(r) && (r = Re.unhangRange(e, r, {
                  voids: i
                })), Ee.isRange(r)) if (Ee.isCollapsed(r)) r = r.anchor;else {
                  var [, l] = Ee.edges(r),
                    u = Re.pointRef(e, l);
                  Pt.delete(e, {
                    at: r
                  }), r = u.unref(), null == t.at && Pt.select(e, r);
                }
                var [c] = Re.nodes(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  }),
                  d = Re.previous(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  });
                if (c && d) {
                  var [p, h] = c,
                    [f, m] = d;
                  if (0 !== h.length && 0 !== m.length) {
                    var g,
                      v,
                      y = fe.next(m),
                      b = fe.common(h, m),
                      w = fe.isSibling(h, m),
                      x = Array.from(Re.levels(e, {
                        at: h
                      }), e => {
                        var [t] = e;
                        return t;
                      }).slice(b.length).slice(0, -1),
                      D = Re.above(e, {
                        at: h,
                        mode: "highest",
                        match: t => x.includes(t) && lr(e, t)
                      }),
                      C = D && Re.pathRef(e, D[1]);
                    if (Ge.isText(p) && Ge.isText(f)) {
                      var S = De(p, ar);
                      v = f.text.length, g = S;
                    } else {
                      if (!Pe.isElement(p) || !Pe.isElement(f)) throw new Error("Cannot merge the node at path [".concat(h, "] with the previous sibling because it is not the same kind: ").concat(Ke.stringify(p), " ").concat(Ke.stringify(f)));
                      S = De(p, sr);
                      v = f.children.length, g = S;
                    }
                    w || Pt.moveNodes(e, {
                      at: h,
                      to: y,
                      voids: i
                    }), C && Pt.removeNodes(e, {
                      at: C.current,
                      voids: i
                    }), Pe.isElement(f) && Re.isEmpty(e, f) || Ge.isText(f) && "" === f.text && 0 !== m[m.length - 1] ? Pt.removeNodes(e, {
                      at: m,
                      voids: i
                    }) : e.apply({
                      type: "merge_node",
                      path: y,
                      position: v,
                      properties: g
                    }), C && C.unref();
                  }
                }
              }
            });
          },
          cr = (e, t) => {
            Re.withoutNormalizing(e, () => {
              var {
                  to: n,
                  at: r = e.selection,
                  mode: o = "lowest",
                  voids: i = !1
                } = t,
                {
                  match: a
                } = t;
              if (r) {
                null == a && (a = fe.isPath(r) ? Ye(e, r) : t => Pe.isElement(t) && Re.isBlock(e, t));
                var s = Re.pathRef(e, n),
                  l = Re.nodes(e, {
                    at: r,
                    match: a,
                    mode: o,
                    voids: i
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return Re.pathRef(e, n);
                  });
                for (var c of u) {
                  var d = c.unref(),
                    p = s.current;
                  0 !== d.length && e.apply({
                    type: "move_node",
                    path: d,
                    newPath: p
                  }), s.current && fe.isSibling(p, d) && fe.isAfter(p, d) && (s.current = fe.next(s.current));
                }
                s.unref();
              }
            });
          },
          dr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  hanging: n = !1,
                  voids: r = !1,
                  mode: o = "lowest"
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = fe.isPath(i) ? Ye(e, i) : t => Pe.isElement(t) && Re.isBlock(e, t)), !n && Ee.isRange(i) && (i = Re.unhangRange(e, i, {
                  voids: r
                }));
                var s = Re.nodes(e, {
                    at: i,
                    match: a,
                    mode: o,
                    voids: r
                  }),
                  l = Array.from(s, t => {
                    var [, n] = t;
                    return Re.pathRef(e, n);
                  });
                for (var u of l) {
                  var c = u.unref();
                  if (c) {
                    var [d] = Re.node(e, c);
                    e.apply({
                      type: "remove_node",
                      path: c,
                      node: d
                    });
                  }
                }
              }
            });
          },
          pr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  match: r,
                  at: o = e.selection,
                  compare: i,
                  merge: a
                } = n,
                {
                  hanging: s = !1,
                  mode: l = "lowest",
                  split: u = !1,
                  voids: c = !1
                } = n;
              if (o) {
                if (null == r && (r = fe.isPath(o) ? Ye(e, o) : t => Pe.isElement(t) && Re.isBlock(e, t)), !s && Ee.isRange(o) && (o = Re.unhangRange(e, o, {
                  voids: c
                })), u && Ee.isRange(o)) {
                  if (Ee.isCollapsed(o) && Re.leaf(e, o.anchor)[0].text.length > 0) return;
                  var d = Re.rangeRef(e, o, {
                      affinity: "inward"
                    }),
                    [p, h] = Ee.edges(o),
                    f = "lowest" === l ? "lowest" : "highest",
                    m = Re.isEnd(e, h, h.path);
                  Pt.splitNodes(e, {
                    at: h,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !m
                  });
                  var g = Re.isStart(e, p, p.path);
                  Pt.splitNodes(e, {
                    at: p,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !g
                  }), o = d.unref(), null == n.at && Pt.select(e, o);
                }
                for (var [v, y] of (i || (i = (e, t) => e !== t), Re.nodes(e, {
                  at: o,
                  match: r,
                  mode: l,
                  voids: c
                }))) {
                  var b = {},
                    w = {};
                  if (0 !== y.length) {
                    var x = !1;
                    for (var D in t) "children" !== D && "text" !== D && i(t[D], v[D]) && (x = !0, v.hasOwnProperty(D) && (b[D] = v[D]), a ? null != t[D] && (w[D] = a(v[D], t[D])) : null != t[D] && (w[D] = t[D]));
                    x && e.apply({
                      type: "set_node",
                      path: y,
                      properties: b,
                      newProperties: w
                    });
                  }
                }
              }
            });
          },
          hr = (e, t) => {
            if (Ee.isCollapsed(t)) return t.anchor;
            var [, n] = Ee.edges(t),
              r = Re.pointRef(e, n);
            return Pt.delete(e, {
              at: t
            }), r.unref();
          },
          fr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  voids: r = !1
                } = t,
                {
                  match: o,
                  at: i = e.selection,
                  height: a = 0,
                  always: s = !1
                } = t;
              if (null == o && (o = t => Pe.isElement(t) && Re.isBlock(e, t)), Ee.isRange(i) && (i = hr(e, i)), fe.isPath(i)) {
                var l = i,
                  u = Re.point(e, l),
                  [c] = Re.parent(e, l);
                o = e => e === c, a = u.path.length - l.length + 1, i = u, s = !0;
              }
              if (i) {
                var d,
                  p = Re.pointRef(e, i, {
                    affinity: "backward"
                  });
                try {
                  var [h] = Re.nodes(e, {
                    at: i,
                    match: o,
                    mode: n,
                    voids: r
                  });
                  if (!h) return;
                  var f = Re.void(e, {
                    at: i,
                    mode: "highest"
                  });
                  if (!r && f) {
                    var [m, g] = f;
                    if (Pe.isElement(m) && e.isInline(m)) {
                      var v = Re.after(e, g);
                      if (!v) {
                        var y = fe.next(g);
                        Pt.insertNodes(e, {
                          text: ""
                        }, {
                          at: y,
                          voids: r
                        }), v = Re.point(e, y);
                      }
                      i = v, s = !0;
                    }
                    a = i.path.length - g.length + 1, s = !0;
                  }
                  d = Re.pointRef(e, i);
                  var b = i.path.length - a,
                    [, w] = h,
                    x = i.path.slice(0, b),
                    D = 0 === a ? i.offset : i.path[b] + 0;
                  for (var [C, S] of Re.levels(e, {
                    at: x,
                    reverse: !0,
                    voids: r
                  })) {
                    var E = !1;
                    if (S.length < w.length || 0 === S.length || !r && Pe.isElement(C) && Re.isVoid(e, C)) break;
                    var _ = p.current,
                      P = Re.isEnd(e, _, S);
                    if (s || !p || !Re.isEdge(e, _, S)) {
                      E = !0;
                      var k = Te.extractProps(C);
                      e.apply({
                        type: "split_node",
                        path: S,
                        position: D,
                        properties: k
                      });
                    }
                    D = S[S.length - 1] + (E || P ? 1 : 0);
                  }
                  if (null == t.at) {
                    var A = d.current || Re.end(e, []);
                    Pt.select(e, A);
                  }
                } finally {
                  var z;
                  p.unref(), null === (z = d) || void 0 === z || z.unref();
                }
              }
            });
          },
          mr = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Array.isArray(t) || (t = [t]);
            var r = {};
            for (var o of t) r[o] = null;
            Pt.setNodes(e, r, n);
          },
          gr = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            Re.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  split: r = !1,
                  voids: o = !1
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = fe.isPath(i) ? Ye(e, i) : t => Pe.isElement(t) && Re.isBlock(e, t)), fe.isPath(i) && (i = Re.range(e, i));
                var s = Ee.isRange(i) ? Re.rangeRef(e, i) : null,
                  l = Re.nodes(e, {
                    at: i,
                    match: a,
                    mode: n,
                    voids: o
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return Re.pathRef(e, n);
                  }).reverse(),
                  c = function (t) {
                    var n = t.unref(),
                      [i] = Re.node(e, n),
                      a = Re.range(e, n);
                    r && s && (a = Ee.intersection(s.current, a)), Pt.liftNodes(e, {
                      at: a,
                      match: e => Pe.isAncestor(i) && i.children.includes(e),
                      voids: o
                    });
                  };
                for (var d of u) c(d);
                s && s.unref();
              }
            });
          };
        function vr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function yr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? vr(Object(n), !0).forEach(function (t) {
              me(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var br = function (e, t) {
          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          Re.withoutNormalizing(e, () => {
            var {
                mode: r = "lowest",
                split: o = !1,
                voids: i = !1
              } = n,
              {
                match: a,
                at: s = e.selection
              } = n;
            if (s) {
              if (null == a && (a = fe.isPath(s) ? Ye(e, s) : e.isInline(t) ? t => Pe.isElement(t) && Re.isInline(e, t) || Ge.isText(t) : t => Pe.isElement(t) && Re.isBlock(e, t)), o && Ee.isRange(s)) {
                var [l, u] = Ee.edges(s),
                  c = Re.rangeRef(e, s, {
                    affinity: "inward"
                  });
                Pt.splitNodes(e, {
                  at: u,
                  match: a,
                  voids: i
                }), Pt.splitNodes(e, {
                  at: l,
                  match: a,
                  voids: i
                }), s = c.unref(), null == n.at && Pt.select(e, s);
              }
              var d = Array.from(Re.nodes(e, {
                at: s,
                match: e.isInline(t) ? t => Pe.isElement(t) && Re.isBlock(e, t) : e => Re.isEditor(e),
                mode: "lowest",
                voids: i
              }));
              for (var [, p] of d) {
                var h = Ee.isRange(s) ? Ee.intersection(s, Re.range(e, p)) : s;
                if (h) {
                  var f = Array.from(Re.nodes(e, {
                    at: h,
                    match: a,
                    mode: r,
                    voids: i
                  }));
                  if (f.length > 0) {
                    var m = function () {
                      var [n] = f,
                        r = f[f.length - 1],
                        [, o] = n,
                        [, a] = r;
                      if (0 === o.length && 0 === a.length) return "continue";
                      var s = fe.equals(o, a) ? fe.parent(o) : fe.common(o, a),
                        l = Re.range(e, o, a),
                        u = Re.node(e, s),
                        [c] = u,
                        d = s.length + 1,
                        p = fe.next(a.slice(0, d)),
                        h = yr(yr({}, t), {}, {
                          children: []
                        });
                      Pt.insertNodes(e, h, {
                        at: p,
                        voids: i
                      }), Pt.moveNodes(e, {
                        at: l,
                        match: e => Pe.isAncestor(c) && c.children.includes(e),
                        to: p.concat(0),
                        voids: i
                      });
                    }();
                    if ("continue" === m) continue;
                  }
                }
              }
            }
          });
        };
        function wr(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var xr = new WeakMap(),
          Dr = new WeakMap();
        class Cr {}
        class Sr extends Cr {
          constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            super();
            var {
              offset: t,
              path: n
            } = e;
            this.offset = t, this.path = n;
          }
        }
        class Er extends Cr {
          constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            super();
            var {
              offset: t,
              path: n
            } = e;
            this.offset = t, this.path = n;
          }
        }
        var _r = e => Dr.get(e);
        function Pr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function kr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pr(Object(n), !0).forEach(function (t) {
              wr(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ar = new WeakSet(),
          zr = e => {
            var t = [],
              n = e => {
                if (null != e) {
                  var r = t[t.length - 1];
                  if ("string" == typeof e) {
                    var o = {
                      text: e
                    };
                    Ar.add(o), e = o;
                  }
                  if (Ge.isText(e)) {
                    var i = e;
                    Ge.isText(r) && Ar.has(r) && Ar.has(i) && Ge.equals(r, i, {
                      loose: !0
                    }) ? r.text += i.text : t.push(i);
                  } else if (Pe.isElement(e)) t.push(e);else {
                    if (!(e instanceof Cr)) throw new Error("Unexpected hyperscript child object: ".concat(e));
                    var a = t[t.length - 1];
                    Ge.isText(a) || (n(""), a = t[t.length - 1]), e instanceof Sr ? ((e, t) => {
                      var n = e.text.length;
                      xr.set(e, [n, t]);
                    })(a, e) : e instanceof Er && ((e, t) => {
                      var n = e.text.length;
                      Dr.set(e, [n, t]);
                    })(a, e);
                  }
                }
              };
            for (var r of e.flat(1 / 0)) n(r);
            return t;
          };
        function Tr(e, t, n) {
          return kr(kr({}, t), {}, {
            children: zr(n)
          });
        }
        function Or(e, t, n) {
          var r = zr(n);
          if (r.length > 1) throw new Error("The <text> hyperscript tag must only contain a single node's worth of children.");
          var [o] = r;
          if (null == o && (o = {
            text: ""
          }), !Ge.isText(o)) throw new Error("\n    The <text> hyperscript tag can only contain text content as children.");
          return Ar.delete(o), Object.assign(o, t), o;
        }
        var Ir = e => (t, n, r) => {
          var o,
            i = [];
          for (var a of r) Ee.isRange(a) ? o = a : i.push(a);
          var s,
            l = zr(i),
            u = {},
            c = e();
          for (var [d, p] of (Object.assign(c, n), c.children = l, Te.texts(c))) {
            var h = (s = d, xr.get(s)),
              f = _r(d);
            if (null != h) {
              var [m] = h;
              u.anchor = {
                path: p,
                offset: m
              };
            }
            if (null != f) {
              var [g] = f;
              u.focus = {
                path: p,
                offset: g
              };
            }
          }
          if (u.anchor && !u.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
          if (!u.anchor && u.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
          return null != o ? c.selection = o : Ee.isRange(u) && (c.selection = u), c;
        };
        function Fr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Mr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Fr(Object(n), !0).forEach(function (t) {
              wr(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Rr = {
            anchor: function (e, t, n) {
              return new Sr(t);
            },
            cursor: function (e, t, n) {
              return [new Sr(t), new Er(t)];
            },
            editor: Ir(() => {
              var e = {
                children: [],
                operations: [],
                selection: null,
                marks: null,
                isElementReadOnly: () => !1,
                isInline: () => !1,
                isSelectable: () => !0,
                isVoid: () => !1,
                markableVoid: () => !1,
                onChange: () => {},
                apply: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return kt(e, ...n);
                },
                addMark: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Rt(e, ...n);
                },
                deleteBackward: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return qt(e, ...n);
                },
                deleteForward: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Ht(e, ...n);
                },
                deleteFragment: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Ut(e, ...n);
                },
                getFragment: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return zt(e, ...n);
                },
                insertBreak: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return sn(e, ...n);
                },
                insertSoftBreak: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return un(e, ...n);
                },
                insertFragment: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Wn(e, ...n);
                },
                insertNode: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return ln(e, ...n);
                },
                insertText: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return pn(e, ...n);
                },
                normalizeNode: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Tt(e, ...n);
                },
                removeMark: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Kn(e, ...n);
                },
                getDirtyPaths: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return At(e, ...n);
                },
                shouldNormalize: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Ot(e, ...n);
                },
                above: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return It(e, ...n);
                },
                after: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Nt(e, ...n);
                },
                before: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Kt(e, ...n);
                },
                collapse: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Yn(e, ...n);
                },
                delete: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Gn(e, ...n);
                },
                deselect: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Xn(e, ...n);
                },
                edges: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Zt(e, ...n);
                },
                elementReadOnly: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Wt(e, ...n);
                },
                end: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Yt(e, ...n);
                },
                first: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Xt(e, ...n);
                },
                fragment: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Qt(e, ...n);
                },
                getMarks: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Sn(e, ...n);
                },
                hasBlocks: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return nn(e, ...n);
                },
                hasInlines: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return rn(e, ...n);
                },
                hasPath: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return on(e, ...n);
                },
                hasTexts: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return an(e, ...n);
                },
                insertNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return or(e, ...n);
                },
                isBlock: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return hn(e, ...n);
                },
                isEdge: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return fn(e, ...n);
                },
                isEmpty: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return mn(e, ...n);
                },
                isEnd: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return gn(e, ...n);
                },
                isNormalizing: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return vn(e, ...n);
                },
                isStart: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return yn(e, ...n);
                },
                last: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return bn(e, ...n);
                },
                leaf: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return wn(e, ...n);
                },
                levels: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return xn(e, ...n);
                },
                liftNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return ir(e, ...n);
                },
                mergeNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return ur(e, ...n);
                },
                move: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Qn(e, ...n);
                },
                moveNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return cr(e, ...n);
                },
                next: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return En(e, ...n);
                },
                node: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return _n(e, ...n);
                },
                nodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Pn(e, ...n);
                },
                normalize: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return kn(e, ...n);
                },
                parent: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return An(e, ...n);
                },
                path: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return On(e, ...n);
                },
                pathRef: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return zn(e, ...n);
                },
                pathRefs: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Tn(e, ...n);
                },
                point: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Mn(e, ...n);
                },
                pointRef: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return In(e, ...n);
                },
                pointRefs: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Fn(e, ...n);
                },
                positions: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Rn(e, ...n);
                },
                previous: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return jn(e, ...n);
                },
                range: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Ln(e, ...n);
                },
                rangeRef: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Bn(e, ...n);
                },
                rangeRefs: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Nn(e, ...n);
                },
                removeNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return dr(e, ...n);
                },
                select: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Jn(e, ...n);
                },
                setNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return pr(e, ...n);
                },
                setNormalizing: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return qn(e, ...n);
                },
                setPoint: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return nr(e, ...n);
                },
                setSelection: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return rr(e, ...n);
                },
                splitNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return fr(e, ...n);
                },
                start: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Hn(e, ...n);
                },
                string: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Un(e, ...n);
                },
                unhangRange: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return Zn(e, ...n);
                },
                unsetNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return mr(e, ...n);
                },
                unwrapNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return gr(e, ...n);
                },
                void: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return tn(e, ...n);
                },
                withoutNormalizing: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return $n(e, ...n);
                },
                wrapNodes: function () {
                  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                  return br(e, ...n);
                }
              };
              return e;
            }),
            element: Tr,
            focus: function (e, t, n) {
              return new Er(t);
            },
            fragment: function (e, t, n) {
              return zr(n);
            },
            selection: function (e, t, n) {
              var r = n.find(e => e instanceof Sr),
                o = n.find(e => e instanceof Er);
              if (!r || null == r.offset || null == r.path) throw new Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
              if (!o || null == o.offset || null == o.path) throw new Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
              return kr({
                anchor: {
                  offset: r.offset,
                  path: r.path
                },
                focus: {
                  offset: o.offset,
                  path: o.path
                }
              }, t);
            },
            text: Or
          },
          jr = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              {
                elements: t = {}
              } = e,
              n = Nr(t),
              r = Mr(Mr(Mr({}, Rr), n), e.creators),
              o = Br(r);
            return o;
          },
          Br = e => function (t, n) {
            for (var o = arguments.length, i = new Array(o > 2 ? o - 2 : 0), a = 2; a < o; a++) i[a - 2] = arguments[a];
            var s = e[t];
            if (!s) throw new Error("No hyperscript creator found for tag: <".concat(t, ">"));
            null == n && (n = {}), (0, r.P)(n) || (i = [n].concat(i), n = {});
            var l = s(t, n, i = i.filter(e => Boolean(e)).flat());
            return l;
          },
          Nr = e => {
            var t = {},
              n = function (n) {
                var r = e[n];
                if ("object" != typeof r) throw new Error("Properties specified for a hyperscript shorthand should be an object, but for the custom element <".concat(n, ">  tag you passed: ").concat(r));
                t[n] = (e, t, n) => Tr(0, Mr(Mr({}, r), t), n);
              };
            for (var r in e) n(r);
            return t;
          },
          Lr = jr();
      },
      68223: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          __assign: () => i,
          __asyncDelegator: () => E,
          __asyncGenerator: () => S,
          __asyncValues: () => _,
          __await: () => C,
          __awaiter: () => f,
          __classPrivateFieldGet: () => T,
          __classPrivateFieldIn: () => I,
          __classPrivateFieldSet: () => O,
          __createBinding: () => g,
          __decorate: () => s,
          __esDecorate: () => u,
          __exportStar: () => v,
          __extends: () => o,
          __generator: () => m,
          __importDefault: () => z,
          __importStar: () => A,
          __makeTemplateObject: () => P,
          __metadata: () => h,
          __param: () => l,
          __propKey: () => d,
          __read: () => b,
          __rest: () => a,
          __runInitializers: () => c,
          __setFunctionName: () => p,
          __spread: () => w,
          __spreadArray: () => D,
          __spreadArrays: () => x,
          __values: () => y
        });
        var r = function (e, t) {
          return r = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, r(e, t);
        };
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var i = function () {
          return i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, i.apply(this, arguments);
        };
        function a(e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        }
        function s(e, t, n, r) {
          var o,
            i = arguments.length,
            a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
          return i > 3 && a && Object.defineProperty(t, n, a), a;
        }
        function l(e, t) {
          return function (n, r) {
            t(n, r, e);
          };
        }
        function u(e, t, n, r, o, i) {
          function a(e) {
            if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
            return e;
          }
          for (var s, l = r.kind, u = "getter" === l ? "get" : "setter" === l ? "set" : "value", c = !t && e ? r.static ? e : e.prototype : null, d = t || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), p = !1, h = n.length - 1; h >= 0; h--) {
            var f = {};
            for (var m in r) f[m] = "access" === m ? {} : r[m];
            for (var m in r.access) f.access[m] = r.access[m];
            f.addInitializer = function (e) {
              if (p) throw new TypeError("Cannot add initializers after decoration has completed");
              i.push(a(e || null));
            };
            var g = (0, n[h])("accessor" === l ? {
              get: d.get,
              set: d.set
            } : d[u], f);
            if ("accessor" === l) {
              if (void 0 === g) continue;
              if (null === g || "object" != typeof g) throw new TypeError("Object expected");
              (s = a(g.get)) && (d.get = s), (s = a(g.set)) && (d.set = s), (s = a(g.init)) && o.push(s);
            } else (s = a(g)) && ("field" === l ? o.push(s) : d[u] = s);
          }
          c && Object.defineProperty(c, r.name, d), p = !0;
        }
        function c(e, t, n) {
          for (var r = arguments.length > 2, o = 0; o < t.length; o++) n = r ? t[o].call(e, n) : t[o].call(e);
          return r ? n : void 0;
        }
        function d(e) {
          return "symbol" == typeof e ? e : "".concat(e);
        }
        function p(e, t, n) {
          return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
            configurable: !0,
            value: n ? "".concat(n, " ", t) : t
          });
        }
        function h(e, t) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
        }
        function f(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        }
        function m(e, t) {
          var n,
            r,
            o,
            i,
            a = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
          return i = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;
          function s(s) {
            return function (l) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                  if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
                  switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                    case 0:
                    case 1:
                      o = s;
                      break;
                    case 4:
                      return a.label++, {
                        value: s[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                        a.label = s[1];
                        break;
                      }
                      if (6 === s[0] && a.label < o[1]) {
                        a.label = o[1], o = s;
                        break;
                      }
                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(s);
                        break;
                      }
                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  s = t.call(e, a);
                } catch (e) {
                  s = [6, e], r = 0;
                } finally {
                  n = o = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                  value: s[0] ? s[1] : void 0,
                  done: !0
                };
              }([s, l]);
            };
          }
        }
        var g = Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n);
          var o = Object.getOwnPropertyDescriptor(t, n);
          o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
            enumerable: !0,
            get: function () {
              return t[n];
            }
          }), Object.defineProperty(e, r, o);
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        };
        function v(e, t) {
          for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || g(t, e, n);
        }
        function y(e) {
          var t = "function" == typeof Symbol && Symbol.iterator,
            n = t && e[t],
            r = 0;
          if (n) return n.call(e);
          if (e && "number" == typeof e.length) return {
            next: function () {
              return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
              };
            }
          };
          throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function b(e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            o,
            i = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = i.return) && n.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        }
        function w() {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(b(arguments[t]));
          return e;
        }
        function x() {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
          var r = Array(e),
            o = 0;
          for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
          return r;
        }
        function D(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || Array.prototype.slice.call(t));
        }
        function C(e) {
          return this instanceof C ? (this.v = e, this) : new C(e);
        }
        function S(e, t, n) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var r,
            o = n.apply(e, t || []),
            i = [];
          return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
            return this;
          }, r;
          function a(e) {
            o[e] && (r[e] = function (t) {
              return new Promise(function (n, r) {
                i.push([e, t, n, r]) > 1 || s(e, t);
              });
            });
          }
          function s(e, t) {
            try {
              (n = o[e](t)).value instanceof C ? Promise.resolve(n.value.v).then(l, u) : c(i[0][2], n);
            } catch (e) {
              c(i[0][3], e);
            }
            var n;
          }
          function l(e) {
            s("next", e);
          }
          function u(e) {
            s("throw", e);
          }
          function c(e, t) {
            e(t), i.shift(), i.length && s(i[0][0], i[0][1]);
          }
        }
        function E(e) {
          var t, n;
          return t = {}, r("next"), r("throw", function (e) {
            throw e;
          }), r("return"), t[Symbol.iterator] = function () {
            return this;
          }, t;
          function r(r, o) {
            t[r] = e[r] ? function (t) {
              return (n = !n) ? {
                value: C(e[r](t)),
                done: !1
              } : o ? o(t) : t;
            } : o;
          }
        }
        function _(e) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var t,
            n = e[Symbol.asyncIterator];
          return n ? n.call(e) : (e = y(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
            return this;
          }, t);
          function r(n) {
            t[n] = e[n] && function (t) {
              return new Promise(function (r, o) {
                (function (e, t, n, r) {
                  Promise.resolve(r).then(function (t) {
                    e({
                      value: t,
                      done: n
                    });
                  }, t);
                })(r, o, (t = e[n](t)).done, t.value);
              });
            };
          }
        }
        function P(e, t) {
          return Object.defineProperty ? Object.defineProperty(e, "raw", {
            value: t
          }) : e.raw = t, e;
        }
        var k = Object.create ? function (e, t) {
          Object.defineProperty(e, "default", {
            enumerable: !0,
            value: t
          });
        } : function (e, t) {
          e.default = t;
        };
        function A(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && g(t, e, n);
          return k(t, e), t;
        }
        function z(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function T(e, t, n, r) {
          if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
          if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
          return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
        }
        function O(e, t, n, r, o) {
          if ("m" === r) throw new TypeError("Private method is not writable");
          if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
          if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
          return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
        }
        function I(e, t) {
          if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
          return "function" == typeof e ? t === e : e.has(t);
        }
      },
      17855: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        n(68223).__exportStar(n(65297), t);
      },
      65297: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.slateDemoHtmlToSlateConfig = t.payloadHtmlToSlateConfig = t.htmlToSlateConfig = t.slateDemoSlateToHtmlConfig = t.payloadSlateToHtmlConfig = t.slateToHtmlConfig = t.slateToHtml = t.htmlToSlate = void 0;
        var r = n(20075);
        Object.defineProperty(t, "htmlToSlate", {
          enumerable: !0,
          get: function () {
            return r.htmlToSlate;
          }
        });
        var o = n(65433);
        Object.defineProperty(t, "slateToHtml", {
          enumerable: !0,
          get: function () {
            return o.slateToHtml;
          }
        });
        var i = n(83511);
        Object.defineProperty(t, "slateToHtmlConfig", {
          enumerable: !0,
          get: function () {
            return i.slateToDomConfig;
          }
        }), Object.defineProperty(t, "payloadSlateToHtmlConfig", {
          enumerable: !0,
          get: function () {
            return i.payloadSlateToDomConfig;
          }
        }), Object.defineProperty(t, "slateDemoSlateToHtmlConfig", {
          enumerable: !0,
          get: function () {
            return i.slateDemoSlateToDomConfig;
          }
        });
        var a = n(97074);
        Object.defineProperty(t, "htmlToSlateConfig", {
          enumerable: !0,
          get: function () {
            return a.config;
          }
        });
        var s = n(71192);
        Object.defineProperty(t, "payloadHtmlToSlateConfig", {
          enumerable: !0,
          get: function () {
            return s.config;
          }
        });
        var l = n(15641);
        Object.defineProperty(t, "slateDemoHtmlToSlateConfig", {
          enumerable: !0,
          get: function () {
            return l.config;
          }
        });
      },
      97074: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(89432),
          o = n(83511);
        t.config = {
          elementAttributeTransform: ({
            el: e
          }) => {
            const t = {},
              n = {
                align: "textAlign"
              };
            return Object.keys(n).forEach(r => {
              const i = n[r],
                a = (0, o.extractCssFromStyle)(e, i);
              a && (t[r] = a);
            }), t;
          },
          elementTags: {
            a: e => ({
              type: "link",
              newTab: e && "_blank" === (0, r.getAttributeValue)(e, "target"),
              url: e && (0, r.getAttributeValue)(e, "href")
            }),
            blockquote: () => ({
              type: "blockquote"
            }),
            h1: () => ({
              type: "h1"
            }),
            h2: () => ({
              type: "h2"
            }),
            h3: () => ({
              type: "h3"
            }),
            h4: () => ({
              type: "h4"
            }),
            h5: () => ({
              type: "h5"
            }),
            h6: () => ({
              type: "h6"
            }),
            li: () => ({
              type: "li"
            }),
            ol: () => ({
              type: "ol"
            }),
            p: () => ({
              type: "p"
            }),
            ul: () => ({
              type: "ul"
            })
          },
          textTags: {
            code: () => ({
              code: !0
            }),
            pre: () => ({
              code: !0
            }),
            del: () => ({
              strikethrough: !0
            }),
            em: () => ({
              italic: !0
            }),
            i: () => ({
              italic: !0
            }),
            s: () => ({
              strikethrough: !0
            }),
            strong: () => ({
              bold: !0
            }),
            u: () => ({
              underline: !0
            })
          },
          htmlPreProcessString: e => e.replace(/<pre[^>]*>/g, "<code>").replace(/<\/pre>/g, "</code>"),
          filterWhitespaceNodes: !0,
          convertBrToLineBreak: !0,
          trimWhiteSpace: !0
        };
      },
      71192: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(97074),
          o = n(89432);
        t.config = Object.assign(Object.assign({}, r.config), {
          elementTags: Object.assign(Object.assign({}, r.config.elementTags), {
            a: e => ({
              type: "link",
              linkType: e && (0, o.getAttributeValue)(e, "data-link-type"),
              newTab: e && "_blank" === (0, o.getAttributeValue)(e, "target"),
              url: e && (0, o.getAttributeValue)(e, "href")
            })
          })
        });
      },
      15641: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.config = void 0;
        const r = n(97074);
        t.config = Object.assign(Object.assign({}, r.config), {
          elementTags: {
            blockquote: () => ({
              type: "block-quote"
            }),
            h1: () => ({
              type: "heading-one"
            }),
            h2: () => ({
              type: "heading-two"
            }),
            li: () => ({
              type: "list-item"
            }),
            ol: () => ({
              type: "numbered-list"
            }),
            ul: () => ({
              type: "bulleted-list"
            }),
            p: () => ({
              type: "paragraph"
            })
          }
        });
      },
      20075: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.htmlToSlate = void 0;
        const r = n(38911),
          o = n(77479),
          i = n(47915),
          a = n(89432),
          s = n(58480),
          l = n(97074),
          u = n(15191),
          c = n(99357),
          d = ({
            el: e,
            config: t = l.config,
            index: n = 0,
            childrenLength: s = 0,
            context: m = ""
          }) => {
            var g, v;
            if (e.type !== o.ElementType.Tag && e.type !== o.ElementType.Text) return null;
            const y = e,
              b = (0, a.getName)(y),
              w = (0, c.getContext)(b) || m,
              x = n === s - 1;
            (null === (g = y.prev) || void 0 === g ? void 0 : g.type) === o.ElementType.Text && (null === (v = y.next) || void 0 === v || v.type, o.ElementType.Text);
            if ("br" === b && t.convertBrToLineBreak && "preserve" !== m) return [(0, r.jsx)("text", {
              text: m ? "\n" : ""
            }, [])];
            const D = y.childNodes ? y.childNodes.map((e, n) => d({
              el: e,
              config: t,
              index: n,
              childrenLength: y.childNodes.length,
              context: w
            })).filter(e => e).filter(e => !h(e)).map(e => f(e)).flat() : [];
            if ("body" === (0, a.getName)(y)) return (0, r.jsx)("fragment", {}, D);
            if (t.elementTags[b]) {
              let e = t.elementTags[b](y);
              return t.elementAttributeTransform && (e = Object.assign(Object.assign({}, e), t.elementAttributeTransform({
                el: y
              }))), (0, r.jsx)("element", e, D);
            }
            if (t.textTags[b] || e.type === o.ElementType.Text) {
              const o = p({
                  el: y,
                  config: t
                }),
                l = (0, c.processTextValue)({
                  text: (0, a.textContent)(e),
                  context: w,
                  isInlineStart: 0 === n,
                  isInlineEnd: Number.isInteger(s) && x,
                  isNextSiblingBlock: e.next && (0, i.isTag)(e.next) && (0, u.isBlock)(e.next.tagName) || !1,
                  shouldTrimWhiteSpace: t.trimWhiteSpace
                });
              if ("" === l) return null;
              if ((0, c.isAllWhitespace)(l)) {
                if (t.filterWhitespaceNodes && !w) return null;
                if (t.convertBrToLineBreak) {
                  if (y.prev && "br" === (0, a.getName)(y.prev)) return null;
                  if (y.next && "br" === (0, a.getName)(y.next)) return null;
                }
              }
              return [(0, r.jsx)("text", Object.assign(Object.assign({}, o), {
                text: l
              }), [])];
            }
            return D;
          },
          p = ({
            el: e,
            config: t = l.config
          }) => {
            let n = {};
            const r = (0, a.getChildren)(e);
            if (r.length) [e, ...r.flat()].forEach(e => {
              const r = (0, a.getName)(e),
                o = t.textTags[r] ? t.textTags[r](e) : {};
              n = Object.assign(Object.assign({}, n), o);
            }), 1 === r.length && (0, a.getChildren)(r[0]).length && (n = Object.assign(Object.assign({}, n), p({
              el: r[0],
              config: t
            })));else {
              const r = (0, a.getName)(e),
                o = t.textTags[r] ? t.textTags[r](e) : {};
              n = Object.assign({}, o);
            }
            return n;
          };
        t.htmlToSlate = (e, t = l.config) => {
          let n = [];
          const r = new i.DomHandler((e, r) => {
              if (e) ;else {
                const e = t.htmlUpdaterMap ? Object.entries(t.htmlUpdaterMap) : [];
                for (const [t, n] of e) (0, s.selectAll)(t, r).forEach(e => {
                  if ((0, i.isTag)(e)) {
                    const t = n(e);
                    null !== t && t !== e && ("string" == typeof t ? (0, a.replaceElement)(e, (0, o.parseDocument)(t)) : (0, a.replaceElement)(e, t));
                  }
                });
                n = r.map(e => d({
                  el: e,
                  config: t
                })).filter(e => e).map(e => e.children ? e : {
                  children: e
                }).filter(e => !h(e)).map(e => f(e));
              }
            }),
            u = new o.Parser(r, {
              decodeEntities: !0
            });
          let c = e;
          return t.htmlPreProcessString instanceof Function && (c = t.htmlPreProcessString(e)), u.write(c), u.end(), n;
        };
        const h = e => {
            const t = Object.keys(e);
            return "children" in e && 0 === e.children.length && 1 === t.length;
          },
          f = e => {
            Object.keys(e);
            return "children" in e ? (0 === e.children.length && e.children.push({
              text: ""
            }), e) : e;
          };
      },
      99357: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getContext = t.isAllWhitespace = t.minifyText = t.processTextValue = void 0;
        const r = n(15191);
        t.processTextValue = ({
          text: e,
          context: n = "",
          isInlineStart: r = !1,
          isInlineEnd: o = !1,
          isNextSiblingBlock: i = !1,
          shouldTrimWhiteSpace: a = !0
        }) => {
          let s = e;
          return "preserve" === n || (s = (0, t.minifyText)(s, a), "block" === n && (r && (s = s.trimStart()), (o || i) && (s = s.trimEnd()))), s;
        };
        t.minifyText = (e, t) => t ? i(o(e)) : o(e);
        const o = e => e.replace(/(?:\r\n|\r|\n)/g, " "),
          i = e => e.replace(/ +(?= )/g, "");
        t.isAllWhitespace = e => !/[^\t\n\r ]/.test(e);
        t.getContext = e => e && "" !== e.trim() ? a(e) ? "preserve" : (0, r.isBlock)(e) ? "block" : "inline" : "";
        const a = e => ["code", "pre", "xmp"].includes(e);
      },
      65433: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.slateToHtml = void 0;
        const r = n(97220),
          o = n(83511);
        t.slateToHtml = (e, t = o.slateToDomConfig) => {
          const n = (0, o.slateToDom)(e, t);
          return (0, r.default)(n, {
            encodeEntities: "encodeEntities" in t && t.encodeEntities
          });
        };
      },
      79082: (e, t, n) => {
        let r = n(78590),
          o = n(66685),
          i = n(90182);
        e.exports = function (e) {
          let t = r(e);
          return async e => {
            let n = await t.process(e, {
              parser: i,
              from: void 0
            });
            return o(n);
          };
        };
      },
      83877: (e, t, n) => {
        let r = n(34652),
          o = n(90182),
          i = n(79082),
          a = n(84765);
        e.exports = {
          objectify: r,
          parse: o,
          async: i,
          sync: a
        };
      },
      34652: (e, t, n) => {
        let r = n(40599),
          o = {
            boxFlex: !0,
            boxFlexGroup: !0,
            columnCount: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            strokeDashoffset: !0,
            strokeOpacity: !0,
            strokeWidth: !0
          };
        function i(e) {
          return void 0 === e.nodes || a(e);
        }
        function a(e) {
          let t,
            n = {};
          return e.each(e => {
            if ("atrule" === e.type) t = "@" + e.name, e.params && (t += " " + e.params), void 0 === n[t] ? n[t] = i(e) : Array.isArray(n[t]) ? n[t].push(i(e)) : n[t] = [n[t], i(e)];else if ("rule" === e.type) {
              let t = a(e);
              if (n[e.selector]) for (let r in t) n[e.selector][r] = t[r];else n[e.selector] = t;
            } else if ("decl" === e.type) {
              t = "-" === e.prop[0] && "-" === e.prop[1] || e.parent && ":export" === e.parent.selector ? e.prop : r(e.prop);
              let i = e.value;
              !isNaN(e.value) && o[t] && (i = parseFloat(e.value)), e.important && (i += " !important"), void 0 === n[t] ? n[t] = i : Array.isArray(n[t]) ? n[t].push(i) : n[t] = [n[t], i];
            }
          }), n;
        }
        e.exports = a;
      },
      90182: (e, t, n) => {
        let r = n(78590),
          o = /\s*!important\s*$/i,
          i = {
            "box-flex": !0,
            "box-flex-group": !0,
            "column-count": !0,
            flex: !0,
            "flex-grow": !0,
            "flex-positive": !0,
            "flex-shrink": !0,
            "flex-negative": !0,
            "font-weight": !0,
            "line-clamp": !0,
            "line-height": !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            "tab-size": !0,
            widows: !0,
            "z-index": !0,
            zoom: !0,
            "fill-opacity": !0,
            "stroke-dashoffset": !0,
            "stroke-opacity": !0,
            "stroke-width": !0
          };
        function a(e, t, n) {
          !1 !== n && null !== n && (t.startsWith("--") || (t = t.replace(/([A-Z])/g, "-$1").replace(/^ms-/, "-ms-").toLowerCase()), "number" == typeof n && (0 === n || i[t] ? n = n.toString() : n += "px"), "css-float" === t && (t = "float"), o.test(n) ? (n = n.replace(o, ""), e.push(r.decl({
            prop: t,
            value: n,
            important: !0
          }))) : e.push(r.decl({
            prop: t,
            value: n
          })));
        }
        function s(e, t, n) {
          let o = r.atRule({
            name: t[1],
            params: t[3] || ""
          });
          "object" == typeof n && (o.nodes = [], l(n, o)), e.push(o);
        }
        function l(e, t) {
          let n, o, i;
          for (n in e) if (o = e[n], null != o) if ("@" === n[0]) {
            let e = n.match(/@(\S+)(\s+([\W\w]*)\s*)?/);
            if (Array.isArray(o)) for (let n of o) s(t, e, n);else s(t, e, o);
          } else if (Array.isArray(o)) for (let e of o) a(t, n, e);else "object" == typeof o ? (i = r.rule({
            selector: n
          }), l(o, i), t.push(i)) : a(t, n, o);
        }
        e.exports = function (e) {
          let t = r.root();
          return l(e, t), t;
        };
      },
      66685: (e, t, n) => {
        let r = n(34652);
        e.exports = function (e) {
          return console && console.warn && e.warnings().forEach(e => {
            let t = e.plugin || "PostCSS";
            console.warn(t + ": " + e.text);
          }), r(e.root);
        };
      },
      84765: (e, t, n) => {
        let r = n(78590),
          o = n(66685),
          i = n(90182);
        e.exports = function (e) {
          let t = r(e);
          return e => {
            let n = t.process(e, {
              parser: i,
              from: void 0
            });
            return o(n);
          };
        };
      },
      39926: (e, t, n) => {
        "use strict";

        let r = n(10795);
        class o extends r {
          constructor(e) {
            super(e), this.type = "atrule";
          }
          append(...e) {
            return this.proxyOf.nodes || (this.nodes = []), super.append(...e);
          }
          prepend(...e) {
            return this.proxyOf.nodes || (this.nodes = []), super.prepend(...e);
          }
        }
        e.exports = o, o.default = o, r.registerAtRule(o);
      },
      37257: (e, t, n) => {
        "use strict";

        let r = n(34421);
        class o extends r {
          constructor(e) {
            super(e), this.type = "comment";
          }
        }
        e.exports = o, o.default = o;
      },
      10795: (e, t, n) => {
        "use strict";

        let r,
          o,
          i,
          a,
          {
            isClean: s,
            my: l
          } = n(16356),
          u = n(76663),
          c = n(37257),
          d = n(34421);
        function p(e) {
          return e.map(e => (e.nodes && (e.nodes = p(e.nodes)), delete e.source, e));
        }
        function h(e) {
          if (e[s] = !1, e.proxyOf.nodes) for (let t of e.proxyOf.nodes) h(t);
        }
        class f extends d {
          append(...e) {
            for (let t of e) {
              let e = this.normalize(t, this.last);
              for (let t of e) this.proxyOf.nodes.push(t);
            }
            return this.markDirty(), this;
          }
          cleanRaws(e) {
            if (super.cleanRaws(e), this.nodes) for (let t of this.nodes) t.cleanRaws(e);
          }
          each(e) {
            if (!this.proxyOf.nodes) return;
            let t,
              n,
              r = this.getIterator();
            for (; this.indexes[r] < this.proxyOf.nodes.length && (t = this.indexes[r], n = e(this.proxyOf.nodes[t], t), !1 !== n);) this.indexes[r] += 1;
            return delete this.indexes[r], n;
          }
          every(e) {
            return this.nodes.every(e);
          }
          getIterator() {
            this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach += 1;
            let e = this.lastEach;
            return this.indexes[e] = 0, e;
          }
          getProxyProcessor() {
            return {
              get: (e, t) => "proxyOf" === t ? e : e[t] ? "each" === t || "string" == typeof t && t.startsWith("walk") ? (...n) => e[t](...n.map(e => "function" == typeof e ? (t, n) => e(t.toProxy(), n) : e)) : "every" === t || "some" === t ? n => e[t]((e, ...t) => n(e.toProxy(), ...t)) : "root" === t ? () => e.root().toProxy() : "nodes" === t ? e.nodes.map(e => e.toProxy()) : "first" === t || "last" === t ? e[t].toProxy() : e[t] : e[t],
              set: (e, t, n) => (e[t] === n || (e[t] = n, "name" !== t && "params" !== t && "selector" !== t || e.markDirty()), !0)
            };
          }
          index(e) {
            return "number" == typeof e ? e : (e.proxyOf && (e = e.proxyOf), this.proxyOf.nodes.indexOf(e));
          }
          insertAfter(e, t) {
            let n,
              r = this.index(e),
              o = this.normalize(t, this.proxyOf.nodes[r]).reverse();
            r = this.index(e);
            for (let e of o) this.proxyOf.nodes.splice(r + 1, 0, e);
            for (let e in this.indexes) n = this.indexes[e], r < n && (this.indexes[e] = n + o.length);
            return this.markDirty(), this;
          }
          insertBefore(e, t) {
            let n,
              r = this.index(e),
              o = 0 === r && "prepend",
              i = this.normalize(t, this.proxyOf.nodes[r], o).reverse();
            r = this.index(e);
            for (let e of i) this.proxyOf.nodes.splice(r, 0, e);
            for (let e in this.indexes) n = this.indexes[e], r <= n && (this.indexes[e] = n + i.length);
            return this.markDirty(), this;
          }
          normalize(e, t) {
            if ("string" == typeof e) e = p(r(e).nodes);else if (void 0 === e) e = [];else if (Array.isArray(e)) {
              e = e.slice(0);
              for (let t of e) t.parent && t.parent.removeChild(t, "ignore");
            } else if ("root" === e.type && "document" !== this.type) {
              e = e.nodes.slice(0);
              for (let t of e) t.parent && t.parent.removeChild(t, "ignore");
            } else if (e.type) e = [e];else if (e.prop) {
              if (void 0 === e.value) throw new Error("Value field is missed in node creation");
              "string" != typeof e.value && (e.value = String(e.value)), e = [new u(e)];
            } else if (e.selector) e = [new o(e)];else if (e.name) e = [new i(e)];else {
              if (!e.text) throw new Error("Unknown node type in node creation");
              e = [new c(e)];
            }
            return e.map(e => (e[l] || f.rebuild(e), (e = e.proxyOf).parent && e.parent.removeChild(e), e[s] && h(e), void 0 === e.raws.before && t && void 0 !== t.raws.before && (e.raws.before = t.raws.before.replace(/\S/g, "")), e.parent = this.proxyOf, e));
          }
          prepend(...e) {
            e = e.reverse();
            for (let t of e) {
              let e = this.normalize(t, this.first, "prepend").reverse();
              for (let t of e) this.proxyOf.nodes.unshift(t);
              for (let t in this.indexes) this.indexes[t] = this.indexes[t] + e.length;
            }
            return this.markDirty(), this;
          }
          push(e) {
            return e.parent = this, this.proxyOf.nodes.push(e), this;
          }
          removeAll() {
            for (let e of this.proxyOf.nodes) e.parent = void 0;
            return this.proxyOf.nodes = [], this.markDirty(), this;
          }
          removeChild(e) {
            let t;
            e = this.index(e), this.proxyOf.nodes[e].parent = void 0, this.proxyOf.nodes.splice(e, 1);
            for (let n in this.indexes) t = this.indexes[n], t >= e && (this.indexes[n] = t - 1);
            return this.markDirty(), this;
          }
          replaceValues(e, t, n) {
            return n || (n = t, t = {}), this.walkDecls(r => {
              t.props && !t.props.includes(r.prop) || t.fast && !r.value.includes(t.fast) || (r.value = r.value.replace(e, n));
            }), this.markDirty(), this;
          }
          some(e) {
            return this.nodes.some(e);
          }
          walk(e) {
            return this.each((t, n) => {
              let r;
              try {
                r = e(t, n);
              } catch (e) {
                throw t.addToError(e);
              }
              return !1 !== r && t.walk && (r = t.walk(e)), r;
            });
          }
          walkAtRules(e, t) {
            return t ? e instanceof RegExp ? this.walk((n, r) => {
              if ("atrule" === n.type && e.test(n.name)) return t(n, r);
            }) : this.walk((n, r) => {
              if ("atrule" === n.type && n.name === e) return t(n, r);
            }) : (t = e, this.walk((e, n) => {
              if ("atrule" === e.type) return t(e, n);
            }));
          }
          walkComments(e) {
            return this.walk((t, n) => {
              if ("comment" === t.type) return e(t, n);
            });
          }
          walkDecls(e, t) {
            return t ? e instanceof RegExp ? this.walk((n, r) => {
              if ("decl" === n.type && e.test(n.prop)) return t(n, r);
            }) : this.walk((n, r) => {
              if ("decl" === n.type && n.prop === e) return t(n, r);
            }) : (t = e, this.walk((e, n) => {
              if ("decl" === e.type) return t(e, n);
            }));
          }
          walkRules(e, t) {
            return t ? e instanceof RegExp ? this.walk((n, r) => {
              if ("rule" === n.type && e.test(n.selector)) return t(n, r);
            }) : this.walk((n, r) => {
              if ("rule" === n.type && n.selector === e) return t(n, r);
            }) : (t = e, this.walk((e, n) => {
              if ("rule" === e.type) return t(e, n);
            }));
          }
          get first() {
            if (this.proxyOf.nodes) return this.proxyOf.nodes[0];
          }
          get last() {
            if (this.proxyOf.nodes) return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
          }
        }
        f.registerParse = e => {
          r = e;
        }, f.registerRule = e => {
          o = e;
        }, f.registerAtRule = e => {
          i = e;
        }, f.registerRoot = e => {
          a = e;
        }, e.exports = f, f.default = f, f.rebuild = e => {
          "atrule" === e.type ? Object.setPrototypeOf(e, i.prototype) : "rule" === e.type ? Object.setPrototypeOf(e, o.prototype) : "decl" === e.type ? Object.setPrototypeOf(e, u.prototype) : "comment" === e.type ? Object.setPrototypeOf(e, c.prototype) : "root" === e.type && Object.setPrototypeOf(e, a.prototype), e[l] = !0, e.nodes && e.nodes.forEach(e => {
            f.rebuild(e);
          });
        };
      },
      36271: (e, t, n) => {
        "use strict";

        let r = n(74241),
          o = n(75866);
        class i extends Error {
          constructor(e, t, n, r, o, a) {
            super(e), this.name = "CssSyntaxError", this.reason = e, o && (this.file = o), r && (this.source = r), a && (this.plugin = a), void 0 !== t && void 0 !== n && ("number" == typeof t ? (this.line = t, this.column = n) : (this.line = t.line, this.column = t.column, this.endLine = n.line, this.endColumn = n.column)), this.setMessage(), Error.captureStackTrace && Error.captureStackTrace(this, i);
          }
          setMessage() {
            this.message = this.plugin ? this.plugin + ": " : "", this.message += this.file ? this.file : "<css input>", void 0 !== this.line && (this.message += ":" + this.line + ":" + this.column), this.message += ": " + this.reason;
          }
          showSourceCode(e) {
            if (!this.source) return "";
            let t = this.source;
            null == e && (e = r.isColorSupported), o && e && (t = o(t));
            let n,
              i,
              a = t.split(/\r?\n/),
              s = Math.max(this.line - 3, 0),
              l = Math.min(this.line + 2, a.length),
              u = String(l).length;
            if (e) {
              let {
                bold: e,
                gray: t,
                red: o
              } = r.createColors(!0);
              n = t => e(o(t)), i = e => t(e);
            } else n = i = e => e;
            return a.slice(s, l).map((e, t) => {
              let r = s + 1 + t,
                o = " " + (" " + r).slice(-u) + " | ";
              if (r === this.line) {
                let t = i(o.replace(/\d/g, " ")) + e.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return n(">") + i(o) + e + "\n " + t + n("^");
              }
              return " " + i(o) + e;
            }).join("\n");
          }
          toString() {
            let e = this.showSourceCode();
            return e && (e = "\n\n" + e + "\n"), this.name + ": " + this.message + e;
          }
        }
        e.exports = i, i.default = i;
      },
      76663: (e, t, n) => {
        "use strict";

        let r = n(34421);
        class o extends r {
          constructor(e) {
            e && void 0 !== e.value && "string" != typeof e.value && (e = {
              ...e,
              value: String(e.value)
            }), super(e), this.type = "decl";
          }
          get variable() {
            return this.prop.startsWith("--") || "$" === this.prop[0];
          }
        }
        e.exports = o, o.default = o;
      },
      76076: (e, t, n) => {
        "use strict";

        let r,
          o,
          i = n(10795);
        class a extends i {
          constructor(e) {
            super({
              type: "document",
              ...e
            }), this.nodes || (this.nodes = []);
          }
          toResult(e = {}) {
            return new r(new o(), this, e).stringify();
          }
        }
        a.registerLazyResult = e => {
          r = e;
        }, a.registerProcessor = e => {
          o = e;
        }, e.exports = a, a.default = a;
      },
      15245: (e, t, n) => {
        "use strict";

        let r = n(76663),
          o = n(73789),
          i = n(37257),
          a = n(39926),
          s = n(18078),
          l = n(56593),
          u = n(39445);
        function c(e, t) {
          if (Array.isArray(e)) return e.map(e => c(e));
          let {
            inputs: n,
            ...d
          } = e;
          if (n) {
            t = [];
            for (let e of n) {
              let n = {
                ...e,
                __proto__: s.prototype
              };
              n.map && (n.map = {
                ...n.map,
                __proto__: o.prototype
              }), t.push(n);
            }
          }
          if (d.nodes && (d.nodes = e.nodes.map(e => c(e, t))), d.source) {
            let {
              inputId: e,
              ...n
            } = d.source;
            d.source = n, null != e && (d.source.input = t[e]);
          }
          if ("root" === d.type) return new l(d);
          if ("decl" === d.type) return new r(d);
          if ("rule" === d.type) return new u(d);
          if ("comment" === d.type) return new i(d);
          if ("atrule" === d.type) return new a(d);
          throw new Error("Unknown node type: " + e.type);
        }
        e.exports = c, c.default = c;
      },
      18078: (e, t, n) => {
        "use strict";

        let {
            SourceMapConsumer: r,
            SourceMapGenerator: o
          } = n(24456),
          {
            fileURLToPath: i,
            pathToFileURL: a
          } = n(36216),
          {
            isAbsolute: s,
            resolve: l
          } = n(32368),
          {
            nanoid: u
          } = n(36394),
          c = n(75866),
          d = n(36271),
          p = n(73789),
          h = Symbol("fromOffsetCache"),
          f = Boolean(r && o),
          m = Boolean(l && s);
        class g {
          constructor(e, t = {}) {
            if (null == e || "object" == typeof e && !e.toString) throw new Error(`PostCSS received ${e} instead of CSS string`);
            if (this.css = e.toString(), "\ufeff" === this.css[0] || "￾" === this.css[0] ? (this.hasBOM = !0, this.css = this.css.slice(1)) : this.hasBOM = !1, t.from && (!m || /^\w+:\/\//.test(t.from) || s(t.from) ? this.file = t.from : this.file = l(t.from)), m && f) {
              let e = new p(this.css, t);
              if (e.text) {
                this.map = e;
                let t = e.consumer().file;
                !this.file && t && (this.file = this.mapResolve(t));
              }
            }
            this.file || (this.id = "<input css " + u(6) + ">"), this.map && (this.map.file = this.from);
          }
          error(e, t, n, r = {}) {
            let o, i, s;
            if (t && "object" == typeof t) {
              let e = t,
                r = n;
              if ("number" == typeof e.offset) {
                let r = this.fromOffset(e.offset);
                t = r.line, n = r.col;
              } else t = e.line, n = e.column;
              if ("number" == typeof r.offset) {
                let e = this.fromOffset(r.offset);
                i = e.line, s = e.col;
              } else i = r.line, s = r.column;
            } else if (!n) {
              let e = this.fromOffset(t);
              t = e.line, n = e.col;
            }
            let l = this.origin(t, n, i, s);
            return o = l ? new d(e, void 0 === l.endLine ? l.line : {
              column: l.column,
              line: l.line
            }, void 0 === l.endLine ? l.column : {
              column: l.endColumn,
              line: l.endLine
            }, l.source, l.file, r.plugin) : new d(e, void 0 === i ? t : {
              column: n,
              line: t
            }, void 0 === i ? n : {
              column: s,
              line: i
            }, this.css, this.file, r.plugin), o.input = {
              column: n,
              endColumn: s,
              endLine: i,
              line: t,
              source: this.css
            }, this.file && (a && (o.input.url = a(this.file).toString()), o.input.file = this.file), o;
          }
          fromOffset(e) {
            let t, n;
            if (this[h]) n = this[h];else {
              let e = this.css.split("\n");
              n = new Array(e.length);
              let t = 0;
              for (let r = 0, o = e.length; r < o; r++) n[r] = t, t += e[r].length + 1;
              this[h] = n;
            }
            t = n[n.length - 1];
            let r = 0;
            if (e >= t) r = n.length - 1;else {
              let t,
                o = n.length - 2;
              for (; r < o;) if (t = r + (o - r >> 1), e < n[t]) o = t - 1;else {
                if (!(e >= n[t + 1])) {
                  r = t;
                  break;
                }
                r = t + 1;
              }
            }
            return {
              col: e - n[r] + 1,
              line: r + 1
            };
          }
          mapResolve(e) {
            return /^\w+:\/\//.test(e) ? e : l(this.map.consumer().sourceRoot || this.map.root || ".", e);
          }
          origin(e, t, n, r) {
            if (!this.map) return !1;
            let o,
              l,
              u = this.map.consumer(),
              c = u.originalPositionFor({
                column: t,
                line: e
              });
            if (!c.source) return !1;
            "number" == typeof n && (o = u.originalPositionFor({
              column: r,
              line: n
            })), l = s(c.source) ? a(c.source) : new URL(c.source, this.map.consumer().sourceRoot || a(this.map.mapFile));
            let d = {
              column: c.column,
              endColumn: o && o.column,
              endLine: o && o.line,
              line: c.line,
              url: l.toString()
            };
            if ("file:" === l.protocol) {
              if (!i) throw new Error("file: protocol is not available in this PostCSS build");
              d.file = i(l);
            }
            let p = u.sourceContentFor(c.source);
            return p && (d.source = p), d;
          }
          toJSON() {
            let e = {};
            for (let t of ["hasBOM", "css", "file", "id"]) null != this[t] && (e[t] = this[t]);
            return this.map && (e.map = {
              ...this.map
            }, e.map.consumerCache && (e.map.consumerCache = void 0)), e;
          }
          get from() {
            return this.file || this.id;
          }
        }
        e.exports = g, g.default = g, c && c.registerInput && c.registerInput(g);
      },
      37617: (e, t, n) => {
        "use strict";

        let {
            isClean: r,
            my: o
          } = n(16356),
          i = n(52741),
          a = n(9921),
          s = n(10795),
          l = n(76076),
          u = (n(33066), n(73381)),
          c = n(75994),
          d = n(56593);
        const p = {
            atrule: "AtRule",
            comment: "Comment",
            decl: "Declaration",
            document: "Document",
            root: "Root",
            rule: "Rule"
          },
          h = {
            AtRule: !0,
            AtRuleExit: !0,
            Comment: !0,
            CommentExit: !0,
            Declaration: !0,
            DeclarationExit: !0,
            Document: !0,
            DocumentExit: !0,
            Once: !0,
            OnceExit: !0,
            postcssPlugin: !0,
            prepare: !0,
            Root: !0,
            RootExit: !0,
            Rule: !0,
            RuleExit: !0
          },
          f = {
            Once: !0,
            postcssPlugin: !0,
            prepare: !0
          };
        function m(e) {
          return "object" == typeof e && "function" == typeof e.then;
        }
        function g(e) {
          let t = !1,
            n = p[e.type];
          return "decl" === e.type ? t = e.prop.toLowerCase() : "atrule" === e.type && (t = e.name.toLowerCase()), t && e.append ? [n, n + "-" + t, 0, n + "Exit", n + "Exit-" + t] : t ? [n, n + "-" + t, n + "Exit", n + "Exit-" + t] : e.append ? [n, 0, n + "Exit"] : [n, n + "Exit"];
        }
        function v(e) {
          let t;
          return t = "document" === e.type ? ["Document", 0, "DocumentExit"] : "root" === e.type ? ["Root", 0, "RootExit"] : g(e), {
            eventIndex: 0,
            events: t,
            iterator: 0,
            node: e,
            visitorIndex: 0,
            visitors: []
          };
        }
        function y(e) {
          return e[r] = !1, e.nodes && e.nodes.forEach(e => y(e)), e;
        }
        let b = {};
        class w {
          constructor(e, t, n) {
            let r;
            if (this.stringified = !1, this.processed = !1, "object" != typeof t || null === t || "root" !== t.type && "document" !== t.type) {
              if (t instanceof w || t instanceof u) r = y(t.root), t.map && (void 0 === n.map && (n.map = {}), n.map.inline || (n.map.inline = !1), n.map.prev = t.map);else {
                let e = c;
                n.syntax && (e = n.syntax.parse), n.parser && (e = n.parser), e.parse && (e = e.parse);
                try {
                  r = e(t, n);
                } catch (e) {
                  this.processed = !0, this.error = e;
                }
                r && !r[o] && s.rebuild(r);
              }
            } else r = y(t);
            this.result = new u(e, r, n), this.helpers = {
              ...b,
              postcss: b,
              result: this.result
            }, this.plugins = this.processor.plugins.map(e => "object" == typeof e && e.prepare ? {
              ...e,
              ...e.prepare(this.result)
            } : e);
          }
          async() {
            return this.error ? Promise.reject(this.error) : this.processed ? Promise.resolve(this.result) : (this.processing || (this.processing = this.runAsync()), this.processing);
          }
          catch(e) {
            return this.async().catch(e);
          }
          finally(e) {
            return this.async().then(e, e);
          }
          getAsyncError() {
            throw new Error("Use process(css).then(cb) to work with async plugins");
          }
          handleError(e, t) {
            let n = this.result.lastPlugin;
            try {
              t && t.addToError(e), this.error = e, "CssSyntaxError" !== e.name || e.plugin ? n.postcssVersion : (e.plugin = n.postcssPlugin, e.setMessage());
            } catch (e) {
              console && console.error && console.error(e);
            }
            return e;
          }
          prepareVisitors() {
            this.listeners = {};
            let e = (e, t, n) => {
              this.listeners[t] || (this.listeners[t] = []), this.listeners[t].push([e, n]);
            };
            for (let t of this.plugins) if ("object" == typeof t) for (let n in t) {
              if (!h[n] && /^[A-Z]/.test(n)) throw new Error(`Unknown event ${n} in ${t.postcssPlugin}. Try to update PostCSS (${this.processor.version} now).`);
              if (!f[n]) if ("object" == typeof t[n]) for (let r in t[n]) e(t, "*" === r ? n : n + "-" + r.toLowerCase(), t[n][r]);else "function" == typeof t[n] && e(t, n, t[n]);
            }
            this.hasListener = Object.keys(this.listeners).length > 0;
          }
          async runAsync() {
            this.plugin = 0;
            for (let e = 0; e < this.plugins.length; e++) {
              let t = this.plugins[e],
                n = this.runOnRoot(t);
              if (m(n)) try {
                await n;
              } catch (e) {
                throw this.handleError(e);
              }
            }
            if (this.prepareVisitors(), this.hasListener) {
              let e = this.result.root;
              for (; !e[r];) {
                e[r] = !0;
                let t = [v(e)];
                for (; t.length > 0;) {
                  let e = this.visitTick(t);
                  if (m(e)) try {
                    await e;
                  } catch (e) {
                    let n = t[t.length - 1].node;
                    throw this.handleError(e, n);
                  }
                }
              }
              if (this.listeners.OnceExit) for (let [t, n] of this.listeners.OnceExit) {
                this.result.lastPlugin = t;
                try {
                  if ("document" === e.type) {
                    let t = e.nodes.map(e => n(e, this.helpers));
                    await Promise.all(t);
                  } else await n(e, this.helpers);
                } catch (e) {
                  throw this.handleError(e);
                }
              }
            }
            return this.processed = !0, this.stringify();
          }
          runOnRoot(e) {
            this.result.lastPlugin = e;
            try {
              if ("object" == typeof e && e.Once) {
                if ("document" === this.result.root.type) {
                  let t = this.result.root.nodes.map(t => e.Once(t, this.helpers));
                  return m(t[0]) ? Promise.all(t) : t;
                }
                return e.Once(this.result.root, this.helpers);
              }
              if ("function" == typeof e) return e(this.result.root, this.result);
            } catch (e) {
              throw this.handleError(e);
            }
          }
          stringify() {
            if (this.error) throw this.error;
            if (this.stringified) return this.result;
            this.stringified = !0, this.sync();
            let e = this.result.opts,
              t = a;
            e.syntax && (t = e.syntax.stringify), e.stringifier && (t = e.stringifier), t.stringify && (t = t.stringify);
            let n = new i(t, this.result.root, this.result.opts).generate();
            return this.result.css = n[0], this.result.map = n[1], this.result;
          }
          sync() {
            if (this.error) throw this.error;
            if (this.processed) return this.result;
            if (this.processed = !0, this.processing) throw this.getAsyncError();
            for (let e of this.plugins) {
              if (m(this.runOnRoot(e))) throw this.getAsyncError();
            }
            if (this.prepareVisitors(), this.hasListener) {
              let e = this.result.root;
              for (; !e[r];) e[r] = !0, this.walkSync(e);
              if (this.listeners.OnceExit) if ("document" === e.type) for (let t of e.nodes) this.visitSync(this.listeners.OnceExit, t);else this.visitSync(this.listeners.OnceExit, e);
            }
            return this.result;
          }
          then(e, t) {
            return this.async().then(e, t);
          }
          toString() {
            return this.css;
          }
          visitSync(e, t) {
            for (let [n, r] of e) {
              let e;
              this.result.lastPlugin = n;
              try {
                e = r(t, this.helpers);
              } catch (e) {
                throw this.handleError(e, t.proxyOf);
              }
              if ("root" !== t.type && "document" !== t.type && !t.parent) return !0;
              if (m(e)) throw this.getAsyncError();
            }
          }
          visitTick(e) {
            let t = e[e.length - 1],
              {
                node: n,
                visitors: o
              } = t;
            if ("root" !== n.type && "document" !== n.type && !n.parent) return void e.pop();
            if (o.length > 0 && t.visitorIndex < o.length) {
              let [e, r] = o[t.visitorIndex];
              t.visitorIndex += 1, t.visitorIndex === o.length && (t.visitors = [], t.visitorIndex = 0), this.result.lastPlugin = e;
              try {
                return r(n.toProxy(), this.helpers);
              } catch (e) {
                throw this.handleError(e, n);
              }
            }
            if (0 !== t.iterator) {
              let o,
                i = t.iterator;
              for (; o = n.nodes[n.indexes[i]];) if (n.indexes[i] += 1, !o[r]) return o[r] = !0, void e.push(v(o));
              t.iterator = 0, delete n.indexes[i];
            }
            let i = t.events;
            for (; t.eventIndex < i.length;) {
              let e = i[t.eventIndex];
              if (t.eventIndex += 1, 0 === e) return void (n.nodes && n.nodes.length && (n[r] = !0, t.iterator = n.getIterator()));
              if (this.listeners[e]) return void (t.visitors = this.listeners[e]);
            }
            e.pop();
          }
          walkSync(e) {
            e[r] = !0;
            let t = g(e);
            for (let n of t) if (0 === n) e.nodes && e.each(e => {
              e[r] || this.walkSync(e);
            });else {
              let t = this.listeners[n];
              if (t && this.visitSync(t, e.toProxy())) return;
            }
          }
          warnings() {
            return this.sync().warnings();
          }
          get content() {
            return this.stringify().content;
          }
          get css() {
            return this.stringify().css;
          }
          get map() {
            return this.stringify().map;
          }
          get messages() {
            return this.sync().messages;
          }
          get opts() {
            return this.result.opts;
          }
          get processor() {
            return this.result.processor;
          }
          get root() {
            return this.sync().root;
          }
          get [Symbol.toStringTag]() {
            return "LazyResult";
          }
        }
        w.registerPostcss = e => {
          b = e;
        }, e.exports = w, w.default = w, d.registerLazyResult(w), l.registerLazyResult(w);
      },
      1902: e => {
        "use strict";

        let t = {
          comma: e => t.split(e, [","], !0),
          space: e => t.split(e, [" ", "\n", "\t"]),
          split(e, t, n) {
            let r = [],
              o = "",
              i = !1,
              a = 0,
              s = !1,
              l = "",
              u = !1;
            for (let n of e) u ? u = !1 : "\\" === n ? u = !0 : s ? n === l && (s = !1) : '"' === n || "'" === n ? (s = !0, l = n) : "(" === n ? a += 1 : ")" === n ? a > 0 && (a -= 1) : 0 === a && t.includes(n) && (i = !0), i ? ("" !== o && r.push(o.trim()), o = "", i = !1) : o += n;
            return (n || "" !== o) && r.push(o.trim()), r;
          }
        };
        e.exports = t, t.default = t;
      },
      52741: (e, t, n) => {
        "use strict";

        let {
            SourceMapConsumer: r,
            SourceMapGenerator: o
          } = n(24456),
          {
            dirname: i,
            relative: a,
            resolve: s,
            sep: l
          } = n(32368),
          {
            pathToFileURL: u
          } = n(36216),
          c = n(18078),
          d = Boolean(r && o),
          p = Boolean(i && s && a && l);
        e.exports = class {
          constructor(e, t, n, r) {
            this.stringify = e, this.mapOpts = n.map || {}, this.root = t, this.opts = n, this.css = r, this.originalCSS = r, this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute, this.memoizedFileURLs = new Map(), this.memoizedPaths = new Map(), this.memoizedURLs = new Map();
          }
          addAnnotation() {
            let e;
            e = this.isInline() ? "data:application/json;base64," + this.toBase64(this.map.toString()) : "string" == typeof this.mapOpts.annotation ? this.mapOpts.annotation : "function" == typeof this.mapOpts.annotation ? this.mapOpts.annotation(this.opts.to, this.root) : this.outputFile() + ".map";
            let t = "\n";
            this.css.includes("\r\n") && (t = "\r\n"), this.css += t + "/*# sourceMappingURL=" + e + " */";
          }
          applyPrevMaps() {
            for (let e of this.previous()) {
              let t,
                n = this.toUrl(this.path(e.file)),
                o = e.root || i(e.file);
              !1 === this.mapOpts.sourcesContent ? (t = new r(e.text), t.sourcesContent && (t.sourcesContent = null)) : t = e.consumer(), this.map.applySourceMap(t, n, this.toUrl(this.path(o)));
            }
          }
          clearAnnotation() {
            if (!1 !== this.mapOpts.annotation) if (this.root) {
              let e;
              for (let t = this.root.nodes.length - 1; t >= 0; t--) e = this.root.nodes[t], "comment" === e.type && 0 === e.text.indexOf("# sourceMappingURL=") && this.root.removeChild(t);
            } else this.css && (this.css = this.css.replace(/\n*?\/\*#[\S\s]*?\*\/$/gm, ""));
          }
          generate() {
            if (this.clearAnnotation(), p && d && this.isMap()) return this.generateMap();
            {
              let e = "";
              return this.stringify(this.root, t => {
                e += t;
              }), [e];
            }
          }
          generateMap() {
            if (this.root) this.generateString();else if (1 === this.previous().length) {
              let e = this.previous()[0].consumer();
              e.file = this.outputFile(), this.map = o.fromSourceMap(e);
            } else this.map = new o({
              file: this.outputFile()
            }), this.map.addMapping({
              generated: {
                column: 0,
                line: 1
              },
              original: {
                column: 0,
                line: 1
              },
              source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
            return this.isSourcesContent() && this.setSourcesContent(), this.root && this.previous().length > 0 && this.applyPrevMaps(), this.isAnnotation() && this.addAnnotation(), this.isInline() ? [this.css] : [this.css, this.map];
          }
          generateString() {
            this.css = "", this.map = new o({
              file: this.outputFile()
            });
            let e,
              t,
              n = 1,
              r = 1,
              i = "<no source>",
              a = {
                generated: {
                  column: 0,
                  line: 0
                },
                original: {
                  column: 0,
                  line: 0
                },
                source: ""
              };
            this.stringify(this.root, (o, s, l) => {
              if (this.css += o, s && "end" !== l && (a.generated.line = n, a.generated.column = r - 1, s.source && s.source.start ? (a.source = this.sourcePath(s), a.original.line = s.source.start.line, a.original.column = s.source.start.column - 1, this.map.addMapping(a)) : (a.source = i, a.original.line = 1, a.original.column = 0, this.map.addMapping(a))), e = o.match(/\n/g), e ? (n += e.length, t = o.lastIndexOf("\n"), r = o.length - t) : r += o.length, s && "start" !== l) {
                let e = s.parent || {
                  raws: {}
                };
                ("decl" === s.type || "atrule" === s.type && !s.nodes) && s === e.last && !e.raws.semicolon || (s.source && s.source.end ? (a.source = this.sourcePath(s), a.original.line = s.source.end.line, a.original.column = s.source.end.column - 1, a.generated.line = n, a.generated.column = r - 2, this.map.addMapping(a)) : (a.source = i, a.original.line = 1, a.original.column = 0, a.generated.line = n, a.generated.column = r - 1, this.map.addMapping(a)));
              }
            });
          }
          isAnnotation() {
            return !!this.isInline() || (void 0 !== this.mapOpts.annotation ? this.mapOpts.annotation : !this.previous().length || this.previous().some(e => e.annotation));
          }
          isInline() {
            if (void 0 !== this.mapOpts.inline) return this.mapOpts.inline;
            let e = this.mapOpts.annotation;
            return (void 0 === e || !0 === e) && (!this.previous().length || this.previous().some(e => e.inline));
          }
          isMap() {
            return void 0 !== this.opts.map ? !!this.opts.map : this.previous().length > 0;
          }
          isSourcesContent() {
            return void 0 !== this.mapOpts.sourcesContent ? this.mapOpts.sourcesContent : !this.previous().length || this.previous().some(e => e.withContent());
          }
          outputFile() {
            return this.opts.to ? this.path(this.opts.to) : this.opts.from ? this.path(this.opts.from) : "to.css";
          }
          path(e) {
            if (this.mapOpts.absolute) return e;
            if (60 === e.charCodeAt(0)) return e;
            if (/^\w+:\/\//.test(e)) return e;
            let t = this.memoizedPaths.get(e);
            if (t) return t;
            let n = this.opts.to ? i(this.opts.to) : ".";
            "string" == typeof this.mapOpts.annotation && (n = i(s(n, this.mapOpts.annotation)));
            let r = a(n, e);
            return this.memoizedPaths.set(e, r), r;
          }
          previous() {
            if (!this.previousMaps) if (this.previousMaps = [], this.root) this.root.walk(e => {
              if (e.source && e.source.input.map) {
                let t = e.source.input.map;
                this.previousMaps.includes(t) || this.previousMaps.push(t);
              }
            });else {
              let e = new c(this.originalCSS, this.opts);
              e.map && this.previousMaps.push(e.map);
            }
            return this.previousMaps;
          }
          setSourcesContent() {
            let e = {};
            if (this.root) this.root.walk(t => {
              if (t.source) {
                let n = t.source.input.from;
                if (n && !e[n]) {
                  e[n] = !0;
                  let r = this.usesFileUrls ? this.toFileUrl(n) : this.toUrl(this.path(n));
                  this.map.setSourceContent(r, t.source.input.css);
                }
              }
            });else if (this.css) {
              let e = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
              this.map.setSourceContent(e, this.css);
            }
          }
          sourcePath(e) {
            return this.mapOpts.from ? this.toUrl(this.mapOpts.from) : this.usesFileUrls ? this.toFileUrl(e.source.input.from) : this.toUrl(this.path(e.source.input.from));
          }
          toBase64(e) {
            return Buffer ? Buffer.from(e).toString("base64") : window.btoa(unescape(encodeURIComponent(e)));
          }
          toFileUrl(e) {
            let t = this.memoizedFileURLs.get(e);
            if (t) return t;
            if (u) {
              let t = u(e).toString();
              return this.memoizedFileURLs.set(e, t), t;
            }
            throw new Error("`map.absolute` option is not available in this PostCSS build");
          }
          toUrl(e) {
            let t = this.memoizedURLs.get(e);
            if (t) return t;
            "\\" === l && (e = e.replace(/\\/g, "/"));
            let n = encodeURI(e).replace(/[#?]/g, encodeURIComponent);
            return this.memoizedURLs.set(e, n), n;
          }
        };
      },
      15791: (e, t, n) => {
        "use strict";

        let r = n(52741),
          o = n(9921),
          i = (n(33066), n(75994));
        const a = n(73381);
        class s {
          constructor(e, t, n) {
            let i;
            t = t.toString(), this.stringified = !1, this._processor = e, this._css = t, this._opts = n, this._map = void 0;
            let s = o;
            this.result = new a(this._processor, i, this._opts), this.result.css = t;
            let l = this;
            Object.defineProperty(this.result, "root", {
              get: () => l.root
            });
            let u = new r(s, i, this._opts, t);
            if (u.isMap()) {
              let [e, t] = u.generate();
              e && (this.result.css = e), t && (this.result.map = t);
            } else u.clearAnnotation(), this.result.css = u.css;
          }
          async() {
            return this.error ? Promise.reject(this.error) : Promise.resolve(this.result);
          }
          catch(e) {
            return this.async().catch(e);
          }
          finally(e) {
            return this.async().then(e, e);
          }
          sync() {
            if (this.error) throw this.error;
            return this.result;
          }
          then(e, t) {
            return this.async().then(e, t);
          }
          toString() {
            return this._css;
          }
          warnings() {
            return [];
          }
          get content() {
            return this.result.css;
          }
          get css() {
            return this.result.css;
          }
          get map() {
            return this.result.map;
          }
          get messages() {
            return [];
          }
          get opts() {
            return this.result.opts;
          }
          get processor() {
            return this.result.processor;
          }
          get root() {
            if (this._root) return this._root;
            let e,
              t = i;
            try {
              e = t(this._css, this._opts);
            } catch (e) {
              this.error = e;
            }
            if (this.error) throw this.error;
            return this._root = e, e;
          }
          get [Symbol.toStringTag]() {
            return "NoWorkResult";
          }
        }
        e.exports = s, s.default = s;
      },
      34421: (e, t, n) => {
        "use strict";

        let {
            isClean: r,
            my: o
          } = n(16356),
          i = n(36271),
          a = n(12983),
          s = n(9921);
        function l(e, t) {
          let n = new e.constructor();
          for (let r in e) {
            if (!Object.prototype.hasOwnProperty.call(e, r)) continue;
            if ("proxyCache" === r) continue;
            let o = e[r],
              i = typeof o;
            "parent" === r && "object" === i ? t && (n[r] = t) : "source" === r ? n[r] = o : Array.isArray(o) ? n[r] = o.map(e => l(e, n)) : ("object" === i && null !== o && (o = l(o)), n[r] = o);
          }
          return n;
        }
        class u {
          constructor(e = {}) {
            this.raws = {}, this[r] = !1, this[o] = !0;
            for (let t in e) if ("nodes" === t) {
              this.nodes = [];
              for (let n of e[t]) "function" == typeof n.clone ? this.append(n.clone()) : this.append(n);
            } else this[t] = e[t];
          }
          addToError(e) {
            if (e.postcssNode = this, e.stack && this.source && /\n\s{4}at /.test(e.stack)) {
              let t = this.source;
              e.stack = e.stack.replace(/\n\s{4}at /, `$&${t.input.from}:${t.start.line}:${t.start.column}$&`);
            }
            return e;
          }
          after(e) {
            return this.parent.insertAfter(this, e), this;
          }
          assign(e = {}) {
            for (let t in e) this[t] = e[t];
            return this;
          }
          before(e) {
            return this.parent.insertBefore(this, e), this;
          }
          cleanRaws(e) {
            delete this.raws.before, delete this.raws.after, e || delete this.raws.between;
          }
          clone(e = {}) {
            let t = l(this);
            for (let n in e) t[n] = e[n];
            return t;
          }
          cloneAfter(e = {}) {
            let t = this.clone(e);
            return this.parent.insertAfter(this, t), t;
          }
          cloneBefore(e = {}) {
            let t = this.clone(e);
            return this.parent.insertBefore(this, t), t;
          }
          error(e, t = {}) {
            if (this.source) {
              let {
                end: n,
                start: r
              } = this.rangeBy(t);
              return this.source.input.error(e, {
                column: r.column,
                line: r.line
              }, {
                column: n.column,
                line: n.line
              }, t);
            }
            return new i(e);
          }
          getProxyProcessor() {
            return {
              get: (e, t) => "proxyOf" === t ? e : "root" === t ? () => e.root().toProxy() : e[t],
              set: (e, t, n) => (e[t] === n || (e[t] = n, "prop" !== t && "value" !== t && "name" !== t && "params" !== t && "important" !== t && "text" !== t || e.markDirty()), !0)
            };
          }
          markDirty() {
            if (this[r]) {
              this[r] = !1;
              let e = this;
              for (; e = e.parent;) e[r] = !1;
            }
          }
          next() {
            if (!this.parent) return;
            let e = this.parent.index(this);
            return this.parent.nodes[e + 1];
          }
          positionBy(e, t) {
            let n = this.source.start;
            if (e.index) n = this.positionInside(e.index, t);else if (e.word) {
              let r = (t = this.toString()).indexOf(e.word);
              -1 !== r && (n = this.positionInside(r, t));
            }
            return n;
          }
          positionInside(e, t) {
            let n = t || this.toString(),
              r = this.source.start.column,
              o = this.source.start.line;
            for (let t = 0; t < e; t++) "\n" === n[t] ? (r = 1, o += 1) : r += 1;
            return {
              column: r,
              line: o
            };
          }
          prev() {
            if (!this.parent) return;
            let e = this.parent.index(this);
            return this.parent.nodes[e - 1];
          }
          rangeBy(e) {
            let t = {
                column: this.source.start.column,
                line: this.source.start.line
              },
              n = this.source.end ? {
                column: this.source.end.column + 1,
                line: this.source.end.line
              } : {
                column: t.column + 1,
                line: t.line
              };
            if (e.word) {
              let r = this.toString(),
                o = r.indexOf(e.word);
              -1 !== o && (t = this.positionInside(o, r), n = this.positionInside(o + e.word.length, r));
            } else e.start ? t = {
              column: e.start.column,
              line: e.start.line
            } : e.index && (t = this.positionInside(e.index)), e.end ? n = {
              column: e.end.column,
              line: e.end.line
            } : e.endIndex ? n = this.positionInside(e.endIndex) : e.index && (n = this.positionInside(e.index + 1));
            return (n.line < t.line || n.line === t.line && n.column <= t.column) && (n = {
              column: t.column + 1,
              line: t.line
            }), {
              end: n,
              start: t
            };
          }
          raw(e, t) {
            return new a().raw(this, e, t);
          }
          remove() {
            return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
          }
          replaceWith(...e) {
            if (this.parent) {
              let t = this,
                n = !1;
              for (let r of e) r === this ? n = !0 : n ? (this.parent.insertAfter(t, r), t = r) : this.parent.insertBefore(t, r);
              n || this.remove();
            }
            return this;
          }
          root() {
            let e = this;
            for (; e.parent && "document" !== e.parent.type;) e = e.parent;
            return e;
          }
          toJSON(e, t) {
            let n = {},
              r = null == t;
            t = t || new Map();
            let o = 0;
            for (let e in this) {
              if (!Object.prototype.hasOwnProperty.call(this, e)) continue;
              if ("parent" === e || "proxyCache" === e) continue;
              let r = this[e];
              if (Array.isArray(r)) n[e] = r.map(e => "object" == typeof e && e.toJSON ? e.toJSON(null, t) : e);else if ("object" == typeof r && r.toJSON) n[e] = r.toJSON(null, t);else if ("source" === e) {
                let i = t.get(r.input);
                null == i && (i = o, t.set(r.input, o), o++), n[e] = {
                  end: r.end,
                  inputId: i,
                  start: r.start
                };
              } else n[e] = r;
            }
            return r && (n.inputs = [...t.keys()].map(e => e.toJSON())), n;
          }
          toProxy() {
            return this.proxyCache || (this.proxyCache = new Proxy(this, this.getProxyProcessor())), this.proxyCache;
          }
          toString(e = s) {
            e.stringify && (e = e.stringify);
            let t = "";
            return e(this, e => {
              t += e;
            }), t;
          }
          warn(e, t, n) {
            let r = {
              node: this
            };
            for (let e in n) r[e] = n[e];
            return e.warn(t, r);
          }
          get proxyOf() {
            return this;
          }
        }
        e.exports = u, u.default = u;
      },
      75994: (e, t, n) => {
        "use strict";

        let r = n(10795),
          o = n(52438),
          i = n(18078);
        function a(e, t) {
          let n = new i(e, t),
            r = new o(n);
          try {
            r.parse();
          } catch (e) {
            throw e;
          }
          return r.root;
        }
        e.exports = a, a.default = a, r.registerParse(a);
      },
      52438: (e, t, n) => {
        "use strict";

        let r = n(76663),
          o = n(1426),
          i = n(37257),
          a = n(39926),
          s = n(56593),
          l = n(39445);
        const u = {
          empty: !0,
          space: !0
        };
        e.exports = class {
          constructor(e) {
            this.input = e, this.root = new s(), this.current = this.root, this.spaces = "", this.semicolon = !1, this.createTokenizer(), this.root.source = {
              input: e,
              start: {
                column: 1,
                line: 1,
                offset: 0
              }
            };
          }
          atrule(e) {
            let t,
              n,
              r,
              o = new a();
            o.name = e[1].slice(1), "" === o.name && this.unnamedAtrule(o, e), this.init(o, e[2]);
            let i = !1,
              s = !1,
              l = [],
              u = [];
            for (; !this.tokenizer.endOfFile();) {
              if (t = (e = this.tokenizer.nextToken())[0], "(" === t || "[" === t ? u.push("(" === t ? ")" : "]") : "{" === t && u.length > 0 ? u.push("}") : t === u[u.length - 1] && u.pop(), 0 === u.length) {
                if (";" === t) {
                  o.source.end = this.getPosition(e[2]), o.source.end.offset++, this.semicolon = !0;
                  break;
                }
                if ("{" === t) {
                  s = !0;
                  break;
                }
                if ("}" === t) {
                  if (l.length > 0) {
                    for (r = l.length - 1, n = l[r]; n && "space" === n[0];) n = l[--r];
                    n && (o.source.end = this.getPosition(n[3] || n[2]), o.source.end.offset++);
                  }
                  this.end(e);
                  break;
                }
                l.push(e);
              } else l.push(e);
              if (this.tokenizer.endOfFile()) {
                i = !0;
                break;
              }
            }
            o.raws.between = this.spacesAndCommentsFromEnd(l), l.length ? (o.raws.afterName = this.spacesAndCommentsFromStart(l), this.raw(o, "params", l), i && (e = l[l.length - 1], o.source.end = this.getPosition(e[3] || e[2]), o.source.end.offset++, this.spaces = o.raws.between, o.raws.between = "")) : (o.raws.afterName = "", o.params = ""), s && (o.nodes = [], this.current = o);
          }
          checkMissedSemicolon(e) {
            let t = this.colon(e);
            if (!1 === t) return;
            let n,
              r = 0;
            for (let o = t - 1; o >= 0 && (n = e[o], "space" === n[0] || (r += 1, 2 !== r)); o--);
            throw this.input.error("Missed semicolon", "word" === n[0] ? n[3] + 1 : n[2]);
          }
          colon(e) {
            let t,
              n,
              r,
              o = 0;
            for (let [i, a] of e.entries()) {
              if (t = a, n = t[0], "(" === n && (o += 1), ")" === n && (o -= 1), 0 === o && ":" === n) {
                if (r) {
                  if ("word" === r[0] && "progid" === r[1]) continue;
                  return i;
                }
                this.doubleColon(t);
              }
              r = t;
            }
            return !1;
          }
          comment(e) {
            let t = new i();
            this.init(t, e[2]), t.source.end = this.getPosition(e[3] || e[2]), t.source.end.offset++;
            let n = e[1].slice(2, -2);
            if (/^\s*$/.test(n)) t.text = "", t.raws.left = n, t.raws.right = "";else {
              let e = n.match(/^(\s*)([^]*\S)(\s*)$/);
              t.text = e[2], t.raws.left = e[1], t.raws.right = e[3];
            }
          }
          createTokenizer() {
            this.tokenizer = o(this.input);
          }
          decl(e, t) {
            let n = new r();
            this.init(n, e[0][2]);
            let o,
              i = e[e.length - 1];
            for (";" === i[0] && (this.semicolon = !0, e.pop()), n.source.end = this.getPosition(i[3] || i[2] || function (e) {
              for (let t = e.length - 1; t >= 0; t--) {
                let n = e[t],
                  r = n[3] || n[2];
                if (r) return r;
              }
            }(e)), n.source.end.offset++; "word" !== e[0][0];) 1 === e.length && this.unknownWord(e), n.raws.before += e.shift()[1];
            for (n.source.start = this.getPosition(e[0][2]), n.prop = ""; e.length;) {
              let t = e[0][0];
              if (":" === t || "space" === t || "comment" === t) break;
              n.prop += e.shift()[1];
            }
            for (n.raws.between = ""; e.length;) {
              if (o = e.shift(), ":" === o[0]) {
                n.raws.between += o[1];
                break;
              }
              "word" === o[0] && /\w/.test(o[1]) && this.unknownWord([o]), n.raws.between += o[1];
            }
            "_" !== n.prop[0] && "*" !== n.prop[0] || (n.raws.before += n.prop[0], n.prop = n.prop.slice(1));
            let a,
              s = [];
            for (; e.length && (a = e[0][0], "space" === a || "comment" === a);) s.push(e.shift());
            this.precheckMissedSemicolon(e);
            for (let t = e.length - 1; t >= 0; t--) {
              if (o = e[t], "!important" === o[1].toLowerCase()) {
                n.important = !0;
                let r = this.stringFrom(e, t);
                r = this.spacesFromEnd(e) + r, " !important" !== r && (n.raws.important = r);
                break;
              }
              if ("important" === o[1].toLowerCase()) {
                let r = e.slice(0),
                  o = "";
                for (let e = t; e > 0; e--) {
                  let t = r[e][0];
                  if (0 === o.trim().indexOf("!") && "space" !== t) break;
                  o = r.pop()[1] + o;
                }
                0 === o.trim().indexOf("!") && (n.important = !0, n.raws.important = o, e = r);
              }
              if ("space" !== o[0] && "comment" !== o[0]) break;
            }
            e.some(e => "space" !== e[0] && "comment" !== e[0]) && (n.raws.between += s.map(e => e[1]).join(""), s = []), this.raw(n, "value", s.concat(e), t), n.value.includes(":") && !t && this.checkMissedSemicolon(e);
          }
          doubleColon(e) {
            throw this.input.error("Double colon", {
              offset: e[2]
            }, {
              offset: e[2] + e[1].length
            });
          }
          emptyRule(e) {
            let t = new l();
            this.init(t, e[2]), t.selector = "", t.raws.between = "", this.current = t;
          }
          end(e) {
            this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.semicolon = !1, this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.spaces = "", this.current.parent ? (this.current.source.end = this.getPosition(e[2]), this.current.source.end.offset++, this.current = this.current.parent) : this.unexpectedClose(e);
          }
          endFile() {
            this.current.parent && this.unclosedBlock(), this.current.nodes && this.current.nodes.length && (this.current.raws.semicolon = this.semicolon), this.current.raws.after = (this.current.raws.after || "") + this.spaces, this.root.source.end = this.getPosition(this.tokenizer.position());
          }
          freeSemicolon(e) {
            if (this.spaces += e[1], this.current.nodes) {
              let e = this.current.nodes[this.current.nodes.length - 1];
              e && "rule" === e.type && !e.raws.ownSemicolon && (e.raws.ownSemicolon = this.spaces, this.spaces = "");
            }
          }
          getPosition(e) {
            let t = this.input.fromOffset(e);
            return {
              column: t.col,
              line: t.line,
              offset: e
            };
          }
          init(e, t) {
            this.current.push(e), e.source = {
              input: this.input,
              start: this.getPosition(t)
            }, e.raws.before = this.spaces, this.spaces = "", "comment" !== e.type && (this.semicolon = !1);
          }
          other(e) {
            let t = !1,
              n = null,
              r = !1,
              o = null,
              i = [],
              a = e[1].startsWith("--"),
              s = [],
              l = e;
            for (; l;) {
              if (n = l[0], s.push(l), "(" === n || "[" === n) o || (o = l), i.push("(" === n ? ")" : "]");else if (a && r && "{" === n) o || (o = l), i.push("}");else if (0 === i.length) {
                if (";" === n) {
                  if (r) return void this.decl(s, a);
                  break;
                }
                if ("{" === n) return void this.rule(s);
                if ("}" === n) {
                  this.tokenizer.back(s.pop()), t = !0;
                  break;
                }
                ":" === n && (r = !0);
              } else n === i[i.length - 1] && (i.pop(), 0 === i.length && (o = null));
              l = this.tokenizer.nextToken();
            }
            if (this.tokenizer.endOfFile() && (t = !0), i.length > 0 && this.unclosedBracket(o), t && r) {
              if (!a) for (; s.length && (l = s[s.length - 1][0], "space" === l || "comment" === l);) this.tokenizer.back(s.pop());
              this.decl(s, a);
            } else this.unknownWord(s);
          }
          parse() {
            let e;
            for (; !this.tokenizer.endOfFile();) switch (e = this.tokenizer.nextToken(), e[0]) {
              case "space":
                this.spaces += e[1];
                break;
              case ";":
                this.freeSemicolon(e);
                break;
              case "}":
                this.end(e);
                break;
              case "comment":
                this.comment(e);
                break;
              case "at-word":
                this.atrule(e);
                break;
              case "{":
                this.emptyRule(e);
                break;
              default:
                this.other(e);
            }
            this.endFile();
          }
          precheckMissedSemicolon() {}
          raw(e, t, n, r) {
            let o,
              i,
              a,
              s,
              l = n.length,
              c = "",
              d = !0;
            for (let e = 0; e < l; e += 1) o = n[e], i = o[0], "space" !== i || e !== l - 1 || r ? "comment" === i ? (s = n[e - 1] ? n[e - 1][0] : "empty", a = n[e + 1] ? n[e + 1][0] : "empty", u[s] || u[a] || "," === c.slice(-1) ? d = !1 : c += o[1]) : c += o[1] : d = !1;
            if (!d) {
              let r = n.reduce((e, t) => e + t[1], "");
              e.raws[t] = {
                raw: r,
                value: c
              };
            }
            e[t] = c;
          }
          rule(e) {
            e.pop();
            let t = new l();
            this.init(t, e[0][2]), t.raws.between = this.spacesAndCommentsFromEnd(e), this.raw(t, "selector", e), this.current = t;
          }
          spacesAndCommentsFromEnd(e) {
            let t,
              n = "";
            for (; e.length && (t = e[e.length - 1][0], "space" === t || "comment" === t);) n = e.pop()[1] + n;
            return n;
          }
          spacesAndCommentsFromStart(e) {
            let t,
              n = "";
            for (; e.length && (t = e[0][0], "space" === t || "comment" === t);) n += e.shift()[1];
            return n;
          }
          spacesFromEnd(e) {
            let t,
              n = "";
            for (; e.length && (t = e[e.length - 1][0], "space" === t);) n = e.pop()[1] + n;
            return n;
          }
          stringFrom(e, t) {
            let n = "";
            for (let r = t; r < e.length; r++) n += e[r][1];
            return e.splice(t, e.length - t), n;
          }
          unclosedBlock() {
            let e = this.current.source.start;
            throw this.input.error("Unclosed block", e.line, e.column);
          }
          unclosedBracket(e) {
            throw this.input.error("Unclosed bracket", {
              offset: e[2]
            }, {
              offset: e[2] + 1
            });
          }
          unexpectedClose(e) {
            throw this.input.error("Unexpected }", {
              offset: e[2]
            }, {
              offset: e[2] + 1
            });
          }
          unknownWord(e) {
            throw this.input.error("Unknown word", {
              offset: e[0][2]
            }, {
              offset: e[0][2] + e[0][1].length
            });
          }
          unnamedAtrule(e, t) {
            throw this.input.error("At-rule without name", {
              offset: t[2]
            }, {
              offset: t[2] + t[1].length
            });
          }
        };
      },
      78590: (e, t, n) => {
        "use strict";

        let r = n(36271),
          o = n(76663),
          i = n(37617),
          a = n(10795),
          s = n(18100),
          l = n(9921),
          u = n(15245),
          c = n(76076),
          d = n(9150),
          p = n(37257),
          h = n(39926),
          f = n(73381),
          m = n(18078),
          g = n(75994),
          v = n(1902),
          y = n(39445),
          b = n(56593),
          w = n(34421);
        function x(...e) {
          return 1 === e.length && Array.isArray(e[0]) && (e = e[0]), new s(e);
        }
        x.plugin = function (e, t) {
          let n,
            r = !1;
          function o(...n) {
            console && console.warn && !r && (r = !0, console.warn(e + ": postcss.plugin was deprecated. Migration guide:\nhttps://evilmartians.com/chronicles/postcss-8-plugin-migration"), process.env.LANG && process.env.LANG.startsWith("cn") && console.warn(e + ": 里面 postcss.plugin 被弃用. 迁移指南:\nhttps://www.w3ctech.com/topic/2226"));
            let o = t(...n);
            return o.postcssPlugin = e, o.postcssVersion = new s().version, o;
          }
          return Object.defineProperty(o, "postcss", {
            get: () => (n || (n = o()), n)
          }), o.process = function (e, t, n) {
            return x([o(n)]).process(e, t);
          }, o;
        }, x.stringify = l, x.parse = g, x.fromJSON = u, x.list = v, x.comment = e => new p(e), x.atRule = e => new h(e), x.decl = e => new o(e), x.rule = e => new y(e), x.root = e => new b(e), x.document = e => new c(e), x.CssSyntaxError = r, x.Declaration = o, x.Container = a, x.Processor = s, x.Document = c, x.Comment = p, x.Warning = d, x.AtRule = h, x.Result = f, x.Input = m, x.Rule = y, x.Root = b, x.Node = w, i.registerPostcss(x), e.exports = x, x.default = x;
      },
      73789: (e, t, n) => {
        "use strict";

        let {
            SourceMapConsumer: r,
            SourceMapGenerator: o
          } = n(24456),
          {
            existsSync: i,
            readFileSync: a
          } = n(66972),
          {
            dirname: s,
            join: l
          } = n(32368);
        class u {
          constructor(e, t) {
            if (!1 === t.map) return;
            this.loadAnnotation(e), this.inline = this.startWith(this.annotation, "data:");
            let n = t.map ? t.map.prev : void 0,
              r = this.loadMap(t.from, n);
            !this.mapFile && t.from && (this.mapFile = t.from), this.mapFile && (this.root = s(this.mapFile)), r && (this.text = r);
          }
          consumer() {
            return this.consumerCache || (this.consumerCache = new r(this.text)), this.consumerCache;
          }
          decodeInline(e) {
            if (/^data:application\/json;charset=utf-?8,/.test(e) || /^data:application\/json,/.test(e)) return decodeURIComponent(e.substr(RegExp.lastMatch.length));
            if (/^data:application\/json;charset=utf-?8;base64,/.test(e) || /^data:application\/json;base64,/.test(e)) return t = e.substr(RegExp.lastMatch.length), Buffer ? Buffer.from(t, "base64").toString() : window.atob(t);
            var t;
            let n = e.match(/data:application\/json;([^,]+),/)[1];
            throw new Error("Unsupported source map encoding " + n);
          }
          getAnnotationURL(e) {
            return e.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
          }
          isMap(e) {
            return "object" == typeof e && ("string" == typeof e.mappings || "string" == typeof e._mappings || Array.isArray(e.sections));
          }
          loadAnnotation(e) {
            let t = e.match(/\/\*\s*# sourceMappingURL=/gm);
            if (!t) return;
            let n = e.lastIndexOf(t.pop()),
              r = e.indexOf("*/", n);
            n > -1 && r > -1 && (this.annotation = this.getAnnotationURL(e.substring(n, r)));
          }
          loadFile(e) {
            if (this.root = s(e), i(e)) return this.mapFile = e, a(e, "utf-8").toString().trim();
          }
          loadMap(e, t) {
            if (!1 === t) return !1;
            if (t) {
              if ("string" == typeof t) return t;
              if ("function" != typeof t) {
                if (t instanceof r) return o.fromSourceMap(t).toString();
                if (t instanceof o) return t.toString();
                if (this.isMap(t)) return JSON.stringify(t);
                throw new Error("Unsupported previous source map format: " + t.toString());
              }
              {
                let n = t(e);
                if (n) {
                  let e = this.loadFile(n);
                  if (!e) throw new Error("Unable to load previous source map: " + n.toString());
                  return e;
                }
              }
            } else {
              if (this.inline) return this.decodeInline(this.annotation);
              if (this.annotation) {
                let t = this.annotation;
                return e && (t = l(s(e), t)), this.loadFile(t);
              }
            }
          }
          startWith(e, t) {
            return !!e && e.substr(0, t.length) === t;
          }
          withContent() {
            return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
          }
        }
        e.exports = u, u.default = u;
      },
      18100: (e, t, n) => {
        "use strict";

        let r = n(15791),
          o = n(37617),
          i = n(76076),
          a = n(56593);
        class s {
          constructor(e = []) {
            this.version = "8.4.35", this.plugins = this.normalize(e);
          }
          normalize(e) {
            let t = [];
            for (let n of e) if (!0 === n.postcss ? n = n() : n.postcss && (n = n.postcss), "object" == typeof n && Array.isArray(n.plugins)) t = t.concat(n.plugins);else if ("object" == typeof n && n.postcssPlugin) t.push(n);else if ("function" == typeof n) t.push(n);else {
              if ("object" != typeof n || !n.parse && !n.stringify) throw new Error(n + " is not a PostCSS plugin");
            }
            return t;
          }
          process(e, t = {}) {
            return this.plugins.length || t.parser || t.stringifier || t.syntax ? new o(this, e, t) : new r(this, e, t);
          }
          use(e) {
            return this.plugins = this.plugins.concat(this.normalize([e])), this;
          }
        }
        e.exports = s, s.default = s, a.registerProcessor(s), i.registerProcessor(s);
      },
      73381: (e, t, n) => {
        "use strict";

        let r = n(9150);
        class o {
          constructor(e, t, n) {
            this.processor = e, this.messages = [], this.root = t, this.opts = n, this.css = void 0, this.map = void 0;
          }
          toString() {
            return this.css;
          }
          warn(e, t = {}) {
            t.plugin || this.lastPlugin && this.lastPlugin.postcssPlugin && (t.plugin = this.lastPlugin.postcssPlugin);
            let n = new r(e, t);
            return this.messages.push(n), n;
          }
          warnings() {
            return this.messages.filter(e => "warning" === e.type);
          }
          get content() {
            return this.css;
          }
        }
        e.exports = o, o.default = o;
      },
      56593: (e, t, n) => {
        "use strict";

        let r,
          o,
          i = n(10795);
        class a extends i {
          constructor(e) {
            super(e), this.type = "root", this.nodes || (this.nodes = []);
          }
          normalize(e, t, n) {
            let r = super.normalize(e);
            if (t) if ("prepend" === n) this.nodes.length > 1 ? t.raws.before = this.nodes[1].raws.before : delete t.raws.before;else if (this.first !== t) for (let e of r) e.raws.before = t.raws.before;
            return r;
          }
          removeChild(e, t) {
            let n = this.index(e);
            return !t && 0 === n && this.nodes.length > 1 && (this.nodes[1].raws.before = this.nodes[n].raws.before), super.removeChild(e);
          }
          toResult(e = {}) {
            return new r(new o(), this, e).stringify();
          }
        }
        a.registerLazyResult = e => {
          r = e;
        }, a.registerProcessor = e => {
          o = e;
        }, e.exports = a, a.default = a, i.registerRoot(a);
      },
      39445: (e, t, n) => {
        "use strict";

        let r = n(10795),
          o = n(1902);
        class i extends r {
          constructor(e) {
            super(e), this.type = "rule", this.nodes || (this.nodes = []);
          }
          get selectors() {
            return o.comma(this.selector);
          }
          set selectors(e) {
            let t = this.selector ? this.selector.match(/,\s*/) : null,
              n = t ? t[0] : "," + this.raw("between", "beforeOpen");
            this.selector = e.join(n);
          }
        }
        e.exports = i, i.default = i, r.registerRule(i);
      },
      12983: e => {
        "use strict";

        const t = {
          after: "\n",
          beforeClose: "\n",
          beforeComment: "\n",
          beforeDecl: "\n",
          beforeOpen: " ",
          beforeRule: "\n",
          colon: ": ",
          commentLeft: " ",
          commentRight: " ",
          emptyBody: "",
          indent: "    ",
          semicolon: !1
        };
        class n {
          constructor(e) {
            this.builder = e;
          }
          atrule(e, t) {
            let n = "@" + e.name,
              r = e.params ? this.rawValue(e, "params") : "";
            if (void 0 !== e.raws.afterName ? n += e.raws.afterName : r && (n += " "), e.nodes) this.block(e, n + r);else {
              let o = (e.raws.between || "") + (t ? ";" : "");
              this.builder(n + r + o, e);
            }
          }
          beforeAfter(e, t) {
            let n;
            n = "decl" === e.type ? this.raw(e, null, "beforeDecl") : "comment" === e.type ? this.raw(e, null, "beforeComment") : "before" === t ? this.raw(e, null, "beforeRule") : this.raw(e, null, "beforeClose");
            let r = e.parent,
              o = 0;
            for (; r && "root" !== r.type;) o += 1, r = r.parent;
            if (n.includes("\n")) {
              let t = this.raw(e, null, "indent");
              if (t.length) for (let e = 0; e < o; e++) n += t;
            }
            return n;
          }
          block(e, t) {
            let n,
              r = this.raw(e, "between", "beforeOpen");
            this.builder(t + r + "{", e, "start"), e.nodes && e.nodes.length ? (this.body(e), n = this.raw(e, "after")) : n = this.raw(e, "after", "emptyBody"), n && this.builder(n), this.builder("}", e, "end");
          }
          body(e) {
            let t = e.nodes.length - 1;
            for (; t > 0 && "comment" === e.nodes[t].type;) t -= 1;
            let n = this.raw(e, "semicolon");
            for (let r = 0; r < e.nodes.length; r++) {
              let o = e.nodes[r],
                i = this.raw(o, "before");
              i && this.builder(i), this.stringify(o, t !== r || n);
            }
          }
          comment(e) {
            let t = this.raw(e, "left", "commentLeft"),
              n = this.raw(e, "right", "commentRight");
            this.builder("/*" + t + e.text + n + "*/", e);
          }
          decl(e, t) {
            let n = this.raw(e, "between", "colon"),
              r = e.prop + n + this.rawValue(e, "value");
            e.important && (r += e.raws.important || " !important"), t && (r += ";"), this.builder(r, e);
          }
          document(e) {
            this.body(e);
          }
          raw(e, n, r) {
            let o;
            if (r || (r = n), n && (o = e.raws[n], void 0 !== o)) return o;
            let i = e.parent;
            if ("before" === r) {
              if (!i || "root" === i.type && i.first === e) return "";
              if (i && "document" === i.type) return "";
            }
            if (!i) return t[r];
            let a = e.root();
            if (a.rawCache || (a.rawCache = {}), void 0 !== a.rawCache[r]) return a.rawCache[r];
            if ("before" === r || "after" === r) return this.beforeAfter(e, r);
            {
              let t = "raw" + ((s = r)[0].toUpperCase() + s.slice(1));
              this[t] ? o = this[t](a, e) : a.walk(e => {
                if (o = e.raws[n], void 0 !== o) return !1;
              });
            }
            var s;
            return void 0 === o && (o = t[r]), a.rawCache[r] = o, o;
          }
          rawBeforeClose(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && e.nodes.length > 0 && void 0 !== e.raws.after) return t = e.raws.after, t.includes("\n") && (t = t.replace(/[^\n]+$/, "")), !1;
            }), t && (t = t.replace(/\S/g, "")), t;
          }
          rawBeforeComment(e, t) {
            let n;
            return e.walkComments(e => {
              if (void 0 !== e.raws.before) return n = e.raws.before, n.includes("\n") && (n = n.replace(/[^\n]+$/, "")), !1;
            }), void 0 === n ? n = this.raw(t, null, "beforeDecl") : n && (n = n.replace(/\S/g, "")), n;
          }
          rawBeforeDecl(e, t) {
            let n;
            return e.walkDecls(e => {
              if (void 0 !== e.raws.before) return n = e.raws.before, n.includes("\n") && (n = n.replace(/[^\n]+$/, "")), !1;
            }), void 0 === n ? n = this.raw(t, null, "beforeRule") : n && (n = n.replace(/\S/g, "")), n;
          }
          rawBeforeOpen(e) {
            let t;
            return e.walk(e => {
              if ("decl" !== e.type && (t = e.raws.between, void 0 !== t)) return !1;
            }), t;
          }
          rawBeforeRule(e) {
            let t;
            return e.walk(n => {
              if (n.nodes && (n.parent !== e || e.first !== n) && void 0 !== n.raws.before) return t = n.raws.before, t.includes("\n") && (t = t.replace(/[^\n]+$/, "")), !1;
            }), t && (t = t.replace(/\S/g, "")), t;
          }
          rawColon(e) {
            let t;
            return e.walkDecls(e => {
              if (void 0 !== e.raws.between) return t = e.raws.between.replace(/[^\s:]/g, ""), !1;
            }), t;
          }
          rawEmptyBody(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && 0 === e.nodes.length && (t = e.raws.after, void 0 !== t)) return !1;
            }), t;
          }
          rawIndent(e) {
            if (e.raws.indent) return e.raws.indent;
            let t;
            return e.walk(n => {
              let r = n.parent;
              if (r && r !== e && r.parent && r.parent === e && void 0 !== n.raws.before) {
                let e = n.raws.before.split("\n");
                return t = e[e.length - 1], t = t.replace(/\S/g, ""), !1;
              }
            }), t;
          }
          rawSemicolon(e) {
            let t;
            return e.walk(e => {
              if (e.nodes && e.nodes.length && "decl" === e.last.type && (t = e.raws.semicolon, void 0 !== t)) return !1;
            }), t;
          }
          rawValue(e, t) {
            let n = e[t],
              r = e.raws[t];
            return r && r.value === n ? r.raw : n;
          }
          root(e) {
            this.body(e), e.raws.after && this.builder(e.raws.after);
          }
          rule(e) {
            this.block(e, this.rawValue(e, "selector")), e.raws.ownSemicolon && this.builder(e.raws.ownSemicolon, e, "end");
          }
          stringify(e, t) {
            if (!this[e.type]) throw new Error("Unknown AST node type " + e.type + ". Maybe you need to change PostCSS stringifier.");
            this[e.type](e, t);
          }
        }
        e.exports = n, n.default = n;
      },
      9921: (e, t, n) => {
        "use strict";

        let r = n(12983);
        function o(e, t) {
          new r(t).stringify(e);
        }
        e.exports = o, o.default = o;
      },
      16356: e => {
        "use strict";

        e.exports.isClean = Symbol("isClean"), e.exports.my = Symbol("my");
      },
      1426: e => {
        "use strict";

        const t = "'".charCodeAt(0),
          n = '"'.charCodeAt(0),
          r = "\\".charCodeAt(0),
          o = "/".charCodeAt(0),
          i = "\n".charCodeAt(0),
          a = " ".charCodeAt(0),
          s = "\f".charCodeAt(0),
          l = "\t".charCodeAt(0),
          u = "\r".charCodeAt(0),
          c = "[".charCodeAt(0),
          d = "]".charCodeAt(0),
          p = "(".charCodeAt(0),
          h = ")".charCodeAt(0),
          f = "{".charCodeAt(0),
          m = "}".charCodeAt(0),
          g = ";".charCodeAt(0),
          v = "*".charCodeAt(0),
          y = ":".charCodeAt(0),
          b = "@".charCodeAt(0),
          w = /[\t\n\f\r "#'()/;[\\\]{}]/g,
          x = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g,
          D = /.[\r\n"'(/\\]/,
          C = /[\da-f]/i;
        e.exports = function (e, S = {}) {
          let E,
            _,
            P,
            k,
            A,
            z,
            T,
            O,
            I,
            F,
            M = e.css.valueOf(),
            R = S.ignoreErrors,
            j = M.length,
            B = 0,
            N = [],
            L = [];
          function V(t) {
            throw e.error("Unclosed " + t, B);
          }
          return {
            back: function (e) {
              L.push(e);
            },
            endOfFile: function () {
              return 0 === L.length && B >= j;
            },
            nextToken: function (e) {
              if (L.length) return L.pop();
              if (B >= j) return;
              let S = !!e && e.ignoreUnclosed;
              switch (E = M.charCodeAt(B), E) {
                case i:
                case a:
                case l:
                case u:
                case s:
                  _ = B;
                  do {
                    _ += 1, E = M.charCodeAt(_);
                  } while (E === a || E === i || E === l || E === u || E === s);
                  F = ["space", M.slice(B, _)], B = _ - 1;
                  break;
                case c:
                case d:
                case f:
                case m:
                case y:
                case g:
                case h:
                  {
                    let e = String.fromCharCode(E);
                    F = [e, e, B];
                    break;
                  }
                case p:
                  if (O = N.length ? N.pop()[1] : "", I = M.charCodeAt(B + 1), "url" === O && I !== t && I !== n && I !== a && I !== i && I !== l && I !== s && I !== u) {
                    _ = B;
                    do {
                      if (z = !1, _ = M.indexOf(")", _ + 1), -1 === _) {
                        if (R || S) {
                          _ = B;
                          break;
                        }
                        V("bracket");
                      }
                      for (T = _; M.charCodeAt(T - 1) === r;) T -= 1, z = !z;
                    } while (z);
                    F = ["brackets", M.slice(B, _ + 1), B, _], B = _;
                  } else _ = M.indexOf(")", B + 1), k = M.slice(B, _ + 1), -1 === _ || D.test(k) ? F = ["(", "(", B] : (F = ["brackets", k, B, _], B = _);
                  break;
                case t:
                case n:
                  P = E === t ? "'" : '"', _ = B;
                  do {
                    if (z = !1, _ = M.indexOf(P, _ + 1), -1 === _) {
                      if (R || S) {
                        _ = B + 1;
                        break;
                      }
                      V("string");
                    }
                    for (T = _; M.charCodeAt(T - 1) === r;) T -= 1, z = !z;
                  } while (z);
                  F = ["string", M.slice(B, _ + 1), B, _], B = _;
                  break;
                case b:
                  w.lastIndex = B + 1, w.test(M), _ = 0 === w.lastIndex ? M.length - 1 : w.lastIndex - 2, F = ["at-word", M.slice(B, _ + 1), B, _], B = _;
                  break;
                case r:
                  for (_ = B, A = !0; M.charCodeAt(_ + 1) === r;) _ += 1, A = !A;
                  if (E = M.charCodeAt(_ + 1), A && E !== o && E !== a && E !== i && E !== l && E !== u && E !== s && (_ += 1, C.test(M.charAt(_)))) {
                    for (; C.test(M.charAt(_ + 1));) _ += 1;
                    M.charCodeAt(_ + 1) === a && (_ += 1);
                  }
                  F = ["word", M.slice(B, _ + 1), B, _], B = _;
                  break;
                default:
                  E === o && M.charCodeAt(B + 1) === v ? (_ = M.indexOf("*/", B + 2) + 1, 0 === _ && (R || S ? _ = M.length : V("comment")), F = ["comment", M.slice(B, _ + 1), B, _], B = _) : (x.lastIndex = B + 1, x.test(M), _ = 0 === x.lastIndex ? M.length - 1 : x.lastIndex - 2, F = ["word", M.slice(B, _ + 1), B, _], N.push(F), B = _);
              }
              return B++, F;
            },
            position: function () {
              return B;
            }
          };
        };
      },
      33066: e => {
        "use strict";

        let t = {};
        e.exports = function (e) {
          t[e] || (t[e] = !0, "undefined" != typeof console && console.warn && console.warn(e));
        };
      },
      9150: e => {
        "use strict";

        class t {
          constructor(e, t = {}) {
            if (this.type = "warning", this.text = e, t.node && t.node.source) {
              let e = t.node.rangeBy(t);
              this.line = e.start.line, this.column = e.start.column, this.endLine = e.end.line, this.endColumn = e.end.column;
            }
            for (let e in t) this[e] = t[e];
          }
          toString() {
            return this.node ? this.node.error(this.text, {
              index: this.index,
              plugin: this.plugin,
              word: this.word
            }).message : this.plugin ? this.plugin + ": " + this.text : this.text;
          }
        }
        e.exports = t, t.default = t;
      },
      59492: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          __assign: () => i,
          __asyncDelegator: () => E,
          __asyncGenerator: () => S,
          __asyncValues: () => _,
          __await: () => C,
          __awaiter: () => f,
          __classPrivateFieldGet: () => T,
          __classPrivateFieldIn: () => I,
          __classPrivateFieldSet: () => O,
          __createBinding: () => g,
          __decorate: () => s,
          __esDecorate: () => u,
          __exportStar: () => v,
          __extends: () => o,
          __generator: () => m,
          __importDefault: () => z,
          __importStar: () => A,
          __makeTemplateObject: () => P,
          __metadata: () => h,
          __param: () => l,
          __propKey: () => d,
          __read: () => b,
          __rest: () => a,
          __runInitializers: () => c,
          __setFunctionName: () => p,
          __spread: () => w,
          __spreadArray: () => D,
          __spreadArrays: () => x,
          __values: () => y
        });
        var r = function (e, t) {
          return r = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, r(e, t);
        };
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var i = function () {
          return i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, i.apply(this, arguments);
        };
        function a(e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        }
        function s(e, t, n, r) {
          var o,
            i = arguments.length,
            a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
          if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
          return i > 3 && a && Object.defineProperty(t, n, a), a;
        }
        function l(e, t) {
          return function (n, r) {
            t(n, r, e);
          };
        }
        function u(e, t, n, r, o, i) {
          function a(e) {
            if (void 0 !== e && "function" != typeof e) throw new TypeError("Function expected");
            return e;
          }
          for (var s, l = r.kind, u = "getter" === l ? "get" : "setter" === l ? "set" : "value", c = !t && e ? r.static ? e : e.prototype : null, d = t || (c ? Object.getOwnPropertyDescriptor(c, r.name) : {}), p = !1, h = n.length - 1; h >= 0; h--) {
            var f = {};
            for (var m in r) f[m] = "access" === m ? {} : r[m];
            for (var m in r.access) f.access[m] = r.access[m];
            f.addInitializer = function (e) {
              if (p) throw new TypeError("Cannot add initializers after decoration has completed");
              i.push(a(e || null));
            };
            var g = (0, n[h])("accessor" === l ? {
              get: d.get,
              set: d.set
            } : d[u], f);
            if ("accessor" === l) {
              if (void 0 === g) continue;
              if (null === g || "object" != typeof g) throw new TypeError("Object expected");
              (s = a(g.get)) && (d.get = s), (s = a(g.set)) && (d.set = s), (s = a(g.init)) && o.push(s);
            } else (s = a(g)) && ("field" === l ? o.push(s) : d[u] = s);
          }
          c && Object.defineProperty(c, r.name, d), p = !0;
        }
        function c(e, t, n) {
          for (var r = arguments.length > 2, o = 0; o < t.length; o++) n = r ? t[o].call(e, n) : t[o].call(e);
          return r ? n : void 0;
        }
        function d(e) {
          return "symbol" == typeof e ? e : "".concat(e);
        }
        function p(e, t, n) {
          return "symbol" == typeof t && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
            configurable: !0,
            value: n ? "".concat(n, " ", t) : t
          });
        }
        function h(e, t) {
          if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(e, t);
        }
        function f(e, t, n, r) {
          return new (n || (n = Promise))(function (o, i) {
            function a(e) {
              try {
                l(r.next(e));
              } catch (e) {
                i(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                i(e);
              }
            }
            function l(e) {
              var t;
              e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
                e(t);
              })).then(a, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        }
        function m(e, t) {
          var n,
            r,
            o,
            i,
            a = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: []
            };
          return i = {
            next: s(0),
            throw: s(1),
            return: s(2)
          }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
            return this;
          }), i;
          function s(s) {
            return function (l) {
              return function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; i && (i = 0, s[0] && (a = 0)), a;) try {
                  if (n = 1, r && (o = 2 & s[0] ? r.return : s[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, s[1])).done) return o;
                  switch (r = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                    case 0:
                    case 1:
                      o = s;
                      break;
                    case 4:
                      return a.label++, {
                        value: s[1],
                        done: !1
                      };
                    case 5:
                      a.label++, r = s[1], s = [0];
                      continue;
                    case 7:
                      s = a.ops.pop(), a.trys.pop();
                      continue;
                    default:
                      if (!(o = a.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        a = 0;
                        continue;
                      }
                      if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                        a.label = s[1];
                        break;
                      }
                      if (6 === s[0] && a.label < o[1]) {
                        a.label = o[1], o = s;
                        break;
                      }
                      if (o && a.label < o[2]) {
                        a.label = o[2], a.ops.push(s);
                        break;
                      }
                      o[2] && a.ops.pop(), a.trys.pop();
                      continue;
                  }
                  s = t.call(e, a);
                } catch (e) {
                  s = [6, e], r = 0;
                } finally {
                  n = o = 0;
                }
                if (5 & s[0]) throw s[1];
                return {
                  value: s[0] ? s[1] : void 0,
                  done: !0
                };
              }([s, l]);
            };
          }
        }
        var g = Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n);
          var o = Object.getOwnPropertyDescriptor(t, n);
          o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
            enumerable: !0,
            get: function () {
              return t[n];
            }
          }), Object.defineProperty(e, r, o);
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        };
        function v(e, t) {
          for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || g(t, e, n);
        }
        function y(e) {
          var t = "function" == typeof Symbol && Symbol.iterator,
            n = t && e[t],
            r = 0;
          if (n) return n.call(e);
          if (e && "number" == typeof e.length) return {
            next: function () {
              return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
              };
            }
          };
          throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
        }
        function b(e, t) {
          var n = "function" == typeof Symbol && e[Symbol.iterator];
          if (!n) return e;
          var r,
            o,
            i = n.call(e),
            a = [];
          try {
            for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
          } catch (e) {
            o = {
              error: e
            };
          } finally {
            try {
              r && !r.done && (n = i.return) && n.call(i);
            } finally {
              if (o) throw o.error;
            }
          }
          return a;
        }
        function w() {
          for (var e = [], t = 0; t < arguments.length; t++) e = e.concat(b(arguments[t]));
          return e;
        }
        function x() {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
          var r = Array(e),
            o = 0;
          for (t = 0; t < n; t++) for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++) r[o] = i[a];
          return r;
        }
        function D(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || Array.prototype.slice.call(t));
        }
        function C(e) {
          return this instanceof C ? (this.v = e, this) : new C(e);
        }
        function S(e, t, n) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var r,
            o = n.apply(e, t || []),
            i = [];
          return r = {}, a("next"), a("throw"), a("return"), r[Symbol.asyncIterator] = function () {
            return this;
          }, r;
          function a(e) {
            o[e] && (r[e] = function (t) {
              return new Promise(function (n, r) {
                i.push([e, t, n, r]) > 1 || s(e, t);
              });
            });
          }
          function s(e, t) {
            try {
              (n = o[e](t)).value instanceof C ? Promise.resolve(n.value.v).then(l, u) : c(i[0][2], n);
            } catch (e) {
              c(i[0][3], e);
            }
            var n;
          }
          function l(e) {
            s("next", e);
          }
          function u(e) {
            s("throw", e);
          }
          function c(e, t) {
            e(t), i.shift(), i.length && s(i[0][0], i[0][1]);
          }
        }
        function E(e) {
          var t, n;
          return t = {}, r("next"), r("throw", function (e) {
            throw e;
          }), r("return"), t[Symbol.iterator] = function () {
            return this;
          }, t;
          function r(r, o) {
            t[r] = e[r] ? function (t) {
              return (n = !n) ? {
                value: C(e[r](t)),
                done: !1
              } : o ? o(t) : t;
            } : o;
          }
        }
        function _(e) {
          if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
          var t,
            n = e[Symbol.asyncIterator];
          return n ? n.call(e) : (e = y(e), t = {}, r("next"), r("throw"), r("return"), t[Symbol.asyncIterator] = function () {
            return this;
          }, t);
          function r(n) {
            t[n] = e[n] && function (t) {
              return new Promise(function (r, o) {
                (function (e, t, n, r) {
                  Promise.resolve(r).then(function (t) {
                    e({
                      value: t,
                      done: n
                    });
                  }, t);
                })(r, o, (t = e[n](t)).done, t.value);
              });
            };
          }
        }
        function P(e, t) {
          return Object.defineProperty ? Object.defineProperty(e, "raw", {
            value: t
          }) : e.raw = t, e;
        }
        var k = Object.create ? function (e, t) {
          Object.defineProperty(e, "default", {
            enumerable: !0,
            value: t
          });
        } : function (e, t) {
          e.default = t;
        };
        function A(e) {
          if (e && e.__esModule) return e;
          var t = {};
          if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && g(t, e, n);
          return k(t, e), t;
        }
        function z(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function T(e, t, n, r) {
          if ("a" === n && !r) throw new TypeError("Private accessor was defined without a getter");
          if ("function" == typeof t ? e !== t || !r : !t.has(e)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
          return "m" === n ? r : "a" === n ? r.call(e) : r ? r.value : t.get(e);
        }
        function O(e, t, n, r, o) {
          if ("m" === r) throw new TypeError("Private method is not writable");
          if ("a" === r && !o) throw new TypeError("Private accessor was defined without a setter");
          if ("function" == typeof t ? e !== t || !o : !t.has(e)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
          return "a" === r ? o.call(e, n) : o ? o.value = n : t.set(e, n), n;
        }
        function I(e, t) {
          if (null === t || "object" != typeof t && "function" != typeof t) throw new TypeError("Cannot use 'in' operator on non-object");
          return "function" == typeof e ? t === e : e.has(t);
        }
      },
      15191: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const r = n(59492);
        r.__exportStar(n(99944), t), r.__exportStar(n(94325), t), r.__exportStar(n(93026), t);
      },
      93026: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isBlock = void 0;
        const n = ["address", "article", "aside", "blockquote", "body", "br", "caption", "center", "col", "colgroup", "dd", "dialog", "dir", "div", "dl", "dt", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "legend", "li", "li", "listing", "main", "menu", "nav", "ol", "optgroup", "option", "p", "plaintext", "pre", "section", "summary", "table", "tbody", "td", "td", "tfoot", "th", "th", "thead", "tr", "ul", "wbr", "xmp"];
        t.isBlock = e => n.includes(e);
      },
      99944: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.transformStyleStringToObject = t.transformStyleObjectToString = void 0;
        const r = n(78590),
          o = n(83877);
        t.transformStyleObjectToString = e => {
          const t = {
            parser: o.parse,
            from: void 0
          };
          return (0, r.default)().process(e, t).css.replace(/(\r\n|\n|\r)/gm, " ").replace(/\s\s+/g, " ");
        };
        t.transformStyleStringToObject = e => {
          const t = r.default.parse(e);
          return (0, o.objectify)(t);
        };
      },
      94325: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.styleMapToAttribs = t.intersection = t.decodeBreakingEntities = t.encodeBreakingEntities = t.getNested = t.removeEmpty = t.isEmptyObject = t.styleToString = t.parseStyleCssText = t.prependSpace = t.hasLineBreak = void 0;
        t.hasLineBreak = e => null !== e.match(/[\r\n]+/);
        t.prependSpace = e => e && ` ${e.trim()}`;
        t.parseStyleCssText = e => {
          const t = {};
          if (!e) return t;
          const n = e.split(";");
          for (const e of n) {
            const n = e.trim();
            if (n) {
              const e = n.split(":");
              t[e[0].trim().replace(/(?:^|[-])(\w)/g, (e, t) => (t = "-" === e.substring(0, 1) ? t.toUpperCase() : t) || "")] = e[1].trim();
            }
          }
          return t;
        };
        t.styleToString = e => Object.keys(e).reduce((t, n) => t + n.split(/(?=[A-Z])/).join("-").toLowerCase() + ":" + e[n] + ";", "");
        t.isEmptyObject = e => e && 0 === Object.keys(e).length && Object.getPrototypeOf(e) === Object.prototype;
        t.removeEmpty = e => Object.fromEntries(Object.entries(e).filter(([e, t]) => null != t));
        t.getNested = (e, ...t) => t.reduce((e, t) => e && e[t], e);
        t.encodeBreakingEntities = e => e = e.replace(/[&<>]/g, e => (e => {
          switch (e) {
            case "&":
              return "&amp;";
            case "<":
              return "&lt;";
            case ">":
              return "&gt;";
            default:
              return e;
          }
        })(e));
        t.decodeBreakingEntities = e => e.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">");
        t.intersection = (e, t) => Object.keys(e).concat(Object.keys(t)).sort().reduce((e, t, n, r) => (n && r[n - 1] === t && e.push(t), e), []);
        t.styleMapToAttribs = ({
          elementStyleMap: e,
          node: n
        }) => {
          let r = {};
          const o = {};
          return Object.keys(e).forEach(t => {
            const r = e[t],
              i = n[t];
            i && (o[r] = i);
          }), (0, t.isEmptyObject)(o) || (r = Object.assign(Object.assign({}, r), {
            style: (0, t.styleToString)(o)
          })), (0, t.isEmptyObject)(r) ? {} : r;
        };
      },
      2278: (e, t, n) => {
        "use strict";

        function r(e, t, n) {
          !function (e, t) {
            if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }(e, t), t.set(e, n);
        }
        n.d(t, {
          _: () => r
        });
      },
      4338: (e, t) => {
        "use strict";

        function n(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.OptionsReader = void 0;
        var r = function () {
          function e(t, n) {
            var r = this;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), this.ownerDocument = null, this.enableTouchEvents = !0, this.enableMouseEvents = !1, this.enableKeyboardEvents = !1, this.ignoreContextMenu = !1, this.enableHoverOutsideTarget = !1, this.touchSlop = 0, this.scrollAngleRanges = void 0, this.context = n, this.delayTouchStart = t.delayTouchStart || t.delay || 0, this.delayMouseStart = t.delayMouseStart || t.delay || 0, Object.keys(t).forEach(function (e) {
              null != t[e] && (r[e] = t[e]);
            });
          }
          var t, r, o;
          return t = e, (r = [{
            key: "window",
            get: function () {
              return this.context && this.context.window ? this.context.window : "undefined" != typeof window ? window : void 0;
            }
          }, {
            key: "document",
            get: function () {
              return this.ownerDocument ? this.ownerDocument : this.window ? this.window.document : void 0;
            }
          }]) && n(t.prototype, r), o && n(t, o), e;
        }();
        t.OptionsReader = r;
      },
      2874: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.TouchBackendImpl = void 0;
        var r,
          o = n(47930),
          i = n(96944),
          a = n(91527),
          s = n(68953),
          l = n(68827),
          u = n(17890),
          c = n(4338);
        function d(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        function p(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var h = (p(r = {}, i.ListenerType.mouse, {
            start: "mousedown",
            move: "mousemove",
            end: "mouseup",
            contextmenu: "contextmenu"
          }), p(r, i.ListenerType.touch, {
            start: "touchstart",
            move: "touchmove",
            end: "touchend"
          }), p(r, i.ListenerType.keyboard, {
            keydown: "keydown"
          }), r),
          f = function () {
            function e(t, n, r) {
              var o = this;
              !function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, e), this.lastClientOffset = null, this.lastDragOverTargetIds = null, this.updateTimer = null, this.getSourceClientOffset = function (e) {
                var t = o.sourceNodes.get(e);
                return t && (0, s.getNodeClientOffset)(t);
              }, this.handleTopMoveStartCapture = function (e) {
                (0, a.eventShouldStartDrag)(e) && (o.moveStartSourceIds = []);
              }, this.handleMoveStart = function (e) {
                Array.isArray(o.moveStartSourceIds) && o.moveStartSourceIds.unshift(e);
              }, this.handleTopMoveStart = function (e) {
                if ((0, a.eventShouldStartDrag)(e)) {
                  var t = (0, s.getEventClientOffset)(e);
                  if (t) {
                    (0, a.isTouchEvent)(e) && (o.lastTargetTouchFallback = e.targetTouches[0]), o._mouseClientOffset = t;
                    var n = e.type === h.touch.start ? o.options.delayTouchStart : o.options.delayMouseStart;
                    if (!o.monitor.isDragging() && o.waitingForDelay && n > 0) {
                      var r = o.moveStartSourceIds;
                      o.actions.beginDrag(r, {
                        clientOffset: o._mouseClientOffset,
                        getSourceClientOffset: o.getSourceClientOffset,
                        publishSource: !1
                      });
                    }
                  }
                  o.waitingForDelay = !1;
                }
              }, this.handleTopMoveStartDelay = function (e) {
                if ((0, a.eventShouldStartDrag)(e)) {
                  var t = e.type === h.touch.start ? o.options.delayTouchStart : o.options.delayMouseStart;
                  o.timeout = setTimeout(o.handleTopMoveStart.bind(o, e), t), o.waitingForDelay = !0;
                }
              }, this.handleTopMoveCapture = function () {
                o.dragOverTargetIds = [];
              }, this.handleMove = function (e, t) {
                o.dragOverTargetIds && o.dragOverTargetIds.unshift(t);
              }, this.handleTopMove = function (e) {
                if (o.document && !o.waitingForDelay) {
                  o.timeout && clearTimeout(o.timeout);
                  var t = o.moveStartSourceIds,
                    n = o.dragOverTargetIds,
                    r = o.options.enableHoverOutsideTarget,
                    i = (0, s.getEventClientOffset)(e, o.lastTargetTouchFallback);
                  if (i) if (o._isScrolling || !o.monitor.isDragging() && (0, l.inAngleRanges)(o._mouseClientOffset.x || 0, o._mouseClientOffset.y || 0, i.x, i.y, o.options.scrollAngleRanges)) o._isScrolling = !0;else if (!o.monitor.isDragging() && o._mouseClientOffset.hasOwnProperty("x") && t && (0, l.distance)(o._mouseClientOffset.x || 0, o._mouseClientOffset.y || 0, i.x, i.y) > (o.options.touchSlop ? o.options.touchSlop : 0) && (o.moveStartSourceIds = void 0, o.actions.beginDrag(t, {
                    clientOffset: o._mouseClientOffset,
                    getSourceClientOffset: o.getSourceClientOffset,
                    publishSource: !1
                  })), o.monitor.isDragging()) {
                    var a = o.sourceNodes.get(o.monitor.getSourceId());
                    o.installSourceNodeRemovalObserver(a), o.actions.publishDragSource(), e.cancelable && e.preventDefault();
                    var u = (n || []).map(function (e) {
                        return o.targetNodes.get(e);
                      }).filter(function (e) {
                        return !!e;
                      }),
                      c = o.options.getDropTargetElementsAtPoint ? o.options.getDropTargetElementsAtPoint(i.x, i.y, u) : o.document.elementsFromPoint(i.x, i.y),
                      d = [];
                    for (var p in c) if (c.hasOwnProperty(p)) {
                      var h = c[p];
                      for (d.push(h); h;) (h = h.parentElement) && -1 === d.indexOf(h) && d.push(h);
                    }
                    var f = d.filter(function (e) {
                      return u.indexOf(e) > -1;
                    }).map(function (e) {
                      return o._getDropTargetId(e);
                    }).filter(function (e) {
                      return !!e;
                    }).filter(function (e, t, n) {
                      return n.indexOf(e) === t;
                    });
                    if (r) for (var m in o.targetNodes) {
                      var g = o.targetNodes.get(m);
                      if (a && g && g.contains(a) && -1 === f.indexOf(m)) {
                        f.unshift(m);
                        break;
                      }
                    }
                    if (o.lastDragOverTargetIds = f.reverse(), o.lastClientOffset = i, !o.updateTimer) {
                      var v = function e() {
                        o.monitor.isDragging() && (o.actions.hover(o.lastDragOverTargetIds, {
                          clientOffset: o.lastClientOffset
                        }), o.updateTimer = requestAnimationFrame(e));
                      };
                      o.updateTimer = requestAnimationFrame(function () {
                        v();
                      });
                    }
                  }
                }
              }, this._getDropTargetId = function (e) {
                for (var t = o.targetNodes.keys(), n = t.next(); !1 === n.done;) {
                  var r = n.value;
                  if (e === o.targetNodes.get(r)) return r;
                  n = t.next();
                }
              }, this.handleTopMoveEndCapture = function (e) {
                o._isScrolling = !1, o.lastTargetTouchFallback = void 0, (0, a.eventShouldEndDrag)(e) && (o.monitor.isDragging() && !o.monitor.didDrop() ? (e.cancelable && e.preventDefault(), o._mouseClientOffset = {}, o.uninstallSourceNodeRemovalObserver(), o.actions.drop(), o.actions.endDrag(), o.updateTimer && cancelAnimationFrame(o.updateTimer), o.updateTimer = null) : o.moveStartSourceIds = void 0);
              }, this.handleCancelOnEscape = function (e) {
                "Escape" === e.key && o.monitor.isDragging() && (o._mouseClientOffset = {}, o.uninstallSourceNodeRemovalObserver(), o.actions.endDrag());
              }, this.options = new c.OptionsReader(r, n), this.actions = t.getActions(), this.monitor = t.getMonitor(), this.sourceNodes = new Map(), this.sourcePreviewNodes = new Map(), this.sourcePreviewNodeOptions = new Map(), this.targetNodes = new Map(), this.listenerTypes = [], this._mouseClientOffset = {}, this._isScrolling = !1, this.options.enableMouseEvents && this.listenerTypes.push(i.ListenerType.mouse), this.options.enableTouchEvents && this.listenerTypes.push(i.ListenerType.touch), this.options.enableKeyboardEvents && this.listenerTypes.push(i.ListenerType.keyboard);
            }
            var t, n, r;
            return t = e, (n = [{
              key: "profile",
              value: function () {
                var e;
                return {
                  sourceNodes: this.sourceNodes.size,
                  sourcePreviewNodes: this.sourcePreviewNodes.size,
                  sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
                  targetNodes: this.targetNodes.size,
                  dragOverTargetIds: (null === (e = this.dragOverTargetIds) || void 0 === e ? void 0 : e.length) || 0
                };
              }
            }, {
              key: "setup",
              value: function () {
                this.document && ((0, o.invariant)(!e.isSetUp, "Cannot have two Touch backends at the same time."), e.isSetUp = !0, this.addEventListener(this.document, "start", this.getTopMoveStartHandler()), this.addEventListener(this.document, "start", this.handleTopMoveStartCapture, !0), this.addEventListener(this.document, "move", this.handleTopMove), this.addEventListener(this.document, "move", this.handleTopMoveCapture, !0), this.addEventListener(this.document, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.addEventListener(this.document, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.addEventListener(this.document, "keydown", this.handleCancelOnEscape, !0));
              }
            }, {
              key: "teardown",
              value: function () {
                this.document && (e.isSetUp = !1, this._mouseClientOffset = {}, this.removeEventListener(this.document, "start", this.handleTopMoveStartCapture, !0), this.removeEventListener(this.document, "start", this.handleTopMoveStart), this.removeEventListener(this.document, "move", this.handleTopMoveCapture, !0), this.removeEventListener(this.document, "move", this.handleTopMove), this.removeEventListener(this.document, "end", this.handleTopMoveEndCapture, !0), this.options.enableMouseEvents && !this.options.ignoreContextMenu && this.removeEventListener(this.document, "contextmenu", this.handleTopMoveEndCapture), this.options.enableKeyboardEvents && this.removeEventListener(this.document, "keydown", this.handleCancelOnEscape, !0), this.uninstallSourceNodeRemovalObserver());
              }
            }, {
              key: "throttle",
              value: function (e, t) {
                var n = !1;
                return function (r) {
                  n || (e(r), n = !0, setTimeout(function () {
                    n = !1;
                  }, t));
                };
              }
            }, {
              key: "addEventListener",
              value: function (e, t, n, r) {
                var o = u.supportsPassive ? {
                    capture: r,
                    passive: !1
                  } : r,
                  i = this.throttle(n, 50);
                this.listenerTypes.forEach(function (n) {
                  var r = h[n][t];
                  r && e.addEventListener(r, i, o);
                });
              }
            }, {
              key: "removeEventListener",
              value: function (e, t, n, r) {
                var o = u.supportsPassive ? {
                  capture: r,
                  passive: !1
                } : r;
                this.listenerTypes.forEach(function (r) {
                  var i = h[r][t];
                  i && e.removeEventListener(i, n, o);
                });
              }
            }, {
              key: "connectDragSource",
              value: function (e, t) {
                var n = this,
                  r = this.handleMoveStart.bind(this, e);
                return this.sourceNodes.set(e, t), this.addEventListener(t, "start", r), function () {
                  n.sourceNodes.delete(e), n.removeEventListener(t, "start", r);
                };
              }
            }, {
              key: "connectDragPreview",
              value: function (e, t, n) {
                var r = this;
                return this.sourcePreviewNodeOptions.set(e, n), this.sourcePreviewNodes.set(e, t), function () {
                  r.sourcePreviewNodes.delete(e), r.sourcePreviewNodeOptions.delete(e);
                };
              }
            }, {
              key: "connectDropTarget",
              value: function (e, t) {
                var n = this;
                if (!this.document) return function () {};
                var r = function (r) {
                  if (n.document && n.monitor.isDragging()) {
                    var o;
                    switch (r.type) {
                      case h.mouse.move:
                        o = {
                          x: r.clientX,
                          y: r.clientY
                        };
                        break;
                      case h.touch.move:
                        o = {
                          x: r.touches[0].clientX,
                          y: r.touches[0].clientY
                        };
                    }
                    var i = null != o ? n.document.elementFromPoint(o.x, o.y) : void 0,
                      a = i && t.contains(i);
                    return i === t || a ? n.handleMove(r, e) : void 0;
                  }
                };
                return this.addEventListener(this.document.body, "move", r), this.targetNodes.set(e, t), function () {
                  n.document && (n.targetNodes.delete(e), n.removeEventListener(n.document.body, "move", r));
                };
              }
            }, {
              key: "getTopMoveStartHandler",
              value: function () {
                return this.options.delayTouchStart || this.options.delayMouseStart ? this.handleTopMoveStartDelay : this.handleTopMoveStart;
              }
            }, {
              key: "installSourceNodeRemovalObserver",
              value: function (e) {
                var t = this;
                this.uninstallSourceNodeRemovalObserver(), this.draggedSourceNode = e, this.draggedSourceNodeRemovalObserver = new MutationObserver(function () {
                  e && !e.parentElement && (t.resurrectSourceNode(), t.uninstallSourceNodeRemovalObserver());
                }), e && e.parentElement && this.draggedSourceNodeRemovalObserver.observe(e.parentElement, {
                  childList: !0
                });
              }
            }, {
              key: "resurrectSourceNode",
              value: function () {
                this.document && this.draggedSourceNode && (this.draggedSourceNode.style.display = "none", this.draggedSourceNode.removeAttribute("data-reactid"), this.document.body.appendChild(this.draggedSourceNode));
              }
            }, {
              key: "uninstallSourceNodeRemovalObserver",
              value: function () {
                this.draggedSourceNodeRemovalObserver && this.draggedSourceNodeRemovalObserver.disconnect(), this.draggedSourceNodeRemovalObserver = void 0, this.draggedSourceNode = void 0;
              }
            }, {
              key: "document",
              get: function () {
                return this.options.document;
              }
            }]) && d(t.prototype, n), r && d(t, r), e;
          }();
        t.TouchBackendImpl = f;
      },
      36623: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var r = {
          TouchBackend: !0
        };
        t.TouchBackend = void 0;
        var o = n(2874);
        Object.keys(o).forEach(function (e) {
          "default" !== e && "__esModule" !== e && (Object.prototype.hasOwnProperty.call(r, e) || e in t && t[e] === o[e] || Object.defineProperty(t, e, {
            enumerable: !0,
            get: function () {
              return o[e];
            }
          }));
        });
        t.TouchBackend = function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return new o.TouchBackendImpl(e, t, n);
        };
      },
      96944: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.ListenerType = void 0, t.ListenerType = n, function (e) {
          e.mouse = "mouse", e.touch = "touch", e.keyboard = "keyboard";
        }(n || (t.ListenerType = n = {}));
      },
      68827: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.distance = function (e, t, n, r) {
          return Math.sqrt(Math.pow(Math.abs(n - e), 2) + Math.pow(Math.abs(r - t), 2));
        }, t.inAngleRanges = function (e, t, n, r, o) {
          if (!o) return !1;
          for (var i = 180 * Math.atan2(r - t, n - e) / Math.PI + 180, a = 0; a < o.length; ++a) if ((null == o[a].start || i >= o[a].start) && (null == o[a].end || i <= o[a].end)) return !0;
          return !1;
        };
      },
      68953: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getNodeClientOffset = function (e) {
          var t = 1 === e.nodeType ? e : e.parentElement;
          if (!t) return;
          var n = t.getBoundingClientRect(),
            r = n.top;
          return {
            x: n.left,
            y: r
          };
        }, t.getEventClientTouchOffset = o, t.getEventClientOffset = i;
        var r = n(91527);
        function o(e, t) {
          return 1 === e.targetTouches.length ? i(e.targetTouches[0]) : t && 1 === e.touches.length && e.touches[0].target === t.target ? i(e.touches[0]) : void 0;
        }
        function i(e, t) {
          return (0, r.isTouchEvent)(e) ? o(e, t) : {
            x: e.clientX,
            y: e.clientY
          };
        }
      },
      91527: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.eventShouldStartDrag = function (e) {
          return void 0 === e.button || e.button === r;
        }, t.eventShouldEndDrag = function (e) {
          return void 0 === e.buttons || 0 == (e.buttons & n);
        }, t.isTouchEvent = function (e) {
          return !!e.targetTouches;
        };
        var n = 1,
          r = 0;
      },
      17890: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.supportsPassive = void 0;
        var n = function () {
          var e = !1;
          try {
            addEventListener("test", function () {}, Object.defineProperty({}, "passive", {
              get: function () {
                return e = !0, !0;
              }
            }));
          } catch (e) {}
          return e;
        }();
        t.supportsPassive = n;
      },
      47930: (e, t, n) => {
        "use strict";

        function r(e, t) {
          for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) r[o - 2] = arguments[o];
          if (!e) {
            var i;
            if (void 0 === t) i = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
              var a = 0;
              (i = new Error(t.replace(/%s/g, function () {
                return r[a++];
              }))).name = "Invariant Violation";
            }
            throw i.framesToPop = 1, i;
          }
        }
        n.r(t), n.d(t, {
          invariant: () => r
        });
      },
      35782: (e, t, n) => {
        "use strict";

        n.d(t, {
          _H: () => Zt,
          Pj: () => Ft,
          dp: () => Ot,
          Sn: () => Ne,
          vU: () => Gt,
          XN: () => St,
          YB: () => Et
        });
        var r = n(70655),
          o = n(67294),
          i = n(8679),
          a = n.n(i);
        ["angle-degree", "area-acre", "area-hectare", "concentr-percent", "digital-bit", "digital-byte", "digital-gigabit", "digital-gigabyte", "digital-kilobit", "digital-kilobyte", "digital-megabit", "digital-megabyte", "digital-petabyte", "digital-terabit", "digital-terabyte", "duration-day", "duration-hour", "duration-millisecond", "duration-minute", "duration-month", "duration-second", "duration-week", "duration-year", "length-centimeter", "length-foot", "length-inch", "length-kilometer", "length-meter", "length-mile-scandinavian", "length-mile", "length-millimeter", "length-yard", "mass-gram", "mass-kilogram", "mass-ounce", "mass-pound", "mass-stone", "temperature-celsius", "temperature-fahrenheit", "volume-fluid-ounce", "volume-gallon", "volume-liter", "volume-milliliter"].map(function (e) {
          return e.slice(e.indexOf("-") + 1);
        });
        function s(e, t, n) {
          if (void 0 === n && (n = Error), !e) throw new n(t);
        }
        var l = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20BF\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFB\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC1\uFDFC\uFDFD\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDE8\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEE0-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF73\uDF80-\uDFD8\uDFE0-\uDFEB]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDD78\uDD7A-\uDDCB\uDDCD-\uDE53\uDE60-\uDE6D\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6\uDF00-\uDF92\uDF94-\uDFCA]/;
        new RegExp("^" + l.source), new RegExp(l.source + "$");
        var u, c, d, p;
        !function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = "MISSING_LOCALE_DATA", t;
          }
          (0, r.ZT)(t, e);
        }(Error);
        function h(e) {
          return e.type === d.literal;
        }
        function f(e) {
          return e.type === d.argument;
        }
        function m(e) {
          return e.type === d.number;
        }
        function g(e) {
          return e.type === d.date;
        }
        function v(e) {
          return e.type === d.time;
        }
        function y(e) {
          return e.type === d.select;
        }
        function b(e) {
          return e.type === d.plural;
        }
        function w(e) {
          return e.type === d.pound;
        }
        function x(e) {
          return e.type === d.tag;
        }
        function D(e) {
          return !(!e || "object" != typeof e || e.type !== p.number);
        }
        function C(e) {
          return !(!e || "object" != typeof e || e.type !== p.dateTime);
        }
        !function (e) {
          e.startRange = "startRange", e.shared = "shared", e.endRange = "endRange";
        }(u || (u = {})), function (e) {
          e[e.EXPECT_ARGUMENT_CLOSING_BRACE = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE", e[e.EMPTY_ARGUMENT = 2] = "EMPTY_ARGUMENT", e[e.MALFORMED_ARGUMENT = 3] = "MALFORMED_ARGUMENT", e[e.EXPECT_ARGUMENT_TYPE = 4] = "EXPECT_ARGUMENT_TYPE", e[e.INVALID_ARGUMENT_TYPE = 5] = "INVALID_ARGUMENT_TYPE", e[e.EXPECT_ARGUMENT_STYLE = 6] = "EXPECT_ARGUMENT_STYLE", e[e.INVALID_NUMBER_SKELETON = 7] = "INVALID_NUMBER_SKELETON", e[e.INVALID_DATE_TIME_SKELETON = 8] = "INVALID_DATE_TIME_SKELETON", e[e.EXPECT_NUMBER_SKELETON = 9] = "EXPECT_NUMBER_SKELETON", e[e.EXPECT_DATE_TIME_SKELETON = 10] = "EXPECT_DATE_TIME_SKELETON", e[e.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE", e[e.EXPECT_SELECT_ARGUMENT_OPTIONS = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS", e[e.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR", e[e.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT", e[e.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT", e[e.INVALID_PLURAL_ARGUMENT_SELECTOR = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_PLURAL_ARGUMENT_SELECTOR = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR", e[e.DUPLICATE_SELECT_ARGUMENT_SELECTOR = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR", e[e.MISSING_OTHER_CLAUSE = 22] = "MISSING_OTHER_CLAUSE", e[e.INVALID_TAG = 23] = "INVALID_TAG", e[e.INVALID_TAG_NAME = 25] = "INVALID_TAG_NAME", e[e.UNMATCHED_CLOSING_TAG = 26] = "UNMATCHED_CLOSING_TAG", e[e.UNCLOSED_TAG = 27] = "UNCLOSED_TAG";
        }(c || (c = {})), function (e) {
          e[e.literal = 0] = "literal", e[e.argument = 1] = "argument", e[e.number = 2] = "number", e[e.date = 3] = "date", e[e.time = 4] = "time", e[e.select = 5] = "select", e[e.plural = 6] = "plural", e[e.pound = 7] = "pound", e[e.tag = 8] = "tag";
        }(d || (d = {})), function (e) {
          e[e.number = 0] = "number", e[e.dateTime = 1] = "dateTime";
        }(p || (p = {}));
        var S = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/,
          E = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
        function _(e) {
          var t = {};
          return e.replace(E, function (e) {
            var n = e.length;
            switch (e[0]) {
              case "G":
                t.era = 4 === n ? "long" : 5 === n ? "narrow" : "short";
                break;
              case "y":
                t.year = 2 === n ? "2-digit" : "numeric";
                break;
              case "Y":
              case "u":
              case "U":
              case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
              case "q":
              case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
              case "M":
              case "L":
                t.month = ["numeric", "2-digit", "short", "long", "narrow"][n - 1];
                break;
              case "w":
              case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
              case "d":
                t.day = ["numeric", "2-digit"][n - 1];
                break;
              case "D":
              case "F":
              case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
              case "E":
                t.weekday = 4 === n ? "short" : 5 === n ? "narrow" : "short";
                break;
              case "e":
                if (n < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                t.weekday = ["short", "long", "narrow", "short"][n - 4];
                break;
              case "c":
                if (n < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                t.weekday = ["short", "long", "narrow", "short"][n - 4];
                break;
              case "a":
                t.hour12 = !0;
                break;
              case "b":
              case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
              case "h":
                t.hourCycle = "h12", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "H":
                t.hourCycle = "h23", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "K":
                t.hourCycle = "h11", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "k":
                t.hourCycle = "h24", t.hour = ["numeric", "2-digit"][n - 1];
                break;
              case "j":
              case "J":
              case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
              case "m":
                t.minute = ["numeric", "2-digit"][n - 1];
                break;
              case "s":
                t.second = ["numeric", "2-digit"][n - 1];
                break;
              case "S":
              case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
              case "z":
                t.timeZoneName = n < 4 ? "short" : "long";
                break;
              case "Z":
              case "O":
              case "v":
              case "V":
              case "X":
              case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
            }
            return "";
          }), t;
        }
        var P = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
        var k,
          A = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g,
          z = /^(@+)?(\+|#+)?$/g,
          T = /(\*)(0+)|(#+)(0+)|(0+)/g,
          O = /^(0+)$/;
        function I(e) {
          var t = {};
          return e.replace(z, function (e, n, r) {
            return "string" != typeof r ? (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length) : "+" === r ? t.minimumSignificantDigits = n.length : "#" === n[0] ? t.maximumSignificantDigits = n.length : (t.minimumSignificantDigits = n.length, t.maximumSignificantDigits = n.length + ("string" == typeof r ? r.length : 0)), "";
          }), t;
        }
        function F(e) {
          switch (e) {
            case "sign-auto":
              return {
                signDisplay: "auto"
              };
            case "sign-accounting":
            case "()":
              return {
                currencySign: "accounting"
              };
            case "sign-always":
            case "+!":
              return {
                signDisplay: "always"
              };
            case "sign-accounting-always":
            case "()!":
              return {
                signDisplay: "always",
                currencySign: "accounting"
              };
            case "sign-except-zero":
            case "+?":
              return {
                signDisplay: "exceptZero"
              };
            case "sign-accounting-except-zero":
            case "()?":
              return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
              };
            case "sign-never":
            case "+_":
              return {
                signDisplay: "never"
              };
          }
        }
        function M(e) {
          var t;
          if ("E" === e[0] && "E" === e[1] ? (t = {
            notation: "engineering"
          }, e = e.slice(2)) : "E" === e[0] && (t = {
            notation: "scientific"
          }, e = e.slice(1)), t) {
            var n = e.slice(0, 2);
            if ("+!" === n ? (t.signDisplay = "always", e = e.slice(2)) : "+?" === n && (t.signDisplay = "exceptZero", e = e.slice(2)), !O.test(e)) throw new Error("Malformed concise eng/scientific notation");
            t.minimumIntegerDigits = e.length;
          }
          return t;
        }
        function R(e) {
          var t = F(e);
          return t || {};
        }
        function j(e) {
          for (var t = {}, n = 0, o = e; n < o.length; n++) {
            var i = o[n];
            switch (i.stem) {
              case "percent":
              case "%":
                t.style = "percent";
                continue;
              case "%x100":
                t.style = "percent", t.scale = 100;
                continue;
              case "currency":
                t.style = "currency", t.currency = i.options[0];
                continue;
              case "group-off":
              case ",_":
                t.useGrouping = !1;
                continue;
              case "precision-integer":
              case ".":
                t.maximumFractionDigits = 0;
                continue;
              case "measure-unit":
              case "unit":
                t.style = "unit", t.unit = i.options[0].replace(/^(.*?)-/, "");
                continue;
              case "compact-short":
              case "K":
                t.notation = "compact", t.compactDisplay = "short";
                continue;
              case "compact-long":
              case "KK":
                t.notation = "compact", t.compactDisplay = "long";
                continue;
              case "scientific":
                t = (0, r.pi)((0, r.pi)((0, r.pi)({}, t), {
                  notation: "scientific"
                }), i.options.reduce(function (e, t) {
                  return (0, r.pi)((0, r.pi)({}, e), R(t));
                }, {}));
                continue;
              case "engineering":
                t = (0, r.pi)((0, r.pi)((0, r.pi)({}, t), {
                  notation: "engineering"
                }), i.options.reduce(function (e, t) {
                  return (0, r.pi)((0, r.pi)({}, e), R(t));
                }, {}));
                continue;
              case "notation-simple":
                t.notation = "standard";
                continue;
              case "unit-width-narrow":
                t.currencyDisplay = "narrowSymbol", t.unitDisplay = "narrow";
                continue;
              case "unit-width-short":
                t.currencyDisplay = "code", t.unitDisplay = "short";
                continue;
              case "unit-width-full-name":
                t.currencyDisplay = "name", t.unitDisplay = "long";
                continue;
              case "unit-width-iso-code":
                t.currencyDisplay = "symbol";
                continue;
              case "scale":
                t.scale = parseFloat(i.options[0]);
                continue;
              case "integer-width":
                if (i.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                i.options[0].replace(T, function (e, n, r, o, i, a) {
                  if (n) t.minimumIntegerDigits = r.length;else {
                    if (o && i) throw new Error("We currently do not support maximum integer digits");
                    if (a) throw new Error("We currently do not support exact integer digits");
                  }
                  return "";
                });
                continue;
            }
            if (O.test(i.stem)) t.minimumIntegerDigits = i.stem.length;else if (A.test(i.stem)) {
              if (i.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
              i.stem.replace(A, function (e, n, r, o, i, a) {
                return "*" === r ? t.minimumFractionDigits = n.length : o && "#" === o[0] ? t.maximumFractionDigits = o.length : i && a ? (t.minimumFractionDigits = i.length, t.maximumFractionDigits = i.length + a.length) : (t.minimumFractionDigits = n.length, t.maximumFractionDigits = n.length), "";
              }), i.options.length && (t = (0, r.pi)((0, r.pi)({}, t), I(i.options[0])));
            } else if (z.test(i.stem)) t = (0, r.pi)((0, r.pi)({}, t), I(i.stem));else {
              var a = F(i.stem);
              a && (t = (0, r.pi)((0, r.pi)({}, t), a));
              var s = M(i.stem);
              s && (t = (0, r.pi)((0, r.pi)({}, t), s));
            }
          }
          return t;
        }
        var B = new RegExp("^" + S.source + "*"),
          N = new RegExp(S.source + "*$");
        function L(e, t) {
          return {
            start: e,
            end: t
          };
        }
        var V = !!String.prototype.startsWith,
          K = !!String.fromCodePoint,
          q = !!Object.fromEntries,
          H = !!String.prototype.codePointAt,
          U = !!String.prototype.trimStart,
          Z = !!String.prototype.trimEnd,
          $ = !!Number.isSafeInteger ? Number.isSafeInteger : function (e) {
            return "number" == typeof e && isFinite(e) && Math.floor(e) === e && Math.abs(e) <= 9007199254740991;
          },
          G = !0;
        try {
          G = "a" === (null === (k = ne("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu").exec("a")) || void 0 === k ? void 0 : k[0]);
        } catch (e) {
          G = !1;
        }
        var W,
          Y = V ? function (e, t, n) {
            return e.startsWith(t, n);
          } : function (e, t, n) {
            return e.slice(n, n + t.length) === t;
          },
          X = K ? String.fromCodePoint : function () {
            for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
            for (var n, r = "", o = e.length, i = 0; o > i;) {
              if ((n = e[i++]) > 1114111) throw RangeError(n + " is not a valid code point");
              r += n < 65536 ? String.fromCharCode(n) : String.fromCharCode(55296 + ((n -= 65536) >> 10), n % 1024 + 56320);
            }
            return r;
          },
          Q = q ? Object.fromEntries : function (e) {
            for (var t = {}, n = 0, r = e; n < r.length; n++) {
              var o = r[n],
                i = o[0],
                a = o[1];
              t[i] = a;
            }
            return t;
          },
          J = H ? function (e, t) {
            return e.codePointAt(t);
          } : function (e, t) {
            var n = e.length;
            if (!(t < 0 || t >= n)) {
              var r,
                o = e.charCodeAt(t);
              return o < 55296 || o > 56319 || t + 1 === n || (r = e.charCodeAt(t + 1)) < 56320 || r > 57343 ? o : r - 56320 + (o - 55296 << 10) + 65536;
            }
          },
          ee = U ? function (e) {
            return e.trimStart();
          } : function (e) {
            return e.replace(B, "");
          },
          te = Z ? function (e) {
            return e.trimEnd();
          } : function (e) {
            return e.replace(N, "");
          };
        function ne(e, t) {
          return new RegExp(e, t);
        }
        if (G) {
          var re = ne("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
          W = function (e, t) {
            var n;
            return re.lastIndex = t, null !== (n = re.exec(e)[1]) && void 0 !== n ? n : "";
          };
        } else W = function (e, t) {
          for (var n = [];;) {
            var r = J(e, t);
            if (void 0 === r || ae(r) || se(r)) break;
            n.push(r), t += r >= 65536 ? 2 : 1;
          }
          return X.apply(void 0, n);
        };
        var oe = function () {
          function e(e, t) {
            void 0 === t && (t = {}), this.message = e, this.position = {
              offset: 0,
              line: 1,
              column: 1
            }, this.ignoreTag = !!t.ignoreTag, this.requiresOtherClause = !!t.requiresOtherClause, this.shouldParseSkeletons = !!t.shouldParseSkeletons;
          }
          return e.prototype.parse = function () {
            if (0 !== this.offset()) throw Error("parser can only be used once");
            return this.parseMessage(0, "", !1);
          }, e.prototype.parseMessage = function (e, t, n) {
            for (var r = []; !this.isEOF();) {
              var o = this.char();
              if (123 === o) {
                if ((i = this.parseArgument(e, n)).err) return i;
                r.push(i.val);
              } else {
                if (125 === o && e > 0) break;
                if (35 !== o || "plural" !== t && "selectordinal" !== t) {
                  if (60 === o && !this.ignoreTag && 47 === this.peek()) {
                    if (n) break;
                    return this.error(c.UNMATCHED_CLOSING_TAG, L(this.clonePosition(), this.clonePosition()));
                  }
                  if (60 === o && !this.ignoreTag && ie(this.peek() || 0)) {
                    if ((i = this.parseTag(e, t)).err) return i;
                    r.push(i.val);
                  } else {
                    var i;
                    if ((i = this.parseLiteral(e, t)).err) return i;
                    r.push(i.val);
                  }
                } else {
                  var a = this.clonePosition();
                  this.bump(), r.push({
                    type: d.pound,
                    location: L(a, this.clonePosition())
                  });
                }
              }
            }
            return {
              val: r,
              err: null
            };
          }, e.prototype.parseTag = function (e, t) {
            var n = this.clonePosition();
            this.bump();
            var r = this.parseTagName();
            if (this.bumpSpace(), this.bumpIf("/>")) return {
              val: {
                type: d.literal,
                value: "<" + r + "/>",
                location: L(n, this.clonePosition())
              },
              err: null
            };
            if (this.bumpIf(">")) {
              var o = this.parseMessage(e + 1, t, !0);
              if (o.err) return o;
              var i = o.val,
                a = this.clonePosition();
              if (this.bumpIf("</")) {
                if (this.isEOF() || !ie(this.char())) return this.error(c.INVALID_TAG, L(a, this.clonePosition()));
                var s = this.clonePosition();
                return r !== this.parseTagName() ? this.error(c.UNMATCHED_CLOSING_TAG, L(s, this.clonePosition())) : (this.bumpSpace(), this.bumpIf(">") ? {
                  val: {
                    type: d.tag,
                    value: r,
                    children: i,
                    location: L(n, this.clonePosition())
                  },
                  err: null
                } : this.error(c.INVALID_TAG, L(a, this.clonePosition())));
              }
              return this.error(c.UNCLOSED_TAG, L(n, this.clonePosition()));
            }
            return this.error(c.INVALID_TAG, L(n, this.clonePosition()));
          }, e.prototype.parseTagName = function () {
            var e,
              t = this.offset();
            for (this.bump(); !this.isEOF() && (45 === (e = this.char()) || 46 === e || e >= 48 && e <= 57 || 95 === e || e >= 97 && e <= 122 || e >= 65 && e <= 90 || 183 == e || e >= 192 && e <= 214 || e >= 216 && e <= 246 || e >= 248 && e <= 893 || e >= 895 && e <= 8191 || e >= 8204 && e <= 8205 || e >= 8255 && e <= 8256 || e >= 8304 && e <= 8591 || e >= 11264 && e <= 12271 || e >= 12289 && e <= 55295 || e >= 63744 && e <= 64975 || e >= 65008 && e <= 65533 || e >= 65536 && e <= 983039);) this.bump();
            return this.message.slice(t, this.offset());
          }, e.prototype.parseLiteral = function (e, t) {
            for (var n = this.clonePosition(), r = "";;) {
              var o = this.tryParseQuote(t);
              if (o) r += o;else {
                var i = this.tryParseUnquoted(e, t);
                if (i) r += i;else {
                  var a = this.tryParseLeftAngleBracket();
                  if (!a) break;
                  r += a;
                }
              }
            }
            var s = L(n, this.clonePosition());
            return {
              val: {
                type: d.literal,
                value: r,
                location: s
              },
              err: null
            };
          }, e.prototype.tryParseLeftAngleBracket = function () {
            return this.isEOF() || 60 !== this.char() || !this.ignoreTag && (ie(e = this.peek() || 0) || 47 === e) ? null : (this.bump(), "<");
            var e;
          }, e.prototype.tryParseQuote = function (e) {
            if (this.isEOF() || 39 !== this.char()) return null;
            switch (this.peek()) {
              case 39:
                return this.bump(), this.bump(), "'";
              case 123:
              case 60:
              case 62:
              case 125:
                break;
              case 35:
                if ("plural" === e || "selectordinal" === e) break;
                return null;
              default:
                return null;
            }
            this.bump();
            var t = [this.char()];
            for (this.bump(); !this.isEOF();) {
              var n = this.char();
              if (39 === n) {
                if (39 !== this.peek()) {
                  this.bump();
                  break;
                }
                t.push(39), this.bump();
              } else t.push(n);
              this.bump();
            }
            return X.apply(void 0, t);
          }, e.prototype.tryParseUnquoted = function (e, t) {
            if (this.isEOF()) return null;
            var n = this.char();
            return 60 === n || 123 === n || 35 === n && ("plural" === t || "selectordinal" === t) || 125 === n && e > 0 ? null : (this.bump(), X(n));
          }, e.prototype.parseArgument = function (e, t) {
            var n = this.clonePosition();
            if (this.bump(), this.bumpSpace(), this.isEOF()) return this.error(c.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition()));
            if (125 === this.char()) return this.bump(), this.error(c.EMPTY_ARGUMENT, L(n, this.clonePosition()));
            var r = this.parseIdentifierIfPossible().value;
            if (!r) return this.error(c.MALFORMED_ARGUMENT, L(n, this.clonePosition()));
            if (this.bumpSpace(), this.isEOF()) return this.error(c.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition()));
            switch (this.char()) {
              case 125:
                return this.bump(), {
                  val: {
                    type: d.argument,
                    value: r,
                    location: L(n, this.clonePosition())
                  },
                  err: null
                };
              case 44:
                return this.bump(), this.bumpSpace(), this.isEOF() ? this.error(c.EXPECT_ARGUMENT_CLOSING_BRACE, L(n, this.clonePosition())) : this.parseArgumentOptions(e, t, r, n);
              default:
                return this.error(c.MALFORMED_ARGUMENT, L(n, this.clonePosition()));
            }
          }, e.prototype.parseIdentifierIfPossible = function () {
            var e = this.clonePosition(),
              t = this.offset(),
              n = W(this.message, t),
              r = t + n.length;
            return this.bumpTo(r), {
              value: n,
              location: L(e, this.clonePosition())
            };
          }, e.prototype.parseArgumentOptions = function (e, t, n, o) {
            var i,
              a = this.clonePosition(),
              s = this.parseIdentifierIfPossible().value,
              l = this.clonePosition();
            switch (s) {
              case "":
                return this.error(c.EXPECT_ARGUMENT_TYPE, L(a, l));
              case "number":
              case "date":
              case "time":
                this.bumpSpace();
                var u = null;
                if (this.bumpIf(",")) {
                  this.bumpSpace();
                  var h = this.clonePosition();
                  if ((w = this.parseSimpleArgStyleIfPossible()).err) return w;
                  if (0 === (g = te(w.val)).length) return this.error(c.EXPECT_ARGUMENT_STYLE, L(this.clonePosition(), this.clonePosition()));
                  u = {
                    style: g,
                    styleLocation: L(h, this.clonePosition())
                  };
                }
                if ((x = this.tryParseArgumentClose(o)).err) return x;
                var f = L(o, this.clonePosition());
                if (u && Y(null == u ? void 0 : u.style, "::", 0)) {
                  var m = ee(u.style.slice(2));
                  if ("number" === s) return (w = this.parseNumberSkeletonFromString(m, u.styleLocation)).err ? w : {
                    val: {
                      type: d.number,
                      value: n,
                      location: f,
                      style: w.val
                    },
                    err: null
                  };
                  if (0 === m.length) return this.error(c.EXPECT_DATE_TIME_SKELETON, f);
                  var g = {
                    type: p.dateTime,
                    pattern: m,
                    location: u.styleLocation,
                    parsedOptions: this.shouldParseSkeletons ? _(m) : {}
                  };
                  return {
                    val: {
                      type: "date" === s ? d.date : d.time,
                      value: n,
                      location: f,
                      style: g
                    },
                    err: null
                  };
                }
                return {
                  val: {
                    type: "number" === s ? d.number : "date" === s ? d.date : d.time,
                    value: n,
                    location: f,
                    style: null !== (i = null == u ? void 0 : u.style) && void 0 !== i ? i : null
                  },
                  err: null
                };
              case "plural":
              case "selectordinal":
              case "select":
                var v = this.clonePosition();
                if (this.bumpSpace(), !this.bumpIf(",")) return this.error(c.EXPECT_SELECT_ARGUMENT_OPTIONS, L(v, (0, r.pi)({}, v)));
                this.bumpSpace();
                var y = this.parseIdentifierIfPossible(),
                  b = 0;
                if ("select" !== s && "offset" === y.value) {
                  if (!this.bumpIf(":")) return this.error(c.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, L(this.clonePosition(), this.clonePosition()));
                  var w;
                  if (this.bumpSpace(), (w = this.tryParseDecimalInteger(c.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, c.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE)).err) return w;
                  this.bumpSpace(), y = this.parseIdentifierIfPossible(), b = w.val;
                }
                var x,
                  D = this.tryParsePluralOrSelectOptions(e, s, t, y);
                if (D.err) return D;
                if ((x = this.tryParseArgumentClose(o)).err) return x;
                var C = L(o, this.clonePosition());
                return "select" === s ? {
                  val: {
                    type: d.select,
                    value: n,
                    options: Q(D.val),
                    location: C
                  },
                  err: null
                } : {
                  val: {
                    type: d.plural,
                    value: n,
                    options: Q(D.val),
                    offset: b,
                    pluralType: "plural" === s ? "cardinal" : "ordinal",
                    location: C
                  },
                  err: null
                };
              default:
                return this.error(c.INVALID_ARGUMENT_TYPE, L(a, l));
            }
          }, e.prototype.tryParseArgumentClose = function (e) {
            return this.isEOF() || 125 !== this.char() ? this.error(c.EXPECT_ARGUMENT_CLOSING_BRACE, L(e, this.clonePosition())) : (this.bump(), {
              val: !0,
              err: null
            });
          }, e.prototype.parseSimpleArgStyleIfPossible = function () {
            for (var e = 0, t = this.clonePosition(); !this.isEOF();) {
              switch (this.char()) {
                case 39:
                  this.bump();
                  var n = this.clonePosition();
                  if (!this.bumpUntil("'")) return this.error(c.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, L(n, this.clonePosition()));
                  this.bump();
                  break;
                case 123:
                  e += 1, this.bump();
                  break;
                case 125:
                  if (!(e > 0)) return {
                    val: this.message.slice(t.offset, this.offset()),
                    err: null
                  };
                  e -= 1;
                  break;
                default:
                  this.bump();
              }
            }
            return {
              val: this.message.slice(t.offset, this.offset()),
              err: null
            };
          }, e.prototype.parseNumberSkeletonFromString = function (e, t) {
            var n = [];
            try {
              n = function (e) {
                if (0 === e.length) throw new Error("Number skeleton cannot be empty");
                for (var t = [], n = 0, r = e.split(P).filter(function (e) {
                    return e.length > 0;
                  }); n < r.length; n++) {
                  var o = r[n].split("/");
                  if (0 === o.length) throw new Error("Invalid number skeleton");
                  for (var i = o[0], a = o.slice(1), s = 0, l = a; s < l.length; s++) if (0 === l[s].length) throw new Error("Invalid number skeleton");
                  t.push({
                    stem: i,
                    options: a
                  });
                }
                return t;
              }(e);
            } catch (e) {
              return this.error(c.INVALID_NUMBER_SKELETON, t);
            }
            return {
              val: {
                type: p.number,
                tokens: n,
                location: t,
                parsedOptions: this.shouldParseSkeletons ? j(n) : {}
              },
              err: null
            };
          }, e.prototype.tryParsePluralOrSelectOptions = function (e, t, n, r) {
            for (var o, i = !1, a = [], s = new Set(), l = r.value, u = r.location;;) {
              if (0 === l.length) {
                var d = this.clonePosition();
                if ("select" === t || !this.bumpIf("=")) break;
                var p = this.tryParseDecimalInteger(c.EXPECT_PLURAL_ARGUMENT_SELECTOR, c.INVALID_PLURAL_ARGUMENT_SELECTOR);
                if (p.err) return p;
                u = L(d, this.clonePosition()), l = this.message.slice(d.offset, this.offset());
              }
              if (s.has(l)) return this.error("select" === t ? c.DUPLICATE_SELECT_ARGUMENT_SELECTOR : c.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, u);
              "other" === l && (i = !0), this.bumpSpace();
              var h = this.clonePosition();
              if (!this.bumpIf("{")) return this.error("select" === t ? c.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : c.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, L(this.clonePosition(), this.clonePosition()));
              var f = this.parseMessage(e + 1, t, n);
              if (f.err) return f;
              var m = this.tryParseArgumentClose(h);
              if (m.err) return m;
              a.push([l, {
                value: f.val,
                location: L(h, this.clonePosition())
              }]), s.add(l), this.bumpSpace(), l = (o = this.parseIdentifierIfPossible()).value, u = o.location;
            }
            return 0 === a.length ? this.error("select" === t ? c.EXPECT_SELECT_ARGUMENT_SELECTOR : c.EXPECT_PLURAL_ARGUMENT_SELECTOR, L(this.clonePosition(), this.clonePosition())) : this.requiresOtherClause && !i ? this.error(c.MISSING_OTHER_CLAUSE, L(this.clonePosition(), this.clonePosition())) : {
              val: a,
              err: null
            };
          }, e.prototype.tryParseDecimalInteger = function (e, t) {
            var n = 1,
              r = this.clonePosition();
            this.bumpIf("+") || this.bumpIf("-") && (n = -1);
            for (var o = !1, i = 0; !this.isEOF();) {
              var a = this.char();
              if (!(a >= 48 && a <= 57)) break;
              o = !0, i = 10 * i + (a - 48), this.bump();
            }
            var s = L(r, this.clonePosition());
            return o ? $(i *= n) ? {
              val: i,
              err: null
            } : this.error(t, s) : this.error(e, s);
          }, e.prototype.offset = function () {
            return this.position.offset;
          }, e.prototype.isEOF = function () {
            return this.offset() === this.message.length;
          }, e.prototype.clonePosition = function () {
            return {
              offset: this.position.offset,
              line: this.position.line,
              column: this.position.column
            };
          }, e.prototype.char = function () {
            var e = this.position.offset;
            if (e >= this.message.length) throw Error("out of bound");
            var t = J(this.message, e);
            if (void 0 === t) throw Error("Offset " + e + " is at invalid UTF-16 code unit boundary");
            return t;
          }, e.prototype.error = function (e, t) {
            return {
              val: null,
              err: {
                kind: e,
                message: this.message,
                location: t
              }
            };
          }, e.prototype.bump = function () {
            if (!this.isEOF()) {
              var e = this.char();
              10 === e ? (this.position.line += 1, this.position.column = 1, this.position.offset += 1) : (this.position.column += 1, this.position.offset += e < 65536 ? 1 : 2);
            }
          }, e.prototype.bumpIf = function (e) {
            if (Y(this.message, e, this.offset())) {
              for (var t = 0; t < e.length; t++) this.bump();
              return !0;
            }
            return !1;
          }, e.prototype.bumpUntil = function (e) {
            var t = this.offset(),
              n = this.message.indexOf(e, t);
            return n >= 0 ? (this.bumpTo(n), !0) : (this.bumpTo(this.message.length), !1);
          }, e.prototype.bumpTo = function (e) {
            if (this.offset() > e) throw Error("targetOffset " + e + " must be greater than or equal to the current offset " + this.offset());
            for (e = Math.min(e, this.message.length);;) {
              var t = this.offset();
              if (t === e) break;
              if (t > e) throw Error("targetOffset " + e + " is at invalid UTF-16 code unit boundary");
              if (this.bump(), this.isEOF()) break;
            }
          }, e.prototype.bumpSpace = function () {
            for (; !this.isEOF() && ae(this.char());) this.bump();
          }, e.prototype.peek = function () {
            if (this.isEOF()) return null;
            var e = this.char(),
              t = this.offset(),
              n = this.message.charCodeAt(t + (e >= 65536 ? 2 : 1));
            return null != n ? n : null;
          }, e;
        }();
        function ie(e) {
          return e >= 97 && e <= 122 || e >= 65 && e <= 90;
        }
        function ae(e) {
          return e >= 9 && e <= 13 || 32 === e || 133 === e || e >= 8206 && e <= 8207 || 8232 === e || 8233 === e;
        }
        function se(e) {
          return e >= 33 && e <= 35 || 36 === e || e >= 37 && e <= 39 || 40 === e || 41 === e || 42 === e || 43 === e || 44 === e || 45 === e || e >= 46 && e <= 47 || e >= 58 && e <= 59 || e >= 60 && e <= 62 || e >= 63 && e <= 64 || 91 === e || 92 === e || 93 === e || 94 === e || 96 === e || 123 === e || 124 === e || 125 === e || 126 === e || 161 === e || e >= 162 && e <= 165 || 166 === e || 167 === e || 169 === e || 171 === e || 172 === e || 174 === e || 176 === e || 177 === e || 182 === e || 187 === e || 191 === e || 215 === e || 247 === e || e >= 8208 && e <= 8213 || e >= 8214 && e <= 8215 || 8216 === e || 8217 === e || 8218 === e || e >= 8219 && e <= 8220 || 8221 === e || 8222 === e || 8223 === e || e >= 8224 && e <= 8231 || e >= 8240 && e <= 8248 || 8249 === e || 8250 === e || e >= 8251 && e <= 8254 || e >= 8257 && e <= 8259 || 8260 === e || 8261 === e || 8262 === e || e >= 8263 && e <= 8273 || 8274 === e || 8275 === e || e >= 8277 && e <= 8286 || e >= 8592 && e <= 8596 || e >= 8597 && e <= 8601 || e >= 8602 && e <= 8603 || e >= 8604 && e <= 8607 || 8608 === e || e >= 8609 && e <= 8610 || 8611 === e || e >= 8612 && e <= 8613 || 8614 === e || e >= 8615 && e <= 8621 || 8622 === e || e >= 8623 && e <= 8653 || e >= 8654 && e <= 8655 || e >= 8656 && e <= 8657 || 8658 === e || 8659 === e || 8660 === e || e >= 8661 && e <= 8691 || e >= 8692 && e <= 8959 || e >= 8960 && e <= 8967 || 8968 === e || 8969 === e || 8970 === e || 8971 === e || e >= 8972 && e <= 8991 || e >= 8992 && e <= 8993 || e >= 8994 && e <= 9e3 || 9001 === e || 9002 === e || e >= 9003 && e <= 9083 || 9084 === e || e >= 9085 && e <= 9114 || e >= 9115 && e <= 9139 || e >= 9140 && e <= 9179 || e >= 9180 && e <= 9185 || e >= 9186 && e <= 9254 || e >= 9255 && e <= 9279 || e >= 9280 && e <= 9290 || e >= 9291 && e <= 9311 || e >= 9472 && e <= 9654 || 9655 === e || e >= 9656 && e <= 9664 || 9665 === e || e >= 9666 && e <= 9719 || e >= 9720 && e <= 9727 || e >= 9728 && e <= 9838 || 9839 === e || e >= 9840 && e <= 10087 || 10088 === e || 10089 === e || 10090 === e || 10091 === e || 10092 === e || 10093 === e || 10094 === e || 10095 === e || 10096 === e || 10097 === e || 10098 === e || 10099 === e || 10100 === e || 10101 === e || e >= 10132 && e <= 10175 || e >= 10176 && e <= 10180 || 10181 === e || 10182 === e || e >= 10183 && e <= 10213 || 10214 === e || 10215 === e || 10216 === e || 10217 === e || 10218 === e || 10219 === e || 10220 === e || 10221 === e || 10222 === e || 10223 === e || e >= 10224 && e <= 10239 || e >= 10240 && e <= 10495 || e >= 10496 && e <= 10626 || 10627 === e || 10628 === e || 10629 === e || 10630 === e || 10631 === e || 10632 === e || 10633 === e || 10634 === e || 10635 === e || 10636 === e || 10637 === e || 10638 === e || 10639 === e || 10640 === e || 10641 === e || 10642 === e || 10643 === e || 10644 === e || 10645 === e || 10646 === e || 10647 === e || 10648 === e || e >= 10649 && e <= 10711 || 10712 === e || 10713 === e || 10714 === e || 10715 === e || e >= 10716 && e <= 10747 || 10748 === e || 10749 === e || e >= 10750 && e <= 11007 || e >= 11008 && e <= 11055 || e >= 11056 && e <= 11076 || e >= 11077 && e <= 11078 || e >= 11079 && e <= 11084 || e >= 11085 && e <= 11123 || e >= 11124 && e <= 11125 || e >= 11126 && e <= 11157 || 11158 === e || e >= 11159 && e <= 11263 || e >= 11776 && e <= 11777 || 11778 === e || 11779 === e || 11780 === e || 11781 === e || e >= 11782 && e <= 11784 || 11785 === e || 11786 === e || 11787 === e || 11788 === e || 11789 === e || e >= 11790 && e <= 11798 || 11799 === e || e >= 11800 && e <= 11801 || 11802 === e || 11803 === e || 11804 === e || 11805 === e || e >= 11806 && e <= 11807 || 11808 === e || 11809 === e || 11810 === e || 11811 === e || 11812 === e || 11813 === e || 11814 === e || 11815 === e || 11816 === e || 11817 === e || e >= 11818 && e <= 11822 || 11823 === e || e >= 11824 && e <= 11833 || e >= 11834 && e <= 11835 || e >= 11836 && e <= 11839 || 11840 === e || 11841 === e || 11842 === e || e >= 11843 && e <= 11855 || e >= 11856 && e <= 11857 || 11858 === e || e >= 11859 && e <= 11903 || e >= 12289 && e <= 12291 || 12296 === e || 12297 === e || 12298 === e || 12299 === e || 12300 === e || 12301 === e || 12302 === e || 12303 === e || 12304 === e || 12305 === e || e >= 12306 && e <= 12307 || 12308 === e || 12309 === e || 12310 === e || 12311 === e || 12312 === e || 12313 === e || 12314 === e || 12315 === e || 12316 === e || 12317 === e || e >= 12318 && e <= 12319 || 12320 === e || 12336 === e || 64830 === e || 64831 === e || e >= 65093 && e <= 65094;
        }
        function le(e) {
          e.forEach(function (e) {
            if (delete e.location, y(e) || b(e)) for (var t in e.options) delete e.options[t].location, le(e.options[t].value);else m(e) && D(e.style) || (g(e) || v(e)) && C(e.style) ? delete e.style.location : x(e) && le(e.children);
          });
        }
        function ue(e, t) {
          void 0 === t && (t = {}), t = (0, r.pi)({
            shouldParseSkeletons: !0,
            requiresOtherClause: !0
          }, t);
          var n = new oe(e, t).parse();
          if (n.err) {
            var o = SyntaxError(c[n.err.kind]);
            throw o.location = n.err.location, o.originalMessage = n.err.message, o;
          }
          return (null == t ? void 0 : t.captureLocation) || le(n.val), n.val;
        }
        function ce(e, t) {
          var n = t && t.cache ? t.cache : ye,
            r = t && t.serializer ? t.serializer : me;
          return (t && t.strategy ? t.strategy : fe)(e, {
            cache: n,
            serializer: r
          });
        }
        function de(e, t, n, r) {
          var o,
            i = null == (o = r) || "number" == typeof o || "boolean" == typeof o ? r : n(r),
            a = t.get(i);
          return void 0 === a && (a = e.call(this, r), t.set(i, a)), a;
        }
        function pe(e, t, n) {
          var r = Array.prototype.slice.call(arguments, 3),
            o = n(r),
            i = t.get(o);
          return void 0 === i && (i = e.apply(this, r), t.set(o, i)), i;
        }
        function he(e, t, n, r, o) {
          return n.bind(t, e, r, o);
        }
        function fe(e, t) {
          return he(e, this, 1 === e.length ? de : pe, t.cache.create(), t.serializer);
        }
        var me = function () {
          return JSON.stringify(arguments);
        };
        function ge() {
          this.cache = Object.create(null);
        }
        ge.prototype.has = function (e) {
          return e in this.cache;
        }, ge.prototype.get = function (e) {
          return this.cache[e];
        }, ge.prototype.set = function (e, t) {
          this.cache[e] = t;
        };
        var ve,
          ye = {
            create: function () {
              return new ge();
            }
          },
          be = {
            variadic: function (e, t) {
              return he(e, this, pe, t.cache.create(), t.serializer);
            },
            monadic: function (e, t) {
              return he(e, this, de, t.cache.create(), t.serializer);
            }
          };
        !function (e) {
          e.MISSING_VALUE = "MISSING_VALUE", e.INVALID_VALUE = "INVALID_VALUE", e.MISSING_INTL_API = "MISSING_INTL_API";
        }(ve || (ve = {}));
        var we,
          xe = function (e) {
            function t(t, n, r) {
              var o = e.call(this, t) || this;
              return o.code = n, o.originalMessage = r, o;
            }
            return (0, r.ZT)(t, e), t.prototype.toString = function () {
              return "[formatjs Error: " + this.code + "] " + this.message;
            }, t;
          }(Error),
          De = function (e) {
            function t(t, n, r, o) {
              return e.call(this, 'Invalid values for "' + t + '": "' + n + '". Options are "' + Object.keys(r).join('", "') + '"', ve.INVALID_VALUE, o) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(xe),
          Ce = function (e) {
            function t(t, n, r) {
              return e.call(this, 'Value for "' + t + '" must be of type ' + n, ve.INVALID_VALUE, r) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(xe),
          Se = function (e) {
            function t(t, n) {
              return e.call(this, 'The intl string context variable "' + t + '" was not provided to the string "' + n + '"', ve.MISSING_VALUE, n) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(xe);
        function Ee(e) {
          return "function" == typeof e;
        }
        function _e(e, t, n, r, o, i, a) {
          if (1 === e.length && h(e[0])) return [{
            type: we.literal,
            value: e[0].value
          }];
          for (var s = [], l = 0, u = e; l < u.length; l++) {
            var c = u[l];
            if (h(c)) s.push({
              type: we.literal,
              value: c.value
            });else if (w(c)) "number" == typeof i && s.push({
              type: we.literal,
              value: n.getNumberFormat(t).format(i)
            });else {
              var d = c.value;
              if (!o || !(d in o)) throw new Se(d, a);
              var p = o[d];
              if (f(c)) p && "string" != typeof p && "number" != typeof p || (p = "string" == typeof p || "number" == typeof p ? String(p) : ""), s.push({
                type: "string" == typeof p ? we.literal : we.object,
                value: p
              });else if (g(c)) {
                var S = "string" == typeof c.style ? r.date[c.style] : C(c.style) ? c.style.parsedOptions : void 0;
                s.push({
                  type: we.literal,
                  value: n.getDateTimeFormat(t, S).format(p)
                });
              } else if (v(c)) {
                S = "string" == typeof c.style ? r.time[c.style] : C(c.style) ? c.style.parsedOptions : void 0;
                s.push({
                  type: we.literal,
                  value: n.getDateTimeFormat(t, S).format(p)
                });
              } else if (m(c)) {
                (S = "string" == typeof c.style ? r.number[c.style] : D(c.style) ? c.style.parsedOptions : void 0) && S.scale && (p *= S.scale || 1), s.push({
                  type: we.literal,
                  value: n.getNumberFormat(t, S).format(p)
                });
              } else {
                if (x(c)) {
                  var E = c.children,
                    _ = c.value,
                    P = o[_];
                  if (!Ee(P)) throw new Ce(_, "function", a);
                  var k = P(_e(E, t, n, r, o, i).map(function (e) {
                    return e.value;
                  }));
                  Array.isArray(k) || (k = [k]), s.push.apply(s, k.map(function (e) {
                    return {
                      type: "string" == typeof e ? we.literal : we.object,
                      value: e
                    };
                  }));
                }
                if (y(c)) {
                  if (!(A = c.options[p] || c.options.other)) throw new De(c.value, p, Object.keys(c.options), a);
                  s.push.apply(s, _e(A.value, t, n, r, o));
                } else if (b(c)) {
                  var A;
                  if (!(A = c.options["=" + p])) {
                    if (!Intl.PluralRules) throw new xe('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', ve.MISSING_INTL_API, a);
                    var z = n.getPluralRules(t, {
                      type: c.pluralType
                    }).select(p - (c.offset || 0));
                    A = c.options[z] || c.options.other;
                  }
                  if (!A) throw new De(c.value, p, Object.keys(c.options), a);
                  s.push.apply(s, _e(A.value, t, n, r, o, p - (c.offset || 0)));
                } else ;
              }
            }
          }
          return function (e) {
            return e.length < 2 ? e : e.reduce(function (e, t) {
              var n = e[e.length - 1];
              return n && n.type === we.literal && t.type === we.literal ? n.value += t.value : e.push(t), e;
            }, []);
          }(s);
        }
        function Pe(e, t) {
          return t ? Object.keys(e).reduce(function (n, o) {
            var i, a;
            return n[o] = (i = e[o], (a = t[o]) ? (0, r.pi)((0, r.pi)((0, r.pi)({}, i || {}), a || {}), Object.keys(i).reduce(function (e, t) {
              return e[t] = (0, r.pi)((0, r.pi)({}, i[t]), a[t] || {}), e;
            }, {})) : i), n;
          }, (0, r.pi)({}, e)) : e;
        }
        function ke(e) {
          return {
            create: function () {
              return {
                has: function (t) {
                  return t in e;
                },
                get: function (t) {
                  return e[t];
                },
                set: function (t, n) {
                  e[t] = n;
                }
              };
            }
          };
        }
        !function (e) {
          e[e.literal = 0] = "literal", e[e.object = 1] = "object";
        }(we || (we = {}));
        var Ae = function () {
          function e(t, n, o, i) {
            var a,
              s = this;
            if (void 0 === n && (n = e.defaultLocale), this.formatterCache = {
              number: {},
              dateTime: {},
              pluralRules: {}
            }, this.format = function (e) {
              var t = s.formatToParts(e);
              if (1 === t.length) return t[0].value;
              var n = t.reduce(function (e, t) {
                return e.length && t.type === we.literal && "string" == typeof e[e.length - 1] ? e[e.length - 1] += t.value : e.push(t.value), e;
              }, []);
              return n.length <= 1 ? n[0] || "" : n;
            }, this.formatToParts = function (e) {
              return _e(s.ast, s.locales, s.formatters, s.formats, e, void 0, s.message);
            }, this.resolvedOptions = function () {
              return {
                locale: Intl.NumberFormat.supportedLocalesOf(s.locales)[0]
              };
            }, this.getAst = function () {
              return s.ast;
            }, "string" == typeof t) {
              if (this.message = t, !e.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
              this.ast = e.__parse(t, {
                ignoreTag: null == i ? void 0 : i.ignoreTag
              });
            } else this.ast = t;
            if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
            this.formats = Pe(e.formats, o), this.locales = n, this.formatters = i && i.formatters || (void 0 === (a = this.formatterCache) && (a = {
              number: {},
              dateTime: {},
              pluralRules: {}
            }), {
              getNumberFormat: ce(function () {
                for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                return new ((e = Intl.NumberFormat).bind.apply(e, (0, r.ev)([void 0], t)))();
              }, {
                cache: ke(a.number),
                strategy: be.variadic
              }),
              getDateTimeFormat: ce(function () {
                for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                return new ((e = Intl.DateTimeFormat).bind.apply(e, (0, r.ev)([void 0], t)))();
              }, {
                cache: ke(a.dateTime),
                strategy: be.variadic
              }),
              getPluralRules: ce(function () {
                for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                return new ((e = Intl.PluralRules).bind.apply(e, (0, r.ev)([void 0], t)))();
              }, {
                cache: ke(a.pluralRules),
                strategy: be.variadic
              })
            });
          }
          return Object.defineProperty(e, "defaultLocale", {
            get: function () {
              return e.memoizedDefaultLocale || (e.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale), e.memoizedDefaultLocale;
            },
            enumerable: !1,
            configurable: !0
          }), e.memoizedDefaultLocale = null, e.__parse = ue, e.formats = {
            number: {
              currency: {
                style: "currency"
              },
              percent: {
                style: "percent"
              }
            },
            date: {
              short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
              },
              medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
              },
              long: {
                month: "long",
                day: "numeric",
                year: "numeric"
              },
              full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
              }
            },
            time: {
              short: {
                hour: "numeric",
                minute: "numeric"
              },
              medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
              },
              long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
              },
              full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
              }
            }
          }, e;
        }();
        var ze;
        !function (e) {
          e.FORMAT_ERROR = "FORMAT_ERROR", e.UNSUPPORTED_FORMATTER = "UNSUPPORTED_FORMATTER", e.INVALID_CONFIG = "INVALID_CONFIG", e.MISSING_DATA = "MISSING_DATA", e.MISSING_TRANSLATION = "MISSING_TRANSLATION";
        }(ze || (ze = {}));
        var Te = function (e) {
            function t(n, r, o) {
              var i = e.call(this, "[@formatjs/intl Error " + n + "] " + r + " \n" + (o ? "\n" + o.message + "\n" + o.stack : "")) || this;
              return i.code = n, "function" == typeof Error.captureStackTrace && Error.captureStackTrace(i, t), i;
            }
            return (0, r.ZT)(t, e), t;
          }(Error),
          Oe = function (e) {
            function t(t, n) {
              return e.call(this, ze.UNSUPPORTED_FORMATTER, t, n) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(Te),
          Ie = function (e) {
            function t(t, n) {
              return e.call(this, ze.INVALID_CONFIG, t, n) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(Te),
          Fe = function (e) {
            function t(t, n) {
              return e.call(this, ze.MISSING_DATA, t, n) || this;
            }
            return (0, r.ZT)(t, e), t;
          }(Te),
          Me = function (e) {
            function t(t, n, r, o) {
              var i = e.call(this, ze.FORMAT_ERROR, t + " \nLocale: " + n + "\nMessageID: " + (null == r ? void 0 : r.id) + "\nDefault Message: " + (null == r ? void 0 : r.defaultMessage) + "\nDescription: " + (null == r ? void 0 : r.description) + " \n", o) || this;
              return i.descriptor = r, i;
            }
            return (0, r.ZT)(t, e), t;
          }(Te),
          Re = function (e) {
            function t(t, n) {
              var r = e.call(this, ze.MISSING_TRANSLATION, 'Missing message: "' + t.id + '" for locale "' + n + '", using ' + (t.defaultMessage ? "default message" : "id") + " as fallback.") || this;
              return r.descriptor = t, r;
            }
            return (0, r.ZT)(t, e), t;
          }(Te);
        function je(e, t, n) {
          return void 0 === n && (n = {}), t.reduce(function (t, r) {
            return r in e ? t[r] = e[r] : r in n && (t[r] = n[r]), t;
          }, {});
        }
        var Be = {
          formats: {},
          messages: {},
          timeZone: void 0,
          defaultLocale: "en",
          defaultFormats: {},
          onError: function (e) {
            0;
          }
        };
        function Ne() {
          return {
            dateTime: {},
            number: {},
            message: {},
            relativeTime: {},
            pluralRules: {},
            list: {},
            displayNames: {}
          };
        }
        function Le(e) {
          return {
            create: function () {
              return {
                has: function (t) {
                  return t in e;
                },
                get: function (t) {
                  return e[t];
                },
                set: function (t, n) {
                  e[t] = n;
                }
              };
            }
          };
        }
        function Ve(e, t, n, r) {
          var o,
            i = e && e[t];
          if (i && (o = i[n]), o) return o;
          r(new Oe("No " + t + " format named: " + n));
        }
        function Ke(e, t) {
          return Object.keys(e).reduce(function (n, o) {
            return n[o] = (0, r.pi)({
              timeZone: t
            }, e[o]), n;
          }, {});
        }
        function qe(e, t) {
          return Object.keys((0, r.pi)((0, r.pi)({}, e), t)).reduce(function (n, o) {
            return n[o] = (0, r.pi)((0, r.pi)({}, e[o] || {}), t[o] || {}), n;
          }, {});
        }
        function He(e, t) {
          if (!t) return e;
          var n = Ae.formats;
          return (0, r.pi)((0, r.pi)((0, r.pi)({}, n), e), {
            date: qe(Ke(n.date, t), Ke(e.date || {}, t)),
            time: qe(Ke(n.time, t), Ke(e.time || {}, t))
          });
        }
        function Ue(e, t, n, o, i) {
          var a = e.locale,
            l = e.formats,
            u = e.messages,
            c = e.defaultLocale,
            p = e.defaultFormats,
            h = e.onError,
            f = e.timeZone,
            m = e.defaultRichTextElements;
          void 0 === n && (n = {
            id: ""
          });
          var g = n.id,
            v = n.defaultMessage;
          s(!!g, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
          var y = String(g),
            b = u && Object.prototype.hasOwnProperty.call(u, y) && u[y];
          if (Array.isArray(b) && 1 === b.length && b[0].type === d.literal) return b[0].value;
          if (!o && b && "string" == typeof b && !m) return b.replace(/'\{(.*?)\}'/gi, "{$1}");
          if (o = (0, r.pi)((0, r.pi)({}, m), o || {}), l = He(l, f), p = He(p, f), !b) {
            if ((!v || a && a.toLowerCase() !== c.toLowerCase()) && h(new Re(n, a)), v) try {
              return t.getMessageFormat(v, c, p, i).format(o);
            } catch (e) {
              return h(new Me('Error formatting default message for: "' + y + '", rendering default message verbatim', a, n, e)), "string" == typeof v ? v : y;
            }
            return y;
          }
          try {
            return t.getMessageFormat(b, a, l, (0, r.pi)({
              formatters: t
            }, i || {})).format(o);
          } catch (e) {
            h(new Me('Error formatting message: "' + y + '", using ' + (v ? "default message" : "id") + " as fallback.", a, n, e));
          }
          if (v) try {
            return t.getMessageFormat(v, c, p, i).format(o);
          } catch (e) {
            h(new Me('Error formatting the default message for: "' + y + '", rendering message verbatim', a, n, e));
          }
          return "string" == typeof b ? b : "string" == typeof v ? v : y;
        }
        var Ze = ["localeMatcher", "formatMatcher", "timeZone", "hour12", "weekday", "era", "year", "month", "day", "hour", "minute", "second", "timeZoneName", "hourCycle", "dateStyle", "timeStyle", "calendar", "numberingSystem"];
        function $e(e, t, n, o) {
          var i = e.locale,
            a = e.formats,
            s = e.onError,
            l = e.timeZone;
          void 0 === o && (o = {});
          var u = o.format,
            c = (0, r.pi)((0, r.pi)({}, l && {
              timeZone: l
            }), u && Ve(a, t, u, s)),
            d = je(o, Ze, c);
          return "time" !== t || d.hour || d.minute || d.second || d.timeStyle || d.dateStyle || (d = (0, r.pi)((0, r.pi)({}, d), {
            hour: "numeric",
            minute: "numeric"
          })), n(i, d);
        }
        function Ge(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n[0],
            i = n[1],
            a = void 0 === i ? {} : i,
            s = "string" == typeof o ? new Date(o || 0) : o;
          try {
            return $e(e, "date", t, a).format(s);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting date.", t));
          }
          return String(s);
        }
        function We(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n[0],
            i = n[1],
            a = void 0 === i ? {} : i,
            s = "string" == typeof o ? new Date(o || 0) : o;
          try {
            return $e(e, "time", t, a).format(s);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting time.", t));
          }
          return String(s);
        }
        function Ye(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n[0],
            i = n[1],
            a = n[2],
            s = void 0 === a ? {} : a,
            l = e.timeZone,
            u = e.locale,
            c = e.onError,
            d = je(s, Ze, l ? {
              timeZone: l
            } : {});
          try {
            return t(u, d).formatRange(o, i);
          } catch (e) {
            c(new Te(ze.FORMAT_ERROR, "Error formatting date time range.", e));
          }
          return String(o);
        }
        function Xe(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n[0],
            i = n[1],
            a = void 0 === i ? {} : i,
            s = "string" == typeof o ? new Date(o || 0) : o;
          try {
            return $e(e, "date", t, a).formatToParts(s);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting date.", t));
          }
          return [];
        }
        function Qe(e, t) {
          for (var n = [], r = 2; r < arguments.length; r++) n[r - 2] = arguments[r];
          var o = n[0],
            i = n[1],
            a = void 0 === i ? {} : i,
            s = "string" == typeof o ? new Date(o || 0) : o;
          try {
            return $e(e, "time", t, a).formatToParts(s);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting time.", t));
          }
          return [];
        }
        var Je = ["localeMatcher", "style", "type", "fallback"];
        function et(e, t, n, r) {
          var o = e.locale,
            i = e.onError;
          Intl.DisplayNames || i(new xe('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', ve.MISSING_INTL_API));
          var a = je(r, Je);
          try {
            return t(o, a).of(n);
          } catch (e) {
            i(new Te(ze.FORMAT_ERROR, "Error formatting display name.", e));
          }
        }
        var tt = ["localeMatcher", "type", "style"],
          nt = Date.now();
        function rt(e, t, n, r) {
          void 0 === r && (r = {});
          var o = ot(e, t, n, r).reduce(function (e, t) {
            var n = t.value;
            return "string" != typeof n ? e.push(n) : "string" == typeof e[e.length - 1] ? e[e.length - 1] += n : e.push(n), e;
          }, []);
          return 1 === o.length ? o[0] : o;
        }
        function ot(e, t, n, o) {
          var i = e.locale,
            a = e.onError;
          void 0 === o && (o = {}), Intl.ListFormat || a(new xe('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', ve.MISSING_INTL_API));
          var s = je(o, tt);
          try {
            var l = {},
              u = n.map(function (e, t) {
                if ("object" == typeof e) {
                  var n = function (e) {
                    return nt + "_" + e + "_" + nt;
                  }(t);
                  return l[n] = e, n;
                }
                return String(e);
              });
            return t(i, s).formatToParts(u).map(function (e) {
              return "literal" === e.type ? e : (0, r.pi)((0, r.pi)({}, e), {
                value: l[e.value] || e.value
              });
            });
          } catch (e) {
            a(new Te(ze.FORMAT_ERROR, "Error formatting list.", e));
          }
          return n;
        }
        var it = ["localeMatcher", "type"];
        function at(e, t, n, r) {
          var o = e.locale,
            i = e.onError;
          void 0 === r && (r = {}), Intl.PluralRules || i(new xe('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', ve.MISSING_INTL_API));
          var a = je(r, it);
          try {
            return t(o, a).select(n);
          } catch (e) {
            i(new Me("Error formatting plural.", e));
          }
          return "other";
        }
        var st = ["numeric", "style"];
        function lt(e, t, n, r, o) {
          void 0 === o && (o = {}), r || (r = "second"), Intl.RelativeTimeFormat || e.onError(new xe('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', ve.MISSING_INTL_API));
          try {
            return function (e, t, n) {
              var r = e.locale,
                o = e.formats,
                i = e.onError;
              void 0 === n && (n = {});
              var a = n.format,
                s = !!a && Ve(o, "relative", a, i) || {};
              return t(r, je(n, st, s));
            }(e, t, o).format(n, r);
          } catch (t) {
            e.onError(new Me("Error formatting relative time.", t));
          }
          return String(n);
        }
        var ut = ["localeMatcher", "style", "currency", "currencyDisplay", "unit", "unitDisplay", "useGrouping", "minimumIntegerDigits", "minimumFractionDigits", "maximumFractionDigits", "minimumSignificantDigits", "maximumSignificantDigits", "compactDisplay", "currencyDisplay", "currencySign", "notation", "signDisplay", "unit", "unitDisplay", "numberingSystem"];
        function ct(e, t, n) {
          var r = e.locale,
            o = e.formats,
            i = e.onError;
          void 0 === n && (n = {});
          var a = n.format,
            s = a && Ve(o, "number", a, i) || {};
          return t(r, je(n, ut, s));
        }
        function dt(e, t, n, r) {
          void 0 === r && (r = {});
          try {
            return ct(e, t, r).format(n);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting number.", t));
          }
          return String(n);
        }
        function pt(e, t, n, r) {
          void 0 === r && (r = {});
          try {
            return ct(e, t, r).formatToParts(n);
          } catch (t) {
            e.onError(new Te(ze.FORMAT_ERROR, "Error formatting number.", t));
          }
          return [];
        }
        function ht(e) {
          var t;
          e.defaultRichTextElements && "string" == typeof ((t = e.messages || {}) ? t[Object.keys(t)[0]] : void 0) && console.warn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
        }
        function ft(e, t) {
          var n = function (e) {
              void 0 === e && (e = {
                dateTime: {},
                number: {},
                message: {},
                relativeTime: {},
                pluralRules: {},
                list: {},
                displayNames: {}
              });
              var t = Intl.RelativeTimeFormat,
                n = Intl.ListFormat,
                o = Intl.DisplayNames,
                i = ce(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.DateTimeFormat).bind.apply(e, (0, r.ev)([void 0], t)))();
                }, {
                  cache: Le(e.dateTime),
                  strategy: be.variadic
                }),
                a = ce(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.NumberFormat).bind.apply(e, (0, r.ev)([void 0], t)))();
                }, {
                  cache: Le(e.number),
                  strategy: be.variadic
                }),
                s = ce(function () {
                  for (var e, t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
                  return new ((e = Intl.PluralRules).bind.apply(e, (0, r.ev)([void 0], t)))();
                }, {
                  cache: Le(e.pluralRules),
                  strategy: be.variadic
                });
              return {
                getDateTimeFormat: i,
                getNumberFormat: a,
                getMessageFormat: ce(function (e, t, n, o) {
                  return new Ae(e, t, n, (0, r.pi)({
                    formatters: {
                      getNumberFormat: a,
                      getDateTimeFormat: i,
                      getPluralRules: s
                    }
                  }, o || {}));
                }, {
                  cache: Le(e.message),
                  strategy: be.variadic
                }),
                getRelativeTimeFormat: ce(function () {
                  for (var e = [], n = 0; n < arguments.length; n++) e[n] = arguments[n];
                  return new (t.bind.apply(t, (0, r.ev)([void 0], e)))();
                }, {
                  cache: Le(e.relativeTime),
                  strategy: be.variadic
                }),
                getPluralRules: s,
                getListFormat: ce(function () {
                  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
                  return new (n.bind.apply(n, (0, r.ev)([void 0], e)))();
                }, {
                  cache: Le(e.list),
                  strategy: be.variadic
                }),
                getDisplayNames: ce(function () {
                  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
                  return new (o.bind.apply(o, (0, r.ev)([void 0], e)))();
                }, {
                  cache: Le(e.displayNames),
                  strategy: be.variadic
                })
              };
            }(t),
            o = (0, r.pi)((0, r.pi)({}, Be), e),
            i = o.locale,
            a = o.defaultLocale,
            s = o.onError;
          return i ? !Intl.NumberFormat.supportedLocalesOf(i).length && s ? s(new Fe('Missing locale data for locale: "' + i + '" in Intl.NumberFormat. Using default locale: "' + a + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')) : !Intl.DateTimeFormat.supportedLocalesOf(i).length && s && s(new Fe('Missing locale data for locale: "' + i + '" in Intl.DateTimeFormat. Using default locale: "' + a + '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')) : (s && s(new Ie('"locale" was not configured, using "' + a + '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')), o.locale = o.defaultLocale || "en"), ht(o), (0, r.pi)((0, r.pi)({}, o), {
            formatters: n,
            formatNumber: dt.bind(null, o, n.getNumberFormat),
            formatNumberToParts: pt.bind(null, o, n.getNumberFormat),
            formatRelativeTime: lt.bind(null, o, n.getRelativeTimeFormat),
            formatDate: Ge.bind(null, o, n.getDateTimeFormat),
            formatDateToParts: Xe.bind(null, o, n.getDateTimeFormat),
            formatTime: We.bind(null, o, n.getDateTimeFormat),
            formatDateTimeRange: Ye.bind(null, o, n.getDateTimeFormat),
            formatTimeToParts: Qe.bind(null, o, n.getDateTimeFormat),
            formatPlural: at.bind(null, o, n.getPluralRules),
            formatMessage: Ue.bind(null, o, n),
            formatList: rt.bind(null, o, n.getListFormat),
            formatListToParts: ot.bind(null, o, n.getListFormat),
            formatDisplayName: et.bind(null, o, n.getDisplayNames)
          });
        }
        function mt(e) {
          s(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
        }
        var gt = (0, r.pi)((0, r.pi)({}, Be), {
          textComponent: o.Fragment
        });
        function vt(e, t) {
          if (e === t) return !0;
          if (!e || !t) return !1;
          var n = Object.keys(e),
            r = Object.keys(t),
            o = n.length;
          if (r.length !== o) return !1;
          for (var i = 0; i < o; i++) {
            var a = n[i];
            if (e[a] !== t[a] || !Object.prototype.hasOwnProperty.call(t, a)) return !1;
          }
          return !0;
        }
        var yt,
          bt,
          wt = o.createContext(null),
          xt = wt.Consumer,
          Dt = wt.Provider,
          Ct = wt;
        function St(e, t) {
          var n = t || {},
            i = n.intlPropName,
            s = void 0 === i ? "intl" : i,
            l = n.forwardRef,
            u = void 0 !== l && l,
            c = n.enforceContext,
            d = void 0 === c || c,
            p = function (t) {
              return o.createElement(xt, null, function (n) {
                var i;
                d && mt(n);
                var a = ((i = {})[s] = n, i);
                return o.createElement(e, (0, r.pi)({}, t, a, {
                  ref: u ? t.forwardedRef : null
                }));
              });
            };
          return p.displayName = "injectIntl(" + function (e) {
            return e.displayName || e.name || "Component";
          }(e) + ")", p.WrappedComponent = e, u ? a()(o.forwardRef(function (e, t) {
            return o.createElement(p, (0, r.pi)({}, e, {
              forwardedRef: t
            }));
          }), e) : a()(p, e);
        }
        function Et() {
          var e = o.useContext(Ct);
          return mt(e), e;
        }
        !function (e) {
          e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
        }(yt || (yt = {})), function (e) {
          e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
        }(bt || (bt = {}));
        var _t = function (e) {
          var t = Et(),
            n = e.value,
            o = e.children,
            i = (0, r._T)(e, ["value", "children"]);
          return o(t.formatNumberToParts(n, i));
        };
        _t.displayName = "FormattedNumberParts";
        function Pt(e) {
          var t = function (t) {
            var n = Et(),
              o = t.value,
              i = t.children,
              a = (0, r._T)(t, ["value", "children"]),
              s = "string" == typeof o ? new Date(o || 0) : o;
            return i("formatDate" === e ? n.formatDateToParts(s, a) : n.formatTimeToParts(s, a));
          };
          return t.displayName = bt[e], t;
        }
        function kt(e) {
          var t = function (t) {
            var n = Et(),
              i = t.value,
              a = t.children,
              s = (0, r._T)(t, ["value", "children"]),
              l = n[e](i, s);
            if ("function" == typeof a) return a(l);
            var u = n.textComponent || o.Fragment;
            return o.createElement(u, null, l);
          };
          return t.displayName = yt[e], t;
        }
        function At(e) {
          return {
            locale: e.locale,
            timeZone: e.timeZone,
            formats: e.formats,
            textComponent: e.textComponent,
            messages: e.messages,
            defaultLocale: e.defaultLocale,
            defaultFormats: e.defaultFormats,
            onError: e.onError,
            wrapRichTextChunksInFragment: e.wrapRichTextChunksInFragment,
            defaultRichTextElements: e.defaultRichTextElements
          };
        }
        function zt(e) {
          return e ? Object.keys(e).reduce(function (t, n) {
            var r,
              i = e[n];
            return t[n] = Ee(i) ? (r = i, function (e) {
              return r(o.Children.toArray(e));
            }) : i, t;
          }, {}) : e;
        }
        _t.displayName = "FormattedNumberParts";
        var Tt = function (e, t, n, i) {
            for (var a = [], s = 4; s < arguments.length; s++) a[s - 4] = arguments[s];
            var l = zt(i),
              u = Ue.apply(void 0, (0, r.ev)([e, t, n, l], a));
            return Array.isArray(u) ? o.Children.toArray(u) : u;
          },
          Ot = function (e, t) {
            var n = e.defaultRichTextElements,
              o = (0, r._T)(e, ["defaultRichTextElements"]),
              i = zt(n),
              a = ft((0, r.pi)((0, r.pi)((0, r.pi)({}, gt), o), {
                defaultRichTextElements: i
              }), t);
            return (0, r.pi)((0, r.pi)({}, a), {
              formatMessage: Tt.bind(null, {
                locale: a.locale,
                timeZone: a.timeZone,
                formats: a.formats,
                defaultLocale: a.defaultLocale,
                defaultFormats: a.defaultFormats,
                messages: a.messages,
                onError: a.onError,
                defaultRichTextElements: i
              }, a.formatters)
            });
          },
          It = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.cache = {
                dateTime: {},
                number: {},
                message: {},
                relativeTime: {},
                pluralRules: {},
                list: {},
                displayNames: {}
              }, t.state = {
                cache: t.cache,
                intl: Ot(At(t.props), t.cache),
                prevConfig: At(t.props)
              }, t;
            }
            return (0, r.ZT)(t, e), t.getDerivedStateFromProps = function (e, t) {
              var n = t.prevConfig,
                r = t.cache,
                o = At(e);
              return vt(n, o) ? null : {
                intl: Ot(o, r),
                prevConfig: o
              };
            }, t.prototype.render = function () {
              return mt(this.state.intl), o.createElement(Dt, {
                value: this.state.intl
              }, this.props.children);
            }, t.displayName = "IntlProvider", t.defaultProps = gt, t;
          }(o.PureComponent);
        const Ft = It;
        var Mt = 3600;
        function Rt(e) {
          var t = Math.abs(e);
          return t < 60 ? "second" : t < Mt ? "minute" : t < 86400 ? "hour" : "day";
        }
        function jt(e) {
          switch (e) {
            case "second":
              return 1;
            case "minute":
              return 60;
            case "hour":
              return Mt;
            default:
              return 86400;
          }
        }
        var Bt = ["second", "minute", "hour"];
        function Nt(e) {
          return void 0 === e && (e = "second"), Bt.includes(e);
        }
        var Lt = function (e) {
            var t = Et(),
              n = t.formatRelativeTime,
              i = t.textComponent,
              a = e.children,
              s = n(e.value || 0, e.unit, (0, r._T)(e, ["children", "value", "unit"]));
            return "function" == typeof a ? a(s) : i ? o.createElement(i, null, s) : o.createElement(o.Fragment, null, s);
          },
          Vt = function (e) {
            var t = e.value,
              n = e.unit,
              i = e.updateIntervalInSeconds,
              a = (0, r._T)(e, ["value", "unit", "updateIntervalInSeconds"]);
            s(!i || !(!i || !Nt(n)), "Cannot schedule update with unit longer than hour");
            var l,
              u = o.useState(),
              c = u[0],
              d = u[1],
              p = o.useState(0),
              h = p[0],
              f = p[1],
              m = o.useState(0),
              g = m[0],
              v = m[1];
            n === c && t === h || (f(t || 0), d(n), v(Nt(n) ? function (e, t) {
              if (!e) return 0;
              switch (t) {
                case "second":
                  return e;
                case "minute":
                  return 60 * e;
                default:
                  return e * Mt;
              }
            }(t, n) : 0)), o.useEffect(function () {
              function e() {
                clearTimeout(l);
              }
              if (e(), !i || !Nt(n)) return e;
              var t = g - i,
                r = Rt(t);
              if ("day" === r) return e;
              var o = jt(r),
                a = t - t % o,
                s = a >= g ? a - o : a,
                u = Math.abs(s - g);
              return g !== s && (l = setTimeout(function () {
                return v(s);
              }, 1e3 * u)), e;
            }, [g, i, n]);
            var y = t || 0,
              b = n;
            if (Nt(n) && "number" == typeof g && i) {
              var w = jt(b = Rt(g));
              y = Math.round(g / w);
            }
            return o.createElement(Lt, (0, r.pi)({
              value: y,
              unit: b
            }, a));
          };
        Vt.displayName = "FormattedRelativeTime", Vt.defaultProps = {
          value: 0,
          unit: "second"
        };
        var Kt = function (e) {
          var t = Et(),
            n = t.formatPlural,
            r = t.textComponent,
            i = e.value,
            a = e.other,
            s = e.children,
            l = e[n(i, e)] || a;
          return "function" == typeof s ? s(l) : r ? o.createElement(r, null, l) : l;
        };
        Kt.defaultProps = {
          type: "cardinal"
        }, Kt.displayName = "FormattedPlural";
        function qt(e, t) {
          var n = e.values,
            o = (0, r._T)(e, ["values"]),
            i = t.values,
            a = (0, r._T)(t, ["values"]);
          return vt(i, n) && vt(o, a);
        }
        function Ht(e) {
          var t = Et(),
            n = t.formatMessage,
            r = t.textComponent,
            i = void 0 === r ? o.Fragment : r,
            a = e.id,
            s = e.description,
            l = e.defaultMessage,
            u = e.values,
            c = e.children,
            d = e.tagName,
            p = void 0 === d ? i : d,
            h = n({
              id: a,
              description: s,
              defaultMessage: l
            }, u, {
              ignoreTag: e.ignoreTag
            });
          return Array.isArray(h) || (h = [h]), "function" == typeof c ? c(h) : p ? o.createElement(p, null, o.Children.toArray(h)) : o.createElement(o.Fragment, null, h);
        }
        Ht.displayName = "FormattedMessage";
        var Ut = o.memo(Ht, qt);
        Ut.displayName = "MemoizedFormattedMessage";
        const Zt = Ut;
        var $t = function (e) {
          var t = Et(),
            n = e.from,
            i = e.to,
            a = e.children,
            s = (0, r._T)(e, ["from", "to", "children"]),
            l = t.formatDateTimeRange(n, i, s);
          if ("function" == typeof a) return a(l);
          var u = t.textComponent || o.Fragment;
          return o.createElement(u, null, l);
        };
        $t.displayName = "FormattedDateTimeRange";
        function Gt(e) {
          return e;
        }
        kt("formatDate"), kt("formatTime"), kt("formatNumber"), kt("formatList"), kt("formatDisplayName"), Pt("formatDate"), Pt("formatTime");
      },
      97087: (e, t, n) => {
        "use strict";

        n.d(t, {
          eC: () => b,
          UQ: () => y,
          pQ: () => v,
          j2: () => C,
          kS: () => D,
          Q$: () => x,
          dN: () => w
        });
        var r = n(15359),
          o = n(16126),
          i = n(96156),
          a = n(77017),
          s = n(86358);
        class l extends s.X {
          constructor(e, t) {
            super(e), this.code = t;
          }
        }
        var u = n(13798);
        function c(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class d {
          constructor(e, t) {
            this.jsonCommand = t, this.identifier = (0, a.v4)(), this.coreClient = e;
          }
          async request() {
            const e = await this.coreClient.dispatchCommand(JSON.stringify(this.jsonCommand));
            if (e.success) return e;
            throw new l(e.message, e.code);
          }
        }
        class p {
          constructor(e, t) {
            this.requestQueue = e, this.coreClient = t;
          }
          executeCommand(e, t, n) {
            return (0, u.nb)(this.requestQueue.enqueue(new d(this.coreClient, function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? c(Object(n), !0).forEach(function (t) {
                  (0, i.Z)(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({
              type: e
            }, n)), t));
          }
          cancelRequests(e) {
            this.requestQueue.cancelRequests(t => e(t));
          }
        }
        var h = n(51679),
          f = n(67559);
        class m {
          constructor(e) {
            this.requestQueue = new h.g(e);
          }
          enqueue(e, t) {
            const {
              promise: n,
              cancel: r
            } = this.requestQueue.enqueue(e, t === f.Priority.High);
            return {
              promise: n,
              cancel: () => {
                (function (e) {
                  return "cancel" in e;
                })(e) && e.cancel(), r();
              }
            };
          }
          cancelRequests(e) {
            this.requestQueue.cancel(e);
          }
        }
        const g = e => new m(e),
          v = e => {
            const t = g(2);
            return {
              wasmCtx: {
                engine: new p(t, e)
              },
              requestQueue: t
            };
          },
          y = (e, t, n) => ({
            serverCtx: {
              info: e,
              satisfiesVersion: n
            },
            requestQueue: g(10),
            getWasmDispatch: t
          }),
          b = (e, t) => {
            (0, o.h)(!e.wasmCtx), e.wasmCtx = {
              engine: new p(e.requestQueue, t)
            };
          },
          w = (e, t) => ((0, o.h)(e.wasmCtx), t(e.wasmCtx)),
          x = (e, t) => ((0, o.h)(e.serverCtx), t(e.serverCtx)),
          D = (e, t, n) => {
            if (e.wasmCtx) return w(e, t);
            if (e.serverCtx) return x(e, n);
            throw new r.p2("No engine found");
          },
          C = (e, t) => !!e.serverCtx && e.serverCtx.satisfiesVersion(t);
      },
      67559: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          ContentEditor: () => A,
          ContentEditorTypes: () => o,
          ImageFormat: () => S,
          Priority: () => C,
          Renderer: () => r,
          addWASMCtx: () => i.eC,
          createContentEditor: () => k,
          createServerContext: () => i.UQ,
          createWASMContext: () => i.pQ,
          ping: () => s,
          satifiesServerVersion: () => i.j2,
          withEngine: () => i.kS,
          withServerEngine: () => i.Q$,
          withWASMEngine: () => i.dN
        });
        var r = {};
        n.r(r), n.d(r, {
          renderTile: () => D
        });
        var o = {};
        n.r(o);
        var i = n(97087),
          a = n(13798);
        const s = async e => (0, i.kS)(e, async e => {
          await e.engine.executeCommand("ping", C.Normal, {});
        }, async e => {
          throw new a.X9("not implemented");
        });
        var l = n(16126);
        let u = function (e) {
          return e[e.Windows = 0] = "Windows", e[e.iOS = 1] = "iOS", e[e.macOS = 2] = "macOS", e[e.Android = 3] = "Android", e[e.Linux = 4] = "Linux", e;
        }({});
        const c = function () {
          var e, t, n, r, o, i;
          let a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null !== (e = null === (t = globalThis.navigator) || void 0 === t ? void 0 : t.userAgent) && void 0 !== e ? e : "",
            s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null !== (n = null === (r = globalThis.navigator) || void 0 === r ? void 0 : r.platform) && void 0 !== n ? n : "",
            l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null !== (o = null === (i = globalThis.navigator) || void 0 === i ? void 0 : i.maxTouchPoints) && void 0 !== o ? o : 0;
          return s.indexOf("MacIntel") > -1 && l > 1 ? u.iOS : a.indexOf("Win") > -1 ? u.Windows : a.indexOf("iPhone") > -1 || a.indexOf("iPad") > -1 || "iPad" === s ? u.iOS : a.indexOf("Mac") > -1 ? u.macOS : a.indexOf("Android") > -1 ? u.Android : a.indexOf("Linux") > -1 ? u.Linux : null;
        }();
        let d = function (e) {
          return e[e.Trident = 0] = "Trident", e[e.Edge = 1] = "Edge", e[e.Blink = 2] = "Blink", e[e.Webkit = 3] = "Webkit", e[e.Gecko = 4] = "Gecko", e;
        }({});
        const p = function () {
            var e, t;
            let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null !== (e = null === (t = globalThis.navigator) || void 0 === t ? void 0 : t.userAgent) && void 0 !== e ? e : "";
            return n.indexOf("Trident/") > -1 ? d.Trident : n.indexOf("Edge/") > -1 ? d.Edge : n.indexOf("Chrome/") > -1 ? d.Blink : n.indexOf("AppleWebKit/") > -1 ? d.Webkit : n.indexOf("Gecko/") > -1 ? d.Gecko : null;
          }(),
          h = 16383;
        const f = e => {
          if (e) {
            if (e.includes("image/webp")) return S.WebP;
            if (e.includes("image/png")) return S.PNG;
            if (e.includes("image/jpeg")) return S.JPEG;
          }
          throw new a.X9("Couldn't determine image format");
        };
        var m = n(96156),
          g = n(77017);
        function v(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function y(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? v(Object(n), !0).forEach(function (t) {
              (0, m.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        let b = function (e) {
          return e[e.Token = 0] = "Token", e[e.QueryToken = 1] = "QueryToken", e[e.ImageToken = 2] = "ImageToken", e;
        }({});
        class w {
          constructor(e, t) {
            (0, m.Z)(this, "abortController", new AbortController()), this.url = e, this.requestInit = t, this.identifier = (0, g.v4)();
          }
          async request() {
            return fetch(this.url, y(y({}, this.requestInit), {}, {
              signal: this.abortController.signal
            }));
          }
          cancel() {
            this.abortController.abort();
          }
        }
        const x = (e, t, n, r, o, i) => {
            let s = y(y({}, null == i ? void 0 : i.headers), t.info.headers);
            switch (o) {
              case b.Token:
                s = y(y({}, s), {}, {
                  "X-PSPDFKit-Token": t.info.token
                });
                break;
              case b.ImageToken:
                s = y(y({}, s), {}, {
                  "X-PSPDFKit-Image-Token": t.info.imageToken
                });
            }
            let l = "";
            if (o == b.QueryToken) {
              const e = new URLSearchParams();
              e.append("token", t.info.token), l = "?" + e.toString();
            }
            return (0, a.nb)(e.enqueue(new w(`${t.info.url}i/d/${t.info.documentId}/h/${t.info.layerHandle}/${n}${l}`, y(y({}, i), {}, {
              headers: s
            })), r));
          },
          D = (e, t, n, r, o, s, m) => {
            const g = new a.sk(),
              v = (0, i.kS)(e, async e => {
                var i, a, d;
                o.format = null !== (i = o.format) && void 0 !== i ? i : S.Bitmap;
                const p = function (e, t) {
                    let {
                      width: n,
                      height: r
                    } = t;
                    return e === S.WebP && (n > h || r > h) || e === S.Bitmap && c === u.iOS && n * r > 16777216 ? S.PNG : e;
                  }(o.format, n),
                  f = s && (s.annotations.length > 0 || s.formFieldValues.length > 0),
                  {
                    promise: m,
                    cancel: v
                  } = e.engine.executeCommand("render_tile", null !== (a = o.priority) && void 0 !== a ? a : C.Normal, {
                    render_annotations: f,
                    print_rendering: o.renderForPrinting,
                    page: t,
                    bitmap_width: r.width,
                    bitmap_height: r.height,
                    bitmap_x: r.left,
                    bitmap_y: r.top,
                    page_width: n.width,
                    page_height: n.height,
                    format: p,
                    render_text: null === (d = o.renderText) || void 0 === d || d
                  });
                g.addCancelFn(v);
                const y = await m;
                return (0, l.h)(1 == y.values.length, "Should have exactly one image buffer in result."), (0, l.h)(y.values[0] instanceof Uint8Array), {
                  buffer: y.values[0],
                  format: p
                };
              }, async i => {
                (0, l.h)(!o.format, "Requesting image format is not supported on server.");
                const u = `page-${t}-dimensions-${n.width}-${n.height}-tile-${r.left}-${r.top}-${r.width}-${r.height}${o.renderForPrinting ? "-print" : ""}`,
                  c = s ? ((e, t) => {
                    const n = new FormData();
                    return n.append("data", JSON.stringify({
                      annotations: e.annotations,
                      formFieldValues: e.formFieldValues,
                      formFields: e.formFields,
                      signatures: e.signatures || []
                    })), t && t.length > 0 && t.forEach(t => {
                      const r = e.attachments[t];
                      (0, l.h)(r, `Attachment data '${t}' could not be found.`), (0, l.h)(r.data, `Attachment '${t}' doesn't have any data.`), n.append(t, r.data);
                    }), n;
                  })(s, m) : void 0,
                  v = {
                    method: c ? "POST" : "GET",
                    body: c,
                    headers: p != d.Webkit || n.width <= h && n.height <= h ? {
                      Accept: "image/webp,*/*"
                    } : void 0
                  },
                  y = x(e.requestQueue, i, u, o.priority, b.ImageToken, v);
                g.addCancelFn(y.cancel);
                const w = await y.promise;
                if (!w.ok) {
                  if ("application/json" !== w.headers.get("content-type")) throw new a.X9(`The image can not be rendered because of an unknown error (${w.status})`);
                  {
                    const i = await w.json();
                    if (i.attachments_not_found) {
                      if (!s) throw new a.X9("Document state is required when attachments are missing");
                      for (const e of i.attachments_not_found) if (!s.attachments[e]) throw new a.X9(`Attachment ${e} not found in document state, but required by server.`);
                      const l = D(e, t, n, r, o, s, i.attachments_not_found);
                      return g.addCancelFn(() => {
                        l.cancel();
                      }), l.promise;
                    }
                    if (i.error) throw new a.X9(`The server could not render the requested image (${i.error})`);
                  }
                }
                const C = await w.arrayBuffer();
                return {
                  buffer: new Uint8Array(C),
                  format: f(w.headers.get("content-type"))
                };
              });
            return (0, a.nb)({
              promise: v,
              cancel: () => g.cancel()
            });
          };
        let C = function (e) {
            return e[e.Normal = 0] = "Normal", e[e.High = 1] = "High", e;
          }({}),
          S = function (e) {
            return e.PNG = "png", e.JPEG = "jpeg", e.WebP = "webp", e.Bitmap = "bitmap", e;
          }({});
        const E = ">=1.3",
          _ = async (e, t, n) => {
            const r = await e.engine.executeCommand(t, C.High, n);
            return (0, l.h)(1 === r.values.length, `expected only one response for ${t}: ${r.values}`), (0, l.h)(!(r.values[0] instanceof Uint8Array), "expected JSON response: " + r.values), r.values[0];
          },
          P = e => {
            e.serverCtx && (0, l.h)((0, i.j2)(e, E), "Content Editing is available with Document Engine version >=1.3");
          };
        async function k(e) {
          if (e.serverCtx) {
            P(e);
            const t = x(e.requestQueue, e.serverCtx, "pdf", C.High, b.QueryToken);
            if (!e.wasmCtx) {
              (0, l.h)(e.getWasmDispatch);
              const t = await e.getWasmDispatch();
              e.wasmCtx || (0, i.eC)(e, t);
            }
            (0, l.h)(e.wasmCtx);
            const n = await t;
            return await e.wasmCtx.engine.coreClient.writeFile("/document.pdf", await n.arrayBuffer()), await e.wasmCtx.engine.executeCommand("open_document", C.Normal, {
              file_path: "/document.pdf"
            }), await e.wasmCtx.engine.executeCommand("content_editing/enter", C.High, {}), new A(e.wasmCtx, e);
          }
          var t;
          if (e.wasmCtx) return (0, l.h)(e.wasmCtx, "wasmCtx is required."), await (null === (t = e.wasmCtx) || void 0 === t ? void 0 : t.engine.executeCommand("content_editing/enter", C.High, {})), new A(e.wasmCtx, e);
        }
        class A {
          constructor(e, t) {
            (0, l.h)(e, "wasmCtx is required."), this.wasmCtx = e, this.ctx = t;
          }
          async closeContentEditor() {
            await this.wasmCtx.engine.executeCommand("content_editing/exit", C.High, {});
          }
          async getTextBlocks(e) {
            return _(this.wasmCtx, "content_editing/get_text_blocks", {
              pageIndex: e
            });
          }
          async detectParagraphs(e) {
            return _(this.wasmCtx, "content_editing/detect_paragraphs", {
              pageIndex: e
            });
          }
          async renderTextBlock(e, t, n) {
            const r = await this.wasmCtx.engine.executeCommand("content_editing/render_text_block", C.High, {
              textBlockId: e,
              renderTextBlockParams: t,
              externalControlState: n
            });
            return (0, l.h)(2 === r.values.length, "expected only two responses for renderTextBlock. ArrayBuffer and Size info."), (0, l.h)(!(r.values[0] instanceof Uint8Array), `expected JSON response: ${r.values}`), (0, l.h)(r.values[1] instanceof Uint8Array, `expected ArrayBuffer response: ${r.values}`), {
              imageBuffer: r.values[1],
              displayRect: r.values[0].displayRect
            };
          }
          async setTextBlockCursor(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/set_cursor", {
              textBlockId: e,
              offset: t,
              selectText: n,
              externalControlState: r
            });
          }
          async moveTextBlockCursor(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/move_cursor", {
              textBlockId: e,
              movement: t,
              selectText: n,
              externalControlState: r
            });
          }
          async insertTextBlockString(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/insert_text", {
              textBlockId: e,
              cluster: t,
              text: n,
              externalControlState: r
            });
          }
          async insertTextBlockContentRef(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/insert_content_ref", {
              textBlockId: e,
              cluster: t,
              contentRef: n,
              externalControlState: r
            });
          }
          async createTextBlock(e) {
            return _(this.wasmCtx, "content_editing/create_text_block", {
              pageIndex: e
            });
          }
          async layoutTextBlock(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/layout", {
              textBlockId: e,
              cursor: t,
              selection: n,
              externalControlState: r
            });
          }
          async deleteTextBlockRange(e, t, n) {
            return _(this.wasmCtx, "content_editing/delete_range", {
              textBlockId: e,
              range: t,
              externalControlState: n
            });
          }
          async deleteTextBlockString(e, t, n) {
            return _(this.wasmCtx, "content_editing/delete_cluster", {
              textBlockId: e,
              direction: t,
              externalControlState: n
            });
          }
          async setTextBlockSelection(e, t, n) {
            return _(this.wasmCtx, "content_editing/set_selection", {
              textBlockId: e,
              mode: t,
              externalControlState: n
            });
          }
          async setTextBlockSelectionRange(e, t, n, r, o) {
            return _(this.wasmCtx, "content_editing/set_selection_range", {
              textBlockId: e,
              begin: t,
              end: n,
              mode: r,
              externalControlState: o
            });
          }
          async textBlockUndo(e, t) {
            return _(this.wasmCtx, "content_editing/undo", {
              textBlockId: e,
              externalControlState: t
            });
          }
          async textBlockRedo(e, t) {
            return _(this.wasmCtx, "content_editing/redo", {
              textBlockId: e,
              externalControlState: t
            });
          }
          async textBlockRestore(e, t, n) {
            return _(this.wasmCtx, "content_editing/restore", {
              textBlockId: e,
              version: t,
              externalControlState: n
            });
          }
          async textBlockApplyFormat(e, t, n, r) {
            return _(this.wasmCtx, "content_editing/apply_format", {
              textBlockId: e,
              range: t,
              formatModifications: n,
              externalControlState: r
            });
          }
          async save(e, t, n) {
            try {
              const r = "/update";
              if (this.ctx.serverCtx) {
                P(this.ctx);
                const o = await _(this.wasmCtx, "content_editing/save_to_document", {
                  path: e,
                  textBlockSaveInfos: t,
                  graphicBlockSaveInfos: n,
                  alsoSaveUpdate: !0,
                  updateSavePath: r
                });
                (0, l.h)(o.checksum.length > 0, "expected non-empty checksum");
                let i = new FormData();
                i.append("update", new Blob([await this.wasmCtx.engine.coreClient.readFile(r)]), "update"), i.append("checksum", o.checksum);
                if ((await x(this.ctx.requestQueue, this.ctx.serverCtx, "update-source-document", C.High, b.Token, {
                  method: "POST",
                  body: i
                })).ok) return;
                (0, l.h)(this.ctx.serverCtx, "serverCtx is required."), i = new FormData(), i.append("file", new Blob([await this.wasmCtx.engine.coreClient.readFile(e)]), "file"), await x(this.ctx.requestQueue, this.ctx.serverCtx, "replace-source-document", C.High, b.Token, {
                  method: "POST",
                  body: i
                });
              } else await this.wasmCtx.engine.executeCommand("content_editing/save_to_document", C.High, {
                path: e,
                textBlockSaveInfos: t,
                graphicBlockSaveInfos: n
              });
            } catch (t) {
              throw new Error(`Error saving to ${e}: ${t.message}`);
            }
          }
          async getAvailableFaces() {
            return _(this.wasmCtx, "content_editing/available_faces");
          }
          async detectPageElements(e) {
            return _(this.wasmCtx, "content_editing/detect_page_elements", {
              pageIndex: e
            });
          }
          async renderGraphicBlock(e, t) {
            const n = await this.wasmCtx.engine.executeCommand("content_editing/render_graphic_block", C.High, {
              graphicBlockId: e,
              renderGraphicBlockParams: t
            });
            return (0, l.h)(2 === n.values.length, "expected only two responses for renderGraphicBlock. ArrayBuffer and Size info."), (0, l.h)(!(n.values[0] instanceof Uint8Array), `expected JSON response: ${n.values}`), (0, l.h)(n.values[1] instanceof Uint8Array, `expected ArrayBuffer response: ${n.values}`), {
              imageBuffer: n.values[1],
              displayRect: n.values[0].displayRect
            };
          }
          cancelRequests() {
            this.wasmCtx.engine.cancelRequests(e => !!e.jsonCommand && ((0, l.h)("string" == typeof e.jsonCommand.type, "expected string type"), e.jsonCommand.type.startsWith("content_editing/")));
          }
        }
      },
      86358: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => o
        });
        var r = n(15359);
        class o extends r.p2 {
          constructor(e) {
            super(e);
          }
        }
      },
      16126: (e, t, n) => {
        "use strict";

        n.d(t, {
          h: () => o
        });
        var r = n(15359);
        function o(e, t) {
          (0, r.kG)(e, t);
        }
      },
      13798: (e, t, n) => {
        "use strict";

        n.d(t, {
          sk: () => a,
          f: () => r,
          X9: () => o.X,
          nb: () => s
        });
        var r = n(67559),
          o = n(86358),
          i = n(96156);
        class a {
          constructor() {
            (0, i.Z)(this, "cancelled", !1), (0, i.Z)(this, "cancelFns", []);
          }
          cancel() {
            for (const e of this.cancelFns) e();
            this.cancelled = !0;
          }
          isCancelled() {
            return this.cancelled;
          }
          addCancelFn(e) {
            this.cancelFns.push(e);
          }
        }
        const s = e => ({
          promise: e.promise,
          cancel: e.cancel,
          then: (t, n) => {
            const r = e.promise.then(t, n);
            return s({
              promise: r,
              cancel: e.cancel
            });
          }
        });
      },
      75472: (e, t, n) => {
        "use strict";

        n.d(t, {
          Xn: () => h,
          AO: () => s,
          L7: () => l,
          $u: () => f
        });
        var r = n(96156),
          o = n(15359),
          i = n(96650);
        const a = () => {};
        class s {
          constructor() {
            (0, r.Z)(this, "_requests", new Map()), (0, r.Z)(this, "_nextRequestId", 1), (0, r.Z)(this, "_isLoading", !0), (0, r.Z)(this, "_loadPromise", null), (0, r.Z)(this, "_initPromise", null), (0, r.Z)(this, "_hasOpenedDocument", !1), (0, r.Z)(this, "_hasLoadedCertificates", !1), (0, r.Z)(this, "_handleMessage", e => {
              const t = e.data,
                n = this._requests.get(t.id);
              (0, o.kG)(n, `No request was made for id ${t.id}.`);
              const {
                resolve: r,
                reject: i
              } = n;
              if (this._requests.delete(t.id), t.error) {
                const e = new o.p2(t.error);
                e.callArgs = t.callArgs, i(e);
              } else r(t.result);
            });
          }
          getNativeModule() {
            throw new Error("Method not implemented.");
          }
          async loadNativeModule(e, t) {
            let {
              mainThreadOrigin: n,
              disableWebAssemblyStreaming: r,
              enableAutomaticLinkExtraction: i,
              overrideMemoryLimit: a,
              wasmLoaderPath: s,
              wasm: l,
              workerSpawnerFn: u
            } = t;
            return (0, o.kG)(!this._hasOpenedDocument, "cannot invoke `loadNativeModule` while an instance is still in use. Please call `recycle` first."), this._loadPromise ? this._loadPromise.then(() => {}) : (this._initPromise || (this.workerSpawner || (this.workerSpawner = await u(), this.workerSpawner.setMessageHandler(this._handleMessage)), this._baseCoreUrl = e, this._mainThreadOrigin = n, this._initPromise = this._sendRequest("loadNativeModule", [s && l ? {
              wasm: l,
              wasmLoaderPath: s
            } : e, {
              mainThreadOrigin: n,
              disableWebAssemblyStreaming: r,
              enableAutomaticLinkExtraction: i,
              overrideMemoryLimit: a
            }]).then(e => e).catch(e => {
              throw this._isLoading = !1, this.destroy(), e;
            })), this._initPromise);
          }
          load(e, t, n) {
            let {
              mainThreadOrigin: r,
              customFonts: i,
              dynamicFonts: a,
              productId: s
            } = n;
            return (0, o.kG)(!this._hasOpenedDocument, "cannot invoke `load` while an instance is still in use. Please call `recycle` first."), this._loadPromise || (this._loadPromise = this._sendRequest("load", [e, t, {
              mainThreadOrigin: r,
              customFonts: i,
              dynamicFonts: a,
              productId: s
            }]).then(e => (this._isLoading = !1, e)).catch(e => {
              var t;
              throw this._isLoading = !1, null === (t = this.workerSpawner) || void 0 === t || t.terminate(), e;
            })), this._loadPromise;
          }
          protobufBridge(e, t, n) {
            return this._assertLoaded(), this._sendRequest("protobufBridge", [e, t, n]);
          }
          version() {
            return this._assertLoaded(), this._sendRequest("version");
          }
          writeFile(e, t) {
            return this._assertLoaded(), this._sendRequest("writeFile", [e, t]);
          }
          readFile(e) {
            return this._assertLoaded(), this._sendRequest("readFile", [e]);
          }
          openDocument(e, t, n) {
            return this._assertLoaded(), this._hasOpenedDocument = !0, this._sendRequest("openDocument", [e, t, n]).catch(e => {
              throw this._hasOpenedDocument = !1, e;
            });
          }
          async getMeasurementScales() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getMeasurementScales");
          }
          async removeMeasurementScale(e) {
            return this._sendRequest("removeMeasurementScale", [e]);
          }
          async addMeasurementScale(e) {
            return await this._sendRequest("addMeasurementScale", [e]);
          }
          async getAnnotationsByScale(e) {
            return await this._sendRequest("getAnnotationsByScale", [e]);
          }
          async openDocumentAt() {
            throw new Error("Should never be called");
          }
          async getAllPageInfos(e) {
            return this._assertLoaded(), this._sendRequest("getAllPageInfos", [e]);
          }
          async enablePDFJavaScriptSupport() {
            return this._assertLoaded(), this._sendRequest("enablePDFJavaScriptSupport");
          }
          async runPDFFormattingScripts(e, t) {
            return this._assertLoaded(), this._sendRequest("runPDFFormattingScripts", [e, t]);
          }
          async getSuggestedLineHeightFactor(e, t) {
            return this._assertLoaded(), this._sendRequest("getSuggestedLineHeightFactor", [e, t]);
          }
          async getAvailableFontFaces(e) {
            return this._assertLoaded(), this._sendRequest("getAvailableFontFaces", [e]);
          }
          async setFontSubstitutions(e) {
            return this._assertLoaded(), this._sendRequest("setFontSubstitutions", [e]);
          }
          getBookmarks() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getBookmarks");
          }
          getFormJSON() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getFormJSON");
          }
          evalFormValuesActions(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("evalFormValuesActions", [e]);
          }
          evalScript(e, t, n) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("evalScript", [e, t, n]);
          }
          setFormJSONUpdateBatchMode(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setFormJSONUpdateBatchMode", [e]);
          }
          getFormValues() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getFormValues");
          }
          closeDocument() {
            return this._assertLoaded(), this._hasOpenedDocument = !1, this._sendRequest("closeDocument");
          }
          renderAnnotation(e, t, n, r, o, i) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("renderAnnotation", [e, t, n, r, o, i]);
          }
          renderPageAnnotations(e, t, n, r, o) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("renderPageAnnotations", [e, t, n, r, o]);
          }
          renderDetachedAnnotation(e, t, n, r, o) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("renderDetachedAnnotation", [e, t, n, r, o]);
          }
          onKeystrokeEvent(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("onKeystrokeEvent", [e]);
          }
          getAttachment(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getAttachment", [e]);
          }
          textForPageIndex(e) {
            this._assertLoaded(), this._assertDocumentOpen();
            return this._sendRequest("textForPageIndex", [e]);
          }
          contentTreeForPageIndex(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("contentTreeForPageIndex", [e]);
          }
          annotationsForPageIndex(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("annotationsForPageIndex", [e]);
          }
          getTabOrder(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getTabOrder", [e]);
          }
          setTabOrder(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setTabOrder", [e, t]);
          }
          createAnnotation(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("createAnnotation", [e, t]);
          }
          updateAnnotation(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("updateAnnotation", [e]);
          }
          deleteAnnotation(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("deleteAnnotation", [e]);
          }
          createFormField(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("createFormField", [e, t]);
          }
          updateFormField(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("updateFormField", [e, t]);
          }
          deleteFormField(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("deleteFormField", [e]);
          }
          setFormFieldValue(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setFormFieldValue", [e]);
          }
          deleteFormFieldValue(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("deleteFormFieldValue", [e]);
          }
          createBookmark(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("createBookmark", [e]);
          }
          updateBookmark(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("updateBookmark", [e]);
          }
          deleteBookmark(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("deleteBookmark", [e]);
          }
          setDocumentOutline(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setDocumentOutline", [e]);
          }
          getTextFromRects(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getTextFromRects", [e, t]);
          }
          getClosestSnapPoint(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getClosestSnapPoint", [e, t]);
          }
          configureSnapper(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("configureSnapper", [e]);
          }
          search(e, t, n, r) {
            let o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : i.S.TEXT;
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("search", [e, t, n, r, o]);
          }
          getSecondaryMeasurementUnit() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getSecondaryMeasurementUnit", []);
          }
          compareDocuments(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("compareDocuments", [e]);
          }
          setSecondaryMeasurementUnit(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setSecondaryMeasurementUnit", [e]);
          }
          getMeasurementSnappingPoints(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getMeasurementSnappingPoints", [e]);
          }
          parseXFDF(e, t) {
            return this._sendRequest("parseXFDF", [e, t]);
          }
          getEmbeddedFilesList() {
            return this._sendRequest("getEmbeddedFilesList");
          }
          exportFile() {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = arguments.length > 2 ? arguments[2] : void 0,
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "pdf",
              o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
              i = arguments.length > 5 ? arguments[5] : void 0,
              a = arguments.length > 6 ? arguments[6] : void 0,
              s = arguments.length > 7 ? arguments[7] : void 0;
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("exportFile", [e, t, n, r, o, i, a, s]);
          }
          importXFDF(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("importXFDF", [e, t, n]);
          }
          exportXFDF(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("exportXFDF", [e]);
          }
          importInstantJSON(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("importInstantJSON", [e]);
          }
          exportInstantJSON(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("exportInstantJSON", [e]);
          }
          getDocumentOutline() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getDocumentOutline");
          }
          getPageGlyphs(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getPageGlyphs", [e]);
          }
          applyOperations(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("applyOperations", [e, t]);
          }
          reloadDocument() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("reloadDocument");
          }
          exportPDFWithOperations(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("exportPDFWithOperations", [e, t]);
          }
          loadCertificates(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._hasLoadedCertificates = Boolean(e.length), this._sendRequest("loadCertificates", [e]).catch(e => {
              throw this._hasLoadedCertificates = !1, e;
            });
          }
          getSignaturesInfo() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getSignaturesInfo", []);
          }
          getComments() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getComments", []);
          }
          applyComments(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("applyComments", [e]);
          }
          prepareSign(e, t, n, r, o, i) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("prepareSign", [e, t, n, r, o, i]);
          }
          getTimestampRequest(e, t) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getTimestampRequest", [e, t]);
          }
          getRevocationRequests(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getRevocationRequests", [e]);
          }
          setSignaturesLTV(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setSignaturesLTV", [e]);
          }
          sign(e, t, n, r, o, i, a, s) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("sign", [e, t, n, r, o, i, a, s]);
          }
          restoreToOriginalState() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("restoreToOriginalState");
          }
          applyRedactions() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("applyRedactions", []);
          }
          readFormJSONObjects() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("readFormJSONObjects");
          }
          clearAPStreamCache() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("clearAPStreamCache");
          }
          setComparisonDocument(e, t) {
            return this._assertLoaded(), t || this._assertDocumentOpen(), this._sendRequest("setComparisonDocument", [e, t]);
          }
          openComparisonDocument(e) {
            return this._assertLoaded(), this._hasOpenedDocument = !0, this._sendRequest("openComparisonDocument", [e]).catch(e => {
              throw this._hasOpenedDocument = !1, e;
            });
          }
          documentCompareAndOpen(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("documentCompareAndOpen", [e]);
          }
          persistOpenDocument(e) {
            return this._assertLoaded(), e || this._assertDocumentOpen(), this._sendRequest("persistOpenDocument", [e]);
          }
          cleanupDocumentComparison() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("cleanupDocumentComparison");
          }
          getOCGs() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getOCGs", []);
          }
          getOCGVisibilityState() {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("getOCGVisibilityState", []);
          }
          setOCGVisibilityState(e) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("setOCGVisibilityState", [e]);
          }
          updateButtonIcon(e, t, n) {
            return this._assertLoaded(), this._assertDocumentOpen(), this._sendRequest("updateButtonIcon", [e, t, n]);
          }
          dispatchCommand(e) {
            return this._assertLoaded(), this._sendRequest("dispatchCommand", [e]);
          }
          recycle() {
            this._hasLoadedCertificates && this.loadCertificates([]), this._hasOpenedDocument && this.closeDocument(), this._isLoading || this._requests.forEach((e, t) => {
              this._requests.set(t, {
                resolve: a,
                reject: a
              });
            });
          }
          destroy() {
            var e;
            this._loadPromise = null, null === (e = this.workerSpawner) || void 0 === e || e.terminate();
          }
          _assertLoaded() {
            if (this._isLoading) throw new o.p2("CoreClient not yet initialized");
          }
          _assertDocumentOpen() {
            if (!this._hasOpenedDocument) throw new o.p2("This method can not be called since there is no open document. Have you run PSPDFKit.unload()?");
          }
          _sendRequest(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            (0, o.kG)(this.workerSpawner, "CoreClient has been destroyed");
            const n = this.workerSpawner;
            return new Promise((r, o) => {
              const i = this._assignId(),
                a = [...t].filter(e => e instanceof ArrayBuffer);
              n.postMessage({
                id: i,
                action: e,
                args: t
              }, a), this._requests = this._requests.set(i, {
                resolve: r,
                reject: o
              });
            });
          }
          _assignId() {
            const e = this._nextRequestId;
            return this._nextRequestId = this._nextRequestId + 1, e;
          }
          getCoreCallRecording() {
            return this._assertLoaded(), this._sendRequest("getCoreCallRecording");
          }
          enableCoreCallRecording(e) {
            return this._assertLoaded(), this._sendRequest("enableCoreCallRecording", [e]);
          }
        }
        class l {
          constructor(e) {
            (0, r.Z)(this, "size", 1), (0, r.Z)(this, "_freeObjects", []), this._constructor = e;
          }
          checkOut() {
            let e;
            return e = this._freeObjects.length > 0 ? this._freeObjects.shift() : new this._constructor(), {
              object: e,
              checkIn: () => {
                this._freeObjects.length >= this.size ? e.destroy() : (e.recycle(), this._freeObjects.push(e));
              }
            };
          }
        }
        n(71856), n(91117), n(35349);
        var u = n(52923),
          c = n.n(u);
        let d;
        d = "object" == typeof process && "object" == typeof process.versions && void 0 !== process.versions.node ? c() : function (e) {
          return "object" == typeof window ? new Promise((t, n) => {
            const r = document.createElement("script");
            r.type = "text/javascript", r.async = !0, r.onload = () => t(window.PSPDFModuleInit), r.onerror = n, r.src = e;
            const {
              documentElement: i
            } = document;
            (0, o.kG)(i), i.appendChild(r);
          }) : (self.importScripts(e), Promise.resolve(self.PSPDFModuleInit));
        };
        n(34299), n(79112), n(10983);
        var p = n(33383);
        n(74110);
        n(94161), n(98179), n(72110);
        const h = "/create.pdf";
        new Set();
        new Set();
        p.x.Maui_iOS, p.x.Maui_Android, p.x.Maui_MacCatalyst, p.x.Maui_Windows, p.x.FlutterForWeb;
        const f = async function () {
          let e,
            t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
          if (t) {
            const {
              default: t
            } = await n.e(4132).then(n.bind(n, 27425));
            e = new t();
          } else e = new Worker(new URL(n.p + n.u(4098), n.b));
          return {
            setMessageHandler(t) {
              (0, o.kG)(e, "Worker is null"), e.onmessage = t;
            },
            postMessage(t, n) {
              var r;
              null === (r = e) || void 0 === r || r.postMessage(t, n);
            },
            terminate() {
              var t;
              null === (t = e) || void 0 === t || t.terminate(), e = null;
            }
          };
        };
      },
      94161: (e, t, n) => {
        "use strict";

        n.d(t, {
          r: () => o
        });
        var r = n(15359);
        async function o(e) {
          const t = (await async function (e) {
            try {
              const t = await fetch(e).catch(t => {
                throw new r.p2(`Error fetching dynamic fonts file ${e}. ${t}`);
              });
              if (200 !== t.status) throw new r.p2(`Error fetching dynamic fonts file ${e}. Status code: ${t.status}`);
              return t;
            } catch (e) {
              throw e;
            }
          }(e)).json().catch(t => {
            throw new r.p2(`Error parsing dynamic fonts file ${e}. ${t}`);
          });
          return t;
        }
      },
      51679: (e, t, n) => {
        "use strict";

        n.d(t, {
          g: () => a
        });
        var r = n(35369),
          o = n(15359);
        function i() {
          return !0;
        }
        class a {
          constructor(e) {
            this.queue = (0, r.zN)(), this.priorityQueue = (0, r.zN)(), this.inFlightRequests = (0, r.D5)(), this.inflightRequestLimit = e, this.isDestroyed = !1;
          }
          enqueue(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            if (this.isDestroyed) return {
              promise: new Promise(() => {}),
              cancel: () => {}
            };
            let n = null,
              o = null;
            const i = new Promise((e, t) => {
                n = e, o = t;
              }),
              a = t ? this.priorityQueue : this.queue,
              s = (0, r.t8)(a, e, {
                promise: i,
                resolve: n,
                reject: o
              });
            return t ? this.priorityQueue = s : this.queue = s, t ? this.next() : setTimeout(() => this.next(), 35), {
              promise: i,
              cancel: () => this._cancel(e)
            };
          }
          _cancel(e) {
            this.queue.has(e) && (this.queue = this.queue.delete(e)), this.priorityQueue.has(e) && (this.priorityQueue = this.priorityQueue.delete(e)), this.inFlightRequests.has(e) && (this.inFlightRequests = this.inFlightRequests.delete(e));
          }
          cancelAll() {
            this.queue = (0, r.zN)(), this.priorityQueue = (0, r.zN)(), this.inFlightRequests = (0, r.D5)();
          }
          cancel(e) {
            const t = (t, n) => e(n);
            this.queue = this.queue.filter(t), this.priorityQueue = this.priorityQueue.filter(t), this.inFlightRequests = this.inFlightRequests.filter(t);
          }
          _requestFinished(e, t) {
            if (this.isDestroyed) return;
            const n = this.inFlightRequests.get(e);
            n && (n.resolve(t), this.inFlightRequests = this.inFlightRequests.delete(e)), this.next();
          }
          _requestFailed(e, t) {
            if (this.isDestroyed) return;
            const n = this.inFlightRequests.get(e);
            n && (n.reject(t), this.inFlightRequests = this.inFlightRequests.delete(e)), this.next();
          }
          next() {
            if (!(this.isDestroyed || this.inFlightRequests.size >= this.inflightRequestLimit)) {
              if (this.priorityQueue.size >= 1) {
                const e = this.priorityQueue.findLastEntry(i);
                (0, o.kG)(e);
                const [t, n] = e;
                return this.priorityQueue = this.priorityQueue.delete(t), this.inFlightRequests = this.inFlightRequests.set(t, n), void t.request().then(e => this._requestFinished(t, e)).catch(e => this._requestFailed(t, e));
              }
              if (this.queue.size >= 1) {
                const e = this.queue.findEntry(i);
                (0, o.kG)(e);
                const [t, n] = e;
                this.queue = this.queue.delete(t), this.inFlightRequests = this.inFlightRequests.set(t, n), t.request().then(e => this._requestFinished(t, e)).catch(e => this._requestFailed(t, e));
              }
            }
          }
          destroy() {
            this.isDestroyed = !0;
          }
        }
      },
      82654: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(96156);
        class o {
          constructor(e) {
            (0, r.Z)(this, "_subscriptions", new Set()), this._state = e;
          }
          getState() {
            return this._state;
          }
          setState(e) {
            this._state = "function" == typeof e ? e(this._state) : e;
            for (const e of this._subscriptions) e(this._state);
          }
          subscribe(e) {
            return this._subscriptions.add(e), () => this.unsubscribe(e);
          }
          unsubscribe(e) {
            this._subscriptions.delete(e);
          }
        }
      },
      17137: (e, t, n) => {
        "use strict";

        n.d(t, {
          T: () => i,
          Z: () => o
        });
        const r = function e(t) {
          let n;
          return n = t instanceof Error ? t : new Error(t), Object.setPrototypeOf(n, e.prototype), n;
        };
        r.prototype = Object.create(Error.prototype, {
          name: {
            value: "PSPDFKitError",
            enumerable: !1
          }
        });
        const o = r;
        function i() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return t => new r("" === e ? t : `${e}: ${t}`);
        }
      },
      73044: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        const r = e => {
          throw new Error("");
        };
      },
      14736: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => i,
          Z: () => o
        });
        const r = {
          keys: []
        };
        function o(e, t) {
          var n;
          let o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : r;
          if (o = {
            keys: null != (null === (n = o) || void 0 === n ? void 0 : n.keys) ? o.keys : r.keys
          }, Object.is(e, t)) return [];
          let i = o.keys || [];
          if (0 === i.length) {
            i = [...new Set(Object.keys(e).concat(Object.keys(t)))];
          }
          const a = i.filter(n => e[n] !== t[n]);
          return a.map(n => ({
            key: n,
            previous: e[n],
            current: t[n]
          }));
        }
        function i(e) {
          return e.map(e => {
            let {
              key: t,
              previous: n,
              current: r
            } = e;
            return `- ${t} was previously ${n}, but is now ${r}`;
          }).join("\n");
        }
      },
      6273: (e, t, n) => {
        "use strict";

        function r() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          if (2 === t.length) return i(t[0], t[1]) || null;
          const r = t.slice(1).reduce((e, t) => i(e, t), t[0]);
          return r || null;
        }
        n.d(t, {
          Z: () => r
        });
        const o = new WeakMap();
        function i(e, t) {
          if (e && t) {
            const n = o.get(e) || new WeakMap();
            o.set(e, n);
            const r = n.get(t) || (n => {
              a(e, n), a(t, n);
            });
            return n.set(t, r), r;
          }
          return e || t;
        }
        function a(e, t) {
          "function" == typeof e ? e(t) : e.current = t;
        }
      },
      38252: (e, t, n) => {
        "use strict";

        function r(e) {
          a(e);
        }
        function o(e, t, n) {
          if (n) return r(`The API ${e} has been deprecated and will be removed in the next major release. Please use ${t} instead. Please go to https://pspdfkit.com/api/web/ for more informations`);
          r(`The function ${e} was deprecated and will be removed in future version. Please use ${t} instead.`);
        }
        function i(e) {
          console.log(e);
        }
        function a() {
          console.warn(...arguments);
        }
        function s(e) {
          console.error(e);
        }
        function l() {
          console.info(...arguments);
        }
        n.d(t, {
          XV: () => o,
          ZK: () => a,
          a1: () => r,
          cM: () => i,
          um: () => l,
          vU: () => s
        });
      },
      23664: (e, t, n) => {
        "use strict";

        n.d(t, {
          GO: () => o,
          cO: () => r
        });
        const r = ["a[href]", "area[href]", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "iframe", "object", "embed", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'].join(",");
        function o(e) {
          return Array.prototype.filter.call(e.querySelectorAll(r), e => !(e.inert || e.hasAttribute("inert") || "-1" === e.getAttribute("tabindex") || !(e.offsetWidth || e.offsetHeight || e.getClientRects().length)));
        }
      },
      15359: (e, t, n) => {
        "use strict";

        n.d(t, {
          $O: () => l.Z,
          AK: () => s.Z,
          FE: () => d.Z,
          GB: () => l.G,
          H7: () => p.x,
          Ou: () => p.Z,
          PO: () => a.Z,
          Qo: () => h.Q,
          Rz: () => i.Z,
          Tr: () => o.T,
          XV: () => c.XV,
          ZK: () => c.ZK,
          a1: () => c.a1,
          cM: () => c.cM,
          kG: () => r.Z,
          lH: () => f.l,
          p2: () => o.Z,
          um: () => c.um,
          vU: () => c.vU,
          wp: () => u.w
        });
        var r = n(51984),
          o = n(17137),
          i = n(73044),
          a = n(81787),
          s = n(61904),
          l = n(14736),
          u = n(9041),
          c = n(38252),
          d = (n(51722), n(23664), n(86849), n(82654), n(6273)),
          p = n(37131),
          h = n(28413),
          f = n(86241);
        n(1184);
      },
      51984: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(17137);
        function o(e, t) {
          if (!e) throw new r.Z(`Assertion failed: ${t || "Condition not met"}\n\nFor further assistance, please go to: https://pspdfkit.com/support/request`);
        }
      },
      51722: (e, t, n) => {
        "use strict";

        function r(e) {
          return "true" === e.contentEditable || "INPUT" === e.tagName || "TEXTAREA" === e.tagName;
        }
        n.d(t, {
          c: () => r
        });
      },
      81787: (e, t, n) => {
        "use strict";

        function r(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }
        n.d(t, {
          Z: () => r
        });
      },
      61904: (e, t, n) => {
        "use strict";

        function r(e) {
          const t = new MessageChannel();
          try {
            t.port1.postMessage(e);
          } catch (e) {
            return !1;
          }
          return !0;
        }
        n.d(t, {
          Z: () => r
        });
      },
      86849: (e, t, n) => {
        "use strict";

        n.d(t, {
          AV: () => v,
          Cp: () => r,
          E$: () => l,
          MS: () => p,
          OC: () => w,
          P9: () => h,
          b8: () => i,
          bs: () => b,
          cS: () => g,
          d2: () => y,
          gs: () => m,
          gx: () => s,
          iT: () => a,
          j4: () => o,
          rw: () => f,
          tW: () => c,
          wG: () => d,
          zz: () => u
        });
        const r = 48,
          o = 70,
          i = 71,
          a = 80,
          s = 90,
          l = 13,
          u = 27,
          c = 32,
          d = 34,
          p = 33,
          h = 37,
          f = 38,
          m = 39,
          g = 40,
          v = 187,
          y = 189,
          b = 8,
          w = 9;
      },
      86241: (e, t, n) => {
        "use strict";

        function r(e) {
          return null != e;
        }
        n.d(t, {
          l: () => r
        });
      },
      9041: (e, t, n) => {
        "use strict";

        function r(e) {
          alert(e);
        }
        n.d(t, {
          w: () => r
        });
      },
      28413: (e, t, n) => {
        "use strict";

        function r(e, t) {
          if (t.caretRangeFromPoint) return t.caretRangeFromPoint(e.x, e.y);
          if ("caretPositionFromPoint" in t && "function" == typeof t.caretPositionFromPoint) {
            const n = t.caretPositionFromPoint(e.x, e.y),
              r = t.createRange();
            return r.setStart(n.offsetNode, n.offset), r.setEnd(n.offsetNode, n.offset), r;
          }
        }
        n.d(t, {
          Q: () => r
        });
      },
      1184: () => {},
      37131: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o,
          x: () => i
        });
        var r = n(51984);
        function o(e) {
          (0, r.Z)("object" == typeof e && null !== e, "instantJSON must be an Object"), (0, r.Z)("https://pspdfkit.com/instant-json/v1" === e.format, "instantJSON has an invalid format, please use 'https://pspdfkit.com/instant-json/v1");
          const {
            pdfId: t
          } = e;
          t && (0, r.Z)("object" == typeof t && null !== t && ("string" == typeof t.permanent && "string" == typeof t.changing || "string" != typeof t.permanent && "string" != typeof t.changing), "instantJSON has an invalid pdfId"), (0, r.Z)(void 0 === e.skippedPdfObjectIds || Array.isArray(e.skippedPdfObjectIds), "instantJSON has invalid skippedPdfObjectIds"), (0, r.Z)(void 0 === e.annotations || Array.isArray(e.annotations) && e.annotations.every(e => "object" == typeof e && null !== e), "instantJSON has invalid annotations"), (0, r.Z)(void 0 === e.formFieldValues || Array.isArray(e.formFieldValues) && e.formFieldValues.every(e => "object" == typeof e && null !== e), "instantJSON has invalid form field values"), (0, r.Z)(void 0 === e.skippedPdfBookmarkIds || Array.isArray(e.skippedPdfBookmarkIds), "instantJSON has invalid skippedPdfBookmarkIds"), (0, r.Z)(void 0 === e.bookmarks || Array.isArray(e.bookmarks) && e.bookmarks.every(e => "object" == typeof e && null !== e), "instantJSON has invalid bookmarks");
        }
        function i(e) {
          const t = {};
          return Object.keys(e).forEach(n => {
            Array.isArray(e[n]) ? t[n] = e[n].filter(Boolean) : "object" == typeof e[n] && null !== e[n] ? t[n] = i(e[n]) : t[n] = e[n];
          }), t;
        }
      },
      31672: (e, t, n) => {
        "use strict";

        n.d(t, {
          HJ: () => en,
          zx: () => h,
          hE: () => f,
          qe: () => yt,
          M5: () => xt,
          bK: () => Un,
          FE: () => Zt,
          D: () => no,
          F0: () => Yt,
          w6: () => Wt,
          z: () => On,
          QO: () => xn,
          u_: () => gn,
          Ex: () => Sn,
          Ee: () => Vn,
          xv: () => Tn,
          oi: () => jn,
          TX: () => ln,
          ri: () => r
        });
        var r = {};
        n.r(r), n.d(r, {
          applyStyle: () => $r,
          cssStringToObject: () => Sr,
          deserialize: () => Dr,
          escapeHtml: () => br,
          getComputedStyleAll: () => Kr,
          getInnerHTML: () => Tr,
          getLastNCharacters: () => Fr,
          getSelectedNodesColor: () => qr,
          getStyleString: () => Er,
          getText: () => kr,
          getWrapperTags: () => zr,
          isAtStartOfWordOrText: () => Mr,
          isMarkActive: () => _r,
          isRangeSelected: () => Ir,
          isSelectionUnderlined: () => Gr,
          parseHTML: () => Ar,
          prepareHTML: () => Or,
          serialize: () => Cr,
          setStyleOrToggleFormat: () => Nr,
          toHex: () => Lr,
          toggleMark: () => Pr,
          unwrapNode: () => Zr,
          wrapNode: () => Ur
        });
        var o = n(22122),
          i = n(17375),
          a = n(67294),
          s = n.t(a, 2),
          l = n(9327),
          u = n.n(l),
          c = n(37672),
          d = n.n(c);
        const p = ["className", "disabled", "inverted", "primary", "danger", "type"],
          h = e => {
            const {
                className: t,
                disabled: n,
                inverted: r,
                primary: s,
                danger: l,
                type: c
              } = e,
              h = (0, i.Z)(e, p),
              f = u()({
                [d().general]: !0,
                [d().default]: !s,
                [d().primary]: s,
                [d().danger]: l,
                [d().disabled]: n,
                [d().inverted]: !n && r
              }, t);
            return a.createElement("button", (0, o.Z)({}, h, {
              className: f,
              disabled: n,
              type: c || "button"
            }));
          },
          f = e => {
            const {
              className: t,
              children: n,
              align: r,
              style: o
            } = e;
            let i = null;
            return a.createElement("div", {
              className: u()(d().group, "start" === r && d().groupAlignStart, "end" === r && d().groupAlignEnd, t),
              style: o
            }, a.Children.map(n, e => e ? i ? (i = e, a.createElement(a.Fragment, null, a.createElement("div", {
              className: d().groupSpacer
            }), e)) : (i = e, e) : null));
          };
        function m(e) {
          if (null === e || !0 === e || !1 === e) return NaN;
          var t = Number(e);
          return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
        }
        function g(e, t) {
          if (t.length < e) throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
        }
        function v(e) {
          g(1, arguments);
          var t = Object.prototype.toString.call(e);
          return e instanceof Date || "object" == typeof e && "[object Date]" === t ? new Date(e.getTime()) : "number" == typeof e || "[object Number]" === t ? new Date(e) : ("string" != typeof e && "[object String]" !== t || "undefined" == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
        }
        function y(e, t) {
          g(2, arguments);
          var n = v(e).getTime(),
            r = m(t);
          return new Date(n + r);
        }
        function b(e) {
          var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
          return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
        }
        Math.pow(10, 8);
        function w(e) {
          g(1, arguments);
          var t = v(e);
          return !isNaN(t);
        }
        var x = {
          lessThanXSeconds: {
            one: "less than a second",
            other: "less than {{count}} seconds"
          },
          xSeconds: {
            one: "1 second",
            other: "{{count}} seconds"
          },
          halfAMinute: "half a minute",
          lessThanXMinutes: {
            one: "less than a minute",
            other: "less than {{count}} minutes"
          },
          xMinutes: {
            one: "1 minute",
            other: "{{count}} minutes"
          },
          aboutXHours: {
            one: "about 1 hour",
            other: "about {{count}} hours"
          },
          xHours: {
            one: "1 hour",
            other: "{{count}} hours"
          },
          xDays: {
            one: "1 day",
            other: "{{count}} days"
          },
          aboutXWeeks: {
            one: "about 1 week",
            other: "about {{count}} weeks"
          },
          xWeeks: {
            one: "1 week",
            other: "{{count}} weeks"
          },
          aboutXMonths: {
            one: "about 1 month",
            other: "about {{count}} months"
          },
          xMonths: {
            one: "1 month",
            other: "{{count}} months"
          },
          aboutXYears: {
            one: "about 1 year",
            other: "about {{count}} years"
          },
          xYears: {
            one: "1 year",
            other: "{{count}} years"
          },
          overXYears: {
            one: "over 1 year",
            other: "over {{count}} years"
          },
          almostXYears: {
            one: "almost 1 year",
            other: "almost {{count}} years"
          }
        };
        function D(e) {
          return function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = t.width ? String(t.width) : e.defaultWidth,
              r = e.formats[n] || e.formats[e.defaultWidth];
            return r;
          };
        }
        const C = {
          date: D({
            formats: {
              full: "EEEE, MMMM do, y",
              long: "MMMM do, y",
              medium: "MMM d, y",
              short: "MM/dd/yyyy"
            },
            defaultWidth: "full"
          }),
          time: D({
            formats: {
              full: "h:mm:ss a zzzz",
              long: "h:mm:ss a z",
              medium: "h:mm:ss a",
              short: "h:mm a"
            },
            defaultWidth: "full"
          }),
          dateTime: D({
            formats: {
              full: "{{date}} 'at' {{time}}",
              long: "{{date}} 'at' {{time}}",
              medium: "{{date}}, {{time}}",
              short: "{{date}}, {{time}}"
            },
            defaultWidth: "full"
          })
        };
        var S = {
          lastWeek: "'last' eeee 'at' p",
          yesterday: "'yesterday at' p",
          today: "'today at' p",
          tomorrow: "'tomorrow at' p",
          nextWeek: "eeee 'at' p",
          other: "P"
        };
        function E(e) {
          return function (t, n) {
            var r,
              o = n || {};
            if ("formatting" === (o.context ? String(o.context) : "standalone") && e.formattingValues) {
              var i = e.defaultFormattingWidth || e.defaultWidth,
                a = o.width ? String(o.width) : i;
              r = e.formattingValues[a] || e.formattingValues[i];
            } else {
              var s = e.defaultWidth,
                l = o.width ? String(o.width) : e.defaultWidth;
              r = e.values[l] || e.values[s];
            }
            return r[e.argumentCallback ? e.argumentCallback(t) : t];
          };
        }
        const _ = {
          ordinalNumber: function (e, t) {
            var n = Number(e),
              r = n % 100;
            if (r > 20 || r < 10) switch (r % 10) {
              case 1:
                return n + "st";
              case 2:
                return n + "nd";
              case 3:
                return n + "rd";
            }
            return n + "th";
          },
          era: E({
            values: {
              narrow: ["B", "A"],
              abbreviated: ["BC", "AD"],
              wide: ["Before Christ", "Anno Domini"]
            },
            defaultWidth: "wide"
          }),
          quarter: E({
            values: {
              narrow: ["1", "2", "3", "4"],
              abbreviated: ["Q1", "Q2", "Q3", "Q4"],
              wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
            },
            defaultWidth: "wide",
            argumentCallback: function (e) {
              return Number(e) - 1;
            }
          }),
          month: E({
            values: {
              narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
              abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
              wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
            },
            defaultWidth: "wide"
          }),
          day: E({
            values: {
              narrow: ["S", "M", "T", "W", "T", "F", "S"],
              short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
              abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
              wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
            },
            defaultWidth: "wide"
          }),
          dayPeriod: E({
            values: {
              narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              },
              abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              },
              wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "morning",
                afternoon: "afternoon",
                evening: "evening",
                night: "night"
              }
            },
            defaultWidth: "wide",
            formattingValues: {
              narrow: {
                am: "a",
                pm: "p",
                midnight: "mi",
                noon: "n",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              },
              abbreviated: {
                am: "AM",
                pm: "PM",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              },
              wide: {
                am: "a.m.",
                pm: "p.m.",
                midnight: "midnight",
                noon: "noon",
                morning: "in the morning",
                afternoon: "in the afternoon",
                evening: "in the evening",
                night: "at night"
              }
            },
            defaultFormattingWidth: "wide"
          })
        };
        function P(e) {
          return function (t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n.width,
              o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth],
              i = t.match(o);
            if (!i) return null;
            var a,
              s = i[0],
              l = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth],
              u = Array.isArray(l) ? A(l, function (e) {
                return e.test(s);
              }) : k(l, function (e) {
                return e.test(s);
              });
            a = e.valueCallback ? e.valueCallback(u) : u, a = n.valueCallback ? n.valueCallback(a) : a;
            var c = t.slice(s.length);
            return {
              value: a,
              rest: c
            };
          };
        }
        function k(e, t) {
          for (var n in e) if (e.hasOwnProperty(n) && t(e[n])) return n;
        }
        function A(e, t) {
          for (var n = 0; n < e.length; n++) if (t(e[n])) return n;
        }
        var z,
          T = {
            ordinalNumber: (z = {
              matchPattern: /^(\d+)(th|st|nd|rd)?/i,
              parsePattern: /\d+/i,
              valueCallback: function (e) {
                return parseInt(e, 10);
              }
            }, function (e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                n = e.match(z.matchPattern);
              if (!n) return null;
              var r = n[0],
                o = e.match(z.parsePattern);
              if (!o) return null;
              var i = z.valueCallback ? z.valueCallback(o[0]) : o[0];
              i = t.valueCallback ? t.valueCallback(i) : i;
              var a = e.slice(r.length);
              return {
                value: i,
                rest: a
              };
            }),
            era: P({
              matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
              },
              defaultMatchWidth: "wide",
              parsePatterns: {
                any: [/^b/i, /^(a|c)/i]
              },
              defaultParseWidth: "any"
            }),
            quarter: P({
              matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
              },
              defaultMatchWidth: "wide",
              parsePatterns: {
                any: [/1/i, /2/i, /3/i, /4/i]
              },
              defaultParseWidth: "any",
              valueCallback: function (e) {
                return e + 1;
              }
            }),
            month: P({
              matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
              },
              defaultMatchWidth: "wide",
              parsePatterns: {
                narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
                any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
              },
              defaultParseWidth: "any"
            }),
            day: P({
              matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
              },
              defaultMatchWidth: "wide",
              parsePatterns: {
                narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
                any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
              },
              defaultParseWidth: "any"
            }),
            dayPeriod: P({
              matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
              },
              defaultMatchWidth: "any",
              parsePatterns: {
                any: {
                  am: /^a/i,
                  pm: /^p/i,
                  midnight: /^mi/i,
                  noon: /^no/i,
                  morning: /morning/i,
                  afternoon: /afternoon/i,
                  evening: /evening/i,
                  night: /night/i
                }
              },
              defaultParseWidth: "any"
            })
          };
        var O = {
          code: "en-US",
          formatDistance: function (e, t, n) {
            var r;
            return n = n || {}, r = "string" == typeof x[e] ? x[e] : 1 === t ? x[e].one : x[e].other.replace("{{count}}", t), n.addSuffix ? n.comparison > 0 ? "in " + r : r + " ago" : r;
          },
          formatLong: C,
          formatRelative: function (e, t, n, r) {
            return S[e];
          },
          localize: _,
          match: T,
          options: {
            weekStartsOn: 0,
            firstWeekContainsDate: 1
          }
        };
        const I = O;
        function F(e, t) {
          g(2, arguments);
          var n = m(t);
          return y(e, -n);
        }
        function M(e, t) {
          for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t;) r = "0" + r;
          return n + r;
        }
        var R = {
          y: function (e, t) {
            var n = e.getUTCFullYear(),
              r = n > 0 ? n : 1 - n;
            return M("yy" === t ? r % 100 : r, t.length);
          },
          M: function (e, t) {
            var n = e.getUTCMonth();
            return "M" === t ? String(n + 1) : M(n + 1, 2);
          },
          d: function (e, t) {
            return M(e.getUTCDate(), t.length);
          },
          a: function (e, t) {
            var n = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
            switch (t) {
              case "a":
              case "aa":
                return n.toUpperCase();
              case "aaa":
                return n;
              case "aaaaa":
                return n[0];
              default:
                return "am" === n ? "a.m." : "p.m.";
            }
          },
          h: function (e, t) {
            return M(e.getUTCHours() % 12 || 12, t.length);
          },
          H: function (e, t) {
            return M(e.getUTCHours(), t.length);
          },
          m: function (e, t) {
            return M(e.getUTCMinutes(), t.length);
          },
          s: function (e, t) {
            return M(e.getUTCSeconds(), t.length);
          },
          S: function (e, t) {
            var n = t.length,
              r = e.getUTCMilliseconds();
            return M(Math.floor(r * Math.pow(10, n - 3)), t.length);
          }
        };
        const j = R;
        var B = 864e5;
        function N(e) {
          g(1, arguments);
          var t = 1,
            n = v(e),
            r = n.getUTCDay(),
            o = (r < t ? 7 : 0) + r - t;
          return n.setUTCDate(n.getUTCDate() - o), n.setUTCHours(0, 0, 0, 0), n;
        }
        function L(e) {
          g(1, arguments);
          var t = v(e),
            n = t.getUTCFullYear(),
            r = new Date(0);
          r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
          var o = N(r),
            i = new Date(0);
          i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
          var a = N(i);
          return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
        }
        function V(e) {
          g(1, arguments);
          var t = L(e),
            n = new Date(0);
          n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
          var r = N(n);
          return r;
        }
        var K = 6048e5;
        function q(e) {
          g(1, arguments);
          var t = v(e),
            n = N(t).getTime() - V(t).getTime();
          return Math.round(n / K) + 1;
        }
        function H(e, t) {
          g(1, arguments);
          var n = t || {},
            r = n.locale,
            o = r && r.options && r.options.weekStartsOn,
            i = null == o ? 0 : m(o),
            a = null == n.weekStartsOn ? i : m(n.weekStartsOn);
          if (!(a >= 0 && a <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
          var s = v(e),
            l = s.getUTCDay(),
            u = (l < a ? 7 : 0) + l - a;
          return s.setUTCDate(s.getUTCDate() - u), s.setUTCHours(0, 0, 0, 0), s;
        }
        function U(e, t) {
          g(1, arguments);
          var n = v(e, t),
            r = n.getUTCFullYear(),
            o = t || {},
            i = o.locale,
            a = i && i.options && i.options.firstWeekContainsDate,
            s = null == a ? 1 : m(a),
            l = null == o.firstWeekContainsDate ? s : m(o.firstWeekContainsDate);
          if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
          var u = new Date(0);
          u.setUTCFullYear(r + 1, 0, l), u.setUTCHours(0, 0, 0, 0);
          var c = H(u, t),
            d = new Date(0);
          d.setUTCFullYear(r, 0, l), d.setUTCHours(0, 0, 0, 0);
          var p = H(d, t);
          return n.getTime() >= c.getTime() ? r + 1 : n.getTime() >= p.getTime() ? r : r - 1;
        }
        function Z(e, t) {
          g(1, arguments);
          var n = t || {},
            r = n.locale,
            o = r && r.options && r.options.firstWeekContainsDate,
            i = null == o ? 1 : m(o),
            a = null == n.firstWeekContainsDate ? i : m(n.firstWeekContainsDate),
            s = U(e, t),
            l = new Date(0);
          l.setUTCFullYear(s, 0, a), l.setUTCHours(0, 0, 0, 0);
          var u = H(l, t);
          return u;
        }
        var $ = 6048e5;
        function G(e, t) {
          g(1, arguments);
          var n = v(e),
            r = H(n, t).getTime() - Z(n, t).getTime();
          return Math.round(r / $) + 1;
        }
        var W = "midnight",
          Y = "noon",
          X = "morning",
          Q = "afternoon",
          J = "evening",
          ee = "night",
          te = {
            G: function (e, t, n) {
              var r = e.getUTCFullYear() > 0 ? 1 : 0;
              switch (t) {
                case "G":
                case "GG":
                case "GGG":
                  return n.era(r, {
                    width: "abbreviated"
                  });
                case "GGGGG":
                  return n.era(r, {
                    width: "narrow"
                  });
                default:
                  return n.era(r, {
                    width: "wide"
                  });
              }
            },
            y: function (e, t, n) {
              if ("yo" === t) {
                var r = e.getUTCFullYear(),
                  o = r > 0 ? r : 1 - r;
                return n.ordinalNumber(o, {
                  unit: "year"
                });
              }
              return j.y(e, t);
            },
            Y: function (e, t, n, r) {
              var o = U(e, r),
                i = o > 0 ? o : 1 - o;
              return "YY" === t ? M(i % 100, 2) : "Yo" === t ? n.ordinalNumber(i, {
                unit: "year"
              }) : M(i, t.length);
            },
            R: function (e, t) {
              return M(L(e), t.length);
            },
            u: function (e, t) {
              return M(e.getUTCFullYear(), t.length);
            },
            Q: function (e, t, n) {
              var r = Math.ceil((e.getUTCMonth() + 1) / 3);
              switch (t) {
                case "Q":
                  return String(r);
                case "QQ":
                  return M(r, 2);
                case "Qo":
                  return n.ordinalNumber(r, {
                    unit: "quarter"
                  });
                case "QQQ":
                  return n.quarter(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "QQQQQ":
                  return n.quarter(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.quarter(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            q: function (e, t, n) {
              var r = Math.ceil((e.getUTCMonth() + 1) / 3);
              switch (t) {
                case "q":
                  return String(r);
                case "qq":
                  return M(r, 2);
                case "qo":
                  return n.ordinalNumber(r, {
                    unit: "quarter"
                  });
                case "qqq":
                  return n.quarter(r, {
                    width: "abbreviated",
                    context: "standalone"
                  });
                case "qqqqq":
                  return n.quarter(r, {
                    width: "narrow",
                    context: "standalone"
                  });
                default:
                  return n.quarter(r, {
                    width: "wide",
                    context: "standalone"
                  });
              }
            },
            M: function (e, t, n) {
              var r = e.getUTCMonth();
              switch (t) {
                case "M":
                case "MM":
                  return j.M(e, t);
                case "Mo":
                  return n.ordinalNumber(r + 1, {
                    unit: "month"
                  });
                case "MMM":
                  return n.month(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "MMMMM":
                  return n.month(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.month(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            L: function (e, t, n) {
              var r = e.getUTCMonth();
              switch (t) {
                case "L":
                  return String(r + 1);
                case "LL":
                  return M(r + 1, 2);
                case "Lo":
                  return n.ordinalNumber(r + 1, {
                    unit: "month"
                  });
                case "LLL":
                  return n.month(r, {
                    width: "abbreviated",
                    context: "standalone"
                  });
                case "LLLLL":
                  return n.month(r, {
                    width: "narrow",
                    context: "standalone"
                  });
                default:
                  return n.month(r, {
                    width: "wide",
                    context: "standalone"
                  });
              }
            },
            w: function (e, t, n, r) {
              var o = G(e, r);
              return "wo" === t ? n.ordinalNumber(o, {
                unit: "week"
              }) : M(o, t.length);
            },
            I: function (e, t, n) {
              var r = q(e);
              return "Io" === t ? n.ordinalNumber(r, {
                unit: "week"
              }) : M(r, t.length);
            },
            d: function (e, t, n) {
              return "do" === t ? n.ordinalNumber(e.getUTCDate(), {
                unit: "date"
              }) : j.d(e, t);
            },
            D: function (e, t, n) {
              var r = function (e) {
                g(1, arguments);
                var t = v(e),
                  n = t.getTime();
                t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
                var r = t.getTime(),
                  o = n - r;
                return Math.floor(o / B) + 1;
              }(e);
              return "Do" === t ? n.ordinalNumber(r, {
                unit: "dayOfYear"
              }) : M(r, t.length);
            },
            E: function (e, t, n) {
              var r = e.getUTCDay();
              switch (t) {
                case "E":
                case "EE":
                case "EEE":
                  return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "EEEEE":
                  return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "EEEEEE":
                  return n.day(r, {
                    width: "short",
                    context: "formatting"
                  });
                default:
                  return n.day(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            e: function (e, t, n, r) {
              var o = e.getUTCDay(),
                i = (o - r.weekStartsOn + 8) % 7 || 7;
              switch (t) {
                case "e":
                  return String(i);
                case "ee":
                  return M(i, 2);
                case "eo":
                  return n.ordinalNumber(i, {
                    unit: "day"
                  });
                case "eee":
                  return n.day(o, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "eeeee":
                  return n.day(o, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "eeeeee":
                  return n.day(o, {
                    width: "short",
                    context: "formatting"
                  });
                default:
                  return n.day(o, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            c: function (e, t, n, r) {
              var o = e.getUTCDay(),
                i = (o - r.weekStartsOn + 8) % 7 || 7;
              switch (t) {
                case "c":
                  return String(i);
                case "cc":
                  return M(i, t.length);
                case "co":
                  return n.ordinalNumber(i, {
                    unit: "day"
                  });
                case "ccc":
                  return n.day(o, {
                    width: "abbreviated",
                    context: "standalone"
                  });
                case "ccccc":
                  return n.day(o, {
                    width: "narrow",
                    context: "standalone"
                  });
                case "cccccc":
                  return n.day(o, {
                    width: "short",
                    context: "standalone"
                  });
                default:
                  return n.day(o, {
                    width: "wide",
                    context: "standalone"
                  });
              }
            },
            i: function (e, t, n) {
              var r = e.getUTCDay(),
                o = 0 === r ? 7 : r;
              switch (t) {
                case "i":
                  return String(o);
                case "ii":
                  return M(o, t.length);
                case "io":
                  return n.ordinalNumber(o, {
                    unit: "day"
                  });
                case "iii":
                  return n.day(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "iiiii":
                  return n.day(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "iiiiii":
                  return n.day(r, {
                    width: "short",
                    context: "formatting"
                  });
                default:
                  return n.day(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            a: function (e, t, n) {
              var r = e.getUTCHours() / 12 >= 1 ? "pm" : "am";
              switch (t) {
                case "a":
                case "aa":
                  return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "aaa":
                  return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                  }).toLowerCase();
                case "aaaaa":
                  return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            b: function (e, t, n) {
              var r,
                o = e.getUTCHours();
              switch (r = 12 === o ? Y : 0 === o ? W : o / 12 >= 1 ? "pm" : "am", t) {
                case "b":
                case "bb":
                  return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "bbb":
                  return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                  }).toLowerCase();
                case "bbbbb":
                  return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            B: function (e, t, n) {
              var r,
                o = e.getUTCHours();
              switch (r = o >= 17 ? J : o >= 12 ? Q : o >= 4 ? X : ee, t) {
                case "B":
                case "BB":
                case "BBB":
                  return n.dayPeriod(r, {
                    width: "abbreviated",
                    context: "formatting"
                  });
                case "BBBBB":
                  return n.dayPeriod(r, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(r, {
                    width: "wide",
                    context: "formatting"
                  });
              }
            },
            h: function (e, t, n) {
              if ("ho" === t) {
                var r = e.getUTCHours() % 12;
                return 0 === r && (r = 12), n.ordinalNumber(r, {
                  unit: "hour"
                });
              }
              return j.h(e, t);
            },
            H: function (e, t, n) {
              return "Ho" === t ? n.ordinalNumber(e.getUTCHours(), {
                unit: "hour"
              }) : j.H(e, t);
            },
            K: function (e, t, n) {
              var r = e.getUTCHours() % 12;
              return "Ko" === t ? n.ordinalNumber(r, {
                unit: "hour"
              }) : M(r, t.length);
            },
            k: function (e, t, n) {
              var r = e.getUTCHours();
              return 0 === r && (r = 24), "ko" === t ? n.ordinalNumber(r, {
                unit: "hour"
              }) : M(r, t.length);
            },
            m: function (e, t, n) {
              return "mo" === t ? n.ordinalNumber(e.getUTCMinutes(), {
                unit: "minute"
              }) : j.m(e, t);
            },
            s: function (e, t, n) {
              return "so" === t ? n.ordinalNumber(e.getUTCSeconds(), {
                unit: "second"
              }) : j.s(e, t);
            },
            S: function (e, t) {
              return j.S(e, t);
            },
            X: function (e, t, n, r) {
              var o = (r._originalDate || e).getTimezoneOffset();
              if (0 === o) return "Z";
              switch (t) {
                case "X":
                  return re(o);
                case "XXXX":
                case "XX":
                  return oe(o);
                default:
                  return oe(o, ":");
              }
            },
            x: function (e, t, n, r) {
              var o = (r._originalDate || e).getTimezoneOffset();
              switch (t) {
                case "x":
                  return re(o);
                case "xxxx":
                case "xx":
                  return oe(o);
                default:
                  return oe(o, ":");
              }
            },
            O: function (e, t, n, r) {
              var o = (r._originalDate || e).getTimezoneOffset();
              switch (t) {
                case "O":
                case "OO":
                case "OOO":
                  return "GMT" + ne(o, ":");
                default:
                  return "GMT" + oe(o, ":");
              }
            },
            z: function (e, t, n, r) {
              var o = (r._originalDate || e).getTimezoneOffset();
              switch (t) {
                case "z":
                case "zz":
                case "zzz":
                  return "GMT" + ne(o, ":");
                default:
                  return "GMT" + oe(o, ":");
              }
            },
            t: function (e, t, n, r) {
              var o = r._originalDate || e;
              return M(Math.floor(o.getTime() / 1e3), t.length);
            },
            T: function (e, t, n, r) {
              return M((r._originalDate || e).getTime(), t.length);
            }
          };
        function ne(e, t) {
          var n = e > 0 ? "-" : "+",
            r = Math.abs(e),
            o = Math.floor(r / 60),
            i = r % 60;
          if (0 === i) return n + String(o);
          var a = t || "";
          return n + String(o) + a + M(i, 2);
        }
        function re(e, t) {
          return e % 60 == 0 ? (e > 0 ? "-" : "+") + M(Math.abs(e) / 60, 2) : oe(e, t);
        }
        function oe(e, t) {
          var n = t || "",
            r = e > 0 ? "-" : "+",
            o = Math.abs(e);
          return r + M(Math.floor(o / 60), 2) + n + M(o % 60, 2);
        }
        const ie = te;
        function ae(e, t) {
          switch (e) {
            case "P":
              return t.date({
                width: "short"
              });
            case "PP":
              return t.date({
                width: "medium"
              });
            case "PPP":
              return t.date({
                width: "long"
              });
            default:
              return t.date({
                width: "full"
              });
          }
        }
        function se(e, t) {
          switch (e) {
            case "p":
              return t.time({
                width: "short"
              });
            case "pp":
              return t.time({
                width: "medium"
              });
            case "ppp":
              return t.time({
                width: "long"
              });
            default:
              return t.time({
                width: "full"
              });
          }
        }
        var le = {
          p: se,
          P: function (e, t) {
            var n,
              r = e.match(/(P+)(p+)?/),
              o = r[1],
              i = r[2];
            if (!i) return ae(e, t);
            switch (o) {
              case "P":
                n = t.dateTime({
                  width: "short"
                });
                break;
              case "PP":
                n = t.dateTime({
                  width: "medium"
                });
                break;
              case "PPP":
                n = t.dateTime({
                  width: "long"
                });
                break;
              default:
                n = t.dateTime({
                  width: "full"
                });
            }
            return n.replace("{{date}}", ae(o, t)).replace("{{time}}", se(i, t));
          }
        };
        const ue = le;
        var ce = ["D", "DD"],
          de = ["YY", "YYYY"];
        function pe(e) {
          return -1 !== ce.indexOf(e);
        }
        function he(e) {
          return -1 !== de.indexOf(e);
        }
        function fe(e, t, n) {
          if ("YYYY" === e) throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
          if ("YY" === e) throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://git.io/fxCyr"));
          if ("D" === e) throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
          if ("DD" === e) throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://git.io/fxCyr"));
        }
        var me = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
          ge = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
          ve = /^'([^]*?)'?$/,
          ye = /''/g,
          be = /[a-zA-Z]/;
        function we(e, t, n) {
          g(2, arguments);
          var r = String(t),
            o = n || {},
            i = o.locale || I,
            a = i.options && i.options.firstWeekContainsDate,
            s = null == a ? 1 : m(a),
            l = null == o.firstWeekContainsDate ? s : m(o.firstWeekContainsDate);
          if (!(l >= 1 && l <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
          var u = i.options && i.options.weekStartsOn,
            c = null == u ? 0 : m(u),
            d = null == o.weekStartsOn ? c : m(o.weekStartsOn);
          if (!(d >= 0 && d <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
          if (!i.localize) throw new RangeError("locale must contain localize property");
          if (!i.formatLong) throw new RangeError("locale must contain formatLong property");
          var p = v(e);
          if (!w(p)) throw new RangeError("Invalid time value");
          var h = b(p),
            f = F(p, h),
            y = {
              firstWeekContainsDate: l,
              weekStartsOn: d,
              locale: i,
              _originalDate: p
            },
            x = r.match(ge).map(function (e) {
              var t = e[0];
              return "p" === t || "P" === t ? (0, ue[t])(e, i.formatLong, y) : e;
            }).join("").match(me).map(function (n) {
              if ("''" === n) return "'";
              var r = n[0];
              if ("'" === r) return xe(n);
              var a = ie[r];
              if (a) return !o.useAdditionalWeekYearTokens && he(n) && fe(n, t, e), !o.useAdditionalDayOfYearTokens && pe(n) && fe(n, t, e), a(f, n, i.localize, y);
              if (r.match(be)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + r + "`");
              return n;
            }).join("");
          return x;
        }
        function xe(e) {
          return e.match(ve)[1].replace(ye, "'");
        }
        function De(e, t) {
          if (null == e) throw new TypeError("assign requires that input parameter not be null or undefined");
          for (var n in t = t || {}) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          return e;
        }
        function Ce(e, t, n) {
          g(2, arguments);
          var r = n || {},
            o = r.locale,
            i = o && o.options && o.options.weekStartsOn,
            a = null == i ? 0 : m(i),
            s = null == r.weekStartsOn ? a : m(r.weekStartsOn);
          if (!(s >= 0 && s <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
          var l = v(e),
            u = m(t),
            c = l.getUTCDay(),
            d = u % 7,
            p = (d + 7) % 7,
            h = (p < s ? 7 : 0) + u - c;
          return l.setUTCDate(l.getUTCDate() + h), l;
        }
        var Se = /^(1[0-2]|0?\d)/,
          Ee = /^(3[0-1]|[0-2]?\d)/,
          _e = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
          Pe = /^(5[0-3]|[0-4]?\d)/,
          ke = /^(2[0-3]|[0-1]?\d)/,
          Ae = /^(2[0-4]|[0-1]?\d)/,
          ze = /^(1[0-1]|0?\d)/,
          Te = /^(1[0-2]|0?\d)/,
          Oe = /^[0-5]?\d/,
          Ie = /^[0-5]?\d/,
          Fe = /^\d/,
          Me = /^\d{1,2}/,
          Re = /^\d{1,3}/,
          je = /^\d{1,4}/,
          Be = /^-?\d+/,
          Ne = /^-?\d/,
          Le = /^-?\d{1,2}/,
          Ve = /^-?\d{1,3}/,
          Ke = /^-?\d{1,4}/,
          qe = /^([+-])(\d{2})(\d{2})?|Z/,
          He = /^([+-])(\d{2})(\d{2})|Z/,
          Ue = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
          Ze = /^([+-])(\d{2}):(\d{2})|Z/,
          $e = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
        function Ge(e, t, n) {
          var r = t.match(e);
          if (!r) return null;
          var o = parseInt(r[0], 10);
          return {
            value: n ? n(o) : o,
            rest: t.slice(r[0].length)
          };
        }
        function We(e, t) {
          var n = t.match(e);
          return n ? "Z" === n[0] ? {
            value: 0,
            rest: t.slice(1)
          } : {
            value: ("+" === n[1] ? 1 : -1) * (36e5 * (n[2] ? parseInt(n[2], 10) : 0) + 6e4 * (n[3] ? parseInt(n[3], 10) : 0) + 1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
            rest: t.slice(n[0].length)
          } : null;
        }
        function Ye(e, t) {
          return Ge(Be, e, t);
        }
        function Xe(e, t, n) {
          switch (e) {
            case 1:
              return Ge(Fe, t, n);
            case 2:
              return Ge(Me, t, n);
            case 3:
              return Ge(Re, t, n);
            case 4:
              return Ge(je, t, n);
            default:
              return Ge(new RegExp("^\\d{1," + e + "}"), t, n);
          }
        }
        function Qe(e, t, n) {
          switch (e) {
            case 1:
              return Ge(Ne, t, n);
            case 2:
              return Ge(Le, t, n);
            case 3:
              return Ge(Ve, t, n);
            case 4:
              return Ge(Ke, t, n);
            default:
              return Ge(new RegExp("^-?\\d{1," + e + "}"), t, n);
          }
        }
        function Je(e) {
          switch (e) {
            case "morning":
              return 4;
            case "evening":
              return 17;
            case "pm":
            case "noon":
            case "afternoon":
              return 12;
            default:
              return 0;
          }
        }
        function et(e, t) {
          var n,
            r = t > 0,
            o = r ? t : 1 - t;
          if (o <= 50) n = e || 100;else {
            var i = o + 50;
            n = e + 100 * Math.floor(i / 100) - (e >= i % 100 ? 100 : 0);
          }
          return r ? n : 1 - n;
        }
        var tt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          nt = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        function rt(e) {
          return e % 400 == 0 || e % 4 == 0 && e % 100 != 0;
        }
        var ot = {
          G: {
            priority: 140,
            parse: function (e, t, n, r) {
              switch (t) {
                case "G":
                case "GG":
                case "GGG":
                  return n.era(e, {
                    width: "abbreviated"
                  }) || n.era(e, {
                    width: "narrow"
                  });
                case "GGGGG":
                  return n.era(e, {
                    width: "narrow"
                  });
                default:
                  return n.era(e, {
                    width: "wide"
                  }) || n.era(e, {
                    width: "abbreviated"
                  }) || n.era(e, {
                    width: "narrow"
                  });
              }
            },
            set: function (e, t, n, r) {
              return t.era = n, e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["R", "u", "t", "T"]
          },
          y: {
            priority: 130,
            parse: function (e, t, n, r) {
              var o = function (e) {
                return {
                  year: e,
                  isTwoDigitYear: "yy" === t
                };
              };
              switch (t) {
                case "y":
                  return Xe(4, e, o);
                case "yo":
                  return n.ordinalNumber(e, {
                    unit: "year",
                    valueCallback: o
                  });
                default:
                  return Xe(t.length, e, o);
              }
            },
            validate: function (e, t, n) {
              return t.isTwoDigitYear || t.year > 0;
            },
            set: function (e, t, n, r) {
              var o = e.getUTCFullYear();
              if (n.isTwoDigitYear) {
                var i = et(n.year, o);
                return e.setUTCFullYear(i, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
              }
              var a = "era" in t && 1 !== t.era ? 1 - n.year : n.year;
              return e.setUTCFullYear(a, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]
          },
          Y: {
            priority: 130,
            parse: function (e, t, n, r) {
              var o = function (e) {
                return {
                  year: e,
                  isTwoDigitYear: "YY" === t
                };
              };
              switch (t) {
                case "Y":
                  return Xe(4, e, o);
                case "Yo":
                  return n.ordinalNumber(e, {
                    unit: "year",
                    valueCallback: o
                  });
                default:
                  return Xe(t.length, e, o);
              }
            },
            validate: function (e, t, n) {
              return t.isTwoDigitYear || t.year > 0;
            },
            set: function (e, t, n, r) {
              var o = U(e, r);
              if (n.isTwoDigitYear) {
                var i = et(n.year, o);
                return e.setUTCFullYear(i, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), H(e, r);
              }
              var a = "era" in t && 1 !== t.era ? 1 - n.year : n.year;
              return e.setUTCFullYear(a, 0, r.firstWeekContainsDate), e.setUTCHours(0, 0, 0, 0), H(e, r);
            },
            incompatibleTokens: ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]
          },
          R: {
            priority: 130,
            parse: function (e, t, n, r) {
              return Qe("R" === t ? 4 : t.length, e);
            },
            set: function (e, t, n, r) {
              var o = new Date(0);
              return o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0), N(o);
            },
            incompatibleTokens: ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
          },
          u: {
            priority: 130,
            parse: function (e, t, n, r) {
              return Qe("u" === t ? 4 : t.length, e);
            },
            set: function (e, t, n, r) {
              return e.setUTCFullYear(n, 0, 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]
          },
          Q: {
            priority: 120,
            parse: function (e, t, n, r) {
              switch (t) {
                case "Q":
                case "QQ":
                  return Xe(t.length, e);
                case "Qo":
                  return n.ordinalNumber(e, {
                    unit: "quarter"
                  });
                case "QQQ":
                  return n.quarter(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.quarter(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "QQQQQ":
                  return n.quarter(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.quarter(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.quarter(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.quarter(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 4;
            },
            set: function (e, t, n, r) {
              return e.setUTCMonth(3 * (n - 1), 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
          },
          q: {
            priority: 120,
            parse: function (e, t, n, r) {
              switch (t) {
                case "q":
                case "qq":
                  return Xe(t.length, e);
                case "qo":
                  return n.ordinalNumber(e, {
                    unit: "quarter"
                  });
                case "qqq":
                  return n.quarter(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.quarter(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                case "qqqqq":
                  return n.quarter(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                default:
                  return n.quarter(e, {
                    width: "wide",
                    context: "standalone"
                  }) || n.quarter(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.quarter(e, {
                    width: "narrow",
                    context: "standalone"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 4;
            },
            set: function (e, t, n, r) {
              return e.setUTCMonth(3 * (n - 1), 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]
          },
          M: {
            priority: 110,
            parse: function (e, t, n, r) {
              var o = function (e) {
                return e - 1;
              };
              switch (t) {
                case "M":
                  return Ge(Se, e, o);
                case "MM":
                  return Xe(2, e, o);
                case "Mo":
                  return n.ordinalNumber(e, {
                    unit: "month",
                    valueCallback: o
                  });
                case "MMM":
                  return n.month(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.month(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "MMMMM":
                  return n.month(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.month(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.month(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.month(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 11;
            },
            set: function (e, t, n, r) {
              return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]
          },
          L: {
            priority: 110,
            parse: function (e, t, n, r) {
              var o = function (e) {
                return e - 1;
              };
              switch (t) {
                case "L":
                  return Ge(Se, e, o);
                case "LL":
                  return Xe(2, e, o);
                case "Lo":
                  return n.ordinalNumber(e, {
                    unit: "month",
                    valueCallback: o
                  });
                case "LLL":
                  return n.month(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.month(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                case "LLLLL":
                  return n.month(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                default:
                  return n.month(e, {
                    width: "wide",
                    context: "standalone"
                  }) || n.month(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.month(e, {
                    width: "narrow",
                    context: "standalone"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 11;
            },
            set: function (e, t, n, r) {
              return e.setUTCMonth(n, 1), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]
          },
          w: {
            priority: 100,
            parse: function (e, t, n, r) {
              switch (t) {
                case "w":
                  return Ge(Pe, e);
                case "wo":
                  return n.ordinalNumber(e, {
                    unit: "week"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 53;
            },
            set: function (e, t, n, r) {
              return H(function (e, t, n) {
                g(2, arguments);
                var r = v(e),
                  o = m(t),
                  i = G(r, n) - o;
                return r.setUTCDate(r.getUTCDate() - 7 * i), r;
              }(e, n, r), r);
            },
            incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]
          },
          I: {
            priority: 100,
            parse: function (e, t, n, r) {
              switch (t) {
                case "I":
                  return Ge(Pe, e);
                case "Io":
                  return n.ordinalNumber(e, {
                    unit: "week"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 53;
            },
            set: function (e, t, n, r) {
              return N(function (e, t) {
                g(2, arguments);
                var n = v(e),
                  r = m(t),
                  o = q(n) - r;
                return n.setUTCDate(n.getUTCDate() - 7 * o), n;
              }(e, n, r), r);
            },
            incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]
          },
          d: {
            priority: 90,
            subPriority: 1,
            parse: function (e, t, n, r) {
              switch (t) {
                case "d":
                  return Ge(Ee, e);
                case "do":
                  return n.ordinalNumber(e, {
                    unit: "date"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              var r = rt(e.getUTCFullYear()),
                o = e.getUTCMonth();
              return r ? t >= 1 && t <= nt[o] : t >= 1 && t <= tt[o];
            },
            set: function (e, t, n, r) {
              return e.setUTCDate(n), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]
          },
          D: {
            priority: 90,
            subPriority: 1,
            parse: function (e, t, n, r) {
              switch (t) {
                case "D":
                case "DD":
                  return Ge(_e, e);
                case "Do":
                  return n.ordinalNumber(e, {
                    unit: "date"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return rt(e.getUTCFullYear()) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
            },
            set: function (e, t, n, r) {
              return e.setUTCMonth(0, n), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]
          },
          E: {
            priority: 90,
            parse: function (e, t, n, r) {
              switch (t) {
                case "E":
                case "EE":
                case "EEE":
                  return n.day(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "EEEEE":
                  return n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "EEEEEE":
                  return n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.day(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 6;
            },
            set: function (e, t, n, r) {
              return (e = Ce(e, n, r)).setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["D", "i", "e", "c", "t", "T"]
          },
          e: {
            priority: 90,
            parse: function (e, t, n, r) {
              var o = function (e) {
                var t = 7 * Math.floor((e - 1) / 7);
                return (e + r.weekStartsOn + 6) % 7 + t;
              };
              switch (t) {
                case "e":
                case "ee":
                  return Xe(t.length, e, o);
                case "eo":
                  return n.ordinalNumber(e, {
                    unit: "day",
                    valueCallback: o
                  });
                case "eee":
                  return n.day(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "eeeee":
                  return n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "eeeeee":
                  return n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.day(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 6;
            },
            set: function (e, t, n, r) {
              return (e = Ce(e, n, r)).setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]
          },
          c: {
            priority: 90,
            parse: function (e, t, n, r) {
              var o = function (e) {
                var t = 7 * Math.floor((e - 1) / 7);
                return (e + r.weekStartsOn + 6) % 7 + t;
              };
              switch (t) {
                case "c":
                case "cc":
                  return Xe(t.length, e, o);
                case "co":
                  return n.ordinalNumber(e, {
                    unit: "day",
                    valueCallback: o
                  });
                case "ccc":
                  return n.day(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "short",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                case "ccccc":
                  return n.day(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                case "cccccc":
                  return n.day(e, {
                    width: "short",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "standalone"
                  });
                default:
                  return n.day(e, {
                    width: "wide",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "abbreviated",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "short",
                    context: "standalone"
                  }) || n.day(e, {
                    width: "narrow",
                    context: "standalone"
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 6;
            },
            set: function (e, t, n, r) {
              return (e = Ce(e, n, r)).setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]
          },
          i: {
            priority: 90,
            parse: function (e, t, n, r) {
              var o = function (e) {
                return 0 === e ? 7 : e;
              };
              switch (t) {
                case "i":
                case "ii":
                  return Xe(t.length, e);
                case "io":
                  return n.ordinalNumber(e, {
                    unit: "day"
                  });
                case "iii":
                  return n.day(e, {
                    width: "abbreviated",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting",
                    valueCallback: o
                  });
                case "iiiii":
                  return n.day(e, {
                    width: "narrow",
                    context: "formatting",
                    valueCallback: o
                  });
                case "iiiiii":
                  return n.day(e, {
                    width: "short",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting",
                    valueCallback: o
                  });
                default:
                  return n.day(e, {
                    width: "wide",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "abbreviated",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "short",
                    context: "formatting",
                    valueCallback: o
                  }) || n.day(e, {
                    width: "narrow",
                    context: "formatting",
                    valueCallback: o
                  });
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 7;
            },
            set: function (e, t, n, r) {
              return e = function (e, t) {
                g(2, arguments);
                var n = m(t);
                n % 7 == 0 && (n -= 7);
                var r = 1,
                  o = v(e),
                  i = o.getUTCDay(),
                  a = ((n % 7 + 7) % 7 < r ? 7 : 0) + n - i;
                return o.setUTCDate(o.getUTCDate() + a), o;
              }(e, n, r), e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]
          },
          a: {
            priority: 80,
            parse: function (e, t, n, r) {
              switch (t) {
                case "a":
                case "aa":
                case "aaa":
                  return n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "aaaaa":
                  return n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            set: function (e, t, n, r) {
              return e.setUTCHours(Je(n), 0, 0, 0), e;
            },
            incompatibleTokens: ["b", "B", "H", "K", "k", "t", "T"]
          },
          b: {
            priority: 80,
            parse: function (e, t, n, r) {
              switch (t) {
                case "b":
                case "bb":
                case "bbb":
                  return n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "bbbbb":
                  return n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            set: function (e, t, n, r) {
              return e.setUTCHours(Je(n), 0, 0, 0), e;
            },
            incompatibleTokens: ["a", "B", "H", "K", "k", "t", "T"]
          },
          B: {
            priority: 80,
            parse: function (e, t, n, r) {
              switch (t) {
                case "B":
                case "BB":
                case "BBB":
                  return n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                case "BBBBB":
                  return n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
                default:
                  return n.dayPeriod(e, {
                    width: "wide",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "abbreviated",
                    context: "formatting"
                  }) || n.dayPeriod(e, {
                    width: "narrow",
                    context: "formatting"
                  });
              }
            },
            set: function (e, t, n, r) {
              return e.setUTCHours(Je(n), 0, 0, 0), e;
            },
            incompatibleTokens: ["a", "b", "t", "T"]
          },
          h: {
            priority: 70,
            parse: function (e, t, n, r) {
              switch (t) {
                case "h":
                  return Ge(Te, e);
                case "ho":
                  return n.ordinalNumber(e, {
                    unit: "hour"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 12;
            },
            set: function (e, t, n, r) {
              var o = e.getUTCHours() >= 12;
              return o && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : o || 12 !== n ? e.setUTCHours(n, 0, 0, 0) : e.setUTCHours(0, 0, 0, 0), e;
            },
            incompatibleTokens: ["H", "K", "k", "t", "T"]
          },
          H: {
            priority: 70,
            parse: function (e, t, n, r) {
              switch (t) {
                case "H":
                  return Ge(ke, e);
                case "Ho":
                  return n.ordinalNumber(e, {
                    unit: "hour"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 23;
            },
            set: function (e, t, n, r) {
              return e.setUTCHours(n, 0, 0, 0), e;
            },
            incompatibleTokens: ["a", "b", "h", "K", "k", "t", "T"]
          },
          K: {
            priority: 70,
            parse: function (e, t, n, r) {
              switch (t) {
                case "K":
                  return Ge(ze, e);
                case "Ko":
                  return n.ordinalNumber(e, {
                    unit: "hour"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 11;
            },
            set: function (e, t, n, r) {
              return e.getUTCHours() >= 12 && n < 12 ? e.setUTCHours(n + 12, 0, 0, 0) : e.setUTCHours(n, 0, 0, 0), e;
            },
            incompatibleTokens: ["a", "b", "h", "H", "k", "t", "T"]
          },
          k: {
            priority: 70,
            parse: function (e, t, n, r) {
              switch (t) {
                case "k":
                  return Ge(Ae, e);
                case "ko":
                  return n.ordinalNumber(e, {
                    unit: "hour"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 1 && t <= 24;
            },
            set: function (e, t, n, r) {
              var o = n <= 24 ? n % 24 : n;
              return e.setUTCHours(o, 0, 0, 0), e;
            },
            incompatibleTokens: ["a", "b", "h", "H", "K", "t", "T"]
          },
          m: {
            priority: 60,
            parse: function (e, t, n, r) {
              switch (t) {
                case "m":
                  return Ge(Oe, e);
                case "mo":
                  return n.ordinalNumber(e, {
                    unit: "minute"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 59;
            },
            set: function (e, t, n, r) {
              return e.setUTCMinutes(n, 0, 0), e;
            },
            incompatibleTokens: ["t", "T"]
          },
          s: {
            priority: 50,
            parse: function (e, t, n, r) {
              switch (t) {
                case "s":
                  return Ge(Ie, e);
                case "so":
                  return n.ordinalNumber(e, {
                    unit: "second"
                  });
                default:
                  return Xe(t.length, e);
              }
            },
            validate: function (e, t, n) {
              return t >= 0 && t <= 59;
            },
            set: function (e, t, n, r) {
              return e.setUTCSeconds(n, 0), e;
            },
            incompatibleTokens: ["t", "T"]
          },
          S: {
            priority: 30,
            parse: function (e, t, n, r) {
              return Xe(t.length, e, function (e) {
                return Math.floor(e * Math.pow(10, 3 - t.length));
              });
            },
            set: function (e, t, n, r) {
              return e.setUTCMilliseconds(n), e;
            },
            incompatibleTokens: ["t", "T"]
          },
          X: {
            priority: 10,
            parse: function (e, t, n, r) {
              switch (t) {
                case "X":
                  return We(qe, e);
                case "XX":
                  return We(He, e);
                case "XXXX":
                  return We(Ue, e);
                case "XXXXX":
                  return We($e, e);
                default:
                  return We(Ze, e);
              }
            },
            set: function (e, t, n, r) {
              return t.timestampIsSet ? e : new Date(e.getTime() - n);
            },
            incompatibleTokens: ["t", "T", "x"]
          },
          x: {
            priority: 10,
            parse: function (e, t, n, r) {
              switch (t) {
                case "x":
                  return We(qe, e);
                case "xx":
                  return We(He, e);
                case "xxxx":
                  return We(Ue, e);
                case "xxxxx":
                  return We($e, e);
                default:
                  return We(Ze, e);
              }
            },
            set: function (e, t, n, r) {
              return t.timestampIsSet ? e : new Date(e.getTime() - n);
            },
            incompatibleTokens: ["t", "T", "X"]
          },
          t: {
            priority: 40,
            parse: function (e, t, n, r) {
              return Ye(e);
            },
            set: function (e, t, n, r) {
              return [new Date(1e3 * n), {
                timestampIsSet: !0
              }];
            },
            incompatibleTokens: "*"
          },
          T: {
            priority: 20,
            parse: function (e, t, n, r) {
              return Ye(e);
            },
            set: function (e, t, n, r) {
              return [new Date(n), {
                timestampIsSet: !0
              }];
            },
            incompatibleTokens: "*"
          }
        };
        const it = ot;
        var at = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g,
          st = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g,
          lt = /^'([^]*?)'?$/,
          ut = /''/g,
          ct = /\S/,
          dt = /[a-zA-Z]/;
        function pt(e, t, n, r) {
          g(3, arguments);
          var o = String(e),
            i = String(t),
            a = r || {},
            s = a.locale || I;
          if (!s.match) throw new RangeError("locale must contain match property");
          var l = s.options && s.options.firstWeekContainsDate,
            u = null == l ? 1 : m(l),
            c = null == a.firstWeekContainsDate ? u : m(a.firstWeekContainsDate);
          if (!(c >= 1 && c <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
          var d = s.options && s.options.weekStartsOn,
            p = null == d ? 0 : m(d),
            h = null == a.weekStartsOn ? p : m(a.weekStartsOn);
          if (!(h >= 0 && h <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
          if ("" === i) return "" === o ? v(n) : new Date(NaN);
          var f,
            y = {
              firstWeekContainsDate: c,
              weekStartsOn: h,
              locale: s
            },
            w = [{
              priority: 10,
              subPriority: -1,
              set: ht,
              index: 0
            }],
            x = i.match(st).map(function (e) {
              var t = e[0];
              return "p" === t || "P" === t ? (0, ue[t])(e, s.formatLong, y) : e;
            }).join("").match(at),
            D = [];
          for (f = 0; f < x.length; f++) {
            var C = x[f];
            !a.useAdditionalWeekYearTokens && he(C) && fe(C, i, e), !a.useAdditionalDayOfYearTokens && pe(C) && fe(C, i, e);
            var S = C[0],
              E = it[S];
            if (E) {
              var _ = E.incompatibleTokens;
              if (Array.isArray(_)) {
                for (var P = void 0, k = 0; k < D.length; k++) {
                  var A = D[k].token;
                  if (-1 !== _.indexOf(A) || A === S) {
                    P = D[k];
                    break;
                  }
                }
                if (P) throw new RangeError("The format string mustn't contain `".concat(P.fullToken, "` and `").concat(C, "` at the same time"));
              } else if ("*" === E.incompatibleTokens && D.length) throw new RangeError("The format string mustn't contain `".concat(C, "` and any other token at the same time"));
              D.push({
                token: S,
                fullToken: C
              });
              var z = E.parse(o, C, s.match, y);
              if (!z) return new Date(NaN);
              w.push({
                priority: E.priority,
                subPriority: E.subPriority || 0,
                set: E.set,
                validate: E.validate,
                value: z.value,
                index: w.length
              }), o = z.rest;
            } else {
              if (S.match(dt)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + S + "`");
              if ("''" === C ? C = "'" : "'" === S && (C = ft(C)), 0 !== o.indexOf(C)) return new Date(NaN);
              o = o.slice(C.length);
            }
          }
          if (o.length > 0 && ct.test(o)) return new Date(NaN);
          var T = w.map(function (e) {
              return e.priority;
            }).sort(function (e, t) {
              return t - e;
            }).filter(function (e, t, n) {
              return n.indexOf(e) === t;
            }).map(function (e) {
              return w.filter(function (t) {
                return t.priority === e;
              }).sort(function (e, t) {
                return t.subPriority - e.subPriority;
              });
            }).map(function (e) {
              return e[0];
            }),
            O = v(n);
          if (isNaN(O)) return new Date(NaN);
          var M = F(O, b(O)),
            R = {};
          for (f = 0; f < T.length; f++) {
            var j = T[f];
            if (j.validate && !j.validate(M, j.value, y)) return new Date(NaN);
            var B = j.set(M, R, j.value, y);
            B[0] ? (M = B[0], De(R, B[1])) : M = B;
          }
          return M;
        }
        function ht(e, t) {
          if (t.timestampIsSet) return e;
          var n = new Date(0);
          return n.setFullYear(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate()), n.setHours(e.getUTCHours(), e.getUTCMinutes(), e.getUTCSeconds(), e.getUTCMilliseconds()), n;
        }
        function ft(e) {
          return e.match(lt)[1].replace(ut, "'");
        }
        var mt = n(7232),
          gt = n.n(mt),
          vt = n(98179);
        const yt = a.forwardRef((e, t) => {
          const [n, r] = a.useState(),
            [o, i] = a.useState(),
            s = a.useCallback(e => {
              r(e);
            }, []),
            l = a.useCallback(e => {
              i(e);
            }, []);
          a.useEffect(() => {
            n && o && o.value !== n.value && (o.value = n.value);
          }, [n, o]);
          const [c, d] = a.useState(!1);
          a.useImperativeHandle(t, () => n, [n]);
          const p = e.format.split("").map(e => {
              switch (e) {
                case "m":
                  return "M";
                case "M":
                  return "m";
              }
              return e;
            }).join(""),
            h = vt.i7 || vt.TL || "date" === e.type,
            f = t => {
              if (!n) return;
              const r = n.ownerDocument.activeElement;
              var i;
              r !== n && r !== o && (null === (i = e.onBlur) || void 0 === i || i.call(e, t), d(!1));
            },
            m = t => {
              var n;
              c || null === (n = e.onFocus) || void 0 === n || n.call(e, t);
              d(!0);
            },
            g = () => {
              switch (e.type) {
                case "date":
                  return "yyyy-MM-dd";
                case "time":
                  return "HH:mm";
                case "datetime-local":
                  return "yyyy-MM-dd'T'HH:mm";
              }
            },
            v = u()({
              [gt().picker]: !0,
              [gt().firefoxDatePicker]: vt.vU
            });
          return a.createElement("div", {
            className: gt().wrapper
          }, a.createElement("input", {
            "data-testid": "input",
            ref: s,
            name: e.name,
            value: e.value,
            style: e.style,
            className: u()(gt().input, e.className, "PSPDFKit-Annotation-Widget-Date-Input"),
            type: "text",
            disabled: e.disabled,
            maxLength: e.maxLength,
            placeholder: e.format,
            required: e.required,
            onChange: t => {
              if (n) {
                var r;
                const i = pt(n.value, p, new Date());
                !0 === w(i) && o && (o.value = we(i, g())), null === (r = e.onChange) || void 0 === r || r.call(e, t);
              }
            },
            onBlur: f,
            onFocus: m
          }), h ? a.createElement("div", {
            style: {
              opacity: c ? 1 : 0
            },
            className: gt().pickerWidget
          }, a.createElement("input", {
            "data-testid": "picker",
            ref: l,
            className: v,
            type: e.type,
            onChange: t => {
              if (n && o) {
                var r;
                if ("" === o.value) n.value = "";else {
                  const e = pt(o.value, g(), new Date());
                  w(e) && o && (n.value = we(e, p));
                }
                null === (r = e.onChange) || void 0 === r || r.call(e, t);
              }
            },
            onBlur: f,
            onFocus: m,
            disabled: e.disabled
          })) : null);
        });
        yt.defaultProps = {};
        var bt = n(19290),
          wt = n.n(bt);
        function xt(e) {
          let {
            children: t,
            className: n
          } = e;
          return a.createElement("div", {
            className: u()(wt().center, n)
          }, t);
        }
        var Dt = n(96156),
          Ct = n(2245),
          St = n(36623),
          Et = n(35369),
          _t = n(67366),
          Pt = n(81454),
          kt = n.n(Pt);
        const At = e => {
            const {
                onDragOver: t
              } = e,
              [, n] = (0, Ct.c0)({
                type: zt,
                item: () => (e.onDragStart && e.onDragStart(e.index), {
                  id: e.index,
                  type: zt
                }),
                canDrag: () => e.draggable || !1,
                end: () => {
                  e.onDragEnd && e.onDragEnd();
                }
              }),
              [, r] = (0, Ct.LW)({
                accept: zt,
                hover: (n, r) => {
                  t && t(e.index, r.getClientOffset());
                }
              });
            return a.createElement("div", {
              "data-id": e.index,
              ref: r
            }, a.createElement("div", {
              ref: n,
              className: kt().item
            }, a.createElement("div", {
              className: kt().content
            }, e.children)));
          },
          zt = "ITEM",
          Tt = e => {
            const {
                renderItem: t,
                containerOffset: n
              } = e,
              {
                item: r,
                isDragging: o,
                currentOffset: i
              } = (0, Ct.f$)(e => ({
                item: e.getItem(),
                currentOffset: e.getSourceClientOffset(),
                isDragging: e.isDragging()
              })),
              s = a.useMemo(() => o ? a.createElement(At, {
                index: r.id
              }, t(r.id)) : null, [o, r, t]);
            if (!o || !i) return null;
            const {
                x: l,
                y: u
              } = i,
              c = {
                transform: `translate(${l - n.left}px, ${u - n.top}px)`
              };
            return a.createElement("div", {
              className: kt().dragPreview
            }, a.createElement("div", {
              style: c
            }, s));
          };
        var Ot = n(67057);
        function It(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ft(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? It(Object(n), !0).forEach(function (t) {
              (0, Dt.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : It(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Mt = e => {
            const {
                scrollY: t = 0,
                onViewportChange: n,
                initialForcedScrollY: r
              } = e,
              [o, i] = a.useState(null),
              [s, l] = a.useState({
                height: 0,
                width: 0,
                scrollY: 0
              }),
              u = a.useRef(null),
              c = a.useRef(null),
              d = a.useRef(0);
            a.useLayoutEffect(() => {
              o && (o.scrollTop = t);
            }, [o, t]), a.useLayoutEffect(() => {
              o && "number" == typeof r && (o.scrollTop = r);
            }, [o, r]);
            const {
                currentOffset: p,
                isDragging: h
              } = (0, Ct.f$)(e => ({
                isDragging: e.isDragging(),
                currentOffset: e.getClientOffset()
              })),
              f = a.useCallback(() => {
                const {
                    clientWidth: e = 0,
                    clientHeight: t = 0
                  } = o || {},
                  n = e || 0,
                  r = t || 0;
                n === s.width && r === s.height || l(Ft(Ft({}, s), {}, {
                  width: n || 0,
                  height: r || 0
                }));
              }, [o, s]),
              m = a.useCallback(e => {
                const t = e.currentTarget.scrollTop,
                  n = Ft(Ft({}, s), {}, {
                    scrollY: t
                  });
                s.scrollY !== t && l(n);
              }, [s]);
            a.useLayoutEffect(() => {
              n(s);
            }, [n, s]), a.useEffect(() => {
              u.current = null == o ? void 0 : o.getBoundingClientRect(), f();
            }, [o, f]);
            const g = a.useCallback(() => {
                clearInterval(c.current), c.current = null;
              }, []),
              v = a.useCallback(e => {
                g(), o && d.current !== e && (g(), c.current = setInterval(() => {
                  o.scrollBy(0, e);
                }, Lt), d.current = e);
              }, [o, g]);
            a.useEffect(() => {
              if (!u.current || !p) return void g();
              const {
                  height: e
                } = u.current,
                t = p.y < Rt,
                n = p.y > e - Rt,
                r = p.y,
                o = e - p.y,
                i = jt + (Rt - (t ? r : o)) / Rt * (Bt - jt);
              !c.current || t || n ? t ? v(-Nt * i) : n && v(Nt * i) : g();
            }, [p, v, g]);
            const y = {
                position: "relative",
                width: "100%",
                height: "100%",
                overflowX: "hidden",
                overflowY: h && (0, vt.b1)() ? "hidden" : "scroll"
              },
              b = a.useRef(null);
            return a.useEffect(() => {
              var e;
              b.current && (null === (e = b.current) || void 0 === e || e.focus({
                preventScroll: !0
              }));
            }), a.createElement("div", {
              "data-testid": "scroll",
              ref: e => i(e),
              style: y,
              onScroll: m
            }, a.createElement(Ot.Z, {
              onResize: f
            }), o ? e.renderContent(s, b) : null);
          },
          Rt = 50,
          jt = .5,
          Bt = 1,
          Nt = 10,
          Lt = 1;
        var Vt = n(15359);
        class Kt {
          constructor(e, t, n) {
            let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
              o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
            (0, Dt.Z)(this, "itemWidth", 0), (0, Dt.Z)(this, "itemHeight", 0), (0, Dt.Z)(this, "itemPaddingLeft", 0), (0, Dt.Z)(this, "itemPaddingRight", 0), (0, Dt.Z)(this, "totalItems", 0), (0, Vt.kG)(e > 0, "You must provide an item width of greater than 0"), (0, Vt.kG)(t > 0, "You must provide an item height of greater than 0"), (0, Vt.kG)(r >= 0, "Padding must be greater than 0"), (0, Vt.kG)(o >= 0, "Padding must be greater than 0"), this.itemWidth = e, this.itemHeight = t, this.totalItems = n, this.itemPaddingLeft = r, this.itemPaddingRight = o;
          }
          contentHeight(e) {
            const t = this.itemsPerRow(e);
            return Math.ceil(this.totalItems / t) * this.itemHeight;
          }
          itemsPerRow(e) {
            return Math.max(Math.floor(e.width / this.itemWidth), 1);
          }
          layoutAttributesForItemsIn(e) {
            const {
                scrollY: t,
                height: n
              } = e,
              r = this.itemsPerRow(e),
              o = Math.ceil(this.totalItems / r),
              i = t ? Math.floor(t / this.itemHeight) : 0,
              a = Math.ceil(n / this.itemHeight),
              s = Math.max(i - qt, 0),
              l = Math.min(i + a + qt, o),
              u = [];
            for (let t = s * r; t < l * r; t++) u.push(this.layoutAttributeForItemAt(e, t));
            return u;
          }
          layoutAttributeForItemAt(e, t) {
            const {
                width: n
              } = e,
              r = this.itemsPerRow(e),
              o = r * this.itemWidth,
              i = Math.max((n - o) / (r + 1), 0),
              a = Math.floor(t / r);
            return {
              index: t,
              left: (this.itemWidth + i) * (t % r) + i,
              top: this.itemHeight * a,
              width: this.itemWidth,
              height: this.itemHeight
            };
          }
          layoutAttributeForInsertionCursor(e, t, n) {
            const r = this.itemsPerRow(e),
              o = r + 1,
              i = Math.floor((t || n) / r),
              a = (n + i) % o,
              s = this.itemWidth * r,
              l = (e.width - s) / o,
              u = a === r;
            let c = (l + this.itemWidth) * a;
            return 0 === a ? c += this.itemPaddingLeft : u && (c -= this.itemPaddingRight), {
              index: n,
              left: c,
              top: this.itemHeight * i,
              width: l,
              height: this.itemHeight,
              atRowEnd: u
            };
          }
        }
        const qt = 2;
        function Ht(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ut(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ht(Object(n), !0).forEach(function (t) {
              (0, Dt.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ht(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Zt = e => {
          var t;
          const {
              draggingEnabled: n = !1,
              totalItems: r,
              itemHeight: o,
              itemWidth: i,
              itemPaddingLeft: s,
              itemPaddingRight: l,
              selectedItemIndexes: u = (0, Et.l4)(),
              canInsert: c,
              renderDragPreview: d,
              renderInsertionCursor: p,
              focusedItemIndex: h,
              containerOffset: f,
              gridContainerEl: m
            } = e,
            [g, v] = a.useState(null),
            y = a.useRef(null),
            b = a.useRef(null),
            w = a.useRef(null),
            [x, D] = a.useState((0, Et.l4)([])),
            C = new Kt(i, o, r, s, l),
            [S, E] = a.useState(0),
            _ = (0, _t.v9)(e => e.shadowRoot);
          a.useLayoutEffect(() => {
            0 !== u.size && (e => {
              const t = b.current;
              if (0 === e.size) return;
              if (!t) return;
              const n = t.height + t.scrollY,
                r = e => {
                  const r = e.top + e.height / 2;
                  return r > t.scrollY && r < n;
                };
              let o = C.layoutAttributesForItemsIn(t);
              o = o.filter(t => e.has(t.index));
              if (o.filter(r).length > 0) return;
              let i = o.filter(e => !r(e));
              0 === i.length && (i = e.map(e => C.layoutAttributeForItemAt(t, e)).toArray()), i = i.sort((e, t) => e.index - t.index);
              const a = i[0];
              b.current = Ut(Ut({}, t), {}, {
                scrollY: a.top
              }), E(a.top);
            })(u);
          }, [u]);
          const P = e => {
              e.preventDefault();
            },
            k = e => u.has(e) || !1,
            A = () => {
              y.current = null, w.current = null, D((0, Et.l4)([]));
            },
            z = (0, a.useCallback)((e, t) => {
              if (!m) return y.current = null, void (w.current = null);
              const n = null == _ ? void 0 : _.elementsFromPoint(e, t),
                r = null == n ? void 0 : n.find(e => m.contains(e));
              if (r) {
                const t = r.closest("[data-page-index]") || r,
                  n = t.getAttribute("data-page-index");
                if ("string" == typeof n) {
                  const r = parseInt(n, 10),
                    o = t.getBoundingClientRect();
                  y.current = {
                    index: r,
                    bounds: o
                  };
                  const i = o.left + o.width / 2;
                  w.current = e < i ? r : r + 1;
                }
              } else y.current = null, w.current = null;
            }, [_, m]),
            T = a.useCallback((e, t) => {
              if (!n) return;
              const o = y.current;
              if (g && t) if (null === o || o.index !== e) {
                const t = g.querySelector(`[data-id="${e}"]`),
                  n = null == t ? void 0 : t.getBoundingClientRect();
                if (!n) return void (y.current = null);
                y.current = {
                  index: e,
                  bounds: n
                };
              } else {
                const n = o.bounds.left + o.bounds.width / 2,
                  i = t.x < n ? e : e + 1;
                w.current = Math.min(i, r);
              }
            }, [y, g, r, n]),
            O = e => {
              if (!n) return;
              const t = k(e);
              D(t ? (0, Et.l4)(u) : (0, Et.l4)([e]));
            },
            I = () => {
              if (!n) return;
              const t = w.current;
              if (null !== t) {
                const n = Array.from(x);
                if (x.has(t)) return void F();
                e.onDragEnd && e.onDragEnd(n, t);
              }
              A();
            },
            F = () => {
              requestAnimationFrame(() => A());
            },
            M = t => {
              if (d) return d(t, Array.from(x));
              {
                const n = {
                  selected: !1,
                  dragging: !1
                };
                return e.renderItem(t, n);
              }
            },
            R = e => {
              b.current = e;
            },
            j = (t, n) => {
              if (!p) return null;
              const r = null !== w.current ? w.current : e.insertionIndex;
              if (null == r) return;
              const o = t.layoutAttributeForInsertionCursor(n, y.current ? y.current.index : null, r),
                i = {
                  position: "absolute",
                  width: o.width,
                  height: o.height,
                  left: o.left,
                  top: o.top,
                  zIndex: 100
                },
                s = (e => !c || c(x.isEmpty() && u ? Array.from(u) : Array.from(x), e))(o.index);
              return a.createElement("div", {
                style: i
              }, p(s, !!o.atRowEnd));
            },
            B = (t, s) => {
              const l = C.layoutAttributesForItemsIn(t);
              let u = !1;
              if (l.length > 0) {
                const e = l[0].index,
                  t = l[l.length - 1].index;
                u = null != h && (h < e || h > t);
              }
              const c = l.map((t, c) => {
                  const {
                      index: d
                    } = t,
                    p = {
                      position: "absolute",
                      left: t.left,
                      top: t.top,
                      width: t.width,
                      height: t.height
                    },
                    h = c === Math.floor(l.length / 2) && u;
                  return a.createElement("div", {
                    key: e.itemKey ? e.itemKey(d) : d,
                    style: p
                  }, ((t, s) => {
                    const l = {
                        selected: k(t),
                        dragging: x.has(t),
                        itemRef: s
                      },
                      u = !(t < r);
                    return a.createElement(At, {
                      index: t,
                      draggable: n && !u,
                      onDragStart: O,
                      onDragOver: T,
                      onDragEnd: I
                    }, u ? a.createElement("div", {
                      style: {
                        width: i,
                        height: o
                      }
                    }) : e.renderItem(t, l));
                  })(d, h ? s : void 0));
                }),
                d = {
                  height: C.contentHeight(t),
                  width: "100%"
                };
              return a.createElement("div", {
                style: d
              }, j(C, t), c);
            };
          return a.createElement("div", {
            ref: e => v(e)
          }, (() => {
            var r;
            if (!g) return null;
            const o = g.ownerDocument,
              i = {
                enableMouseEvents: !0,
                delayTouchStart: 500,
                touchSlop: 10,
                ignoreContextMenu: !0,
                ownerDocument: (null == _ ? void 0 : _.ownerDocument) || o,
                getDropTargetElementsAtPoint: _ && n ? z : void 0
              },
              s = {
                width: e.width,
                height: e.height
              };
            return a.createElement(Ct.WG, {
              backend: St.TouchBackend,
              options: i
            }, a.createElement("div", {
              className: kt().container,
              onContextMenu: P,
              style: s
            }, n && (t || (t = a.createElement(Tt, {
              renderItem: M,
              containerOffset: f
            }))), a.createElement(Mt, {
              onViewportChange: R,
              renderContent: B,
              scrollY: (null === (r = b.current) || void 0 === r ? void 0 : r.scrollY) || 0,
              initialForcedScrollY: S
            })));
          })());
        };
        var $t = n(7764),
          Gt = n.n($t);
        const Wt = e => {
          const {
              children: t,
              onPress: n,
              expanded: r,
              ariaControls: o,
              className: i,
              headingRef: s
            } = e,
            l = e.headingTag;
          return a.createElement(l, {
            className: u()("PSPDFKit-Expando-Control", Gt().control, i),
            ref: s
          }, a.createElement("button", {
            className: Gt().controlButton,
            "aria-expanded": o ? r : void 0,
            "aria-controls": o,
            onClick: n,
            autoFocus: e.autoFocus
          }, t));
        };
        Wt.defaultProps = {
          headingTag: "div"
        };
        const Yt = e => {
          const {
            children: t,
            expanded: n,
            id: r
          } = e;
          return a.createElement("div", {
            id: r,
            className: u()("PSPDFKit-Expando-Content", !n && Gt().contentHidden, !n && "PSPDFKit-Expando-Content-Hidden")
          }, t);
        };
        var Xt = n(51722),
          Qt = n(86849),
          Jt = n(23664);
        class en extends a.Component {
          constructor() {
            super(...arguments), (0, Dt.Z)(this, "rootRef", a.createRef()), (0, Dt.Z)(this, "activeItem", a.createRef()), (0, Dt.Z)(this, "state", {
              activeItemIndex: 0,
              focusReason: "initial"
            }), (0, Dt.Z)(this, "didSetActiveItem", !1), (0, Dt.Z)(this, "onActiveItemIndexChange", () => {
              this.props.onActiveItemIndexChange && this.props.onActiveItemIndexChange(this.state.activeItemIndex);
            }), (0, Dt.Z)(this, "onKeyDown", e => {
              var t;
              const {
                ignoreOnKeyPress: n
              } = this.props;
              if ("function" == typeof n ? n(e) : e.altKey || e.shiftKey) return;
              const r = null === (t = e.currentTarget.ownerDocument.defaultView) || void 0 === t ? void 0 : t.HTMLElement;
              if (!(e.target instanceof r) || (0, Xt.c)(e.target)) return;
              const {
                  activeItemIndex: o
                } = this.state,
                i = e.ctrlKey || e.metaKey;
              if (e.which === this.props.prevKey && o > 0 && this.setState({
                activeItemIndex: i ? 0 : o - 1,
                focusReason: "keyboard"
              }, this.onActiveItemIndexChange), e.which === this.props.nextKey) {
                const e = this.props.items.length - 1;
                o < e && this.setState({
                  activeItemIndex: i ? e : o + 1,
                  focusReason: "keyboard"
                }, this.onActiveItemIndexChange);
              }
            }), (0, Dt.Z)(this, "onFocus", e => {
              const t = e.target !== e.currentTarget;
              let n = this.state.activeItemIndex;
              const r = e.currentTarget,
                o = r && r.parentNode && r.parentNode.children ? Array.prototype.findIndex.call(r.parentNode.children, e => e === r) : -1;
              -1 !== o && (n = o), this.setState({
                activeItemIndex: n,
                focusReason: t ? "focus_within" : "focus"
              }, this.onActiveItemIndexChange);
            });
          }
          setActiveItem(e) {
            this.didSetActiveItem = !0, this.setState({
              activeItemIndex: e,
              focusReason: "focus"
            });
          }
          getActiveItem() {
            return this.state.activeItemIndex;
          }
          componentDidMount() {
            tn(this.rootRef.current, this.activeItem.current), this.onActiveItemIndexChange();
          }
          componentDidUpdate(e, t) {
            (this.didSetActiveItem || e.items.length !== this.props.items.length || t.activeItemIndex !== this.state.activeItemIndex) && (this.didSetActiveItem = !1, tn(this.rootRef.current, this.activeItem.current), "focus_within" !== this.state.focusReason && function (e) {
              if (!e) return;
              const t = e.children,
                n = t[0],
                r = n.matches || n.msMatchesSelector;
              1 === t.length && r.call(n, Jt.cO) ? (e.removeAttribute("tabindex"), n.focus()) : e.focus();
            }(this.activeItem.current));
          }
          render() {
            if ("function" == typeof this.props.children) {
              let e = !1,
                t = !1;
              const n = this.props.children({
                activeItemIndex: this.state.activeItemIndex,
                getContainerProps: () => (e = !0, {
                  onKeyDown: this.onKeyDown,
                  ref: this.rootRef
                }),
                getItemProps: e => {
                  let {
                    item: n
                  } = e;
                  (0, Vt.kG)(n, "getItemProps must be called with `{ item }`");
                  const r = this.props.items.findIndex(e => e === n);
                  (0, Vt.kG)(r > -1, "getItemPropsL: Cannot find `item` in `props.items`");
                  const o = r === this.state.activeItemIndex;
                  return t = !0, {
                    tabIndex: o ? 0 : -1,
                    ref: o ? this.activeItem : void 0,
                    onFocus: this.onFocus,
                    onClick: e => {
                      e.target.closest(Jt.cO) || this.setState({
                        activeItemIndex: r,
                        focusReason: "focus"
                      }, this.onActiveItemIndexChange);
                    }
                  };
                }
              });
              return (0, Vt.kG)(n, "Did not return valid children"), (0, Vt.kG)(e, "Did not call getContainerProps"), (0, Vt.kG)(t, "Did not call getItemProps"), n;
            }
            return a.createElement("div", {
              onKeyDown: this.onKeyDown,
              ref: this.rootRef,
              "data-testid": "accessible-collection"
            }, this.props.items.map((e, t) => {
              const n = t === this.state.activeItemIndex;
              return a.createElement("div", {
                key: t,
                tabIndex: n ? 0 : -1,
                ref: n ? this.activeItem : void 0,
                onFocus: this.onFocus,
                onClick: e => {
                  e.target.closest(Jt.cO) || this.setState({
                    activeItemIndex: t,
                    focusReason: "focus"
                  }, this.onActiveItemIndexChange);
                }
              }, e);
            }));
          }
        }
        function tn(e, t) {
          if (!e || !t) return;
          (0, Jt.GO)(e).forEach(t => {
            t.parentNode !== e && t.setAttribute("tabindex", "-1");
          }), Array.prototype.forEach.call(t.querySelectorAll('[tabindex="-1"]'), e => {
            e.removeAttribute("tabindex");
          });
        }
        (0, Dt.Z)(en, "defaultProps", {
          prevKey: Qt.rw,
          nextKey: Qt.cS,
          ignoreOnKeyPress: null
        });
        var nn = n(67665),
          rn = n(19575),
          on = n(42164),
          an = n.n(on);
        const sn = ["className", "tag", "announce"],
          ln = a.forwardRef(function (e, t) {
            const {
                className: n,
                tag: r,
                announce: s
              } = e,
              l = (0, i.Z)(e, sn),
              c = s ? {
                role: "status",
                "aria-live": s
              } : {};
            return a.createElement(r || "p", (0, o.Z)({}, l, {
              ref: t,
              className: u()(an().visuallyHidden, n)
            }, c));
          });
        class un extends a.Component {
          constructor() {
            super(...arguments), (0, Dt.Z)(this, "_handleRef", e => {
              this._el = e, this._document = e ? e.ownerDocument : null;
            }), (0, Dt.Z)(this, "_handleKeyDown", e => {
              const t = this._el,
                n = this._document;
              if (e.keyCode === Qt.OC && t && n) {
                const r = (0, Jt.GO)(t),
                  o = r.indexOf(n.activeElement);
                e.shiftKey && 0 === o ? (r[r.length - 1].focus(), e.preventDefault()) : e.shiftKey || o !== r.length - 1 || (r[0].focus(), e.preventDefault());
              }
            });
          }
          componentDidMount() {
            this._document && this._document.addEventListener("keydown", this._handleKeyDown), document.addEventListener("keydown", this._handleKeyDown);
            const e = this._el;
            if (e && !e.querySelector('[autofocus]:not([autofocus="false"])')) {
              const t = (0, Jt.GO)(e)[0] || e.querySelector('[tabindex="-1"]');
              t && t.focus();
            }
          }
          componentWillUnmount() {
            this._document && this._document.removeEventListener("keydown", this._handleKeyDown), document.removeEventListener("keydown", this._handleKeyDown);
          }
          render() {
            return a.createElement("div", {
              ref: this._handleRef
            }, this.props.children);
          }
        }
        var cn = n(35840),
          dn = n.n(cn);
        const pn = ["children", "className", "spaced"],
          hn = ["className", "spaced"],
          fn = [];
        function mn() {
          const e = fn.length - 1;
          fn.forEach((t, n) => {
            t.setState({
              isOnTop: n == e
            });
          });
        }
        class gn extends a.Component {
          constructor() {
            super(...arguments), (0, Dt.Z)(this, "descriptionId", this.props.accessibilityDescription ? `modal-description-${rn.Base64.encode(this.props.accessibilityDescription).substr(0, 10)}` : null), (0, Dt.Z)(this, "restoreOnCloseElement", this.props.restoreOnCloseElement), (0, Dt.Z)(this, "useBorderRadius", !1 !== this.props.useBorderRadius), (0, Dt.Z)(this, "state", {
              isShaking: !1,
              isOnTop: !0
            }), (0, Dt.Z)(this, "_preventPropagation", e => {
              e.stopPropagation(), e.nativeEvent && e.nativeEvent.stopImmediatePropagation();
            }), (0, Dt.Z)(this, "_handleClick", () => {
              this.props.onDismiss && this.props.onDismiss();
            }), (0, Dt.Z)(this, "onMount", e => {
              0 === fn.length && e.setAttribute("aria-hidden", "true"), fn.push(this), mn();
            }), (0, Dt.Z)(this, "onUnmount", e => {
              fn.pop(), 0 === fn.length && e.removeAttribute("aria-hidden"), mn(), this.restoreOnCloseElement && this.restoreOnCloseElement.focus();
            }), (0, Dt.Z)(this, "_handleKeyDown", e => {
              e.keyCode !== Qt.E$ && e.keyCode !== Qt.tW || e.nativeEvent.stopImmediatePropagation(), this.props.onEscape && e.keyCode === Qt.zz && (this.props.onEscape(), e.preventDefault(), e.target.ownerDocument.addEventListener("keyup", this._preventPropagation, {
                capture: !0,
                once: !0
              })), this.props.onEnter && e.keyCode === Qt.E$ && (this.props.onEnter(), e.preventDefault());
            }), (0, Dt.Z)(this, "_handleAnimationEnd", () => {
              this.setState({
                isShaking: !1
              });
            });
          }
          shake() {
            this.setState({
              isShaking: !0
            });
          }
          componentDidMount() {
            this.props.innerRef && (this.props.innerRef.current = this);
          }
          componentWillUnmount() {
            this.props.innerRef && (this.props.innerRef.current = null);
          }
          render() {
            var e, t;
            const {
                isShaking: n,
                isOnTop: r
              } = this.state,
              {
                className: o,
                backdropFixed: i,
                visibleDimensions: s
              } = this.props,
              l = r ? un : a.Fragment,
              c = i && s ? {
                position: "absolute",
                left: s.width / 2,
                top: s.height / 2,
                transform: "translate(-50%, -50%)"
              } : {};
            return a.createElement(nn.m, {
              onMount: this.onMount,
              onUnmount: this.onUnmount
            }, a.createElement("div", {
              "aria-hidden": !r
            }, a.createElement(l, null, a.createElement("div", {
              className: u()(dn().backdropContainer, "PSPDFKit-Modal-Backdrop", i && dn().backdropFixed),
              onClick: this._handleClick,
              onKeyDown: r ? this._handleKeyDown : void 0
            }, a.createElement("div", {
              role: this.props.role,
              "aria-label": this.props.accessibilityLabel,
              "aria-describedby": this.props.accessibilityDescription && null !== (e = this.descriptionId) && void 0 !== e ? e : void 0,
              className: u()(dn().dialog, o, "PSPDFKit-Modal-Dialog", {
                [dn().shaking]: n,
                [dn().squareCorners]: !this.useBorderRadius
              }),
              onTouchEndCapture: this._preventPropagation,
              onMouseUpCapture: this._preventPropagation,
              onPointerUpCapture: this._preventPropagation,
              onKeyUpCapture: this._preventPropagation,
              onAnimationEnd: this._handleAnimationEnd,
              tabIndex: -1,
              style: c
            }, this.props.children, this.props.accessibilityDescription && a.createElement(ln, {
              id: null !== (t = this.descriptionId) && void 0 !== t ? t : void 0
            }, this.props.accessibilityDescription))))));
          }
        }
        function vn(e) {
          const {
              children: t,
              className: n,
              spaced: r
            } = e,
            s = (0, i.Z)(e, pn),
            l = u()(dn().section, r && dn().sectionSpaced, r && "PSPDFKit-Modal-Section-Spaced", n, "PSPDFKit-Modal-Section");
          return a.createElement("div", (0, o.Z)({}, s, {
            className: l
          }), t);
        }
        function yn(e) {
          const {
              className: t,
              spaced: n
            } = e,
            r = (0, i.Z)(e, hn),
            s = u()(dn().divider, n && dn().dividerSpaced, n && "PSPDFKit-Modal-Divider-Spaced", t, "PSPDFKit-Modal-Divider");
          return a.createElement("div", (0, o.Z)({}, r, {
            className: s
          }));
        }
        (0, Dt.Z)(gn, "Section", vn), (0, Dt.Z)(gn, "Divider", yn), (0, Dt.Z)(gn, "defaultProps", {
          role: "dialog"
        }), vn.displayName = "Modal.Section", vn.defaultProps = {
          spaced: !1
        }, yn.displayName = "Modal.Divider", yn.defaultProps = {
          spaced: !0
        };
        var bn = n(90315),
          wn = n.n(bn);
        const xn = a.forwardRef(function (e, t) {
          const n = a.useRef(null);
          return a.useImperativeHandle(t, () => n.current), a.useEffect(() => {
            const e = n.current;
            return null == e || e.showModal(), () => {
              null == e || e.close();
            };
          }, []), a.createElement("dialog", {
            ref: n,
            className: u()("PSPDFKit-Modal-Backdrop", wn().wrapper, e.wrapperClass),
            onClose: e.onDismiss
          }, a.createElement("form", {
            method: "dialog",
            className: e.formClass
          }, e.children));
        });
        var Dn = n(64550),
          Cn = n.n(Dn);
        const Sn = e => {
          let {
            message: t,
            progress: n,
            style: r
          } = e;
          if (n) {
            const e = Math.floor(100 * n);
            return a.createElement("div", {
              className: u()("PSPDFKit-Progress", Cn().progress),
              style: r,
              role: "progressbar",
              "aria-valuenow": e,
              "aria-label": `${e}% complete`
            }, a.createElement("div", {
              className: Cn().progressBar
            }, a.createElement("div", {
              className: Cn().progressFill,
              style: {
                width: `${e}%`
              }
            })), t ? a.createElement("div", {
              className: Cn().progressText
            }, t) : null);
          }
          return a.createElement("div", {
            className: u()("PSPDFKit-Progress", Cn().loader),
            style: r,
            role: "progressbar",
            "aria-valuenow": 0,
            "aria-label": "0% complete"
          }, a.createElement("div", {
            className: Cn().loaderDot
          }), a.createElement("div", {
            className: Cn().loaderDot
          }), a.createElement("div", {
            className: Cn().loaderDot
          }));
        };
        var En = n(8134),
          _n = n.n(En);
        const Pn = ["className", "children"];
        function kn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function An(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? kn(Object(n), !0).forEach(function (t) {
              (0, Dt.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const zn = e => t => {
            const {
                className: n,
                children: r
              } = t,
              o = An(An({}, (0, i.Z)(t, Pn)), {}, {
                className: u()(_n()[e], n)
              });
            return a.createElement(e, o, r);
          },
          Tn = zn("p");
        Tn.displayName = "Text";
        const On = zn("h1");
        On.displayName = "HeaderText";
        var In = n(24470),
          Fn = n.n(In);
        const Mn = ["secureTextEntry", "error", "success", "selectTextOnFocus", "onBlur", "onFocus"],
          Rn = (e, t) => {
            const n = a.useRef(null);
            a.useImperativeHandle(t, () => n.current), a.useEffect(() => {
              const {
                selectTextOnFocus: t,
                autoFocus: n
              } = e;
              t && n && r();
            }, []);
            const r = a.useCallback(() => {
                const {
                    selectTextOnFocus: t
                  } = e,
                  {
                    current: r
                  } = n;
                r && (t && r.select(), h && h());
              }, []),
              {
                secureTextEntry: s,
                error: l,
                success: c,
                selectTextOnFocus: d,
                onBlur: p,
                onFocus: h
              } = e,
              f = (0, i.Z)(e, Mn),
              m = u()({
                [Fn().default]: !l && !c,
                [Fn().error]: l,
                [Fn().success]: c
              }, e.className),
              g = s ? "password" : "text";
            return a.createElement("input", (0, o.Z)({}, f, {
              className: m,
              type: g,
              ref: n,
              onFocus: r,
              onBlur: p
            }));
          },
          jn = a.memo(a.forwardRef(Rn));
        var Bn = n(53261),
          Nn = n(47963),
          Ln = n.n(Nn);
        function Vn(e) {
          let {
            inputName: t,
            label: n,
            options: r,
            onChange: o,
            selectedOption: i,
            labelClassNamePrefix: s,
            disabled: l = !1,
            showLabel: c,
            isButton: d,
            wrapperClasses: p
          } = e;
          return a.createElement("div", {
            className: u()(Ln().radioGroup, {
              [p]: p
            }),
            "aria-label": n,
            role: "radiogroup"
          }, r.map(e => {
            let {
              value: n,
              label: r,
              iconPath: p
            } = e;
            const h = n === i,
              f = u()(Ln().iconLabel, {
                [Ln().iconLabelIsActive]: h,
                [`${s}-${n}`]: !0,
                [`${s}-active`]: h,
                [Ln().focusedLabelFocusVisible]: h,
                [Ln().selectedLabel]: h && d,
                [Ln().radioGroupLabel]: !h && d,
                [Ln().fullWidthRadio]: d
              });
            return a.createElement("label", {
              key: n,
              className: f
            }, a.createElement(ln, {
              tag: "span"
            }, r), a.createElement("input", {
              type: "radio",
              name: t,
              value: n,
              checked: h,
              onChange: e => o(e.target.value),
              "aria-label": r,
              disabled: l
            }), d && h && a.createElement(Bn.Z, {
              src: p,
              className: u()(Ln().icon, {
                [Ln().radioGroupIcon]: d
              })
            }), !d && a.createElement(Bn.Z, {
              src: p,
              className: Ln().icon
            }), c && a.createElement("span", null, r));
          }));
        }
        var Kn = n(5612),
          qn = n.n(Kn);
        let Hn = 0;
        function Un(e) {
          const t = a.useRef(Hn++),
            {
              label: n,
              accessibilityLabel: r,
              onUpdate: o
            } = e,
            i = a.useCallback(e => {
              o(e.target.checked);
            }, [o]);
          const s = u()(qn().label, e.styles.label);
          return a.createElement("div", {
            className: e.styles.controlWrapper
          }, a.createElement("div", {
            className: e.styles.control
          }, a.createElement("div", {
            className: u()("PSPDFKit-Checkbox-Input", e.className, qn().root)
          }, a.createElement("input", {
            className: u()(qn().input, e.styles.input),
            type: "checkbox",
            id: `${qn().label}-${t.current}`,
            onChange: i,
            checked: e.value
          }), e.label ? a.createElement("label", {
            htmlFor: `${qn().label}-${t.current}`,
            className: s
          }, n) : r ? a.createElement("label", {
            htmlFor: `${qn().label}-${t.current}`,
            className: s
          }, a.createElement(ln, {
            tag: "span"
          }, r)) : null)));
        }
        var Zn = n(4345),
          $n = n(77493),
          Gn = n(57645),
          Wn = n(23629),
          Yn = n(35583);
        function Xn(e) {
          return Xn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, Xn(e);
        }
        function Qn(e) {
          var t = function (e, t) {
            if ("object" !== Xn(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" !== Xn(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" === Xn(t) ? t : String(t);
        }
        function Jn(e, t, n) {
          return (t = Qn(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var er = new WeakMap(),
          tr = new WeakMap();
        class nr {}
        class rr extends nr {
          constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            super(), Jn(this, "offset", void 0), Jn(this, "path", void 0);
            var {
              offset: t,
              path: n
            } = e;
            this.offset = t, this.path = n;
          }
        }
        class or extends nr {
          constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            super(), Jn(this, "offset", void 0), Jn(this, "path", void 0);
            var {
              offset: t,
              path: n
            } = e;
            this.offset = t, this.path = n;
          }
        }
        var ir = e => tr.get(e);
        function ar(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function sr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ar(Object(n), !0).forEach(function (t) {
              Jn(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ar(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var lr = new WeakSet(),
          ur = e => {
            var t = [],
              n = e => {
                if (null != e) {
                  var r = t[t.length - 1];
                  if ("string" == typeof e) {
                    var o = {
                      text: e
                    };
                    lr.add(o), e = o;
                  }
                  if ($n.xv.isText(e)) {
                    var i = e;
                    $n.xv.isText(r) && lr.has(r) && lr.has(i) && $n.xv.equals(r, i, {
                      loose: !0
                    }) ? r.text += i.text : t.push(i);
                  } else if ($n.W_.isElement(e)) t.push(e);else {
                    if (!(e instanceof nr)) throw new Error("Unexpected hyperscript child object: ".concat(e));
                    var a = t[t.length - 1];
                    $n.xv.isText(a) || (n(""), a = t[t.length - 1]), e instanceof rr ? ((e, t) => {
                      var n = e.text.length;
                      er.set(e, [n, t]);
                    })(a, e) : e instanceof or && ((e, t) => {
                      var n = e.text.length;
                      tr.set(e, [n, t]);
                    })(a, e);
                  }
                }
              };
            for (var r of e.flat(1 / 0)) n(r);
            return t;
          };
        function cr(e, t, n) {
          return sr(sr({}, t), {}, {
            children: ur(n)
          });
        }
        function dr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function pr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? dr(Object(n), !0).forEach(function (t) {
              Jn(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var hr,
          fr = {
            anchor: function (e, t, n) {
              return new rr(t);
            },
            cursor: function (e, t, n) {
              return [new rr(t), new or(t)];
            },
            editor: (hr = $n.Jh, (e, t, n) => {
              var r,
                o = [];
              for (var i of n) $n.e6.isRange(i) ? r = i : o.push(i);
              var a,
                s = ur(o),
                l = {},
                u = hr();
              for (var [c, d] of (Object.assign(u, t), u.children = s, $n.NB.texts(u))) {
                var p = (a = c, er.get(a)),
                  h = ir(c);
                if (null != p) {
                  var [f] = p;
                  l.anchor = {
                    path: d,
                    offset: f
                  };
                }
                if (null != h) {
                  var [m] = h;
                  l.focus = {
                    path: d,
                    offset: m
                  };
                }
              }
              if (l.anchor && !l.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
              if (!l.anchor && l.focus) throw new Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
              return null != r ? u.selection = r : $n.e6.isRange(l) && (u.selection = l), u;
            }),
            element: cr,
            focus: function (e, t, n) {
              return new or(t);
            },
            fragment: function (e, t, n) {
              return ur(n);
            },
            selection: function (e, t, n) {
              var r = n.find(e => e instanceof rr),
                o = n.find(e => e instanceof or);
              if (!r || null == r.offset || null == r.path) throw new Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
              if (!o || null == o.offset || null == o.path) throw new Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
              return sr({
                anchor: {
                  offset: r.offset,
                  path: r.path
                },
                focus: {
                  offset: o.offset,
                  path: o.path
                }
              }, t);
            },
            text: function (e, t, n) {
              var r = ur(n);
              if (r.length > 1) throw new Error("The <text> hyperscript tag must only contain a single node's worth of children.");
              var [o] = r;
              if (null == o && (o = {
                text: ""
              }), !$n.xv.isText(o)) throw new Error("\n    The <text> hyperscript tag can only contain text content as children.");
              return lr.delete(o), Object.assign(o, t), o;
            }
          },
          mr = e => function (t, n) {
            for (var r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) o[i - 2] = arguments[i];
            var a = e[t];
            if (!a) throw new Error("No hyperscript creator found for tag: <".concat(t, ">"));
            null == n && (n = {}), (0, Yn.P)(n) || (o = [n].concat(o), n = {});
            var s = a(t, n, o = o.filter(e => Boolean(e)).flat());
            return s;
          },
          gr = e => {
            var t = {},
              n = function () {
                var n = e[r];
                if ("object" != typeof n) throw new Error("Properties specified for a hyperscript shorthand should be an object, but for the custom element <".concat(r, ">  tag you passed: ").concat(n));
                t[r] = (e, t, r) => cr(0, pr(pr({}, n), t), r);
              };
            for (var r in e) n();
            return t;
          },
          vr = function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              {
                elements: t = {}
              } = e,
              n = gr(t),
              r = pr(pr(pr({}, fr), n), e.creators),
              o = mr(r);
            return o;
          }();
        const yr = /["'&<>]/;
        function br(e) {
          const t = "" + e,
            n = yr.exec(t);
          if (!n) return t;
          let r,
            o = "",
            i = 0,
            a = 0;
          for (i = n.index; i < t.length; i++) {
            switch (t.charCodeAt(i)) {
              case 34:
                r = "&quot;";
                break;
              case 38:
                r = "&amp;";
                break;
              case 39:
                r = "&#39;";
                break;
              case 60:
                r = "&lt;";
                break;
              case 62:
                r = "&gt;";
                break;
              default:
                continue;
            }
            a !== i && (o += t.substring(a, i)), a = i + 1, o += r;
          }
          return a !== i ? o + t.substring(a, i) : o;
        }
        function wr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wr(Object(n), !0).forEach(function (t) {
              (0, Dt.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function Dr(e, t) {
          if (e.nodeType === Node.TEXT_NODE) return vr("text", t, e.textContent);
          if (e.nodeType !== Node.ELEMENT_NODE) return null;
          const n = xr({}, t);
          switch (e.nodeName.toUpperCase()) {
            case "B":
              n.bold = !0;
              break;
            case "I":
            case "EM":
              n.italic = !0;
              break;
            case "U":
              n.underline = !0;
              break;
            case "SPAN":
              if ("underline" === Sr(e.getAttribute("style") || "")["text-decoration"]) {
                n.underline = !0;
                break;
              }
          }
          const r = Array.from(e.childNodes).map(e => Dr(e, n)).flat();
          switch (0 === r.length && r.push(vr("text", n, "")), e.nodeName.toUpperCase()) {
            case "BR":
              return vr("text", t, "\n");
            case "SPAN":
              {
                const t = function (e) {
                  return "SPAN" === e.nodeName.toUpperCase() && e.getAttribute("data-user-id");
                }(e);
                if (t) return vr("element", {
                  type: "mention",
                  userId: t,
                  displayName: kr(Cr(r))
                }, r);
                if (function (e) {
                  return "SPAN" === e.nodeName.toUpperCase() && e.getAttribute("style");
                }(e) && !function (e) {
                  return "underline" === e.style.textDecoration && !e.style.color && !e.style.backgroundColor;
                }(e)) {
                  const t = Sr(e.getAttribute("style") || ""),
                    n = t.color ? Lr(t.color) : void 0,
                    o = t["background-color"] ? Lr(t["background-color"]) : void 0;
                  return vr("element", {
                    type: "style",
                    fontColor: n,
                    backgroundColor: o
                  }, r);
                }
                return r;
              }
            case "P":
              return vr("element", {
                type: "paragraph"
              }, r);
            case "A":
              return vr("element", {
                type: "link",
                url: e.getAttribute("href")
              }, r);
            default:
              return r;
          }
        }
        function Cr(e) {
          function t(e) {
            var t;
            if (function (e) {
              return $n.xv.isText(e);
            }(e)) {
              let t = br(e.text);
              return e.bold && (t = `<b>${t}</b>`), e.italic && (t = `<i>${t}</i>`), e.underline && (t = `<span style="text-decoration: underline;">${t}</span>`), t;
            }
            const n = null === (t = e.children) || void 0 === t ? void 0 : t.map(e => Cr(e)).join("");
            switch (e.type) {
              case "paragraph":
                return `<p>${n}</p>`;
              case "link":
                return `<a href="${e.url}">${n}</a>`;
              case "mention":
                return `<span data-user-id="${e.userId}">${e.displayName}</span>`;
              case "style":
                {
                  const t = Er(e);
                  return `<span${t ? ` style="${t}"` : ""}>${n}</span>`;
                }
              default:
                return n;
            }
          }
          return Array.isArray(e) ? e.map(e => t(e)).join("") : t(e);
        }
        function Sr(e) {
          return e ? ((e = e.trim()).endsWith(";") && (e = e.slice(0, -1)), e.split(";").map(e => e.split(":").map(e => e.trim())).reduce((e, t) => {
            let [n, r] = t;
            return xr(xr({}, e), {}, {
              [n]: r
            });
          }, {})) : {};
        }
        function Er(e) {
          let t = "";
          return e.fontColor && (t += `color: ${e.fontColor};`), e.backgroundColor && (t += `background-color: ${e.backgroundColor};`), t;
        }
        function _r(e, t) {
          const n = $n.ML.marks(e);
          return !!n && !0 === n[t];
        }
        const Pr = (e, t) => {
          _r(e, t) ? $n.ML.removeMark(e, t) : $n.ML.addMark(e, t, !0);
        };
        function kr(e) {
          const t = document.createElement("div");
          return t.innerHTML = e, t.textContent || "";
        }
        function Ar() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return new DOMParser().parseFromString(e, "text/html");
        }
        function zr() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          const t = (e || "").match(/(<[^<>]+>)/g) || [],
            n = {
              pre: [],
              post: []
            };
          return t.forEach(e => {
            if (e.startsWith("<html")) return n.pre.push(e), void n.post.unshift("</html>");
            e.startsWith("<body") && (n.pre.push(e), n.post.unshift("</body>"));
          }), n;
        }
        function Tr() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return Ar(e).body.innerHTML;
        }
        function Or(e) {
          let {
            changeUnderlineCSStoHTML: t = !0
          } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const n = Ar(e).body;
          if (0 === n.childNodes.length) {
            const e = document.createElement("p");
            return n.appendChild(e), n;
          }
          const r = document.createElement("body");
          let o = [];
          return [...n.childNodes].forEach((e, t) => {
            const i = n.childNodes.length - 1 === t;
            if ("P" === e.nodeName.toUpperCase() || i) {
              if (i && "P" !== e.nodeName.toUpperCase() && o.push(e), o.length) {
                const e = document.createElement("p");
                o.forEach(t => {
                  e.appendChild(t);
                }), r.appendChild(e), o = [];
              }
              "P" === e.nodeName.toUpperCase() && r.appendChild(e);
            } else o.push(e);
          }), r.childNodes.forEach(e => {
            var n, r, o, i, a, s;
            (null === (n = (r = e).querySelectorAll) || void 0 === n || n.call(r, "p").forEach(e => {
              const t = document.createElement("span");
              e.style.cssText && t.setAttribute("style", e.style.cssText), t.innerHTML = e.innerHTML, e.replaceWith(t);
            }), null === (o = (i = e).querySelectorAll) || void 0 === o || o.call(i, "div").forEach(e => {
              const t = document.createElement("span");
              e.style.cssText && t.setAttribute("style", e.style.cssText), t.innerHTML = e.innerHTML, e.replaceWith(t);
            }), t) && (null === (a = (s = e).querySelectorAll) || void 0 === a || a.call(s, "span").forEach(e => {
              if ("underline" === e.style.textDecoration) {
                const t = document.createElement("u");
                t.innerHTML = e.innerHTML, e.innerHTML = t.outerHTML, e.style.textDecoration = "", e.style.cssText || (e.removeAttribute("style"), e.attributes.length || e.replaceWith(...e.childNodes));
              }
            }));
          }), r;
        }
        function Ir(e) {
          if (!e) return !1;
          const {
            selection: t
          } = e;
          return !!t && $n.e6.isExpanded(t) && "" !== $n.ML.string(e, t);
        }
        function Fr(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          const {
            selection: n
          } = e;
          if (n) {
            const [r] = $n.e6.edges(n),
              o = $n.ML.before(e, r, {
                distance: t,
                unit: "character"
              }),
              i = o && $n.ML.range(e, o, r);
            return {
              text: i && $n.ML.string(e, i),
              range: i
            };
          }
          return null;
        }
        function Mr(e) {
          return e && (" " === e.text || !e.range);
        }
        function Rr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function jr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Rr(Object(n), !0).forEach(function (t) {
              (0, Dt.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Rr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function Br(e, t, n) {
          var r;
          const o = jr(jr({}, Sr(null !== (r = e.getAttribute("style")) && void 0 !== r ? r : "")), {}, {
            ["fontColor" === t ? "color" : "background-color"]: null != n ? n : void 0
          });
          return Object.entries(o).filter(e => {
            let [, t] = e;
            return void 0 !== t;
          }).map(e => {
            let [t, n] = e;
            return `${t}: ${n}`;
          }).join("; ").concat(";");
        }
        function Nr(e, t, n) {
          const r = Or(e, {
            changeUnderlineCSStoHTML: !1
          });
          function o(e) {
            var t;
            const n = null === (t = e.closest("p")) || void 0 === t ? void 0 : t.textContent;
            return e.textContent === n && !e.closest("span[style]");
          }
          return r.querySelectorAll("p").forEach(e => {
            const {
              isBold: r,
              isUnderlined: i,
              isItalic: a
            } = Vr(e);
            if ("fontColor" === t) {
              let t = !1;
              if (e.querySelectorAll("span[style]").forEach(e => {
                o(e) ? (t = !0, e.setAttribute("style", Br(e, "fontColor", n))) : (e.style.color = "", "" === e.style.cssText && e.replaceWith(...e.childNodes));
              }), !t) {
                const t = document.createElement("span");
                t.setAttribute("style", Br(t, "fontColor", n)), t.innerHTML = e.innerHTML, e.innerHTML = t.outerHTML;
              }
            } else if ("underline" === t) {
              const t = e.querySelectorAll("span[style]");
              if (i) t.forEach(e => {
                e.style.textDecoration = "";
              });else {
                let n = !1;
                if (t.forEach(e => {
                  o(e) && (n = !0, e.style.textDecoration = "underline");
                }), !n) {
                  const t = document.createElement("span");
                  t.style.textDecoration = "underline", t.innerHTML = e.innerHTML, e.innerHTML = t.outerHTML;
                }
              }
              t.forEach(e => {
                o(e) ? e.style.textDecoration = i ? "" : "underline" : (e.style.textDecoration = "", "" === e.style.cssText && e.replaceWith(...e.childNodes));
              });
            } else if ("bold" === t) {
              const t = e.querySelectorAll("b");
              if (r) t.forEach(e => {
                e.replaceWith(...e.childNodes);
              });else {
                const t = document.createElement("b");
                t.innerHTML = e.innerHTML, e.innerHTML = t.outerHTML;
              }
            } else if ("italic" === t) {
              const t = e.querySelectorAll("i, em");
              if (a) t.forEach(e => {
                e.replaceWith(...e.childNodes);
              });else {
                const t = document.createElement("i");
                t.innerHTML = e.innerHTML, e.innerHTML = t.outerHTML;
              }
            }
          }), r.innerHTML;
        }
        function Lr(e) {
          if (!e) return "";
          if (e.startsWith("rgb")) {
            const t = e.replace("rgb(", "").replace(")", "").split(",").map(e => parseInt(e, 10)).map(e => e.toString(16)).map(e => 1 === e.length ? `0${e}` : e).join("");
            return `#${t}`;
          }
          return e.startsWith("#") && 9 === e.length ? `#${e.substr(3, 6)}` : 7 === e.length && e.startsWith("#") ? e : "#000000";
        }
        function Vr(e) {
          const t = e.querySelectorAll("span[style]"),
            n = Array.from(t).filter(t => t.textContent === e.textContent),
            r = n.filter(e => e.style.color),
            o = n.filter(e => e.style.backgroundColor),
            i = n.filter(e => "underline" === e.style.textDecoration),
            a = e.querySelectorAll("b"),
            s = Array.from(a).filter(t => t.textContent === e.textContent),
            l = e.querySelectorAll("i, em"),
            u = Array.from(l).filter(t => t.textContent === e.textContent);
          return {
            fontColor: r.length > 0 ? Lr(r[r.length - 1].style.color) : null,
            backgroundColor: o.length > 0 ? Lr(o[o.length - 1].style.backgroundColor) : null,
            isUnderlined: i.length > 0,
            isBold: s.length > 0,
            isItalic: u.length > 0
          };
        }
        function Kr(e) {
          const t = Or(e, {
              changeUnderlineCSStoHTML: !1
            }).querySelectorAll("p"),
            n = Array.from(t).map(e => Vr(e));
          return {
            fontColor: n.every(e => {
              let {
                fontColor: t
              } = e;
              return t && t === n[0].fontColor;
            }) ? n[0].fontColor : null,
            isUnderlined: n.every(e => {
              let {
                isUnderlined: t
              } = e;
              return t && t === n[0].isUnderlined;
            }),
            isBold: n.every(e => {
              let {
                isBold: t
              } = e;
              return t && t === n[0].isBold;
            }),
            isItalic: n.every(e => {
              let {
                isItalic: t
              } = e;
              return t && t === n[0].isItalic;
            }),
            backgroundColor: n.every(e => {
              let {
                backgroundColor: t
              } = e;
              return t && t === n[0].backgroundColor;
            }) ? n[0].backgroundColor : null
          };
        }
        function qr(e, t) {
          var n;
          const {
            selection: r
          } = e;
          if (!r) return;
          const [...o] = Array.from($n.ML.nodes(e, {
              at: $n.ML.unhangRange(e, r),
              match: e => !$n.ML.isEditor(e) && Hr(e)
            })),
            i = o.map(e => {
              let [t] = e;
              return t;
            });
          if (!i) return;
          const a = i.map(e => Lr(e[t]));
          return 1 === new Set(a).size && null !== (n = a[0]) && void 0 !== n ? n : void 0;
        }
        function Hr(e) {
          return "style" === e.type;
        }
        function Ur(e, t) {
          const {
            selection: n
          } = e;
          n && $n.e6.isCollapsed(n) ? $n.YR.insertNodes(e, t) : ($n.YR.wrapNodes(e, t, {
            split: !0
          }), $n.YR.collapse(e, {
            edge: "end"
          }));
        }
        function Zr(e, t) {
          $n.YR.unwrapNodes(e, {
            match: e => !$n.ML.isEditor(e) && $n.W_.isElement(e) && e.type === t
          });
        }
        function $r(e, t, n) {
          (0, Vt.kG)(e, "Editor is not defined.");
          const [r] = $n.ML.nodes(e, {
            match: e => !$n.ML.isEditor(e) && $n.W_.isElement(e) && Hr(e)
          });
          r ? $n.YR.setNodes(e, {
            [t]: n
          }, {
            match: e => Hr(e),
            split: !0
          }) : Ur(e, {
            type: "style",
            [t]: n,
            children: [{
              text: ""
            }]
          });
        }
        function Gr(e) {
          var t;
          const {
            selection: n
          } = e;
          if (!n) return !1;
          const [...r] = Array.from($n.ML.nodes(e, {
              at: $n.ML.unhangRange(e, n),
              match: e => !$n.ML.isEditor(e) && Hr(e)
            })),
            o = r.map(e => {
              let [t] = e;
              return t;
            });
          return !(null == o || null === (t = o[0]) || void 0 === t || !t.underline);
        }
        function Wr(e, t) {
          const n = Dr(Or(e));
          $n.YR.insertFragment(t, n);
        }
        function Yr(e) {
          return "mention" === e.type;
        }
        const Xr = e => {
          const {
            insertData: t,
            isInline: n,
            markableVoid: r,
            isVoid: o
          } = e;
          return e.isInline = e => "link" === e.type || Yr(e) || "style" === e.type || n(e), e.isVoid = e => Yr(e) || o(e), e.markableVoid = e => Yr(e) || r(e), e.insertData = n => {
            try {
              const r = n.getData("text/html");
              if (r) return void Wr(r, e);
              t(n);
            } catch (t) {
              !function (e) {
                let {
                  html: t,
                  editor: n
                } = e;
                try {
                  $n.YR.insertNodes(n, {
                    type: "style",
                    contentEditable: !1,
                    fontSize: 0,
                    children: [{
                      text: "​"
                    }]
                  }), Wr(t, n);
                } catch (e) {
                  return !1;
                }
              }({
                html: n.getData("text/html"),
                editor: e
              });
            }
          }, e;
        };
        var Qr, Jr;
        const eo = "undefined" != typeof navigator && /Android/.test(navigator.userAgent),
          to = "undefined" != typeof navigator && /Chrome/.test(navigator.userAgent),
          no = a.forwardRef((e, t) => {
            let {
              text: n,
              style: r,
              updateBoundingBox: o,
              onValueChange: i,
              onBlurSave: s,
              maxLength: l,
              onStopEditing: c,
              onEscape: d,
              lastMousePoint: p,
              onEditorInit: h,
              className: f,
              placeholder: m,
              onBlur: g,
              autoFocus: v = !0,
              onSelectionChange: y,
              autoOpenKeyboard: b = !0,
              onKeyDown: w,
              keepSelectedTool: x,
              title: D = "Rich text editor",
              shadowRoot: C
            } = e;
            const {
                value: S,
                wrapperTags: E
              } = (0, a.useMemo)(() => ({
                wrapperTags: zr(n),
                value: Tr(n)
              }), [n]),
              _ = (0, a.useRef)(null),
              P = a.useRef(S),
              k = (0, a.useMemo)(() => Xr((0, Gn.VC)((0, Zn.BU)((0, $n.Jh)()))), []),
              A = (0, a.useCallback)(e => {
                e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
              }, []);
            (0, a.useEffect)(() => {
              const e = _.current;
              function t(t) {
                var n, r;
                const o = null == t || null === (n = t.target) || void 0 === n ? void 0 : n.shadowRoot,
                  i = o ? null == o || null === (r = o.elementFromPoint) || void 0 === r || null === (r = r.call(o, t.x, t.y)) || void 0 === r ? void 0 : r.parentElement : t.target,
                  a = !(null == i || !i.closest(".PSPDFKit-Text-Annotation-Toolbar, .PSPDFKit-Input-Dropdown-Items, .PSPDFKit-Input-Dropdown-Button"));
                null != e && e.contains(t.target) || null == s || s({
                  isTextToolbarClicked: a,
                  isNativeBlurEvent: !0
                });
              }
              return null == e || e.ownerDocument.addEventListener("pointerdown", t, {
                capture: !0
              }), $n.YR.select(k, $n.ML.end(k, [])), () => {
                null == e || e.ownerDocument.removeEventListener("pointerdown", t, {
                  capture: !0
                });
              };
            }, [k, s]);
            const z = (0, a.useMemo)(() => Dr(Or(S)), [S]),
              T = (0, a.useCallback)(e => a.createElement(io, e), []),
              O = (0, a.useCallback)(e => a.createElement(ro, e), []);
            (0, a.useEffect)(() => (null == h || h(k), () => {
              null == h || h(null);
            }), [k, h]), (0, a.useEffect)(() => {
              v && (Zn.F3.focus(k), x ? b || setTimeout(() => {
                Zn.F3.blur(k);
              }, 0) : setTimeout(() => {
                Zn.F3.blur(k), Zn.F3.focus(k), b || Zn.F3.blur(k);
              }, 0));
            }, [b]), (0, a.useEffect)(() => {
              setTimeout(() => {
                if (p && _.current) {
                  const e = (0, Vt.Qo)(p, _.current.ownerDocument);
                  if (!e) return;
                  const t = Zn.F3.toSlatePoint(k, [e.startContainer, e.startOffset], {
                    exactMatch: !0,
                    suppressThrow: !0
                  });
                  t && $n.YR.select(k, t);
                }
              }, 0);
            }, [k, p, t]);
            const I = (0, a.useCallback)(e => {
                if ("Escape" !== e.key) return "Enter" === e.key && e.shiftKey ? (null == c || c(), void e.preventDefault()) : void (l && kr(P.current).length >= l && e.preventDefault());
                null == d || d(e);
              }, [l, d, c]),
              F = (0, a.useCallback)(() => {
                const {
                  selection: e
                } = k;
                if (e && $n.e6.isCollapsed(e)) {
                  var t, n, r;
                  const [i] = $n.e6.edges(e),
                    a = Fr(k, 2);
                  if ((null != a && null !== (t = a.text) && void 0 !== t && t.startsWith(" ") || 1 === (null == a || null === (n = a.text) || void 0 === n ? void 0 : n.length)) && null != a && null !== (r = a.text) && void 0 !== r && r.endsWith("@")) {
                    var o;
                    (0, Vt.kG)(a, "lastTwoCharacters should be defined");
                    const e = null === (o = Fr(k)) || void 0 === o ? void 0 : o.range;
                    return e ? {
                      query: "",
                      target: e
                    } : null;
                  }
                  {
                    const e = $n.ML.before(k, i, {
                        unit: "word"
                      }),
                      t = e && $n.ML.before(k, e),
                      n = t && $n.ML.range(k, t, i),
                      r = n && $n.ML.string(k, n),
                      o = r && r.match(/^@(\w+)$/),
                      a = $n.ML.after(k, i),
                      s = $n.ML.range(k, i, a),
                      l = $n.ML.string(k, s).match(/^(\s|$)/);
                    return o && l && n ? {
                      query: o[1],
                      target: n
                    } : null;
                  }
                }
                return null;
              }, [k]),
              M = (0, a.useCallback)(e => {
                var t;
                k.operations.every(e => "set_selection" === e.type) && (null == y || y(), "onSelectionChange" in k && "function" == typeof k.onSelectionChange && k.onSelectionChange());
                const n = e.map(e => Cr(e)).join("");
                P.current = n, i(`${E.pre.join("")}${n}${E.post.join("")}`, {
                  activeMention: null !== (t = F()) && void 0 !== t ? t : null
                }), null == o || o(), "onValueChange" in k && "function" == typeof k.onValueChange && k.onValueChange(n);
              }, [i, o, E, k, y, F]);
            return a.createElement("div", {
              role: "presentation",
              className: u()(Wn.richTextEditor, "PSPDFKit-Rich-Text-Editor", f),
              style: r,
              ref: (0, Vt.FE)(t, _),
              onBlur: () => {
                null == s || s({}), null == g || g();
              },
              onDragStart: A,
              onDragEnd: A,
              onKeyUp: A,
              onMouseDown: A,
              onPointerUp: A,
              onTouchStart: A,
              onTouchEnd: A,
              onMouseUp: A
            }, a.createElement(Zn.mH, {
              onChange: M,
              editor: k,
              value: z
            }, a.createElement(Zn.CX, {
              title: D,
              placeholder: m,
              renderLeaf: O,
              renderElement: T,
              onInput: o,
              className: Wn.wrapper,
              onKeyDown: e => {
                w ? w(e) : (I(e), (e.metaKey || e.ctrlKey) && "b" === e.key ? (e.preventDefault(), Pr(k, "bold")) : (e.metaKey || e.ctrlKey) && "i" === e.key ? (e.preventDefault(), Pr(k, "italic")) : (e.metaKey || e.ctrlKey) && "u" === e.key && (e.preventDefault(), Pr(k, "underline")), eo && !Zn.F3.isComposing(k) && setTimeout(k.onChange, 10), vt.vU && C && Zn.F3.focus(k));
              }
            })));
          }),
          ro = e => {
            let {
              attributes: t,
              children: n,
              leaf: r
            } = e;
            return r.bold && (n = a.createElement("strong", null, n)), r.italic && (n = a.createElement("em", null, n)), r.underline && (n = a.createElement("u", null, n)), a.createElement("span", t, n);
          },
          oo = () => a.createElement("span", {
            contentEditable: !1,
            style: {
              fontSize: 0
            }
          }, "$", String.fromCodePoint(160)),
          io = e => {
            const {
              attributes: t,
              children: n,
              element: r
            } = e;
            switch (r.type) {
              case "link":
                return a.createElement("a", (0, o.Z)({}, t, {
                  href: r.url
                }), Qr || (Qr = a.createElement(oo, null)), n, Jr || (Jr = a.createElement(oo, null)));
              case "mention":
                return a.createElement("span", (0, o.Z)({}, t, {
                  contentEditable: to ? void 0 : t.contentEditable,
                  "data-user-id": r.userId
                }), n, "@", r.displayName);
              case "style":
                return a.createElement("span", (0, o.Z)({}, t, {
                  style: {
                    color: r.fontColor,
                    backgroundColor: r.backgroundColor
                  }
                }), n);
              default:
                return a.createElement("p", t, n);
            }
          };
        function ao(...e) {
          return t => e.forEach(e => function (e, t) {
            "function" == typeof e ? e(t) : null != e && (e.current = t);
          }(e, t));
        }
        function so(...e) {
          return (0, a.useCallback)(ao(...e), e);
        }
        function lo(e, t = []) {
          let n = [];
          const r = () => {
            const t = n.map(e => (0, a.createContext)(e));
            return function (n) {
              const r = (null == n ? void 0 : n[e]) || t;
              return (0, a.useMemo)(() => ({
                [`__scope${e}`]: {
                  ...n,
                  [e]: r
                }
              }), [n, r]);
            };
          };
          return r.scopeName = e, [function (t, r) {
            const o = (0, a.createContext)(r),
              i = n.length;
            function s(t) {
              const {
                  scope: n,
                  children: r,
                  ...s
                } = t,
                l = (null == n ? void 0 : n[e][i]) || o,
                u = (0, a.useMemo)(() => s, Object.values(s));
              return (0, a.createElement)(l.Provider, {
                value: u
              }, r);
            }
            return n = [...n, r], s.displayName = t + "Provider", [s, function (n, s) {
              const l = (null == s ? void 0 : s[e][i]) || o,
                u = (0, a.useContext)(l);
              if (u) return u;
              if (void 0 !== r) return r;
              throw new Error(`\`${n}\` must be used within \`${t}\``);
            }];
          }, uo(r, ...t)];
        }
        function uo(...e) {
          const t = e[0];
          if (1 === e.length) return t;
          const n = () => {
            const n = e.map(e => ({
              useScope: e(),
              scopeName: e.scopeName
            }));
            return function (e) {
              const r = n.reduce((t, {
                useScope: n,
                scopeName: r
              }) => ({
                ...t,
                ...n(e)[`__scope${r}`]
              }), {});
              return (0, a.useMemo)(() => ({
                [`__scope${t.scopeName}`]: r
              }), [r]);
            };
          };
          return n.scopeName = t.scopeName, n;
        }
        function co() {
          return co = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, co.apply(this, arguments);
        }
        var po = n(73935);
        function ho() {
          return ho = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, ho.apply(this, arguments);
        }
        const fo = (0, a.forwardRef)((e, t) => {
          const {
              children: n,
              ...r
            } = e,
            o = a.Children.toArray(n),
            i = o.find(vo);
          if (i) {
            const e = i.props.children,
              n = o.map(t => t === i ? a.Children.count(e) > 1 ? a.Children.only(null) : (0, a.isValidElement)(e) ? e.props.children : null : t);
            return (0, a.createElement)(mo, ho({}, r, {
              ref: t
            }), (0, a.isValidElement)(e) ? (0, a.cloneElement)(e, void 0, n) : null);
          }
          return (0, a.createElement)(mo, ho({}, r, {
            ref: t
          }), n);
        });
        fo.displayName = "Slot";
        const mo = (0, a.forwardRef)((e, t) => {
          const {
            children: n,
            ...r
          } = e;
          return (0, a.isValidElement)(n) ? (0, a.cloneElement)(n, {
            ...yo(r, n.props),
            ref: ao(t, n.ref)
          }) : a.Children.count(n) > 1 ? a.Children.only(null) : null;
        });
        mo.displayName = "SlotClone";
        const go = ({
          children: e
        }) => (0, a.createElement)(a.Fragment, null, e);
        function vo(e) {
          return (0, a.isValidElement)(e) && e.type === go;
        }
        function yo(e, t) {
          const n = {
            ...t
          };
          for (const r in t) {
            const o = e[r],
              i = t[r];
            /^on[A-Z]/.test(r) ? o && i ? n[r] = (...e) => {
              i(...e), o(...e);
            } : o && (n[r] = o) : "style" === r ? n[r] = {
              ...o,
              ...i
            } : "className" === r && (n[r] = [o, i].filter(Boolean).join(" "));
          }
          return {
            ...e,
            ...n
          };
        }
        ["a", "button", "div", "h2", "h3", "img", "label", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce((e, t) => {
          const n = (0, a.forwardRef)((e, n) => {
            const {
                asChild: r,
                ...o
              } = e,
              i = r ? fo : t;
            return (0, a.useEffect)(() => {
              window[Symbol.for("radix-ui")] = !0;
            }, []), (0, a.createElement)(i, co({}, o, {
              ref: n
            }));
          });
          return n.displayName = `Primitive.${t}`, {
            ...e,
            [t]: n
          };
        }, {});
        function bo(e) {
          const t = e + "CollectionProvider",
            [n, r] = lo(t),
            [o, i] = n(t, {
              collectionRef: {
                current: null
              },
              itemMap: new Map()
            }),
            s = e => {
              const {
                  scope: t,
                  children: n
                } = e,
                r = a.useRef(null),
                i = a.useRef(new Map()).current;
              return a.createElement(o, {
                scope: t,
                itemMap: i,
                collectionRef: r
              }, n);
            },
            l = e + "CollectionSlot",
            u = a.forwardRef((e, t) => {
              const {
                  scope: n,
                  children: r
                } = e,
                o = so(t, i(l, n).collectionRef);
              return a.createElement(fo, {
                ref: o
              }, r);
            }),
            c = e + "CollectionItemSlot",
            d = "data-radix-collection-item",
            p = a.forwardRef((e, t) => {
              const {
                  scope: n,
                  children: r,
                  ...o
                } = e,
                s = a.useRef(null),
                l = so(t, s),
                u = i(c, n);
              return a.useEffect(() => (u.itemMap.set(s, {
                ref: s,
                ...o
              }), () => {
                u.itemMap.delete(s);
              })), a.createElement(fo, {
                [d]: "",
                ref: l
              }, r);
            });
          return [{
            Provider: s,
            Slot: u,
            ItemSlot: p
          }, function (t) {
            const n = i(e + "CollectionConsumer", t),
              r = a.useCallback(() => {
                const e = n.collectionRef.current;
                if (!e) return [];
                const t = Array.from(e.querySelectorAll(`[${d}]`)),
                  r = Array.from(n.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
                return r;
              }, [n.collectionRef, n.itemMap]);
            return r;
          }, r];
        }
        new Set(), new Set(), new Set();
        !function () {
          let e = [];
        }();
        function wo(e, t) {
          const n = [...e],
            r = n.indexOf(t);
          return -1 !== r && n.splice(r, 1), n;
        }
        const xo = Boolean(null === globalThis || void 0 === globalThis ? void 0 : globalThis.document) ? a.useLayoutEffect : () => {};
        s["useId".toString()];
        Math.min, Math.max;
        const Do = ["top", "right", "bottom", "left"];
        Do.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
        Math.min, Math.max, Math.round;
        "undefined" != typeof document ? a.useLayoutEffect : a.useEffect;
        const Co = "Popper",
          [So, Eo] = lo(Co),
          [_o, Po] = So(Co),
          ko = "PopperContent",
          [Ao, zo] = So(ko),
          [To, Oo] = So(ko, {
            hasParent: !1,
            positionUpdateFns: new Set()
          });
        const Io = e => {
          const {
              present: t,
              children: n
            } = e,
            r = function (e) {
              const [t, n] = (0, a.useState)(),
                r = (0, a.useRef)({}),
                o = (0, a.useRef)(e),
                i = (0, a.useRef)("none"),
                s = e ? "mounted" : "unmounted",
                [l, u] = function (e, t) {
                  return (0, a.useReducer)((e, n) => {
                    const r = t[e][n];
                    return null != r ? r : e;
                  }, e);
                }(s, {
                  mounted: {
                    UNMOUNT: "unmounted",
                    ANIMATION_OUT: "unmountSuspended"
                  },
                  unmountSuspended: {
                    MOUNT: "mounted",
                    ANIMATION_END: "unmounted"
                  },
                  unmounted: {
                    MOUNT: "mounted"
                  }
                });
              return (0, a.useEffect)(() => {
                const e = Fo(r.current);
                i.current = "mounted" === l ? e : "none";
              }, [l]), xo(() => {
                const t = r.current,
                  n = o.current;
                if (n !== e) {
                  const r = i.current,
                    a = Fo(t);
                  if (e) u("MOUNT");else if ("none" === a || "none" === (null == t ? void 0 : t.display)) u("UNMOUNT");else {
                    const e = r !== a;
                    u(n && e ? "ANIMATION_OUT" : "UNMOUNT");
                  }
                  o.current = e;
                }
              }, [e, u]), xo(() => {
                if (t) {
                  const e = e => {
                      const n = Fo(r.current).includes(e.animationName);
                      e.target === t && n && (0, po.flushSync)(() => u("ANIMATION_END"));
                    },
                    n = e => {
                      e.target === t && (i.current = Fo(r.current));
                    };
                  return t.addEventListener("animationstart", n), t.addEventListener("animationcancel", e), t.addEventListener("animationend", e), () => {
                    t.removeEventListener("animationstart", n), t.removeEventListener("animationcancel", e), t.removeEventListener("animationend", e);
                  };
                }
                u("ANIMATION_END");
              }, [t, u]), {
                isPresent: ["mounted", "unmountSuspended"].includes(l),
                ref: (0, a.useCallback)(e => {
                  e && (r.current = getComputedStyle(e)), n(e);
                }, [])
              };
            }(t),
            o = "function" == typeof n ? n({
              present: r.isPresent
            }) : a.Children.only(n),
            i = so(r.ref, o.ref);
          return "function" == typeof n || r.isPresent ? (0, a.cloneElement)(o, {
            ref: i
          }) : null;
        };
        function Fo(e) {
          return (null == e ? void 0 : e.animationName) || "none";
        }
        Io.displayName = "Presence";
        const Mo = "RovingFocusGroup",
          [Ro, jo, Bo] = bo(Mo),
          [No, Lo] = lo(Mo, [Bo]),
          [Vo, Ko] = No(Mo);
        new WeakMap(), new WeakMap();
        var qo = n(70655),
          Ho = "right-scroll-bar-position",
          Uo = "width-before-scroll-bar";
        function Zo(e, t) {
          return function (e, t) {
            var n = (0, a.useState)(function () {
              return {
                value: e,
                callback: t,
                facade: {
                  get current() {
                    return n.value;
                  },
                  set current(e) {
                    var t = n.value;
                    t !== e && (n.value = e, n.callback(e, t));
                  }
                }
              };
            })[0];
            return n.callback = t, n.facade;
          }(t || null, function (t) {
            return e.forEach(function (e) {
              return function (e, t) {
                return "function" == typeof e ? e(t) : e && (e.current = t), e;
              }(e, t);
            });
          });
        }
        new WeakMap();
        new WeakMap();
        function $o(e) {
          return e;
        }
        function Go(e, t) {
          void 0 === t && (t = $o);
          var n = [],
            r = !1,
            o = {
              read: function () {
                if (r) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
                return n.length ? n[n.length - 1] : e;
              },
              useMedium: function (e) {
                var o = t(e, r);
                return n.push(o), function () {
                  n = n.filter(function (e) {
                    return e !== o;
                  });
                };
              },
              assignSyncMedium: function (e) {
                for (r = !0; n.length;) {
                  var t = n;
                  n = [], t.forEach(e);
                }
                n = {
                  push: function (t) {
                    return e(t);
                  },
                  filter: function () {
                    return n;
                  }
                };
              },
              assignMedium: function (e) {
                r = !0;
                var t = [];
                if (n.length) {
                  var o = n;
                  n = [], o.forEach(e), t = n;
                }
                var i = function () {
                    var n = t;
                    t = [], n.forEach(e);
                  },
                  a = function () {
                    return Promise.resolve().then(i);
                  };
                a(), n = {
                  push: function (e) {
                    t.push(e), a();
                  },
                  filter: function (e) {
                    return t = t.filter(e), n;
                  }
                };
              }
            };
          return o;
        }
        var Wo = function (e) {
          var t = e.sideCar,
            n = (0, qo._T)(e, ["sideCar"]);
          if (!t) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
          var r = t.read();
          if (!r) throw new Error("Sidecar medium not found");
          return a.createElement(r, (0, qo.pi)({}, n));
        };
        Wo.isSideCarExport = !0;
        var Yo,
          Xo = function (e) {
            void 0 === e && (e = {});
            var t = Go(null);
            return t.options = (0, qo.pi)({
              async: !0,
              ssr: !1
            }, e), t;
          }(),
          Qo = function () {},
          Jo = a.forwardRef(function (e, t) {
            var n = a.useRef(null),
              r = a.useState({
                onScrollCapture: Qo,
                onWheelCapture: Qo,
                onTouchMoveCapture: Qo
              }),
              o = r[0],
              i = r[1],
              s = e.forwardProps,
              l = e.children,
              u = e.className,
              c = e.removeScrollBar,
              d = e.enabled,
              p = e.shards,
              h = e.sideCar,
              f = e.noIsolation,
              m = e.inert,
              g = e.allowPinchZoom,
              v = e.as,
              y = void 0 === v ? "div" : v,
              b = (0, qo._T)(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]),
              w = h,
              x = Zo([n, t]),
              D = (0, qo.pi)((0, qo.pi)({}, b), o);
            return a.createElement(a.Fragment, null, d && a.createElement(w, {
              sideCar: Xo,
              removeScrollBar: c,
              shards: p,
              noIsolation: f,
              inert: m,
              setCallbacks: i,
              allowPinchZoom: !!g,
              lockRef: n
            }), s ? a.cloneElement(a.Children.only(l), (0, qo.pi)((0, qo.pi)({}, D), {
              ref: x
            })) : a.createElement(y, (0, qo.pi)({}, D, {
              className: u,
              ref: x
            }), l));
          });
        Jo.defaultProps = {
          enabled: !0,
          removeScrollBar: !0,
          inert: !1
        }, Jo.classNames = {
          fullWidth: Uo,
          zeroRight: Ho
        };
        function ei() {
          if (!document) return null;
          var e = document.createElement("style");
          e.type = "text/css";
          var t = Yo || n.nc;
          return t && e.setAttribute("nonce", t), e;
        }
        var ti = function () {
            var e = 0,
              t = null;
            return {
              add: function (n) {
                var r, o;
                0 == e && (t = ei()) && (o = n, (r = t).styleSheet ? r.styleSheet.cssText = o : r.appendChild(document.createTextNode(o)), function (e) {
                  (document.head || document.getElementsByTagName("head")[0]).appendChild(e);
                }(t)), e++;
              },
              remove: function () {
                ! --e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
              }
            };
          },
          ni = function () {
            var e,
              t = (e = ti(), function (t, n) {
                a.useEffect(function () {
                  return e.add(t), function () {
                    e.remove();
                  };
                }, [t && n]);
              });
            return function (e) {
              var n = e.styles,
                r = e.dynamic;
              return t(n, r), null;
            };
          },
          ri = {
            left: 0,
            top: 0,
            right: 0,
            gap: 0
          },
          oi = function (e) {
            return parseInt(e || "", 10) || 0;
          },
          ii = function (e) {
            if (void 0 === e && (e = "margin"), "undefined" == typeof window) return ri;
            var t = function (e) {
                var t = window.getComputedStyle(document.body),
                  n = t["padding" === e ? "paddingLeft" : "marginLeft"],
                  r = t["padding" === e ? "paddingTop" : "marginTop"],
                  o = t["padding" === e ? "paddingRight" : "marginRight"];
                return [oi(n), oi(r), oi(o)];
              }(e),
              n = document.documentElement.clientWidth,
              r = window.innerWidth;
            return {
              left: t[0],
              top: t[1],
              right: t[2],
              gap: Math.max(0, r - n + t[2] - t[0])
            };
          },
          ai = ni(),
          si = function (e, t, n, r) {
            var o = e.left,
              i = e.top,
              a = e.right,
              s = e.gap;
            return void 0 === n && (n = "margin"), "\n  .".concat("with-scroll-bars-hidden", " {\n   overflow: hidden ").concat(r, ";\n   padding-right: ").concat(s, "px ").concat(r, ";\n  }\n  body {\n    overflow: hidden ").concat(r, ";\n    overscroll-behavior: contain;\n    ").concat([t && "position: relative ".concat(r, ";"), "margin" === n && "\n    padding-left: ".concat(o, "px;\n    padding-top: ").concat(i, "px;\n    padding-right: ").concat(a, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(s, "px ").concat(r, ";\n    "), "padding" === n && "padding-right: ".concat(s, "px ").concat(r, ";")].filter(Boolean).join(""), "\n  }\n  \n  .").concat(Ho, " {\n    right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(Uo, " {\n    margin-right: ").concat(s, "px ").concat(r, ";\n  }\n  \n  .").concat(Ho, " .").concat(Ho, " {\n    right: 0 ").concat(r, ";\n  }\n  \n  .").concat(Uo, " .").concat(Uo, " {\n    margin-right: 0 ").concat(r, ";\n  }\n  \n  body {\n    ").concat("--removed-body-scroll-bar-size", ": ").concat(s, "px;\n  }\n");
          },
          li = function (e) {
            var t = e.noRelative,
              n = e.noImportant,
              r = e.gapMode,
              o = void 0 === r ? "margin" : r,
              i = a.useMemo(function () {
                return ii(o);
              }, [o]);
            return a.createElement(ai, {
              styles: si(i, !t, o, n ? "" : "!important")
            });
          },
          ui = !1;
        if ("undefined" != typeof window) try {
          var ci = Object.defineProperty({}, "passive", {
            get: function () {
              return ui = !0, !0;
            }
          });
          window.addEventListener("test", ci, ci), window.removeEventListener("test", ci, ci);
        } catch (e) {
          ui = !1;
        }
        var di = !!ui && {
            passive: !1
          },
          pi = function (e, t) {
            var n = window.getComputedStyle(e);
            return "hidden" !== n[t] && !(n.overflowY === n.overflowX && !function (e) {
              return "TEXTAREA" === e.tagName;
            }(e) && "visible" === n[t]);
          },
          hi = function (e, t) {
            var n = t;
            do {
              if ("undefined" != typeof ShadowRoot && n instanceof ShadowRoot && (n = n.host), fi(e, n)) {
                var r = mi(e, n);
                if (r[1] > r[2]) return !0;
              }
              n = n.parentNode;
            } while (n && n !== document.body);
            return !1;
          },
          fi = function (e, t) {
            return "v" === e ? function (e) {
              return pi(e, "overflowY");
            }(t) : function (e) {
              return pi(e, "overflowX");
            }(t);
          },
          mi = function (e, t) {
            return "v" === e ? [(n = t).scrollTop, n.scrollHeight, n.clientHeight] : function (e) {
              return [e.scrollLeft, e.scrollWidth, e.clientWidth];
            }(t);
            var n;
          },
          gi = function (e) {
            return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
          },
          vi = function (e) {
            return [e.deltaX, e.deltaY];
          },
          yi = function (e) {
            return e && "current" in e ? e.current : e;
          },
          bi = function (e) {
            return "\n  .block-interactivity-".concat(e, " {pointer-events: none;}\n  .allow-interactivity-").concat(e, " {pointer-events: all;}\n");
          },
          wi = 0,
          xi = [];
        const Di = (Ci = function (e) {
          var t = a.useRef([]),
            n = a.useRef([0, 0]),
            r = a.useRef(),
            o = a.useState(wi++)[0],
            i = a.useState(function () {
              return ni();
            })[0],
            s = a.useRef(e);
          a.useEffect(function () {
            s.current = e;
          }, [e]), a.useEffect(function () {
            if (e.inert) {
              document.body.classList.add("block-interactivity-".concat(o));
              var t = (0, qo.ev)([e.lockRef.current], (e.shards || []).map(yi), !0).filter(Boolean);
              return t.forEach(function (e) {
                return e.classList.add("allow-interactivity-".concat(o));
              }), function () {
                document.body.classList.remove("block-interactivity-".concat(o)), t.forEach(function (e) {
                  return e.classList.remove("allow-interactivity-".concat(o));
                });
              };
            }
          }, [e.inert, e.lockRef.current, e.shards]);
          var l = a.useCallback(function (e, t) {
              if ("touches" in e && 2 === e.touches.length) return !s.current.allowPinchZoom;
              var o,
                i = gi(e),
                a = n.current,
                l = "deltaX" in e ? e.deltaX : a[0] - i[0],
                u = "deltaY" in e ? e.deltaY : a[1] - i[1],
                c = e.target,
                d = Math.abs(l) > Math.abs(u) ? "h" : "v";
              if ("touches" in e && "h" === d && "range" === c.type) return !1;
              var p = hi(d, c);
              if (!p) return !0;
              if (p ? o = d : (o = "v" === d ? "h" : "v", p = hi(d, c)), !p) return !1;
              if (!r.current && "changedTouches" in e && (l || u) && (r.current = o), !o) return !0;
              var h = r.current || o;
              return function (e, t, n, r, o) {
                var i = function (e, t) {
                    return "h" === e && "rtl" === t ? -1 : 1;
                  }(e, window.getComputedStyle(t).direction),
                  a = i * r,
                  s = n.target,
                  l = t.contains(s),
                  u = !1,
                  c = a > 0,
                  d = 0,
                  p = 0;
                do {
                  var h = mi(e, s),
                    f = h[0],
                    m = h[1] - h[2] - i * f;
                  (f || m) && fi(e, s) && (d += m, p += f), s = s.parentNode;
                } while (!l && s !== document.body || l && (t.contains(s) || t === s));
                return (c && (o && 0 === d || !o && a > d) || !c && (o && 0 === p || !o && -a > p)) && (u = !0), u;
              }(h, t, e, "h" === h ? l : u, !0);
            }, []),
            u = a.useCallback(function (e) {
              var n = e;
              if (xi.length && xi[xi.length - 1] === i) {
                var r = "deltaY" in n ? vi(n) : gi(n),
                  o = t.current.filter(function (e) {
                    return e.name === n.type && e.target === n.target && function (e, t) {
                      return e[0] === t[0] && e[1] === t[1];
                    }(e.delta, r);
                  })[0];
                if (o && o.should) n.cancelable && n.preventDefault();else if (!o) {
                  var a = (s.current.shards || []).map(yi).filter(Boolean).filter(function (e) {
                    return e.contains(n.target);
                  });
                  (a.length > 0 ? l(n, a[0]) : !s.current.noIsolation) && n.cancelable && n.preventDefault();
                }
              }
            }, []),
            c = a.useCallback(function (e, n, r, o) {
              var i = {
                name: e,
                delta: n,
                target: r,
                should: o
              };
              t.current.push(i), setTimeout(function () {
                t.current = t.current.filter(function (e) {
                  return e !== i;
                });
              }, 1);
            }, []),
            d = a.useCallback(function (e) {
              n.current = gi(e), r.current = void 0;
            }, []),
            p = a.useCallback(function (t) {
              c(t.type, vi(t), t.target, l(t, e.lockRef.current));
            }, []),
            h = a.useCallback(function (t) {
              c(t.type, gi(t), t.target, l(t, e.lockRef.current));
            }, []);
          a.useEffect(function () {
            return xi.push(i), e.setCallbacks({
              onScrollCapture: p,
              onWheelCapture: p,
              onTouchMoveCapture: h
            }), document.addEventListener("wheel", u, di), document.addEventListener("touchmove", u, di), document.addEventListener("touchstart", d, di), function () {
              xi = xi.filter(function (e) {
                return e !== i;
              }), document.removeEventListener("wheel", u, di), document.removeEventListener("touchmove", u, di), document.removeEventListener("touchstart", d, di);
            };
          }, []);
          var f = e.removeScrollBar,
            m = e.inert;
          return a.createElement(a.Fragment, null, m ? a.createElement(i, {
            styles: bi(o)
          }) : null, f ? a.createElement(li, {
            gapMode: "margin"
          }) : null);
        }, Xo.useMedium(Ci), Wo);
        var Ci,
          Si = a.forwardRef(function (e, t) {
            return a.createElement(Jo, (0, qo.pi)({}, e, {
              ref: t,
              sideCar: Di
            }));
          });
        Si.classNames = Jo.classNames;
        const Ei = ["Enter", " "],
          _i = ["ArrowUp", "PageDown", "End"],
          Pi = "Menu",
          [ki, Ai, zi] = bo(Pi),
          [Ti, Oi] = lo(Pi, [zi, Eo, Lo]),
          [Ii, Fi] = (Eo(), Lo(), Ti(Pi)),
          [Mi, Ri] = Ti(Pi),
          ji = "MenuPortal",
          [Bi, Ni] = Ti(ji, {
            forceMount: void 0
          }),
          Li = "MenuContent",
          [Vi, Ki] = Ti(Li),
          qi = "MenuRadioGroup",
          [Hi, Ui] = Ti(qi, {
            value: void 0,
            onValueChange: () => {}
          }),
          Zi = "MenuItemIndicator",
          [$i, Gi] = Ti(Zi, {
            checked: !1
          }),
          Wi = "MenuSub",
          [Yi, Xi] = Ti(Wi);
        const Qi = "DropdownMenu",
          [Ji, ea] = lo(Qi, [Oi]),
          [ta, na] = (Oi(), Ji(Qi));
        n(95189), n(58729);
      },
      39236: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => Xe
        });
        var r = n(35369),
          o = n(15359),
          i = n(82654),
          a = n(96156),
          s = n(69847),
          l = n(44550),
          u = n(52163);
        function c(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function d(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? c(Object(n), !0).forEach(function (t) {
              (0, a.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const p = "You need the text comparison license component to use this feature.",
          h = "The text comparison feature is only available in Standalone mode.";
        var f = n(66327),
          m = n(36828),
          g = n(33622),
          v = n(67041),
          y = n(84293),
          b = n(12705),
          w = n(93113),
          x = n(68944),
          D = n(40084),
          C = n(70025),
          S = n(44077),
          E = n(33056),
          _ = n(73900),
          P = n(89637),
          k = n(4087),
          A = n(53416),
          z = n(79724);
        const T = (0, z.Z)("ToolbarItems");
        var O = n(4715),
          I = n(54103),
          F = n(33427),
          M = n(5130);
        const R = ["annotationSelection.change"];
        var j = n(45249),
          B = n(56573),
          N = n(20388),
          L = n(17078),
          V = n(7654);
        const K = (0, z.Z)("Annotations");
        var q = n(23951);
        const H = (0, z.Z)("Bookmarks");
        var U = n(4480),
          Z = n(55012);
        var $ = n(56874);
        const G = (0, z.Z)("CustomOverlayItem");
        var W = n(43069),
          Y = n(28018),
          X = n(77897);
        const Q = (0, z.Z)("Forms");
        var J = n(21753);
        var ee = n(38252),
          te = n(21693);
        const ne = (0, z.Z)("InkSignatures"),
          re = ["inkSignatures.create", "inkSignatures.update", "inkSignatures.delete", "inkSignatures.change"],
          oe = ["storedSignatures.create", "storedSignatures.update", "storedSignatures.delete", "storedSignatures.change"];
        var ie = n(10983),
          ae = n(21853);
        const se = (0, z.Z)();
        async function le(e, t, n) {
          var r;
          if ("object" != typeof e || "number" != typeof e.width && "number" != typeof e.height) throw new o.p2("The first argument must be an object with either `width` or `height` set to a number.");
          if ("width" in e && "height" in e) throw new o.p2("The first argument can't contain both `height` and `width` propeties at the same time.");
          if ("width" in e && "number" != typeof e.width) throw new o.p2("`width` must be a number.");
          if ("height" in e && "number" != typeof e.height) throw new o.p2("`height` must be a number.");
          se("number" == typeof t, "pageIndex must be a number."), await (null === (r = n.getState().annotationManager) || void 0 === r ? void 0 : r.loadAnnotationsForPageIndex(t));
          const i = n.getState(),
            a = i.pages.get(t);
          se(a, `Could not find page with index ${t} in this document.`);
          const {
            pageSize: s
          } = a;
          let l, u;
          "width" in e && "number" == typeof e.width && e.width > 0 && e.width <= ie.Qr ? (l = Math.round(e.width), u = Math.round(l * s.height / s.width)) : "height" in e && "number" == typeof e.height && e.height > 0 && e.height <= ie.Qr ? (u = Math.round(e.height), l = Math.round(u * s.width / s.height)) : se(!1, `Could not calculate cover dimensions. Values must be in the interval \`(0; ${ie.Qr}]\`.`);
          const c = i.annotations.filter(e => e.pageIndex === t && !(e instanceof j.Jn || e instanceof j.On && i.commentThreads.has(e.id))).toList(),
            d = i.formFields.filter(e => e.annotationIds.some(e => {
              const n = i.annotations.get(e);
              return !(!n || n.pageIndex !== t);
            })),
            p = (0, W.Qg)(d);
          se(i.backend);
          const {
              promise: h
            } = i.backend.corePDFBridge.renderTile(t, new j.$u({
              width: l,
              height: u
            }), new j.UL({
              width: l,
              height: u
            }), !1, !0, {
              annotations: c,
              formFieldValues: p,
              formFields: d.toList(),
              attachments: i.attachments,
              signatures: i.digitalSignatures && i.digitalSignatures.signatures
            }),
            {
              element: f
            } = await h;
          return {
            element: f,
            width: l,
            height: u
          };
        }
        var ue = n(18287),
          ce = n(13422),
          de = n(96650),
          pe = n(5709),
          he = n(82716);
        const fe = ["search.stateChange", "search.termChange"];
        var me = n(30006);
        const ge = (0, z.Z)("StampAnnotationTemplates");
        var ve = n(1990),
          ye = n(20253),
          be = n(6197);
        function we(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xe(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? we(Object(n), !0).forEach(function (t) {
              (0, a.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : we(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const De = (0, z.Z)("ToolbarItems");
        var Ce = n(38705);
        var Se = n(86037),
          Ee = n(35727),
          _e = n(35464);
        var Pe = n(41172);
        function ke(e) {
          return e instanceof r.aV ? e.toArray() : Array.isArray(e) ? [...e] : [e];
        }
        function Ae(e, t) {
          return "STANDALONE" !== e.type ? t() : (e.setFormJSONUpdateBatchMode(!0), t().finally(() => {
            e.setFormJSONUpdateBatchMode(!1);
          }));
        }
        var ze = n(49876);
        const Te = ["history.undo", "history.redo", "history.change", "history.willChange", "history.clear"];
        var Oe = n(75287),
          Ie = n(65652),
          Fe = n(713);
        const Me = (0, z.Z)("DocumentEditorFooterItem");
        var Re = n(3792);
        const je = ["documentComparisonUI.start", "documentComparisonUI.end"];
        var Be = n(8210);
        var Ne = n(17310),
          Le = n(58163),
          Ve = n(44156),
          Ke = n(2891),
          qe = n(4526),
          He = n(55752),
          Ue = n(11267);
        const Ze = (0, z.Z)(),
          $e = ["instant.connectedClients.change", "page.press", "textLine.press", "annotationPresets.update", "annotationNote.hover", "annotationNote.press"],
          Ge = [function (e, t) {
            Object.defineProperty(t, "editableAnnotationTypes", {
              enumerable: !0,
              configurable: !1,
              get: () => e.getState().editableAnnotationTypes
            }), t.setEditableAnnotationTypes = function (t) {
              if (!Array.isArray(t)) throw new o.p2("editableAnnotationTypes must be an array of annotation types.");
              if (!t.every(e => e && e.prototype && (e.prototype instanceof q.Z || e == q.Z))) throw new o.p2("editableAnnotationTypes must be an array of annotation types.");
              e.dispatch((0, f.ZV)((0, r.l4)(t)));
            }, t.setIsEditableAnnotation = function (t) {
              if ("function" != typeof t) throw new o.p2("The type for isEditableAnnotation is not valid. Must be `function`.");
              e.dispatch((0, f.R1)(t));
            };
          }, function (e, t) {
            const n = () => e.getState().annotationPresets;
            Object.defineProperty(t, "annotationPresets", {
              enumerable: !0,
              configurable: !1,
              get: () => n().toObject()
            }), Object.defineProperty(t, "currentAnnotationPreset", {
              enumerable: !0,
              configurable: !1,
              get: () => e.getState().currentItemPreset
            }), t.setAnnotationPresets = function (t) {
              let o = t;
              "function" == typeof t && (o = t.call(null, n().toObject())), T("object" == typeof o, `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not an object.`), Object.values(o).forEach(A.G);
              const i = (0, r.D5)(o);
              n().equals(i) || e.dispatch((0, k.QA)(i));
            }, t.setCurrentAnnotationPreset = function (t) {
              const n = e.getState();
              "string" == typeof t && (0, o.kG)(void 0 !== n.annotationPresets.get(t), `There is no annotation preset with the supplied 'annotationPresetID' ${t}`), e.dispatch((0, k.Ds)(t));
            };
          }, function (e, t) {
            const n = () => [...e.getState().stampAnnotationTemplates];
            Object.defineProperty(t, "stampAnnotationTemplates", {
              enumerable: !0,
              configurable: !1,
              get: () => n()
            }), t.setStampAnnotationTemplates = function (t) {
              let r = t;
              "function" == typeof r && (r = r.call(null, n())), ge(Array.isArray(r), `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not an array.`), r.forEach(me.wB);
              const o = n();
              JSON.stringify(o) !== JSON.stringify(r) && e.dispatch((0, k.fx)([...r]));
            };
          }, Ce.ZP, function (e, t) {
            const n = () => e.getState().toolbarItems;
            Object.defineProperty(t, "toolbarItems", {
              enumerable: !0,
              configurable: !1,
              get: () => n().toJS()
            }), t.setToolbarItems = function (t) {
              let i = t;
              "function" == typeof i && (i = i.call(null, n().toJS())), De(Array.isArray(i), `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not an array.`), i = i.map(e => "ink-signature" === e.type ? ((0, o.a1)("The 'ink-signature' toolbar item type has been renamed to 'signature'. The 'ink-signature' identifier will be removed on a future release of PSPDFKit for Web."), xe(xe({}, e), {}, {
                type: "signature"
              })) : e), i.forEach(be.G);
              const a = (0, r.d0)(i);
              n().equals(a) || e.dispatch((0, ye.De)(a));
            }, t.setAnnotationToolbarItems = t => {
              (0, o.kG)("function" == typeof t, "The annotationToolbarItemsCallback argument must be a function."), e.dispatch((0, ye.v1)(t));
            };
          }, function (e, t) {
            const n = function (e) {
              const {
                eventEmitter: t
              } = e.getState();
              t.events.push("annotations.willChange", "annotations.change", "annotations.willSave", "annotations.didSave", "annotations.load", "annotations.create", "annotations.update", "annotations.delete", "annotations.press", "annotations.focus", "annotations.blur", "annotations.transform", "annotations.cut", "annotations.copy", "annotations.paste", "annotations.duplicate");
              let n = e.getState().annotations;
              const r = () => t.emit("annotations.willSave"),
                o = () => t.emit("annotations.didSave"),
                i = e => t.emit("annotations.load", e),
                a = e => t.emit("annotations.create", e),
                s = e => t.emit("annotations.update", e),
                l = e => t.emit("annotations.delete", e);
              let u = !1;
              const c = () => {
                  if (!u) {
                    const {
                      annotationManager: t
                    } = e.getState();
                    t && (t.eventEmitter.on("willSave", r), t.eventEmitter.on("didSave", o), t.eventEmitter.on("load", i), t.eventEmitter.on("create", a), t.eventEmitter.on("update", s), t.eventEmitter.on("delete", l), u = !0);
                  }
                },
                d = e.subscribe(() => {
                  const r = e.getState().annotations;
                  n !== r && (n = r, t.emit("annotations.change")), c();
                });
              return c(), () => {
                if (u) {
                  const {
                    annotationManager: t
                  } = e.getState();
                  K(t, "AnnotationManager is not present in the state"), t.eventEmitter.off("willSave", r), t.eventEmitter.off("didSave", o), t.eventEmitter.off("load", i), t.eventEmitter.off("create", a), t.eventEmitter.off("update", s), t.eventEmitter.off("delete", l), u = !1;
                }
                d();
              };
            }(e);
            return t.getAnnotations = async function (t) {
              K("number" == typeof t, "`pageIndex` must be a number");
              const {
                annotationManager: n,
                totalPages: r
              } = e.getState();
              K(t > -1 && t < r, "`pageIndex` must be a number between 0 and " + (r - 1)), await (null == n ? void 0 : n.loadAnnotationsForPageIndex(t));
              const {
                annotations: o
              } = e.getState();
              return o.filter(e => e.pageIndex === t).toList();
            }, t.createAttachment = async function (t) {
              const {
                  hash: n
                } = await (0, B.uq)(t),
                r = new j.Pg({
                  data: t
                });
              return e.dispatch((0, L.O)({
                hash: n,
                attachment: r
              })), n;
            }, t.getAttachment = async function (t) {
              if (!(0, F.F3)(t)) throw new o.p2(`${t} is not a valid attachment.`);
              const n = e.getState(),
                r = n.attachments.get(t);
              if (r) {
                if (r.data) return r.data;
                throw new o.p2(`Attachment ${t} not found.`);
              }
              return K(n.backend), n.backend.getAttachment(t);
            }, t.calculateFittingTextAnnotationBoundingBox = function (t) {
              K(t instanceof O.gd, "The annotation in `calculateFittingTextAnnotationBoundingBox(annotation)` must be of type `PSPDFKit.Annotations.TextAnnotation`"), K("number" == typeof t.pageIndex, "`pageIndex` must be a number");
              const {
                  viewportState: n,
                  shadowRoot: r
                } = e.getState(),
                o = n.pageSizes.get(t.pageIndex);
              return K(o, "`pageIndex` is not a valid page index in the open document"), (0, N.Zv)(t, o, void 0, r);
            }, t.getEmbeddedFiles = async function () {
              const {
                backend: t
              } = e.getState();
              return K(t), t.getEmbeddedFiles();
            }, t.setOnAnnotationResizeStart = function (t) {
              e.dispatch((0, k.dt)(t));
            }, t.getOverlappingAnnotations = async function (t) {
              K(t instanceof O.q6 || t instanceof V.ZP, "Argument must be an annotation or a form field");
              const {
                annotationManager: n,
                annotations: o
              } = e.getState();
              if (t instanceof V.ZP) {
                const i = t.annotationIds ? t.annotationIds : (0, r.aV)(),
                  a = o.valueSeq().toList().filter(e => i.includes(e.id) || i.includes(String(e.pdfObjectId))),
                  s = a.map(e => e.pageIndex),
                  l = s.filter((e, t) => s.indexOf(e) === t);
                for (let e = 0; e < l.size; e++) {
                  const t = l.get(e);
                  t && (await (null == n ? void 0 : n.loadAnnotationsForPageIndex(t)));
                }
                const u = e.getState().annotations.valueSeq().toList().filter(e => a.some(t => t.pageIndex === e.pageIndex)).filter(e => !(e instanceof O.x_ && e.formFieldName !== t.formFieldName));
                let c,
                  d = (0, r.aV)();
                return u.size > 0 && (c = a.map(e => e.boundingBox), d = u.filter(e => c.some(t => e.boundingBox.isRectOverlapping(t)))), d;
              }
              {
                await (null == n ? void 0 : n.loadAnnotationsForPageIndex(t.pageIndex));
                const {
                  annotations: r
                } = e.getState();
                return r.filter(e => !(e.id === t.id)).filter(e => e.boundingBox.isRectOverlapping(t.boundingBox) && e.pageIndex === t.pageIndex).valueSeq().toList();
              }
            }, n;
          }, function (e, t) {
            const n = function (e) {
              const {
                eventEmitter: t
              } = e.getState();
              t.events.push("bookmarks.change", "bookmarks.willSave", "bookmarks.didSave", "bookmarks.load", "bookmarks.create", "bookmarks.update", "bookmarks.delete");
              const n = () => t.emit("bookmarks.change"),
                r = () => t.emit("bookmarks.willSave"),
                o = () => t.emit("bookmarks.didSave"),
                i = e => t.emit("bookmarks.load", e),
                a = e => t.emit("bookmarks.create", e),
                s = e => t.emit("bookmarks.update", e),
                l = e => t.emit("bookmarks.delete", e);
              let u = !1;
              const c = () => {
                  if (!u) {
                    const {
                      bookmarkManager: t
                    } = e.getState();
                    t && (t.eventEmitter.on("change", n), t.eventEmitter.on("willSave", r), t.eventEmitter.on("didSave", o), t.eventEmitter.on("load", i), t.eventEmitter.on("create", a), t.eventEmitter.on("update", s), t.eventEmitter.on("delete", l), u = !0);
                  }
                },
                d = e.subscribe(c);
              return c(), () => {
                if (u) {
                  const {
                    bookmarkManager: t
                  } = e.getState();
                  t.eventEmitter.off("change", n), t.eventEmitter.off("willSave", r), t.eventEmitter.off("didSave", o), t.eventEmitter.off("load", i), t.eventEmitter.off("create", a), t.eventEmitter.off("update", s), t.eventEmitter.off("delete", l), u = !1;
                }
                d();
              };
            }(e);
            return t.getBookmarks = async function () {
              var t;
              const n = await (null === (t = e.getState().bookmarkManager) || void 0 === t ? void 0 : t.getBookmarks());
              return H(n), n.toList();
            }, n;
          }, function (e, t) {
            const n = function (e) {
              const {
                eventEmitter: t
              } = e.getState();
              t.events.push("formFieldValues.update", "formFieldValues.willSave", "formFieldValues.didSave", "forms.willSubmit", "forms.didSubmit", "formFields.change", "formFields.willSave", "formFields.didSave", "formFields.load", "formFields.create", "formFields.update", "formFields.delete");
              const n = e.getState();
              let {
                formFields: r
              } = n;
              const o = () => t.emit("formFieldValues.willSave"),
                i = () => t.emit("formFieldValues.didSave"),
                a = e => t.emit("formFieldValues.update", e),
                s = e => t.emit("forms.willSubmit", e),
                l = e => t.emit("forms.didSubmit", e),
                u = () => t.emit("formFields.willSave"),
                c = () => t.emit("formFields.didSave"),
                d = e => t.emit("formFields.load", e),
                p = e => t.emit("formFields.create", e),
                h = e => t.emit("formFields.update", e),
                f = e => t.emit("formFields.delete", e);
              let m = !1,
                g = !1;
              const v = () => {
                  const t = e.getState();
                  if (!m) {
                    const {
                      formFieldValueManager: e
                    } = t;
                    e && (e.eventEmitter.on("willSave", o), e.eventEmitter.on("didSave", i), e.eventEmitter.on("update", a), e.eventEmitter.on("willSubmit", s), e.eventEmitter.on("didSubmit", l), m = !0);
                  }
                  if (!g) {
                    const {
                      formFieldManager: e
                    } = t;
                    e && (0, b.ix)(t) && (e.eventEmitter.on("willSave", u), e.eventEmitter.on("didSave", c), e.eventEmitter.on("load", d), e.eventEmitter.on("create", p), e.eventEmitter.on("update", h), e.eventEmitter.on("delete", f), g = !0);
                  }
                },
                y = e.subscribe(() => {
                  const n = e.getState().formFields;
                  r !== n && (r = n, t.emit("formFields.change")), v();
                });
              return v(), () => {
                if (m) {
                  const {
                    formFieldValueManager: t
                  } = e.getState();
                  t.eventEmitter.off("willSave", o), t.eventEmitter.off("didSave", i), t.eventEmitter.off("update", a), t.eventEmitter.off("willSubmit", s), t.eventEmitter.off("didSubmit", l), m = !1;
                }
                if (g) {
                  const {
                    formFieldManager: t
                  } = e.getState();
                  t.eventEmitter.off("willSave", u), t.eventEmitter.off("didSave", c), t.eventEmitter.off("load", d), t.eventEmitter.off("create", p), t.eventEmitter.off("update", h), t.eventEmitter.off("delete", f), g = !1;
                }
                y();
              };
            }(e);
            return t.getFormFields = async function () {
              const {
                features: t,
                formFieldManager: n,
                formsEnabled: r
              } = e.getState();
              Q(t.includes(l.q.FORMS), M.DR), Q(r, M.BZ), n instanceof Y.c && (await n.loadFormFields());
              const {
                formFields: o
              } = e.getState();
              return o.valueSeq().toList();
            }, t.getFormFieldValues = function () {
              const {
                formFields: t,
                features: n,
                formsEnabled: o
              } = e.getState();
              return Q(n.includes(l.q.FORMS), M.DR), Q(o, M.BZ), (0, W.Qg)(t).reduce((e, t) => (e[t.name] = t.value instanceof r.aV ? t.value.toJS() : t.value, e), {});
            }, t.setFormFieldValues = async function (t) {
              const {
                formFieldManager: n,
                features: o,
                formsEnabled: i
              } = e.getState();
              Q(o.includes(l.q.FORMS), M.DR), Q(i, M.BZ), n instanceof Y.c && (await n.loadFormFields());
              const {
                  formFields: a
                } = e.getState(),
                s = Object.keys(t).map(e => {
                  const n = a.get(e);
                  Q(a.has(e), `Tried to set the form field value for form field \`${e}\` which does not exist.`);
                  const o = Array.isArray(t[e]) ? (0, r.aV)(t[e]) : t[e];
                  return n && (0, M._1)(n, o), {
                    name: e,
                    value: o,
                    optionIndexes: void 0
                  };
                });
              return new Promise(t => {
                e.dispatch((0, X.xh)(s, t));
              }).then(() => {}).catch(e => {
                throw e;
              });
            }, t.setOnWidgetAnnotationCreationStart = function (t) {
              const {
                features: n
              } = e.getState();
              Q("function" == typeof t, "The callback must be a function."), Q(n.includes(l.q.FORMS), M.DR), Q(n.includes(l.q.FORM_DESIGNER), M.RB), e.dispatch((0, X.r$)(t));
            }, n;
          }, ve.Z, function (e, t) {
            function n() {
              const {
                selectedAnnotationIds: t,
                annotations: n
              } = e.getState();
              return (0, r.aV)(t.map(e => {
                const t = n.get(e);
                return (0, o.kG)(t), t;
              }));
            }
            function i(t, n) {
              if (!t) return void e.dispatch((0, P.fz)());
              const i = r.aV.isList(t) ? t : (0, r.aV)([t]),
                {
                  annotations: a
                } = e.getState(),
                s = e.getState(),
                u = i.map(t => {
                  const n = t instanceof O.q6 ? t.id : t;
                  (0, o.kG)("string" == typeof n, "annotationId must be a string"), (0, o.kG)(a.has(n), "Unknown annotationId. Either the annotation was not yet created or is not yet loaded from the annotation provider.");
                  const r = a.get(n);
                  return (0, o.kG)(r && (0, F.Fp)(r), "Annotations with the `noView` or `hidden` flag set cannot be selected."), r instanceof O.x_ && !s.formDesignMode ? e.dispatch((0, k.vy)(n)) : ((0, o.kG)(!(r instanceof O.x_) || s.features.includes(l.q.FORM_DESIGNER), `Cannot select PSPDFKit.Annotations.WidgetAnnotation: ${M.RB}`), (0, o.kG)(!(r instanceof O.x_) || (0, b.k_)(s.backend), `Cannot select PSPDFKit.Annotations.WidgetAnnotation: ${M.Bl}`)), n;
                });
              if (1 === u.size) {
                const t = a.get(u.first());
                e.dispatch((0, P.J4)(u.toSet(), t instanceof O.gd || t instanceof O.Qi ? n : I.o.SELECTED));
              } else e.dispatch((0, P.J4)(u.toSet(), I.o.SELECTED));
            }
            t.getSelectedAnnotation = function () {
              (0, o.XV)("getSelectedAnnotation", "getSelectedAnnotations", !1);
              const e = n();
              return e.size > 0 ? e.first() : null;
            }, t.getSelectedAnnotations = function () {
              const e = n();
              return e.size > 0 ? e : null;
            }, t.setSelectedAnnotation = function (e) {
              (0, o.XV)("setSelectedAnnotation", "setSelectedAnnotations", !1), i(e, I.o.SELECTED);
            }, t.setSelectedAnnotations = function (e) {
              i(e, I.o.SELECTED);
            }, t.groupAnnotations = function (t) {
              if (!t || 0 === (null == t ? void 0 : t.size)) return;
              const n = null == t ? void 0 : t.map(e => e instanceof O.q6 ? e.id : e);
              e.dispatch((0, f._R)(n.toSet()));
            }, t.getAnnotationsGroups = function () {
              const {
                annotationsGroups: t
              } = e.getState();
              return t.size >= 1 ? t : null;
            }, t.deleteAnnotationsGroup = function (t) {
              t && e.dispatch((0, f.UZ)(t));
            }, t.setEditingAnnotation = function (t, n) {
              e.dispatch((0, P.fz)()), !0 === n && e.dispatch((0, P.Y1)()), i(t, I.o.EDITING);
            };
            let a = n();
            const {
              eventEmitter: s
            } = e.getState();
            return s.events.push(...R), e.subscribe(() => {
              const e = n();
              a.every(t => e.some(e => e.id === t.id)) && a.size === e.size ? a = e : (a = e, s.emit("annotationSelection.change", e));
            });
          }, function (e, t) {
            t.setCustomOverlayItem = function (t) {
              G(t instanceof $.Z, "invalid item. Expected an instance of PSPDFKit.CustomOverlayItem"), (0, $.G)(t), e.dispatch((e => ({
                type: Z.jJ7,
                item: e
              }))(t));
            }, t.removeCustomOverlayItem = function (t) {
              G("string" == typeof t, "`id` must be a string"), e.dispatch((e => ({
                type: Z.G8_,
                id: e
              }))(t));
            };
          }, function (e, t) {
            t.setLocale = async function (t) {
              const n = (0, J.z5)(t);
              await (0, J.sS)(n), e.dispatch((0, f.i_)(n));
            }, Object.defineProperty(t, "locale", {
              enumerable: !0,
              configurable: !1,
              get: () => e.getState().locale
            });
          }, function (e, t) {
            const n = () => e.getState().searchState;
            t.search = async function (t) {
              let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              const {
                  backend: r,
                  totalPages: o,
                  searchState: {
                    minSearchQueryLength: i
                  }
                } = e.getState(),
                a = null != n.startPageIndex ? n.startPageIndex : 0,
                s = null != n.endPageIndex ? n.endPageIndex : o - 1,
                l = n.searchType || de.S.TEXT,
                u = n.searchInAnnotations || !1,
                c = "boolean" == typeof n.caseSensitive ? n.caseSensitive : l !== de.S.TEXT;
              return (0, he.k)(Object.values(de.S).includes(l), "searchType is not valid."), l === de.S.PRESET && (0, he.k)(Object.values(pe.n).includes(t), "search query is not a valid search pattern."), (0, he.k)("number" == typeof a && "number" == typeof s, "startPageIndex/endPageIndex must be numbers"), (0, he.k)("boolean" == typeof u, "searchInAnnotations should be boolean"), (0, he.k)(void 0 === n.caseSensitive || "boolean" == typeof n.caseSensitive, "caseSensitive should be boolean"), (0, he.k)(s >= a, "endPageIndex must be greater than or equal to startPageIndex"), (0, he.k)(t.length >= i, `"${t}" - search query length (${t.length}) shorter than the minimum (${i})`), (0, he.k)(r), await r.search(t, a, s - a + 1, c, u, l);
            }, Object.defineProperty(t, "searchState", {
              enumerable: !0,
              configurable: !1,
              get: n
            }), t.setSearchState = function (t) {
              let i = t;
              if ("function" == typeof i && (i = i.call(null, n())), !(i instanceof ce.Z)) {
                const e = "function" == typeof i ? "return value of your update function" : "supplied argument";
                throw new o.p2(`The ${e} is not an instance of PSPDFKit.SearchState.`);
              }
              const a = n();
              i.minSearchQueryLength !== a.minSearchQueryLength && ((0, o.ZK)(`Trying to set readonly property SearchState.minSearchQueryLength from ${a.minSearchQueryLength} to ${i.minSearchQueryLength} failed. For more details please see https://pspdfkit.com/api/web/PSPDFKit.SearchState.html#minSearchQueryLength`), i = i.set("minSearchQueryLength", a.minSearchQueryLength)), function (e) {
                if ("boolean" != typeof e.isFocused) throw new o.p2("`isFocused` must be of type boolean.");
                if ("boolean" != typeof e.isLoading) throw new o.p2("`isLoading` must be of type boolean.");
                if ("string" != typeof e.term) throw new o.p2("`term` must be of type string.");
                if ("number" != typeof e.focusedResultIndex) throw new o.p2("`focusedResultIndex` must be of type number.");
                if (!(e.results instanceof r.aV)) throw new o.p2("`results` must be of type PSPDFKit.Immutable.List.");
              }(i), function (e, t, n) {
                const {
                  dispatch: r
                } = e;
                t !== n && r((0, ue.j8)(n));
              }(e, n(), i);
            }, t.startUISearch = function (t) {
              const {
                  dispatch: n,
                  getState: r
                } = e,
                {
                  searchProvider: o,
                  eventEmitter: i,
                  searchState: {
                    minSearchQueryLength: a
                  }
                } = r();
              let s = !1;
              i.emit("search.termChange", {
                term: t,
                preventDefault: () => {
                  s = !0;
                }
              }), s || ((0, he.k)(t.length >= a, `"${t}" - search query length (${t.length}) shorter than the minimum (${a})`), n((0, ue.Xe)()), n((0, ue._8)(t)), null == o || o.searchTerm(t));
            };
            let i = e.getState();
            const {
              eventEmitter: a
            } = i;
            return a.events.push(...fe), e.subscribe(() => {
              const t = e.getState();
              i.searchState.equals(t.searchState) || a.emit("search.stateChange", t.searchState), i = t;
            });
          }, function (e, t) {
            t.renderPageAsArrayBuffer = async function (t, n) {
              const {
                element: r,
                width: o,
                height: i
              } = await le(t, n, e);
              let a;
              if (r instanceof HTMLImageElement) {
                const e = document.createElement("canvas");
                e.width = o, e.height = i, a = e.getContext("2d"), await (0, ae.sR)(r), a.drawImage(r, 0, 0, o, i);
              } else r instanceof HTMLCanvasElement ? a = r.getContext("2d") : se(!1, "There was an error while rendering the page. Please try again.");
              return a.getImageData(0, 0, o, i).data.buffer;
            }, t.renderPageAsImageURL = async function (t, n) {
              const {
                element: r
              } = await le(t, n, e);
              return r instanceof HTMLImageElement ? r.src : r instanceof HTMLCanvasElement ? URL.createObjectURL(await (0, ae._c)(r)) : void se(!1, "There was an error while generating the image URL. Please try again.");
            };
          }, function (e, t) {
            async function n() {
              let {
                storedSignatures: t
              } = e.getState().signatureState;
              if (!t) {
                const n = (0, te.de)();
                await n(e.dispatch, e.getState), t = e.getState().signatureState.storedSignatures;
              }
              return t || (0, r.aV)();
            }
            async function o(t) {
              let n = e.getState().signatureState.storedSignatures;
              const o = n instanceof r.aV;
              n || (n = await e.getState().signatureState.populateStoredSignatures());
              let i = t;
              "function" == typeof i && (i = i.call(null, n)), ne(i instanceof r.aV && i.every(e => e instanceof j.Zc || e instanceof j.sK), `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not a PSPDFKit.Immutable.List of PSPDFKit.Annotations.InkAnnotation or PSPDFKit.Annotations.ImageAnnotation`), o && n.equals(i) || (e.dispatch((0, te.nR)(i)), e.getState().eventEmitter.emit("inkSignatures.update", i), e.getState().eventEmitter.emit("inkSignatures.change"), e.getState().eventEmitter.emit("storedSignatures.update", i), e.getState().eventEmitter.emit("storedSignatures.change"));
            }
            e.getState().eventEmitter.events.push(...re, ...oe), t.getInkSignatures = async function () {
              return (0, ee.XV)("instance.getInkSignatures", "instance.getStoredSignatures"), n();
            }, t.getStoredSignatures = n, t.setInkSignatures = async function (e) {
              return (0, ee.XV)("instance.setInkSignatures", "instance.setStoredSignatures"), o(e);
            }, t.setStoredSignatures = o;
          }, U.Z, function (e, t) {
            t.setIsEditableComment = function (t) {
              (0, o.kG)("function" == typeof t, "The type for isEditableComment is not valid. Must be `function`."), e.dispatch((0, f.Gh)(t));
            };
          }, Se.Z, function (e, t) {
            const n = function (e) {
              const {
                eventEmitter: t
              } = e.getState();
              t.events.push("comments.change", "comments.willSave", "comments.didSave", "comments.load", "comments.create", "comments.update", "comments.delete", "comments.mention");
              const n = () => t.emit("comments.change"),
                r = () => t.emit("comments.willSave"),
                o = () => t.emit("comments.didSave"),
                i = e => t.emit("comments.load", e),
                a = e => t.emit("comments.create", e),
                s = e => t.emit("comments.update", e),
                l = e => t.emit("comments.delete", e);
              let u = !1;
              const c = () => {
                  if (!u) {
                    const {
                      commentManager: t
                    } = e.getState();
                    t && (t.eventEmitter.on("change", n), t.eventEmitter.on("willSave", r), t.eventEmitter.on("didSave", o), t.eventEmitter.on("load", i), t.eventEmitter.on("create", a), t.eventEmitter.on("update", s), t.eventEmitter.on("delete", l), u = !0);
                  }
                },
                d = e.subscribe(c);
              return c(), () => {
                if (u) {
                  const {
                    commentManager: t
                  } = e.getState();
                  t && (t.eventEmitter.off("change", n), t.eventEmitter.off("willSave", r), t.eventEmitter.off("didSave", o), t.eventEmitter.off("load", i), t.eventEmitter.off("create", a), t.eventEmitter.off("update", s), t.eventEmitter.off("delete", l)), u = !1;
                }
                d();
              };
            }(e);
            return t.getComments = async function () {
              const {
                  comments: t,
                  backend: n
                } = e.getState(),
                r = t.filter(e => !(0, Ee.kT)(e)).toList();
              return r.size || null == n || !n.isUsingInstantProvider() ? r : new Promise(t => {
                const n = setInterval(() => {
                  const {
                    hasFetchedInitialRecordsFromInstant: r,
                    comments: o
                  } = e.getState();
                  r && (clearInterval(n), t(o.filter(e => !(0, Ee.kT)(e)).toList()));
                }, 500);
              });
            }, t.setMentionableUsers = function (t) {
              e.dispatch((0, _e.v7)(t));
            }, t.setMaxMentionSuggestions = function (t) {
              e.dispatch((0, _e.aZ)(t));
            }, t.setOnCommentCreationStart = function (t) {
              (0, o.kG)("function" == typeof t, "The callback must be a function."), e.dispatch((0, _e.Rf)(t));
            }, n;
          }, Pe.Z, function (e, t) {
            const n = function (e) {
              const {
                eventEmitter: t
              } = e.getState();
              t.events.push("document.saveStateChange");
              const n = e => {
                t.emit("document.saveStateChange", e);
              };
              let r = !1;
              const i = () => {
                  if (!r) {
                    const {
                      changeManager: t
                    } = e.getState();
                    t && (t.eventEmitter.on("saveStateChange", n), r = !0);
                  }
                },
                a = e.subscribe(() => {
                  i();
                });
              return i(), () => {
                if (r) {
                  const {
                    changeManager: t
                  } = e.getState();
                  (0, o.kG)(t), t.eventEmitter.off("saveStateChange", n), r = !1;
                }
                a();
              };
            }(e);
            return t.save = async function () {
              const {
                changeManager: t
              } = e.getState();
              return (0, o.kG)(t), t.save(!0);
            }, t.hasUnsavedChanges = function () {
              const {
                changeManager: t
              } = e.getState();
              return (0, o.kG)(t), t.hasUnsavedChanges();
            }, t.syncChanges = async function () {
              const {
                backend: n
              } = e.getState();
              if ((0, o.kG)(n), !n.isUsingInstantProvider()) throw new o.p2("You need PSPDFKit Instant to use this method.");
              return t.save();
            }, t.create = async function (t) {
              const {
                changeManager: n,
                backend: r
              } = e.getState();
              return (0, o.kG)(n && r), Ae(r, () => n.create(ke(t)));
            }, t.update = async function (t) {
              const {
                changeManager: n,
                backend: r
              } = e.getState();
              return (0, o.kG)(n && r), Ae(r, () => n.update(ke(t)));
            }, t.delete = async function (t) {
              const {
                changeManager: n,
                backend: r
              } = e.getState();
              return (0, o.kG)(n && r), Ae(r, () => n.delete(ke(t)));
            }, t.ensureChangesSaved = async function (t) {
              const {
                changeManager: n,
                backend: r
              } = e.getState();
              return (0, o.kG)(n && r), "STANDALONE" === (null == r ? void 0 : r.type) && (await (null == r ? void 0 : r.setFormJSONUpdateBatchMode(!1))), n.ensureChangesSaved(ke(t));
            }, n;
          }, Pe.Z, function (e, t) {
            t.setGroup = function (t) {
              const {
                backend: n
              } = e.getState();
              null != n && n.isCollaborationPermissionsEnabled() ? e.dispatch((0, f.YK)(t)) : (0, o.ZK)("`instance.setGroup` is no-op if Collaboration Permissions is not enabled.");
            }, t.resetGroup = function () {
              const {
                backend: t
              } = e.getState();
              null != t && t.isCollaborationPermissionsEnabled() ? e.dispatch((0, f.YK)(t.getDefaultGroup())) : (0, o.ZK)("`instance.setGroup` is no-op if Collaboration Permissions is not enabled.");
            };
          }, function (e, t) {
            const n = () => e.getState().documentEditorFooterItems,
              o = () => e.getState().documentEditorToolbarItems;
            Object.defineProperty(t, "documentEditorFooterItems", {
              enumerable: !0,
              configurable: !1,
              get: () => n().toJS()
            }), Object.defineProperty(t, "documentEditorToolbarItems", {
              enumerable: !0,
              configurable: !1,
              get: () => o().toJS()
            }), t.setDocumentEditorFooterItems = function (t) {
              const {
                features: o
              } = e.getState();
              (0, he.k)(o.includes(l.q.DOCUMENT_EDITING), U.I);
              let i = t;
              "function" == typeof i && (i = i(n().toJS())), Me(Array.isArray(i), `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not an array.`), i.forEach(Ie.G);
              const a = (0, r.d0)(i);
              var s;
              n().equals(a) || e.dispatch((s = a, {
                type: Z.Kpf,
                documentEditorFooterItems: s
              }));
            }, t.setDocumentEditorToolbarItems = function (t) {
              const {
                features: n
              } = e.getState();
              (0, he.k)(n.includes(l.q.DOCUMENT_EDITING), U.I);
              let i = t;
              "function" == typeof i && (i = i(o().toJS())), Me(Array.isArray(i), `The ${"function" == typeof t ? "return value of your update function" : "supplied argument"} is not an array.`), i.forEach(Fe.G);
              const a = (0, r.d0)(i);
              var s;
              o().equals(a) || e.dispatch((s = a, {
                type: Z.wPI,
                documentEditorToolbarItems: s
              }));
            };
          }, function (e, t) {
            function n() {
              const {
                isHistoryEnabled: t,
                undoActions: n
              } = e.getState();
              return t && n.size > 0;
            }
            function r() {
              const {
                isHistoryEnabled: t,
                redoActions: n
              } = e.getState();
              return t && n.size > 0;
            }
            e.getState().eventEmitter.events.push(...Te), t.history = {}, t.history.undo = async function () {
              return !!n() && (e.dispatch((0, ze.Yw)()), !0);
            }, t.history.redo = async function () {
              return !!r() && (e.dispatch((0, ze.KX)()), !0);
            }, t.history.canUndo = function () {
              return n();
            }, t.history.canRedo = function () {
              return r();
            }, t.history.clear = function () {
              e.dispatch((0, ze.QQ)());
            }, t.history.enable = function () {
              e.dispatch((0, ze.z9)());
            }, t.history.disable = function () {
              e.dispatch((0, ze.ou)());
            };
          }, function (e, t) {
            t.parseXFDF = async (t, n) => {
              const {
                backend: r
              } = e.getState();
              return (0, o.kG)(r, "backend is null."), (0, o.kG)("STANDALONE" === r.type, "`instance.parseXFDF` only works in standalone mode."), r.parseXFDF(t, null != n && n);
            };
          }, function (e, t) {
            e.getState().eventEmitter.events.push(...je), t.setDocumentComparisonMode = async function (t) {
              const {
                features: n,
                backend: r,
                viewportState: {
                  documentComparisonMode: i
                }
              } = e.getState();
              if ((0, o.kG)(n.includes(l.q.DOCUMENT_COMPARISON), u.nN), (0, o.kG)("STANDALONE" === (null == r ? void 0 : r.type), u.bZ), function (e) {
                if ("object" != typeof e) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration` must be a `PSPDFKit.DocumentComparisonConfiguration` plain object, or `null`.");
                if (null === e) return;
                if ("boolean" != typeof e.autoCompare) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration.autoCompare` must be a boolean value.");
                if ("object" != typeof e.documentA || null === e.documentA) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration.documentA` must be a plain object.");
                if ("object" != typeof e.documentB || null === e.documentB) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration.documentB` must be a plain object.");
                if (!("string" == typeof e.documentA.source || e.documentA.source instanceof ArrayBuffer || e.documentA.source instanceof Promise)) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration.documentA#source` must be a string, an ArrayBuffer or a Promise object resolving to a string or an ArrayBuffer.");
                if (!("string" == typeof e.documentB.source || e.documentB.source instanceof ArrayBuffer || e.documentB.source instanceof Promise)) throw new o.p2("`PSPDFKit.DocumentComparisonConfiguration.documentB#source` must be a string, an ArrayBuffer or a Promise object resolving to a string or an ArrayBuffer.");
                if (void 0 !== e.documentA.pageIndex && "number" != typeof e.documentA.pageIndex) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.documentA#pageIndex` must be a number.");
                if (void 0 !== e.documentB.pageIndex && "number" != typeof e.documentB.pageIndex) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.documentB#pageIndex` must be a number.");
                if (void 0 !== e.blendMode && !Object.values(Re.b).includes(e.blendMode)) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.blendMode` must be a `PSPDFKit.BlendMode`.");
                if (void 0 !== e.strokeColors && ("object" != typeof e.strokeColors || null === e.strokeColors)) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.strokeColors` must be a plain object.");
                if ("object" == typeof e.strokeColors) {
                  if (void 0 !== e.strokeColors.documentA && !(e.strokeColors.documentA instanceof j.Il)) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.strokeColors#documentA` must be a `PSPDFKit.Color` value.");
                  if (void 0 !== e.strokeColors.documentB && !(e.strokeColors.documentB instanceof j.Il)) throw new o.p2("If provided, `PSPDFKit.DocumentComparisonConfiguration.strokeColors#documentB` must be a `PSPDFKit.Color` value.");
                  e.strokeColors.documentA && e.strokeColors.documentB && e.strokeColors.documentA.equals(e.strokeColors.documentB) && (0, o.ZK)("The values provided for `PSPDFKit.DocumentComparisonConfiguration.strokeColors#documentA` and `PSPDFKit.DocumentComparisonConfiguration.strokeColors#documentB` are identical.");
                }
              }(t), t) e.dispatch((0, f.cz)(t));else if (i) {
                const {
                  completion: {
                    end: {
                      promise: t
                    }
                  }
                } = i;
                return e.dispatch((0, f.cz)(null)), t;
              }
            };
          }, function (e, t) {
            t.compareDocuments = async function (t, n) {
              var r;
              const {
                backend: i,
                features: a
              } = e.getState();
              if ("object" != typeof t || null === t) throw new o.p2("`comparisonDocuments` must be a plain object.");
              (0, o.kG)(a.includes(l.q.TEXT_COMPARISON), p), (0, o.kG)("STANDALONE" === (null == i ? void 0 : i.type), h);
              const c = await async function (e) {
                return (0, o.kG)(e.originalDocument.filePath), (0, o.kG)(e.changedDocument.filePath), {
                  originalDocument: d(d({}, (0, s.c)(e.originalDocument)), {}, {
                    arrayBuffer: await (0, u.rh)(e.originalDocument.filePath)
                  }),
                  changedDocument: d(d({}, (0, s.c)(e.changedDocument)), {}, {
                    arrayBuffer: await (0, u.rh)(e.changedDocument.filePath)
                  })
                };
              }(t);
              return (0, o.kG)(i), (0, o.kG)("STANDALONE" === i.type, "compareDocuments is only supported in the web standalone."), null === (r = i.compareDocuments) || void 0 === r ? void 0 : r.call(i, c, n);
            };
          }, function (e, t) {
            t.getPageTabOrder = async function (t) {
              const {
                pages: n,
                backend: r
              } = e.getState();
              if ((0, o.kG)(r), "STANDALONE" !== r.type) throw new o.p2("`instance.getTabOrder()` is only available in Standalone mode.");
              if ("number" != typeof t) throw new o.p2("pageIndex must be a number.");
              if (t >= n.size || t < 0) throw new o.p2(`pageIndex is out of bounds. Please provide a value between 0 and ${n.size - 1}.`);
              const i = n.get(t);
              if (!i) throw new o.p2(`Cannot retrieve tab order for page: page ${t} does not exist.`);
              if (i.tabOrder) return i.tabOrder;
              await r.provider.updateTabOrder(t);
              const {
                  pages: a
                } = e.getState(),
                s = a.get(t);
              if (!s) throw new o.p2(`Cannot retrieve tab order for page: page ${t} does not exist.`);
              if (!s.tabOrder) throw new o.p2(`Cannot retrieve tab order for page: page ${t} does not have a tab order.`);
              return s.tabOrder;
            }, t.setPageTabOrder = async function (t, n) {
              if ("function" != typeof n) throw new o.p2("annotationIdsSortCallback must be a function.");
              const {
                backend: r,
                annotations: i,
                pages: a
              } = e.getState();
              if ((0, o.kG)(r), "STANDALONE" !== r.type) throw new o.p2("`instance.getTabOrder()` is only available in Standalone mode.");
              if (!a.get(t)) throw new o.p2(`Cannot set tab order for page: page ${t} does not exist.`);
              const s = n((await this.getPageTabOrder(t)).map(e => i.get(e)).filter(Boolean));
              if (!Array.isArray(s)) throw new o.p2("annotationIdsSortCallback must return an array of annotation IDs.");
              const l = s.map(e => {
                const t = i.get(e);
                if (!t) throw new o.p2(`Annotation with ID ${e} does not exist.`);
                return {
                  id: t.id,
                  pdfObjectId: t.pdfObjectId
                };
              });
              return e.dispatch((0, k.N1)(t, l)), r.provider.setTabOrder(t, l);
            };
          }, Oe.ZP],
          We = "You need PSPDFKit Instant to use this method.",
          Ye = "You need to enable clients presence in your configuration (`instant: { clientsPresenceEnabled: true }`) to use this method.";
        class Xe {
          constructor(e) {
            let {
              store: t,
              backend: n,
              eventEmitter: a
            } = e;
            a.events.push(...$e);
            let s = !1;
            const u = Ge.map(e => e(t, this));
            let c = (0, r.D5)();
            t.dispatch((0, f.lW)(e => {
              s || (c = e.map(e => (0, g.B)(e)), a.emit("instant.connectedClients.change", c));
            })), Object.defineProperty(this, "totalPageCount", {
              enumerable: !0,
              configurable: !1,
              get: () => t.getState().totalPages
            }), this.pageInfoForIndex = function (e) {
              const n = t.getState().pages.get(e);
              return n ? (0, m.J)(n) : null;
            }, this.textLinesForPageIndex = async function (e) {
              const {
                promise: t
              } = n.textForPageIndex(e);
              return t;
            }, this.toggleClipboardActions = function (e) {
              Ze("boolean" == typeof e, "`toggleClipboardActions` expects a boolean as an argument"), t.dispatch((0, f.UG)(e));
            }, this.setMeasurementSnapping = function (e) {
              Ze("boolean" == typeof e, "`setMeasurementSnapping` expects a boolean as an argument"), Ze(t.getState().features.includes(l.q.MEASUREMENT_TOOLS), Ke.oD), t.dispatch((0, f.Gc)(e));
            }, this.setMeasurementPrecision = function (e) {
              Ze("string" == typeof e, "`setMeasurementPrecision` expects a string as an argument"), Ze(t.getState().features.includes(l.q.MEASUREMENT_TOOLS), Ke.oD), t.dispatch((0, f.M4)(e));
            }, this.setMeasurementScale = function (e) {
              Ze(e instanceof Le.Z, "`setMeasurementScale` expects an instance of `MeasurementScale` as an argument"), Ze(t.getState().features.includes(l.q.MEASUREMENT_TOOLS), Ke.oD), t.dispatch((0, f._b)(e));
            }, this.setMeasurementValueConfiguration = e => {
              Ze("function" == typeof e, "The `measurementValueConfigurationCallback` argument must be a function."), Ze(t.getState().features.includes(l.q.MEASUREMENT_TOOLS), Ke.oD), t.dispatch((0, f.QL)(e));
            }, this.getMarkupAnnotationText = async function (e) {
              return Ze(e instanceof v.Z, "annotation must be a PSPDFKit.Annotations.MarkupAnnotation"), n.getTextFromRects(e.pageIndex, e.rects);
            }, this.getTextFromRects = async function (e, t) {
              return Ze("number" == typeof e, "pageIndex must be a number"), Ze(t instanceof r.aV && t.every(e => e instanceof S.UL), "rects must be a PSPDFKit.Immutable.List of PSPDFKit.Geometry.Rect"), n.getTextFromRects(e, t);
            }, this.getDocumentPermissions = async function () {
              return (0, b.Pt)(t.getState());
            }, Object.defineProperty(this, "currentZoomLevel", {
              enumerable: !0,
              configurable: !1,
              get: () => t.getState().viewportState.zoomLevel
            }), Object.defineProperty(this, "annotationCreatorName", {
              enumerable: !0,
              configurable: !1,
              get: () => t.getState().annotationCreatorName
            }), Object.defineProperty(this, "maximumZoomLevel", {
              enumerable: !0,
              configurable: !1,
              get() {
                const {
                  viewportState: e
                } = t.getState();
                return (0, y.Sm)(e);
              }
            }), Object.defineProperty(this, "minimumZoomLevel", {
              enumerable: !0,
              configurable: !1,
              get() {
                const {
                  viewportState: e
                } = t.getState();
                return (0, y.Yo)(e);
              }
            }), Object.defineProperty(this, "zoomStep", {
              enumerable: !0,
              configurable: !1,
              get() {
                const {
                  viewportState: e
                } = t.getState();
                return e.zoomStep;
              }
            }), Object.defineProperty(this, "disablePointSnapping", {
              get() {
                const {
                  viewportState: e
                } = t.getState();
                return e.disablePointSnapping;
              }
            }), Object.defineProperty(this, "connectedClients", {
              enumerable: !0,
              configurable: !1,
              get: () => n.isUsingInstantProvider() ? n.hasClientsPresence() ? c : ((0, o.ZK)(Ye), (0, r.D5)()) : ((0, o.ZK)(We), (0, r.D5)())
            }), Object.defineProperty(this, "enableAlwaysScrollToZoom", {
              get() {
                const {
                  viewportState: e
                } = t.getState();
                return e.enableAlwaysScrollToZoom;
              }
            }), this.addEventListener = function (e, t) {
              Ze("instant.connectedClients.change" !== e || n.isUsingInstantProvider(), We), Ze("instant.connectedClients.change" !== e || n.hasClientsPresence(), Ye), Ze(!e.startsWith("comments.") || (0, b.xr)(n), We);
              const r = Qe(e);
              try {
                a.on(r, t);
              } catch (e) {
                throw new o.p2(e);
              }
            }, this.removeEventListener = function (e, t) {
              Ze("instant.connectedClients.change" !== e || n.isUsingInstantProvider(), We), Ze("instant.connectedClients.change" !== e || n.hasClientsPresence(), Ye);
              const r = Qe(e);
              try {
                a.off(r, t);
              } catch (e) {
                throw new o.p2(e);
              }
            }, this.jumpToRect = function (e, n) {
              const {
                totalPages: r
              } = t.getState();
              Ze(e >= 0 && e < r, `Could not find page with index ${e} in this document.`), Ze(n instanceof S.UL, "rect must be of type `PSPDFKit.Geometry.Rect`."), t.dispatch((0, D.kN)(e, n));
            }, this.jumpAndZoomToRect = function (e, n) {
              const {
                totalPages: r
              } = t.getState();
              Ze(e >= 0 && e < r, `Could not find page with index ${e} in this document.`), Ze(n instanceof S.UL, "rect must be of type `PSPDFKit.Geometry.Rect`."), t.dispatch((0, D.vP)(e, n));
            }, this.transformContentClientToPageSpace = function (e, n) {
              const {
                totalPages: r,
                viewportState: o
              } = t.getState();
              Ze(n >= 0 && n < r, `Could not find page with index ${n} in this document.`), Ze(e instanceof S.UL || e instanceof S.E9, "rectOrPoint must be of type `PSPDFKit.Geometry.Rect` or `PSPDFKit.Geometry.Point`.");
              const i = (0, w.Ek)(o, n);
              return e.apply(i);
            }, this.transformContentPageToClientSpace = function (e, n) {
              const {
                totalPages: r,
                viewportState: o
              } = t.getState();
              Ze(n >= 0 && n < r, `Could not find page with index ${n} in this document.`), Ze(e instanceof S.UL || e instanceof S.E9, "rectOrPoint must be of type `PSPDFKit.Geometry.Rect` or `PSPDFKit.Geometry.Point`.");
              const i = (0, w.cr)(o, n);
              return e.apply(i);
            }, this.transformClientToPageSpace = function (e, n) {
              const {
                totalPages: r,
                viewportState: o,
                rootElement: i
              } = t.getState();
              Ze(n >= 0 && n < r, `Could not find page with index ${n} in this document.`), Ze(e instanceof S.UL || e instanceof S.E9, "rectOrPoint must be of type `PSPDFKit.Geometry.Rect` or `PSPDFKit.Geometry.Point`.");
              const a = null == i ? void 0 : i.getBoundingClientRect(),
                s = (0, w.Ek)(o, n).translate({
                  x: -a.left,
                  y: -a.top
                });
              return e.apply(s);
            }, this.transformPageToClientSpace = function (e, n) {
              const {
                totalPages: r,
                viewportState: o,
                rootElement: i
              } = t.getState();
              Ze(n >= 0 && n < r, `Could not find page with index ${n} in this document.`), Ze(e instanceof S.UL || e instanceof S.E9, "rectOrPoint must be of type `PSPDFKit.Geometry.Rect` or `PSPDFKit.Geometry.Point`.");
              const a = null == i ? void 0 : i.getBoundingClientRect(),
                s = (0, w.cr)(o, n);
              return e.translate(new S.E9({
                x: a.left,
                y: a.top
              })).apply(s);
            }, this.transformRawToPageSpace = function (e, n) {
              Ze(null != n, "No page index was provided as second parameter to this function.");
              const {
                  pages: r
                } = t.getState(),
                o = r.get(n);
              Ze(o, `No page found with pageIndex ${n}`);
              let i = null;
              if (e instanceof S.eB) i = e;else {
                i = (0, Ne.r)(e);
                const t = i.top;
                i = i.set("top", i.bottom).set("bottom", t);
              }
              let a = i.apply(o.matrix);
              const s = S.UL.fromInset(a),
                l = a.top;
              return a = a.set("top", a.bottom).set("bottom", l), s.set("top", o.pageSize.height - a.top);
            }, this.transformPageToRawSpace = function (e, n) {
              Ze(null != n, "No page index was provided as second parameter to this function.");
              const {
                  pages: r
                } = t.getState(),
                o = r.get(n);
              Ze(o, `No page found with pageIndex ${n}`);
              let i = S.eB.fromRect(e);
              const {
                  height: a
                } = o.pageSize,
                s = a - i.top;
              i = i.set("top", s).set("bottom", s - e.height);
              const l = i.apply(o.reverseMatrix),
                u = l.top;
              return l.set("top", l.bottom).set("bottom", u);
            }, this.exportOffice = async function (e) {
              if (!e || !e.format || !Object.values(Ue._).includes(e.format)) throw new o.p2(`An object has to be passed to \`instance.exportOffice()\` specifying one of the supported output formats\n        in the \`format\` property: ${Object.values(Ue._).map(e => `PSPDFKit.OfficeDocumentFormat.${e}`).join(", ")}`);
              return n.exportOffice(e);
            }, this.exportPDF = async function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              const r = t.getState();
              if ((0, b.RZ)(r)) {
                var i;
                let t;
                return e.flattenElectronicSignatures && "STANDALONE" === n.type && (t = r.annotations.toList().filter(e => (e instanceof He.Z || e instanceof qe.Z) && e.isSignature).map(e => ({
                  pageIndex: e.pageIndex,
                  id: e.id,
                  pdfObjectId: e.pdfObjectId
                }))), n.exportPDF(e, null === (i = t) || void 0 === i ? void 0 : i.toArray());
              }
              throw new o.p2("This document permissions do not allow exporting.");
            }, this.exportXFDF = async function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
              return n.exportXFDF(e);
            }, this.exportInstantJSON = async function (e) {
              return n.exportInstantJSON(e);
            }, this._destroy = function () {
              u.filter(Boolean).forEach(e => {
                null == e || e();
              }), s = !0;
            }, this.print = function (e) {
              const n = t.getState(),
                {
                  isPrinting: r
                } = n,
                i = (0, b.VT)(n);
              e && "object" != typeof e && (0, o.ZK)("PSPDFKit.Instance.print: options must be an object. If you want to pass the `printMode`, use `{ mode: PSPDFKit.PrintMode.DOM }` instead.");
              const a = "object" == typeof e ? e.mode : e;
              if (!i) throw new o.p2("Tried to start a print job while printing is disabled.");
              if (r) throw new o.p2("Tried to start a print job while another one was already being processed.\nUse PSPDFKit.Instance#abortPrint to terminate the current print job.\n        ");
              if (a && !Object.prototype.hasOwnProperty.call(C.X, a)) throw new o.p2("The supplied printMode is not valid.\nValid `printMode`s are: PSPDFKit.PrintMode.DOM, PSPDFKit.PrintMode.EXPORT_PDF");
              t.dispatch(_.S0({
                mode: a,
                excludeAnnotations: "object" == typeof e && e.excludeAnnotations
              }));
            }, this.setAnnotationCreatorName = function (e) {
              const {
                annotationCreatorNameReadOnly: n
              } = t.getState();
              if (n) throw new o.p2("When the annotation creator name is defined on the JWT it can't be overriden.");
              t.dispatch((0, f.X8)(e));
            }, this.setCustomRenderers = function (e) {
              t.dispatch((0, f.jM)(e));
            }, this.setCustomUIConfiguration = function (e) {
              const {
                customUIStore: n
              } = t.getState();
              if ((null == n ? void 0 : n.getState()) === e) return;
              let r, o;
              r = "function" == typeof e ? e((null == n ? void 0 : n.getState()) || null) : e, (0, Be.a)(r), n || (o = new i.Z(r), t.dispatch((0, f.W)(o))), (n || o).setState(r);
            }, this.setInlineTextSelectionToolbarItems = e => {
              Ze("function" == typeof e, "The inlineTextSelectionToolbarItemsCallback argument must be a function."), t.dispatch((0, P.tu)(e));
            }, this.abortPrint = function () {
              const e = t.getState(),
                {
                  isPrinting: n
                } = e;
              if (!(0, b.VT)(e)) throw new o.p2("Tried to terminate a print job while printing is disabled.");
              if (!n) throw new o.p2("No print job to abort found.");
              t.dispatch(_.xF());
            }, this.getDocumentOutline = async function () {
              const e = t.getState();
              if (e.documentOutlineState.elements) return e.documentOutlineState.elements;
              Ze(e.backend);
              const n = await e.backend.getDocumentOutline();
              return t.dispatch((0, E.o)(n)), n;
            }, this.setDocumentOutline = async function (e) {
              const n = t.getState();
              Ze(n.backend);
              try {
                await n.backend.setDocumentOutline(e);
              } catch (e) {
                throw new o.p2(`Failed to set the document outline: ${e.message}`, e);
              }
              t.dispatch((0, E.o)(e));
            }, this.getPageGlyphs = async function (e) {
              const n = t.getState();
              return Ze(n.backend), Ze("number" == typeof e && Number.isInteger(e) && e >= 0 && e < n.totalPages, `Page index must be an integer between 0 and ${n.totalPages - 1} (number of pages - 1) inclusive.`), n.backend.getPageGlyphs(e);
            }, this.getLayers = async function () {
              const e = t.getState();
              return Ze(e.backend), e.backend.getOCGs();
            }, this.getLayersVisibilityState = async function () {
              const e = t.getState();
              return Ze(e.backend), e.backend.getOCGVisibilityState();
            }, this.setLayersVisibilityState = async function (e) {
              t.dispatch((0, Ve.Nx)(e));
            }, Object.defineProperty(this, "contentWindow", {
              enumerable: !0,
              configurable: !1,
              get: () => t.getState().frameWindow
            }), Object.defineProperty(this, "contentDocument", {
              enumerable: !0,
              configurable: !1,
              get() {
                var e;
                return t.getState().shadowRoot || (null === (e = t.getState().frameWindow) || void 0 === e ? void 0 : e.document);
              }
            }), Object.defineProperty(this, "licenseFeatures", {
              enumerable: !0,
              configurable: !1,
              get: () => t.getState().features
            }), "production" !== (0, x.zj)() && (this._store = t, this._eventEmitter = a);
          }
        }
        function Qe(e) {
          switch (e) {
            case "annotations.onPress":
            case "textLine.onPress":
            case "page.onPress":
              {
                const t = e.replace(".onPress", ".press");
                return (0, o.a1)(`The event ${e} was renamed and will be removed in a a future version. Please use ${t} instead.`), t;
              }
            default:
              return e;
          }
        }
      },
      7409: (e, t, n) => {
        "use strict";

        n.d(t, {
          default: () => Yt
        });
        var r = n(96156),
          o = n(17375);
        n(41817), n(72443), n(69007), n(83510), n(41840), n(32159), n(84944), n(86535), n(2707), n(33792), n(99244), n(61874), n(9494), n(56977), n(19601), n(38559), n(54678), n(91058), n(88674), n(17727), n(83593), n(24603), n(74916), n(92087), n(39714), n(27852), n(32023), n(4723), n(15306), n(64765), n(23123), n(23157), n(48702), n(55674), n(33105), n(3462), n(33824), n(12974), n(4129), n(33948), n(84633), n(85844), n(60285), n(83753), n(41637);
        "object" == typeof window && (window._babelPolyfill = !1);
        var i = n(35369),
          a = n(15359),
          s = n(8716),
          l = n(98502),
          u = n(2252),
          c = n(30874),
          d = n(11267),
          p = n(4715);
        function h(e, t, n) {
          if (!t.has(e)) throw new TypeError("attempted to " + n + " private field on non-instance");
          return t.get(e);
        }
        function f(e, t) {
          return function (e, t) {
            return t.get ? t.get.call(e) : t.value;
          }(e, h(e, t, "get"));
        }
        function m(e, t, n) {
          return function (e, t, n) {
            if (t.set) t.set.call(e, n);else {
              if (!t.writable) throw new TypeError("attempted to set read only private field");
              t.value = n;
            }
          }(e, h(e, t, "set"), n), n;
        }
        var g = n(31312),
          v = n(39236),
          y = n(21853);
        function b(e) {
          if (null == e) throw new a.p2("Expected `PSPDFKit.unload` to be called with an `HTMLElement | string | PSPDFKit.Instance`\ninstead none was provided.");
          if ("string" == typeof e) {
            const t = e;
            if (null === (e = document.querySelector(t))) throw new a.p2(`Couldn't find a container which matches the provided selector \`${t}\``);
          } else if (!((0, y.Re)(e) || e instanceof v.Z)) throw new a.p2("Expected `PSPDFKit.unload` to be called with a valid `target` argument.\nAllowed values for `target` are: `HTMLElement | string | PSPDFKit.Instance`.\n");
          let t;
          return e instanceof v.Z ? t = g.ae.current.get(e) : g.If.current.has(e) && (t = g.If.current.get(e)), !!t && (t(), !0);
        }
        var w = n(8898);
        function x(e, t) {
          C(e, t), t.add(e);
        }
        function D(e, t, n) {
          C(e, t), t.set(e, n);
        }
        function C(e, t) {
          if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function S(e, t, n) {
          if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
          return n;
        }
        var E = new WeakMap(),
          _ = new WeakMap(),
          P = new WeakMap(),
          k = new WeakMap(),
          A = new WeakMap(),
          z = new WeakMap(),
          T = new WeakMap(),
          O = new WeakMap(),
          I = new WeakMap(),
          F = new WeakSet(),
          M = new WeakSet(),
          R = new WeakSet(),
          j = new WeakSet(),
          B = new WeakSet(),
          N = new WeakSet(),
          L = new WeakSet(),
          V = new WeakSet();
        class K {
          constructor(e) {
            x(this, V), x(this, L), x(this, N), x(this, B), x(this, j), x(this, R), x(this, M), x(this, F), D(this, E, {
              writable: !0,
              value: void 0
            }), D(this, _, {
              writable: !0,
              value: void 0
            }), D(this, P, {
              writable: !0,
              value: void 0
            }), D(this, k, {
              writable: !0,
              value: void 0
            }), D(this, A, {
              writable: !0,
              value: void 0
            }), D(this, z, {
              writable: !0,
              value: void 0
            }), D(this, T, {
              writable: !0,
              value: void 0
            }), D(this, O, {
              writable: !0,
              value: void 0
            }), D(this, I, {
              writable: !0,
              value: void 0
            }), m(this, E, e);
          }
          annotationFocused(e) {
            f(this, E).invokeMethodAsync(this.annotationFocused.name, e);
          }
          async annotationPressed(e) {
            const t = await f(this, E).invokeMethodAsync("annotationsPressed", e.annotation.id, e.selected);
            e.preventDefault = t;
          }
          annotationSelected(e) {
            f(this, E).invokeMethodAsync(this.annotationSelected.name, e);
          }
          annotationToolbarButtonClicked(e, t) {
            f(this, E).invokeMethodAsync(this.annotationToolbarButtonClicked.name, e, t);
          }
          annotationUnfocused(e) {
            f(this, E).invokeMethodAsync(this.annotationUnfocused.name, e);
          }
          mainToolbarButtonClicked(e) {
            f(this, E).invokeMethodAsync(this.mainToolbarButtonClicked.name, e);
          }
          subscribeToEvent(e, t) {
            switch (e) {
              case "annotations.change":
                m(this, _, () => S(this, F, q).call(this)), t.addEventListener(e, f(this, _));
                break;
              case "annotations.create":
                m(this, P, e => S(this, M, H).call(this, e)), t.addEventListener(e, f(this, P));
                break;
              case "annotations.delete":
                m(this, k, e => S(this, R, U).call(this, e)), t.addEventListener(e, f(this, k));
                break;
              case "annotations.didSave":
                m(this, A, () => S(this, j, Z).call(this)), t.addEventListener(e, f(this, A));
                break;
              case "annotations.load":
                m(this, z, e => S(this, B, $).call(this, e)), t.addEventListener(e, f(this, z));
                break;
              case "annotations.update":
                m(this, I, e => S(this, N, G).call(this, e)), t.addEventListener(e, f(this, I));
                break;
              case "annotations.willChange":
                m(this, T, e => S(this, L, W).call(this, e)), t.addEventListener(e, f(this, T));
                break;
              case "annotations.willSave":
                m(this, O, () => S(this, V, Y).call(this)), t.addEventListener(e, f(this, O));
            }
          }
          unsubscribeFromEvent(e, t) {
            switch (e) {
              case "annotations.change":
                t.removeEventListener(e, f(this, _));
                break;
              case "annotations.create":
                t.removeEventListener(e, f(this, P));
                break;
              case "annotations.delete":
                t.removeEventListener(e, f(this, k));
                break;
              case "annotations.didSave":
                t.removeEventListener(e, f(this, A));
                break;
              case "annotations.load":
                t.removeEventListener(e, f(this, z));
                break;
              case "annotations.update":
                t.removeEventListener(e, f(this, I));
                break;
              case "annotations.willChange":
                t.removeEventListener(e, f(this, T));
                break;
              case "annotations.willSave":
                t.removeEventListener(e, f(this, O));
            }
          }
          viewStateUpdated(e, t) {
            const {
              interactionMode: n,
              sidebarMode: r
            } = e;
            n == t.interactionMode && r == t.sidebarMode || f(this, E).invokeMethodAsync(this.viewStateUpdated.name, JSON.stringify({
              interactionMode: n,
              sidebarMode: r
            }));
          }
        }
        function q() {
          f(this, E).invokeMethodAsync("annotationsChanged");
        }
        function H(e) {
          f(this, E).invokeMethodAsync("annotationsCreated", JSON.stringify(e));
        }
        function U(e) {
          f(this, E).invokeMethodAsync("annotationsDeleted", JSON.stringify(e));
        }
        function Z() {
          f(this, E).invokeMethodAsync("annotationsDidSave");
        }
        function $(e) {
          f(this, E).invokeMethodAsync("annotationsLoaded", JSON.stringify(e));
        }
        function G(e) {
          f(this, E).invokeMethodAsync("annotationsUpdated", JSON.stringify(e));
        }
        function W(e) {
          f(this, E).invokeMethodAsync("annotationsWillChange", JSON.stringify(e.annotations), e.reason);
        }
        function Y() {
          f(this, E).invokeMethodAsync("annotationsWillSave");
        }
        var X = n(90093),
          Q = n(11765);
        function J(e, t, n) {
          !function (e, t) {
            if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
          }(e, t), t.set(e, n);
        }
        var ee = new WeakMap();
        class te {
          constructor(e) {
            J(this, ee, {
              writable: !0,
              value: void 0
            }), m(this, ee, e);
          }
          async applyRedactions() {
            await f(this, ee).applyRedactions();
          }
          async createAnnotation(e) {
            const [t] = await f(this, ee).create((0, Q.vH)(null, JSON.parse(e)));
            return t.id;
          }
          deleteAnnotations(e) {
            f(this, ee).delete(JSON.parse(e));
          }
          async exportInstantJSON() {
            return await f(this, ee).exportInstantJSON();
          }
          async flattenAnnotations(e) {
            f(this, ee).applyOperations([{
              type: "flattenAnnotations",
              pageIndexes: e
            }]);
          }
          async getAnnotations(e) {
            const t = await f(this, ee).getAnnotations(e),
              n = [];
            return t.forEach(e => {
              try {
                const t = (0, Q.Hs)(e);
                n.push(t);
              } catch (e) {
                if ("Unsupported annotation type" !== e.message) throw e;
              }
            }), JSON.stringify(n);
          }
          importInstantJSON(e) {
            f(this, ee).applyOperations([{
              type: "applyInstantJson",
              instantJson: e
            }]);
          }
          setSelectedAnnotations(e) {
            f(this, ee).setSelectedAnnotations(null == e ? null : (0, i.aV)(JSON.parse(e)));
          }
          updateAnnotation(e) {
            const t = JSON.parse(e),
              n = (0, Q.vH)(t.id, t);
            f(this, ee).update(n);
          }
        }
        function ne(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function re(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ne(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ne(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function oe(e, t) {
          ae(e, t), t.add(e);
        }
        function ie(e, t, n) {
          ae(e, t), t.set(e, n);
        }
        function ae(e, t) {
          if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
        }
        function se(e, t, n) {
          if (!t.has(e)) throw new TypeError("attempted to get private field on non-instance");
          return n;
        }
        var le = new WeakMap(),
          ue = new WeakMap(),
          ce = new WeakMap(),
          de = new WeakMap(),
          pe = new WeakMap(),
          he = new WeakMap(),
          fe = new WeakMap(),
          me = new WeakMap(),
          ge = new WeakSet(),
          ve = new WeakSet(),
          ye = new WeakSet(),
          be = new WeakSet(),
          we = new WeakSet(),
          xe = new WeakSet();
        async function De(e, t) {
          const {
              CustomStylesheetPath: n,
              License: r,
              PackageName: o,
              ProductId: i,
              instantJson: a,
              IsDarkTheme: s,
              UseInBuiltFilePicker: l,
              toolbarItems: u,
              toolbarPlacement: c
            } = JSON.parse(t),
            d = {
              licenseKey: r,
              container: f(this, le),
              document: e,
              theme: s ? w.Q.DARK : w.Q.LIGHT,
              appName: o,
              productId: se(this, ye, Se).call(this, i),
              toolbarItems: u,
              toolbarPlacement: c,
              initialViewState: se(this, we, _e).call(this, t),
              instantJSON: a
            };
          n && (d.styleSheets = [n]);
          const p = "undefined" != typeof advanceConfiguration ? re(re({}, advanceConfiguration), d) : d;
          if (this.currentDocument = await (0, g.zD)(p), m(this, ce, new te(this.currentDocument)), this.currentDocument.setToolbarItems(e => f(this, pe) ? f(this, pe) : e), this.currentDocument.setAnnotationToolbarItems((e, t) => {
            let {
              defaultAnnotationToolbarItems: n
            } = t;
            const r = se(this, ve, Ce).call(this, e),
              o = f(this, de).get(r);
            return o || n;
          }), se(this, xe, Pe).call(this), l) {
            const e = {
              type: "custom",
              id: "file-picker",
              title: "Pick document",
              onPress: () => {
                var e, n;
                (se(this, be, Ee).call(this), f(this, me)) || (m(this, me, document.getElementById("filePicker")), null === (n = f(this, me)) || void 0 === n || n.addEventListener("change", e => {
                  var n;
                  const r = null == e || null === (n = e.target) || void 0 === n ? void 0 : n.files[0];
                  if (r) {
                    const e = new FileReader();
                    e.onload = async e => {
                      const n = new Uint8Array(e.target.result);
                      this.unload(), await se(this, ge, De).call(this, n.buffer, t);
                    }, e.readAsArrayBuffer(r);
                  }
                }));
                null === (e = f(this, me)) || void 0 === e || e.click();
              },
              icon: '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 20.5H7C6.60218 20.5 6.22064 20.342 5.93934 20.0607C5.65804 19.7794 5.5 19.3978 5.5 19V5C5.5 4.60218 5.65804 4.22064 5.93934 3.93934C6.22064 3.65804 6.60218 3.5 7 3.5H14L18.5 8V14" stroke="#3D424E" stroke-miterlimit="10" stroke-linecap="round"/><path opacity="0.66" d="M14.4963 8.21565H18.01L13.7936 3.99927V7.51292C13.796 7.69854 13.8708 7.87587 14.0021 8.00714C14.1334 8.1384 14.3107 8.21322 14.4963 8.21565Z" fill="#3D424E"/><path d="M18.5 18V23" stroke="#3D424E" stroke-miterlimit="10" stroke-linecap="round"/><path d="M21 20.5H16" stroke="#3D424E" stroke-miterlimit="10" stroke-linecap="round"/></svg>'
            };
            this.currentDocument.setToolbarItems(t => [e, ...t]);
          }
        }
        function Ce(e) {
          if (e instanceof p.Zc) return p.Zc.readableName;
          if (e instanceof p.b3) return p.b3.readableName;
          if (e instanceof p.Xs) return p.Xs.readableName;
          if (e instanceof p.o9) return p.o9.readableName;
          if (e instanceof p.om) return p.om.readableName;
          if (e instanceof p.Hi) return p.Hi.readableName;
          if (e instanceof p.Wk) return p.Wk.readableName;
          if (e instanceof p.On) return p.On.readableName;
          if (e instanceof p.sK) return p.sK.readableName;
          if (e instanceof p.GI) return p.GI.readableName;
          if (e instanceof p.x_) return p.x_.readableName;
          if (e instanceof p.gd) return p.gd.readableName;
          if (e instanceof p.Qi) return p.Qi.readableName;
          if (e instanceof p.R1) return p.R1.readableName;
          throw "Unknown annotation type";
        }
        function Se(e) {
          return `Maui_${e}`;
        }
        function Ee() {
          if (!f(this, he)) {
            const e = document.getElementById("documentLoadingIndicator");
            if (!e) return;
            m(this, he, e);
          }
          f(this, he).style.visibility = "collapse";
        }
        function _e(e) {
          const {
            interactionMode: t,
            sidebarMode: n,
            showToolbar: r
          } = JSON.parse(e);
          return new X.Z({
            interactionMode: t,
            showToolbar: r,
            sidebarMode: n
          });
        }
        function Pe() {
          this.currentDocument.addEventListener("viewState.change", (e, t) => {
            f(this, ue).viewStateUpdated(e, t);
          }), this.currentDocument.addEventListener("annotations.focus", e => {
            f(this, ue).annotationFocused(e.annotation.id);
          }), this.currentDocument.addEventListener("annotations.blur", e => {
            f(this, ue).annotationUnfocused(e.annotation.id);
          }), this.currentDocument.addEventListener("annotationSelection.change", e => {
            e && f(this, ue).annotationSelected(e.id);
          }), this.currentDocument.addEventListener("annotations.press", e => {
            f(this, ue).annotationPressed(e);
          });
        }
        new class {
          constructor() {
            oe(this, xe), oe(this, we), oe(this, be), oe(this, ye), oe(this, ve), oe(this, ge), ie(this, le, {
              writable: !0,
              value: "#pspdfkit"
            }), ie(this, ue, {
              writable: !0,
              value: void 0
            }), ie(this, ce, {
              writable: !0,
              value: void 0
            }), ie(this, de, {
              writable: !0,
              value: new Map()
            }), ie(this, pe, {
              writable: !0,
              value: void 0
            }), ie(this, he, {
              writable: !0,
              value: void 0
            }), ie(this, fe, {
              writable: !0,
              value: void 0
            }), ie(this, me, {
              writable: !0,
              value: void 0
            });
          }
          initialize(e) {
            m(this, ue, new K(e));
          }
          async addAdvanceAccessScript(e) {
            const t = document.getElementById("advanceAccess");
            t.src = e;
            const n = new Promise((e, n) => {
              t.onload = e, t.onerror = n;
            });
            await n;
          }
          async loadDocumentFromPath(e, t) {
            se(this, be, Ee).call(this), await se(this, ge, De).call(this, e, t);
          }
          async loadDocumentFromBase64String(e, t) {
            se(this, be, Ee).call(this), await se(this, ge, De).call(this, `data:application/pdf;base64,${e}`, t);
          }
          async loadDocumentFromBuffer(e, t) {
            se(this, be, Ee).call(this), await se(this, ge, De).call(this, e.buffer, t);
          }
          async exportDocument(e) {
            const t = JSON.parse(e),
              n = await this.currentDocument.exportPDF(t);
            return new Uint8Array(n);
          }
          setMainToolbarItems(e) {
            var t;
            const n = JSON.parse(e);
            m(this, pe, n), f(this, pe).forEach(e => {
              "custom" === e.type && (e.onPress = (e, t) => {
                f(this, ue).mainToolbarButtonClicked(t);
              });
            }), null === (t = this.currentDocument) || void 0 === t || t.setToolbarItems(e => f(this, pe) ? f(this, pe) : e);
          }
          setAnnotationToolbarItems(e, t) {
            var n;
            const r = JSON.parse(t);
            f(this, de).set(e, r), f(this, de).get(e).forEach(t => {
              "custom" === t.type && (t.onPress = (t, n) => {
                f(this, ue).annotationToolbarButtonClicked(e, n);
              });
            }), null === (n = this.currentDocument) || void 0 === n || n.setAnnotationToolbarItems((e, t) => {
              let {
                defaultAnnotationToolbarItems: n
              } = t;
              const r = se(this, ve, Ce).call(this, e),
                o = f(this, de).get(r);
              return o || n;
            });
          }
          unload() {
            b("#pspdfkit");
          }
          setViewState(e, t) {
            const n = this.currentDocument.viewState.set(e, t);
            this.currentDocument.setViewState(n);
          }
          async applyRedactions() {
            await f(this, ce).applyRedactions();
          }
          async createAnnotation(e) {
            return await f(this, ce).createAnnotation(e);
          }
          async exportInstantJSON() {
            return JSON.stringify(await f(this, ce).exportInstantJSON());
          }
          async getAnnotations(e) {
            return f(this, ce).getAnnotations(e);
          }
          importInstantJSON(e) {
            f(this, ce).importInstantJSON(JSON.parse(e));
          }
          setSelectedAnnotations(e) {
            f(this, ce).setSelectedAnnotations(e);
          }
          deleteAnnotations(e) {
            f(this, ce).deleteAnnotations(e);
          }
          async flattenAnnotations(e) {
            return await f(this, ce).flattenAnnotations(e);
          }
          updateAnnotation(e) {
            f(this, ce).updateAnnotation(e);
          }
          subscribeToEvent(e) {
            f(this, ue).subscribeToEvent(e, this.currentDocument);
          }
          unsubscribeFromEvent(e) {
            f(this, ue).unsubscribeFromEvent(e, this.currentDocument);
          }
          showDocumentLoadingIndicator() {
            if (!f(this, he)) {
              const e = document.getElementById("documentLoadingIndicator");
              if (!e) return;
              m(this, he, e);
            }
            f(this, he).style.visibility = "visible";
          }
          showGenericProcessingIndicator() {
            if (!f(this, fe)) {
              const e = document.getElementById("genericProcessingIndicator");
              if (!e) return;
              m(this, fe, e);
            }
            f(this, fe).style.visibility = "visible";
          }
          hideGenericProcessingIndicator() {
            if (!f(this, fe)) {
              const e = document.getElementById("genericProcessingIndicator");
              if (!e) return;
              m(this, fe, e);
            }
            f(this, fe).style.visibility = "collapse";
          }
        }();
        var ke = n(1858),
          Ae = n(690),
          ze = n(96706),
          Te = n(2841),
          Oe = n(99745),
          Ie = n(60379),
          Fe = n(56874),
          Me = n(10734),
          Re = n(29435),
          je = n(33622),
          Be = n(36828),
          Ne = n(34390),
          Le = n(56207),
          Ve = n(2282),
          Ke = n(47120),
          qe = n(74110),
          He = n(69842),
          Ue = n(68944),
          Ze = n(48625),
          $e = n(25673),
          Ge = n(14286),
          We = n(59062),
          Ye = n(87996),
          Xe = n(44077),
          Qe = n(70025),
          Je = n(26637),
          et = n(1990),
          tt = n(2464),
          nt = n(13264),
          rt = n(91105),
          ot = n(27122);
        var it = n(7202),
          at = n(65369),
          st = n(39684),
          lt = n(97586),
          ut = n(38478),
          ct = n(81777),
          dt = n(13349),
          pt = n(31442),
          ht = n(38246),
          ft = n(57712),
          mt = n(41390),
          gt = n(73417),
          vt = n(66013),
          yt = n(58342),
          bt = n(21753),
          wt = n(68804),
          xt = n(13422),
          Dt = n(5709),
          Ct = n(96650),
          St = n(34923),
          Et = n(2549),
          _t = n(62083),
          Pt = n(24126),
          kt = n(18009),
          At = n(74750),
          zt = n(93767),
          Tt = n(3792),
          Ot = n(3888),
          It = n(42370),
          Ft = n(35062),
          Mt = n(94327),
          Rt = n(1385),
          jt = n(97281),
          Bt = n(15650),
          Nt = n(33383),
          Lt = n(58163),
          Vt = n(5705),
          Kt = n(74311),
          qt = n(45249),
          Ht = n(33241);
        const Ut = ["color"];
        function Zt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function $t(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Zt(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        let Gt;
        try {
          Gt = (0, Ue.SV)(document);
        } catch (e) {}
        const Wt = g.n_;
        const Yt = {
          UI: {
            Core: l,
            createBlock: s.j,
            Recipes: Ht.l,
            Interfaces: Ht.x,
            App: u
          },
          Immutable: {
            List: i.aV
          },
          version: "2024.5.0",
          Geometry: {
            Point: Xe.E9,
            DrawingPoint: Xe.Wm,
            Rect: Xe.UL,
            Size: Xe.$u,
            Inset: Xe.eB
          },
          Actions: {
            Action: Ae.aU,
            GoToAction: ze.Di,
            GoToEmbeddedAction: ze.Qr,
            GoToRemoteAction: ze._6,
            HideAction: ze.ZD,
            JavaScriptAction: ze.bp,
            LaunchAction: ze.b,
            NamedAction: ze.oH,
            ResetFormAction: ze.BO,
            SubmitFormAction: ze.pl,
            URIAction: ze.lm
          },
          Annotations: {
            Annotation: p.q6,
            CommentMarkerAnnotation: p.Jn,
            HighlightAnnotation: p.FV,
            InkAnnotation: p.Zc,
            ShapeAnnotation: p.UX,
            LineAnnotation: p.o9,
            RectangleAnnotation: p.b3,
            EllipseAnnotation: p.Xs,
            PolygonAnnotation: p.Hi,
            PolylineAnnotation: p.om,
            LinkAnnotation: p.R1,
            NoteAnnotation: p.Qi,
            MarkupAnnotation: p.On,
            RedactionAnnotation: p.Wk,
            SquiggleAnnotation: p.hL,
            StampAnnotation: p.GI,
            StrikeOutAnnotation: p.R9,
            TextAnnotation: p.gd,
            UnderlineAnnotation: p.xu,
            ImageAnnotation: p.sK,
            UnknownAnnotation: p.Ih,
            WidgetAnnotation: p.x_,
            MediaAnnotation: p.Hu,
            toSerializableObject: Q.Hs,
            fromSerializableObject: e => (0, Q.vH)(null, e),
            rotate: (e, t, n) => {
              const r = (0, Vt.h4)(e, n);
              return (0, Vt.az)(r.set("rotation", t));
            }
          },
          AnnotationPresets: {
            toSerializableObject: Q.xT,
            fromSerializableObject: Q.MR
          },
          Comment: Le.ZP,
          Bookmark: Oe.Z,
          CustomOverlayItem: Fe.Z,
          OutlineElement: Me.Z,
          FormFields: {
            FormField: ke.Wi,
            ButtonFormField: ke.R0,
            CheckBoxFormField: ke.rF,
            ChoiceFormField: ke.Dz,
            ComboBoxFormField: ke.fB,
            ListBoxFormField: ke.Vi,
            RadioButtonFormField: ke.XQ,
            TextFormField: ke.$o,
            SignatureFormField: ke.Yo,
            toSerializableObject: Q.vD,
            fromSerializableObject: e => (0, Q.IN)(String(e.pdfObjectId), e)
          },
          FormFieldValue: ke.KD,
          FormOption: Re.Z,
          Callout: qt.UW,
          Color: Ie.Z,
          Instance: v.Z,
          preloadWorker: Wt,
          load: g.zD,
          unload: b,
          convertToOffice: g.py,
          convertToPDF: g.eQ,
          populateDocumentTemplate: g.XV,
          Error: a.p2,
          SaveError: Et.V,
          ViewState: X.Z,
          PageInfo: Be.Z,
          TextLine: Ne.Z,
          InstantClient: je.Z,
          TextSelection: et.H,
          SearchResult: wt.Z,
          SearchState: xt.Z,
          AutoSaveMode: Ke.u,
          SignatureSaveMode: lt.f,
          LayoutMode: Ge.X,
          PrintMode: Qe.X,
          PrintQuality: Je.g,
          ScrollMode: tt.G,
          ZoomMode: ct.c,
          InteractionMode: Ze.A,
          unstable_InkEraserMode: $e.b,
          SidebarMode: ot.f,
          UIElement: {
            Sidebar: "Sidebar"
          },
          Alignment: zt.v,
          BlendMode: Tt.b,
          BorderStyle: Ot.N,
          LineCap: It.u,
          SidebarPlacement: at.d,
          SignatureAppearanceMode: st.H,
          ShowSignatureValidationStatusMode: dt.W,
          NoteIcon: We.Zi,
          Theme: w.Q,
          ToolbarPlacement: nt.p,
          ElectronicSignatureCreationMode: rt.M,
          I18n: bt.ZP,
          baseUrl: Gt,
          DocumentIntegrityStatus: qe.QA,
          SignatureValidationStatus: qe.qA,
          SignatureType: qe.BG,
          SignatureContainerType: qe.FR,
          PAdESLevel: qe.hz,
          CertificateChainValidationStatus: qe.wk,
          DocumentValidationStatus: He._,
          AnnotationsWillChangeReason: Te.f,
          DocumentComparisonSourceType: it.b,
          MeasurementScaleUnitFrom: Mt.s,
          MeasurementScaleUnitTo: Rt.K,
          MeasurementPrecision: jt.L,
          MeasurementScale: Lt.Z,
          ProductId: Nt.x,
          ProcessorEngine: Bt.l,
          Conformance: Kt.w,
          DocumentPermissions: _t.X,
          ComparisonOperation: qt.Bd,
          DocumentDescriptor: qt.ZS,
          ComparisonOperationType: c.b,
          OfficeDocumentFormat: d._,
          viewStateFromOpenParameters: ut.s,
          get defaultElectronicSignatureColorPresets() {
            return (0, i.d0)(vt.Z).toJS().map(e => {
              let {
                color: t
              } = e;
              return $t($t({}, (0, o.Z)(e, Ut)), {}, {
                color: new Ie.Z(t)
              });
            });
          },
          get defaultToolbarItems() {
            return gt.ZP.toJS();
          },
          get defaultDocumentEditorFooterItems() {
            return Pt.Z.toJS();
          },
          get defaultDocumentEditorToolbarItems() {
            return kt.Z.toJS();
          },
          get defaultAnnotationPresets() {
            return pt.ZP.toObject();
          },
          get defaultStampAnnotationTemplates() {
            return [...mt.ZP];
          },
          get defaultAnnotationsSidebarContent() {
            return At.Z.toJS();
          },
          defaultEditableAnnotationTypes: ht.Z,
          defaultElectronicSignatureCreationModes: ft.Z,
          defaultSigningFonts: yt.Z,
          Options: Ye.Options,
          SearchPattern: Dt.n,
          SearchType: Ct.S,
          UIDateTimeElement: Ft.Y,
          generateInstantId: St.C,
          Font: Ve.Z
        };
      },
      6502: (e, t, n) => {
        "use strict";

        n.d(t, {
          TU: () => m,
          aG: () => h,
          gH: () => g,
          oo: () => f
        });
        var r = n(15359),
          o = n(67366),
          i = n(35369),
          a = n(77897),
          s = n(40084),
          l = n(96706),
          u = n(97395),
          c = n(87996),
          d = n(4087),
          p = n(66701);
        const h = e => (t, n) => {
            !function e(c) {
              try {
                if (c instanceof l.lm) {
                  (0, r.kG)("string" == typeof c.uri, "URIAction requires `uri`");
                  const e = n();
                  (!e.onOpenURI || e.onOpenURI(c.uri, !0)) && (0, u.Z)(c.uri);
                } else if (c instanceof l.Di) (0, r.kG)("number" == typeof c.pageIndex, "GoToAction requires `pageIndex`"), t((0, s.YA)(c.pageIndex));else if (c instanceof l.BO) (0, r.kG)("boolean" == typeof c.includeExclude, "ResetFormAction requires `includeExclude`"), t((0, a.yM)(c.fields, c.includeExclude));else if (c instanceof l.pl) (0, r.kG)("string" == typeof c.uri, "ResetFormAction requires `uri`"), (0, r.kG)("boolean" == typeof c.includeExclude, "ResetFormAction requires `includeExclude`"), t((0, a.V6)(c));else {
                  if (!(c instanceof l.ZD)) throw new r.p2(`Annotation action not handled: ${c.constructor.name}`);
                  {
                    (0, r.kG)(i.aV.isList(c.annotationReferences), "HideAction must have `annotationReferences`");
                    const {
                        annotations: e,
                        formFields: a
                      } = n(),
                      s = c.annotationReferences.map(e => "fieldName" in e && a.get(e.fieldName)),
                      l = c.annotationReferences.map(t => "pdfObjectId" in t && "number" == typeof t.pdfObjectId ? e.find(e => e.pdfObjectId === t.pdfObjectId) : null);
                    (0, o.dC)(() => {
                      l.forEach(e => {
                        e && t((0, d.FG)(e.set("hidden", c.hide)));
                      }), s.forEach(n => {
                        n && n.annotationIds.forEach(n => {
                          const r = e.get(n);
                          r && t((0, d.FG)(r.set("hidden", c.hide)));
                        });
                      });
                    });
                  }
                }
              } catch (e) {
                (0, r.ZK)(e.message);
              }
              c.subActions && c.subActions.forEach(t => {
                e(t);
              });
            }(e);
          },
          f = e => {
            const {
              action: t
            } = e;
            return t instanceof l.bp ? g(t.script, "onPointerDown", e instanceof p.Z ? e.formFieldName : null) : h(t);
          },
          m = (e, t) => {
            const {
              additionalActions: n,
              formFieldName: r
            } = e;
            return (null == n ? void 0 : n[t]) instanceof l.bp ? g(n[t].script, t, e instanceof p.Z ? r : null) : h(null == n ? void 0 : n[t]);
          };
        function g(e, t, n) {
          return async (o, i) => {
            const {
              backend: s
            } = i();
            if ((0, r.kG)(s), "STANDALONE" !== s.type || !c.Options.PDF_JAVASCRIPT) return;
            (0, r.kG)("string" == typeof e, "JavaScriptAction requires `script`");
            const l = await s.evalScript(e, t, n);
            o((0, a.bt)({
              changes: l
            }));
          };
        }
      },
      4087: (e, t, n) => {
        "use strict";

        n.d(t, {
          $d: () => T,
          $e: () => k,
          Ds: () => R,
          FG: () => Z,
          GI: () => ne,
          GT: () => Q,
          GZ: () => W,
          Iv: () => P,
          N1: () => se,
          QA: () => j,
          RK: () => ee,
          VX: () => V,
          WL: () => z,
          XG: () => J,
          ZE: () => L,
          Zr: () => I,
          aF: () => F,
          d8: () => Y,
          dt: () => oe,
          fx: () => X,
          gX: () => M,
          hQ: () => G,
          hX: () => E,
          hj: () => _,
          i0: () => te,
          ip: () => A,
          lA: () => O,
          mw: () => ie,
          pZ: () => B,
          sF: () => N,
          ug: () => re,
          uk: () => H,
          vc: () => S,
          vy: () => ae
        });
        var r = n(35369),
          o = n(67366),
          i = n(15359),
          a = n(45249),
          s = n(2841),
          l = n(44077),
          u = n(89637),
          c = n(17078),
          d = n(66327),
          p = n(40084),
          h = n(77897),
          f = n(35464),
          m = n(33427),
          g = n(5619),
          v = n(20388),
          y = n(97238),
          b = n(56573),
          w = n(35727),
          x = n(55012),
          D = n(10983),
          C = n(31442);
        const S = (e, t) => n => {
            n((0, u.Ab)()), n({
              type: x.ILc,
              annotation: e,
              pageIndex: t
            });
          },
          E = (e, t) => n => {
            n((0, u.Ab)()), n({
              type: x.HS7,
              annotation: e,
              pageIndex: t
            });
          },
          _ = (e, t) => n => {
            n((0, u.Ab)()), n({
              type: x.jzI,
              annotation: e,
              pageIndex: t
            });
          },
          P = async e => {
            const {
              hash: t,
              dimensions: n
            } = await (0, b.uq)(e);
            return {
              hash: t,
              dimensions: n,
              attachment: new a.Pg({
                data: e
              })
            };
          },
          k = e => async (t, n) => {
            const {
                dimensions: i,
                hash: a,
                attachment: l
              } = await P(e),
              d = (0, m.om)(n(), i, a, e.type, e.name),
              h = {
                annotations: (0, r.aV)([d]),
                reason: s.f.SELECT_END
              },
              {
                eventEmitter: f,
                annotationManager: g
              } = n();
            (0, o.dC)(() => {
              null == f || f.emit("annotations.willChange", h), t((0, c.O)({
                hash: a,
                attachment: l
              })), t(O((0, r.aV)([d]))), null == g || g.createObject(d, {
                attachments: (0, r.D5)([[a, l]])
              }), null == g || g.autoSave(), t((0, u.Df)((0, r.l4)([d.id]), null)), t((0, p.kN)(d.pageIndex, d.boundingBox));
            });
          },
          A = e => (t, n) => {
            let i;
            const {
                imageAttachmentId: c,
                contentType: d,
                fileName: h,
                description: f
              } = e,
              g = c && n().attachments.get(c);
            if (e instanceof a.GI) t(R("stamp")), i = (0, m.hG)(n(), new l.$u({
              width: e.boundingBox.width,
              height: e.boundingBox.height
            }), e);else {
              if (!(e instanceof a.sK)) return;
              if (!c) return;
              t(R("image")), i = (0, m.om)(n(), new l.$u({
                width: e.boundingBox.width,
                height: e.boundingBox.height
              }), c, d || "", h), f && (i = i.set("description", f));
            }
            const v = {
                annotations: (0, r.aV)([i]),
                reason: s.f.SELECT_END
              },
              {
                eventEmitter: y,
                annotationManager: b
              } = n();
            (0, o.dC)(() => {
              null == y || y.emit("annotations.willChange", v), t(O((0, r.aV)([i]))), null == b || b.createObject(i, {
                attachments: c && g ? (0, r.D5)([[c, g]]) : (0, r.D5)()
              }), null == b || b.autoSave(), t((0, u.Df)((0, r.l4)([i.id]), null)), t((0, p.kN)(i.pageIndex, i.boundingBox));
            });
          },
          z = e => (t, n) => {
            const {
              annotationManager: o,
              backend: a,
              attachments: s
            } = n();
            (0, i.kG)(a), "STANDALONE" === a.type ? t(O((0, r.aV)(e.map(e => e.set("pdfObjectId", null).delete("APStreamCache"))))) : t(O((0, r.aV)(e))), null == o || o.createObjects(e, e.map(e => ({
              attachments: (0, m.Dc)(s, e)
            })));
          },
          T = e => (t, n) => {
            const a = n();
            (0, i.kG)(a.backend);
            const {
              annotationManager: s,
              backend: l,
              attachments: u
            } = a;
            (0, o.dC)(() => {
              "STANDALONE" === (null == l ? void 0 : l.type) ? t(O((0, r.aV)([e.set("pdfObjectId", null).delete("APStreamCache")]))) : t(O((0, r.aV)([e]))), null == s || s.createObject(e, {
                attachments: (0, m.Dc)(u, e)
              });
            });
          },
          O = e => ({
            type: x.M85,
            annotations: e
          }),
          I = e => ({
            type: x.R8P,
            annotations: e
          }),
          F = e => ({
            type: x.gF5,
            ids: e
          }),
          M = e => (t, n) => {
            const r = n(),
              o = r.currentItemPreset;
            if (!o) return;
            const i = r.annotationPresets.get(o);
            if (!i) return;
            let a = !1;
            r.eventEmitter.emit("annotationPresets.update", {
              preventDefault: () => a = !0,
              currentPreset: o,
              currentPresetProperties: i,
              newPresetProperties: e
            }), a || t({
              type: x.oE1,
              attributes: e
            });
          },
          R = e => ({
            type: x.oWy,
            currentItemPreset: e
          }),
          j = e => ({
            type: x.UiQ,
            annotationPresets: e
          }),
          B = (e, t) => ({
            type: x.R1i,
            annotationID: e,
            annotationPresetID: t
          }),
          N = e => ({
            type: x.x0v,
            annotationID: e
          }),
          L = e => ({
            type: x.JwD,
            annotationID: e
          }),
          V = (e, t) => (n, r) => {
            n(R(t)), (0, y.PK)(r(), e).forEach(e => {
              n(T(e)), !C.AQ[t] && n(B(e.id, t));
            });
          },
          K = (e, t) => {
            const {
              annotationManager: n,
              attachments: r
            } = e();
            n.updateObject(t, (0, m.Dc)(r, t));
          },
          q = {},
          H = e => (t, n) => {
            const {
              annotations: o,
              invalidAPStreams: a,
              backend: s
            } = n();
            if (!o.has(e.id)) return void (0, i.ZK)("An annotation that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\nThe update of this annotation was skipped.");
            (0, m.tl)({
              annotations: o,
              backend: s
            }, (0, r.aV)([e]));
            let l = e.set("updatedAt", new Date());
            t(I((0, r.aV)([l]))), l = (0, m.tM)(n(), a, l), q[l.id] || (q[l.id] = (0, g.Z)(K, D.sP)), q[l.id](n, l);
          };
        function U(e, t, n) {
          const {
            annotations: r,
            invalidAPStreams: o,
            backend: s,
            annotationManager: l,
            attachments: u
          } = t;
          (0, m.tl)({
            annotations: r,
            backend: s
          }, n);
          const c = n.map(e => r.has(e.id) ? (e instanceof a.UX && e.isMeasurement() && (e = e.set("note", e.getMeasurementDetails().label)), "STANDALONE" === (null == s ? void 0 : s.type) ? e.delete("APStreamCache").set("updatedAt", new Date()) : e.set("updatedAt", new Date())) : ((0, i.ZK)("An annotation that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\nThe update of this annotation was skipped."), !1)).filter(Boolean);
          e(I(c)), c.forEach(e => {
            const n = (0, m.tM)(t, o, e);
            null !== e.pageIndex && (null == l || l.updateObject(n, {
              attachments: (0, m.Dc)(u, n)
            }));
          });
        }
        const Z = e => (t, n) => {
          const i = n();
          (0, o.dC)(() => {
            U(t, i, (0, r.aV)([e]));
          });
        };
        function $(e, t, n) {
          const {
            commentThreads: s,
            comments: l,
            annotationManager: u,
            formFieldValueManager: c
          } = t;
          n.forEach(t => {
            const n = s.get(t.id);
            if (n && 1 === n.size) {
              const t = l.get(n.first());
              t && (0, w.kT)(t) && ((0, i.kG)(t.id), e((0, f.Vn)((0, r.l4)([t.id]))));
            }
          }), n.forEach(t => {
            (t instanceof a.Jn || t instanceof a.FV || t.isCommentThreadRoot) && e((0, f.Wn)(t));
          });
          let d = (0, r.aV)();
          (0, o.dC)(() => {
            e(F(n.map(e => e.id).toSet())), d = n.map(e => (0, m.dk)(t, e)), d.forEach(e => {
              null == u || u.deleteObject(e);
            });
          }), d.forEach(n => {
            if (n instanceof a.x_) {
              const i = n.formFieldName ? t.formFields.get(n.formFieldName) : null;
              var o;
              if (i) if (1 !== i.annotationIds.size || i.annotationIds.first() !== n.id && i.annotationIds.first() !== String(n.pdfObjectId)) {
                if (i.annotationIds.includes(n.id) || i.annotationIds.includes(String(n.pdfObjectId))) {
                  const t = i.annotationIds.findIndex(e => e === n.id || e === String(n.pdfObjectId));
                  let o = i.set("annotationIds", i.annotationIds.filter(e => e !== n.id && e !== String(n.pdfObjectId)));
                  o.options && (o = o.set("options", i.options.filter((e, n) => n !== t))), e((0, h.vK)(o)), o.options.some(e => e.value === o.value) || e((0, h.xW)((0, r.aV)([new a.KD({
                    name: o.name,
                    value: null
                  })])));
                }
              } else e((0, h.Wh)(i)), null !== (o = t.backend) && void 0 !== o && o.isUsingInstantProvider() || null == c || c.deleteObject(new a.KD({
                name: i.name,
                value: i.value
              }));
            }
            q[n.id] && delete q[n.id];
          });
        }
        const G = e => (t, n) => {
            $(t, n(), (0, r.aV)([e]));
          },
          W = (e, t) => (n, r) => {
            const i = r(),
              {
                annotations: a
              } = i,
              s = t.map(e => a.get(e)).filter(Boolean);
            (0, o.dC)(() => {
              e.size > 0 && U(n, i, e), s.size > 0 && $(n, i, s);
            });
          };
        function Y(e) {
          return (t, n) => {
            if (e && !e.isEmpty()) {
              const t = n(),
                o = e.map(e => t.annotations.get(e)).filter(Boolean),
                i = {
                  annotations: (0, r.aV)(o),
                  reason: s.f.DELETE_START
                };
              t.eventEmitter.emit("annotations.willChange", i);
            }
            t({
              type: x.sCM,
              annotationsIDs: e
            });
          };
        }
        const X = e => ({
            type: x.qRJ,
            stampAnnotationTemplates: e
          }),
          Q = e => ({
            type: x.RPc,
            lineWidth: e
          });
        function J() {
          return (e, t) => {
            const n = t();
            let r = new a.Qi((0, m.lx)(n));
            const o = n.pages.get(n.viewportState.currentPageIndex);
            (0, i.kG)(o);
            const s = a.UL.getCenteredRect(new l.$u({
              width: D.SP,
              height: D.SP
            }), o.pageSize);
            r = r.set("pageIndex", n.viewportState.currentPageIndex).set("boundingBox", s), e((0, d.i9)(null, r)), e(Z(r));
          };
        }
        function ee() {
          return (e, t) => {
            const n = t();
            let r = new a.gd((0, m.lx)(n));
            const o = n.pages.get(n.viewportState.currentPageIndex);
            (0, i.kG)(o);
            const {
                pagesRotation: s,
                currentPageIndex: l
              } = n.viewportState,
              u = o.pageSize.scale(.5),
              c = (0, v.gB)(new a.E9({
                x: u.width,
                y: u.height
              }), s);
            r = r.set("pageIndex", l).set("boundingBox", c).set("rotation", s), e((0, d.DU)(null, r)), e(Z(r));
          };
        }
        const te = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            return {
              type: x.WaW,
              value: e
            };
          },
          ne = e => ({
            type: x.ieh,
            ids: e
          }),
          re = e => ({
            type: x.kVz,
            ids: e
          }),
          oe = e => ({
            type: x.hw0,
            callback: e
          }),
          ie = (e, t) => ({
            type: x.Dqw,
            variant: e,
            annotationObjectIds: t
          }),
          ae = e => ({
            type: x.uOP,
            annotationId: e
          }),
          se = (e, t) => ({
            type: x.SHi,
            pageIndex: e,
            tabOrder: t
          });
      },
      35464: (e, t, n) => {
        "use strict";

        n.d(t, {
          $z: () => z,
          BY: () => S,
          Dm: () => D,
          GH: () => T,
          Jr: () => E,
          Rf: () => O,
          UM: () => P,
          V4: () => _,
          Vn: () => x,
          Wn: () => k,
          aZ: () => b,
          cQ: () => v,
          fg: () => m,
          gk: () => w,
          mh: () => g,
          v7: () => y
        });
        var r = n(35369),
          o = n(55012),
          i = n(10983),
          a = n(45249),
          s = n(4087),
          l = n(89637),
          u = n(66327),
          c = n(97238),
          d = n(35727),
          p = n(33427),
          h = n(82716),
          f = n(89004);
        const m = e => t => {
            t({
              type: o.ckI,
              comments: e
            }), t(z());
          },
          g = e => t => {
            t({
              type: o.hxO,
              rootId: e
            }), t(z());
          };
        function v() {
          return (e, t) => {
            const n = (0, c.PK)(t(), a.FV, !0);
            if (n.size) {
              e((0, l.fz)()), e((0, s.lA)(n));
              const o = t().annotations.get(n.first().id);
              (0, h.k)(o), e((0, l.Df)((0, r.l4)([o.id]), null)), e(g(o.id));
            }
          };
        }
        const y = e => ({
            type: o.YHT,
            users: e
          }),
          b = e => ({
            type: o.ZLr,
            maxSuggestions: e
          }),
          w = e => t => {
            t((e => ({
              type: o.FdD,
              comments: e
            }))(e)), t(z());
          },
          x = e => t => {
            t({
              type: o.kg,
              ids: e
            }), t(z());
          };
        function D() {
          return (e, t) => {
            const n = t(),
              o = [],
              i = [];
            n.selectedAnnotationIds.forEach(e => {
              const t = n.commentThreads.get(e);
              if (!t) return;
              let r = t.size;
              t.forEach(e => {
                var t;
                const i = n.comments.get(e);
                !i || null != i.pageIndex || null != (null === (t = i.text) || void 0 === t ? void 0 : t.value) && "" !== (0, f.KY)(i.text.value) || (o.push(e), r--);
              }), 0 === r && i.push(e);
            }), o.length > 0 && e(x((0, r.l4)(o))), i.length > 0 && e((0, s.aF)((0, r.l4)(i)));
          };
        }
        function C(e, t) {
          let {
            oldComment: n,
            comment: o,
            action: i
          } = t;
          const {
            comments: a,
            eventEmitter: s
          } = e;
          if ("DELETE" === i) (0, h.k)(n), s.emit("comments.mention", {
            comment: n,
            modifications: n.getMentionedUserIds().map(e => ({
              userId: e,
              action: "REMOVED"
            })).toList()
          });else if ("CREATE" === i) (0, h.k)(o), s.emit("comments.mention", {
            comment: o,
            modifications: o.getMentionedUserIds().map(e => ({
              userId: e,
              action: "ADDED"
            })).toList()
          });else {
            (0, h.k)(o);
            const e = n || o.id && a.get(o.id),
              t = o.getMentionedUserIds();
            let i = (0, r.aV)();
            (0, h.k)(e);
            const l = e.getMentionedUserIds(),
              u = l.subtract(t);
            u.size > 0 && (i = i.push(...u.map(e => ({
              userId: e,
              action: "REMOVED"
            })).toList()));
            const c = t.subtract(l);
            c.size > 0 && (i = i.push(...c.map(e => ({
              userId: e,
              action: "ADDED"
            })).toList())), s.emit("comments.mention", {
              comment: o,
              modifications: i
            });
          }
        }
        const S = (e, t) => (n, o) => {
            const i = o();
            (0, h.k)(e.rootId);
            const a = i.annotations.get(e.rootId);
            (0, h.k)(a);
            const l = new Date(),
              u = e.set("updatedAt", l).set("pageIndex", a.pageIndex);
            C(i, {
              comment: u,
              oldComment: t,
              action: "UPDATE"
            }), n(w((0, r.aV)([u])));
            const c = i.commentThreads.get(e.rootId);
            if ((0, h.k)(null != c), 1 === c.size && (0, d.kT)(e)) {
              var p, f;
              let e = a.set("isCommentThreadRoot", !0);
              const t = i.comments.get(c.first());
              e = e.set("isAnonymous", Boolean(null == t ? void 0 : t.isAnonymous)), n((0, s.Zr)((0, r.aV)([e]))), null === (p = i.annotationManager) || void 0 === p || p.createObject(e), null === (f = i.annotationManager) || void 0 === f || f.autoSave();
            }
            (0, h.k)(null != i.commentManager);
            const m = o(),
              g = m.comments.toList().filter(e => !(0, d.kT)(e));
            i.commentManager.createObject(u, {
              comments: g,
              annotations: m.annotations
            }), i.commentManager.autoSave();
          },
          E = e => (t, n) => {
            const o = new Date(),
              i = e.set("createdAt", o).set("updatedAt", o);
            t(m((0, r.aV)([i]))), C(n(), {
              comment: i,
              action: "CREATE"
            });
            const {
              commentManager: a,
              annotations: s
            } = n();
            (0, h.k)(null != a);
            const l = n().comments.toList().filter(e => !(0, d.kT)(e));
            a.createObject(i, {
              comments: l,
              annotations: s
            });
          },
          _ = e => (t, n) => {
            const o = e.set("updatedAt", new Date());
            t(w((0, r.aV)([o]))), C(n(), {
              comment: o,
              oldComment: e,
              action: "UPDATE"
            });
            const {
              annotations: i,
              commentManager: a
            } = n();
            (0, h.k)(null != a);
            const s = n().comments.toList().filter(e => !(0, d.kT)(e));
            a.updateObject(o, {
              comments: s,
              annotations: i
            });
          },
          P = e => (t, n) => {
            const o = n();
            if ((0, h.k)(e.id), C(o, {
              oldComment: e,
              action: "DELETE"
            }), e.rootId) {
              const r = o.commentThreads.get(e.rootId);
              if (r && r.first() === e.id) {
                const a = r.toList().get(1);
                if (a) {
                  const r = o.comments.get(a);
                  var i;
                  if (r) A(n, e.rootId, t, null !== (i = r.isAnonymous) && void 0 !== i && i);
                }
              }
              if (r && (1 === r.size || (0, d._P)(r, o.comments) && 2 === r.size)) {
                const n = o.annotations.get(e.rootId);
                if (n) return void t((0, s.hQ)(n));
              }
            }
            t(x((0, r.l4)([e.id])));
            const {
              commentManager: a
            } = o;
            (0, h.k)(null != a);
            const l = n(),
              u = l.comments.toList().filter(e => !(0, d.kT)(e));
            a.deleteObject(e, {
              comments: u,
              annotations: l.annotations
            }), a.autoSave();
          },
          k = e => (t, n) => {
            var r;
            const o = n();
            if ((0, h.k)(e), "SERVER" === (null === (r = o.backend) || void 0 === r ? void 0 : r.type)) return;
            const i = o.comments.filter(t => t.rootId === e.id && !(0, d.kT)(t)).map(e => e.id);
            if (0 === i.size) return;
            t(x(i.toSet())), o.comments.forEach(e => {
              C(o, {
                oldComment: e,
                action: "DELETE"
              });
            });
            const {
              commentManager: a
            } = o;
            (0, h.k)(null != a);
            const s = n();
            let l = s.comments.toList().filter(e => !(0, d.kT)(e));
            l.forEach(t => {
              t.rootId === e.id && (a.deleteObject(t, {
                comments: l,
                annotations: s.annotations
              }), l = l.filter(e => e.id !== t.id));
            }), a.autoSave();
          },
          A = (e, t, n, o) => {
            var i, a;
            const l = e(),
              u = l.annotations.get(t);
            (0, h.k)(null != u);
            const c = u.set("isAnonymous", o);
            n((0, s.Zr)((0, r.aV)([c]))), null === (i = l.annotationManager) || void 0 === i || i.updateObject(c), null === (a = l.annotationManager) || void 0 === a || a.autoSave();
          };
        function z() {
          return {
            type: o.NB4
          };
        }
        const T = () => (e, t) => {
          const n = t();
          let o = new a.Jn((0, p.lx)(n));
          const l = n.pages.get(n.viewportState.currentPageIndex);
          (0, h.k)(l);
          const c = a.UL.getCenteredRect(new a.$u({
            width: i.zk,
            height: i.zk
          }), l.pageSize);
          o = o.set("pageIndex", n.viewportState.currentPageIndex).set("boundingBox", c), e((0, u.k6)(o)), e((0, s.Zr)((0, r.aV)([o]))), e(g(o.id));
        };
        function O(e) {
          return {
            type: o.mfU,
            onCommentCreationStartCallback: e
          };
        }
      },
      66327: (e, t, n) => {
        "use strict";

        n.d(t, {
          $Q: () => ue,
          A7: () => ve,
          BB: () => m,
          BR: () => S,
          C4: () => M,
          Cc: () => k,
          Ce: () => O,
          Cn: () => ft,
          DU: () => re,
          Di: () => lt,
          EJ: () => Le,
          EY: () => xe,
          FA: () => St,
          Fs: () => qe,
          Ft: () => vt,
          GL: () => Te,
          Gc: () => q,
          Gh: () => je,
          HT: () => yt,
          Hf: () => Ne,
          I: () => Ft,
          IU: () => ce,
          Ie: () => We,
          JN: () => be,
          Jn: () => ie,
          K_: () => ye,
          LE: () => K,
          LH: () => Ke,
          Lt: () => ne,
          M4: () => U,
          M5: () => dt,
          MV: () => A,
          O4: () => Mt,
          Ol: () => G,
          Ox: () => Ze,
          P4: () => D,
          PR: () => At,
          P_: () => ut,
          Q8: () => Pe,
          QL: () => Z,
          Ql: () => de,
          R: () => f,
          R1: () => Me,
          RN: () => $,
          Rx: () => Y,
          SE: () => ze,
          Sn: () => v,
          T: () => Ae,
          T1: () => Tt,
          TR: () => x,
          Tu: () => _e,
          UF: () => et,
          UG: () => g,
          UU: () => ae,
          UZ: () => _t,
          Ug: () => _,
          VU: () => P,
          W: () => xt,
          Wv: () => te,
          X2: () => le,
          X8: () => Xe,
          XX: () => tt,
          Xv: () => bt,
          YA: () => me,
          YF: () => Ct,
          YI: () => X,
          YK: () => Ye,
          ZV: () => Fe,
          Z_: () => Rt,
          Zg: () => se,
          _$: () => wt,
          _P: () => De,
          _R: () => Et,
          _U: () => ge,
          _b: () => H,
          _z: () => R,
          aw: () => w,
          bv: () => Q,
          c8: () => pe,
          cI: () => Ee,
          cz: () => ct,
          d5: () => y,
          d9: () => it,
          dp: () => N,
          ek: () => Se,
          el: () => Ve,
          fq: () => st,
          hS: () => E,
          he: () => Ot,
          i9: () => B,
          iJ: () => pt,
          i_: () => Ge,
          iu: () => J,
          jJ: () => zt,
          jM: () => ot,
          jP: () => F,
          k4: () => oe,
          k6: () => L,
          lC: () => b,
          lL: () => Dt,
          lV: () => Qe,
          lW: () => he,
          m$: () => ee,
          m0: () => W,
          m9: () => It,
          mu: () => Ue,
          oX: () => Ce,
          of: () => Pt,
          p2: () => kt,
          p9: () => z,
          pM: () => j,
          qB: () => mt,
          rL: () => ht,
          rd: () => He,
          s3: () => C,
          sJ: () => Je,
          sY: () => Oe,
          si: () => rt,
          t: () => I,
          t6: () => at,
          tr: () => V,
          u0: () => ke,
          vI: () => $e,
          vM: () => jt,
          vY: () => we,
          we: () => Re,
          xF: () => nt,
          xW: () => gt,
          yg: () => T,
          z5: () => fe,
          ze: () => Be
        });
        var r = n(96156),
          o = n(15359),
          i = n(67366),
          a = n(33056),
          s = n(55012),
          l = n(89637),
          u = n(27122),
          c = n(40084),
          d = n(79112);
        function p(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function h(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const f = () => ({
            type: s.Dj2
          }),
          m = () => ({
            type: s.G5w
          }),
          g = e => ({
            type: s.kt4,
            enabled: e
          }),
          v = () => ({
            type: s.GW4
          }),
          y = e => ({
            type: s.mqf,
            preset: e
          }),
          b = () => ({
            type: s.tLW
          }),
          w = e => ({
            type: s.tS$,
            preset: e
          }),
          x = () => ({
            type: s.g30
          }),
          D = e => ({
            type: s.GXR,
            preset: e
          }),
          C = () => ({
            type: s.J7J
          }),
          S = e => ({
            type: s.yPS,
            preset: e
          }),
          E = () => ({
            type: s.m_C
          }),
          _ = () => ({
            type: s.JyO
          }),
          P = () => ({
            type: s.NDs
          }),
          k = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              signatureRect: null,
              signaturePageIndex: null,
              formFieldName: null
            };
            return h({
              type: s.Vu4
            }, e);
          },
          A = () => ({
            type: s.S$y
          }),
          z = (e, t) => () => T(e, t),
          T = (e, t, n) => ({
            type: s.JS9,
            shapeClass: e,
            shapeInteractionMode: t,
            preset: n
          }),
          O = () => ({
            type: s.AIf
          }),
          I = e => ({
            type: s.cbv,
            preset: e
          }),
          F = () => ({
            type: s.TUA
          }),
          M = () => ({
            type: s.Dzg
          }),
          R = () => ({
            type: s.M3C
          }),
          j = () => ({
            type: s.tie
          }),
          B = (e, t) => ({
            type: s.ZDQ,
            preset: e,
            annotation: t
          }),
          N = () => ({
            type: s.B1n
          }),
          L = e => ({
            type: s.dEe,
            annotation: e
          }),
          V = () => ({
            type: s.iMs
          });
        function K(e) {
          return {
            type: s.IFt,
            formDesignMode: e
          };
        }
        function q(e) {
          return {
            type: s.Gkm,
            measurementSnapping: e
          };
        }
        function H(e) {
          return {
            type: s.G6t,
            scale: e
          };
        }
        function U(e) {
          return {
            type: s.fwq,
            measurementPrecision: e
          };
        }
        function Z(e) {
          return {
            type: s.vkF,
            configurationCallback: e
          };
        }
        function $(e) {
          return {
            type: s.SdX,
            scales: e
          };
        }
        function G() {
          return {
            type: s.aYj
          };
        }
        function W() {
          return {
            type: s.hpj
          };
        }
        function Y() {
          return {
            type: s.QYP
          };
        }
        function X() {
          return {
            type: s.zKF
          };
        }
        const Q = () => ({
            type: s.MuN
          }),
          J = () => ({
            type: s.xk1
          }),
          ee = () => ({
            type: s.tYC
          }),
          te = () => ({
            type: s.NAH
          }),
          ne = (e, t) => ({
            type: s.pnu,
            preset: e,
            annotation: t,
            isCallout: !0
          }),
          re = (e, t) => ({
            type: s.pnu,
            preset: e,
            annotation: t
          }),
          oe = () => ({
            type: s.KqR
          }),
          ie = () => ({
            type: s.R7l
          }),
          ae = () => ({
            type: s.Vpf
          }),
          se = () => ({
            type: s.eFQ
          }),
          le = () => ({
            type: s.L8n
          }),
          ue = e => ({
            type: s.VNM,
            editor: e
          }),
          ce = e => ({
            type: s.tPZ,
            width: e
          }),
          de = e => ({
            type: s.u9b,
            zoomStep: e
          }),
          pe = e => ({
            type: s.tIQ,
            disablePointSnapping: e
          }),
          he = e => ({
            type: s.Ce5,
            callback: e
          }),
          fe = e => ({
            type: s.WtY,
            transformClientToPage: e
          });
        function me(e) {
          return {
            type: s.rWQ,
            layoutMode: e
          };
        }
        function ge(e) {
          return {
            type: s.b0l,
            scrollMode: e
          };
        }
        function ve(e) {
          return {
            type: s._TO,
            showSignatureValidationStatus: e
          };
        }
        function ye(e) {
          return {
            type: s._n_,
            scrollElement: e
          };
        }
        function be(e) {
          return {
            type: s.bxr,
            spreadSpacing: e
          };
        }
        function we(e) {
          return {
            type: s._ko,
            pageSpacing: e
          };
        }
        function xe(e) {
          return {
            type: s.FHt,
            keepFirstSpreadAsSinglePage: e
          };
        }
        function De(e) {
          return {
            type: s.ht3,
            viewportPadding: e
          };
        }
        function Ce(e) {
          return {
            type: s.NfO,
            readOnlyEnabled: e
          };
        }
        function Se() {
          return {
            type: s.Xlm
          };
        }
        function Ee() {
          return {
            type: s.cyk
          };
        }
        function _e() {
          return {
            type: s.KYU
          };
        }
        function Pe() {
          return {
            type: s.Nl1
          };
        }
        function ke() {
          return {
            type: s.L9g
          };
        }
        function Ae() {
          return {
            type: s.Dl4
          };
        }
        function ze() {
          return {
            type: s.GfR
          };
        }
        function Te(e) {
          return {
            type: s.iQZ,
            features: e
          };
        }
        function Oe(e) {
          return {
            type: s.JQC,
            signatureFeatureAvailability: e
          };
        }
        function Ie(e) {
          return t => {
            t({
              type: s.hv0,
              mode: e
            }), t((0, l.vR)());
          };
        }
        function Fe(e) {
          return {
            type: s.ZbY,
            editableAnnotationTypes: e
          };
        }
        function Me(e) {
          return {
            type: s.uFU,
            isEditableAnnotation: e
          };
        }
        function Re(e, t) {
          return {
            type: s.ArU,
            editableAnnotationTypes: e,
            isEditableAnnotation: t
          };
        }
        function je(e) {
          return {
            type: s.Q2U,
            isEditableComment: e
          };
        }
        const Be = () => (e, t) => {
          e(Ie(u.f.ANNOTATIONS));
          const n = t();
          for (let e = 0; e < n.totalPages; e++) {
            var r;
            null === (r = n.annotationManager) || void 0 === r || r.loadAnnotationsForPageIndex(e);
          }
        };
        function Ne() {
          return Ie(u.f.BOOKMARKS);
        }
        const Le = () => async (e, t) => {
          e(Ie(u.f.DOCUMENT_OUTLINE));
          const n = t();
          if (n.documentOutlineState.elements) return;
          (0, o.kG)(n.backend);
          const r = await n.backend.getDocumentOutline();
          e((0, a.o)(r));
        };
        function Ve() {
          return Ie(u.f.THUMBNAILS);
        }
        function Ke() {
          return Ie(u.f.SIGNATURES);
        }
        function qe() {
          return Ie(u.f.LAYERS);
        }
        function He() {
          return Ie(u.f.CUSTOM);
        }
        function Ue() {
          return {
            type: s.hv0,
            mode: null
          };
        }
        function Ze(e) {
          return {
            type: s.eI4,
            placement: e
          };
        }
        function $e(e) {
          return {
            type: s.bP3,
            sidebarOptions: e
          };
        }
        function Ge(e) {
          return {
            type: s.dVW,
            locale: e
          };
        }
        function We() {
          return {
            type: s.RTr
          };
        }
        function Ye(e) {
          return {
            type: s.heZ,
            group: e
          };
        }
        function Xe(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return {
            type: s.hlI,
            annotationCreatorName: e,
            immutable: t
          };
        }
        const Qe = () => ({
            type: s.YIz
          }),
          Je = () => ({
            type: s.K26
          }),
          et = e => ({
            type: s.$VE,
            interactionMode: e
          }),
          tt = () => ({
            type: s.yrz
          });
        function nt() {
          return {
            type: s.Hbz
          };
        }
        function rt() {
          return {
            type: s.sYK
          };
        }
        const ot = e => ({
          type: s.fAF,
          customRenderers: e
        });
        function it() {
          return {
            type: s.pNz
          };
        }
        function at() {
          return {
            type: s.bV3
          };
        }
        function st() {
          return {
            type: s.EpY
          };
        }
        function lt() {
          return {
            type: s.bui
          };
        }
        function ut(e) {
          return {
            type: s.vVk,
            previewRedactionMode: e
          };
        }
        function ct(e) {
          return async (t, n) => {
            const {
              viewportState: r,
              eventEmitter: a,
              documentComparisonState: s
            } = n();
            if (e) {
              const n = {
                start: {},
                end: {}
              };
              n.start.promise = new Promise((e, t) => {
                n.start.resolve = e, n.start.reject = t;
              }), n.end.promise = new Promise((e, t) => {
                n.end.resolve = e, n.end.reject = t;
              }), (0, i.dC)(() => {
                t((0, c.nr)(r.set("documentComparisonMode", h(h({}, e), {}, {
                  completion: n
                })))), t(dt({
                  referencePoints: [],
                  autoCompare: e.autoCompare,
                  isResultFetched: !1,
                  currentTab: e.autoCompare ? null : d.Q.documentA,
                  documentKey: d.Q.documentA,
                  previousViewportState: {
                    zoomMode: r.zoomMode,
                    zoomLevel: r.zoomLevel,
                    scrollPosition: r.scrollPosition,
                    currentPageIndex: r.currentPageIndex,
                    pageSizes: r.pageSizes
                  }
                }));
              }), a.emit("documentComparisonUI.start", e);
            } else if (r.documentComparisonMode) {
              const {
                completion: e
              } = r.documentComparisonMode;
              try {
                e.start.resolve(), await e.end.promise, (0, i.dC)(() => {
                  t((0, c.nr)(r.set("documentComparisonMode", null).merge(s.previousViewportState))), t(dt(null));
                }), a.emit("documentComparisonUI.end");
              } catch (e) {
                throw new o.p2(e.message);
              }
            }
          };
        }
        function dt(e) {
          return {
            type: s.KA1,
            documentComparisonState: e
          };
        }
        function pt(e) {
          return {
            type: s.D5x,
            a11yStatusMessage: e
          };
        }
        function ht() {
          return {
            type: s.JRS
          };
        }
        function ft() {
          return {
            type: s.Gox
          };
        }
        function mt(e) {
          return {
            type: s.rpU,
            lastToolbarActionUsedKeyboard: e
          };
        }
        function gt() {
          return {
            type: s.MYU
          };
        }
        function vt() {
          return {
            type: s.mbD
          };
        }
        function yt() {
          return {
            type: s.wog
          };
        }
        function bt() {
          return {
            type: s.UL9
          };
        }
        function wt(e) {
          return {
            type: s.IyB,
            instance: e
          };
        }
        function xt(e) {
          return {
            type: s.eJ4,
            customUIStore: e
          };
        }
        const Dt = () => ({
            type: s.qKG
          }),
          Ct = e => ({
            type: s.oZW,
            multiAnnotationsUsingShortcut: e
          }),
          St = () => ({
            type: s.odo
          }),
          Et = e => ({
            type: s.FQb,
            annotationsIds: e
          }),
          _t = e => ({
            type: s.bzW,
            groupId: e
          }),
          Pt = (e, t) => ({
            type: s.b4I,
            annotationId: e,
            groupId: t
          }),
          kt = e => ({
            type: s.tzG,
            customFontsReadableNames: e
          }),
          At = () => ({
            type: s.Vje
          }),
          zt = () => ({
            type: s.XTO
          });
        function Tt(e) {
          return {
            type: s.ej0,
            enableAlwaysScrollToZoom: e
          };
        }
        function Ot(e) {
          return {
            type: s.QM1,
            forceRenderWidgetsInAnnotationsOrder: e
          };
        }
        function It(e) {
          return {
            type: s.ol,
            evaluation: e
          };
        }
        function Ft(e) {
          return {
            type: s.wJn,
            prerenderedPageSpreads: e
          };
        }
        function Mt(e) {
          return {
            type: s.rq0,
            configuration: e
          };
        }
        function Rt(e) {
          return {
            type: s.HXk,
            showDocumentAssistant: e
          };
        }
        function jt(e) {
          return {
            type: s.wHH,
            currentTextSelection: e
          };
        }
      },
      25384: (e, t, n) => {
        "use strict";

        n.d(t, {
          Bm: () => p,
          qZ: () => d,
          rJ: () => m,
          sr: () => h,
          uT: () => f
        });
        var r = n(67366),
          o = n(55012),
          i = n(18287),
          a = n(77897),
          s = n(44156),
          l = n(66327),
          u = n(70982),
          c = n(49876);
        function d(e, t) {
          return {
            type: o.BS3,
            reason: e,
            progress: t
          };
        }
        function p() {
          return {
            type: o.nmm
          };
        }
        function h(e) {
          return {
            type: o.zZV,
            reason: e
          };
        }
        function f(e) {
          return {
            type: o.Ty$,
            resolvePassword: e
          };
        }
        function m(e) {
          let {
            attemptedUnlockViaModal: t,
            hasPassword: n,
            features: d,
            signatureFeatureAvailability: p,
            permissions: h,
            documentInfo: f,
            formJSON: m,
            annotationManager: g,
            bookmarkManager: v,
            formFieldManager: y,
            formFieldValueManager: b,
            commentManager: w,
            changeManager: x,
            minSearchQueryLength: D,
            documentHandle: C,
            allowedTileScales: S,
            pageKeys: E
          } = e;
          return (e, _) => {
            const {
              searchState: P,
              documentHandle: k,
              features: A,
              signatureFeatureAvailability: z
            } = _();
            (0, r.dC)(() => {
              S && e(function (e) {
                return {
                  type: o.iZ1,
                  allowedTileScales: e
                };
              }(S)), t && e({
                type: o.hC8
              }), e(function (e) {
                return {
                  type: o.poO,
                  hasPassword: e
                };
              }(n)), d && 0 === A.size && e((0, l.GL)(d)), p && !z && e((0, l.sY)(p)), e((0, s.at)(h)), k && k !== C && e({
                type: o.obk
              }), e((0, s.GO)(f, E)), m && e((0, a.Qi)(m)), e((0, c.QQ)()), e(function (e) {
                return {
                  type: o.rxv,
                  annotationManager: e
                };
              }(g)), e(function (e) {
                return {
                  type: o.Hrp,
                  bookmarkManager: e
                };
              }(v)), e(function (e) {
                return {
                  type: o.oj5,
                  formFieldManager: e
                };
              }(y)), e(function (e) {
                return {
                  type: o.GHc,
                  formFieldValueManager: e
                };
              }(b)), null != w && e(function (e) {
                return {
                  type: o.UII,
                  commentManager: e
                };
              }(w)), e(function (e) {
                return {
                  type: o.gbd,
                  changeManager: e
                };
              }(x)), "number" == typeof D && e((0, i.j8)(P.set("minSearchQueryLength", D))), e((0, u.kE)(C));
            });
          };
        }
      },
      2927: (e, t, n) => {
        "use strict";

        n.d(t, {
          $t: () => I,
          C0: () => A,
          FD: () => x,
          Hv: () => N,
          Ij: () => T,
          Mq: () => F,
          O2: () => M,
          Ow: () => C,
          PZ: () => O,
          Pq: () => z,
          RL: () => D,
          SF: () => k,
          Yg: () => P,
          Zv: () => E,
          gY: () => g,
          lx: () => j,
          qt: () => w,
          rO: () => H,
          sC: () => S,
          ss: () => v,
          u: () => q,
          u8: () => y,
          um: () => K,
          uy: () => B,
          v2: () => b,
          yy: () => _
        });
        var r = n(67366),
          o = n(13798),
          i = n(75472),
          a = n(97087),
          s = n(15359),
          l = n(55012),
          u = n(95431),
          c = n(77897),
          d = n(35998),
          p = n(96988),
          h = n(89637),
          f = n(26559),
          m = n(68944);
        const g = async (e, t) => {
            const {
              backend: n
            } = t();
            if ((0, m.Kr)(n)) {
              if (e({
                type: l.iR6,
                promptContentEditorDocumentDownload: !0
              }), !n.corePDFBridge.ctx.wasmCtx) {
                e({
                  type: l.mxA,
                  isServerModeDownloadingWASM: !0
                });
                try {
                  var r, o;
                  const t = await (null === (r = (o = n.corePDFBridge.ctx).getWasmDispatch) || void 0 === r ? void 0 : r.call(o));
                  (0, s.kG)(t), n.corePDFBridge.ctx.wasmCtx || (await (0, a.eC)(n.corePDFBridge.ctx, t));
                } catch (e) {
                  (0, s.vU)(`Failed to load WASM context: ${e.message}`);
                } finally {
                  e({
                    type: l.mxA,
                    isServerModeDownloadingWASM: !1
                  });
                }
              }
            } else e(v);
          },
          v = async (e, t) => {
            const {
              backend: n,
              contentEditorSession: i
            } = t();
            i.contentEditor && (await i.contentEditor.closeContentEditor()), (0, s.kG)(n), (0, m.Kr)(n) && (0, r.dC)(() => {
              e({
                type: l.fBs,
                isServerModeDownloadingDocument: !0
              }), e({
                type: l.mxA,
                isServerModeDownloadingWASM: !0
              });
            });
            const a = await o.f.createContentEditor(n.corePDFBridge.ctx);
            (0, m.Kr)(n) && (0, r.dC)(() => {
              e({
                type: l.mxA,
                isServerModeDownloadingWASM: !1
              }), e({
                type: l.fBs,
                isServerModeDownloadingDocument: !1
              });
            }), (0, r.dC)(() => {
              e((0, h.fz)()), e({
                type: l.MGL,
                contentEditor: a
              });
            });
          },
          y = async (e, t) => {
            const {
              contentEditorSession: n
            } = t();
            (0, s.kG)(n.contentEditor), await n.contentEditor.closeContentEditor(), (0, r.dC)(() => {
              e({
                type: l.Qm9
              }), e(P(!1));
            });
          },
          b = (e, t, n, r, o) => V(e, t, e => e.setTextBlockCursor(t, n, r, o)),
          w = (e, t, n, r, o) => V(e, t, e => e.insertTextBlockString(t, n, r, o)),
          x = (e, t, n, r, o) => V(e, t, e => e.moveTextBlockCursor(t, n, r, o)),
          D = (e, t, n, r) => V(e, t, e => e.deleteTextBlockString(t, n, r)),
          C = (e, t, n, r) => V(e, t, e => e.setTextBlockSelection(t, n, r)),
          S = (e, t, n, r, o, i) => V(e, t, e => e.setTextBlockSelectionRange(t, n, r, o, i)),
          E = (e, t, n) => V(e, t, e => e.textBlockUndo(t, n)),
          _ = (e, t, n) => V(e, t, e => e.textBlockRedo(t, n)),
          P = e => ({
            type: l.bOH,
            isVisible: e
          }),
          k = (e, t) => ({
            type: l.joZ,
            pageIndex: e,
            textBlockId: t
          }),
          A = (e, t) => ({
            type: l.xhM,
            pageIndex: e,
            textBlockId: t
          }),
          z = e => {
            e({
              type: l.fQw
            });
          },
          T = async (e, t) => {
            e({
              type: l.Y4,
              isSaving: !0
            });
            const {
                contentEditorSession: n,
                backend: o,
                features: a,
                annotations: p,
                isAPStreamRendered: h,
                contentEditorSession: f
              } = t(),
              m = (0, d.Gp)(n);
            (0, s.kG)(o), (0, s.kG)(f.contentEditor);
            try {
              await f.contentEditor.save(i.Xn, m, []);
            } catch (t) {
              return void (0, r.dC)(() => {
                e({
                  type: l.Y4,
                  isSaving: !1
                }), e({
                  type: l.guy,
                  promptContentEditorCannotSaveChanges: !0
                });
              });
            }
            o.cancelRequests(), f.contentEditor.cancelRequests(), await o.contentEditorReload(), e({
              type: l.Y4,
              isSaving: !1
            });
            const g = await o.runPDFFormattingScriptsFromWidgets(p, null, h);
            await (0, u.jX)(e, t, {
              features: a
            }), g.length && e((0, c.bt)({
              changes: g
            })), e(y);
          },
          O = e => {
            let {
              fixpointValue: t,
              newWidth: n
            } = e;
            return async (e, r) => {
              const o = r(),
                {
                  contentEditorSession: i
                } = o;
              (0, s.kG)(i.contentEditor);
              const {
                textBlockInteractionState: a
              } = i;
              if ((null == a ? void 0 : a.state) !== p.FP.Selected) return;
              const {
                pageIndex: u,
                textBlockId: c
              } = a;
              e({
                type: l.ciU,
                pageIndex: u,
                textBlockId: c,
                fixpointValue: t,
                newWidth: n
              });
              const d = (0, p.aT)(u, c)(r());
              (0, s.kG)(d), await i.contentEditor.layoutTextBlock(c, null, null, (0, f.hH)(d)).then(t => e({
                type: l.VOt,
                pageIndex: u,
                textBlockId: c,
                updateInfo: t
              })).catch();
            };
          },
          I = e => {
            let {
              anchor: t,
              pageIndex: n = null,
              textBlockId: r = null,
              isKeyboardMove: o
            } = e;
            return async (e, i) => {
              const a = i(),
                {
                  contentEditorSession: u
                } = a;
              if ((0, s.kG)(u.contentEditor), null === n || !r) {
                const {
                  textBlockInteractionState: e
                } = u;
                if ({
                  pageIndex: n,
                  textBlockId: r
                } = e, (null == e ? void 0 : e.state) === p.FP.Active) return;
              }
              e({
                type: l.fLm,
                pageIndex: n,
                textBlockId: r,
                anchor: t,
                isKeyboardMove: o
              });
              const c = (0, p.aT)(n, r)(i());
              (0, s.kG)(c), await u.contentEditor.layoutTextBlock(r, null, null, (0, f.hH)(c)).then(t => e({
                type: l.VOt,
                pageIndex: n,
                textBlockId: r,
                updateInfo: t
              })).catch();
            };
          },
          F = e => (t, n) => {
            const r = n(),
              {
                contentEditorSession: o
              } = r;
            (0, s.kG)(o.contentEditor);
            const {
              textBlockInteractionState: i
            } = o;
            (0, s.kG)((null == i ? void 0 : i.state) === p.FP.Active);
            const a = (0, p.aT)(i.pageIndex, i.textBlockId)(r);
            if (a) if (a.selection) o.contentEditor.textBlockApplyFormat(i.textBlockId, null, e, (0, f.hH)(a)).then(e => {
              t({
                type: l.VOt,
                pageIndex: i.pageIndex,
                textBlockId: i.textBlockId,
                updateInfo: e
              });
            });else {
              let n = a.modificationsCharacterStyle.fontRef.faceRef;
              e.family && (n = n.set("family", e.family)), null != e.bold && (n = n.setIn(["variant", "bold"], e.bold)), null != e.italic && (n = n.setIn(["variant", "italic"], e.italic)), t({
                type: l.Ebp,
                pageIndex: i.pageIndex,
                textBlockId: i.textBlockId,
                faceRef: n,
                color: e.color,
                size: e.size
              });
            }
          },
          M = async (e, t) => {
            e(R());
            const {
              contentEditorSession: n
            } = t();
            (0, s.kG)(n.contentEditor);
            const r = await n.contentEditor.getAvailableFaces();
            e(L(r));
          },
          R = () => ({
            type: l.U7k
          }),
          j = (e, t) => ({
            type: l.Han,
            tooltipRect: e,
            fontFace: t
          }),
          B = e => async t => {
            new Promise(n => {
              setTimeout(() => {
                e.aborted || t({
                  type: l.WmI
                }), n();
              }, 100);
            });
          },
          N = e => ({
            type: l.nI6,
            abortController: e
          }),
          L = e => ({
            type: l.ZgW,
            faceList: e
          }),
          V = (e, t, n) => async (r, o) => {
            const {
              contentEditorSession: i
            } = o();
            (0, s.kG)(i.contentEditor), r({
              type: l.HYy
            });
            const a = await n(i.contentEditor);
            r({
              type: l.VOt,
              pageIndex: e,
              textBlockId: t,
              updateInfo: a
            });
          },
          K = async (e, t) => {
            const n = t(),
              {
                contentEditorSession: o
              } = n,
              {
                textBlockInteractionState: i
              } = o;
            (0, s.kG)((null == i ? void 0 : i.state) === p.FP.Selected || (null == i ? void 0 : i.state) === p.FP.Active);
            const {
                pageIndex: a,
                textBlockId: u
              } = i,
              c = (0, p.aT)(a, u)(t());
            (0, s.kG)(c);
            const d = (0, f.hH)(c);
            (0, r.dC)(() => {
              e(C(a, u, "everything", d)), e(D(a, u, "forward", d)), e({
                type: l.snK,
                pageIndex: a,
                textBlockId: u
              });
            });
          },
          q = e => ({
            type: l.teI,
            mode: e
          }),
          H = (e, t) => async (n, o) => {
            const {
              contentEditorSession: i
            } = o();
            (0, s.kG)(i.contentEditor), n({
              type: l.HYy
            });
            const a = await i.contentEditor.createTextBlock(e);
            a.textBlock.modificationsCharacterStyle.fontRef.size = 16;
            const {
                id: u,
                textBlock: {
                  maxWidth: c,
                  alignment: d,
                  lineSpacingFactor: p,
                  modificationsCharacterStyle: h
                }
              } = a,
              f = await i.contentEditor.layoutTextBlock(u, null, null, {
                maxWidth: c,
                alignment: d,
                lineSpacingFactor: p,
                modificationsCharacterStyle: h
              });
            (0, r.dC)(() => {
              n({
                type: l.uo5,
                pageIndex: e,
                initialTextBlock: a,
                anchor: t.set("y", t.y - f.contentRect.offset.y / 2)
              }), n({
                type: l.VOt,
                pageIndex: e,
                textBlockId: u,
                updateInfo: f
              });
            });
          };
      },
      56554: (e, t, n) => {
        "use strict";

        n.d(t, {
          Y: () => l,
          e: () => s
        });
        var r = n(15359),
          o = n(95431),
          i = n(55012),
          a = n(77897);
        function s(e, t, n, i) {
          return async (s, l) => {
            const {
              backend: u,
              features: c,
              pages: d
            } = l();
            try {
              (0, r.kG)(u), u.cancelRequests();
              const n = await u.signDocumentAndReload(e, t);
              if (await (0, o.jX)(s, l, {
                features: c,
                pageKeys: d.map(e => e.pageKey)
              }), n && "STANDALONE" === u.type) {
                const e = await u.runPDFFormattingScripts([n], !1);
                e.length > 0 && s((0, a.bt)({
                  changes: e,
                  isReloading: !0
                }));
              }
            } catch (e) {
              return i(e);
            }
            l().eventEmitter.emit("document.change", []), n();
          };
        }
        function l(e) {
          return {
            type: i.lRe,
            digitalSignatures: e
          };
        }
      },
      70982: (e, t, n) => {
        "use strict";

        n.d(t, {
          KY: () => p,
          NV: () => h,
          b_: () => c,
          kE: () => d
        });
        var r = n(15359),
          o = n(95431),
          i = n(55012),
          a = n(77897),
          s = n(11765),
          l = n(34923),
          u = n(94732);
        function c(e, t, n) {
          return async (i, l) => {
            const {
              backend: c,
              features: d,
              pages: p,
              annotations: h,
              isAPStreamRendered: m
            } = l();
            (0, r.kG)(c);
            try {
              const t = e.map(s.kg);
              c.cancelRequests(), await c.applyOperationsAndReload(t);
              const n = await c.runPDFFormattingScriptsFromWidgets(h, null, m);
              await (0, o.jX)(i, l, {
                features: d,
                pageKeys: f(p.map(e => e.pageKey), e, h.filter(e => e instanceof u.Z))
              }), n.length && i((0, a.bt)({
                changes: n
              }));
            } catch (e) {
              return n(e);
            }
            l().eventEmitter.emit("document.change", e), t();
          };
        }
        function d(e) {
          return {
            type: i.S0t,
            documentHandle: e
          };
        }
        function p(e) {
          return {
            type: i.YS$,
            isDocumentHandleOutdated: e
          };
        }
        function h(e, t) {
          return async (n, i) => {
            const {
              backend: s,
              features: l,
              annotations: u,
              isAPStreamRendered: c
            } = i();
            (0, r.kG)(s);
            try {
              s.cancelRequests(), await s.reloadDocument();
              const e = await s.runPDFFormattingScriptsFromWidgets(u, null, c);
              await (0, o.jX)(n, i, {
                features: l
              }), e.length && n((0, a.bt)({
                changes: e
              }));
            } catch (e) {
              return t(e);
            }
            i().eventEmitter.emit("document.change", []), e();
          };
        }
        function f(e, t, n) {
          return t.reduce((e, t) => {
            switch (t.type) {
              case "addPage":
                return e.insert("beforePageIndex" in t ? t.beforePageIndex : t.afterPageIndex + 1, (0, l.C)());
              case "movePages":
                {
                  const n = e.filter((e, n) => t.pageIndexes.includes(n));
                  return e.map((e, n) => t.pageIndexes.includes(n) ? null : e).splice("beforePageIndex" in t ? t.beforePageIndex : t.afterPageIndex + 1, 0, ...n.toArray()).filter(e => e);
                }
              case "removePages":
                return e.filter((e, n) => !t.pageIndexes.includes(n));
              case "keepPages":
                return e.filter((e, n) => t.pageIndexes.includes(n));
              case "duplicatePages":
                return e.flatMap((e, n) => t.pageIndexes.includes(n) ? [e, (0, l.C)()] : [e]);
              case "addPageMargins":
              case "cropPages":
              case "rotatePages":
              case "flattenAnnotations":
                return e.map((e, n) => !t.pageIndexes || t.pageIndexes.includes(n) ? (0, l.C)() : e);
              case "applyRedactions":
                {
                  const t = n.map(e => e.pageIndex).toSet();
                  return e.map((e, n) => t.includes(n) ? (0, l.C)() : e);
                }
              case "updateMetadata":
              case "setPageLabel":
                return e;
              case "importDocument":
                if (t.treatImportedDocumentAsOnePage) {
                  const n = "beforePageIndex" in t ? t.beforePageIndex : t.afterPageIndex + 1;
                  return e.map((e, t) => t < n ? e : (0, l.C)());
                }
                return e;
              case "applyInstantJson":
              case "applyXfdf":
              case "performOcr":
                return e.map(() => (0, l.C)());
              default:
                throw new Error(`Operation ${t} is not implemented`);
            }
          }, e);
        }
      },
      33056: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q: () => i,
          o: () => o
        });
        var r = n(55012);
        function o(e) {
          return {
            type: r.Oh4,
            outline: e
          };
        }
        function i(e) {
          return {
            type: r.Whn,
            level: e
          };
        }
      },
      77897: (e, t, n) => {
        "use strict";

        n.d(t, {
          bt: () => q,
          kW: () => H,
          zq: () => T,
          TD: () => F,
          Wh: () => Z,
          HE: () => I,
          PT: () => R,
          h4: () => N,
          el: () => B,
          ul: () => K,
          Vp: () => $,
          yM: () => G,
          _4: () => X,
          xW: () => O,
          xh: () => L,
          Qi: () => z,
          r$: () => j,
          V6: () => W,
          vK: () => U,
          C2: () => M
        });
        var r = n(67366),
          o = n(15359),
          i = n(35369),
          a = n(73935),
          s = n(45249),
          l = n(55012),
          u = n(11765),
          c = n(4087),
          d = n(690),
          p = n(97395),
          h = n(43069),
          f = n(73900),
          m = n(46364),
          g = n(87996),
          v = n(17766),
          y = n(96156),
          b = n(35782),
          w = n(8514);
        function x(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function D(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? x(Object(n), !0).forEach(function (t) {
              (0, y.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        async function C(e, t, n) {
          const {
              default: r
            } = await w.o[e](),
            i = (0, b.dp)({
              locale: e,
              messages: r
            }, (0, b.Sn)());
          setTimeout(() => (0, o.wp)(i.formatMessage(t, null == n ? void 0 : n.reduce((e, t, n) => D(D({}, e), {}, {
            [`arg${n}`]: t
          }), {}))), 0);
        }
        var S = n(66327),
          E = n(48625),
          _ = n(47120),
          P = n(33427),
          k = n(60859),
          A = n(34923);
        function z(e) {
          return {
            type: l.iJ2,
            formJSON: e
          };
        }
        function T(e) {
          return {
            type: l.Ui_,
            formFieldValues: e
          };
        }
        function O(e) {
          return {
            type: l.m3$,
            formFieldValues: e
          };
        }
        function I(e) {
          return {
            type: l.u7V,
            formFieldValuesIds: e
          };
        }
        function F(e) {
          return {
            type: l.zGM,
            formFields: e
          };
        }
        function M(e) {
          return {
            type: l.Wyx,
            formFields: e
          };
        }
        function R(e) {
          return {
            type: l.u_c,
            formFieldsIds: e
          };
        }
        function j(e) {
          return {
            type: l.TYu,
            onWidgetCreationStartCallback: e
          };
        }
        function B() {
          return e => {
            e((0, S.LE)(!0)), e((0, S.UF)(E.A.FORM_CREATOR));
          };
        }
        function N() {
          return e => {
            e((0, S.LE)(!1)), e((0, S.XX)());
          };
        }
        function L(e, t) {
          return (n, a) => {
            const l = e.map(e => new s.KD({
                name: e.name,
                value: e.value,
                optionIndexes: e.optionIndexes,
                isFitting: e.isFitting
              })),
              u = (0, i.aV)(l),
              {
                backend: c,
                formFields: d,
                formFieldValueManager: p,
                annotations: f,
                viewportState: {
                  zoomLevel: m
                }
              } = a();
            if ((0, o.kG)(c), (0, o.kG)(p), g.Options.PDF_JAVASCRIPT && "STANDALONE" === c.type) n(K(u, t));else {
              const e = [];
              (0, r.dC)(() => {
                u.forEach(t => {
                  let r;
                  const a = new Promise(e => {
                    r = e;
                  });
                  e.push(a), (0, h.Ay)({
                    getState: () => ({
                      formFields: d,
                      annotations: f,
                      backend: c
                    }),
                    originalFormFields: (0, i.D5)({
                      [t.name]: d.get(t.name)
                    }),
                    formFieldValues: (0, i.aV)(l),
                    callback: e => {
                      if (!e.includes(t.name)) {
                        const e = d.get(t.name);
                        (0, o.kG)(e);
                        const r = e.annotationIds.reduce((e, t) => {
                          const n = f.get(t);
                          return n instanceof s.x_ ? e.push(n) : e;
                        }, (0, i.aV)());
                        if (e.multiLine) {
                          const o = (0, k.$Z)(r.first(), e.value, m);
                          n(O((0, i.aV)([t.set("isFitting", o)])));
                        } else n(O((0, i.aV)([t])));
                      }
                    },
                    resolve: r
                  }), p.updateObject(t);
                });
              }), Promise.all(e).then(() => {
                null == t || t((0, i.aV)());
              }).catch(e => {
                throw e;
              });
            }
          };
        }
        let V = Promise.resolve();
        function K(e, t) {
          return async (n, r) => {
            const l = V;
            let u;
            V = new Promise(function (e) {
              u = e;
            }), await l;
            let c = (0, i.aV)();
            try {
              const {
                backend: t
              } = r();
              if ((0, o.kG)(t), "STANDALONE" !== t.type || !g.Options.PDF_JAVASCRIPT) return;
              const l = await (0, m.Vs)(t.evalFormValuesActions(e), 1e4),
                p = l.filter(e => e.change_type === d.zR && "pspdfkit/form-field-value" === e.object.type),
                f = p.map(e => e.object.name),
                v = (0, i.aV)(p.map(e => new s.KD({
                  name: e.object.name,
                  value: Array.isArray(e.object.value) ? (0, i.aV)(e.object.value) : e.object.value,
                  optionIndexes: e.object.optionIndexes
                }))),
                y = e.map(e => e.name).toArray().filter(e => f.indexOf(e) < 0),
                {
                  formFields: b
                } = r(),
                w = (0, h.Qg)(b.filter((e, t) => y.indexOf(t) >= 0)),
                x = b.filter(t => e.find(e => e.name === t.name) || w.find(e => e.name === t.name) || f.includes(t.name)),
                D = e.map(e => v.find(t => t.name === e.name) || e).concat(v.filter(t => !e.find(e => e.name === t.name)));
              (0, h.Ay)({
                getState: r,
                originalFormFields: x,
                formFieldValues: D,
                callback: t => {
                  e.size > 0 && (0, a.flushSync)(function () {
                    n(O(e));
                  }), w.size > 0 && (c = w, n(O(w))), n(q({
                    changes: l,
                    unchangedFormFieldValues: t
                  }));
                }
              });
            } catch (e) {} finally {
              u();
            }
            null == t || t(c);
          };
        }
        function q(e) {
          let {
            changes: t,
            unchangedFormFieldValues: n = [],
            resolve: a,
            reject: s,
            isReloading: m = !1
          } = e;
          return (e, g) => {
            const y = g(),
              {
                annotations: b,
                formFields: w,
                formFieldManager: x,
                backend: D,
                autoSaveMode: S
              } = y,
              E = y.formattedFormFieldValues;
            let P,
              k = (0, i.aV)(),
              A = y.editingFormFieldValues;
            (0, r.dC)(function () {
              null == D || D.setFormJSONUpdateBatchMode(!0).catch(e => {
                null == s || s(e);
              }), k = (0, i.aV)().withMutations(n => {
                P = E.withMutations(r => {
                  t.forEach(t => {
                    let {
                      change_type: i,
                      object: a
                    } = t;
                    switch (i) {
                      case d.uV:
                      case d.zR:
                        if ("pspdfkit/form-field-value" === a.type) {
                          const e = (0, u.u9)(a);
                          n.push(e), "string" == typeof a.formattedValue && r.set(e.name, a.formattedValue), "string" == typeof a.editingValue && (A = A.set(e.name, a.editingValue));
                        } else if (a.type.startsWith("pspdfkit/form-field/")) {
                          if (!x) return;
                          const t = (0, u.IN)(a.id, a, {
                            permissions: a.permissions,
                            group: a.group
                          });
                          w.has(t.name) ? e(U(t)) : e(H(t));
                        } else try {
                          const t = (0, u.vH)(a.id, a);
                          b.has(t.id) ? e((0, c.FG)(t)) : e((0, c.$d)(t));
                        } catch (e) {
                          (0, o.ZK)(`Form actions: unable to apply change of type "${i}"\n\n${a}\n\n${e.message}`);
                        }
                        break;
                      case d.co:
                        if (a.type.startsWith("pspdfkit/form-field/")) {
                          const t = w.get(a.name);
                          t ? e(Z(t)) : (0, o.ZK)(`Form actions: unable to find FormField to delete with id "${a.id}".`);
                        } else {
                          const t = b.get(a.id);
                          t ? e((0, c.hQ)(t)) : (0, o.ZK)(`Form actions: unable to find Annotation to delete with id "${a.id}".`);
                        }
                        break;
                      case d.D2:
                        switch (a.type) {
                          case "pspdfkit/javascript/effects/alert":
                            {
                              const {
                                message: e
                              } = a;
                              if (e.startsWith(h.$Y)) {
                                const t = e.split("[")[1].split("]"),
                                  n = t[1].split(h.as);
                                C(y.locale, v.A.dateValidationBadFormat, [t[0], n[1]]);
                              } else if (e.startsWith(h.sh)) {
                                const t = e.split("[")[1].split("]");
                                C(y.locale, v.A.numberValidationBadFormat, [t[0]]);
                              } else (0, o.wp)(e);
                              break;
                            }
                          case "pspdfkit/javascript/effects/print":
                            e((0, f.S0)());
                            break;
                          case "pspdfkit/javascript/effects/launchURL":
                            var s;
                            (null === (s = y.onOpenURI) || void 0 === s ? void 0 : s.call(y, a.url, !1)) && (a.newFrame ? (0, p.Z)(a.url) : (0, p.l)(a.url));
                            break;
                          case "pspdfkit/javascript/effects/mail":
                            {
                              if (!a.to) break;
                              let e = `mailto:${Array.isArray(a.to) ? a.to.join(",") : a.to}?`;
                              const t = [];
                              if (a.subject && t.push(`subject=${encodeURIComponent(a.subject)}`), a.cc) {
                                const e = Array.isArray(a.cc) ? a.cc.map(e => encodeURIComponent(e)).join(";") : encodeURIComponent(a.cc);
                                t.push(`cc=${e}`);
                              }
                              if (a.bcc) {
                                const e = Array.isArray(a.bcc) ? a.bcc.map(e => encodeURIComponent(e)).join(";") : encodeURIComponent(a.bcc);
                                t.push(`bcc=${e}`);
                              }
                              a.message && t.push(`body=${encodeURIComponent(a.message)}`), e += t.join("&"), (0, p.Z)(e);
                              break;
                            }
                          case "pspdfkit/javascript/effects/importIcon":
                            {
                              const t = b.find(e => e.pdfObjectId === a.annotationID || e.id === a.id);
                              t ? e(X(t)) : (0, o.ZK)(`Form actions: unable to find Annotation to import icon for with pdfObjectId "${a.annotationID}".`);
                              break;
                            }
                          default:
                            (0, o.ZK)(`Form actions: side effect "${a.type}" not supported.`);
                        }
                        break;
                      case d.Q:
                        break;
                      default:
                        (0, o.ZK)(`Form actions: change type "${i}" not supported.`);
                    }
                  });
                });
              });
            });
            const z = null == D ? void 0 : D.setFormJSONUpdateBatchMode(!1);
            let T = [];
            if (k.size > 0) {
              e(O(k)), P.size > 0 && e(function (e) {
                return {
                  type: l.VK7,
                  formattedFormFieldValues: e
                };
              }(P)), A.size > 0 && e(function (e) {
                return {
                  type: l.yET,
                  editingFormFieldValues: e
                };
              }(A));
              const {
                formFieldValueManager: t
              } = g();
              (0, o.kG)(t);
              let r = (0, i.l4)();
              T = k.filter(e => !n.includes(e.name)).map(e => {
                if (t.updateObject(e), m) {
                  const t = w.get(e.name);
                  if (t) {
                    const e = t.annotationIds.map(e => b.get(e)).filter(Boolean);
                    r = r.concat((0, i.l4)(e.map(e => e.pageIndex)));
                  }
                }
                return S === _.u.DISABLED ? Promise.resolve() : t.ensureObjectSaved(e);
              }).toArray(), m && r.size > 0 && e({
                type: l.TG1,
                pageIndexes: r
              });
            }
            Promise.all([z, ...T]).then(() => {
              null == a || a();
            }).catch(e => {
              null == s || s(e);
            });
          };
        }
        function H(e) {
          return (t, n) => {
            const {
              formFields: r,
              formFieldManager: a
            } = n();
            if (r.get(e.name)) throw new o.p2(`Cannot create form field: a form field with the name "${e.name}" already exists. Form field names must be unique.`);
            t(F((0, i.aV)([e]))), null == a || a.createObject(e);
          };
        }
        function U(e) {
          return (t, n) => {
            var r;
            const {
                formFields: a,
                annotationManager: l,
                annotations: u,
                backend: d,
                formFieldManager: p
              } = n(),
              h = a.find(t => t.id === e.id || t.name === e.name);
            if (!h) return void (0, o.ZK)("A form field that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\nThe update of this form field was skipped.");
            const f = e.merge({
              value: h.value,
              values: h.values
            });
            if (h.readOnly !== e.readOnly) {
              const t = e.annotationIds.map(e => u.get(e)).filter(Boolean);
              (0, P.CU)({
                formFields: a,
                backend: d
              }, t, e);
            }
            let m;
            if (t(M((0, i.aV)([f]))), h.name !== e.name) {
              const n = u.filter(e => e instanceof s.x_ && e.formFieldName === h.name).toList();
              m = n.map(t => t.set("formFieldName", e.name)), t((0, c.Zr)(m));
            }
            null == p || p.updateObject(f), (null === (r = m) || void 0 === r ? void 0 : r.size) > 0 && m.forEach(e => {
              null == l || l.updateObject(e);
            });
          };
        }
        function Z(e) {
          return (t, n) => {
            var r;
            const o = n(),
              a = e.annotationIds.map(e => o.annotations.get(e)).filter(Boolean);
            var s;
            a.isEmpty() || (t((0, c.aF)(a.map(e => null == e ? void 0 : e.id).toSet())), a.forEach(e => {
              var t;
              null === (t = o.annotationManager) || void 0 === t || t.deleteObject(e);
            })), t((s = (0, i.l4)([e.name]), {
              type: l.D_w,
              formFieldNames: s
            })), null === (r = o.formFieldManager) || void 0 === r || r.deleteObject(e);
          };
        }
        function $(e, t, n) {
          return (r, i) => {
            const {
              formFields: a,
              annotations: l
            } = i();
            (0, o.kG)(a.has(e.name), `Form field with name "${e.name}" not found; renaming it is not possible.`), (0, o.kG)(e.annotationIds.size === n.size, "Invalid newWidgetIds size.");
            const u = e.annotationIds.map(e => l.get(e) || l.find(t => String(t.pdfObjectId) === e)).filter(e => e instanceof s.x_),
              d = u.map((e, r) => {
                const i = n.get(r);
                return (0, o.kG)(i, "Invalid newWidgetId."), e.set("formFieldName", t).set("id", i).set("pdfObjectId", null);
              }),
              p = d.map(e => e.id);
            d.forEach(e => {
              r((0, c.$d)(e));
            });
            const h = e.merge({
              name: t,
              id: (0, A.C)(),
              pdfObjectId: null,
              annotationIds: p
            });
            r(H(h));
          };
        }
        function G(e, t) {
          return (n, r) => {
            const i = Y(r(), e, t).map(e => {
              const {
                name: t
              } = e;
              let n;
              return e instanceof s.$o || e instanceof s.XQ ? n = e.defaultValue : e instanceof s.Dz || e instanceof s.rF ? n = e.defaultValues : e instanceof s.R0 ? n = null : (0, o.kG)(!1), new s.KD({
                name: t,
                value: n
              });
            });
            g.Options.PDF_JAVASCRIPT && n(K(i)), n(O(i)), i.forEach(e => {
              var t;
              null === (t = r().formFieldValueManager) || void 0 === t || t.updateObject(e);
            });
          };
        }
        function W(e) {
          return (t, n) => {
            var r;
            const a = n();
            let l,
              u = !1;
            if (null === (r = a.formFieldValueManager) || void 0 === r || r.eventEmitter.emit("willSubmit", {
              preventDefault: () => u = !0
            }), u) return;
            const {
                uri: c,
                fields: d,
                includeExclude: p,
                exportFormat: h,
                getMethod: f,
                submitPDF: m,
                xfdf: g
              } = e,
              v = (0, i.D5)(Y(a, d, p).filter(e => !e.noExport).map(e => {
                const {
                  name: t
                } = e;
                return [t, e instanceof s.R0 ? null : void 0 === e.value ? e.values : e.value];
              }));
            if (h) {
              const e = function (e) {
                const t = [];
                return e.forEach((e, n) => {
                  const r = encodeURIComponent(n);
                  "string" == typeof e ? t.push(`${r}=${encodeURIComponent(e)}`) : null === e ? t.push(`${r}=`) : e instanceof i.aV && e.forEach(e => {
                    t.push(`${r}[]=${encodeURIComponent(e)}`);
                  });
                }), t.join("&");
              }(v);
              if (f) l = Promise.resolve({
                uri: `${c}?${e}`,
                fetchOptions: {
                  method: "GET"
                }
              });else {
                const t = {
                  headers: new Headers({
                    "Content-Type": "application/x-www-form-urlencoded"
                  }),
                  method: "POST",
                  body: e
                };
                l = Promise.resolve({
                  uri: c,
                  fetchOptions: t
                });
              }
            } else {
              if (!m) return g ? void (0, o.vU)("XFDF Form submission not supported yet.") : void (0, o.vU)("FDF Form submission not supported yet.");
              var y;
              l = null === (y = a.backend) || void 0 === y ? void 0 : y.exportPDF({
                flatten: !0,
                incremental: !1
              }).then(e => {
                const t = {
                  headers: new Headers({
                    "Content-Type": "application/pdf"
                  }),
                  method: "POST",
                  body: e
                };
                return {
                  uri: c,
                  fetchOptions: t
                };
              });
            }
            l.then(e => {
              let {
                uri: t,
                fetchOptions: n
              } = e;
              fetch(t, n).then(e => {
                var t;
                null === (t = a.formFieldValueManager) || void 0 === t || t.eventEmitter.emit("didSubmit", {
                  response: e
                });
              });
            }).catch(e => {
              var t;
              e(`Form submission failed with the following error:\n\n${e}`), null === (t = a.formFieldValueManager) || void 0 === t || t.eventEmitter.emit("didSubmit", {
                error: e
              });
            });
          };
        }
        function Y(e, t, n) {
          let r;
          const o = e.formFields.keySeq().toSet();
          return r = t ? n ? o.subtract(t) : o.intersect(t) : o, e.get("formFields").valueSeq().filter(e => r.includes(e.name)).toList();
        }
        function X(e) {
          return {
            type: l.zyH,
            annotation: e
          };
        }
      },
      49876: (e, t, n) => {
        "use strict";

        n.d(t, {
          KX: () => x,
          QQ: () => D,
          Yw: () => w,
          ou: () => S,
          pB: () => y,
          z9: () => C,
          zM: () => b
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(55012),
          s = n(4087),
          l = n(48338),
          u = n(23951),
          c = n(33427),
          d = n(76934),
          p = n(35464),
          h = n(34923),
          f = n(77897);
        function m(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function g(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? m(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function v(e) {
          return {
            type: a.faS,
            historyChangeContext: e
          };
        }
        function y(e, t) {
          return (n, r) => {
            const {
              historyChangeContext: o
            } = r();
            n(v(e)), t(), n(v(o));
          };
        }
        function b(e) {
          return {
            type: a.x64,
            annotationId: e
          };
        }
        function w() {
          return (e, t) => {
            const {
              undoActions: n,
              annotations: r,
              isHistoryEnabled: m
            } = t();
            if (!m) throw new i.p2("Cannot undo: the Undo Redo history API is disabled.");
            if (0 === n.size) throw new i.p2("Cannot undo: the Undo actions history is empty.");
            const v = n.last(),
              b = (0, l.kM)(v, r);
            e(y(d.j.HISTORY, () => {
              "create" === v.type ? e(function (e) {
                return function (t, n) {
                  const {
                    historyIdsMap: r,
                    backend: i
                  } = n();
                  let l = e.payload;
                  const u = e.formField;
                  if (e.restoreAPStream && "STANDALONE" === (null == i ? void 0 : i.type) && (l = l.set("APStreamCache", {
                    attach: r.get(l.id) || l.id
                  })), t((0, s.$d)(l)), u && t((0, f.kW)(u)), l.isCommentThreadRoot && e.comments) {
                    e.comments.map(t => t.set("rootId", e.payload.id).set("id", (0, h.C)())).forEach(e => {
                      t((0, p.Jr)(e));
                    });
                  }
                  e.restoreAPStream ? t((0, s.ug)((0, o.D5)({
                    [l.id]: l.pageIndex
                  }))) : t((0, s.GI)((0, o.D5)({
                    [l.id]: l.pageIndex
                  })));
                  const c = {
                    type: "delete",
                    payload: {
                      id: l.id
                    }
                  };
                  t({
                    type: a.bVL,
                    nextRedoAction: c
                  });
                };
              }(v)) : "update" === v.type ? e(function (e) {
                return function (t, n) {
                  const {
                    annotations: r,
                    historyIdsMap: d,
                    backend: p
                  } = n();
                  let h = r.get(e.payload.id);
                  !h && e.deletedAnnotation && (h = e.deletedAnnotation.set("id", (0, c.xc)()), t((0, s.$d)(h))), (0, i.kG)(h instanceof u.Z);
                  let f = h.merge(g(g({}, e.payload), {}, {
                    pdfObjectId: h.pdfObjectId,
                    id: h.id
                  }));
                  e.restoreAPStream && "STANDALONE" === (null == p ? void 0 : p.type) && (f = f.set("APStreamCache", {
                    attach: d.get(f.id) || f.id
                  })), t((0, s.FG)(f)), e.restoreAPStream && t((0, s.ug)((0, o.D5)({
                    [f.id]: f.pageIndex
                  })));
                  const m = {
                    type: "update",
                    payload: g(g({}, (0, l.mZ)(f, h)), {}, {
                      id: h.id
                    })
                  };
                  t({
                    type: a.bVL,
                    nextRedoAction: m
                  }), t({
                    type: a.tC1,
                    oldId: d.get(e.payload.id) || e.payload.id,
                    newId: h.id
                  });
                };
              }(v)) : "delete" === v.type ? e(function (e) {
                return function (t, n) {
                  const r = n(),
                    {
                      annotations: i,
                      commentThreads: d,
                      comments: p,
                      historyIdsMap: h
                    } = r,
                    m = i.get(e.payload.id);
                  if (!(m instanceof u.Z)) return;
                  t((0, s.hQ)(m));
                  const g = (0, c.xc)(),
                    v = (0, l.Yr)(m, g, d, p),
                    y = (0, l.ax)(m, g, r);
                  y && t((0, f.PT)((0, o.l4)([y.id])));
                  const b = {
                    type: "create",
                    payload: m.merge(e.payload).set("id", g),
                    comments: v,
                    formField: y
                  };
                  t({
                    type: a.bVL,
                    nextRedoAction: b,
                    oldId: e.payload.id
                  }), t({
                    type: a.tC1,
                    oldId: h.get(e.payload.id) || e.payload.id,
                    newId: g
                  });
                };
              }(v)) : (0, i.Rz)(v.type);
            }));
            const {
                annotations: w,
                eventEmitter: x
              } = t(),
              D = (0, l.FA)(v, w, v.payload.id);
            x.emit("history.undo", {
              before: b,
              after: D
            }), x.emit("history.change", {
              before: b,
              after: D,
              action: "undo"
            });
          };
        }
        function x() {
          return (e, t) => {
            const {
              redoActions: n,
              annotations: r,
              isHistoryEnabled: o
            } = t();
            if (!o) throw new i.p2("Cannot redo: the Undo Redo history API is disabled.");
            if (0 === n.size) throw new i.p2("Cannot redo: the Redo actions history is empty.");
            const m = n.last(),
              v = (0, l.kM)(m, r);
            e(y(d.j.HISTORY, () => {
              "create" === m.type ? e(function (e) {
                return t => {
                  const n = e.payload,
                    r = e.formField;
                  if (t((0, s.$d)(n)), n.isCommentThreadRoot && e.comments) {
                    e.comments.map(e => e.set("rootId", n.id).set("id", (0, h.C)())).forEach(e => {
                      t((0, p.Jr)(e));
                    });
                  }
                  r && t((0, f.kW)(r));
                  const o = {
                    type: "delete",
                    payload: {
                      id: n.id
                    }
                  };
                  t({
                    type: a.iwn,
                    nextUndoAction: o
                  });
                };
              }(m)) : "update" === m.type ? e(function (e) {
                return (t, n) => {
                  const {
                      annotations: r
                    } = n(),
                    o = r.get(e.payload.id);
                  (0, i.kG)(o instanceof u.Z);
                  const d = o.merge(g(g({}, e.payload), {}, {
                      id: o.id
                    })),
                    p = (0, c.pe)(n, o, () => {
                      t((0, s.FG)(d));
                    }),
                    h = {
                      type: "update",
                      payload: (0, l.mZ)(d, o),
                      restoreAPStream: p
                    };
                  t({
                    type: a.iwn,
                    nextUndoAction: h
                  });
                };
              }(m)) : "delete" === m.type && e(function (e) {
                return (t, n) => {
                  const r = n(),
                    {
                      historyIdsMap: o,
                      annotations: d,
                      commentThreads: p,
                      comments: h
                    } = r,
                    f = d.get(e.payload.id);
                  (0, i.kG)(f instanceof u.Z);
                  const m = (0, c.pe)(n, f, () => {
                      t((0, s.hQ)(f));
                    }),
                    g = (0, c.xc)(),
                    v = (0, l.Yr)(f, g, p, h),
                    y = (0, l.ax)(f, g, r),
                    b = {
                      type: "create",
                      payload: f.set("id", g),
                      restoreAPStream: m,
                      comments: v,
                      formField: y
                    };
                  t({
                    type: a.iwn,
                    nextUndoAction: b,
                    oldId: e.payload.id
                  }), t({
                    type: a.tC1,
                    oldId: o.get(e.payload.id) || e.payload.id,
                    newId: g
                  });
                };
              }(m));
            }));
            const {
                annotations: b,
                eventEmitter: w
              } = t(),
              x = (0, l.FA)(m, b, m.payload.id);
            w.emit("history.redo", {
              before: v,
              after: x
            }), w.emit("history.change", {
              before: v,
              after: x,
              action: "redo"
            });
          };
        }
        function D() {
          return (e, t) => {
            e({
              type: a._Qf
            });
            const {
              backend: n,
              eventEmitter: r
            } = t();
            "STANDALONE" === (null == n ? void 0 : n.type) && n.clearAPStreamCache(), r.emit("history.clear");
          };
        }
        function C() {
          return {
            type: a._33
          };
        }
        function S() {
          return {
            type: a.wG7
          };
        }
      },
      14935: (e, t, n) => {
        "use strict";

        n.d(t, {
          C0: () => m,
          Ik: () => u,
          Se: () => d,
          U7: () => f,
          VO: () => c,
          Xh: () => p,
          eO: () => l,
          v9: () => h
        });
        var r = n(15359),
          o = n(70982),
          i = n(29152),
          a = n(66327),
          s = n(55012);
        function l(e) {
          return {
            type: s.$8O,
            measurementToolState: e
          };
        }
        function u(e) {
          return {
            type: s.UP4,
            hintLines: e
          };
        }
        function c(e) {
          return {
            type: s.Zt9,
            secondaryMeasurementUnit: e
          };
        }
        function d(e) {
          return {
            type: s.VNu,
            activeMeasurementScale: e
          };
        }
        function p(e) {
          return {
            type: s.wgG,
            isCalibratingScale: e
          };
        }
        const h = e => async (t, n) => {
            const o = n();
            (0, r.kG)(o.backend);
            const {
              backend: i,
              secondaryMeasurementUnit: a
            } = o;
            try {
              e && (await (null == i ? void 0 : i.setSecondaryMeasurementUnit(e)), t(c(e))), a && !e && (await (null == i ? void 0 : i.setSecondaryMeasurementUnit(null)), t(c(null)));
            } catch (e) {
              (0, r.ZK)(`Failed to set secondary measurement unit: ${e}.`), t(c(a));
            }
          },
          f = (e, t) => async (n, s) => {
            const l = s();
            (0, r.kG)(l.backend);
            const {
                backend: u,
                measurementScales: c
              } = l,
              d = "STANDALONE" === u.type;
            (0, r.kG)(c);
            const {
                added: p,
                deleted: h
              } = (0, i.Rc)(c, e),
              f = h.map(async e => {
                d && (await (null == u ? void 0 : u.removeMeasurementScale(e)));
                (null == t ? void 0 : t.find(t => t.prevScale === e)) || (await (0, i.fH)({
                  deletedScale: e,
                  getState: s,
                  dispatch: n
                }));
              }),
              m = p.map(async e => {
                d && (await (null == u ? void 0 : u.addMeasurementScale(e)));
              }),
              g = null == t ? void 0 : t.map(async t => {
                await (0, i.Hg)({
                  scale: e[t.index],
                  oldScale: t.prevScale,
                  getState: s,
                  dispatch: n
                });
              });
            Promise.all([f, m, g]).then(async () => {
              d || (p.length > 0 ? await (null == u ? void 0 : u.addMeasurementScale(p[0])) : h.length > 0 && (await (null == u ? void 0 : u.removeMeasurementScale(h[0]))), n((0, o.KY)(!0))), n((0, a.RN)(e));
            });
          },
          m = e => async (t, n) => {
            const o = n();
            (0, r.kG)(o.backend);
            const {
              backend: i,
              measurementScales: s
            } = o;
            await (null == i ? void 0 : i.addMeasurementScale(e)), t((0, a.RN)(s ? [...s, e] : [e]));
          };
      },
      40084: (e, t, n) => {
        "use strict";

        n.d(t, {
          IT: () => a,
          Ic: () => p,
          Pt: () => D,
          U1: () => b,
          YA: () => s,
          Yr: () => x,
          _R: () => g,
          ac: () => C,
          du: () => y,
          dx: () => d,
          fz: () => i,
          kN: () => u,
          kr: () => f,
          lO: () => v,
          lt: () => l,
          nr: () => h,
          vG: () => m,
          vP: () => c,
          vc: () => w
        });
        var r = n(55012),
          o = n(35464);
        const i = () => ({
            type: r.wtk
          }),
          a = () => ({
            type: r.mE7
          }),
          s = e => ({
            type: r.RxB,
            pageIndex: e
          }),
          l = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            return {
              type: r.mLh,
              scrollPosition: e,
              lastScrollUsingKeyboard: t
            };
          },
          u = (e, t) => ({
            type: r.g4f,
            pageIndex: e,
            rect: t
          }),
          c = (e, t) => ({
            type: r.Lyo,
            pageIndex: e,
            rect: t
          });
        function d(e, t) {
          return n => {
            n({
              type: r.xYE,
              viewportRect: e,
              isTriggeredByOrientationChange: t
            }), n((0, o.$z)());
          };
        }
        const p = (e, t) => ({
            type: r.syg,
            zoomLevel: e,
            scrollPosition: t
          }),
          h = e => ({
            type: r.ZGb,
            viewportState: e
          }),
          f = () => ({
            type: r.UFs
          }),
          m = () => ({
            type: r.RCc
          }),
          g = () => ({
            type: r.MfE
          }),
          v = () => ({
            type: r.BWS
          }),
          y = () => ({
            type: r.QU3
          }),
          b = e => ({
            type: r.lD1,
            degCW: e
          }),
          w = () => ({
            type: r.kRo
          }),
          x = () => ({
            type: r.UFK
          }),
          D = e => ({
            type: r.D1d,
            width: e
          }),
          C = e => ({
            type: r.WsN,
            shouldDisable: e
          });
      },
      44156: (e, t, n) => {
        "use strict";

        n.d(t, {
          GO: () => l,
          Nx: () => f,
          at: () => d,
          h1: () => p,
          kQ: () => h,
          uM: () => u,
          wY: () => c
        });
        var r = n(67366),
          o = n(55012),
          i = n(79724),
          a = n(34923);
        const s = (0, i.Z)();
        function l(e, t) {
          return {
            type: o.ME7,
            payload: e,
            pageKeys: t
          };
        }
        function u(e) {
          return {
            type: o.dCo,
            payload: e
          };
        }
        const c = (e, t) => ({
          type: o.z_j,
          pageIndex: e,
          contentBlocks: t
        });
        function d(e) {
          return {
            type: o.fnw,
            backendPermissions: e
          };
        }
        const p = e => ({
            type: o.QYq,
            OCGLayers: e
          }),
          h = e => ({
            type: o.kQ7,
            visibleLayerIds: e
          }),
          f = e => async (t, n) => {
            (0, r.dC)(async () => {
              const {
                backend: r,
                pages: i
              } = n();
              var l;
              s(r), t(h(e.visibleLayerIds)), await r.setOCGVisibilityState(e), t((l = i.map(e => ({
                pageIndex: e.pageIndex,
                pageKey: (0, a.C)()
              })), {
                type: o.bM3,
                pageKeysForPages: l
              }));
            });
          };
      },
      73900: (e, t, n) => {
        "use strict";

        n.d(t, {
          xF: () => z,
          WQ: () => A,
          S0: () => O
        });
        var r = n(35369),
          o = n(15359),
          i = n(10983),
          a = n(26637),
          s = n(45249),
          l = n(98179);
        const u = l.Ni;
        function c(e, t, n) {
          const r = i.nJ[n];
          let o = r >= i.nJ[a.g.LOW] && u ? i.nJ[a.g.MEDIUM] : r;
          t || (o = i.nJ[a.g.MEDIUM]);
          let l = e.scale(o).floor();
          return l.width > i.Qr && l.width > l.height && (l = new s.$u({
            width: i.Qr,
            height: Math.round(i.Qr * l.height / l.width)
          })), l.height > i.Qr && l.height > l.width && (l = new s.$u({
            width: Math.round(i.Qr * l.width / l.height),
            height: i.Qr
          })), [l, o];
        }
        const d = e => {
          const t = e.scale(i.Ui);
          return new s.$u({
            width: Math.ceil(t.width),
            height: Math.floor(t.height)
          });
        };
        function p(e, t, n, r) {
          const a = e.ownerDocument,
            l = a.createElement("div");
          l.id = "print";
          const u = a.createElement("style");
          u.textContent = function (e) {
            const t = `\n    @page {\n      size: ${e.width}pt ${e.height}pt;\n    }\n\n    \n    @page {\n      margin: 0;\n    }`;
            return `\n    @media print {\n      \n      * {\n        ${h()}\n        padding: 0 !important;\n        margin: 0 !important;\n        box-sizing: initial !important;\n        display: none !important;\n        visibility: hidden !important;\n      }\n\n      html, body {\n        ${h()}\n        height: 100% !important;\n        width: 100% !important;\n        display: block !important;\n        visibility: visible !important;\n      }\n\n      \n\n      body {\n        background: transparent none !important;\n      }\n\n      #print, #print-container {\n        ${h()}\n        display: block !important;\n        visibility: visible !important;\n        height: 100% !important;\n      }\n\n      #print-container > div {\n        ${h()}\n        display: block !important;\n        visibility: visible !important;\n        position: relative !important;\n        top: 0 !important;\n        left: 0 !important;\n        width: 1px !important;\n        height: 1px !important;\n        overflow: visible !important;\n        page-break-after: always !important;\n        page-break-inside: avoid !important;\n      }\n\n      #print-container canvas {\n        ${h()}\n        display: block !important;\n        visibility: visible !important;\n      }\n\n    \n      #print-container > .rotate90 {\n       ${h()}\n        display: block !important;\n        visibility: visible !important;\n        transform: rotate(90deg) !important;\n    }\n\n    \n    #print-container > .rotateNegative90 {\n       ${h()}\n        display: block !important;\n        visibility: visible !important;\n        transform: translateY(${Math.abs(e.height - e.width)}pt) rotate(-90deg) !important;\n    }\n\n    \n    @-moz-document url-prefix() {\n      #print-container > .rotateNegative90 , #print-container > .rotate90 {\n        margin-bottom: ${Math.abs(e.height - e.width)}pt !important;\n      }\n    }\n\n\n\n\n    ${t}\n  `;
          }(function (e) {
            const t = e.first();
            if (!t) return new s.$u({
              width: i.zA,
              height: i._2
            });
            let n = !1;
            const r = e.reduce((e, t) => {
              let {
                pageSize: r
              } = t;
              return r.width < e.width ? (n = !0, r) : (r.height != e.height && (n = !0), e);
            }, t.pageSize).floor();
            return n && (0, o.ZK)("Printing documents using PrintMode.DOM may lead to incorrect results because not all pages have the same size.\nFor more information, see: https://pspdfkit.com/guides/web/current/features/printing/"), r;
          }(n));
          const c = a.createElement("div");
          return c.id = "print-container", t.forEach((e, t) => {
            const {
                rotation: o
              } = n.get(t) || {},
              i = a.createElement("div");
            if (i.classList.add("page"), r) {
              e.width > e.height && (1 === o ? i.classList.add("rotateNegative90") : i.classList.add("rotate90"));
            }
            i.appendChild(e), c.appendChild(i);
          }), l.appendChild(u), l.appendChild(c), e.appendChild(l), () => {
            e.removeChild(l);
          };
        }
        function h() {
          return "animation: none 0s ease 0s 1 normal none running !important;\nbackface-visibility: visible !important;\nbackground: transparent none repeat 0 0/auto auto padding-box border-box scroll !important;\nborder: medium none currentColor !important;\nborder-collapse: separate !important;\nborder-image: none !important;\nborder-radius: 0 !important;\nborder-spacing: 0 !important;\nbottom: auto !important;\nbox-shadow: none !important;\nbox-sizing: content-box !important;\ncaption-side: top !important;\nclear: none !important;\nclip: auto !important;\ncolor: #000 !important;\ncolumns: auto !important;\ncolumn-count: auto !important;\ncolumn-fill: balance !important;\ncolumn-gap: normal !important;\ncolumn-rule: medium none currentColor !important;\ncolumn-span: 1 !important;\ncolumn-width: auto !important;\ncontent: normal !important;\ncounter-increment: none !important;\ncounter-reset: none !important;\ncursor: auto !important;\ndirection: ltr !important;\ndisplay: inline !important;\nempty-cells: show !important;\nfloat: none !important;\nfont-family: serif !important;\nfont-size: medium !important;\nfont-style: normal !important;\nfont-variant: normal !important;\nfont-weight: 400 !important;\nfont-stretch: normal !important;\nline-height: normal !important;\nheight: auto !important;\nhyphens: none !important;\nleft: auto !important;\nletter-spacing: normal !important;\nlist-style: disc outside none !important;\nmargin: 0 !important;\nmax-height: none !important;\nmax-width: none !important;\nmin-height: 0 !important;\nmin-width: 0 !important;\nopacity: 1 !important;\norphans: 2 !important;\noutline: medium none invert !important;\noverflow: visible !important;\noverflow-x: visible !important;\noverflow-y: visible !important;\npadding: 0 !important;\npage-break-after: auto !important;\npage-break-before: auto !important;\npage-break-inside: auto !important;\nperspective: none !important;\nperspective-origin: 50% 50% !important;\nposition: static !important;\nright: auto !important;\ntab-size: 8 !important;\ntable-layout: auto !important;\ntext-align: left !important;\ntext-align-last: auto !important;\ntext-decoration: none !important;\ntext-indent: 0 !important;\ntext-shadow: none !important;\ntext-transform: none !important;\ntop: auto !important;\ntransform: none !important;\ntransform-origin: 50% 50% 0 !important;\ntransform-style: flat !important;\ntransition: none 0s ease 0s !important;\nunicode-bidi: normal !important;\nvertical-align: baseline !important;\nvisibility: visible !important;\nwhite-space: normal !important;\nwidows: 2 !important;\nwidth: auto !important;\nword-spacing: normal !important;\nz-index: auto !important;\nall-initial !important;";
        }
        var f = n(66327),
          m = n(43069),
          g = n(32249),
          v = n(33427),
          y = n(70025),
          b = n(82716);
        const w = {
          macos: {
            blink: !0,
            webkit: !0
          },
          windows: {
            blink: !0,
            trident: !0
          },
          ios: {
            webkit: !0
          },
          android: {},
          linux: {
            blink: !0
          },
          unknown: {}
        };
        let x = null,
          D = null,
          C = null,
          S = null;
        function E() {
          C && (clearTimeout(C), C = null), S && (clearTimeout(S), S = null), x && x.parentNode && (x.parentNode.removeChild(x), x = null), D && D();
        }
        var _ = n(55012),
          P = n(12705);
        function k() {
          return {
            type: _.skc
          };
        }
        function A() {
          return {
            type: _.snh
          };
        }
        function z() {
          return {
            type: _._uU
          };
        }
        function T(e) {
          const t = "number" == typeof e ? e : null;
          return {
            type: _.qV6,
            currentPage: t
          };
        }
        function O() {
          let {
            mode: e,
            excludeAnnotations: t = !1
          } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return (n, r) => {
            e || (e = r().printMode);
            return (e === y.X.DOM ? F : M)(n, r, t);
          };
        }
        let I = () => {};
        async function F(e, t, n) {
          e((0, f.X2)()), e(T(0)), e(k());
          const o = [];
          let i = t(),
            a = [];
          function u() {
            a.forEach(e => {
              e();
            }), a = [];
          }
          I(), I = u;
          for (const {
            pageIndex: p,
            pageSize: f
          } of i.pages) {
            if (!t().isPrinting) return I(), I = () => {}, void e(T(null));
            const [g, w] = c(f, (0, P.jb)(i), i.printQuality);
            try {
              var h;
              await (null === (h = i.annotationManager) || void 0 === h ? void 0 : h.loadAnnotationsForPageIndex(p)), i = t();
              const u = i.pages.get(p);
              let c;
              if ((0, b.k)(u && i.backend), n) c = i.backend.corePDFBridge.renderTile(p, g, new s.UL({
                width: g.width,
                height: g.height
              }), !0, !0).promise;else {
                var y;
                const {
                    annotationIds: e
                  } = u,
                  t = e.map(e => i.annotations.get(e)).filter(Boolean).filter(e => (0, v.x2)(e) && (0, v.d)(e) && !(e instanceof s.Jn || e instanceof s.On && i.commentThreads.has(e.id))).toList(),
                  n = i.formFields.filter(e => e.annotationIds.some(e => {
                    const t = i.annotations.get(e);
                    return !(!t || t.pageIndex !== p);
                  })),
                  o = (0, m.Qg)(n),
                  a = t.reduce((e, t) => e.merge((0, v.Dc)(i.attachments, t)), (0, r.D5)()),
                  l = null === (y = i.digitalSignatures) || void 0 === y || null === (y = y.signatures) || void 0 === y ? void 0 : y.filter(e => n.some(t => {
                    let {
                      name: n
                    } = t;
                    return n === e.signatureFormFQN;
                  }));
                c = i.backend.corePDFBridge.renderTile(p, g, new s.UL({
                  width: g.width,
                  height: g.height
                }), !0, !0, {
                  annotations: t,
                  formFieldValues: o,
                  attachments: a,
                  signatures: l,
                  formFields: n.toList()
                }).promise;
              }
              let {
                element: x,
                release: D
              } = await c;
              if (a.push(D), "IMG" === x.nodeName) {
                const e = x,
                  t = document.createElement("canvas");
                t.width = g.width, t.height = g.height;
                const n = t.getContext("2d");
                (0, b.k)(n), null == n || n.drawImage(e, 0, 0), x = t;
              }
              const {
                renderPageCallback: C
              } = i;
              if ("function" == typeof C) {
                const e = x.getContext("2d");
                null == e || e.scale(w, w), C(e, p, f);
              }
              const S = l.G6 ? f : d(f);
              x.style.cssText = `width: ${S.width}px !important;\nheight: ${S.height}px !important; display: none; filter: none; ${l.vU ? "border: 1px solid transparent !important" : ""}`, o.push(x), e(T(p + 1));
            } catch (e) {
              throw u(), e;
            }
          }
          try {
            (0, b.k)(document.body, "Printing requires a `<body>` tag in the main HTML layout.");
            const {
                pages: t
              } = i,
              n = function (e) {
                let t;
                for (const [n, {
                  pageSize: r
                }] of e.entries()) {
                  const e = r.width > r.height ? "landscape" : "portrait";
                  if (0 !== n) {
                    if (e !== t) return !0;
                  } else t = e;
                }
                return !1;
              }(t),
              r = p(document.body, o, t, n);
            I = () => {
              u(), r();
            }, await (w = () => {
              if ((0, g.il)(), window.focus(), l.b5) {
                let e = !1;
                const t = () => {
                    e = !0, window.focus();
                  },
                  n = () => {
                    e = !1;
                  },
                  r = () => {
                    e || (window.removeEventListener("focus", r), window.removeEventListener("beforeprint", t), window.removeEventListener("afterprint", n), I(), I = () => {});
                  };
                window.addEventListener("focus", r), window.addEventListener("beforeprint", t), window.addEventListener("afterprint", n);
              }
              window.print();
            }, x = () => {
              e((0, f.Zg)()), e(A()), e(T(null));
            }, new Promise(e => {
              const t = Date.now();
              setTimeout(() => {
                w(), x();
                const n = Date.now() - t > 500 ? 25 : 18e4;
                setTimeout(e, n);
              });
            }));
          } catch (e) {
            throw e;
          } finally {
            l.b5 || (I(), I = () => {});
          }
          var w, x;
        }
        async function M(e, t, n) {
          const r = t().backend;
          if ((0, b.k)(r), !function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : l.By,
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.SR,
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : navigator.plugins;
            const r = w[e].hasOwnProperty(t);
            let o = "ios" === e;
            const i = /pdf/i;
            for (let e = 0; e < n.length; e++) n[e].name.match(i) && (o = !0);
            return r && o;
          }() || t().hasPassword) {
            if ("STANDALONE" === r.type && "function" == typeof navigator.msSaveOrOpenBlob) {
              const e = await r.exportPDF({
                flatten: !0,
                incremental: !1,
                includeComments: !1,
                saveForPrinting: !0,
                excludeAnnotations: n
              });
              navigator.msSaveOrOpenBlob(new Blob([e], {
                type: "application/pdf"
              }), "document.pdf");
            } else {
              const {
                promise: e
              } = r.getPDFURL({
                includeComments: !1,
                saveForPrinting: !0,
                excludeAnnotations: n
              });
              !function (e) {
                const t = window.open(e, "_blank");
                t ? (t.opener = null, t.focus()) : (0, o.cM)("PSPDFKit: cannot open the PDF document in another window. You browser is probably blocking the popup.");
              }(await e);
            }
          } else {
            e(k());
            try {
              await function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.SR,
                  n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(async (r, o) => {
                  const i = 12e4;
                  E();
                  const a = document.documentElement;
                  (0, b.k)(a, "Could not access document.documentElement");
                  const s = e => {
                      e.dataset.pspdfkitPrint = "true", e.style.position = "absolute", e.style.bottom = "0px", e.style.left = "0px", e.style.width = "0px", e.style.height = "0px", e.style.border = "none", e.setAttribute("type", "application/pdf");
                    },
                    {
                      promise: l,
                      revoke: u
                    } = e.generatePDFObjectURL({
                      includeComments: !1,
                      saveForPrinting: !0,
                      excludeAnnotations: n
                    });
                  D = u;
                  const c = await l;
                  if ("trident" === t) {
                    x = document.createElement("embed"), x.setAttribute("src", c), s(x), a.appendChild(x), x.focus();
                    const e = Date.now();
                    !function t() {
                      const n = document.querySelector("embed[data-pspdfkit-print=true]");
                      (0, b.k)(n, "element not found"), Date.now() - e > 3e4 && (u(), o(new Error("timeout")));
                      try {
                        n.print(), r(), C = setTimeout(E, i);
                      } catch (e) {
                        S = setTimeout(t, 500);
                      }
                    }();
                  } else try {
                    x = document.createElement("iframe"), x.setAttribute("src", c), x.setAttribute("aria-hidden", "true"), s(x), x.onload = () => {
                      (0, b.k)(x, "iframe.onload called without element"), (0, b.k)(x instanceof HTMLIFrameElement, "element must be of type iframe");
                      const e = x.contentWindow;
                      if ("webkit" === t) {
                        const t = setInterval(() => {
                          var n;
                          "about:blank" !== (null == e ? void 0 : e.location.href) && "complete" === (null == e ? void 0 : e.document.readyState) && (clearInterval(t), null === (n = x) || void 0 === n || n.focus(), null == e || e.print(), r(), C = setTimeout(E, i));
                        }, 100);
                        setTimeout(() => {
                          clearInterval(t), o("Print failed: the document is taking too long to prepare"), E();
                        }, 5e3);
                      } else x.focus(), null == e || e.print(), r(), C = setTimeout(E, i);
                    }, a.appendChild(x);
                  } catch (e) {
                    o(e), E();
                  }
                });
              }(r, void 0, n), e(A());
            } catch (t) {
              e(A());
            }
          }
        }
      },
      31647: (e, t, n) => {
        "use strict";

        n.d(t, {
          g: () => s
        });
        var r = n(15359),
          o = n(95431),
          i = n(94732),
          a = n(34923);
        function s(e, t) {
          return async (n, i) => {
            const {
              backend: a,
              features: s
            } = i();
            try {
              (0, r.kG)(a), a.cancelRequests(), await a.applyRedactionsAndReload(), await (0, o.jX)(n, i, {
                features: s,
                pageKeys: l(i())
              });
            } catch (e) {
              return t(e);
            }
            i().eventEmitter.emit("document.change", []), e();
          };
        }
        function l(e) {
          const {
              pages: t,
              annotations: n
            } = e,
            r = n.filter(e => e instanceof i.Z).map(e => e.pageIndex).toSet();
          return t.map(e => r.includes(e.pageIndex) ? (0, a.C)() : e.pageKey);
        }
      },
      18287: (e, t, n) => {
        "use strict";

        n.d(t, {
          M0: () => d,
          Sc: () => p,
          Xe: () => s,
          _8: () => o,
          ct: () => l,
          dZ: () => a,
          j8: () => h,
          jL: () => i,
          nJ: () => c,
          t2: () => f,
          tB: () => u
        });
        var r = n(55012);
        function o(e) {
          return {
            type: r.FH6,
            term: e
          };
        }
        function i() {
          return {
            type: r.$Jy
          };
        }
        function a() {
          return {
            type: r.gIV
          };
        }
        function s() {
          return {
            type: r.$hO
          };
        }
        function l() {
          return {
            type: r._AY
          };
        }
        function u() {
          return {
            type: r.Ifu
          };
        }
        function c() {
          return {
            type: r.nFn
          };
        }
        function d(e) {
          return {
            type: r.F6q,
            isLoading: e
          };
        }
        function p(e) {
          return {
            type: r.qZT,
            results: e
          };
        }
        function h(e) {
          return {
            type: r.p1u,
            state: e
          };
        }
        function f(e) {
          return {
            type: r.esN,
            provider: e
          };
        }
      },
      89637: (e, t, n) => {
        "use strict";

        n.d(t, {
          Ab: () => P,
          BO: () => _,
          Df: () => T,
          FP: () => x,
          IP: () => M,
          J4: () => A,
          Oc: () => j,
          Q2: () => R,
          Sb: () => I,
          VR: () => O,
          Y1: () => z,
          _: () => K,
          _3: () => B,
          d5: () => C,
          fz: () => k,
          mg: () => L,
          mv: () => N,
          oX: () => F,
          td: () => S,
          tu: () => q,
          vR: () => D
        });
        var r = n(67366),
          o = n(35369),
          i = n(15359),
          a = n(98179),
          s = n(45249),
          l = n(11192),
          u = n(12705),
          c = n(33427),
          d = n(35464),
          p = n(4087),
          h = n(31442),
          f = n(54103),
          m = n(55012),
          g = n(97238),
          v = n(6502),
          y = n(35727),
          b = n(67009),
          w = n(14935);
        const x = (e, t) => n => {
            n((0, d.Dm)()), n(((e, t) => ({
              type: m.f3N,
              textRange: e,
              inlineTextMarkupToolbar: t
            }))(e, t));
          },
          D = () => (e, t) => {
            (0, l.a7)(t().frameWindow), e({
              type: m.MOe
            });
          },
          C = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, o.l4)(),
              t = arguments.length > 1 ? arguments[1] : void 0;
            return {
              type: m._fK,
              newSelectedAnnotationsIds: e,
              annotationClass: t
            };
          },
          S = e => (t, n) => {
            const {
                annotations: r,
                selectedAnnotationIds: i
              } = n(),
              a = i.reduce((e, t) => {
                const n = r.get(t);
                return n ? e.push(n) : e;
              }, (0, o.aV)());
            t(E(a)), t(C((0, o.l4)(), e));
          },
          E = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, o.aV)(),
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, o.aV)(),
              n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : (0, o.aV)();
            return (r, o) => {
              const i = o().currentItemPreset;
              e.forEach(e => {
                e && r((0, p.hQ)(e)), e && !h.ZP[i] && r((0, p.sF)(e.id));
              }), t.forEach(e => {
                r((0, p.$d)(e)), i && !h.ZP[i] && r((0, p.pZ)(e.id, i));
              }), n.forEach(e => {
                r((0, p.uk)(e));
              });
            };
          },
          _ = e => (t, n) => {
            const r = n();
            if (!r.currentTextSelection) return t(S(e)), void t(D());
            const i = r.annotations.filter(e => r.selectedAnnotationIds.has(e.id)).mapEntries(e => {
                let [, t] = e;
                return [null != t.pageIndex ? t.pageIndex : r.viewportState.currentPageIndex, null != t.pageIndex ? t : t.set("pageIndex", r.viewportState.currentPageIndex)];
              }),
              a = (0, g.Bx)(r, i, e),
              s = i.reduce((e, t) => a.find(e => e.id === t.id) ? e : e.push(t), (0, o.aV)()),
              l = a.filter(e => !r.selectedAnnotationIds.has(e.id)),
              u = a.filter(e => r.selectedAnnotationIds.has(e.id) && !e.equals(i.get(e.pageIndex)));
            t(E(s, l, u));
            const c = (0, o.l4)(a.map(e => e.id));
            t(C(c, e));
          },
          P = () => (e, t) => {
            const n = t();
            n.selectedAnnotationIds.toSeq().map(e => n.annotations.get(e)).filter(Boolean).filter(e => e instanceof s.gd ? !e.text.value || "" === e.text.value : (e instanceof s.Hi || e instanceof s.om) && (!e.points || e.points.size <= 1)).forEach(t => {
              e((0, p.hQ)(t));
            });
          },
          k = () => (e, t) => {
            var n;
            (0, l.a7)(t().frameWindow), (0, r.dC)(() => {
              e((0, d.Dm)()), e(P()), e((0, p.i0)()), e({
                type: m.MOe
              }), e({
                type: m.a33
              }), e((0, d.$z)()), e(V(null)), e((0, w.Ik)(null));
            }), null === (n = t().annotationManager) || void 0 === n || n.autoSave();
          },
          A = (e, t) => (n, r) => {
            const o = r(),
              a = o.annotations.filter((t, n) => e.includes(n)),
              c = (0, u.ix)(o),
              p = a.some(e => e instanceof s.x_);
            (0, i.kG)(!p || c, "Widget annotations cannot be selected without the corresponding license feature nor without instant enabled.");
            const h = a.map(e => e.id).toSet();
            n((0, d.Dm)()), (0, l.a7)(o.frameWindow);
            const f = h.find(e => o.commentThreads.has(e));
            if (f) {
              const e = o.commentThreads.get(f);
              (0, i.kG)(null != e);
              (0, y._P)(e, o.comments) || n((0, d.mh)(f));
            }
            n({
              type: m._Yi,
              annotations: h,
              mode: t,
              selectedAnnotationShouldDrag: null
            }), n((0, d.$z)());
          },
          z = () => ({
            type: m.RvB
          }),
          T = (e, t) => (n, r) => {
            const {
              commentThreads: a,
              comments: s,
              annotationsGroups: l
            } = r();
            if (1 === e.size) {
              const r = null == l ? void 0 : l.find(t => {
                let {
                  annotationsIds: n
                } = t;
                return n.has(e.first());
              });
              if (r) return n(T(r.annotationsIds, t || null)), void n(V(r.groupKey));
            }
            e.forEach(e => {
              if (a.has(e)) {
                const t = a.get(e);
                (0, i.kG)(t);
                (0, y._P)(t, s) || n((0, d.mh)(e));
              }
            }), n(((e, t) => ({
              type: m._Yi,
              annotations: (0, o.l4)(e),
              mode: f.o.SELECTED,
              selectedAnnotationShouldDrag: t
            }))(e, t)), n((0, d.$z)());
          },
          O = e => ({
            type: m._Yi,
            annotations: (0, o.l4)([e]),
            mode: f.o.EDITING
          });
        function I() {
          return {
            type: m.c3G
          };
        }
        const F = e => ({
            type: m.TPT,
            id: e
          }),
          M = e => ({
            type: m.iyZ,
            id: e
          }),
          R = e => ({
            type: m.qh0,
            id: e
          }),
          j = e => ({
            type: m.rm,
            id: e
          }),
          B = e => (t, n) => {
            const {
              eventEmitter: r
            } = n();
            if (e) {
              let t = !1;
              if (r.emit("annotationNote.hover", {
                preventDefault: () => t = !0,
                annotationNote: e
              }), t) return;
            }
            t({
              type: m.yyM,
              annotationNote: e
            });
          },
          N = e => (t, n) => {
            const {
              eventEmitter: r
            } = n();
            if (e) {
              let t = !1;
              if (r.emit("annotationNote.press", {
                preventDefault: () => t = !0,
                annotationNote: e
              }), t) return;
            }
            t({
              type: m.vSH,
              annotationNote: e
            });
          },
          L = function (e, t) {
            let {
              selectedAnnotationShouldDrag: n,
              preventDefault: i,
              stopPropagation: l,
              ignoreReadOnly: d,
              isAnnotationPressPrevented: h,
              clearSelection: f,
              longPress: m
            } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
              selectedAnnotationShouldDrag: null,
              preventDefault: !1,
              stopPropagation: !1,
              ignoreReadOnly: !1,
              isAnnotationPressPrevented: void 0,
              clearSelection: !1,
              longPress: !1
            };
            return (g, y) => {
              var w, x;
              const D = y(),
                {
                  selectedAnnotationIds: C,
                  annotations: S,
                  activeAnnotationNote: E,
                  collapseSelectedNoteContent: _,
                  interactionsDisabled: P,
                  eventEmitter: A,
                  formDesignMode: z,
                  isMultiSelectionEnabled: O
                } = D,
                I = !!e && (e instanceof s.Qi || (e instanceof s.Jn || e instanceof s.FV) && e.isCommentThreadRoot);
              if (null != e && e.locked && !I) return;
              const F = C.size > 1,
                M = t.shiftKey || a.Ni && F;
              if (E && g(N(null)), _ && g((0, p.i0)()), !d && (P || e && (!("action" in e) || !e.action) && (null === (w = e.additionalActions) || void 0 === w || !w.onPointerDown) && !e.isCommentThreadRoot && (0, u.lV)(e, D))) return;
              if (void 0 === h && (h = !!e && (0, c.TW)({
                annotation: e,
                nativeEvent: t.nativeEvent,
                selected: !1
              }, A)), h) return;
              if ((i || t.hasOwnProperty("type") && "keypress" === t.type) && t.preventDefault(), l && t.stopPropagation(), f && g(k()), !e) return;
              if (M) {
                const t = S.get(C.first());
                if ((null == t ? void 0 : t.pageIndex) !== e.pageIndex) return;
              }
              const R = C.has(e.id);
              if ("action" in e && e.action && !m && !R && !M) return void g((0, v.oo)(e));
              if ("additionalActions" in e && null !== (x = e.additionalActions) && void 0 !== x && x.onPointerDown) return void g((0, v.TU)(e, "onPointerDown"));
              const j = !(0, b.Zt)(D, e) && (!(e instanceof s.x_) || z);
              if (!j) return;
              const B = D.annotationsGroups.find(t => {
                let {
                  annotationsIds: n
                } = t;
                return n.has(e.id);
              });
              if (R || !j || M || B) {
                if (M && O) {
                  if (R) return g(T(C.remove(e.id), n || null)), void g(V(null));
                  if (B) return void (0, r.dC)(() => {
                    g(T(D.selectedAnnotationIds.merge(B.annotationsIds), n || null)), g(V(null));
                  });
                  if (!R && !B) return g(T(C.add(e.id), n || null)), void g(V(null));
                }
                if (!M) {
                  if (!R && !B) return void (0, r.dC)(() => {
                    g(k()), g(T((0, o.l4)([e.id]), n || null));
                  });
                  R || !B || F || (0, r.dC)(() => {
                    g(T(B.annotationsIds, n || null)), g(V(B.groupKey));
                  });
                }
              } else (0, r.dC)(() => {
                g(k()), g(T((0, o.l4)([e.id]), n || null));
              });
            };
          },
          V = e => ({
            type: m.t$K,
            groupId: e
          }),
          K = e => ({
            type: m.vBn,
            pullToRefreshNewState: e
          }),
          q = e => ({
            type: m.L2A,
            inlineTextSelectionToolbarItemsCallback: e
          });
      },
      21693: (e, t, n) => {
        "use strict";

        n.d(t, {
          Bm: () => y,
          T6: () => m,
          Th: () => f,
          de: () => b,
          l5: () => g,
          nR: () => v
        });
        var r = n(35369),
          o = n(15359),
          i = n(55012),
          a = n(54662),
          s = n(55441),
          l = n(90569),
          u = n(13205),
          c = n(33427),
          d = n(2841),
          p = n(17078),
          h = n(4087);
        function f(e, t) {
          let {
              signatureRect: n,
              signaturePageIndex: p
            } = t,
            {
              hash: h,
              attachment: f
            } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
          return (t, m) => {
            var g, v;
            null === p && (p = m().viewportState.currentPageIndex), (0, o.kG)("number" == typeof p, "Page index for a signature should be a number.");
            const y = m().pages.get(p);
            (0, o.kG)(y, `Cannot find page at index ${p}`);
            const b = y.pageSize;
            let w,
              x = e.withMutations(e => {
                const t = (0, c.lx)(m());
                Object.keys(t).forEach(n => {
                  e.set(n, t[n]);
                }), e.set("pageIndex", p), e.set("isSignature", !0);
              });
            if (n) {
              x = x.set("boundingBox", x.boundingBox.set("top", 0).set("left", 0)), x = (0, s.o)(x, new l.Z({
                width: n.width,
                height: n.height
              }), !0);
              const {
                  boundingBox: e
                } = x,
                t = n.left + (n.width - e.width) / 2,
                r = n.top + (n.height - e.height) / 2;
              w = new u.Z({
                x: t,
                y: r
              });
            } else if (!x.boundingBox.top && !x.boundingBox.left) {
              const {
                boundingBox: e
              } = x;
              w = new u.Z({
                x: b.width / 2 - e.width / 2,
                y: b.height / 2 - e.height / 2
              });
            }
            w && (x = (0, a.c)(x, w, b, new u.Z()));
            const D = {
              annotations: (0, r.aV)([x]),
              reason: d.f.SELECT_END
            };
            m().eventEmitter.emit("annotations.willChange", D), t({
              type: i.mGH,
              signature: x
            }), null === (g = m().annotationManager) || void 0 === g || g.createObject(x, {
              attachments: h && f ? (0, r.D5)([[h, f]]) : (0, r.D5)()
            }), null === (v = m().annotationManager) || void 0 === v || v.autoSave();
          };
        }
        function m(e, t) {
          return (n, r) => {
            const o = e.merge({
              id: null,
              name: null,
              pageIndex: 0
            });
            t && n({
              type: i.W0l,
              annotation: o
            }), r().eventEmitter.emit("inkSignatures.create", o), r().eventEmitter.emit("inkSignatures.change"), r().eventEmitter.emit("storedSignatures.create", o), r().eventEmitter.emit("storedSignatures.change");
          };
        }
        function g(e, t, n, r) {
          let {
              dimensions: o,
              hash: i,
              attachment: a,
              file: s
            } = e,
            {
              signatureRect: l,
              signaturePageIndex: u
            } = r;
          return (e, r) => {
            let d;
            e((0, h.Ds)("image")), d = s instanceof File ? (0, c.om)(r(), o, i, s.type, s.name) : (0, c.om)(r(), o, i, "image/png"), d = d.set("isSignature", !0), e((0, p.O)({
              hash: i,
              attachment: a
            })), e(f(d, {
              signatureRect: l,
              signaturePageIndex: u
            }, {
              hash: i,
              attachment: a
            })), t && e(m(d, n));
          };
        }
        function v(e) {
          return {
            type: i.Kw7,
            annotations: e
          };
        }
        function y(e, t) {
          return (n, r) => {
            t && n({
              type: i.Kc8,
              annotation: e
            }), r().eventEmitter.emit("inkSignatures.delete", e), r().eventEmitter.emit("inkSignatures.change"), r().eventEmitter.emit("storedSignatures.delete", e), r().eventEmitter.emit("storedSignatures.change");
          };
        }
        function b() {
          return async (e, t) => {
            const {
              populateStoredSignatures: n
            } = t().signatureState;
            e(v(await n()));
          };
        }
      },
      20253: (e, t, n) => {
        "use strict";

        n.d(t, {
          De: () => o,
          LT: () => a,
          v1: () => i
        });
        var r = n(55012);
        const o = e => ({
            type: r.aWu,
            toolbarItems: e
          }),
          i = e => ({
            type: r.T3g,
            annotationToolbarItemsCallback: e
          }),
          a = e => ({
            type: r.A8G,
            height: e
          });
      },
      739: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => x
        });
        var r = n(96156),
          o = n(67294),
          i = n(45249),
          a = n(40163),
          s = n(59140),
          l = n(98179),
          u = n(21853),
          c = n(47460),
          d = n.n(c),
          p = n(37390),
          h = n.n(p),
          f = n(48947),
          m = n.n(f),
          g = n(24322),
          v = n(14935);
        const y = (0, l.yx)(),
          b = "data:image/svg+xml;base64," + globalThis.btoa(h()),
          w = "data:image/svg+xml;base64," + globalThis.btoa(m());
        class x extends o.Component {
          constructor() {
            super(...arguments), (0, r.Z)(this, "shouldComponentUpdate", a.O), (0, r.Z)(this, "position", null), (0, r.Z)(this, "rect", null), (0, r.Z)(this, "state", {
              isDrawing: !1,
              isPenUser: !1,
              explicitScroll: !1,
              clientX: 0,
              clientY: 0,
              canAutoCloseShape: !1
            }), (0, r.Z)(this, "_drawingAreaEl", null), (0, r.Z)(this, "lastClickTime", null), (0, r.Z)(this, "_drawingAreaRef", e => {
              var t;
              (this._drawingAreaEl = e, e && l.TL) && (null === (t = this._drawingAreaEl) || void 0 === t || t.addEventListener("touchmove", u.PF));
            }), (0, r.Z)(this, "onUnmount", () => {
              var e;
              this._drawingAreaEl && l.TL && (null === (e = this._drawingAreaEl) || void 0 === e || e.removeEventListener("touchmove", u.PF));
              this._drawingAreaEl = null;
            }), (0, r.Z)(this, "_handlePointerDown", e => {
              let t = !0;
              if (y && this.props.canScrollWhileDrawing && ("pen" !== e.pointerType || this.state.isPenUser ? "touch" === e.pointerType && this.state.isPenUser && (this.setState({
                explicitScroll: !0,
                clientX: e.clientX,
                clientY: e.clientY
              }), t = !1) : this.setState({
                explicitScroll: !1,
                isPenUser: !0
              })), this.state.isDrawing) return void this._handlePointerUp();
              if (!e.isPrimary) return;
              if (!this._drawingAreaEl) return;
              this.rect = this._drawingAreaEl.getBoundingClientRect(), e.stopPropagation();
              const n = new i.E9({
                  x: e.clientX,
                  y: e.clientY
                }),
                r = this.position && n.distance(this.position) <= 10;
              var o, a;
              (this.position = n, this._buffer = [], this.setState({
                isDrawing: !0
              }), this.props.currentAnnotation instanceof i.om || this.props.currentAnnotation instanceof i.Hi) && (null === (o = (a = this.props).dispatch) || void 0 === o || o.call(a, (0, v.Ik)(null)));
              const {
                  onDrawStart: s,
                  onDoubleClick: l
                } = this.props,
                u = new Date().getTime();
              if (this.lastClickTime && l && u - this.lastClickTime < 500 && r) return l(this._transformPoint(n)), void (this.lastClickTime = null);
              this.lastClickTime = u, t && s && s(this._transformPoint(n), n);
            }), (0, r.Z)(this, "_buffer", []), (0, r.Z)(this, "_throttleMove", D()), (0, r.Z)(this, "_throttleUp", D()), (0, r.Z)(this, "_handlePointerMove", e => {
              if (this.state.explicitScroll) {
                const t = {
                    x: e.clientX,
                    y: e.clientY
                  },
                  n = {
                    x: this.state.clientX,
                    y: this.state.clientY
                  };
                return requestAnimationFrame(() => {
                  if (this.props.scrollElement) {
                    const e = this.props.scrollElement.scrollTop + (n.y - t.y),
                      r = this.props.scrollElement.scrollLeft + (n.x - t.x);
                    this.props.scrollElement.scrollTop = e, this.props.scrollElement.scrollLeft = r;
                  }
                }), void this.setState({
                  clientX: t.x,
                  clientY: t.y
                });
              }
              this._handleDrawLine(e), this._handleCursorMove(e);
            }), (0, r.Z)(this, "_handleCursorMove", e => {
              if (this.props.currentAnnotation instanceof i.om || this.props.currentAnnotation instanceof i.Hi) {
                if (!this.props.defaultAutoCloseThreshold) return;
                const a = new i.E9({
                    x: e.clientX,
                    y: e.clientY
                  }),
                  s = this.props.currentAnnotation.points,
                  l = s.last(),
                  u = this._transformPoint(a);
                var t, n;
                if (l && u) null === (t = (n = this.props).dispatch) || void 0 === t || t.call(n, (0, v.Ik)({
                  lines: [{
                    start: l,
                    end: u
                  }],
                  pageIndex: this.props.currentAnnotation.pageIndex
                }));
                if (s && s.size < 3) return;
                const c = (0, g.KM)(this.props.currentAnnotation, 0, this.props.defaultAutoCloseThreshold, new i.E9({
                  x: u.x,
                  y: u.y
                }));
                var r, o;
                if (-1 !== c && c !== s.size - 1) this.setState({
                  canAutoCloseShape: !0
                }), null === (r = (o = this.props).dispatch) || void 0 === r || r.call(o, (0, v.Ik)({
                  lines: [{
                    start: l,
                    end: s.get(c)
                  }],
                  pageIndex: this.props.currentAnnotation.pageIndex
                }));else this.setState({
                  canAutoCloseShape: !1
                });
              }
            }), (0, r.Z)(this, "_handlePointerUp", e => {
              e && !e.isPrimary || (e && e.stopPropagation(), this.setState({
                isDrawing: !1
              }), this.state.isPenUser && "touch" == (null == e ? void 0 : e.pointerType) ? this.setState({
                explicitScroll: !1
              }) : this._throttleUp(() => {
                const {
                  onDrawEnd: e
                } = this.props;
                this._drawingAreaEl && (this.rect = this._drawingAreaEl.getBoundingClientRect(), this._buffer = [], this.position && e && e(this._transformPoint(this.position)));
              }));
            }), (0, r.Z)(this, "_defaultTransformPoint", e => {
              if (!this.rect) return e;
              const t = this.props.size.width / this.rect.width,
                n = this.props.size.height / this.rect.height,
                r = "number" == typeof this.rect.x ? this.rect.x : this.rect.left,
                o = "number" == typeof this.rect.y ? this.rect.y : this.rect.top;
              return new i.Wm({
                x: e.x - r,
                y: e.y - o
              }).scale(t, n);
            }), (0, r.Z)(this, "_transformPoint", e => this._clipPointToContainerBounds((this.props.transformPoint || this._defaultTransformPoint)(new i.Wm({
              x: e.x,
              y: e.y
            }))));
          }
          render() {
            return o.createElement(s.Z, {
              onPointerDown: this._handlePointerDown,
              onRootPointerMove: this.state.isDrawing ? this._handlePointerMove : this._handleCursorMove,
              onRootPointerUpCapture: this.state.isDrawing ? this._handlePointerUp : void 0,
              interactionMode: this.props.interactionMode
            }, o.createElement("div", {
              "data-testid": "drawcomponent",
              role: "application"
            }, o.createElement("div", {
              className: d().layer,
              style: (this.props.currentAnnotation instanceof i.om || this.props.currentAnnotation instanceof i.Hi) && !l.G6 ? {
                cursor: this.state.canAutoCloseShape ? `url(${w}) 6 6, auto` : `url(${b}) 6 6, auto`
              } : {},
              ref: this._drawingAreaRef
            })));
          }
          _handleDrawLine(e) {
            e.preventDefault(), e.stopPropagation();
            const t = new i.E9({
              x: e.clientX,
              y: e.clientY
            });
            if (t.equals(this.position)) return;
            this.position = t;
            const {
              onDrawCoalesced: n
            } = this.props;
            if (n) {
              const t = e.getCoalescedEvents();
              this._buffer = this._buffer.concat(t), this._throttleMove(() => {
                const [e, t] = this._buffer.reduce((e, t) => {
                  const n = new i.E9({
                    x: t.clientX,
                    y: t.clientY
                  });
                  return e[0].push(this._transformPoint(n)), e[1].push(n), e;
                }, [[], []]);
                this._buffer = [], n(e, t);
              });
            }
          }
          _clipPointToContainerBounds(e) {
            if (this._isPointWithinContainer(e)) return e;
            const {
              size: t
            } = this.props;
            return e.x > t.width && (e = e.set("x", t.width)), e.x < 0 && (e = e.set("x", 0)), e.y > t.height && (e = e.set("y", t.height)), e.y < 0 && (e = e.set("y", 0)), e;
          }
          _isPointWithinContainer(e) {
            const {
              size: t
            } = this.props;
            return new i.UL({
              width: t.width,
              height: t.height
            }).isPointInside(e);
          }
        }
        function D() {
          let e;
          return t => {
            e || requestAnimationFrame(() => {
              const t = e;
              e = null, t();
            }), e = t;
          };
        }
      },
      2877: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => p
        });
        var r = n(96156),
          o = n(15359),
          i = n(67294),
          a = n(94184),
          s = n.n(a),
          l = n(72322),
          u = n(21853),
          c = n(84008),
          d = n.n(c);
        class p extends i.PureComponent {
          constructor() {
            var e;
            super(...arguments), e = this, (0, r.Z)(this, "_cancelImagePromise", null), (0, r.Z)(this, "_throttledFetchImage", (0, l.Z)(this._fetchImage, "number" == typeof this.props.throttleTimeout ? this.props.throttleTimeout : 2e3, !0)), (0, r.Z)(this, "imageRef", i.createRef()), (0, r.Z)(this, "_replaceImage", function (t) {
              let n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              e.imageRef.current ? (e.imageRef.current.appendChild(t.element), setTimeout(() => t.release(), 500), e.imageRef.current && e.imageRef.current.children.length > 1 && e.imageRef.current.removeChild(e.imageRef.current.firstChild), e.props.onRenderFinished && e.props.onRenderFinished(), n && e._throttledFetchImage()) : t.release();
            }), (0, r.Z)(this, "_onImageAvailable", function (t) {
              let n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              const {
                  label: r,
                  visible: i
                } = e.props,
                a = t.element;
              a && e.imageRef.current && a !== e.imageRef.current.firstChild && (a.setAttribute("alt", r || ""), i || a.setAttribute("role", "presentation"), (0, u.sR)(a).then(() => requestAnimationFrame(() => e._replaceImage(t, n))).catch(t => {
                (0, o.vU)(t), e.props.onError && e.props.onError(t);
              }));
            });
          }
          componentDidMount() {
            this._throttledFetchImage();
          }
          refresh() {
            this._throttledFetchImage();
          }
          refreshSkippingThrottle() {
            this._fetchImage();
          }
          async _fetchImage() {
            let e;
            this._cancelOutstandingRequests();
            const {
              promise: t,
              isProvisional: n,
              cancel: r
            } = this.props.fetchImage();
            this._cancelImagePromise = r;
            try {
              var i, a;
              if (e = await t, e) this._onImageAvailable(e, n);else null === (i = (a = this.props).onError) || void 0 === i || i.call(a);
            } catch (e) {
              var s, l;
              (0, o.vU)(e), r(e), null === (s = (l = this.props).onError) || void 0 === s || s.call(l, e);
            }
            this._cancelImagePromise = null;
          }
          _cancelOutstandingRequests() {
            this._cancelImagePromise && this._cancelImagePromise();
          }
          componentWillUnmount() {
            this._cancelOutstandingRequests();
          }
          render() {
            const {
              className: e,
              rectStyle: t
            } = this.props;
            return i.createElement("div", {
              className: s()(d().root, e),
              style: t,
              ref: this.imageRef
            });
          }
        }
      },
      21655: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => y
        });
        var r = n(22122),
          o = n(96156),
          i = n(31672),
          a = n(67294),
          s = n(94184),
          l = n.n(s),
          u = n(83882),
          c = n(86849),
          d = n(44077),
          p = n(98179),
          h = n(16989),
          f = n.n(h);
        function m(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function g(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? m(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function v(e) {
          const {
              pageIndex: t,
              cssPrefix: n,
              renderItemCallback: o,
              itemState: i,
              clickDisabled: s,
              onItemPress: d,
              onItemFocus: h,
              size: m,
              itemScale: v,
              thumbnailSize: y,
              thumbnailHeight: b
            } = e,
            w = g(g({}, m.toJS()), {}, {
              paddingTop: 32 * v,
              paddingRight: 32 * v,
              paddingBottom: 24 * v,
              paddingLeft: 32 * v
            }),
            [, x] = function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = 0;
              const [r, o] = a.useState(null),
                [i, s] = a.useState(!1),
                l = e => {
                  t || s(e);
                };
              function u() {
                n = Date.now(), l(!1);
              }
              return [i, {
                onTouchStart() {
                  n = Date.now(), l(!0);
                },
                onTouchEnd: u,
                onTouchCancel: u,
                onMouseEnter() {
                  Date.now() - n > 500 && l(!0);
                },
                onMouseLeave() {
                  l(!1);
                },
                onMouseDown(e) {
                  o(e);
                },
                onPointerDown(e) {
                  o(e);
                },
                onClick(t) {
                  r && r.clientX === t.clientX && r.clientY === t.clientY && (e(t), o(null));
                }
              }];
            }(() => {
              i.dragging || d(t);
            }),
            {
              item: D,
              label: C,
              props: S
            } = o(t, y, b),
            E = l()(f().thumbnail, n + "-Thumbnails-Page-Image", {
              [f().thumbnailClickDisabled]: s,
              [f().thumbnailSelected]: i.selected,
              [f().thumbnailBeingDragged]: i.dragging
            });
          return a.createElement("div", (0, r.Z)({
            style: w,
            className: l()(f().column, n + "-Thumbnails-Page", f()[`engine-${p.SR}`], {
              [n + "-Thumbnails-Page-Selected"]: i.selected
            }),
            "data-testid": "grid-column",
            "data-page-index": t
          }, S), a.createElement("div", {
            style: {
              width: y,
              height: y
            },
            className: f().columnPreview
          }, e.clickDisabled ? a.createElement("div", {
            className: E
          }, D) : a.createElement(u.Z, (0, r.Z)({
            is: "div",
            className: E,
            "aria-label": `Select Page ${C}`,
            "aria-pressed": i.selected,
            onKeyPress: e => {
              const {
                charCode: n
              } = e;
              n === c.tW && d(t);
            },
            onFocus: () => h(t),
            onBlur: () => h(null),
            ref: i.itemRef
          }, "object" == typeof x && x), D)), a.createElement("div", {
            style: {
              height: 24,
              maxWidth: y,
              marginTop: 16 * v,
              lineHeight: "24px"
            },
            className: l()(f().label, n + "-Thumbnails-Page-Label", {
              [f().labelSelected]: i.selected
            })
          }, C));
        }
        const y = e => {
          const {
            cssPrefix: t,
            clickDisabled: n,
            width: r,
            moveCursor: o,
            thumbnailHeight: s,
            containerOffset: u,
            gridContainerEl: c
          } = e;
          let {
            itemScale: p
          } = e;
          const [h, m] = a.useState(null);
          p = Math.min(p, (r - 15) / (s + 32 + 32)), p = Math.max(p, .01);
          const g = a.useMemo(function () {
              return new d.$u({
                width: p * (s + 32 + 32),
                height: p * (s + 32 + 24 + 16) + 24
              });
            }, [p, s]),
            y = s * p,
            b = o ? "left" === o.position ? o.pageIndex : o.pageIndex + 1 : void 0;
          return a.createElement(i.FE, {
            width: e.width,
            height: e.height,
            canInsert: e.canInsert,
            draggingEnabled: !!e.onItemsMove && !n,
            totalItems: e.totalItems,
            itemWidth: g.width,
            itemHeight: g.height,
            itemPaddingLeft: 32 * p,
            itemPaddingRight: 32 * p,
            renderItem: (r, o) => a.createElement(v, {
              selectedItemIndexes: e.selectedItemIndexes,
              size: g,
              itemScale: p,
              pageIndex: r,
              itemState: o,
              cssPrefix: t,
              clickDisabled: n || !1,
              renderItemCallback: e.renderItemCallback,
              onItemPress: e.onItemPress,
              onItemFocus: e => m(e),
              thumbnailHeight: s,
              thumbnailSize: y
            }),
            itemKey: e.itemKeyCallback,
            renderDragPreview: e.renderDragPreviewCallback ? (t, n) => e.renderDragPreviewCallback ? e.renderDragPreviewCallback(n, t, y, s) : null : void 0,
            renderInsertionCursor: (e, t) => {
              const n = {
                top: 32 * p + 1,
                height: s * p - 1
              };
              return a.createElement("div", {
                style: n,
                className: l()(f().moveCursor, {
                  [f().moveCursorDisabled]: !e
                })
              }, null != (null == o ? void 0 : o.previewContent) && a.createElement("div", {
                className: l()(f().moveCursorPreview, {
                  [f().moveCursorPreviewEnd]: t
                })
              }, o.previewContent));
            },
            onDragEnd: e.onItemsMove,
            selectedItemIndexes: e.selectedItemIndexes,
            insertionIndex: b,
            focusedItemIndex: h,
            containerOffset: u,
            gridContainerEl: c
          });
        };
      },
      53261: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r = n(22122),
          o = n(17375),
          i = n(67294);
        const a = ["src"];
        function s(e) {
          let {
              src: t
            } = e,
            n = (0, o.Z)(e, a);
          const s = i.useRef(null);
          return i.useEffect(function () {
            if (s.current) {
              const e = s.current.childNodes[0];
              "function" == typeof e.setAttribute && e.setAttribute("focusable", "false");
            }
          }, []), i.createElement("span", (0, r.Z)({}, n, {
            dangerouslySetInnerHTML: {
              __html: t
            },
            ref: s
          }));
        }
      },
      12559: (e, t, n) => {
        "use strict";

        n.d(t, {
          O: () => p
        });
        var r = n(96156),
          o = n(67294);
        function i(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function a(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const s = {
            strokeDasharray: 100
          },
          l = a(a({}, s), {}, {
            fill: "none"
          }),
          u = e => o.createElement("polygon", {
            points: "0.5,2 0.5,0.5 3.5,0.5 3.5,3.5 0.5,3.5 0.5,2",
            style: a(a({}, e), s)
          }),
          c = e => o.createElement("circle", {
            cx: "2",
            cy: "2",
            r: "1.5",
            style: a(a({}, e), s)
          }),
          d = e => o.createElement("line", {
            x1: "0",
            y1: "2",
            x2: "4",
            y2: "2",
            style: a(a({}, e), l)
          }),
          p = {
            none: {
              startElement: d,
              endElement: d,
              width: 4
            },
            square: {
              startElement: u,
              endElement: u,
              width: 3.5
            },
            circle: {
              startElement: c,
              endElement: c,
              width: 3.5
            },
            diamond: {
              startElement: e => o.createElement("polygon", {
                points: "3.5,2 2.25,3.25 1,2 2.25,0.75 3.5,2 4,2",
                style: a(a({}, e), s)
              }),
              endElement: e => o.createElement("polygon", {
                points: "0.75,2 2,0.75 3.25,2 2,3.25 0.75,2 0.25,2",
                style: a(a({}, e), s)
              }),
              width: 3.5
            },
            openArrow: {
              startElement: e => o.createElement("polyline", {
                points: "4.25,0.5 1.25,2 4.25,3.5 1.25,2 4.75,2",
                style: a(a({}, e), l)
              }),
              endElement: e => o.createElement("polyline", {
                points: "0.25,0.5 3.25,2 0.25,3.5 3.25,2 -0.25,2",
                style: a(a({}, e), l)
              }),
              width: 3.75
            },
            closedArrow: {
              startElement: e => o.createElement("polygon", {
                points: "3.75,2 3.75,0.75 1.25,2 3.75,3.25 3.75,2 4.75,2",
                style: a(a({}, e), s)
              }),
              endElement: e => o.createElement("polygon", {
                points: "0.75,2 0.75,0.75 3.25,2 0.75,3.25 0.75,2 -0.75,2",
                style: a(a({}, e), s)
              }),
              width: 3.75
            },
            butt: {
              startElement: e => o.createElement("line", {
                x1: "3.75",
                y1: "0.5",
                x2: "3.75",
                y2: "3.5",
                style: a(a({}, e), l)
              }),
              endElement: e => o.createElement("line", {
                x1: "0.5",
                y1: "0.5",
                x2: "0.5",
                y2: "3.5",
                style: a(a({}, e), l)
              }),
              width: .5
            },
            reverseOpenArrow: {
              startElement: e => o.createElement("polyline", {
                points: "1,0.5 4,2 1,3.5",
                style: a(a({}, e), l)
              }),
              endElement: e => o.createElement("polyline", {
                points: "3.25,0.5 0.25,2 3.25,3.5",
                style: a(a({}, e), l)
              }),
              width: 3
            },
            reverseClosedArrow: {
              startElement: e => o.createElement("polygon", {
                points: "4,2 1.5,3.25 1.5,0.75",
                style: a(a({}, e), s)
              }),
              endElement: e => o.createElement("polygon", {
                points: "0.25,2 2.75,3.25 2.75,0.75",
                style: a(a({}, e), s)
              }),
              width: 2.75
            },
            slash: {
              startElement: e => o.createElement("polyline", {
                points: "3.25,0.5 2.25,3.75 2.85,2 3.75,2",
                style: a(a({}, e), l)
              }),
              endElement: e => o.createElement("polyline", {
                points: "1.85,0.5 0.85,3.75 1.25,2 0.35,2",
                style: a(a({}, e), l)
              }),
              width: 1.5
            }
          };
      },
      29911: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(67294),
          o = n(94184),
          i = n.n(o),
          a = n(44032),
          s = n.n(a);
        function l(e) {
          let {
            scale: t = 1,
            rotate: n = 0
          } = e;
          const [o, a] = r.useState(!1);
          r.useEffect(() => {
            const e = setTimeout(() => {
              a(!0);
            }, 400);
            return () => {
              clearTimeout(e);
            };
          }, []);
          const l = `scale(${t})`,
            u = {
              transform: n ? `rotate(${n}deg) ${l}` : l,
              transformOrigin: "center center"
            };
          return r.createElement("div", {
            style: u,
            className: i()("PSPDFKit-Loading-Indicator", s().loader, {
              [s().loaderShown]: o
            })
          }, r.createElement("div", {
            className: s().loaderDot
          }), r.createElement("div", {
            className: s().loaderDot
          }), r.createElement("div", {
            className: s().loaderDot
          }));
        }
      },
      80444: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => S
        });
        var r = n(96156),
          o = n(67366),
          i = n(67294),
          a = n(84293),
          s = n(93113),
          l = n(11192),
          u = n(98179),
          c = n(2464),
          d = n(40084),
          p = n(45249),
          h = n(87849),
          f = n(82716);
        const m = (0, h.Yw)(),
          g = {
            onPinchStart: "pinchstart",
            onPinchIn: "pinchin",
            onPinchOut: "pinchout",
            onPinchCancel: "pinchcancel",
            onPinchEnd: "pinchend",
            onSwipeLeft: "swipeleft",
            onSwipeRight: "swiperight",
            onDoubleTap: "doubletap"
          };
        function v(e, t, n) {
          t && Object.keys(t).forEach(r => {
            const o = g[r];
            !o || "function" != typeof t[r] || n && "function" == typeof n[r] && n[r] === t[r] || e.off(o, t[r]);
          }), n && (n.enablePinch && e.get("pinch").set({
            enable: !0,
            threshold: .3
          }), n.onDoubleTap && e.get("doubletap").set({
            posThreshold: 50
          }), Object.keys(n).forEach(r => {
            const o = g[r];
            !o || "function" != typeof n[r] || t && "function" == typeof n[r] && n[r] === t[r] || e.on(o, n[r]);
          }));
        }
        class y extends i.Component {
          constructor() {
            super(...arguments), (0, r.Z)(this, "_handleRef", e => {
              e && ((0, f.k)("string" == typeof e.nodeName, "TRC requires a basic HTML element as children. This looks like a custom react component."), this._refElement = e);
            });
          }
          componentDidMount() {
            this.initializeHammer(), v(this._hammer, null, this.props);
          }
          initializeHammer() {
            this._hammer = new m(this._refElement, {
              touchAction: "pan-x pan-y"
            }), this._refElement.style.msTouchSelect = "initial";
          }
          componentDidUpdate(e) {
            this._hammer && v(this._hammer, e, this.props);
          }
          componentWillUnmount() {
            v(this._hammer, this.props, null), this._hammer && (this._hammer.stop(), this._hammer.destroy()), this._hammer = null;
          }
          render() {
            const e = i.Children.only(this.props.children);
            return (0, f.k)(!e.ref, "TRC requires the child element to not have a `ref` assigned. Consider inserting a new `<div>` in between."), i.cloneElement(e, {
              ref: this._handleRef
            });
          }
        }
        const b = !n(87856).Gn || {
          passive: !1,
          capture: !0
        };
        class w extends i.Component {
          constructor() {
            super(...arguments), (0, r.Z)(this, "_trackpadRef", i.createRef()), (0, r.Z)(this, "_hasWheelEventStarted", !1), (0, r.Z)(this, "_currentWheelTimeout", null), (0, r.Z)(this, "_lastScale", 1), (0, r.Z)(this, "_handleWheel", e => {
              if (!this.props.enableAlwaysScrollToZoom && !e.ctrlKey) return;
              e.preventDefault(), e.stopPropagation(), this._currentWheelTimeout && clearTimeout(this._currentWheelTimeout), this._currentWheelTimeout = setTimeout(() => {
                this.props.onPinchEnd(), this._hasWheelEventStarted = !1, this._lastScale = 1;
              }, 250);
              const t = function (e, t) {
                return {
                  center: {
                    x: e.clientX,
                    y: e.clientY
                  },
                  scale: t - e.deltaY / 120,
                  pointerType: "mouse",
                  preventDefault: e.preventDefault,
                  srcEvent: e
                };
              }(e, this._lastScale);
              let n = 1;
              n = t.scale > 1 ? 1.05 * this._lastScale : .95 * this._lastScale, t.scale = n, n * this.props.zoomLevel > this.props.minZoomLevel && n * this.props.zoomLevel < this.props.maxZoomLevel && (this._hasWheelEventStarted || (this.props.onPinchStart(t), this._hasWheelEventStarted = !0), this._lastScale = n, this.props.onPinch(t));
            }), (0, r.Z)(this, "_handleGestureStart", e => {
              e.preventDefault(), this.props.onPinchStart(x(e));
            }), (0, r.Z)(this, "_handleGestureChange", e => {
              e.preventDefault(), this.props.onPinch(x(e));
            }), (0, r.Z)(this, "_handleGestureEnd", e => {
              e.preventDefault(), this.props.onPinchEnd(x(e));
            });
          }
          componentDidMount() {
            const {
              current: e
            } = this._trackpadRef;
            if (e) {
              const t = e.ownerDocument;
              t.addEventListener("wheel", this._handleWheel, b), "ios" !== u.By && (t.addEventListener("gesturestart", this._handleGestureStart), t.addEventListener("gesturechange", this._handleGestureChange), t.addEventListener("gestureend", this._handleGestureEnd));
            }
          }
          componentWillUnmount() {
            const {
              current: e
            } = this._trackpadRef;
            if (e) {
              const t = e.ownerDocument;
              t.removeEventListener("wheel", this._handleWheel, b), "ios" !== u.By && (t.removeEventListener("gesturestart", this._handleGestureStart), t.removeEventListener("gesturechange", this._handleGestureChange), t.removeEventListener("gestureend", this._handleGestureEnd));
            }
          }
          render() {
            return i.createElement("div", {
              ref: this._trackpadRef
            }, this.props.children);
          }
        }
        function x(e) {
          return {
            center: {
              x: e.clientX,
              y: e.clientY
            },
            scale: e.scale,
            pointerType: "mouse",
            preventDefault: e.preventDefault,
            srcEvent: e
          };
        }
        function D(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function C(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? D(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class S extends i.Component {
          constructor() {
            super(), (0, r.Z)(this, "_zoomLayerRef", i.createRef()), (0, r.Z)(this, "_handleDoubleTap", e => {
              if ("touch" !== e.pointerType) return;
              const {
                  viewportState: t
                } = this.props,
                {
                  viewportRect: n,
                  zoomLevel: r
                } = t;
              this._startZooming();
              const o = new p.E9({
                  x: e.center.x,
                  y: e.center.y
                }).translate(n.getLocation().scale(-1)),
                i = this.props.viewportState.scrollMode === c.G.PER_SPREAD || this.props.viewportState.scrollMode === c.G.DISABLED ? (0, a.vw)(t) : (0, a.kh)(t),
                s = r > i ? i : 1.5 * r,
                l = (0, a.cq)(t, s, {
                  zoomCenter: o
                });
              this.setState({
                nextViewportState: l,
                shouldAnimate: !0
              }), this._callEndZoomingAfterTransition(l);
            }), (0, r.Z)(this, "_handlePinchStart", e => {
              const {
                  viewportState: t
                } = this.props,
                {
                  viewportRect: n
                } = t;
              this._startZooming(), this._touchZoomCenter = new p.E9({
                x: e.center.x,
                y: e.center.y
              }).translate(n.getLocation().scale(-1));
            }), (0, r.Z)(this, "_handlePinch", e => {
              this._isZooming && (this._lastPinchScale = e.scale, this.requestAnimationFrameId || (this.requestAnimationFrameId = window.requestAnimationFrame(this._renderNextFrame)), null !== this._pinchResetTimeoutId && clearTimeout(this._pinchResetTimeoutId), this._pinchResetTimeoutId = setTimeout(() => this._handlePinchEnd(), 2e3));
            }), (0, r.Z)(this, "_handlePinchEnd", () => {
              if (!this._isZooming) return;
              null !== this._pinchResetTimeoutId && (clearTimeout(this._pinchResetTimeoutId), this._pinchResetTimeoutId = null);
              const {
                  viewportState: e
                } = this.props,
                {
                  zoomLevel: t
                } = e;
              if (!this._touchZoomCenter) return;
              this.requestAnimationFrameId && (window.cancelAnimationFrame(this.requestAnimationFrameId), this.requestAnimationFrameId = null);
              const n = t * this._lastPinchScale,
                r = (0, a.cq)(e, n, {
                  zoomCenter: this._touchZoomCenter
                });
              this.state.nextViewportState && (0, a.hT)(this.state.nextViewportState) ? (this.setState({
                nextViewportState: r,
                shouldAnimate: !0
              }), this._callEndZoomingAfterTransition(r)) : this._zoomComplete(r);
            }), (0, r.Z)(this, "_renderNextFrame", () => {
              const {
                  viewportState: e
                } = this.props,
                {
                  zoomLevel: t
                } = e,
                n = t * this._lastPinchScale,
                r = (0, a.cq)(e, n, {
                  zoomCenter: this._touchZoomCenter,
                  unbounded: !0
                });
              this.setState({
                nextViewportState: r
              }), this.requestAnimationFrameId = null;
            }), (0, r.Z)(this, "_zoomComplete", e => {
              (0, o.dC)(() => {
                this.props.dispatch((0, d.nr)(e)), this._endZooming();
              });
            }), this._touchZoomCenter = new p.E9(), this._isZooming = !1, this.state = {
              shouldAnimate: !1,
              nextViewportState: null
            }, this.requestAnimationFrameId = null;
          }
          render() {
            const {
                children: e,
                viewportState: t
              } = this.props,
              {
                nextViewportState: n
              } = this.state,
              r = (0, s.G4)(t);
            let o = {
              transformOrigin: "0 0",
              width: r.width + t.viewportPadding.x,
              height: r.height + t.viewportPadding.y
            };
            if (n) {
              const e = n.scrollPosition.scale(n.zoomLevel).translate(t.scrollPosition.scale(-t.zoomLevel)),
                r = (0, s.G4)(n).translate(e.scale(-1)),
                i = n.zoomLevel / t.zoomLevel;
              o = C(C({}, o), {}, {
                transform: `translate(${r.left}px, ${r.top}px)\n                    scale(${i}, ${i})`,
                willChange: "transform",
                transition: this.state.shouldAnimate ? "transform 150ms ease-in" : ""
              });
            } else o = C(C({}, o), {}, {
              transform: `translate(${Math.ceil(r.left)}px, ${Math.ceil(r.top)}px)`
            });
            return i.createElement(w, {
              onPinchStart: this._handlePinchStart,
              onPinch: this._handlePinch,
              onPinchEnd: this._handlePinchEnd,
              zoomLevel: this.props.viewportState.zoomLevel,
              minZoomLevel: (0, a.Yo)(this.props.viewportState),
              maxZoomLevel: (0, a.Sm)(this.props.viewportState),
              enableAlwaysScrollToZoom: this.props.viewportState.enableAlwaysScrollToZoom
            }, i.createElement(y, {
              onPinchStart: this._handlePinchStart,
              onPinchIn: this._handlePinch,
              onPinchOut: this._handlePinch,
              onPinchEnd: this._handlePinchEnd,
              onPinchCancel: this._handlePinchEnd,
              onDoubleTap: this._handleDoubleTap,
              enablePinch: !0
            }, i.createElement("div", null, i.createElement("div", {
              ref: this._zoomLayerRef,
              style: o,
              className: "PSPDFKit-Zoom"
            }, e))));
          }
          _callEndZoomingAfterTransition(e) {
            this._removeAnimationEventListener();
            const t = this._zoomComplete.bind(this, e);
            this._zoomCompleteFn = t, this._zoomLayerRef.current && this._zoomLayerRef.current.addEventListener("transitionend", this._zoomCompleteFn), setTimeout(() => {
              this._zoomCompleteFn && t === this._zoomCompleteFn && this._zoomCompleteFn();
            }, 250);
          }
          _startZooming() {
            if (!this._isZooming && (this._isZooming = !0, "gecko" === u.SR && "windows" === u.By && this._zoomLayerRef.current)) {
              const {
                defaultView: e
              } = this._zoomLayerRef.current.ownerDocument;
              (0, l.a7)(e);
            }
          }
          _endZooming() {
            this._resetState();
          }
          _resetState() {
            this.setState({
              shouldAnimate: !1,
              nextViewportState: null
            }), this._lastPinchScale = 1, this._touchZoomCenter = new p.E9(), this._isZooming = !1, this._removeAnimationEventListener();
          }
          _removeAnimationEventListener() {
            this._zoomLayerRef.current && this._zoomLayerRef.current.removeEventListener("transitionend", this._zoomCompleteFn), this._zoomCompleteFn = null;
          }
        }
      },
      3962: (e, t, n) => {
        "use strict";

        n.r(t), n.d(t, {
          default: () => ne,
          getDocumentKeyForReferencePoints: () => te,
          messages: () => re
        });
        var r,
          o,
          i,
          a,
          s,
          l,
          u,
          c,
          d = n(67294),
          p = n(73935),
          h = n(35782),
          f = n(52163),
          m = n(79112),
          g = n(96156),
          v = n(29911),
          y = n(22122),
          b = n(67665),
          w = n(94184),
          x = n.n(w),
          D = n(67366),
          C = n(80444),
          S = n(739),
          E = n(53261),
          _ = n(44077),
          P = n(68540),
          k = n(92744),
          A = n(48625),
          z = n(15164),
          T = n(85944),
          O = n(98179),
          I = n(28735),
          F = n.n(I);
        const M = (0, O.b1)(),
          R = M ? {
            x: 31.25,
            y: 13
          } : {
            x: 12.5,
            y: -4
          },
          j = e => {
            const {
                viewportState: t,
                backend: r,
                scrollElement: o,
                styles: i,
                currentDocumentKey: a,
                referencePoints: s,
                addReferencePoint: l,
                page: u,
                isAutoCompare: c,
                interactionMode: p
              } = e,
              {
                formatMessage: f
              } = (0, h.YB)(),
              g = (0, P.tm)(),
              [v, y] = d.useState(!1),
              w = d.useRef(null),
              O = (0, P.R9)(e => {
                M ? (v || y(!0), w.current && clearTimeout(w.current), w.current = setTimeout(() => {
                  w.current = null, g() && y(!1);
                }, 300)) : e();
              }),
              I = a !== m.Q.result ? a === m.Q.documentA ? s.slice(0, 3) : s.slice(3, 6) : [],
              j = s.length < 6 && I.filter(Boolean).length < 3 && !c && p !== A.A.PAN && (a === m.Q.documentA && s.length < 3 || a === m.Q.documentB && s.length >= 3),
              B = {
                width: u.pageSize.width * t.zoomLevel,
                height: u.pageSize.height * t.zoomLevel
              },
              L = d.useRef(null),
              V = x()({
                "PSPDFKit-Page": !0,
                [`PSPDFKit-Page-Rotation-${t.pagesRotation}-degree`]: !0,
                [i.page]: !0,
                [i["deg-" + t.pagesRotation]]: !0
              }),
              K = (0, P._x)(),
              q = (0, D.v9)(e => e.showToolbar) ? T.k3 : 0,
              H = (0, P.R9)(() => {
                l(K(new _.Wm({
                  x: t.viewportRect.width / 2 + 2,
                  y: t.viewportRect.height / 2 + q
                })));
              }),
              U = {
                inViewport: !0,
                page: u,
                backend: r,
                shouldPrerender: !0,
                zoomLevel: t.zoomLevel,
                rotation: t.pagesRotation,
                renderPageCallback: e.renderPageCallback,
                allowedTileScales: e.allowedTileScales,
                documentHandle: a,
                viewportRect: t.viewportRect,
                forceDetailView: !1,
                renderPagePreview: e.renderPagePreview,
                isPageSizeReal: !0,
                crispTiles: !0,
                inContentEditorMode: !1
              },
              Z = (0, D.v9)(e => e.scrollbarOffset),
              $ = I.map((e, n) => e ? d.createElement("div", {
                className: x()({
                  "PSPDFKit-DocumentComparison-ReferencePoint-Marker": !0,
                  [i.referencePoint]: !0
                }),
                style: {
                  left: e.x * t.zoomLevel - R.x + (M ? Z / 2 : 0),
                  top: e.y * t.zoomLevel - R.y
                },
                key: `point_${n}`
              }, d.createElement(N, {
                touchDevice: M,
                className: i.comparisonPin
              }, n + 1)) : null);
            return d.createElement(d.Fragment, null, d.createElement("div", {
              className: x()({
                [i.source]: !M,
                [i.sourceTouch]: !!M,
                "PSPDFKit-DocumentComparison-Source": !0,
                [`PSPDFKit-DocumentComparison-Source-${a}`]: !!a
              }),
              style: {
                cursor: j && !M ? `url('data:image/svg+xml,${F()}') 12 22, crosshair` : "auto"
              }
            }, j && M && d.createElement(b.m, null, d.createElement("div", {
              className: i.crosshair,
              ref: L
            }, d.createElement("div", {
              className: x()(i.selectPoint, {
                [i.hidden]: v
              }),
              onClick: H
            }, f(re.Comparison_selectPoint)), d.createElement(E.Z, {
              src: n(23874)
            }))), d.createElement(C.Z, {
              dispatch: e.dispatch,
              viewportState: t
            }, d.createElement("section", {
              className: V,
              style: B,
              "data-page-index": u ? u.pageIndex : ""
            }, d.createElement(z.Z, U), $, M ? null : d.createElement("div", {
              className: i.pointerLayer
            }, j ? d.createElement(S.Z, {
              size: u.pageSize,
              onDrawEnd: l,
              transformPoint: K,
              interactionMode: p,
              scrollElement: o
            }) : null)))), o && !M ? d.createElement(k.B, {
              viewportState: t,
              scrollElement: o,
              onScroll: O,
              className: "PSPDFKit-DocumentComparison-Magnifier",
              pageIndex: u.pageIndex,
              pageRendererComponentProps: U
            }, $) : null);
          },
          B = M ? {
            width: "100",
            height: "100",
            viewBox: "-10 0 90 100",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          } : {
            width: "66",
            height: "66",
            viewBox: "-10 0 56 66",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          N = e => {
            let {
              children: t,
              touchDevice: n,
              className: p
            } = e;
            return d.createElement("svg", (0, y.Z)({}, B, {
              className: p
            }), n ? d.createElement("g", {
              stroke: "#f5281b"
            }, r || (r = d.createElement("path", {
              d: "M44.0171 43.4142L72.3014 71.6985",
              strokeWidth: "4"
            })), o || (o = d.createElement("path", {
              d: "M12.9043 12.3015L41.1886 40.5858",
              strokeWidth: "4"
            })), i || (i = d.createElement("path", {
              d: "M72.3013 12.3015L44.017 40.5858",
              strokeWidth: "4"
            })), a || (a = d.createElement("path", {
              d: "M41.189 43.4142L12.9047 71.6985",
              strokeWidth: "4"
            })), d.createElement("text", {
              x: "-10",
              y: "82",
              fontSize: "28",
              fill: "#f5281b",
              dominantBaseline: "central"
            }, t)) : d.createElement("g", {
              stroke: "#f5281b"
            }, s || (s = d.createElement("path", {
              d: "M26.0083 25.7072L40.1505 39.8493",
              strokeWidth: "1.99616"
            })), l || (l = d.createElement("path", {
              d: "M10.4521 10.1508L24.5943 24.2929",
              strokeWidth: "1.99616"
            })), u || (u = d.createElement("path", {
              d: "M40.1509 10.1508L26.0087 24.2929",
              strokeWidth: "1.99616"
            })), c || (c = d.createElement("path", {
              d: "M24.5952 25.7072L10.453 39.8493",
              strokeWidth: "1.99616"
            })), d.createElement("text", {
              x: "0",
              y: "44",
              fontSize: "14",
              fill: "#f5281b",
              dominantBaseline: "central"
            }, t)));
          };
        var L = n(31672);
        const V = e => {
          const {
              addSource: t
            } = e,
            n = d.useCallback(e => {
              (null == e ? void 0 : e.click) && e.click();
            }, []),
            r = d.useCallback(e => {
              if (e.target.files[0]) {
                const n = new FileReader();
                n.onload = e => {
                  var n;
                  t(null === (n = e.target) || void 0 === n ? void 0 : n.result);
                }, n.readAsArrayBuffer(e.target.files[0]);
              }
            }, [t]);
          return d.createElement(L.TX, {
            tag: "div"
          }, d.createElement("input", {
            ref: n,
            "aria-label": "",
            "aria-hidden": !0,
            type: "file",
            accept: "image/png, image/jpeg, image/tiff, application/pdf",
            onChange: r,
            tabIndex: -1
          }));
        };
        var K,
          q = n(7202),
          H = n(8271),
          U = n(40084),
          Z = n(74751),
          $ = n(2058);
        function G(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function W(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? G(Object(n), !0).forEach(function (t) {
              (0, g.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : G(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Y = e => {
            const {
                styles: t,
                currentDocumentKey: n,
                referencePoints: r,
                addReferencePoint: o,
                settings: i,
                completionConfiguration: a,
                setDocumentSources: s,
                documentSources: l,
                backend: u,
                viewportState: c,
                interactionMode: h,
                dispatch: g,
                isAutoCompare: y,
                renderPagePreview: b
              } = e,
              w = (0, P.tm)(),
              [x, D] = d.useState(null),
              [C, S] = d.useState(!1),
              E = (0, P.R9)(() => {
                x && g((0, U.nr)((0, f.mr)(c, x)));
              });
            d.useEffect(() => {
              E();
            }, [x, E]);
            const [k, A] = (0, P.dX)();
            d.useEffect(() => {
              A(!1);
            }, [y, A]);
            const z = (0, P.R9)(e => {
                e && !l[e] && i[e].source !== q.b.USE_OPEN_DOCUMENT || async function () {
                  if (C) return;
                  let t;
                  e !== m.Q.result && e ? (x && D(null), t = await u.openComparisonDocument(e)) : (x && D(null), t = k ? await u.openComparisonDocument(m.Q.result) : await X(r, i, u), A(!0));
                  const n = i[m.Q.documentA].pageIndex || 0,
                    o = new H.Z(W({
                      pageSize: new _.$u(t.pages[n])
                    }, t.pages[n]));
                  w() && D(o);
                }();
              }),
              T = d.useRef(null);
            d.useEffect(() => {
              T.current !== n && x && D(null), T.current = n;
            }, [n, x]), d.useEffect(() => {
              x || C || z(n);
            }, [x, n, z, C, l]);
            const O = 6 === r.length || y;
            d.useEffect(() => {
              O && !y && z(null);
            }, [z, O, y]), d.useEffect(() => {
              !async function () {
                try {
                  await a.start.promise, w() && (0, p.unstable_batchedUpdates)(() => {
                    S(!0), D(null);
                  });
                } catch (e) {
                  a.start.reject(e);
                }
              }();
            }, [a, w]), d.useEffect(() => {
              C && async function () {
                try {
                  await u.cleanupDocumentComparison(), a.end.resolve();
                } catch (e) {
                  a.end.reject(e);
                }
              }();
            }, [C, u, a]);
            const I = d.useCallback(async e => {
              e && (await u.setComparisonDocument(n, e), w() && s(W(W({}, l), {}, {
                [n]: e
              })));
            }, [n, l, s, u, w]);
            return x ? d.createElement(j, {
              backend: e.backend,
              renderPageCallback: e.renderPageCallback,
              allowedTileScales: e.allowedTileScales,
              viewportState: c,
              scrollElement: e.scrollElement,
              styles: t,
              dispatch: e.dispatch,
              viewportWidth: e.viewportWidth,
              currentDocumentKey: n,
              addReferencePoint: o,
              referencePoints: r,
              page: x,
              isAutoCompare: y,
              interactionMode: h,
              renderPagePreview: b
            }) : O || l[n] || i[n].source !== q.b.USE_FILE_DIALOG ? d.createElement("div", {
              className: t.documentComparisonPageLoading
            }, K || (K = d.createElement(v.Z, {
              scale: 2
            }))) : d.createElement(V, {
              addSource: I
            });
          },
          X = async (e, t, n) => {
            var r, o, i, a, s, l;
            let u;
            u = e && e.length ? [[[e[3].x, e[3].y], [e[0].x, e[0].y]], [[e[4].x, e[4].y], [e[1].x, e[1].y]], [[e[5].x, e[5].y], [e[2].x, e[2].y]]] : f.h6;
            return await n.documentCompareAndOpen({
              documentA: {
                pageIndex: t.documentA.pageIndex || 0,
                strokeColor: null !== (r = t.strokeColors) && void 0 !== r && r.documentA ? (0, Z.C)(null === (o = t.strokeColors) || void 0 === o ? void 0 : o.documentA) : (0, Z.C)(null === (i = $.se.strokeColors) || void 0 === i ? void 0 : i.documentA)
              },
              documentB: {
                pageIndex: t.documentB.pageIndex || 0,
                strokeColor: null !== (a = t.strokeColors) && void 0 !== a && a.documentB ? (0, Z.C)(null === (s = t.strokeColors) || void 0 === s ? void 0 : s.documentB) : (0, Z.C)(null === (l = $.se.strokeColors) || void 0 === l ? void 0 : l.documentB)
              },
              options: {
                type: "path",
                points: u,
                blendMode: t.blendMode || "darken"
              }
            });
          },
          Q = e => {
            const {
                onHide: t,
                styles: r
              } = e,
              {
                formatMessage: o
              } = (0, h.YB)();
            return d.createElement("div", {
              className: r.container
            }, d.createElement("div", {
              className: r.wrapper
            }, d.createElement(E.Z, {
              src: n(33413),
              className: r.icon,
              style: {
                color: "#5E5CEB"
              }
            }), d.createElement("div", {
              className: r.header
            }, o(J.UserHint_title)), d.createElement("div", {
              className: r.hint
            }, o(J.UserHint_description)), d.createElement("div", {
              className: r.hideButton
            }, d.createElement(L.zx, {
              onClick: t
            }, o(J.UserHint_dismissMessage)))));
          },
          J = (0, h.vU)({
            UserHint_title: {
              id: "UserHint_Select",
              defaultMessage: "Selecting Points",
              description: "User hint Title. User should select points to compare documents."
            },
            UserHint_description: {
              id: "UserHint_description",
              defaultMessage: "Select 3 points on both documents for manual alignment. For best results, choose  points near corners of the document, and make sure to choose the points in the same  order on both documents.",
              description: "Main body of the user hint. Explains what to do to compare documents"
            },
            UserHint_dismissMessage: {
              id: "UserHint_dismissMessage",
              defaultMessage: "Dismiss Message",
              description: "Dismiss user hint message"
            }
          }),
          ee = (0, O.b1)(),
          te = e => e.length < 3 ? m.Q.documentA : e.length < 6 ? m.Q.documentB : m.Q.result,
          ne = e => {
            const {
                interactionMode: t,
                initialDocumentSources: n,
                settings: r,
                backend: o
              } = e,
              {
                styles: i
              } = e.CSS_HACK,
              a = (0, P.tm)(),
              [s, l] = (0, P.nG)(),
              [u, c] = (0, P.jw)(),
              [h] = (0, P.$)(),
              [g, v] = d.useState(!0),
              y = (0, f.SH)(u),
              b = (0, P.R9)(e => {
                e !== y && c(e || m.Q.result);
              }),
              w = d.useCallback(e => {
                const t = [...s, e];
                (0, p.unstable_batchedUpdates)(() => {
                  l(t), b(te(t));
                });
              }, [s, b, l]),
              [x, D] = d.useState(null);
            return d.useEffect(() => {
              !async function () {
                const [e, t] = await Promise.all([n[m.Q.documentA], n[m.Q.documentB]]);
                (e && e.byteLength > 0 || r[m.Q.documentA].source === q.b.USE_OPEN_DOCUMENT) && (await o.setComparisonDocument(m.Q.documentA, e)), (t && t.byteLength > 0 || r[m.Q.documentB].source === q.b.USE_OPEN_DOCUMENT) && (await o.setComparisonDocument(m.Q.documentB, t)), a() && D({
                  [m.Q.documentA]: e,
                  [m.Q.documentB]: t,
                  [m.Q.result]: {
                    source: null
                  }
                });
              }();
            }, [n, o, r, a]), d.createElement("div", {
              className: i.docComparison
            }, x ? d.createElement(Y, {
              backend: o,
              renderPageCallback: e.renderPageCallback,
              allowedTileScales: e.allowedTileScales,
              viewportState: e.viewportState,
              interactionMode: t,
              scrollElement: e.scrollElement,
              styles: i,
              dispatch: e.dispatch,
              settings: r,
              completionConfiguration: e.completionConfiguration,
              documentSources: x,
              setDocumentSources: D,
              viewportWidth: e.viewportWidth,
              currentDocumentKey: y,
              addReferencePoint: w,
              referencePoints: s,
              isAutoCompare: h,
              renderPagePreview: e.renderPagePreview
            }) : null, !ee && !(6 === s.length) && !h && g && d.createElement(Q, {
              styles: i.userHintStyles,
              onHide: () => v(!1)
            }));
          },
          re = (0, h.vU)({
            Comparison_documentOld: {
              id: "Comparison_documentOld",
              defaultMessage: "Old Document",
              description: "One of the documents to be compared."
            },
            Comparison_documentOldTouch: {
              id: "Comparison_documentOldTouch",
              defaultMessage: "Old",
              description: "The original document used in the comparison."
            },
            Comparison_documentNew: {
              id: "Comparison_documentNew",
              defaultMessage: "New Document",
              description: "The new document used in the comparison."
            },
            Comparison_documentNewTouch: {
              id: "Comparison_documentNewTouch",
              defaultMessage: "New",
              description: "The new document used in the comparison."
            },
            Comparison_result: {
              id: "Comparison_result",
              defaultMessage: "Comparison",
              description: "The compared document."
            },
            Comparison_resetButton: {
              id: "Comparison_resetButton",
              defaultMessage: "Reset",
              description: "Reset all placed alignment points."
            },
            Comparison_alignButton: {
              id: "Comparison_alignButton",
              defaultMessage: "Align Documents",
              description: "Start the manual document alignment process."
            },
            Comparison_alignButtonTouch: {
              id: "Comparison_alignButtonTouch",
              defaultMessage: "Align",
              description: "Start the manual document alignment process."
            },
            Comparison_selectPoint: {
              id: "Comparison_selectPoint",
              defaultMessage: "Select Point",
              description: "Select alignment point."
            }
          });
      },
      2058: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => D,
          se: () => y
        });
        var r = n(96156),
          o = n(67294),
          i = n(29911),
          a = n(60379),
          s = n(7202),
          l = n(52163),
          u = n(79112),
          c = n(80389),
          d = n.n(c),
          p = n(5871),
          h = n.n(p);
        function f(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function m(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? f(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const g = {
            styles: m(m({}, d()), {}, {
              userHintStyles: h()
            })
          },
          v = o.lazy(() => Promise.resolve().then(n.bind(n, 3962))),
          y = {
            documentA: {
              source: s.b.USE_OPEN_DOCUMENT,
              pageIndex: 0
            },
            documentB: {
              source: s.b.USE_FILE_DIALOG,
              pageIndex: 0
            },
            strokeColors: {
              documentA: new a.Z({
                r: 245,
                g: 40,
                b: 27
              }),
              documentB: new a.Z({
                r: 49,
                g: 193,
                b: 255
              })
            },
            blendMode: "darken",
            autoCompare: !1
          },
          b = o.createElement("div", {
            className: d().documentComparisonPageLoading,
            "data-testid": "documentComparisonFallback"
          }, o.createElement(i.Z, {
            scale: 2
          })),
          w = (e, t) => ({
            documentA: m(m({}, y.documentA), {}, {
              pageIndex: (null == e ? void 0 : e.documentA.source) === s.b.USE_OPEN_DOCUMENT ? t : 0
            }, null == e ? void 0 : e.documentA),
            documentB: m(m({}, y.documentB), {}, {
              pageIndex: (null == e ? void 0 : e.documentB.source) === s.b.USE_OPEN_DOCUMENT ? t : 0
            }, null == e ? void 0 : e.documentB),
            strokeColors: m(m({}, y.strokeColors), null == e ? void 0 : e.strokeColors),
            blendMode: (null == e ? void 0 : e.blendMode) || y.blendMode,
            autoCompare: e.autoCompare
          }),
          x = e => e !== s.b.USE_OPEN_DOCUMENT && e !== s.b.USE_FILE_DIALOG ? (0, l.rh)(e) : null,
          D = e => {
            const {
                backend: t,
                viewportState: n,
                interactionMode: r = null,
                configuration: i
              } = e,
              a = o.useMemo(() => w(i, n.currentPageIndex), [i, n.currentPageIndex]);
            o.useEffect(() => {
              let e;
              a[u.Q.documentA].source === s.b.USE_OPEN_DOCUMENT ? e = u.Q.documentA : a[u.Q.documentB].source === s.b.USE_OPEN_DOCUMENT && (e = u.Q.documentB), t.persistOpenDocument(e);
            }, [t, a]);
            const l = o.useRef({
              [u.Q.documentA]: x(a.documentA.source),
              [u.Q.documentB]: x(a.documentB.source)
            });
            return o.createElement(o.Suspense, {
              fallback: b
            }, o.createElement(v, {
              backend: e.backend,
              interactionMode: r,
              renderPageCallback: e.renderPageCallback,
              allowedTileScales: e.allowedTileScales,
              viewportState: n,
              scrollElement: e.scrollElement,
              CSS_HACK: g,
              viewportWidth: e.viewportWidth,
              dispatch: e.dispatch,
              settings: a,
              completionConfiguration: i.completion,
              initialDocumentSources: l.current,
              renderPagePreview: e.renderPagePreview
            }));
          };
      },
      46945: (e, t, n) => {
        "use strict";

        n.d(t, {
          n: () => l
        });
        var r = n(22122),
          o = n(67294),
          i = n(31672),
          a = n(50439),
          s = n.n(a);
        function l(e) {
          return o.createElement(i.bK, (0, r.Z)({}, e, {
            styles: {
              label: s().label,
              input: s().input
            }
          }));
        }
      },
      62477: (e, t, n) => {
        "use strict";

        n.d(t, {
          U: () => l
        });
        var r = n(67294),
          o = n(31672),
          i = n(53261),
          a = n(86378),
          s = n.n(a);
        function l(e) {
          let {
            title: t,
            children: a
          } = e;
          const [l, u] = r.useState(!1),
            c = (0, r.useCallback)(() => u(e => !e), []);
          return r.createElement(r.Fragment, null, r.createElement(o.w6, {
            expanded: l,
            onPress: c,
            className: s().wrapper
          }, r.createElement("div", {
            className: s().controlContent
          }, r.createElement(i.Z, {
            src: n(35982)(`./caret-${l ? "down" : "right"}.svg`),
            className: s().icon
          }), r.createElement("span", null, t))), r.createElement(o.F0, {
            expanded: l
          }, r.createElement("div", {
            className: s().content
          }, a)));
        }
      },
      62102: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => I,
          ck: () => T,
          zx: () => z
        });
        var r = n(96156),
          o = n(22122),
          i = n(67294),
          a = n(35782),
          s = n(94184),
          l = n.n(s),
          u = n(83882),
          c = n(67366),
          d = n(17766),
          p = n(62477),
          h = n(53261),
          f = n(35012),
          m = n(54707),
          g = n(46945),
          v = n(22690),
          y = n(3888),
          b = n(71623),
          w = n(33427),
          x = n(30549),
          D = n.n(x),
          C = n(44170),
          S = n.n(C),
          E = n(84691),
          _ = n.n(E);
        function P(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function k(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? P(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function A(e) {
          return O[e] || d.Z[e];
        }
        const z = (e, t, n) => r => {
            let {
              btnComponentProps: a,
              selectedItem: s
            } = r;
            return i.createElement(u.Z, (0, o.Z)({
              is: "div"
            }, a, {
              className: l()("PSPDFKit-Input-Dropdown-Button", _().selectBox, D().selectBox, {
                [_().measurementDropdownText]: "measurement" === t
              }),
              style: {
                minWidth: "measurement" === t ? "60px" : "100px",
                columnGap: "measurement" === t ? "8px" : "",
                width: n ? `${n}px` : ""
              }
            }), i.createElement("span", null, null != s && s.label ? A(s.label) ? e(A(s.label)) : s.label : null), i.createElement("div", null, (0, b.Z)({
              type: "caret-down",
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: l()(_().dropdownIcon)
            })));
          },
          T = (e, t) => n => {
            let {
              item: r,
              state: a,
              itemComponentProps: s,
              ref: c
            } = n;
            return i.createElement(u.Z, (0, o.Z)({
              is: "div",
              className: l()(_().item, {
                [_().isSelected]: (null == a ? void 0 : a.includes("selected")) || (null == a ? void 0 : a.includes("focused")),
                [_().measurementDropdownText]: "measurement" === t
              }),
              name: null == r ? void 0 : r.value
            }, s, {
              ref: c
            }), i.createElement("span", null, null != r && r.label ? A(r.label) ? e(A(r.label)) : r.label : null));
          };
        const O = (0, a.vU)({
            borderColor: {
              id: "borderColor",
              defaultMessage: "Border Color",
              description: "Form designer popover style section border color label"
            },
            borderWidth: {
              id: "borderWidth",
              defaultMessage: "Border Width",
              description: "Form designer popover style section border width label"
            },
            borderStyle: {
              id: "borderStyle",
              defaultMessage: "Border Style",
              description: "Form designer popover style section border style label"
            },
            print: {
              id: "print",
              defaultMessage: "Print",
              description: "Form designer popover style section print label"
            },
            solid: {
              id: "solid",
              defaultMessage: "Solid",
              description: "Form designer popover style section solid border label"
            },
            dashed: {
              id: "dashed",
              defaultMessage: "Dashed",
              description: "Form designer popover style section dashed border label"
            },
            beveled: {
              id: "beveled",
              defaultMessage: "Beveled",
              description: "Form designer popover style section beveled border label"
            },
            inset: {
              id: "inset",
              defaultMessage: "Inset",
              description: "Form designer popover style section inset border label"
            },
            underline: {
              id: "underline",
              defaultMessage: "Underline",
              description: "Form designer popover style section unredline border label"
            }
          }),
          I = function (e) {
            var t;
            let {
              annotation: r,
              updateAnnotation: o,
              intl: a,
              frameWindow: s,
              label: l,
              pageSize: u
            } = e;
            const b = (0, c.v9)(e => e.shadowRoot),
              x = i.useCallback(e => a.formatMessage(d.Z.numberInPt, {
                arg0: e.toFixed(0)
              }), [a]),
              C = i.useCallback(e => `${Math.round(e)}%`, []),
              E = i.useCallback(e => o({
                borderWidth: e
              }), [o]),
              _ = i.useCallback(e => {
                if (!u) return;
                const t = Number(e);
                if (90 !== Math.abs(t - r.rotation) && 270 !== Math.abs(t - r.rotation)) o({
                  rotation: t
                });else {
                  const e = (0, w.eJ)(r, u),
                    n = e.set("rotation", t);
                  o({
                    rotation: n.rotation,
                    boundingBox: e.boundingBox
                  });
                }
              }, [u, o, r]),
              P = i.useMemo(() => [{
                label: "none",
                value: "none"
              }, ...Object.keys(y.N).map(e => ({
                label: e,
                value: e
              }))], []),
              I = null !== (t = P.find(e => {
                var t;
                return (null !== (t = r.borderStyle) && void 0 !== t ? t : "none") === e.value;
              })) && void 0 !== t ? t : null,
              F = [{
                label: "0°",
                value: "0"
              }, {
                label: "90°",
                value: "90"
              }, {
                label: "180°",
                value: "180"
              }, {
                label: "270°",
                value: "270"
              }];
            let M = r.rotation ? F.find(e => {
              let {
                value: t
              } = e;
              return Number(t) === r.rotation;
            }) : F[0];
            void 0 === M && (M = F[0]);
            const R = i.useCallback(z(a.formatMessage), [a.formatMessage]),
              j = i.useCallback(T(a.formatMessage), [a.formatMessage]);
            return i.createElement(p.U, {
              title: l
            }, i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(92742),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(d.Z.fillColor)), i.createElement(f.Z, {
              record: r,
              onChange: o,
              styles: k(k({}, S()), {}, {
                colorSvg: D().colorSvg,
                colorItem: D().colorItem,
                controlWrapper: k(k({}, S().controlWrapper), {}, {
                  width: "auto"
                })
              }),
              accessibilityLabel: a.formatMessage(d.Z.fillColor),
              caretDirection: "down",
              colorProperty: "backgroundColor",
              frameWindow: s,
              className: D().colorDropdown
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(25615),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(O.borderColor)), i.createElement(f.Z, {
              record: r,
              onChange: o,
              styles: k(k({}, S()), {}, {
                colorSvg: D().colorSvg,
                colorItem: D().colorItem,
                controlWrapper: k(k({}, S().controlWrapper), {}, {
                  width: "auto"
                })
              }),
              accessibilityLabel: a.formatMessage(O.borderColor),
              caretDirection: "down",
              colorProperty: "borderColor",
              frameWindow: s,
              className: D().colorDropdown
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(20113),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(O.borderStyle)), i.createElement("div", {
              className: D().nativeDropdown
            }, i.createElement("select", {
              "aria-label": a.formatMessage(O.borderStyle),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: r.borderStyle || "",
              onChange: e => {
                e.target.value !== P[0].value ? void 0 !== e.target.value && o({
                  borderStyle: e.target.value
                }) : o({
                  borderStyle: null
                });
              }
            }, P.map(e => i.createElement("option", {
              key: e.value,
              value: e.value,
              disabled: e.disabled
            }, e.label ? a.formatMessage(A(e.label)) : "")))), i.createElement(v.Z, {
              items: P,
              value: I,
              accessibilityLabel: a.formatMessage(O.borderStyle),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: D().dropdownGroupComponent,
              menuClassName: D().dropdownGroupMenu,
              ButtonComponent: R,
              ItemComponent: j,
              onSelect: (e, t) => {
                t.value !== P[0].value ? void 0 !== t.value && o({
                  borderStyle: t.value
                }) : o({
                  borderStyle: null
                });
              },
              frameWindow: s
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(41869),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(O.borderWidth)), i.createElement(m.Z, {
              onChange: E,
              value: r.borderWidth || 0,
              name: "borderWidth",
              caretDirection: "down",
              min: 0,
              max: 40,
              valueLabel: x,
              className: D().sliderDropdown,
              accessibilityLabel: a.formatMessage(O.borderWidth),
              shadowRoot: b
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(22636),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(d.Z.opacity)), i.createElement(m.Z, {
              onChange: e => o({
                opacity: e / 100
              }),
              value: 100 * r.opacity,
              name: "opacity",
              caretDirection: "down",
              valueLabel: C,
              className: D().sliderDropdown,
              accessibilityLabel: a.formatMessage(d.Z.opacity),
              shadowRoot: b
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(3315),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(d.Z.rotation)), i.createElement("div", {
              className: D().nativeDropdown
            }, i.createElement("select", {
              "aria-label": a.formatMessage(d.Z.rotation),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: r.rotation || 0,
              onChange: e => {
                e.target.value && _(e.target.value);
              }
            }, F.map(e => i.createElement("option", {
              key: e.value,
              value: e.value,
              disabled: e.disabled
            }, e.label)))), i.createElement(v.Z, {
              items: F,
              value: M,
              accessibilityLabel: a.formatMessage(d.Z.rotation),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: D().dropdownGroupComponent,
              menuClassName: D().dropdownGroupMenu,
              ButtonComponent: R,
              ItemComponent: j,
              onSelect: (e, t) => {
                t.value && _(t.value);
              },
              frameWindow: s
            })), i.createElement("div", {
              className: D().item
            }, i.createElement(h.Z, {
              src: n(738),
              className: D().itemIcon,
              role: "presentation"
            }), i.createElement("div", {
              className: D().itemLabel
            }, a.formatMessage(O.print)), i.createElement(g.n, {
              value: !r.noPrint,
              onUpdate: e => o({
                noPrint: !e
              }),
              accessibilityLabel: a.formatMessage(O.print)
            })));
          };
      },
      46455: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => h,
          Z: () => f
        });
        var r = n(67294),
          o = n(35369),
          i = n(19181),
          a = n(54537),
          s = n(44077),
          l = n(92537),
          u = n(33427),
          c = n(43069),
          d = n(15743),
          p = n.n(d);
        function h(e, t, n, r) {
          const {
              width: o,
              height: i
            } = e,
            a = Math.min(n / o, n / i),
            s = Math.min(r / o, r / i),
            u = Math.ceil(o * s * (0, l.L)()),
            c = Math.ceil(i * s * (0, l.L)()),
            d = Math.floor(o * a),
            p = Math.floor(i * a);
          let h = d,
            f = p;
          90 !== t && 270 !== t || (h = p, f = d);
          let m = 0,
            g = 0;
          return 90 === t ? m = h : 180 === t ? (m = h, g = f) : 270 === t && (g = f), {
            ratio: a,
            tileRatio: s,
            tileWidth: u,
            tileHeight: c,
            containerWidth: d,
            containerHeight: p,
            rotatedWidth: h,
            rotatedHeight: f,
            translationX: m,
            translationY: g
          };
        }
        const f = (0, i.x)(function (e, t) {
          const {
              page: n
            } = t,
            {
              backend: r,
              annotations: i,
              attachments: a,
              formFields: s,
              showAnnotations: l,
              renderPageCallback: d
            } = e,
            p = l ? (0, u.xp)(i, n) : void 0,
            h = l ? (0, c.ET)(s, n) : void 0,
            f = l && h ? (0, c.Qg)(h.reduce((e, t) => e.set(t.name, t), (0, o.D5)())) : void 0;
          return {
            annotations: p,
            formFields: h,
            formFieldValues: f,
            attachments: l ? a : void 0,
            backend: r,
            renderPageCallback: d,
            digitalSignatures: e.digitalSignatures
          };
        })(function (e) {
          const {
              page: {
                pageSize: t,
                pageIndex: n,
                pageKey: o
              },
              size: i,
              maxSize: u,
              backend: c,
              annotations: d,
              attachments: f,
              formFields: m,
              formFieldValues: g,
              renderPageCallback: v,
              digitalSignatures: y,
              pageRef: b
            } = e,
            w = e.rotation || 0,
            {
              ratio: x,
              tileRatio: D,
              tileWidth: C,
              tileHeight: S,
              rotatedWidth: E,
              rotatedHeight: _,
              translationX: P,
              translationY: k
            } = h(t, w, i, u),
            A = r.useMemo(function () {
              return new s.$u({
                width: C,
                height: S
              });
            }, [S, C]),
            z = r.useMemo(function () {
              return new s.UL({
                width: C,
                height: S
              });
            }, [S, C]),
            T = {
              width: E,
              height: _,
              transform: `\n      translateX(${P}px)\n      translateY(${k}px)\n      rotate(${w}deg)\n      scale(${x / D / (0, l.L)()})\n    `,
              transformOrigin: "top left"
            };
          return r.createElement("div", {
            style: T,
            ref: b
          }, r.createElement("div", {
            className: p().tilePlaceholder,
            style: {
              width: C,
              height: S
            }
          }), r.createElement(a.Z, {
            backend: c,
            pageIndex: n,
            originalPageSize: t,
            scaledPageSize: A,
            rect: z,
            annotations: d,
            attachments: f,
            formFields: m,
            formFieldValues: g,
            renderPageCallback: v,
            digitalSignatures: y,
            pageKey: o
          }));
        });
      },
      67057: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => d
        });
        var r = n(22122),
          o = n(96156),
          i = n(67294),
          a = n(73935),
          s = n(40163),
          l = n(45249),
          u = n(45639),
          c = n.n(u);
        class d extends i.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", s.O), (0, o.Z)(this, "_lastOrientationChange", 0), (0, o.Z)(this, "_handleResize", () => {
              const e = this._element && this._element.getBoundingClientRect();
              if (!e) return;
              const t = Date.now() - this._lastOrientationChange < 1e3;
              (0, a.unstable_batchedUpdates)(() => {
                this.props.onResize(l.UL.fromClientRect(e), t);
              });
            }), (0, o.Z)(this, "_handleOrientationChange", () => {
              this._lastOrientationChange = Date.now();
            }), (0, o.Z)(this, "_handleRef", e => {
              var t, n, r;
              this._element = e, null === (t = (n = this.props).onRefUpdate) || void 0 === t || t.call(n, (null == e || null === (r = e.contentDocument) || void 0 === r ? void 0 : r.defaultView) || null);
            });
          }
          componentDidMount() {
            const e = this._getIFrameWindow();
            null == e || e.addEventListener("resize", this._handleResize), null == e || e.addEventListener("orientationchange", this._handleOrientationChange), this._handleResize();
          }
          componentWillUnmount() {
            const e = this._getIFrameWindow();
            null == e || e.removeEventListener("resize", this._handleResize), null == e || e.removeEventListener("orientationchange", this._handleOrientationChange);
          }
          _getIFrameWindow() {
            var e;
            return null === (e = this._element) || void 0 === e ? void 0 : e.contentWindow;
          }
          render() {
            return i.createElement("iframe", (0, r.Z)({
              ref: this._handleRef,
              className: c().root
            }, {
              inert: ""
            }, {
              "aria-hidden": !0,
              tabIndex: "-1"
            }));
          }
        }
      },
      71623: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => c
        });
        var r = n(67294),
          o = n(94184),
          i = n.n(o),
          a = n(53261),
          s = n(37253),
          l = n.n(s),
          u = n(89004);
        function c(e) {
          const {
              icon: t,
              type: o,
              style: s = null
            } = e,
            c = i()(l().root, e.className, "PSPDFKit-Icon", "PSPDFKit-Icon-" + (0, u.in)(o));
          if (t) return /<svg/i.test(t) ? r.createElement(a.Z, {
            src: t,
            className: c,
            role: "presentation",
            style: s || void 0
          }) : r.createElement("img", {
            src: t,
            role: "presentation",
            className: c,
            style: s || void 0
          });
          if ("custom" === o) return null;
          let d;
          try {
            d = n(89457)(`./${o}.svg`);
          } catch (e) {}
          return d ? r.createElement(a.Z, {
            src: d,
            className: c,
            "aria-hidden": "true",
            style: s || void 0
          }) : null;
        }
      },
      35012: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => p
        });
        var r = n(96156),
          o = n(67294),
          i = n(45249),
          a = n(87996),
          s = n(94732),
          l = n(33427),
          u = n(22939),
          c = n(17766);
        const d = [i.Xs, i.gd, i.Zc, s.Z, i.FV, i.o9, i.om, i.Hi, i.b3, i.x_];
        class p extends o.PureComponent {
          static getDerivedStateFromProps(e) {
            if (e.annotationToolbarColorPresets) {
              const t = e.annotationToolbarColorPresets({
                propertyName: (() => {
                  for (const [t, n] of l.fc.entries()) if (n === e.colorProperty) return t;
                })(),
                defaultAnnotationToolbarColorPresets: a.Options.COLOR_PRESETS
              });
              if (void 0 !== t) return !1 === t.showColorPicker ? {
                hasColorPicker: t.showColorPicker,
                colors: t.presets,
                isUsingCustomConfig: !0
              } : {
                colors: t.presets,
                hasColorPicker: !0,
                isUsingCustomConfig: !0
              };
            }
            return e.colors ? {
              colors: e.colors
            } : {
              colors: a.Options.COLOR_PRESETS
            };
          }
          constructor(e) {
            super(e), (0, r.Z)(this, "state", {
              colors: a.Options.COLOR_PRESETS,
              colorPresets: (0, l.sH)(this.props.colorProperty),
              creatingColor: void 0,
              hasColorPicker: !0,
              isDeleteButtonVisible: void 0,
              isUsingCustomConfig: !1
            }), (0, r.Z)(this, "defaultBorderColor", "#404040"), (0, r.Z)(this, "_autoFocused", !1), (0, r.Z)(this, "_onChange", e => {
              this.props.onChange({
                [this.props.colorProperty]: e ? e.color : null
              });
            }), (0, r.Z)(this, "showCustomPickerForAnnotation", e => d.some(t => e instanceof t)), (0, r.Z)(this, "_setStoredColors", e => localStorage.setItem(`persistedColors${this.props.colorProperty}`, JSON.stringify(e)));
          }
          render() {
            var e;
            const {
                record: t
              } = this.props,
              n = this.state.hasColorPicker && (!(t instanceof i.q6) || this.showCustomPickerForAnnotation(t)),
              r = this.props.record[this.props.colorProperty],
              a = null !== (e = this.state.colors.find(e => !(null != e.color && !e.color.transparent || null != r) || null != e.color && null != r && e.color.equals(r))) && void 0 !== e ? e : {
                color: r,
                localization: c.Z.color
              };
            return o.createElement(u.Z, {
              colors: this.state.colors,
              value: a,
              customColorPresets: this.state.colorPresets,
              setCustomColorPresets: e => e ? this.setState({
                colorPresets: e
              }) : null,
              onChange: this._onChange,
              className: this.props.className,
              caretDirection: this.props.caretDirection,
              removeTransparent: this.props.removeTransparent,
              opacity: this.props.record.opacity,
              accessibilityLabel: this.props.accessibilityLabel,
              keepOpacity: this.props.keepOpacity,
              frameWindow: this.props.frameWindow,
              innerRef: this.props.innerRef,
              lastToolbarActionUsedKeyboard: this.props.lastToolbarActionUsedKeyboard,
              styles: this.props.styles,
              setStoredColors: this._setStoredColors,
              shouldShowCustomColorPicker: n,
              unavailableItemFallback: {
                type: "swatch"
              },
              isUsingCustomConfig: this.state.isUsingCustomConfig
            });
          }
        }
        (0, r.Z)(p, "defaultProps", {
          className: "",
          removeTransparent: !1,
          lastToolbarActionUsedKeyboard: !1
        });
      },
      22939: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => Y
        });
        var r = n(22122),
          o = n(83882),
          i = n(67294),
          a = n(77017),
          s = n(15359),
          l = n(31672),
          u = n(94184),
          c = n.n(u),
          d = n(35782),
          p = n(43165),
          h = n.n(p),
          f = n(87996),
          m = n(45249),
          g = n(44380),
          v = n.n(g),
          y = n(84691),
          b = n.n(y),
          w = n(17722),
          x = n.n(w),
          D = n(94683),
          C = n.n(D),
          S = n(17766),
          E = n(22690),
          _ = n(50331),
          P = n.n(_),
          k = n(98179),
          A = n(21853),
          z = n(71623),
          T = n(53261),
          O = n(775),
          I = n(74076),
          F = n.n(I);
        const M = i.memo(function (e) {
          const {
              onCreateNewColor: t,
              onChange: n,
              disabled: r,
              isChoosingColor: o
            } = e,
            [a, s] = i.useState("#000000"),
            l = {
              opacity: r ? "40%" : "100%",
              backgroundImage: o ? "none" : F().nativeColorInput.backgroundImage,
              backgroundColor: o ? a : null,
              border: o ? "1px solid var(--PSPDFKit-ColorDropdownPickerComponent-item-circle-border-stroke)" : "none",
              width: o ? "18px" : "22px",
              height: o ? "18px" : "22px"
            };
          return i.createElement("label", {
            htmlFor: "input-color"
          }, i.createElement("div", {
            className: F().nativeColorInputWrapper
          }, i.createElement(O.DebounceInput, {
            className: c()(F().nativeColorInput, "PSPDFKit-Custom-Color-Input"),
            style: l,
            type: "color",
            id: "input-color",
            debounceTimeout: 200,
            value: a,
            onChange: e => {
              const t = e.target.value;
              t && (s(t), n(m.Il.fromHex(t)));
            },
            onBlur: e => {
              const n = e.target.value;
              n && t(m.Il.fromHex(n));
            },
            disabled: r
          })));
        });
        var R, j, B, N, L;
        const V = e => {
            var t, n;
            const r = null !== (t = e.colors) && void 0 !== t ? t : f.Options.COLOR_PRESETS,
              {
                formatMessage: o
              } = (0, d.YB)(),
              {
                removeTransparent: s = !1,
                customColorPresets: l = [],
                setCustomColorPresets: u,
                setStoredColors: p,
                lastToolbarActionUsedKeyboard: h = !1,
                opacity: g = 1,
                innerRef: v,
                value: y,
                caretDirection: b,
                keepOpacity: w,
                frameWindow: x,
                accessibilityLabel: D,
                onChange: C,
                unavailableItemFallback: S = {
                  type: "label"
                },
                disabled: _ = !1,
                styles: P,
                shouldShowCustomColorPicker: A = !1,
                isUsingCustomConfig: z = !1,
                menuClassName: T
              } = e,
              [O, I] = i.useState(),
              [F, R] = i.useState(),
              j = i.useRef(!1),
              B = i.useCallback(e => {
                const t = [...r, ...l].find(t => {
                    var n, r, o, i;
                    return null !== (n = null != t.color && null != (null == e || null === (r = e.value) || void 0 === r ? void 0 : r.color) && (null === (o = e.value.color) || void 0 === o ? void 0 : o.equals(t.color))) && void 0 !== n ? n : null == (null == e || null === (i = e.value) || void 0 === i ? void 0 : i.color) && null == t.color;
                  }),
                  n = [...r, ...l].find(e => t ? H(e) === H(t) : null);
                C(null != n ? n : null);
              }, [r, l, C]),
              N = i.useCallback(e => {
                var t;
                const n = {
                    color: e,
                    localization: {
                      id: `custom-${(0, a.v4)()}`,
                      defaultMessage: "Custom",
                      description: "Custom color"
                    }
                  },
                  r = [...l, n];
                null == p || p(r), u && (u(r), I(void 0)), null != y && null !== (t = y.color) && void 0 !== t && t.equals(e) || C(n);
              }, [l, u, p, C, y]),
              L = i.useCallback(e => {
                var t;
                const n = l.filter(t => t.localization.id !== e.localization.id);
                null == p || p(n), u && (u(n), I(void 0)), e.color && null != y && null !== (t = y.color) && void 0 !== t && t.equals(e.color) && C(r[0]);
              }, [l, C, u, p, r, y]),
              V = i.useCallback(e => {
                I(e);
                const t = {
                  color: e,
                  localization: {
                    id: `custom-${(0, a.v4)()}`,
                    defaultMessage: "Custom",
                    description: "Custom color"
                  }
                };
                C(t);
              }, [C]),
              q = [...r, ...l].filter(e => !(s && (null === e.color || e.color.transparent))).map(e => ({
                label: e.localization.id,
                value: e,
                disabled: !1
              })),
              U = G({
                caretDirection: b,
                colors: r,
                customColorPresets: l,
                colorItems: q,
                disabled: _,
                innerRef: v,
                keepOpacity: w,
                lastToolbarActionUsedKeyboard: h,
                opacity: g,
                unavailableItemFallback: S,
                styles: P,
                value: y,
                formatMessage: o,
                autoFocused: j
              }),
              Z = W({
                colors: r,
                customColorPresets: l,
                isDeleteButtonVisible: F,
                setIsDeleteButtonVisible: R,
                formatMessage: o,
                handleChange: B,
                handleDeleteColor: L,
                keepOpacity: w,
                opacity: g,
                styles: P
              });
            return i.createElement("div", {
              className: P.controlWrapper
            }, i.createElement("div", {
              className: P.control
            }, i.createElement(E.Z, {
              items: q,
              value: null != y && null !== (n = q.find(e => H(e.value) === H(y))) && void 0 !== n ? n : null,
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: b,
              className: `${e.className} ${P.colorSelect}`,
              menuClassName: c()(P.dropdownMenu, P.colorPickerDropdownMenu, T),
              ButtonComponent: U,
              ItemComponent: Z,
              onSelect: (0, k.b1)() ? void 0 : (e, t) => {
                B(t);
              },
              frameWindow: x,
              accessibilityLabel: D,
              maxCols: 6,
              itemWidth: 30,
              appendAfter: A ? {
                node: K,
                index: z ? r.length - 1 : r.length - (s ? 2 : 1)
              } : null
            }, A && i.createElement(M, {
              onCreateNewColor: N,
              onChange: V,
              disabled: l.length >= 17,
              isChoosingColor: O instanceof m.Il
            }))));
          },
          K = () => {
            const {
              formatMessage: e
            } = (0, d.YB)();
            return i.createElement("label", {
              style: {
                width: "100%",
                paddingTop: "10px",
                paddingBottom: "10px",
                paddingLeft: "5px"
              }
            }, e(S.Z.custom));
          };
        function q(e) {
          let {
            onClick: t
          } = e;
          return i.createElement(o.Z, {
            onClick: t,
            is: "button",
            className: c()(`PSPDFKit-AnnotationToolbar-Custom-Color-Delete-Button ${v().colorDeleteButton}`)
          }, R || (R = i.createElement(T.Z, {
            src: P(),
            "aria-hidden": "true"
          })));
        }
        function H(e) {
          return null != e ? null != e.color ? e.color.toCSSValue() : "none" : "N/A";
        }
        function U(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
          return {
            stroke: "var(--PSPDFKit-ColorDropdownPickerComponent-item-circle-border-stroke)",
            fill: e ? e.toCSSValue() : "none",
            strokeWidth: 1,
            fillOpacity: t ? n : 1
          };
        }
        const Z = () => i.createElement(i.Fragment, null, i.createElement("defs", null, i.createElement("pattern", {
            id: "PSPDFKit-Color-Background-Chessboard",
            width: "0.5",
            height: "0.5",
            patternContentUnits: "objectBoundingBox"
          }, i.createElement("rect", {
            x: "0",
            y: "0",
            width: "0.25",
            height: "0.25",
            style: {
              fill: "rgba(0,0,0,.2)"
            }
          }), i.createElement("rect", {
            x: "0.25",
            y: "0.25",
            width: "0.25",
            height: "0.25",
            style: {
              fill: "rgba(0,0,0,.2)"
            }
          }))), i.createElement("circle", {
            cx: "12",
            cy: "12",
            r: "10",
            style: {
              fill: "url(#PSPDFKit-Color-Background-Chessboard)"
            }
          })),
          $ = () => i.createElement("g", {
            transform: "translate(5 5)"
          }, i.createElement("line", {
            x1: "2",
            x2: "12",
            y1: "12",
            y2: "2",
            style: {
              stroke: "#F00",
              strokeWidth: 2
            },
            strokeLinecap: "round"
          })),
          G = e => t => {
            var n, o, a;
            let {
                btnComponentProps: s,
                selectedItem: u
              } = t,
              d = !1;
            if (null != (null == u || null === (n = u.value) || void 0 === n ? void 0 : n.color)) {
              var p;
              const t = null === (p = u.value) || void 0 === p ? void 0 : p.color;
              d = Boolean(!e.colorItems.some(e => {
                var n;
                return null === (n = e.value) || void 0 === n || null === (n = n.color) || void 0 === n ? void 0 : n.equals(t);
              }));
            } else d = !e.colorItems.some(e => {
              var t, n, r;
              return null == (null === (t = e.value) || void 0 === t ? void 0 : t.color) && null == (null == u || null === (n = u.value) || void 0 === n ? void 0 : n.color) || (null === (r = e.value) || void 0 === r || null === (r = r.color) || void 0 === r ? void 0 : r.transparent);
            });
            const h = [...e.colors, ...e.customColorPresets].find(e => {
                var t;
                return u ? H(e) === H(u.value) : null === (t = e.color) || void 0 === t ? void 0 : t.transparent;
              }),
              f = h ? H(h) : null,
              m = e.formatMessage(h ? h.localization : {
                id: "transparent",
                defaultMessage: "Transparent",
                description: "Transparent"
              }),
              g = e.value,
              v = (!g || !h || "transparent" === h.localization.id || !e.keepOpacity && e.opacity < 1) && (j || (j = i.createElement(Z, null)));
            return i.createElement("button", (0, r.Z)({}, s, {
              className: c()("PSPDFKit-Input-Dropdown-Button", "PSPDFKit-Input-Color-Dropdown", e.styles.colorSelectButton, {
                [x().isDisabled]: e.disabled,
                [e.styles.controlIsDisabled]: e.disabled
              }),
              ref: t => {
                s.ref(t), "function" == typeof e.innerRef ? e.innerRef(t) : e.innerRef && "object" == typeof e.innerRef && "current" in e.innerRef && (e.innerRef.current = t), e.innerRef && t && !e.autoFocused.current && (t.focus(), e.autoFocused.current = !0, e.lastToolbarActionUsedKeyboard && (t.classList.add(C().focusedFocusVisible), t.addEventListener("blur", A.Cz)));
              },
              name: "clickableBox",
              disabled: e.disabled
            }), d && "label" === e.unavailableItemFallback.type ? i.createElement("span", null, null !== (o = e.unavailableItemFallback.label) && void 0 !== o ? o : "N/A") : i.createElement(i.Fragment, null, i.createElement(l.TX, {
              tag: "div"
            }, m), i.createElement("svg", (0, r.Z)({
              viewBox: "0 0 24 24",
              className: e.styles.colorSvg,
              key: f
            }, {
              title: m,
              value: f
            }, {
              "aria-hidden": !0
            }), v, (h && "transparent" === h.localization.id || !g) && (B || (B = i.createElement($, null))), i.createElement("circle", {
              cx: "12",
              cy: "12",
              r: "10",
              style: U(null !== (a = null == g ? void 0 : g.color) && void 0 !== a ? a : null)
            }))), i.createElement("div", null, (0, z.Z)({
              type: `caret-${e.caretDirection}`,
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: c()(b().dropdownIcon)
            })));
          },
          W = e => t => {
            var n, a;
            let {
              item: u,
              state: d,
              itemComponentProps: p
            } = t;
            const f = [...e.colors, ...e.customColorPresets].find(e => {
                var t, n;
                return null != e.color && null != (null == u || null === (t = u.value) || void 0 === t ? void 0 : t.color) ? e.color.equals(null == u ? void 0 : u.value.color) : null == e.color && null == (null == u || null === (n = u.value) || void 0 === n ? void 0 : n.color);
              }),
              m = e.colors.some(e => {
                var t, n;
                return null != e.color && null != (null == u || null === (t = u.value) || void 0 === t ? void 0 : t.color) ? e.color.equals(u.value.color) : null == e.color && null == (null == u || null === (n = u.value) || void 0 === n ? void 0 : n.color);
              });
            (0, s.kG)(f, "Couldn't find matching color.");
            const g = H(f),
              y = m ? e.formatMessage(f.localization) : e.formatMessage(S.Z.newColor),
              w = e.customColorPresets.find(e => {
                var t, n;
                return null != e.color && null != (null == u || null === (t = u.value) || void 0 === t ? void 0 : t.color) ? e.color.equals(u.value.color) : null == e.color && null == (null == u || null === (n = u.value) || void 0 === n ? void 0 : n.color);
              });
            let D,
              C = 0;
            const E = ("transparent" === f.localization.id || !e.keepOpacity && e.opacity < 1) && (N || (N = i.createElement(Z, null)));
            return i.createElement("div", {
              "data-testid": "color-swatch",
              className: v().colorItemContainer
            }, w && (e.isDeleteButtonVisible === g || !(0, k.b1)()) && i.createElement(q, {
              onClick: () => e.handleDeleteColor(w)
            }), i.createElement(o.Z, (0, r.Z)({
              is: "div",
              className: c()(h().root, x().root, {
                [b().isSelected]: (null == d ? void 0 : d.includes("selected")) || (null == d ? void 0 : d.includes("focused"))
              }, b().item, e.styles.colorItem),
              name: null !== (n = null == u || null === (a = u.value) || void 0 === a ? void 0 : a.localization.id) && void 0 !== n ? n : ""
            }, p, {
              onPointerDown: (0, k.b1)() ? () => {
                C = Date.now(), D = setTimeout(() => {
                  e.setIsDeleteButtonVisible(g);
                }, 300);
              } : void 0,
              onPointerUp: (0, k.b1)() ? (t => () => {
                Date.now() - C < 300 && (window.clearTimeout(D), e.setIsDeleteButtonVisible(void 0), e.handleChange(t));
              })(u) : void 0
            }), i.createElement(l.TX, {
              tag: "div"
            }, y), i.createElement("svg", (0, r.Z)({
              viewBox: "0 0 24 24",
              className: `PSPDFKit-Input-Dropdown-Item ${e.styles.colorSvg}`,
              key: g
            }, {
              title: y,
              value: g
            }, {
              "aria-hidden": "true"
            }), E, "transparent" === f.localization.id && (L || (L = i.createElement($, null))), i.createElement("circle", {
              cx: "12",
              cy: "12",
              r: "10",
              style: U(f.color, e.keepOpacity)
            }))));
          },
          Y = i.memo(V);
      },
      54707: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => y
        });
        var r = n(22122),
          o = n(96156),
          i = (n(15359), n(67294)),
          a = n(94184),
          s = n.n(a),
          l = n(31672),
          u = n(53261),
          c = n(40163),
          d = n(60210),
          p = n.n(d);
        let h = 0;
        class f extends i.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "inputRef", i.createRef()), (0, o.Z)(this, "shouldComponentUpdate", c.O), (0, o.Z)(this, "_guid", h++), (0, o.Z)(this, "triggerChange", () => {
              this.inputRef.current && this.props.onChange(Number(this.inputRef.current.value));
            });
          }
          render() {
            const {
              label: e,
              accessibilityLabel: t
            } = this.props;
            return i.createElement("div", {
              className: `PSPDFKit-Input-Slider ${this.props.className} ${p().root}`
            }, this.props.label ? i.createElement("label", {
              htmlFor: `${p().label}-${this._guid}`,
              className: p().label
            }, this.props.label) : this.props.accessibilityLabel ? i.createElement(l.TX, {
              tag: "label",
              htmlFor: `${p().label}-${this._guid}`
            }, this.props.accessibilityLabel) : null, i.createElement("div", {
              className: p().input
            }, i.createElement("input", {
              id: `${p().label}-${this._guid}`,
              type: "range",
              ref: this.inputRef,
              className: "PSPDFKit-Input-Slider-Input",
              min: this.props.min,
              max: this.props.max,
              step: this.props.step,
              value: this.props.value,
              onChange: this.triggerChange
            })), !this.props.hideLabel && i.createElement("label", {
              className: `PSPDFKit-Input-Slider-Value ${p().value}`
            }, this.props.valueLabel(this.props.value)));
          }
        }
        (0, o.Z)(f, "defaultProps", {
          min: 0,
          max: 100,
          step: 1,
          valueLabel: e => e.toString(),
          className: ""
        });
        var m = n(65927),
          g = n.n(m);
        let v = 0;
        class y extends i.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "controlRef", i.createRef()), (0, o.Z)(this, "state", {
              isOpen: !1
            }), (0, o.Z)(this, "_guid", v++), (0, o.Z)(this, "_toggleItems", () => {
              this.state.isOpen ? this._hideItems() : this._showItems();
            }), (0, o.Z)(this, "_handleKeyDown", e => {
              "ArrowDown" !== e.key || this.state.isOpen || this._toggleItems();
            }), (0, o.Z)(this, "_handleBlur", e => {
              e.preventDefault(), e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), setTimeout(() => {
                const e = this.controlRef.current,
                  t = this.props.shadowRoot,
                  n = t ? t.activeElement : e && e.ownerDocument && e.ownerDocument.activeElement,
                  r = e && e.contains(n);
                this.state.isOpen && !r && this._hideItems();
              }, 0);
            });
          }
          _showItems() {
            this.setState({
              isOpen: !0
            });
          }
          _hideItems() {
            this.setState({
              isOpen: !1
            });
          }
          render() {
            const {
              label: e,
              accessibilityLabel: t,
              caretDirection: r
            } = this.props;
            const o = this.props.className ? this.props.className : "",
              a = s()(g().root, this.state.isOpen && g().show, o, "PSPDFKit-Input-Dropdown", this.state.isOpen && "PSPDFKit-Input-Dropdown-open");
            return i.createElement("div", {
              style: this.props.style,
              className: a,
              onBlur: this._handleBlur,
              ref: this.controlRef,
              tabIndex: -1
            }, i.createElement("button", {
              className: `PSPDFKit-Input-Dropdown-Button ${g().button}`,
              onClick: this._toggleItems,
              onKeyDown: this._handleKeyDown,
              "aria-labelledby": `${g().srLabel}-${this._guid} ${g().value}-${this._guid}`,
              style: {
                height: 32
              },
              ref: this.props.innerRef,
              "aria-expanded": this.state.isOpen,
              "aria-controls": `${g().dropdownItems}-${this._guid}`,
              type: "button"
            }, i.createElement("span", {
              className: `PSPDFKit-Input-Dropdown-FlexContainer ${g().flexContainer}`,
              "aria-hidden": "true"
            }, i.createElement("span", {
              className: `PSPDFKit-Input-Slider-Value ${g().value}`,
              id: `${g().value}-${this._guid}`
            }, this.props.valueLabel(this.props.value))), i.createElement(l.TX, {
              id: `${g().srLabel}-${this._guid}`
            }, t || null), i.createElement(u.Z, {
              src: n("down" === r ? 52904 : 19201),
              className: g().toggle,
              "aria-hidden": "true"
            })), i.createElement("div", {
              className: s()("PSPDFKit-Input-Dropdown-Items", g().dropdownItems, g().dropdown, {
                [g().dropDownItemsUp]: "up" === this.props.caretDirection
              }),
              id: `${g().dropdownItems}-${this._guid}`
            }, this.state.isOpen && this._renderDropdownItems()));
          }
          _renderDropdownItems() {
            return i.createElement("div", {
              style: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                width: "auto",
                padding: "5px 10px"
              }
            }, i.createElement(f, (0, r.Z)({}, this.props, {
              className: `${this.props.className} ${g().slider}`,
              hideLabel: !0
            })));
          }
        }
        (0, o.Z)(y, "defaultProps", {
          min: 0,
          max: 100,
          step: 1,
          valueLabel: e => e.toString(),
          className: ""
        });
      },
      92744: (e, t, n) => {
        "use strict";

        n.d(t, {
          B: () => C
        });
        var r,
          o = n(22122),
          i = n(67294),
          a = n(67665),
          s = n(94184),
          l = n.n(s),
          u = n(93113),
          c = n(92537),
          d = n(98179),
          p = n(68540),
          h = n(59140),
          f = n(45249),
          m = n(15164),
          g = n(21683),
          v = n(37922),
          y = n.n(v);
        const b = d.G6 && (0, c.L)() > 1,
          w = b ? 2 : 1,
          x = 16 / w;
        function D(e, t) {
          const {
            zoomLevel: n
          } = e;
          return Math.round((0, g.e8)(e, (0, g.dF)(e, t)) * n);
        }
        const C = e => {
          const {
              pageRendererComponentProps: t,
              contentState: n,
              pageIndex: s,
              viewportState: g,
              onScroll: v,
              className: C,
              scrollElement: S,
              label: E,
              cursorPosition: _,
              isMobile: P
            } = e,
            [{
              x: k,
              y: A
            }, z] = i.useState({
              x: 0,
              y: 0
            }),
            [{
              scrollTop: T,
              scrollLeft: O
            }, I] = i.useState({
              scrollLeft: (null == S ? void 0 : S.scrollLeft) || 0,
              scrollTop: ((null == S ? void 0 : S.scrollTop) || 0) - D(g, s)
            }),
            F = (0, p.R9)(e => {
              _ || z({
                x: e.clientX,
                y: e.clientY
              });
            }),
            M = (0, p.tm)(),
            R = (0, p.R9)(() => {
              if (!S || !M()) return;
              const e = {
                scrollLeft: S.scrollLeft,
                scrollTop: S.scrollTop - D(g, s)
              };
              v ? v(() => I(e)) : I(e);
            });
          i.useEffect(() => (null == S || S.addEventListener("scroll", R, !1), () => {
            null == S || S.removeEventListener("scroll", R, !1);
          }), [R, S]);
          const j = P ? 136 : 174,
            B = g.scrollPosition.scale(g.zoomLevel).translate(g.scrollPosition.scale(-g.zoomLevel)),
            N = (0, u.G4)(g).translate(B.scale(-1)),
            L = (0, c.L)(),
            V = Math.floor(L * (((null == _ ? void 0 : _.x) || k) - N.left + O)) / L - g.viewportRect.left,
            K = Math.floor(L * (((null == _ ? void 0 : _.y) || A) - N.top + T)) / L - g.viewportRect.top,
            q = Math.floor(j / 2 - V),
            H = Math.floor(j / 2 - K),
            U = L / (w * x / L) + .5 / w,
            Z = w * x * .5 * L,
            $ = E || `${(g.zoomLevel * x * L / 2).toFixed(1).replace(".0", "")}x`;
          return i.createElement(h.Z, {
            onRootPointerMove: F
          }, i.createElement(a.m, null, i.createElement("div", {
            className: l()(y().magnifierContainer, {
              [y().magnifierContainerMobile]: P
            }, C)
          }, i.createElement("div", {
            className: y().magnifier,
            style: {
              transformOrigin: `${V}px ${K}px`,
              transform: `scale(${x * L / 2}) translate(-${U}px, -${U}px)`,
              left: q,
              top: H
            }
          }, i.createElement(m.Z, (0, o.Z)({}, t, {
            contentState: n,
            viewportRect: new f.UL({
              left: V,
              top: K,
              width: j,
              height: j
            }),
            forceDetailView: !0
          })), e.children), i.createElement("div", {
            className: y().magnifierGridContainer
          }, i.createElement("svg", {
            width: j,
            height: j,
            viewBox: `0 0 ${j * L} ${j * L}`
          }, i.createElement("defs", null, i.createElement("pattern", {
            id: "grid",
            x: P ? -3 * L : L > 1 ? -.5 * L : 0,
            y: P ? -3 * L : L > 1 ? -.5 * L : 0,
            width: Z,
            height: Z,
            patternUnits: "userSpaceOnUse"
          }, i.createElement("polyline", {
            points: `${Z - .5},0 ${Z - .5},${Z - .5} 0,${Z - .5}`,
            className: y().magnifierGridStroke,
            strokeWidth: 1,
            strokeLinejoin: "miter",
            strokeLinecap: "butt",
            shapeRendering: "crispEdges"
          }))), i.createElement("g", {
            transform: `translate(-${1 + Z / 2},-${1 + Z / 2})`
          }, r || (r = i.createElement("rect", {
            fill: "url(#grid)",
            x: "0",
            y: "0",
            width: "100%",
            height: "100%",
            strokeLinejoin: "miter",
            strokeLinecap: "butt",
            shapeRendering: "crispEdges"
          })), i.createElement("rect", {
            x: Math.floor(j * L / 2) + L * (b || d.vU && L > 1 ? 0 : .5),
            y: Math.floor(j * L / 2) + (b ? 1 : 0),
            width: Z,
            height: Z,
            className: y().magnifierCenterStroke,
            strokeWidth: 1,
            strokeLinejoin: "miter",
            strokeLinecap: "butt",
            shapeRendering: "crispEdges"
          }), i.createElement("rect", {
            x: Math.floor(j * L / 2) - 1,
            y: Math.floor(j * L / 2) - 1,
            width: Z + 3,
            height: Z + 3,
            className: y().magnifierCenterOutlineStroke,
            strokeWidth: 2,
            strokeLinejoin: "miter",
            strokeLinecap: "butt",
            shapeRendering: "crispEdges"
          }))), i.createElement("div", {
            className: y().magnifierLabelBackground
          }), i.createElement("div", {
            className: y().magnifierLabelText
          }, $)))));
        };
      },
      92879: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => W,
          qw: () => Q,
          sY: () => Y
        });
        var r,
          o,
          i,
          a,
          s = n(22122),
          l = n(67294),
          u = n(94184),
          c = n.n(u),
          d = n(35782),
          p = n(35369),
          h = n(31672),
          f = n(15359),
          m = n(67366),
          g = n(83882),
          v = n(70982),
          y = n(85151),
          b = n(48625),
          w = n(89637),
          x = n(14935),
          D = n(17766),
          C = n(11236),
          S = n(30549),
          E = n.n(S),
          _ = n(60790),
          P = n(4087),
          k = n(53261),
          A = n(97281),
          z = n(29152),
          T = n(98179),
          O = n(22690),
          I = n(62102),
          F = n(2841),
          M = n(94327),
          R = n(8643),
          j = n.n(R),
          B = n(89107),
          N = n.n(B),
          L = n(87301),
          V = n.n(L),
          K = n(84691),
          q = n.n(K),
          H = n(1385),
          U = n(66327),
          Z = n(75124),
          $ = n(79579),
          G = n.n($);
        const W = function (e) {
            var t, r, o, i, a, s, u, g, S;
            let {
              referenceRect: T,
              viewportState: R,
              isHidden: B,
              annotation: L,
              frameWindow: K,
              eventEmitter: q,
              setModalClosurePreventionError: $
            } = e;
            (0, f.kG)(L.measurementPrecision && L.measurementScale);
            const {
                formatMessage: G
              } = (0, d.YB)(),
              W = (0, m.I0)(),
              X = L.getMeasurementDetails().value,
              J = (0, m.v9)(e => e.backend),
              ee = (0, m.v9)(e => e.measurementScales),
              te = (0, m.v9)(e => e.activeMeasurementScale),
              [ne, re] = (0, l.useState)(!1),
              [oe, ie] = (0, l.useState)(!1),
              ae = te && !ne ? te.precision : L.measurementPrecision,
              [se, le] = (0, l.useState)((0, p.l4)([])),
              [ue, ce] = (0, l.useState)(X.toFixed(z._P[ae])),
              de = l.useMemo(() => te && !ne ? {
                unitFrom: te.scale.unitFrom,
                unitTo: te.scale.unitTo,
                fromValue: te.scale.fromValue,
                toValue: te.scale.toValue
              } : L.measurementScale, [te, L.measurementScale, ne]),
              [pe, he] = (0, l.useState)((0, y.sJ)({
                scale: de,
                precision: ae
              }).label),
              [fe, me] = (0, l.useState)(null == de ? void 0 : de.fromValue.toString()),
              [ge, ve] = (0, l.useState)(null == de ? void 0 : de.toValue.toString()),
              [ye, be] = (0, l.useState)(!1),
              we = (0, l.useCallback)(e => {
                const t = L.merge(e),
                  n = {
                    annotations: (0, p.aV)([t]),
                    reason: F.f.PROPERTY_CHANGE
                  };
                q.emit("annotations.willChange", n), W((0, P.FG)(t)), re(!0);
              }, [L, W, q]),
              xe = l.useCallback(e => {
                const t = (0, z.P_)(L, e);
                we({
                  measurementScale: t
                }), me(t.fromValue.toString()), ve(t.toValue.toString());
              }, [L, we]);
            (0, l.useEffect)(() => {
              $({
                error: _.x.MEASUREMENT_ERROR,
                annotationId: L.id
              });
            }, [L.id]), (0, l.useEffect)(() => {
              xe(parseFloat(ue || "1"));
            }, [ue, de]), (0, l.useEffect)(() => {
              W((0, U.M4)(ae));
            }, [ae]), (0, l.useEffect)(() => {
              oe && pe || (he((0, y.sJ)({
                scale: de,
                precision: ae
              }).label), le(se.delete("scaleName")));
              const e = null == ee ? void 0 : ee.find(e => {
                let {
                  scale: t,
                  precision: n
                } = e;
                return t.fromValue === Number(null == de ? void 0 : de.fromValue) && t.toValue === Number(null == de ? void 0 : de.toValue) && t.unitFrom === (null == de ? void 0 : de.unitFrom) && t.unitTo === (null == de ? void 0 : de.unitTo) && n === ae;
              });
              le(e ? se.add("duplicate") : se.delete("duplicate"));
            }, [fe, ge, ue, de, ae]);
            const De = "startPoint" in L && L.startPoint,
              Ce = "endPoint" in L && L.endPoint;
            (0, l.useEffect)(() => {
              ce(L.getMeasurementDetails().value.toFixed(z._P[ae]));
            }, [De, Ce, ae]);
            const Se = l.useCallback((0, I.zx)(G, "measurement"), [G]),
              Ee = l.useCallback((0, I.ck)(G), [G]),
              _e = l.useCallback(() => {
                const e = {
                  name: pe,
                  scale: {
                    fromValue: parseFloat(fe),
                    toValue: parseFloat(ge),
                    unitFrom: null == de ? void 0 : de.unitFrom,
                    unitTo: null == de ? void 0 : de.unitTo
                  },
                  precision: ae
                };
                (0, m.dC)(() => {
                  W((0, x.C0)(e)), W((0, x.Se)(e));
                }), "SERVER" === (null == J ? void 0 : J.type) ? (0, m.dC)(() => {
                  W((0, P.hQ)(L)), W((0, w.fz)()), W((0, U.UF)(b.A.MEASUREMENT)), W((0, x.Xh)(!1)), W((0, v.KY)(!0));
                }) : be(!0);
              }, [be, W, fe, ae, null == de ? void 0 : de.unitFrom, null == de ? void 0 : de.unitTo, pe, ge]),
              Pe = "in" === L.measurementScale.unitTo || "ft" === L.measurementScale.unitTo || "yd" === L.measurementScale.unitTo ? z.nK : z.nK.filter(e => !e.label.includes("/"));
            return ye ? l.createElement(h.u_, {
              onEscape: () => {
                (0, m.dC)(() => {
                  W((0, P.hQ)(L)), W((0, w.fz)()), W((0, U.UF)(b.A.MEASUREMENT)), W((0, x.Xh)(!1));
                });
              },
              background: "var(--PSPDFKit-MeasurementModalComponent-background-color)",
              className: V().calibrationSuccessModal
            }, l.createElement("div", {
              className: V().calibrationSuccessModalContainer
            }, l.createElement("div", {
              className: V().calibrationSuccessRow
            }, l.createElement(k.Z, {
              src: n(97468),
              className: E().itemIcon,
              role: "presentation",
              style: {
                color: "#628D06"
              }
            }), l.createElement("div", {
              onClick: () => {
                (0, m.dC)(() => {
                  W((0, P.hQ)(L)), W((0, w.fz)()), W((0, U.UF)(b.A.MEASUREMENT)), W((0, x.Xh)(!1));
                });
              }
            }, l.createElement(k.Z, {
              src: n(66361),
              className: E().itemIcon,
              role: "presentation",
              style: {
                cursor: "pointer"
              }
            }))), l.createElement("div", {
              className: c()(V().calibrationSuccessRow, V().calibrationSuccessTitle)
            }, l.createElement("p", null, G(Y.calibrationScaleSuccess))), l.createElement("div", {
              className: V().calibrationSuccessRow
            }, l.createElement("p", null, G(Y.calibrationScaleSubtitle))))) : B ? null : l.createElement(C.Z, {
              referenceRect: T,
              viewportState: R,
              className: "PSPDFKit-Measurement-Popover",
              wrapperClassName: "PSPDFKit-Measurement-Editor",
              title: G(Y.calibrateScale),
              footer: l.createElement("div", {
                className: c()(V().footer, V().contentRow, V().spaceBetweenRow)
              }, l.createElement(h.hE, {
                className: "PSPDFKit-Confirm-Dialog-Buttons",
                align: "end"
              }, l.createElement(h.zx, {
                autoFocus: !0,
                onClick: () => {
                  (0, m.dC)(() => {
                    W((0, x.Xh)(!1)), W((0, P.hQ)(L)), W((0, w.fz)()), W((0, U.UF)(b.A.MEASUREMENT));
                  });
                },
                className: c()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Cancel", V().button)
              }, G(D.Z.delete)), l.createElement(h.zx, {
                onClick: () => _e(),
                primary: !0,
                disabled: se.size > 0,
                className: c()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Confirm", V().button)
              }, G(D.Z.done))))
            }, l.createElement("div", {
              className: N().calibration
            }, l.createElement("div", {
              className: N().calibrationTop
            }, l.createElement(k.Z, {
              src: n(64772),
              className: E().itemIcon,
              role: "presentation"
            }), l.createElement("div", {
              className: E().itemLabel
            }, G(Y.calibrateLength)), l.createElement("div", {
              className: N().calibrateRight
            }, l.createElement(h.oi, {
              type: "number",
              value: ue,
              onChange: e => {
                if (ce(e.target.value), !function (e) {
                  const t = parseFloat(e);
                  return !isNaN(t) && isFinite(t) && t > 0;
                }(e.target.value)) return void le(se.add("calibrationValue"));
                le(se.delete("calibrationValue"));
                const t = parseFloat(e.target.value);
                xe(t);
              },
              required: !0,
              style: {
                height: 32,
                width: 90,
                borderColor: se.has("calibrationValue") ? "#FF0000" : void 0
              },
              className: c()(j().input, "PSPDFKit-Calibration-Input")
            }), l.createElement("div", {
              className: c()(E().nativeDropdown, N().nativeButton)
            }, l.createElement("select", {
              "aria-label": G(Y.calibrate),
              className: c()("PSPDFKit-Input-Dropdown-Select", "PSPDFKit-Calibration-UnitTo"),
              value: null !== (t = null === (r = z.b5.find(e => e.value === (null == de ? void 0 : de.unitTo))) || void 0 === r ? void 0 : r.value) && void 0 !== t ? t : null === (o = L.measurementScale) || void 0 === o ? void 0 : o.unitTo,
              onChange: e => {
                var t;
                we({
                  measurementScale: null === (t = L.measurementScale) || void 0 === t ? void 0 : t.set("unitTo", e.target.value)
                });
              }
            }, Object.keys(H.K).map(e => l.createElement("option", {
              key: e,
              value: H.K[e]
            }, H.K[e])))), l.createElement(O.Z, {
              items: z.b5,
              value: null !== (i = z.b5.find(e => e.value === (null == de ? void 0 : de.unitTo))) && void 0 !== i ? i : null,
              accessibilityLabel: G(Y.calibrate),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: c()(E().dropdownGroupComponent, "PSPDFKit-Calibration-UnitTo"),
              menuClassName: E().dropdownGroupMenu,
              ButtonComponent: Se,
              ItemComponent: Ee,
              onSelect: (e, t) => {
                var n;
                we({
                  measurementScale: null === (n = L.measurementScale) || void 0 === n ? void 0 : n.set("unitTo", t.value)
                });
              },
              frameWindow: K
            })))), l.createElement("span", {
              className: N().spacer
            }), l.createElement("div", {
              className: N().scale
            }, l.createElement("div", {
              className: N().scaleTop
            }, l.createElement(k.Z, {
              src: n(45983),
              className: E().itemIcon,
              role: "presentation"
            }), l.createElement("div", {
              className: E().itemLabel
            }, G(Y.measurementScale))), l.createElement("div", {
              style: {
                width: "100%"
              },
              className: N().itemHeader
            }, l.createElement(h.oi, {
              type: "text",
              value: pe,
              onChange: e => {
                e.target.value ? le(se.delete("scaleName")) : le(se.add("scaleName")), he(e.target.value), oe || ie(!0);
              },
              required: !0,
              style: {
                height: 32,
                width: "100%",
                borderColor: se.has("scaleName") ? "#FF0000" : void 0
              },
              className: c()(j().input, "PSPDFKit-Calibration-Name")
            })), l.createElement("div", {
              className: N().scaleBottom
            }, l.createElement("div", null, l.createElement(h.oi, {
              type: "number",
              value: fe,
              required: !0,
              disabled: !0,
              style: {
                height: 32,
                width: 90,
                borderColor: se.has("fromValue") ? "#FF0000" : void 0,
                opacity: "var(--PSPDFKit-Button-isDisabled-opacity)"
              },
              className: c()(j().input, j().disabled)
            }), l.createElement("div", {
              className: c()(E().nativeDropdown, N().nativeButton)
            }, l.createElement("select", {
              "aria-label": G(Y.measurementScale),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: (null === (a = L.measurementScale) || void 0 === a ? void 0 : a.unitFrom) || "",
              disabled: !0
            }, Object.keys(M.s).map(e => l.createElement("option", {
              key: e,
              value: M.s[e]
            }, M.s[e])))), l.createElement(O.Z, {
              items: z.m_,
              value: null !== (s = z.m_.find(e => e.value === (null == de ? void 0 : de.unitFrom))) && void 0 !== s ? s : null,
              accessibilityLabel: G(Y.measurementScale),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: E().dropdownGroupComponent,
              menuClassName: E().dropdownGroupMenu,
              ButtonComponent: Se,
              ItemComponent: Ee,
              disabled: !0,
              frameWindow: K
            })), ":", l.createElement("div", null, l.createElement(h.oi, {
              type: "number",
              value: ge,
              required: !0,
              disabled: !0,
              style: {
                height: 32,
                width: 90,
                borderColor: se.has("toValue") ? "#FF0000" : void 0,
                opacity: "var(--PSPDFKit-Button-isDisabled-opacity)"
              },
              className: c()(j().input, j().disabled)
            }), l.createElement("div", {
              className: c()(E().nativeDropdown, N().nativeButton)
            }, l.createElement("select", {
              "aria-label": G(Y.measurementScale),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: (null === (u = L.measurementScale) || void 0 === u ? void 0 : u.unitTo) || "",
              disabled: !0
            }, Object.keys(H.K).map(e => l.createElement("option", {
              key: e,
              value: H.K[e]
            }, H.K[e])))), l.createElement(O.Z, {
              items: z.b5,
              value: null !== (g = z.b5.find(e => e.value === (null == de ? void 0 : de.unitTo))) && void 0 !== g ? g : null,
              accessibilityLabel: G(Y.measurementScale),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: E().dropdownGroupComponent,
              menuClassName: E().dropdownGroupMenu,
              ButtonComponent: Se,
              ItemComponent: Ee,
              disabled: !0,
              frameWindow: K
            })))), l.createElement("span", {
              className: N().spacer
            }), l.createElement("div", {
              className: E().item
            }, l.createElement("div", {
              className: c()(E().itemLabel, N().itemLabel)
            }, G(Y.measurementPrecision)), l.createElement("div", {
              className: c()(E().nativeDropdown, N().nativeButton)
            }, l.createElement("select", {
              style: {
                height: 30
              },
              "aria-label": G(Y.measurementPrecision),
              className: c()("PSPDFKit-Input-Dropdown-Select", "PSPDFKit-Calibration-Precision"),
              value: L.measurementPrecision || "",
              onChange: e => {
                we({
                  measurementPrecision: e.target.value
                });
              }
            }, Object.keys(A.L).map((e, t) => l.createElement("option", {
              key: e,
              value: A.L[e]
            }, z.W9[t])))), l.createElement(O.Z, {
              items: Pe,
              value: null !== (S = Pe.find(e => e.value === L.measurementPrecision)) && void 0 !== S ? S : null,
              accessibilityLabel: G(Y.measurementPrecision),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: c()(E().dropdownGroupComponent, "PSPDFKit-Measurement-Popover-Precision-Dropdown", "PSPDFKit-Calibration-Precision"),
              menuClassName: E().dropdownGroupMenu,
              ButtonComponent: Se,
              ItemComponent: Q,
              onSelect: (e, t) => {
                we({
                  measurementPrecision: t.value
                }), ce(X.toFixed(z._P[t.value]).toString());
              },
              frameWindow: K
            })), se.has("duplicate") && l.createElement("p", {
              className: V().scaleError
            }, G(Z.s.scaleAlreadyAddedWarning)));
          },
          Y = (0, d.vU)({
            calibrationScaleSuccess: {
              id: "calibrationScaleSuccess",
              defaultMessage: "Scale has been successfully set",
              description: "Scale has been successfully set"
            },
            calibrationScaleSubtitle: {
              id: "calibrationScaleSubtitle",
              defaultMessage: "Start measuring by selecting one of the measurement tools.",
              description: "Start measuring by selecting one of the measurement tools."
            },
            perimeterMeasurementSettings: {
              id: "perimeterMeasurementSettings",
              defaultMessage: "Perimeter Measurement Settings",
              description: "Perimeter Measurement Settings"
            },
            polygonAreaMeasurementSettings: {
              id: "polygonAreaMeasurementSettings",
              defaultMessage: "Polygon Area Measurement Settings",
              description: "Polygon Area Measurement Settings"
            },
            rectangularAreaMeasurementSettings: {
              id: "rectangularAreaMeasurementSettings",
              defaultMessage: "Rectangle Area Measurement Settings",
              description: "Rectangle Area Measurement Settings"
            },
            ellipseAreaMeasurementSettings: {
              id: "ellipseAreaMeasurementSettings",
              defaultMessage: "Ellipse Area Measurement Settings",
              description: "Ellipse Area Measurement Settings"
            },
            calibrateLength: {
              id: "calibrateLength",
              defaultMessage: "Calibrate Length",
              description: "Calibrate"
            },
            measurementPrecision: {
              id: "measurementPrecision",
              defaultMessage: "Precision",
              description: "Precision"
            },
            measurementScale: {
              id: "measurementScale",
              defaultMessage: "Scale",
              description: "Scale"
            },
            calibrateScale: {
              id: "calibrateScale",
              defaultMessage: "Calibrate Scale",
              description: "Calibrate Scale"
            },
            calibrate: {
              id: "calibrate",
              defaultMessage: "Calibrate",
              description: "Calibrate"
            }
          });
        const X = e => T.G6 ? l.createElement("span", null, e.label) : "1/2" === e.label ? r || (r = l.createElement("span", null, "1⁄2 in")) : "1/4" === e.label ? o || (o = l.createElement("span", null, "1⁄4 in")) : "1/8" === e.label ? i || (i = l.createElement("span", null, "1⁄8 in")) : "1/16" === e.label ? a || (a = l.createElement("span", null, "1⁄16 in ")) : l.createElement("span", null, e.label),
          Q = e => {
            let {
              item: t,
              state: n,
              itemComponentProps: r,
              ref: o
            } = e;
            return l.createElement(g.Z, (0, s.Z)({
              is: "div",
              className: c()(q().item, {
                [q().isSelected]: (null == n ? void 0 : n.includes("selected")) || (null == n ? void 0 : n.includes("focused"))
              }, q().measurementDropdownText),
              name: null == t ? void 0 : t.value
            }, r, {
              ref: o
            }), null != n && n.includes("selected") ? l.createElement(k.Z, {
              src: G(),
              className: N().icon
            }) : l.createElement("span", {
              className: N().icon
            }), l.createElement(X, {
              label: null == t ? void 0 : t.label
            }));
          };
      },
      38835: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => T,
          s: () => O
        });
        var r = n(67294),
          o = n(35782),
          i = n(31672),
          a = n(94184),
          s = n.n(a),
          l = n(67366),
          u = n(15837),
          c = n(58163),
          d = n(4087),
          p = n(89637),
          h = n(66327),
          f = n(67260),
          m = n(75124),
          g = n(72113),
          v = n(17766),
          y = n(87301),
          b = n.n(y),
          w = n(46945),
          x = n(89107),
          D = n.n(x),
          C = n(1385),
          S = n(30549),
          E = n.n(S),
          _ = n(22690),
          P = n(62102),
          k = n(97281),
          A = n(29152),
          z = n(14935);
        const T = function (e) {
            var t, n;
            let {
              frameWindow: a
            } = e;
            const {
                formatMessage: y
              } = (0, o.YB)(),
              x = (0, l.v9)(e => e.measurementScales),
              S = (0, l.v9)(e => e.secondaryMeasurementUnit),
              [T, I] = r.useState(Boolean(S)),
              [F, M] = r.useState(null == S ? void 0 : S.unitTo),
              [R, j] = r.useState(null == S ? void 0 : S.precision),
              [B, N] = r.useState(!1),
              [L, V] = r.useState([]),
              [K, q] = r.useState(null),
              [H, U] = r.useState(null),
              [Z, $] = r.useState(!1),
              G = (0, l.v9)(e => {
                const {
                  selectedAnnotationIds: t,
                  annotations: n
                } = e;
                return t.map(e => n.get(e));
              }),
              W = (0, l.I0)(),
              Y = r.useCallback((0, P.zx)(y, "measurement"), [y]),
              X = r.useCallback((0, P.ck)(y), [y]),
              Q = r.useCallback(() => {
                W((0, h.jJ)()), W((0, p.fz)()), W((0, d.Ds)("measurement")), W((0, h.BR)());
              }, [W]),
              J = r.useCallback(e => {
                if (B && L && x) {
                  const {
                    deleted: t
                  } = (0, A.Rc)(x, L);
                  if (t.filter(e => !(null == H ? void 0 : H.find(t => t.prevScale === e))).length > 0 && !e) return void $(!0);
                  (0, l.dC)(() => {
                    W((0, z.U7)(L, H)), W((0, z.Se)(K));
                  });
                }
                T && F && R && W((0, z.v9)({
                  unitTo: F,
                  precision: R
                })), !S || F || R || W((0, z.v9)(null)), G.size > 0 && (0, l.dC)(() => {
                  G.toList().forEach(e => {
                    const t = e.set("measurementScale", new c.Z({
                      fromValue: Number(null == K ? void 0 : K.scale.fromValue),
                      toValue: Number(null == K ? void 0 : K.scale.toValue),
                      unitFrom: null == K ? void 0 : K.scale.unitFrom,
                      unitTo: null == K ? void 0 : K.scale.unitTo
                    })).set("measurementPrecision", null == K ? void 0 : K.precision);
                    W((0, d.FG)(t));
                  });
                }), Q();
              }, [K, B, W, H, x, Q, L, S, F, R, T]),
              ee = r.useMemo(() => !!F && (0, A.B0)(F), [F]);
            return Z ? r.createElement(f.z, {
              onConfirm: () => {
                J(!0);
              },
              onCancel: () => {
                $(!1);
              },
              accessibilityLabel: y(O.scaleAnnotationsDeleteWarning),
              accessibilityDescription: y(O.scaleAnnotationsDeleteWarning)
            }, r.createElement("p", null, y(O.scaleAnnotationsDeleteWarning))) : r.createElement(g.Z, {
              onEscape: Q,
              background: "var(--PSPDFKit-MeasurementModalComponent-background-color)",
              className: s()(b().modal, "PSPDFKit-Modal-Measurement-Settings")
            }, r.createElement("h2", {
              className: s()(b().title, b().header, b().contentRow)
            }, y(O.setScale)), r.createElement(m.Z, {
              frameWindow: a,
              setAreValidScales: N,
              scalesSetter: V,
              activeScaleSetter: q,
              editedScalesSetter: U
            }), r.createElement("h2", {
              className: s()(b().contentRow, b().sectionTitle, b().spaceBetweenRow)
            }, y(O.secondaryUnits)), r.createElement("div", {
              className: s()(b().contentRow, b().spaceBetweenRow)
            }, r.createElement("p", null, y(O.displaySecondaryUnit)), r.createElement(w.n, {
              value: T,
              onUpdate: () => {
                T ? (M(void 0), j(void 0)) : (M(C.K.INCHES), j(k.L.WHOLE)), I(!T);
              },
              accessibilityLabel: y(O.displaySecondaryUnit)
            })), T ? r.createElement("div", {
              className: "PSPDFKit-Secondary-Measurement"
            }, r.createElement("div", {
              className: s()(b().contentRow, b().spaceBetweenRow)
            }, r.createElement("p", null, y(O.unit)), r.createElement("div", {
              className: s()(b().nativeDropdown, D().nativeButton)
            }, r.createElement("select", {
              style: {
                height: 30
              },
              "aria-label": y(O.measurementScale),
              value: (null === (t = A.b5.find(e => e.value === F)) || void 0 === t ? void 0 : t.value) || "",
              className: "PSPDFKit-Input-Dropdown-Select",
              onChange: e => {
                M(e.target.value);
              }
            }, Object.keys(C.K).map(e => r.createElement("option", {
              key: e,
              value: C.K[e]
            }, C.K[e])))), r.createElement(_.Z, {
              items: A.b5,
              value: null !== (n = A.b5.find(e => e.value === F)) && void 0 !== n ? n : null,
              accessibilityLabel: y(O.measurementScale),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: s()(b().dropdownGroupComponent, E().dropdownGroupComponent, "PSPDFKit-Secondary-Measurement-UnitTo"),
              menuClassName: E().dropdownGroupMenu,
              ButtonComponent: Y,
              ItemComponent: X,
              onSelect: (e, t) => {
                (0, A.B0)(t.value) && (0, A.zl)(R) && !ee && j(void 0), M(t.value);
              },
              frameWindow: a
            })), r.createElement("div", {
              className: s()(b().contentRow, b().spaceBetweenRow)
            }, r.createElement("p", null, y(O.measurementPrecision)), r.createElement(u.Z, {
              frameWindow: a,
              unit: F,
              onPrecisionChange: j,
              selectedPrecision: R,
              precisionDropdownClassname: "PSPDFKit-Secondary-Measurement-Precision",
              accessibilityLabel: y(O.measurementPrecision)
            }))) : null, r.createElement("div", {
              className: s()(b().footer, b().contentRow, b().spaceBetweenRow)
            }, r.createElement(i.hE, {
              className: "PSPDFKit-Confirm-Dialog-Buttons",
              align: "end"
            }, r.createElement(i.zx, {
              autoFocus: !0,
              onClick: Q,
              className: s()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Cancel", b().button)
            }, y(v.Z.cancel)), r.createElement(i.zx, {
              onClick: () => J(),
              primary: !0,
              disabled: T && (!F || !R) || !B,
              className: s()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Confirm", b().button)
            }, y(v.Z.done)))));
          },
          O = (0, o.vU)({
            distanceMeasurementSettings: {
              id: "distanceMeasurementSettings",
              defaultMessage: "Distance Measurement Settings",
              description: "Distance Measurement Settings"
            },
            perimeterMeasurementSettings: {
              id: "perimeterMeasurementSettings",
              defaultMessage: "Perimeter Measurement Settings",
              description: "Perimeter Measurement Settings"
            },
            polygonAreaMeasurementSettings: {
              id: "polygonAreaMeasurementSettings",
              defaultMessage: "Polygon Area Measurement Settings",
              description: "Polygon Area Measurement Settings"
            },
            rectangularAreaMeasurementSettings: {
              id: "rectangularAreaMeasurementSettings",
              defaultMessage: "Rectangle Area Measurement Settings",
              description: "Rectangle Area Measurement Settings"
            },
            ellipseAreaMeasurementSettings: {
              id: "ellipseAreaMeasurementSettings",
              defaultMessage: "Ellipse Area Measurement Settings",
              description: "Ellipse Area Measurement Settings"
            },
            measurementCalibrateLength: {
              id: "measurementCalibrateLength",
              defaultMessage: "Calibrate Length",
              description: "Calibrate"
            },
            measurementPrecision: {
              id: "measurementPrecision",
              defaultMessage: "Precision",
              description: "Precision"
            },
            measurementScale: {
              id: "measurementScale",
              defaultMessage: "Scale",
              description: "Measurement Scale"
            },
            setScale: {
              id: "setScale",
              defaultMessage: "Set Scale",
              description: "Set Scale"
            },
            unit: {
              id: "unit",
              defaultMessage: "Unit",
              description: "Unit"
            },
            secondaryUnits: {
              id: "secondaryUnits",
              defaultMessage: "Secondary Units",
              description: "Secondary Units"
            },
            displaySecondaryUnit: {
              id: "displaySecondaryUnit",
              defaultMessage: "Display Secondary Unit",
              description: "Display Secondary Unit"
            },
            scaleAnnotationsDeleteWarning: {
              id: "scaleAnnotationsDeleteWarning",
              defaultMessage: "Deleting the scale will also delete measurements using the scale.",
              description: "Message displayed in the scales deletion dialog"
            }
          });
      },
      15837: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => b
        });
        var r = n(94184),
          o = n.n(r),
          i = n(67294),
          a = n(35782),
          s = n(62102),
          l = n(92879),
          u = n(89107),
          c = n.n(u),
          d = n(38835),
          p = n(87301),
          h = n.n(p),
          f = n(30549),
          m = n.n(f),
          g = n(22690),
          v = n(97281),
          y = n(29152);
        const b = e => {
          var t, n;
          let {
            unit: r,
            frameWindow: u,
            selectedPrecision: p,
            onPrecisionChange: f,
            wrapperClass: b,
            precisionDropdownClassname: w,
            accessibilityLabel: x,
            index: D
          } = e;
          const {
              formatMessage: C
            } = (0, a.YB)(),
            S = (0, i.useMemo)(() => !!r && (0, y.B0)(r), [r]),
            E = (0, i.useMemo)(() => S ? y.Qc : y.nK, [S]),
            _ = i.useCallback((0, s.zx)(C, "measurement"), [C]);
          return i.createElement("div", {
            className: b || void 0
          }, i.createElement("div", {
            className: o()(h().nativeDropdown, c().nativeButton)
          }, i.createElement("select", {
            style: {
              height: 30
            },
            "aria-label": C(d.s.measurementPrecision),
            "data-test-id": void 0 !== D ? `PSPDFKit-Scale-${D + 1}-Precision` : "PSPDFKit-Scale-Precision",
            value: (null === (t = y.nK.find(e => e.value === p || e.label === p)) || void 0 === t ? void 0 : t.value) || "",
            className: o()("PSPDFKit-Input-Dropdown-Select", "PSPDFKit-Measurement-Precision-Dropdown"),
            onChange: e => {
              f(e.target.value);
            }
          }, Object.keys(v.L).filter(e => S ? !(0, y.zl)(v.L[e]) : e).map((e, t) => i.createElement("option", {
            key: e,
            value: v.L[e]
          }, y.W9[t])))), i.createElement(g.Z, {
            items: E,
            value: null !== (n = E.find(e => e.value === p || e.label === p)) && void 0 !== n ? n : null,
            accessibilityLabel: x,
            discreteDropdown: !1,
            isActive: !1,
            caretDirection: "down",
            className: o()("PSPDFKit-Input-Dropdown-Select", h().dropdownGroupComponent, "PSPDFKit-Measurement-Precision-Dropdown", w),
            "data-test-id": void 0 !== D ? `PSPDFKit-Scale-${D + 1}-Precision` : "PSPDFKit-Scale-Precision",
            menuClassName: m().dropdownGroupMenu,
            ButtonComponent: _,
            ItemComponent: l.qw,
            onSelect: (e, t) => {
              f(t.value);
            },
            frameWindow: u
          }));
        };
      },
      75124: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => j,
          s: () => R
        });
        var r = n(96156),
          o = n(31672),
          i = n(94184),
          a = n.n(i),
          s = n(67294),
          l = n(35782),
          u = n(67366),
          c = n(15837),
          d = n(97281),
          p = n(62102),
          h = n(30549),
          f = n.n(h),
          m = n(8643),
          g = n.n(m),
          v = n(53261),
          y = n(92879),
          b = n(89107),
          w = n.n(b),
          x = n(17766),
          D = n(22690),
          C = n(94327),
          S = n(1385),
          E = n(29152),
          _ = n(87301),
          P = n.n(_);
        function k(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function A(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? k(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : k(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const z = "duplicate",
          T = "name",
          O = "fromValue",
          I = "toValue",
          F = "precision";
        function M(e) {
          const t = parseFloat(e);
          return !isNaN(t) && isFinite(t) && t > 0;
        }
        const R = (0, l.vU)({
            scaleSelector: {
              id: "scaleSelector",
              defaultMessage: "Scale {arg0}",
              description: "Scale checkbox selector for multiple scale selection accessibility"
            },
            scaleName: {
              id: "scaleName",
              defaultMessage: "Scale Name",
              description: "Scale Name"
            },
            scaleUnitFrom: {
              id: "scaleUnitFrom",
              defaultMessage: "Scale unit from",
              description: "Scale unit from"
            },
            scaleUnitTo: {
              id: "scaleUnitTo",
              defaultMessage: "Scale unit to",
              description: "Scale unit to"
            },
            addScale: {
              id: "addScale",
              defaultMessage: "Add scale",
              description: "Add scale"
            },
            scaleAlreadyAddedWarning: {
              id: "scaleAlreadyAddedWarning",
              defaultMessage: "Scale with these settings has already been defined. Please choose a different scale.",
              description: "Scale with these settings has already been defined. Please choose a different scale."
            }
          }),
          j = function (e) {
            const {
                frameWindow: t,
                setAreValidScales: r,
                scalesSetter: i,
                activeScaleSetter: h,
                editedScalesSetter: m
              } = e,
              {
                formatMessage: b
              } = (0, l.YB)(),
              _ = (0, u.v9)(e => e.measurementScales),
              k = (0, u.v9)(e => e.activeMeasurementScale),
              [j, B] = (0, s.useState)([]),
              [N, L] = (0, s.useState)(_),
              [V, K] = (0, s.useState)(k ? null == _ ? void 0 : _.findIndex(e => (0, E.cd)(e, k)) : 0),
              [q, H] = (0, s.useState)([]),
              [U, Z] = (0, s.useState)([]);
            s.useEffect(() => {
              const e = function (e, t) {
                const n = [];
                return t.forEach(t => {
                  const r = e[t],
                    o = [],
                    i = r.scale.fromValue,
                    a = r.scale.toValue,
                    s = r.precision;
                  M(i) || o.push(O), M(a) || o.push(I), s || o.push(F);
                  const l = [];
                  e.forEach((e, n) => {
                    n !== t && (l.push(n), r.name && r.name === e.name && !o.includes(T) && o.push(T), (0, E.cd)(r, e) && !o.includes(z) && o.push(z));
                  }), o.length > 0 && n.push({
                    index: t,
                    fields: o,
                    conflicts: l
                  });
                }), n;
              }(N, U);
              if (e.length > 0) {
                const t = e[e.length - 1];
                B([t]);
              } else B([]), Z([]), i(N);
              r(0 === e.length);
            }, [N, i, r]), s.useEffect(() => {
              L(_);
            }, [_]), s.useEffect(() => {
              const e = null == N ? void 0 : N.find((e, t) => t === V);
              e && h(e);
            }, [V, h, N]), s.useEffect(() => {
              m(q);
            }, [q]);
            const $ = (e, t, n) => {
                L(r => {
                  const o = null == r ? void 0 : r.map(e => A(A({}, e), {}, {
                    scale: A({}, e.scale)
                  }));
                  return "precision" === t ? o[e][t] = n : o[e].scale = A(A({}, o[e].scale), {}, {
                    [t]: n
                  }), o;
                }), null != _ && _.find(t => JSON.stringify(t) === JSON.stringify(null == N ? void 0 : N[e])) && q && !q.find(t => t === e) && H([...q, {
                  index: e,
                  prevScale: _[e]
                }]), U.includes(e) || Z([...U, e]);
              },
              G = s.useCallback((0, p.zx)(b, "measurement"), [b]),
              W = s.useCallback((0, p.ck)(b), [b]);
            return s.createElement("div", {
              className: P().scale
            }, null == N ? void 0 : N.map((e, r) => {
              var i, l;
              const u = e.name,
                d = e.scale,
                p = e.precision,
                h = null == d ? void 0 : d.unitFrom,
                m = null == d ? void 0 : d.unitTo,
                k = null == d ? void 0 : d.fromValue,
                M = null == d ? void 0 : d.toValue,
                B = j.find(e => e.index === r),
                Y = null == B ? void 0 : B.fields.includes(z),
                X = null == B ? void 0 : B.fields.includes(T),
                Q = null == B ? void 0 : B.fields.includes(O),
                J = null == B ? void 0 : B.fields.includes(I),
                ee = null == B ? void 0 : B.fields.includes(F);
              return s.createElement("div", {
                key: r,
                style: {
                  marginBottom: "var(--PSPDFKit-spacing-6)"
                }
              }, s.createElement("div", {
                className: a()(P().scaleRow),
                style: Y ? {
                  borderBottom: 0
                } : {},
                "data-test-id": `PSPDFKit-Scale-${r + 1}`
              }, s.createElement("input", {
                key: u,
                type: "radio",
                checked: Boolean(V === r && !Y),
                value: r,
                id: b(R.scaleSelector, {
                  arg0: r + 1
                }),
                name: b(R.scaleSelector, {
                  arg0: r + 1
                }),
                onChange: e => {
                  e.target.checked && K(r);
                },
                className: a()(P().activeScaleRadio, "PSPDFKit-Active-Scale-Radio-Input")
              }), s.createElement("div", {
                className: a()(P().scaleContent, P().scaleMiddleSection)
              }, s.createElement("div", {
                className: a()(P().scaleRow, P().spaceBetweenRow, P().rowSeparator)
              }, s.createElement(o.oi, {
                type: "text",
                value: u,
                placeholder: b(R.scaleName),
                onChange: e => {
                  ((e, t) => {
                    U.includes(e) || Z([...U, e]), L(n => {
                      const r = null == n ? void 0 : n.map(e => A(A({}, e), {}, {
                        scale: A({}, e.scale)
                      }));
                      return r[e].name = t, r;
                    }), null != _ && _.find(t => JSON.stringify(t) === JSON.stringify(null == N ? void 0 : N[e])) && q && !q.find(t => t === e) && H([...q, {
                      index: e,
                      prevScale: _[e]
                    }]);
                  })(r, e.target.value);
                },
                required: !0,
                style: {
                  height: 32,
                  width: "100%",
                  borderColor: X ? "#FF0000" : void 0
                },
                className: a()(g().input),
                maxLength: 40
              })), s.createElement("div", {
                className: a()(P().scaleRow, P().rowSeparator)
              }, s.createElement("div", {
                className: P().scaleRowContent
              }, s.createElement(o.oi, {
                type: "number",
                value: "" + k,
                onChange: e => {
                  $(r, "fromValue", e.target.value);
                },
                required: !0,
                style: {
                  height: 32,
                  width: 54,
                  borderColor: Q || Y ? "#FF0000" : void 0
                },
                "data-test-id": `PSPDFKit-Scale-${r + 1}-FromValue`,
                className: a()(g().input)
              }), s.createElement("div", {
                className: a()(P().nativeDropdown, w().nativeButton)
              }, s.createElement("select", {
                style: {
                  height: 30
                },
                "aria-label": `${b(R.scaleUnitFrom)} ${r + 1}`,
                className: a()("PSPDFKit-Input-Dropdown-Select"),
                "data-test-id": `PSPDFKit-Scale-${r + 1}-UnitFrom`,
                value: h || "",
                onChange: e => {
                  $(r, "unitFrom", e.target.value);
                }
              }, Object.keys(C.s).map(e => s.createElement("option", {
                key: e,
                value: C.s[e]
              }, C.s[e])))), s.createElement(D.Z, {
                items: E.m_,
                value: null !== (i = E.m_.find(e => e.value === h)) && void 0 !== i ? i : null,
                accessibilityLabel: `${b(R.scaleUnitFrom)} ${r + 1}`,
                discreteDropdown: !1,
                isActive: !1,
                caretDirection: "down",
                "data-test-id": `PSPDFKit-Scale-${r + 1}-UnitFrom`,
                className: a()(P().dropdownGroupComponent, f().dropdownGroupComponent),
                menuClassName: f().dropdownGroupMenu,
                ButtonComponent: G,
                ItemComponent: W,
                onSelect: (e, t) => {
                  $(r, "unitFrom", t.value);
                },
                frameWindow: t
              })), "=", s.createElement("div", {
                className: P().scaleRowContent
              }, s.createElement(o.oi, {
                type: "number",
                value: "" + M,
                onChange: e => {
                  $(r, "toValue", e.target.value);
                },
                required: !0,
                style: {
                  height: 32,
                  width: 54,
                  borderColor: J || Y ? "#FF0000" : void 0
                },
                "data-test-id": `PSPDFKit-Scale-${r + 1}-ToValue`,
                className: a()(g().input)
              }), s.createElement("div", {
                className: a()(P().nativeDropdown, w().nativeButton)
              }, s.createElement("select", {
                style: {
                  height: 30
                },
                "aria-label": `${b(R.scaleUnitFrom)} ${r + 1}`,
                "data-test-id": `PSPDFKit-Scale-${r + 1}-UnitTo`,
                className: a()("PSPDFKit-Input-Dropdown-Select"),
                value: m || "",
                onChange: e => {
                  $(r, "unitTo", e.target.value);
                }
              }, Object.keys(S.K).map(e => s.createElement("option", {
                key: e,
                value: S.K[e]
              }, S.K[e])))), s.createElement(D.Z, {
                items: E.b5,
                value: null !== (l = E.b5.find(e => e.value === m)) && void 0 !== l ? l : null,
                accessibilityLabel: `${b(R.scaleUnitFrom)} ${r + 1}`,
                discreteDropdown: !1,
                isActive: !1,
                caretDirection: "down",
                "data-test-id": `PSPDFKit-Scale-${r + 1}-UnitTo`,
                className: a()(P().dropdownGroupComponent, f().dropdownGroupComponent),
                menuClassName: f().dropdownGroupMenu,
                ButtonComponent: G,
                ItemComponent: W,
                onSelect: (e, t) => {
                  $(r, "unitTo", t.value);
                },
                frameWindow: t
              }))), s.createElement("div", {
                className: a()(P().scaleRow, P().spaceBetweenRow, P().rowSeparator)
              }, s.createElement("p", {
                className: f().itemLabel
              }, b(y.sY.measurementPrecision)), s.createElement(c.Z, {
                frameWindow: t,
                unit: m,
                onPrecisionChange: e => $(r, "precision", e),
                selectedPrecision: p,
                wrapperClass: a()({
                  [P().error]: ee
                }),
                accessibilityLabel: `${y.sY.measurementScale} ${b(y.sY.measurementPrecision)} ${r + 1}`,
                index: r
              }))), s.createElement("div", null, s.createElement(o.zx, {
                "data-test-id": `PSPDFKit-Scale-${r + 1}-RemoveScale`,
                className: a()(P().closeButton, "PSPDFKit-Measurement-Exit-Dialog-Close-Button"),
                onClick: () => {
                  (e => {
                    if (L(t => {
                      const n = null == t ? void 0 : t.map(e => A(A({}, e), {}, {
                        scale: A({}, e.scale)
                      }));
                      return n.splice(e, 1), n;
                    }), q) {
                      const t = q.filter(t => t.index !== e).map(e => A(A({}, e), {}, {
                        index: e.index - 1
                      }));
                      H(t);
                    }
                    if (U) {
                      const t = U.filter(t => t !== e).map(e => e - 1);
                      Z(t);
                    }
                    K(e => e ? e - 1 : 0);
                  })(r);
                },
                "aria-label": b(x.Z.close),
                disabled: 1 === N.length,
                style: {
                  position: "relative",
                  top: "7px"
                }
              }, s.createElement(v.Z, {
                className: P().signatureValidationCloseIcon,
                src: n(2256)
              })))), (Y || X) && s.createElement("p", {
                className: a()(P().scaleError)
              }, b(R.scaleAlreadyAddedWarning)));
            }), s.createElement("div", {
              className: P().addNewScale,
              onClick: () => {
                L(e => {
                  const t = null == e ? void 0 : e.map(e => A(A({}, e), {}, {
                    scale: A({}, e.scale)
                  }));
                  return t.push({
                    name: "",
                    scale: {
                      unitFrom: "cm",
                      unitTo: "cm",
                      fromValue: 1,
                      toValue: 1
                    },
                    precision: d.L.WHOLE
                  }), t;
                }), Z([...U, null == N ? void 0 : N.length]);
              }
            }, s.createElement(v.Z, {
              className: P().signatureValidationCloseIcon,
              src: n(45632),
              style: {
                color: "#4636E3"
              }
            }), s.createElement("u", {
              style: {
                color: "var(--color-blue600)"
              }
            }, b(R.addScale))));
          };
      },
      85151: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => N,
          sJ: () => j
        });
        var r = n(22122),
          o = n(94184),
          i = n.n(o),
          a = n(83882),
          s = n(85628),
          l = n.n(s),
          u = n(67294),
          c = n(35782),
          d = n(67366),
          p = n(79579),
          h = n.n(p),
          f = n(29152),
          m = n(38835),
          g = n(58163),
          v = n(48625),
          y = n(4087),
          b = n(14935),
          w = n(62102),
          x = n(84691),
          D = n.n(x),
          C = n(30549),
          S = n.n(C),
          E = n(89107),
          _ = n.n(E),
          P = n(22690),
          k = n(66327),
          A = n(53261),
          z = n(44170),
          T = n.n(z),
          O = n(71479),
          I = n(87301),
          F = n.n(I),
          M = n(17766);
        function R(e, t) {
          const n = Math.round(e * t);
          return new (l())(n / t).toFraction(!0);
        }
        function j(e) {
          if (!e) return {
            label: "",
            value: null
          };
          let t, n;
          const r = function (e) {
            switch (e) {
              case "whole":
                return "1";
              case "oneDp":
                return "0.1";
              case "twoDp":
                return "0.001";
              case "threeDp":
              case "fourDp":
                return "0.0001";
              default:
                return null;
            }
          }(e.precision) || e.precision;
          if (["1", "0.1", "0.01", "0.001", "0.0001"].includes(r)) {
            const o = function (e) {
              switch (e) {
                case "1":
                default:
                  return 0;
                case "0.1":
                  return 1;
                case "0.01":
                  return 2;
                case "0.001":
                  return 3;
                case "0.0001":
                  return 4;
              }
            }(r);
            t = Number(e.scale.fromValue).toFixed(o), n = Number(e.scale.toValue).toFixed(o);
          } else if (["1/2", "1/4", "1/8", "1/16"].includes(r)) {
            const o = Number(r.split("/")[1]);
            t = R(e.scale.fromValue, o), n = R(e.scale.toValue, o);
          }
          return {
            label: e.name || `${t} ${e.scale.unitFrom} : ${n} ${e.scale.unitTo}`,
            value: e
          };
        }
        const B = (0, c.vU)({
            unit: {
              id: "unit",
              defaultMessage: "Unit",
              description: "Unit"
            },
            scalesDropdown: {
              id: "scalesDropdown",
              defaultMessage: "Scales dropdown",
              description: "Scales dropdown"
            },
            editAddNewScale: {
              id: "editAddNewScale",
              defaultMessage: "Edit or add new scale",
              description: "Edit or add new scale"
            },
            useCalibrationTool: {
              id: "useCalibrationTool",
              defaultMessage: "Use calibration tool",
              description: "Use calibration tool"
            }
          }),
          N = function (e) {
            var t;
            let {
              frameWindow: r,
              selectedAnnotation: o,
              onAnnotationScaleUpdate: a,
              selectedAnnotations: s
            } = e;
            const l = (0, d.v9)(e => e.measurementScales),
              p = (0, d.v9)(e => e.activeMeasurementScale),
              h = (0, d.I0)(),
              {
                formatMessage: x
              } = (0, c.YB)(),
              C = u.useMemo(() => function (e, t) {
                if (t && e) return null == e ? void 0 : e.find(e => {
                  var n, r, o, i;
                  const a = e.precision === t.measurementPrecision,
                    s = e.scale.fromValue === (null === (n = t.measurementScale) || void 0 === n ? void 0 : n.fromValue),
                    l = e.scale.toValue === (null === (r = t.measurementScale) || void 0 === r ? void 0 : r.toValue),
                    u = e.scale.unitFrom === (null === (o = t.measurementScale) || void 0 === o ? void 0 : o.unitFrom),
                    c = e.scale.unitTo === (null === (i = t.measurementScale) || void 0 === i ? void 0 : i.unitTo);
                  return a && s && l && u && c;
                });
              }(l, o) || p, [l, o, p]),
              E = u.useCallback((0, w.zx)(x, "measurement", 200), [x]),
              z = u.useMemo(() => !!s && (0, f.mq)(s), [s]),
              I = u.useMemo(() => function (e, t, n) {
                if (!e) return [];
                const r = e.map(e => j(e));
                return t ? [...r, {
                  label: n,
                  value: n
                }] : r;
              }(l, z, x(M.Z.mixed)), [z, x, l]),
              R = u.useCallback(e => {
                if (e.value !== x(M.Z.mixed)) if (o) {
                  const {
                      value: t
                    } = e,
                    {
                      precision: n,
                      scale: r
                    } = t,
                    {
                      fromValue: o,
                      toValue: i,
                      unitFrom: s,
                      unitTo: l
                    } = r;
                  null == a || a({
                    measurementPrecision: n,
                    measurementScale: new g.Z({
                      fromValue: Number(o),
                      toValue: Number(i),
                      unitFrom: s,
                      unitTo: l
                    })
                  });
                } else h((0, b.Se)(e.value));
              }, [h, x, a, o]);
            if (!l) return null;
            if (!C) return u.createElement("div", {
              className: T().warningButton,
              onClick: () => h((0, k.PR)())
            }, u.createElement(A.Z, {
              src: n(42744),
              role: "presentation",
              className: T().warningButtonIcon
            }), u.createElement("span", {
              className: T().radioButtonWarningLabel
            }, x(m.s.setScale)));
            function N() {
              (0, d.dC)(() => {
                h((0, b.Xh)(!0)), h((0, y.Ds)("distance")), h((0, k.yg)(O.Z, v.A.DISTANCE));
              });
            }
            return u.createElement("div", {
              className: _().scaleDropdownContainer
            }, u.createElement("div", {
              className: i()(S().nativeDropdown, _().nativeButton)
            }, u.createElement("select", {
              "aria-label": x(B.scalesDropdown),
              value: z ? x(M.Z.mixed) : null === (t = I.find(e => JSON.stringify(e.value) === JSON.stringify(C))) || void 0 === t ? void 0 : t.label,
              className: i()("PSPDFKit-Input-Dropdown-Select", "PSPDFKit-Scales-Dropdown"),
              onChange: e => {
                const t = e.target.value;
                "editAddScale" === t ? h((0, k.PR)()) : "calibrationTool" === t ? N() : R(I.find(e => e.label === t));
              }
            }, null == I ? void 0 : I.map(e => u.createElement("option", {
              key: e.label,
              value: e.label
            }, e.label)), u.createElement("option", {
              key: x(B.editAddNewScale),
              value: "editAddScale"
            }, x(B.editAddNewScale), "..."), u.createElement("option", {
              key: x(B.useCalibrationTool),
              value: "calibrationTool"
            }, x(B.useCalibrationTool), "..."))), u.createElement(P.Z, {
              items: I,
              value: z ? {
                label: x(M.Z.mixed),
                value: x(M.Z.mixed)
              } : I.find(e => JSON.stringify(e.value) === JSON.stringify(C)),
              accessibilityLabel: x(B.scalesDropdown),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: i()(S().dropdownGroupComponent, "PSPDFKit-Measurement-Popover-Precision-Dropdown", "PSPDFKit-Scales-Dropdown"),
              menuClassName: i()(S().dropdownGroupMenu, D().measurementDropdownText),
              ButtonComponent: E,
              ItemComponent: L,
              onSelect: (e, t) => R(t),
              frameWindow: r
            }, u.createElement("div", {
              className: F().scalesDropdownItem,
              onClick: () => h((0, k.PR)())
            }, x(B.editAddNewScale), "..."), u.createElement("div", {
              className: F().scalesDropdownItem,
              onClick: () => {
                N();
              }
            }, x(B.useCalibrationTool), "...")));
          },
          L = e => {
            let {
              item: t,
              state: n,
              itemComponentProps: r,
              ref: o
            } = e;
            return u.createElement(V, {
              item: t,
              state: n,
              itemComponentProps: r,
              ref: o
            });
          },
          V = u.forwardRef((e, t) => {
            var n;
            let {
              item: o,
              state: s,
              itemComponentProps: l,
              width: c
            } = e;
            return u.createElement(a.Z, (0, r.Z)({
              is: "div",
              className: i()(D().item, F().item, {
                [D().isSelected]: (null == s ? void 0 : s.includes("selected")) || (null == s ? void 0 : s.includes("focused"))
              }),
              name: null !== (n = null == o ? void 0 : o.value) && void 0 !== n ? n : null == o ? void 0 : o.label,
              style: {
                width: c
              },
              ref: t
            }, l), null != s && s.includes("selected") ? u.createElement(A.Z, {
              src: h(),
              className: F().icon
            }) : u.createElement("span", {
              className: F().icon
            }), null == o ? void 0 : o.label);
          });
      },
      17766: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => a,
          Z: () => i
        });
        var r = n(35782),
          o = n(60379);
        const i = (0, r.vU)({
            color: {
              id: "color",
              defaultMessage: "Color",
              description: "Color"
            },
            fillColor: {
              id: "fillColor",
              defaultMessage: "Fill Color",
              description: "Background color"
            },
            newColor: {
              id: "newColor",
              defaultMessage: "New Color",
              description: "New Custom Color"
            },
            [o.Z.BLACK.toCSSValue()]: {
              id: "black",
              defaultMessage: "Black",
              description: "Black, the color"
            },
            [o.Z.WHITE.toCSSValue()]: {
              id: "white",
              defaultMessage: "White",
              description: "White, the color"
            },
            [o.Z.BLUE.toCSSValue()]: {
              id: "blue",
              defaultMessage: "Blue",
              description: "Blue, the color"
            },
            [o.Z.RED.toCSSValue()]: {
              id: "red",
              defaultMessage: "Red",
              description: "Red, the color"
            },
            [o.Z.GREEN.toCSSValue()]: {
              id: "green",
              defaultMessage: "Green",
              description: "Green, the color"
            },
            [o.Z.ORANGE.toCSSValue()]: {
              id: "orange",
              defaultMessage: "Orange",
              description: "Orange, the color"
            },
            [o.Z.LIGHT_BLUE.toCSSValue()]: {
              id: "lightBlue",
              defaultMessage: "Light Blue",
              description: "Light Blue color"
            },
            [o.Z.LIGHT_RED.toCSSValue()]: {
              id: "lightRed",
              defaultMessage: "Light Red",
              description: "Light Red color"
            },
            [o.Z.LIGHT_GREEN.toCSSValue()]: {
              id: "lightGreen",
              defaultMessage: "Light Green",
              description: "Light Green color"
            },
            [o.Z.LIGHT_YELLOW.toCSSValue()]: {
              id: "yellow",
              defaultMessage: "Yellow",
              description: "Yellow color"
            },
            opacity: {
              id: "opacity",
              defaultMessage: "Opacity",
              description: "Opacity"
            },
            thickness: {
              id: "thickness",
              defaultMessage: "Thickness",
              description: "Thickness of a line"
            },
            "linecaps-dasharray": {
              id: "linecaps-dasharray",
              defaultMessage: "Line Style",
              description: "Select line caps and dash pattern of lines"
            },
            linestyle: {
              id: "dasharray",
              defaultMessage: "Line style",
              description: "Select line style"
            },
            borderStyle: {
              id: "borderStyle",
              defaultMessage: "Border style",
              description: "Select border style"
            },
            borderColor: {
              id: "borderColor",
              defaultMessage: "Border color",
              description: "Select border color"
            },
            font: {
              id: "font",
              defaultMessage: "Font",
              description: "Font"
            },
            fontSize: {
              id: "fontSize",
              defaultMessage: "Font size",
              description: "Font size selection"
            },
            fonts: {
              id: "fonts",
              defaultMessage: "Fonts",
              description: "Fonts"
            },
            allFonts: {
              id: "allFonts",
              defaultMessage: "All Fonts",
              description: "Used when presenting a list of fonts"
            },
            fontFamilyUnsupported: {
              id: "fontFamilyUnsupported",
              defaultMessage: "{arg0} (not supported)",
              description: "Font family (type) is not supported"
            },
            alignment: {
              id: "alignment",
              defaultMessage: "Alignment",
              description: "Alignment (left, center, right, top, middle, bottom)"
            },
            alignmentRight: {
              id: "alignmentRight",
              defaultMessage: "Right",
              description: "Right alignment"
            },
            alignmentLeft: {
              id: "alignmentLeft",
              defaultMessage: "Left",
              description: "Left alignment"
            },
            alignmentCenter: {
              id: "alignmentCenter",
              defaultMessage: "center",
              description: "Center alignment"
            },
            verticalAlignment: {
              id: "verticalAlignment",
              defaultMessage: "Vertical Alignment",
              description: "Vertical Alignment (top, center, bottom)"
            },
            horizontalAlignment: {
              id: "horizontalAlignment",
              defaultMessage: "Horizontal Alignment",
              description: "Horizontal Alignment (left, center, right)"
            },
            size: {
              id: "size",
              defaultMessage: "Size",
              description: "Used to label sizes (eg. font)"
            },
            numberInPt: {
              id: "numberInPt",
              defaultMessage: "{arg0} pt",
              description: "A number in pt (points). eg. 10pt"
            },
            startLineCap: {
              id: "startLineCap",
              defaultMessage: "Line Start",
              description: 'Start line cap marker. eg. "open arrow"'
            },
            strokeDashArray: {
              id: "strokeDashArray",
              defaultMessage: "Line Style",
              description: "Line Style"
            },
            endLineCap: {
              id: "endLineCap",
              defaultMessage: "Line End",
              description: 'End line cap marker. eg. "open arrow"'
            },
            edit: {
              id: "edit",
              defaultMessage: "Edit",
              description: "Generic edit label"
            },
            save: {
              id: "save",
              defaultMessage: "Save",
              description: "Generic save label"
            },
            saveAs: {
              id: "saveAs",
              defaultMessage: "Save As...",
              description: 'Generic "save as" label'
            },
            export: {
              id: "export",
              defaultMessage: "Export",
              description: 'Generic "export" label'
            },
            delete: {
              id: "delete",
              defaultMessage: "Delete",
              description: "Generic delete label"
            },
            cancel: {
              id: "cancel",
              defaultMessage: "Cancel",
              description: "Cancel"
            },
            ok: {
              id: "ok",
              defaultMessage: "OK",
              description: "Ok, usually used to confirm an action"
            },
            close: {
              id: "close",
              defaultMessage: "Close",
              description: 'Generic, usually to close something. "something" can be inferred from the context in which the message appears'
            },
            done: {
              id: "done",
              defaultMessage: "Done",
              description: 'Generic "done" message. Usually used in a button.'
            },
            annotationsCount: {
              id: "annotationsCount",
              defaultMessage: "{arg0, plural,\n      =0 {{arg0} Annotations}\n      one {{arg0} Annotation}\n      two {{arg0} Annotations}\n      other {{arg0} Annotations}\n    }",
              description: "Amount of annotations."
            },
            annotations: {
              id: "annotations",
              defaultMessage: "Annotations",
              description: "PDF Annotations"
            },
            bookmark: {
              id: "bookmark",
              defaultMessage: "Bookmark",
              description: "PDF Bookmark"
            },
            bookmarks: {
              id: "bookmarks",
              defaultMessage: "Bookmarks",
              description: "PDF Bookmarks"
            },
            annotation: {
              id: "annotation",
              defaultMessage: "Annotation",
              description: "Annotation"
            },
            selectedAnnotation: {
              id: "selectedAnnotation",
              defaultMessage: "selected {arg0}",
              description: "Selected Annotation"
            },
            selectedAnnotationWithText: {
              id: "selectedAnnotationWithText",
              defaultMessage: "Selected {arg0} with {arg1} as content",
              description: "Selected Text or Note Annotation"
            },
            noteAnnotation: {
              id: "noteAnnotation",
              defaultMessage: "Note",
              description: "Text Note Annotation"
            },
            comment: {
              id: "comment",
              defaultMessage: "Comment",
              description: "Comment"
            },
            commentAction: {
              id: "commentAction",
              defaultMessage: "Comment",
              description: "Comment"
            },
            comments: {
              id: "comments",
              defaultMessage: "Comments",
              description: "Comments"
            },
            textAnnotation: {
              id: "textAnnotation",
              defaultMessage: "Text",
              description: "Free Text Annotation"
            },
            calloutAnnotation: {
              id: "calloutAnnotation",
              defaultMessage: "Callout",
              description: "Free Text Annotation (Callout)"
            },
            pen: {
              id: "pen",
              defaultMessage: "Drawing",
              description: "Ink Annotation used to do freehand drawing."
            },
            eraser: {
              id: "eraser",
              defaultMessage: "Ink Eraser",
              description: "Ink Eraser tool to remove ink annotations points by hand."
            },
            inkAnnotation: {
              id: "inkAnnotation",
              defaultMessage: "Drawing",
              description: "Ink Annotation used to do freehand drawing."
            },
            highlighterAnnotation: {
              id: "highlighterAnnotation",
              defaultMessage: "Freeform Highlight",
              description: "Ink Annotation used to highlight content."
            },
            highlightAnnotation: {
              id: "highlightAnnotation",
              defaultMessage: "Text Highlight",
              description: "Highlight Annotation used to select and mark text."
            },
            underlineAnnotation: {
              id: "underlineAnnotation",
              defaultMessage: "Underline",
              description: "Undeline Annotation used to select and mark text."
            },
            squiggleAnnotation: {
              id: "squiggleAnnotation",
              defaultMessage: "Squiggle",
              description: "Squiggle Annotation used to select and mark text."
            },
            strikeOutAnnotation: {
              id: "strikeOutAnnotation",
              defaultMessage: "Strikethrough",
              description: "StrikeOut Annotation used to select and mark text."
            },
            lineAnnotation: {
              id: "lineAnnotation",
              defaultMessage: "Line",
              description: "Shape Annotation used to draw straight lines."
            },
            arrowAnnotation: {
              id: "arrowAnnotation",
              defaultMessage: "Arrow",
              description: "Shape Annotation used to draw an arrow."
            },
            rectangleAnnotation: {
              id: "rectangleAnnotation",
              defaultMessage: "Rectangle",
              description: "Shape Annotation used to draw rectangles."
            },
            ellipseAnnotation: {
              id: "ellipseAnnotation",
              defaultMessage: "Ellipse",
              description: "Shape Annotation used to draw ellipses."
            },
            polygonAnnotation: {
              id: "polygonAnnotation",
              defaultMessage: "Polygon",
              description: "Shape Annotation used to draw polygons."
            },
            polylineAnnotation: {
              id: "polylineAnnotation",
              defaultMessage: "Polyline",
              description: "Shape Annotation used to draw polylines."
            },
            imageAnnotation: {
              id: "imageAnnotation",
              defaultMessage: "Image",
              description: "Image Annotation"
            },
            stampAnnotation: {
              id: "stampAnnotation",
              defaultMessage: "Stamp",
              description: "Stamp Annotation"
            },
            redactionAnnotation: {
              id: "redactionAnnotation",
              defaultMessage: "Redaction",
              description: "Redaction Annotation"
            },
            unknownAnnotation: {
              id: "unknownAnnotation",
              defaultMessage: "Unknown",
              description: "Unknown Annotation"
            },
            arrow: {
              id: "arrow",
              defaultMessage: "Line with arrow",
              description: "Shape Annotation used to draw straight lines with an arrow."
            },
            highlighter: {
              id: "highlighter",
              defaultMessage: "Freeform Highlight",
              description: "Ink Annotation used to highlight content with freehand drawing."
            },
            icon: {
              id: "icon",
              defaultMessage: "Icon",
              description: "Label for when users need to select an icon"
            },
            pageXofY: {
              id: "pageXofY",
              defaultMessage: "Page {arg0} of {arg1}",
              description: "Page indicator."
            },
            pageX: {
              id: "pageX",
              defaultMessage: "Page {arg0}",
              description: "Page number"
            },
            searchDocument: {
              id: "searchDocument",
              defaultMessage: "Search Document",
              description: "Search document (for text)"
            },
            sign: {
              id: "sign",
              defaultMessage: "Sign",
              description: "Label for a signature field"
            },
            signed: {
              id: "signed",
              defaultMessage: "Signed",
              description: "Label for a signed field"
            },
            signatures: {
              id: "signatures",
              defaultMessage: "Signatures",
              description: "Signatures title"
            },
            blendMode: {
              id: "blendMode",
              defaultMessage: "Blend Mode",
              description: "Blend Mode"
            },
            linesCount: {
              id: "linesCount",
              defaultMessage: "{arg0, plural,\n      =0 {{arg0} Lines}\n      one {{arg0} Line}\n      two {{arg0} Lines}\n      other {{arg0} Lines}\n    }",
              description: "Amount of lines (for example in a ink annotation)."
            },
            filePath: {
              id: "filePath",
              defaultMessage: "File Path",
              description: "Location of a file or file name"
            },
            useAnExistingStampDesign: {
              id: "useAnExistingStampDesign",
              defaultMessage: "Use an existing stamp design",
              description: "Use an existing stamp design"
            },
            customStamp: {
              id: "customStamp",
              defaultMessage: "Custom Stamp",
              description: "Custom Stamp"
            },
            stampText: {
              id: "stampText",
              defaultMessage: "Stamp Text",
              description: "Stamp Text"
            },
            clear: {
              id: "clear",
              defaultMessage: "Clear",
              description: "Clear"
            },
            date: {
              id: "date",
              defaultMessage: "Date",
              description: "Date."
            },
            time: {
              id: "time",
              defaultMessage: "Time",
              description: "Time."
            },
            sidebar: {
              id: "sidebar",
              defaultMessage: "Sidebar",
              description: "Generic label for a sidebar"
            },
            gotoPageX: {
              id: "gotoPageX",
              defaultMessage: "Go to Page {arg0}",
              description: "Go to a page"
            },
            name: {
              id: "name",
              defaultMessage: "Name",
              description: "Name field usually."
            },
            chooseColor: {
              id: "chooseColor",
              defaultMessage: "Choose Color",
              description: "Choose color from the UI."
            },
            textHighlighter: {
              id: "textHighlighter",
              defaultMessage: "Text highlighter",
              description: "Highlighter tool used to highlight selected text."
            },
            undo: {
              id: "undo",
              defaultMessage: "Undo",
              description: "Undo last action."
            },
            redo: {
              id: "redo",
              defaultMessage: "Redo",
              description: "Redo last undone action."
            },
            showMore: {
              id: "showMore",
              defaultMessage: "Show More",
              description: "Show more"
            },
            showLess: {
              id: "showLess",
              defaultMessage: "Show Less",
              description: "Show Less"
            },
            nMoreComments: {
              id: "nMoreComments",
              defaultMessage: "{arg0, plural,\none {{arg0} more comment}\nother {{arg0} more comments}\n}",
              description: "n more comments"
            },
            documentEditor: {
              id: "documentEditor",
              defaultMessage: "Document Editor",
              description: "Document Editor toolbar label"
            },
            areaRedaction: {
              id: "areaRedaction",
              defaultMessage: "Area Redaction",
              description: "Area Redaction toolbar item label"
            },
            textRedaction: {
              id: "textRedaction",
              defaultMessage: "Text Redaction",
              description: "Text Redaction toolbar item label"
            },
            outlineColor: {
              id: "outlineColor",
              defaultMessage: "Outline Color",
              description: "Outline color"
            },
            overlayText: {
              id: "overlayText",
              defaultMessage: "Overlay text",
              description: "Overlay text"
            },
            insertOverlayText: {
              id: "overlayTextPlaceholder",
              defaultMessage: "Insert overlay text",
              description: "Overlay Text property placeholder"
            },
            repeatText: {
              id: "repeatText",
              defaultMessage: "Repeat text",
              description: "Repeat text placeholder"
            },
            preview: {
              id: "preview",
              defaultMessage: "Preview",
              description: "Preview"
            },
            markupToolbar: {
              id: "markupAnnotationToolbar",
              defaultMessage: "Markup annotation toolbar",
              description: "Label for the markup annotation toolbar popover"
            },
            documentViewport: {
              id: "documentViewport",
              defaultMessage: "document viewport",
              description: "Label for document viewport region"
            },
            top: {
              id: "top",
              defaultMessage: "Top",
              description: "Top"
            },
            bottom: {
              id: "bottom",
              defaultMessage: "Bottom",
              description: "Bottom"
            },
            resize: {
              id: "resize",
              defaultMessage: "Resize",
              description: "Resize action when an annotation is selected."
            },
            resizeHandleTop: {
              id: "resizeHandleTop",
              defaultMessage: "top",
              description: "One of the top resize handlers."
            },
            resizeHandleBottom: {
              id: "resizeHandleBottom",
              defaultMessage: "bottom",
              description: "One of the bottom resize handlers."
            },
            resizeHandleLeft: {
              id: "resizeHandleLeft",
              defaultMessage: "left",
              description: "One of the left resize handlers."
            },
            resizeHandleRight: {
              id: "resizeHandleRight",
              defaultMessage: "right",
              description: "One of the right resize handlers."
            },
            cropAll: {
              id: "cropAll",
              defaultMessage: "Crop All",
              description: "Crop all pages."
            },
            cropAllPages: {
              id: "cropAllPages",
              defaultMessage: "Crop All Pages",
              description: "Crop all pages."
            },
            cropCurrent: {
              id: "cropCurrent",
              defaultMessage: "Crop Current",
              description: "Crop current page."
            },
            cropCurrentPage: {
              id: "cropCurrentPage",
              defaultMessage: "Crop Current Page",
              description: "Crop current page."
            },
            documentCrop: {
              id: "documentCrop",
              defaultMessage: "Document Crop",
              description: "Crop document pages."
            },
            documentComparison: {
              id: "documentComparison",
              defaultMessage: "Document Comparison",
              description: "Compare two documents."
            },
            rotateCounterclockwise: {
              id: "rotateCounterclockwise",
              defaultMessage: "Rotate counterclockwise",
              description: "Label for the rotate counterclockwise button"
            },
            rotateClockwise: {
              id: "rotateClockwise",
              defaultMessage: "Rotate clockwise",
              description: "Label for the rotate clockwise button"
            },
            rotation: {
              id: "rotation",
              defaultMessage: "Rotate",
              description: "Label for the rotate button"
            },
            applyRedactions: {
              id: "applyRedactions",
              defaultMessage: "Apply Redactions",
              description: "Applies redactions to document"
            },
            cloudyRectangleAnnotation: {
              id: "cloudyRectangleAnnotation",
              defaultMessage: "Cloudy Rectangle",
              description: "Cloudy Rectangle"
            },
            dashedRectangleAnnotation: {
              id: "dashedRectangleAnnotation",
              defaultMessage: "Dashed Rectangle",
              description: "Dashed Rectangle"
            },
            cloudyEllipseAnnotation: {
              id: "cloudyEllipseAnnotation",
              defaultMessage: "Cloudy Ellipse",
              description: "Cloudy Ellipse"
            },
            dashedEllipseAnnotation: {
              id: "dashedEllipseAnnotation",
              defaultMessage: "Dashed Ellipse",
              description: "Dashed Ellipse"
            },
            cloudyPolygonAnnotation: {
              id: "cloudyPolygonAnnotation",
              defaultMessage: "Cloudy Polygon",
              description: "Cloudy Polygon"
            },
            dashedPolygonAnnotation: {
              id: "dashedPolygonAnnotation",
              defaultMessage: "Dashed Polygon",
              description: "Dashed Polygon"
            },
            cloudAnnotation: {
              id: "cloudAnnotation",
              defaultMessage: "Cloud",
              description: "Cloud Annotation"
            },
            addSignature: {
              id: "addSignature",
              defaultMessage: "Add Signature",
              description: "Add Signature"
            },
            storeSignature: {
              id: "storeSignature",
              defaultMessage: "Store Signature",
              description: "Store the signature that is in creation"
            },
            clearSignature: {
              id: "clearSignature",
              defaultMessage: "Clear Signature",
              description: "Clear the signature canvas"
            },
            button: {
              id: "button",
              defaultMessage: "Button Field",
              description: "Button Field"
            },
            textField: {
              id: "textField",
              defaultMessage: "Text Field",
              description: "Text Field"
            },
            radioField: {
              id: "radioField",
              defaultMessage: "Radio Field",
              description: "Radio Field"
            },
            checkboxField: {
              id: "checkboxField",
              defaultMessage: "Checkbox Field",
              description: "Checkbox Field"
            },
            comboBoxField: {
              id: "comboBoxField",
              defaultMessage: "Combo Box Field",
              description: "Combo Box Field"
            },
            listBoxField: {
              id: "listBoxField",
              defaultMessage: "List Box Field",
              description: "List Box Field"
            },
            signatureField: {
              id: "signatureField",
              defaultMessage: "Signature Field",
              description: "Signature Field"
            },
            dateField: {
              id: "dateField",
              defaultMessage: "Date Field",
              description: "Date Field"
            },
            formCreator: {
              id: "formCreator",
              defaultMessage: "Form Creator",
              description: "Create, edit or Delete widget annotations."
            },
            mediaAnnotation: {
              id: "mediaAnnotation",
              defaultMessage: "Media Annotation",
              description: "Media Annotation"
            },
            mediaFormatNotSupported: {
              id: "mediaFormatNotSupported",
              defaultMessage: "This browser does not support embedded medias.",
              description: "The browser does not support embedded medias"
            },
            contentEditor: {
              id: "contentEditor",
              defaultMessage: "Content Editor",
              description: "Content Editor"
            },
            saveAndClose: {
              id: "saveAndClose",
              defaultMessage: "Save & Close",
              description: "Save changes"
            },
            none: {
              id: "none",
              defaultMessage: "None",
              description: "Normal line"
            },
            linkAnnotation: {
              id: "linkAnnotation",
              defaultMessage: "Link",
              description: "Link Annotation"
            },
            measurement: {
              id: "measurement",
              defaultMessage: "Measurement",
              description: "Measurement"
            },
            Snapping: {
              id: "Snapping",
              defaultMessage: "Snapping",
              description: "Snapping"
            },
            distanceMeasurement: {
              id: "distanceMeasurement",
              defaultMessage: "Distance",
              description: "Measurement Annotation used to measure distance between 2 points"
            },
            multiAnnotationsSelection: {
              id: "multiAnnotationsSelection",
              defaultMessage: "Select Multiple Annotations",
              description: "Multiple annotations selection tool used to enable selection of multiple annotations."
            },
            rectangularAreaMeasurement: {
              id: "rectangularAreaMeasurement",
              defaultMessage: "Rectangle Area",
              description: "Measurement Annotation used to measure rectangle areas."
            },
            ellipseAreaMeasurement: {
              id: "ellipseAreaMeasurement",
              defaultMessage: "Ellipse Area",
              description: "Measurement Annotation used to measure elliptical areas."
            },
            polygonAreaMeasurement: {
              id: "polygonAreaMeasurement",
              defaultMessage: "Polygon Area",
              description: "Measurement Annotation used to measure polygon areas."
            },
            perimeterMeasurement: {
              id: "perimeterMeasurement",
              defaultMessage: "Perimeter",
              description: "Measure Annotation used to measure perimeter."
            },
            bold: {
              id: "bold",
              defaultMessage: "Bold",
              description: "Bold text"
            },
            italic: {
              id: "italic",
              defaultMessage: "Italic",
              description: "Italic text"
            },
            underline: {
              id: "underline",
              defaultMessage: "Underline",
              description: "Underline"
            },
            discard: {
              id: "discardChanges",
              defaultMessage: "Discard Changes",
              description: "Discard"
            },
            anonymous: {
              id: "anonymous",
              defaultMessage: "Anonymous",
              description: "Anonymous"
            },
            loading: {
              id: "loading",
              defaultMessage: "Loading...",
              description: "Shown while the document is being fetched"
            },
            group: {
              id: "group",
              defaultMessage: "Group",
              description: "Group annotations."
            },
            ungroup: {
              id: "ungroup",
              defaultMessage: "Ungroup",
              description: "Ungroup annotations."
            },
            mixedMeasurements: {
              id: "mixedMeasurements",
              defaultMessage: "Mixed Measurements",
              description: "Mixed Measurements"
            },
            mixed: {
              id: "mixed",
              defaultMessage: "Mixed",
              description: "Mixed"
            },
            back: {
              id: "back",
              defaultMessage: "Back",
              description: "back"
            },
            readOnlyAnnotationFlag: {
              id: "readOnly",
              defaultMessage: "Read-only",
              description: "this annotation is read only"
            },
            lockedContents: {
              id: "lockedContents",
              defaultMessage: "Locked Contents",
              description: "this annotation has its contents locked"
            },
            locked: {
              id: "locked",
              defaultMessage: "Locked",
              description: "this annotation is locked"
            },
            selectImage: {
              id: "selectImage",
              defaultMessage: "Select image",
              description: "Selects an image from the local file system"
            },
            layers: {
              id: "layers",
              defaultMessage: "Layers",
              description: "OCG layers sidebar header title"
            },
            noLayers: {
              id: "noLayers",
              defaultMessage: "No Layers",
              description: "Message shown when there are no OCG layers in the document"
            },
            custom: {
              id: "custom",
              defaultMessage: "Custom",
              description: "Custom"
            },
            documentAI: {
              id: "documentAI",
              defaultMessage: "Document AI",
              description: "Document AI"
            }
          }),
          a = (0, r.vU)({
            numberValidationBadFormat: {
              id: "numberValidationBadFormat",
              defaultMessage: "The value entered does not match the format of the field [{arg0}]",
              description: "The number form field value format is wrong."
            },
            dateValidationBadFormat: {
              id: "dateValidationBadFormat",
              defaultMessage: "Invalid date/time: please ensure that the date/time exists. Field [{arg0}] should match format {arg1}",
              description: "The date form field value format is wrong."
            }
          });
      },
      67260: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => f,
          z: () => h
        });
        var r = n(31672),
          o = n(35782),
          i = n(67294),
          a = n(94184),
          s = n.n(a),
          l = n(17766),
          u = n(72113),
          c = n(68540),
          d = n(91414),
          p = n.n(d);
        function h(e) {
          let {
            backdropFixed: t = !0,
            onCancel: n,
            onConfirm: a,
            accessibilityLabel: d,
            accessibilityDescription: h,
            restoreOnClose: f,
            children: m
          } = e;
          const {
              formatMessage: g
            } = (0, o.YB)(),
            v = (0, c.Je)();
          return i.createElement(u.Z, {
            role: "alertdialog",
            onEscape: n,
            background: "rgba(0,0,0,.1)",
            className: "PSPDFKit-Confirm-Dialog",
            accessibilityLabel: d || "Confirm Dialog",
            accessibilityDescription: h,
            restoreOnClose: f,
            backdropFixed: t,
            visibleDimensions: v
          }, i.createElement(u.Z.Section, {
            style: {
              paddingBottom: 0
            }
          }, i.createElement("div", {
            className: `${p().content} PSPDFKit-Confirm-Dialog-Content`
          }, m)), i.createElement(u.Z.Section, null, i.createElement(r.hE, {
            className: "PSPDFKit-Confirm-Dialog-Buttons",
            align: "end"
          }, i.createElement(r.zx, {
            autoFocus: !0,
            onClick: n,
            className: s()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Cancel", p().button)
          }, g(l.Z.cancel)), i.createElement(r.zx, {
            onClick: a,
            primary: !0,
            className: s()("PSPDFKit-Confirm-Dialog-Button", "PSPDFKit-Confirm-Dialog-Button-Confirm", p().button)
          }, g(l.Z.delete)))));
        }
        const f = h;
      },
      15164: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => D
        });
        var r = n(67294),
          o = n(29911),
          i = n(54537),
          a = n(45249);
        function s(e) {
          const {
              backend: t,
              onInitialRenderFinished: n,
              pageIndex: o,
              pageSize: s,
              pageKey: l,
              renderPageCallback: u,
              zoomLevel: c,
              scaleFactor: d
            } = e,
            p = r.useRef(!1),
            h = r.useCallback(function () {
              p.current || (p.current = !0, n && n());
            }, [n]),
            f = r.useMemo(function () {
              return new a.UL({
                width: Math.ceil(s.width * d),
                height: Math.ceil(s.height * d)
              });
            }, [s, d]),
            m = e.inContentEditorMode || !1;
          return r.createElement("div", {
            style: {
              transform: `scale(${c / d})`,
              transformOrigin: "0 0"
            },
            key: l,
            className: "PSPDFKit-PageOverview-Tile"
          }, r.createElement(i.Z, {
            backend: t,
            pageIndex: o,
            scaledPageSize: f,
            originalPageSize: s,
            onRenderFinished: h,
            rect: f,
            renderPageCallback: u,
            pageKey: l,
            hasInitialRenderFinished: p.current,
            inContentEditorMode: m
          }));
        }
        var l = n(19181),
          u = n(22122),
          c = n(93113),
          d = n(44077),
          p = n(10983);
        function h(e) {
          let {
            backend: t,
            viewportState: n,
            page: o,
            tileSize: a,
            tileOverlapping: s,
            scale: l,
            renderPageCallback: d,
            tilesRenderedCallback: h,
            contentState: m,
            crispTiles: g,
            inContentEditorMode: v,
            tilesClassName: y
          } = e;
          const {
              pageIndex: b,
              pageSize: w,
              pageKey: x
            } = o,
            [D, C] = function (e, t, n, o, i, a, s) {
              const [l, u] = r.useState({}),
                d = r.useRef([]),
                h = r.useMemo(function () {
                  return function (e, t, n, r, o, i, a) {
                    const {
                        viewportRect: s
                      } = e,
                      l = (0, c.Ek)(e, o),
                      u = s.apply(l).scale(a).round(),
                      d = t.scale(a).ceil(),
                      h = {};
                    f(h, u, d, n, r, i, a);
                    const m = s.grow(Math.min(p.pK, n)).apply(l).scale(a).round();
                    return f(h, m, d, n, r, i, a);
                  }(e, t, n, o, i, a, s);
                }, [i, a, t, s, o, n, e]);
              r.useLayoutEffect(function () {
                u(e => function (e, t, n) {
                  const r = {};
                  for (const n of t) r[n] = e[n];
                  for (const e in n) r[e] = n[e];
                  return r;
                }(e, d.current, h));
              }, [h]);
              return [r.useMemo(function () {
                return function (e) {
                  const t = [];
                  for (const n in e) {
                    const r = e[n],
                      {
                        scale: o
                      } = r;
                    let i = t.find(function (e) {
                      return e[0] === o;
                    });
                    if (void 0 === i) {
                      let e;
                      for (i = [o, []], e = 0; e < t.length && t[e][0] < o; e++);
                      t.splice(e, 0, i);
                    }
                    i[1].push(r);
                  }
                  return t;
                }(l);
              }, [l]), function (e) {
                if (!l.hasOwnProperty(e)) return void 0;
                const t = Object.keys(l).length;
                d.current.length + 1 >= t ? (d.current = Object.keys(h), u(h)) : d.current.push(e);
              }];
            }(n, w, a, s, b, x, l);
          return r.createElement(r.Fragment, null, D.map(e => {
            let [a, s] = e;
            const l = w,
              c = l.scale(a).ceil();
            return r.createElement("div", {
              key: a
            }, s.map(e => r.createElement(i.Z, (0, u.Z)({
              key: e.key,
              rect: e.rect,
              pageIndex: b,
              originalPageSize: l,
              scaledPageSize: c,
              backend: t,
              renderPageCallback: d,
              onRenderFinished: () => {
                C(e.key), h();
              },
              pageKey: o.pageKey,
              crisp: g,
              inContentEditorMode: v
            }, m, {
              tileScale: n.zoomLevel / a,
              tilesClassName: y
            }))));
          }));
        }
        function f(e, t, n, r, o, i, a) {
          for (let s = 0; s <= n.height; s += r) {
            let l = r;
            if (s + l > n.height && (l = Math.floor(n.height - s)), s + l <= t.top || s >= t.bottom || l <= 0) s -= o;else {
              for (let u = 0; u <= n.width; u += r) {
                let c = r;
                if (u + r > n.width && (c = Math.floor(n.width - u)), u + c <= t.left || u >= t.right || c <= 0) {
                  u -= o;
                  continue;
                }
                const p = `${i}-sw${n.width}-sh${n.height}-x${u}-y${s}-w${c}-h${l}`;
                e[p] = {
                  key: p,
                  scale: a,
                  rect: new d.UL({
                    width: c,
                    height: l,
                    left: u,
                    top: s
                  })
                }, u -= o;
              }
              s -= o;
            }
          }
          return e;
        }
        const m = r.memo(h, function (e, t) {
          return e.page.pageKey === t.page.pageKey && !(0, c.pA)(e.viewportState, t.viewportState) && e.inContentEditorMode === t.inContentEditorMode;
        });
        const g = (0, l.x)(function (e) {
          var t;
          return {
            viewportState: e.viewportState,
            backend: e.backend,
            tileSize: "SERVER" === (null === (t = e.backend) || void 0 === t ? void 0 : t.type) ? p.uq : p.Bd,
            tileOverlapping: p.Dx,
            renderPageCallback: e.renderPageCallback
          };
        })(m);
        var v = n(92537),
          y = n(98179);
        var b = n(68540),
          w = n(47460),
          x = n.n(w);
        const D = function (e) {
          const {
              inViewport: t,
              shouldPrerender: n,
              rotation: i,
              backend: a,
              zoomLevel: l,
              renderPageCallback: u,
              page: c,
              onInitialOverviewRenderFinished: d,
              allowedTileScales: p,
              forceDetailView: h,
              renderPagePreview: f,
              isPageSizeReal: m,
              crispTiles: w = !1,
              inContentEditorMode: D,
              contentState: C
            } = e,
            [S, E] = r.useState(!f),
            _ = r.useCallback(function () {
              E(!0), d && d();
            }, [d]),
            P = function (e, t, n) {
              var r;
              let o = (0, v.L)();
              const i = window.navigator,
                a = null == i || null === (r = i.connection) || void 0 === r ? void 0 : r.saveData;
              "STANDALONE" === t.type && y.Ni && o > 2 && (o = 2), "SERVER" === t.type && a && (o = 1);
              const s = e * o;
              return "all" === n ? s : n.reduce((e, t) => e < s ? t : e);
            }(l, a, p),
            k = r.useMemo(() => c.pageSize.floor(), [c.pageSize]),
            A = r.useMemo(function () {
              const t = Math.min((0, v.L)(), 2);
              return Math.min(e.viewportRect.width * t / k.width, 1);
            }, [k.width, e.viewportRect.width]),
            [z, T] = r.useState(!1),
            O = (0, b.R9)(() => {
              z || f || T(!0);
            }),
            I = t && m && (!f || P > 1 || h || l > A) ? r.createElement("div", {
              style: {
                opacity: S ? 1 : 0
              },
              className: "PSPDFKit-PageTilesContainer"
            }, r.createElement(g, {
              contentState: C,
              page: c,
              scale: P,
              key: c.pageKey,
              crispTiles: w,
              tilesRenderedCallback: O,
              inContentEditorMode: D,
              tilesClassName: "PSPDFKit-PageTile"
            })) : null;
          return r.createElement("div", null, (!S || !m || !z && !f) && r.createElement("div", {
            className: `${x().layer} ${x().deadCenter}`
          }, r.createElement(o.Z, {
            scale: 1.5,
            rotate: -i
          })), (t || S || n) && f && m && r.createElement(s, {
            backend: a,
            pageIndex: c.pageIndex,
            pageSize: k,
            pageKey: c.pageKey,
            onInitialRenderFinished: _,
            zoomLevel: l,
            scaleFactor: A,
            renderPageCallback: u,
            inContentEditorMode: D
          }), I);
        };
      },
      54537: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => m
        });
        var r = n(96156),
          o = n(67294),
          i = n(35369),
          a = n(94184),
          s = n.n(a),
          l = n(2877),
          u = n(46364),
          c = n(33427),
          d = n(98179),
          p = n(15743),
          h = n.n(p);
        function f(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class m extends o.PureComponent {
          constructor() {
            super(...arguments), (0, r.Z)(this, "imageFetcherRef", o.createRef()), (0, r.Z)(this, "_fetchImage", () => {
              const {
                  backend: e,
                  originalPageSize: t,
                  scaledPageSize: n,
                  pageIndex: r,
                  rect: o,
                  attachments: a,
                  renderPageCallback: s,
                  digitalSignatures: l
                } = this.props,
                d = (this.props.annotations || (0, i.aV)()).filter(c.bz),
                p = this.props.formFields || (0, i.aV)(),
                h = this.props.formFieldValues || (0, i.aV)(),
                f = l && l.signatures || [],
                m = this.props.inContentEditorMode || !1;
              let g;
              if ((d.size > 0 || h.size > 0) && (g = {
                annotations: d,
                formFieldValues: h,
                formFields: p,
                attachments: a || (0, i.D5)(),
                signatures: f
              }), !n.width || !n.height) return {
                promise: Promise.resolve(null),
                cancel: () => {}
              };
              const {
                cancel: v,
                promise: y
              } = e.corePDFBridge.renderTile(r, n, o, !1, !m, g);
              return (0, u.uZ)(y.then(e => {
                let {
                  element: i
                } = e;
                if ("function" == typeof s) {
                  var a, l;
                  let c;
                  if ("IMG" === i.nodeName) {
                    var u;
                    const e = i,
                      t = document.createElement("canvas");
                    t.width = o.width, t.height = o.height, c = t.getContext("2d"), null === (u = c) || void 0 === u || u.drawImage(e, 0, 0), i = t;
                  }
                  c || (c = i.getContext("2d")), null === (a = c) || void 0 === a || a.translate(-o.left, -o.top), null === (l = c) || void 0 === l || l.scale(n.width / t.width, n.height / t.height), s(c, r, t);
                  const d = document.createElement("img");
                  d.src = i.toDataURL(), e.element = d;
                }
                return e;
              }), v);
            });
          }
          componentDidUpdate(e) {
            const {
                annotations: t,
                formFieldValues: n
              } = this.props,
              {
                annotations: r,
                formFieldValues: o
              } = e;
            (null != this.props.hasInitialRenderFinished && !this.props.hasInitialRenderFinished || !this.props.scaledPageSize.equals(e.scaledPageSize) || !this.props.rect.equals(e.rect) || t && t !== r && !t.equals(r) || n && n !== o && !n.equals(o) || this.props.pageKey !== e.pageKey || this.props.inContentEditorMode !== e.inContentEditorMode) && this.imageFetcherRef.current && this.imageFetcherRef.current.refresh();
          }
          render() {
            const {
                onRenderFinished: e,
                rect: t,
                tileScale: n = 1,
                crisp: i = !1,
                tilesClassName: a
              } = this.props,
              {
                width: u,
                height: c,
                left: p,
                top: m
              } = t,
              g = {
                width: u * n,
                height: c * n,
                left: p * n,
                top: m * n,
                outline: null
              },
              v = s()(function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? f(Object(n), !0).forEach(function (t) {
                    (0, r.Z)(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                [h().tile]: !0,
                [h().tileChrome]: d.i7,
                [h().tileFirefox]: d.vU,
                [h().tileSafari]: d.G6,
                [h().crispTile]: i
              }, a ? {
                [a]: !0
              } : null));
            return o.createElement(l.Z, {
              fetchImage: this._fetchImage,
              className: v,
              rectStyle: g,
              onRenderFinished: e,
              visible: !1,
              ref: this.imageFetcherRef
            });
          }
        }
      },
      11236: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u,
          j: () => c
        });
        var r = n(67294),
          o = n(94184),
          i = n.n(o),
          a = n(84337),
          s = n(66645),
          l = n.n(s);
        function u(e) {
          let {
            referenceRect: t,
            viewportState: n,
            isHidden: o,
            children: s,
            title: u,
            className: c,
            wrapperClassName: d,
            innerWrapperClassName: p,
            footerClassName: h,
            footer: f,
            centeredTitle: m
          } = e;
          return r.createElement(a.Z, {
            referenceRect: t,
            viewportState: n,
            className: i()(l().popover, c, {
              [l().popoverHidden]: o
            })
          }, r.createElement("div", {
            className: i()(l().container, d)
          }, r.createElement("div", {
            className: i()(l().innerContainer, p)
          }, r.createElement("h2", {
            className: i()(l().title, {
              [l().centeredTitle]: m
            })
          }, u), s && r.createElement("div", {
            className: l().content
          }, s), f && r.createElement("div", {
            className: i()(l().footer, h)
          }, f)), " "));
        }
        function c(e) {
          let {
            children: t,
            className: n,
            onClick: o
          } = e;
          return r.createElement("button", {
            className: i()(l().footerButton, n),
            onClick: o
          }, t);
        }
      },
      84337: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => y
        });
        var r = n(96156),
          o = n(67294),
          i = n(94184),
          a = n.n(i),
          s = n(59140),
          l = n(67057),
          u = n(44077),
          c = n(89004),
          d = n(54146),
          p = n.n(d);
        function h(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function f(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? h(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function m(e, t, n) {
          let {
              top: r,
              right: o,
              bottom: i,
              left: a
            } = n,
            s = null,
            l = null;
          return e.isRectInside(t.setLocation(r)) ? (l = r, s = "top") : e.isRectInside(t.setLocation(i)) ? (l = i, s = "bottom") : e.isRectInside(t.setLocation(a)) ? (l = a, s = "left") : e.isRectInside(t.setLocation(o)) && (l = o, s = "right"), {
            direction: s,
            position: l
          };
        }
        function g(e) {
          let {
            children: t,
            referenceRect: n,
            viewportRect: r,
            scroll: i = new u.E9(),
            onPositionInfoChange: a,
            onPositionConflict: s
          } = e;
          const [c, d] = o.useState({
              position: null,
              direction: null
            }),
            [p, h] = o.useState(null);
          o.useLayoutEffect(() => {
            if (!p) return;
            const e = r.translate(i);
            if (!e.isRectInside(n) && !e.isRectOverlapping(n)) return;
            const t = function (e) {
              let {
                  viewportRect: t,
                  referenceRect: n,
                  contentRect: r,
                  scroll: o,
                  onPositionConflict: i
                } = e,
                a = n.left + n.width / 2 - r.width / 2;
              const s = new u.E9({
                  x: a,
                  y: n.top - r.height
                }),
                l = new u.E9({
                  x: a,
                  y: n.bottom
                });
              let c = n.top + n.height / 2 - r.height / 2;
              const d = new u.E9({
                  x: n.left - r.width,
                  y: c
                }),
                p = new u.E9({
                  x: n.right,
                  y: c
                });
              let {
                position: h,
                direction: f
              } = m(t, r, {
                top: s,
                right: p,
                bottom: l,
                left: d
              });
              h || (a < t.left ? a = t.left : a + r.width > t.width + t.left && (a = t.width + t.left - r.width), c < t.top ? c = t.top : c + r.height > t.height + t.top && (c = t.height + t.top - r.height), {
                position: h,
                direction: f
              } = m(t, r, {
                top: s.set("x", a),
                right: p.set("y", c),
                bottom: l.set("x", a),
                left: d.set("y", c)
              })), h || ("function" == typeof i ? {
                position: h,
                direction: f
              } = i({
                referenceRect: n,
                viewportRect: t,
                contentRect: r,
                scroll: o,
                attempts: {
                  top: s,
                  right: p,
                  bottom: l,
                  left: d
                }
              }) : t.isRectOverlapping(n) && (h = new u.E9({
                x: t.left + t.width / 2 - r.width / 2,
                y: t.top + t.height / 2 - r.height / 2
              }), f = "center"));
              return {
                direction: f,
                position: h
              };
            }({
              viewportRect: e,
              referenceRect: n,
              contentRect: p,
              scroll: i,
              onPositionConflict: s
            });
            t.position && d(t);
          }, [r, n, p, s, i]), o.useEffect(() => {
            a && a(c);
          }, [c, a]);
          const {
              direction: g
            } = c,
            v = c.position && c.position.translate(r.getLocation().scale(-1)),
            y = f(f({
              position: "absolute"
            }, v ? {
              top: v.y,
              left: v.x
            } : {
              top: -1e5,
              left: -1e5
            }), {}, {
              visibility: v ? void 0 : "hidden"
            }),
            b = e => {
              (e.height || e.width || e.top || e.left) && h(e);
            };
          return "function" == typeof t ? t({
            style: y,
            direction: g,
            onResize: b
          }) : o.createElement("div", {
            style: y
          }, o.createElement(l.Z, {
            onResize: b
          }), t);
        }
        const v = function (e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        };
        function y(e) {
          let {
            children: t,
            referenceRect: n,
            color: r,
            baseColor: i,
            className: d,
            arrowClassName: h,
            viewportState: m,
            onPositionInfoChange: y,
            arrowSize: b = 5,
            customZIndex: w
          } = e;
          const {
            viewportRect: x,
            zoomLevel: D,
            scrollPosition: C
          } = m;
          return o.createElement(g, {
            referenceRect: n.grow(b),
            viewportRect: x,
            scroll: C.scale(D),
            onPositionInfoChange: y
          }, e => {
            let {
              style: m,
              direction: g,
              onResize: y
            } = e;
            const D = g && (0, c.kC)(g),
              C = g && "center" !== g ? function (e) {
                let t,
                  n,
                  {
                    referenceRect: r,
                    viewportRect: o,
                    size: i,
                    direction: a
                  } = e;
                switch ("top" === a || "bottom" === a ? n = r.left + r.width / 2 - i : t = r.top + r.height / 2 - i, a) {
                  case "top":
                    t = r.top - i;
                    break;
                  case "bottom":
                    t = r.top + r.height;
                    break;
                  case "left":
                    n = r.left - i;
                    break;
                  case "right":
                    n = r.left + r.width;
                    break;
                  default:
                    throw new Error("invalid direction");
                }
                return new u.E9({
                  y: t,
                  x: n
                }).translate(o.getLocation().scale(-1));
              }({
                referenceRect: n,
                viewportRect: x,
                size: b,
                direction: g
              }) : null,
              S = {};
            let E;
            if (r) {
              switch (g) {
                case "top":
                  S.color = r[r.length - 1].toCSSValue();
                  break;
                case "bottom":
                  S.color = r[0].toCSSValue();
                  break;
                default:
                  S.color = r[Math.floor((r.length - 1) / 2)].toCSSValue();
              }
              const e = r.map((e, t) => `${e.toCSSValue()} ${100 * t / (r.length - 1)}%`).join(", ");
              i && (m = f(f({}, m), {}, {
                backgroundColor: i.toCSSValue()
              }), E = {
                color: i.toCSSValue()
              }), m = f(f({}, m), {}, {
                backgroundImage: `linear-gradient(to bottom, ${e})`,
                zIndex: w
              });
            }
            return o.createElement(s.Z, {
              onPointerUp: v
            }, o.createElement("div", {
              className: d
            }, C && o.createElement("span", {
              style: f(f({}, E), {}, {
                zIndex: w
              })
            }, o.createElement("div", {
              style: f({
                position: "absolute",
                top: C.y,
                left: C.x,
                width: b,
                height: b,
                zIndex: w
              }, S),
              className: a()(p().arrow, h, D && p()[`arrow${D}`], "PSPDFKit-Popover-Arrow", D && "PSPDFKit-Popover-Arrow-" + D)
            })), o.createElement("div", {
              style: m,
              className: a()(p().root, "PSPDFKit-Popover", D && "PSPDFKit-Popover-" + D)
            }, t, o.createElement(l.Z, {
              onResize: y
            }))));
          });
        }
      },
      67040: (e, t, n) => {
        "use strict";

        n.d(t, {
          S: () => i
        });
        var r = n(15359),
          o = n(1175);
        const i = e => t => e(function (e) {
          const t = e.nativeEvent || e;
          let n = !1,
            i = 0,
            a = 0;
          const s = t.shiftKey;
          let l = t.pointerType || "mouse";
          const u = (void 0 !== e.touches || void 0 !== e.changedTouches) && void 0 === e.width;
          u ? (l = "touch", n = 1 == t.touches.length || "touchend" === e.type, n && t.changedTouches.length && (i = t.changedTouches[0].clientX, a = t.changedTouches[0].clientY)) : (n = e.isPrimary || (0, o.I)(e), i = e.clientX, a = e.clientY);
          let c = {
            clientX: i,
            clientY: a,
            isPrimary: n,
            pointerType: l,
            shiftKey: s,
            metaKey: t.metaKey,
            ctrlKey: t.ctrlKey,
            getCoalescedEvents: "function" == typeof t.getCoalescedEvents ? () => {
              const e = t.getCoalescedEvents.call(t);
              return e.length ? e : [c];
            } : () => [c],
            stopPropagation: () => {
              e.stopPropagation(), t.stopImmediatePropagation();
            },
            preventDefault: () => {
              e.preventDefault();
            },
            get target() {
              var n;
              const o = null === (n = t.composedPath) || void 0 === n ? void 0 : n.call(t)[0];
              if (!o && !e.target) throw new r.p2(`No valid target found for event ${t}.`);
              return null != o ? o : e.target;
            },
            nativeEvent: t,
            get buttons() {
              return u ? (0, r.ZK)("TouchEvent do not have the method buttons") : e.buttons;
            }
          };
          return c;
        }(t));
      },
      59140: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => b
        });
        var r = n(22122),
          o = n(96156),
          i = n(67294),
          a = n(15359),
          s = n(67040),
          l = n(87856),
          u = n(98179);
        const c = l.Gn ? {
            passive: !1
          } : void 0,
          d = !l.Gn || {
            passive: !1,
            capture: !0
          },
          p = 1e3;
        let h = 0,
          f = 0;
        function m(e) {
          return e ? function () {
            if (h = Date.now(), !(Date.now() - f < p)) return e(...arguments);
          } : e;
        }
        function g(e) {
          return e ? function () {
            const t = Date.now();
            if (!(t - f < p || t - h < p)) return e(...arguments);
          } : e;
        }
        function v(e) {
          return e ? function () {
            return f = Date.now(), e(...arguments);
          } : e;
        }
        function y() {}
        class b extends i.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_attachedListeners", {
              touchstart: [null, null],
              touchmove: [null, null],
              touchend: [null, null],
              touchcancel: [null, null],
              mousedown: [null, null],
              mousemove: [null, null],
              mouseup: [null, null],
              mouseenter: [null, null],
              mouseleave: [null, null],
              pointerdown: [null, null],
              pointermove: [null, null],
              pointerup: [null, null],
              pointerenter: [null, null],
              pointerleave: [null, null],
              pointercancel: [null, null]
            }), (0, o.Z)(this, "_handleRef", e => {
              this.props.onDOMElement && this.props.onDOMElement(e), e && ((0, a.kG)("string" == typeof e.nodeName, "PRC requires a basic HTML element as children (so that we can find the proper `ownerDocument`)."), this._refDocument = e.ownerDocument);
            });
          }
          componentDidMount() {
            this._updateRootListeners(this.props);
          }
          componentDidUpdate() {
            this._updateRootListeners(this.props);
          }
          componentWillUnmount() {
            this._removeAllRootListeners();
          }
          _updateListener(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            const r = this._refDocument;
            let o = null,
              i = null;
            const a = this._attachedListeners[e][n ? 1 : 0];
            if (a && ([o, i] = a), i !== t && (o && (r.removeEventListener(e, o, n ? d : c), this._attachedListeners[e][n ? 1 : 0] = null), "function" == typeof t)) {
              const o = (0, s.S)(t);
              r.addEventListener(e, o, n ? d : c), this._attachedListeners[e][n ? 1 : 0] = [o, t];
            }
          }
          _removeAllRootListeners() {
            const e = this._refDocument;
            Object.entries(this._attachedListeners).forEach(t => {
              let [n, r] = t;
              const [o, i] = r;
              o && e.removeEventListener(n, o[0], c), i && e.removeEventListener(n, i[0], d);
            });
          }
          _updateRootListeners(e) {
            Object.entries(e).forEach(e => {
              let [t, n] = e;
              switch (t) {
                case "onRootPointerDown":
                  this._updateListener("touchstart", m(n)), this.disablePointerEvents || this._updateListener("pointerdown", v(n)), this._updateListener("mousedown", g(n));
                  break;
                case "onRootPointerDownCapture":
                  this._updateListener("touchstart", m(n), !0), this.disablePointerEvents || this._updateListener("pointerdown", v(n), !0), this._updateListener("mousedown", g(n), !0);
                  break;
                case "onRootPointerMove":
                  this._updateListener("touchmove", m(n)), this.disablePointerEvents || this._updateListener("pointermove", v(n)), this._updateListener("mousemove", g(n));
                  break;
                case "onRootPointerMoveCapture":
                  this._updateListener("touchmove", m(n), !0), this.disablePointerEvents || this._updateListener("pointermove", v(n), !0), this._updateListener("mousemove", g(n), !0);
                  break;
                case "onRootPointerUp":
                  this._updateListener("touchend", m(n)), this.disablePointerEvents || this._updateListener("pointerup", v(n)), this._updateListener("mouseup", g(n));
                  break;
                case "onRootPointerEnter":
                  this.disablePointerEvents || this._updateListener("pointerenter", v(n)), this._updateListener("mouseenter", g(n));
                  break;
                case "onRootPointerLeave":
                  this.disablePointerEvents || this._updateListener("pointerleave", v(n)), this._updateListener("mouseleave", g(n));
                  break;
                case "onRootPointerUpCapture":
                  this._updateListener("touchend", m(n), !0), this.disablePointerEvents || this._updateListener("pointerup", v(n), !0), this._updateListener("mouseup", g(n), !0);
                  break;
                case "onRootPointerEnterCapture":
                  this.disablePointerEvents || this._updateListener("pointerenter", v(n), !0), this._updateListener("mouseenter", g(n), !0);
                  break;
                case "onRootPointerLeaveCapture":
                  this.disablePointerEvents || this._updateListener("pointerleave", v(n), !0), this._updateListener("mouseleave", g(n), !0);
                  break;
                case "onRootPointerCancel":
                  this.disablePointerEvents || this._updateListener("pointercancel", v(n)), this._updateListener("touchcancel", m(n));
                  break;
                case "onRootPointerCancelCapture":
                  this.disablePointerEvents || this._updateListener("pointercancel", v(n), !0), this._updateListener("touchcancel", m(n), !0);
              }
            });
          }
          render() {
            const e = {};
            let t = !1;
            if (this.disablePointerEvents = "INK" !== this.props.interactionMode && (0, u.yx)(), Object.entries(this.props).forEach(n => {
              let [r, o] = n;
              if ("function" == typeof o) switch (r) {
                case "onPointerDown":
                  e.onTouchStart = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerDown = v((0, s.S)(o))), e.onMouseDown = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerDownCapture":
                  e.onTouchStartCapture = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerDownCapture = v((0, s.S)(o))), e.onMouseDownCapture = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerMove":
                  e.onTouchMove = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerMove = v((0, s.S)(o))), e.onMouseMove = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerMoveCapture":
                  e.onTouchMoveCapture = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerMoveCapture = v((0, s.S)(o))), e.onMouseMoveCapture = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerUp":
                  e.onTouchEnd = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerUp = v((0, s.S)(o))), e.onMouseUp = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerUpCapture":
                  e.onTouchEndCapture = m((0, s.S)(o)), this.disablePointerEvents || (e.onPointerUpCapture = v((0, s.S)(o))), e.onMouseUpCapture = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerEnter":
                  this.disablePointerEvents || (e.onPointerEnter = v((0, s.S)(o))), e.onMouseEnter = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerEnterCapture":
                  this.disablePointerEvents || (e.onPointerEnterCapture = v((0, s.S)(o))), e.onMouseEnterCapture = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerLeave":
                  this.disablePointerEvents || (e.onPointerLeave = v((0, s.S)(o))), e.onMouseLeave = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerLeaveCapture":
                  this.disablePointerEvents || (e.onPointerLeaveCapture = v((0, s.S)(o))), e.onMouseLeaveCapture = g((0, s.S)(o)), t = !0;
                  break;
                case "onPointerCancel":
                  this.disablePointerEvents || (e.onPointerCancel = v((0, s.S)(o))), e.onTouchCancel = m((0, s.S)(o)), t = !0;
                  break;
                case "onPointerCancelCapture":
                  this.disablePointerEvents || (e.onPointerCancelCapture = v((0, s.S)(o))), e.onTouchCancelCapture = m((0, s.S)(o)), t = !0;
                  break;
                case "onRootPointerDown":
                case "onRootPointerDownCapture":
                  e.onTouchStart = e.onTouchStart || y, this.disablePointerEvents || (e.onPointerDown = e.onPointerDown || y), e.onMouseDown = e.onMouseDown || y;
                  break;
                case "onRootPointerMove":
                case "onRootPointerMoveCapture":
                  e.onTouchMove = e.onTouchMove || y, this.disablePointerEvents || (e.onPointerMove = e.onPointerMove || y), e.onMouseMove = e.onMouseMove || y;
                  break;
                case "onRootPointerUp":
                case "onRootPointerUpCapture":
                  e.onTouchEnd = e.onTouchEnd || y, this.disablePointerEvents || (e.onPointerUp = e.onPointerUp || y), e.onMouseUp = e.onMouseUp || y;
                  break;
                case "onRootPointerEnter":
                case "onRootPointerEnterCapture":
                  this.disablePointerEvents || (e.onPointerEnter = e.onPointerEnter || y), e.onMouseEnter = e.onMouseEnter || y;
                  break;
                case "onRootPointerLeave":
                case "onRootPointerLeaveCapture":
                  this.disablePointerEvents || (e.onPointerLeave = e.onPointerLeave || y), e.onMouseLeave = e.onMouseLeave || y;
                  break;
                case "onRootPointerCancel":
                case "onRootPointerCancelCapture":
                  this.disablePointerEvents || (e.onPointerCancel = e.onPointerCancel || y), e.onTouchCancel = e.onTouchCancel || y;
              }
            }), !t) return i.createElement("div", (0, r.Z)({
              ref: this._handleRef
            }, e), this.props.children);
            const n = i.Children.only(this.props.children);
            return e.ref = this._handleRef, (0, a.kG)(!n.ref, "PRC requires the child element to not have a `ref` assigned. Consider inserting a new `<div>` in between."), i.cloneElement(n, e);
          }
        }
      },
      54130: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => c
        });
        var r = n(22122),
          o = n(67294),
          i = n(94184),
          a = n.n(i),
          s = (n(43165), n(80422)),
          l = n(17722),
          u = n.n(l);
        const c = o.forwardRef(function (e, t) {
          const {
              selected: n,
              disabled: i
            } = e,
            l = a()(u().root, n && u().isActive, i && u().isDisabled, "string" == typeof e.className && e.className, "PSPDFKit-Toolbar-Button", n && "PSPDFKit-Toolbar-Button-active", i && "PSPDFKit-Toolbar-Button-disabled");
          return o.createElement(s.Z, (0, r.Z)({}, e, {
            className: l,
            iconClassName: "PSPDFKit-Toolbar-Button-Icon",
            ref: t,
            itemComponentProps: e.itemComponentProps
          }));
        });
      },
      85944: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => Oe,
          k3: () => Pe
        });
        var r = n(96156),
          o = n(67294),
          i = n(35369),
          a = n(94184),
          s = n.n(a),
          l = n(30845),
          u = n(35782),
          c = n(31672),
          d = n(86849),
          p = n(67366),
          h = n(40163),
          f = n(22122),
          m = n(67665),
          g = n(41756),
          v = n(26353),
          y = n(84013),
          b = n(98260),
          w = n(2464),
          x = n(66327),
          D = n(46302),
          C = n(84691),
          S = n.n(C),
          E = n(37103),
          _ = n.n(E),
          P = n(54130),
          k = n(13608),
          A = n.n(k),
          z = n(14286),
          T = n(40084),
          O = n(89637),
          I = n(53328),
          F = n.n(I),
          M = n(71623);
        function R(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function j(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? R(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : R(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function B(e) {
          let {
            isActive: t,
            isHighlighted: n,
            type: r,
            title: i,
            className: a,
            itemProps: l
          } = e;
          return o.createElement("span", (0, f.Z)({
            className: s()(_().button, a, "PSPDFKit-Layout-Config-Option", t && "PSPDFKit-Layout-Config-Option-Active", n && "PSPDFKit-Layout-Config-Option-Highlighted"),
            title: i,
            "aria-label": i
          }, l), (0, M.Z)({
            type: `layout-config/${r.toLowerCase()}`,
            style: {
              width: 36,
              height: 36
            },
            className: s()(_().icon, t && _().activeIcon, n && _().highlightedIcon, "PSPDFKit-Layout-Config-Option-Icon")
          }));
        }
        const N = [{
          type: "layout",
          mode: z.X.SINGLE
        }, {
          type: "layout",
          mode: z.X.DOUBLE
        }, {
          type: "layout",
          mode: z.X.AUTO
        }, {
          type: "scroll",
          mode: w.G.CONTINUOUS
        }, {
          type: "scroll",
          mode: w.G.PER_SPREAD
        }, {
          type: "rotate",
          mode: "-90"
        }, {
          type: "rotate",
          mode: "90"
        }];
        function L(e, t) {
          switch (t.type) {
            case g.ZP.stateChangeTypes.keyDownEnter:
            case g.ZP.stateChangeTypes.clickItem:
              return j(j({}, t), {}, {
                isOpen: e.isOpen,
                highlightedIndex: e.highlightedIndex
              });
            default:
              return t;
          }
        }
        const V = (0, u.XN)(function (e) {
          const {
              dispatch: t,
              layoutMode: n,
              scrollMode: r,
              disabled: i
            } = e,
            {
              formatMessage: a
            } = e.intl,
            l = o.useRef(),
            u = (0, p.v9)(e => e.shadowRoot),
            c = o.useMemo(() => u ? (0, b.ke)(u, window) : e.frameWindow, []);
          return o.createElement(g.ZP, {
            onSelect: function (e) {
              if (e) switch (e.type) {
                case "layout":
                  t((0, x.YA)(e.mode));
                  break;
                case "scroll":
                  t((0, x._U)(e.mode));
                  break;
                case "rotate":
                  t((0, T.U1)(e.mode));
              }
            },
            itemToString: e => null === e ? "" : `${e.type} ${e.mode}`,
            stateReducer: L,
            environment: c
          }, u => {
            let {
                getToggleButtonProps: c,
                getMenuProps: d,
                getItemProps: p,
                isOpen: h,
                highlightedIndex: g,
                setHighlightedIndex: b
              } = u,
              x = !1;
            const C = d({
                onMouseDown: () => {
                  x = !0;
                },
                onTouchStart: () => {
                  x = !0;
                }
              }, {
                suppressRefError: !0
              }),
              E = c(),
              k = "down" === e.caretDirection;
            return o.createElement("div", {
              className: s()(h && "PSPDFKit-Input-Dropdown-open")
            }, o.createElement("div", (0, f.Z)({
              ref: l
            }, j(j({}, E), e.disabled ? {
              onClick: null
            } : null), {
              onBlur: function (e) {
                if (x && (x = !1, e.nativeEvent.preventDownshiftDefault = !0, l.current)) {
                  const e = l.current.querySelector("button");
                  e && e.focus();
                }
                E.onBlur(e);
              }
            }), o.createElement(P.Z, {
              type: "layout-config",
              selected: h,
              title: a(K.pageLayout),
              icon: e.icon,
              className: s()(A().toolbarButton, "PSPDFKit-Toolbar-Button-Layout-Config", e.className),
              onPress: e => {
                e.target.focus && e.target.focus(), h || t((0, O.fz)());
              },
              disabled: i
            })), o.createElement(m.m, null, o.createElement(y.Z, null, h && o.createElement(v.Z, {
              timeout: {
                enter: window["PSPDFKit-disable-animations"] ? 0 : 240,
                exit: window["PSPDFKit-disable-animations"] ? 0 : 80
              },
              classNames: {
                enter: s()(F().scaleInEnter, {
                  [F().scaleInEnterTop]: k,
                  [F().scaleInEnterBottom]: !k
                }),
                enterActive: F().scaleInEnterActive,
                exit: s()(F().scaleInExit, {
                  [F().scaleInExitTop]: k,
                  [F().scaleInExitBottom]: !k
                }),
                exitActive: s()(F().scaleInExitActive, {
                  [F().scaleInExitActiveTop]: k,
                  [F().scaleInExitActiveBottom]: !k
                })
              }
            }, o.createElement(D.Z, {
              referenceElement: l.current,
              horizontalAlignment: "center"
            }, o.createElement("div", (0, f.Z)({}, C, {
              className: s()(S().root, _().dropdownMenu, "PSPDFKit-Dropdown-Layout-Config", {
                [_().dropdownMenuUp]: !k
              }),
              style: {
                padding: 0
              },
              onMouseLeave: () => b(null)
            }), o.createElement("table", {
              className: s()(_().table, "PSPDFKit-Layout-Config")
            }, o.createElement("tbody", null, o.createElement("tr", null, o.createElement("td", {
              className: "PSPDFKit-Layout-Config-Label"
            }, a(K.pageMode)), o.createElement("td", {
              style: {
                textAlign: "right"
              },
              className: "PSPDFKit-Layout-Config-Options"
            }, o.createElement(B, {
              itemProps: p({
                item: N[0]
              }),
              isActive: n === z.X.SINGLE,
              isHighlighted: 0 === g,
              type: z.X.SINGLE,
              className: "PSPDFKit-Layout-Config-Option-Layout-Mode-Single",
              title: a(K.pageModeSingle)
            }), o.createElement(B, {
              itemProps: p({
                item: N[1]
              }),
              isActive: n === z.X.DOUBLE,
              isHighlighted: 1 === g,
              type: z.X.DOUBLE,
              className: "PSPDFKit-Layout-Config-Option-Layout-Mode-Double",
              title: a(K.pageModeDouble)
            }), o.createElement(B, {
              itemProps: p({
                item: N[2]
              }),
              isActive: n === z.X.AUTO,
              isHighlighted: 2 === g,
              type: z.X.AUTO,
              className: "PSPDFKit-Layout-Config-Option-Layout-Mode-Auto",
              title: a(K.pageModeAutomatic)
            }))), o.createElement("tr", null, o.createElement("td", {
              className: "PSPDFKit-Layout-Config-Label"
            }, a(K.pageTransition)), o.createElement("td", {
              style: {
                textAlign: "right"
              },
              className: "PSPDFKit-Layout-Config-Options"
            }, o.createElement(B, {
              itemProps: p({
                item: N[3]
              }),
              isActive: r === w.G.CONTINUOUS,
              isHighlighted: 3 === g,
              type: w.G.CONTINUOUS,
              className: "PSPDFKit-Layout-Config-Option-Scroll-Mode-Continuous",
              title: a(K.pageTransitionContinuous)
            }), o.createElement(B, {
              itemProps: p({
                item: N[4]
              }),
              isActive: r === w.G.PER_SPREAD,
              isHighlighted: 4 === g,
              type: "single",
              className: "PSPDFKit-Layout-Config-Option-Scroll-Mode-Per-Spread",
              title: a(K.pageTransitionJump)
            }))), o.createElement("tr", null, o.createElement("td", {
              className: "PSPDFKit-Layout-Config-Label"
            }, a(K.pageRotation)), o.createElement("td", {
              style: {
                textAlign: "right"
              },
              className: "PSPDFKit-Layout-Config-Options"
            }, o.createElement(B, {
              itemProps: p({
                item: N[5]
              }),
              type: "view_rotate_left",
              title: a(K.pageRotationLeft),
              className: "PSPDFKit-Layout-Config-Option-Page-Rotation-Left",
              isHighlighted: 5 === g,
              isActive: !1
            }), o.createElement(B, {
              itemProps: p({
                item: N[6]
              }),
              type: "view_rotate_right",
              title: a(K.pageRotationRight),
              className: "PSPDFKit-Layout-Config-Option-Page-Rotation-Right",
              isHighlighted: 6 === g,
              isActive: !1
            })))))))))), !h && o.createElement("div", C), o.createElement(m.m, null, o.createElement(y.Z, null, h && o.createElement(v.Z, {
              timeout: {
                enter: window["PSPDFKit-disable-animations"] ? 0 : 240,
                exit: window["PSPDFKit-disable-animations"] ? 0 : 80
              },
              classNames: {
                enter: s()(F().scaleInEnter, {
                  [F().scaleInEnterTop]: k,
                  [F().scaleInEnterBottom]: !k
                }),
                enterActive: F().scaleInEnterActive,
                exit: s()(F().scaleInExit, {
                  [F().scaleInExitTop]: k,
                  [F().scaleInExitBottom]: !k
                }),
                exitActive: s()(F().scaleInExitActive, {
                  [F().scaleInExitActiveTop]: k,
                  [F().scaleInExitActiveBottom]: !k
                })
              }
            }, o.createElement(D.Z, {
              referenceElement: l.current,
              horizontalAlignment: "center"
            }, o.createElement(o.Fragment, null, o.createElement("div", {
              className: s()(_().arrow, {
                [_().arrowUp]: !k
              })
            }, o.createElement("div", {
              className: s()({
                [_().arrowFill]: k,
                [_().arrowFillUp]: !k
              })
            }))))))));
          });
        });
        const K = (0, u.vU)({
          pageLayout: {
            id: "pageLayout",
            defaultMessage: "Page Layout",
            description: 'Button to open the "change page layout" menu'
          },
          pageMode: {
            id: "pageMode",
            defaultMessage: "Page Mode",
            description: "Label for the page mode configuration"
          },
          pageModeSingle: {
            id: "pageModeSingle",
            defaultMessage: "Single",
            description: "Single page mode"
          },
          pageModeDouble: {
            id: "pageModeDouble",
            defaultMessage: "Double",
            description: "Double page mode"
          },
          pageModeAutomatic: {
            id: "pageModeAutomatic",
            defaultMessage: "Automatic",
            description: "Automatic page mode"
          },
          pageTransition: {
            id: "pageTransition",
            defaultMessage: "Page Transition",
            description: "Label for the page transition mode"
          },
          pageTransitionContinuous: {
            id: "pageTransitionContinuous",
            defaultMessage: "Continuous",
            description: "Continuous page transition mode"
          },
          pageTransitionJump: {
            id: "pageTransitionJump",
            defaultMessage: "Jump",
            description: "Jump-ing page transition mode (one page at the time)"
          },
          pageRotation: {
            id: "pageRotation",
            defaultMessage: "Page Rotation",
            description: "Label for the page rotation mode (left, right)"
          },
          pageRotationLeft: {
            id: "pageRotationLeft",
            defaultMessage: "Rotate Left",
            description: "Button to rotate the page to the left of 90°"
          },
          pageRotationRight: {
            id: "pageRotationRight",
            defaultMessage: "Rotate Right",
            description: "Button to rotate the page to the right of 90°"
          }
        });
        var q = n(15359),
          H = n(53261),
          U = n(61533),
          Z = n.n(U);
        const $ = e => {
            ["-", "+", ".", "e", "E"].some(t => e.key === t) && e.preventDefault();
          },
          G = e => {
            e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
          },
          W = e => {
            e.currentTarget.select();
          },
          Y = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              withParens: !1
            };
            return t => o.createElement("div", {
              className: Z().desktop
            }, e.withParens && "(", t.map((e, t) => o.createElement("span", {
              key: t
            }, e)), e.withParens && ")");
          };
        const X = (0, u.XN)(function (e) {
            const t = e.pages.get(e.currentPageNumber - 1);
            (0, q.kG)(null != t, `Couldn't get page number ${e.currentPageNumber}`);
            const r = o.useMemo(() => e.pages.some(e => e.pageLabel !== (e.pageIndex + 1).toString()), [e.pages]),
              [i, a] = o.useState(null == t ? void 0 : t.pageLabel);
            o.useEffect(() => {
              a(null == t ? void 0 : t.pageLabel);
            }, [null == t ? void 0 : t.pageLabel]);
            const l = n => {
                if (r) {
                  const t = e.pages.findIndex(e => e.pageLabel === n);
                  if (t >= 0 && !e.readOnly) return void e.dispatch((0, T.YA)(t));
                }
                const o = parseInt(n);
                1 <= o && o <= e.totalPages && !e.readOnly ? e.dispatch((0, T.YA)(o - 1)) : a(t.pageLabel);
              },
              {
                formatMessage: c
              } = e.intl,
              d = s()({
                "PSPDFKit-Page-Indicator-Prev": !0,
                [Z().prev]: !0,
                "PSPDFKit-Page-Indicator-Prev-disabled": 1 === e.currentPageNumber
              }),
              p = s()({
                "PSPDFKit-Page-Indicator-Next": !0,
                [Z().next]: !0,
                "PSPDFKit-Page-Indicator-Next-disabled": e.currentPageNumber === e.totalPages
              }),
              h = o.createElement("div", {
                className: Z().control
              }, o.createElement("button", {
                className: d,
                title: c(Q.prevPage),
                onClick: () => e.dispatch((0, T.IT)()),
                disabled: 1 === e.currentPageNumber || e.readOnly
              }, o.createElement(H.Z, {
                src: n(10190),
                className: Z().icon
              })), o.createElement("label", {
                className: Z().inputLabel,
                htmlFor: Z().input
              }, c(Q.goToPage)), o.createElement("input", (0, f.Z)({
                id: Z().input,
                type: r ? "text" : "number",
                value: i,
                className: `PSPDFKit-Page-Indicator-Input ${Z().input}`,
                onMouseDown: G,
                onFocus: W,
                onChange: t => {
                  e.readOnly || a(t.currentTarget.value);
                },
                onBlur: e => {
                  l(e.currentTarget.value);
                },
                onKeyPress: e => {
                  "Enter" === e.key && l(e.currentTarget.value);
                },
                disabled: e.readOnly
              }, r ? {} : {
                min: 1,
                max: e.totalPages,
                onKeyDown: $,
                pattern: "[0-9]"
              })), o.createElement("button", {
                className: p,
                onClick: () => e.dispatch((0, T.fz)()),
                title: c(Q.nextPage),
                disabled: e.currentPageNumber === e.totalPages || e.readOnly
              }, o.createElement(H.Z, {
                src: n(92122),
                className: Z().icon
              })));
            return o.createElement("div", {
              className: `PSPDFKit-Page-Indicator ${Z().root}`
            }, r ? o.createElement(o.Fragment, null, o.createElement(u._H, {
              id: "pageX",
              defaultMessage: "Page {arg0}",
              description: "Page indicator prefix",
              values: {
                arg0: h
              },
              children: Y()
            }), o.createElement(u._H, {
              id: "XofY",
              defaultMessage: "{arg0} of {arg1}",
              description: "Page indicator label",
              values: {
                arg0: e.currentPageNumber,
                arg1: e.totalPages
              },
              children: Y({
                withParens: !0
              })
            })) : o.createElement(u._H, {
              id: "pageXofY",
              defaultMessage: "Page {arg0} of {arg1}",
              description: "Page indicator control. arg0 is an interactive widget to select pages.",
              values: {
                arg0: h,
                arg1: e.totalPages
              },
              children: Y()
            }), o.createElement("div", {
              className: Z().mobile
            }, o.createElement("label", {
              className: Z().label
            }, o.createElement("strong", null, e.currentPageNumber), " ", "/", " ", e.totalPages)));
          }),
          Q = (0, u.vU)({
            prevPage: {
              id: "prevPage",
              defaultMessage: "Previous Page",
              description: "Button to go to the previous page"
            },
            nextPage: {
              id: "nextPage",
              defaultMessage: "Next Page",
              description: "Button to go to the next page"
            },
            goToPage: {
              id: "goToPage",
              defaultMessage: "Go to Page",
              description: "label for the go to page selector"
            }
          }),
          J = (0, p.$j)(e => ({
            currentPageNumber: e.viewportState.currentPageIndex + 1
          }))(X);
        var ee = n(80292),
          te = n(76465),
          ne = n(3324),
          re = n(45249),
          oe = n(94732),
          ie = n(2841),
          ae = n(2927),
          se = n(4087),
          le = n(35464),
          ue = n(5283),
          ce = n(73900),
          de = n(18287),
          pe = n(98179);
        function he(e, t) {
          const n = document.createElement("a");
          n.href = e, n.style.display = "none", n.download = t, n.setAttribute("download", t);
          const r = document.body;
          return r ? (r.appendChild(n), n.click(), () => {
            const e = document.body;
            e && e.removeChild(n);
          }) : () => {};
        }
        var fe = n(87996),
          me = n(48625),
          ge = n(27122),
          ve = n(81777),
          ye = n(20063),
          be = n(13264),
          we = n(17766),
          xe = n(49876),
          De = n(2058),
          Ce = n(43069),
          Se = n(77897);
        function Ee(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function _e(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ee(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ee(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Pe = 44;
        class ke extends o.Component {
          constructor() {
            for (var e, t = arguments.length, n = new Array(t), a = 0; a < t; a++) n[a] = arguments[a];
            super(...n), e = this, (0, r.Z)(this, "state", {
              currentPageIndex: 0,
              items: null,
              responsiveGroupItems: null,
              activeResponsiveGroup: null,
              mediaQueryDidUpdate: {},
              lastSelectedToolbarItemType: null,
              prevActiveGroup: null
            }), (0, r.Z)(this, "imagePickerRef", o.createRef()), (0, r.Z)(this, "itemToFocusRef", o.createRef()), (0, r.Z)(this, "_mediaListeners", {}), (0, r.Z)(this, "_handlePanTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.PAN ? t((0, T.Yr)()) : t((0, T.vc)());
            }), (0, r.Z)(this, "handleFormDesignerTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), (0, Ce.fF)(e) ? t((0, Se.h4)()) : t((0, Se.el)());
            }), (0, r.Z)(this, "_handleZoomOutTap", () => {
              this.props.dispatch((0, T.vG)());
            }), (0, r.Z)(this, "_handleZoomInTap", () => {
              this.props.dispatch((0, T.kr)());
            }), (0, r.Z)(this, "_handleUndoTap", () => {
              this.props.canUndo && this.props.dispatch((0, xe.Yw)());
            }), (0, r.Z)(this, "_handleRedoTap", () => {
              this.props.canRedo && this.props.dispatch((0, xe.KX)());
            }), (0, r.Z)(this, "_handleMarqueeZoomTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.MARQUEE_ZOOM ? t((0, x.si)()) : t((0, x.xF)());
            }), (0, r.Z)(this, "_handleFitToWidthTap", () => {
              this.props.dispatch((0, T.du)());
            }), (0, r.Z)(this, "_handleFitToBothTap", () => {
              this.props.dispatch((0, T.lO)());
            }), (0, r.Z)(this, "handleCalloutTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.CALLOUT && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.k4)())) : (o((0, se.Ds)(n)), o((0, x.Lt)()));
            }), (0, r.Z)(this, "_handleTextTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.TEXT && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.k4)())) : (o((0, se.Ds)(n)), o((0, x.DU)()));
            }), (0, r.Z)(this, "_handleTextKeyPress", () => {
              const {
                dispatch: e
              } = this.props;
              e((0, O.fz)()), e((0, se.RK)());
            }), (0, r.Z)(this, "_handleTextHighlighterTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.TEXT_HIGHLIGHTER && n === this.props.currentItemPreset ? o((0, x.lC)()) : o((0, x.d5)(n));
            }), (0, r.Z)(this, "_handleLinkTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.LINK && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.UU)())) : (o((0, se.Ds)(n)), o((0, x.Jn)()));
            }), (0, r.Z)(this, "_handleInkTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.INK && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.s3)())) : (o((0, se.Ds)(n)), o((0, x.P4)()));
            }), (0, r.Z)(this, "_handleMeasurementTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.MEASUREMENT && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.hS)())) : (o((0, se.Ds)(n)), o((0, x.BR)()));
            }), (0, r.Z)(this, "_handleInkEraserTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.INK_ERASER ? (o((0, se.Ds)(null)), o((0, x.VU)())) : (o((0, se.Ds)(n)), o((0, x.Ug)()));
            }), (0, r.Z)(this, "_handleLineTap", (e, t, n) => this._handleShapeTap(re.o9, me.A.SHAPE_LINE, n)), (0, r.Z)(this, "_handleRectangleTap", (e, t, n) => this._handleShapeTap(re.b3, me.A.SHAPE_RECTANGLE, n)), (0, r.Z)(this, "_handleEllipseTap", (e, t, n) => this._handleShapeTap(re.Xs, me.A.SHAPE_ELLIPSE, n)), (0, r.Z)(this, "_handlePolygonTap", (e, t, n) => this._handleShapeTap(re.Hi, me.A.SHAPE_POLYGON, n)), (0, r.Z)(this, "_handlePolylineTap", (e, t, n) => this._handleShapeTap(re.om, me.A.SHAPE_POLYLINE, n)), (0, r.Z)(this, "_handleShapeTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === t && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.Ce)())) : (o((0, se.Ds)(n)), o((0, x.yg)(e, t)));
            }), (0, r.Z)(this, "_handleNoteTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.NOTE && n === this.props.currentItemPreset ? (o((0, se.Ds)(null)), o((0, x.dp)())) : (o((0, se.Ds)(n)), o((0, x.i9)()));
            }), (0, r.Z)(this, "_handleNoteKeyPress", () => {
              const {
                dispatch: e
              } = this.props;
              e((0, O.fz)()), e((0, se.XG)());
            }), (0, r.Z)(this, "_handleCommentMarkerTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.COMMENT_MARKER ? t((0, x.tr)()) : t((0, x.k6)());
            }), (0, r.Z)(this, "_handleCommentMarkerKeyPress", () => {
              const {
                dispatch: e
              } = this.props;
              e((0, O.fz)()), e((0, le.GH)());
            }), (0, r.Z)(this, "_handleSignatureTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.INK_SIGNATURE || r === me.A.SIGNATURE ? (o((0, se.Ds)(null)), o((0, x.MV)())) : (o((0, se.Ds)(n)), o((0, x.Cc)()));
            }), (0, r.Z)(this, "_handleStampTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.STAMP_PICKER ? t((0, x.pM)()) : t((0, x.C4)());
            }), (0, r.Z)(this, "_handleRedactRectangleTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.REDACT_SHAPE_RECTANGLE && n === this.props.currentItemPreset ? o((0, x.jP)()) : o((0, x.t)(n));
            }), (0, r.Z)(this, "_handleRedactTextHighlighterTap", (e, t, n) => {
              const {
                interactionMode: r,
                dispatch: o
              } = this.props;
              o((0, O.fz)()), r === me.A.REDACT_TEXT_HIGHLIGHTER && n === this.props.currentItemPreset ? o((0, x.TR)()) : o((0, x.aw)(n));
            }), (0, r.Z)(this, "_handleResponsiveGroupTap", e => {
              this.setState({
                activeResponsiveGroup: e
              }), e && this.setState({
                prevActiveGroup: e
              });
            }), (0, r.Z)(this, "_handleAnnotateResponsiveGroupTap", () => this._handleResponsiveGroupTap("annotate")), (0, r.Z)(this, "_handlePrintTap", () => {
              this.props.printingEnabled && this.props.dispatch((0, ce.S0)());
            }), (0, r.Z)(this, "_handleSearchTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.SEARCH ? t((0, de.ct)()) : t((0, de.Xe)());
            }), (0, r.Z)(this, "handleCropTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), e === me.A.DOCUMENT_CROP ? t((0, x.Cn)()) : t((0, x.rL)());
            }), (0, r.Z)(this, "handleDocumentComparisonTap", () => {
              const {
                currentDocumentComparisonMode: e,
                dispatch: t
              } = this.props;
              t((0, O.fz)()), t(e ? (0, x.cz)(null) : (0, x.cz)(De.se));
            }), (0, r.Z)(this, "_handleExportPDFTap", async () => {
              this.props.exportEnabled && this.props.dispatch(function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return async (t, n) => {
                  const {
                      backend: r,
                      annotations: o
                    } = n(),
                    i = e.flattenElectronicSignatures ? o.toList().filter(e => (e instanceof re.Zc || e instanceof re.sK) && e.isSignature).map(e => ({
                      pageIndex: e.pageIndex,
                      id: e.id,
                      pdfObjectId: e.pdfObjectId
                    })) : void 0;
                  (0, q.kG)(r);
                  const a = HTMLAnchorElement.prototype.hasOwnProperty("download"),
                    s = await r.exportPDF(e, null == i ? void 0 : i.toArray()),
                    l = s.mimeType || "application/pdf",
                    u = s.extension || "pdf",
                    c = new Blob([s], {
                      type: l
                    }),
                    d = `${(await r.documentInfo()).title || "document"}.${u}`;
                  let p = () => {};
                  if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(c, d);else if (a) {
                    const e = window.URL.createObjectURL(c),
                      t = he(e, d);
                    p = () => {
                      t(), window.URL.revokeObjectURL(e);
                    };
                  } else {
                    const e = new FileReader();
                    e.onloadend = () => {
                      p = he(e.result, u);
                    }, e.readAsDataURL(c);
                  }
                  window.setTimeout(p, 1e3);
                };
              }());
            }), (0, r.Z)(this, "_handleDebugTap", () => {
              this.props.dispatch((0, x.BB)());
            }), (0, r.Z)(this, "_handleThumbnailsSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.THUMBNAILS ? t((0, x.mu)()) : t((0, x.el)());
            }), (0, r.Z)(this, "_handleDocumentOutlineSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.DOCUMENT_OUTLINE ? t((0, x.mu)()) : t((0, x.EJ)());
            }), (0, r.Z)(this, "_handleDocumentEditorTap", () => {
              const {
                dispatch: e
              } = this.props;
              e((0, O.fz)()), e((0, x.lV)());
            }), (0, r.Z)(this, "_handleAnnotationsSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.ANNOTATIONS ? t((0, x.mu)()) : t((0, x.ze)());
            }), (0, r.Z)(this, "_handleBookmarksSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.BOOKMARKS ? t((0, x.mu)()) : t((0, x.Hf)());
            }), (0, r.Z)(this, "_handleSignaturesSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.SIGNATURES ? t((0, x.mu)()) : t((0, x.LH)());
            }), (0, r.Z)(this, "_handleOCGsSidebarTap", () => {
              const {
                sidebarMode: e,
                dispatch: t
              } = this.props;
              e === ge.f.LAYERS ? t((0, x.mu)()) : t((0, x.Fs)());
            }), (0, r.Z)(this, "_handleImageTap", () => {
              const e = {
                annotations: (0, i.aV)([new re.sK({
                  pageIndex: this.state.currentPageIndex
                })]),
                reason: ie.f.SELECT_START
              };
              this.props.eventEmitter.emit("annotations.willChange", e);
              const t = this.imagePickerRef && this.imagePickerRef.current;
              if (t) try {
                const {
                  formatMessage: e
                } = this.props.intl;
                this.props.dispatch((0, x.iJ)(e(Ie.selectAFileForImage))), t.removeAttribute("aria-hidden"), t.click();
              } catch (e) {
                t.setAttribute("aria-hidden", "true");
                const n = {
                  annotations: (0, i.aV)(),
                  reason: ie.f.SELECT_END
                };
                this.props.eventEmitter.emit("annotations.willChange", n);
              }
            }), (0, r.Z)(this, "_handleImageSelect", e => {
              if (e.target.setAttribute("aria-hidden", "true"), !e.target.files[0]) return;
              this.props.dispatch((0, O.fz)()), this.props.dispatch((0, se.Ds)("image")), this.props.dispatch((0, se.$e)(e.target.files[0]));
              const {
                formatMessage: t
              } = this.props.intl;
              this.props.dispatch((0, x.iJ)(t(Ie.newAnnotationCreated, {
                arg0: "image"
              }))), e.target.value = "";
            }), (0, r.Z)(this, "_handleResponsiveGroupClose", () => {
              this.props.dispatch((0, O.fz)()), this._handleResponsiveGroupTap(null);
            }), (0, r.Z)(this, "_handleContentEditorTap", () => {
              const {
                interactionMode: e,
                dispatch: t,
                isContentEditorSessionDirty: n
              } = this.props;
              e === me.A.CONTENT_EDITOR ? t(n ? (0, ae.Yg)(!0) : ae.u8) : t(ae.gY);
            }), (0, r.Z)(this, "_handleMultiAnnotationsSelectionTap", () => {
              const {
                interactionMode: e,
                dispatch: t
              } = this.props;
              e === me.A.MULTI_ANNOTATIONS_SELECTION ? t((0, x.FA)()) : t((0, x.YF)());
            }), (0, r.Z)(this, "_handleDocumentAssistantTap", () => {
              const {
                showDocumentAssistant: e,
                dispatch: t
              } = this.props;
              t(e ? (0, x.Z_)(!1) : (0, x.Z_)(!0));
            }), (0, r.Z)(this, "_getBuiltInDefaults", (0, l.Z)((e, t, n, r, o, i, a, s, l, u, c, d, p, h, f, m, g, v, y) => {
              const {
                  formatMessage: b
                } = e,
                w = n === me.A.CONTENT_EDITOR;
              return {
                debug: {
                  className: "",
                  onPress: this._handleDebugTap,
                  title: "Debug Info",
                  forceHide: !t
                },
                image: {
                  className: "PSPDFKit-Toolbar-Button-Image-Annotation",
                  title: b(we.Z.imageAnnotation),
                  forceHide: r(re.sK),
                  responsiveGroup: "annotate",
                  preset: "image",
                  onPress: this._handleImageTap,
                  dropdownGroup: "image",
                  disabled: w
                },
                stamp: {
                  className: "PSPDFKit-Toolbar-Button-Stamp-Annotation",
                  selected: n === me.A.STAMP_PICKER || n === me.A.STAMP_CUSTOM,
                  onPress: this._handleStampTap,
                  title: b(we.Z.stampAnnotation),
                  forceHide: r(re.GI),
                  responsiveGroup: "annotate",
                  preset: "stamp",
                  dropdownGroup: "image",
                  disabled: w
                },
                link: {
                  className: "PSPDFKit-Toolbar-Button-Link-Annotation",
                  selected: n === me.A.LINK && "link" === this.state.lastSelectedToolbarItemType,
                  onPress: this._handleLinkTap,
                  title: b(we.Z.linkAnnotation),
                  forceHide: r(re.R1),
                  responsiveGroup: "annotate",
                  preset: "link",
                  dropdownGroup: "image",
                  disabled: w
                },
                ink: {
                  className: "PSPDFKit-Toolbar-Button-Ink-Annotation",
                  selected: n === me.A.INK && "ink" === f,
                  onPress: this._handleInkTap,
                  title: b(we.Z.pen),
                  forceHide: r(re.Zc),
                  responsiveGroup: "annotate",
                  dropdownGroup: "ink",
                  preset: "ink",
                  disabled: w
                },
                "ink-eraser": {
                  className: "PSPDFKit-Toolbar-Button-Ink-Eraser",
                  selected: n === me.A.INK_ERASER && "ink-eraser" === f,
                  onPress: this._handleInkEraserTap,
                  title: b(we.Z.eraser),
                  forceHide: r(re.Zc),
                  responsiveGroup: "annotate",
                  dropdownGroup: "ink",
                  preset: "ink",
                  disabled: w
                },
                highlighter: {
                  className: "PSPDFKit-Toolbar-Button-Ink-Annotation PSPDFKit-Toolbar-Button-Variant-Highlighter",
                  selected: n === me.A.INK && "highlighter" === f,
                  onPress: this._handleInkTap,
                  title: b(we.Z.highlighter),
                  forceHide: r(re.Zc),
                  responsiveGroup: "annotate",
                  dropdownGroup: "ink",
                  preset: "highlighter",
                  disabled: w
                },
                "text-highlighter": {
                  className: "PSPDFKit-Toolbar-Button-TextHighlighter-Annotation",
                  selected: n === me.A.TEXT_HIGHLIGHTER && "text-highlighter" === f,
                  onPress: this._handleTextHighlighterTap,
                  title: b(we.Z.textHighlighter),
                  forceHide: r(re.FV),
                  responsiveGroup: "annotate",
                  dropdownGroup: "ink",
                  preset: "text-highlighter",
                  disabled: w
                },
                line: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Line-Annotation",
                  selected: n === me.A.SHAPE_LINE && "line" === f,
                  onPress: this._handleLineTap,
                  title: b(we.Z.lineAnnotation),
                  forceHide: r(re.o9),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "line",
                  disabled: w
                },
                arrow: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Line-Annotation PSPDFKit-Toolbar-Button-Variant-Arrow",
                  selected: n === me.A.SHAPE_LINE && "arrow" === f,
                  onPress: this._handleLineTap,
                  title: b(we.Z.arrow),
                  forceHide: r(re.o9),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "arrow",
                  disabled: w
                },
                rectangle: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Rectangle-Annotation",
                  selected: n === me.A.SHAPE_RECTANGLE && "rectangle" === f,
                  onPress: this._handleRectangleTap,
                  title: b(we.Z.rectangleAnnotation),
                  forceHide: r(re.b3),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "rectangle",
                  disabled: w
                },
                "cloudy-rectangle": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Rectangle-Annotation PSPDFKit-Toolbar-Button-Variant-CloudyRectangle",
                  selected: n === me.A.SHAPE_RECTANGLE && "cloudy-rectangle" === f,
                  onPress: this._handleRectangleTap,
                  title: b(we.Z.cloudyRectangleAnnotation),
                  forceHide: r(re.b3),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "cloudy-rectangle",
                  disabled: w
                },
                "dashed-rectangle": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Rectangle-Annotation PSPDFKit-Toolbar-Button-Variant-DashedRectangle",
                  selected: n === me.A.SHAPE_RECTANGLE && "dashed-rectangle" === f,
                  onPress: this._handleRectangleTap,
                  title: b(we.Z.dashedRectangleAnnotation),
                  forceHide: r(re.b3),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "dashed-rectangle",
                  disabled: w
                },
                ellipse: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Ellipse-Annotation",
                  selected: n === me.A.SHAPE_ELLIPSE && "ellipse" === f,
                  onPress: this._handleEllipseTap,
                  title: b(we.Z.ellipseAnnotation),
                  forceHide: r(re.Xs),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "ellipse",
                  disabled: w
                },
                "cloudy-ellipse": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Ellipse-Annotation PSPDFKit-Toolbar-Button-Variant-CloudyEllipse",
                  selected: n === me.A.SHAPE_ELLIPSE && "cloudy-ellipse" === f,
                  onPress: this._handleEllipseTap,
                  title: b(we.Z.cloudyEllipseAnnotation),
                  forceHide: r(re.Xs),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "cloudy-ellipse",
                  disabled: w
                },
                "dashed-ellipse": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Ellipse-Annotation PSPDFKit-Toolbar-Button-Variant-DashedEllipse",
                  selected: n === me.A.SHAPE_ELLIPSE && "dashed-ellipse" === f,
                  onPress: this._handleEllipseTap,
                  title: b(we.Z.dashedEllipseAnnotation),
                  forceHide: r(re.Xs),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "dashed-ellipse",
                  disabled: w
                },
                polygon: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Polygon-Annotation",
                  selected: n === me.A.SHAPE_POLYGON && "polygon" === f,
                  onPress: this._handlePolygonTap,
                  title: b(we.Z.polygonAnnotation),
                  forceHide: r(re.Hi),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "polygon",
                  disabled: w
                },
                "cloudy-polygon": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Polygon-Annotation PSPDFKit-Toolbar-Button-Variant-CloudyPolygon",
                  selected: n === me.A.SHAPE_POLYGON && "cloudy-polygon" === f,
                  onPress: this._handlePolygonTap,
                  title: Te("cloudy-", this.props.items) ? b(we.Z.cloudAnnotation) : b(we.Z.cloudyPolygonAnnotation),
                  forceHide: r(re.Hi),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "cloudy-polygon",
                  disabled: w
                },
                "dashed-polygon": {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Polygon-Annotation PSPDFKit-Toolbar-Button-Variant-DashedPolygon",
                  selected: n === me.A.SHAPE_POLYGON && "dashed-polygon" === f,
                  onPress: this._handlePolygonTap,
                  title: b(we.Z.dashedPolygonAnnotation),
                  forceHide: r(re.Hi),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "dashed-polygon",
                  disabled: w
                },
                polyline: {
                  className: "PSPDFKit-Toolbar-Button-Shape-Annotation PSPDFKit-Toolbar-Button-Polyline-Annotation",
                  selected: n === me.A.SHAPE_POLYLINE && "polyline" === f,
                  onPress: this._handlePolylineTap,
                  title: b(we.Z.polylineAnnotation),
                  forceHide: r(re.om),
                  responsiveGroup: "annotate",
                  dropdownGroup: "shapes",
                  preset: "polyline",
                  disabled: w
                },
                note: {
                  className: "PSPDFKit-Toolbar-Button-Note-Annotation",
                  selected: n === me.A.NOTE && "note" === f,
                  onPress: this._handleNoteTap,
                  onKeyPress: this._handleNoteKeyPress,
                  title: b(we.Z.noteAnnotation),
                  forceHide: r(re.Qi),
                  responsiveGroup: "annotate",
                  preset: "note",
                  disabled: w
                },
                comment: {
                  className: "PSPDFKit-Toolbar-Button-Comment-Marker-Annotation",
                  selected: n === me.A.COMMENT_MARKER,
                  title: b(we.Z.comment),
                  onPress: this._handleCommentMarkerTap,
                  onKeyPress: this._handleCommentMarkerKeyPress,
                  forceHide: r(re.Jn),
                  responsiveGroup: "annotate",
                  disabled: w
                },
                signature: {
                  className: "PSPDFKit-Toolbar-Button-InkSignature-Annotation PSPDFKit-Toolbar-Button-Signature",
                  selected: n === me.A.INK_SIGNATURE || n === me.A.SIGNATURE,
                  onPress: this._handleSignatureTap,
                  title: b(we.Z.sign),
                  forceHide: s === ye.H.NONE || a || r(re.Zc) && s !== ye.H.ELECTRONIC_SIGNATURES,
                  responsiveGroup: "annotate",
                  preset: s === ye.H.ELECTRONIC_SIGNATURES ? "es-signature" : "ink-signature",
                  disabled: w
                },
                "redact-text-highlighter": {
                  className: "PSPDFKit-Toolbar-Button-RedactTextHighlighter-Annotation",
                  selected: n === me.A.REDACT_TEXT_HIGHLIGHTER,
                  onPress: this._handleRedactTextHighlighterTap,
                  title: b(we.Z.textRedaction),
                  forceHide: r(oe.Z),
                  responsiveGroup: "annotate",
                  dropdownGroup: "redaction",
                  preset: "redaction",
                  disabled: w
                },
                "redact-rectangle": {
                  className: "PSPDFKit-Toolbar-Button-Redaction-Annotation PSPDFKit-Toolbar-Button-Rectangle-Redaction-Annotation",
                  selected: n === me.A.REDACT_SHAPE_RECTANGLE,
                  onPress: this._handleRedactRectangleTap,
                  title: b(we.Z.areaRedaction),
                  forceHide: r(oe.Z),
                  responsiveGroup: "annotate",
                  dropdownGroup: "redaction",
                  preset: "redaction",
                  disabled: w
                },
                "form-creator": {
                  className: "PSPDFKit-Toolbar-Button-Form-Creator",
                  selected: (0, Ce.fF)(n),
                  onPress: this.handleFormDesignerTap,
                  title: b(we.Z.formCreator),
                  forceHide: r(re.x_),
                  disabled: w
                },
                pan: {
                  className: "PSPDFKit-Toolbar-Button-Pan",
                  selected: n === me.A.PAN,
                  onPress: this._handlePanTap,
                  title: b(Ie.panMode),
                  forceHide: pe.Ni,
                  disabled: w
                },
                print: {
                  className: "PSPDFKit-Toolbar-Button-Print",
                  onPress: this._handlePrintTap,
                  title: b(Ie.print),
                  disabled: !l || w
                },
                "document-editor": {
                  className: "PSPDFKit-Toolbar-Button-Document-Editor",
                  onPress: this._handleDocumentEditorTap,
                  title: b(we.Z.documentEditor),
                  dropdownGroup: "editor",
                  disabled: w
                },
                "document-crop": {
                  className: "PSPDFKit-Toolbar-Button-Document-Crop",
                  onPress: this.handleCropTap,
                  title: b(we.Z.documentCrop),
                  dropdownGroup: "editor",
                  selected: n === me.A.DOCUMENT_CROP,
                  disabled: w
                },
                "document-comparison": {
                  className: "PSPDFKit-Toolbar-Button-Document-Comparison",
                  onPress: this.handleDocumentComparisonTap,
                  title: b(we.Z.documentComparison),
                  dropdownGroup: "editor",
                  forceHide: !o,
                  selected: i,
                  disabled: w
                },
                search: {
                  className: "PSPDFKit-Toolbar-Button-Search",
                  selected: n === me.A.SEARCH,
                  onPress: this._handleSearchTap,
                  title: b(we.Z.searchDocument),
                  disabled: w
                },
                text: {
                  className: "PSPDFKit-Toolbar-Button-Text-Annotation",
                  selected: n === me.A.TEXT && "text" === this.state.lastSelectedToolbarItemType,
                  onPress: this._handleTextTap,
                  onKeyPress: this._handleTextKeyPress,
                  title: b(we.Z.textAnnotation),
                  forceHide: r(re.gd),
                  dropdownGroup: "text",
                  responsiveGroup: "annotate",
                  preset: "text",
                  disabled: w
                },
                callout: {
                  className: "PSPDFKit-Toolbar-Button-Callout-Annotation",
                  selected: n === me.A.CALLOUT && "callout" === this.state.lastSelectedToolbarItemType,
                  onPress: this.handleCalloutTap,
                  title: b(we.Z.calloutAnnotation),
                  forceHide: r(re.gd),
                  dropdownGroup: "text",
                  responsiveGroup: "annotate",
                  preset: "callout",
                  disabled: w
                },
                "zoom-mode": _e({
                  mediaQueries: [pe.Ni ? `(min-width: ${fe.Options.BREAKPOINT_MD_TOOLBAR}px)` : "all"]
                }, c === ve.c.FIT_TO_VIEWPORT ? {
                  className: "PSPDFKit-Toolbar-Button-Fit-To-Width",
                  onPress: this._handleFitToWidthTap,
                  title: b(Ie.fitWidth),
                  type: "fit-width",
                  disabled: w
                } : {
                  className: "PSPDFKit-Toolbar-Button-Fit-To-Page",
                  onPress: this._handleFitToBothTap,
                  title: b(Ie.fitPage),
                  type: "fit-page",
                  disabled: w
                }),
                "zoom-out": {
                  className: "PSPDFKit-Toolbar-Button-Zoom-Out",
                  disabled: p,
                  onPress: this._handleZoomOutTap,
                  title: b(Ie.zoomOut),
                  mediaQueries: [pe.Ni ? `(min-width: ${fe.Options.BREAKPOINT_MD_TOOLBAR}px)` : "all"]
                },
                "zoom-in": {
                  className: "PSPDFKit-Toolbar-Button-Zoom-In",
                  disabled: d,
                  onPress: this._handleZoomInTap,
                  title: b(Ie.zoomIn),
                  mediaQueries: [pe.Ni ? `(min-width: ${fe.Options.BREAKPOINT_MD_TOOLBAR}px)` : "all"]
                },
                undo: {
                  className: "PSPDFKit-Toolbar-Button-Undo",
                  disabled: !m || w,
                  onPress: this._handleUndoTap,
                  title: b(Ie.undo),
                  forceHide: a,
                  responsiveGroup: "annotate"
                },
                redo: {
                  className: "PSPDFKit-Toolbar-Button-Redo",
                  disabled: !g || w,
                  onPress: this._handleRedoTap,
                  title: b(Ie.redo),
                  forceHide: a,
                  responsiveGroup: "annotate"
                },
                "marquee-zoom": {
                  className: "PSPDFKit-Toolbar-Button-Marquee-Zoom",
                  selected: n === me.A.MARQUEE_ZOOM,
                  onPress: this._handleMarqueeZoomTap,
                  title: b(Ie.marqueeZoom),
                  disabled: w
                },
                spacer: {},
                pager: {
                  disabled: w
                },
                "layout-config": {
                  mediaQueries: [`(min-width: ${fe.Options.BREAKPOINT_SM_TOOLBAR + 1}px)`],
                  disabled: w
                },
                "multi-annotations-selection": {
                  className: "PSPDFKit-Toolbar-Button-Multiple-Annotations-Selection",
                  selected: n === me.A.MULTI_ANNOTATIONS_SELECTION,
                  onPress: this._handleMultiAnnotationsSelectionTap,
                  title: b(we.Z.multiAnnotationsSelection),
                  disabled: !v || w
                },
                annotate: {
                  className: "PSPDFKit-Toolbar-Button-Annotate",
                  onPress: this._handleAnnotateResponsiveGroupTap,
                  title: b(we.Z.annotations),
                  forceHide: r(re.q6),
                  mediaQueries: [`(max-width: ${fe.Options.BREAKPOINT_MD_TOOLBAR}px)`],
                  disabled: w
                },
                measure: {
                  className: "PSPDFKit-Toolbar-Button-Measurement-Annotation",
                  selected: n === me.A.MEASUREMENT || n === me.A.DISTANCE || n === me.A.PERIMETER || n === me.A.RECTANGLE_AREA || n === me.A.POLYGON_AREA || n === me.A.ELLIPSE_AREA,
                  onPress: this._handleMeasurementTap,
                  title: b(we.Z.measurement),
                  forceHide: r(re.q6),
                  responsiveGroup: "annotate",
                  preset: "measurement",
                  disabled: w
                },
                "responsive-group": {
                  onPress: (e, t) => this._handleResponsiveGroupTap(t),
                  disabled: w
                },
                "sidebar-thumbnails": {
                  className: "PSPDFKit-Toolbar-Button-Sidebar PSPDFKit-Toolbar-Button-Sidebar-Thumbnails",
                  title: b(Ie.thumbnails),
                  onPress: this._handleThumbnailsSidebarTap,
                  selected: h === ge.f.THUMBNAILS,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "sidebar-document-outline": {
                  className: "PSPDFKit-Toolbar-Button-Sidebar PSPDFKit-Toolbar-Button-Sidebar-Document-Outline",
                  title: b(Ie.outline),
                  onPress: this._handleDocumentOutlineSidebarTap,
                  selected: h === ge.f.DOCUMENT_OUTLINE,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "sidebar-annotations": {
                  className: "PSPDFKit-Toolbar-Button-Sidebar PSPDFKit-Toolbar-Button-Sidebar-Annotations",
                  title: b(we.Z.annotations),
                  onPress: this._handleAnnotationsSidebarTap,
                  selected: h === ge.f.ANNOTATIONS,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "sidebar-bookmarks": {
                  className: "PSPDFKit-Toolbar-Button-Bookmarks PSPDFKit-Toolbar-Button-Sidebar-Bookmarks",
                  title: b(we.Z.bookmarks),
                  onPress: this._handleBookmarksSidebarTap,
                  selected: h === ge.f.BOOKMARKS,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "sidebar-signatures": {
                  className: "PSPDFKit-Toolbar-Button-Signatures PSPDFKit-Toolbar-Button-Sidebar-Signatures",
                  title: b(we.Z.signatures),
                  onPress: this._handleSignaturesSidebarTap,
                  selected: h === ge.f.SIGNATURES,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "sidebar-layers": {
                  className: "PSPDFKit-Toolbar-Button-Sidebar PSPDFKit-Toolbar-Button-Sidebar-Layers",
                  title: b(we.Z.layers),
                  onPress: this._handleOCGsSidebarTap,
                  selected: h === ge.f.LAYERS,
                  forceHide: this.props.shouldHideOCGsSidebar,
                  dropdownGroup: "sidebar",
                  disabled: w
                },
                "export-pdf": {
                  className: "PSPDFKit-Toolbar-Button-Export-PDF",
                  title: b(we.Z.export),
                  onPress: this._handleExportPDFTap,
                  disabled: !u || w,
                  selected: !1
                },
                "content-editor": {
                  className: "PSPDFKit-Toolbar-Button-Content-Editor",
                  onPress: this._handleContentEditorTap,
                  title: b(we.Z.contentEditor),
                  selected: n === me.A.CONTENT_EDITOR
                },
                "document-assistant": {
                  className: "PSPDFKit-Toolbar-Button-Document-Assistant",
                  onPress: this._handleDocumentAssistantTap,
                  title: b(we.Z.documentAI),
                  selected: y
                }
              };
            })), (0, r.Z)(this, "_prepareToolbarItems", (0, l.Z)((e, t, n, r, o, i, a, s, l, u, c, d, p, h, f, m, g, v, y, b, w, x, D, C, S) => {
              const E = this._getBuiltInDefaults(e, t, n, o, i, a, r, s, l, u, c, d, p, h, b, w, x, D, S),
                _ = a ? f : (0, ue.q1)(f, E, C ? g : m),
                P = (0, ue.DQ)(_, E),
                k = a ? function (e) {
                  return e.filter(e => ze.includes(e.get("type")));
                }(P) : P,
                A = (0, ue.Ut)((0, ue.hJ)(k)),
                z = (0, ue.Ut)(k, !0, v);
              return {
                items: A,
                groupedItems: this.getDropdownGroupGroupedItems(A),
                groupedResponsiveItems: this.getDropdownGroupGroupedItems(z)
              };
            })), (0, r.Z)(this, "_onMediaQueryUpdate", () => {
              var e;
              null !== (e = this.props.frameWindow) && void 0 !== e && e.matchMedia("print").matches || this.setState({
                mediaQueryDidUpdate: {}
              });
            }), (0, r.Z)(this, "_updateMediaQueryListener", () => {
              const {
                  intl: e,
                  debugMode: t,
                  interactionMode: n,
                  isAnnotationTypeReadOnly: r,
                  isDocumentComparisonAvailable: o,
                  currentDocumentComparisonMode: i,
                  isDocumentReadOnly: a,
                  signatureFeatureAvailability: s,
                  printingEnabled: l,
                  exportEnabled: u,
                  zoomMode: c,
                  maxZoomReached: d,
                  minZoomReached: p,
                  sidebarMode: h,
                  items: f,
                  canUndo: m,
                  canRedo: g,
                  isMultiSelectionEnabled: v,
                  showDocumentAssistant: y
                } = this.props,
                b = this._getBuiltInDefaults(e, t, n, r, o, !!i, a, s, l, u, c, d, p, h, this.state.lastSelectedToolbarItemType, m, g, v, y),
                w = (0, ue.se)(f, b),
                x = this.props.shadowRoot ? this.props.resizeWatchFrameWindow : this.props.frameWindow;
              x && (w.forEach(e => {
                if (this._mediaListeners.hasOwnProperty(e)) return;
                const t = null == x ? void 0 : x.matchMedia(e);
                t && (t.addListener(this._onMediaQueryUpdate), this._mediaListeners[e] = t);
              }), Object.keys(this._mediaListeners).filter(e => !w.includes(e)).forEach(e => {
                this._mediaListeners[e].removeListener(this._onMediaQueryUpdate), delete this._mediaListeners[e];
              }));
            }), (0, r.Z)(this, "_handleKeyPress", e => {
              e.keyCode === d.zz && this.state.activeResponsiveGroup && this._handleResponsiveGroupClose();
            }), (0, r.Z)(this, "_handleOnPress", function (t, n, r, o, i) {
              let a = arguments.length > 5 && void 0 !== arguments[5] && arguments[5],
                s = arguments.length > 6 ? arguments[6] : void 0;
              (0, ue.Li)(o) && e.setState({
                lastSelectedToolbarItemType: o
              }), (0, p.dC)(() => {
                a && s ? s(n, r, i, a) : t(n, r, i, a), e.props.dispatch((0, x.qB)(a));
              });
            }), (0, r.Z)(this, "DropdownItemComponent", o.forwardRef((e, t) => {
              if (!e.item) return null;
              const n = e.item.item,
                r = e.item.index,
                {
                  isSelectedItem: o,
                  state: i,
                  itemComponentProps: a
                } = e;
              return Ae(this.props, _e(_e({}, n), {}, {
                className: s()(n.className, {
                  [A().dropdownButtonSelected]: null == i ? void 0 : i.includes("selected"),
                  [A().dropdownButtonDisabled]: null == i ? void 0 : i.includes("disabled"),
                  [A().dropdownButtonFocused]: null == i ? void 0 : i.includes("focused")
                }),
                onPress: o ? n.onPress : void 0
              }), r, this._handleOnPress, !o, t, a);
            })), (0, r.Z)(this, "_renderGroupedItems", e => {
              let {
                groupedItems: t,
                classNamePartial: n
              } = e;
              return t.map((e, t) => Array.isArray(e) ? e.length < 2 ? Ae(this.props, e[0].item, e[0].index, this._handleOnPress, !1, 0 === t ? this.itemToFocusRef : void 0) : o.createElement(ne.Z, {
                frameWindow: this.props.frameWindow,
                items: e,
                disabled: e.every(e => e.item.disabled),
                ItemComponent: this.DropdownItemComponent,
                role: "menu",
                onSelect: (t, n) => {
                  const {
                    onPress: r,
                    id: o,
                    type: i,
                    preset: a,
                    disabled: s
                  } = n.item;
                  if (!s && (e.forEach(e => {
                    delete e.item.selected;
                  }), r)) {
                    const e = "keydown" === t.type;
                    this._handleOnPress(r, t, o, i, a, e);
                  }
                },
                isActive: e.some(e => e.item.selected),
                key: `toolbar-items-group-${t}-${n}`,
                caretDirection: this.props.toolbarPlacement === be.p.TOP ? "down" : "up",
                ref: 0 === t ? this.itemToFocusRef : void 0
              }) : Ae(this.props, e.item, e.index, this._handleOnPress, !1, 0 === t || e.item.type === this.state.prevActiveGroup ? this.itemToFocusRef : void 0));
            });
          }
          static getDerivedStateFromProps(e, t) {
            let n = null;
            if (e.interactionMode && e.interactionMode in ue.FO) {
              const t = ue.FO[e.interactionMode];
              Array.isArray(t) ? n = e.currentItemPreset && t.includes(e.currentItemPreset) ? e.currentItemPreset : t[0] : "string" == typeof t && (n = t);
            }
            return n !== t.lastSelectedToolbarItemType ? {
              lastSelectedToolbarItemType: n,
              currentPageIndex: e.currentPageIndex
            } : {
              currentPageIndex: e.currentPageIndex
            };
          }
          getDropdownGroupGroupedItems(e) {
            let t = (0, i.aV)();
            const n = {};
            return e.forEach((e, r) => {
              const o = (0, i.D5)({
                  index: r,
                  item: e
                }),
                a = e.get("dropdownGroup");
              a ? void 0 !== n[a] ? t = t.update(n[a], e => e instanceof i.aV ? e.push(o) : e) : (n[a] = t.size, t = t.push((0, i.aV)([o]))) : t = t.push(o);
            }), t.toJS();
          }
          componentDidUpdate(e, t) {
            this._updateMediaQueryListener();
            const n = t && !t.activeResponsiveGroup && this.state.activeResponsiveGroup,
              r = t && t.activeResponsiveGroup && !this.state.activeResponsiveGroup;
            (n || r) && this.itemToFocusRef.current && this.itemToFocusRef.current.focus();
          }
          componentDidMount() {
            this._updateMediaQueryListener();
          }
          componentWillUnmount() {
            Object.keys(this._mediaListeners).forEach(e => {
              this._mediaListeners[e].removeListener(this._onMediaQueryUpdate), delete this._mediaListeners[e];
            });
          }
          shouldComponentUpdate(e, t) {
            const n = _e(_e({}, e), {}, {
                currentPageIndex: this.props.currentPageIndex
              }),
              r = _e(_e({}, t), {}, {
                currentPageIndex: this.state.currentPageIndex
              });
            return h.O.bind(this)(n, r);
          }
          render() {
            const {
                props: e
              } = this,
              {
                intl: t,
                debugMode: n,
                interactionMode: r,
                isDocumentReadOnly: i,
                isAnnotationTypeReadOnly: a,
                isDocumentComparisonAvailable: s,
                currentDocumentComparisonMode: l,
                signatureFeatureAvailability: u,
                printingEnabled: d,
                exportEnabled: p,
                zoomMode: h,
                maxZoomReached: f,
                minZoomReached: m,
                sidebarMode: g,
                items: v,
                frameWindow: y,
                resizeWatchFrameWindow: b,
                toolbarPlacement: w,
                canUndo: x,
                canRedo: D,
                isMultiSelectionEnabled: C,
                shadowRoot: S,
                showDocumentAssistant: E
              } = e,
              {
                formatMessage: _
              } = t,
              {
                activeResponsiveGroup: P,
                mediaQueryDidUpdate: k,
                lastSelectedToolbarItemType: z
              } = this.state,
              {
                groupedItems: T,
                groupedResponsiveItems: O
              } = this._prepareToolbarItems(t, n, r, i, a, s, !!l, u, d, p, h, f, m, g, v, y, b, P, k, z, x, D, C, S, E),
              I = P && O.length,
              F = I ? this._renderGroupedItems({
                groupedItems: O,
                classNamePartial: "groupedResponsiveItems"
              }) : this._renderGroupedItems({
                groupedItems: T,
                classNamePartial: "groupedItems"
              }),
              M = I && T.filter(e => !Array.isArray(e)).find(e => e.item.id === P),
              R = M && M.item ? M.item.title : void 0,
              j = v.some(e => "image" === e.get("type"));
            return o.createElement("div", {
              className: `PSPDFKit-Toolbar ${A().root}`,
              onKeyDown: this._handleKeyPress
            }, I ? null : F, o.createElement(te.Z, {
              onClose: this._handleResponsiveGroupClose,
              isPrimary: !0,
              position: w === be.p.TOP ? "top" : "bottom",
              accessibilityLabel: R
            }, I ? F : null), j && o.createElement(c.TX, {
              tag: "div"
            }, o.createElement("input", {
              ref: this.imagePickerRef,
              "aria-label": _(Ie.selectImage),
              "aria-hidden": !0,
              type: "file",
              accept: "image/png, image/jpeg, application/pdf",
              onChange: this._handleImageSelect,
              tabIndex: -1
            })));
          }
        }
        function Ae(e, t, n, r, i, a, l) {
          switch (t.type) {
            case "spacer":
              return o.createElement("div", {
                style: {
                  flex: 1
                },
                key: `spacer-${n}`
              });
            case "pager":
              return o.createElement(J, {
                dispatch: e.dispatch,
                pages: e.pages,
                totalPages: e.totalPages,
                key: e.currentPageIndex.toString(),
                readOnly: e.scrollMode === w.G.DISABLED
              });
            case "layout-config":
              var u;
              return o.createElement(V, {
                dispatch: e.dispatch,
                key: "layout-config",
                className: t.className,
                icon: t.icon,
                layoutMode: e.layoutMode,
                scrollMode: e.scrollMode,
                caretDirection: e.toolbarPlacement === be.p.TOP ? "down" : "up",
                frameWindow: e.frameWindow,
                disabled: null !== (u = t.disabled) && void 0 !== u && u
              });
            default:
              {
                const {
                  type: e,
                  id: u,
                  className: c,
                  disabled: d,
                  selected: p,
                  icon: h,
                  title: f,
                  onPress: m,
                  preset: g,
                  onKeyPress: v
                } = t;
                return "custom" === e && t.node ? o.createElement(ee.Z, {
                  node: t.node,
                  className: c,
                  onPress: m ? t => r(m, t, u, e, g) : void 0,
                  title: f,
                  disabled: d,
                  selected: p,
                  ref: a,
                  itemComponentProps: l,
                  key: `custom-node-${n}`
                }) : o.createElement(P.Z, {
                  type: e,
                  className: s()(c, i ? A().dropdownButton : A().toolbarButton),
                  disabled: d,
                  selected: p,
                  icon: h,
                  title: f,
                  onPress: m ? (t, n) => r(m, t, u, e, g, n, v) : void 0,
                  key: `${e}-${n}`,
                  children: i ? f : void 0,
                  role: i ? "menuitem" : void 0,
                  ref: a,
                  itemComponentProps: l,
                  doNotAutoFocusOnFirstItem: !0
                });
              }
          }
        }
        const ze = ["pan", "zoom-in", "zoom-out", "fit-page", "fit-width", "spacer", "export-pdf", "document-comparison"];
        function Te(e, t) {
          return 1 === t.filter(t => {
            var n;
            return null === (n = t.get("type")) || void 0 === n ? void 0 : n.startsWith(e);
          }).size;
        }
        const Oe = (0, u.XN)(ke),
          Ie = (0, u.vU)({
            thumbnails: {
              id: "thumbnails",
              defaultMessage: "Thumbnails",
              description: "Show or hide the thumbnails sidebar"
            },
            outline: {
              id: "outline",
              defaultMessage: "Outline",
              description: "Show or hide the document outline sidebar"
            },
            panMode: {
              id: "panMode",
              defaultMessage: "Pan Mode",
              description: "Activate and deactivate the pan mode (the hand cursor to move the page)"
            },
            zoomIn: {
              id: "zoomIn",
              defaultMessage: "Zoom In",
              description: "Zoom in the document"
            },
            zoomOut: {
              id: "zoomOut",
              defaultMessage: "Zoom Out",
              description: "Zoom out the document"
            },
            undo: {
              id: "undo",
              defaultMessage: "Undo",
              description: "Undo a previous annotation operation"
            },
            redo: {
              id: "redo",
              defaultMessage: "Redo",
              description: "Redo a previous annotation operation"
            },
            marqueeZoom: {
              id: "marqueeZoom",
              defaultMessage: "Marquee Zoom",
              description: "Enables Marquee Zoom mode which allows to zoom to a rectangle"
            },
            fitPage: {
              id: "fitPage",
              defaultMessage: "Fit Page",
              description: "Fit the page in the viewer based on the bigger dimension"
            },
            fitWidth: {
              id: "fitWidth",
              defaultMessage: "Fit Width",
              description: "Fit the page in the document based on its width"
            },
            print: {
              id: "print",
              defaultMessage: "Print",
              description: "print"
            },
            selectImage: {
              id: "selectImage",
              defaultMessage: "Select Image",
              description: "Label for the select image field"
            },
            unsupportedImageFormat: {
              id: "unsupportedImageFormat",
              defaultMessage: "Unsupported type for image annotation: {arg0}. Please use a JPEG, PNG or PDF.",
              description: "Unsupported image type error."
            },
            newAnnotationCreated: {
              id: "newAnnotationCreated",
              defaultMessage: "New {arg0} annotation created.",
              description: "A new annotation was created."
            },
            selectAFileForImage: {
              id: "selectAFileForImage",
              defaultMessage: "Select a file for the new image annotation.",
              description: "Select a file from the file dialog for the new image annotation."
            }
          });
      },
      22690: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => z
        });
        var r = n(22122),
          o = n(96156),
          i = n(67294),
          a = n(94184),
          s = n.n(a),
          l = n(35782),
          u = n(41756),
          c = n(67665),
          d = n(86849),
          p = n(31672),
          h = n(35369),
          f = n(67366),
          m = n(98260),
          g = n(98179),
          v = n(71623),
          y = n(46302),
          b = n(10983),
          w = n(17722),
          x = n.n(w),
          D = n(84691),
          C = n.n(D),
          S = n(94683),
          E = n.n(S),
          _ = n(18920);
        function P(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function k(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? P(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function A(e, t) {
          var n, o, a;
          const {
              items: w,
              value: D,
              onSelect: S,
              children: P,
              appendAfter: A,
              menuPositionOffsets: z
            } = e,
            {
              formatMessage: I
            } = (0, l.YB)(),
            F = (0, f.v9)(e => e.shadowRoot),
            M = (0, f.v9)(e => e.containerRect),
            R = i.useRef(null),
            j = i.useCallback(e => {
              let {
                selectedItem: t
              } = e;
              S && S(R.current || (0, _._t)("click"), t), R.current = null;
            }, [S]),
            B = i.useRef(),
            N = null !== (n = i.useMemo(() => w.find(e => e.value === (null == D ? void 0 : D.value)), [w, D])) && void 0 !== n ? n : D,
            L = e.ItemComponent,
            V = {
              root: s()("PSPDFKit-Input-Dropdown", e.isActive && !e.disabled && "PSPDFKit-Input-Dropdown-active", "PSPDFKit-Toolbar-Dropdown", e.className, x().withDropdown, !e.isActive && x().withDropdownIdle, e.disabled && x().withDropdownDisabled, N && "string" == typeof N.icon ? N.icon : void 0),
              button: s()("PSPDFKit-Input-Dropdown-Button", x().dropdown, e.isActive && !e.disabled && x().isActive, {
                [x().discreteDropdown]: e.discreteDropdown,
                [x().isDisabled]: e.disabled
              }),
              menu: s()("PSPDFKit-Input-Dropdown-Items", C().root, e.menuClassName)
            },
            [K, q] = i.useState(!1),
            H = F ? (0, m.ke)(F, window) : e.frameWindow,
            {
              getToggleButtonProps: U,
              getMenuProps: Z,
              getItemProps: $,
              getLabelProps: G,
              isOpen: W,
              selectedItem: Y,
              highlightedIndex: X,
              setHighlightedIndex: Q
            } = (0, u.L7)(k(k({}, e.frameWindow ? k({}, H ? {
              environment: H
            } : null) : null), {}, {
              items: w,
              itemToString: T,
              selectedItem: N,
              onHighlightedIndexChange: e => {
                switch (e.type) {
                  case u.L7.stateChangeTypes.MenuKeyDownArrowDown:
                  case u.L7.stateChangeTypes.MenuKeyDownArrowUp:
                  case u.L7.stateChangeTypes.MenuKeyDownEscape:
                  case u.L7.stateChangeTypes.MenuKeyDownHome:
                  case u.L7.stateChangeTypes.MenuKeyDownEnd:
                  case u.L7.stateChangeTypes.MenuKeyDownEnter:
                  case u.L7.stateChangeTypes.MenuKeyDownSpaceButton:
                  case u.L7.stateChangeTypes.MenuKeyDownCharacter:
                  case u.L7.stateChangeTypes.FunctionSetHighlightedIndex:
                    !K && q(!0);
                    break;
                  default:
                    K && q(!1);
                }
              },
              onSelectedItemChange: t => {
                "menu" !== e.role && j(t);
              },
              circularNavigation: !e.hasOwnProperty("circularNavigation") || e.circularNavigation,
              getA11yStatusMessage() {},
              getA11ySelectionMessage() {}
            })),
            J = U({
              onKeyDown: e => {
                let {
                  nativeEvent: t,
                  key: n
                } = e;
                "Enter" === n && (R.current = t);
              },
              onClick: e => {
                e.target.focus && e.target.focus();
              },
              "aria-haspopup": "menu" === e.role ? "true" : "listbox"
            }),
            ee = Z({
              onKeyDown: t => {
                if (t.keyCode === d.zz && W && !e.propagateEscPress) t.stopPropagation();else if ((t.keyCode === d.E$ || t.keyCode === d.tW) && X > -1 && "menu" === e.role && W && !w[X].disabled) R.current = t.nativeEvent, j({
                  selectedItem: w[X]
                });else if (t.keyCode === d.P9 && oe > 1) Q(0 === X ? w.length : X - 1);else if (t.keyCode === d.gs && oe > 1) Q(X === w.length - 1 ? 0 : X + 1);else if (t.keyCode === d.OC && B.current) {
                  const e = B.current.querySelector(`#${J.id}`);
                  e && e.focus();
                }
              }
            }, {
              suppressRefError: !0
            }),
            te = G(),
            ne = e.ButtonComponent,
            re = "menu" === e.role ? {
              role: void 0,
              "aria-labelledby": void 0,
              "aria-haspopup": void 0,
              "aria-expanded": void 0
            } : {},
            oe = Math.min(w.length, e.maxCols || 1),
            ie = {
              display: "flex",
              flexDirection: oe > 1 ? "row" : "column",
              flexWrap: "wrap",
              width: e.itemWidth ? oe * e.itemWidth : "auto",
              boxSizing: "content-box"
            },
            ae = null != e.icon ? e.icon : {};
          return i.createElement("div", (0, r.Z)({
            className: s()(W && "PSPDFKit-Input-Dropdown-open", V.root)
          }, re, {
            "data-test-id": e["data-test-id"]
          }), i.createElement(p.TX, {
            tag: "div"
          }, i.createElement("span", te, e.accessibilityLabel)), i.createElement("div", {
            ref: B,
            className: s()(x().wrapper, (null == Y ? void 0 : Y.className) || "", {
              [x().disabledWrapper]: e.disabled,
              [x().isDisabled]: e.disabled
            })
          }, ne ? ne({
            btnComponentProps: J,
            selectedItem: Y,
            ref: t,
            caretDirection: e.caretDirection,
            disabled: null !== (o = e.disabled) && void 0 !== o && o,
            isOpen: W
          }) : i.createElement(i.Fragment, null, L({
            item: Y,
            isSelectedItem: !0,
            state: null,
            ref: t
          }), i.createElement("button", (0, r.Z)({}, k(k({}, J), e.disabled ? {
            onClick: null
          } : null), {
            className: V.button,
            style: {
              minWidth: 0
            },
            type: "button"
          }), i.createElement(v.Z, (0, r.Z)({
            type: `caret-${e.caretDirection}`,
            style: {
              width: 12,
              height: "100%"
            },
            className: s()("PSPDFKit-Toolbar-Button-Icon", x().dropdownIcon, {
              [x().disabledDropdownIcon]: e.disabled
            })
          }, ae)), i.createElement(p.TX, {
            tag: "div"
          }, i.createElement("span", null, null == Y ? void 0 : Y.label))))), i.createElement(c.m, null, i.createElement(y.Z, {
            referenceElement: B.current,
            measure: W,
            offsets: z
          }, t => {
            let {
              ref: n,
              style: o
            } = t;
            const l = "down" === e.caretDirection;
            let u;
            u = (e.frameWindow ? e.frameWindow.innerWidth : F ? M.width : B.current.ownerDocument.defaultView.innerWidth) >= b.Fg ? B.current.offsetWidth : "auto";
            const c = o.top,
              d = {
                maxHeight: l && "auto" !== c ? M.height - B.current.offsetHeight - c + "px" : void 0,
                overflowY: "auto"
              };
            return i.createElement("div", {
              ref: n,
              style: k({
                minWidth: u
              }, o)
            }, i.createElement("div", (0, r.Z)({}, ee, {
              className: `${V.menu} ${s()({
                [C().hiddenMenu]: !W
              })}`,
              style: k(k({}, d), ie),
              onMouseLeave: () => Q(null),
              role: "menu" === e.role ? "menu" : "listbox",
              "aria-labelledby": J["aria-label"] ? void 0 : ee["aria-labelledby"],
              "aria-label": J["aria-label"],
              "aria-hidden": !W
            }), W && w.map((t, n) => {
              var r;
              const o = !!Y && (Y.value || t.label) === (t.value || t.label),
                l = function (e, t, n) {
                  return t.indexOf(e) === n;
                }(t, w, X);
              let u = (0, h.l4)();
              t.disabled && (u = u.add("disabled")), l && (u = u.add("focused")), o && (u = u.add("selected")), t.disabled || l || o || (u = u.add("default"));
              const c = s()("PSPDFKit-Input-Dropdown-Item", t.className || "", {
                  "PSPDFKit-Input-Dropdown-Item-disabled": t.disabled,
                  "PSPDFKit-Input-Dropdown-Item-focused": !t.disabled && l,
                  "PSPDFKit-Input-Dropdown-Item-selected": !t.disabled && o,
                  "PSPDFKit-Input-Dropdown-Item-default": !t.disabled && !o && !l,
                  [E().focusVisible]: l && K
                }),
                d = $(k({
                  item: t,
                  index: n,
                  disabled: null !== (r = t.disabled) && void 0 !== r && r,
                  onClick: n => {
                    let {
                      nativeEvent: r
                    } = n;
                    t.disabled || (R.current = r, "menu" === e.role && W && j({
                      selectedItem: t
                    }));
                  }
                }, "menu" === e.role ? {
                  "aria-selected": void 0,
                  role: void 0
                } : g.G6 ? {} : {
                  "aria-selected": void 0,
                  "aria-label": o ? I(O.selectedItem, {
                    arg0: t.label
                  }) : void 0
                }));
              return i.createElement(i.Fragment, {
                key: `${T(t)}${n}`
              }, i.createElement("div", {
                className: c
              }, L({
                item: t,
                isSelectedItem: !1,
                state: u,
                itemComponentProps: d
              })), null != A && (null == A ? void 0 : A.index) === n && (a || (a = i.createElement(A.node, null))));
            }), P));
          })));
        }
        const z = (0, i.memo)(i.forwardRef(A));
        function T(e) {
          return null != e && e.label ? null == e ? void 0 : e.label : (null != (null == e ? void 0 : e.value) && "object" == typeof e.value && "toString" in e.value && "function" == typeof e.value.toString && e.value.toString(), null != (null == e ? void 0 : e.value) && "string" == typeof e.value ? e.value : "N/A");
        }
        const O = (0, l.vU)({
          accessibilityLabelDropdownGroupToggle: {
            id: "accessibilityLabelDropdownGroupToggle",
            defaultMessage: "{arg0} tools, toggle menu",
            description: "Accessible label to announce the button to open and close a toolbar menu which contains tools like shapes or ink annotations buttons."
          },
          selectedItem: {
            id: "selectedItem",
            defaultMessage: "{arg0}, selected",
            description: "Label for selected item in a dropdown"
          }
        });
      },
      3324: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => m
        });
        var r = n(22122),
          o = n(17375),
          i = n(35782),
          a = n(67294),
          s = n(94184),
          l = n.n(s),
          u = n(17722),
          c = n.n(u),
          d = n(22690),
          p = n(82716);
        const h = ["item"],
          f = ["selectedItem"],
          m = a.memo(a.forwardRef(function (e, t) {
            const {
                items: n,
                noInitialSelection: s,
                ItemComponent: u,
                ButtonComponent: m
              } = e,
              [b, w] = a.useState(null),
              {
                formatMessage: x
              } = (0, i.YB)(),
              D = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Toolbar";
                return e.charAt(0).toUpperCase() + e.substr(1);
              }(n[0].item.dropdownGroup),
              C = a.useMemo(() => n.find(e => e.item.selected) || b || (s ? null : n[0]), [n, s, b]),
              S = l()("PSPDFKit-Toolbar-DropdownGroup", D && "PSPDFKit-Toolbar-DropdownGroup-" + D, e.className, C ? "string" == typeof C.item.icon ? C.item.icon : "string" == typeof C.item.type && "custom" !== C.item.type ? c().withDropdownIcon : void 0 : void 0),
              E = e.items.map(g),
              _ = C ? g(C) : null,
              P = a.useCallback(e => {
                const {
                    item: i
                  } = e,
                  s = (0, o.Z)(e, h),
                  l = n.find(e => null != i ? v(i, e) : null);
                return a.createElement(u, (0, r.Z)({
                  item: l
                }, s, {
                  ref: t
                }));
              }, [n, u, t]),
              k = a.useCallback(e => {
                const {
                    selectedItem: t
                  } = e,
                  i = (0, o.Z)(e, f),
                  s = n.find(e => null != t ? v(t, e) : null);
                return (0, p.k)(s, "A dropdown item must be present for the button"), (0, p.k)(m, "A button must be available to render dropdown"), a.createElement(m, (0, r.Z)({
                  selectedItem: s
                }, i));
              }, [m, n]);
            return a.createElement(d.Z, {
              onSelect: (t, n) => {
                const r = e.items.find(e => v(n, e));
                var o;
                null != r && (null === (o = e.onSelect) || void 0 === o || o.call(e, t, r));
                if (b !== e.items.find(e => v(n, e))) {
                  const t = e.items.find(e => v(n, e));
                  t && w(t);
                }
              },
              items: E,
              value: _,
              ItemComponent: P,
              ButtonComponent: m ? k : void 0,
              isActive: e.isActive,
              className: S,
              menuClassName: e.menuClassName,
              icon: e.icon,
              discreteDropdown: e.discreteDropdown,
              caretDirection: e.caretDirection,
              frameWindow: e.frameWindow,
              role: e.role,
              ref: t,
              accessibilityLabel: e.accessibilityLabel || x(y.accessibilityLabelDropdownGroupToggle, {
                arg0: D
              }),
              noInitialSelection: e.noInitialSelection,
              maxCols: e.maxCols,
              itemWidth: e.itemWidth,
              circularNavigation: e.circularNavigation,
              propagateEscPress: e.propagateEscPress,
              appendAfter: e.appendAfter,
              disabled: e.disabled
            }, e.children);
          }));
        function g(e) {
          var t, n, r, o;
          return {
            value: null !== (t = null !== (n = null !== (r = e.item.id) && void 0 !== r ? r : e.item.title) && void 0 !== n ? n : e.item.type) && void 0 !== t ? t : "",
            icon: e.item.icon,
            label: null !== (o = e.item.title) && void 0 !== o ? o : "",
            disabled: e.item.disabled
          };
        }
        function v(e, t) {
          return t.item.id === e.value || t.item.title === e.value || t.item.type === e.value;
        }
        const y = (0, i.vU)({
          accessibilityLabelDropdownGroupToggle: {
            id: "accessibilityLabelDropdownGroupToggle",
            defaultMessage: "{arg0} tools, toggle menu",
            description: "Accessible label to announce the button to open and close a toolbar menu which contains tools like shapes or ink annotations buttons."
          },
          selectedItem: {
            id: "selectedItem",
            defaultMessage: "{arg0}, selected",
            description: "Label for selected item in a dropdown"
          }
        });
      },
      80292: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(22122),
          o = n(67294),
          i = n(94184),
          a = n.n(i),
          s = n(60101);
        const l = o.forwardRef(function (e, t) {
          const {
              selected: n,
              disabled: i
            } = e,
            l = a()("string" == typeof e.className && e.className, "PSPDFKit-Toolbar-Node", n && "PSPDFKit-Toolbar-Node-active", i && "PSPDFKit-Toolbar-Node-disabled");
          return o.createElement(s.Z, (0, r.Z)({}, e, {
            className: l,
            ref: t,
            itemComponentProps: e.itemComponentProps
          }));
        });
      },
      76465: (e, t, n) => {
        "use strict";

        n.d(t, {
          B: () => h,
          Z: () => f
        });
        var r = n(67294),
          o = n(35782),
          i = n(26353),
          a = n(84013),
          s = n(94184),
          l = n.n(s),
          u = n(13524),
          c = n.n(u),
          d = n(17766),
          p = n(54130);
        function h(e) {
          let {
            children: t,
            onClose: n,
            isPrimary: o,
            position: s,
            intl: u,
            accessibilityLabel: h,
            onEntered: f,
            className: m
          } = e;
          const {
              formatMessage: g
            } = u,
            v = r.Children.count(t) > 0;
          return r.createElement(a.Z, null, v && r.createElement(i.Z, {
            timeout: {
              enter: window["PSPDFKit-disable-animations"] ? 0 : 150,
              exit: window["PSPDFKit-disable-animations"] ? 0 : 120
            },
            classNames: {
              enter: c().slideRightEnter,
              enterActive: c().slideRightEnterActive,
              enterDone: c().slideRightEnterDone,
              exit: c().slideRightExit,
              exitActive: c().slideRightExitActive
            },
            onEntered: f
          }, r.createElement("div", {
            className: l()({
              [c().responsiveGroup]: !0,
              [c().primary]: o,
              [c().secondary]: !o,
              [c().stickToBottom]: "bottom" === s,
              "PSPDFKit-Toolbar-Responsive-Group": !0
            }, m),
            role: "dialog",
            "aria-label": h
          }, r.createElement(p.Z, {
            type: "custom",
            title: g(d.Z.close),
            className: c().button,
            onPress: n
          }, r.createElement("div", {
            className: c().animatedArrow
          })), r.createElement("div", {
            style: {
              flex: 1
            }
          }), r.createElement("div", {
            className: c().items
          }, t))));
        }
        const f = (0, o.XN)(h);
      },
      80422: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => c
        });
        var r = n(22122),
          o = n(67294),
          i = n(94184),
          a = n.n(i),
          s = n(71623),
          l = n(43165),
          u = n.n(l);
        const c = o.memo(o.forwardRef(function (e, t) {
          const {
              type: n,
              selected: i,
              disabled: l,
              onPress: c,
              icon: d,
              role: p,
              title: h,
              doNotAutoFocusOnFirstItem: f = !1
            } = e,
            m = o.useRef(!1),
            g = o.useCallback(function (e) {
              e.preventDefault(), !l && c && c(e.nativeEvent, m.current);
            }, [c, l]),
            v = o.useCallback(function () {
              m.current = !0;
            }, []),
            y = o.useCallback(function () {
              m.current = !1;
            }, []),
            b = (0, s.Z)({
              icon: d,
              type: n,
              className: a()(void 0 !== e.children && u().withLabel, "PSPDFKit-Tool-Button-Icon", e.iconClassName)
            }),
            w = e.children || (b ? null : h),
            x = a()(u().root, i && u().isActive, l && u().isDisabled, "string" == typeof e.className && e.className, "PSPDFKit-Tool-Button", i && "PSPDFKit-Tool-Button-active", l && "PSPDFKit-Tool-Button-disabled");
          o.useEffect(() => {
            !e.presentational && t && t.current && !f && t.current.focus();
          }, [e.presentational, t, f]);
          const D = o.createElement("button", (0, r.Z)({
            className: x,
            title: h,
            "aria-label": h,
            disabled: l,
            onClick: c ? g : void 0,
            onKeyDown: c ? v : void 0,
            onPointerUp: c ? y : void 0,
            "aria-pressed": "annotate" !== n && "responsive-group" !== n && void 0 !== i ? i : void 0
          }, e.itemComponentProps, {
            role: p || (e.itemComponentProps ? e.itemComponentProps.role : void 0),
            type: "button",
            ref: t
          }), b, null != w && o.createElement("span", null, w));
          return e.presentational ? o.createElement("div", null, o.createElement("div", {
            className: x,
            title: h,
            "aria-hidden": "true",
            role: "presentation"
          }, b)) : e.disabled ? o.createElement("div", {
            className: a()({
              [u().disabledWrapper]: e.disabled
            })
          }, D) : D;
        }));
      },
      60101: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u
        });
        var r = n(22122),
          o = n(67294),
          i = n(94184),
          a = n.n(i),
          s = n(13099),
          l = n.n(s);
        const u = o.memo(o.forwardRef(function (e, t) {
          const {
              node: n,
              title: i,
              selected: s,
              disabled: u
            } = e,
            c = o.useRef();
          o.useImperativeHandle(t, () => ({
            focus: () => {
              n instanceof n.ownerDocument.defaultView.HTMLElement && n.focus();
            }
          })), o.useLayoutEffect(() => {
            const e = c && c.current;
            e && (e.innerHTML = "", e.appendChild(n));
          }, [n]);
          const d = a()("PSPDFKit-Tool-Node", {
              "PSPDFKit-Tool-Node-active": s,
              "PSPDFKit-Tool-Node-disabled": u
            }, e.className, l().root, {
              [l().disabled]: u,
              [l().annotationToolbar]: "annotationToolbar" === e.variant
            }),
            p = e.onPress ? t => {
              let {
                nativeEvent: n
              } = t;
              e.onPress && e.onPress(n);
            } : void 0;
          return o.createElement("div", (0, r.Z)({
            onClick: p,
            className: d,
            title: i,
            "aria-label": i,
            tabIndex: u ? -1 : void 0,
            "aria-disabled": !!u || void 0
          }, e.itemComponentProps, {
            ref: c
          }));
        }));
      },
      87996: (e, t, n) => {
        "use strict";

        n.d(t, {
          Options: () => m,
          W: () => h,
          n: () => v
        });
        var r = n(96156),
          o = n(79724),
          i = n(97586),
          a = n(60379),
          s = n(16602),
          l = n(18726),
          u = n(17766),
          c = n(42370),
          d = n(10983);
        function p(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        const h = s.Z.filter(e => e.color !== a.Z.DARK_BLUE),
          f = {
            MIN_TEXT_ANNOTATION_SIZE: 5,
            MIN_INK_ANNOTATION_SIZE: 16,
            MIN_SHAPE_ANNOTATION_SIZE: 16,
            MIN_IMAGE_ANNOTATION_SIZE: 5,
            MIN_STAMP_ANNOTATION_SIZE: 15,
            MIN_WIDGET_ANNOTATION_SIZE: 3,
            ENABLE_INK_SMOOTH_LINES: !0,
            INK_EPSILON_RANGE_OPTIMIZATION: 10,
            SIGNATURE_SAVE_MODE: i.f.USING_UI,
            INITIAL_DESKTOP_SIDEBAR_WIDTH: 300,
            IGNORE_DOCUMENT_PERMISSIONS: !1,
            SELECTION_OUTLINE_PADDING: function (e) {
              return e.width > d.y$ ? 10 : 13;
            },
            RESIZE_ANCHOR_RADIUS: function (e) {
              return e.width > d.y$ ? 7 : 10;
            },
            SELECTION_STROKE_WIDTH: 2,
            TEXT_ANNOTATION_AUTOFIT_TEXT_ON_EXPORT: !0,
            TEXT_ANNOTATION_AUTOFIT_BOUNDING_BOX_ON_EDIT: !0,
            DISABLE_KEYBOARD_SHORTCUTS: !1,
            DEFAULT_INK_ERASER_CURSOR_WIDTH: 12.5,
            COLOR_PRESETS: h,
            LINE_CAP_PRESETS: ["none"].concat(c.a),
            LINE_WIDTH_PRESETS: null,
            HIGHLIGHT_COLOR_PRESETS: [a.Z.LIGHT_YELLOW, a.Z.LIGHT_BLUE, a.Z.LIGHT_GREEN, a.Z.LIGHT_RED].map(e => ({
              color: e,
              localization: u.Z[e.toCSSValue()]
            })),
            TEXT_MARKUP_COLOR_PRESETS: s.Z.filter(e => [a.Z.BLACK, a.Z.BLUE, a.Z.RED, a.Z.GREEN].includes(e.color)),
            NOTE_COLOR_PRESETS: l.W,
            PDF_JAVASCRIPT: !0,
            BREAKPOINT_MD_TOOLBAR: 1070,
            BREAKPOINT_SM_TOOLBAR: 768
          },
          m = Object.preventExtensions(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? p(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, f)),
          g = (0, o.Z)("Options"),
          v = e => {
            for (const t in e) g(void 0 !== f[t], `Option \`${t}\` is not available in the \`Options\` object`), g(typeof f[t] == typeof e[t], `Option \`${t}\` is of incorrect type \`${typeof e[t]}\`, should be \`${typeof f[t]}\``);
          };
      },
      55012: (e, t, n) => {
        "use strict";

        n.d(t, {
          $8O: () => Cr,
          $Jy: () => At,
          $VE: () => ft,
          $hO: () => Tt,
          A8G: () => De,
          AIf: () => et,
          ArU: () => qn,
          B1n: () => nt,
          BS3: () => r,
          BWS: () => se,
          Ce5: () => g,
          D1d: () => rr,
          D5x: () => Hn,
          D_w: () => Gt,
          Dj2: () => ce,
          Dl4: () => $,
          Dqw: () => dr,
          Dzg: () => it,
          Ebp: () => Or,
          EpY: () => Pn,
          F6q: () => Mt,
          FH6: () => kt,
          FHt: () => I,
          FQb: () => Ur,
          FdD: () => yt,
          G5w: () => de,
          G6t: () => wr,
          G8_: () => Jt,
          GHc: () => l,
          GW4: () => pe,
          GXR: () => $e,
          GfR: () => G,
          Gkm: () => yr,
          Gox: () => $n,
          HS7: () => Ct,
          HXk: () => Do,
          HYy: () => Rr,
          Han: () => Lr,
          Hbz: () => pt,
          Hrp: () => s,
          IFt: () => mn,
          ILc: () => Dt,
          Ifu: () => It,
          IyB: () => tr,
          J7J: () => Ge,
          JQC: () => J,
          JRS: () => Zn,
          JS9: () => Je,
          JwD: () => ke,
          JyO: () => We,
          K26: () => dt,
          KA1: () => Wn,
          KYU: () => H,
          Kc8: () => on,
          Kpf: () => Vn,
          KqR: () => ot,
          Kw7: () => rn,
          L2A: () => cr,
          L8n: () => ut,
          L9g: () => Z,
          Lyo: () => C,
          M3C: () => at,
          M85: () => xt,
          ME7: () => y,
          MGL: () => pr,
          MOe: () => Oe,
          MYU: () => Yn,
          MfE: () => ae,
          MuN: () => he,
          NAH: () => ge,
          NB4: () => wt,
          NDs: () => Ye,
          NfO: () => V,
          Nl1: () => U,
          Oh4: () => Yt,
          Q2U: () => fn,
          QM1: () => fo,
          QU3: () => le,
          QYP: () => N,
          QYq: () => vo,
          Qm9: () => hr,
          R1i: () => Pe,
          R7l: () => mr,
          R8P: () => Et,
          RCc: () => ie,
          RPc: () => gn,
          RTr: () => f,
          RvB: () => Ne,
          RxB: () => P,
          S$y: () => Qe,
          S0t: () => yn,
          SHi: () => wo,
          SdX: () => Dr,
          T3g: () => ar,
          TG1: () => Jr,
          TPT: () => Ie,
          TUA: () => Ze,
          TYu: () => lr,
          Ty$: () => sn,
          U7k: () => jr,
          UFK: () => R,
          UFs: () => oe,
          UII: () => c,
          UL9: () => er,
          UP4: () => Sr,
          UX$: () => Qn,
          UiQ: () => _e,
          Ui_: () => Lt,
          VK7: () => Kt,
          VNM: () => Yr,
          VNu: () => lo,
          VOt: () => Tr,
          Vje: () => io,
          Vpf: () => gr,
          Vu4: () => Xe,
          W0l: () => nn,
          WaW: () => zn,
          Whn: () => Xt,
          WmI: () => Vr,
          WsN: () => to,
          WtY: () => v,
          Wyx: () => Zt,
          XTO: () => ao,
          Xlm: () => K,
          Y4: () => Mr,
          YHT: () => d,
          YIz: () => ct,
          YS$: () => bn,
          ZDQ: () => tt,
          ZGb: () => z,
          ZLr: () => p,
          ZbY: () => hn,
          ZgW: () => Br,
          Zt9: () => so,
          _33: () => Nn,
          _AY: () => Ot,
          _Qf: () => jn,
          _TO: () => En,
          _Yi: () => je,
          _fK: () => dn,
          _ko: () => O,
          _n_: () => we,
          _uU: () => ne,
          a33: () => ze,
          aWu: () => Ce,
          aYj: () => j,
          b0l: () => be,
          b4I: () => Gr,
          bM3: () => co,
          bOH: () => Nr,
          bP3: () => Q,
          bV3: () => Sn,
          bVL: () => In,
          bui: () => kn,
          bxr: () => T,
          bzW: () => $r,
          c3G: () => Be,
          cbv: () => Ue,
          ciU: () => Ir,
          ckI: () => gt,
          cyk: () => q,
          dCo: () => b,
          dEe: () => xn,
          dVW: () => en,
          eFQ: () => lt,
          eI4: () => X,
          eJ4: () => nr,
          ej0: () => ho,
          esN: () => Bt,
          f3N: () => Te,
          fAF: () => wn,
          fBs: () => Po,
          fDl: () => $t,
          fLm: () => Fr,
          fQw: () => kr,
          faS: () => Mn,
          fnw: () => w,
          fwq: () => br,
          g30: () => He,
          g4f: () => D,
          gF5: () => _t,
          gIV: () => zt,
          gbd: () => h,
          guy: () => Eo,
          hC8: () => un,
          heZ: () => m,
          hlI: () => xe,
          hpj: () => B,
          ht3: () => F,
          hv0: () => Y,
          hw0: () => Gn,
          hxO: () => vt,
          iJ2: () => Nt,
          iMs: () => Dn,
          iQZ: () => W,
          iR6: () => So,
          iZ1: () => cn,
          ieh: () => Tn,
          iwn: () => Fn,
          iyZ: () => Fe,
          jJ7: () => Qt,
          joZ: () => Pr,
          jzI: () => St,
          kD6: () => _r,
          kQ7: () => yo,
          kRo: () => M,
          kVz: () => On,
          kg: () => bt,
          kt4: () => sr,
          l$y: () => Er,
          lD1: () => ue,
          lRe: () => _n,
          m3$: () => Vt,
          mE7: () => _,
          mGH: () => tn,
          mLh: () => x,
          m_C: () => oo,
          mbD: () => Xn,
          mfU: () => Qr,
          mqf: () => Ve,
          mxA: () => _o,
          nFn: () => Ft,
          nI6: () => Kr,
          nmm: () => o,
          oE1: () => Se,
          oWy: () => Ee,
          oZW: () => qr,
          obk: () => vn,
          odo: () => Hr,
          oj5: () => u,
          ol: () => mo,
          p1u: () => jt,
          pNz: () => Cn,
          pnu: () => rt,
          poO: () => ln,
          qKG: () => vr,
          qRJ: () => an,
          qV6: () => re,
          qZT: () => Rt,
          qh0: () => or,
          rWQ: () => ye,
          rm: () => ir,
          rpU: () => Un,
          rq0: () => xo,
          rxv: () => a,
          sCM: () => Pt,
          sYK: () => ht,
          skc: () => ee,
          snK: () => eo,
          snh: () => te,
          syg: () => k,
          t$K: () => Zr,
          tC1: () => Rn,
          tIQ: () => po,
          tLW: () => Ke,
          tPZ: () => ve,
          tS$: () => qe,
          tYC: () => me,
          teI: () => fr,
          tie: () => st,
          tzG: () => no,
          u7V: () => Ht,
          u9b: () => A,
          uFU: () => pn,
          uOP: () => Xr,
          u_c: () => Wt,
          uo5: () => zr,
          vBn: () => Wr,
          vSH: () => Re,
          vVk: () => An,
          vgx: () => ur,
          vkF: () => xr,
          wG7: () => Ln,
          wHH: () => Co,
          wJn: () => bo,
          wPI: () => Kn,
          wgG: () => uo,
          wog: () => Jn,
          wtk: () => E,
          x0v: () => Ae,
          x64: () => Bn,
          xYE: () => S,
          xhM: () => Ar,
          xk1: () => fe,
          yET: () => qt,
          yPS: () => ro,
          yrz: () => mt,
          yyM: () => Me,
          zGM: () => Ut,
          zKF: () => L,
          zZV: () => i,
          z_j: () => Le,
          zyH: () => go
        });
        const r = "CONNECTING",
          o = "CONNECTED",
          i = "CONNECTION_FAILED",
          a = "SET_ANNOTATION_MANAGER",
          s = "SET_BOOKMARK_MANAGER",
          l = "SET_FORM_FIELD_VALUE_MANAGER",
          u = "SET_FORM_FIELD_MANAGER",
          c = "SET_COMMENT_MANAGER",
          d = "SET_MENTIONABLE_USERS",
          p = "SET_MAX_MENTION_SUGGESTIONS",
          h = "SET_CHANGE_MANAGER",
          f = "SET_HAS_FETCHED_INITIAL_RECORDS_FROM_INSTANT",
          m = "SET_GROUP",
          g = "SET_CLIENTS_UPDATE_CALLBACK",
          v = "SET_TRANSFORM_CLIENT_TO_PAGE",
          y = "FETCH_DOCUMENT_SUCCESS",
          b = "FETCH_PAGES_SUCCESS",
          w = "SET_BACKEND_PERMISSIONS",
          x = "SCROLLED",
          D = "JUMP_TO_RECT",
          C = "JUMP_AND_ZOOM_TO_RECT",
          S = "RESIZED",
          E = "NEXT_PAGE",
          _ = "PREVIOUS_PAGE",
          P = "SET_PAGE",
          k = "SET_ZOOM_LEVEL",
          A = "SET_ZOOM_STEP",
          z = "SET_VIEWPORT_STATE",
          T = "SET_SPREAD_SPACING",
          O = "SET_PAGE_SPACING",
          I = "SET_FIRST_PAGE_ALWAYS_SINGLE",
          F = "SET_VIEWPORT_PADDING",
          M = "ENABLE_PANNING",
          R = "DISABLE_PANNING",
          j = "ENABLE_PRINTING",
          B = "DISABLE_PRINTING",
          N = "ENABLE_EXPORT",
          L = "DISABLE_EXPORT",
          V = "ENABLE_READ_ONLY",
          K = "DISABLE_READ_ONLY",
          q = "SHOW_ANNOTATIONS",
          H = "HIDE_ANNOTATIONS",
          U = "SHOW_COMMENTS",
          Z = "HIDE_COMMENTS",
          $ = "SHOW_ANNOTATION_NOTES",
          G = "HIDE_ANNOTATION_NOTES",
          W = "SET_FEATURES",
          Y = "SET_SIDEBAR_MODE",
          X = "SET_SIDEBAR_PLACEMENT",
          Q = "SET_SIDEBAR_OPTIONS",
          J = "SET_SIGNATURE_FEATURE_AVAILABILITY",
          ee = "START_PRINTING",
          te = "END_PRINTING",
          ne = "ABORT_PRINTING",
          re = "UPDATE_PRINT_LOADING_INDICATOR",
          oe = "ZOOM_IN",
          ie = "ZOOM_OUT",
          ae = "ZOOM_TO_AUTO",
          se = "ZOOM_TO_FIT_TO_VIEWPORT",
          le = "ZOOM_TO_FIT_TO_WIDTH",
          ue = "ROTATE",
          ce = "ENABLE_DEBUG_MODE",
          de = "SHOW_DEBUG_CONSOLE",
          pe = "HIDE_DEBUG_CONSOLE",
          he = "SHOW_TOOLBAR",
          fe = "HIDE_TOOLBAR",
          me = "ENABLE_ANNOTATION_TOOLBAR",
          ge = "DISABLE_ANNOTATION_TOOLBAR",
          ve = "SET_SCROLLBAR_OFFSET",
          ye = "SET_LAYOUT_MODE",
          be = "SET_SCROLL_MODE",
          we = "SET_SCROLL_ELEMENT",
          xe = "SET_ANNOTATION_CREATOR",
          De = "SET_ANNOTATION_TOOLBAR_HEIGHT",
          Ce = "UPDATE_TOOLBAR_ITEMS",
          Se = "UPDATE_CURRENT_PRESET",
          Ee = "SET_CURRENT_ITEM_PRESET",
          _e = "UPDATE_ANNOTATION_PRESETS",
          Pe = "ADD_ANNOTATION_PRESET_ID",
          ke = "SET_CURRENT_ITEM_PRESET_FROM_ANNOTATION",
          Ae = "REMOVE_ANNOTATION_PRESET_ID",
          ze = "DESELECT",
          Te = "TEXT_SELECTED",
          Oe = "TEXT_DESELECTED",
          Ie = "SET_ANNOTATION_HOVER",
          Fe = "UNSET_ANNOTATION_HOVER",
          Me = "SET_ANNOTATION_NOTE_HOVER",
          Re = "SET_ACTIVE_ANNOTATION_NOTE",
          je = "SET_SELECTED_ANNOTATIONS",
          Be = "UNSET_SELECTED_ANNOTATION_SHOULD_DRAG",
          Ne = "SET_SELECTED_TEXT_ON_EDIT",
          Le = "FETCH_CONTENT_BLOCKS_SUCCESS",
          Ve = "ENABLE_TEXT_HIGHLIGHTER_MODE",
          Ke = "DISABLE_TEXT_HIGHLIGHTER_MODE",
          qe = "ENABLE_REDACT_TEXT_HIGHLIGHTER_MODE",
          He = "DISABLE_REDACT_TEXT_HIGHLIGHTER_MODE",
          Ue = "ENABLE_REDACT_SHAPE_RECTANGLE_MODE",
          Ze = "DISABLE_REDACT_SHAPE_RECTANGLE_MODE",
          $e = "ENABLE_INK_MODE",
          Ge = "DISABLE_INK_MODE",
          We = "ENABLE_INK_ERASER_MODE",
          Ye = "DISABLE_INK_ERASER_MODE",
          Xe = "ENABLE_SIGNATURE_MODE",
          Qe = "DISABLE_SIGNATURE_MODE",
          Je = "ENABLE_SHAPE_MODE",
          et = "DISABLE_SHAPE_MODE",
          tt = "ENABLE_NOTE_MODE",
          nt = "DISABLE_NOTE_MODE",
          rt = "ENABLE_TEXT_MODE",
          ot = "DISABLE_TEXT_MODE",
          it = "ENABLE_STAMP_PICKER_MODE",
          at = "ENABLE_STAMP_CUSTOM_MODE",
          st = "DISABLE_STAMP_MODE",
          lt = "ENABLE_INTERACTIONS",
          ut = "DISABLE_INTERACTIONS",
          ct = "SHOW_DOCUMENT_EDITOR",
          dt = "HIDE_DOCUMENT_EDITOR",
          pt = "ENABLE_MARQUEE_ZOOM",
          ht = "DISABLE_MARQUEE_ZOOM",
          ft = "SET_INTERACTION_MODE",
          mt = "RESET_INTERACTION_MODE",
          gt = "CREATE_COMMENTS",
          vt = "CREATE_COMMENT_DRAFT",
          yt = "UPDATE_COMMENTS",
          bt = "DELETE_COMMENTS",
          wt = "COMPUTE_COMMENT_MODE",
          xt = "CREATE_ANNOTATIONS",
          Dt = "CREATE_INK_ANNOTATION_ON_NEW_PAGE",
          Ct = "CREATE_SHAPE_ANNOTATION_ON_NEW_PAGE",
          St = "CREATE_REDACTION_ANNOTATION_ON_NEW_PAGE",
          Et = "UPDATE_ANNOTATIONS",
          _t = "DELETE_ANNOTATIONS",
          Pt = "SET_ANNOTATIONS_TO_DELETE",
          kt = "SEARCH_FOR_TERM",
          At = "FOCUS_NEXT_SEARCH_HIGHLIGHT",
          zt = "FOCUS_PREVIOUS_SEARCH_HIGHLIGHT",
          Tt = "SHOW_SEARCH",
          Ot = "HIDE_SEARCH",
          It = "FOCUS_SEARCH",
          Ft = "BLUR_SEARCH",
          Mt = "SET_SEARCH_IS_LOADING",
          Rt = "SET_SEARCH_RESULTS",
          jt = "SET_SEARCH_STATE",
          Bt = "SET_SEARCH_PROVIDER",
          Nt = "SET_FORM_JSON",
          Lt = "CREATE_FORM_FIELD_VALUES",
          Vt = "SET_FORM_FIELD_VALUES",
          Kt = "SET_FORMATTED_FORM_FIELD_VALUES",
          qt = "SET_EDITING_FORM_FIELD_VALUES",
          Ht = "DELETE_FORM_FIELD_VALUES",
          Ut = "CREATE_FORM_FIELDS",
          Zt = "UPDATE_FORM_FIELDS",
          $t = "REPLACE_FORM_FIELD",
          Gt = "DELETE_FORM_FIELDS",
          Wt = "DELETE_FORM_FIELDS_BY_IDS",
          Yt = "SET_DOCUMENT_OUTLINE",
          Xt = "TOGGLE_DOCUMENT_OUTLINE_ELEMENT",
          Qt = "SET_CUSTOM_OVERLAY_ITEM",
          Jt = "REMOVE_CUSTOM_OVERLAY_ITEM",
          en = "I18N_SET_LOCALE",
          tn = "CREATE_SIGNATURE",
          nn = "STORE_SIGNATURE",
          rn = "SET_STORED_SIGNATURES",
          on = "DELETE_STORED_SIGNATURE",
          an = "UPDATE_STAMP_ANNOTATION_TEMPLATES",
          sn = "SHOW_PASSWORD_PROMPT",
          ln = "SET_HAS_PASSWORD",
          un = "UNLOCKED_VIA_MODAL",
          cn = "SET_ALLOWED_TILE_SCALES",
          dn = "UPDATE_SELECTED_MARKUP_ANNOTATIONS",
          pn = "SET_IS_EDITABLE_ANNOTATION",
          hn = "SET_EDITABLE_ANNOTATION_TYPES",
          fn = "SET_IS_EDITABLE_COMMENT",
          mn = "SET_FORM_DESIGN_MODE",
          gn = "SET_INK_ERASER_WIDTH",
          vn = "RESET_DOCUMENT_STATE",
          yn = "SET_DOCUMENT_HANDLE",
          bn = "SET_DOCUMENT_HANDLE_OUTDATED",
          wn = "UPDATE_CUSTOM_RENDERERS",
          xn = "ENABLE_COMMENT_MARKER",
          Dn = "DISABLE_COMMENT_MARKER",
          Cn = "START_DIGITAL_SIGNATURE",
          Sn = "END_DIGITAL_SIGNATURE",
          En = "SET_SHOW_SIGNATURE_VALIDATION_STATUS_MODE",
          _n = "SET_DIGITAL_SIGNATURES",
          Pn = "START_REDACTION",
          kn = "END_REDACTION",
          An = "SET_PREVIEW_REDACTION_MODE",
          zn = "SET_COLLAPSE_SELECTED_NOTE_CONTENT",
          Tn = "INVALIDATE_AP_STREAMS",
          On = "VALIDATE_AP_STREAMS",
          In = "HISTORY_UPDATE_FROM_UNDO",
          Fn = "HISTORY_UPDATE_FROM_REDO",
          Mn = "SET_HISTORY_CHANGE_CONTEXT",
          Rn = "HISTORY_IDS_MAP_ADD",
          jn = "CLEAR_HISTORY",
          Bn = "REMOVE_ANNOTATION_FROM_HISTORY",
          Nn = "ENABLE_HISTORY",
          Ln = "DISABLE_HISTORY",
          Vn = "UPDATE_DOCUMENT_EDITOR_FOOTER_ITEMS",
          Kn = "UPDATE_DOCUMENT_EDITOR_TOOLBAR_ITEMS",
          qn = "SET_EDITABLE_ANNOTATION_STATE",
          Hn = "SET_A11Y_STATUS_MESSAGE",
          Un = "SET_LAST_TOOLBAR_ACTION_USED_KEYBOARD",
          Zn = "ENABLE_DOCUMENT_CROP_MODE",
          $n = "DISABLE_DOCUMENT_CROP_MODE",
          Gn = "SET_ON_ANNOTATION_RESIZE_START",
          Wn = "SET_DOCUMENT_COMPARISON_STATE",
          Yn = "ENABLE_SCROLL_WHILE_DRAWING",
          Xn = "DISABLE_SCROLL_WHILE_DRAWING",
          Qn = "SET_REUSE_STATE",
          Jn = "ENABLE_KEEP_SELECTED_TOOL",
          er = "DISABLE_KEEP_SELECTED_TOOL",
          tr = "SET_INSTANCE",
          nr = "SET_CUSTOM_UI_STORE",
          rr = "SET_SIDEBAR_WIDTH",
          or = "SET_READ_ONLY_ANNOTATION_FOCUS",
          ir = "UNSET_READ_ONLY_ANNOTATION_FOCUS",
          ar = "SET_ANNOTATION_TOOLBAR_ITEMS_CALLBACK",
          sr = "TOGGLE_CLIPBOARD_ACTIONS",
          lr = "SET_ON_WIDGET_CREATION_START_CALLBACK",
          ur = "SET_FORM_DESIGNER_LOCAL_WIDGET_ANNOTATION",
          cr = "SET_INLINE_TOOLBAR_ITEMS_CALLBACK",
          dr = "ADD_ANNOTATION_VARIANTS",
          pr = "ENABLE_CONTENT_EDITOR",
          hr = "DISABLE_CONTENT_EDITOR",
          fr = "CHANGE_CONTENT_EDITOR_SESSION_MODE",
          mr = "ENABLE_LINK_MODE",
          gr = "DISABLE_LINK_MODE",
          vr = "DISABLE_DRAWING_LINK_ANNOTATION_MODE",
          yr = "SET_MEASUREMENT_SNAPPING",
          br = "SET_MEASUREMENT_PRECISION",
          wr = "SET_MEASUREMENT_SCALE",
          xr = "SET_MEASUREMENT_VALUE_CONFIGURATION_CALLBACK",
          Dr = "SET_MEASUREMENT_SCALES",
          Cr = "SET_MEASUREMENT_TOOL_STATE",
          Sr = "SET_HINT_LINES",
          Er = "CONTENT_EDITOR/PAGE/LOADING",
          _r = "CONTENT_EDITOR/PAGE/LOADED",
          Pr = "CONTENT_EDITOR/TEXT_BLOCK/INTERACTION/ACTIVE",
          kr = "CONTENT_EDITOR/TEXT_BLOCK/INTERACTION/TOGGLE",
          Ar = "CONTENT_EDITOR/TEXT_BLOCK/INTERACTION/SELECT",
          zr = "CONTENT_EDITOR/TEXT_BLOCK/CREATE",
          Tr = "CONTENT_EDITOR/TEXT_BLOCK/UPDATE_INFO",
          Or = "CONTENT_EDITOR/TEXT_BLOCK/SET_FORMAT",
          Ir = "CONTENT_EDITOR_/TEXT_BLOCK/RESIZE",
          Fr = "CONTENT_EDITOR_/TEXT_BLOCK/MOVE",
          Mr = "CONTENT_EDITOR/SAVING",
          Rr = "CONTENT_EDITOR/SET_DIRTY",
          jr = "CONTENT_EDITOR/FACE_LIST/LOADING",
          Br = "CONTENT_EDITOR/FACE_LIST/SET",
          Nr = "CONTENT_EDITOR_SET_EXIT_DIALOG",
          Lr = "CONTENT_EDITOR_SHOW_FONT_MISMATCH_TOOLTIP",
          Vr = "CONTENT_EDITOR_HIDE_FONT_MISMATCH_TOOLTIP",
          Kr = "CONTENT_EDITOR_FONT_MISMATCH_TOOLTIP_ABORT_CONTROLLER",
          qr = "ENABLE_MULTI_ANNOTATIONS_SELECTION_MODE",
          Hr = "DISABLE_MULTI_ANNOTATIONS_SELECTION_MODE",
          Ur = "CREATE_ANNOTATION_GROUP",
          Zr = "SET_SELECTED_GROUP",
          $r = "DELETE_ANNOTATION_GROUP",
          Gr = "REMOVE_ANNOTATION_FROM_GROUP",
          Wr = "SET_PULL_TO_REFRESH_STATE",
          Yr = "SET_RICH_EDITOR_REF",
          Xr = "FOCUS_WIDGET_ANNOTATION",
          Qr = "SET_ON_COMMENT_CREATION_START_CALLBACK",
          Jr = "INVALIDATE_PAGE_KEYS",
          eo = "CONTENT_EDITOR_ACTIVE_TEXT_BLOCK_DELETE",
          to = "CHANGE_SCROLL_STATE",
          no = "SET_CUSTOM_FONTS_READABLE_NAMES",
          ro = "ENABLE_MEASUREMENT_MODE",
          oo = "DISABLE_MEASUREMENT_MODE",
          io = "SHOW_MEASUREMENT_SETTINGS",
          ao = "HIDE_MEASUREMENT_SETTINGS",
          so = "SET_SECONDARY_MEASUREMENT_UNIT",
          lo = "SET_ACTIVE_MEASUREMENT_SCALE",
          uo = "SET_CALIBRATION_MODE",
          co = "UPDATE_PAGE_KEYS",
          po = "SET_DISABLE_POINT_SNAPPING",
          ho = "SET_ENABLE_ALWAYS_SCROLL_TO_ZOOM",
          fo = "SET_FORCE_RENDER_WIDGETS_IN_ANNOTATIONS_ORDER",
          mo = "SET_EVALUATION",
          go = "SELECT_IMPORT_ICON_IMAGE",
          vo = "SET_OCG_LAYERS",
          yo = "SET_OCG_VISIBILITY",
          bo = "SET_PRERENDERED_PAGE_SPREADS",
          wo = "SET_PAGE_TAB_ORDER",
          xo = "SET_DOCUMENT_ASSISTANT_CONFIGURATION",
          Do = "SET_SHOW_DOCUMENT_ASSISTANT",
          Co = "SET_DOCUMENT_ASSISTANT_ADDITIONAL_CONTEXT",
          So = "CONTENT_EDITOR_SET_PROMPT_DOCUMENT_DOWNLOAD",
          Eo = "CONTENT_EDITOR_SET_PROMPT_CANNOT_SAVE_CHANGES",
          _o = "SET_IS_SERVER_MODE_DOWNLOADING_WASM",
          Po = "SET_IS_SERVER_MODE_DOWNLOADING_DOCUMENT";
      },
      10983: (e, t, n) => {
        "use strict";

        n.d(t, {
          Bd: () => E,
          Bs: () => L,
          D4: () => c,
          Dx: () => k,
          Fg: () => i,
          GI: () => o,
          Hr: () => S,
          J8: () => F,
          Kk: () => D,
          M5: () => R,
          QS: () => m,
          Qc: () => W,
          Qq: () => r,
          Qr: () => B,
          RI: () => s,
          SP: () => O,
          Sk: () => x,
          St: () => $,
          Ui: () => j,
          V4: () => A,
          W3: () => X,
          XU: () => h,
          XZ: () => v,
          YJ: () => w,
          _2: () => K,
          c1: () => C,
          cY: () => f,
          fV: () => T,
          g3: () => u,
          gZ: () => b,
          h8: () => p,
          i1: () => G,
          mM: () => H,
          mc: () => J,
          nJ: () => N,
          oW: () => M,
          pK: () => P,
          pt: () => Y,
          rB: () => U,
          rT: () => Q,
          re: () => z,
          rm: () => l,
          sP: () => Z,
          uq: () => _,
          wK: () => y,
          xD: () => d,
          y$: () => a,
          zA: () => V,
          zT: () => q,
          zh: () => g,
          zk: () => I
        });
        const r = 1200,
          o = 1070,
          i = 768,
          a = 480,
          s = 32768,
          l = 18,
          u = 50,
          c = a,
          d = a,
          p = 320,
          h = 250,
          f = .5,
          m = 10,
          g = 1.25,
          v = 5,
          y = 30,
          b = 2,
          w = 20,
          x = 0,
          D = 20,
          C = 5,
          S = 1,
          E = 1536,
          _ = 512,
          P = 512,
          k = 5,
          A = 1.25,
          z = "PSPDFKit-Root",
          T = "PSPDFKit-Shadow-Portal",
          O = 36,
          I = 32,
          F = 5,
          M = 0,
          R = 1,
          j = 96 / 72,
          B = 5e3,
          N = {
            LOW: 75 / 72,
            MEDIUM: 150 / 72,
            HIGH: 300 / 72
          },
          L = 2 / 3,
          V = 595,
          K = 842,
          q = 50,
          H = 96,
          U = 300,
          Z = 1e3,
          $ = 4.25,
          G = 2,
          W = 10,
          Y = 16383,
          X = 4,
          Q = 250,
          J = {
            thumbnailMinSize: Q / 2,
            thumbnailMaxSize: Q + 1.5 * Q,
            thumbnailDefaultSize: Q
          };
      },
      31442: (e, t, n) => {
        "use strict";

        n.d(t, {
          AQ: () => d,
          ZP: () => g,
          hD: () => m
        });
        var r = n(96156),
          o = n(35369),
          i = n(60379),
          a = n(4715),
          s = n(42370);
        function l(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function u(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const c = {
            line: a.o9,
            rectangle: a.b3,
            "cloudy-rectangle": a.b3,
            "dashed-rectangle": a.b3,
            ellipse: a.Xs,
            "cloudy-ellipse": a.Xs,
            "dashed-ellipse": a.Xs,
            polygon: a.Hi,
            "cloudy-polygon": a.Hi,
            "dashed-polygon": a.Hi,
            polyline: a.om,
            ink: a.Zc,
            note: a.Qi,
            text: a.gd,
            stamp: a.GI,
            image: a.sK,
            widget: a.x_,
            strikeout: a.R9,
            underline: a.xu,
            squiggle: a.hL,
            highlight: a.FV,
            arrow: a.o9,
            highlighter: a.Zc,
            "text-highlighter": a.FV,
            "ink-signature": a.Zc,
            redaction: a.Wk,
            "es-signature": a.Zc,
            perimeter: a.om,
            distance: a.o9,
            "ellipse-area": a.Xs,
            "rectangle-area": a.b3,
            "polygon-area": a.Hi
          },
          d = {
            line: {},
            rectangle: {},
            ellipse: {},
            polygon: {},
            polyline: {},
            ink: {},
            note: {},
            text: {},
            stamp: {},
            image: {},
            widget: {},
            strikeout: {},
            underline: {},
            squiggle: {},
            highlight: {},
            redaction: {}
          },
          p = {
            arrow: {
              lineCaps: {
                end: "openArrow"
              }
            },
            "cloudy-rectangle": {
              cloudyBorderIntensity: 2
            },
            "dashed-rectangle": {
              strokeDashArray: [3, 3]
            },
            "cloudy-ellipse": {
              cloudyBorderIntensity: 2
            },
            "dashed-ellipse": {
              strokeDashArray: [3, 3]
            },
            "cloudy-polygon": {
              cloudyBorderIntensity: 2
            },
            "dashed-polygon": {
              strokeDashArray: [3, 3]
            },
            highlighter: {
              strokeColor: i.Z.LIGHT_YELLOW,
              lineWidth: 30,
              blendMode: "multiply",
              opacity: 1
            },
            "text-highlighter": {
              color: i.Z.LIGHT_YELLOW,
              blendMode: "multiply",
              opacity: 1
            },
            "ink-signature": {
              isSignature: !0
            },
            "es-signature": {
              isSignature: !0,
              strokeColor: i.Z.BLACK
            },
            distance: {
              lineCaps: {
                start: s.u.butt,
                end: s.u.butt
              },
              strokeWidth: 3,
              strokeColor: i.Z.RED
            },
            perimeter: {
              lineCaps: {
                start: s.u.butt,
                end: s.u.openArrow
              },
              strokeWidth: 3,
              strokeColor: i.Z.RED
            },
            "ellipse-area": {
              strokeWidth: 3,
              strokeColor: i.Z.RED
            },
            "rectangle-area": {
              strokeWidth: 3,
              strokeColor: i.Z.RED
            },
            "polygon-area": {
              strokeWidth: 3,
              strokeColor: i.Z.RED
            }
          },
          h = ["lines", "points", "startPoint", "endPoint"],
          f = e => Object.keys(e).filter(t => !h.includes(t) && null != e[t]).reduce((t, n) => (t[n] = e[n], t), {});
        for (const e in d) {
          const t = c[e];
          Object.getPrototypeOf(t) === a.UX ? d[e] = f(u(u({}, a.UX.defaultValues), t.defaultValues)) : Object.getPrototypeOf(t) === a.On ? d[e] = f(u(u({}, a.On.defaultValues), t.defaultValues)) : d[e] = f(t.defaultValues);
        }
        for (const e in p) {
          const t = c[e];
          Object.getPrototypeOf(t) === a.UX ? p[e] = f(u(u(u({}, a.UX.defaultValues), t.defaultValues), p[e])) : Object.getPrototypeOf(t) === a.On ? p[e] = f(u(u(u({}, a.On.defaultValues), t.defaultValues), p[e])) : p[e] = f(u(u({}, t.defaultValues), p[e]));
        }
        const m = (0, o.D5)([[a.FV, "highlight"], [a.xu, "underline"], [a.hL, "squiggle"], [a.R9, "strikeout"]]),
          g = (0, o.D5)(u(u({}, d), p));
      },
      74750: (e, t, n) => {
        "use strict";

        n.d(t, {
          J: () => i,
          Z: () => a
        });
        var r = n(35369),
          o = n(4715);
        const i = [o.Xs, o.FV, o.sK, o.Zc, o.o9, o.Qi, o.Hi, o.om, o.b3, o.hL, o.GI, o.R9, o.gd, o.xu, o.x_],
          a = (0, r.d0)(i);
      },
      24126: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i,
          l: () => o
        });
        var r = n(35369);
        const o = [{
            type: "cancel"
          }, {
            type: "selected-pages"
          }, {
            type: "spacer"
          }, {
            type: "loading-indicator"
          }, {
            type: "save-as"
          }, {
            type: "save"
          }],
          i = (0, r.d0)(o);
      },
      18009: (e, t, n) => {
        "use strict";

        n.d(t, {
          L: () => o,
          Z: () => i
        });
        var r = n(35369);
        const o = [{
            type: "add"
          }, {
            type: "remove"
          }, {
            type: "duplicate"
          }, {
            type: "rotate-left"
          }, {
            type: "rotate-right"
          }, {
            type: "move"
          }, {
            type: "move-left"
          }, {
            type: "move-right"
          }, {
            type: "import-document"
          }, {
            type: "extract-pages"
          }, {
            type: "spacer"
          }, {
            type: "undo"
          }, {
            type: "redo"
          }, {
            type: "select-all"
          }, {
            type: "select-none"
          }, {
            type: "zoom-out"
          }, {
            type: "zoom-in"
          }],
          i = (0, r.d0)(o);
      },
      38246: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(4715);
        const o = Object.freeze([r.Xs, r.FV, r.sK, r.Zc, r.o9, r.Qi, r.Hi, r.om, r.b3, r.Wk, r.hL, r.GI, r.R9, r.gd, r.x_, r.xu, r.Jn, r.R1].filter(Boolean));
      },
      66013: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(60379);
        const o = new r.Z({
            r: 70,
            g: 54,
            b: 227
          }),
          i = {
            color: r.Z.BLUE,
            localization: {
              id: "blue",
              defaultMessage: "Blue",
              description: "Blue color"
            }
          },
          a = [{
            color: r.Z.BLACK,
            localization: {
              id: "black",
              defaultMessage: "Black",
              description: "Black color"
            }
          }, i, {
            color: o,
            localization: {
              id: "darkBlue",
              defaultMessage: "Dark blue",
              description: "Dark blue color"
            }
          }];
      },
      57712: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(91105);
        const o = Object.freeze([r.M.DRAW, r.M.IMAGE, r.M.TYPE]);
      },
      58342: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(2282);
        const o = Object.freeze([new r.Z({
          name: "Caveat"
        }), new r.Z({
          name: "Pacifico"
        }), new r.Z({
          name: "Marck Script"
        }), new r.Z({
          name: "Meddon"
        })]);
      },
      41390: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => l
        });
        var r = n(4715),
          o = n(36691);
        const i = n(98179).Ni ? 396 : 240,
          a = new o.Z({
            width: i,
            height: i / 3,
            left: 0,
            top: 0
          }),
          s = new o.Z({
            width: i,
            height: i,
            left: 0,
            top: 0
          }),
          l = Object.freeze([["Approved", a], ["NotApproved", a], ["Draft", a], ["Final", a], ["Completed", a], ["Confidential", a], ["ForPublicRelease", a], ["NotForPublicRelease", a], ["ForComment", a], ["Void", a], ["PreliminaryResults", a], ["InformationOnly", a], ["Rejected", s], ["Accepted", s], ["InitialHere", a], ["SignHere", a], ["Witness", a], ["AsIs", a], ["Departmental", a], ["Experimental", a], ["Expired", a], ["Sold", a], ["TopSecret", a], ["Revised", a], ["RejectedWithText", a]].map(e => {
            let [t, n] = e;
            return new r.GI({
              stampType: t,
              boundingBox: n
            });
          }));
      },
      73417: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => o,
          _o: () => i
        });
        const r = [{
            type: "sidebar-thumbnails"
          }, {
            type: "sidebar-document-outline"
          }, {
            type: "sidebar-annotations"
          }, {
            type: "sidebar-bookmarks"
          }, {
            type: "sidebar-signatures"
          }, {
            type: "sidebar-layers"
          }, {
            type: "pager"
          }, {
            type: "multi-annotations-selection"
          }, {
            type: "pan"
          }, {
            type: "zoom-out"
          }, {
            type: "zoom-in"
          }, {
            type: "zoom-mode"
          }, {
            type: "spacer"
          }, {
            type: "annotate"
          }, {
            type: "ink"
          }, {
            type: "highlighter"
          }, {
            type: "text-highlighter"
          }, {
            type: "ink-eraser"
          }, {
            type: "signature"
          }, {
            type: "image"
          }, {
            type: "stamp"
          }, {
            type: "note"
          }, {
            type: "text"
          }, {
            type: "callout"
          }, {
            type: "line"
          }, {
            type: "link"
          }, {
            type: "arrow"
          }, {
            type: "rectangle"
          }, {
            type: "ellipse"
          }, {
            type: "polygon"
          }, {
            type: "cloudy-polygon"
          }, {
            type: "polyline"
          }, {
            type: "print"
          }, {
            type: "document-editor"
          }, {
            type: "document-crop"
          }, {
            type: "search"
          }, {
            type: "export-pdf"
          }, {
            type: "debug"
          }],
          o = (0, n(35369).d0)(r),
          i = [...r.map(e => e.type), "layout-config", "marquee-zoom", "custom", "responsive-group", "comment", "redact-text-highlighter", "redact-rectangle", "cloudy-rectangle", "dashed-rectangle", "cloudy-ellipse", "dashed-ellipse", "dashed-polygon", "document-comparison", "measure", "undo", "redo", "form-creator", "content-editor", "distance", "perimeter", "rectangle-area", "ellipse-area", "polygon-area", "document-assistant"];
      },
      81683: (e, t, n) => {
        "use strict";

        n.d(t, {
          m: () => w
        });
        var r = n(73571),
          o = n(67294),
          i = n(33241),
          a = n(22122),
          s = n(98502);
        const l = e => {
          let {
            children: t,
            modalProps: n,
            modalContentProps: r,
            dialogProps: i
          } = e;
          return o.createElement(s.Modal, (0, a.Z)({
            isOpen: !0
          }, n), o.createElement(s.ModalContent, r, o.createElement(s.Dialog, (0, a.Z)({
            variant: "ghost"
          }, i, {
            className: "PSPDFKit-Modal-Dialog"
          }), t)));
        };
        var u,
          c = n(85816),
          d = n(56479),
          p = n(10102);
        const h = {
            enableDrawer: !0
          },
          f = {
            from: {
              opacity: 0,
              transform: "translateX(10px)"
            },
            enter: {
              opacity: 1,
              transform: "translateX(0px)"
            },
            leave: {
              opacity: 0,
              transform: "translateX(10px)"
            }
          },
          m = e => {
            let {
              titleId: t,
              onCloseRequest: n,
              children: r,
              toolbarsHeight: i,
              isOpen: a
            } = e;
            const {
                formatMessage: m
              } = (0, s.useI18n)(),
              g = (0, s.useDevice)(),
              v = (0, o.useMemo)(() => ({
                "aria-labelledby": t
              }), [t]),
              y = (0, o.useMemo)(() => ({
                onOpenChange: n
              }), [n]);
            return "mobile" === g ? o.createElement(l, {
              dialogProps: v,
              modalProps: y,
              modalContentProps: h
            }, r) : o.createElement(s.Transition, {
              isMounted: a,
              transitions: f,
              className: (0, c.Kj)({
                borderRadius: "md",
                borderColor: "border.medium",
                backgroundColor: "background.primary.subtle",
                borderStyle: "solid",
                borderWidth: 1,
                boxShadow: "medium",
                position: "absolute",
                display: "flex",
                flexDirection: "column"
              }),
              style: {
                width: 320,
                top: `calc(${null != i ? i : 0}px + ${c.themeVars.spacing.xl})`,
                bottom: c.themeVars.spacing.xl,
                right: c.themeVars.spacing.xl,
                zIndex: 1
              }
            }, o.createElement(s.Box, {
              width: "full",
              display: "flex",
              alignItems: "center",
              paddingLeft: "lg",
              paddingRight: "sm",
              paddingY: "sm"
            }, o.createElement(s.Text, {
              type: "title",
              size: "sm",
              id: t
            }, m(p.s.chat)), u || (u = o.createElement(s.Box, {
              flex: 1
            })), o.createElement(s.ActionIconButton, {
              icon: d.aM,
              size: "md",
              variant: "secondary",
              onPress: n,
              "aria-label": m(p.s.close)
            })), o.createElement(s.Separator, {
              style: {
                backgroundColor: c.themeVars.color.border.medium
              }
            }), r);
          };
        var g = n(8840),
          v = n(67366),
          y = n(17766);
        const b = e => {
            let {
              children: t,
              referenceRect: n,
              variant: r,
              dialogTitleId: i,
              onOutsideClick: a
            } = e;
            const {
                formatMessage: l
              } = (0, s.useI18n)(),
              u = (0, v.v9)(e => e.rootElement);
            return "mobile" === (0, s.useDevice)() ? o.createElement(s.Modal, {
              isOpen: !0
            }, o.createElement(s.ModalContent, {
              enableDrawer: !0
            }, o.createElement(s.Dialog, {
              inheritDrawer: !0,
              "aria-labelledby": i,
              variant: "ghost",
              size: "content"
            }, t))) : "sidebar" === r ? o.createElement(o.Fragment, null, t) : o.createElement(s.Popover, {
              type: "dialog",
              isOpen: !!n,
              onOpenChange: e => {
                e || null == a || a();
              }
            }, o.createElement(s.PopoverTrigger, null, n && o.createElement(s.ActionButton, {
              style: {
                opacity: 0,
                visibility: "hidden",
                position: "fixed",
                top: n.top,
                left: n.left,
                width: n.width,
                height: n.height
              },
              label: l(y.Z.comment)
            })), o.createElement(s.PopoverContent, {
              includeArrow: !0,
              className: (0, g.AK)((0, c.Kj)({
                boxShadow: "medium"
              }), "PSPDFKit-Comment-Thread-Popover"),
              contentContainerStyle: {
                overflow: "hidden"
              },
              contentContainerClassName: (0, c.Kj)({
                display: "flex"
              }),
              boundaryElement: (null == u ? void 0 : u.querySelector(".PSPDFKit-Viewport")) || void 0,
              shouldCloseOnInteractOutside: e => {
                var t;
                return !(null !== (t = e.dataset) && void 0 !== t && t.annotationId || e.classList.contains("PSPDFKit-Comment-Marker-Annotation-Selected"));
              }
            }, o.createElement(s.Dialog, {
              size: "content",
              "aria-labelledby": i,
              className: c.Kj.variants({
                borderRadius: "md",
                display: "flex"
              }),
              style: {
                overflow: "hidden"
              }
            }, t)));
          },
          w = {
            [i.x.SignaturesList]: e => ({
              content: o.createElement(r.$H, e.props),
              decorator: e => o.createElement(l, e)
            }),
            [i.x.CreateSignature]: e => ({
              content: o.createElement(r.lQ, e.props),
              decorator: e => o.createElement(l, e)
            }),
            [i.x.StampsList]: e => ({
              content: o.createElement(r.Sq, e.props),
              decorator: e => o.createElement(l, e)
            }),
            [i.x.CreateStamp]: e => ({
              content: o.createElement(r.t7, e.props),
              decorator: e => o.createElement(l, e)
            }),
            [i.x.ChatDialog]: e => ({
              content: o.createElement(r.VY, e.props),
              decorator: e => o.createElement(m, e)
            }),
            [i.x.CommentThread]: e => ({
              content: o.createElement(r.xg, e.props),
              decorator: e => o.createElement(b, e)
            })
          };
      },
      72113: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(67366),
          o = n(31672);
        const i = (0, r.$j)(function (e, t) {
          var n;
          let {
            restoreOnClose: r = !0
          } = t;
          const o = null === (n = e.frameWindow) || void 0 === n ? void 0 : n.document;
          return {
            restoreOnCloseElement: r ? null != o && o.hasFocus() ? o.activeElement && "function" == typeof o.activeElement.focus ? o.activeElement : o.body : document.activeElement : null
          };
        })(o.u_);
      },
      46302: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(67366),
          o = n(96156),
          i = n(67294);
        function a(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class s extends i.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "elRef", i.createRef()), (0, o.Z)(this, "state", {
              styles: this._calculatePositionStyles()
            });
          }
          _calculatePositionStyles() {
            var e, t;
            const {
                referenceElement: n,
                horizontalAlignment: r,
                isRTL: o
              } = this.props,
              {
                containerRect: i,
                offsets: a
              } = this.props,
              s = null !== (e = null == a ? void 0 : a.top) && void 0 !== e ? e : 0,
              l = this.elRef.current,
              u = n ? n.getBoundingClientRect() : null,
              c = l ? l.getBoundingClientRect() : null,
              d = null === (t = this.elRef.current) || void 0 === t ? void 0 : t.getRootNode(),
              p = d instanceof ShadowRoot ? d.host.getBoundingClientRect() : {
                top: 0,
                left: 0
              };
            let h = u ? u.top + u.height - p.top : 0;
            if (c && u && u.top + u.height + c.height > i.height + i.top && (h = u.top - p.top > 0 ? Math.max(0, u.top - c.height - p.top) : u.top - p.top + u.height), !l || !u) return {
              top: h + s,
              left: "auto",
              right: "auto"
            };
            if (l.offsetWidth > i.width) return {
              top: h + s,
              left: 0,
              right: 0
            };
            const f = o ? "right" : "left",
              m = o ? "left" : "right";
            let g = "left" === f ? u.left - p.left : u.right - p.left;
            switch (r) {
              case "center":
                g -= (l.offsetWidth - u.width) / 2;
                break;
              case "end":
                g -= l.offsetWidth - u.width;
            }
            return g < 0 ? {
              top: h + s,
              [f]: 0,
              [m]: "auto"
            } : g + l.offsetWidth > i.width ? {
              top: h + s,
              [m]: 0,
              [f]: "auto"
            } : "auto" === r && g > i.width / 2 ? {
              top: h + s,
              [f]: g - l.offsetWidth + u.width,
              [m]: "auto"
            } : {
              top: h + s,
              [f]: g,
              [m]: "auto"
            };
          }
          componentDidUpdate(e) {
            (e.containerRect !== this.props.containerRect || this.props.measure && !e.measure) && this.setState({
              styles: this._calculatePositionStyles()
            });
          }
          componentDidMount() {
            this.setState({
              styles: this._calculatePositionStyles()
            });
          }
          render() {
            const {
                children: e
              } = this.props,
              t = function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? a(Object(n), !0).forEach(function (t) {
                    (0, o.Z)(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                position: "absolute"
              }, this.state.styles);
            return "function" == typeof e ? e({
              ref: this.elRef,
              style: t
            }) : i.createElement("div", {
              ref: this.elRef,
              style: t
            }, e);
          }
        }
        (0, o.Z)(s, "defaultProps", {
          horizontalAlignment: "auto",
          measure: !0
        });
        const l = (0, r.$j)(e => ({
          containerRect: e.containerRect
        }))(s);
      },
      93767: (e, t, n) => {
        "use strict";

        n.d(t, {
          v: () => r
        });
        const r = {
          START: "START",
          END: "END"
        };
      },
      47120: (e, t, n) => {
        "use strict";

        n.d(t, {
          u: () => r
        });
        const r = {
          IMMEDIATE: "IMMEDIATE",
          INTELLIGENT: "INTELLIGENT",
          DISABLED: "DISABLED"
        };
      },
      3792: (e, t, n) => {
        "use strict";

        n.d(t, {
          b: () => r
        });
        const r = {
          normal: "normal",
          multiply: "multiply",
          screen: "screen",
          overlay: "overlay",
          darken: "darken",
          lighten: "lighten",
          colorDodge: "colorDodge",
          colorBurn: "colorBurn",
          hardLight: "hardLight",
          softLight: "softLight",
          difference: "difference",
          exclusion: "exclusion"
        };
      },
      3888: (e, t, n) => {
        "use strict";

        n.d(t, {
          N: () => r
        });
        const r = {
          solid: "solid",
          dashed: "dashed",
          beveled: "beveled",
          inset: "inset",
          underline: "underline"
        };
      },
      60679: (e, t, n) => {
        "use strict";

        n.d(t, {
          _: () => r
        });
        const r = {
          SIDEBAR: "SIDEBAR",
          PANE: "PANE"
        };
      },
      30874: (e, t, n) => {
        "use strict";

        n.d(t, {
          b: () => r
        });
        const r = {
          TEXT: "text"
        };
      },
      14178: (e, t, n) => {
        "use strict";

        n.d(t, {
          F: () => r
        });
        const r = {
          PASSWORD_REQUIRED: "PASSWORD_REQUIRED",
          CONNECTING: "CONNECTING",
          CONNECTED: "CONNECTED",
          CONNECTION_FAILED: "CONNECTION_FAILED"
        };
      },
      79112: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q: () => r
        });
        const r = {
          documentA: "documentA",
          documentB: "documentB",
          result: "result"
        };
      },
      7202: (e, t, n) => {
        "use strict";

        n.d(t, {
          b: () => r
        });
        const r = {
          USE_OPEN_DOCUMENT: "USE_OPEN_DOCUMENT",
          USE_FILE_DIALOG: "USE_FILE_DIALOG"
        };
      },
      62083: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => s,
          Z: () => u
        });
        var r = n(96156),
          o = n(35369);
        function i(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function a(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const s = {
            annotationsAndForms: "annotationsAndForms",
            assemble: "assemble",
            extract: "extract",
            extractAccessibility: "extractAccessibility",
            fillForms: "fillForms",
            modification: "modification",
            printHighQuality: "printHighQuality",
            printing: "printing"
          },
          l = Object.keys(s).reduce((e, t) => a(a({}, e), {}, {
            [t]: !0
          }), {});
        class u extends (0, o.WV)(l) {}
      },
      91105: (e, t, n) => {
        "use strict";

        n.d(t, {
          M: () => r
        });
        const r = {
          DRAW: "DRAW",
          IMAGE: "IMAGE",
          TYPE: "TYPE"
        };
      },
      76934: (e, t, n) => {
        "use strict";

        n.d(t, {
          j: () => r
        });
        const r = {
          DEFAULT: "DEFAULT",
          EXTERNAL: "EXTERNAL",
          HISTORY: "HISTORY"
        };
      },
      25673: (e, t, n) => {
        "use strict";

        n.d(t, {
          b: () => r
        });
        const r = {
          POINT: "POINT",
          STROKE: "STROKE"
        };
      },
      48625: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => r
        });
        const r = {
          TEXT_HIGHLIGHTER: "TEXT_HIGHLIGHTER",
          INK: "INK",
          INK_SIGNATURE: "INK_SIGNATURE",
          SIGNATURE: "SIGNATURE",
          STAMP_PICKER: "STAMP_PICKER",
          STAMP_CUSTOM: "STAMP_CUSTOM",
          SHAPE_LINE: "SHAPE_LINE",
          SHAPE_RECTANGLE: "SHAPE_RECTANGLE",
          SHAPE_ELLIPSE: "SHAPE_ELLIPSE",
          SHAPE_POLYGON: "SHAPE_POLYGON",
          SHAPE_POLYLINE: "SHAPE_POLYLINE",
          INK_ERASER: "INK_ERASER",
          NOTE: "NOTE",
          COMMENT_MARKER: "COMMENT_MARKER",
          TEXT: "TEXT",
          CALLOUT: "CALLOUT",
          PAN: "PAN",
          SEARCH: "SEARCH",
          DOCUMENT_EDITOR: "DOCUMENT_EDITOR",
          MARQUEE_ZOOM: "MARQUEE_ZOOM",
          REDACT_TEXT_HIGHLIGHTER: "REDACT_TEXT_HIGHLIGHTER",
          REDACT_SHAPE_RECTANGLE: "REDACT_SHAPE_RECTANGLE",
          DOCUMENT_CROP: "DOCUMENT_CROP",
          BUTTON_WIDGET: "BUTTON_WIDGET",
          TEXT_WIDGET: "TEXT_WIDGET",
          RADIO_BUTTON_WIDGET: "RADIO_BUTTON_WIDGET",
          CHECKBOX_WIDGET: "CHECKBOX_WIDGET",
          COMBO_BOX_WIDGET: "COMBO_BOX_WIDGET",
          LIST_BOX_WIDGET: "LIST_BOX_WIDGET",
          SIGNATURE_WIDGET: "SIGNATURE_WIDGET",
          DATE_WIDGET: "DATE_WIDGET",
          FORM_CREATOR: "FORM_CREATOR",
          LINK: "LINK",
          DISTANCE: "DISTANCE",
          PERIMETER: "PERIMETER",
          RECTANGLE_AREA: "RECTANGLE_AREA",
          ELLIPSE_AREA: "ELLIPSE_AREA",
          POLYGON_AREA: "POLYGON_AREA",
          CONTENT_EDITOR: "CONTENT_EDITOR",
          MULTI_ANNOTATIONS_SELECTION: "MULTI_ANNOTATIONS_SELECTION",
          MEASUREMENT: "MEASUREMENT",
          MEASUREMENT_SETTINGS: "MEASUREMENT_SETTINGS"
        };
      },
      14286: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => r
        });
        const r = {
          SINGLE: "SINGLE",
          DOUBLE: "DOUBLE",
          AUTO: "AUTO"
        };
      },
      44550: (e, t, n) => {
        "use strict";

        n.d(t, {
          q: () => r
        });
        const r = {
          ANNOTATION_EDITING: "annotation_editing",
          FORMS: "acro_forms",
          DIGITAL_SIGNATURES: "digital_signatures",
          DOCUMENT_COMPARISON: "comparison",
          DOCUMENT_EDITING: "document_editing",
          WEB_VIEWER: "web:viewer",
          WEB_ANNOTATION_EDITING: "web:annotation_editing",
          INSTANT: "instant",
          SERVER_OPT_OUT_ANALYTICS: "server:disable-analytics",
          UI: "user_interface",
          TEXT_SELECTION: "text_selection",
          ELECTRON: "web:electron",
          FORM_DESIGNER: "editable_forms",
          COMMENTS: "comments",
          REDACTIONS: "redaction",
          ELECTRONIC_SIGNATURES: "electronic_signatures",
          CONTENT_EDITING: "content_editing",
          MEASUREMENT_TOOLS: "measurement_tools",
          TEXT_COMPARISON: "text_comparison",
          IMAGE_DOCUMENT: "image_document",
          OCR: "ocr",
          PDF_A: "pdfa",
          COMPRESSION: "compression",
          IMAGE_CINVERSION: "image_conversion",
          LIBREOFFICE_WORD: "libreoffice_word",
          LINEARIZATION: "linearization",
          PDF_GENERATION: "pdf_generation",
          DOCUMENT_ASSISTANT: "document_assistant"
        };
      },
      42370: (e, t, n) => {
        "use strict";

        n.d(t, {
          a: () => o,
          u: () => r
        });
        const r = {
            square: "square",
            circle: "circle",
            diamond: "diamond",
            openArrow: "openArrow",
            closedArrow: "closedArrow",
            butt: "butt",
            reverseOpenArrow: "reverseOpenArrow",
            reverseClosedArrow: "reverseClosedArrow",
            slash: "slash"
          },
          o = Object.values(r);
      },
      97281: (e, t, n) => {
        "use strict";

        n.d(t, {
          L: () => r
        });
        const r = {
          WHOLE: "whole",
          ONE: "oneDp",
          TWO: "twoDp",
          THREE: "threeDp",
          FOUR: "fourDp",
          HALVES: "1/2",
          QUARTERS: "1/4",
          EIGHTHS: "1/8",
          SIXTEENTHS: "1/16"
        };
      },
      94327: (e, t, n) => {
        "use strict";

        n.d(t, {
          s: () => r
        });
        const r = {
          INCHES: "in",
          MILLIMETERS: "mm",
          CENTIMETERS: "cm",
          POINTS: "pt"
        };
      },
      1385: (e, t, n) => {
        "use strict";

        n.d(t, {
          K: () => r
        });
        const r = {
          INCHES: "in",
          MILLIMETERS: "mm",
          CENTIMETERS: "cm",
          POINTS: "pt",
          FEET: "ft",
          METERS: "m",
          YARDS: "yd",
          KILOMETERS: "km",
          MILES: "mi"
        };
      },
      60790: (e, t, n) => {
        "use strict";

        n.d(t, {
          x: () => r
        });
        const r = {
          FORM_DESIGNER_ERROR: "FORM_DESIGNER_ERROR",
          MEASUREMENT_ERROR: "MEASUREMENT_ERROR"
        };
      },
      59062: (e, t, n) => {
        "use strict";

        n.d(t, {
          V9: () => i,
          Y4: () => o,
          Zi: () => r
        });
        const r = {
            COMMENT: "COMMENT",
            RIGHT_POINTER: "RIGHT_POINTER",
            RIGHT_ARROW: "RIGHT_ARROW",
            CHECK: "CHECK",
            CIRCLE: "CIRCLE",
            CROSS: "CROSS",
            INSERT: "INSERT",
            NEW_PARAGRAPH: "NEW_PARAGRAPH",
            NOTE: "NOTE",
            PARAGRAPH: "PARAGRAPH",
            HELP: "HELP",
            STAR: "STAR",
            KEY: "KEY"
          },
          o = {
            [r.COMMENT]: "comment",
            [r.RIGHT_POINTER]: "rightPointer",
            [r.RIGHT_ARROW]: "rightArrow",
            [r.CHECK]: "check",
            [r.CIRCLE]: "circle",
            [r.CROSS]: "cross",
            [r.INSERT]: "insert",
            [r.NEW_PARAGRAPH]: "newParagraph",
            [r.NOTE]: "note",
            [r.PARAGRAPH]: "paragraph",
            [r.HELP]: "help",
            [r.STAR]: "star",
            [r.KEY]: "key"
          },
          i = Object.keys(o).reduce((e, t) => (e[o[t]] = t, e), {});
      },
      11267: (e, t, n) => {
        "use strict";

        n.d(t, {
          _: () => r
        });
        const r = {
          docx: "docx",
          xlsx: "xlsx",
          pptx: "pptx"
        };
      },
      74311: (e, t, n) => {
        "use strict";

        n.d(t, {
          w: () => r
        });
        const r = {
          PDFA_1A: "pdfa-1a",
          PDFA_1B: "pdfa-1b",
          PDFA_2A: "pdfa-2a",
          PDFA_2U: "pdfa-2u",
          PDFA_2B: "pdfa-2b",
          PDFA_3A: "pdfa-3a",
          PDFA_3U: "pdfa-3u",
          PDFA_3B: "pdfa-3b",
          PDFA_4: "pdfa-4",
          PDFA_4E: "pdfa-4e",
          PDFA_4F: "pdfa-4f"
        };
      },
      70025: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => r
        });
        const r = {
          DOM: "DOM",
          EXPORT_PDF: "EXPORT_PDF"
        };
      },
      26637: (e, t, n) => {
        "use strict";

        n.d(t, {
          g: () => r
        });
        const r = {
          LOW: "LOW",
          MEDIUM: "MEDIUM",
          HIGH: "HIGH"
        };
      },
      15650: (e, t, n) => {
        "use strict";

        n.d(t, {
          l: () => r
        });
        const r = {
          smallerSize: "smallerSize",
          fasterProcessing: "fasterProcessing"
        };
      },
      33383: (e, t, n) => {
        "use strict";

        n.d(t, {
          x: () => r
        });
        const r = {
          SharePoint: "SharePoint",
          Salesforce: "Salesforce",
          Maui_Android: "Maui_Android",
          Maui_iOS: "Maui_iOS",
          Maui_MacCatalyst: "Maui_MacCatalyst",
          Maui_Windows: "Maui_Windows",
          FlutterForWeb: "FlutterForWeb",
          Electron: "Electron"
        };
      },
      28233: (e, t, n) => {
        "use strict";

        n.d(t, {
          J: () => r
        });
        let r = function (e) {
          return e.NO = "NO", e.VIA_VIEW_STATE = "VIA_VIEW_STATE", e.VIA_BACKEND_PERMISSIONS = "VIA_BACKEND_PERMISSIONS", e.LICENSE_RESTRICTED = "LICENSE_RESTRICTED", e;
        }({});
      },
      33241: (e, t, n) => {
        "use strict";

        n.d(t, {
          l: () => o,
          x: () => i
        });
        var r = n(73571);
        const o = {
            SignaturesList: r.$H,
            CreateSignature: r.lQ,
            StampsList: r.Sq,
            CreateStamp: r.t7,
            ChatDialog: r.VY,
            CommentThread: r.xg
          },
          i = Object.fromEntries(Object.entries(o).map(e => {
            let [t] = e;
            return [t, t];
          }));
      },
      74814: (e, t, n) => {
        "use strict";

        n.d(t, {
          V: () => r
        });
        const r = {
          TOP: "TOP",
          BOTTOM: "BOTTOM",
          LEFT: "LEFT",
          RIGHT: "RIGHT",
          TOP_LEFT: "TOP_LEFT",
          TOP_RIGHT: "TOP_RIGHT",
          BOTTOM_RIGHT: "BOTTOM_RIGHT",
          BOTTOM_LEFT: "BOTTOM_LEFT"
        };
      },
      2464: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => r
        });
        const r = {
          CONTINUOUS: "CONTINUOUS",
          PER_SPREAD: "PER_SPREAD",
          DISABLED: "DISABLED"
        };
      },
      5709: (e, t, n) => {
        "use strict";

        n.d(t, {
          n: () => r
        });
        const r = {
          CREDIT_CARD_NUMBER: "credit_card_number",
          DATE: "date",
          TIME: "time",
          EMAIL_ADDRESS: "email_address",
          INTERNATIONAL_PHONE_NUMBER: "international_phone_number",
          IP_V4: "ipv4",
          IP_V6: "ipv6",
          MAC_ADDRESS: "mac_address",
          NORTH_AMERICAN_PHONE_NUMBER: "north_american_phone_number",
          SOCIAL_SECURITY_NUMBER: "social_security_number",
          URL: "url",
          US_ZIP_CODE: "us_zip_code",
          VIN: "vin"
        };
      },
      96650: (e, t, n) => {
        "use strict";

        n.d(t, {
          S: () => r
        });
        const r = {
          TEXT: "text",
          PRESET: "preset",
          REGEX: "regex"
        };
      },
      54103: (e, t, n) => {
        "use strict";

        n.d(t, {
          o: () => r
        });
        const r = {
          SELECTED: "SELECTED",
          EDITING: "EDITING"
        };
      },
      13349: (e, t, n) => {
        "use strict";

        n.d(t, {
          W: () => r
        });
        const r = {
          IF_SIGNED: "IF_SIGNED",
          HAS_WARNINGS: "HAS_WARNINGS",
          HAS_ERRORS: "HAS_ERRORS",
          NEVER: "NEVER"
        };
      },
      27122: (e, t, n) => {
        "use strict";

        n.d(t, {
          f: () => r
        });
        const r = {
          ANNOTATIONS: "ANNOTATIONS",
          BOOKMARKS: "BOOKMARKS",
          DOCUMENT_OUTLINE: "DOCUMENT_OUTLINE",
          THUMBNAILS: "THUMBNAILS",
          SIGNATURES: "SIGNATURES",
          LAYERS: "LAYERS",
          CUSTOM: "CUSTOM"
        };
      },
      65369: (e, t, n) => {
        "use strict";

        n.d(t, {
          d: () => r
        });
        const r = {
          START: "START",
          END: "END"
        };
      },
      39684: (e, t, n) => {
        "use strict";

        n.d(t, {
          H: () => r
        });
        const r = {
          signatureOnly: "signatureOnly",
          signatureAndDescription: "signatureAndDescription",
          descriptionOnly: "descriptionOnly"
        };
      },
      20063: (e, t, n) => {
        "use strict";

        n.d(t, {
          H: () => r
        });
        const r = {
          ELECTRONIC_SIGNATURES: "electronic_signatures",
          LEGACY_SIGNATURES: "legacy_signatures",
          NONE: "none"
        };
      },
      97586: (e, t, n) => {
        "use strict";

        n.d(t, {
          f: () => r
        });
        const r = {
          ALWAYS: "ALWAYS",
          NEVER: "NEVER",
          USING_UI: "USING_UI"
        };
      },
      8898: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q: () => r
        });
        const r = {
          LIGHT: "LIGHT",
          DARK: "DARK",
          AUTO: "AUTO"
        };
      },
      13264: (e, t, n) => {
        "use strict";

        n.d(t, {
          p: () => r
        });
        const r = {
          TOP: "TOP",
          BOTTOM: "BOTTOM"
        };
      },
      35062: (e, t, n) => {
        "use strict";

        n.d(t, {
          Y: () => r
        });
        const r = {
          COMMENT_THREAD: "COMMENT_THREAD",
          ANNOTATIONS_SIDEBAR: "ANNOTATIONS_SIDEBAR"
        };
      },
      81777: (e, t, n) => {
        "use strict";

        n.d(t, {
          c: () => r
        });
        const r = {
          AUTO: "AUTO",
          FIT_TO_WIDTH: "FIT_TO_WIDTH",
          FIT_TO_VIEWPORT: "FIT_TO_VIEWPORT",
          CUSTOM: "CUSTOM"
        };
      },
      21753: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => h,
          sS: () => p,
          z5: () => d
        });
        var r = n(79724),
          o = n(9792),
          i = n.n(o),
          a = n(86105),
          s = n(68944),
          l = n(94809);
        const u = (0, r.Z)("I18n"),
          c = e => e.split("-")[0],
          d = e => {
            let t = e;
            return i().includes(t) || (t = c(t), u(i().includes(t), `The "${t}" locale is not supported. Available locales are: ${i().join(", ")}. You can also add "${t}" as a custom one with PSPDFKit.I18n.locales.push('${t}')`)), t;
          };
        async function p(e) {
          await (0, a.EV)(e), await (0, a.wP)(c(e));
        }
        const h = {
          locales: i(),
          messages: a.ZP,
          preloadLocalizationData: async function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            "string" == typeof t.baseUrl && (0, l.Pn)(t.baseUrl);
            const r = t.baseUrl || (0, s.SV)(window.document);
            n.p = r;
            const o = d(e);
            await p(o);
          }
        };
      },
      9792: e => {
        e.exports = ["cs", "cy", "da", "de", "el", "en-GB", "en", "es", "fi", "fr-CA", "fr", "hr", "id", "it", "ja", "ko", "ms", "nb-NO", "nl", "pl", "pt-PT", "pt", "ru", "sk", "sl", "sv", "th", "tr", "uk", "zh-Hans", "zh-Hant"];
      },
      86105: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => l,
          wP: () => c,
          EV: () => u
        });
        var r = n(79724),
          o = n(8514);
        const i = {
            cs: () => n.e(3005).then(n.t.bind(n, 74531, 23)),
            cy: () => n.e(7050).then(n.t.bind(n, 42673, 23)),
            da: () => n.e(752).then(n.t.bind(n, 27645, 23)),
            de: () => n.e(8869).then(n.t.bind(n, 18675, 23)),
            el: () => n.e(1882).then(n.t.bind(n, 67657, 23)),
            en: () => n.e(5014).then(n.t.bind(n, 39818, 23)),
            es: () => n.e(1252).then(n.t.bind(n, 56927, 23)),
            fi: () => n.e(5528).then(n.t.bind(n, 24521, 23)),
            fr: () => n.e(1145).then(n.t.bind(n, 18712, 23)),
            hr: () => n.e(9677).then(n.t.bind(n, 2471, 23)),
            id: () => n.e(5192).then(n.t.bind(n, 73772, 23)),
            it: () => n.e(3424).then(n.t.bind(n, 3340, 23)),
            ja: () => n.e(4728).then(n.t.bind(n, 88245, 23)),
            ko: () => n.e(1089).then(n.t.bind(n, 9077, 23)),
            ms: () => n.e(1518).then(n.t.bind(n, 49939, 23)),
            nb: () => n.e(2279).then(n.t.bind(n, 12788, 23)),
            nl: () => n.e(9486).then(n.t.bind(n, 93550, 23)),
            pl: () => n.e(6523).then(n.t.bind(n, 46751, 23)),
            pt: () => n.e(4932).then(n.t.bind(n, 67822, 23)),
            ru: () => n.e(1385).then(n.t.bind(n, 93258, 23)),
            sk: () => n.e(1077).then(n.t.bind(n, 67726, 23)),
            sl: () => n.e(1277).then(n.t.bind(n, 71817, 23)),
            sv: () => n.e(2727).then(n.t.bind(n, 85361, 23)),
            th: () => n.e(1063).then(n.t.bind(n, 74418, 23)),
            tr: () => n.e(9384).then(n.t.bind(n, 27097, 23)),
            uk: () => n.e(1843).then(n.t.bind(n, 98621, 23)),
            zh: () => n.e(4072).then(n.t.bind(n, 99577, 23))
          },
          a = (0, r.Z)("I18n"),
          s = {},
          l = s;
        async function u(e) {
          if (!(e in s)) try {
            const t = await o.o[e]();
            s[e] = t.default;
          } catch (t) {
            a(!1, `Cannot find translations for "${e}". Please retry or add them manually to PSPDFKit.I18n.messages["${e}"]`);
          }
          return s[e];
        }
        async function c(e) {
          if (i[e]) try {
            await i[e]();
          } catch (t) {
            a(!1, `Cannot find locale data for "${e}". Please retry or contact support for further assistance.`);
          }
        }
      },
      8514: (e, t, n) => {
        "use strict";

        n.d(t, {
          o: () => r
        });
        const r = {
          cs: () => n.e(3579).then(n.t.bind(n, 46984, 19)),
          cy: () => n.e(7578).then(n.t.bind(n, 50706, 19)),
          da: () => n.e(1139).then(n.t.bind(n, 32156, 19)),
          de: () => n.e(1009).then(n.t.bind(n, 47875, 19)),
          el: () => n.e(1323).then(n.t.bind(n, 87908, 19)),
          "en-GB": () => n.e(6045).then(n.t.bind(n, 29207, 19)),
          en: () => n.e(1874).then(n.t.bind(n, 70840, 19)),
          es: () => n.e(473).then(n.t.bind(n, 59657, 19)),
          fi: () => n.e(9390).then(n.t.bind(n, 5317, 19)),
          "fr-CA": () => n.e(2916).then(n.t.bind(n, 76215, 19)),
          fr: () => n.e(3360).then(n.t.bind(n, 28435, 19)),
          hr: () => n.e(157).then(n.t.bind(n, 24733, 19)),
          id: () => n.e(9726).then(n.t.bind(n, 33615, 19)),
          it: () => n.e(8839).then(n.t.bind(n, 24068, 19)),
          ja: () => n.e(3463).then(n.t.bind(n, 87854, 19)),
          ko: () => n.e(1168).then(n.t.bind(n, 23980, 19)),
          ms: () => n.e(1391).then(n.t.bind(n, 48853, 19)),
          "nb-NO": () => n.e(4966).then(n.t.bind(n, 16844, 19)),
          nl: () => n.e(5677).then(n.t.bind(n, 14314, 19)),
          pl: () => n.e(4899).then(n.t.bind(n, 16365, 19)),
          "pt-PT": () => n.e(5431).then(n.t.bind(n, 55910, 19)),
          pt: () => n.e(517).then(n.t.bind(n, 7638, 19)),
          ru: () => n.e(8057).then(n.t.bind(n, 21652, 19)),
          sk: () => n.e(9971).then(n.t.bind(n, 57298, 19)),
          sl: () => n.e(5595).then(n.t.bind(n, 33943, 19)),
          sv: () => n.e(6530).then(n.t.bind(n, 99649, 19)),
          th: () => n.e(5666).then(n.t.bind(n, 81446, 19)),
          tr: () => n.e(407).then(n.t.bind(n, 18141, 19)),
          uk: () => n.e(3095).then(n.t.bind(n, 76911, 19)),
          "zh-Hans": () => n.e(6678).then(n.t.bind(n, 47224, 19)),
          "zh-Hant": () => n.e(7579).then(n.t.bind(n, 58372, 19))
        };
      },
      88221: (e, t, n) => {
        e.exports = n(7409).default;
      },
      79685: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        class r {
          constructor() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
            this.events = e, this.listeners = {};
          }
          on(e, t) {
            if ("function" != typeof t) throw new TypeError("Listener must be a function");
            if (!this.supportsEvent(e)) throw new TypeError(`Event '${e}' is not supported. Only supporting ${this.events.join(", ")}`);
            this.listeners[e] = this.listeners[e] || [], this.listeners[e].push(t);
          }
          off(e, t) {
            if ("function" != typeof t) throw new TypeError("Listener must be a function");
            if (!this.supportsEvent(e)) throw new TypeError(`Event '${e}' is not supported. Only supporting ${this.events.join(", ")}`);
            const n = this.listeners[e] || [];
            n.forEach((e, r) => {
              e === t && n.splice(r, 1);
            }), 0 === n.length && delete this.listeners[e];
          }
          emit(e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
            if (!this.supportsEvent(e)) throw new TypeError(`Event '${e}' is not supported. Only supporting ${this.events.join(", ")}`);
            const o = this.listeners[e];
            void 0 !== o && o.forEach(e => {
              e.call(null, ...n);
            });
          }
          supportsEvent(e) {
            return 0 === this.events.length || -1 !== this.events.indexOf(e);
          }
        }
      },
      28018: (e, t, n) => {
        "use strict";

        n.d(t, {
          c: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(7654),
          a = n(47120),
          s = n(96326);
        class l {
          constructor(e, t) {
            (0, r.Z)(this, "localFormFieldsMapping", (0, o.D5)()), (0, r.Z)(this, "onCreate", e => {
              this.localFormFieldsMapping = this.localFormFieldsMapping.set(e.id, e.name);
            }), (0, r.Z)(this, "onUpdate", e => {
              this.onCreate(e);
            }), (0, r.Z)(this, "onDelete", e => {
              this.localFormFieldsMapping = this.localFormFieldsMapping.delete(e.id);
            }), this.formFieldProvider = e, this.localFormFieldCallbacks = t;
          }
          createBackendObject(e) {
            return this.formFieldProvider.createFormField(e);
          }
          updateBackendObject(e) {
            return this.formFieldProvider.updateFormField(e);
          }
          deleteBackendObject(e) {
            return this.formFieldProvider.deleteFormField(e);
          }
          createStoreObjects(e) {
            this.localFormFieldsMapping = this.localFormFieldsMapping.withMutations(t => {
              e.forEach(e => {
                t.set(e.id, e.name);
              });
            }), this.localFormFieldCallbacks.createFormFields(e);
          }
          updateStoreObjects(e) {
            this.localFormFieldsMapping = this.localFormFieldsMapping.withMutations(t => {
              e.forEach(e => {
                t.set(e.id, e.name);
              });
            }), this.localFormFieldCallbacks.updateFormFields(e);
          }
          deleteStoreObjects(e) {
            this.localFormFieldsMapping = this.localFormFieldsMapping.withMutations(t => {
              e.forEach(e => {
                t.delete(e);
              });
            }), this.localFormFieldCallbacks.deleteFormFields(e);
          }
          validateObject(e) {
            if (!e.name || "string" != typeof e.name || !e.id || "string" != typeof e.id) return !1;
            try {
              return (0, i.Gu)(e), !0;
            } catch (e) {
              return !1;
            }
          }
          getObjectById(e) {
            const t = this.localFormFieldsMapping.get(e);
            return t ? this.localFormFieldCallbacks.getFormFieldByName(t) : null;
          }
          getObjectId(e) {
            return e.id;
          }
          refresh() {
            this.localFormFieldCallbacks.refreshSignaturesInfo();
          }
          syncChanges() {
            return this.formFieldProvider.syncChanges();
          }
        }
        class u extends s.a {
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : a.u.IMMEDIATE,
              o = arguments.length > 3 ? arguments[3] : void 0;
            super(new l(e, t), n, o), (0, r.Z)(this, "loadFormFields", function () {
              let e = null;
              return async function () {
                e || (e = this.formFieldProvider.loadFormFields()), await e;
              };
            }()), this.formFieldProvider = e;
          }
        }
      },
      9933: (e, t, n) => {
        "use strict";

        n.d(t, {
          D: () => l,
          V: () => s
        });
        var r = n(96156),
          o = n(35369);
        function i(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function a(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function s(e) {
          const t = e.defaultValues || {},
            n = e.prototype;
          n._defaultValues = a(a({}, n._defaultValues || {}), t);
          const r = Object.keys(n._defaultValues);
          n._keys = r, n._indices = {};
          for (let e = 0; e < r.length; e++) {
            const t = r[e];
            n._indices[t] = e;
          }
          r.forEach(e => {
            Object.defineProperty(n, e, {
              get() {
                return this.get(e);
              },
              set(t) {
                this.set(e, t);
              }
            });
          });
        }
        class l extends (0, o.WV)({}) {
          constructor(e) {
            super(e);
          }
        }
      },
      32249: (e, t, n) => {
        "use strict";

        n.d(t, {
          mH: () => h,
          ZP: () => v,
          il: () => g
        });
        var r = n(96156),
          o = n(35369),
          i = n(77017),
          a = n(15359);
        function s(e, t) {
          const n = t.record_rev,
            r = e.stagedRecordsChanges;
          if ((0, a.kG)("number" == typeof n && n >= 0, "Tried to apply changes but the server responded with no `record_rev`"), (0, a.kG)(n >= e.localRecordsRev, "The server revision number is lower than the current one."), n <= e.localRecordsRev) return e;
          (0, a.kG)("number" == typeof t.previous_record_rev, "The payload must have a `previous_record_rev`"), (0, a.kG)(t.previous_record_rev >= e.localRecordsRev, "The payload's `previous_record_rev` is unknown to us, this means we missed out on changes.");
          let i = 0;
          const s = e.requiredAttachmentIds;
          let l = (0, o.l4)(),
            u = (0, o.aV)();
          const c = [],
            d = e.localRecordsContents.withMutations(e => {
              let n;
              n = {
                accepted: {
                  created: t => {
                    let {
                      id: n,
                      permissions: o,
                      group: s,
                      isAnonymous: l
                    } = t;
                    (0, a.kG)(!e.has(n), "There's already a record with the newly created record id");
                    const u = r.find(e => e.id === n);
                    if (!u) return;
                    u.resolve(null);
                    const {
                      content: c
                    } = u;
                    e.set(n, {
                      content: c,
                      permissions: o,
                      group: s,
                      isAnonymous: l
                    }), i++;
                  },
                  updated: t => {
                    let {
                      id: n,
                      permissions: o,
                      group: s,
                      isAnonymous: l
                    } = t;
                    (0, a.kG)(e.has(n), "Tried to update a record that is not present");
                    const u = r.find(e => e.id === n);
                    if (!u) return;
                    u.resolve(!0);
                    const {
                      content: c
                    } = u;
                    e.set(n, {
                      content: c,
                      permissions: o,
                      group: s,
                      isAnonymous: l
                    }), i++;
                  },
                  deleted: t => {
                    (0, a.kG)(e.has(t), "Tried to delete a record that is not present");
                    const n = r.find(e => e.id === t);
                    n && (n.resolve(!0), e.delete(t), i++);
                  }
                },
                rejected: (e, t) => {
                  let [n, o] = t;
                  const d = r.find(e => e.id === n);
                  if (d) switch (i++, o) {
                    case "conflict":
                      d.reject(new a.p2("The server rejected the change due to a conflict")), "created" !== e && c.push(n);
                      break;
                    case "attachment_not_found":
                      {
                        const e = Object.keys(d.attachments),
                          t = !s.intersect(e).isEmpty();
                        if (d.attachments && !t && Object.keys(d.attachments).length > 0) {
                          l = l.union(Object.keys(d.attachments)), u = u.push(d);
                          break;
                        }
                      }
                    default:
                      d.reject(new a.p2("The server rejected the change")), "created" !== e && c.push(n);
                  }
                },
                changes: {
                  created: t => {
                    (0, a.kG)(!e.has(t.id), "The change set tried to add a record that is already present");
                    const {
                      content: n,
                      permissions: r,
                      group: o,
                      isAnonymous: i
                    } = t;
                    e.set(t.id, {
                      content: n,
                      permissions: r,
                      group: o,
                      isAnonymous: i
                    });
                  },
                  updated: t => {
                    (0, a.kG)(e.has(t.id), `The change set tried to update a record with id ${t.id} that was not present`);
                    const {
                      content: n,
                      permissions: r,
                      group: o,
                      isAnonymous: i
                    } = t;
                    e.set(t.id, {
                      content: n,
                      permissions: r,
                      group: o,
                      isAnonymous: i
                    }), c.push(t.id);
                  },
                  deleted: t => {
                    (0, a.kG)(e.has(t), `The change set you tried to delete a record with id ${t} that was not present`), e.delete(t), c.push(t);
                  }
                }
              }, t.accepted.created.forEach(n.accepted.created), t.accepted.updated.forEach(n.accepted.updated), t.accepted.deleted.forEach(n.accepted.deleted), ["created", "updated", "deleted"].forEach(e => {
                Object.entries(t.rejected[e]).forEach(t => {
                  let r = t[1];
                  "conflict" !== r && "attachment_not_found" !== r && (r = null), n.rejected(e, [t[0], r]);
                });
              }), t.changes.created.forEach(n.changes.created), t.changes.updated.forEach(n.changes.updated), t.changes.deleted.forEach(n.changes.deleted);
            });
          (0, a.kG)(i === r.size, "Some changes were not processed by the server");
          const p = function (e, t) {
            const n = e.localRecordsChanges.filter(e => "created" === e.type || !t.includes(e.id) || (e.reject(new a.p2("Request was cleared because a newer revision arrived.")), !1));
            return e.set("localRecordsChanges", n);
          }(e, (0, o.aV)(c));
          return p.withMutations(e => e.set("requiredAttachmentIds", l).update("localRecordsChanges", e => e.merge(u)).set("stagedRecordsChanges", (0, o.aV)()).set("localRecordsContents", d).set("localRecordsRev", n));
        }
        class l {
          constructor(e, t) {
            (0, r.Z)(this, "_currentDelay", 0), this._initialDelay = e, this._delayGrowthCap = t, this._currentDelay = e;
          }
          schedule(e) {
            const t = this._currentDelay;
            this.cancel(), t < this._delayGrowthCap && (this._currentDelay += 1e3 + Math.ceil(Math.random() * t)), this._timeout = setTimeout(() => e(), t);
          }
          cancel() {
            this._timeout && (clearTimeout(this._timeout), this._timeout = null);
          }
          reset() {
            this._currentDelay = this._initialDelay, this.cancel();
          }
        }
        var u = n(96723),
          c = n(74496);
        function d(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function p(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? d(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const h = 3e4;
        let f = 0;
        const m = new Set();
        function g() {
          m.forEach(e => {
            e._currentRequest && !e._currentRequestHasChanges && (e._abortCurrentRequest(), setTimeout(() => e.nextCycle().catch(console.log), 0));
          });
        }
        class v {
          constructor(e) {
            let {
              getState: t,
              setState: n,
              onChanges: o,
              onAcceptedRecords: i,
              longPollingTimeout: a = h,
              backoffTimer: s = new l(1e3, 6e4),
              RequestClass: c = u.Z
            } = e;
            (0, r.Z)(this, "onDocumentHandleConflictCallback", () => {}), (0, r.Z)(this, "_lastAbortedRequest", null), (0, r.Z)(this, "_handleBeforeUnload", () => {
              this._abortCurrentRequest();
            }), this._currentRequestHasChanges = !1, this._isDestroyed = !1, this.getState = t, this.setState = n, this.onChangesCallback = o || (() => {}), this.onAcceptedRecordsCallback = i || (() => {}), this.RequestClass = c, this._longPollingTimeout = a, this._backoffTimer = s, window.addEventListener("beforeunload", this._handleBeforeUnload), m.add(this);
          }
          async nextCycle() {
            let e,
              t,
              n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._longPollingTimeout;
            if (this._isDestroyed) return;
            if (this._currentRequest && this._currentRequestHasChanges) return (0, a.kG)(this._currentRequestPromise, "Expected to have request running but no one was ever made."), this._currentRequestPromise;
            this._currentRequest && (this._abortCurrentRequest(), this._backoffTimer && this._backoffTimer.cancel());
            const r = this.getState(),
              l = r.localRecordsChanges;
            this.setState(r.set("localRecordsChanges", (0, o.aV)()).set("stagedRecordsChanges", l));
            const u = this._createSyncRequest(),
              d = !l.isEmpty(),
              h = new Promise((n, r) => {
                e = n, t = r;
              }),
              m = (0, i.v4)(),
              g = {
                request_id: m,
                record_rev: r.localRecordsRev,
                changes: {
                  created: l.filter(e => "created" === e.type).map(e => {
                    let {
                      id: t,
                      content: n,
                      group: r,
                      isAnonymous: o
                    } = e;
                    const i = n && "isAnonymous" in n ? n.isAnonymous : o;
                    return p(p(p({
                      id: t
                    }, "boolean" == typeof i && {
                      isAnonymous: i
                    }), n && {
                      content: n
                    }), r && {
                      group: r
                    });
                  }).toJS(),
                  updated: l.filter(e => "updated" === e.type).map(e => {
                    let {
                      id: t,
                      content: n,
                      group: r,
                      isAnonymous: o
                    } = e;
                    const i = n && "isAnonymous" in n ? n.isAnonymous : o;
                    return p(p(p({
                      id: t
                    }, "boolean" == typeof i && {
                      isAnonymous: i
                    }), n && {
                      content: n
                    }), r && {
                      group: r
                    });
                  }).toJS(),
                  deleted: l.filter(e => "deleted" === e.type).map(e => e.id).toJS()
                },
                timeout: d ? 0 : n
              },
              v = r.requiredAttachmentIds.isEmpty() ? g : function (e, t) {
                const n = new FormData();
                return n.append("sync", JSON.stringify(e)), t.requiredAttachmentIds.forEach(e => {
                  var r;
                  n.append(e, null === (r = t.localRecordsChanges.find(t => t.attachments.hasOwnProperty(e))) || void 0 === r ? void 0 : r.attachments[e]);
                }), n;
              }(g, r);
            return u.request({
              method: "POST",
              data: v
            }).then(t => {
              void 0 !== t.request_id && (0, a.kG)(t.request_id === m, "The response doesn't match the client request ID"), (0, a.kG)(u !== this._lastAbortedRequest, "A manually aborted request still managed to resolve."), (0, a.kG)(u === this._currentRequest, "Expected the resolved request to be the latest created request."), (0, a.kG)(!this._isDestroyed, "The instance is destroyed yet the request managed to resolve.");
              const n = this.getState(),
                r = s(n, p(p({}, t), {}, {
                  previous_record_rev: n.localRecordsRev
                }));
              this.setState(r), this._currentRequestHasChanges = !1, this._currentRequest = null, f -= 1, e();
              try {
                t.record_rev > n.localRecordsRev && (this.onAcceptedRecordsCallback(t.accepted), this.onChangesCallback(t.changes)), this._scheduleNextCycle(!1, () => !r.localRecordsChanges.isEmpty());
              } catch (e) {
                throw f += 1, e;
              }
            }).catch(e => {
              if ("Outdated layer handle" === e.message && !this._isDestroyed) return this.onDocumentHandleConflictCallback(), this.destroy(), t();
              u === this._lastAbortedRequest ? t(new a.p2("A manually aborted request still managed to reject.")) : u !== this._currentRequest ? t(new a.p2("Expected the reject request to be the latest created request.")) : this._isDestroyed ? t(new a.p2("The instance is destroyed yet the request managed to reject.")) : t(new a.p2("Pushing changes failed" + (e && e.message ? `: ${e.message}` : "")));
              const n = (0, c.n)({
                oldChanges: l,
                newChanges: this.getState().localRecordsChanges
              });
              this.setState(r.set("localRecordsChanges", n).set("stagedRecordsChanges", (0, o.aV)())), this._currentRequestHasChanges = !1, this._currentRequest = null, f -= 1, this._scheduleNextCycle(!0);
            }), f += 1, f > 3 && (0, a.ZK)(`PSPDFKit: detected ${f} open sync requests. This might be due to multiple PSPDFKit for Web instances running in parallel, did you forget to \`unload\` any of them? Due to the browser limit of maximum number of default simultaneous persistent connections per server, this might cause subsequent requests to be queued and processed later which might result in a slowdown for your app.`), this._currentRequest = u, this._currentRequestHasChanges = d, this._currentRequestPromise = h, h;
          }
          setOnDocumentHandleConflictCallback(e) {
            this.onDocumentHandleConflictCallback = e;
          }
          destroy() {
            this._abortCurrentRequest(), window.removeEventListener("beforeunload", this._handleBeforeUnload), this._isDestroyed = !0, m.delete(this);
          }
          log(e) {
            (0, a.cM)(e);
          }
          _scheduleNextCycle(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : () => !0;
            const n = () => {
              this.nextCycle().catch(this.log);
            };
            e ? this._backoffTimer.schedule(n) : (this._backoffTimer.reset(), (this._longPollingTimeout > 0 || t()) && n());
          }
          _createSyncRequest() {
            const {
              serverURL: e,
              authPayload: t
            } = this.getState().requestInfo;
            return (0, a.kG)("string" == typeof e, "Cannot call request without serverURL"), (0, a.kG)(t && "string" == typeof t.auth_token, "Cannot call request without authPayload"), new this.RequestClass(e, t.auth_token);
          }
          _abortCurrentRequest() {
            this._currentRequest && (f -= 1, this._lastAbortedRequest = this._currentRequest, this._currentRequest.abort(), this._currentRequest = null);
          }
        }
      },
      74496: (e, t, n) => {
        "use strict";

        n.d(t, {
          n: () => o
        });
        var r = n(15359);
        function o() {
          let {
              oldChanges: e,
              newChanges: t
            } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = e;
          return t.forEach(e => {
            n = i({
              oldChanges: n,
              newChange: e
            });
          }), n;
        }
        function i() {
          let {
              oldChanges: e,
              newChange: t
            } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t,
            o = e.filter(e => {
              if (e.id === t.id) {
                switch (t.type) {
                  case "updated":
                    if ("created" === e.type) {
                      n = a(e, t.set("type", "created"));
                      break;
                    }
                    if ("updated" === e.type) {
                      n = a(e, t);
                      break;
                    }
                  case "deleted":
                    if ("created" === e.type) {
                      e.resolve(), t.resolve(), n = null;
                      break;
                    }
                    if ("updated" === e.type) {
                      n = a(e, t);
                      break;
                    }
                  default:
                    e.reject(new r.p2("Request was cleared because a more recent update was queued."));
                }
                return !1;
              }
              return !0;
            });
          return n && (o = o.push(n)), o;
        }
        function a(e, t) {
          const n = e.resolve,
            r = t.resolve,
            o = e.reject,
            i = t.reject;
          return t.set("resolve", e => {
            n(e), r(e);
          }).set("reject", e => {
            o(e), i(e);
          });
        }
      },
      2549: (e, t, n) => {
        "use strict";

        n.d(t, {
          V: () => o,
          h: () => i
        });
        var r = n(15359);
        function o(e, t) {
          let n;
          return n = e instanceof Error ? e : new Error(e), Object.setPrototypeOf(n, o.prototype), n.reason = t, n;
        }
        function i(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
          return new o(n ? `Some changes could not be ${t ? "synced" : "saved"} to backend: ${n}` : `Some changes could not be ${t ? "synced" : "saved"} to backend.`, e);
        }
        o.prototype = Object.create(r.p2.prototype, {
          name: {
            value: "PSPDFKitSaveError",
            enumerable: !1
          }
        });
      },
      24382: (e, t, n) => {
        "use strict";

        n.d(t, {
          y: () => r,
          z: () => o
        });
        const r = 1,
          o = 2;
      },
      69867: (e, t, n) => {
        "use strict";

        n.d(t, {
          f: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(44077);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class u {
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "",
              a = arguments.length > 4 ? arguments[4] : void 0;
            if (this.examples = t, this.customStyles = n, this.document = a ? a.ownerDocument : e, this.wrapper = e.createElement("div"), this.wrapper.setAttribute("aria-hidden", "true"), this.wrapper.className = r, this._setStyles(this.wrapper, l(l({}, u.defaultWrapperStyles), n)), t instanceof o.aV) t.forEach(t => {
              const n = "string" == typeof t ? t : "",
                r = e.createElement("span");
              r.setAttribute("aria-hidden", "true"), r.style.display = "inline-block", r.style.whiteSpace = "pre-wrap", r.innerText = n, this.wrapper.appendChild(r);
            });else {
              const e = "string" == typeof t ? t : "";
              this.wrapper.innerHTML = e;
            }
            const s = a || this.document.documentElement;
            (0, i.kG)(s, "documentElement must not be null"), s.appendChild(this.wrapper);
          }
          measure() {
            const e = a.UL.fromClientRect(this.wrapper.getBoundingClientRect()),
              t = e.getLocation().scale(-1);
            return this.examples instanceof o.aV ? this.examples.map((e, n) => {
              const r = this.wrapper.childNodes[n];
              return a.UL.fromClientRect(r.getBoundingClientRect()).translate(t);
            }) : (0, o.aV)([e.translate(t)]);
          }
          remove() {
            this.wrapper.parentNode && this.wrapper.parentNode.removeChild(this.wrapper), this.wrapper = null, this.examples = null;
          }
          _setStyles(e, t) {
            for (const n in t) e.style[n] = t[n];
          }
        }
        (0, r.Z)(u, "defaultWrapperStyles", Object.freeze({
          maxWidth: "none",
          display: "inline-block",
          position: "absolute",
          height: "auto",
          width: "auto",
          margin: "0",
          padding: "0",
          whiteSpace: "nowrap",
          top: "-10000px",
          left: "-10000px",
          fontSize: "80px",
          fontWeight: "normal"
        }));
      },
      2891: (e, t, n) => {
        "use strict";

        n.d(t, {
          GA: () => T,
          Nk: () => z,
          oD: () => A
        });
        var r = n(15359),
          o = n(35369),
          i = n(67366),
          a = n(27856),
          s = n.n(a),
          l = n(4715),
          u = n(45249),
          c = n(94732),
          d = n(79724),
          p = n(41172),
          h = n(33427),
          f = n(4087),
          m = n(51065),
          g = n(29977),
          v = n(20993),
          y = n(5130),
          b = n(12705),
          w = n(1858),
          x = n(72127),
          D = n(27922),
          C = n(3888),
          S = n(21713),
          E = n(44550);
        const _ = (0, d.Z)("Annotations"),
          P = "The API you're trying to use requires a annotation editing license. Annotation Editing is a component of PSPDFKit for Web and thus sold separately.\nhttps://pspdfkit.com/guides/web/current/annotations/introduction-to-annotations/",
          k = "WidgetAnnotation can only be modified if you are using Standalone setup or with Instant turned on. If you are using server backed setup, make sure `instant` is set to `true` in configuration.",
          A = "The API you're trying to use requires a measurement license. Measurement is a component of PSPDFKit for Web and sold separately.";
        class z extends v.I {
          constructor(e, t) {
            super(t().annotationManager), this.dispatch = e, this.getState = t;
          }
          async create(e, t) {
            const n = this.getState(),
              o = e.map(e => {
                O(n, e, "create");
                const o = e.id;
                if ("string" == typeof o && _(!n.annotations.has(o), `Annotation id (${o}) is already used.`), e instanceof l.x_ && t) {
                  T(n, e) || _(t.some(t => t instanceof w.Wi && t.name === e.formFieldName), `Widget orphan: The widget annotation can't be created because no form field was found with the name '${e.formFieldName}'. Please ensure that you create the corresponding form field together with the widget via instance.create([widget, formField]).`);
                }
                const {
                  annotationCreatorName: i,
                  annotationCreatorNameReadOnly: a
                } = n;
                if (e.creatorName && e.creatorName !== i && a) throw new r.p2("The annotation creator name is different from the one set on the JWT.");
                M(e);
                let s = e.withMutations(t => {
                  t.merge((0, h.lx)(n.set("currentItemPreset", null))), ["name", "id", "creatorName", "createdAt", "updatedAt"].map(n => e[n] && t.set(n, e[n]));
                });
                if (e instanceof l.x_ && e.group) throw new r.p2("If you want to define the `group` of this widget annotation, pass it to the corresponding form field instead. Widget annotations inherit the `group` from their form field.");
                if (s instanceof l.x_ && (s = s.delete("group")), e instanceof l.x_) {
                  const n = this.getState;
                  if ((null == t ? void 0 : t.some(t => t instanceof w.Wi && t.name === e.formFieldName)) && !!T(n(), e)) throw new r.p2(`The widget annotation can't be created because the form field it'll be created with has a duplicated form field name '${e.formFieldName}'. Please ensure the form field name is unique.`);
                  setTimeout(() => {
                    _(s instanceof l.x_, "Expected widget annotation");
                    null == T(n(), s) && (this.dispatch((0, f.hQ)(s)), (0, r.ZK)(`Widget orphan: The widget annotation has been deleted because no form was field found with the name ${s.formFieldName} after 500ms. Please ensure that once instance.create() resolves, a corresponding form field is created with instance.create(). (See: https://pspdfkit.com/api/web/PSPDFKit.Instance.html#create)`));
                  }, 500);
                }
                return s = R(s), s;
              });
            return this.dispatch((0, f.WL)(o.filter(e => !(e instanceof Error)))), this.autoSave(), (0, S.s)(o);
          }
          async update(e) {
            const t = this.getState(),
              n = e.map(e => {
                var n;
                O(t, e, "update"), _("string" == typeof e.id, "The annotation you passed to Instance.update() has no id.\nPlease use Instance.create() first to assign an id.");
                const o = t.annotations.get(e.id);
                _(o, "An annotation that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\nThe update of this annotation was skipped."), _(!(e instanceof l.sK && e.imageAttachmentId !== (null === (n = t.annotations.get(e.id)) || void 0 === n ? void 0 : n.imageAttachmentId)), "Changing the imageAttachmentId of an annotation is not allowed."), _(t.backend), t.backend.isCollaborationPermissionsEnabled() || e.group === o.group && e.isEditable === o.isEditable && e.isDeletable === o.isDeletable && e.canSetGroup === o.canSetGroup || (e = e.set("group", o.group).set("isEditable", o.isEditable).set("isDeletable", o.isDeletable).set("canSetGroup", o.canSetGroup), (0, r.ZK)("`group`, `isEditable`, `isDeletable` and `canSetGroup` are only relevant when Collaboration Permissions are enabled in server backed setup. You do not have it enabled so these values are set to `undefined`."));
                if (!e.delete("group").equals(o.delete("group")) && !(0, x.CM)(o, t)) throw new r.p2("You don't have permission to update this annotation.");
                if (e instanceof l.x_ && e.group !== o.group) throw new r.p2("The `group` property of widget annotations is read only and can't be updated directly. If you want to do that you should update the `group` property of the connected form field and this annotation will inherit that `group`.");
                if (e.group !== o.group && !(0, x.uW)(o, t)) throw new r.p2("You don't have permission to update the `group` of this annotation.");
                if (e.isEditable !== o.isEditable || e.isDeletable !== o.isDeletable || e.canSetGroup !== o.canSetGroup) throw new r.p2("You can't update `isEditable`, `canSetGroup` or `isDeletable` since they are read only properties which depend on the `group` property.");
                if (e.creatorName !== o.creatorName && t.annotationCreatorNameReadOnly) throw new r.p2("You can't change the creatorName of an annotation if it was already set on the JWT.");
                const i = (e = R(e)).set("updatedAt", new Date());
                return M(i), i;
              });
            return n.length > 0 && (0, i.dC)(() => {
              n.forEach(e => {
                e instanceof Error || this.dispatch((0, f.FG)(e));
              }), this.autoSave();
            }), (0, S.s)(n);
          }
          async delete(e) {
            const t = this.getState(),
              n = e.map(e => {
                O(t, e, "delete");
                const n = t.annotations.get(e.id);
                if (_(n, `No annotation with id ${e.id} found.`), !(0, x.Kd)(n, t)) throw new r.p2("You don't have permission to delete this annotation.");
                return e;
              });
            return n.length > 0 && (0, i.dC)(() => {
              n.forEach(e => {
                e instanceof Error || this.dispatch((0, f.hQ)(e));
              }), this.autoSave();
            }), (0, S.s)(n);
          }
          async ensureChangesSaved(e) {
            _("string" == typeof e.id, "The annotation you passed to Instance.ensureChangesSaved() has no id.\nPlease use Instance.create() first to assign an id.");
            const {
              annotationManager: t
            } = this.getState();
            return _(t), await t.ensureObjectSaved(e);
          }
          async getObjectById(e) {
            _("string" == typeof e, "The supplied id is not a valid id.");
            const {
              annotations: t,
              features: n
            } = this.getState();
            return (0, b.Vz)(n) ? t.get(e) : null;
          }
        }
        function T(e, t) {
          const n = e.annotations.get(t.id);
          let r = t.formFieldName;
          return null != n && null != n.formFieldName && (r = n.formFieldName), null != r ? e.formFields.get(r) : null;
        }
        function O(e, t, n) {
          const {
            features: o
          } = e;
          if (!(0, b.Vz)(o)) {
            if (!(t instanceof u.Zc || t instanceof l.sK)) throw new r.p2(`Annotations: ${P}`);
            if (!0 === t.isSignature && !o.includes(E.q.ELECTRONIC_SIGNATURES)) throw new r.p2("Annotations: The API you're trying to use requires either an electronic signatures or annotation editing license. Electronic Signatures and Annotation Editing are components of PSPDFKit for Web and thus sold separately.\nhttps://pspdfkit.com/guides/web/current/annotations/introduction-to-annotations/");
            if (!t.isSignature || !o.includes(E.q.ELECTRONIC_SIGNATURES)) throw new r.p2(`Annotations: ${P}`);
          }
          let i = "";
          t.id && (i = ` with id "${t.id}"`), t instanceof l.x_ && function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
            const {
              features: n
            } = e;
            _(n.includes(E.q.FORM_DESIGNER), (t || "") + y.RB), _((0, b.k_)(e.backend), k);
          }(e, `Tried to ${n} a widget annotation${i}. Widget annotations are part of forms. `), _(!(t instanceof c.Z) || o.includes(E.q.REDACTIONS), `Tried to ${n} a redaction annotation${i}. ${p.q}`), _(!(t instanceof u.UX && t.isMeasurement()) || o.includes(E.q.MEASUREMENT_TOOLS), `Tried to ${n} a measurement annotation${i}. ${A}`);
        }
        function I(e) {
          _(e instanceof u.UL, "`boundingBox` must be an instance of PSPDFKit.Geometry.Rect");
          for (const [t, n] of e) _("number" == typeof n, `invalid value \`${n}\` for \`boundingBox.${t}\``);
        }
        function F(e) {
          _(e instanceof u.E9, "`startPoint` and `endPoint` must be instances of PSPDFKit.Geometry.Point");
          for (const [t, n] of e) _("number" == typeof n, `invalid value \`${n}\` for \`point.${t}\``);
        }
        function M(e) {
          if (_(e instanceof l.q6, "Invalid annotation"), _("number" == typeof e.pageIndex, "`pageIndex` must be a number"), _("number" == typeof e.opacity, "`opacity` must be a number"), _("boolean" == typeof e.noView, "`noView` must be a boolean"), _("boolean" == typeof e.noPrint, "`noPrint` must be a boolean"), _("boolean" == typeof e.noZoom, "`noZoom` must be a boolean"), _("boolean" == typeof e.hidden, "`hidden` must be a boolean"), _(null == e.customData || (0, r.PO)(e.customData) && (0, r.AK)(e.customData), "`customData` must be a serializable object"), I(e.boundingBox), "text" in e && null != e.text && (_("object" == typeof e.text && null !== e.text, "`text` is not an object with properties `format` and `value`"), _("plain" === e.text.format || "xhtml" === e.text.format, "Invalid text format"), _("string" == typeof e.text.value, "`text.value` must be a string")), e instanceof u.Qi && _("plain" === e.text.format, "Invalid text format. Only `plain` format is supported"), e instanceof l.x_) {
            if (e.additionalActions) for (const [t, n] of Object.entries(e.additionalActions)) _("onBlur" === t || "onFocus" === t || "onInput" === t || "onFormat" === t || "onChange" === t, `Invalid attribute ${t} in \`additionalActions\`. Supported attributes: \`onBlur\`, \`onFocus\`, \`onInput\`, \`onFormat\`, \`onChange\``), _(n instanceof D.b, `Invalid attribute type of ${t} in \`additionalActions\`. ${t} must be of type \`PSPDFKit.Actions.JavaScriptAction\``);
            _("string" == typeof e.formFieldName && e.formFieldName.length > 0, "Annotation attribute `formFieldName` must be of type `string` and larger than 0 characters");
          }
          if ((e instanceof l.x_ || e instanceof l.gd) && (null != e.isItalic && _("boolean" == typeof e.isItalic, "Annotation attribute `isItalic` must be of type `boolean`"), null != e.isBold && _("boolean" == typeof e.isBold, "Annotation attribute `isBold` must be of type `boolean`"), null != e.verticalAlign && _("string" == typeof e.verticalAlign && ("top" === e.verticalAlign || "center" === e.verticalAlign || "bottom" === e.verticalAlign), "Annotation attribute `verticalAlign` must be of type `string` and either `top`, `center`, or `bottom`"), null != e.horizontalAlign && _("string" == typeof e.horizontalAlign && ("left" === e.horizontalAlign || "center" === e.horizontalAlign || "right" === e.horizontalAlign), "Annotation attribute `horizontalAlign` must be of type `string` and either `left`, `center`, or `right`"), null != e.borderWidth && _("number" == typeof e.borderWidth, "Annotation attribute `borderWidth` must be of type `number`"), null != e.borderStyle && _(e.borderStyle === C.N.solid || e.borderStyle === C.N.dashed || e.borderStyle === C.N.beveled || e.borderStyle === C.N.inset || e.borderStyle === C.N.underline, "Annotation attribute `borderStyle` must be one of `solid`, `dashed`, `beveled`, `inset`, `underline`"), null != e.font && _("string" == typeof e.font && e.font.length > 0, "Annotation attribute `font` must be of type `string` and larger than 0 characters."), null != e.fontSize && _("number" == typeof e.fontSize || "auto" === e.fontSize, "Annotation attribute `fontSize` must be of type `number` or the string `auto`")), ["fillColor", "backgroundColor", "fontColor", "color", "borderColor", "strokeColor"].forEach(t => {
            e.has(t) && null !== e.get(t) && _(e.get(t) instanceof u.Il, `\`${t}\` must be an instance of PSPDFKit.Color`);
          }), e.has("lines") && (_("lines" in e && e.lines instanceof o.aV, "lines must be an instance of PSPDFKit.Immutable.List"), e.lines.forEach((e, t) => {
            _(e instanceof o.aV, "line must be an instance of PSPDFKit.Immutable.List"), e.some((e, n) => {
              _(e instanceof m.Z, `found an invalid DrawingPoint at index ${n} for line ${t}`);
            });
          })), e instanceof l.On && _(e.has("rects"), "Text markup annotations must have `rects`"), e instanceof l.GI && _(g.pY[e.stampType], `Unknown stamp annotation stampType: \`${e.stampType}\``), e.has("rects") && (_("rects" in e && e.rects instanceof o.aV, "rects must be an instance of `PSPDFKit.Immutable.List`"), _(e.rects.size > 0, "rects must be contain at least one rect"), e.rects.forEach(I)), e.has("startPoint") && (_("startPoint" in e && e.startPoint instanceof u.E9, "startPoint must be an instance of `PSPDFKit.Immutable.Point`"), F(e.startPoint)), e.has("endPoint") && (_("endPoint" in e && e.endPoint instanceof u.E9, "endPoint must be an instance of `PSPDFKit.Immutable.Point`"), F(e.endPoint)), e.has("rotation")) {
            const t = e.rotation;
            e instanceof l.x_ ? _(0 === t || 90 === t || 180 === t || 270 === t, "`rotation` must be of type `number` and one of 0, 90, 180, or 270.") : (e instanceof l.gd || e instanceof l.GI || e instanceof l.sK) && _(Math.abs(t) % 1 == 0, "`rotation` must be an integer");
          }
        }
        function R(e) {
          let t = e;
          if (e instanceof l.gd && "xhtml" === e.text.format) {
            let n, o, i;
            _(t instanceof l.gd, "Expected TextAnnotation");
            try {
              n = new DOMParser().parseFromString(e.text.value, "text/html");
            } catch (e) {
              throw new r.p2("TextAnnotation text value must be a valid xhtml string.");
            }
            if (n = n.firstChild, "parsererror" === n.nodeName) throw new r.p2("TextAnnotation text value must contain a valid xhtml string.");
            "#comment" === n.nodeName.toLowerCase() && (n = n.nextSibling), "html" === n.nodeName.toLowerCase() && (n = n.firstChild), "head" === n.nodeName.toLowerCase() && (n = n.nextSibling), "body" === n.nodeName.toLowerCase() && (n = n.firstChild), "div" === n.nodeName.toLowerCase() && (n = n.firstChild, o = document.createElement("div")), "p" !== n.nodeName.toLowerCase() ? ((0, r.ZK)("TextAnnotation text value must be wrapped in <p> tags if the format is `xhtml`."), i = document.createElement("p"), i.appendChild(n), o ? o.appendChild(i) : o = i) : o = n, t = t.set("text", {
              format: "xhtml",
              value: s().sanitize(o.outerHTML)
            }), e.fontColor && ((0, r.ZK)('TextAnnotation fontColor is not supported for xhtml formatted text. You should add inline span element to the text value instead.\n\n      Example: <p><span style="color: #ff0000;">your text</span></p>'), t = t.set("fontColor", null)), e.text.value || (t = t.set("text", {
              format: "xhtml",
              value: '<p><span style="color: #000000"></span></p>'
            }));
          }
          return t;
        }
      },
      20993: (e, t, n) => {
        "use strict";

        n.d(t, {
          I: () => o
        });
        var r = n(15359);
        class o {
          constructor(e) {
            this._objectManager = e;
          }
          create(e, t) {
            return Promise.reject(new r.p2("create() is not implemented"));
          }
          update(e, t) {
            return Promise.reject(new r.p2("update() is not implemented"));
          }
          delete(e) {
            return Promise.reject(new r.p2("delete() is not implemented"));
          }
          getObjectById(e) {
            return Promise.resolve(null);
          }
          ensureChangesSaved(e) {
            throw new r.p2("ensureChangesSaved() is not implemented");
          }
          hasUnsavedChanges() {
            return !!this._objectManager && this._objectManager.hasUnsavedChanges();
          }
          manualSave(e) {
            return this._objectManager ? this._objectManager.manualSave(e) : Promise.resolve();
          }
          autoSave() {
            this._objectManager && this._objectManager.autoSave();
          }
          getEventEmitter() {
            return this._objectManager ? this._objectManager.eventEmitter : null;
          }
          lockSave() {
            return this._objectManager ? this._objectManager.lockSave() : () => {};
          }
        }
      },
      5130: (e, t, n) => {
        "use strict";

        n.d(t, {
          BZ: () => D,
          Bl: () => x,
          DR: () => b,
          RB: () => w,
          _1: () => P,
          fu: () => S
        });
        var r = n(34997),
          o = n(35369),
          i = n(15359),
          a = n(67366),
          s = n(79724),
          l = n(43069),
          u = n(12705),
          c = n(77897),
          d = n(48169),
          p = n(20993),
          h = n(72127),
          f = n(27922),
          m = n(21713),
          g = n(45249),
          v = n(1858),
          y = n(44550);
        const b = "The API you're trying to use requires a forms license. Forms is a component of PSPDFKit for Web and thus sold separately.\nhttps://pspdfkit.com/guides/web/current/forms/introduction-to-forms/",
          w = "The API you're trying to use requires a license that includes the Form Designer component on standalone mode or with PSPDFKit Instant. This is a separate component of PSPDFKit for Web and thus sold separately.\nhttps://pspdfkit.com/guides/web/current/forms/introduction-to-forms/",
          x = "The API you're trying to use is only available when using the standalone mode or with PSPDFKit Instant.",
          D = "The API you're trying to use is not available when `disableForms` is set to `true`.",
          C = (0, s.Z)("Forms");
        class S extends p.I {
          constructor(e, t) {
            super(t().formFieldManager), this.dispatch = e, this.getState = t;
          }
          async create(e, t) {
            const n = [],
              i = this.getState();
            E(i, "Tried to create a form field. ");
            const s = e.map(e => {
              try {
                const o = e.id;
                "string" == typeof o && C(!(0, l.CL)(i, o), `Form field id (${o}) is already used.`), _(e, i, t);
                let a = "string" == typeof o ? e : e.set("id", (0, r.SK)());
                if (C(i.backend), C(i.formFieldValueManager), i.backend.isCollaborationPermissionsEnabled() && !e.group && i.group !== i.backend.getDefaultGroup() && (a = a.set("group", i.group)), void 0 !== e.value || void 0 !== e.values) {
                  const t = new d.Z({
                    name: e.name,
                    value: void 0 !== e.value ? e.value : e.values
                  });
                  n.push(t);
                }
                return a;
              } catch (e) {
                return e;
              }
            });
            return (0, a.dC)(() => {
              s.forEach(e => {
                e instanceof Error || (this.dispatch((0, c.kW)(e)), this.autoSave());
              });
            }), n.forEach(e => {
              this.dispatch((0, c.xW)((0, o.aV)([e]))), C(i.formFieldValueManager), i.formFieldValueManager.createObject(e), i.formFieldValueManager.autoSave();
            }), (0, m.s)(s);
          }
          async update(e, t) {
            const n = this.getState();
            C(n.formFieldValueManager);
            const r = e.map(e => {
              try {
                E(n, "Tried to update a form field. "), C("string" == typeof e.id, "The form field you passed to Instance.update() has no id.\n      Please use Instance.create() first to assign an id."), _(e, n, t);
                const r = (0, l.CL)(n, e.id);
                C(r, "A form field that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\nThe update of this form field was skipped."), C(n.backend), n.backend.isCollaborationPermissionsEnabled() || e.group === r.group && e.isEditable === r.isEditable && e.isDeletable === r.isDeletable && e.canSetGroup === r.canSetGroup && e.isFillable === r.isFillable || (e = e.set("group", r.group).set("isEditable", r.isEditable).set("isDeletable", r.isDeletable).set("canSetGroup", r.canSetGroup).set("isFillable", r.isFillable), (0, i.ZK)("`group`, `isEditable`, `isDeletable`, `isFillable` and `canSetGroup` are only relevant when Collaboration Permissions are enabled in server backed setup. You do not have it enabled so these values are set to `undefined`."));
                if (!e.delete("group").equals(r.delete("group")) && !(0, h.iR)(r, n)) throw new i.p2("You don't have permission to update this form field.");
                if (e.group !== r.group && !(0, h.uW)(r, n)) throw new i.p2("You don't have permission to update the `group` of this form field.");
                if (e.isEditable !== r.isEditable || e.isDeletable !== r.isDeletable || e.canSetGroup !== r.canSetGroup || e.isFillable !== r.isFillable) throw new i.p2("You can't update `isFillable`, `isEditable`, `canSetGroup` or `isDeletable` since they are read only properties which depend on the `group` property.");
                return e;
              } catch (e) {
                return e;
              }
            });
            return (0, a.dC)(() => {
              r.forEach(e => {
                e instanceof Error || (this.dispatch((0, c.vK)(e)), this.autoSave());
              });
            }), (0, m.s)(r);
          }
          async delete(e) {
            const t = this.getState();
            E(t, "Tried to delete a form field. ");
            const n = e.map(e => {
              try {
                const r = (0, l.CL)(t, e.id);
                if (C(r, `There is no form field with id '${e.id}'`), C(t.formFieldValueManager), !(0, h.ev)(r, t)) throw new i.p2("You don't have permission to delete this form field.");
                var n;
                if (void 0 !== r.value || void 0 !== r.values) null === (n = t.formFieldValueManager) || void 0 === n || n.deleteObject(new d.Z({
                  name: r.name,
                  value: void 0 !== r.value ? r.value : r.values
                })), t.formFieldValueManager.autoSave();
                return e;
              } catch (e) {
                return e;
              }
            });
            return (0, a.dC)(() => {
              n.forEach(e => {
                e instanceof Error || (this.dispatch((0, c.Wh)(e)), this.autoSave());
              });
            }), (0, m.s)(n);
          }
          async ensureChangesSaved(e) {
            C("string" == typeof e.id, "The form field you passed to Instance.ensureSaved() has no id.\n Please use Instance.create() first to assign an id.");
            const {
              formFieldManager: t
            } = this.getState();
            return C(t), await t.ensureObjectSaved(e);
          }
          async getObjectById(e) {
            return C("string" == typeof e, "The supplied id is not a valid id."), (0, l.CL)(this.getState(), e);
          }
        }
        function E(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          const {
            features: n,
            formsEnabled: r
          } = e;
          C(n.includes(y.q.FORMS), (t || "") + b), C(r, (t || "") + D), C(n.includes(y.q.FORM_DESIGNER), (t || "") + w), C((0, u.k_)(e.backend), x);
        }
        function _(e, t, n) {
          if (e.additionalActions) for (const [t, n] of Object.entries(e.additionalActions)) C("onCalculate" === t || "onChange" === t || "onFormat" === t || "onInput" === t, `Invalid attribute ${t} in \`additionalActions\`. Supported attributes: \`onCalculate\`, \`onChange\`, \`onFormat\`, \`onInput\``), C(n instanceof f.b, `Invalid attribute type of ${t} in \`additionalActions\`. ${t} must be of type \`PSPDFKit.Actions.JavaScriptAction\``);
          e.annotationIds && (C(e.annotationIds instanceof o.aV, "Invalid form field `annotationIds` attribute. `annotationIds` must be of type `PSPDFKit.Immutable.List`"), C(e.annotationIds.every(e => "string" == typeof e), "Invalid form field `annotationIds` attribute. `annotationIds` should only contain string values."), e.annotationIds.forEach(e => {
            !function (e, t, n) {
              const r = e.get("annotations");
              if (!(((null == t ? void 0 : t.find(e => e instanceof g.q6 && e.id === n)) || r.get(n) || r.find(e => {
                var t;
                return (null == e || null === (t = e.pdfObjectId) || void 0 === t ? void 0 : t.toString()) === n;
              })) instanceof g.x_)) throw new i.p2("Invalid form field `annotationIds` attribute. `annotationIds` should only contain references to widget annotations.");
            }(t, n, e);
          })), null != e.id && C("string" == typeof e.id && e.id.length > 0, "Invalid form field `id` attribute. `id` must be of type `string` and larger than 0 characters."), null != e.label && C("string" == typeof e.label, "Invalid form field `label` attribute. `label` must be of type `string`"), C("string" == typeof e.name && e.name.length > 0, "Invalid form field `name` attribute. `name` must be of type `string` and larger than 0 characters."), null != e.noExport && C("boolean" == typeof e.noExport, "Invalid form field `noExport` attribute. `noExport` must be of type `boolean`"), null != e.pdfObjectId && C("number" == typeof e.pdfObjectId, "Invalid form field `pdfObjectId` attribute. `pdfObjectId` must be of type `number`"), null != e.readOnly && C("boolean" == typeof e.readOnly, "Invalid form field `readOnly` attribute. `readOnly` must be of type `boolean`"), null != e.required && C("boolean" == typeof e.required, "Invalid form field `required` attribute. `required` must be of type `boolean`");
        }
        function P(e, t) {
          e instanceof v.$o ? C("string" == typeof (t = t || ""), `The type of action value for a TextFormField ${e.name} is ${typeof t}, but has to be a string`) : e instanceof v.Dz || e instanceof v.rF ? C(t instanceof o.aV, `The type of action value for the ${e instanceof v.Dz ? "ChoiceFormField" : "CheckBoxFormField"} ${e.name} is ${typeof t}, but has to be a List of strings`) : e instanceof v.XQ ? C("string" == typeof t || null === t, `The type of action value for a RadioButtonFormField ${e.name} is ${typeof t}, but has to either be a string or null`) : e instanceof v.R0 || e instanceof v.Yo || C(!1, `Cannot set form field value for ${e.name}: unknown form field type`);
        }
      },
      60209: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        class r {
          constructor(e, t) {
            this.element = e, this.release = t;
          }
        }
      },
      96326: (e, t, n) => {
        "use strict";

        n.d(t, {
          a: () => w
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(47120);
        const s = "CREATED",
          l = "UPDATED",
          u = "DELETED";
        var c = n(46364),
          d = n(79685),
          p = n(79724),
          h = n(34997);
        class f {
          constructor() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : () => {};
            (0, r.Z)(this, "_locks", (0, o.l4)()), this._onUnlockCallback = e;
          }
          lock() {
            const e = (0, h.SK)();
            return this._locks = this._locks.add(e), () => {
              this._locks = this._locks.remove(e), this._locks.isEmpty() && this._onUnlockCallback();
            };
          }
          isLocked() {
            return !this._locks.isEmpty();
          }
        }
        var m = n(2549);
        const g = (0, p.Z)("SaveModeQueue");
        class v {
          constructor(e) {
            let {
              autoSaveMode: t,
              flushCreateObject: n,
              flushUpdateObject: i,
              flushDeleteObject: s,
              validateObject: l,
              getObjectId: u,
              syncChanges: c = async () => {}
            } = e;
            (0, r.Z)(this, "eventEmitter", new d.Z(["willSave", "didSave", "saveStateChange"])), (0, r.Z)(this, "_modifications", (0, o.D5)()), (0, r.Z)(this, "_inFlightModifications", (0, o.D5)()), (0, r.Z)(this, "_savedObjects", (0, o.l4)()), (0, r.Z)(this, "_ensureSavedRequests", (0, o.D5)()), (0, r.Z)(this, "_prevHasUnsavedObjects", !1), (0, r.Z)(this, "_saveLock", new f(() => {
              if (this._autoSaveMode === a.u.IMMEDIATE || !this._saveRequests.isEmpty()) {
                const e = this._autoSaveMode === a.u.IMMEDIATE || this._saveRequests.some(e => e.syncChanges),
                  t = this._saveRequests.some(e => e.manualSave),
                  n = this._saveRequests;
                this._saveRequests = this._saveRequests.clear(), this._save(e, t).then(() => {
                  n.forEach(e => {
                    e.resolve();
                  });
                }).catch(e => {
                  n.forEach(t => {
                    t.reject(e);
                  });
                });
              }
            })), (0, r.Z)(this, "_saveRequests", (0, o.aV)()), this._autoSaveMode = t, this._flushCreateObject = n, this._flushUpdateObject = i, this._flushDeleteObject = s, this._validateObject = l, this._getObjectId = u, this._syncChanges = c;
          }
          lockSave() {
            return this._saveLock.lock();
          }
          assertSaveLocked() {
            g(this._saveLock.isLocked(), "This method can't be used without active save lock, use saveLock() to acquire the lock.");
          }
          createObject(e) {
            this.assertSaveLocked();
            const t = this._getObjectId(e);
            this._setModificationsAndNotifyChange(this._modifications.set(t, {
              object: e,
              type: s
            }));
          }
          updateObject(e) {
            this.assertSaveLocked();
            const t = this._getObjectId(e),
              n = this._modifications.get(t),
              r = n && n.type === s && !this._inFlightModifications.has(t);
            this._setModificationsAndNotifyChange(this._modifications.set(t, {
              object: e,
              type: r ? s : l
            }));
          }
          deleteObject(e) {
            this.assertSaveLocked();
            const t = this._getObjectId(e),
              n = this._modifications.get(t);
            n && n.type === s ? this._setModificationsAndNotifyChange(this._modifications.delete(t)) : this._setModificationsAndNotifyChange(this._modifications.set(t, {
              object: e,
              type: u
            }));
          }
          enqueueInFlightModification(e) {
            const t = this._getObjectId(e.object);
            return this._inFlightModifications.has(t) ? this._inFlightModifications = this._inFlightModifications.updateIn([t], t => t.push(e)) : this._inFlightModifications = this._inFlightModifications.set(t, (0, o.aV)([e])), this._notifySaveStateChange(), () => {
              this._inFlightModifications = this._inFlightModifications.updateIn([t], t => t.filter(t => t !== e));
              const n = this._inFlightModifications.get(t);
              n && 0 === n.size && (this._inFlightModifications = this._inFlightModifications.delete(t)), this._notifySaveStateChange();
            };
          }
          clearQueueForObject(e) {
            this._setModificationsAndNotifyChange(this._modifications.delete(e));
          }
          queuedObjectType(e) {
            const t = this._inFlightModifications.get(e);
            if (t && t.size > 0) return t.last().type;
            {
              const t = this._modifications.get(e);
              return t ? t.type : null;
            }
          }
          hasUnsavedObjects() {
            return this._modifications.size > 0 || this._inFlightModifications.size > 0;
          }
          autoSave() {
            this._autoSaveMode === a.u.INTELLIGENT && this.manualSave(!0).catch(() => {});
          }
          manualSave() {
            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return this._save(e, !0);
          }
          _save(e, t) {
            return new Promise((n, r) => {
              if (this._saveLock.isLocked()) this._saveRequests = this._saveRequests.push({
                resolve: n,
                reject: r,
                syncChanges: e,
                manualSave: t
              });else {
                const a = this._modifications.filter(e => {
                  let {
                    type: t
                  } = e;
                  return t !== u;
                }).filter(e => {
                  let {
                    object: t
                  } = e;
                  return !this._validateObject(t);
                });
                t && a.forEach(e => {
                  (0, i.ZK)(`Can not save invalid object with ID: ${this._getObjectId(e.object)}.\n  Make sure to remove or update this object, before trying to save again.`);
                });
                let d = (0, o.aV)();
                const p = this._modifications.filter((e, t) => !a.has(t)),
                  h = p.map(e => {
                    let {
                      object: t,
                      type: n
                    } = e;
                    const r = {
                      object: t,
                      type: n
                    };
                    let o;
                    switch (d = d.push(this.enqueueInFlightModification(r)), n) {
                      case s:
                        o = this._flushCreateObject(t);
                        break;
                      case l:
                        o = this._flushUpdateObject(t);
                        break;
                      default:
                        o = this._flushDeleteObject(t);
                    }
                    return o.then(() => {
                      this._markModificationAsSaved(r);
                    }).catch(e => {
                      throw y(e), e;
                    });
                  }).valueSeq().toArray();
                if (this._setModificationsAndNotifyChange(a, !1), e && h.length > 0 && h.push(this._syncChanges().catch(e => {
                  throw y(e), e;
                })), this.eventEmitter.emit("willSave"), 0 === h.length) return this.eventEmitter.emit("didSave"), void n();
                let f;
                (0, c.jK)(h).catch(t => {
                  const n = p.toList(),
                    r = e ? t.pop() : null,
                    i = t.map((e, t) => {
                      const r = n.get(t);
                      if (e && r) return {
                        error: e,
                        object: r.object,
                        modificationType: r.type
                      };
                    }).filter(Boolean);
                  throw f = (0, o.aV)(i), (0, m.h)(i, Boolean(r), r ? r.message : null);
                }).finally(() => {
                  d.forEach(e => {
                    e();
                  });
                  let e = p;
                  f && (e = e.withMutations(e => {
                    g(f), f.forEach(t => {
                      const n = this._getObjectId(t.object);
                      e.remove(n);
                    });
                  })), this._resolveEnsureSavedRequests(e.map(e => e.object).valueSeq().toArray()), f && this._rejectEnsureSavedRequests(f.toArray()), this.eventEmitter.emit("didSave");
                }).then(() => {
                  n();
                }).catch(r);
              }
            });
          }
          markObjectsAsSaved(e) {
            this._savedObjects = this._savedObjects.union(e);
          }
          isSaved(e) {
            return this._savedObjects.has(e) && null == this.queuedObjectType(e);
          }
          ensureObjectSaved(e) {
            return new Promise((t, n) => {
              const r = this._getObjectId(e);
              this.isSaved(r) ? t(e) : this._ensureSavedRequests = this._ensureSavedRequests.withMutations(e => {
                const i = e.get(r);
                i ? e.set(r, i.push({
                  resolve: t,
                  reject: n
                })) : e.set(r, (0, o.aV)([{
                  resolve: t,
                  reject: n
                }]));
              });
            });
          }
          _resolveEnsureSavedRequests(e) {
            this._ensureSavedRequests = this._ensureSavedRequests.withMutations(t => {
              e.forEach(e => {
                const n = this._getObjectId(e),
                  r = t.get(n);
                r && this.isSaved(n) && (r.forEach(t => {
                  let {
                    resolve: n
                  } = t;
                  n(e);
                }), t.delete(n));
              });
            });
          }
          _rejectEnsureSavedRequests(e) {
            this._ensureSavedRequests = this._ensureSavedRequests.withMutations(t => {
              e.forEach(e => {
                const n = this._getObjectId(e.object),
                  r = t.get(n);
                r && (r.forEach(t => {
                  let {
                    reject: n
                  } = t;
                  n(e.error);
                }), t.delete(n));
              });
            });
          }
          _markModificationAsSaved(e) {
            const t = this._getObjectId(e.object);
            switch (e.type) {
              case "CREATED":
              case "UPDATED":
                this._savedObjects = this._savedObjects.add(t);
                break;
              case "DELETED":
                this._savedObjects = this._savedObjects.remove(t);
            }
          }
          _setModificationsAndNotifyChange(e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            this._modifications = e, t && this._notifySaveStateChange();
          }
          _notifySaveStateChange() {
            const e = this.hasUnsavedObjects();
            this._prevHasUnsavedObjects !== e && (this._prevHasUnsavedObjects = e, this.eventEmitter.emit("saveStateChange", e));
          }
        }
        function y(e) {
          (0, i.vU)(e);
        }
        var b = n(24382);
        class w {
          constructor(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : a.u.IMMEDIATE,
              n = arguments.length > 2 ? arguments[2] : void 0;
            (0, r.Z)(this, "eventEmitter", new d.Z(this._getSupportedEvents())), (0, r.Z)(this, "_createdObjects", (0, o.D5)()), (0, r.Z)(this, "_updatedObjects", (0, o.D5)()), (0, r.Z)(this, "_deletedObjects", (0, o.D5)()), (0, r.Z)(this, "_crudEventsLock", new f(() => {
              (this._createdObjects.size || this._updatedObjects.size || this._deletedObjects.size) && this.eventEmitter.emit("change"), this._createdObjects.size && (this.eventEmitter.emit("create", (0, o.aV)(this._createdObjects.values())), this._createdObjects = this._createdObjects.clear()), this._updatedObjects.size && (this.eventEmitter.emit("update", (0, o.aV)(this._updatedObjects.values())), this._updatedObjects = this._updatedObjects.clear()), this._deletedObjects.size && (this.eventEmitter.emit("delete", (0, o.aV)(this._deletedObjects.values())), this._deletedObjects = this._deletedObjects.clear());
            })), this._callbacks = e, this._autoSaveMode = t, null != n && (this.eventEmitter = n), this._saveModeQueue = new v({
              autoSaveMode: t,
              flushCreateObject: async e => {
                try {
                  await this._callbacks.createBackendObject(e.object, e.additionalFields);
                } catch (t) {
                  throw this._callbacks.deleteStoreObjects((0, o.l4)([e.id])), this.eventEmitter.emit("change"), this.eventEmitter.emit("delete", (0, o.aV)([e.object])), t;
                }
                this._callbacks.refresh();
              },
              flushUpdateObject: async e => {
                await this._callbacks.updateBackendObject(e.object, e.additionalFields), this._callbacks.refresh();
              },
              flushDeleteObject: async e => {
                try {
                  await this._callbacks.deleteBackendObject(e.object, e.additionalFields);
                } catch (t) {
                  throw this._callbacks.createStoreObjects((0, o.aV)([e.object])), this.eventEmitter.emit("change"), this.eventEmitter.emit("create", (0, o.aV)([e.object])), t;
                }
                this._callbacks.refresh();
              },
              validateObject: e => this._callbacks.validateObject(e.object),
              getObjectId: e => e.id,
              syncChanges: () => this._callbacks.syncChanges()
            }), this._saveModeQueue.eventEmitter.on("willSave", () => {
              this.eventEmitter.emit("change"), this.eventEmitter.emit("willSave");
            }), this._saveModeQueue.eventEmitter.on("didSave", () => {
              this.eventEmitter.emit("change"), this.eventEmitter.emit("didSave");
            }), this._saveModeQueue.eventEmitter.on("saveStateChange", e => this.eventEmitter.emit("saveStateChange", e));
          }
          autoSave() {
            this._saveModeQueue.autoSave();
          }
          manualSave() {
            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            return this._saveModeQueue.manualSave(e).catch(e => {
              throw (0, i.kG)(e instanceof m.V), e.reason && (e.reason = e.reason.map(e => ({
                error: e.error,
                modificationType: e.modificationType,
                object: e.object.object
              }))), e;
            });
          }
          ensureObjectSaved(e) {
            return this._saveModeQueue.ensureObjectSaved(this._createSaveQueueObject(this._callbacks.getObjectId(e), e)).then(e => e.object);
          }
          hasUnsavedChanges() {
            return this._saveModeQueue.hasUnsavedObjects();
          }
          lockSave() {
            const e = this._crudEventsLock.lock(),
              t = this._saveModeQueue.lockSave();
            return () => {
              t(), e();
            };
          }
          createObject(e, t) {
            const n = this.lockSave();
            try {
              const r = this._callbacks.getObjectId(e);
              (0, i.kG)(r);
              const o = this._saveModeQueue.queuedObjectType(r),
                a = this._saveModeQueue.isSaved(r) || o === l,
                u = o === s;
              a || u ? (this._callbacks.onUpdate && this._callbacks.onUpdate(e, t), this._saveModeQueue.updateObject(this._createSaveQueueObject(r, e, t)), this._updatedObjects = this._updatedObjects.set(r, e)) : (this._callbacks.onCreate && this._callbacks.onCreate(e, t), this._saveModeQueue.createObject(this._createSaveQueueObject(r, e, t)), this._createdObjects = this._createdObjects.set(r, e));
            } finally {
              n();
            }
          }
          createObjects(e, t) {
            const n = this.lockSave();
            try {
              e.forEach((e, n) => {
                const r = this._callbacks.getObjectId(e);
                (0, i.kG)(r);
                const o = this._saveModeQueue.queuedObjectType(r);
                this._saveModeQueue.isSaved(r) || o === l || o === s ? (this._callbacks.onUpdate && this._callbacks.onUpdate(e, t[n]), this._saveModeQueue.updateObject(this._createSaveQueueObject(r, e, t[n])), this._updatedObjects = this._updatedObjects.set(r, e)) : (this._callbacks.onCreate && this._callbacks.onCreate(e, t[n]), this._saveModeQueue.createObject(this._createSaveQueueObject(r, e, t[n])), this._createdObjects = this._createdObjects.set(r, e));
              });
            } finally {
              n();
            }
          }
          updateObject(e, t) {
            this.createObject(e, t);
          }
          deleteObject(e, t) {
            const n = this.lockSave();
            try {
              const r = this._callbacks.getObjectId(e);
              (0, i.kG)(r);
              const o = this._saveModeQueue.queuedObjectType(r),
                a = this._saveModeQueue.isSaved(r) || o === l,
                u = o === s;
              this._callbacks.onDelete && this._callbacks.onDelete(e, t), (a || u) && this._saveModeQueue.deleteObject(this._createSaveQueueObject(r, e, t)), this._deletedObjects = this._deletedObjects.set(r, e);
            } finally {
              n();
            }
          }
          backendObjectsCreated(e, t, n) {
            const r = t === b.y,
              o = e.map(e => this._callbacks.getObjectId(e)).toArray();
            this._saveModeQueue.markObjectsAsSaved(o), this._callbacks.createStoreObjects(e, n), this.eventEmitter.emit("change"), this.eventEmitter.emit(r ? "load" : "create", e), o.forEach(e => {
              this._saveModeQueue.clearQueueForObject(e);
            }), !r && this._callbacks.refresh();
          }
          backendObjectsUpdated(e, t) {
            this._callbacks.updateStoreObjects(e), t || (this.eventEmitter.emit("change"), this.eventEmitter.emit("update", e));
            e.map(e => this._callbacks.getObjectId(e)).toArray().forEach(e => {
              this._saveModeQueue.clearQueueForObject(e);
            }), this._callbacks.refresh();
          }
          backendObjectsDeleted(e) {
            const t = e.map(e => this._callbacks.getObjectById(e)).filter(Boolean).toList();
            this._callbacks.deleteStoreObjects(e), e.forEach(e => {
              this._saveModeQueue.clearQueueForObject(e);
            }), this.eventEmitter.emit("change"), this.eventEmitter.emit("delete", t), this._callbacks.refresh();
          }
          _getSupportedEvents() {
            return ["change", "willSave", "didSave", "load", "create", "update", "delete", "saveStateChange"];
          }
          _createSaveQueueObject(e, t, n) {
            return void 0 === n ? {
              id: e,
              object: t
            } : {
              id: e,
              object: t,
              additionalFields: n
            };
          }
        }
      },
      96723: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(94809),
          o = n(68944);
        class i {
          constructor(e, t) {
            this.identifier = this.url = e, this.token = t, this.aborted = !1;
          }
          request() {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              method: "GET"
            };
            const {
                method: t,
                data: n = null
              } = e,
              i = new XMLHttpRequest();
            return i.open(t, this.url, !0), i.setRequestHeader("X-PSPDFKit-Token", this.token), i.setRequestHeader("PSPDFKit-Platform", "web"), i.setRequestHeader("PSPDFKit-Version", (0, o.oM)()), new Promise((e, t) => {
              i.onreadystatechange = () => {
                this.aborted || 4 === i.readyState && ((0, r.vu)(i.status) ? e(JSON.parse(i.responseText)) : t({
                  message: i.responseText
                }));
              }, this.httpRequest = i, i.send(n instanceof FormData ? n : "object" == typeof n ? JSON.stringify(n) : void 0);
            });
          }
          abort() {
            this.httpRequest && (this.aborted = !0, this.httpRequest.abort(), this.httpRequest = null);
          }
        }
      },
      55696: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => c
        });
        var r = n(96156),
          o = n(15359),
          i = n(96029),
          a = n(98492),
          s = n(84610);
        function l(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function u(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class c {
          constructor(e) {
            this.annotation = e;
          }
          toJSON() {
            var e, t;
            return u(u(u({
              id: this.annotation.id,
              name: this.annotation.name,
              subject: this.annotation.subject,
              v: c.VERSION,
              pdfObjectId: this.annotation.pdfObjectId,
              pageIndex: this.annotation.pageIndex,
              bbox: (0, a.u)(this.annotation.boundingBox),
              opacity: this.annotation.opacity,
              flags: this.serializeFlags(),
              action: this.annotation.action && (0, i.vP)(this.annotation.action),
              note: this.annotation.note,
              createdAt: this.annotation.createdAt.toISOString(),
              updatedAt: this.annotation.updatedAt.toISOString(),
              creatorName: this.annotation.creatorName,
              customData: this.annotation.customData,
              isCommentThreadRoot: this.annotation.isCommentThreadRoot,
              isAnonymous: this.annotation.isAnonymous
            }, this.annotation.blendMode && "normal" !== this.annotation.blendMode ? {
              blendMode: this.annotation.blendMode
            } : null), null !== (e = this.annotation.APStreamCache) && void 0 !== e && e.cache || null !== (t = this.annotation.APStreamCache) && void 0 !== t && t.attach ? {
              APStreamCache: this.annotation.APStreamCache
            } : null), (0, s.Ut)(this.annotation));
          }
          static fromJSON(e, t, n) {
            (0, o.kG)(null == t.name || "string" == typeof t.name, "`name` must be of type `string`"), (0, o.kG)(t.v <= c.VERSION, "Version Unknown"), (0, o.kG)(void 0 !== e && "number" != typeof e, "`id` must be of type `string`"), (0, o.kG)("object" == typeof t.bbox, "Missing `bbox` field"), (0, o.kG)("number" == typeof t.opacity, "Missing `opacity` field"), (0, o.kG)("number" == typeof t.pageIndex, "Missing `pageIndex` field"), (0, o.kG)(null == t.customData || (0, o.PO)(t.customData), "`customData` must be an object"), (0, o.kG)("boolean" == typeof t.isCommentThreadRoot || void 0 === t.isCommentThreadRoot, "`isCommentThreadRoot` should be a `undefined` or `boolean`"), (0, o.kG)("boolean" == typeof t.isAnonymous || void 0 === t.isAnonymous, "`isAnonymous` should be a `undefined` or `boolean`"), (0, s.G)(n);
            const r = Array.isArray(t.flags) ? t.flags : [];
            let l;
            try {
              l = t.action && (0, i.lk)(t.action);
            } catch (e) {
              (0, o.ZK)(`PDF Action not supported:\n\n${t.action}`);
            }
            return u(u({
              id: e,
              name: t.name || null,
              subject: t.subject || null,
              pdfObjectId: t.pdfObjectId || null,
              pageIndex: t.pageIndex,
              opacity: t.opacity,
              boundingBox: (0, a.k)(t.bbox),
              noPrint: r.includes("noPrint"),
              noZoom: r.includes("noZoom"),
              noRotate: r.includes("noRotate"),
              noView: r.includes("noView"),
              hidden: r.includes("hidden"),
              locked: r.includes("locked"),
              lockedContents: r.includes("lockedContents"),
              readOnly: r.includes("readOnly"),
              action: l,
              note: t.note || null,
              createdAt: t.createdAt ? new Date(t.createdAt) : new Date(0),
              updatedAt: t.updatedAt ? new Date(t.updatedAt) : new Date(0),
              creatorName: t.creatorName || null,
              customData: t.customData || null,
              isCommentThreadRoot: !!t.isCommentThreadRoot,
              isAnonymous: !!t.isAnonymous
            }, c.blendModeObjectForAnnotation(t)), (0, s.a5)(n));
          }
          static blendModeObjectForAnnotation(e) {
            return e.blendMode ? {
              blendMode: e.blendMode
            } : "pspdfkit/markup/highlight" === e.type ? {
              blendMode: "normal"
            } : null;
          }
          serializeFlags() {
            const e = [];
            return ["noPrint", "noZoom", "noRotate", "noView", "hidden", "locked", "lockedContents", "readOnly"].forEach(t => {
              this.annotation[t] && e.push(t);
            }), e.length ? e : null;
          }
        }
        (0, r.Z)(c, "VERSION", 2);
      },
      40071: (e, t, n) => {
        "use strict";

        n.d(t, {
          M: () => d,
          Z: () => p
        });
        var r = n(96156),
          o = n(35369),
          i = n(55696),
          a = n(4715),
          s = n(98492),
          l = n(82716);
        function u(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function c(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? u(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const d = {
          "pspdfkit/markup/highlight": a.FV,
          "pspdfkit/markup/squiggly": a.hL,
          "pspdfkit/markup/strikeout": a.R9,
          "pspdfkit/markup/underline": a.xu,
          "pspdfkit/markup/redaction": a.Wk
        };
        class p extends i.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return c(c({}, super.toJSON()), {
              rects: this.annotation.rects.map(e => (0, s.u)(e)).toJS()
            });
          }
          static fromJSON(e, t, n) {
            return (0, l.k)("object" == typeof t.rects, "Missing `rects` field"), c(c({}, super.fromJSON(e, t, n)), {}, {
              rects: (0, o.aV)(t.rects).map(e => (0, s.k)(e))
            });
          }
        }
      },
      88133: (e, t, n) => {
        "use strict";

        n.d(t, {
          a: () => a,
          i: () => s
        });
        var r = n(15359),
          o = n(96029),
          i = n(99745);
        function a(e) {
          return {
            id: e.id,
            v: 1,
            pdfBookmarkId: e.pdfBookmarkId,
            type: "pspdfkit/bookmark",
            name: e.name,
            sortKey: e.sortKey,
            action: e.action && (0, o.vP)(e.action)
          };
        }
        function s(e, t) {
          let n;
          (0, r.kG)(null == e || "string" == typeof e, "`id` must be null or of type `string`"), (0, r.kG)(null == t.name || "string" == typeof t.name, "`name` must be of type `string`"), (0, r.kG)(null == t.sortKey || "number" == typeof t.sortKey, "`sortKey` must be of type `number`"), (0, r.kG)("object" == typeof t.action, "Missing `action` field");
          try {
            n = (0, o.lk)(t.action);
          } catch (e) {
            (0, r.ZK)(`PDF Action not supported:\n\n${t.action}`);
          }
          return new i.Z({
            id: e,
            pdfBookmarkId: t.pdfBookmarkId || null,
            name: t.name,
            sortKey: t.sortKey,
            action: n
          });
        }
      },
      92310: (e, t, n) => {
        "use strict";

        n.d(t, {
          o: () => u,
          z: () => c
        });
        var r = n(96156),
          o = n(15359),
          i = n(45249),
          a = n(84610);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function u(e, t) {
          return l({
            id: e.id,
            type: "pspdfkit/comment",
            v: 2,
            rootId: t,
            pageIndex: e.pageIndex,
            pdfObjectId: e.pdfObjectId,
            creatorName: e.creatorName,
            createdAt: e.createdAt,
            updatedAt: e.updatedAt,
            text: e.text,
            customData: e.customData,
            isAnonymous: e.isAnonymous
          }, (0, a.Ut)(e));
        }
        function c(e, t, n) {
          return (0, o.kG)(2 === t.v, "Unknown comment version"), (0, o.kG)("pspdfkit/comment" === t.type, "Invalid comment type"), (0, o.kG)("string" == typeof t.rootId || "number" == typeof t.rootId, "`rootId` must be of type `string` or `number`"), (0, o.kG)("number" == typeof t.pageIndex, "`pageIndex` must be of type `number`"), (0, o.kG)(null == t.pdfObjectId || "number" == typeof t.pdfObjectId, "`pdfObjectId` must be of type `number`"), (0, o.kG)(null == t.creatorName || "string" == typeof t.creatorName, "`creatorName` must be of type `string`"), (0, o.kG)("object" == typeof t.text, "`text` must be of type `object`"), (0, o.kG)("string" == typeof t.text.value, "`text.value` must be of type `string`"), (0, o.kG)("plain" === t.text.format || "xhtml" === t.text.format, "`text.format` must be `plain` or `xhtml`"), (0, o.kG)(null == t.customData || (0, o.PO)(t.customData), "`customData` must be a JSON-serializable object"), (0, o.kG)(void 0 === (null == n ? void 0 : n.isAnonymous) || "boolean" == typeof (null == n ? void 0 : n.isAnonymous) || null === (null == n ? void 0 : n.isAnonymous), "`isAnonymous` should be `undefined` or `boolean`."), (0, a.G)(n), new i.sv(l({
            id: e,
            rootId: t.rootId.toString(),
            pageIndex: t.pageIndex,
            pdfObjectId: t.pdfObjectId,
            creatorName: t.creatorName,
            createdAt: t.createdAt ? new Date(t.createdAt) : new Date(0),
            updatedAt: t.updatedAt ? new Date(t.updatedAt) : new Date(0),
            text: t.text,
            customData: t.customData,
            isAnonymous: null == n ? void 0 : n.isAnonymous
          }, (0, a.a5)(n)));
        }
      },
      26559: (e, t, n) => {
        "use strict";

        n.d(t, {
          T8: () => i,
          X$: () => r,
          hH: () => a,
          uE: () => o
        });
        const r = e => e.toJS(),
          o = e => e.toJS(),
          i = (e, t) => {
            return {
              maxWidth: e.maxWidth,
              alignment: e.alignment,
              lineSpacingFactor: e.lineSpacingFactor,
              modificationsCharacterStyle: (n = t, n.toJS())
            };
            var n;
          },
          a = e => i(e.layout, e.modificationsCharacterStyle);
      },
      69847: (e, t, n) => {
        "use strict";

        function r(e) {
          var t;
          return {
            type: e.type,
            options: {
              numberOfContextWords: null === (t = e.options) || void 0 === t ? void 0 : t.numberOfContextWords
            }
          };
        }
        function o(e) {
          return {
            filePath: e.filePath,
            password: e.password,
            pageIndexes: e.pageIndexes,
            jwt: e.jwt
          };
        }
        n.d(t, {
          c: () => o,
          j: () => r
        });
      },
      32751: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => d
        });
        var r = n(96156),
          o = n(15359),
          i = n(74751),
          a = n(94732),
          s = n(82197),
          l = n(40071);
        function u(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function c(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? u(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class d extends l.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return c(c({}, super.toJSON()), {}, {
              type: "pspdfkit/markup/redaction",
              fillColor: this.annotation.fillColor && (0, i.C)(this.annotation.fillColor),
              outlineColor: this.annotation.outlineColor && (0, i.C)(this.annotation.outlineColor),
              overlayText: this.annotation.overlayText,
              repeatOverlayText: this.annotation.repeatOverlayText,
              rotation: this.annotation.rotation,
              color: this.annotation.color && (0, i.C)(this.annotation.color)
            });
          }
          static fromJSON(e, t, n) {
            var r, l;
            (0, o.kG)("pspdfkit/markup/redaction" === t.type, "Wrong `type` field");
            const u = "number" == typeof t.rotation ? (0, s.Lv)(t.rotation) : 0;
            return new a.Z(c(c({}, super.fromJSON(e, t, n)), {}, {
              fillColor: t.fillColor ? (0, i.b)(t.fillColor) : a.Z.defaultValues.fillColor,
              outlineColor: t.outlineColor ? (0, i.b)(t.outlineColor) : a.Z.defaultValues.outlineColor,
              overlayText: null !== (r = t.overlayText) && void 0 !== r ? r : null,
              repeatOverlayText: null !== (l = t.repeatOverlayText) && void 0 !== l ? l : null,
              rotation: u,
              color: t.color ? (0, i.b)(t.color) : a.Z.defaultValues.color
            }));
          }
        }
      },
      10552: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => f,
          q: () => h
        });
        var r = n(96156),
          o = n(35369),
          i = n(74751),
          a = n(55696),
          s = n(85513),
          l = n(82716),
          u = n(58163),
          c = n(97281);
        function d(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function p(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? d(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const h = {
          1: "whole",
          .1: "oneDp",
          .01: "twoDp",
          .001: "threeDp",
          1e-4: "fourDp"
        };
        class f extends a.Z {
          toJSON() {
            return p(p({}, super.toJSON()), {
              strokeWidth: this.annotation.strokeWidth,
              strokeColor: this.annotation.strokeColor && (0, i.C)(this.annotation.strokeColor),
              fillColor: this.annotation.fillColor && (0, i.C)(this.annotation.fillColor),
              strokeDashArray: this.annotation.strokeDashArray,
              measurementPrecision: this.annotation.measurementPrecision,
              measurementScale: this.annotation.measurementScale && (e = this.annotation.measurementScale, {
                unitFrom: e.unitFrom,
                unitTo: e.unitTo,
                from: e.fromValue,
                to: e.toValue
              })
            });
            var e;
          }
          static fromJSON(e, t, n) {
            var r;
            ((0, l.k)("number" == typeof t.strokeWidth || "number" == typeof t.lineWidth, "Missing `strokeWidth` or deprecated `lineWidth` field"), t.measurementPrecision) && t.measurementPrecision && Object.keys(h).includes(t.measurementPrecision) && (t.measurementPrecision = null !== (r = h[t.measurementPrecision]) && void 0 !== r ? r : c.L.TWO);
            return p(p({}, super.fromJSON(e, t, n)), {
              strokeWidth: null != t.strokeWidth ? t.strokeWidth : null != t.lineWidth ? t.lineWidth : null,
              strokeColor: null != t.strokeColor ? (0, i.b)(t.strokeColor) : null,
              fillColor: t.fillColor ? (0, i.b)(t.fillColor) : null,
              strokeDashArray: t.strokeDashArray,
              measurementPrecision: t.measurementPrecision,
              measurementScale: t.measurementScale ? m(t.measurementScale) : null
            });
          }
          _pointsToJSON() {
            return this.annotation.points.map(e => (0, s.K)(e)).toJS();
          }
          static _JSONToPoints(e) {
            return (0, o.aV)(e.map(e => (0, s.W)(e)));
          }
          static _JSONLinesToPoints(e) {
            return (0, o.aV)(e.points[0].map(s.W));
          }
        }
        function m(e) {
          return new u.Z({
            unitFrom: e.unitFrom,
            unitTo: e.unitTo,
            fromValue: e.from,
            toValue: e.to
          });
        }
      },
      72251: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => f
        });
        var r = n(96156),
          o = n(15359),
          i = n(3888),
          a = n(74751),
          s = n(45249),
          l = n(55696),
          u = n(96029),
          c = n(11765),
          d = n(82197);
        function p(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function h(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class f extends l.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return h(h({}, super.toJSON()), {
              type: "pspdfkit/widget",
              formFieldName: this.annotation.formFieldName,
              borderColor: this.annotation.borderColor && (0, a.C)(this.annotation.borderColor),
              borderStyle: this.annotation.borderStyle,
              borderDashArray: this.annotation.borderDashArray,
              borderWidth: this.annotation.borderWidth,
              font: this.annotation.font,
              fontSize: this.annotation.fontSize,
              fontColor: this.annotation.fontColor && (0, a.C)(this.annotation.fontColor),
              backgroundColor: this.annotation.backgroundColor && (0, a.C)(this.annotation.backgroundColor),
              horizontalAlign: this.annotation.horizontalAlign,
              verticalAlign: this.annotation.verticalAlign,
              fontStyle: (0, c.XH)(this.annotation),
              rotation: this.annotation.rotation,
              additionalActions: this.annotation.additionalActions && (0, u.GI)(this.annotation.additionalActions),
              lineHeightFactor: this.annotation.lineHeightFactor
            });
          }
          static fromJSON(e, t, n) {
            return (0, o.kG)("pspdfkit/widget" === t.type, "Wrong `type` field"), (0, o.kG)("string" == typeof t.formFieldName, "Wrong `formFieldName` field"), t.borderStyle && ((0, o.kG)("string" == typeof i.N[t.borderStyle], "Invalid value for `borderStyle`"), (0, o.kG)("number" == typeof t.borderWidth, "Missing `borderWidth` field")), t.horizontalAlign && (0, o.kG)(["left", "center", "right"].includes(t.horizontalAlign), "Wrong `horizontalAlign` field"), t.verticalAlign && (0, o.kG)(["top", "center", "bottom"].includes(t.verticalAlign), "Wrong `verticalAlign` field"), new s.x_(h(h({}, super.fromJSON(e, t, n)), {
              formFieldName: t.formFieldName,
              borderColor: t.borderColor ? (0, a.b)(t.borderColor) : null,
              borderStyle: t.borderStyle && i.N[t.borderStyle],
              borderDashArray: t.borderDashArray,
              borderWidth: t.borderWidth,
              fontColor: t.fontColor ? (0, a.b)(t.fontColor) : null,
              fontSize: t.fontSize,
              font: t.font || null,
              backgroundColor: t.backgroundColor ? (0, a.b)(t.backgroundColor) : null,
              horizontalAlign: t.horizontalAlign ? t.horizontalAlign : null,
              verticalAlign: t.verticalAlign ? t.verticalAlign : null,
              isBold: t.fontStyle && t.fontStyle.includes("bold"),
              isItalic: t.fontStyle && t.fontStyle.includes("italic"),
              rotation: "number" == typeof t.rotation ? (0, d.n5)(t.rotation) : 0,
              additionalActions: t.additionalActions ? (0, u.eb)(t.additionalActions) : null,
              lineHeightFactor: t.lineHeightFactor
            }));
          }
        }
      },
      96029: (e, t, n) => {
        "use strict";

        n.d(t, {
          GI: () => h,
          eb: () => p,
          lk: () => c,
          vP: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(96706);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function u(e) {
          return function e(t) {
            const n = l({}, t.subActions && {
              subactions: t.subActions.map(t => e(t)).toArray()
            });
            if (t instanceof a.lm) return l({
              type: "uri",
              uri: t.uri
            }, n);
            if (t instanceof a.Di) return l({
              type: "goTo",
              pageIndex: t.pageIndex
            }, n);
            if (t instanceof a.Qr) return l({
              type: "goToEmbedded",
              newWindow: t.newWindow,
              relativePath: t.relativePath,
              targetType: t.targetType
            }, n);
            if (t instanceof a._6) return l({
              type: "goToRemote",
              relativePath: t.relativePath,
              namedDestination: t.namedDestination
            }, n);
            if (t instanceof a.ZD) return l({
              type: "hide",
              hide: t.hide,
              annotationReferences: t.annotationReferences.toJS()
            }, n);
            if (t instanceof a.bp) return l({
              type: "javaScript",
              script: t.script
            }, n);
            if (t instanceof a.b) return l({
              type: "launch",
              filePath: t.filePath
            }, n);
            if (t instanceof a.oH) return l({
              type: "named",
              action: t.action
            }, n);
            if (t instanceof a.BO) return l({
              type: "resetForm",
              fields: t.fields ? t.fields.toArray() : null,
              flags: t.includeExclude ? "includeExclude" : null
            }, n);
            if (t instanceof a.pl) return l({
              type: "submitForm",
              uri: t.uri,
              fields: t.fields ? t.fields.toArray() : null,
              flags: d(t)
            }, n);
            throw new Error(`Unknown action type: ${t.constructor.name}`);
          }(e);
        }
        function c(e) {
          return function e(t) {
            let n = null;
            switch (t.subactions && (n = {
              subActions: (0, o.aV)(t.subactions.map(t => e(t)))
            }), t.type) {
              case "uri":
                return (0, i.kG)("string" == typeof t.uri, "URI action must have a `uri`"), new a.lm(l({
                  uri: t.uri
                }, n));
              case "goTo":
                return (0, i.kG)("number" == typeof t.pageIndex, "Goto action must have a `pageIndex`"), new a.Di(l({
                  pageIndex: t.pageIndex
                }, n));
              case "goToEmbedded":
                return (0, i.kG)("boolean" == typeof t.newWindow, "GoToEmbeddedAction must have `newWindow`"), (0, i.kG)("parent" === t.targetType || "child" === t.targetType, "GoToEmbeddedAction must have a valid `targetType`"), new a.Qr(l({
                  newWindow: t.newWindow,
                  relativePath: t.relativePath || "",
                  targetType: t.targetType || ""
                }, n));
              case "goToRemote":
                return new a._6(l({
                  relativePath: t.relativePath || "",
                  namedDestination: t.namedDestination || ""
                }, n));
              case "hide":
                return (0, i.kG)(Array.isArray(t.annotationReferences), "HideAction must have `annotationReferences`"), new a.ZD(l({
                  hide: !!t.hide,
                  annotationReferences: (0, o.aV)(t.annotationReferences)
                }, n));
              case "javaScript":
                return new a.bp(l({
                  script: t.script || ""
                }, n));
              case "launch":
                return new a.b(l({
                  filePath: t.filePath || ""
                }, n));
              case "named":
                return new a.oH(l({
                  action: t.action || ""
                }, n));
              case "resetForm":
                {
                  (0, i.kG)(t.fields instanceof Array || void 0 === t.fields, "The value of the `fields` field of ResetForm Action has to be an array or undefined"), (0, i.kG)("string" == typeof t.flags || void 0 === t.flags, "The value of the `flags` field of ResetForm Action has to be a string or undefined");
                  const e = "includeExclude" === t.flags;
                  return new a.BO(l({
                    fields: t.fields ? (0, o.aV)(t.fields) : void 0,
                    includeExclude: e
                  }, n));
                }
              case "submitForm":
                return (0, i.kG)("string" == typeof t.uri, "The value of the `uri` field of SubmitForm Action has to be a string"), (0, i.kG)(t.fields instanceof Array || void 0 === t.fields, "The value of the `fields` field of SubmitForm Action has to be an array or undefined"), (0, i.kG)(t.flags instanceof Array || void 0 === t.flags, "The value of the `flags` field of SubmitForm Action has to be a array or undefined"), t.flags || (t.flags = []), new a.pl(l({
                  fields: t.fields ? (0, o.aV)(t.fields) : void 0,
                  uri: t.uri,
                  includeExclude: t.flags.includes("includeExclude"),
                  includeNoValueFields: t.flags.includes("includeNoValueFields"),
                  exportFormat: t.flags.includes("exportFormat"),
                  getMethod: t.flags.includes("getMethod"),
                  submitCoordinated: t.flags.includes("submitCoordinated"),
                  xfdf: t.flags.includes("xfdf"),
                  includeAppendSaves: t.flags.includes("includeAppendSaves"),
                  includeAnnotations: t.flags.includes("includeAnnotations"),
                  submitPDF: t.flags.includes("submitPDF"),
                  canonicalFormat: t.flags.includes("canonicalFormat"),
                  excludeNonUserAnnotations: t.flags.includes("excludeNonUserAnnotations"),
                  excludeFKey: t.flags.includes("excludeFKey"),
                  embedForm: t.flags.includes("embedForm")
                }, n));
              default:
                throw new Error(`Unknown action: ${t}`);
            }
          }(e);
        }
        function d(e) {
          const t = [];
          return ["includeExclude", "includeNoValueFields", "exportFormat", "getMethod", "submitCoordinated", "xfdf", "includeAppendSaves", "includeAnnotations", "submitPDF", "canonicalFormat", "excludeNonUserAnnotations", "excludeFKey", "embedForm"].forEach(n => {
            e[n] && t.push(n);
          }), t.length ? t : null;
        }
        function p(e) {
          return Object.keys(e).reduce((t, n) => {
            const r = e[n];
            return r && (t[n] = c(r)), t;
          }, {});
        }
        function h(e) {
          return Object.keys(e).reduce((t, n) => {
            const r = e[n];
            return r instanceof a.aU && (t[n] = u(r)), t;
          }, {});
        }
      },
      84610: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => s,
          Ut: () => u,
          a5: () => l
        });
        var r = n(96156),
          o = n(15359);
        function i(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function a(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function s() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          const {
            group: t,
            permissions: n
          } = e;
          (0, o.kG)(void 0 === t || "string" == typeof t || null === t, "`group` should be `undefined` or `string`."), (0, o.kG)(void 0 === n || (0, o.PO)(n), "`permissions` should be `undefined` or an `object`."), (0, o.PO)(n) && ((0, o.kG)("boolean" == typeof n.edit, "`permissions.edit` should be `boolean`."), (0, o.kG)("boolean" == typeof n.delete, "`permissions.delete` should be `boolean`."), (0, o.kG)("boolean" == typeof n.setGroup, "`permissions.setGroup` should be `boolean`."), void 0 !== n.fill && (0, o.kG)("boolean" == typeof n.fill, "`permissions.fill` should be `boolean`."), void 0 !== n.reply && (0, o.kG)("boolean" == typeof n.reply, "`permissions.reply` should be `boolean`."));
        }
        function l() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          const {
            group: t,
            permissions: n
          } = e;
          let r = {
            group: t
          };
          return (0, o.PO)(n) && (r = a(a({}, r), {}, {
            canSetGroup: n.setGroup,
            isEditable: n.edit,
            isDeletable: n.delete
          }), "boolean" == typeof n.fill && (r.isFillable = n.fill), "boolean" == typeof n.reply && (r.canReply = n.reply)), r;
        }
        function u(e) {
          const t = "boolean" == typeof e.isEditable && "boolean" == typeof e.canSetGroup && "boolean" == typeof e.isDeletable;
          let n = {
            group: e.group
          };
          return t && ((0, o.kG)("boolean" == typeof e.isEditable), (0, o.kG)("boolean" == typeof e.isDeletable), (0, o.kG)("boolean" == typeof e.canSetGroup), n = a(a({}, n), {}, {
            permissions: {
              edit: e.isEditable,
              delete: e.isDeletable,
              setGroup: e.canSetGroup
            }
          }), "boolean" == typeof e.isFillable && (n.permissions = a(a({}, n.permissions), {}, {
            fill: e.isFillable
          })), "boolean" == typeof e.canReply && (n.permissions = a(a({}, n.permissions), {}, {
            reply: e.canReply
          }))), n;
        }
      },
      74751: (e, t, n) => {
        "use strict";

        n.d(t, {
          C: () => i,
          b: () => a
        });
        var r = n(15359),
          o = n(45249);
        function i(e) {
          return e.toHex();
        }
        function a(e) {
          if ((0, r.kG)(7 === e.length || 9 === e.length, "Tried to deserialize color that does not have 7 or 9 characters"), "#00000000" === e) return o.Il.TRANSPARENT;
          const t = parseInt(e.substring(1, 3), 16),
            n = parseInt(e.substring(3, 5), 16),
            i = parseInt(e.substring(5, 7), 16);
          return new o.Il({
            r: t,
            g: n,
            b: i
          });
        }
      },
      17310: (e, t, n) => {
        "use strict";

        n.d(t, {
          B: () => i,
          r: () => a
        });
        var r = n(15359),
          o = n(45249);
        function i(e) {
          return [e.left, e.top, e.right, e.bottom];
        }
        function a(e) {
          return (0, r.kG)(4 === e.length, "Tried to deserialize inset that does not have 4 entries"), new o.eB({
            left: e[0],
            top: e[1],
            right: e[2],
            bottom: e[3]
          });
        }
      },
      85513: (e, t, n) => {
        "use strict";

        n.d(t, {
          K: () => i,
          W: () => a
        });
        var r = n(15359),
          o = n(45249);
        function i(e) {
          return [e.x, e.y];
        }
        function a(e) {
          return (0, r.kG)(2 === e.length, "Tried to deserialize point that does not have 2 entries"), new o.E9({
            x: e[0],
            y: e[1]
          });
        }
      },
      98492: (e, t, n) => {
        "use strict";

        n.d(t, {
          k: () => a,
          u: () => i
        });
        var r = n(15359),
          o = n(45249);
        function i(e) {
          return [e.left, e.top, e.width, e.height];
        }
        function a(e) {
          return (0, r.kG)(4 === e.length, "Tried to deserialize rect that does not have 4 entries"), new o.UL({
            left: e[0],
            top: e[1],
            width: e[2],
            height: e[3]
          });
        }
      },
      11765: (e, t, n) => {
        "use strict";

        n.d(t, {
          Lw: () => We,
          vH: () => Ie,
          Mu: () => Re,
          IN: () => Fe,
          u9: () => Ne,
          Vl: () => st,
          rS: () => Le,
          XH: () => rt,
          l9: () => Je,
          Fd: () => et,
          _o: () => nt,
          _Q: () => $e,
          Qp: () => Ge,
          $T: () => tt,
          Hs: () => Oe,
          jA: () => je,
          kg: () => ot,
          vD: () => Me,
          kr: () => Be,
          xT: () => Xe,
          sr: () => Ue,
          _D: () => Ke,
          eE: () => qe,
          _L: () => Ze,
          YA: () => at,
          MR: () => Qe
        });
        var r = n(17375),
          o = n(96156),
          i = n(15359),
          a = n(35369),
          s = n(45249),
          l = n(94732),
          u = n(96726),
          c = n(74751),
          d = n(85513),
          p = n(55696);
        function h(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function f(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? h(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class m extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return f(f({}, super.toJSON()), {
              type: "pspdfkit/ink",
              lines: this._linesToJSON(),
              lineWidth: this.annotation.lineWidth,
              strokeColor: this.annotation.strokeColor && (0, c.C)(this.annotation.strokeColor),
              backgroundColor: this.annotation.backgroundColor && (0, c.C)(this.annotation.backgroundColor),
              isDrawnNaturally: this.annotation.isDrawnNaturally,
              isSignature: this.annotation.isSignature
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/ink" === t.type, "Wrong `type` field"), (0, i.kG)("object" == typeof t.lines, "Missing `lines` field"), (0, i.kG)("number" == typeof t.lineWidth, "Missing `lineWidth` field"), (0, i.kG)("boolean" == typeof t.isDrawnNaturally, "Missing `isDrawnNaturally` field"), new s.Zc(f(f({}, super.fromJSON(e, t, n)), {
              lines: this._JSONToLines(t.lines),
              lineWidth: t.lineWidth,
              strokeColor: t.strokeColor ? (0, c.b)(t.strokeColor) : null,
              backgroundColor: t.backgroundColor ? (0, c.b)(t.backgroundColor) : null,
              isDrawnNaturally: t.isDrawnNaturally,
              isSignature: t.isSignature
            }));
          }
          _linesToJSON() {
            return {
              points: this.annotation.lines.map(e => e.map(e => (0, d.K)(e))).toJS(),
              intensities: this.annotation.lines.map(e => e.map(e => e.intensity)).toJS()
            };
          }
          static _JSONToLines(e) {
            return (0, a.aV)(e.points).map((t, n) => {
              const r = e.intensities[n];
              return (0, a.aV)(t).map((e, t) => {
                const n = r[t],
                  o = (0, d.W)(e);
                return new s.Wm({
                  x: o.x,
                  y: o.y,
                  intensity: n
                });
              });
            });
          }
        }
        var g = n(10552),
          v = n(82716);
        function y(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function b(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? y(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class w extends g.Z {
          toJSON() {
            return b(b({}, super.toJSON()), {
              type: "pspdfkit/shape/line",
              startPoint: (0, d.K)(this.annotation.startPoint),
              endPoint: (0, d.K)(this.annotation.endPoint),
              lineCaps: this.annotation.lineCaps
            });
          }
          static fromJSON(e, t, n) {
            var r, o, i, a;
            return (0, v.k)("pspdfkit/shape/line" === t.type, "Wrong `type` field"), (0, v.k)("object" == typeof t.startPoint || "object" == typeof (null === (r = t.lines) || void 0 === r ? void 0 : r.points[0][0]), "Missing `startPoint` or deprecated `lines.points[0][0]` field"), (0, v.k)("object" == typeof t.endPoint || "object" == typeof (null === (o = t.lines) || void 0 === o ? void 0 : o.points[0][1]), "Missing `endPoint` or deprecated `lines.points[0][1]` field"), new s.o9(b(b({}, super.fromJSON(e, t, n)), {
              startPoint: (0, d.W)(t.startPoint || (null === (i = t.lines) || void 0 === i ? void 0 : i.points[0][0])),
              endPoint: (0, d.W)(t.endPoint || (null === (a = t.lines) || void 0 === a ? void 0 : a.points[0][1])),
              lineCaps: t.lineCaps
            }));
          }
        }
        var x = n(17310),
          D = n(98492);
        function C(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function S(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? C(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : C(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class E extends g.Z {
          toJSON() {
            return S(S({}, super.toJSON()), {
              type: "pspdfkit/shape/rectangle",
              cloudyBorderIntensity: this.annotation.cloudyBorderIntensity,
              cloudyBorderInset: this.annotation.cloudyBorderInset ? (0, x.B)(this.annotation.cloudyBorderInset) : null,
              measurementBBox: this.annotation.measurementBBox ? (0, D.u)(this.annotation.measurementBBox) : null
            });
          }
          static fromJSON(e, t, n) {
            return (0, v.k)("pspdfkit/shape/rectangle" === t.type, "Wrong `type` field"), new s.b3(S(S({}, super.fromJSON(e, t, n)), {
              cloudyBorderIntensity: t.cloudyBorderIntensity,
              cloudyBorderInset: Array.isArray(t.cloudyBorderInset) ? (0, x.r)(t.cloudyBorderInset) : null,
              measurementBBox: t.measurementBBox ? (0, D.k)(t.measurementBBox) : null
            }));
          }
        }
        function _(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function P(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? _(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class k extends g.Z {
          toJSON() {
            return P(P({}, super.toJSON()), {
              type: "pspdfkit/shape/ellipse",
              cloudyBorderIntensity: this.annotation.cloudyBorderIntensity,
              cloudyBorderInset: this.annotation.cloudyBorderInset ? (0, x.B)(this.annotation.cloudyBorderInset) : null,
              measurementBBox: this.annotation.measurementBBox ? (0, D.u)(this.annotation.measurementBBox) : null
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/shape/ellipse" === t.type, "Wrong `type` field"), new s.Xs(P(P({}, super.fromJSON(e, t, n)), {
              cloudyBorderIntensity: t.cloudyBorderIntensity,
              cloudyBorderInset: Array.isArray(t.cloudyBorderInset) ? (0, x.r)(t.cloudyBorderInset) : null,
              measurementBBox: t.measurementBBox ? (0, D.k)(t.measurementBBox) : null
            }));
          }
        }
        function A(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function z(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? A(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : A(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class T extends g.Z {
          toJSON() {
            return z(z({}, super.toJSON()), {
              type: "pspdfkit/shape/polygon",
              points: this._pointsToJSON(),
              cloudyBorderIntensity: this.annotation.cloudyBorderIntensity
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/shape/polygon" === t.type, "Wrong `type` field"), new s.Hi(z(z({}, super.fromJSON(e, t, n)), {
              points: t.points ? this._JSONToPoints(t.points) : this._JSONLinesToPoints(t.lines),
              cloudyBorderIntensity: t.cloudyBorderIntensity
            }));
          }
        }
        function O(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function I(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? O(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : O(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class F extends g.Z {
          toJSON() {
            return I(I({}, super.toJSON()), {
              type: "pspdfkit/shape/polyline",
              points: this._pointsToJSON(),
              lineCaps: this.annotation.lineCaps
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/shape/polyline" === t.type, "Wrong `type` field"), new s.om(I(I({}, super.fromJSON(e, t, n)), {
              points: t.points ? this._JSONToPoints(t.points) : this._JSONLinesToPoints(t.lines),
              lineCaps: t.lineCaps
            }));
          }
        }
        function M(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function R(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? M(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class j extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return R(R({}, super.toJSON()), {
              type: "pspdfkit/link",
              borderColor: this.annotation.borderColor ? (0, c.C)(this.annotation.borderColor) : null,
              borderWidth: this.annotation.borderWidth,
              borderStyle: this.annotation.borderStyle
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/link" === t.type, "Wrong `type` field"), (0, i.kG)("object" == typeof t.action, "Missing `action` field"), new s.R1(R(R({}, super.fromJSON(e, t, n)), {}, {
              borderColor: t.borderColor ? (0, c.b)(t.borderColor) : null,
              borderWidth: t.borderWidth,
              borderStyle: t.borderStyle
            }));
          }
        }
        var B = n(59062);
        function N(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function L(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? N(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : N(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class V extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return (0, v.k)("object" == typeof this.annotation.text, "`text` must be an object"), (0, v.k)("plain" === this.annotation.text.format || "xhtml" === this.annotation.text.format, "Invalid `text.format` field"), (0, v.k)("string" == typeof this.annotation.text.value, "Missing `text.value` field"), "xhtml" === this.annotation.text.format && (0, i.ZK)("NoteAnnotationSerializer: `text.format` is set to `xhtml`, but this is not supported by PSPDFKit for Web. Falling back to `plain`."), L(L({}, super.toJSON()), {
              type: "pspdfkit/note",
              text: this.annotation.text,
              icon: B.Y4[this.annotation.icon] || this.annotation.icon,
              color: (0, c.C)(this.annotation.color)
            });
          }
          static fromJSON(e, t, n) {
            (0, v.k)("pspdfkit/note" === t.type, "Wrong `type` field");
            const r = {};
            if ("string" == typeof t.icon) {
              const e = B.V9[t.icon];
              r.icon = e || t.icon;
            }
            var o;
            ("string" == typeof t.color && (r.color = (0, c.b)(t.color)), "object" == typeof t.text) && (r.text = t.text, "xhtml" === (null === (o = t.text) || void 0 === o ? void 0 : o.format) && ((0, i.ZK)("NoteAnnotationSerializer: `text.format` is set to `xhtml`, but this is not supported by PSPDFKit for Web. Falling back to `plain`."), r.text.format = "plain"));
            return new s.Qi(L(L({}, super.fromJSON(e, t, n)), r));
          }
        }
        var K = n(3888),
          q = n(42370),
          H = n(82197);
        function U(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Z(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? U(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : U(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class $ extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return Z(Z({}, super.toJSON()), {
              type: "pspdfkit/text",
              text: this.annotation.text,
              fontColor: this.annotation.fontColor && (0, c.C)(this.annotation.fontColor),
              backgroundColor: this.annotation.backgroundColor && (0, c.C)(this.annotation.backgroundColor),
              font: this.annotation.font,
              borderColor: this.annotation.borderColor && (0, c.C)(this.annotation.borderColor),
              rotation: "number" == typeof this.annotation.rotation ? (0, H.Lv)(this.annotation.rotation) : this.annotation.rotation,
              fontSize: this.annotation.fontSize,
              fontStyle: rt(this.annotation) || [],
              horizontalAlign: this.annotation.horizontalAlign,
              verticalAlign: this.annotation.verticalAlign,
              callout: this._calloutToJSON(),
              borderStyle: this.annotation.borderStyle,
              borderWidth: this.annotation.borderWidth,
              isFitting: this.annotation.isFitting,
              lineHeightFactor: this.annotation.lineHeightFactor
            });
          }
          static fromJSON(e, t, n) {
            (0, i.kG)("pspdfkit/text" === t.type, "Wrong `type` field"), (0, i.kG)("object" == typeof t.text, "Missing `text` field"), (0, i.kG)("string" == typeof t.text.format, "Missing `text.format` field"), (0, i.kG)("string" == typeof t.text.value, "Missing `text.value` field"), (0, i.kG)("string" == typeof t.font, "Missing `font` field"), t.borderStyle && ((0, i.kG)("string" == typeof K.N[t.borderStyle], "Invalid value for `borderStyle`"), (0, i.kG)("number" == typeof t.borderWidth, "Missing `borderWidth` field"));
            const r = t.fontStyle instanceof Array ? t.fontStyle : [],
              o = "number" == typeof t.rotation ? (0, H.Lv)(t.rotation) : 0;
            return new s.gd(Z(Z({}, super.fromJSON(e, t, n)), {
              text: t.text,
              fontColor: t.fontColor ? (0, c.b)(t.fontColor) : null,
              backgroundColor: t.backgroundColor ? (0, c.b)(t.backgroundColor) : null,
              font: t.font,
              rotation: o,
              fontSize: null != t.fontSize ? t.fontSize : s.gd.defaultValues.fontSize,
              isBold: r.includes("bold"),
              isItalic: r.includes("italic"),
              horizontalAlign: t.horizontalAlign || "left",
              verticalAlign: t.verticalAlign || "top",
              callout: this._JSONToCallout(t.callout),
              borderStyle: t.borderStyle && K.N[t.borderStyle],
              borderWidth: t.borderWidth,
              borderColor: t.borderColor ? (0, c.b)(t.borderColor) : null,
              isFitting: !!t.isFitting || null == t.fontSize,
              lineHeightFactor: t.lineHeightFactor
            }));
          }
          _calloutToJSON() {
            const {
              callout: e
            } = this.annotation;
            return e ? ((0, i.kG)(e.start instanceof s.E9), (0, i.kG)(e.end instanceof s.E9), (0, i.kG)(!e.innerRectInset || e.innerRectInset instanceof s.eB), {
              start: (0, d.K)(e.start),
              knee: e.knee && (0, d.K)(e.knee),
              end: (0, d.K)(e.end),
              cap: e.cap,
              innerRectInset: e.innerRectInset && (0, x.B)(e.innerRectInset)
            }) : null;
          }
          static _JSONToCallout(e) {
            return e ? ((0, i.kG)("object" == typeof e.start, "Missing `callout.start` field"), (0, i.kG)("object" == typeof e.end, "Missing `callout.end` field"), (0, i.kG)(!e.cap || "string" == typeof q.u[e.cap], "Invalid value for `callout.cap`"), new s.UW({
              start: (0, d.W)(e.start),
              knee: e.knee && (0, d.W)(e.knee),
              end: (0, d.W)(e.end),
              cap: e.cap && q.u[e.cap],
              innerRectInset: e.innerRectInset && (0, x.r)(e.innerRectInset)
            })) : null;
          }
        }
        var G = n(40071);
        function W(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Y(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? W(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class X extends G.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return Y(Y({}, super.toJSON()), {}, {
              type: this.typeForAnnotation(),
              color: (0, c.C)(this.annotation.color)
            });
          }
          static fromJSON(e, t, n) {
            (0, i.kG)(t.type.startsWith("pspdfkit/markup/"), "Wrong `type` field"), (0, i.kG)("string" == typeof t.color, "Missing `color` field");
            return new (0, G.M[t.type])(Y(Y({}, super.fromJSON(e, t, n)), {}, {
              color: (0, c.b)(t.color)
            }));
          }
          typeForAnnotation() {
            const e = this.annotation.constructor;
            for (const t of Object.keys(G.M)) if (e === G.M[t]) return t;
            throw new Error("Unknown text markup annotation");
          }
        }
        function Q(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function J(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Q(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Q(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class ee extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return J(J({}, super.toJSON()), {}, {
              type: "pspdfkit/unknown"
            });
          }
          static fromJSON(e, t, n) {
            return new s.Ih(super.fromJSON(e, t, n));
          }
        }
        function te(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ne(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? te(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : te(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class re extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return ne(ne({}, super.toJSON()), ne(ne({
              type: "pspdfkit/image",
              description: this.annotation.description,
              fileName: this.annotation.fileName,
              contentType: this.annotation.contentType,
              imageAttachmentId: this.annotation.imageAttachmentId,
              rotation: this.annotation.rotation,
              isSignature: this.annotation.isSignature
            }, this.annotation.xfdfAppearanceStream ? {
              xfdfAppearanceStream: this.annotation.xfdfAppearanceStream
            } : null), this.annotation.xfdfAppearanceStreamOriginalPageRotation ? {
              xfdfAppearanceStreamOriginalPageRotation: this.annotation.xfdfAppearanceStreamOriginalPageRotation
            } : null));
          }
          static fromJSON(e, t, n) {
            (0, i.kG)("pspdfkit/image" === t.type, "Wrong `type` field");
            const r = {};
            return "string" == typeof t.description && (r.description = t.description), "string" == typeof t.fileName && (r.fileName = t.fileName), "string" == typeof t.contentType && (r.contentType = t.contentType), "string" == typeof t.imageAttachmentId && (r.imageAttachmentId = t.imageAttachmentId), "boolean" == typeof t.isSignature && (r.isSignature = t.isSignature), "string" == typeof t.xfdfAppearanceStream && (r.xfdfAppearanceStream = t.xfdfAppearanceStream), "number" == typeof t.xfdfAppearanceStreamOriginalPageRotation && (r.xfdfAppearanceStreamOriginalPageRotation = t.xfdfAppearanceStreamOriginalPageRotation), r.rotation = "number" == typeof t.rotation ? (0, H.Lv)(t.rotation) : 0, new s.sK(ne(ne({}, super.fromJSON(e, t, n)), r));
          }
        }
        var oe = n(29977);
        function ie(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ae(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ie(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ie(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class se extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return ae(ae({}, super.toJSON()), ae(ae({
              type: "pspdfkit/stamp",
              stampType: this.annotation.stampType,
              title: this.annotation.title,
              color: this.annotation.color && (0, c.C)(this.annotation.color),
              subtitle: this.annotation.subtitle,
              rotation: "number" == typeof this.annotation.rotation ? (0, H.Lv)(this.annotation.rotation) : this.annotation.rotation
            }, this.annotation.xfdfAppearanceStream ? {
              xfdfAppearanceStream: this.annotation.xfdfAppearanceStream
            } : null), this.annotation.xfdfAppearanceStreamOriginalPageRotation ? {
              xfdfAppearanceStreamOriginalPageRotation: this.annotation.xfdfAppearanceStreamOriginalPageRotation
            } : null));
          }
          static fromJSON(e, t, n) {
            (0, i.kG)("pspdfkit/stamp" === t.type, "Wrong `type` field");
            const r = {};
            return oe.pY[t.kind || t.stampType] && (r.stampType = t.stampType || t.kind), "string" == typeof t.title && (r.title = t.title), "string" != typeof t.subTitle && "string" != typeof t.subtitle || (r.subtitle = t.subtitle || t.subTitle), "string" == typeof t.color && (r.color = (0, c.b)(t.color)), "string" == typeof t.xfdfAppearanceStream && (r.xfdfAppearanceStream = t.xfdfAppearanceStream), "number" == typeof t.xfdfAppearanceStreamOriginalPageRotation && (r.xfdfAppearanceStreamOriginalPageRotation = t.xfdfAppearanceStreamOriginalPageRotation), r.rotation = "number" == typeof t.rotation ? (0, H.Lv)(t.rotation) : 0, new s.GI(ae(ae({}, super.fromJSON(e, t, n)), r));
          }
        }
        var le = n(72251);
        function ue(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ce(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ue(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ue(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class de extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return ce(ce({}, super.toJSON()), {}, {
              type: "pspdfkit/comment-marker"
            });
          }
          static fromJSON(e, t, n) {
            return (0, i.kG)("pspdfkit/comment-marker" === t.type, "Wrong `type` field"), new s.Jn(super.fromJSON(e, t, n));
          }
        }
        var pe = n(32751);
        function he(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function fe(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? he(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : he(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class me extends p.Z {
          constructor(e) {
            super(e);
          }
          toJSON() {
            return fe(fe({}, super.toJSON()), {
              type: "pspdfkit/media",
              description: this.annotation.description,
              fileName: this.annotation.fileName,
              contentType: this.annotation.contentType,
              mediaAttachmentId: this.annotation.mediaAttachmentId
            });
          }
          static fromJSON(e, t, n) {
            (0, i.kG)("pspdfkit/media" === t.type, "Wrong `type` field");
            const r = {};
            return "string" == typeof t.description && (r.description = t.description), "string" == typeof t.fileName && (r.fileName = t.fileName), "string" == typeof t.contentType && (r.contentType = t.contentType), "string" == typeof t.mediaAttachmentId && (r.mediaAttachmentId = t.mediaAttachmentId), new u.Z(fe(fe({}, super.fromJSON(e, t, n)), r));
          }
        }
        var ge = n(1858),
          ve = n(29435),
          ye = n(7654),
          be = n(96029),
          we = n(84610);
        function xe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function De(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? xe(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ce = n(74110),
          Se = n(69842),
          Ee = n(92310),
          _e = n(67009);
        const Pe = ["watermarkImage", "graphicImage"],
          ke = ["signatureType", "certificates"];
        function Ae(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ze(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ae(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ae(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Te = e => {
          Object.keys(e).forEach(t => {
            null == e[t] || e[t] instanceof Array && 0 === e[t].length ? delete e[t] : "object" != typeof e[t] || e[t] instanceof Array || Te(e[t]);
          });
        };
        function Oe(e) {
          const t = new (function (e) {
            switch (e) {
              case s.Zc:
                return m;
              case s.o9:
                return w;
              case s.b3:
                return E;
              case s.Xs:
                return k;
              case s.Hi:
                return T;
              case s.om:
                return F;
              case s.R1:
                return j;
              case s.FV:
              case s.R9:
              case s.xu:
              case s.hL:
                return X;
              case l.Z:
                return pe.Z;
              case s.gd:
                return $;
              case s.Qi:
                return V;
              case s.sK:
                return re;
              case s.GI:
                return se;
              case s.x_:
                return le.Z;
              case s.Jn:
                return de;
              case s.Ih:
                return ee;
              case u.Z:
                return me;
              default:
                throw new Error("Unsupported annotation type");
            }
          }(e.constructor))(e).toJSON();
          return Te(t), t;
        }
        function Ie(e, t, n) {
          return Ye(t.type).fromJSON(e, t, n);
        }
        function Fe(e, t, n) {
          return function (e, t, n) {
            (0, v.k)(1 === t.v, "Version Unknown"), (0, v.k)("string" == typeof e, "`id` must be of type `string`"), (0, v.k)(null == t.name || "string" == typeof t.name, "`name` must be of type `string`"), (0, v.k)("string" == typeof t.type && t.type.startsWith("pspdfkit/form-field/") && 3 === t.type.split("/").length, `Invalid type for form field '${t.type}'`), (0, we.G)(n);
            const r = t.type.split("/")[2],
              o = t.flags ? t.flags.reduce((e, t) => (e[t] = !0, e), {}) : {},
              s = De({
                id: e,
                pdfObjectId: t.pdfObjectId || null,
                name: t.name,
                annotationIds: (0, a.aV)(t.annotationIds),
                label: t.label,
                readOnly: o.readOnly,
                required: o.required,
                noExport: o.noExport,
                additionalActions: t.additionalActions ? (0, be.eb)(t.additionalActions) : null
              }, (0, we.a5)(n));
            switch (t.type) {
              case "pspdfkit/form-field/button":
                return new ge.R0(De(De({}, s), {}, {
                  buttonLabel: t.buttonLabel
                }));
              case "pspdfkit/form-field/checkbox":
                return new ge.rF(De(De({}, s), {}, {
                  defaultValues: (0, a.aV)(t.defaultValues),
                  options: (0, a.aV)(t.options.map(e => new ve.Z(e)))
                }));
              case "pspdfkit/form-field/combobox":
                return new ge.fB(De(De({}, s), {}, {
                  options: (0, a.aV)(t.options.map(e => new ve.Z(e))),
                  multiSelect: t.multiSelect,
                  commitOnChange: t.commitOnChange,
                  defaultValues: (0, a.aV)(t.defaultValues),
                  edit: t.edit,
                  doNotSpellCheck: t.doNotSpellCheck
                }));
              case "pspdfkit/form-field/listbox":
                return new ge.Vi(De(De({}, s), {}, {
                  options: (0, a.aV)(t.options.map(e => new ve.Z(e))),
                  multiSelect: t.multiSelect,
                  commitOnChange: t.commitOnChange,
                  defaultValues: (0, a.aV)(t.defaultValues)
                }));
              case "pspdfkit/form-field/radio":
                return new ge.XQ(De(De({}, s), {}, {
                  noToggleToOff: t.noToggleToOff,
                  radiosInUnison: t.radiosInUnison,
                  defaultValue: t.defaultValue,
                  options: (0, a.aV)(t.options.map(e => new ve.Z(e)))
                }));
              case "pspdfkit/form-field/text":
                return new ge.$o(De(De({}, s), {}, {
                  defaultValue: t.defaultValue,
                  password: t.password,
                  maxLength: t.maxLength,
                  doNotSpellCheck: t.doNotSpellCheck,
                  doNotScroll: t.doNotScroll,
                  multiLine: t.multiLine,
                  comb: t.comb
                }));
              case "pspdfkit/form-field/signature":
                return new ge.Yo(s);
              default:
                throw new i.p2(`Form field type not deserializable: ${r}`);
            }
          }(e, t, n);
        }
        function Me(e) {
          return function (e) {
            const t = ye.Mr.filter(t => e[t]),
              n = De(De({
                id: e.id,
                v: 1,
                pdfObjectId: e.pdfObjectId,
                name: e.name,
                annotationIds: e.annotationIds.toArray(),
                label: e.label,
                additionalActions: e.additionalActions && (0, be.GI)(e.additionalActions)
              }, (0, we.Ut)(e)), (null == t ? void 0 : t.length) && {
                flags: t
              });
            if (e instanceof ge.R0) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/button",
              buttonLabel: e.buttonLabel
            });
            if (e instanceof ge.rF) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/checkbox",
              defaultValues: e.defaultValues.toArray(),
              options: e.options.toJS()
            });
            if (e instanceof ge.fB) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/combobox",
              options: e.options.toJS(),
              multiSelect: e.multiSelect,
              commitOnChange: e.commitOnChange,
              defaultValues: e.defaultValues.toArray(),
              edit: e.edit,
              doNotSpellCheck: e.doNotSpellCheck
            });
            if (e instanceof ge.Vi) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/listbox",
              options: e.options.toJS(),
              multiSelect: e.multiSelect,
              commitOnChange: e.commitOnChange,
              defaultValues: e.defaultValues.toArray()
            });
            if (e instanceof ge.XQ) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/radio",
              options: e.options.toJS(),
              noToggleToOff: e.noToggleToOff,
              radiosInUnison: e.radiosInUnison,
              defaultValue: e.defaultValue
            });
            if (e instanceof ge.$o) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/text",
              password: e.password,
              maxLength: e.maxLength,
              doNotSpellcheck: e.doNotSpellCheck,
              doNotScroll: e.doNotScroll,
              multiLine: e.multiLine,
              comb: e.comb,
              defaultValue: e.defaultValue
            });
            if (e instanceof ge.Yo) return De(De({}, n), {}, {
              type: "pspdfkit/form-field/signature"
            });
            throw new i.p2("Form field type not serializable");
          }(e);
        }
        function Re(e, t, n) {
          return (0, Ee.z)(e, t, n);
        }
        function je(e, t) {
          return (0, Ee.o)(e, t);
        }
        function Be(e) {
          const t = a.aV.isList(e.value) ? e.value.toArray() : null == e.value ? void 0 : e.value;
          return ze(ze({
            v: 1,
            type: "pspdfkit/form-field-value",
            name: e.name,
            value: t
          }, e.optionIndexes && e.optionIndexes.size >= 1 ? {
            optionIndexes: e.optionIndexes.toArray()
          } : null), "boolean" == typeof e.isFitting && {
            isFitting: e.isFitting
          });
        }
        function Ne(e) {
          (0, i.kG)("pspdfkit/form-field-value" === e.type, "Invalid `type` for form field value."), (0, i.kG)(1 === e.v, "Invalid `version` for form field value."), (0, i.kG)("string" == typeof e.name, "Invalid `name` for form field value. Must be of type `string`."), (0, i.kG)(void 0 === e.value || null === e.value || "string" == typeof e.value || Array.isArray(e.value), "Invalid `value` for form field value. Must be of type `undefined`, `null`, `string`, or `Array<string>`."), (0, i.kG)(void 0 === e.optionIndexes || Array.isArray(e.optionIndexes) && e.optionIndexes.every(Number.isInteger), "Invalid `optionIndexes` value for form field value. Must be an Array of integers."), (0, i.kG)(void 0 === (null == e ? void 0 : e.isFitting) || "boolean" == typeof e.isFitting, "Invalid `isFitting` value for form field value. Must be a boolean.");
          const t = e.value instanceof Array ? (0, a.aV)(e.value) : e.value,
            n = e.name;
          return new ge.KD(ze(ze({
            name: n,
            value: t
          }, e.optionIndexes && e.optionIndexes.length >= 1 ? {
            optionIndexes: (0, a.aV)(e.optionIndexes)
          } : null), "boolean" == typeof e.isFitting && {
            isFitting: e.isFitting
          }));
        }
        function Le(e) {
          if (!Object.values(Se._).includes(e.status)) throw new i.p2("Invalid `status` for signatures info. Must be one of the `PSPDFKit.DocumentValidationStatus` values");
          if ("string" != typeof e.checkedAt) throw new i.p2("Invalid `checkedAt` for signatures info. Must be of type `string`.");
          if (void 0 !== e.signatures && !Array.isArray(e.signatures)) throw new i.p2("Invalid `signatures` for signatures info. Must be of type `undefined` or `Array`.");
          if (!["undefined", "boolean"].includes(typeof e.documentModifiedSinceSignature)) throw new i.p2("Invalid `documentModifiedSinceSignature` for signatures info. Must be of type `undefined` or `boolean`.");
          const {
            checkedAt: t,
            signatures: n,
            documentModifiedSinceSignature: r
          } = e;
          return ze(ze({
            status: Se._[e.status],
            checkedAt: new Date(t)
          }, n ? {
            signatures: Ve(n)
          } : null), "boolean" == typeof r ? {
            documentModifiedSinceSignature: r
          } : null);
        }
        function Ve(e) {
          return e.map(e => {
            if ("pspdfkit/signature-info" !== e.type) throw new i.p2("Invalid `type` for signature info.");
            if (["signerName", "creationDate", "signatureReason", "signatureLocation"].forEach(t => {
              if (!["undefined", "string"].includes(typeof e[t])) throw new i.p2(`Invalid \`${t}\` for signature info. Must be \`undefined\` or \`string\`.`);
            }), ["isTrusted", "isSelfSigned", "isExpired", "documentModifiedSinceSignature"].forEach(t => {
              if (!["boolean"].includes(typeof e[t])) throw new i.p2(`Invalid \`${t}\` for signature info. Must be \`boolean\``);
            }), !["string"].includes(typeof e.signatureFormFQN)) throw new i.p2("Invalid `signatureFormFQN` for signature info. Must be a `string`.");
            if (!Object.values(Ce.QA).includes(e.documentIntegrityStatus)) throw new i.p2("Invalid `documentIntegrityStatus` for signature info. Must be one of the `PSPDFKit.DocumentIntegrityStatus` values");
            if (e.signatureType && !Object.values(Ce.Xl).includes(e.signatureType)) throw new i.p2(`Invalid \`signatureType\` for signature info: ${e.signatureType}. Must be 'cms' or 'cades' if present`);
            if (!Object.values(Ce.wk).includes(e.certificateChainValidationStatus)) throw new i.p2("Invalid `certificateChainValidationStatus` for signature info. Must be one of the `PSPDFKit.CertificateChainValidationStatus` values");
            if (!Object.values(Ce.qA).includes(e.signatureValidationStatus)) throw new i.p2("Invalid `signatureValidationStatus` for signature info. Must be one of the `PSPDFKit.SignatureValidationStatus` values");
            return ze(ze({
              type: e.type
            }, e.signatureType ? {
              signatureType: it[e.signatureType]
            } : null), {}, {
              documentIntegrityStatus: Ce.QA[e.documentIntegrityStatus],
              certificateChainValidationStatus: Ce.wk[e.certificateChainValidationStatus],
              signatureValidationStatus: Ce.qA[e.signatureValidationStatus],
              isTrusted: e.isTrusted,
              isSelfSigned: e.isSelfSigned,
              isExpired: e.isExpired,
              documentModifiedSinceSignature: e.documentModifiedSinceSignature,
              signerName: e.signerName,
              signatureReason: e.signatureReason,
              signatureLocation: e.signatureLocation,
              creationDate: e.creationDate ? new Date(e.creationDate) : void 0,
              signatureFormFQN: e.signatureFormFQN,
              PAdESSignatureLevel: e.PAdESSignatureLevel,
              validFrom: e.validFrom,
              validUntil: e.validUntil,
              timestampInfo: e.timestampInfo,
              ltv: e.ltv
            });
          });
        }
        function Ke(e) {
          return ze({
            type: "pspdfkit/signature-metadata"
          }, e);
        }
        function qe(e) {
          return e ? {
            type: "pspdfkit/signature-position",
            pageIndex: e.pageIndex,
            rect: (0, D.u)(e.boundingBox)
          } : null;
        }
        function He(e) {
          return new Promise((t, n) => {
            if ("function" == typeof e.arrayBuffer) t(e.arrayBuffer());else if (e instanceof window.Blob) {
              const r = new FileReader();
              r.onloadend = () => t(r.result), r.onerror = n, r.readAsArrayBuffer(e);
            } else n(new Error("The input is not a Blob or File."));
          });
        }
        async function Ue(e) {
          if (!e) return null;
          const {
              watermarkImage: t,
              graphicImage: n
            } = e,
            o = (0, r.Z)(e, Pe);
          let i, a, s, l;
          return t && (i = await He(t), a = t.type), n && (s = await He(n), l = n.type), ze(ze(ze(ze(ze({
            type: "pspdfkit/signature-appearance"
          }, o), i ? {
            watermark: (0, _e.sM)(i)
          } : {}), a ? {
            watermarkContentType: a
          } : {}), s ? {
            graphic: (0, _e.sM)(s)
          } : {}), l ? {
            graphicContentType: l
          } : {});
        }
        function Ze(e) {
          const t = e || {},
            {
              signatureType: n,
              certificates: o
            } = t,
            i = (0, r.Z)(t, ke);
          return ze({
            type: "pspdfkit/signer-data-source",
            certificates: o || [],
            signatureType: at[n || (o && o.length > 0 ? Ce.BG.CAdES : Ce.BG.CMS)] || Ce.Xl.cms
          }, i);
        }
        function $e(e) {
          return "string" == typeof e.type && e.type.startsWith("pspdfkit/form-field/");
        }
        function Ge(e) {
          return "pspdfkit/form-field-value" === e.type;
        }
        function We(e) {
          return e.map(e => e.data).toJS();
        }
        const Ye = e => {
          switch (e) {
            case "pspdfkit/ink":
              return m;
            case "pspdfkit/shape/line":
              return w;
            case "pspdfkit/shape/rectangle":
              return E;
            case "pspdfkit/shape/ellipse":
              return k;
            case "pspdfkit/shape/polygon":
              return T;
            case "pspdfkit/shape/polyline":
              return F;
            case "pspdfkit/link":
              return j;
            case "pspdfkit/markup/highlight":
            case "pspdfkit/markup/squiggly":
            case "pspdfkit/markup/strikeout":
            case "pspdfkit/markup/underline":
              return X;
            case "pspdfkit/markup/redaction":
              return pe.Z;
            case "pspdfkit/text":
              return $;
            case "pspdfkit/note":
              return V;
            case "pspdfkit/image":
              return re;
            case "pspdfkit/stamp":
              return se;
            case "pspdfkit/widget":
              return le.Z;
            case "pspdfkit/comment-marker":
              return de;
            case "pspdfkit/media":
              return me;
            default:
              return ee;
          }
        };
        function Xe(e) {
          const t = Object.entries(e).reduce((e, t) => {
            let [n, r] = t;
            switch (n) {
              case "color":
              case "fontColor":
              case "strokeColor":
              case "backgroundColor":
              case "borderColor":
              case "fillColor":
              case "outlineColor":
                e[n] = r && (0, c.C)(r);
                break;
              case "startPoint":
              case "endPoint":
                e[n] = r && (0, d.K)(r);
                break;
              case "icon":
                e.icon = B.Y4[r];
                break;
              case "points":
                e.points = r && r.map(e => (0, d.K)(e)).toJS();
                break;
              case "lines":
                e.lines = r && {
                  points: r.map(e => e.map(e => (0, d.K)(e))).toJS(),
                  intensities: r.map(e => e.map(e => e.intensity)).toJS()
                };
                break;
              case "isBold":
                e.fontStyle = Array.isArray(e.fontStyle) ? e.fontStyle.concat("bold") : ["bold"];
                break;
              case "isItalic":
                e.fontStyle = Array.isArray(e.fontStyle) ? e.fontStyle.concat("italic") : ["italic"];
                break;
              case "callout":
                e.callout = r && {
                  start: (0, d.K)(r.start),
                  knee: r.knee && (0, d.K)(r.knee),
                  end: (0, d.K)(r.end),
                  cap: r.cap
                };
                break;
              case "boundingBox":
                e.bbox = r && (0, D.u)(r);
                break;
              case "cloudyBorderInset":
                e.cloudyBorderInset = r && (0, x.B)(r);
                break;
              case "strokeDashArray":
              case "borderDashArray":
                e.strokeDashArray = r;
                break;
              case "action":
                e.action = r && (0, be.vP)(r);
                break;
              case "createdAt":
              case "updatedAt":
                e[n] = r && r.toISOString();
                break;
              case "noPrint":
              case "noZoom":
              case "noRotate":
              case "noView":
              case "hidden":
                !0 === r && (e.flags = Array.isArray(e.flags) ? e.flags.concat(n) : [n]);
                break;
              default:
                e[n] = r;
            }
            return e;
          }, {});
          return Te(t), t;
        }
        function Qe(e) {
          const t = Object.entries(e).reduce((e, t) => {
            let [n, r] = t;
            switch (n) {
              case "color":
              case "fontColor":
              case "strokeColor":
              case "backgroundColor":
              case "borderColor":
              case "fillColor":
              case "outlineColor":
                e[n] = null != r ? (0, c.b)(r) : null;
                break;
              case "startPoint":
              case "endPoint":
                e[n] = r && (0, d.W)(r);
                break;
              case "icon":
                e.icon = B.V9[r];
                break;
              case "points":
                e.points = r && (0, a.aV)(r.map(e => (0, d.W)(e)));
                break;
              case "lines":
                e.lines = r && (0, a.aV)(r.points).map((e, t) => {
                  const n = r.intensities[t];
                  return (0, a.aV)(e).map((e, t) => {
                    const r = n[t],
                      o = (0, d.W)(e);
                    return new s.Wm({
                      x: o.x,
                      y: o.y,
                      intensity: r
                    });
                  });
                });
                break;
              case "fontStyle":
                e.isBold = r && r.includes("bold"), e.isItalic = r && r.includes("italic");
                break;
              case "callout":
                e.callout = r && {
                  start: (0, d.W)(r.start),
                  knee: r.knee && (0, d.W)(r.knee),
                  end: (0, d.W)(r.end),
                  cap: r.cap
                };
                break;
              case "bbox":
                e.boundingBox = r && (0, D.k)(r);
                break;
              case "cloudyBorderInset":
                e.cloudyBorderInset = r && (0, x.r)(r);
                break;
              case "strokeDashArray":
                e.strokeDashArray = r;
                break;
              case "action":
                e.action = r && (0, be.lk)(r);
                break;
              case "createdAt":
              case "updatedAt":
                e[n] = new Date(r);
                break;
              case "flags":
                r && (e.noPrint = r.includes("noPrint"), e.noZoom = r.includes("noZoom"), e.noRotate = r.includes("noRotate"), e.noView = r.includes("noView"), e.hidden = r.includes("hidden"));
                break;
              default:
                e[n] = r;
            }
            return e;
          }, {});
          return Te(t), t;
        }
        function Je(e) {
          return "pspdfkit/bookmark" === e.type;
        }
        function et(e) {
          return "pspdfkit/comment" === e.type;
        }
        function tt(e) {
          return "pspdfkit/signature-info" === e.type;
        }
        function nt(e) {
          return "pspdfkit/embedded-file" === e.type;
        }
        function rt(e) {
          const t = [];
          return e.isBold && t.push("bold"), e.isItalic && t.push("italic"), t.length > 0 ? t : null;
        }
        function ot(e) {
          if ("addPage" === e.type) {
            if ("afterPageIndex" in e && "number" == typeof e.afterPageIndex) return ze({
              type: e.type,
              afterPageIndex: e.afterPageIndex,
              pageWidth: e.pageWidth,
              pageHeight: e.pageHeight,
              rotateBy: e.rotateBy,
              backgroundColor: e.backgroundColor.toCSSValue()
            }, e.insets && {
              insets: (0, D.u)(e.insets)
            });
            if ("beforePageIndex" in e && "number" == typeof e.beforePageIndex) return ze({
              type: e.type,
              beforePageIndex: e.beforePageIndex,
              pageWidth: e.pageWidth,
              pageHeight: e.pageHeight,
              rotateBy: e.rotateBy,
              backgroundColor: e.backgroundColor.toCSSValue()
            }, e.insets && {
              insets: (0, D.u)(e.insets)
            });
            throw new i.p2("The `addPage` operation is missing either the `afterPageIndex` or the `beforePageIndex` property");
          }
          return "cropPages" === e.type ? {
            type: e.type,
            cropBox: (0, D.u)(e.cropBox),
            pageIndexes: e.pageIndexes
          } : "addPageMargins" === e.type ? {
            type: e.type,
            margins: (0, x.B)(e.margins),
            pageIndexes: e.pageIndexes
          } : "flattenAnnotations" === e.type ? ze({
            type: e.type,
            pageIndexes: e.pageIndexes,
            annotationIds: e.annotationIds,
            noteAnnotationOpacity: e.noteAnnotationOpacity
          }, e.noteAnnotationBackgroundColor ? {
            noteAnnotationBackgroundColor: (0, c.C)(e.noteAnnotationBackgroundColor)
          } : null) : e;
        }
        const it = {
            cms: "CMS",
            cades: "CAdES",
            documentTimestamp: "documentTimestamp"
          },
          at = {
            CMS: "cms",
            CAdES: "cades",
            documentTimestamp: "documentTimestamp"
          };
        function st(e) {
          return (0, a.aV)(e.map(e => ({
            c: e.c,
            rect: (0, D.k)(e.r)
          })));
        }
      },
      31312: (e, t, n) => {
        "use strict";

        n.d(t, {
          py: () => gS,
          eQ: () => mS,
          xE: () => tS,
          Un: () => vS,
          zD: () => lS,
          ae: () => ZC,
          XV: () => yS,
          n_: () => sS,
          Nt: () => nS,
          If: () => UC
        });
        var r = {};
        n.r(r), n.d(r, {
          Decoder: () => Gx,
          Encoder: () => Zx,
          PacketType: () => Ux,
          protocol: () => Hx
        });
        var o = n(96156),
          i = n(31672),
          a = n(67665),
          s = n(35369),
          l = n(67366),
          u = n(15359),
          c = n(73935),
          d = n(67294),
          p = n(94184),
          h = n.n(p),
          f = n(82654),
          m = n(38252),
          g = n(87153),
          v = n.n(g),
          y = n(98260);
        class b {
          constructor() {
            this.ranges = [], this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
          }
          getRangeAt(e) {
            return this.ranges[e];
          }
          addRange(e) {
            this.ranges.push(e);
          }
          removeAllRanges() {
            this.ranges = [];
          }
          setBaseAndExtent(e, t, n, r) {
            const o = document.createRange();
            o.setStart(e, t), o.setEnd(n, r), this.removeAllRanges(), this.addRange(o), this.anchorNode = e, this.anchorOffset = t, this.focusNode = n, this.focusOffset = r;
          }
          isEmptySelection() {
            return 0 === this.ranges.length;
          }
          get isCollapsed() {
            return 0 === this.ranges.length || 1 === this.ranges.length && this.ranges[0].collapsed;
          }
          collapse(e, t) {
            const n = document.createRange();
            n.collapse(!0), n.setStart(e, t), n.setEnd(e, t), this.removeAllRanges(), this.addRange(n), this.anchorNode = e, this.anchorOffset = t, this.focusNode = e, this.focusOffset = t;
          }
          extend(e, t) {
            if (0 === this.ranges.length) throw new Error("No ranges to extend");
            this.ranges[this.ranges.length - 1].setEnd(e, t), this.focusNode = e, this.focusOffset = t;
          }
          get rangeCount() {
            return this.ranges.length;
          }
          toString() {
            return this.ranges.map(e => e.toString()).join("");
          }
        }
        class w {
          constructor(e) {
            (0, o.Z)(this, "selection", new b()), (0, o.Z)(this, "isSelecting", !1), (0, o.Z)(this, "initialPoint", null), (0, o.Z)(this, "currentPoint", null), (0, o.Z)(this, "clickCount", 0), (0, o.Z)(this, "clickTimer", null), (0, o.Z)(this, "processing", !1), this.boundHandleMouseDown = this.handleMouseDown.bind(this), this.boundHandleMouseMove = this.handleMouseMove.bind(this), this.boundHandleMouseUp = this.handleMouseUp.bind(this), this.boundSelectionChange = this.windowSelectionChange.bind(this), this.boundBeforeInput = this.handleBeforeInput.bind(this), this.setupEventListeners(e), window.ShadowRoot.prototype.getSelection = () => {
              const e = x();
              return (0, y.W1)(e) || e === document.body ? document.getSelection() : this.selection;
            };
          }
          setupEventListeners(e) {
            e.addEventListener("mousedown", this.boundHandleMouseDown), e.addEventListener("mousemove", this.boundHandleMouseMove), document.addEventListener("mouseup", this.boundHandleMouseUp), window.addEventListener("selectionchange", this.boundSelectionChange, !0), window.addEventListener("beforeinput", this.boundBeforeInput, !0);
          }
          cleanupEventListeners(e) {
            e.removeEventListener("mousedown", this.boundHandleMouseDown), e.removeEventListener("mousemove", this.boundHandleMouseMove), document.removeEventListener("mouseup", this.boundHandleMouseUp), window.removeEventListener("selectionchange", this.boundSelectionChange, !0), window.removeEventListener("beforeinput", this.boundBeforeInput, !0);
          }
          windowSelectionChange() {
            if (!this.processing) {
              this.processing = !0;
              const e = x();
              e && "true" === e.getAttribute("contenteditable") && document.execCommand("indent"), this.processing = !1;
            }
          }
          handleBeforeInput(e) {
            const t = e;
            if (this.processing) {
              const e = t.getTargetRanges()[0],
                n = new Range();
              n.setStart(e.startContainer, e.startOffset), n.setEnd(e.endContainer, e.endOffset), this.selection.removeAllRanges(), this.selection.addRange(n), t.preventDefault(), t.stopImmediatePropagation();
            }
          }
          handleMouseDown(e) {
            const t = e,
              n = e.composedPath()[0];
            return this.clickCount++, 2 === this.clickCount ? (this.handleDoubleClick(t), void this.resetClickCountAfterDelay()) : 3 === this.clickCount ? (this.handleTripleClick(t), void (this.clickCount = 0)) : (1 !== this.clickCount || this.selection.isEmptySelection() || this.selection.removeAllRanges(), this.setupInitialSelectionPoint({
              e: t,
              target: n
            }), void this.resetClickCountAfterDelay());
          }
          handleMouseMove(e) {
            const t = e;
            if (!this.isSelecting) return;
            const n = t.composedPath()[0],
              r = (0, y.m_)(n, t.clientX, t.clientY);
            let o = 0;
            if (r && r.nodeType === Node.TEXT_NODE && (o = (0, y.QC)(r, t.clientX, t.clientY)), this.currentPoint = {
              node: r,
              offset: o
            }, this.initialPoint && this.currentPoint) {
              const {
                  node: e,
                  offset: t
                } = this.initialPoint,
                {
                  node: n,
                  offset: r
                } = this.currentPoint;
              e && n && this.updateSelection(e, t, n, r);
            }
          }
          handleMouseUp() {
            if (this.isSelecting = !1, setTimeout(() => {
              1 === this.clickCount && (this.currentPoint || this.initialPoint && null !== this.initialPoint.node || this.selection.removeAllRanges(), this.clickCount = 0);
            }, 400), this.initialPoint && this.currentPoint) {
              const e = this.initialPoint.node,
                t = this.currentPoint.node;
              if (e && t) {
                const e = (0, y.g)(this.initialPoint, this.currentPoint);
                this.updateSelection(e.startNode, e.startOffset, e.endNode, e.endOffset);
              }
            }
            this.initialPoint = null, this.currentPoint = null;
          }
          setupInitialSelectionPoint(e) {
            let {
              e: t,
              target: n
            } = e;
            const r = (0, y.m_)(n, t.clientX, t.clientY),
              o = r && r.nodeType === Node.TEXT_NODE ? (0, y.QC)(r, t.clientX, t.clientY) : 0;
            this.initialPoint = {
              node: r,
              offset: o
            }, this.isSelecting = !0;
          }
          resetClickCountAfterDelay() {
            clearTimeout(this.clickTimer), this.clickTimer = setTimeout(() => {
              this.clickCount = 0;
            }, 400);
          }
          handleDoubleClick(e) {
            const t = e.composedPath()[0],
              n = (0, y.m_)(t, e.clientX, e.clientY);
            if (n && n.nodeType === Node.TEXT_NODE) {
              const t = (0, y.xA)(n, e.clientX, e.clientY);
              t && (this.selection.removeAllRanges(), this.selection.addRange(t));
            }
          }
          handleTripleClick(e) {
            clearTimeout(this.clickTimer), this.clickCount = 0;
            const t = e.composedPath()[0],
              n = (0, y.S9)(t);
            n && (this.selection.removeAllRanges(), this.selection.addRange(n));
          }
          updateSelection(e, t, n, r) {
            const o = new Range();
            o.setStart(e, t), o.setEnd(n, r), this.selection.removeAllRanges(), this.selection.addRange(o);
          }
        }
        function x() {
          let e = document.activeElement;
          for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
          return e;
        }
        var D = n(72110);
        function C(e) {
          return (0, u.kG)(Array.isArray(e), "fontSubstitutions must be an array of FontSubstitution objects."), e.every(e => "string" == typeof (null == e ? void 0 : e.pattern) && "" !== (null == e ? void 0 : e.pattern.trim()) && "string" == typeof (null == e ? void 0 : e.target) && "" !== e.target.trim());
        }
        var S = n(90093),
          E = n(44077),
          _ = n(45249),
          P = n(47120),
          k = n(46364),
          A = n(44228),
          z = n(29152),
          T = n(1385),
          O = n(94327),
          I = n(79724),
          F = n(38852);
        const M = (0, I.Z)("MeasurementValueConfiguration");
        function R(e) {
          let t = !1;
          e.forEach((n, r) => {
            var o;
            o = n, M((0, u.PO)(o) && !!o, "Expected item to be an object"), M((0, u.PO)(o.scale) && !!o.scale, "Expected scale to be an object"), M(void 0 !== o.scale.unitFrom && Object.values(O.s).includes(o.scale.unitFrom), `Scale ${o.name} does not have a valid 'unitFrom' value.`), M(void 0 !== o.scale.unitTo && Object.values(T.K).includes(o.scale.unitTo), `Scale ${o.name} does not have a valid 'unitTo' value.`), M(void 0 !== o.scale.fromValue && (0, F.hj)(Number(o.scale.fromValue)), `Scale ${o.name} does not have a valid 'fromValue' value.`), M(void 0 !== o.scale.toValue && (0, F.hj)(Number(o.scale.toValue)), `Scale ${o.name} does not have a valid 'toValue' value.`), M("string" == typeof o.precision || void 0 === o.precision, "`measurementValueConfiguration.measurementPrecision` must be a string.");
            for (let t = r + 1; t < e.length; t++) {
              const o = (0, z.cd)(n, e[t]);
              M(!o, `Scale ${n.name || `at index ${r}`} is a duplicate of ${e[t].name || `at index ${t}`}.`);
            }
            n.selected && (M(!t, "Only one scale can be selected at a time. Please check your configuration."), t = !0);
          });
        }
        var j = n(33427),
          B = n(48625),
          N = n(54103),
          L = n(57943),
          V = n(55012);
        function K(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function q(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? K(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const H = new _.ZM(),
          U = {
            [V.M85]: (e, t) => e.withMutations(e => {
              t.annotations.forEach(t => {
                (0, j.ud)(e, t);
              });
            }),
            [V.ILc]: (e, t) => {
              const n = t.annotation.withMutations(n => n.merge((0, j.lx)(e)).set("pageIndex", t.pageIndex));
              return e.withMutations(e => {
                e.set("selectedAnnotationIds", (0, s.l4)([n.id])), e.set("interactionMode", B.A.INK), e.set("selectedAnnotationMode", N.o.EDITING), (0, j.ud)(e, n);
              });
            },
            [V.RPc]: (e, t) => e.set("inkEraserCursorWidth", t.lineWidth),
            [V.HS7]: (e, t) => {
              const n = t.annotation.withMutations(n => n.merge((0, j.lx)(e)).set("pageIndex", t.pageIndex));
              return e.withMutations(e => {
                e.set("selectedAnnotationIds", (0, s.l4)([n.id])), e.set("interactionMode", (0, L.R4)(t.annotation.constructor)), e.set("selectedAnnotationMode", N.o.EDITING), (0, j.ud)(e, n);
              });
            },
            [V.jzI]: (e, t) => {
              const n = t.annotation.withMutations(n => n.merge((0, j.lx)(e)).set("pageIndex", t.pageIndex));
              return e.withMutations(e => {
                e.set("selectedAnnotationIds", (0, s.l4)([n.id])), e.set("interactionMode", B.A.REDACT_SHAPE_RECTANGLE), e.set("selectedAnnotationMode", N.o.EDITING), (0, j.ud)(e, n);
              });
            },
            [V.oE1]: (e, t) => {
              let {
                attributes: n
              } = t;
              const {
                currentItemPreset: r
              } = e;
              return r ? e.hasIn(["annotationPresets"], r) ? e.mergeIn(["annotationPresets", r], n) : e.setIn(["annotationPresets", r], n) : e;
            },
            [V.oWy]: (e, t) => {
              let {
                currentItemPreset: n
              } = t;
              return e.set("currentItemPreset", n);
            },
            [V.UiQ]: (e, t) => {
              let {
                annotationPresets: n
              } = t;
              return e.set("annotationPresets", n);
            },
            [V.R1i]: (e, t) => {
              let {
                annotationID: n,
                annotationPresetID: r
              } = t;
              return e.setIn(["annotationPresetIds", n], r);
            },
            [V.x0v]: (e, t) => {
              let {
                annotationID: n
              } = t;
              return e.delete("annotationPresetIds", n);
            },
            [V.JwD]: (e, t) => {
              let {
                annotationID: n
              } = t;
              const r = e.annotationPresetIds.has(n) ? e.annotationPresetIds.get(n) : (0, j.X5)(e, n);
              return e.set("currentItemPreset", r);
            },
            [V.R8P]: (e, t) => e.withMutations(e => {
              t.annotations.forEach(t => {
                (0, j._E)(e, t);
              });
            }),
            [V.gF5]: (e, t) => e.withMutations(e => {
              t.ids.forEach(t => {
                (0, j.Dl)(e, t);
              });
            }),
            [V.sCM]: (e, t) => {
              let {
                annotationsIDs: n
              } = t;
              return e.set("annotationsIdsToDelete", n);
            },
            [V.qRJ]: (e, t) => {
              let {
                stampAnnotationTemplates: n
              } = t;
              return e.set("stampAnnotationTemplates", n);
            },
            [V.WaW]: (e, t) => e.set("collapseSelectedNoteContent", t.value),
            [V.ieh]: (e, t) => e.withMutations(e => {
              t.ids.forEach((t, n) => {
                e.invalidAPStreams.get(t) || e.set("invalidAPStreams", e.invalidAPStreams.set(t, (0, s.l4)()));
                const r = e.invalidAPStreams.get(t);
                r && e.set("invalidAPStreams", e.invalidAPStreams.set(t, r.add(n)));
              });
            }),
            [V.kVz]: (e, t) => e.withMutations(e => {
              t.ids.forEach((t, n) => {
                e.invalidAPStreams.get(t) && e.deleteIn(["invalidAPStreams", t], n);
              });
            }),
            [V.hw0]: (e, t) => e.set("onAnnotationResizeStart", t.callback),
            [V.$8O]: (e, t) => {
              let {
                measurementToolState: n
              } = t;
              return e.set("measurementToolState", n ? q(q({}, e.measurementToolState), n) : null);
            },
            [V.UP4]: (e, t) => {
              let {
                hintLines: n
              } = t;
              return e.set("hintLines", n);
            },
            [V.vkF]: (e, t) => {
              let {
                configurationCallback: n
              } = t;
              return e.set("measurementValueConfiguration", n);
            },
            [V.SdX]: (e, t) => {
              var n, r;
              let {
                scales: o
              } = t;
              const i = null !== (n = null === (r = e.measurementValueConfiguration) || void 0 === r ? void 0 : r.call(e, o)) && void 0 !== n ? n : o;
              i && R(i);
              const a = e.activeMeasurementScale || i.find(e => e.selected) || i[0];
              return e.withMutations(e => {
                e.set("measurementScales", i), a && e.set("activeMeasurementScale", a);
              });
            },
            [V.Zt9]: (e, t) => e.set("secondaryMeasurementUnit", t.secondaryMeasurementUnit),
            [V.VNu]: (e, t) => e.set("activeMeasurementScale", t.activeMeasurementScale),
            [V.wgG]: (e, t) => e.set("isCalibratingScale", t.isCalibratingScale),
            [V.Dqw]: (e, t) => e.withMutations(e => {
              "down" === t.variant ? e.updateIn(["APStreamVariantsDown"], e => e.concat(t.annotationObjectIds)) : "rollover" === t.variant && e.updateIn(["APStreamVariantsRollover"], e => e.concat(t.annotationObjectIds));
            }),
            [V.uOP]: (e, t) => e.set("widgetAnnotationToFocus", t.annotationId),
            [V.SHi]: (e, t) => {
              const {
                  annotations: n,
                  formFields: r
                } = e,
                o = [],
                i = t.tabOrder.reduce((e, i) => {
                  const a = n.find(e => "number" == typeof e.pdfObjectId ? i.pdfObjectId === e.pdfObjectId : i.id === e.id);
                  let s;
                  if (a instanceof _.x_) {
                    if (s = r.get(a.formFieldName), !s) return e;
                    if (s instanceof _.XQ) {
                      if (o.includes(s.name)) return e;
                      const r = n.filter(e => e instanceof _.x_ && e.formFieldName === s.name),
                        i = t.tabOrder.filter(e => r.some(t => "number" == typeof e.pdfObjectId ? e.pdfObjectId === t.pdfObjectId : e.id === t.id)).map(e => e.id);
                      return o.push(s.name), e.concat(i);
                    }
                  }
                  return e.concat([null == a ? void 0 : a.id]);
                }, []).filter(Boolean);
              return e.setIn(["pages", t.pageIndex, "tabOrder"], i);
            }
          };
        function Z() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : H,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = U[t.type];
          return n ? n(e, t) : e;
        }
        var $ = n(17078),
          G = n(93113),
          W = n(94732),
          Y = n(31442),
          X = n(38246),
          Q = n(39934),
          J = n(2841),
          ee = n(44550),
          te = n(28233),
          ne = n(17375);
        function re(e) {
          var t = function (e, t) {
            if ("object" != typeof e || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" != typeof r) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" == typeof t ? t : String(t);
        }
        function oe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ie(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? oe(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const ae = () => () => {};
        function se() {
          const e = d.createContext(ae);
          class t extends d.Component {
            constructor() {
              super(...arguments), (0, o.Z)(this, "state", {
                instances: {}
              }), (0, o.Z)(this, "refCreator", (e, t, n) => r => {
                this.setState(o => {
                  let {
                    instances: i
                  } = o;
                  const a = i[e] || {
                    node: null,
                    portalTarget: document.createElement("div"),
                    target: null
                  };
                  return n && (a.portalTarget.className = n), a.portalTarget.parentNode !== r && r && r.appendChild(a.portalTarget), a.node === t && a.target === r ? null : {
                    instances: ie(ie({}, i), {}, {
                      [e]: ie(ie({}, a), {}, {
                        node: t,
                        target: r
                      })
                    })
                  };
                }, () => {
                  if (null === r) {
                    null === this.state.instances[e].target && this.setState(t => {
                      let {
                        instances: n
                      } = t;
                      const {
                        [e]: r
                      } = n;
                      return {
                        instances: (0, ne.Z)(n, [e].map(re))
                      };
                    });
                  }
                });
              });
            }
            render() {
              const t = Object.entries(this.state.instances).map(e => {
                let [t, {
                  node: n,
                  portalTarget: r
                }] = e;
                return c.createPortal(void 0 === n ? null : n, r, t);
              });
              return d.createElement(e.Provider, {
                value: this.refCreator
              }, this.props.children, t);
            }
          }
          return {
            Provider: t,
            Reparent: function (t) {
              let {
                id: n,
                children: r,
                className: o
              } = t;
              return d.createElement(e.Consumer, null, e => d.createElement("div", {
                ref: e(n, r, o)
              }));
            }
          };
        }
        const le = se(),
          ue = se();
        se();
        var ce = n(22122),
          de = n(4715);
        function pe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function he(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? pe(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function fe(e) {
          let {
            append: t,
            node: n,
            children: r,
            rendererStyles: o,
            onDisappear: i
          } = e;
          const [a, s] = d.useState(null),
            l = d.useRef(i);
          return d.useLayoutEffect(() => {
            if (a && n && n !== a.firstChild) {
              for (; a.firstChild;) a.removeChild(a.firstChild);
              a.appendChild(n);
            }
            return () => {
              const e = l.current;
              e && e(n);
            };
          }, [n, a]), d.useLayoutEffect(() => {
            l.current = i;
          }, [i]), d.createElement("div", {
            style: {
              position: "relative"
            }
          }, t && r, n && d.createElement("div", {
            ref: s,
            style: o
          }));
        }
        function me(e, t) {
          return !e && !t;
        }
        const ge = {
          node: "object",
          append: "boolean",
          noZoom: "boolean",
          onDisappear: "function"
        };
        const ve = (0, l.$j)(e => ({
            customRenderers: e.customRenderers
          }))(function (e) {
            const {
              children: t,
              customRenderers: n,
              renderer: r,
              zoomLevel: o,
              notCSSScaled: i = !1
            } = e;
            if (!n || !n[r]) return t;
            const a = d.Children.only(t),
              s = a.props,
              l = ye[r],
              c = n[r];
            (0, u.kG)(null != c);
            const p = c(l(s));
            if (!p) return t;
            !function (e) {
              (0, u.kG)(e.node, "Custom renderers must return an object with a node property.");
              for (const t in e) e.hasOwnProperty(t) && ((0, u.kG)(void 0 !== ge[t], `Render configuration '${t}' property is not supported`), (0, u.kG)(typeof e[t] === ge[t], `Render configuration ${t} property has wrong '${typeof e[t]}' type, should be '${ge[t]}'`));
            }(p);
            const {
                node: h,
                append: f,
                noZoom: m = !1,
                onDisappear: g
              } = p,
              v = be[r];
            (0, u.kG)("boolean" == typeof m);
            const y = he({
              pointerEvents: f ? "none" : "all"
            }, v ? v(s, m, i, o) : null);
            return d.createElement(fe, {
              node: h,
              append: f,
              onDisappear: g,
              rendererStyles: y
            }, a);
          }),
          ye = {
            Annotation: e => ({
              annotation: e.annotation
            }),
            CommentAvatar: e => ({
              comment: e.comment
            })
          },
          be = {
            Annotation: function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                n = arguments.length > 2 ? arguments[2] : void 0,
                r = arguments.length > 3 ? arguments[3] : void 0;
              if (e && e.annotation && e.annotation.boundingBox) {
                const {
                  left: o,
                  top: i,
                  width: a,
                  height: s
                } = e.annotation.boundingBox;
                return he({
                  position: "absolute",
                  left: o * r,
                  top: i * r,
                  width: n ? a * r : a,
                  height: n ? s * r : s
                }, me(t, n) ? {
                  transform: `scale(${r})`,
                  transformOrigin: "0 0"
                } : null);
              }
              return {};
            },
            CommentAvatar: null
          };
        var we = n(83882),
          xe = n(35782),
          De = n(98179),
          Ce = n(82716);
        function Se(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class Ee extends d.PureComponent {
          render() {
            const {
              applyZoom: e,
              children: t,
              position: n,
              zoomLevel: r,
              noRotate: i,
              currentPagesRotation: a,
              disablePointerEvents: s,
              additionalStyle: l = {},
              isMultiAnnotationsSelected: u
            } = this.props;
            (0, Ce.k)(!i || "number" == typeof a);
            const c = (e ? `scale(${r}) ` : "") + (i ? `rotate(-${String(a)}deg)` : ""),
              p = function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? Se(Object(n), !0).forEach(function (t) {
                    (0, o.Z)(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Se(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                top: n ? n.y * r : null,
                left: n ? n.x * r : null,
                position: "absolute",
                transform: c,
                transformOrigin: "0 0",
                pointerEvents: !0 === s ? "none" : "auto",
                zIndex: u ? 2 : "unset"
              }, l);
            return d.createElement("div", {
              style: p,
              className: this.props.className
            }, t);
          }
        }
        var _e = n(89637),
          Pe = n(40163),
          ke = n(17766),
          Ae = n(71623),
          ze = n(97008),
          Te = n.n(ze);
        class Oe extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_onPointerDownUp", e => {
              e.isPrimary && (!this.props.isReadOnly && e.preventDefault(), this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null));
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              const n = () => {
                this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                  selectedAnnotationShouldDrag: t,
                  stopPropagation: !0,
                  ignoreReadOnly: !0
                }));
              };
              De.Ni ? window.setTimeout(n, 5) : n();
            }), (0, o.Z)(this, "_handleClick", e => {
              "keypress" === e.type && this._handlePress(e, null);
            });
          }
          render() {
            const {
                annotation: e,
                zoomLevel: t,
                rotation: n,
                active: r,
                intl: {
                  formatMessage: o
                }
              } = this.props,
              {
                width: i,
                height: a
              } = e.boundingBox,
              s = this.props.isReadOnly ? {
                onPointerUp: this._onPointerDownUp
              } : {
                onPointerDown: this._onPointerDownUp
              },
              l = h()("PSPDFKit-Annotation", "PSPDFKit-Comment-Marker-Annotation", r && !this.props.isDisabled && "PSPDFKit-Annotation-Selected", r && !this.props.isDisabled && "PSPDFKit-Comment-Marker-Annotation-Selected", Te().annotation);
            return d.createElement(Ee, {
              position: e.boundingBox.getLocation(),
              zoomLevel: t,
              currentPagesRotation: n,
              noRotate: !0,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(we.Z, (0, ce.Z)({}, s, {
              onClick: this._handleClick,
              disabled: this.props.isDisabled,
              style: {
                width: i,
                height: a,
                transformOrigin: "top left",
                transform: `translate(${i * t / 2 - i / 2}px, ${a * t / 2 - a / 2}px)`
              },
              className: l,
              "data-annotation-id": e.id,
              "aria-controls": `CommentThread-${e.id}`,
              "aria-label": `${o(ke.Z.annotation)}: ${o(ke.Z.comment)}`,
              tabIndex: -1
            }), d.createElement(Ae.Z, {
              style: {
                width: 20,
                height: 20
              },
              className: h()(Te().icon, r && Te().iconActive),
              type: "comment-indicator"
            })));
          }
        }
        const Ie = (0, xe.XN)(Oe, {
          forwardRef: !0
        });
        var Fe,
          Me = n(56573),
          Re = n(2877),
          je = n(53261),
          Be = n(29911),
          Ne = n(10983),
          Le = n(66361),
          Ve = n.n(Le),
          Ke = n(43069),
          qe = n(5705),
          He = n(82197),
          Ue = n(11471),
          Ze = n.n(Ue);
        function $e(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ge(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? $e(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $e(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class We extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "isAlive", !0), (0, o.Z)(this, "_shouldShowIndicators", this.props.annotation instanceof _.sK || this.props.annotation instanceof _.R1 || this.props.annotation instanceof _.GI || this.props.annotation instanceof _.Ih || this.props.formField instanceof _.Yo), (0, o.Z)(this, "_imageFetcherRef", e => {
              e && !this._fetchImageComponentInstance && (this._fetchImageComponentInstance = e);
            }), (0, o.Z)(this, "_fetchImageComponentInstance", null), (0, o.Z)(this, "state", {
              loadingState: "LOADING",
              showLoadingIndicator: !1,
              renderedAnnotation: null
            }), (0, o.Z)(this, "_fetchImage", () => {
              const {
                backend: e,
                attachment: t,
                zoomLevel: n,
                isDetachedAnnotation: r
              } = this.props;
              let o = this.props.annotation;
              r && (o = o.update("boundingBox", e => null == e ? void 0 : e.set("left", 0).set("top", 0)));
              const i = this._lastZoomLevelUsed < n;
              return this._lastZoomLevelUsed = n, (0, Me.an)({
                backend: e,
                blob: null == t ? void 0 : t.data,
                annotation: o,
                isDetachedAnnotation: Boolean(r),
                zoomLevel: n,
                variant: this.props.variant,
                hasZoomedIn: i
              });
            }), (0, o.Z)(this, "_renderFinished", () => {
              var e, t;
              this.isAlive && (this.props.annotation instanceof _.GI && this.setState({
                renderedAnnotation: this.props.annotation
              }), this._shouldShowIndicators && this.setState({
                loadingState: "LOADED"
              }), null === (e = (t = this.props).onRenderFinished) || void 0 === e || e.call(t));
            }), (0, o.Z)(this, "_showError", () => {
              var e, t;
              this.isAlive && (this.props.annotation instanceof _.GI || this.props.annotation instanceof _.sK || this.props.annotation instanceof _.Ih ? this._shouldShowIndicators && this.setState({
                loadingState: "ERROR"
              }) : null === (e = (t = this.props).onError) || void 0 === e || e.call(t));
            }), (0, o.Z)(this, "_showLoadingIndicator", () => {
              this.isAlive && this._shouldShowIndicators && this.setState(e => ({
                showLoadingIndicator: "LOADING" === e.loadingState
              }));
            });
          }
          componentDidUpdate(e) {
            !this.props.isDragging && this.isAlive && Qe(e, this.props) && (this._fetchImageComponentInstance && this.props.annotation.rotation !== e.annotation.rotation ? this._fetchImageComponentInstance.refreshSkippingThrottle() : this._fetchImageComponentInstance && this._fetchImageComponentInstance.refresh());
          }
          componentDidMount() {
            this._shouldShowIndicators && setTimeout(this._showLoadingIndicator, Ne.rB);
          }
          componentWillUnmount() {
            this.isAlive = !1;
            const {
              annotation: e,
              backend: t
            } = this.props;
            "imageAttachmentId" in e && e.imageAttachmentId && (t.attachmentsCache = t.attachmentsCache.delete((0, Me.UW)(e)));
          }
          render() {
            var e;
            const {
                annotation: t,
                attachment: n,
                formField: r,
                label: o,
                zoomLevel: a
              } = this.props,
              s = t instanceof _.GI && (null === (e = this.state.renderedAnnotation) || void 0 === e ? void 0 : e.opacity) !== t.opacity,
              l = Ge(Ge(Ge({}, Ye), function (e) {
                let {
                  annotation: t,
                  attachment: n,
                  zoomLevel: r
                } = e;
                if (t instanceof _.x_) {
                  return Ge({
                    position: "absolute",
                    top: 0
                  }, 90 === (0, He.Lv)(t.rotation) || 270 === (0, He.Lv)(t.rotation) ? {
                    width: t.boundingBox.width * r,
                    height: t.boundingBox.height * r
                  } : null);
                }
                if (t instanceof _.R1) return {
                  position: "absolute",
                  top: 0
                };
                if (t instanceof _.UX || t instanceof _.Zc) return {
                  padding: De.Ni ? Ne.wK : Ne.XZ
                };
                if (t instanceof _.GI && (0, qe.kv)(t)) {
                  const e = (0, qe.h4)(t),
                    n = (t.boundingBox.width - e.boundingBox.width) / 2 * r,
                    o = (t.boundingBox.height - e.boundingBox.height) / 2 * r;
                  return {
                    transformOrigin: "50% 50%",
                    transform: `translate(${-n}px, ${-o}px) rotate(${String(t.rotation)}deg)`,
                    width: t.boundingBox.width * r,
                    height: t.boundingBox.height * r
                  };
                }
                if (t instanceof _.gd && (0, qe.kv)(t)) {
                  const e = (0, qe.h4)(t),
                    n = (t.boundingBox.width - e.boundingBox.width) / 2 * r,
                    o = (t.boundingBox.height - e.boundingBox.height) / 2 * r;
                  return {
                    transformOrigin: "50% 50%",
                    transform: `translate(${-n}px, ${-o}px) rotate(${String(t.rotation)}deg)`,
                    width: t.boundingBox.width * r,
                    height: t.boundingBox.height * r
                  };
                }
                if (t instanceof _.sK && n && t.opacity < 1) return {
                  opacity: t.opacity
                };
                if (t instanceof _.R1 || t instanceof _.gd || t instanceof _.On || t instanceof _.Qi || t instanceof _.Ih || t instanceof _.sK || t instanceof _.GI) return {};
                (0, u.Rz)(t.constructor);
              }({
                annotation: this.state.renderedAnnotation || t,
                attachment: n,
                zoomLevel: a
              })), s ? {
                opacity: t.opacity
              } : null),
              c = h()(Ze().wrapper, "PSPDFKit-APStream-Wrapper", {
                [Ze().loading]: this._shouldShowIndicators && "LOADING" === this.state.loadingState && this.state.showLoadingIndicator,
                [Ze().error]: this._shouldShowIndicators && "ERROR" === this.state.loadingState
              }),
              p = h()(t instanceof _.GI && Ze().stampAnnotation, t instanceof _.x_ && Ze().widgetAnnotation, "PSPDFKit-APStream"),
              f = t instanceof _.GI || t instanceof _.sK || t instanceof _.Ih || t instanceof _.x_ && r instanceof _.Yo ? null : 0;
            return d.createElement("figure", {
              style: l,
              className: c,
              "data-name": null == r ? void 0 : r.name
            }, d.createElement(Re.Z, {
              className: p,
              fetchImage: this._fetchImage,
              label: o,
              visible: !0,
              onRenderFinished: this._renderFinished,
              onError: this._showError,
              throttleTimeout: f,
              rectStyle: Xe,
              ref: this._imageFetcherRef
            }), "description" in t && t.description && d.createElement(i.TX, {
              tag: "figcaption"
            }, t.description), this._shouldShowIndicators && "LOADING" === this.state.loadingState && this.state.showLoadingIndicator ? d.createElement("div", {
              className: Ze().placeholder
            }, Fe || (Fe = d.createElement(Be.Z, null))) : this._shouldShowIndicators && "ERROR" === this.state.loadingState ? d.createElement("div", {
              className: Ze().placeholder
            }, d.createElement(je.Z, {
              src: Ve(),
              className: Ze().errorIcon
            })) : null);
          }
        }
        const Ye = {
            position: "relative",
            overflow: "hidden",
            margin: 0,
            pointerEvents: "none",
            width: "100%",
            height: "100%"
          },
          Xe = {
            pointerEvents: "none",
            width: "100%",
            height: "100%"
          };
        function Qe(e, t) {
          return function (e, t) {
            return !(0, j.ix)(t.annotation, t.zoomLevel) && t.zoomLevel > e.zoomLevel;
          }(e, t) || (0, j.AC)(e.annotation, t.annotation) || (0, j.TL)(e.formField, t.formField) || t.formField && e.formField && t.formField.formattedValue !== e.formField.formattedValue || !(0, Ke.BT)(t.formField, e.formField) || e.variant !== t.variant || e.isDigitallySigned !== t.isDigitallySigned || "number" == typeof e.annotation.pdfObjectId && "number" == typeof t.annotation.pdfObjectId && e.annotation.pdfObjectId !== t.annotation.pdfObjectId;
        }
        var Je = n(59140),
          et = n(74038),
          tt = n.n(et);
        class nt extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "el", null), (0, o.Z)(this, "_innerRef", e => {
              this.el = e;
            }), (0, o.Z)(this, "_handlePointerDown", e => {
              e.isPrimary && this.props.isSelectable && this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null);
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0
              }));
            }), (0, o.Z)(this, "_handleClick", e => {
              "keypress" === e.type && this._handlePress(e, null);
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              e.stopPropagation();
            });
          }
          render() {
            const {
                annotation: e,
                attachment: t,
                backend: n,
                onRenderFinished: r,
                zoomLevel: o,
                isSelectable: i,
                isDisabled: a,
                isDragging: s,
                intl: {
                  formatMessage: l
                }
              } = this.props,
              {
                boundingBox: u,
                id: c
              } = e,
              p = {
                cursor: (0, j.B7)(e, {
                  isSelectable: i
                }),
                overflow: "hidden",
                width: u.width * o,
                height: u.height * o,
                display: "block",
                outline: this.props.isFocused ? j.A8 : null
              };
            return d.createElement(le.Reparent, {
              id: `annotation-image-${c}`
            }, d.createElement(Ee, {
              position: u.getLocation(),
              zoomLevel: o,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp,
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(e.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(e.id));
              }
            }, d.createElement(we.Z, {
              disabled: a,
              onPointerDown: this._handlePointerDown,
              onClick: this._handleClick,
              style: p,
              className: h()("PSPDFKit-Annotation PSPDFKit-Image-Annotation", {
                [tt().readOnlyOutline]: e.readOnly || e.locked
              }),
              "data-annotation-id": e.id,
              "aria-label": `${l(ke.Z.annotation)}: ${l(ke.Z.imageAnnotation)}`,
              innerRef: this._innerRef,
              tabIndex: -1
            }, d.createElement(We, {
              annotation: e,
              attachment: t,
              backend: n,
              onRenderFinished: r,
              zoomLevel: o,
              label: l(ke.Z.imageAnnotation),
              isDragging: s,
              onError: this.props.onError
            })))));
          }
        }
        const rt = (0, xe.XN)(nt, {
          forwardRef: !0
        });
        var ot = n(55441),
          it = n(87996),
          at = n(89407),
          st = n.n(at);
        function lt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ut(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? lt(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class ct extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "precision", (0, ot.HB)(this.props.zoomLevel)), (0, o.Z)(this, "_handlePointerDown", e => {
              e.persist(), e.isPrimary && (e.preventDefault(), this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null));
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              this.precision = (0, ot.HB)(this.props.zoomLevel), this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0
              }));
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              e.stopPropagation();
            }), (0, o.Z)(this, "el", null);
          }
          render() {
            const {
                annotation: e,
                intl: {
                  formatMessage: t
                },
                isSelectable: n,
                pathDataFromFragments: r,
                backend: o,
                zoomLevel: i,
                isDragging: a = !1,
                shouldKeepRenderingAPStream: s = !1
              } = this.props,
              {
                boundingBox: l,
                blendMode: u
              } = e,
              c = l.grow(De.Ni ? Ne.wK : Ne.XZ),
              p = (0, j.B7)(e, {
                isSelectable: n
              }),
              f = ut(ut({}, c.toJS()), {}, {
                cursor: p
              }),
              m = u && "normal" !== u ? ut({
                mixBlendMode: (0, j.vk)(u)
              }, De.G6 ? {
                transform: "translate3d(0,0,0)"
              } : null) : {};
            return d.createElement("div", {
              style: m
            }, d.createElement(Ee, {
              zoomLevel: this.props.zoomLevel,
              applyZoom: !0,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(Je.Z, {
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(e.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(e.id));
              }
            }, d.createElement(we.Z, {
              disabled: this.props.isDisabled,
              onPointerUp: s ? this._handlePointerUp : void 0,
              className: h()(st().container, {
                [st().cursorNotAllowed]: e.readOnly || e.locked
              }, "PSPDFKit-Ink-Annotation PSPDFKit-Annotation"),
              style: f,
              "data-annotation-id": e.id,
              "aria-label": `${t(ke.Z.annotation)}: ${t(ke.Z.inkAnnotation)}`,
              tabIndex: -1
            }, d.createElement(pt, {
              annotation: e,
              onPointerDown: this._handlePointerDown,
              isSelectable: this.props.isSelectable,
              viewBox: c,
              pathDataFromFragments: r,
              renderInvisibleClickPath: s,
              precision: this.precision
            }), s && o && d.createElement(le.Reparent, {
              id: `annotation-ink-${e.id}`
            }, d.createElement(We, {
              annotation: e,
              backend: o,
              zoomLevel: i,
              label: t(ke.Z.inkAnnotation),
              isDragging: a,
              onError: this.props.onError
            }))))));
          }
        }
        const dt = (0, xe.XN)(ct, {
            forwardRef: !0
          }),
          pt = function (e) {
            let {
              annotation: t,
              isSelectable: n,
              viewBox: r,
              pathDataFromFragments: o = () => null,
              onPointerDown: i,
              renderInvisibleClickPath: a = !1,
              precision: l = (0, ot.HB)(1)
            } = e;
            const {
                ENABLE_INK_SMOOTH_LINES: u
              } = it.Options,
              c = d.useMemo(() => u ? e => (0, ot.vR)(e, l) : ot.$U, [l, u]),
              p = d.useRef([]),
              f = d.useCallback((e, n, r) => o(t.id, n, r) || (0, ot.IQ)(e).map(c).flat(), [o, c, t]);
            p.current = d.useMemo(() => {
              t.lines.size !== p.current.length && (p.current = []);
              const e = [];
              return t.lines.forEach(function () {
                let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, s.aV)(),
                  n = arguments.length > 1 ? arguments[1] : void 0;
                e.push(f(t, n, p.current[n]));
              }), e;
            }, [t, f]);
            const m = d.useMemo(() => {
                const {
                    strokeColor: e,
                    lineWidth: r,
                    lines: o
                  } = t,
                  s = {
                    stroke: (null == e ? void 0 : e.toCSSValue()) || "transparent",
                    strokeWidth: r,
                    pointerEvents: "none"
                  },
                  l = {
                    strokeWidth: n ? Math.max(De.Ni ? Ne.wK : Ne.XZ, r) : 0
                  },
                  c = h()({
                    [st().path]: !0,
                    [st().selectable]: !t.readOnly && !t.locked,
                    "PSPDFKit-Smooth-Lines": u
                  }),
                  f = o.map((e, t) => {
                    const r = (0, ot.u8)(p.current[t]);
                    return d.createElement("g", {
                      key: t
                    }, !a && d.createElement("path", {
                      className: c,
                      style: s,
                      d: r,
                      "data-testid": "ink-path"
                    }), n && d.createElement("path", {
                      onPointerDown: i,
                      className: c,
                      style: l,
                      stroke: "transparent",
                      d: r,
                      "data-testid": "clickable-path"
                    }));
                  });
                return d.createElement("g", null, f);
              }, [t, n, i, u, a]),
              g = d.useMemo(() => {
                const {
                    backgroundColor: e,
                    boundingBox: n
                  } = t,
                  r = h()({
                    [st().rect]: !0,
                    [st().selectable]: !!e
                  }),
                  o = {
                    fill: (null == e ? void 0 : e.toCSSValue()) || "transparent"
                  },
                  {
                    width: a,
                    height: s,
                    top: l,
                    left: u
                  } = n;
                return d.createElement("rect", {
                  onPointerDown: i,
                  x: u,
                  y: l,
                  width: a,
                  height: s,
                  className: r,
                  style: o
                });
              }, [i, t, a]),
              v = `${r.left} ${r.top} ${r.width} ${r.height}`,
              y = {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                opacity: t.opacity,
                overflow: "hidden"
              };
            return d.createElement("svg", {
              viewBox: v,
              style: y,
              className: st().svg,
              focusable: !1,
              "data-testid": "ink-svg"
            }, g, m);
          };
        var ht = n(18661),
          ft = n.n(ht),
          mt = n(96706);
        const gt = d.memo(function (e) {
          const {
              annotation: t,
              isDisabled: n,
              annotation: {
                boundingBox: r
              },
              zoomLevel: o,
              isFocused: i,
              shouldKeepRenderingAPStream: a,
              dispatch: s,
              backend: l,
              isDragging: c = !1,
              isMultiAnnotationsSelected: p = !1
            } = e,
            {
              formatMessage: f
            } = (0, xe.YB)(),
            m = (0, d.useRef)(null),
            g = h()(ft().annotationRect, "PSPDFKit-Link-Annotation", "PSPDFKit-Annotation"),
            {
              borderColor: v,
              borderStyle: y,
              borderWidth: b,
              opacity: w
            } = t,
            x = {
              width: r.width * o,
              height: r.height * o,
              outline: i ? j.A8 : null
            },
            D = (0, j.B7)(t),
            C = {
              width: r.width * o,
              height: r.height * o,
              borderWidth: b || 0,
              borderColor: v ? v.toCSSValue() : "transparent",
              borderStyle: y || void 0,
              opacity: w,
              cursor: D
            },
            S = d.useMemo(() => function (e) {
              var t;
              switch ((null === (t = e.action) || void 0 === t ? void 0 : t.constructor) || null) {
                case mt.lm:
                  {
                    const t = e.action;
                    return (0, u.kG)("string" == typeof t.uri, "URIAction requires `uri`"), {
                      type: "a",
                      props: {
                        href: t.uri,
                        "aria-label": t.uri,
                        title: e.note
                      }
                    };
                  }
                case mt.Di:
                  {
                    const t = e.action;
                    (0, u.kG)("number" == typeof t.pageIndex, "GoToAction requires `pageIndex`");
                    const n = `#page=${t.pageIndex}`;
                    return {
                      type: "a",
                      props: {
                        href: n,
                        "aria-label": n,
                        title: e.note
                      }
                    };
                  }
                case mt.BO:
                  {
                    const t = e.action;
                    return (0, u.kG)("boolean" == typeof t.includeExclude, "ResetFormAction requires `includeExclude`"), {
                      type: "button",
                      props: {
                        type: "reset",
                        "aria-label": `Reset${t.fields ? t.fields.join(" ") : ""}`
                      }
                    };
                  }
                case mt.pl:
                  {
                    const t = e.action;
                    return (0, u.kG)("string" == typeof t.uri, "ResetFormAction requires `uri`"), (0, u.kG)("boolean" == typeof t.includeExclude, "ResetFormAction requires `includeExclude`"), {
                      type: "button",
                      props: {
                        type: "submit",
                        "aria-label": `Submit to ${t.uri}`
                      }
                    };
                  }
                default:
                  return {
                    type: "div",
                    props: {}
                  };
              }
            }(t), [t]);
          return d.createElement(Ee, {
            position: r.getLocation(),
            zoomLevel: o,
            disablePointerEvents: !0,
            isMultiAnnotationsSelected: p
          }, d.createElement(we.Z, {
            disabled: n,
            className: h()(`PSPDFKit-${t.constructor.readableName}-Annotation PSPDFKit-Annotation`),
            style: x,
            onPointerUp: a ? function (e) {
              e.stopPropagation();
            } : void 0,
            "data-annotation-id": t.id,
            "aria-label": f(ke.Z.linkAnnotation),
            innerRef: m,
            onMouseEnter: () => {
              s((0, _e.oX)(t.id));
            },
            onMouseLeave: () => {
              s((0, _e.IP)(t.id));
            },
            tabIndex: -1
          }, d.createElement(S.type, (0, ce.Z)({}, S.props, {
            className: g,
            style: C,
            "data-annotation-id": t.id,
            tabIndex: n ? -1 : 0,
            "aria-disabled": n ? "true" : "false"
          })), a && l && d.createElement(le.Reparent, {
            id: `annotation-link-${t.id}`
          }, d.createElement(We, {
            annotation: t,
            backend: l,
            zoomLevel: o,
            label: f(ke.Z.linkAnnotation),
            isDragging: c,
            onError: e.onError
          }))));
        });
        const vt = gt;
        var yt = n(4087),
          bt = n(59062),
          wt = n(64131),
          xt = n.n(wt);
        class Dt extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "el", null), (0, o.Z)(this, "_innerRef", e => {
              this.el = e;
            }), (0, o.Z)(this, "onClick", () => {
              this.props.dispatch((0, yt.i0)()), window.setTimeout(() => {
                this.props.dispatch((0, _e.VR)(this.props.annotation.id));
              }, 0);
            }), (0, o.Z)(this, "_onPointerDownUp", e => {
              e.isPrimary && (this.props.isReadOnly || e.preventDefault(), this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null), this.props.isOpen || this.props.dispatch((0, _e.IP)(this.props.annotation.id)), e.stopPropagation());
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0,
                ignoreReadOnly: !0
              }));
            }), (0, o.Z)(this, "_handleClick", e => {
              "keypress" === e.type && this._handlePress(e, null);
            }), (0, o.Z)(this, "_onMouseEnter", () => {
              this.props.dispatch((0, _e.oX)(this.props.annotation.id));
            }), (0, o.Z)(this, "_onMouseLeave", () => {
              this.props.dispatch((0, _e.IP)(this.props.annotation.id));
            });
          }
          render() {
            const {
                intl: {
                  formatMessage: e
                },
                backend: t,
                shouldKeepRenderingAPStream: r,
                isFocused: o,
                isSelectable: a
              } = this.props,
              s = !this.props.isOpen && !this.props.isFullscreen && !De.Ni,
              {
                annotation: l,
                zoomLevel: u,
                rotation: c
              } = this.props,
              {
                boundingBox: p,
                color: f,
                icon: m
              } = l,
              {
                width: g,
                height: v
              } = p,
              y = (0, j.B7)(l, {
                isSelectable: a
              }),
              b = {
                width: g,
                height: v,
                transformOrigin: "top left",
                transform: `translate(${g * u / 2 - g / 2}px, ${v * u / 2 - v / 2}px)`,
                color: f.toCSSValue(),
                opacity: l.opacity,
                outline: o ? j.A8 : null,
                cursor: y
              },
              w = bt.Y4[m] || bt.Y4[bt.Zi.COMMENT],
              x = (0, F.Oe)(w);
            let D;
            try {
              D = n(36403)(`./${w}.svg`);
            } catch (e) {}
            const C = this.props.isReadOnly ? {
                onPointerUp: this._onPointerDownUp
              } : {
                onPointerDown: this._onPointerDownUp
              },
              S = h()({
                "PSPDFKit-Annotation": !0,
                "PSPDFKit-Note-Annotation": !0,
                [`PSPDFKit-Note-Annotation-Icon-${x}`]: !0,
                [xt().annotation]: !0,
                [xt().noteIconInPage]: !0
              });
            return d.createElement(d.Fragment, null, d.createElement(Ee, {
              position: p.getLocation(),
              zoomLevel: u,
              currentPagesRotation: c,
              noRotate: !0,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(we.Z, (0, ce.Z)({}, C, {
              onClick: this._handleClick,
              disabled: this.props.isDisabled,
              style: b,
              className: S,
              onPointerEnter: s ? this._onMouseEnter : void 0,
              onPointerLeave: s ? this._onMouseLeave : void 0,
              "data-annotation-id": l.id,
              "aria-label": `${e(ke.Z.annotation)}: ${e(ke.Z.noteAnnotation)}`,
              "aria-controls": `NoteAnnotationContent-${l.id}`,
              innerRef: this._innerRef,
              tabIndex: -1
            }), r ? d.createElement(le.Reparent, {
              id: `annotation-note-${l.id}`
            }, d.createElement(We, {
              annotation: l,
              zoomLevel: u,
              backend: t,
              label: e(ke.Z.noteAnnotation),
              onError: this.props.onError
            })) : D ? d.createElement(je.Z, {
              src: D,
              className: xt().icon,
              role: "presentation"
            }) : w)), !this.props.isOpen && d.createElement(i.TX, {
              id: `NoteAnnotationContent-${l.id}`
            }));
          }
        }
        const Ct = (0, xe.XN)(Dt, {
          forwardRef: !0
        });
        const St = (0, l.$j)(function (e, t) {
            let {
              annotation: n
            } = t;
            return {
              annotation: n,
              isFullscreen: e.viewportState.viewportRect.width <= Ne.D4,
              rotation: e.viewportState.pagesRotation,
              isOpen: e.selectedAnnotationIds.has(n.id) && "number" == typeof n.pageIndex
            };
          }, null, null, {
            forwardRef: !0
          })(Ct),
          Et = St;
        var _t = n(34997),
          Pt = n(12559);
        function kt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function At(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? kt(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const zt = e => {
          let {
            lineCap: t,
            style: n,
            id: r,
            position: o,
            strokeWidth: i,
            capAtMaxStroke: a = !1
          } = e;
          const {
            markerScale: s,
            strokeScale: l
          } = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
            const n = 5;
            if (e < L.Rv) return {
              markerScale: 25 - (e - 1) * n,
              strokeScale: 1 / (L.Rv - e)
            };
            if (t && e > L.RR - 2) return {
              markerScale: n,
              strokeScale: L.RR
            };
            return {
              markerScale: n,
              strokeScale: 1
            };
          }(i, a);
          return d.createElement("marker", {
            id: r,
            style: n,
            markerWidth: s,
            markerHeight: s,
            refX: "start" === o ? 3.75 : .5,
            refY: "2",
            orient: "auto",
            viewBox: "0 0 5 5"
          }, Pt.O[t][`${o}Element`](At(At({}, n), {}, {
            strokeWidth: l
          })));
        };
        var Tt = n(99721),
          Ot = n.n(Tt);
        const It = e => {
            let {
              isSelectable: t,
              onPointerDown: n,
              annotation: {
                strokeDashArray: r,
                strokeColor: o,
                strokeWidth: i,
                startPoint: a,
                endPoint: l,
                lineCaps: u,
                fillColor: c,
                pageIndex: p,
                id: f = (0, _t.SK)(),
                locked: m,
                readOnly: g
              },
              renderInvisibleClickPath: v = !1
            } = e;
            if (null === p || 0 === i && !v) return null;
            const y = {
                stroke: (null == o ? void 0 : o.toCSSValue()) || "transparent",
                strokeWidth: i,
                fill: "transparent"
              },
              b = h()({
                [Ot().visible]: !0
              }),
              w = t ? De.Ni ? Math.max(Ne.wK, i) : Math.max(Ne.XZ, i) : 0,
              x = h()({
                [Ot().selectable]: !g && !m
              }),
              D = {
                stroke: (null == o ? void 0 : o.toCSSValue()) || "transparent",
                pointerEvents: "none",
                fill: (null == c ? void 0 : c.toCSSValue()) || "transparent",
                strokeWidth: 1
              },
              C = `${f}-StartLineCap`,
              S = `${f}-EndLineCap`,
              E = (0, L.CW)((0, s.aV)([a, l]), i, u || {}),
              _ = E.first(),
              P = E.get(1),
              k = {
                x1: void 0 !== _ ? _.x : a.x,
                y1: void 0 !== _ ? _.y : a.y,
                x2: void 0 !== P ? P.x : l.x,
                y2: void 0 !== P ? P.y : l.y
              },
              A = k.x1 !== a.x || k.y1 !== a.y,
              z = k.x2 !== l.x || k.y2 !== l.y,
              T = u && A ? `url(#${C})` : void 0,
              O = u && z ? `url(#${S})` : void 0;
            return d.createElement("g", {
              style: {
                strokeWidth: i
              }
            }, (A || z) && d.createElement("defs", null, u && A && u.start && d.createElement(zt, {
              style: D,
              lineCap: u.start,
              id: C,
              strokeWidth: i,
              position: "start"
            }), u && z && u.end && d.createElement(zt, {
              style: D,
              lineCap: u.end,
              id: S,
              strokeWidth: i,
              position: "end"
            })), !v && d.createElement("line", {
              className: b,
              style: y,
              x1: k.x1,
              y1: k.y1,
              x2: k.x2,
              y2: k.y2,
              strokeDasharray: r ? r.map(e => e * i).join(",") : "",
              markerStart: T,
              markerEnd: O,
              strokeLinecap: "butt"
            }), t && d.createElement("line", {
              onPointerDown: n,
              className: x,
              stroke: "transparent",
              style: {
                fill: "none",
                strokeWidth: w
              },
              x1: a.x,
              y1: a.y,
              x2: l.x,
              y2: l.y
            }));
          },
          Ft = e => {
            let {
              isSelectable: t,
              onPointerDown: n,
              annotation: r,
              renderInvisibleClickPath: o = !1
            } = e;
            const {
                strokeDashArray: i,
                strokeColor: a,
                strokeWidth: s,
                fillColor: l,
                pageIndex: u,
                boundingBox: c,
                cloudyBorderIntensity: p,
                cloudyBorderInset: f
              } = r,
              m = Number(p);
            if (null === u || 0 === s && !l && !o) return null;
            const {
                width: g,
                height: v,
                top: y,
                left: b
              } = c,
              w = {
                stroke: (null == a ? void 0 : a.toCSSValue()) || "transparent",
                strokeWidth: s,
                fill: (null == l ? void 0 : l.toCSSValue()) || "transparent"
              },
              x = h()({
                [Ot().visible]: !0,
                [Ot().cloudy]: !!m,
                [Ot().strokeDashArray]: !!i
              }),
              D = t ? De.Ni ? Math.max(Ne.wK, s) : Math.max(Ne.XZ, s) : 0,
              C = {
                fill: l && !l.equals(_.Il.TRANSPARENT) ? "transparent" : "none",
                strokeWidth: D
              },
              S = h()({
                [Ot().selectable]: !r.readOnly && !r.locked,
                [Ot().cloudy]: !!m
              }),
              E = g > s ? g - s : g / 4,
              P = v > s ? v - s : v / 4,
              k = i ? i.map(e => e * s).join(",") : "",
              A = m > 0,
              z = A ? Mt(m, f, c) : "";
            return d.createElement(d.Fragment, null, !o && (A ? d.createElement("path", {
              d: z,
              className: x,
              style: w,
              strokeDasharray: k
            }) : d.createElement("rect", {
              className: x,
              style: w,
              strokeDasharray: k,
              x: b + s / 2,
              y: y + s / 2,
              width: E,
              height: P
            })), t && (A ? d.createElement("path", {
              onPointerDown: n,
              d: z,
              className: S,
              style: C,
              stroke: "transparent"
            }) : d.createElement("rect", {
              onPointerDown: n,
              className: S,
              stroke: "transparent",
              style: C,
              x: b + s / 2,
              y: y + s / 2,
              width: E,
              height: P
            })));
          },
          Mt = (e, t, n) => {
            const {
              left: r,
              top: o,
              width: i,
              height: a
            } = t instanceof _.eB ? _.eB.applyToRect(t, n) : n;
            return (0, L.rr)({
              points: [[r, o], [r + i, o], [r + i, o + a], [r, o + a]],
              intensity: e
            });
          },
          Rt = e => {
            let {
              isSelectable: t,
              onPointerDown: n,
              annotation: r,
              renderInvisibleClickPath: o = !1
            } = e;
            const {
                strokeDashArray: i,
                strokeColor: a,
                strokeWidth: s,
                fillColor: l,
                pageIndex: u,
                boundingBox: c,
                cloudyBorderIntensity: p,
                cloudyBorderInset: f
              } = r,
              m = Number(p);
            if (null === u || 0 === s && !l && !o) return null;
            const {
                width: g,
                height: v,
                top: y,
                left: b
              } = c,
              w = {
                stroke: (null == a ? void 0 : a.toCSSValue()) || "transparent",
                strokeWidth: s,
                fill: (null == l ? void 0 : l.toCSSValue()) || "transparent"
              },
              x = h()({
                [Ot().visible]: !0,
                [Ot().cloudy]: !!m,
                [Ot().strokeDashArray]: !!i
              }),
              D = t ? De.Ni ? Math.max(Ne.wK, s) : Math.max(Ne.XZ, s) : 0,
              C = {
                fill: l && !l.equals(_.Il.TRANSPARENT) ? "transparent" : "none",
                strokeWidth: D
              },
              S = h()({
                [Ot().selectable]: !r.readOnly && !r.locked,
                [Ot().cloudy]: !!m
              }),
              E = g > 2 * s ? (g - s) / 2 : g / 4,
              P = v > 2 * s ? (v - s) / 2 : v / 4,
              k = i ? i.map(e => e * s).join(",") : "",
              A = m > 0,
              z = A ? (0, L.Hz)({
                boundingBox: c,
                cloudyBorderIntensity: m,
                cloudyBorderInset: f
              }) : "";
            return d.createElement(d.Fragment, null, !o && (A ? d.createElement("path", {
              className: x,
              style: w,
              strokeDasharray: k,
              d: z
            }) : d.createElement("ellipse", {
              className: x,
              style: w,
              strokeDasharray: k,
              cx: b + g / 2,
              cy: y + v / 2,
              rx: E,
              ry: P
            })), t && (A ? d.createElement("path", {
              onPointerDown: n,
              className: S,
              style: C,
              d: z,
              stroke: "transparent"
            }) : d.createElement("ellipse", {
              onPointerDown: n,
              className: S,
              stroke: "transparent",
              style: C,
              cx: b + g / 2,
              cy: y + v / 2,
              rx: E,
              ry: P
            })));
          },
          jt = e => {
            let {
              isSelectable: t,
              onPointerDown: n,
              annotation: r,
              renderInvisibleClickPath: o = !1
            } = e;
            const {
                strokeDashArray: i,
                strokeColor: a,
                strokeWidth: s,
                fillColor: l,
                pageIndex: u,
                points: c,
                cloudyBorderIntensity: p
              } = r,
              f = Number(p);
            if (null === u || 0 === c.size || 0 === s && (!l || l.equals(_.Il.TRANSPARENT)) && !o) return null;
            const m = {
                stroke: a ? a.toCSSValue() : "transparent",
                strokeWidth: s,
                fill: (null == l ? void 0 : l.toCSSValue()) || "transparent"
              },
              g = h()({
                [Ot().visible]: !0,
                [Ot().cloudy]: !!f,
                [Ot().strokeDashArray]: !!i
              }),
              v = t ? De.Ni ? Math.max(Ne.wK, s) : Math.max(Ne.XZ, s) : 0,
              y = {
                fill: l && !l.equals(_.Il.TRANSPARENT) ? "transparent" : "none",
                strokeWidth: v
              },
              b = h()({
                [Ot().selectable]: !r.readOnly && !r.locked,
                [Ot().cloudy]: !!f
              }),
              w = c.first();
            if (void 0 === w) return null;
            const x = 1 === c.size || 2 === c.size ? c.push(w) : c,
              D = i ? i.map(e => e * s).join(",") : "",
              C = f > 0 && x.size > 2,
              S = C ? Bt({
                annotation: r,
                intensity: f
              }) : `${x.map(e => `${e.x},${e.y}`).join(" ")}`;
            return d.createElement(d.Fragment, null, !o && (C ? d.createElement("path", {
              className: g,
              style: m,
              strokeDasharray: D,
              d: S
            }) : d.createElement("polygon", {
              className: g,
              style: m,
              strokeDasharray: D,
              points: S
            })), t && (C ? d.createElement("path", {
              onPointerDown: n,
              className: b,
              style: y,
              stroke: "transparent",
              d: S
            }) : d.createElement("polygon", {
              onPointerDown: n,
              className: b,
              stroke: "transparent",
              style: y,
              points: S
            })));
          },
          Bt = e => {
            let {
              intensity: t,
              annotation: n
            } = e;
            return (0, L.rr)({
              points: n.points.map(e => [e.x, e.y]).toArray(),
              intensity: t
            });
          },
          Nt = e => {
            let {
              isSelectable: t,
              onPointerDown: n,
              annotation: {
                strokeDashArray: r,
                strokeColor: o,
                strokeWidth: i,
                lineCaps: a,
                fillColor: s,
                pageIndex: l,
                points: u,
                id: c = (0, _t.SK)(),
                locked: p,
                readOnly: f
              },
              renderInvisibleClickPath: m = !1
            } = e;
            if (null === l || void 0 === u || 0 === u.size || 0 === i && !m) return null;
            const g = u.first(),
              v = u.last();
            if (!g || !v) return null;
            const y = {
                stroke: (null == o ? void 0 : o.toCSSValue()) || "transparent",
                strokeWidth: i,
                fill: "transparent"
              },
              b = h()({
                [Ot().visible]: !0
              }),
              w = t ? De.Ni ? Math.max(Ne.wK, i) : Math.max(Ne.XZ, i) : 0,
              x = h()({
                [Ot().selectable]: !f && !p
              }),
              D = {
                stroke: (null == o ? void 0 : o.toCSSValue()) || "transparent",
                pointerEvents: "none",
                fill: (null == s ? void 0 : s.toCSSValue()) || "transparent",
                strokeWidth: 1
              },
              C = `${c}-StartLineCap`,
              S = `${c}-EndLineCap`,
              E = 1 === u.size ? ` ${g.x},${g.y}` : "",
              _ = (0, L.CW)(u, i, a || {}),
              P = _.first(),
              k = _.last();
            if (!P || !k) return null;
            const A = a && (P.x !== g.x || P.y !== g.y),
              z = a && (k.x !== v.x || k.y !== v.y),
              T = `${_.map(e => `${e.x},${e.y}`).join(" ")}${E}`,
              O = a && A ? `url(#${C})` : void 0,
              I = a && z ? `url(#${S})` : void 0;
            return d.createElement("g", {
              style: {
                strokeWidth: i
              }
            }, (A || z) && d.createElement("defs", null, a && A && a.start && d.createElement(zt, {
              style: D,
              lineCap: a.start,
              strokeWidth: i,
              id: C,
              position: "start"
            }), a && z && a.end && d.createElement(zt, {
              style: D,
              lineCap: a.end,
              strokeWidth: i,
              id: S,
              position: "end"
            })), !m && d.createElement("polyline", {
              className: b,
              style: y,
              points: T,
              strokeDasharray: r ? r.map(e => e * i).join(",") : "",
              markerStart: O,
              markerEnd: I
            }), t && d.createElement("polyline", {
              onPointerDown: n,
              className: x,
              stroke: "transparent",
              style: {
                fill: "none",
                strokeWidth: w
              },
              points: T
            }));
          },
          Lt = e => {
            const {
                annotation: t,
                viewBox: n,
                isSelectable: r,
                onPointerDown: o,
                renderInvisibleClickPath: i = !1
              } = e,
              a = `${n.left} ${n.top} ${n.width} ${n.height}`,
              s = {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%",
                opacity: t.opacity,
                overflow: "hidden"
              },
              l = (e => {
                switch (e) {
                  case _.o9:
                    return It;
                  case _.b3:
                    return Ft;
                  case _.Xs:
                    return Rt;
                  case _.Hi:
                    return jt;
                  case _.om:
                    return Nt;
                  default:
                    throw new Error("Unexpected shape annotation type");
                }
              })(t.constructor);
            return d.createElement("svg", {
              viewBox: a,
              style: s,
              className: Ot().svg,
              focusable: !1
            }, d.createElement(l, {
              isSelectable: r,
              onPointerDown: o,
              annotation: t,
              renderInvisibleClickPath: i
            }));
          };
        var Vt = n(739),
          Kt = n(66327);
        function qt(e, t) {
          return e.distance(t) > Ne.c1;
        }
        var Ht = n(14935),
          Ut = n(24322);
        function Zt(e) {
          const {
              pageIndex: t,
              currentAnnotation: n,
              onAnnotationUpdate: r,
              keepSelectedTool: o,
              interactionMode: i,
              defaultAutoCloseThreshold: a,
              backend: u,
              disablePointSnapping: c
            } = e,
            p = d.useRef(null),
            h = (0, l.v9)(e => e.eventEmitter),
            f = (0, l.I0)(),
            [m, g] = d.useState(!1),
            [v, y] = d.useState(null),
            b = d.useMemo(() => (0, L.sS)(n.constructor), [n.constructor]),
            w = d.useCallback(function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              f((0, yt.FG)(e)), t && (f((0, Kt.Ce)()), f((0, _e.Df)((0, s.l4)([e.id]), null)), f((0, yt.ZE)(e.id)), f((0, Ht.eO)(null)));
            }, [f]),
            x = d.useCallback(() => {
              (n instanceof _.om || n instanceof _.Hi) && w(n, !0);
            }, [n, w]),
            D = d.useCallback((e, o) => {
              var i, a;
              (0, Ut.mE)(u, n, c) && u.configureSnapper(t);
              let l = n;
              const d = {
                annotations: (0, s.aV)([l]),
                reason: J.f.DRAW_START
              };
              h.emit("annotations.willChange", d);
              const m = new _.E9({
                x: e.x,
                y: e.y
              });
              if (l instanceof _.o9) l = l.merge({
                startPoint: m,
                endPoint: m
              });else if (l instanceof _.b3 || l instanceof _.Xs) {
                p.current = m;
                const e = l.cloudyBorderIntensity * Ne.St + l.strokeWidth / 2;
                l = l.merge({
                  boundingBox: new _.UL({
                    left: m.x,
                    top: m.y,
                    width: 0,
                    height: 0
                  }),
                  cloudyBorderInset: l.cloudyBorderIntensity ? l.cloudyBorderInset || _.eB.fromValue(e) : null
                });
              } else if (l instanceof W.Z) {
                p.current = m;
                const e = new _.UL({
                  left: m.x,
                  top: m.y,
                  width: 0,
                  height: 0
                });
                l = l.merge({
                  boundingBox: e,
                  rects: (0, s.aV)([e])
                });
              } else (l instanceof _.Hi || l instanceof _.om) && (l = l.update("points", e => e.push(m)));
              l = l.set("boundingBox", b(l));
              const g = l.pageIndex;
              if (null === g) l = l.set("pageIndex", t);else if (g !== t) {
                l = l.set("pageIndex", t);
                const e = l instanceof W.Z ? yt.hj : yt.hX;
                f(e(l, t));
              }
              l instanceof _.Xs || !("isMeasurement" in l) || null === (i = (a = l).isMeasurement) || void 0 === i || !i.call(a) || f((0, Ht.eO)({
                magnifierLabel: l.getMeasurementDetails().label,
                drawnAnnotationID: l.id,
                drawnAnnotationPageIndex: l.pageIndex,
                magnifierCursorPosition: o
              })), r(l);
            }, [n, f, h, t, r, b]),
            C = d.useCallback(async (e, t) => {
              var o, i;
              let l = n,
                d = e[e.length - 1];
              const h = t[t.length - 1];
              if ((0, Ut.mE)(u, l, c)) {
                const e = await u.getClosestSnapPoint(new _.E9({
                  x: d.x,
                  y: d.y
                }));
                d = d.set("x", e.x).set("y", e.y);
              }
              const x = new _.E9({
                x: d.x,
                y: d.y
              });
              if (l instanceof _.o9) l = l.set("endPoint", x);else if (l instanceof _.b3 || l instanceof _.Xs) {
                (0, Ce.k)(null != p.current);
                const e = p.current,
                  t = new _.UL({
                    left: Math.min(e.x, x.x),
                    top: Math.min(e.y, x.y),
                    width: Math.abs(x.x - e.x),
                    height: Math.abs(x.y - e.y)
                  });
                l = l.merge({
                  boundingBox: t
                });
              } else if (l instanceof W.Z) {
                (0, Ce.k)(null != p.current);
                const e = p.current,
                  t = new _.UL({
                    left: Math.min(e.x, x.x),
                    top: Math.min(e.y, x.y),
                    width: Math.abs(x.x - e.x),
                    height: Math.abs(x.y - e.y)
                  });
                l = l.merge({
                  boundingBox: t,
                  rects: (0, s.aV)([t])
                });
              } else if (l instanceof _.Hi || l instanceof _.om) {
                const e = l.points.size - 1;
                if (v && qt(v, x)) g(!1), y(null);else if (!m) {
                  const t = (0, Ut.KM)(l, e, a),
                    n = -1 !== t;
                  l = $t(l, x, n, t), n && (w(l), g(!0), y(l.points.get(e)));
                }
                l.isMeasurement() && "isMeasurement" in l && f((0, Ht.eO)({
                  magnifierLabel: l.getMeasurementDetails().label,
                  drawnAnnotationID: l.id,
                  drawnAnnotationPageIndex: l.pageIndex,
                  magnifierCursorPosition: h
                }));
              }
              l = l.set("boundingBox", b(l)), r(l), l instanceof _.Xs || l instanceof _.om || l instanceof _.Hi || !("isMeasurement" in l) || null === (o = (i = l).isMeasurement) || void 0 === o || !o.call(i) || f((0, Ht.eO)({
                magnifierLabel: l.getMeasurementDetails().label,
                magnifierCursorPosition: t[t.length - 1]
              }));
            }, [n, b, r, v, m, a, w, f]),
            S = d.useCallback(() => {
              var e, t;
              let l = n;
              const {
                  left: u,
                  top: c,
                  width: d,
                  height: p
                } = l.boundingBox,
                m = {
                  annotations: (0, s.aV)([l]),
                  reason: J.f.DRAW_END
                };
              if (h.emit("annotations.willChange", m), l instanceof _.Xs || !("isMeasurement" in l) || null === (e = (t = l).isMeasurement) || void 0 === e || !e.call(t) || f((0, Ht.eO)(null)), l instanceof _.o9) qt(l.startPoint, l.endPoint) ? (f((0, yt.FG)(l)), f((0, Kt.Ce)()), f((0, _e.Df)((0, s.l4)([l.id]), null)), f((0, yt.ZE)(l.id)), o && f((0, Kt.yg)(l.constructor, i))) : (l = l.merge({
                startPoint: new _.E9(),
                endPoint: new _.E9(),
                boundingBox: new _.UL()
              }), r(l));else if (l instanceof _.b3 || l instanceof _.Xs || l instanceof W.Z) {
                if (qt(new _.E9({
                  x: u,
                  y: c
                }), new _.E9({
                  x: u + d,
                  y: c + p
                }))) f((0, yt.FG)(l)), f((0, _e.Df)((0, s.l4)([l.id]), null)), l instanceof W.Z || f((0, Kt.Ce)()), f((0, yt.ZE)(l.id)), l instanceof W.Z && o && f((0, Kt.t)()), o && l instanceof _.UX && f((0, Kt.yg)(l.constructor, i));else {
                  const e = new _.UL();
                  l = l instanceof W.Z ? l.merge({
                    boundingBox: e,
                    rects: (0, s.aV)([e])
                  }) : l.merge({
                    boundingBox: e
                  }), r(l);
                }
              } else if (l instanceof _.Hi || l instanceof _.om) {
                const e = l.points.size - 1,
                  t = (0, Ut.KM)(l, e, a),
                  n = -1 !== t,
                  r = $t(l, l.points.last(), n, t);
                n ? w(r) : f((0, yt.FG)(r));
              } else f((0, yt.FG)(l));
            }, [n, r, f, h, o, i]),
            E = (0, l.v9)(e => (0, G.zi)(e, t)),
            P = d.useCallback(e => e.apply(E), [E]);
          return d.createElement(Vt.Z, {
            size: e.pageSize,
            onDrawStart: D,
            onDrawCoalesced: C,
            onDrawEnd: S,
            transformPoint: P,
            interactionMode: i,
            scrollElement: e.scrollElement,
            onDoubleClick: x,
            currentAnnotation: n,
            defaultAutoCloseThreshold: a,
            dispatch: f
          });
        }
        const $t = function (e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = arguments.length > 3 ? arguments[3] : void 0;
          if (n) {
            var o;
            const t = null === (o = e.get("points")) || void 0 === o ? void 0 : o.get(r);
            return e.update("points", e => e.set(e.size - 1, t));
          }
          return e.update("points", e => e.set(e.size - 1, t));
        };
        function Gt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Wt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Gt(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function Yt(e) {
          return {
            calculateBoundingBox: (0, L.sS)(e.shapeAnnotation.constructor),
            currentShapeAnnotation: e.shapeAnnotation,
            shapeAnnotationFromCurrentProps: e.shapeAnnotation
          };
        }
        class Xt extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", Wt({
              isDrawing: !1
            }, Yt(this.props))), (0, o.Z)(this, "_handleAnnotationUpdate", e => {
              this.setState({
                currentShapeAnnotation: e,
                isDrawing: !0
              });
            });
          }
          static getDerivedStateFromProps(e, t) {
            return (0, s.is)(t.shapeAnnotationFromCurrentProps, e.shapeAnnotation) || (0, s.is)(t.currentShapeAnnotation, e.shapeAnnotation) ? null : Yt(e);
          }
          componentDidMount() {
            this.props.dispatch((0, Kt.X2)());
          }
          componentWillUnmount() {
            this.props.dispatch((0, Kt.Zg)());
          }
          render() {
            const e = this.state.currentShapeAnnotation,
              {
                pageSize: t,
                viewportState: {
                  zoomLevel: n
                }
              } = this.props,
              {
                boundingBox: r
              } = e,
              o = h()({
                [Ot().canvas]: !0
              });
            return d.createElement("div", {
              className: o
            }, d.createElement(Ee, {
              zoomLevel: n,
              applyZoom: !0
            }, e.isMeasurement() && this.state.isDrawing ? d.createElement("div", {
              className: "PSPDFKit-Measurement-Label",
              style: (0, z.KI)(e)
            }, d.createElement(Jt, {
              value: e.getMeasurementDetails().label
            })) : null, d.createElement("div", {
              style: Wt(Wt({}, r.toJS()), {}, {
                position: "absolute"
              })
            }, d.createElement(Lt, {
              isSelectable: !1,
              annotation: e,
              viewBox: r
            }))), d.createElement(Zt, {
              pageSize: t,
              pageIndex: this.props.pageIndex,
              currentAnnotation: e,
              onAnnotationUpdate: this._handleAnnotationUpdate,
              keepSelectedTool: this.props.keepSelectedTool,
              interactionMode: this.props.interactionMode,
              scrollElement: this.props.scrollElement,
              defaultAutoCloseThreshold: this.props.defaultAutoCloseThreshold,
              backend: this.props.backend,
              disablePointSnapping: this.props.disablePointSnapping
            }));
          }
        }
        const Qt = (0, l.$j)((e, t) => {
            let {
              pageIndex: n
            } = t;
            return {
              viewportState: e.viewportState,
              clientToPageTransformation: (0, G.zi)(e, n),
              eventEmitter: e.eventEmitter,
              keepSelectedTool: e.keepSelectedTool,
              interactionMode: e.interactionMode,
              scrollElement: e.scrollElement,
              defaultAutoCloseThreshold: e.defaultAutoCloseThreshold
            };
          })(Xt),
          Jt = e => {
            let {
              value: t,
              isSecondaryMeasurement: n
            } = e;
            if (n && t.includes("/")) {
              const e = t.split("/");
              return d.createElement("span", null, "  (", d.createElement("span", null, e[0], d.createElement(d.Fragment, null, "⁄"), e[1]), ")");
            }
            if (n && !t.includes("/")) return d.createElement("span", null, "  (", d.createElement("span", null, t), ")");
            if (!n && t.includes("/")) {
              const e = t.split("/");
              return d.createElement("span", null, e[0], d.createElement(d.Fragment, null, "⁄"), e[1], ";");
            }
            return d.createElement("span", null, t);
          };
        function en(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function tn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? en(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : en(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class nn extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "handlePointerDown", e => {
              e.isPrimary && this.props.isSelectable && (e.preventDefault(), this.handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null));
            }), (0, o.Z)(this, "handlePress", (e, t) => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0
              }));
            }), (0, o.Z)(this, "handlePointerUp", e => {
              e.stopPropagation();
            }), (0, o.Z)(this, "el", null), (0, o.Z)(this, "innerRef", e => {
              this.el = e;
            });
          }
          render() {
            const {
                annotation: e,
                intl: {
                  formatMessage: t
                },
                zoomLevel: n,
                backend: r,
                isDragging: o,
                shouldKeepRenderingAPStream: i
              } = this.props,
              {
                boundingBox: a
              } = e;
            let s;
            s = !!((0, z.S6)(e) && !e.measurementBBox && (a.width < 100 || a.height < 100) || e.isMeasurement() && !i);
            const l = a.grow(De.Ni ? Ne.wK : Ne.XZ),
              u = l.toJS(),
              c = (0, j.B7)(e),
              p = tn(tn({}, u), {}, {
                cursor: c
              }),
              f = e.constructor.readableName,
              m = f && ke.Z[`${f.charAt(0).toLowerCase() + f.slice(1)}Annotation`],
              g = (0, j.vk)(e.blendMode),
              v = g ? {
                mixBlendMode: g
              } : {},
              y = e.isMeasurement() && this.props.secondaryMeasurementUnit && (0, z.Rw)(e, this.props.secondaryMeasurementUnit);
            return d.createElement(Ee, {
              zoomLevel: n,
              additionalStyle: v,
              applyZoom: !0,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, e.isMeasurement() && s && d.createElement("div", {
              className: "PSPDFKit-Measurement-Label",
              style: (0, z.KI)(e, !!y)
            }, d.createElement(Jt, {
              value: e.getMeasurementDetails().label
            }), y ? d.createElement(Jt, {
              value: y.label,
              isSecondaryMeasurement: !0
            }) : null), d.createElement(Je.Z, {
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(e.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(e.id));
              }
            }, d.createElement(we.Z, {
              disabled: this.props.isDisabled,
              className: h()(Ot().container, `PSPDFKit-${rn(e)}-Annotation`, "PSPDFKit-Shape-Annotation", "PSPDFKit-Annotation", {
                [Ot().cursorNotAllowed]: e.readOnly || e.locked
              }),
              style: p,
              onPointerUp: i ? this.handlePointerUp : void 0,
              "data-annotation-id": e.id,
              "aria-label": `${t(ke.Z.annotation)}${f && m ? `: ${t(m)}` : ""}`,
              innerRef: this.innerRef,
              tabIndex: -1
            }, d.createElement(Lt, {
              annotation: e,
              onPointerDown: this.handlePointerDown,
              isSelectable: this.props.isSelectable,
              viewBox: l,
              renderInvisibleClickPath: i
            }), i && d.createElement(le.Reparent, {
              id: `annotation-shape-${e.id}`
            }, d.createElement(We, {
              annotation: e,
              zoomLevel: n,
              backend: r,
              label: t(f && m ? m : ke.Z.annotation),
              isDragging: o,
              onError: this.props.onError
            })))));
          }
        }
        function rn(e) {
          const t = e.constructor.readableName;
          return e.isMeasurement() ? "Line" === t ? "Distance" : "Polyline" === t ? "Perimeter" : "Polygon" === t ? "Polygon-Area" : "Rectangle" === t ? "Rectangle-Area" : "Ellipse" === t ? "Ellipse-Area" : void 0 : t;
        }
        const on = (0, xe.XN)(nn, {
          forwardRef: !0
        });
        function an(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class sn extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_handlePointerDown", e => {
              e.isPrimary && this.props.isSelectable && this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null);
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0
              }));
            }), (0, o.Z)(this, "_handleClick", e => {
              "keypress" === e.type && this._handlePress(e, null);
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              e.stopPropagation();
            }), (0, o.Z)(this, "el", null), (0, o.Z)(this, "_innerRef", e => {
              this.el = e;
            });
          }
          render() {
            const {
                annotation: e,
                globalAnnotation: t,
                onRenderFinished: n,
                zoomLevel: r,
                backend: i,
                isSelectable: a,
                isDisabled: s,
                isDragging: l,
                isAutoSaveDisabled: u,
                cursor: c,
                intl: {
                  formatMessage: p
                }
              } = this.props,
              {
                boundingBox: f,
                id: m
              } = e,
              g = (0, j.WX)(e, r),
              v = f.width * g,
              y = f.height * g,
              b = function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? an(Object(n), !0).forEach(function (t) {
                    (0, o.Z)(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : an(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                cursor: (0, j.B7)(e, {
                  isSelectable: a,
                  cursor: c
                }),
                overflow: "hidden",
                width: v,
                height: y,
                display: "block"
              }, (0, qe.kv)(e) ? {
                transformOrigin: "50% 50%",
                transform: `rotate(${String(-e.rotation)}deg)`
              } : null),
              w = "STANDALONE" === i.type && "number" != typeof e.pdfObjectId && u,
              x = w ? t.set("id", null) : t;
            return d.createElement(le.Reparent, {
              id: `annotation-stamp-${m}`
            }, d.createElement(Ee, {
              position: f.getLocation(),
              zoomLevel: r,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp,
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(e.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(e.id));
              }
            }, d.createElement(we.Z, {
              disabled: s,
              onPointerDown: this._handlePointerDown,
              onClick: this._handleClick,
              style: b,
              className: h()("PSPDFKit-Annotation PSPDFKit-Stamp-Annotation", {
                [tt().readOnlyOutline]: e.readOnly || e.locked
              }),
              "data-annotation-id": e.id,
              "aria-label": `${p(ke.Z.annotation)}: ${p(ke.Z.stampAnnotation)}`,
              innerRef: this._innerRef,
              tabIndex: -1
            }, d.createElement(We, {
              annotation: x,
              zoomLevel: g,
              backend: i,
              onRenderFinished: n,
              label: p(ke.Z.stampAnnotation),
              isDragging: l,
              isDetachedAnnotation: w,
              onError: this.props.onError
            })))));
          }
        }
        const ln = (0, xe.XN)(sn, {
          forwardRef: !0
        });
        var un = n(27856),
          cn = n.n(un),
          dn = n(30845),
          pn = n(20388),
          hn = n(50647),
          fn = n.n(hn),
          mn = n(45071),
          gn = n(89004);
        function vn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        const yn = d.forwardRef((e, t) => {
          var n;
          let {
            annotation: {
              callout: r,
              borderWidth: i,
              borderStyle: a,
              boundingBox: c,
              borderColor: p,
              id: h,
              backgroundColor: f,
              verticalAlign: m,
              fontSize: g,
              font: v
            },
            annotation: y,
            children: b,
            isEditing: w
          } = e;
          const x = (0, l.I0)(),
            D = d.useRef(null),
            C = (0, l.v9)(e => e.viewportState.zoomLevel);
          (0, u.kG)(r, "CalloutTextComponent: callout is undefined");
          const S = (0, d.useRef)(!0);
          (0, mn.useGranularLayoutEffect)(() => {
            if (S.current) S.current = !1;else {
              var e;
              const t = null === (e = D.current) || void 0 === e ? void 0 : e.getBoundingClientRect();
              if (!t) return;
              const n = (0, gn.Vq)({
                annotation: y,
                rect: t,
                zoomLevel: C,
                callout: y.callout,
                text: y.text
              });
              n && x((0, yt.FG)(y.merge(n)));
            }
          }, [g, v], [y, C]);
          const E = null === (n = r.innerRectInset) || void 0 === n ? void 0 : n.setScale(C),
            P = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? vn(Object(n), !0).forEach(function (t) {
                  (0, o.Z)(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vn(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({
              position: "absolute",
              borderWidth: i || void 0,
              borderStyle: a || void 0,
              borderColor: (null == p ? void 0 : p.toCSSValue()) || void 0,
              backgroundColor: (null == f ? void 0 : f.toCSSValue()) || void 0,
              left: null == E ? void 0 : E.left,
              top: null == E ? void 0 : E.top,
              right: null == E ? void 0 : E.right,
              bottom: null == E ? void 0 : E.bottom,
              padding: "4px 8px 4px 0"
            }, w && {
              right: void 0,
              width: "max-content",
              bottom: void 0,
              height: "auto",
              outline: "1px solid rgba(60, 151, 254, 0.5)",
              outlineOffset: 2
            }),
            k = `${h}-calloutLinecapId`,
            A = c.scale(C),
            z = {
              stroke: (null == p ? void 0 : p.toCSSValue()) || "black",
              pointerEvents: "none",
              strokeWidth: 1,
              fill: "transparent"
            },
            T = (0, s.aV)([r.start, r.knee, r.end].filter(Boolean).map(e => ((0, u.kG)(e, "CalloutTextComponent: point is undefined"), function (e, t, n) {
              return new _.E9({
                x: (e.x - t.left) * n,
                y: (e.y - t.top) * n
              });
            }(e, c, C)))),
            O = (0, L.CW)(T, i || 1, {
              start: r.cap,
              end: null
            }).map(e => `${e.x},${e.y}`).join(" ");
          return d.createElement(d.Fragment, null, d.createElement("svg", {
            style: {
              position: "absolute",
              inset: 0
            },
            width: A.width,
            height: A.height,
            stroke: null == p ? void 0 : p.toCSSValue(),
            viewBox: `0 0 ${A.width} ${A.height}`,
            focusable: !1
          }, d.createElement("g", null, r.cap && d.createElement("defs", null, d.createElement(zt, {
            lineCap: r.cap,
            style: z,
            strokeWidth: i || 1,
            id: k,
            position: "start",
            capAtMaxStroke: !0
          })), d.createElement("polyline", {
            fill: "none",
            points: O,
            stroke: (null == p ? void 0 : p.toCSSValue()) || "black",
            strokeWidth: i || void 0,
            markerStart: `url(#${k})`
          }))), d.createElement("div", {
            style: P,
            ref: t,
            className: "Callout"
          }, d.createElement("div", {
            style: {
              verticalAlign: "center" === m ? "middle" : m,
              display: "inline-block"
            },
            ref: D
          }, b)));
        });
        const bn = ["backgroundColor"];
        function wn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wn(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Dn extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "el", null), (0, o.Z)(this, "_innerRef", e => {
              this.el = e;
            }), (0, o.Z)(this, "memoizedCalculateFittingFontSize", (0, dn.Z)(pn.MF)), (0, o.Z)(this, "onClick", e => {
              if ("function" == typeof this.props.onClick) {
                if (this.props.annotation.lockedContents) return;
                this.props.onClick(e);
              }
              window.setTimeout(() => {
                this.props.dispatch((0, _e.VR)(this.props.annotation.id));
              }, 0);
            }), (0, o.Z)(this, "_handlePointerDown", e => {
              e.isPrimary && this.props.isSelectable && (e.preventDefault(), this._handlePress(e, "touch" !== e.pointerType ? new _.E9({
                x: e.clientX,
                y: e.clientY
              }) : null));
            }), (0, o.Z)(this, "_handlePress", (e, t) => {
              "function" == typeof this.props.onClick || this.props.annotation.locked ? this.onClick(e) : this.props.dispatch((0, _e.mg)(this.props.annotation, e, {
                selectedAnnotationShouldDrag: t,
                stopPropagation: !0
              }));
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              e.stopPropagation();
            });
          }
          render() {
            const {
                annotation: {
                  boundingBox: e
                },
                annotation: t,
                globalAnnotation: n,
                zoomLevel: r,
                isDisabled: o,
                isSelectable: i,
                intl: {
                  formatMessage: a
                },
                backend: s,
                isDragging: l,
                cursor: u,
                shouldKeepRenderingAPStream: c,
                isMultiAnnotationsSelected: p
              } = this.props,
              f = (0, j.WX)(t, r),
              m = (0, j.B7)(t, {
                isSelectable: i,
                cursor: u
              });
            l || (this._lastFittingFontSizeAnnotation = this.memoizedCalculateFittingFontSize(t, f));
            const g = xn(xn({}, (0, pn.z1)(t.isFitting ? this._lastFittingFontSizeAnnotation : t, f, c)), {}, {
                cursor: m
              }, (0, qe.kv)(t) && c ? {
                transformOrigin: "50% 50%",
                transform: `rotate(${String(-t.rotation)}deg)`
              } : null),
              {
                backgroundColor: v
              } = g,
              y = (0, ne.Z)(g, bn),
              b = "xhtml" === t.text.format;
            let w;
            var x, D;
            c || (w = b ? d.createElement("div", {
              dangerouslySetInnerHTML: {
                __html: null === (x = t.text) || void 0 === x ? void 0 : x.value
              }
            }) : cn().sanitize((0, pn.hr)(null === (D = t.text) || void 0 === D ? void 0 : D.value)), b && (y.color = void 0));
            return d.createElement(Ee, {
              position: e.getLocation(),
              zoomLevel: r,
              isMultiAnnotationsSelected: p
            }, d.createElement(Je.Z, {
              onPointerUp: c ? this._handlePointerUp : void 0,
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(t.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(t.id));
              }
            }, d.createElement(we.Z, {
              disabled: o,
              onPointerDown: this._handlePointerDown,
              style: xn(xn({}, y), {}, {
                backgroundColor: (0, j.Vc)(t) ? void 0 : v
              }),
              className: h()(fn().annotation, {
                [fn().readOnlyOutline]: t.readOnly || t.locked
              }, "PSPDFKit-Text-Annotation PSPDFKit-Annotation"),
              "data-annotation-id": t.id,
              "aria-label": `${a(ke.Z.annotation)}: ${a(ke.Z.textAnnotation)}`,
              innerRef: this._innerRef,
              tabIndex: -1
            }, c ? d.createElement(le.Reparent, {
              id: `annotation-text-${t.id}`
            }, d.createElement(We, {
              annotation: n,
              zoomLevel: f,
              backend: s,
              label: a(ke.Z.textAnnotation),
              isDragging: l,
              onError: this.props.onError
            })) : t.callout ? d.createElement(yn, {
              annotation: t
            }, w) : w)));
          }
        }
        const Cn = (0, xe.XN)(Dn, {
          forwardRef: !0
        });
        var Sn = n(54670),
          En = n(29211),
          _n = n.n(En);
        function Pn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function kn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pn(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function An(e) {
          const {
              annotation: t,
              previewRedactionMode: n,
              zoomLevel: r,
              isSelectable: o
            } = e,
            {
              boundingBox: i
            } = t,
            [a, s] = d.useState(0),
            l = 10 * r,
            u = Math.round(1.75 * r),
            c = Math.floor(Math.floor(l) + u);
          d.useLayoutEffect(() => {
            if (n && t.overlayText && t.repeatOverlayText) {
              const e = new Sn.default(`${l}px Helvetica, sans-serif`),
                {
                  width: n
                } = e.measureText(t.overlayText);
              s(n), e.clean();
            }
          }, [n, t.overlayText, t.repeatOverlayText, l, s]);
          const p = d.useMemo(() => t.overlayText && !t.repeatOverlayText ? t.rects.sortBy({
              0: e => [e.top, e.left],
              90: e => [e.left, -e.top],
              180: e => [-e.top, -e.left],
              270: e => [-e.left, e.top]
            }[t.rotation || "0"], Pe.b).first() : null, [t.overlayText, t.repeatOverlayText, t.rects, t.rotation]),
            f = t.rects.map((e, s) => {
              const u = e.scale(r),
                {
                  overlayText: f,
                  textHeight: m
                } = function (e, t, n, r, o, i) {
                  let a = e.overlayText,
                    s = r;
                  if (t && a && e.repeatOverlayText && n) {
                    const e = i.width / n,
                      t = Math.max(1, Math.floor(i.height / r)),
                      l = Math.ceil(e * t);
                    s = r * t, s + o <= i.height && (s += o), a = a.repeat(l);
                  }
                  return {
                    overlayText: a,
                    textHeight: s
                  };
                }(t, n, a, c, l, u),
                g = {
                  fontSize: l,
                  lineHeight: `${c}px`,
                  height: t.repeatOverlayText ? m : "100%"
                };
              if ((0, qe.kv)(t)) {
                const e = 90 === t.rotation || 270 === t.rotation;
                g.transformOrigin = "50% 50%", g.transform = (e ? `translate(${Math.round(u.width / 2 - u.height / 2)}px, ${-Math.round(u.width / 2 - u.height / 2)}px) ` : "") + `rotate(${String(-t.rotation)}deg)`, e && (g.width = u.height, g.height = u.width);
              }
              const v = (0, j.B7)(t, {
                  isSelectable: o
                }),
                y = {
                  top: (e.top - i.top) * r,
                  left: (e.left - i.left) * r,
                  width: u.width,
                  height: u.height,
                  cursor: v,
                  backgroundColor: n ? "white" : void 0
                },
                b = {
                  width: u.width,
                  height: u.height
                },
                w = kn(kn({}, b), {}, {
                  border: t.outlineColor instanceof _.Il ? `2px solid ${t.outlineColor.toCSSValue()}` : void 0,
                  opacity: t.opacity
                }),
                x = kn(kn({}, b), {}, {
                  border: 0,
                  color: t.color instanceof _.Il ? t.color.toCSSValue() : void 0,
                  backgroundColor: t.fillColor instanceof _.Il ? t.fillColor.toCSSValue() : "black",
                  opacity: t.opacity
                }),
                D = h()({
                  [_n().textContainer]: !0,
                  [_n().selectable]: !0
                });
              return d.createElement("div", {
                key: s,
                className: _n().rectContainer,
                style: y
              }, d.createElement("div", {
                className: D,
                style: n ? x : w
              }, n && (t.repeatOverlayText || e.equals(p)) && d.createElement("span", {
                className: _n().textSpan,
                style: g
              }, f)));
            });
          return d.createElement(d.Fragment, null, f);
        }
        const zn = function (e) {
          const {
              isSelectable: t,
              dispatch: n,
              annotation: r,
              zoomLevel: o,
              active: i,
              isMultiAnnotationsSelected: a
            } = e,
            {
              boundingBox: s
            } = r,
            u = d.useCallback(e => {
              n((0, _e.mg)(r, e));
            }, [n, r]),
            c = d.useRef(null),
            p = (0, l.v9)(e => e.previewRedactionMode),
            f = {
              width: s.width * o,
              height: s.height * o,
              cursor: t ? "pointer" : "auto"
            };
          return d.createElement(Ee, {
            zoomLevel: e.zoomLevel,
            position: s.getLocation(),
            className: _n().wrapper,
            disablePointerEvents: !0,
            isMultiAnnotationsSelected: a
          }, d.createElement(Je.Z, {
            onPointerEnter: () => {
              e.dispatch((0, _e.oX)(r.id));
            },
            onPointerLeave: () => {
              e.dispatch((0, _e.IP)(r.id));
            }
          }, d.createElement(we.Z, {
            is: "div",
            disabled: Boolean(e.isDisabled),
            className: h()(_n().container, "PSPDFKit-Redaction-Annotation PSPDFKit-Annotation", i && !e.isDisabled && "PSPDFKit-Annotation-Selected", i && !e.isDisabled && "PSPDFKit-Redaction-Annotation-Selected"),
            style: f,
            "data-annotation-id": r.id,
            onClick: u,
            innerRef: c,
            tabIndex: -1
          }, e.active ? d.createElement("div", {
            className: _n().active
          }) : null, d.createElement(An, {
            annotation: r,
            previewRedactionMode: p,
            isSelectable: t,
            zoomLevel: o
          }))));
        };
        var Tn,
          On = n(90255),
          In = n.n(On);
        class Fn extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O);
          }
          render() {
            const {
                color: e,
                markupStyle: t,
                zoomLevel: n,
                pageRotation: r
              } = this.props,
              o = (0, _t.SK)(),
              i = 0 !== r ? {
                transform: `rotate(${90 * r}deg)`
              } : {};
            return d.createElement("svg", {
              className: In().markup,
              style: t,
              focusable: !1
            }, d.createElement("defs", null, d.createElement("pattern", {
              id: o,
              width: "8",
              height: "3",
              patternUnits: "userSpaceOnUse",
              fill: e instanceof _.Il ? e.toCSSValue() : "transparent",
              style: i
            }, Tn || (Tn = d.createElement("path", {
              d: "M8 2.9C7.2 2.9 6.7 2.3 6.5 1.9 6.2 1.5 6.1 1.4 6 1.4 5.9 1.4 5.8 1.5 5.5 1.9 5.3 2.3 4.8 2.9 4 2.9 3.2 2.9 2.7 2.3 2.5 1.9 2.2 1.5 2.1 1.4 2 1.4 1.9 1.4 1.8 1.5 1.5 1.9 1.3 2.3 0.8 2.9 0 2.9L0 1.6C0.1 1.6 0.2 1.5 0.5 1.1 0.7 0.7 1.2 0.1 2 0.1 2.8 0.1 3.3 0.7 3.5 1.1 3.8 1.5 3.9 1.6 4 1.6 4.1 1.6 4.2 1.5 4.5 1.1 4.7 0.7 5.2 0.1 6 0.1 6.8 0.1 7.3 0.7 7.5 1.1 7.8 1.5 7.9 1.6 8 1.6L8 2.9 8 2.9Z"
            })))), d.createElement("rect", {
              fill: `url(#${o})`,
              width: "100%",
              height: "100%",
              transform: `scale(${n < 1 ? `1, ${n}` : `${n}`})`
            }));
          }
        }
        function Mn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Rn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Mn(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class jn extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "el", null), (0, o.Z)(this, "_innerRef", e => {
              this.el = e;
            }), (0, o.Z)(this, "_handlePress", e => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e));
            }), (0, o.Z)(this, "_handleCommentIconPress", e => {
              this._handlePress(e), e.stopPropagation();
            });
          }
          render() {
            const {
                active: e,
                annotation: t,
                zoomLevel: n,
                isSelectable: r,
                intl: {
                  formatMessage: o
                },
                backend: i,
                shouldKeepRenderingAPStream: a,
                pageRotation: s
              } = this.props,
              l = t instanceof _.FV,
              c = (0, j.B7)(t, {
                isSelectable: r
              }),
              {
                boundingBox: p
              } = t,
              f = t.rects.map((r, o) => {
                const i = h()({
                    [In().annotationRect]: !0,
                    [In()[t.constructor.className]]: !0
                  }),
                  a = {
                    top: (r.top - p.top) * n,
                    left: (r.left - p.left) * n,
                    width: r.width * n,
                    height: r.height * n,
                    opacity: t.opacity,
                    cursor: c
                  },
                  u = function (e) {
                    let {
                      annotation: t,
                      rect: n,
                      zoomLevel: r,
                      pageRotation: o
                    } = e;
                    const i = (0, j.B7)(t),
                      a = {
                        width: n.width * r,
                        height: n.height * r,
                        backgroundColor: t.color instanceof _.Il ? t.color.toCSSValue() : "transparent",
                        cursor: i
                      };
                    if (t instanceof _.R9) switch (o) {
                      case 0:
                        return Rn(Rn({}, a), {}, {
                          height: Math.max(1, Math.floor(2 * r)),
                          marginTop: Math.max(1, Math.floor(-1 * r))
                        });
                      case 1:
                        return Rn(Rn({}, a), {}, {
                          width: Math.max(1, Math.floor(2 * r)),
                          left: "auto",
                          right: "50%",
                          top: 0,
                          marginRight: Math.max(1, Math.floor(-1 * r))
                        });
                      case 2:
                        return Rn(Rn({}, a), {}, {
                          height: Math.max(1, Math.floor(2 * r)),
                          top: "auto",
                          bottom: "50%",
                          marginBottom: Math.max(1, Math.floor(-1 * r))
                        });
                      case 3:
                        return Rn(Rn({}, a), {}, {
                          width: Math.max(1, Math.floor(2 * r)),
                          right: "auto",
                          left: "50%",
                          top: 0,
                          marginLeft: Math.max(1, Math.floor(-1 * r))
                        });
                    } else if (t instanceof _.xu) switch (o) {
                      case 0:
                        return Rn(Rn({}, a), {}, {
                          marginTop: Math.max(1, Math.floor(2 * r)),
                          height: Math.max(1, Math.floor(2 * r))
                        });
                      case 1:
                        return Rn(Rn({}, a), {}, {
                          marginRight: Math.max(1, Math.floor(2 * r)),
                          width: Math.max(1, Math.floor(2 * r))
                        });
                      case 2:
                        return Rn(Rn({}, a), {}, {
                          marginBottom: Math.max(1, Math.floor(2 * r)),
                          height: Math.max(1, Math.floor(2 * r)),
                          top: 0
                        });
                      case 3:
                        return Rn(Rn({}, a), {}, {
                          width: Math.max(1, Math.floor(2 * r)),
                          left: "auto",
                          marginLeft: Math.max(1, Math.floor(2 * r))
                        });
                    } else if (t instanceof _.hL) switch (o) {
                      case 0:
                        return Rn(Rn({}, a), {}, {
                          height: 3 * r,
                          overflow: "hidden"
                        });
                      case 1:
                        return Rn(Rn({}, a), {}, {
                          width: 3 * r,
                          overflow: "hidden"
                        });
                      case 2:
                        return Rn(Rn({}, a), {}, {
                          height: 3 * r,
                          top: 0,
                          overflow: "hidden"
                        });
                      case 3:
                        return Rn(Rn({}, a), {}, {
                          width: 3 * r,
                          left: "auto",
                          overflow: "hidden"
                        });
                    }
                    return a;
                  }({
                    annotation: t,
                    rect: r,
                    zoomLevel: n,
                    pageRotation: s
                  }),
                  f = {
                    backgroundColor: t.color instanceof _.Il ? t.color.toCSSValue() : "transparent"
                  };
                return d.createElement("div", {
                  key: o,
                  className: i,
                  style: a
                }, e ? d.createElement("div", {
                  className: h()({
                    [In().active]: !l
                  }),
                  style: f
                }) : null, t instanceof _.hL ? d.createElement(Fn, {
                  markupStyle: u,
                  color: t.color,
                  zoomLevel: n,
                  pageRotation: s
                }) : d.createElement("div", {
                  className: In().markup,
                  style: u
                }));
              }).toArray(),
              m = (0, j.vk)(t.blendMode),
              g = m ? {
                mixBlendMode: m
              } : void 0,
              v = Rn({
                width: p.width * n,
                height: p.height * n,
                cursor: c
              }, De.G6 ? null : g),
              y = function (e) {
                switch (e.constructor) {
                  case _.FV:
                    return "Highlight";
                  case _.R9:
                    return "StrikeOut";
                  case _.xu:
                    return "Underline";
                  case _.hL:
                    return "Squiggle";
                  default:
                    throw new u.p2(`Unknown text markup annotation type of annotation: ${JSON.stringify(e.toJS())}`);
                }
              }(t),
              b = ke.Z[`${y.charAt(0).toLowerCase() + y.slice(1)}Annotation`],
              w = h()(In().annotation, "PSPDFKit-Annotation", "PSPDFKit-Text-Markup-Annotation", `PSPDFKit-${y}-Annotation`, {
                [In().activeTextMarkup]: e && l,
                [In().highlight]: l,
                "PSPDFKit-Text-Markup-Annotation-selected": e,
                "PSPDFKit-Text-Markup-Comment-Annotation": t.isCommentThreadRoot
              }),
              x = {};
            return e && (x["data-testid"] = "selected annotation"), d.createElement(Ee, {
              position: p.getLocation(),
              zoomLevel: n,
              disablePointerEvents: !t.readOnly,
              additionalStyle: De.G6 ? g : void 0
            }, d.createElement(Je.Z, {
              onPointerEnter: () => {
                this.props.dispatch((0, _e.oX)(t.id));
              },
              onPointerLeave: () => {
                this.props.dispatch((0, _e.IP)(t.id));
              }
            }, d.createElement(we.Z, (0, ce.Z)({
              is: "div",
              style: v,
              className: w,
              onClick: this._handlePress,
              disabled: !!this.props.isDisabled,
              "data-annotation-id": t.id,
              "aria-label": `${o(ke.Z.annotation)}: ${o(b)}`,
              innerRef: this._innerRef
            }, x, {
              tabIndex: -1
            }), d.createElement(d.Fragment, null, a && d.createElement(We, {
              annotation: t,
              zoomLevel: n,
              backend: i,
              label: o(b),
              onError: this.props.onError
            }), (!a || e) && f))));
          }
        }
        (0, o.Z)(jn, "defaultProps", {
          active: !1
        });
        const Bn = (0, xe.XN)(jn, {
          forwardRef: !0
        });
        var Nn = n(39213),
          Ln = n.n(Nn);
        function Vn(e) {
          let {
            annotation: t,
            zoomLevel: n,
            isDisabled: r,
            backend: o,
            isFocused: i,
            isMultiAnnotationsSelected: a
          } = e;
          const s = d.useRef(null),
            {
              formatMessage: l
            } = (0, xe.YB)(),
            {
              boundingBox: u
            } = t,
            c = {
              width: u.width * n,
              height: u.height * n
            };
          return d.useEffect(() => {
            i && s.current && s.current.focus();
          }, [i]), d.createElement(Ee, {
            position: u.getLocation(),
            zoomLevel: n,
            applyZoom: !0,
            isMultiAnnotationsSelected: a
          }, d.createElement(we.Z, {
            disabled: r,
            className: h()(Ln().annotation, "PSPDFKit-Annotation-Unknown PSPDFKit-Annotation-Unsupported PSPDFKit-Annotation"),
            style: c,
            "data-annotation-id": t.id,
            "aria-label": l(ke.Z.annotation),
            innerRef: s,
            tabIndex: -1
          }, o && d.createElement(We, {
            annotation: t,
            backend: o,
            zoomLevel: n,
            label: l(ke.Z.annotation)
          })));
        }
        var Kn = n(12705),
          qn = n(19181),
          Hn = n(561),
          Un = n.n(Hn),
          Zn = n(2928),
          $n = n.n(Zn);
        function Gn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Wn(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Gn(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Yn extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "_handleClickAction", e => {
              this.props.dispatch((0, _e.mg)(this.props.annotation, e));
            }), (0, o.Z)(this, "_handleFocus", e => {
              const {
                onFocus: t,
                annotation: n
              } = this.props;
              t && t(n, e);
            }), (0, o.Z)(this, "_handleBlur", e => {
              const {
                onBlur: t,
                annotation: n,
                annotationToFocus: r
              } = this.props;
              r === n.id && this.props.dispatch((0, yt.vy)(null)), t && t(n, e);
            });
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            var r;
            n !== t && this.props.annotation.id === t && (null === (r = this._inputRef.current) || void 0 === r || r.focus());
          }
          render() {
            const {
                annotation: e,
                formField: {
                  name: t,
                  readOnly: n,
                  buttonLabel: r,
                  label: o
                },
                zoomLevel: i,
                formDesignMode: a,
                isRenderingAPStream: s,
                canFillFormFieldCP: l
              } = this.props,
              u = "number" == typeof e.fontSize ? e.fontSize : 12,
              c = Wn({
                width: Math.ceil(e.boundingBox.width * i),
                height: Math.ceil(e.boundingBox.height * i)
              }, s ? {
                opacity: 0
              } : Wn(Wn({}, (0, Ke.i2)(e, i)), {}, {
                fontSize: Math.ceil(u * i),
                justifyContent: e.verticalAlign && Qn[e.verticalAlign] || "center",
                alignItems: e.horizontalAlign && Jn[e.horizontalAlign] || "center"
              })),
              p = l && !n,
              f = !p || a,
              m = h()({
                [Un().widget]: !0,
                [Un().onFocus]: !0,
                [Un().readOnly]: !p,
                [Un().flexText]: !0,
                [$n().btn]: !f,
                [$n().btnFormDesigner]: a,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Button": !0,
                "PSPDFKit-Annotation-Widget-read-only": !p
              });
            return d.createElement("button", {
              ref: this._inputRef,
              className: m,
              disabled: f,
              name: t,
              type: Xn(e),
              style: c,
              onClick: this._handleClickAction,
              onFocus: this._handleFocus,
              onBlur: this._handleBlur
            }, r || o || "");
          }
        }
        function Xn(e) {
          const {
            action: t
          } = e;
          if (!t) return "button";
          switch (t.constructor) {
            case mt.BO:
              return "reset";
            case mt.pl:
              return "submit";
            default:
              return "button";
          }
        }
        const Qn = {
            top: "flex-start",
            center: "center",
            bottom: "flex-end"
          },
          Jn = {
            left: "flex-start",
            center: "center",
            right: "flex-end"
          };
        var er = n(77897),
          tr = n(36401),
          nr = n.n(tr);
        function rr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class or extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              checked: (0, Ke.CK)(this.props.formField, this.props.annotation)
            }), (0, o.Z)(this, "UNSAFE_componentWillReceiveProps", e => {
              e.formField.values.equals(this.props.formField.values) || this.setState({
                checked: (0, Ke.CK)(e.formField, e.annotation)
              });
            }), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "_onChange", () => {
              const {
                  formField: e,
                  annotation: t
                } = this.props,
                n = (0, Ke.l_)(e, t),
                r = this.state.checked ? (0, s.aV)(["Off"]) : (0, s.aV)([n]),
                o = (0, Ke.g6)(e, t, !this.state.checked);
              this.setState({
                checked: !this.state.checked
              }), this.props.dispatch((0, er.xh)([{
                name: e.name,
                value: r,
                optionIndexes: o
              }]));
            }), (0, o.Z)(this, "_handleFocus", e => {
              const {
                onFocus: t,
                annotation: n
              } = this.props;
              null == t || t(n, e);
            }), (0, o.Z)(this, "_handleBlur", e => {
              const {
                onBlur: t,
                annotation: n
              } = this.props;
              this.props.annotationToFocus === this.props.annotation.id && this.props.dispatch((0, yt.vy)(null)), null == t || t(n, e);
            });
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            var r;
            n !== t && this.props.annotation.id === t && (null === (r = this._inputRef.current) || void 0 === r || r.focus());
          }
          render() {
            const {
                annotation: {
                  id: e
                },
                annotation: t,
                zoomLevel: r,
                formField: i,
                formDesignMode: a,
                isRenderingAPStream: s,
                canFillFormFieldCP: l
              } = this.props,
              {
                readOnly: u
              } = i,
              c = (0, Ke.l_)(i, t),
              p = function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? rr(Object(n), !0).forEach(function (t) {
                    (0, o.Z)(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rr(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                width: Math.ceil(t.boundingBox.width * r),
                height: Math.ceil(t.boundingBox.height * r)
              }, s ? {
                opacity: 0
              } : (0, Ke.i2)(t, r)),
              f = l && !u,
              m = h()({
                [nr().readOnly]: !f,
                [nr().input]: !0,
                [Un().widget]: !0,
                [Un().readOnly]: !f,
                "PSPDFKit-Annotation-Widget-CheckBox-Control": !0
              }),
              g = h()({
                [nr().checkradio]: !0,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-CheckBox": !0,
                "PSPDFKit-Annotation-Widget-read-only": !f
              });
            return d.createElement("label", {
              style: p,
              className: g
            }, d.createElement("input", {
              ref: this._inputRef,
              type: "checkbox",
              disabled: !f || a,
              name: i.name,
              value: c,
              key: e,
              checked: this.state.checked,
              onChange: this._onChange,
              onFocus: this._handleFocus,
              onBlur: this._handleBlur
            }), d.createElement("span", {
              className: m,
              style: {
                borderWidth: Math.max(1, r)
              }
            }), this.state.checked && d.createElement("span", {
              className: nr().check,
              role: "presentation"
            }, d.createElement(je.Z, {
              src: n(22606)
            })));
          }
        }
        var ir = n(41756),
          ar = n(60859),
          sr = n(68850),
          lr = n.n(sr);
        const ur = ["height", "width", "opacity"];
        function cr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function dr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? cr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class pr extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "_memoizedCalculateFontSize", (0, dn.Z)(ar.MX)), (0, o.Z)(this, "latestKeystrokeDiff", null), (0, o.Z)(this, "_getInput", e => {
              if (e.isEmpty()) return "";
              {
                const t = this.props.formField.options.find(t => t.get("value") === e.first());
                return t ? t.label : e.first() || "";
              }
            }), (0, o.Z)(this, "state", {
              initialValue: this._getInput(this.props.formField.values),
              value: this._getInput(this.props.formField.values),
              values: this.props.formField.values,
              isOpen: !1,
              isFocused: !1,
              textSelected: !1
            }), (0, o.Z)(this, "_getSelectedLabel", () => {
              const {
                  options: e
                } = this.props.formField,
                t = this.state.values.first(),
                n = e.find(e => e.value === t);
              return n && n.label || t;
            }), (0, o.Z)(this, "UNSAFE_componentWillReceiveProps", e => {
              e.formField.values !== this.props.formField.values && this.setState({
                values: e.formField.values
              });
            }), (0, o.Z)(this, "_onChange", e => {
              const t = e.currentTarget,
                {
                  value: n
                } = t,
                {
                  backend: r,
                  formField: o,
                  annotation: i
                } = this.props;
              if (!(0, Ke.sC)(r, i, o)) return void this.setState({
                value: n,
                textSelected: !1
              });
              const {
                  selectionStart: a,
                  selectionEnd: s
                } = t,
                l = (0, F.QE)(this.state.initialValue, n, a);
              this.latestKeystrokeDiff = l;
              const c = {
                change: l.change,
                value: l.prev,
                returnCode: !0,
                name: this.props.formField.name,
                selStart: a,
                selEnd: s
              };
              this.setState({
                value: n,
                textSelected: !1
              }), r.onKeystrokeEvent(c).then(e => {
                if (l !== this.latestKeystrokeDiff || 0 === e.length) return;
                const n = e[0].object;
                if (!n.returnCode) return void this.setState({
                  value: this.state.initialValue,
                  textSelected: !1
                });
                const r = (0, F.F6)(l, n.change),
                  o = e.slice(1);
                o.length && this.props.dispatch((0, er.bt)({
                  changes: o
                })), this.setState({
                  value: r,
                  initialValue: r,
                  textSelected: !1
                }, function () {
                  n.selStart !== t.selectionStart && (t.selectionStart = n.selStart), n.selEnd !== t.selectionEnd && (t.selectionEnd = n.selEnd);
                });
              }).catch(u.vU);
            }), (0, o.Z)(this, "_onSelect", e => {
              if (!e) {
                const e = this.state;
                return this.setState({
                  values: e.values,
                  isOpen: !1,
                  value: e.value,
                  textSelected: !1
                }, () => {
                  this.props.onOpenStateChange(this.state.isOpen);
                }), this.latestKeystrokeDiff = null, void (this._button && this._button.focus());
              }
              const t = (0, s.aV)([e.value]);
              this.setState({
                values: t,
                isOpen: !1,
                value: e.label,
                textSelected: !1
              }, () => {
                this.props.onOpenStateChange(this.state.isOpen);
              }), this.latestKeystrokeDiff = null, this.props.formField.commitOnChange && (this.props.formField.values.equals(t) || this.props.dispatch((0, er.xh)([{
                name: this.props.formField.name,
                value: t
              }], e => {
                e.some(e => e.name === this.props.formField.name) && this.setState({
                  value: this.state.initialValue,
                  textSelected: !1
                });
              }))), this._button && this._button.focus();
            }), (0, o.Z)(this, "_handleBlur", e => {
              e.persist();
              const {
                currentTarget: t
              } = e;
              this.props.dispatch((0, yt.vy)(null)), this.latestKeystrokeDiff = null, setTimeout(() => {
                const n = this.props.shadowRoot ? this.props.shadowRoot.activeElement : this.props.frameWindow.document.activeElement;
                if (!t.contains(n)) {
                  const t = this._getInput(this.state.values);
                  this.setState({
                    isOpen: !1,
                    isFocused: !1,
                    value: t,
                    initialValue: t
                  }, () => {
                    this.props.onOpenStateChange(this.state.isOpen);
                  }), this.props.formField.values.equals(this.state.values) || this.props.dispatch((0, er.xh)([{
                    name: this.props.formField.name,
                    value: this.state.values
                  }], e => {
                    e.some(e => e.name === this.props.formField.name) && this.setState({
                      value: this.state.initialValue,
                      textSelected: !1
                    });
                  }));
                  const {
                    onBlur: n,
                    annotation: r
                  } = this.props;
                  n && n(r, e);
                }
              }, 0);
            }), (0, o.Z)(this, "calculateFilteredOptions", () => {
              const e = this.state.isOpen,
                {
                  formField: {
                    options: t,
                    edit: n
                  }
                } = this.props,
                r = e ? t.toSeq().filter(e => this.state.textSelected || !this.state.value || e.label.toLowerCase().includes(this.state.value.toLowerCase())).toList() : (0, s.aV)();
              return n ? r.some(e => this.state.value.includes(e.label)) ? r : r.unshift(new _.mv({
                label: this.state.value,
                value: this.state.value
              })) : r;
            }), (0, o.Z)(this, "_renderComboBoxTop", (e, t, r, o) => {
              const {
                  name: i,
                  readOnly: a
                } = this.props.formField,
                s = this.props.formDesignMode,
                l = this.props.canFillFormFieldCP && !a,
                u = h()({
                  [lr().comboBoxTop]: !0,
                  "PSPDFKit-Annotation-Widget-ComboBox-Button": !0,
                  "PSPDFKit-Annotation-Widget-read-only": !l
                }),
                c = this._getSelectedLabel();
              return d.createElement("div", {
                className: u,
                onClick: this._openDropdownClick,
                ref: o
              }, d.createElement("button", {
                "aria-controls": `PSPDFKit-dd-${this.props.formField.name}-menu`,
                "aria-expanded": r,
                "aria-haspopup": "true",
                tabIndex: r ? -1 : 0,
                style: e,
                disabled: !l || s,
                className: lr().valueBtn,
                onFocus: e => {
                  this.setState({
                    isFocused: !0
                  });
                  const {
                    onFocus: t,
                    annotation: n
                  } = this.props;
                  t && (e.persist(), t(n, e));
                },
                ref: e => this._button = e,
                name: i,
                value: c
              }, c), d.createElement("div", (0, ce.Z)({
                "aria-hidden": !r,
                className: lr().arrowBtn
              }, t), d.createElement(je.Z, {
                src: n(52904)
              })));
            }), (0, o.Z)(this, "_openDropdownClick", () => {
              this.props.formField.readOnly || this.props.formField.formDesignMode || !this.props.canFillFormFieldCP || this.setState(e => {
                let {
                  isOpen: t
                } = e;
                return {
                  isOpen: !t
                };
              }, () => {
                this._inputRef.current && (this._inputRef.current.select(), this.setState({
                  textSelected: !0
                }, () => {
                  this.props.onOpenStateChange(this.state.isOpen);
                }));
              });
            }), (0, o.Z)(this, "_setContentElementRect", e => {
              this.props.handleComboxBoxRect(e);
            }), (0, o.Z)(this, "_downShiftRenderFn", e => {
              let {
                getInputProps: t,
                getItemProps: n,
                getToggleButtonProps: r,
                isOpen: o,
                highlightedIndex: i
              } = e;
              const {
                  annotation: {
                    boundingBox: {
                      width: a,
                      height: s
                    }
                  },
                  annotation: l,
                  formField: {
                    doNotSpellCheck: u,
                    readOnly: c,
                    required: p
                  },
                  formDesignMode: f,
                  isRenderingAPStream: m,
                  canFillFormFieldCP: g,
                  viewportState: v
                } = this.props,
                {
                  zoomLevel: y
                } = v,
                b = this.calculateFilteredOptions(),
                w = b.size > 5 ? 5 : b.size,
                x = {
                  fontSize: 10 * y,
                  padding: 2 * y,
                  height: Math.ceil(20 * y)
                },
                D = c || f || !g,
                C = t({
                  ref: this._inputRef,
                  value: this.state.value,
                  onFocus: () => this.setState({
                    isOpen: !0
                  }, () => {
                    this.props.onOpenStateChange(this.state.isOpen);
                  }),
                  spellCheck: !u,
                  onChange: this._onChange
                }),
                S = r(),
                E = h()({
                  [lr().comboBox]: !0,
                  [lr().expanded]: o,
                  [Un().widget]: !0,
                  [Un().focusedWidget]: o || this.state.isFocused,
                  [Un().readOnly]: D,
                  "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-ComboBox": !0,
                  "PSPDFKit-Annotation-Widget-ComboBox-isOpen": o,
                  "PSPDFKit-Annotation-Widget-Required": p
                }),
                _ = Math.max(4, Math.min(.7 * s, 12)) * y,
                P = 90 === l.rotation || 270 === l.rotation,
                k = this._memoizedCalculateFontSize(this._getSelectedLabel(), a, s, l.fontSize, !1, 0, this._inputRef.current),
                A = dr({
                  width: Math.ceil(l.boundingBox.width * y),
                  height: Math.ceil(l.boundingBox.height * y)
                }, m ? {
                  opacity: 0
                } : (0, Ke.i2)(l, y, !1)),
                {
                  height: z,
                  width: T,
                  opacity: O
                } = A,
                I = (0, ne.Z)(A, ur),
                F = dr(dr({}, (0, Ke.VY)(l, y)), {}, {
                  borderWidth: Math.max(1, y),
                  fontSize: _,
                  opacity: O,
                  [P ? "height" : "width"]: T,
                  [P ? "width" : "height"]: z
                }),
                M = dr(dr({}, I), {}, {
                  cursor: D ? "default" : "pointer",
                  padding: `0 ${ar.DI * y}px`,
                  fontSize: k * y,
                  [P ? "width" : "height"]: z,
                  [P ? "height" : "width"]: T
                }),
                R = h()({
                  [lr().menu]: !0,
                  "PSPDFKit-Annotation-Widget-ComboBox-Menu": !0
                }),
                j = Math.ceil(20 * w * y),
                B = Math.ceil(b.size * y);
              return d.createElement("div", {
                className: E,
                style: dr(dr({}, F), o ? {
                  position: "fixed"
                } : void 0),
                tabIndex: -1,
                onBlur: this._handleBlur
              }, d.createElement(hr, {
                viewportRect: v.viewportRect,
                isVertical: 90 === l.rotation || 270 === l.rotation,
                setContentElementRect: this._setContentElementRect
              }, e => {
                let {
                  referenceRef: t,
                  contentRef: r,
                  style: a
                } = e;
                return d.createElement(d.Fragment, null, this._renderComboBoxTop(M, S, o, t), o && d.createElement("div", {
                  className: R,
                  ref: r,
                  style: a
                }, d.createElement("input", (0, ce.Z)({}, C, {
                  className: h()(lr().comboBoxInput, "PSPDFKit-Annotation-Widget-ComboBox-SearchInput"),
                  style: {
                    textAlign: "center"
                  },
                  tabIndex: -1,
                  required: p
                })), d.createElement("div", {
                  className: h()(lr().comboBoxList, "PSPDFKit-Annotation-Widget-ComboBox-List"),
                  id: `PSPDFKit-dd-${this.props.formField.name}-menu`
                }, b.isEmpty() ? d.createElement("div", {
                  className: lr().comboBoxListItem,
                  style: x
                }, "No results found") : d.createElement("div", {
                  className: lr().listContainer,
                  style: {
                    height: j
                  }
                }, d.createElement("div", {
                  className: lr().list,
                  style: {
                    height: B
                  }
                }, b.map((e, t) => {
                  const r = i === t;
                  (0, Ce.k)(e);
                  const o = this.state.values.includes(e.get("value")),
                    a = h()({
                      [lr().comboBoxListItem]: !0,
                      [lr().comboBoxListItemActive]: r,
                      [lr().comboBoxListItemSelected]: o
                    });
                  let s;
                  return s = 0 === t && this.props.formField.edit && !this.props.formField.options.includes(e) ? e.label.length ? `Create "${e.label}"` : d.createElement("span", {
                    className: lr().empty
                  }, "(empty)") : e.label, d.createElement("div", (0, ce.Z)({
                    className: h()(a, "PSPDFKit-Annotation-Widget-ComboBox-ListItem", {
                      "PSPDFKit-Annotation-Widget-ComboBox-ListItem-Active": r,
                      "PSPDFKit-Annotation-Widget-ComboBox-ListItem-Selected": o
                    }),
                    title: e.label
                  }, n({
                    key: e.value,
                    index: t,
                    item: e,
                    style: x
                  })), s);
                }))))));
              }));
            }), (0, o.Z)(this, "_itemToString", e => e ? e.label : "");
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            n !== t && this.props.annotation.id === t && this._openDropdownClick();
          }
          componentWillUnmount() {
            this.latestKeystrokeDiff = null;
          }
          render() {
            const {
              frameWindow: e
            } = this.props;
            return d.createElement(ir.ZP, {
              environment: e,
              onSelect: this._onSelect,
              itemToString: this._itemToString,
              isOpen: this.state.isOpen,
              defaultHighlightedIndex: 0
            }, this._downShiftRenderFn);
          }
        }
        const hr = function (e) {
          const {
              children: t,
              viewportRect: n,
              isVertical: r,
              setContentElementRect: o
            } = e,
            [i, a] = d.useState(null),
            [s, l] = d.useState(null),
            [u, c] = d.useState(null),
            p = d.useCallback(() => {
              const e = s ? s.getBoundingClientRect() : null,
                t = i ? i.getBoundingClientRect() : null,
                a = r ? "left" : "top",
                l = r ? "width" : "height";
              let u = e ? e[l] : 0;
              null !== t && null !== e && e[a] + e[l] + t[l] > n[l] && 0 !== e[a] && (u = -t[l]), o && o(t), c({
                top: u
              });
            }, [i, s, n, r]);
          d.useLayoutEffect(() => {
            p();
          }, [p]);
          return t({
            referenceRef: e => l(e),
            contentRef: e => a(e),
            style: dr(dr({
              position: "absolute"
            }, u), {}, {
              width: "100%"
            }, s && i ? null : {
              opacity: 0
            })
          });
        };
        var fr = n(55338),
          mr = n.n(fr);
        function gr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function vr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? gr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class yr extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              values: this.props.formField.values
            }), (0, o.Z)(this, "UNSAFE_componentWillReceiveProps", e => {
              e.formField.values.equals(this.props.formField.values) || this.setState({
                values: e.formField.values
              });
            }), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "_onChange", e => {
              const t = e.target.options,
                n = (0, s.dM)([...t]).filter(e => e.selected).map(e => e.value).toList();
              this.setState({
                values: n
              }), this.props.formField.commitOnChange && (this.props.formField.values.equals(n) || this.props.dispatch((0, er.xh)([{
                name: this.props.formField.name,
                value: n
              }])));
            }), (0, o.Z)(this, "_onBlur", e => {
              this.props.annotationToFocus === this.props.annotation.id && this.props.dispatch((0, yt.vy)(null)), this.props.formField.values.equals(this.state.values) || this.props.dispatch((0, er.xh)([{
                name: this.props.formField.name,
                value: this.state.values
              }]));
              const {
                onBlur: t,
                annotation: n
              } = this.props;
              t && t(n, e);
            }), (0, o.Z)(this, "_onFocus", e => {
              const {
                onFocus: t,
                annotation: n
              } = this.props;
              t && t(n, e);
            });
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            var r;
            n !== t && this.props.annotation.id === t && (null === (r = this._inputRef.current) || void 0 === r || r.focus());
          }
          render() {
            const {
                annotation: e,
                formField: {
                  options: t,
                  name: n,
                  multiSelect: r,
                  readOnly: o,
                  required: i
                },
                zoomLevel: a,
                formDesignMode: s,
                isRenderingAPStream: l,
                canFillFormFieldCP: u
              } = this.props,
              c = u && !o,
              p = vr({
                width: Math.ceil(e.boundingBox.width * a),
                height: Math.ceil(e.boundingBox.height * a)
              }, l ? {
                opacity: 0
              } : vr(vr({}, (0, Ke.i2)(e, a)), {}, {
                fontSize: Math.ceil(12 * a),
                textAlign: e.horizontalAlign
              })),
              f = h()({
                [mr().listBox]: !0,
                [Un().widget]: !0,
                [Un().onFocus]: !0,
                [Un().readOnly]: !c,
                [mr().listBoxRotated]: !!e.rotation,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-ListBox": !0,
                "PSPDFKit-Annotation-Widget-read-only": !c,
                "PSPDFKit-Annotation-Widget-Required": i
              }),
              m = r ? this.state.values.toArray() : this.state.values.size > 0 ? this.state.values.get(0) : void 0;
            return d.createElement("select", {
              ref: this._inputRef,
              disabled: !c || s,
              style: p,
              size: t.size,
              className: f,
              name: n,
              onChange: this._onChange,
              multiple: r,
              onBlur: this._onBlur,
              onFocus: this._onFocus,
              value: m,
              required: i
            }, t.map(e => d.createElement("option", {
              key: e.value,
              value: e.value
            }, e.label)));
          }
        }
        var br = n(86849);
        const wr = ["borderColor", "borderWidth", "borderStyle", "height", "width", "opacity", "backgroundColor"];
        function xr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Dr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? xr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Cr extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              checked: (0, Ke.CK)(this.props.formField, this.props.annotation)
            }), (0, o.Z)(this, "UNSAFE_componentWillReceiveProps", e => {
              const t = (0, Ke.CK)(e.formField, e.annotation);
              this.setState({
                checked: t
              });
            }), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "handleChange", () => {
              const {
                dispatch: e,
                formField: t,
                annotation: n
              } = this.props;
              if (this.state.checked && t.noToggleToOff) return;
              const r = (0, Ke.g6)(t, n, !this.state.checked);
              e((0, er.xh)([{
                name: t.name,
                value: this.state.checked ? null : (0, Ke.l_)(t, n),
                optionIndexes: r
              }])), this.setState(e => {
                let {
                  checked: t
                } = e;
                return {
                  checked: !t
                };
              });
            }), (0, o.Z)(this, "uncheck", e => {
              const {
                formField: t,
                dispatch: n,
                annotation: r
              } = this.props;
              if (t.readOnly || t.noToggleToOff || !this.state.checked || "keydown" === e.type && e.keyCode !== br.tW) return;
              "keydown" === e.type && e.preventDefault();
              const o = (0, Ke.g6)(t, r, !1);
              n((0, er.xh)([{
                name: t.name,
                value: null,
                optionIndexes: o
              }]));
            }), (0, o.Z)(this, "_handleFocus", e => {
              const {
                onFocus: t,
                annotation: n
              } = this.props;
              t && t(n, e);
            }), (0, o.Z)(this, "_handleBlur", e => {
              const {
                onBlur: t,
                annotation: n,
                annotationToFocus: r
              } = this.props;
              r === n.id && this.props.dispatch((0, yt.vy)(null)), t && t(n, e);
            });
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            var r;
            n !== t && this.props.annotation.id === t && (null === (r = this._inputRef.current) || void 0 === r || r.focus());
          }
          render() {
            const {
                annotation: {
                  id: e
                },
                annotation: t,
                zoomLevel: n,
                formField: r,
                formDesignMode: o,
                isRenderingAPStream: i,
                canFillFormFieldCP: a
              } = this.props,
              {
                checked: s
              } = this.state,
              l = Dr({
                width: Math.ceil(t.boundingBox.width * n),
                height: Math.ceil(t.boundingBox.height * n)
              }, i ? {
                opacity: 0
              } : (0, Ke.i2)(t, n, !1)),
              {
                borderColor: u,
                borderWidth: c,
                borderStyle: p,
                height: f,
                width: m,
                opacity: g,
                backgroundColor: v
              } = l,
              y = (0, ne.Z)(l, wr),
              {
                transform: b,
                transformOrigin: w
              } = (0, Ke.i2)(t, n);
            let x = {
              width: m,
              height: f,
              opacity: g
            };
            (0, qe.kv)(t) && (x = Dr(Dr({}, x), {}, {
              transform: b,
              transformOrigin: w
            }));
            const D = a && !r.readOnly,
              C = h()({
                [nr().input]: !0,
                [nr().inputRadio]: !0,
                [Un().widget]: !0,
                [Un().readOnly]: !D,
                "PSPDFKit-Annotation-Widget-RadioButton-Control": !0
              }),
              S = h()({
                [nr().checkradio]: !0,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-RadioButton": !0,
                "PSPDFKit-Annotation-Widget-read-only": !D
              });
            return d.createElement("label", {
              style: x,
              className: S
            }, d.createElement("input", {
              ref: this._inputRef,
              type: "radio",
              name: r.name,
              disabled: !D || o,
              key: e,
              defaultChecked: s,
              value: (0, Ke.l_)(r, t),
              className: s ? nr().checked : null,
              onChange: D ? this.handleChange : void 0,
              onClick: this.uncheck,
              onKeyDown: this.uncheck,
              onFocus: this._handleFocus,
              onBlur: this._handleBlur,
              style: y
            }), d.createElement("span", {
              className: C,
              style: {
                borderColor: u,
                borderWidth: null != c ? c : Math.max(1, n),
                borderStyle: p,
                backgroundColor: v
              }
            }));
          }
        }
        var Sr = n(70101),
          Er = n.n(Sr),
          _r = n(20063);
        function Pr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function kr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Ar extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              overlappingAnnotation: null
            }), (0, o.Z)(this, "_focusableElement", null), (0, o.Z)(this, "_onDOMElement", e => {
              this._focusableElement = e;
            }), (0, o.Z)(this, "_handlePress", e => {
              e.stopPropagation(), e.preventDefault();
              const t = this.props.features.includes(ee.q.ELECTRONIC_SIGNATURES) ? "es-signature" : "ink-signature",
                n = this.props.isAnnotationPressPrevented({
                  annotation: this.props.annotation,
                  nativeEvent: e.nativeEvent,
                  selected: !1
                });
              if (!e.isPrimary || n || this.props.isDigitallySigned) return;
              const {
                overlappingAnnotation: r
              } = this.state;
              r ? this.props.dispatch((0, _e.mg)(r, e, {
                selectedAnnotationShouldDrag: "touch" !== e.pointerType ? new _.E9({
                  x: e.clientX,
                  y: e.clientY
                }) : null
              })) : (this._focusableElement && this._focusableElement.focus(), this.props.dispatch((0, yt.Ds)(t)), this.props.dispatch((0, Kt.Cc)({
                signatureRect: this.props.annotation.boundingBox,
                signaturePageIndex: this.props.annotation.pageIndex,
                formFieldName: this.props.formField.name
              })));
            }), (0, o.Z)(this, "_handleFocus", e => {
              const {
                onFocus: t,
                annotation: n
              } = this.props;
              t && t(n, e);
            }), (0, o.Z)(this, "_handleBlur", e => {
              const {
                onBlur: t,
                annotation: n,
                annotationToFocus: r
              } = this.props;
              r === n.id && this.props.dispatch((0, yt.vy)(null)), t && t(n, e);
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              e.stopPropagation();
            });
          }
          static getDerivedStateFromProps(e) {
            const t = e.inkAnnotations.find(t => t.boundingBox.isRectOverlapping(e.annotation.boundingBox)) || e.imageAnnotations.find(t => t.boundingBox.isRectOverlapping(e.annotation.boundingBox));
            return {
              overlappingAnnotation: t || null
            };
          }
          componentDidUpdate(e) {
            const {
                annotationToFocus: t
              } = this.props,
              {
                annotationToFocus: n
              } = e;
            if (n !== t && this.props.annotation.id === t && !this.props.isDigitallySigned) {
              const {
                  overlappingAnnotation: e
                } = this.state,
                t = this.props.features.includes(ee.q.ELECTRONIC_SIGNATURES) ? "es-signature" : "ink-signature";
              e ? this.props.dispatch((0, _e.Df)((0, s.l4)([e.id]), null)) : (this._focusableElement && this._focusableElement.focus(), this.props.dispatch((0, yt.Ds)(t)), this.props.dispatch((0, Kt.Cc)({
                signatureRect: this.props.annotation.boundingBox,
                signaturePageIndex: this.props.annotation.pageIndex,
                formFieldName: this.props.formField.name
              })));
            }
          }
          render() {
            const {
                formatMessage: e
              } = this.props.intl,
              {
                annotation: t,
                annotation: {
                  boundingBox: n,
                  id: r
                },
                formField: {
                  readOnly: o,
                  name: a
                },
                zoomLevel: s,
                formDesignMode: l,
                isDigitallySigned: u,
                hasSignatureLicenseComponent: c,
                backend: p,
                isDragging: f,
                canFillFormFieldCP: m,
                signatureFeatureAvailability: g,
                isRenderingAPStream: v
              } = this.props,
              y = Math.ceil(n.height * s),
              b = kr(kr({}, (0, Ke.i2)(t, s, !1)), {}, {
                fontSize: (20 < y ? 20 : y) * s
              }),
              w = m && !o && g !== _r.H.NONE,
              x = h()({
                [Un().readOnly]: !w,
                [Un().widget]: !0,
                [Un().onFocus]: !0,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Signature": !0,
                "PSPDFKit-Annotation-Widget-read-only": !w
              }),
              D = h()({
                [Er().sign]: !0,
                [Er().signReadOnly]: !w,
                "PSPDFKit-Annotation-Widget-Signature-Badge": !0
              }),
              C = (v || u) && c && (0, j.U7)(n),
              S = h()({
                "PSPDFKit-Annotation-Widget": !0,
                "PSPDFKit-Annotation-Widget-Signature": !0,
                "PSPDFKit-Annotation-Widget-Signature-Signed": u
              }),
              E = d.createElement(d.Fragment, null, d.createElement("span", {
                className: D,
                "aria-hidden": "true"
              }, e(ke.Z.sign)), d.createElement(i.TX, {
                tag: "span"
              }, `${a}, ${e(ke.Z.sign)}`));
            return C ? d.createElement(le.Reparent, {
              id: `annotation-signature-widget-${r}`
            }, d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp,
              onPointerDown: w ? this._handlePress : void 0,
              onDOMElement: this._onDOMElement
            }, d.createElement(we.Z, {
              onFocus: this._handleFocus,
              onBlur: this._handleBlur,
              style: kr(kr({}, b), {}, {
                cursor: w || !u ? "pointer" : "auto"
              }),
              className: S,
              "data-annotation-id": t.id,
              "aria-label": `${e(ke.Z.annotation)}: ${e(ke.Z.sign)}`,
              is: "div"
            }, d.createElement(We, {
              annotation: t,
              backend: p,
              zoomLevel: s,
              label: `${e(ke.Z.signed)}`,
              isDragging: f,
              isDigitallySigned: u,
              onError: this.props.onError
            }), u || this.state.overlappingAnnotation ? null : E))) : d.createElement(Je.Z, {
              onPointerDown: w ? this._handlePress : void 0,
              onDOMElement: this._onDOMElement
            }, d.createElement("button", {
              className: x,
              "data-name": a,
              style: b,
              disabled: !w || l,
              onFocus: this._handleFocus,
              onBlur: this._handleBlur
            }, this.state.overlappingAnnotation ? d.createElement(i.TX, {
              tag: "span"
            }, a, ", ", e(ke.Z.signed)) : E));
          }
        }
        const zr = (0, xe.XN)(Ar, {
          forwardRef: !0
        });
        var Tr = n(67009);
        const Or = (0, qn.x)(function (e, t) {
            const {
                annotation: n
              } = t,
              r = n.pageIndex,
              o = e.pages.get(r),
              i = e.features,
              a = e.signatureFeatureAvailability;
            (0, Ce.k)(o, "Cannot find page for widgetAnnotation with id ", n.id);
            const s = (0, j.xp)(e.annotations, o),
              l = s.filter(e => e instanceof de.Zc).toList(),
              u = s.filter(e => e instanceof de.sK).toList();
            return {
              isDigitallySigned: (0, Tr.Zt)(e, n),
              inkAnnotations: l,
              imageAnnotations: u,
              isAnnotationPressPrevented: t => (0, j.TW)(t, e.eventEmitter),
              backend: e.backend,
              features: i,
              signatureFeatureAvailability: a,
              hasSignatureLicenseComponent: i.includes(ee.q.DIGITAL_SIGNATURES) || i.includes(ee.q.ELECTRONIC_SIGNATURES)
            };
          })(zr),
          Ir = Or;
        function Fr(e, t) {
          return Fr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
            return e.__proto__ = t, e;
          }, Fr(e, t);
        }
        function Mr(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Fr(e, t);
        }
        var Rr = n(69867),
          jr = n(21853),
          Br = n(18920);
        function Nr() {
          Nr = function (e, t) {
            return new n(e, void 0, t);
          };
          var e = RegExp.prototype,
            t = new WeakMap();
          function n(e, r, o) {
            var i = new RegExp(e, r);
            return t.set(i, o || t.get(e)), Fr(i, n.prototype);
          }
          function r(e, n) {
            var r = t.get(n);
            return Object.keys(r).reduce(function (t, n) {
              var o = r[n];
              if ("number" == typeof o) t[n] = e[o];else {
                for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
                t[n] = e[o[i]];
              }
              return t;
            }, Object.create(null));
          }
          return Mr(n, RegExp), n.prototype.exec = function (t) {
            var n = e.exec.call(this, t);
            if (n) {
              n.groups = r(n, this);
              var o = n.indices;
              o && (o.groups = r(o, this));
            }
            return n;
          }, n.prototype[Symbol.replace] = function (n, o) {
            if ("string" == typeof o) {
              var i = t.get(this);
              return e[Symbol.replace].call(this, n, o.replace(/\$<([^>]+)>/g, function (e, t) {
                var n = i[t];
                return "$" + (Array.isArray(n) ? n.join("$") : n);
              }));
            }
            if ("function" == typeof o) {
              var a = this;
              return e[Symbol.replace].call(this, n, function () {
                var e = arguments;
                return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(r(e, a)), o.apply(this, e);
              });
            }
            return e[Symbol.replace].call(this, n, o);
          }, Nr.apply(this, arguments);
        }
        function Lr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Vr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Lr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Lr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Kr = ["m/d", "m/d/yy", "mm/dd/yy", "mm/yy", "d-mmm", "d-mmm-yy", "dd-mmm-yy", "yy-mm-dd", "mmm-yy", "mmmm-yy", "mmm d, yyyy", "mmmm d, yyyy", "m/d/yy h:MM tt", "m/d/yy HH:MM"],
          qr = ["HH:MM", "h:MM tt", "HH:MM:ss", "h:MM:ss tt"];
        function Hr(e, t) {
          const {
            value: n,
            readOnly: r
          } = e.formField;
          return {
            initialValue: n,
            value: n,
            valueFromCurrentProps: n,
            readOnlyFromCurrentProps: r,
            isFocused: !!t && t.isFocused,
            initialEditingValue: e.editingValue,
            editingValue: t ? t.editingValue : e.editingValue,
            shouldRecalculateWhenOverflow: !1
          };
        }
        class Ur extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", Hr(this.props)), (0, o.Z)(this, "_usedHeight", 0), (0, o.Z)(this, "_latestKeystrokeDiff", null), (0, o.Z)(this, "_memoizedGetTextareaUsedHeight", (0, dn.Z)($r)), (0, o.Z)(this, "_memoizedCalculateFontSize", (0, dn.Z)(ar.MX)), (0, o.Z)(this, "_memoizedCalculateCombLetterSpacing", (0, dn.Z)(Zr)), (0, o.Z)(this, "_reusableRealmRemoveTimeout", null), (0, o.Z)(this, "_reusableRealm", null), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "_onChange", () => {
              const e = this._inputRef.current;
              (0, u.kG)(e);
              const {
                  value: t
                } = e,
                {
                  comb: n,
                  doNotScroll: r,
                  multiLine: o
                } = this.props.formField,
                i = t.length < this.state.value.length,
                {
                  zoomLevel: a,
                  annotation: {
                    fontSize: s,
                    lineHeightFactor: l
                  }
                } = this.props;
              if (r && !n && !i) {
                const n = "auto" === s || null == s ? ar.w5[0] : s,
                  r = e.parentNode;
                (0, u.kG)(r);
                const i = e.cloneNode(!0),
                  c = n * a - (o ? 0 : parseFloat(i.style.paddingTop) + parseFloat(i.style.paddingBottom));
                i.style.fontSize = `${c}px`, i.style.borderWidth = "0px", i.style.textAlign = "left", "TEXTAREA" === i.tagName ? i.innerText = t : i.value = t;
                let d = !0;
                r.appendChild(i);
                try {
                  if (o) {
                    const t = c * (null != l ? l : 1),
                      n = parseFloat(e.style.height) / t < 2,
                      r = n ? 0 : Math.min(.4 * c * a, 5 * a);
                    i.style.lineHeight = n ? `${Math.min(c, t)}px` : `${Math.min(t, parseFloat(e.style.height) - r || 0)}px`, i.style.paddingTop = `${r}px`, d = (0, jr.f)(i);
                  } else d = (0, jr.o5)(i);
                } finally {
                  r.removeChild(i);
                }
                if (d) return;
              }
              const {
                backend: c,
                formField: d,
                annotation: p
              } = this.props;
              if (!(0, Ke.sC)(c, p, d)) return void this.setState({
                value: t
              });
              const {
                  selectionStart: h
                } = e,
                f = (0, F.QE)("string" == typeof this.state.initialEditingValue ? this.state.initialEditingValue : this.state.initialValue, t, h);
              this._latestKeystrokeDiff = f;
              const m = {
                change: f.change,
                value: f.prev,
                returnCode: !0,
                name: this.props.formField.name,
                selStart: h,
                selEnd: f.endCursorPosition
              };
              this.setState({
                value: t,
                editingValue: t
              }), c.onKeystrokeEvent(m).then(t => {
                if (f !== this._latestKeystrokeDiff || 0 === t.length) return;
                const n = t[0].object;
                if (!n.returnCode) return void this.setState({
                  value: this.state.initialValue,
                  editingValue: this.state.initialEditingValue
                });
                const r = (0, F.F6)(f, n.change),
                  o = t.slice(1);
                o.length && this.props.dispatch((0, er.bt)({
                  changes: o
                })), this.setState({
                  value: r,
                  initialValue: r,
                  editingValue: r,
                  initialEditingValue: r
                }, function () {
                  n.selStart !== e.selectionStart && (e.selectionStart = n.selStart), n.selEnd !== f.endCursorPosition && (e.selectionEnd = n.selEnd);
                });
              }).catch(u.vU);
            }), (0, o.Z)(this, "_onFocus", e => {
              const t = this._inputRef.current;
              this.setState({
                isFocused: !0,
                shouldRecalculateWhenOverflow: !!t && t.clientHeight < t.scrollHeight
              });
              const {
                onFocus: n
              } = this.props;
              n && (e.persist(), n(this.props.annotation, e.nativeEvent));
            }), (0, o.Z)(this, "_onBlur", e => {
              this.setState({
                isFocused: !1
              }), this.props.annotationToFocus === this.props.annotation.id && this.props.dispatch((0, yt.vy)(null)), this._latestKeystrokeDiff = null, this._commitChanges();
              const {
                onBlur: t
              } = this.props;
              t && (e.persist(), t(this.props.annotation, e.nativeEvent));
            });
          }
          static getDerivedStateFromProps(e, t) {
            return t.valueFromCurrentProps !== e.formField.value || t.readOnlyFromCurrentProps !== e.formField.readOnly ? Hr(e, t) : null;
          }
          componentWillUnmount() {
            this._latestKeystrokeDiff = null, this._commitChanges();
            const {
              onBlur: e,
              annotation: t
            } = this.props;
            e && e(t, (0, Br.My)("blur"));
          }
          _commitChanges() {
            this.props.formField.value !== this.state.value && this.props.dispatch((0, er.xh)([Vr({
              name: this.props.formField.name,
              value: this.state.value
            }, this.props.formField.multiLine && {
              isFitting: (0, ar.$Z)(this.props.annotation, this.state.value, this.props.zoomLevel)
            })], e => {
              e.some(e => e.name === this.props.formField.name) && this.setState({
                value: this.state.initialValue,
                editingValue: this.state.initialEditingValue
              });
            }));
          }
          _dateFormat() {
            var e, t;
            const {
                annotation: n
              } = this.props,
              r = (null === (e = n.additionalActions) || void 0 === e || null === (e = e.onFormat) || void 0 === e ? void 0 : e.script) || (null === (t = this.props.formField.additionalActions) || void 0 === t || null === (t = t.onFormat) || void 0 === t ? void 0 : t.script);
            if (!r) return null;
            const o = Nr(/(AFTime|AFDate)_([FormatEx]*)\("*([0-9]+|[\w\d\s:\-/]*)"*\)/, {
                name: 1,
                type: 2,
                argument: 3
              }),
              i = r.match(o);
            if (!i) return null;
            const {
              argument: a,
              type: s,
              name: l
            } = i.groups;
            if ("FormatEx" === s) {
              const e = a.match(/[d|y|m]/);
              return "AFDate" === l && e || "AFTime" === l && !e ? a : null;
            }
            switch (l) {
              case "AFDate":
                return Kr[a];
              case "AFTime":
                return qr[a];
            }
            return null;
          }
          _dateInputType(e) {
            if (e) {
              const t = e.match(/[d|y|m]/),
                n = e.match(/[H|h|M|t]/);
              if (t && n) return "datetime-local";
              if (n) return "time";
            }
            return "date";
          }
          _getReusableRealm() {
            return this._reusableRealm ? this._reusableRealm.window.document.body.innerHTML = "" : this._reusableRealm = (0, jr.Aw)(this.props.frameWindow), this._reusableRealmRemoveTimeout && clearTimeout(this._reusableRealmRemoveTimeout), this._reusableRealmRemoveTimeout = setTimeout(() => {
              this._reusableRealm && this._reusableRealm.remove(), this._reusableRealm = null, this._reusableRealmRemoveTimeout = null;
            }, 200), (0, u.kG)(this._reusableRealm), this._reusableRealm;
          }
          componentDidMount() {
            this.props.formField.multiLine && !this.props.formField.password && "number" != typeof this.props.annotation.lineHeightFactor && this.props.backend.getSuggestedLineHeightFactor(this.props.annotation).then(e => {
              this.props.dispatch((0, yt.Zr)((0, s.aV)([this.props.annotation.set("lineHeightFactor", e)])));
            }).catch(u.vU);
          }
          componentDidUpdate(e) {
            var t;
            e.annotationToFocus !== this.props.annotationToFocus && this.props.annotationToFocus === this.props.annotation.id && (null === (t = this._inputRef.current) || void 0 === t || t.focus());
          }
          render() {
            const {
                annotation: {
                  boundingBox: {
                    width: e,
                    height: t
                  },
                  lineHeightFactor: n
                },
                annotation: r,
                formField: {
                  name: o,
                  password: a,
                  maxLength: s,
                  doNotSpellCheck: l,
                  doNotScroll: u,
                  multiLine: c,
                  readOnly: p,
                  comb: f,
                  required: m
                },
                zoomLevel: g,
                formDesignMode: v,
                formattedValue: y,
                frameWindow: b,
                isRenderingAPStream: w,
                canFillFormFieldCP: x
              } = this.props,
              D = function (e, t) {
                return e.isFocused || null == t ? e.isFocused && null != e.editingValue ? e.editingValue : e.value : t;
              }(this.state, y),
              C = this._memoizedCalculateFontSize(D, e, t, r.fontSize, c, r.borderWidth || 0, this._inputRef.current),
              S = Vr({
                width: r.boundingBox.width * g,
                height: r.boundingBox.height * g,
                fontSize: C * g
              }, w ? {
                opacity: 0
              } : Vr(Vr({}, (0, Ke.i2)(r, g)), {}, {
                overflow: u ? "hidden" : "auto",
                paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: c ? ar.DI * g : 0,
                paddingRight: c ? ar.DI * g : 0
              }));
            if (r.horizontalAlign && (S.textAlign = r.horizontalAlign), r.verticalAlign && !c && ("bottom" === r.verticalAlign ? S.paddingTop = S.height - S.fontSize - 2 * S.borderWidth : "top" === r.verticalAlign && (S.paddingBottom = S.height - S.fontSize - 2 * S.borderWidth)), f && "number" == typeof s && !c) {
              const t = this._memoizedCalculateCombLetterSpacing(C, e, s, b.document, this._inputRef.current) * g;
              S.fontFamily = "monospace", S.letterSpacing = t, S.paddingLeft = t / 2, S.paddingRight = 0;
            }
            const E = a ? "password" : "text",
              _ = x && !p,
              P = h()({
                [Un().readOnly]: !_,
                [Un().widget]: !0,
                [Un().combNoPaddingLeftOnFocus]: f && s,
                [Un().onFocus]: !0,
                "PSPDFKit-Annotation-Widget PSPDFKit-Annotation-Widget-Text": !0,
                "PSPDFKit-Annotation-Widget-read-only": !_,
                "PSPDFKit-Annotation-Widget-Required": m
              }),
              k = !_ || v;
            if (!a && c) {
              let e = ar.n * g;
              const t = S.height - S.fontSize;
              t - 2 * e < 0 && (e = t > 0 ? t / 2 : 0);
              const i = Math.min(S.fontSize * (null != n ? n : 1), S.height),
                a = S.height / i < 2 ? 0 : Math.min(.4 * C * g, 5 * g),
                u = Vr(Vr({}, S), {}, {
                  resize: "none",
                  paddingTop: a,
                  paddingLeft: ar.DI * g,
                  paddingRight: ar.DI * g,
                  lineHeight: `${i}px`
                });
              if (r.verticalAlign && "top" !== r.verticalAlign) {
                this._usedHeight = this._memoizedGetTextareaUsedHeight(D || " ", r.boundingBox.width, g, C, this._getReusableRealm());
                const t = u.height - (this._usedHeight || u.fontSize);
                "bottom" === r.verticalAlign ? u.paddingTop = u.height > this._usedHeight ? t - e - 2 * u.borderWidth : 0 : "center" === r.verticalAlign && (u.paddingTop = u.height > this._usedHeight ? t / 2 - u.borderWidth : 0, u.paddingBottom = u.height > this._usedHeight ? t / 2 - e - u.borderWidth : 0);
              }
              return d.createElement("textarea", {
                ref: this._inputRef,
                className: P,
                name: o,
                readOnly: k,
                value: D,
                style: u,
                maxLength: s,
                spellCheck: !l,
                onChange: this._onChange,
                onBlur: this._onBlur,
                onFocus: this._onFocus,
                required: m
              });
            }
            const A = this._dateFormat(),
              z = this._dateInputType(A);
            return A && z ? d.createElement(i.qe, {
              ref: this._inputRef,
              style: S,
              className: P,
              name: o,
              value: D,
              disabled: k,
              type: z,
              maxLength: s,
              format: A,
              onChange: this._onChange,
              onBlur: this._onBlur,
              onFocus: this._onFocus,
              required: m
            }) : d.createElement("input", {
              ref: this._inputRef,
              className: P,
              type: E,
              disabled: k,
              maxLength: s,
              name: o,
              value: D,
              style: S,
              spellCheck: !l,
              onChange: this._onChange,
              onBlur: this._onBlur,
              onFocus: this._onFocus,
              required: m
            });
          }
        }
        function Zr(e, t, n, r, o) {
          let i,
            a = e / 2;
          try {
            i = new Rr.f(r, (0, s.aV)(["_"]), {
              fontSize: `${e}px`,
              width: `${t}px`,
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              fontFamily: "monospace"
            }, Un().widget, o && o.parentNode);
            const n = i.measure().first();
            (0, u.kG)(n), a = n.width;
          } finally {
            i && i.remove();
          }
          const l = t / n - a;
          return Math.max(l, 0);
        }
        function $r(e, t, n, r, o) {
          let i;
          try {
            const a = {
              width: `${Math.ceil(t * n)}px`,
              fontSize: r * n + "px",
              padding: `0 ${ar.DI * n}px`,
              whiteSpace: "pre-wrap",
              overflowWrap: "break-word",
              maxWidth: t * n + "px",
              border: `${Math.max(1, n)}px solid transparent`,
              boxSizing: "border-box",
              display: "block",
              fontFamily: "Helvetica, sans-serif",
              margin: "0",
              outline: "0"
            };
            return i = new Rr.f(o.window.document, e, a), i.wrapper ? i.wrapper.scrollHeight : 0;
          } finally {
            i && i.remove();
          }
        }
        var Gr = n(6502);
        function Wr(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Yr(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Wr(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wr(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Xr extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              isFocused: !1,
              isComboboxOpen: !1,
              isRollover: !1,
              isDown: !1
            }), (0, o.Z)(this, "_elementBoundingBox", null), (0, o.Z)(this, "_pointerRecognizerRef", e => {
              this._pointerRecognizer = e;
            }), (0, o.Z)(this, "onFocus", (e, t) => {
              const {
                onFocus: n,
                dispatch: r,
                annotation: {
                  additionalActions: o,
                  formFieldName: i
                }
              } = this.props;
              o && o.onFocus && r((0, Gr.gH)(o.onFocus.script, "onFocus", i)), n && n(e, t), this.setState({
                isFocused: !0
              });
            }), (0, o.Z)(this, "onBlur", (e, t) => {
              const {
                onBlur: n,
                dispatch: r,
                annotation: {
                  additionalActions: o,
                  formFieldName: i
                }
              } = this.props;
              o && o.onBlur && r((0, Gr.gH)(o.onBlur.script, "onBlur", i)), n && n(e, t), this.setState({
                isFocused: !1
              });
            }), (0, o.Z)(this, "onPointerUp", () => {
              var e;
              null !== (e = this.props.annotation.additionalActions) && void 0 !== e && e.onPointerUp && this.props.dispatch((0, Gr.TU)(this.props.annotation, "onPointerUp")), this.state.isDown && this.setState({
                isDown: !1
              });
            }), (0, o.Z)(this, "onPointerEnter", () => {
              var e, t;
              this._elementBoundingBox = null === (e = this._pointerRecognizer) || void 0 === e ? void 0 : e.getBoundingClientRect(), null !== (t = this.props.annotation.additionalActions) && void 0 !== t && t.onPointerEnter && this.props.dispatch((0, Gr.TU)(this.props.annotation, "onPointerEnter")), this.props.hasRolloverVariantAPStream && this.setState({
                isRollover: !0
              });
            }), (0, o.Z)(this, "onPointerLeave", () => {
              var e;
              null !== (e = this.props.annotation.additionalActions) && void 0 !== e && e.onPointerLeave && this.props.dispatch((0, Gr.TU)(this.props.annotation, "onPointerLeave")), this.state.isRollover && this.setState({
                isRollover: !1,
                isDown: !1
              });
            }), (0, o.Z)(this, "onRootPointerMove", e => {
              var t, n, r, o;
              this._elementBoundingBox && this.state.isRollover && (e.clientX < (null === (t = this._elementBoundingBox) || void 0 === t ? void 0 : t.left) || e.clientX > (null === (n = this._elementBoundingBox) || void 0 === n ? void 0 : n.right) || e.clientY < (null === (r = this._elementBoundingBox) || void 0 === r ? void 0 : r.top) || e.clientY > (null === (o = this._elementBoundingBox) || void 0 === o ? void 0 : o.bottom)) && this.onPointerLeave();
            }), (0, o.Z)(this, "handlePointerUp", e => {
              e.stopPropagation();
            }), (0, o.Z)(this, "handleOpenStateChange", e => {
              var t, n;
              (this.setState({
                isComboboxOpen: e
              }), this.props.isComboBoxOpen && this.props.isComboBoxOpen(e), e) || null === (t = (n = this.props).handleComboBoxRect) || void 0 === t || t.call(n, null);
            }), (0, o.Z)(this, "handleComboBoxRect", e => {
              var t, n;
              null === (t = (n = this.props).handleComboBoxRect) || void 0 === t || t.call(n, e);
            }), (0, o.Z)(this, "handlePointerDown", e => {
              if (e.isPrimary && this.props.isSelectable && this.props.hasDownVariantAPStream && this.setState({
                isDown: !0
              }), !e.isPrimary || !this.props.isSelectable || this.props.formField instanceof _.R0 && !this.props.formDesignMode) return;
              const t = {
                selectedAnnotationShouldDrag: "touch" !== e.pointerType ? new _.E9({
                  x: e.clientX,
                  y: e.clientY
                }) : null,
                stopPropagation: !0
              };
              this.props.dispatch((0, _e.mg)(this.props.annotation, e, t));
            });
          }
          renderWidgetComponent(e) {
            const {
              formField: t,
              canFillFormFieldCP: n,
              frameWindow: r,
              shadowRoot: o
            } = this.props;
            (0, u.kG)(t), (0, u.kG)(r);
            const i = {
              dispatch: this.props.dispatch,
              annotation: this.props.annotation,
              zoomLevel: this.props.zoomLevel,
              frameWindow: r,
              onFocus: this.onFocus,
              onBlur: this.onBlur,
              onPointerUp: e ? this.handlePointerUp : void 0,
              formDesignMode: this.props.formDesignMode,
              backend: this.props.backend,
              formattedValue: this.props.formattedValue,
              editingValue: this.props.editingValue,
              isRenderingAPStream: e,
              canFillFormFieldCP: n,
              viewportState: this.props.viewportState,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected,
              annotationToFocus: this.props.annotationToFocus,
              shadowRoot: o,
              isFocused: this.state.isFocused
            };
            if (t instanceof _.$o) return d.createElement(Ur, (0, ce.Z)({}, i, {
              formField: t
            }));
            if (t instanceof _.Vi) return d.createElement(yr, (0, ce.Z)({}, i, {
              formField: t
            }));
            if (t instanceof _.rF) return d.createElement(or, (0, ce.Z)({}, i, {
              formField: t
            }));
            if (t instanceof _.fB) return d.createElement(pr, (0, ce.Z)({}, i, {
              handleComboxBoxRect: this.handleComboBoxRect,
              onOpenStateChange: this.handleOpenStateChange,
              formField: t
            }));
            if (t instanceof _.XQ) return d.createElement(Cr, (0, ce.Z)({}, i, {
              formField: t
            }));
            if (t instanceof _.R0) return d.createElement(Yn, (0, ce.Z)({}, i, {
              formField: t
            }));
            if (t instanceof _.Yo) return d.createElement(Ir, (0, ce.Z)({}, i, {
              isDragging: this.props.isDragging,
              formField: t
            }));
            throw new Error("Unsupported type for FormField.");
          }
          renderWidgetMaybeWithAPStream() {
            const {
                annotation: e,
                zoomLevel: t,
                backend: n,
                formField: r,
                isDragging: o,
                shouldKeepRenderingAPStream: i,
                intl: {
                  formatMessage: a
                }
              } = this.props,
              s = i && !this.state.isComboboxOpen && (!this.state.isFocused || r instanceof _.rF || r instanceof _.XQ || r instanceof _.R0),
              l = (0, j.vk)(e.blendMode),
              u = l ? {
                mixBlendMode: l
              } : {};
            let c;
            return this.state.isRollover && (c = "rollover"), this.state.isDown && (c = "down"), d.createElement("div", {
              style: u
            }, this.renderWidgetComponent(s), !s || r instanceof _.Yo ? null : d.createElement(le.Reparent, {
              id: `annotation-widget-${e.id}`,
              className: Ze().APStreamParent
            }, d.createElement(We, {
              annotation: e,
              variant: c,
              zoomLevel: t,
              backend: n,
              formField: r,
              label: a(ke.Z.annotation),
              isDragging: o
            })));
          }
          render() {
            const {
              annotation: {
                rotation: e,
                boundingBox: t,
                id: n
              },
              zoomLevel: r,
              formDesignMode: o,
              formField: i,
              isSelectable: a
            } = this.props;
            if (!i) return null;
            const s = 90 === (0, He.Lv)(e) || 270 === (0, He.Lv)(e);
            let l = Jr,
              u = eo;
            s && (l = Yr(Yr({}, l), {}, {
              transformOrigin: "50% 50%",
              transform: (0, Ke.G8)({
                width: Math.ceil(t.width * r),
                height: Math.ceil(t.height * r),
                rotation: (0, He.Lv)(e)
              })
            }), u = Yr(Yr({}, u), {}, {
              transformOrigin: "50% 50%",
              transform: (0, Ke.G8)({
                width: Math.ceil(t.width * r),
                height: Math.ceil(t.height * r),
                rotation: (0, He.Lv)(e),
                reverse: !0
              })
            }));
            const c = h()((i instanceof _.rF || i instanceof _.XQ || i instanceof _.R0 || i instanceof _.Yo) && Ze().focusWithinOutline, "PSPDFKit-Annotation");
            return d.createElement(Ee, {
              position: t.getLocation(),
              zoomLevel: r,
              isMultiAnnotationsSelected: this.props.isMultiAnnotationsSelected
            }, d.createElement(Je.Z, {
              onPointerDown: this.handlePointerDown,
              onPointerUp: this.onPointerUp,
              onPointerEnter: this.onPointerEnter,
              onPointerLeave: this.onPointerLeave,
              onRootPointerMove: this.onRootPointerMove,
              onDOMElement: this._pointerRecognizerRef
            }, o && a ? d.createElement("div", {
              style: l,
              className: "PSPDFKit-Annotation",
              "data-annotation-id": n
            }, d.createElement("div", {
              style: u
            }, this.renderWidgetMaybeWithAPStream())) : d.createElement("div", {
              className: c,
              "data-annotation-id": n
            }, this.renderWidgetMaybeWithAPStream())));
          }
        }
        const Qr = (0, xe.XN)(Xr, {
            forwardRef: !0
          }),
          Jr = {
            cursor: "pointer"
          },
          eo = {
            pointerEvents: "none"
          };
        var to = n(72127);
        const no = (0, qn.x)(function (e, t) {
            let {
              annotation: n
            } = t;
            const r = e.formFields.get(n.formFieldName),
              o = r && e.formattedFormFieldValues.get(r.name),
              i = r && e.editingFormFieldValues.get(r.name);
            return {
              annotation: n,
              formField: (null == r ? void 0 : r.set("readOnly", (0, Kn.VY)(r, n, e))) || null,
              frameWindow: e.frameWindow,
              formDesignMode: e.formDesignMode,
              backend: e.backend,
              formattedValue: o,
              editingValue: i,
              canFillFormFieldCP: !!r && (0, to.os)(r, e),
              viewportState: e.viewportState,
              isViewStateReadOnly: te.J.VIA_VIEW_STATE,
              hasDownVariantAPStream: !("number" != typeof n.pdfObjectId || !e.APStreamVariantsDown.has(n.pdfObjectId)),
              hasRolloverVariantAPStream: !("number" != typeof n.pdfObjectId || !e.APStreamVariantsRollover.has(n.pdfObjectId)),
              annotationToFocus: e.widgetAnnotationToFocus,
              shadowRoot: e.shadowRoot
            };
          }, {
            forwardRef: !0
          })(Qr),
          ro = no;
        var oo = n(93408),
          io = n.n(oo),
          ao = n(81026);
        const so = ao.p1;
        const lo = function (e) {
            var t;
            const {
                annotation: n,
                dispatch: r,
                zoomLevel: o,
                isAnnotationSelected: i,
                activeAnnotationNote: a,
                visible: s
              } = e,
              l = a && (null === (t = a.parentAnnotation) || void 0 === t ? void 0 : t.id) === n.id,
              u = n.isCommentThreadRoot,
              c = d.useMemo(() => l && a ? a : (0, ao.Yu)(n, u ? 24 : so, u ? 24 : so), [n, l, u, a]),
              p = c.position,
              f = (u || n.note || l) && function (e) {
                return !(e instanceof de.Qi || e instanceof de.gd || e instanceof de.Jn || e instanceof de.x_ || e instanceof de.R1 || function (e) {
                  return e.creatorName && /AutoCAD SHX Text/i.test(e.creatorName);
                }(e));
              }(n),
              m = !De.Ni && !u,
              {
                width: g,
                height: v
              } = c.boundingBox,
              y = {
                width: g,
                height: v,
                transformOrigin: "top left",
                transform: `translate(${g * o / 2 - g / 2}px, ${v * o / 2 - v / 2}px)`,
                cursor: (0, j.B7)(n, {
                  isAnnotationNote: !0
                })
              },
              b = n.constructor.readableName,
              w = (0, j.B7)(n);
            return d.createElement(d.Fragment, null, f && d.createElement(Ee, {
              position: p,
              zoomLevel: o
            }, d.createElement(Je.Z, {
              onPointerUp: e => {
                u ? r((0, _e.mg)(n, e)) : (i || r((0, _e.mg)(c.parentAnnotation, e)), r((0, _e.mv)(c))), e && e.stopPropagation();
              }
            }, d.createElement("div", {
              className: h()({
                "PSPDFKit-Annotation-Note": !0,
                [io().noteIndicator]: !0,
                [io().noteIndicatorActive]: i || l,
                [`PSPDFKit-Annotation-Note-${b}Annotation`]: !!b
              }),
              onMouseEnter: m ? e => {
                r((0, _e._3)(c)), e && e.stopPropagation();
              } : void 0,
              onMouseLeave: m ? e => {
                r((0, _e._3)(null)), e && e.stopPropagation();
              } : void 0,
              style: {
                cursor: w
              }
            }, s ? d.createElement(Ae.Z, {
              style: y,
              className: h()(io().icon, l && io().iconActive),
              type: u ? "comment-indicator" : "note-indicator"
            }) : d.createElement("div", {
              style: y
            })))));
          },
          uo = d.memo(function (e) {
            const {
                annotation: t,
                annotation: {
                  boundingBox: n
                },
                zoomLevel: r,
                backend: o,
                isMultiAnnotationsSelected: i
              } = e,
              {
                formatMessage: a
              } = (0, xe.YB)(),
              s = {
                width: n.width * r,
                height: n.height * r
              },
              [l, c] = d.useState(void 0),
              [p, f] = d.useState(void 0);
            d.useEffect(() => {
              o.cachedRenderAnnotation(t, void 0, s.width, s.height).promise.then(e => {
                if ((null == e ? void 0 : e.element) instanceof HTMLImageElement) return f(e.element.src);
              }).catch(e => {
                throw new u.p2(`Could not render the media annotation: ${e.message}`);
              });
            }, [t, o, s.width, s.height]), d.useEffect(() => {
              o.getAttachment(t.mediaAttachmentId).then(e => c(e)).catch(() => {
                throw new u.p2("Could not get media attachment for " + t.id);
              });
            }, [t.mediaAttachmentId, o, t.id]);
            const m = d.useMemo(() => l ? URL.createObjectURL(l) : "", [l]);
            return d.useEffect(() => function () {
              m && URL.revokeObjectURL(m);
            }, [m]), m ? d.createElement(Ee, {
              position: n.getLocation(),
              zoomLevel: r,
              isMultiAnnotationsSelected: i
            }, d.createElement("div", {
              className: h()("PSPDFKit-MediaAnnotation", "PSPDFKit-Annotation"),
              "data-annotation-id": t.id
            }, d.createElement("video", {
              src: m,
              controls: !0,
              width: s.width,
              height: s.height,
              poster: p,
              "aria-label": `${a(ke.Z.annotation)}: ${a(ke.Z.mediaAnnotation)} ${t.fileName}`
            }, a(ke.Z.mediaFormatNotSupported)))) : null;
          }),
          co = uo;
        var po = n(68540);
        const ho = d.forwardRef(function (e, t) {
            let {
              annotation: n,
              globalAnnotation: r,
              attachments: o,
              backend: i,
              dispatch: a,
              isAnnotationReadOnly: s,
              isDisabled: u,
              isHover: c,
              isFocused: p,
              onBlur: h,
              onFocus: f,
              pageSize: m,
              zoomLevel: g,
              rotation: v,
              pageRotation: y,
              isSelected: b,
              showAnnotationNotes: w,
              activeAnnotationNote: x,
              onClick: D,
              isResizing: C = !1,
              isModifying: S = !1,
              isDragging: E = !1,
              isRotating: _ = !1,
              isAutoSaveDisabled: P,
              cursor: k,
              shouldRenderAPStream: A,
              isMultiAnnotationsSelected: z = !1,
              isComboBoxOpen: T,
              handleComboBoxRect: O
            } = e;
            const [I, F] = d.useState(!1),
              M = d.useCallback(() => F(!0), []),
              R = (0, l.v9)(e => "formFieldName" in n ? e.formFields.get(n.formFieldName) : void 0),
              B = (0, l.v9)(e => (0, Tr.Zt)(e, n)),
              N = (0, po.jC)({
                annotation: n,
                formField: R,
                zoomLevel: g,
                isDigitallySignedWidget: B
              });
            d.useEffect(() => {
              N && Qe({
                annotation: n,
                formField: R,
                zoomLevel: g,
                isDigitallySigned: B
              }, N) && F(!1);
            }, [n, R, g, B]);
            const L = s(n),
              V = {
                backend: i,
                dispatch: a,
                isDisabled: u,
                isSelectable: !L,
                onBlur: h,
                onFocus: f,
                ref: t,
                zoomLevel: g,
                rotation: v,
                isDragging: E,
                isAutoSaveDisabled: P,
                shouldKeepRenderingAPStream: A && !C && !S && !_ && !I,
                isFocused: p,
                isMultiAnnotationsSelected: z,
                cursor: k,
                isComboBoxOpen: T,
                handleComboBoxRect: O,
                onError: M
              },
              K = (0, l.v9)(e => e.secondaryMeasurementUnit);
            let q = null;
            return n instanceof de.Hu && (q = d.createElement(co, (0, ce.Z)({}, V, {
              annotation: n
            }))), n instanceof de.sK ? q = d.createElement(rt, (0, ce.Z)({}, V, {
              attachment: n.imageAttachmentId ? o.get(n.imageAttachmentId) : null,
              annotation: n
            })) : n instanceof de.Zc ? q = d.createElement(dt, (0, ce.Z)({}, V, {
              annotation: n
            })) : n instanceof de.R1 ? q = d.createElement(vt, (0, ce.Z)({}, V, {
              isHover: c,
              annotation: n
            })) : n instanceof de.Qi ? q = d.createElement(Et, (0, ce.Z)({}, V, {
              isReadOnly: L,
              annotation: n
            })) : n instanceof de.UX ? q = d.createElement(on, (0, ce.Z)({}, V, {
              annotation: n,
              secondaryMeasurementUnit: K
            })) : n instanceof de.GI ? q = d.createElement(ln, (0, ce.Z)({}, V, {
              annotation: n,
              globalAnnotation: r,
              isAutoSaveDisabled: P
            })) : n instanceof de.gd ? q = d.createElement(Cn, (0, ce.Z)({}, V, {
              pageSize: m,
              onClick: D,
              annotation: n,
              globalAnnotation: r
            })) : n instanceof de.Wk ? q = d.createElement(zn, (0, ce.Z)({}, V, {
              active: b,
              annotation: n
            })) : n instanceof de.On ? q = d.createElement(Bn, (0, ce.Z)({}, V, {
              active: b,
              pageRotation: y,
              annotation: n
            })) : n instanceof de.Ih ? q = d.createElement(Vn, (0, ce.Z)({}, V, {
              annotation: n
            })) : n instanceof de.x_ ? q = d.createElement(ro, (0, ce.Z)({}, V, {
              annotation: n
            })) : n instanceof de.Jn && (q = d.createElement(Ie, (0, ce.Z)({}, V, {
              isReadOnly: L,
              active: b,
              annotation: n
            }))), d.createElement(ve, {
              key: n.id,
              zoomLevel: g,
              renderer: "Annotation",
              notCSSScaled: n instanceof de.x_
            }, d.createElement(mo, {
              annotation: n
            }, q, w && (0, j.YV)(n) && d.createElement(lo, {
              dispatch: a,
              annotation: n,
              zoomLevel: g,
              isAnnotationSelected: b,
              activeAnnotationNote: x,
              visible: !0
            })));
          }),
          fo = ho;
        function mo(e) {
          let {
            children: t
          } = e;
          return d.createElement("div", null, t);
        }
        const go = (0, l.$j)((e, t) => {
            let {
              pageIndex: n
            } = t;
            return {
              viewportState: e.viewportState,
              transformClientToPage: function (t) {
                return e.transformClientToPage(t, n);
              }
            };
          }),
          vo = (0, l.$j)(e => ({
            transformClientToPage: e.transformClientToPage
          }));
        var yo = n(35464),
          bo = n(51491),
          wo = n.n(bo);
        class xo extends d.PureComponent {
          constructor(e) {
            let t, n, r;
            if (super(e), (0, o.Z)(this, "layerRef", d.createRef()), (0, o.Z)(this, "_handlePointerUp", e => {
              if (!e.isPrimary) return;
              const t = this._getNormalizedMousePosition(e);
              if (!t) return;
              const n = this._fitRectInPage(new _.UL({
                  left: t.x - this.sizes.width / 2,
                  top: t.y - this.sizes.height / 2,
                  width: this.sizes.width,
                  height: this.sizes.height
                }), this.props.pageSize),
                r = this.props.annotation.set("pageIndex", this.props.pageIndex).set("boundingBox", n);
              e.stopPropagation(), r instanceof _.Qi ? this.props.dispatch((0, yt.FG)(r)) : r instanceof _.Jn && (this.props.dispatch((0, yt.Zr)((0, s.aV)([r]))), this.props.dispatch((0, yo.mh)(r.id)));
            }), e.annotation instanceof _.Qi) t = n = r = Ne.SP, this.cursor = "context-menu";else {
              if (!(e.annotation instanceof _.Jn)) throw Error("Annotation type not supported.");
              t = n = r = Ne.zk, this.cursor = "context-menu";
            }
            this.sizes = {
              width: t,
              height: n,
              minWidth: r
            };
          }
          _getNormalizedMousePosition(e) {
            const {
              target: t
            } = e;
            if (this.layerRef.current) {
              const {
                defaultView: n
              } = this.layerRef.current.ownerDocument;
              if (t instanceof n.HTMLDivElement) return this.props.transformClientToPage(new _.E9({
                x: e.clientX,
                y: e.clientY
              }), this.props.pageIndex);
            }
          }
          _fitRectInPage(e, t) {
            const {
                width: n,
                height: r
              } = t,
              o = this.sizes.minWidth || this.sizes.width;
            return e.top + e.height > r && (e = e.set("top", r - e.height)), e.left + o > n && (e = e.set("left", n - o)), e;
          }
          render() {
            return d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp
            }, d.createElement("div", {
              "data-testid": "create-annotation-layer"
            }, d.createElement("div", {
              className: wo().layer,
              style: {
                cursor: this.cursor || "auto"
              },
              ref: this.layerRef
            })));
          }
        }
        const Do = vo(xo);
        var Co = n(80054),
          So = n.n(Co);
        class Eo extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              currentSelectableAnnotation: null
            }), (0, o.Z)(this, "_handlePointerDownCapture", e => {
              this._pointerDownTime = Date.now();
              const t = this._transformToPagePoint(e);
              this._selectableAnnotation = this.findSelectableAnnotation(t);
              const n = (0, j.Jy)(this.props.selectedAnnotations, this.props.zoomLevel);
              !De.Ni || !this.props.isMultiAnnotationsSelected || null != n && n.isPointInside(t) || this.checkAnnotationAtPoint(t) || this.props.dispatch((0, _e.fz)());
              const r = this._selectableAnnotation instanceof _.R1;
              var o, i, a, s;
              (r && (this._selectedAnnotationOnDown = this.findSelectedAnnotationAtPoint(t)), this._isInterestedInUpCapture = r && !this._selectedAnnotationOnDown, e.metaKey || e.ctrlKey && this.props.isMultiSelectionEnabled) ? (null === (o = (i = this.props).setMultiAnnsInitialEvent) || void 0 === o || o.call(i, e.nativeEvent), this.props.dispatch((0, Kt.YF)(!0))) : null === (a = (s = this.props).setMultiAnnsInitialEvent) || void 0 === a || a.call(s, void 0);
            }), (0, o.Z)(this, "_handlePointerUpCapture", e => {
              if (!this._selectableAnnotation || !this._isInterestedInUpCapture || !this.getSelection().isCollapsed) return;
              const t = Date.now() - this._pointerDownTime > 300,
                n = this._selectableAnnotation,
                r = n instanceof _.R1;
              if (t && !r) return void (this._selectableAnnotation = null);
              const o = n instanceof _.On || r,
                i = !this._selectedAnnotationOnDown && Boolean(this.findSelectedAnnotationAtPoint(this._transformToPagePoint(e)));
              this.props.dispatch((0, _e.mg)(n, e, {
                preventDefault: o,
                stopPropagation: o,
                clearSelection: i,
                longPress: t && r
              }));
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              if (!this.getSelection().isCollapsed || !this._selectableAnnotation || this._selectedAnnotationOnDown) return;
              const t = this._selectableAnnotation,
                n = t instanceof _.On;
              this.props.dispatch((0, _e.mg)(t, e, {
                preventDefault: n,
                stopPropagation: n
              }));
            }), (0, o.Z)(this, "_handlePointerMove", e => {
              if ("mouse" !== e.pointerType) return;
              const {
                  currentSelectableAnnotation: t
                } = this.state,
                n = this._transformToPagePoint(e),
                r = this.findSelectableAnnotation(n);
              !(0, s.is)(r, t) && (t && this.props.hoverAnnotationIds.has(t.id) && this.props.dispatch((0, _e.IP)(t.id)), !r || this.props.hoverAnnotationIds.has(r.id) || this.checkifHoverPointIsDefferedRegion(new _.E9({
                x: e.clientX,
                y: e.clientY
              })) || this.props.dispatch((0, _e.oX)(r.id)), this.setState({
                currentSelectableAnnotation: r
              }));
            });
          }
          checkifHoverPointIsDefferedRegion(e) {
            if (this.props.hitCaptureDeferredRect && this.props.hitCaptureDeferredRect.length > 0) for (const t of this.props.hitCaptureDeferredRect) {
              if (e.x >= t.left && e.x <= t.right && e.y >= t.top && e.y <= t.bottom) return !0;
            }
            return !1;
          }
          _transformToPagePoint(e) {
            return this.props.transformClientToPage(new _.E9({
              x: e.clientX,
              y: e.clientY
            }), this.props.pageIndex);
          }
          _boundingBoxHitTest(e) {
            const t = De.Ni ? Ne.wK : Ne.XZ;
            return n => n instanceof _.R1 ? n.boundingBox.isPointInside(e) : n.boundingBox.grow(t).isPointInside(e);
          }
          _findSelectableLinkAnnotation(e) {
            return this.props.selectableLinkAnnotations.filter(j.Fp).findLast(this._boundingBoxHitTest(e));
          }
          _findSelectableTextMarkupAnnotation(e) {
            return this.props.selectableTextMarkupAnnotations.filter(j.Fp).findLast(t => t.rects.find(t => t.grow(De.Ni ? Ne.wK : Ne.XZ).isPointInside(e)));
          }
          findSelectableAnnotation(e) {
            const t = this._findSelectableLinkAnnotation(e),
              n = this._findSelectableTextMarkupAnnotation(e);
            return t || n;
          }
          findSelectedAnnotationAtPoint(e) {
            return this.props.selectedAnnotations.findLast(this._boundingBoxHitTest(e));
          }
          checkAnnotationAtPoint(e) {
            var t, n;
            return null !== (t = null === (n = this.props.currentPageAnnotations) || void 0 === n ? void 0 : n.some(t => {
              var n;
              return null === (n = t.boundingBox) || void 0 === n ? void 0 : n.isPointInside(e);
            })) && void 0 !== t && t;
          }
          getSelection() {
            return this.props.window.getSelection();
          }
          render() {
            const e = !!this.state.currentSelectableAnnotation,
              t = h()({
                [So().layer]: !0,
                [So().cursorText]: this.props.keepSelectedTool && "TEXT" === this.props.interactionMode,
                [So().cursorPointer]: e,
                "PSPDFKit-CursorPointer": e
              });
            return d.createElement(Je.Z, {
              onPointerMove: this._handlePointerMove,
              onPointerUp: this._handlePointerUp,
              onPointerDownCapture: this.props.isHitCaptureDeferred ? void 0 : this._handlePointerDownCapture,
              onPointerDown: this.props.isHitCaptureDeferred ? this._handlePointerDownCapture : void 0,
              onPointerUpCapture: this._handlePointerUpCapture
            }, d.createElement("div", {
              className: t
            }, this.props.children));
          }
        }
        const _o = vo(Eo);
        var Po = n(92537);
        class ko extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "precision", (0, ot.HB)(this.props.zoomLevel)), (0, o.Z)(this, "pointsToPathArray", it.Options.ENABLE_INK_SMOOTH_LINES ? e => (0, ot.vR)(e, this.precision) : ot.$U), (0, o.Z)(this, "_pathDataFromFragments", (e, t, n) => {
              if (!n || n.length < 3) return null;
              const r = this.props.annotation.lines.get(t);
              return !r || r.size < n.length || r.size < 4 ? null : r.size === n.length ? n : [...n.slice(0, n.length - 2), ...this.pointsToPathArray(r.slice(n.length - 2)).slice(1)];
            }), (0, o.Z)(this, "_onDrawStart", e => {
              let {
                annotation: t,
                onDrawStart: n
              } = this.props;
              this.precision = (0, ot.HB)(this.props.zoomLevel), t = t.update("lines", t => t.push((0, s.aV)([e, new _.Wm({
                x: e.x,
                y: e.y,
                intensity: e.intensity
              })]))), t = t.set("boundingBox", (0, ot.gz)(t)), n(t);
            }), (0, o.Z)(this, "_onDraw", e => {
              let {
                  annotation: t,
                  onDraw: n
                } = this.props,
                r = t.lines.last();
              (0, u.kG)(r), r = e.reduce((e, t) => (0, ot.H9)(e, t, this.props.distanceBetweenPoints) ? e.push(t) : e, r.pop()).push(e[e.length - 1]), t = t.setIn(["lines", this.props.annotation.lines.size - 1], r), t = t.set("boundingBox", function (e, t) {
                const {
                  boundingBox: n,
                  lineWidth: r
                } = e;
                let {
                    left: o,
                    top: i,
                    width: a,
                    height: s
                  } = n,
                  l = Math.floor(o),
                  u = Math.floor(i),
                  c = Math.ceil(o + a),
                  d = Math.ceil(i + s);
                return t.forEach(e => {
                  l = Math.floor(Math.min(o, e.x - r / 2)), u = Math.floor(Math.min(i, e.y - r / 2)), c = Math.ceil(Math.max(o + a, e.x + r / 2)), d = Math.ceil(Math.max(i + s, e.y + r / 2)), o = l, i = u, a = c - l, s = d - u;
                }), new _.UL({
                  left: o,
                  top: i,
                  width: a,
                  height: s
                });
              }(t, r)), n(t);
            }), (0, o.Z)(this, "_onDrawEnd", () => {
              let {
                annotation: e,
                onDrawEnd: t
              } = this.props;
              const n = e.lines.last();
              if ((0, u.kG)(n), n.size > 1) {
                const t = n.get(n.size - 2);
                t && 0 === n.last().distance(t) && (e = e.updateIn(["lines", e.lines.size - 1], e => e.pop()));
              }
              t(e);
            });
          }
          render() {
            const {
                annotation: e,
                canvasSize: t,
                zoomLevel: n
              } = this.props,
              {
                boundingBox: r
              } = e;
            return d.createElement("div", {
              className: st().canvas,
              style: {
                cursor: this.props.cursor,
                mixBlendMode: (0, j.vk)(e.blendMode)
              },
              "data-testid": "ink-canvas-outer-div"
            }, d.createElement(Ee, {
              zoomLevel: n,
              applyZoom: !0
            }, d.createElement("div", {
              style: {
                position: "absolute",
                top: r.top,
                left: r.left,
                width: r.width,
                height: r.height
              }
            }, d.createElement(pt, {
              isSelectable: !1,
              annotation: e,
              viewBox: r,
              pathDataFromFragments: this._pathDataFromFragments,
              precision: this.precision
            }))), d.createElement(Vt.Z, {
              scrollElement: this.props.scrollElement,
              size: t,
              onDrawStart: this._onDrawStart,
              onDrawCoalesced: this._onDraw,
              onDrawEnd: this._onDrawEnd,
              transformPoint: this.props.transformPoint,
              interactionMode: this.props.interactionMode,
              canScrollWhileDrawing: this.props.canScrollWhileDrawing
            }));
          }
        }
        (0, o.Z)(ko, "defaultProps", {
          canvasSize: new _.$u({
            width: 300,
            height: 200
          }),
          distanceBetweenPoints: 0,
          cursor: "default",
          zoomLevel: 1
        });
        const Ao = (0, dn.Z)(ot.Vv);
        function zo(e) {
          const t = e.inkAnnotation.lineWidth / 2 * e.viewportState.zoomLevel;
          return {
            currentInkAnnotation: e.inkAnnotation,
            cursor: Ao(t),
            zoomLevel: e.viewportState.zoomLevel,
            inkAnnotationFromCurrentProps: e.inkAnnotation
          };
        }
        class To extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", zo(this.props)), (0, o.Z)(this, "lastEndDrawingTime", Date.now()), (0, o.Z)(this, "_transformClientToPage", e => e.apply(this.props.clientToPageTransformation)), (0, o.Z)(this, "_onDrawStart", e => {
              const t = e.pageIndex,
                n = {
                  annotations: (0, s.aV)([e]),
                  reason: J.f.DRAW_START
                };
              this.props.eventEmitter.emit("annotations.willChange", n), null === t ? e = e.set("pageIndex", this.props.pageIndex) : t !== this.props.pageIndex ? (e = e.set("pageIndex", this.props.pageIndex), this.props.dispatch((0, yt.vc)(e, this.props.pageIndex))) : (0, ot.Ip)(e, this.props.pageSize, this.lastEndDrawingTime) || (e = (e = e.update("lines", e => (0, s.aV)([e.last()]))).set("boundingBox", (0, ot.gz)(e)), this.props.dispatch((0, yt.vc)(e, this.props.pageIndex))), this.setState({
                currentInkAnnotation: e
              });
            }), (0, o.Z)(this, "_onDraw", e => {
              this.setState({
                currentInkAnnotation: e
              });
            }), (0, o.Z)(this, "_onDrawEnd", e => {
              const t = {
                annotations: (0, s.aV)([e]),
                reason: J.f.DRAW_END
              };
              this.props.eventEmitter.emit("annotations.willChange", t), this.lastEndDrawingTime = Date.now(), this.setState({
                currentInkAnnotation: e
              }, () => {
                this.state.currentInkAnnotation.lines.size && this.props.dispatch((0, yt.FG)(this.state.currentInkAnnotation));
              });
            });
          }
          static getDerivedStateFromProps(e, t) {
            return (0, s.is)(t.inkAnnotationFromCurrentProps, e.inkAnnotation) || (0, s.is)(t.currentInkAnnotation, e.inkAnnotation) && e.viewportState.zoomLevel === t.zoomLevel ? null : zo(e);
          }
          componentDidMount() {
            this.props.dispatch((0, Kt.X2)());
          }
          componentWillUnmount() {
            this.props.dispatch((0, Kt.Zg)());
          }
          render() {
            const e = this.state.currentInkAnnotation,
              {
                pageSize: t
              } = this.props,
              {
                INK_EPSILON_RANGE_OPTIMIZATION: n
              } = it.Options;
            return d.createElement(ko, {
              scrollElement: this.props.scrollElement,
              annotation: e,
              canvasSize: t,
              onDrawStart: this._onDrawStart,
              onDrawEnd: this._onDrawEnd,
              onDraw: this._onDraw,
              transformPoint: this._transformClientToPage,
              distanceBetweenPoints: n / (this.props.viewportState.zoomLevel * (0, Po.L)()),
              cursor: this.state.cursor,
              zoomLevel: this.props.viewportState.zoomLevel,
              interactionMode: this.props.interactionMode,
              canScrollWhileDrawing: this.props.canScrollWhileDrawing
            });
          }
        }
        const Oo = (0, l.$j)((e, t) => {
          let {
            pageIndex: n
          } = t;
          return {
            viewportState: e.viewportState,
            clientToPageTransformation: (0, G.zi)(e, n),
            eventEmitter: e.eventEmitter,
            interactionMode: e.interactionMode,
            canScrollWhileDrawing: e.canScrollWhileDrawing
          };
        })(To);
        var Io = n(13205);
        const Fo = 100;
        function Mo(e, t) {
          const n = Math.floor(e.x / Fo);
          return Math.floor(e.y / Fo) * t + n;
        }
        function Ro(e, t, n, r) {
          const {
              lineWidth: o,
              id: i
            } = e,
            a = Math.ceil(r.width / Fo),
            s = t / 2;
          return e.lines.forEach((e, t) => {
            e.forEach((e, r) => {
              if (null == e) return;
              const l = Math.floor(e.x / Fo),
                u = Math.floor(e.y / Fo),
                c = {
                  point: e,
                  annotationId: i,
                  lineIndex: t,
                  pointIndex: r,
                  strokeRadius: o / 2
                },
                d = Math.ceil((s + c.strokeRadius) / Fo);
              for (let t = u - d; t <= u + d; t++) for (let r = l - d; r <= l + d; r++) if (r > -1 && t > -1) {
                if (new Io.Z({
                  x: r < l ? (r + 1) * Fo : r === l ? e.x : r * Fo,
                  y: t < u ? (t + 1) * Fo : t === u ? e.y : t * Fo
                }).distance(e) < s + c.strokeRadius) {
                  const e = t * a + r;
                  n[e] ? n[e].push(c) : n[e] = [c];
                }
              }
            });
          }), n;
        }
        function jo(e, t, n, r) {
          return !(e.x + r < t.x - n || e.x - r > t.x + n || e.y + r < t.y - n || e.y - r > t.y + n) && e.distance(t) < n + r;
        }
        const Bo = (0, l.$j)((e, t) => {
          let {
            pageIndex: n
          } = t;
          return {
            inkEraserCursorWidth: e.inkEraserCursorWidth,
            zoomLevel: e.viewportState.zoomLevel,
            clientToPageTransformation: (0, G.zi)(e, n),
            scrollElement: e.scrollElement,
            interactionMode: e.interactionMode
          };
        })(function (e) {
          const {
              canvasSize: t = new _.$u({
                width: 300,
                height: 200
              }),
              inkEraserCursorWidth: n,
              zoomLevel: r,
              dispatch: o,
              inkAnnotations: i,
              clientToPageTransformation: a
            } = e,
            l = d.useMemo(function () {
              return (0, ot.Vv)(n / 2 * r);
            }, [n, r]),
            [u, c] = d.useState({
              localAnnotations: i,
              lastErasedPointsPaths: []
            }),
            p = d.useRef(null),
            h = d.useCallback(e => e.apply(a), [a]);
          d.useEffect(() => {
            p.current = i.reduce((e, r) => Ro(r, n, e, t), []), c({
              localAnnotations: i,
              lastErasedPointsPaths: []
            });
          }, [i, n, t]);
          const f = d.useCallback(e => {
              c(function (e, t, n, r, o, i) {
                const a = Math.ceil(i.width / Fo),
                  s = {};
                return t.forEach(e => {
                  const t = Mo(e, a);
                  r[t] && r[t].forEach(t => {
                    t && t.point && jo(t.point, e, n / 2, t.strokeRadius) && (t.point = null, o.push([t.annotationId, t.lineIndex, t.pointIndex]), s[t.annotationId] = !0);
                  });
                }), {
                  localAnnotations: e.map(e => s[e.id] ? e.withMutations(t => {
                    o.filter(t => t[0] === e.id).forEach(e => {
                      t.setIn(["lines", e[1], e[2]], null);
                    });
                  }) : e),
                  lastErasedPointsPaths: o
                };
              }(u.localAnnotations, Array.isArray(e) ? e : [e], n, p.current, [], t));
            }, [u.localAnnotations, n, t]),
            m = d.useCallback(() => {
              const e = function (e, t) {
                return e.map((e, n) => e === t.get(n) ? e : (e = e.withMutations(e => {
                  e.update("lines", e => e.reduce((e, t) => e.concat(t.reduce((e, t) => null == t ? e.push((0, s.aV)()) : e.update(-1, e => e.push(t)), (0, s.aV)([(0, s.aV)()])).filter(e => e.size > 0)), (0, s.aV)()).filter(e => e.size > 0));
                })).set("boundingBox", (0, ot.gz)(e)));
              }(u.localAnnotations, i);
              o((0, yt.GZ)(e.filter(e => e.lines && e.lines.size > 0), e.filter(e => !e.lines || 0 === e.lines.size).map(e => e.id)));
            }, [u.localAnnotations, o, i]);
          d.useEffect(() => (o((0, Kt.X2)()), () => {
            o((0, Kt.Zg)());
          }), [o]);
          const g = d.useCallback((e, t, n) => {
            var r;
            if (!n) return null;
            const {
              lastErasedPointsPaths: o,
              localAnnotations: i
            } = u;
            if (0 === o.length) return n;
            const a = null == i || null === (r = i.find(t => t.id === e)) || void 0 === r ? void 0 : r.lines.get(t);
            return a && a.size === n.length ? o.reduce((n, r) => {
              if (function (e, t, n, r) {
                return e[0] === n && e[1] === r && "M 0,0" !== t[e[2]];
              }(r, n, e, t)) {
                n[r[2]] = "M 0,0";
                const e = n[r[2] + 1],
                  t = a.get(r[2] + 1);
                if (t && No(e)) {
                  const e = n[r[2] + 2];
                  n[r[2] + 1] = `${No(e) ? "M" : "L"} ${t.x},${t.y}`;
                }
                const o = n[r[2] - 1],
                  i = a.get(r[2] - 1),
                  s = i ? `L ${i.x},${i.y}` : "";
                if (No(o)) {
                  const e = n[r[2] - 2];
                  i && Lo(e) && (n[r[2] - 1] = s);
                } else i && Lo(o) && (n[r[2] - 1] = s);
                return n;
              }
              return n;
            }, n) : null;
          }, [u]);
          return d.createElement("div", {
            className: st().canvas,
            style: {
              cursor: l
            }
          }, u.localAnnotations.map(e => d.createElement(dt, {
            dispatch: o,
            annotation: e,
            isSelectable: !1,
            isDisabled: !0,
            zoomLevel: r,
            key: e.id,
            pathDataFromFragments: g
          })), d.createElement(Vt.Z, {
            size: t,
            onDrawStart: f,
            onDrawCoalesced: f,
            onDrawEnd: m,
            transformPoint: h,
            interactionMode: e.interactionMode,
            scrollElement: e.scrollElement
          }));
        });
        function No(e) {
          return "string" == typeof e && e.startsWith("C");
        }
        function Lo(e) {
          return "string" == typeof e && e.startsWith("M");
        }
        const Vo = (0, l.$j)((e, t) => {
          let {
            pageIndex: n
          } = t;
          return {
            inkEraserCursorWidth: e.inkEraserCursorWidth,
            zoomLevel: e.viewportState.zoomLevel,
            clientToPageTransformation: (0, G.zi)(e, n),
            scrollElement: e.scrollElement,
            interactionMode: e.interactionMode
          };
        })(function (e) {
          const {
              canvasSize: t = new _.$u({
                width: 300,
                height: 200
              }),
              inkEraserCursorWidth: n,
              zoomLevel: r,
              dispatch: o,
              inkAnnotations: i,
              clientToPageTransformation: a
            } = e,
            l = d.useMemo(function () {
              return (0, ot.Vv)(n / 2 * r);
            }, [n, r]),
            [u, c] = d.useState({
              localAnnotations: i,
              lastErasedLinesPaths: []
            }),
            p = d.useRef(null),
            h = d.useCallback(e => e.apply(a), [a]);
          d.useEffect(() => {
            p.current = i.reduce((e, r) => Ro(r, n, e, t), []), c({
              localAnnotations: i,
              lastErasedLinesPaths: []
            });
          }, [i, n, t]);
          const f = d.useCallback(e => {
              c(function (e, t, n, r, o, i) {
                const a = Math.ceil(i.width / Fo),
                  l = {};
                return t.forEach(e => {
                  const t = Mo(e, a);
                  r[t] && r[t].forEach(t => {
                    t && t.point && jo(t.point, e, n / 2, t.strokeRadius) && (t.point = null, o.push([t.annotationId, t.lineIndex]), l[t.annotationId] = !0);
                  });
                }), {
                  localAnnotations: e.map(e => l[e.id] ? e.withMutations(t => {
                    o.filter(t => t[0] === e.id).forEach(e => {
                      t.setIn(["lines", e[1]], (0, s.aV)([]));
                    });
                  }) : e),
                  lastErasedLinesPaths: o
                };
              }(u.localAnnotations, Array.isArray(e) ? e : [e], n, p.current, [], t));
            }, [u.localAnnotations, n, t]),
            m = d.useCallback(() => {
              const e = function (e, t) {
                return e.map((e, n) => e === t.get(n) ? e : (e = e.update("lines", e => e.filter(Boolean).filter(e => e.size > 0))).set("boundingBox", (0, ot.gz)(e)));
              }(u.localAnnotations, i);
              o((0, yt.GZ)(e.filter(e => {
                var t;
                return (null === (t = e.lines) || void 0 === t ? void 0 : t.size) > 0;
              }), e.filter(e => !e.lines || 0 === e.lines.size).map(e => e.id)));
            }, [u.localAnnotations, o, i]);
          return d.useEffect(() => (o((0, Kt.X2)()), () => {
            o((0, Kt.Zg)());
          }), [o]), d.createElement("div", {
            className: st().canvas,
            style: {
              cursor: l
            }
          }, u.localAnnotations.map(e => d.createElement(dt, {
            dispatch: o,
            annotation: e,
            isSelectable: !1,
            isDisabled: !0,
            zoomLevel: r,
            key: e.id
          })), d.createElement(Vt.Z, {
            size: t,
            onDrawStart: f,
            onDrawCoalesced: f,
            onDrawEnd: m,
            transformPoint: h,
            interactionMode: e.interactionMode,
            scrollElement: e.scrollElement
          }));
        });
        class Ko extends d.Component {
          constructor(e) {
            super(e), (0, o.Z)(this, "_handledBlur", !1), (0, o.Z)(this, "editor", d.createRef()), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "clearText", () => {
              const {
                current: e
              } = this.editor;
              if (!e) return "";
              e.innerText = "", setTimeout(() => {
                this.props.valueDidUpdate && this.props.valueDidUpdate();
              }, 0), this.focus();
            }), (0, o.Z)(this, "focus", () => {
              const {
                current: e
              } = this.editor;
              e && (e.focus(), setTimeout(() => {
                const {
                  current: e
                } = this.editor;
                e && (this._handledBlur = !0, e.blur(), e.focus(), "webkit" === De.SR && this.setInitialSelection());
              }, 0), this.setInitialSelection());
            }), (0, o.Z)(this, "_createRangeAndSelect", e => {
              const {
                current: t
              } = this.editor;
              if (!t) return;
              const {
                  ownerDocument: n,
                  childNodes: r
                } = t,
                o = r[r.length - 1];
              if (!o) return;
              if (void 0 === n.createRange) return;
              const i = n.createRange();
              let a;
              a = "gecko" === De.SR ? o.length - 1 : o.length, i.setStart(o, e ? 0 : a), i.setEnd(o, a), this.setSelection(i);
            }), (0, o.Z)(this, "_preventDeselect", e => {
              e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
            }), (0, o.Z)(this, "_handleKeyDown", e => {
              if (e.keyCode !== br.zz) {
                if (e.keyCode === br.E$ && e.shiftKey) return this.props.onStopEditing(), void e.preventDefault();
                if (this.getPlainText().length >= this.props.maxLength) e.preventDefault();else if ("blink" === De.SR && e.keyCode === br.E$) {
                  const {
                    current: n
                  } = this.editor;
                  if (!n) return;
                  const {
                    defaultView: r
                  } = n.ownerDocument;
                  (0, u.kG)(r, "defaultView is null");
                  const o = r.getSelection();
                  if (null != o && o.anchorNode && "#text" === (null == o ? void 0 : o.anchorNode.nodeName)) {
                    var t;
                    const n = qo(o);
                    if (null === (t = o.anchorNode.parentNode) || void 0 === t || t.normalize(), o.anchorNode && "#text" === o.anchorNode.nodeName) {
                      const t = o.anchorOffset;
                      "Range" === o.type && o.deleteFromDocument();
                      const r = o.anchorNode.nodeValue;
                      (0, u.kG)(r, "currentText is null");
                      const i = n && r.replace(/\n/, "").length > 0;
                      o.anchorNode.nodeValue = r.substr(0, o.anchorOffset) + "\n" + (i ? "\n" : "") + r.substr(o.anchorOffset), o.collapse(o.anchorNode, t + 1), e.preventDefault(), setTimeout(() => {
                        this.props.valueDidUpdate && this.props.valueDidUpdate();
                      }, 0);
                    }
                  }
                } else if ("gecko" === De.SR && e.keyCode === br.E$) {
                  const {
                    current: t
                  } = this.editor;
                  if (!t) return;
                  const {
                    defaultView: r
                  } = t.ownerDocument;
                  (0, u.kG)(r, "defaultView is null");
                  const o = r.getSelection();
                  if (null != o && o.anchorNode && "#text" === (null == o ? void 0 : o.anchorNode.nodeName) && (function (e) {
                    let {
                      anchorNode: t,
                      anchorOffset: n
                    } = e;
                    return null != t && ("#text" === t.nodeName && (0 === n || t.nodeValue.length > n && "\n" === t.nodeValue.charAt(n - 1)) || "DIV" === t.nodeName && t.hasChildNodes() && t.childNodes.length > 0 && "BR" === t.childNodes[0].nodeName);
                  }(o) || qo(o))) {
                    var n;
                    const t = qo(o);
                    if (null === (n = o.anchorNode.parentNode) || void 0 === n || n.normalize(), o.anchorNode && "#text" === o.anchorNode.nodeName) {
                      const n = o.anchorOffset;
                      "Range" === o.type && o.deleteFromDocument();
                      const r = o.anchorNode.nodeValue;
                      (0, u.kG)(r, "currentText is null");
                      const i = t && r.replace(/\n/, "").length > 0;
                      o.anchorNode.nodeValue = r.substr(0, o.anchorOffset) + "\n" + (i ? "\n" : "") + r.substr(o.anchorOffset), o.collapse(o.anchorNode, n + 1 + (i ? 1 : 0)), e.preventDefault(), setTimeout(() => {
                        this.props.valueDidUpdate && this.props.valueDidUpdate();
                      }, 0);
                    }
                  }
                }
              } else this.props.onEscape(e);
            }), (0, o.Z)(this, "_handleInput", () => {
              const {
                current: e
              } = this.editor;
              if (e) {
                if ("gecko" === De.SR) {
                  const {
                      innerText: t
                    } = e,
                    n = t.charAt(t.length - 1);
                  if (" " === n) {
                    const t = e.childNodes[e.childNodes.length - 1];
                    t.nodeValue === n && (t.nodeValue = "\n");
                  }
                }
                this.props.valueDidUpdate && this.props.valueDidUpdate();
              }
            }), (0, o.Z)(this, "_handlePaste", e => {
              var t, n;
              if (!this.editor.current) return;
              const r = this.editor.current.ownerDocument;
              e.preventDefault();
              const o = null === (t = e.clipboardData) || void 0 === t ? void 0 : t.getData("text/plain");
              this.getPlainText().length + o.length >= this.props.maxLength || r.execCommand("insertText", !1, cn().sanitize(null === (n = e.clipboardData) || void 0 === n ? void 0 : n.getData("text/plain")));
            }), (0, o.Z)(this, "_handleDrop", e => {
              if (!this.editor.current) return;
              const t = this.editor.current.ownerDocument;
              if (e.preventDefault(), e.dataTransfer) {
                const n = e.dataTransfer.getData("text/plain");
                if (this.getPlainText.length + n.length >= this.props.maxLength) return;
                t.execCommand("insertText", !1, n), this.props.valueDidUpdate && this.props.valueDidUpdate();
              }
            }), (0, o.Z)(this, "_handleScroll", e => {
              const {
                current: t
              } = this.editor;
              t && (t.scrollTop = 0, t.scrollLeft = 0, e.stopPropagation(), e.preventDefault());
            }), (0, o.Z)(this, "_handlePointerDown", e => {
              this.editor.current && ((0, Br.pr)({
                event: e,
                element: this.editor.current
              }) || this._handleBlur());
            }), (0, o.Z)(this, "_handleBlur", () => {
              this._handledBlur || (this._handledBlur = !0, this.props.onBlur());
            }), (0, o.Z)(this, "_handleFocus", () => {
              this._handledBlur = !1, this.props.onFocus && this.props.onFocus();
            }), this.innerText = this.props.defaultValue + "\n";
          }
          componentDidMount() {
            this.editor.current && (this.props.autoFocus || this.props.autoSelect) && this.focus();
          }
          getElement() {
            return this.editor.current;
          }
          getEditorBoundingClientRect() {
            const {
              current: e
            } = this.editor;
            return (0, u.kG)(e), _.UL.fromClientRect(e.getBoundingClientRect());
          }
          getPlainText() {
            const {
              current: e
            } = this.editor;
            return e ? void 0 === e.innerText ? "" : e.innerText.replace(/\n$/, "") : "";
          }
          setSelection(e) {
            var t, n;
            const {
              current: r
            } = this.editor;
            if (!r) return;
            const o = De.G6 ? null === (t = (n = r.getRootNode()).getSelection) || void 0 === t ? void 0 : t.call(n) : r.ownerDocument.getSelection();
            null == o || o.removeAllRanges(), null == o || o.addRange(e);
          }
          blur() {
            this.editor.current && this.editor.current.blur();
          }
          setInitialSelection() {
            if (this.props.autoSelect) return void this.autoSelectText();
            const {
              lastMousePoint: e
            } = this.props;
            let t,
              n = !1;
            if (e) {
              if (!this.editor.current) return;
              const {
                ownerDocument: r
              } = this.editor.current;
              t = (0, u.Qo)(e, r), n = !!t && (t.commonAncestorContainer === this.editor.current || t.commonAncestorContainer.parentElement === this.editor.current);
            }
            t && n ? this.setSelection(t) : this.moveFocusToEnd();
          }
          moveFocusToEnd() {
            this._createRangeAndSelect(!1);
          }
          autoSelectText() {
            this._createRangeAndSelect(!0);
          }
          render() {
            return d.createElement(d.Fragment, null, d.createElement("div", {
              style: this.props.style,
              className: fn().editor,
              onInput: this._handleInput,
              onBlur: this._handleBlur,
              onFocus: this._handleFocus,
              onMouseUp: this._preventDeselect,
              onPointerUp: this._preventDeselect,
              onKeyDown: this._handleKeyDown,
              onKeyUp: this._preventDeselect,
              onTouchStart: this._preventDeselect,
              onTouchEnd: this._preventDeselect,
              onPaste: this._handlePaste,
              onDrop: this._handleDrop,
              onScroll: this._handleScroll,
              ref: this.editor,
              contentEditable: !0,
              suppressContentEditableWarning: !0,
              spellCheck: "false",
              "data-testid": "content-editable-component"
            }, cn().sanitize(this.innerText)), d.createElement(Je.Z, {
              onRootPointerDownCapture: this._handlePointerDown
            }));
          }
        }
        function qo(e) {
          return null != e.anchorNode && null == e.anchorNode.nextSibling && ("#text" === e.anchorNode.nodeName && e.anchorOffset === e.anchorNode.nodeValue.length || "DIV" === e.anchorNode.nodeName && e.anchorNode.hasChildNodes() && e.anchorNode.childNodes.length > 0 && "BR" === e.anchorNode.childNodes[0].nodeName);
        }
        (0, o.Z)(Ko, "defaultProps", {
          autoFocus: !0,
          autoSelect: !1
        });
        var Ho = n(74814),
          Uo = n(89939),
          Zo = n.n(Uo),
          $o = n(23301);
        function Go(e) {
          let {
            x: t,
            y: n,
            direction: r,
            startResizing: o,
            endResizing: i,
            onFitToSide: a,
            viewportSize: s,
            title: l,
            cursor: u
          } = e;
          const c = (0, $o.cL)(Ho.V[r]),
            p = h()({
              [Zo().resizeAnchor]: !0,
              [Zo().nwseCursor]: r === Ho.V.TOP_LEFT || r === Ho.V.BOTTOM_RIGHT,
              [Zo().neswCursor]: r === Ho.V.TOP_RIGHT || r === Ho.V.BOTTOM_LEFT,
              [Zo().ewCursor]: r === Ho.V.LEFT || r === Ho.V.RIGHT,
              [Zo().nsCursor]: r === Ho.V.TOP || r === Ho.V.BOTTOM,
              "PSPDFKit-Resize-Anchor": !0,
              [`PSPDFKit-Resize-Anchor-${c}`]: !0
            }),
            {
              RESIZE_ANCHOR_RADIUS: f
            } = it.Options,
            m = f(s),
            g = u ? {
              cursor: u
            } : void 0;
          return d.createElement(Je.Z, {
            onPointerDown: o,
            onPointerUp: i
          }, d.createElement("circle", {
            cx: t,
            cy: n,
            r: m - Ne.Hr / 2,
            strokeWidth: Ne.Hr,
            className: p,
            onDoubleClick: a,
            style: g
          }, l ? d.createElement("title", null, l) : null));
        }
        function Wo(e) {
          let {
            x: t,
            y: n,
            startModifying: r,
            endModifying: o,
            pointIndex: i,
            viewportSize: a,
            title: s,
            cursor: l
          } = e;
          const u = h()({
              [Zo().resizeAnchor]: !0
            }),
            {
              RESIZE_ANCHOR_RADIUS: c
            } = it.Options,
            p = c(a),
            f = l ? {
              cursor: l
            } : void 0;
          return d.createElement(Je.Z, {
            onPointerDown: r,
            onPointerUp: o
          }, d.createElement("circle", (0, ce.Z)({
            cx: t,
            cy: n,
            r: p - Ne.Hr / 2,
            strokeWidth: Ne.Hr,
            className: u,
            id: `pointIndex${i}`,
            style: f
          }, {
            title: s
          })));
        }
        function Yo(e) {
          let {
            width: t,
            startRotating: n,
            endRotating: r,
            viewportSize: o,
            rotationHandleLength: i,
            rotation: a = 0,
            title: s
          } = e;
          const {
              RESIZE_ANCHOR_RADIUS: l,
              SELECTION_STROKE_WIDTH: u
            } = it.Options,
            c = h()({
              "PSPDFKit-Annotations-Rotation-Anchor": !0,
              [Zo().rotateAnchor]: !0
            }),
            p = l(o);
          return d.createElement("svg", {
            "data-testid": "rotation-handle-ui",
            className: h()(Zo().rotationHandleSvg, "PSPDFKit-Annotations-Rotation-Handle")
          }, d.createElement("line", {
            className: h()(Zo().rotationLine, "PSPDFKit-Annotations-Rotation-Line"),
            x1: t / 2,
            y1: 0,
            x2: t / 2,
            y2: i,
            style: {
              strokeWidth: u
            }
          }), d.createElement(Je.Z, {
            onPointerDown: n,
            onPointerUp: r
          }, d.createElement("circle", {
            cx: t / 2,
            cy: i,
            r: p - Ne.Hr / 2,
            strokeWidth: Ne.Hr,
            className: c,
            style: {
              cursor: (0, qe.Mg)(a, "grab")
            }
          }, s ? d.createElement("title", null, s) : null)));
        }
        var Xo = n(4325);
        function Qo(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Jo(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Qo(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qo(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function ei(e) {
          const {
              formatMessage: t
            } = (0, xe.YB)(),
            n = (0, l.v9)(e => e.selectedAnnotationIds),
            r = (0, l.v9)(e => e.isMultiSelectionEnabled);
          function o(n, r, o) {
            const i = ti(o),
              a = ti(o + e.pagesRotation),
              s = `${t(ke.Z.resize)}, ${ni[a].split(",").map(e => t(ke.Z[`resizeHandle${e.trim()}`])).join(", ")}`;
            return d.createElement(Go, {
              key: o,
              x: n,
              y: r,
              direction: a,
              title: s,
              startResizing: t => {
                e.startResizing && e.startResizing(t, i);
              },
              endResizing: ri,
              onFitToSide: () => {
                e.onFitToSide && e.onFitToSide(a);
              },
              viewportSize: e.viewportSize,
              cursor: e.cursor
            });
          }
          const {
              zoomLevel: i,
              annotation: a,
              annotationBoundingBox: s,
              viewportSize: u,
              customZIndex: c,
              cursor: p
            } = e,
            {
              RESIZE_ANCHOR_RADIUS: f,
              SELECTION_STROKE_WIDTH: m
            } = it.Options,
            g = (0, Xo.q)(s.scale(i), u),
            {
              SELECTION_OUTLINE_PADDING: v
            } = it.Options,
            y = v(u),
            b = f(u),
            w = a ? (0, $o.G8)(a) + 2 * (0, Xo.K)(u) : 0,
            x = Math.min(2 * b, w),
            D = Math.max(g.width, x),
            C = Math.max(g.height, x),
            S = Math.max(b + m / 2, m),
            E = 2 * S,
            P = Math.max(b, m / 2),
            k = (0, j.fk)(a, s, i, u, S),
            A = h()({
              [Zo().selectionRect]: !0,
              [Zo().isDragging]: e.isDragging,
              "PSPDFKit-Selection-Outline-Rect": !0
            }),
            z = !a || (0, j.vj)(a) ? Jo({
              strokeWidth: m
            }, p ? {
              cursor: p
            } : null) : {
              stroke: "transparent",
              cursor: (0, j.B7)(a, {
                cursor: p,
                isSelected: !0
              })
            },
            T = h()({
              [Zo().draggingRect]: !0,
              [Zo().isDragging]: e.isDragging,
              "PSPDFKit-Selection-Outline-Border": !0
            }),
            O = a ? a.rotation : e.annotationRotation,
            I = 35 * (a ? (0, j.WX)(a, i) : i),
            F = d.useRef(g),
            M = a ? (0, j.B7)(a, {
              cursor: p,
              isSelected: !0
            }) : void 0,
            R = Jo(Jo({
              left: g.left - S,
              top: g.top - S,
              width: D + E,
              height: C + E,
              overflow: "visible"
            }, a || "number" != typeof O || 0 === O ? null : {
              transformOrigin: `${y + F.current.width / 2}px ${y + F.current.height / 2}px`
            }), {}, {
              transform: "number" != typeof O || 0 === O || a instanceof _.x_ || a instanceof _.sK ? void 0 : `rotate(${-O}deg)`,
              zIndex: null != c ? c : 0,
              cursor: M
            }),
            B = i * (f(u) - Ne.Hr / 2),
            N = {
              left: R.left + R.width / 2 - B,
              top: R.top + R.height,
              width: 2 * B,
              height: I + B,
              overflow: "visible",
              transformOrigin: `center -${R.height / 2}px`,
              transform: "number" == typeof O && 0 !== O ? `rotate(${-O}deg)` : void 0
            };
          return d.createElement(d.Fragment, null, d.createElement("svg", {
            style: R,
            className: Zo().svg,
            focusable: !1
          }, a instanceof _.o9 ? d.createElement("line", {
            className: A,
            x1: k[0].x,
            y1: k[0].y,
            x2: k[1].x,
            y2: k[1].y,
            style: Jo(Jo({}, z), {}, {
              strokeWidth: De.Ni ? Math.max(Ne.wK, a.strokeWidth) * i : Math.max(Ne.XZ, a.strokeWidth) * i,
              pointerEvents: "all"
            })
          }) : d.createElement("rect", {
            className: A,
            style: z,
            x: S - m / 2,
            y: S - m / 2,
            width: D + m,
            height: C + m
          })), e.children || null, d.createElement("svg", {
            style: R,
            className: Zo().svg,
            focusable: !1
          }, d.createElement(Je.Z, {
            onPointerDown: function (t) {
              const o = r && n.size > 1 && De.Ni,
                i = e.deselectAnnotation && (t.shiftKey || o);
              e.isEditableCP && 2 !== t.buttons && (i && e.deselectAnnotation ? e.deselectAnnotation(t) : (t.stopPropagation(), null != e.startDragging && e.startDragging(t)));
            }
          }, a instanceof _.o9 ? d.createElement("line", {
            className: T,
            x1: k[0].x,
            y1: k[0].y,
            x2: k[1].x,
            y2: k[1].y,
            style: Jo(Jo({}, z), {}, {
              strokeWidth: De.Ni ? Math.max(Ne.wK, a.strokeWidth) * i : Math.max(Ne.XZ, a.strokeWidth) * i,
              pointerEvents: "all"
            })
          }) : d.createElement("rect", {
            x: S - m / 2,
            y: S - m / 2,
            width: D + m,
            height: C + m,
            className: T,
            style: z
          })), e.startResizing && e.isResizable ? [o(R.width / 2, P, 0), o(R.width - P, P, 45), o(R.width - P, R.height / 2, 90), o(R.width - P, R.height - P, 135), o(R.width / 2, R.height - P, 180), o(P, R.height - P, 225), o(P, R.height / 2, 270), o(P, P, 315)] : null, e.startModifying && e.isModifiable ? k.map((t, n) => function (t, n, r, o) {
            return d.createElement(Wo, {
              key: `modifyAnchor${r}`,
              x: t,
              y: n,
              pointIndex: r,
              title: o,
              startModifying: t => {
                e.startModifying && e.startModifying(t, r);
              },
              endModifying: ri,
              viewportSize: e.viewportSize,
              cursor: e.cursor
            });
          }(t.x, t.y, n, "Modify point")) : null), e.startRotating && e.isRotatable ? d.createElement("svg", {
            style: N,
            className: Zo().svg,
            focusable: !1
          }, d.createElement(Yo, {
            key: "rotateAnchor",
            width: N.width,
            startRotating: t => {
              var n;
              return null === (n = e.startRotating) || void 0 === n ? void 0 : n.call(e, t);
            },
            endRotating: ri,
            viewportSize: e.viewportSize,
            rotationHandleLength: I,
            rotation: O,
            title: t(ke.Z.rotation)
          })) : null);
        }
        function ti(e) {
          switch ((0, u.kG)(e % 45 == 0, "Only multiples of 45° allowed."), e % 360) {
            case 0:
              return Ho.V.TOP;
            case 45:
              return Ho.V.TOP_RIGHT;
            case 90:
              return Ho.V.RIGHT;
            case 135:
              return Ho.V.BOTTOM_RIGHT;
            case 180:
              return Ho.V.BOTTOM;
            case 225:
              return Ho.V.BOTTOM_LEFT;
            case 270:
              return Ho.V.LEFT;
            case 315:
              return Ho.V.TOP_LEFT;
            default:
              throw new Error("Unsupported resize degrees");
          }
        }
        const ni = {
          [Ho.V.TOP]: "Top",
          [Ho.V.TOP_RIGHT]: "Top, Right",
          [Ho.V.RIGHT]: "Right",
          [Ho.V.BOTTOM_RIGHT]: "Bottom, Right",
          [Ho.V.BOTTOM]: "Bottom",
          [Ho.V.BOTTOM_LEFT]: "Bottom, Left",
          [Ho.V.LEFT]: "Left",
          [Ho.V.TOP_LEFT]: "Top, Left"
        };
        function ri(e) {
          e.stopPropagation();
        }
        var oi = n(49876);
        function ii(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ai(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ii(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ii(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class si extends d.PureComponent {
          constructor(e) {
            var t, n;
            super(e), (0, o.Z)(this, "editorRef", d.createRef()), (0, o.Z)(this, "richTextEditorRef", d.createRef()), (0, o.Z)(this, "updateSelectionBoundingBox", () => {
              const e = this._getNormalizedEditorBoundingBox(),
                t = it.Options.TEXT_ANNOTATION_AUTOFIT_BOUNDING_BOX_ON_EDIT ? e : this.state.selectionBoundingBox.set("left", e.left).set("top", e.top),
                n = this.props.annotation.set("boundingBox", t),
                r = (0, j.WX)(n, this.props.viewportState.zoomLevel);
              var o, i;
              _.UL.areRectsCloserThan((0, qe.h4)(n).boundingBox, (0, qe.h4)(n.set("boundingBox", this.state.selectionBoundingBox)).boundingBox, r) || (this.setState({
                selectionBoundingBox: n.boundingBox
              }), null === (o = (i = this.props).onChange) || void 0 === o || o.call(i, n.boundingBox, this.getText()));
            }), (0, o.Z)(this, "shouldCleanupAnnotation", () => !((0, j.Vc)(this.props.annotation) || !(0, j.Ie)(this.props.annotation)) && ("xhtml" === this.props.annotation.text.format ? "" === (0, gn.KY)(this.state.richTextContent) : "" === this.getText().value)), (0, o.Z)(this, "handleEscape", () => {
              this.props.dispatch((0, _e.fz)()), this.props.onEditingDone();
            }), (0, o.Z)(this, "handleBlur", e => {
              null != e && e.isNativeBlurEvent && this._triggerOnEditingDone(void 0, null == e ? void 0 : e.isTextToolbarClicked, this.shouldCleanupAnnotation());
            }), (0, o.Z)(this, "onStopEditing", () => {
              this._triggerOnEditingDone(!0);
            }), (0, o.Z)(this, "onRichEditorInit", e => {
              this.props.dispatch((0, Kt.$Q)(e));
            });
            const {
              annotation: r
            } = e;
            this.lastSavedAnnotation = r, this.initialOutlineBoundingBox = this.getInitialBoundingBox(r);
            let a = !1,
              s = (0, pn.hr)(null === (t = e.annotation.text) || void 0 === t ? void 0 : t.value) || "";
            var l, u, c;
            if (e.enableRichText(e.annotation)) {
              if (a = !0, "plain" === (null === (l = e.annotation.text) || void 0 === l ? void 0 : l.format)) {
                var p;
                const t = (null === (p = e.annotation.fontColor) || void 0 === p ? void 0 : p.toHex()) || "",
                  n = i.ri.prepareHTML(e.annotation.text.value);
                s = i.ri.setStyleOrToggleFormat(i.ri.serialize(i.ri.deserialize(n)), "fontColor", t);
              }
            } else "xhtml" === (null === (u = e.annotation.text) || void 0 === u ? void 0 : u.format) && (s = i.ri.getText((null === (c = e.annotation.text) || void 0 === c ? void 0 : c.value) || ""));
            this.state = {
              selectionBoundingBox: this.initialOutlineBoundingBox,
              annotation: r,
              richTextContent: null === (n = e.annotation.text) || void 0 === n ? void 0 : n.value,
              useRichText: a,
              text: s
            };
          }
          getInitialBoundingBox(e) {
            let t = e.boundingBox;
            return (0, j.U7)(t) || (t = t.set("width", it.Options.MIN_TEXT_ANNOTATION_SIZE).set("height", e.fontSize)), t;
          }
          componentDidUpdate(e) {
            this.updateSelectionBoundingBox(), e && !e.annotation.equals(this.props.annotation) && (this.initialOutlineBoundingBox = this.getInitialBoundingBox(this.props.annotation), this.setState(t => ai(ai({}, t), {}, {
              annotation: this.props.annotation
            }, t.useRichText && this.props.annotation.text.value !== t.richTextContent && this.props.annotation.text.value !== e.annotation.text.value ? {
              richTextContent: this.props.annotation.text.value
            } : null)));
          }
          _getNormalizedEditorBoundingBox() {
            const {
                current: e
              } = this.editorRef,
              {
                current: t
              } = this.richTextEditorRef;
            return t ? this.props.transformClientToPage(_.UL.fromClientRect(ui(t))) : e ? this.props.transformClientToPage(_.UL.fromClientRect(ui(e.getElement()))) : new _.UL();
          }
          getText() {
            const {
              current: e
            } = this.editorRef;
            return e || this.state.useRichText ? e ? {
              value: e.getPlainText(),
              format: "plain"
            } : {
              value: this.state.richTextContent,
              format: "xhtml"
            } : {
              value: "",
              format: "plain"
            };
          }
          _triggerOnEditingDone() {
            var e;
            let t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            const {
                current: o
              } = this.editorRef,
              i = this.getText(),
              {
                annotation: a,
                onChange: s
              } = this.props,
              l = (0, j.WX)(a, this.props.viewportState.zoomLevel);
            if ((0, j.Vc)(a)) return void (null == s || s(this.state.selectionBoundingBox, i));
            if (!o && !this.state.useRichText) return;
            let u = (null === (e = this.props.annotation.text) || void 0 === e ? void 0 : e.value) !== i.value ? this.props.annotation.set("text", i).set("boundingBox", this.state.selectionBoundingBox) : this.props.annotation;
            if ("xhtml" === i.format && this.props.annotation.fontColor ? u = u.set("fontColor", null) : "plain" !== i.format || this.props.annotation.fontColor || (u = u.set("fontColor", _.Il.BLACK)), it.Options.TEXT_ANNOTATION_AUTOFIT_BOUNDING_BOX_ON_EDIT) {
              const e = this._getNormalizedEditorBoundingBox(),
                t = u.boundingBox;
              !e.getSize().equals(t.getSize()) && (u = u.set("boundingBox", e)), (0, j.ix)(u, this.props.viewportState.zoomLevel) && (u = u.setIn(["boundingBox", "width"], u.boundingBox.width * this.props.viewportState.zoomLevel).setIn(["boundingBox", "height"], u.boundingBox.height * this.props.viewportState.zoomLevel)), u = (0, pn.XA)(u, l);
            }
            this.lastSavedAnnotation.equals(u) || (this.lastSavedAnnotation = u, this.props.onEditingDone((0, $o.er)(u, this.props.annotation.boundingBox), t, n, r));
          }
          componentWillUnmount() {
            this.shouldCleanupAnnotation() && (this.props.dispatch((0, yt.aF)((0, s.l4)([this.props.annotation.id]))), this.props.dispatch((0, oi.zM)(this.props.annotation.id)));
          }
          render() {
            var e;
            const t = this.props.annotation,
              {
                zoomLevel: n
              } = this.props.viewportState,
              r = t.boundingBox,
              o = this.props.pageSize.width,
              a = this.props.pageSize.height,
              s = (0, j.WX)(t, n),
              l = (0, pn.z1)(t.set("rotation", 0), s, !1);
            let u, c;
            const p = Math.floor(r.left * n),
              h = Math.floor(r.top * n);
            switch (t.rotation) {
              case 0:
                u = o * n - p, c = a * n - h;
                break;
              case 90:
                u = r.bottom * n, c = o * n - p;
                break;
              case 180:
                u = r.right * n, c = r.bottom * n;
                break;
              case 270:
                u = a * n - h, c = r.right * n;
            }
            const f = (0, j.Vc)(t),
              m = ai(ai({}, !f && {
                left: p,
                top: h
              }), {}, {
                minWidth: it.Options.MIN_TEXT_ANNOTATION_SIZE * s,
                minHeight: t.fontSize * s,
                maxWidth: u,
                maxHeight: c
              }),
              g = it.Options.TEXT_ANNOTATION_AUTOFIT_BOUNDING_BOX_ON_EDIT ? m : ai(ai({}, l), m);
            delete l.width, delete l.height, delete l.overflow;
            const v = Math.ceil(t.boundingBox.width * s),
              y = Math.ceil(t.boundingBox.height * s);
            switch (g.transformOrigin = "0 0", t.rotation) {
              case 90:
                g.transform = `translate(0, ${y}px) rotate(${-t.rotation}deg)`;
                break;
              case 180:
                g.transform = `translate(${v}px, ${y}px) rotate(${-t.rotation}deg)`;
                break;
              case 270:
                g.transform = `translate(${v}px, 0) rotate(${-t.rotation}deg)`;
                break;
              default:
                (0, qe.kv)(t) && (g.transformOrigin = `${n * this.initialOutlineBoundingBox.width / 2}px ${n * this.initialOutlineBoundingBox.height / 2}px`, g.transform = `rotate(${String(-t.rotation)}deg)`);
            }
            return this.state.useRichText || "xhtml" !== (null === (e = this.props.annotation.text) || void 0 === e ? void 0 : e.format) || (g.color = _.Il.BLACK.toHex()), d.createElement(d.Fragment, null, !f && d.createElement(ei, {
              zoomLevel: n,
              pagesRotation: this.props.viewportState.pagesRotation,
              annotationBoundingBox: this.state.selectionBoundingBox,
              annotationRotation: t.rotation,
              isResizable: !0,
              isModifiable: !1,
              isRotatable: !0,
              isEditableCP: !0,
              viewportSize: this.props.viewportState.viewportRect.getSize()
            }), d.createElement("div", {
              style: ai(ai({}, l), !this.state.useRichText && {
                wordBreak: f ? void 0 : l.wordBreak,
                overflowWrap: f ? "break-word" : l.overflowWrap
              }),
              className: fn().editorWrapper
            }, this.state.useRichText ? d.createElement(i.D, {
              text: this.state.text,
              style: ai(ai({}, g), {}, {
                color: _.Il.BLACK.toHex()
              }),
              updateBoundingBox: this.updateSelectionBoundingBox,
              ref: this.richTextEditorRef,
              onValueChange: e => {
                this.setState(t => ai(ai({}, t), {}, {
                  richTextContent: e
                }));
              },
              onBlurSave: this.handleBlur,
              onStopEditing: this.onStopEditing,
              onEscape: this.handleEscape,
              maxLength: Ne.RI,
              lastMousePoint: this.props.lastMousePoint,
              onEditorInit: this.onRichEditorInit,
              className: !f && fn().richEditor,
              autoFocus: !0,
              keepSelectedTool: this.props.keepSelectedTool,
              shadowRoot: this.props.shadowRoot
            }) : d.createElement(Ko, {
              style: ai(ai({}, g), {
                position: f ? "static" : g.position
              }),
              valueDidUpdate: this.updateSelectionBoundingBox,
              onBlur: () => this.handleBlur({
                isNativeBlurEvent: !0
              }),
              onStopEditing: this.onStopEditing,
              onEscape: this.handleEscape,
              ref: this.editorRef,
              maxLength: Ne.RI,
              defaultValue: this.state.text,
              lastMousePoint: this.props.lastMousePoint,
              autoSelect: this.props.autoSelect
            })));
          }
        }
        (0, o.Z)(si, "defaultProps", {
          autoSelect: !1
        });
        const li = go(si);
        function ui(e) {
          var t;
          const n = e.cloneNode(!0);
          n.style.transform = "none", n.style.visibility = "hidden", n.style.pointerEvents = "none", null === (t = e.parentElement) || void 0 === t || t.append(n);
          const r = n.getBoundingClientRect();
          return n.remove(), r;
        }
        const ci = e => {
          let {
            annotation: t,
            children: n
          } = e;
          const r = (0, l.v9)(e => e.viewportState.zoomLevel),
            o = (0, d.useRef)(null),
            i = (0, l.I0)(),
            a = t.boundingBox.scale(r),
            s = (0, d.useCallback)((e, n) => {
              var a;
              const s = null === (a = o.current) || void 0 === a ? void 0 : a.getBoundingClientRect();
              if (!s) return;
              const {
                  callout: l
                } = t,
                u = (0, gn.Vq)({
                  rect: s,
                  annotation: t,
                  zoomLevel: r,
                  text: n,
                  callout: l
                });
              u && i((0, yt.FG)(t.merge(u)));
            }, [t, r, i]),
            u = (0, d.useRef)(t);
          return u.current = t, (0, d.useEffect)(() => () => {
            ("xhtml" === u.current.text.format ? (0, gn.KY)(u.current.text.value) : u.current.text.value) || "xhtml" !== u.current.text.format || i((0, yt.hQ)(u.current));
          }, [i]), d.createElement("div", {
            style: {
              position: "absolute",
              left: a.left,
              top: a.top,
              minHeight: a.height,
              width: a.width
            }
          }, d.createElement(yn, {
            annotation: t,
            isEditing: !0,
            ref: o
          }, n(s)));
        };
        class di extends d.PureComponent {
          constructor() {
            var e;
            super(...arguments), e = this, (0, o.Z)(this, "_onEditingDone", function (t) {
              let n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
              const i = t && (0, qe.az)(t),
                a = i ? (0, s.aV)([i]) : (0, s.aV)([]),
                l = {
                  annotations: a,
                  reason: J.f.TEXT_EDIT_END
                };
              e.props.eventEmitter.emit("annotations.willChange", l), i && (o || e.props.dispatch((0, yt.FG)(i)), n && e.props.dispatch((0, _e.Df)((0, s.l4)([e.props.annotation.id]), null)), e.props.keepSelectedTool && !r && e.props.dispatch((0, Kt.DU)()));
            });
          }
          componentDidMount() {
            const e = {
              annotations: (0, s.aV)([this.props.annotation]),
              reason: J.f.TEXT_EDIT_START
            };
            this.props.eventEmitter.emit("annotations.willChange", e), this.props.dispatch((0, Kt.X2)());
          }
          componentWillUnmount() {
            this.props.dispatch((0, Kt.Zg)());
          }
          render() {
            const {
                annotation: e,
                autoSelect: t,
                dispatch: n,
                pageSize: r,
                lastMousePoint: o,
                pageIndex: i,
                enableRichText: a
              } = this.props,
              s = s => d.createElement(li, {
                dispatch: n,
                annotation: (0, qe.h4)(e),
                lastMousePoint: o,
                pageSize: r,
                pageIndex: i,
                onEditingDone: this._onEditingDone,
                autoSelect: t,
                enableRichText: a,
                onChange: s,
                keepSelectedTool: this.props.keepSelectedTool,
                shadowRoot: this.props.shadowRoot
              });
            return (0, j.Vc)(e) ? d.createElement(ci, {
              annotation: e
            }, e => s(e)) : s();
          }
        }
        (0, o.Z)(di, "defaultProps", {
          autoSelect: !1
        });
        class pi extends d.Component {
          constructor(e) {
            super(e), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_handlePointerUp", e => {
              if (!e.isPrimary) return;
              const t = this._getNormalizedMousePosition(e);
              if (!t) return;
              const {
                  pagesRotation: n
                } = this.props.viewportState,
                r = (0, j.ix)(this.props.annotation, this.props.zoomLevel) ? this.props.annotation.fontSize / this.props.zoomLevel : this.props.annotation.fontSize,
                o = new _.E9({
                  x: t.x,
                  y: Math.max(t.y - r / 2, 0)
                }),
                i = (0, pn.gB)(o, n),
                a = this._fitRectInPage(i, this.props.pageSize);
              this.setState({
                bindPointerUpEvent: !1
              });
              let l = this.props.annotation.set("pageIndex", this.props.pageIndex).set("boundingBox", a).set("rotation", n);
              this.props.interactionMode === B.A.CALLOUT && (l = function (e, t, n) {
                const r = function (e, t) {
                    let n = "top-right";
                    const {
                      width: r
                    } = t;
                    e.x + 100 > r && (n = n.replace("right", "left"));
                    e.y - 120 < 0 && (n = n.replace("top", "bottom"));
                    return n;
                  }(e, t),
                  o = new _.E9({
                    x: e.x,
                    y: e.y
                  }),
                  i = new _.E9({
                    x: r.includes("right") ? e.x + 50 : e.x - 50,
                    y: r.includes("top") ? e.y - 50 : e.y + 50
                  }),
                  a = new _.E9({
                    x: r.includes("right") ? e.x + 50 : e.x - 50,
                    y: r.includes("top") ? e.y - hi : e.y + hi
                  }),
                  s = new _.eB({
                    top: r.includes("top") ? 0 : hi,
                    right: r.includes("right") ? 0 : 42,
                    bottom: r.includes("top") ? hi : 0,
                    left: r.includes("right") ? 42 : 0
                  }),
                  l = new _.UW({
                    start: o,
                    knee: i,
                    end: a,
                    innerRectInset: s,
                    cap: "openArrow"
                  }),
                  u = new _.UL({
                    top: r.includes("top") ? e.y - 100 : e.y,
                    left: r.includes("right") ? e.x : e.x - 85,
                    width: 85,
                    height: 100
                  });
                return n.set("callout", l).set("boundingBox", u).set("borderWidth", n.borderWidth || 2).set("borderStyle", n.borderStyle || "solid").set("borderColor", n.borderColor || _.Il.BLACK);
              }(t, this.props.pageSize, l)), this.props.dispatch((0, yt.Zr)((0, s.aV)([l]))), e.stopPropagation();
            }), this.state = {
              bindPointerUpEvent: !0
            };
          }
          _getNormalizedMousePosition(e) {
            const {
              target: t
            } = e;
            if ("DIV" == t.tagName) return this.props.transformClientToPage(new _.E9({
              x: e.clientX,
              y: e.clientY
            }));
          }
          _fitRectInPage(e, t) {
            const {
                width: n,
                height: r
              } = t,
              {
                MIN_TEXT_ANNOTATION_SIZE: o
              } = it.Options;
            return e.top + e.height > r && (e = e.set("top", r - e.height)), e.left + o > n && (e = e.set("left", n - o)), e;
          }
          render() {
            const e = h()({
              [fn().layer]: !0,
              "PSPDFKit-Text-Canvas": !0
            });
            return d.createElement(Je.Z, {
              onPointerUpCapture: this.state.bindPointerUpEvent ? this._handlePointerUp : void 0
            }, d.createElement("div", {
              className: e,
              style: {
                cursor: "text"
              }
            }));
          }
        }
        (0, o.Z)(pi, "defaultProps", {
          autoSelect: !1
        });
        const hi = 80;
        const fi = go(pi);
        var mi = n(54662);
        const gi = {
          ArrowUp: 0,
          ArrowRight: 90,
          ArrowDown: 180,
          ArrowLeft: 270
        };
        function vi(e) {
          switch (e) {
            case 0:
              return new E.E9({
                x: 0,
                y: -1
              });
            case 90:
              return new E.E9({
                x: 1,
                y: 0
              });
            case 180:
              return new E.E9({
                x: 0,
                y: 1
              });
            case 270:
              return new E.E9({
                x: -1,
                y: 0
              });
            default:
              throw Error();
          }
        }
        var yi = n(11192);
        function bi(e) {
          var t;
          null !== (t = e.getSelection()) && void 0 !== t && t.isCollapsed || (0, yi.a7)(e);
        }
        function wi(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xi(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wi(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wi(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Di = {
          isListening: !1,
          isDragging: !1,
          previousMousePosition: null,
          initialClickWithinAnnotation: null,
          translation: new _.E9(),
          initialDragCompleted: !1
        };
        function Ci(e, t) {
          const n = t;
          switch (n.type) {
            case "start":
              {
                const {
                  mousePosition: t,
                  initialClickWithinAnnotation: r
                } = n;
                return xi(xi({}, e), {}, {
                  isListening: !0,
                  previousMousePosition: t,
                  initialClickWithinAnnotation: r
                });
              }
            case "drag":
              {
                const {
                  mousePosition: t,
                  translation: r
                } = n;
                return xi(xi({}, e), {}, {
                  isDragging: !0,
                  previousMousePosition: t,
                  translation: r
                });
              }
            case "scroll":
              return xi(xi({}, e), {}, {
                translation: n.translation
              });
            case "stop":
              return xi(xi({}, Di), {}, {
                initialDragCompleted: !0
              });
            default:
              throw (0, u.Rz)(n.type);
          }
        }
        function Si(e) {
          var t;
          return null === (t = e.target) || void 0 === t ? void 0 : t.classList.contains(Zo().selectionRect);
        }
        var Ei = n(58846);
        const _i = {
          pointIndex: null,
          startingMousePosition: null,
          isListening: !1
        };
        function Pi(e, t, n) {
          let r;
          return e instanceof _.o9 ? r = e[["startPoint", "endPoint"][t]].apply(n) : e instanceof _.om && (r = e.points.get(t).apply(n)), r;
        }
        const ki = {
          startingMousePosition: null,
          startingResizeAnchor: null,
          isListening: !1
        };
        function Ai(e, t, n) {
          const r = e.boundingBox.apply(t);
          let o;
          return n === Ho.V.TOP_LEFT ? o = new _.E9({
            x: r.left,
            y: r.top
          }) : n === Ho.V.TOP_RIGHT ? o = new _.E9({
            x: r.left + r.width,
            y: r.top
          }) : n === Ho.V.BOTTOM_LEFT ? o = new _.E9({
            x: r.left,
            y: r.top + r.height
          }) : n === Ho.V.BOTTOM_RIGHT && (o = new _.E9({
            x: r.left + r.width,
            y: r.top + r.height
          })), o;
        }
        function zi(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ti(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? zi(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zi(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Oi = go(function (e) {
          const {
              annotation: t,
              globalAnnotation: n,
              viewportState: {
                zoomLevel: r,
                viewportRect: o,
                pagesRotation: i
              },
              children: a,
              isResizable: c,
              isModifiable: p,
              isRotatable: f,
              onFocus: m,
              onBlur: g,
              getScrollElement: v,
              transformClientToPage: y,
              window: b,
              interactionsDisabled: w,
              dispatch: x,
              selectedAnnotationShouldDrag: D,
              pageSize: C,
              isAnnotationPressPrevented: S,
              eventEmitter: P,
              restrictAnnotationToPageBounds: k,
              isEditableCP: A,
              shouldConstrainAspectRatio: T,
              setGlobalCursor: O,
              annotationDimensions: I,
              backend: F,
              disablePointSnapping: M
            } = e,
            R = (0, d.useRef)(!1),
            {
              formatMessage: B
            } = (0, xe.YB)(),
            N = d.useMemo(() => {
              let e;
              return (0, z.S6)(t) && t.measurementBBox ? (e = t.set("boundingBox", t.measurementBBox), e) : t;
            }, [t]),
            [L, V] = (0, po.Ah)(N),
            K = (0, l.v9)(e => e.shadowRoot),
            [q, H] = d.useState(null),
            [U, Z] = function (e, t, n) {
              const r = d.useRef(null);
              return [d.useCallback(function (e) {
                const {
                  current: t
                } = r;
                if (!t) return;
                const o = "function" == typeof t.getWrappedInstance ? t.getWrappedInstance() : t;
                o && "function" == typeof o.onClick && !n && o.onClick(e);
              }, [n]), r];
            }(0, 0, R.current);
          (0, d.useEffect)(() => {
            L && P.emit("annotations.transform", {
              annotation: L
            });
          }, [L, P]);
          const $ = d.useMemo(() => (0, G.cr)(e.viewportState, t.pageIndex), [e.viewportState, t.pageIndex]),
            W = d.useMemo(() => (0, j.SY)(L, r, i), [L, r, i]),
            Y = d.useCallback(function (e) {
              return e.scale(1 / r).rotate(i);
            }, [r, i]),
            X = d.useCallback(e => {
              H(e), O(e);
            }, [O]),
            Q = d.useCallback(function (e) {
              const t = (0, qe.az)(e),
                n = (0, j.SY)(t, r, i);
              if (C && k) {
                if (!new _.UL({
                  left: 0,
                  top: 0,
                  width: C.width,
                  height: C.height
                }).isRectInside(n)) return;
              }
              x((0, yt.FG)(t));
            }, [x, C, k, r, i]),
            {
              isDragging: ee,
              cancelDrag: te,
              startDraggingWithEvent: ne,
              startDraggingAtPoint: re,
              dragListener: oe
            } = function (e) {
              let {
                getScrollElement: t,
                transformClientToPage: n,
                transformedAnnotation: r,
                setTransformedAnnotation: o,
                setGlobalAnnotation: i,
                annotation: a,
                interactionsDisabled: l,
                dispatch: c,
                frameWindow: p,
                pageSize: h,
                onClick: f,
                transformDeltaFromClientToPage: m,
                eventEmitter: g,
                restrictAnnotationToPageBounds: v,
                isEditableCP: y,
                zoomLevel: b
              } = e;
              const [w, x] = d.useReducer(Ci, Di),
                {
                  isListening: D,
                  isDragging: C
                } = w,
                S = d.useCallback(function () {
                  return new _.E9({
                    x: t().scrollLeft,
                    y: t().scrollTop
                  });
                }, [t]);
              d.useEffect(() => () => {
                C && l && c((0, Kt.Zg)());
              }, [c, l, C]);
              const E = d.useRef(null),
                P = d.useCallback(function (e) {
                  E.current = S();
                  const t = n(e).translate(a.boundingBox.getLocation().scale(-1)),
                    r = m(e);
                  x({
                    type: "start",
                    mousePosition: r,
                    initialClickWithinAnnotation: t
                  });
                }, [S, n, m, a.boundingBox]),
                k = d.useCallback(function (e) {
                  e.isPrimary && P(new _.E9({
                    x: e.clientX,
                    y: e.clientY
                  }));
                }, [P]),
                A = d.useCallback(function () {
                  x({
                    type: "stop"
                  }), bi(p), c((0, Kt.Zg)());
                }, [p, c]),
                T = d.useCallback(function (e) {
                  if ((C || Si(e)) && e.stopPropagation(), r.equals(a) ? w.initialDragCompleted && f(e) : i(r), x({
                    type: "stop"
                  }), C) {
                    const e = {
                      annotations: (0, s.aV)([r]),
                      reason: J.f.MOVE_END
                    };
                    g.emit("annotations.willChange", e);
                  }
                  bi(p), c((0, Kt.Zg)());
                }, [a, p, c, C, f, w.initialDragCompleted, r, g, i]),
                O = d.useCallback(function (e) {
                  if (e.stopPropagation(), e.preventDefault(), C && 0 === e.buttons) return void T(e);
                  const {
                    previousMousePosition: t,
                    initialClickWithinAnnotation: n,
                    translation: r
                  } = w;
                  (0, u.kG)(t), (0, u.kG)(n);
                  const i = m(new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    })),
                    d = qt(n, t);
                  !l && d && c((0, Kt.X2)());
                  const f = i.translate(t.scale(-1)),
                    y = r.translate(f),
                    D = (0, mi.c)(a, y, h, n, v, b),
                    S = (0, z.S6)(D) ? D.set("measurementBBox", D.boundingBox) : D;
                  if (o(S), x({
                    type: "drag",
                    mousePosition: i,
                    translation: y
                  }), bi(p), !C) {
                    const e = {
                      annotations: (0, s.aV)([a]),
                      reason: J.f.MOVE_START
                    };
                    g.emit("annotations.willChange", e);
                  }
                }, [a, p, c, l, h, o, w, C, m, g, T, v, b]),
                I = d.useCallback(function () {
                  const e = t();
                  if (void 0 === e.scrollTop || void 0 === e.scrollLeft) return;
                  const n = S(),
                    r = E.current;
                  (0, u.kG)(r);
                  const i = m(n.translate(r.scale(-1))),
                    s = w.translation.translate(i);
                  let l = w.initialClickWithinAnnotation;
                  l || (l = new _.E9());
                  const c = (0, mi.c)(a, s, h, l, !1, b);
                  o(c), x({
                    type: "scroll",
                    translation: s
                  }), E.current = n, bi(p);
                }, [a, p, t, S, h, o, w.initialClickWithinAnnotation, w.translation, m, b]);
              (0, po.wA)(D, t, I);
              const F = D && d.createElement(Je.Z, {
                onRootPointerDownCapture: T,
                onRootPointerMoveCapture: y && !a.locked ? O : void 0,
                onRootPointerUpCapture: T
              });
              return {
                isDragging: C,
                cancelDrag: A,
                startDraggingWithEvent: k,
                startDraggingAtPoint: P,
                dragListener: F
              };
            }({
              getScrollElement: v,
              transformClientToPage: y,
              transformedAnnotation: L,
              setTransformedAnnotation: V,
              setGlobalAnnotation: Q,
              annotation: t,
              interactionsDisabled: w,
              dispatch: x,
              frameWindow: b,
              pageSize: C,
              onClick: U,
              transformDeltaFromClientToPage: Y,
              eventEmitter: P,
              restrictAnnotationToPageBounds: k,
              isEditableCP: A,
              zoomLevel: r
            }),
            {
              startResizing: ie,
              resizeListener: ae,
              isResizing: se
            } = function (e) {
              let {
                transformedAnnotation: t,
                setTransformedAnnotation: n,
                setGlobalAnnotation: r,
                annotation: o,
                dispatch: i,
                frameWindow: a,
                transformDeltaFromClientToPage: l,
                eventEmitter: c,
                pageSize: p,
                restrictAnnotationToPageBounds: h,
                shouldConstrainAspectRatio: f,
                annotationDimensions: m,
                clientTransformationMatrix: g,
                interactionsDisabled: v,
                backend: y,
                disablePointSnapping: b
              } = e;
              const [w, x] = d.useState(ki),
                [D, C] = d.useState(!1),
                S = d.useRef(void 0),
                E = d.useRef(null),
                P = d.useRef(!1);
              d.useEffect(() => () => {
                D && v && i((0, Kt.Zg)());
              }, [i, v, D]);
              const k = d.useCallback(function (e, n) {
                  var r;
                  if (!e.isPrimary) return;
                  (0, Ut.mE)(y, o, b) && y.configureSnapper(o.pageIndex);
                  const a = new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    }),
                    d = l(a);
                  x({
                    startingMousePosition: d,
                    startingResizeAnchor: n,
                    isListening: !0
                  }), C(!0);
                  const p = {
                    annotations: (0, s.aV)([o]),
                    reason: J.f.RESIZE_START
                  };
                  c.emit("annotations.willChange", p), o instanceof _.b3 && ![Ho.V.TOP, Ho.V.RIGHT, Ho.V.BOTTOM, Ho.V.LEFT].includes(n) && null !== (r = o.isMeasurement) && void 0 !== r && r.call(o) && ((0, u.kG)(t instanceof _.b3), i((0, Ht.eO)({
                    magnifierLabel: t.getMeasurementDetails().label,
                    drawnAnnotationID: t.id,
                    drawnAnnotationPageIndex: t.pageIndex,
                    magnifierCursorPosition: Ai(o, g, n)
                  }))), i((0, Kt.X2)());
                }, [t, i, l, o, c, g]),
                A = d.useCallback(async function (e) {
                  var t;
                  e.preventDefault();
                  const r = new _.E9({
                    x: e.clientX,
                    y: e.clientY
                  });
                  let s = l(r);
                  if ((0, Ut.mE)(y, o, b)) {
                    const e = await y.getClosestSnapPoint(new _.E9({
                      x: s.x,
                      y: s.y
                    }));
                    s = s.set("x", e.x).set("y", e.y);
                  }
                  const {
                    startingMousePosition: c,
                    startingResizeAnchor: d
                  } = w;
                  (0, u.kG)(c), (0, u.kG)(d);
                  const v = {
                      annotation: o,
                      resizeAnchor: d,
                      isShiftPressed: e.shiftKey
                    },
                    x = E.current;
                  null !== x && x.annotation.id === v.annotation.id && x.isShiftPressed === v.isShiftPressed && x.resizeAnchor === v.resizeAnchor || (P.current = f(v), S.current = m(v)), E.current = v;
                  const D = s.translate(c.scale(-1)),
                    C = (0, $o.D7)(o, D, d, P.current, void 0, p, h, S.current),
                    k = (0, z.S6)(C) ? C.set("measurementBBox", C.boundingBox) : C;
                  n(k), bi(a), o instanceof _.b3 && ![Ho.V.TOP, Ho.V.RIGHT, Ho.V.BOTTOM, Ho.V.LEFT].includes(d) && null !== (t = o.isMeasurement) && void 0 !== t && t.call(o) && ((0, u.kG)(C instanceof _.b3), i((0, Ht.eO)({
                    magnifierLabel: C.getMeasurementDetails().label,
                    magnifierCursorPosition: Ai(C, g, d)
                  })));
                }, [i, o, a, n, g, f, w, l, p, h]),
                T = d.useCallback(function (e) {
                  var n;
                  e.stopPropagation(), C(!1), x(ki), r(t), i((0, Kt.Zg)()), bi(a);
                  const l = {
                    annotations: (0, s.aV)([t]),
                    reason: J.f.RESIZE_END
                  };
                  c.emit("annotations.willChange", l), o instanceof _.b3 && null !== (n = o.isMeasurement) && void 0 !== n && n.call(o) && i((0, Ht.eO)(null));
                }, [o, a, i, r, t, c]);
              return {
                startResizing: k,
                resizeListener: w.isListening && d.createElement(Je.Z, {
                  onRootPointerMoveCapture: A,
                  onRootPointerUpCapture: T
                }),
                isResizing: D
              };
            }({
              transformedAnnotation: L,
              setTransformedAnnotation: V,
              setGlobalAnnotation: Q,
              annotation: t,
              dispatch: x,
              frameWindow: b,
              transformDeltaFromClientToPage: Y,
              eventEmitter: P,
              pageSize: C,
              restrictAnnotationToPageBounds: k,
              shouldConstrainAspectRatio: T,
              annotationDimensions: I,
              clientTransformationMatrix: $,
              interactionsDisabled: w,
              backend: F,
              disablePointSnapping: M
            }),
            {
              startRotating: le,
              rotateListener: ue,
              isRotating: ce
            } = function (e) {
              let {
                transformedAnnotation: t,
                setTransformedAnnotation: n,
                setGlobalAnnotation: r,
                annotation: o,
                dispatch: i,
                frameWindow: a,
                transformClientToPage: l,
                eventEmitter: u,
                pageSize: c,
                restrictAnnotationToPageBounds: p,
                centerPoint: h,
                interactionsDisabled: f,
                setLocalAndGlobalCursor: m,
                zoomLevel: g
              } = e;
              const [v, y] = d.useState(!1),
                [b, w] = d.useState(!1);
              d.useEffect(() => () => {
                b && f && i((0, Kt.Zg)());
              }, [i, f, b]);
              const x = d.useCallback(e => {
                  const t = new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    }),
                    n = l(t),
                    r = h.x - n.x,
                    o = n.y - h.y,
                    i = -Math.atan2(r, o);
                  return Math.round(i * (180 / Math.PI));
                }, [h, l]),
                D = d.useCallback(function (e) {
                  if (!e.isPrimary) return;
                  y(!0), w(!0);
                  const t = {
                    annotations: (0, s.aV)([o]),
                    reason: J.f.ROTATE_START
                  };
                  u.emit("annotations.willChange", t), i((0, Kt.X2)()), m((0, qe.Mg)(x(e), "grabbing"));
                }, [i, o, u, x, m]),
                C = d.useCallback(function (e) {
                  const r = x(e),
                    o = (0, qe.sw)(t, r, c, p, g);
                  n(o), bi(a), m((0, qe.Mg)(r, "grabbing"));
                }, [t, a, n, x, m, c, p, g]),
                S = d.useCallback(function (e) {
                  e.stopPropagation(), w(!1), y(!1);
                  const t = x(e),
                    n = (0, qe.sw)(o, t, c, p, g);
                  r(n), i((0, Kt.Zg)()), bi(a), m("");
                  const l = {
                    annotations: (0, s.aV)([n]),
                    reason: J.f.ROTATE_END
                  };
                  u.emit("annotations.willChange", l);
                }, [a, i, r, o, x, u, c, p, m, g]);
              return {
                startRotating: D,
                rotateListener: v && d.createElement(Je.Z, {
                  onRootPointerMoveCapture: C,
                  onRootPointerUpCapture: S
                }),
                isRotating: b
              };
            }({
              transformedAnnotation: L,
              setTransformedAnnotation: V,
              setGlobalAnnotation: Q,
              annotation: t,
              dispatch: x,
              frameWindow: b,
              transformClientToPage: y,
              eventEmitter: P,
              pageSize: C,
              restrictAnnotationToPageBounds: k,
              centerPoint: W.getCenter(),
              interactionsDisabled: w,
              setLocalAndGlobalCursor: X,
              zoomLevel: r
            }),
            de = (0, po.lB)(t, C, r, x),
            {
              startModifying: pe,
              modifyListener: he,
              isModifying: fe
            } = function (e) {
              let {
                transformedAnnotation: t,
                setTransformedAnnotation: n,
                setGlobalAnnotation: r,
                annotation: o,
                dispatch: i,
                frameWindow: a,
                transformDeltaFromClientToPage: c,
                eventEmitter: p,
                clientTransformationMatrix: h,
                pageSize: f,
                restrictAnnotationToPageBounds: m,
                backend: g,
                disablePointSnapping: v,
                zoomLevel: y
              } = e;
              const [b, w] = d.useState(_i),
                [x, D] = d.useState(!1),
                C = (0, l.v9)(e => e.defaultAutoCloseThreshold),
                S = d.useCallback(async function (e, t) {
                  var n;
                  if (!e.isPrimary) return;
                  const r = new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    }),
                    a = c(r);
                  (0, Ut.mE)(g, o, v) && (await g.configureSnapper(o.pageIndex)), w({
                    pointIndex: t,
                    startingMousePosition: a,
                    isListening: !0
                  }), D(!0);
                  const l = {
                    annotations: (0, s.aV)([o]),
                    reason: J.f.RESIZE_START
                  };
                  p.emit("annotations.willChange", l), o instanceof _.UX && null !== (n = o.isMeasurement) && void 0 !== n && n.call(o) && i((0, Ht.eO)({
                    magnifierLabel: o.getMeasurementDetails().label,
                    drawnAnnotationID: o.id,
                    drawnAnnotationPageIndex: o.pageIndex,
                    magnifierCursorPosition: Pi(o, t, h)
                  })), i((0, Kt.X2)());
                }, [i, c, o, p, h]),
                P = d.useCallback(async function (e) {
                  var t, r;
                  e.preventDefault();
                  const s = new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    }),
                    l = c(s),
                    {
                      startingMousePosition: d,
                      pointIndex: p
                    } = b;
                  (0, u.kG)(d), (0, u.kG)(null !== p);
                  const f = l.translate(d.scale(-1));
                  let m = (0, Ei.Sy)(o, f, p);
                  if ((0, u.kG)(m), (0, Ut.mE)(g, o, v)) {
                    let e = new _.E9({
                      x: 0,
                      y: 0
                    });
                    m instanceof _.o9 ? e = m.get(["startPoint", "endPoint"][p]) : (m instanceof _.om || m instanceof _.Hi) && (e = m.points.get(p));
                    const t = await g.getClosestSnapPoint(new _.E9({
                      x: e.x,
                      y: e.y
                    }));
                    e = e.set("x", t.x).set("y", t.y), m instanceof _.o9 ? m = m.set(["startPoint", "endPoint"][p], e) : (m instanceof _.om || m instanceof _.Hi) && (m = m.set("points", m.points.set(p, e)));
                  }
                  if (m instanceof _.om || m instanceof _.Hi) {
                    const e = (0, Ut.KM)(m, p, C);
                    -1 !== e && (m = (0, Ut.dg)(m, p, e));
                  }
                  n(m), bi(a), "isMeasurement" in m && null !== (t = (r = m).isMeasurement) && void 0 !== t && t.call(r) && i((0, Ht.eO)({
                    magnifierLabel: m.getMeasurementDetails().label,
                    magnifierCursorPosition: Pi(m, p, h)
                  }));
                }, [i, o, a, n, b, c, h]),
                k = d.useCallback(function (e) {
                  var n;
                  if (e.stopPropagation(), D(!1), w(_i), f && m) {
                    const e = new E.UL({
                        left: 0,
                        top: 0,
                        width: f.width,
                        height: f.height
                      }),
                      t = (0, j.SY)(o, y);
                    if (!e.isRectInside(t)) return;
                  }
                  r(t), i((0, Kt.Zg)()), bi(a);
                  const l = {
                    annotations: (0, s.aV)([t]),
                    reason: J.f.RESIZE_END
                  };
                  p.emit("annotations.willChange", l), "isMeasurement" in o && null !== (n = o.isMeasurement) && void 0 !== n && n.call(o) && i((0, Ht.eO)(null));
                }, [o, a, i, t, p, r, f, m, y]);
              return {
                startModifying: S,
                modifyListener: b.isListening && d.createElement(Je.Z, {
                  onRootPointerMoveCapture: P,
                  onRootPointerUpCapture: k
                }),
                isModifying: x
              };
            }({
              transformedAnnotation: L,
              setTransformedAnnotation: V,
              setGlobalAnnotation: Q,
              annotation: t,
              dispatch: x,
              frameWindow: b,
              transformDeltaFromClientToPage: Y,
              eventEmitter: P,
              clientTransformationMatrix: $,
              pageSize: C,
              restrictAnnotationToPageBounds: k,
              backend: F,
              disablePointSnapping: M,
              zoomLevel: r
            });
          (0, po.Sv)(D, x, re);
          const me = function (e, t) {
              return d.Children.map(e, e => d.cloneElement(e, Ti(Ti({}, t), {}, {
                isDisabled: !0
              })));
            }(a, Ti({
              annotation: L,
              globalAnnotation: n,
              ref: Z,
              isResizing: se,
              isModifying: fe,
              isDragging: ee,
              isRotating: ce
            }, q ? {
              cursor: q
            } : null)),
            ge = d.useRef(null);
          ge.current = function (e) {
            g && g(t, e);
          };
          const ve = (0, po.wL)(v);
          d.useEffect(function () {
            const {
              current: e
            } = ve;
            return function () {
              if (e && e === (null == e ? void 0 : e.ownerDocument.activeElement)) {
                const e = ge.current;
                e && e((0, Br.My)("blur"));
              }
            };
          }, []), d.useLayoutEffect(function () {
            ee && te();
          }, [r, te]), function (e, t, n, r, o, i, a, l, c) {
            let p = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : null,
              h = arguments.length > 10 ? arguments[10] : void 0;
            const [f, m] = d.useState(!1),
              g = d.useRef(!1),
              v = d.useCallback(function (t) {
                const o = t.composedPath()[0];
                if ((0, u.kG)(o), !(0, jr.eR)(o)) switch (t.key) {
                  case "Enter":
                  case " ":
                  case "Spacebar":
                    if ((0, jr.gC)(o) || (0, jr.N1)(o)) return;
                    e(t), t.preventDefault();
                    break;
                  case "ArrowLeft":
                  case "ArrowRight":
                  case "ArrowUp":
                  case "ArrowDown":
                    {
                      if ((0, jr.N1)(o)) return;
                      t.preventDefault();
                      const e = t.shiftKey ? 10 : 1,
                        u = (0, He.n5)(gi[t.key] - a),
                        d = vi(u),
                        p = 0 === u || 270 === u ? new E.E9() : new E.E9({
                          x: n.boundingBox.width,
                          y: n.boundingBox.height
                        }),
                        f = (0, mi.c)(n, d.scale(e), i, p, c, h);
                      if (r(f), !g.current) {
                        const e = {
                          annotations: (0, s.aV)([n]),
                          reason: J.f.MOVE_START
                        };
                        l.emit("annotations.willChange", e), g.current = !0;
                      }
                      m(!0);
                    }
                }
              }, [e, a, n, i, c, r, l, h]),
              y = d.useCallback(function (e) {
                const t = e.composedPath()[0];
                if ((0, u.kG)(t), !(0, jr.eR)(t) && (("Spacebar" !== e.key && " " !== e.key || !(0, jr.gC)(t)) && e.preventDefault(), f && o(n), g.current)) {
                  const e = {
                    annotations: (0, s.aV)([n]),
                    reason: J.f.MOVE_END
                  };
                  l.emit("annotations.willChange", e), g.current = !1;
                }
              }, [f, o, n, l]);
            d.useLayoutEffect(function () {
              const e = p ? p.ownerDocument : t.document;
              return e.addEventListener("keydown", v), e.addEventListener("keyup", y), function () {
                e.removeEventListener("keydown", v), e.removeEventListener("keyup", y);
              };
            }, [t.document, v, y, p]);
          }(U, b, L, V, Q, C, i, P, k, K, r);
          const ye = (0, j._k)(L, B);
          return d.createElement(Je.Z, {
            onPointerDownCapture: function (e) {
              e.isPrimary && (R.current = S({
                annotation: t,
                nativeEvent: e.nativeEvent,
                selected: !0
              }, P), R.current || x((0, _e.mg)(L, e, {
                selectedAnnotationShouldDrag: "touch" !== e.pointerType ? new _.E9({
                  x: e.clientX,
                  y: e.clientY
                }) : null,
                stopPropagation: !1,
                isAnnotationPressPrevented: !1
              })));
            },
            onPointerUp: Ii
          }, d.createElement("div", {
            style: {
              touchAction: "none"
            },
            role: "application"
          }, d.createElement(ei, {
            zoomLevel: r,
            viewportSize: o.getSize(),
            startModifying: pe,
            startResizing: ie,
            startDragging: ne,
            startRotating: le,
            onFitToSide: de,
            isDragging: ee,
            pagesRotation: i,
            annotation: L,
            isResizable: c && A,
            isModifiable: p && A,
            isRotatable: f && A,
            isEditableCP: A,
            annotationBoundingBox: W,
            window: b,
            cursor: q
          }, d.createElement("div", {
            tabIndex: 0,
            ref: ve,
            role: "button",
            "aria-label": L instanceof _.x_ ? B(ke.Z.selectedAnnotation, {
              arg0: ye
            }) : L instanceof _.gd || L instanceof _.Qi ? B(ke.Z.selectedAnnotationWithText, {
              arg0: ye,
              arg1: L.text.value
            }) : B(ke.Z.selectedAnnotation, {
              arg0: ye
            }),
            "data-testid": "selected annotation",
            onFocus: function (e) {
              m && m(t, e);
            },
            onBlur: ge.current,
            className: h()("PSPDFKit-Annotation-Selected", L.constructor.readableName && `PSPDFKit-${L.constructor.readableName}-Annotation-Selected`)
          }, me)), oe, ae, he, ue));
        });
        function Ii(e) {
          e.stopPropagation();
        }
        const Fi = (0, l.$j)(function (e, t) {
            let {
              annotation: n
            } = t;
            return {
              interactionsDisabled: e.interactionsDisabled,
              selectedAnnotationShouldDrag: e.selectedAnnotationShouldDrag,
              isAnnotationPressPrevented: t => (0, j.TW)(t, e.eventEmitter),
              eventEmitter: e.eventEmitter,
              restrictAnnotationToPageBounds: e.restrictAnnotationToPageBounds,
              isEditableCP: (0, to.CM)(n, e),
              shouldConstrainAspectRatio: t => (0, j.xU)(t, e),
              annotationDimensions: t => (0, j.aI)(t, e)
            };
          })(Oi),
          Mi = {
            isListening: !1,
            isDragging: !1,
            previousMousePosition: null,
            initialClickWithinAnnotation: null,
            translation: new _.E9(),
            initialDragCompleted: !1
          };
        function Ri(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ji(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ri(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ri(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Bi = go(function (e) {
          const {
              children: t,
              selectedAnnotations: n,
              selectedGlobalAnnotations: r,
              dispatch: o,
              viewportState: {
                zoomLevel: i,
                viewportRect: a,
                pagesRotation: l
              },
              isEditableCP: c,
              getScrollElement: p,
              transformClientToPage: f,
              window: m,
              interactionsDisabled: g,
              pageSize: v,
              eventEmitter: y,
              restrictAnnotationToPageBounds: b,
              selectedAnnotationShouldDrag: w,
              onFocus: x,
              onBlur: D
            } = e,
            {
              formatMessage: C
            } = (0, xe.YB)(),
            [S, E] = (0, po.Ah)(n),
            P = (0, po.wL)(p),
            k = (0, j.Jy)(S, i),
            A = d.useCallback(function (e) {
              return e.scale(1 / i).rotate(l);
            }, [i, l]),
            z = d.useCallback(function (e) {
              const t = e.map(e => {
                const t = (0, qe.az)(e),
                  n = (0, j.SY)(t, i, l);
                if (v && b) {
                  if (!new _.UL({
                    left: 0,
                    top: 0,
                    width: v.width,
                    height: v.height
                  }).isRectInside(n)) return null;
                }
                return t === e ? null : t;
              }).filter(Boolean);
              o((0, yt.GZ)(t, (0, s.aV)()));
            }, [o, v, b, i, l]),
            {
              isDragging: T,
              cancelDrag: O,
              startDraggingWithEvent: I,
              startDraggingAtPoint: F,
              dragListener: M
            } = function (e) {
              let {
                getScrollElement: t,
                transformClientToPage: n,
                transformedAnnotations: r,
                setTransformedAnnotations: o,
                setGlobalAnnotations: i,
                interactionsDisabled: a,
                dispatch: s,
                frameWindow: l,
                pageSize: c,
                transformDeltaFromClientToPage: p,
                eventEmitter: h,
                restrictAnnotationToPageBounds: f,
                isEditableCP: m,
                selectedAnnotationsBoundingBox: g,
                selectedAnnotations: v,
                zoomLevel: y
              } = e;
              const [b, w] = d.useReducer(Ci, Mi),
                {
                  isListening: x,
                  isDragging: D
                } = b,
                C = d.useCallback(function () {
                  return new _.E9({
                    x: t().scrollLeft,
                    y: t().scrollTop
                  });
                }, [t]);
              d.useEffect(() => () => {
                D && a && s((0, Kt.Zg)());
              }, [s, a, D]);
              const S = d.useRef(null),
                E = d.useCallback(function (e) {
                  S.current = C();
                  const t = n(e).translate(g.getLocation().scale(-1)),
                    r = p(e);
                  w({
                    type: "start",
                    mousePosition: r,
                    initialClickWithinAnnotation: t
                  });
                }, [C, n, p, g]),
                P = d.useCallback(function (e) {
                  e.isPrimary && E(new _.E9({
                    x: e.clientX,
                    y: e.clientY
                  }));
                }, [E]),
                k = d.useCallback(function () {
                  w({
                    type: "stop"
                  }), bi(l), s((0, Kt.Zg)());
                }, [l, s]),
                A = d.useCallback(function (e) {
                  if ((D || Si(e)) && e.stopPropagation(), r && i(r), w({
                    type: "stop"
                  }), D) {
                    const e = {
                      annotations: r,
                      reason: J.f.MOVE_END
                    };
                    h.emit("annotations.willChange", e);
                  }
                  bi(l), s((0, Kt.Zg)());
                }, [l, s, D, r, h, i]),
                z = d.useCallback(function (e) {
                  if (e.stopPropagation(), e.preventDefault(), D && 0 === e.buttons) return void A(e);
                  const {
                    previousMousePosition: t,
                    initialClickWithinAnnotation: n,
                    translation: r
                  } = b;
                  (0, u.kG)(t), (0, u.kG)(n);
                  const i = p(new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    })),
                    d = qt(n, t);
                  !a && d && s((0, Kt.X2)());
                  const m = i.translate(t.scale(-1)),
                    g = r.translate(m),
                    x = v.map(e => (0, mi.c)(e, g, c, n, f, y));
                  if (function (e, t) {
                    return e.left <= 0 || e.top <= 0 || e.left + e.width >= t.width || e.top + e.height >= t.height;
                  }((0, j.Jy)(x, y), c) || (o(x), w({
                    type: "drag",
                    mousePosition: i,
                    translation: g
                  })), bi(l), !D) {
                    const e = {
                      annotations: x,
                      reason: J.f.MOVE_START
                    };
                    h.emit("annotations.willChange", e);
                  }
                }, [l, s, a, c, o, b, D, p, h, A, f, v, y]),
                T = d.useCallback(function () {
                  const e = t();
                  if (void 0 === e.scrollTop || void 0 === e.scrollLeft) return;
                  const n = C(),
                    r = S.current;
                  (0, u.kG)(r);
                  const i = p(n.translate(r.scale(-1))),
                    a = b.translation.translate(i),
                    s = b.initialClickWithinAnnotation || new _.E9(),
                    d = v.map(e => (0, mi.c)(e, a, c, s, !1, y));
                  o(d), w({
                    type: "scroll",
                    translation: a
                  }), S.current = n, bi(l);
                }, [l, t, C, c, o, b.initialClickWithinAnnotation, b.translation, p, v, y]);
              (0, po.wA)(x, t, T);
              const O = x && d.createElement(Je.Z, {
                onRootPointerDownCapture: A,
                onRootPointerMoveCapture: m ? z : void 0,
                onRootPointerUpCapture: A
              });
              return {
                isDragging: D,
                cancelDrag: k,
                startDraggingWithEvent: P,
                startDraggingAtPoint: E,
                dragListener: O
              };
            }({
              getScrollElement: p,
              transformClientToPage: f,
              transformedAnnotations: S,
              setTransformedAnnotations: E,
              setGlobalAnnotations: z,
              interactionsDisabled: g,
              dispatch: o,
              frameWindow: m,
              pageSize: v,
              transformDeltaFromClientToPage: A,
              eventEmitter: y,
              restrictAnnotationToPageBounds: b,
              isEditableCP: c,
              selectedAnnotationsBoundingBox: k,
              selectedAnnotations: n,
              zoomLevel: i
            }),
            R = d.Children.toArray(t).map(e => d.isValidElement(e) ? function (e, t) {
              return d.cloneElement(e, ji(ji({}, t), {}, {
                isDisabled: !0
              }));
            }(e, {
              annotation: S.find(t => {
                var n;
                return t.id === (null === (n = e.props) || void 0 === n ? void 0 : n.annotation.id);
              }),
              globalAnnotation: r.find(t => {
                var n;
                return t.id === (null === (n = e.props) || void 0 === n ? void 0 : n.annotation.id);
              }),
              isDragging: T
            }) : e);
          (0, po.Sv)(w, o, F), d.useLayoutEffect(function () {
            T && O();
          }, [i, O]);
          const B = d.useRef(null);
          B.current = function (e, t) {
            D && D(e, t);
          };
          const N = R.filter(e => Boolean(e.props.annotation)).length > 1;
          return d.createElement(Je.Z, {
            onPointerDownCapture: function (e) {
              e.isPrimary;
            },
            onPointerUp: Ni
          }, d.createElement("div", {
            style: {
              touchAction: "none",
              zIndex: 1
            }
          }, d.createElement(ei, {
            zoomLevel: i,
            viewportSize: a.getSize(),
            startDragging: I,
            isDragging: T,
            pagesRotation: l,
            isResizable: !1,
            isModifiable: !1,
            isEditableCP: c,
            annotationBoundingBox: k,
            isRotatable: !1
          }, R.filter(e => Boolean(e.props.annotation)).map((e, t) => {
            const n = e.props.annotation,
              r = (0, j._k)(n, C);
            return d.createElement(ei, {
              key: n.id,
              zoomLevel: i,
              viewportSize: a.getSize(),
              startDragging: I,
              isDragging: T,
              pagesRotation: l,
              isResizable: !1,
              isModifiable: !1,
              isRotatable: !1,
              isEditableCP: c,
              annotationBoundingBox: (0, j.SY)(n, i, l),
              deselectAnnotation: e => {
                o((0, _e.mg)(n, e));
              },
              annotationRotation: n.rotation,
              customZIndex: 2
            }, d.createElement("div", {
              tabIndex: t,
              "aria-label": n instanceof de.x_ ? C(ke.Z.selectedAnnotation, {
                arg0: r
              }) : n instanceof de.gd || n instanceof de.Qi ? C(ke.Z.selectedAnnotationWithText, {
                arg0: r,
                arg1: n.text.value
              }) : C(ke.Z.selectedAnnotation, {
                arg0: r
              }),
              ref: N ? void 0 : P,
              role: "button",
              "data-testid": `selected annotation ${t}`,
              onFocus: e => {
                return t = n, r = e, void (x && x(t, r));
                var t, r;
              },
              onBlur: e => {
                var t;
                return null === (t = B.current) || void 0 === t ? void 0 : t.call(B, n, e);
              },
              className: h()(`PSPDFKit-Annotation-Selected-${t}`, "PSPDFKit-Annotation-Selected", n.constructor.readableName && `PSPDFKit-${n.constructor.readableName}-Annotation-Selected`)
            }, e));
          })), M));
        });
        function Ni(e) {
          e.stopPropagation();
        }
        const Li = (0, l.$j)(function (e, t) {
          let {
            annotation: n
          } = t;
          return {
            interactionsDisabled: e.interactionsDisabled,
            selectedAnnotationShouldDrag: e.selectedAnnotationShouldDrag,
            eventEmitter: e.eventEmitter,
            restrictAnnotationToPageBounds: e.restrictAnnotationToPageBounds,
            isEditableCP: (0, to.CM)(n, e),
            shouldConstrainAspectRatio: t => (0, j.xU)(t, e)
          };
        })(Bi);
        function Vi(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ki(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Vi(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vi(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function qi(e) {
          const [t, n] = d.useState(new W.Z()),
            [r, o] = d.useState(new W.Z());
          (0, s.is)(t, e.redactionAnnotation) || (0, s.is)(r, e.redactionAnnotation) || (o(e.redactionAnnotation), n(e.redactionAnnotation));
          const {
            dispatch: i,
            pageSize: a,
            keepSelectedTool: u
          } = e;
          d.useEffect(() => (i((0, Kt.X2)()), () => {
            i((0, Kt.Zg)());
          }), [i]);
          const {
              pageIndex: c
            } = e,
            p = (0, l.v9)(e => e.viewportState.zoomLevel),
            f = h()([_n().canvas], "PSPDFKit-Redaction-Canvas"),
            {
              boundingBox: m
            } = r,
            g = (0, l.v9)(e => e.scrollElement);
          return d.createElement("div", {
            className: f
          }, d.createElement(Ee, {
            zoomLevel: p,
            applyZoom: !0
          }, d.createElement("div", {
            style: Ki(Ki({}, m.toJS()), {}, {
              position: "absolute"
            })
          }, d.createElement(An, {
            annotation: r,
            zoomLevel: 1,
            previewRedactionMode: !1,
            isSelectable: !1
          }))), d.createElement(Zt, {
            pageSize: a,
            pageIndex: c,
            currentAnnotation: r,
            onAnnotationUpdate: o,
            keepSelectedTool: u,
            scrollElement: g
          }));
        }
        var Hi,
          Ui = n(25673),
          Zi = n(61193),
          $i = n.n(Zi),
          Gi = (Hi = function (e, t) {
            return Hi = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
            }, Hi(e, t);
          }, function (e, t) {
            function n() {
              this.constructor = e;
            }
            Hi(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          Wi = function () {
            return Wi = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, Wi.apply(this, arguments);
          },
          Yi = {
            top: {
              width: "100%",
              height: "10px",
              top: "-5px",
              left: "0px",
              cursor: "row-resize"
            },
            right: {
              width: "10px",
              height: "100%",
              top: "0px",
              right: "-5px",
              cursor: "col-resize"
            },
            bottom: {
              width: "100%",
              height: "10px",
              bottom: "-5px",
              left: "0px",
              cursor: "row-resize"
            },
            left: {
              width: "10px",
              height: "100%",
              top: "0px",
              left: "-5px",
              cursor: "col-resize"
            },
            topRight: {
              width: "20px",
              height: "20px",
              position: "absolute",
              right: "-10px",
              top: "-10px",
              cursor: "ne-resize"
            },
            bottomRight: {
              width: "20px",
              height: "20px",
              position: "absolute",
              right: "-10px",
              bottom: "-10px",
              cursor: "se-resize"
            },
            bottomLeft: {
              width: "20px",
              height: "20px",
              position: "absolute",
              left: "-10px",
              bottom: "-10px",
              cursor: "sw-resize"
            },
            topLeft: {
              width: "20px",
              height: "20px",
              position: "absolute",
              left: "-10px",
              top: "-10px",
              cursor: "nw-resize"
            }
          },
          Xi = function (e) {
            function t() {
              var t = null !== e && e.apply(this, arguments) || this;
              return t.onMouseDown = function (e) {
                t.props.onResizeStart(e, t.props.direction);
              }, t.onTouchStart = function (e) {
                t.props.onResizeStart(e, t.props.direction);
              }, t;
            }
            return Gi(t, e), t.prototype.render = function () {
              return d.createElement("div", {
                className: this.props.className || "",
                style: Wi(Wi({
                  position: "absolute",
                  userSelect: "none"
                }, Yi[this.props.direction]), this.props.replaceStyles || {}),
                onMouseDown: this.onMouseDown,
                onTouchStart: this.onTouchStart
              }, this.props.children);
            }, t;
          }(d.PureComponent),
          Qi = n(53316),
          Ji = n.n(Qi),
          ea = function () {
            var e = function (t, n) {
              return e = Object.setPrototypeOf || {
                __proto__: []
              } instanceof Array && function (e, t) {
                e.__proto__ = t;
              } || function (e, t) {
                for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
              }, e(t, n);
            };
            return function (t, n) {
              function r() {
                this.constructor = t;
              }
              e(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
            };
          }(),
          ta = function () {
            return ta = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, ta.apply(this, arguments);
          },
          na = {
            width: "auto",
            height: "auto"
          },
          ra = Ji()(function (e, t, n) {
            return Math.max(Math.min(e, n), t);
          }),
          oa = Ji()(function (e, t) {
            return Math.round(e / t) * t;
          }),
          ia = Ji()(function (e, t) {
            return new RegExp(e, "i").test(t);
          }),
          aa = function (e) {
            return Boolean(e.touches && e.touches.length);
          },
          sa = Ji()(function (e, t, n) {
            void 0 === n && (n = 0);
            var r = t.reduce(function (n, r, o) {
                return Math.abs(r - e) < Math.abs(t[n] - e) ? o : n;
              }, 0),
              o = Math.abs(t[r] - e);
            return 0 === n || o < n ? t[r] : e;
          }),
          la = Ji()(function (e, t) {
            return e.substr(e.length - t.length, t.length) === t;
          }),
          ua = Ji()(function (e) {
            return "auto" === (e = e.toString()) || la(e, "px") || la(e, "%") || la(e, "vh") || la(e, "vw") || la(e, "vmax") || la(e, "vmin") ? e : e + "px";
          }),
          ca = function (e, t, n, r) {
            if (e && "string" == typeof e) {
              if (la(e, "px")) return Number(e.replace("px", ""));
              if (la(e, "%")) return t * (Number(e.replace("%", "")) / 100);
              if (la(e, "vw")) return n * (Number(e.replace("vw", "")) / 100);
              if (la(e, "vh")) return r * (Number(e.replace("vh", "")) / 100);
            }
            return e;
          },
          da = Ji()(function (e, t, n, r, o, i, a) {
            return r = ca(r, e.width, t, n), o = ca(o, e.height, t, n), i = ca(i, e.width, t, n), a = ca(a, e.height, t, n), {
              maxWidth: void 0 === r ? void 0 : Number(r),
              maxHeight: void 0 === o ? void 0 : Number(o),
              minWidth: void 0 === i ? void 0 : Number(i),
              minHeight: void 0 === a ? void 0 : Number(a)
            };
          }),
          pa = ["as", "style", "className", "grid", "snap", "bounds", "boundsByDirection", "size", "defaultSize", "minWidth", "minHeight", "maxWidth", "maxHeight", "lockAspectRatio", "lockAspectRatioExtraWidth", "lockAspectRatioExtraHeight", "enable", "handleStyles", "handleClasses", "handleWrapperStyle", "handleWrapperClass", "children", "onResizeStart", "onResize", "onResizeStop", "handleComponent", "scale", "resizeRatio", "snapGap"],
          ha = "__resizable_base__",
          fa = function (e) {
            function t(t) {
              var n = e.call(this, t) || this;
              return n.ratio = 1, n.resizable = null, n.parentLeft = 0, n.parentTop = 0, n.resizableLeft = 0, n.resizableRight = 0, n.resizableTop = 0, n.resizableBottom = 0, n.targetLeft = 0, n.targetTop = 0, n.appendBase = function () {
                if (!n.resizable || !n.window) return null;
                var e = n.parentNode;
                if (!e) return null;
                var t = n.window.document.createElement("div");
                return t.style.width = "100%", t.style.height = "100%", t.style.position = "absolute", t.style.transform = "scale(0, 0)", t.style.left = "0", t.style.flex = "0", t.classList ? t.classList.add(ha) : t.className += ha, e.appendChild(t), t;
              }, n.removeBase = function (e) {
                var t = n.parentNode;
                t && t.removeChild(e);
              }, n.ref = function (e) {
                e && (n.resizable = e);
              }, n.state = {
                isResizing: !1,
                width: void 0 === (n.propsSize && n.propsSize.width) ? "auto" : n.propsSize && n.propsSize.width,
                height: void 0 === (n.propsSize && n.propsSize.height) ? "auto" : n.propsSize && n.propsSize.height,
                direction: "right",
                original: {
                  x: 0,
                  y: 0,
                  width: 0,
                  height: 0
                },
                backgroundStyle: {
                  height: "100%",
                  width: "100%",
                  backgroundColor: "rgba(0,0,0,0)",
                  cursor: "auto",
                  opacity: 0,
                  position: "fixed",
                  zIndex: 9999,
                  top: "0",
                  left: "0",
                  bottom: "0",
                  right: "0"
                },
                flexBasis: void 0
              }, n.onResizeStart = n.onResizeStart.bind(n), n.onMouseMove = n.onMouseMove.bind(n), n.onMouseUp = n.onMouseUp.bind(n), n;
            }
            return ea(t, e), Object.defineProperty(t.prototype, "parentNode", {
              get: function () {
                return this.resizable ? this.resizable.parentNode : null;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "window", {
              get: function () {
                return this.resizable && this.resizable.ownerDocument ? this.resizable.ownerDocument.defaultView : null;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "propsSize", {
              get: function () {
                return this.props.size || this.props.defaultSize || na;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "size", {
              get: function () {
                var e = 0,
                  t = 0;
                if (this.resizable && this.window) {
                  var n = this.resizable.offsetWidth,
                    r = this.resizable.offsetHeight,
                    o = this.resizable.style.position;
                  "relative" !== o && (this.resizable.style.position = "relative"), e = "auto" !== this.resizable.style.width ? this.resizable.offsetWidth : n, t = "auto" !== this.resizable.style.height ? this.resizable.offsetHeight : r, this.resizable.style.position = o;
                }
                return {
                  width: e,
                  height: t
                };
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(t.prototype, "sizeStyle", {
              get: function () {
                var e = this,
                  t = this.props.size,
                  n = function (t) {
                    if (void 0 === e.state[t] || "auto" === e.state[t]) return "auto";
                    if (e.propsSize && e.propsSize[t] && la(e.propsSize[t].toString(), "%")) {
                      if (la(e.state[t].toString(), "%")) return e.state[t].toString();
                      var n = e.getParentSize();
                      return Number(e.state[t].toString().replace("px", "")) / n[t] * 100 + "%";
                    }
                    return ua(e.state[t]);
                  };
                return {
                  width: t && void 0 !== t.width && !this.state.isResizing ? ua(t.width) : n("width"),
                  height: t && void 0 !== t.height && !this.state.isResizing ? ua(t.height) : n("height")
                };
              },
              enumerable: !1,
              configurable: !0
            }), t.prototype.getParentSize = function () {
              if (!this.parentNode) return this.window ? {
                width: this.window.innerWidth,
                height: this.window.innerHeight
              } : {
                width: 0,
                height: 0
              };
              var e = this.appendBase();
              if (!e) return {
                width: 0,
                height: 0
              };
              var t = !1,
                n = this.parentNode.style.flexWrap;
              "wrap" !== n && (t = !0, this.parentNode.style.flexWrap = "wrap"), e.style.position = "relative", e.style.minWidth = "100%";
              var r = {
                width: e.offsetWidth,
                height: e.offsetHeight
              };
              return t && (this.parentNode.style.flexWrap = n), this.removeBase(e), r;
            }, t.prototype.bindEvents = function () {
              this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
                capture: !0,
                passive: !1
              }), this.window.addEventListener("touchend", this.onMouseUp));
            }, t.prototype.unbindEvents = function () {
              this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
            }, t.prototype.componentDidMount = function () {
              if (this.resizable && this.window) {
                var e = this.window.getComputedStyle(this.resizable);
                this.setState({
                  width: this.state.width || this.size.width,
                  height: this.state.height || this.size.height,
                  flexBasis: "auto" !== e.flexBasis ? e.flexBasis : void 0
                });
              }
            }, t.prototype.componentWillUnmount = function () {
              this.window && this.unbindEvents();
            }, t.prototype.createSizeForCssProperty = function (e, t) {
              var n = this.propsSize && this.propsSize[t];
              return "auto" !== this.state[t] || this.state.original[t] !== e || void 0 !== n && "auto" !== n ? e : "auto";
            }, t.prototype.calculateNewMaxFromBoundary = function (e, t) {
              var n,
                r,
                o = this.props.boundsByDirection,
                i = this.state.direction,
                a = o && ia("left", i),
                s = o && ia("top", i);
              if ("parent" === this.props.bounds) {
                var l = this.parentNode;
                l && (n = a ? this.resizableRight - this.parentLeft : l.offsetWidth + (this.parentLeft - this.resizableLeft), r = s ? this.resizableBottom - this.parentTop : l.offsetHeight + (this.parentTop - this.resizableTop));
              } else "window" === this.props.bounds ? this.window && (n = a ? this.resizableRight : this.window.innerWidth - this.resizableLeft, r = s ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (n = a ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), r = s ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
              return n && Number.isFinite(n) && (e = e && e < n ? e : n), r && Number.isFinite(r) && (t = t && t < r ? t : r), {
                maxWidth: e,
                maxHeight: t
              };
            }, t.prototype.calculateNewSizeFromDirection = function (e, t) {
              var n = this.props.scale || 1,
                r = this.props.resizeRatio || 1,
                o = this.state,
                i = o.direction,
                a = o.original,
                s = this.props,
                l = s.lockAspectRatio,
                u = s.lockAspectRatioExtraHeight,
                c = s.lockAspectRatioExtraWidth,
                d = a.width,
                p = a.height,
                h = u || 0,
                f = c || 0;
              return ia("right", i) && (d = a.width + (e - a.x) * r / n, l && (p = (d - f) / this.ratio + h)), ia("left", i) && (d = a.width - (e - a.x) * r / n, l && (p = (d - f) / this.ratio + h)), ia("bottom", i) && (p = a.height + (t - a.y) * r / n, l && (d = (p - h) * this.ratio + f)), ia("top", i) && (p = a.height - (t - a.y) * r / n, l && (d = (p - h) * this.ratio + f)), {
                newWidth: d,
                newHeight: p
              };
            }, t.prototype.calculateNewSizeFromAspectRatio = function (e, t, n, r) {
              var o = this.props,
                i = o.lockAspectRatio,
                a = o.lockAspectRatioExtraHeight,
                s = o.lockAspectRatioExtraWidth,
                l = void 0 === r.width ? 10 : r.width,
                u = void 0 === n.width || n.width < 0 ? e : n.width,
                c = void 0 === r.height ? 10 : r.height,
                d = void 0 === n.height || n.height < 0 ? t : n.height,
                p = a || 0,
                h = s || 0;
              if (i) {
                var f = (c - p) * this.ratio + h,
                  m = (d - p) * this.ratio + h,
                  g = (l - h) / this.ratio + p,
                  v = (u - h) / this.ratio + p,
                  y = Math.max(l, f),
                  b = Math.min(u, m),
                  w = Math.max(c, g),
                  x = Math.min(d, v);
                e = ra(e, y, b), t = ra(t, w, x);
              } else e = ra(e, l, u), t = ra(t, c, d);
              return {
                newWidth: e,
                newHeight: t
              };
            }, t.prototype.setBoundingClientRect = function () {
              if ("parent" === this.props.bounds) {
                var e = this.parentNode;
                if (e) {
                  var t = e.getBoundingClientRect();
                  this.parentLeft = t.left, this.parentTop = t.top;
                }
              }
              if (this.props.bounds && "string" != typeof this.props.bounds) {
                var n = this.props.bounds.getBoundingClientRect();
                this.targetLeft = n.left, this.targetTop = n.top;
              }
              if (this.resizable) {
                var r = this.resizable.getBoundingClientRect(),
                  o = r.left,
                  i = r.top,
                  a = r.right,
                  s = r.bottom;
                this.resizableLeft = o, this.resizableRight = a, this.resizableTop = i, this.resizableBottom = s;
              }
            }, t.prototype.onResizeStart = function (e, t) {
              if (this.resizable && this.window) {
                var n,
                  r = 0,
                  o = 0;
                if (e.nativeEvent && function (e) {
                  return Boolean((e.clientX || 0 === e.clientX) && (e.clientY || 0 === e.clientY));
                }(e.nativeEvent)) {
                  if (r = e.nativeEvent.clientX, o = e.nativeEvent.clientY, 3 === e.nativeEvent.which) return;
                } else e.nativeEvent && aa(e.nativeEvent) && (r = e.nativeEvent.touches[0].clientX, o = e.nativeEvent.touches[0].clientY);
                if (this.props.onResizeStart) if (this.resizable) if (!1 === this.props.onResizeStart(e, t, this.resizable)) return;
                this.props.size && (void 0 !== this.props.size.height && this.props.size.height !== this.state.height && this.setState({
                  height: this.props.size.height
                }), void 0 !== this.props.size.width && this.props.size.width !== this.state.width && this.setState({
                  width: this.props.size.width
                })), this.ratio = "number" == typeof this.props.lockAspectRatio ? this.props.lockAspectRatio : this.size.width / this.size.height;
                var i = this.window.getComputedStyle(this.resizable);
                if ("auto" !== i.flexBasis) {
                  var a = this.parentNode;
                  if (a) {
                    var s = this.window.getComputedStyle(a).flexDirection;
                    this.flexDir = s.startsWith("row") ? "row" : "column", n = i.flexBasis;
                  }
                }
                this.setBoundingClientRect(), this.bindEvents();
                var l = {
                  original: {
                    x: r,
                    y: o,
                    width: this.size.width,
                    height: this.size.height
                  },
                  isResizing: !0,
                  backgroundStyle: ta(ta({}, this.state.backgroundStyle), {
                    cursor: this.window.getComputedStyle(e.target).cursor || "auto"
                  }),
                  direction: t,
                  flexBasis: n
                };
                this.setState(l);
              }
            }, t.prototype.onMouseMove = function (e) {
              if (this.state.isResizing && this.resizable && this.window) {
                if (this.window.TouchEvent && aa(e)) try {
                  e.preventDefault(), e.stopPropagation();
                } catch (e) {}
                var t = this.props,
                  n = t.maxWidth,
                  r = t.maxHeight,
                  o = t.minWidth,
                  i = t.minHeight,
                  a = aa(e) ? e.touches[0].clientX : e.clientX,
                  s = aa(e) ? e.touches[0].clientY : e.clientY,
                  l = this.state,
                  u = l.direction,
                  c = l.original,
                  d = l.width,
                  p = l.height,
                  h = this.getParentSize(),
                  f = da(h, this.window.innerWidth, this.window.innerHeight, n, r, o, i);
                n = f.maxWidth, r = f.maxHeight, o = f.minWidth, i = f.minHeight;
                var m = this.calculateNewSizeFromDirection(a, s),
                  g = m.newHeight,
                  v = m.newWidth,
                  y = this.calculateNewMaxFromBoundary(n, r),
                  b = this.calculateNewSizeFromAspectRatio(v, g, {
                    width: y.maxWidth,
                    height: y.maxHeight
                  }, {
                    width: o,
                    height: i
                  });
                if (v = b.newWidth, g = b.newHeight, this.props.grid) {
                  var w = oa(v, this.props.grid[0]),
                    x = oa(g, this.props.grid[1]),
                    D = this.props.snapGap || 0;
                  v = 0 === D || Math.abs(w - v) <= D ? w : v, g = 0 === D || Math.abs(x - g) <= D ? x : g;
                }
                this.props.snap && this.props.snap.x && (v = sa(v, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (g = sa(g, this.props.snap.y, this.props.snapGap));
                var C = {
                  width: v - c.width,
                  height: g - c.height
                };
                if (d && "string" == typeof d) if (la(d, "%")) v = v / h.width * 100 + "%";else if (la(d, "vw")) {
                  v = v / this.window.innerWidth * 100 + "vw";
                } else if (la(d, "vh")) {
                  v = v / this.window.innerHeight * 100 + "vh";
                }
                if (p && "string" == typeof p) if (la(p, "%")) g = g / h.height * 100 + "%";else if (la(p, "vw")) {
                  g = g / this.window.innerWidth * 100 + "vw";
                } else if (la(p, "vh")) {
                  g = g / this.window.innerHeight * 100 + "vh";
                }
                var S = {
                  width: this.createSizeForCssProperty(v, "width"),
                  height: this.createSizeForCssProperty(g, "height")
                };
                "row" === this.flexDir ? S.flexBasis = S.width : "column" === this.flexDir && (S.flexBasis = S.height), this.setState(S), this.props.onResize && this.props.onResize(e, u, this.resizable, C);
              }
            }, t.prototype.onMouseUp = function (e) {
              var t = this.state,
                n = t.isResizing,
                r = t.direction,
                o = t.original;
              if (n && this.resizable) {
                var i = {
                  width: this.size.width - o.width,
                  height: this.size.height - o.height
                };
                this.props.onResizeStop && this.props.onResizeStop(e, r, this.resizable, i), this.props.size && this.setState(this.props.size), this.unbindEvents(), this.setState({
                  isResizing: !1,
                  backgroundStyle: ta(ta({}, this.state.backgroundStyle), {
                    cursor: "auto"
                  })
                });
              }
            }, t.prototype.updateSize = function (e) {
              this.setState({
                width: e.width,
                height: e.height
              });
            }, t.prototype.renderResizer = function () {
              var e = this,
                t = this.props,
                n = t.enable,
                r = t.handleStyles,
                o = t.handleClasses,
                i = t.handleWrapperStyle,
                a = t.handleWrapperClass,
                s = t.handleComponent;
              if (!n) return null;
              var l = Object.keys(n).map(function (t) {
                return !1 !== n[t] ? d.createElement(Xi, {
                  key: t,
                  direction: t,
                  onResizeStart: e.onResizeStart,
                  replaceStyles: r && r[t],
                  className: o && o[t]
                }, s && s[t] ? s[t] : null) : null;
              });
              return d.createElement("div", {
                className: a,
                style: i
              }, l);
            }, t.prototype.render = function () {
              var e = this,
                t = Object.keys(this.props).reduce(function (t, n) {
                  return -1 !== pa.indexOf(n) || (t[n] = e.props[n]), t;
                }, {}),
                n = ta(ta(ta({
                  position: "relative",
                  userSelect: this.state.isResizing ? "none" : "auto"
                }, this.props.style), this.sizeStyle), {
                  maxWidth: this.props.maxWidth,
                  maxHeight: this.props.maxHeight,
                  minWidth: this.props.minWidth,
                  minHeight: this.props.minHeight,
                  boxSizing: "border-box",
                  flexShrink: 0
                });
              this.state.flexBasis && (n.flexBasis = this.state.flexBasis);
              var r = this.props.as || "div";
              return d.createElement(r, ta({
                ref: this.ref,
                style: n,
                className: this.props.className
              }, t), this.state.isResizing && d.createElement("div", {
                style: this.state.backgroundStyle
              }), this.props.children, this.renderResizer());
            }, t.defaultProps = {
              as: "div",
              onResizeStart: function () {},
              onResize: function () {},
              onResizeStop: function () {},
              enable: {
                top: !0,
                right: !0,
                bottom: !0,
                left: !0,
                topRight: !0,
                bottomRight: !0,
                bottomLeft: !0,
                topLeft: !0
              },
              style: {},
              grid: [1, 1],
              lockAspectRatio: !1,
              lockAspectRatioExtraWidth: 0,
              lockAspectRatioExtraHeight: 0,
              scale: 1,
              resizeRatio: 1,
              snapGap: 0
            }, t;
          }(d.PureComponent),
          ma = n(66780),
          ga = n.n(ma);
        function va(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ya(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? va(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : va(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const ba = {
          top: h()(ga().handles, ga().handleTop, "PSPDFKit-Document-Crop-Resize-Anchor-Top"),
          right: h()(ga().handles, ga().handleRight, "PSPDFKit-Document-Crop-Resize-Anchor-Right"),
          bottom: h()(ga().handles, ga().handleBottom, "PSPDFKit-Document-Crop-Resize-Anchor-Bottom"),
          left: h()(ga().handles, ga().handleLeft, "PSPDFKit-Document-Crop-Resize-Anchor-Left"),
          topRight: h()(ga().handles, ga().handleTopRight, "PSPDFKit-Document-Crop-Resize-Anchor-Top-Right"),
          bottomRight: h()(ga().handles, ga().handleBottomRight, "PSPDFKit-Document-Crop-Resize-Anchor-Bottom-Right"),
          bottomLeft: h()(ga().handles, ga().handleBottomLeft, "PSPDFKit-Document-Crop-Resize-Anchor-Bottom-Left"),
          topLeft: h()(ga().handles, ga().handleTopLeft, "PSPDFKit-Document-Crop-Resize-Anchor-Top-Left")
        };
        function wa(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          return e.scale(1 / t);
        }
        function xa(e) {
          return "touches" in e ? {
            clientX: e.touches[0].clientX,
            clientY: e.touches[0].clientY
          } : {
            clientX: e.clientX,
            clientY: e.clientY
          };
        }
        let Da = function (e) {
          return e[e.NOT_CREATED = 0] = "NOT_CREATED", e[e.CREATING = 1] = "CREATING", e[e.CREATED = 2] = "CREATED", e;
        }({});
        const Ca = e => {
          let {
            page: t,
            viewportState: n,
            onAreaChangeComplete: r,
            frameWindow: o,
            onAreaChangeStart: i,
            initialDraggingEvent: a
          } = e;
          const {
              zoomLevel: s
            } = n,
            c = (0, l.v9)(e => e.shadowRoot),
            [p, f] = (0, d.useState)(s),
            m = (0, d.useRef)(null),
            [g, v] = (0, d.useState)({
              left: 0,
              top: 0,
              height: 0,
              width: 0
            }),
            [y, b] = (0, d.useState)(!1),
            [w, x] = (0, d.useState)(null),
            [D, C] = (0, d.useState)(Da.NOT_CREATED),
            [S, E] = (0, d.useState)(!1),
            [P, k] = (0, d.useState)(void 0),
            [A, z] = (0, d.useState)(!1),
            T = (0, d.useRef)(null),
            O = (0, l.v9)(e => e.scrollElement);
          (0, d.useEffect)(() => {
            (0, jr.Re)(O) && (O.style.overflow = S ? "hidden" : "auto", c ? c.host.ownerDocument.body.style.overscrollBehavior = S ? "contain" : "auto" : o.document.body.style.overscrollBehavior = S ? "contain" : "auto");
          }, [o.document, S, c, O]), (0, d.useEffect)(() => {
            function e(e) {
              "Shift" === e.key && z(!0);
            }
            function t(e) {
              "Shift" === e.key && z(!1);
            }
            const n = c || o.document;
            return n.addEventListener("keydown", e), n.addEventListener("keyup", t), () => {
              n.removeEventListener("keydown", e), n.removeEventListener("keyup", t);
            };
          }, [o.document, c]), (0, d.useEffect)(() => {
            if (P && s !== p) {
              const e = P.scale(s / p);
              k(e), f(s), D === Da.CREATING && (C(Da.CREATED), null == r || r(wa(e, s)));
            }
          }, [p, s, P]);
          const I = (0, d.useCallback)((e, t, n, r) => {
            k(e => {
              var n, o;
              (0, u.kG)(e);
              let i = new _.UL({
                left: e.left,
                top: e.top,
                width: (null === (n = T.current) || void 0 === n ? void 0 : n.width) + r.width,
                height: (null === (o = T.current) || void 0 === o ? void 0 : o.height) + r.height
              });
              return e && t.toLowerCase().includes("top") && (i = i.set("top", e.top - (i.height - e.height))), e && t.toLowerCase().includes("left") && (i = i.set("left", e.left - (i.width - e.width))), i;
            });
          }, [k, t.pageSize, s, g]);
          function F(e) {
            const t = e.composedPath().find(e => {
              var t;
              return null === (t = e.classList) || void 0 === t ? void 0 : t.contains("PSPDFKit-Page");
            });
            return t ? parseInt(t.getAttribute("data-page-index"), 10) : null;
          }
          const M = (0, po.R9)(e => {
            "touches" in e && 2 === e.touches.length && b(!0);
            const n = F(e);
            if (t.pageIndex !== n) return;
            e.stopImmediatePropagation(), (0, u.kG)(m.current);
            const r = m.current.getBoundingClientRect(),
              {
                clientY: o,
                clientX: i
              } = xa(e);
            v(r), x(new _.E9({
              x: i - r.left,
              y: o - r.top
            }));
          });
          (0, d.useEffect)(() => {
            a && M(a);
          }, [a, M]);
          const R = (0, po.R9)(e => {
              if (!w || D === Da.CREATED) return;
              const {
                clientX: t,
                clientY: n
              } = xa(e);
              if (w.x !== t || w.y !== t) {
                e.stopImmediatePropagation(), E(!0);
                const r = t - g.left,
                  o = n - g.top,
                  a = new _.UL({
                    left: Math.max(0, Math.min(r, w.x)),
                    top: Math.max(0, Math.min(o, w.y)),
                    width: r < w.x ? Math.min(w.x, w.x - r) : Math.min(r - w.x, g.width - w.x),
                    height: o < w.y ? Math.min(w.y, w.y - o) : Math.min(o - w.y, g.height - w.y)
                  });
                k(a), C(Da.CREATING), D === Da.NOT_CREATED && (null == i || i(wa(a, s)));
              }
            }),
            j = (0, po.R9)(e => {
              if (D === Da.CREATED) return;
              b(!1);
              const n = F(e);
              t.pageIndex === n && e.stopImmediatePropagation(), E(!1), x(null), P ? (null == r || r(wa(P, s)), C(Da.CREATED)) : C(Da.NOT_CREATED);
            });
          (0, d.useEffect)(() => {
            const e = c || o.document;
            return e.addEventListener("pointerdown", M), e.addEventListener("pointermove", R), e.addEventListener("pointerup", j, {
              capture: !0
            }), e.addEventListener("touchstart", M), e.addEventListener("touchmove", R), e.addEventListener("touchend", j), () => {
              e.removeEventListener("pointerdown", M), e.removeEventListener("pointermove", R), e.removeEventListener("pointerup", j, {
                capture: !0
              }), e.removeEventListener("touchstart", M), e.removeEventListener("touchmove", R), e.removeEventListener("touchend", j);
            };
          }, [M, R, j]);
          const B = P && {
            x: P.left,
            y: P.top,
            width: P.width,
            height: P.height
          };
          return d.createElement("div", {
            ref: m,
            className: ga().wrapper,
            onPointerUp: e => e.stopPropagation(),
            role: "application"
          }, D !== Da.NOT_CREATED && d.createElement(d.Fragment, null, D === Da.CREATED && function (e) {
            const t = {
              position: "absolute",
              backgroundColor: "rgba(0,0,0,0.2)"
            };
            return e ? d.createElement(d.Fragment, null, d.createElement("div", {
              style: ya(ya({}, t), {}, {
                left: 0,
                top: 0,
                bottom: 0,
                width: e.left
              })
            }), d.createElement("div", {
              style: ya(ya({}, t), {}, {
                left: e.left,
                top: 0,
                right: 0,
                height: e.top
              })
            }), d.createElement("div", {
              style: ya(ya({}, t), {}, {
                left: e.left + e.width,
                top: e.top,
                right: 0,
                bottom: 0
              })
            }), d.createElement("div", {
              style: ya(ya({}, t), {}, {
                left: e.left,
                top: e.top + e.height,
                bottom: 0,
                width: e.width
              })
            })) : null;
          }(P), d.createElement($i(), {
            position: B,
            onStart: () => {
              (0, u.kG)(P), null == i || i(wa(P, s));
            },
            onDrag: (e, t) => {
              if (y) return !1;
              k(e => ((0, u.kG)(e), e.merge({
                left: t.x,
                top: t.y
              })));
            },
            onStop: () => {
              (0, u.kG)(P), null == r || r(wa(P, s));
            },
            defaultPosition: B,
            cancel: `.${ga().handles}`,
            bounds: "parent"
          }, d.createElement(fa, {
            size: P ? {
              width: P.width,
              height: P.height
            } : void 0,
            onResizeStart: () => {
              E(!0), (0, u.kG)(m.current && P), null == i || i(wa(P, s)), v(m.current.getBoundingClientRect()), T.current = P;
            },
            onResize: I,
            onResizeStop: () => {
              E(!1), (0, u.kG)(P), null == r || r(wa(P, s)), T.current = null;
            },
            handleClasses: ba,
            bounds: "parent",
            boundsByDirection: !0,
            lockAspectRatio: A
          }, d.createElement("div", {
            style: P ? {
              width: P.width,
              height: P.height
            } : void 0,
            className: h()(ga().cropBox, "PSPDFKit-Document-Crop-Box")
          })))));
        };
        function Sa(e) {
          const {
            dispatch: t,
            linkAnnotation: n,
            pageIndex: r
          } = e;
          d.useEffect(() => () => {
            t((0, Kt.lL)());
          }, []);
          const o = h()({
            [_n().canvas]: !0
          });
          return d.createElement("div", {
            className: o
          }, d.createElement(Ca, {
            viewportState: e.viewportState,
            page: e.page,
            onAreaChangeComplete: function (e) {
              const o = n.set("pageIndex", r).set("boundingBox", e);
              window.setTimeout(() => {
                (0, l.dC)(() => {
                  t((0, yt.FG)(o)), t((0, Kt.UU)()), t((0, _e.Df)((0, s.l4)([o.id]), null)), t((0, yt.ZE)(o.id)), t((0, Kt.lL)());
                });
              }, 10);
            },
            frameWindow: e.window
          }));
        }
        var Ea = n(98891),
          _a = n.n(Ea);
        const Pa = e => {
          let {
            viewportState: t,
            onAreaChangeComplete: n,
            frameWindow: r,
            onAreaChangeStart: o,
            initialDraggingEvent: i
          } = e;
          const a = (0, l.I0)(),
            {
              zoomLevel: s
            } = t,
            c = (0, d.useRef)(null),
            [p, f] = (0, d.useState)({
              left: 0,
              top: 0,
              height: 0,
              width: 0
            }),
            [m, g] = (0, d.useState)(!1),
            [v, y] = (0, d.useState)(null),
            [b, w] = (0, d.useState)(Da.NOT_CREATED),
            [x, D] = (0, d.useState)(void 0),
            C = (0, po.R9)(e => {
              "touches" in e && 2 === e.touches.length && g(!0), a((0, _e._)(!0)), e.stopImmediatePropagation(), (0, u.kG)(c.current);
              const t = c.current.getBoundingClientRect(),
                {
                  clientY: n,
                  clientX: r
                } = xa(e);
              f(t), y(new _.E9({
                x: r - t.left,
                y: n - t.top
              }));
            });
          (0, d.useEffect)(() => {
            i && C(i);
          }, [i, C]);
          const S = (0, po.R9)(e => {
              if (!v || b === Da.CREATED) return;
              const {
                clientX: t,
                clientY: n
              } = xa(e);
              if (v.x !== t || v.y !== t) {
                e.stopImmediatePropagation();
                const r = t - p.left,
                  i = n - p.top,
                  a = new _.UL({
                    left: Math.max(0, Math.min(r, v.x)),
                    top: Math.max(0, Math.min(i, v.y)),
                    width: r < v.x ? Math.min(v.x, v.x - r) : Math.min(r - v.x, p.width - v.x),
                    height: i < v.y ? Math.min(v.y, v.y - i) : Math.min(i - v.y, p.height - v.y)
                  });
                D(a), w(Da.CREATING), b === Da.NOT_CREATED && (null == o || o(wa(a, s)));
              }
            }),
            E = (0, po.tm)(),
            P = (0, po.R9)(() => {
              b !== Da.CREATED && (g(!1), a((0, _e._)(!1)), y(null), x && E() ? (null == n || n(wa(x, s)), w(Da.CREATED)) : w(Da.NOT_CREATED));
            });
          (0, d.useEffect)(() => (r.document.addEventListener("pointerdown", C), r.document.addEventListener("pointermove", S), r.document.addEventListener("pointerup", P, {
            capture: !0
          }), r.document.addEventListener("touchstart", C), r.document.addEventListener("touchmove", S), r.document.addEventListener("touchend", P, {
            capture: !0
          }), () => {
            r.document.removeEventListener("pointerdown", C), r.document.removeEventListener("pointermove", S), r.document.removeEventListener("pointerup", P, {
              capture: !0
            }), r.document.removeEventListener("touchstart", C), r.document.removeEventListener("touchmove", S), r.document.removeEventListener("touchend", P, {
              capture: !0
            });
          }), [C, S, P]);
          const k = x && {
            x: x.left,
            y: x.top,
            width: x.width,
            height: x.height
          };
          return d.createElement("div", {
            ref: c,
            className: _a().wrapper,
            onPointerUp: e => e.stopPropagation(),
            role: "application"
          }, b !== Da.NOT_CREATED && d.createElement(d.Fragment, null, d.createElement($i(), {
            position: k,
            onStart: () => {
              (0, u.kG)(x), null == o || o(wa(x, s));
            },
            onDrag: (e, t) => {
              if (m) return !1;
              D(e => ((0, u.kG)(e), e.merge({
                left: t.x,
                top: t.y
              })));
            },
            onStop: () => {
              (0, u.kG)(x), null == n || n(wa(x, s));
            },
            defaultPosition: k,
            bounds: "parent"
          }, d.createElement("div", {
            style: x ? {
              width: x.width,
              height: x.height
            } : void 0,
            className: h()(_a().selectionBox, "PSPDFKit-Multiple-Selection-Box")
          }))));
        };
        function ka(e) {
          const t = (0, l.I0)(),
            n = (0, l.v9)(e => e.annotations),
            r = (0, l.v9)(e => e.selectedAnnotationIds),
            {
              pageIndex: o,
              viewportState: i,
              window: a,
              initialDraggingEvent: u,
              multiAnnotationsUsingShortcut: c
            } = e;
          return De.Ni && r.size > 0 ? null : d.createElement("div", {
            className: _n().canvas
          }, d.createElement(Pa, {
            viewportState: i,
            onAreaChangeComplete: function (e) {
              const r = n.filter(e => e.pageIndex === o).toArray(),
                i = [];
              r.forEach(t => {
                let [n, r] = t;
                const o = r.boundingBox;
                e.isRectOverlapping(o) && i.push(n);
              }), i.length ? a.setTimeout(() => {
                (0, l.dC)(() => {
                  De.Ni || t((0, _e.fz)()), t((0, _e.Df)((0, s.l4)(i), null));
                });
              }, 5) : t((0, Kt.FA)());
            },
            frameWindow: a,
            initialDraggingEvent: c ? u : void 0
          }));
        }
        var Aa = n(30006);
        function za(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        const Ta = function (e) {
          const {
              annotation: t,
              zoomLevel: n,
              isDisabled: r,
              isFocused: i,
              isSelected: a,
              onFocus: s,
              onBlur: u
            } = e,
            c = (0, xe.YB)(),
            {
              formatMessage: p
            } = c,
            h = (0, l.I0)(),
            f = d.useCallback(e => {
              if (t instanceof de.gd && t.locked) {
                if (t.lockedContents) return;
                setTimeout(() => {
                  h((0, _e.VR)(t.id));
                }, 0);
              } else t instanceof de.Qi || t instanceof de.Jn ? h((0, _e.mg)(t, e, {
                selectedAnnotationShouldDrag: null,
                stopPropagation: !0,
                ignoreReadOnly: !0
              })) : t instanceof de.On && t.isCommentThreadRoot ? h((0, _e.mg)(t, e)) : h((0, _e.mg)(t, e, {
                selectedAnnotationShouldDrag: null,
                stopPropagation: !0
              }));
            }, [h, t]),
            m = d.useCallback(e => {
              (0, j.So)(t) && (null == s || s(t, e), (0, j.yj)(t, e) && h((0, _e.Q2)(t.id)));
            }, [h, s, t]),
            g = d.useCallback(e => {
              null == u || u(t, e), (0, j.yj)(t, e) && h((0, _e.Oc)(t.id));
            }, [h, u, t]);
          let v = "";
          t instanceof de.Jn && (v = `CommentThread-${t.id}`);
          const y = d.useRef(null),
            b = function (e, t) {
              return t && (e instanceof de.GI || e instanceof de.Zc || e instanceof de.UX || e instanceof de.gd || e instanceof de.On);
            }(t, i);
          d.useEffect(() => {
            var e;
            b && (null === (e = y.current) || void 0 === e || e.focus());
          }, [b]);
          const w = (0, po.jC)(e),
            x = null == w ? void 0 : w.isSelected,
            D = null == w ? void 0 : w.isDisabled;
          d.useEffect(() => {
            var e;
            y.current && y.current.ownerDocument.activeElement !== y.current && void 0 !== x && void 0 !== D && (t instanceof de.On && !x && a ? null === (e = y.current) || void 0 === e || e.focus() : x && !a && r && g((0, Br.My)("blur")));
          }, [t, g, a, r, x, D]);
          const C = (0, j.WX)(t, n),
            S = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? za(Object(n), !0).forEach(function (t) {
                  (0, o.Z)(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : za(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({
              position: "absolute",
              top: t.boundingBox.top * n,
              left: t.boundingBox.left * n,
              width: t.boundingBox.width * C,
              height: t.boundingBox.height * C,
              pointerEvents: "none"
            }, function (e, t) {
              if (e instanceof de.GI || e instanceof de.gd) return t ? {
                outline: j.A8,
                outlineOffset: "10px"
              } : {};
              if (e instanceof de.UX || e instanceof de.On) return t ? {
                outline: j.A8
              } : {};
              return {};
            }(t, i)),
            E = function (e, t) {
              if (e instanceof de.gd) {
                if ("plain" === e.text.format) return e.text.value;
                var n;
                if ("xhtml" === e.text.format) return null !== (n = new DOMParser().parseFromString(e.text.value, "text/html").body.textContent) && void 0 !== n ? n : void 0;
              }
              var r, o;
              return e instanceof de.Qi ? null !== (r = e.text.value) && void 0 !== r ? r : void 0 : e instanceof de.GI && null !== (o = (0, Aa.vW)({
                annotation: e,
                intl: t
              })) && void 0 !== o ? o : void 0;
            }(t, c);
          return d.createElement(we.Z, {
            disabled: r,
            onClick: f,
            onFocus: m,
            onBlur: g,
            "data-annotation-id": t.id,
            "aria-controls": v ? `CommentThread-${t.id}` : void 0,
            "aria-label": `${p(ke.Z.annotation)}: ${p((0, j.Xr)(t))}. ${null != E ? E : ""}`,
            tabIndex: 0,
            className: "PSPDFKit-Annotation-Keyboard-Navigable",
            style: S,
            innerRef: y
          });
        };
        const Oa = [B.A.SHAPE_LINE, B.A.SHAPE_RECTANGLE, B.A.SHAPE_ELLIPSE, B.A.SHAPE_POLYLINE, B.A.SHAPE_POLYGON],
          Ia = [B.A.DISTANCE, B.A.PERIMETER, B.A.RECTANGLE_AREA, B.A.ELLIPSE_AREA, B.A.POLYGON_AREA];
        var Fa = n(34923),
          Ma = n(58163);
        function Ra(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ja(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ra(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ra(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Ba = new Q.Z(),
          Na = {
            [V.Dj2]: e => e.set("debugMode", !0),
            [V.RTr]: e => e.set("hasFetchedInitialRecordsFromInstant", !0),
            [V.kt4]: (e, t) => {
              let {
                enabled: n
              } = t;
              return e.set("areClipboardActionsEnabled", n);
            },
            [V.heZ]: (e, t) => {
              let {
                group: n
              } = t;
              return e.set("group", n);
            },
            [V.G5w]: e => e.set("isDebugConsoleVisible", !0),
            [V.GW4]: e => e.set("isDebugConsoleVisible", !1),
            [V.mqf]: (e, t) => {
              let {
                preset: n = "text-highlighter"
              } = t;
              const r = new _.FV((0, j.lx)(e.set("currentItemPreset", n)));
              return e.withMutations(e => {
                e.set("currentItemPreset", n), e.set("interactionMode", B.A.TEXT_HIGHLIGHTER), e.set("selectedAnnotationIds", (0, s.l4)([r.id])), e.set("selectedAnnotationMode", N.o.EDITING), n && !(n in Y.AQ) && e.setIn(["annotationPresetIds", r.id], n), e.setIn(["annotations", r.id], r);
              });
            },
            [V.tLW]: e => e.withMutations(t => {
              t.set("currentItemPreset", null), t.set("interactionMode", null), e.interactionMode === B.A.TEXT_HIGHLIGHTER && (0, j.Xu)(t), t.set("selectedAnnotationIds", (0, s.l4)());
            }),
            [V.tS$]: (e, t) => {
              let {
                preset: n = "redaction"
              } = t;
              const r = new W.Z((0, j.lx)(e.set("currentItemPreset", n)));
              return e.withMutations(e => {
                e.set("currentItemPreset", n), e.set("interactionMode", B.A.REDACT_TEXT_HIGHLIGHTER), e.set("selectedAnnotationIds", (0, s.l4)([r.id])), e.set("selectedAnnotationMode", N.o.EDITING), n && !(n in Y.AQ) && e.setIn(["annotationPresetIds", r.id], n), e.setIn(["annotations", r.id], r);
              });
            },
            [V.g30]: e => e.withMutations(t => {
              t.set("currentItemPreset", null), t.set("interactionMode", null), e.interactionMode === B.A.REDACT_TEXT_HIGHLIGHTER && (0, j.Xu)(t), t.set("selectedAnnotationIds", (0, s.l4)());
            }),
            [V.VNM]: (e, t) => {
              let {
                editor: n
              } = t;
              return e.set("richTextEditorRef", n);
            },
            [V.yPS]: (e, t) => {
              let {
                preset: n
              } = t;
              return e.withMutations(e => {
                e.set("interactionMode", B.A.MEASUREMENT), void 0 !== n && e.set("currentItemPreset", n);
              });
            },
            [V.m_C]: e => e.set("interactionMode", null),
            [V.GXR]: (e, t) => {
              let {
                preset: n
              } = t;
              const r = new _.Zc((0, j.lx)(e));
              return e.withMutations(t => {
                t.set("interactionMode", B.A.INK), t.set("interactionsDisabled", !0), t.set("selectedAnnotationIds", (0, s.l4)([r.id])), t.set("selectedAnnotationMode", N.o.EDITING), void 0 !== n && t.set("currentItemPreset", n);
                const o = void 0 !== n ? n : e.currentItemPreset;
                o && !Y.AQ[o] && t.setIn(["annotationPresetIds", r.id], o), t.setIn(["annotations", r.id], r);
              });
            },
            [V.J7J]: e => e.set("interactionMode", null),
            [V.JyO]: e => e.withMutations(e => {
              e.set("interactionMode", B.A.INK_ERASER), e.set("selectedAnnotationIds", (0, s.l4)()), e.set("interactionsDisabled", !0);
            }),
            [V.NDs]: e => e.withMutations(e => {
              e.set("interactionMode", null), e.set("interactionsDisabled", !1);
            }),
            [V.Vu4]: (e, t) => {
              let {
                signatureRect: n,
                signaturePageIndex: r,
                formFieldName: o
              } = t;
              null !== r && (0, u.kG)("number" == typeof r && r >= 0 && r < e.totalPages, "pageIndex must be a number between 0 and " + (e.totalPages - 1)), null !== o && (0, u.kG)("string" == typeof o, "formFieldName must be a string");
              const i = {
                annotations: (0, s.aV)([new _.Zc({
                  isSignature: !0,
                  pageIndex: r
                })]),
                reason: J.f.SELECT_START
              };
              return e.eventEmitter.emit("annotations.willChange", i), e.withMutations(e => {
                e.set("interactionMode", B.A.SIGNATURE), e.setIn(["signatureState", "signatureRect"], n), e.setIn(["signatureState", "signaturePageIndex"], r), e.setIn(["signatureState", "formFieldName"], o);
              });
            },
            [V.S$y]: e => e.withMutations(e => {
              e.set("widgetAnnotationToFocus", null), e.set("interactionMode", null), e.set("currentItemPreset", null), e.setIn(["signatureState", "formFieldName"], null), e.setIn(["signatureState", "signatureRect"], null), e.setIn(["signatureState", "signaturePageIndex"], null);
            }),
            [V.Dzg]: e => {
              const t = {
                annotations: (0, s.aV)([new _.GI({
                  pageIndex: e.viewportState.currentPageIndex
                })]),
                reason: J.f.SELECT_START
              };
              return e.eventEmitter.emit("annotations.willChange", t), e.withMutations(e => {
                e.set("interactionMode", B.A.STAMP_PICKER), e.set("currentItemPreset", null);
              });
            },
            [V.M3C]: e => e.withMutations(e => {
              e.set("interactionMode", B.A.STAMP_CUSTOM), e.set("currentItemPreset", null);
            }),
            [V.tie]: e => e.withMutations(e => {
              e.set("interactionMode", null);
            }),
            [V.JS9]: (e, t) => {
              const n = Ia.includes(t.shapeInteractionMode),
                r = (0, j.lx)(e),
                {
                  activeMeasurementScale: o,
                  isCalibratingScale: i
                } = e;
              n && (r.measurementScale = null != o && o.scale ? new Ma.Z({
                fromValue: Number(o.scale.fromValue),
                toValue: Number(o.scale.toValue),
                unitFrom: o.scale.unitFrom,
                unitTo: o.scale.unitTo
              }) : e.measurementScale, r.measurementPrecision = null != o && o.precision ? o.precision : e.measurementPrecision, i && (r.strokeColor = _.Il.BLUE));
              const a = new t.shapeClass(r);
              return e.withMutations(n => {
                n.set("interactionMode", t.shapeInteractionMode), n.set("interactionsDisabled", !0), n.set("selectedAnnotationIds", (0, s.l4)([a.id])), n.set("selectedAnnotationMode", N.o.EDITING), void 0 !== t.preset && n.set("currentItemPreset", t.preset);
                const r = void 0 !== t.preset ? t.preset : e.currentItemPreset;
                r && !Y.AQ[r] && n.setIn(["annotationPresetIds", a.id], r), n.setIn(["annotations", a.id], a);
              });
            },
            [V.AIf]: e => e.withMutations(e => {
              e.set("interactionMode", null);
            }),
            [V.cbv]: (e, t) => {
              let {
                preset: n = "redaction"
              } = t;
              const r = new W.Z((0, j.lx)(e.set("currentItemPreset", n)));
              return e.withMutations(e => {
                e.set("currentItemPreset", n), e.set("interactionMode", B.A.REDACT_SHAPE_RECTANGLE), e.set("interactionsDisabled", !0), e.set("selectedAnnotationIds", (0, s.l4)([r.id])), e.set("selectedAnnotationMode", N.o.EDITING), n && !(n in Y.AQ) && e.setIn(["annotationPresetIds", r.id], n), e.setIn(["annotations", r.id], r);
              });
            },
            [V.TUA]: e => e.withMutations(t => {
              t.set("interactionMode", null), t.set("currentItemPreset", null), e.interactionMode === B.A.REDACT_SHAPE_RECTANGLE && (0, j.Xu)(t), t.set("selectedAnnotationIds", (0, s.l4)());
            }),
            [V.ZDQ]: (e, t) => {
              const {
                  annotation: n,
                  preset: r
                } = t,
                o = n || new _.Qi((0, j.lx)(e));
              return e.withMutations(t => {
                t.set("interactionMode", B.A.NOTE), t.set("selectedAnnotationIds", (0, s.l4)([o.id])), t.set("selectedAnnotationMode", N.o.EDITING), void 0 !== r && t.set("currentItemPreset", r);
                const n = void 0 !== r ? r : e.currentItemPreset;
                n && !Y.AQ[n] && t.setIn(["annotationPresetIds", o.id], n), t.setIn(["annotations", o.id], o);
              });
            },
            [V.B1n]: e => e.withMutations(e => {
              e.set("interactionMode", null);
            }),
            [V.dEe]: (e, t) => {
              const n = t.annotation ? t.annotation : new _.Jn((0, j.lx)(e));
              return e.withMutations(e => {
                e.set("selectedAnnotationIds", (0, s.l4)([n.id])), e.set("selectedAnnotationMode", N.o.EDITING), e.setIn(["annotations", n.id], n), e.set("interactionMode", B.A.COMMENT_MARKER), e.set("currentItemPreset", null);
              });
            },
            [V.iMs]: e => e.set("interactionMode", null),
            [V.pnu]: (e, t) => {
              const {
                annotation: n,
                preset: r
              } = t;
              let o = n;
              if (!o && (o = new _.gd((0, j.lx)(e)), e.enableRichText(o))) {
                var a;
                const e = i.ri.setStyleOrToggleFormat(o.text.value || "", "fontColor", (null === (a = o.fontColor) || void 0 === a ? void 0 : a.toHex()) || "");
                o = o.set("fontColor", null).set("text", {
                  format: "xhtml",
                  value: e
                });
              }
              const l = o.id;
              return e.withMutations(n => {
                n.set("interactionMode", t.isCallout ? B.A.CALLOUT : B.A.TEXT), void 0 !== r && n.set("currentItemPreset", r);
                const i = void 0 !== r ? r : e.currentItemPreset;
                i && !Y.AQ[i] && n.setIn(["annotationPresetIds", l], i), n.setIn(["annotations", l], o), n.set("selectedAnnotationIds", (0, s.l4)([l])), n.set("selectedAnnotationMode", N.o.EDITING);
              });
            },
            [V.KqR]: e => e.withMutations(e => {
              e.set("interactionMode", null);
            }),
            [V.JRS]: e => e.withMutations(e => {
              e.set("interactionMode", B.A.DOCUMENT_CROP), e.set("interactionsDisabled", !0), e.set("currentItemPreset", null);
            }),
            [V.Gox]: e => e.withMutations(e => {
              e.set("interactionMode", null), e.set("interactionsDisabled", !1);
            }),
            [V.eFQ]: e => e.set("interactionsDisabled", !1),
            [V.L8n]: e => e.set("interactionsDisabled", !0),
            [V.MuN]: e => e.set("showToolbar", !0),
            [V.xk1]: e => e.set("showToolbar", !1),
            [V.tYC]: e => e.set("enableAnnotationToolbar", !0),
            [V.NAH]: e => e.set("enableAnnotationToolbar", !1),
            [V.Ce5]: (e, t) => e.set("clientsChangeCallback", t.callback),
            [V.WtY]: (e, t) => e.set("transformClientToPage", t.transformClientToPage),
            [V.tPZ]: (e, t) => {
              const n = t.width > 0 ? Math.abs(t.width - e.scrollbarOffset) : -1 * e.scrollbarOffset,
                r = (0, G.a$)(e.viewportState, e.viewportState.viewportRect, !1, n);
              return e.merge({
                viewportState: r,
                scrollbarOffset: t.width
              });
            },
            [V.rWQ]: (e, t) => {
              let {
                layoutMode: n
              } = t;
              return e.update("viewportState", e => (0, G.YA)(e, n));
            },
            [V.b0l]: (e, t) => {
              let {
                scrollMode: n
              } = t;
              return e.update("viewportState", e => (0, G._U)(e, n));
            },
            [V._n_]: (e, t) => {
              let {
                scrollElement: n
              } = t;
              return e.set("scrollElement", n);
            },
            [V.bxr]: (e, t) => {
              let {
                spreadSpacing: n
              } = t;
              return e.set("viewportState", (0, G.JN)(e.viewportState, n));
            },
            [V._ko]: (e, t) => {
              let {
                pageSpacing: n
              } = t;
              return e.set("viewportState", (0, G.vY)(e.viewportState, n));
            },
            [V.FHt]: (e, t) => {
              let {
                keepFirstSpreadAsSinglePage: n
              } = t;
              return e.set("viewportState", (0, G.EY)(e.viewportState, n));
            },
            [V.ht3]: (e, t) => {
              let {
                viewportPadding: n
              } = t;
              return e.set("viewportState", (0, G._P)(e.viewportState, n));
            },
            [V.aYj]: e => e.set("printingEnabled", !0),
            [V.hpj]: e => e.set("printingEnabled", !1),
            [V.QYP]: e => e.set("exportEnabled", !0),
            [V.zKF]: e => e.set("exportEnabled", !1),
            [V.NfO]: (e, t) => {
              let {
                readOnlyEnabled: n
              } = t;
              return e.set("readOnlyEnabled", n);
            },
            [V.cyk]: e => e.set("showAnnotations", !0),
            [V.KYU]: e => e.set("showAnnotations", !1),
            [V.Nl1]: e => e.set("showComments", !0),
            [V.L9g]: e => e.set("showComments", !1),
            [V.Dl4]: e => e.set("showAnnotationNotes", !0),
            [V.GfR]: e => e.set("showAnnotationNotes", !1),
            [V.Xlm]: e => ((0, u.kG)(!e.backendPermissions.readOnly, "Can not disable read only mode."), e.set("readOnlyEnabled", te.J.NO)),
            [V.iQZ]: (e, t) => {
              let {
                features: n
              } = t;
              return (0, u.kG)(0 === e.features.size, "Cannot alterate the supported features list after initialization."), n.includes(ee.q.FORMS) || (e = e.set("formsEnabled", !1)), (0, Kn.Vz)(n) || n.includes(ee.q.ELECTRONIC_SIGNATURES) || (e = (e = e.set("readOnlyEnabled", te.J.LICENSE_RESTRICTED)).setIn(["backendPermissions", "readOnly"], !0)), e.set("features", n);
            },
            [V.JQC]: (e, t) => {
              let {
                signatureFeatureAvailability: n
              } = t;
              return (0, u.kG)(!e.signatureFeatureAvailability, "Cannot alterate the signature feature availability after initialization."), e.set("signatureFeatureAvailability", n);
            },
            [V.hv0]: (e, t) => {
              let {
                mode: n
              } = t;
              return e.set("sidebarMode", n);
            },
            [V.eI4]: (e, t) => {
              let {
                placement: n
              } = t;
              return e.set("sidebarPlacement", n);
            },
            [V.bP3]: (e, t) => {
              let {
                sidebarOptions: n
              } = t;
              return e.set("sidebarOptions", n);
            },
            [V._TO]: (e, t) => {
              let {
                showSignatureValidationStatus: n
              } = t;
              return e.set("showSignatureValidationStatus", n);
            },
            [V.dVW]: (e, t) => {
              let {
                locale: n
              } = t;
              return e.set("locale", n);
            },
            [V.hlI]: (e, t) => {
              let {
                annotationCreatorName: n,
                immutable: r
              } = t;
              return e.set("annotationCreatorName", n).set("annotationCreatorNameReadOnly", r);
            },
            [V.ZbY]: (e, t) => {
              let {
                editableAnnotationTypes: n
              } = t;
              return e.set("editableAnnotationTypes", n).set("isEditableAnnotation", null);
            },
            [V.uFU]: (e, t) => {
              let {
                isEditableAnnotation: n
              } = t;
              return e.set("isEditableAnnotation", n).set("editableAnnotationTypes", (0, s.l4)(X.Z));
            },
            [V.ArU]: (e, t) => {
              let {
                editableAnnotationTypes: n,
                isEditableAnnotation: r
              } = t;
              return e.set("isEditableAnnotation", r).set("editableAnnotationTypes", n);
            },
            [V.Q2U]: (e, t) => {
              let {
                isEditableComment: n
              } = t;
              return e.set("isEditableComment", n);
            },
            [V.IFt]: (e, t) => {
              let {
                formDesignMode: n
              } = t;
              return e.withMutations(t => {
                t.set("formDesignMode", n), !1 === n && t.set("selectedAnnotationIds", e.selectedAnnotationIds.filter(t => e.annotations.get(t) && !(e.annotations.get(t) instanceof _.x_)));
              });
            },
            [V.YIz]: e => e.set("interactionMode", B.A.DOCUMENT_EDITOR),
            [V.Gkm]: (e, t) => {
              let {
                measurementSnapping: n
              } = t;
              return e.set("measurementSnapping", n);
            },
            [V.fwq]: (e, t) => {
              let {
                measurementPrecision: n
              } = t;
              return e.set("measurementPrecision", n);
            },
            [V.G6t]: (e, t) => {
              let {
                scale: n
              } = t;
              return e.set("measurementScale", n);
            },
            [V.K26]: e => e.set("interactionMode", null),
            [V.Hbz]: e => e.set("interactionMode", B.A.MARQUEE_ZOOM),
            [V.$VE]: (e, t) => {
              let {
                interactionMode: n
              } = t;
              return e.set("interactionMode", n);
            },
            [V.yrz]: e => e.set("interactionMode", null),
            [V.sYK]: e => e.set("interactionMode", null),
            [V.fAF]: (e, t) => e.set("customRenderers", t.customRenderers),
            [V.pNz]: e => e.withMutations(e => {
              e.set("isSigning", !0), e.set("interactionsDisabled", !0);
            }),
            [V.bV3]: e => e.withMutations(e => {
              e.set("isSigning", !1), e.set("interactionsDisabled", !1);
            }),
            [V.EpY]: e => e.withMutations(e => {
              e.set("isApplyingRedactions", !0), e.set("interactionsDisabled", !0);
            }),
            [V.bui]: e => e.withMutations(e => {
              e.set("isApplyingRedactions", !1), e.set("interactionsDisabled", !1);
            }),
            [V.vVk]: (e, t) => {
              let {
                previewRedactionMode: n
              } = t;
              return e.set("previewRedactionMode", n);
            },
            [V.D5x]: (e, t) => e.set("a11yStatusMessage", t.a11yStatusMessage),
            [V.rpU]: (e, t) => {
              let {
                lastToolbarActionUsedKeyboard: n
              } = t;
              return e.set("lastToolbarActionUsedKeyboard", n);
            },
            [V.KA1]: (e, t) => {
              let {
                documentComparisonState: n
              } = t;
              return e.set("documentComparisonState", n ? ja(ja({}, e.documentComparisonState), n) : null);
            },
            [V.MYU]: e => e.set("canScrollWhileDrawing", !0),
            [V.mbD]: e => e.set("canScrollWhileDrawing", !1),
            [V.wog]: e => e.set("keepSelectedTool", !0),
            [V.UL9]: e => e.set("keepSelectedTool", !1),
            [V.tIQ]: (e, t) => {
              const n = e.viewportState.set("disablePointSnapping", t.disablePointSnapping);
              return e.set("viewportState", n);
            },
            [V.IyB]: (e, t) => {
              let {
                instance: n
              } = t;
              return e.set("instance", n);
            },
            [V.eJ4]: (e, t) => {
              let {
                customUIStore: n
              } = t;
              return e.set("customUIStore", n);
            },
            [V.R7l]: e => {
              const t = new _.R1((0, j.lx)(e)),
                n = "link";
              return e.withMutations(e => {
                e.set("linkAnnotationMode", !0), e.set("interactionMode", B.A.LINK), e.set("selectedAnnotationIds", (0, s.l4)([t.id])), e.set("selectedAnnotationMode", N.o.EDITING), e.setIn(["annotations", t.id], t), e.set("currentItemPreset", n);
                const r = n;
                !Y.AQ.link && e.setIn(["annotationPresetIds", t.id], r);
              });
            },
            [V.qKG]: e => e.withMutations(e => {
              e.set("linkAnnotationMode", !1);
            }),
            [V.oZW]: (e, t) => {
              let {
                multiAnnotationsUsingShortcut: n
              } = t;
              return e.withMutations(t => {
                e.isMultiSelectionEnabled && (t.set("interactionMode", B.A.MULTI_ANNOTATIONS_SELECTION), t.set("selectedAnnotationIds", (0, s.l4)()), t.set("selectedAnnotationMode", N.o.SELECTED), t.set("multiAnnotationsUsingShortcut", n));
              });
            },
            [V.odo]: e => e.withMutations(e => {
              e.set("interactionMode", null), e.set("multiAnnotationsUsingShortcut", null);
            }),
            [V.Vje]: e => e.set("interactionMode", B.A.MEASUREMENT_SETTINGS),
            [V.XTO]: e => e.set("interactionMode", null),
            [V.FQb]: (e, t) => {
              let {
                annotationsIds: n
              } = t;
              return e.withMutations(e => {
                var t;
                const {
                    annotationsGroups: r,
                    annotations: o
                  } = e,
                  i = null === (t = o.find(e => e.get("id") === n.first())) || void 0 === t ? void 0 : t.get("pageIndex");
                n.forEach(e => {
                  const t = o.find(t => t.id === e);
                  (0, u.kG)(t, `Annotation with id ${e} couldn't be found.`), (0, u.kG)(i === t.get("pageIndex"), "Annotations can't be grouped if they are not on the same page");
                });
                const a = r.map(e => {
                    const t = e.annotationsIds;
                    return e.annotationsIds = t.filter(e => !n.includes(e)), e;
                  }).filter(e => e.annotationsIds.size > 0),
                  l = (0, Fa.C)();
                e.set("annotationsGroups", a.set(l, {
                  groupKey: l,
                  annotationsIds: (0, s.l4)(n)
                })), e.set("selectedGroupId", l);
              });
            },
            [V.t$K]: (e, t) => {
              let {
                groupId: n
              } = t;
              return e.set("selectedGroupId", n);
            },
            [V.vBn]: (e, t) => {
              let {
                pullToRefreshNewState: n
              } = t;
              return e.set("disablePullToRefresh", n);
            },
            [V.bzW]: (e, t) => {
              let {
                groupId: n
              } = t;
              return e.withMutations(e => {
                const {
                  annotationsGroups: t
                } = e;
                e.set("annotationsGroups", t.delete(n)), e.set("selectedGroupId", null);
              });
            },
            [V.b4I]: (e, t) => {
              let {
                annotationId: n,
                groupId: r
              } = t;
              return e.withMutations(e => {
                const {
                    annotationsGroups: t
                  } = e,
                  o = t.get(r);
                o && (e.set("annotationsGroups", t.set(r, {
                  groupKey: r,
                  annotationsIds: o.annotationsIds.delete(n)
                })), e.set("selectedGroupId", null));
              });
            },
            [V.tzG]: (e, t) => {
              let {
                customFontsReadableNames: n
              } = t;
              return e.set("customFontsReadableNames", n);
            },
            [V.ej0]: (e, t) => {
              const n = e.viewportState.set("enableAlwaysScrollToZoom", t.enableAlwaysScrollToZoom);
              return e.set("viewportState", n);
            },
            [V.QM1]: (e, t) => {
              const n = e.viewportState.set("forceRenderWidgetsInAnnotationsOrder", t.forceRenderWidgetsInAnnotationsOrder);
              return e.set("viewportState", n);
            },
            [V.ol]: (e, t) => e.set("evaluation", t.evaluation),
            [V.wJn]: (e, t) => {
              const n = e.viewportState.set("prerenderedPageSpreads", t.prerenderedPageSpreads);
              return e.set("viewportState", n);
            },
            [V.rq0]: (e, t) => e.setIn(["documentAssistant", "configuration"], t.configuration),
            [V.HXk]: (e, t) => e.setIn(["documentAssistant", "show"], t.showDocumentAssistant),
            [V.wHH]: (e, t) => t.currentTextSelection && t.currentTextSelection.textRange ? e.setIn(["documentAssistant", "additionalContext"], {
              text: (0, yi.Q)(e, t.currentTextSelection),
              pageIndex: t.currentTextSelection.startPageIndex,
              boundingBox: (0, yi.U2)(e, t.currentTextSelection.textRange, !0)
            }) : e.setIn(["documentAssistant", "additionalContext"], null),
            [V.mxA]: (e, t) => e.set("isServerModeDownloadingWASM", t.isServerModeDownloadingWASM),
            [V.fBs]: (e, t) => e.set("isServerModeDownloadingDocument", t.isServerModeDownloadingDocument)
          };
        function La() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ba,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Na[t.type];
          return n ? n(e, t) : e;
        }
        var Va = n(14178);
        const Ka = new _.ZM(),
          qa = {
            [V.BS3]: (e, t) => e.set("connectionState", new _.em({
              name: Va.F.CONNECTING,
              reason: t.reason,
              progress: t.progress
            })),
            [V.nmm]: e => e.set("connectionState", new _.em({
              name: Va.F.CONNECTED
            })),
            [V.zZV]: (e, t) => e.set("connectionState", new _.em({
              name: Va.F.CONNECTION_FAILED,
              reason: t.reason
            })),
            [V.rxv]: (e, t) => e.set("annotationManager", t.annotationManager),
            [V.Hrp]: (e, t) => e.set("bookmarkManager", t.bookmarkManager),
            [V.GHc]: (e, t) => e.set("formFieldValueManager", t.formFieldValueManager),
            [V.oj5]: (e, t) => e.set("formFieldManager", t.formFieldManager),
            [V.UII]: (e, t) => e.set("commentManager", t.commentManager),
            [V.gbd]: (e, t) => e.set("changeManager", t.changeManager),
            [V.Ty$]: (e, t) => e.set("connectionState", new _.em({
              name: Va.F.PASSWORD_REQUIRED
            })).set("resolvePassword", t.resolvePassword),
            [V.hC8]: e => e.set("isUnlockedViaModal", !0).set("resolvePassword", null),
            [V.poO]: (e, t) => e.set("hasPassword", t.hasPassword),
            [V.iZ1]: (e, t) => e.set("allowedTileScales", t.allowedTileScales)
          };
        function Ha() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ka,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = qa[t.type];
          return n ? n(e, t) : e;
        }
        const Ua = new _.ZM(),
          Za = {
            [V.jJ7]: (e, t) => {
              const {
                item: n
              } = t;
              return (0, Ce.k)(e.pages.get(n.pageIndex), `Trying to insert a CustomOverlayItem at pageIndex ${n.pageIndex}. But such a page does not exist.`), e.withMutations(e => {
                e.updateIn(["pages", n.pageIndex, "customOverlayItemIds"], e => e.add(n.id)).setIn(["customOverlayItems", n.id], n);
              });
            },
            [V.G8_]: (e, t) => {
              const n = e.customOverlayItems.get(t.id);
              return (0, Ce.k)(n, "CustomOverlayItem not found"), e.withMutations(e => {
                e.deleteIn(["pages", n.pageIndex, "customOverlayItemIds", n.id]).deleteIn(["customOverlayItems", n.id]);
              });
            }
          };
        function $a() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ua,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Za[t.type];
          return n ? n(e, t) : e;
        }
        const Ga = new _.ZM(),
          Wa = {
            [V.lRe]: (e, t) => e.set("digitalSignatures", t.digitalSignatures)
          };
        function Ya() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ga,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Wa[t.type];
          return n ? n(e, t) : e;
        }
        const Xa = new Q.Z(),
          Qa = {
            [V.Oh4]: (e, t) => {
              let {
                outline: n
              } = t;
              return e.withMutations(e => {
                e.setIn(["documentOutlineState", "elements"], n), e.setIn(["documentOutlineState", "expanded"], es((0, s.D5)(), n, "0"));
              });
            },
            [V.Whn]: (e, t) => {
              let {
                level: n
              } = t;
              return e.updateIn(["documentOutlineState", "expanded", n], e => !e);
            }
          };
        function Ja() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Xa,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Qa[t.type];
          return n ? n(e, t) : e;
        }
        function es(e, t, n) {
          return t.reduce((e, t, r) => {
            if (0 === t.size) return e;
            const o = `${n}-${r}`;
            return es(e.set(o, t.isExpanded), t.children, o);
          }, e);
        }
        var ts = n(21683),
          ns = n(23248),
          rs = n(84293),
          os = n(81777);
        const is = new _.ZM(),
          as = {
            [V.wtk]: e => {
              const {
                  viewportState: t
                } = e,
                n = (0, ts.dF)(t, t.currentPageIndex),
                r = (0, ts.kd)(t),
                o = n >= r - 1 ? r - 1 : n + 1,
                i = (0, ts.P1)(t, o)[0];
              return (0, u.kG)("number" == typeof i, "Can not find the next pageIndex."), e.withMutations(t => {
                t.set("viewportState", (0, ns.eb)(e.viewportState, i)), t.set("hoverAnnotationIds", (0, s.l4)());
              });
            },
            [V.mE7]: e => {
              const {
                  viewportState: t
                } = e,
                n = (0, ts.dF)(t, t.currentPageIndex),
                r = n <= 0 ? 0 : n - 1,
                o = (0, ts.P1)(t, r)[0];
              return (0, u.kG)("number" == typeof o, "Can not find the next pageIndex."), e.withMutations(n => {
                n.set("viewportState", (0, ns.eb)(e.viewportState, o)), o !== t.currentPageIndex && n.set("hoverAnnotationIds", (0, s.l4)());
              });
            },
            [V.RxB]: (e, t) => {
              const {
                pageIndex: n
              } = t;
              return (0, u.kG)(n >= 0 && n < e.totalPages, "pageIndex out of bounds"), e.withMutations(t => {
                t.set("viewportState", (0, ns.eb)(e.viewportState, n)), n !== e.viewportState.currentPageIndex && t.set("hoverAnnotationIds", (0, s.l4)());
              });
            },
            [V.mLh]: (e, t) => {
              const {
                scrollPosition: n,
                lastScrollUsingKeyboard: r = !1
              } = t;
              return e.set("viewportState", (0, ns.hu)(e.viewportState, n).set("lastScrollUsingKeyboard", r));
            },
            [V.g4f]: (e, t) => {
              let {
                pageIndex: n,
                rect: r
              } = t;
              return e.set("viewportState", (0, ns.kN)(e.viewportState, n, r));
            },
            [V.Lyo]: (e, t) => {
              let {
                pageIndex: n,
                rect: r
              } = t;
              return e.set("viewportState", (0, ns.vP)(e.viewportState, n, r));
            },
            [V.xYE]: (e, t) => {
              var n;
              let {
                viewportRect: r,
                isTriggeredByOrientationChange: o
              } = t;
              const i = _.UL.fromClientRect(null === (n = e.rootElement) || void 0 === n ? void 0 : n.getBoundingClientRect()),
                a = (0, G.a$)(e.viewportState, r, o, e.scrollbarOffset);
              return e.withMutations(e => {
                e.set("containerRect", i), e.set("viewportState", a);
              });
            },
            [V.syg]: (e, t) => {
              let n = (0, rs.cq)(e.viewportState, t.zoomLevel);
              return t.scrollPosition && (n = n.set("scrollPosition", t.scrollPosition)), e.set("viewportState", n);
            },
            [V.u9b]: (e, t) => {
              const n = e.viewportState.set("zoomStep", t.zoomStep);
              return e.set("viewportState", n);
            },
            [V.ZGb]: (e, t) => e.set("viewportState", t.viewportState),
            [V.UFs]: e => e.set("viewportState", (0, rs.cq)(e.viewportState, e.viewportState.zoomLevel * e.viewportState.zoomStep)),
            [V.RCc]: e => e.set("viewportState", (0, rs.cq)(e.viewportState, e.viewportState.zoomLevel / e.viewportState.zoomStep)),
            [V.MfE]: e => e.set("viewportState", (0, rs.cq)(e.viewportState, os.c.AUTO)),
            [V.BWS]: e => e.set("viewportState", (0, rs.cq)(e.viewportState, os.c.FIT_TO_VIEWPORT)),
            [V.QU3]: e => e.set("viewportState", (0, rs.cq)(e.viewportState, os.c.FIT_TO_WIDTH)),
            [V.lD1]: (e, t) => {
              let {
                degCW: n
              } = t;
              return e.update("viewportState", e => (0, He.U1)(e, n));
            },
            [V.kRo]: e => e.set("interactionMode", B.A.PAN),
            [V.UFK]: e => e.set("interactionMode", null),
            [V.D1d]: (e, t) => {
              let {
                width: n
              } = t;
              return e.set("sidebarWidth", n);
            },
            [V.WsN]: (e, t) => {
              let {
                shouldDisable: n
              } = t;
              return e.set("scrollDisabled", n);
            }
          };
        function ss() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : is,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = as[t.type];
          return n ? n(e, t) : e;
        }
        var ls = n(62083),
          us = n(2464),
          cs = n(65160),
          ds = n(13422),
          ps = n(85944);
        function hs(e) {
          return (0, u.kG)(6 === e.length, "Tried to deserialize matrix that does not have 6 entries"), new E.sl({
            a: e[0],
            b: e[1],
            c: e[2],
            d: e[3],
            e: e[4],
            f: e[5]
          });
        }
        var fs = n(98492),
          ms = n(26564),
          gs = n.n(ms),
          vs = n(80567);
        function ys(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function bs(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ys(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ys(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const ws = new _.ZM(),
          xs = {
            [V.dCo]: (e, t) => {
              const n = e.pages.map(e => e.pageKey),
                r = (0, s.aV)(t.payload).map(t => {
                  var r;
                  const o = new _.$u({
                      width: t.width,
                      height: t.height
                    }),
                    i = n.get(t.pageIndex) || (0, Fa.C)(),
                    a = (null === (r = e.pages.get(t.pageIndex)) || void 0 === r ? void 0 : r.annotationIds) || (0, s.hU)();
                  return new _.T3(bs(bs({}, t), {}, {
                    matrix: hs(t.matrix),
                    reverseMatrix: hs(t.reverseMatrix),
                    untransformedRect: (0, fs.k)(t.untransformedBBox),
                    transformedRect: (0, fs.k)(t.transformedBBox),
                    rawPdfBoxes: t.rawPdfBoxes,
                    pageKey: i,
                    pageSize: o,
                    annotationIds: a
                  }));
                }),
                o = r.map(e => e.pageSize);
              return e.withMutations(e => {
                const t = e.viewportState.set("pageSizes", o);
                e.set("pages", r), e.set("viewportState", t), e.set("arePageSizesLoaded", !0);
              });
            },
            [V.ME7]: (e, t) => {
              const n = (0, s.aV)(t.payload.pages).map(e => {
                  var n;
                  const r = new _.$u({
                      width: e.width,
                      height: e.height
                    }),
                    o = (null === (n = t.pageKeys) || void 0 === n ? void 0 : n.get(e.pageIndex)) || (0, Fa.C)();
                  return new _.T3(bs(bs({}, e), {}, {
                    matrix: hs(e.matrix),
                    reverseMatrix: hs(e.reverseMatrix),
                    untransformedRect: (0, fs.k)(e.untransformedBBox),
                    transformedRect: (0, fs.k)(e.transformedBBox),
                    rawPdfBoxes: e.rawPdfBoxes,
                    pageKey: o,
                    pageSize: r
                  }));
                }),
                r = n.map(e => e.pageSize);
              return e.withMutations(o => {
                let i = o.viewportState.set("pageSizes", r);
                if (o.set("pages", n), o.set("totalPages", n.size), o.set("documentPermissions", new ls.Z(it.Options.IGNORE_DOCUMENT_PERMISSIONS ? void 0 : t.payload.permissions)), i.currentPageIndex >= n.size && (i = i.set("currentPageIndex", 0)), i.zoomMode === os.c.CUSTOM) {
                  const e = (0, rs.Yo)(i),
                    t = (0, rs.Sm)(i);
                  (i.zoomLevel < e || i.zoomLevel > t) && (i = i.set("zoomMode", os.c.AUTO));
                }
                if (i = i.zoomMode === os.c.CUSTOM ? i.merge({
                  zoomLevel: (0, rs.X9)(i, i.zoomLevel)
                }) : i.merge({
                  zoomLevel: (0, rs.X9)(i, i.zoomMode)
                }), i.scrollMode === us.G.PER_SPREAD && (i = (0, G._U)(i.set("scrollMode", us.G.CONTINUOUS), us.G.PER_SPREAD)), i.scrollMode === us.G.DISABLED && (i = (0, G._U)(i.set("scrollMode", us.G.CONTINUOUS), us.G.DISABLED)), i.currentPageIndex > 0) {
                  if (0 === i.viewportRect.width || 0 === i.viewportRect.height) {
                    let t = e.containerRect;
                    e.showToolbar && (t = t.set("top", ps.k3).set("height", t.height - ps.k3)), i = i.set("viewportRect", t);
                  }
                  i = (0, ns.eb)(i.set("currentPageIndex", 0), i.currentPageIndex);
                }
                o.set("viewportState", i);
              });
            },
            [V.z_j]: (e, t) => {
              const n = {},
                r = (0, s.D5)().withMutations(r => {
                  const o = {};
                  function i(t) {
                    t.textLines.forEach(t => {
                      var r;
                      if (!t.id) return;
                      let i = {};
                      const a = (0, vs.wn)((0, vs.f3)(t.hints));
                      a && (i = {
                        fontFamily: a
                      }, n[t.id] = a), o[t.id] = {
                        measurement: new Rr.f(null === (r = e.frameWindow) || void 0 === r ? void 0 : r.document, (0, s.aV)([(0, cs.LD)((0, Kn.HI)(e), t)]), i, gs().line, e.shadowRoot),
                        textLine: t
                      };
                    }), t.contentBlocks.forEach(e => {
                      i(e);
                    });
                  }
                  t.contentBlocks.forEach(e => {
                    i(e);
                  });
                  for (const e in o) {
                    const {
                        measurement: t,
                        textLine: n
                      } = o[e],
                      i = t.measure().get(0);
                    (0, Ce.k)(i), r.set(parseInt(e), {
                      scaleX: n.boundingBox.width / i.width,
                      scaleY: n.boundingBox.height / i.height
                    });
                  }
                  for (const e in o) {
                    const {
                      measurement: t
                    } = o[e];
                    t.remove();
                  }
                });
              return e.setIn(["pages", t.pageIndex, "contentBlocks"], t.contentBlocks).setIn(["pages", t.pageIndex, "textLineScales"], r).setIn(["pages", t.pageIndex, "textElementFonts"], n);
            },
            [V.fnw]: (e, t) => {
              let {
                backendPermissions: n
              } = t;
              return e.withMutations(e => {
                n.readOnly && e.set("readOnlyEnabled", te.J.VIA_BACKEND_PERMISSIONS), n.downloadingAllowed || (e.set("exportEnabled", !1), e.set("printingEnabled", !1)), e.set("backendPermissions", n);
              });
            },
            [V.obk]: e => e.withMutations(e => {
              e.set("annotations", (0, s.D5)()), e.set("attachments", (0, s.D5)()), e.set("formFields", (0, s.D5)()), e.set("currentTextSelection", null), e.set("interactionMode", null), e.set("selectedAnnotationIds", (0, s.l4)()), e.set("selectedAnnotationShouldDrag", null), e.set("selectedAnnotationMode", null), e.set("activeAnnotationNote", null), e.set("interactionsDisabled", !1), e.set("annotationPresetIds", (0, s.D5)()), e.set("documentOutlineState", new _.S()), e.set("comments", (0, s.D5)()), e.set("commentThreads", (0, s.D5)()), e.set("invalidAPStreams", (0, s.D5)()), e.set("searchState", new ds.Z());
            }),
            [V.S0t]: (e, t) => e.set("documentHandle", t.documentHandle).set("isDocumentHandleOutdated", !1),
            [V.YS$]: (e, t) => e.set("isDocumentHandleOutdated", t.isDocumentHandleOutdated),
            [V.UX$]: (e, t) => e.set("reuseState", t.state ? new Q.w(t.state) : null),
            [V.TG1]: (e, t) => e.withMutations(e => {
              t.pageIndexes.forEach(t => {
                e.setIn(["pages", t, "pageKey"], (0, Fa.C)());
              });
            }),
            [V.bM3]: (e, t) => e.withMutations(e => {
              t.pageKeysForPages.forEach(t => {
                e.setIn(["pages", t.pageIndex, "pageKey"], t.pageKey);
              });
            }),
            [V.QYq]: (e, t) => e.set("OCGLayers", t.OCGLayers),
            [V.kQ7]: (e, t) => e.set("visibleOCGLayers", t.visibleLayerIds)
          };
        function Ds() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : ws,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = xs[t.type];
          return n ? n(e, t) : e;
        }
        const Cs = new Q.Z(),
          Ss = {
            [V.skc]: e => e.set("isPrinting", !0),
            [V.snh]: e => e.set("isPrinting", !1),
            [V._uU]: e => e.set("isPrinting", !1),
            [V.qV6]: (e, t) => {
              let {
                currentPage: n
              } = t;
              return e.set("printLoadingIndicatorProgress", n);
            }
          };
        function Es() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Cs,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Ss[t.type];
          return n ? n(e, t) : e;
        }
        function _s(e, t) {
          const {
              focusedResultIndex: n
            } = e.searchState,
            r = e.searchState.results.size;
          if (r <= 0) return e;
          let o = n + t;
          o < 0 && (o += r);
          const i = Math.abs(o % r),
            a = e.searchState.results.get(i);
          (0, Ce.k)(a);
          const s = (0, ns.kN)(e.viewportState, a.pageIndex, _.UL.union(null == a ? void 0 : a.rectsOnPage));
          return e.setIn(["searchState", "focusedResultIndex"], i).set("viewportState", s);
        }
        const Ps = {
          [V.FH6]: (e, t) => t.term.length >= e.searchState.minSearchQueryLength ? e.setIn(["searchState", "term"], t.term) : e.setIn(["searchState", "term"], t.term).setIn(["searchState", "focusedResultIndex"], -1).setIn(["searchState", "results"], (0, s.aV)()).setIn(["searchState", "isLoading"], !1),
          [V.$Jy]: e => _s(e, 1),
          [V.gIV]: e => _s(e, -1),
          [V.$hO]: e => e.set("interactionMode", B.A.SEARCH).setIn(["searchState", "isFocused"], !0),
          [V._AY]: e => e.set("interactionMode", null).mergeIn(["searchState"], {
            isFocused: !1,
            term: "",
            results: (0, s.aV)(),
            focusedResultIndex: -1
          }),
          [V.Ifu]: e => e.setIn(["searchState", "isFocused"], !0),
          [V.nFn]: e => e.setIn(["searchState", "isFocused"], !1),
          [V.F6q]: (e, t) => {
            let {
              isLoading: n
            } = t;
            return e.setIn(["searchState", "isLoading"], n);
          },
          [V.qZT]: (e, t) => {
            let {
                results: n
              } = t,
              r = e.viewportState,
              o = -1;
            if (-1 !== e.searchState.focusedResultIndex) {
              const t = e.searchState.results.get(e.searchState.focusedResultIndex);
              (0, Ce.k)(t);
              const {
                  pageIndex: r
                } = t,
                i = t.rectsOnPage.first();
              (0, Ce.k)(i);
              const {
                top: a,
                left: s
              } = i;
              o = n.findIndex(e => {
                const t = e.rectsOnPage.first();
                return (0, Ce.k)(t), e.pageIndex === r && t.top === a && t.left === s;
              });
            }
            if (-1 === o && n.size > 0) {
              o = n.findIndex(t => t.pageIndex >= e.viewportState.currentPageIndex), -1 === o && (o = 0);
              const t = n.get(o);
              (0, Ce.k)(t), r = (0, ns.kN)(e.viewportState, t.pageIndex, _.UL.union(t.rectsOnPage));
            }
            return e.setIn(["searchState", "results"], n).setIn(["searchState", "focusedResultIndex"], o).set("viewportState", r);
          },
          [V.p1u]: (e, t) => {
            let {
              state: n
            } = t;
            return e.set("searchState", n);
          },
          [V.esN]: (e, t) => {
            let {
              provider: n
            } = t;
            return e.set("searchProvider", n);
          }
        };
        function ks(e, t) {
          const n = Ps[t.type];
          return n ? n(e, t) : e;
        }
        const As = new _.ZM(),
          zs = {
            [V.f3N]: (e, t) => {
              const n = t.textRange.startAndEndIds();
              if (!n) return e;
              const {
                  startTextLineId: r,
                  endTextLineId: o,
                  startNestedContentBlockId: i,
                  endNestedContentBlockId: a,
                  startPageIndex: l,
                  endPageIndex: u
                } = n,
                c = new _.Bs({
                  textRange: t.textRange,
                  startTextLineId: r,
                  endTextLineId: o,
                  startNestedContentBlockId: i,
                  endNestedContentBlockId: a,
                  startPageIndex: l,
                  endPageIndex: u
                }),
                d = e.withMutations(t => {
                  t.set("currentTextSelection", c), e.interactionMode !== B.A.TEXT_HIGHLIGHTER && e.interactionMode !== B.A.REDACT_TEXT_HIGHLIGHTER && t.set("selectedAnnotationIds", (0, s.l4)());
                });
              return (0, Kn.j$)(_.On, e) ? d : d.withMutations(e => {
                e.set("inlineTextMarkupToolbar", t.inlineTextMarkupToolbar);
              });
            },
            [V.MOe]: e => e.delete("currentTextSelection"),
            [V.a33]: e => e.withMutations(t => {
              t.delete("selectedAnnotationMode"), t.set("currentItemPreset", null), e.interactionMode === B.A.TEXT_HIGHLIGHTER && (0, j.Xu)(t), t.set("selectedAnnotationIds", (0, s.l4)()), t.set("widgetAnnotationToFocus", null), t.set("interactionMode", e.interactionMode === B.A.PAN || e.interactionMode === B.A.FORM_CREATOR ? e.interactionMode : null), t.set("selectedTextOnEdit", !1), t.set("activeAnnotationNote", null), e.interactionMode === B.A.DISTANCE && e.isCalibratingScale && t.set("isCalibratingScale", !1);
            }),
            [V._Yi]: (e, t) => {
              let n = null;
              const r = t.annotations.filter(t => {
                const r = e.annotations.get(t);
                return n = e.annotationPresetIds.get(t) || null, r && (r instanceof _.Qi || r.isCommentThreadRoot || !(0, Kn.lV)(r, e));
              });
              return 0 === r.size ? e : e.withMutations(o => {
                o.set("selectedAnnotationIds", r), o.set("currentItemPreset", n), o.set("selectedAnnotationMode", t.mode), o.set("selectedAnnotationShouldDrag", t.selectedAnnotationShouldDrag), o.delete("currentTextSelection"), De.Ni && 1 === r.size && e.interactionMode === B.A.MULTI_ANNOTATIONS_SELECTION && o.set("interactionMode", null);
              });
            },
            [V.c3G]: e => e.set("selectedAnnotationShouldDrag", null),
            [V.RvB]: e => e.set("selectedTextOnEdit", !0),
            [V.qh0]: (e, t) => ((0, u.kG)(e.annotations.has(t.id), "Annotation not found"), e.readOnlyEnabled ? e.update("focusedAnnotationIds", e => e.add(t.id)) : e),
            [V.rm]: (e, t) => ((0, u.kG)(e.annotations.has(t.id), "Annotation not found"), e.readOnlyEnabled ? e.update("focusedAnnotationIds", e => e.delete(t.id)) : e),
            [V.TPT]: (e, t) => {
              (0, u.kG)(e.annotations.has(t.id), "Annotation not found");
              const n = e.annotations.get(t.id);
              return e.readOnlyEnabled === te.J.NO || n instanceof _.Qi ? e.updateIn(["hoverAnnotationIds"], e => e.has(t.id) ? e : e.add(t.id)) : e;
            },
            [V.iyZ]: (e, t) => {
              (0, u.kG)(e.annotations.has(t.id), "Annotation not found");
              const n = e.annotations.get(t.id);
              return e.readOnlyEnabled === te.J.NO || n instanceof _.Qi ? e.updateIn(["hoverAnnotationIds"], e => e.has(t.id) ? e.delete(t.id) : e) : e;
            },
            [V.yyM]: (e, t) => {
              const n = t.annotationNote;
              return e.set("hoverAnnotationNote", n);
            },
            [V.vSH]: (e, t) => e.set("activeAnnotationNote", t.annotationNote),
            [V._fK]: (e, t) => e.withMutations(n => {
              if (t.newSelectedAnnotationsIds.size > 0) n.set("selectedAnnotationIds", t.newSelectedAnnotationsIds);else {
                const r = 1 === e.selectedAnnotationIds.size && e.annotations.get(e.selectedAnnotationIds.first());
                if (!r || null != r.pageIndex) {
                  const r = new t.annotationClass((0, j.lx)(e));
                  n.setIn(["annotations", r.id], r), n.set("selectedAnnotationIds", (0, s.l4)([r.id])), null != e.currentItemPreset && n.setIn(["annotationPresetIds", r.id], e.currentItemPreset);
                }
              }
            }),
            [V.L2A]: (e, t) => e.set("inlineTextSelectionToolbarItems", t.inlineTextSelectionToolbarItemsCallback)
          };
        function Ts() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : As,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = zs[t.type];
          return n ? n(e, t) : e;
        }
        const Os = new _.ZM(),
          Is = {
            [V.mGH]: (e, t) => {
              let {
                signature: n
              } = t;
              return e.withMutations(e => {
                (0, j.ud)(e, n);
              });
            },
            [V.W0l]: (e, t) => {
              let {
                annotation: n
              } = t;
              return e.signatureState.formFieldName && (0, u.kG)(!e.signatureState.formFieldsNotSavingSignatures.includes(e.signatureState.formFieldName), `Cannot save signature for the form field \`${e.signatureState.formFieldName}\` because this field is in formFieldsNotSavingSignatures`), e.updateIn(["signatureState", "storedSignatures"], e => e.push(n));
            },
            [V.Kw7]: (e, t) => {
              let {
                annotations: n
              } = t;
              return e.setIn(["signatureState", "storedSignatures"], n);
            },
            [V.Kc8]: (e, t) => {
              let {
                annotation: n
              } = t;
              return e.updateIn(["signatureState", "storedSignatures"], e => e.filter(e => !e.equals(n)));
            }
          };
        function Fs() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Os,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Is[t.type];
          return n ? n(e, t) : e;
        }
        const Ms = new _.ZM(),
          Rs = {
            [V.aWu]: (e, t) => e.set("toolbarItems", t.toolbarItems),
            [V.T3g]: (e, t) => e.set("annotationToolbarItems", t.annotationToolbarItemsCallback),
            [V.A8G]: (e, t) => e.set("annotationToolbarHeight", t.height)
          };
        function js() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ms,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Rs[t.type];
          return n ? n(e, t) : e;
        }
        const Bs = new _.ZM(),
          Ns = {
            [V.iJ2]: (e, t) => {
              let {
                formJSON: n
              } = t;
              (0, u.kG)("pspdfkit/form" == n.type, "Invalid type for form JSON."), (0, u.kG)(1 == n.v, "Invalid version for form JSON."), (0, u.kG)(n.fields instanceof Array, "Invalid type for `fields` in form JSON.");
              const r = (0, Ke.U_)(n.fields),
                o = (0, Ke.hT)(n.annotations);
              return e.withMutations(e => {
                e.set("formFields", r), o.forEach(t => {
                  const {
                    id: n
                  } = t;
                  e.setIn(["annotations", n], t), (0, u.kG)(e.pages.has(t.pageIndex), "Invalid `pageIndex` of widget annotation: " + t.pageIndex), e.updateIn(["pages", t.pageIndex, "annotationIds"], e => e.add(n));
                });
              });
            },
            [V.zGM]: (e, t) => e.withMutations(e => {
              t.formFields.forEach(t => {
                e.setIn(["formFields", t.name], t);
              });
            }),
            [V.Wyx]: (e, t) => e.withMutations(n => {
              t.formFields.forEach(t => {
                const r = e.formFields.valueSeq().find(e => e.id === t.id);
                (0, u.kG)(r, "Invalid form field ID: " + t.id);
                const o = r.name !== t.name;
                if (t instanceof _.XQ) {
                  const n = e.formFields.find(e => e.name === t.name),
                    r = null == n ? void 0 : n.annotationIds;
                  if (r && n.id !== t.id) {
                    let e = r,
                      o = n.options;
                    [...t.annotationIds].forEach((n, r) => {
                      e.includes(n) || (e = e.push(n), o = o.push(t.options.get(r)));
                    }), t = t.set("annotationIds", e).set("options", o);
                  }
                }
                if (o) {
                  t.annotationIds.forEach(e => {
                    n.annotations.get(e) && n.setIn(["annotations", e, "formFieldName"], t.name);
                  }), n.deleteIn(["formFields", r.name]);
                }
                n.setIn(["formFields", t.name], t), (0, Ke.r_)(r, e, n);
              });
            }),
            [V.fDl]: (e, t) => {
              const n = e.formFields.find(e => e.id === t.formField.id);
              return e.withMutations(r => {
                r.deleteIn(["formFields", null == n ? void 0 : n.name]), r.setIn(["formFields", t.formField.name], t.formField), (0, Ke.r_)(e.formFields.get(t.formField.name), e, r);
              });
            },
            [V.D_w]: (e, t) => e.withMutations(e => {
              t.formFieldNames.forEach(t => {
                e.formFields.get(t) && e.deleteIn(["formFields", t]);
              });
            }),
            [V.u_c]: (e, t) => e.withMutations(n => {
              t.formFieldsIds.forEach(t => {
                const r = (0, Ke.CL)(e, t);
                r && n.deleteIn(["formFields", r.name]);
              });
            }),
            [V.Ui_]: (e, t) => e.withMutations(n => {
              (0, Ke.AM)({
                state: e,
                mutableState: n,
                formFieldValues: t.formFieldValues,
                areFormFieldValuesNew: !0
              });
            }),
            [V.m3$]: (e, t) => e.withMutations(n => {
              (0, Ke.AM)({
                state: e,
                mutableState: n,
                formFieldValues: t.formFieldValues,
                areFormFieldValuesNew: !1
              });
            }),
            [V.VK7]: (e, t) => {
              let {
                formattedFormFieldValues: n
              } = t;
              return e.set("formattedFormFieldValues", e.formattedFormFieldValues.merge(n));
            },
            [V.yET]: (e, t) => {
              let {
                editingFormFieldValues: n
              } = t;
              return e.set("editingFormFieldValues", e.editingFormFieldValues.merge(n));
            },
            [V.u7V]: (e, t) => e.withMutations(n => {
              t.formFieldValuesIds.forEach(t => {
                const r = t.split("/")[1],
                  o = e.formFields.get(r);
                o && (o instanceof _.$o ? n.setIn(["formFields", r, "value"], "") : o instanceof _.XQ ? n.setIn(["formFields", r, "value"], null) : o instanceof _.Dz || o instanceof _.rF ? n.setIn(["formFields", r, "values"], (0, s.aV)()) : o instanceof _.R0 || o instanceof _.Yo || (0, u.kG)(!1, `DELETE_FORM_FIELD_VALUE not implemented for ${r}`));
              });
            }),
            [V.TYu]: (e, t) => {
              let {
                onWidgetCreationStartCallback: n
              } = t;
              return e.set("onWidgetAnnotationCreationStart", n);
            },
            [V.vgx]: (e, t) => {
              let {
                annotationId: n
              } = t;
              return e.set("formDesignerUnsavedWidgetAnnotation", n);
            },
            [V.zyH]: (e, t) => {
              let {
                annotation: n
              } = t;
              return e.set("buttonToImportIconFor", n);
            }
          };
        function Ls() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Bs,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Ns[t.type];
          return n ? n(e, t) : e;
        }
        var Vs = n(35727);
        const Ks = new _.ZM(),
          qs = {
            [V.ckI]: (e, t) => e.withMutations(e => {
              t.comments.forEach(t => {
                if ((0, Ce.k)(t.id && !e.comments.has(t.id), `Comment with ID ${t.id} already exists.`), t.pageIndex < 0 || t.pageIndex >= e.pages.size) (0, u.ZK)(`Tried to add a comment with ID ${t.id} with an out of bounds page index (${t.pageIndex}). This comment was skipped.`);else if (e.setIn(["comments", t.id], t), (0, Ce.k)(t.rootId && t.id), e.commentThreads.has(t.rootId)) {
                  const n = e.commentThreads.get(t.rootId);
                  (0, Ce.k)(n), e.setIn(["commentThreads", t.rootId], n.add(t.id).sortBy(t => {
                    const n = e.comments.get(t);
                    (0, Ce.k)(n);
                    const r = n.createdAt.getTime();
                    return [(0, Vs.kT)(n) ? 1 : 0, r];
                  }, Pe.b));
                } else e.setIn(["commentThreads", t.rootId], (0, s.hU)([t.id]));
              });
            }),
            [V.hxO]: (e, t) => {
              const n = t.rootId,
                r = e.annotations.get(n),
                o = new Date();
              let i = new _.sv({
                id: (0, Fa.C)(),
                rootId: n,
                creatorName: e.annotationCreatorName || null,
                createdAt: o,
                updatedAt: o,
                text: {
                  format: "plain",
                  value: ""
                }
              });
              if (e.onCommentCreationStart) {
                const t = e.onCommentCreationStart(i);
                (0, Ce.k)(t instanceof _.sv, "`onCommentCreationStart` should return an instance of `Comment`"), i = t;
              }
              (0, Ce.k)(e.backend), e.backend.isCollaborationPermissionsEnabled() && e.group !== e.backend.getDefaultGroup() && (i = i.set("group", e.group));
              return !(0, Kn.Ez)(i, e) && r && (0, to.mi)(r, e) ? e.withMutations(e => {
                e.setIn(["comments", i.id], i), e.commentThreads.has(n) ? e.updateIn(["commentThreads", n], e => e.add(i.id)) : e.setIn(["commentThreads", n], (0, s.hU)([i.id]));
              }) : e.set("interactionMode", null);
            },
            [V.FdD]: (e, t) => e.withMutations(e => {
              t.comments.forEach(t => {
                (0, Ce.k)(t.id && e.comments.has(t.id), `Comment with missing ID ${t.id} not found and thus cannot be updated.`), e.setIn(["comments", t.id], t);
              });
            }),
            [V.kg]: (e, t) => e.withMutations(e => {
              t.ids.forEach(t => {
                (0, Ce.k)(e.comments.has(t), `Comment with ID ${t} not found, so it cannot be deleted.`);
                const n = e.comments.get(t);
                (0, Ce.k)(null != n, `Attempted to delete non-existent comment with ID ${t}`), (0, Ce.k)(n.rootId);
                const r = e.commentThreads.get(n.rootId);
                if ((0, Ce.k)(null != r, `Comment with ID ${t} has no corresponding thread with matching root ID ${n.rootId}`), (0, Ce.k)(n.id && r.has(n.id), `Comment with ID ${n.id} is missing from its thread.`), 1 === r.size) e.removeIn(["commentThreads", n.rootId]);else {
                  const t = r.remove(n.id);
                  if (e.setIn(["commentThreads", n.rootId], t), 1 === t.size) {
                    const r = e.comments.get(t.first());
                    (0, Ce.k)(null != r), (0, Vs.kT)(r) && (e.removeIn(["commentThreads", n.rootId]), e.removeIn(["comments", r.id]));
                  }
                }
                e.removeIn(["comments", t]);
              });
            }),
            [V.NB4]: e => e.setIn(["viewportState", "commentMode"], (0, Vs.dq)(e)),
            [V.YHT]: (e, t) => e.set("mentionableUsers", t.users),
            [V.ZLr]: (e, t) => e.set("maxMentionSuggestions", t.maxSuggestions),
            [V.mfU]: (e, t) => {
              let {
                onCommentCreationStartCallback: n
              } = t;
              return e.set("onCommentCreationStart", n);
            }
          };
        function Hs() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ks,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = qs[t.type];
          return n ? n(e, t) : e;
        }
        const Us = new _.ZM(),
          Zs = {
            [V.Kpf]: (e, t) => e.set("documentEditorFooterItems", t.documentEditorFooterItems),
            [V.wPI]: (e, t) => e.set("documentEditorToolbarItems", t.documentEditorToolbarItems)
          };
        function $s() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Us,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Zs[t.type];
          return n ? n(e, t) : e;
        }
        function Gs(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ws(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Gs(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gs(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Ys = new Q.Z(),
          Xs = {
            [V.bVL]: (e, t) => e.withMutations(n => {
              n.set("redoActions", e.redoActions.push(t.nextRedoAction));
              const r = t.oldId;
              if (r) {
                n.update("redoActions", e => e.map(e => e.payload.id === t.oldId ? Ws(Ws({}, e), {}, {
                  payload: Ws(Ws({}, e.payload), {}, {
                    id: t.nextRedoAction.payload.id
                  })
                }) : e));
                const o = t.nextRedoAction.payload.pageIndex,
                  i = "number" == typeof o && e.invalidAPStreams.has(o) ? e.invalidAPStreams.get(o) : null;
                i && i.has(r) && n.setIn(["invalidAPStreams", o], i.add(t.nextRedoAction.payload.id).delete(r));
              }
              n.set("undoActions", e.undoActions.pop());
            }),
            [V.iwn]: (e, t) => e.withMutations(n => {
              n.set("undoActions", e.undoActions.push(t.nextUndoAction));
              const r = t.oldId;
              if (r) {
                n.update("undoActions", e => e.map(e => e.payload.id === t.oldId ? Ws(Ws({}, e), {}, {
                  payload: Ws(Ws({}, e.payload), {}, {
                    id: t.nextUndoAction.payload.id
                  })
                }) : e));
                const o = t.nextUndoAction.payload.pageIndex,
                  i = "number" == typeof o && e.invalidAPStreams.has(o) ? e.invalidAPStreams.get(o) : null;
                i && i.has(r) && n.setIn(["invalidAPStreams", o], i.add(t.nextUndoAction.payload.id).delete(r));
              }
              n.set("redoActions", e.redoActions.pop());
            }),
            [V.faS]: (e, t) => e.set("historyChangeContext", t.historyChangeContext),
            [V.tC1]: (e, t) => e.set("historyIdsMap", e.historyIdsMap.set(t.newId, t.oldId)),
            [V.x64]: (e, t) => {
              let {
                annotationId: n
              } = t;
              const r = e.historyIdsMap.findKey(e => e === n);
              return e.withMutations(t => {
                t.set("undoActions", e.undoActions.filter(e => e.payload.id !== r)), t.set("redoActions", e.redoActions.filter(e => e.payload.id !== r));
              });
            },
            [V._Qf]: e => e.withMutations(t => {
              t.set("undoActions", e.undoActions.clear()), t.set("redoActions", e.redoActions.clear()), t.set("historyIdsMap", e.historyIdsMap.clear());
            }),
            [V._33]: e => e.set("isHistoryEnabled", !0),
            [V.wG7]: e => e.set("isHistoryEnabled", !1)
          };
        function Qs() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Ys,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = Xs[t.type];
          return n ? n(e, t) : e;
        }
        var Js = n(96988);
        const el = e => new Js.Sg(e),
          tl = e => new Js.UL({
            offset: el(e.offset),
            size: el(e.size)
          }),
          nl = e => new Js.W4(e),
          rl = e => {
            let t = s.l4.of();
            for (const n of e) t = t.add(nl(n));
            return t;
          },
          ol = e => new Js.I5({
            family: e.family,
            variants: rl(e.variants)
          }),
          il = e => new Js.yO({
            family: e.family,
            variant: nl(e.variant)
          }),
          al = e => new Js.IA({
            faceRef: il(e.faceRef),
            size: e.size
          }),
          sl = e => new Js.mZ(e),
          ll = e => new Js.vz({
            fontRef: al(e.fontRef),
            color: e.color,
            effects: sl(e.effects)
          }),
          ul = e => new Js.JR(e),
          cl = e => new Js.yJ({
            family: e.family,
            faceMismatch: e.faceMismatch ? ul(e.faceMismatch) : null,
            bold: e.bold,
            italic: e.italic,
            xScale: e.xScale,
            skew: e.skew,
            color: e.color,
            size: e.size
          }),
          dl = e => new Js.a2(e),
          pl = e => new Js.DN(e),
          hl = e => new Js.FQ({
            cluster: e.cluster,
            offset: el(e.offset),
            advance: el(e.advance),
            text: e.text,
            control: e.control,
            lastOfSegment: e.lastOfSegment,
            beginOfWord: e.beginOfWord,
            endOfWord: e.endOfWord
          }),
          fl = e => new Js.tW({
            offset: el(e.offset),
            lineSpacing: dl(e.lineSpacing),
            elements: s.aV.of(...e.elements.map(hl))
          });
        var ml = n(35998);
        const gl = new Q.Z(),
          vl = (e, t) => {
            let n = !1;
            const r = tl(t.contentRect);
            (0, s.is)(r, e.contentRect) || (e = e.set("contentRect", r)), (0, s.is)(t.version, e.version) || (e = e.set("version", t.version), n = !0);
            const o = (i = t.cursor, new Js.CF({
              offset: el(i.offset),
              lineSpacing: dl(i.lineSpacing)
            }));
            var i;
            (0, s.is)(o, e.cursor) || (e = e.set("cursor", o), n = !0);
            const a = t.selection ? (e => new Js.Y1(e))(t.selection) : null;
            (0, s.is)(a, e.selection) || (e = e.set("selection", a), n = !0);
            const l = (e => new Js.Ts({
              lines: s.aV.of(...e.lines.map(fl))
            }))(t.layoutView);
            (0, s.is)(l, e.layoutView) || (e = e.set("layoutView", l));
            const u = (e => new Js.tk({
              selectionStyleInfo: e.selectionStyleInfo ? cl(e.selectionStyleInfo) : null,
              modificationsCharacterStyle: e.modificationsCharacterStyle ? ll(e.modificationsCharacterStyle) : null,
              modificationsCharacterStyleFaceMismatch: e.modificationsCharacterStyleFaceMismatch ? ul(e.modificationsCharacterStyleFaceMismatch) : null
            }))(t.detectedStyle);
            if ((0, s.is)(u, e.detectedStyle) || (e = e.set("detectedStyle", u)), u.modificationsCharacterStyle) {
              let t = u.modificationsCharacterStyle;
              t = t.setIn(["effects"], new Js.mZ({})), n && !(0, s.is)(t, e.modificationsCharacterStyle) && (e = e.set("modificationsCharacterStyle", t));
            }
            return e;
          },
          yl = {
            [V.MGL]: (e, t) => e.withMutations(e => {
              const n = e.contentEditorSession.sessionId + 1;
              e.set("contentEditorSession", new Js.aN({
                sessionId: n,
                active: !0,
                contentEditor: t.contentEditor
              })).set("interactionMode", B.A.CONTENT_EDITOR);
            }),
            [V.Qm9]: e => e.withMutations(e => {
              e.setIn(["contentEditorSession", "active"], !1).setIn(["contentEditorSession", "contentEditor"], null).set("interactionMode", null);
            }),
            [V.l$y]: (e, t) => e.withMutations(e => {
              (0, Ce.k)(!e.contentEditorSession.pageStates.has(t.pageIndex)), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], new Js.nv({
                loading: !0
              }));
            }),
            [V.kD6]: (e, t) => e.withMutations(e => {
              var n;
              (0, Ce.k)(null === (n = e.contentEditorSession.pageStates.get(t.pageIndex)) || void 0 === n ? void 0 : n.loading);
              let r = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(r);
              const o = t.initialTextBlocks.map(e => {
                  const t = e.textBlock,
                    n = el(t.anchor),
                    r = pl(t.globalEffects),
                    o = new Js.Ar({
                      maxWidth: t.maxWidth,
                      alignment: t.alignment,
                      lineSpacingFactor: t.lineSpacingFactor
                    }),
                    i = new Js.Q7({
                      id: e.id,
                      initialAnchor: n,
                      initialGlobalEffects: r,
                      initialLayout: o,
                      anchor: n,
                      globalEffects: r,
                      layout: o,
                      modificationsCharacterStyle: ll(t.modificationsCharacterStyle)
                    });
                  return vl(i, e.updateInfo);
                }),
                i = s.aV.of(...o);
              r = r.set("textBlocks", i), r = r.set("initialTextBlocks", i), r = r.set("loading", !1), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], r);
            }),
            [V.joZ]: (e, t) => e.withMutations(e => {
              e.setIn(["contentEditorSession", "textBlockInteractionState"], new Js._h({
                pageIndex: t.pageIndex,
                textBlockId: t.textBlockId,
                state: Js.FP.Active
              }));
            }),
            [V.fQw]: e => e.withMutations(e => {
              const t = e.contentEditorSession.textBlockInteractionState;
              if (t.state === Js.FP.Active) {
                let n = e.contentEditorSession.pageStates.get(t.pageIndex);
                (0, Ce.k)(n), n = n.set("textBlocks", n.textBlocks.filter(e => !(e.justCreated && 0 === e.contentRect.size.x)).map(e => e.id === t.textBlockId && e.justCreated ? e = e.set("justCreated", !1).set("layout", e.layout.set("maxWidth", Math.max(e.contentRect.size.x, 10))) : e)), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n);
              }
              e.setIn(["contentEditorSession", "textBlockInteractionState"], e.contentEditorSession.textBlockInteractionState.state === Js.FP.Active ? e.contentEditorSession.textBlockInteractionState.set("state", Js.FP.Selected) : new Js._h());
            }),
            [V.VOt]: (e, t) => e.withMutations(e => {
              let n = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(n), n = ((e, t, n) => {
                const r = e.textBlocks.map(e => e.id != t ? e : vl(e, n));
                return e.set("textBlocks", r);
              })(n, t.textBlockId, t.updateInfo), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n);
            }),
            [V.U7k]: e => e.withMutations(e => {
              e.setIn(["contentEditorSession", "availableFaces", "loading"], !0);
            }),
            [V.ZgW]: (e, t) => e.withMutations(e => {
              const n = (r = t.faceList, s.aV.of(...r.map(ol)));
              var r;
              e.setIn(["contentEditorSession", "availableFaces"], new Js.t9({
                faceList: n,
                loading: !1
              }));
            }),
            [V.Y4]: (e, t) => e.withMutations(e => {
              e.setIn(["contentEditorSession", "saving"], t.isSaving);
            }),
            [V.HYy]: e => e.withMutations(e => {
              e.setIn(["contentEditorSession", "dirty"], !0);
            }),
            [V.bOH]: (e, t) => e.set("showExitContentEditorDialog", t.isVisible),
            [V.Han]: (e, t) => e.set("contentEditorSession", e.contentEditorSession.set("fontMismatchTooltip", new Js.xb({
              fontFace: t.fontFace,
              rect: t.tooltipRect
            }))),
            [V.WmI]: e => e.set("contentEditorSession", e.contentEditorSession.set("fontMismatchTooltip", null)),
            [V.nI6]: (e, t) => e.contentEditorSession.fontMismatchTooltip ? e.setIn(["contentEditorSession", "fontMismatchTooltip", "dismissAbortController"], t.abortController) : e,
            [V.Ebp]: (e, t) => e.withMutations(e => {
              let n = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(n), n = n.set("textBlocks", n.textBlocks.map(e => {
                if (e.id != t.textBlockId) return e;
                let n = e.modificationsCharacterStyle;
                return t.faceRef && !(0, s.is)(t.faceRef, n.fontRef.faceRef) && (n = n.setIn(["fontRef", "faceRef"], t.faceRef)), t.size && !(0, s.is)(t.size, n.fontRef.size) && (n = n.setIn(["fontRef", "size"], t.size)), t.color && !(0, s.is)(t.color, n.color) && (n = n.set("color", t.color)), e = e.set("modificationsCharacterStyle", n);
              })), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n);
            }),
            [V.ciU]: (e, t) => e.withMutations(e => {
              e.contentEditorSession.dirty || e.setIn(["contentEditorSession", "dirty"], !0);
              let n = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(n), n = n.set("textBlocks", n.textBlocks.map(e => {
                if (e.id != t.textBlockId) return e;
                const {
                    fixpointValue: n,
                    newWidth: r
                  } = t,
                  {
                    layout: o,
                    globalEffects: i,
                    anchor: a
                  } = e;
                (0, Ce.k)(o.maxWidth);
                const s = (0, ml.uB)(o.alignment, i, n, r - o.maxWidth);
                return e = (e = e.set("anchor", new Js.Sg({
                  x: a.x + s.x,
                  y: a.y + s.y
                }))).setIn(["layout", "maxWidth"], r);
              })), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n);
            }),
            [V.fLm]: (e, t) => e.withMutations(e => {
              let n = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(n), e.contentEditorSession.dirty || e.setIn(["contentEditorSession", "dirty"], !0), t.isKeyboardMove || e.contentEditorSession.textBlockInteractionState.state === Js.FP.Moving || e.setIn(["contentEditorSession", "textBlockInteractionState"], new Js._h({
                state: Js.FP.Moving,
                pageIndex: t.pageIndex,
                textBlockId: t.textBlockId
              })), n = n.set("textBlocks", n.textBlocks.map(e => e.id != t.textBlockId ? e : e = e.set("anchor", new Js.Sg({
                x: t.anchor.x,
                y: t.anchor.y
              })))), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n);
            }),
            [V.xhM]: (e, t) => e.withMutations(e => {
              e.setIn(["contentEditorSession", "textBlockInteractionState"], new Js._h({
                pageIndex: t.pageIndex,
                textBlockId: t.textBlockId,
                state: Js.FP.Selected
              }));
            }),
            [V.snK]: (e, t) => e.withMutations(e => {
              e.setIn(["contentEditorSession", "textBlockInteractionState"], new Js._h());
              let n = e.contentEditorSession.pageStates.get(t.pageIndex);
              (0, Ce.k)(n), n = n.set("textBlocks", n.textBlocks.filter(e => e.id !== t.textBlockId)), e.setIn(["contentEditorSession", "pageStates", t.pageIndex], n), e.setIn(["contentEditorSession", "mode"], Js.wR.Edit);
            }),
            [V.teI]: (e, t) => e.withMutations(e => {
              e.setIn(["contentEditorSession", "mode"], t.mode);
            }),
            [V.uo5]: (e, t) => e.withMutations(e => {
              var n;
              let r = e.contentEditorSession.pageStates.get(t.pageIndex);
              const o = null === (n = e.pages.get(t.pageIndex)) || void 0 === n || null === (n = n.pageSize) || void 0 === n ? void 0 : n.width;
              (0, Ce.k)(r), (0, Ce.k)(o);
              const {
                  pageIndex: i,
                  initialTextBlock: a
                } = t,
                s = a.textBlock,
                l = pl(s.globalEffects),
                u = new Js.Ar({
                  maxWidth: o - t.anchor.x,
                  alignment: s.alignment,
                  lineSpacingFactor: s.lineSpacingFactor
                });
              let c = new Js.Q7({
                id: a.id,
                initialAnchor: t.anchor,
                initialGlobalEffects: l,
                initialLayout: u,
                anchor: t.anchor,
                globalEffects: l,
                layout: u,
                justCreated: !0,
                modificationsCharacterStyle: ll(s.modificationsCharacterStyle)
              });
              return c = vl(c, a.updateInfo), r = r.set("textBlocks", r.textBlocks.push(c)), e.setIn(["contentEditorSession", "pageStates", i], r).setIn(["contentEditorSession", "mode"], Js.wR.Edit).setIn(["contentEditorSession", "textBlockInteractionState"], new Js._h({
                pageIndex: i,
                textBlockId: a.id,
                state: Js.FP.Active
              }));
            }),
            [V.iR6]: (e, t) => e.set("promptContentEditorDocumentDownload", t.promptContentEditorDocumentDownload),
            [V.guy]: (e, t) => e.set("promptContentEditorCannotSaveChanges", t.promptContentEditorCannotSaveChanges)
          };
        function bl() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : gl,
            t = arguments.length > 1 ? arguments[1] : void 0;
          const n = yl[t.type];
          return n ? n(e, t) : e;
        }
        function wl(e, t) {
          return [Z, $.Z, La, Ha, $a, Ya, Ja, ss, Ds, Es, ks, Ts, Fs, js, Ls, Hs, $s, Qs, bl].reduce((e, n) => n(e, t), e);
        }
        function xl() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return (0, A.xC)({
            reducer: wl,
            preloadedState: new Q.Z(e),
            middleware: e => e({
              serializableCheck: !1,
              immutableCheck: !1
            })
          });
        }
        var Dl = n(25384),
          Cl = n(11765),
          Sl = n(95431),
          El = n(44156);
        async function _l(e) {
          let t,
            {
              backend: n,
              dispatch: r,
              getState: o,
              maxPasswordRetries: i,
              password: a,
              formFieldValuesJSON: l,
              customFonts: c,
              stylesheetPromise: d
            } = e;
          await d;
          try {
            let e = !1;
            const {
                features: d,
                signatureFeatureAvailability: p,
                hasPassword: h,
                minSearchQueryLength: f,
                allowedTileScales: m,
                creatorName: g,
                defaultGroup: v,
                evaluation: y
              } = await async function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.POSITIVE_INFINITY,
                  n = arguments.length > 2 ? arguments[2] : void 0,
                  r = arguments.length > 3 ? arguments[3] : void 0,
                  o = null,
                  i = 0;
                for (; !o;) {
                  try {
                    o = await n(e);
                  } catch (n) {
                    const o = i < t;
                    if ("INVALID_PASSWORD" !== n.message || !o) throw n;
                    e = await r();
                  }
                  i++;
                }
                if (!o) throw new u.p2("Exceeded the maximum amount of password retries.");
                return o;
              }(a, i, t => n.load({
                password: t,
                progressCallback: (t, n) => {
                  e || r((0, Dl.qZ)(t, n));
                },
                isPDFJavaScriptEnabled: it.Options.PDF_JAVASCRIPT
              }), () => (e = !0, new Promise(e => r((0, Dl.uT)(e))))),
              {
                frameWindow: b
              } = o();
            let w = (0, s.l4)();
            if (c && b) {
              const e = await n.getAvailableFontFaces(c);
              for (const t of c) {
                const n = e.find(e => e.name === t.name),
                  r = (null == n ? void 0 : n.readableName) || t.name;
                b.document.fonts.add(new FontFace((0, pn.hm)(r), await t.data.arrayBuffer())), w = w.add(r);
              }
              w.size > 0 && r((0, Kt.p2)(w));
            }
            await (0, Sl.jX)(r, o, {
              attemptedUnlockViaModal: e,
              features: d,
              signatureFeatureAvailability: p,
              hasPassword: h,
              minSearchQueryLength: f,
              allowedTileScales: m,
              evaluation: y
            });
            const {
              annotations: x,
              isAPStreamRendered: D,
              formFields: C
            } = o();
            n.isUsingInstantProvider() && r((0, Kt.Ie)()), n.isCollaborationPermissionsEnabled() && r((0, Kt.YK)(v));
            const S = await n.runPDFFormattingScriptsFromWidgets(x, C, D);
            if (S.length) {
              const {
                formFieldManager: e
              } = o();
              let n, i;
              null !== e && (await e.loadFormFields()), t = new Promise((e, t) => {
                n = e, i = t;
              }), r((0, er.bt)({
                changes: S,
                resolve: n,
                reject: i
              }));
            }
            if ("STANDALONE" === n.type && it.Options.PDF_JAVASCRIPT && l && r((0, er.ul)((0, s.aV)(l.map(Cl.u9)))), "STANDALONE" === n.type) {
              const e = await n.getOCGs(),
                t = await n.getOCGVisibilityState();
              r((0, El.h1)(e)), r((0, El.kQ)(t.visibleLayerIds));
            }
            r((0, Dl.Bm)()), g && r((0, Kt.X8)(g, !0));
          } catch (e) {
            (0, u.vU)("An error occurred while initializing PSPDFKit for Web.\n\n    Please contact our customer support, if you're having troubles setting up PSPDFKit for Web or the PSPDFKit Document Engine: https://pspdfkit.com/guides/web/current/pspdfkit-for-web/troubleshooting/");
            const t = e instanceof u.p2 ? e : new u.p2(e);
            throw -1 !== t.message.indexOf("File not in PDF format or corrupted") ? r((0, Dl.sr)(t.message)) : r((0, Dl.sr)()), t;
          }
          return t;
        }
        var Pl = n(68944),
          kl = n(21753);
        function Al(e) {
          try {
            e.querySelector(":focus-visible");
            const t = e.documentElement || e;
            return void (t && t.setAttribute("data-focusvisible-supported", "true"));
          } catch (e) {}
          const t = "data-focusvisible-polyfill";
          let n = !0,
            r = !1,
            o = null;
          const i = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0
          };
          function a(t) {
            return !!(t && t !== e && "HTML" !== t.nodeName && "BODY" !== t.nodeName && "classList" in t && "contains" in t.classList);
          }
          function s(e) {
            e.hasAttribute(t) || e.setAttribute(t, !0);
          }
          function l(e) {
            e.removeAttribute(t);
          }
          function u() {
            !0 === n && function () {
              const t = e.querySelectorAll("[data-focusvisible-polyfill]");
              for (let e = 0; e < t.length; e += 1) l(t[e]);
            }(), n = !1;
          }
          function c() {
            e.addEventListener("mousemove", d), e.addEventListener("mousedown", d), e.addEventListener("mouseup", d), e.addEventListener("pointermove", d), e.addEventListener("pointerdown", d), e.addEventListener("pointerup", d), e.addEventListener("touchmove", d), e.addEventListener("touchstart", d), e.addEventListener("touchend", d);
          }
          function d(t) {
            var r;
            "HTML" !== (null === (r = t.target) || void 0 === r ? void 0 : r.nodeName) && (n = !1, e.removeEventListener("mousemove", d), e.removeEventListener("mousedown", d), e.removeEventListener("mouseup", d), e.removeEventListener("pointermove", d), e.removeEventListener("pointerdown", d), e.removeEventListener("pointerup", d), e.removeEventListener("touchmove", d), e.removeEventListener("touchstart", d), e.removeEventListener("touchend", d));
          }
          e.addEventListener("keydown", function (t) {
            "Tab" !== t.key && (t.metaKey || t.altKey || t.ctrlKey || t.shiftKey) || (a(e.activeElement) && s(e.activeElement), n = !0);
          }, !0), e.addEventListener("mousedown", u, !0), e.addEventListener("pointerdown", u, !0), e.addEventListener("touchstart", u, !0), e.addEventListener("focus", function (e) {
            const t = e.target;
            a(t) && (n || function (e) {
              const t = e.type,
                n = e.tagName,
                r = e.readOnly;
              return !("INPUT" !== n || !i[t] || r) || "TEXTAREA" === n && !r || !!e.isContentEditable;
            }(t)) && s(t);
          }, !0), e.addEventListener("blur", function (e) {
            const n = e.target;
            a(n) && null != n && n.hasAttribute(t) && (r = !0, window.clearTimeout(o), o = window.setTimeout(function () {
              r = !1, window.clearTimeout(o);
            }, 100), l(n));
          }, !0), e.addEventListener("visibilitychange", function () {
            "hidden" === function (e) {
              return e instanceof ShadowRoot ? e.host.ownerDocument : e;
            }(e).visibilityState && (r && (n = !0), c());
          }, !0), c();
        }
        var zl = n(87849),
          Tl = n(15650),
          Ol = n(70025),
          Il = n(26637),
          Fl = n(18287),
          Ml = n(5619);
        const Rl = [10, 20, 50, 100, 200, 500];
        class jl {
          constructor(e, t) {
            (0, o.Z)(this, "_activeSearches", []), this.getState = e, this.dispatch = t, this.term = "", this._debouncedSearchRequest = (0, Ml.Z)(this._searchRequest, Ne.XU);
          }
          cancelSearch() {
            this._cancelSearchRequests(), this.searchTerm(""), this.dispatch((0, Fl.ct)());
          }
          searchTerm(e) {
            if ("pspdfkit:info" === e.toLowerCase() || "pspdf:info" === e.toLowerCase()) {
              const e = "PSPDFKit for Web 2024.5.0 (https://pspdfkit.com/web)";
              return (0, u.wp)(e), void this._cancelSearchRequests();
            }
            if ("pspdfkit:debug" === e.toLowerCase() || "pspdf:debug" === e.toLowerCase()) return this.dispatch((0, Kt.R)()), void this._cancelSearchRequests();
            const t = this.getState();
            if (e.length < t.searchState.minSearchQueryLength) return this.term = "", void this._cancelSearchRequests();
            this.dispatch((0, Fl.M0)(!0)), this.term = e, this._debouncedSearchRequest();
          }
          async _searchRequest() {
            if ("" === this.term) return;
            this._cancelSearchRequests();
            const e = this.getState();
            (0, u.kG)(e.backend);
            let t = e.totalPages,
              n = 0;
            t = "STANDALONE" === e.backend.type ? 5 : Rl[n];
            const r = e.viewportState.currentPageIndex;
            this._activeSearches.push(!0);
            const o = this._activeSearches.length - 1;
            let i = (0, s.aV)();
            for (const a of [0, 1]) {
              let s, l;
              for (0 === a ? (s = r, l = e.totalPages - s) : (s = 0, l = r); l > 0;) {
                "SERVER" === e.backend.type && (t = Rl[n], n += n >= Rl.length - 1 ? 0 : 1);
                let r = t;
                l < 1.5 * t && (r = l);
                const a = await e.backend.search(this.term, s, r, !1);
                if (i = i.concat(a), !this._activeSearches[o]) return;
                this.dispatch((0, Fl.Sc)(i)), l -= r, s += r;
              }
            }
            this.dispatch((0, Fl.M0)(!1));
          }
          _cancelSearchRequests(e) {
            for (const t of this._activeSearches.keys()) null != e && t === e || (this._activeSearches[t] = !1);
          }
        }
        var Bl = n(53416),
          Nl = n(6197),
          Ll = n(50898),
          Vl = n(65652),
          Kl = n(713),
          ql = n(38705),
          Hl = n(38478),
          Ul = n(23951),
          Zl = n(2282),
          $l = n(26353),
          Gl = n(84013),
          Wl = n(98502),
          Yl = n(92879);
        const Xl = (0, d.createContext)(() => {
          throw new Error();
        });
        var Ql = n(40084),
          Jl = n(27122),
          eu = n(65369),
          tu = n(97586),
          nu = n(13264),
          ru = n(35062),
          ou = n(59003),
          iu = n.n(ou);
        const au = function (e) {
            var t, r;
            const {
                formatMessage: o
              } = (0, xe.YB)(),
              i = d.useCallback(e => e.stopPropagation(), []),
              a = h()("PSPDFKit-Sidebar-Annotations-Item", e.layoutClassName, iu().layout, {
                [iu().selected]: e.isSelectedItem,
                [iu().layoutNavigationDisabled]: e.navigationDisabled,
                "PSPDFKit-Sidebar-Annotations-Item-Selected": e.isSelectedItem
              });
            return d.createElement("div", {
              ref: e.itemRef
            }, d.createElement(Je.Z, {
              onPointerUpCapture: i
            }, d.createElement(d.Fragment, null, d.createElement("div", (0, ce.Z)({
              className: a,
              onClick: e.onPress
            }, e.itemWrapperProps), e.icon, d.createElement("div", {
              className: iu().layoutContent
            }, e.children, (null === (t = e.showFooter) || void 0 === t || t) && (e.author || e.formattedDate) && d.createElement("footer", {
              className: h()(iu().footer, "PSPDFKit-Sidebar-Annotations-Footer")
            }, d.createElement("p", null, e.author && d.createElement("span", null, e.author, e.formattedDate ? ", " : ""), e.formattedDate && d.createElement("time", {
              dateTime: null === (r = e.date) || void 0 === r ? void 0 : r.toISOString()
            }, e.formattedDate)), e.additionalFooter)), e.isDeletable && d.createElement("button", {
              className: h()(iu().delete, "PSPDFKit-Sidebar-Annotations-Delete"),
              onClick: e.onDelete,
              "aria-label": o(ke.Z.delete)
            }, d.createElement(je.Z, {
              src: n(63949),
              role: "presentation"
            }))), d.createElement("div", {
              className: iu().flagsContainer
            }, e.isReadOnly && d.createElement("div", {
              className: iu().flagWrapper
            }, d.createElement("div", {
              className: h()(iu().lock, "PSPDFKit-Sidebar-Annotations-ReadOnly")
            }, d.createElement(je.Z, {
              src: n(50308),
              role: "presentation"
            })), d.createElement("div", {
              className: iu().label,
              "aria-label": o(ke.Z.readOnlyAnnotationFlag)
            }, o(ke.Z.readOnlyAnnotationFlag))), e.isLocked && d.createElement("div", {
              className: iu().flagWrapper
            }, d.createElement("span", {
              className: h()(iu().lock, "PSPDFKit-Sidebar-Annotations-Locked")
            }, d.createElement(je.Z, {
              src: n(50308),
              role: "presentation"
            })), d.createElement("span", {
              className: iu().label,
              "aria-label": o(ke.Z.locked)
            }, o(ke.Z.locked))), e.hasLockedContents && d.createElement("div", {
              className: iu().flagWrapper
            }, d.createElement("span", {
              className: h()(iu().lock, "PSPDFKit-Sidebar-Annotations-LockedContents")
            }, d.createElement(je.Z, {
              src: n(50308),
              role: "presentation"
            })), d.createElement("span", {
              className: iu().label,
              "aria-label": o(ke.Z.lockedContents)
            }, o(ke.Z.lockedContents)))))));
          },
          su = {
            highlighter: "highlighter",
            arrow: "arrow",
            callout: "textAnnotation",
            "cloudy-rectangle": "cloudyRectangleAnnotation",
            "dashed-rectangle": "dashedRectangleAnnotation",
            "cloudy-ellipse": "cloudyEllipseAnnotation",
            "dashed-ellipse": "dashedEllipseAnnotation",
            "cloudy-polygon": "cloudyPolygonAnnotation",
            "dashed-polygon": "dashedPolygonAnnotation",
            "ellipse-area": "ellipseAreaMeasurement",
            "rectangle-area": "rectangularAreaMeasurement",
            "polygon-area": "polygonAreaMeasurement",
            distance: "distanceMeasurement",
            perimeter: "perimeterMeasurement"
          },
          lu = e => {
            const {
                formatMessage: t
              } = e.intl,
              n = su[e.type] || `${e.type}Annotation`;
            return d.createElement(d.Fragment, null, d.createElement("button", {
              autoFocus: e.autoFocus
            }, t(ke.Z[n])), ",", " ", t(ke.Z.linesCount, {
              arg0: e.annotation.lines.size
            }));
          },
          uu = e => {
            const t = e.annotation.text.value || "";
            let n = (0, F.aF)("xhtml" === e.annotation.text.format ? (0, gn.KY)(t) : t);
            const r = su[e.type] || "textAnnotation";
            return 0 === n.length && (n = e.intl.formatMessage(ke.Z[r])), d.createElement("button", {
              autoFocus: e.autoFocus
            }, n);
          },
          cu = e => d.createElement("button", {
            autoFocus: e.autoFocus
          }, e.intl.formatMessage(ke.Z[`${e.type}Annotation`])),
          du = e => {
            const t = su[e.type] || `${e.type}Annotation`;
            return d.createElement("button", {
              autoFocus: e.autoFocus
            }, e.intl.formatMessage(ke.Z[t]));
          },
          pu = e => d.createElement("button", {
            autoFocus: e.autoFocus
          }, e.annotation.formFieldName),
          hu = {
            text: uu,
            callout: uu,
            ink: lu,
            highlighter: lu,
            note: e => {
              let t = (0, F.aF)(e.annotation.text.value || "");
              return 0 === t.length && (t = e.intl.formatMessage(ke.Z.noteAnnotation)), d.createElement("button", {
                autoFocus: e.autoFocus
              }, t);
            },
            highlight: cu,
            underline: cu,
            strikeOut: cu,
            squiggle: cu,
            link: e => {
              var t;
              return d.createElement("button", {
                autoFocus: e.autoFocus
              }, (null === (t = e.annotation.action) || void 0 === t ? void 0 : t.uri) || e.intl.formatMessage(ke.Z.linkAnnotation));
            },
            rectangle: du,
            "cloudy-rectangle": du,
            "dashed-rectangle": du,
            ellipse: du,
            "cloudy-ellipse": du,
            "dashed-ellipse": du,
            polygon: du,
            "cloudy-polygon": du,
            "dashed-polygon": du,
            polyline: du,
            line: du,
            arrow: du,
            image: e => {
              const {
                  formatMessage: t
                } = e.intl,
                {
                  fileName: n
                } = e.annotation,
                r = (0, F.aF)(e.annotation.description || "");
              return d.createElement(d.Fragment, null, d.createElement("button", {
                autoFocus: e.autoFocus
              }, t(ke.Z[`${e.type}Annotation`])), n && !r && d.createElement("div", {
                title: t(ke.Z.filePath) + `: ${n}`
              }, n), r && d.createElement("div", null, r));
            },
            stamp: e => {
              const {
                  formatMessage: t
                } = e.intl,
                {
                  fileName: n
                } = e.annotation,
                r = (0, F.aF)((0, Aa.vW)({
                  annotation: e.annotation,
                  intl: e.intl
                }) || "");
              return d.createElement(d.Fragment, null, d.createElement("button", {
                autoFocus: e.autoFocus
              }, t(ke.Z[`${e.type}Annotation`])), n && !r && d.createElement("div", {
                title: `${t(ke.Z.stampText)}: ${t(ke.Z[e.annotation.stampType])}`
              }, `${t(ke.Z.stampText)}: ${t(ke.Z[e.annotation.stampType])}`), r && d.createElement("div", null, r));
            },
            "form-text": pu,
            "form-checkbox": pu,
            "form-button": pu,
            "form-signature": pu,
            redaction: e => d.createElement("button", {
              autoFocus: e.autoFocus
            }, e.intl.formatMessage(ke.Z[`${e.type}Annotation`])),
            media: e => {
              const {
                  formatMessage: t
                } = e.intl,
                {
                  fileName: n
                } = e.annotation,
                r = (0, F.aF)(e.annotation.description || "");
              return d.createElement(d.Fragment, null, d.createElement("button", {
                autoFocus: e.autoFocus
              }, t(ke.Z[`${e.type}Annotation`])), n && !r && d.createElement("div", {
                title: t(ke.Z.filePath) + `: ${n}`
              }, n), r && d.createElement("div", null, r));
            },
            perimeter: du,
            distance: du,
            "ellipse-area": du,
            "rectangle-area": du,
            "polygon-area": du
          };
        class fu extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_itemRef", e => {
              var t, n;
              e && (this._el = e, null === (t = (n = this.props).onRenderItemCallback) || void 0 === t || t.call(n, e, this.props.annotation));
            }), (0, o.Z)(this, "onPress", () => {
              const {
                annotation: e,
                dispatch: t,
                onPress: n
              } = this.props;
              if (!this.props.navigationDisabled) {
                if (t((0, Ql.kN)(e.pageIndex, e.boundingBox)), this.props.isAnnotationReadOnly(e) || !(this.props.annotation instanceof de.x_) && (this.props.annotation.readOnly || this.props.annotation.lockedContents || this.props.annotation.locked)) {
                  var r;
                  if (this.props.focusedAnnotationIds && this.props.focusedAnnotationIds.size > 0) t((0, _e.Oc)(null === (r = this.props.focusedAnnotationIds) || void 0 === r ? void 0 : r.first()));
                  return setTimeout(() => {
                    t((0, _e.Q2)(e.id));
                  }, 100);
                }
                e instanceof de.x_ ? t((0, _e.fz)()) : De.Ni && e instanceof de.Qi ? t((0, _e.VR)(e.id)) : t((0, _e.Df)((0, s.l4)([e.id]), null)), n && n();
              }
            }), (0, o.Z)(this, "onDelete", () => {
              const {
                annotation: e,
                dispatch: t,
                navigationDisabled: n
              } = this.props;
              n || t((0, Ql.kN)(e.pageIndex, e.boundingBox)), t((0, yt.d8)((0, s.l4)([e.id])));
            }), (0, o.Z)(this, "preventDeselect", e => e.stopPropagation());
          }
          componentDidUpdate(e) {
            var t, n;
            this._el && e.onRenderItemCallback !== this.props.onRenderItemCallback && (null === (t = (n = this.props).onRenderItemCallback) || void 0 === t || t.call(n, this._el, this.props.annotation));
          }
          render() {
            const {
                annotation: e,
                intl: t,
                isSelectedAnnotation: n,
                annotationType: r,
                isAnnotationReadOnly: o,
                autoFocus: i,
                canDeleteAnnotationCP: a,
                dateTimeStringCallback: s
              } = this.props,
              {
                formatDate: l
              } = t,
              u = e.creatorName;
            let c = null;
            e.updatedAt.getTime() && (s && (c = s({
              dateTime: e.updatedAt,
              element: ru.Y.ANNOTATIONS_SIDEBAR,
              object: e
            })), null == c && (c = l(e.updatedAt)));
            const p = hu[r],
              f = h()("PSPDFKit-Sidebar-Annotations-Annotation", `PSPDFKit-Sidebar-Annotations-Annotation-${(0, gn.in)(r)}`, {
                "PSPDFKit-Sidebar-Annotations-Annotation-Selected": n
              }),
              m = !(e instanceof de.x_) && !(e instanceof de.Hu) && !e.locked && !o(e) && !De.Ni && a(e),
              g = (0, Ae.Z)({
                type: r.toLowerCase(),
                className: h()(iu().icon, "PSPDFKit-Sidebar-Annotations-Icon")
              });
            return d.createElement(au, {
              itemRef: this._itemRef,
              layoutClassName: f,
              isSelectedItem: n,
              navigationDisabled: this.props.navigationDisabled,
              onPress: this.onPress,
              onDelete: this.onDelete,
              isDeletable: m,
              itemWrapperProps: {
                "data-annotation-id": e.id
              },
              icon: g,
              showFooter: !(e instanceof de.x_),
              author: u,
              formattedDate: c,
              date: e.updatedAt,
              isReadOnly: e.readOnly,
              isLocked: e.locked,
              hasLockedContents: e.lockedContents
            }, d.createElement(p, {
              intl: t,
              annotation: e,
              type: r,
              autoFocus: i
            }));
          }
        }
        const mu = (0, xe.XN)(fu);
        var gu = n(1858),
          vu = n(67260);
        const yu = (0, xe.vU)({
          commentOptions: {
            id: "commentOptions",
            defaultMessage: "Comment Options",
            description: "Comment Options"
          },
          editContent: {
            id: "editContent",
            defaultMessage: "Edit Content",
            description: "Edit Content"
          },
          deleteCommentConfirmMessage: {
            id: "deleteCommentConfirmMessage",
            defaultMessage: "Are you sure you want to delete this comment?",
            description: 'Message displayed in the "Delete Comment" confirm dialog'
          },
          deleteCommentConfirmAccessibilityLabel: {
            id: "deleteCommentConfirmAccessibilityLabel",
            defaultMessage: "Confirm comment deletion",
            description: 'Accessibility label (title) for the "Delete Comment" confirm dialog'
          },
          deleteCommentConfirmAccessibilityDescription: {
            id: "deleteCommentConfirmAccessibilityDescription",
            defaultMessage: "Dialog allowing the user to confirm or cancel deleting the comment",
            description: 'Accessibility description for the "Delete Comment" confirm dialog'
          },
          moreComments: {
            id: "moreComments",
            defaultMessage: "More comments",
            description: "More comments indicator in comments popover"
          }
        });
        const bu = function (e) {
            var t;
            const n = d.useRef(),
              {
                rootComment: r,
                commentsCount: o,
                onRenderItemCallback: i,
                annotation: a,
                onPress: u,
                navigationDisabled: c,
                isCommentReadOnly: p,
                dateTimeStringCallback: f,
                isSelectedAnnotation: m,
                canDeleteCommentCP: g
              } = e,
              v = (0, l.I0)(),
              {
                formatMessage: y,
                formatDate: b
              } = (0, xe.YB)(),
              [w, x] = d.useState(!1),
              D = d.useCallback(e => {
                e && (n.current = e, null == i || i(e, a));
              }, [a, i]),
              C = (0, po.R9)(() => {
                if (!c) {
                  if (v((0, Ql.kN)(a.pageIndex, a.boundingBox)), p(r)) return setTimeout(() => {
                    v((0, _e.Q2)(a.id));
                  }, 100);
                  v((0, _e.Df)((0, s.l4)([a.id]), null)), u && u();
                }
              }),
              S = (0, po.R9)(() => {
                c || v((0, Ql.kN)(a.pageIndex, a.boundingBox)), x(!0);
              }),
              E = d.useCallback(() => {
                v((0, yo.UM)(r)), x(!1);
              }, [r, v]),
              _ = r.isAnonymous ? y(ke.Z.anonymous) : null !== (t = r.creatorName) && void 0 !== t ? t : y(ke.Z.anonymous);
            let P = null;
            r.createdAt.getTime() && (f && (P = f({
              dateTime: r.createdAt,
              element: ru.Y.ANNOTATIONS_SIDEBAR,
              object: r
            })), null == P && (P = b(r.createdAt, a.isCommentThreadRoot && r ? {
              hour12: !0,
              hour: "numeric",
              minute: "numeric",
              month: "numeric",
              day: "numeric",
              year: "numeric"
            } : void 0)));
            let k = null;
            o && o > 1 && (k = y(ke.Z.nMoreComments, {
              arg0: o - 1
            }));
            const A = h()("PSPDFKit-Sidebar-Annotations-Comment", {
                "PSPDFKit-Sidebar-Annotations-Comment-Selected": m
              }),
              z = !p(r) && !De.Ni && g(r),
              T = (0, Ae.Z)({
                type: "comment",
                className: h()(iu().icon, "PSPDFKit-Sidebar-Annotations-Icon")
              });
            return d.createElement(d.Fragment, null, d.createElement(au, {
              itemRef: D,
              layoutClassName: A,
              isSelectedItem: m,
              navigationDisabled: c,
              onPress: C,
              onDelete: S,
              isDeletable: z,
              itemWrapperProps: {
                "data-annotation-id": a.id
              },
              icon: T,
              showFooter: !0,
              author: _,
              formattedDate: P,
              date: a.updatedAt,
              additionalFooter: a.isCommentThreadRoot && k ? d.createElement("span", null, k) : null,
              isReadOnly: a.readOnly,
              isLocked: a.locked,
              hasLockedContents: a.lockedContents
            }, d.createElement("button", {
              autoFocus: e.autoFocus
            }, (0, F.aF)((0, gn.KY)((null == r ? void 0 : r.text.value) || "")))), w && d.createElement(vu.Z, {
              onConfirm: E,
              onCancel: () => {
                x(!1);
              },
              accessibilityLabel: y(yu.deleteCommentConfirmAccessibilityLabel),
              accessibilityDescription: y(yu.deleteCommentConfirmAccessibilityDescription)
            }, d.createElement("p", null, y(yu.deleteCommentConfirmMessage))));
          },
          wu = d.memo(function (e) {
            let {
              closeOnPress: t = !1,
              navigationDisabled: n,
              annotations: r,
              comments: o,
              commentThreads: i,
              formFields: a,
              pages: u,
              isAnnotationReadOnly: c,
              isCommentReadOnly: p,
              selectedAnnotationIds: f,
              canDeleteAnnotationCP: m,
              canDeleteCommentCP: g,
              sidebarOptions: v,
              focusedAnnotationIds: y
            } = e;
            const [b, w] = d.useState(null),
              {
                includeContent: x
              } = v;
            d.useEffect(() => {
              null == b || b.focus();
            }, [b]);
            const {
                formatMessage: D
              } = (0, xe.YB)(),
              C = (0, l.I0)(),
              S = (0, l.v9)(e => e.dateTimeString),
              E = (0, po.R9)(() => {
                n || t && C((0, Kt.mu)());
              }),
              P = x.some(e => e === _.sv),
              k = h()(iu().container, "PSPDFKit-Sidebar-Annotations"),
              A = d.useMemo(() => r.filter(e => null !== e.pageIndex && (P && e.isCommentThreadRoot || !e.isCommentThreadRoot && null !== xu(e, a) && x.some(t => e instanceof t))), [r, a, x, P]),
              z = d.useMemo(() => u.reduce((e, t) => {
                const n = function (e) {
                  let t = e.filter(e => e.isCommentThreadRoot).sortBy(e => e.boundingBox.top);
                  return e.map(e => {
                    if (!e.isCommentThreadRoot) return e;
                    const n = t.first();
                    return t = t.shift(), n;
                  });
                }((0, j.xp)(A, t));
                return 0 === n.size ? e : e.push(n);
              }, (0, s.aV)()), [u, A]),
              T = (0, po.Bo)(b, z),
              O = (null == z ? void 0 : z.reduce((e, t) => e + t.size, 0)) || 0,
              I = (0, po.mP)(T, e => e.id, e => A.get(e));
            return d.createElement("div", {
              className: k,
              role: "region",
              "aria-label": D(ke.Z.annotations),
              ref: w
            }, d.createElement("div", {
              className: "PSPDFKit-Sidebar-Header"
            }, O > 0 ? d.createElement("div", {
              className: h()(iu().annotationCounter, "PSPDFKit-Sidebar-Annotations-Annotation-Counter")
            }, D(ke.Z.annotationsCount, {
              arg0: O
            })) : null), O > 0 && z ? d.createElement(d.Fragment, null, z.map((e, t) => {
              const r = e.first().pageIndex,
                s = u.get(r);
              (0, Ce.k)(s);
              const l = s.get("pageLabel");
              return d.createElement("section", {
                key: `Annotations-Sidebar-Page-${r}`
              }, d.createElement("h1", {
                className: h()(iu().pageNumber, "PSPDFKit-Sidebar-Annotations-Page-Number")
              }, D(ke.Z.pageX, {
                arg0: l || r + 1
              })), d.createElement("div", {
                className: h()(iu().content, iu().annotations, "PSPDFKit-Sidebar-Annotations-Container")
              }, e.map((e, r) => {
                if (e.isCommentThreadRoot && P) {
                  const a = i.get(e.id),
                    s = null == a ? void 0 : a.first(),
                    l = null == a ? void 0 : a.last();
                  if (a && l && s) {
                    const i = o.get(l);
                    if (i) {
                      const l = !(0, Vs.kT)(i) && (null == i ? void 0 : i.text.value).length > 0 ? null == a ? void 0 : a.size : (null == a ? void 0 : a.size) - 1,
                        u = o.get(s);
                      return d.createElement(bu, {
                        annotation: e,
                        rootComment: u,
                        commentsCount: l,
                        onPress: E,
                        isCommentReadOnly: p,
                        isSelectedAnnotation: f.has(e.id),
                        navigationDisabled: n,
                        autoFocus: 0 === r && 0 === t,
                        canDeleteCommentCP: g,
                        key: `Annotation-Info-${e.id}`,
                        onRenderItemCallback: I,
                        dateTimeStringCallback: S
                      });
                    }
                  }
                }
                const s = xu(e, a);
                return null != s ? d.createElement(mu, {
                  dispatch: C,
                  annotation: e,
                  annotationType: s,
                  onPress: E,
                  isAnnotationReadOnly: c,
                  isSelectedAnnotation: f.has(e.id),
                  navigationDisabled: n,
                  autoFocus: 0 === r && 0 === t,
                  canDeleteAnnotationCP: m,
                  key: `Annotation-Info-${e.id}`,
                  onRenderItemCallback: I,
                  dateTimeStringCallback: S,
                  focusedAnnotationIds: y
                }) : null;
              })));
            })) : d.createElement("div", {
              className: h()(iu().container, iu().empty, "PSPDFKit-Sidebar-Empty"),
              role: "region",
              "aria-label": D(ke.Z.annotations)
            }, D(Du.noAnnotations)));
          });
        function xu(e, t) {
          var n;
          let r;
          const o = Number(e.cloudyBorderIntensity) > 0,
            i = null === (n = e.strokeDashArray) || void 0 === n ? void 0 : n.length;
          return e instanceof de.Zc ? function (e) {
            return "normal" === e.blendMode ? 0 === e.opacity || e.lineWidth / e.opacity > 40 ? "highlighter" : "ink" : e.lineWidth > 15 ? "highlighter" : "ink";
          }(e) : e instanceof de.gd ? e.callout ? "callout" : "text" : e instanceof de.Qi ? "note" : e instanceof de.sK ? "image" : e instanceof de.GI ? "stamp" : e instanceof de.FV ? "highlight" : e instanceof de.xu ? "underline" : e instanceof de.R9 ? "strikeOut" : e instanceof de.hL ? "squiggle" : e instanceof de.R1 ? "link" : e instanceof de.b3 ? e.isMeasurement() ? "rectangle-area" : o ? "cloudy-rectangle" : i ? "dashed-rectangle" : "rectangle" : e instanceof de.Xs ? e.isMeasurement() ? "ellipse-area" : o ? "cloudy-ellipse" : i ? "dashed-ellipse" : "ellipse" : e instanceof de.Hi ? e.isMeasurement() ? "polygon-area" : o ? "cloudy-polygon" : i ? "dashed-polygon" : "polygon" : e instanceof de.om ? e.isMeasurement() ? "perimeter" : "polyline" : e instanceof de.o9 ? function (e) {
            if (e.isMeasurement()) return "distance";
            if (!e.lineCaps) return "line";
            const t = "openArrow" === e.lineCaps.start || "closedArrow" === e.lineCaps.start || "reverseOpenArrow" === e.lineCaps.start || "reverseClosedArrow" === e.lineCaps.start,
              n = "openArrow" === e.lineCaps.end || "closedArrow" === e.lineCaps.end || "reverseOpenArrow" === e.lineCaps.end || "reverseClosedArrow" === e.lineCaps.end;
            return t || n ? "arrow" : "line";
          }(e) : e instanceof de.x_ ? ((0, Ce.k)(t), r = t.get(e.formFieldName), r instanceof gu.$o || r instanceof gu.Vi || r instanceof gu.fB ? "form-text" : r instanceof gu.rF ? "form-checkbox" : r instanceof gu.XQ || r instanceof gu.R0 ? "form-button" : r instanceof gu.Yo ? "form-signature" : null) : e instanceof W.Z ? "redaction" : e instanceof de.Hu ? "media" : null;
        }
        const Du = (0, xe.vU)({
          noAnnotations: {
            id: "noAnnotations",
            defaultMessage: "No Annotations",
            description: "Message shown when there is no annotations"
          }
        });
        var Cu,
          Su = n(42370),
          Eu = n(9470),
          _u = n(22690),
          Pu = n(17722),
          ku = n.n(Pu),
          Au = n(43165),
          zu = n.n(Au),
          Tu = n(84691),
          Ou = n.n(Tu);
        function Iu(e) {
          return Bu[e] || ke.Z[e];
        }
        function Fu(e) {
          let {
            itemId: t,
            label: n,
            isEnd: r
          } = e;
          return d.createElement(d.Fragment, null, d.createElement(i.TX, {
            tag: "div"
          }, n), d.createElement("svg", {
            viewBox: "0 0 8 4",
            style: {
              height: 16,
              width: 32
            }
          }, d.createElement("g", {
            transform: r ? "rotate(180 4,2)" : void 0
          }, Pt.O[t].startElement({
            fill: "transparent"
          }), Cu || (Cu = d.createElement("line", {
            x1: "3.5",
            y1: "2",
            x2: "8",
            y2: "2"
          })))));
        }
        function Mu(e) {
          let {
            itemId: t,
            label: n
          } = e;
          const r = Eu.x.find(e => e.id === t);
          return d.createElement(d.Fragment, null, d.createElement(i.TX, {
            tag: "div"
          }, n), d.createElement("svg", {
            viewBox: "0 0 16 4",
            style: {
              width: 54,
              height: 16
            }
          }, d.createElement("line", {
            x1: "0",
            y1: "2",
            x2: "16",
            y2: "2",
            strokeDasharray: r ? r.dashArray : void 0,
            fill: "transparent"
          })));
        }
        class Ru extends d.PureComponent {
          constructor() {
            for (var e, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
            super(...n), e = this, (0, o.Z)(this, "calculateBoundingBox", (0, dn.Z)((0, L.sS)(this.props.annotation.constructor))), (0, o.Z)(this, "_onChangeStartLineCap", e => {
              const {
                  annotation: t
                } = this.props,
                n = {};
              return "none" !== e && (n.start = e), "lineCaps" in t && t.lineCaps && null != t.lineCaps.end && (n.end = t.lineCaps.end), this.props.updateAnnotation({
                lineCaps: n,
                boundingBox: this.calculateBoundingBox(t.set("lineCaps", n))
              });
            }), (0, o.Z)(this, "_onChangeDashArray", e => {
              const t = Eu.x.find(t => t.id === e);
              return this.props.updateAnnotation({
                strokeDashArray: void 0 !== t ? t.dashArray : null
              });
            }), (0, o.Z)(this, "_onChangeEndLineCap", e => {
              const {
                  annotation: t
                } = this.props,
                n = {};
              return "lineCaps" in t && t.lineCaps && null != t.lineCaps.start && (n.start = t.lineCaps.start), "none" !== e && (n.end = e), this.props.updateAnnotation({
                lineCaps: n,
                boundingBox: this.calculateBoundingBox(t.set("lineCaps", n))
              });
            }), (0, o.Z)(this, "LineCapSelectButton", function (t, n) {
              let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                o = arguments.length > 3 ? arguments[3] : void 0;
              return i => {
                var a;
                let {
                  btnComponentProps: s,
                  selectedItem: l
                } = i;
                const u = null !== (a = null == l ? void 0 : l.label) && void 0 !== a ? a : "",
                  c = t(Iu(u));
                return d.createElement(we.Z, (0, ce.Z)({
                  is: "div"
                }, s, {
                  className: h()("PSPDFKit-Input-Dropdown-Button", Ou().selectBox, e.props.styles.startLineCapSelect),
                  name: "clickableBox",
                  ref: e => {
                    s.ref(e), "function" == typeof o ? o(e) : o && (o.current = e);
                  }
                }), d.createElement(Fu, {
                  itemId: u,
                  isEnd: r,
                  label: c
                }), d.createElement("div", null, (0, Ae.Z)({
                  type: "caret-" + n,
                  style: {
                    width: 12,
                    height: 12,
                    flexBasis: 12,
                    marginLeft: 3,
                    strokeWidth: 0
                  },
                  className: h()(Ou().dropdownIcon)
                })));
              };
            }), (0, o.Z)(this, "LineCapItem", function (e) {
              let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
              return n => {
                var r;
                let {
                  item: o,
                  state: i,
                  itemComponentProps: a,
                  ref: s
                } = n;
                const l = null !== (r = null == o ? void 0 : o.label) && void 0 !== r ? r : "",
                  u = e(Iu(l));
                return d.createElement(we.Z, (0, ce.Z)({
                  is: "div",
                  className: h()(zu().root, ku().root, (null == i ? void 0 : i.includes("selected")) && Ou().isSelected, (null == i ? void 0 : i.includes("focused")) && Ou().isSelected)
                }, a, {
                  ref: s
                }), d.createElement(Fu, {
                  label: u,
                  isEnd: t,
                  itemId: l
                }));
              };
            }), (0, o.Z)(this, "DashArrayButton", (e, t) => n => {
              var r;
              let {
                btnComponentProps: o,
                selectedItem: i
              } = n;
              const a = null !== (r = null == i ? void 0 : i.label) && void 0 !== r ? r : "",
                s = e(Iu(a));
              return d.createElement(we.Z, (0, ce.Z)({
                is: "div"
              }, o, {
                ref: o.ref,
                className: h()("PSPDFKit-Input-Dropdown-Button", Ou().selectBox, this.props.styles.strokeDashArraySelect),
                name: "clickableBox"
              }), d.createElement(Mu, {
                label: s,
                itemId: a
              }), d.createElement("div", null, (0, Ae.Z)({
                type: "caret-" + t,
                style: {
                  width: 12,
                  height: 12,
                  flexBasis: 12,
                  marginLeft: 3,
                  strokeWidth: 0
                },
                className: h()(Ou().dropdownIcon)
              })));
            }), (0, o.Z)(this, "DashArrayItem", e => t => {
              var n;
              let {
                item: r,
                state: o,
                itemComponentProps: i,
                ref: a
              } = t;
              const s = null !== (n = null == r ? void 0 : r.label) && void 0 !== n ? n : "",
                l = e(Iu(s));
              return d.createElement(we.Z, (0, ce.Z)({
                is: "div",
                className: h()(zu().root, ku().root, (null == o ? void 0 : o.includes("selected")) && Ou().isSelected, (null == o ? void 0 : o.includes("focused")) && Ou().isSelected),
                ref: a
              }, i), d.createElement(Mu, {
                label: l,
                itemId: s
              }));
            }), (0, o.Z)(this, "_startButton", this.LineCapSelectButton(this.props.intl.formatMessage, this.props.caretDirection, !1, this.props.innerRef)), (0, o.Z)(this, "_endButton", this.LineCapSelectButton(this.props.intl.formatMessage, this.props.caretDirection, !0)), (0, o.Z)(this, "_startItem", this.LineCapItem(this.props.intl.formatMessage)), (0, o.Z)(this, "_endItem", this.LineCapItem(this.props.intl.formatMessage, !0)), (0, o.Z)(this, "_dashArrayButton", this.DashArrayButton(this.props.intl.formatMessage, this.props.caretDirection)), (0, o.Z)(this, "_dashArrayItem", this.DashArrayItem(this.props.intl.formatMessage));
          }
          render() {
            const {
                intl: {
                  formatMessage: e
                },
                styles: t,
                annotation: n,
                caretDirection: r
              } = this.props,
              {
                strokeDashArray: o
              } = n,
              i = it.Options.LINE_CAP_PRESETS,
              a = {
                start: "none",
                end: "none"
              };
            "lineCaps" in n && n.lineCaps && (Su.a.includes(n.lineCaps.start) && (a.start = n.lineCaps.start), Su.a.includes(n.lineCaps.end) && (a.end = n.lineCaps.end)), i.includes(a.start) || (a.start = "N/A"), i.includes(a.end) || (a.end = "N/A");
            const s = i.map(e => ({
                value: e,
                label: e,
                className: `PSPDFKit-LineCap-${e.replace(" ", "")}`
              })),
              l = o instanceof Array && 2 === o.length ? Eu.x.find(e => 2 === e.dashArray.length && e.dashArray[0] === o[0] && e.dashArray[1] === o[1]) : Eu.x[0],
              u = Eu.x.map(e => ({
                value: e.id,
                label: e.id,
                className: `PSPDFKit-DashArray-${e.id.replace(" ", "")}`
              }));
            return d.createElement("div", {
              className: t.controlWrapper
            }, d.createElement("div", {
              className: t.control
            }, d.createElement(_u.Z, {
              items: s,
              value: {
                value: a.start,
                label: a.start
              },
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: r,
              accessibilityLabel: e(ke.Z.startLineCap),
              className: h()("PSPDFKit-Annotation-Toolbar-StartLineCap", t.startLineCapSelect, "PSPDFKit-Toolbar-DropdownGroup", "PSPDFKit-Toolbar-DropdownGroup-Toolbar"),
              menuClassName: h()(t.dropdownMenu, t.lineCapsDashArrayMenu),
              maxCols: 5,
              itemWidth: 54,
              ButtonComponent: this._startButton,
              ItemComponent: this._startItem,
              onSelect: (e, t) => {
                t.value && this._onChangeStartLineCap(t.value);
              },
              frameWindow: this.props.frameWindow
            }), d.createElement(_u.Z, {
              items: u,
              value: l ? {
                label: l.id,
                value: l.id
              } : {
                label: "solid",
                value: "solid"
              },
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: r,
              accessibilityLabel: e(ke.Z.strokeDashArray),
              className: h()("PSPDFKit-Annotation-Toolbar-DashArray", t.strokeDashArraySelect, "PSPDFKit-Toolbar-DropdownGroup", "PSPDFKit-Toolbar-DropdownGroup-Toolbar"),
              menuClassName: h()(t.dropdownMenu, t.lineCapsDashArrayMenu),
              itemWidth: 76,
              ButtonComponent: this._dashArrayButton,
              ItemComponent: this._dashArrayItem,
              onSelect: (e, t) => {
                t.value && this._onChangeDashArray(t.value);
              },
              frameWindow: this.props.frameWindow
            }), d.createElement(_u.Z, {
              items: s,
              value: {
                label: a.end,
                value: a.end
              },
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: r,
              accessibilityLabel: e(ke.Z.endLineCap),
              className: h()("PSPDFKit-Annotation-Toolbar-EndLineCap", t.endLineCapSelect, "PSPDFKit-Toolbar-DropdownGroup", "PSPDFKit-Toolbar-DropdownGroup-Toolbar"),
              menuClassName: h()(t.dropdownMenu, t.lineCapsDashArrayMenu),
              maxCols: 5,
              itemWidth: 54,
              ButtonComponent: this._endButton,
              ItemComponent: this._endItem,
              onSelect: (e, t) => {
                t.value && this._onChangeEndLineCap(t.value);
              },
              frameWindow: this.props.frameWindow
            })));
          }
        }
        const ju = Ru,
          Bu = (0, xe.vU)({
            square: {
              id: "square",
              defaultMessage: "Square",
              description: "Square line cap"
            },
            circle: {
              id: "circle",
              defaultMessage: "Circle",
              description: "Circle line cap"
            },
            diamond: {
              id: "diamond",
              defaultMessage: "Diamond",
              description: "Diamond line cap"
            },
            openArrow: {
              id: "openArrow",
              defaultMessage: "Open Arrow",
              description: "Open arrow line cap"
            },
            closedArrow: {
              id: "closedArrow",
              defaultMessage: "Closed Arrow",
              description: "Closed arrow line cap"
            },
            butt: {
              id: "butt",
              defaultMessage: "Butt",
              description: "Butt line cap"
            },
            reverseOpenArrow: {
              id: "reverseOpenArrow",
              defaultMessage: "Reverse Open Arrow",
              description: "Reverse open arrow line cap"
            },
            reverseClosedArrow: {
              id: "reverseClosedArrow",
              defaultMessage: "Reverse Closed Arrow",
              description: "Reverse closed arrow line cap"
            },
            slash: {
              id: "slash",
              defaultMessage: "Slash",
              description: "Slash line cap"
            },
            solid: {
              id: "solid",
              defaultMessage: "Solid",
              description: "Solid line"
            },
            narrowDots: {
              id: "narrowDots",
              defaultMessage: "Narrow Dots",
              description: "Narrow dotted line"
            },
            wideDots: {
              id: "wideDots",
              defaultMessage: "Wide Dots",
              description: "Wide dotted line"
            },
            narrowDashes: {
              id: "narrowDashes",
              defaultMessage: "Narrow Dashes",
              description: "Narrow dashed line"
            },
            wideDashes: {
              id: "wideDashes",
              defaultMessage: "Wide Dashes",
              description: "Wide dashed line"
            }
          });
        var Nu;
        const Lu = 74,
          Vu = {
            width: 54,
            height: 13.5,
            fill: "transparent"
          };
        const Ku = Ne.i1 * Ne.St;
        function qu(e) {
          let {
            label: t,
            element: n
          } = e;
          return d.createElement(d.Fragment, null, d.createElement(i.TX, {
            tag: "div"
          }, t), n);
        }
        class Hu extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              calculateShapeBoundingBox: (0, L.sS)(this.props.annotation.constructor)
            }), (0, o.Z)(this, "DashArrayButton", e => {
              var t;
              let {
                btnComponentProps: n,
                selectedItem: r
              } = e;
              const o = null !== (t = null == r ? void 0 : r.label) && void 0 !== t ? t : "solid",
                i = this.props.intl.formatMessage(Zu[o]),
                a = this._lineStyleOptions.get(o);
              return d.createElement(we.Z, (0, ce.Z)({
                is: "div"
              }, n, {
                className: h()("PSPDFKit-Input-Dropdown-Button", Ou().selectBox, this.props.styles.strokeDashArraySelect),
                name: "clickableBox",
                ref: e => {
                  n.ref(e), "function" == typeof this.props.innerRef ? this.props.innerRef(e) : this.props.innerRef && (this.props.innerRef.current = e);
                }
              }), d.createElement(qu, {
                label: i,
                element: a
              }), d.createElement("div", null, (0, Ae.Z)({
                type: "caret-" + this.props.caretDirection,
                style: {
                  width: 12,
                  height: 12,
                  flexBasis: 12,
                  marginLeft: 3,
                  strokeWidth: 0
                },
                className: h()(Ou().dropdownIcon)
              })));
            }), (0, o.Z)(this, "DashArrayItem", e => {
              var t;
              let {
                item: n,
                state: r,
                itemComponentProps: o,
                ref: i
              } = e;
              const a = null !== (t = null == n ? void 0 : n.label) && void 0 !== t ? t : "solid",
                s = this.props.intl.formatMessage(Zu[a]),
                l = this._lineStyleOptions.get(a);
              return d.createElement(we.Z, (0, ce.Z)({
                is: "div",
                className: h()(zu().root, ku().root, (null == r ? void 0 : r.includes("selected")) && Ou().isSelected, (null == r ? void 0 : r.includes("focused")) && Ou().isSelected)
              }, o, {
                ref: i
              }), d.createElement(qu, {
                label: s,
                element: l
              }));
            }), (0, o.Z)(this, "_onChange", (e, t) => {
              const {
                  value: n
                } = t,
                {
                  annotation: r
                } = this.props,
                o = "cloudy" === n ? Ne.i1 : 0,
                i = Eu.x.find(e => e.id === n),
                a = ((e, t, n) => {
                  if (e.constructor === de.Xs || e.constructor === de.b3) {
                    if (t > 0 && !e.cloudyBorderIntensity) return e.boundingBox.grow(Ku + e.strokeWidth / 2);
                    if (!t && e.cloudyBorderIntensity > 0) return e.boundingBox.grow(-(Ku + e.strokeWidth / 2));
                  }
                  return e.constructor === de.Hi ? n(e.set("cloudyBorderIntensity", t)) : n(e);
                })(r, o, this.state.calculateShapeBoundingBox);
              return this.props.updateAnnotation({
                strokeDashArray: void 0 !== i && Array.isArray(i.dashArray) && 2 === i.dashArray.length ? i.dashArray : null,
                cloudyBorderIntensity: o,
                cloudyBorderInset: o ? _.eB.fromValue(Ku + r.strokeWidth / 2) : r.cloudyBorderInset,
                boundingBox: a
              });
            }), (0, o.Z)(this, "_lineStyleOptions", function () {
              const e = new Map();
              return Eu.x.forEach(t => {
                e.set(t.id, d.createElement("svg", {
                  viewBox: "0 0 16 4",
                  style: Vu,
                  key: t.id
                }, d.createElement("line", {
                  x1: "0",
                  y1: "2",
                  x2: "16",
                  y2: "2",
                  strokeDasharray: t.dashArray
                })));
              }), e.set("cloudy", Nu || (Nu = d.createElement("svg", {
                viewBox: "0 0 16 4",
                style: Vu,
                key: "cloudy"
              }, d.createElement("path", {
                d: "M 1 2.23 A 2.125 2.125 0 0 1 4.67 1.68 A 2.125 2.125 0 0 0 4.35 2.23 A 2.125 2.125 0 0 1 8 1.68 A 2.125 2.125 0 0 0 7.68 2.23 A 2.125 2.125 0 0 1 11.33 1.68 A 2.125 2.125 0 0 0 11.02 2.23 A 2.125 2.125 0 1 1 14.14 4.80 A 2.125 2.125 0 0 0 13.55 4.54"
              })))), e;
            }(this.props.intl.formatMessage));
          }
          static getDerivedStateFromProps(e) {
            return {
              calculateShapeBoundingBox: (0, L.sS)(e.annotation.constructor)
            };
          }
          render() {
            const {
                intl: {
                  formatMessage: e
                },
                styles: t,
                annotation: n,
                frameWindow: r
              } = this.props,
              {
                strokeDashArray: o,
                cloudyBorderIntensity: i
              } = n,
              a = Array.isArray(o) && 2 === o.length && Eu.x.find(e => 2 === e.dashArray.length && e.dashArray[0] === o[0] && e.dashArray[1] === o[1]),
              s = i > 0 ? a || i !== Ne.i1 ? "" : "cloudy" : a ? a.id : o ? "" : "solid",
              l = Array.from(this._lineStyleOptions.keys()).map(e => ({
                label: e,
                value: e,
                className: `PSPDFKit-LineStyle-${Zu[null != e ? e : "solid"].id}`
              }));
            return d.createElement("div", {
              className: t.controlWrapper
            }, d.createElement("div", {
              className: t.control
            }, d.createElement(_u.Z, {
              items: l,
              value: {
                label: s || "solid",
                value: s || "solid"
              },
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: this.props.caretDirection,
              accessibilityLabel: e(ke.Z.strokeDashArray),
              className: h()("PSPDFKit-Annotation-Toolbar-LineStyle", t.strokeDashArraySelect, "PSPDFKit-Toolbar-DropdownGroup", "PSPDFKit-Toolbar-DropdownGroup-Toolbar"),
              menuClassName: h()(t.dropdownMenu, t.strokeDashArrayMenu),
              maxCols: 1,
              itemWidth: Lu,
              ButtonComponent: this.DashArrayButton,
              ItemComponent: this.DashArrayItem,
              onSelect: this._onChange,
              frameWindow: r
            })));
          }
        }
        const Uu = Hu,
          Zu = (0, xe.vU)({
            solid: {
              id: "solid",
              defaultMessage: "Solid",
              description: "Solid line"
            },
            narrowDots: {
              id: "narrowDots",
              defaultMessage: "Narrow Dots",
              description: "Narrow dotted line"
            },
            wideDots: {
              id: "wideDots",
              defaultMessage: "Wide Dots",
              description: "Wide dotted line"
            },
            narrowDashes: {
              id: "narrowDashes",
              defaultMessage: "Narrow Dashes",
              description: "Narrow dashed line"
            },
            wideDashes: {
              id: "wideDashes",
              defaultMessage: "Wide Dashes",
              description: "Wide dashed line"
            },
            cloudy: {
              id: "cloudy",
              defaultMessage: "Cloudy border",
              description: "Cloudy border effect"
            }
          });
        var $u = n(54707);
        function Gu(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        const Wu = d.forwardRef((e, t) => {
            const n = (0, l.v9)(e => e.shadowRoot);
            let r = [],
              i = !1;
            Array.isArray(it.Options.LINE_WIDTH_PRESETS) && (r = it.Options.LINE_WIDTH_PRESETS, i = !0);
            let a = !1,
              s = !1;
            e.annotation instanceof _.Zc && (a = !0), e.annotation instanceof _.R1 && (s = !0);
            const {
                intl: {
                  formatMessage: u
                },
                styles: c,
                annotation: p,
                type: f,
                caretDirection: m
              } = e,
              g = f ? `PSPDFKit-${f}-Annotation-Toolbar-StrokeWidth` : "",
              v = h()("PSPDFKit-Annotation-Toolbar-StrokeWidth", f && g);
            let y = 1,
              b = 40,
              w = a ? p.lineWidth : s ? p.borderWidth : p.strokeWidth;
            return i && (y = 0, b = r.length - 1, w = r.indexOf(w)), d.createElement("div", {
              className: c.controlWrapper
            }, d.createElement("div", {
              className: c.control
            }, d.createElement($u.Z, {
              name: "lineWidth",
              accessibilityLabel: e.accessibilityLabel || u(ke.Z.size),
              className: v,
              value: w,
              valueLabel: t => {
                let n = t;
                if (i) {
                  if (-1 === t) return "N/A";
                  n = r[t];
                }
                return e.intl.formatMessage(ke.Z.numberInPt, {
                  arg0: n.toFixed(0)
                });
              },
              min: y,
              max: b,
              step: 1,
              onChange: t => {
                let n = t;
                if (i && (n = r[t]), a) return e.updateAnnotation({
                  lineWidth: n
                });
                if (s) return e.updateAnnotation({
                  borderWidth: n
                });
                if (e.annotation instanceof _.b3 || e.annotation instanceof _.Xs) {
                  const t = n / 2 - e.annotation.strokeWidth / 2,
                    r = e.annotation.cloudyBorderInset ? new _.eB({
                      left: e.annotation.cloudyBorderInset.left + t,
                      top: e.annotation.cloudyBorderInset.top + t,
                      right: e.annotation.cloudyBorderInset.right + t,
                      bottom: e.annotation.cloudyBorderInset.bottom + t
                    }) : null;
                  return e.updateAnnotation(function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = null != arguments[t] ? arguments[t] : {};
                      t % 2 ? Gu(Object(n), !0).forEach(function (t) {
                        (0, o.Z)(e, t, n[t]);
                      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gu(Object(n)).forEach(function (t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                      });
                    }
                    return e;
                  }({
                    strokeWidth: n,
                    boundingBox: (0, L.sS)(e.annotation.constructor)(e.annotation.set("strokeWidth", n))
                  }, r ? {
                    cloudyBorderInset: r
                  } : null));
                }
                return e.updateAnnotation({
                  strokeWidth: n,
                  boundingBox: (0, L.sS)(e.annotation.constructor)(e.annotation.set("strokeWidth", n))
                });
              },
              caretDirection: m,
              innerRef: t,
              shadowRoot: n
            })));
          }),
          Yu = Wu;
        class Xu extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "updateAnnotation", e => this.props.updateAnnotation({
              opacity: e / 100
            })), (0, o.Z)(this, "valueLabel", e => `${Math.round(e)}%`);
          }
          render() {
            const {
                intl: {
                  formatMessage: e
                },
                styles: t,
                annotation: n,
                type: r,
                caretDirection: o
              } = this.props,
              i = r ? `PSPDFKit-${r}-Annotation-Toolbar-Opacity` : "",
              a = h()("PSPDFKit-Annotation-Toolbar-Opacity", r && i);
            return d.createElement("div", {
              className: t.controlWrapper
            }, d.createElement("div", {
              className: t.control
            }, d.createElement($u.Z, {
              name: "opacity",
              accessibilityLabel: e(ke.Z.opacity),
              className: a,
              value: 100 * n.opacity,
              valueLabel: this.valueLabel,
              min: 10,
              max: 100,
              step: 1,
              onChange: this.updateAnnotation,
              caretDirection: o,
              innerRef: this.props.innerRef,
              shadowRoot: this.props.shadowRoot
            })));
          }
        }
        const Qu = {
          LineCapsDashArrayComponent: ju,
          LineStyleComponent: Uu,
          StrokeWidthComponent: Yu,
          OpacityComponent: Xu
        };
        var Ju = n(54130),
          ec = n(35012),
          tc = n(16165),
          nc = n.n(tc);
        let rc = 0;
        const oc = d.forwardRef(function (e, t) {
          const n = d.useRef(rc++),
            {
              label: r,
              accessibilityLabel: o,
              onUpdate: a,
              onBlur: s,
              onFocus: l,
              onKeyDown: u,
              textStyles: c,
              disabled: p = !1,
              autoFocus: f = !0,
              name: m = "name"
            } = e,
            g = d.useCallback(e => {
              a && a(e.target.value);
            }, [a]);
          return d.createElement("div", {
            className: e.styles.controlWrapper
          }, d.createElement("div", {
            className: e.styles.control
          }, d.createElement("div", {
            className: `PSPDFKit-Text-Input ${e.className || ""} ${nc().root}`
          }, e.label ? d.createElement("label", {
            htmlFor: `${nc().root}-${n.current}`,
            className: nc().label
          }, r) : o ? d.createElement(i.TX, {
            tag: "label",
            htmlFor: `${nc().root}-${n.current}`
          }, o) : null, d.createElement(i.oi, {
            className: h()(nc().input, e.styles.input),
            value: e.value,
            onChange: g,
            onBlur: s,
            onFocus: l,
            onKeyDown: u,
            autoFocus: f,
            selectTextOnFocus: !0,
            name: m,
            placeholder: e.placeholder,
            autoComplete: "off",
            id: `${nc().root}-${n.current}`,
            ref: t,
            style: c,
            disabled: p
          }))));
        });
        var ic = n(44170),
          ac = n.n(ic);
        const sc = d.forwardRef(function (e, t) {
          const {
              intl: n,
              isEditing: r,
              showAnnotationNotes: o,
              isAnnotationNoteActive: i,
              hasAnnotationNote: a,
              onAnnotationNotePress: s,
              disabled: l
            } = e,
            {
              formatMessage: u
            } = n;
          return d.createElement(d.Fragment, null, o && !r ? d.createElement(Ju.Z, {
            type: a || i ? "note" : "note-add",
            title: u(ke.Z.noteAnnotation),
            className: h()(ac().button, ac().annotationNoteButton, {
              [ac().disableEditing]: l
            }),
            onPress: l ? void 0 : s,
            selected: i,
            ref: t
          }) : null);
        });
        var lc = n(31647),
          uc = n(80292),
          cc = n(76465);
        function dc(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function pc(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? dc(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dc(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function hc(e) {
          return "custom" === e.type;
        }
        function fc(e) {
          return hc(e) ? `custom-${e.id}` : e.group;
        }
        const mc = e => {
          let {
            annotationToolbarItems: t,
            builtInItems: n,
            btnFocusRefIfFocusedItem: r,
            onGroupExpansion: o,
            builtInToolbarProps: i = {},
            expandedGroup: a,
            hasDesktopLayout: s,
            onGroupTransitionEnded: l,
            position: u,
            typeMap: c
          } = e;
          const p = (0, d.useMemo)(() => t.every(e => {
              if (hc(e)) return !1;
              if ("spacer" === e.type) return !0;
              {
                const t = n.find(t => t.type === e.type);
                return !(null == t || !t.hidden);
              }
            }), [n, t]),
            f = a ? n.find(e => fc(e) === a) || t.filter(hc).find(e => fc(e) === a) : void 0,
            m = (0, d.useMemo)(() => ((e, t, n) => {
              if (n) return e.map(e => {
                const n = !hc(e) && t.find(t => t.type === e.type);
                return pc(pc({}, e), n && {
                  group: n.group,
                  node: n.node,
                  title: e.title || n.title,
                  onPress: (t, r) => {
                    var o, i;
                    null === (o = n.onPress) || void 0 === o || o.call(n, t.nativeEvent, e.id), null === (i = e.onPress) || void 0 === i || i.call(e, t.nativeEvent, r);
                  },
                  disabled: n.disabled && e.disabled,
                  className: h()(n.className, e.className)
                });
              }).find(e => n === fc(e));
            })(t, n, a), [t, a, n]);
          if (m) return d.createElement("div", {
            className: ac().right
          }, d.createElement(cc.Z, {
            onClose: () => o(null),
            isPrimary: !1,
            position: u,
            onEntered: l,
            accessibilityLabel: m ? m.title : void 0,
            className: ac().expanded
          }, (0, jr.Re)(m.node) ? d.createElement(uc.Z, {
            node: m.node,
            className: m.className,
            onPress: m.onPress,
            title: m.title,
            disabled: m.disabled
          }) : d.createElement("div", {
            className: m.className,
            onClick: e => {
              var t;
              return null === (t = m.onPress) || void 0 === t ? void 0 : t.call(m, e.nativeEvent, m.id);
            },
            title: m.title
          }, m.node)));
          if (p) return null;
          const g = t.find(e => {
            var t;
            return "spacer" !== e.type && !(null !== (t = n.find(t => t.type === e.type)) && void 0 !== t && t.hidden);
          });
          return d.createElement("form", {
            className: ac().form,
            onSubmit: jr.PF
          }, t.map((e, t) => {
            if ("spacer" === e.type) return d.createElement("div", {
              key: e.type,
              className: h()("PSPDFKit-Annotation-Toolbar-Spacer", e.className),
              style: {
                display: "flex",
                flex: 1
              },
              onClick: t => {
                var n;
                return null === (n = e.onPress) || void 0 === n ? void 0 : n.call(e, t.nativeEvent, e.id);
              }
            });
            const l = n.find(t => t.type === e.type),
              u = (null == g ? void 0 : g.id) === e.id && (null == g ? void 0 : g.type) === e.type;
            if (hc(e)) {
              const n = "node" in e && !!e.node && d.createElement("div", {
                  role: "button",
                  ref: r(fc(e), f, 0 === t && !a),
                  key: e.id
                }, d.createElement(uc.Z, {
                  node: e.node,
                  className: e.className,
                  onPress: t => {
                    var n;
                    return null === (n = e.onPress) || void 0 === n ? void 0 : n.call(e, t, e.id);
                  },
                  title: e.title,
                  disabled: e.disabled,
                  variant: "annotationToolbar"
                })),
                i = "icon" in e && !!e.icon && d.createElement("div", {
                  role: "button",
                  key: e.id,
                  className: h()(ac().button, ku().root, zu().root, `${e.className}-Icon`),
                  onClick: t => {
                    var n;
                    "custom" === e.type && e.node && o(`custom-${e.id}`), null === (n = e.onPress) || void 0 === n || n.call(e, t, e.id);
                  },
                  ref: r(fc(e), f, u && !a),
                  title: e.title
                }, (e => "icon" in e ? "string" == typeof e.icon ? /<svg/i.test(e.icon) ? d.createElement(je.Z, {
                  className: ac().customIconSvg,
                  src: e.icon,
                  role: "presentation"
                }) : d.createElement("img", {
                  alt: e.title,
                  src: e.icon,
                  role: "presentation"
                }) : e.icon instanceof Node ? d.createElement(uc.Z, {
                  key: e.id,
                  node: e.icon,
                  className: e.iconClassName,
                  onPress: t => {
                    var n;
                    return null === (n = e.onIconPress) || void 0 === n ? void 0 : n.call(e, t, e.id);
                  },
                  title: e.title,
                  disabled: e.disabled
                }) : void 0 : null)(e));
              return s ? n || i : i || n;
            }
            if (!l || l.hidden) return null;
            const p = (null == c ? void 0 : c[e.type]) || e.type,
              m = "function" == typeof i ? i(l) : i;
            return l.group ? d.createElement(d.Fragment, {
              key: l.type
            }, d.createElement("div", {
              className: h()(l.className, {
                [ac().disableEditing]: l.disabled
              })
            }, d.createElement(Ju.Z, (0, ce.Z)({
              type: p,
              icon: e.icon,
              title: e.title || l.title,
              onPress: t => {
                var n, r;
                (o(l.group || null), s) ? null === (n = e.onPress) || void 0 === n || n.call(e, t, e.id) : null === (r = e.onIconPress) || void 0 === r || r.call(e, t, e.id);
              }
            }, m, {
              className: h()(m.className, e.className),
              ref: r(fc(l), f, u && !a)
            })), l.node), !l.hideSeparator && d.createElement("div", {
              className: ac().separator
            })) : d.createElement("div", {
              className: h()(l.className, {
                [ac().disableEditing]: l.disabled
              }, e.className),
              key: l.type,
              onClick: t => {
                var n;
                null === (n = e.onPress) || void 0 === n || n.call(e, t.nativeEvent, e.id);
              },
              title: e.title || l.title
            }, l.node);
          }));
        };
        var gc = n(5283);
        function vc(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function yc(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? vc(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vc(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const bc = d.memo(function (e) {
          const {
              annotation: t,
              isEditing: n,
              dispatch: r,
              canEditAnnotationCP: o,
              canDeleteSelectedAnnotationCP: a,
              expandedGroup: s,
              btnFocusRefIfFocusedGroup: u,
              btnFocusRefIfFocusedItem: c,
              lastToolbarActionUsedKeyboard: p,
              annotationToolbarItems: f,
              keepSelectedTool: m
            } = e,
            g = (0, l.v9)(e => e.shadowRoot),
            v = (0, po.R9)(i => {
              o && (t.rects.size > 0 && n ? (r((0, yt.gX)(i)), r((0, Kt.aw)()), r((0, _e.vR)())) : e.updateAnnotation(i, "redaction"));
            }),
            y = (0, po.R9)(() => (r((0, Kt.fq)()), new Promise((e, t) => (r((0, lc.g)(() => {
              r((0, Kt.Di)()), e();
            }, e => {
              r((0, Kt.Di)()), t(e);
            })), e)))),
            {
              position: b,
              intl: w
            } = e,
            {
              formatMessage: x
            } = w,
            D = {
              updateAnnotation: v,
              annotation: t,
              styles: ac(),
              intl: w,
              caretDirection: "bottom" === b ? "up" : "down"
            },
            C = [{
              node: d.createElement(ec.Z, (0, ce.Z)({}, D, {
                record: t,
                colorProperty: "fillColor",
                onChange: v,
                className: "PSPDFKit-Redaction-Annotation-Toolbar-Fill-Color",
                accessibilityLabel: x(ke.Z.fillColor),
                removeTransparent: !0,
                keepOpacity: !0,
                frameWindow: e.frameWindow,
                innerRef: u("fillColor", !s),
                lastToolbarActionUsedKeyboard: p,
                annotationToolbarColorPresets: e.annotationToolbarColorPresets
              })),
              title: x(ke.Z.fillColor),
              type: "fill-color",
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Fill-Color"),
              group: "fillColor",
              disabled: !o,
              hideSeparator: !0
            }, {
              node: d.createElement("div", {
                style: {
                  display: "flex"
                }
              }, d.createElement(oc, {
                accessibilityLabel: x(ke.Z.overlayText),
                placeholder: x(ke.Z.insertOverlayText),
                className: ac().overlayTextInput,
                value: t.overlayText || "",
                onUpdate: e => {
                  v({
                    overlayText: e
                  });
                },
                styles: yc(yc({}, ac()), {}, {
                  controlWrapper: ac().controlWrapperAutoWidth,
                  input: ac().overlayInput
                }),
                ref: u("overlayText")
              }), d.createElement(ec.Z, (0, ce.Z)({}, D, {
                record: t,
                colorProperty: "color",
                onChange: v,
                className: "PSPDFKit-Redaction-Annotation-Toolbar-Color",
                removeTransparent: !0,
                accessibilityLabel: x(ke.Z.color),
                keepOpacity: !0,
                styles: yc(yc({}, ac()), {}, {
                  controlWrapper: ac().controlWrapperAutoWidth
                }),
                frameWindow: e.frameWindow,
                annotationToolbarColorPresets: e.annotationToolbarColorPresets
              })), d.createElement(i.bK, {
                label: x(ke.Z.repeatText),
                value: Boolean(t.repeatOverlayText),
                onUpdate: e => {
                  v({
                    repeatOverlayText: e
                  });
                },
                styles: yc(yc({}, ac()), {}, {
                  controlWrapper: ac().controlWrapperAutoWidth
                })
              })),
              title: x(ke.Z.overlayText),
              group: "overlayText",
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Overlay-Text", ac().overlayTextMargin),
              disabled: !e.canEditAnnotationCP,
              type: "overlay-text"
            }, {
              node: d.createElement(ec.Z, (0, ce.Z)({}, D, {
                record: t,
                colorProperty: "outlineColor",
                onChange: v,
                className: "PSPDFKit-Redaction-Annotation-Toolbar-Outline-Color",
                accessibilityLabel: x(ke.Z.outlineColor),
                frameWindow: e.frameWindow,
                innerRef: u("outlineColor"),
                annotationToolbarColorPresets: e.annotationToolbarColorPresets
              })),
              title: x(ke.Z.outlineColor),
              group: "outlineColor",
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Outline-Color"),
              disabled: !e.canEditAnnotationCP,
              type: "outline-color"
            }, {
              node: d.createElement(Qu.OpacityComponent, (0, ce.Z)({}, D, {
                innerRef: u("opacity"),
                shadowRoot: g
              })),
              title: x(ke.Z.opacity),
              group: "opacity",
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity"),
              disabled: !e.canEditAnnotationCP,
              type: "opacity"
            }, {
              node: d.createElement(Ju.Z, {
                type: "delete",
                icon: (0, gc.KT)(f),
                title: x(ke.Z.delete),
                className: h()("PSPDFKit-Redaction-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                  [ac().disabledButton]: !a
                }),
                onPress: a ? () => e.deleteAnnotation() : () => {}
              }),
              type: "delete",
              hidden: null === t.pageIndex || !!s || m
            }, {
              node: d.createElement("div", {
                className: h()(ac().applyRedactionsWrapper)
              }, d.createElement(Ju.Z, {
                type: "applyRedaction",
                title: x(ke.Z.applyRedactions),
                className: h()("PSPDFKit-Redaction-Annotation-Toolbar-Button-Apply-Redactions", ac().button, ac().buttonNoBorder, ac().applyRedactionsButton),
                onPress: y
              })),
              type: "apply-redactions",
              hidden: null === t.pageIndex || !!s || m
            }, {
              node: d.createElement(sc, {
                intl: w,
                isEditing: e.isEditing,
                showAnnotationNotes: e.showAnnotationNotes,
                hasAnnotationNote: e.hasAnnotationNote,
                isAnnotationNoteActive: e.isAnnotationNoteActive,
                onAnnotationNotePress: e.onAnnotationNotePress,
                disabled: !e.canEditAnnotationCP
              }),
              disabled: !e.canEditAnnotationCP,
              hidden: !e.showAnnotationNotes || n,
              type: "annotation-note"
            }],
            S = {
              "overlay-text": t.repeatOverlayText ? "redaction-text-repeating" : "redaction-text-single",
              "outline-color": "border-color"
            },
            E = {
              presentational: e.viewportWidth > Ne.GI,
              disabled: Boolean(s),
              className: h()(ac().button, ac().buttonNoBorder)
            };
          return d.createElement("div", {
            className: h()("PSPDFKit-Redaction-Annotation-Toolbar", ac().content)
          }, d.createElement(mc, {
            annotationToolbarItems: f,
            builtInItems: C,
            btnFocusRefIfFocusedItem: c,
            onGroupExpansion: e.onGroupExpansion,
            builtInToolbarProps: E,
            hasDesktopLayout: e.hasDesktopLayout,
            expandedGroup: s,
            onGroupTransitionEnded: e.onGroupTransitionEnded,
            position: b,
            typeMap: S
          }));
        });
        const wc = bc,
          xc = d.memo(function (e) {
            const {
                annotation: t,
                intl: n,
                position: r,
                expandedGroup: o,
                btnFocusRefIfFocusedGroup: i,
                btnFocusRefIfFocusedItem: a,
                canDeleteSelectedAnnotationCP: s,
                annotationToolbarItems: u
              } = e,
              c = (0, l.v9)(e => e.shadowRoot),
              p = (0, po.R9)(t => e.updateAnnotation(t, "stamp")),
              {
                formatMessage: f
              } = n,
              m = [{
                node: d.createElement(Qu.OpacityComponent, {
                  intl: n,
                  type: "Image",
                  styles: ac(),
                  annotation: t,
                  updateAnnotation: p,
                  caretDirection: "bottom" === r ? "up" : "down",
                  innerRef: i("opacity", !o),
                  shadowRoot: c
                }),
                title: f(ke.Z.opacity),
                type: "opacity",
                disabled: !e.canEditAnnotationCP,
                group: "opacity",
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(u),
                  title: f(ke.Z.delete),
                  className: h()("PSPDFKit-Stamp-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !s
                  }),
                  onPress: s ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                disabled: null === e.annotation.pageIndex
              }, {
                node: d.createElement(sc, {
                  intl: e.intl,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP
                }),
                type: "annotation-note",
                disabled: !e.showAnnotationNotes
              }];
            return d.createElement("div", {
              className: h()("PSPDFKit-Stamp-Annotation-Toolbar", ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: u,
              builtInItems: m,
              btnFocusRefIfFocusedItem: a,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: {
                className: ac().button
              },
              hasDesktopLayout: e.hasDesktopLayout,
              expandedGroup: o,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: r
            }));
          });
        const Dc = xc,
          Cc = d.memo(function (e) {
            const {
                annotation: t,
                intl: n,
                position: r,
                expandedGroup: o,
                btnFocusRefIfFocusedGroup: i,
                btnFocusRefIfFocusedItem: a,
                canDeleteSelectedAnnotationCP: s,
                annotationToolbarItems: u
              } = e,
              c = (0, l.v9)(e => e.shadowRoot),
              p = (0, po.R9)(t => e.updateAnnotation(t, "image")),
              {
                formatMessage: f
              } = n,
              m = [{
                node: d.createElement(Qu.OpacityComponent, {
                  intl: n,
                  type: "Image",
                  styles: ac(),
                  annotation: t,
                  updateAnnotation: p,
                  caretDirection: "bottom" === r ? "up" : "down",
                  innerRef: i("opacity", !o),
                  shadowRoot: c
                }),
                title: f(ke.Z.opacity),
                type: "opacity",
                group: "opacity",
                disabled: !e.canEditAnnotationCP,
                hidden: e.areOnlyElectronicSignaturesEnabled,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
              }, {
                node: d.createElement(Ju.Z, {
                  type: "counterclockwise",
                  title: f(ke.Z.rotateCounterclockwise),
                  className: `PSPDFKit-Image-Annotation-Toolbar-Button-Rotate PSPDFKit-Image-Annotation-Toolbar-Button-Rotate-Counterclockwise ${ac().button} ${ac().rotateButton}`,
                  onPress: () => {
                    e.selectedAnnotationPageSize && e.updateAnnotation((0, j.eJ)(e.annotation, e.selectedAnnotationPageSize, j.z1.COUNTERCLOCKWISE));
                  }
                }),
                type: "counterclockwise-rotation",
                disabled: !e.canEditAnnotationCP,
                hidden: e.areOnlyElectronicSignaturesEnabled
              }, {
                node: d.createElement(Ju.Z, {
                  type: "clockwise",
                  title: f(ke.Z.rotateClockwise),
                  className: `PSPDFKit-Image-Annotation-Toolbar-Button-Rotate PSPDFKit-Image-Annotation-Toolbar-Button-Rotate-Clockwise ${ac().button} ${ac().rotateButton}`,
                  onPress: () => {
                    e.selectedAnnotationPageSize && e.updateAnnotation((0, j.eJ)(e.annotation, e.selectedAnnotationPageSize, j.z1.CLOCKWISE));
                  }
                }),
                type: "clockwise-rotation",
                disabled: !e.canEditAnnotationCP,
                hidden: e.areOnlyElectronicSignaturesEnabled
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(u),
                  title: f(ke.Z.delete),
                  className: h()("PSPDFKit-Image-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !s
                  }),
                  onPress: s ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                hidden: null === e.annotation.pageIndex || !!o
              }, {
                node: d.createElement(sc, {
                  intl: e.intl,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP
                }),
                type: "annotation-note",
                hidden: !e.showAnnotationNotes || e.areOnlyElectronicSignaturesEnabled
              }];
            return d.createElement("div", {
              className: h()("PSPDFKit-Image-Annotation-Toolbar", ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: u,
              builtInItems: m,
              btnFocusRefIfFocusedItem: a,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: {
                className: ac().button
              },
              hasDesktopLayout: e.hasDesktopLayout,
              expandedGroup: o,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: r
            }));
          });
        const Sc = Cc;
        var Ec = n(68938),
          _c = n.n(Ec);
        const Pc = ["Tab", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
        class kc extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              keyboardFocus: !!this.props.lastToolbarActionUsedKeyboard
            }), (0, o.Z)(this, "_handleKeyUp", e => {
              Pc.includes(e.key) && this.setState({
                keyboardFocus: !0
              });
            }), (0, o.Z)(this, "_handlePointerUp", () => {
              this.setState({
                keyboardFocus: !1
              });
            }), (0, o.Z)(this, "shouldComponentUpdate", Pe.O);
          }
          componentDidMount() {
            var e;
            const t = null === (e = this.props.innerRef) || void 0 === e || null === (e = e.current) || void 0 === e ? void 0 : e.parentNode;
            t && t.focus();
          }
          render() {
            const {
                colorPresets: e,
                activeColor: t,
                innerRef: n
              } = this.props,
              {
                formatMessage: r
              } = this.props.intl;
            return this.props.colorPresets.length < 2 ? null : d.createElement("div", {
              className: h()("PSPDFKit-Input-ColorPicker", this.props.className, _c().root),
              role: "radiogroup",
              "aria-label": this.props.accessibilityLabel,
              onKeyUp: this._handleKeyUp,
              onPointerUp: this._handlePointerUp,
              onBlur: e => {
                e.currentTarget.contains(e.relatedTarget) || this.setState({
                  keyboardFocus: !1
                });
              }
            }, e.map((e, o) => {
              const a = e.color === t || e.color && t && e.color.equals(t),
                s = h()({
                  [_c().input]: !0,
                  [_c().inputIsActive]: a,
                  "PSPDFKit-Input-ColorPicker-Label": !0,
                  "PSPDFKit-Input-ColorPicker-Label-active": a,
                  [_c().focusRing]: this.state.keyboardFocus && a
                }),
                l = h()({
                  [_c().swatch]: !0,
                  [_c().swatchIsTransparent]: !e.color,
                  [_c().swatchIsWhite]: !e.color || e.color.equals(_.Il.WHITE),
                  "PSPDFKit-Input-ColorPicker-Swatch": !0
                }),
                u = e.color ? e.color.toCSSValue() : null;
              let c = e.localization.defaultMessage;
              null != u && (e.localization.id ? c = r(e.localization) : null != ke.Z[u] && (c = r(ke.Z[u])));
              const p = e.color && e.color.toCSSValue();
              return d.createElement("label", {
                className: s,
                key: o,
                title: c,
                "aria-label": c
              }, d.createElement("span", {
                className: l,
                style: {
                  backgroundColor: p || "transparent"
                }
              }), d.createElement(i.TX, null, " ", c, " "), d.createElement(i.TX, {
                tag: "input",
                type: "radio",
                name: _c().root,
                value: o,
                checked: !!a,
                onChange: t => {
                  t.target.checked && this.props.onClick(e.color);
                },
                ref: a && n ? n : void 0
              }));
            }));
          }
        }
        (0, o.Z)(kc, "defaultProps", {
          className: ""
        });
        const Ac = (0, xe.XN)(kc);
        var zc = n(3792);
        const Tc = d.forwardRef(function (e, t) {
            let {
              value: n = "normal",
              onChange: r,
              className: o,
              caretDirection: i,
              frameWindow: a
            } = e;
            const {
                formatMessage: s
              } = (0, xe.YB)(),
              l = Object.keys(zc.b).map(e => ({
                value: e,
                label: e
              })),
              u = d.useCallback(Oc(s, i), [s, i]),
              c = d.useCallback(Ic(s), [s]);
            return d.createElement(d.Fragment, null, d.createElement(_u.Z, {
              items: l,
              value: {
                label: n,
                value: n
              },
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: i,
              accessibilityLabel: s(ke.Z.blendMode),
              className: h()(ac().blendModeSelect, o, "PSPDFKit-Toolbar-DropdownGroup", "PSPDFKit-Toolbar-DropdownGroup-Toolbar"),
              menuClassName: ac().dropdownMenu,
              ButtonComponent: u,
              ItemComponent: c,
              onSelect: (e, t) => {
                if (t.value) {
                  const e = zc.b[t.value];
                  r(e);
                }
              },
              frameWindow: a,
              ref: t
            }), d.createElement("div", {
              className: h()(ac().fontSizeNativeFlexbox)
            }, d.createElement("div", {
              className: ac().nativeDropdown
            }, d.createElement("select", {
              "aria-label": s(ke.Z.blendMode),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: n,
              onChange: e => {
                if (void 0 !== e.target.value) {
                  const t = zc.b[e.target.value];
                  r(t);
                }
              },
              ref: t
            }, l.map(e => d.createElement("option", {
              key: e.value,
              value: e.value,
              disabled: e.disabled
            }, s(Fc[e.label])))))));
          }),
          Oc = (e, t) => n => {
            let {
              btnComponentProps: r,
              selectedItem: o
            } = n;
            return d.createElement(we.Z, (0, ce.Z)({
              is: "div"
            }, r, {
              ref: r.ref,
              className: h()("PSPDFKit-Input-Dropdown-Button ", Ou().selectBox, ac().selectBox),
              style: {
                minWidth: "100px"
              }
            }), d.createElement("span", null, null != o && o.label ? e(Fc[o.label]) : null), d.createElement("div", null, (0, Ae.Z)({
              type: "caret-" + t,
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: h()(Ou().dropdownIcon)
            })));
          },
          Ic = e => t => {
            let {
              item: n,
              state: r,
              itemComponentProps: o,
              ref: i
            } = t;
            return d.createElement(we.Z, (0, ce.Z)({
              is: "div",
              ref: i,
              className: h()(Ou().item, {
                [Ou().isSelected]: (null == r ? void 0 : r.includes("selected")) || (null == r ? void 0 : r.includes("focused"))
              }),
              name: null == n ? void 0 : n.label
            }, o), null != n && n.label ? e(Fc[n.label]) : null);
          },
          Fc = (0, xe.vU)({
            normal: {
              id: "normal",
              defaultMessage: "Normal",
              description: "Blend Mode Normal"
            },
            multiply: {
              id: "multiply",
              defaultMessage: "Multiply",
              description: "Blend Mode Multiply"
            },
            screen: {
              id: "screenBlend",
              defaultMessage: "Screen",
              description: "Blend Mode Screen"
            },
            overlay: {
              id: "overlay",
              defaultMessage: "Overlay",
              description: "Blend Mode Overlay"
            },
            darken: {
              id: "darken",
              defaultMessage: "Darken",
              description: "Blend Mode Darken"
            },
            lighten: {
              id: "lighten",
              defaultMessage: "Lighten",
              description: "Blend Mode Lighten"
            },
            colorDodge: {
              id: "colorDodge",
              defaultMessage: "Color Dodge",
              description: "Blend Mode Color Dodge"
            },
            colorBurn: {
              id: "colorBurn",
              defaultMessage: "Color Burn",
              description: "Blend Mode Color Burn"
            },
            hardLight: {
              id: "hardLight",
              defaultMessage: "Hard Light",
              description: "Blend Mode Hard Light"
            },
            softLight: {
              id: "softLight",
              defaultMessage: "Soft Light",
              description: "Blend Mode Soft Light"
            },
            difference: {
              id: "difference",
              defaultMessage: "Difference",
              description: "Blend Mode Difference"
            },
            exclusion: {
              id: "exclusion",
              defaultMessage: "Exclusion",
              description: "Blend Mode Exclusion"
            },
            hue: {
              id: "hue",
              defaultMessage: "Hue",
              description: "Blend Mode Hue"
            },
            saturation: {
              id: "saturation",
              defaultMessage: "Saturation",
              description: "Blend Mode Saturation"
            },
            color: {
              id: "color",
              defaultMessage: "Color",
              description: "Blend Mode Color"
            },
            luminosity: {
              id: "luminosity",
              defaultMessage: "Luminosity",
              description: "Blend Mode Luminosity"
            }
          }),
          Mc = d.memo(function (e) {
            const t = (0, po.R9)(t => {
                const {
                  annotation: n,
                  isEditing: r,
                  dispatch: o,
                  variantAnnotationPresetID: i,
                  canEditAnnotationCP: a
                } = e;
                if (a) if (n.rects.size > 0 && r) o((0, yt.gX)(t)), o((0, Kt.d5)()), o((0, _e.vR)());else {
                  const r = i || Y.hD.get(n.constructor);
                  e.updateAnnotation(t, r);
                }
              }),
              {
                position: n,
                annotation: r,
                expandedGroup: o,
                btnFocusRefIfFocusedGroup: i,
                btnFocusRefIfFocusedItem: a,
                canDeleteSelectedAnnotationCP: s,
                lastToolbarActionUsedKeyboard: u,
                annotationToolbarItems: c
              } = e,
              p = (0, l.v9)(e => e.shadowRoot),
              {
                formatMessage: f
              } = e.intl,
              m = it.Options.TEXT_MARKUP_COLOR_PRESETS,
              g = it.Options.HIGHLIGHT_COLOR_PRESETS,
              v = r instanceof _.FV ? g : m,
              y = [{
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(Ac, {
                  className: "PSPDFKit-Text-Markup-Annotation-Toolbar-Color",
                  accessibilityLabel: f(ke.Z.color),
                  colorPresets: v,
                  activeColor: r.color,
                  onClick: e => t({
                    color: e
                  }),
                  innerRef: i("color", !o),
                  lastToolbarActionUsedKeyboard: u
                }))),
                title: f(ke.Z.color),
                group: "color",
                type: "color",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Color")
              }, {
                node: d.createElement(Qu.OpacityComponent, {
                  intl: e.intl,
                  type: "Text-Markup",
                  styles: ac(),
                  annotation: r,
                  updateAnnotation: e => t(e),
                  caretDirection: "bottom" === n ? "up" : "down",
                  innerRef: i("opacity"),
                  shadowRoot: p
                }),
                title: f(ke.Z.opacity),
                group: "opacity",
                type: "opacity",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
              }, {
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(Tc, {
                  value: r.blendMode,
                  className: "PSPDFKit-Text-Markup-Annotation-Toolbar-Blend-Mode",
                  onChange: e => t({
                    blendMode: e
                  }),
                  caretDirection: "bottom" === n ? "up" : "down",
                  frameWindow: e.frameWindow,
                  ref: i("blendMode")
                }))),
                title: f(ke.Z.blendMode),
                group: "blendMode",
                type: "blend-mode",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-BlendMode")
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(c),
                  title: f(ke.Z.delete),
                  className: h()("PSPDFKit-Text-Markup-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !s
                  }),
                  onPress: s ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                hidden: null === e.annotation.pageIndex || !!o || e.isEditing
              }, {
                node: d.createElement(sc, {
                  intl: e.intl,
                  isEditing: e.isEditing,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP
                }),
                type: "annotation-note",
                hidden: !e.showAnnotationNotes || e.isEditing
              }],
              b = {
                className: ac().button,
                presentational: e.viewportWidth >= Ne.GI,
                disabled: !!o
              };
            return d.createElement("div", {
              className: h()("PSPDFKit-Text-Markup-Annotation-Toolbar", ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: c,
              builtInItems: y,
              btnFocusRefIfFocusedItem: a,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: b,
              hasDesktopLayout: e.hasDesktopLayout,
              expandedGroup: o,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: n,
              typeMap: {
                color: "border-color"
              }
            }));
          });
        const Rc = Mc;
        var jc = n(4345),
          Bc = n(13538),
          Nc = n(8087),
          Lc = n.n(Nc),
          Vc = n(79579),
          Kc = n.n(Vc);
        const qc = e => {
            let {
              item: t,
              state: n,
              itemComponentProps: r,
              ref: o
            } = e;
            return d.createElement(Hc, {
              item: t,
              state: n,
              fontFamily: void 0,
              itemComponentProps: r,
              ref: o
            });
          },
          Hc = d.forwardRef((e, t) => {
            var n;
            let {
              item: r,
              state: o,
              fontFamily: i,
              itemComponentProps: a,
              width: s
            } = e;
            return d.createElement(we.Z, (0, ce.Z)({
              is: "div",
              className: h()(Ou().item, Lc().item, {
                [Ou().isSelected]: (null == o ? void 0 : o.includes("selected")) || (null == o ? void 0 : o.includes("focused"))
              }),
              name: null !== (n = null == r ? void 0 : r.value) && void 0 !== n ? n : null == r ? void 0 : r.label,
              style: {
                fontFamily: i,
                width: s
              },
              ref: t
            }, a), null != o && o.includes("selected") ? d.createElement(je.Z, {
              src: Kc(),
              className: Lc().icon
            }) : d.createElement("span", {
              className: Lc().icon
            }), null == r ? void 0 : r.label);
          }),
          Uc = e => function (t) {
            var n;
            let {
              btnComponentProps: r,
              selectedItem: o,
              caretDirection: a,
              disabled: s,
              isOpen: l
            } = t;
            const u = d.useRef(),
              {
                formatMessage: c
              } = (0, xe.YB)();
            d.useLayoutEffect(() => {
              u.current && (u.current.value = (null == o ? void 0 : o.label) || "");
            }, [o]);
            const p = d.useCallback(() => {
              var t;
              const n = null === (t = u.current) || void 0 === t ? void 0 : t.value;
              if (n && u.current && n !== (null == o ? void 0 : o.label)) {
                const t = parseFloat(n);
                var r, i, a;
                if (Number.isNaN(t)) u.current.value = null !== (r = null == o ? void 0 : o.label) && void 0 !== r ? r : "";else e({
                  selectedItem: {
                    label: null !== (i = t.toString()) && void 0 !== i ? i : "",
                    value: null !== (a = t.toString()) && void 0 !== a ? a : ""
                  },
                  preventFocusShift: !1
                });
              }
            }, [null == o ? void 0 : o.label]);
            return d.createElement("div", {
              className: h()(Lc().wrapper)
            }, d.createElement(oc, {
              accessibilityLabel: c(ke.Z.fontSize),
              className: Lc().textInput,
              onBlur: p,
              onKeyDown: t => {
                var n, r;
                const o = null !== (n = null === (r = u.current) || void 0 === r ? void 0 : r.value) && void 0 !== n ? n : "0";
                if ("ArrowUp" === t.key) {
                  var i, a;
                  const t = parseFloat(o) + 1;
                  e({
                    selectedItem: {
                      label: null !== (i = t.toString()) && void 0 !== i ? i : "",
                      value: null !== (a = t.toString()) && void 0 !== a ? a : ""
                    },
                    preventFocusShift: !0
                  });
                } else if ("ArrowDown" === t.key) {
                  var s, l;
                  const t = Math.max(0, parseFloat(o) - 1);
                  e({
                    selectedItem: {
                      label: null !== (s = t.toString()) && void 0 !== s ? s : "",
                      value: null !== (l = t.toString()) && void 0 !== l ? l : ""
                    },
                    preventFocusShift: !0
                  });
                } else "Enter" === t.key && (t.preventDefault(), p());
              },
              onFocus: () => {
                De.G6 && setTimeout(() => {
                  u.current && u.current.setSelectionRange(0, u.current.value.length);
                }, 100);
              },
              name: "fontSize",
              styles: {
                input: h()({
                  [Lc().inputDisabled]: s
                }, Lc().textInputField)
              },
              disabled: s,
              ref: u,
              autoFocus: !1
            }), d.createElement("button", (0, ce.Z)({}, r, {
              ref: r.ref,
              key: null !== (n = null == o ? void 0 : o.value) && void 0 !== n ? n : null == o ? void 0 : o.label,
              className: h()("PSPDFKit-Input-Dropdown-Button", Ou().selectBox, Lc().arrowDropdownBtn, Lc().fontSizeDropdownBtn, {
                [Lc().inputDisabled]: s,
                [Ou().disabled]: s
              }),
              disabled: s
            }), d.createElement(i.TX, null, c(ke.Z.fontSize)), d.createElement("div", null, (0, Ae.Z)({
              type: `caret-${a}`,
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: h()(Ou().dropdownIcon, {
                [Ou().isOpen]: l
              })
            }))));
          },
          Zc = function (e) {
            const {
              disabled: t = !1
            } = e;
            return d.createElement(_u.Z, {
              frameWindow: e.frameWindow,
              items: e.items,
              value: e.value,
              className: e.className,
              maxCols: 1,
              isActive: !1,
              caretDirection: e.caretDirection,
              disabled: t,
              menuClassName: h()(e.menuClass, Lc().dropdownMenu),
              ButtonComponent: Uc(e.onSelect),
              ItemComponent: qc,
              onSelect: (t, n) => {
                e.onSelect({
                  selectedItem: n,
                  preventFocusShift: !1
                });
              },
              menuPositionOffsets: {
                top: -1
              }
            });
          },
          $c = d.forwardRef(function (e, t) {
            var r, o;
            const {
                caretDirection: a,
                onChange: s,
                frameWindow: l,
                intl: u,
                styles: c,
                fontSizes: p,
                fontFamilyItems: f,
                isBold: m = !1,
                isItalic: g = !1,
                isUnderline: v = !1,
                currentFontFamily: y,
                currentFontSize: b,
                currentHorizontalAlign: w,
                currentVerticalAlign: x,
                showAlignmentOptions: D,
                showFontStyleOptions: C,
                disabled: S = !1,
                showUnderline: E = !1
              } = e,
              {
                formatMessage: _
              } = u,
              P = d.useCallback(Yc(150, a, c, S, c.fontFamily), [a, c, S]),
              k = p.map(e => ({
                label: e.toString(),
                value: e.toString(),
                disabled: !1
              })),
              A = f.map(e => {
                var t, n;
                return d.createElement("option", {
                  key: null !== (t = e.value) && void 0 !== t ? t : e.label,
                  value: null !== (n = e.value) && void 0 !== n ? n : e.label,
                  disabled: e.disabled
                }, e.label);
              });
            return d.createElement("div", {
              className: c.controlWrapper
            }, d.createElement("div", {
              className: h()(c.control, c.textFormatControls)
            }, d.createElement("div", {
              className: h()(c.fontFamilyNativeFlexbox)
            }, d.createElement("div", {
              className: c.nativeDropdown
            }, d.createElement("select", {
              "aria-label": _(ke.Z.font),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: null != y ? y : "",
              onChange: e => {
                void 0 !== e.target.value && s({
                  modification: {
                    font: e.target.value
                  }
                });
              },
              ref: t,
              disabled: S
            }, A, f.some(e => e.value === y) ? null : d.createElement("option", {
              style: {
                display: "none"
              }
            }, y)))), d.createElement(_u.Z, {
              items: f,
              value: y ? {
                label: y,
                value: y
              } : null,
              accessibilityLabel: _(ke.Z.font),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: a,
              className: h()(e.fontFamilyClasses, c.fontFamilySelect),
              menuClassName: h()(c.dropdownMenu, e.fontFamilyMenuClasses),
              ButtonComponent: P,
              ItemComponent: Wc,
              onSelect: (e, t) => {
                null != t.value && s({
                  modification: {
                    font: t.value
                  }
                });
              },
              frameWindow: l,
              disabled: S
            }), d.createElement(Zc, {
              items: k,
              value: {
                label: b ? b.toString() : "",
                value: (null != b ? b : "").toString() || ""
              },
              frameWindow: l,
              className: h()(c.fontSizeSelect, e.fontSizeClasses),
              menuClass: h()(e.fontSizeMenuClasses),
              caretDirection: a,
              disabled: S,
              onSelect: e => {
                let {
                  selectedItem: t,
                  preventFocusShift: n
                } = e;
                null != t.value && s({
                  modification: {
                    fontSize: Number(t.value)
                  },
                  preventFocusShift: n
                });
              }
            }), C ? d.createElement(d.Fragment, null, d.createElement(i.zx, {
              className: h()(c.fontStyleBtn, c.fontStyleBtnBorderless, {
                [c.activeFontStyleBtn]: m
              }),
              style: {
                marginRight: 8
              },
              title: _(ke.Z.bold),
              onClick: () => {
                s({
                  modification: {
                    bold: !m
                  }
                });
              },
              disabled: S,
              "aria-pressed": m
            }, d.createElement(je.Z, {
              src: n(6274)
            }), d.createElement(i.TX, null, _(ke.Z.bold))), d.createElement(i.zx, {
              className: h()(c.fontStyleBtn, c.fontStyleBtnBorderless, {
                [c.activeFontStyleBtn]: g
              }),
              onClick: () => {
                s({
                  modification: {
                    italic: !g
                  }
                });
              },
              disabled: S,
              title: _(ke.Z.italic),
              "aria-pressed": g
            }, d.createElement(je.Z, {
              src: n(66311)
            }), d.createElement(i.TX, null, _(ke.Z.italic))), E && d.createElement(i.zx, {
              className: h()(c.fontStyleBtn, c.fontStyleBtnBorderless, {
                [c.activeFontStyleBtn]: v
              }),
              style: {
                marginLeft: 8
              },
              onClick: () => {
                s({
                  modification: {
                    underline: !v
                  }
                });
              },
              disabled: S,
              title: _(ke.Z.underline),
              "aria-pressed": v
            }, d.createElement(je.Z, {
              src: n(1438)
            }), d.createElement(i.TX, null, _(ke.Z.underline)))) : null, D ? d.createElement(d.Fragment, null, d.createElement("span", {
              className: c.radioGroupWrapper
            }, d.createElement(i.Ee, {
              inputName: "horizontalAlign",
              label: _(ke.Z.horizontalAlignment),
              selectedOption: null != w ? w : "",
              labelClassNamePrefix: null !== (r = e.horizontalAlignClasses) && void 0 !== r ? r : "",
              options: ["left", "center", "right"].map(e => ({
                value: e,
                label: _(ke.Z[`alignment${(0, gn.kC)(e)}`]),
                iconPath: n(58758)(`./text-align-horizontal-${e}.svg`)
              })),
              onChange: e => s({
                modification: {
                  horizontalAlign: e
                }
              }),
              disabled: S
            })), d.createElement(i.Ee, {
              inputName: "verticalAlign",
              label: _(ke.Z.verticalAlignment),
              selectedOption: null != x ? x : "",
              labelClassNamePrefix: null !== (o = e.verticalAlignClasses) && void 0 !== o ? o : "",
              options: ["top", "center", "bottom"].map(e => ({
                value: e,
                label: _(ke.Z["center" === e ? "alignmentCenter" : e]),
                iconPath: n(29712)(`./text-align-vertical-${e}.svg`)
              })),
              onChange: e => s({
                modification: {
                  verticalAlign: e
                }
              }),
              disabled: S
            })) : null));
          }),
          Gc = d.forwardRef((e, t) => {
            var n;
            let {
              item: r,
              state: o,
              fontFamily: i,
              itemComponentProps: a,
              width: s
            } = e;
            return d.createElement(we.Z, (0, ce.Z)({
              is: "div",
              className: h()(Ou().item, {
                [Ou().isSelected]: (null == o ? void 0 : o.includes("selected")) || (null == o ? void 0 : o.includes("focused"))
              }),
              name: null !== (n = null == r ? void 0 : r.value) && void 0 !== n ? n : null == r ? void 0 : r.label,
              style: {
                fontFamily: i,
                width: s
              },
              ref: t
            }, a), null == r ? void 0 : r.label);
          }),
          Wc = e => {
            let {
              item: t,
              state: n,
              itemComponentProps: r
            } = e;
            return d.createElement(Gc, {
              item: t,
              state: n,
              fontFamily: null == t ? void 0 : t.label,
              itemComponentProps: r
            });
          },
          Yc = (e, t, n, r, o) => i => {
            var a;
            let {
              btnComponentProps: s,
              selectedItem: l
            } = i;
            return d.createElement("button", (0, ce.Z)({}, s, {
              ref: s.ref,
              key: null !== (a = null == l ? void 0 : l.value) && void 0 !== a ? a : null == l ? void 0 : l.label,
              className: h()("PSPDFKit-Input-Dropdown-Button", Ou().selectBox, n.selectBox, {
                [ku().isDisabled]: r,
                [n.controlIsDisabled]: r,
                [Ou().disabled]: r
              }),
              style: {
                width: e
              },
              disabled: r
            }), d.createElement("span", {
              className: o
            }, null == l ? void 0 : l.label), d.createElement("div", null, (0, Ae.Z)({
              type: `caret-${t}`,
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: h()(Ou().dropdownIcon)
            })));
          };
        var Xc = n(17448),
          Qc = n.n(Xc);
        function Jc(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ed(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Jc(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Jc(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const td = d.forwardRef(function (e, t) {
          const {
              annotation: n,
              caretDirection: r,
              onChange: o,
              frameWindow: i,
              intl: a,
              styles: s,
              showInlineFontStyles: l = !0,
              customFontsReadableNames: u
            } = e,
            {
              formatMessage: c
            } = a,
            {
              fontSizePresets: p
            } = Bc.default,
            h = Math.round(n.fontSize),
            f = -1 === p.indexOf(h) ? p.concat(h).sort((e, t) => e - t) : p,
            m = vs.vt.toArray().map(e => ({
              label: e,
              value: e
            })),
            g = m.concat(u.toArray().map(e => ({
              label: e,
              value: e
            })).filter(e => !m.some(t => t.value === e.value)));
          if (!vs.vt.has(n.font) && !u.has(n.font) && "" !== n.font.trim()) {
            const e = c(ke.Z.fontFamilyUnsupported, {
              arg0: n.font
            });
            g.push({
              label: e,
              value: e,
              disabled: !0
            });
          }
          return d.createElement($c, {
            onChange: e => {
              let {
                modification: t
              } = e;
              return o(t);
            },
            caretDirection: r,
            frameWindow: i,
            ref: t,
            intl: a,
            styles: ed(ed({}, s), {}, {
              fontStyleBtn: Qc().fontStyleBtn,
              fontStyleBtnBorderless: Qc().fontStyleBtnBorderless,
              activeFontStyleBtn: Qc().activeFontStyleBtn
            }),
            fontSizes: f,
            fontFamilyItems: g,
            showAlignmentOptions: !0,
            showFontStyleOptions: l,
            showUnderline: l,
            isBold: e.selectedIsBold,
            isItalic: e.selectedIsItalic,
            isUnderline: e.selectedIsUnderline,
            currentFontFamily: n.font,
            currentFontSize: h,
            currentHorizontalAlign: n.horizontalAlign,
            currentVerticalAlign: n.verticalAlign,
            fontFamilyClasses: "PSPDFKit-Text-Annotation-Toolbar-Font-Family",
            fontSizeClasses: "PSPDFKit-Text-Annotation-Toolbar-Font-Size",
            horizontalAlignClasses: "PSPDFKit-Text-Annotation-Toolbar-Alignment",
            verticalAlignClasses: "PSPDFKit-Text-Annotation-Toolbar-Vertical-Alignment",
            inlineStyleClasses: "PSPDFKit-Text-Annotation-Toolbar-Inline-Style"
          });
        });
        function nd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function rd(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? nd(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const od = new _.Il({
          r: .5,
          g: .5,
          b: .5
        });
        function id(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ad(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? id(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : id(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const sd = d.memo(function (e) {
          var t;
          const n = d.useRef(null),
            r = (0, l.v9)(e => e.shadowRoot),
            o = "xhtml" === e.annotation.text.format,
            a = (0, po.R9)(t => {
              if (!e.canEditAnnotationCP) return;
              let n = e.annotation.merge(t);
              if ((0, j.Vc)(n)) e.updateAnnotation(t);else if (e.selectedAnnotationPageSize && (t.fontSize || t.font || t.text && "xhtml" === t.text.format)) {
                const {
                  rotation: o
                } = n;
                let i = (0, qe.h4)(n);
                const a = i.boundingBox.getCenter();
                i = (0, pn.Zv)(i.set("rotation", 0), e.selectedAnnotationPageSize, e.zoomLevel, r), i = (0, pn.XA)(i, e.zoomLevel);
                const s = new _.E9({
                    x: i.boundingBox.getCenter().x - a.x,
                    y: i.boundingBox.getCenter().y - a.y
                  }),
                  l = s.rotate(o),
                  u = new _.E9({
                    x: l.x - s.x,
                    y: l.y - s.y
                  });
                i = i.update("boundingBox", e => null == e ? void 0 : e.translate(u)), n = (0, qe.az)(i.set("rotation", o)), e.updateAnnotation(ad(ad({}, t), {}, {
                  isFitting: n.isFitting,
                  boundingBox: n.boundingBox
                }));
              } else {
                const {
                  isFitting: r
                } = (0, pn.XA)((0, qe.h4)(n).set("rotation", 0), e.zoomLevel);
                e.updateAnnotation(ad(ad({}, t), {}, {
                  isFitting: r
                }));
              }
              e.richTextEditorRef && jc.F3.focus(e.richTextEditorRef);
            }),
            {
              activeTextStyle: s,
              updateAnnotationOrEditorText: u,
              selectedIsUnderline: c,
              selectedIsBold: p,
              selectedIsItalic: f
            } = function (e) {
              let {
                editor: t,
                frameWindow: n,
                updateAnnotation: r,
                text: o,
                isRichText: a
              } = e;
              const [s, l] = (0, d.useState)(null),
                [u, c] = (0, d.useState)(!1),
                [p, h] = (0, d.useState)(!1),
                [f, m] = (0, d.useState)(!1),
                g = (0, d.useCallback)(() => {
                  t && (c(i.ri.isMarkActive(t, "bold")), h(i.ri.isMarkActive(t, "italic")), m(i.ri.isMarkActive(t, "underline")));
                }, [t]),
                v = (0, d.useCallback)(() => {
                  if (!t || !a) return;
                  const e = (0, gn.BK)(i.ri.getSelectedNodesColor(t, "fontColor")),
                    n = (0, gn.BK)(i.ri.getSelectedNodesColor(t, "backgroundColor"));
                  l({
                    fontColor: e ? _.Il.fromHex(e) : od,
                    backgroundColor: n ? _.Il.fromHex(n) : null
                  }), g();
                }, [t, g, a]);
              t && (t.onSelectionChange = v, t.onValueChange = () => {
                g(), v();
              }), (0, d.useEffect)(() => {
                var e;
                if (a && t) return null === (e = n.document) || void 0 === e || e.addEventListener("keydown", r), () => {
                  var e;
                  null === (e = n.document) || void 0 === e || e.removeEventListener("keydown", r);
                };
                function r(e) {
                  t && (!e.ctrlKey && !e.metaKey || "u" !== e.key && "i" !== e.key && "b" !== e.key || g());
                }
              }, [t, n, a, g]);
              const y = (0, d.useCallback)(e => {
                const a = new Map(Object.entries(e)),
                  s = a.has("fontColor") || a.has("backgroundColor"),
                  u = a.has("bold") || a.has("italic") || a.has("underline");
                if (s) {
                  const a = e.fontColor ? "fontColor" : "backgroundColor";
                  var d, p;
                  if (i.ri.isRangeSelected(t)) i.ri.applyStyle(t, a, !e[a] || null !== (d = e[a]) && void 0 !== d && d.equals(_.Il.TRANSPARENT) ? null : e[a].toHex()), r({
                    text: {
                      format: "xhtml",
                      value: i.ri.serialize(null == t ? void 0 : t.children[0])
                    }
                  }), l(t => rd(rd({}, t), {}, {
                    [a]: e[a]
                  })), null === (p = n.getSelection()) || void 0 === p || p.removeAllRanges();else if ("fontColor" === a) {
                    const t = i.ri.setStyleOrToggleFormat(o, a, e[a].toHex());
                    r({
                      text: {
                        format: "xhtml",
                        value: t
                      },
                      fontColor: e.fontColor
                    });
                  } else l({
                    backgroundColor: e.backgroundColor
                  }), r(e);
                } else if (u) {
                  const n = Object.keys(e)[0];
                  if (t && i.ri.isRangeSelected(t)) {
                    switch (i.ri.toggleMark(t, n), n) {
                      case "bold":
                        c(e.bold);
                        break;
                      case "italic":
                        h(e.italic);
                        break;
                      case "underline":
                        m(e.underline);
                    }
                    r({
                      text: {
                        format: "xhtml",
                        value: i.ri.serialize(null == t ? void 0 : t.children[0])
                      }
                    });
                  } else {
                    const e = i.ri.setStyleOrToggleFormat(o, n);
                    r({
                      text: {
                        format: "xhtml",
                        value: e
                      }
                    });
                  }
                } else r(e);
              }, [r, o, t, n]);
              if (a) {
                if (t) return {
                  activeTextStyle: s,
                  updateAnnotationOrEditorText: y,
                  selectedIsBold: u,
                  selectedIsItalic: p,
                  selectedIsUnderline: f
                };
                {
                  const {
                    fontColor: e,
                    isUnderlined: t,
                    isItalic: n,
                    isBold: r
                  } = i.ri.getComputedStyleAll(o);
                  return {
                    activeTextStyle: {
                      fontColor: e ? _.Il.fromHex(e) : void 0,
                      backgroundColor: null == s ? void 0 : s.backgroundColor
                    },
                    updateAnnotationOrEditorText: y,
                    selectedIsBold: r,
                    selectedIsItalic: n,
                    selectedIsUnderline: t
                  };
                }
              }
              return {
                updateAnnotationOrEditorText: r
              };
            }({
              editor: e.richTextEditorRef,
              frameWindow: e.frameWindow,
              updateAnnotation: a,
              text: (null === (t = e.annotation.text) || void 0 === t ? void 0 : t.value) || "",
              isRichText: o
            }),
            {
              annotation: m,
              position: g,
              intl: v,
              expandedGroup: y,
              btnFocusRefIfFocusedGroup: b,
              canDeleteSelectedAnnotationCP: w,
              keepSelectedTool: x,
              interactionMode: D,
              annotationToolbarColorPresets: C
            } = e,
            {
              formatMessage: S
            } = v,
            E = "bottom" === g ? "up" : "down",
            P = {
              onChange: u,
              annotation: m,
              styles: ac(),
              intl: v,
              caretDirection: E
            },
            k = x && D === B.A.TEXT,
            A = [{
              node: d.createElement("div", {
                className: ac().controlWrapper
              }, d.createElement("div", {
                className: ac().control
              }, d.createElement(ec.Z, (0, ce.Z)({}, P, {
                record: o ? ad(ad({}, s), {}, {
                  opacity: m.opacity
                }) : m,
                colorProperty: "fontColor",
                className: "PSPDFKit-Text-Annotation-Toolbar-Font-Color",
                removeTransparent: !0,
                frameWindow: e.frameWindow,
                accessibilityLabel: S(ke.Z.color),
                innerRef: b("color"),
                annotationToolbarColorPresets: C
              })))),
              title: S(ke.Z.color),
              type: "color",
              group: "color",
              disabled: !e.canEditAnnotationCP,
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-TextColor")
            }, {
              node: d.createElement("div", {
                className: ac().controlWrapper
              }, d.createElement("div", {
                className: ac().control
              }, d.createElement(ec.Z, (0, ce.Z)({}, P, {
                record: o ? ad(ad({}, s), {}, {
                  opacity: m.opacity
                }, !e.richTextEditorRef && {
                  backgroundColor: m.backgroundColor
                }) : m,
                colorProperty: "backgroundColor",
                className: "PSPDFKit-Text-Annotation-Toolbar-Background-Color",
                frameWindow: e.frameWindow,
                accessibilityLabel: S(ke.Z.fillColor),
                innerRef: b("backgroundColor"),
                annotationToolbarColorPresets: C
              })))),
              title: S(ke.Z.fillColor),
              type: "background-color",
              group: "backgroundColor",
              disabled: !e.canEditAnnotationCP,
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-FillColor")
            }, D === B.A.CALLOUT || (0, j.Vc)(m) ? {
              node: d.createElement("div", {
                className: ac().controlWrapper
              }, d.createElement("div", {
                className: ac().control
              }, d.createElement(ec.Z, (0, ce.Z)({}, P, {
                record: m,
                colorProperty: "borderColor",
                className: "PSPDFKit-Text-Annotation-Toolbar-Border-Color",
                frameWindow: e.frameWindow,
                accessibilityLabel: S(ke.Z.borderColor),
                innerRef: b("borderColor"),
                annotationToolbarColorPresets: C
              })))),
              title: S(ke.Z.borderColor),
              type: "border-color",
              group: "borderColor",
              disabled: !e.canEditAnnotationCP,
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-BorderColor")
            } : null, {
              node: d.createElement(Qu.OpacityComponent, {
                intl: e.intl,
                type: "Text",
                styles: ac(),
                annotation: m,
                updateAnnotation: a,
                caretDirection: E,
                innerRef: b("opacity"),
                shadowRoot: r
              }),
              title: S(ke.Z.opacity),
              type: "opacity",
              group: "opacity",
              disabled: !e.canEditAnnotationCP,
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
            }, {
              node: d.createElement(td, (0, ce.Z)({}, P, {
                frameWindow: e.frameWindow,
                ref: b("font"),
                selectedIsBold: p,
                selectedIsItalic: f,
                selectedIsUnderline: c,
                showInlineFontStyles: o,
                customFontsReadableNames: e.customFontsReadableNames
              })),
              title: S(ke.Z.font),
              type: "font",
              group: "font",
              disabled: !e.canEditAnnotationCP,
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Font")
            }, {
              node: d.createElement(Ju.Z, {
                type: "delete",
                icon: (0, gc.KT)(e.annotationToolbarItems),
                title: S(ke.Z.delete),
                className: h()("PSPDFKit-Text-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                  [ac().disabledButton]: !w
                }),
                onPress: w ? () => e.deleteAnnotation() : () => {}
              }),
              type: "delete",
              hidden: k || null === e.annotation.pageIndex || !!y,
              disabled: !e.canDeleteSelectedAnnotationCP
            }].filter(Boolean),
            z = {
              className: ac().button,
              presentational: e.viewportWidth > Ne.GI,
              disabled: !!y
            };
          return d.createElement("div", {
            ref: n,
            className: h()("PSPDFKit-Text-Annotation-Toolbar", ac().content)
          }, d.createElement(mc, {
            annotationToolbarItems: e.annotationToolbarItems,
            builtInItems: A,
            btnFocusRefIfFocusedItem: e.btnFocusRefIfFocusedItem,
            onGroupExpansion: e.onGroupExpansion,
            hasDesktopLayout: e.hasDesktopLayout,
            expandedGroup: e.expandedGroup,
            builtInToolbarProps: z,
            onGroupTransitionEnded: e.onGroupTransitionEnded,
            position: e.position,
            typeMap: {
              color: "text-color",
              "background-color": "fill-color",
              "border-color": "stroke-color"
            }
          }));
        });
        const ld = sd,
          ud = d.forwardRef(function (e, t) {
            const {
                annotation: n,
                updateAnnotation: r,
                intl: o
              } = e,
              {
                formatMessage: a
              } = o,
              [s, l] = d.useState(!1),
              u = d.useCallback(e => {
                "Tab" === e.key && l(!0);
              }, [l]),
              c = d.useCallback(() => {
                l(!1);
              }, [l]);
            return d.createElement("div", {
              className: ac().controlWrapper
            }, d.createElement("div", {
              className: `${ac().control} PSPDFKit-Note-Annotation-Toolbar-Icons`,
              role: "radiogroup",
              "aria-label": a(ke.Z.icon),
              onKeyUp: u,
              onPointerUp: c,
              onBlur: e => {
                e.currentTarget.contains(e.relatedTarget) || l(!1);
              }
            }, Object.keys(bt.Zi).map((e, o) => {
              const l = bt.Y4[e],
                u = (0, F.Oe)(l),
                c = n.icon === e,
                p = h()(zu().root, ac().noteIconLabel, ac().button, ac().icon, "PSPDFKit-Tool-Button", c && "PSPDFKit-Tool-Button-active", `PSPDFKit-Note-Annotation-Icon-${u}`, {
                  [ac().isActive]: c,
                  [ac().focusRing]: c && s
                });
              return d.createElement("label", {
                "aria-label": a(cd[`icon${(0, gn.kC)(l)}`]),
                className: p,
                key: `NoteAnnotationToolbarIcon-${e}`
              }, d.createElement(Ae.Z, {
                type: `note/${l}`
              }), d.createElement(i.TX, {
                tag: "input",
                type: "radio",
                name: ac().radioInput,
                value: o,
                checked: c,
                onChange: t => {
                  t.target.checked && r({
                    icon: e
                  });
                },
                ref: c && t ? t : void 0
              }));
            })));
          }),
          cd = (0, xe.vU)({
            iconRightPointer: {
              id: "iconRightPointer",
              defaultMessage: "Right Pointer",
              description: "Icon Right Pointer"
            },
            iconRightArrow: {
              id: "iconRightArrow",
              defaultMessage: "Right Arrow",
              description: "Icon Right Arrow"
            },
            iconCheck: {
              id: "iconCheck",
              defaultMessage: "Checkmark",
              description: "Icon Checkmark"
            },
            iconCircle: {
              id: "iconCircle",
              defaultMessage: "Circle",
              description: "Icon Circle"
            },
            iconCross: {
              id: "iconCross",
              defaultMessage: "Cross",
              description: "Icon Cross"
            },
            iconInsert: {
              id: "iconInsert",
              defaultMessage: "Insert Text",
              description: "Icon Insert Text"
            },
            iconNewParagraph: {
              id: "iconNewParagraph",
              defaultMessage: "New Paragraph",
              description: "Icon New Paragraph"
            },
            iconNote: {
              id: "iconNote",
              defaultMessage: "Text Note",
              description: "Icon Text Note"
            },
            iconComment: {
              id: "iconComment",
              defaultMessage: "Comment",
              description: "Icon Comment"
            },
            iconParagraph: {
              id: "iconParagraph",
              defaultMessage: "Paragraph",
              description: "Icon Paragraph"
            },
            iconHelp: {
              id: "iconHelp",
              defaultMessage: "Help",
              description: "Icon Help"
            },
            iconStar: {
              id: "iconStar",
              defaultMessage: "Star",
              description: "Icon Star"
            },
            iconKey: {
              id: "iconKey",
              defaultMessage: "Key",
              description: "Icon Key"
            }
          }),
          dd = d.memo(function (e) {
            let {
              annotation: t,
              intl: n,
              updateAnnotation: r,
              isAnnotationReadOnly: o,
              deleteAnnotation: i,
              position: a,
              viewportWidth: s,
              expandedGroup: l,
              btnFocusRefIfFocusedGroup: u,
              btnFocusRefIfFocusedItem: c,
              canEditAnnotationCP: p,
              canDeleteSelectedAnnotationCP: f,
              keepSelectedTool: m,
              interactionMode: g,
              annotationToolbarItems: v,
              onGroupExpansion: y,
              hasDesktopLayout: b,
              onGroupTransitionEnded: w
            } = e;
            const {
                formatMessage: x
              } = n,
              D = it.Options.NOTE_COLOR_PRESETS,
              C = o(t) || t.locked,
              S = C || t instanceof ao.FN,
              E = null !== t.pageIndex && !C,
              _ = m && g === B.A.NOTE,
              P = [{
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(Ac, {
                  className: "PSPDFKit-Note-Annotation-Toolbar-Color",
                  accessibilityLabel: x(ke.Z.color),
                  colorPresets: D,
                  activeColor: t.color,
                  onClick: e => r({
                    color: e
                  }),
                  innerRef: u("color")
                }))),
                title: x(ke.Z.color),
                className: `${ac().formGroup} PSPDFKit-Toolbox PSPDFKit-Toolbox-FillColor`,
                hidden: S,
                disabled: !p,
                onPress: () => {},
                type: "color",
                group: "color",
                hideSeparator: !0
              }, {
                node: d.createElement(ud, {
                  annotation: t,
                  updateAnnotation: r,
                  intl: n,
                  ref: u("note")
                }),
                title: x(ke.Z.icon),
                hidden: S,
                onPress: () => {},
                disabled: !p,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-NoteIcon"),
                type: "note-icon",
                group: "note"
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(v),
                  title: x(ke.Z.delete),
                  className: h()("PSPDFKit-Note-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !f
                  }),
                  onPress: f ? () => i() : () => {}
                }),
                disabled: !f,
                hidden: _ || !(E && "note" !== l && "color" !== l),
                type: "delete",
                onPress: () => {},
                className: ""
              }],
              k = {
                className: ac().button,
                presentational: s > Ne.GI,
                disabled: !!l
              };
            return d.createElement("div", {
              className: h()("PSPDFKit-Note-Annotation-Toolbar", ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: v,
              builtInItems: P,
              btnFocusRefIfFocusedItem: c,
              onGroupExpansion: y,
              builtInToolbarProps: () => k,
              hasDesktopLayout: b,
              expandedGroup: l,
              onGroupTransitionEnded: w,
              position: a,
              typeMap: {
                "note-icon": "note",
                color: "fill-color"
              }
            }));
          });
        const pd = dd,
          hd = ["boundingBox"],
          fd = d.memo(function (e) {
            const t = (0, po.R9)(t => {
                const {
                  annotation: n,
                  isEditing: r,
                  dispatch: o,
                  canEditAnnotationCP: i
                } = e;
                if (i) if (n.lines.size > 0 && r) {
                  const {
                      boundingBox: e
                    } = t,
                    n = (0, ne.Z)(t, hd);
                  o((0, yt.gX)(n)), o((0, Kt.P4)());
                } else t.lineWidth && n.lines.size > 0 && (t.boundingBox = n.boundingBox.grow((t.lineWidth - n.lineWidth) / 2)), e.updateAnnotation(t);
              }),
              {
                annotation: n,
                intl: r,
                position: o,
                isEditing: i,
                expandedGroup: a,
                canDeleteSelectedAnnotationCP: s,
                btnFocusRefIfFocusedGroup: u,
                lastToolbarActionUsedKeyboard: c,
                annotationToolbarItems: p,
                btnFocusRefIfFocusedItem: f
              } = e,
              m = (0, l.v9)(e => e.shadowRoot),
              {
                formatMessage: g
              } = r,
              v = {
                onChange: t,
                record: n,
                styles: ac(),
                intl: r,
                caretDirection: "bottom" === o ? "up" : "down",
                frameWindow: e.frameWindow
              },
              y = e.areOnlyElectronicSignaturesEnabled && e.annotation.isSignature,
              b = [{
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(ec.Z, (0, ce.Z)({}, v, {
                  className: "PSPDFKit-Ink-Annotation-Toolbar-Stroke-Color",
                  colorProperty: "strokeColor",
                  removeTransparent: !0,
                  accessibilityLabel: g(ke.Z.color),
                  innerRef: u("color", !a),
                  lastToolbarActionUsedKeyboard: c,
                  annotationToolbarColorPresets: e.annotationToolbarColorPresets
                })))),
                title: g(ke.Z.color),
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-StrokeColor"),
                hidden: y,
                disabled: !e.canEditAnnotationCP,
                type: "stroke-color",
                group: "color"
              }, {
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(ec.Z, (0, ce.Z)({}, v, {
                  accessibilityLabel: g(ke.Z.fillColor),
                  className: "PSPDFKit-Ink-Annotation-Toolbar-Background-Color",
                  colorProperty: "backgroundColor",
                  innerRef: u("backgroundColor"),
                  annotationToolbarColorPresets: e.annotationToolbarColorPresets
                })))),
                title: g(ke.Z.fillColor),
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-FillColor"),
                hidden: y,
                disabled: !e.canEditAnnotationCP,
                type: "fill-color",
                group: "backgroundColor"
              }, {
                node: d.createElement(Qu.OpacityComponent, {
                  intl: e.intl,
                  type: "Ink",
                  styles: ac(),
                  annotation: n,
                  updateAnnotation: t,
                  caretDirection: "bottom" === o ? "up" : "down",
                  innerRef: u("opacity"),
                  shadowRoot: m
                }),
                title: g(ke.Z.opacity),
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity"),
                hidden: y,
                disabled: !e.canEditAnnotationCP,
                type: "opacity",
                group: "opacity"
              }, {
                node: d.createElement(Qu.StrokeWidthComponent, {
                  intl: e.intl,
                  type: "Ink",
                  styles: ac(),
                  annotation: n,
                  updateAnnotation: t,
                  caretDirection: "bottom" === o ? "up" : "down",
                  accessibilityLabel: g(ke.Z.thickness),
                  ref: u("lineWidth")
                }),
                title: g(ke.Z.thickness),
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineWidth"),
                hidden: y,
                disabled: !e.canEditAnnotationCP,
                type: "line-width",
                group: "lineWidth"
              }, {
                node: d.createElement("div", {
                  className: ac().controlWrapper
                }, d.createElement("div", {
                  className: ac().control
                }, d.createElement(Tc, {
                  value: n.blendMode,
                  className: "PSPDFKit-Ink-Annotation-Toolbar-Blend-Mode",
                  onChange: e => t({
                    blendMode: e
                  }),
                  caretDirection: "bottom" === o ? "up" : "down",
                  frameWindow: e.frameWindow,
                  ref: u("blendMode")
                }))),
                title: g(ke.Z.blendMode),
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-BlendMode"),
                hidden: y,
                disabled: !e.canEditAnnotationCP,
                type: "blend-mode",
                group: "blendMode"
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(p),
                  title: g(ke.Z.delete),
                  className: h()("PSPDFKit-Ink-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !s
                  }),
                  onPress: s ? () => e.deleteAnnotation() : () => {}
                }),
                disabled: !s,
                hidden: !(null != e.annotation.pageIndex && !i),
                type: "delete"
              }, {
                node: d.createElement(sc, {
                  intl: r,
                  isEditing: i,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP
                }),
                hidden: e.areOnlyElectronicSignaturesEnabled || !e.showAnnotationNotes || i,
                disabled: !e.canEditAnnotationCP,
                type: "annotation-note"
              }],
              w = {
                className: ac().button,
                presentational: e.viewportWidth > Ne.GI,
                disabled: !!a
              };
            return d.createElement("div", {
              className: h()("PSPDFKit-Ink-Annotation-Toolbar", ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: p,
              builtInItems: b,
              btnFocusRefIfFocusedItem: f,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: w,
              hasDesktopLayout: e.hasDesktopLayout,
              expandedGroup: a,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: o
            }));
          });
        const md = fd;
        var gd = n(20253),
          vd = n(67057);
        const yd = ["icon"];
        function bd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function wd(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? bd(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function xd(e) {
          return {
            desktop: ["stroke-color", "fill-color", "opacity", "line-width", e ? "linecaps-dasharray" : "line-style", "spacer", "annotation-note", "delete"],
            mobile: ["delete", "annotation-note", "spacer", "stroke-color", "fill-color", "opacity", "line-width", e ? "linecaps-dasharray" : "line-style"]
          };
        }
        const Dd = s.d0({
            [de.Zc.readableName]: {
              desktop: ["stroke-color", "fill-color", "opacity", "line-width", "blend-mode", "spacer", "annotation-note", "delete"],
              mobile: ["delete", "annotation-note", "spacer", "stroke-color", "fill-color", "opacity", "line-width", "blend-mode"]
            },
            [de.b3.readableName]: xd(!1),
            [de.Xs.readableName]: xd(!1),
            [de.o9.readableName]: xd(!0),
            [de.om.readableName]: xd(!0),
            [de.Hi.readableName]: xd(!1),
            [de.On.readableName]: {
              desktop: ["color", "opacity", "blend-mode", "spacer", "annotation-note", "delete"],
              mobile: ["delete", "annotation-note", "spacer", "color", "opacity", "blend-mode"]
            },
            [de.sK.readableName]: {
              desktop: ["opacity", "counterclockwise-rotation", "clockwise-rotation", "spacer", "annotation-note", "delete"],
              mobile: ["delete", "annotation-note", "spacer", "opacity", "counterclockwise-rotation", "clockwise-rotation"]
            },
            [de.GI.readableName]: {
              desktop: ["opacity", "spacer", "annotation-note", "delete"],
              mobile: ["delete", "annotation-note", "spacer", "opacity"]
            },
            [de.x_.readableName]: {
              desktop: ["opacity", "counterclockwise-rotation", "clockwise-rotation", "spacer", "annotation-note", "delete"],
              mobile: ["delete", "counterclockwise-rotation", "clockwise-rotation", "annotation-note", "spacer", "opacity"]
            },
            [de.gd.readableName]: {
              desktop: ["color", "background-color", "border-color", "opacity", "font", "spacer", "delete"],
              mobile: ["delete", "spacer", "color", "background-color", "border-color", "opacity", "font"]
            },
            [W.Z.readableName]: {
              desktop: ["fill-color", "overlay-text", "outline-color", "opacity", "spacer", "annotation-note", "delete", "apply-redactions"],
              mobile: ["delete", "apply-redactions", "annotation-note", "spacer", "fill-color", "overlay-text", "outline-color", "opacity"]
            },
            [de.Qi.readableName]: {
              desktop: ["color", "note-icon", "spacer", "delete"],
              mobile: ["delete", "spacer", "color", "note-icon"]
            },
            [de.R1.readableName]: {
              desktop: ["stroke-color", "opacity", "line-width", "spacer", "annotation-note", "delete", "line-style"],
              mobile: ["delete", "annotation-note", "spacer", "stroke-color", "opacity", "line-width", "line-style"]
            },
            Measurement: {
              desktop: ["back", "measurementType", "measurementScale", "stroke-color", "opacity", "line-width", "snapping", "spacer", "annotation-note", "delete"],
              mobile: ["back", "measurementType", "measurementScale", "delete", "annotation-note", "spacer", "stroke-color", "opacity", "line-width", "snapping"]
            }
          }),
          Cd = (0, I.Z)("AnnotationToolbarItem");
        const Sd = function (e) {
            const {
                intl: t,
                position: n,
                annotation: r,
                expandedGroup: o,
                btnFocusRefIfFocusedItem: i,
                annotationToolbarItems: a,
                hasDesktopLayout: s,
                btnFocusRefIfFocusedGroup: u,
                lastToolbarActionUsedKeyboard: c,
                name: p,
                canDeleteSelectedAnnotationCP: f
              } = e,
              m = (0, l.v9)(e => e.shadowRoot),
              g = (0, po.R9)(t => {
                const {
                  annotation: n,
                  canEditAnnotationCP: r
                } = e;
                r && (t.strokeWidth && (t.boundingBox = n.boundingBox.grow((t.strokeWidth - n.strokeWidth) / 2)), e.updateAnnotation(t));
              }),
              v = r instanceof _.b3 || r instanceof _.Xs ? e.updateAnnotation : g,
              y = r instanceof _.o9 || r instanceof _.om,
              {
                formatMessage: b
              } = t,
              w = {
                updateAnnotation: v,
                annotation: r,
                styles: ac(),
                intl: t,
                caretDirection: "bottom" === n ? "up" : "down"
              },
              x = [{
                node: d.createElement(ec.Z, (0, ce.Z)({}, w, {
                  record: e.annotation,
                  colorProperty: "strokeColor",
                  onChange: e.updateAnnotation,
                  className: `PSPDFKit-${p}-Annotation-Toolbar-Stroke-Color`,
                  removeTransparent: !0,
                  frameWindow: e.frameWindow,
                  accessibilityLabel: b(ke.Z.color),
                  innerRef: u("color", !o),
                  lastToolbarActionUsedKeyboard: c,
                  annotationToolbarColorPresets: e.annotationToolbarColorPresets
                })),
                title: b(ke.Z.color),
                group: "color",
                type: "stroke-color",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox", {
                  "PSPDFKit-Toolbox-BorderColor": !y,
                  "PSPDFKit-Toolbox-StrokeColor": y
                })
              }, {
                node: d.createElement(ec.Z, (0, ce.Z)({}, w, {
                  record: r,
                  colorProperty: "fillColor",
                  onChange: e.updateAnnotation,
                  className: `PSPDFKit-${p}-Annotation-Toolbar-Fill-Color`,
                  frameWindow: e.frameWindow,
                  accessibilityLabel: b(ke.Z.fillColor),
                  innerRef: u("fillColor"),
                  annotationToolbarColorPresets: e.annotationToolbarColorPresets
                })),
                title: b(ke.Z.fillColor),
                group: "fillColor",
                type: "fill-color",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-FillColor")
              }, {
                node: d.createElement(Qu.OpacityComponent, (0, ce.Z)({}, w, {
                  type: p,
                  innerRef: u("opacity"),
                  shadowRoot: m
                })),
                title: b(ke.Z.opacity),
                group: "opacity",
                type: "opacity",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
              }, {
                node: d.createElement(Qu.StrokeWidthComponent, (0, ce.Z)({}, w, {
                  type: p,
                  accessibilityLabel: b(ke.Z.thickness),
                  ref: u("line-width")
                })),
                title: b(ke.Z.thickness),
                group: "line-width",
                type: "line-width",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineWidth")
              }, ...(r instanceof _.o9 || r instanceof _.om ? [{
                node: d.createElement(Qu.LineCapsDashArrayComponent, (0, ce.Z)({}, w, {
                  frameWindow: e.frameWindow,
                  innerRef: u("linecaps-dasharray")
                })),
                title: b(ke.Z["linecaps-dasharray"]),
                group: "linecaps-dasharray",
                type: "linecaps-dasharray",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineCaps-DashArray")
              }] : [{
                node: d.createElement(Qu.LineStyleComponent, (0, ce.Z)({}, w, {
                  frameWindow: e.frameWindow,
                  innerRef: u("linestyle")
                })),
                title: b(ke.Z.linestyle),
                group: "linestyle",
                type: "line-style",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineStyle")
              }]), {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(a),
                  title: b(ke.Z.delete),
                  className: h()(`PSPDFKit-${p}-Annotation-Toolbar-Button-Delete`, ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !f
                  }),
                  onPress: f ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                hidden: null === e.annotation.pageIndex || !!o
              }, {
                node: d.createElement(sc, {
                  intl: e.intl,
                  isEditing: e.isEditing,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP
                }),
                type: "annotation-note",
                hidden: !e.showAnnotationNotes || e.isEditing
              }],
              D = {
                className: ac().button,
                presentational: e.viewportWidth > Ne.GI,
                disabled: !!o
              },
              C = {
                "line-style": "linestyle"
              };
            return r instanceof _.o9 || r instanceof _.om || (C["stroke-color"] = "border-color"), d.createElement("div", {
              className: h()(`PSPDFKit-${p}-Annotation-Toolbar`, ac().content)
            }, d.createElement(mc, {
              annotationToolbarItems: a,
              builtInItems: x,
              btnFocusRefIfFocusedItem: i,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: D,
              hasDesktopLayout: s,
              expandedGroup: o,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: n,
              typeMap: C
            }));
          },
          Ed = d.memo(function (e) {
            const {
                formatMessage: t
              } = e.intl,
              n = [{
                node: d.createElement(Ju.Z, {
                  type: "widget_ccw",
                  title: t(ke.Z.rotateCounterclockwise),
                  className: `PSPDFKit-Widget-Annotation-Toolbar-Button-Rotate PSPDFKit-Widget-Annotation-Toolbar-Button-Rotate-Counterclockwise ${ac().button} ${ac().rotateButton}`,
                  onPress: () => {
                    e.selectedAnnotationPageSize && e.updateAnnotation((0, j.eJ)(e.annotation, e.selectedAnnotationPageSize, j.z1.COUNTERCLOCKWISE));
                  }
                }),
                type: "counterclockwise-rotation",
                disabled: !e.canEditAnnotationCP
              }, {
                node: d.createElement(Ju.Z, {
                  type: "widget_cw",
                  title: t(ke.Z.rotateClockwise),
                  className: `PSPDFKit-Widget-Annotation-Toolbar-Button-Rotate PSPDFKit-Widget-Toolbar-Button-Rotate-Clockwise ${ac().button} ${ac().rotateButton}`,
                  onPress: () => {
                    e.selectedAnnotationPageSize && e.updateAnnotation((0, j.eJ)(e.annotation, e.selectedAnnotationPageSize, j.z1.CLOCKWISE));
                  }
                }),
                type: "clockwise-rotation",
                disabled: !e.canEditAnnotationCP
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(e.annotationToolbarItems),
                  title: t(ke.Z.delete),
                  className: h()("PSPDFKit-Widget-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !e.canDeleteSelectedAnnotationCP
                  }),
                  onPress: e.canDeleteSelectedAnnotationCP ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                hidden: null === e.annotation.pageIndex
              }];
            return d.createElement("div", {
              className: `PSPDFKit-Widget-Annotation-Toolbar ${ac().content}`
            }, d.createElement(mc, {
              annotationToolbarItems: e.annotationToolbarItems,
              builtInItems: n,
              btnFocusRefIfFocusedItem: e.btnFocusRefIfFocusedItem,
              onGroupExpansion: e.onGroupExpansion,
              hasDesktopLayout: e.hasDesktopLayout,
              expandedGroup: e.expandedGroup,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: e.position
            }));
          });
        var _d = n(3888);
        function Pd(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function kd(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Pd(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pd(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Ad = d.memo(function (e) {
          const t = (0, xe.YB)(),
            n = (0, l.v9)(e => e.shadowRoot),
            r = (0, po.R9)(t => {
              const {
                canEditAnnotationCP: n
              } = e;
              if (!n) return;
              const r = function (e, t) {
                if (!t.borderStyle && ("number" == typeof e.borderWidth || e.borderColor instanceof _.Il)) return kd(kd({}, e), {}, {
                  borderStyle: _d.N.solid
                });
                return e;
              }(t, e.annotation);
              e.updateAnnotation(r);
            }),
            {
              annotation: o,
              position: i,
              expandedGroup: a,
              canDeleteSelectedAnnotationCP: s,
              btnFocusRefIfFocusedGroup: u,
              annotationToolbarItems: c,
              btnFocusRefIfFocusedItem: p,
              lastToolbarActionUsedKeyboard: f
            } = e,
            m = {
              onChange: r,
              record: o,
              styles: ac(),
              intl: t,
              caretDirection: "bottom" === i ? "up" : "down",
              frameWindow: e.frameWindow
            },
            g = e.annotation.isSignature,
            v = [{
              node: d.createElement("div", {
                className: ac().controlWrapper
              }, d.createElement("div", {
                className: ac().control
              }, d.createElement(ec.Z, (0, ce.Z)({}, m, {
                className: "PSPDFKit-Link-Annotation-Toolbar-Border-Color",
                colorProperty: "borderColor",
                accessibilityLabel: t.formatMessage(ke.Z.color),
                innerRef: u("color", !a),
                lastToolbarActionUsedKeyboard: f,
                annotationToolbarColorPresets: e.annotationToolbarColorPresets
              })))),
              title: t.formatMessage(ke.Z.borderColor),
              className: h()(ac().formGroup, "PSPDFKit-Toolbox", "PSPDFKit-Toolbox-BorderColor"),
              hidden: g,
              disabled: !e.canEditAnnotationCP,
              type: "stroke-color",
              group: "color"
            }, {
              node: d.createElement(Qu.OpacityComponent, {
                intl: e.intl,
                type: "Link",
                styles: ac(),
                annotation: o,
                updateAnnotation: r,
                caretDirection: "bottom" === i ? "up" : "down",
                innerRef: u("opacity"),
                shadowRoot: n
              }),
              title: t.formatMessage(ke.Z.opacity),
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity"),
              hidden: g,
              disabled: !e.canEditAnnotationCP,
              type: "opacity",
              group: "opacity"
            }, {
              node: d.createElement(Qu.StrokeWidthComponent, {
                intl: e.intl,
                type: "Link",
                styles: ac(),
                annotation: o,
                updateAnnotation: r,
                caretDirection: "bottom" === i ? "up" : "down",
                accessibilityLabel: t.formatMessage(ke.Z.thickness),
                ref: u("lineWidth")
              }),
              title: t.formatMessage(ke.Z.thickness),
              className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineWidth"),
              hidden: g,
              disabled: !e.canEditAnnotationCP,
              type: "line-width",
              group: "lineWidth"
            }, {
              node: d.createElement(Ju.Z, {
                type: "delete",
                icon: (0, gc.KT)(c),
                title: t.formatMessage(ke.Z.delete),
                className: h()("PSPDFKit-Link-Annotation-Toolbar-Button-Delete", ac().button, ac().deleteButton, {
                  [ac().disabledButton]: !s
                }),
                onPress: s ? () => e.deleteAnnotation() : () => {}
              }),
              disabled: !s,
              hidden: null === e.annotation.pageIndex || !!a,
              type: "delete"
            }],
            y = {
              className: ac().button,
              presentational: e.viewportWidth > Ne.GI,
              disabled: !!a
            };
          return d.createElement("div", {
            className: h()("PSPDFKit-Link-Annotation-Toolbar", ac().content)
          }, d.createElement(mc, {
            annotationToolbarItems: c,
            builtInItems: v,
            btnFocusRefIfFocusedItem: p,
            onGroupExpansion: e.onGroupExpansion,
            builtInToolbarProps: y,
            hasDesktopLayout: e.hasDesktopLayout,
            expandedGroup: a,
            onGroupTransitionEnded: e.onGroupTransitionEnded,
            position: i
          }));
        });
        const zd = Ad;
        var Td = n(70964),
          Od = n(85151),
          Id = n(40775),
          Fd = n.n(Id),
          Md = n(80422);
        const Rd = function (e) {
            const {
                intl: t,
                position: n,
                annotation: r,
                expandedGroup: o,
                btnFocusRefIfFocusedItem: i,
                annotationToolbarItems: a,
                hasDesktopLayout: s,
                btnFocusRefIfFocusedGroup: u,
                lastToolbarActionUsedKeyboard: c,
                canDeleteSelectedAnnotationCP: p,
                selectedAnnotations: f
              } = e,
              m = (0, l.I0)(),
              g = (0, l.v9)(e => e.shadowRoot),
              v = (0, l.v9)(e => e.secondaryMeasurementUnit),
              y = d.useMemo(() => e.selectedAnnotations && e.selectedAnnotations.size > 1, [e.selectedAnnotations]),
              b = d.useMemo(() => !!f && (0, z.xA)(f), [f]),
              w = d.useMemo(() => (0, z.bs)(r), [r]),
              x = (0, po.R9)(t => {
                const {
                  annotation: n,
                  canEditAnnotationCP: r
                } = e;
                if (r) {
                  if (t.strokeWidth) {
                    if (y && f) {
                      const r = [];
                      return f.forEach(e => {
                        r.push({
                          boundingBox: e.boundingBox.grow((t.strokeWidth - n.strokeWidth) / 2),
                          strokeWidth: t.strokeWidth
                        });
                      }), void e.updateAnnotation(r);
                    }
                    t.boundingBox = n.boundingBox.grow((t.strokeWidth - n.strokeWidth) / 2);
                  }
                  e.updateAnnotation(t);
                }
              }),
              D = r instanceof _.b3 || r instanceof _.Xs ? e.updateAnnotation : x,
              C = r instanceof _.o9 || r instanceof _.om,
              {
                formatMessage: S
              } = t,
              E = {
                updateAnnotation: D,
                annotation: r,
                styles: ac(),
                intl: t,
                caretDirection: "bottom" === n ? "up" : "down"
              },
              P = z.Di.find(e => e.title === w),
              k = d.useMemo(() => (0, z.Rw)(r, v), [r, v]),
              A = [{
                node: d.createElement(Ju.Z, {
                  type: "back",
                  title: S(ke.Z.back),
                  className: h()(`PSPDFKit-${w}-Annotation-Toolbar-Button-Back`, ac().button, ac().measurementBackButton),
                  onPress: () => {
                    (0, l.dC)(() => {
                      m((0, _e.fz)()), m((0, yt.Ds)("measurement")), m((0, Kt.BR)());
                    });
                  }
                }),
                type: "back"
              }, {
                node: b ? d.createElement(Md.Z, {
                  key: S(ke.Z.mixedMeasurements),
                  type: "measure",
                  title: S(ke.Z.mixedMeasurements),
                  className: h()(P.className, Fd().measurementValue, ac().measurementToolbarButton, "PSPDFKit-Annotation-Toolbar-Measurement")
                }, r && null != r && r.note ? d.createElement(d.Fragment, null, S(ke.Z.mixedMeasurements)) : null) : d.createElement(Md.Z, {
                  key: P.interactionMode,
                  type: P.icon,
                  title: S(ke.Z[P.localeKey]),
                  className: h()(P.className, Fd().measurementValue, ac().measurementToolbarButton, "PSPDFKit-Annotation-Toolbar-Measurement")
                }, r && null != r && r.note ? y ? d.createElement(d.Fragment, null, P.title) : d.createElement(d.Fragment, null, P.title, ":", " ", d.createElement("b", null, r.note, k ? ` (${k.label})` : "")) : null),
                title: S(ke.Z[P.localeKey]),
                type: "measurementType",
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-MeasurementType")
              }, {
                node: d.createElement(d.Fragment, null, d.createElement(Md.Z, {
                  key: "scale",
                  type: "scale",
                  title: S(Yl.sY.measurementScale),
                  className: h()(ac().measurementToolbarButton)
                }), d.createElement(Od.ZP, {
                  frameWindow: e.frameWindow,
                  selectedAnnotation: r,
                  onAnnotationScaleUpdate: e.updateAnnotation,
                  selectedAnnotations: e.selectedAnnotations
                })),
                title: S(Yl.sY.measurementScale),
                type: "measurementScale",
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-MeasurementScale")
              }, {
                node: d.createElement(ec.Z, (0, ce.Z)({}, E, {
                  record: e.annotation,
                  colorProperty: "strokeColor",
                  onChange: e.updateAnnotation,
                  className: `PSPDFKit-${w}-Annotation-Toolbar-Stroke-Color`,
                  frameWindow: e.frameWindow,
                  accessibilityLabel: S(ke.Z.color),
                  innerRef: u("color", !o),
                  lastToolbarActionUsedKeyboard: c,
                  annotationToolbarColorPresets: e.annotationToolbarColorPresets
                })),
                title: S(ke.Z.color),
                group: "color",
                type: "stroke-color",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox", {
                  "PSPDFKit-Toolbox-BorderColor": !C,
                  "PSPDFKit-Toolbox-StrokeColor": C
                })
              }, {
                node: d.createElement(Qu.OpacityComponent, (0, ce.Z)({}, E, {
                  type: w,
                  innerRef: u("opacity"),
                  shadowRoot: g
                })),
                title: S(ke.Z.opacity),
                group: "opacity",
                type: "opacity",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Opacity")
              }, {
                node: d.createElement(Qu.StrokeWidthComponent, (0, ce.Z)({}, E, {
                  type: w,
                  accessibilityLabel: S(ke.Z.thickness),
                  ref: u("line-width")
                })),
                title: S(ke.Z.thickness),
                group: "line-width",
                type: "line-width",
                disabled: !e.canEditAnnotationCP,
                className: h()(ac().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-LineWidth")
              }, {
                node: d.createElement(Ju.Z, {
                  type: "delete",
                  icon: (0, gc.KT)(a),
                  title: S(ke.Z.delete),
                  className: h()(`PSPDFKit-${w}-Annotation-Toolbar-Button-Delete`, ac().button, ac().deleteButton, {
                    [ac().disabledButton]: !p
                  }),
                  onPress: p ? () => e.deleteAnnotation() : () => {}
                }),
                type: "delete",
                hidden: null === e.annotation.pageIndex || !!o
              }, {
                node: d.createElement(sc, {
                  intl: e.intl,
                  isEditing: e.isEditing,
                  showAnnotationNotes: e.showAnnotationNotes,
                  hasAnnotationNote: e.hasAnnotationNote,
                  isAnnotationNoteActive: e.isAnnotationNoteActive,
                  onAnnotationNotePress: e.onAnnotationNotePress,
                  disabled: !e.canEditAnnotationCP || y
                }),
                type: "annotation-note",
                hidden: !e.showAnnotationNotes || e.isEditing
              }],
              T = {
                className: ac().button,
                presentational: e.viewportWidth > Ne.GI,
                disabled: !!o
              },
              O = {
                "line-style": "linestyle"
              };
            return r instanceof _.o9 || r instanceof _.om || (O["stroke-color"] = "border-color"), d.createElement("div", {
              className: h()(`PSPDFKit-${w}-Annotation-Toolbar`, ac().content, ac().measurementToolbar)
            }, d.createElement(mc, {
              annotationToolbarItems: a,
              builtInItems: A,
              btnFocusRefIfFocusedItem: i,
              onGroupExpansion: e.onGroupExpansion,
              builtInToolbarProps: T,
              hasDesktopLayout: s,
              expandedGroup: o,
              onGroupTransitionEnded: e.onGroupTransitionEnded,
              position: n,
              typeMap: O
            }));
          },
          jd = ["text"];
        class Bd extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              showConfirmDelete: !1,
              expandedGroup: null,
              transitionFinished: !1,
              prevActiveGroup: null
            }), (0, o.Z)(this, "focusRef", d.createRef()), (0, o.Z)(this, "deleteAnnotation", () => {
              var e;
              const t = this.props.annotation,
                n = this.props.selectedAnnotations && (null === (e = this.props.selectedAnnotations) || void 0 === e ? void 0 : e.size) > 1;
              t && !n ? this.props.dispatch((0, yt.d8)((0, s.l4)([t.id]))) : n && this.props.selectedAnnotations && this.props.dispatch((0, yt.d8)(this.props.selectedAnnotations.map(e => e.id)));
            }), (0, o.Z)(this, "handleEntered", () => {
              this.setState({
                transitionFinished: !0
              });
            }), (0, o.Z)(this, "handleGroupExpansion", e => {
              e ? this.setState({
                prevActiveGroup: e,
                expandedGroup: e
              }) : this.setState({
                expandedGroup: e,
                transitionFinished: !1
              });
            }), (0, o.Z)(this, "_handleKeyPress", e => {
              e.keyCode === br.zz && this.state.expandedGroup && this.handleGroupExpansion();
            }), (0, o.Z)(this, "updateAnnotation", (e, t, n) => {
              if (!e || !this.props.canEditAnnotationCP) return;
              e = e.merge(t);
              const r = {
                annotations: (0, s.aV)([e]),
                reason: J.f.PROPERTY_CHANGE
              };
              this.props.eventEmitter.emit("annotations.willChange", r), n && this.props.dispatch((0, yt.Ds)(n));
              const {
                  text: o
                } = t,
                i = (0, ne.Z)(t, jd);
              this.props.dispatch((0, yt.gX)(i)), this.props.dispatch((0, yt.FG)(e));
            }), (0, o.Z)(this, "updateSingleAnnotation", (e, t) => {
              const n = this.props.annotation;
              this.updateAnnotation(n, e, t);
            }), (0, o.Z)(this, "updateAnnotations", (e, t) => {
              const {
                selectedAnnotations: n
              } = this.props;
              n && (null == n ? void 0 : n.size) > 1 && (0, l.dC)(() => {
                var n;
                null === (n = this.props.selectedAnnotations) || void 0 === n || n.toList().forEach((n, r) => {
                  Array.isArray(e) ? this.updateAnnotation(n, e[r], t) : this.updateAnnotation(n, e, t);
                });
              });
            }), (0, o.Z)(this, "onAnnotationNotePress", () => {
              const e = this.props.annotation;
              if (this.isActiveAnnotationNote()) this.closeAnnotationNote();else if (e) {
                const t = (0, ao.Yu)(e);
                this.props.dispatch((0, _e.mv)(t));
              }
            }), (0, o.Z)(this, "deleteAnnotationNote", () => {
              const e = this.props.annotation;
              e && (this.props.dispatch((0, yt.FG)(e.delete("note"))), this.closeAnnotationNote());
            }), (0, o.Z)(this, "closeAnnotationNote", () => {
              this.props.dispatch((0, _e.mv)(null));
            }), (0, o.Z)(this, "_handleResize", e => {
              this.props.dispatch((0, gd.LT)(e.height));
            });
          }
          isActiveAnnotationNote() {
            var e;
            const {
              activeAnnotationNote: t,
              annotation: n
            } = this.props;
            return Boolean(t && n && (null === (e = t.parentAnnotation) || void 0 === e ? void 0 : e.id) === n.id);
          }
          defaultToolbarItems() {
            var e;
            const {
              annotation: t,
              annotationToolbarItems: n,
              viewportWidth: r
            } = this.props;
            if ((0, u.kG)(t), !Dd.get(Ld(t))) return (0, s.aV)();
            const o = r > Ne.GI,
              i = null === (e = Dd.get(Ld(t))) || void 0 === e || null === (e = e.get(o ? "desktop" : "mobile")) || void 0 === e ? void 0 : e.map(e => ({
                type: e
              }));
            if ((0, u.kG)(i, `No default toolbar items found for annotation type: ${Ld(t)}`), n) {
              const e = n(t, {
                hasDesktopLayout: o,
                defaultAnnotationToolbarItems: i.toJS()
              });
              if (e) return e.forEach(e => {
                !function (e, t) {
                  var n, r, o, i;
                  const a = Dd.get(t);
                  Cd(a, "There are no built-in annotation toolbar items for this annotation type");
                  const s = new Set([...(null !== (n = null === (r = a.get("mobile")) || void 0 === r ? void 0 : r.toJS()) && void 0 !== n ? n : []), ...(null !== (o = null === (i = a.get("desktop")) || void 0 === i ? void 0 : i.toJS()) && void 0 !== o ? o : [])]);
                  Cd((0, u.PO)(e) && !!e, "Expected item to be an object"), e.icon && "custom" !== e.type ? Cd((0, F.HD)(e.icon), "Expected icon to be a string") : e.icon && Cd((0, F.HD)(e.icon) || e.icon instanceof Node, "Expected icon to be a string or a Node");
                  const {
                      icon: l
                    } = e,
                    c = (0, ne.Z)(e, yd);
                  (0, Ll.G)(wd(wd({}, c), {}, {
                    type: "custom"
                  })), Cd("type" in e && (0, F.HD)(e.type) && [...s, "spacer", "custom"].includes(e.type), `Expected item.type to one of ${[...s, "spacer", "custom"].join(", ")}`), "custom" === e.type && (Cd("id" in e && (0, F.HD)(e.id), "Expected item.id to be a string"), Cd("node" in e || "icon" in e, "Expected item to have either a `node` or `icon` property for custom element"));
                }(e, Ld(t));
              }), (0, s.aV)(e);
            }
            return i;
          }
          renderContent() {
            var e,
              t = this;
            const {
              annotation: n,
              variantAnnotationPresetID: r,
              position: o,
              viewportWidth: i,
              frameWindow: a,
              intl: s,
              showAnnotationNotes: l,
              canEditAnnotationCP: c,
              canDeleteSelectedAnnotationCP: p,
              lastToolbarActionUsedKeyboard: h,
              interactionMode: f,
              keepSelectedTool: m,
              annotationToolbarColorPresets: g,
              richTextEditorRef: v,
              customFontsReadableNames: y,
              isCalibratingScale: b
            } = this.props;
            if (!n) return null;
            const w = {
                deleteAnnotation: this.deleteAnnotation,
                updateAnnotation: this.props.selectedAnnotations && (null === (e = this.props.selectedAnnotations) || void 0 === e ? void 0 : e.size) > 1 ? this.updateAnnotations : this.updateSingleAnnotation,
                intl: s,
                position: o,
                viewportWidth: i,
                onGroupTransitionEnded: this.handleEntered,
                onGroupExpansion: this.handleGroupExpansion,
                expandedGroup: this.state.expandedGroup,
                btnFocusRefIfFocusedGroup: function (e) {
                  let n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                  return (0, gc.CN)(e, t.state.expandedGroup) || n && null !== f && i > Ne.GI ? t.focusRef : void 0;
                },
                btnFocusRefIfFocusedItem: function (e, n) {
                  let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                  return (0, gc.Kt)(e, n, t.state.prevActiveGroup) || r && null !== f && i < Ne.GI ? t.focusRef : void 0;
                },
                frameWindow: a,
                canEditAnnotationCP: c,
                canDeleteSelectedAnnotationCP: p,
                annotation: n,
                lastToolbarActionUsedKeyboard: h,
                annotationToolbarColorPresets: g,
                annotationToolbarItems: this.defaultToolbarItems(),
                hasDesktopLayout: i > Ne.GI,
                customFontsReadableNames: this.props.customFontsReadableNames
              },
              x = {
                onAnnotationNotePress: this.onAnnotationNotePress,
                showAnnotationNotes: l && !n.isCommentThreadRoot,
                hasAnnotationNote: Boolean(n.note),
                isAnnotationNoteActive: this.isActiveAnnotationNote()
              };
            return n instanceof W.Z ? d.createElement(wc, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              dispatch: this.props.dispatch,
              keepSelectedTool: m
            })) : n instanceof _.R1 ? d.createElement(zd, (0, ce.Z)({}, w, x, {
              annotation: n
            })) : n instanceof _.On ? d.createElement(Rc, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              dispatch: this.props.dispatch,
              variantAnnotationPresetID: r
            })) : n instanceof _.Zc ? d.createElement(md, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              dispatch: this.props.dispatch,
              areOnlyElectronicSignaturesEnabled: this.props.areOnlyElectronicSignaturesEnabled
            })) : n instanceof Td.Z && n.isMeasurement() ? b ? null : d.createElement(Rd, (0, ce.Z)({}, w, x, {
              annotation: n,
              dispatch: this.props.dispatch,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              selectedAnnotations: this.props.selectedAnnotations
            })) : n instanceof _.o9 ? d.createElement(Sd, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              name: "Line"
            })) : n instanceof _.b3 ? d.createElement(Sd, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              name: "Rectangle"
            })) : n instanceof _.Xs ? d.createElement(Sd, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              name: "Ellipse"
            })) : n instanceof _.Hi ? d.createElement(Sd, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              name: "Polygon"
            })) : n instanceof _.om ? d.createElement(Sd, (0, ce.Z)({}, w, x, {
              annotation: n,
              isEditing: this.props.selectedAnnotationMode === N.o.EDITING,
              name: "Polyline"
            })) : n instanceof _.gd ? d.createElement(ld, (0, ce.Z)({}, w, {
              annotation: n,
              richTextEditorRef: v,
              selectedAnnotationPageSize: this.props.selectedAnnotationPageSize,
              zoomLevel: this.props.zoomLevel || 1,
              keepSelectedTool: m,
              interactionMode: f,
              customFontsReadableNames: y
            })) : n instanceof _.Qi ? d.createElement(pd, (0, ce.Z)({}, w, {
              annotation: n,
              dispatch: this.props.dispatch,
              isAnnotationReadOnly: this.props.isAnnotationReadOnly,
              keepSelectedTool: m,
              interactionMode: f
            })) : n instanceof _.sK ? d.createElement(Sc, (0, ce.Z)({}, w, x, {
              annotation: n,
              areOnlyElectronicSignaturesEnabled: this.props.areOnlyElectronicSignaturesEnabled,
              selectedAnnotationPageSize: this.props.selectedAnnotationPageSize
            })) : n instanceof _.GI ? d.createElement(Dc, (0, ce.Z)({}, w, x, {
              annotation: n
            })) : n instanceof _.x_ ? d.createElement(Ed, (0, ce.Z)({}, w, {
              annotation: n,
              selectedAnnotationPageSize: this.props.selectedAnnotationPageSize
            })) : n instanceof _.Jn ? null : void (0, u.kG)(!1, "Annotation type not handled");
          }
          componentDidUpdate(e, t) {
            const n = this.state.expandedGroup && this.state.transitionFinished && !t.transitionFinished,
              r = !this.state.expandedGroup && t.expandedGroup && this.state.prevActiveGroup;
            (n || r) && this.focusRef.current && this.focusRef.current.focus();
          }
          render() {
            return d.createElement("div", {
              className: h()("PSPDFKit-Annotation-Toolbar", ac().root, {
                [ac().stickToBottom]: "bottom" === this.props.position
              }),
              onKeyDown: this._handleKeyPress
            }, d.createElement(vd.Z, {
              onResize: this._handleResize
            }), this.renderContent());
          }
        }
        const Nd = (0, xe.XN)(Bd);
        function Ld(e) {
          var t;
          return "isMeasurement" in e && null !== (t = e.isMeasurement) && void 0 !== t && t.call(e) ? "Measurement" : Dd.get(e.constructor.readableName) ? e.constructor.readableName : e instanceof _.On ? _.On.readableName : e instanceof _.x_ ? _.x_.readableName : void new u.p2("AnnotationToolbarComponent: getReadableName: Annotation type not handled");
        }
        function Vd(e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        }
        const Kd = d.memo(function (e) {
            let {
              intl: t,
              dispatch: n,
              inkEraserCursorWidth: r,
              position: o,
              viewportWidth: i
            } = e;
            const a = (0, l.v9)(e => e.shadowRoot),
              {
                handleGroupExpansion: s,
                handleEntered: u,
                expandedGroup: c,
                prevActiveGroup: p,
                btnFocusRef: f
              } = (0, po.Tp)(),
              [m, g] = d.useState(r);
            d.useEffect(() => {
              n((0, yt.GT)(m));
            }, [m, n]), d.useEffect(() => {
              g(r);
            }, [r]);
            const v = d.useCallback(e => {
                n((0, yt.gX)({
                  inkEraserWidth: e
                })), g(e);
              }, [n]),
              y = d.useCallback(e => {
                e.keyCode === br.zz && c && s();
              }, [c, s]),
              {
                formatMessage: b
              } = t,
              w = {
                lineWidth: {
                  node: d.createElement("div", {
                    className: ac().controlWrapper
                  }, d.createElement("div", {
                    className: ac().control
                  }, d.createElement($u.Z, {
                    name: "lineWidth",
                    accessibilityLabel: b(ke.Z.size),
                    className: "PSPDFKit-Ink-Eraser-Toolbar-Line-Width",
                    value: m,
                    valueLabel: e => b(ke.Z.numberInPt, {
                      arg0: e.toFixed(0)
                    }),
                    min: 1,
                    max: 40,
                    step: 1,
                    onChange: v,
                    caretDirection: "bottom" === o ? "up" : "down",
                    innerRef: (0, gc.CN)("lineWidth", c) ? f : void 0,
                    shadowRoot: a
                  }))),
                  title: b(ke.Z.thickness)
                }
              };
            return d.createElement("div", {
              className: h()("PSPDFKit-Annotation-Toolbar", ac().root, {
                [ac().stickToBottom]: "bottom" === o
              }),
              onMouseUp: Vd,
              onTouchEnd: Vd,
              onPointerUp: Vd,
              onKeyDown: y
            }, d.createElement("div", {
              className: `\n        PSPDFKit-Ink-Eraser-Toolbar\n        ${ac().content}\n\n      `
            }, d.createElement("div", {
              className: ac().left
            }, d.createElement("form", {
              className: ac().form,
              onSubmit: jr.PF
            }, d.createElement("div", {
              className: `${ac().formGroup} PSPDFKit-Toolbox PSPDFKit-Toolbox-LineWidth`
            }, d.createElement(Ju.Z, {
              type: "line-width",
              title: w.lineWidth.title,
              className: ac().button,
              onPress: () => s("lineWidth"),
              disabled: Boolean(c),
              presentational: i > Ne.GI,
              ref: (0, gc.Kt)("lineWidth", c, p) ? f : void 0
            }), w.lineWidth.node))), d.createElement("div", {
              className: ac().right
            }, d.createElement(cc.Z, {
              position: o,
              onClose: () => s(null),
              isPrimary: !1,
              onEntered: u,
              accessibilityLabel: c ? w[c].title : void 0
            }, c ? w[c].node : void 0))));
          }),
          qd = (0, xe.XN)(Kd);
        var Hd = n(46632),
          Ud = n.n(Hd);
        const Zd = (0, l.$j)(e => ({
          connectionFailureReason: e.connectionFailureReason
        }), () => ({}))(e => d.createElement("div", {
          className: `PSPDFKit-Error ${Ud().root}`
        }, d.createElement("div", {
          className: `PSPDFKit-Error-Box ${Ud().box}`
        }, d.createElement("div", {
          className: Ud().error
        }, d.createElement(je.Z, {
          src: n(66361),
          className: Ud().icon
        })), d.createElement("div", {
          className: `PSPDFKit-Error-Message ${Ud().errorMessage}`
        }, d.createElement("p", null, null != e.connectionFailureReason ? e.connectionFailureReason : d.createElement(d.Fragment, null, "An error occurred while loading the document. Try", " ", d.createElement("a", {
          href: "#",
          onClick: () => window.location.reload()
        }, "reloading the page"), "."))))));
        var $d,
          Gd = n(72113),
          Wd = n(83181),
          Yd = n.n(Wd);
        const Xd = {
          timeout: 300,
          classNames: {
            enter: Yd().unlockEnter,
            enterActive: Yd().unlockEnterActive,
            exit: Yd().unlockExit,
            exitActive: Yd().unlockExitActive
          }
        };
        class Qd extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_modalRef", d.createRef()), (0, o.Z)(this, "_inputRef", d.createRef()), (0, o.Z)(this, "state", {
              value: "",
              isIncorrectPassword: !1,
              inputShowError: !1
            }), (0, o.Z)(this, "_onConfirm", () => {
              this.props.resolvePassword && this.props.resolvePassword(this.state.value);
            }), (0, o.Z)(this, "_onChange", e => {
              const {
                value: t
              } = e.currentTarget;
              this.setState({
                value: t,
                inputShowError: !1
              });
            });
          }
          componentDidUpdate(e) {
            e.resolvePassword === this.props.resolvePassword || this.props.unlocked || (this._modalRef.current && this._modalRef.current.shake(), this._inputRef.current && this._inputRef.current.focus(), this.setState({
              isIncorrectPassword: !0,
              inputShowError: !0
            }));
          }
          render() {
            const {
                unlocked: e
              } = this.props,
              {
                isIncorrectPassword: t,
                inputShowError: r
              } = this.state,
              {
                formatMessage: o
              } = this.props.intl;
            return d.createElement(Gd.Z, {
              role: "dialog",
              onEnter: this._onConfirm,
              background: "rgba(0,0,0,.1)",
              className: h()("PSPDFKit-Password-Dialog", Yd().container),
              accessibilityLabel: o(Jd.password),
              accessibilityDescription: o(Jd.passwordAccessibilityDescription),
              innerRef: this._modalRef
            }, d.createElement("div", {
              className: "PSPDFKit-Password-Dialog-Content"
            }, d.createElement(Gd.Z.Section, null, d.createElement(i.M5, null, d.createElement("div", {
              className: Yd().iconBox
            }, d.createElement(Gl.Z, null, e ? d.createElement($l.Z, (0, ce.Z)({}, Xd, {
              key: "unlock"
            }), d.createElement(je.Z, {
              src: n(80790),
              className: h()(Yd().icon, Yd()["icon-success"])
            })) : d.createElement($l.Z, (0, ce.Z)({}, Xd, {
              key: "lock"
            }), d.createElement(je.Z, {
              src: n(50308),
              className: h()({
                [Yd().icon]: !0,
                [Yd()["icon-regular"]]: !t,
                [Yd()["icon-error"]]: t
              })
            })))))), d.createElement(i.z, null, o(Jd.passwordRequired)), d.createElement(Gd.Z.Section, null, d.createElement(i.xv, null, o(Jd.unlockDocumentDescription))), d.createElement(i.oi, {
              name: "password",
              value: this.state.value,
              onChange: this._onChange,
              "aria-label": o(Jd.password),
              autoFocus: !0,
              selectTextOnFocus: !0,
              disabled: e,
              secureTextEntry: !0,
              error: r,
              success: e,
              ref: this._inputRef
            })), t && !e ? d.createElement(Gd.Z.Section, {
              className: Yd().alert,
              spaced: !0
            }, o(Jd.incorrectPassword)) : $d || ($d = d.createElement(Gd.Z.Divider, null)), d.createElement("div", {
              className: h()("PSPDFKit-Password-Dialog-Buttons", Yd().dialogButtons)
            }, d.createElement(i.hE, {
              className: "PSPDFKit-Confirm-Dialog-Buttons"
            }, d.createElement(i.zx, {
              onClick: this._onConfirm,
              primary: !0,
              className: "PSPDFKit-Confirm-Dialog-Button PSPDFKit-Confirm-Dialog-Button-Confirm"
            }, o(Jd.unlock)))));
          }
        }
        const Jd = (0, xe.vU)({
            password: {
              id: "password",
              defaultMessage: "Password",
              description: "Text on a label"
            },
            passwordAccessibilityDescription: {
              id: "passwordAccessibilityDescription",
              defaultMessage: "Dialog prompting for a password to unlock the document",
              description: "Accessibility description for password modal"
            },
            passwordRequired: {
              id: "passwordRequired",
              defaultMessage: "Password Required",
              description: "Title of the modal to indicate a password is required"
            },
            unlockDocumentDescription: {
              id: "unlockDocumentDescription",
              defaultMessage: "You have to unlock this document to view it. Please enter the password in the field below.",
              description: "Label of the password prompt"
            },
            incorrectPassword: {
              id: "incorrectPassword",
              defaultMessage: "The password you entered isn't correct. Please try again.",
              description: "Error message when an incorrect password was entered"
            },
            unlock: {
              id: "unlock",
              defaultMessage: "Unlock",
              description: "Button to unlock a password protected PDF"
            }
          }),
          ep = (0, xe.XN)(Qd);
        var tp,
          np = n(69462),
          rp = n.n(np);
        class op extends d.Component {
          render() {
            const {
                resolvePassword: e,
                children: t,
                intl: n
              } = this.props,
              {
                formatMessage: r
              } = n,
              {
                name: o,
                progress: a,
                reason: s
              } = this.props.connectionState;
            switch (o) {
              case Va.F.CONNECTING:
                {
                  var l;
                  const e = s ? null !== (l = ip[s]) && void 0 !== l ? l : s : null,
                    t = e ? r(e) : "";
                  return d.createElement("div", {
                    className: rp().loader
                  }, d.createElement(i.Ex, {
                    message: t,
                    progress: null != a ? a : 0
                  }));
                }
              case Va.F.CONNECTION_FAILED:
                return tp || (tp = d.createElement(Zd, null));
              case Va.F.PASSWORD_REQUIRED:
                return d.createElement(ep, {
                  resolvePassword: e,
                  unlocked: this.props.isUnlockedViaModal
                });
              default:
                return void 0 === t ? null : t;
            }
          }
        }
        const ip = (0, xe.vU)({
            loading: {
              id: "loading",
              defaultMessage: "Loading...",
              description: "Shown while the document is being fetched"
            }
          }),
          ap = (0, xe.XN)(op),
          sp = (0, dn.Z)((e, t, n) => {
            const r = (0, j.xp)(e, t);
            return n ? r.sort(hp) : r.sort(pp);
          });
        const lp = (0, qn.x)(function (e, t) {
            let {
              page: n
            } = t;
            const r = !!e.reuseState,
              o = sp(e.annotations, n, e.viewportState.forceRenderWidgetsInAnnotationsOrder);
            let i = (0, s.aV)(),
              a = null;
            switch (e.selectedAnnotationMode) {
              case N.o.SELECTED:
                i = o.filter(t => e.selectedAnnotationIds.has(t.id));
                break;
              case N.o.EDITING:
                a = e.selectedAnnotationIds.map(t => {
                  const n = e.annotations.get(t);
                  return (0, u.kG)(n), n;
                }).first(), (a instanceof _.Qi || a instanceof _.Jn) && a.pageIndex === n.pageIndex && (i = (0, s.aV)([a]));
            }
            return {
              backend: e.backend,
              hoverAnnotationIds: e.hoverAnnotationIds,
              interactionMode: e.interactionMode,
              isAnnotationReadOnly: t => (0, Kn.lV)(t, e),
              selectedAnnotationIds: e.selectedAnnotationIds,
              activeAnnotationNote: e.activeAnnotationNote,
              selectedTextOnEdit: e.selectedTextOnEdit,
              showAnnotations: e.showAnnotations,
              window: e.frameWindow,
              zoomLevel: e.viewportState.zoomLevel,
              rotation: e.viewportState.pagesRotation,
              onFocusAnnotation: cp(e.eventEmitter),
              onBlurAnnotation: dp(e.eventEmitter),
              formDesignMode: e.formDesignMode,
              annotations: o,
              isReloadingDocument: r,
              attachments: e.attachments,
              selectedAnnotations: i,
              editingAnnotation: a,
              showComments: (0, Vs.Y7)(e),
              showAnnotationNotes: e.showAnnotationNotes,
              eventEmitter: e.eventEmitter,
              isAPStreamRendered: e.isAPStreamRendered,
              pageInvalidAPStreams: e.invalidAPStreams.get(n.pageIndex),
              canEditAnnotationCP: t => (0, to.CM)(t, e),
              canDeleteAnnotationCP: t => (0, to.Kd)(t, e),
              keepSelectedTool: e.keepSelectedTool,
              scrollElement: e.scrollElement,
              focusedAnnotationIds: e.focusedAnnotationIds,
              inkEraserMode: e.inkEraserMode,
              viewportState: e.viewportState,
              page: n,
              enableRichText: e.enableRichText,
              multiAnnotationsUsingShortcut: e.multiAnnotationsUsingShortcut,
              isMultiSelectionEnabled: e.isMultiSelectionEnabled,
              comments: e.comments,
              isAutoSaveDisabled: e.autoSaveMode === P.u.DISABLED
            };
          })(function (e) {
            const {
              annotations: t,
              isReloadingDocument: n,
              showAnnotations: r,
              zoomLevel: o,
              rotation: i,
              attachments: a,
              backend: c,
              dispatch: p,
              hoverAnnotationIds: h,
              page: f,
              isAnnotationReadOnly: m,
              canEditAnnotationCP: g,
              canDeleteAnnotationCP: v,
              getScrollElement: y,
              onFocusAnnotation: b,
              onBlurAnnotation: w,
              formDesignMode: x,
              selectedTextOnEdit: D,
              selectedAnnotationIds: C,
              selectedAnnotations: S,
              activeAnnotationNote: E,
              interactionMode: P,
              editingAnnotation: k,
              window: A,
              children: z,
              showComments: T,
              showAnnotationNotes: O,
              eventEmitter: I,
              isAPStreamRendered: F,
              pageInvalidAPStreams: M = (0, s.l4)(),
              keepSelectedTool: R,
              focusedAnnotationIds: N,
              inkEraserMode: V,
              enableRichText: K,
              multiAnnotationsUsingShortcut: q,
              setGlobalCursor: H,
              isMultiSelectionEnabled: U,
              comments: Z,
              isAutoSaveDisabled: $
            } = e;
            (0, u.kG)(M);
            const {
                pageSize: G,
                pageIndex: Y
              } = f,
              X = d.useCallback(e => e instanceof _.Jn ? !!Z.some(t => t.rootId === e.id) && T : !(e instanceof _.On && e.isCommentThreadRoot) || T, [T, Z]),
              [Q, J] = d.useState(null),
              [ee, te] = d.useState(void 0),
              [ne, re] = d.useState(!1),
              [oe, ie] = d.useState(Array()),
              ae = (0, l.v9)(e => e.shadowRoot),
              se = d.useCallback(function (e) {
                "number" == typeof e.clientX && "number" == typeof e.clientY && J(new _.E9({
                  x: e.clientX,
                  y: e.clientY
                }));
              }, []),
              ue = C.size > 0,
              ce = t.filter(e => e instanceof _.On && (e.isCommentThreadRoot || !m(e))),
              de = d.useMemo(() => t.filter(e => e instanceof _.R1), [t]),
              pe = d.useMemo(() => t.filter(e => e instanceof _.Zc), [t]),
              he = (0, po.R9)(e => e instanceof _.Zc && (0, j.Fp)(e) && !m(e) && g(e) && v(e)),
              fe = d.useMemo(() => pe.filter(he), [pe, he]);
            function me(e) {
              const t = C.has(e.id);
              return e instanceof W.Z ? t && P !== B.A.REDACT_TEXT_HIGHLIGHTER : t;
            }
            function ge(e) {
              ie(e ? [...oe, e] : []);
            }
            const ve = k instanceof _.Zc ? k : null,
              ye = k instanceof _.UX ? k : null,
              be = k instanceof _.gd && null === k.pageIndex ? k : null,
              we = k instanceof _.gd && k.pageIndex === Y ? k : null,
              xe = k instanceof _.Qi && null === k.pageIndex ? k : null,
              De = k instanceof _.Jn && null === k.pageIndex ? k : null,
              Ce = k instanceof W.Z && null === k.pageIndex ? k : null,
              Se = k instanceof _.R1 && null === k.pageIndex ? k : null,
              [Ee, _e] = d.useState(!1),
              Pe = d.useRef(!1),
              ke = e => (Ee && (0, j.eD)(e) || "number" == typeof e.buttonIconUpdatedAt) && !(null != M && M.has(e.id)) && (0, j.U7)(e.boundingBox) && F(e),
              Ae = d.useRef(o),
              ze = d.useRef(Y),
              Te = (0, po.tm)();
            d.useEffect(() => {
              if (n) return void (Pe.current = !1);
              (o > Ae.current || ze.current !== Y) && (Pe.current = !1, ze.current = Y), Ae.current = o;
              const e = t.filter(e => !(null != M && M.has(e.id)) && (0, j.eD)(e) && (0, j.U7)(e.boundingBox) && F(e));
              e.size > 0 && !Pe.current && (Pe.current = !0, c.renderPageAnnotations(Y, e, o * (0, Po.L)()).then(() => {
                Te() && _e(!0);
              }));
            }, [Y, o, F, c, M, t, _e, Ee, n, Te]), d.useEffect(() => {
              Ee && c.clearPageAPStreams(Y, M);
            }, [Ee, c, Y, M]), d.useEffect(() => {
              if (Ee) return () => {
                c.clearAllPageAPStreams(Y);
              };
            }, [c, Y, Ee]);
            const Oe = (0, po.jC)({
                zoomLevel: o
              }),
              Ie = !(null == Oe || !Oe.zoomLevel) && Oe.zoomLevel < o;
            d.useEffect(() => {
              Ie && c.clearAllPageAPStreams(Y);
            });
            const Fe = V === Ui.b.POINT ? Bo : Vo,
              Me = S.filter(e => X(e) && (0, j.Fp)(e) && (0, j.yU)(e) && (!m(e) || e instanceof _.Qi) && (!(e instanceof _.Jn) || null == k)),
              Re = Me.size > 1,
              je = t.filter(e => X(e) && (0, j.Fp)(e) && function (e) {
                return !(P === B.A.INK_ERASER && he(e));
              }(e) && (!me(e) || !(0, j.yU)(e) || m(e) || e instanceof _.Jn && k && k.equals(e)) && !function (e) {
                return e instanceof _.x_ && me(e) && x;
              }(e)),
              Be = je.filter(e => (0, j.OR)(e)),
              Ne = je.filter(e => !(0, j.OR)(e));
            return d.createElement(le.Provider, null, d.createElement(_o, {
              dispatch: p,
              selectableTextMarkupAnnotations: ce,
              selectableLinkAnnotations: de,
              hoverAnnotationIds: h,
              zoomLevel: o,
              window: A,
              pageIndex: Y,
              selectedAnnotations: S,
              keepSelectedTool: R,
              interactionMode: P,
              setMultiAnnsInitialEvent: te,
              isMultiSelectionEnabled: U,
              isHitCaptureDeferred: ne,
              hitCaptureDeferredRect: oe,
              currentPageAnnotations: t,
              isMultiAnnotationsSelected: Re
            }, z, r ? d.createElement("div", null, Ne.map(e => e instanceof _.x_ ? null : d.createElement(fo, {
              key: e.id,
              annotation: (0, qe.h4)(e),
              globalAnnotation: e,
              attachments: a,
              backend: c,
              dispatch: p,
              isAnnotationReadOnly: m,
              isDisabled: ue && !me(e),
              isHover: h.has(e.id),
              isSelected: me(e),
              activeAnnotationNote: E,
              showAnnotationNotes: O,
              onBlur: w,
              onFocus: b,
              pageSize: G,
              zoomLevel: o,
              rotation: i,
              pageRotation: f.rotation,
              shouldRenderAPStream: ke(e),
              isFocused: N.has(e.id),
              isMultiAnnotationsSelected: Re,
              isComboBoxOpen: re,
              handleComboBoxRect: ge,
              isAutoSaveDisabled: $
            })), Ne.sort((e, t) => {
              if (!f.tabOrder || "string" != typeof e.id || "string" != typeof t.id) return 0;
              const n = f.tabOrder.indexOf(e.id),
                r = f.tabOrder.indexOf(t.id);
              return -1 === n && -1 === r ? 0 : -1 === n ? 1 : -1 === r ? -1 : n - r;
            }).map(e => e instanceof _.x_ ? d.createElement(fo, {
              key: e.id,
              annotation: (0, qe.h4)(e),
              globalAnnotation: e,
              attachments: a,
              backend: c,
              dispatch: p,
              isAnnotationReadOnly: m,
              isDisabled: ue && !me(e),
              isHover: h.has(e.id),
              isSelected: me(e),
              activeAnnotationNote: E,
              showAnnotationNotes: O,
              onBlur: w,
              onFocus: b,
              pageSize: G,
              zoomLevel: o,
              rotation: i,
              pageRotation: f.rotation,
              shouldRenderAPStream: ke(e),
              isFocused: N.has(e.id),
              isMultiAnnotationsSelected: Re,
              isComboBoxOpen: re,
              handleComboBoxRect: ge,
              isAutoSaveDisabled: $
            }) : d.createElement(Ta, {
              annotation: e,
              isDisabled: ue && !me(e),
              zoomLevel: o,
              key: e.id,
              onBlur: w,
              onFocus: b,
              isFocused: N.has(e.id),
              isSelected: me(e)
            })), Be.map(e => d.createElement(fo, {
              key: e.id,
              annotation: (0, qe.h4)(e),
              globalAnnotation: e,
              attachments: a,
              backend: c,
              dispatch: p,
              isAnnotationReadOnly: m,
              isDisabled: ue && !me(e),
              isHover: h.has(e.id),
              isSelected: me(e),
              activeAnnotationNote: E,
              showAnnotationNotes: O,
              onBlur: w,
              onFocus: b,
              pageSize: G,
              zoomLevel: o,
              rotation: i,
              pageRotation: f.rotation,
              shouldRenderAPStream: ke(e),
              isFocused: N.has(e.id),
              isMultiAnnotationsSelected: Re,
              isComboBoxOpen: re,
              handleComboBoxRect: ge,
              isAutoSaveDisabled: $
            })), Re && d.createElement(d.Fragment, {
              key: "multi-annotations-selection"
            }, d.createElement(Li, {
              dispatch: p,
              pageIndex: Y,
              pageSize: G,
              window: A,
              getScrollElement: y,
              selectedAnnotations: Me.map(e => (0, qe.h4)(e)),
              selectedGlobalAnnotations: Me
            }, Me.map(e => d.createElement(fo, {
              key: e.id,
              annotation: (0, qe.h4)(e),
              globalAnnotation: e,
              attachments: a,
              backend: c,
              dispatch: p,
              isAnnotationReadOnly: m,
              isDisabled: !1,
              isHover: h.has(e.id),
              isSelected: !0,
              activeAnnotationNote: E,
              showAnnotationNotes: O,
              onBlur: w,
              onFocus: b,
              pageSize: G,
              zoomLevel: o,
              rotation: i,
              pageRotation: f.rotation,
              onClick: e instanceof _.gd ? se : void 0,
              shouldRenderAPStream: ke(e),
              isFocused: !1,
              isComboBoxOpen: re,
              handleComboBoxRect: ge,
              isAutoSaveDisabled: $
            })))), !Re && Me.map(t => d.createElement(d.Fragment, {
              key: t.id
            }, d.createElement(Fi, {
              pageIndex: Y,
              pageSize: G,
              annotation: (0, qe.h4)(t),
              globalAnnotation: t,
              window: A,
              getScrollElement: y,
              onFocus: b,
              onBlur: w,
              isResizable: (0, j.IO)(t),
              isModifiable: (0, j.Km)(t),
              isRotatable: (0, j.a$)(t),
              setGlobalCursor: H,
              backend: c,
              disablePointSnapping: e.viewportState.disablePointSnapping,
              isAnnotationLocked: t.locked
            }, d.createElement(fo, {
              annotation: (0, qe.h4)(t),
              globalAnnotation: t,
              attachments: a,
              backend: c,
              dispatch: p,
              isAnnotationReadOnly: m,
              isDisabled: !1,
              isHover: h.has(t.id),
              isSelected: !0,
              isFocused: !1,
              activeAnnotationNote: E,
              showAnnotationNotes: O,
              onBlur: w,
              onFocus: b,
              pageSize: G,
              zoomLevel: o,
              rotation: i,
              pageRotation: f.rotation,
              onClick: t instanceof _.gd ? se : void 0,
              shouldRenderAPStream: ke(t),
              isComboBoxOpen: re,
              handleComboBoxRect: ge,
              isAutoSaveDisabled: $
            })), O && (0, j.YV)(t) && d.createElement(lo, {
              dispatch: p,
              annotation: t,
              zoomLevel: o,
              isAnnotationSelected: !0,
              activeAnnotationNote: E,
              visible: !1
            })))) : null), P === B.A.INK && null !== ve && (0, j.Fp)(ve) ? d.createElement(Oo, {
              dispatch: p,
              pageSize: G,
              pageIndex: Y,
              inkAnnotation: ve.pageIndex === Y ? ve : ve.delete("lines").delete("boundingBox"),
              scrollElement: e.scrollElement
            }) : null, P === B.A.INK_ERASER && pe.size > 0 ? d.createElement(Fe, {
              inkAnnotations: fe,
              canvasSize: G,
              pageIndex: Y
            }) : null, ye && [...Oa, ...Ia].includes(P) && (0, j.Fp)(ye) ? d.createElement(Qt, {
              dispatch: p,
              pageSize: G,
              pageIndex: Y,
              shapeAnnotation: ye.pageIndex === Y ? ye : (0, L.Hx)(ye),
              isAnnotationMeasurement: [...Ia].includes(P),
              backend: c,
              disablePointSnapping: e.viewportState.disablePointSnapping
            }) : null, P !== B.A.TEXT && P !== B.A.CALLOUT || !be ? null : d.createElement(fi, {
              annotation: be,
              interactionMode: P,
              dispatch: p,
              pageSize: G,
              pageIndex: Y,
              autoSelect: D,
              eventEmitter: I,
              zoomLevel: o
            }), we && (0, j.Fp)(we) ? d.createElement(di, {
              dispatch: p,
              annotation: we,
              pageIndex: Y,
              pageSize: G,
              autoSelect: D,
              lastMousePoint: null === Q ? void 0 : Q,
              eventEmitter: I,
              keepSelectedTool: R,
              enableRichText: K,
              shadowRoot: ae
            }) : null, (xe || De) && d.createElement(Do, {
              dispatch: p,
              annotation: xe || De,
              pageSize: G,
              pageIndex: Y,
              zoomLevel: o
            }), Ce && P === B.A.REDACT_SHAPE_RECTANGLE && (0, j.Fp)(Ce) ? d.createElement(qi, {
              dispatch: p,
              pageSize: G,
              pageIndex: Y,
              redactionAnnotation: Ce.pageIndex === Y ? Ce : Ce.delete("boundingBox"),
              keepSelectedTool: R
            }) : null, P === B.A.LINK && Se ? d.createElement(Sa, {
              dispatch: p,
              linkAnnotation: Se,
              viewportState: e.viewportState,
              page: e.page,
              window: e.window,
              pageIndex: Y,
              keepSelectedTool: R
            }) : null, P === B.A.MULTI_ANNOTATIONS_SELECTION ? d.createElement(ka, {
              viewportState: e.viewportState,
              window: e.window,
              pageIndex: Y,
              initialDraggingEvent: ee,
              multiAnnotationsUsingShortcut: q
            }) : null);
          }),
          up = lp,
          cp = (0, dn.Z)(e => (t, n) => {
            e.emit("annotations.focus", {
              annotation: t,
              nativeEvent: void 0 !== n.nativeEvent ? n.nativeEvent : n
            });
          }),
          dp = (0, dn.Z)(e => (t, n) => {
            e.emit("annotations.blur", {
              annotation: t,
              nativeEvent: void 0 !== n.nativeEvent ? n.nativeEvent : n
            });
          });
        function pp(e, t) {
          const n = fp(e),
            r = fp(t);
          return n > r ? 1 : n < r ? -1 : 0;
        }
        function hp(e, t) {
          const n = mp(e),
            r = mp(t);
          return n > r ? 1 : n < r ? -1 : 0;
        }
        function fp(e) {
          return e instanceof _.x_ ? 3 : e instanceof _.FV || e instanceof _.R9 || e instanceof _.xu || e instanceof _.hL ? 2 : e instanceof _.R1 ? 1 : 0;
        }
        function mp(e) {
          return e.isSignature ? 3 : e instanceof _.FV || e instanceof _.R9 || e instanceof _.xu || e instanceof _.hL ? 2 : e instanceof _.R1 ? 1 : 0;
        }
        var gp = n(47460),
          vp = n.n(gp);
        const yp = ["keyup", "selectionchange", "touchend", "mouseup", "pointerup"];
        class bp extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_hostElement", d.createRef()), (0, o.Z)(this, "_onAppearInvoked", !1), (0, o.Z)(this, "_preventTextSelection", e => {
              const t = this._hostElement.current;
              if (!t) return;
              const n = t.ownerDocument.defaultView.getSelection() || {},
                {
                  anchorNode: r,
                  extentNode: o,
                  focusNode: i,
                  isCollapsed: a
                } = n;
              if (r && t.contains(r) || o && t.contains(o) || i && t.contains(i)) {
                if (a) return;
                e.stopPropagation(), e.stopImmediatePropagation();
              }
            });
          }
          _appendNode() {
            const e = this._hostElement.current;
            if (!e) return;
            const {
              node: t,
              onAppear: n
            } = this.props.item;
            e.innerHTML = "", e.appendChild(t), "function" != typeof n || this._onAppearInvoked || (this._onAppearInvoked = !0, n());
          }
          componentDidMount() {
            const e = this._hostElement.current;
            if (e) {
              const t = e.ownerDocument;
              yp.forEach(e => {
                t.addEventListener(e, this._preventTextSelection, !0);
              });
            }
            this._appendNode();
          }
          componentDidUpdate(e) {
            this.props.item.node !== e.item.node && this._appendNode();
          }
          componentWillUnmount() {
            const e = this._hostElement.current;
            if (!e) return;
            const t = e.ownerDocument;
            yp.forEach(e => {
              t.removeEventListener(e, this._preventTextSelection, !0);
            }), this._onAppearInvoked = !1;
            const {
              onDisappear: n
            } = this.props.item;
            "function" == typeof n && n();
          }
          render() {
            return d.createElement(Ee, {
              applyZoom: !this.props.item.disableAutoZoom,
              position: this.props.item.position,
              noRotate: this.props.item.noRotate,
              currentPagesRotation: this.props.rotation,
              zoomLevel: this.props.zoomLevel
            }, d.createElement("div", {
              className: vp().selectable,
              ref: this._hostElement
            }));
          }
        }
        var wp = n(15164);
        class xp extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_handlePointerUp", e => {
              const {
                transformClientToPage: t,
                onEmit: n,
                pageIndex: r
              } = this.props;
              n(e, t(new E.E9({
                x: e.clientX,
                y: e.clientY
              }), r));
            });
          }
          render() {
            return d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp
            }, d.createElement(this.props.element, {
              className: this.props.className
            }, this.props.children));
          }
        }
        const Dp = vo(xp);
        var Cp = n(63124),
          Sp = n.n(Cp);
        function Ep(e) {
          let {
            focused: t,
            searchResult: n,
            zoomLevel: r
          } = e;
          const o = h()({
            [Sp().highlight]: !0,
            [Sp().focused]: t,
            "PSPDFKit-Search-Highlight": !0,
            "PSPDFKit-Search-Highlight-focused": t
          });
          return d.createElement("div", {
            "data-testid": "SearchHighlight",
            "aria-live": "polite"
          }, t ? d.createElement(i.TX, {
            announce: "polite"
          }, "Search Result: ", n.previewText) : null, n.rectsOnPage.map((e, t) => d.createElement("div", {
            key: t,
            style: {
              top: Math.floor(e.top * r),
              left: Math.floor(e.left * r),
              width: Math.ceil(e.width * r),
              height: Math.ceil(e.height * r)
            },
            className: o
          })).toArray());
        }
        const _p = (0, l.$j)(function (e, t) {
            const {
              searchState: n
            } = e;
            return {
              searchResults: n.results.filter(e => e.pageIndex === t.pageIndex),
              focusedResult: n.results.get(n.focusedResultIndex)
            };
          })(function (e) {
            let {
              searchResults: t,
              focusedResult: n,
              zoomLevel: r
            } = e;
            return d.createElement("div", {
              className: Sp().layer,
              "data-testid": "SearchHighlightLayer"
            }, t.map((e, t) => d.createElement(Ep, {
              focused: e === n,
              key: t,
              searchResult: e,
              zoomLevel: r
            })));
          }),
          Pp = e => {
            let {
              textLine: t,
              eventEmitter: n,
              enableTextSelection: r,
              scaling: o,
              vertical: i,
              isTextCopyingAllowed: a,
              isPanModeEnabled: s,
              contentBlockId: u,
              pageIndex: c,
              parentBoundingBoxes: p,
              fontFamily: f
            } = e;
            const m = (0, po.R9)((0, dn.Z)(j.a5)),
              g = d.useCallback((e, r) => {
                const o = {
                  textLine: t,
                  point: r,
                  nativeEvent: e.nativeEvent
                };
                n.emit("textLine.press", o);
              }, [n, t]),
              v = (0, l.I0)(),
              y = d.useCallback(() => {
                v((0, _e.vR)());
              }, []),
              b = h()({
                [gs().line]: !0,
                [gs().lineTextCursor]: !s,
                [gs().debug]: !1,
                [gs().enableTextSelection]: r,
                "PSPDFKit-Text": !0,
                [gs().vertical]: !!i,
                [gs().selectableText]: !0
              }),
              {
                left: w,
                top: x
              } = p.reduce((e, t) => ({
                left: e.left - t.left,
                top: e.top - t.top
              }), {
                left: t.boundingBox.left,
                top: t.boundingBox.top
              }),
              D = {
                left: w,
                top: x,
                transform: o && o.scaleX > 0 && o.scaleY > 0 ? `scale(${o.scaleX}, ${o.scaleY})` : "",
                fontFamily: f
              },
              C = (0, cs.LD)(a, t),
              S = (0, l.v9)(e => m(e.annotations, t.pageIndex)),
              E = S.find(e => e.boundingBox.isRectInside(t.boundingBox));
            return d.createElement(Dp, {
              pageIndex: c,
              className: h()({
                [gs().lineSelection]: !0
              }),
              onEmit: g,
              element: "span"
            }, !De.vU && d.createElement("span", {
              className: h()({
                [gs().linePadding]: !0,
                [gs().preventUserSelect]: De.G6 || De.b5
              }),
              style: {
                top: x,
                left: w - 20,
                transform: "none"
              },
              onClick: De.G6 || De.b5 ? y : void 0
            }), d.createElement("span", (0, ce.Z)({
              className: b,
              style: D,
              key: t.id || void 0,
              "data-contentblock-id": u,
              "data-textline-id": t.id,
              "data-page-index": c
            }, E && E.note ? {
              title: E.note
            } : void 0), C));
          },
          kp = d.memo(Pp);
        var Ap = n(65739),
          zp = n(40573),
          Tp = n.n(zp);
        function Op(e) {
          const {
              contentElement: t,
              pageIndex: n,
              contentBlockId: r,
              alt: o,
              parentBoundingBoxes: i
            } = e,
            {
              boundingBox: a
            } = t,
            {
              left: s,
              top: l
            } = i.reduce((e, t) => ({
              left: e.left - t.left,
              top: e.top - t.top
            }), {
              left: a.left,
              top: a.top
            }),
            u = {
              top: l,
              left: s,
              width: a.width,
              height: a.height
            };
          return "image" === t.elementType ? d.createElement("img", {
            src: Me.wc,
            alt: o,
            title: o,
            style: u,
            "data-contentblock-id": r,
            "data-contentelement-id": t.id,
            "data-page-index": n,
            className: Tp().element,
            onDragStart: () => !1
          }) : d.createElement("span", {
            style: u,
            "data-contentblock-id": r,
            "data-contentelement-id": t.id,
            "data-page-index": n,
            title: o
          });
        }
        var Ip = n(1079),
          Fp = n.n(Ip);
        function Mp(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Rp(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Mp(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mp(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const jp = function e(t) {
          var n;
          const {
            vertical: r,
            contentBlock: o,
            textLineScales: i,
            textElementFonts: a,
            areBlockTypeChildrenAllowed: s,
            parentBoundingBoxes: l,
            nestedContentBlockId: u
          } = t;
          let c = "span";
          const p = null === (n = o.contentTreeElementMetadata) || void 0 === n ? void 0 : n.pdfua_type,
            h = {
              role: void 0,
              style: void 0,
              title: void 0
            };
          let f = t.parentBoundingBoxes;
          if (h.style = De.vU ? {} : Rp({}, u ? null : {
            zIndex: -1
          }), o.boundingBox && (0, cs.cJ)(p)) {
            const e = l.reduce((e, t) => ({
                left: e.left - t.left,
                top: e.top - t.top
              }), {
                left: o.boundingBox.left,
                top: o.boundingBox.top
              }),
              t = {
                left: e.left,
                top: e.top,
                width: o.boundingBox.width,
                height: o.boundingBox.height
              };
            h.style = Rp(Rp({}, t), {}, {
              position: "absolute"
            }), f = f.push(new _.UL(t));
          }
          if (p && p in Ap.m) {
            var m, g;
            if (c = s ? Ap.m[p] : "span", 0 === o.contentElements.size && 0 === o.textLines.size && null !== (m = o.contentTreeElementMetadata) && void 0 !== m && m.alt) h.title = null === (g = o.contentTreeElementMetadata) || void 0 === g ? void 0 : g.alt;
            "span" === c && Ap.j[p] && (h.role = Ap.j[p]), h.style = Rp(Rp({}, h.style), (0, cs.wj)(c));
          }
          return d.createElement(c, (0, ce.Z)({
            className: o.boundingBox && "Figure" === p ? Fp().blockContainer : void 0
          }, h), o.contentBlocks.map(n => d.createElement(e, {
            dispatch: t.dispatch,
            enableTextSelection: t.enableTextSelection,
            key: n.id,
            pageIndex: t.pageIndex,
            textLineScales: i,
            textElementFonts: a,
            contentBlock: n,
            nestedContentBlockId: (null != u ? u : "") + o.id + ".",
            vertical: r,
            eventEmitter: t.eventEmitter,
            isTextCopyingAllowed: t.isTextCopyingAllowed,
            isPanModeEnabled: t.isPanModeEnabled,
            areBlockTypeChildrenAllowed: s && o.allowsBlockTypeChildren,
            parentBoundingBoxes: f
          })), o.textLines.map(e => d.createElement(kp, {
            enableTextSelection: t.enableTextSelection,
            key: e.id,
            pageIndex: t.pageIndex,
            scaling: i && i.get(e.id),
            textLine: e,
            fontFamily: a && e.id ? a[e.id] : void 0,
            contentBlockId: (null != u ? u : "") + o.id,
            vertical: r,
            eventEmitter: t.eventEmitter,
            isTextCopyingAllowed: t.isTextCopyingAllowed,
            isPanModeEnabled: t.isPanModeEnabled,
            parentBoundingBoxes: f
          })), o.contentElements.map(e => {
            var n;
            return d.createElement(Op, {
              key: e.id,
              pageIndex: t.pageIndex,
              contentBlockId: (null != u ? u : "") + o.id,
              contentElement: e,
              alt: null === (n = o.contentTreeElementMetadata) || void 0 === n ? void 0 : n.alt,
              parentBoundingBoxes: f
            });
          }));
        };
        var Bp;
        class Np extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "layerRef", d.createRef()), (0, o.Z)(this, "state", {
              needsTextSelectionOverlay: "gecko" === De.SR,
              overlayHeight: 0
            }), (0, o.Z)(this, "handleMouseDown", e => {
              if (this.state.needsTextSelectionOverlay && this.layerRef.current) {
                const t = this.layerRef.current.getBoundingClientRect();
                if (e.clientY) {
                  const n = Math.max(0, e.clientY - t.top);
                  this.setState({
                    overlayHeight: n / this.props.zoomLevel
                  });
                }
              }
            }), (0, o.Z)(this, "handleMouseUp", () => {
              this.state.needsTextSelectionOverlay && this.setState({
                overlayHeight: 0
              });
            });
          }
          render() {
            const {
              enableTextSelection: e,
              zoomLevel: t,
              rotation: n,
              eventEmitter: r,
              contentBlocks: o,
              pageIndex: i,
              textLineScales: a,
              textElementFonts: l,
              pageSize: u
            } = this.props;
            return d.createElement("div", {
              className: h()(gs().layer, "PSPDFKit-Content-Layer"),
              onMouseDown: this.handleMouseDown,
              onMouseUp: this.handleMouseUp,
              style: {
                transform: `scale(${t})`,
                transformOrigin: "0 0"
              },
              ref: this.layerRef,
              role: "webkit" === De.SR ? "text" : void 0
            }, Bp || (Bp = d.createElement("div", null)), null == o ? void 0 : o.map(t => d.createElement(jp, {
              dispatch: this.props.dispatch,
              enableTextSelection: e,
              key: t.id,
              pageIndex: i,
              textLineScales: a,
              textElementFonts: l,
              contentBlock: t,
              vertical: 90 === n || 270 === n,
              eventEmitter: r,
              isTextCopyingAllowed: this.props.isTextCopyingAllowed,
              isPanModeEnabled: this.props.isPanModeEnabled,
              nestedContentBlockId: "",
              areBlockTypeChildrenAllowed: !0,
              parentBoundingBoxes: (0, s.aV)([new E.UL(u)])
            })), this.state.needsTextSelectionOverlay && this.state.overlayHeight > 0 ? d.createElement("div", {
              className: gs().overlay,
              style: {
                top: this.state.overlayHeight
              }
            }) : null);
          }
        }
        var Lp = n(2998),
          Vp = n.n(Lp);
        function Kp(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function qp(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Kp(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Kp(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Hp = {
          rect: null,
          startingPoint: null
        };
        const Up = (0, l.$j)(function (e, t) {
          let {
            pageIndex: n
          } = t;
          return {
            clientToPageTransformation: (0, G.zi)(e, n),
            zoomLevel: e.viewportState.zoomLevel,
            interactionMode: e.interactionMode
          };
        })(function (e) {
          const {
              dispatch: t,
              pageSize: n,
              clientToPageTransformation: r,
              pageIndex: o,
              zoomLevel: i
            } = e,
            [a, s] = d.useState(Hp),
            l = d.useCallback(e => e.apply(r), [r]);
          d.useEffect(function () {
            return t((0, Kt.X2)()), function () {
              t((0, Kt.Zg)());
            };
          }, [t]);
          const {
            rect: u
          } = a;
          return d.createElement("div", {
            className: Vp().canvas
          }, null !== u ? d.createElement("svg", {
            className: Vp().svg,
            style: {
              left: u.left * i,
              top: u.top * i,
              width: u.width * i,
              height: u.height * i
            },
            focusable: !1
          }, d.createElement("rect", {
            className: Vp().rect,
            height: u.height * i,
            width: u.width * i,
            x: 0,
            y: 0
          }), d.createElement("rect", {
            className: Vp().rectStrokeBetween,
            height: u.height * i,
            width: u.width * i,
            x: 0,
            y: 0
          })) : null, d.createElement(Vt.Z, {
            size: n,
            onDrawStart: function (e) {
              s(t => qp(qp({}, t), {}, {
                startingPoint: e
              }));
            },
            onDrawCoalesced: function (e) {
              const {
                startingPoint: t
              } = a;
              (0, Ce.k)(t);
              const n = e[e.length - 1];
              s(e => qp(qp({}, e), {}, {
                rect: Zp(t, n)
              }));
            },
            onDrawEnd: function () {
              const {
                  rect: e
                } = a,
                n = 5 / i;
              null === e || e.width < n && e.height < n || t((0, Ql.vP)(o, e)), s(Hp);
            },
            transformPoint: l,
            interactionMode: e.interactionMode,
            scrollElement: e.scrollElement
          }));
        });
        function Zp(e, t) {
          const n = Math.min(e.x, t.x),
            r = Math.min(e.y, t.y),
            o = Math.max(e.x, t.x),
            i = Math.max(e.y, t.y);
          return new _.UL({
            left: n,
            top: r,
            width: o - n,
            height: i - r
          });
        }
        var $p = n(96213),
          Gp = n.n($p);
        function Wp(e) {
          let {
            frameWindow: t,
            pageRef: r,
            interactionMode: o,
            onCreate: i,
            pageIndex: a,
            intl: s
          } = e;
          const [c, p] = (0, d.useState)([0, 0]),
            [f, m] = (0, d.useState)((0, De.b1)()),
            g = (0, l.v9)(e => e.shadowRoot);
          return (0, d.useEffect)(() => {
            if ((0, De.b1)()) return;
            function e(e) {
              const {
                  pageX: t,
                  pageY: n
                } = e,
                o = e.target.closest(".PSPDFKit-Page");
              if (!o) return void m(!1);
              const i = o.getAttribute("data-page-index");
              if ((0, u.kG)("string" == typeof i, "Page number is not a string"), +i === a) {
                m(!0), (0, u.kG)(r.current);
                const {
                  left: e,
                  top: o
                } = r.current.getBoundingClientRect();
                p([t - e, n - o]);
              } else m(!1);
            }
            const n = g || t;
            return n.addEventListener("mousemove", e), () => {
              (0, De.b1)() || n.removeEventListener("mousemove", e);
            };
          }, [r, t, a, g]), f ? d.createElement("div", {
            className: h()({
              [Gp().wrapper]: (0, De.b1)()
            }, "PSPDFKit-Form-Creator-Guides"),
            onPointerUp: i,
            role: "application"
          }, !(0, De.b1)() && d.createElement(d.Fragment, null, d.createElement("div", {
            className: Gp().hGuide,
            style: {
              transform: `translate(0, ${c[1]}px)`
            }
          }), d.createElement("div", {
            className: Gp().vGuide,
            style: {
              transform: `translate(${c[0]}px,0)`
            }
          }), d.createElement("div", {
            className: h()({
              [Gp().buttonWidget]: o === B.A.BUTTON_WIDGET,
              [Gp().textWidget]: o === B.A.TEXT_WIDGET,
              [Gp().radioWidget]: o === B.A.RADIO_BUTTON_WIDGET,
              [Gp().checkboxWidget]: o === B.A.CHECKBOX_WIDGET,
              [Gp().signWidget]: o === B.A.SIGNATURE_WIDGET,
              [Gp().listBoxWidget]: o === B.A.LIST_BOX_WIDGET,
              [Gp().comboBoxWidget]: o === B.A.COMBO_BOX_WIDGET,
              [Gp().dateWidget]: o === B.A.DATE_WIDGET
            }),
            style: {
              transform: `translate(${c[0]}px,${c[1]}px)`
            }
          }, d.createElement("div", null, s.formatMessage(ke.Z.sign)), d.createElement(je.Z, {
            src: n(52904)
          })))) : null;
        }
        var Yp = n(26559);
        function Xp(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Qp(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Xp(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xp(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Jp = e => {
            const {
                page: t,
                textBlockId: n,
                anchor: r,
                zoomLevel: o,
                textBlockState: i,
                isActive: a,
                contentEditor: s
              } = e,
              l = d.useRef(null),
              c = d.useRef({
                offset: {
                  x: 0,
                  y: 0
                },
                size: {
                  x: -1,
                  y: -1
                }
              }),
              p = d.useCallback((0, Ml.k)((e, t) => ((0, u.kG)(s), s.renderTextBlock(n, e, t)), 20), []),
              h = i.layout,
              f = i.globalEffects,
              m = i.modificationsCharacterStyle;
            d.useEffect(() => {
              !async function () {
                const e = (0, Yp.T8)(h, m),
                  n = (0, Po.L)(),
                  i = await p({
                    pixelAnchor: {
                      x: r.x * o * n,
                      y: r.y * o * n
                    },
                    globalEffects: (0, Yp.uE)(f),
                    pixelPageSize: {
                      x: t.pageSize.width * o * n,
                      y: t.pageSize.height * o * n
                    },
                    pixelViewport: {
                      offset: {
                        x: 0,
                        y: 0
                      },
                      size: {
                        x: t.pageSize.width * o * n,
                        y: t.pageSize.height * o * n
                      }
                    },
                    cursor: null,
                    selection: a ? {
                      color: "#b5d7ff"
                    } : null
                  }, e),
                  s = i.displayRect,
                  u = l.current;
                if (!u) return;
                const d = c.current;
                d.offset.x != s.offset.x && (u.style.left = s.offset.x / n + "px"), d.offset.y != s.offset.y && (u.style.top = s.offset.y / n + "px"), d.size.x != s.size.x && (u.style.width = s.size.x / (De.G6 ? 1 : n) + "px", u.width = s.size.x), d.size.y != s.size.y && (u.style.height = s.size.y / (De.G6 ? 1 : n) + "px", u.height = s.size.y);
                const g = u.getContext("2d");
                if (g) {
                  if (g.clearRect(0, 0, s.size.x, s.size.y), s.size.x && s.size.y) {
                    const e = new ImageData(new Uint8ClampedArray(i.imageBuffer), s.size.x, s.size.y);
                    g.putImageData(e, 0, 0);
                  }
                  c.current = s;
                }
              }();
            });
            const g = De.G6 ? {
              transformOrigin: "top left",
              transform: `scale(${1 / devicePixelRatio})`
            } : {};
            return d.createElement("canvas", {
              ref: l,
              style: Qp({
                position: "absolute",
                left: 0,
                top: 0
              }, g)
            });
          },
          eh = d.memo(Jp);
        var th = n(2927);
        const nh = {
          on(e, t) {
            document.addEventListener(e, e => t(e.detail));
          },
          dispatch(e, t) {
            document.dispatchEvent(new CustomEvent(e, {
              detail: t
            }));
          },
          remove(e, t) {
            document.removeEventListener(e, t);
          }
        };
        var rh = n(89306),
          oh = n.n(rh),
          ih = n(72322);
        const ah = (0, xe.vU)({
          fontMismatch: {
            id: "ceFontMismatch",
            defaultMessage: "The {arg0} font isn’t available or can’t be used to edit content in this document. Added or changed content will revert to a default font.",
            description: "Message to show when there is a mismatch"
          },
          toggleFontMismatchTooltip: {
            id: "ceToggleFontMismatchTooltip",
            defaultMessage: "Toggle font mismatch tooltip",
            description: "Message to show for the button that displays the font mismatch tooltip"
          },
          deleteTextBlockConfirmMessage: {
            id: "deleteTextBlockConfirmMessage",
            defaultMessage: "Are you sure you want to delete this text box?",
            description: "Message for the delete text block confirm dialog"
          },
          deleteTextBlockConfirmAccessibilityLabel: {
            id: "deleteTextBlockConfirmAccessibilityLabel",
            defaultMessage: "Confirm text box deletion",
            description: "Accessibility label for the delete text block confirm dialog"
          },
          deleteTextBlockConfirmAccessibilityDescription: {
            id: "deleteTextBlockConfirmAccessibilityDescription",
            defaultMessage: "Dialog allowing the user to confirm or cancel deleting the text box",
            description: "Accessibility description for the delete annotation confirm dialog"
          },
          ceDownloadRequiredTitle: {
            id: "ceDownloadRequiredTitle",
            defaultMessage: "Download Required",
            description: "Title for the Download Required dialog"
          },
          ceDownloadRequiredMessage: {
            id: "ceDownloadRequiredMessage",
            defaultMessage: "To enable content editing directly in your browser, your document needs to be downloaded.",
            description: "Text content for the Download Required dialog"
          },
          ceDownloadRequiredButton: {
            id: "ceDownloadRequiredButton",
            defaultMessage: "Download Document",
            description: "Button text for the Download Required dialog"
          },
          ceCannotSaveChangesTitle: {
            id: "ceCannotSaveChangesTitle",
            defaultMessage: "Cannot Save Changes",
            description: "Title for the Cannot Save Changes dialog"
          },
          ceCannotSaveChangesMessage: {
            id: "ceCannotSaveChangesMessage",
            defaultMessage: "This file was edited by another user at the same time and their changes have already been uploaded. Your edits cannot be saved. Review your edits and try again if necessary, or exit without saving any changes.",
            description: "Text content for the Cannot Save Changes dialog"
          },
          ceCannotSaveChangesButton: {
            id: "ceCannotSaveChangesButton",
            defaultMessage: "Discard",
            description: "Button text for the Cannot Save Changes primary button"
          },
          ceCannotSaveChangesReviewButton: {
            id: "ceCannotSaveChangesReviewButton",
            defaultMessage: "Review",
            description: "Button text for the Cannot Save Changes primary cancel button"
          },
          ceDownloadingDocument: {
            id: "ceDownloadingDocument",
            defaultMessage: "Preparing document for editing...",
            description: "Message displayed when the document is being downloaded for Server-backed content editing."
          },
          ceSaving: {
            id: "ceSaving",
            defaultMessage: "Saving the document...",
            description: "Message displayed when the content edited document is being saved."
          }
        });
        function sh(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function lh(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? sh(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sh(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function uh(e) {
          let {
            faceMismatch: t,
            relativePixelContentRect: r,
            textBlockState: o,
            zoomLevel: a,
            anchor: s,
            geometricStyleAttributes: u,
            positionAttributes: c
          } = e;
          const {
              formatMessage: p
            } = (0, xe.YB)(),
            h = (0, l.I0)(),
            {
              contentRect: f,
              globalEffects: m,
              layout: g
            } = o,
            v = d.useMemo(() => {
              const e = E.sl.IDENTITY.rotateRad(m.rotation).scale(1, m.flipY ? -1 : 1),
                t = r.offset.x + u.width,
                n = new _.E9({
                  x: t + 5 * a,
                  y: r.offset.y
                }).apply(e),
                o = n.x + s.x * a + (m.rotation < 0 ? r.offset.x : 0),
                i = n.y + s.y * a + (m.rotation < 0 ? r.offset.y : 0);
              return new _.E9({
                x: o,
                y: i
              });
            }, [u.width, a, m.flipY, m.rotation, s.x, s.y, r.offset.x, r.offset.y]),
            y = lh(lh({}, c), {}, {
              position: "fixed",
              left: v.x,
              top: v.y,
              width: Math.max(12, Math.round(16 * a)),
              height: Math.max(12, Math.round(16 * a)),
              zIndex: 3
            });
          return d.createElement("button", {
            style: y,
            className: oh().tooltipButton,
            onClick: e => {
              e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), e.preventDefault();
            },
            onPointerDown: e => {
              e.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), e.preventDefault();
            },
            onPointerOver: () => {
              var e;
              const n = r.offset.x + f.size.x,
                o = r.offset.y,
                i = new _.E9({
                  x: n,
                  y: o
                }),
                l = E.sl.IDENTITY.rotateRad(m.rotation).scale(1, m.flipY ? -1 : 1),
                u = i.apply(l);
              h((0, th.lx)(new _.UL({
                left: s.x + (null !== (e = g.maxWidth) && void 0 !== e ? e : u.x),
                top: v.y / a,
                width: 16,
                height: 16
              }), t));
            },
            onPointerLeave: () => {
              if (!De.Ni) {
                const e = new AbortController();
                h((0, th.Hv)(e)), h((0, th.uy)(e.signal));
              }
            }
          }, d.createElement(je.Z, {
            src: n(69241),
            className: oh().tooltipSVG
          }), d.createElement(i.TX, null, p(ah.toggleFontMismatchTooltip)));
        }
        function ch(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function dh(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ch(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ch(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const ph = e => {
            var t, n;
            const {
                page: {
                  pageSize: r,
                  pageIndex: o
                },
                textBlockId: i,
                anchor: a,
                zoomLevel: s,
                textBlockState: u,
                isActive: c,
                frameWindow: p
              } = e,
              f = (0, l.I0)(),
              m = u.contentRect,
              g = u.globalEffects,
              v = u.detectedStyle,
              y = u.cursor,
              b = d.useRef(!1),
              [w, x] = d.useState(!1),
              D = d.useRef(!1),
              C = (0, l.v9)(e => (0, Js.G_)(o, i)(e)),
              S = (0, l.v9)(e => (0, Js.QC)(o, i)(e));
            d.useEffect(() => {
              if (!c) {
                const e = new AbortController();
                f((0, th.Hv)(e)), f((0, th.uy)(e.signal));
              }
            }, [c, f]);
            const E = d.useRef(null),
              P = d.useMemo(() => {
                var e, t, n;
                return c ? null != (null === (e = v.selectionStyleInfo) || void 0 === e ? void 0 : e.faceMismatch) ? v.selectionStyleInfo.faceMismatch.unavailableFaceName : null !== (t = null === (n = v.modificationsCharacterStyleFaceMismatch) || void 0 === n ? void 0 : n.unavailableFaceName) && void 0 !== t ? t : null : null;
              }, [null === (t = v.selectionStyleInfo) || void 0 === t ? void 0 : t.faceMismatch, null === (n = v.modificationsCharacterStyleFaceMismatch) || void 0 === n ? void 0 : n.unavailableFaceName, c]),
              k = d.useRef(null),
              A = d.useRef(null),
              z = e => {
                var t, n;
                (0, Ce.k)(e.currentTarget);
                return new _.E9({
                  x: (null !== (t = e.nativeEvent.offsetX) && void 0 !== t ? t : 0) / s + m.offset.x,
                  y: (null !== (n = e.nativeEvent.offsetY) && void 0 !== n ? n : 0) / s + m.offset.y
                });
              },
              T = () => (0, Yp.T8)(u.layout, u.modificationsCharacterStyle),
              O = function (e) {
                let {
                  textAreaRef: t,
                  textBlockId: n,
                  pageIndex: r,
                  makeExternalState: o
                } = e;
                const i = d.useRef(!1),
                  a = (0, l.I0)(),
                  s = e => {
                    t.current && null != e && e.length && a((0, th.qt)(r, n, null, e, o()));
                  },
                  u = De.Dt || De.TL;
                return {
                  onChange: e => {
                    i.current || s("insertLineBreak" === e.nativeEvent.inputType ? "\n" : e.nativeEvent.data);
                  },
                  onCompositionStart: () => {
                    u || (i.current = !0);
                  },
                  onCompositionEnd: e => {
                    u || (i.current = !1, s(e.data));
                  }
                };
              }({
                textAreaRef: E,
                textBlockId: i,
                pageIndex: o,
                makeExternalState: T
              }),
              I = function (e) {
                let {
                  textBlockState: t,
                  textBlockId: n,
                  pageIndex: r,
                  makeExternalState: o
                } = e;
                const i = (0, l.I0)();
                return {
                  onCopy: e => {
                    e.preventDefault(), t.selection && e.clipboardData.setData("text/plain", t.selection.text);
                  },
                  onCut: e => {
                    e.preventDefault(), t.selection && (e.clipboardData.setData("text/plain", t.selection.text), i((0, th.qt)(r, n, null, "", o())));
                  },
                  onPaste: e => {
                    e.preventDefault();
                    const t = e.clipboardData.getData("text/plain");
                    i((0, th.qt)(r, n, null, t, o()));
                  }
                };
              }({
                textBlockId: i,
                pageIndex: o,
                textBlockState: u,
                makeExternalState: T
              }),
              F = function (e) {
                let {
                  textBlockId: t,
                  makeExternalState: n,
                  textBlockState: r,
                  pageSize: o,
                  pageIndex: i,
                  isSelected: a,
                  isActive: s
                } = e;
                const u = (0, l.I0)();
                return e => {
                  const l = De.V5 && e.altKey || !De.V5 && e.ctrlKey;
                  if (s) switch (e.key) {
                    case "ArrowRight":
                      u((0, th.FD)(i, t, l ? "forwardWord" : "forward", e.shiftKey, n()));
                      break;
                    case "ArrowLeft":
                      u((0, th.FD)(i, t, l ? "backwardWord" : "backward", e.shiftKey, n()));
                      break;
                    case "ArrowDown":
                      u((0, th.FD)(i, t, "nextLine", e.shiftKey, n()));
                      break;
                    case "ArrowUp":
                      u((0, th.FD)(i, t, "previousLine", e.shiftKey, n()));
                      break;
                    case "Home":
                      u((0, th.FD)(i, t, "first", e.shiftKey, n()));
                      break;
                    case "End":
                      u((0, th.FD)(i, t, "last", e.shiftKey, n()));
                      break;
                    case "Backspace":
                      u((0, th.RL)(i, t, "backward", n()));
                      break;
                    case "Delete":
                      u((0, th.RL)(i, t, "forward", n()));
                      break;
                    case "a":
                    case "A":
                      if (!(De.V5 && e.metaKey || !De.V5 && e.ctrlKey)) break;
                      u((0, th.Ow)(i, t, "everything", n()));
                      break;
                    case "z":
                    case "Z":
                      if (!(De.V5 && e.metaKey || !De.V5 && e.ctrlKey)) break;
                      e.shiftKey ? u((0, th.yy)(i, t, n())) : u((0, th.Zv)(i, t, n()));
                      break;
                    case "y":
                    case "Y":
                      if (!(De.V5 && e.metaKey || !De.V5 && e.ctrlKey)) break;
                      u((0, th.yy)(i, t, n()));
                      break;
                    case "Escape":
                      u(th.Pq), e.preventDefault();
                  } else if (a) {
                    let n = 1;
                    switch (e.shiftKey && (n = 10), e.key) {
                      case "ArrowRight":
                        {
                          e.preventDefault();
                          const t = new _.E9({
                            x: r.anchor.x + n,
                            y: r.anchor.y
                          });
                          if (t.x + r.contentRect.offset.x + r.contentRect.size.x >= o.width) break;
                          u((0, th.$t)({
                            anchor: t,
                            isKeyboardMove: !0
                          }));
                          break;
                        }
                      case "ArrowLeft":
                        {
                          e.preventDefault();
                          const t = new _.E9({
                            x: r.anchor.x - n,
                            y: r.anchor.y
                          });
                          if (t.x + r.contentRect.offset.x <= 0) break;
                          u((0, th.$t)({
                            anchor: t,
                            isKeyboardMove: !0
                          }));
                          break;
                        }
                      case "ArrowDown":
                        {
                          e.preventDefault();
                          const t = new _.E9({
                            x: r.anchor.x,
                            y: r.anchor.y + n
                          });
                          if (t.y + r.contentRect.offset.y + r.contentRect.size.y >= o.height) break;
                          u((0, th.$t)({
                            anchor: t,
                            isKeyboardMove: !0
                          }));
                          break;
                        }
                      case "ArrowUp":
                        {
                          e.preventDefault();
                          const t = new _.E9({
                            x: r.anchor.x,
                            y: r.anchor.y - n
                          });
                          if (t.y + r.contentRect.offset.y <= 0) break;
                          u((0, th.$t)({
                            anchor: t,
                            isKeyboardMove: !0
                          }));
                          break;
                        }
                      case "Enter":
                        u((0, th.SF)(i, t)), e.preventDefault();
                        break;
                      case "Escape":
                        u(th.Pq), e.preventDefault();
                        break;
                      case "Backspace":
                      case "Delete":
                      case "Del":
                        u((0, th.u)(Js.wR.Delete)), e.preventDefault(), e.stopPropagation();
                        break;
                      default:
                        e.preventDefault();
                    }
                  } else switch (e.key) {
                    case "Enter":
                      u((0, th.C0)(i, t)), e.preventDefault();
                      break;
                    case "Escape":
                      u(th.Pq), e.preventDefault();
                  }
                };
              }({
                textBlockId: i,
                textBlockState: u,
                makeExternalState: T,
                pageSize: r,
                pageIndex: o,
                isActive: c,
                isSelected: C
              });
            function M(e) {
              var t;
              const n = z(e),
                r = {
                  x: n.x,
                  y: n.y
                };
              null === (t = E.current) || void 0 === t || t.focus(), f((0, th.v2)(o, i, r, e.shiftKey, T())), k.current = {
                mode: "characters",
                begin: r
              };
            }
            function R(e) {
              e.stopPropagation(), e.stopImmediatePropagation();
              const t = {
                x: e.clientX,
                y: e.clientY
              };
              if (!A.current) return [null, null];
              const n = new _.UL({
                width: r.width,
                height: r.height
              });
              let o = new _.E9(t);
              const i = A.current;
              if (o = o.apply(i.transformation), !n.isPointInside(o)) return [null, null];
              return [(t.x - i.start.x) * i.scale / i.zoomLevel, (t.y - i.start.y) * i.scale / i.zoomLevel];
            }
            d.useEffect(() => {
              D.current && C && (D.current = !1);
            }, [C]);
            const j = d.useCallback((0, ih.Z)(e => {
                const [t, n] = R(e);
                if (null === t || null === n || !A.current) return;
                const r = new _.E9({
                  x: A.current.anchor.x + t,
                  y: A.current.anchor.y + n
                });
                A.current.changed = !0, f((0, th.$t)({
                  anchor: r,
                  pageIndex: o,
                  textBlockId: i
                }));
              }, 20), []),
              B = d.useCallback(() => {
                var e;
                p.document.removeEventListener("pointermove", j, {
                  capture: !0
                }), p.document.removeEventListener("pointerup", B, {
                  capture: !0
                }), f((0, Ql.ac)(!1)), null !== (e = A.current) && void 0 !== e && e.changed && (A.current.previousInteractionState === Js.FP.Selected ? f((0, th.C0)(o, i)) : f(th.Pq)), A.current = null;
              }, []);
            d.useEffect(() => {
              var e;
              c && u.justCreated && (null === (e = E.current) || void 0 === e || e.focus());
            }, [c, u.justCreated]);
            const N = () => {
              var e;
              return c && (null === (e = E.current) || void 0 === e ? void 0 : e.focus());
            };
            d.useEffect(() => (nh.on("content-editing:re-focus", N), () => nh.remove("content-editing:re-focus", N)));
            const L = u.layout;
            (0, Ce.k)(null !== L.maxWidth);
            const V = {
                offset: {
                  x: (0, ml._v)(L.alignment, ml.Im, L.maxWidth),
                  y: m.offset.y
                },
                size: {
                  x: L.maxWidth,
                  y: m.size.y
                }
              },
              K = (0, ml.sz)(tl(V), s),
              q = (0, ml.yK)(K, a, s),
              H = {
                position: "absolute",
                left: q.offset.x,
                top: q.offset.y
              },
              U = dh(dh({}, H), {}, {
                width: q.size.x,
                height: q.size.y,
                transformOrigin: `${-K.offset.x}px ${-K.offset.y}px`,
                transform: `rotate(${g.rotation}rad) scaleY(${g.flipY ? -1 : 1})`
              });
            u.justCreated && (U.width = Math.max(m.size.x, 10) * s);
            const Z = (0, l.v9)(e => (0, G.zi)(e, o)),
              $ = (e, t) => n => {
                n.stopPropagation(), n.isPrimary && 0 === n.button && (n.nativeEvent.stopImmediatePropagation(), n.preventDefault(), p.document.addEventListener("pointermove", W, {
                  passive: !0,
                  capture: !0
                }), p.document.addEventListener("pointerup", Y, {
                  passive: !0,
                  capture: !0
                }), f((0, Ql.ac)(!0)), C || c || f((0, th.SF)(o, i)), (0, Ce.k)(null !== L.maxWidth), A.current = {
                  fixpoint: e,
                  scale: t,
                  zoomLevel: s,
                  start: {
                    x: n.clientX,
                    y: n.clientY
                  },
                  anchor: u.anchor,
                  maxWidth: L.maxWidth,
                  transformation: Z,
                  previousInteractionState: C ? Js.FP.Selected : Js.FP.None
                });
              },
              W = d.useCallback((0, ih.Z)(e => {
                const [t] = R(e);
                null !== t && A.current && f((0, th.PZ)({
                  fixpointValue: A.current.fixpoint,
                  newWidth: A.current.maxWidth + t
                }));
              }, 20), []),
              Y = d.useCallback(() => {
                A.current = null, p.document.removeEventListener("pointermove", W, {
                  capture: !0
                }), p.document.removeEventListener("pointerup", Y, {
                  capture: !0
                }), f((0, Ql.ac)(!1));
              }, []);
            return d.createElement(d.Fragment, null, P ? d.createElement(uh, {
              faceMismatch: P,
              relativePixelContentRect: K,
              textBlockState: u,
              zoomLevel: s,
              anchor: a,
              geometricStyleAttributes: U,
              positionAttributes: H
            }) : null, d.createElement("div", {
              style: dh(dh({}, U), {}, {
                position: "fixed",
                zIndex: 2
              }),
              className: h()(oh().textBlock, {
                [oh().selectedTextBlock]: C,
                [oh().movingTextBlock]: S,
                [oh().activeTextBlock]: c,
                [oh().focusIn]: w
              }),
              onFocus: () => {
                b.current = !0;
              },
              onBlur: () => {
                b.current = !1, x(!1);
              },
              onKeyUp: e => {
                const t = e.target.ownerDocument.defaultView && e.target instanceof e.target.ownerDocument.defaultView.HTMLTextAreaElement;
                b.current && "Tab" === e.key && t && (x(!0), f((0, th.FD)(o, i, "first", !1, T())));
              }
            }, d.createElement("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: `${m.offset.x * s} ${K.offset.y} ${K.size.x} ${K.size.y}`,
              style: dh(dh({}, U), {}, {
                width: q.size.x,
                position: "absolute",
                left: 0,
                top: 0,
                transform: void 0,
                transformOrigin: void 0,
                display: c ? "block" : "none"
              }),
              className: oh().blinkingCaret
            }, d.createElement("line", {
              stroke: "currentColor",
              x1: y.offset.x * s,
              y1: (y.offset.y + y.lineSpacing.bottom) * s,
              x2: y.offset.x * s,
              y2: (y.offset.y - y.lineSpacing.top) * s
            })), d.createElement("textarea", (0, ce.Z)({
              ref: E,
              onPointerDown: e => {
                e.stopPropagation(), c ? M(e) : (e.preventDefault(), e.isPrimary && (p.document.addEventListener("pointermove", j, {
                  passive: !0,
                  capture: !0
                }), p.document.addEventListener("pointerup", B, {
                  passive: !0,
                  capture: !0
                }), f((0, Ql.ac)(!0)), (0, Ce.k)(null !== L.maxWidth), A.current = {
                  fixpoint: 0,
                  scale: 1,
                  zoomLevel: s,
                  start: {
                    x: e.clientX,
                    y: e.clientY
                  },
                  anchor: u.anchor,
                  maxWidth: L.maxWidth,
                  transformation: Z,
                  previousInteractionState: C ? Js.FP.Selected : Js.FP.None
                }));
              },
              onPointerMove: e => {
                if (A.current) return;
                if (e.preventDefault(), !(c && 1 & e.buttons)) return;
                e.stopPropagation();
                const t = z(e),
                  n = {
                    x: t.x,
                    y: t.y
                  },
                  r = k.current;
                (0, Ce.k)(r), f((0, th.sC)(o, i, r.begin, n, r.mode, T()));
              },
              onPointerUp: e => {
                var t;
                null !== (t = A.current) && void 0 !== t && t.changed || (e.preventDefault(), e.stopPropagation(), C || c ? c || (f((0, th.SF)(o, i)), M(e)) : (f((0, th.C0)(o, i)), D.current = !0));
              },
              onMouseUp: e => {
                if (e.detail >= 2) {
                  e.preventDefault(), e.stopPropagation();
                  const t = z(e),
                    n = {
                      x: t.x,
                      y: t.y
                    };
                  k.current = {
                    mode: "words",
                    begin: n
                  }, f((0, th.sC)(o, i, n, n, "words", T())), e.detail >= 3 && f((0, th.Ow)(o, i, "everything", T()));
                }
              },
              onClick: e => {
                e.preventDefault(), e.stopPropagation();
              },
              onKeyDown: F
            }, O, I, {
              onContextMenu: jr.PF,
              style: dh(dh({}, U), {}, {
                resize: "none",
                opacity: 0,
                touchAction: "none",
                left: 0,
                top: 0,
                transform: void 0,
                transformOrigin: void 0
              }),
              defaultValue: u.layoutView.lines.map(e => (0, ml.z8)(e.elements)).join(" ")
            })), C ? d.createElement(d.Fragment, null, d.createElement("div", {
              draggable: !0,
              onPointerDown: $(ml.Tl, -1),
              className: h()(oh().resizeHandle, oh().resizeHandleLeft)
            }, d.createElement("div", {
              className: oh().resizeHandleCircle
            })), d.createElement("div", {
              draggable: !0,
              onPointerDown: $(ml.Im, 1),
              className: h()(oh().resizeHandle, oh().resizeHandleRight)
            }, d.createElement("div", {
              className: oh().resizeHandleCircle
            }))) : null));
          },
          hh = d.memo(ph),
          fh = e => {
            const {
                page: t,
                textBlockId: n,
                zoomLevel: r,
                frameWindow: o
              } = e,
              i = (0, l.v9)(e => {
                const r = (0, Js.aT)(t.pageIndex, n)(e);
                return (0, Ce.k)(r), r.anchor;
              }),
              a = (0, l.v9)(e => (0, Js.aT)(t.pageIndex, n)(e));
            (0, Ce.k)(a);
            const s = (0, l.v9)(e => (0, Js.Dn)(t.pageIndex, n)(e)),
              u = (0, l.v9)(e => e.contentEditorSession.contentEditor);
            return d.createElement("div", {
              className: "PSPDFKit-Content-Editing-Text-Block"
            }, d.createElement(eh, {
              page: t,
              textBlockId: n,
              anchor: i,
              zoomLevel: r,
              textBlockState: a,
              isActive: s,
              contentEditor: u
            }), d.createElement(hh, {
              page: t,
              textBlockId: n,
              anchor: i,
              zoomLevel: r,
              isActive: s,
              textBlockState: a,
              frameWindow: o
            }));
          },
          mh = d.memo(fh);
        function gh(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function vh(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? gh(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gh(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const yh = e => {
            const t = (0, l.I0)(),
              {
                formatMessage: n
              } = (0, xe.YB)(),
              {
                page: r,
                zoomLevel: o,
                backend: i,
                frameWindow: a
              } = e;
            d.useEffect(() => {
              var e;
              t((e = r.pageIndex, async (t, n) => {
                if ((0, Js.Cd)(e)(n()) != Js.R1.Uninitialized) return;
                t({
                  type: V.l$y,
                  pageIndex: e
                });
                const r = n().contentEditorSession;
                (0, u.kG)(r.contentEditor);
                const o = await r.contentEditor.detectParagraphs(e);
                t({
                  type: V.kD6,
                  pageIndex: e,
                  initialTextBlocks: o
                });
              }));
            }, [t, r.pageIndex]);
            const s = r.pageSize.height * o,
              c = r.pageSize.width * o,
              p = (0, l.v9)((0, Js.jI)(r.pageIndex), l.wU),
              h = (0, l.v9)(e => e.contentEditorSession.mode),
              f = h === Js.wR.Create,
              m = h === Js.wR.Delete,
              g = (0, l.v9)(e => (0, G.zi)(e, r.pageIndex)),
              v = (0, l.v9)(e => e.contentEditorSession.textBlockInteractionState.state),
              y = v === Js.FP.Active,
              b = v === Js.FP.Moving;
            return d.createElement("div", {
              tabIndex: 0,
              onPointerDown: e => {
                if (f) {
                  const n = new _.E9({
                      x: e.clientX,
                      y: e.clientY
                    }).apply(g),
                    o = new Js.Sg({
                      x: n.x,
                      y: n.y
                    });
                  t((0, th.rO)(r.pageIndex, o));
                } else m || (y && (e.preventDefault(), e.stopPropagation()), t(th.Pq));
              },
              className: "content-editing-overlay",
              style: vh({
                position: "absolute",
                top: 0,
                left: 0,
                touchAction: b ? "none" : "auto",
                height: s,
                width: c,
                zIndex: 1
              }, f ? {
                cursor: "text"
              } : {})
            }, m && d.createElement(vu.Z, {
              onConfirm: () => t(th.um),
              onCancel: () => t((0, th.u)(Js.wR.Edit)),
              accessibilityLabel: n(ah.deleteTextBlockConfirmAccessibilityLabel),
              accessibilityDescription: n(ah.deleteTextBlockConfirmAccessibilityDescription),
              "aria-atomic": !0,
              restoreOnClose: !1
            }, d.createElement("p", null, n(ah.deleteTextBlockConfirmMessage))), p.map(e => d.createElement(mh, {
              key: e,
              backend: i,
              textBlockId: e,
              page: r,
              zoomLevel: o,
              frameWindow: a
            })));
          },
          bh = d.memo(yh);
        function wh(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xh(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wh(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wh(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Dh = {
          [B.A.BUTTON_WIDGET]: [120, 40],
          [B.A.CHECKBOX_WIDGET]: [32, 32],
          [B.A.COMBO_BOX_WIDGET]: [220, 40],
          [B.A.LIST_BOX_WIDGET]: [220, 150],
          [B.A.RADIO_BUTTON_WIDGET]: [32, 32],
          [B.A.SIGNATURE_WIDGET]: [220, 150],
          [B.A.TEXT_WIDGET]: [220, 40],
          [B.A.DATE_WIDGET]: [220, 40]
        };
        let Ch = 0;
        var Sh = n(40193),
          Eh = n.n(Sh),
          _h = n(11568),
          Ph = n.n(_h);
        const kh = e => {
          let {
            pageSize: t
          } = e;
          const n = (0, l.v9)(e => e.hintLines);
          return n ? d.createElement("svg", {
            id: "hint-lines",
            viewBox: `0 0 ${t.width} ${t.height}`,
            className: Ph().hintLineSvg
          }, n.lines.map((e, t) => d.createElement("line", {
            key: t,
            x1: e.start.x,
            y1: e.start.y,
            x2: e.end.x,
            y2: e.end.y,
            className: Ph().line
          }))) : null;
        };
        class Ah extends d.Component {
          constructor(e) {
            super(e), (0, o.Z)(this, "pageRef", d.createRef()), (0, o.Z)(this, "_handleOverviewRenderFinished", () => {
              this.setState({
                isOverviewRendered: !0
              }), this.props.onInitialOverviewRenderFinished && this.props.onInitialOverviewRenderFinished(this.props.page.pageIndex);
            }), (0, o.Z)(this, "_handleScroll", e => {
              this.pageRef.current && (this.pageRef.current.scrollTop = 0, this.pageRef.current.scrollLeft = 0), e.stopPropagation(), e.preventDefault();
            }), (0, o.Z)(this, "_handleOnPressEmit", (e, t) => {
              const n = {
                pageIndex: this.props.page.pageIndex,
                point: t,
                nativeEvent: e.nativeEvent
              };
              this.props.eventEmitter.emit("page.press", n);
            }), (0, o.Z)(this, "onCropAreaChangeComplete", e => {
              const t = (0, He.kI)(e, this.props.page.pageSize, this.props.viewportState.pagesRotation),
                n = {
                  cropBox: t,
                  pageIndex: this.props.page.pageIndex
                };
              this.props.eventEmitter.emit("cropArea.changeStop", n), this.props.onCropChange(t, this.props.page.pageIndex);
            }), (0, o.Z)(this, "onCropAreaChangeStart", e => {
              const t = (0, He.kI)(e, this.props.page.pageSize, this.props.viewportState.pagesRotation),
                n = {
                  cropBox: t,
                  pageIndex: this.props.page.pageIndex
                };
              this.props.eventEmitter.emit("cropArea.changeStart", n), this.props.onCropChange(t, this.props.page.pageIndex);
            }), (0, o.Z)(this, "createWidgetAnnotation", e => {
              var t, n, r;
              e.stopPropagation(), this.props.dispatch((t = this.props.page.pageIndex, n = [e.pageX, e.pageY], r = this.props.intl, async (e, o) => {
                const {
                  interactionMode: i,
                  viewportState: a,
                  onWidgetAnnotationCreationStart: l,
                  changeManager: c
                } = o();
                Ch++;
                const d = (0, G.Ek)(a, t),
                  p = (0, j.xc)();
                (0, u.kG)(i, "interactionMode is not defined");
                const h = Dh[i],
                  f = new Date();
                let m,
                  g = new _.x_(xh(xh({
                    id: p,
                    formFieldName: `${i}_${(0, Fa.C)()}`,
                    boundingBox: new _.UL({
                      left: n[0],
                      top: n[1],
                      width: h[0],
                      height: h[1]
                    }).apply(d),
                    pageIndex: t,
                    createdAt: f,
                    updatedAt: f,
                    fontSize: 12
                  }, i === B.A.BUTTON_WIDGET ? {
                    backgroundColor: _.Il.BLUE,
                    fontColor: _.Il.WHITE
                  } : {}), i === B.A.DATE_WIDGET ? {
                    additionalActions: {
                      onFormat: new _.bp({
                        script: 'AFDate_FormatEx("yyyy-mm-dd")'
                      })
                    }
                  } : {}));
                switch (i) {
                  case B.A.BUTTON_WIDGET:
                    m = new _.R0({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName,
                      buttonLabel: "Button"
                    });
                    break;
                  case B.A.TEXT_WIDGET:
                  case B.A.DATE_WIDGET:
                    m = new _.$o({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName
                    });
                    break;
                  case B.A.RADIO_BUTTON_WIDGET:
                    m = new _.XQ({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName,
                      options: (0, s.aV)([new _.mv({
                        label: r.formatMessage(Th.labelX, {
                          arg0: 1
                        }),
                        value: `Value ${Ch}`
                      })])
                    });
                    break;
                  case B.A.CHECKBOX_WIDGET:
                    m = new _.rF({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName,
                      options: (0, s.aV)([new _.mv({
                        label: r.formatMessage(Th.labelX, {
                          arg0: 1
                        }),
                        value: `Value ${Ch}`
                      })])
                    });
                    break;
                  case B.A.SIGNATURE_WIDGET:
                    m = new _.Yo({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName
                    });
                    break;
                  case B.A.LIST_BOX_WIDGET:
                    m = new _.Vi({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName,
                      options: (0, s.aV)([new _.mv({
                        label: "Option 1",
                        value: `Value ${Ch}`
                      })])
                    });
                    break;
                  case B.A.COMBO_BOX_WIDGET:
                    m = new _.fB({
                      annotationIds: (0, s.aV)([g.id]),
                      name: g.formFieldName,
                      options: (0, s.aV)([new _.mv({
                        label: "Option 1",
                        value: "Option 1"
                      }), new _.mv({
                        label: "Option 2",
                        value: "Option 2"
                      })])
                    });
                    break;
                  default:
                    throw new Error(`Unknown interaction mode: ${i}`);
                }
                if (m = m.set("id", (0, Fa.C)()), l) {
                  const e = l(g, m);
                  g = e.annotation || g, m = e.formField || m, (0, u.kG)(g instanceof _.x_, "widgetAnnotation must be an instance of WidgetAnnotation"), (0, u.kG)(m instanceof _.Wi, "formField must be an instance of FormField"), (0, u.kG)(g.formFieldName === m.name, "widgetAnnotation.formFieldName must be equal to formField.name"), (0, u.kG)(t === g.pageIndex, "You are not allowed to change the pageIndex");
                }
                e({
                  type: V.vgx,
                  annotationId: g.id
                }), null == c || c.create([g, m]), e((0, er.el)()), e((0, _e.J4)((0, s.l4)([g.id]), N.o.SELECTED));
              }));
            }), this._contentBlocksPromise = null, this._cancelTextPromise = null, this.state = {
              hasBeenInViewport: e.inViewport,
              isOverviewRendered: !e.renderPagePreview
            };
          }
          shouldComponentUpdate(e, t) {
            return !!e.page && (this.props.isReused !== e.isReused || this.props.page.pageIndex !== e.page.pageIndex || !(!e.inViewport || this.props.inViewport) || !(e.inViewport || !this.props.inViewport) || e.shouldPrerender !== this.props.shouldPrerender || (e.inViewport ? Pe.O.call(this, e, t) : this.props.interactionMode === B.A.CONTENT_EDITOR && e.interactionMode !== B.A.CONTENT_EDITOR || this.props.viewportState.zoomLevel !== e.viewportState.zoomLevel));
          }
          UNSAFE_componentWillReceiveProps(e) {
            e.inViewport && !this.state.hasBeenInViewport && this.setState({
              hasBeenInViewport: !0
            });
          }
          UNSAFE_componentWillMount() {
            (this.props.inViewport || this.props.shouldPrerender) && this.componentWillEnterViewport(this.props), this.props.inViewport && this.setState({
              hasBeenInViewport: !0
            });
          }
          UNSAFE_componentWillUpdate(e) {
            this.props.isReused ? (this._resetTextLines(), this._fetchPageContent(e)) : !this.props.inViewport && e.inViewport || e.shouldPrerender ? this.componentWillEnterViewport(e) : this.props.inViewport && !e.inViewport && this.componentWillExitViewport();
          }
          componentDidUpdate(e) {
            this.state.isOverviewRendered && this.props.onInitialOverviewRenderFinished && this.props.parent !== e.parent && this.props.onInitialOverviewRenderFinished(this.props.page.pageIndex), e.page.pageKey !== this.props.page.pageKey && (this._resetTextLines(), this.fetchTextLinesForProps(this.props));
          }
          componentWillEnterViewport(e) {
            this._fetchPageContent(e);
          }
          _fetchPageContent(e) {
            e.annotationManager.loadAnnotationsForPageIndex(e.page.pageIndex), null == e.page.contentBlocks && null == this._contentBlocksPromise && this.fetchTextLinesForProps(e);
          }
          componentWillExitViewport() {
            this._resetTextLines();
          }
          _resetTextLines() {
            this._contentBlocksPromise && this._cancelTextPromise && (this._cancelTextPromise(), this._contentBlocksPromise = null);
          }
          async fetchTextLinesForProps(e) {
            if (!this.props.enableTextLoading || this.props.interactionMode === B.A.CONTENT_EDITOR) return void e.dispatch((0, El.wY)(e.page.pageIndex, (0, s.aV)()));
            const {
              promise: t,
              cancel: n
            } = e.backend.getContentTreeForPageIndex(e.page.pageIndex);
            this._contentBlocksPromise = t, this._cancelTextPromise = n;
            try {
              const t = await this._contentBlocksPromise;
              e.dispatch((0, El.wY)(e.page.pageIndex, t));
            } catch (e) {
              if (e && !e.aborted) throw e;
            }
          }
          isWithinRange() {
            const {
              page: {
                pageIndex: e
              },
              viewportState: {
                currentPageIndex: t
              }
            } = this.props;
            return e >= Math.min(0, t - 2) && e <= t + 2;
          }
          render() {
            const {
                props: e
              } = this,
              {
                page: t,
                intl: n,
                innerRef: r,
                viewportState: o,
                frameWindow: a,
                cropInfo: s
              } = e,
              {
                formatMessage: l
              } = n,
              u = {
                width: t.pageSize.width * o.zoomLevel,
                height: t.pageSize.height * o.zoomLevel
              };
            let c = {
              height: u.height,
              width: u.width,
              transform: E.sl.IDENTITY.rotate(-o.pagesRotation).toCssValue()
            };
            if (90 === o.pagesRotation || 270 === o.pagesRotation) {
              const e = (u.height - u.width) / 2;
              c = {
                height: u.width,
                width: u.height,
                transform: E.sl.IDENTITY.rotate(o.pagesRotation).translate({
                  x: -e,
                  y: e
                }).toCssValue()
              };
            }
            const p = h()({
              "PSPDFKit-Page": !0,
              [`PSPDFKit-Page-Rotation-${o.pagesRotation}-degree`]: !0,
              [Eh().root]: !0,
              [Eh()["deg-" + o.pagesRotation]]: !0,
              [Eh().textHighlighterMode]: e.interactionMode === B.A.TEXT_HIGHLIGHTER || e.interactionMode === B.A.REDACT_TEXT_HIGHLIGHTER,
              [Eh().hideCursor]: (0, Ke.o6)(e.interactionMode)
            });
            return t ? d.createElement("section", {
              className: p,
              style: u,
              ref: this.pageRef,
              "data-page-index": t.pageIndex,
              "data-page-is-loaded": null !== t.contentBlocks && this.state.isOverviewRendered,
              onScroll: this._handleScroll,
              key: t.pageKey,
              "aria-label": l(Th.pageX, {
                arg0: t.pageLabel || t.pageIndex + 1
              }),
              tabIndex: e.documentHasActiveAnnotation ? -1 : 0
            }, d.createElement("div", {
              className: Eh().focusPage,
              ref: r
            }), this.state.hasBeenInViewport && this.state.isOverviewRendered && t.contentBlocks ? null : d.createElement(i.TX, null, l(ke.Z.loading)), d.createElement(Dp, {
              pageIndex: t.pageIndex,
              onEmit: this._handleOnPressEmit,
              element: "div"
            }, (this.state.hasBeenInViewport || this.state.isOverviewRendered || e.shouldPrerender) && d.createElement(wp.Z, {
              inViewport: e.inViewport,
              shouldPrerender: !e.inViewport && e.shouldPrerender,
              page: t,
              backend: e.backend,
              zoomLevel: o.zoomLevel,
              rotation: o.pagesRotation,
              renderPageCallback: e.renderPageCallback,
              onInitialOverviewRenderFinished: this._handleOverviewRenderFinished,
              allowedTileScales: e.allowedTileScales,
              viewportRect: o.viewportRect,
              forceDetailView: !1,
              renderPagePreview: e.renderPagePreview,
              isPageSizeReal: e.isPageSizeReal,
              inContentEditorMode: e.interactionMode === B.A.CONTENT_EDITOR
            }), e.interactionMode === B.A.CONTENT_EDITOR && e.inViewport && !!e.contentEditor && d.createElement(bh, {
              backend: e.backend,
              zoomLevel: o.zoomLevel,
              page: t,
              frameWindow: a
            }), this.props.hintLinesPageIndex === t.pageIndex ? d.createElement(kh, {
              pageSize: t.pageSize
            }) : null, this.state.hasBeenInViewport && this.state.isOverviewRendered && d.createElement(d.Fragment, null, d.createElement(_p, {
              pageIndex: t.pageIndex,
              zoomLevel: o.zoomLevel
            }), d.createElement(Xl.Consumer, null, n => d.createElement(up, {
              page: t,
              getScrollElement: n,
              setGlobalCursor: this.props.setGlobalCursor
            }, t.contentBlocks ? d.createElement(Np, {
              dispatch: e.dispatch,
              enableTextSelection: e.enableTextSelection,
              zoomLevel: o.zoomLevel,
              rotation: o.pagesRotation,
              eventEmitter: e.eventEmitter,
              isTextCopyingAllowed: e.isTextCopyingAllowed,
              isPanModeEnabled: e.isPanModeEnabled,
              pageIndex: t.pageIndex,
              contentBlocks: t.contentBlocks,
              textLineScales: t.textLineScales,
              pageSize: t.pageSize,
              textElementFonts: t.textElementFonts
            }) : null)), e.interactionMode === B.A.MARQUEE_ZOOM ? d.createElement(Up, {
              pageIndex: t.pageIndex,
              pageSize: t.pageSize,
              scrollElement: e.scrollElement
            }) : null, e.customOverlayItems.size > 0 && d.createElement("div", null, e.customOverlayItems.map(e => d.createElement(bp, {
              key: e.id,
              item: e,
              rotation: o.pagesRotation,
              zoomLevel: o.zoomLevel
            }))))), e.interactionMode === B.A.DOCUMENT_CROP && (null === s && this.isWithinRange() || (null == s ? void 0 : s.pageIndex) === t.pageIndex) && d.createElement("div", {
              style: c
            }, d.createElement(Ca, {
              viewportState: o,
              page: this.props.page,
              onAreaChangeComplete: this.onCropAreaChangeComplete,
              frameWindow: a,
              onAreaChangeStart: this.onCropAreaChangeStart
            })), (0, Ke.o6)(e.interactionMode) && d.createElement("div", {
              style: c
            }, d.createElement(Wp, {
              frameWindow: a,
              pageRef: this.pageRef,
              interactionMode: e.interactionMode,
              pageIndex: t.pageIndex,
              onCreate: this.createWidgetAnnotation,
              intl: e.intl
            }))) : null;
          }
        }
        const zh = (0, xe.XN)(Ah),
          Th = (0, xe.vU)({
            pageX: {
              id: "pageX",
              defaultMessage: "Page {arg0}",
              description: "Current page"
            },
            labelX: {
              id: "labelX",
              defaultMessage: "Label {arg0}",
              description: "Label"
            }
          });
        const Oh = (0, qn.x)(function (e, t) {
          var n;
          const r = e.pages.get(t.pageIndex),
            o = (null == r ? void 0 : r.customOverlayItemIds.map(t => e.customOverlayItems.get(t)).toList()) || null;
          return {
            frameWindow: e.frameWindow,
            enableTextLoading: (0, Kn.$Q)(e),
            enableTextSelection: e.interactionMode !== B.A.PAN,
            annotationManager: e.annotationManager,
            backend: e.backend,
            customOverlayItems: o,
            eventEmitter: e.eventEmitter,
            page: r,
            isTextCopyingAllowed: (0, Kn.HI)(e),
            renderPageCallback: e.renderPageCallback,
            interactionMode: e.interactionMode,
            documentHasActiveAnnotation: e.selectedAnnotationIds.size > 0,
            allowedTileScales: e.allowedTileScales,
            isPanModeEnabled: e.interactionMode === B.A.PAN && !De.Ni,
            viewportState: e.viewportState,
            scrollElement: e.scrollElement,
            isReused: !!e.reuseState,
            renderPagePreview: e.renderPagePreview,
            isPageSizeReal: e.firstCurrentPageIndex === t.pageIndex || e.arePageSizesLoaded,
            hintLinesPageIndex: null === (n = e.hintLines) || void 0 === n ? void 0 : n.pageIndex,
            contentEditor: e.contentEditorSession.contentEditor
          };
        })(zh);
        class Ih extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "spreadRef", d.createRef()), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "pageIndexesWaitingForRender", (0, ts.P1)(this.props.viewportState, this.props.spreadIndex)), (0, o.Z)(this, "_handleOverviewRenderFinished", e => {
              if (this.props.onOverviewRenderFinished) {
                const t = this.pageIndexesWaitingForRender.indexOf(e);
                t > -1 && this.pageIndexesWaitingForRender.splice(t, 1), 0 === this.pageIndexesWaitingForRender.length && this.props.onOverviewRenderFinished && this.props.onOverviewRenderFinished(this.props.spreadIndex);
              }
            });
          }
          render() {
            const {
                spreadIndex: e,
                viewportState: t,
                inViewport: n,
                shouldPrerender: r,
                onCropChange: o,
                cropInfo: i
              } = this.props,
              a = (0, ts.Xk)(t, e);
            return d.createElement("div", {
              style: {
                width: a.width * t.zoomLevel,
                height: a.height * t.zoomLevel
              },
              hidden: this.props.hidden
            }, (0, ts.P1)(t, e).map(a => {
              const s = (0, G.DB)(E.sl.IDENTITY, t, a, e, t.zoomLevel),
                l = this.props.pageKeys.get(a);
              return d.createElement("div", {
                key: l,
                style: {
                  transform: s.toCssValue(!0),
                  transformOrigin: "0 0",
                  position: "absolute"
                }
              }, d.createElement(ue.Reparent, {
                id: `page-${l}`
              }, d.createElement(Oh, {
                pageIndex: a,
                inViewport: n,
                shouldPrerender: r,
                viewportRect: t.viewportRect,
                onInitialOverviewRenderFinished: this._handleOverviewRenderFinished,
                innerRef: this.props.innerRef,
                parent: this.spreadRef,
                onCropChange: o,
                cropInfo: i,
                setGlobalCursor: this.props.setGlobalCursor
              })));
            }));
          }
        }
        var Fh = n(80444),
          Mh = n(14286);
        const Rh = d.memo(function (e) {
          const {
              viewportState: t
            } = e,
            {
              lastScrollUsingKeyboard: n
            } = t,
            r = d.useRef(null),
            o = (0, ts.dF)(t, t.currentPageIndex),
            [i, a] = (0, ts.wU)(t, o);
          return d.useEffect(() => {
            var e;
            const i = (0, ts.kd)(t),
              a = null !== (e = t.prerenderedPageSpreads) && void 0 !== e ? e : i;
            o - a > 0 && r.current && n && r.current.focus({
              preventScroll: !0
            });
          }, [o, n, t]), 0 === t.viewportRect.width || 0 === t.viewportRect.height ? null : d.createElement(Fh.Z, {
            dispatch: e.dispatch,
            viewportState: t
          }, d.createElement("div", null, function () {
            const {
                viewportState: t,
                viewportState: {
                  viewportRect: n,
                  scrollPosition: s,
                  zoomLevel: l
                },
                onCropChange: u,
                cropInfo: c
              } = e,
              p = (0, ts.kd)(t),
              h = s.y,
              f = s.y + n.height / l,
              m = (0, ts.Ad)(t);
            let g = 0,
              v = 0;
            const y = [];
            for (let n = 0; n < p; n++) {
              var b;
              const s = (0, ts.Xk)(t, n);
              v = g + s.height;
              const w = g < f && v > h,
                x = (m - s.width) / 2,
                D = new E.UL({
                  left: x,
                  top: g,
                  width: s.width,
                  height: s.height
                }).scale(l),
                C = {
                  left: D.left,
                  top: D.top,
                  width: D.width,
                  height: D.height,
                  position: "absolute"
                };
              v += t.spreadSpacing, g = v;
              const S = null !== (b = t.prerenderedPageSpreads) && void 0 !== b ? b : p;
              if ((0, ts.wX)(n, o, S)) {
                const s = n === o,
                  l = (0, ts.nw)(t) === Mh.X.DOUBLE ? n.toString() : e.pageKeys.get(n);
                y.push(d.createElement("div", {
                  key: l,
                  className: "PSPDFKit-Spread",
                  style: C,
                  "data-spread-index": n
                }, d.createElement(Ih, {
                  spreadIndex: n,
                  viewportState: t,
                  inViewport: w,
                  shouldPrerender: !s && "number" == typeof i && o === i,
                  onOverviewRenderFinished: a,
                  innerRef: s ? r : void 0,
                  onCropChange: u,
                  cropInfo: c,
                  pageKeys: e.pageKeys,
                  setGlobalCursor: e.setGlobalCursor
                })));
              }
            }
            return y;
          }()));
        });
        var jh,
          Bh,
          Nh = n(93162),
          Lh = n.n(Nh),
          Vh = n(87161),
          Kh = n.n(Vh);
        class qh extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "rootRef", d.createRef()), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_handleOnClose", () => {
              this.props.dispatch((0, Kt.Sn)());
            }), (0, o.Z)(this, "_download", () => {
              Lh().saveAs(this._getBlob(), `PSPDFKit-for-Web-Debug-Output-${Date.now()}.txt`);
            });
          }
          _getDebugOutput() {
            const e = document.documentElement;
            if ((0, u.kG)(e, "externalDocumentElement must not be null"), this.rootRef.current) {
              const t = this.rootRef.current.ownerDocument.documentElement;
              return (0, u.kG)(t, "internalDocumentElement must not be null"), `-----BEGIN VERSION-----\n  PSPDFKit for Web Version: 2024.5.0 (21dad822d1)\n  PSPDFKit Document Engine Version: 2024.5.0\n  -----END VERSION-----\n\n  -----BEGIN CLIENT INFO-----\n  User Agent: ${navigator.userAgent}\n  Language: ${navigator.language}\n  Engine: ${De.SR}\n  System: ${De.By}\n  Pixel ratio: ${(0, Po.L)()}\n  -----END CLIENT INFO-----\n\n  -----BEGIN EXTERNAL HTML-----\n  ${e.innerHTML}\n  -----END EXTERNAL HTML-----\n\n  -----BEGIN INTERNAL HTML-----\n  ${t.innerHTML}\n  -----END INTERNAL HTML-----\n  `;
            }
          }
          _getBlob() {
            return new Blob([this._getDebugOutput()], {
              type: "text/plain;charset=utf-8"
            });
          }
          render() {
            return d.createElement(Gd.Z, {
              onDismiss: this._handleOnClose
            }, d.createElement("div", {
              className: Kh().root,
              ref: this.rootRef
            }, d.createElement("div", {
              className: Kh().header
            }, jh || (jh = d.createElement("h2", null, "Debug Output")), Bh || (Bh = d.createElement("p", null, "When reporting an issue to support, please provide the debug output. The output contains the PSPDFKit for Web version, information about your device, a snapshot of the current DOM. Please submit new support requests via our", " ", d.createElement("a", {
              target: "_blank",
              href: "https://pspdfkit.com/support/request"
            }, "support form"), ".")), d.createElement(i.zx, {
              onClick: this._download
            }, "Download Debug Output"))));
          }
        }
        class Hh extends d.Component {
          constructor() {
            var e;
            super(...arguments), e = this, (0, o.Z)(this, "onConfirm", () => {
              if (this.props.setA11yStatusMessage) {
                const {
                  formatMessage: e
                } = this.props.intl;
                this.props.setA11yStatusMessage(e(Zh.annotationDeleted));
              }
              const e = {
                annotations: (0, s.aV)(this.props.annotations),
                reason: J.f.DELETE_END
              };
              this.props.eventEmitter.emit("annotations.willChange", e), this.props.annotations.forEach(e => {
                this.props.dispatch((0, yt.hQ)(e));
              }), this.onCancel(!1), this.props.dispatch((0, _e.fz)());
            }), (0, o.Z)(this, "onCancel", function () {
              let t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
              if (e.props.dispatch((0, yt.d8)(null)), t) {
                const t = {
                  annotations: (0, s.aV)(),
                  reason: J.f.DELETE_END
                };
                e.props.eventEmitter.emit("annotations.willChange", t);
              }
            });
          }
          render() {
            const {
              formatMessage: e
            } = this.props.intl;
            return d.createElement(vu.Z, {
              onConfirm: this.onConfirm,
              onCancel: this.onCancel,
              accessibilityLabel: e(Zh.deleteAnnotationConfirmAccessibilityLabel),
              accessibilityDescription: e(Zh.deleteAnnotationConfirmAccessibilityDescription),
              "aria-atomic": !0,
              restoreOnClose: !1
            }, d.createElement("p", null, e(Zh.deleteAnnotationConfirmMessage)));
          }
        }
        const Uh = (0, xe.XN)(Hh),
          Zh = (0, xe.vU)({
            deleteAnnotationConfirmMessage: {
              id: "deleteAnnotationConfirmMessage",
              defaultMessage: "Are you sure you want to delete this annotation?",
              description: 'Message displayed in the "Delete Annotation" confirm dialog'
            },
            deleteAnnotationConfirmAccessibilityLabel: {
              id: "deleteAnnotationConfirmAccessibilityLabel",
              defaultMessage: "Confirm annotation deletion",
              description: 'Accessibility label (title) for the "Delete Annotation" confirm dialog'
            },
            deleteAnnotationConfirmAccessibilityDescription: {
              id: "deleteAnnotationConfirmAccessibilityDescription",
              defaultMessage: "Dialog allowing the user to confirm or cancel deleting the annotation",
              description: 'Accessibility description for the "Delete Annotation" confirm dialog'
            },
            annotationDeleted: {
              id: "annotationDeleted",
              defaultMessage: "Annotation deleted.",
              description: "An annotation has been deleted."
            }
          });
        function $h(e) {
          let {
            locale: t
          } = e;
          const n = (0, d.useRef)(null);
          return (0, d.useEffect)(function () {
            const e = n.current;
            if (!e) return;
            const r = e.ownerDocument.documentElement;
            r && (r.lang = t);
          }, [t]), d.createElement("div", {
            ref: n
          });
        }
        var Gh = n(33056),
          Wh = n(93952),
          Yh = n.n(Wh);
        function Xh(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Qh(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Xh(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Xh(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class Jh extends d.PureComponent {
          render() {
            const {
              outlineElements: e,
              expanded: t,
              navigationDisabled: n,
              onRenderItemCallback: r
            } = this.props;
            return e.map((e, o) => {
              const {
                  isBold: a,
                  isItalic: s,
                  children: l,
                  action: u,
                  color: c
                } = e,
                p = `${this.props.parentLevel}-${o}`;
              let f = t.get(p);
              "boolean" != typeof f && (f = e.isExpanded);
              const m = l.size > 0,
                g = d.createElement("span", {
                  className: h()(Yh().controlContainer, {
                    [Yh().controlContainerNoIcon]: !m,
                    [Yh().controlContainerNavigationDisabled]: !m && n
                  })
                }, m && d.createElement("span", {
                  onClick: e => {
                    e.stopPropagation(), this.props.onPress(p, null, m);
                  }
                }, d.createElement(Ae.Z, {
                  type: "caret",
                  className: h()(Yh().icon, f && Yh().iconExpanded),
                  style: {
                    width: 24,
                    height: 24
                  }
                })), d.createElement("span", {
                  className: Yh().control,
                  style: Qh({
                    fontWeight: a ? "bold" : void 0,
                    fontStyle: s ? "italic" : void 0
                  }, c ? {
                    color: c.toCSSValue()
                  } : null)
                }, e.title)),
                v = () => {
                  this.props.onPress(p, u, m);
                },
                y = r ? t => r(t, e) : void 0;
              if (!m || !f) return d.createElement(i.w6, {
                key: p,
                onPress: v,
                expanded: !1,
                autoFocus: 0 === o && "0" === this.props.parentLevel,
                headingRef: y
              }, g);
              const b = `outline-control-${p}`;
              return d.createElement("div", {
                key: p,
                ref: y
              }, d.createElement(i.w6, {
                onPress: v,
                expanded: f,
                ariaControls: b,
                autoFocus: 0 === o && "0" === this.props.parentLevel
              }, g), d.createElement(i.F0, {
                expanded: f,
                id: b
              }, d.createElement("div", {
                className: Yh().content
              }, d.createElement(Jh, {
                parentLevel: p,
                onPress: this.props.onPress,
                outlineElements: l,
                expanded: t,
                navigationDisabled: n,
                onRenderItemCallback: r
              }))));
            });
          }
        }
        (0, o.Z)(Jh, "defaultProps", {
          parentLevel: "0"
        });
        var ef,
          tf = n(25217),
          nf = n.n(tf),
          rf = n(78055),
          of = n.n(rf);
        const af = d.memo(function (e) {
            const {
                outlineElements: t,
                expanded: n,
                backend: r,
                documentHandle: o,
                navigationDisabled: i,
                closeOnPress: a = !1
              } = e,
              [s, c] = d.useState(null);
            d.useEffect(() => {
              null == s || s.focus();
            }, [s]);
            const p = (0, l.I0)();
            d.useEffect(() => {
              t || ((0, u.kG)(r), r.getDocumentOutline().then(e => {
                p((0, Gh.o)(e));
              }));
            }, []);
            const f = (0, po.jC)(e);
            d.useEffect(() => {
              o === (null == f ? void 0 : f.documentHandle) || t || ((0, u.kG)(r), r.getDocumentOutline().then(e => {
                p((0, Gh.o)(e));
              }));
            });
            const m = (0, po.R9)((e, t, n) => {
                n && p((0, Gh.Q)(e)), i || (setTimeout(() => {
                  t && p((0, Gr.aG)(t));
                }), a && !n && p((0, Kt.mu)()));
              }),
              g = t || null,
              v = (0, po.Bo)(s, g),
              y = (0, po.mP)(v, e => e.title, e => null == g ? void 0 : g.find(t => t.title === e)),
              b = h()(Yh().container, !t && Yh().empty + " PSPDFKit-Sidebar-Loading", t && 0 === t.size && Yh().empty + " PSPDFKit-Sidebar-Empty", "PSPDFKit-Sidebar-Document-Outline"),
              {
                formatMessage: w
              } = (0, xe.YB)();
            return g ? 0 === g.size ? d.createElement("div", {
              className: b,
              ref: c
            }, w(sf.noOutline)) : d.createElement("div", {
              className: b,
              role: "region",
              "aria-label": w(sf.outline),
              ref: c
            }, d.createElement("div", {
              className: of().sidebarHeader
            }, d.createElement("h2", {
              "aria-hidden": "true",
              className: h()(nf().heading, "PSPDFKit-Sidebar-Document-Outline-Heading")
            }, d.createElement("span", null, w(sf.outline)))), d.createElement(Jh, {
              outlineElements: g,
              expanded: n,
              onPress: m,
              navigationDisabled: i,
              onRenderItemCallback: y
            })) : d.createElement("div", {
              className: b,
              ref: c
            }, ef || (ef = d.createElement(Be.Z, null)));
          }),
          sf = (0, xe.vU)({
            noOutline: {
              id: "noOutline",
              defaultMessage: "No Outline",
              description: "Message shown when there is no document outline / table of contents"
            },
            outline: {
              id: "outline",
              defaultMessage: "Outline",
              description: "Outline"
            }
          });
        class lf extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_handleKeydown", e => {
              var t;
              const n = (null === (t = this.props.shadowRoot) || void 0 === t ? void 0 : t.activeElement) || this.props.document.activeElement;
              this.props.hasSelectedAnnotations || n && "BODY" !== n.tagName && (0, jr.Qu)(n) || e.shiftKey || e.metaKey || e.ctrlKey || e.alt || (e.keyCode === br.P9 && this._handleKeyLeft(), e.keyCode === br.gs && this._handleKeyRight());
            }), (0, o.Z)(this, "_handleKeyRight", () => {
              const e = (0, ns.TW)(this.props.viewportState);
              Math.ceil(this.props.viewportState.scrollPosition.x) >= Math.floor(e.x) && this.props.dispatch((0, Ql.fz)());
            }), (0, o.Z)(this, "_handleKeyLeft", () => {
              Math.floor(this.props.viewportState.scrollPosition.x) <= 0 && this.props.dispatch((0, Ql.IT)());
            });
          }
          componentDidMount() {
            var e;
            ((null === (e = this.props.shadowRoot) || void 0 === e ? void 0 : e.ownerDocument) || this.props.document).addEventListener("keydown", this._handleKeydown);
          }
          componentWillUnmount() {
            var e;
            ((null === (e = this.props.shadowRoot) || void 0 === e ? void 0 : e.ownerDocument) || this.props.document).removeEventListener("keydown", this._handleKeydown);
          }
          render() {
            const {
              children: e
            } = this.props;
            return void 0 === e ? null : e;
          }
        }
        var uf = n(51722),
          cf = n(73900);
        function df(e, t, n) {
          return async (r, o) => {
            const {
                viewportState: {
                  currentPageIndex: i
                },
                formFields: a
              } = o(),
              l = [],
              c = [];
            for (const t of e) {
              const {
                  annotation: e,
                  formField: o,
                  attachmentBlobPromise: d
                } = t,
                p = "COPY" === n && t.annotation.pageIndex === i ? new _.E9({
                  x: 20,
                  y: 20
                }) : t.offset;
              if (e instanceof _.x_) {
                const t = a.get(e.formFieldName) || o;
                (0, u.kG)(t, `Form field with name "${e.formFieldName}" not found`);
                const d = (0, j.xc)(),
                  h = "CUT" === n ? e.formFieldName : `${null == t ? void 0 : t.name} copy`,
                  f = e.id === e.name;
                let m = e.set("id", d).set("formFieldName", h).set("boundingBox", p ? e.boundingBox.translate(p) : e.boundingBox).delete("group").delete("pdfObjectId");
                n && (m = m.set("pageIndex", i)), f && (m = m.set("name", d));
                let g = t.set("name", h).set("annotationIds", (0, s.aV)([d])).set("id", (0, Fa.C)()).delete("group").delete("pdfObjectId");
                t.options && "CUT" !== n && (g = g.set("options", (0, s.aV)([t.options.get(0).set("value", `${t.options.get(0).value}_1`)])).set("annotationIds", (0, s.aV)([d]))), l.push(m), r((0, yt.$d)(m)), r((0, er.kW)(g)), c.push(g);
              } else {
                const t = (0, j.xc)(),
                  o = e.id === e.name;
                let a = e.set("id", t).delete("pdfObjectId");
                if (p && (a = (0, mi.n)(a, p)), n && (a = a.set("pageIndex", i)), o && (a = a.set("name", t)), "imageAttachmentId" in e && e.imageAttachmentId && d) {
                  let e;
                  try {
                    e = await d;
                  } catch (e) {
                    throw new u.p2(`Could not retrieve attachment data: ${e.message}`);
                  }
                  (0, u.kG)(e, "Attachment not found");
                  const {
                      hash: t
                    } = await (0, Me.uq)(e),
                    n = new _.Pg({
                      data: e
                    });
                  r((0, $.O)({
                    hash: t,
                    attachment: n
                  })), a = a.set("imageAttachmentId", t);
                }
                l.push(a), r((0, yt.$d)(a));
              }
            }
            const d = {
              annotations: l,
              formFields: c,
              previousAction: n,
              originalAnnotations: e.map(e => e.annotation),
              originalFormFields: a
            };
            t(d);
          };
        }
        function pf(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function hf(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? pf(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pf(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class ff extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              copiedOrCutAnnotations: null
            }), (0, o.Z)(this, "getSelectedAnnotations", () => {
              const {
                  annotations: e,
                  selectedAnnotationsIds: t,
                  backend: n
                } = this.props,
                r = null == e ? void 0 : e.filter(e => null == t ? void 0 : t.has(e.id)).valueSeq().toArray();
              return null == r ? void 0 : r.map(e => {
                let t;
                return e instanceof _.sK && e.imageAttachmentId && (t = null == n ? void 0 : n.getAttachment(e.imageAttachmentId)), {
                  annotation: e,
                  attachmentBlobPromise: t
                };
              });
            }), (0, o.Z)(this, "handleKeyDown", async e => {
              const {
                dispatch: t,
                selectedAnnotationsIds: n,
                commentThreads: r,
                isPrinting: o,
                printingEnabled: i,
                canDeleteSelectedAnnotationCP: a,
                selectedAnnotation: c,
                eventEmitter: d,
                backend: p,
                formFields: h,
                areClipboardActionsEnabled: f,
                modalClosurePreventionError: m,
                setModalClosurePreventionError: g,
                annotations: v,
                isMultiSelectionEnabled: y,
                contentEditorSession: b,
                interactionMode: w
              } = this.props;
              (0, u.kG)(p, "backend is required");
              const x = e.composedPath()[0];
              if (e.metaKey && e.ctrlKey) return;
              if (this.props.canUndo && (e.metaKey || e.ctrlKey) && !e.shiftKey && e.keyCode === br.gx && !(0, jr.eR)(x)) return t((0, oi.Yw)()), void e.preventDefault();
              if (this.props.canRedo && !(0, jr.eR)(x) && (e.metaKey || e.ctrlKey) && e.shiftKey && e.keyCode === br.gx) return t((0, oi.KX)()), void e.preventDefault();
              if (f && (e.metaKey || e.ctrlKey) && e.keyCode === br.b8 && e.shiftKey && n && n.size > 0 && (e.preventDefault(), this.props.selectedGroupId ? t((0, Kt.UZ)(this.props.selectedGroupId)) : (0, l.dC)(() => {
                n.forEach(e => {
                  var n;
                  const r = null === (n = this.props.annotationsGroups) || void 0 === n ? void 0 : n.find(t => {
                    let {
                      annotationsIds: n
                    } = t;
                    return n.has(e);
                  });
                  r && t((0, Kt.of)(e, r.groupKey));
                });
              })), e.shiftKey) return;
              f && (e.metaKey || e.ctrlKey) && e.keyCode === br.b8 && n && n.size > 0 && (e.preventDefault(), t((0, Kt._R)(n))), (e.ctrlKey && e.keyCode === br.j4 || e.metaKey && e.keyCode === br.j4) && (t((0, _e.fz)()), t((0, Fl.Xe)()), e.preventDefault()), (e.metaKey || e.ctrlKey) && e.keyCode === br.iT && (!o && i && t((0, cf.S0)()), e.preventDefault(), e.stopImmediatePropagation()), (e.metaKey || e.ctrlKey) && e.keyCode === br.AV && (t((0, Ql.kr)()), e.preventDefault()), (e.metaKey || e.ctrlKey) && e.keyCode === br.d2 && (t((0, Ql.vG)()), e.preventDefault()), (e.metaKey || e.ctrlKey) && e.keyCode === br.Cp && (t((0, Ql._R)()), e.preventDefault());
              const {
                copiedOrCutAnnotations: D
              } = this.state;
              var C, S;
              if (f && (e.ctrlKey || e.metaKey) && D && "v" === e.key && (e.preventDefault(), e.stopPropagation(), t((C = D, (e, t) => {
                var n;
                const {
                  eventEmitter: r
                } = t();
                e(df(C, e => {
                  r.emit("annotations.paste", e);
                }, null == C || null === (n = C[0]) || void 0 === n || null === (n = n.previousAction) || void 0 === n ? void 0 : n.toUpperCase()));
              })), this.setState({
                copiedOrCutAnnotations: null
              })), f && y && (e.ctrlKey || e.metaKey) && "a" === e.key) {
                var E;
                const n = x && (0, jr.eR)(x),
                  r = null === (E = window.top) || void 0 === E ? void 0 : E.document.activeElement,
                  o = r && (0, jr.eR)(r);
                if (n || o) return;
                e.preventDefault(), e.stopPropagation();
                const i = null == v ? void 0 : v.filter(e => e.pageIndex === this.props.currentPageIndex).map(e => e.id);
                i && (0, l.dC)(() => {
                  t((0, _e.fz)()), t((0, _e.Df)(i.toSet(), null));
                });
              }
              if (b.active && b.textBlockInteractionState.state === Js.FP.Selected && ["Del", "Delete", "Backspace"].includes(e.key) && (e.preventDefault(), e.stopPropagation(), t((0, th.u)(Js.wR.Delete))), n && n.size > 0 && !(0, jr.eR)(x)) if (!["Del", "Delete", "Backspace"].includes(e.key) || r && n.some(e => r.has(e)) || !a) {
                if (f && (e.ctrlKey || e.metaKey) && c && "c" === e.key) {
                  var P;
                  e.preventDefault(), e.stopPropagation();
                  const t = null === (P = this.getSelectedAnnotations()) || void 0 === P ? void 0 : P.map(e => hf(hf({}, e), {}, {
                    previousAction: "copy"
                  }));
                  this.setState({
                    copiedOrCutAnnotations: t
                  }), d.emit("annotations.copy", {
                    annotation: c
                  });
                } else if (f && (e.ctrlKey || e.metaKey) && c && "x" === e.key) {
                  var k;
                  if (!t((S = c, (e, t) => (0, to.Kd)(S, t())))) return;
                  e.preventDefault(), e.stopPropagation();
                  const n = null === (k = this.getSelectedAnnotations()) || void 0 === k ? void 0 : k.map(e => {
                    const t = e.annotation;
                    return hf(hf({}, e), {}, {
                      formField: t instanceof _.x_ ? null == h ? void 0 : h.get(t.formFieldName) : void 0,
                      previousAction: "cut"
                    });
                  });
                  this.setState({
                    copiedOrCutAnnotations: n
                  }), d.emit("annotations.cut", {
                    annotation: c
                  }), (0, l.dC)(() => {
                    n.forEach(e => {
                      t((0, yt.hQ)(e.annotation));
                    });
                  });
                } else if (f && (e.ctrlKey || e.metaKey) && c && "d" === e.key) {
                  e.preventDefault(), e.stopPropagation();
                  const n = this.getSelectedAnnotations();
                  t(function (e) {
                    return (t, n) => {
                      const {
                        eventEmitter: r
                      } = n();
                      t(df(e, e => {
                        r.emit("annotations.duplicate", e);
                      })), t((0, _e.J4)((0, s.l4)(e.map(e => e.annotation.id)), N.o.SELECTED));
                    };
                  }(n)), this.setState({
                    copiedOrCutAnnotations: null
                  });
                } else if (!("Esc" !== e.key && "Escape" !== e.key || (0, jr.N1)(x) || (0, jr.fp)(x) || m && m.annotationId === (null == c ? void 0 : c.id))) {
                  e.preventDefault(), e.stopPropagation(), t((0, _e.fz)());
                  const r = n.first(),
                    o = this.props.getScrollElement();
                  if (o && r) {
                    const e = o.querySelector(`[data-annotation-id="${r}"]`);
                    e && (0, jr._s)(o, e);
                  }
                }
              } else (null == m ? void 0 : m.annotationId) === (null == c ? void 0 : c.id) && g(null), e.preventDefault(), e.stopPropagation(), t((0, yt.d8)(n));
              "Esc" !== e.key && "Escape" !== e.key || w !== B.A.MEASUREMENT || (0, l.dC)(() => {
                t((0, yt.Ds)(null)), t((0, Kt.hS)());
              }), e.keyCode !== br.bs || (0, jr.eR)(x) || (e.preventDefault(), e.stopPropagation());
            }), (0, o.Z)(this, "_handleRef", e => {
              this.props.shadowRoot ? this._document = this.props.shadowRoot.ownerDocument : e && !this.props.shadowRoot && (this._document = e.ownerDocument);
            });
          }
          componentDidMount() {
            this._document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keydown", this.handleKeyDown), this.props.isTextCopyingAllowed || this._document.addEventListener("copy", mf);
          }
          componentWillUnmount() {
            this._document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keydown", this.handleKeyDown), this.props.isTextCopyingAllowed || this._document.removeEventListener("copy", mf);
          }
          render() {
            return d.createElement("div", {
              ref: this._handleRef
            });
          }
        }
        function mf(e) {
          const {
            target: t
          } = e;
          (0, uf.c)(t) || e.preventDefault();
        }
        const gf = ["highlight", "strikeout", "underline", "squiggle", "redact-text-highlighter", "comment", "document-assistant"],
          vf = (0, I.Z)("InlineTextSelectionToolbarItem ");
        var yf = n(23514),
          bf = n.n(yf);
        function wf(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xf(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wf(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wf(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Df = new Map([["highlight", _.FV], ["strikeout", _.R9], ["underline", _.xu], ["squiggle", _.hL], ["redact-text-highlighter", W.Z], ["comment", _.Jn]]);
        function Cf(e) {
          return e.node ? d.createElement(uc.Z, {
            node: e.node,
            title: e.title,
            className: e.className,
            icon: e.icon,
            onPress: e.onPress,
            selected: e.selected,
            disabled: e.disabled
          }) : d.createElement(Ju.Z, {
            type: e.type,
            title: e.title,
            className: e.className,
            icon: e.icon,
            onPress: e.onPress,
            selected: e.selected,
            disabled: e.disabled
          });
        }
        function Sf(e) {
          const t = (0, xe.YB)(),
            {
              dispatch: n,
              isAnnotationTypeReadOnly: r,
              showComments: o,
              showRedactions: i,
              showDocumentAssistant: a,
              hasMobileLayout: s,
              inlineTextSelectionToolbarItems: l,
              currentTextSelection: c
            } = e,
            p = t.formatMessage,
            f = d.useCallback((e, t) => {
              n((0, yt.VX)(e, t)), n((0, _e.fz)());
            }, [n]),
            m = d.useCallback(() => {
              n((0, yo.cQ)());
            }, [n]),
            g = d.useCallback(() => {
              c && (n((0, Kt.Z_)(!0)), n((0, Kt.vM)(c)));
            }, [n, c]),
            v = h()({
              [bf().button]: !s
            }, {
              [ac().button]: s
            }),
            y = d.useMemo(() => {
              const e = [{
                type: "highlight",
                title: p(ke.Z.highlightAnnotation),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Highlight", v),
                onPress: () => {
                  f(_.FV, "highlight");
                }
              }, {
                type: "strikeout",
                title: p(ke.Z.strikeOutAnnotation),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Strike-Out", v),
                onPress: () => {
                  f(_.R9, "strikeout");
                }
              }, {
                type: "underline",
                title: p(ke.Z.underlineAnnotation),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Underline", v),
                onPress: () => {
                  f(_.xu, "underline");
                }
              }, {
                type: "squiggle",
                title: p(ke.Z.squiggleAnnotation),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Squiggle", v),
                onPress: () => {
                  f(_.hL, "squiggle");
                }
              }];
              return o && e.push({
                type: "comment",
                title: p(ke.Z.comment),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Comment", v),
                onPress: () => {
                  m();
                }
              }), i && e.push({
                type: "redact-text-highlighter",
                title: p(ke.Z.redactionAnnotation),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Redaction", v),
                onPress: () => {
                  f(W.Z, "redaction");
                }
              }), a && e.unshift({
                type: "document-assistant",
                title: p(ke.Z.documentAI),
                className: h()("PSPDFKit-Text-Markup-Inline-Toolbar-Document-Assistant", v),
                onPress: () => {
                  g();
                }
              }), e;
            }, [f, v, p, m, o, i, a, g]),
            b = d.useMemo(() => {
              if (l) {
                if (!c) return [];
                const e = l({
                  defaultItems: y,
                  hasDesktopLayout: !s
                }, c);
                e.forEach(e => {
                  !function (e) {
                    vf((0, u.PO)(e) && !!e, "Expected item to be an object");
                    const {
                      type: t,
                      id: n,
                      title: r,
                      icon: o,
                      className: i,
                      onPress: a,
                      disabled: s
                    } = e;
                    vf("type" in e && (0, F.HD)(t) && [...gf, "custom"].includes(t), `Expected item.type to be one of ${[...gf, "custom"].join(", ")}`), r && vf((0, F.HD)(r), "Expected `title` to be a string"), o && vf((0, F.HD)(o), "Expected `icon` to be a string"), n && vf((0, F.HD)(n), "Expected `id` to be a string"), i && vf((0, F.HD)(i), "Expected `className` to be a string"), a && vf("function" == typeof a, "`onPress` must be a `function`"), "disabled" in e && vf("boolean" == typeof s, "`disabled` must be a `boolean`"), e.node && vf(Ll.a.includes(e.node.nodeType), "`node.nodeType` is invalid. Expected one of " + Ll.a.join(", "));
                  }(e);
                });
                return e.map(e => "custom" === e.type && null !== e.onPress ? xf(xf({}, e), {}, {
                  onPress: () => {
                    e.onPress(), n((0, _e.fz)());
                  }
                }) : e).map(e => ({
                  node: Cf(e),
                  type: e.type
                }));
              }
              return y.map(e => ({
                node: Cf(e),
                type: e.type
              }));
            }, [y, c, s, l, Cf, n]),
            w = h()({
              [ac().content]: s,
              [ac().mobileTextMarkup]: s,
              [bf().inner]: !s
            });
          return d.createElement("div", {
            className: h()("PSPDFKit-Text-Markup-Inline-Toolbar", {
              [bf().root]: !s
            }),
            role: "dialog",
            "aria-label": p(ke.Z.markupToolbar)
          }, d.createElement("div", {
            className: w
          }, b.map((e, t) => "custom" !== e.type && "document-assistant" !== e.type && r(Df.get(e.type)) ? null : "custom" === e.type ? d.createElement("div", {
            key: `custom-${t}`
          }, e.node) : d.createElement("div", {
            key: e.type
          }, e.node))));
        }
        class Ef extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O);
          }
          render() {
            const {
              position: e,
              dispatch: t,
              showComments: n,
              showRedactions: r,
              currentTextSelection: o,
              isAnnotationTypeReadOnly: i,
              inlineTextSelectionToolbarItems: a,
              showDocumentAssistant: s
            } = this.props;
            return d.createElement("div", {
              className: h()("PSPDFKit-Annotation-Toolbar", ac().root, {
                [ac().stickToBottom]: "bottom" === e
              })
            }, d.createElement(Sf, {
              dispatch: t,
              isAnnotationTypeReadOnly: i,
              showComments: n,
              showRedactions: r,
              hasMobileLayout: !0,
              inlineTextSelectionToolbarItems: a,
              currentTextSelection: o,
              showDocumentAssistant: s
            }));
          }
        }
        var _f = n(67040),
          Pf = n(18726),
          kf = n(60101),
          Af = n(39270),
          zf = n.n(Af);
        const Tf = d.memo(function (e) {
            const t = e.items.map((t, n) => {
              const {
                className: r,
                disabled: o,
                selected: i,
                icon: a,
                title: s,
                onPress: l
              } = t;
              return t.node ? d.createElement(kf.Z, {
                node: t.node,
                className: h()("PSPDFKit-Annotation-Tool-Node", e.itemClassName, r, zf().node),
                onPress: l,
                title: s,
                disabled: o,
                selected: i,
                key: `AnnotationTools-tool-${n}`
              }) : d.createElement(Md.Z, {
                type: "custom",
                className: h()("PSPDFKit-Annotation-Tool-Button", e.itemClassName, r, zf().button),
                disabled: o,
                selected: i,
                icon: a,
                title: s,
                onPress: l,
                key: `AnnotationTools-tool-${n}`
              });
            });
            return d.createElement("div", {
              role: "toolbar",
              className: h()(zf().root, e.rootClassName)
            }, t);
          }),
          Of = ["children", "fullScreen", "hover", "tools", "intl", "closeNote", "clearNote", "isLocked", "isReadOnly", "hasLockedContents"];
        function If(e) {
          e.stopPropagation();
        }
        const Ff = (0, xe.XN)(e => {
          const {
              children: t,
              fullScreen: n,
              hover: r,
              tools: o,
              intl: i,
              closeNote: a,
              clearNote: s,
              isLocked: l,
              isReadOnly: u,
              hasLockedContents: c
            } = e,
            p = (0, ne.Z)(e, Of),
            {
              formatMessage: f
            } = i,
            m = d.useRef(null);
          d.useEffect(function () {
            const e = m.current;
            if (e) return e.addEventListener("wheel", If, !0), () => e.removeEventListener("wheel", If, !0);
          }, []);
          const g = (0, Ae.Z)({
              type: "close"
            }),
            v = (0, Ae.Z)({
              type: "delete"
            }),
            y = (0, Ae.Z)({
              type: "lock",
              style: {
                width: 12,
                height: 12,
                flexBasis: 12
              },
              className: xt().icon
            }),
            b = [u ? f(ke.Z.readOnlyAnnotationFlag) : "", l ? f(ke.Z.locked) : "", c ? f(ke.Z.lockedContents) : ""].filter(e => "" !== e).join(", ");
          return d.createElement("div", (0, ce.Z)({
            className: `PSPDFKit-Note-Annotation-Content ${xt().wrapper}${n ? " " + xt().fullScreen : ""}`
          }, p, {
            ref: m
          }), d.createElement("div", {
            className: xt().header
          }, d.createElement("h3", {
            className: xt().title
          }, f(ke.Z.noteAnnotation)), d.createElement("button", {
            className: h()(xt().button, r ? xt().hidden : null),
            title: f(ke.Z.close),
            "aria-label": f(ke.Z.close),
            onClick: a || void 0,
            role: "button",
            type: "button"
          }, g)), d.createElement("div", {
            className: xt().content
          }, t), s && d.createElement("button", {
            className: h()(xt().button, r ? xt().hidden : null),
            title: f(ke.Z.clear),
            "aria-label": f(ke.Z.clear),
            onClick: s,
            role: "button",
            type: "button"
          }, v), o && !n && d.createElement("div", {
            className: xt().tools
          }, d.createElement(Tf, {
            items: o,
            rootClassName: xt().tools,
            itemClassName: xt().tool
          })), d.createElement("div", {
            className: xt().footer
          }, (l || u || c) && d.createElement(d.Fragment, null, y, d.createElement("div", {
            className: xt().label,
            "aria-label": b
          }, b))));
        });
        function Mf(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Rf(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Mf(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Mf(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const jf = {
          left: 0,
          top: 0,
          maxWidth: "100%",
          maxHeight: "auto",
          minWidth: "100%",
          minHeight: "100%"
        };
        class Bf extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "_didUpdate", !1), (0, o.Z)(this, "_didEditorFocus", !1), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              value: this.props.annotation.text.value
            }), (0, o.Z)(this, "focus", () => {
              this._isFocused || (this._isFocused = !0, this._editor && this._editor.focus());
            }), (0, o.Z)(this, "clearText", () => {
              this._editor && this._editor.clearText();
            }), (0, o.Z)(this, "_isFocused", !1), (0, o.Z)(this, "_lastSavedAnnotation", this.props.annotation), (0, o.Z)(this, "_onRef", e => {
              this._editor = e;
            }), (0, o.Z)(this, "_valueDidUpdate", () => {
              this._didUpdate = !0;
            }), (0, o.Z)(this, "_updateAnnotation", () => {
              if (this._didUpdate) {
                var e;
                const n = this.props.annotation.set("text", {
                  format: "plain",
                  value: null === (e = this._editor) || void 0 === e ? void 0 : e.getPlainText()
                });
                if (this._lastSavedAnnotation.text.value !== n.text.value || this._lastSavedAnnotation.text.format !== n.text.format) if (this._lastSavedAnnotation = n, n instanceof ao.FN) {
                  var t;
                  const e = null === (t = n.parentAnnotation) || void 0 === t ? void 0 : t.set("note", n.text.value);
                  (0, u.kG)(e), this.props.dispatch((0, yt.FG)(e));
                } else this.props.dispatch((0, yt.FG)(n)), this.props.keepSelectedTool && this.props.dispatch((0, Kt.i9)());
              } else this.props.keepSelectedTool && this.props.dispatch((0, Kt.i9)());
            }), (0, o.Z)(this, "_onBlur", () => {
              this._updateAnnotation();
            }), (0, o.Z)(this, "_onStopEditing", () => {
              this._updateAnnotation(), this.props.dispatch((0, yt.i0)(!0));
            }), (0, o.Z)(this, "_onEscape", () => {
              this.props.dispatch((0, _e.fz)()), this._updateAnnotation();
            }), (0, o.Z)(this, "_handleEditorFocus", () => {
              if (!this._didEditorFocus) {
                const e = {
                  annotations: (0, s.aV)([this.props.annotation]),
                  reason: J.f.TEXT_EDIT_START
                };
                this.props.eventEmitter.emit("annotations.willChange", e);
              }
              this._didEditorFocus = !0;
            });
          }
          UNSAFE_componentWillReceiveProps(e) {
            e.annotation.text.value !== this.props.annotation.text.value && (this._editor && (this._editor.innerText = e.annotation.text.value), this.setState({
              value: e.annotation.text.value
            }));
          }
          componentWillUnmount() {
            if (this._didEditorFocus) {
              const e = {
                annotations: (0, s.aV)([this.props.annotation]),
                reason: J.f.TEXT_EDIT_END
              };
              this.props.eventEmitter.emit("annotations.willChange", e);
            }
            this._updateAnnotation();
          }
          render() {
            return d.createElement(Ko, {
              autoFocus: !1,
              autoSelect: this.props.autoSelect,
              onBlur: this._onBlur,
              onStopEditing: this._onStopEditing,
              onEscape: this._onEscape,
              ref: this._onRef,
              maxLength: Ne.RI,
              defaultValue: this.state.value,
              lastMousePoint: this.props.lastMousePoint,
              style: Rf(Rf({}, jf), {}, {
                cursor: this.props.uneditableContentCursor || "inherit"
              }),
              valueDidUpdate: this._valueDidUpdate,
              onFocus: this._handleEditorFocus
            });
          }
        }
        (0, o.Z)(Bf, "defaultProps", {
          autoSelect: !1
        });
        var Nf = n(84337);
        class Lf extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {}), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "_closeNote", () => {
              this.props.noteAnnotation instanceof ao.FN ? this.props.dispatch((0, _e.mv)(null)) : this.props.dispatch((0, _e.fz)());
            }), (0, o.Z)(this, "_clearNote", () => {
              this._editor && this._editor.clearText();
            }), (0, o.Z)(this, "_preventDeselect", e => {
              e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
            }), (0, o.Z)(this, "_makeHandleMouseUpAndTouchEnd", e => (0, _f.S)(t => {
              this.setState({
                lastMousePoint: new _.E9({
                  x: t.clientX,
                  y: t.clientY
                })
              }, () => {
                this.props.dispatch((0, _e.VR)(e));
              });
            })), (0, o.Z)(this, "_onRef", e => {
              this._editor = e, this.props.isFullscreen && this._editor && this._editor.focus();
            }), (0, o.Z)(this, "_getGradient", (0, dn.Z)(e => {
              let t = e.lighter(30);
              const n = Math.min(t.r, t.g, t.b);
              for (let e = 0; e < 10 && t.contrastRatio(_.Il.BLACK) < 4.5; e++) t = t.lighter((255 - n) / 25.5);
              return {
                top: t.lighter(30),
                bottom: t
              };
            })), (0, o.Z)(this, "isPopoverPositioned", !1), (0, o.Z)(this, "onPopoverPositioned", () => {
              !this.isPopoverPositioned && this._editor && (this.isPopoverPositioned = !0, this._editor.focus());
            });
          }
          render() {
            const {
              dispatch: e,
              noteAnnotation: t,
              noteAnnotationToModify: n,
              viewportState: r,
              isFullscreen: o,
              collapseSelectedNoteContent: i
            } = this.props;
            if (null == t.pageIndex || i) return null;
            const a = n && t.id === n.id,
              s = t instanceof ao.FN,
              {
                color: l
              } = t,
              c = Kf[l.toCSSValue()] || this._getGradient(l.saturate(60)),
              p = this.props.isAnnotationReadOnly(t),
              h = p || t.lockedContents;
            if (o) {
              if (!a && !p) return null;
              const n = l.toCSSValue(),
                o = `linear-gradient(to bottom, ${c.top.toCSSValue()} 0%, ${c.bottom.toCSSValue()} 100%)`,
                i = r.viewportRect.height - (this.props.annotationToolbarHeight < r.viewportRect.height ? this.props.annotationToolbarHeight : 0),
                u = (0, j.B7)(t);
              return d.createElement(Ff, {
                fullScreen: !0,
                hover: this.props.isHover,
                key: `NoteAnnotationContent-${t.id}`,
                style: {
                  backgroundColor: n,
                  backgroundImage: o,
                  width: "100%",
                  height: i,
                  top: i < r.viewportRect.height ? this.props.annotationToolbarHeight : "auto"
                },
                onMouseUp: this._preventDeselect,
                onPointerUp: this._preventDeselect,
                onTouchEnd: this._preventDeselect,
                closeNote: this._closeNote,
                clearNote: a && !h && s ? this._clearNote : void 0,
                id: `NoteAnnotationContent-${t.id}`,
                isLocked: t.locked,
                isReadOnly: t.readOnly,
                hasLockedContents: t.lockedContents
              }, h ? t.text.value : d.createElement(Bf, {
                annotation: t,
                dispatch: e,
                ref: this._onRef,
                autoSelect: this.props.autoSelect,
                eventEmitter: this.props.eventEmitter,
                keepSelectedTool: this.props.keepSelectedTool,
                uneditableContentCursor: u
              }));
            }
            let f, m;
            a || h || (f = m = this._makeHandleMouseUpAndTouchEnd(t.id));
            const g = (0, G.cr)(r, t.pageIndex).translate(r.scrollPosition.scale(r.zoomLevel)),
              v = t.update("boundingBox", e => ((0, u.kG)(e), e.merge({
                left: e.left + (e.width - e.width / r.zoomLevel) / 2,
                top: e.top + (e.height - e.height / r.zoomLevel) / 2,
                width: e.width / r.zoomLevel,
                height: e.height / r.zoomLevel
              }))),
              y = (0, j.B7)(t, {
                isExpandedNote: !0
              });
            return d.createElement(Nf.Z, {
              referenceRect: (0, j.SY)(v, r.zoomLevel, r.pagesRotation).apply(g),
              viewportState: r,
              onPositionInfoChange: this.onPopoverPositioned,
              baseColor: l,
              color: [c.top, c.bottom],
              className: "PSPDFKit-Popover-Note-Annotation",
              customZIndex: 1001
            }, d.createElement(Ff, {
              onMouseUp: f,
              onTouchEnd: m,
              tools: this.props.tools,
              closeNote: this._closeNote,
              clearNote: a && !h && s ? this._clearNote : void 0,
              hover: this.props.isHover,
              id: `NoteAnnotationContent-${t.id}`,
              style: {
                cursor: y
              },
              isLocked: t.locked,
              isReadOnly: t.readOnly,
              hasLockedContents: t.lockedContents
            }, h ? t.text.value : d.createElement(Bf, {
              annotation: t,
              dispatch: e,
              ref: a ? this._onRef : void 0,
              lastMousePoint: this.state.lastMousePoint,
              autoSelect: this.props.autoSelect,
              eventEmitter: this.props.eventEmitter,
              keepSelectedTool: this.props.keepSelectedTool,
              uneditableContentCursor: y
            })));
          }
        }
        (0, o.Z)(Lf, "defaultProps", {
          autoSelect: !1
        });
        const Vf = {
            yellow: {
              top: new _.Il({
                r: 245,
                g: 240,
                b: 158
              }),
              bottom: new _.Il({
                r: 250,
                g: 247,
                b: 106
              })
            },
            orange: {
              top: new _.Il({
                r: 250,
                g: 213,
                b: 161
              }),
              bottom: new _.Il({
                r: 255,
                g: 184,
                b: 112
              })
            },
            red: {
              top: new _.Il({
                r: 255,
                g: 181,
                b: 178
              }),
              bottom: new _.Il({
                r: 255,
                g: 134,
                b: 126
              })
            },
            fuchsia: {
              top: new _.Il({
                r: 255,
                g: 186,
                b: 255
              }),
              bottom: new _.Il({
                r: 240,
                g: 139,
                b: 233
              })
            },
            blue: {
              top: new _.Il({
                r: 164,
                g: 211,
                b: 255
              }),
              bottom: new _.Il({
                r: 113,
                g: 166,
                b: 244
              })
            },
            green: {
              top: new _.Il({
                r: 190,
                g: 255,
                b: 161
              }),
              bottom: new _.Il({
                r: 130,
                g: 227,
                b: 111
              })
            }
          },
          Kf = {};
        for (const e of Pf.W) null != e.color && null != e.localization.id && (Kf[e.color.toCSSValue()] = Vf[e.localization.id]);
        var qf = n(1175),
          Hf = n(98861),
          Uf = n.n(Hf);
        class Zf extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "elementRef", d.createRef()), (0, o.Z)(this, "state", {
              isPanning: !1
            }), (0, o.Z)(this, "initialPosition", null), (0, o.Z)(this, "previousPosition", null), (0, o.Z)(this, "_handleDragStart", e => {
              this.props.enabled && (0, qf.I)(e) && (this.initialPosition = this.previousPosition = new E.E9({
                x: e.clientX,
                y: e.clientY
              }), this.setState({
                isPanning: !0
              }), this._addEventListeners());
            }), (0, o.Z)(this, "_handleDragMove", e => {
              if (!(0, qf.W)(e)) return void this._handleDragEnd(e);
              if (!this.props.enabled || !this.previousPosition) return;
              const t = new E.E9({
                  x: e.clientX,
                  y: e.clientY
                }),
                n = this.previousPosition.translate(t.scale(-1)),
                r = this._getScrollElement(),
                {
                  scrollLeft: o,
                  scrollTop: i
                } = r;
              r.scrollLeft = o + n.x, r.scrollTop = i + n.y, this.previousPosition = t, e.stopPropagation();
            }), (0, o.Z)(this, "_handleDragEnd", e => {
              this.initialPosition && this.previousPosition && (qt(this.initialPosition, this.previousPosition) && (e.stopPropagation(), e.stopImmediatePropagation()), this.previousPosition = null, this.setState({
                isPanning: !1
              }), this._removeEventListeners());
            });
          }
          componentDidMount() {
            this.elementRef.current && this.elementRef.current.addEventListener("mousedown", this._handleDragStart);
          }
          componentWillUnmount() {
            this.elementRef.current && this.elementRef.current.removeEventListener("mousedown", this._handleDragStart), this._removeEventListeners();
          }
          render() {
            const {
                enabled: e
              } = this.props,
              {
                isPanning: t
              } = this.state,
              n = h()({
                [Uf().layer]: e,
                [Uf().isPanning]: t
              });
            return d.createElement("div", {
              className: n,
              ref: this.elementRef
            }, this.props.children);
          }
          _addEventListeners() {
            const {
              defaultView: e
            } = this._getScrollElement().ownerDocument;
            null == e || e.addEventListener("mouseup", this._handleDragEnd, !0), null == e || e.addEventListener("mousemove", this._handleDragMove);
          }
          _removeEventListeners() {
            const e = this._getScrollElement();
            if (!e) return;
            const {
              defaultView: t
            } = e.ownerDocument;
            t && (t.removeEventListener("mouseup", this._handleDragEnd, !0), t.removeEventListener("mousemove", this._handleDragMove));
          }
          _getScrollElement() {
            return this.context();
          }
        }
        (0, o.Z)(Zf, "contextType", Xl);
        const $f = d.memo(function (e) {
          const {
              dispatch: t,
              viewportState: n,
              interactionMode: r,
              spreadIndex: o,
              onCropChange: i,
              cropInfo: a
            } = e,
            s = d.useRef(null);
          d.useEffect(() => {
            null !== s.current && s.current !== o && (r === B.A.SEARCH ? t((0, _e.vR)()) : t((0, _e.fz)())), s.current = o;
          }, [t, o, r]);
          const [l, u] = (0, ts.wU)(n, o);
          if (0 === n.viewportRect.width || 0 === n.viewportRect.height) return null;
          function c(t, r, o) {
            const s = {
                transform: (0, G.vs)(E.sl.IDENTITY, n, t).toCssValue(),
                transformOrigin: "0 0"
              },
              l = (0, ts.nw)(n) === Mh.X.DOUBLE ? t.toString() : e.pageKeys.get(t);
            return d.createElement("div", {
              key: l,
              className: "PSPDFKit-Spread",
              style: s,
              "data-spread-index": t
            }, d.createElement(Ih, {
              key: l,
              spreadIndex: t,
              viewportState: n,
              inViewport: r,
              shouldPrerender: o,
              hidden: !r,
              onOverviewRenderFinished: u,
              onCropChange: i,
              cropInfo: a,
              pageKeys: e.pageKeys,
              setGlobalCursor: e.setGlobalCursor
            }));
          }
          return d.createElement(Fh.Z, {
            dispatch: e.dispatch,
            viewportState: n
          }, d.createElement("div", null, function (e) {
            var t;
            const r = [];
            if (r.push(c(e, !0, !1)), n.scrollMode === us.G.DISABLED) return r;
            const o = (0, ts.kd)(n),
              i = null !== (t = n.prerenderedPageSpreads) && void 0 !== t ? t : o,
              a = Math.max(e - i, 0),
              s = Math.min(e + i, o - 1);
            for (let t = a; t <= s; t++) t !== e && r.push(c(t, !1, "number" == typeof l && e === l));
            return r;
          }(o)));
        });
        var Gf = n(87856),
          Wf = n(14883),
          Yf = n.n(Wf),
          Xf = n(60679);
        const Qf = !(!Gf.Gn || "edge" == De.SR) && {
          passive: !0
        };
        class Jf extends d.Component {
          constructor() {
            super(), (0, o.Z)(this, "_elementRef", d.createRef()), (0, o.Z)(this, "_handleWheel", e => {
              const {
                  viewportState: t,
                  scrollElement: n
                } = this.props,
                r = t.zoomLevel <= (0, rs.Mq)(t);
              let o = !0;
              if (n) {
                const {
                  clientHeight: e,
                  scrollHeight: r
                } = n;
                o = t.commentMode !== Xf._.SIDEBAR || t.scrollMode !== us.G.PER_SPREAD || t.scrollPosition.y + e >= r;
              }
              if (!(r && o)) return;
              const i = (0, G.G4)(t);
              e.clientX > Math.ceil(i.left) + i.width + t.viewportPadding.x || (e.deltaY < 0 ? this.props.dispatch((0, Ql.IT)()) : e.deltaY > 0 && this.props.dispatch((0, Ql.fz)()));
            }), (0, o.Z)(this, "_handleSwipeLeft", () => {
              const e = (0, ns.TW)(this.props.viewportState);
              Math.ceil(this.props.viewportState.scrollPosition.x) >= Math.floor(e.x) && this.props.dispatch((0, Ql.fz)());
            }), (0, o.Z)(this, "_handleSwipeRight", () => {
              Math.floor(this.props.viewportState.scrollPosition.x) <= 0 && this.props.dispatch((0, Ql.IT)());
            }), (0, o.Z)(this, "_handleTouchStart", e => {
              const t = this._elementRef.current;
              t && null === this._touchStart && (0, zl.sX)(e) && (this._touchStart = nm(e), t.ownerDocument.addEventListener("touchend", this._handleTouchEnd, !0));
            }), (0, o.Z)(this, "_handleTouchEnd", e => {
              const t = this._elementRef.current;
              if (!t) return;
              const n = this._touchStart;
              if (!n) return;
              const r = nm(e),
                o = r.x - n.x,
                i = r.y - n.y,
                a = function (e, t, n) {
                  const r = t / e || 0,
                    o = n / e || 0;
                  return Math.abs(r) > Math.abs(o) ? r : o;
                }(r.timestamp - n.timestamp, o, i),
                s = function (e, t) {
                  const n = t.x - e.x,
                    r = t.y - e.y;
                  return Math.sqrt(n * n + r * r);
                }(n, r),
                l = function (e, t) {
                  if (e === t) return 0;
                  if (Math.abs(e) >= Math.abs(t)) return e < 0 ? em : tm;
                  return t < 0 ? 3 : 4;
                }(o, i);
              if (s > 10 && Math.abs(a) > .3 && !this.props.interactionsDisabled) switch (l) {
                case em:
                  this._handleSwipeLeft();
                  break;
                case tm:
                  this._handleSwipeRight();
              }
              t.ownerDocument.removeEventListener("touchend", this._handleTouchEnd, !0), this._touchStart = null;
            }), (0, o.Z)(this, "_handleClick", e => {
              const t = this._elementRef.current;
              if (!t || this.props.hasSelection || t.ownerDocument.defaultView && e.target instanceof t.ownerDocument.defaultView.HTMLElement && (0, uf.c)(e.target)) return;
              const n = t.getBoundingClientRect(),
                r = (e.clientX - n.left) / n.width;
              r < .3 ? this._handleSwipeRight() : r > .7 && this._handleSwipeLeft();
            }), this._handleWheel = (0, ih.Z)(this._handleWheel, 250), this._touchStart = null;
          }
          componentDidMount() {
            const e = this._elementRef.current;
            e && (e.addEventListener("touchstart", this._handleTouchStart), e.addEventListener("wheel", this._handleWheel, Qf));
          }
          componentWillUnmount() {
            const e = this._elementRef.current;
            e && (e.removeEventListener("touchstart", this._handleTouchStart), e.removeEventListener("wheel", this._handleWheel, Qf), e.ownerDocument.removeEventListener("touchend", this._handleTouchEnd, !0));
          }
          render() {
            return d.createElement("div", {
              className: Yf().root,
              onClick: this._handleClick,
              ref: this._elementRef
            }, this.props.children);
          }
        }
        const em = 1,
          tm = 2;
        function nm(e) {
          const t = e.touches[0] || e.changedTouches[0];
          return {
            x: t.clientX,
            y: t.clientY,
            timestamp: Date.now()
          };
        }
        var rm = n(16085),
          om = n.n(rm);
        const im = function (e) {
            let {
              progress: t,
              totalPages: n
            } = e;
            const {
                formatMessage: r
              } = (0, xe.YB)(),
              o = (0, l.I0)(),
              a = d.useCallback(() => {
                (0, l.dC)(() => {
                  o((0, Kt.Zg)()), o((0, cf.WQ)());
                });
              }, [o]);
            return d.createElement(Gd.Z, {
              onEscape: a,
              accessibilityLabel: r(am.printProgressModal),
              accessibilityDescription: r(am.printProgressModalDesc)
            }, d.createElement("div", {
              className: om().root
            }, d.createElement("div", null, r(am.printPrepare)), "number" == typeof t && d.createElement(d.Fragment, null, d.createElement("div", {
              className: om().progressWrapper
            }, d.createElement("div", {
              className: om().progress,
              "aria-label": `${t}% complete`,
              role: "progressbar",
              "aria-valuenow": t
            }, d.createElement("div", {
              className: om().progressBar,
              style: {
                width: `${Math.floor(100 * t / n)}%`
              }
            })), d.createElement("div", {
              className: om().progressText
            }, r(am.pageXofY, {
              arg0: t,
              arg1: n
            }))), d.createElement(i.zx, {
              title: r(ke.Z.cancel),
              onClick: a
            }, r(ke.Z.cancel)))));
          },
          am = (0, xe.vU)({
            pageXofY: {
              id: "pageXofY",
              defaultMessage: "Page {arg0} of {arg1}",
              description: "Printing processing progress"
            },
            printPrepare: {
              id: "printPrepare",
              defaultMessage: "Preparing document for printing…",
              description: "Shown while the printing process is preparing the pages for printing"
            },
            printProgressModal: {
              id: "printProgressModal",
              defaultMessage: "Printing in progress",
              description: "Printing in progress modal"
            },
            printProgressModalDesc: {
              id: "printProgressModalDesc",
              defaultMessage: "Indicates that a document is being prepared for printing",
              description: "Description for the Printing in progress modal"
            }
          });
        var sm,
          lm = n(22945),
          um = n.n(lm);
        const cm = function () {
            const {
              formatMessage: e
            } = (0, xe.YB)();
            return d.createElement(Gd.Z, {
              accessibilityLabel: e(dm.signingModal),
              accessibilityDescription: e(dm.signingModalDescription)
            }, d.createElement("div", {
              className: um().root
            }, d.createElement(je.Z, {
              src: n(65936),
              className: um().icon,
              role: "presentation"
            }), d.createElement("div", {
              className: um().message
            }, e(dm.signing), sm || (sm = d.createElement(Be.Z, null)))));
          },
          dm = (0, xe.vU)({
            signing: {
              id: "signing",
              defaultMessage: "Signing...",
              description: "Shown while the digital signature flow is in progress"
            },
            signingModal: {
              id: "signingInProgress",
              defaultMessage: "Signing in progress",
              description: "Signing in progress modal"
            },
            signingModalDescription: {
              id: "signingModalDesc",
              defaultMessage: "Indicates that the current document is being signed",
              description: "Description of the Signing in progress modal"
            }
          });
        var pm,
          hm = n(57193),
          fm = n.n(hm);
        function mm() {
          const {
            formatMessage: e
          } = (0, xe.YB)();
          return d.createElement(Gd.Z, {
            accessibilityLabel: e(gm.redactionsModal),
            accessibilityDescription: e(gm.redactionModalDescription)
          }, d.createElement("div", {
            className: fm().root
          }, d.createElement(je.Z, {
            src: n(20377),
            className: fm().icon,
            role: "presentation"
          }), d.createElement("div", {
            className: fm().message
          }, e(gm.applyingRedactions), pm || (pm = d.createElement(Be.Z, null)))));
        }
        const gm = (0, xe.vU)({
          applyingRedactions: {
            id: "applyingRedactions",
            defaultMessage: "Applying redactions...",
            description: "Shown while the redactions flow is in progress"
          },
          redactionsModal: {
            id: "redactionInProgress",
            defaultMessage: "Redaction in progress",
            description: "Redaction in progress modal"
          },
          redactionModalDescription: {
            id: "redactionModalDesc",
            defaultMessage: "Indicates that the current document is being redacted",
            description: "Description of the Redacted in progress modal"
          }
        });
        var vm = n(58288),
          ym = n.n(vm);
        function bm(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function wm(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? bm(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : bm(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const xm = {
            WebkitOverflowScrolling: "touch",
            overflow: "auto"
          },
          Dm = [br.cS, br.rw, br.wG, br.MS];
        class Cm extends d.PureComponent {
          constructor(e) {
            super(e), (0, o.Z)(this, "usingNavigationKeys", !1), (0, o.Z)(this, "handleScroll", (0, ih.Z)(this.handleScroll.bind(this), 100, !0)), (0, o.Z)(this, "handleKeyDown", e => {
              Dm.indexOf(e.keyCode) >= 0 && !this.usingNavigationKeys && (this.usingNavigationKeys = !0);
            }), (0, o.Z)(this, "handleKeyUp", e => {
              Dm.indexOf(e.keyCode) >= 0 && this.usingNavigationKeys && (this.usingNavigationKeys = !1);
            }), (0, o.Z)(this, "_handleRef", e => {
              e && (this.element = e, this.props.onScrollElementChange(e));
            }), this.previousKnownScrollPosition = new _.E9(), this.previousKnownZoomLevel = 1;
          }
          updateScrollbarOffset(e) {
            const t = this.element.offsetWidth - this.element.clientWidth,
              n = "hidden" !== this.element.style.overflow;
            "number" == typeof t && e != t && n && this.props.dispatch((0, Kt.IU)(t));
          }
          componentDidUpdate(e) {
            requestAnimationFrame(() => this.updateScrollbarOffset(e.scrollbarOffset)), this.updateScrollPosition();
          }
          componentDidMount() {
            this.updateScrollbarOffset(), this.updateScrollPosition(), this.props.dispatch((0, Kt.K_)(this.element)), this.element.ownerDocument.addEventListener("keydown", this.handleKeyDown), this.element.ownerDocument.addEventListener("keyup", this.handleKeyUp);
          }
          componentWillUnmount() {
            this.props.dispatch((0, Kt.K_)(null)), this.element.ownerDocument.removeEventListener("keydown", this.handleKeyDown), this.element.ownerDocument.removeEventListener("keyup", this.handleKeyUp);
          }
          updateScrollPosition() {
            const {
              viewportState: e
            } = this.props;
            if (0 === e.viewportRect.width) return;
            if (this.previousKnownScrollPosition.equals(e.scrollPosition) && this.previousKnownZoomLevel === e.zoomLevel) return;
            const t = this.element,
              n = Math.round(e.scrollPosition.x * e.zoomLevel),
              r = Math.round(e.scrollPosition.y * e.zoomLevel);
            t.scrollTop !== r && (t.scrollTop = r), t.scrollLeft !== n && (t.scrollLeft = n), this.previousKnownScrollPosition = e.scrollPosition, this.previousKnownZoomLevel = e.zoomLevel;
          }
          handleScroll() {
            const {
                dispatch: e,
                viewportState: t
              } = this.props,
              {
                scrollPosition: n,
                zoomLevel: r
              } = t;
            if (0 === t.viewportRect.width) return;
            const o = this.element;
            if (void 0 === o.scrollTop || void 0 === o.scrollLeft) return;
            const i = new _.E9({
                x: o.scrollLeft / r,
                y: o.scrollTop / r
              }),
              a = function (e, t, n) {
                const r = 1 / n;
                return Math.abs(e.x - t.x) > r || Math.abs(e.y - t.y) > r;
              }(n, i, r);
            a && (this.previousKnownScrollPosition = i, this.previousKnownZoomLevel = r, e((0, Ql.lt)(i, this.usingNavigationKeys)));
          }
          render() {
            const {
              children: e,
              scrollDisabled: t
            } = this.props;
            return d.createElement("div", {
              ref: this._handleRef,
              className: `PSPDFKit-Scroll ${ym().root}`,
              style: wm(wm({}, xm), {}, {
                overflow: t ? "hidden" : "auto"
              }),
              onScroll: this.handleScroll
            }, e);
          }
        }
        var Sm,
          Em = n(76438),
          _m = n(99135),
          Pm = n.n(_m);
        const km = (0, xe.XN)(function (e) {
            const {
                formatMessage: t
              } = e.intl,
              n = t(Am.searchResultOf, {
                arg0: e.searchResultsSize > 0 ? e.focusedResultIndex + 1 : 0,
                arg1: e.searchResultsSize
              }),
              r = d.createElement("div", {
                role: "status",
                className: Pm().searchPosition,
                "aria-live": "polite",
                "aria-label": De.vU ? n : void 0
              }, n);
            return d.createElement(d.Fragment, null, e.isLoading && d.createElement("div", {
              className: Pm().loader
            }, Sm || (Sm = d.createElement(Be.Z, null))), r);
          }),
          Am = (0, xe.vU)({
            searchResultOf: {
              id: "searchResultOf",
              defaultMessage: "{arg0} of {arg1}",
              description: "Shows the current search result number. E.g. 1 of 10"
            }
          });
        var zm = n(48731),
          Tm = n.n(zm);
        const Om = (0, xe.vU)({
            searchPreviousMatch: {
              id: "searchPreviousMatch",
              defaultMessage: "Previous",
              description: "Go to the previous search result"
            },
            searchNextMatch: {
              id: "searchNextMatch",
              defaultMessage: "Next",
              description: "Go to the next search result"
            }
          }),
          Im = (0, xe.XN)(e => {
            const t = d.useRef(null);
            d.useEffect(() => {
              (() => {
                const n = t.current;
                (0, Ce.k)(null != n), n.ownerDocument.activeElement !== n && e.isFocused ? n.focus() : n.ownerDocument.activeElement !== n || e.isFocused || n.blur();
              })();
            });
            const {
                formatMessage: r
              } = e.intl,
              o = h()({
                [Tm().previous]: !0,
                "PSPDFKit-Search-Control-Prev": !0,
                "PSPDFKit-Search-Control-Prev-disabled": e.searchResultsSize <= 0
              }),
              i = h()({
                [Tm().next]: !0,
                "PSPDFKit-Search-Control-Next": !0,
                "PSPDFKit-Search-Control-Next-disabled": e.searchResultsSize <= 0
              }),
              a = 0 === e.term.length,
              s = h()({
                [Tm().results]: !0,
                [Tm().resultsDisabled]: a,
                "PSPDFKit-Search-Form-Result": !0
              }),
              l = r(ke.Z.searchDocument);
            return d.createElement("div", {
              className: h()("PSPDFKit-Search", Tm().root, {
                [Tm().noToolbar]: !e.showToolbar || e.toolbarPlacement !== nu.p.TOP
              }),
              "data-testid": "pspdfkit-search-form-component-root"
            }, d.createElement("div", {
              className: `PSPDFKit-Search-Form ${Tm().searchBox}`
            }, d.createElement("input", {
              type: "text",
              name: "search",
              ref: t,
              autoComplete: "off",
              placeholder: l,
              "aria-label": l,
              value: e.term,
              onChange: () => {
                const n = t.current;
                (0, Ce.k)(null != n);
                const r = n.value;
                let o = !1;
                e.eventEmitter.emit("search.termChange", {
                  term: r,
                  preventDefault: () => {
                    o = !0;
                  }
                }), o || (e.searchForTerm(n.value), e.searchProvider.searchTerm(n.value));
              },
              onKeyDown: t => {
                t.shiftKey && (t.keyCode === br.E$ || t.metaKey && t.keyCode === br.b8) ? (t.preventDefault(), e.focusPreviousSearchHighlight()) : t.keyCode === br.E$ || t.metaKey && t.keyCode === br.b8 ? (t.preventDefault(), e.focusNextSearchHighlight()) : t.keyCode === br.zz && (t.preventDefault(), e.searchProvider.cancelSearch());
              },
              onFocus: () => {
                e.focusSearch();
              },
              onBlur: () => {
                e.blurSearch();
              },
              className: `PSPDFKit-Search-Form-Input ${Tm().input}`
            }), d.createElement("div", {
              className: s
            }, !a && d.createElement(km, {
              isLoading: e.isLoading,
              searchResultsSize: e.searchResultsSize,
              focusedResultIndex: e.focusedResultIndex
            })), d.createElement("div", {
              className: `PSPDFKit-Search-Control ${Tm().control}`
            }, d.createElement("button", {
              className: o,
              title: r(Om.searchPreviousMatch),
              disabled: e.searchResultsSize <= 1,
              onClick: e.focusPreviousSearchHighlight
            }, d.createElement(je.Z, {
              src: n(10190),
              className: `${Tm().icon} ${Tm().iconLeft}`
            })), d.createElement("button", {
              className: i,
              title: r(Om.searchNextMatch),
              disabled: e.searchResultsSize <= 1,
              onClick: e.focusNextSearchHighlight
            }, d.createElement(je.Z, {
              src: n(92122),
              className: `${Tm().icon} ${Tm().iconRight}`
            })))), d.createElement("button", {
              className: `PSPDFKit-Search-Button-Close ${Tm().button}`,
              onClick: () => e.searchProvider.cancelSearch()
            }, r(ke.Z.close)));
          });
        const Fm = (0, l.$j)(function (e) {
          return {
            isFocused: e.searchState.isFocused,
            isLoading: e.searchState.isLoading,
            term: e.searchState.term,
            searchResultsSize: e.searchState.results.size,
            focusedResultIndex: e.searchState.focusedResultIndex,
            searchProvider: e.searchProvider,
            eventEmitter: e.eventEmitter,
            locale: e.locale,
            showToolbar: e.showToolbar,
            toolbarPlacement: e.toolbarPlacement
          };
        }, function (e) {
          return (0, Em.DE)({
            searchForTerm: Fl._8,
            focusNextSearchHighlight: Fl.jL,
            focusPreviousSearchHighlight: Fl.dZ,
            focusSearch: Fl.tB,
            blurSearch: Fl.nJ
          }, e);
        })(Im);
        class Mm {
          constructor(e, t, n) {
            var r;
            const o = e.getRangeAt(0);
            let i = new _.SV();
            if (this.selection = e, this.className = n, this.rootElement = t, this.isShadowRoot = t instanceof ShadowRoot, this.window = this.isShadowRoot ? window : t.ownerDocument.defaultView, this.commonAncestorContainer = o.commonAncestorContainer, e.rangeCount > 1) {
              const t = e.getRangeAt(e.rangeCount - 1);
              o.setEnd(t.endContainer, t.endOffset);
            }
            const a = !(null != t && t.contains(o.startContainer)),
              s = !(null != t && t.contains(o.endContainer));
            (0, u.kG)(t);
            const l = !(null !== (r = this.commonAncestorContainer) && void 0 !== r && r.contains(t));
            if (a && s && l) this.textRange = null;else {
              if (o.startContainer instanceof this.window.Text && null != t && t.contains(o.startContainer) && this._parentsMatchClass(o.startContainer)) i = i.set("startNode", o.startContainer).set("startOffset", o.startOffset);else if (o.startContainer instanceof this.window.Element || o.startContainer instanceof this.window.Text) {
                let e;
                if (e = o.startContainer.hasChildNodes() ? this._nextTextNode(o.startContainer.childNodes[o.startOffset]) : this._nextTextNode(o.startContainer), null == e) return void (this.textRange = null);
                i = i.set("startNode", e).set("startOffset", 0);
              } else (0, u.kG)(!1, "Selected start container is neither DOM Element nor Text");
              if (o.endContainer instanceof this.window.Text && null != t && t.contains(o.endContainer) && this._parentsMatchClass(o.endContainer)) i = i.set("endNode", o.endContainer).set("endOffset", o.endOffset);else if (o.endContainer instanceof this.window.Element || o.endContainer instanceof this.window.Text) {
                let e;
                if (o.endContainer.hasChildNodes()) {
                  if (o.endOffset >= o.endContainer.childNodes.length) {
                    let t = this._nextCrossSibling(o.endContainer);
                    t || (t = o.endContainer.childNodes[o.endContainer.childNodes.length - 1]), e = this._previousTextNode(t);
                  } else e = this._previousTextNode(o.endContainer.childNodes[o.endOffset]);
                } else e = this._previousTextNode(o.endContainer);
                if (null == e) return void (this.textRange = null);
                i = i.set("endNode", e).set("endOffset", e.length);
              } else (0, u.kG)(!1, "Selected start container is neither DOM Element nor Text");
              if (i.startNode == i.endNode && i.startOffset >= i.endOffset) return void (this.textRange = null);
              if (!this._isBeforeOrSame(i.startNode, i.endNode)) return void (this.textRange = null);
              this.textRange = i;
            }
          }
          getTextRange() {
            return this.textRange;
          }
          _nextTextNode(e) {
            let t = this._findNextSpanNodeInTree(e);
            if (e === this.commonAncestorContainer) return null;
            let n = e;
            for (; !t;) {
              if (n = this._nextCrossSibling(n), null == n) return null;
              t = this._findNextSpanNodeInTree(n);
            }
            return t.firstChild;
          }
          _previousTextNode(e) {
            let t = null;
            if (e === this.commonAncestorContainer) return null;
            let n = e;
            for (; !t;) {
              if (n = this._previousCrossSibling(n), null == n) return null;
              t = this._findLastSpanNodeInTree(n);
            }
            return t.firstChild;
          }
          _nextCrossSibling(e) {
            if (!e) return null;
            if (null != e.nextSibling) return e.nextSibling;
            const t = e.parentNode;
            return null == t || t === this.commonAncestorContainer ? null : null != t.nextSibling ? t.nextSibling : this._nextCrossSibling(t);
          }
          _previousCrossSibling(e) {
            if (null !== e.previousSibling) return e.previousSibling;
            const t = e.parentNode;
            return null == t || t === this.commonAncestorContainer ? null : null !== t.previousSibling ? t.previousSibling : this._previousCrossSibling(t);
          }
          _findNextSpanNodeInTree(e) {
            if (e instanceof this.window.HTMLElement && e.classList.contains(this.className)) return e;
            if (e instanceof this.window.HTMLElement) for (let t = 0; t < e.childNodes.length; t++) {
              const n = e.childNodes[t],
                r = this._findNextSpanNodeInTree(n);
              if (null !== r) return r;
            }
            return null;
          }
          _findLastSpanNodeInTree(e) {
            if (e instanceof this.window.HTMLElement && e.classList.contains(this.className)) return e;
            if (e instanceof this.window.HTMLElement) for (let t = e.childNodes.length - 1; t >= 0; t--) {
              const n = e.childNodes[t],
                r = this._findLastSpanNodeInTree(n);
              if (null !== r) return r;
            }
            return null;
          }
          _parentsMatchClass(e) {
            let t = e.parentNode;
            for (; t;) {
              if (t instanceof this.window.HTMLElement && t.classList.contains(this.className)) return !0;
              if (t instanceof this.window.ShadowRoot) break;
              t = t.parentNode;
            }
            return !1;
          }
          _isBeforeOrSame(e, t) {
            const n = e.compareDocumentPosition(t) & Node.DOCUMENT_POSITION_FOLLOWING,
              r = 0 == e.compareDocumentPosition(t);
            return n || r;
          }
        }
        var Rm = n(66645),
          jm = n.n(Rm);
        let Bm = null,
          Nm = null;
        const Lm = (e, t) => e.container === t.container && e.offset === t.offset,
          Vm = {
            Left: !0,
            ArrowLeft: !0,
            Top: !0,
            ArrowTop: !0,
            Right: !0,
            ArrowRight: !0,
            Bottom: !0,
            ArrowBottom: !0,
            Home: !0,
            End: !0,
            PageDown: !0,
            PageUp: !0,
            Esc: !0,
            Escape: !0
          };
        class Km extends d.PureComponent {
          constructor() {
            super(...arguments), (0, o.Z)(this, "isMouseSelection", !1), (0, o.Z)(this, "pointerMadeSelection", !1), (0, o.Z)(this, "isShiftPressed", !1), (0, o.Z)(this, "isPrimaryPointerGesture", !1), (0, o.Z)(this, "isSelecting", !1), (0, o.Z)(this, "selectionRange", document.createRange()), (0, o.Z)(this, "preventDefaultPointerUpAction", !1), (0, o.Z)(this, "_handleSelectStart", () => {
              this.props.interactionMode !== B.A.TEXT_HIGHLIGHTER && this.props.interactionMode !== B.A.REDACT_TEXT_HIGHLIGHTER || (this.isShiftPressed ? this._processTextSelection(De.Ni ? "touch" : "mouse") : this.props.dispatch((0, _e.d5)((0, s.l4)(), this.props.interactionMode === B.A.TEXT_HIGHLIGHTER ? _.FV : W.Z)));
            }), (0, o.Z)(this, "_handleSelectionChange", () => {
              const {
                  interactionMode: e,
                  shadowRoot: t,
                  rootElement: n
                } = this.props,
                {
                  defaultView: r
                } = n.ownerDocument;
              let o, i;
              if (De.G6 && t) o = null == t ? void 0 : t.getSelection();else {
                const {
                  selection: e,
                  isFalseCollapse: n
                } = t ? (0, y.HY)(t) : (0, y.sD)(r);
                o = e, i = n;
              }
              !this.pointerMadeSelection && (e => {
                if (e.rangeCount <= 0) return !1;
                if (e.rangeCount > 1) {
                  const t = e.getRangeAt(e.rangeCount - 1);
                  t.setEnd(t.endContainer, t.endOffset);
                }
                const t = e.getRangeAt(0),
                  {
                    startContainer: n,
                    endContainer: r,
                    startOffset: o,
                    endOffset: i
                  } = t,
                  a = {
                    container: n,
                    offset: o
                  },
                  s = {
                    container: r,
                    offset: i
                  };
                let l;
                return l = null === Bm || null === Nm || !(Lm(Bm, a) || Lm(Nm, s) || Lm(Bm, s) || Lm(Nm, a)), Bm = a, Nm = s, l;
              })(o) && (this._handleSelectStart(), this.pointerMadeSelection = !0), this.isMouseSelection && e !== B.A.TEXT_HIGHLIGHTER && e !== B.A.REDACT_TEXT_HIGHLIGHTER || (o && !o.isCollapsed || i) && this._processTextSelection(De.Ni ? "touch" : "mouse");
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              let {
                pointerType: t,
                shiftKey: n,
                target: r
              } = e;
              if (r.closest(".BaselineUI-Dialog") || r.closest(".BaselineUI-Popover-Content") || r.closest(".BaselineUI-Popover-Underlay") || r.closest('.BaselineUI-ThemeProvider[data-testid="underlay"]') || r.closest(".PSPDFKit-Comment-Thread")) return;
              if (this.preventDefaultPointerUpAction) return void (this.preventDefaultPointerUpAction = !1);
              if (this.preventDefaultPointerUpAction = !1, !this.isPrimaryPointerGesture) return;
              "mouse" === t && (this.isMouseSelection = !1);
              const o = r;
              if (null != o && o.classList && o.classList.contains("PSPDFKit-Scroll")) return;
              this.pointerMadeSelection = !1, this.isShiftPressed = n;
              const i = this.props.selectedAnnotationIds.size > 1;
              this.isShiftPressed || De.Ni && i || window.setTimeout(() => {
                this._checkForTextSelection(t);
              }, 0);
            }), (0, o.Z)(this, "_handlePointerDown", e => {
              let {
                pointerType: t,
                shiftKey: n,
                isPrimary: r
              } = e;
              this.isPrimaryPointerGesture = r, "mouse" === t && (this.isMouseSelection = !0, this.isShiftPressed = n);
            }), (0, o.Z)(this, "_handleKeyUp", e => {
              const {
                rootElement: t,
                shadowRoot: n
              } = this.props;
              if (t) {
                const r = n ? n.ownerDocument.defaultView : t.ownerDocument.defaultView;
                this.isShiftPressed = e.shiftKey;
                const o = e.composedPath()[0];
                if (!Vm.hasOwnProperty(e.key) || r && o instanceof r.HTMLElement && ((0, jr.eR)(o, r) || (0, jr.N1)(o) || (0, jr.gC)(o))) return;
                window.setTimeout(() => {
                  e.defaultPrevented || this._checkForTextSelection("mouse");
                }, 0);
              }
            });
          }
          componentDidMount() {
            const {
                rootElement: e,
                shadowRoot: t
              } = this.props,
              n = (null == t ? void 0 : t.ownerDocument) || e.ownerDocument,
              r = t || e.ownerDocument;
            n && (r.addEventListener("keyup", this._handleKeyUp), n.addEventListener("selectionchange", this._handleSelectionChange));
          }
          componentWillUnmount() {
            const {
                rootElement: e,
                shadowRoot: t
              } = this.props,
              n = (null == t ? void 0 : t.ownerDocument) || e.ownerDocument,
              r = t || e.ownerDocument;
            n && (r.removeEventListener("keyup", this._handleKeyUp), n.removeEventListener("selectionchange", this._handleSelectionChange)), Bm = null, Nm = null;
          }
          _checkForTextSelection(e) {
            const {
                dispatch: t,
                currentTextSelection: n,
                selectedAnnotationIds: r,
                activeAnnotationNote: o,
                rootElement: i,
                interactionMode: a,
                shadowRoot: s
              } = this.props,
              {
                defaultView: l
              } = i.ownerDocument,
              u = s || i.ownerDocument;
            if (this.props.modalClosurePreventionError && r.includes(this.props.modalClosurePreventionError.annotationId)) {
              const e = u.querySelector(".PSPDFKit-Form-Creator-Popover > .PSPDFKit-Popover");
              return null == e || e.classList.add(jm().shakeEffect), void setTimeout(() => {
                null == e || e.classList.remove(jm().shakeEffect);
              }, 200);
            }
            if (!l) return;
            const {
              selection: c,
              isFalseCollapse: d
            } = s ? (0, y.HY)(s) : (0, y.sD)(l);
            c && (!c.isCollapsed || d ? this._processTextSelection(e) : (n || r.size > 0 || o) && (a === B.A.TEXT_HIGHLIGHTER || a === B.A.REDACT_TEXT_HIGHLIGHTER || a === B.A.CONTENT_EDITOR ? (this.isShiftPressed && t((0, _e.td)(a === B.A.TEXT_HIGHLIGHTER ? _.FV : W.Z)), t((0, _e.vR)())) : t((0, _e.fz)())));
          }
          _processTextSelection(e) {
            const {
                dispatch: t,
                rootElement: n,
                interactionMode: r,
                shadowRoot: o
              } = this.props,
              {
                defaultView: i
              } = n.ownerDocument;
            if (!i && !o) return;
            let a;
            if (De.G6 && o) a = o.getSelection();else {
              const {
                selection: e
              } = o ? (0, y.HY)(o) : (0, y.sD)(i);
              a = e;
            }
            if (!a) return;
            const s = a.rangeCount > 0 ? ((e, t, n) => new Mm(e, t, n).getTextRange())(a, o || n, gs().selectableText) : null;
            null != s && (0, l.dC)(() => {
              t((0, _e.FP)(s, "mouse" === e && r !== B.A.TEXT_HIGHLIGHTER && r !== B.A.REDACT_TEXT_HIGHLIGHTER)), r === B.A.TEXT_HIGHLIGHTER ? t((0, _e.BO)(_.FV)) : r === B.A.REDACT_TEXT_HIGHLIGHTER && t((0, _e.BO)(W.Z));
            });
          }
          render() {
            return d.createElement(Je.Z, {
              onPointerUp: this._handlePointerUp,
              onPointerDown: this._handlePointerDown,
              onPointerDownCapture: e => {
                e.target.closest(".BaselineUI-Dialog") && (this.preventDefaultPointerUpAction = !0);
              }
            }, d.createElement("div", null, this.props.children));
          }
        }
        const qm = (0, d.createContext)(null),
          Hm = {
            didCatch: !1,
            error: null
          };
        class Um extends d.Component {
          constructor(e) {
            super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = Hm;
          }
          static getDerivedStateFromError(e) {
            return {
              didCatch: !0,
              error: e
            };
          }
          resetErrorBoundary() {
            const {
              error: e
            } = this.state;
            if (null !== e) {
              for (var t, n, r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
              null === (t = (n = this.props).onReset) || void 0 === t || t.call(n, {
                args: o,
                reason: "imperative-api"
              }), this.setState(Hm);
            }
          }
          componentDidCatch(e, t) {
            var n, r;
            null === (n = (r = this.props).onError) || void 0 === n || n.call(r, e, t);
          }
          componentDidUpdate(e, t) {
            const {
                didCatch: n
              } = this.state,
              {
                resetKeys: r
              } = this.props;
            var o, i;
            n && null !== t.error && function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
              return e.length !== t.length || e.some((e, n) => !Object.is(e, t[n]));
            }(e.resetKeys, r) && (null === (o = (i = this.props).onReset) || void 0 === o || o.call(i, {
              next: r,
              prev: e.resetKeys,
              reason: "keys"
            }), this.setState(Hm));
          }
          render() {
            const {
                children: e,
                fallbackRender: t,
                FallbackComponent: n,
                fallback: r
              } = this.props,
              {
                didCatch: o,
                error: i
              } = this.state;
            let a = e;
            if (o) {
              const e = {
                error: i,
                resetErrorBoundary: this.resetErrorBoundary
              };
              if ("function" == typeof t) a = t(e);else if (n) a = (0, d.createElement)(n, e);else {
                if (null !== r && !(0, d.isValidElement)(r)) throw i;
                a = r;
              }
            }
            return (0, d.createElement)(qm.Provider, {
              value: {
                didCatch: o,
                error: i,
                resetErrorBoundary: this.resetErrorBoundary
              }
            }, a);
          }
        }
        function Zm(e, t) {
          return e > t ? t / 1.5 : e;
        }
        class $m extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "sidebarRef", d.createRef()), (0, o.Z)(this, "state", {
              size: Math.min(this.props.initialSize, this.props.maxWidth),
              prevSize: Math.min(this.props.initialSize, this.props.maxWidth)
            }), (0, o.Z)(this, "onResize", e => {
              const {
                  size: t
                } = this.state,
                {
                  onResize: n
                } = this.props,
                r = this.sidebarRef.current && this.sidebarRef.current.getBoundingClientRect();
              r && (null == n || n({
                sidebarRect: r,
                isDragging: e,
                size: t
              }));
            }), (0, o.Z)(this, "onResizeFinish", e => {
              e !== this.props.initialSize && this.props.dispatch((0, Ql.Pt)(e));
            }), (0, o.Z)(this, "onDrag", (e, t) => {
              const {
                minWidth: n,
                maxWidth: r
              } = this.props;
              this.setState(t => {
                let {
                  size: o
                } = t;
                return e < n ? {
                  size: n,
                  prevSize: n
                } : e > r || r - e < 10 ? {
                  size: r,
                  prevSize: o
                } : {
                  size: e,
                  prevSize: o
                };
              }, () => {
                this.onResize(t);
              });
            }), (0, o.Z)(this, "onDoubleClick", () => {
              const {
                maxWidth: e
              } = this.props;
              this.setState(t => {
                let {
                  size: n,
                  prevSize: r
                } = t;
                return n === e ? {
                  size: Zm(r, e)
                } : {
                  size: e,
                  prevSize: n
                };
              }, () => this.onResize(!1));
            });
          }
          componentDidMount() {
            this.onResize(!1);
          }
          componentDidUpdate(e) {
            const {
                size: t,
                prevSize: n
              } = this.state,
              {
                maxWidth: r
              } = this.props;
            r !== e.maxWidth && (t === e.maxWidth || t > r) ? this.setState({
              size: r,
              prevSize: Zm(n, r)
            }) : this.props.initialSize !== e.initialSize && this.setState({
              size: this.props.initialSize
            });
          }
          componentWillUnmount() {
            this.onResize(!1);
          }
          render() {
            const {
                size: e
              } = this.state,
              {
                draggerSize: t,
                isRTL: n,
                maxWidth: r,
                minWidth: o
              } = this.props;
            return d.createElement("div", {
              ref: this.sidebarRef
            }, d.createElement(Gm, {
              size: e,
              onDrag: this.onDrag,
              onDoubleClick: this.onDoubleClick,
              onResizeFinish: this.onResizeFinish,
              draggerSize: t,
              isRTL: n,
              currentValue: Math.round((e - o) / (r - o) * 100),
              shadowRoot: this.props.shadowRoot
            }, d.createElement(Um, {
              fallbackRender: e => {
                let {
                  error: t
                } = e;
                return t(t.message);
              }
            }, this.props.children(e - t, t))));
          }
        }
        class Gm extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              isDragging: !1,
              previousPosition: null
            }), (0, o.Z)(this, "_handlePointerDown", e => {
              const {
                isPrimary: t
              } = e;
              if (!t) return;
              const n = new E.E9({
                x: e.clientX,
                y: e.clientY
              });
              this.setState({
                isDragging: !0,
                previousPosition: n
              });
            }), (0, o.Z)(this, "_handlePointerMove", e => {
              if (!this.state.isDragging) return;
              const t = new E.E9({
                x: e.clientX,
                y: e.clientY
              });
              this._handleDrag(t);
            }), (0, o.Z)(this, "_handlePointerUp", e => {
              if (!this.state.isDragging) return;
              this.setState({
                isDragging: !1
              });
              const {
                previousPosition: t
              } = this.state;
              if (!t) return;
              const n = new E.E9({
                  x: e.clientX,
                  y: e.clientY
                }),
                r = this.props.size + (this.props.isRTL ? t.x - n.x : n.x - t.x);
              this.props.onResizeFinish(r);
            }), (0, o.Z)(this, "_handleDoubleClick", () => {
              this.props.onDoubleClick();
            }), (0, o.Z)(this, "_handleKeyDown", e => {
              const {
                size: t,
                isRTL: n,
                onDrag: r,
                onDoubleClick: o
              } = this.props;
              "ArrowRight" === e.key ? r(n ? t - 2 : t + 2, !1) : "ArrowLeft" === e.key ? r(n ? t + 2 : t - 2, !1) : "Enter" === e.key && o();
            }), (0, o.Z)(this, "_handleDrag", e => {
              const {
                previousPosition: t
              } = this.state;
              if (!t) return;
              const n = this.props.size + (this.props.isRTL ? t.x - e.x : e.x - t.x);
              this.props.onDrag(n, !1), this.setState({
                previousPosition: e
              });
            });
          }
          render() {
            const {
              isRTL: e,
              draggerSize: t,
              currentValue: n
            } = this.props;
            return d.createElement("div", {
              className: `${of().sidebar} PSPDFKit-Sidebar`,
              style: {
                width: this.props.size,
                position: "relative",
                overflow: "hidden",
                [e ? "paddingLeft" : "paddingRight"]: t
              }
            }, this.props.children, d.createElement("div", {
              onDoubleClick: this._handleDoubleClick
            }, d.createElement(Je.Z, {
              onPointerDown: this._handlePointerDown,
              onRootPointerMoveCapture: this._handlePointerMove,
              onRootPointerUpCapture: this._handlePointerUp
            }, d.createElement("div", {
              style: {
                [e ? "left" : "right"]: 0,
                width: t
              },
              className: `${of().dragger} PSPDFKit-Sidebar-Dragger`
            }, d.createElement("div", {
              tabIndex: 0,
              role: "separator",
              "aria-label": "Resizer handle",
              "aria-orientation": "vertical",
              "aria-valuenow": n,
              onKeyDown: this._handleKeyDown,
              style: this.props.shadowRoot ? {} : {
                [e ? "right" : "left"]: this.props.size - t
              },
              className: `${of().draggerHandle} PSPDFKit-Sidebar-DraggerHandle`
            })))));
          }
        }
        class Wm extends d.PureComponent {
          render() {
            const {
              formatMessage: e
            } = this.props.intl;
            return d.createElement(Gd.Z, {
              role: "dialog",
              onEscape: this.props.onEscape,
              background: "rgba(0,0,0,.1)",
              className: Er().modal,
              accessibilityLabel: e(Ym.signatureDialog),
              accessibilityDescription: e(Ym.signatureDialogDescription)
            }, this.props.children);
          }
        }
        const Ym = {
            signatureDialog: {
              id: "signatureDialog",
              defaultMessage: "Signature",
              description: "Signature Dialog"
            },
            signatureDialogDescription: {
              id: "signatureDialogDesc",
              defaultMessage: "This dialog lets you select an ink signature to insert into the document. If you do not have stored signatures, you can create one using the canvas view.",
              description: "Signature Dialog description"
            }
          },
          Xm = (0, xe.XN)(Wm);
        var Qm = n(60379),
          Jm = n(16602),
          eg = n(55752);
        function tg(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ng(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? tg(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tg(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const rg = Jm.Z.filter(e => [Qm.Z.BLACK, Qm.Z.BLUE, Qm.Z.RED].includes(e.color));
        class og extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O), (0, o.Z)(this, "state", {
              annotation: new eg.Z(ng(ng({}, this.props.preset), {}, {
                isSignature: !0
              })),
              zoomLevel: 1
            }), (0, o.Z)(this, "_onAnnotationColorChange", e => {
              const t = this.state.annotation.withMutations(t => {
                t.set("strokeColor", e);
              });
              this._onChange(t);
            }), (0, o.Z)(this, "_clear", () => {
              this.setState({
                annotation: new eg.Z(ng(ng({}, this.props.preset), {}, {
                  isSignature: !0
                }))
              }, this._callOnChange);
            }), (0, o.Z)(this, "_onChange", e => {
              this.setState({
                annotation: e
              }, this._callOnChange);
            }), (0, o.Z)(this, "_callOnChange", () => {
              const {
                onChange: e
              } = this.props;
              if (!e) return;
              e((0, mi.c)(this.state.annotation, this.state.annotation.boundingBox.getLocation().scale(-1), this.props.canvasSize, new E.E9()));
            }), (0, o.Z)(this, "_onResize", e => {
              this.setState({
                zoomLevel: e.width / this.props.canvasSize.width
              });
            });
          }
          render() {
            const {
                annotation: e
              } = this.state,
              {
                canvasSize: t
              } = this.props,
              {
                formatMessage: n
              } = this.props.intl,
              r = e.lines.isEmpty();
            return d.createElement(d.Fragment, null, d.createElement("div", {
              className: Er().header
            }, d.createElement(Ac, {
              colorPresets: rg,
              activeColor: e.strokeColor,
              onClick: this._onAnnotationColorChange,
              className: h()(Er().colorPicker, "PSPDFKit-Signature-Dialog-Color-Picker")
            }), d.createElement(i.zx, {
              onClick: this._clear,
              inverted: !0,
              disabled: r,
              className: h()(Er().button, "PSPDFKit-Signature-Dialog-Clear-Signature-Button")
            }, n(ke.Z.clearSignature))), d.createElement("div", {
              className: Er().editorCanvasContainer
            }, d.createElement("div", {
              className: h()(Er().editorCanvas, "PSPDFKit-Signature-Dialog-Canvas", "PSPDFKit-Signature-Canvas", "interactions-disabled")
            }, d.createElement(vd.Z, {
              onResize: this._onResize
            }), d.createElement("div", {
              className: h()(Er().signHere, "PSPDFKit-Signature-Dialog-Sign-Here-Label", {
                [Er().signHereHidden]: !e.lines.isEmpty()
              })
            }, n(ig.pleaseSignHere)), d.createElement(ko, {
              annotation: e,
              canvasSize: t,
              onDrawStart: this._onChange,
              onDraw: this._onChange,
              onDrawEnd: this._onChange,
              zoomLevel: this.state.zoomLevel,
              cursor: "crosshair"
            }))));
          }
        }
        (0, o.Z)(og, "defaultProps", {
          canvasSize: new E.$u({
            width: 600,
            height: 260
          }),
          preset: {}
        });
        const ig = (0, xe.vU)({
            pleaseSignHere: {
              id: "pleaseSignHere",
              defaultMessage: "Please sign here",
              description: "Message on the signature canvas"
            }
          }),
          ag = (0, xe.XN)(og);
        var sg,
          lg = n(16522),
          ug = n.n(lg);
        function cg(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function dg(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? cg(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cg(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class pg extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "imageFetcherRef", d.createRef()), (0, o.Z)(this, "loadingIndicatorTimeout", null), (0, o.Z)(this, "unmounted", !1), (0, o.Z)(this, "state", {
              loadingState: "LOADING",
              showLoadingIndicator: !1
            }), (0, o.Z)(this, "_fetchImage", () => {
              const {
                backend: e,
                attachment: t,
                templateWidth: n
              } = this.props;
              let r = this.props.annotation.update("boundingBox", e => null == e ? void 0 : e.set("left", 0).set("top", 0)),
                {
                  boundingBox: o
                } = r;
              const i = Math.max(o.width, o.height);
              return i < n && (o = o.scale(n / i), r = r.set("boundingBox", o)), (0, Me.an)({
                backend: e,
                blob: null == t ? void 0 : t.data,
                annotation: r,
                isDetachedAnnotation: !0,
                zoomLevel: 1
              });
            }), (0, o.Z)(this, "_renderFinished", e => {
              this.unmounted || (this.setState({
                loadingState: "LOADED"
              }), this.props.onRenderFinished && this.props.onRenderFinished(e));
            }), (0, o.Z)(this, "_showError", () => {
              this.setState({
                loadingState: "ERROR"
              });
            }), (0, o.Z)(this, "_showLoadingIndicator", () => {
              this.setState(e => ({
                showLoadingIndicator: "LOADING" === e.loadingState
              }));
            });
          }
          componentDidUpdate(e) {
            if (!(0, s.is)((0, j.ip)(this.props.annotation), (0, j.ip)(e.annotation)) || e.annotation.imageAttachmentId !== this.props.annotation.imageAttachmentId || e.templateWidth < this.props.templateWidth) {
              if (!this.imageFetcherRef.current) return;
              this.imageFetcherRef.current.refresh();
            }
          }
          componentDidMount() {
            this.loadingIndicatorTimeout = setTimeout(this._showLoadingIndicator, Ne.rB);
          }
          componentWillUnmount() {
            this.unmounted = !0, window.clearTimeout(this.loadingIndicatorTimeout);
          }
          render() {
            const {
                annotation: e,
                templateWidth: t,
                label: n,
                contain: r
              } = this.props,
              {
                opacity: o
              } = e,
              {
                width: i,
                height: a
              } = e.boundingBox,
              s = i > 0 && a > 0 ? i / a : 1,
              l = s > 1 ? ug().wideImg : ug().highImg,
              u = h()(e instanceof _.sK ? ug().imageAnnotation : ug().stampAnnotation, r ? ug().containedImg : ug().notContainedImg, l),
              c = h()(ug().wrapper, {
                [ug()["imageAnnotation-loading"]]: "LOADING" === this.state.loadingState && this.state.showLoadingIndicator,
                [ug()["imageAnnotation-error"]]: "ERROR" === this.state.loadingState
              }),
              p = {
                opacity: o,
                position: "relative",
                width: r ? 0 === t || s >= 1 ? "100%" : t : "auto"
              },
              f = dg(dg({}, p), {}, {
                height: 0 === t ? "100%" : s > 1 ? t : t * s
              });
            return d.createElement("div", {
              style: p,
              className: c
            }, d.createElement(Re.Z, {
              className: u,
              fetchImage: this._fetchImage,
              label: n,
              visible: !0,
              onRenderFinished: this._renderFinished,
              onError: this._showError,
              rectStyle: f,
              ref: this.imageFetcherRef
            }), "LOADING" === this.state.loadingState && this.state.showLoadingIndicator ? d.createElement("div", {
              className: ug().placeHolder
            }, sg || (sg = d.createElement(Be.Z, null))) : "ERROR" === this.state.loadingState ? d.createElement("div", {
              className: ug().placeHolder
            }, d.createElement(je.Z, {
              src: Ve(),
              className: ug().errorIcon
            })) : null);
          }
        }
        class hg extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "shouldComponentUpdate", Pe.O);
          }
          render() {
            const {
                formatMessage: e
              } = this.props.intl,
              t = null == this.props.showDeleteBtn || this.props.showDeleteBtn;
            return d.createElement("ul", {
              className: h()(Er().signaturePickerList, "PSPDFKit-Signature-Dialog-Picker", "PSPDFKit-Signature-Picker")
            }, this.props.signatures.map((r, o) => d.createElement("li", {
              key: o,
              className: h()(Er().signaturePickerListItem, "PSPDFKit-Signature-Dialog-Picker-Item"),
              "data-signature": o
            }, d.createElement(i.zx, {
              className: h()(Er().selectSignatureButton, "PSPDFKit-Signature-Dialog-Picker-Item-Button", {
                [Er().imageAnnotation]: r instanceof _.sK
              }),
              onClick: () => {
                this.props.onSelect(r);
              },
              autoFocus: 0 === o
            }, r instanceof _.Zc ? d.createElement(pt, {
              isSelectable: !1,
              annotation: r,
              viewBox: r.boundingBox
            }) : d.createElement(pg, {
              annotation: r,
              backend: this.props.backend,
              label: r.description || e(ke.Z.imageAnnotation),
              attachment: r.imageAttachmentId ? this.props.attachments.get(r.imageAttachmentId) : null,
              templateWidth: 153.5
            })), t ? d.createElement("button", {
              className: h()(Er().deleteSignatureButton, "PSPDFKit-Signature-Dialog-Picker-Item-Delete-Button"),
              onClick: () => {
                this.props.onDelete(r);
              },
              "aria-label": e(ke.Z.delete)
            }, d.createElement(je.Z, {
              src: n(63949)
            })) : null)));
          }
        }
        const fg = (0, xe.XN)(hg);
        var mg;
        function gg(e) {
          let {
            children: t,
            hasDivider: n
          } = e;
          return n ? d.createElement(d.Fragment, null, mg || (mg = d.createElement(i.u_.Divider, {
            spaced: !1
          })), d.createElement(i.u_.Section, null, t)) : d.createElement("div", {
            className: Er().footer
          }, t);
        }
        class vg extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              annotation: null,
              hideSignaturePicker: !1,
              storeSignature: !!this.props.canStoreSignature
            }), (0, o.Z)(this, "_hideSignaturePicker", () => {
              this.setState({
                hideSignaturePicker: !0,
                annotation: null
              });
            }), (0, o.Z)(this, "_onSignatureChange", e => {
              this.setState({
                annotation: e
              });
            }), (0, o.Z)(this, "_onDone", () => {
              const {
                  onCreate: e,
                  onCancel: t
                } = this.props,
                {
                  annotation: n,
                  storeSignature: r
                } = this.state;
              n ? null == e || e(n, r, !0) : null == t || t();
            }), (0, o.Z)(this, "_toggleStoreSignature", () => {
              this.setState(e => ({
                storeSignature: !e.storeSignature
              }));
            });
          }
          render() {
            const {
                onCreate: e,
                onDelete: t,
                storedSignatures: n,
                preset: r
              } = this.props,
              o = !!this.props.canStoreSignature,
              a = !this.state.hideSignaturePicker && o && Boolean(n && n.size > 0),
              {
                formatMessage: l
              } = this.props.intl,
              {
                annotation: u,
                storeSignature: c
              } = this.state,
              p = null !== u && u.lines instanceof s.aV && !u.lines.isEmpty(),
              {
                SIGNATURE_SAVE_MODE: f
              } = it.Options,
              m = f === tu.f.USING_UI;
            return d.createElement("div", {
              className: h()(Er().viewRoot, "PSPDFKit-Signature-Dialog", {
                [Er().viewSignaturePicker]: a
              })
            }, a && n ? d.createElement(d.Fragment, null, d.createElement("div", {
              className: Er().header
            }, d.createElement("div", {
              className: h()(Er().title, "PSPDFKit-Signature-Dialog-Signature-Heading"),
              role: "heading",
              "aria-level": "1"
            }, l(ke.Z.signatures)), d.createElement(i.zx, {
              className: "PSPDFKit-Signature-Dialog-Add-Signature-Button",
              onClick: this._hideSignaturePicker,
              inverted: !0
            }, l(ke.Z.addSignature))), d.createElement("div", {
              className: Er().signaturePickerContainer
            }, d.createElement(fg, {
              signatures: n,
              onSelect: t => {
                e(t, !1, !0);
              },
              onDelete: e => {
                t(e, !0);
              },
              backend: this.props.backend,
              attachments: this.props.attachments,
              viewportWidth: this.props.viewportWidth
            }))) : d.createElement(ag, {
              onChange: this._onSignatureChange,
              preset: r
            }), d.createElement(gg, {
              hasDivider: a && o
            }, !a && o && m && d.createElement("label", {
              className: h()(Er().checkbox, "PSPDFKit-Signature-Dialog-Store-Signature-Checkbox")
            }, d.createElement("input", {
              type: "checkbox",
              name: "store",
              checked: c,
              onChange: this._toggleStoreSignature
            }), d.createElement("span", {
              className: Er().checkboxLabel
            }, l(ke.Z.storeSignature))), d.createElement(i.hE, {
              className: Er().group,
              align: "end"
            }, d.createElement(i.zx, {
              onClick: this.props.onCancel,
              className: h()(Er().button, "PSPDFKit-Signature-Dialog-Cancel-Button"),
              autoFocus: !a
            }, l(ke.Z.cancel)), !a && d.createElement(i.zx, {
              primary: !0,
              disabled: !p,
              onClick: p ? this._onDone : null,
              className: h()(Er().button, "PSPDFKit-Signature-Dialog-Done-Button")
            }, l(ke.Z.done)))));
          }
        }
        (0, o.Z)(vg, "defaultProps", {
          canStoreSignature: !0
        });
        const yg = (0, xe.XN)(vg);
        var bg = n(21655),
          wg = n(46455),
          xg = n(36828);
        const Dg = (0, xe.vU)({
          thumbnails: {
            id: "thumbnails",
            defaultMessage: "Thumbnails",
            description: "Thumbnails"
          }
        });
        const Cg = (0, qn.x)(function (e) {
          const {
              pages: t,
              backend: n,
              viewportState: {
                viewportRect: r
              },
              annotations: o,
              attachments: i,
              showAnnotations: a,
              formFields: l,
              renderPageCallback: u
            } = e,
            c = (0, Ke.Qg)(l);
          let d = {
            left: 0,
            top: 0,
            x: 0,
            y: 0
          };
          return e.shadowRoot instanceof ShadowRoot && (d = e.shadowRoot.host.getBoundingClientRect()), {
            annotations: a ? o : (0, s.D5)(),
            attachments: i,
            backend: n,
            formFields: l,
            formFieldValues: c,
            height: r.height,
            pages: t,
            renderPageCallback: u,
            containerOffset: d
          };
        })(function (e) {
          const {
              pages: t,
              closeOnPress: n,
              selectedPageIndex: r,
              navigationDisabled: o,
              containerOffset: i
            } = e,
            [a, u] = d.useState(null);
          d.useEffect(() => {
            null == a || a.focus();
          }, [a]);
          const c = d.useMemo(() => t.map(xg.J), [t]),
            {
              formatMessage: p
            } = (0, xe.YB)(),
            h = (0, po.Bo)(a, c),
            f = (0, po.mP)(h, e => String(e.index), e => null == c ? void 0 : c.find(t => String(t.index) === String(e))),
            m = (0, l.I0)(),
            g = d.useCallback(function (e) {
              o || (n ? (m((0, Ql.YA)(e)), m((0, Kt.mu)())) : e !== r && m((0, Ql.YA)(e)));
            }, [n, m, r, o]),
            v = d.useCallback(function (e, n, r) {
              const o = t.find(t => t.pageIndex === e);
              if (!o) return {
                item: null,
                label: e + 1 + ""
              };
              const i = f ? e => {
                f(e, (0, xg.J)(o));
              } : void 0;
              return {
                item: d.createElement(wg.Z, {
                  key: o.pageKey,
                  page: o,
                  size: n,
                  maxSize: r,
                  pageRef: i
                }),
                label: o.pageLabel || e + 1 + ""
              };
            }, [t, f]),
            y = d.useCallback(function (e) {
              const n = t.find(t => t.pageIndex === e);
              return (null == n ? void 0 : n.pageKey) || `${e}`;
            }, [t]);
          return d.createElement("div", {
            role: "region",
            "aria-label": p(Dg.thumbnails),
            tabIndex: -1,
            ref: u,
            className: "PSPDFKit-Sidebar-Thumbnails"
          }, c ? d.createElement(bg.Z, {
            width: e.width,
            height: e.height,
            totalItems: c.size,
            renderItemCallback: v,
            itemKeyCallback: y,
            itemScale: e.scale,
            onItemPress: g,
            selectedItemIndexes: (0, s.l4)([r]),
            cssPrefix: "PSPDFKit-Sidebar",
            clickDisabled: o,
            thumbnailHeight: Ne.rT,
            containerOffset: i
          }) : null);
        });
        var Sg = n(27895),
          Eg = n.n(Sg);
        function _g(e) {
          let {
            position: t,
            children: n
          } = e;
          return d.createElement("div", null, d.createElement("div", {
            className: h()("PSPDFKit-Toolbars", Eg().root, {
              [Eg().stickToBottom]: "bottom" === t
            })
          }, n));
        }
        var Pg = n(69842),
          kg = n(5017),
          Ag = n.n(kg);
        function zg(e) {
          const [t, r] = d.useState(!1),
            [o, a] = d.useState(!1),
            s = d.useRef(e.digitalSignatures);
          d.useEffect(() => {
            e.digitalSignatures !== s.current && r(!1), s.current = e.digitalSignatures;
          }, [e.digitalSignatures]), d.useEffect(() => {
            !async function () {
              const t = (0, Tr.jI)(e.digitalSignatures, e.showSignatureValidationStatus);
              a(t);
            }();
          }, [e.showSignatureValidationStatus, e.digitalSignatures]);
          const {
              formatMessage: l
            } = (0, xe.YB)(),
            {
              status: u,
              messageId: c,
              iconPath: p
            } = e.digitalSignatures ? function (e) {
              let {
                documentModifiedSinceSignature: t,
                status: n
              } = e;
              if (n === Pg._.valid) return t ? {
                status: "warning",
                messageId: "digitalSignaturesDocModified",
                iconPath: "warning-2.svg"
              } : {
                status: "valid",
                messageId: "digitalSignaturesAllValid",
                iconPath: "digital-signatures/signature-valid.svg"
              };
              if (n === Pg._.warning) return {
                status: "warning",
                messageId: t ? "digitalSignaturesSignatureWarningDocModified" : "digitalSignaturesSignatureWarning",
                iconPath: "warning-2.svg"
              };
              if (n === Pg._.error) return {
                status: "error",
                messageId: t ? "digitalSignaturesSignatureErrorDocModified" : "digitalSignaturesSignatureError",
                iconPath: "digital-signatures/signature-error.svg"
              };
              return {
                status: null,
                messageId: null,
                iconPath: null
              };
            }(e.digitalSignatures) : {
              status: null,
              messageId: null,
              iconPath: null
            };
          if (null == u || null == c || t) return null;
          const f = h()(Ag().root, Ag()[`status-${u}`], "PSPDFKit-Digital-Signatures-Status", `PSPDFKit-Digital-Signatures-Status-${(0, gn.kC)(u)}`),
            m = h()(Ag().signatureValidationStatusIcon, Ag()[`status-${u}-icon`], "PSPDFKit-Digital-Signatures-Status-Icon");
          return o ? d.createElement("div", {
            className: f
          }, d.createElement("div", {
            className: Ag().signatureInfoContainer
          }, d.createElement("div", {
            className: Ag().signatureValidationStatusIconContainer
          }, d.createElement(je.Z, {
            className: m,
            src: n(79230)(`./${p}`)
          })), d.createElement("span", {
            className: h()(Ag().signatureValidationStatusText, "PSPDFKit-Digital-Signatures-Status-Text")
          }, l(Tg[c]))), d.createElement(i.zx, {
            className: h()(Ag().signatureValidationCloseButton, "PSPDFKit-Digital-Signatures-Status-Close-Button"),
            onClick: () => {
              r(!0);
            },
            "aria-label": "Close digital signatures status bar"
          }, d.createElement(je.Z, {
            className: Ag().signatureValidationCloseIcon,
            src: n(2256)
          }))) : null;
        }
        const Tg = (0, xe.vU)({
          digitalSignaturesDocModified: {
            id: "digitalSignaturesDocModified",
            defaultMessage: "The document has been digitally signed, but it has been modified since it was signed.",
            description: "Message when document is valid but has been modified since it was signed."
          },
          digitalSignaturesAllValid: {
            id: "digitalSignaturesAllValid",
            defaultMessage: "The document has been digitally signed and all signatures are valid.",
            description: "Message when document is valid."
          },
          digitalSignaturesSignatureWarningDocModified: {
            id: "digitalSignaturesSignatureWarningDocModified",
            defaultMessage: "The document has been digitally signed, but it has been modified since it was signed and at least one signature has problems.",
            description: 'Message when the document is in a "warning" status and the document has been modified since signing.'
          },
          digitalSignaturesSignatureWarning: {
            id: "digitalSignaturesSignatureWarning",
            defaultMessage: "The document has been digitally signed, but at least one signature has problems.",
            description: 'Message when the document is in a "warning" status.'
          },
          digitalSignaturesSignatureErrorDocModified: {
            id: "digitalSignaturesSignatureErrorDocModified",
            defaultMessage: "The document has been digitally signed, but it has been modified since it was signed and at least one signature is invalid.",
            description: 'Message when the document is in a "error" status and the document has been modified since signing.'
          },
          digitalSignaturesSignatureError: {
            id: "digitalSignaturesSignatureError",
            defaultMessage: "The document has been digitally signed, but at least one signature is invalid.",
            description: 'Message when the document is in a "error" status.'
          }
        });
        var Og = n(99879),
          Ig = n.n(Og);
        const Fg = d.memo(function (e) {
          return d.createElement(Tf, {
            itemClassName: Ig().item,
            rootClassName: h()("PSPDFKit-Annotation-Tooltip", Ig().root),
            items: e.items
          });
        });
        var Mg = n(98416),
          Rg = n.n(Mg);
        function jg(e) {
          let {
            viewportState: {
              viewportRect: t
            },
            children: n,
            scrollbarOffset: r
          } = e;
          const o = {
            width: t.width + r,
            height: t.height
          };
          return d.createElement("div", {
            className: `PSPDFKit-Viewport ${Rg().root}`,
            style: o
          }, n);
        }
        var Bg = n(91414),
          Ng = n.n(Bg);
        const Lg = (0, xe.XN)(function (e) {
            const {
              formatMessage: t
            } = e.intl;
            return d.createElement(Gd.Z, {
              role: "alertdialog",
              onEscape: e.onCancel,
              background: "rgba(0,0,0,.1)",
              className: "PSPDFKit-Confirm-Dialog PSPDFKit-Reload-Document-Confirm-Dialog",
              accessibilityLabel: t(Vg.reloadDocumentDialog),
              accessibilityDescription: t(Vg.reloadDocumentDialogDesc)
            }, d.createElement(Gd.Z.Section, {
              style: {
                paddingBottom: 0
              }
            }, d.createElement("div", {
              className: `${Ng().content} PSPDFKit-Confirm-Dialog-Content`
            }, d.createElement("div", null, t(Vg.instantModifiedWarning)))), d.createElement(Gd.Z.Section, null, d.createElement(i.hE, {
              className: "PSPDFKit-Confirm-Dialog-Buttons",
              align: "end"
            }, d.createElement(i.zx, {
              autoFocus: !0,
              onClick: e.onCancel,
              className: "PSPDFKit-Confirm-Dialog-Button PSPDFKit-Confirm-Dialog-Button-Cancel"
            }, t(ke.Z.cancel)), d.createElement(i.zx, {
              onClick: e.onConfirm,
              primary: !0,
              className: "PSPDFKit-Confirm-Dialog-Button PSPDFKit-Confirm-Dialog-Button-Confirm"
            }, t(Vg.reloadDocument)))));
          }),
          Vg = (0, xe.vU)({
            instantModifiedWarning: {
              id: "instantModifiedWarning",
              defaultMessage: "Reload document confirm dialog message",
              description: "The document was modified and is now in read-only mode. Reload the page to fix this."
            },
            reloadDocument: {
              id: "reloadDocument",
              defaultMessage: "Reload Document",
              description: "Reload"
            },
            reloadDocumentDialog: {
              id: "reloadDocumentDialog",
              defaultMessage: "Confirm document reload",
              description: "Reload Document Confirm Dialog"
            },
            reloadDocumentDialogDesc: {
              id: "reloadDocumentDialogDesc",
              defaultMessage: "Dialog prompting the user to confirm reloading the document.",
              description: "Description for the Reload Document Dialog"
            }
          });
        var Kg = n(56554),
          qg = n(13349),
          Hg = n(36572),
          Ug = n.n(Hg),
          Zg = n(3324),
          $g = n(13608),
          Gg = n(65575),
          Wg = n.n(Gg);
        function Yg(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Xg(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Yg(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Yg(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Qg = {
            components: {
              ToolbarDropdownGroupComponent: Zg.Z,
              ToolbarButtonComponent: Ju.Z
            },
            styles: Xg(Xg({}, Ug()), {}, {
              toolbar: $g
            })
          },
          Jg = (0, d.lazy)(() => n.e(4572).then(n.bind(n, 29332))),
          ev = d.createElement("div", {
            className: Wg().fallback,
            "data-testid": "fallback"
          }, d.createElement("div", {
            className: Wg().fallbackToolbar
          }), d.createElement("div", {
            className: Wg().fallbackPagesView
          }, d.createElement(Be.Z, {
            scale: 2
          })), d.createElement("div", {
            className: Wg().fallbackToolbar
          })),
          tv = {
            documentEditor: {
              id: "documentEditor",
              defaultMessage: "Document Editor",
              description: "Document Editor"
            },
            documentEditorDesc: {
              id: "documentEditorDesc",
              defaultMessage: "Make changes to the current document",
              description: "Description of the Document Editor modal"
            }
          },
          nv = e => {
            const {
                formatMessage: t
              } = (0, xe.YB)(),
              [n, r] = (0, d.useState)(!0),
              o = (0, d.useCallback)(e => {
                r(!e);
              }, []),
              i = (0, d.useCallback)(() => {
                n && e.onCancel();
              }, [n, e]);
            return d.createElement(Gd.Z, {
              onEscape: i,
              useBorderRadius: !1,
              className: Wg().modal,
              accessibilityLabel: t(tv.documentEditor),
              accessibilityDescription: t(tv.documentEditorDesc)
            }, d.createElement(d.Suspense, {
              fallback: ev
            }, d.createElement(Jg, {
              onCancel: e.onCancel,
              scale: e.scale,
              CSS_HACK: Qg,
              onDialog: o,
              usesShadowDOM: e.usesShadowDOM
            })));
          };
        function rv() {
          const [e, t] = d.useState(null),
            n = (0, l.v9)(e => e.instance),
            [r, o] = d.useState(!1);
          d.useEffect(() => {
            o(!!n);
          }, [n]), d.useEffect(() => {
            null == e || e.focus();
          }, [e]), (0, po.Bo)(e, null);
          const i = h()(of().container, "PSPDFKit-Sidebar-Custom");
          return r ? d.createElement("div", {
            role: "region",
            tabIndex: -1,
            ref: t,
            className: i
          }) : null;
        }
        var ov,
          iv = n(74792),
          av = n(22284);
        function sv(e) {
          const {
            formatMessage: t
          } = (0, xe.YB)();
          return d.createElement("form", {
            onSubmit: e.onSave,
            className: h()(nf().editor, "PSPDFKit-Sidebar-Bookmarks-Editor"),
            onKeyUp: t => {
              t.which === br.zz && e.onCancel();
            }
          }, e.title && d.createElement("h2", {
            className: h()(nf().heading, "PSPDFKit-Sidebar-Bookmarks-Heading")
          }, e.title), d.createElement("label", null, d.createElement(i.oi, {
            value: e.value,
            onChange: e.onChange,
            autoFocus: !0,
            selectTextOnFocus: !0,
            name: "name",
            placeholder: t(ke.Z.name),
            autoComplete: "off",
            style: {
              fontSize: "inherit",
              fontWeight: "normal",
              padding: "calc(0.8125em/ 2) 0.8125em"
            }
          })), d.createElement("div", {
            className: h()(nf().buttonContainer, "PSPDFKit-Sidebar-Bookmarks-Button-Container")
          }, e.onDelete && d.createElement(i.zx, {
            onClick: e.onDelete,
            inverted: !0,
            danger: !0,
            className: h()("PSPDFKit-Sidebar-Bookmarks-Button-Delete", nf().bookmarkDeleteButton)
          }, t(ke.Z.delete)), d.createElement("div", {
            className: nf().bookmarkSaveCancelButtonsContainer
          }, d.createElement(i.zx, {
            onClick: e.onCancel,
            className: "PSPDFKit-Sidebar-Bookmarks-Button-Cancel"
          }, t(ke.Z.cancel)), d.createElement(i.zx, {
            primary: !0,
            type: "submit",
            className: "PSPDFKit-Sidebar-Bookmarks-Button-Save"
          }, t(ke.Z.save)))));
        }
        function lv(e) {
          var t;
          const {
              bookmarks: r,
              pages: o,
              currentPageIndex: a,
              bookmarkManager: u
            } = e,
            [c, p] = d.useState(null);
          d.useEffect(() => {
            null == c || c.focus();
          }, [c]);
          const [f, m] = d.useState(null),
            [g, v] = d.useState(null),
            [y, b] = d.useState(!1),
            [w, x] = d.useState(null),
            D = (0, l.I0)(),
            C = d.useRef(),
            S = d.useRef(null),
            E = d.useRef(!1),
            [P, k] = d.useState(new Set()),
            {
              formatMessage: A
            } = (0, xe.YB)(),
            z = (0, po.R9)(() => {
              m(null), v(null), b(!1);
            }),
            T = (0, po.R9)(e => {
              v(e.currentTarget.value);
            }),
            O = (0, po.R9)(() => {
              f && f.id && (E.current = !0), z(), x(A(dv.cancelledEditingBookmark));
            }),
            I = (0, po.R9)(e => {
              if (e.persist(), e.preventDefault(), f && g !== f.name) {
                let e = f.set("name", g).setIn(["action", "pageIndex"], a);
                e.id ? u.updateObject(e) : (e = e.set("id", (0, av.A)()), S.current = e.id, u.createObject(e)), u.autoSave(), x(A(dv.bookmarkEdited));
              } else x(A(dv.bookmarkCreated));
              z();
            }),
            F = (0, po.R9)(() => {
              f && (u.deleteObject(f), u.autoSave()), z(), x(A(dv.bookmarkDeleted));
            }),
            M = (0, po.R9)(() => {
              b(!1);
            }),
            R = (0, po.R9)(() => {
              b(!0);
            }),
            j = (0, po.R9)(e => {
              m(e), v(e.name || "");
            }),
            B = (0, po.R9)(() => {
              m(new _.rp({
                action: new _.Di({
                  pageIndex: e.currentPageIndex
                })
              })), v("");
            });
          d.useEffect(() => {
            null != c && c.hasAttribute("aria-label") && c.focus();
          }, [c]);
          const N = (0, po.jC)(e);
          d.useEffect(() => {
            if (C.current && null != N && N.bookmarks && r && (N.bookmarks !== r || E.current)) {
              var e;
              const t = null !== (e = cv(r).findIndex(e => e.id === S.current)) && void 0 !== e ? e : -1;
              t > -1 && C.current.setActiveItem(t), E.current = !1;
            }
          });
          const L = r ? (0, s.aV)(cv(r)) : r,
            V = (0, po.Bo)(c, L),
            K = {
              className: h()(nf().container, !L && nf().loading + " PSPDFKit-Sidebar-Loading", L && 0 === L.size && " PSPDFKit-Sidebar-Empty", "PSPDFKit-Sidebar-Bookmarks"),
              ref: p,
              style: {
                width: e.width
              },
              role: "region",
              "aria-label": A(ke.Z.bookmarks)
            },
            q = (0, po.mP)(V, e => e.id, e => null == L ? void 0 : L.find(t => t.id === e));
          if (!L) return d.createElement("div", (0, ce.Z)({}, K, {
            tabIndex: 0
          }), d.createElement(i.TX, {
            "aria-live": "polite"
          }, A(dv.loadingBookmarks)), ov || (ov = d.createElement(Be.Z, null)));
          const H = o.get(a),
            U = H && H.get("pageLabel");
          return d.createElement("div", K, d.createElement(i.TX, {
            "aria-live": "polite"
          }, A(ke.Z.bookmarks)), f && !f.id ? d.createElement(sv, {
            onChange: T,
            onSave: I,
            onCancel: O,
            value: g,
            title: A(ke.Z.pageX, {
              arg0: U || e.currentPageIndex + 1
            }) + ": " + A(dv.newBookmark)
          }) : d.createElement("div", {
            style: {
              width: "100%"
            }
          }, d.createElement("div", {
            className: of().sidebarHeader
          }, d.createElement("h2", {
            "aria-hidden": "true",
            className: h()(nf().heading, "PSPDFKit-Sidebar-Bookmarks-Heading")
          }, " ", d.createElement("span", null, A(ke.Z.bookmarks))), d.createElement(i.zx, {
            primary: !0,
            onClick: B,
            className: h()("PSPDFKit-Sidebar-Bookmarks-Button-Add"),
            autoFocus: !0
          }, A(dv.newBookmark)))), L && L.size > 0 && d.createElement(i.HJ, {
            onActiveItemIndexChange: e => {
              const t = L.get(e);
              t && t.id && (S.current = t.id);
            },
            ref: C,
            items: L.toArray().map((r, i) => {
              const s = r.action,
                l = s.pageIndex === a,
                u = h()({
                  [nf().layout]: !0,
                  [nf().layoutWidth]: !0,
                  [nf().layoutEditing]: r === f,
                  [nf().layoutNarrow]: e.closeOnPress,
                  [nf().selected]: l,
                  "PSPDFKit-Sidebar-Bookmarks-Bookmark": !0,
                  "PSPDFKit-Sidebar-Bookmarks-Bookmark-Selected": l,
                  "PSPDFKit-Sidebar-Bookmarks-Bookmark-Editing": r === f
                }),
                c = h()([nf().name], {
                  [nf().nameEllipsis]: !P.has(i)
                }, "PSPDFKit-Sidebar-Bookmarks-Name"),
                p = o.get(s.pageIndex),
                m = p && p.pageLabel,
                v = r.action instanceof _.Di ? A(ke.Z.pageX, {
                  arg0: m || s.pageIndex + 1
                }) : null,
                y = r.action instanceof _.Di ? m || s.pageIndex + 1 : null,
                b = v || A(ke.Z.bookmark),
                w = d.createElement(d.Fragment, null, d.createElement("div", {
                  onClick: () => (e => {
                    k(t => (t.has(e) ? t.delete(e) : t.add(e), new Set(t)));
                  })(i),
                  className: c
                }, r.name || A(ke.Z.bookmark)), !!y && d.createElement("span", {
                  className: h()(nf().pageNumber)
                }, y));
              r.name;
              const x = q ? e => {
                q(e, r);
              } : void 0;
              return d.createElement("div", {
                key: "bookmark-item-" + r.id,
                ref: x,
                className: h()(nf().wrapper, nf().container)
              }, r === f ? t || (t = d.createElement(sv, {
                onChange: T,
                onSave: I,
                onCancel: O,
                onDelete: R,
                value: g
              })) : d.createElement("div", {
                className: h()(nf().wrapper, nf().fullWidth)
              }, d.createElement("div", {
                className: u,
                "aria-label": b,
                onClick: t => {
                  t.preventDefault(), D((0, Gr.aG)(r.action)), e.closeOnPress && D((0, Kt.mu)());
                }
              }, d.createElement("button", {
                type: "button",
                className: nf().layoutSmallWidth,
                "aria-label": r.action instanceof _.Di ? A(ke.Z.gotoPageX, {
                  arg0: m || r.action.pageIndex + 1
                }) : r.name || void 0
              }, d.createElement("span", {
                className: nf().wrapper
              }, w)), d.createElement("button", {
                title: b + ": " + A(ke.Z.edit),
                className: h()(nf().edit, e.closeOnPress && nf().editVisible, "PSPDFKit-Sidebar-Bookmarks-Button-Edit"),
                onClick: e => {
                  e.stopPropagation(), j(r);
                }
              }, d.createElement(je.Z, {
                src: n(61802),
                role: "presentation"
              })))));
            })
          }), d.createElement(i.TX, {
            announce: "polite"
          }, w), L && L.size > 0 && y && d.createElement(vu.Z, {
            onCancel: M,
            onConfirm: F,
            accessibilityLabel: A(dv.deleteBookmarkConfirmAccessibilityLabel),
            accessibilityDescription: A(dv.deleteBookmarkConfirmAccessibilityDescription)
          }, A(dv.deleteBookmarkConfirmMessage)));
        }
        const uv = (0, iv.createSubscription)({
            getCurrentValue: () => {},
            subscribe: (e, t) => {
              let n = function () {};
              const r = () => {
                const n = e.getBookmarks();
                return n.then(t), n;
              };
              return r().then(() => {
                e.eventEmitter.on("change", r), n = () => {
                  e.eventEmitter.off("change", r);
                };
              }), () => n();
            }
          }),
          cv = (0, dn.Z)(e => e.valueSeq().toArray().sort((e, t) => {
            const n = e.action.pageIndex,
              r = t.action.pageIndex,
              o = !isNaN(n),
              i = !isNaN(r);
            return o && i ? n === r ? 0 : n < r ? -1 : 1 : o ? -1 : i ? 1 : e.name && t.name ? e.name < t.name ? -1 : 1 : 0;
          })),
          dv = (0, xe.vU)({
            bookmarkCreated: {
              id: "bookmarkCreated",
              defaultMessage: "Created Bookmark",
              description: "A11Y announces when a bookmark is created"
            },
            bookmarkEdited: {
              id: "bookmarkEdited",
              defaultMessage: "Edited Bookmark",
              description: "A11Y announces when a bookmark is edited"
            },
            bookmarkDeleted: {
              id: "bookmarkDeleted",
              defaultMessage: "Deleted Bookmark",
              description: "A11Y announces when a bookmark is deleted"
            },
            cancelledEditingBookmark: {
              id: "cancelledEditingBookmark",
              defaultMessage: "Cancelled Editing Bookmark",
              description: "A11Y announces when editing of a bookmark is cancelled"
            },
            newBookmark: {
              id: "newBookmark",
              defaultMessage: "New Bookmark",
              description: "Button to create a bookmark"
            },
            removeBookmark: {
              id: "removeBookmark",
              defaultMessage: "Remove Bookmark",
              description: "Button to remove a bookmark"
            },
            noBookmarks: {
              id: "noBookmarsk",
              defaultMessage: "No Bookmarks",
              description: "When there are not bookmarks"
            },
            loadingBookmarks: {
              id: "loadingBookmarks",
              defaultMessage: "Loading Bookmarks",
              description: "When bookmarks are loading"
            },
            deleteBookmarkConfirmMessage: {
              id: "deleteBookmarkConfirmMessage",
              defaultMessage: "Are you sure you want to delete this bookmark?",
              description: 'Message displayed in the "Delete Bookmark" confirm dialog'
            },
            deleteBookmarkConfirmAccessibilityLabel: {
              id: "deleteBookmarkConfirmAccessibilityLabel",
              defaultMessage: "Confirm bookmark deletion",
              description: 'Accessibility label (title) for the "Delete Bookmark" confirm dialog'
            },
            deleteBookmarkConfirmAccessibilityDescription: {
              id: "deleteBookmarkConfirmAccessibilityDescription",
              defaultMessage: "Dialog allowing the user to confirm or cancel deleting the bookmark",
              description: 'Accessibility description for the "Delete Bookmark" confirm dialog'
            }
          });
        var pv = n(70982),
          hv = n(21693),
          fv = n(17223),
          mv = n.n(fv);
        const gv = (0, xe.XN)(e => {
          let {
            position: t,
            onCropApply: r,
            onCropCancel: o,
            isCropAreaSelected: i,
            frameWindow: a,
            intl: {
              formatMessage: s
            }
          } = e;
          return d.useEffect(() => {
            function e(e) {
              "Enter" === e.key ? i && r(!1) : "Escape" === e.key && o();
            }
            return a.document.addEventListener("keydown", e), () => {
              a.document.removeEventListener("keydown", e);
            };
          }, [i]), d.createElement("div", {
            className: h()("PSPDFKit-Annotation-Toolbar", "PSPDFKit-Document-Crop-Toolbar", ac().root, mv().container, {
              [ac().stickToBottom]: "bottom" === t
            }),
            onMouseUp: vv,
            onTouchEnd: vv,
            onPointerUp: vv
          }, d.createElement("div", {
            className: mv().buttonContainer
          }, d.createElement("div", {
            role: "button",
            className: h()(mv().cropButton, {
              [mv().cropButtonDisabled]: !i
            }),
            onClick: i ? () => r(!1) : void 0,
            title: s(ke.Z.cropCurrentPage),
            "aria-disabled": !i
          }, d.createElement(je.Z, {
            src: n(23717)
          }), " ", d.createElement("span", {
            className: mv().desktopButtonText
          }, s(ke.Z.cropCurrentPage)), d.createElement("span", {
            className: mv().mobileButtonText
          }, s(ke.Z.cropCurrent))), d.createElement("div", {
            role: "button",
            className: h()(mv().cropButton, {
              [mv().cropButtonDisabled]: !i
            }),
            onClick: i ? () => r(!0) : void 0,
            title: s(ke.Z.cropAllPages),
            "aria-disabled": !i
          }, d.createElement(je.Z, {
            src: n(41725)
          }), d.createElement("span", {
            className: mv().desktopButtonText
          }, s(ke.Z.cropAllPages)), d.createElement("span", {
            className: mv().mobileButtonText
          }, s(ke.Z.cropAll)))), d.createElement("div", {
            role: "button",
            className: `${mv().cancelButton} ${mv().cancelDesktop}`,
            onClick: () => o(),
            title: s(ke.Z.cancel)
          }, d.createElement("span", null, s(ke.Z.cancel))), d.createElement("div", {
            role: "button",
            className: `${mv().cropButton} ${mv().cancelMobile}`,
            onClick: () => o(),
            title: s(ke.Z.cancel)
          }, d.createElement(je.Z, {
            src: n(66361)
          })));
        });
        function vv(e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        }
        var yv = n(22939);
        const bv = ml.AK,
          wv = e => {
            var t, r, o, i;
            const a = (0, xe.YB)(),
              {
                formatMessage: s
              } = a,
              u = (0, l.I0)(),
              {
                frameWindow: c,
                position: p,
                viewportWidth: f,
                creationMode: m
              } = e,
              g = (0, l.v9)(Js.YG),
              {
                handleGroupExpansion: v,
                handleEntered: y,
                expandedGroup: b,
                prevActiveGroup: w,
                btnFocusRef: x
              } = (0, po.Tp)(),
              D = (0, l.v9)(Js.lK),
              C = (0, l.v9)(e => e.contentEditorSession.textBlockInteractionState.state),
              S = (0, l.v9)(e => e.contentEditorSession.dirty),
              E = null === D || C !== Js.FP.Active;
            d.useEffect(() => {
              g.faceList || g.loading || u(th.O2);
            }, [g.faceList, g.loading, u]);
            const P = [...(g.faceList || [new Js.I5({
                family: ""
              })]).map(e => ({
                label: e.family,
                value: e.family
              }))],
              k = d.useCallback(e => {
                let {
                  modification: t,
                  preventFocusShift: n = !1
                } = e;
                const [[r, o]] = Object.entries(t);
                switch (r) {
                  case "fontSize":
                    u((0, th.Mq)({
                      size: o
                    })), n || nh.dispatch("content-editing:re-focus", null);
                    break;
                  case "font":
                    u((0, th.Mq)({
                      family: o
                    })), n || nh.dispatch("content-editing:re-focus", null);
                    break;
                  case "bold":
                    u((0, th.Mq)({
                      bold: o
                    })), n || nh.dispatch("content-editing:re-focus", null);
                    break;
                  case "italic":
                    u((0, th.Mq)({
                      italic: o
                    })), n || nh.dispatch("content-editing:re-focus", null);
                }
              }, [u]),
              A = d.useCallback(() => u((0, th.u)(m ? Js.wR.Edit : Js.wR.Create)), [u, m]),
              z = d.useCallback(() => {
                u((0, th.u)(Js.wR.Delete));
              }, [u]),
              T = D ? (e => {
                if (e.detectedStyle.selectionStyleInfo) {
                  const {
                    family: t,
                    bold: n,
                    italic: r,
                    color: o,
                    size: i
                  } = e.detectedStyle.selectionStyleInfo;
                  return {
                    family: t,
                    bold: n,
                    italic: r,
                    color: o ? _.Il.fromHex(o) : null,
                    size: i
                  };
                }
                const {
                    family: t,
                    variant: {
                      bold: n,
                      italic: r
                    }
                  } = e.modificationsCharacterStyle.fontRef.faceRef,
                  {
                    color: o,
                    fontRef: {
                      size: i
                    }
                  } = e.modificationsCharacterStyle;
                return {
                  family: t,
                  bold: n,
                  italic: r,
                  color: _.Il.fromHex(o),
                  size: i
                };
              })(D) : null,
              O = null !== (t = null == T ? void 0 : T.family) && void 0 !== t ? t : void 0,
              I = null !== (r = null == T ? void 0 : T.size) && void 0 !== r ? r : void 0,
              F = null == T ? void 0 : T.bold,
              M = null == T ? void 0 : T.italic;
            let R = null;
            if (null != (null == T ? void 0 : T.color)) {
              var j;
              const e = T.color;
              R = null !== (j = it.Options.COLOR_PRESETS.find(t => {
                var n;
                return null === (n = t.color) || void 0 === n ? void 0 : n.equals(e);
              })) && void 0 !== j ? j : {
                color: e,
                localization: ke.Z.color
              };
            }
            const B = Boolean((null == D ? void 0 : D.detectedStyle.selectionStyleInfo) && null == R),
              N = {
                "text-color": {
                  node: d.createElement(yv.Z, {
                    onChange: e => {
                      var t;
                      e && u((0, th.Mq)({
                        color: null === (t = e.color) || void 0 === t ? void 0 : t.toHex()
                      }));
                      nh.dispatch("content-editing:re-focus", null);
                    },
                    styles: Qc(),
                    value: null !== (o = R) && void 0 !== o ? o : B ? null : null !== (i = it.Options.COLOR_PRESETS.find(e => e.color === _.Il.BLACK)) && void 0 !== i ? i : null,
                    caretDirection: "down",
                    className: "PSPDFKit-Content-Editing-Toolbar-Font-Color",
                    menuClassName: "PSPDFKit-Content-Editing-Toolbar-Font-Color-Menu",
                    removeTransparent: !0,
                    frameWindow: c,
                    colors: it.Options.COLOR_PRESETS,
                    innerRef: (0, gc.CN)("text-color", b) ? x : void 0,
                    unavailableItemFallback: B ? {
                      type: "label",
                      label: ""
                    } : {
                      type: "swatch"
                    },
                    disabled: E,
                    accessibilityLabel: s(ke.Z.color)
                  }),
                  title: s(ke.Z.color)
                },
                font: {
                  node: d.createElement($c, {
                    onChange: k,
                    caretDirection: "down",
                    frameWindow: c,
                    intl: a,
                    styles: Qc(),
                    fontSizes: bv,
                    fontFamilyItems: P,
                    showAlignmentOptions: !1,
                    showFontStyleOptions: !0,
                    currentFontFamily: O,
                    currentFontSize: I,
                    isBold: F,
                    isItalic: M,
                    fontFamilyClasses: "PSPDFKit-Content-Editing-Toolbar-Font-Family",
                    fontFamilyMenuClasses: "PSPDFKit-Content-Editing-Toolbar-Font-Family-Menu",
                    fontSizeClasses: "PSPDFKit-Content-Editing-Toolbar-Font-Size",
                    fontSizeMenuClasses: "PSPDFKit-Content-Editing-Toolbar-Font-Size-Menu",
                    horizontalAlignClasses: "PSPDFKit-Content-Editing-Toolbar-Alignment",
                    verticalAlignClasses: "PSPDFKit-Content-Editing-Toolbar-Vertical-Alignment",
                    disabled: E,
                    ref: (0, gc.CN)("font", b) ? x : void 0
                  }),
                  title: s(ke.Z.font)
                }
              };
            return d.createElement("div", {
              className: h()("PSPDFKit-Content-Editing-Toolbar", Qc().root, {
                [Qc().stickToBottom]: "bottom" === p
              })
            }, d.createElement("div", {
              className: Qc().content
            }, b ? d.createElement("div", {
              className: Qc().right
            }, d.createElement(cc.B, {
              position: p,
              onClose: () => v(null),
              isPrimary: !1,
              onEntered: y,
              intl: a,
              className: Qc().expanded
            }, b ? N[b].node : void 0)) : d.createElement("form", {
              className: Qc().form,
              onSubmit: jr.PF
            }, d.createElement("div", {
              style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }
            }, d.createElement("div", {
              className: h()(Qc().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Add-Text")
            }, d.createElement(Ju.Z, {
              type: "add-text-box",
              icon: n(33150),
              title: s(xv.addTextBox),
              className: h()("PSPDFKit-Content-Editing-Toolbar-Add-Text-Box", Qc().iconButton, {
                [Qc().iconButtonActive]: m
              }),
              onPress: A,
              selected: m
            })), d.createElement("div", {
              className: h()(Qc().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-TextColor")
            }, d.createElement(Ju.Z, {
              type: "text-color",
              title: N["text-color"].title,
              className: Qc().button,
              onPress: () => v("text-color"),
              disabled: Boolean(b) || E,
              presentational: f > Ne.GI,
              ref: (0, gc.Kt)("text-color", b, w) ? x : void 0
            }), N["text-color"].node), d.createElement("div", {
              className: h()(Qc().formGroup, "PSPDFKit-Toolbox PSPDFKit-Toolbox-Font")
            }, d.createElement(Ju.Z, {
              type: "font",
              title: N.font.title,
              className: Qc().button,
              onPress: () => v("font"),
              disabled: E,
              presentational: f > Ne.GI,
              ref: (0, gc.Kt)("font", b, w) ? x : void 0
            }), N.font.node)), d.createElement("div", {
              className: "PSPDFKit-Toolbar-Spacer",
              style: {
                display: "flex",
                flex: 1
              }
            }), f >= Ne.GI ? d.createElement("div", {
              className: Qc().buttonContainer
            }, d.createElement(Ju.Z, {
              type: "delete",
              title: a.formatMessage(ke.Z.delete),
              className: h()("PSPDFKit-Content-Editor-Toolbar-Button-Delete", Qc().iconButton),
              onPress: z,
              disabled: !D
            }), d.createElement("button", {
              className: Qc().contentEditorButton,
              type: "button",
              onClick: () => u(th.u8),
              title: a.formatMessage(ke.Z.cancel)
            }, d.createElement("span", null, a.formatMessage(ke.Z.cancel))), d.createElement("button", {
              className: h()(Qc().contentEditorButton, Qc().saveButton, {
                [Qc().disabledButton]: !S
              }),
              type: "button",
              onClick: () => u(th.Ij),
              title: a.formatMessage(ke.Z.saveAndClose),
              disabled: !S
            }, d.createElement("span", null, a.formatMessage(ke.Z.saveAndClose)))) : d.createElement(d.Fragment, null, d.createElement(Ju.Z, {
              type: "delete",
              title: a.formatMessage(ke.Z.delete),
              className: h()("PSPDFKit-Content-Editor-Toolbar-Button-Delete", Qc().iconButton),
              onPress: z,
              disabled: !D
            }), d.createElement(Ju.Z, {
              type: "close",
              title: a.formatMessage(ke.Z.close),
              className: Qc().button,
              onPress: () => {
                u(S ? (0, th.Yg)(!0) : th.u8);
              }
            })))));
          },
          xv = (0, xe.vU)({
            addTextBox: {
              id: "addTextBox",
              defaultMessage: "Add Text Box",
              description: "Label for the add text box button"
            }
          });
        var Dv,
          Cv,
          Sv,
          Ev = n(52163),
          _v = n(2058),
          Pv = n(3962),
          kv = n(79112),
          Av = n(92294),
          zv = n.n(Av);
        function Tv(e) {
          e.stopPropagation(), e.nativeEvent.stopImmediatePropagation();
        }
        const Ov = {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          Iv = (0, De.b1)(),
          Fv = d.memo(function (e) {
            let {
              position: t
            } = e;
            const {
                formatMessage: n
              } = (0, xe.YB)(),
              [r, o] = (0, po.$)(),
              [i, a] = (0, po.nG)(),
              s = (0, po.R9)(() => {
                (0, c.unstable_batchedUpdates)(() => {
                  a([]), p === kv.Q.result && f(kv.Q.documentA);
                });
              }),
              [l, u] = (0, po.jw)(),
              p = (0, Ev.SH)(l),
              f = (0, po.R9)(e => {
                e !== p && u(e || kv.Q.result);
              }),
              m = () => {
                (0, c.unstable_batchedUpdates)(() => {
                  a([]), o(!1), f(kv.Q.documentA);
                });
              },
              [, g] = (0, po.dX)(),
              v = (0, po.R9)(() => {
                s(), f(kv.Q.documentA), g(!1);
              });
            return d.createElement("div", {
              className: h()(zv().root, {
                "PSPDFKit-DocumentComparison-Toolbar": !0,
                [zv().stickToBottom]: "bottom" === t
              }),
              onMouseUp: Tv,
              onTouchEnd: Tv,
              onPointerUp: Tv
            }, d.createElement("div", {
              className: zv().content
            }, d.createElement("div", {
              className: zv().left
            }, d.createElement("form", {
              className: zv().form,
              onSubmit: jr.PF
            }, d.createElement("div", {
              className: zv().tabsContainer
            }, d.createElement("div", {
              className: h()(zv().documentTab, {
                [zv().documentTabActive]: p === kv.Q.documentA,
                [zv().autoCompareTab]: r,
                [zv().mobileTab]: Iv
              }),
              onPointerUp: () => f(kv.Q.documentA),
              onTouchEnd: () => f(kv.Q.documentA)
            }, d.createElement("span", {
              className: h()(zv().documentText, {
                [zv().mobileText]: !!Iv,
                [zv().documentTabActiveText]: p === kv.Q.documentA
              })
            }, n(Iv ? Pv.messages.Comparison_documentOldTouch : Pv.messages.Comparison_documentOld)), !r && i.length < 3 && d.createElement(Mv, {
              referencePoints: i,
              startIndex: 0,
              styles: zv(),
              touchDevice: Iv
            }), !r && i.length >= 3 && d.createElement("span", {
              className: h()([zv().toolbarReferencePoints, zv().toolbarReferencePointsSet])
            }, d.createElement("div", {
              className: zv().toolbarReferencePoint
            }, d.createElement("svg", (0, ce.Z)({}, Ov, {
              className: zv().documentCheckMark
            }), Dv || (Dv = d.createElement("circle", {
              cx: "10",
              cy: "10",
              r: "10"
            })), jv)))), d.createElement("div", {
              className: h()(zv().documentTab, {
                [zv().documentTabActive]: p === kv.Q.documentB,
                [zv().autoCompareTab]: r,
                [zv().mobileTab]: Iv
              }),
              onPointerUp: () => f(kv.Q.documentB),
              onTouchEnd: () => f(kv.Q.documentB)
            }, d.createElement("span", {
              className: h()(zv().documentText, {
                [zv().mobileText]: !!Iv,
                [zv().documentTabActiveText]: p === kv.Q.documentB
              })
            }, n(Iv ? Pv.messages.Comparison_documentNewTouch : Pv.messages.Comparison_documentNew)), !r && i.length < 6 && d.createElement(Mv, {
              referencePoints: i,
              startIndex: 3,
              styles: zv(),
              touchDevice: Iv
            }), !r && 6 === i.length && d.createElement("span", {
              className: h()([zv().toolbarReferencePoints, zv().toolbarReferencePointsSet])
            }, d.createElement("div", {
              className: zv().toolbarReferencePoint
            }, d.createElement("svg", (0, ce.Z)({}, Ov, {
              className: zv().documentCheckMark
            }), Cv || (Cv = d.createElement("circle", {
              cx: "10",
              cy: "10",
              r: "10"
            })), jv)))), (r || 6 === i.length) && d.createElement("div", {
              className: h()(zv().documentTab, zv().resultTab, {
                [zv().documentTabActive]: p === kv.Q.result,
                [zv().autoCompareTab]: r
              }),
              onPointerUp: () => f(null),
              onTouchEnd: () => f(null)
            }, d.createElement("span", {
              className: h()(zv().documentText, {
                [zv().mobileText]: !!Iv,
                [zv().documentTabActiveText]: p === kv.Q.result
              })
            }, n(Pv.messages.Comparison_result)))), d.createElement("div", {
              className: zv().controlButtonContainer
            }, !r && i.length > 0 && d.createElement("div", {
              className: h()(zv().buttonReset, zv().buttonResetActive, {
                [zv().mobileButton]: Iv
              }),
              onPointerUp: v,
              onTouchEnd: v
            }, n(Pv.messages.Comparison_resetButton)), r && d.createElement("div", {
              className: h()({
                [zv().buttonAlignDocuments]: !0,
                [zv().mobileButton]: Iv
              }),
              onPointerUp: m,
              onTouchEnd: m
            }, n(Iv ? Pv.messages.Comparison_alignButtonTouch : Pv.messages.Comparison_alignButton)))))));
          });
        const Mv = e => {
            const {
                styles: t,
                referencePoints: n,
                startIndex: r,
                touchDevice: o
              } = e,
              i = n.slice(r, r + 3),
              a = Array.from({
                length: 3 - i.length
              });
            return d.createElement("span", {
              className: h()(t.toolbarReferencePoints, {
                [t.toolbarReferencePointMobile]: !!o,
                [t.second]: 3 === r
              })
            }, i.concat(a).map((e, o, i) => {
              const a = e ? "set" : 0 === o && n.length === r || i[o - 1] ? "current" : "empty";
              return d.createElement("div", {
                className: h()(t.referencePointParent, "PSPDFKit-DocumentComparison-ReferencePoint-State", `PSPDFKit-DocumentComparison-ReferencePoint-State-${(0, gn.kC)(a)}`),
                key: `point_${o + r}`
              }, o > 0 ? d.createElement("div", {
                className: t.separator
              }) : null, d.createElement("div", {
                className: t.toolbarReferencePoint
              }, d.createElement("svg", (0, ce.Z)({}, Ov, {
                className: t[Rv[a]]
              }), Sv || (Sv = d.createElement("circle", {
                cx: "10",
                cy: "10",
                r: "10"
              })), e ? jv : d.createElement(Bv, null, o + 1))));
            }));
          },
          Rv = {
            set: "checkMark",
            current: "referencePointSet",
            empty: "referencePoint"
          },
          jv = d.createElement("path", {
            d: "M5.45508 10.1125L8.53758 12.94L14.5451 6.25",
            strokeWidth: "1.875",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
          }),
          Bv = e => {
            let {
              children: t
            } = e;
            return d.createElement("text", {
              x: "10",
              y: "11",
              textAnchor: "middle",
              dominantBaseline: "middle",
              dy: ""
            }, t);
          };
        var Nv = n(72313),
          Lv = n.n(Nv),
          Vv = n(53328),
          Kv = n.n(Vv),
          qv = n(24987);
        const Hv = [{
          interactionMode: B.A.BUTTON_WIDGET,
          icon: "form-button",
          title: "Create Button Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-ButtonWidget"
        }, {
          interactionMode: B.A.TEXT_WIDGET,
          icon: "form-text",
          title: "Create Text Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-TextWidget"
        }, {
          interactionMode: B.A.RADIO_BUTTON_WIDGET,
          icon: "form-radio",
          title: "Create Radio Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-RadioWidget"
        }, {
          interactionMode: B.A.CHECKBOX_WIDGET,
          icon: "form-checkbox",
          title: "Create Checkbox Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-CheckboxWidget"
        }, {
          interactionMode: B.A.COMBO_BOX_WIDGET,
          icon: "form-combobox",
          title: "Create Combobox widget",
          className: "PSPDFKit-Form-Creator-Toolbar-ComboboxWidget"
        }, {
          interactionMode: B.A.LIST_BOX_WIDGET,
          icon: "form-listbox",
          title: "Create List Box Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-ListBoxWidget"
        }, {
          interactionMode: B.A.SIGNATURE_WIDGET,
          icon: "form-signature",
          title: "Create Signature Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-SignatureWidget"
        }, {
          interactionMode: B.A.DATE_WIDGET,
          icon: "form-date",
          title: "Create Date Widget",
          className: "PSPDFKit-Form-Creator-Toolbar-DateWidget"
        }];
        var Uv = n(60790);
        const Zv = e => {
          let {
            position: t,
            dispatch: n,
            interactionMode: r,
            frameWindow: o,
            modalClosurePreventionError: i,
            selectedAnnotation: a
          } = e;
          return d.useEffect(() => {
            function e(e) {
              "Escape" !== e.key || i && (null == i ? void 0 : i.error) === Uv.x.FORM_DESIGNER_ERROR || a || n((0, Kt.XX)());
            }
            return o.document.addEventListener("keydown", e), () => {
              o.document.removeEventListener("keydown", e);
            };
          }, [n, i, a]), d.createElement("div", {
            className: h()("PSPDFKit-Form-Creator-Toolbar", ac().root, Fd().formDesignerContainer, {
              [ac().stickToBottom]: "bottom" === t
            }),
            onMouseUp: vv,
            onTouchEnd: vv,
            onPointerUp: vv
          }, d.createElement("div", null, Hv.map(e => d.createElement(Md.Z, {
            key: e.interactionMode,
            type: e.icon,
            title: e.title,
            className: h()(Fd().formDesignerButton, {
              [Fd().formDesignerButtonActive]: r === e.interactionMode
            }, e.className),
            onPress: () => {
              r === e.interactionMode ? n((0, er.el)()) : (n((0, er.h4)()), n((0, Kt.UF)(e.interactionMode)));
            },
            selected: r === e.interactionMode
          }))), d.createElement("div", {
            className: Fd().spacer
          }));
        };
        var $v = n(11236),
          Gv = n(62102),
          Wv = n(62477),
          Yv = n(30549),
          Xv = n.n(Yv);
        function Qv(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Jv(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Qv(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Qv(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function ey(e) {
          let {
            btnComponentProps: t,
            selectedItem: n
          } = e;
          return d.createElement(we.Z, (0, ce.Z)({
            is: "div"
          }, t, {
            className: h()("PSPDFKit-Input-Dropdown-Button ", Ou().selectBox, Xv().selectBox),
            style: {
              minWidth: "100px"
            }
          }), d.createElement("span", null, null == n ? void 0 : n.label), d.createElement("div", null, (0, Ae.Z)({
            type: "caret-down",
            style: {
              width: 12,
              height: 12,
              flexBasis: 12
            },
            className: h()(Ou().dropdownIcon)
          })));
        }
        function ty(e) {
          let {
            item: t,
            state: n,
            itemComponentProps: r
          } = e;
          return d.createElement(we.Z, (0, ce.Z)({
            is: "div",
            className: h()(Ou().item, {
              [Ou().isSelected]: (null == n ? void 0 : n.includes("selected")) || (null == n ? void 0 : n.includes("focused"))
            }),
            name: null == t ? void 0 : t.value
          }, r), null == t ? void 0 : t.label);
        }
        function ny(e, t) {
          return e.horizontalAlign ? e.horizontalAlign : t instanceof _.R0 ? "center" : "left";
        }
        function ry(e, t) {
          return e.verticalAlign ? e.verticalAlign : t instanceof _.R0 ? "center" : t instanceof _.$o && t.multiLine ? "top" : "center";
        }
        const oy = (0, xe.vU)({
            textStyle: {
              id: "textStyle",
              defaultMessage: "Text style",
              description: "Form designer popover text section title"
            },
            fontSize: {
              id: "fontSize",
              defaultMessage: "Font size",
              description: "Form designer popover text section font size label"
            },
            fontColor: {
              id: "fontColor",
              defaultMessage: "Font color",
              description: "Form designer popover text section font color label"
            }
          }),
          iy = function (e) {
            var t, r, o, a, s;
            let {
              annotation: l,
              updateAnnotation: u,
              intl: c,
              frameWindow: p,
              formField: h,
              customFontsReadableNames: f
            } = e;
            const m = vs.vt.toArray().map(e => ({
                label: e,
                value: e
              })),
              g = m.concat(f.toArray().map(e => ({
                label: e,
                value: e
              })).filter(e => !m.some(t => t.value === e.value)));
            if (l.font && !vs.vt.has(l.font || "") && !f.some(e => e === l.font) && "" !== l.font.trim()) {
              const e = c.formatMessage(ke.Z.fontFamilyUnsupported, {
                arg0: l.font
              });
              g.push({
                label: e,
                value: e,
                disabled: !0
              });
            }
            const v = ["auto", 4, 6, 8, 10, 12, 14, 18, 24, 36, 48, 64, 72, 96, 144, 192, 200].map(e => ({
                value: e,
                label: e.toString()
              })),
              y = d.useCallback(e => u({
                horizontalAlign: e
              }), [u]),
              b = d.useCallback(e => u({
                verticalAlign: e
              }), [u]);
            return d.createElement(Wv.U, {
              title: c.formatMessage(oy.textStyle)
            }, d.createElement("div", {
              className: Xv().item
            }, d.createElement(je.Z, {
              src: n(81741),
              className: Xv().itemIcon,
              role: "presentation"
            }), d.createElement("div", {
              className: Xv().itemLabel
            }, c.formatMessage(ke.Z.font)), d.createElement("div", {
              className: Xv().nativeDropdown
            }, d.createElement("select", {
              "aria-label": c.formatMessage(ke.Z.font),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: l.font || "",
              onChange: e => {
                void 0 !== e.target.value && u({
                  font: e.target.value
                });
              }
            }, g.map(e => d.createElement("option", {
              key: e.value,
              value: e.value,
              disabled: e.disabled
            }, e.label)))), d.createElement(_u.Z, {
              items: g,
              value: {
                label: null !== (t = l.font) && void 0 !== t ? t : g[0].label,
                value: null !== (r = l.font) && void 0 !== r ? r : g[0].value
              },
              accessibilityLabel: c.formatMessage(ke.Z.font),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: Xv().dropdownGroupComponent,
              menuClassName: Xv().dropdownGroupMenu,
              ButtonComponent: ey,
              ItemComponent: ty,
              onSelect: (e, t) => {
                void 0 !== t.value && u({
                  font: t.value
                });
              },
              frameWindow: p
            })), d.createElement("div", {
              className: Xv().item
            }, d.createElement(je.Z, {
              src: n(14379),
              className: Xv().itemIcon,
              role: "presentation"
            }), d.createElement("div", {
              className: Xv().itemLabel
            }, c.formatMessage(oy.fontSize)), d.createElement("div", {
              className: Xv().nativeDropdown
            }, d.createElement("select", {
              "aria-label": c.formatMessage(oy.fontSize),
              className: "PSPDFKit-Input-Dropdown-Select",
              value: l.fontSize || "",
              onChange: e => {
                u({
                  fontSize: "auto" === e.target.value ? "auto" : parseFloat(e.target.value)
                });
              }
            }, v.map(e => d.createElement("option", {
              key: e.value,
              value: e.value,
              disabled: e.disabled
            }, e.label)))), d.createElement(_u.Z, {
              items: v,
              value: (null !== (o = v.find(e => e.value === Math.round(l.fontSize || 0))) && void 0 !== o ? o : null != l.fontSize) ? {
                value: l.fontSize,
                label: null !== (a = null === (s = l.fontSize) || void 0 === s ? void 0 : s.toString()) && void 0 !== a ? a : ""
              } : null,
              accessibilityLabel: c.formatMessage(oy.fontSize),
              discreteDropdown: !1,
              isActive: !1,
              caretDirection: "down",
              className: Xv().dropdownGroupComponent,
              menuClassName: Xv().dropdownGroupMenu,
              ButtonComponent: ey,
              ItemComponent: ty,
              onSelect: (e, t) => {
                null == t.value || "auto" !== t.value && isNaN(t.value) || u({
                  fontSize: t.value
                });
              },
              frameWindow: p
            })), d.createElement("div", {
              className: Xv().item
            }, d.createElement(je.Z, {
              src: n(92742),
              className: Xv().itemIcon,
              role: "presentation"
            }), d.createElement("div", {
              className: Xv().itemLabel
            }, c.formatMessage(ke.Z.color)), d.createElement(ec.Z, {
              record: l,
              onChange: u,
              styles: Jv(Jv({}, ac()), {}, {
                colorSvg: Xv().colorSvg,
                colorItem: Xv().colorItem,
                dropdownMenu: Xv().colorDropdownMenu,
                controlWrapper: Jv(Jv({}, ac().controlWrapper), {}, {
                  width: "auto"
                })
              }),
              accessibilityLabel: c.formatMessage(ke.Z.fillColor),
              caretDirection: "down",
              colorProperty: "fontColor",
              frameWindow: p,
              className: Xv().colorDropdown
            })), d.createElement("div", {
              className: Xv().item
            }, d.createElement(je.Z, {
              src: n(9984),
              className: Xv().itemIcon,
              role: "presentation"
            }), d.createElement("div", {
              className: Xv().itemLabel
            }, c.formatMessage(ke.Z.horizontalAlignment)), d.createElement(i.Ee, {
              inputName: "horizontalAlign",
              label: c.formatMessage(ke.Z.horizontalAlignment),
              selectedOption: ny(l, h),
              labelClassNamePrefix: "PSPDFKit-Form-Creator-Editor-Horizontal-Alignment",
              options: ["left", "center", "right"].map(e => ({
                value: e,
                label: c.formatMessage(ke.Z[`alignment${(0, gn.kC)(e)}`]),
                iconPath: n(58758)(`./text-align-horizontal-${e}.svg`)
              })),
              onChange: y
            })), !(h instanceof _.Vi) && d.createElement("div", {
              className: Xv().item
            }, d.createElement(je.Z, {
              src: n(68715),
              className: Xv().itemIcon,
              role: "presentation"
            }), d.createElement("div", {
              className: Xv().itemLabel
            }, c.formatMessage(ke.Z.verticalAlignment)), d.createElement(i.Ee, {
              inputName: "verticalAlign",
              label: c.formatMessage(ke.Z.verticalAlignment),
              selectedOption: ry(l, h),
              labelClassNamePrefix: "PSPDFKit-Form-Creator-Editor-Vertical-Alignment",
              options: ["top", "center", "bottom"].map(e => ({
                value: e,
                label: c.formatMessage(ke.Z["center" === e ? "alignmentCenter" : e]),
                iconPath: n(29712)(`./text-align-vertical-${e}.svg`)
              })),
              onChange: b
            })));
          };
        var ay = n(8643),
          sy = n.n(ay);
        const ly = ["label", "errorMessage", "inputClassName", "className", "disablePadding"];
        function uy(e) {
          let {
              label: t,
              errorMessage: n,
              inputClassName: r,
              className: o,
              disablePadding: a
            } = e,
            s = (0, ne.Z)(e, ly);
          return d.createElement("div", {
            className: h()(!a && sy().wrapper, o)
          }, d.createElement("label", {
            className: h()(sy().label, "PSPDFKit-Form-Creator-Editor-Text-Input-Label")
          }, t, s.required && "*", d.createElement(i.oi, (0, ce.Z)({}, s, {
            className: h()(sy().input, {
              [sy().inputError]: !!n
            }, r)
          }))), n && d.createElement("span", {
            className: sy().errorLabel
          }, n));
        }
        var cy = n(46945);
        const dy = (0, xe.vU)({
            advanced: {
              id: "advanced",
              defaultMessage: "Advanced",
              description: "Form designer popover advanced section title"
            },
            creatorName: {
              id: "creatorName",
              defaultMessage: "Creator Name",
              description: "Form designer popover advanced section creator name label"
            },
            note: {
              id: "note",
              defaultMessage: "Note",
              description: "Form designer popover advanced section note label"
            },
            customData: {
              id: "customData",
              defaultMessage: "Custom data",
              description: "Form designer popover advanced section custom data label"
            },
            required: {
              id: "required",
              defaultMessage: "Required",
              description: "Form designer popover advanced section required label"
            },
            readOnly: {
              id: "readOnly",
              defaultMessage: "Read Only",
              description: "Form designer popover advanced section read only label"
            },
            multiSelect: {
              id: "multiSelect",
              defaultMessage: "Multi Select",
              description: "Form designer popover advanced section multi select label"
            },
            createdAt: {
              id: "createdAt",
              defaultMessage: "Created at",
              description: "Form designer popover advanced section created at label"
            },
            updatedAt: {
              id: "updatedAt",
              defaultMessage: "Updated at",
              description: "Form designer popover advanced section updated at label"
            },
            customDataErrorMessage: {
              id: "customDataErrorMessage",
              defaultMessage: "Must be a plain JSON-serializable object",
              description: "Form designer popover advanced section custom data error"
            },
            multiLine: {
              id: "multiLine",
              defaultMessage: "Multi Line",
              description: "Form designer popover multiline input label"
            }
          }),
          py = function (e) {
            let {
              intl: t,
              annotation: n,
              updateAnnotation: r,
              formField: o,
              updateFormField: i,
              locale: a,
              onCustomDataError: s
            } = e;
            const [l, u] = d.useState({
                value: JSON.stringify(n.customData),
                error: ""
              }),
              c = d.useRef(l),
              p = d.useCallback(e => r({
                creatorName: e.target.value
              }), [r]),
              h = d.useCallback(e => r({
                note: e.target.value
              }), [r]),
              f = d.useCallback(e => {
                let n = "";
                try {
                  JSON.parse(e.target.value), s(!1);
                } catch (e) {
                  n = t.formatMessage(dy.customDataErrorMessage), s(!0);
                }
                u({
                  value: e.target.value,
                  error: n
                });
              }, [t, s]),
              m = d.useCallback(() => {
                if (!l.error && l.value !== c.current.value) try {
                  const e = JSON.parse(l.value);
                  r({
                    customData: e
                  });
                } catch (e) {}
              }, [r, l]);
            (0, po.L8)(() => {
              if (!l.error && l.value !== c.current.value) try {
                const e = JSON.parse(l.value);
                r({
                  customData: e
                });
              } catch (e) {}
            }, [r, l]);
            const g = d.useCallback(e => i({
                required: e
              }), [i]),
              v = d.useCallback(e => i({
                readOnly: e
              }), [i]),
              y = d.useCallback(e => i({
                multiSelect: e
              }), [i]),
              b = d.useCallback(e => i({
                multiLine: e
              }), [i]);
            return d.createElement("div", {
              className: "PSPDFKit-Form-Creator-Editor-Advanved-Section"
            }, d.createElement(Wv.U, {
              title: t.formatMessage(dy.advanced)
            }, d.createElement(uy, {
              label: t.formatMessage(dy.creatorName),
              value: n.creatorName || "",
              onChange: p
            }), d.createElement(uy, {
              label: t.formatMessage(dy.note),
              value: n.note || "",
              onChange: h
            }), d.createElement(uy, {
              label: t.formatMessage(dy.customData),
              value: l.value,
              onChange: f,
              onBlur: m,
              errorMessage: l.error,
              className: Xv().lastInputField
            }), d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.required)), d.createElement(cy.n, {
              value: !(null == o || !o.required),
              onUpdate: g,
              accessibilityLabel: t.formatMessage(dy.required)
            })), d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.readOnly)), d.createElement(cy.n, {
              value: !(null == o || !o.readOnly),
              onUpdate: v,
              accessibilityLabel: t.formatMessage(dy.readOnly)
            })), o instanceof _.Dz && d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.multiSelect)), d.createElement(cy.n, {
              value: !(null == o || !o.multiSelect),
              onUpdate: y,
              accessibilityLabel: t.formatMessage(dy.multiSelect)
            })), o instanceof _.$o && d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.multiLine)), d.createElement(cy.n, {
              value: !(null == o || !o.multiLine),
              onUpdate: b,
              accessibilityLabel: t.formatMessage(dy.multiLine)
            })), d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, "ID"), d.createElement("div", {
              className: Xv().advancedItemValue
            }, n.id)), d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.createdAt)), d.createElement("div", {
              className: Xv().advancedItemValue
            }, n.createdAt.toLocaleDateString(a))), d.createElement("div", {
              className: Xv().advancedItem
            }, d.createElement("div", {
              className: Xv().advancedItemLabel
            }, t.formatMessage(dy.updatedAt)), d.createElement("div", {
              className: Xv().advancedItemValue
            }, n.updatedAt.toLocaleDateString(a)))));
          };
        var hy = n(2245),
          fy = n(36623),
          my = n(17777),
          gy = n.n(my);
        const vy = (e, t) => ({
            x: e.x - t.x,
            y: e.y - t.y
          }),
          yy = (e, t) => {
            const n = e.getClientOffset();
            if (null === n) return null;
            if (!t.current || !t.current.getBoundingClientRect) return vy(n, (e => {
              const t = e.getInitialClientOffset(),
                n = e.getInitialSourceClientOffset();
              return null === t || null === n ? {
                x: 0,
                y: 0
              } : vy(t, n);
            })(e));
            const r = t.current.getBoundingClientRect(),
              o = {
                x: r.width / 2,
                y: r.height / 2
              };
            return vy(n, o);
          },
          by = e => {
            const t = "translate(".concat(e.x.toFixed(1), "px, ").concat(e.y.toFixed(1), "px)");
            return {
              pointerEvents: "none",
              position: "fixed",
              top: 0,
              left: 0,
              transform: t,
              WebkitTransform: t
            };
          };
        function wy(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function xy(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? wy(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wy(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Dy = e => {
          let {
            id: t,
            index: r,
            moveCard: o,
            option: i,
            onDelete: a
          } = e;
          const s = (0, d.useRef)(null),
            l = (0, d.useRef)(null),
            [{
              handlerId: u
            }, c] = (0, hy.LW)({
              accept: "CARD",
              collect: e => ({
                handlerId: e.getHandlerId()
              }),
              hover(e, t) {
                var n;
                if (!l.current) return;
                const i = e.index,
                  a = r;
                if (i === a) return;
                const s = null === (n = l.current) || void 0 === n ? void 0 : n.getBoundingClientRect(),
                  u = (s.bottom - s.top) / 2,
                  c = t.getClientOffset().y - s.top;
                i < a && c < u || i > a && c > u || (o(i, a), e.index = a);
              }
            }),
            {
              display: p,
              style: f
            } = (() => {
              const e = (0, d.useRef)(null),
                t = (0, hy.f$)(t => ({
                  currentOffset: yy(t, e),
                  isDragging: t.isDragging(),
                  itemType: t.getItemType(),
                  item: t.getItem(),
                  monitor: t
                }));
              return t.isDragging && null !== t.currentOffset ? {
                display: !0,
                itemType: t.itemType,
                item: t.item,
                style: by(t.currentOffset),
                monitor: t.monitor,
                ref: e
              } : {
                display: !1
              };
            })(),
            [{
              isDragging: m,
              id: g
            }, v] = (0, hy.c0)({
              type: "CARD",
              item: () => ({
                id: t,
                index: r
              }),
              collect: e => {
                var t;
                return {
                  isDragging: e.isDragging(),
                  id: null === (t = e.getItem()) || void 0 === t ? void 0 : t.id
                };
              }
            }),
            y = m ? .5 : 1;
          v(c(s));
          const b = e => d.createElement("div", {
            style: e ? xy(xy({}, f), {
              width: 332
            }) : {
              opacity: y
            },
            className: h()(gy().option, {
              [gy().preview]: e
            }),
            ref: e ? void 0 : l
          }, d.createElement("button", (0, ce.Z)({
            type: "button",
            className: gy().hamburger
          }, e ? void 0 : {
            ref: s,
            "data-handler-id": u
          }), d.createElement(je.Z, {
            src: n(60967),
            role: "presentation"
          })), d.createElement("div", {
            className: gy().optionContent
          }, i.label), d.createElement("button", {
            className: h()(gy().button, gy().deleteButton),
            type: "button",
            onClick: () => a(r)
          }, d.createElement(je.Z, {
            src: n(2256),
            className: h()(gy().icon, gy().deleteIcon),
            role: "presentation"
          })));
          return d.createElement(d.Fragment, null, b(!1), p && g === t && b(!0));
        };
        const Cy = (0, xe.vU)({
            options: {
              id: "options",
              defaultMessage: "Options",
              description: "Options control label"
            },
            enterDescriptionHere: {
              id: "enterDescriptionHere",
              defaultMessage: "Enter description here",
              description: "New option input placeholder"
            },
            addOption: {
              id: "addOption",
              defaultMessage: "Add option",
              description: "New option button text"
            },
            emptyInput: {
              id: "emptyInput",
              defaultMessage: "Please fill in this field",
              description: "New option empty input label"
            }
          }),
          Sy = (0, xe.XN)(function (e) {
            let {
              intl: t,
              options: n,
              onChange: r,
              ownerDocument: o
            } = e;
            const {
                formatMessage: i
              } = t,
              [a, s] = d.useState(!0);
            return d.createElement(hy.WG, {
              backend: fy.TouchBackend,
              options: {
                enableMouseEvents: !0,
                delayTouchStart: 500,
                touchSlop: 10,
                ignoreContextMenu: !0,
                ownerDocument: o
              }
            }, d.createElement("form", {
              className: gy().wrapper,
              onSubmit: e => {
                e.preventDefault();
                const t = e.target,
                  {
                    value: o
                  } = t.newOption;
                o ? (t.reset(), r(n.push(new _.mv({
                  value: o,
                  label: o
                })))) : s(!1);
              }
            }, d.createElement("div", {
              className: gy().title
            }, i(Cy.options)), d.createElement("div", null, n.map((e, t) => d.createElement(Dy, {
              key: e.value,
              index: t,
              moveCard: (e, t) => {
                const o = n.get(t);
                (0, u.kG)(o, "Item not found"), r(n.delete(t).insert(e, o));
              },
              option: e,
              id: e.value,
              onDelete: e => r(n.delete(e))
            })), d.createElement("div", {
              className: h()(gy().option, gy().addOptionInputWrapper, {
                [gy().addOptionInputWrapperInvalid]: !a
              })
            }, d.createElement("input", {
              autoFocus: !0,
              className: h()(gy().optionContent, gy().addOptionInput),
              name: "newOption",
              type: "text",
              placeholder: i(Cy.enterDescriptionHere),
              onBlur: () => s(!0),
              onChange: e => {
                !a && e.target.value.trim() && s(!0);
              }
            }))), !a && d.createElement("div", {
              className: gy().invalidOptionInput
            }, t.formatMessage(Cy.emptyInput)), d.createElement("button", {
              className: h()(gy().button, gy().addOptionButton),
              type: "submit"
            }, i(Cy.addOption))));
          });
        var Ey, _y, Py, ky, Ay;
        function zy(e, t) {
          return t ? ke.Z.dateField : e instanceof _.R0 ? ke.Z.button : e instanceof _.$o ? ke.Z.textField : e instanceof _.XQ ? ke.Z.radioField : e instanceof _.rF ? ke.Z.checkboxField : e instanceof _.fB ? ke.Z.comboBoxField : e instanceof _.Vi ? ke.Z.listBoxField : ke.Z.signatureField;
        }
        const Ty = (0, xe.vU)({
            formDesignerPopoverTitle: {
              id: "formDesignerPopoverTitle",
              defaultMessage: "{formFieldType} properties",
              description: "Form designer popover title"
            },
            styleSectionLabel: {
              id: "styleSectionLabel",
              defaultMessage: "{formFieldType} style",
              description: "Form designer style section"
            },
            formFieldName: {
              id: "formFieldName",
              defaultMessage: "Form field name",
              description: "Form designer popover form field name input label"
            },
            format: {
              id: "format",
              defaultMessage: "Format",
              description: "Format"
            },
            buttonText: {
              id: "buttonText",
              defaultMessage: "Button Text",
              description: "Form designer popover button text input label"
            },
            defaultValue: {
              id: "defaultValue",
              defaultMessage: "Default Value",
              description: "Form designer popover default value input label"
            },
            multiline: {
              id: "multiline",
              defaultMessage: "Multiline",
              description: "Form designer popover multiline input label"
            },
            radioButtonFormFieldNameWarning: {
              id: "radioButtonFormFieldNameWarning",
              defaultMessage: "To group the radio buttons, make sure they have the same form field names.",
              description: "Form designer popover radio button form field name warning message"
            },
            formFieldNameExists: {
              id: "formFieldNameExists",
              defaultMessage: "A form field named {formFieldName} already exists. Please choose a different name.",
              description: "Change form field name if it already exists."
            },
            formFieldNameNotEmpty: {
              id: "formFieldNameNotEmpty",
              defaultMessage: "Form Field Name cannot be left empty.",
              description: "Form Field Name cannot be left empty."
            },
            label: {
              id: "label",
              defaultMessage: "Label",
              description: "Label"
            },
            value: {
              id: "value",
              defaultMessage: "Value",
              description: "Value"
            }
          }),
          Oy = function (e) {
            var t;
            let {
              referenceRect: r,
              viewportState: o,
              isHidden: i,
              getExistingFormFieldByName: a,
              dispatch: l,
              annotation: c,
              formField: p,
              frameWindow: f,
              eventEmitter: m,
              locale: g,
              isUnsavedAnnotation: v,
              setModalClosurePreventionError: y,
              modalClosurePreventionError: b,
              pageSize: w,
              customFontsReadableNames: x
            } = e;
            const D = (0, xe.YB)(),
              C = (0, d.useMemo)(() => {
                if (p instanceof _.XQ || p instanceof _.rF) return p.annotationIds.findIndex((0, j.oF)(c));
              }, [p, c]),
              [S, E] = (0, d.useState)(p.name),
              [P, k] = (0, d.useState)(),
              [A, z] = d.useState(!1),
              T = d.useCallback(e => {
                let t = c;
                if (!t) return;
                t = t.merge(e);
                const n = {
                  annotations: (0, s.aV)([t]),
                  reason: J.f.PROPERTY_CHANGE
                };
                m.emit("annotations.willChange", n), l((0, yt.FG)(t));
              }, [m, l, c]),
              O = d.useCallback(e => {
                if (!p) return;
                let t = p;
                t = t.merge(e);
                if (!(S !== p.name)) return void l((0, er.vK)(t));
                const n = a(S);
                if (!n) {
                  const e = p.annotationIds.map(() => (0, j.xc)());
                  l((0, er.Vp)(t.set("name", p.name), S, e));
                  const n = p.annotationIds.findIndex((0, j.oF)(c)),
                    r = e.get(n);
                  return (0, u.kG)(r), l((0, _e.J4)((0, s.l4)([r]))), void l((0, er.Wh)(p));
                }
                t = t.set("name", S);
                const r = c.merge({
                  id: (0, j.xc)(),
                  formFieldName: S
                });
                t = t.merge({
                  annotationIds: n.annotationIds.push(r.id),
                  options: n.options.push(-1 !== C ? p.options.get(C) : p.options.first()),
                  id: n.id,
                  pdfObjectId: n.pdfObjectId
                }), l((0, yt.$d)(r)), l((0, er.vK)(t)), l((0, _e.J4)((0, s.l4)([r.id]))), l((0, er.Wh)(p));
              }, [p, l, S, c, a, C]);
            (0, mn.useGranularEffect)(() => {
              E(p.name), k(void 0);
            }, [c.id], [p.name]);
            const I = d.useCallback(e => {
                const t = e.target.value;
                E(t), null != t && t.trim() ? !a(t) || c.formFieldName === t || p instanceof _.XQ ? (k(void 0), A || y(null)) : (k(D.formatMessage(Ty.formFieldNameExists, {
                  formFieldName: t
                })), y({
                  annotationId: c.id,
                  error: Uv.x.FORM_DESIGNER_ERROR
                })) : (k(D.formatMessage(Ty.formFieldNameNotEmpty)), y({
                  annotationId: c.id,
                  error: Uv.x.FORM_DESIGNER_ERROR
                }));
              }, [D, c, p, a, y, A]),
              F = d.useCallback(e => O({
                buttonLabel: e.target.value
              }), [O]),
              M = d.useCallback(e => O({
                options: e
              }), [O]),
              R = (0, d.useCallback)(e => {
                const t = e.target.value;
                (0, u.kG)(void 0 !== C);
                const n = p.options.get(C),
                  r = p.options.set(C, n.set("label", t));
                O({
                  options: r
                });
              }, [O, p, C]),
              B = d.useCallback(e => {
                z(e), e ? y({
                  annotationId: c.id,
                  error: Uv.x.FORM_DESIGNER_ERROR
                }) : b && !P && y(null);
              }, [y, b, P, c]),
              N = (0, d.useCallback)(e => {
                const t = e.target.value;
                (0, u.kG)(void 0 !== C);
                const n = p.options.get(C),
                  r = p.options.set(C, n.set("value", t));
                O({
                  options: r
                });
              }, [O, p, C]),
              L = d.useMemo(() => {
                return p instanceof _.R0 ? d.createElement(uy, {
                  label: D.formatMessage(Ty.buttonText),
                  value: (null == p ? void 0 : p.buttonLabel) || "",
                  onChange: F,
                  className: Xv().lastInputField
                }) : p instanceof _.XQ ? ((0, u.kG)(void 0 !== C), d.createElement(d.Fragment, null, d.createElement("div", {
                  className: Xv().radioButtonWarning
                }, d.createElement(je.Z, {
                  src: n(21619),
                  role: "presentation",
                  className: Xv().radioButtonWarningIcon,
                  style: {
                    color: "#EB7F00"
                  }
                }), d.createElement("span", {
                  className: Xv().radioButtonWarningLabel
                }, D.formatMessage(Ty.radioButtonFormFieldNameWarning))), d.createElement(uy, {
                  label: D.formatMessage(Ty.label),
                  value: (null == p || null === (e = p.options.get(C)) || void 0 === e ? void 0 : e.label) || "",
                  onChange: R,
                  required: !0
                }), d.createElement(uy, {
                  label: D.formatMessage(Ty.value),
                  value: (null == p || null === (t = p.options.get(C)) || void 0 === t ? void 0 : t.value) || "",
                  onChange: N,
                  required: !0,
                  className: Xv().lastInputField
                }))) : p instanceof _.rF ? ((0, u.kG)(void 0 !== C), d.createElement(d.Fragment, null, d.createElement(uy, {
                  label: D.formatMessage(Ty.label),
                  value: (null == p || null === (r = p.options.get(C)) || void 0 === r ? void 0 : r.label) || "",
                  onChange: R,
                  required: !0
                }), d.createElement(uy, {
                  label: D.formatMessage(Ty.value),
                  value: (null == p || null === (o = p.options.get(C)) || void 0 === o ? void 0 : o.value) || "",
                  onChange: N,
                  required: !0,
                  className: Xv().lastInputField
                }))) : p instanceof _.Vi || p instanceof _.fB ? d.createElement(Sy, {
                  options: p.options,
                  onChange: M,
                  ownerDocument: f.document
                }) : null;
                var e, t, r, o;
              }, [f.document, p, D, F, M, R, N, C]),
              V = p instanceof _.$o && !(null === (t = c.additionalActions) || void 0 === t || !t.onFormat);
            return d.createElement($v.Z, {
              referenceRect: r,
              viewportState: o,
              isHidden: i || !p,
              className: "PSPDFKit-Form-Creator-Popover",
              wrapperClassName: "PSPDFKit-Form-Creator-Editor",
              title: D.formatMessage(Ty.formDesignerPopoverTitle, {
                formFieldType: p ? D.formatMessage(zy(p, V)) : ""
              }),
              footer: d.createElement(d.Fragment, null, d.createElement($v.j, {
                className: h()(Xv().footerButton, Xv().deleteButton, "PSPDFKit-Form-Creator-Editor-Delete"),
                onClick: () => {
                  y(null), l((0, yt.d8)((0, s.l4)([c.id])));
                }
              }, D.formatMessage(ke.Z.delete)), d.createElement($v.j, {
                className: h()(Xv().footerButton, Xv().doneButton, "PSPDFKit-Form-Creator-Editor-Done"),
                onClick: () => {
                  b || l((0, _e.fz)());
                }
              }, D.formatMessage(ke.Z.done)))
            }, d.createElement(d.Fragment, null, d.createElement("div", {
              className: v ? void 0 : Xv().formFieldNameReadOnly
            }, d.createElement("div", null, d.createElement(uy, {
              label: D.formatMessage(Ty.formFieldName),
              value: S,
              onChange: I,
              onKeyDown: e => e.stopPropagation(),
              required: !0,
              errorMessage: P,
              className: h()({
                [Xv().lastInputField]: !L && !V
              }),
              inputClassName: "PSPDFKit-Form-Creator-Editor-Form-Field-Name",
              onBlur: () => {
                P || O({
                  name: S
                });
              }
            })), L), V && d.createElement("div", {
              className: h()(sy().wrapper, Xv().lastInputField)
            }, d.createElement("label", {
              className: sy().label,
              htmlFor: "dateTimeFormat"
            }, "Format", d.createElement("div", {
              className: sy().formatSelectWrapper,
              role: "button"
            }, d.createElement("select", {
              className: sy().dateSelect,
              name: "dateTimeFormat",
              id: "dateTimeFormat",
              onChange: e => {
                const t = e.target.value;
                T({
                  additionalActions: {
                    onFormat: new _.bp({
                      script: `AFDate_FormatEx("${t}")`
                    })
                  }
                });
              }
            }, Ey || (Ey = d.createElement("option", {
              value: "yyyy-mm-dd"
            }, "yyyy-mm-dd")), _y || (_y = d.createElement("option", {
              value: "mm/dd/yyyy"
            }, "mm/dd/yyyy")), Py || (Py = d.createElement("option", {
              value: "dd/mm/yyyy"
            }, "dd/mm/yyyy")), ky || (ky = d.createElement("option", {
              value: "m/d/yyyy HH:MM"
            }, "m/d/yyyy HH:MM")), Ay || (Ay = d.createElement("option", {
              value: "d/m/yyyy HH:MM"
            }, "d/m/yyyy HH:MM")))))), d.createElement(Gv.ZP, {
              intl: D,
              annotation: c,
              label: D.formatMessage(Ty.styleSectionLabel, {
                formFieldType: p ? D.formatMessage(zy(p, V)) : ""
              }),
              updateAnnotation: T,
              frameWindow: f,
              pageSize: w
            }), !(p instanceof _.Yo) && !(p instanceof _.XQ) && !(p instanceof _.rF) && d.createElement(iy, {
              intl: D,
              annotation: c,
              updateAnnotation: T,
              frameWindow: f,
              formField: p,
              customFontsReadableNames: x
            }), d.createElement(py, {
              key: c.id,
              intl: D,
              annotation: c,
              updateAnnotation: T,
              formField: p,
              updateFormField: O,
              locale: g,
              onCustomDataError: B
            })));
          };
        var Iy,
          Fy,
          My = n(29538),
          Ry = n.n(My);
        const jy = De.Ni ? () => {
            const e = (0, l.I0)();
            return d.createElement(i.QO, {
              wrapperClass: h()(Ry().mobileWrapper, "PSPDFKit-ContentEditor-Exit-Dialog"),
              formClass: Ry().formWrapper,
              onDismiss: () => {
                e((0, th.Yg)(!1));
              }
            }, Fy || (Fy = d.createElement(By, null)));
          } : () => {
            const {
                formatMessage: e
              } = (0, xe.YB)(),
              t = (0, l.I0)();
            return d.createElement(Gd.Z, {
              role: "alertdialog",
              background: "rgba(0,0,0,.1)",
              className: h()(Ry().modalRoot, "PSPDFKit-ContentEditor-Exit-Dialog"),
              accessibilityLabel: e(Ny.contentEditorSavePromptAccessibilityLabel),
              accessibilityDescription: e(Ny.contentEditorSavePromptAccessibilityDescription),
              restoreOnClose: !0,
              onEscape: () => {
                t((0, th.Yg)(!1));
              }
            }, Iy || (Iy = d.createElement(By, null)));
          },
          By = () => {
            const {
                formatMessage: e
              } = (0, xe.YB)(),
              t = (0, l.I0)();
            return d.createElement(d.Fragment, null, d.createElement(Gd.Z.Section, {
              className: h()(Ry().dropdownSection, Ry().mainSection)
            }, d.createElement(i.zx, {
              className: h()(Ry().closeButton, "PSPDFKit-ContentEditor-Exit-Dialog-Close-Button"),
              onClick: () => {
                t((0, th.Yg)(!1));
              },
              "aria-label": e(ke.Z.close)
            }, d.createElement(je.Z, {
              className: Ry().closeIcon,
              src: n(2256)
            })), d.createElement("div", {
              className: h()(Ry().container, "PSPDFKit-ContentEditor-Exit-Dialog-Content")
            }, d.createElement(je.Z, {
              className: Ry().warningIcon,
              src: n(94072)
            }), d.createElement("h2", {
              className: Ry().heading
            }, e(Ny.contentEditorSavePromptHeading)), d.createElement("p", {
              className: Ry().description
            }, e(Ny.contentEditorSavePromptMessage)))), d.createElement(Gd.Z.Section, {
              className: h()(Ry().buttonsGroupSection, Ry().dropdownSection)
            }, d.createElement(i.hE, {
              className: h()(Ry().buttonsGroup, "PSPDFKit-ContentEditor-Exit-Dialog-Buttons"),
              align: "end"
            }, d.createElement(i.zx, {
              autoFocus: !0,
              onClick: () => {
                t(th.u8);
              },
              className: h()("PSPDFKit-ContentEditor-Exit-Dialog-Button", "PSPDFKit-ContentEditor-Exit-Dialog-Button-Discard-Changes", Ry().button)
            }, "Don't Save"), d.createElement(i.zx, {
              onClick: () => {
                t(th.Ij);
              },
              primary: !0,
              className: h()("PSPDFKit-ContentEditor-Exit-Dialog-Button", "PSPDFKit-ContentEditor-Exit-Dialog-Button-Save-Changes", Ry().button)
            }, "Save"))));
          },
          Ny = (0, xe.vU)({
            contentEditorSavePromptHeading: {
              id: "contentEditorSavePromptHeading",
              defaultMessage: "Save changes before exiting?",
              description: 'Heading displayed in the "Exit Content Editing Mode" confirm dialog'
            },
            contentEditorSavePromptMessage: {
              id: "contentEditorSavePromptMessage",
              defaultMessage: "If you don’t save your changes to the document, your changes will be lost.",
              description: 'Message displayed in the "Exit Content Editing Mode" confirm dialog'
            },
            contentEditorSavePromptAccessibilityLabel: {
              id: "contentEditorSavePromptAccessibilityLabel",
              defaultMessage: "Confirm content editing exit dialog",
              description: 'Accessibility description for the "Delete Annotation" confirm dialog'
            },
            contentEditorSavePromptAccessibilityDescription: {
              id: "contentEditorSavePromptAccessibilityDescription",
              defaultMessage: "A content editing session is about to be dismissed and data could be loss. This dialog serves as a confirmation to whether continue with this action or not.",
              description: 'Accessibility description for the "Exit Content Editing Mode" confirm dialog'
            }
          });
        var Ly = n(11147),
          Vy = n.n(Ly);
        const Ky = {
            uri: "uri",
            page: "page"
          },
          qy = "edit",
          Hy = "hover",
          Uy = "open";
        function Zy(e) {
          if (!e.action) return null;
          const t = e.action;
          return t instanceof _.lm ? t.uri : t.pageIndex + 1;
        }
        function $y(e) {
          return d.createElement("div", {
            className: h()(Vy().container)
          }, d.createElement("div", {
            className: Vy().innerContainer
          }, d.createElement("div", {
            className: Vy().content
          }, d.createElement(Gy, e))));
        }
        function Gy(e) {
          var t, r;
          let {
            pages: o,
            dispatch: a,
            annotation: s
          } = e;
          const l = (0, xe.YB)(),
            u = s.action instanceof _.Di,
            c = s.action instanceof _.lm;
          let p;
          u && (p = s.action), c && (p = s.action);
          const h = (0, d.useMemo)(() => !c && !u || c ? Ky.uri : Ky.page, [u, c]),
            [f, m] = (0, d.useState)(h),
            [g, v] = (0, d.useState)((null === (t = p) || void 0 === t ? void 0 : t.uri) || ""),
            [y, b] = (0, d.useState)((null === (r = p) || void 0 === r ? void 0 : r.pageIndex) + 1 || ""),
            [w, x] = (0, d.useState)(""),
            D = f === Ky.uri,
            C = (0, d.useCallback)(e => o.get(e - 1), [o]),
            S = (0, d.useCallback)(() => {
              const e = Number(y);
              if (e) {
                if (C(e)) {
                  const t = new _.Di({
                      pageIndex: e - 1
                    }),
                    n = s.set("action", t);
                  a((0, yt.FG)(n));
                } else x(l.formatMessage(Yy.invalidPageNumber));
              } else x(l.formatMessage(Yy.invalidPageNumber));
            }, [s, a, y, C]),
            E = (0, d.useCallback)(() => {
              if (!g) return void x(l.formatMessage(Yy.invalidPageLink));
              const e = new _.lm({
                  uri: g
                }),
                t = s.set("action", e);
              a((0, yt.FG)(t));
            }, [s, a, g]),
            P = (0, d.useCallback)(() => {
              if (D) return d.createElement(uy, {
                label: l.formatMessage(ke.Z.linkAnnotation),
                value: g,
                onChange: e => {
                  v(e.target.value), x("");
                },
                onBlur: E,
                errorMessage: w,
                placeholder: "www.example.com",
                disablePadding: !0
              });
            }, [w, l, D, g, E]),
            k = (0, d.useCallback)(() => {
              if (!D) return d.createElement(uy, {
                disablePadding: !0,
                label: l.formatMessage(Yy.targetPageLink),
                value: y,
                onChange: e => {
                  b(e.target.value), w && x("");
                },
                onBlur: S,
                placeholder: "1",
                errorMessage: w
              });
            }, [w, l, D, y, S]);
          return d.createElement(d.Fragment, null, d.createElement("label", {
            className: Vy().label
          }, l.formatMessage(Yy.linkTo), d.createElement(i.Ee, {
            inputName: "LinkTo",
            label: l.formatMessage(ke.Z.horizontalAlignment),
            selectedOption: f,
            labelClassNamePrefix: "PSPDFKit-Link-Popover-Editor-LinkTo",
            wrapperClasses: Vy().radioGroupWrapper,
            options: Object.keys(Ky).map(e => ({
              value: e,
              label: l.formatMessage(Yy[`${e}Link`]),
              iconPath: n(46154)
            })),
            onChange: e => {
              m(Ky[e]), w && x("");
            },
            isButton: !0,
            showLabel: !0
          })), P(), k());
        }
        function Wy(e) {
          const {
              viewportState: t,
              isHidden: n,
              annotation: r,
              isHover: o,
              dispatch: a
            } = e,
            s = (0, xe.YB)(),
            [l, u] = (0, d.useState)(!1),
            c = (0, d.useMemo)(() => (0, Xo.q)((0, j.Wj)(r, t.pagesRotation, t.viewportRect.getSize(), t.zoomLevel).apply((0, G.cr)(t, r.pageIndex).translate(t.scrollPosition.scale(t.zoomLevel))), t.viewportRect.getSize()), [r, t]),
            p = (0, d.useMemo)(() => r && o ? Hy : r && !r.action || l ? qy : Uy, [r, o, l]),
            f = (null == r ? void 0 : r.action) instanceof _.lm,
            m = (0, d.useMemo)(() => p === qy ? s.formatMessage(Yy.linkSettingsPopoverTitle) : f ? Zy(r) : `${s.formatMessage(Yy.linkToPage, {
              arg0: Zy(r)
            })}: ${Zy(r)}`, [r, p, s]),
            g = (0, d.useCallback)(t => {
              if (t) {
                const e = r.action instanceof _.lm;
                return d.createElement("div", {
                  className: h()(Vy().container)
                }, d.createElement("div", {
                  className: Vy().contentRow
                }, d.createElement(i.zx, {
                  className: h()("PSPDFKit-Link-Popover-Editor-Edit-Button"),
                  onClick: () => u(!0)
                }, s.formatMessage(ke.Z.edit)), d.createElement(i.zx, {
                  className: h()("PSPDFKit-Link-Popover-Editor-Open-Button"),
                  onClick: () => {
                    a((0, _e.fz)()), a((0, Gr.oo)(r));
                  },
                  primary: !0
                }, s.formatMessage(e ? Yy.openLink : Yy.goToPageLink))));
              }
              return d.createElement($y, e);
            }, [r, a, s, e]),
            v = (0, d.useCallback)(() => {
              switch (p) {
                case qy:
                  return g();
                case Uy:
                  return g(!0);
                default:
                  return null;
              }
            }, [p, g]);
          return d.createElement($v.Z, {
            referenceRect: c,
            viewportState: t,
            isHidden: n,
            className: "PSPDFKit-Link-Editor-Popover",
            wrapperClassName: "PSPDFKit-Link-Editor",
            title: m,
            centeredTitle: p !== qy
          }, v());
        }
        const Yy = (0, xe.vU)({
          linkSettingsPopoverTitle: {
            id: "linkSettingsPopoverTitle",
            defaultMessage: "Link Settings",
            description: "Link settings popover title"
          },
          linkTo: {
            id: "linkTo",
            defaultMessage: "Link To",
            description: "Link to popover option"
          },
          linkToPage: {
            id: "linkToPage",
            defaultMessage: "Link to Page",
            description: "Link to page action"
          },
          targetPageLink: {
            id: "targetPageLink",
            defaultMessage: "Page Number",
            description: "Link settings popover target link"
          },
          linkSettings: {
            id: "linkSettings",
            defaultMessage: "Link Settings",
            description: "Link Settings"
          },
          uriLink: {
            id: "uriLink",
            defaultMessage: "Website",
            description: "Link to uri"
          },
          pageLink: {
            id: "pageLink",
            defaultMessage: "Page",
            description: "Link to a page"
          },
          openLink: {
            id: "openLink",
            defaultMessage: "Open Link",
            description: "Open link to a page"
          },
          goToPageLink: {
            id: "goToPageLink",
            defaultMessage: "Go to Page",
            description: "Go to a page link"
          },
          invalidPageNumber: {
            id: "invalidPageNumber",
            defaultMessage: "Enter a valid page number.",
            description: "Invalid page number"
          },
          invalidPageLink: {
            id: "invalidPageLink",
            defaultMessage: "Enter a valid page link.",
            description: "Invalid page link"
          }
        });
        var Xy = n(92744),
          Qy = n(74268),
          Jy = n.n(Qy);
        const eb = function (e) {
            const {
                referenceRect: t,
                viewportState: n,
                activeTextBlock: r,
                fontFace: o
              } = e,
              i = (0, l.I0)(),
              {
                formatMessage: a
              } = (0, xe.YB)(),
              s = (0, l.v9)(e => {
                var t, n;
                return null !== (t = null === (n = e.contentEditorSession.fontMismatchTooltip) || void 0 === n ? void 0 : n.dismissAbortController) && void 0 !== t ? t : null;
              });
            return d.createElement(Nf.Z, {
              referenceRect: t.apply((0, G.cr)(n, r.pageIndex)).translate(n.scrollPosition.scale(n.zoomLevel)),
              viewportState: n,
              className: h()(Jy().container, "PSPDFKit-Font-Mismatch-Notification-Container"),
              color: [new _.Il({
                r: 255,
                g: 199,
                b: 143
              })],
              arrowSize: 0,
              arrowClassName: Jy().arrow
            }, d.createElement("div", {
              className: h()(Jy().wrapper, "PSPDFKit-Font-Mismatch-Notification"),
              onPointerOver: () => {
                s && s.abort();
              },
              onPointerLeave: () => {
                const e = new AbortController();
                i((0, th.Hv)(e)), i((0, th.uy)(e.signal));
              }
            }, d.createElement("span", {
              className: Jy().tooltipFont
            }, a(ah.fontMismatch, {
              arg0: o
            }))));
          },
          tb = d.memo(function (e) {
            const t = (0, xe.YB)(),
              n = (0, l.I0)(),
              r = (0, l.v9)(e => e.selectedGroupId),
              {
                selectedAnnotationIds: o
              } = e;
            return d.createElement("div", {
              className: h()("PSPDFKit-Multi-Annotations-Selection-Toolbar", ac().root, ac().content, ac().reverseRow)
            }, d.createElement(Ju.Z, {
              type: "delete",
              title: t.formatMessage(ke.Z.delete),
              className: ac().button,
              onPress: () => {
                n((0, yt.d8)(o));
              }
            }), r ? null : d.createElement(Ju.Z, {
              type: "group",
              title: t.formatMessage(ke.Z.group),
              className: ac().button,
              onPress: () => {
                n((0, Kt._R)(o));
              }
            }), r ? d.createElement(Ju.Z, {
              type: "ungroup",
              title: t.formatMessage(ke.Z.ungroup),
              className: ac().button,
              onPress: () => {
                n((0, Kt.UZ)(r));
              }
            }) : null);
          });
        const nb = tb,
          rb = e => {
            const t = (0, l.I0)(),
              {
                formatMessage: n
              } = (0, xe.YB)(),
              {
                interactionMode: r,
                currentItemPreset: o,
                frameWindow: i,
                backend: a
              } = e;
            function s(e, n, i) {
              t((0, _e.fz)()), r === n && i === o ? (0, l.dC)(() => {
                t((0, yt.Ds)(null)), t((0, Kt.Ce)());
              }) : (0, l.dC)(() => {
                t((0, yt.Ds)(i)), t((0, Kt.yg)(e, n));
              });
            }
            return d.createElement("div", {
              className: h()("PSPDFKit-Measurement-Toolbar", ac().root, ac().content, ac().measurementToolbar),
              onMouseUp: vv,
              onTouchEnd: vv,
              onPointerUp: vv
            }, z.Di.map(e => d.createElement(Md.Z, {
              key: e.interactionMode,
              type: e.icon,
              title: n(ke.Z[e.localeKey]),
              className: h()(Fd().formDesignerButton, {
                [Fd().formDesignerButtonActive]: r === e.interactionMode
              }, e.className),
              onPress: () => {
                s(e.class, e.interactionMode, e.preset);
              },
              selected: r === e.interactionMode
            })), d.createElement("div", {
              className: Fd().spacer
            }), d.createElement("div", {
              className: ac().right
            }, d.createElement(Od.ZP, {
              frameWindow: i
            }), d.createElement(Md.Z, {
              key: "scale",
              type: "scale",
              title: n(Yl.sY.measurementScale),
              className: h()(ac().measurementToolbarButton)
            }), d.createElement(Md.Z, {
              key: "calibrate",
              type: "calibrate",
              title: n(Yl.sY.calibrate),
              className: h()(Fd().formDesignerButton, "PSPDFKit-Scale-Calibration"),
              onPress: () => {
                const e = z.Di.find(e => e.interactionMode === B.A.DISTANCE);
                e && (t((0, Ht.Xh)(!0)), s(e.class, e.interactionMode, e.preset));
              }
            }), "STANDALONE" === (null == a ? void 0 : a.type) && d.createElement("button", {
              className: h()(ac().pointSnappingToggleButtonWrapper, "PSPDFKit-Measurement-Snapping-Toggle")
            }, d.createElement("div", {
              className: h()(ac().pointSnappingToggleButton)
            }, d.createElement("label", {
              className: h()(ac().checkbox)
            }, d.createElement("input", {
              type: "checkbox",
              name: "toggle-point-snapping",
              checked: !e.disablePointSnapping,
              onChange: () => {
                t((0, Kt.c8)(!e.disablePointSnapping));
              }
            }), d.createElement("span", {
              className: ac().checkboxLabel
            }, n(ke.Z.Snapping)))))));
          };
        var ob = n(38835),
          ib = n(89359),
          ab = n.n(ib);
        const sb = function (e) {
            const {
                referenceRect: t,
                viewportState: n,
                isReadOnly: r,
                isLocked: o,
                hasLockedContents: i
              } = e,
              {
                formatMessage: a
              } = (0, xe.YB)(),
              s = [r ? a(ke.Z.readOnlyAnnotationFlag) : "", o ? a(ke.Z.locked) : "", i ? a(ke.Z.lockedContents) : ""].filter(e => "" !== e).join(", "),
              l = t.grow(10);
            return d.createElement(Nf.Z, {
              referenceRect: l,
              viewportState: n,
              className: "PSPDFKit-Annotation-Flags-Popover",
              arrowClassName: ab().arrow
            }, d.createElement("span", {
              className: ab().tooltip,
              "aria-label": s
            }, s));
          },
          lb = e => {
            let {
              showComments: t,
              showRedactions: n,
              showDocumentAssistant: r
            } = e;
            const o = [{
              type: "highlight"
            }, {
              type: "strikeout"
            }, {
              type: "underline"
            }, {
              type: "squiggle"
            }];
            return t && o.push({
              type: "comment"
            }), n && o.push({
              type: "redact-text-highlighter"
            }), r && o.push({
              type: "document-assistant"
            }), o;
          };
        var ub = n(25534),
          cb = n.n(ub);
        function db(e) {
          let {
            text: t,
            anchorClassName: n,
            textClassName: r,
            tag: o
          } = e;
          return d.createElement(o || "p", {
            className: r
          }, t.split(" ").map((e, t) => {
            let r = "",
              o = e;
            return (e.endsWith(".") || e.endsWith(",")) && (r = e.slice(-1), o = e.slice(0, -1)), URL.canParse(o) && new URL(o).protocol.startsWith("http") ? d.createElement(d.Fragment, null, d.createElement("a", {
              key: t,
              href: o,
              target: "_blank",
              rel: "noopener noreferrer",
              className: n
            }, o), r) : e;
          }).reduce((e, t, n) => e.concat([n > 0 ? " " : "", t]), []));
        }
        function pb(e) {
          const t = d.useCallback(() => {
            e.evaluationUrl && (window.location.href = e.evaluationUrl);
          }, [e.evaluationUrl]);
          return d.createElement(Gd.Z, {
            role: "alertdialog",
            restoreOnClose: !1,
            className: h()("PSPDFKit-NoLicenseTimeout-Dialog", cb().noLicenseTimeoutModal),
            accessibilityDescription: "Dialog that pops up after some time when no trial or commercial license is provided.",
            accessibilityLabel: "No trial license provided warning dialog."
          }, d.createElement(Gd.Z.Section, {
            className: cb().topSection
          }, d.createElement(je.Z, {
            src: n(99939),
            className: cb().icon
          }), d.createElement("h2", {
            className: cb().header
          }, "Evaluation time is up"), d.createElement("hr", {
            className: cb().modalSeparator
          }), d.createElement(db, {
            tag: "p",
            text: e.evaluationMessage || "",
            textClassName: cb().text,
            anchorClassName: cb().link
          })), d.createElement(Gd.Z.Section, {
            className: cb().bottomSection
          }, d.createElement(i.zx, {
            autoFocus: !0,
            onClick: t,
            className: h()("PSPDFKit-NoLicenseTimeout-Dialog-Button", cb().button, cb().signUpButton),
            primary: !0
          }, "Sign Up for Trial")));
        }
        var hb = n(97838),
          fb = n.n(hb);
        const mb = (0, d.memo)(function (e) {
            let {
              closeOnPress: t = !1,
              formFields: n,
              signaturesInfo: r,
              annotations: o,
              navigationDisabled: i
            } = e;
            const [a, u] = (0, d.useState)(null);
            (0, d.useEffect)(() => {
              null == a || a.focus();
            }, [a]);
            const {
                formatMessage: c
              } = (0, xe.YB)(),
              p = (0, l.I0)(),
              f = (0, po.R9)(e => {
                const n = o.find(t => t instanceof de.x_ && t.formFieldName === e);
                (0, Ce.k)(n), p((0, Ql.kN)(n.pageIndex, n.boundingBox)), t && p((0, Kt.mu)());
              }),
              m = (0, d.useMemo)(() => {
                var e;
                return o.filter(e => {
                  if (e instanceof de.x_) {
                    (0, Ce.k)(n);
                    const o = n.get(e.formFieldName);
                    var t;
                    if (o instanceof gu.Yo) return !(null != r && null !== (t = r.signatures) && void 0 !== t && t.some(e => e.signatureFormFQN === o.name));
                  }
                  return !1;
                }).sortBy(e => [e.pageIndex, e.boundingBox.top], Pe.b).reduce((e, t) => e.push({
                  type: "unsigned-signature-field",
                  annotation: t
                }), (0, s.aV)((null == r || null === (e = r.signatures) || void 0 === e ? void 0 : e.map(e => ({
                  type: "signature",
                  signature: e
                }))) || []));
              }, [o, n, r]),
              g = (0, po.Bo)(a, m),
              v = (0, po.mP)(g, e => "signature" === e.type ? e.signature.signatureFormFQN : e.annotation.formFieldName, e => m.find(t => "unsigned-signature-field" === t.type ? t.annotation.formFieldName === e : t.signature.signatureFormFQN === e));
            return d.createElement("div", {
              className: h()(fb().container, "PSPDFKit-Sidebar-Signatures"),
              role: "region",
              "aria-label": c(ke.Z.signatures),
              ref: u
            }, d.createElement("div", {
              className: h()(fb().header, "PSPDFKit-Sidebar-Header")
            }, c(ke.Z.signatures)), m.size > 0 ? d.createElement("ul", {
              className: h()(fb().itemList, "PSPDFKit-Sidebar-Signatures-Container")
            }, m.map(e => {
              var t, n, r, o;
              const a = (0, Ae.Z)({
                  type: `${e.type}${"signature" === e.type ? `-${null === (t = e.signature) || void 0 === t ? void 0 : t.signatureValidationStatus}` : ""}`,
                  className: h()(fb().icon, "signature" === e.type ? fb().iconSigned : fb().iconUnsigned, {
                    [fb().iconValid]: "signature" === e.type && "valid" === (null === (n = e.signature) || void 0 === n ? void 0 : n.signatureValidationStatus),
                    [fb().iconWarning]: "signature" === e.type && "warning" === (null === (r = e.signature) || void 0 === r ? void 0 : r.signatureValidationStatus),
                    [fb().iconError]: "signature" === e.type && "error" === (null === (o = e.signature) || void 0 === o ? void 0 : o.signatureValidationStatus)
                  }, "PSPDFKit-Sidebar-Signatures-Icon")
                }),
                s = "signature" === e.type ? e.signature.signatureFormFQN : e.annotation.formFieldName,
                l = "signature" === e.type && e.signature.signerName || s;
              return d.createElement("li", {
                ref: v ? t => {
                  v && t && v(t, e);
                } : void 0,
                onClick: () => {
                  i || f(s);
                },
                key: `${e.type}-${s}`,
                className: h()(fb().item, "PSPDFKit-Sidebar-Signatures-Item")
              }, a, d.createElement("span", {
                className: h()(fb().title, "PSPDFKit-Sidebar-Signatures-Title"),
                title: l
              }, l));
            })) : d.createElement("div", {
              className: h()(fb().container, fb().empty, "PSPDFKit-Sidebar-Empty"),
              role: "region",
              "aria-label": c(ke.Z.signatures)
            }, c(gb.noSignatures)));
          }),
          gb = (0, xe.vU)({
            noSignatures: {
              id: "noSignatures",
              defaultMessage: "No Signatures",
              description: "Message shown when there are no signatures"
            }
          });
        function vb(e) {
          let {
            onSelectImage: t
          } = e;
          const n = d.useCallback(e => {
              e && (e.click(), function (e, t) {
                (0, De.eJ)(16.4) ? (e.addEventListener("blur", () => {
                  e.addEventListener("blur", () => {
                    t();
                  }, {
                    once: !0
                  });
                }, {
                  once: !0
                }), e.focus()) : e.addEventListener("cancel", t, {
                  once: !0
                });
              }(e, () => t(null)));
            }, [t]),
            {
              formatMessage: r
            } = (0, xe.YB)();
          return d.createElement(i.TX, {
            tag: "div"
          }, d.createElement("input", {
            "aria-label": r(ke.Z.selectImage),
            "aria-hidden": !0,
            type: "file",
            accept: "image/png, image/jpeg, application/pdf",
            onChange: e => {
              var n;
              const r = null === (n = e.target.files) || void 0 === n ? void 0 : n[0];
              t(r || null);
            },
            tabIndex: -1,
            ref: n
          }));
        }
        var yb = n(70799);
        n(2278);
        new Map();
        new Map();
        const bb = ["hours", "minutes", "seconds"];
        new Map();
        const wb = {
          badInput: !1,
          customError: !1,
          patternMismatch: !1,
          rangeOverflow: !1,
          rangeUnderflow: !1,
          stepMismatch: !1,
          tooLong: !1,
          tooShort: !1,
          typeMismatch: !1,
          valueMissing: !1,
          valid: !0
        };
        (0, d.createContext)({}), Date.now();
        function xb(e) {
          return null;
        }
        function Db(e) {
          return null != e.hasChildItems ? e.hasChildItems : !!e.childItems || !!(e.title && d.Children.count(e.children) > 0);
        }
        xb.getCollectionNode = function* (e, t) {
          let {
              childItems: n,
              title: r,
              children: o
            } = e,
            i = e.title || e.children,
            a = e.textValue || ("string" == typeof i ? i : "") || e["aria-label"] || "";
          a || (null == t ? void 0 : t.suppressTextValueWarning) || console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop."), yield {
            type: "item",
            props: e,
            rendered: i,
            textValue: a,
            "aria-label": e["aria-label"],
            hasChildNodes: Db(e),
            *childNodes() {
              if (n) for (let e of n) yield {
                type: "item",
                value: e
              };else if (r) {
                let e = [];
                d.Children.forEach(o, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        function Cb(e) {
          return null;
        }
        Cb.getCollectionNode = function* (e) {
          let {
            children: t,
            title: n,
            items: r
          } = e;
          yield {
            type: "section",
            props: e,
            hasChildNodes: !0,
            rendered: n,
            "aria-label": e["aria-label"],
            *childNodes() {
              if ("function" == typeof t) {
                if (!r) throw new Error("props.children was a function but props.items is missing");
                for (let e of r) yield {
                  type: "item",
                  value: e,
                  renderer: t
                };
              } else {
                let e = [];
                d.Children.forEach(t, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        new WeakMap();
        class Sb {
          *[Symbol.iterator]() {
            yield* this.iterable;
          }
          get size() {
            return this.keyMap.size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            return this.firstKey;
          }
          getLastKey() {
            return this.lastKey;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getChildren(e) {
            let t = this.keyMap.get(e);
            return (null == t ? void 0 : t.childNodes) || [];
          }
          constructor(e) {
            this.keyMap = new Map(), this.iterable = e;
            let t,
              n = e => {
                if (this.keyMap.set(e.key, e), e.childNodes && "section" === e.type) for (let t of e.childNodes) n(t);
              };
            for (let t of e) n(t);
            let r = 0;
            for (let [e, n] of this.keyMap) t ? (t.nextKey = e, n.prevKey = t.key) : (this.firstKey = e, n.prevKey = void 0), "item" === n.type && (n.index = r++), n, t.nextKey = void 0;
            this.lastKey = null == t ? void 0 : t.key;
          }
        }
        class Eb {
          getStringForLocale(e, t) {
            let n = this.strings[t];
            n || (n = function (e, t, n = "en-US") {
              if (t[e]) return t[e];
              let r = function (e) {
                return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
              }(e);
              if (t[r]) return t[r];
              for (let e in t) if (e.startsWith(r + "-")) return t[e];
              return t[n];
            }(t, this.strings, this.defaultLocale), this.strings[t] = n);
            let r = n[e];
            if (!r) throw new Error(`Could not find intl message ${e} in ${t} locale`);
            return r;
          }
          constructor(e, t = "en-US") {
            this.strings = {
              ...e
            }, this.defaultLocale = t;
          }
        }
        new Map(), new Map();
        function _b(e) {
          return e && e.__esModule ? e.default : e;
        }
        new Eb(_b({
          "ar-AE": {
            rangeOverflow: e => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
            rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
            rangeUnderflow: e => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
            unavailableDate: "البيانات المحددة غير متاحة."
          },
          "bg-BG": {
            rangeOverflow: e => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
            rangeReversed: "Началната дата трябва да е преди крайната.",
            rangeUnderflow: e => `Стойността трябва да е ${e.minValue} или по-късно.`,
            unavailableDate: "Избраната дата не е налична."
          },
          "cs-CZ": {
            rangeOverflow: e => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
            rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
            rangeUnderflow: e => `Hodnota musí být ${e.minValue} nebo pozdější.`,
            unavailableDate: "Vybrané datum není k dispozici."
          },
          "da-DK": {
            rangeOverflow: e => `Værdien skal være ${e.maxValue} eller tidligere.`,
            rangeReversed: "Startdatoen skal være før slutdatoen.",
            rangeUnderflow: e => `Værdien skal være ${e.minValue} eller nyere.`,
            unavailableDate: "Den valgte dato er ikke tilgængelig."
          },
          "de-DE": {
            rangeOverflow: e => `Der Wert muss ${e.maxValue} oder früher sein.`,
            rangeReversed: "Das Anfangsdatum muss vor dem Enddatum liegen.",
            rangeUnderflow: e => `Der Wert muss ${e.minValue} oder später sein.`,
            unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
          },
          "el-GR": {
            rangeOverflow: e => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
            rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
            rangeUnderflow: e => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
            unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
          },
          "en-US": {
            rangeUnderflow: e => `Value must be ${e.minValue} or later.`,
            rangeOverflow: e => `Value must be ${e.maxValue} or earlier.`,
            rangeReversed: "Start date must be before end date.",
            unavailableDate: "Selected date unavailable."
          },
          "es-ES": {
            rangeOverflow: e => `El valor debe ser ${e.maxValue} o anterior.`,
            rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
            rangeUnderflow: e => `El valor debe ser ${e.minValue} o posterior.`,
            unavailableDate: "Fecha seleccionada no disponible."
          },
          "et-EE": {
            rangeOverflow: e => `Väärtus peab olema ${e.maxValue} või varasem.`,
            rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
            rangeUnderflow: e => `Väärtus peab olema ${e.minValue} või hilisem.`,
            unavailableDate: "Valitud kuupäev pole saadaval."
          },
          "fi-FI": {
            rangeOverflow: e => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
            rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
            rangeUnderflow: e => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
            unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
          },
          "fr-FR": {
            rangeOverflow: e => `La valeur doit être ${e.maxValue} ou antérieure.`,
            rangeReversed: "La date de début doit être antérieure à la date de fin.",
            rangeUnderflow: e => `La valeur doit être ${e.minValue} ou ultérieure.`,
            unavailableDate: "La date sélectionnée n’est pas disponible."
          },
          "he-IL": {
            rangeOverflow: e => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
            rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
            rangeUnderflow: e => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
            unavailableDate: "התאריך הנבחר אינו זמין."
          },
          "hr-HR": {
            rangeOverflow: e => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
            rangeReversed: "Datum početka mora biti prije datuma završetka.",
            rangeUnderflow: e => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
            unavailableDate: "Odabrani datum nije dostupan."
          },
          "hu-HU": {
            rangeOverflow: e => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
            rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
            rangeUnderflow: e => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
            unavailableDate: "A kiválasztott dátum nem érhető el."
          },
          "it-IT": {
            rangeOverflow: e => `Il valore deve essere ${e.maxValue} o precedente.`,
            rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
            rangeUnderflow: e => `Il valore deve essere ${e.minValue} o successivo.`,
            unavailableDate: "Data selezionata non disponibile."
          },
          "ja-JP": {
            rangeOverflow: e => `値は ${e.maxValue} 以下にする必要があります。`,
            rangeReversed: "開始日は終了日より前にする必要があります。",
            rangeUnderflow: e => `値は ${e.minValue} 以上にする必要があります。`,
            unavailableDate: "選択した日付は使用できません。"
          },
          "ko-KR": {
            rangeOverflow: e => `값은 ${e.maxValue} 이전이어야 합니다.`,
            rangeReversed: "시작일은 종료일 이전이어야 합니다.",
            rangeUnderflow: e => `값은 ${e.minValue} 이상이어야 합니다.`,
            unavailableDate: "선택한 날짜를 사용할 수 없습니다."
          },
          "lt-LT": {
            rangeOverflow: e => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
            rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
            rangeUnderflow: e => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
            unavailableDate: "Pasirinkta data nepasiekiama."
          },
          "lv-LV": {
            rangeOverflow: e => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
            rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
            rangeUnderflow: e => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
            unavailableDate: "Atlasītais datums nav pieejams."
          },
          "nb-NO": {
            rangeOverflow: e => `Verdien må være ${e.maxValue} eller tidligere.`,
            rangeReversed: "Startdatoen må være før sluttdatoen.",
            rangeUnderflow: e => `Verdien må være ${e.minValue} eller senere.`,
            unavailableDate: "Valgt dato utilgjengelig."
          },
          "nl-NL": {
            rangeOverflow: e => `Waarde moet ${e.maxValue} of eerder zijn.`,
            rangeReversed: "De startdatum moet voor de einddatum liggen.",
            rangeUnderflow: e => `Waarde moet ${e.minValue} of later zijn.`,
            unavailableDate: "Geselecteerde datum niet beschikbaar."
          },
          "pl-PL": {
            rangeOverflow: e => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
            rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
            rangeUnderflow: e => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
            unavailableDate: "Wybrana data jest niedostępna."
          },
          "pt-BR": {
            rangeOverflow: e => `O valor deve ser ${e.maxValue} ou anterior.`,
            rangeReversed: "A data inicial deve ser anterior à data final.",
            rangeUnderflow: e => `O valor deve ser ${e.minValue} ou posterior.`,
            unavailableDate: "Data selecionada indisponível."
          },
          "pt-PT": {
            rangeOverflow: e => `O valor tem de ser ${e.maxValue} ou anterior.`,
            rangeReversed: "A data de início deve ser anterior à data de fim.",
            rangeUnderflow: e => `O valor tem de ser ${e.minValue} ou posterior.`,
            unavailableDate: "Data selecionada indisponível."
          },
          "ro-RO": {
            rangeOverflow: e => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
            rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
            rangeUnderflow: e => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
            unavailableDate: "Data selectată nu este disponibilă."
          },
          "ru-RU": {
            rangeOverflow: e => `Значение должно быть не позже ${e.maxValue}.`,
            rangeReversed: "Дата начала должна предшествовать дате окончания.",
            rangeUnderflow: e => `Значение должно быть не раньше ${e.minValue}.`,
            unavailableDate: "Выбранная дата недоступна."
          },
          "sk-SK": {
            rangeOverflow: e => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
            rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
            rangeUnderflow: e => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
            unavailableDate: "Vybratý dátum je nedostupný."
          },
          "sl-SI": {
            rangeOverflow: e => `Vrednost mora biti ${e.maxValue} ali starejša.`,
            rangeReversed: "Začetni datum mora biti pred končnim datumom.",
            rangeUnderflow: e => `Vrednost mora biti ${e.minValue} ali novejša.`,
            unavailableDate: "Izbrani datum ni na voljo."
          },
          "sr-SP": {
            rangeOverflow: e => `Vrednost mora da bude ${e.maxValue} ili starija.`,
            rangeReversed: "Datum početka mora biti pre datuma završetka.",
            rangeUnderflow: e => `Vrednost mora da bude ${e.minValue} ili novija.`,
            unavailableDate: "Izabrani datum nije dostupan."
          },
          "sv-SE": {
            rangeOverflow: e => `Värdet måste vara ${e.maxValue} eller tidigare.`,
            rangeReversed: "Startdatumet måste vara före slutdatumet.",
            rangeUnderflow: e => `Värdet måste vara ${e.minValue} eller senare.`,
            unavailableDate: "Det valda datumet är inte tillgängligt."
          },
          "tr-TR": {
            rangeOverflow: e => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
            rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
            rangeUnderflow: e => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
            unavailableDate: "Seçilen tarih kullanılamıyor."
          },
          "uk-UA": {
            rangeOverflow: e => `Значення має бути не пізніше ${e.maxValue}.`,
            rangeReversed: "Дата початку має передувати даті завершення.",
            rangeUnderflow: e => `Значення має бути не раніше ${e.minValue}.`,
            unavailableDate: "Вибрана дата недоступна."
          },
          "zh-CN": {
            rangeOverflow: e => `值必须是 ${e.maxValue} 或更早日期。`,
            rangeReversed: "开始日期必须早于结束日期。",
            rangeUnderflow: e => `值必须是 ${e.minValue} 或更晚日期。`,
            unavailableDate: "所选日期不可用。"
          },
          "zh-TW": {
            rangeOverflow: e => `值必須是 ${e.maxValue} 或更早。`,
            rangeReversed: "開始日期必須在結束日期之前。",
            rangeUnderflow: e => `值必須是 ${e.minValue} 或更晚。`,
            unavailableDate: "所選日期無法使用。"
          }
        }));
        new Eb({
          ach: {
            year: "mwaka",
            month: "dwe",
            day: "nino"
          },
          af: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          am: {
            year: "ዓዓዓዓ",
            month: "ሚሜ",
            day: "ቀቀ"
          },
          an: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          ar: {
            year: "سنة",
            month: "شهر",
            day: "يوم"
          },
          ast: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          az: {
            year: "iiii",
            month: "aa",
            day: "gg"
          },
          be: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          bg: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          bn: {
            year: "yyyy",
            month: "মিমি",
            day: "dd"
          },
          br: {
            year: "bbbb",
            month: "mm",
            day: "dd"
          },
          bs: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          ca: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          cak: {
            year: "jjjj",
            month: "ii",
            day: "q'q'"
          },
          ckb: {
            year: "ساڵ",
            month: "مانگ",
            day: "ڕۆژ"
          },
          cs: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          cy: {
            year: "bbbb",
            month: "mm",
            day: "dd"
          },
          da: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          de: {
            year: "jjjj",
            month: "mm",
            day: "tt"
          },
          dsb: {
            year: "llll",
            month: "mm",
            day: "źź"
          },
          el: {
            year: "εεεε",
            month: "μμ",
            day: "ηη"
          },
          en: {
            year: "yyyy",
            month: "mm",
            day: "dd"
          },
          eo: {
            year: "jjjj",
            month: "mm",
            day: "tt"
          },
          es: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          et: {
            year: "aaaa",
            month: "kk",
            day: "pp"
          },
          eu: {
            year: "uuuu",
            month: "hh",
            day: "ee"
          },
          fa: {
            year: "سال",
            month: "ماه",
            day: "روز"
          },
          ff: {
            year: "hhhh",
            month: "ll",
            day: "ññ"
          },
          fi: {
            year: "vvvv",
            month: "kk",
            day: "pp"
          },
          fr: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          fy: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          ga: {
            year: "bbbb",
            month: "mm",
            day: "ll"
          },
          gd: {
            year: "bbbb",
            month: "mm",
            day: "ll"
          },
          gl: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          he: {
            year: "שנה",
            month: "חודש",
            day: "יום"
          },
          hr: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          hsb: {
            year: "llll",
            month: "mm",
            day: "dd"
          },
          hu: {
            year: "éééé",
            month: "hh",
            day: "nn"
          },
          ia: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          id: {
            year: "tttt",
            month: "bb",
            day: "hh"
          },
          it: {
            year: "aaaa",
            month: "mm",
            day: "gg"
          },
          ja: {
            year: " 年 ",
            month: "月",
            day: "日"
          },
          ka: {
            year: "წწწწ",
            month: "თთ",
            day: "რრ"
          },
          kk: {
            year: "жжжж",
            month: "аа",
            day: "кк"
          },
          kn: {
            year: "ವವವವ",
            month: "ಮಿಮೀ",
            day: "ದಿದಿ"
          },
          ko: {
            year: "연도",
            month: "월",
            day: "일"
          },
          lb: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          lo: {
            year: "ປປປປ",
            month: "ດດ",
            day: "ວວ"
          },
          lt: {
            year: "mmmm",
            month: "mm",
            day: "dd"
          },
          lv: {
            year: "gggg",
            month: "mm",
            day: "dd"
          },
          meh: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          ml: {
            year: "വർഷം",
            month: "മാസം",
            day: "തീയതി"
          },
          ms: {
            year: "tttt",
            month: "mm",
            day: "hh"
          },
          nl: {
            year: "jjjj",
            month: "mm",
            day: "dd"
          },
          nn: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          no: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          oc: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          pl: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          pt: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          rm: {
            year: "oooo",
            month: "mm",
            day: "dd"
          },
          ro: {
            year: "aaaa",
            month: "ll",
            day: "zz"
          },
          ru: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          sc: {
            year: "aaaa",
            month: "mm",
            day: "dd"
          },
          scn: {
            year: "aaaa",
            month: "mm",
            day: "jj"
          },
          sk: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          sl: {
            year: "llll",
            month: "mm",
            day: "dd"
          },
          sr: {
            year: "гггг",
            month: "мм",
            day: "дд"
          },
          sv: {
            year: "åååå",
            month: "mm",
            day: "dd"
          },
          szl: {
            year: "rrrr",
            month: "mm",
            day: "dd"
          },
          tg: {
            year: "сссс",
            month: "мм",
            day: "рр"
          },
          th: {
            year: "ปปปป",
            month: "ดด",
            day: "วว"
          },
          tr: {
            year: "yyyy",
            month: "aa",
            day: "gg"
          },
          uk: {
            year: "рррр",
            month: "мм",
            day: "дд"
          },
          "zh-CN": {
            year: "年",
            month: "月",
            day: "日"
          },
          "zh-TW": {
            year: "年",
            month: "月",
            day: "日"
          }
        }, "en");
        function Pb(e) {
          let {
              initialItems: t = [],
              initialSelectedKeys: n,
              getKey: r = e => e.id || e.key,
              getChildren: o = e => e.children
            } = e,
            i = (0, d.useMemo)(() => new Map(), []),
            a = (0, d.useMemo)(() => p(t), []),
            [s, l] = (0, d.useState)(a),
            [u, c] = (0, d.useState)(new Set(n || []));
          function p(e = [], t) {
            return e.map(e => {
              let n = {
                key: r(e),
                parentKey: t,
                value: e,
                children: null
              };
              return n.children = p(o(e), n.key), i.set(n.key, n), n;
            });
          }
          function h(e, t, n) {
            let r = i.get(t);
            if (!r) return e;
            let o = n(r);
            for (null == o ? m(r) : f(o); r.parentKey;) {
              let e = i.get(r.parentKey),
                t = {
                  key: e.key,
                  parentKey: e.parentKey,
                  value: e.value,
                  children: null
                },
                n = e.children;
              null == o && (n = n.filter(e => e !== r)), t.children = n.map(e => e === r ? o : e), i.set(t.key, t), o = t, r = e;
            }
            return null == o && (e = e.filter(e => e !== r)), e.map(e => e === r ? o : e);
          }
          function f(e) {
            i.set(e.key, e);
            for (let t of e.children) f(t);
          }
          function m(e) {
            i.delete(e.key);
            for (let t of e.children) m(t);
          }
          return {
            items: s,
            selectedKeys: u,
            setSelectedKeys: c,
            getItem: e => i.get(e),
            insert(e, t, ...n) {
              l(r => {
                let o = p(n, e);
                return null == e ? [...r.slice(0, t), ...o, ...r.slice(t)] : h(r, e, e => ({
                  key: e.key,
                  parentKey: e.parentKey,
                  value: e.value,
                  children: [...e.children.slice(0, t), ...o, ...e.children.slice(t)]
                }));
              });
            },
            insertBefore(e, ...t) {
              let n = i.get(e);
              if (!n) return;
              let r = i.get(n.parentKey),
                o = (r ? r.children : s).indexOf(n);
              this.insert(null == r ? void 0 : r.key, o, ...t);
            },
            insertAfter(e, ...t) {
              let n = i.get(e);
              if (!n) return;
              let r = i.get(n.parentKey),
                o = (r ? r.children : s).indexOf(n);
              this.insert(null == r ? void 0 : r.key, o + 1, ...t);
            },
            prepend(e, ...t) {
              this.insert(e, 0, ...t);
            },
            append(e, ...t) {
              if (null == e) this.insert(null, s.length, ...t);else {
                let n = i.get(e);
                if (!n) return;
                this.insert(e, n.children.length, ...t);
              }
            },
            remove(...e) {
              let t = s;
              for (let n of e) t = h(t, n, () => null);
              l(t);
              let n = new Set(u);
              for (let e of u) i.has(e) || n.delete(e);
              c(n);
            },
            removeSelectedItems() {
              this.remove(...u);
            },
            move(e, t, n) {
              l(r => {
                let o = i.get(e);
                if (!o) return r;
                r = h(r, e, () => null);
                const a = {
                  ...o,
                  parentKey: t
                };
                return null == t ? [...r.slice(0, n), a, ...r.slice(n)] : h(r, t, e => ({
                  key: e.key,
                  parentKey: e.parentKey,
                  value: e.value,
                  children: [...e.children.slice(0, n), a, ...e.children.slice(n)]
                }));
              });
            },
            update(e, t) {
              l(n => h(n, e, e => {
                let n = {
                  key: e.key,
                  parentKey: e.parentKey,
                  value: t,
                  children: null
                };
                return n.children = p(o(t), n.key), n;
              }));
            }
          };
        }
        new Map();
        let kb = !1;
        try {
          kb = "exceptZero" === new Intl.NumberFormat("de-DE", {
            signDisplay: "exceptZero"
          }).resolvedOptions().signDisplay;
        } catch (e) {}
        let Ab = !1;
        try {
          Ab = "unit" === new Intl.NumberFormat("de-DE", {
            style: "unit",
            unit: "degree"
          }).resolvedOptions().style;
        } catch (e) {}
        new Map();
        new Set(["decimal", "fraction", "integer", "minusSign", "plusSign", "group"]);
        Math.round(1e10 * Math.random());
        class zb {
          *[Symbol.iterator]() {
            yield* [...this.rows];
          }
          get size() {
            return [...this.rows].length;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            var e;
            return null === [...this.rows][0] || void 0 === e ? void 0 : e.key;
          }
          getLastKey() {
            var e;
            let t = [...this.rows];
            return null === t[t.length - 1] || void 0 === e ? void 0 : e.key;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getChildren(e) {
            let t = this.keyMap.get(e);
            return (null == t ? void 0 : t.childNodes) || [];
          }
          constructor(e) {
            this.keyMap = new Map(), this.keyMap = new Map(), this.columnCount = null == e ? void 0 : e.columnCount, this.rows = [];
            let t,
              n = t => {
                let o = this.keyMap.get(t.key);
                e.visitNode && e.visitNode(t), this.keyMap.set(t.key, t);
                let i,
                  a = new Set();
                for (let e of t.childNodes) "cell" === e.type && null == e.parentKey && (e.parentKey = t.key), a.add(e.key), i ? (i.nextKey = e.key, e.prevKey = i.key) : e.prevKey = null, n(e), e;
                if (i && (i.nextKey = null), o) for (let e of o.childNodes) a.has(e.key) || r(e);
              },
              r = e => {
                this.keyMap.delete(e.key);
                for (let t of e.childNodes) this.keyMap.get(t.key) === t && r(t);
              };
            e.items.forEach((e, r) => {
              let o = {
                level: 0,
                key: "row-" + r,
                type: "row",
                value: void 0,
                hasChildNodes: !0,
                childNodes: [...e.childNodes],
                rendered: void 0,
                textValue: void 0,
                ...e
              };
              t ? (t.nextKey = o.key, o.prevKey = t.key) : o.prevKey = null, this.rows.push(o), n(o), o;
            }), t && (t.nextKey = null);
          }
        }
        const Tb = "row-header-column-" + Math.random().toString(36).slice(2);
        let Ob = "row-header-column-" + Math.random().toString(36).slice(2);
        for (; Tb === Ob;) Ob = "row-header-column-" + Math.random().toString(36).slice(2);
        class Ib extends zb {
          *[Symbol.iterator]() {
            yield* this.body.childNodes;
          }
          get size() {
            return this._size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            var e;
            return null === $c5a24bc478652b5f$export$fbdeaa6a76694f71(this.body.childNodes) || void 0 === e ? void 0 : e.key;
          }
          getLastKey() {
            var e;
            return null === $c5a24bc478652b5f$export$7475b2c64539e4cf(this.body.childNodes) || void 0 === e ? void 0 : e.key;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          getTextValue(e) {
            let t = this.getItem(e);
            if (!t) return "";
            if (t.textValue) return t.textValue;
            let n = this.rowHeaderColumnKeys;
            if (n) {
              let e = [];
              for (let r of t.childNodes) {
                let t = this.columns[r.index];
                if (n.has(t.key) && r.textValue && e.push(r.textValue), e.length === n.size) break;
              }
              return e.join(" ");
            }
            return "";
          }
          constructor(e, t, n) {
            let r,
              o = new Set(),
              i = [];
            if (null == n ? void 0 : n.showSelectionCheckboxes) {
              let e = {
                type: "column",
                key: Tb,
                value: null,
                textValue: "",
                level: 0,
                index: (null == n ? void 0 : n.showDragButtons) ? 1 : 0,
                hasChildNodes: !1,
                rendered: null,
                childNodes: [],
                props: {
                  isSelectionCell: !0
                }
              };
              i.unshift(e);
            }
            if (null == n ? void 0 : n.showDragButtons) {
              let e = {
                type: "column",
                key: Ob,
                value: null,
                textValue: "",
                level: 0,
                index: 0,
                hasChildNodes: !1,
                rendered: null,
                childNodes: [],
                props: {
                  isDragButtonCell: !0
                }
              };
              i.unshift(e);
            }
            let a = [],
              s = new Map(),
              l = e => {
                switch (e.type) {
                  case "body":
                    e;
                    break;
                  case "column":
                    s.set(e.key, e), e.hasChildNodes || (i.push(e), e.props.isRowHeader && o.add(e.key));
                    break;
                  case "item":
                    return void a.push(e);
                }
                for (let t of e.childNodes) l(t);
              };
            for (let t of e) l(t);
            let u = function (e, t) {
              if (0 === t.length) return [];
              let n = [],
                r = new Map();
              for (let o of t) {
                let t = o.parentKey,
                  i = [o];
                for (; t;) {
                  let n = e.get(t);
                  if (!n) break;
                  if (r.has(n)) {
                    n.colspan++;
                    let {
                      column: e,
                      index: t
                    } = r.get(n);
                    if (t > i.length) break;
                    for (let n = t; n < i.length; n++) e.splice(n, 0, null);
                    for (let t = i.length; t < e.length; t++) e[t] && r.has(e[t]) && (r.get(e[t]).index = t);
                  } else n.colspan = 1, i.push(n), r.set(n, {
                    column: i,
                    index: i.length - 1
                  });
                  n.parentKey;
                }
                n.push(i), o.index = n.length - 1;
              }
              let o = Math.max(...n.map(e => e.length)),
                i = Array(o).fill(0).map(() => []),
                a = 0;
              for (let e of n) {
                let t = o - 1;
                for (let n of e) {
                  if (n) {
                    let e = i[t],
                      r = e.reduce((e, t) => e + t.colspan, 0);
                    if (r < a) {
                      let o = {
                        type: "placeholder",
                        key: "placeholder-" + n.key,
                        colspan: a - r,
                        index: r,
                        value: null,
                        rendered: null,
                        level: t,
                        hasChildNodes: !1,
                        childNodes: [],
                        textValue: null
                      };
                      e.length > 0 && (e[e.length - 1].nextKey = o.key, o.prevKey = e[e.length - 1].key), e.push(o);
                    }
                    e.length > 0 && (e[e.length - 1].nextKey = n.key, n.prevKey = e[e.length - 1].key), n.level = t, n.colIndex = a, e.push(n);
                  }
                  0;
                }
                0;
              }
              let s = 0;
              for (let e of i) {
                let n = e.reduce((e, t) => e + t.colspan, 0);
                if (n < t.length) {
                  let r = {
                    type: "placeholder",
                    key: "placeholder-" + e[e.length - 1].key,
                    colspan: t.length - n,
                    index: n,
                    value: null,
                    rendered: null,
                    level: s,
                    hasChildNodes: !1,
                    childNodes: [],
                    textValue: null,
                    prevKey: e[e.length - 1].key
                  };
                  e.push(r);
                }
                0;
              }
              return i.map((e, t) => ({
                type: "headerrow",
                key: "headerrow-" + t,
                index: t,
                value: null,
                rendered: null,
                level: 0,
                hasChildNodes: !0,
                childNodes: e,
                textValue: null
              }));
            }(s, i);
            u.forEach((e, t) => a.splice(t, 0, e)), super({
              columnCount: i.length,
              items: a,
              visitNode: e => (e.column = i[e.index], e)
            }), this._size = 0, this.columns = i, this.rowHeaderColumnKeys = o, this.body = r, this.headerRows = u, this._size = [...r.childNodes].length, 0 === this.rowHeaderColumnKeys.size && ((null == n ? void 0 : n.showSelectionCheckboxes) ? (null == n ? void 0 : n.showDragButtons) ? this.rowHeaderColumnKeys.add(this.columns[2].key) : this.rowHeaderColumnKeys.add(this.columns[1].key) : this.rowHeaderColumnKeys.add(this.columns[0].key));
          }
        }
        function Fb(e) {
          return null;
        }
        Fb.getCollectionNode = function* (e, t) {
          let {
            children: n,
            columns: r
          } = e;
          if (t.columns = [], "function" == typeof n) {
            if (!r) throw new Error("props.children was a function but props.columns is missing");
            for (let e of r) yield {
              type: "column",
              value: e,
              renderer: n
            };
          } else {
            let e = [];
            d.Children.forEach(n, t => {
              e.push({
                type: "column",
                element: t
              });
            }), yield* e;
          }
        };
        function Mb(e) {
          return null;
        }
        Mb.getCollectionNode = function* (e) {
          let {
            children: t,
            items: n
          } = e;
          yield {
            type: "body",
            hasChildNodes: !0,
            props: e,
            *childNodes() {
              if ("function" == typeof t) {
                if (!n) throw new Error("props.children was a function but props.items is missing");
                for (let e of n) yield {
                  type: "item",
                  value: e,
                  renderer: t
                };
              } else {
                let e = [];
                d.Children.forEach(t, t => {
                  e.push({
                    type: "item",
                    element: t
                  });
                }), yield* e;
              }
            }
          };
        };
        function Rb(e) {
          return null;
        }
        Rb.getCollectionNode = function* (e, t) {
          let {
              title: n,
              children: r,
              childColumns: o
            } = e,
            i = n || r,
            a = e.textValue || ("string" == typeof i ? i : "") || e["aria-label"],
            s = yield {
              type: "column",
              hasChildNodes: !!o || n && d.Children.count(r) > 0,
              rendered: i,
              textValue: a,
              props: e,
              *childNodes() {
                if (o) for (let e of o) yield {
                  type: "column",
                  value: e
                };else if (n) {
                  let e = [];
                  d.Children.forEach(r, t => {
                    e.push({
                      type: "column",
                      element: t
                    });
                  }), yield* e;
                }
              },
              shouldInvalidate: e => (l(e), !1)
            },
            l = e => {
              for (let t of s) t.hasChildNodes || e.columns.push(t);
            };
          l(t);
        };
        function jb(e) {
          return null;
        }
        jb.getCollectionNode = function* (e, t) {
          let {
            children: n,
            textValue: r,
            UNSTABLE_childItems: o
          } = e;
          yield {
            type: "item",
            props: e,
            textValue: r,
            "aria-label": e["aria-label"],
            hasChildNodes: !0,
            *childNodes() {
              if (t.showDragButtons && (yield {
                type: "cell",
                key: "header-drag",
                props: {
                  isDragButtonCell: !0
                }
              }), t.showSelectionCheckboxes && "none" !== t.selectionMode && (yield {
                type: "cell",
                key: "header",
                props: {
                  isSelectionCell: !0
                }
              }), "function" == typeof n) {
                for (let e of t.columns) yield {
                  type: "cell",
                  element: n(e.key),
                  key: e.key
                };
                if (o) for (let e of o) yield {
                  type: "item",
                  value: e
                };
              } else {
                let e = [],
                  r = [];
                if (d.Children.forEach(n, n => {
                  if (n.type === jb) {
                    if (e.length < t.columns.length) throw new Error("All of a Row's child Cells must be positioned before any child Rows.");
                    r.push({
                      type: "item",
                      element: n
                    });
                  } else e.push({
                    type: "cell",
                    element: n
                  });
                }), e.length !== t.columns.length) throw new Error(`Cell count must match column count. Found ${e.length} cells and ${t.columns.length} columns.`);
                yield* e, yield* r;
              }
            },
            shouldInvalidate: e => e.columns.length !== t.columns.length || e.columns.some((e, n) => e.key !== t.columns[n].key) || e.showSelectionCheckboxes !== t.showSelectionCheckboxes || e.showDragButtons !== t.showDragButtons || e.selectionMode !== t.selectionMode
          };
        };
        function Bb(e) {
          return null;
        }
        Bb.getCollectionNode = function* (e) {
          let {
              children: t
            } = e,
            n = e.textValue || ("string" == typeof t ? t : "") || e["aria-label"] || "";
          yield {
            type: "cell",
            props: e,
            rendered: t,
            textValue: n,
            "aria-label": e["aria-label"],
            hasChildNodes: !1
          };
        };
        class Nb {
          *[Symbol.iterator]() {
            yield* this.iterable;
          }
          get size() {
            return this.keyMap.size;
          }
          getKeys() {
            return this.keyMap.keys();
          }
          getKeyBefore(e) {
            let t = this.keyMap.get(e);
            return t ? t.prevKey : null;
          }
          getKeyAfter(e) {
            let t = this.keyMap.get(e);
            return t ? t.nextKey : null;
          }
          getFirstKey() {
            return this.firstKey;
          }
          getLastKey() {
            return this.lastKey;
          }
          getItem(e) {
            return this.keyMap.get(e);
          }
          at(e) {
            const t = [...this.getKeys()];
            return this.getItem(t[e]);
          }
          constructor(e, {
            expandedKeys: t
          } = {}) {
            this.keyMap = new Map(), this.iterable = e, t || new Set();
            let n,
              r = e => {
                if (this.keyMap.set(e.key, e), e.childNodes && ("section" === e.type || t.has(e.key))) for (let t of e.childNodes) r(t);
              };
            for (let t of e) r(t);
            let o = 0;
            for (let [e, t] of this.keyMap) n ? (n.nextKey = e, t.prevKey = n.key) : (this.firstKey = e, t.prevKey = void 0), "item" === t.type && (t.index = o++), t, n.nextKey = void 0;
            this.lastKey = null == n ? void 0 : n.key;
          }
        }
        var Lb = n(9327),
          Vb = n.n(Lb),
          Kb = n(93767),
          qb = n(92619),
          Hb = n.n(qb);
        const Ub = n(71623).Z,
          Zb = e => {
            let {
              isExpanded: t,
              title: n,
              id: r,
              isSelected: o = !1,
              isVisible: i,
              onAction: a,
              radioGroupsIDs: s,
              lockedOCGs: l,
              hasChildren: u,
              level: c,
              indentUnit: p,
              isAncestorHidden: h,
              isAncestorLocked: f,
              componentClassName: m,
              iconsAlignment: g
            } = e;
            const {
                pressProps: v
              } = (0, yb.r7)({
                onPress: () => {
                  null == a || a({
                    action: "toggleSelection",
                    key: r
                  });
                }
              }),
              {
                pressProps: y
              } = (0, yb.r7)({
                onPress: () => {
                  null == a || a({
                    action: "toggleExpanded",
                    key: r
                  });
                }
              }),
              {
                pressProps: b
              } = (0, yb.r7)({
                onPress: () => {
                  D || f || E || null == a || a({
                    action: "toggleVisibility",
                    key: r
                  });
                }
              }),
              {
                pressProps: w
              } = (0, yb.r7)({
                onPress: () => {
                  f || null == a || a({
                    action: "toggleLock",
                    key: r
                  });
                }
              }),
              x = t ? "chevron-down-filled" : "chevron-right-filled",
              D = (null == l ? void 0 : l.includes(Number(r))) || !1,
              C = r.startsWith("noid-"),
              S = (null == s ? void 0 : s.includes(Number(r))) || !1,
              E = !D && S && (null == s ? void 0 : s.some(e => null == l ? void 0 : l.includes(e))),
              _ = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                  t = arguments.length > 1 ? arguments[1] : void 0,
                  n = arguments.length > 2 ? arguments[2] : void 0,
                  r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                if (e) return "ancestor-hidden";
                if (r) return null;
                if (t && !n) return "eye-open";
                if (t && n) return "checked-radio-group";
                if (!t && !n) return "eye-close";
                if (!t && n) return "unchecked-radio-group";
                return null;
              }(h, i, S, C),
              P = function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                  t = arguments.length > 1 ? arguments[1] : void 0,
                  n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (e || n) return "ancestor-locked";
                if (t) return "ocg-lock";
                return "ocg-unlock";
              }(f, D, E),
              k = !i && !C,
              A = d.createElement(d.Fragment, null, C ? d.createElement($b, {
                indentUnit: p,
                level: 1,
                className: `${m}-TreeItem-Spacer`
              }) : d.createElement("div", (0, ce.Z)({
                role: "button"
              }, w), d.createElement(Ub, {
                type: P,
                className: Vb()(Hb().icon, Hb().iconContainer, `${m}-TreeItem-LockIcon`, `${m}-TreeItem-LockIcon-${P}`, {
                  [Hb().notLocked]: !D && !f && !E
                })
              })), _ ? d.createElement("div", (0, ce.Z)({
                role: "button"
              }, b), d.createElement(Ub, {
                type: _,
                className: Vb()(Hb().icon, Hb().iconContainer, Hb()[`icon-${_}`], `${m}-TreeItem-VisibilityIcon`, `${m}-TreeItem-VisibilityIcon-${_}`, {
                  [Hb().visibilityIconLocked]: (D || f) && !k
                })
              })) : d.createElement($b, {
                indentUnit: p,
                level: 1,
                className: `${m}-TreeItem-Spacer`
              }));
            return d.createElement("div", {
              className: Vb()(Hb().treeItem, `${m}-TreeItem`, {
                [Hb().hidden]: k,
                [Hb().selected]: o,
                [Hb().locked]: D
              })
            }, g === Kb.v.START && A, u ? d.createElement("div", y, d.createElement(Ub, {
              type: x,
              className: Vb()(Hb().arrowIcon, Hb().iconContainer, `${m}-TreeItem-ExpandIcon`)
            })) : d.createElement($b, {
              indentUnit: p,
              level: c
            }), d.createElement("p", (0, ce.Z)({}, v, {
              className: Vb()(Hb().treeItem, Hb().visibilityIcon, Hb().title, `${m}-TreeItem-Title`, {
                [Hb().noOcgId]: C
              }),
              style: {
                width: `calc(100% - ${(c + 2) * p}px)`
              }
            }), d.createElement("span", {
              className: Hb().textWithOverflowEllipsis
            }, n)), g === Kb.v.END && A);
          };
        function $b(e) {
          let {
            level: t,
            indentUnit: n,
            className: r
          } = e;
          return d.createElement("div", {
            className: Vb()(Hb().noChildrenSpacer, r),
            style: {
              width: t * n
            }
          });
        }
        Zb.displayName = "TreeItem";
        const Gb = ["tree", "onAction", "defaultExpandedKeys", "visibleOCGs", "lockedOCGs", "radioGroupsIDs", "indentUnit", "componentClassName", "iconsAlignment"],
          Wb = d.forwardRef((e, t) => {
            let {
                tree: n,
                onAction: r,
                defaultExpandedKeys: o,
                visibleOCGs: i,
                lockedOCGs: a,
                radioGroupsIDs: l,
                indentUnit: c,
                componentClassName: p,
                iconsAlignment: h
              } = e,
              f = (0, ne.Z)(e, Gb);
            const m = (0, yb.Me)(),
              g = (0, yb.bO)();
            (0, u.kG)(g);
            const [v, y] = d.useState((0, s.l4)(o || [])),
              [b, w] = d.useState(null),
              {
                focusWithinProps: x
              } = (0, yb.L_)({
                onFocusWithin: () => {
                  null === b && (g.focusFirst(), w(n.items[0].key));
                }
              }),
              {
                keyboardProps: D
              } = (0, yb.v5)({
                onKeyDown: e => {
                  const t = e.target,
                    o = t.dataset.key,
                    i = n.getItem(o),
                    a = i.children.length > 0;
                  switch (e.key) {
                    case "Home":
                      {
                        const e = g.focusFirst();
                        w((null == e ? void 0 : e.dataset.key) || b);
                        break;
                      }
                    case "End":
                      {
                        const e = g.focusLast();
                        w((null == e ? void 0 : e.dataset.key) || b);
                        break;
                      }
                    case "ArrowDown":
                      {
                        const e = g.focusNext({
                          from: t,
                          wrap: !0
                        });
                        w((null == e ? void 0 : e.dataset.key) || b);
                        break;
                      }
                    case "ArrowUp":
                      {
                        const e = g.focusPrevious({
                          from: t,
                          wrap: !0
                        });
                        w((null == e ? void 0 : e.dataset.key) || b);
                        break;
                      }
                    case "ArrowRight":
                      if (o && a) if (v.has(o)) {
                        const e = g.focusNext({
                          from: t
                        });
                        w((null == e ? void 0 : e.dataset.key) || b);
                      } else y(e => (0, s.l4)(e.add(o)));
                      break;
                    case "ArrowLeft":
                      if (o) if (v.has(o) && a) y(e => (0, s.l4)([...e].filter(e => e !== o)));else if (i.parentKey) {
                        var l;
                        const e = g.focusNext({
                          from: null === (l = t.closest("ul")) || void 0 === l ? void 0 : l.closest("li")
                        });
                        w((null == e ? void 0 : e.dataset.key) || b);
                      }
                      break;
                    case "Enter":
                    case " ":
                      o && (null == r || r({
                        action: "toggleVisibility",
                        key: o
                      }));
                  }
                }
              }),
              C = (0, d.useCallback)(e => {
                v.has(e) ? y(t => (0, s.l4)([...t].filter(t => t !== e))) : y(t => (0, s.l4)(t.add(e)));
              }, [y, v]),
              S = (0, d.useCallback)(e => {
                let {
                  action: t,
                  key: n
                } = e;
                "toggleExpanded" === t ? C(n) : "toggleSelection" === t && w(b === n ? null : n), null == r || r({
                  action: t,
                  key: n
                });
              }, [r, C, b, w]),
              E = (0, d.useCallback)(function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : n.items,
                  t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
                  {
                    isAncestorHidden: r,
                    isAncestorLocked: o
                  } = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                return e.map(e => {
                  const n = e.key.startsWith("noid-"),
                    s = (null == i ? void 0 : i.includes(e.key)) || n,
                    u = b === e.key,
                    f = v.has(e.key),
                    g = (null == a ? void 0 : a.includes(Number(e.key))) || !1,
                    y = `${m}-${e.key}`;
                  return e.children.length ? d.createElement("li", {
                    key: e.key,
                    className: Vb()(Hb().list, Hb().parentArrow, Hb().treeItemContainer, Hb().itemContentContainer, {
                      [Hb().selected]: u,
                      [Hb().locked]: g
                    }),
                    role: "treeitem",
                    "aria-selected": u,
                    tabIndex: 0,
                    "data-key": e.key,
                    "aria-expanded": f,
                    "aria-owns": y
                  }, d.createElement(Zb, {
                    id: e.key,
                    title: e.value.title,
                    isExpanded: v.has(e.key),
                    isFocused: null === b || b === e.key,
                    isSelected: b === e.key,
                    onAction: S,
                    isVisible: s,
                    lockedOCGs: a,
                    hasChildren: e.children.length > 0,
                    level: t,
                    indentUnit: c,
                    isAncestorHidden: r,
                    isAncestorLocked: o,
                    componentClassName: p,
                    iconsAlignment: h
                  }), d.createElement("ul", {
                    className: Vb()(Hb().childRoot, {
                      [Hb().hiddenChildRoot]: !v.has(e.key)
                    }),
                    id: y,
                    role: "group"
                  }, E(e.children, t + 1, {
                    isAncestorHidden: !s,
                    isAncestorLocked: g
                  }))) : d.createElement("li", {
                    key: e.key,
                    className: Vb()(Hb().treeItemContainer, Hb().list, Hb().itemWithNoChildren, {
                      [Hb().selected]: u
                    }),
                    role: "treeitem",
                    "aria-selected": u,
                    tabIndex: 0,
                    "data-key": e.key,
                    "aria-expanded": f,
                    "aria-owns": y
                  }, d.createElement(Zb, {
                    id: e.key,
                    title: e.value.title,
                    isFocused: null === b || b === e.key,
                    isSelected: !1,
                    onAction: S,
                    isVisible: s,
                    radioGroupsIDs: l,
                    lockedOCGs: a,
                    level: t,
                    indentUnit: c,
                    isAncestorHidden: r,
                    isAncestorLocked: o,
                    componentClassName: p,
                    iconsAlignment: h
                  }));
                });
              }, [n, v, b, i, m, a, l, c, S, p, h]),
              _ = d.useMemo(() => E(), [E]);
            return d.createElement("ul", (0, ce.Z)({}, (0, yb.dG)(D, x, f), {
              role: "tree",
              ref: t,
              className: Hb().treeView
            }), _);
          });
        Wb.displayName = "TreeViewBase";
        const Yb = ["items", "defaultExpandedKeys", "visibleOCGs", "lockedOCGs", "radioGroupsIDs", "componentClassName"],
          Xb = d.forwardRef((e, t) => {
            let {
                items: n,
                defaultExpandedKeys: r,
                visibleOCGs: o,
                lockedOCGs: i,
                radioGroupsIDs: a,
                componentClassName: s
              } = e,
              l = (0, ne.Z)(e, Yb);
            const u = Pb({
                initialItems: n,
                getKey: e => e.id,
                getChildren: e => e.children || []
              }),
              c = (0, d.useCallback)(function (e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                for (const n of e) t.push(n.key), c(n.children, t);
                return t;
              }, []),
              p = d.useMemo(() => "all" === r ? c(u.items) : Array.isArray(r) ? r : void 0, [u, r, c]);
            return d.createElement(yb.MT, null, d.createElement(Wb, (0, ce.Z)({}, l, {
              defaultExpandedKeys: p,
              tree: u,
              visibleOCGs: o,
              ref: t,
              radioGroupsIDs: a,
              lockedOCGs: i,
              componentClassName: s || "TreeView"
            })));
          });
        Xb.displayName = "TreeView";
        var Qb,
          Jb = n(14578),
          ew = n.n(Jb);
        function tw(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function nw(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? tw(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : tw(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function rw(e) {
          var t;
          const {
              sidebarOptions: n,
              setSidebarOptions: r,
              visibleLayers: o,
              OCGLayers: i
            } = e,
            {
              lockedLayers: a,
              iconsAlignment: c
            } = n,
            p = (0, l.I0)(),
            {
              formatMessage: f
            } = (0, xe.YB)(),
            [m, g] = d.useState((0, s.l4)(o.map(e => e.toString()))),
            [v, y] = d.useState(a);
          d.useEffect(() => {
            (function (e, t) {
              if (e.length !== t.length) return !1;
              for (let n = 0; n < e.length; n++) if (e[n] !== t[n]) return !1;
              return !0;
            })(a, v) || y(a);
          }, [a]), d.useEffect(() => {
            const e = (0, s.l4)(o.map(e => e.toString()));
            m.equals(e) || g(e);
          }, [o]);
          const b = (null !== (t = null == i ? void 0 : i.filter(e => !dw(e) && "number" == typeof e.radioGroup)) && void 0 !== t ? t : []).map(e => e.ocgId).filter(e => "number" == typeof e),
            w = d.useCallback(e => {
              let {
                action: t,
                key: o
              } = e;
              if ("toggleVisibility" === t) {
                (0, u.kG)(i), (0, u.kG)(m);
                const e = hw(i, Number(o));
                if (!e) return;
                const t = m.toArray();
                if (m.includes(o)) {
                  if (e && dw(e)) {
                    const t = aw(e, o, m, a);
                    p((0, El.Nx)({
                      visibleLayerIds: t.toArray().map(e => Number(e))
                    }));
                  } else {
                    const {
                      currentVisibleOCGs: e
                    } = sw(t, o);
                    p((0, El.Nx)(e));
                    const n = m.delete(o);
                    g(n);
                  }
                } else if (e && dw(e)) {
                  const {
                    currentVisibleOCGs: t,
                    newVisibleOCGs: n
                  } = lw(e, o, m, i);
                  g(n), p((0, El.Nx)(t));
                } else if (null != b && b.includes(Number(o))) {
                  const {
                    currentVisibleOCGs: e,
                    newVisibleOCGs: t
                  } = cw(o, b, m);
                  g(t), p((0, El.Nx)(e));
                } else {
                  const e = uw(i, Number(o)),
                    n = m.add(o).union(e);
                  g(n), t.push(o);
                  const r = {
                    visibleLayerIds: t.concat(e).map(e => Number(e))
                  };
                  p((0, El.Nx)(r));
                }
              } else if ("toggleLock" === t) {
                const e = v.includes(Number(o)) ? v.filter(e => e !== Number(o)) : v.concat(Number(o));
                r(nw(nw({}, n), {}, {
                  lockedLayers: e
                }));
              }
            }, [i, m, p, a, n, b, v, r]);
          if (!i) return d.createElement("div", {
            className: h()(ew().OCGsContainer, "PSPDFKit-Sidebar-Layers")
          }, Qb || (Qb = d.createElement(Be.Z, null)));
          if (0 === i.length) return d.createElement("div", {
            className: h()(ew().OCGsContainer, "PSPDFKit-Sidebar-Layers")
          }, d.createElement("div", {
            className: h()("PSPDFKit-Sidebar-Layers-Header")
          }, d.createElement("div", {
            className: h()(ou.empty, "PSPDFKit-Sidebar-Empty")
          }, f(ke.Z.noLayers))));
          const x = ow(i);
          return d.createElement("div", {
            className: h()(ew().OCGsContainer, "PSPDFKit-Sidebar-Layers")
          }, d.createElement("div", {
            className: h()(ew().title, "PSPDFKit-Sidebar-Layers-Header")
          }, f(ke.Z.layers)), d.createElement(Xb, {
            items: x,
            visibleOCGs: m,
            onAction: w,
            lockedOCGs: v,
            radioGroupsIDs: b,
            indentUnit: 32,
            componentClassName: "PSPDFKit-Layers",
            iconsAlignment: c
          }));
        }
        const ow = e => e.map(e => iw(e));
        function iw(e) {
          var t;
          return {
            id: (null === (t = e.ocgId) || void 0 === t ? void 0 : t.toString()) || `noid-${(0, Fa.C)()}`,
            title: e.name || "",
            description: e.name,
            children: dw(e) ? e.layers.map(e => iw(e)) : []
          };
        }
        const aw = (e, t, n, r) => {
            const o = [...(null == e ? void 0 : e.layers.filter(e => !r.includes(e.ocgId)).map(e => e.ocgId)), Number(t)].map(e => e.toString()),
              i = n.filter(e => !o.includes(e));
            return i;
          },
          sw = (e, t) => ({
            currentVisibleOCGs: {
              visibleLayerIds: e.map(e => Number(e)).filter(e => e !== Number(t))
            }
          }),
          lw = (e, t, n, r) => {
            const o = [...(null == e ? void 0 : e.layers.map(e => {
                var t;
                return null === (t = e.ocgId) || void 0 === t ? void 0 : t.toString();
              })), t],
              i = (0, s.l4)([...o, ...n, ...uw(r, Number(t))]);
            return {
              currentVisibleOCGs: pw(i),
              newVisibleOCGs: i
            };
          },
          uw = (e, t) => {
            if (!e) return [];
            const n = [];
            return e.forEach(e => {
              dw(e) && ("number" == typeof e.ocgId && e.layers.some(e => e.ocgId === t) ? n.push(e.ocgId.toString()) : n.push(...uw(e.layers, t)));
            }), n;
          },
          cw = (e, t, n) => {
            const r = n.find(e => t.includes(Number(e))),
              o = r ? n.add(e).delete(r) : n.add(e);
            return {
              currentVisibleOCGs: pw(o),
              newVisibleOCGs: o
            };
          };
        function dw(e) {
          return "layers" in e;
        }
        const pw = e => ({
          visibleLayerIds: e.toArray().map(e => Number(e))
        });
        function hw(e, t) {
          const n = e.find(e => e.ocgId === t);
          if (n) return n;
          for (const n of e) if (dw(n)) {
            const e = hw(n.layers, t);
            if (e) return e;
          }
          return null;
        }
        var fw = n(8898),
          mw = n(8840),
          gw = n(33241),
          vw = n(81683);
        function yw(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function bw(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? yw(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yw(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function ww(e, t, n, r) {
          let o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {};
          const {
            content: i,
            decorator: a
          } = vw.m[e]({
            props: n,
            instance: r
          });
          (0, mw.kG)(i, "defaultContent is required"), (0, mw.kG)(a, "defaultDecorator is required");
          const {
              content: s,
              decorator: l
            } = t({
              props: n,
              instance: r
            }),
            u = s || i,
            c = u instanceof Node ? d.createElement(Wl.DomNodeRenderer, {
              node: u
            }) : u,
            p = l ? l(bw(bw({}, o), {}, {
              children: c
            })) : a(bw(bw({}, o), {}, {
              children: c
            }));
          return p instanceof Node ? d.createElement(Wl.DomNodeRenderer, {
            node: p
          }) : p;
        }
        const xw = e => {
          let {
            onCreate: t,
            onDelete: n,
            onCancel: r,
            storedSignatures: o,
            setIsSignaturePickerHidden: i
          } = e;
          const a = (0, yb.Me)(),
            {
              formatMessage: s
            } = (0, xe.YB)(),
            u = (0, l.v9)(e => e.ui[gw.x.SignaturesList]),
            c = (0, l.v9)(e => e.instance),
            p = (0, l.v9)(e => e.backend),
            h = (0, l.v9)(e => e.attachments),
            f = (0, d.useMemo)(() => (null == o ? void 0 : o.map(e => ({
              svgSrc: e instanceof de.Zc ? d.createElement(pt, {
                isSelectable: !1,
                annotation: e,
                viewBox: e.boundingBox
              }) : d.createElement(pg, {
                annotation: e,
                backend: p,
                label: e.description || s(ke.Z.imageAnnotation),
                attachment: e.imageAttachmentId ? h.get(e.imageAttachmentId) : null,
                templateWidth: 200
              }),
              id: e.id || (0, Fa.C)()
            })).toArray()) || [], [o, s, p, h]),
            m = (0, d.useMemo)(() => null == f ? void 0 : f.map((e, t) => ({
              id: e.id,
              annotation: null == o ? void 0 : o.get(t)
            })), [o, f]),
            g = (0, d.useCallback)(e => {
              const n = m.find(t => t.id === e);
              (0, mw.kG)(null == n ? void 0 : n.annotation, "Signature not found"), t(n.annotation, !1, !1);
            }, [t, m]),
            v = (0, d.useCallback)(e => {
              const t = m.find(t => t.id === e);
              (0, mw.kG)(null == t ? void 0 : t.annotation, "Signature not found"), n(t.annotation, !1);
            }, [n, m]),
            y = (0, d.useMemo)(() => ({
              titleId: a,
              items: f,
              onAddFromPreview: g,
              onRemoveFromPreview: v,
              onAdd: () => i(!0),
              onCancel: r
            }), [a, f, g, v, r, i]),
            b = (0, d.useMemo)(() => ({
              dialogProps: {
                size: "lg",
                "aria-labelledby": a
              },
              modalProps: {
                onOpenChange: r
              }
            }), [r, a]);
          return ww(gw.x.SignaturesList, u, y, c, b);
        };
        var Dw = n(73571);
        function Cw(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Sw(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Cw(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cw(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const Ew = e => {
            let {
              onCreate: t,
              preset: n,
              onCancel: r,
              colorPresets: o,
              frameWindow: i,
              signingFonts: a,
              hasSignaturesCreationListener: u,
              creationModes: c
            } = e;
            const p = (0, yb.Me)(),
              h = (0, l.I0)(),
              f = (0, l.v9)(e => {
                var t;
                return null === (t = e.ui) || void 0 === t ? void 0 : t[gw.x.CreateSignature];
              }),
              m = (0, l.v9)(e => e.instance),
              {
                formatMessage: g
              } = (0, xe.YB)();
            d.useEffect(() => {
              null != i && i.document.fonts && (0, vs.GE)(a, i.document.fonts);
            }, [a, null == i ? void 0 : i.document.fonts]);
            const v = (0, l.v9)(e => {
                var t;
                return (null === (t = e.electronicSignatureDefaultTextCallback) || void 0 === t ? void 0 : t.call(e)) || "";
              }),
              y = d.useCallback(e => {
                (async (r, o) => {
                  if ((null === (r = e.signature) || void 0 === r ? void 0 : r.type) === Dw.BL.DRAW) {
                    (0, mw.kG)(e.signature.value, "Signature value is required");
                    const r = (0, s.aV)(e.signature.value.map(e => (0, s.aV)(e.map(e => {
                      let [t, n, r] = e;
                      return new E.Wm({
                        x: t,
                        y: n,
                        intensity: r
                      });
                    }))));
                    let o = new de.Zc(Sw(Sw({}, n), {}, {
                      lines: r,
                      isSignature: !0,
                      strokeColor: _.Il.fromHex(e.color)
                    }));
                    o = o.set("boundingBox", (0, ot.gz)(o));
                    const i = (0, mi.c)(o, o.boundingBox.getLocation().scale(-1), new E.$u(e.canvasSize), new E.E9());
                    t(i, e.shouldStoreSignature, !1);
                  } else if ((null === (o = e.signature) || void 0 === o ? void 0 : o.type) === Dw.BL.IMAGE) (0, mw.kG)(e.signature.value, "Signature value is required"), t(e.signature.value, e.shouldStoreSignature, !1);else {
                    var a;
                    const r = new de.gd(Sw(Sw({}, n), {}, {
                        font: e.selectedFont,
                        fontSize: 16,
                        text: {
                          format: "plain",
                          value: (null === (a = e.signature) || void 0 === a ? void 0 : a.value) || v
                        },
                        fontColor: _.Il.fromHex(e.color)
                      })),
                      o = await (0, Me.Y)(r.text.value, {
                        font: r.font,
                        fontColor: r.fontColor
                      }, i);
                    h((0, yt.gX)({
                      fontColor: r.fontColor,
                      font: r.font
                    })), t(o, e.shouldStoreSignature, !1);
                  }
                })();
              }, [t, n, h, i, v]),
              b = (0, d.useMemo)(() => ({
                titleId: p,
                colorPresets: o.map(e => {
                  var t;
                  return {
                    color: (null === (t = e.color) || void 0 === t ? void 0 : t.toHex()) || "",
                    label: g(e.localization)
                  };
                }),
                allowStoringSignature: u,
                allowedTabs: c.toArray(),
                fonts: a.map(e => e.name).toJS(),
                onCloseRequest: r,
                initialState: {
                  shouldStoreSignature: u,
                  text: v
                },
                onAdd: y
              }), [p, o, v, u, c, a, r, y, g]),
              w = (0, d.useMemo)(() => ({
                dialogProps: {
                  size: "lg",
                  "aria-labelledby": p
                },
                modalProps: {
                  onOpenChange: r
                },
                modalContentProps: {
                  disableAnimation: !0
                }
              }), [p, r]);
            return ww(gw.x.CreateSignature, f, b, m, w);
          },
          _w = ["storedSignatures"],
          Pw = e => {
            let {
                storedSignatures: t
              } = e,
              n = (0, ne.Z)(e, _w);
            const [r, o] = d.useState(!1);
            return !r && Boolean(t && t.size > 0) ? d.createElement(xw, (0, ce.Z)({}, n, {
              setIsSignaturePickerHidden: o,
              storedSignatures: t
            })) : d.createElement(Ew, n);
          };
        var kw = n(29977);
        var Aw = n(85816),
          zw = n(4280);
        function Tw(e) {
          let {
            onCancel: t,
            onCreate: n,
            dispatch: r,
            backend: o,
            stampAnnotationTemplates: i,
            viewportWidth: a,
            attachments: s
          } = e;
          const u = (0, yb.Me)(),
            c = (0, l.v9)(e => e.ui[gw.x.StampsList]),
            p = (0, l.v9)(e => e.instance),
            h = function (e) {
              let {
                stampAnnotationTemplates: t
              } = e;
              const n = (0, xe.YB)();
              return (0, d.useMemo)(() => {
                const e = t.map(e => (e instanceof _.GI && (null == e.title && (e = e.set("title", (0, Aa.vW)({
                  annotation: e,
                  intl: n
                }))), e.subtitle && "Custom" === e.stampType || (e = e.set("subtitle", (0, Aa.Cq)(kw.pY[e.stampType], new Date(), n))), void 0 !== kw.a$[e.stampType] && (e = e.set("stampType", kw.a$[e.stampType]))), e));
                return Object.fromEntries(e.map(e => [(0, j.xc)(), e]));
              }, [n, t]);
            }({
              stampAnnotationTemplates: i
            }),
            f = function (e) {
              let {
                viewportWidth: t,
                backend: n,
                attachments: r,
                annotations: o
              } = e;
              const i = (0, xe.YB)();
              return (0, d.useMemo)(() => {
                const {
                  formatMessage: e
                } = i;
                return Object.entries(o).map(t => {
                  let [o, a] = t;
                  return {
                    id: o,
                    "aria-label": (0, Aa.vW)({
                      annotation: a,
                      intl: i
                    }),
                    svgSrc: d.createElement("div", {
                      key: o,
                      className: (0, Aw.Kj)({
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "background.primary.medium",
                        paddingX: "xl",
                        height: "full",
                        flex: 1
                      })
                    }, d.createElement(pg, {
                      annotation: a,
                      backend: n,
                      label: a instanceof _.sK ? e(ke.Z.imageAnnotation) : a.title || e(zw.Z[(0, F.LE)((0, kw.k1)(a.stampType))]),
                      attachment: a.imageAttachmentId ? r.get(a.imageAttachmentId) : null,
                      templateWidth: 0,
                      contain: !0
                    }))
                  };
                });
              }, [i, n, o, t, r]);
            }({
              viewportWidth: a,
              backend: o,
              attachments: s,
              annotations: h
            }),
            m = (0, d.useCallback)(e => {
              const t = h[e];
              t && n(t);
            }, [h, n]),
            g = (0, d.useMemo)(() => ({
              titleId: u,
              items: f,
              onCustomStampPress: () => {
                r((0, Kt._z)());
              },
              onCancel: t,
              onAdd: m
            }), [u, f, t, m, r]),
            v = (0, d.useMemo)(() => ({
              dialogProps: {
                "aria-labelledby": u
              },
              modalProps: {
                onOpenChange: t
              },
              modalContentProps: {
                disableAnimation: !0
              }
            }), [t, u]);
          return ww(gw.x.StampsList, c, g, p, v);
        }
        function Ow(e) {
          let {
            onCancel: t,
            onCreate: n,
            dispatch: r
          } = e;
          const o = (0, yb.Me)(),
            i = (0, l.v9)(e => e.ui[gw.x.CreateStamp]),
            a = (0, l.v9)(e => e.instance),
            s = (0, d.useCallback)(e => {
              let {
                text: t,
                subText: r,
                color: o,
                width: i
              } = e;
              const a = new _.GI({
                stampType: "Custom",
                title: null != t ? t : "",
                subtitle: r,
                color: _.Il.fromHex(o),
                boundingBox: new _.UL({
                  left: 0,
                  top: 0,
                  width: i,
                  height: Ne.mM
                })
              });
              n(a);
            }, [n]),
            u = (0, d.useMemo)(() => ({
              titleId: o,
              colorPresets: Aa.s3,
              onCreate: s,
              onCloseRequest: t,
              getLighterVariant: e => _.Il.fromHex(e).lighter(Ne.zT).toHex(),
              onExistingStampPress: () => {
                r((0, Kt.C4)());
              }
            }), [o, t, r, s]),
            c = (0, d.useMemo)(() => ({
              dialogProps: {
                "aria-labelledby": o
              },
              modalProps: {
                onOpenChange: t
              }
            }), [o, t]);
          return ww(gw.x.CreateStamp, i, u, a, c);
        }
        function Iw(e) {
          let {
            onCancel: t,
            onCreate: n,
            mode: r,
            dispatch: o,
            backend: i,
            stampAnnotationTemplates: a,
            viewportWidth: s,
            attachments: l
          } = e;
          return d.createElement(d.Fragment, null, r === B.A.STAMP_PICKER && d.createElement(Tw, {
            attachments: l,
            onCreate: n,
            onCancel: t,
            stampAnnotationTemplates: a,
            backend: i,
            dispatch: o,
            viewportWidth: s
          }), r === B.A.STAMP_CUSTOM && d.createElement(Ow, {
            onCreate: n,
            onCancel: t,
            dispatch: o
          }));
        }
        var Fw = n(77017);
        var Mw = n(96650);
        const Rw = Object.create(null);
        Rw.open = "0", Rw.close = "1", Rw.ping = "2", Rw.pong = "3", Rw.message = "4", Rw.upgrade = "5", Rw.noop = "6";
        const jw = Object.create(null);
        Object.keys(Rw).forEach(e => {
          jw[Rw[e]] = e;
        });
        const Bw = {
            type: "error",
            data: "parser error"
          },
          Nw = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === Object.prototype.toString.call(Blob),
          Lw = "function" == typeof ArrayBuffer,
          Vw = e => "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer,
          Kw = ({
            type: e,
            data: t
          }, n, r) => Nw && t instanceof Blob ? n ? r(t) : qw(t, r) : Lw && (t instanceof ArrayBuffer || Vw(t)) ? n ? r(t) : qw(new Blob([t]), r) : r(Rw[e] + (t || "")),
          qw = (e, t) => {
            const n = new FileReader();
            return n.onload = function () {
              const e = n.result.split(",")[1];
              t("b" + (e || ""));
            }, n.readAsDataURL(e);
          };
        function Hw(e) {
          return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
        }
        let Uw;
        const Zw = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
          $w = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256);
        for (let e = 0; e < Zw.length; e++) $w[Zw.charCodeAt(e)] = e;
        const Gw = "function" == typeof ArrayBuffer,
          Ww = (e, t) => {
            if ("string" != typeof e) return {
              type: "message",
              data: Xw(e, t)
            };
            const n = e.charAt(0);
            if ("b" === n) return {
              type: "message",
              data: Yw(e.substring(1), t)
            };
            return jw[n] ? e.length > 1 ? {
              type: jw[n],
              data: e.substring(1)
            } : {
              type: jw[n]
            } : Bw;
          },
          Yw = (e, t) => {
            if (Gw) {
              const n = (e => {
                let t,
                  n,
                  r,
                  o,
                  i,
                  a = .75 * e.length,
                  s = e.length,
                  l = 0;
                "=" === e[e.length - 1] && (a--, "=" === e[e.length - 2] && a--);
                const u = new ArrayBuffer(a),
                  c = new Uint8Array(u);
                for (t = 0; t < s; t += 4) n = $w[e.charCodeAt(t)], r = $w[e.charCodeAt(t + 1)], o = $w[e.charCodeAt(t + 2)], i = $w[e.charCodeAt(t + 3)], c[l++] = n << 2 | r >> 4, c[l++] = (15 & r) << 4 | o >> 2, c[l++] = (3 & o) << 6 | 63 & i;
                return u;
              })(e);
              return Xw(n, t);
            }
            return {
              base64: !0,
              data: e
            };
          },
          Xw = (e, t) => "blob" === t ? e instanceof Blob ? e : new Blob([e]) : e instanceof ArrayBuffer ? e : e.buffer,
          Qw = String.fromCharCode(30);
        function Jw() {
          return new TransformStream({
            transform(e, t) {
              !function (e, t) {
                Nw && e.data instanceof Blob ? e.data.arrayBuffer().then(Hw).then(t) : Lw && (e.data instanceof ArrayBuffer || Vw(e.data)) ? t(Hw(e.data)) : Kw(e, !1, e => {
                  Uw || (Uw = new TextEncoder()), t(Uw.encode(e));
                });
              }(e, n => {
                const r = n.length;
                let o;
                if (r < 126) o = new Uint8Array(1), new DataView(o.buffer).setUint8(0, r);else if (r < 65536) {
                  o = new Uint8Array(3);
                  const e = new DataView(o.buffer);
                  e.setUint8(0, 126), e.setUint16(1, r);
                } else {
                  o = new Uint8Array(9);
                  const e = new DataView(o.buffer);
                  e.setUint8(0, 127), e.setBigUint64(1, BigInt(r));
                }
                e.data && "string" != typeof e.data && (o[0] |= 128), t.enqueue(o), t.enqueue(n);
              });
            }
          });
        }
        let ex;
        function tx(e) {
          return e.reduce((e, t) => e + t.length, 0);
        }
        function nx(e, t) {
          if (e[0].length === t) return e.shift();
          const n = new Uint8Array(t);
          let r = 0;
          for (let o = 0; o < t; o++) n[o] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
          return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
        }
        function rx(e) {
          if (e) return function (e) {
            for (var t in rx.prototype) e[t] = rx.prototype[t];
            return e;
          }(e);
        }
        rx.prototype.on = rx.prototype.addEventListener = function (e, t) {
          return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
        }, rx.prototype.once = function (e, t) {
          function n() {
            this.off(e, n), t.apply(this, arguments);
          }
          return n.fn = t, this.on(e, n), this;
        }, rx.prototype.off = rx.prototype.removeListener = rx.prototype.removeAllListeners = rx.prototype.removeEventListener = function (e, t) {
          if (this._callbacks = this._callbacks || {}, 0 == arguments.length) return this._callbacks = {}, this;
          var n,
            r = this._callbacks["$" + e];
          if (!r) return this;
          if (1 == arguments.length) return delete this._callbacks["$" + e], this;
          for (var o = 0; o < r.length; o++) if ((n = r[o]) === t || n.fn === t) {
            r.splice(o, 1);
            break;
          }
          return 0 === r.length && delete this._callbacks["$" + e], this;
        }, rx.prototype.emit = function (e) {
          this._callbacks = this._callbacks || {};
          for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
          if (n) {
            r = 0;
            for (var o = (n = n.slice(0)).length; r < o; ++r) n[r].apply(this, t);
          }
          return this;
        }, rx.prototype.emitReserved = rx.prototype.emit, rx.prototype.listeners = function (e) {
          return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
        }, rx.prototype.hasListeners = function (e) {
          return !!this.listeners(e).length;
        };
        const ox = "undefined" != typeof self ? self : "undefined" != typeof window ? window : Function("return this")();
        function ix(e, ...t) {
          return t.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
        }
        const ax = ox.setTimeout,
          sx = ox.clearTimeout;
        function lx(e, t) {
          t.useNativeTimers ? (e.setTimeoutFn = ax.bind(ox), e.clearTimeoutFn = sx.bind(ox)) : (e.setTimeoutFn = ox.setTimeout.bind(ox), e.clearTimeoutFn = ox.clearTimeout.bind(ox));
        }
        class ux extends Error {
          constructor(e, t, n) {
            super(e), this.description = t, this.context = n, this.type = "TransportError";
          }
        }
        class cx extends rx {
          constructor(e) {
            super(), this.writable = !1, lx(this, e), this.opts = e, this.query = e.query, this.socket = e.socket;
          }
          onError(e, t, n) {
            return super.emitReserved("error", new ux(e, t, n)), this;
          }
          open() {
            return this.readyState = "opening", this.doOpen(), this;
          }
          close() {
            return "opening" !== this.readyState && "open" !== this.readyState || (this.doClose(), this.onClose()), this;
          }
          send(e) {
            "open" === this.readyState && this.write(e);
          }
          onOpen() {
            this.readyState = "open", this.writable = !0, super.emitReserved("open");
          }
          onData(e) {
            const t = Ww(e, this.socket.binaryType);
            this.onPacket(t);
          }
          onPacket(e) {
            super.emitReserved("packet", e);
          }
          onClose(e) {
            this.readyState = "closed", super.emitReserved("close", e);
          }
          pause(e) {}
          createUri(e, t = {}) {
            return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
          }
          _hostname() {
            const e = this.opts.hostname;
            return -1 === e.indexOf(":") ? e : "[" + e + "]";
          }
          _port() {
            return this.opts.port && (this.opts.secure && Number(443 !== this.opts.port) || !this.opts.secure && 80 !== Number(this.opts.port)) ? ":" + this.opts.port : "";
          }
          _query(e) {
            const t = function (e) {
              let t = "";
              for (let n in e) e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
              return t;
            }(e);
            return t.length ? "?" + t : "";
          }
        }
        const dx = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""),
          px = {};
        let hx,
          fx = 0,
          mx = 0;
        function gx(e) {
          let t = "";
          do {
            t = dx[e % 64] + t, e = Math.floor(e / 64);
          } while (e > 0);
          return t;
        }
        function vx() {
          const e = gx(+new Date());
          return e !== hx ? (fx = 0, hx = e) : e + "." + gx(fx++);
        }
        for (; mx < 64; mx++) px[dx[mx]] = mx;
        let yx = !1;
        try {
          yx = "undefined" != typeof XMLHttpRequest && "withCredentials" in new XMLHttpRequest();
        } catch (e) {}
        const bx = yx;
        function wx(e) {
          const t = e.xdomain;
          try {
            if ("undefined" != typeof XMLHttpRequest && (!t || bx)) return new XMLHttpRequest();
          } catch (e) {}
          if (!t) try {
            return new ox[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
          } catch (e) {}
        }
        function xx() {}
        const Dx = null != new wx({
          xdomain: !1
        }).responseType;
        class Cx extends rx {
          constructor(e, t) {
            super(), lx(this, t), this.opts = t, this.method = t.method || "GET", this.uri = e, this.data = void 0 !== t.data ? t.data : null, this.create();
          }
          create() {
            var e;
            const t = ix(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
            t.xdomain = !!this.opts.xd;
            const n = this.xhr = new wx(t);
            try {
              n.open(this.method, this.uri, !0);
              try {
                if (this.opts.extraHeaders) {
                  n.setDisableHeaderCheck && n.setDisableHeaderCheck(!0);
                  for (let e in this.opts.extraHeaders) this.opts.extraHeaders.hasOwnProperty(e) && n.setRequestHeader(e, this.opts.extraHeaders[e]);
                }
              } catch (e) {}
              if ("POST" === this.method) try {
                n.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
              } catch (e) {}
              try {
                n.setRequestHeader("Accept", "*/*");
              } catch (e) {}
              null === (e = this.opts.cookieJar) || void 0 === e || e.addCookies(n), "withCredentials" in n && (n.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (n.timeout = this.opts.requestTimeout), n.onreadystatechange = () => {
                var e;
                3 === n.readyState && (null === (e = this.opts.cookieJar) || void 0 === e || e.parseCookies(n)), 4 === n.readyState && (200 === n.status || 1223 === n.status ? this.onLoad() : this.setTimeoutFn(() => {
                  this.onError("number" == typeof n.status ? n.status : 0);
                }, 0));
              }, n.send(this.data);
            } catch (e) {
              return void this.setTimeoutFn(() => {
                this.onError(e);
              }, 0);
            }
            "undefined" != typeof document && (this.index = Cx.requestsCount++, Cx.requests[this.index] = this);
          }
          onError(e) {
            this.emitReserved("error", e, this.xhr), this.cleanup(!0);
          }
          cleanup(e) {
            if (void 0 !== this.xhr && null !== this.xhr) {
              if (this.xhr.onreadystatechange = xx, e) try {
                this.xhr.abort();
              } catch (e) {}
              "undefined" != typeof document && delete Cx.requests[this.index], this.xhr = null;
            }
          }
          onLoad() {
            const e = this.xhr.responseText;
            null !== e && (this.emitReserved("data", e), this.emitReserved("success"), this.cleanup());
          }
          abort() {
            this.cleanup();
          }
        }
        if (Cx.requestsCount = 0, Cx.requests = {}, "undefined" != typeof document) if ("function" == typeof attachEvent) attachEvent("onunload", Sx);else if ("function" == typeof addEventListener) {
          addEventListener("onpagehide" in ox ? "pagehide" : "unload", Sx, !1);
        }
        function Sx() {
          for (let e in Cx.requests) Cx.requests.hasOwnProperty(e) && Cx.requests[e].abort();
        }
        const Ex = "function" == typeof Promise && "function" == typeof Promise.resolve ? e => Promise.resolve().then(e) : (e, t) => t(e, 0),
          _x = ox.WebSocket || ox.MozWebSocket,
          Px = "undefined" != typeof navigator && "string" == typeof navigator.product && "reactnative" === navigator.product.toLowerCase();
        const kx = {
            websocket: class extends cx {
              constructor(e) {
                super(e), this.supportsBinary = !e.forceBase64;
              }
              get name() {
                return "websocket";
              }
              doOpen() {
                if (!this.check()) return;
                const e = this.uri(),
                  t = this.opts.protocols,
                  n = Px ? {} : ix(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
                this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
                try {
                  this.ws = Px ? new _x(e, t, n) : t ? new _x(e, t) : new _x(e);
                } catch (e) {
                  return this.emitReserved("error", e);
                }
                this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
              }
              addEventListeners() {
                this.ws.onopen = () => {
                  this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
                }, this.ws.onclose = e => this.onClose({
                  description: "websocket connection closed",
                  context: e
                }), this.ws.onmessage = e => this.onData(e.data), this.ws.onerror = e => this.onError("websocket error", e);
              }
              write(e) {
                this.writable = !1;
                for (let t = 0; t < e.length; t++) {
                  const n = e[t],
                    r = t === e.length - 1;
                  Kw(n, this.supportsBinary, e => {
                    try {
                      this.ws.send(e);
                    } catch (e) {}
                    r && Ex(() => {
                      this.writable = !0, this.emitReserved("drain");
                    }, this.setTimeoutFn);
                  });
                }
              }
              doClose() {
                void 0 !== this.ws && (this.ws.close(), this.ws = null);
              }
              uri() {
                const e = this.opts.secure ? "wss" : "ws",
                  t = this.query || {};
                return this.opts.timestampRequests && (t[this.opts.timestampParam] = vx()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
              }
              check() {
                return !!_x;
              }
            },
            webtransport: class extends cx {
              get name() {
                return "webtransport";
              }
              doOpen() {
                "function" == typeof WebTransport && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
                  this.onClose();
                }).catch(e => {
                  this.onError("webtransport error", e);
                }), this.transport.ready.then(() => {
                  this.transport.createBidirectionalStream().then(e => {
                    const t = function (e, t) {
                        ex || (ex = new TextDecoder());
                        const n = [];
                        let r = 0,
                          o = -1,
                          i = !1;
                        return new TransformStream({
                          transform(a, s) {
                            for (n.push(a);;) {
                              if (0 === r) {
                                if (tx(n) < 1) break;
                                const e = nx(n, 1);
                                i = 128 == (128 & e[0]), o = 127 & e[0], r = o < 126 ? 3 : 126 === o ? 1 : 2;
                              } else if (1 === r) {
                                if (tx(n) < 2) break;
                                const e = nx(n, 2);
                                o = new DataView(e.buffer, e.byteOffset, e.length).getUint16(0), r = 3;
                              } else if (2 === r) {
                                if (tx(n) < 8) break;
                                const e = nx(n, 8),
                                  t = new DataView(e.buffer, e.byteOffset, e.length),
                                  i = t.getUint32(0);
                                if (i > Math.pow(2, 21) - 1) {
                                  s.enqueue(Bw);
                                  break;
                                }
                                o = i * Math.pow(2, 32) + t.getUint32(4), r = 3;
                              } else {
                                if (tx(n) < o) break;
                                const e = nx(n, o);
                                s.enqueue(Ww(i ? e : ex.decode(e), t)), r = 0;
                              }
                              if (0 === o || o > e) {
                                s.enqueue(Bw);
                                break;
                              }
                            }
                          }
                        });
                      }(Number.MAX_SAFE_INTEGER, this.socket.binaryType),
                      n = e.readable.pipeThrough(t).getReader(),
                      r = Jw();
                    r.readable.pipeTo(e.writable), this.writer = r.writable.getWriter();
                    const o = () => {
                      n.read().then(({
                        done: e,
                        value: t
                      }) => {
                        e || (this.onPacket(t), o());
                      }).catch(e => {});
                    };
                    o();
                    const i = {
                      type: "open"
                    };
                    this.query.sid && (i.data = `{"sid":"${this.query.sid}"}`), this.writer.write(i).then(() => this.onOpen());
                  });
                }));
              }
              write(e) {
                this.writable = !1;
                for (let t = 0; t < e.length; t++) {
                  const n = e[t],
                    r = t === e.length - 1;
                  this.writer.write(n).then(() => {
                    r && Ex(() => {
                      this.writable = !0, this.emitReserved("drain");
                    }, this.setTimeoutFn);
                  });
                }
              }
              doClose() {
                var e;
                null === (e = this.transport) || void 0 === e || e.close();
              }
            },
            polling: class extends cx {
              constructor(e) {
                if (super(e), this.polling = !1, "undefined" != typeof location) {
                  const t = "https:" === location.protocol;
                  let n = location.port;
                  n || (n = t ? "443" : "80"), this.xd = "undefined" != typeof location && e.hostname !== location.hostname || n !== e.port;
                }
                const t = e && e.forceBase64;
                this.supportsBinary = Dx && !t, this.opts.withCredentials && (this.cookieJar = void 0);
              }
              get name() {
                return "polling";
              }
              doOpen() {
                this.poll();
              }
              pause(e) {
                this.readyState = "pausing";
                const t = () => {
                  this.readyState = "paused", e();
                };
                if (this.polling || !this.writable) {
                  let e = 0;
                  this.polling && (e++, this.once("pollComplete", function () {
                    --e || t();
                  })), this.writable || (e++, this.once("drain", function () {
                    --e || t();
                  }));
                } else t();
              }
              poll() {
                this.polling = !0, this.doPoll(), this.emitReserved("poll");
              }
              onData(e) {
                ((e, t) => {
                  const n = e.split(Qw),
                    r = [];
                  for (let e = 0; e < n.length; e++) {
                    const o = Ww(n[e], t);
                    if (r.push(o), "error" === o.type) break;
                  }
                  return r;
                })(e, this.socket.binaryType).forEach(e => {
                  if ("opening" === this.readyState && "open" === e.type && this.onOpen(), "close" === e.type) return this.onClose({
                    description: "transport closed by the server"
                  }), !1;
                  this.onPacket(e);
                }), "closed" !== this.readyState && (this.polling = !1, this.emitReserved("pollComplete"), "open" === this.readyState && this.poll());
              }
              doClose() {
                const e = () => {
                  this.write([{
                    type: "close"
                  }]);
                };
                "open" === this.readyState ? e() : this.once("open", e);
              }
              write(e) {
                this.writable = !1, ((e, t) => {
                  const n = e.length,
                    r = new Array(n);
                  let o = 0;
                  e.forEach((e, i) => {
                    Kw(e, !1, e => {
                      r[i] = e, ++o === n && t(r.join(Qw));
                    });
                  });
                })(e, e => {
                  this.doWrite(e, () => {
                    this.writable = !0, this.emitReserved("drain");
                  });
                });
              }
              uri() {
                const e = this.opts.secure ? "https" : "http",
                  t = this.query || {};
                return !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = vx()), this.supportsBinary || t.sid || (t.b64 = 1), this.createUri(e, t);
              }
              request(e = {}) {
                return Object.assign(e, {
                  xd: this.xd,
                  cookieJar: this.cookieJar
                }, this.opts), new Cx(this.uri(), e);
              }
              doWrite(e, t) {
                const n = this.request({
                  method: "POST",
                  data: e
                });
                n.on("success", t), n.on("error", (e, t) => {
                  this.onError("xhr post error", e, t);
                });
              }
              doPoll() {
                const e = this.request();
                e.on("data", this.onData.bind(this)), e.on("error", (e, t) => {
                  this.onError("xhr poll error", e, t);
                }), this.pollXhr = e;
              }
            }
          },
          Ax = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
          zx = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"];
        function Tx(e) {
          if (e.length > 2e3) throw "URI too long";
          const t = e,
            n = e.indexOf("["),
            r = e.indexOf("]");
          -1 != n && -1 != r && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
          let o = Ax.exec(e || ""),
            i = {},
            a = 14;
          for (; a--;) i[zx[a]] = o[a] || "";
          return -1 != n && -1 != r && (i.source = t, i.host = i.host.substring(1, i.host.length - 1).replace(/;/g, ":"), i.authority = i.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), i.ipv6uri = !0), i.pathNames = function (e, t) {
            const n = /\/{2,9}/g,
              r = t.replace(n, "/").split("/");
            "/" != t.slice(0, 1) && 0 !== t.length || r.splice(0, 1);
            "/" == t.slice(-1) && r.splice(r.length - 1, 1);
            return r;
          }(0, i.path), i.queryKey = function (e, t) {
            const n = {};
            return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function (e, t, r) {
              t && (n[t] = r);
            }), n;
          }(0, i.query), i;
        }
        let Ox = /*#__PURE__*/(() => {
          class Ox extends rx {
            constructor(e, t = {}) {
              super(), this.binaryType = "arraybuffer", this.writeBuffer = [], e && "object" == typeof e && (t = e, e = null), e ? (e = Tx(e), t.hostname = e.host, t.secure = "https" === e.protocol || "wss" === e.protocol, t.port = e.port, e.query && (t.query = e.query)) : t.host && (t.hostname = Tx(t.host).host), lx(this, t), this.secure = null != t.secure ? t.secure : "undefined" != typeof location && "https:" === location.protocol, t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || ("undefined" != typeof location ? location.hostname : "localhost"), this.port = t.port || ("undefined" != typeof location && location.port ? location.port : this.secure ? "443" : "80"), this.transports = t.transports || ["polling", "websocket", "webtransport"], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
                path: "/engine.io",
                agent: !1,
                withCredentials: !1,
                upgrade: !0,
                timestampParam: "t",
                rememberUpgrade: !1,
                addTrailingSlash: !0,
                rejectUnauthorized: !0,
                perMessageDeflate: {
                  threshold: 1024
                },
                transportOptions: {},
                closeOnBeforeunload: !1
              }, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), "string" == typeof this.opts.query && (this.opts.query = function (e) {
                let t = {},
                  n = e.split("&");
                for (let e = 0, r = n.length; e < r; e++) {
                  let r = n[e].split("=");
                  t[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
                }
                return t;
              }(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, "function" == typeof addEventListener && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
                this.transport && (this.transport.removeAllListeners(), this.transport.close());
              }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), "localhost" !== this.hostname && (this.offlineEventListener = () => {
                this.onClose("transport close", {
                  description: "network connection lost"
                });
              }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
            }
            createTransport(e) {
              const t = Object.assign({}, this.opts.query);
              t.EIO = 4, t.transport = e, this.id && (t.sid = this.id);
              const n = Object.assign({}, this.opts, {
                query: t,
                socket: this,
                hostname: this.hostname,
                secure: this.secure,
                port: this.port
              }, this.opts.transportOptions[e]);
              return new kx[e](n);
            }
            open() {
              let e;
              if (this.opts.rememberUpgrade && Ox.priorWebsocketSuccess && -1 !== this.transports.indexOf("websocket")) e = "websocket";else {
                if (0 === this.transports.length) return void this.setTimeoutFn(() => {
                  this.emitReserved("error", "No transports available");
                }, 0);
                e = this.transports[0];
              }
              this.readyState = "opening";
              try {
                e = this.createTransport(e);
              } catch (e) {
                return this.transports.shift(), void this.open();
              }
              e.open(), this.setTransport(e);
            }
            setTransport(e) {
              this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", e => this.onClose("transport close", e));
            }
            probe(e) {
              let t = this.createTransport(e),
                n = !1;
              Ox.priorWebsocketSuccess = !1;
              const r = () => {
                n || (t.send([{
                  type: "ping",
                  data: "probe"
                }]), t.once("packet", e => {
                  if (!n) if ("pong" === e.type && "probe" === e.data) {
                    if (this.upgrading = !0, this.emitReserved("upgrading", t), !t) return;
                    Ox.priorWebsocketSuccess = "websocket" === t.name, this.transport.pause(() => {
                      n || "closed" !== this.readyState && (u(), this.setTransport(t), t.send([{
                        type: "upgrade"
                      }]), this.emitReserved("upgrade", t), t = null, this.upgrading = !1, this.flush());
                    });
                  } else {
                    const e = new Error("probe error");
                    e.transport = t.name, this.emitReserved("upgradeError", e);
                  }
                }));
              };
              function o() {
                n || (n = !0, u(), t.close(), t = null);
              }
              const i = e => {
                const n = new Error("probe error: " + e);
                n.transport = t.name, o(), this.emitReserved("upgradeError", n);
              };
              function a() {
                i("transport closed");
              }
              function s() {
                i("socket closed");
              }
              function l(e) {
                t && e.name !== t.name && o();
              }
              const u = () => {
                t.removeListener("open", r), t.removeListener("error", i), t.removeListener("close", a), this.off("close", s), this.off("upgrading", l);
              };
              t.once("open", r), t.once("error", i), t.once("close", a), this.once("close", s), this.once("upgrading", l), -1 !== this.upgrades.indexOf("webtransport") && "webtransport" !== e ? this.setTimeoutFn(() => {
                n || t.open();
              }, 200) : t.open();
            }
            onOpen() {
              if (this.readyState = "open", Ox.priorWebsocketSuccess = "websocket" === this.transport.name, this.emitReserved("open"), this.flush(), "open" === this.readyState && this.opts.upgrade) {
                let e = 0;
                const t = this.upgrades.length;
                for (; e < t; e++) this.probe(this.upgrades[e]);
              }
            }
            onPacket(e) {
              if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), this.resetPingTimeout(), e.type) {
                case "open":
                  this.onHandshake(JSON.parse(e.data));
                  break;
                case "ping":
                  this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
                  break;
                case "error":
                  const t = new Error("server error");
                  t.code = e.data, this.onError(t);
                  break;
                case "message":
                  this.emitReserved("data", e.data), this.emitReserved("message", e.data);
              }
            }
            onHandshake(e) {
              this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this.upgrades = this.filterUpgrades(e.upgrades), this.pingInterval = e.pingInterval, this.pingTimeout = e.pingTimeout, this.maxPayload = e.maxPayload, this.onOpen(), "closed" !== this.readyState && this.resetPingTimeout();
            }
            resetPingTimeout() {
              this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
                this.onClose("ping timeout");
              }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
            }
            onDrain() {
              this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, 0 === this.writeBuffer.length ? this.emitReserved("drain") : this.flush();
            }
            flush() {
              if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
                const e = this.getWritablePackets();
                this.transport.send(e), this.prevBufferLen = e.length, this.emitReserved("flush");
              }
            }
            getWritablePackets() {
              if (!(this.maxPayload && "polling" === this.transport.name && this.writeBuffer.length > 1)) return this.writeBuffer;
              let e = 1;
              for (let n = 0; n < this.writeBuffer.length; n++) {
                const r = this.writeBuffer[n].data;
                if (r && (e += "string" == typeof (t = r) ? function (e) {
                  let t = 0,
                    n = 0;
                  for (let r = 0, o = e.length; r < o; r++) t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
                  return n;
                }(t) : Math.ceil(1.33 * (t.byteLength || t.size))), n > 0 && e > this.maxPayload) return this.writeBuffer.slice(0, n);
                e += 2;
              }
              var t;
              return this.writeBuffer;
            }
            write(e, t, n) {
              return this.sendPacket("message", e, t, n), this;
            }
            send(e, t, n) {
              return this.sendPacket("message", e, t, n), this;
            }
            sendPacket(e, t, n, r) {
              if ("function" == typeof t && (r = t, t = void 0), "function" == typeof n && (r = n, n = null), "closing" === this.readyState || "closed" === this.readyState) return;
              (n = n || {}).compress = !1 !== n.compress;
              const o = {
                type: e,
                data: t,
                options: n
              };
              this.emitReserved("packetCreate", o), this.writeBuffer.push(o), r && this.once("flush", r), this.flush();
            }
            close() {
              const e = () => {
                  this.onClose("forced close"), this.transport.close();
                },
                t = () => {
                  this.off("upgrade", t), this.off("upgradeError", t), e();
                },
                n = () => {
                  this.once("upgrade", t), this.once("upgradeError", t);
                };
              return "opening" !== this.readyState && "open" !== this.readyState || (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
                this.upgrading ? n() : e();
              }) : this.upgrading ? n() : e()), this;
            }
            onError(e) {
              Ox.priorWebsocketSuccess = !1, this.emitReserved("error", e), this.onClose("transport error", e);
            }
            onClose(e, t) {
              "opening" !== this.readyState && "open" !== this.readyState && "closing" !== this.readyState || (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), "function" == typeof removeEventListener && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this.prevBufferLen = 0);
            }
            filterUpgrades(e) {
              const t = [];
              let n = 0;
              const r = e.length;
              for (; n < r; n++) ~this.transports.indexOf(e[n]) && t.push(e[n]);
              return t;
            }
          }
          Ox.protocol = 4;
          return Ox;
        })();
        Ox.protocol;
        const Ix = "function" == typeof ArrayBuffer,
          Fx = Object.prototype.toString,
          Mx = "function" == typeof Blob || "undefined" != typeof Blob && "[object BlobConstructor]" === Fx.call(Blob),
          Rx = "function" == typeof File || "undefined" != typeof File && "[object FileConstructor]" === Fx.call(File);
        function jx(e) {
          return Ix && (e instanceof ArrayBuffer || (e => "function" == typeof ArrayBuffer.isView ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer)(e)) || Mx && e instanceof Blob || Rx && e instanceof File;
        }
        function Bx(e, t) {
          if (!e || "object" != typeof e) return !1;
          if (Array.isArray(e)) {
            for (let t = 0, n = e.length; t < n; t++) if (Bx(e[t])) return !0;
            return !1;
          }
          if (jx(e)) return !0;
          if (e.toJSON && "function" == typeof e.toJSON && 1 === arguments.length) return Bx(e.toJSON(), !0);
          for (const t in e) if (Object.prototype.hasOwnProperty.call(e, t) && Bx(e[t])) return !0;
          return !1;
        }
        function Nx(e) {
          const t = [],
            n = e.data,
            r = e;
          return r.data = Lx(n, t), r.attachments = t.length, {
            packet: r,
            buffers: t
          };
        }
        function Lx(e, t) {
          if (!e) return e;
          if (jx(e)) {
            const n = {
              _placeholder: !0,
              num: t.length
            };
            return t.push(e), n;
          }
          if (Array.isArray(e)) {
            const n = new Array(e.length);
            for (let r = 0; r < e.length; r++) n[r] = Lx(e[r], t);
            return n;
          }
          if ("object" == typeof e && !(e instanceof Date)) {
            const n = {};
            for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = Lx(e[r], t));
            return n;
          }
          return e;
        }
        function Vx(e, t) {
          return e.data = Kx(e.data, t), delete e.attachments, e;
        }
        function Kx(e, t) {
          if (!e) return e;
          if (e && !0 === e._placeholder) {
            if ("number" == typeof e.num && e.num >= 0 && e.num < t.length) return t[e.num];
            throw new Error("illegal attachments");
          }
          if (Array.isArray(e)) for (let n = 0; n < e.length; n++) e[n] = Kx(e[n], t);else if ("object" == typeof e) for (const n in e) Object.prototype.hasOwnProperty.call(e, n) && (e[n] = Kx(e[n], t));
          return e;
        }
        const qx = ["connect", "connect_error", "disconnect", "disconnecting", "newListener", "removeListener"],
          Hx = 5;
        var Ux;
        !function (e) {
          e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
        }(Ux || (Ux = {}));
        class Zx {
          constructor(e) {
            this.replacer = e;
          }
          encode(e) {
            return e.type !== Ux.EVENT && e.type !== Ux.ACK || !Bx(e) ? [this.encodeAsString(e)] : this.encodeAsBinary({
              type: e.type === Ux.EVENT ? Ux.BINARY_EVENT : Ux.BINARY_ACK,
              nsp: e.nsp,
              data: e.data,
              id: e.id
            });
          }
          encodeAsString(e) {
            let t = "" + e.type;
            return e.type !== Ux.BINARY_EVENT && e.type !== Ux.BINARY_ACK || (t += e.attachments + "-"), e.nsp && "/" !== e.nsp && (t += e.nsp + ","), null != e.id && (t += e.id), null != e.data && (t += JSON.stringify(e.data, this.replacer)), t;
          }
          encodeAsBinary(e) {
            const t = Nx(e),
              n = this.encodeAsString(t.packet),
              r = t.buffers;
            return r.unshift(n), r;
          }
        }
        function $x(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }
        class Gx extends rx {
          constructor(e) {
            super(), this.reviver = e;
          }
          add(e) {
            let t;
            if ("string" == typeof e) {
              if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
              t = this.decodeString(e);
              const n = t.type === Ux.BINARY_EVENT;
              n || t.type === Ux.BINARY_ACK ? (t.type = n ? Ux.EVENT : Ux.ACK, this.reconstructor = new Wx(t), 0 === t.attachments && super.emitReserved("decoded", t)) : super.emitReserved("decoded", t);
            } else {
              if (!jx(e) && !e.base64) throw new Error("Unknown type: " + e);
              if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
              t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
            }
          }
          decodeString(e) {
            let t = 0;
            const n = {
              type: Number(e.charAt(0))
            };
            if (void 0 === Ux[n.type]) throw new Error("unknown packet type " + n.type);
            if (n.type === Ux.BINARY_EVENT || n.type === Ux.BINARY_ACK) {
              const r = t + 1;
              for (; "-" !== e.charAt(++t) && t != e.length;);
              const o = e.substring(r, t);
              if (o != Number(o) || "-" !== e.charAt(t)) throw new Error("Illegal attachments");
              n.attachments = Number(o);
            }
            if ("/" === e.charAt(t + 1)) {
              const r = t + 1;
              for (; ++t;) {
                if ("," === e.charAt(t)) break;
                if (t === e.length) break;
              }
              n.nsp = e.substring(r, t);
            } else n.nsp = "/";
            const r = e.charAt(t + 1);
            if ("" !== r && Number(r) == r) {
              const r = t + 1;
              for (; ++t;) {
                const n = e.charAt(t);
                if (null == n || Number(n) != n) {
                  --t;
                  break;
                }
                if (t === e.length) break;
              }
              n.id = Number(e.substring(r, t + 1));
            }
            if (e.charAt(++t)) {
              const r = this.tryParse(e.substr(t));
              if (!Gx.isPayloadValid(n.type, r)) throw new Error("invalid payload");
              n.data = r;
            }
            return n;
          }
          tryParse(e) {
            try {
              return JSON.parse(e, this.reviver);
            } catch (e) {
              return !1;
            }
          }
          static isPayloadValid(e, t) {
            switch (e) {
              case Ux.CONNECT:
                return $x(t);
              case Ux.DISCONNECT:
                return void 0 === t;
              case Ux.CONNECT_ERROR:
                return "string" == typeof t || $x(t);
              case Ux.EVENT:
              case Ux.BINARY_EVENT:
                return Array.isArray(t) && ("number" == typeof t[0] || "string" == typeof t[0] && -1 === qx.indexOf(t[0]));
              case Ux.ACK:
              case Ux.BINARY_ACK:
                return Array.isArray(t);
            }
          }
          destroy() {
            this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
          }
        }
        class Wx {
          constructor(e) {
            this.packet = e, this.buffers = [], this.reconPack = e;
          }
          takeBinaryData(e) {
            if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
              const e = Vx(this.reconPack, this.buffers);
              return this.finishedReconstruction(), e;
            }
            return null;
          }
          finishedReconstruction() {
            this.reconPack = null, this.buffers = [];
          }
        }
        function Yx(e, t, n) {
          return e.on(t, n), function () {
            e.off(t, n);
          };
        }
        const Xx = Object.freeze({
          connect: 1,
          connect_error: 1,
          disconnect: 1,
          disconnecting: 1,
          newListener: 1,
          removeListener: 1
        });
        class Qx extends rx {
          constructor(e, t, n) {
            super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
          }
          get disconnected() {
            return !this.connected;
          }
          subEvents() {
            if (this.subs) return;
            const e = this.io;
            this.subs = [Yx(e, "open", this.onopen.bind(this)), Yx(e, "packet", this.onpacket.bind(this)), Yx(e, "error", this.onerror.bind(this)), Yx(e, "close", this.onclose.bind(this))];
          }
          get active() {
            return !!this.subs;
          }
          connect() {
            return this.connected || (this.subEvents(), this.io._reconnecting || this.io.open(), "open" === this.io._readyState && this.onopen()), this;
          }
          open() {
            return this.connect();
          }
          send(...e) {
            return e.unshift("message"), this.emit.apply(this, e), this;
          }
          emit(e, ...t) {
            if (Xx.hasOwnProperty(e)) throw new Error('"' + e.toString() + '" is a reserved event name');
            if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(t), this;
            const n = {
              type: Ux.EVENT,
              data: t,
              options: {}
            };
            if (n.options.compress = !1 !== this.flags.compress, "function" == typeof t[t.length - 1]) {
              const e = this.ids++,
                r = t.pop();
              this._registerAckCallback(e, r), n.id = e;
            }
            const r = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
            return this.flags.volatile && (!r || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(n), this.packet(n)) : this.sendBuffer.push(n)), this.flags = {}, this;
          }
          _registerAckCallback(e, t) {
            var n;
            const r = null !== (n = this.flags.timeout) && void 0 !== n ? n : this._opts.ackTimeout;
            if (void 0 === r) return void (this.acks[e] = t);
            const o = this.io.setTimeoutFn(() => {
                delete this.acks[e];
                for (let t = 0; t < this.sendBuffer.length; t++) this.sendBuffer[t].id === e && this.sendBuffer.splice(t, 1);
                t.call(this, new Error("operation has timed out"));
              }, r),
              i = (...e) => {
                this.io.clearTimeoutFn(o), t.apply(this, e);
              };
            i.withError = !0, this.acks[e] = i;
          }
          emitWithAck(e, ...t) {
            return new Promise((n, r) => {
              const o = (e, t) => e ? r(e) : n(t);
              o.withError = !0, t.push(o), this.emit(e, ...t);
            });
          }
          _addToQueue(e) {
            let t;
            "function" == typeof e[e.length - 1] && (t = e.pop());
            const n = {
              id: this._queueSeq++,
              tryCount: 0,
              pending: !1,
              args: e,
              flags: Object.assign({
                fromQueue: !0
              }, this.flags)
            };
            e.push((e, ...r) => {
              if (n !== this._queue[0]) return;
              return null !== e ? n.tryCount > this._opts.retries && (this._queue.shift(), t && t(e)) : (this._queue.shift(), t && t(null, ...r)), n.pending = !1, this._drainQueue();
            }), this._queue.push(n), this._drainQueue();
          }
          _drainQueue(e = !1) {
            if (!this.connected || 0 === this._queue.length) return;
            const t = this._queue[0];
            t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
          }
          packet(e) {
            e.nsp = this.nsp, this.io._packet(e);
          }
          onopen() {
            "function" == typeof this.auth ? this.auth(e => {
              this._sendConnectPacket(e);
            }) : this._sendConnectPacket(this.auth);
          }
          _sendConnectPacket(e) {
            this.packet({
              type: Ux.CONNECT,
              data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
              }, e) : e
            });
          }
          onerror(e) {
            this.connected || this.emitReserved("connect_error", e);
          }
          onclose(e, t) {
            this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t), this._clearAcks();
          }
          _clearAcks() {
            Object.keys(this.acks).forEach(e => {
              if (!this.sendBuffer.some(t => String(t.id) === e)) {
                const t = this.acks[e];
                delete this.acks[e], t.withError && t.call(this, new Error("socket has been disconnected"));
              }
            });
          }
          onpacket(e) {
            if (e.nsp === this.nsp) switch (e.type) {
              case Ux.CONNECT:
                e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
              case Ux.EVENT:
              case Ux.BINARY_EVENT:
                this.onevent(e);
                break;
              case Ux.ACK:
              case Ux.BINARY_ACK:
                this.onack(e);
                break;
              case Ux.DISCONNECT:
                this.ondisconnect();
                break;
              case Ux.CONNECT_ERROR:
                this.destroy();
                const t = new Error(e.data.message);
                t.data = e.data.data, this.emitReserved("connect_error", t);
            }
          }
          onevent(e) {
            const t = e.data || [];
            null != e.id && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
          }
          emitEvent(e) {
            if (this._anyListeners && this._anyListeners.length) {
              const t = this._anyListeners.slice();
              for (const n of t) n.apply(this, e);
            }
            super.emit.apply(this, e), this._pid && e.length && "string" == typeof e[e.length - 1] && (this._lastOffset = e[e.length - 1]);
          }
          ack(e) {
            const t = this;
            let n = !1;
            return function (...r) {
              n || (n = !0, t.packet({
                type: Ux.ACK,
                id: e,
                data: r
              }));
            };
          }
          onack(e) {
            const t = this.acks[e.id];
            "function" == typeof t && (delete this.acks[e.id], t.withError && e.data.unshift(null), t.apply(this, e.data));
          }
          onconnect(e, t) {
            this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
          }
          emitBuffered() {
            this.receiveBuffer.forEach(e => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach(e => {
              this.notifyOutgoingListeners(e), this.packet(e);
            }), this.sendBuffer = [];
          }
          ondisconnect() {
            this.destroy(), this.onclose("io server disconnect");
          }
          destroy() {
            this.subs && (this.subs.forEach(e => e()), this.subs = void 0), this.io._destroy(this);
          }
          disconnect() {
            return this.connected && this.packet({
              type: Ux.DISCONNECT
            }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
          }
          close() {
            return this.disconnect();
          }
          compress(e) {
            return this.flags.compress = e, this;
          }
          get volatile() {
            return this.flags.volatile = !0, this;
          }
          timeout(e) {
            return this.flags.timeout = e, this;
          }
          onAny(e) {
            return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
          }
          prependAny(e) {
            return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
          }
          offAny(e) {
            if (!this._anyListeners) return this;
            if (e) {
              const t = this._anyListeners;
              for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
            } else this._anyListeners = [];
            return this;
          }
          listenersAny() {
            return this._anyListeners || [];
          }
          onAnyOutgoing(e) {
            return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
          }
          prependAnyOutgoing(e) {
            return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
          }
          offAnyOutgoing(e) {
            if (!this._anyOutgoingListeners) return this;
            if (e) {
              const t = this._anyOutgoingListeners;
              for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
            } else this._anyOutgoingListeners = [];
            return this;
          }
          listenersAnyOutgoing() {
            return this._anyOutgoingListeners || [];
          }
          notifyOutgoingListeners(e) {
            if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
              const t = this._anyOutgoingListeners.slice();
              for (const n of t) n.apply(this, e.data);
            }
          }
        }
        function Jx(e) {
          e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
        }
        Jx.prototype.duration = function () {
          var e = this.ms * Math.pow(this.factor, this.attempts++);
          if (this.jitter) {
            var t = Math.random(),
              n = Math.floor(t * this.jitter * e);
            e = 0 == (1 & Math.floor(10 * t)) ? e - n : e + n;
          }
          return 0 | Math.min(e, this.max);
        }, Jx.prototype.reset = function () {
          this.attempts = 0;
        }, Jx.prototype.setMin = function (e) {
          this.ms = e;
        }, Jx.prototype.setMax = function (e) {
          this.max = e;
        }, Jx.prototype.setJitter = function (e) {
          this.jitter = e;
        };
        class eD extends rx {
          constructor(e, t) {
            var n;
            super(), this.nsps = {}, this.subs = [], e && "object" == typeof e && (t = e, e = void 0), (t = t || {}).path = t.path || "/socket.io", this.opts = t, lx(this, t), this.reconnection(!1 !== t.reconnection), this.reconnectionAttempts(t.reconnectionAttempts || 1 / 0), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(null !== (n = t.randomizationFactor) && void 0 !== n ? n : .5), this.backoff = new Jx({
              min: this.reconnectionDelay(),
              max: this.reconnectionDelayMax(),
              jitter: this.randomizationFactor()
            }), this.timeout(null == t.timeout ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
            const o = t.parser || r;
            this.encoder = new o.Encoder(), this.decoder = new o.Decoder(), this._autoConnect = !1 !== t.autoConnect, this._autoConnect && this.open();
          }
          reconnection(e) {
            return arguments.length ? (this._reconnection = !!e, this) : this._reconnection;
          }
          reconnectionAttempts(e) {
            return void 0 === e ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
          }
          reconnectionDelay(e) {
            var t;
            return void 0 === e ? this._reconnectionDelay : (this._reconnectionDelay = e, null === (t = this.backoff) || void 0 === t || t.setMin(e), this);
          }
          randomizationFactor(e) {
            var t;
            return void 0 === e ? this._randomizationFactor : (this._randomizationFactor = e, null === (t = this.backoff) || void 0 === t || t.setJitter(e), this);
          }
          reconnectionDelayMax(e) {
            var t;
            return void 0 === e ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, null === (t = this.backoff) || void 0 === t || t.setMax(e), this);
          }
          timeout(e) {
            return arguments.length ? (this._timeout = e, this) : this._timeout;
          }
          maybeReconnectOnOpen() {
            !this._reconnecting && this._reconnection && 0 === this.backoff.attempts && this.reconnect();
          }
          open(e) {
            if (~this._readyState.indexOf("open")) return this;
            this.engine = new Ox(this.uri, this.opts);
            const t = this.engine,
              n = this;
            this._readyState = "opening", this.skipReconnect = !1;
            const r = Yx(t, "open", function () {
                n.onopen(), e && e();
              }),
              o = t => {
                this.cleanup(), this._readyState = "closed", this.emitReserved("error", t), e ? e(t) : this.maybeReconnectOnOpen();
              },
              i = Yx(t, "error", o);
            if (!1 !== this._timeout) {
              const e = this._timeout,
                n = this.setTimeoutFn(() => {
                  r(), o(new Error("timeout")), t.close();
                }, e);
              this.opts.autoUnref && n.unref(), this.subs.push(() => {
                this.clearTimeoutFn(n);
              });
            }
            return this.subs.push(r), this.subs.push(i), this;
          }
          connect(e) {
            return this.open(e);
          }
          onopen() {
            this.cleanup(), this._readyState = "open", this.emitReserved("open");
            const e = this.engine;
            this.subs.push(Yx(e, "ping", this.onping.bind(this)), Yx(e, "data", this.ondata.bind(this)), Yx(e, "error", this.onerror.bind(this)), Yx(e, "close", this.onclose.bind(this)), Yx(this.decoder, "decoded", this.ondecoded.bind(this)));
          }
          onping() {
            this.emitReserved("ping");
          }
          ondata(e) {
            try {
              this.decoder.add(e);
            } catch (e) {
              this.onclose("parse error", e);
            }
          }
          ondecoded(e) {
            Ex(() => {
              this.emitReserved("packet", e);
            }, this.setTimeoutFn);
          }
          onerror(e) {
            this.emitReserved("error", e);
          }
          socket(e, t) {
            let n = this.nsps[e];
            return n ? this._autoConnect && !n.active && n.connect() : (n = new Qx(this, e, t), this.nsps[e] = n), n;
          }
          _destroy(e) {
            const t = Object.keys(this.nsps);
            for (const e of t) {
              if (this.nsps[e].active) return;
            }
            this._close();
          }
          _packet(e) {
            const t = this.encoder.encode(e);
            for (let n = 0; n < t.length; n++) this.engine.write(t[n], e.options);
          }
          cleanup() {
            this.subs.forEach(e => e()), this.subs.length = 0, this.decoder.destroy();
          }
          _close() {
            this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
          }
          disconnect() {
            return this._close();
          }
          onclose(e, t) {
            this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
          }
          reconnect() {
            if (this._reconnecting || this.skipReconnect) return this;
            const e = this;
            if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;else {
              const t = this.backoff.duration();
              this._reconnecting = !0;
              const n = this.setTimeoutFn(() => {
                e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), e.skipReconnect || e.open(t => {
                  t ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", t)) : e.onreconnect();
                }));
              }, t);
              this.opts.autoUnref && n.unref(), this.subs.push(() => {
                this.clearTimeoutFn(n);
              });
            }
          }
          onreconnect() {
            const e = this.backoff.attempts;
            this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
          }
        }
        const tD = {};
        function nD(e, t) {
          "object" == typeof e && (t = e, e = void 0);
          const n = function (e, t = "", n) {
              let r = e;
              n = n || "undefined" != typeof location && location, null == e && (e = n.protocol + "//" + n.host), "string" == typeof e && ("/" === e.charAt(0) && (e = "/" === e.charAt(1) ? n.protocol + e : n.host + e), /^(https?|wss?):\/\//.test(e) || (e = void 0 !== n ? n.protocol + "//" + e : "https://" + e), r = Tx(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
              const o = -1 !== r.host.indexOf(":") ? "[" + r.host + "]" : r.host;
              return r.id = r.protocol + "://" + o + ":" + r.port + t, r.href = r.protocol + "://" + o + (n && n.port === r.port ? "" : ":" + r.port), r;
            }(e, (t = t || {}).path || "/socket.io"),
            r = n.source,
            o = n.id,
            i = n.path,
            a = tD[o] && i in tD[o].nsps;
          let s;
          return t.forceNew || t["force new connection"] || !1 === t.multiplex || a ? s = new eD(r, t) : (tD[o] || (tD[o] = new eD(r, t)), s = tD[o]), n.query && !t.query && (t.query = n.queryKey), s.socket(n.path, t);
        }
        Object.assign(nD, {
          Manager: eD,
          Socket: Qx,
          io: nD,
          connect: nD
        });
        class rD {
          constructor() {
            (0, o.Z)(this, "ongoingRequests", new Map());
          }
          create() {
            const e = (0, Fw.v4)();
            return this.ongoingRequests.set(e, {
              lastChunkIndex: null,
              outOfOrderChunks: []
            }), e;
          }
          update(e, t, n) {
            const r = this.ongoingRequests.get(e);
            if ((0, mw.kG)(r), null === r.lastChunkIndex || n === r.lastChunkIndex + 1) {
              {
                r.lastChunkIndex = n;
                const e = r.outOfOrderChunks;
                for (let o = 0; o < e.length; o++) {
                  const i = e[o];
                  i.index === n + 1 && (t += i.content), r.lastChunkIndex = i.index;
                }
                r.outOfOrderChunks = [];
              }
              return t;
            }
            {
              const e = {
                  content: t,
                  index: n
                },
                o = r.outOfOrderChunks,
                i = function (e, t) {
                  let n = 0,
                    r = e.length;
                  for (; n < r;) {
                    const o = n + r >>> 1;
                    e[o].index < t.index ? n = o + 1 : r = o;
                  }
                  return n;
                }(r.outOfOrderChunks, e);
              o.splice(i, 0, e);
            }
          }
          get(e) {
            return this.ongoingRequests.get(e);
          }
          delete(e) {
            this.ongoingRequests.delete(e);
          }
          clear() {
            this.ongoingRequests.clear();
          }
        }
        const oD = ["requestId", "content", "index", "end"];
        function iD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function aD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? iD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : iD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        let sD = function (e) {
          return e.Connected = "connected", e.Disconnected = "disconnected", e.Reconnect_failed = "reconnect_failed", e;
        }({});
        class lD {
          constructor(e, t, n, r) {
            const {
              backendUrl: o,
              jwt: i,
              userId: a,
              chatSessionId: s
            } = e;
            this.backendUrl = o, this.jwt = i, this.userId = a, this.chatSessionId = s, this.documentId = n, this.documentHandle = t, this.ongoingRequestManager = new rD();
            const l = new URL(o).pathname;
            this.socket = nD(`${this.backendUrl}/socket/v1/document-assistant`, {
              path: `${l}${l.endsWith("/") ? "" : "/"}socket.io`,
              reconnectionDelay: 3e3,
              reconnection: !0,
              reconnectionAttempts: 2,
              transports: ["websocket"],
              agent: !1,
              upgrade: !1,
              rejectUnauthorized: !1,
              auth: {
                token: this.jwt
              }
            }), this.socket.on("connect", () => {
              r(sD.Connected);
            }), this.socket.on("disconnect", () => {
              r(sD.Disconnected);
            }), this.socket.io.on("reconnect_failed", () => {
              r(sD.Reconnect_failed);
            });
          }
          async initialize() {
            return await fetch(`${this.backendUrl}/api/v1/users/${this.userId}/documents/${this.documentId}/handle/${this.documentHandle}`, {
              headers: {
                Authorization: `Token token=${this.jwt}`
              }
            }), new Promise(e => {
              this.socket.once("document-assistant-ready", async () => {
                const t = await fetch(`${this.backendUrl}/api/v1/users/${this.userId}/sessions/${this.chatSessionId}`, {
                    headers: {
                      Authorization: `Token token=${this.jwt}`
                    }
                  }),
                  n = await t.json();
                e(n);
              }), this.socket.emit("initialize", {
                userId: this.userId,
                documentId: this.documentId,
                documentHandle: this.documentHandle,
                sessionId: this.chatSessionId
              });
            });
          }
          setChatSessionId(e) {
            return this.chatSessionId = e, this.initialize();
          }
          setDocumentHandle(e) {
            return this.documentHandle = e, this.initialize();
          }
          addErrorListener(e) {
            this.socket.on("error", t => {
              let {
                requestId: n,
                message: r,
                code: o
              } = t;
              const i = this.ongoingRequestManager.get(n);
              (0, mw.kG)(i), this.ongoingRequestManager.delete(n), e({
                requestId: n,
                message: r,
                code: o
              });
            });
          }
          addChatBlockListener(e) {
            this.socket.on("chat-block", t => {
              let {
                  requestId: n,
                  content: r = "",
                  index: o,
                  end: i
                } = t,
                a = (0, ne.Z)(t, oD);
              const s = this.ongoingRequestManager.get(n);
              if ((0, mw.kG)(s), i) this.ongoingRequestManager.delete(n), e(aD({
                requestId: n,
                content: r,
                index: o,
                end: i
              }, a));else {
                const t = this.ongoingRequestManager.update(n, r, o);
                if (void 0 === t) return;
                e(aD({
                  requestId: n,
                  content: t,
                  index: o,
                  end: i
                }, a));
              }
            });
          }
          emitAgentCompletion(e, t, n) {
            const r = this.ongoingRequestManager.create();
            return this.socket.emit("agent-completion", {
              requestId: r,
              agent: e,
              issuer: t,
              parameters: n,
              documentId: this.documentId,
              chatId: this.chatSessionId
            }), r;
          }
          emitCompletion(e, t) {
            const n = this.ongoingRequestManager.create();
            return this.socket.emit("completion", {
              requestId: n,
              issuer: e,
              parameters: t,
              documentId: this.documentId,
              chatId: this.chatSessionId
            }), n;
          }
          destroy() {
            this.socket.disconnect(), this.ongoingRequestManager.clear();
          }
        }
        var uD = n(10102);
        const cD = "PLAIN",
          dD = "SUGGESTIONS",
          pD = "QUERY_RESULT",
          hD = "ERROR",
          fD = "ACTIONS",
          mD = "ADDITIONAL_CONTEXT";
        function gD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function vD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? gD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function yD(e) {
          let {
            onSendMessage: t,
            onTemplateAction: n,
            dispatch: r,
            formatMessage: o
          } = e;
          return (0, po.R9)((e, i, a) => {
            const {
              suggestions: l,
              additionalContext: u,
              links: c,
              stagedActions: d
            } = i;
            if (Array.isArray(l) && l.length > 0) return u ? vD(vD(vD({}, e), u && {
              additionalContext: u.text,
              linkToAdditionalContext: {
                text: o(uD.s.goToSelection),
                onPress: () => r((0, Ql.kN)(u.pageIndex, new _.UL(u.boundingBox)))
              }
            }), {}, {
              type: mD,
              actions: l.map(e => {
                let {
                  type: r,
                  text: o,
                  agent: i,
                  parameters: a,
                  template: s
                } = e;
                return "request" === r ? {
                  onPress: () => t(null == a ? void 0 : a.input, i, a),
                  text: o
                } : {
                  text: o,
                  onPress: () => n({
                    text: null != s ? s : "",
                    agent: i,
                    parameters: a
                  })
                };
              })
            }) : l.every(e => {
              let {
                type: t
              } = e;
              return "request" === t;
            }) ? vD(vD({}, e), {}, {
              type: dD,
              suggestions: l.map(e => {
                let {
                  text: n,
                  agent: r,
                  parameters: o
                } = e;
                return {
                  onPress: () => t(n, r, o),
                  text: n
                };
              })
            }) : vD(vD({}, e), {}, {
              type: fD,
              actions: l.map(e => {
                let {
                  type: r,
                  text: o,
                  agent: i,
                  template: a,
                  parameters: s
                } = e;
                return "request" === r ? {
                  onPress: () => t(o, i, s),
                  text: o
                } : {
                  text: o,
                  onPress: () => n({
                    text: null != a ? a : "",
                    agent: i,
                    parameters: s
                  })
                };
              })
            });
            if (Array.isArray(c) && c.length > 0) return vD(vD({}, e), {}, {
              type: pD,
              links: c.map(e => {
                let {
                  text: t,
                  href: n
                } = e;
                if (n.startsWith("document://")) {
                  const [{
                      pageIndex: e,
                      rects: o
                    }] = JSON.parse(n.replace("document://", "")),
                    i = _.UL.union((0, s.aV)(o.map(e => new _.UL(e))));
                  return {
                    text: t,
                    onPress: () => r((0, Ql.kN)(parseInt(e), i))
                  };
                }
                return {
                  text: t,
                  onPress: () => window.location.assign(n)
                };
              }),
              actionsText: "",
              actions: []
            });
            if (Array.isArray(d) && d.some(e => "redact" === e.type)) {
              const t = [{
                text: o(ke.Z.applyRedactions),
                onPress: () => {
                  r((0, Kt.fq)()), r((0, lc.g)(() => r((0, Kt.Di)()), () => r((0, Kt.Di)())));
                }
              }];
              return a && !a.isEmpty() && t.unshift({
                text: o(ke.Z.discard),
                onPress: () => {
                  r((0, yt.d8)(null == a ? void 0 : a.toSet())), t.shift();
                }
              }), vD(vD({}, e), {}, {
                type: fD,
                actions: t
              });
            }
            return e;
          });
        }
        const bD = ["content", "sender"],
          wD = ["requestId", "end", "content", "actions"];
        function xD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function DD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? xD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function CD(e) {
          let {
            configuration: t,
            documentHandle: n,
            documentId: r,
            additionalContext: o,
            onTemplateAction: i,
            onMessageSubmit: a
          } = e;
          const {
              formatMessage: s
            } = (0, Wl.useI18n)(),
            [u, c] = (0, d.useState)(null),
            [p, h] = (0, d.useState)(!0),
            [f, m] = (0, d.useState)(!1),
            [g, v] = (0, d.useState)([]),
            [y, b] = (0, d.useState)(null),
            w = (0, l.I0)(),
            x = (0, l.v9)(e => e.instance),
            D = (0, po.R9)((e, t, n) => {
              if (u !== sD.Connected || f || !y) return;
              const {
                agent: r,
                parameters: o
              } = a();
              let i;
              m(!0);
              const s = DD(DD({
                input: e
              }, n), o);
              i = r || t ? y.emitAgentCompletion(null != r ? r : t, "user", s) : y.emitCompletion("user", s), v(t => [...t, {
                type: cD,
                id: `request-${i}`,
                text: e,
                sender: "You",
                isComplete: !0
              }, {
                type: cD,
                id: `response-${i}`,
                text: "",
                sender: "AI",
                isComplete: !1
              }]);
            }),
            C = yD({
              onSendMessage: D,
              onTemplateAction: i,
              dispatch: w,
              formatMessage: s
            }),
            S = (0, po.R9)(e => {
              if (0 !== e.length || o) v(e.map(e => {
                let {
                    content: t,
                    sender: n
                  } = e,
                  r = (0, ne.Z)(e, bD);
                const o = {
                  type: cD,
                  id: (0, Fw.v4)(),
                  text: t,
                  sender: "ai" === n ? "AI" : "You",
                  isComplete: !0
                };
                return C(o, r);
              })), h(!1);else {
                m(!0);
                const e = null == y ? void 0 : y.emitAgentCompletion("SuggestedQuestions", "system", {
                  input: ""
                });
                v([{
                  type: dD,
                  suggestions: [],
                  id: `response-${e}`,
                  text: "",
                  sender: "AI",
                  isComplete: !1
                }]), h(!1);
              }
            });
          return (0, d.useEffect)(() => {
            const e = new lD(t, n, r, e => {
              c(e), "disconnected" === e ? h(!0) : "reconnect_failed" === e && (h(!1), v(e => [...e, {
                type: hD,
                id: "error",
                text: "",
                error: {
                  title: "Connection error",
                  description: "Failed to connect to the server. Please try again later."
                },
                sender: "AI",
                isComplete: !0
              }]));
            });
            e.addErrorListener(e => {
              let {
                requestId: t,
                message: n,
                code: r
              } = e;
              v(e => e.map(e => e.id === `response-${t}` ? DD(DD({}, e), {}, {
                type: hD,
                error: {
                  title: r,
                  description: n
                },
                isComplete: !0
              }) : e));
            }), e.addChatBlockListener(async e => {
              let t,
                {
                  requestId: n,
                  end: r,
                  content: o,
                  actions: i
                } = e,
                a = (0, ne.Z)(e, wD);
              if (r && m(!1), Array.isArray(a.stagedActions) && a.stagedActions.some(e => "redact" === e.type)) {
                const e = new Set(null == i ? void 0 : i.filter(e => "staged-redaction" === e.type).map(e => e.terms.map(e => function (e) {
                  return Array.from(new Intl.Segmenter().segment(e)).map(e => e.segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/[‘’']/g, "[‘’']").replace(/["“”«»„]/g, '["“”«»„]')).join("[-]?[\n\r\t]?");
                }(e))).flat());
                t = await (null == x ? void 0 : x.createRedactionsBySearch(Array.from(e).join("|"), {
                  searchType: Mw.S.REGEX,
                  caseSensitive: !1,
                  searchInAnnotations: !1
                }));
              }
              v(e => e.map(e => {
                if (e.id === `response-${n}`) {
                  const n = DD(DD({}, e), {}, {
                    text: e.text + o,
                    isComplete: r
                  });
                  return C(n, a, t);
                }
                return e;
              }));
            }), b(e);
          }, []), (0, d.useEffect)(() => {
            if (y) return y.initialize().then(S), () => {
              y.destroy();
            };
          }, [y, S]), (0, d.useEffect)(() => {
            y && (h(!0), y.setChatSessionId(t.chatSessionId).then(S));
          }, [t.chatSessionId]), (0, d.useEffect)(() => {
            y && (h(!0), y.setDocumentHandle(n).then(S));
          }, [n]), (0, d.useEffect)(() => {
            if (y && !p && o) {
              const e = y.emitAgentCompletion("SelectedTextSuggestedActions", "system", {
                context: o
              });
              i({
                text: "",
                agent: "ContextSpecificQA",
                parameters: {
                  context: o
                }
              }), v(t => [...t, {
                type: mD,
                id: `response-${e}`,
                text: "",
                sender: "AI",
                additionalContext: o.text,
                isComplete: !1,
                actions: [],
                linkToAdditionalContext: {
                  text: s(uD.s.goToSelection),
                  onPress: () => w((0, Ql.kN)(o.pageIndex, new _.UL(o.boundingBox)))
                }
              }]), w((0, Kt.vM)(null));
            }
          }, [y, w, p, o, s]), {
            messages: g,
            onSendMessage: D,
            isLoading: p,
            isConnected: u === sD.Connected,
            isGenerating: f
          };
        }
        const SD = ["text"];
        function ED(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function _D(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ED(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ED(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const PD = {
          value: "",
          agent: null,
          parameters: null
        };
        function kD(e) {
          let {
            toolbarsHeight: t,
            configuration: n,
            documentHandle: r,
            documentId: o,
            isOpen: i
          } = e;
          const a = (0, yb.Me)(),
            s = (0, l.v9)(e => e.instance),
            u = (0, l.v9)(e => e.documentAssistant.additionalContext),
            [c, p] = (0, d.useState)(PD),
            h = (0, d.useRef)(null),
            f = (0, po.R9)(() => {
              var e;
              return null === (e = n.onMessageSubmit) || void 0 === e || e.call(n), {
                agent: c.agent,
                parameters: c.parameters
              };
            }),
            m = (0, d.useCallback)(e => {
              var t;
              let {
                  text: n
                } = e,
                r = (0, ne.Z)(e, SD);
              h.current && (p(_D({
                value: n
              }, r)), h.current.setCaretPosition(null !== (t = n.lastIndexOf('"')) && void 0 !== t ? t : -1));
            }, []),
            {
              messages: g,
              onSendMessage: v,
              isLoading: y,
              isConnected: b,
              isGenerating: w
            } = CD({
              configuration: n,
              documentHandle: r,
              documentId: o,
              additionalContext: u,
              onTemplateAction: m,
              onMessageSubmit: f
            }),
            x = (0, l.I0)(),
            D = (0, d.useCallback)(() => {
              x((0, Kt.Z_)(!1));
            }, [x]),
            C = (0, l.v9)(e => e.ui[gw.x.ChatDialog]),
            S = (0, d.useCallback)(e => {
              v(e), p(PD);
            }, [v]),
            E = (0, d.useMemo)(() => ({
              editorHandle: h,
              isLoading: y,
              isSubmitDisabled: !b || w || y,
              messages: g,
              onMessageSubmit: S,
              onInputChanged: e => p(t => _D(_D({}, t), {}, {
                value: e
              })),
              titleId: a,
              style: {
                height: "calc(100% - 49px)",
                minHeight: "40vh",
                maxHeight: "80vh"
              },
              inputValue: c.value
            }), [w, b, a, c, p, S, y, g]),
            _ = (0, d.useMemo)(() => ({
              titleId: a,
              onCloseRequest: D,
              toolbarsHeight: t,
              isOpen: i
            }), [a, D, t, i]);
          return ww(gw.x.ChatDialog, C, E, s, _);
        }
        function AD(e) {
          let {
            isOpen: t,
            configuration: n,
            toolbarsHeight: r,
            documentId: o,
            documentHandle: i
          } = e;
          const a = function (e) {
            let {
              isMounted: t,
              delay: n
            } = e;
            const [r, o] = (0, d.useState)(!1);
            return (0, d.useEffect)(() => {
              let e;
              return t && !r ? o(!0) : !t && r && (e = setTimeout(() => o(!1), n)), () => clearTimeout(e);
            }, [t, n, r]), r;
          }({
            isMounted: t,
            delay: 200
          });
          return a ? d.createElement(kD, {
            configuration: n,
            toolbarsHeight: r,
            documentId: o,
            documentHandle: i,
            isOpen: t
          }) : null;
        }
        var zD = n(43098),
          TD = n(83034);
        function OD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ID(e, t, n, r, i) {
          const a = (0, Kn.Ez)(e, r),
            s = !!(0, to.kR)(e, r),
            l = !!(0, to.kR)(e, r),
            u = r.anonymousComments,
            c = r.dateTimeString,
            p = !a && s,
            h = t > 0 && n.get(t - 1),
            f = !!h && (h.creatorName !== e.creatorName || e.isAnonymous || h.isAnonymous);
          return (0, mw.kG)(e.id), function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? OD(Object(n), !0).forEach(function (t) {
                (0, o.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OD(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({
            id: e.id,
            contentStringType: "xhtml" === e.text.format ? "html" : "plain",
            content: e.text.value || "",
            canEdit: p,
            isAnonymous: !!e.isAnonymous,
            canDelete: !a && l,
            canBeAnonymous: p && u,
            description: (null == c ? void 0 : c({
              dateTime: e.createdAt,
              element: ru.Y.COMMENT_THREAD,
              object: e
            })) || d.createElement(Wl.DateFormat, {
              date: e.createdAt,
              hour12: !0,
              hour: "numeric",
              minute: "numeric",
              month: "short",
              day: "numeric"
            })
          }, (f || 0 === t) && {
            name: e.isAnonymous ? i(ke.Z.anonymous) : e.creatorName || i(ke.Z.anonymous),
            avatarProps: {
              name: e.isAnonymous ? "?" : e.creatorName || "?",
              className: "PSPDFKit-Comment-Avatar"
            }
          });
        }
        function FD(e) {
          const t = new DOMParser().parseFromString(e, "text/html");
          return t.body.querySelectorAll("u").forEach(e => {
            const t = document.createElement("span");
            t.style.textDecoration = "underline", t.innerHTML = e.innerHTML, e.replaceWith(t);
          }), t.body.innerHTML;
        }
        function MD(e) {
          let {
            onResize: t,
            commentThread: n,
            comments: r
          } = e;
          const o = (0, l.v9)(e => e),
            {
              maxMentionSuggestions: i,
              anonymousComments: a,
              keepSelectedTool: u,
              mentionableUsers: c
            } = o,
            p = (0, yb.Me)(),
            {
              formatMessage: h
            } = (0, Wl.useI18n)(),
            f = (0, l.I0)(),
            m = (0, d.useRef)(null);
          (0, d.useEffect)(() => {
            const e = m.current;
            if (!e || !t) return;
            const n = new ResizeObserver(e => null == t ? void 0 : t(e[0]));
            return n.observe(e), () => n.disconnect();
          }, [t]);
          const g = n.map(e => {
              const t = r.get(e);
              return (0, mw.kG)(t), t;
            }).toList(),
            v = null == g ? void 0 : g.find(e => (0, Vs.kT)(e)),
            y = (0, d.useMemo)(() => g.filter(e => !(0, Vs.kT)(e)).map((e, t, n) => ID(e, t, n, o, h)).toJS(), [g, o, h]),
            b = d.useCallback(e => {
              if (!(0, gn.KY)(e)) return;
              const t = 0 === y.length;
              (0, mw.kG)(v);
              const n = v.set("text", {
                  format: "xhtml",
                  value: FD(e)
                }),
                r = n.rootId;
              (0, mw.kG)(r), f((0, yo.BY)(n)), f((0, yo.mh)(r)), t && f((0, _e.Df)((0, s.l4)([r]), null)), u && f((0, Kt.k6)());
            }, [y, v, f, u]),
            w = (0, d.useCallback)((e, t) => {
              const n = r.get(e);
              (0, mw.kG)(n);
              const o = n.set("isAnonymous", t);
              f((0, yo.gk)((0, s.aV)([o])));
            }, [r, f]),
            x = (0, d.useCallback)(e => {
              const t = r.get(e);
              (0, mw.kG)(t), f((0, yo.UM)(t));
            }, [r, f]),
            D = (0, d.useCallback)((e, t) => {
              const n = r.get(e);
              (0, mw.kG)(n);
              const o = n.set("text", {
                format: "xhtml",
                value: FD(t)
              });
              f((0, yo.BY)(o, n)), u && f((0, Kt.k6)());
            }, [r, f, u]),
            C = (0, d.useMemo)(() => a ? [{
              type: "toggle",
              props: {
                "aria-label": h(ke.Z.anonymous),
                icon: TD.sp,
                onPress: () => w((null == v ? void 0 : v.id) || "", !0),
                isSelected: !(null == v || !v.isAnonymous)
              }
            }] : [], [a, null == v ? void 0 : v.id, null == v ? void 0 : v.isAnonymous, h, w]);
          return {
            comments: y,
            titleId: p,
            mentionableUsers: c,
            maxMentionableUsersSuggestions: i,
            onAnonymousToggle: w,
            onDelete: x,
            onCommentUpdate: D,
            onCommentAdd: b,
            editorFooterButtons: C,
            ref: m,
            className: "PSPDFKit-Comment-Thread",
            allowCommentCreation: !!v,
            defaultEditorValue: (null == v ? void 0 : v.text.value) || void 0
          };
        }
        function RD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function jD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? RD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : RD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function BD(e, t) {
          if (!e) return !1;
          let n = !1;
          if ((0, Vs._P)(e, t)) {
            const r = null == e ? void 0 : e.last();
            (0, mw.kG)(null != r);
            const o = t.get(r);
            (0, mw.kG)(null != o), n = o.text.value.length > 0;
          }
          return n;
        }
        const ND = "PSPDFKit-CommentThread-Root";
        function LD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function VD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? LD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : LD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const KD = e => {
            let {
              annotation: t,
              commentThread: n,
              comments: r
            } = e;
            const o = (0, l.I0)(),
              i = (0, l.v9)(e => e.instance),
              a = (0, l.v9)(e => {
                var t;
                return null === (t = e.ui) || void 0 === t ? void 0 : t[gw.x.CommentThread];
              }),
              s = (0, l.v9)(e => e.viewportState),
              u = (0, l.v9)(e => e.rootElement),
              c = MD({
                commentThread: n,
                comments: r
              }),
              p = (0, d.useMemo)(() => {
                const e = null == u ? void 0 : u.getBoundingClientRect(),
                  n = (0, G.cr)(s, t.pageIndex);
                return t.boundingBox.apply(n).translate(new _.E9({
                  y: -e.top,
                  x: -e.left
                }));
              }, [t.boundingBox, t.pageIndex, u, s]),
              f = (0, d.useMemo)(() => VD(VD({}, c), {}, {
                variant: "popover",
                className: h()(c.className, {
                  "PSPDFKit-Comment-Thread-Selected": !0,
                  "PSPDFKit-Comment-Thread-Expanded": !0
                })
              }), [c]),
              m = (0, d.useMemo)(() => ({
                dialogTitleId: c.titleId,
                variant: "popover",
                referenceRect: p,
                onOutsideClick: () => {
                  o((0, _e.fz)());
                }
              }), [c.titleId, o, p]);
            return ww(gw.x.CommentThread, a, f, i, m);
          },
          qD = e => {
            let {
              annotation: t,
              onResize: n,
              style: r,
              "aria-label": o,
              commentThread: i,
              comments: a,
              containerRef: u
            } = e;
            const c = (0, l.v9)(e => {
                var t;
                return null === (t = e.ui) || void 0 === t ? void 0 : t[gw.x.CommentThread];
              }),
              p = MD({
                onResize: n,
                commentThread: i,
                comments: a
              }),
              f = (0, l.I0)(),
              m = (0, l.v9)(e => e.instance),
              g = (0, l.v9)(e => e.annotations),
              v = (0, l.v9)(e => e.selectedAnnotationIds),
              y = g.get(v.first()),
              b = (0, Vs.en)(i, a),
              w = (null == y ? void 0 : y.id) === t.id || BD(i, a),
              x = (0, d.useCallback)(() => {
                w || (f((0, yo.Dm)()), f((0, _e.Df)((0, s.l4)([t.id]), null)));
              }, [t.id, f, w]);
            (0, d.useEffect)(() => {
              if (u.current) {
                const e = u.current;
                return e.addEventListener("click", x, !0), () => {
                  e.removeEventListener("click", x, !0);
                };
              }
            }, [x, u]);
            const D = (0, d.useMemo)(() => VD(VD({}, p), {}, {
                className: h()(p.className, {
                  "PSPDFKit-Comment-Thread-Selected": w
                }),
                variant: "sidebar",
                "aria-label": o,
                state: {
                  isExpanded: w
                },
                style: r,
                onStateChange: e => {
                  "isExpanded" in e && (w ? f((0, _e.fz)()) : (f((0, yo.Dm)()), f((0, _e.Df)((0, s.l4)([t.id]), null))));
                },
                onEditorValueChange: e => {
                  b && f((0, yo.gk)((0, s.aV)([b.update("text", t => VD(VD({}, t), {}, {
                    value: e
                  }))])));
                }
              }), [p, t.id, o, f, b, w, r]),
              C = (0, d.useMemo)(() => ({
                dialogTitleId: p.titleId,
                variant: "sidebar"
              }), [p.titleId]);
            return ww(gw.x.CommentThread, c, D, m, C);
          };
        function HD(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function UD(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? HD(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : HD(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const ZD = () => {
            const e = (0, l.v9)(e => e.annotations),
              t = (0, l.v9)(e => e.selectedAnnotationIds),
              n = (0, l.v9)(e => e.viewportState),
              r = (0, l.v9)(e => e.commentThreads),
              o = (0, l.v9)(e => e.comments),
              i = d.useRef(null),
              a = d.useMemo(() => {
                const e = (0, G.G4)(n);
                return Math.ceil(e.left) + e.width + n.viewportPadding.x;
              }, [n]),
              {
                threadInfo: s,
                updatePosition: c,
                totalHeight: p
              } = function (e) {
                const t = (0, l.v9)(e => e.annotations),
                  n = (0, l.v9)(e => e.commentThreads),
                  r = (0, l.v9)(e => e.viewportState),
                  o = (0, l.v9)(e => e.selectedAnnotationIds),
                  i = (0, d.useRef)(0),
                  {
                    currentPageIndex: a,
                    layoutMode: s
                  } = r,
                  u = s === Mh.X.SINGLE ? 2 : 4,
                  c = d.useMemo(() => Object.entries(n.map((e, n) => {
                    const o = t.get(n);
                    return o && "number" == typeof o.pageIndex ? (0, Vs.nN)(o, r) : -1;
                  }).toJSON()).sort((e, t) => e[1] - t[1]), [t, n, r]),
                  [p, h] = d.useState(n.map((e, t) => ({
                    rootId: t,
                    top: 0,
                    isVisible: !1
                  })).toList().toJS()),
                  f = t.get(o.first()),
                  m = (0, d.useCallback)(() => {
                    let n = 0;
                    i.current = 0;
                    const r = c.map(r => {
                      var o;
                      let [s, l] = r;
                      const c = t.get(s);
                      if (!c || "number" != typeof c.pageIndex) return null;
                      if (c.pageIndex < a - u || c.pageIndex > a + u) return null;
                      (0, mw.kG)(l);
                      const d = (null === (o = e.current) || void 0 === o || null === (o = o.querySelector(`.${ND}[data-root-id="${s}"]`)) || void 0 === o ? void 0 : o.clientHeight) || 0,
                        p = Math.max(l, i.current);
                      return (null == f ? void 0 : f.id) === s && (n = p - l), i.current = p + d + 10, {
                        rootId: s,
                        top: p,
                        isVisible: !0
                      };
                    }).filter(e => null !== e).map(e => jD(jD({}, e), {}, {
                      top: e.top - n
                    }));
                    h(r);
                  }, [t, c, a, u, e, f]);
                return (0, d.useLayoutEffect)(m, [m, n]), {
                  threadInfo: p,
                  updatePosition: m,
                  totalHeight: i.current
                };
              }(i),
              f = e.get(t.first()),
              m = f && r.get(null == f ? void 0 : f.id);
            return n.commentMode === Xf._.PANE || n.zoomMode === os.c.FIT_TO_WIDTH ? f && m ? d.createElement(KD, {
              annotation: f,
              commentThread: m,
              comments: o
            }) : null : d.createElement("aside", {
              style: {
                transform: `translate(${a}px)`,
                height: p + 2 * n.viewportPadding.y
              },
              ref: i,
              className: h()((0, Aw.Kj)({
                position: "absolute"
              }), "_1gtjs4n0", "PSPDFKit-Comment-Threads")
            }, null == s ? void 0 : s.filter(Boolean).map(e => ((0, u.kG)(e), d.createElement($D, (0, ce.Z)({
              key: e.rootId
            }, e, {
              updatePosition: c
            })))));
          },
          $D = e => {
            var t, n;
            let {
              rootId: r,
              top: o,
              isVisible: i,
              updatePosition: a
            } = e;
            const s = (0, l.v9)(e => e.annotations.get(r)),
              u = (0, l.v9)(e => e.comments),
              {
                formatMessage: c
              } = (0, xe.YB)(),
              p = u.filter(e => e.rootId === r).toList(),
              f = (0, l.v9)(e => {
                const t = e.selectedAnnotationIds;
                return t.size > 0 ? e.annotations.get(t.first()) : null;
              }),
              m = (0, l.v9)(e => e.commentThreads.get(r)),
              g = BD(m, u),
              v = d.useRef(!0),
              y = p.every(e => null === e.id),
              b = !(!f || f.id !== (null == s ? void 0 : s.id)),
              w = b || g,
              [x, D] = (0, zD.q_)(() => ({
                transform: `translate(${b && y && !v ? -40 : 0}px, ${o}px)`,
                opacity: y ? 0 : 1,
                immediate: !i,
                config: zD.vc.stiff
              }));
            (0, d.useLayoutEffect)(() => {
              D.start({
                transform: `translate(${b ? -40 : 0}px, ${o}px)`,
                opacity: 1,
                immediate: !i
              });
            }, [D, b, o, i]);
            const C = w ? p : p.take(1),
              S = w ? c(GD.commentThread) : c(GD.commentDialogClosed, {
                arg0: null === (t = C.first()) || void 0 === t ? void 0 : t.creatorName,
                arg1: null === (n = C.first()) || void 0 === n ? void 0 : n.text.value
              }),
              E = (0, d.useRef)(null);
            return s && "number" == typeof s.pageIndex && m ? d.createElement(zD.q.div, {
              key: r,
              className: h()("_1gtjs4n1", ND),
              "data-root-id": r,
              style: UD({
                visibility: i ? void 0 : "hidden",
                zIndex: b ? 999 : 0
              }, x),
              ref: E
            }, d.createElement(qD, {
              annotation: s,
              "aria-label": S,
              onResize: a,
              commentThread: m,
              comments: u,
              containerRef: E
            })) : null;
          },
          GD = (0, xe.vU)({
            commentDialogClosed: {
              id: "commentDialogClosed",
              defaultMessage: "Open comment thread started by {arg0}: “{arg1}”",
              description: "With the dialog closed, show the author of the comment and the number of replies."
            },
            commentThread: {
              id: "commentThread",
              defaultMessage: "Comment Thread",
              description: "Comment thread."
            }
          });
        var WD,
          YD,
          XD,
          QD,
          JD,
          eC,
          tC,
          nC,
          rC = n(56479);
        function oC() {
          const e = (0, l.I0)(),
            {
              formatMessage: t
            } = (0, xe.YB)();
          return d.createElement(Wl.Modal, {
            isOpen: !0
          }, d.createElement(Wl.ModalContent, null, d.createElement(Wl.AlertDialog, {
            title: t(ah.ceDownloadRequiredTitle),
            message: t(ah.ceDownloadRequiredMessage),
            primaryActionLabel: t(ah.ceDownloadRequiredButton),
            cancelLabel: t(ke.Z.cancel),
            icon: rC.F3,
            iconColor: "var(--bui-color-support-info-medium)",
            onPrimaryAction: () => {
              (0, l.dC)(() => {
                e({
                  type: V.iR6,
                  promptContentEditorDocumentDownload: !1
                }), e({
                  type: V.fBs,
                  isServerModeDownloadingDocument: !0
                });
              }), e(th.ss);
            },
            onCancel: () => {
              e({
                type: V.iR6,
                promptContentEditorDocumentDownload: !1
              });
            },
            showCloseButton: !1
          })));
        }
        function iC() {
          const e = (0, l.I0)(),
            {
              formatMessage: t
            } = (0, xe.YB)();
          return d.createElement(Wl.Modal, {
            isOpen: !0
          }, d.createElement(Wl.ModalContent, null, d.createElement(Wl.AlertDialog, {
            title: t(ah.ceCannotSaveChangesTitle),
            message: t(ah.ceCannotSaveChangesMessage),
            primaryActionLabel: t(ah.ceCannotSaveChangesButton),
            cancelLabel: t(ah.ceCannotSaveChangesReviewButton),
            icon: rC.av,
            iconColor: "var(--bui-color-support-warning-medium)",
            onPrimaryAction: () => {
              e({
                type: V.guy,
                promptContentEditorCannotSaveChanges: !1
              }), e(th.u8);
            },
            onCancel: () => {
              e({
                type: V.guy,
                promptContentEditorCannotSaveChanges: !1
              });
            },
            showCloseButton: !0
          })));
        }
        function aC(e) {
          let {
            intlMessageDescriptor: t
          } = e;
          const {
            formatMessage: n
          } = (0, xe.YB)();
          return d.createElement(Wl.Modal, {
            isOpen: !0
          }, d.createElement(Wl.ModalContent, null, d.createElement(Wl.ProgressSpinner, {
            label: n(t),
            className: Lv().progressSpinner
          })));
        }
        function sC(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function lC(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? sC(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sC(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function uC(e) {
          return it.Options.DISABLE_KEYBOARD_SHORTCUTS || e.viewportState.scrollMode === us.G.DISABLED ? e.children : d.createElement(lf, e);
        }
        const cC = function (e) {
          var t;
          switch (e.theme) {
            case fw.Q.AUTO:
              return null !== (t = e.frameWindow) && void 0 !== t && t.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
            case fw.Q.DARK:
              return "dark";
            case fw.Q.LIGHT:
              return "light";
          }
        };
        class dC extends d.Component {
          constructor() {
            super(...arguments), (0, o.Z)(this, "state", {
              isResizingSidebar: !1,
              scrollElement: null,
              silenceOutdatedDocumentPromptForHandle: null,
              filteredItems: (0, gc.I4)(this.props.state),
              isAnnotationTypeReadOnlyMemoized: (0, dn.Z)((e, t) => (0, Kn.j$)(e, this.props.state, t)),
              crop: null,
              modalClosurePreventionError: null,
              noLicenseKeyTimeoutFinished: !1,
              resizeWatchFrameWindow: null,
              theme: cC(this.props.state)
            }), (0, o.Z)(this, "_memoizedMapPagesToPageKeys", (0, dn.Z)(e => e.map(e => e.pageKey))), (0, o.Z)(this, "handleScrollElementChange", e => {
              this.setState({
                scrollElement: e
              });
            }), (0, o.Z)(this, "getScrollElement", () => {
              const {
                scrollElement: e
              } = this.state;
              return (0, u.kG)(e), e;
            }), (0, o.Z)(this, "setGlobalCursor", e => {
              this.getScrollElement().style.cursor = e;
            }), (0, o.Z)(this, "getThumbnailScale", () => this.props.state.containerRect.width <= Ne.Fg ? .55 : 1), (0, o.Z)(this, "isAnnotationReadOnly", e => (0, Kn.lV)(e, this.props.state) || !(0, to.CM)(e, this.props.state)), (0, o.Z)(this, "isCommentReadOnly", e => (0, Kn.Ez)(e, this.props.state) || !(0, to.kR)(e, this.props.state)), (0, o.Z)(this, "reloadDocument", () => {
              const e = this.props.state.documentHandle;
              this.props.dispatch((0, pv.NV)(() => this.closeReloadDocumentModal(e), e => {
                throw e;
              }));
            }), (0, o.Z)(this, "closeReloadDocumentModal", e => {
              this.setState({
                silenceOutdatedDocumentPromptForHandle: e
              });
            }), (0, o.Z)(this, "_canDeleteAnnotationCP", e => (0, to.Kd)(e, this.props.state)), (0, o.Z)(this, "_canDeleteCommentCP", e => (0, to.Ss)(e, this.props.state)), (0, o.Z)(this, "renderSidebar", (e, t) => {
              const n = this.props.state,
                r = this.props.state.containerRect.width - e <= t,
                o = n.viewportState.scrollMode === us.G.DISABLED,
                i = n.sidebarOptions;
              if (e <= 0) return null;
              switch (n.sidebarMode) {
                case Jl.f.THUMBNAILS:
                  return d.createElement(Cg, {
                    scale: this.getThumbnailScale(),
                    width: e,
                    selectedPageIndex: n.viewportState.currentPageIndex,
                    closeOnPress: r,
                    navigationDisabled: o
                  });
                case Jl.f.DOCUMENT_OUTLINE:
                  return d.createElement(af, {
                    outlineElements: n.documentOutlineState.elements,
                    expanded: n.documentOutlineState.expanded,
                    closeOnPress: r,
                    backend: n.backend,
                    documentHandle: n.documentHandle,
                    navigationDisabled: o
                  });
                case Jl.f.ANNOTATIONS:
                  return d.createElement(wu, {
                    pages: n.pages,
                    annotations: n.annotations,
                    comments: n.comments,
                    commentThreads: n.commentThreads,
                    formFields: n.formFields,
                    isAnnotationReadOnly: this.isAnnotationReadOnly,
                    isCommentReadOnly: this.isCommentReadOnly,
                    selectedAnnotationIds: n.selectedAnnotationIds,
                    sidebarOptions: i[Jl.f.ANNOTATIONS],
                    closeOnPress: r,
                    navigationDisabled: o,
                    canDeleteAnnotationCP: this._canDeleteAnnotationCP,
                    canDeleteCommentCP: this._canDeleteCommentCP,
                    focusedAnnotationIds: n.focusedAnnotationIds
                  });
                case Jl.f.BOOKMARKS:
                  return d.createElement(uv, {
                    source: n.bookmarkManager
                  }, t => d.createElement(lv, {
                    bookmarks: t,
                    bookmarkManager: n.bookmarkManager,
                    currentPageIndex: n.viewportState.currentPageIndex,
                    pages: n.pages,
                    width: e,
                    closeOnPress: r
                  }));
                case Jl.f.SIGNATURES:
                  return d.createElement(mb, {
                    annotations: n.annotations,
                    formFields: n.formFields,
                    signaturesInfo: n.digitalSignatures,
                    closeOnPress: r,
                    navigationDisabled: o
                  });
                case Jl.f.LAYERS:
                  return d.createElement(rw, {
                    sidebarOptions: i[Jl.f.LAYERS],
                    setSidebarOptions: e => this.setSidebarOptions(Jl.f.LAYERS, e),
                    OCGLayers: n.OCGLayers,
                    visibleLayers: n.visibleOCGLayers
                  });
                case Jl.f.CUSTOM:
                  return WD || (WD = d.createElement(rv, null));
                default:
                  return null;
              }
            }), (0, o.Z)(this, "_viewportEl", null), (0, o.Z)(this, "_viewportRef", e => {
              e ? (this._viewportEl = e, this._viewportEl.addEventListener("copy", this._copyEventHandler)) : this._viewportEl && (this._viewportEl.removeEventListener("copy", this._copyEventHandler), this._viewportEl = null);
            }), (0, o.Z)(this, "_copyEventHandler", e => {
              var t, n;
              if (!this._viewportEl) return;
              if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
              const {
                  shadowRoot: r,
                  frameWindow: o
                } = this.props.state,
                i = r ? (0, y.HY)(r).selection : null == o ? void 0 : o.getSelection();
              null === (t = e.clipboardData) || void 0 === t || t.setData("text/plain", null !== (n = null == i ? void 0 : i.toString()) && void 0 !== n ? n : ""), e.preventDefault();
            }), (0, o.Z)(this, "renderViewport", e => {
              var t, n;
              const {
                  selectedAnnotation: r,
                  state: o,
                  dispatch: i
                } = this.props,
                {
                  viewportState: a
                } = o,
                s = r && null !== r.pageIndex && "function" == typeof o.annotationTooltipCallback && !o.interactionsDisabled ? o.annotationTooltipCallback(r) : [];
              return d.createElement(Km, {
                dispatch: this.props.dispatch,
                currentTextSelection: this.props.state.currentTextSelection,
                selectedAnnotationIds: this.props.state.selectedAnnotationIds,
                activeAnnotationNote: this.props.state.activeAnnotationNote,
                rootElement: null === (t = this.props.state.frameWindow) || void 0 === t ? void 0 : t.document.documentElement,
                interactionMode: this.props.state.interactionMode,
                modalClosurePreventionError: this.state.modalClosurePreventionError,
                shadowRoot: this.props.state.shadowRoot
              }, d.createElement("div", {
                style: {
                  position: "relative",
                  height: "100%"
                }
              }, d.createElement(jg, {
                viewportState: a,
                scrollbarOffset: o.scrollbarOffset
              }, d.createElement(uC, {
                dispatch: i,
                viewportState: a,
                hasSelectedAnnotations: this.props.state.selectedAnnotationIds.size > 0,
                document: null === (n = o.frameWindow) || void 0 === n ? void 0 : n.document,
                shadowRoot: o.shadowRoot
              }, d.createElement(ue.Provider, null, a.scrollMode === us.G.PER_SPREAD ? d.createElement(Jf, {
                dispatch: i,
                viewportState: a,
                hasSelection: this.props.state.selectedAnnotationIds.size > 0 || null !== this.props.state.currentTextSelection,
                scrollElement: this.state.scrollElement,
                interactionsDisabled: o.interactionsDisabled
              }, this.renderViewportContent(s, e)) : this.renderViewportContent(s, e))), this._isFullscreen && this.renderExpandendNoteAnnotations(s))));
            }), (0, o.Z)(this, "_handleDocumentEditorCancel", () => {
              this.props.dispatch((0, Kt.sJ)());
            }), (0, o.Z)(this, "_closeSignatureModal", () => {
              const e = {
                annotations: (0, s.aV)(),
                reason: J.f.SELECT_END
              };
              this.props.state.eventEmitter.emit("annotations.willChange", e), this.props.dispatch((0, Kt.MV)());
            }), (0, o.Z)(this, "_createSignatureFromAnnotation", (e, t, n) => {
              e instanceof de.Zc && this.props.dispatch((0, yt.gX)({
                strokeColor: e.strokeColor
              }));
              const {
                  signatureRect: r,
                  signaturePageIndex: o
                } = this.props.state.signatureState,
                {
                  attachments: i
                } = this.props.state;
              let a;
              if ("imageAttachmentId" in e && e.imageAttachmentId && i.has(e.imageAttachmentId)) {
                const t = i.get(e.imageAttachmentId);
                (0, u.kG)(t), a = {
                  hash: e.imageAttachmentId,
                  attachment: t
                };
              }
              this.props.dispatch((0, hv.Th)(e, {
                signatureRect: r,
                signaturePageIndex: o
              }, a)), t && this.props.dispatch((0, hv.T6)(e, n)), this.props.dispatch((0, Kt.MV)());
            }), (0, o.Z)(this, "_createSignatureFromFile", async (e, t, n) => {
              const {
                signatureRect: r,
                signaturePageIndex: o
              } = this.props.state.signatureState;
              this.props.dispatch((0, Kt.MV)());
              const {
                hash: i,
                dimensions: a,
                attachment: s
              } = await (0, yt.Iv)(e);
              this.props.dispatch((0, hv.l5)({
                hash: i,
                dimensions: a,
                attachment: s,
                file: e
              }, t, n, {
                signatureRect: r,
                signaturePageIndex: o
              }));
            }), (0, o.Z)(this, "_createSignature", (e, t, n) => {
              e instanceof de.q6 ? this._createSignatureFromAnnotation(e, t, n) : this._createSignatureFromFile(e, t, n);
            }), (0, o.Z)(this, "_deleteStoredSignature", (e, t) => {
              this.props.dispatch((0, hv.Bm)(e, t));
            }), (0, o.Z)(this, "_closeStampModal", () => {
              const e = {
                annotations: (0, s.aV)(),
                reason: J.f.SELECT_END
              };
              this.props.state.eventEmitter.emit("annotations.willChange", e), this.props.dispatch((0, Kt.pM)());
            }), (0, o.Z)(this, "_createAnnotationFromTemplate", e => {
              this.props.dispatch((0, Kt.pM)()), this.props.dispatch((0, yt.ip)(e));
            }), (0, o.Z)(this, "_getAttachments", () => this.props.state.attachments), (0, o.Z)(this, "_fetchDigitalSignaturesInfo", () => {
              var e;
              null === (e = this.props.state.backend) || void 0 === e || e.getSignaturesInfo().then(e => {
                this.props.dispatch((0, Kg.Y)(e));
              }).catch(u.vU);
            }), (0, o.Z)(this, "_setA11yStatusMessage", e => {
              this.props.dispatch((0, Kt.iJ)("")), window.setTimeout(() => {
                this.props.dispatch((0, Kt.iJ)(e));
              }, 200);
            }), (0, o.Z)(this, "isDocumentComparisonAvailable", () => (0, Ev.RG)(this.props.state)), (0, o.Z)(this, "handleCrop", e => {
              (0, u.kG)(this.state.crop), this.props.dispatch((0, pv.b_)([{
                type: "cropPages",
                cropBox: this.state.crop.area,
                pageIndexes: e ? void 0 : [this.state.crop.pageIndex]
              }], () => {}, () => {})), this.props.dispatch((0, Kt.Cn)());
            }), (0, o.Z)(this, "setCropDetails", (e, t) => {
              this.setState({
                crop: {
                  area: e,
                  pageIndex: t
                }
              });
            }), (0, o.Z)(this, "onCropCancel", () => {
              const {
                dispatch: e
              } = this.props;
              e((0, Kt.Cn)());
            }), (0, o.Z)(this, "onSelectButtonImportIconImage", e => {
              const {
                  dispatch: t,
                  state: n
                } = this.props,
                {
                  backend: r
                } = n;
              if ((0, u.kG)(r), !e) return void this.props.dispatch((0, er._4)(null));
              const o = new FileReader();
              o.onload = async () => {
                const n = this.props.state.buttonToImportIconFor;
                await r.updateButtonIcon(n, o.result, e.type), t((0, er._4)(null)), r.clearPageAPStreams(null == n ? void 0 : n.pageIndex, (0, s.l4)([n.id])), t((0, yt.Zr)((0, s.aV)([n.set("buttonIconUpdatedAt", Date.now())])));
              }, o.readAsArrayBuffer(e);
            }), (0, o.Z)(this, "getToolbarComponent", () => {
              const {
                  selectedAnnotation: e,
                  activeAnnotationNote: t,
                  state: n,
                  currentTextSelection: r
                } = this.props,
                {
                  viewportState: o,
                  selectedAnnotationIds: i
                } = n,
                a = n.toolbarPlacement === nu.p.TOP ? "top" : "bottom",
                s = n.selectedAnnotationIds.every(e => {
                  const t = n.annotations.get(e);
                  return !!t && "isMeasurement" in t && t.isMeasurement();
                });
              if (n.selectedAnnotationIds.size > 1 && !s) return d.createElement(nb, {
                selectedAnnotationIds: i
              });
              if (e && !(0, Ke.fF)(n.interactionMode) || t) {
                const r = e ? n.pages.get(e.pageIndex) : null,
                  a = r && r.pageSize,
                  s = e && n.annotationPresetIds.get(e.id),
                  l = !(!e || !(0, to.CM)(e, n)),
                  u = (0, Kn.aE)(this.props.state),
                  c = !(!e || !(0, to.Kd)(e, n)),
                  p = i.map(e => n.annotations.get(e));
                return d.createElement(Nd, {
                  dispatch: this.props.dispatch,
                  annotation: e,
                  selectedAnnotationPageSize: a,
                  isAnnotationReadOnly: this.isAnnotationReadOnly,
                  variantAnnotationPresetID: s,
                  selectedAnnotationMode: this.props.state.selectedAnnotationMode,
                  zoomLevel: o.zoomLevel,
                  position: n.toolbarPlacement === nu.p.TOP ? "top" : "bottom",
                  eventEmitter: n.eventEmitter,
                  frameWindow: n.frameWindow,
                  viewportWidth: n.containerRect.width,
                  activeAnnotationNote: t,
                  showAnnotationNotes: this.props.state.showAnnotationNotes,
                  canEditAnnotationCP: l,
                  canDeleteSelectedAnnotationCP: c,
                  areOnlyElectronicSignaturesEnabled: u,
                  lastToolbarActionUsedKeyboard: n.lastToolbarActionUsedKeyboard,
                  interactionMode: n.interactionMode,
                  keepSelectedTool: this.props.state.keepSelectedTool,
                  annotationToolbarColorPresets: n.annotationToolbarColorPresets,
                  annotationToolbarItems: n.annotationToolbarItems,
                  richTextEditorRef: n.richTextEditorRef,
                  customFontsReadableNames: n.customFontsReadableNames,
                  isCalibratingScale: n.isCalibratingScale,
                  selectedAnnotations: p
                });
              }
              var l, u;
              return n.interactionMode === B.A.INK_ERASER ? d.createElement(qd, {
                dispatch: this.props.dispatch,
                inkEraserCursorWidth: null !== (l = null === (u = n.annotationPresets.get("ink")) || void 0 === u ? void 0 : u.inkEraserWidth) && void 0 !== l ? l : it.Options.DEFAULT_INK_ERASER_CURSOR_WIDTH,
                position: a,
                viewportWidth: n.containerRect.width
              }) : n.interactionMode === B.A.DOCUMENT_CROP ? d.createElement(gv, {
                onCropApply: this.handleCrop,
                onCropCancel: this.onCropCancel,
                position: a,
                isCropAreaSelected: !!this.state.crop,
                frameWindow: n.frameWindow
              }) : (0, Ke.fF)(n.interactionMode) ? d.createElement(Zv, {
                position: a,
                interactionMode: n.interactionMode,
                dispatch: this.props.dispatch,
                frameWindow: n.frameWindow,
                modalClosurePreventionError: this.state.modalClosurePreventionError,
                selectedAnnotation: !!n.selectedAnnotationIds.size
              }) : n.interactionMode === B.A.CONTENT_EDITOR && n.contentEditorSession.contentEditor ? d.createElement(wv, {
                position: a,
                viewportWidth: n.containerRect.width,
                frameWindow: n.frameWindow,
                creationMode: n.contentEditorSession.mode === Js.wR.Create
              }) : n.interactionMode === B.A.MEASUREMENT ? d.createElement(rb, {
                position: a,
                interactionMode: n.interactionMode,
                viewportWidth: n.containerRect.width,
                frameWindow: n.frameWindow,
                disablePointSnapping: n.viewportState.disablePointSnapping,
                backend: n.backend
              }) : d.createElement(Ef, {
                dispatch: this.props.dispatch,
                isAnnotationTypeReadOnly: this.state.isAnnotationTypeReadOnlyMemoized,
                position: n.toolbarPlacement === nu.p.TOP ? "top" : "bottom",
                showComments: (0, Vs.oK)(n),
                showRedactions: this.props.state.features.includes(ee.q.REDACTIONS),
                showDocumentAssistant: this.props.state.features.includes(ee.q.DOCUMENT_ASSISTANT) && !!this.props.state.documentAssistant.configuration,
                inlineTextSelectionToolbarItems: n.inlineTextSelectionToolbarItems,
                currentTextSelection: r
              });
            }), (0, o.Z)(this, "handleSidebarResize", e => {
              let {
                sidebarRect: t,
                isDragging: n,
                size: r
              } = e;
              const o = (0, qv.p)(this.props.state, t, r);
              this.props.dispatch((0, Ql.dx)(o, !1)), this.setState({
                isResizingSidebar: n
              });
            }), (0, o.Z)(this, "handleResizeHelperResize", (e, t) => {
              const n = this.props.state,
                r = e.width,
                o = n.shadowRoot ? e.left : 0,
                i = n.containerRect.width === n.sidebarWidth,
                a = !i && r - n.sidebarWidth < 200;
              let s;
              n.sidebarMode && !a ? i ? (s = e.set("width", r).set("left", o), this.props.dispatch((0, Ql.Pt)(r))) : s = e.set("width", r - n.sidebarWidth).set("left", (n.sidebarPlacement === eu.d.START ? n.sidebarWidth : 0) + o) : (s = e, n.sidebarMode && a && this.props.dispatch((0, Kt.mu)())), this.props.dispatch((0, Ql.dx)(s, t));
            }), (0, o.Z)(this, "_updateResizeWatchFrameWindow", e => {
              this.setState({
                resizeWatchFrameWindow: e
              });
            });
          }
          setSidebarOptions(e, t) {
            const {
              state: n
            } = this.props;
            this.props.dispatch((0, Kt.vI)(lC(lC({}, n.sidebarOptions), {}, {
              [e]: t
            })));
          }
          renderViewportContent(e, t) {
            const {
                selectedAnnotation: n,
                selectedFormField: r,
                state: o,
                dispatch: i,
                currentTextSelection: a
              } = this.props,
              {
                viewportState: l,
                interactionsDisabled: u,
                interactionMode: c,
                formFields: p,
                frameWindow: h,
                eventEmitter: f,
                locale: m,
                scrollElement: g,
                measurementToolState: v,
                contentEditorSession: {
                  fontMismatchTooltip: y,
                  textBlockInteractionState: b
                },
                selectedAnnotationIds: w
              } = o;
            let x = null;
            if (o.interactionMode !== B.A.TEXT_HIGHLIGHTER && !o.interactionsDisabled && a && !t(de.On) && o.inlineTextMarkupToolbar) {
              const e = (0, Vs.oK)(this.props.state),
                n = this.props.state.features.includes(ee.q.REDACTIONS),
                r = this.props.state.features.includes(ee.q.DOCUMENT_ASSISTANT) && !!this.props.state.documentAssistant.configuration,
                s = this.props.state.inlineTextSelectionToolbarItems ? this.props.state.inlineTextSelectionToolbarItems({
                  defaultItems: lb({
                    showComments: e,
                    showRedactions: n,
                    showDocumentAssistant: r
                  }),
                  hasDesktopLayout: !1
                }, a) : lb({
                  showComments: e,
                  showRedactions: n,
                  showDocumentAssistant: r
                }),
                u = (0, yi.U2)(o, a.textRange);
              x = s.length > 0 && u ? d.createElement(Nf.Z, {
                referenceRect: u,
                viewportState: l,
                className: "PSPDFKit-Popover-Text-Markup-Toolbar"
              }, d.createElement(Sf, {
                dispatch: i,
                isAnnotationTypeReadOnly: t,
                showComments: e,
                showRedactions: n,
                showDocumentAssistant: r,
                inlineTextSelectionToolbarItems: this.props.state.inlineTextSelectionToolbarItems,
                currentTextSelection: a
              })) : null;
            }
            let D = null;
            const C = o.annotations.filter(e => e.readOnly || e.locked || e.lockedContents),
              S = o.hoverAnnotationIds.find(e => C.has(e)),
              E = o.focusedAnnotationIds.find(e => C.has(e)),
              P = S ? C.get(S) : void 0,
              k = E ? C.get(E) : void 0;
            let A = (0, s.aV)();
            const z = !!P && (P instanceof _.Qi || (P instanceof de.Jn || P instanceof de.FV) && P.isCommentThreadRoot);
            let T, O;
            if (P && !z && (A = A.push(P)), k && (A = A.push(k)), A.size > 0 && A.map(e => {
              const t = (0, j.SY)(e, l.zoomLevel, l.pagesRotation).apply((0, G.cr)(l, e.pageIndex).translate(l.scrollPosition.scale(l.zoomLevel)));
              return D = d.createElement(sb, {
                referenceRect: t,
                viewportState: l,
                isReadOnly: e.readOnly,
                isLocked: e.locked,
                hasLockedContents: e.lockedContents
              });
            }), T = o.viewportState.documentComparisonMode && o.backend ? d.createElement(_v.ZP, {
              renderPageCallback: o.renderPageCallback,
              backend: o.backend,
              allowedTileScales: o.allowedTileScales,
              viewportState: o.viewportState,
              interactionMode: o.interactionMode,
              scrollElement: o.scrollElement,
              dispatch: i,
              configuration: o.viewportState.documentComparisonMode,
              viewportWidth: o.containerRect.width,
              renderPagePreview: o.renderPagePreview
            }) : l.scrollMode === us.G.PER_SPREAD || l.scrollMode === us.G.DISABLED ? d.createElement($f, {
              onCropChange: this.setCropDetails,
              dispatch: i,
              spreadIndex: (0, ts.dF)(l, l.currentPageIndex),
              viewportState: l,
              interactionMode: o.interactionMode,
              cropInfo: this.state.crop,
              pageKeys: this._memoizedMapPagesToPageKeys(o.pages),
              setGlobalCursor: this.setGlobalCursor
            }) : d.createElement(Rh, {
              onCropChange: this.setCropDetails,
              dispatch: i,
              viewportState: l,
              cropInfo: this.state.crop,
              pageKeys: this._memoizedMapPagesToPageKeys(o.pages),
              setGlobalCursor: this.setGlobalCursor
            }), v && o.backend && (0, F.hj)(v.drawnAnnotationPageIndex)) {
              var I;
              const e = {
                inViewport: !0,
                page: o.pages.get(v.drawnAnnotationPageIndex),
                backend: o.backend,
                shouldPrerender: !0,
                zoomLevel: l.zoomLevel,
                rotation: l.pagesRotation,
                renderPageCallback: o.renderPageCallback,
                allowedTileScales: "all",
                documentHandle: o.documentHandle,
                viewportRect: l.viewportRect,
                forceDetailView: !1,
                renderPagePreview: o.renderPagePreview,
                isPageSizeReal: !!o.arePageSizesLoaded,
                inContentEditorMode: !1
              };
              let t = v.magnifierCursorPosition;
              const n = (0, ts.Ad)(l),
                r = (0, ts.dF)(l, v.drawnAnnotationPageIndex),
                i = (0, ts.Xk)(l, r);
              let a = (n - i.width) / 2 * l.zoomLevel;
              o.sidebarMode && (a += o.sidebarWidth);
              let s = 0;
              if ((0, ts.nw)(l) === Mh.X.DOUBLE) {
                const e = (0, ts.hK)(l, v.drawnAnnotationPageIndex);
                if (i.height !== e.height && (s = (i.height - e.height) / 2 * l.zoomLevel), v.drawnAnnotationPageIndex % 2 != 0) {
                  a += (0, ts.hK)(l, v.drawnAnnotationPageIndex - 1).width * l.zoomLevel;
                }
              }
              t = null === (I = v.magnifierCursorPosition) || void 0 === I ? void 0 : I.merge({
                x: v.magnifierCursorPosition.x - a,
                y: v.magnifierCursorPosition.y - s
              }), O = d.createElement(Xy.B, {
                pageRendererComponentProps: e,
                viewportState: l,
                scrollElement: g,
                className: "PSPDFKit-Measurement-Magnifier",
                label: v.magnifierLabel,
                pageIndex: v.drawnAnnotationPageIndex,
                cursorPosition: t,
                isMobile: o.containerRect.width <= Ne.Fg
              });
            }
            const M = n ? o.pages.get(n.pageIndex) : null,
              R = M && M.pageSize;
            return d.createElement(Cm, {
              dispatch: i,
              viewportState: l,
              scrollbarOffset: o.scrollbarOffset,
              onScrollElementChange: this.handleScrollElementChange,
              scrollDisabled: o.scrollDisabled
            }, d.createElement(Zf, {
              enabled: o.interactionMode === B.A.PAN && !De.Ni && !o.interactionsDisabled && !!o.scrollElement
            }, d.createElement("div", {
              className: Lv().viewportContent,
              ref: this._viewportRef,
              "data-testid": "viewport"
            }, T, (0, Vs.Y7)(o) && l.commentMode && (YD || (YD = d.createElement(ZD, null)))), x, D, n && !(n instanceof _.Qi) && e.length > 0 && !this.props.noteAnnotationToModify && d.createElement(Nf.Z, {
              referenceRect: (0, Xo.q)((0, j.Wj)(n, l.pagesRotation, l.viewportRect.getSize(), l.zoomLevel).apply((0, G.cr)(l, n.pageIndex).translate(l.scrollPosition.scale(l.zoomLevel))), l.viewportRect.getSize()),
              viewportState: l,
              className: "PSPDFKit-Popover-Annotation-Tooltip"
            }, d.createElement(Fg, {
              items: e
            })), n && null !== n.pageIndex && n instanceof _.UX && n.isMeasurement() && o.isCalibratingScale && d.createElement(Yl.ZP, {
              annotation: n,
              isHidden: u,
              referenceRect: (0, Xo.q)((0, j.Wj)(n, l.pagesRotation, l.viewportRect.getSize(), l.zoomLevel).apply((0, G.cr)(l, n.pageIndex).translate(l.scrollPosition.scale(l.zoomLevel))), l.viewportRect.getSize()),
              viewportState: l,
              eventEmitter: f,
              modalClosurePreventionError: this.state.modalClosurePreventionError,
              setModalClosurePreventionError: e => this.setState({
                modalClosurePreventionError: e
              }),
              frameWindow: h,
              locale: m
            }), n && r && 1 === w.size && (0, Ke.fF)(c) && n instanceof _.x_ && d.createElement(Oy, {
              modalClosurePreventionError: this.state.modalClosurePreventionError,
              setModalClosurePreventionError: e => this.setState({
                modalClosurePreventionError: e
              }),
              annotation: n,
              formField: r,
              getExistingFormFieldByName: e => p.get(e),
              isHidden: u,
              referenceRect: (0, Xo.q)((0, j.Wj)(n, l.pagesRotation, l.viewportRect.getSize(), l.zoomLevel).apply((0, G.cr)(l, n.pageIndex).translate(l.scrollPosition.scale(l.zoomLevel))), l.viewportRect.getSize()),
              viewportState: l,
              dispatch: i,
              frameWindow: h,
              eventEmitter: f,
              locale: m,
              isUnsavedAnnotation: n.id === this.props.state.formDesignerUnsavedWidgetAnnotation,
              pageSize: R,
              customFontsReadableNames: this.props.state.customFontsReadableNames || (0, s.l4)()
            }), this.renderLinkAnnotationPopover(), O, this.renderAnimatedExpandendNoteAnnotations(e), null != y && y.fontFace && (null == b ? void 0 : b.state) === Js.FP.Active && null != y && y.rect ? d.createElement(eb, {
              referenceRect: y.rect,
              fontFace: y.fontFace,
              viewportState: l,
              activeTextBlock: b
            }) : null));
          }
          getSnapshotBeforeUpdate(e) {
            const t = e.selectedNoteAnnotations && this.props.selectedNoteAnnotations && 0 !== e.selectedNoteAnnotations.size && e.selectedNoteAnnotations.size === this.props.selectedNoteAnnotations.size;
            return this._animateNoteAnnotation = !window["PSPDFKit-disable-animations"] && !t, null;
          }
          renderAnimatedExpandendNoteAnnotations(e) {
            const t = this._isFullscreen ? null : this.renderExpandendNoteAnnotations(e);
            return this._animateNoteAnnotation && null !== t ? d.createElement(Gl.Z, null, t.map(e => d.createElement($l.Z, {
              key: `NoteAnnotationPopopver-${e.props.noteAnnotation.id}`,
              timeout: {
                enter: window["PSPDFKit-disable-animations"] ? 0 : 100,
                exit: window["PSPDFKit-disable-animations"] ? 0 : 150
              },
              classNames: {
                enter: Kv().fadeEnter,
                enterActive: Kv().fadeEnterActive,
                exit: Kv().fadeExit,
                exitActive: Kv().fadeExitActive
              }
            }, e))) : d.createElement("div", null, t);
          }
          renderExpandendNoteAnnotations(e) {
            var t, n, r, o;
            if (!this.props.state.showAnnotations || this.props.state.interactionsDisabled && !this._isFullscreen || this.props.state.selectedAnnotationIds.size > 1) return (0, s.l4)();
            const i = [];
            if (this.props.activeAnnotationNote && (0, j.YV)(null === (t = this.props.activeAnnotationNote) || void 0 === t ? void 0 : t.parentAnnotation)) {
              const e = this.props.activeAnnotationNote;
              i.push(d.createElement(Lf, {
                key: `NoteAnnotationPopopver-${e.id}`,
                noteAnnotation: e,
                noteAnnotationToModify: e,
                viewportState: this.props.state.viewportState,
                dispatch: this.props.dispatch,
                isFullscreen: this._isFullscreen,
                collapseSelectedNoteContent: !1,
                annotationToolbarHeight: this.props.state.annotationToolbarHeight,
                isAnnotationReadOnly: this.isAnnotationReadOnly,
                autoSelect: this.props.state.selectedTextOnEdit,
                eventEmitter: this.props.state.eventEmitter,
                keepSelectedTool: this.props.state.keepSelectedTool
              }));
            }
            if (this.props.hoverAnnotationNote && (0, j.YV)(null === (n = this.props.hoverAnnotationNote) || void 0 === n ? void 0 : n.parentAnnotation) && (!this.props.activeAnnotationNote || (null === (r = this.props.hoverAnnotationNote) || void 0 === r || null === (r = r.parentAnnotation) || void 0 === r ? void 0 : r.id) !== (null === (o = this.props.activeAnnotationNote) || void 0 === o || null === (o = o.parentAnnotation) || void 0 === o ? void 0 : o.id))) {
              const e = this.props.hoverAnnotationNote;
              i.push(d.createElement(Lf, {
                key: `NoteAnnotationPopopver-${e.id}`,
                noteAnnotation: e,
                noteAnnotationToModify: null,
                viewportState: this.props.state.viewportState,
                dispatch: this.props.dispatch,
                isFullscreen: this._isFullscreen,
                isHover: !0,
                collapseSelectedNoteContent: !1,
                annotationToolbarHeight: this.props.state.annotationToolbarHeight,
                isAnnotationReadOnly: this.isAnnotationReadOnly,
                autoSelect: this.props.state.selectedTextOnEdit,
                eventEmitter: this.props.state.eventEmitter,
                keepSelectedTool: this.props.state.keepSelectedTool
              }));
            }
            return this.props.selectedNoteAnnotations && 0 !== this.props.selectedNoteAnnotations.size ? this.props.selectedNoteAnnotations.filter(e => null !== e.pageIndex).map(t => {
              const n = !!this.props.selectedAnnotation && t.id === this.props.selectedAnnotation.id;
              return d.createElement(Lf, {
                key: `NoteAnnotationPopopver-${t.id}`,
                noteAnnotation: t,
                noteAnnotationToModify: this.props.noteAnnotationToModify,
                viewportState: this.props.state.viewportState,
                dispatch: this.props.dispatch,
                isFullscreen: this._isFullscreen,
                isHover: !n,
                annotationToolbarHeight: this.props.state.annotationToolbarHeight,
                isAnnotationReadOnly: this.isAnnotationReadOnly,
                tools: n ? e : [],
                collapseSelectedNoteContent: this.props.state.collapseSelectedNoteContent,
                autoSelect: this.props.state.selectedTextOnEdit,
                eventEmitter: this.props.state.eventEmitter,
                keepSelectedTool: this.props.state.keepSelectedTool
              });
            }).concat(i) : (0, s.l4)(i);
          }
          renderLinkAnnotationPopover() {
            const {
                selectedAnnotation: e,
                state: t,
                dispatch: n,
                hoveredLinkAnnotation: r
              } = this.props,
              {
                viewportState: o,
                frameWindow: i,
                locale: a,
                pages: s,
                linkAnnotationMode: l
              } = t,
              u = e && e instanceof de.R1 && !l,
              c = !(null == r || !r.action || u);
            if (!c && !u) return null;
            const p = c ? r : e;
            return d.createElement(Wy, {
              annotation: p,
              viewportState: o,
              dispatch: n,
              frameWindow: i,
              locale: a,
              pages: s,
              isHover: c
            });
          }
          componentDidMount() {
            this._isMounted = !0;
          }
          componentWillUnmount() {
            this._noLicenseTimeout && (clearTimeout(this._noLicenseTimeout), this._noLicenseTimeout = null), this._isMounted = !1;
          }
          componentDidUpdate(e) {
            this.props.state.interactionMode !== B.A.DOCUMENT_CROP && e.state.interactionMode === B.A.DOCUMENT_CROP && this.setState({
              crop: null
            }), (0, Ke.fF)(e.state.interactionMode) && !(0, Ke.fF)(this.props.state.interactionMode) && this.props.dispatch((0, Kt.LE)(!1)), this.props.state.interactionMode !== B.A.INK_SIGNATURE && this.props.state.interactionMode !== B.A.SIGNATURE || this.props.state.signatureState.storedSignatures || this.props.dispatch((0, hv.de)());
            var t, n;
            ((this.props.state.features.includes(ee.q.DIGITAL_SIGNATURES) && !this.props.state.digitalSignatures && this.props.state.connectionState.name === Va.F.CONNECTED || (e.state.documentHandle !== this.props.state.documentHandle || !this.props.state.digitalSignatures) && this.props.state.connectionState.name === Va.F.CONNECTED && this.props.state.features.includes(ee.q.DIGITAL_SIGNATURES)) && this._fetchDigitalSignaturesInfo(), e.state.features.equals(this.props.state.features) && e.state.backend === this.props.state.backend && e.state.backendPermissions.equals(this.props.state.backendPermissions) && e.state.documentPermissions.equals(this.props.state.documentPermissions) && e.state.readOnlyEnabled === this.props.state.readOnlyEnabled && e.state.editableAnnotationTypes.equals(this.props.state.editableAnnotationTypes) && e.state.toolbarItems.equals(this.props.state.toolbarItems) && e.state.showComments === this.props.state.showComments || this.setState({
              isAnnotationTypeReadOnlyMemoized: (0, dn.Z)(e => (0, Kn.j$)(e, this.props.state)),
              filteredItems: (0, gc.I4)(this.props.state)
            }), this.props.selectedAnnotation && this.props.dispatch((0, _e.IP)(this.props.selectedAnnotation.id)), e.state.evaluation !== this.props.state.evaluation) && this.props.state.noLicenseKey && "STANDALONE" === (null === (t = this.props.state.backend) || void 0 === t ? void 0 : t.type) && this.props.state.evaluation && (this._noLicenseTimeout = setTimeout(() => {
              this._isMounted && this.setState({
                noLicenseKeyTimeoutFinished: !0
              });
            }, 60 * (null === (n = this.props.state.evaluation) || void 0 === n ? void 0 : n.timeInMinutes) * 1e3));
          }
          render() {
            var e, t, n, r, o;
            const {
                selectedAnnotation: i,
                activeAnnotationNote: a,
                state: s
              } = this.props,
              {
                viewportState: l,
                isDocumentHandleOutdated: u
              } = s;
            this._isFullscreen = l.viewportRect.width <= Ne.D4;
            const c = s.containerRect.width <= Ne.Fg ? s.containerRect.width : 200,
              p = i instanceof _.Qi && this.isAnnotationReadOnly(i) && !this._isFullscreen,
              f = s.currentItemPreset && s.annotationPresets.get(s.currentItemPreset) || {},
              {
                SIGNATURE_SAVE_MODE: m,
                DISABLE_KEYBOARD_SHORTCUTS: g
              } = it.Options,
              v = s.sidebarMode && d.createElement($m, {
                initialSize: s.sidebarWidth,
                minWidth: c,
                maxWidth: s.containerRect.width,
                draggerSize: s.containerRect.width <= Ne.Fg ? 0 : 6,
                onResize: this.handleSidebarResize,
                isRTL: s.sidebarPlacement === eu.d.END,
                dispatch: this.props.dispatch,
                shadowRoot: s.shadowRoot
              }, this.renderSidebar),
              y = (i || a) && !p || !s.interactionsDisabled && (s.currentTextSelection || s.interactionMode === B.A.TEXT_HIGHLIGHTER) && !s.inlineTextMarkupToolbar || s.interactionMode === B.A.INK_ERASER || s.interactionMode === B.A.DOCUMENT_CROP || s.interactionMode === B.A.CONTENT_EDITOR || s.interactionMode === B.A.MEASUREMENT || (0, Ke.fF)(s.interactionMode),
              b = !(!i || !(0, to.Kd)(i, s)),
              w = l.documentComparisonMode && d.createElement(Fv, {
                position: s.toolbarPlacement === nu.p.TOP ? "top" : "bottom"
              }),
              x = !w && s.enableAnnotationToolbar && !(i && this.props.state.commentThreads.has(i.id)) && d.createElement(Gl.Z, null, y ? d.createElement($l.Z, {
                timeout: {
                  exit: window["PSPDFKit-disable-animations"] ? 0 : 120,
                  enter: window["PSPDFKit-disable-animations"] ? 0 : 100
                },
                classNames: s.toolbarPlacement === nu.p.TOP ? {
                  enter: Kv().slideDownEnter,
                  enterActive: Kv().slideDownEnterActive,
                  exit: Kv().slideDownExit,
                  exitActive: Kv().slideDownExitActive
                } : {
                  enter: Kv().slideUpEnter,
                  enterActive: Kv().slideUpEnterActive,
                  exit: Kv().slideUpExit,
                  exitActive: Kv().slideUpExitActive
                }
              }, this.getToolbarComponent()) : null),
              D = s.digitalSignatures && s.showSignatureValidationStatus !== qg.W.NEVER ? d.createElement($l.Z, {
                in: !!y,
                timeout: {
                  exit: window["PSPDFKit-disable-animations"] ? 0 : 120,
                  enter: window["PSPDFKit-disable-animations"] ? 0 : 100
                },
                classNames: s.toolbarPlacement === nu.p.TOP ? {
                  enter: Kv().moveDownSignatureBarEnter,
                  enterActive: Kv().moveDownSignatureBarEnterActive,
                  exit: Kv().moveDownExit,
                  exitActive: Kv().moveDownSignatureBarExitActive
                } : {
                  enter: Kv().moveUpSignatureBarEnter,
                  enterActive: Kv().moveUpSignatureBarEnterActive,
                  exit: Kv().moveUpSignatureBarExit,
                  exitActive: Kv().moveUpSignatureBarExitActive
                }
              }, d.createElement(zg, {
                digitalSignatures: s.digitalSignatures,
                showSignatureValidationStatus: s.showSignatureValidationStatus
              })) : null,
              C = s.signatureFeatureAvailability,
              S = (0, Kn.bp)(s),
              E = "SERVER" === (null === (e = s.backend) || void 0 === e ? void 0 : e.type),
              P = d.createElement(d.Fragment, null, s.showToolbar && d.createElement(ps.ZP, {
                sidebarMode: s.sidebarMode,
                currentPageIndex: l.currentPageIndex,
                debugMode: s.debugMode,
                dispatch: this.props.dispatch,
                eventEmitter: this.props.state.eventEmitter,
                frameWindow: s.frameWindow,
                resizeWatchFrameWindow: this.state.resizeWatchFrameWindow,
                interactionMode: s.interactionMode,
                items: this.state.filteredItems,
                layoutMode: l.layoutMode,
                maxZoomReached: l.zoomLevel >= (0, rs.Sm)(l),
                minZoomReached: l.zoomLevel <= (0, rs.Yo)(l),
                printingEnabled: (0, Kn.VT)(s),
                exportEnabled: (0, Kn.RZ)(s),
                isDocumentReadOnly: S,
                isAnnotationTypeReadOnly: this.state.isAnnotationTypeReadOnlyMemoized,
                isDocumentComparisonAvailable: this.isDocumentComparisonAvailable(),
                signatureFeatureAvailability: C,
                scrollMode: l.scrollMode,
                pages: s.pages,
                totalPages: s.totalPages,
                zoomMode: l.zoomMode,
                currentItemPreset: s.currentItemPreset,
                toolbarPlacement: s.toolbarPlacement,
                documentEditorEnabled: (0, Kn.Xr)(s),
                canUndo: s.isHistoryEnabled && s.undoActions.size > 0,
                canRedo: s.isHistoryEnabled && s.redoActions.size > 0,
                currentDocumentComparisonMode: l.documentComparisonMode,
                isContentEditorSessionDirty: s.contentEditorSession.dirty,
                isMultiSelectionEnabled: s.isMultiSelectionEnabled,
                shouldHideOCGsSidebar: E,
                shadowRoot: s.shadowRoot,
                showDocumentAssistant: s.documentAssistant.show
              }), d.createElement(_g, {
                position: s.toolbarPlacement === nu.p.TOP ? "top" : "bottom"
              }, s.toolbarPlacement === nu.p.TOP ? d.createElement(d.Fragment, null, w || x, D) : d.createElement(d.Fragment, null, D, w || x)));
            let k;
            return (0, Pl.Kr)(s.backend) && (s.promptContentEditorDocumentDownload || !s.isServerModeDownloadingDocument && !s.isServerModeDownloadingWASM ? s.contentEditorSession.saving && (k = ah.ceSaving) : k = ah.ceDownloadingDocument), d.createElement(Xl.Provider, {
              value: this.getScrollElement
            }, d.createElement(hC, null, d.createElement(Wl.ThemeProvider, {
              theme: this.state.theme
            }, d.createElement(Wl.I18nProvider, {
              locale: s.locale,
              messages: lC({}, kl.ZP.messages)
            }, d.createElement(Wl.PortalContainerProvider, {
              portalContainer: (null === (t = s.shadowRoot) || void 0 === t ? void 0 : t.querySelector(`.${Ne.fV}`)) || (null === (n = s.frameWindow) || void 0 === n ? void 0 : n.document.body) || void 0
            }, d.createElement("div", {
              className: `PSPDFKit-Container PSPDFKit-browser-engine-${De.SR} PSPDFKit-browser-system-${De.By} ${De.Ni ? "PSPDFKit-mobile-os" : ""} PSPDFKit-${(0, ts.s)(s.containerRect)} ${Lv().root} ${s.interactionsDisabled ? "interactions-disabled" : ""} ${null != s.backend ? "PSPDFKit-backend-" + ("STANDALONE" === s.backend.type ? "standalone" : "server") : ""} ${s.disablePullToRefresh ? "overscrollDisabled" : ""}`
            }, s.isDebugConsoleVisible && d.createElement(qh, {
              dispatch: this.props.dispatch
            }), (s.interactionMode === B.A.STAMP_PICKER || s.interactionMode === B.A.STAMP_CUSTOM) && d.createElement(Iw, {
              onCreate: this._createAnnotationFromTemplate,
              backend: s.backend,
              onCancel: this._closeStampModal,
              stampAnnotationTemplates: s.stampAnnotationTemplates,
              dispatch: this.props.dispatch,
              mode: s.interactionMode,
              attachments: s.attachments,
              viewportWidth: s.containerRect.width
            }), (s.interactionMode === B.A.INK_SIGNATURE || s.interactionMode === B.A.SIGNATURE) && s.signatureState.storedSignatures && C === _r.H.LEGACY_SIGNATURES && d.createElement(Xm, {
              onEscape: this._closeSignatureModal
            }, d.createElement(yg, {
              onCancel: this._closeSignatureModal,
              onCreate: this._createSignatureFromAnnotation,
              onDelete: this._deleteStoredSignature,
              storedSignatures: s.signatureState.storedSignatures,
              preset: f,
              canStoreSignature: (null == s.signatureState.formFieldName || !s.signatureState.formFieldsNotSavingSignatures.includes(s.signatureState.formFieldName)) && m !== tu.f.NEVER,
              backend: s.backend,
              attachments: s.attachments,
              viewportWidth: s.containerRect.width
            })), !(s.interactionMode !== B.A.INK_SIGNATURE && s.interactionMode !== B.A.SIGNATURE || !s.signatureState.storedSignatures || C !== _r.H.ELECTRONIC_SIGNATURES) && d.createElement(Pw, {
              preset: f,
              colorPresets: this.props.state.electronicSignatureColorPresets,
              frameWindow: s.frameWindow,
              onCreate: this._createSignature,
              onDelete: this._deleteStoredSignature,
              onCancel: this._closeSignatureModal,
              storedSignatures: s.signatureState.storedSignatures,
              hasSignaturesCreationListener: Object.keys(s.eventEmitter.listeners).includes("storedSignatures.create") || Object.keys(s.eventEmitter.listeners).includes("inkSignatures.create"),
              hasSignaturesDeletionListener: Object.keys(s.eventEmitter.listeners).includes("storedSignatures.delete") || Object.keys(s.eventEmitter.listeners).includes("inkSignatures.delete"),
              viewportWidth: s.containerRect.width,
              creationModes: s.electronicSignatureCreationModes,
              signingFonts: s.signingFonts
            }), s.interactionMode === B.A.MEASUREMENT_SETTINGS && d.createElement(ob.Z, {
              frameWindow: s.frameWindow
            }), s.interactionMode === B.A.DOCUMENT_EDITOR && d.createElement(nv, {
              onCancel: this._handleDocumentEditorCancel,
              scale: this.getThumbnailScale(),
              usesShadowDOM: !!s.shadowRoot
            }), s.isPrinting && d.createElement(im, {
              progress: s.printLoadingIndicatorProgress,
              totalPages: s.totalPages
            }), s.features.includes(ee.q.DOCUMENT_ASSISTANT) && !!s.documentAssistant.configuration && d.createElement(AD, {
              isOpen: s.documentAssistant.show,
              configuration: s.documentAssistant.configuration,
              toolbarsHeight: s.annotationToolbarHeight + ps.k3,
              documentHandle: s.documentHandle,
              documentId: s.documentId
            }), s.isSigning && (XD || (XD = d.createElement(cm, null))), s.isApplyingRedactions && (QD || (QD = d.createElement(mm, null))), d.createElement(ap, {
              connectionState: s.connectionState,
              resolvePassword: s.resolvePassword,
              isUnlockedViaModal: s.isUnlockedViaModal
            }, s.toolbarPlacement === nu.p.TOP && P, s.interactionMode === B.A.SEARCH && (JD || (JD = d.createElement(Fm, null))), d.createElement("div", {
              className: Lv().main
            }, !v && d.createElement(vd.Z, {
              onResize: this.handleResizeHelperResize,
              onRefUpdate: this._updateResizeWatchFrameWindow
            }), s.sidebarPlacement === eu.d.START && v, d.createElement("div", {
              className: h()(Lv().mainContent, this.state.isResizingSidebar && Lv().mainContentResizing)
            }, this.renderViewport(this.state.isAnnotationTypeReadOnlyMemoized)), s.sidebarPlacement === eu.d.END && v, v && d.createElement(vd.Z, {
              onResize: this.handleResizeHelperResize,
              onRefUpdate: this._updateResizeWatchFrameWindow
            })), s.toolbarPlacement === nu.p.BOTTOM && P, s.annotationsIdsToDelete && d.createElement(Uh, {
              dispatch: this.props.dispatch,
              annotations: s.annotationsIdsToDelete.map(e => s.annotations.get(e)).filter(Boolean),
              eventEmitter: s.eventEmitter,
              setA11yStatusMessage: this._setA11yStatusMessage
            }), s.showExitContentEditorDialog && (eC || (eC = d.createElement(jy, null))), !g && d.createElement(ff, {
              dispatch: this.props.dispatch,
              printingEnabled: (0, Kn.VT)(s),
              isPrinting: s.isPrinting,
              isTextCopyingAllowed: (0, Kn.HI)(s),
              selectedAnnotationsIds: this.props.editableSelectedAnnotationIds,
              commentThreads: this.props.state.commentThreads,
              getScrollElement: this.getScrollElement,
              canDeleteSelectedAnnotationCP: b,
              canUndo: s.isHistoryEnabled && s.undoActions.size > 0,
              canRedo: s.isHistoryEnabled && s.redoActions.size > 0,
              selectedAnnotation: this.props.selectedAnnotation,
              currentPageIndex: l.currentPageIndex,
              eventEmitter: s.eventEmitter,
              backend: s.backend,
              formFields: s.formFields,
              areClipboardActionsEnabled: s.areClipboardActionsEnabled,
              modalClosurePreventionError: this.state.modalClosurePreventionError,
              setModalClosurePreventionError: e => {
                this.setState({
                  modalClosurePreventionError: e
                });
              },
              annotations: s.annotations,
              selectedGroupId: s.selectedGroupId,
              annotationsGroups: s.annotationsGroups,
              isMultiSelectionEnabled: s.isMultiSelectionEnabled,
              contentEditorSession: s.contentEditorSession,
              interactionMode: s.interactionMode,
              shadowRoot: s.shadowRoot
            }), u && this.state.silenceOutdatedDocumentPromptForHandle !== s.documentHandle && d.createElement(Lg, {
              onConfirm: this.reloadDocument,
              onCancel: () => this.closeReloadDocumentModal(s.documentHandle)
            })), d.createElement($h, {
              locale: s.locale
            }), d.createElement(pC, {
              message: s.a11yStatusMessage
            }), this.state.noLicenseKeyTimeoutFinished && this.props.state.noLicenseKey && d.createElement(pb, {
              evaluationMessage: null === (r = this.props.state.evaluation) || void 0 === r ? void 0 : r.message,
              evaluationUrl: null === (o = this.props.state.evaluation) || void 0 === o ? void 0 : o.url
            }), s.buttonToImportIconFor && d.createElement(vb, {
              onSelectImage: this.onSelectButtonImportIconImage
            }), (0, Pl.Kr)(s.backend) && s.promptContentEditorDocumentDownload && (tC || (tC = d.createElement(oC, null))), (0, Pl.Kr)(s.backend) && s.promptContentEditorCannotSaveChanges && (nC || (nC = d.createElement(iC, null))), !!k && d.createElement(aC, {
              intlMessageDescriptor: k
            })))))));
          }
        }
        const pC = d.memo(e => d.createElement(i.TX, {
            announce: "polite",
            role: "status",
            tag: "div"
          }, d.createElement("div", null, e.message))),
          hC = d.memo(e => {
            let {
              children: t
            } = e;
            const n = (0, Wl.useDevice)();
            return d.cloneElement(t, {
              className: "mobile" !== n ? "non-mobile" : void 0
            });
          }),
          fC = (0, l.$j)(e => {
            const {
                annotations: t,
                formFields: n,
                hoverAnnotationIds: r,
                hoverAnnotationNote: o,
                activeAnnotationNote: i,
                selectedAnnotationIds: a
              } = e,
              s = a.concat(r).map(e => t.get(e)).filter(e => e && e instanceof _.Qi),
              l = r.concat(r).map(e => t.get(e)).filter(e => e && e instanceof _.R1).first(),
              u = s.first(),
              c = u && e.selectedAnnotationMode === N.o.EDITING ? u : null,
              d = e.selectedAnnotationIds.size > 0 ? e.annotations.get(e.selectedAnnotationIds.first()) : null,
              p = d && d instanceof _.x_ ? n.get(d.formFieldName) : null;
            return {
              state: e,
              selectedNoteAnnotations: s,
              noteAnnotationToModify: c,
              selectedAnnotation: d,
              selectedFormField: p,
              activeAnnotationNote: i,
              hoverAnnotationNote: o,
              editableSelectedAnnotationIds: a.filter(t => {
                const n = e.annotations.get(t);
                return n && !(0, Kn.lV)(n, e);
              }),
              currentTextSelection: e.currentTextSelection,
              hoveredLinkAnnotation: l
            };
          })(dC);
        var mC = n(41390),
          gC = n(58342),
          vC = n(73417),
          yC = n(24126),
          bC = n(79685),
          wC = n(39236),
          xC = n(86105);
        const DC = (0, l.$j)(function (e) {
            return {
              locale: e.locale,
              messages: xC.ZP[e.locale]
            };
          })(xe.Pj),
          CC = ["Annotation", "CommentAvatar"];
        var SC = n(8210),
          EC = n(4480),
          _C = n(86037),
          PC = n(94809),
          kC = n(91105),
          AC = n(57712),
          zC = n(18009),
          TC = n(66013),
          OC = n(5130),
          IC = n(2891),
          FC = (n(78599), n(70118), n(56207)),
          MC = n(33383),
          RC = n(74311),
          jC = n(2427);
        var BC,
          NC,
          LC = n(11267),
          VC = n(75287),
          KC = n(25435);
        function qC(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function HC(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? qC(Object(n), !0).forEach(function (t) {
              (0, o.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qC(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const UC = {
            current: (0, s.D5)()
          },
          ZC = {
            current: (0, s.D5)()
          },
          $C = new Promise(function () {}),
          GC = "pspdfkit-lib/pspdfkit-2024.5.0.css",
          WC = `\n<style data-pspdfkit="true">\nbody, html, .${Ne.re} {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n.${Ne.re} {\n  container: pspdfkit / size;\n}\n</style>\n`,
          YC = ["baseUrl", "baseCoreUrl", "baseProcessorEngineUrl", "licenseKey", "disableWebAssemblyStreaming", "enableAutomaticLinkExtraction", "overrideMemoryLimit", "customFonts", "isSharePoint", "isSalesforce", "productId", "processorEngine"];
        let XC,
          QC = null,
          JC = null,
          eS = null;
        function tS() {
          return XC;
        }
        function nS(e) {
          XC = e;
        }
        function rS(e) {
          n.p = e;
        }
        function oS(e) {
          var t;
          return e.baseUrl ? e.baseUrl : "authPayload" in e && "object" == typeof e.authPayload && "string" == typeof (null === (t = e.authPayload) || void 0 === t ? void 0 : t.accessToken) ? "https://cdn.cloud.pspdfkit.com/pspdfkit-web@2024.5.0/" : (0, Pl.SV)(window.document);
        }
        function iS(e) {
          return e.baseCoreUrl ? e.baseCoreUrl : oS(e);
        }
        function aS(e) {
          return e.baseProcessorEngineUrl ? e.baseProcessorEngineUrl : oS(e);
        }
        async function sS(e) {
          if ((0, u.kG)((null == e.document || "string" == typeof e.document || e.document instanceof ArrayBuffer) && null == e.documentId, "Preloading is only supported for Standalone mode using WASM"), QC instanceof Promise) try {
            return void (await QC);
          } catch (t) {
            if (JC && 0 === (0, u.$O)(e, JC).length) throw t;
            JC = null;
          }
          JC = e, "string" == typeof e.baseUrl && (0, PC.Pn)(e.baseUrl);
          rS(oS(e));
          const t = e.appName || e.electronAppName || (0, D.$u)() || window.location.origin,
            r = aS(e);
          e.processorEngine && (XC = vS({
            baseUrl: r,
            mainThreadOrigin: t,
            licenseKey: e.licenseKey,
            processorEngine: e.processorEngine,
            customFonts: e.customFonts,
            dynamicFonts: e.dynamicFonts,
            fontSubstitutions: e.fontSubstitutions,
            inlineWorkers: e.inlineWorkers
          })), QC = async function (e) {
            const t = oS(e),
              r = iS(e),
              o = aS(e),
              i = HC(HC({}, e), {}, {
                baseUrl: t,
                baseCoreUrl: r,
                baseProcessorEngineUrl: o
              });
            rS(t), eS || (eS = await Promise.all([n.e(4267), n.e(3610)]).then(n.bind(n, 58258)));
            const {
              corePool: a,
              validateStandaloneConfiguration: s,
              normalizeCoreOptions: l,
              loadModule: u
            } = eS;
            s(i);
            const c = l(i),
              {
                object: d,
                checkIn: p
              } = a.checkOut();
            await u(d, c), p();
          }(e), await Promise.all([QC, XC]);
        }
        async function lS(e) {
          De.fq && new u.p2("Starting 2022.5.0, we no longer support Internet Explorer 11."), De.rO && new u.p2("Starting 2023.2.0, we no longer support Microsoft Edge 18."), "disableWebAssembly" in e && e.disableWebAssembly && (0, u.a1)("The 'disableWebAssembly' option is deprecated. It will be removed in a future release as we are removing support for ASM.js.");
          const t = {
            current: !0
          };
          let r = null;
          if (!0 !== e.headless) {
            r = dS(e), (0, u.kG)(!UC.current.has(r), "Configuration#container is already used to mount a PSPDFKit for Web instance. \n\nEither use PSPDFKit.unload(container) before loading again or use a different container.");
            const n = r;
            UC.current = UC.current.set(r, function () {
              t.current = !1, UC.current = UC.current.delete(n);
            });
          }
          try {
            var o, p, g, y, b;
            if (QC instanceof Promise) try {
              await QC;
            } catch (t) {
              if (JC && 0 === (0, u.$O)(e, JC).length) throw t;
              JC = null;
            } else QC = Promise.resolve();
            let r;
            const T = oS(e);
            if (rS(T), !t.current) return $C;
            if ("document" in e && e.document) {
              var x, A;
              if (!e.processorEngine && null !== (x = JC) && void 0 !== x && x.processorEngine && (e.processorEngine = Tl.l.fasterProcessing), null != JC) {
                const t = (0, u.$O)(JC, e, {
                  keys: YC
                });
                (0, u.kG)(0 === t.length, "The configuration object passed to PSPDFKit is different from the one given previously\n" + (0, u.GB)(t));
              }
              JC = e, eS || (eS = await Promise.all([n.e(4267), n.e(3610)]).then(n.bind(n, 58258)));
              const t = null === (A = eS) || void 0 === A ? void 0 : A.default;
              r = new t(HC(HC({}, e), {}, {
                baseCoreUrl: iS(e)
              })), e.autoSaveMode || (e.autoSaveMode = P.u.IMMEDIATE), (e.appName && (0, D.d)() || e.electronAppName) && (e.electronAppName && ((0, u.ZK)("The `Configuration.electronAppName` option is deprecated and will be removed in a future version. Please use `appName` instead."), (0, u.kG)((0, D.d)(), "`electronAppName` should only be set when using Electron.")), (0, jC.t0)(e.appName || e.electronAppName, e.productId));
            }
            if ("documentId" in e && e.documentId || "authPayload" in e && "object" == typeof e.authPayload && "string" == typeof (null === (o = e.authPayload) || void 0 === o ? void 0 : o.accessToken)) {
              const t = (await Promise.all([n.e(4267), n.e(6377)]).then(n.bind(n, 22425))).default;
              r = new t(e), e.autoSaveMode || (e.autoSaveMode = e.instant ? P.u.IMMEDIATE : P.u.INTELLIGENT);
            }
            if (!t.current) return r && r.destroy(), $C;
            if (!r) throw new u.p2("Backend could not be inferred. Please add one of the following properties to the configuration:\n  - `document` to load document and render the document client-side.\n  - `documentId` to connect to PSPDFKit Document Engine and render the document server-side.\n");
            if (e.autoSaveMode && e.autoSaveMode !== P.u.INTELLIGENT && e.autoSaveMode !== P.u.IMMEDIATE && e.autoSaveMode !== P.u.DISABLED) throw new u.p2("The supplied autoSaveMode is not valid.\nValid `autoSaveMode`s are: PSPDFKit.AutoSaveMode.INTELLIGENT, PSPDFKit.AutoSaveMode.IMMEDIATE or PSPDFKit.AutoSaveMode.DISABLED");
            if (e.printOptions || (e.printOptions = {}), e.printOptions && e.printOptions.mode && !Object.prototype.hasOwnProperty.call(Ol.X, e.printOptions.mode)) throw new u.p2("The supplied mode in printOptions is not valid.\nValid `printMode`s are: PSPDFKit.PrintMode.DOM, PSPDFKit.PrintMode.EXPORT_PDF");
            if (e.printOptions && e.printOptions.quality && !Object.prototype.hasOwnProperty.call(Il.g, e.printOptions.quality)) throw new u.p2("The supplied quality in printOptions is not valid.\nValid `printOptions.quality`s are: PSPDFKit.PrintQuality.LOW, PSPDFKit.PrintQuality.MEDIUM, PSPDFKit.PrintQuality.HIGH");
            if (e.printMode && (0, u.ZK)("Configuration.printMode has been deprecated and will be removed in the next major version. Please refer to the migration guide in order to keep the desired behavior."), e.printMode && !e.printOptions.mode) {
              if (!Object.prototype.hasOwnProperty.call(Ol.X, e.printMode)) throw new u.p2("The supplied printMode is not valid.\nValid `printMode`s are: PSPDFKit.PrintMode.DOM, PSPDFKit.PrintMode.EXPORT_PDF");
              e.printOptions.mode = e.printMode;
            }
            "disableHighQualityPrinting" in e && ((0, u.ZK)("Configuration.disableHighQualityPrinting has been deprecated and will be removed in the next major version. Please refer to the migration guide in order to keep the desired behavior."), uS(e, "disableHighQualityPrinting"), e.disableHighQualityPrinting && "boolean" == typeof e.disableHighQualityPrinting && !e.printOptions.quality && ("STANDALONE" !== r.type || "ios" !== De.By && "android" !== De.By ? e.printOptions.quality = e.disableHighQualityPrinting ? Il.g.MEDIUM : Il.g.HIGH : e.printOptions.quality = Il.g.MEDIUM));
            let O,
              I = null;
            if (e.electronicSignatures) {
              if (e.electronicSignatures.creationModes) {
                if (!Array.isArray(e.electronicSignatures.creationModes) || !e.electronicSignatures.creationModes.length) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#creationModes must be a non-empty array if specified.");
                if (e.electronicSignatures.creationModes.some(e => !Object.keys(kC.M).includes(e))) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#creationModes only accepts PSPDFKit.ElectronicSignatureCreationMode values.");
              }
              if (e.electronicSignatures.fonts) {
                if (!Array.isArray(e.electronicSignatures.fonts) || !e.electronicSignatures.fonts.length) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#fonts must be a non-empty array if specified.");
                if (e.electronicSignatures.fonts.some(e => !(e instanceof Zl.Z))) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#fonts only accepts PSPDFKit.Font values.");
              }
              if (e.electronicSignatures.forceLegacySignaturesFeature && "boolean" != typeof e.electronicSignatures.forceLegacySignaturesFeature) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#forceLegacySignaturesFeature only accepts boolean values.");
              if (void 0 !== e.electronicSignatures.setDefaultTypeText) if ("function" == typeof e.electronicSignatures.setDefaultTypeText) I = e.electronicSignatures.setDefaultTypeText;else {
                if ("string" != typeof e.electronicSignatures.setDefaultTypeText) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#setDefaultTypeText must be a function or a string if provided.");
                {
                  const t = e.electronicSignatures.setDefaultTypeText;
                  I = () => t;
                }
              }
            }
            uS(e, "disableForms"), cS(e, "annotationTooltipCallback"), uS(e, "disableTextSelection"), uS(e, "preventTextCopy"), cS(e, "renderPageCallback"), function (e, t) {
              if (e[t]) {
                if (!Array.isArray(e[t])) throw new u.p2(`${t} must be an array of annotation types.`);
                if (!e[t].every(e => e && e.prototype && (e.prototype instanceof Ul.Z || e == Ul.Z))) throw new u.p2(`${t} must be an array of annotation types.`);
              }
            }(e, "editableAnnotationTypes"), cS(e, "isEditableAnnotation"), cS(e, "isEditableComment"), cS(e, "dateTimeString"), cS(e, "annotationToolbarColorPresets"), cS(e, "annotationToolbarItems"), cS(e, "onWidgetAnnotationCreationStart"), cS(e, "inlineTextSelectionToolbarItems"), cS(e, "onCommentCreationStart"), cS(e, "measurementValueConfiguration"), "mentionableUsers" in e && ((0, u.kG)(Array.isArray(e.mentionableUsers), "mentionableUsers must be an array"), e.mentionableUsers.forEach(FC.vQ)), (0, u.um)(`PSPDFKit for ${(0, D.d)() ? "Electron" : "Web"} 2024.5.0 (https://pspdfkit.com/web)`);
            try {
              O = (0, kl.z5)(e.locale || navigator.language);
            } catch (e) {
              O = "en";
            }
            if (e.populateInkSignatures && "function" != typeof e.populateInkSignatures) throw new u.p2("populateInkSignatures must be a function.");
            if (e.populateStoredSignatures && "function" != typeof e.populateStoredSignatures) throw new u.p2("populateStoredSignatures must be a function.");
            if (null != e.maxPasswordRetries && "number" != typeof e.maxPasswordRetries) throw new u.p2("maxPasswordRetries must be a number.");
            if (e.formFieldsNotSavingSignatures && (!Array.isArray(e.formFieldsNotSavingSignatures) || e.formFieldsNotSavingSignatures.some(e => "string" != typeof e))) throw new u.p2("formFieldsNotSavingSignatures must be an array of strings.");
            let F,
              M,
              R,
              j = new S.Z();
            e.disableOpenParameters || (j = (0, Hl.s)(j)), e.initialViewState && (j = e.initialViewState, j = (0, ql.F3)(j, null)), e.customRenderers && (F = function (e) {
              for (const t in e) e.hasOwnProperty(t) && ((0, u.kG)(CC.includes(t), `'${t}' is not a custom renderable entity. Custom renderable entities are: ${CC.join(", ")}`), (0, u.kG)("function" == typeof e[t], `'${t}' custom renderer must be a function.`));
              return e;
            }(e.customRenderers)), e.customUI && (M = (0, SC.a)(e.customUI)), (0, u.kG)("number" == typeof it.Options.DEFAULT_INK_ERASER_CURSOR_WIDTH && it.Options.DEFAULT_INK_ERASER_CURSOR_WIDTH >= 0, "PSPDFKit.Options.DEFAULT_INK_ERASER_CURSOR_WIDTH must be set to a positive number."), (0, u.kG)(!e.isAPStreamRendered || "function" == typeof e.isAPStreamRendered, "When provided, `configuration.isAPStreamRendered` must be a function."), (0, u.kG)(!e.enableRichText || "function" == typeof e.enableRichText, "When provided, `configuration.enableRichText` must be a function."), (0, u.kG)("boolean" == typeof e.enableHistory || void 0 === e.enableHistory, "When provided, `configuration.enableHistory` must be a boolean value."), (0, u.kG)("boolean" == typeof e.enableClipboardActions || void 0 === e.enableClipboardActions, "When provided, `configuration.enableClipboardOperations` must be a boolean value."), e.unstable_inkEraserMode && ((0, u.kG)(Object.keys(Ui.b).includes(e.unstable_inkEraserMode), "`unstable_inkEraserMode` must be one of: `PSPDFKit.unstable_InkEraserMode.POINT` or `PSPDFKit.unstable_InkEraserMode.STROKE`"), R = e.unstable_inkEraserMode), (0, u.kG)("boolean" == typeof e.measurementSnapping || void 0 === e.measurementSnapping, "When provided, `configuration.measurementSnapping` must be a boolean value."), (0, u.kG)("string" == typeof e.measurementPrecision || void 0 === e.measurementPrecision, "When provided, `configuration.measurementPrecision` must be a string."), (0, u.kG)(e.measurementScale instanceof Ma.Z || void 0 === e.measurementScale, "When provided, `configuration.measurementScale` must be an instance of `MeasurementScale`."), (0, u.kG)("boolean" == typeof e.anonymousComments || void 0 === e.anonymousComments || !0 === e.anonymousComments && "STANDALONE" !== r.type, "When provided, `configuration.anonymousComments` must be used only with PSPDFKit Document Engine and be a boolean value."), (0, u.kG)("boolean" == typeof e.disableMultiSelection || void 0 === e.disableMultiSelection, "When provided, `configuration.disableMultiSelection` must be a boolean value."), (0, u.kG)("number" == typeof e.autoCloseThreshold || void 0 === e.autoCloseThreshold, "When provided, `configuration.autoCloseThreshold` must be a number."), e.ui && function (e) {
              (0, mw.kG)("object" == typeof e, "The provided UI must be an object.");
              for (const [t, n] of Object.entries(e)) (0, mw.kG)(Object.keys(gw.x).includes(t), `'${t}' is not a valid UI element. Valid UI elements are: ${Object.keys(gw.x).join(", ")}`), (0, mw.kG)("function" == typeof n, `The provided UI for "${t}" must be a function.`);
            }(e.ui), (0, u.kG)("boolean" == typeof e.useIframe || void 0 === e.useIframe, "When provided, `configuration.useIframe` must be a boolean value.");
            const N = HC(HC({
              backend: r,
              autoSaveMode: e.autoSaveMode,
              printMode: null === (p = e.printOptions) || void 0 === p ? void 0 : p.mode,
              printQuality: null === (g = e.printOptions) || void 0 === g ? void 0 : g.quality,
              showComments: !!j.showComments,
              showAnnotationNotes: !!j.showAnnotationNotes,
              printingEnabled: j.allowPrinting,
              exportEnabled: j.allowExport,
              readOnlyEnabled: j.readOnly ? te.J.VIA_VIEW_STATE : te.J.NO,
              formsEnabled: !e.disableForms,
              formDesignMode: !e.disableForms && j.formDesignMode,
              showAnnotations: j.showAnnotations,
              eventEmitter: new bC.Z(),
              locale: O,
              clientPermissions: new _.uh({
                extract: !e.disableTextSelection,
                preventTextCopy: !!e.preventTextCopy,
                printHighQuality: (null === (y = e.printOptions) || void 0 === y ? void 0 : y.quality) === Il.g.HIGH
              }),
              signatureState: new _.dp({
                populateStoredSignatures: e.populateStoredSignatures || e.populateInkSignatures,
                formFieldsNotSavingSignatures: (0, s.l4)(e.formFieldsNotSavingSignatures || [])
              }),
              renderPageCallback: e.renderPageCallback,
              annotationTooltipCallback: e.annotationTooltipCallback ? t => {
                var n;
                const r = null === (n = e.annotationTooltipCallback) || void 0 === n ? void 0 : n.call(e, t);
                return null == r || r.forEach(e => {
                  (0, Ll.G)(e);
                }), r;
              } : null,
              sidebarMode: j.sidebarMode,
              sidebarOptions: j.sidebarOptions,
              sidebarPlacement: j.sidebarPlacement,
              isEditableAnnotation: e.isEditableAnnotation,
              isEditableComment: e.isEditableComment,
              customRenderers: F
            }, M ? {
              customUIStore: new f.Z(M)
            } : null), {}, {
              toolbarPlacement: e.toolbarPlacement,
              showSignatureValidationStatus: j.showSignatureValidationStatus || qg.W.NEVER,
              previewRedactionMode: j.previewRedactionMode,
              keepSelectedTool: j.keepSelectedTool,
              isAPStreamRendered: e.isAPStreamRendered,
              restrictAnnotationToPageBounds: e.restrictAnnotationToPageBounds,
              electronicSignatureCreationModes: (0, s.hU)(e.electronicSignatures && e.electronicSignatures.creationModes || AC.Z),
              signingFonts: (0, s.hU)(e.electronicSignatures && e.electronicSignatures.fonts || gC.Z),
              isHistoryEnabled: !!e.enableHistory,
              areClipboardActionsEnabled: !!e.enableClipboardActions,
              onOpenURI: e.onOpenURI,
              onAnnotationResizeStart: e.onAnnotationResizeStart,
              canScrollWhileDrawing: j.canScrollWhileDrawing,
              dateTimeString: e.dateTimeString,
              annotationToolbarColorPresets: e.annotationToolbarColorPresets,
              annotationToolbarItems: e.annotationToolbarItems,
              onWidgetAnnotationCreationStart: e.onWidgetAnnotationCreationStart,
              inkEraserMode: R,
              firstCurrentPageIndex: j.currentPageIndex,
              arePageSizesLoaded: "STANDALONE" !== r.type,
              inlineTextSelectionToolbarItems: e.inlineTextSelectionToolbarItems,
              measurementSnapping: e.measurementSnapping,
              measurementPrecision: e.measurementPrecision,
              measurementScale: e.measurementScale,
              measurementValueConfiguration: e.measurementValueConfiguration,
              anonymousComments: e.anonymousComments,
              enableRichText: e.enableRichText,
              maxMentionSuggestions: "maxMentionSuggestions" in e && e.maxMentionSuggestions || void 0,
              mentionableUsers: "mentionableUsers" in e && e.mentionableUsers || [],
              isMultiSelectionEnabled: !e.disableMultiSelection,
              defaultAutoCloseThreshold: e.autoCloseThreshold,
              onCommentCreationStart: e.onCommentCreationStart,
              electronicSignatureDefaultTextCallback: I,
              noLicenseKey: !e.licenseKey && "STANDALONE" === r.type,
              ui: e.ui ? HC(HC({}, vw.m), e.ui) : void 0,
              documentAssistant: new KC.Z({
                configuration: e.documentAssistant,
                show: j.showDocumentAssistant
              }),
              documentId: "STANDALONE" === r.type ? null : e.documentId
            });
            let L,
              K,
              q = Promise.resolve();
            if (!0 === e.headless) L = xl(HC(HC({}, N), {}, {
              frameWindow: window
            }));else if ([L, q, K] = await async function (e, t, n, r, o) {
              var p, f, g, y;
              const b = dS(r);
              if (b.childNodes.length > 0) throw new u.p2('`Configuration#container` is expected to be an empty element but instead it contains child nodes.\nTo fix this, please make sure that the container is empty (e.g. by using an empty div `<div id="PSPDFKit"><div>`');
              if (r.styleSheets && !(r.styleSheets instanceof Array)) throw new u.p2("styleSheets must either be an Array of strings");
              let x = [];
              const D = window.getComputedStyle(b).getPropertyValue("width"),
                C = window.getComputedStyle(b).getPropertyValue("height");
              if (!D || D && "0px" === D) throw new u.p2("The mounting container has no width.\n      PSPDFKit for Web adapts to the dimensions of this element and will require this to be set. You can set it to 100% to adopt to the dimensions of the parent node.");
              if (!C || C && "0px" === C) throw new u.p2("The mounting container has no height.\n      PSPDFKit for Web adapts to the dimensions of this element and will require this to be set. You can set it to 100% to adopt to the dimensions of the parent node.");
              if (r.theme) {
                if ("string" != typeof r.theme || !fw.Q[r.theme]) throw new u.p2("Invalid theme. Configuration#theme must be a valid PSPDFKit.Theme");
                (r.theme === fw.Q.DARK || r.theme === fw.Q.AUTO && window.matchMedia("(prefers-color-scheme: dark)").matches) && x.push(`${t}pspdfkit-lib/dark-${v()}.css`);
              }
              r.styleSheets && (x = x.concat(r.styleSheets));
              let S = Ne.cY;
              null != r.minDefaultZoomLevel && ((0, u.kG)("number" == typeof r.minDefaultZoomLevel && r.minDefaultZoomLevel > 0, "minDefaultZoomLevel must be a number greater than 0"), S = r.minDefaultZoomLevel);
              let P = Ne.QS;
              null != r.maxDefaultZoomLevel && ((0, u.kG)("number" == typeof r.maxDefaultZoomLevel && r.maxDefaultZoomLevel > 0, "maxDefaultZoomLevel must be a number greater than 0"), P = r.maxDefaultZoomLevel);
              (0, u.kG)(P >= S, `maxDefaultZoomLevel (${P}) must be greater than or equal to minDefaultZoomLevel (${S}). If you didn't set one of those values, then the default value was used.`);
              const A = E.UL.fromClientRect(b.getBoundingClientRect()).setLocation(new E.E9()),
                z = new _.Vk({
                  currentPageIndex: o.currentPageIndex,
                  disablePointSnapping: o.disablePointSnapping,
                  zoomLevel: "number" == typeof o.zoom ? o.zoom : 1,
                  zoomMode: "number" == typeof o.zoom ? os.c.CUSTOM : o.zoom,
                  pagesRotation: (0, He.n5)(o.pagesRotation),
                  layoutMode: o.layoutMode,
                  scrollMode: o.scrollMode,
                  pageSpacing: o.pageSpacing,
                  spreadSpacing: o.spreadSpacing,
                  keepFirstSpreadAsSinglePage: o.keepFirstSpreadAsSinglePage,
                  viewportPadding: new E.E9({
                    x: o.viewportPadding.horizontal,
                    y: o.viewportPadding.vertical
                  }),
                  minDefaultZoomLevel: S,
                  maxDefaultZoomLevel: P,
                  enableAlwaysScrollToZoom: o.enableAlwaysScrollToZoom,
                  forceRenderWidgetsInAnnotationsOrder: o.forceRenderWidgetsInAnnotationsOrder,
                  prerenderedPageSpreads: o.prerenderedPageSpreads
                });
              let T = vC.ZP.toJS();
              r.toolbarItems && (T = r.toolbarItems, T = T.map(e => "ink-signature" === e.type ? ((0, u.a1)("The 'ink-signature' toolbar item type has been renamed to 'signature'. The 'ink-signature' identifier will be removed on a future release of PSPDFKit for Web."), HC(HC({}, e), {}, {
                type: "signature"
              })) : e), T.forEach(Nl.G));
              let O = yC.Z.toJS();
              r.documentEditorFooterItems && (O = r.documentEditorFooterItems, O.forEach(Vl.G));
              let I = zC.Z.toJS();
              r.documentEditorToolbarItems && (I = r.documentEditorToolbarItems, I.forEach(Kl.G));
              if (r.documentAssistant) {
                var F;
                if ("SERVER" !== (null === (F = n.backend) || void 0 === F ? void 0 : F.type)) throw new u.p2("Document Assistant is only available with the PSPDFKit Document Engine");
                if (!r.documentAssistant.backendUrl || "string" != typeof r.documentAssistant.backendUrl) throw new u.p2("documentAssistant.backendUrl is required and must be a string");
                if (!r.documentAssistant.chatSessionId || "string" != typeof r.documentAssistant.chatSessionId) throw new u.p2("documentAssistant.chatSessionId is required and must be a string");
                if (!r.documentAssistant.jwt || "string" != typeof r.documentAssistant.jwt) throw new u.p2("documentAssistant.jwt is required and must be a string");
                if (!r.documentAssistant.userId || "string" != typeof r.documentAssistant.userId) throw new u.p2("documentAssistant.userId is required and must be a string");
                if (r.documentAssistant.onMessageSubmit && "function" != typeof r.documentAssistant.onMessageSubmit) throw new u.p2("documentAssistant.onMessageSubmit must be a function");
              }
              let M = Ne.mc;
              if (r.documentEditorConfiguration) {
                const {
                  thumbnailMinSize: e,
                  thumbnailMaxSize: t,
                  thumbnailDefaultSize: n
                } = r.documentEditorConfiguration;
                null != n && (0, u.kG)("number" == typeof n && n > 0, "documentEditor.thumbnailDefaultSize must be a number greater than 0"), null != t && ((0, u.kG)("number" == typeof t && t > 0, "documentEditor.thumbnailMaxSize must be a number greater than 0"), (0, u.kG)(t > e, "documentEditor.thumbnailMaxSize must be bigger than documentEditor.thumbnailMinSize")), null != e && ((0, u.kG)("number" == typeof e && e > 0, "documentEditor.thumbnailMinSize must be a number greater than 0"), (0, u.kG)(e < t, "documentEditor.thumbnailMinSize must be smaller than documentEditor.thumbnailMaxSize")), M = HC(HC({}, M), r.documentEditorConfiguration);
              }
              let R = Y.ZP.toObject();
              R.ink.inkEraserWidth = it.Options.DEFAULT_INK_ERASER_CURSOR_WIDTH, r.annotationPresets && (R = r.annotationPresets, Object.values(R).forEach(Bl.G));
              let j = mC.ZP;
              r.stampAnnotationTemplates && Array.isArray(r.stampAnnotationTemplates) && (j = r.stampAnnotationTemplates, j.forEach(Aa.wB));
              "mentionableUsers" in r && ((0, u.kG)(Array.isArray(r.mentionableUsers), "mentionableUsers must be an array"), r.mentionableUsers.forEach(FC.vQ));
              "maxMentionSuggestions" in r && (0, u.kG)("number" == typeof r.maxMentionSuggestions && r.maxMentionSuggestions > 0, "maxMentionSuggestions must be a number greater than 0");
              Object.isFrozen(it.Options) || (it.W !== it.Options.COLOR_PRESETS && (0, m.XV)("Options.COLOR_PRESETS", "PSPDFKit#Customisation.AnnotationToolbarColorPresets", !0), (0, it.n)(it.Options), Object.freeze(it.Options));
              const B = function () {
                const e = document.createElement("div");
                return e.className = "PSPDFKit-Container", e.style.width = "100%", e.style.height = "100%", e;
              }();
              b.appendChild(B), pS(b, function () {
                const {
                  parentNode: e
                } = B;
                e && e.removeChild(B);
              });
              const N = void 0 === r.useIframe || !r.useIframe,
                [L, V] = await async function (e, t, n, r, o) {
                  let i, a;
                  const s = new Promise(function (e, t) {
                    i = e, a = t;
                  });
                  let l;
                  if (r && !o) {
                    let e;
                    try {
                      e = await (0, k.jK)([t + GC].concat(n).map(e => {
                        const n = n => {
                          const r = n instanceof Error;
                          return {
                            filename: e,
                            css: r ? null : n,
                            isCustom: e !== t + GC
                          };
                        };
                        return fetch(e, {
                          credentials: "same-origin"
                        }).then(e => {
                          if (200 !== e.status) throw Error(`${e.status} ${e.statusText}`);
                          return e.text();
                        }).then(n).catch(n);
                      }));
                    } catch (t) {
                      e = t;
                    }
                    e = e.filter(e => null !== e.css), l = WC + e.map(e => {
                      let {
                        css: t,
                        isCustom: n,
                        filename: r
                      } = e;
                      return `<style${n ? ` data-source="${r}"` : ""}>${t}</style>`;
                    }).join("");
                  } else l = `<link rel="stylesheet" href="${t + GC}" data-pspdfkit="true">\n${n.map(e => `<link rel="stylesheet" href="${e}">`).join("\n")}\n${WC}\n`;
                  return new Promise(t => {
                    if (o) {
                      const n = e.attachShadow({
                          mode: "open"
                        }),
                        r = document.createElement("div");
                      r.className = Ne.re, r.style.width = "100%", r.style.height = "100%", r.style.border = "0", r.style.display = "block", n.appendChild(r);
                      const o = document.createElement("div");
                      o.className = Ne.fV, n.appendChild(o);
                      const u = document.createRange().createContextualFragment(l);
                      n.prepend(u), hS(i, a, n), t([n, s]);
                    } else {
                      const n = document.createElement("iframe");
                      n.setAttribute("allowfullscreen", "true"), n.setAttribute("title", "PSPDFKit"), n.style.width = "100%", n.style.height = "100%", n.style.border = "0", n.style.display = "block", e.appendChild(n);
                      const r = n.contentDocument;
                      if (r) {
                        r.open(), r.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>PSPDFKit</title></head><body><div class="${Ne.re}"></div></body></html>`), r.close(), r.addEventListener("touchstart", () => {
                          document.body && (document.body.style.overscrollBehavior = "none");
                        }), r.addEventListener("touchcancel", () => {
                          document.body && (document.body.style.overscrollBehavior = "inherit");
                        }), r.addEventListener("touchend", () => {
                          document.body && (document.body.style.overscrollBehavior = "inherit");
                        });
                        const e = r.createRange().createContextualFragment(l);
                        r.head.appendChild(e), hS(i, a, r), t([r, s]);
                      }
                    }
                  });
                }(B, t, x, r.enableServiceWorkerSupport || !1, N);
              if (function (e) {
                var t;
                const n = e instanceof ShadowRoot,
                  r = n ? e.ownerDocument : null === (t = e.defaultView) || void 0 === t ? void 0 : t.document;
                if (!r) return;
                const o = r.createRange().createContextualFragment(`<style data-pspdfkit="true">${fS}</style>`);
                n ? e.appendChild(o) : null == r || r.head.appendChild(o);
              }(L), !e.current) return $C;
              Al(L);
              const K = (0, zl.bl)(L);
              "function" == typeof K && pS(b, function () {
                K();
              });
              const q = (null === (p = r.electronicSignatures) || void 0 === p ? void 0 : p.colorPresets) || TC.Z;
              if (0 === q.length) throw new u.p2("PSPDFKit.Configuration.electronicSignatures#colorPresets should have at least one preset.");
              let H = null;
              if ("customFonts" in r && r.customFonts) {
                const e = n.backend.getCustomFontsPromise();
                e.current || (e.current = (0, vs.x6)(r.customFonts)), H = await e.current;
              }
              if (De.G6 && N && L instanceof ShadowRoot) {
                const e = new w(L);
                pS(b, function () {
                  e.cleanupEventListeners(L);
                });
              }
              const U = xl(HC(HC({}, n), {}, {
                rootElement: b,
                containerRect: A,
                showToolbar: o.showToolbar,
                disablePointSnapping: o.disablePointSnapping,
                enableAnnotationToolbar: o.enableAnnotationToolbar,
                toolbarItems: (0, s.d0)(T),
                electronicSignatureColorPresets: q,
                annotationPresets: (0, s.D5)(R),
                stampAnnotationTemplates: Object.freeze(j),
                currentItemPreset: null,
                viewportState: z,
                interactionMode: null,
                documentEditorFooterItems: (0, s.d0)(O),
                documentEditorToolbarItems: (0, s.d0)(I),
                frameWindow: N ? window : L.defaultView,
                shadowRoot: N ? L : null,
                sidebarWidth: A.width <= Ne.Fg ? A.width : it.Options.INITIAL_DESKTOP_SIDEBAR_WIDTH,
                renderPagePreview: "boolean" != typeof r.renderPagePreview || r.renderPagePreview,
                enableAlwaysScrollToZoom: o.enableAlwaysScrollToZoom,
                documentEditorConfig: M,
                theme: r.theme
              }));
              if (await (0, kl.sS)(U.getState().locale), !e.current) return $C;
              U.dispatch((0, Fl.t2)(new jl(U.getState, U.dispatch))), U.dispatch((0, Kt.z5)((0, G.YV)(U.getState)));
              const Z = N ? L.querySelector(`.${Ne.re}`) : null === (f = L.defaultView) || void 0 === f ? void 0 : f.document.querySelector(`.${Ne.re}`);
              return (0, u.kG)(Z, "Internal PSPDFKit Error: Mount Target could not be found in contentDocument. Please contact support@pspdfkit.com"), (0, c.render)(d.createElement(l.zt, {
                store: U
              }, N ? BC || (BC = d.createElement(i.TX, {
                id: "a11y-status-message",
                role: "status",
                "aria-live": "polite",
                "aria-relevant": "additions text"
              })) : null, d.createElement(DC, {
                onError: e => (e.code, e)
              }, d.createElement("div", {
                className: h()(vp().withLayers, N && vp().relativeContainer, (!("CSS" in window) || !(null !== (g = (y = window.CSS).supports) && void 0 !== g && g.call(y, "isolation: isolate"))) && vp().withLayersFallback)
              }, d.createElement(a.P, null, NC || (NC = d.createElement(fC, null)))))), Z), pS(b, function () {
                (0, c.unmountComponentAtNode)(Z);
              }), [U, V, H];
            }(t, T, N, e, j), !t.current) return $C;
            const H = L.getState(),
              {
                eventEmitter: U,
                rootElement: Z
              } = H;
            Z && pS(Z, function () {
              r && r.destroy();
            }), _.UX.prototype.getMeasurementDetails = function () {
              return H.features.includes(ee.q.MEASUREMENT_TOOLS) || new u.p2(IC.oD), (0, z.t9)(this);
            };
            const $ = new wC.Z({
              store: L,
              backend: r,
              eventEmitter: U
            });
            if (await _l({
              dispatch: L.dispatch,
              backend: r,
              getState: L.getState,
              password: e.password,
              maxPasswordRetries: !0 === e.headless ? 0 : "number" == typeof e.maxPasswordRetries ? e.maxPasswordRetries : Number.POSITIVE_INFINITY,
              formFieldValuesJSON: "STANDALONE" === r.type ? "instantJSON" in e && e.instantJSON && e.instantJSON.formFieldValues : null,
              customFonts: K,
              stylesheetPromise: q
            }), !t.current) return r && r.destroy(), $C;
            let W = function () {
              $._destroy(), !0 === e.headless && r && r.destroy(), ZC.current = ZC.current.delete($);
            };
            Z && (W = pS(Z, W)), ZC.current = ZC.current.set($, W);
            const {
              features: Q,
              formDesignMode: J,
              previewRedactionMode: ne,
              documentPermissions: re,
              frameWindow: oe
            } = L.getState();
            if (e.fontSubstitutions && ((0, u.kG)(C(e.fontSubstitutions), "Invalid fontSubstitutions"), r.setFontSubstitutions(e.fontSubstitutions)), re.fillForms || re.annotationsAndForms || it.Options.IGNORE_DOCUMENT_PERMISSIONS ? L.dispatch((0, Kt.we)(e.editableAnnotationTypes ? (0, s.l4)(e.editableAnnotationTypes) : (0, s.l4)(X.Z), e.isEditableAnnotation)) : L.dispatch((0, Kt.ZV)((0, s.l4)([]))), Q.includes(ee.q.ELECTRONIC_SIGNATURES) && function (e, t) {
              const n = e.document.createRange(),
                r = vs.eE.map(e => `@font-face {\n    font-family: '${e.name}';\n    font-style: normal;\n    font-weight: ${e.weight};\n    font-display: swap;\n    src: url(${t}pspdfkit-lib/${e.file}.woff2) format('woff2'),\n         url(${t}pspdfkit-lib/${e.file}.woff) format('woff');\n  }`).join("\n"),
                o = n.createContextualFragment(`<style data-pspdfkit="true">\n${r}\n  </style>`);
              e.document.head.appendChild(o);
            }(oe, T), J && !(0, Kn.ix)(L.getState())) throw L.dispatch((0, Kt.LE)(!1)), re.annotationsAndForms || re.fillForms ? new u.p2("Widget annotation selection (`configuration.viewState.formDesignMode = true`) can only be enabled if the license includes the Form Designer component and on standalone mode or with PSPDFKit Instant.") : new u.p2('Widget annotation selection (`configuration.viewState.formDesignMode = true`) can only be enabled if the current document has either the "Editing Annotations and Forms" or the "Filling Forms" permissions granted. you can override this behavior by setting the PSPDFKit.Options.IGNORE_DOCUMENT_PERMISSIONS option before initializing PSPDFKit. Please make also sure the license includes the Form Designer component and a backend that supports it.');
            if (ne && !Q.includes(ee.q.REDACTIONS)) throw L.dispatch((0, Kt.P_)(!1)), new u.p2("`configuration.viewState.previewRedactionMode = true` can only be enabled if the license includes the Redactions component.");
            if (e.initialViewState && e.initialViewState.interactionMode === B.A.DOCUMENT_EDITOR && !Q.includes(ee.q.DOCUMENT_EDITING)) throw L.dispatch((0, Kt.sJ)()), new u.p2(EC.I);
            if (e.initialViewState && e.initialViewState.interactionMode === B.A.CONTENT_EDITOR && !Q.includes(ee.q.CONTENT_EDITING)) throw L.dispatch({
              type: V.Qm9
            }), new u.p2(ml.Aq);
            if ((0, Ke.fF)(null === (b = e.initialViewState) || void 0 === b ? void 0 : b.interactionMode) && !Q.includes(ee.q.FORM_DESIGNER)) throw L.dispatch((0, Kt.XX)()), new u.p2(OC.RB);
            if (e.initialViewState && e.initialViewState.showSignatureValidationStatus !== qg.W.NEVER && !Q.includes(ee.q.DIGITAL_SIGNATURES)) throw new u.p2(_C.C);
            if ((e.documentEditorFooterItems || e.documentEditorToolbarItems || e.documentEditorConfiguration) && !Q.includes(ee.q.DOCUMENT_EDITING)) throw new u.p2(EC.I);
            if (e.documentAssistant && !Q.includes(ee.q.DOCUMENT_ASSISTANT)) throw L.dispatch((0, Kt.O4)(null)), new u.p2(VC.oQ);
            if (e.initialViewState && !0 === e.initialViewState.showDocumentAssistant && !Q.includes(ee.q.DOCUMENT_ASSISTANT)) throw L.dispatch((0, Kt.Z_)(!1)), new u.p2(VC.oQ);
            if (!0 !== e.headless && !Q.includes(ee.q.UI)) throw L.dispatch((0, Dl.sr)("Your license does not cover the configured functionality.")), new u.p2("The web UI feature is not enabled for your license key. Please contact support or sales to purchase the UI module for your product.");
            if (!0 !== e.headless && j.interactionMode) {
              const e = (0, ql.eV)(j.interactionMode, H);
              L.dispatch(e.onEnterAction());
            }
            return L.dispatch((0, Kt._$)($)), $;
          } catch (e) {
            const {
              type: t,
              request: n
            } = e;
            throw "error" === t && n && /\/pspdfkit-lib\//.test(n) && e("Failed to load pspdfkit-lib.\nMake sure you are serving all PSPDFKit library files as described in https://pspdfkit.com/guides/web/current/standalone/adding-to-your-project/#copy-the-pspdfkit-for-web-assets."), e;
          }
        }
        function uS(e, t) {
          if (e[t] && "boolean" != typeof e[t]) throw new u.p2(`The type for ${t} is not valid. Must be \`true\` or \`false\`.`);
        }
        function cS(e, t) {
          if (e[t] && "function" != typeof e[t]) throw new u.p2(`The type for ${t} is not valid. Must be \`function\`.`);
        }
        function dS(e) {
          const t = "string" == typeof e.container ? document.querySelector(e.container) : e.container;
          if (!(0, jr.Re)(t)) throw new u.p2("`Configuration#container` must either be a valid element or a CSS selector");
          return t;
        }
        function pS(e, t) {
          const n = UC.current.get(e);
          function r() {
            t(), null == n || n();
          }
          return (0, u.kG)(n), UC.current = UC.current.set(e, r), r;
        }
        function hS(e, t, n) {
          const r = Array.prototype.slice.call(n.querySelectorAll('link[rel="stylesheet"]')).filter(e => !e.dataset.loaded).map(function (e) {
            let t, n;
            e.dataset.loaded = "true";
            const r = new Promise(function (e, r) {
              t = e, n = r;
            });
            return e.onload = function () {
              t();
            }, e.onerror = function () {
              const r = e.href + " could not be loaded. Make sure that the file is accessible from your webserver.";
              e.dataset.pspdfkit ? n(new u.p2(r)) : ((0, u.vU)(r), t());
            }, r;
          });
          Promise.all(r).then(e, t);
        }
        const fS = "\n:host, body {\n  font-size: var(--PSPDFKit-fontSize-1);\n  font-family: var(--PSPDFKit-fontFamily-1);\n  line-height: var(--PSPDFKit-lineHeight-1);\n  background: var(--PSPDFKit-App-background);\n}\n";
        async function mS(e, t) {
          const {
            licenseKey: n,
            electronAppName: r,
            productId: o,
            appName: i
          } = e;
          bS(e);
          const a = oS(e);
          (0, u.kG)(o !== MC.x.Salesforce, "Document conversion is not currently supported in Salesforce."), t && (0, u.kG)(t && Object.values(RC.w).includes(t), "The supplied PDF/A Conformance type is not valid. Valid Conformance should be one of the following options PSPDFKit.Conformance." + Object.keys(RC.w).join(", PSPDFKit.Conformance."));
          const s = await (0, Sl.D4)(a, e.document, o),
            l = i || r || (0, D.$u)() || window.location.origin,
            c = aS(e);
          XC || (XC = vS({
            baseUrl: c,
            mainThreadOrigin: l,
            customFonts: e.customFonts,
            dynamicFonts: e.dynamicFonts,
            fontSubstitutions: e.fontSubstitutions,
            licenseKey: n,
            processorEngine: e.processorEngine,
            inlineWorkers: e.inlineWorkers
          }));
          const d = await XC;
          return (0, u.kG)(d), await d.toPdf(s, t);
        }
        async function gS(e, t) {
          const {
            licenseKey: n,
            electronAppName: r,
            productId: o,
            appName: i
          } = e;
          bS(e);
          const a = oS(e);
          (0, u.kG)(o !== MC.x.Salesforce, "Document conversion is not currently supported in Salesforce."), (0, u.kG)(t && Object.values(LC._).includes(t), `The provided conversion output format ${t} is not supported. Supported output formats are ${Object.values(LC._).map(e => `PSPDFKit.OfficeDocumentFormat.${e}`).join(", ")}.`);
          const s = await (0, Sl.D4)(a, e.document, o),
            l = i || r || (0, D.$u)() || window.location.origin,
            c = aS(e);
          XC || (XC = vS({
            baseUrl: c,
            mainThreadOrigin: l,
            customFonts: e.customFonts,
            dynamicFonts: e.dynamicFonts,
            fontSubstitutions: e.fontSubstitutions,
            licenseKey: n,
            processorEngine: e.processorEngine,
            inlineWorkers: e.inlineWorkers
          }));
          const d = await XC;
          return (0, u.kG)(d), await d.toOffice(s, t);
        }
        async function vS(e) {
          let {
            baseUrl: t,
            mainThreadOrigin: r,
            customFonts: o,
            dynamicFonts: i,
            fontSubstitutions: a,
            licenseKey: s,
            processorEngine: l,
            inlineWorkers: u
          } = e;
          const c = await n.e(1305).then(n.bind(n, 90027));
          try {
            const e = !l || l === Tl.l.fasterProcessing,
              n = await c.getBrowserSpawner(u);
            return new c.GdPictureWorker(HC(HC(HC({
              baseUrl: t,
              aot: e,
              mainThreadOrigin: r,
              licenseKey: s,
              workerSpawner: n
            }, o ? {
              customFonts: await (0, vs.x6)(o)
            } : null), i ? {
              dynamicFonts: i
            } : null), a ? {
              fontSubstitutions: C(a) ? a : null
            } : null));
          } catch (e) {
            throw e;
          }
        }
        async function yS(e, t) {
          const {
            licenseKey: n,
            electronAppName: r,
            productId: o,
            appName: i
          } = e;
          bS(e), (0, u.kG)(o !== MC.x.Salesforce, "Document template populate is not currently supported in Salesforce.");
          const a = oS(e),
            s = await (0, Sl.D4)(a, e.document, o),
            l = i || r || (0, D.$u)() || window.location.origin,
            c = aS(e);
          let d;
          try {
            return XC || (XC = vS({
              baseUrl: c,
              mainThreadOrigin: l,
              customFonts: e.customFonts,
              dynamicFonts: e.dynamicFonts,
              fontSubstitutions: e.fontSubstitutions,
              licenseKey: n,
              processorEngine: e.processorEngine,
              inlineWorkers: e.inlineWorkers
            })), d = await XC, (0, u.kG)(d), await d.populateDocumentTemplate(s, t, e.licenseKey);
          } catch (e) {
            throw e;
          } finally {
            var p;
            null === (p = d) || void 0 === p || p.destroy(), nS(null);
          }
        }
        function bS(e) {
          const {
            licenseKey: t,
            electronAppName: n,
            productId: r,
            appName: o
          } = e;
          "string" == typeof e.baseUrl && (0, PC.Pn)(e.baseUrl);
          rS(oS(e)), (0, u.kG)(null == t || "string" == typeof t, "licenseKey must be a string value if provided. Please obtain yours from https://customers.pspdfkit.com."), "string" == typeof t && (0, u.kG)(!t.startsWith("TRIAL-"), "You're using the npm key instead of the license key. This key is used to download the PSPDFKit for Web package via the node package manager.\n\nLeave out the license key to activate as a trial."), (o && (0, D.d)() || n) && ((0, u.kG)(n, "The `electronAppName` option is deprecated and will be removed in a future version. Please use `appName` instead."), (0, jC.t0)(o || n, r));
        }
      },
      53416: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => o
        });
        const r = (0, n(79724).Z)("AnnotationPreset"),
          o = e => {
            r("object" == typeof e, "`annotationPreset` is not an `object`");
          };
      },
      78025: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          readOnly: !1,
          downloadingAllowed: !0
        }) {}
      },
      99745: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => d,
          Z: () => c
        });
        var r = n(96156),
          o = n(35369),
          i = n(79724),
          a = n(690),
          s = n(88133);
        const l = (0, i.Z)("Bookmark"),
          u = {
            id: null,
            pdfBookmarkId: null,
            name: null,
            sortKey: null,
            action: null
          };
        class c extends o.WV(u) {}
        (0, r.Z)(c, "toSerializableObject", s.a), (0, r.Z)(c, "fromSerializableObject", e => (0, s.i)(null, e));
        const d = e => {
          const {
            name: t,
            sortKey: n,
            action: r
          } = e;
          null != t && l("string" == typeof t, "`name` must be a string"), null != n && l("number" == typeof n, "`sortKey` must be a number"), l(r instanceof a.aU, "`action` must be an instance of PSPDFKit.Actions.Action");
        };
      },
      49616: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          printHighQuality: !0,
          extract: !0,
          preventTextCopy: !1
        }) {}
      },
      60379: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r,
          o = n(96156),
          i = n(35369),
          a = n(15359);
        class s extends (0, i.WV)({
          r: 0,
          g: 0,
          b: 0,
          transparent: !1
        }) {
          constructor(e) {
            !0 !== e.transparent ? super(e) : super({
              transparent: !0
            });
          }
          lighter(e) {
            (0, a.kG)("number" == typeof e && e >= 0 && e <= 100, "Invalid `percent` value. Must be 0-100.");
            const t = 255 * e / 100;
            let n = parseInt(this.r + t),
              r = parseInt(this.g + t),
              o = parseInt(this.b + t);
            return n = n < 255 ? n : 255, r = r < 255 ? r : 255, o = o < 255 ? o : 255, new s({
              r: n,
              g: r,
              b: o
            });
          }
          darker(e) {
            (0, a.kG)("number" == typeof e && e >= 0 && e <= 100, "Invalid `percent` value. Must be 0-100.");
            const t = 255 * e / 100;
            let n = parseInt(this.r - t),
              r = parseInt(this.g - t),
              o = parseInt(this.b - t);
            return n = n > 0 ? n : 0, r = r > 0 ? r : 0, o = o > 0 ? o : 0, new s({
              r: n,
              g: r,
              b: o
            });
          }
          equals(e) {
            return (0, a.kG)(e instanceof s || "object" == typeof e, "Invalid `color` provided. It must be an instance of Color or an RGB object."), (0, a.kG)("number" == typeof e.r && e.r >= 0 && e.r <= 255, "Invalid `r` value provided. It must be an integer between 0 and 255."), (0, a.kG)("number" == typeof e.g && e.g >= 0 && e.g <= 255, "Invalid `g` value provided. It must be an integer between 0 and 255."), (0, a.kG)("number" == typeof e.b && e.b >= 0 && e.b <= 255, "Invalid `b` value provided. It must be an integer between 0 and 255."), !this.transparent && !e.transparent && this.r === e.r && this.g === e.g && this.b === e.b || this.transparent && e.transparent;
          }
          saturate(e) {
            (0, a.kG)("number" == typeof e && e >= 0 && e <= 100, "Invalid `percent` value. Must be 0-100.");
            const t = e / 100,
              n = .3086 * this.r + .6094 * this.g + .082 * this.b;
            return new s({
              r: Math.round(this.r * t + n * (1 - t)),
              g: Math.round(this.g * t + n * (1 - t)),
              b: Math.round(this.b * t + n * (1 - t))
            });
          }
          sRGBToRGBComponent(e) {
            return e <= .03928 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
          }
          relativeLuminance() {
            const {
                r: e,
                g: t,
                b: n
              } = {
                r: this.r / 255,
                g: this.g / 255,
                b: this.b / 255
              },
              {
                R: r,
                G: o,
                B: i
              } = {
                R: this.sRGBToRGBComponent(e),
                G: this.sRGBToRGBComponent(t),
                B: this.sRGBToRGBComponent(n)
              };
            return .2126 * r + .7152 * o + .0722 * i;
          }
          contrastRatio(e) {
            return (this.relativeLuminance() + .05) / (e.relativeLuminance() + .05);
          }
          toCSSValue() {
            return this.transparent ? "transparent" : `rgb(${this.r}, ${this.g}, ${this.b})`;
          }
          toHex() {
            if (this.transparent) return "#00000000";
            let e = this.r.toString(16),
              t = this.g.toString(16),
              n = this.b.toString(16);
            return 1 == e.length && (e = "0" + e), 1 == t.length && (t = "0" + t), 1 == n.length && (n = "0" + n), "#" + e + t + n;
          }
        }
        r = s, (0, o.Z)(s, "BLACK", new r({
          r: 0,
          g: 0,
          b: 0
        })), (0, o.Z)(s, "GREY", new r({
          r: 128,
          g: 128,
          b: 128
        })), (0, o.Z)(s, "WHITE", new r({
          r: 255,
          g: 255,
          b: 255
        })), (0, o.Z)(s, "DARK_BLUE", new r({
          r: 36,
          g: 131,
          b: 199
        })), (0, o.Z)(s, "RED", new r({
          r: 248,
          g: 36,
          b: 0
        })), (0, o.Z)(s, "PURPLE", new r({
          r: 255,
          g: 0,
          b: 255
        })), (0, o.Z)(s, "PINK", new r({
          r: 255,
          g: 114,
          b: 147
        })), (0, o.Z)(s, "GREEN", new r({
          r: 110,
          g: 176,
          b: 0
        })), (0, o.Z)(s, "ORANGE", new r({
          r: 243,
          g: 149,
          b: 0
        })), (0, o.Z)(s, "YELLOW", new r({
          r: 255,
          g: 255,
          b: 0
        })), (0, o.Z)(s, "LIGHT_BLUE", new r({
          r: 141,
          g: 184,
          b: 255
        })), (0, o.Z)(s, "LIGHT_RED", new r({
          r: 247,
          g: 141,
          b: 138
        })), (0, o.Z)(s, "LIGHT_GREEN", new r({
          r: 162,
          g: 250,
          b: 123
        })), (0, o.Z)(s, "LIGHT_YELLOW", new r({
          r: 252,
          g: 238,
          b: 124
        })), (0, o.Z)(s, "BLUE", new r({
          r: 34,
          g: 147,
          b: 251
        })), (0, o.Z)(s, "LIGHT_ORANGE", new r({
          r: 255,
          g: 139,
          b: 94
        })), (0, o.Z)(s, "LIGHT_GREY", new r({
          r: 192,
          g: 192,
          b: 192
        })), (0, o.Z)(s, "DARK_GREY", new r({
          r: 64,
          g: 64,
          b: 64
        })), (0, o.Z)(s, "MAUVE", new r({
          r: 245,
          g: 135,
          b: 255
        })), (0, o.Z)(s, "TRANSPARENT", new r({
          transparent: !0
        })), (0, o.Z)(s, "fromHex", e => e.length >= 8 && (e.endsWith("00") || e.endsWith("00")) ? r.TRANSPARENT : new r({
          r: parseInt(e.substr(1, 2), 16),
          g: parseInt(e.substr(3, 2), 16),
          b: parseInt(e.substr(5, 2), 16)
        }));
      },
      16602: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(60379);
        const o = [{
          color: r.Z.RED,
          localization: {
            id: "red",
            defaultMessage: "Red",
            description: "Red color"
          }
        }, {
          color: r.Z.ORANGE,
          localization: {
            id: "orange",
            defaultMessage: "Orange",
            description: "Orange color"
          }
        }, {
          color: r.Z.YELLOW,
          localization: {
            id: "yellow",
            defaultMessage: "Yellow",
            description: "Yellow color"
          }
        }, {
          color: r.Z.GREEN,
          localization: {
            id: "green",
            defaultMessage: "Green",
            description: "Green color"
          }
        }, {
          color: r.Z.DARK_BLUE,
          localization: {
            id: "darkBlue",
            defaultMessage: "Dark blue",
            description: "Dark blue color"
          }
        }, {
          color: r.Z.BLUE,
          localization: {
            id: "blue",
            defaultMessage: "Blue",
            description: "Blue color"
          }
        }, {
          color: r.Z.PURPLE,
          localization: {
            id: "purple",
            defaultMessage: "Purple",
            description: "Purple color"
          }
        }, {
          color: r.Z.PINK,
          localization: {
            id: "pink",
            defaultMessage: "Pink",
            description: "Pink color"
          }
        }, {
          color: r.Z.LIGHT_ORANGE,
          localization: {
            id: "lightOrange",
            defaultMessage: "Light Orange",
            description: "Light Orange color"
          }
        }, {
          color: r.Z.LIGHT_YELLOW,
          localization: {
            id: "lightYellow",
            defaultMessage: "Light Yellow",
            description: "Light Yellow color"
          }
        }, {
          color: r.Z.LIGHT_GREEN,
          localization: {
            id: "lightGreen",
            defaultMessage: "Light Green",
            description: "Light Green color"
          }
        }, {
          color: r.Z.LIGHT_BLUE,
          localization: {
            id: "lightBlue",
            defaultMessage: "Light Blue",
            description: "Light Blue color"
          }
        }, {
          color: r.Z.MAUVE,
          localization: {
            id: "mauve",
            defaultMessage: "Mauve",
            description: "Mauve color"
          }
        }, {
          color: r.Z.TRANSPARENT,
          localization: {
            id: "transparent",
            defaultMessage: "Transparent",
            description: "Transparent"
          }
        }, {
          color: r.Z.WHITE,
          localization: {
            id: "white",
            defaultMessage: "White",
            description: "White color"
          }
        }, {
          color: r.Z.LIGHT_GREY,
          localization: {
            id: "lightGrey",
            defaultMessage: "Light Grey",
            description: "Light Grey color"
          }
        }, {
          color: r.Z.GREY,
          localization: {
            id: "grey",
            defaultMessage: "Grey",
            description: "Grey color"
          }
        }, {
          color: r.Z.DARK_GREY,
          localization: {
            id: "darkGrey",
            defaultMessage: "Dark Grey",
            description: "Dark Grey color"
          }
        }, {
          color: r.Z.BLACK,
          localization: {
            id: "black",
            defaultMessage: "Black",
            description: "Black color"
          }
        }];
      },
      25822: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        class r {
          constructor(e) {
            this.name = e.name, this.reason = e.reason, this.progress = e.progress;
          }
        }
      },
      96988: (e, t, n) => {
        "use strict";

        n.d(t, {
          Ar: () => v,
          CF: () => b,
          Cd: () => F,
          DN: () => c,
          Dn: () => B,
          FP: () => a,
          FQ: () => D,
          G_: () => L,
          I5: () => z,
          IA: () => m,
          JR: () => x,
          Q7: () => P,
          QC: () => V,
          R1: () => i,
          Sg: () => l,
          Ts: () => S,
          UL: () => u,
          W4: () => p,
          Y1: () => w,
          YG: () => N,
          _h: () => A,
          a2: () => y,
          aN: () => I,
          aT: () => R,
          jI: () => M,
          lK: () => j,
          mZ: () => d,
          nv: () => k,
          t9: () => T,
          tW: () => C,
          tk: () => _,
          vz: () => g,
          wR: () => s,
          xb: () => O,
          yJ: () => E,
          yO: () => f
        });
        var r = n(15359),
          o = n(35369);
        let i = function (e) {
            return e[e.Uninitialized = 0] = "Uninitialized", e[e.Loading = 1] = "Loading", e[e.Loaded = 2] = "Loaded", e;
          }({}),
          a = function (e) {
            return e[e.None = 0] = "None", e[e.Selected = 1] = "Selected", e[e.Active = 2] = "Active", e[e.Moving = 3] = "Moving", e;
          }({}),
          s = function (e) {
            return e[e.Edit = 0] = "Edit", e[e.Create = 1] = "Create", e[e.Delete = 2] = "Delete", e;
          }({});
        class l extends (0, o.WV)({
          x: 0,
          y: 0
        }) {}
        class u extends (0, o.WV)({
          offset: new l(),
          size: new l()
        }) {}
        class c extends (0, o.WV)({
          rotation: 0,
          flipY: !1
        }) {}
        class d extends (0, o.WV)({
          xScale: 1,
          skew: 0
        }) {}
        class p extends (0, o.WV)({
          bold: !1,
          italic: !1
        }) {}
        const h = {
          regular: new p(),
          bold: new p({
            bold: !0
          }),
          italic: new p({
            italic: !0
          }),
          boldItalic: new p({
            bold: !0,
            italic: !0
          })
        };
        class f extends (0, o.WV)({
          family: "",
          variant: h.regular
        }) {}
        class m extends (0, o.WV)({
          faceRef: new f(),
          size: 0
        }) {}
        class g extends (0, o.WV)({
          fontRef: new m(),
          color: "#000000",
          effects: new d()
        }) {}
        class v extends (0, o.WV)({
          maxWidth: null,
          alignment: "begin",
          lineSpacingFactor: 1
        }) {}
        class y extends (0, o.WV)({
          top: 0,
          bottom: 0
        }) {}
        class b extends (0, o.WV)({
          offset: new l(),
          lineSpacing: new y()
        }) {}
        class w extends (0, o.WV)({
          begin: 0,
          end: 0,
          text: ""
        }) {}
        class x extends (0, o.WV)({
          unavailableFaceName: null
        }) {}
        class D extends (0, o.WV)({
          cluster: 0,
          offset: new l(),
          advance: new l(),
          text: "",
          control: null,
          lastOfSegment: !1,
          beginOfWord: !1,
          endOfWord: !1
        }) {}
        class C extends (0, o.WV)({
          offset: new l(),
          lineSpacing: new y(),
          elements: (0, o.aV)()
        }) {}
        class S extends (0, o.WV)({
          lines: (0, o.aV)()
        }) {}
        class E extends (0, o.WV)({
          family: null,
          faceMismatch: null,
          bold: null,
          italic: null,
          size: null,
          xScale: null,
          skew: null,
          color: null
        }) {}
        class _ extends (0, o.WV)({
          selectionStyleInfo: null,
          modificationsCharacterStyle: null,
          modificationsCharacterStyleFaceMismatch: null
        }) {}
        class P extends (0, o.WV)({
          id: "",
          initialAnchor: new l(),
          initialGlobalEffects: new c(),
          initialLayout: new v(),
          anchor: new l(),
          globalEffects: new c(),
          layout: new v(),
          justCreated: !1,
          modificationsCharacterStyle: new g(),
          version: 0,
          contentRect: new u(),
          cursor: new b(),
          selection: null,
          detectedStyle: new _(),
          layoutView: new S()
        }) {}
        class k extends (0, o.WV)({
          initialTextBlocks: (0, o.aV)(),
          textBlocks: (0, o.aV)(),
          loading: !0
        }) {}
        class A extends (0, o.WV)({
          pageIndex: 0,
          textBlockId: "",
          state: a.None
        }) {}
        class z extends (0, o.WV)({
          family: "",
          variants: (0, o.l4)()
        }) {}
        class T extends (0, o.WV)({
          faceList: null,
          loading: !1
        }) {}
        class O extends (0, o.WV)({
          fontFace: null,
          rect: null,
          dismissAbortController: null
        }) {}
        class I extends (0, o.WV)({
          pageStates: (0, o.D5)(),
          availableFaces: new T(),
          textBlockInteractionState: new A(),
          sessionId: 0,
          active: !1,
          dirty: !1,
          saving: !1,
          mode: s.Edit,
          fontMismatchTooltip: null,
          contentEditor: null
        }) {}
        const F = e => t => {
            const n = t.contentEditorSession.pageStates.get(e);
            return n ? n.loading ? i.Loading : i.Loaded : i.Uninitialized;
          },
          M = e => t => {
            const n = t.contentEditorSession.pageStates.get(e);
            return n ? [...n.textBlocks.map(e => e.id)] : [];
          },
          R = (e, t) => n => {
            const o = n.contentEditorSession.pageStates.get(e);
            (0, r.kG)(o);
            for (const e of o.textBlocks) if (e.id == t) return e;
            return null;
          },
          j = e => {
            const {
              textBlockInteractionState: t
            } = e.contentEditorSession;
            return !t || t.state !== a.Active && t.state !== a.Selected ? null : R(t.pageIndex, t.textBlockId)(e);
          },
          B = (e, t) => n => {
            const {
              textBlockInteractionState: r
            } = n.contentEditorSession;
            return r && r.state === a.Active && r.pageIndex === e && r.textBlockId === t;
          },
          N = e => e.contentEditorSession.availableFaces,
          L = (e, t) => n => {
            const {
              textBlockInteractionState: r
            } = n.contentEditorSession;
            return r && r.state === a.Selected && r.pageIndex === e && r.textBlockId === t;
          },
          V = (e, t) => n => {
            const {
              textBlockInteractionState: r
            } = n.contentEditorSession;
            return r && r.state === a.Moving && r.pageIndex === e && r.textBlockId === t;
          };
        class K extends (0, o.WV)({
          x: new l(),
          y: new l()
        }) {}
        class q extends (0, o.WV)({
          rotation: 0,
          baseSize: new l(),
          skew: 0,
          flip: !1
        }) {}
        class H extends (0, o.WV)({
          params: new q(),
          uiSize: new l()
        }) {}
      },
      56874: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => l,
          Z: () => a
        });
        var r = n(35369),
          o = n(44077);
        const i = (0, n(79724).Z)("CustomOverlayItem");
        class a extends (0, r.WV)({
          disableAutoZoom: !1,
          id: null,
          node: null,
          noRotate: !1,
          pageIndex: 0,
          position: new o.E9(),
          onAppear: null,
          onDisappear: null
        }) {
          constructor(e) {
            super(e);
          }
        }
        const s = [Node.ELEMENT_NODE, Node.TEXT_NODE, Node.COMMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE],
          l = e => {
            const {
              disableAutoZoom: t,
              id: n,
              node: r,
              noRotate: a,
              pageIndex: l,
              position: u,
              onAppear: c,
              onDisappear: d
            } = e;
            i("boolean" == typeof t, "`disableAutoZoom` must be a `boolean`"), i("string" == typeof n, "`id` must be a `string`"), i(r instanceof Node, "`node` must be an instance of `Node`"), i(s.includes(r.nodeType), "`node.nodeType` is invalid. Expected one of " + s.join(", ")), i("boolean" == typeof a, "`noRotate` must be a `boolean`"), i("number" == typeof l, "`pageIndex` must be a `number`"), i(u instanceof o.E9, "`position` must be an instance of `PSPDFKit.Geometry.Point`"), c && i("function" == typeof c, "`onAppear` must be a `function`"), d && i("function" == typeof d, "`onDisappear` must be a `function`");
          };
      },
      9470: (e, t, n) => {
        "use strict";

        n.d(t, {
          x: () => r
        });
        const r = Object.freeze([{
          id: "solid",
          dashArray: []
        }, {
          id: "narrowDots",
          dashArray: [1, 1]
        }, {
          id: "wideDots",
          dashArray: [1, 3]
        }, {
          id: "narrowDashes",
          dashArray: [3, 3]
        }, {
          id: "wideDashes",
          dashArray: [6, 6]
        }]);
      },
      25435: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(35369);
        const o = {
          configuration: null,
          show: !1,
          additionalContext: null
        };
        class i extends (0, r.WV)(o) {}
      },
      65652: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => l
        });
        var r = n(50898),
          o = n(79724),
          i = n(24126);
        const a = (0, o.Z)("DocumentEditorFooterItem"),
          s = [...i.l.map(e => e.type), "custom"],
          l = e => {
            const {
              type: t,
              id: n,
              className: o,
              onPress: i,
              node: l
            } = e;
            a("string" == typeof t, "Mandatory `type` is either missing or not a `string`"), a(s.indexOf(t) >= 0, `Invalid built-in type \`${t}\`. Choose one from ${s.join(", ")}`), "custom" === t && (a(l, "`node` is mandatory for `custom` footer items."), a(l && r.a.includes(l.nodeType), "`node.nodeType` is invalid. Expected one of " + r.a.join(", ")), n && a("string" == typeof n, "`id` must be a `string`"), o && a("string" == typeof o, "`className` must be a `string`"), i && a("function" == typeof i, "`onPress` must be a `function`")), n && a("string" == typeof n, "`id` must be a `string`");
          };
      },
      713: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => d
        });
        var r = n(96156),
          o = n(79724),
          i = n(18009),
          a = n(50898);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const u = (0, o.Z)("DocumentEditorToolbarItem"),
          c = [...i.L.map(e => e.type), "custom"],
          d = e => {
            const {
              type: t
            } = e;
            u("string" == typeof t, "Mandatory `type` is either missing or not a `string`"), (0, a.G)(l(l({}, e), {}, {
              type: "custom"
            }), u), u(c.indexOf(t) >= 0, `Invalid built-in type \`${t}\`. Choose one from ${c.join(", ")}`);
          };
      },
      92370: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(35369);
        const o = {
          elements: null,
          expanded: (0, r.D5)()
        };
        class i extends (0, r.WV)(o) {}
      },
      2282: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        (0, n(79724).Z)("Font");
        class o extends (0, r.WV)({
          name: null,
          callback: null
        }) {
          constructor(e) {
            super(e);
          }
        }
      },
      29435: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          label: "",
          value: ""
        }) {}
      },
      33622: (e, t, n) => {
        "use strict";

        n.d(t, {
          B: () => l,
          Z: () => s
        });
        var r = n(96156);
        function o(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function i(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const a = {
          enumerable: !0,
          configurable: !1,
          writable: !1
        };
        class s {}
        function l(e) {
          const t = new s();
          return Object.defineProperty(t, "clientId", i(i({}, a), {}, {
            value: e.clientId
          })), Object.defineProperty(t, "userId", i(i({}, a), {}, {
            value: e.userId
          })), t;
        }
      },
      34923: (e, t, n) => {
        "use strict";

        n.d(t, {
          C: () => o
        });
        var r = n(34997);
        function o() {
          return (0, r.SK)();
        }
      },
      10734: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          children: (0, r.aV)(),
          title: "",
          color: null,
          isBold: !1,
          isItalic: !1,
          isExpanded: !1,
          action: null
        }) {}
      },
      65739: (e, t, n) => {
        "use strict";

        n.d(t, {
          j: () => o,
          m: () => r
        });
        const r = {
            P: "p",
            TH: "th",
            TD: "td",
            Table: "table",
            TBody: "tbody",
            THead: "thead",
            TR: "tr",
            H1: "h1",
            H2: "h2",
            H3: "h3",
            H4: "h4",
            H5: "h5",
            H6: "h6",
            Figure: "figure",
            Link: "span",
            Span: "span",
            L: "ul",
            LI: "li",
            Part: "div",
            Sect: "section",
            Article: "article",
            Div: "div"
          },
          o = {
            P: "paragraph",
            TH: "cell",
            TD: "cell",
            Table: "table",
            TBody: "table",
            THead: "table",
            TR: "row",
            H1: "heading",
            H2: "heading",
            H3: "heading",
            H4: "heading",
            H5: "heading",
            H6: "heading",
            Figure: "figure",
            Link: "link",
            L: "list",
            LI: "listitem",
            Sect: "region",
            Article: "article",
            Span: void 0,
            Div: void 0,
            Part: void 0
          };
      },
      8271: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(35369),
          o = n(44077);
        const i = {
          pageSize: new o.$u(),
          pageIndex: 0,
          pageLabel: "",
          rotation: 0,
          inViewport: !1,
          contentBlocks: null,
          textLineScales: null,
          annotationIds: (0, r.hU)(),
          customOverlayItemIds: (0, r.l4)(),
          pageKey: "",
          textElementFonts: (0, r.D5)(),
          untransformedRect: new o.UL(),
          transformedRect: new o.UL(),
          matrix: o.sl.IDENTITY,
          reverseMatrix: o.sl.IDENTITY,
          rawPdfBoxes: {
            bleedBox: null,
            cropBox: null,
            mediaBox: null,
            trimBox: null
          },
          tabOrder: null
        };
        class a extends (0, r.WV)(i) {}
      },
      36828: (e, t, n) => {
        "use strict";

        n.d(t, {
          J: () => l,
          Z: () => s
        });
        var r = n(96156);
        function o(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function i(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? o(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const a = {
          enumerable: !0,
          configurable: !1,
          writable: !1
        };
        class s {}
        function l(e) {
          const t = new s();
          return Object.defineProperty(t, "index", i(i({}, a), {}, {
            value: e.pageIndex
          })), Object.defineProperty(t, "rotation", i(i({}, a), {}, {
            value: 90 * e.rotation
          })), Object.defineProperty(t, "label", i(i({}, a), {}, {
            value: e.pageLabel
          })), Object.defineProperty(t, "width", i(i({}, a), {}, {
            value: e.pageSize.width
          })), Object.defineProperty(t, "height", i(i({}, a), {}, {
            value: e.pageSize.height
          })), Object.defineProperty(t, "rawPdfBoxes", i(i({}, a), {}, {
            value: i({}, e.rawPdfBoxes)
          })), t;
        }
      },
      21063: (e, t, n) => {
        "use strict";

        n.d(t, {
          T: () => a
        });
        var r = n(74750),
          o = n(27122),
          i = n(93767);
        const a = {
          [o.f.ANNOTATIONS]: {
            includeContent: [...r.J]
          },
          [o.f.LAYERS]: {
            lockedLayers: [],
            iconsAlignment: i.v.END
          }
        };
      },
      78191: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          storedSignatures: null,
          signatureRect: null,
          signaturePageIndex: null,
          populateStoredSignatures: () => Promise.resolve((0, r.aV)()),
          formFieldsNotSavingSignatures: (0, r.l4)(),
          formFieldName: null
        }) {}
      },
      39934: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => L,
          w: () => N
        });
        var r = n(35369),
          o = n(44077),
          i = n(25822),
          a = n(14178),
          s = n(78191),
          l = n(13422),
          u = n(34723),
          c = n(78025),
          d = n(49616),
          p = n(62083),
          h = n(65369),
          f = n(13264),
          m = n(13349),
          g = n(38246),
          v = n(57712),
          y = n(92370),
          b = n(47120),
          w = n(70025),
          x = n(26637),
          D = n(79685),
          C = n(58342),
          S = n(76934),
          E = n(25673),
          _ = n(28233),
          P = n(21063),
          k = n(96988),
          A = n(97281),
          z = n(58163),
          T = n(94327),
          O = n(1385),
          I = n(10983),
          F = n(8898),
          M = n(81683),
          R = n(25435);
        const j = {
            reuseState: null,
            backend: null,
            pages: (0, r.aV)(),
            totalPages: 0,
            debugMode: !1,
            isDebugConsoleVisible: !1,
            rootElement: null,
            scrollElement: null,
            frameWindow: null,
            containerRect: new o.UL(),
            connectionFailureReason: null,
            connectionState: new i.Z({
              name: a.F.CONNECTING
            }),
            scrollbarOffset: 0,
            currentTextSelection: null,
            inlineTextMarkupToolbar: !0,
            annotations: (0, r.D5)(),
            attachments: (0, r.D5)(),
            formFields: (0, r.D5)(),
            formattedFormFieldValues: (0, r.D5)(),
            editingFormFieldValues: (0, r.D5)(),
            readOnlyEnabled: _.J.NO,
            formsEnabled: !0,
            formDesignMode: !1,
            showAnnotations: !0,
            showComments: !0,
            showAnnotationNotes: !0,
            printingEnabled: !0,
            exportEnabled: !0,
            selectedAnnotationIds: (0, r.l4)(),
            selectedAnnotationShouldDrag: null,
            selectedAnnotationMode: null,
            selectedTextOnEdit: !1,
            shadowRoot: null,
            interactionMode: null,
            interactionsDisabled: !1,
            showToolbar: !0,
            enableAnnotationToolbar: !0,
            disablePointSnapping: !1,
            sidebarMode: null,
            sidebarOptions: P.T,
            sidebarPlacement: h.d.START,
            showSignatureValidationStatus: m.W.NEVER,
            hoverAnnotationIds: (0, r.l4)(),
            hoverAnnotationNote: null,
            activeAnnotationNote: null,
            clientsChangeCallback: () => {},
            searchState: new l.Z(),
            clientPermissions: new d.Z(),
            backendPermissions: new c.Z(),
            documentPermissions: new p.Z(),
            inkEraserCursorWidth: 0,
            isPrinting: !1,
            printLoadingIndicatorProgress: null,
            toolbarItems: (0, r.aV)(),
            electronicSignatureColorPresets: [],
            electronicSignatureDefaultTextCallback: null,
            annotationToolbarHeight: 0,
            annotationPresets: (0, r.D5)(),
            annotationPresetIds: (0, r.D5)(),
            currentItemPreset: null,
            stampAnnotationTemplates: [],
            viewportState: new u.Z(),
            annotationManager: null,
            bookmarkManager: null,
            formFieldManager: null,
            formFieldValueManager: null,
            commentManager: null,
            changeManager: null,
            searchProvider: null,
            autoSaveMode: b.u.IMMEDIATE,
            eventEmitter: new D.Z(),
            printMode: w.X.DOM,
            printQuality: x.g.LOW,
            features: (0, r.aV)(),
            signatureFeatureAvailability: null,
            customOverlayItems: (0, r.D5)(),
            locale: "en",
            annotationCreatorName: null,
            signatureState: new s.Z(),
            annotationCreatorNameReadOnly: !1,
            hasPassword: !1,
            resolvePassword: null,
            isUnlockedViaModal: !1,
            transformClientToPage: e => e,
            documentOutlineState: new y.Z(),
            annotationsIdsToDelete: null,
            renderPageCallback: null,
            annotationTooltipCallback: null,
            isEditableAnnotation: null,
            isEditableComment: null,
            editableAnnotationTypes: (0, r.l4)(g.Z),
            customRenderers: null,
            customUIStore: null,
            documentHandle: null,
            documentId: null,
            allowedTileScales: "all",
            isDocumentHandleOutdated: !1,
            toolbarPlacement: f.p.TOP,
            comments: (0, r.D5)(),
            commentThreads: (0, r.D5)(),
            isSigning: !1,
            isApplyingRedactions: !1,
            digitalSignatures: null,
            previewRedactionMode: !1,
            canScrollWhileDrawing: !1,
            isAPStreamRendered: () => !0,
            invalidAPStreams: (0, r.D5)(),
            collapseSelectedNoteContent: !1,
            restrictAnnotationToPageBounds: !0,
            hasFetchedInitialRecordsFromInstant: !1,
            group: void 0,
            documentEditorFooterItems: (0, r.aV)(),
            electronicSignatureCreationModes: (0, r.hU)(v.Z),
            signingFonts: (0, r.hU)(C.Z),
            documentEditorToolbarItems: (0, r.aV)(),
            isHistoryEnabled: !1,
            areClipboardActionsEnabled: !1,
            historyChangeContext: S.j.DEFAULT,
            undoActions: (0, r.aV)(),
            redoActions: (0, r.aV)(),
            historyIdsMap: (0, r.D5)(),
            a11yStatusMessage: "",
            lastToolbarActionUsedKeyboard: !1,
            onOpenURI: null,
            onAnnotationResizeStart: void 0,
            documentComparisonState: null,
            keepSelectedTool: !1,
            instance: null,
            dateTimeString: null,
            sidebarWidth: 0,
            annotationToolbarItems: null,
            focusedAnnotationIds: (0, r.l4)(),
            annotationToolbarColorPresets: null,
            renderPagePreview: !0,
            onWidgetAnnotationCreationStart: null,
            formDesignerUnsavedWidgetAnnotation: null,
            inkEraserMode: E.b.POINT,
            firstCurrentPageIndex: 0,
            arePageSizesLoaded: null,
            inlineTextSelectionToolbarItems: null,
            measurementSnapping: !0,
            measurementPrecision: A.L.TWO,
            measurementScale: new z.Z({
              unitFrom: T.s.INCHES,
              unitTo: O.K.INCHES,
              fromValue: 1,
              toValue: 1
            }),
            measurementToolState: null,
            measurementValueConfiguration: null,
            measurementScales: null,
            APStreamVariantsRollover: (0, r.l4)(),
            APStreamVariantsDown: (0, r.l4)(),
            contentEditorSession: new k.aN(),
            showExitContentEditorDialog: !1,
            linkAnnotationMode: !1,
            anonymousComments: !1,
            annotationsGroups: (0, r.D5)(),
            selectedGroupId: null,
            enableRichText: () => !1,
            richTextEditorRef: null,
            multiAnnotationsUsingShortcut: null,
            disablePullToRefresh: !1,
            mentionableUsers: [],
            maxMentionSuggestions: 5,
            isMultiSelectionEnabled: !0,
            widgetAnnotationToFocus: null,
            onCommentCreationStart: null,
            defaultAutoCloseThreshold: I.W3,
            hintLines: null,
            scrollDisabled: !1,
            customFontsReadableNames: (0, r.l4)(),
            secondaryMeasurementUnit: null,
            activeMeasurementScale: null,
            isCalibratingScale: !1,
            dynamicFonts: null,
            enableAlwaysScrollToZoom: !1,
            noLicenseKey: !1,
            evaluation: void 0,
            buttonToImportIconFor: null,
            documentEditorConfig: I.mc,
            flattenSignedFormFieldOnExport: !1,
            OCGLayers: null,
            visibleOCGLayers: [],
            theme: F.Q.AUTO,
            ui: M.m,
            documentAssistant: new R.Z(),
            promptContentEditorDocumentDownload: !1,
            promptContentEditorCannotSaveChanges: !1,
            isServerModeDownloadingWASM: !1,
            isServerModeDownloadingDocument: !1
          },
          B = {
            pages: (0, r.aV)(),
            annotations: (0, r.D5)(),
            attachments: (0, r.D5)(),
            formFields: (0, r.D5)(),
            comments: (0, r.D5)(),
            commentThreads: (0, r.D5)()
          };
        class N extends (0, r.WV)(B) {}
        class L extends (0, r.WV)(j) {}
      },
      34390: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(35369),
          o = n(44077);
        class i extends (0, r.WV)({
          id: null,
          pageIndex: null,
          boundingBox: new o.UL(),
          contents: "",
          hints: null
        }) {}
      },
      50898: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => i,
          a: () => o
        });
        const r = (0, n(79724).Z)("ToolItem"),
          o = [Node.ELEMENT_NODE, Node.TEXT_NODE, Node.DOCUMENT_FRAGMENT_NODE],
          i = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : r;
            const {
              type: n,
              id: i,
              title: a,
              className: s,
              icon: l,
              onPress: u,
              disabled: c,
              selected: d,
              node: p
            } = e;
            t("custom" === n, "Mandatory `type` is either missing or not `custom`"), p && (t("custom" === n, "`node` is only supported for `custom` tool items."), t(o.includes(p.nodeType), "`node.nodeType` is invalid. Expected one of " + o.join(", "))), i && t("string" == typeof i, "`id` must be a `string`"), a && t("string" == typeof a, "`title` must be a `string`"), s && t("string" == typeof s, "`className` must be a `string`"), l && t("string" == typeof l, "`icon` must be a `string`"), u && t("function" == typeof u, "`onPress` must be a `function`"), "disabled" in e && t("boolean" == typeof c, "`disabled` must be a `boolean`"), "selected" in e && t("boolean" == typeof d, "`selected` must be a `boolean`");
          };
      },
      6197: (e, t, n) => {
        "use strict";

        n.d(t, {
          G: () => c
        });
        var r = n(96156),
          o = n(73417),
          i = n(79724),
          a = n(50898);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const u = (0, i.Z)("ToolbarItem"),
          c = e => {
            const {
              type: t,
              mediaQueries: n,
              preset: r
            } = e;
            u("string" == typeof t, "Mandatory `type` is either missing or not a `string`"), (0, a.G)(l(l({}, e), {}, {
              type: "custom"
            }), u), u(o._o.includes(t), `Invalid built-in type \`${t}\`. Choose one from ${o._o.join(", ")}`), n && (u(Array.isArray(n), "`mediaQueries` must be an `array`"), u(n.length > 0, "`mediaQueries` must not be an empty `array`"), n.forEach(e => {
              u("string" == typeof e, `Invalid media query: \`${e}\``);
              const t = e.split("(").length,
                n = e.split(")").length;
              0 === t && 0 === n || u(t === n, `Detected unbalanced parenthesis in the media query: ${e}`);
            })), "preset" in e && u("string" == typeof r, "`preset` must be a `string`");
          };
      },
      90093: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => f
        });
        var r = n(15359),
          o = n(35369),
          i = n(10983),
          a = n(80233),
          s = n(14286),
          l = n(2464),
          u = n(65369),
          c = n(81777),
          d = n(13349),
          p = n(21063);
        const h = "You tried to call a function on ViewState that requires a PSPDFKit.Instance.\nThis is possible, when you use a ViewState that is obtained via Instance#viewState, Instance.setViewState or by setting the instance value of a ViewState explicitly.";
        class f extends (0, o.WV)({
          currentPageIndex: 0,
          zoom: c.c.AUTO,
          zoomStep: i.V4,
          pagesRotation: 0,
          layoutMode: s.X.SINGLE,
          scrollMode: l.G.CONTINUOUS,
          showToolbar: !0,
          enableAnnotationToolbar: !0,
          allowPrinting: !0,
          allowExport: !0,
          interactionMode: null,
          readOnly: !1,
          showAnnotations: !0,
          showComments: !0,
          showAnnotationNotes: !0,
          sidebarMode: null,
          sidebarOptions: p.T,
          sidebarPlacement: u.d.START,
          spreadSpacing: i.YJ,
          pageSpacing: i.Sk,
          keepFirstSpreadAsSinglePage: !1,
          viewportPadding: new a.Z(),
          instance: null,
          formDesignMode: !1,
          showSignatureValidationStatus: d.W.NEVER,
          previewRedactionMode: !1,
          canScrollWhileDrawing: !1,
          keepSelectedTool: !1,
          resolvedLayoutMode: s.X.SINGLE,
          sidebarWidth: 0,
          disablePointSnapping: !1,
          enableAlwaysScrollToZoom: !1,
          forceRenderWidgetsInAnnotationsOrder: !1,
          prerenderedPageSpreads: i.J8,
          showDocumentAssistant: !1
        }) {
          zoomIn() {
            if (!this.instance) throw new r.p2(h);
            this.instance.zoomStep || (this.instance.zoomStep = i.V4);
            const {
              maximumZoomLevel: e
            } = this.instance;
            let t = this.instance.currentZoomLevel * this.instance.zoomStep;
            return t > e && (t = e), this.set("zoom", t);
          }
          zoomOut() {
            if (!this.instance) throw new r.p2(h);
            this.instance.zoomStep || (this.instance.zoomStep = i.V4);
            const {
              minimumZoomLevel: e
            } = this.instance;
            let t = this.instance.currentZoomLevel / this.instance.zoomStep;
            return t < e && (t = e), this.set("zoom", t);
          }
          rotateLeft() {
            return this.update("pagesRotation", e => (e + 270) % 360);
          }
          rotateRight() {
            return this.update("pagesRotation", e => (e + 90) % 360);
          }
          goToNextPage() {
            if (!this.instance) throw new r.p2(h);
            let e = this.currentPageIndex + 1;
            return e > this.instance.totalPageCount - 1 && (e = this.instance.totalPageCount - 1), this.set("currentPageIndex", e);
          }
          goToPreviousPage() {
            let e = this.currentPageIndex - 1;
            return e < 0 && (e = 0), this.set("currentPageIndex", e);
          }
        }
      },
      80233: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = n(35369),
          o = n(10983);
        class i extends (0, r.WV)({
          horizontal: o.Kk,
          vertical: o.Kk
        }) {}
      },
      34723: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => c
        });
        var r = n(35369),
          o = n(10983),
          i = n(14286),
          a = n(2464),
          s = n(81777),
          l = n(44077);
        const u = {
          zoomLevel: 1,
          zoomMode: s.c.AUTO,
          layoutMode: i.X.SINGLE,
          scrollMode: a.G.CONTINUOUS,
          scrollPosition: new l.E9(),
          currentPageIndex: 0,
          viewportRect: new l.UL(),
          pageSizes: (0, r.aV)(),
          commentMode: null,
          pagesRotation: 0,
          viewportPadding: new l.E9({
            x: o.Kk,
            y: o.Kk
          }),
          spreadSpacing: o.YJ,
          pageSpacing: o.Sk,
          keepFirstSpreadAsSinglePage: !1,
          minDefaultZoomLevel: o.cY,
          maxDefaultZoomLevel: o.QS,
          zoomStep: o.V4,
          lastScrollUsingKeyboard: !1,
          documentComparisonMode: null,
          disablePointSnapping: !1,
          enableAlwaysScrollToZoom: !1,
          forceRenderWidgetsInAnnotationsOrder: !1,
          prerenderedPageSpreads: 5
        };
        class c extends r.WV(u) {}
      },
      690: (e, t, n) => {
        "use strict";

        n.d(t, {
          D2: () => c,
          Q: () => d,
          aU: () => a,
          co: () => u,
          uV: () => s,
          zR: () => l
        });
        var r = n(96156),
          o = n(15359),
          i = n(9933);
        class a extends i.D {
          constructor(e) {
            if (super(e), (0, r.Z)(this, "subActions", null), this.subActions = null == e ? void 0 : e.subActions, this.constructor === a) throw new o.p2("PSPDFKit.Actions.Action is an abstract base class and can not be instantiated");
          }
        }
        (0, i.V)(a);
        const s = 1,
          l = 1,
          u = 2,
          c = 3,
          d = 4;
      },
      27922: (e, t, n) => {
        "use strict";

        n.d(t, {
          b: () => a
        });
        var r = n(96156),
          o = n(9933),
          i = n(690);
        class a extends i.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, r.Z)(a, "defaultValues", {
          script: ""
        }), (0, o.V)(a);
      },
      96706: (e, t, n) => {
        "use strict";

        n.d(t, {
          aU: () => r.aU,
          Di: () => a,
          Qr: () => s,
          _6: () => l,
          ZD: () => c,
          bp: () => d.b,
          b: () => p,
          oH: () => h,
          BO: () => f,
          pl: () => m,
          lm: () => g
        });
        var r = n(690),
          o = n(96156),
          i = n(9933);
        class a extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(a, "defaultValues", {
          pageIndex: null
        }), (0, i.V)(a);
        class s extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(s, "defaultValues", {
          newWindow: !1,
          relativePath: "",
          targetType: "parent"
        }), (0, i.V)(s);
        class l extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(l, "defaultValues", {
          relativePath: "",
          namedDestination: ""
        }), (0, i.V)(l);
        var u = n(35369);
        class c extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(c, "defaultValues", {
          hide: !0,
          annotationReferences: (0, u.aV)()
        }), (0, i.V)(c);
        var d = n(27922);
        class p extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(p, "defaultValues", {
          filePath: null
        }), (0, i.V)(p);
        class h extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(h, "defaultValues", {
          action: null
        }), (0, i.V)(h);
        class f extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(f, "defaultValues", {
          fields: null,
          includeExclude: !1
        }), (0, i.V)(f);
        class m extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(m, "defaultValues", {
          uri: null,
          fields: null,
          includeExclude: !1,
          includeNoValueFields: !0,
          exportFormat: !0,
          getMethod: !1,
          submitCoordinated: !1,
          xfdf: !1,
          includeAppendSaves: !1,
          includeAnnotations: !1,
          submitPDF: !1,
          canonicalFormat: !1,
          excludeNonUserAnnotations: !1,
          excludeFKey: !1,
          embedForm: !1
        }), (0, i.V)(m);
        class g extends r.aU {
          constructor(e) {
            super(e);
          }
        }
        (0, o.Z)(g, "defaultValues", {
          uri: null
        }), (0, i.V)(g);
      },
      23951: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(15359),
          i = n(44077),
          a = n(9933);
        class s extends a.D {
          constructor(e) {
            if (super(e), this.constructor === s) throw new o.p2("PSPDFKit.Annotations.Annotation is an abstract base class and can not be instantiated");
          }
        }
        (0, r.Z)(s, "defaultValues", {
          id: null,
          name: null,
          subject: null,
          pdfObjectId: null,
          pageIndex: null,
          boundingBox: new i.UL(),
          opacity: 1,
          action: null,
          note: null,
          creatorName: null,
          createdAt: new Date(0),
          updatedAt: new Date(0),
          customData: null,
          noPrint: !1,
          noZoom: !1,
          noRotate: !1,
          noView: !1,
          locked: !1,
          lockedContents: !1,
          readOnly: !1,
          hidden: !1,
          blendMode: "normal",
          additionalActions: null,
          isCommentThreadRoot: !1,
          isAnonymous: !1,
          group: void 0,
          isEditable: void 0,
          isDeletable: void 0,
          canSetGroup: void 0,
          canReply: void 0,
          APStreamCache: void 0,
          rotation: 0
        }), (0, a.V)(s);
        const l = s;
      },
      81026: (e, t, n) => {
        "use strict";

        n.d(t, {
          FN: () => c,
          Yu: () => d,
          p1: () => u
        });
        var r = n(96156),
          o = n(34997),
          i = n(4715),
          a = n(44077),
          s = n(16006),
          l = n(9933);
        const u = 32;
        class c extends i.Qi {}
        function d(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : u;
          if (e) {
            var r;
            const i = p(e, t, n);
            return new c({
              id: (0, o.SK)(),
              pageIndex: e.pageIndex,
              boundingBox: new a.UL({
                left: i.x,
                top: i.y,
                width: t,
                height: n
              }),
              text: {
                format: "plain",
                value: null !== (r = e.note) && void 0 !== r ? r : ""
              },
              parentAnnotation: e,
              position: i
            });
          }
          return new c({
            id: (0, o.SK)(),
            notePosition: new a.E9()
          });
        }
        function p(e, t, n) {
          let r = null;
          var o, l;
          if (e instanceof i.Zc) e.lines.isEmpty() || null !== (o = e.lines.get(0)) && void 0 !== o && o.isEmpty() || (r = null === (l = e.lines.get(0)) || void 0 === l ? void 0 : l.get(0));else if (e instanceof s.Z || e instanceof i.om) {
            if (e.points && e.points.size >= 2) {
              const t = e.points.get(0),
                n = e.points.get(1);
              r = new a.E9({
                x: (t.x + n.x) / 2,
                y: (t.y + n.y) / 2
              });
            }
          } else if (e instanceof i.o9) {
            const t = e.startPoint,
              n = e.endPoint;
            r = new a.E9({
              x: (t.x + n.x) / 2,
              y: (t.y + n.y) / 2
            });
          } else if (e instanceof i.On) return new a.E9({
            x: e.boundingBox.right + 4,
            y: e.boundingBox.getCenter().y - n / 2
          });
          return r || (r = new a.E9({
            x: e.boundingBox.getCenter().x,
            y: e.boundingBox.top
          })), r.set("x", r.x - t / 2).set("y", r.y - n / 2);
        }
        (0, r.Z)(c, "defaultValues", {
          parentAnnotation: null,
          position: new a.E9(),
          notePosition: new a.E9()
        }), (0, l.V)(c);
      },
      4526: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r = n(96156),
          o = n(23951),
          i = n(9933);
        class a extends o.Z {}
        (0, r.Z)(a, "defaultValues", {
          description: null,
          fileName: null,
          contentType: null,
          imageAttachmentId: null,
          isSignature: !1,
          xfdfAppearanceStream: null,
          xfdfAppearanceStreamOriginalPageRotation: null
        }), (0, r.Z)(a, "readableName", "Image"), (0, i.V)(a);
        const s = a;
      },
      55752: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(23951),
          a = n(60379),
          s = n(9933);
        class l extends i.Z {}
        (0, r.Z)(l, "defaultValues", {
          lines: (0, o.aV)(),
          lineWidth: 5,
          strokeColor: a.Z.BLUE,
          backgroundColor: null,
          isDrawnNaturally: !1,
          isSignature: !1
        }), (0, r.Z)(l, "readableName", "Ink"), (0, s.V)(l);
        const u = l;
      },
      96726: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(96156),
          o = n(23951),
          i = n(9933);
        class a extends o.Z {}
        (0, r.Z)(a, "defaultValues", {
          description: null,
          fileName: null,
          contentType: null,
          mediaAttachmentId: null
        }), (0, r.Z)(a, "readableName", "Media"), (0, i.V)(a);
      },
      18726: (e, t, n) => {
        "use strict";

        n.d(t, {
          W: () => u,
          Z: () => d
        });
        var r,
          o = n(96156),
          i = n(23951),
          a = n(60379),
          s = n(59062),
          l = n(9933);
        const u = [{
          color: new a.Z({
            r: 255,
            g: 216,
            b: 63
          }),
          localization: {
            id: "yellow",
            defaultMessage: "Yellow",
            description: "Yellow color"
          }
        }, {
          color: new a.Z({
            r: 255,
            g: 127,
            b: 0
          }),
          localization: {
            id: "orange",
            defaultMessage: "Orange",
            description: "Orange, the color"
          }
        }, {
          color: new a.Z({
            r: 255,
            g: 51,
            b: 0
          }),
          localization: {
            id: "red",
            defaultMessage: "Red",
            description: "Red, the color"
          }
        }, {
          color: new a.Z({
            r: 229,
            g: 51,
            b: 255
          }),
          localization: {
            id: "fuchsia",
            defaultMessage: "Fuchsia",
            description: "Fuchsia, the color"
          }
        }, {
          color: new a.Z({
            r: 0,
            g: 153,
            b: 255
          }),
          localization: {
            id: "blue",
            defaultMessage: "Blue",
            description: "Blue, the color"
          }
        }, {
          color: new a.Z({
            r: 114,
            g: 255,
            b: 0
          }),
          localization: {
            id: "green",
            defaultMessage: "Green",
            description: "Green, the color"
          }
        }];
        class c extends i.Z {}
        (0, o.Z)(c, "isEditable", !0), (0, o.Z)(c, "readableName", "Note"), (0, o.Z)(c, "defaultValues", {
          text: {
            format: "plain",
            value: ""
          },
          icon: s.Zi.COMMENT,
          color: null === (r = u.find(e => "yellow" === e.localization.id)) || void 0 === r ? void 0 : r.color
        }), (0, l.V)(c);
        const d = c;
      },
      94732: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r = n(96156),
          o = n(67041),
          i = n(60379),
          a = n(9933);
        class s extends o.Z {}
        (0, r.Z)(s, "readableName", "Redaction"), (0, r.Z)(s, "defaultValues", {
          color: i.Z.RED,
          fillColor: i.Z.BLACK,
          outlineColor: i.Z.RED,
          overlayText: null,
          repeatOverlayText: null,
          rotation: 0
        }), (0, a.V)(s);
      },
      70964: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(23951),
          i = n(60379),
          a = n(9933);
        class s extends o.Z {
          isMeasurement() {
            return null !== this.measurementScale;
          }
        }
        (0, r.Z)(s, "readableName", "Shape"), (0, r.Z)(s, "defaultValues", {
          strokeWidth: 5,
          strokeColor: i.Z.BLUE,
          fillColor: null,
          strokeDashArray: null,
          measurementPrecision: null,
          measurementScale: null
        }), (0, a.V)(s);
        const l = s;
      },
      29977: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZP: () => c,
          a$: () => s,
          k1: () => l,
          pY: () => a
        });
        var r = n(96156),
          o = n(23951),
          i = n(9933);
        const a = {
            Approved: {},
            NotApproved: {},
            Draft: {},
            Final: {},
            Completed: {},
            Confidential: {},
            ForPublicRelease: {},
            NotForPublicRelease: {},
            ForComment: {},
            Void: {},
            PreliminaryResults: {},
            InformationOnly: {},
            Rejected: {},
            Accepted: {},
            InitialHere: {},
            SignHere: {},
            Witness: {},
            AsIs: {},
            Departmental: {},
            Experimental: {},
            Expired: {},
            Sold: {},
            TopSecret: {},
            Revised: {
              includeDate: !0,
              includeTime: !0
            },
            RejectedWithText: {
              includeDate: !0,
              includeTime: !0
            },
            Custom: {}
          },
          s = {
            RejectedWithText: "Rejected"
          },
          l = e => s[e] || e;
        class u extends o.Z {}
        (0, r.Z)(u, "defaultValues", {
          stampType: "Custom",
          title: null,
          subtitle: null,
          color: null,
          xfdfAppearanceStream: null,
          xfdfAppearanceStreamOriginalPageRotation: null
        }), (0, r.Z)(u, "readableName", "Stamp"), (0, i.V)(u);
        const c = u;
      },
      13538: (e, t, n) => {
        "use strict";

        n.d(t, {
          default: () => u
        });
        var r = n(96156),
          o = n(80567),
          i = n(23951),
          a = n(60379),
          s = n(9933);
        class l extends i.Z {}
        (0, r.Z)(l, "defaultValues", {
          text: {
            format: "plain",
            value: ""
          },
          fontColor: a.Z.BLACK,
          backgroundColor: null,
          font: o.vt.first() || "sans-serif",
          fontSize: 18,
          isBold: !1,
          isItalic: !1,
          horizontalAlign: "left",
          verticalAlign: "top",
          callout: null,
          borderStyle: null,
          borderWidth: null,
          borderColor: null,
          isFitting: !1,
          lineHeightFactor: null
        }), (0, r.Z)(l, "isEditable", !0), (0, r.Z)(l, "readableName", "Text"), (0, r.Z)(l, "fontSizePresets", Object.freeze([4, 6, 8, 10, 12, 14, 18, 24, 36, 48, 64, 72, 96, 144, 192, 200])), (0, s.V)(l);
        const u = l;
      },
      67041: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(23951),
          a = n(60379),
          s = n(9933);
        class l extends i.Z {}
        (0, r.Z)(l, "defaultValues", {
          rects: (0, o.aV)(),
          color: a.Z.BLACK,
          blendMode: "normal"
        }), (0, r.Z)(l, "readableName", "Text-Markup"), (0, s.V)(l);
        const u = l;
      },
      66701: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => s
        });
        var r = n(96156),
          o = n(23951),
          i = n(9933);
        class a extends o.Z {}
        (0, r.Z)(a, "defaultValues", {
          formFieldName: null,
          borderColor: null,
          borderStyle: null,
          borderDashArray: null,
          borderWidth: null,
          backgroundColor: null,
          fontSize: null,
          font: null,
          isBold: !1,
          isItalic: !1,
          fontColor: null,
          horizontalAlign: null,
          verticalAlign: null,
          additionalActions: null,
          lineHeightFactor: null,
          buttonIconUpdatedAt: null
        }), (0, r.Z)(a, "readableName", "Widget"), (0, i.V)(a);
        const s = a;
      },
      4715: (e, t, n) => {
        "use strict";

        n.d(t, {
          q6: () => r.Z,
          Jn: () => k,
          Xs: () => f.Z,
          FV: () => l,
          sK: () => u.Z,
          Zc: () => c.Z,
          o9: () => p.Z,
          R1: () => y,
          Hu: () => z.Z,
          Qi: () => b.Z,
          Hi: () => m.Z,
          om: () => g.Z,
          b3: () => h.Z,
          Wk: () => A.Z,
          UX: () => d.Z,
          hL: () => w,
          GI: () => x.ZP,
          R9: () => D,
          gd: () => C.default,
          On: () => i.Z,
          xu: () => S,
          Ih: () => _,
          x_: () => P.Z
        });
        var r = n(23951),
          o = n(96156),
          i = n(67041),
          a = n(60379),
          s = n(9933);
        class l extends i.Z {}
        (0, o.Z)(l, "className", "highlight"), (0, o.Z)(l, "readableName", "Highlight"), (0, o.Z)(l, "defaultValues", {
          blendMode: "multiply",
          color: a.Z.LIGHT_YELLOW
        }), (0, s.V)(l);
        var u = n(4526),
          c = n(55752),
          d = n(70964),
          p = n(71479),
          h = n(14165),
          f = n(9513),
          m = n(16006),
          g = n(45874);
        class v extends r.Z {}
        (0, o.Z)(v, "readableName", "Link"), (0, o.Z)(v, "defaultValues", {
          borderWidth: 0,
          borderColor: null,
          borderStyle: null,
          opacity: 1
        }), (0, s.V)(v);
        const y = v;
        var b = n(18726);
        class w extends i.Z {}
        (0, o.Z)(w, "className", "squiggle"), (0, o.Z)(w, "readableName", "Squiggle"), (0, o.Z)(w, "defaultValues", {
          color: a.Z.RED
        }), (0, s.V)(w);
        var x = n(29977);
        class D extends i.Z {}
        (0, o.Z)(D, "className", "strikeout"), (0, o.Z)(D, "readableName", "Strike Out"), (0, o.Z)(D, "defaultValues", {
          color: a.Z.RED
        }), (0, s.V)(D);
        var C = n(13538);
        class S extends i.Z {}
        (0, o.Z)(S, "className", "underline"), (0, o.Z)(S, "readableName", "Underline"), (0, o.Z)(S, "defaultValues", {
          color: a.Z.BLACK
        }), (0, s.V)(S);
        class E extends r.Z {}
        (0, s.V)(E);
        const _ = E;
        var P = n(66701);
        class k extends r.Z {}
        (0, o.Z)(k, "readableName", "Comment-Marker"), (0, s.V)(k);
        var A = n(94732),
          z = n(96726);
      },
      9513: (e, t, n) => {
        "use strict";

        n.d(t, {
          F: () => c,
          Z: () => d
        });
        var r = n(96156),
          o = n(70964),
          i = n(44077),
          a = n(10983),
          s = n(9933);
        function l(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        class u extends o.Z {
          constructor(e) {
            super(c(e));
          }
        }
        function c(e) {
          if (!e) return;
          const t = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }({}, e);
          if (Number(e.cloudyBorderIntensity) > 0 && !e.cloudyBorderInset) {
            const n = Number(e.cloudyBorderIntensity) * a.St + (e.strokeWidth || o.Z.defaultValues.strokeWidth) / 2;
            return t.cloudyBorderInset = i.eB.fromValue(n), t;
          }
          return t;
        }
        (0, r.Z)(u, "defaultValues", {
          cloudyBorderIntensity: null,
          cloudyBorderInset: null,
          measurementBBox: null
        }), (0, r.Z)(u, "readableName", "Ellipse"), (0, s.V)(u);
        const d = u;
      },
      71479: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(70964),
          i = n(44077),
          a = n(9933);
        class s extends o.Z {}
        (0, r.Z)(s, "defaultValues", {
          startPoint: new i.E9(),
          endPoint: new i.E9(),
          lineCaps: null
        }), (0, r.Z)(s, "readableName", "Line"), (0, a.V)(s);
        const l = s;
      },
      16006: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(35369),
          i = n(70964),
          a = n(9933);
        class s extends i.Z {}
        (0, r.Z)(s, "defaultValues", {
          points: (0, o.aV)(),
          cloudyBorderIntensity: null
        }), (0, r.Z)(s, "readableName", "Polygon"), (0, a.V)(s);
        const l = s;
      },
      45874: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(35369),
          i = n(70964),
          a = n(9933);
        class s extends i.Z {}
        (0, r.Z)(s, "defaultValues", {
          points: (0, o.aV)(),
          lineCaps: null
        }), (0, r.Z)(s, "readableName", "Polyline"), (0, a.V)(s);
        const l = s;
      },
      14165: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => l
        });
        var r = n(96156),
          o = n(70964),
          i = n(9513),
          a = n(9933);
        class s extends o.Z {
          constructor(e) {
            super((0, i.F)(e));
          }
        }
        (0, r.Z)(s, "defaultValues", {
          cloudyBorderIntensity: null,
          cloudyBorderInset: null,
          measurementBBox: null
        }), (0, r.Z)(s, "readableName", "Rectangle"), (0, a.V)(s);
        const l = s;
      },
      56207: (e, t, n) => {
        "use strict";

        n.d(t, {
          Gu: () => u,
          ZP: () => l,
          vQ: () => c
        });
        var r = n(96156),
          o = n(15359),
          i = n(35369),
          a = n(92310);
        const s = {
          id: null,
          rootId: null,
          pageIndex: null,
          pdfObjectId: null,
          creatorName: null,
          createdAt: new Date(0),
          updatedAt: new Date(0),
          text: {
            format: "xhtml",
            value: null
          },
          customData: null,
          group: void 0,
          isEditable: void 0,
          isDeletable: void 0,
          canSetGroup: void 0,
          isAnonymous: void 0
        };
        class l extends i.WV(s) {
          getMentionedUserIds() {
            const e = this.text.value;
            (0, o.kG)("string" == typeof e, "`text.value` must be of type `string`");
            const t = new DOMParser().parseFromString(e, "text/html").body.querySelectorAll("span[data-user-id]"),
              n = Array.from(t).map(e => e.getAttribute("data-user-id")).filter(o.lH);
            return i.l4(n);
          }
        }
        (0, r.Z)(l, "toSerializableObject", e => (0, a.o)(e, e.rootId)), (0, r.Z)(l, "fromSerializableObject", e => (0, a.z)(e.id || null, e));
        const u = e => {
          (0, o.kG)("string" == typeof e.id, "`id` must be of type `string`"), (0, o.kG)("string" == typeof e.rootId, "`rootId` must be of type `string`"), (0, o.kG)("number" == typeof e.pageIndex, "`pageIndex` must be of type `number`"), (0, o.kG)(null == e.pdfObjectId || "number" == typeof e.pdfObjectId, "`pdfObjectId` must be of type `number`"), (0, o.kG)(null == e.creatorName || "string" == typeof e.creatorName, "`creatorName` must be of type `string`"), (0, o.kG)(e.createdAt instanceof Date, "`createdAt` must be a Date"), (0, o.kG)(e.updatedAt instanceof Date, "`updatedAt` must be a Date"), (0, o.kG)("object" == typeof e.text, "`text` must be of type `object`"), (0, o.kG)("string" == typeof e.text.value, "`text` must be of type `string`"), (0, o.kG)("xhtml" === e.text.format || "plain" === e.text.format, "`text.format` must be either `xhtml` or `plain`"), (0, o.kG)(null == e.customData || (0, o.PO)(e.customData), "`customData` must be a JSON-serializable object"), (0, o.kG)(void 0 === e.isAnonymous || "boolean" == typeof e.isAnonymous || null == e.isAnonymous, "`isAnonymous` must be of type `boolean`");
        };
        function c(e) {
          return (0, o.kG)("string" == typeof e.id, "`id` must be of type `string`"), (0, o.kG)("string" == typeof e.name, "`name` must be of type `string`"), e.avatarUrl && (0, o.kG)("string" == typeof e.avatarUrl, "`avatarUrl` must be of type `string`"), e.description && (0, o.kG)("string" == typeof e.description, "`description` must be of type `string`"), (0, o.kG)("string" == typeof e.displayName, "`displayName` must be of type `string`"), e;
        }
      },
      74110: (e, t, n) => {
        "use strict";

        n.d(t, {
          BG: () => a,
          FR: () => u,
          QA: () => r,
          Xl: () => l,
          hz: () => s,
          qA: () => i,
          wk: () => o
        });
        const r = {
            ok: "ok",
            tampered_document: "tampered_document",
            failed_to_retrieve_signature_contents: "failed_to_retrieve_signature_contents",
            failed_to_retrieve_byterange: "failed_to_retrieve_byterange",
            failed_to_compute_digest: "failed_to_compute_digest",
            failed_retrieve_signing_certificate: "failed_retrieve_signing_certificate",
            failed_retrieve_public_key: "failed_retrieve_public_key",
            failed_encryption_padding: "failed_encryption_padding",
            tampered_or_invalid_timestamp: "tampered_or_invalid_timestamp",
            general_failure: "general_failure"
          },
          o = {
            ok: "ok",
            ok_but_self_signed: "ok_but_self_signed",
            ok_but_could_not_check_revocation: "ok_but_could_not_check_revocation",
            untrusted: "untrusted",
            expired: "expired",
            not_yet_valid: "not_yet_valid",
            invalid: "invalid",
            revoked: "revoked",
            failed_to_retrieve_signature_contents: "failed_to_retrieve_signature_contents",
            general_validation_problem: "general_validation_problem"
          },
          i = {
            valid: "valid",
            warning: "warning",
            error: "error"
          },
          a = {
            CMS: "CMS",
            CAdES: "CAdES"
          },
          s = {
            b_b: "b-b",
            b_t: "b-t",
            b_lt: "b-lt"
          },
          l = {
            cms: "cms",
            cades: "cades",
            documentTimestamp: "documentTimestamp"
          },
          u = {
            raw: "raw",
            pkcs7: "pkcs7"
          };
      },
      69842: (e, t, n) => {
        "use strict";

        n.d(t, {
          _: () => r
        });
        const r = {
          valid: "valid",
          warning: "warning",
          error: "error",
          not_signed: "not_signed"
        };
      },
      2841: (e, t, n) => {
        "use strict";

        n.d(t, {
          f: () => r
        });
        let r = function (e) {
          return e.DRAW_START = "DRAW_START", e.DRAW_END = "DRAW_END", e.TEXT_EDIT_START = "TEXT_EDIT_START", e.TEXT_EDIT_END = "TEXT_EDIT_END", e.SELECT_START = "SELECT_START", e.SELECT_END = "SELECT_END", e.MOVE_START = "MOVE_START", e.MOVE_END = "MOVE_END", e.RESIZE_START = "RESIZE_START", e.RESIZE_END = "RESIZE_END", e.ROTATE_START = "ROTATE_START", e.ROTATE_END = "ROTATE_END", e.DELETE_START = "DELETE_START", e.DELETE_END = "DELETE_END", e.PROPERTY_CHANGE = "PROPERTY_CHANGE", e;
        }({});
      },
      7654: (e, t, n) => {
        "use strict";

        n.d(t, {
          Gu: () => c,
          Mr: () => s,
          ZP: () => u
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(9933);
        const s = ["readOnly", "required", "noExport"];
        class l extends a.D {
          constructor(e) {
            if (super(e), this.constructor === l) throw new i.p2("PSPDFKit.FormFields.FormField is an abstract base class and can not be instantiated");
          }
        }
        (0, r.Z)(l, "defaultValues", {
          id: null,
          pdfObjectId: null,
          annotationIds: (0, o.aV)(),
          name: null,
          label: "",
          readOnly: !1,
          required: !1,
          noExport: !1,
          additionalActions: null,
          group: void 0,
          isEditable: void 0,
          isFillable: void 0,
          isDeletable: void 0,
          canSetGroup: void 0
        }), (0, a.V)(l);
        const u = l;
        function c(e) {
          return e.has("name");
        }
      },
      48169: (e, t, n) => {
        "use strict";

        n.d(t, {
          X: () => s,
          Z: () => a
        });
        var r = n(96156),
          o = n(9933);
        class i extends o.D {
          constructor(e) {
            super(e), void 0 !== (null == e ? void 0 : e.optionIndexes) && (this.optionIndexes = e.optionIndexes), void 0 !== (null == e ? void 0 : e.isFitting) && (this.isFitting = e.isFitting);
          }
        }
        (0, r.Z)(i, "defaultValues", {
          name: null,
          value: null
        }), (0, o.V)(i);
        const a = i;
        function s(e) {
          return `form-field-value/${e.name}`;
        }
      },
      1858: (e, t, n) => {
        "use strict";

        n.d(t, {
          R0: () => s,
          rF: () => c,
          Dz: () => p,
          fB: () => f,
          Wi: () => o.ZP,
          KD: () => m.Z,
          Vi: () => v,
          XQ: () => b,
          Yo: () => C,
          $o: () => x
        });
        var r = n(96156),
          o = n(7654),
          i = n(9933);
        class a extends o.ZP {}
        (0, r.Z)(a, "defaultValues", {
          buttonLabel: null
        }), (0, i.V)(a);
        const s = a;
        var l = n(35369);
        class u extends o.ZP {}
        (0, r.Z)(u, "defaultValues", {
          values: (0, l.aV)(),
          defaultValues: (0, l.aV)(),
          options: (0, l.aV)(),
          optionIndexes: void 0
        }), (0, i.V)(u);
        const c = u;
        class d extends o.ZP {}
        (0, r.Z)(d, "defaultValues", {
          options: (0, l.aV)(),
          values: (0, l.aV)(),
          defaultValues: (0, l.aV)(),
          multiSelect: !1,
          commitOnChange: !1,
          additionalActions: null
        }), (0, i.V)(d);
        const p = d;
        class h extends p {}
        (0, r.Z)(h, "defaultValues", {
          edit: !1,
          doNotSpellCheck: !1
        }), (0, i.V)(h);
        const f = h;
        var m = n(48169);
        class g extends p {}
        (0, i.V)(g);
        const v = g;
        class y extends o.ZP {}
        (0, r.Z)(y, "defaultValues", {
          options: (0, l.aV)(),
          noToggleToOff: !1,
          radiosInUnison: !0,
          value: "",
          defaultValue: "",
          optionIndexes: void 0
        }), (0, i.V)(y);
        const b = y;
        class w extends o.ZP {}
        (0, r.Z)(w, "defaultValues", {
          password: !1,
          maxLength: null,
          doNotSpellCheck: !1,
          doNotScroll: !1,
          multiLine: !1,
          comb: !1,
          value: "",
          defaultValue: "",
          additionalActions: null
        }), (0, i.V)(w);
        const x = w;
        class D extends o.ZP {}
        const C = D;
      },
      51065: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u
        });
        var r = n(96156),
          o = n(13205),
          i = n(9933);
        function a(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function s(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        class l extends o.Z {
          constructor(e) {
            super(e);
          }
        }
        (0, r.Z)(l, "defaultValues", s(s({}, o.Z.defaultValues), {}, {
          intensity: .5
        })), (0, i.V)(l);
        const u = l;
      },
      13205: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(96156),
          o = n(9933);
        class i extends o.D {
          constructor(e) {
            super(e);
          }
          scale(e, t) {
            return this.withMutations(n => {
              t || (t = e), n.set("x", this.x * e).set("y", this.y * t);
            });
          }
          translate(e) {
            let {
              x: t,
              y: n
            } = e;
            return this.withMutations(e => {
              e.set("x", this.x + t).set("y", this.y + n);
            });
          }
          translateX(e) {
            return this.translate(new i({
              x: e,
              y: 0
            }));
          }
          translateY(e) {
            return this.translate(new i({
              x: 0,
              y: e
            }));
          }
          distance(e) {
            return Math.sqrt((e.x - this.x) ** 2 + (e.y - this.y) ** 2);
          }
          rotate(e) {
            e %= 360;
            const {
              x: t,
              y: n
            } = this;
            switch (e) {
              case 0:
                return this;
              case 90:
                return this.set("x", n).set("y", -t);
              case 180:
                return this.set("x", -t).set("y", -n);
              case 270:
                return this.set("x", -n).set("y", t);
              default:
                {
                  const r = e * Math.PI / 180;
                  return this.set("x", Math.cos(r) * t + Math.sin(r) * n).set("y", Math.cos(r) * n - Math.sin(r) * t);
                }
            }
          }
          apply(e) {
            const [t, n] = e.applyToPoint([this.x, this.y]);
            return this.withMutations(e => {
              e.set("x", t).set("y", n);
            });
          }
        }
        (0, r.Z)(i, "defaultValues", {
          x: 0,
          y: 0
        }), (0, o.V)(i);
        const a = i;
      },
      36691: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => u
        });
        var r = n(96156),
          o = n(15359),
          i = n(9933),
          a = n(13205),
          s = n(90569);
        class l extends i.D {
          constructor(e) {
            super(e);
          }
          get right() {
            return this.left + this.width;
          }
          get bottom() {
            return this.top + this.height;
          }
          static fromClientRect(e) {
            let {
              top: t,
              left: n,
              width: r,
              height: o
            } = e;
            return new l({
              top: t,
              left: n,
              width: r,
              height: o
            });
          }
          static union(e) {
            const t = e.map(e => e.top).min(),
              n = e.map(e => e.bottom).max() - t,
              r = e.map(e => e.left).min(),
              o = e.map(e => e.right).max() - r;
            return new l({
              left: r,
              top: t,
              width: o,
              height: n
            });
          }
          static getCenteredRect(e, t) {
            return new l({
              left: (t.width - e.width) / 2,
              top: (t.height - e.height) / 2,
              width: e.width,
              height: e.height
            });
          }
          static fromInset(e) {
            return new l({
              left: e.left,
              top: e.top,
              width: e.right - e.left,
              height: e.bottom - e.top
            });
          }
          static fromPoints() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            (0, o.kG)(4 === t.length, "Rect.fromPoints requires 4 points");
            const r = Math.min(...t.map(e => e.x)),
              i = Math.min(...t.map(e => e.y)),
              a = Math.max(...t.map(e => e.x)),
              s = Math.max(...t.map(e => e.y));
            return new l({
              left: r,
              top: i,
              width: a - r,
              height: s - i
            });
          }
          expandToIncludePoints() {
            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
            const r = Math.min(this.left, ...t.map(e => e.x)),
              o = Math.min(this.top, ...t.map(e => e.y)),
              i = Math.max(this.left + this.width, ...t.map(e => e.x)),
              a = Math.max(this.top + this.height, ...t.map(e => e.y));
            return new l({
              left: r,
              top: o,
              width: i - r,
              height: a - o
            });
          }
          static areRectsCloserThan(e, t, n) {
            return Math.abs(e.left - t.left) <= n && Math.abs(e.top - t.top) <= n && Math.abs(e.left + e.width - (t.left + t.width)) <= n && Math.abs(e.top + e.height - (t.top + t.height)) <= n;
          }
          static areVerticallyAligned(e, t, n) {
            return Math.abs(e.top - t.top) <= n && Math.abs(e.top + e.height - (t.top + t.height)) <= n;
          }
          translate(e) {
            let {
              x: t,
              y: n
            } = e;
            return this.withMutations(e => {
              e.set("left", this.left + t).set("top", this.top + n);
            });
          }
          translateX(e) {
            return this.set("left", this.left + e);
          }
          translateY(e) {
            return this.set("top", this.top + e);
          }
          scale(e, t) {
            return this.withMutations(n => {
              t || (t = e), n.set("left", this.left * e).set("top", this.top * t).set("width", this.width * e).set("height", this.height * t);
            });
          }
          grow(e) {
            return this.withMutations(t => {
              t.set("left", this.left - e).set("top", this.top - e).set("width", this.width + 2 * e).set("height", this.height + 2 * e);
            });
          }
          getLocation() {
            return new a.Z({
              x: this.left,
              y: this.top
            });
          }
          getSize() {
            return new s.Z({
              width: this.width,
              height: this.height
            });
          }
          getCenter() {
            return new a.Z({
              x: this.left + this.width / 2,
              y: this.top + this.height / 2
            });
          }
          setLocation(e) {
            return this.withMutations(t => {
              t.set("left", e.x).set("top", e.y);
            });
          }
          roundOverlap() {
            return this.withMutations(e => {
              e.set("left", Math.floor(this.left)).set("top", Math.floor(this.top)).set("width", Math.ceil(this.width)).set("height", Math.ceil(this.height));
            });
          }
          round() {
            return this.withMutations(e => {
              e.set("left", Math.round(this.left)).set("top", Math.round(this.top)).set("width", Math.round(this.width)).set("height", Math.round(this.height));
            });
          }
          isPointInside(e) {
            return e.x >= this.left && e.x <= this.right && e.y >= this.top && e.y <= this.bottom;
          }
          isRectInside(e) {
            return this.isPointInside(e.getLocation()) && this.isPointInside(e.getLocation().translate(new a.Z({
              x: e.width,
              y: e.height
            })));
          }
          isRectOverlapping(e) {
            return e.left < this.right && e.right > this.left && e.top < this.bottom && e.bottom > this.top;
          }
          normalize() {
            return this.withMutations(e => e.set("left", this.width < 0 ? this.left + this.width : this.left).set("top", this.height < 0 ? this.top + this.height : this.top).set("width", Math.abs(this.width)).set("height", Math.abs(this.height)));
          }
          apply(e) {
            const [t, n] = e.applyToPoint([this.left, this.top]),
              [r, o] = e.applyToVector([this.width, this.height]);
            return this.withMutations(e => e.set("left", t).set("top", n).set("width", r).set("height", o)).normalize();
          }
        }
        (0, r.Z)(l, "defaultValues", {
          left: 0,
          top: 0,
          width: 0,
          height: 0
        }), (0, i.V)(l);
        const u = l;
      },
      90569: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          width: 0,
          height: 0
        }) {
          scale(e) {
            return this.withMutations(t => {
              t.set("width", this.width * e).set("height", this.height * e);
            });
          }
          ceil() {
            return this.withMutations(e => {
              e.set("width", Math.ceil(this.width)).set("height", Math.ceil(this.height));
            });
          }
          floor() {
            return this.withMutations(e => {
              e.set("width", Math.floor(this.width)).set("height", Math.floor(this.height));
            });
          }
          swapDimensions() {
            return this.withMutations(e => {
              e.set("width", this.height).set("height", this.width);
            });
          }
          apply(e) {
            const [t, n] = e.applyToVector([this.width, this.height]);
            return this.withMutations(e => {
              e.set("width", Math.abs(t)).set("height", Math.abs(n));
            });
          }
        }
      },
      44077: (e, t, n) => {
        "use strict";

        n.d(t, {
          Wm: () => i.Z,
          eB: () => f,
          E9: () => o.Z,
          UL: () => a.Z,
          $u: () => s.Z,
          sl: () => p
        });
        var r,
          o = n(13205),
          i = n(51065),
          a = n(36691),
          s = n(90569),
          l = n(96156),
          u = n(15359),
          c = n(9933);
        class d extends c.D {
          translate(e) {
            let {
              x: t,
              y: n
            } = e;
            return this.transform(1, 0, 0, 1, t, n);
          }
          translateX(e) {
            return this.translate({
              x: e,
              y: 0
            });
          }
          translateY(e) {
            return this.translate({
              x: 0,
              y: e
            });
          }
          scale(e, t) {
            return t || (t = e), this.transform(e, 0, 0, t, 0, 0);
          }
          transform(e, t, n, r, o, i) {
            const {
              a,
              b: s,
              c: l,
              d: u,
              e: c,
              f: d
            } = this;
            return this.withMutations(p => p.set("a", e * a + n * s).set("b", t * a + r * s).set("c", e * l + n * u).set("d", t * l + r * u).set("e", e * c + n * d + o).set("f", t * c + r * d + i));
          }
          rotate(e) {
            (0, u.kG)(e % 90 == 0, "Only multiples of 90° allowed.");
            const t = (360 - e) * Math.PI / 180,
              n = Math.cos(t),
              r = Math.sin(t);
            return this.transform(n, r, -r, n, 0, 0);
          }
          rotateRad(e) {
            const t = Math.cos(e),
              n = Math.sin(e);
            return this.transform(t, n, -n, t, 0, 0);
          }
          inverse() {
            const {
                a: e,
                b: t,
                c: n,
                d: r,
                e: o,
                f: i
              } = this,
              a = e * r - t * n;
            return this.withMutations(s => s.set("a", r / a).set("b", t / -a).set("c", n / -a).set("d", e / a).set("e", (n * i - r * o) / a).set("f", (e * i - t * o) / -a));
          }
          toCssValue() {
            const {
              a: e,
              b: t,
              c: n,
              d: r,
              e: o,
              f: i
            } = this;
            return `matrix(${e.toFixed(2)}, ${t.toFixed(2)}, ${n.toFixed(2)}, ${r.toFixed(2)}, ${o.toFixed(2)}, ${i.toFixed(2)})`;
          }
          applyToPoint(e) {
            let [t, n] = e;
            const {
              a: r,
              b: o,
              c: i,
              d: a,
              e: s,
              f: l
            } = this;
            return [r * t + i * n + s, o * t + a * n + l];
          }
          applyToVector(e) {
            let [t, n] = e;
            const {
              a: r,
              b: o,
              c: i,
              d: a
            } = this;
            return [r * t + i * n, o * t + a * n];
          }
        }
        r = d, (0, l.Z)(d, "defaultValues", {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: 0,
          f: 0
        }), (0, l.Z)(d, "IDENTITY", new r()), (0, c.V)(d);
        const p = d;
        var h = n(35369);
        class f extends (0, h.WV)({
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }) {
          static applyToRect(e, t) {
            if (!(e instanceof f)) throw new u.p2("`inset` must be an instance of `PSPDFKit.Geometry.Inset`");
            if (!(t instanceof a.Z)) throw new u.p2("`rect` must be an instance of `PSPDFKit.Geometry.Rect`");
            return new a.Z({
              top: t.top + e.top,
              left: t.left + e.left,
              width: t.width - (e.left + e.right),
              height: t.height - (e.top + e.bottom)
            });
          }
          static fromRect(e) {
            return new f({
              left: e.left,
              top: e.top,
              right: e.left + e.width,
              bottom: e.top + e.height
            });
          }
          static fromValue(e) {
            if ("number" != typeof e) throw new u.p2("The provided value must be a number");
            return new f({
              top: e,
              left: e,
              right: e,
              bottom: e
            });
          }
          apply(e) {
            const t = e.applyToPoint([this.left, this.top]),
              n = e.applyToPoint([this.left, this.bottom]),
              r = e.applyToPoint([this.right, this.top]),
              o = e.applyToPoint([this.right, this.bottom]),
              i = Math.min(t[0], n[0], r[0], o[0]),
              a = Math.max(t[0], n[0], r[0], o[0]),
              s = Math.min(t[1], n[1], r[1], o[1]),
              l = Math.max(t[1], n[1], r[1], o[1]);
            return new f({
              left: i,
              right: a,
              top: s,
              bottom: l
            });
          }
          setScale(e) {
            return new f({
              left: this.left * e,
              right: this.right * e,
              top: this.top * e,
              bottom: this.bottom * e
            });
          }
        }
      },
      45249: (e, t, n) => {
        "use strict";

        n.d(t, {
          q6: () => i.q6,
          Pg: () => l,
          rp: () => u.Z,
          R0: () => a.R0,
          UW: () => h,
          rF: () => a.rF,
          Dz: () => a.Dz,
          uh: () => y.Z,
          Il: () => f.Z,
          fB: () => a.fB,
          sv: () => O.ZP,
          Jn: () => i.Jn,
          Bd: () => N,
          em: () => m.Z,
          b0: () => w,
          dc: () => x,
          ZS: () => q,
          S: () => _.Z,
          Wm: () => o.Wm,
          Xs: () => i.Xs,
          Wi: () => a.Wi,
          KD: () => a.KD,
          mv: () => g.Z,
          Di: () => r.Di,
          FV: () => i.FV,
          sK: () => i.sK,
          Zc: () => i.Zc,
          eB: () => o.eB,
          bp: () => r.bp,
          o9: () => i.o9,
          R1: () => i.R1,
          Vi: () => a.Vi,
          Hu: () => i.Hu,
          Qi: () => i.Qi,
          sT: () => k.Z,
          T3: () => v.Z,
          E9: () => o.E9,
          Hi: () => i.Hi,
          om: () => i.om,
          XQ: () => a.XQ,
          UL: () => o.UL,
          b3: () => i.b3,
          UX: () => i.UX,
          Yo: () => a.Yo,
          dp: () => P.Z,
          $u: () => o.$u,
          hL: () => i.hL,
          GI: () => i.GI,
          ZM: () => b.Z,
          R9: () => i.R9,
          gd: () => i.gd,
          $o: () => a.$o,
          bi: () => D.Z,
          On: () => i.On,
          SV: () => S,
          Bs: () => E,
          lm: () => r.lm,
          xu: () => i.xu,
          Ih: () => i.Ih,
          f7: () => T.Z,
          gx: () => z.Z,
          Vk: () => A.Z,
          x_: () => i.x_
        });
        var r = n(96706),
          o = n(44077),
          i = n(4715),
          a = n(1858),
          s = n(35369);
        class l extends (0, s.WV)({
          data: null
        }) {}
        var u = n(99745),
          c = n(96156),
          d = n(9933);
        class p extends d.D {}
        (0, c.Z)(p, "defaultValues", {
          start: null,
          knee: null,
          end: null,
          cap: null,
          innerRectInset: null
        }), (0, d.V)(p);
        const h = p;
        var f = n(60379),
          m = (n(16602), n(25822)),
          g = (n(56874), n(9470), n(29435)),
          v = (n(33622), n(8271)),
          y = (n(36828), n(49616)),
          b = (n(78025), n(39934));
        class w extends (0, s.WV)({
          id: null,
          pageIndex: null,
          textLines: (0, s.aV)(),
          contentElements: (0, s.aV)(),
          contentBlocks: (0, s.aV)(),
          contentTreeElementMetadata: null,
          allowsBlockTypeChildren: !0,
          boundingBox: null
        }) {}
        class x extends (0, s.WV)({
          id: null,
          pageIndex: null,
          boundingBox: new o.UL(),
          elementType: null
        }) {}
        var D = n(34390),
          C = n(15359);
        class S extends (0, s.WV)({
          startNode: null,
          startOffset: null,
          endNode: null,
          endOffset: null
        }) {
          startAndEndIds() {
            const e = this.startNode.parentNode,
              t = this.endNode.parentNode;
            if (!e || !t) return null;
            const n = parseInt(e.dataset.textlineId),
              r = parseInt(t.dataset.textlineId),
              o = e.dataset.contentblockId,
              i = t.dataset.contentblockId,
              a = parseInt(e.dataset.pageIndex),
              s = parseInt(t.dataset.pageIndex);
            return (0, C.kG)("number" == typeof n, "selection startId is not a number"), (0, C.kG)("number" == typeof r, "selection endId is not a number"), (0, C.kG)("string" == typeof o, "selection startBlockId is not a string"), (0, C.kG)("string" == typeof i, "selection endBlockId is not a string"), (0, C.kG)("number" == typeof a, "selection start pageIndex is not a number"), (0, C.kG)("number" == typeof s, "selection end pageIndex is not a number"), {
              startTextLineId: n,
              endTextLineId: r,
              startNestedContentBlockId: o,
              endNestedContentBlockId: i,
              startPageIndex: a,
              endPageIndex: s
            };
          }
        }
        class E extends (0, s.WV)({
          textRange: null,
          startTextLineId: null,
          endTextLineId: null,
          startNestedContentBlockId: null,
          endNestedContentBlockId: null,
          startPageIndex: null,
          endPageIndex: null
        }) {}
        var _ = n(92370),
          P = n(78191),
          k = n(10734),
          A = n(34723),
          z = n(80233),
          T = n(90093),
          O = n(56207),
          I = n(79724),
          F = n(30874);
        function M(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function R(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? M(Object(n), !0).forEach(function (t) {
              (0, c.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const j = (0, I.Z)("ComparisonOperation"),
          B = {
            type: F.b.TEXT,
            options: {
              numberOfContextWords: 0
            }
          };
        class N extends (0, s.WV)(B) {
          constructor(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            j(void 0 === t.numberOfContextWords || "number" == typeof t.numberOfContextWords, "numberOfContextWords must be a number."), super({
              type: e,
              options: R(R({}, B.options), t)
            });
          }
        }
        function L(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        const V = (0, I.Z)("DocumentDescriptor"),
          K = {
            filePath: void 0,
            password: void 0,
            pageIndexes: [],
            jwt: void 0
          };
        class q extends (0, s.WV)(K) {
          constructor(e) {
            !function (e) {
              let {
                filePath: t,
                pageIndexes: n,
                password: r,
                jwt: o
              } = e;
              t && V("string" == typeof t || t instanceof ArrayBuffer, "filePath must be a string or ArrayBuffer.");
              null != o && V("string" == typeof o && o.length > 0, "jwt must be a non-empty string.");
              null != r && V("string" == typeof r && r.length > 0, "password must be a non-empty string.");
              V(n.length > 0, "pageIndexes must be a non-empty array."), V(n.every(e => "number" == typeof e || Array.isArray(e) && 2 === e.length && e.every(e => "number" == typeof e)), "pageIndexes must be an array of numbers or arrays of two numbers.");
            }(e), super(function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? L(Object(n), !0).forEach(function (t) {
                  (0, c.Z)(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : L(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({}, e));
          }
        }
      },
      58163: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(35369),
          o = n(94327),
          i = n(1385);
        class a extends (0, r.WV)({
          unitFrom: o.s.INCHES,
          unitTo: i.K.INCHES,
          fromValue: 1,
          toValue: 1
        }) {}
      },
      68804: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          pageIndex: null,
          previewText: "",
          locationInPreview: null,
          lengthInPreview: null,
          rectsOnPage: (0, r.aV)(),
          isAnnotation: null,
          annotationRect: null
        }) {}
      },
      13422: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(35369);
        class o extends (0, r.WV)({
          isFocused: !1,
          isLoading: !1,
          term: "",
          focusedResultIndex: -1,
          results: (0, r.aV)(),
          minSearchQueryLength: 1
        }) {}
      },
      8210: (e, t, n) => {
        "use strict";

        n.d(t, {
          a: () => a
        });
        var r = n(82716),
          o = n(27122);
        const i = {
          Sidebar: Object.values(o.f)
        };
        function a(e) {
          for (const t in e) if (e.hasOwnProperty(t)) {
            (0, r.k)(void 0 !== typeof i[t], `'${t}' is not a customizable UI element. Customizable UI elements are: ${Object.keys(i).join(", ")}`);
            const n = i[t];
            (0, r.k)(Object.keys(e[t]).every(e => n.includes(e)), `The provided custom UI configuration contains one or more invalid keys for "${t}". Valid "${t}" keys are: ${n.join(",")}`), (0, r.k)(Object.values(e[t]).every(e => "function" == typeof e), "The custom UI values provided must be callback functions.");
          }
          return e;
        }
      },
      86037: (e, t, n) => {
        "use strict";

        n.d(t, {
          C: () => l,
          Z: () => u
        });
        var r = n(15359),
          o = n(66327),
          i = n(56554),
          a = n(44550),
          s = n(67009);
        const l = "The API you're trying to use requires a digital signatures license. Digital Signatures is a component of PSPDFKit for Web and sold separately.";
        function u(e, t) {
          t.getSignaturesInfo = function () {
            const {
              features: t,
              backend: n
            } = e.getState();
            return (0, r.kG)(t.includes(a.q.DIGITAL_SIGNATURES), l), (0, r.kG)(n), n.getSignaturesInfo().then(t => (e.dispatch((0, i.Y)(t)), t));
          }, t.signDocument = function (t, n) {
            const {
              features: u,
              backend: c
            } = e.getState();
            var d;
            ((0, r.kG)(u.includes(a.q.DIGITAL_SIGNATURES), l), t && (0, s.w2)(t, c), "STANDALONE" === (null == c ? void 0 : c.type)) ? null != t && t.signingData ? (0, r.kG)(void 0 === n || void 0 === (null == t || null === (d = t.signingData) || void 0 === d ? void 0 : d.privateKey), "On a Standalone deployment, when `signaturePreparationData.signingData.privateKey` is set, `twoStepSignatureCallbackOrSigningServiceData` should not be provided.") : (0, r.kG)("function" == typeof n, "On a Standalone deployment, when `signaturePreparationData.signingData` is not provided or does not include a `privateKey`, `twoStepSignatureCallbackOrSigningServiceData` must be a function.") : "SERVER" === (null == c ? void 0 : c.type) && (0, r.kG)(!n || "object" == typeof n, "On a Server deployment, `twoStepSignatureCallbackOrSigningServiceData` must be a `PSPDFKit.SigningServiceData` object if specified.");
            return e.dispatch((0, o.d9)()), new Promise((r, a) => {
              e.dispatch((0, i.e)(t, n, () => {
                e.dispatch((0, o.t6)()), r();
              }, t => {
                e.dispatch((0, o.t6)()), a(t);
              }));
            });
          }, t.setSignaturesLTV = async function (t) {
            const {
              features: n,
              backend: o
            } = e.getState();
            (0, r.kG)(n.includes(a.q.DIGITAL_SIGNATURES), l), (0, r.kG)(!t || Array.isArray(t) && t.every(e => Boolean(e instanceof ArrayBuffer && e.byteLength > 0 || "string" == typeof e && e.length > 0)), "`certificates` must be an array of strings or ArrayBuffers."), (0, r.kG)(o);
            const s = await o.setSignaturesLTV(t);
            return e.dispatch((0, i.Y)(s)), s;
          };
        }
      },
      75287: (e, t, n) => {
        "use strict";

        n.d(t, {
          Qr: () => c,
          ZP: () => d,
          oQ: () => u
        });
        var r = n(96156),
          o = n(15359),
          i = n(66327),
          a = n(44550);
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const u = "The API you're trying to use requires a license that includes the Document Assistant component. This is a separate component and thus sold separately.",
          c = "Document Assistant configuration object is required before this feature can be used.";
        function d(e, t) {
          t.setDocumentAssistantChatSessionId = function (t) {
            const {
              features: n,
              documentAssistant: {
                configuration: r
              }
            } = e.getState();
            (0, o.kG)(t && "string" == typeof t, "chatSessionId is required and must be a string."), (0, o.kG)(n.includes(a.q.DOCUMENT_ASSISTANT), u), (0, o.kG)(r, c), e.dispatch((0, i.O4)(l(l({}, r), {}, {
              chatSessionId: t
            })));
          };
        }
      },
      4480: (e, t, n) => {
        "use strict";

        n.d(t, {
          I: () => l,
          Z: () => c
        });
        var r = n(15359);
        function o(e) {
          return (0, r.kG)(Array.isArray(e) && e.length > 0, "Operations must be a non-empty array of operations."), e.forEach(e => {
            (0, r.kG)(e.hasOwnProperty("type"), "Invalid operation: no `type` field");
          }), e;
        }
        var i = n(70982),
          a = n(11765),
          s = n(44550);
        const l = "The API you're trying to use requires a document editing license. Document editing is a component of PSPDFKit for Web and sold separately.",
          u = ["document.change"];
        function c(e, t) {
          e.getState().eventEmitter.events.push(...u), t.applyOperations = function (t) {
            const {
              features: n
            } = e.getState();
            return (0, r.kG)(n.includes(s.q.DOCUMENT_EDITING), l), o(t), new Promise((n, r) => {
              e.dispatch((0, i.b_)(t, n, r));
            });
          }, t.exportPDFWithOperations = async function (t) {
            const {
              features: n,
              backend: i
            } = e.getState();
            return (0, r.kG)(n.includes(s.q.DOCUMENT_EDITING), l), o(t), (0, r.kG)(i), i.exportPDFWithOperations(t.map(a.kg));
          };
        }
      },
      41172: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => m,
          q: () => f
        });
        var r = n(96156),
          o = n(15359),
          i = n(67366),
          a = n(31647),
          s = n(66327),
          l = n(4087),
          u = n(96650),
          c = n(44550),
          d = n(24382);
        function p(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function h(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? p(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const f = "The API you're trying to use requires a redactions license. Redactions is a component of PSPDFKit for Web and sold separately.";
        function m(e, t) {
          t.createRedactionsBySearch = async function (t, n) {
            const r = e.getState(),
              {
                features: a,
                backend: s,
                annotationPresets: p,
                eventEmitter: m
              } = r;
            if (!a.includes(c.q.REDACTIONS)) throw new o.p2(f);
            (0, o.kG)(t, "You need to pass a search query.");
            const g = p.get("redaction"),
              v = h(h(h({}, {
                searchType: u.S.TEXT,
                searchInAnnotations: !0,
                caseSensitive: !n || n.searchType !== u.S.TEXT
              }), n), {}, {
                annotationPreset: h(h({}, g), n && n.annotationPreset)
              });
            (0, o.kG)(s);
            const y = await s.searchAndRedact(t, v, r);
            if (y.size) if ("STANDALONE" === s.type) (0, i.dC)(() => {
              y.forEach(t => {
                e.dispatch((0, l.$d)(t));
              });
            });else if ("SERVER" === s.type && !s.isUsingInstantProvider()) {
              var b;
              const {
                  alreadyLoadedPages: e
                } = s.provider.state,
                t = y.filter(t => e.has(t.pageIndex));
              null === (b = r.annotationManager) || void 0 === b || b.backendObjectsCreated(y, d.z), m.emit("annotations.create", t);
            }
            return y.map(e => e.id);
          }, t.applyRedactions = function () {
            const {
              features: t
            } = e.getState();
            if (!t.includes(c.q.REDACTIONS)) throw new o.p2(f);
            return e.dispatch((0, s.fq)()), new Promise((t, n) => (e.dispatch((0, a.g)(() => {
              e.dispatch((0, s.Di)()), t();
            }, t => {
              e.dispatch((0, s.Di)()), n(t);
            })), t));
          };
        }
      },
      1990: (e, t, n) => {
        "use strict";

        n.d(t, {
          H: () => s,
          Z: () => u
        });
        var r = n(35369),
          o = n(15359),
          i = n(11192),
          a = n(97238);
        class s extends (0, r.WV)({
          startTextLineId: null,
          endTextLineId: null,
          startPageIndex: null,
          endPageIndex: null,
          startNestedContentBlockId: null,
          endNestedContentBlockId: null,
          startNode: null,
          startOffset: null,
          endNode: null,
          endOffset: null,
          getText: null,
          getSelectedTextLines: null,
          getBoundingClientRect: null,
          getSelectedRectsPerPage: null
        }) {}
        const l = ["textSelection.change"];
        function u(e, t) {
          t.getTextSelection = function () {
            var t, n, r, l;
            const u = e.getState(),
              c = u.currentTextSelection;
            return c ? new s({
              startTextLineId: c.startTextLineId,
              endTextLineId: c.endTextLineId,
              startNestedContentBlockId: c.startNestedContentBlockId,
              endNestedContentBlockId: c.endNestedContentBlockId,
              startPageIndex: c.startPageIndex,
              endPageIndex: c.endPageIndex,
              startNode: null === (t = c.textRange) || void 0 === t ? void 0 : t.startNode,
              startOffset: null === (n = c.textRange) || void 0 === n ? void 0 : n.startOffset,
              endNode: null === (r = c.textRange) || void 0 === r ? void 0 : r.endNode,
              endOffset: null === (l = c.textRange) || void 0 === l ? void 0 : l.endOffset,
              getText: async () => (0, i.Q)(u, c),
              getSelectedTextLines: async () => ((0, o.kG)(c.textRange), (0, i.ZJ)(u, c.textRange).valueSeq().toList().flatten(!0)),
              getBoundingClientRect: async () => ((0, o.kG)(c.textRange), (0, i.U2)(u, c.textRange)),
              getSelectedRectsPerPage: async () => (0, a.rf)(u)
            }) : null;
          };
          let n = e.getState();
          const {
            eventEmitter: r
          } = n;
          return r.events.push(...l), e.subscribe(() => {
            const o = e.getState();
            n.currentTextSelection !== o.currentTextSelection && r.emit("textSelection.change", t.getTextSelection()), n = o;
          });
        }
      },
      38705: (e, t, n) => {
        "use strict";

        n.d(t, {
          F3: () => L,
          ZP: () => B,
          eV: () => N
        });
        var r = n(67366),
          o = n(15359),
          i = n(38252),
          a = n(10983),
          s = n(27122),
          l = n(65369),
          u = n(13349),
          c = n(81777),
          d = n(4480),
          p = n(35727),
          h = n(86037),
          f = n(12705),
          m = n(5130),
          g = n(18287),
          v = n(2464),
          y = n(82197),
          b = n(14286),
          w = n(48625),
          x = n(89637),
          D = n(84293),
          C = n(45249),
          S = n(2927),
          E = n(66327),
          _ = n(40084),
          P = n(38478),
          k = n(24987),
          A = n(43069),
          z = n(77897),
          T = n(28233),
          O = n(44550),
          I = n(87996),
          F = n(35998),
          M = n(75287);
        const R = ["viewState.change", "viewState.currentPageIndex.change", "viewState.zoom.change"],
          j = ["cropArea.changeStart", "cropArea.changeStop"];
        function B(e, t) {
          const {
            eventEmitter: n
          } = e.getState();
          let l = !0,
            u = b();
          function g() {
            if (!l) return;
            const e = b(),
              t = u;
            u = e;
            const r = t.delete("instance"),
              o = e.delete("instance");
            r.equals(o) || (t.currentPageIndex !== e.currentPageIndex && n.emit("viewState.currentPageIndex.change", e.currentPageIndex), t.zoom !== e.zoom && n.emit("viewState.zoom.change", e.zoom), n.emit("viewState.change", e, t));
          }
          n.events.push(...R), n.events.push(...j);
          const v = e.subscribe(g);
          function b() {
            const n = e.getState();
            return (0, P.w)(n, t);
          }
          return Object.defineProperty(t, "viewState", {
            enumerable: !0,
            configurable: !1,
            get: b
          }), t.setViewState = function (t) {
            let n = t;
            if ("function" == typeof n && (n = n.call(null, b())), !(n instanceof C.f7)) {
              const e = "function" == typeof n ? "return value of your update function" : "supplied argument";
              throw new o.p2(`The ${e} is not an instance of PSPDFKit.ViewState.`);
            }
            l = !1, n = L(n, e), function (e, t, n) {
              t.zoom !== n.zoom && (n.zoom === c.c.AUTO ? e.dispatch((0, _._R)()) : n.zoom === c.c.FIT_TO_VIEWPORT ? e.dispatch((0, _.lO)()) : n.zoom === c.c.FIT_TO_WIDTH ? e.dispatch((0, _.du)()) : "number" == typeof n.zoom && e.dispatch((0, _.Ic)(n.zoom)));
              if (t.pagesRotation !== n.pagesRotation) {
                const r = (0, y.n5)(n.pagesRotation - t.pagesRotation);
                e.dispatch((0, _.U1)(r));
              }
              t.layoutMode !== n.layoutMode && e.dispatch((0, E.YA)(n.layoutMode));
              t.scrollMode !== n.scrollMode && e.dispatch((0, E._U)(n.scrollMode));
              t.showToolbar !== n.showToolbar && (t.showToolbar ? e.dispatch((0, E.iu)()) : e.dispatch((0, E.bv)()));
              t.enableAnnotationToolbar !== n.enableAnnotationToolbar && (t.enableAnnotationToolbar ? e.dispatch((0, E.Wv)()) : e.dispatch((0, E.m$)()));
              t.allowPrinting !== n.allowPrinting && (n.allowPrinting ? e.dispatch((0, E.Ol)()) : e.dispatch((0, E.m0)()));
              t.allowExport !== n.allowExport && (n.allowExport ? e.dispatch((0, E.Rx)()) : e.dispatch((0, E.YI)()));
              t.zoomStep !== n.zoomStep && (!n.zoomStep || n.zoomStep < 1 ? ((0, o.ZK)(`The zoomStep value must be greater than 1. The value you provided was ${n.zoomStep}.The zoomStep value will be set to default ${a.V4}`), e.dispatch((0, E.Ql)(a.V4))) : e.dispatch((0, E.Ql)(n.zoomStep)));
              t.disablePointSnapping !== n.disablePointSnapping && "boolean" == typeof n.disablePointSnapping && e.dispatch((0, E.c8)(n.disablePointSnapping));
              const l = e.getState();
              t.showSignatureValidationStatus !== n.showSignatureValidationStatus && ((0, o.kG)(l.features.includes(O.q.DIGITAL_SIGNATURES), h.C), e.dispatch((0, E.A7)(n.showSignatureValidationStatus)));
              (!0 === n.formDesignMode || (0, A.fF)(n.interactionMode)) && ((0, o.kG)(l.features.includes(O.q.FORM_DESIGNER), m.RB), (0, o.kG)(l.backend && (0, f.k_)(l.backend), m.Bl));
              !0 === n.previewRedactionMode && (0, o.kG)(l.features.includes(O.q.REDACTIONS), "The API you're trying to use requires a redactions license. Redactions is a component of PSPDFKit for Web and sold separately.");
              n.interactionMode === w.A.DOCUMENT_EDITOR && (0, o.kG)(l.features.includes(O.q.DOCUMENT_EDITING), d.I);
              n.interactionMode === w.A.CONTENT_EDITOR && (0, o.kG)(l.features.includes(O.q.CONTENT_EDITING), F.Aq);
              t.formDesignMode !== n.formDesignMode && e.dispatch((0, E.LE)(n.formDesignMode));
              if (t.interactionMode !== n.interactionMode) {
                if (null != n.interactionMode) {
                  const o = N(n.interactionMode, l),
                    i = t.interactionMode ? N(t.interactionMode, l) : null;
                  (n.interactionMode === w.A.DOCUMENT_EDITOR && (0, f.Xr)({
                    features: l.features,
                    backendPermissions: l.backendPermissions,
                    documentPermissions: l.documentPermissions,
                    readOnlyEnabled: l.readOnlyEnabled
                  }) || n.interactionMode === w.A.CONTENT_EDITOR && (0, f.qs)({
                    features: l.features,
                    backendPermissions: l.backendPermissions,
                    documentPermissions: l.documentPermissions,
                    readOnlyEnabled: l.readOnlyEnabled
                  }) || !n.readOnly || o.allowWhenInReadOnlyMode) && (0, r.dC)(() => {
                    i && e.dispatch(i.onLeaveAction()), e.dispatch(o.onEnterAction());
                  });
                } else if (null != t.interactionMode) {
                  const n = N(t.interactionMode, l);
                  e.dispatch((0, x.fz)()), e.dispatch(n.onLeaveAction());
                }
                n.interactionMode === w.A.INK_SIGNATURE && (0, i.a1)("PSPDFKit.InteractionMode.INK_SIGNATURE was deprecated and will be removed in future version. Please use PSPDFKit.InteractionMode.SIGNATURE instead.");
              }
              t.readOnly !== n.readOnly && (n.readOnly ? e.dispatch((0, E.oX)(T.J.VIA_VIEW_STATE)) : e.dispatch((0, E.ek)()));
              t.showAnnotations !== n.showAnnotations && (n.showAnnotations ? e.dispatch((0, E.cI)()) : e.dispatch((0, E.Tu)()));
              t.showComments !== n.showComments && ((0, o.kG)(l.features.includes(O.q.COMMENTS), p.kx), n.showComments ? e.dispatch((0, E.Q8)()) : e.dispatch((0, E.u0)()));
              t.showAnnotationNotes !== n.showAnnotationNotes && (n.showAnnotationNotes ? e.dispatch((0, E.T)()) : e.dispatch((0, E.SE)()));
              const u = {
                [s.f.ANNOTATIONS]: E.ze,
                [s.f.BOOKMARKS]: E.Hf,
                [s.f.DOCUMENT_OUTLINE]: E.EJ,
                [s.f.THUMBNAILS]: E.el,
                [s.f.SIGNATURES]: E.LH,
                [s.f.LAYERS]: E.Fs,
                [s.f.CUSTOM]: E.rd
              };
              t.sidebarMode !== n.sidebarMode && (null === n.sidebarMode ? e.dispatch((0, E.mu)()) : e.dispatch(u[n.sidebarMode]()));
              t.sidebarPlacement !== n.sidebarPlacement && e.dispatch((0, E.Ox)(n.sidebarPlacement));
              t.sidebarOptions !== n.sidebarOptions && e.dispatch((0, E.vI)(n.sidebarOptions));
              t.spreadSpacing !== n.spreadSpacing && e.dispatch((0, E.JN)(n.spreadSpacing));
              t.pageSpacing !== n.pageSpacing && e.dispatch((0, E.vY)(n.pageSpacing));
              t.keepFirstSpreadAsSinglePage !== n.keepFirstSpreadAsSinglePage && e.dispatch((0, E.EY)(n.keepFirstSpreadAsSinglePage));
              if (t.viewportPadding.horizontal !== n.viewportPadding.horizontal || t.viewportPadding.vertical !== n.viewportPadding.vertical) {
                const t = new C.E9({
                  x: n.viewportPadding.horizontal,
                  y: n.viewportPadding.vertical
                });
                e.dispatch((0, E._P)(t));
              }
              t.currentPageIndex !== n.currentPageIndex && e.dispatch((0, _.YA)(n.currentPageIndex));
              t.previewRedactionMode !== n.previewRedactionMode && e.dispatch((0, E.P_)(n.previewRedactionMode));
              n.canScrollWhileDrawing && !t.canScrollWhileDrawing && e.dispatch((0, E.xW)());
              !n.canScrollWhileDrawing && t.canScrollWhileDrawing && e.dispatch((0, E.Ft)());
              n.keepSelectedTool && e.dispatch((0, E.HT)());
              !n.keepSelectedTool && t.keepSelectedTool && e.dispatch((0, E.Xv)());
              if (t.sidebarWidth !== n.sidebarWidth) {
                const t = e.getState(),
                  {
                    containerRect: o
                  } = t,
                  i = {
                    width: n.sidebarWidth,
                    height: o.height
                  };
                (0, r.dC)(() => {
                  e.dispatch((0, _.Pt)(n.sidebarWidth)), e.dispatch((0, _.dx)((0, k.p)(t, i, n.sidebarWidth), !1));
                }), t.viewportState.viewportRect.set("height", i.height);
              }
              t.enableAlwaysScrollToZoom !== n.enableAlwaysScrollToZoom && "boolean" == typeof n.enableAlwaysScrollToZoom && e.dispatch((0, E.T1)(n.enableAlwaysScrollToZoom));
              t.forceRenderWidgetsInAnnotationsOrder !== n.forceRenderWidgetsInAnnotationsOrder && "boolean" == typeof n.forceRenderWidgetsInAnnotationsOrder && e.dispatch((0, E.he)(n.forceRenderWidgetsInAnnotationsOrder));
              t.prerenderedPageSpreads !== n.prerenderedPageSpreads && ("number" != typeof n.prerenderedPageSpreads && null !== n.prerenderedPageSpreads || e.dispatch((0, E.I)(n.prerenderedPageSpreads)));
              !0 === n.showDocumentAssistant && ((0, o.kG)(l.features.includes(O.q.DOCUMENT_ASSISTANT), M.oQ), (0, o.kG)(l.documentAssistant.configuration, M.Qr));
              t.showDocumentAssistant !== n.showDocumentAssistant && e.dispatch((0, E.Z_)(n.showDocumentAssistant));
            }(e, b(), n), l = !0, g();
          }, v;
        }
        function N(e, t) {
          return {
            [w.A.TEXT_HIGHLIGHTER]: {
              onEnterAction: E.d5,
              onLeaveAction: E.lC,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.INK]: {
              onEnterAction: E.P4,
              onLeaveAction: E.s3,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.INK_ERASER]: {
              onEnterAction: E.Ug,
              onLeaveAction: E.VU,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.STAMP_PICKER]: {
              onEnterAction: E.C4,
              onLeaveAction: E.pM,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.STAMP_CUSTOM]: {
              onEnterAction: E._z,
              onLeaveAction: E.pM,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.INK_SIGNATURE]: {
              onEnterAction: E.Cc,
              onLeaveAction: E.MV,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SIGNATURE]: {
              onEnterAction: E.Cc,
              onLeaveAction: E.MV,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SHAPE_LINE]: {
              onEnterAction: (0, E.p9)(C.o9, w.A.SHAPE_LINE),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SHAPE_RECTANGLE]: {
              onEnterAction: (0, E.p9)(C.b3, w.A.SHAPE_RECTANGLE),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SHAPE_ELLIPSE]: {
              onEnterAction: (0, E.p9)(C.Xs, w.A.SHAPE_ELLIPSE),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SHAPE_POLYGON]: {
              onEnterAction: (0, E.p9)(C.Hi, w.A.SHAPE_POLYGON),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SHAPE_POLYLINE]: {
              onEnterAction: (0, E.p9)(C.om, w.A.SHAPE_POLYLINE),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.NOTE]: {
              onEnterAction: E.i9,
              onLeaveAction: E.dp,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.COMMENT_MARKER]: {
              onEnterAction: () => ((0, o.kG)(t && t.features.includes(O.q.COMMENTS), p.kx), (0, E.k6)()),
              onLeaveAction: () => ((0, o.kG)(t && t.features.includes(O.q.COMMENTS), p.kx), (0, E.tr)()),
              allowWhenInReadOnlyMode: !1
            },
            [w.A.TEXT]: {
              onEnterAction: E.DU,
              onLeaveAction: E.k4,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.CALLOUT]: {
              onEnterAction: E.Lt,
              onLeaveAction: E.k4,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.PAN]: {
              onEnterAction: _.vc,
              onLeaveAction: _.Yr,
              allowWhenInReadOnlyMode: !0
            },
            [w.A.SEARCH]: {
              onEnterAction: g.Xe,
              onLeaveAction: g.ct,
              allowWhenInReadOnlyMode: !0
            },
            [w.A.DOCUMENT_EDITOR]: {
              onEnterAction: E.lV,
              onLeaveAction: E.sJ,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.MARQUEE_ZOOM]: {
              onEnterAction: E.xF,
              onLeaveAction: E.si,
              allowWhenInReadOnlyMode: !0
            },
            [w.A.REDACT_TEXT_HIGHLIGHTER]: {
              onEnterAction: E.aw,
              onLeaveAction: E.TR,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.REDACT_SHAPE_RECTANGLE]: {
              onEnterAction: E.t,
              onLeaveAction: E.jP,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.DOCUMENT_CROP]: {
              onEnterAction: E.rL,
              onLeaveAction: E.Cn,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.CONTENT_EDITOR]: {
              onEnterAction: () => S.gY,
              onLeaveAction: () => S.u8,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.FORM_CREATOR]: {
              onEnterAction: z.el,
              onLeaveAction: z.h4,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.SIGNATURE_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.SIGNATURE_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.LIST_BOX_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.LIST_BOX_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.COMBO_BOX_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.COMBO_BOX_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.CHECKBOX_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.CHECKBOX_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.RADIO_BUTTON_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.RADIO_BUTTON_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.TEXT_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.TEXT_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.BUTTON_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.BUTTON_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.DATE_WIDGET]: {
              onEnterAction: () => (0, E.UF)(w.A.DATE_WIDGET),
              onLeaveAction: E.XX,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.LINK]: {
              onEnterAction: E.Jn,
              onLeaveAction: E.UU,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.DISTANCE]: {
              onEnterAction: (0, E.p9)(C.o9, w.A.DISTANCE),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.PERIMETER]: {
              onEnterAction: (0, E.p9)(C.om, w.A.PERIMETER),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.RECTANGLE_AREA]: {
              onEnterAction: (0, E.p9)(C.b3, w.A.RECTANGLE_AREA),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.ELLIPSE_AREA]: {
              onEnterAction: (0, E.p9)(C.Xs, w.A.ELLIPSE_AREA),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.POLYGON_AREA]: {
              onEnterAction: (0, E.p9)(C.Hi, w.A.POLYGON_AREA),
              onLeaveAction: E.Ce,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.MULTI_ANNOTATIONS_SELECTION]: {
              onEnterAction: E.YF,
              onLeaveAction: E.FA,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.MEASUREMENT_SETTINGS]: {
              onEnterAction: E.PR,
              onLeaveAction: E.jJ,
              allowWhenInReadOnlyMode: !1
            },
            [w.A.MEASUREMENT]: {
              onEnterAction: E.BR,
              onLeaveAction: E.hS,
              allowWhenInReadOnlyMode: !1
            }
          }[e];
        }
        function L(e, t) {
          var n, r, i, a, d, p, h, m, g, y, x, S;
          const E = t ? t.getState() : null;
          if ("number" != typeof e.currentPageIndex) throw new o.p2("The currentPageIndex set on the new ViewState is not of type `number`.");
          if (e.disablePointSnapping && "boolean" != typeof e.disablePointSnapping) throw new o.p2("The disablePointSnapping set on the new ViewState is not of type `boolean`.");
          if (E && (e.currentPageIndex < 0 || e.currentPageIndex >= E.totalPages)) throw new o.p2(`The currentPageIndex set on the new ViewState is out of bounds.\nThe index is expected to be in the range from 0 to ${E.totalPages - 1} (inclusive).`);
          if ("number" == typeof e.zoom) {
            if (E) {
              const {
                  viewportState: t
                } = E,
                n = (0, D.Yo)(t),
                r = (0, D.Sm)(t);
              if (e.zoom < n) throw new o.p2(`The supplied zoom level is smaller than the minimum zoom level for this document (${n})`);
              if (e.zoom > r) throw new o.p2(`The supplied zoom level is larger than the maximum zoom level for this document (${r})`);
            }
          } else if (e.zoom !== c.c.AUTO && e.zoom !== c.c.FIT_TO_WIDTH && e.zoom !== c.c.FIT_TO_VIEWPORT) throw new o.p2("The supplied zoom mode is not valid.\nValid zoom modes are: PSPDFKit.ZoomMode.AUTO, PSPDFKit.ZoomMode.FIT_TO_VIEWPORT, or PSPDFKit.ZoomMode.FIT_TO_WIDTH");
          if (e.pagesRotation % 90 != 0) throw new o.p2("The supplied pagesRotation must be a multiple of 90°.");
          if (e.layoutMode !== b.X.SINGLE && e.layoutMode !== b.X.DOUBLE && e.layoutMode !== b.X.AUTO) throw new o.p2("The supplied layout mode is not valid.\nValid layout modes are: PSPDFKit.LayoutMode.SINGLE, PSPDFKit.LayoutMode.DOUBLE, or PSPDFKit.LayoutMode.AUTO");
          if (e.scrollMode !== v.G.CONTINUOUS && e.scrollMode !== v.G.PER_SPREAD && e.scrollMode !== v.G.DISABLED) throw new o.p2("The supplied scroll mode is not valid.\nValid scroll modes are: PSPDFKit.ScrollMode.CONTINUOUS, PSPDFKit.ScrollMode.PER_SPREAD, or PSPDFKit.ScrollMode.DISABLED");
          if (e.showSignatureValidationStatus !== u.W.IF_SIGNED && e.showSignatureValidationStatus !== u.W.HAS_ERRORS && e.showSignatureValidationStatus !== u.W.HAS_WARNINGS && e.showSignatureValidationStatus !== u.W.NEVER) throw new o.p2("The supplied mode for showing the digital signature validation UI is not valid.");
          if ("number" != typeof e.spreadSpacing || e.spreadSpacing < 0) throw new o.p2(`Expected \`spreadSpacing\` to be a positive number but instead got: ${e.spreadSpacing}.`);
          if ("number" != typeof e.pageSpacing || e.pageSpacing < 0) throw new o.p2(`Expected \`pageSpacing\` to be a positive number but instead got: ${e.pageSpacing}.`);
          if ("boolean" != typeof e.keepFirstSpreadAsSinglePage) throw new o.p2(`Expected \`keepFirstSpreadAsSinglePage\` to be a boolean but instead got: ${e.keepFirstSpreadAsSinglePage}.`);
          if ("number" != typeof e.viewportPadding.vertical) throw new o.p2("The supplied viewportPadding has a missing property: vertical not found");
          if ("number" != typeof e.viewportPadding.horizontal) throw new o.p2("The supplied viewportPadding has a missing property: horizontal not found");
          if (e.viewportPadding.vertical < 0 || e.viewportPadding.horizontal < 0) throw new o.p2("The supplied viewportPadding horizontal or vertical value is not a positive number");
          if ("boolean" != typeof e.allowPrinting) throw new o.p2("`allowPrinting` must be of type boolean.");
          if (E && !0 === e.allowPrinting && !E.backendPermissions.downloadingAllowed) throw new o.p2("To enable printing, you need to authenticate the `download` permission in the JWT (See: https://pspdfkit.com/guides/web/server-backed/client-authentication/)");
          if ("boolean" != typeof e.allowExport) throw new o.p2("`allowExport` must be of type boolean.");
          if (E && !0 === e.allowExport && !E.backendPermissions.downloadingAllowed) throw new o.p2("To enable PDF export, you need to authenticate the `download` permission in the JWT (See: https://pspdfkit.com/guides/web/server-backed/client-authentication/)");
          if ("boolean" != typeof e.previewRedactionMode) throw new o.p2("`previewRedactionMode` must be of type boolean.");
          if ("boolean" != typeof e.readOnly) throw new o.p2("`readOnly` must be of type boolean.");
          if (!E || !1 !== e.readOnly || I.Options.IGNORE_DOCUMENT_PERMISSIONS || !E.backendPermissions.readOnly && (E.documentPermissions.annotationsAndForms || E.documentPermissions.fillForms) || (e = e.set("readOnly", !0), (0, o.ZK)("It’s not possible to change PSPDFKit.ViewState#readOnly to false if the current backend or document permissions do not allow it. For document permissions, you can override this behavior by setting the PSPDFKit.Options.IGNORE_DOCUMENT_PERMISSIONS option before initializing PSPDFKit.")), e.interactionMode && Object.values(w.A).indexOf(e.interactionMode) < 0) throw new o.p2(`The supplied interaction mode is not valid.\nValid view modes are: ${Object.keys(w.A).map(e => `PSPDFKit.InteractionMode.${e}`).join(", ")}`);
          if (null != e.interactionMode) {
            const t = N(e.interactionMode, E);
            null != E && (e.interactionMode === w.A.DOCUMENT_EDITOR && (0, f.Xr)({
              features: E.features,
              backendPermissions: E.backendPermissions,
              documentPermissions: E.documentPermissions,
              readOnlyEnabled: E.readOnlyEnabled
            }) || e.interactionMode === w.A.CONTENT_EDITOR && (0, f.qs)({
              features: E.features,
              backendPermissions: E.backendPermissions,
              documentPermissions: E.documentPermissions,
              readOnlyEnabled: E.readOnlyEnabled
            })) || !e.readOnly || t.allowWhenInReadOnlyMode || ((0, o.ZK)(`Can’t set PSPDFKit.ViewState#interactionMode to ${e.interactionMode} when PSPDFKit.ViewState#readOnly is true.`), e = e.set("interactionMode", null));
          }
          if ("boolean" != typeof e.showAnnotations) throw new o.p2("`showAnnotations` must be of type boolean.");
          if (!1 === e.showAnnotations && !1 === e.readOnly) throw new o.p2("In order to hide annotations, you must also enable read only mode.");
          if ("boolean" != typeof e.showComments) throw new o.p2("`showComments` must be of type boolean.");
          if ("boolean" != typeof e.showAnnotationNotes) throw new o.p2("`showAnnotationNotes` must be of type boolean.");
          if (e.sidebarMode && Object.values(s.f).indexOf(e.sidebarMode) < 0) throw new o.p2(`The supplied sidebar mode is not valid.\nValid view modes are: ${Object.keys(s.f).map(e => `PSPDFKit.SidebarMode.${e}`).join(", ")} or \`null\`.`);
          if (Object.values(l.d).indexOf(e.sidebarPlacement) < 0) throw new o.p2(`The supplied sidebar placement is not valid.\nValid placements are: ${Object.keys(l.d).map(e => `PSPDFKit.SidebarPlacement.${e}`).join(" or ")}.`);
          if (!(null !== (n = e.sidebarOptions) && void 0 !== n && n[s.f.ANNOTATIONS] || null !== (r = e.sidebarOptions) && void 0 !== r && r[s.f.LAYERS])) throw new o.p2("The supplied sidebar options configuration is missing the required `PSPDFKit.SidebarMode.ANNOTATIONS` or `PSPDFKit.SidebarMode.LAYERS` property.");
          if (null !== (i = e.sidebarOptions) && void 0 !== i && i[s.f.ANNOTATIONS] && !Array.isArray(null === (a = e.sidebarOptions[s.f.ANNOTATIONS]) || void 0 === a ? void 0 : a.includeContent)) throw new o.p2("The `includeContent` property is mandatory for the `PSPDFKit.SidebarMode.ANNOTATIONS` sidebar options and it must be an array");
          if (null !== (d = e.sidebarOptions) && void 0 !== d && d[s.f.LAYERS] && (null === (p = e.sidebarOptions) || void 0 === p || null === (p = p[s.f.LAYERS]) || void 0 === p || !p.lockedLayers)) throw new o.p2("The `lockedLayers` property is mandatory for the `PSPDFKit.SidebarMode.LAYERS` sidebar options and it must be an array");
          if (null !== (h = e.sidebarOptions) && void 0 !== h && h[s.f.LAYERS] && !Array.isArray(null === (m = e.sidebarOptions[s.f.LAYERS]) || void 0 === m ? void 0 : m.lockedLayers)) throw new o.p2("The `lockedLayers` property is mandatory for the `PSPDFKit.SidebarMode.LAYERS` sidebar options and it must be an array");
          if (null !== (g = e.sidebarOptions) && void 0 !== g && g[s.f.LAYERS] && (null === (y = e.sidebarOptions) || void 0 === y || null === (y = y[s.f.LAYERS]) || void 0 === y || !y.iconsAlignment)) throw new o.p2("The `iconsAlignment` property is mandatory for the `PSPDFKit.SidebarMode.LAYERS` sidebar options and it must be either `PSPDFKit.Alignment.START` or `PSPDFKit.Alignment.END` ");
          if (null !== (x = e.sidebarOptions) && void 0 !== x && x[s.f.ANNOTATIONS] && e.sidebarOptions[s.f.ANNOTATIONS].includeContent.length && e.sidebarOptions[s.f.ANNOTATIONS].includeContent.some(e => !(e.prototype instanceof C.q6) && e !== C.sv)) throw new o.p2("The `includeContent` array can only contain annotations classes or `PSPDFKit.Comment` as possible values");
          if (null !== (S = e.sidebarOptions) && void 0 !== S && S[s.f.LAYERS] && e.sidebarOptions[s.f.LAYERS].lockedLayers.length && e.sidebarOptions[s.f.LAYERS].lockedLayers.some(e => "number" != typeof e)) throw new o.p2("The `lockedLayers` array can only contain numbers as possible values");
          if ("boolean" != typeof e.canScrollWhileDrawing) throw new o.p2("`canScrollWhileDrawing` must be of type boolean.");
          if ("boolean" != typeof e.keepSelectedTool) throw new o.p2("`keepSelectedTool` must be of type boolean.");
          if ("number" != typeof e.sidebarWidth) throw new o.p2("`sidebarWidth` must be of type number.");
          if ("boolean" != typeof e.enableAlwaysScrollToZoom) throw new o.p2("`enableAlwaysScrollToZoom` must be of type boolean.");
          if ("boolean" != typeof e.forceRenderWidgetsInAnnotationsOrder) throw new o.p2("`forceRenderWidgetsInAnnotationsOrder` must be of type boolean.");
          if ("number" != typeof e.prerenderedPageSpreads && null !== e.prerenderedPageSpreads) throw new o.p2("`prerenderedPageSpreads` must be of type number or null.");
          if ("boolean" != typeof e.showDocumentAssistant) throw new o.p2(`Expected \`showDocumentAssistant\` to be a boolean but instead got: ${e.showDocumentAssistant}.`);
          return e;
        }
      },
      17078: (e, t, n) => {
        "use strict";

        n.d(t, {
          O: () => a,
          Z: () => s
        });
        var r = n(44228);
        const o = new (n(45249).ZM)(),
          i = (0, r.oM)({
            name: "attachments",
            initialState: o,
            reducers: {
              createAttachment: (e, t) => {
                const {
                  hash: n,
                  attachment: r
                } = t.payload;
                return e.setIn(["attachments", n], r);
              }
            }
          }),
          {
            createAttachment: a
          } = i.actions,
          s = i.reducer;
      },
      10102: (e, t, n) => {
        "use strict";

        n.d(t, {
          s: () => r
        });
        const r = (0, n(35782).vU)({
          chat: {
            id: "chat",
            defaultMessage: "Chat"
          },
          close: {
            id: "close",
            defaultMessage: "Close"
          },
          goToSelection: {
            id: "goToSelection",
            defaultMessage: "Go to selection"
          }
        });
      },
      4280: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        const r = (0, n(35782).vU)({
          approved: {
            id: "approved",
            defaultMessage: "Approved",
            description: "Approved Stamp Annotation"
          },
          notApproved: {
            id: "notApproved",
            defaultMessage: "Not Approved",
            description: "Not Approved Stamp Annotation"
          },
          draft: {
            id: "draft",
            defaultMessage: "Draft",
            description: "Draft Stamp Annotation"
          },
          final: {
            id: "final",
            defaultMessage: "Final",
            description: "Final Stamp Annotation"
          },
          completed: {
            id: "completed",
            defaultMessage: "Completed",
            description: "Completed Stamp Annotation"
          },
          confidential: {
            id: "confidential",
            defaultMessage: "Confidential",
            description: "Confidential Stamp Annotation"
          },
          forPublicRelease: {
            id: "forPublicRelease",
            defaultMessage: "For Public Release",
            description: "For Public Release Stamp Annotation"
          },
          notForPublicRelease: {
            id: "notForPublicRelease",
            defaultMessage: "Not For Public Release",
            description: "Not For Public Release Stamp Annotation"
          },
          forComment: {
            id: "forComment",
            defaultMessage: "For Comment",
            description: "ForComment Stamp Annotation"
          },
          void: {
            id: "void",
            defaultMessage: "Void",
            description: "Void Stamp Annotation"
          },
          preliminaryResults: {
            id: "preliminaryResults",
            defaultMessage: "Preliminary Results",
            description: "Preliminary Results Stamp Annotation"
          },
          informationOnly: {
            id: "informationOnly",
            defaultMessage: "Information Only",
            description: "Information Only Stamp Annotation"
          },
          rejected: {
            id: "rejected",
            defaultMessage: "Rejected",
            description: "Rejected Stamp Annotation"
          },
          accepted: {
            id: "accepted",
            defaultMessage: "Accepted",
            description: "Accepted Stamp Annotation"
          },
          initialHere: {
            id: "initialHere",
            defaultMessage: "Initial Here",
            description: "Initial Here Stamp Annotation"
          },
          signHere: {
            id: "signHere",
            defaultMessage: "Sign Here",
            description: "Sign Here Stamp Annotation"
          },
          witness: {
            id: "witness",
            defaultMessage: "Witness",
            description: "Witness Stamp Annotation"
          },
          asIs: {
            id: "asIs",
            defaultMessage: "As Is",
            description: "As Is Stamp Annotation"
          },
          departmental: {
            id: "departmental",
            defaultMessage: "Departmental",
            description: "Departmental Stamp Annotation"
          },
          experimental: {
            id: "experimental",
            defaultMessage: "Experimental",
            description: "Experimental Stamp Annotation"
          },
          expired: {
            id: "expired",
            defaultMessage: "Expired",
            description: "Expired Stamp Annotation"
          },
          sold: {
            id: "sold",
            defaultMessage: "Sold",
            description: "Sold Stamp Annotation"
          },
          topSecret: {
            id: "topSecret",
            defaultMessage: "Top Secret",
            description: "TopSecret Stamp Annotation"
          },
          revised: {
            id: "revised",
            defaultMessage: "Revised",
            description: "Revised Stamp Annotation"
          },
          custom: {
            id: "custom",
            defaultMessage: "Custom",
            description: "Custom Stamp Annotation"
          },
          stampAnnotationTemplatesDialog: {
            id: "stampAnnotationTemplatesDialog",
            defaultMessage: "Stamp Annotation Templates",
            description: "Stamp Annotation Templates Dialog"
          },
          stampAnnotationTemplatesDialogDescription: {
            id: "stampAnnotationTemplatesDialogDesc",
            defaultMessage: "This dialog lets you select a stamp annotation to insert into the document or create a custom stamp annotation with your own text.",
            description: "Stamp Annotation Templates Dialog Description"
          }
        });
      },
      33427: (e, t, n) => {
        "use strict";

        n.d(t, {
          A8: () => de,
          AC: () => oe,
          B7: () => we,
          CU: () => fe,
          Dc: () => H,
          Dl: () => _,
          F3: () => q,
          Fp: () => T,
          IO: () => G,
          Ie: () => ke,
          Jy: () => ve,
          Km: () => U,
          OR: () => Se,
          SY: () => P,
          So: () => De,
          TL: () => ie,
          TW: () => J,
          U7: () => ne,
          Vc: () => $,
          WX: () => _e,
          Wj: () => k,
          X5: () => L,
          Xr: () => xe,
          Xu: () => ee,
          YV: () => be,
          _E: () => S,
          _R: () => re,
          _k: () => ye,
          a$: () => Z,
          a5: () => Ee,
          aI: () => Y,
          bz: () => z,
          d: () => I,
          dk: () => ce,
          eD: () => te,
          eJ: () => ge,
          et: () => ze,
          fc: () => B,
          fk: () => A,
          hG: () => K,
          ip: () => j,
          ix: () => Pe,
          lx: () => N,
          oF: () => pe,
          om: () => V,
          pe: () => le,
          sH: () => D,
          tM: () => ue,
          tl: () => he,
          ud: () => C,
          vM: () => Ae,
          vj: () => Q,
          vk: () => F,
          x2: () => O,
          xU: () => W,
          xc: () => M,
          xp: () => R,
          yU: () => X,
          yj: () => Ce,
          z1: () => me
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(34997),
          s = n(45249),
          l = n(94732),
          u = n(4325),
          c = n(10983),
          d = n(87996),
          p = n(44077),
          h = n(17766),
          f = n(60379),
          m = n(48338),
          g = n(89004),
          v = n(74814),
          y = n(48625),
          b = n(5705);
        function w(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function x(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? w(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function D(e) {
          try {
            const t = localStorage.getItem(`persistedColors${e}`);
            if (t) try {
              return JSON.parse(t).map(e => ({
                color: new f.Z({
                  r: e.color.r,
                  g: e.color.g,
                  b: e.color.b
                }),
                localization: e.localization
              }));
            } catch (e) {
              return (0, i.ZK)(`Wrong color data stored in localStorage: ${e.message}`), [];
            }
            return [];
          } catch (e) {
            return [];
          }
        }
        function C(e, t) {
          return (0, i.kG)("number" == typeof t.pageIndex, "Annotation has no valid pageIndex"), (0, i.kG)(!e.annotations.has(t.id), `Annotation ID (${t.id}) is already known`), t.pageIndex < 0 || t.pageIndex >= e.pages.size ? ((0, i.ZK)(`Tried to add an annotation (ID: ${t.id}) with an out of bounds page index. This annotation was skipped.`), e) : (t instanceof s.sK && (0, i.kG)(q(t.imageAttachmentId), "imageAttachmentId is not a valid hash or pdfObjectId"), e.withMutations(e => {
            var n;
            t.id || (t = t.set("id", M())), e.setIn(["annotations", t.id], t), null !== (n = e.isAPStreamRendered) && void 0 !== n && n.call(e, t) && !te(t) && e.updateIn(["invalidAPStreams", t.pageIndex], function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, o.l4)();
              return e.add(t.id);
            }), E(e, t), (0, m._d)(e, t);
          }));
        }
        function S(e, t) {
          (0, i.kG)("string" == typeof t.id, "Annotation has no valid id");
          const n = e.annotations.get(t.id);
          return (0, i.kG)(n instanceof s.q6, `Annotation with id ${t.id} not found and thus the update was ignored.`), e.withMutations(r => {
            var i, a, l;
            null != t.pageIndex && E(r, t), !0 !== t.noView && !0 !== t.hidden || !r.selectedAnnotationIds.has(t.id) || (r.delete("selectedAnnotationMode"), r.set("interactionMode", null), r.update("selectedAnnotationIds", e => e.filterNot(e => e === t.id)), r.update("hoverAnnotationIds", e => e.delete(t.id))), "number" != typeof n.buttonIconUpdatedAt && "number" == typeof t.buttonIconUpdatedAt && null !== (i = r.invalidAPStreams.get(t.pageIndex)) && void 0 !== i && i.has(t.id) && r.updateIn(["invalidAPStreams", t.pageIndex], function () {
              let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, o.l4)();
              return e.delete(t.id);
            }), r.setIn(["annotations", t.id], t);
            const u = e.activeAnnotationNote;
            u && (null === (a = u.parentAnnotation) || void 0 === a ? void 0 : a.id) === t.id && (t.note ? t.note !== u.text.value && r.set("activeAnnotationNote", u.set("text", {
              format: "plain",
              value: t.note
            })) : r.set("activeAnnotationNote", null));
            const c = e.hoverAnnotationNote;
            c && (null === (l = c.parentAnnotation) || void 0 === l ? void 0 : l.id) === t.id && (t.note ? t.note !== c.text.value && r.set("hoverAnnotationNote", c.set("text", {
              format: "plain",
              value: t.note
            })) : r.set("hoverAnnotationNote", null));
            const d = le(() => r, t, () => {
              var e;
              const {
                  formFields: i
                } = r,
                a = t instanceof s.x_ ? i.get(t.formFieldName) : null;
              null !== (e = r.isAPStreamRendered) && void 0 !== e && e.call(r, t) && oe(n, t) && T(n) === T(t) && function (e, t) {
                if (e instanceof s.x_ && t instanceof s.R0) return !1;
                return !0;
              }(t, a) && r.updateIn(["invalidAPStreams", t.pageIndex], function () {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : (0, o.l4)();
                return e.add(t.id);
              });
            });
            (0, m.GW)(r, n, t, d);
          });
        }
        function E(e, t) {
          return e.updateIn(["pages", t.pageIndex, "annotationIds"], e => e.add(t.id));
        }
        function _(e, t) {
          const n = e.annotations.get(t);
          return e.withMutations(r => {
            var o, i, a;
            r.selectedAnnotationIds.has(t) && (r.delete("selectedAnnotationMode"), r.interactionMode !== y.A.FORM_CREATOR && r.set("interactionMode", null)), r.update("annotations", e => e.delete(t)), r.update("selectedAnnotationIds", e => e.filterNot(e => e === t)), r.update("annotationPresetIds", e => e.filterNot(e => e === t)), r.update("hoverAnnotationIds", e => e.delete(t)), null !== r.annotationsIdsToDelete && r.update("annotationsIdsToDelete", e => null == e ? void 0 : e.filterNot(e => e === t));
            const s = e.activeAnnotationNote;
            s && (null === (o = s.parentAnnotation) || void 0 === o ? void 0 : o.id) === t && r.set("activeAnnotationNote", null);
            const l = e.hoverAnnotationNote;
            if (l && (null === (i = l.parentAnnotation) || void 0 === i ? void 0 : i.id) === t && r.set("hoverAnnotationNote", null), null == (null == n ? void 0 : n.pageIndex)) return;
            r.deleteIn(["pages", n.pageIndex, "annotationIds", t]);
            const u = e.invalidAPStreams.get(n.pageIndex),
              c = (!u || !u.has(t)) && (null === (a = e.isAPStreamRendered) || void 0 === a ? void 0 : a.call(e, n));
            (0, m.WF)(r, n, c), "number" == typeof n.pdfObjectId && (r.deleteIn(["APStreamVariantsRollover", n.pdfObjectId]), r.deleteIn(["APStreamVariantsDown", n.pdfObjectId]));
          });
        }
        function P(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1,
            n = arguments.length > 2 ? arguments[2] : void 0;
          const {
            boundingBox: r
          } = e;
          if (Pe(e, t)) return r.set("width", r.width / t).set("height", r.height / t);
          if (e instanceof s.Qi) {
            const e = r.getLocation(),
              t = new p.sl().translate(e.scale(-1)).rotate(n || 0).translate(e);
            return r.apply(t);
          }
          return r;
        }
        function k(e, t, n) {
          let r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 1;
          return (0, u.q)(P(e, r, t), n);
        }
        function A(e, t, n, r, o) {
          var a;
          let l = e instanceof s.q6 && ("points" in e && (null === (a = e.points) || void 0 === a ? void 0 : a.toJS()) || "startPoint" in e && e.startPoint && e.endPoint && [e.startPoint.toJS(), e.endPoint.toJS()]);
          if ($(e)) {
            (0, i.kG)(e instanceof s.gd, "Callout annotation is not a TextAnnotation");
            const {
              callout: t
            } = e;
            (0, i.kG)(t, "Callout annotation has no callout");
            const {
              knee: n,
              start: r
            } = t;
            l = [r, n].map(e => null == e ? void 0 : e.toJS());
          }
          const c = (0, u.K)(r);
          return Array.isArray(l) ? l.map(e => ({
            x: o + c + (e.x - t.left) * n,
            y: o + c + (e.y - t.top) * n
          })) : [];
        }
        function z(e) {
          const t = null != e.pageIndex;
          return e instanceof s.gd ? t && null != e.text.value && "" !== e.text.value : e instanceof s.Hi || e instanceof s.om ? t && null != e.points && e.points.size > 1 : t;
        }
        function T(e) {
          return !1 === e.noView && !0 !== e.hidden;
        }
        function O(e) {
          return !1 === e.noPrint && !0 !== e.hidden;
        }
        function I(e) {
          return !(e instanceof s.Ih);
        }
        function F(e) {
          return e ? e.replace(/[A-Z]/g, "-$&").toLowerCase() : null;
        }
        const M = a.SK;
        function R(e, t) {
          return function (e, t) {
            return t.map(function (t) {
              return e.get(t);
            }).filter(Boolean).toList();
          }(e, t.annotationIds);
        }
        function j(e) {
          return e.boundingBox.setLocation(new s.E9());
        }
        const B = (0, o.D5)([["stroke-color", "strokeColor"], ["background-color", "backgroundColor"], ["color", "color"], ["fill-color", "fillColor"], ["font-color", "fontColor"], ["outline-color", "outlineColor"]]);
        function N(e) {
          var t;
          const n = M(),
            r = function (e) {
              const t = e.currentItemPreset;
              return t && e.annotationPresets.get(t) || {};
            }(e),
            o = x(x({}, r), {}, {
              id: n,
              name: n,
              creatorName: e.annotationCreatorName,
              createdAt: new Date(),
              updatedAt: new Date()
            });
          return e.group !== (null === (t = e.backend) || void 0 === t ? void 0 : t.getDefaultGroup()) && (o.group = e.group), r.group && r.group !== e.group && (o.group = r.group), e.annotationToolbarColorPresets ? B.reduce((t, n, r) => {
            const o = e.annotationToolbarColorPresets({
              propertyName: r,
              defaultAnnotationToolbarColorPresets: d.Options.COLOR_PRESETS
            });
            if (void 0 === o) return t;
            const i = o.presets,
              a = D(B.get(r, r));
            return function (e, t) {
              return e.some(e => !t && null === e.color || t && e.color && e.color.equals(t));
            }([...i, ...a], t[n]) ? t : x(x({}, t), {}, {
              [n]: i[0].color
            });
          }, o) : o;
        }
        function L(e, t) {
          const n = e.annotations.get(t);
          return n ? n instanceof s.o9 ? "line" : n instanceof s.Xs ? "ellipse" : n instanceof s.b3 ? "rectangle" : n instanceof s.om ? "polyline" : n instanceof s.Hi ? "polygon" : n instanceof s.Zc ? "ink" : n instanceof s.Qi ? "note" : n instanceof s.gd ? "text" : n instanceof s.sK ? "image" : n instanceof s.GI ? "stamp" : n instanceof s.x_ ? "widget" : n instanceof s.FV ? "highlight" : n instanceof s.xu ? "underline" : n instanceof s.R9 ? "strikeout" : n instanceof s.hL ? "squiggle" : n instanceof l.Z ? "redaction" : null : null;
        }
        function V(e, t, n, r, o) {
          const {
              width: a,
              height: l
            } = t,
            {
              currentPageIndex: u,
              pagesRotation: d
            } = e.viewportState,
            p = e.pages.get(u);
          (0, i.kG)(p, `Cannot find page at index ${u}`);
          const h = p.pageSize,
            f = Math.min(h.width * c.Bs / a, h.height * c.Bs / l, 1);
          let m = a * f,
            g = l * f;
          return 90 !== d && 270 !== d || ([m, g] = [g, m]), new s.sK(x(x({}, N(e)), {}, {
            pageIndex: u,
            imageAttachmentId: n,
            contentType: r,
            rotation: d,
            fileName: o,
            boundingBox: new s.UL({
              left: h.width / 2 - m / 2,
              top: h.height / 2 - g / 2,
              width: m,
              height: g
            })
          }));
        }
        function K(e, t, n) {
          const {
              width: r,
              height: o
            } = t,
            {
              currentPageIndex: a,
              pagesRotation: l
            } = e.viewportState,
            u = e.pages.get(a);
          (0, i.kG)(u, `Cannot find page at index ${a}`);
          const d = u.pageSize,
            p = Math.min(d.width * c.Bs / r, d.height * c.Bs / o, 1);
          let h = r * p,
            f = o * p;
          return 90 !== l && 270 !== l || ([h, f] = [f, h]), new s.GI(x(x({}, N(e)), {}, {
            pageIndex: a,
            stampType: n.stampType,
            title: n.title,
            subtitle: n.subtitle,
            color: n.color,
            opacity: n.opacity,
            rotation: l,
            boundingBox: new s.UL({
              left: d.width / 2 - h / 2,
              top: d.height / 2 - f / 2,
              width: h,
              height: f
            })
          }));
        }
        function q(e) {
          return RegExp("^([A-Fa-f0-9]{64}|[0-9]+)$").test(e);
        }
        function H(e, t) {
          let n = (0, o.D5)();
          return (Array.isArray(t) ? t : [t]).forEach(t => {
            if (t instanceof s.sK && t.imageAttachmentId) {
              const r = e.get(t.imageAttachmentId);
              r && (n = n.set(t.imageAttachmentId, r));
            }
          }), n;
        }
        function U(e) {
          return e.locked ? !e.locked : e instanceof s.om || e instanceof s.Hi || e instanceof s.o9 || $(e);
        }
        function Z(e) {
          if (e.locked) return !e.locked;
          switch (e.constructor) {
            case s.gd:
              return !$(e);
            case s.GI:
              return !0;
            default:
              return !1;
          }
        }
        function $(e) {
          var t;
          return e instanceof s.gd && !(null === (t = e.callout) || void 0 === t || !t.innerRectInset);
        }
        function G(e) {
          return e.locked ? !e.locked : e instanceof s.om || e instanceof s.Hi || e instanceof s.b3 || e instanceof s.sK || e instanceof s.Zc || e instanceof s.Xs || e instanceof s.GI || e instanceof s.gd && !$(e) || e instanceof s.x_ || e instanceof s.R1;
        }
        function W(e, t) {
          const n = t.onAnnotationResizeStart ? t.onAnnotationResizeStart(e) : void 0;
          if (void 0 !== n) return (0, i.kG)(!0 === n.maintainAspectRatio || !1 === n.maintainAspectRatio || null === n.maintainAspectRatio || void 0 === n.maintainAspectRatio, "onAnnotationResizeStart should return a valid configuration or undefined"), !!n.maintainAspectRatio && n.maintainAspectRatio;
          if (e.isShiftPressed) return !0;
          const r = e.annotation instanceof s.sK || e.annotation instanceof s.GI,
            o = [v.V.TOP_LEFT, v.V.TOP_RIGHT, v.V.BOTTOM_LEFT, v.V.BOTTOM_RIGHT];
          return !!(r && o.includes(e.resizeAnchor) || "isSignature" in e.annotation && e.annotation.isSignature);
        }
        function Y(e, t) {
          const n = t.onAnnotationResizeStart ? t.onAnnotationResizeStart(e) : void 0;
          return n && (n.minHeight && n.minHeight < 0 && ((0, i.ZK)("minimum height in the onAnnotationResizeStart API should be greater than 0"), n.minHeight = void 0), n.maxHeight && n.maxHeight < 0 && ((0, i.ZK)("maximum height in the onAnnotationResizeStart API should be greater than 0"), n.maxHeight = void 0), n.maxWidth && n.maxWidth < 0 && ((0, i.ZK)("maximum width in the onAnnotationResizeStart API should be greater than 0"), n.maxWidth = void 0), n.minWidth && n.minWidth < 0 && ((0, i.ZK)("maximum width in the onAnnotationResizeStart API should be greater than 0"), n.minWidth = void 0), n.maxHeight && n.minHeight && n.maxHeight < n.minHeight && ((0, i.ZK)("maximum Height parameter should be greater than the minimum Height parameter in onAnnotationResizeStart API"), n.maxHeight = void 0, n.minHeight = void 0), n.maxWidth && n.minWidth && n.maxWidth < n.minWidth && ((0, i.ZK)("maximum Width parameter should be greater than the minimum Width parameter in onAnnotationResizeStart API"), n.maxWidth = void 0, n.minWidth = void 0)), {
            maxHeight: null == n ? void 0 : n.maxHeight,
            maxWidth: null == n ? void 0 : n.maxWidth,
            minWidth: null == n ? void 0 : n.minWidth,
            minHeight: null == n ? void 0 : n.minHeight
          };
        }
        function X(e) {
          return e instanceof s.om || e instanceof s.Hi || e instanceof s.o9 || e instanceof s.b3 || e instanceof s.sK || e instanceof s.Zc || e instanceof s.Xs || e instanceof s.GI || e instanceof s.gd || e instanceof s.x_ || e instanceof s.Qi || e instanceof s.Jn || e instanceof s.R1;
        }
        function Q(e) {
          return e instanceof s.om || e instanceof s.Hi || e instanceof s.b3 || e instanceof s.sK || e instanceof s.Zc || e instanceof s.Xs || e instanceof s.GI || e instanceof s.gd || e instanceof s.x_ || e instanceof l.Z || e instanceof s.R1 || e instanceof s.Ih;
        }
        function J(e, t) {
          let n = !1;
          return t.emit("annotations.press", x(x({}, e), {}, {
            preventDefault: () => {
              e.nativeEvent.stopPropagation(), e.nativeEvent.stopImmediatePropagation(), n = !0;
            }
          })), n;
        }
        function ee(e) {
          e.selectedAnnotationIds.forEach(t => {
            e.deleteIn(["annotationPresetIds"], t);
          });
        }
        function te(e) {
          return "number" == typeof e.pdfObjectId;
        }
        function ne(e) {
          return e.width > 0 && e.height > 0;
        }
        function re(e, t) {
          return !(e instanceof s.GI || e instanceof s.Ih || e instanceof s.sK || e instanceof s.x_ && (t instanceof s.Yo || t instanceof s.R0 && "number" == typeof e.buttonIconUpdatedAt));
        }
        function oe(e, t) {
          return !(0, o.is)(j(e), j(t)) || e.opacity !== t.opacity || e.rotation !== t.rotation || T(e) !== T(t) || t instanceof s.sK && e instanceof s.sK && e.imageAttachmentId !== t.imageAttachmentId || t instanceof s.GI && e instanceof s.GI && (!ae(e.color, t.color) || e.stampType !== t.stampType || e.title !== t.title || e.subtitle !== t.subtitle) || !(!(t instanceof s.UX && e instanceof s.UX) || e.strokeWidth === t.strokeWidth && ae(e.strokeColor, t.strokeColor) && ae(e.fillColor, t.fillColor) && (!t.strokeDashArray || e.strokeDashArray && !t.strokeDashArray.some((t, n) => void 0 === e.strokeDashArray[n] || t !== e.strokeDashArray[n]))) || !(!(t instanceof s.UX && e instanceof s.UX && t.isMeasurement()) || e.measurementScale === t.measurementScale && e.measurementPrecision === t.measurementPrecision) || (t instanceof s.b3 || t instanceof s.Xs) && (e instanceof s.b3 || e instanceof s.Xs) && (t.cloudyBorderInset !== e.cloudyBorderInset || t.cloudyBorderIntensity !== e.cloudyBorderIntensity) || !!((t instanceof s.o9 || t instanceof s.om) && (e instanceof s.o9 || e instanceof s.om) && t.lineCaps && (!e.lineCaps || t.lineCaps.start !== e.lineCaps.start || t.lineCaps.end !== e.lineCaps.end) || !t.lineCaps && e.lineCaps) || !!(t instanceof s.o9 && se(e, t)) || !!((t instanceof s.om || t instanceof s.Hi) && (e instanceof s.om || e instanceof s.Hi) && se(e, t)) || t instanceof s.Zc && e instanceof s.Zc && (e.lineWidth !== t.lineWidth || !ae(e.strokeColor, t.strokeColor) || !ae(e.backgroundColor, t.backgroundColor) || e.blendMode !== t.blendMode) || t instanceof s.gd && e instanceof s.gd && (e.text.value !== t.text.value || e.fontSize !== t.fontSize || e.font !== t.font || !ae(e.fontColor, t.fontColor) || !ae(e.backgroundColor, t.backgroundColor) || e.isBold !== t.isBold || e.isItalic !== t.isItalic || e.horizontalAlign !== t.horizontalAlign || e.verticalAlign !== t.verticalAlign || e.borderWidth !== t.borderWidth || e.borderStyle !== t.borderStyle) || t instanceof s.Qi && e instanceof s.Qi && (!ae(t.color, e.color) || e.icon !== t.icon) || t instanceof s.On && e instanceof s.On && (e.blendMode !== t.blendMode || !ae(e.color, t.color) || e.rects !== t.rects) || t instanceof s.x_ && e instanceof s.x_ && t.buttonIconUpdatedAt !== e.buttonIconUpdatedAt;
        }
        function ie(e, t) {
          return (null == e ? void 0 : e.readOnly) !== (null == t ? void 0 : t.readOnly);
        }
        function ae(e, t) {
          return e instanceof f.Z && t instanceof f.Z ? e.equals(t) : !(e instanceof f.Z || t instanceof f.Z);
        }
        function se(e, t) {
          if (e instanceof s.o9 && t instanceof s.o9) {
            if (t.startPoint !== e.startPoint || t.endPoint !== e.endPoint) return !(t.startPoint.x - e.startPoint.x == t.boundingBox.left - e.boundingBox.left && t.startPoint.y - e.startPoint.y == t.boundingBox.top - e.boundingBox.top);
          } else if ((e instanceof s.om || e instanceof s.Hi) && (t instanceof s.om || t instanceof s.Hi)) return !(e.points.size === t.points.size && e.points.every((n, r) => {
            const o = t.points.get(r);
            return (0, i.kG)(o && n), o.x - n.x == t.boundingBox.left - e.boundingBox.left && o.y - n.y == t.boundingBox.top - e.boundingBox.top;
          }));
          return !1;
        }
        function le(e, t, n) {
          const {
            invalidAPStreams: r
          } = e();
          let o = !1,
            i = r.get(t.pageIndex);
          i && (o = !!i.get(t.id)), n();
          const {
              invalidAPStreams: a,
              annotations: s
            } = e(),
            l = s.get(t.id);
          if (!l) return !o;
          let u = !1;
          return i = a.get(l.pageIndex), i && (u = !!i.get(l.id)), !o && u;
        }
        function ue(e, t, n) {
          (0, i.kG)(e.backend);
          const {
              invalidAPStreams: r,
              historyIdsMap: o,
              isHistoryEnabled: a,
              backend: s
            } = e,
            l = t.get(n.pageIndex),
            u = r.get(n.pageIndex);
          return !a || "STANDALONE" !== (null == s ? void 0 : s.type) || l && l.has(n.id) || !u || !u.has(n.id) ? n : n.set("APStreamCache", {
            cache: o.get(n.id) || n.id
          });
        }
        function ce(e, t) {
          (0, i.kG)(e.backend);
          const {
            historyIdsMap: n,
            isHistoryEnabled: r,
            backend: o
          } = e;
          return r && "STANDALONE" === (null == o ? void 0 : o.type) ? t.set("APStreamCache", {
            cache: n.get(t.id) || t.id
          }) : t;
        }
        const de = "rgba(70, 54, 227, 0.5) solid 2px";
        function pe(e) {
          const {
            id: t,
            pdfObjectId: n
          } = e;
          return e => e === (null == n ? void 0 : n.toString()) || e === t;
        }
        function he(e, t) {
          let {
            backend: n,
            annotations: r
          } = e;
          t.forEach(e => {
            const t = r.get(e.id);
            t && oe(t, e) && (null == n || n.clearPageAPStreams(t.pageIndex, (0, o.l4)([t.id])));
          });
        }
        function fe(e, t, n) {
          let {
            backend: r,
            formFields: i
          } = e;
          t.forEach(e => {
            const t = i.get(e.formFieldName);
            t && ie(t, n) && (null == r || r.clearPageAPStreams(e.pageIndex, (0, o.l4)([e.id])));
          });
        }
        const me = Object.freeze({
          CLOCKWISE: "CLOCKWISE",
          COUNTERCLOCKWISE: "COUNTERCLOCKWISE"
        });
        function ge(e, t, n) {
          const {
              rotation: r,
              boundingBox: o
            } = e,
            i = o.getCenter();
          let a = new s.E9({
            x: Math.max(0, i.x - o.height / 2),
            y: Math.max(0, i.y - o.width / 2)
          });
          a.x + o.height > t.width && (a = a.set("x", t.width - o.height)), a.y + o.width > t.height && (a = a.set("y", t.height - o.width));
          const l = e.set("boundingBox", o.withMutations(e => {
            e.height = o.width, e.width = o.height, e.left = a.x, e.top = a.y;
          }));
          if (n) {
            const e = n === me.CLOCKWISE;
            switch (r) {
              case 0:
                return l.set("rotation", e ? 270 : 90);
              case 90:
                return l.set("rotation", e ? 0 : 180);
              case 180:
                return l.set("rotation", e ? 90 : 270);
              case 270:
                return l.set("rotation", e ? 180 : 0);
            }
          }
          return l;
        }
        function ve(e, t) {
          return s.UL.union(e.map(e => {
            if ((0, b.o0)(e)) {
              return P((0, b.az)(e), t);
            }
            return P(e, t);
          }));
        }
        function ye(e, t) {
          if (e instanceof s.x_) return "widget";
          if (Object.keys(h.Z).includes(e.constructor.readableName.toLowerCase() + "Annotation")) {
            const n = function (e) {
              if (e instanceof s.Jn) return h.Z.comment.id;
              const t = e.constructor.readableName.toLowerCase() + "Annotation";
              return h.Z[t].id;
            }(e);
            return t(h.Z[n]);
          }
          return e.constructor.readableName.toLowerCase();
        }
        function be(e) {
          return !(e instanceof s.UX && e.isMeasurement());
        }
        function we(e, t) {
          return null != t && t.isAnnotationNote ? e.readOnly ? "not-allowed" : "inherit" : e instanceof s.gd ? e.readOnly ? "not-allowed" : e.locked ? "text" : e.lockedContents ? "pointer" : (null == t ? void 0 : t.cursor) || (null != t && t.isSelectable ? "pointer" : "auto") : e instanceof s.GI ? e.readOnly || e.locked ? "not-allowed" : (null == t ? void 0 : t.cursor) || (null != t && t.isSelectable ? "pointer" : "auto") : e instanceof s.Zc ? e.readOnly || e.locked ? "not-allowed" : e.lockedContents ? "pointer" : "inherit" : e instanceof s.R1 ? e.locked ? "pointer" : "inherit" : e instanceof s.Qi && null != t && t.isExpandedNote ? e.readOnly || e.locked && e.lockedContents ? "not-allowed" : e.locked ? "text" : e.lockedContents ? "not-allowed" : t.isSelectable ? "pointer" : "auto" : e.readOnly || e.locked && e.lockedContents || e.locked ? "not-allowed" : e.lockedContents || null != t && t.isSelectable || null != t && t.isSelected ? "pointer" : "auto";
        }
        function xe(e) {
          if (e instanceof s.GI) return h.Z.stampAnnotation;
          if (e instanceof s.sK) return h.Z.imageAnnotation;
          if (e instanceof s.gd) return h.Z.textAnnotation;
          if (e instanceof s.Qi) return h.Z.noteAnnotation;
          if (e instanceof s.Jn) return h.Z.comment;
          if (e instanceof s.Zc) return h.Z.inkAnnotation;
          if (e instanceof s.R1) return h.Z.linkAnnotation;
          if (e instanceof s.o9) return h.Z.lineAnnotation;
          if (e instanceof s.b3) return h.Z.rectangleAnnotation;
          if (e instanceof s.Xs) return h.Z.ellipseAnnotation;
          if (e instanceof s.Hi) return h.Z.polygonAnnotation;
          if (e instanceof s.om) return h.Z.polylineAnnotation;
          if (e instanceof s.FV) return h.Z.highlightAnnotation;
          if (e instanceof s.hL) return h.Z.squiggleAnnotation;
          if (e instanceof s.xu) return h.Z.underlineAnnotation;
          if (e instanceof s.R9) return h.Z.strikeOutAnnotation;
          if (e instanceof l.Z) return h.Z.redactionAnnotation;
          if (e instanceof s.Hu) return h.Z.mediaAnnotation;
          if (e instanceof s.Ih) return h.Z.unknownAnnotation;
          throw new i.p2(`Unsupported annotation type: ${JSON.stringify(e.toJS())}`);
        }
        function De(e) {
          return (!(e instanceof s.GI || e instanceof s.sK || e instanceof s.Qi || e instanceof s.UX) || !e.locked && !e.readOnly) && !(e instanceof s.gd && e.readOnly);
        }
        function Ce(e, t) {
          return !(e instanceof s.Hu || e instanceof l.Z || e instanceof s.On || "focus" === t.type);
        }
        function Se(e) {
          return e.isSignature;
        }
        function Ee(e, t) {
          return e.filter(e => e.pageIndex === t && e instanceof s.R1).toList();
        }
        function _e(e, t) {
          return Pe(e, t) ? 1 : t;
        }
        function Pe(e, t) {
          return (e instanceof s.GI || e instanceof s.gd && !$(e)) && e.noZoom && t >= 1;
        }
        function ke(e) {
          return e.createdAt.getTime() === e.updatedAt.getTime();
        }
        function Ae(e) {
          return e instanceof s.gd ? "xhtml" === e.text.format ? (0, g.KY)(e.text.value) : e.text.value : "";
        }
        function ze(e) {
          const t = {
            width: e.boundingBox.width,
            height: e.boundingBox.height,
            opacity: e.opacity,
            rotation: e.rotation
          };
          var n;
          return e instanceof s.GI ? JSON.stringify(x(x({}, t), {}, {
            stampType: e.stampType,
            title: e.title,
            subtitle: e.subtitle,
            color: null === (n = e.color) || void 0 === n ? void 0 : n.toHex(),
            xfdfAppearanceStream: e.xfdfAppearanceStream,
            xfdfAppearanceStreamOriginalPageRotation: e.xfdfAppearanceStreamOriginalPageRotation
          })) : JSON.stringify(t);
        }
      },
      34299: (e, t, n) => {
        "use strict";

        function r(e) {
          const t = new FileReader();
          return new Promise((n, r) => {
            t.onerror = e => {
              r(new Error(e));
            }, t.onload = e => {
              var t;
              n(new Uint8Array(null === (t = e.target) || void 0 === t ? void 0 : t.result));
            }, t.readAsArrayBuffer(e);
          });
        }
        n.d(t, {
          V: () => r
        });
      },
      22284: (e, t, n) => {
        "use strict";

        n.d(t, {
          A: () => r
        });
        const r = n(34997).SK;
      },
      98179: (e, t, n) => {
        "use strict";

        var r;
        function o() {
          var e, t;
          let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null !== (e = null === (t = globalThis.navigator) || void 0 === t ? void 0 : t.userAgent) && void 0 !== e ? e : "";
          return n.indexOf("Trident/") > -1 ? "trident" : n.indexOf("Edge/") > -1 ? "edge" : n.indexOf("Chrome/") > -1 ? "blink" : n.indexOf("AppleWebKit/") > -1 ? "webkit" : n.indexOf("Gecko/") > -1 ? "gecko" : "unknown";
        }
        function i(e, t) {
          const n = new RegExp(` ${t}/(\\d+)\\.*`);
          let r;
          return (r = e.match(n)) ? Number(r[1]) : 0;
        }
        function a() {
          var e, t, n, r, o, i;
          let a = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null !== (e = null === (t = globalThis.navigator) || void 0 === t ? void 0 : t.userAgent) && void 0 !== e ? e : "",
            s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null !== (n = null === (r = globalThis.navigator) || void 0 === r ? void 0 : r.platform) && void 0 !== n ? n : "",
            l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null !== (o = null === (i = globalThis.navigator) || void 0 === i ? void 0 : i.maxTouchPoints) && void 0 !== o ? o : 0;
          return s.indexOf("MacIntel") > -1 && l > 1 ? "ios" : a.indexOf("Win") > -1 ? "windows" : a.indexOf("iPhone") > -1 || a.indexOf("iPad") > -1 || "iPad" === s ? "ios" : a.indexOf("Mac") > -1 ? "macos" : a.indexOf("Android") > -1 ? "android" : a.indexOf("Linux") > -1 ? "linux" : "unknown";
        }
        n.d(t, {
          By: () => l,
          Dt: () => g,
          G6: () => c,
          Ni: () => u,
          SR: () => s,
          TL: () => m,
          V5: () => x,
          b1: () => w,
          b5: () => v,
          eJ: () => D,
          fq: () => h,
          i7: () => p,
          rO: () => f,
          vU: () => d,
          yx: () => y
        });
        const s = o(),
          l = a(),
          u = (function () {
            var e;
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null === (e = globalThis.navigator) || void 0 === e ? void 0 : e.userAgent;
            switch (o(t)) {
              case "trident":
                return i(t, "Trident");
              case "edge":
                return i(t, "Edge");
              case "blink":
                return i(t, "Chrome");
              case "webkit":
                return i(t, "Version");
              case "gecko":
                return i(t, "Firefox");
              default:
                ;
            }
          }(), function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a(),
              t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : o();
            return "ios" === e || "android" === e || y(t);
          }()),
          c = "webkit" === s,
          d = "gecko" === s,
          p = "blink" === s,
          h = "trident" === s,
          f = "edge" === s,
          m = "ios" === l || y(),
          g = "android" === l,
          v = p && g;
        function y() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o();
          return ("undefined" == typeof window || !window.PSPDFKIT_PLAYWRIGHT_TEST) && "webkit" === e && "undefined" != typeof TouchEvent;
        }
        let b;
        function w() {
          var e;
          void 0 === b && (b = "ontouchstart" in window || (null === (e = globalThis.navigator) || void 0 === e ? void 0 : e.maxTouchPoints) > 0);
          return b;
        }
        "undefined" != typeof window && (window.addEventListener("mousemove", function e() {
          b = !1, window.removeEventListener("mousemove", e);
        }), window.addEventListener("pointermove", function e(t) {
          "mouse" !== t.pointerType && "pen" !== t.pointerType || (b = !1), window.removeEventListener("pointermove", e);
        }));
        const x = /Mac/i.test(null === (r = globalThis.navigator) || void 0 === r ? void 0 : r.platform),
          D = e => c && function () {
            var e, t;
            const n = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null !== (e = null === (t = globalThis.navigator) || void 0 === t ? void 0 : t.userAgent) && void 0 !== e ? e : "").match(/Version\/(\d+\.\d)/);
            return n ? Number(n[1]) : 0;
          }() < e;
      },
      72127: (e, t, n) => {
        "use strict";

        n.d(t, {
          CM: () => i,
          Kd: () => a,
          Ss: () => l,
          ev: () => c,
          iR: () => u,
          kR: () => s,
          mi: () => o,
          os: () => d,
          uW: () => p
        });
        var r = n(15359);
        function o(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || null == e.pageIndex || "boolean" != typeof e.canReply || e.isCommentThreadRoot && e.canReply;
        }
        function i(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || null == e.pageIndex || "boolean" != typeof e.isEditable || e.isEditable;
        }
        function a(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || null == e.pageIndex || "boolean" != typeof e.isDeletable || e.isDeletable;
        }
        function s(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || null == e.pageIndex || "boolean" != typeof e.isEditable || e.isEditable;
        }
        function l(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || null == e.pageIndex || "boolean" != typeof e.isDeletable || e.isDeletable;
        }
        function u(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || "boolean" != typeof e.isEditable || e.isEditable;
        }
        function c(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || "boolean" != typeof e.isDeletable || e.isDeletable;
        }
        function d(e, t) {
          return (0, r.kG)(t.backend), !t.backend.isCollaborationPermissionsEnabled() || "boolean" != typeof e.isFillable || e.isFillable;
        }
        function p(e, t) {
          return (0, r.kG)(t.backend), !(!t.backend.isCollaborationPermissionsEnabled() || "boolean" != typeof e.canSetGroup) && e.canSetGroup;
        }
      },
      35727: (e, t, n) => {
        "use strict";

        n.d(t, {
          Y7: () => p,
          _P: () => v,
          dq: () => f,
          en: () => y,
          kT: () => m,
          kx: () => d,
          nN: () => g,
          oK: () => h
        });
        var r = n(93113),
          o = n(21683),
          i = n(44077),
          a = n(10983),
          s = n(2464),
          l = n(60679),
          u = n(12705),
          c = n(82716);
        const d = "The feature you're trying to use requires a comments license. The Comments component is sold separately.";
        function p(e) {
          let {
            showComments: t,
            commentThreads: n,
            features: r,
            backend: o
          } = e;
          return t && n.size > 0 && (0, u.LC)({
            features: r,
            backend: o
          });
        }
        function h(e) {
          let {
            showComments: t,
            features: n,
            backend: r
          } = e;
          return t && (0, u.LC)({
            features: n,
            backend: r
          });
        }
        function f(e) {
          if (!p(e)) return null;
          const {
            viewportState: t
          } = e;
          return e.containerRect.width > a.xD ? t.scrollMode !== s.G.PER_SPREAD && t.scrollMode !== s.G.DISABLED || function (e, t) {
            let {
              viewportState: n,
              pages: r,
              commentThreads: i
            } = e;
            return (0, o.P1)(n, (0, o.dF)(n, t)).some(e => {
              const t = r.get(e);
              return !!t && t.annotationIds.some(e => i.has(e));
            });
          }(e, e.viewportState.currentPageIndex) ? l._.SIDEBAR : null : e.selectedAnnotationIds.size > 0 && e.selectedAnnotationIds.some(t => !!e.commentThreads.get(t)) ? l._.PANE : null;
        }
        const m = e => null == e.pageIndex;
        function g(e, t) {
          const n = (0, o.dF)(t, e.pageIndex);
          let a = i.sl.IDENTITY;
          if (t.scrollMode === s.G.CONTINUOUS) {
            const e = (0, o.e8)(t, n);
            a = a.translateY(e);
          }
          return a = (0, r._4)(a, t), e.boundingBox.apply(a).top;
        }
        const v = (e, t) => !!y(e, t),
          y = (e, t) => {
            const n = e.last();
            if (null !== n) {
              const e = t.get(n);
              if ((0, c.k)(e), m(e)) return e;
            }
          };
      },
      65160: (e, t, n) => {
        "use strict";

        n.d(t, {
          LD: () => c,
          TH: () => l,
          cJ: () => h,
          uv: () => u,
          wj: () => f
        });
        var r = n(35369),
          o = n(45249),
          i = n(98179),
          a = n(98492),
          s = n(65739);
        function l(e, t) {
          return (0, r.aV)(e.textLines.map((e, n) => new o.bi({
            id: n + 1,
            contents: e.contents,
            pageIndex: t,
            boundingBox: new o.UL({
              top: e.top,
              left: e.left,
              height: e.height,
              width: e.width
            })
          })));
        }
        function u(e, t, n, i, l) {
          let u = n,
            c = i,
            h = l;
          const f = [];
          function m(e, n) {
            return new o.dc({
              id: n,
              pageIndex: t,
              boundingBox: (0, a.k)(e.bbox),
              elementType: e.element.type
            });
          }
          return function e(n, r) {
            n && n.forEach(n => {
              if (n.element && n.bbox && ("text" === n.element.type ? n.element.text && r && r.textLines.push(function (e, n) {
                return new o.bi({
                  id: n,
                  contents: e.element.text,
                  pageIndex: t,
                  boundingBox: (0, a.k)(e.bbox),
                  hints: e.element.hints
                });
              }(n, ++c)) : (n.element.type, r && r.contentElements.push(m(n, ++h)))), n.children) {
                const o = {
                  pdfua_type: n.pdfua_type,
                  type: n.type,
                  alt: n.alt
                };
                let a = null;
                "Document" !== n.pdfua_type && (a = {
                  id: ++u,
                  pageIndex: t,
                  textLines: [],
                  contentElements: [],
                  contentBlocks: [],
                  contentTreeElementMetadata: o,
                  allowsBlockTypeChildren: (i = s.m[n.pdfua_type], "p" !== i),
                  boundingBox: null
                }, r ? r.contentBlocks.push(a) : f.push(a)), e(n.children, a);
              }
              var i;
            });
          }(e, null), f.map(function e(t) {
            return new o.b0({
              id: t.id,
              pageIndex: t.pageIndex,
              contentTreeElementMetadata: t.contentTreeElementMetadata,
              textLines: (0, r.aV)(t.textLines),
              contentElements: (0, r.aV)(t.contentElements).filter(p),
              contentBlocks: (0, r.aV)(t.contentBlocks.map(e)),
              allowsBlockTypeChildren: t.allowsBlockTypeChildren,
              boundingBox: d(t)
            });
          });
        }
        function c(e, t) {
          if (e) return t.contents;
          const n = function (e) {
            const t = e.split("‍");
            let n = 0;
            for (const e of t) {
              n += Array.from(e.split(/[\ufe00-\ufe0f]/).join("")).length;
            }
            return n / t.length;
          }(t.contents);
          return i.TL ? " x".repeat(n / 2) : " ".repeat(n);
        }
        function d(e) {
          const {
            textLines: t,
            contentElements: n,
            contentBlocks: i
          } = e;
          if (0 === t.length && 0 === n.length && 0 === i.length) return null;
          const a = t.map(e => e.boundingBox).concat(n.map(e => e.boundingBox)).concat(i.map(d).filter(Boolean));
          return 0 === a.length ? null : o.UL.union((0, r.aV)(a));
        }
        function p(e) {
          return "path" !== e.elementType;
        }
        function h(e) {
          return "Figure" === e || "L" === e || "LI" === e;
        }
        function f(e) {
          return "li" === e ? {
            listStyleType: "none"
          } : null;
        }
      },
      35998: (e, t, n) => {
        "use strict";

        n.d(t, {
          AK: () => c,
          Aq: () => u,
          Gp: () => l,
          Im: () => f,
          Tl: () => m,
          _v: () => y,
          sz: () => d,
          uB: () => b,
          yK: () => p,
          z8: () => h
        });
        var r = n(35369),
          o = n(96988),
          i = n(44077),
          a = n(26559);
        n(44550);
        function s(e) {
          return {
            textBlockId: e.id,
            anchor: (0, a.X$)(e.anchor),
            globalEffects: (0, a.uE)(e.globalEffects),
            externalControlState: (0, a.hH)(e)
          };
        }
        function l(e) {
          const t = [];
          for (const n of e.pageStates.toList()) {
            const e = new Map(n.textBlocks.map(e => [e.id, e]));
            for (const r of n.initialTextBlocks) e.has(r.id) || t.push(s(r));
            for (const e of n.textBlocks) {
              (!(0, r.is)(e.anchor, e.initialAnchor) || !(0, r.is)(e.globalEffects, e.initialGlobalEffects) || !(0, r.is)(e.layout, e.initialLayout) || e.version) && t.push(s(e));
            }
          }
          return t;
        }
        const u = "The API you're trying to use requires a content editor license. The Content Editor component is sold separately.";
        const c = [4, 6, 8, 10, 12, 14, 16, 18, 20, 24, 32, 36, 48, 64, 72, 96, 144, 192, 200];
        function d(e, t) {
          return new o.UL({
            offset: new o.Sg({
              x: e.offset.x * t,
              y: e.offset.y * t
            }),
            size: new o.Sg({
              x: e.size.x * t,
              y: e.size.y * t
            })
          });
        }
        function p(e, t, n) {
          return new o.UL({
            offset: new o.Sg({
              x: e.offset.x + t.x * n,
              y: e.offset.y + t.y * n
            }),
            size: e.size
          });
        }
        function h(e) {
          let t = "";
          for (const n of e) t += n.text;
          return t;
        }
        const f = 0,
          m = 1,
          g = e => {
            switch (e) {
              case "begin":
              case "justified":
                return f;
              case "end":
                return m;
              case "center":
                return .5;
            }
          },
          v = (e, t, n) => {
            const r = (e => new i.sl().rotateRad(e.rotation).scale(1, e.flipY ? -1 : 1))(e),
              a = r.applyToVector([n * t, 0]);
            return new o.Sg({
              x: a[0],
              y: a[1]
            });
          },
          y = (e, t, n) => (t - g(e)) * n,
          b = (e, t, n, r) => {
            const o = g(e) - n;
            return v(t, o, r);
          };
      },
      79724: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o
        });
        var r = n(15359);
        const o = function () {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          return function (t, n) {
            if (!t) throw new r.p2("" === e ? n : `${e}: ${n}`);
          };
        };
      },
      5619: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => o,
          k: () => i
        });
        var r = n(35369);
        function o(e, t) {
          let n;
          return function () {
            for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
            const a = this;
            n && clearTimeout(n), n = setTimeout(() => {
              n = null, e.apply(a, o);
            }, t);
          };
        }
        function i(e) {
          let t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
            o = (0, r.aV)();
          function i(e) {
            const t = o;
            o = o.clear(), e.then(e => {
              t.forEach(t => {
                t.resolve(e);
              });
            }).catch(e => {
              t.forEach(t => {
                t.reject(e);
              });
            });
          }
          return function () {
            for (var r = arguments.length, a = new Array(r), s = 0; s < r; s++) a[s] = arguments[s];
            const l = this;
            return t && clearTimeout(t), t = setTimeout(() => {
              t = null, i(e.apply(l, a));
            }, n), new Promise((e, t) => {
              o = o.push({
                resolve: e,
                reject: t
              });
            });
          };
        }
      },
      67009: (e, t, n) => {
        "use strict";

        n.d(t, {
          sM: () => f,
          uF: () => h,
          Zt: () => m,
          jI: () => p,
          tK: () => w,
          w2: () => g
        });
        var r = n(15359),
          o = n(19575),
          i = n(69842),
          a = n(13349),
          s = n(45249),
          l = n(44550),
          u = n(74110),
          c = n(39684);
        const d = ["application/pdf", "image/png", "image/jpeg"];
        function p(e, t) {
          if (t === a.W.IF_SIGNED && e.status !== i._.not_signed) return !0;
          if (t === a.W.HAS_ERRORS && e.status === i._.error) return !0;
          const n = e.status === i._.valid && e.documentModifiedSinceSignature;
          return !(t !== a.W.HAS_WARNINGS || e.status !== i._.warning && e.status !== i._.error && !n);
        }
        function h(e) {
          if ("string" == typeof e) return o.Base64.encode(e);
          if (e instanceof ArrayBuffer) return f(e);
          throw (0, r.Rz)(e);
        }
        function f(e) {
          let t = "";
          const n = new Uint8Array(e),
            r = n.byteLength;
          for (let e = 0; e < r; e++) t += String.fromCharCode(n[e]);
          return btoa(t);
        }
        function m(e, t) {
          return !!(e.features.includes(l.q.DIGITAL_SIGNATURES) && t instanceof s.x_ && "number" == typeof t.pdfObjectId && e.digitalSignatures && e.digitalSignatures.signatures && e.digitalSignatures.signatures.some(e => {
            let {
              signatureFormFQN: n
            } = e;
            return n === t.formFieldName;
          }) && e.formFields.has(t.formFieldName));
        }
        function g(e, t) {
          e && t && "STANDALONE" === t.type && ((0, r.kG)(void 0 === e.placeholderSize || "number" == typeof e.placeholderSize, "`placeholderSize` must be a number."), (0, r.kG)(void 0 === e.flatten || "boolean" == typeof e.flatten, "`flatten` must be a boolean."), (0, r.kG)(void 0 === e.formFieldName || "string" == typeof e.formFieldName, "`formFieldName` must be a string."), (0, r.kG)(void 0 === e.formFieldName || void 0 === e.position, "`formFieldName` and `position` cannot be used together."), v(e.position), y(e.appearance), b(e.signatureMetadata), function (e) {
            if (!e) return;
            (0, r.kG)(!e.signatureType || e.signatureType === u.BG.CMS || Array.isArray(e.certificates) && e.certificates.length > 0 && e.certificates.every(e => Boolean(e instanceof ArrayBuffer && e.byteLength > 0 || "string" == typeof e && e.length > 0)), "For signatures of type `PSPDFKit.SignatureType.CAdES` an `Array` of certificates must be provided in `signaturePreparationData.signingData.certificates`."), (0, r.kG)(void 0 === e.privateKey || "string" == typeof e.privateKey && e.privateKey.length > 0, "`signingData.privateKey` must be a non-empty string if provided."), (0, r.kG)(Object.values(u.BG).includes(e.signatureType), `\`signingData.signatureType\` must be a valid \`PSPDFKit.SignatureType\` value. \`${e.signatureType}\` was provided instead.`);
          }(e.signingData));
        }
        function v(e) {
          e && ((0, r.kG)("number" == typeof e.pageIndex, "`pageIndex` must be a number."), (0, r.kG)(e.boundingBox instanceof s.UL, "`boundingBox` must be a PSPDFKit.Geometry.Rect instance."));
        }
        function y(e) {
          var t, n;
          e && ((0, r.kG)(void 0 === e.mode || e.mode in c.H, "`mode` must be a valid PSPDFKit.SignatureAppearanceMode value."), (0, r.kG)(void 0 === e.showSigner || "boolean" == typeof e.showSigner, "`showSigner` must be a boolean."), (0, r.kG)(void 0 === e.showSignDate || "boolean" == typeof e.showSignDate, "`showSignDate` must be a boolean."), (0, r.kG)(void 0 === e.showReason || "boolean" == typeof e.showReason, "`showReason` must be a boolean."), (0, r.kG)(void 0 === e.showLocation || "boolean" == typeof e.showLocation, "`showLocation` must be a boolean."), (0, r.kG)(void 0 === e.showWatermark || "boolean" == typeof e.showWatermark, "`showWatermark` must be a boolean."), (0, r.kG)(void 0 === e.showDateTimezone || "boolean" == typeof e.showDateTimezone, "`showDateTimezone` must be a boolean."), (0, r.kG)(void 0 === e.watermarkImage || "Blob" === e.watermarkImage.constructor.name || "File" === e.watermarkImage.constructor.name, "`watermarkImage` must be a Blob or File."), (0, r.kG)(void 0 === e.graphicImage || "Blob" === e.graphicImage.constructor.name || "File" === e.graphicImage.constructor.name, "`graphicImage` must be a Blob or File."), (0, r.kG)(void 0 === e.watermarkImage || d.includes(e.watermarkImage.type), `The image type must be one of the supported formats: ${d.join(", ")}, provided: ${null === (t = e.watermarkImage) || void 0 === t ? void 0 : t.type}.`), (0, r.kG)(void 0 === e.graphicImage || d.includes(e.graphicImage.type), `The image type must be one of the supported formats: ${d.join(", ")}, provided: ${null === (n = e.graphicImage) || void 0 === n ? void 0 : n.type}.`));
        }
        function b(e) {
          e && ((0, r.kG)(void 0 === e.signerName || "string" == typeof e.signerName, "`signerName` must be a string."), (0, r.kG)(void 0 === e.signatureReason || "string" == typeof e.signatureReason, "`signatureReason` must be a string."), (0, r.kG)(void 0 === e.signatureLocation || "string" == typeof e.signatureLocation, "`signatureLocation` must be a string."));
        }
        function w(e) {
          var t, n, o, i;
          e && ((0, r.kG)(!("placeholderSize" in e) || "number" == typeof e.placeholderSize && e.placeholderSize > 0, `Invalid \`placeholderSize\` for signature preparation data. Must be of type \`number\` and greater than \`0\` if present. Provided: ${e.placeholderSize}.`), (0, r.kG)(!("flatten" in e) || "boolean" == typeof e.flatten, `Invalid \`flatten\` for signature preparation data. Must be of type \`boolean\` if present. Provided: ${e.flatten}.`), (0, r.kG)(!("signatureMetadata" in e) || "object" == typeof e.signatureMetadata, `Invalid \`signatureMetadata\` for signature preparation data. Must be of type \`object\` if present. Provided: ${e.signatureMetadata}.`), "signatureMetadata" in e && b(e.signatureMetadata), (0, r.kG)(!("position" in e) || "object" == typeof e.position, `Invalid \`position\` for signature preparation data. Must be of type \`object\` if present. Provided: ${e.position}.`), "position" in e && v(e.position), (0, r.kG)(!("appearance" in e) || "object" == typeof e.appearance, `Invalid \`appearance\` for signature preparation data. Must be of type \`object\` if present. Provided: ${e.appearance}.`), "appearance" in e && y(e.appearance), (0, r.kG)(!("formFieldName" in e) || "string" == typeof e.formFieldName && e.formFieldName.trim().length > 0, `Invalid \`formFieldName\` for signature preparation data. Must be a non-empty \`string\` if present. Provided: ${e.formFieldName}.`), (0, r.kG)(!e.signingData || !("signatureContainer" in e.signingData) || (null === (t = e.signingData) || void 0 === t ? void 0 : t.signatureContainer) && Object.values(u.FR).includes(e.signingData.signatureContainer), `Invalid \`signingData.signatureContainer\`. Must be either \`raw\` or \`pkcs7\` if present. Provided: ${null === (n = e.signingData) || void 0 === n ? void 0 : n.signatureContainer}.`), (0, r.kG)(!e.signingData || !("signatureType" in e.signingData) || (null === (o = e.signingData) || void 0 === o ? void 0 : o.signatureType) && Object.values(u.BG).includes(e.signingData.signatureType), `Invalid \`signingData.signatureType\`. Must be either \`CMS\` or \`CAdES\` if present. Provided: ${null === (i = e.signingData) || void 0 === i ? void 0 : i.signatureType}.`));
        }
      },
      95431: (e, t, n) => {
        "use strict";

        n.d(t, {
          D4: () => Se,
          jX: () => xe
        });
        var r = n(96156),
          o = n(30845),
          i = n(67366),
          a = n(35369),
          s = n(15359),
          l = n(29152),
          u = n(25384),
          c = n(77897),
          d = n(45249),
          p = n(24382),
          h = n(17078),
          f = n(70982),
          m = n(47120),
          g = n(33427),
          v = n(96326),
          y = n(4715);
        class b {
          constructor(e, t) {
            this.annotationProvider = e, this.localAnnotationCallbacks = t;
          }
          createBackendObject(e, t) {
            return (0, s.kG)(!(e instanceof y.Hu), "Media annotations cannot be created nor updated, only deleted."), !this.annotationProvider.canCreateBackendOrphanWidgets && e instanceof d.x_ ? Promise.resolve() : this.annotationProvider.createAnnotation(e, (null == t ? void 0 : t.attachments) || (0, a.D5)());
          }
          updateBackendObject(e, t) {
            return (0, s.kG)(!(e instanceof y.Hu), "Media annotations cannot be created nor updated, only deleted."), this.annotationProvider.updateAnnotation(e, (null == t ? void 0 : t.attachments) || (0, a.D5)());
          }
          deleteBackendObject(e) {
            return this.annotationProvider.deleteAnnotation(e);
          }
          createStoreObjects(e, t) {
            this.localAnnotationCallbacks.createAnnotations(e, (null == t ? void 0 : t.attachments) || (0, a.D5)());
          }
          updateStoreObjects(e) {
            this.localAnnotationCallbacks.updateAnnotations(e);
          }
          deleteStoreObjects(e) {
            this.localAnnotationCallbacks.deleteAnnotations(e);
          }
          validateObject(e) {
            return (0, g.bz)(e);
          }
          getObjectById(e) {
            return this.localAnnotationCallbacks.getAnnotationById(e);
          }
          getObjectId(e) {
            return e.id;
          }
          refresh() {
            this.localAnnotationCallbacks.refreshSignaturesInfo();
          }
          syncChanges() {
            return this.annotationProvider.syncChanges();
          }
        }
        class w extends v.a {
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.u.IMMEDIATE,
              r = arguments.length > 3 ? arguments[3] : void 0;
            super(new b(e, t), n, r), this.annotationProvider = e;
          }
          loadAnnotationsForPageIndex(e) {
            return this.annotationProvider.loadAnnotationsForPageIndex(e);
          }
        }
        var x = n(99745);
        class D {
          constructor(e, t) {
            (0, r.Z)(this, "localBookmarks", (0, a.D5)()), (0, r.Z)(this, "onCreate", e => {
              this.localBookmarks = this.localBookmarks.set(e.id, e);
            }), (0, r.Z)(this, "onUpdate", e => {
              this.onCreate(e);
            }), (0, r.Z)(this, "onDelete", e => {
              this.localBookmarks = this.localBookmarks.delete(e.id);
            }), this.bookmarkProvider = e, this.localBookmarkCallbacks = t;
          }
          createBackendObject(e) {
            return this.bookmarkProvider.createBookmark(e);
          }
          updateBackendObject(e) {
            return this.bookmarkProvider.updateBookmark(e);
          }
          deleteBackendObject(e) {
            return this.bookmarkProvider.deleteBookmark(e.id);
          }
          createStoreObjects(e) {
            this.localBookmarks = this.localBookmarks.withMutations(t => {
              e.forEach(e => {
                t.set(e.id, e);
              });
            });
          }
          updateStoreObjects(e) {
            this.createStoreObjects(e);
          }
          deleteStoreObjects(e) {
            this.localBookmarks = this.localBookmarks.withMutations(t => {
              e.forEach(e => {
                t.delete(e);
              });
            });
          }
          validateObject(e) {
            if (!e.id || "string" != typeof e.id) return !1;
            try {
              return (0, x.G)(e), !0;
            } catch (e) {
              return !1;
            }
          }
          getObjectById(e) {
            return this.localBookmarks.get(e);
          }
          getObjectId(e) {
            return e.id;
          }
          refresh() {
            this.localBookmarkCallbacks.refreshSignaturesInfo();
          }
          syncChanges() {
            return this.bookmarkProvider.syncChanges();
          }
        }
        class C extends v.a {
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.u.IMMEDIATE,
              o = arguments.length > 3 ? arguments[3] : void 0;
            super(new D(e, t), n, o), (0, r.Z)(this, "getBookmarks", function () {
              let e = null;
              return async function () {
                return e || (e = this.bookmarkProvider.loadBookmarks()), await e, this.getLocalBookmarks();
              };
            }()), this.bookmarkProvider = e;
          }
          getLocalBookmarks() {
            return this._callbacks.localBookmarks;
          }
        }
        var S = n(28018),
          E = n(56207);
        class _ {
          constructor(e, t) {
            (0, r.Z)(this, "localComments", (0, a.D5)()), (0, r.Z)(this, "onCreate", e => {
              (0, s.kG)(e.id), this.localComments = this.localComments.set(e.id, e);
            }), (0, r.Z)(this, "onUpdate", e => {
              this.onCreate(e);
            }), (0, r.Z)(this, "onDelete", e => {
              (0, s.kG)(e.id), this.localComments = this.localComments.delete(e.id);
            }), this.commentProvider = e, this.localCommentCallbacks = t;
          }
          createBackendObject(e, t) {
            return this.commentProvider.createComment(e, t.comments, t.annotations);
          }
          updateBackendObject(e, t) {
            return this.commentProvider.updateComment(e, t.comments, t.annotations);
          }
          deleteBackendObject(e, t) {
            return (0, s.kG)(e.id), this.commentProvider.deleteComment(e.id, t.comments, t.annotations);
          }
          createStoreObjects(e) {
            this.localComments = this.localComments.withMutations(t => {
              e.forEach(e => {
                (0, s.kG)(e.id), t.set(e.id, e);
              });
            }), this.localCommentCallbacks.createComments(e);
          }
          updateStoreObjects(e) {
            this.localComments = this.localComments.withMutations(t => {
              e.forEach(e => {
                (0, s.kG)(e.id), t.set(e.id, e);
              });
            }), this.localCommentCallbacks.updateComments(e);
          }
          deleteStoreObjects(e) {
            this.localComments = this.localComments.withMutations(t => {
              e.forEach(e => {
                t.delete(e);
              });
            }), this.localCommentCallbacks.deleteComments(e);
          }
          validateObject(e) {
            try {
              return (0, E.Gu)(e), !0;
            } catch (e) {
              return !1;
            }
          }
          getObjectById(e) {
            return this.localComments.get(e);
          }
          getObjectId(e) {
            return (0, s.kG)(e.id), e.id;
          }
          refresh() {
            this.localCommentCallbacks.refreshSignaturesInfo();
          }
          syncChanges() {
            return this.commentProvider.syncChanges();
          }
        }
        class P extends v.a {
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.u.IMMEDIATE,
              r = arguments.length > 3 ? arguments[3] : void 0;
            super(new _(e, t), n, r), this.commentProvider = e;
          }
          async loadComments() {
            let e = null;
            e || (e = this.commentProvider.loadComments ? this.commentProvider.loadComments() : Promise.resolve()), await e;
          }
        }
        var k = n(48169);
        class A {
          constructor(e, t) {
            this.formFieldValueProvider = e, this.localFormFieldValueCallbacks = t;
          }
          createBackendObject(e) {
            return this.formFieldValueProvider.createFormFieldValue(e);
          }
          updateBackendObject(e) {
            return this.formFieldValueProvider.setFormFieldValue(e);
          }
          deleteBackendObject(e) {
            return this.formFieldValueProvider.deleteFormFieldValue((0, k.X)(e));
          }
          createStoreObjects(e) {
            this.localFormFieldValueCallbacks.createFormFieldValues(e);
          }
          updateStoreObjects(e) {
            this.localFormFieldValueCallbacks.setFormFieldValues(e);
          }
          deleteStoreObjects(e) {
            this.localFormFieldValueCallbacks.deleteFormFieldValues(e);
          }
          getObjectById() {
            return null;
          }
          getObjectId(e) {
            return e.name;
          }
          validateObject() {
            return !0;
          }
          refresh() {
            this.localFormFieldValueCallbacks.refreshSignaturesInfo();
          }
          syncChanges() {
            return this.formFieldValueProvider.syncChanges();
          }
        }
        class z extends v.a {
          _getSupportedEvents() {
            return [...super._getSupportedEvents(), "willSubmit", "didSubmit"];
          }
          constructor(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : m.u.IMMEDIATE,
              r = arguments.length > 3 ? arguments[3] : void 0;
            super(new A(e, t), n === m.u.INTELLIGENT ? m.u.IMMEDIATE : n, r);
          }
          createObject(e) {
            const t = this.lockSave();
            try {
              this._saveModeQueue.createObject(this._createSaveQueueObject(e.name, e)), this._createdObjects = this._createdObjects.set(e.name, e);
            } finally {
              t();
            }
          }
          updateObject(e) {
            const t = this.lockSave();
            try {
              this._saveModeQueue.updateObject(this._createSaveQueueObject(e.name, e)), this._updatedObjects = this._updatedObjects.set(e.name, e);
            } finally {
              t();
            }
          }
          deleteObject(e) {
            const t = this.lockSave();
            try {
              this._saveModeQueue.deleteObject(this._createSaveQueueObject(e.name, e)), this._deletedObjects = this._deletedObjects.set(e.name, (0, k.X)(e));
            } finally {
              t();
            }
          }
        }
        var T = n(4087),
          O = n(56554),
          I = n(12705),
          F = n(87996),
          M = n(35464),
          R = n(49876),
          j = n(79685),
          B = n(46364),
          N = n(2891),
          L = n(5130),
          V = n(79724),
          K = n(20993),
          q = n(72127),
          H = n(44550);
        const U = (0, V.Z)("Forms"),
          Z = (0, s.Tr)("Forms");
        class $ extends K.I {
          constructor(e, t) {
            super(t().formFieldValueManager), this.dispatch = e, this.getState = t;
          }
          async create(e) {
            throw Z(`Can't create ${e.toString()}. Form field values creation is not supported.`);
          }
          async update(e) {
            const {
                formFields: t,
                features: n,
                formsEnabled: r
              } = this.getState(),
              o = this.getState();
            return U(n.includes(H.q.FORMS), L.DR), U(r, L.BZ), U(o.backend), e.map(e => {
              const n = t.get(e.name);
              if (U(n, `Tried to set the form field value for form field \`${e.name}\` which does not exist.`), !(0, q.os)(n, o)) throw new s.p2("You don't have permission to update this form field value.");
              return this.dispatch((0, c.xh)([{
                name: e.name,
                value: e.value,
                optionIndexes: e.optionIndexes
              }])), e;
            });
          }
          async delete(e) {
            return e.map(e => {
              throw Z(`Can't delete ${e.toString()}. Form field values deletion is not supported.`);
            });
          }
          async ensureChangesSaved(e) {
            U("string" == typeof e.name, "The form field value you passed to Instance.ensureChangesSaved() has no name.");
            const {
              formFieldValueManager: t
            } = this.getState();
            return U(t), await t.ensureObjectSaved(e);
          }
        }
        var G = n(22284),
          W = n(21713);
        const Y = (0, V.Z)("Bookmarks");
        class X extends K.I {
          constructor(e, t) {
            super(t().bookmarkManager), this.dispatch = e, this.getState = t;
          }
          async create(e) {
            const t = this.getState(),
              {
                bookmarkManager: n
              } = t,
              r = e.map(e => {
                const t = e.id;
                Y(n), "string" == typeof t && n.getLocalBookmarks() && Y(!n.getLocalBookmarks().has(t), `Bookmark with id (${t}) is already used.`);
                const r = "string" == typeof e.id && e.id.length > 0 ? e : e.set("id", (0, G.A)());
                return (0, x.G)(r), n.createObject(r), n.autoSave(), r;
              });
            return (0, W.s)(r);
          }
          async update(e) {
            const {
              bookmarkManager: t
            } = this.getState();
            Y(t);
            const n = e.map(e => (Y("string" == typeof e.id, "The bookmark you passed to Instance.update() has no id.\nPlease use Instance.create() first to assign an id."), (0, x.G)(e), t.updateObject(e), t.autoSave(), e));
            return (0, W.s)(n);
          }
          async delete(e) {
            const t = this.getState(),
              {
                bookmarkManager: n
              } = t,
              r = await (null == n ? void 0 : n.getBookmarks());
            Y(n);
            const o = e.map(e => {
              Y("string" == typeof e.id, "The supplied bookmark id is not a valid id.");
              const t = null == r ? void 0 : r.get(e.id);
              return Y(t, `No bookmark with id ${e.id} found.`), n.deleteObject(e), n.autoSave(), t;
            });
            return (0, W.s)(o);
          }
          async getObjectById(e) {
            const {
              bookmarkManager: t
            } = this.getState();
            if (!t) return null;
            return (await t.getBookmarks()).get(e);
          }
          async ensureChangesSaved(e) {
            Y("string" == typeof e.id, "The bookmark you passed to Instance.ensureChangesSaved() has no valid id.\nPlease use Instance.create() first to assign an id.");
            const {
              bookmarkManager: t
            } = this.getState();
            return Y(t), await t.ensureObjectSaved(e);
          }
        }
        var Q = n(34997),
          J = n(35727);
        const ee = (0, V.Z)("Comments"),
          te = Q.SK;
        class ne extends K.I {
          constructor(e, t) {
            super(t().commentManager), this.dispatch = e, this.getState = t;
          }
          async create(e, t) {
            const n = this.getState(),
              r = e.map(e => {
                re(n);
                const r = e.id;
                "string" == typeof r && ee(!n.comments.has(r), `Comment id (${r}) is already used.`), ee(e.rootId, "Comment does not have `rootId`");
                const o = n.annotations.get(e.rootId) || (t ? function (e, t) {
                  return e.find(e => e instanceof y.q6 && e.id === t);
                }(t, e.rootId) : null);
                if (ee(o, `Comment orphan: The comment can't be created because no comment thread root was found with the id '${e.rootId}'. Please ensure that you create the corresponding annotation together with the comment via instance.create([comment, commentThreadRootAnnotation]).`), ee(o instanceof y.Jn || o instanceof y.On, `The comment can't be created because its root has wrong type. Was '${o.constructor.name}', only 'CommentMarkerAnnotation' and 'TextMarkupAnnotation' are supported as comment thread roots.`), ee(!e.pageIndex || e.pageIndex === o.pageIndex, `The comment can't be created on different page (${e.pageIndex}) than the comment root (${o.pageIndex}).`), !(0, q.mi)(o, n)) throw new s.p2("You are not allowed to reply to this thread.");
                const {
                  annotationCreatorName: i,
                  annotationCreatorNameReadOnly: a
                } = n;
                if (e.creatorName && e.creatorName !== i && a) throw new s.p2("The comment creator name is different from the one set on the JWT.");
                const l = e.withMutations(t => {
                  const r = new Date();
                  t.set("id", te()).set("creatorName", n.annotationCreatorName).set("createdAt", r).set("updatedAt", r).set("pageIndex", o.pageIndex), ee(n.backend), n.backend.isCollaborationPermissionsEnabled() && !t.group && n.group !== n.backend.getDefaultGroup() && t.merge({
                    group: n.group
                  }), ["id", "creatorName", "createdAt", "updatedAt"].map(n => e[n] && t.set(n, e[n]));
                });
                return (0, E.Gu)(l), l;
              });
            return (0, i.dC)(() => {
              r.forEach(e => {
                e instanceof Error || (this.dispatch((0, M.Jr)(e)), this.autoSave());
              });
            }), (0, W.s)(r);
          }
          async update(e) {
            const t = this.getState(),
              n = e.map(e => {
                var n;
                re(t), ee("string" == typeof e.id, "The comment you passed to Instance.update() has no id.\nPlease use Instance.create() first to assign an id.");
                const r = t.comments.get(e.id);
                ee(r, "An comment that does not exist was updated. This is probably caused by a sync conflict when Instant is enabled.\n    The update of this comment was skipped."), null !== (n = t.backend) && void 0 !== n && n.isCollaborationPermissionsEnabled() || r.group === e.group && e.isEditable === r.isEditable && e.isDeletable === r.isDeletable && e.canSetGroup === r.canSetGroup || (e = e.set("group", r.group).set("isEditable", r.isEditable).set("isDeletable", r.isDeletable).set("canSetGroup", r.canSetGroup), (0, s.ZK)("`group`, `isEditable`, `isDeletable` and `canSetGroup` are only relevant when Collaboration Permissions are enabled in server backed setup. You do not have it enabled so these values are set to `undefined`."));
                if (!e.delete("group").equals(r.delete("group")) && !(0, q.kR)(r, t)) throw new s.p2("You don't have permission to update this comment.");
                if (e.group !== r.group && !(0, q.uW)(e, t)) throw new s.p2("You don't have permission to update the `group` of this comment.");
                if (e.isEditable !== r.isEditable || e.isDeletable !== r.isDeletable || e.canSetGroup !== r.canSetGroup) throw new s.p2("You can't update `isEditable` or `isDeletable` since they are read only properties which depend on the `group` property.");
                if (e.creatorName !== r.creatorName && t.annotationCreatorNameReadOnly) throw new s.p2("You can't change the creatorName of a comment if it was already set on the JWT.");
                if (e.rootId !== r.rootId) throw new s.p2("You can't change the root id of a comment once it has been created.");
                const o = e.set("updatedAt", new Date());
                return (0, E.Gu)(o), o;
              });
            return (0, i.dC)(() => {
              n.forEach(e => {
                e instanceof Error || (this.dispatch((0, M.V4)(e)), this.autoSave());
              });
            }), (0, W.s)(n);
          }
          async delete(e) {
            const t = this.getState();
            re(t);
            const n = e.map(e => {
              ee(e.id);
              const n = t.comments.get(e.id);
              if (ee(n, `No comment with id ${e.id} found.`), !(0, q.Ss)(n, t)) throw new s.p2("You don't have permission to delete this comment.");
              return n;
            });
            return (0, i.dC)(() => {
              n.forEach(e => {
                e instanceof Error || (this.dispatch((0, M.UM)(e)), this.autoSave());
              });
            }), (0, W.s)(n);
          }
          async ensureChangesSaved(e) {
            re(this.getState()), ee("string" == typeof e.id, "The comment you passed to Instance.ensureChangesSaved() has no id.\nPlease use Instance.create() first to assign an id.");
            const {
              commentManager: t
            } = this.getState();
            return ee(t), await t.ensureObjectSaved(e);
          }
          async getObjectById(e) {
            ee("string" == typeof e, "The supplied id is not a valid id.");
            const {
              comments: t,
              features: n
            } = this.getState();
            return n.includes(H.q.COMMENTS) ? t.get(e) : null;
          }
        }
        function re(e) {
          const {
            features: t,
            backend: n
          } = e;
          ee(t.includes(H.q.COMMENTS), J.kx), ee((0, I.xr)(n), "The API you're trying to use is only available when using the PSPDFKit Instant or PSPDFKit for Web Standalone.");
        }
        var oe = n(2549);
        const ie = (0, s.Tr)("Changes");
        class ae {
          constructor(e) {
            this.annotation = e.annotation, this.bookmark = e.bookmark, this.comment = e.comment, this.formField = e.formField, this.formFieldValue = e.formFieldValue;
          }
          toArray() {
            return [this.annotation, this.bookmark, this.comment, this.formField, this.formFieldValue].filter(Boolean);
          }
          forEach(e) {
            this.toArray().forEach(e);
          }
          map(e) {
            return this.toArray().map(e);
          }
        }
        class se {
          constructor(e, t, n, o) {
            (0, r.Z)(this, "_prevHasUnsavedChanges", !1), (0, r.Z)(this, "eventEmitter", new j.Z(["saveStateChange"])), this._dispatch = e, this._getState = t, n && (this.handlers = new ae(n)), o && (this.eventEmitter = o);
          }
          connect() {
            const e = this._getState();
            if (this._backend = e.backend, !this.handlers) {
              const e = {};
              e.annotation = new N.Nk(this._dispatch, this._getState), e.bookmark = new X(this._dispatch, this._getState), e.formField = new L.fu(this._dispatch, this._getState), e.formFieldValue = new $(this._dispatch, this._getState), e.comment = new ne(this._dispatch, this._getState), this.handlers = new ae(e);
            }
            this.handlers.forEach(e => {
              const t = e.getEventEmitter();
              t && t.supportsEvent("saveStateChange") && t.on("saveStateChange", () => this._onSaveStateChanged());
            });
          }
          save() {
            let e = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
            if (!this.hasUnsavedChanges()) return Promise.resolve();
            const t = this.handlers.map(e => e.manualSave(!1));
            return e && t.push(this._backend.syncChanges().catch(le)), (0, B.jK)(t).then(() => {}).catch(t => {
              const n = e ? t.pop() : null,
                r = t.filter(Boolean).map(e => {
                  if (e instanceof oe.V) return e.reason;
                }).filter(Boolean),
                o = (0, a.aV)(r).flatMap(e => e).toArray();
              throw (0, oe.h)(o, Boolean(n), n ? n.message : null);
            });
          }
          hasUnsavedChanges() {
            return this.handlers.map(e => e.hasUnsavedChanges()).some(Boolean);
          }
          _onSaveStateChanged() {
            const e = this.hasUnsavedChanges();
            this._prevHasUnsavedChanges !== e && (this._prevHasUnsavedChanges = e, this.eventEmitter.emit("saveStateChange", {
              hasUnsavedChanges: e
            }));
          }
          async create(e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
            return this._performChanges(e, (n, r) => n.create(r, t ? e : null));
          }
          async update(e) {
            return this._performChanges(e, (t, n) => t.update(n, e));
          }
          _changesForHandler(e, t) {
            return t.filter(t => this._handlerForChange(t) === e);
          }
          async delete(e) {
            const t = e.map(() => ie("Unsupported change type")),
              n = await (0, B.jK)(e.map(async (e, n) => {
                if (e) {
                  if ("string" == typeof e) {
                    for (const t of this.handlers.toArray()) {
                      const n = await t.getObjectById(e);
                      if (n) return n;
                    }
                    t[n] = ie(`No object with id '${e}' found.`);
                  }
                } else t[n] = ie("The supplied id is not a valid id");
                return e;
              }));
            return this._performChanges(n, (e, t) => e.delete(t), t);
          }
          ensureChangesSaved(e) {
            const t = e.map(e => {
              const t = this._handlerForChange(e);
              return t ? t.ensureChangesSaved(e) : Promise.reject(ie("Unsupported change type"));
            });
            return (0, B.jK)(t);
          }
          async _performChanges(e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : e.map(() => ie("Unsupported change type"));
            const r = [],
              o = this.handlers.map(e => e.lockSave());
            try {
              let n = null;
              (0, i.dC)(() => {
                n = this.handlers.map(async (n, o) => {
                  const i = this._changesForHandler(n, e);
                  if (i.length) try {
                    r[o] = await t(n, i);
                  } catch (e) {
                    r[o] = e;
                  }
                });
              }), n && (await (0, B.jK)(n));
            } finally {
              o.forEach(e => {
                e();
              });
            }
            const a = await this._mapResultsToChanges(e, r, n);
            return a.some(e => e instanceof Error) ? Promise.reject(a) : Promise.resolve(a);
          }
          async _mapResultsToChanges(e, t, n) {
            const r = n;
            for (const [n, o] of this.handlers.map(e => e).entries()) {
              const i = await this._changesForHandler(o, e),
                a = t[n];
              i.length && i.forEach((t, n) => {
                const o = e.findIndex(e => e === t);
                var i;
                a instanceof Error ? r[o] = a : r[o] = null !== (i = a[n]) && void 0 !== i ? i : a;
              });
            }
            return r;
          }
          _handlerForChange(e) {
            switch (!0) {
              case e instanceof y.q6:
                return this.handlers.annotation;
              case e instanceof x.Z:
                return this.handlers.bookmark;
              case e instanceof d.sv:
                return this.handlers.comment;
              case e instanceof d.Wi:
                return this.handlers.formField;
              case e instanceof d.KD:
                return this.handlers.formFieldValue;
              default:
                return null;
            }
          }
        }
        function le(e) {
          throw ie(e), e;
        }
        var ue = n(43069),
          ce = n(69842),
          de = n(76934),
          pe = n(55012),
          he = n(44156);
        const fe = "rollover",
          me = "down";
        var ge = n(33383),
          ve = n(66327),
          ye = n(14935);
        function be(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function we(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? be(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        async function xe(e, t, n) {
          if (n.pageKeys) try {
            e(Ce(t())), await De(e, t, n);
          } finally {
            e(Ce(null));
          } else await De(e, t, n);
        }
        async function De(e, t, n) {
          let {
            attemptedUnlockViaModal: r = !1,
            features: m,
            signatureFeatureAvailability: v,
            hasPassword: y = !1,
            minSearchQueryLength: b,
            allowedTileScales: x,
            pageKeys: D,
            evaluation: E
          } = n;
          const {
            backend: _,
            autoSaveMode: k,
            clientsChangeCallback: A,
            formsEnabled: j
          } = t();
          (0, s.kG)(_);
          const {
              provider: B
            } = _,
            [N, L] = await Promise.all([_.permissions(), _.documentInfo()]),
            V = m && m.includes(H.q.FORMS),
            K = (F.Options.IGNORE_DOCUMENT_PERMISSIONS || L.permissions && (L.permissions.annotationsAndForms || L.permissions.fillForms)) && V && j,
            q = K && (0, I.k_)(_) && m && m.includes(H.q.FORM_DESIGNER),
            U = V && !(0, I.k_)(_) ? await _.getFormJSON() : null;
          if (_.isUsingInstantProvider()) {
            (0, s.kG)("onClientsChange" in B && void 0 !== B.onClientsChange, "provider has no callback `onClientsChange` although it is using instant.");
            const n = B;
            n.onClientsChange(e => {
              A.call(null, e);
            }), n.setDocumentHandleOutdated(t => {
              e((0, f.KY)(t));
            }), n.setFormsEnabledInConfig(j), n.setStateGetter(t);
          } else if ("SERVER" === _.type && U && m && v) {
            if (!(0, I.xW)(m, v)) {
              const e = U.fields.filter(e => "pspdfkit/form-field/signature" === e.type).map(e => e.name);
              U.annotations = U.annotations.filter(t => !e.includes(t.formFieldName)), U.fields = U.fields.filter(t => !e.includes(t.name)), B.setIgnoredFormFieldNames((0, a.aV)(e));
            }
          }
          E && e((0, ve.m9)(E));
          const Z = {
              refreshSignaturesInfo: async () => {
                const {
                  digitalSignatures: n
                } = t();
                m && m.includes(H.q.DIGITAL_SIGNATURES) && n && n && n.status !== ce._.not_signed && !1 === n.documentModifiedSinceSignature && (await _.refreshSignaturesInfo(), e((0, O.Y)(await _.getSignaturesInfo())));
              }
            },
            $ = we(we({}, Z), {}, {
              createAnnotations: (t, n) => {
                n && n.forEach((t, n) => {
                  e((0, h.O)({
                    hash: n,
                    attachment: t
                  }));
                }), e((0, R.pB)(de.j.EXTERNAL, () => {
                  e((0, T.lA)(t));
                }));
              },
              updateAnnotations: t => {
                e((0, R.pB)(de.j.EXTERNAL, () => {
                  e((0, T.Zr)(t));
                }));
              },
              deleteAnnotations: t => {
                e((0, R.pB)(de.j.EXTERNAL, () => {
                  e((0, T.aF)(t));
                }));
              },
              getAnnotationById: e => t().annotations.get(e)
            }),
            G = V && (0, I.k_)(_) ? we(we({}, Z), {}, {
              createFormFields: t => {
                e((0, c.TD)(t));
              },
              updateFormFields: t => {
                e((0, c.C2)(t)), e((0, c.xW)(t.map(e => new d.KD({
                  name: e.name,
                  value: e.value
                }))));
              },
              deleteFormFields: t => {
                e((0, c.PT)(t));
              },
              getFormFieldByName: e => t().formFields.get(e)
            }) : null,
            W = we(we({}, Z), {}, {
              createFormFieldValues: t => e((0, c.zq)(t)),
              setFormFieldValues: t => e((0, c.xW)(t)),
              deleteFormFieldValues: t => e((0, c.HE)(t))
            }),
            Y = (0, I.xr)(_),
            X = Y ? we(we({}, Z), {}, {
              createComments: t => {
                e((0, M.fg)(t));
              },
              updateComments: t => {
                e((0, M.gk)(t));
              },
              deleteComments: t => {
                e((0, M.Vn)(t));
              }
            }) : null,
            Q = we({}, Z),
            J = t(),
            ee = new w(B, $, k, J.annotationManager && J.annotationManager.eventEmitter),
            te = new C(B, Q, k, J.bookmarkManager && J.bookmarkManager.eventEmitter),
            ne = V && G && (0, I.k_)(_) ? new S.c(B, G, k, J.formFieldManager && J.formFieldManager.eventEmitter) : null,
            re = new z(B, W, k, J.formFieldValueManager && J.formFieldValueManager.eventEmitter);
          let oe;
          Y && ((0, s.kG)(null != X), oe = new P(B, X, k, J.commentManager && J.commentManager.eventEmitter));
          const ie = (0, o.Z)(g.xp),
            ae = (0, o.Z)(ue.ET),
            le = {
              getPageContentState: e => {
                const {
                    pages: n,
                    annotations: r,
                    formFields: o
                  } = t(),
                  i = n.get(e);
                return (0, s.kG)(i), {
                  pageSize: i.pageSize,
                  annotations: ie(r, i),
                  formFields: ae(o, i)
                };
              },
              getZoomState: () => t().viewportState.zoomLevel,
              getAnnotationWithFormField: e => {
                const {
                    annotations: n,
                    formFields: r
                  } = t(),
                  o = n.get(e);
                return {
                  annotation: o,
                  formField: o instanceof d.x_ && o.formFieldName ? r.get(o.formFieldName) : null
                };
              },
              getFormFieldWidgets: e => {
                const {
                    annotations: n
                  } = t(),
                  {
                    annotationIds: r
                  } = e;
                return n.filter((t, n) => e.annotationIds.includes(n) || e.annotationIds.includes(String(t.pdfObjectId))).toList().sort((e, t) => r.indexOf(e.id) < r.indexOf(t.id) ? -1 : 1);
              },
              getFormFieldByName: e => t().formFields.get(e),
              isFormDesignerEnabled: () => (0, I.ix)(t()),
              isAnnotationInState: e => t().annotations.has(e),
              isFormFieldInState: e => t().formFields.has(e),
              getAvailableVariants: e => {
                const {
                  APStreamVariantsRollover: n,
                  APStreamVariantsDown: r
                } = t();
                if (null == e.pdfObjectId) return [];
                const o = [];
                return n.has(e.pdfObjectId) && o.push(fe), r.has(e.pdfObjectId) && o.push(me), o;
              }
            },
            pe = {
              createAnnotations: (e, t, n) => {
                ee.backendObjectsCreated(e, n, {
                  attachments: t
                });
              },
              updateAnnotations: ee.backendObjectsUpdated.bind(ee),
              deleteAnnotations: ee.backendObjectsDeleted.bind(ee),
              invalidateAPStreams: t => e((0, T.GI)(t)),
              createAttachment: (t, n) => {
                e((0, h.O)({
                  hash: t,
                  attachment: new d.Pg({
                    data: n
                  })
                }));
              },
              addAnnotationVariants: (t, n) => {
                e((0, T.mw)(t, n));
              },
              applyJavaScriptActionChanges: t => {
                e((0, c.bt)(t));
              },
              setPageTabOrder: (t, n) => {
                e((0, T.N1)(t, n));
              }
            },
            ge = {
              createBookmarks: te.backendObjectsCreated.bind(te),
              updateBookmarks: te.backendObjectsUpdated.bind(te),
              deleteBookmarks: te.backendObjectsDeleted.bind(te)
            },
            be = V && ne instanceof S.c && (0, I.k_)(_) ? {
              createFormFields: ne.backendObjectsCreated.bind(ne),
              updateFormFields: ne.backendObjectsUpdated.bind(ne),
              deleteFormFields: ne.backendObjectsDeleted.bind(ne)
            } : null,
            xe = {
              createFormFieldValues: (e, t) => {
                t === p.y ? V && re.backendObjectsCreated(e, t) : t === p.z && q && re.backendObjectsCreated(e, t);
              },
              setFormFieldValues: e => {
                K && re.backendObjectsUpdated(e);
              },
              deleteFormFieldValues: e => {
                q && re.backendObjectsDeleted(e);
              }
            };
          let De;
          Y && ((0, s.kG)(null != oe), De = {
            createComments: oe.backendObjectsCreated.bind(oe),
            updateComments: oe.backendObjectsUpdated.bind(oe),
            deleteComments: oe.backendObjectsDeleted.bind(oe)
          });
          const Ce = new se(e, t, null, J.changeManager && J.changeManager.eventEmitter),
            Se = {
              attemptedUnlockViaModal: r,
              hasPassword: y,
              features: m,
              signatureFeatureAvailability: v,
              permissions: N,
              documentInfo: L,
              formJSON: U,
              annotationManager: ee,
              bookmarkManager: te,
              formFieldManager: ne,
              formFieldValueManager: re,
              commentManager: oe,
              changeManager: Ce,
              minSearchQueryLength: b,
              documentHandle: _.getDocumentHandle(),
              allowedTileScales: x,
              pageKeys: D
            };
          let Ee = null;
          (0, i.dC)(function () {
            e((0, u.rJ)(Se)), B.setReadStateCallbacks(le), B.setAnnotationCallbacks(pe), B.setBookmarkCallbacks(ge), B.setFormFieldValueCallbacks(xe), Y && ((0, s.kG)(null != De), B.setCommentCallbacks(De)), V && (0, I.k_)(_) && ((0, s.kG)(be), B.setFormFieldCallbacks(be)), Ce.connect(), Ee = B.load();
          });
          try {
            await Ee, await new Promise((t, n) => {
              ("visible" === document.visibilityState ? requestAnimationFrame : setTimeout)(() => {
                _.lazyLoadPages().then(r => {
                  const o = [];
                  r && e((0, he.uM)(r)), V && (0, I.k_)(_) && ne && o.push(ne.loadFormFields()), (0, s.kG)(m, "Features should be defined at this point"), (0, I.xr)(_) && (0, I.LC)({
                    features: m,
                    backend: _
                  }) && oe && o.push(oe.loadComments()), (0, I.YN)({
                    features: m,
                    backend: _
                  }) && o.push(async function (e) {
                    var t;
                    let {
                      backend: n,
                      dispatch: r
                    } = e;
                    const o = await (null === (t = n.getSecondaryMeasurementUnit) || void 0 === t ? void 0 : t.call(n));
                    o && r((0, ye.VO)(o));
                    const i = await n.getMeasurementScales();
                    i && r((0, ve.RN)(i ? (0, l.Ex)(i) : null));
                  }({
                    backend: _,
                    dispatch: e
                  })), o.length > 0 ? Promise.all(o).then(() => t()).catch(n) : t();
                }).catch(e => {
                  n(e);
                });
              });
            });
          } catch (e) {
            throw e;
          }
        }
        function Ce(e) {
          return {
            type: pe.UX$,
            state: e
          };
        }
        function Se(e, t, n, r) {
          let o;
          if ("string" == typeof t) {
            if (n === ge.x.SharePoint) {
              const n = new URL(t, e),
                [r, o] = n.hostname.split(".").reverse();
              if ("sharepoint" !== o || "com" !== r) throw new s.p2(`When using SharePoint, the document URL must be a sharepoint.com URL: it's ${o}.${r} instead.`);
            }
            if (n === ge.x.Salesforce) {
              const t = new URL(e),
                [n, r] = t.hostname.split(".").reverse();
              if ("salesforce" !== r && "force" !== r && "visualforce" !== r || "com" !== n) throw new s.p2(`When using Salesforce, the SDK must be loaded from a Salesforce URL: it's ${r}.${n} instead.`);
            }
            o = fetch(t, {
              credentials: "same-origin"
            }).then(e => e.arrayBuffer()).finally(() => {
              null == r || r();
            });
          } else o = t;
          return o;
        }
      },
      52163: (e, t, n) => {
        "use strict";

        n.d(t, {
          RG: () => u,
          SH: () => f,
          bZ: () => d,
          h6: () => m,
          mr: () => p,
          nN: () => c,
          rh: () => h
        });
        var r = n(35369),
          o = n(15359),
          i = n(44550),
          a = n(84293),
          s = n(81777),
          l = n(79112);
        function u(e) {
          var t;
          return "STANDALONE" === (null === (t = e.backend) || void 0 === t ? void 0 : t.type) && e.features.includes(i.q.DOCUMENT_COMPARISON);
        }
        const c = "You need the document comparison license component to use this feature.",
          d = "The document comparison feature is only available in Standalone mode.",
          p = (e, t) => (0, a.cq)(e.set("currentPageIndex", 0).set("pageSizes", (0, r.aV)([t.pageSize])), s.c.FIT_TO_WIDTH);
        async function h(e) {
          const t = await e;
          if ("string" == typeof t) {
            let e;
            try {
              e = fetch(t).then(e => e.arrayBuffer());
            } catch (e) {
              (0, o.vU)(e);
            }
            return e;
          }
          if (t instanceof ArrayBuffer) return t;
          throw new o.p2("Comparison document source is not a URL nor an ArrayBuffer");
        }
        const f = e => e === l.Q.documentA ? l.Q.documentA : e === l.Q.documentB ? l.Q.documentB : l.Q.result,
          m = [[[0, 0], [0, 0]], [[0, 0], [0, 0]], [[0, 0], [0, 0]]];
      },
      21853: (e, t, n) => {
        "use strict";

        n.d(t, {
          Aw: () => d,
          Cz: () => P,
          N1: () => v,
          PF: () => E,
          Qu: () => p,
          R4: () => f,
          R9: () => h,
          Re: () => A,
          _c: () => S,
          _s: () => x,
          ar: () => m,
          cR: () => D,
          eR: () => g,
          f: () => u,
          fp: () => b,
          gC: () => y,
          o5: () => c,
          sR: () => _
        });
        var r = n(15359),
          o = n(60209),
          i = n(98179),
          a = n(87856),
          s = n(94683),
          l = n.n(s);
        function u(e) {
          return function (e) {
            e && i.vU && e.scrollHeight;
          }(e), function (e) {
            return e.scrollHeight > e.clientHeight;
          }(e) || c(e);
        }
        function c(e) {
          return e.scrollWidth > e.clientWidth;
        }
        function d(e) {
          const t = e ? e.document : document,
            n = t.createElement("iframe"),
            {
              documentElement: o
            } = t;
          return (0, r.kG)(o), n.title = "script", n.dataset.testid = "realm", n.style.position = "absolute", n.style.top = "-10000px", n.style.left = "-10000px", n.style.width = "10000px", n.style.height = "10000px", n.setAttribute("aria-hidden", "true"), o.appendChild(n), {
            window: n.contentWindow,
            remove() {
              o.removeChild(n);
            }
          };
        }
        function p(e) {
          let t;
          if (!e.nodeName) return !1;
          const n = e.nodeName,
            r = e.hasAttribute("tabindex") && parseInt(e.getAttribute("tabindex")),
            o = !isNaN(r) && isFinite(r) && "boolean" != typeof r;
          if (/^(IFRAME|LABEL|DATALIST|INPUT|SELECT|TEXTAREA|BUTTON|OBJECT)$/.test(n)) {
            if (t = !e.disabled, t) {
              const n = e.closest("fieldset");
              n && (t = !n.disabled);
            }
          } else t = "A" === n ? e.href || o : e.hasAttribute("contenteditable") && "true" === e.getAttribute("contenteditable") || o;
          return !!t;
        }
        const h = async e => {
          let {
            buffer: t,
            width: n,
            height: r,
            format: o = (0, a.zP)()
          } = e;
          if ("bitmap" === o) return (async e => {
            let {
              buffer: t,
              width: n,
              height: r
            } = e;
            const o = document.createElement("canvas");
            if (0 === Math.floor(r) || 0 === Math.floor(n)) return null;
            o.width = n, o.height = r;
            const i = new Uint8ClampedArray(t),
              a = o.getContext("2d"),
              s = null == a ? void 0 : a.createImageData(n, r);
            return null == s || s.data.set(i), null == a || a.putImageData(s, 0, 0), f(await S(o));
          })({
            buffer: t,
            width: n,
            height: r
          });
          return f(new Blob([t], {
            type: `image/${o}`
          }));
        };
        function f(e) {
          try {
            return m(URL.createObjectURL(e));
          } catch (e) {
            return null;
          }
        }
        async function m(e) {
          const t = new Image();
          return t.onerror = e => {
            throw new r.p2(`There was an error loading the image: ${e.message}`);
          }, t.src = e, await _(t), new o.Z(t, () => URL.revokeObjectURL(e));
        }
        function g(e) {
          return !(!e || 1 !== e.nodeType) && ("true" === e.contentEditable || "INPUT" === e.nodeName || "TEXTAREA" === e.nodeName);
        }
        function v(e) {
          return !(!e || 1 !== e.nodeType) && Boolean(e.attributes.role && "listbox" === e.attributes.role.value || e.attributes.role && "menu" === e.attributes.role.value);
        }
        function y(e) {
          if (!e || 1 !== e.nodeType) return !1;
          const t = e.getRootNode() || e.ownerDocument,
            n = t.querySelector(".PSPDFKit-Toolbar"),
            r = t.querySelector(".BaselineUI-Toolbar"),
            o = t.querySelector(".PSPDFKit-Annotation-Toolbar");
          return Boolean(n && n.contains(e) || r && r.contains(e) || o && o.contains(e));
        }
        function b(e) {
          return !(!e || 1 !== e.nodeType) && Boolean(e.closest(".PSPDFKit-Toolbar-Responsive-Group"));
        }
        let w = !1;
        {
          let e = document.createElement("div");
          const t = () => {};
          try {
            e.addEventListener("focus", t, !0), e.focus(Object.defineProperty({}, "preventScroll", {
              get: () => {
                w = !0;
              }
            }));
          } catch (e) {
            w = !1;
          } finally {
            e.removeEventListener("focus", t), e = null;
          }
        }
        function x(e, t) {
          w && t.focus({
            preventScroll: !0
          });
        }
        function D(e, t) {
          const n = t.HTMLAnchorElement.prototype.hasOwnProperty("download"),
            r = new Blob([e], {
              type: "application/pdf"
            });
          if ("function" == typeof navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(r, "download.pdf");else if (n) {
            const e = window.URL.createObjectURL(r);
            C(e), t.URL.revokeObjectURL(e);
          } else {
            const e = new FileReader();
            e.onloadend = function () {
              const t = e.result;
              "string" == typeof t && C(t);
            }, e.readAsDataURL(r);
          }
        }
        function C(e) {
          (0, r.kG)(null != document.body);
          const t = document.createElement("a");
          t.href = e, t.style.display = "none", t.download = "download.pdf", t.setAttribute("download", "download.pdf"), document.body && document.body.appendChild(t), t.click(), document.body && document.body.removeChild(t);
        }
        function S(e) {
          return new Promise((t, n) => {
            "toBlob" in e ? e.toBlob(e => {
              t(e);
            }, "image/png") : "msToBlob" in e ? t(null == e ? void 0 : e.msToBlob()) : n(new Error("Exporting HTMLCanvasElement to Blob is not supported in this browser."));
          });
        }
        function E(e) {
          e.preventDefault();
        }
        async function _(e) {
          if (!(e instanceof HTMLImageElement) || "IMG" !== e.nodeName) return;
          try {
            await new Promise((t, n) => {
              e.complete ? t() : (e.onerror = n, e.onload = () => t());
            });
          } catch (e) {
            throw new r.p2(`The image could not be loaded: ${e.message}`);
          }
          const t = e.decode();
          try {
            await t;
          } catch (e) {
            if (!i.i7) throw new r.p2(`The image could not be decoded: ${e.message}`);
            await new Promise(e => setTimeout(e, 200));
          }
        }
        function P(e) {
          var t, n;
          null === (t = e.target) || void 0 === t || t.classList.remove(l().focusedFocusVisible), null === (n = e.target) || void 0 === n || n.removeEventListener("blur", P);
        }
        const k = "HTMLElement";
        function A(e) {
          return function (e, t) {
            if (null === e) return !1;
            let n = e.constructor;
            for (; null !== n;) {
              if (n.name === t) return !0;
              n = n.__proto__;
            }
            return !1;
          }(e, k);
        }
      },
      68944: (e, t, n) => {
        "use strict";

        n.d(t, {
          J8: () => u,
          Kr: () => c,
          SV: () => l,
          oM: () => i,
          zj: () => a
        });
        var r = n(15359),
          o = n(72110);
        function i() {
          return "protocol=5, client=2024.5.0, client-git=21dad822d1";
        }
        function a() {
          return "production";
        }
        const s = new Map();
        function l(e) {
          const t = (0, o.Qk)();
          if (t) return t;
          const n = document.createElement("a");
          n.href = function (e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Error;
            const n = s.get(e);
            if ("string" == typeof n) return n;
            if (e.currentScript) {
              const t = e.currentScript.src;
              return s.set(e, t), t;
            }
            {
              let n;
              try {
                throw new t("PSPDFKit document.currentScript.src detection");
              } catch (e) {
                e.stack && (n = e.stack.match(/(?:file|https?):[^)]+/i));
              }
              (0, r.kG)(n, "Failed to automatically determine baseUrl. Please specify the base url as an option.");
              const o = n[0].split(":").slice(0, -2).join(":");
              return s.set(e, o), o;
            }
          }(e);
          const i = n.pathname.split("/").filter(Boolean).slice(0, -1);
          return [`${n.protocol}/`, n.host, ...i].join("/") + "/";
        }
        function u(e) {
          return e || (0, o.$u)() || window.location.origin;
        }
        function c(e) {
          return "SERVER" === (null == e ? void 0 : e.type);
        }
      },
      18920: (e, t, n) => {
        "use strict";

        function r(e) {
          let t,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              bubbles: !1,
              cancelable: !1
            };
          return "function" == typeof Event ? t = new Event(e, n) : (t = document.createEvent("Event"), t.initEvent(e, Boolean(n.bubbles), Boolean(n.cancelable))), t;
        }
        function o(e) {
          const t = document.createEvent("MouseEvent");
          return t.initEvent(e, !0, !0), t;
        }
        function i(e) {
          let {
            event: t,
            element: n
          } = e;
          const r = n.getRootNode().elementFromPoint(t.clientX, t.clientY);
          return n.contains(r);
        }
        n.d(t, {
          My: () => r,
          _t: () => o,
          pr: () => i
        });
      },
      87856: (e, t, n) => {
        "use strict";

        n.d(t, {
          Gn: () => o,
          Rh: () => s,
          Zy: () => i,
          zP: () => a
        });
        var r = n(98179);
        const o = (() => {
          if ("object" != typeof window) return !1;
          let e = !1;
          const t = Object.defineProperty({}, "passive", {
            get: function () {
              return e = !0, !0;
            }
          });
          try {
            window.addEventListener("test", null, t);
          } catch (e) {}
          return e;
        })();
        let i = !r.G6;
        if (!r.G6) {
          const e = new Image();
          e.onload = () => i = e.width > 0 && e.height > 0, e.onerror = () => i = !1, e.src = "data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==";
        }
        const a = () => "bitmap";
        let s = !1;
        try {
          const e = new FormData();
          e.append("key", "value");
          const t = new Response(e);
          "formData" in t && !fetch.polyfill && t.formData().then(() => {
            s = !0;
          }).catch(() => {
            s = !1;
          });
        } catch (e) {
          s = !1;
        }
      },
      80567: (e, t, n) => {
        "use strict";

        n.d(t, {
          eE: () => p,
          GE: () => h,
          f3: () => g,
          wn: () => m,
          x6: () => f,
          vt: () => d
        });
        var r = n(35369),
          o = n(15359),
          i = n(69867);
        const a = {
            Arial: {
              A: 6.70421875,
              B: 5.4102734375,
              C: 6.333125,
              D: 5.92296875,
              E: 5.346796875,
              F: 4.8341015625,
              G: 6.62609375,
              H: 5.620234375,
              I: .952265625,
              J: 3.960078125,
              K: 5.92296875,
              L: 4.47765625,
              M: 6.8360546875,
              N: 5.6446484375,
              O: 6.850703125,
              P: 5.4688671875,
              Q: 6.987421875,
              R: 6.31359375,
              S: 5.7032421875,
              T: 5.678828125,
              U: 5.6348828125,
              V: 6.5528515625,
              W: 9.2091015625,
              X: 6.5675,
              Y: 6.5675,
              Z: 5.6641796875,
              a: 4.780390625,
              b: 4.5020703125,
              c: 4.5216015625,
              d: 4.5020703125,
              e: 4.7852734375,
              f: 3.0372265625,
              g: 4.5753125,
              h: 4.2286328125,
              i: .88390625,
              j: 1.9971875000000001,
              k: 4.301875,
              l: .88390625,
              m: 7.0313671875,
              n: 4.2188671875,
              o: 4.8633984375,
              p: 4.506953125,
              q: 4.4971875,
              r: 2.8223828125,
              s: 4.311640625,
              t: 2.534296875,
              u: 4.2091015625,
              v: 4.760859375,
              w: 7.1192578125,
              x: 4.858515625,
              y: 4.7559765625,
              z: 4.59484375
            },
            Verdana: {
              A: 6.58703125,
              B: 5.4883984375,
              C: 6.0352734375,
              D: 6.147578125,
              E: 4.7950390625,
              F: 4.6485546875,
              G: 6.4844921875,
              H: 5.5665234375,
              I: 2.87609375,
              J: 3.432734375,
              K: 5.8253125,
              L: 4.604609375,
              M: 6.479609375,
              N: 5.551875,
              O: 6.7579296875,
              P: 4.760859375,
              Q: 6.9044140625,
              R: 6.020625,
              S: 5.61046875,
              T: 6.167109375,
              U: 5.5860546875,
              V: 6.58703125,
              W: 8.9942578125,
              X: 6.19640625,
              Y: 6.09875,
              Z: 5.678828125,
              a: 4.6387890625,
              b: 4.8048046875,
              c: 4.428828125,
              d: 4.8048046875,
              e: 4.956171875,
              f: 3.510859375,
              g: 4.8048046875,
              h: 4.565546875,
              i: 1.0401562500000001,
              j: 2.9102734375,
              k: 4.917109375,
              l: .92296875,
              m: 7.963984375,
              n: 4.565546875,
              o: 5.0391796875,
              p: 4.8048046875,
              q: 4.8048046875,
              r: 3.4083203125,
              s: 4.2676953125,
              t: 3.4376171875,
              u: 4.565546875,
              v: 5.327265625,
              w: 7.34875,
              x: 5.33703125,
              y: 5.327265625,
              z: 4.409296875
            },
            Tahoma: {
              A: 6.09875,
              B: 4.936640625,
              C: 5.522578125,
              D: 5.737421875,
              E: 4.5508984375,
              F: 4.3555859375,
              G: 5.8790234375,
              H: 5.2833203125,
              I: 2.827265625,
              J: 3.4376171875,
              K: 5.3028515625,
              L: 4.2188671875,
              M: 6.23546875,
              N: 5.2051953125,
              O: 6.4356640625,
              P: 4.59484375,
              Q: 6.460078125,
              R: 5.6348828125,
              S: 4.9512890625,
              T: 5.854609375,
              U: 5.2637890625,
              V: 6.049921875,
              W: 8.7696484375,
              X: 5.7325390625,
              Y: 5.88390625,
              Z: 5.083125,
              a: 4.3458203125,
              b: 4.5801953125,
              c: 4.1602734375,
              d: 4.5801953125,
              e: 4.7169140625,
              f: 3.3985546875,
              g: 4.5801953125,
              h: 4.292109375,
              i: 1.0499218750000001,
              j: 2.60265625,
              k: 4.526484375,
              l: .92296875,
              m: 7.114375,
              n: 4.292109375,
              o: 4.878046875,
              p: 4.5801953125,
              q: 4.5801953125,
              r: 2.895625,
              s: 3.9503125,
              t: 3.2325390625,
              u: 4.292109375,
              v: 4.926875,
              w: 7.13390625,
              x: 4.858515625,
              y: 4.926875,
              z: 4.0137890625
            },
            "Trebuchet MS": {
              A: 5.864375,
              B: 4.5411328125,
              C: 5.2051953125,
              D: 5.014765625,
              E: 4.2774609375,
              F: 4.4239453125,
              G: 5.6446484375,
              H: 5.083125,
              I: .9815625,
              J: 3.7989453125,
              K: 5.0294140625,
              L: 4.213984375,
              M: 6.9532421875,
              N: 4.9219921875,
              O: 5.96203125,
              P: 4.458125,
              Q: 7.03625,
              R: 5.0440625,
              S: 4.0284375,
              T: 5.6348828125,
              U: 5.02453125,
              V: 5.7520703125,
              W: 8.3985546875,
              X: 5.444453125,
              Y: 5.581171875,
              Z: 4.5313671875,
              a: 4.47765625,
              b: 4.5508984375,
              c: 4.32140625,
              d: 4.5411328125,
              e: 4.8243359375,
              f: 3.432734375,
              g: 4.3409375,
              h: 4.155390625,
              i: 1.8067578125000001,
              j: 2.5977734375,
              k: 4.389765625,
              l: 1.8067578125000001,
              m: 6.987421875,
              n: 4.1505078125,
              o: 4.7364453125,
              p: 4.5606640625,
              q: 4.5753125,
              r: 3.159296875,
              s: 3.4180859375,
              t: 3.3497265625,
              u: 4.253046875,
              v: 4.7852734375,
              w: 7.299921875,
              x: 4.897578125,
              y: 4.819453125,
              z: 4.36046875
            },
            "Times New Roman": {
              A: 7.03625,
              B: 5.96203125,
              C: 5.9669140625,
              D: 6.674921875,
              E: 5.678828125,
              F: 4.995234375,
              G: 6.733515625,
              H: 6.850703125,
              I: 2.8419140625,
              J: 3.6329296875,
              K: 7.143671875,
              L: 5.698359375,
              M: 8.520625,
              N: 7.2169140625,
              O: 6.489375,
              P: 5.0489453125,
              Q: 6.4942578125,
              R: 6.5919140625,
              S: 4.4044140625,
              T: 5.561640625,
              U: 7.065546875,
              V: 7.01671875,
              W: 9.233515625,
              X: 7.03625,
              Y: 6.987421875,
              Z: 5.708125,
              a: 4.0675,
              b: 4.682734375,
              c: 3.77453125,
              d: 4.6973828125,
              e: 3.7891796875,
              f: 3.9649609375,
              g: 4.526484375,
              h: 4.878046875,
              i: 2.2462109375,
              j: 2.71984375,
              k: 4.9805859375,
              l: 2.280390625,
              m: 7.6563671875,
              n: 4.9024609375,
              o: 4.32140625,
              p: 4.6973828125,
              q: 4.67296875,
              r: 3.335078125,
              s: 3.0567578125,
              t: 2.7003125,
              u: 4.9805859375,
              v: 4.82921875,
              w: 7.0704296875,
              x: 4.75109375,
              y: 4.8878125,
              z: 4.0821484375
            },
            Georgia: {
              A: 7.143671875,
              B: 5.6348828125,
              C: 5.9180859375,
              D: 6.6602734375,
              E: 5.8887890625,
              F: 5.4395703125,
              G: 6.8067578125,
              H: 7.1778515625,
              I: 3.1251171875,
              J: 4.8633984375,
              K: 6.7091015625,
              L: 5.5665234375,
              M: 8.588984375,
              N: 7.475703125,
              O: 6.66515625,
              P: 5.3419140625,
              Q: 6.66515625,
              R: 6.753046875,
              S: 4.7657421875,
              T: 6.04015625,
              U: 7.1290234375,
              V: 7.0606640625,
              W: 9.926875,
              X: 7.05578125,
              Y: 6.635859375,
              Z: 5.8008984375,
              a: 4.526484375,
              b: 5.3223828125,
              c: 4.1700390625,
              d: 5.2784375,
              e: 4.28234375,
              f: 3.823359375,
              g: 4.6973828125,
              h: 5.5567578125,
              i: 2.48546875,
              j: 2.9200390625,
              k: 5.4298046875,
              l: 2.60265625,
              m: 8.3253125,
              n: 5.37609375,
              o: 4.7071484375,
              p: 5.2003125,
              q: 5.288203125,
              r: 3.745234375,
              s: 3.5938671875,
              t: 3.26671875,
              u: 5.346796875,
              v: 5.2051953125,
              w: 7.553828125,
              x: 4.936640625,
              y: 5.1661328125,
              z: 3.901484375
            },
            "Courier New": {
              A: 5.854609375,
              B: 5.014765625,
              C: 4.7559765625,
              D: 4.8096875,
              E: 4.8048046875,
              F: 4.7950390625,
              G: 5.0294140625,
              H: 5.02453125,
              I: 3.77453125,
              J: 5.02453125,
              K: 5.3175,
              L: 4.8096875,
              M: 5.8253125,
              N: 5.4102734375,
              O: 5.005,
              P: 4.5753125,
              Q: 5.005,
              R: 5.503046875,
              S: 4.1993359375,
              T: 4.5997265625,
              U: 5.2051953125,
              V: 5.854609375,
              W: 5.6251171875,
              X: 5.239375,
              Y: 5.0294140625,
              Z: 3.9551953125,
              a: 4.721796875,
              b: 5.210078125,
              c: 4.53625,
              d: 5.2247265625,
              e: 4.6094921875,
              f: 4.3946484375,
              g: 5.0098828125,
              h: 5.1221875,
              i: 4.1895703125,
              j: 3.14953125,
              k: 4.79015625,
              l: 4.1895703125,
              m: 5.835078125,
              n: 4.9024609375,
              o: 4.5899609375,
              p: 5.210078125,
              q: 5.210078125,
              r: 4.6094921875,
              s: 3.9844921875,
              t: 4.5801953125,
              u: 4.995234375,
              v: 5.4298046875,
              w: 5.45421875,
              x: 5.0294140625,
              y: 5.0196484375,
              z: 3.7598828125
            },
            "Brush Script MT": {
              A: 7.905390625,
              B: 6.284296875,
              C: 6.264765625,
              D: 6.5235546875,
              E: 6.1817578125,
              F: 6.19640625,
              G: 6.1329296875,
              H: 7.5684765625,
              I: 4.116328125,
              J: 4.897578125,
              K: 7.44640625,
              L: 6.8165234375,
              M: 9.51671875,
              N: 6.9630078125,
              O: 5.083125,
              P: 6.323359375,
              Q: 6.4258984375,
              R: 7.17296875,
              S: 6.8067578125,
              T: 5.84484375,
              U: 7.2755078125,
              V: 6.2305859375,
              W: 8.22765625,
              X: 6.1719921875,
              Y: 6.245234375,
              Z: 5.405390625,
              a: 4.155390625,
              b: 3.9356640625,
              c: 3.003046875,
              d: 4.7559765625,
              e: 2.963984375,
              f: 3.4669140625,
              g: 3.9356640625,
              h: 3.9844921875,
              i: 2.6758984375,
              j: 3.8575390625,
              k: 3.9161328125,
              l: 2.866328125,
              m: 5.6348828125,
              n: 3.73546875,
              o: 3.1934765625,
              p: 4.8341015625,
              q: 3.833125,
              r: 2.99328125,
              s: 3.1641796875,
              t: 3.1934765625,
              u: 3.9454296875,
              v: 3.3253125,
              w: 5.005,
              x: 3.2130078125,
              y: 3.833125,
              z: 3.745234375
            }
          },
          s = (0, r.hU)(["Helvetica", "Arial", "Calibri", "Century Gothic", "Consolas", "Courier", "Dejavu Sans", "Dejavu Serif", "Georgia", "Gill Sans", "Impact", "Lucida Sans", "Myriad Pro", "Open Sans", "Palatino", "Tahoma", "Times New Roman", "Trebuchet", "Verdana", "Zapfino", "Comic Sans"]),
          l = (0, r.hU)(["sans-serif", "serif", "monospace"]);
        let u = new Set();
        const c = (0, r.aV)(["mmmBESbswy"]);
        l.forEach(e => {
          const t = s.filterNot(e => u.has(e)),
            n = new i.f(document, c, {
              fontFamily: e
            }),
            r = t.map(t => [t, new i.f(document, c, {
              fontFamily: `${t},${e}`
            })]),
            a = n.measure().first();
          (0, o.kG)(a), r.forEach(e => {
            let [t, n] = e;
            const r = n.measure().first();
            a.equals(r) || (u = u.add(t));
          }), n.remove(), r.forEach(e => {
            let [, t] = e;
            t.remove();
          });
        });
        const d = s.filter(e => u.has(e)),
          p = [{
            name: "Caveat",
            file: "Caveat-Bold",
            weight: 700
          }, {
            name: "Marck Script",
            file: "MarckScript-Regular",
            weight: 400
          }, {
            name: "Meddon",
            file: "Meddon-Regular",
            weight: 400
          }, {
            name: "Pacifico",
            file: "Pacifico-Regular",
            weight: 400
          }];
        function h(e, t) {
          e.forEach(e => {
            t.load(`16px ${e.name}`);
          });
        }
        function f(e) {
          return Promise.allSettled(e.map(e => new Promise((t, n) => {
            var r, i;
            if ((0, o.kG)(e.name), i = e.name, !/\.[^.]*$/.test(i)) return (0, o.vU)(`The font name for font "${e.name}" must have a file extension.`), void n();
            null == e || null === (r = e.callback) || void 0 === r || r.call(e, e.name).then(r => {
              (0, o.kG)(e.name), r instanceof Blob ? t({
                name: e.name,
                data: r
              }) : ((0, o.vU)(`Callback for retrieving font ${e.name} didn't returned a Blob. It returned ${typeof r}`), n());
            }).catch(t => {
              (0, o.vU)(`Error returned by callback for retrieving font ${e.name}. ${t}`), n();
            });
          }))).then(e => e.filter(e => "fulfilled" === e.status).map(e => e.value));
        }
        function m(e) {
          const t = Object.keys(a);
          let n = null,
            r = 1 / 0;
          for (const o of t) {
            const t = a[o];
            let i = 0;
            for (const n of e) {
              const e = t[n.glyph];
              void 0 !== e && (i += Math.abs(e - n.width));
            }
            i < r && (n = o, r = i);
          }
          return n;
        }
        function g(e) {
          if (!e) return [];
          const t = e.glyphs,
            n = [];
          for (let e = 0; e < t.length; e += 3) {
            const r = t[e],
              o = t[e + 2],
              i = t[e + 1];
            n.push({
              glyph: r,
              width: 10 * o / i
            });
          }
          return n;
        }
      },
      43069: (e, t, n) => {
        "use strict";

        n.d(t, {
          $Y: () => L,
          AM: () => F,
          Ay: () => M,
          BT: () => y,
          CH: () => R,
          CK: () => N,
          CL: () => P,
          ET: () => k,
          G8: () => C,
          Qg: () => v,
          U_: () => b,
          VY: () => D,
          as: () => K,
          fF: () => j,
          g6: () => O,
          gE: () => z,
          hT: () => w,
          i2: () => S,
          l_: () => x,
          o6: () => B,
          r_: () => T,
          sC: () => A,
          sh: () => V
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(1858),
          s = n(45249),
          l = n(690),
          u = n(72251),
          c = n(87996),
          d = n(33427),
          p = n(48625),
          h = n(82197),
          f = n(20388);
        function m(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function g(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? m(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function v(e) {
          return e.map(e => new s.KD({
            name: e.name,
            value: "string" == typeof e.value ? e.value : e.values,
            optionIndexes: e.optionIndexes
          })).toList();
        }
        function y(e, t) {
          var n;
          return e && t ? e instanceof a.Dz || e instanceof a.rF ? e.values.size > 0 ? e.values.equals(t.values) : 0 === t.values.size : (e.value === t.value || "function" == typeof (null === (n = e.value) || void 0 === n ? void 0 : n.equals) && e.value.equals(t.value)) && (!e.optionIndexes || !t.optionIndexes || e.optionIndexes.every((e, n) => t.optionIndexes[n] === e)) : !e && !t;
        }
        function b(e) {
          return (0, o.D5)(e.map(e => {
            (0, i.kG)(null == e.pdfObjectId || "number" == typeof e.pdfObjectId, "Invalid type for `pdfObjectId`.");
            try {
              (0, i.kG)(Array.isArray(e.annotationIds), "Invalid type for `annotationIds`."), (0, i.kG)("string" == typeof e.name, "Invalid type for `name`."), (0, i.kG)("string" == typeof e.label, "Invalid type for `label`.");
              const t = Array.isArray(e.flags) ? e.flags : [],
                n = {
                  pdfObjectId: e.pdfObjectId,
                  annotationIds: (0, o.aV)(e.annotationIds),
                  name: e.name,
                  label: e.label,
                  readOnly: t.includes("readOnly"),
                  required: t.includes("required"),
                  noExport: t.includes("noExport")
                };
              switch (e.type) {
                case "pspdfkit/form-field/button":
                  return function (e) {
                    return new a.R0(g({}, e));
                  }(n);
                case "pspdfkit/form-field/radio":
                  return function (e, t) {
                    return (0, i.kG)(t.options instanceof Array, "Invalid type for `options`."), (0, i.kG)("string" == typeof t.defaultValue, "Invalid type for `defaultValue`."), (0, i.kG)("boolean" == typeof t.noToggleToOff, "Invalid type for `noToggleToOff`."), (0, i.kG)("boolean" == typeof t.radiosInUnison, "Invalid type for `radiosInUnison`."), new a.XQ(g(g({}, e), {}, {
                      options: _(t.options),
                      defaultValue: t.defaultValue,
                      noToggleToOff: t.noToggleToOff,
                      radiosInUnison: t.radiosInUnison
                    }));
                  }(n, e);
                case "pspdfkit/form-field/checkbox":
                  return function (e, t) {
                    return (0, i.kG)(t.options instanceof Array, "Invalid type for `options`."), (0, i.kG)(t.defaultValues instanceof Array, "Invalid type for `defaultValue`."), new a.rF(g(g({}, e), {}, {
                      options: _(t.options),
                      defaultValues: (0, o.aV)(t.defaultValues)
                    }));
                  }(n, e);
                case "pspdfkit/form-field/combobox":
                case "pspdfkit/form-field/listbox":
                  return function (e, t) {
                    (0, i.kG)(t.options instanceof Array, "Invalid type for `options`."), (0, i.kG)("boolean" == typeof t.multiSelect, "Invalid type for `multiSelect`."), (0, i.kG)("boolean" == typeof t.commitOnChange, "Invalid type for `commitOnChange`."), (0, i.kG)(!t.defaultValues || Array.isArray(t.defaultValues), "Invalid type for `defaultValue`.");
                    const n = g(g({}, e), {}, {
                      options: _(t.options),
                      multiSelect: t.multiSelect,
                      commitOnChange: t.commitOnChange,
                      defaultValues: t.defaultValues ? (0, o.aV)(t.defaultValues) : (0, o.aV)()
                    });
                    switch (t.type) {
                      case "pspdfkit/form-field/combobox":
                        {
                          const e = t;
                          return (0, i.kG)("boolean" == typeof e.edit, "Invalid type for `edit`."), (0, i.kG)("boolean" == typeof e.doNotSpellcheck || "boolean" == typeof e.doNotSpellCheck, "Invalid type for `doNotSpellCheck`."), new a.fB(g(g({}, n), {}, {
                            edit: e.edit,
                            doNotSpellCheck: e.doNotSpellCheck || e.doNotSpellcheck
                          }));
                        }
                      case "pspdfkit/form-field/listbox":
                        return new a.Vi(n);
                      default:
                        throw new Error("Unknown choice field type");
                    }
                  }(n, e);
                case "pspdfkit/form-field/text":
                  return function (e, t) {
                    return (0, i.kG)("boolean" == typeof t.doNotSpellcheck || "boolean" == typeof t.doNotSpellCheck, "Invalid type for `doNotSpellCheck`."), (0, i.kG)("boolean" == typeof t.doNotScroll, "Invalid type for `doNotScroll`."), (0, i.kG)("boolean" == typeof t.password, "Invalid type for `password`."), (0, i.kG)("boolean" == typeof t.multiLine, "Invalid type for `multiLine`."), (0, i.kG)("string" == typeof t.defaultValue || !t.defaultValue, "Invalid type for `defaultValue`."), (0, i.kG)(!0 !== t.comb || "number" == typeof t.maxLength, "Invalid type for `comb`. When `comb` is set, the text field must have a `maxLength`."), new a.$o(g(g({}, e), {}, {
                      defaultValue: t.defaultValue,
                      doNotSpellCheck: t.doNotSpellCheck || t.doNotSpellcheck,
                      doNotScroll: t.doNotScroll,
                      password: t.password,
                      maxLength: "number" == typeof t.maxLength ? t.maxLength : null,
                      multiLine: t.multiLine,
                      comb: t.comb
                    }));
                  }(n, e);
                case "pspdfkit/form-field/signature":
                  return function (e) {
                    return new a.Yo(g({}, e));
                  }(n);
                default:
                  throw new Error(`Unsupported form field type: ${e.type}`);
              }
            } catch (t) {
              return (0, i.um)(`Skipped parsing form field #${e.name} from payload because an error occurred while deserializing.`), void (0, i.um)(t);
            }
          }).filter(Boolean).map(e => [null == e ? void 0 : e.name, e]));
        }
        function w(e) {
          return e.map(e => u.Z.fromJSON(e.pdfObjectId ? e.pdfObjectId.toString() : e.id, e));
        }
        function x(e, t) {
          const n = e.annotationIds.findIndex((0, d.oF)(t)),
            r = e.options.get(n);
          return (0, i.kG)(r, `There is no FormOption defined for annotationId '${t.id}' in formField '${e.name}'.`), r.value;
        }
        function D(e, t) {
          let {
            rotation: n,
            boundingBox: r
          } = e;
          if (!n) return {};
          const o = 90 === (0, h.Lv)(n) || 270 === (0, h.Lv)(n),
            i = {},
            a = Math.ceil(r.height * t),
            s = Math.ceil(r.width * t);
          return o && (i.width = a, i.height = s), n && (i.transformOrigin = "50% 50%", i.transform = C({
            width: s,
            height: a,
            rotation: n
          })), i;
        }
        function C(e) {
          let {
            width: t,
            height: n,
            rotation: r,
            reverse: o = !1
          } = e;
          const i = 90 === (0, h.Lv)(r) || 270 === (0, h.Lv)(r);
          return o ? `rotate(${r}deg)` + (i && t && n ? `translate(${-Math.round(t / 2 - n / 2)}px, ${Math.round(t / 2 - n / 2)}px)` : "") : (i && t && n ? `translate(${Math.round(t / 2 - n / 2)}px, ${-Math.round(t / 2 - n / 2)}px) ` : "") + `rotate(${-r}deg)`;
        }
        function S(e, t) {
          let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
          const {
              fontColor: r,
              font: o,
              backgroundColor: i,
              borderColor: a,
              horizontalAlign: s,
              borderWidth: l,
              borderStyle: u,
              isBold: c,
              isItalic: d,
              boundingBox: {
                width: p,
                height: h
              },
              opacity: m
            } = e,
            v = Math.ceil(p * t),
            y = Math.ceil(h * t);
          return g(g({
            color: null == r ? void 0 : r.toCSSValue(),
            backgroundColor: null == i ? void 0 : i.toCSSValue(),
            borderColor: (null == a ? void 0 : a.toCSSValue()) || "transparent",
            opacity: m,
            textAlign: s || void 0,
            fontWeight: c ? "bold" : void 0,
            fontStyle: d ? "italic" : void 0
          }, "string" == typeof o ? {
            fontFamily: (0, f.hm)(o)
          } : null), {}, {
            borderWidth: l || 0,
            borderStyle: null != u ? E[u] : "none",
            width: v,
            height: y
          }, n ? D(e, t) : {});
        }
        const E = {
          solid: "solid",
          dashed: "dashed",
          beveled: "groove",
          inset: "inset",
          underline: "none none solid"
        };
        function _(e) {
          return (0, o.aV)(e.map(e => new s.mv(e)));
        }
        function P(e, t) {
          return e.formFields.find(e => e.id === t);
        }
        function k(e, t) {
          return e.filter(e => e.annotationIds.some(e => t.annotationIds.has(e))).toList();
        }
        function A(e, t, n) {
          var r, o, i, a;
          return "STANDALONE" === e.type && c.Options.PDF_JAVASCRIPT && "function" == typeof e.onKeystrokeEvent && (Boolean(null === (r = t.additionalActions) || void 0 === r ? void 0 : r.onInput) || Boolean(null === (o = n.additionalActions) || void 0 === o ? void 0 : o.onInput) || Boolean(null === (i = t.additionalActions) || void 0 === i ? void 0 : i.onChange) || Boolean(null === (a = n.additionalActions) || void 0 === a ? void 0 : a.onChange));
        }
        function z(e, t) {
          if (0 === e.length) return t;
          if (0 === t.length) return e;
          const n = [],
            r = t.slice(0);
          return e.forEach(e => {
            if ((e.change_type === l.uV || e.change_type === l.zR) && "pspdfkit/form-field-value" === e.object.type) {
              const t = r.findIndex(t => "pspdfkit/form-field-value" === t.object.type && t.object.type === e.object.type && t.object.name === e.object.name);
              if (t > -1) {
                const n = r[t];
                e.object.formattedValue = n.object.formattedValue, e.object.editingValue = n.object.editingValue, r.splice(t, 1);
              }
            }
            n.push(e);
          }), n.concat(r);
        }
        function T(e, t, n) {
          const r = e && n.formFields.get(e.name);
          if (e && r && !y(e, r)) {
            e.annotationIds.reduce((e, n) => {
              var r;
              const i = t.annotations.get(n) || t.annotations.find(e => e.pdfObjectId === parseInt(n));
              if (i && null !== (r = t.isAPStreamRendered) && void 0 !== r && r.call(t, i)) {
                return e.get(i.pageIndex) ? e.updateIn([i.pageIndex], e => e.add(i.id)) : e.set(i.pageIndex, (0, o.l4)([i.id]));
              }
              return e;
            }, (0, o.D5)()).forEach((e, n) => {
              var r;
              null === (r = t.backend) || void 0 === r || r.clearPageAPStreams(n, e);
            });
          }
        }
        function O(e, t, n) {
          const r = e.annotationIds.findIndex((0, d.oF)(t)),
            i = x(e, t),
            a = e.options.filter(e => e.value === i).size;
          let s;
          if (n) {
            if (a < 2) return;
            s = (e.optionIndexes || (0, o.aV)()).push(r);
          } else {
            if (!e.optionIndexes) return;
            s = e.optionIndexes.filter(e => e !== r);
          }
          return s.size > 0 ? s : void 0;
        }
        function I(e, t) {
          const n = t.filter(t => {
            var n;
            const r = null === (n = e.options.get(t)) || void 0 === n ? void 0 : n.value;
            return e.options.filter(e => e.value === r).size > 1;
          });
          return n.size > 0 ? n : void 0;
        }
        function F(e) {
          let {
            state: t,
            mutableState: n,
            formFieldValues: r,
            areFormFieldValuesNew: s
          } = e;
          r.forEach(e => {
            let {
              name: r,
              value: l,
              optionIndexes: u
            } = e;
            const c = t.formFields.get(r);
            if (c) {
              if ((0, i.kG)(!u || c instanceof a.XQ || c instanceof a.rF, "`optionIndexes` property is only supported in radio and checkbox form field values."), c instanceof a.$o) l = l || "", (0, i.kG)("string" == typeof l, `The type of action value for a TextFormField is ${typeof l}, but has to be a string`), n.setIn(["formFields", r, "value"], l);else if (c instanceof a.XQ) {
                if ((0, i.kG)("string" == typeof l || null === l, `The type of action value for a RadioButtonFormField is ${typeof l}, but has to either be a string or null`), n.setIn(["formFields", r, "value"], l), u) {
                  const e = I(c, u);
                  e && n.setIn(["formFields", r, "optionIndexes"], e);
                }
              } else if (c instanceof a.Dz || c instanceof a.rF) {
                if (l = l || (0, o.aV)(), (0, i.kG)(l instanceof o.aV, `The type of action value for the ${c instanceof a.Dz ? "ChoiceFormField" : "CheckBoxFormField"} is ${typeof l}, but has to be a List of strings`), n.setIn(["formFields", r, "values"], l), c instanceof a.rF && u) {
                  const e = I(c, u);
                  e && n.setIn(["formFields", r, "optionIndexes"], e);
                }
              } else c instanceof a.R0 || c instanceof a.Yo || (0, i.kG)(!1, `Cannot set form field value for ${c.name}: unknown form field type`);
              s || T(c, t, n);
            } else (0, i.ZK)(`No form field found with name ${r}`);
          });
        }
        function M(e) {
          let {
            getState: t,
            originalFormFields: n,
            formFieldValues: r,
            callback: a,
            resolve: s
          } = e;
          const {
              formFields: l,
              annotations: u,
              backend: c
            } = t(),
            d = [],
            p = [];
          n.forEach((e, t) => {
            if (!e) return;
            (0, i.kG)(c);
            let n = l.get(t);
            if ((0, i.kG)(n), r.some(e => e.name === t && (n = o.aV.isList(e.value) ? n.set("values", e.value) : n.set("value", e.value), !0)), y(e, n)) p.push(t);else {
              u.filter(e => e.points === t).reduce((e, t) => {
                const n = e.get(t.pageIndex);
                return n ? e.set(t.pageIndex, n.add(t.id)) : e.set(t.pageIndex, (0, o.l4)([t.id]));
              }, (0, o.D5)()).forEach((e, t) => {
                d.push({
                  pageIndex: t,
                  pageWidgetIds: e
                });
              });
            }
          }), a(p), d.forEach(e => {
            let {
              pageIndex: t,
              pageWidgetIds: n
            } = e;
            null == c || c.clearPageAPStreams(t, n);
          }), null == s || s();
        }
        function R(e) {
          return new s.KD(g({
            name: e.name,
            value: e.values || e.value
          }, e.optionIndexes ? {
            optionIndexes: e.optionIndexes
          } : null));
        }
        function j(e) {
          return e === p.A.CHECKBOX_WIDGET || e === p.A.RADIO_BUTTON_WIDGET || e === p.A.SIGNATURE_WIDGET || e === p.A.TEXT_WIDGET || e === p.A.BUTTON_WIDGET || e === p.A.COMBO_BOX_WIDGET || e === p.A.LIST_BOX_WIDGET || e === p.A.FORM_CREATOR || e === p.A.DATE_WIDGET;
        }
        function B(e) {
          return j(e) && e !== p.A.FORM_CREATOR;
        }
        function N(e, t) {
          const n = x(e, t),
            r = !e.optionIndexes || e.optionIndexes.includes(e.annotationIds.findIndex((0, d.oF)(t)));
          return e instanceof a.XQ ? e.value === n && r : e instanceof a.rF ? e.values.includes(n) && r : (0, i.Rz)(e);
        }
        const L = "Invalid date/time: please ensure that the date/time exists. Field [",
          V = "The value entered does not match the format of the field [",
          K = "format ";
      },
      21713: (e, t, n) => {
        "use strict";

        function r(e) {
          return e.some(e => e instanceof Error) ? Promise.reject(e) : Promise.resolve(e);
        }
        n.d(t, {
          s: () => r
        });
      },
      48338: (e, t, n) => {
        "use strict";

        n.d(t, {
          FA: () => g,
          GW: () => y,
          WF: () => b,
          Yr: () => w,
          _d: () => v,
          ax: () => x,
          kM: () => m,
          mZ: () => D
        });
        var r = n(96156),
          o = n(15359),
          i = n(35369),
          a = n(23951),
          s = n(45249),
          l = n(76934),
          u = n(33427),
          c = n(35727),
          d = n(4715),
          p = n(2891);
        function h(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function f(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? h(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function m(e, t) {
          return "create" === e.type ? null : "update" === e.type || "delete" === e.type ? t.get(e.payload.id) : void (0, o.Rz)(e.type);
        }
        function g(e, t, n) {
          if ("create" === e.type) return e.payload;
          if ("update" === e.type) {
            const r = t.get(e.payload.id) || n && t.get(n) || e.deletedAnnotation;
            return (0, o.kG)(r instanceof a.Z), r.merge(e.payload);
          }
          if ("delete" === e.type) return null;
          (0, o.Rz)(e.type);
        }
        function v(e, t) {
          if (e.isHistoryEnabled) {
            let n = !0;
            if (e.eventEmitter.emit("history.willChange", {
              annotation: t,
              type: "create",
              preventDefault() {
                n = !1;
              }
            }), !n) return;
          }
          e.historyChangeContext === l.j.DEFAULT && e.isHistoryEnabled && (e.update("undoActions", e => e.push({
            type: "delete",
            payload: {
              id: t.id
            }
          })), e.update("redoActions", e => e.clear()));
        }
        function y(e, t, n, r) {
          if (e.isHistoryEnabled) {
            let t = !0;
            if (e.eventEmitter.emit("history.willChange", {
              annotation: n,
              type: "update",
              preventDefault() {
                t = !1;
              }
            }), !t) return;
          }
          if (!t.set("updatedAt", null).equals(n.set("updatedAt", null))) if (e.historyChangeContext === l.j.DEFAULT && e.isHistoryEnabled && function (e, t) {
            if (e instanceof s.gd && !e.text) return !(!t || !("text" in t)) && !!t.text.value;
            if (e instanceof s.Jn && !e.isCommentThreadRoot) return !!t && t.isCommentThreadRoot;
            if ("number" != typeof e.pageIndex && "number" != typeof t.pageIndex) return !1;
            return !0;
          }(n, t)) {
            const o = "number" != typeof t.pageIndex && "number" == typeof n.pageIndex || t instanceof s.gd && null == t.text || t instanceof s.Jn && !t.isCommentThreadRoot && n.isCommentThreadRoot ? {
              type: "delete",
              payload: {
                id: t.id
              }
            } : {
              type: "update",
              payload: D(n, t),
              restoreAPStream: r,
              deletedAnnotation: null
            };
            if ("update" === o.type && t instanceof s.gd && (0, u.Ie)(t) && !(0, u.vM)(t)) return;
            e.update("undoActions", e => e.push(o)), e.update("redoActions", e => e.clear());
          } else if (e.historyChangeContext !== l.j.HISTORY && e.undoActions.size > 0) {
            const r = e.undoActions.findLastIndex(e => ("update" === e.type || "delete" === e.type) && e.payload.id === n.id);
            -1 !== r && e.updateIn(["undoActions", r], e => "update" === e.type ? f(f({}, e), {}, {
              payload: D(n, t.merge(e.payload)),
              restoreAPStream: e.restoreAPStream
            }) : "delete" === e.type ? f(f({}, e), {}, {
              payload: f(f({}, D(n, t)), e.payload)
            }) : e);
          }
        }
        function b(e, t, n) {
          if (t instanceof d.Hu) return;
          if (e.isHistoryEnabled) {
            let n = !0;
            if (e.eventEmitter.emit("history.willChange", {
              annotation: t,
              type: "delete",
              preventDefault() {
                n = !1;
              }
            }), !n) return;
          }
          const r = (0, u.xc)();
          if (e.historyChangeContext === l.j.DEFAULT && e.isHistoryEnabled) {
            const o = w(t, r, e.commentThreads, e.comments),
              i = x(t, r, e);
            e.update("undoActions", e => e.map(e => e.payload.id === t.id ? f(f({}, e), {}, {
              payload: f(f({}, e.payload), {}, {
                id: r
              })
            }) : e).push({
              type: "create",
              payload: t.set("id", r),
              formField: i,
              restoreAPStream: n,
              comments: o
            })), e.update("redoActions", e => e.clear());
            const a = e.historyIdsMap.get(t.id);
            a && e.deleteIn(["historyIdsMap", t.id]), e.setIn(["historyIdsMap", r], a || t.id);
          } else if (e.historyChangeContext !== l.j.HISTORY && e.undoActions.size > 0) {
            const o = e.undoActions.findLastIndex(e => "update" === e.type && e.payload.id === t.id);
            if (-1 !== o) {
              e.updateIn(["undoActions", o], e => ({
                type: "update",
                deletedAnnotation: t,
                payload: e.payload,
                restoreAPStream: n
              }));
              const i = e.historyIdsMap.get(t.id);
              i && e.deleteIn(["historyIdsMap", t.id]), e.setIn(["historyIdsMap", r], i || t.id);
            }
          }
        }
        function w(e, t, n, r) {
          let o = null;
          if (e.isCommentThreadRoot) {
            const i = n.get(e.id);
            o = i ? i.map(e => {
              const n = r.get(e);
              return n && n.set("rootId", t);
            }).filter(e => e && !(0, c.kT)(e)).toList() : null;
          }
          return o;
        }
        function x(e, t, n) {
          let r = null;
          return e instanceof s.x_ && (r = (0, p.GA)(n, e)), r && r.set("annotationIds", (0, i.aV)([t]));
        }
        function D(e, t) {
          return t.toSeq().reduce((t, n, r) => (e.has(r) && e.get(r) === n || (t[r] = n), t), {
            id: e.id
          });
        }
      },
      68540: (e, t, n) => {
        "use strict";

        n.d(t, {
          $: () => v,
          Ah: () => k,
          Bo: () => D,
          Je: () => T,
          L8: () => z,
          R9: () => h,
          Sv: () => E,
          Tp: () => S,
          _x: () => b,
          dX: () => y,
          jC: () => x,
          jw: () => g,
          lB: () => _,
          mP: () => C,
          nG: () => m,
          tm: () => w,
          wA: () => A,
          wL: () => P
        });
        var r = n(67294),
          o = n(67366),
          i = n(66327),
          a = n(93113),
          s = n(89637),
          l = n(45249),
          u = n(74814),
          c = n(20388),
          d = n(4087),
          p = n(21853);
        function h(e) {
          const t = r.useRef(e),
            n = r.useCallback(function () {
              for (var e, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
              return null == t || null === (e = t.current) || void 0 === e ? void 0 : e.call(t, ...r);
            }, []);
          return r.useEffect(() => (t.current = e, () => t.current = void 0)), n;
        }
        function f(e) {
          const t = (0, o.I0)();
          return [(0, o.v9)(t => {
            if (t.documentComparisonState && void 0 !== t.documentComparisonState[e]) return t.documentComparisonState[e];
            throw new Error("Document comparison state not properly initialized.");
          }), h(n => t((0, i.M5)({
            [e]: n
          })))];
        }
        function m() {
          return f("referencePoints");
        }
        function g() {
          return f("currentTab");
        }
        function v() {
          return f("autoCompare");
        }
        function y() {
          return f("isResultFetched");
        }
        function b() {
          let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
          const t = r.useRef(),
            n = r.useRef();
          return (0, o.v9)(r => (r.viewportState === t.current && n.current || (n.current = t => t.apply((0, a.zi)(r, e))), t.current = r.viewportState, n.current));
        }
        function w() {
          const e = r.useRef(!0),
            t = r.useCallback(() => e.current, []);
          return r.useEffect(() => () => {
            e.current = !1;
          }, []), t;
        }
        function x(e) {
          const t = r.useRef();
          return r.useEffect(() => {
            t.current = e;
          }), t.current;
        }
        function D(e, t) {
          const n = (0, o.v9)(e => e.customUIStore),
            i = (0, o.v9)(e => e.sidebarMode),
            [a, s] = r.useState(() => {
              var e;
              return i ? null == n || null === (e = n.getState().Sidebar) || void 0 === e ? void 0 : e[i] : void 0;
            });
          r.useEffect(() => null == n ? void 0 : n.subscribe(e => {
            var t;
            if (!i) return;
            const n = null == e || null === (t = e.Sidebar) || void 0 === t ? void 0 : t[i];
            s(() => n);
          }), [n, i]);
          const l = e && (null == a ? void 0 : a({
              containerNode: e,
              items: t
            })),
            u = null == l ? void 0 : l.node;
          return r.useEffect(() => {
            u && e && u !== e && e.lastChild !== u && e.append(u);
          }, [e, u]), null == l ? void 0 : l.onRenderItem;
        }
        function C(e, t, n) {
          const o = r.useRef({}),
            i = h(t),
            a = h(n),
            s = r.useMemo(() => (t, n) => {
              e && t && n && (e({
                itemContainerNode: t,
                item: n
              }), o.current[i(n)] = t);
            }, [e, i]);
          return r.useEffect(() => {
            Object.entries(o.current).forEach(t => {
              let [n, r] = t;
              if (r && n) {
                const t = a(n),
                  r = o.current[n];
                e && r && t && e({
                  itemContainerNode: r,
                  item: t
                });
              }
            });
          }, [e, a]), e ? s : null;
        }
        function S() {
          const [e, t] = r.useState(null),
            [n, o] = r.useState(null),
            [i, a] = r.useState(null),
            s = r.useRef(),
            l = r.useRef(),
            u = r.useRef(null);
          r.useEffect(() => {
            l.current = n, s.current = i;
          }), r.useEffect(() => {
            const t = e && n && !l.current,
              r = !e && s.current && i;
            (t || r) && u.current && u.current.focus();
          }, [n, i, e]);
          const c = r.useCallback(() => {
            o(!0);
          }, [o]);
          return {
            handleGroupExpansion: r.useCallback(e => {
              t(e), e ? a(e) : o(!1);
            }, [a, t, o]),
            handleEntered: c,
            expandedGroup: e,
            prevActiveGroup: i,
            btnFocusRef: u
          };
        }
        function E(e, t, n) {
          r.useLayoutEffect(function () {
            null !== e && (t((0, s.Sb)()), n(e));
          }, [n, e, t]);
        }
        function _(e, t, n, i) {
          const a = (0, o.v9)(e => e.shadowRoot);
          return r.useCallback(function (r) {
            if (!(e instanceof l.gd)) return;
            const o = (0, c.Zv)(e, t, n, a).boundingBox;
            let s = null;
            switch (r) {
              case u.V.RIGHT:
                s = e.setIn(["boundingBox", "width"], o.width);
                break;
              case u.V.BOTTOM:
                s = e.setIn(["boundingBox", "height"], o.height);
                break;
              case u.V.BOTTOM_RIGHT:
                s = e.set("boundingBox", o);
            }
            null !== s && i((0, d.FG)((0, c.XA)(s, n)));
          }, [e, i, t, n, a]);
        }
        function P(e) {
          const t = r.useRef(null);
          return r.useEffect(function () {
            const {
              current: n
            } = t;
            n && (0, p._s)(e(), n);
          }, [e]), t;
        }
        function k(e) {
          const [t, n] = r.useState(e),
            [o, i] = r.useState(e);
          return t !== e && (i(e), n(e)), [o, i];
        }
        function A(e, t, n) {
          r.useEffect(function () {
            if (!e) return;
            const r = t();
            return r.addEventListener("scroll", n), function () {
              r.removeEventListener("scroll", n);
            };
          }, [t, e, n]);
        }
        const z = (e, t) => {
          const n = r.useRef(!1);
          r.useEffect(() => () => {
            n.current = !0;
          }, []), r.useEffect(() => () => {
            n.current && e();
          }, [...t, e]);
        };
        function T() {
          const e = (0, o.v9)(e => e.shadowRoot),
            t = (0, o.v9)(e => e.frameWindow),
            [n, i] = r.useState(void 0);
          return r.useEffect(() => {
            if (!t) return;
            const n = e instanceof ShadowRoot ? e.host : t.frameElement;
            if (!n) return;
            const r = e instanceof ShadowRoot ? n.ownerDocument.defaultView : t.parent;
            if (!r) return;
            let o = !1;
            const a = () => {
                const e = n.getBoundingClientRect(),
                  t = e.width + Math.min(0, e.left) + Math.min(0, r.innerWidth - e.right),
                  o = e.height + Math.min(0, e.top) + Math.min(0, r.innerHeight - e.bottom);
                i({
                  width: t,
                  height: o
                });
              },
              s = () => {
                o || (requestAnimationFrame(() => {
                  a(), o = !1;
                }), o = !0);
              };
            return a(), null == r || r.addEventListener("resize", s), null == r || r.addEventListener("scroll", s, {
              passive: !0
            }), () => {
              null == r || r.removeEventListener("resize", s), null == r || r.removeEventListener("scroll", s, {
                passive: !0
              });
            };
          }, [t, e]), n;
        }
      },
      94809: (e, t, n) => {
        "use strict";

        n.d(t, {
          Pn: () => i,
          qH: () => s,
          rH: () => a,
          sf: () => l,
          vu: () => o
        });
        var r = n(82716);
        function o(e) {
          return 200 <= e && e < 300;
        }
        function i(e) {
          const t = e.indexOf("://") > 0;
          (0, r.k)(t, `The baseUrl must be an absolute URL (e.g. https://example.com/pspdfkit-lib/), but it is set to ${e}.\nProtocol relative URLs (e.g. //example.com/pspdfkit-lib/) are not supported.`);
          const n = "/" === e.substr(-1);
          (0, r.k)(n, `The baseUrl must have a trailing slash in the URL (e.g. https://example.com/pspdfkit-lib/), but it is set to ${e}.`);
        }
        function a(e) {
          return i(e);
        }
        function s(e) {
          return i(e);
        }
        function l(e) {
          const t = e.indexOf("://") > 0;
          (0, r.k)(t, `The hostedBaseUrl must be an absolute URL (e.g. https://api.pspdfkit.com/, but it is set to ${e}.`);
          const n = "/" === e.substr(-1);
          (0, r.k)(n, `The hostedBaseUrl must have a trailing slash in the URL (e.g. https://api.pspdfkit.com/), but it is set to ${e}.`);
        }
      },
      56573: (e, t, n) => {
        "use strict";

        n.d(t, {
          Jc: () => b,
          UW: () => v,
          Y: () => w,
          an: () => y,
          uq: () => g,
          wc: () => C
        });
        var r = n(96156),
          o = n(30845),
          i = n(15359),
          a = n(10983),
          s = n(46364),
          l = n(34299),
          u = n(44077),
          c = n(60209),
          d = n(92537),
          p = n(45249);
        function h(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function f(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? h(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const m = (0, o.Z)(function (e) {
          const t = new FileReader();
          return new Promise((n, r) => {
            t.onerror = e => r(new Error(e)), t.onload = e => {
              var t;
              const r = new Image();
              r.onload = () => {
                n(new u.$u({
                  width: r.width,
                  height: r.height
                }));
              }, r.onerror = () => n(new u.$u({
                width: a.zA,
                height: a._2
              })), r.src = null === (t = e.target) || void 0 === t ? void 0 : t.result;
            }, t.readAsDataURL(e);
          });
        });
        const g = async e => {
          const {
              Sha256: t,
              bytes_to_hex: r
            } = await n.e(1517).then(n.bind(n, 14350)),
            o = new t(),
            i = await (0, l.V)(e);
          return {
            hash: r(o.process(i).finish().result),
            dimensions: await m(e)
          };
        };
        function v(e) {
          return `${e.imageAttachmentId}_${e.id}`;
        }
        function y(e) {
          var t;
          let {
              backend: n,
              blob: r,
              annotation: o,
              isDetachedAnnotation: a = !1,
              zoomLevel: l,
              variant: c,
              hasZoomedIn: h = !1
            } = e,
            m = null,
            y = !1;
          const b = null !== (t = null == o ? void 0 : o.rotation) && void 0 !== t ? t : 0;
          (0, i.kG)(n);
          const w = o ? v(o) : void 0;
          if (o instanceof p.sK && h && w && n.attachmentsCache.has(w)) {
            const e = n.attachmentsCache.get(w);
            (void 0 === e.zoomLevel || void 0 === l || e.zoomLevel < l) && (n.attachmentsCache = n.attachmentsCache.delete(w));
          }
          if (o && "imageAttachmentId" in o && o.imageAttachmentId && w && n.attachmentsCache.has(w)) {
            const {
              dimensions: e,
              img: t,
              provisional: i,
              prevRotation: a
            } = n.attachmentsCache.get(w);
            if (n && i && r && a === b) return D();
            r && "image/png" !== r.type && "image/jpeg" !== r.type && "image/webp" !== r.type && (y = !0), m = x(n, e, b, o, r, t).then(o => (r && "image/png" !== r.type && "image/jpeg" !== r.type && "image/webp" !== r.type && o && (n.attachmentsCache = n.attachmentsCache.set(w, {
              dimensions: e,
              img: t,
              provisional: !0,
              prevRotation: b,
              zoomLevel: l
            })), o));
          } else {
            if (!r || "image/png" !== r.type && "image/jpeg" !== r.type && "image/webp" !== r.type) return D();
            m = g(r).then(e => {
              let {
                dimensions: t
              } = e;
              return x(n, t, b, o, r);
            }).catch(() => {
              throw new i.p2("Couldn't read data from the provided image.");
            });
          }
          return f(f({}, (0, s.uZ)(m)), {}, {
            isProvisional: y
          });
          function D() {
            (0, i.kG)(n, "Backend is required to render the image"), (0, i.kG)(o, "Annotation is required to render the image");
            const {
                boundingBox: e
              } = o,
              t = (0, d.L)() * (null != l ? l : 1);
            let s = Math.round(e.width * t),
              h = Math.round(e.height * t);
            if (!(o instanceof p.GI || o instanceof p.sK)) {
              const e = Math.sqrt(s * h / 1e7);
              e > 1 && (s = Math.round(s * (1 / e)), h = Math.round(h * (1 / e)));
            }
            const f = new u.$u({
                width: s,
                height: h
              }),
              m = a ? n.renderDetachedAnnotation(o, r, s, h) : n.cachedRenderAnnotation(o, r, s, h, c);
            return m.promise = m.promise.then(async e => "imageAttachmentId" in o && o.imageAttachmentId && w && null != e && e.element ? 0 !== b ? x(n, f, 360 - b, o, r, e.element).then(t => (null != t && t.element && (n.attachmentsCache = n.attachmentsCache.set(w, {
              dimensions: 90 === b || 270 === b ? f.swapDimensions() : f,
              img: t.element,
              prevRotation: b,
              zoomLevel: l
            })), e)) : (n.attachmentsCache = n.attachmentsCache.set(w, {
              dimensions: f,
              img: e.element,
              prevRotation: b,
              zoomLevel: l
            }), e) : e), m;
          }
        }
        function b(e, t) {
          const n = new Uint8Array(e.length);
          for (let t = 0; t < e.length; t++) n[t] = e.charCodeAt(t);
          return new Blob([n.buffer], {
            type: t
          });
        }
        async function w(e, t, n) {
          let r,
            o,
            {
              font: i,
              fontColor: a
            } = t;
          "OffscreenCanvas" in n ? (r = new n.OffscreenCanvas(200, 200), o = r.convertToBlob.bind(r)) : (r = n.document.createElement("canvas"), o = () => new Promise(e => {
            r.toBlob(e);
          }));
          const s = r.getContext("2d");
          s.textBaseline = "hanging";
          s.font = `100px "${i}"`;
          const {
            actualBoundingBoxLeft: l,
            actualBoundingBoxRight: u,
            width: c
          } = s.measureText(e);
          r.height = 500;
          const d = 2 * (l || u ? l + u : c);
          return r.width = d, s.textBaseline = "hanging", s.font = `100px "${i}"`, s.fillStyle = a.toCSSValue(), s.fillText(e, d / 4, 125), function (e) {
            const t = e.getContext("2d"),
              n = t.getImageData(0, 0, e.width, e.height),
              r = n.data.length;
            let o = null,
              i = null,
              a = null,
              s = null,
              l = 0,
              u = 0;
            for (let t = 0; t < r; t += 4) 0 !== n.data[t + 3] && (l = t / 4 % e.width, u = ~~(t / 4 / e.width), null === o && (o = u), (null === a || l < a) && (a = l), (null === s || s < l) && (s = l), (null === i || i < u) && (i = u));
            o = o || 0, i = i || 0, a = a || 0, s = s || 0;
            const c = i - o,
              d = s - a;
            if (0 === d || 0 === c) return;
            const p = t.getImageData(a, o, d, c);
            e.width = d, e.height = c, t.putImageData(p, 0, 0);
          }(r), o({
            type: "image/png"
          });
        }
        function x(e, t, n, r, o, i) {
          if (i) return new Promise((e, r) => D(i, t, n).then(e, r));
          if (o) {
            const i = URL.createObjectURL(o),
              a = document.createElement("img");
            return new Promise((s, l) => {
              a.onload = () => {
                o && r && (e.attachmentsCache = e.attachmentsCache.set(v(r), {
                  dimensions: t,
                  img: a,
                  prevRotation: n
                })), D(a, t, n).then(s, l);
              }, a.onerror = () => {
                l(new Error("The attachment provided could not be rendered as image/jpeg, image/png or image/webp although the mime type suggests so."));
              }, a.src = i;
            });
          }
          return new Promise(e => e);
        }
        async function D(e, t, n) {
          if (0 === n) return e.onload = null, e.onerror = null, new c.Z(e, () => {});
          {
            const r = document.createElement("canvas"),
              {
                width: o,
                height: a
              } = t;
            90 === n || 270 === n ? (r.width = a, r.height = o) : (r.width = o, r.height = a);
            const s = r.getContext("2d");
            return (0, i.kG)(s, "Could not get canvas context"), 90 === n || 270 === n ? s.translate(a / 2, o / 2) : s.translate(o / 2, a / 2), s.rotate(n * -Math.PI / 180), s.drawImage(e, -o / 2, -a / 2), new c.Z(r, () => {});
          }
        }
        const C = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
      },
      40163: (e, t, n) => {
        "use strict";

        n.d(t, {
          O: () => i,
          b: () => a
        });
        var r = n(35369);
        function o(e, t) {
          if (e === t || (0, r.is)(e, t)) return !0;
          if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
          const n = Object.keys(e),
            o = Object.keys(t);
          if (n.length !== o.length) return !1;
          const i = Object.prototype.hasOwnProperty.bind(t);
          for (let o = 0; o < n.length; o++) if (!i(n[o]) || !(0, r.is)(e[n[o]], t[n[o]])) return !1;
          return !0;
        }
        function i(e, t) {
          return !o(this.props, e) || !o(this.state, t);
        }
        function a(e, t) {
          if (e.length === t.length) {
            let n = 0;
            for (; n < e.length;) {
              if (e[n] !== t[n]) return e[n] < t[n] ? -1 : 1;
              n++;
            }
            return 0;
          }
          return e.length < t.length ? -1 : 1;
        }
      },
      55441: (e, t, n) => {
        "use strict";

        n.d(t, {
          $U: () => g,
          H9: () => c,
          HB: () => f,
          IQ: () => h,
          Ip: () => y,
          Vv: () => w,
          gz: () => d,
          o: () => p,
          u8: () => v,
          vR: () => m
        });
        var r = n(35369),
          o = n(45249),
          i = n(23301),
          a = n(74814),
          s = n(98179),
          l = n(92537),
          u = n(82716);
        function c(e, t, n) {
          return 0 === n || 0 === e.size || e.last().distance(t) > n;
        }
        function d(e) {
          var t, n, r, i;
          if (0 === e.lines.size) return new o.UL();
          const a = e.lines.flatMap(e => e),
            s = Math.ceil((null === (t = a.maxBy(e => e.x)) || void 0 === t ? void 0 : t.x) + e.lineWidth / 2),
            l = Math.ceil((null === (n = a.maxBy(e => e.y)) || void 0 === n ? void 0 : n.y) + e.lineWidth / 2),
            u = Math.floor((null === (r = a.minBy(e => e.x)) || void 0 === r ? void 0 : r.x) - e.lineWidth / 2),
            c = Math.floor((null === (i = a.minBy(e => e.y)) || void 0 === i ? void 0 : i.y) - e.lineWidth / 2);
          return new o.UL({
            width: s - u,
            height: l - c,
            top: c,
            left: u
          });
        }
        function p(e, t, n) {
          const {
              width: r,
              height: s
            } = e.boundingBox,
            l = (0, i.BP)(new o.$u({
              width: r,
              height: s
            }), t);
          return (0, i.D7)(e, new o.E9({
            x: l.width - r,
            y: l.height - s
          }), a.V.BOTTOM_RIGHT, n, !1);
        }
        const h = e => e.reduce((e, t) => (null == t ? e.push((0, r.aV)()) : e[e.length - 1] = e[e.length - 1].push(t), e), [(0, r.aV)()]).filter(e => e.size > 0),
          f = e => {
            const t = Math.abs(Math.ceil(Math.log10((0, l.L)() * e)));
            let n;
            return n = t > 100 ? 100 : t, n;
          },
          m = (e, t) => {
            const n = e.first();
            if (1 === e.size && n) return [`L ${n.x},${n.y}`];
            const r = [`M ${n.x},${n.y}`],
              o = e.get(1);
            if (2 === e.size && o) return r.push(`L ${o.x},${o.y}`), r;
            for (let n = 2, o = e.size; n < o; ++n) {
              const i = e.get(n - 2),
                a = e.get(n - 1);
              if (i && a) {
                const s = {
                    x: (2 * i.x + a.x) / 3,
                    y: (2 * i.y + a.y) / 3
                  },
                  l = {
                    x: 2 * s.x - i.x,
                    y: 2 * s.y - i.y
                  },
                  u = a,
                  c = e.get(n);
                if (c) {
                  const e = {
                    x: (2 * u.x + c.x) / 3,
                    y: (2 * u.y + c.y) / 3
                  };
                  if (r.push(`C ${s.x.toFixed(t)},${s.y.toFixed(t)} ${l.x.toFixed(t)},${l.y.toFixed(t)} ${(l.x + (e.x - l.x) / 2).toFixed(t)},${(l.y + (e.y - l.y) / 2).toFixed(t)}`), n === o - 1) {
                    const n = {
                      x: 2 * e.x - u.x,
                      y: 2 * e.y - u.y
                    };
                    r.push(`C ${e.x.toFixed(t)},${e.y.toFixed(t)} ${n.x.toFixed(t)},${n.y.toFixed(t)} ${c.x.toFixed(t)},${c.y.toFixed(t)}`);
                  }
                }
              }
            }
            return r;
          },
          g = e => {
            const t = e.first();
            return 1 === e.size && t ? [`L ${t.x},${t.y}`] : e.reduce((e, t, n) => (n > 0 && e.push(`L ${t.x},${t.y}`), e), [`M ${t.x},${t.y}`]);
          },
          v = e => e.reduce((t, n, r) => (e[r - 1] && "M 0,0" !== e[r - 1] || !n.startsWith("L") || t.push(n.replace("L", "M")), t.push(n), t), []).join(" ");
        function y(e, t, n) {
          if (e.lines.size < 2) return !0;
          const r = e.lines.last();
          if (null == e.lines.get(e.lines.size - 2) || null == r || 0 === r.size || r.size > 2) return !0;
          const o = .5 * (t.width + t.height),
            i = e.lines.size < 50 ? .15 : .03,
            a = (Date.now() - n) / 1e3;
          if (a < i) return !0;
          const s = r.first();
          return Boolean(e.lines.pop().some(e => e.some(e => e.distance(s) < o * i / a)));
        }
        function b(e) {
          const t = Math.ceil(2 * e) + 4,
            n = Math.ceil(2 * e) + 4,
            r = document.createElement("canvas");
          r.width = t, r.height = n;
          const o = r.getContext("2d");
          return (0, u.k)(o), o.beginPath(), o.arc(e + 2, e + 2, e, 0, 2 * Math.PI, !1), o.lineWidth = 1, o.strokeStyle = "rgba(0,0,0,.7)", o.stroke(), o.beginPath(), o.arc(e + 2, e + 2, e + 1, 0, 2 * Math.PI, !1), o.lineWidth = 1, o.strokeStyle = "white", o.stroke(), r.toDataURL();
        }
        function w(e) {
          if (e < 3) return "crosshair";
          const t = b(e),
            n = s.SR;
          if ("webkit" === n || "blink" === n) {
            return `-webkit-image-set(\n          url('${t}') 1x,\n          url('${b(2 * e)}') 2x\n        ) ${e + 2} ${e + 2}, crosshair`;
          }
          return `url('${t}') ${e + 2} ${e + 2}, crosshair`;
        }
      },
      82716: (e, t, n) => {
        "use strict";

        n.d(t, {
          k: () => o
        });
        var r = n(15359);
        function o(e, t) {
          if (!e) throw new r.p2(`Assertion failed: ${t || "Condition not met"}\n\nFor further assistance, please go to: https://pspdfkit.com/support/request`);
        }
      },
      2427: (e, t, n) => {
        "use strict";

        n.d(t, {
          eU: () => s,
          t0: () => l,
          yK: () => a
        });
        var r = n(19575),
          o = n(15359),
          i = n(72110);
        function a(e) {
          const t = "The supplied JWT is invalid. Please refer to our guides on how to set up authentication:\n  https://pspdfkit.com/guides/web/current/server-backed/client-authentication/";
          if (-1 !== e.indexOf('{"internal":')) return;
          let n;
          (0, o.kG)("string" == typeof e && 3 === e.split(".").length, t);
          try {
            const t = r.Base64.decode(e.split(".")[1]);
            n = JSON.parse(t);
          } catch (e) {
            throw new o.p2(t);
          }
          (0, o.kG)("string" == typeof n.document_id, "The supplied JWT is invalid. The field 'document_id' has to be a string value.\n  Please refer to our guides for further information: https://pspdfkit.com/guides/web/current/server-backed/client-authentication/");
        }
        function s(e) {
          if ("string" != typeof e) throw new o.p2("`accessToken` must be of type string.");
        }
        function l(e, t) {
          (0, o.kG)("string" == typeof e, "`appName` must be a string."), (0, o.kG)((0, i.d)() || (0, i.AL)(e, t) || (0, i.B0)(e, t), "`appName` should only be set when using Electron, Maui or Flutter for Web."), (0, o.kG)(!(0, i.Sk)() || (0, i.AL)(e, t) || (0, i.B0)(e, t), "`appName` should only be set when using Electron without node integration, Maui or Flutter for Web.");
        }
      },
      71856: (e, t, n) => {
        "use strict";

        function r(e) {
          return {
            name: e.name,
            scale: {
              unitFrom: e.scale.unitFrom,
              unitTo: e.scale.unitTo,
              from: Number(e.scale.fromValue),
              to: Number(e.scale.toValue)
            },
            precision: e.precision
          };
        }
        n.d(t, {
          f: () => r
        });
      },
      29152: (e, t, n) => {
        "use strict";

        n.d(t, {
          B0: () => J,
          Di: () => S,
          Ex: () => U,
          Hg: () => $,
          KI: () => E,
          P_: () => M,
          Qc: () => K,
          Rc: () => H,
          Rw: () => j,
          S6: () => R,
          W9: () => L,
          _P: () => A,
          b5: () => q,
          bs: () => X,
          cd: () => B,
          fH: () => G,
          m_: () => N,
          mq: () => W,
          nK: () => V,
          t9: () => F,
          xA: () => Y,
          zl: () => Q
        });
        var r = n(96156),
          o = n(15359),
          i = n(85628),
          a = n.n(i),
          s = n(35369),
          l = n(58163),
          u = n(85151),
          c = n(4087),
          d = n(10552),
          p = n(48625),
          h = n(97281),
          f = n(94327),
          m = n(1385),
          g = n(9513),
          v = n(71479),
          y = n(16006),
          b = n(45874),
          w = n(14165),
          x = n(98179);
        function D(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function C(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? D(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : D(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        const S = [{
          interactionMode: p.A.DISTANCE,
          icon: "distance",
          title: "Distance",
          className: "PSPDFKit-Form-Creator-Toolbar-ButtonWidget",
          class: v.Z,
          preset: "distance",
          localeKey: "distanceMeasurement"
        }, {
          interactionMode: p.A.PERIMETER,
          icon: "perimeter",
          title: "Perimeter",
          className: "PSPDFKit-Form-Creator-Toolbar-TextWidget",
          class: b.Z,
          preset: "perimeter",
          localeKey: "perimeterMeasurement"
        }, {
          interactionMode: p.A.RECTANGLE_AREA,
          icon: "rectangle-area",
          title: "Rectangle-Area",
          className: "PSPDFKit-Form-Creator-Toolbar-RadioWidget",
          class: w.Z,
          preset: "rectangle-area",
          localeKey: "rectangularAreaMeasurement"
        }, {
          interactionMode: p.A.POLYGON_AREA,
          icon: "polygon-area",
          title: "Polygon-Area",
          className: "PSPDFKit-Form-Creator-Toolbar-CheckboxWidget",
          class: y.Z,
          preset: "polygon-area",
          localeKey: "polygonAreaMeasurement"
        }, {
          interactionMode: p.A.ELLIPSE_AREA,
          icon: "ellipse-area",
          title: "Ellipse-Area",
          className: "PSPDFKit-Form-Creator-Toolbar-ComboboxWidget",
          class: g.Z,
          preset: "ellipse-area",
          localeKey: "ellipseAreaMeasurement"
        }];
        function E(e, t) {
          var n;
          const r = e.strokeWidth / 2 + 10,
            {
              coordinate: o,
              angleInDegrees: i
            } = function (e, t) {
              if (e instanceof v.Z) {
                const {
                  startPoint: t,
                  endPoint: n
                } = e;
                return _(t, n);
              }
              if (e instanceof b.Z) {
                const {
                  points: n
                } = e;
                if (n.size < 2) return {};
                const r = n.last(),
                  o = n.get(n.size - 2);
                return r.y === o.y ? _(o, r) : r.y < o.y ? {
                  coordinate: [r.x, r.y - t]
                } : {
                  coordinate: [r.x, r.y + t]
                };
              }
              if (e instanceof y.Z) {
                const {
                    points: n
                  } = e,
                  r = n.sort((e, t) => e.y - t.y).first();
                return {
                  coordinate: [r.x, r.y - t]
                };
              }
              {
                const {
                  boundingBox: t
                } = e;
                return {
                  coordinate: [t.left + t.width / 2, t.top + t.height / 2]
                };
              }
            }(e, r);
          if (!o) return {
            display: "none"
          };
          const a = {
              position: "absolute",
              transform: "translate(-50%, -50%) " + (e instanceof b.Z || e instanceof w.Z || e instanceof g.Z ? "" : e instanceof v.Z && i ? `rotate(${i}deg) translate(0, -${e.strokeWidth / 2 + 10}px)` : i ? `rotate(${i}deg) translate(0px, -${e.strokeWidth / 2 + 10}px)` : `translate(0px, -${e.strokeWidth / 2 + 10}px)`),
              transformOrigin: "center",
              fontSize: 12,
              color: null === (n = e.strokeColor) || void 0 === n ? void 0 : n.toCSSValue(),
              width: "max-content",
              left: o[0],
              top: e instanceof v.Z && x.G6 && !i ? o[1] - 20 : o[1]
            },
            {
              boundingBox: s
            } = e;
          return (e instanceof w.Z || e instanceof g.Z) && (t && s.width < 200 || s.width < 80) ? C(C({}, a), {}, {
            top: s.top - 30
          }) : a;
        }
        function _(e, t) {
          let n = e,
            r = t;
          t.x < e.x && (n = t, r = e);
          const o = 180 * Math.atan2(r.y - n.y, r.x - n.x) / Math.PI;
          return {
            coordinate: [(e.x + t.x) / 2, (e.y + t.y) / 2],
            angleInDegrees: o
          };
        }
        const P = {
            [h.L.WHOLE]: 0,
            [h.L.ONE]: 1,
            [h.L.TWO]: 2,
            [h.L.THREE]: 3,
            [h.L.FOUR]: 4
          },
          k = {
            [h.L.HALVES]: .5,
            [h.L.QUARTERS]: 1 / 4,
            [h.L.EIGHTHS]: 1 / 8,
            [h.L.SIXTEENTHS]: 1 / 16
          },
          A = C(C({}, P), k);
        function z(e) {
          let t = 0;
          function n(e, t) {
            const n = t.x - e.x,
              r = t.y - e.y;
            return Math.sqrt(n * n + r * r);
          }
          for (let r = 0; r < e.size - 1; r++) t += n(e.get(r), e.get(r + 1));
          return t;
        }
        function T(e) {
          return Math.abs(e) <= Number.EPSILON;
        }
        var O = function (e) {
          return e[e.in = 0] = "in", e[e.mm = 1] = "mm", e[e.cm = 2] = "cm", e[e.pt = 3] = "pt", e[e.ft = 4] = "ft", e[e.m = 5] = "m", e[e.yd = 6] = "yd", e[e.km = 7] = "km", e[e.mi = 8] = "mi", e;
        }(O || {});
        const I = [[1, 25.4, 2.54, 72, .083333, .0254, .0277778, 254e-7, 157828e-10], [.0393701, 1, .1, 2.83465, .00328084, .001, .00109361, 1e-6, 6.21371e-7], [.393701, 10, 1, 28.34655, .0328084, .01, .0109361, 1e-5, 621371e-11], [.0138889, .352778, .0352778, 1, .00115741, 352778e-9, 385802e-9, 3.52778e-7, 2.19206086473e-7]];
        function F(e) {
          const {
            measurementPrecision: t,
            measurementScale: n
          } = e;
          (0, o.kG)(t, "measurementPrecision is required"), (0, o.kG)(n, "measurementScale is required");
          const r = T(n.toValue) || T(n.fromValue) ? 0 : n.toValue / n.fromValue;
          let i,
            l,
            u = I[O[f.s.POINTS]][O[n.unitFrom]];
          if (e instanceof v.Z) {
            const {
              startPoint: t,
              endPoint: n
            } = e;
            i = z((0, s.aV)([t, n])), u *= r;
          } else if (e instanceof b.Z) {
            const {
              points: t
            } = e;
            i = z(t), u *= r;
          } else if (e instanceof y.Z) {
            const {
              points: t
            } = e;
            i = function (e) {
              if (!e.size) return 0;
              let t = 0;
              for (let n = 0; n < e.size - 1; n++) t += e.get(n).x * e.get(n + 1).y - e.get(n + 1).x * e.get(n).y;
              return t += e.get(e.size - 1).x * e.get(0).y - e.get(0).x * e.get(e.size - 1).y, t /= 2, Math.abs(t);
            }(t), u = Math.pow(u, 2) * Math.pow(r, 2);
          } else if (e instanceof w.Z) {
            const {
              boundingBox: t
            } = e;
            i = t.width * t.height, u = Math.pow(u, 2) * Math.pow(r, 2);
          } else {
            const {
              boundingBox: t
            } = e;
            i = Math.PI * (t.width / 2) * (t.height / 2), u = Math.pow(u, 2) * Math.pow(r, 2);
          }
          if ("1/2" === t) {
            const e = 2,
              t = Math.round(i * u * e);
            l = new (a())(t / e).toFraction(!0);
          } else if ("1/4" === t) {
            const e = 4,
              t = Math.round(i * u * e);
            l = new (a())(t / e).toFraction(!0);
          } else if ("1/8" === t) {
            const e = 8,
              t = Math.round(i * u * e);
            l = new (a())(t / e).toFraction(!0);
          } else if ("1/16" === t) {
            const e = 16,
              t = Math.round(i * u * e);
            l = new (a())(t / e).toFraction(!0);
          } else l = (i * u).toFixed(A[t]);
          return {
            value: i * u,
            label: `${l} ${e instanceof v.Z || e instanceof b.Z ? "" : "sq "}${n.unitTo}`
          };
        }
        function M(e, t) {
          var n;
          const {
            measurementScale: r
          } = e;
          (0, o.kG)(r, "measurementScale is required");
          const i = t / (z(e instanceof b.Z ? e.points : (0, s.aV)([e.startPoint, e.endPoint])) * I[O[f.s.POINTS]][O[r.unitFrom]]) * r.fromValue;
          return null == r || null === (n = r.set) || void 0 === n ? void 0 : n.call(r, "toValue", i);
        }
        function R(e) {
          return (e instanceof g.Z || e instanceof w.Z) && e.isMeasurement();
        }
        function j(e, t) {
          if (t && e.measurementScale) {
            const n = e.measurementScale.set("unitTo", t.unitTo);
            return F(e.set("measurementScale", n).set("measurementPrecision", t.precision));
          }
          return "";
        }
        function B(e, t) {
          const n = e.scale.unitFrom,
            r = e.scale.unitTo,
            o = Number(e.scale.fromValue),
            i = Number(e.scale.toValue),
            a = e.precision,
            s = t.scale.unitFrom,
            l = t.scale.unitTo,
            u = Number(t.scale.fromValue),
            c = Number(t.scale.toValue),
            d = t.precision;
          return n === s && r === l && o === u && i === c && a === d;
        }
        const N = Object.keys(f.s).map(e => ({
            label: f.s[e],
            value: f.s[e],
            disabled: !1
          })),
          L = function () {
            const e = [];
            for (const t in h.L) {
              const n = Object.keys(h.L).find(e => e === t);
              if (n && P.hasOwnProperty(h.L[t])) e.push((1 / Math.pow(10, A[h.L[n]])).toString());else if (n && k.hasOwnProperty(h.L[t])) {
                const t = new (a())(A[h.L[n]]);
                e.push(t.toFraction(!0).toString());
              }
            }
            return e;
          }(),
          V = Object.keys(h.L).map((e, t) => ({
            label: L[t],
            value: h.L[e]
          })),
          K = Object.keys(h.L).filter(e => !Q(h.L[e])).map((e, t) => ({
            label: L[t],
            value: h.L[e]
          })),
          q = Object.keys(m.K).map(e => ({
            value: m.K[e],
            label: m.K[e]
          })),
          H = (e, t) => ({
            added: t.filter(t => !e.find(e => JSON.stringify(e) === JSON.stringify(t))),
            deleted: e.filter(e => !t.find(t => JSON.stringify(e) === JSON.stringify(t)))
          });
        function U(e) {
          return e.map((e, t) => {
            const n = C(C({}, e), {}, {
              scale: C(C({}, e.scale), {}, {
                fromValue: e.scale.from,
                toValue: e.scale.to
              })
            });
            var r;
            (delete n.scale.from, delete n.scale.to, n.name && "" !== n.name.trim()) || (n.name = (null === (r = (0, u.sJ)(n)) || void 0 === r ? void 0 : r.label) || `Scale ${t}`);
            return d.q[n.precision] && (n.precision = d.q[n.precision]), n;
          });
        }
        async function Z(e) {
          let {
            operation: t,
            scale: n,
            getState: r,
            measurementUpdate: o,
            dispatch: i
          } = e;
          const a = r(),
            {
              backend: u,
              annotations: d,
              annotationManager: p
            } = a;
          const h = async (e, o) => {
              const a = await (async e => (await (null == p ? void 0 : p.loadAnnotationsForPageIndex(e)), r().annotations))(o);
              !function (e, t, r) {
                e.forEach(e => {
                  const o = t.find(t => t.pdfObjectId === e.pdfObjectId);
                  if (o) switch (r) {
                    case "edit":
                      {
                        const e = o.set("measurementScale", new l.Z({
                          fromValue: Number(n.scale.fromValue),
                          toValue: Number(n.scale.toValue),
                          unitFrom: n.scale.unitFrom,
                          unitTo: n.scale.unitTo
                        })).set("measurementPrecision", n.precision);
                        i((0, c.FG)(e));
                        break;
                      }
                    case "delete":
                      i((0, c.hQ)(o));
                  }
                });
              }(e, a, t);
            },
            f = "STANDALONE" === u.type ? await u.getAnnotationsByScale(n) : function (e, t) {
              return t.filter(t => {
                const n = t.measurementScale,
                  r = t.measurementPrecision;
                return !!n && n.unitFrom === e.scale.unitFrom && n.unitTo === e.scale.unitTo && n.fromValue === e.scale.fromValue && n.toValue === e.scale.toValue && r === e.precision;
              });
            }(n, d),
            m = [];
          if (f.forEach(e => {
            const n = d.find(t => t.pdfObjectId ? t.pdfObjectId === e.pdfObjectId : t.id === e.id);
            if (n && "edit" === t && o) {
              const e = n.set("measurementScale", o.scale).set("measurementPrecision", o.precision);
              i((0, c.FG)(e));
            } else n && "delete" === t ? i((0, c.hQ)(n)) : m.push(e);
          }), m.length > 0) {
            const e = (0, s.l4)(m.map(e => e.pageIndex));
            await Promise.all(e.map(async e => {
              await h(m, e);
            }));
          }
        }
        async function $(e) {
          let {
            scale: t,
            oldScale: n,
            getState: r,
            dispatch: o
          } = e;
          const i = {
            scale: new l.Z({
              fromValue: Number(t.scale.fromValue),
              toValue: Number(t.scale.toValue),
              unitFrom: t.scale.unitFrom,
              unitTo: t.scale.unitTo
            }),
            precision: t.precision
          };
          await Z({
            operation: "edit",
            scale: n,
            getState: r,
            measurementUpdate: i,
            dispatch: o
          });
        }
        async function G(e) {
          let {
            deletedScale: t,
            getState: n,
            dispatch: r
          } = e;
          await Z({
            operation: "delete",
            scale: t,
            getState: n,
            dispatch: r
          });
        }
        function W(e) {
          if (e.size < 2) return !1;
          const t = e.toList(),
            n = t.first(),
            r = {
              scale: n.measurementScale,
              precision: n.measurementPrecision
            };
          for (let e = 1; e < t.size; e++) {
            const n = t.get(e);
            if (!B(r, {
              scale: n.measurementScale,
              precision: n.measurementPrecision
            })) return !0;
          }
          return !1;
        }
        function Y(e) {
          if (e.size < 2) return !1;
          const t = e.toList(),
            n = X(e.first());
          for (let e = 1; e < t.size; e++) {
            if (n !== X(t.get(e))) return !0;
          }
          return !1;
        }
        function X(e) {
          return e instanceof v.Z ? "Distance" : e instanceof b.Z ? "Perimeter" : e instanceof g.Z ? "Ellipse-Area" : e instanceof w.Z ? "Rectangle-Area" : e instanceof y.Z ? "Polygon-Area" : void 0;
        }
        function Q(e) {
          return ["1/2", "1/4", "1/8", "1/16"].includes(e);
        }
        function J(e) {
          return ["mm", "cm", "m", "km"].includes(e);
        }
      },
      58846: (e, t, n) => {
        "use strict";

        n.d(t, {
          Sy: () => s,
          Zt: () => c,
          dY: () => l
        });
        var r = n(15359),
          o = n(45249),
          i = n(57943),
          a = n(33427);
        function s(e, t, n) {
          let s;
          if (e instanceof o.o9) return s = e.set(["startPoint", "endPoint"][n], e[["startPoint", "endPoint"][n]].translate(t)), s.set("boundingBox", (0, i.sS)(o.o9)(s));
          var u;
          if (e instanceof o.om || e instanceof o.Hi) return s = e.setIn(["points", n], null === (u = e.points.get(n)) || void 0 === u ? void 0 : u.translate(t)), s.set("boundingBox", (0, i.sS)(o.om)(s));
          if ((0, a.Vc)(e)) {
            var d, p;
            (0, r.kG)(e instanceof o.gd, "Callout annotation must have a callout");
            const a = null !== (d = e.callout) && void 0 !== d && d.knee ? ["start", "knee", "end"] : ["start", "end"];
            if ("end" === a[n]) return e;
            s = e.setIn(["callout", a[n]], null === (p = e.callout) || void 0 === p || null === (p = p[a[n]]) || void 0 === p ? void 0 : p.translate(t));
            const {
              callout: u
            } = s;
            (0, r.kG)(u, "Callout annotation must have a callout");
            const h = u.innerRectInset;
            (0, r.kG)(h, "Callout annotation must have an innerRectInset"), (0, r.kG)(u.start, "Callout annotation must have a start point");
            const f = {
                left: e.boundingBox.left + h.left,
                top: e.boundingBox.top + h.top,
                right: e.boundingBox.left + e.boundingBox.width - h.right,
                bottom: e.boundingBox.top + e.boundingBox.height - h.bottom
              },
              m = l([[f.left, f.top], [f.right, f.top], [f.right, f.bottom], [f.left, f.bottom]]),
              g = (0, i.sS)(o.gd)(s),
              v = new o.eB({
                left: f.left - g.left,
                top: f.top - g.top,
                right: g.left + g.width - f.right,
                bottom: g.top + g.height - f.bottom
              });
            return s.set("boundingBox", g).setIn(["callout", "innerRectInset"], v).setIn(["callout", "end"], c(u.knee || u.start, m));
          }
          return e;
        }
        function l(e) {
          const t = [];
          for (let n = 0; n < e.length; n++) {
            const r = e[n],
              i = e[(n + 1) % e.length];
            t.push(new o.E9({
              x: (r[0] + i[0]) / 2,
              y: (r[1] + i[1]) / 2
            }));
          }
          return t;
        }
        function u(e, t) {
          return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
        }
        function c(e, t) {
          let n = t[0],
            r = u(e, n);
          for (const o of t) {
            const t = u(e, o);
            t < r && (n = o, r = t);
          }
          return n;
        }
      },
      1175: (e, t, n) => {
        "use strict";

        n.d(t, {
          I: () => o,
          W: () => i
        });
        var r = n(10983);
        function o(e) {
          return e.button === r.oW;
        }
        function i(e) {
          return e.buttons === r.M5;
        }
      },
      97395: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i,
          l: () => a
        });
        var r = n(72110);
        const o = ["http", "https", "mailto"];
        function i(e) {
          const t = e.split(":")[0];
          if (t === e) e = /^[./#]/.test(e) ? e : "http://" + e;else if (o.indexOf(t) <= -1) return;
          a(e, !0);
        }
        function a(e, t) {
          if ((0, r.Sk)()) {
            (0, r.oH)("electron").shell.openExternal(e);
          } else if (t) {
            window.open(e, "_blank").opener = null;
          } else window.opener = null, window.location.href = e;
        }
      },
      12705: (e, t, n) => {
        "use strict";

        n.d(t, {
          $Q: () => g,
          Ez: () => x,
          HI: () => v,
          LC: () => T,
          Pt: () => y,
          RZ: () => m,
          VT: () => f,
          VY: () => M,
          Vz: () => R,
          Xr: () => A,
          YN: () => O,
          aE: () => I,
          bp: () => S,
          ix: () => _,
          j$: () => D,
          jb: () => h,
          k_: () => P,
          lV: () => w,
          qs: () => z,
          xW: () => F,
          xr: () => k
        });
        var r = n(15359),
          o = n(45249),
          i = n(94732),
          a = n(81026),
          s = n(72127),
          l = n(20063),
          u = n(2891),
          c = n(87996),
          d = n(44550),
          p = n(28233);
        function h(e) {
          return e.documentPermissions.printHighQuality;
        }
        function f(e) {
          return e.documentPermissions.printing && e.printingEnabled && e.backendPermissions.downloadingAllowed;
        }
        function m(e) {
          return e.exportEnabled && e.backendPermissions.downloadingAllowed;
        }
        function g(e) {
          return e.documentPermissions.extract && e.clientPermissions.extract;
        }
        function v(e) {
          return g(e) && !e.clientPermissions.preventTextCopy;
        }
        function y(e) {
          return e.documentPermissions.toJS();
        }
        function b(e) {
          let {
            backendPermissions: t,
            documentPermissions: n,
            readOnlyEnabled: r
          } = e;
          return !(!n.modification && n.annotationsAndForms && !t.readOnly && r === p.J.NO);
        }
        function w(e, t) {
          let n = !1;
          if ((0, r.kG)(t.backend), t.backend.isCollaborationPermissionsEnabled() && e instanceof o.x_) {
            const r = (0, u.GA)(t, e);
            n = !!r && (0, s.os)(r, t);
          }
          const i = !n && !(0, s.CM)(e, t) && !(0, s.Kd)(e, t);
          if (I(t) && (!("isSignature" in e) || !e.isSignature)) return !0;
          if (C(t) || i) return !0;
          if (e instanceof a.FN && (e = e.parentAnnotation), !(e instanceof o.gd || e instanceof o.Qi) && !e.note && e.locked) return e.locked;
          if (e.locked && e.lockedContents) return !0;
          if (e.readOnly && (!(e instanceof o.x_) || !(e instanceof o.R1))) return e.readOnly;
          if (t.isEditableAnnotation) return !t.isEditableAnnotation(e);
          if (!S(t) || !b(t)) {
            if (0 === t.editableAnnotationTypes.size) return !0;
            if (t.editableAnnotationTypes.find(t => e instanceof t)) return !1;
          }
          return !0;
        }
        function x(e, t) {
          const n = !(0, s.kR)(e, t) && !(0, s.Ss)(e, t);
          return !(T(t) && !C(t) && !n) || (t.isEditableComment ? !t.isEditableComment(e) : !!S(t) && b(t));
        }
        function D(e, t, n) {
          let {
            features: r,
            backend: a,
            backendPermissions: s,
            documentPermissions: l,
            readOnlyEnabled: u,
            editableAnnotationTypes: c
          } = t;
          if (e === o.Jn && !T({
            features: r,
            backend: a
          })) return !0;
          if (e === i.Z && !r.includes(d.q.REDACTIONS)) return !0;
          if (e === o.UX && n && !r.includes(d.q.MEASUREMENT_TOOLS)) return !0;
          return !!I({
            features: r
          }) || !(!S({
            backendPermissions: s,
            documentPermissions: l,
            readOnlyEnabled: u
          }) || !b({
            backendPermissions: s,
            documentPermissions: l,
            readOnlyEnabled: u
          })) || !c.find(t => e === t || e.prototype instanceof t || t.prototype instanceof e);
        }
        function C(e) {
          return e.backendPermissions.readOnly;
        }
        function S(e) {
          let {
            backendPermissions: t,
            documentPermissions: n,
            readOnlyEnabled: r
          } = e;
          return t.readOnly || !n.modification || r !== p.J.NO;
        }
        function E(e) {
          return (e.documentPermissions.annotationsAndForms || e.documentPermissions.fillForms) && e.formsEnabled;
        }
        function _(e) {
          return E(e) && P(e.backend) && e.features.includes(d.q.FORM_DESIGNER);
        }
        function P(e) {
          return (0, r.kG)(e), e.isUsingInstantProvider() || "STANDALONE" === e.type;
        }
        function k(e) {
          return (0, r.kG)(e), e.isUsingInstantProvider() || "STANDALONE" === e.type;
        }
        function A(e) {
          let {
            features: t,
            backendPermissions: n,
            documentPermissions: r,
            readOnlyEnabled: o
          } = e;
          return t.includes(d.q.DOCUMENT_EDITING) && !(n.readOnly || !r.modification || o === p.J.VIA_VIEW_STATE || o === p.J.VIA_BACKEND_PERMISSIONS);
        }
        function z(e) {
          let {
            features: t,
            backendPermissions: n,
            documentPermissions: r,
            readOnlyEnabled: o
          } = e;
          return t.includes(d.q.CONTENT_EDITING) && !(n.readOnly || !r.modification || o === p.J.VIA_VIEW_STATE || o === p.J.VIA_BACKEND_PERMISSIONS);
        }
        function T(e) {
          let {
            features: t,
            backend: n
          } = e;
          return (0, r.kG)(n), t.includes(d.q.COMMENTS) && ("STANDALONE" === n.type || "SERVER" === n.type && n.isUsingInstantProvider());
        }
        function O(e) {
          let {
            features: t,
            backend: n
          } = e;
          return (0, r.kG)(n), t.includes(d.q.MEASUREMENT_TOOLS) && ("STANDALONE" === n.type || "SERVER" === n.type);
        }
        function I(e) {
          let {
            features: t
          } = e;
          return !R(t) && t.includes(d.q.ELECTRONIC_SIGNATURES);
        }
        function F(e, t) {
          return !!(t === l.H.LEGACY_SIGNATURES || e.includes(d.q.FORMS) && (e.includes(d.q.ELECTRONIC_SIGNATURES) || e.includes(d.q.DIGITAL_SIGNATURES)));
        }
        function M(e, t, n) {
          let {
            backendPermissions: r,
            documentPermissions: i,
            isEditableAnnotation: a,
            editableAnnotationTypes: s,
            readOnlyEnabled: l
          } = n;
          return e.readOnly || a && !a(t) || !s.has(o.x_) || !c.Options.IGNORE_DOCUMENT_PERMISSIONS && !i.fillForms && !i.annotationsAndForms || r.readOnly || l !== p.J.NO;
        }
        function R(e) {
          return e.includes(d.q.WEB_ANNOTATION_EDITING) || e.includes(d.q.ANNOTATION_EDITING);
        }
      },
      53217: (e, t, n) => {
        "use strict";

        n.d(t, {
          $u: () => s,
          Qk: () => l,
          Sk: () => i,
          d: () => o,
          oH: () => u
        });
        var r = n(15359);
        function o() {
          return "object" == typeof navigator && "string" == typeof navigator.userAgent && navigator.userAgent.indexOf("Electron/") >= 0;
        }
        function i() {
          const e = c()[atob("cmVxdWlyZQ==")];
          return o() && "undefined" != typeof window && window && window.process && window.process.type && "function" == typeof e;
        }
        function a() {
          let e;
          try {
            e = u("@electron/remote");
          } catch (t) {
            if ("MODULE_NOT_FOUND" !== t.code) throw t;
            try {
              e = u("electron").remote;
            } catch (e) {
              (0, r.vU)(`Failed to load the remote module package. PSPDFKit for Web needs access to it in order to work in Electron.\n        Please read our Electron guides to help you set it up: https://pspdfkit.com/getting-started/electron/\n        ${t.message}\n        ${e.message}`);
            }
          }
          return e;
        }
        function s() {
          if (!o()) return null;
          if (!i()) return null;
          try {
            const e = u("fs"),
              t = a().app.getAppPath() + "/package.json";
            return JSON.parse(e.readFileSync(t).toString()).name;
          } catch (e) {
            throw new Error(`There was an error parsing this project's \`package.json\`: ${e.message}`);
          }
        }
        function l() {
          if (!o()) return null;
          try {
            return `file://${a().app.getAppPath()}/node_modules/pspdfkit/dist/`;
          } catch (e) {
            return null;
          }
        }
        function u(e) {
          return (0, c()[atob("cmVxdWlyZQ==")])(e);
        }
        function c() {
          return "undefined" != typeof window ? window : "undefined" != typeof self ? self : n.g;
        }
      },
      75665: (e, t, n) => {
        "use strict";

        n.d(t, {
          B: () => o
        });
        var r = n(33383);
        function o(e, t) {
          return "string" == typeof e && t === r.x.FlutterForWeb;
        }
      },
      72110: (e, t, n) => {
        "use strict";

        n.d(t, {
          $u: () => r.$u,
          AL: () => o.A,
          B0: () => i.B,
          Qk: () => r.Qk,
          Sk: () => r.Sk,
          d: () => r.d,
          oH: () => r.oH
        });
        var r = n(53217),
          o = n(49843),
          i = n(75665);
      },
      49843: (e, t, n) => {
        "use strict";

        function r(e, t) {
          return "string" == typeof e && (null == t ? void 0 : t.startsWith("Maui_"));
        }
        n.d(t, {
          A: () => r
        });
      },
      46364: (e, t, n) => {
        "use strict";

        function r(e) {
          return new Promise((t, n) => {
            let r = 0;
            const o = [];
            let i = !1;
            const a = () => {
              r >= e.length && (i ? n(o) : t(o));
            };
            a(), e.forEach((e, t) => {
              e.then(e => {
                r += 1, o[t] = e, a();
              }).catch(e => {
                r += 1, o[t] = e, i = !0, a();
              });
            });
          });
        }
        function o(e, t) {
          let n = !1;
          return {
            promise: new Promise((t, r) => {
              e.then(e => !n && t(e), e => !n && r(e));
            }),
            cancel() {
              n = !0, t && t();
            }
          };
        }
        function i(e, t) {
          return new Promise(function (n, r) {
            e.then(n, r), setTimeout(function () {
              r(Error("promise:timeout"));
            }, t);
          });
        }
        function a() {
          let e, t;
          return {
            promise: new Promise((n, r) => {
              e = n, t = r;
            }),
            resolve: e,
            reject: t
          };
        }
        n.d(t, {
          Vs: () => i,
          d6: () => a,
          jK: () => r,
          uZ: () => o
        });
      },
      92537: (e, t, n) => {
        "use strict";

        function r() {
          let e = 1;
          return void 0 !== window.devicePixelRatio && (e = window.devicePixelRatio), e;
        }
        n.d(t, {
          L: () => r
        });
      },
      23301: (e, t, n) => {
        "use strict";

        n.d(t, {
          BP: () => C,
          D7: () => x,
          G8: () => v,
          cL: () => S,
          er: () => D
        });
        var r = n(35369),
          o = n(15359),
          i = n(87996),
          a = n(74814),
          s = n(45249),
          l = n(5705);
        function u(e) {
          switch (e) {
            case a.V.TOP:
              return {
                mx: 0,
                my: -1
              };
            case a.V.BOTTOM:
              return {
                mx: 0,
                my: 1
              };
            case a.V.LEFT:
              return {
                mx: -1,
                my: 0
              };
            case a.V.RIGHT:
              return {
                mx: 1,
                my: 0
              };
            case a.V.TOP_LEFT:
              return {
                mx: -1,
                my: -1
              };
            case a.V.TOP_RIGHT:
              return {
                mx: 1,
                my: -1
              };
            case a.V.BOTTOM_RIGHT:
              return {
                mx: 1,
                my: 1
              };
            case a.V.BOTTOM_LEFT:
              return {
                mx: -1,
                my: 1
              };
          }
          throw new o.p2("Expected `getMultipliersFromResizeStartingAnchor` to be called with a valid `ResizeStartingAnchor` value.");
        }
        function c(e, t, n, r, o) {
          const i = u(t);
          let a,
            s = e.width + i.mx * n.x,
            l = e.height + i.my * n.y;
          return o && r && (i.mx > 0 && e.left + s > r.width ? (s = r.width - e.left, a = "width") : i.mx < 0 && s - e.width > e.left && (s = e.left + e.width, a = "width"), i.my > 0 && e.top + l > r.height ? (l = r.height - e.top, a = "height") : i.my < 0 && l - e.height > e.top && (l = e.top + e.height, a = "height")), {
            rect: e.set("width", s).set("height", l),
            keepToSide: a
          };
        }
        function d(e, t, n, r, o) {
          const i = u(t),
            a = -1 * i.mx * (e.width - e.width * n),
            l = -1 * i.my * (e.height - e.height * r),
            c = o ? new s.E9({
              x: i.mx >= 0 ? 0 : Math.max(-e.left, a),
              y: i.my >= 0 ? 0 : Math.max(-e.top, l)
            }) : new s.E9({
              x: i.mx >= 0 ? 0 : a,
              y: i.my >= 0 ? 0 : l
            });
          return {
            translation: c,
            dragDifference: o ? new s.E9({
              x: i.mx >= 0 ? 0 : a - c.x,
              y: i.my >= 0 ? 0 : l - c.y
            }) : new s.E9({
              x: 0,
              y: 0
            })
          };
        }
        function p(e, t) {
          const n = u(t);
          return new s.E9({
            x: e.boundingBox.left + e.boundingBox.width / 2 + -1 * n.mx * e.boundingBox.width / 2,
            y: e.boundingBox.top + e.boundingBox.height / 2 + -1 * n.my * e.boundingBox.height / 2
          });
        }
        function h(e, t, n, r) {
          let o = e.lines;
          const i = p(e, r);
          return o = o.map(e => e.map(e => e.translate(i.scale(-1)).scale(t, n).translate(i))), o;
        }
        function f(e, t, n, o) {
          let i;
          if (e instanceof s.o9) i = (0, r.aV)([e.startPoint, e.endPoint]);else {
            if (!(e instanceof s.Hi || e instanceof s.om)) return (0, r.aV)();
            i = e.points;
          }
          const a = p(e, o);
          return i = i.map(e => e.translate(a.scale(-1)).scale(t, n).translate(a)), i;
        }
        function m(e, t, n) {
          const r = v(e);
          if (r > 0) {
            const o = e.boundingBox,
              i = o.width < r ? o.width : r;
            if (t.width < i) {
              const e = t.width;
              if (t = n ? y("width", o, t.set("width", i)) : t.set("width", i), o.left !== t.left) {
                const n = t.width - e;
                t = t.set("left", t.left + n);
              }
            }
            const a = o.height < r ? o.height : r;
            if (t.height < a) {
              const e = t.height;
              if (t = n ? y("height", o, t.set("height", a)) : t.set("height", a), o.top !== t.top) {
                const n = t.height - e;
                t = t.set("top", t.top + n);
              }
            }
          }
          return t;
        }
        function g(e, t, n, r) {
          const o = e.boundingBox;
          let i = t.width;
          r.maxWidth && i > r.maxWidth && (i = r.maxWidth), r.minWidth && i < r.minWidth && (i = r.minWidth);
          const a = t.width;
          if (t = n ? y("width", o, t.set("width", i)) : t.set("width", i), o.left !== t.left) {
            const e = t.width - a;
            t = t.set("left", t.left + e);
          }
          let s = t.height;
          r.maxHeight && t.height > r.maxHeight && (s = r.maxHeight), r.minHeight && t.height < r.minHeight && (s = r.minHeight);
          const l = t.height;
          if (t = n ? y("height", o, t.set("height", s)) : t.set("height", s), o.top !== t.top) {
            const e = t.height - l;
            t = t.set("top", t.top + e);
          }
          return t;
        }
        function v(e) {
          const {
            MIN_IMAGE_ANNOTATION_SIZE: t,
            MIN_STAMP_ANNOTATION_SIZE: n,
            MIN_TEXT_ANNOTATION_SIZE: r,
            MIN_INK_ANNOTATION_SIZE: o,
            MIN_SHAPE_ANNOTATION_SIZE: a,
            MIN_WIDGET_ANNOTATION_SIZE: l
          } = i.Options;
          switch (e.constructor) {
            case s.sK:
              return t;
            case s.GI:
              return n;
            case s.gd:
              return r;
            case s.Zc:
              return o;
            case s.o9:
            case s.b3:
            case s.Xs:
            case s.om:
            case s.Hi:
              return a;
            case s.x_:
              return l;
            default:
              return 0;
          }
        }
        function y(e, t, n) {
          if (!e) return function (e, t) {
            if (0 === e.height || 0 === e.width) return t;
            const n = e.width / e.height,
              r = (t.height + n * t.width) / (n ** 2 + 1);
            return t.set("height", r).set("width", r * n);
          }(t, n);
          if (0 === t.width || 0 === t.height || 0 === n[e]) return n;
          const r = "width" === e ? "height" : "width",
            o = t[e] / t[r];
          return n.set(r, n[e] / o);
        }
        const b = {
            0: a.V.BOTTOM_RIGHT,
            90: a.V.TOP_RIGHT,
            180: a.V.TOP_LEFT,
            270: a.V.BOTTOM_LEFT
          },
          w = {
            [a.V.TOP]: a.V.TOP_RIGHT,
            [a.V.BOTTOM]: a.V.BOTTOM_RIGHT,
            [a.V.LEFT]: a.V.BOTTOM_LEFT,
            [a.V.RIGHT]: a.V.BOTTOM_RIGHT,
            [a.V.TOP_LEFT]: a.V.TOP_LEFT,
            [a.V.TOP_RIGHT]: a.V.TOP_RIGHT,
            [a.V.BOTTOM_LEFT]: a.V.BOTTOM_LEFT,
            [a.V.BOTTOM_RIGHT]: a.V.BOTTOM_RIGHT
          };
        function x(e, t, n, r) {
          let o = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4],
            i = arguments.length > 5 ? arguments[5] : void 0,
            p = arguments.length > 6 ? arguments[6] : void 0,
            x = arguments.length > 7 ? arguments[7] : void 0;
          const C = e.boundingBox;
          let S;
          if ((0, l.o0)(e) && !(0, l.Ag)(e)) {
            const r = u(n),
              o = new s.E9({
                x: C.width / 2 * r.mx,
                y: C.height / 2 * r.my
              }),
              i = o.rotate(e.rotation),
              a = new s.E9({
                x: i.x + t.x,
                y: i.y + t.y
              }).rotate(-e.rotation);
            S = new s.E9({
              x: a.x - o.x,
              y: a.y - o.y
            });
          } else S = t;
          const E = c(C, n, S, i, p);
          let _ = E.rect;
          if (r && (_ = y(E.keepToSide, C, _)), o && x && (null != x && x.maxHeight || null != x && x.maxWidth || null != x && x.minHeight || null != x && x.minWidth)) {
            const t = v(e);
            x.minHeight = x.minHeight ? x.minHeight : t, x.minWidth = x.minWidth ? x.minWidth : t;
          } else o && (_ = m(e, _, r));
          const P = 0 !== C.width ? _.width / C.width : 0,
            k = 0 !== C.height ? _.height / C.height : 0,
            {
              translation: A,
              dragDifference: z
            } = d(C, n, P, k, p);
          _ = _.set("width", _.width + z.x).set("height", _.height + z.y), _ = _.translate(A), (null != x && x.maxHeight || null != x && x.maxWidth || null != x && x.minHeight || null != x && x.minWidth) && (_ = g(e, _, r, x));
          const T = function () {
            const t = e.set("boundingBox", _),
              o = Math.sqrt(P * k);
            let i;
            return t instanceof s.gd ? (0, l.Ag)(e) && n === b[e.rotation] || !(0, l.Ag)(e) && n === a.V.BOTTOM_RIGHT ? t.set("fontSize", t.fontSize * o).set("isFitting", !0) : t.set("isFitting", !0) : t instanceof s.Zc ? t.withMutations(e => {
              e.set("lines", h(t, P, k, r ? w[n] : n)), e.set("lineWidth", t.lineWidth * o);
            }) : t instanceof s.o9 ? (i = f(t, P, k, n), t.withMutations(e => {
              e.set("startPoint", i.get(0)), e.set("endPoint", i.get(1));
            })) : t instanceof s.Hi || t instanceof s.om ? (i = f(t, P, k, n), t.withMutations(e => {
              e.set("boundingBox", _), e.set("points", i);
            })) : t;
          }();
          return D(T, C);
        }
        function D(e, t) {
          if ((0, l.o0)(e) && !(0, l.Ag)(e)) {
            const n = new s.E9({
              x: e.boundingBox.getCenter().x - t.getCenter().x,
              y: e.boundingBox.getCenter().y - t.getCenter().y
            }).rotate(e.rotation);
            return e.update("boundingBox", e => e.set("left", t.left + n.x - (e.width - t.width) / 2).set("top", t.top + n.y - (e.height - t.height) / 2));
          }
          return e;
        }
        function C(e, t) {
          const {
              width: n,
              height: r
            } = e,
            o = t.width / n,
            i = t.height / r,
            a = Math.min(o, i);
          return new s.$u({
            width: n * a,
            height: r * a
          });
        }
        function S(e) {
          switch (e) {
            case a.V.TOP_LEFT:
              return "Top-Left";
            case a.V.TOP:
              return "Top";
            case a.V.TOP_RIGHT:
              return "Top-Right";
            case a.V.LEFT:
              return "Left";
            case a.V.RIGHT:
              return "Right";
            case a.V.BOTTOM_LEFT:
              return "Bottom-Left";
            case a.V.BOTTOM:
              return "Bottom";
            case a.V.BOTTOM_RIGHT:
              return "Bottom-Right";
            default:
              (0, o.Rz)(e);
          }
        }
      },
      5705: (e, t, n) => {
        "use strict";

        n.d(t, {
          Ag: () => d,
          Mg: () => v,
          az: () => l,
          h4: () => u,
          kv: () => c,
          o0: () => p,
          sw: () => s
        });
        var r = n(45249),
          o = n(33427),
          i = n(72938),
          a = n.n(i);
        function s(e, t, n, i) {
          let a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1;
          const s = e.set("rotation", t);
          if (n && i) {
            const t = l(s),
              i = (0, o.SY)(t, a);
            if (!new r.UL({
              left: 0,
              top: 0,
              width: n.width,
              height: n.height
            }).isRectInside(i)) return e;
          }
          return s;
        }
        function l(e) {
          const {
              boundingBox: t,
              rotation: n
            } = e,
            {
              width: o,
              height: i
            } = t;
          if (!p(e)) return e;
          const a = new r.E9({
              x: -o / 2,
              y: -i / 2
            }),
            s = new r.E9({
              x: o / 2,
              y: -i / 2
            }),
            l = new r.E9({
              x: o / 2,
              y: i / 2
            }),
            u = new r.E9({
              x: -o / 2,
              y: i / 2
            }),
            c = a.rotate(n),
            d = s.rotate(n),
            h = l.rotate(n),
            f = u.rotate(n),
            m = Math.min(c.x, d.x, h.x, f.x),
            g = Math.min(c.y, d.y, h.y, f.y),
            v = Math.max(c.x, d.x, h.x, f.x),
            y = Math.max(c.y, d.y, h.y, f.y),
            b = t.getCenter();
          return e.set("boundingBox", new r.UL({
            left: b.x + m,
            top: b.y + g,
            width: v - m,
            height: y - g
          }));
        }
        function u(e, t) {
          if (p(e)) {
            const n = t || function (e, t) {
              if (void 0 === t || 0 === t) return e.getSize();
              const n = Math.floor(t / 360);
              -1 === Math.sign(t) && (t += 360 + 360 * n);
              let o = (t -= 360 * n) % 180;
              const i = o >= 90,
                a = i ? e.height : e.width,
                s = i ? e.width : e.height;
              if (o %= 90, 45 === o) {
                if (a !== s) {
                  const e = Math.min(a, s);
                  return new r.$u({
                    width: Math.sqrt(2) * e,
                    height: Math.sqrt(2) * e
                  });
                }
                return new r.$u({
                  width: Math.sqrt(2) * a,
                  height: Math.sqrt(2) * s
                });
              }
              const l = o * (Math.PI / 180);
              return new r.$u({
                width: (a * Math.cos(l) - s * Math.sin(l)) / Math.cos(2 * l),
                height: (s * Math.cos(l) - a * Math.sin(l)) / Math.cos(2 * l)
              });
            }(e.boundingBox, e.rotation);
            return e.set("boundingBox", new r.UL({
              left: e.boundingBox.left + (e.boundingBox.width - n.width) / 2,
              top: e.boundingBox.top + (e.boundingBox.height - n.height) / 2,
              width: n.width,
              height: n.height
            }));
          }
          return e;
        }
        function c(e) {
          return "number" == typeof e.rotation && e.rotation % 360 != 0;
        }
        function d(e) {
          return "number" == typeof e.rotation && Math.abs(e.rotation) % 90 == 0 && Math.abs(e.rotation) % 360 != 0;
        }
        function p(e) {
          return (0, o.a$)(e) && c(e);
        }
        let h, f, m, g;
        function v(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "grab";
          if (h || (h = new DOMParser(), f = h.parseFromString(a(), "image/svg+xml"), m = f.querySelector("svg"), g = new XMLSerializer()), m && (m.style.transform = `rotate(${-e}deg)`), g) {
            return `url("${`data:image/svg+xml;utf8,${encodeURIComponent(g.serializeToString(f))}`}") 15 15, ${t}`;
          }
          return t;
        }
      },
      11192: (e, t, n) => {
        "use strict";

        n.d(t, {
          Q: () => w,
          U2: () => x,
          ZJ: () => m,
          a7: () => f,
          mB: () => b
        });
        var r = n(35369),
          o = n(15359),
          i = n(93113),
          a = n(65160),
          s = n(12705),
          l = n(45249),
          u = n(98179),
          c = n(69867),
          d = n(38852),
          p = n(26564),
          h = n.n(p);
        function f(e) {
          var t, n;
          const {
            document: r
          } = e;
          if (u.TL) {
            var i;
            const {
                activeElement: t,
                body: n
              } = r,
              a = t && 1 === t.nodeType && t !== n;
            if (null !== (i = e.getSelection()) && void 0 !== i && i.isCollapsed && !a) return;
            const s = r.createElement("input");
            return s.style.position = "fixed", s.style.left = "50vw", s.style.top = "50vh", s.readOnly = !0, (0, o.kG)(r.documentElement, "no document object found"), r.documentElement.appendChild(s), s.focus(), s.blur(), void s.remove();
          }
          var a;
          if (null !== (t = e.getSelection()) && void 0 !== t && t.empty) null === (a = e.getSelection()) || void 0 === a || a.empty();else if (null !== (n = e.getSelection()) && void 0 !== n && n.removeAllRanges) {
            var s;
            null === (s = e.getSelection()) || void 0 === s || s.removeAllRanges();
          }
        }
        function m(e, t) {
          const n = t.startAndEndIds();
          if (!n) return (0, r.D5)();
          const {
            startTextLineId: i,
            endTextLineId: a,
            startPageIndex: s,
            endPageIndex: l
          } = n;
          return (0, r.D5)(e.pages.filter(e => e.contentBlocks && e.pageIndex >= s && e.pageIndex <= l).map(e => {
            const t = y(e.contentBlocks);
            let n;
            return e.pageIndex === s && e.pageIndex === l ? n = t.filter(e => ((0, o.kG)((0, d.hj)(e.id)), e.id >= i && e.id <= a)) : e.pageIndex === s ? n = t.filter(e => ((0, o.kG)((0, d.hj)(e.id)), e.id >= i)) : e.pageIndex === l ? n = t.filter(e => ((0, o.kG)((0, d.hj)(e.id)), e.id <= a)) : ((0, o.kG)(e.contentBlocks), n = y(e.contentBlocks)), [e.pageIndex, n];
          }));
        }
        const g = (e, t, n, r) => {
            var i;
            (0, o.kG)((0, d.hj)(t.pageIndex));
            const a = {
              transform: n && n.scaleX > 0 && n.scaleY > 0 ? `scale(${n.scaleX * e.viewportState.zoomLevel}, ${n.scaleY * e.viewportState.zoomLevel})` : ""
            };
            return new c.f(null === (i = e.frameWindow) || void 0 === i ? void 0 : i.document, r, a, h().line, e.shadowRoot);
          },
          v = (e, t, n, r) => {
            const i = e.pages.get(t);
            (0, o.kG)(i && i.contentBlocks, "Page not found or page has no blocks");
            const a = function (e, t) {
              const n = t.split(".").map(Number);
              function r(e, t) {
                if (0 === t.length) return e;
                const n = t[0],
                  o = e.contentBlocks.find(e => e.id === n);
                return o ? r(o, t.slice(1)) : null;
              }
              for (let t = 0; t < e.size; t++) {
                const o = e.get(t);
                if (o && o.id === n[0]) {
                  const e = r(o, n.slice(1));
                  if (e) return e;
                }
              }
              return null;
            }(i.contentBlocks, r);
            (0, o.kG)(a, "ContentBlock not found");
            const s = a.textLines;
            (0, o.kG)(s, "TextLines not found");
            return s.find(e => e.id === n);
          };
        function y(e) {
          const t = [];
          function n(e, t) {
            t.push(...e.textLines), e.contentBlocks.forEach(e => {
              n(e, t);
            });
          }
          return e.forEach(e => {
            n(e, t);
          }), (0, r.aV)(t);
        }
        function b(e, t) {
          const n = t.startAndEndIds();
          if (!n) return null;
          const {
              startTextLineId: i,
              endTextLineId: l,
              startNestedContentBlockId: u,
              endNestedContentBlockId: c,
              startPageIndex: p,
              endPageIndex: h
            } = n,
            f = e.pages.get(p);
          (0, o.kG)(f, "Index of start page is out of bounds");
          const m = e.pages.get(h);
          if ((0, o.kG)(m, "Index of end page is out of bounds"), i === l && p === h) {
            const n = v(e, p, i, u);
            if (!n) return null;
            (0, o.kG)((0, d.hj)(n.id));
            const l = f.textLineScales && f.textLineScales.get(n.id),
              c = (0, a.LD)((0, s.HI)(e), n),
              h = c.substring(0, t.startOffset),
              m = c.substring(t.startOffset, t.endOffset),
              y = c.substring(t.endOffset),
              b = g(e, n, l, (0, r.aV)([h, m, y])),
              w = b.measure().get(1);
            (0, o.kG)(w);
            const x = w.scale(1 / e.viewportState.zoomLevel).translate(n.boundingBox.getLocation());
            return b.remove(), {
              startRect: x,
              endRect: x
            };
          }
          {
            const n = v(e, p, i, u),
              y = v(e, h, l, c);
            if (!n || !y) return null;
            (0, o.kG)((0, d.hj)(n.id)), (0, o.kG)((0, d.hj)(y.id));
            const b = f.textLineScales && f.textLineScales.get(n.id),
              w = m.textLineScales && m.textLineScales.get(y.id),
              x = (0, a.LD)((0, s.HI)(e), n),
              D = x.substring(0, t.startOffset),
              C = x.substring(t.startOffset),
              S = (0, a.LD)((0, s.HI)(e), y),
              E = S.substring(0, t.endOffset),
              _ = S.substring(t.endOffset),
              P = g(e, n, b, (0, r.aV)([D, C])),
              k = g(e, y, w, (0, r.aV)([E, _])),
              A = P.measure().last();
            (0, o.kG)(A);
            const z = A.scale(1 / e.viewportState.zoomLevel).translate(n.boundingBox.getLocation()),
              T = k.measure().first();
            (0, o.kG)(T);
            const O = T.scale(1 / e.viewportState.zoomLevel).translate(y.boundingBox.getLocation());
            return P.remove(), k.remove(), {
              startRect: z,
              endRect: O
            };
          }
        }
        function w(e, t) {
          const {
            startTextLineId: n,
            endTextLineId: r,
            startNestedContentBlockId: i,
            endNestedContentBlockId: a,
            startPageIndex: s,
            endPageIndex: l,
            textRange: u
          } = t;
          (0, o.kG)((0, d.hj)(s));
          const c = e.pages.get(s);
          (0, o.kG)((0, d.hj)(l)), (0, o.kG)(c, "Index of start page is out of bounds");
          const p = e.pages.get(l);
          if ((0, o.kG)(p, "Index of end page is out of bounds"), (0, o.kG)(u && (0, d.hj)(n) && (0, d.hj)(r) && (0, d.HD)(i) && (0, d.HD)(a)), n === r && s === l) {
            var h;
            const t = v(e, s, n, i);
            return null !== (h = null == t ? void 0 : t.contents.substring(u.startOffset, u.endOffset)) && void 0 !== h ? h : "";
          }
          {
            const t = v(e, s, n, i),
              o = v(e, l, r, a);
            if (!t || !o) return "";
            const c = t.contents.substring(u.startOffset),
              d = o.contents.substring(0, u.endOffset);
            return m(e, u).map((e, t) => e.map(e => e.id == n && t == s ? c : e.id == r && t == l ? d : e.contents)).valueSeq().flatten(!0).join("");
          }
        }
        function x(e, t, n) {
          const r = t.startAndEndIds(),
            o = b(e, t);
          if (!r || !o) return null;
          const {
              startTextLineId: a,
              endTextLineId: s,
              startPageIndex: u,
              endPageIndex: c
            } = r,
            {
              startRect: d,
              endRect: p
            } = o,
            h = m(e, t).map((t, r) => t.map(t => {
              let o;
              if (o = t.id == a && r == u ? d : t.id == s && r == c ? p : t.boundingBox, n) return o;
              const l = (0, i.cr)(e.viewportState, r).translate(e.viewportState.scrollPosition.scale(e.viewportState.zoomLevel));
              return o.apply(l);
            })).valueSeq().flatten(!0).toList();
          return l.UL.union(h);
        }
      },
      4325: (e, t, n) => {
        "use strict";

        n.d(t, {
          K: () => o,
          q: () => i
        });
        var r = n(87996);
        const o = e => {
            const {
              SELECTION_OUTLINE_PADDING: t
            } = r.Options;
            return t(e);
          },
          i = (e, t) => e.grow(o(t));
      },
      98260: (e, t, n) => {
        "use strict";

        n.d(t, {
          HY: () => u,
          QC: () => h,
          S9: () => v,
          W1: () => m,
          g: () => g,
          ke: () => l,
          m_: () => p,
          sD: () => c,
          xA: () => y
        });
        var r = n(96156),
          o = n(15359),
          i = n(98179);
        function a(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function s(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? a(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function l(e, t) {
          return e ? {
            document: e,
            addEventListener: ((t, n, r) => {
              const o = ["touchstart", "touchmove", "scroll"].includes(t) ? s(s({}, r), {}, {
                passive: !0
              }) : r;
              e.addEventListener(t, n, o);
            }).bind(e),
            removeEventListener: e.removeEventListener.bind(e),
            Node: t.Node
          } : t;
        }
        function u(e) {
          if (e) {
            const t = i.vU ? e.ownerDocument.getSelection() : function (e) {
              if ("function" == typeof e.getSelection) return e.getSelection();
              return null;
            }(e);
            if (t) return function (e, t) {
              const n = function (e, t) {
                if (!e.isCollapsed) return !1;
                document.createRange().selectNodeContents(t);
                const n = document.createRange();
                return !(!e.anchorNode || !e.focusNode) && (n.setStart(e.anchorNode, e.anchorOffset), n.setEnd(e.focusNode, e.focusOffset), d(n, t) && function (e) {
                  return "" !== e.toString();
                }(e));
              }(e, t);
              return {
                selection: e,
                isFalseCollapse: n
              };
            }(t, e);
          }
          return function (e, t) {
            const n = {
              selection: null,
              isFalseCollapse: !1
            };
            if (e && !e.isCollapsed) {
              d(e.getRangeAt(0), t) && (n.selection = e);
            }
            return n;
          }(document.getSelection(), e);
        }
        function c(e) {
          return {
            selection: null == e ? void 0 : e.getSelection(),
            isFalseCollapse: !1
          };
        }
        function d(e, t) {
          return t.contains(e.startContainer) && t.contains(e.endContainer);
        }
        function p(e, t, n) {
          let r = function (e, t, n) {
            let r = e;
            for (; r && r.shadowRoot;) {
              const e = r.shadowRoot.elementFromPoint(t, n);
              if (!e || e === r) break;
              r = e;
            }
            return r;
          }(e, t, n);
          return r || (r = function (e, t, n) {
            let r,
              o = e;
            for (; !r && o;) {
              const e = o.parentElement || o.getRootNode().host;
              e && (r = e.shadowRoot ? e.shadowRoot.elementFromPoint(t, n) : document.elementFromPoint(t, n)), o = e;
            }
            return r;
          }(e, t, n)), r && r.nodeType === Node.ELEMENT_NODE ? function (e, t, n) {
            if ("P" !== e.tagName && "SPAN" !== e.tagName) return null;
            let r = null,
              o = 1 / 0;
            const i = document.createRange();
            function a(e) {
              i.selectNodeContents(e);
              const a = i.getBoundingClientRect(),
                s = Math.hypot(a.left - t, a.top - n);
              s < o && (r = e, o = s);
            }
            for (const t of e.childNodes) if (t.nodeType === Node.TEXT_NODE) a(t);else if (t.nodeType === Node.ELEMENT_NODE && "SPAN" === t.tagName) for (const e of t.childNodes) e.nodeType === Node.TEXT_NODE && a(e);
            return r;
          }(r, t, n) : r;
        }
        function h(e, t, n) {
          const r = document.createRange();
          let i = 0,
            a = 1 / 0;
          const s = function (e) {
            const t = document.createElement("span");
            return t.style.position = "absolute", t.style.whiteSpace = "pre", document.body.appendChild(t), function (e, t) {
              const n = window.getComputedStyle(e);
              for (const e of n) t.style[e] = n[e];
            }(e.parentNode, t), t;
          }(e);
          (0, o.kG)(e.textContent);
          for (let o = 0; o <= e.textContent.length; o++) {
            s.textContent = e.textContent.substring(0, o), r.setStart(e, o), r.setEnd(e, o);
            const l = f(r, t, n);
            l < a && (a = l, i = o);
          }
          return s.remove(), i;
        }
        function f(e, t, n) {
          const r = e.getBoundingClientRect();
          return Math.hypot(r.left - t, r.top - n);
        }
        function m(e) {
          for (; e;) {
            if (e.classList && e.classList.contains("PSPDFKit-Rich-Text-Editor") || e.classList && e.classList.contains("BaselineUI-Editor")) return !0;
            e = e.parentNode;
          }
          return !1;
        }
        function g(e, t) {
          let n, r, i, a;
          (0, o.kG)(e.node && t.node);
          const s = e.node.compareDocumentPosition(t.node);
          return s & Node.DOCUMENT_POSITION_FOLLOWING ? ({
            node: n,
            offset: r
          } = e, {
            node: i,
            offset: a
          } = t) : s & Node.DOCUMENT_POSITION_PRECEDING ? ({
            node: n,
            offset: r
          } = t, {
            node: i,
            offset: a
          } = e) : (n = i = e.node, r = Math.min(e.offset, t.offset), a = Math.max(e.offset, t.offset)), {
            startNode: n,
            startOffset: r,
            endNode: i,
            endOffset: a
          };
        }
        function v(e) {
          let t = e;
          for (; t && !["P", "DIV", "SECTION", "ARTICLE"].includes(t.nodeName);) t = t.parentNode;
          if (t) {
            const e = document.createRange();
            return e.selectNodeContents(t), e;
          }
          return null;
        }
        function y(e, t, n) {
          const r = document.createRange();
          let o = 0,
            i = e.textContent.length;
          const a = h(e, t, n);
          for (let t = a; t >= 0; t--) if (" " === e.textContent[t] || 0 === t) {
            o = 0 === t ? 0 : t + 1;
            break;
          }
          for (let t = a; t < e.textContent.length; t++) if (" " === e.textContent[t] || t === e.textContent.length - 1) {
            i = t;
            break;
          }
          return r.setStart(e, o), r.setEnd(e, i), r;
        }
      },
      57943: (e, t, n) => {
        "use strict";

        n.d(t, {
          CW: () => b,
          Hx: () => w,
          Hz: () => E,
          Pr: () => f,
          R4: () => x,
          RR: () => y,
          Rv: () => v,
          rr: () => D,
          sS: () => h
        });
        var r = n(35369),
          o = n(15359),
          i = n(45249),
          a = n(94732),
          s = n(12559),
          l = n(48625),
          u = n(10983),
          c = n(33427);
        const d = (e, t) => e - t,
          p = (e, t) => {
            const n = t.reduce((t, n, r, o) => {
                var i, a;
                const s = {
                    x: t.x.concat([n.x]),
                    y: t.y.concat([n.y])
                  },
                  l = o.get(r + 1) || o.get(r - 1) || n,
                  u = l.x - n.x,
                  c = l.y - n.y;
                if (0 === u && 0 === c) return s;
                const d = Math.sqrt(u ** 2 + c ** 2),
                  p = (0 === r ? "lineCaps" in e && null !== (i = e.lineCaps) && void 0 !== i && i.start ? 2.5 * e.strokeWidth : e.strokeWidth / 2 : r === o.size - 1 && "lineCaps" in e && null !== (a = e.lineCaps) && void 0 !== a && a.end ? 2.5 * e.strokeWidth : e.strokeWidth / 2) / d;
                return {
                  x: s.x.concat([n.x - p * c, n.x + p * c]),
                  y: s.y.concat([n.y - p * u, n.y + p * u])
                };
              }, {
                x: [],
                y: []
              }),
              [r, ...o] = n.x.sort(d),
              i = o.slice(-1)[0] || r,
              [a, ...s] = n.y.sort(d);
            return {
              minX: r,
              maxX: i,
              minY: a,
              maxY: s.slice(-1)[0] || a
            };
          };
        function h(e) {
          switch (e) {
            case i.o9:
              return e => {
                (0, o.kG)(e instanceof i.o9, "Expected `lineAnnotation` to be an instance of `LineAnnotation`");
                const {
                  minX: t,
                  maxX: n,
                  minY: a,
                  maxY: s
                } = p(e, (0, r.aV)([e.startPoint, e.endPoint]));
                return new i.UL({
                  width: n - t + 2 * e.strokeWidth,
                  height: s - a + 2 * e.strokeWidth,
                  top: a - e.strokeWidth,
                  left: t - e.strokeWidth
                });
              };
            case i.b3:
            case i.Xs:
            case a.Z:
              return e => e.boundingBox;
            case i.Hi:
            case i.om:
              return e => {
                if ((0, o.kG)(e instanceof i.om || e instanceof i.Hi, "Expected `polyshapeAnnotation` to be an instance of `PolylineAnnotation` or `PolygonAnnotation`"), 0 === e.points.size) return e.boundingBox;
                const {
                    minX: t,
                    maxX: n,
                    minY: r,
                    maxY: a
                  } = p(e, e.points),
                  s = "cloudyBorderIntensity" in e && e.cloudyBorderIntensity ? e.cloudyBorderIntensity * u.St : 0;
                return new i.UL({
                  width: n - t + 2 * e.strokeWidth + 2 * s,
                  height: a - r + 2 * e.strokeWidth + 2 * s,
                  top: r - e.strokeWidth - s,
                  left: t - e.strokeWidth - s
                });
              };
            case i.gd:
              return e => {
                if ((0, c.Vc)(e)) {
                  (0, o.kG)(e instanceof i.gd, "Expected `annotation` to be a `TextAnnotation`");
                  const {
                    callout: t
                  } = e;
                  (0, o.kG)(t, "Expected `callout` to be defined");
                  const {
                    innerRectInset: n,
                    knee: r,
                    start: a,
                    end: s
                  } = t;
                  (0, o.kG)(n && a && s, "Expected `innerRectInset`, `start` and `end` to be defined");
                  const l = Math.min(e.boundingBox.left + n.left, a.x, s.x, r ? r.x : 1 / 0),
                    u = Math.min(e.boundingBox.top + n.top, a.y, s.y, r ? r.y : 1 / 0),
                    c = Math.max(e.boundingBox.left + e.boundingBox.width - n.right, a.x, s.x, r ? r.x : -1 / 0),
                    d = Math.max(e.boundingBox.top + e.boundingBox.height - n.bottom, a.y, s.y, r ? r.y : -1 / 0),
                    p = 4 * (e.borderWidth || 2);
                  let h = f(a, new i.UL({
                    left: l,
                    top: u,
                    width: c - l,
                    height: d - u
                  }), p);
                  return r && (h = f(r, h, p)), h;
                }
                return e.boundingBox;
              };
          }
          throw new o.p2("Expected `getBoundingBoxCalculator` to be called with a valid shape annotation type class value.");
        }
        function f(e, t, n) {
          const r = t.left === e.x,
            o = t.left + t.width === e.x,
            a = t.top === e.y,
            s = t.top + t.height === e.y;
          return new i.UL({
            left: r ? t.left - n : t.left,
            top: a ? t.top - n : t.top,
            width: r || o ? t.width + n : t.width,
            height: a || s ? t.height + n : t.height
          });
        }
        const m = (e, t) => new i.E9({
            x: e.x + t.weightedStrokeWidthLineRatio * t.xOffset,
            y: e.y + t.weightedStrokeWidthLineRatio * t.yOffset
          }),
          g = {
            xOffset: 0,
            yOffset: 0,
            weightedStrokeWidthLineRatio: 0
          },
          v = 6,
          y = 25;
        function b(e, t, n) {
          if (null === n) return e;
          const o = function (e) {
              return Math.min(Math.max(e, v), y);
            }(t),
            a = n.start,
            l = n.end,
            u = a ? s.O[a].width : 0,
            c = l ? s.O[l].width : 0;
          if (e.size < 2 || !u && !c) return e;
          const d = e.get(0),
            p = e.get(e.size - 1);
          if (!(d instanceof i.E9 && p instanceof i.E9)) return e;
          const h = a ? (() => {
              const t = d,
                n = e.get(1) || t;
              if (!(n instanceof i.E9)) return g;
              const r = n.x - t.x,
                a = n.y - t.y;
              return {
                xOffset: r,
                yOffset: a,
                weightedStrokeWidthLineRatio: 0 !== r || 0 !== a ? u * o / Math.sqrt(r ** 2 + a ** 2) : 0
              };
            })() : g,
            f = l && e.get(e.size - 2) instanceof i.E9 ? (() => {
              const t = p,
                n = e.get(e.size - 2) || t,
                r = -(t.x - n.x),
                i = -(t.y - n.y);
              return {
                xOffset: r,
                yOffset: i,
                weightedStrokeWidthLineRatio: 0 !== r || 0 !== i ? c * o / Math.sqrt(r ** 2 + i ** 2) : 0
              };
            })() : g;
          return e.size > 2 || !a || !l ? e.map((t, n) => 0 === n ? h.weightedStrokeWidthLineRatio <= 1 ? m(t, h) : t : n === e.size - 1 && f.weightedStrokeWidthLineRatio <= 1 ? m(t, f) : t) : h.weightedStrokeWidthLineRatio + f.weightedStrokeWidthLineRatio <= 1 ? (0, r.aV)([m(d, h), m(p, f)]) : e;
        }
        function w(e) {
          return e instanceof i.b3 || e instanceof i.Xs ? e.delete("boundingBox") : e instanceof i.Hi || e instanceof i.om ? e.delete("boundingBox").delete("points") : e instanceof i.o9 ? e.delete("boundingBox").delete("startPoint").delete("endPoint") : e;
        }
        function x(e) {
          switch (e) {
            case i.o9:
              return l.A.SHAPE_LINE;
            case i.b3:
              return l.A.SHAPE_RECTANGLE;
            case i.Xs:
              return l.A.SHAPE_ELLIPSE;
            case i.om:
              return l.A.SHAPE_POLYLINE;
            case i.Hi:
              return l.A.SHAPE_POLYGON;
            default:
              return null;
          }
        }
        function D(e) {
          let {
            points: t,
            intensity: n,
            arcRadius: r = u.St * n
          } = e;
          const o = t.reduce((e, n, o) => {
              const i = o === t.length - 1 ? t[0] : t[o + 1];
              if (k(n, i, .01)) return e;
              const a = P(n, i),
                s = Math.floor(a / (1.75 * r));
              if (a >= a / (s + 1)) {
                const t = s + 1,
                  r = (i[0] - n[0]) / t,
                  o = (i[1] - n[1]) / t;
                e.push(...Array.from({
                  length: t
                }, (e, t) => [n[0] + r * t, n[1] + o * t]));
              }
              return e;
            }, []),
            i = _(t),
            a = i ? "1" : "0",
            s = "1" === a ? "0" : "1",
            l = i ? -.3 : .3;
          return o.reduce((e, t, n) => {
            const u = o[n > 0 ? n - 1 : o.length - 1];
            if (k(t, u)) return e;
            let c = o[(n + 1) % o.length],
              d = n + 1;
            for (; k(t, c);) {
              if (d % o.length === n) return [];
              c = o[(1 + ++d) % o.length];
            }
            let p = A(t, u, r, i),
              h = A(t, c, r, !i);
            if (isNaN(p) && isNaN(h)) return e.push(`${c[0]} ${c[1]}`), e;
            isNaN(p) && (p = h + Math.PI), isNaN(h) && (h = p + Math.PI), h += l;
            const f = i ? h > p ? p + (C - h) > Math.PI ? "1" : "0" : p - h > Math.PI ? "1" : "0" : h > p ? p + (C - h) > Math.PI ? "0" : "1" : p - h > Math.PI ? "0" : "1",
              m = [t[0] + Math.cos(p) * r, t[1] - Math.sin(p) * r],
              g = [t[0] + Math.cos(h) * r, t[1] - Math.sin(h) * r];
            return e.push(0 === e.length ? `M ${m[0]} ${m[1]} A ${r} ${r} 0 ${f} ${a} ${g[0]} ${g[1]}` : ` A ${r} ${r} 0 0 ${s} ${m[0]} ${m[1]} A ${r} ${r} 0 ${f} ${a} ${g[0]} ${g[1]}`), e;
          }, []).join(" ");
        }
        const C = 2 * Math.PI,
          S = C / 360;
        function E(e) {
          let {
            boundingBox: t,
            cloudyBorderIntensity: n,
            cloudyBorderInset: r
          } = e;
          const o = r instanceof i.eB ? i.eB.applyToRect(r, t) : t,
            a = t.width / 2,
            s = t.height / 2;
          if (0 === a || 0 === s) return "";
          const l = Math.min(a, s, u.St * n),
            c = o.width / 2,
            d = o.height / 2,
            p = o.left + c,
            h = o.top + d,
            f = Array.from({
              length: 360
            }, (e, t) => {
              const n = S * t;
              return [p + c * Math.cos(n), h + d * Math.sin(n)];
            }),
            m = f.length;
          let g = 1.75 * l;
          const v = z(f),
            y = v / g;
          g += y > 0 ? v % g / y : 0;
          let b = 0;
          const w = f.reduce((e, t, n) => {
              const r = f[(n + 1) % m],
                o = P(t, r) / g,
                i = (r[0] - t[0]) / o,
                a = (r[1] - t[1]) / o,
                s = i / g * b,
                l = a / g * b;
              let u = t[0] + s,
                c = t[1] + l;
              for (; (i <= 0 && u >= r[0] || i >= 0 && u <= r[0]) && (a <= 0 && c >= r[1] || a >= 0 && c <= r[1]);) e.push([u, c]), u += i, c += a;
              return b = Math.abs(r[0] - u) * (g / Math.abs(i)), e;
            }, []),
            x = w.length;
          return 0 === x ? "" : w.reduce((e, t, n) => {
            const r = w[n > 0 ? n - 1 : x - 1],
              o = w[(n + 1) % x];
            let i = A(t, r, l, !0),
              a = A(t, o, l, !1);
            if (isNaN(i) && isNaN(a)) return e.push(`${o[0]} ${o[1]}`), e;
            isNaN(i) && (i = a + Math.PI), isNaN(a) && (a = i + Math.PI), a -= .3;
            const s = a > i ? i + (C - a) > Math.PI ? "1" : "0" : i - a > Math.PI ? "1" : "0",
              u = [t[0] + Math.cos(i) * l, t[1] - Math.sin(i) * l],
              c = [t[0] + Math.cos(a) * l, t[1] - Math.sin(a) * l];
            return e.push(0 === e.length ? `M ${u[0]} ${u[1]} A ${l} ${l} 0 ${s} 1 ${c[0]} ${c[1]}` : `A ${l} ${l} 0 0 0 ${u[0]} ${u[1]} A ${l} ${l} 0 ${s} 1 ${c[0]} ${c[1]}`), e;
          }, []).join(" ");
        }
        const _ = e => e.reduce((t, n, r) => r < e.length - 1 ? t + (n[0] * e[r + 1][1] - n[1] * e[r + 1][0]) : t + (n[0] * e[0][1] - n[1] * e[0][0]), 0) > 0,
          P = (e, t) => {
            const n = t[0] - e[0],
              r = t[1] - e[1];
            return e[0] === t[0] ? Math.abs(r) : e[1] === t[1] ? Math.abs(n) : Math.sqrt(n ** 2 + r ** 2);
          },
          k = function (e, t) {
            let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : .001;
            return Math.abs(e[0] - t[0]) <= n && Math.abs(e[1] - t[1]) <= n;
          },
          A = (e, t, n, r) => {
            const o = .5 * Math.sqrt((e[0] - t[0]) ** 2 + (e[1] - t[1]) ** 2),
              i = Math.acos(o / n),
              a = [t[0] - e[0], t[1] - e[1]];
            let s = Math.atan2(-a[1], a[0]);
            return s < 0 && (s += C), r ? s - i : s + i;
          },
          z = e => e.reduce((t, n, r) => t + P(n, r < e.length - 1 ? e[r + 1] : e[0]), 0);
      },
      24322: (e, t, n) => {
        "use strict";

        function r(e, t, n, r) {
          var o;
          if ((null === (o = e.points) || void 0 === o ? void 0 : o.size) < 3) return -1;
          const i = e.get("points"),
            a = r || (null == i ? void 0 : i.get(t));
          return i.findIndex(e => {
            if (e.get("x") === a.get("x") && e.get("y") === a.get("y")) return !1;
            return e.distance(a) <= n;
          });
        }
        function o(e, t, n) {
          var r;
          const o = null === (r = e.get("points")) || void 0 === r ? void 0 : r.get(n);
          return e.update("points", e => e.set(t, o));
        }
        function i(e, t, n) {
          return "STANDALONE" === (null == e ? void 0 : e.type) && "function" == typeof t.isMeasurement && t.isMeasurement() && !n;
        }
        n.d(t, {
          KM: () => r,
          dg: () => o,
          mE: () => i
        });
      },
      30006: (e, t, n) => {
        "use strict";

        n.d(t, {
          Cq: () => g,
          Gx: () => w,
          s3: () => y,
          vW: () => v,
          wB: () => m
        });
        var r = n(15359),
          o = n(79724),
          i = n(4715),
          a = n(29977),
          s = n(60379),
          l = n(16602),
          u = n(10983),
          c = n(4280),
          d = n(38852),
          p = n(98179),
          h = n(33427);
        const f = (0, o.Z)("StampAnnotationTemplate"),
          m = e => {
            f(e instanceof i.GI || e instanceof i.sK, "`annotationTemplate` is not an instance of `PSPDFKit.Annotations.StampAnnotation` or ``PSPDFKit.Annotations.ImageAnnotation`");
          },
          g = function (e) {
            var t;
            let {
                includeDate: n,
                includeTime: r
              } = e,
              o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new Date(),
              i = arguments.length > 2 ? arguments[2] : void 0;
            const a = {};
            n && (a.day = "2-digit", a.month = "2-digit", a.year = "numeric"), r && (a.hour = "2-digit", a.minute = "2-digit");
            let s = n || r ? i.formatDate(o, a) : null;
            return s && p.rO && (s = s.replace(/[^A-Za-z 0-9 .,?""!@#$%^&*()-_=+;:<>/\\|}{[\]`~]*/g, "")), null !== (t = s) && void 0 !== t ? t : null;
          },
          v = e => {
            let {
              annotation: t,
              intl: n
            } = e;
            const {
                formatMessage: r
              } = n,
              {
                stampType: o,
                title: s,
                description: l,
                fileName: u
              } = t;
            return t instanceof i.GI ? "Custom" === o && s ? c.Z[(0, d.LE)(s)] ? r(c.Z[(0, d.LE)(s)]) : s : c.Z[(0, d.LE)((0, a.k1)(o))] ? r(c.Z[(0, d.LE)((0, a.k1)(o))]) : o : l || u || " ";
          },
          y = l.Z.filter(e => [s.Z.BLUE, s.Z.RED, s.Z.ORANGE, s.Z.LIGHT_YELLOW, s.Z.GREEN].includes(e.color) || "mauve" === e.localization.id).map(e => function (e) {
            var t, n;
            return (0, r.kG)(null != e.color), {
              label: null !== (t = e.localization.description) && void 0 !== t ? t : "",
              color: null !== (n = Object.values(b(e.color))[0].color.toHex()) && void 0 !== n ? n : "#000000"
            };
          }(e));
        function b(e) {
          const t = e.lighter(u.zT);
          let n = e;
          const r = Math.max(n.r, n.g, n.b);
          for (let e = 0; e < 10 && t.contrastRatio(n) < 4.5; e++) n = n.darker((255 - r) / 25.5);
          return {
            [`${n.toCSSValue()}`]: {
              color: n,
              backgroundColor: t
            }
          };
        }
        function w(e) {
          let {
            annotation: t,
            annotationVisualPropertiesString: n,
            width: r,
            height: o,
            secondAnnotationVisualPropertiesString: i,
            secondAnnotationWidth: a,
            secondAnnotationHeight: s
          } = e;
          return n === i && (t.noZoom || a >= r && s >= o) && !(0, h.eD)(t);
        }
      },
      19181: (e, t, n) => {
        "use strict";

        n.d(t, {
          x: () => o
        });
        var r = n(67366);
        function o(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return (0, r.$j)((t, n) => null == e ? void 0 : e(t.reuseState ? i(t, t.reuseState) : t, n), null, null, t);
        }
        const i = (0, n(30845).Z)((e, t) => e.withMutations(n => {
          n.merge(t), n.set("pages", e.pages.map(e => {
            const n = e.pageKey,
              r = t.pages.find(e => e.pageKey === n);
            return r && r ? e.set("annotationIds", r.annotationIds) : e;
          }));
        }));
      },
      38852: (e, t, n) => {
        "use strict";

        n.d(t, {
          F6: () => u,
          HD: () => d,
          LE: () => a,
          Oe: () => i,
          QE: () => l,
          aF: () => h,
          hj: () => p,
          zW: () => c
        });
        var r = n(37529),
          o = n.n(r);
        function i(e) {
          return e.charAt(0) && e.charAt(0).toUpperCase() + e.slice(1);
        }
        function a(e) {
          return e.charAt(0).toLowerCase() + e.substr(1);
        }
        const s = e => e[0] === o().INSERT;
        function l(e, t, n) {
          var r;
          const i = o()(e, t, n);
          let a = "";
          const l = i.filter(s);
          return l.length > 0 && (a = l[0][1]), {
            prev: e,
            next: t,
            change: a,
            diff: i,
            endCursorPosition: n + ((null === (r = i[1]) || void 0 === r || null === (r = r[1]) || void 0 === r ? void 0 : r.length) || 0)
          };
        }
        function u(e, t) {
          if (t === e.change) return e.next;
          const {
              diff: n
            } = e,
            r = n.findIndex(s);
          return r >= 0 ? n[r][1] = t : n.push([o().INSERT, t]), function (e) {
            let t = "";
            for (let n = 0; n < e.length; n++) {
              const [r, i] = e[n];
              switch (r) {
                case o().DELETE:
                  break;
                case o().INSERT:
                case o().EQUAL:
                  t += i;
              }
            }
            return t;
          }(n);
        }
        function c(e) {
          return e.split("-").map((e, t) => t ? e.charAt(0).toUpperCase() + e.slice(1).toLowerCase() : e.toLowerCase()).join("");
        }
        function d(e) {
          return "string" == typeof e;
        }
        function p(e) {
          return "number" == typeof e;
        }
        function h(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 120;
          const n = e.trim();
          return n.length < t ? n : n.slice(0, t) + "…";
        }
      },
      89004: (e, t, n) => {
        "use strict";

        n.d(t, {
          BK: () => c,
          KY: () => u,
          Vq: () => d,
          in: () => l,
          kC: () => s
        });
        var r = n(15359),
          o = n(58846),
          i = n(45249),
          a = n(57943);
        function s(e) {
          return e.charAt(0).toUpperCase() + e.slice(1);
        }
        function l(e) {
          return e.split(/[^a-zA-Z0-9]/g).reduce((e, t) => e + s(t), "");
        }
        function u(e) {
          const t = document.createElement("div");
          return t.innerHTML = e, t.textContent || "";
        }
        function c(e) {
          return "#00000000" === e ? void 0 : e;
        }
        function d(e) {
          let {
            rect: t,
            callout: n,
            zoomLevel: s,
            annotation: l,
            text: u = l.text
          } = e;
          const {
              height: c,
              width: d
            } = t,
            p = l.boundingBox.scale(s);
          if (null == n || !n.innerRectInset || !d || !c) return;
          const h = n.innerRectInset.setScale(s),
            f = p.left + h.left,
            m = p.left + h.left + d,
            g = p.top + h.top,
            v = p.top + h.top + c,
            y = (l.borderWidth || 2) / 2,
            b = (0, o.dY)([[f + y, g + y], [m - y, g + y], [m - y, v - y], [f + y, v - y]]),
            w = n.knee || n.start;
          (0, r.kG)(w, "CalloutEditComponent: point is undefined");
          const x = (0, o.Zt)(w.scale(s), b);
          (0, r.kG)(n.start);
          let D = i.UL.fromPoints(...[[f, g], [m, g], [m, v], [f, v]].map(e => new i.E9({
            x: e[0],
            y: e[1]
          }))).expandToIncludePoints(...[n.start, n.knee].filter(Boolean).map(e => null == e ? void 0 : e.scale(s)));
          D = (0, a.Pr)(n.start.scale(s), D, 4 * (l.borderWidth || 2)), n.knee && (D = (0, a.Pr)(n.knee.scale(s), D, l.borderWidth || 2));
          const C = x.scale(1 / s);
          return {
            callout: n.set("end", C).set("innerRectInset", new i.eB({
              bottom: (D.top + D.height - v) / s,
              left: (f - D.left) / s,
              right: (D.left + D.width - m) / s,
              top: (g - D.top) / s
            })),
            text: u,
            boundingBox: D.scale(1 / s)
          };
        }
      },
      20388: (e, t, n) => {
        "use strict";

        n.d(t, {
          MF: () => f,
          XA: () => h,
          Zv: () => m,
          gB: () => b,
          hm: () => w,
          hr: () => y,
          z1: () => g
        });
        var r = n(96156),
          o = n(15359),
          i = n(21853),
          a = n(45249),
          s = n(69867),
          l = n(10983),
          u = n(87996),
          c = n(5705);
        function d(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function p(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? d(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function h(e) {
          let t,
            n,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          if (!1 === u.Options.TEXT_ANNOTATION_AUTOFIT_TEXT_ON_EXPORT) return e.set("isFitting", !1);
          try {
            if (t = (0, i.Aw)(), !t.window || !t.window.document) return e;
            t.window.document.head.appendChild(t.window.document.createElement("style")).textContent = "p { margin: 0; }", n = new s.f(t.window.document, e.text.value, g(e.set("rotation", 0), r, !1));
            const o = !(0, i.f)(n.wrapper);
            return e.set("isFitting", o);
          } finally {
            n && n.remove(), t && t.remove();
          }
        }
        function f(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1;
          const n = (0, i.Aw)();
          if (!n.window || !n.window.document) return null == n || n.remove(), e;
          n.window.document.head.appendChild(n.window.document.createElement("style")).textContent = "p { margin: 0; }";
          const r = new s.f(n.window.document, e.text.value, g(e.set("rotation", 0), t, !1)),
            o = !(0, i.f)(r.wrapper);
          for (e = e.set("isFitting", o); !e.isFitting && e.fontSize >= 2;) {
            e = e.set("fontSize", e.fontSize - 1), r._setStyles(r.wrapper, p(p({}, s.f.defaultWrapperStyles), g(e.set("rotation", 0), t, !1)));
            const n = !(0, i.f)(r.wrapper);
            e = e.set("isFitting", n);
          }
          return null == n || n.remove(), e;
        }
        function m(e, t) {
          let n,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            o = arguments.length > 3 ? arguments[3] : void 0;
          try {
            const i = t.width - e.boundingBox.left,
              a = t.height - e.boundingBox.top;
            n = new s.f(document, e.text.value, p(p({}, g(e, r, !1)), {}, {
              width: "auto",
              height: "auto",
              maxWidth: `${Math.ceil(i * r)}px`,
              maxHeight: `${Math.ceil(a * r)}px`,
              padding: "0px",
              margin: "0px",
              overflow: "visible"
            }), void 0, o);
            const {
                width: l,
                height: u
              } = n.wrapper.getBoundingClientRect(),
              c = Math.max(l, n.wrapper.clientWidth, n.wrapper.scrollWidth),
              d = Math.max(u, n.wrapper.clientHeight, n.wrapper.scrollHeight);
            return e.set("boundingBox", e.boundingBox.set("width", Math.ceil(c / r)).set("height", Math.ceil(d / r)));
          } finally {
            n && n.remove();
          }
        }
        function g(e, t, n) {
          const r = p(p({
            width: Math.ceil(e.boundingBox.width * t),
            height: Math.ceil(e.boundingBox.height * t),
            color: e.fontColor ? e.fontColor.toCSSValue() : "transparent",
            backgroundColor: e.backgroundColor && !n ? e.backgroundColor.toCSSValue() : "transparent",
            fontSize: e.fontSize * t + "px",
            fontFamily: `${w(e.font)}, sans-serif`,
            textAlign: e.horizontalAlign
          }, n ? null : {
            opacity: e.opacity
          }), {}, {
            fontWeight: e.isBold ? "bold" : "normal",
            fontStyle: e.isItalic ? "italic" : "normal",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            overflow: "hidden",
            lineHeight: "number" == typeof e.lineHeightFactor ? e.lineHeightFactor * t * e.fontSize + "px" : "normal",
            flexDirection: "column",
            justifyContent: v(e.verticalAlign),
            display: "flex"
          });
          return (0, c.kv)(e) && !n && (r.transformOrigin = "50% 50%", r.transform = `rotate(${String(-e.rotation)}deg)`), r;
        }
        function v(e) {
          switch (e) {
            case "top":
              return "flex-start";
            case "center":
              return "center";
            case "bottom":
              return "flex-end";
            default:
              return (0, o.Rz)(e);
          }
        }
        function y(e) {
          return "string" == typeof e ? e.split("\r\n").join("\n").split("\r").join("\n") : e;
        }
        function b(e, t) {
          let n;
          switch (t) {
            case 0:
              n = new a.UL({
                left: e.x,
                top: e.y,
                width: l.g3,
                height: l.rm
              });
              break;
            case 90:
              n = new a.UL({
                left: e.x,
                top: e.y - l.rm,
                width: l.g3,
                height: l.rm
              });
              break;
            case 180:
              n = new a.UL({
                left: e.x - l.g3,
                top: e.y - l.rm,
                width: l.g3,
                height: l.rm
              });
              break;
            case 270:
              n = new a.UL({
                left: e.x - l.g3,
                top: e.y,
                width: l.g3,
                height: l.rm
              });
              break;
            default:
              throw (0, o.Rz)(t);
          }
          return n;
        }
        function w(e) {
          return /^[-_a-zA-Z0-9\\xA0-\\u{10FFFF}]*$/.test(e) ? e : `"${e}"`;
        }
      },
      97238: (e, t, n) => {
        "use strict";

        n.d(t, {
          Bx: () => p,
          PK: () => d,
          rf: () => h
        });
        var r = n(96156),
          o = n(35369),
          i = n(15359),
          a = n(45249),
          s = n(11192),
          l = n(33427);
        function u(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function c(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? u(Object(n), !0).forEach(function (t) {
              (0, r.Z)(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function d(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          return h(e).map(r => {
            let {
              pageIndex: o,
              rects: i
            } = r;
            return new t(c(c({}, (0, l.lx)(e)), {}, {
              pageIndex: o,
              boundingBox: a.UL.union(i),
              rects: i,
              isCommentThreadRoot: n
            }));
          });
        }
        function p(e, t, n) {
          return h(e).map(r => {
            let {
              pageIndex: o,
              rects: i
            } = r;
            const s = t.get(o);
            return null == s ? new n(c(c({}, (0, l.lx)(e)), {}, {
              pageIndex: o,
              boundingBox: a.UL.union(i),
              rects: i
            })) : s.withMutations(e => e.set("boundingBox", a.UL.union(i)).set("rects", i));
          });
        }
        function h(e) {
          (0, i.kG)(e.currentTextSelection, "Cannot create markup annotation without text selection.");
          const {
            textRange: t,
            startTextLineId: n,
            endTextLineId: r,
            startPageIndex: a,
            endPageIndex: l
          } = e.currentTextSelection;
          (0, i.kG)(t);
          const u = (0, s.mB)(e, t);
          if (!u) return (0, o.aV)();
          const {
            startRect: c,
            endRect: d
          } = u;
          return (0, s.ZJ)(e, t).map((t, o) => {
            const s = e.pages.get(o);
            (0, i.kG)(s);
            const u = t.map(e => e.id == n && o == a ? c : e.id == r && o == l ? d : e.boundingBox);
            return {
              pageIndex: s.pageIndex,
              rects: u
            };
          }).valueSeq().toList();
        }
      },
      72322: (e, t, n) => {
        "use strict";

        function r(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
            r = null,
            o = null;
          return function () {
            const i = this;
            for (var a = arguments.length, s = new Array(a), l = 0; l < a; l++) s[l] = arguments[l];
            if (r) n && (o = s);else {
              e.apply(i, s);
              const a = () => {
                r = null, o && n && (e.apply(i, o), o = null, r = setTimeout(a, t));
              };
              r = setTimeout(a, t);
            }
          };
        }
        n.d(t, {
          Z: () => r
        });
      },
      5283: (e, t, n) => {
        "use strict";

        n.d(t, {
          CN: () => v,
          DQ: () => p,
          FO: () => w,
          I4: () => b,
          KT: () => D,
          Kt: () => y,
          Li: () => x,
          Ut: () => h,
          hJ: () => f,
          q1: () => c,
          se: () => d
        });
        var r = n(35369),
          o = n(15359),
          i = n(12705),
          a = n(35727),
          s = n(48625),
          l = n(44550),
          u = n(28233);
        function c(e, t, n) {
          return e.filter(e => {
            const r = e.get("type");
            if (t[r] && t[r].forceHide) return !1;
            let o = e.get("mediaQueries");
            if (!o) {
              if (g(e)) return !0;
              const n = t[r].mediaQueries;
              if (!n) return !0;
              o = n;
            }
            const i = null == n ? void 0 : n.matchMedia(o.join(", "));
            return null == i ? void 0 : i.matches;
          });
        }
        function d(e, t) {
          return e.map(e => {
            const n = e.get("mediaQueries");
            if (!n) {
              if (g(e)) return;
              const n = (t[e.get("type")] || {}).mediaQueries;
              return n ? (0, r.aV)(n) : void 0;
            }
            return n;
          }).filter(Boolean).flatten().filter(e => "all" !== e).toSet().toArray();
        }
        function p(e, t) {
          return e = e.map(e => {
            const n = e.get("type"),
              o = t[n] || {},
              {
                id: i,
                className: a,
                icon: s,
                title: l,
                selected: u,
                disabled: c,
                responsiveGroup: d,
                onPress: p,
                dropdownGroup: h,
                preset: f,
                node: m
              } = e.toJS(),
              g = "custom" === n,
              v = {
                id: i || n,
                type: o.type || n,
                title: l || o.title,
                icon: s || o.icon,
                className: [o.className, a].filter(Boolean).join(" "),
                selected: g ? u : o.selected,
                disabled: !0 === c ? c : o.disabled,
                onPress: g ? p : o.onPress,
                onKeyPress: g ? void 0 : o.onKeyPress,
                responsiveGroup: d || o.responsiveGroup,
                dropdownGroup: void 0 !== h ? h : o.dropdownGroup,
                preset: f || o.preset
              };
            return m && (v.node = m), (0, r.D5)(v);
          });
        }
        function h(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
            n = arguments.length > 2 ? arguments[2] : void 0;
          return e.filter(r => {
            const o = r.get("responsiveGroup");
            return o && void 0 !== m(e, o) ? !!t && o === n : !t;
          });
        }
        function f(e) {
          return e.map(t => {
            const n = t.get("type"),
              r = t.get("id");
            if ("responsive-group" == n || "annotate" == n) {
              const n = t.get("selected"),
                o = !!e.find(e => e.get("responsiveGroup") == r && 1 == e.get("selected"));
              return t.set("selected", n || o);
            }
            return t;
          });
        }
        function m(e, t) {
          return e.find(e => e.get("id") && e.get("id") === t);
        }
        function g(e) {
          const t = e.get("type");
          return "custom" === t || "responsive-group" === t;
        }
        function v(e, t) {
          return t === e;
        }
        function y(e, t, n) {
          return n === e && !t;
        }
        function b(e) {
          let {
            toolbarItems: t,
            features: n,
            backend: r,
            backendPermissions: s,
            documentPermissions: c,
            readOnlyEnabled: d,
            showComments: p
          } = e;
          return t.filter(e => {
            let t = !0;
            return "document-editor" === e.get("type") || "document-crop" === e.get("type") ? (t = (0, i.Xr)({
              features: n,
              backendPermissions: s,
              documentPermissions: c,
              readOnlyEnabled: d
            }), !t && n.size > 0 && (n.includes(l.q.DOCUMENT_EDITING) ? (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed due to document or backend permissions.`) : (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed without the Document Editing feature in the license.`)), t) : "content-editor" === e.get("type") ? (t = (0, i.qs)({
              features: n,
              backendPermissions: s,
              documentPermissions: c,
              readOnlyEnabled: d
            }), !t && n.size > 0 && (n.includes(l.q.CONTENT_EDITING) || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed without the Content Editor feature in the license.`), !s.readOnly && c.modification && d !== u.J.VIA_VIEW_STATE && d !== u.J.VIA_BACKEND_PERMISSIONS || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed due to document or backend permissions.`)), t) : "comment" === e.get("type") ? (t = (0, i.LC)({
              features: n,
              backend: r
            }) && (0, a.oK)({
              showComments: p,
              features: n,
              backend: r
            }), !t && n.size > 0 && (n.includes(l.q.COMMENTS) || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed without the Comments feature in the license.`), p || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed because comments are disabled.`), "SERVER" !== (null == r ? void 0 : r.type) || null != r && r.isUsingInstantProvider() || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed because comments are not supported on Server deployments without Instant.`)), t) : ["measure", "distance", "perimeter", "rectangle-area", "ellipse-area", "polygon-area"].includes(e.get("type")) ? (t = n.includes(l.q.MEASUREMENT_TOOLS), !t && n.size > 0 && (n.includes(l.q.MEASUREMENT_TOOLS) || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed without the Measurement Tools feature in the license.`)), t) : "document-assistant" !== e.get("type") || (t = n.includes(l.q.DOCUMENT_ASSISTANT), !t && n.size > 0 && (n.includes(l.q.DOCUMENT_ASSISTANT) || (0, o.ZK)(`The '${e.get("type")}' toolbar item type is not allowed without the Document Assistant feature in the license.`)), t);
          });
        }
        const w = {
          [s.A.INK]: ["ink", "highlighter"],
          [s.A.SHAPE_LINE]: ["line", "arrow"],
          [s.A.INK_ERASER]: "ink-eraser",
          [s.A.TEXT_HIGHLIGHTER]: "text-highlighter",
          [s.A.SHAPE_RECTANGLE]: ["rectangle", "cloudy-rectangle", "dashed-rectangle"],
          [s.A.SHAPE_ELLIPSE]: ["ellipse", "cloudy-ellipse", "dashed-ellipse"],
          [s.A.SHAPE_POLYGON]: ["polygon", "cloudy-polygon", "dashed-polygon"],
          [s.A.SHAPE_POLYLINE]: "polyline",
          [s.A.NOTE]: "note",
          [s.A.TEXT]: "text",
          [s.A.CALLOUT]: "callout",
          [s.A.LINK]: "link",
          [s.A.MEASUREMENT]: "measurement"
        };
        function x(e) {
          const t = Object.entries(w).find(t => {
            let [, n] = t;
            return Array.isArray(n) ? n.includes(e) : n === e;
          });
          return t && t[0] || null;
        }
        function D(e) {
          var t;
          return null === (t = e.find(e => "delete" === e.type)) || void 0 === t ? void 0 : t.icon;
        }
      },
      87849: (e, t, n) => {
        "use strict";

        n.d(t, {
          Yw: () => i,
          bl: () => l,
          sX: () => a
        });
        var r = n(98179),
          o = n(87856);
        function i() {
          const e = "webkit" === r.SR;
          let t;
          e && (t = window.PointerEvent);
          const o = window.Hammer;
          e && delete window.PointerEvent;
          const i = n(34988);
          return e && (window.PointerEvent = t), window.Hammer = o, i;
        }
        function a(e) {
          let t;
          if (e.touches) t = e.touches;else {
            if (!e.changedTouches) return !1;
            t = e.changedTouches;
          }
          return t.length <= 1;
        }
        const s = "webkit" === r.SR || "blink" === r.SR;
        function l(e) {
          if (!s) return () => {};
          const t = e => {
              a(e) || e.preventDefault();
            },
            n = ["touchstart", "touchmove"],
            r = o.Gn ? {
              passive: !1
            } : void 0;
          return n.forEach(n => {
            e.addEventListener(n, t, r), document.addEventListener(n, t, r);
          }), () => {
            n.forEach(n => {
              e.removeEventListener(n, t, r), document.removeEventListener(n, t, r);
            });
          };
        }
      },
      54662: (e, t, n) => {
        "use strict";

        n.d(t, {
          c: () => l,
          n: () => s
        });
        var r = n(4715),
          o = n(44077),
          i = n(5705),
          a = n(33427);
        function s(e, t) {
          const n = e.set("boundingBox", e.boundingBox.translate(t));
          return n instanceof r.Zc ? n.update("lines", e => e.map(e => e.map(e => e.translate(t)))) : n instanceof r.o9 ? n.update("startPoint", e => e.translate(t)).update("endPoint", e => e.translate(t)) : n instanceof r.Hi || n instanceof r.om ? n.update("points", e => e.map(e => e.translate(t))) : (0, a.Vc)(e) ? n.update("callout", e => (e.knee && (e = e.update("knee", e => e.translate(t))), e.update("start", e => e.translate(t)).update("end", e => e.translate(t)))) : n;
        }
        function l(e, t, n, r, o) {
          let i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1;
          const a = u(e, t, n, r, o, i);
          return s(e, a);
        }
        function u(e, t, n, r, s) {
          let l = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 1;
          const u = (0, i.az)(e),
            c = (0, a.SY)(u, l),
            d = new o.UL({
              x: 0,
              y: 0,
              width: n.width,
              height: n.height
            }).isRectInside(c);
          return s && d ? (c.left + t.x < 0 && (t = t.set("x", -c.left)), c.left + c.width + t.x > n.width && (t = t.set("x", n.width - c.width - c.left)), c.top + t.y < 0 && (t = t.set("y", -c.top)), c.top + c.height + t.y > n.height && (t = t.set("y", n.height - c.height - c.top))) : (r.x + c.left + t.x < 0 && (t = t.set("x", -r.x - c.left)), r.x + c.left + t.x > n.width && (t = t.set("x", n.width - (r.x + c.left))), r.y + c.top + t.y < 0 && (t = t.set("y", -r.y - c.top)), r.y + c.top + t.y > n.height && (t = t.set("y", n.height - (r.y + c.top)))), t;
        }
      },
      38478: (e, t, n) => {
        "use strict";

        n.d(t, {
          s: () => l,
          w: () => u
        });
        var r = n(45249),
          o = n(81777),
          i = n(90093),
          a = n(21683),
          s = n(28233);
        function l(e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "undefined" != typeof location ? location.hash : null;
          if (!t) return e;
          const n = t.replace("#", "").split("&").map(e => {
            const t = e.split("=");
            if (2 === t.length) return [t[0], t[1]];
          }).filter(Boolean);
          return n.forEach(t => {
            let [n, r] = t;
            switch (n) {
              case "page":
                {
                  const t = parseInt(r, 10);
                  if ("number" != typeof t || Number.isNaN(t) || t <= 0) break;
                  e = e.set("currentPageIndex", t - 1);
                  break;
                }
            }
          }), e;
        }
        function u(e, t) {
          return new i.Z({
            currentPageIndex: e.viewportState.currentPageIndex,
            zoom: e.viewportState.zoomMode === o.c.CUSTOM ? e.viewportState.zoomLevel : e.viewportState.zoomMode,
            pagesRotation: e.viewportState.pagesRotation,
            layoutMode: e.viewportState.layoutMode,
            scrollMode: e.viewportState.scrollMode,
            showToolbar: e.showToolbar,
            enableAnnotationToolbar: e.enableAnnotationToolbar,
            disablePointSnapping: e.viewportState.disablePointSnapping,
            allowPrinting: e.printingEnabled,
            allowExport: e.exportEnabled,
            interactionMode: e.interactionMode,
            readOnly: e.readOnlyEnabled !== s.J.NO,
            showAnnotations: e.showAnnotations,
            showComments: e.showComments,
            showAnnotationNotes: e.showAnnotationNotes,
            sidebarMode: e.sidebarMode,
            sidebarOptions: e.sidebarOptions,
            sidebarPlacement: e.sidebarPlacement,
            spreadSpacing: e.viewportState.spreadSpacing,
            pageSpacing: e.viewportState.pageSpacing,
            keepFirstSpreadAsSinglePage: e.viewportState.keepFirstSpreadAsSinglePage,
            viewportPadding: new r.gx({
              horizontal: e.viewportState.viewportPadding.x,
              vertical: e.viewportState.viewportPadding.y
            }),
            instance: t || e.instance,
            formDesignMode: e.formDesignMode,
            showSignatureValidationStatus: e.showSignatureValidationStatus,
            previewRedactionMode: e.previewRedactionMode,
            keepSelectedTool: e.keepSelectedTool,
            resolvedLayoutMode: (0, a.nw)(e.viewportState),
            sidebarWidth: e.sidebarWidth,
            enableAlwaysScrollToZoom: e.viewportState.enableAlwaysScrollToZoom,
            forceRenderWidgetsInAnnotationsOrder: e.viewportState.forceRenderWidgetsInAnnotationsOrder,
            prerenderedPageSpreads: e.viewportState.prerenderedPageSpreads,
            showDocumentAssistant: e.documentAssistant.show
          });
        }
      },
      93113: (e, t, n) => {
        "use strict";

        n.d(t, {
          DB: () => y,
          EY: () => _,
          Ek: () => v,
          G4: () => k,
          JN: () => S,
          YA: () => D,
          YS: () => f,
          YV: () => I,
          _4: () => w,
          _P: () => P,
          _U: () => C,
          a$: () => x,
          cr: () => m,
          fI: () => A,
          oI: () => T,
          pA: () => z,
          vY: () => E,
          vs: () => b,
          zi: () => F,
          zo: () => O
        });
        var r = n(30845),
          o = n(15359),
          i = n(21683),
          a = n(84293),
          s = n(23248),
          l = n(14286),
          u = n(44077),
          c = n(2464),
          d = n(81777),
          p = n(10983),
          h = n(60679);
        function f(e, t, n) {
          if ((e.scrollMode === c.G.PER_SPREAD || e.scrollMode === c.G.DISABLED) && t !== e.currentPageIndex) return !1;
          const r = m(e, t),
            o = n.apply(r);
          return e.viewportRect.isRectOverlapping(o);
        }
        function m(e, t) {
          var n;
          if (null !== (n = e._pageToClientTransformation) && void 0 !== n && n[t]) return e._pageToClientTransformation[t];
          const r = (0, i.dF)(e, t),
            o = function (e, t) {
              return e.translate(t.viewportRect.getLocation()).translate(t.scrollPosition.scale(-t.zoomLevel));
            }(w(b(y(u.sl.IDENTITY, e, t, r), e, r), e), e);
          return e._pageToClientTransformation || (e._pageToClientTransformation = {}), e._pageToClientTransformation[t] = o, o;
        }
        const g = (0, r.Z)((e, t) => m(e, t).inverse());
        function v(e, t) {
          return g(e, t);
        }
        function y(e, t, n, r) {
          let a = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 1;
          const s = t.pageSizes.get(n);
          switch ((0, o.kG)(s), 0 !== t.pagesRotation && (e = e.rotate(-t.pagesRotation)), t.pagesRotation) {
            case 0:
              break;
            case 90:
              e = e.translateX(s.height * a);
              break;
            case 180:
              e = e.translateX(s.width * a).translateY(s.height * a);
              break;
            case 270:
              e = e.translateY(s.width * a);
              break;
            default:
              throw new Error(`Unsupported pagesRotation: ${t.pagesRotation}. Only supporting: 0, 90, 180, 270.`);
          }
          switch ((0, i.nw)(t)) {
            case l.X.SINGLE:
              return (0, o.kG)(n === r, "In LayoutMode.SINGLE, pageIndex must equal spreadIndex."), e;
            case l.X.DOUBLE:
              {
                if (t.keepFirstSpreadAsSinglePage && 0 == n && 0 == r) return e;
                const o = t.keepFirstSpreadAsSinglePage ? 1 : 0,
                  s = (0, i.hK)(t, n),
                  l = (0, i.Xk)(t, r);
                return e.translateX((n + o) % 2 ? parseInt((l.width - s.width) * a, 10) : 0).translateY(parseInt((l.height - s.height) * a / 2, 10));
              }
            default:
              throw new Error("Unsupported layoutMode");
          }
        }
        function b(e, t, n) {
          if (t.scrollMode === c.G.CONTINUOUS) {
            const r = (0, i.Xk)(t, n).width,
              o = (0, i.e8)(t, n);
            return e.translateX(((0, i.Ad)(t) - r) / 2).translateY(o);
          }
          return e;
        }
        function w(e, t) {
          return e.scale(t.zoomLevel).translate(k(t).getLocation());
        }
        function x(e, t, n, r) {
          const o = e.set("viewportRect", new u.UL({
            width: t.width - r,
            height: t.height,
            top: t.top,
            left: t.left
          }));
          return O(A(e, o, n));
        }
        function D(e, t) {
          const n = e.set("layoutMode", t);
          return O(A(e, n));
        }
        function C(e, t) {
          const n = e.set("scrollMode", t);
          return O(A(e, n));
        }
        function S(e, t) {
          return O(e.set("spreadSpacing", t));
        }
        function E(e, t) {
          return O(e.set("pageSpacing", t));
        }
        function _(e, t) {
          return O(e.set("keepFirstSpreadAsSinglePage", t));
        }
        function P(e, t) {
          return O(e.set("viewportPadding", t));
        }
        function k(e) {
          let t;
          if (e.scrollMode === c.G.CONTINUOUS) t = new u.$u({
            width: (0, i.Ad)(e),
            height: (0, i.Of)(e)
          });else {
            const n = (0, i.dF)(e, e.currentPageIndex);
            t = (0, i.Xk)(e, n);
          }
          let n = new u.UL({
            width: t.width,
            height: t.height
          }).scale(e.zoomLevel).translate(e.viewportPadding);
          const r = e.commentMode === h._.SIDEBAR ? p.h8 : 0;
          e.viewportRect.width - r - 2 * e.viewportPadding.x > n.width && (n = n.translateX((e.viewportRect.width - r - 2 * e.viewportPadding.x - n.width) / 2));
          return e.viewportRect.height - 2 * e.viewportPadding.y > n.height && (n = n.translateY((e.viewportRect.height - 2 * e.viewportPadding.y - n.height) / 2)), n;
        }
        function A(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          const r = (0, i.nw)(e) !== (0, i.nw)(t),
            o = e.scrollMode !== t.scrollMode;
          if (!(n || r || o)) return t;
          switch (t.scrollMode) {
            case c.G.PER_SPREAD:
            case c.G.DISABLED:
              return t.set("zoomMode", d.c.FIT_TO_VIEWPORT);
            case c.G.CONTINUOUS:
              return t = O(t), (0, s.eb)(t, t.currentPageIndex, !0);
            default:
              throw new Error("Unsupported scrollMode");
          }
        }
        function z(e, t) {
          return e.zoomLevel !== t.zoomLevel || e.zoomMode !== t.zoomMode || e.layoutMode !== t.layoutMode || e.scrollMode !== t.scrollMode || e.scrollPosition !== t.scrollPosition || e.currentPageIndex !== t.currentPageIndex || e.viewportRect !== t.viewportRect || e.pageSizes !== t.pageSizes || e.pagesRotation !== t.pagesRotation || e.viewportPadding !== t.viewportPadding || e.spreadSpacing !== t.spreadSpacing || e.pageSpacing !== t.pageSpacing || e.keepFirstSpreadAsSinglePage !== t.keepFirstSpreadAsSinglePage;
        }
        function T(e) {
          return [e.zoomLevel, e.zoomMode, e.layoutMode, e.scrollMode, e.scrollPosition, e.currentPageIndex, e.viewportRect, e.pageSizes, e.pagesRotation, e.viewportPadding, e.spreadSpacing, e.pageSpacing, e.keepFirstSpreadAsSinglePage];
        }
        function O(e) {
          return e.zoomMode !== d.c.CUSTOM ? e.set("zoomLevel", (0, a.X9)(e, e.zoomMode)) : e;
        }
        function I(e) {
          return function (t, n) {
            return t.apply(F(e(), n));
          };
        }
        function F(e, t) {
          let {
            viewportState: n,
            scrollElement: r
          } = e;
          if (r) {
            const e = new u.E9({
              x: r.scrollLeft / n.zoomLevel,
              y: r.scrollTop / n.zoomLevel
            });
            n.scrollPosition.equals(e) || (n = n.set("scrollPosition", e));
          }
          return v(n, t);
        }
      },
      82197: (e, t, n) => {
        "use strict";

        n.d(t, {
          Lv: () => l,
          U1: () => a,
          kI: () => u,
          n5: () => s
        });
        var r = n(15359),
          o = n(93113),
          i = n(45249);
        function a(e, t) {
          (0, r.kG)(t % 90 == 0, "Only multiples of 90° allowed for rotation."), t = s(t);
          const n = e.update("pagesRotation", e => (e + t) % 360);
          return (0, o.zo)((0, o.fI)(e, n, !0));
        }
        function s(e) {
          return (0, r.kG)(e % 90 == 0, "Only multiples of 90° allowed for rotation."), (360 + e % 360) % 360;
        }
        function l(e) {
          return (360 + Math.round(e) % 360) % 360;
        }
        function u(e, t, n) {
          switch (n) {
            case 90:
              return new i.UL({
                left: e.top,
                top: Math.max(0, Math.round(t.height - e.right)),
                height: e.width,
                width: e.height
              });
            case 180:
              return e.merge({
                left: Math.max(0, Math.round(t.width - e.right)),
                top: Math.max(0, Math.round(t.height - e.bottom))
              });
            case 270:
              return new i.UL({
                left: Math.max(0, Math.round(t.width - e.bottom)),
                top: e.left,
                height: e.width,
                width: e.height
              });
            default:
              return e;
          }
        }
      },
      23248: (e, t, n) => {
        "use strict";

        n.d(t, {
          DJ: () => c,
          TW: () => f,
          eb: () => d,
          hu: () => m,
          k3: () => u,
          kN: () => p,
          vP: () => h
        });
        var r = n(21683),
          o = n(93113),
          i = n(84293),
          a = n(44077),
          s = n(2464),
          l = n(81777);
        function u(e, t, n) {
          n || (n = new a.E9({
            x: .5 * e.viewportRect.width,
            y: .1 * e.viewportRect.height
          })), n = n.translate(e.viewportPadding.scale(-1));
          const r = t / e.zoomLevel - 1;
          let o = 0;
          const s = (0, i.kh)(e),
            l = t > s;
          if (l) {
            o = t / Math.max(e.zoomLevel, s) - 1;
          }
          return new a.E9({
            x: l ? e.scrollPosition.x + n.x * o / t : 0,
            y: e.scrollPosition.y + n.y * r / t
          });
        }
        function c(e, t) {
          const n = f(e);
          return new a.E9({
            x: Math.max(0, Math.min(t.x, n.x)),
            y: Math.max(0, Math.min(t.y, n.y))
          });
        }
        function d(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
          if (!n && e.currentPageIndex == t) return e;
          if (e.scrollMode == s.G.PER_SPREAD || e.scrollMode === s.G.DISABLED) return (0, i.cq)(e.set("currentPageIndex", t), l.c.FIT_TO_VIEWPORT).set("scrollPosition", new a.E9()).set("currentPageIndex", t);
          {
            const n = (0, r.dF)(e, t),
              o = (0, r.e8)(e, n),
              i = f(e).y,
              a = Math.min(i, o);
            return e.set("currentPageIndex", t).setIn(["scrollPosition", "y"], a);
          }
        }
        function p(e, t, n) {
          let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
          if (!r && (0, o.YS)(e, t, n)) return e;
          const i = (0, o.cr)(e, t),
            a = n.apply(i),
            s = e.viewportRect.getCenter(),
            l = a.getCenter().translate(s.scale(-1)),
            u = e.scrollPosition.translate(l.scale(1 / e.zoomLevel));
          return e.merge({
            scrollPosition: c(e, u),
            currentPageIndex: t
          });
        }
        function h(e, t, n) {
          const {
              viewportRect: r,
              viewportPadding: o
            } = e,
            a = (r.width - 2 * o.x) / n.width,
            s = (r.height - 2 * o.y) / n.height,
            l = Math.min(a, s);
          return p((0, i.cq)(e, l), t, n, !0);
        }
        function f(e) {
          const t = (0, o.G4)(e),
            n = t.left / e.zoomLevel + t.width / e.zoomLevel + e.viewportPadding.x / e.zoomLevel - e.viewportRect.width / e.zoomLevel,
            r = t.top / e.zoomLevel + t.height / e.zoomLevel + e.viewportPadding.y / e.zoomLevel - e.viewportRect.height / e.zoomLevel;
          return new a.E9({
            x: Math.max(0, n),
            y: Math.max(0, r)
          });
        }
        function m(e, t) {
          return (0, r.Y2)(e.set("scrollPosition", t));
        }
      },
      21683: (e, t, n) => {
        "use strict";

        n.d(t, {
          Ad: () => f,
          Of: () => m,
          P1: () => g,
          Xk: () => w,
          Y2: () => D,
          dF: () => v,
          e8: () => h,
          hK: () => b,
          kd: () => y,
          nw: () => d,
          s: () => x,
          wU: () => C,
          wX: () => S
        });
        var r = n(35369),
          o = n(67294),
          i = n(15359),
          a = n(14286),
          s = n(93113),
          l = n(44077),
          u = n(2464),
          c = n(10983);
        function d(e) {
          if (e.layoutMode === a.X.AUTO) {
            return e.viewportRect.width > e.viewportRect.height && e.viewportRect.width > c.GI ? a.X.DOUBLE : a.X.SINGLE;
          }
          return e.layoutMode;
        }
        function p(e) {
          const t = y(e);
          let n = (0, r.aV)();
          for (let e = 0; e < t; e++) n = n.push(e);
          return n;
        }
        function h(e, t) {
          return p(e).map(t => w(e, t)).takeUntil((e, n) => n >= t).reduce((t, n) => t + n.height + e.spreadSpacing, 0);
        }
        function f(e) {
          const t = p(e).map(t => w(e, t)).maxBy(e => e.width);
          return t ? t.width : 0;
        }
        function m(e) {
          const t = p(e).map(t => w(e, t)),
            n = (t.size - 1) * e.spreadSpacing;
          return t.map(e => e.height).reduce((e, t) => e + t, 0) + n;
        }
        function g(e, t) {
          switch (d(e)) {
            case a.X.SINGLE:
              return (0, i.kG)(t < y(e), "`spreadIndex` is out of bounds."), [t];
            case a.X.DOUBLE:
              {
                const n = e.pageSizes.count();
                if (e.keepFirstSpreadAsSinglePage && 0 === t) return [0];
                const r = e.keepFirstSpreadAsSinglePage ? 1 : 0,
                  o = [],
                  i = 2 * t - r;
                i < n && o.push(i);
                const a = 2 * t + 1 - r;
                return a < n && o.push(a), o;
              }
            default:
              throw new Error("Unsupported layoutMode");
          }
        }
        function v(e, t) {
          if (t >= e.pageSizes.size) return 0;
          switch (d(e)) {
            case a.X.SINGLE:
              return t;
            case a.X.DOUBLE:
              {
                const n = e.keepFirstSpreadAsSinglePage ? 1 : 0;
                return Math.floor((t + n) / 2);
              }
            default:
              throw new Error("Unsupported layoutMode");
          }
        }
        function y(e) {
          switch (d(e)) {
            case a.X.SINGLE:
              return e.pageSizes.size;
            case a.X.DOUBLE:
              {
                if (e.pageSizes.size <= 0) return 0;
                const t = e.keepFirstSpreadAsSinglePage ? 1 : 0;
                return Math.ceil((e.pageSizes.size + t) / 2);
              }
            default:
              throw new Error("Unsupported layoutMode");
          }
        }
        function b(e, t) {
          const n = e.pageSizes.get(t);
          return (0, i.kG)(n, "No such page size"), 90 === e.pagesRotation || 270 === e.pagesRotation ? new l.$u({
            width: n.height,
            height: n.width
          }) : n;
        }
        function w(e, t) {
          const n = g(e, t);
          if (1 === n.length) return b(e, n[0]);
          {
            let t = 0,
              r = 0;
            for (const o of n) {
              const {
                width: n,
                height: i
              } = b(e, o);
              t += n + (0 !== o ? e.pageSpacing : 0), i > r && (r = i);
            }
            return new l.$u({
              width: t,
              height: r
            });
          }
        }
        function x(e) {
          let {
            width: t
          } = e;
          return t <= c.y$ ? "width-xs" : t <= c.Fg ? "width-sm" : t <= c.GI ? "width-md" : t <= c.Qq ? "width-lg" : "width-xl";
        }
        function D(e) {
          let t = e.currentPageIndex,
            n = v(e, e.currentPageIndex);
          if (e.scrollMode === u.G.CONTINUOUS) {
            const t = [0];
            let r = 0;
            for (let n = 0; n < y(e) - 1; n++) {
              const o = r + (w(e, n).height + (0 !== n ? e.spreadSpacing : 0)) * e.zoomLevel;
              r = o, t.push(o);
            }
            const o = e.scrollPosition.y * e.zoomLevel - e.viewportPadding.y + e.viewportRect.height / 2;
            n = t.reduce((e, t, n) => t < o ? n : e, 0);
          }
          const r = g(e, n);
          if (r.length > 1) {
            const o = e.scrollPosition.x * e.zoomLevel - e.viewportPadding.x + e.viewportRect.width / 2,
              i = r[1],
              a = (0, s._4)((0, s.vs)((0, s.DB)(l.sl.IDENTITY, e, i, n), e, n), e);
            t = new l.E9().apply(a).x < o ? i : r[0];
          } else t = r[0];
          return e.set("currentPageIndex", t);
        }
        function C(e, t) {
          const [n, i] = o.useState(null),
            a = o.useRef((0, r.l4)()),
            l = function () {
              const e = o.useRef({
                timeoutId: null,
                clear: function () {
                  this.timeoutId && clearTimeout(this.timeoutId), this.timeoutId = null;
                },
                set: function (e, t) {
                  this.clear(), this.timeoutId = setTimeout(e, t);
                }
              });
              return o.useEffect(() => {
                const t = e.current;
                return () => t.clear();
              }), e.current;
            }(),
            u = o.useCallback(e => {
              a.current.contains(t) && (e ? (l.clear(), l.set(() => {
                i(t);
              }, 500)) : i(t));
            }, [t, l, i]);
          o.useEffect(() => {
            var n;
            l.clear();
            const r = null !== (n = e.prerenderedPageSpreads) && void 0 !== n ? n : e.pageSizes.size;
            a.current = a.current.filter(e => S(e, t, r)), u(!1);
          }, [...(0, s.oI)(e), t, l, u, e.prerenderedPageSpreads, e.pageSizes.size]);
          return [n, o.useCallback(e => {
            a.current = a.current.add(e), u(!0);
          }, [u])];
        }
        function S(e, t, n) {
          return e >= t - n && e <= t + n;
        }
      },
      24987: (e, t, n) => {
        "use strict";

        n.d(t, {
          p: () => o
        });
        var r = n(65369);
        function o(e, t, n) {
          const o = e.viewportState.viewportRect.set("height", t.height);
          return e.sidebarMode ? o.merge({
            width: e.containerRect.width - n,
            left: e.containerRect.left + (e.sidebarPlacement === r.d.START ? n : 0)
          }) : o.merge({
            width: e.containerRect.width,
            left: e.containerRect.left
          });
        }
      },
      84293: (e, t, n) => {
        "use strict";

        n.d(t, {
          Mq: () => f,
          Sm: () => p,
          X9: () => g,
          Yo: () => d,
          cq: () => v,
          hT: () => y,
          kh: () => h,
          vw: () => m
        });
        var r = n(21683),
          o = n(10983),
          i = n(23248),
          a = n(2464),
          s = n(81777),
          l = n(82716);
        let u = Number.POSITIVE_INFINITY,
          c = Number.NEGATIVE_INFINITY;
        function d(e) {
          const t = Math.min(h(e), f(e), e.minDefaultZoomLevel, u);
          return u > t && (u = t), t;
        }
        function p(e) {
          const t = Math.max(h(e), f(e), e.maxDefaultZoomLevel, c);
          return c < t && (c = t), t;
        }
        function h(e) {
          if (0 === e.pageSizes.size || 0 === e.viewportRect.width || 0 === e.viewportRect.height) return 1;
          let t;
          switch (e.scrollMode) {
            case a.G.CONTINUOUS:
              t = (0, r.Ad)(e);
              break;
            case a.G.PER_SPREAD:
            case a.G.DISABLED:
              {
                const n = (0, r.dF)(e, e.currentPageIndex);
                t = (0, r.Xk)(e, n).width;
                break;
              }
            default:
              throw new Error("Unsupported scrollMode");
          }
          return (e.viewportRect.width - 2 * e.viewportPadding.x) / t;
        }
        function f(e) {
          if (0 === e.pageSizes.size || 0 === e.viewportRect.width || 0 === e.viewportRect.height) return 1;
          const t = (0, r.dF)(e, e.currentPageIndex),
            n = (0, r.Xk)(e, t).height;
          return 0 === n ? 1 : (e.viewportRect.height - 2 * e.viewportPadding.y) / n;
        }
        function m(e) {
          const t = h(e),
            n = f(e);
          return Math.min(t, n);
        }
        function g(e, t) {
          switch (t) {
            case s.c.AUTO:
              return function (e) {
                const t = f(e),
                  n = h(e),
                  i = (0, r.hK)(e, 0),
                  a = i && i.width > i.height ? Math.min(t, n) : n;
                return Math.min(a, o.zh);
              }(e);
            case s.c.FIT_TO_VIEWPORT:
              return m(e);
            case s.c.FIT_TO_WIDTH:
              return h(e);
            default:
              return (0, l.k)("number" == typeof t, "Unknown zoom mode"), t;
          }
        }
        function v(e, t) {
          let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = g(e, t);
          const a = "number" == typeof t ? s.c.CUSTOM : t,
            l = d(e),
            u = p(e);
          if (o >= u) {
            if (n.unbounded) {
              const e = b((o - u) / 25);
              o = u * (1 + .5 * e);
            } else o = u;
          } else if (o <= l) if (n.unbounded) {
            const e = b(4 * (o - l));
            o = l * (1 + .25 * e);
          } else o = l;
          let c = (0, i.k3)(e, o, n.zoomCenter);
          return c = (0, i.DJ)(e.set("zoomLevel", o), c), (0, r.Y2)(e.withMutations(e => e.set("zoomLevel", o).set("scrollPosition", c).set("zoomMode", a)));
        }
        function y(e) {
          const {
              zoomLevel: t
            } = e,
            n = d(e);
          return t > p(e) || t < n;
        }
        function b(e) {
          const t = Math.exp(+e),
            n = Math.exp(-e);
          return t == 1 / 0 ? 1 : n == 1 / 0 ? -1 : (t - n) / (t + n);
        }
      },
      60859: (e, t, n) => {
        "use strict";

        n.d(t, {
          $Z: () => g,
          DI: () => d,
          MX: () => f,
          n: () => c,
          w5: () => p
        });
        var r = n(35369),
          o = n(15359),
          i = n(69867),
          a = n(21853),
          s = n(561),
          l = n.n(s),
          u = n(43069);
        const c = 2,
          d = 2,
          p = [1, 2, 3, 4, 6, 8, 9, 10, 12, 14, 16, 18, 20, 25, 30, 35, 40, 45, 50, 55, 60, 70, 80, 90, 100, 110, 120, 130, 144],
          h = p.slice(0, Math.floor(p.length / 4));
        function f(e, t, n, a, s, u, f) {
          if (s && e && 10 === e.charCodeAt(e.length - 1) && (e += "\n"), "auto" !== a) return a || Math.max(4, Math.min(.7 * n, 12));
          let g, v;
          if (f) {
            const e = window.getComputedStyle(f);
            g = e.getPropertyValue("font-family"), s || (v = e.getPropertyValue("line-height"));
          }
          if (s) {
            const a = n - 2 * c,
              s = (0, r.aV)([e]),
              p = m(h, e => {
                const n = function (e) {
                  let {
                    valueString: t,
                    fontSize: n,
                    fontFamily: r = "inherit",
                    availableWidth: a,
                    element: s
                  } = e;
                  const u = new i.f(document, t, {
                      fontSize: `${n}px`,
                      width: `${a}px`,
                      wordBreak: "break-word",
                      whiteSpace: "pre-wrap",
                      fontFamily: r,
                      lineHeight: `${n}px`,
                      margin: "0",
                      padding: "0",
                      border: "none",
                      textAlign: (null == s ? void 0 : s.style.textAlign) || "initial"
                    }, l().widget, s && s.parentNode),
                    c = u.measure().first();
                  (0, o.kG)(c);
                  const d = c.height;
                  return u.remove(), d;
                }({
                  valueString: s,
                  fontSize: e,
                  fontFamily: g,
                  availableWidth: t - 2 * d,
                  element: f
                });
                let r = c;
                const p = a - e;
                return p - 2 * c < 0 && (r = p > 0 ? p / 2 : 0), n + 2 * r + 2 * u > a ? 0 : 1;
              });
            return p;
          }
          {
            const a = (0, r.aV)([e]),
              s = m(p, e => {
                const r = function (e) {
                  let {
                    valueString: t,
                    fontSize: n,
                    fontFamily: r = "inherit",
                    lineHeight: a = "inherit",
                    element: s
                  } = e;
                  const u = new i.f(document, t, {
                      fontSize: `${n}px`,
                      fontFamily: r,
                      lineHeight: a
                    }, l().widget, s && s.parentNode),
                    c = u.measure().first();
                  (0, o.kG)(c);
                  const d = c.width;
                  return u.remove(), d;
                }({
                  valueString: a,
                  fontSize: e,
                  fontFamily: g,
                  lineHeight: v,
                  element: f
                });
                return r > t || e > n ? 0 : 1;
              });
            return s;
          }
        }
        function m(e, t) {
          let n = 0,
            r = e.length - 1,
            o = 0,
            i = e[0];
          for (; n <= r;) o = Math.floor((n + r) / 2), i = e[o], t(i) ? n = o + 1 : r = o - 1;
          return t(i) || (i = e[Math.max(0, o - 1)]), i;
        }
        function g(e, t) {
          let n,
            r,
            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1;
          try {
            return n = (0, a.Aw)(), r = new i.f(n.window.document, t, (0, u.i2)(e, o, !1)), !(0, a.f)(r.wrapper);
          } finally {
            r && r.remove(), n && n.remove();
          }
        }
      },
      11073: e => {
        e.exports = {
          trueFunc: function () {
            return !0;
          },
          falseFunc: function () {
            return !1;
          }
        };
      },
      40599: e => {
        "use strict";

        var t = /-(\w|$)/g,
          n = function (e, t) {
            return t.toUpperCase();
          };
        e.exports = function (e) {
          return "float" === (e = e.toLowerCase()) ? "cssFloat" : 45 === e.charCodeAt(0) && 109 === e.charCodeAt(1) && 115 === e.charCodeAt(2) && 45 === e.charCodeAt(3) ? e.substr(1).replace(t, n) : e.replace(t, n);
        };
      },
      94184: (e, t) => {
        var n;
        !function () {
          "use strict";

          var r = {}.hasOwnProperty;
          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var n = arguments[t];
              if (n) {
                var i = typeof n;
                if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
                  if (n.length) {
                    var a = o.apply(null, n);
                    a && e.push(a);
                  }
                } else if ("object" === i) {
                  if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) {
                    e.push(n.toString());
                    continue;
                  }
                  for (var s in n) r.call(n, s) && n[s] && e.push(s);
                }
              }
            }
            return e.join(" ");
          }
          e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
            return o;
          }.apply(t, [])) || (e.exports = n);
        }();
      },
      83882: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => a
        });
        var r = n(67294);
        function o() {
          return o = Object.assign ? Object.assign.bind() : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, o.apply(this, arguments);
        }
        const i = ["is", "onClick", "disabled", "tabIndex", "onKeyPress"],
          a = r.forwardRef((e, t) => {
            const {
                is: n = "span",
                onClick: a,
                disabled: s,
                tabIndex: l = 0,
                onKeyPress: u
              } = e,
              c = function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = {},
                  i = Object.keys(e);
                for (r = 0; r < i.length; r++) t.indexOf(n = i[r]) >= 0 || (o[n] = e[n]);
                return o;
              }(e, i);
            return r.createElement(n, o({
              tabIndex: s ? void 0 : l,
              role: "button",
              onKeyPress: s ? void 0 : e => {
                switch (e.key) {
                  case " ":
                  case "Spacebar":
                    e.preventDefault(), a && u || u ? u(e) : a && a(e);
                    break;
                  case "Enter":
                    if (u && (u(e), e.isDefaultPrevented())) return;
                    a && a(e);
                }
              },
              onClick: s ? void 0 : a,
              "aria-disabled": s ? "true" : void 0,
              ref: t
            }, c));
          });
        a.displayName = "ClickableBox";
      },
      1410: (e, t, n) => {
        "use strict";

        function r(e) {
          var t,
            n,
            o = "";
          if ("string" == typeof e || "number" == typeof e) o += e;else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = r(e[t])) && (o && (o += " "), o += n);else for (t in e) e[t] && (o && (o += " "), o += t);
          return o;
        }
        n.d(t, {
          Z: () => o
        });
        const o = function () {
          for (var e, t, n = 0, o = ""; n < arguments.length;) (e = arguments[n++]) && (t = r(e)) && (o && (o += " "), o += t);
          return o;
        };
      },
      19662: (e, t, n) => {
        var r = n(60614),
          o = n(66330),
          i = TypeError;
        e.exports = function (e) {
          if (r(e)) return e;
          throw i(o(e) + " is not a function");
        };
      },
      39483: (e, t, n) => {
        var r = n(4411),
          o = n(66330),
          i = TypeError;
        e.exports = function (e) {
          if (r(e)) return e;
          throw i(o(e) + " is not a constructor");
        };
      },
      96077: (e, t, n) => {
        var r = n(60614),
          o = String,
          i = TypeError;
        e.exports = function (e) {
          if ("object" == typeof e || r(e)) return e;
          throw i("Can't set " + o(e) + " as a prototype");
        };
      },
      51223: (e, t, n) => {
        var r = n(5112),
          o = n(70030),
          i = n(3070).f,
          a = r("unscopables"),
          s = Array.prototype;
        null == s[a] && i(s, a, {
          configurable: !0,
          value: o(null)
        }), e.exports = function (e) {
          s[a][e] = !0;
        };
      },
      31530: (e, t, n) => {
        "use strict";

        var r = n(28710).charAt;
        e.exports = function (e, t, n) {
          return t + (n ? r(e, t).length : 1);
        };
      },
      25787: (e, t, n) => {
        var r = n(47976),
          o = TypeError;
        e.exports = function (e, t) {
          if (r(t, e)) return e;
          throw o("Incorrect invocation");
        };
      },
      19670: (e, t, n) => {
        var r = n(70111),
          o = String,
          i = TypeError;
        e.exports = function (e) {
          if (r(e)) return e;
          throw i(o(e) + " is not an object");
        };
      },
      23013: e => {
        e.exports = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView;
      },
      7556: (e, t, n) => {
        var r = n(47293);
        e.exports = r(function () {
          if ("function" == typeof ArrayBuffer) {
            var e = new ArrayBuffer(8);
            Object.isExtensible(e) && Object.defineProperty(e, "a", {
              value: 8
            });
          }
        });
      },
      90260: (e, t, n) => {
        "use strict";

        var r,
          o,
          i,
          a = n(23013),
          s = n(19781),
          l = n(17854),
          u = n(60614),
          c = n(70111),
          d = n(92597),
          p = n(70648),
          h = n(66330),
          f = n(68880),
          m = n(98052),
          g = n(3070).f,
          v = n(47976),
          y = n(79518),
          b = n(27674),
          w = n(5112),
          x = n(69711),
          D = n(29909),
          C = D.enforce,
          S = D.get,
          E = l.Int8Array,
          _ = E && E.prototype,
          P = l.Uint8ClampedArray,
          k = P && P.prototype,
          A = E && y(E),
          z = _ && y(_),
          T = Object.prototype,
          O = l.TypeError,
          I = w("toStringTag"),
          F = x("TYPED_ARRAY_TAG"),
          M = "TypedArrayConstructor",
          R = a && !!b && "Opera" !== p(l.opera),
          j = !1,
          B = {
            Int8Array: 1,
            Uint8Array: 1,
            Uint8ClampedArray: 1,
            Int16Array: 2,
            Uint16Array: 2,
            Int32Array: 4,
            Uint32Array: 4,
            Float32Array: 4,
            Float64Array: 8
          },
          N = {
            BigInt64Array: 8,
            BigUint64Array: 8
          },
          L = function (e) {
            var t = y(e);
            if (c(t)) {
              var n = S(t);
              return n && d(n, M) ? n.TypedArrayConstructor : L(t);
            }
          },
          V = function (e) {
            if (!c(e)) return !1;
            var t = p(e);
            return d(B, t) || d(N, t);
          };
        for (r in B) (i = (o = l[r]) && o.prototype) ? C(i).TypedArrayConstructor = o : R = !1;
        for (r in N) (i = (o = l[r]) && o.prototype) && (C(i).TypedArrayConstructor = o);
        if ((!R || !u(A) || A === Function.prototype) && (A = function () {
          throw O("Incorrect invocation");
        }, R)) for (r in B) l[r] && b(l[r], A);
        if ((!R || !z || z === T) && (z = A.prototype, R)) for (r in B) l[r] && b(l[r].prototype, z);
        if (R && y(k) !== z && b(k, z), s && !d(z, I)) for (r in j = !0, g(z, I, {
          get: function () {
            return c(this) ? this[F] : void 0;
          }
        }), B) l[r] && f(l[r], F, r);
        e.exports = {
          NATIVE_ARRAY_BUFFER_VIEWS: R,
          TYPED_ARRAY_TAG: j && F,
          aTypedArray: function (e) {
            if (V(e)) return e;
            throw O("Target is not a typed array");
          },
          aTypedArrayConstructor: function (e) {
            if (u(e) && (!b || v(A, e))) return e;
            throw O(h(e) + " is not a typed array constructor");
          },
          exportTypedArrayMethod: function (e, t, n, r) {
            if (s) {
              if (n) for (var o in B) {
                var i = l[o];
                if (i && d(i.prototype, e)) try {
                  delete i.prototype[e];
                } catch (n) {
                  try {
                    i.prototype[e] = t;
                  } catch (e) {}
                }
              }
              z[e] && !n || m(z, e, n ? t : R && _[e] || t, r);
            }
          },
          exportTypedArrayStaticMethod: function (e, t, n) {
            var r, o;
            if (s) {
              if (b) {
                if (n) for (r in B) if ((o = l[r]) && d(o, e)) try {
                  delete o[e];
                } catch (e) {}
                if (A[e] && !n) return;
                try {
                  return m(A, e, n ? t : R && A[e] || t);
                } catch (e) {}
              }
              for (r in B) !(o = l[r]) || o[e] && !n || m(o, e, t);
            }
          },
          getTypedArrayConstructor: L,
          isView: function (e) {
            if (!c(e)) return !1;
            var t = p(e);
            return "DataView" === t || d(B, t) || d(N, t);
          },
          isTypedArray: V,
          TypedArray: A,
          TypedArrayPrototype: z
        };
      },
      21285: (e, t, n) => {
        "use strict";

        var r = n(47908),
          o = n(51400),
          i = n(26244);
        e.exports = function (e) {
          for (var t = r(this), n = i(t), a = arguments.length, s = o(a > 1 ? arguments[1] : void 0, n), l = a > 2 ? arguments[2] : void 0, u = void 0 === l ? n : o(l, n); u > s;) t[s++] = e;
          return t;
        };
      },
      48457: (e, t, n) => {
        "use strict";

        var r = n(49974),
          o = n(46916),
          i = n(47908),
          a = n(53411),
          s = n(97659),
          l = n(4411),
          u = n(26244),
          c = n(86135),
          d = n(18554),
          p = n(71246),
          h = Array;
        e.exports = function (e) {
          var t = i(e),
            n = l(this),
            f = arguments.length,
            m = f > 1 ? arguments[1] : void 0,
            g = void 0 !== m;
          g && (m = r(m, f > 2 ? arguments[2] : void 0));
          var v,
            y,
            b,
            w,
            x,
            D,
            C = p(t),
            S = 0;
          if (!C || this === h && s(C)) for (v = u(t), y = n ? new this(v) : h(v); v > S; S++) D = g ? m(t[S], S) : t[S], c(y, S, D);else for (x = (w = d(t, C)).next, y = n ? new this() : []; !(b = o(x, w)).done; S++) D = g ? a(w, m, [b.value, S], !0) : b.value, c(y, S, D);
          return y.length = S, y;
        };
      },
      41318: (e, t, n) => {
        var r = n(45656),
          o = n(51400),
          i = n(26244),
          a = function (e) {
            return function (t, n, a) {
              var s,
                l = r(t),
                u = i(l),
                c = o(a, u);
              if (e && n != n) {
                for (; u > c;) if ((s = l[c++]) != s) return !0;
              } else for (; u > c; c++) if ((e || c in l) && l[c] === n) return e || c || 0;
              return !e && -1;
            };
          };
        e.exports = {
          includes: a(!0),
          indexOf: a(!1)
        };
      },
      42092: (e, t, n) => {
        var r = n(49974),
          o = n(1702),
          i = n(68361),
          a = n(47908),
          s = n(26244),
          l = n(65417),
          u = o([].push),
          c = function (e) {
            var t = 1 == e,
              n = 2 == e,
              o = 3 == e,
              c = 4 == e,
              d = 6 == e,
              p = 7 == e,
              h = 5 == e || d;
            return function (f, m, g, v) {
              for (var y, b, w = a(f), x = i(w), D = r(m, g), C = s(x), S = 0, E = v || l, _ = t ? E(f, C) : n || p ? E(f, 0) : void 0; C > S; S++) if ((h || S in x) && (b = D(y = x[S], S, w), e)) if (t) _[S] = b;else if (b) switch (e) {
                case 3:
                  return !0;
                case 5:
                  return y;
                case 6:
                  return S;
                case 2:
                  u(_, y);
              } else switch (e) {
                case 4:
                  return !1;
                case 7:
                  u(_, y);
              }
              return d ? -1 : o || c ? c : _;
            };
          };
        e.exports = {
          forEach: c(0),
          map: c(1),
          filter: c(2),
          some: c(3),
          every: c(4),
          find: c(5),
          findIndex: c(6),
          filterReject: c(7)
        };
      },
      9341: (e, t, n) => {
        "use strict";

        var r = n(47293);
        e.exports = function (e, t) {
          var n = [][e];
          return !!n && r(function () {
            n.call(null, t || function () {
              return 1;
            }, 1);
          });
        };
      },
      41589: (e, t, n) => {
        var r = n(51400),
          o = n(26244),
          i = n(86135),
          a = Array,
          s = Math.max;
        e.exports = function (e, t, n) {
          for (var l = o(e), u = r(t, l), c = r(void 0 === n ? l : n, l), d = a(s(c - u, 0)), p = 0; u < c; u++, p++) i(d, p, e[u]);
          return d.length = p, d;
        };
      },
      50206: (e, t, n) => {
        var r = n(1702);
        e.exports = r([].slice);
      },
      94362: (e, t, n) => {
        var r = n(41589),
          o = Math.floor,
          i = function (e, t) {
            var n = e.length,
              l = o(n / 2);
            return n < 8 ? a(e, t) : s(e, i(r(e, 0, l), t), i(r(e, l), t), t);
          },
          a = function (e, t) {
            for (var n, r, o = e.length, i = 1; i < o;) {
              for (r = i, n = e[i]; r && t(e[r - 1], n) > 0;) e[r] = e[--r];
              r !== i++ && (e[r] = n);
            }
            return e;
          },
          s = function (e, t, n, r) {
            for (var o = t.length, i = n.length, a = 0, s = 0; a < o || s < i;) e[a + s] = a < o && s < i ? r(t[a], n[s]) <= 0 ? t[a++] : n[s++] : a < o ? t[a++] : n[s++];
            return e;
          };
        e.exports = i;
      },
      77475: (e, t, n) => {
        var r = n(43157),
          o = n(4411),
          i = n(70111),
          a = n(5112)("species"),
          s = Array;
        e.exports = function (e) {
          var t;
          return r(e) && (t = e.constructor, (o(t) && (t === s || r(t.prototype)) || i(t) && null === (t = t[a])) && (t = void 0)), void 0 === t ? s : t;
        };
      },
      65417: (e, t, n) => {
        var r = n(77475);
        e.exports = function (e, t) {
          return new (r(e))(0 === t ? 0 : t);
        };
      },
      53411: (e, t, n) => {
        var r = n(19670),
          o = n(99212);
        e.exports = function (e, t, n, i) {
          try {
            return i ? t(r(n)[0], n[1]) : t(n);
          } catch (t) {
            o(e, "throw", t);
          }
        };
      },
      17072: (e, t, n) => {
        var r = n(5112)("iterator"),
          o = !1;
        try {
          var i = 0,
            a = {
              next: function () {
                return {
                  done: !!i++
                };
              },
              return: function () {
                o = !0;
              }
            };
          a[r] = function () {
            return this;
          }, Array.from(a, function () {
            throw 2;
          });
        } catch (e) {}
        e.exports = function (e, t) {
          if (!t && !o) return !1;
          var n = !1;
          try {
            var i = {};
            i[r] = function () {
              return {
                next: function () {
                  return {
                    done: n = !0
                  };
                }
              };
            }, e(i);
          } catch (e) {}
          return n;
        };
      },
      84326: (e, t, n) => {
        var r = n(1702),
          o = r({}.toString),
          i = r("".slice);
        e.exports = function (e) {
          return i(o(e), 8, -1);
        };
      },
      70648: (e, t, n) => {
        var r = n(51694),
          o = n(60614),
          i = n(84326),
          a = n(5112)("toStringTag"),
          s = Object,
          l = "Arguments" == i(function () {
            return arguments;
          }());
        e.exports = r ? i : function (e) {
          var t, n, r;
          return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
            try {
              return e[t];
            } catch (e) {}
          }(t = s(e), a)) ? n : l ? i(t) : "Object" == (r = i(t)) && o(t.callee) ? "Arguments" : r;
        };
      },
      29320: (e, t, n) => {
        "use strict";

        var r = n(1702),
          o = n(89190),
          i = n(62423).getWeakData,
          a = n(25787),
          s = n(19670),
          l = n(68554),
          u = n(70111),
          c = n(20408),
          d = n(42092),
          p = n(92597),
          h = n(29909),
          f = h.set,
          m = h.getterFor,
          g = d.find,
          v = d.findIndex,
          y = r([].splice),
          b = 0,
          w = function (e) {
            return e.frozen || (e.frozen = new x());
          },
          x = function () {
            this.entries = [];
          },
          D = function (e, t) {
            return g(e.entries, function (e) {
              return e[0] === t;
            });
          };
        x.prototype = {
          get: function (e) {
            var t = D(this, e);
            if (t) return t[1];
          },
          has: function (e) {
            return !!D(this, e);
          },
          set: function (e, t) {
            var n = D(this, e);
            n ? n[1] = t : this.entries.push([e, t]);
          },
          delete: function (e) {
            var t = v(this.entries, function (t) {
              return t[0] === e;
            });
            return ~t && y(this.entries, t, 1), !!~t;
          }
        }, e.exports = {
          getConstructor: function (e, t, n, r) {
            var d = e(function (e, o) {
                a(e, h), f(e, {
                  type: t,
                  id: b++,
                  frozen: void 0
                }), l(o) || c(o, e[r], {
                  that: e,
                  AS_ENTRIES: n
                });
              }),
              h = d.prototype,
              g = m(t),
              v = function (e, t, n) {
                var r = g(e),
                  o = i(s(t), !0);
                return !0 === o ? w(r).set(t, n) : o[r.id] = n, e;
              };
            return o(h, {
              delete: function (e) {
                var t = g(this);
                if (!u(e)) return !1;
                var n = i(e);
                return !0 === n ? w(t).delete(e) : n && p(n, t.id) && delete n[t.id];
              },
              has: function (e) {
                var t = g(this);
                if (!u(e)) return !1;
                var n = i(e);
                return !0 === n ? w(t).has(e) : n && p(n, t.id);
              }
            }), o(h, n ? {
              get: function (e) {
                var t = g(this);
                if (u(e)) {
                  var n = i(e);
                  return !0 === n ? w(t).get(e) : n ? n[t.id] : void 0;
                }
              },
              set: function (e, t) {
                return v(this, e, t);
              }
            } : {
              add: function (e) {
                return v(this, e, !0);
              }
            }), d;
          }
        };
      },
      77710: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(17854),
          i = n(1702),
          a = n(54705),
          s = n(98052),
          l = n(62423),
          u = n(20408),
          c = n(25787),
          d = n(60614),
          p = n(68554),
          h = n(70111),
          f = n(47293),
          m = n(17072),
          g = n(58003),
          v = n(79587);
        e.exports = function (e, t, n) {
          var y = -1 !== e.indexOf("Map"),
            b = -1 !== e.indexOf("Weak"),
            w = y ? "set" : "add",
            x = o[e],
            D = x && x.prototype,
            C = x,
            S = {},
            E = function (e) {
              var t = i(D[e]);
              s(D, e, "add" == e ? function (e) {
                return t(this, 0 === e ? 0 : e), this;
              } : "delete" == e ? function (e) {
                return !(b && !h(e)) && t(this, 0 === e ? 0 : e);
              } : "get" == e ? function (e) {
                return b && !h(e) ? void 0 : t(this, 0 === e ? 0 : e);
              } : "has" == e ? function (e) {
                return !(b && !h(e)) && t(this, 0 === e ? 0 : e);
              } : function (e, n) {
                return t(this, 0 === e ? 0 : e, n), this;
              });
            };
          if (a(e, !d(x) || !(b || D.forEach && !f(function () {
            new x().entries().next();
          })))) C = n.getConstructor(t, e, y, w), l.enable();else if (a(e, !0)) {
            var _ = new C(),
              P = _[w](b ? {} : -0, 1) != _,
              k = f(function () {
                _.has(1);
              }),
              A = m(function (e) {
                new x(e);
              }),
              z = !b && f(function () {
                for (var e = new x(), t = 5; t--;) e[w](t, t);
                return !e.has(-0);
              });
            A || ((C = t(function (e, t) {
              c(e, D);
              var n = v(new x(), e, C);
              return p(t) || u(t, n[w], {
                that: n,
                AS_ENTRIES: y
              }), n;
            })).prototype = D, D.constructor = C), (k || z) && (E("delete"), E("has"), y && E("get")), (z || P) && E(w), b && D.clear && delete D.clear;
          }
          return S[e] = C, r({
            global: !0,
            constructor: !0,
            forced: C != x
          }, S), g(C, e), b || n.setStrong(C, e, y), C;
        };
      },
      99920: (e, t, n) => {
        var r = n(92597),
          o = n(53887),
          i = n(31236),
          a = n(3070);
        e.exports = function (e, t, n) {
          for (var s = o(t), l = a.f, u = i.f, c = 0; c < s.length; c++) {
            var d = s[c];
            r(e, d) || n && r(n, d) || l(e, d, u(t, d));
          }
        };
      },
      84964: (e, t, n) => {
        var r = n(5112)("match");
        e.exports = function (e) {
          var t = /./;
          try {
            "/./"[e](t);
          } catch (n) {
            try {
              return t[r] = !1, "/./"[e](t);
            } catch (e) {}
          }
          return !1;
        };
      },
      49920: (e, t, n) => {
        var r = n(47293);
        e.exports = !r(function () {
          function e() {}
          return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
        });
      },
      76178: e => {
        e.exports = function (e, t) {
          return {
            value: e,
            done: t
          };
        };
      },
      68880: (e, t, n) => {
        var r = n(19781),
          o = n(3070),
          i = n(79114);
        e.exports = r ? function (e, t, n) {
          return o.f(e, t, i(1, n));
        } : function (e, t, n) {
          return e[t] = n, e;
        };
      },
      79114: e => {
        e.exports = function (e, t) {
          return {
            enumerable: !(1 & e),
            configurable: !(2 & e),
            writable: !(4 & e),
            value: t
          };
        };
      },
      86135: (e, t, n) => {
        "use strict";

        var r = n(34948),
          o = n(3070),
          i = n(79114);
        e.exports = function (e, t, n) {
          var a = r(t);
          a in e ? o.f(e, a, i(0, n)) : e[a] = n;
        };
      },
      47045: (e, t, n) => {
        var r = n(56339),
          o = n(3070);
        e.exports = function (e, t, n) {
          return n.get && r(n.get, t, {
            getter: !0
          }), n.set && r(n.set, t, {
            setter: !0
          }), o.f(e, t, n);
        };
      },
      98052: (e, t, n) => {
        var r = n(60614),
          o = n(3070),
          i = n(56339),
          a = n(13072);
        e.exports = function (e, t, n, s) {
          s || (s = {});
          var l = s.enumerable,
            u = void 0 !== s.name ? s.name : t;
          if (r(n) && i(n, u, s), s.global) l ? e[t] = n : a(t, n);else {
            try {
              s.unsafe ? e[t] && (l = !0) : delete e[t];
            } catch (e) {}
            l ? e[t] = n : o.f(e, t, {
              value: n,
              enumerable: !1,
              configurable: !s.nonConfigurable,
              writable: !s.nonWritable
            });
          }
          return e;
        };
      },
      89190: (e, t, n) => {
        var r = n(98052);
        e.exports = function (e, t, n) {
          for (var o in t) r(e, o, t[o], n);
          return e;
        };
      },
      13072: (e, t, n) => {
        var r = n(17854),
          o = Object.defineProperty;
        e.exports = function (e, t) {
          try {
            o(r, e, {
              value: t,
              configurable: !0,
              writable: !0
            });
          } catch (n) {
            r[e] = t;
          }
          return t;
        };
      },
      85117: (e, t, n) => {
        "use strict";

        var r = n(66330),
          o = TypeError;
        e.exports = function (e, t) {
          if (!delete e[t]) throw o("Cannot delete property " + r(t) + " of " + r(e));
        };
      },
      19781: (e, t, n) => {
        var r = n(47293);
        e.exports = !r(function () {
          return 7 != Object.defineProperty({}, 1, {
            get: function () {
              return 7;
            }
          })[1];
        });
      },
      4154: e => {
        var t = "object" == typeof document && document.all,
          n = void 0 === t && void 0 !== t;
        e.exports = {
          all: t,
          IS_HTMLDDA: n
        };
      },
      80317: (e, t, n) => {
        var r = n(17854),
          o = n(70111),
          i = r.document,
          a = o(i) && o(i.createElement);
        e.exports = function (e) {
          return a ? i.createElement(e) : {};
        };
      },
      7207: e => {
        var t = TypeError;
        e.exports = function (e) {
          if (e > 9007199254740991) throw t("Maximum allowed index exceeded");
          return e;
        };
      },
      48324: e => {
        e.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0
        };
      },
      98509: (e, t, n) => {
        var r = n(80317)("span").classList,
          o = r && r.constructor && r.constructor.prototype;
        e.exports = o === Object.prototype ? void 0 : o;
      },
      68886: (e, t, n) => {
        var r = n(88113).match(/firefox\/(\d+)/i);
        e.exports = !!r && +r[1];
      },
      7871: (e, t, n) => {
        var r = n(83823),
          o = n(35268);
        e.exports = !r && !o && "object" == typeof window && "object" == typeof document;
      },
      89363: e => {
        e.exports = "function" == typeof Bun && Bun && "string" == typeof Bun.version;
      },
      83823: e => {
        e.exports = "object" == typeof Deno && Deno && "object" == typeof Deno.version;
      },
      30256: (e, t, n) => {
        var r = n(88113);
        e.exports = /MSIE|Trident/.test(r);
      },
      71528: (e, t, n) => {
        var r = n(88113),
          o = n(17854);
        e.exports = /ipad|iphone|ipod/i.test(r) && void 0 !== o.Pebble;
      },
      6833: (e, t, n) => {
        var r = n(88113);
        e.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(r);
      },
      35268: (e, t, n) => {
        var r = n(84326),
          o = n(17854);
        e.exports = "process" == r(o.process);
      },
      71036: (e, t, n) => {
        var r = n(88113);
        e.exports = /web0s(?!.*chrome)/i.test(r);
      },
      88113: (e, t, n) => {
        var r = n(35005);
        e.exports = r("navigator", "userAgent") || "";
      },
      7392: (e, t, n) => {
        var r,
          o,
          i = n(17854),
          a = n(88113),
          s = i.process,
          l = i.Deno,
          u = s && s.versions || l && l.version,
          c = u && u.v8;
        c && (o = (r = c.split("."))[0] > 0 && r[0] < 4 ? 1 : +(r[0] + r[1])), !o && a && (!(r = a.match(/Edge\/(\d+)/)) || r[1] >= 74) && (r = a.match(/Chrome\/(\d+)/)) && (o = +r[1]), e.exports = o;
      },
      98008: (e, t, n) => {
        var r = n(88113).match(/AppleWebKit\/(\d+)\./);
        e.exports = !!r && +r[1];
      },
      80748: e => {
        e.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"];
      },
      82109: (e, t, n) => {
        var r = n(17854),
          o = n(31236).f,
          i = n(68880),
          a = n(98052),
          s = n(13072),
          l = n(99920),
          u = n(54705);
        e.exports = function (e, t) {
          var n,
            c,
            d,
            p,
            h,
            f = e.target,
            m = e.global,
            g = e.stat;
          if (n = m ? r : g ? r[f] || s(f, {}) : (r[f] || {}).prototype) for (c in t) {
            if (p = t[c], d = e.dontCallGetSet ? (h = o(n, c)) && h.value : n[c], !u(m ? c : f + (g ? "." : "#") + c, e.forced) && void 0 !== d) {
              if (typeof p == typeof d) continue;
              l(p, d);
            }
            (e.sham || d && d.sham) && i(p, "sham", !0), a(n, c, p, e);
          }
        };
      },
      47293: e => {
        e.exports = function (e) {
          try {
            return !!e();
          } catch (e) {
            return !0;
          }
        };
      },
      27007: (e, t, n) => {
        "use strict";

        n(74916);
        var r = n(21470),
          o = n(98052),
          i = n(22261),
          a = n(47293),
          s = n(5112),
          l = n(68880),
          u = s("species"),
          c = RegExp.prototype;
        e.exports = function (e, t, n, d) {
          var p = s(e),
            h = !a(function () {
              var t = {};
              return t[p] = function () {
                return 7;
              }, 7 != ""[e](t);
            }),
            f = h && !a(function () {
              var t = !1,
                n = /a/;
              return "split" === e && ((n = {}).constructor = {}, n.constructor[u] = function () {
                return n;
              }, n.flags = "", n[p] = /./[p]), n.exec = function () {
                return t = !0, null;
              }, n[p](""), !t;
            });
          if (!h || !f || n) {
            var m = r(/./[p]),
              g = t(p, ""[e], function (e, t, n, o, a) {
                var s = r(e),
                  l = t.exec;
                return l === i || l === c.exec ? h && !a ? {
                  done: !0,
                  value: m(t, n, o)
                } : {
                  done: !0,
                  value: s(n, t, o)
                } : {
                  done: !1
                };
              });
            o(String.prototype, e, g[0]), o(c, p, g[1]);
          }
          d && l(c[p], "sham", !0);
        };
      },
      6790: (e, t, n) => {
        "use strict";

        var r = n(43157),
          o = n(26244),
          i = n(7207),
          a = n(49974),
          s = function (e, t, n, l, u, c, d, p) {
            for (var h, f, m = u, g = 0, v = !!d && a(d, p); g < l;) g in n && (h = v ? v(n[g], g, t) : n[g], c > 0 && r(h) ? (f = o(h), m = s(e, t, h, f, m, c - 1) - 1) : (i(m + 1), e[m] = h), m++), g++;
            return m;
          };
        e.exports = s;
      },
      76677: (e, t, n) => {
        var r = n(47293);
        e.exports = !r(function () {
          return Object.isExtensible(Object.preventExtensions({}));
        });
      },
      22104: (e, t, n) => {
        var r = n(34374),
          o = Function.prototype,
          i = o.apply,
          a = o.call;
        e.exports = "object" == typeof Reflect && Reflect.apply || (r ? a.bind(i) : function () {
          return a.apply(i, arguments);
        });
      },
      49974: (e, t, n) => {
        var r = n(21470),
          o = n(19662),
          i = n(34374),
          a = r(r.bind);
        e.exports = function (e, t) {
          return o(e), void 0 === t ? e : i ? a(e, t) : function () {
            return e.apply(t, arguments);
          };
        };
      },
      34374: (e, t, n) => {
        var r = n(47293);
        e.exports = !r(function () {
          var e = function () {}.bind();
          return "function" != typeof e || e.hasOwnProperty("prototype");
        });
      },
      46916: (e, t, n) => {
        var r = n(34374),
          o = Function.prototype.call;
        e.exports = r ? o.bind(o) : function () {
          return o.apply(o, arguments);
        };
      },
      76530: (e, t, n) => {
        var r = n(19781),
          o = n(92597),
          i = Function.prototype,
          a = r && Object.getOwnPropertyDescriptor,
          s = o(i, "name"),
          l = s && "something" === function () {}.name,
          u = s && (!r || r && a(i, "name").configurable);
        e.exports = {
          EXISTS: s,
          PROPER: l,
          CONFIGURABLE: u
        };
      },
      21470: (e, t, n) => {
        var r = n(84326),
          o = n(1702);
        e.exports = function (e) {
          if ("Function" === r(e)) return o(e);
        };
      },
      1702: (e, t, n) => {
        var r = n(34374),
          o = Function.prototype,
          i = o.call,
          a = r && o.bind.bind(i, i);
        e.exports = r ? a : function (e) {
          return function () {
            return i.apply(e, arguments);
          };
        };
      },
      35005: (e, t, n) => {
        var r = n(17854),
          o = n(60614),
          i = function (e) {
            return o(e) ? e : void 0;
          };
        e.exports = function (e, t) {
          return arguments.length < 2 ? i(r[e]) : r[e] && r[e][t];
        };
      },
      71246: (e, t, n) => {
        var r = n(70648),
          o = n(58173),
          i = n(68554),
          a = n(97497),
          s = n(5112)("iterator");
        e.exports = function (e) {
          if (!i(e)) return o(e, s) || o(e, "@@iterator") || a[r(e)];
        };
      },
      18554: (e, t, n) => {
        var r = n(46916),
          o = n(19662),
          i = n(19670),
          a = n(66330),
          s = n(71246),
          l = TypeError;
        e.exports = function (e, t) {
          var n = arguments.length < 2 ? s(e) : t;
          if (o(n)) return i(r(n, e));
          throw l(a(e) + " is not iterable");
        };
      },
      58173: (e, t, n) => {
        var r = n(19662),
          o = n(68554);
        e.exports = function (e, t) {
          var n = e[t];
          return o(n) ? void 0 : r(n);
        };
      },
      10647: (e, t, n) => {
        var r = n(1702),
          o = n(47908),
          i = Math.floor,
          a = r("".charAt),
          s = r("".replace),
          l = r("".slice),
          u = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
          c = /\$([$&'`]|\d{1,2})/g;
        e.exports = function (e, t, n, r, d, p) {
          var h = n + e.length,
            f = r.length,
            m = c;
          return void 0 !== d && (d = o(d), m = u), s(p, m, function (o, s) {
            var u;
            switch (a(s, 0)) {
              case "$":
                return "$";
              case "&":
                return e;
              case "`":
                return l(t, 0, n);
              case "'":
                return l(t, h);
              case "<":
                u = d[l(s, 1, -1)];
                break;
              default:
                var c = +s;
                if (0 === c) return o;
                if (c > f) {
                  var p = i(c / 10);
                  return 0 === p ? o : p <= f ? void 0 === r[p - 1] ? a(s, 1) : r[p - 1] + a(s, 1) : o;
                }
                u = r[c - 1];
            }
            return void 0 === u ? "" : u;
          });
        };
      },
      17854: (e, t, n) => {
        var r = function (e) {
          return e && e.Math == Math && e;
        };
        e.exports = r("object" == typeof globalThis && globalThis) || r("object" == typeof window && window) || r("object" == typeof self && self) || r("object" == typeof n.g && n.g) || function () {
          return this;
        }() || Function("return this")();
      },
      92597: (e, t, n) => {
        var r = n(1702),
          o = n(47908),
          i = r({}.hasOwnProperty);
        e.exports = Object.hasOwn || function (e, t) {
          return i(o(e), t);
        };
      },
      3501: e => {
        e.exports = {};
      },
      842: (e, t, n) => {
        var r = n(17854);
        e.exports = function (e, t) {
          var n = r.console;
          n && n.error && (1 == arguments.length ? n.error(e) : n.error(e, t));
        };
      },
      60490: (e, t, n) => {
        var r = n(35005);
        e.exports = r("document", "documentElement");
      },
      64664: (e, t, n) => {
        var r = n(19781),
          o = n(47293),
          i = n(80317);
        e.exports = !r && !o(function () {
          return 7 != Object.defineProperty(i("div"), "a", {
            get: function () {
              return 7;
            }
          }).a;
        });
      },
      68361: (e, t, n) => {
        var r = n(1702),
          o = n(47293),
          i = n(84326),
          a = Object,
          s = r("".split);
        e.exports = o(function () {
          return !a("z").propertyIsEnumerable(0);
        }) ? function (e) {
          return "String" == i(e) ? s(e, "") : a(e);
        } : a;
      },
      79587: (e, t, n) => {
        var r = n(60614),
          o = n(70111),
          i = n(27674);
        e.exports = function (e, t, n) {
          var a, s;
          return i && r(a = t.constructor) && a !== n && o(s = a.prototype) && s !== n.prototype && i(e, s), e;
        };
      },
      42788: (e, t, n) => {
        var r = n(1702),
          o = n(60614),
          i = n(5465),
          a = r(Function.toString);
        o(i.inspectSource) || (i.inspectSource = function (e) {
          return a(e);
        }), e.exports = i.inspectSource;
      },
      62423: (e, t, n) => {
        var r = n(82109),
          o = n(1702),
          i = n(3501),
          a = n(70111),
          s = n(92597),
          l = n(3070).f,
          u = n(8006),
          c = n(1156),
          d = n(52050),
          p = n(69711),
          h = n(76677),
          f = !1,
          m = p("meta"),
          g = 0,
          v = function (e) {
            l(e, m, {
              value: {
                objectID: "O" + g++,
                weakData: {}
              }
            });
          },
          y = e.exports = {
            enable: function () {
              y.enable = function () {}, f = !0;
              var e = u.f,
                t = o([].splice),
                n = {};
              n[m] = 1, e(n).length && (u.f = function (n) {
                for (var r = e(n), o = 0, i = r.length; o < i; o++) if (r[o] === m) {
                  t(r, o, 1);
                  break;
                }
                return r;
              }, r({
                target: "Object",
                stat: !0,
                forced: !0
              }, {
                getOwnPropertyNames: c.f
              }));
            },
            fastKey: function (e, t) {
              if (!a(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
              if (!s(e, m)) {
                if (!d(e)) return "F";
                if (!t) return "E";
                v(e);
              }
              return e[m].objectID;
            },
            getWeakData: function (e, t) {
              if (!s(e, m)) {
                if (!d(e)) return !0;
                if (!t) return !1;
                v(e);
              }
              return e[m].weakData;
            },
            onFreeze: function (e) {
              return h && f && d(e) && !s(e, m) && v(e), e;
            }
          };
        i[m] = !0;
      },
      29909: (e, t, n) => {
        var r,
          o,
          i,
          a = n(94811),
          s = n(17854),
          l = n(70111),
          u = n(68880),
          c = n(92597),
          d = n(5465),
          p = n(6200),
          h = n(3501),
          f = "Object already initialized",
          m = s.TypeError,
          g = s.WeakMap;
        if (a || d.state) {
          var v = d.state || (d.state = new g());
          v.get = v.get, v.has = v.has, v.set = v.set, r = function (e, t) {
            if (v.has(e)) throw m(f);
            return t.facade = e, v.set(e, t), t;
          }, o = function (e) {
            return v.get(e) || {};
          }, i = function (e) {
            return v.has(e);
          };
        } else {
          var y = p("state");
          h[y] = !0, r = function (e, t) {
            if (c(e, y)) throw m(f);
            return t.facade = e, u(e, y, t), t;
          }, o = function (e) {
            return c(e, y) ? e[y] : {};
          }, i = function (e) {
            return c(e, y);
          };
        }
        e.exports = {
          set: r,
          get: o,
          has: i,
          enforce: function (e) {
            return i(e) ? o(e) : r(e, {});
          },
          getterFor: function (e) {
            return function (t) {
              var n;
              if (!l(t) || (n = o(t)).type !== e) throw m("Incompatible receiver, " + e + " required");
              return n;
            };
          }
        };
      },
      97659: (e, t, n) => {
        var r = n(5112),
          o = n(97497),
          i = r("iterator"),
          a = Array.prototype;
        e.exports = function (e) {
          return void 0 !== e && (o.Array === e || a[i] === e);
        };
      },
      43157: (e, t, n) => {
        var r = n(84326);
        e.exports = Array.isArray || function (e) {
          return "Array" == r(e);
        };
      },
      60614: (e, t, n) => {
        var r = n(4154),
          o = r.all;
        e.exports = r.IS_HTMLDDA ? function (e) {
          return "function" == typeof e || e === o;
        } : function (e) {
          return "function" == typeof e;
        };
      },
      4411: (e, t, n) => {
        var r = n(1702),
          o = n(47293),
          i = n(60614),
          a = n(70648),
          s = n(35005),
          l = n(42788),
          u = function () {},
          c = [],
          d = s("Reflect", "construct"),
          p = /^\s*(?:class|function)\b/,
          h = r(p.exec),
          f = !p.exec(u),
          m = function (e) {
            if (!i(e)) return !1;
            try {
              return d(u, c, e), !0;
            } catch (e) {
              return !1;
            }
          },
          g = function (e) {
            if (!i(e)) return !1;
            switch (a(e)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return !1;
            }
            try {
              return f || !!h(p, l(e));
            } catch (e) {
              return !0;
            }
          };
        g.sham = !0, e.exports = !d || o(function () {
          var e;
          return m(m.call) || !m(Object) || !m(function () {
            e = !0;
          }) || e;
        }) ? g : m;
      },
      45032: (e, t, n) => {
        var r = n(92597);
        e.exports = function (e) {
          return void 0 !== e && (r(e, "value") || r(e, "writable"));
        };
      },
      54705: (e, t, n) => {
        var r = n(47293),
          o = n(60614),
          i = /#|\.prototype\./,
          a = function (e, t) {
            var n = l[s(e)];
            return n == c || n != u && (o(t) ? r(t) : !!t);
          },
          s = a.normalize = function (e) {
            return String(e).replace(i, ".").toLowerCase();
          },
          l = a.data = {},
          u = a.NATIVE = "N",
          c = a.POLYFILL = "P";
        e.exports = a;
      },
      68554: e => {
        e.exports = function (e) {
          return null == e;
        };
      },
      70111: (e, t, n) => {
        var r = n(60614),
          o = n(4154),
          i = o.all;
        e.exports = o.IS_HTMLDDA ? function (e) {
          return "object" == typeof e ? null !== e : r(e) || e === i;
        } : function (e) {
          return "object" == typeof e ? null !== e : r(e);
        };
      },
      31913: e => {
        e.exports = !1;
      },
      47850: (e, t, n) => {
        var r = n(70111),
          o = n(84326),
          i = n(5112)("match");
        e.exports = function (e) {
          var t;
          return r(e) && (void 0 !== (t = e[i]) ? !!t : "RegExp" == o(e));
        };
      },
      52190: (e, t, n) => {
        var r = n(35005),
          o = n(60614),
          i = n(47976),
          a = n(43307),
          s = Object;
        e.exports = a ? function (e) {
          return "symbol" == typeof e;
        } : function (e) {
          var t = r("Symbol");
          return o(t) && i(t.prototype, s(e));
        };
      },
      20408: (e, t, n) => {
        var r = n(49974),
          o = n(46916),
          i = n(19670),
          a = n(66330),
          s = n(97659),
          l = n(26244),
          u = n(47976),
          c = n(18554),
          d = n(71246),
          p = n(99212),
          h = TypeError,
          f = function (e, t) {
            this.stopped = e, this.result = t;
          },
          m = f.prototype;
        e.exports = function (e, t, n) {
          var g,
            v,
            y,
            b,
            w,
            x,
            D,
            C = n && n.that,
            S = !(!n || !n.AS_ENTRIES),
            E = !(!n || !n.IS_RECORD),
            _ = !(!n || !n.IS_ITERATOR),
            P = !(!n || !n.INTERRUPTED),
            k = r(t, C),
            A = function (e) {
              return g && p(g, "normal", e), new f(!0, e);
            },
            z = function (e) {
              return S ? (i(e), P ? k(e[0], e[1], A) : k(e[0], e[1])) : P ? k(e, A) : k(e);
            };
          if (E) g = e.iterator;else if (_) g = e;else {
            if (!(v = d(e))) throw h(a(e) + " is not iterable");
            if (s(v)) {
              for (y = 0, b = l(e); b > y; y++) if ((w = z(e[y])) && u(m, w)) return w;
              return new f(!1);
            }
            g = c(e, v);
          }
          for (x = E ? e.next : g.next; !(D = o(x, g)).done;) {
            try {
              w = z(D.value);
            } catch (e) {
              p(g, "throw", e);
            }
            if ("object" == typeof w && w && u(m, w)) return w;
          }
          return new f(!1);
        };
      },
      99212: (e, t, n) => {
        var r = n(46916),
          o = n(19670),
          i = n(58173);
        e.exports = function (e, t, n) {
          var a, s;
          o(e);
          try {
            if (!(a = i(e, "return"))) {
              if ("throw" === t) throw n;
              return n;
            }
            a = r(a, e);
          } catch (e) {
            s = !0, a = e;
          }
          if ("throw" === t) throw n;
          if (s) throw a;
          return o(a), n;
        };
      },
      63061: (e, t, n) => {
        "use strict";

        var r = n(13383).IteratorPrototype,
          o = n(70030),
          i = n(79114),
          a = n(58003),
          s = n(97497),
          l = function () {
            return this;
          };
        e.exports = function (e, t, n, u) {
          var c = t + " Iterator";
          return e.prototype = o(r, {
            next: i(+!u, n)
          }), a(e, c, !1, !0), s[c] = l, e;
        };
      },
      51656: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(46916),
          i = n(31913),
          a = n(76530),
          s = n(60614),
          l = n(63061),
          u = n(79518),
          c = n(27674),
          d = n(58003),
          p = n(68880),
          h = n(98052),
          f = n(5112),
          m = n(97497),
          g = n(13383),
          v = a.PROPER,
          y = a.CONFIGURABLE,
          b = g.IteratorPrototype,
          w = g.BUGGY_SAFARI_ITERATORS,
          x = f("iterator"),
          D = "keys",
          C = "values",
          S = "entries",
          E = function () {
            return this;
          };
        e.exports = function (e, t, n, a, f, g, _) {
          l(n, t, a);
          var P,
            k,
            A,
            z = function (e) {
              if (e === f && M) return M;
              if (!w && e in I) return I[e];
              switch (e) {
                case D:
                case C:
                case S:
                  return function () {
                    return new n(this, e);
                  };
              }
              return function () {
                return new n(this);
              };
            },
            T = t + " Iterator",
            O = !1,
            I = e.prototype,
            F = I[x] || I["@@iterator"] || f && I[f],
            M = !w && F || z(f),
            R = "Array" == t && I.entries || F;
          if (R && (P = u(R.call(new e()))) !== Object.prototype && P.next && (i || u(P) === b || (c ? c(P, b) : s(P[x]) || h(P, x, E)), d(P, T, !0, !0), i && (m[T] = E)), v && f == C && F && F.name !== C && (!i && y ? p(I, "name", C) : (O = !0, M = function () {
            return o(F, this);
          })), f) if (k = {
            values: z(C),
            keys: g ? M : z(D),
            entries: z(S)
          }, _) for (A in k) (w || O || !(A in I)) && h(I, A, k[A]);else r({
            target: t,
            proto: !0,
            forced: w || O
          }, k);
          return i && !_ || I[x] === M || h(I, x, M, {
            name: f
          }), m[t] = M, k;
        };
      },
      13383: (e, t, n) => {
        "use strict";

        var r,
          o,
          i,
          a = n(47293),
          s = n(60614),
          l = n(70111),
          u = n(70030),
          c = n(79518),
          d = n(98052),
          p = n(5112),
          h = n(31913),
          f = p("iterator"),
          m = !1;
        [].keys && ("next" in (i = [].keys()) ? (o = c(c(i))) !== Object.prototype && (r = o) : m = !0), !l(r) || a(function () {
          var e = {};
          return r[f].call(e) !== e;
        }) ? r = {} : h && (r = u(r)), s(r[f]) || d(r, f, function () {
          return this;
        }), e.exports = {
          IteratorPrototype: r,
          BUGGY_SAFARI_ITERATORS: m
        };
      },
      97497: e => {
        e.exports = {};
      },
      26244: (e, t, n) => {
        var r = n(17466);
        e.exports = function (e) {
          return r(e.length);
        };
      },
      56339: (e, t, n) => {
        var r = n(47293),
          o = n(60614),
          i = n(92597),
          a = n(19781),
          s = n(76530).CONFIGURABLE,
          l = n(42788),
          u = n(29909),
          c = u.enforce,
          d = u.get,
          p = Object.defineProperty,
          h = a && !r(function () {
            return 8 !== p(function () {}, "length", {
              value: 8
            }).length;
          }),
          f = String(String).split("String"),
          m = e.exports = function (e, t, n) {
            "Symbol(" === String(t).slice(0, 7) && (t = "[" + String(t).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), n && n.getter && (t = "get " + t), n && n.setter && (t = "set " + t), (!i(e, "name") || s && e.name !== t) && (a ? p(e, "name", {
              value: t,
              configurable: !0
            }) : e.name = t), h && n && i(n, "arity") && e.length !== n.arity && p(e, "length", {
              value: n.arity
            });
            try {
              n && i(n, "constructor") && n.constructor ? a && p(e, "prototype", {
                writable: !1
              }) : e.prototype && (e.prototype = void 0);
            } catch (e) {}
            var r = c(e);
            return i(r, "source") || (r.source = f.join("string" == typeof t ? t : "")), e;
          };
        Function.prototype.toString = m(function () {
          return o(this) && d(this).source || l(this);
        }, "toString");
      },
      74758: e => {
        var t = Math.ceil,
          n = Math.floor;
        e.exports = Math.trunc || function (e) {
          var r = +e;
          return (r > 0 ? n : t)(r);
        };
      },
      95948: (e, t, n) => {
        var r,
          o,
          i,
          a,
          s,
          l,
          u,
          c,
          d = n(17854),
          p = n(49974),
          h = n(31236).f,
          f = n(20261).set,
          m = n(6833),
          g = n(71528),
          v = n(71036),
          y = n(35268),
          b = d.MutationObserver || d.WebKitMutationObserver,
          w = d.document,
          x = d.process,
          D = d.Promise,
          C = h(d, "queueMicrotask"),
          S = C && C.value;
        S || (r = function () {
          var e, t;
          for (y && (e = x.domain) && e.exit(); o;) {
            t = o.fn, o = o.next;
            try {
              t();
            } catch (e) {
              throw o ? a() : i = void 0, e;
            }
          }
          i = void 0, e && e.enter();
        }, m || y || v || !b || !w ? !g && D && D.resolve ? ((u = D.resolve(void 0)).constructor = D, c = p(u.then, u), a = function () {
          c(r);
        }) : y ? a = function () {
          x.nextTick(r);
        } : (f = p(f, d), a = function () {
          f(r);
        }) : (s = !0, l = w.createTextNode(""), new b(r).observe(l, {
          characterData: !0
        }), a = function () {
          l.data = s = !s;
        })), e.exports = S || function (e) {
          var t = {
            fn: e,
            next: void 0
          };
          i && (i.next = t), o || (o = t, a()), i = t;
        };
      },
      78523: (e, t, n) => {
        "use strict";

        var r = n(19662),
          o = TypeError,
          i = function (e) {
            var t, n;
            this.promise = new e(function (e, r) {
              if (void 0 !== t || void 0 !== n) throw o("Bad Promise constructor");
              t = e, n = r;
            }), this.resolve = r(t), this.reject = r(n);
          };
        e.exports.f = function (e) {
          return new i(e);
        };
      },
      3929: (e, t, n) => {
        var r = n(47850),
          o = TypeError;
        e.exports = function (e) {
          if (r(e)) throw o("The method doesn't accept regular expressions");
          return e;
        };
      },
      2814: (e, t, n) => {
        var r = n(17854),
          o = n(47293),
          i = n(1702),
          a = n(41340),
          s = n(53111).trim,
          l = n(81361),
          u = i("".charAt),
          c = r.parseFloat,
          d = r.Symbol,
          p = d && d.iterator,
          h = 1 / c(l + "-0") != -1 / 0 || p && !o(function () {
            c(Object(p));
          });
        e.exports = h ? function (e) {
          var t = s(a(e)),
            n = c(t);
          return 0 === n && "-" == u(t, 0) ? -0 : n;
        } : c;
      },
      83009: (e, t, n) => {
        var r = n(17854),
          o = n(47293),
          i = n(1702),
          a = n(41340),
          s = n(53111).trim,
          l = n(81361),
          u = r.parseInt,
          c = r.Symbol,
          d = c && c.iterator,
          p = /^[+-]?0x/i,
          h = i(p.exec),
          f = 8 !== u(l + "08") || 22 !== u(l + "0x16") || d && !o(function () {
            u(Object(d));
          });
        e.exports = f ? function (e, t) {
          var n = s(a(e));
          return u(n, t >>> 0 || (h(p, n) ? 16 : 10));
        } : u;
      },
      21574: (e, t, n) => {
        "use strict";

        var r = n(19781),
          o = n(1702),
          i = n(46916),
          a = n(47293),
          s = n(81956),
          l = n(25181),
          u = n(55296),
          c = n(47908),
          d = n(68361),
          p = Object.assign,
          h = Object.defineProperty,
          f = o([].concat);
        e.exports = !p || a(function () {
          if (r && 1 !== p({
            b: 1
          }, p(h({}, "a", {
            enumerable: !0,
            get: function () {
              h(this, "b", {
                value: 3,
                enumerable: !1
              });
            }
          }), {
            b: 2
          })).b) return !0;
          var e = {},
            t = {},
            n = Symbol(),
            o = "abcdefghijklmnopqrst";
          return e[n] = 7, o.split("").forEach(function (e) {
            t[e] = e;
          }), 7 != p({}, e)[n] || s(p({}, t)).join("") != o;
        }) ? function (e, t) {
          for (var n = c(e), o = arguments.length, a = 1, p = l.f, h = u.f; o > a;) for (var m, g = d(arguments[a++]), v = p ? f(s(g), p(g)) : s(g), y = v.length, b = 0; y > b;) m = v[b++], r && !i(h, g, m) || (n[m] = g[m]);
          return n;
        } : p;
      },
      70030: (e, t, n) => {
        var r,
          o = n(19670),
          i = n(36048),
          a = n(80748),
          s = n(3501),
          l = n(60490),
          u = n(80317),
          c = n(6200),
          d = c("IE_PROTO"),
          p = function () {},
          h = function (e) {
            return "<script>" + e + "</" + "script>";
          },
          f = function (e) {
            e.write(h("")), e.close();
            var t = e.parentWindow.Object;
            return e = null, t;
          },
          m = function () {
            try {
              r = new ActiveXObject("htmlfile");
            } catch (e) {}
            var e, t;
            m = "undefined" != typeof document ? document.domain && r ? f(r) : ((t = u("iframe")).style.display = "none", l.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(h("document.F=Object")), e.close(), e.F) : f(r);
            for (var n = a.length; n--;) delete m.prototype[a[n]];
            return m();
          };
        s[d] = !0, e.exports = Object.create || function (e, t) {
          var n;
          return null !== e ? (p.prototype = o(e), n = new p(), p.prototype = null, n[d] = e) : n = m(), void 0 === t ? n : i.f(n, t);
        };
      },
      36048: (e, t, n) => {
        var r = n(19781),
          o = n(3353),
          i = n(3070),
          a = n(19670),
          s = n(45656),
          l = n(81956);
        t.f = r && !o ? Object.defineProperties : function (e, t) {
          a(e);
          for (var n, r = s(t), o = l(t), u = o.length, c = 0; u > c;) i.f(e, n = o[c++], r[n]);
          return e;
        };
      },
      3070: (e, t, n) => {
        var r = n(19781),
          o = n(64664),
          i = n(3353),
          a = n(19670),
          s = n(34948),
          l = TypeError,
          u = Object.defineProperty,
          c = Object.getOwnPropertyDescriptor,
          d = "enumerable",
          p = "configurable",
          h = "writable";
        t.f = r ? i ? function (e, t, n) {
          if (a(e), t = s(t), a(n), "function" == typeof e && "prototype" === t && "value" in n && h in n && !n.writable) {
            var r = c(e, t);
            r && r.writable && (e[t] = n.value, n = {
              configurable: p in n ? n.configurable : r.configurable,
              enumerable: d in n ? n.enumerable : r.enumerable,
              writable: !1
            });
          }
          return u(e, t, n);
        } : u : function (e, t, n) {
          if (a(e), t = s(t), a(n), o) try {
            return u(e, t, n);
          } catch (e) {}
          if ("get" in n || "set" in n) throw l("Accessors not supported");
          return "value" in n && (e[t] = n.value), e;
        };
      },
      31236: (e, t, n) => {
        var r = n(19781),
          o = n(46916),
          i = n(55296),
          a = n(79114),
          s = n(45656),
          l = n(34948),
          u = n(92597),
          c = n(64664),
          d = Object.getOwnPropertyDescriptor;
        t.f = r ? d : function (e, t) {
          if (e = s(e), t = l(t), c) try {
            return d(e, t);
          } catch (e) {}
          if (u(e, t)) return a(!o(i.f, e, t), e[t]);
        };
      },
      1156: (e, t, n) => {
        var r = n(84326),
          o = n(45656),
          i = n(8006).f,
          a = n(41589),
          s = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
        e.exports.f = function (e) {
          return s && "Window" == r(e) ? function (e) {
            try {
              return i(e);
            } catch (e) {
              return a(s);
            }
          }(e) : i(o(e));
        };
      },
      8006: (e, t, n) => {
        var r = n(16324),
          o = n(80748).concat("length", "prototype");
        t.f = Object.getOwnPropertyNames || function (e) {
          return r(e, o);
        };
      },
      25181: (e, t) => {
        t.f = Object.getOwnPropertySymbols;
      },
      79518: (e, t, n) => {
        var r = n(92597),
          o = n(60614),
          i = n(47908),
          a = n(6200),
          s = n(49920),
          l = a("IE_PROTO"),
          u = Object,
          c = u.prototype;
        e.exports = s ? u.getPrototypeOf : function (e) {
          var t = i(e);
          if (r(t, l)) return t[l];
          var n = t.constructor;
          return o(n) && t instanceof n ? n.prototype : t instanceof u ? c : null;
        };
      },
      52050: (e, t, n) => {
        var r = n(47293),
          o = n(70111),
          i = n(84326),
          a = n(7556),
          s = Object.isExtensible,
          l = r(function () {
            s(1);
          });
        e.exports = l || a ? function (e) {
          return !!o(e) && (!a || "ArrayBuffer" != i(e)) && (!s || s(e));
        } : s;
      },
      47976: (e, t, n) => {
        var r = n(1702);
        e.exports = r({}.isPrototypeOf);
      },
      16324: (e, t, n) => {
        var r = n(1702),
          o = n(92597),
          i = n(45656),
          a = n(41318).indexOf,
          s = n(3501),
          l = r([].push);
        e.exports = function (e, t) {
          var n,
            r = i(e),
            u = 0,
            c = [];
          for (n in r) !o(s, n) && o(r, n) && l(c, n);
          for (; t.length > u;) o(r, n = t[u++]) && (~a(c, n) || l(c, n));
          return c;
        };
      },
      81956: (e, t, n) => {
        var r = n(16324),
          o = n(80748);
        e.exports = Object.keys || function (e) {
          return r(e, o);
        };
      },
      55296: (e, t) => {
        "use strict";

        var n = {}.propertyIsEnumerable,
          r = Object.getOwnPropertyDescriptor,
          o = r && !n.call({
            1: 2
          }, 1);
        t.f = o ? function (e) {
          var t = r(this, e);
          return !!t && t.enumerable;
        } : n;
      },
      27674: (e, t, n) => {
        var r = n(1702),
          o = n(19670),
          i = n(96077);
        e.exports = Object.setPrototypeOf || ("__proto__" in {} ? function () {
          var e,
            t = !1,
            n = {};
          try {
            (e = r(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(n, []), t = n instanceof Array;
          } catch (e) {}
          return function (n, r) {
            return o(n), i(r), t ? e(n, r) : n.__proto__ = r, n;
          };
        }() : void 0);
      },
      92140: (e, t, n) => {
        var r = n(46916),
          o = n(60614),
          i = n(70111),
          a = TypeError;
        e.exports = function (e, t) {
          var n, s;
          if ("string" === t && o(n = e.toString) && !i(s = r(n, e))) return s;
          if (o(n = e.valueOf) && !i(s = r(n, e))) return s;
          if ("string" !== t && o(n = e.toString) && !i(s = r(n, e))) return s;
          throw a("Can't convert object to primitive value");
        };
      },
      53887: (e, t, n) => {
        var r = n(35005),
          o = n(1702),
          i = n(8006),
          a = n(25181),
          s = n(19670),
          l = o([].concat);
        e.exports = r("Reflect", "ownKeys") || function (e) {
          var t = i.f(s(e)),
            n = a.f;
          return n ? l(t, n(e)) : t;
        };
      },
      40857: (e, t, n) => {
        var r = n(17854);
        e.exports = r;
      },
      12534: e => {
        e.exports = function (e) {
          try {
            return {
              error: !1,
              value: e()
            };
          } catch (e) {
            return {
              error: !0,
              value: e
            };
          }
        };
      },
      63702: (e, t, n) => {
        var r = n(17854),
          o = n(2492),
          i = n(60614),
          a = n(54705),
          s = n(42788),
          l = n(5112),
          u = n(7871),
          c = n(83823),
          d = n(31913),
          p = n(7392),
          h = o && o.prototype,
          f = l("species"),
          m = !1,
          g = i(r.PromiseRejectionEvent),
          v = a("Promise", function () {
            var e = s(o),
              t = e !== String(o);
            if (!t && 66 === p) return !0;
            if (d && (!h.catch || !h.finally)) return !0;
            if (!p || p < 51 || !/native code/.test(e)) {
              var n = new o(function (e) {
                  e(1);
                }),
                r = function (e) {
                  e(function () {}, function () {});
                };
              if ((n.constructor = {})[f] = r, !(m = n.then(function () {}) instanceof r)) return !0;
            }
            return !t && (u || c) && !g;
          });
        e.exports = {
          CONSTRUCTOR: v,
          REJECTION_EVENT: g,
          SUBCLASSING: m
        };
      },
      2492: (e, t, n) => {
        var r = n(17854);
        e.exports = r.Promise;
      },
      69478: (e, t, n) => {
        var r = n(19670),
          o = n(70111),
          i = n(78523);
        e.exports = function (e, t) {
          if (r(e), o(t) && t.constructor === e) return t;
          var n = i.f(e);
          return (0, n.resolve)(t), n.promise;
        };
      },
      80612: (e, t, n) => {
        var r = n(2492),
          o = n(17072),
          i = n(63702).CONSTRUCTOR;
        e.exports = i || !o(function (e) {
          r.all(e).then(void 0, function () {});
        });
      },
      2626: (e, t, n) => {
        var r = n(3070).f;
        e.exports = function (e, t, n) {
          n in e || r(e, n, {
            configurable: !0,
            get: function () {
              return t[n];
            },
            set: function (e) {
              t[n] = e;
            }
          });
        };
      },
      18572: e => {
        var t = function () {
          this.head = null, this.tail = null;
        };
        t.prototype = {
          add: function (e) {
            var t = {
              item: e,
              next: null
            };
            this.head ? this.tail.next = t : this.head = t, this.tail = t;
          },
          get: function () {
            var e = this.head;
            if (e) return this.head = e.next, this.tail === e && (this.tail = null), e.item;
          }
        }, e.exports = t;
      },
      97651: (e, t, n) => {
        var r = n(46916),
          o = n(19670),
          i = n(60614),
          a = n(84326),
          s = n(22261),
          l = TypeError;
        e.exports = function (e, t) {
          var n = e.exec;
          if (i(n)) {
            var u = r(n, e, t);
            return null !== u && o(u), u;
          }
          if ("RegExp" === a(e)) return r(s, e, t);
          throw l("RegExp#exec called on incompatible receiver");
        };
      },
      22261: (e, t, n) => {
        "use strict";

        var r,
          o,
          i = n(46916),
          a = n(1702),
          s = n(41340),
          l = n(67066),
          u = n(52999),
          c = n(72309),
          d = n(70030),
          p = n(29909).get,
          h = n(9441),
          f = n(38173),
          m = c("native-string-replace", String.prototype.replace),
          g = RegExp.prototype.exec,
          v = g,
          y = a("".charAt),
          b = a("".indexOf),
          w = a("".replace),
          x = a("".slice),
          D = (o = /b*/g, i(g, r = /a/, "a"), i(g, o, "a"), 0 !== r.lastIndex || 0 !== o.lastIndex),
          C = u.BROKEN_CARET,
          S = void 0 !== /()??/.exec("")[1];
        (D || S || C || h || f) && (v = function (e) {
          var t,
            n,
            r,
            o,
            a,
            u,
            c,
            h = this,
            f = p(h),
            E = s(e),
            _ = f.raw;
          if (_) return _.lastIndex = h.lastIndex, t = i(v, _, E), h.lastIndex = _.lastIndex, t;
          var P = f.groups,
            k = C && h.sticky,
            A = i(l, h),
            z = h.source,
            T = 0,
            O = E;
          if (k && (A = w(A, "y", ""), -1 === b(A, "g") && (A += "g"), O = x(E, h.lastIndex), h.lastIndex > 0 && (!h.multiline || h.multiline && "\n" !== y(E, h.lastIndex - 1)) && (z = "(?: " + z + ")", O = " " + O, T++), n = new RegExp("^(?:" + z + ")", A)), S && (n = new RegExp("^" + z + "$(?!\\s)", A)), D && (r = h.lastIndex), o = i(g, k ? n : h, O), k ? o ? (o.input = x(o.input, T), o[0] = x(o[0], T), o.index = h.lastIndex, h.lastIndex += o[0].length) : h.lastIndex = 0 : D && o && (h.lastIndex = h.global ? o.index + o[0].length : r), S && o && o.length > 1 && i(m, o[0], n, function () {
            for (a = 1; a < arguments.length - 2; a++) void 0 === arguments[a] && (o[a] = void 0);
          }), o && P) for (o.groups = u = d(null), a = 0; a < P.length; a++) u[(c = P[a])[0]] = o[c[1]];
          return o;
        }), e.exports = v;
      },
      67066: (e, t, n) => {
        "use strict";

        var r = n(19670);
        e.exports = function () {
          var e = r(this),
            t = "";
          return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
        };
      },
      34706: (e, t, n) => {
        var r = n(46916),
          o = n(92597),
          i = n(47976),
          a = n(67066),
          s = RegExp.prototype;
        e.exports = function (e) {
          var t = e.flags;
          return void 0 !== t || "flags" in s || o(e, "flags") || !i(s, e) ? t : r(a, e);
        };
      },
      52999: (e, t, n) => {
        var r = n(47293),
          o = n(17854).RegExp,
          i = r(function () {
            var e = o("a", "y");
            return e.lastIndex = 2, null != e.exec("abcd");
          }),
          a = i || r(function () {
            return !o("a", "y").sticky;
          }),
          s = i || r(function () {
            var e = o("^r", "gy");
            return e.lastIndex = 2, null != e.exec("str");
          });
        e.exports = {
          BROKEN_CARET: s,
          MISSED_STICKY: a,
          UNSUPPORTED_Y: i
        };
      },
      9441: (e, t, n) => {
        var r = n(47293),
          o = n(17854).RegExp;
        e.exports = r(function () {
          var e = o(".", "s");
          return !(e.dotAll && e.exec("\n") && "s" === e.flags);
        });
      },
      38173: (e, t, n) => {
        var r = n(47293),
          o = n(17854).RegExp;
        e.exports = r(function () {
          var e = o("(?<a>b)", "g");
          return "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c");
        });
      },
      84488: (e, t, n) => {
        var r = n(68554),
          o = TypeError;
        e.exports = function (e) {
          if (r(e)) throw o("Can't call method on " + e);
          return e;
        };
      },
      81150: e => {
        e.exports = Object.is || function (e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
        };
      },
      17152: (e, t, n) => {
        "use strict";

        var r = n(17854),
          o = n(22104),
          i = n(60614),
          a = n(89363),
          s = n(88113),
          l = n(50206),
          u = n(48053),
          c = r.Function,
          d = /MSIE .\./.test(s) || a && function () {
            var e = r.Bun.version.split(".");
            return e.length < 3 || 0 == e[0] && (e[1] < 3 || 3 == e[1] && 0 == e[2]);
          }();
        e.exports = function (e, t) {
          var n = t ? 2 : 1;
          return d ? function (r, a) {
            var s = u(arguments.length, 1) > n,
              d = i(r) ? r : c(r),
              p = s ? l(arguments, n) : [],
              h = s ? function () {
                o(d, this, p);
              } : d;
            return t ? e(h, a) : e(h);
          } : e;
        };
      },
      96340: (e, t, n) => {
        "use strict";

        var r = n(35005),
          o = n(3070),
          i = n(5112),
          a = n(19781),
          s = i("species");
        e.exports = function (e) {
          var t = r(e),
            n = o.f;
          a && t && !t[s] && n(t, s, {
            configurable: !0,
            get: function () {
              return this;
            }
          });
        };
      },
      58003: (e, t, n) => {
        var r = n(3070).f,
          o = n(92597),
          i = n(5112)("toStringTag");
        e.exports = function (e, t, n) {
          e && !n && (e = e.prototype), e && !o(e, i) && r(e, i, {
            configurable: !0,
            value: t
          });
        };
      },
      6200: (e, t, n) => {
        var r = n(72309),
          o = n(69711),
          i = r("keys");
        e.exports = function (e) {
          return i[e] || (i[e] = o(e));
        };
      },
      5465: (e, t, n) => {
        var r = n(17854),
          o = n(13072),
          i = "__core-js_shared__",
          a = r[i] || o(i, {});
        e.exports = a;
      },
      72309: (e, t, n) => {
        var r = n(31913),
          o = n(5465);
        (e.exports = function (e, t) {
          return o[e] || (o[e] = void 0 !== t ? t : {});
        })("versions", []).push({
          version: "3.27.1",
          mode: r ? "pure" : "global",
          copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
          license: "https://github.com/zloirock/core-js/blob/v3.27.1/LICENSE",
          source: "https://github.com/zloirock/core-js"
        });
      },
      36707: (e, t, n) => {
        var r = n(19670),
          o = n(39483),
          i = n(68554),
          a = n(5112)("species");
        e.exports = function (e, t) {
          var n,
            s = r(e).constructor;
          return void 0 === s || i(n = r(s)[a]) ? t : o(n);
        };
      },
      28710: (e, t, n) => {
        var r = n(1702),
          o = n(19303),
          i = n(41340),
          a = n(84488),
          s = r("".charAt),
          l = r("".charCodeAt),
          u = r("".slice),
          c = function (e) {
            return function (t, n) {
              var r,
                c,
                d = i(a(t)),
                p = o(n),
                h = d.length;
              return p < 0 || p >= h ? e ? "" : void 0 : (r = l(d, p)) < 55296 || r > 56319 || p + 1 === h || (c = l(d, p + 1)) < 56320 || c > 57343 ? e ? s(d, p) : r : e ? u(d, p, p + 2) : c - 56320 + (r - 55296 << 10) + 65536;
            };
          };
        e.exports = {
          codeAt: c(!1),
          charAt: c(!0)
        };
      },
      33197: (e, t, n) => {
        "use strict";

        var r = n(1702),
          o = 2147483647,
          i = /[^\0-\u007E]/,
          a = /[.\u3002\uFF0E\uFF61]/g,
          s = "Overflow: input needs wider integers to process",
          l = RangeError,
          u = r(a.exec),
          c = Math.floor,
          d = String.fromCharCode,
          p = r("".charCodeAt),
          h = r([].join),
          f = r([].push),
          m = r("".replace),
          g = r("".split),
          v = r("".toLowerCase),
          y = function (e) {
            return e + 22 + 75 * (e < 26);
          },
          b = function (e, t, n) {
            var r = 0;
            for (e = n ? c(e / 700) : e >> 1, e += c(e / t); e > 455;) e = c(e / 35), r += 36;
            return c(r + 36 * e / (e + 38));
          },
          w = function (e) {
            var t = [];
            e = function (e) {
              for (var t = [], n = 0, r = e.length; n < r;) {
                var o = p(e, n++);
                if (o >= 55296 && o <= 56319 && n < r) {
                  var i = p(e, n++);
                  56320 == (64512 & i) ? f(t, ((1023 & o) << 10) + (1023 & i) + 65536) : (f(t, o), n--);
                } else f(t, o);
              }
              return t;
            }(e);
            var n,
              r,
              i = e.length,
              a = 128,
              u = 0,
              m = 72;
            for (n = 0; n < e.length; n++) (r = e[n]) < 128 && f(t, d(r));
            var g = t.length,
              v = g;
            for (g && f(t, "-"); v < i;) {
              var w = o;
              for (n = 0; n < e.length; n++) (r = e[n]) >= a && r < w && (w = r);
              var x = v + 1;
              if (w - a > c((o - u) / x)) throw l(s);
              for (u += (w - a) * x, a = w, n = 0; n < e.length; n++) {
                if ((r = e[n]) < a && ++u > o) throw l(s);
                if (r == a) {
                  for (var D = u, C = 36;;) {
                    var S = C <= m ? 1 : C >= m + 26 ? 26 : C - m;
                    if (D < S) break;
                    var E = D - S,
                      _ = 36 - S;
                    f(t, d(y(S + E % _))), D = c(E / _), C += 36;
                  }
                  f(t, d(y(D))), m = b(u, x, v == g), u = 0, v++;
                }
              }
              u++, a++;
            }
            return h(t, "");
          };
        e.exports = function (e) {
          var t,
            n,
            r = [],
            o = g(m(v(e), a, "."), ".");
          for (t = 0; t < o.length; t++) n = o[t], f(r, u(i, n) ? "xn--" + w(n) : n);
          return h(r, ".");
        };
      },
      38415: (e, t, n) => {
        "use strict";

        var r = n(19303),
          o = n(41340),
          i = n(84488),
          a = RangeError;
        e.exports = function (e) {
          var t = o(i(this)),
            n = "",
            s = r(e);
          if (s < 0 || s == 1 / 0) throw a("Wrong number of repetitions");
          for (; s > 0; (s >>>= 1) && (t += t)) 1 & s && (n += t);
          return n;
        };
      },
      10365: (e, t, n) => {
        "use strict";

        var r = n(53111).end,
          o = n(76091);
        e.exports = o("trimEnd") ? function () {
          return r(this);
        } : "".trimEnd;
      },
      76091: (e, t, n) => {
        var r = n(76530).PROPER,
          o = n(47293),
          i = n(81361);
        e.exports = function (e) {
          return o(function () {
            return !!i[e]() || "​᠎" !== "​᠎"[e]() || r && i[e].name !== e;
          });
        };
      },
      33217: (e, t, n) => {
        "use strict";

        var r = n(53111).start,
          o = n(76091);
        e.exports = o("trimStart") ? function () {
          return r(this);
        } : "".trimStart;
      },
      53111: (e, t, n) => {
        var r = n(1702),
          o = n(84488),
          i = n(41340),
          a = n(81361),
          s = r("".replace),
          l = "[" + a + "]",
          u = RegExp("^" + l + l + "*"),
          c = RegExp(l + l + "*$"),
          d = function (e) {
            return function (t) {
              var n = i(o(t));
              return 1 & e && (n = s(n, u, "")), 2 & e && (n = s(n, c, "")), n;
            };
          };
        e.exports = {
          start: d(1),
          end: d(2),
          trim: d(3)
        };
      },
      36293: (e, t, n) => {
        var r = n(7392),
          o = n(47293);
        e.exports = !!Object.getOwnPropertySymbols && !o(function () {
          var e = Symbol();
          return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && r && r < 41;
        });
      },
      20261: (e, t, n) => {
        var r,
          o,
          i,
          a,
          s = n(17854),
          l = n(22104),
          u = n(49974),
          c = n(60614),
          d = n(92597),
          p = n(47293),
          h = n(60490),
          f = n(50206),
          m = n(80317),
          g = n(48053),
          v = n(6833),
          y = n(35268),
          b = s.setImmediate,
          w = s.clearImmediate,
          x = s.process,
          D = s.Dispatch,
          C = s.Function,
          S = s.MessageChannel,
          E = s.String,
          _ = 0,
          P = {},
          k = "onreadystatechange";
        try {
          r = s.location;
        } catch (e) {}
        var A = function (e) {
            if (d(P, e)) {
              var t = P[e];
              delete P[e], t();
            }
          },
          z = function (e) {
            return function () {
              A(e);
            };
          },
          T = function (e) {
            A(e.data);
          },
          O = function (e) {
            s.postMessage(E(e), r.protocol + "//" + r.host);
          };
        b && w || (b = function (e) {
          g(arguments.length, 1);
          var t = c(e) ? e : C(e),
            n = f(arguments, 1);
          return P[++_] = function () {
            l(t, void 0, n);
          }, o(_), _;
        }, w = function (e) {
          delete P[e];
        }, y ? o = function (e) {
          x.nextTick(z(e));
        } : D && D.now ? o = function (e) {
          D.now(z(e));
        } : S && !v ? (a = (i = new S()).port2, i.port1.onmessage = T, o = u(a.postMessage, a)) : s.addEventListener && c(s.postMessage) && !s.importScripts && r && "file:" !== r.protocol && !p(O) ? (o = O, s.addEventListener("message", T, !1)) : o = k in m("script") ? function (e) {
          h.appendChild(m("script")).onreadystatechange = function () {
            h.removeChild(this), A(e);
          };
        } : function (e) {
          setTimeout(z(e), 0);
        }), e.exports = {
          set: b,
          clear: w
        };
      },
      50863: (e, t, n) => {
        var r = n(1702);
        e.exports = r(1..valueOf);
      },
      51400: (e, t, n) => {
        var r = n(19303),
          o = Math.max,
          i = Math.min;
        e.exports = function (e, t) {
          var n = r(e);
          return n < 0 ? o(n + t, 0) : i(n, t);
        };
      },
      64599: (e, t, n) => {
        var r = n(57593),
          o = TypeError;
        e.exports = function (e) {
          var t = r(e, "number");
          if ("number" == typeof t) throw o("Can't convert number to bigint");
          return BigInt(t);
        };
      },
      45656: (e, t, n) => {
        var r = n(68361),
          o = n(84488);
        e.exports = function (e) {
          return r(o(e));
        };
      },
      19303: (e, t, n) => {
        var r = n(74758);
        e.exports = function (e) {
          var t = +e;
          return t != t || 0 === t ? 0 : r(t);
        };
      },
      17466: (e, t, n) => {
        var r = n(19303),
          o = Math.min;
        e.exports = function (e) {
          return e > 0 ? o(r(e), 9007199254740991) : 0;
        };
      },
      47908: (e, t, n) => {
        var r = n(84488),
          o = Object;
        e.exports = function (e) {
          return o(r(e));
        };
      },
      84590: (e, t, n) => {
        var r = n(73002),
          o = RangeError;
        e.exports = function (e, t) {
          var n = r(e);
          if (n % t) throw o("Wrong offset");
          return n;
        };
      },
      73002: (e, t, n) => {
        var r = n(19303),
          o = RangeError;
        e.exports = function (e) {
          var t = r(e);
          if (t < 0) throw o("The argument can't be less than 0");
          return t;
        };
      },
      57593: (e, t, n) => {
        var r = n(46916),
          o = n(70111),
          i = n(52190),
          a = n(58173),
          s = n(92140),
          l = n(5112),
          u = TypeError,
          c = l("toPrimitive");
        e.exports = function (e, t) {
          if (!o(e) || i(e)) return e;
          var n,
            l = a(e, c);
          if (l) {
            if (void 0 === t && (t = "default"), n = r(l, e, t), !o(n) || i(n)) return n;
            throw u("Can't convert object to primitive value");
          }
          return void 0 === t && (t = "number"), s(e, t);
        };
      },
      34948: (e, t, n) => {
        var r = n(57593),
          o = n(52190);
        e.exports = function (e) {
          var t = r(e, "string");
          return o(t) ? t : t + "";
        };
      },
      51694: (e, t, n) => {
        var r = {};
        r[n(5112)("toStringTag")] = "z", e.exports = "[object z]" === String(r);
      },
      41340: (e, t, n) => {
        var r = n(70648),
          o = String;
        e.exports = function (e) {
          if ("Symbol" === r(e)) throw TypeError("Cannot convert a Symbol value to a string");
          return o(e);
        };
      },
      66330: e => {
        var t = String;
        e.exports = function (e) {
          try {
            return t(e);
          } catch (e) {
            return "Object";
          }
        };
      },
      69711: (e, t, n) => {
        var r = n(1702),
          o = 0,
          i = Math.random(),
          a = r(1..toString);
        e.exports = function (e) {
          return "Symbol(" + (void 0 === e ? "" : e) + ")_" + a(++o + i, 36);
        };
      },
      85143: (e, t, n) => {
        var r = n(47293),
          o = n(5112),
          i = n(31913),
          a = o("iterator");
        e.exports = !r(function () {
          var e = new URL("b?a=1&b=2&c=3", "http://a"),
            t = e.searchParams,
            n = "";
          return e.pathname = "c%20d", t.forEach(function (e, r) {
            t.delete("b"), n += r + e;
          }), i && !e.toJSON || !t.sort || "http://a/c%20d?a=1&c=3" !== e.href || "3" !== t.get("c") || "a=1" !== String(new URLSearchParams("?a=1")) || !t[a] || "a" !== new URL("https://a@b").username || "b" !== new URLSearchParams(new URLSearchParams("a=b")).get("a") || "xn--e1aybc" !== new URL("http://тест").host || "#%D0%B1" !== new URL("http://a#б").hash || "a1c3" !== n || "x" !== new URL("http://x", void 0).host;
        });
      },
      43307: (e, t, n) => {
        var r = n(36293);
        e.exports = r && !Symbol.sham && "symbol" == typeof Symbol.iterator;
      },
      3353: (e, t, n) => {
        var r = n(19781),
          o = n(47293);
        e.exports = r && o(function () {
          return 42 != Object.defineProperty(function () {}, "prototype", {
            value: 42,
            writable: !1
          }).prototype;
        });
      },
      48053: e => {
        var t = TypeError;
        e.exports = function (e, n) {
          if (e < n) throw t("Not enough arguments");
          return e;
        };
      },
      94811: (e, t, n) => {
        var r = n(17854),
          o = n(60614),
          i = r.WeakMap;
        e.exports = o(i) && /native code/.test(String(i));
      },
      26800: (e, t, n) => {
        var r = n(40857),
          o = n(92597),
          i = n(6061),
          a = n(3070).f;
        e.exports = function (e) {
          var t = r.Symbol || (r.Symbol = {});
          o(t, e) || a(t, e, {
            value: i.f(e)
          });
        };
      },
      6061: (e, t, n) => {
        var r = n(5112);
        t.f = r;
      },
      5112: (e, t, n) => {
        var r = n(17854),
          o = n(72309),
          i = n(92597),
          a = n(69711),
          s = n(36293),
          l = n(43307),
          u = o("wks"),
          c = r.Symbol,
          d = c && c.for,
          p = l ? c : c && c.withoutSetter || a;
        e.exports = function (e) {
          if (!i(u, e) || !s && "string" != typeof u[e]) {
            var t = "Symbol." + e;
            s && i(c, e) ? u[e] = c[e] : u[e] = l && d ? d(t) : p(t);
          }
          return u[e];
        };
      },
      81361: e => {
        e.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff";
      },
      86535: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(6790),
          i = n(19662),
          a = n(47908),
          s = n(26244),
          l = n(65417);
        r({
          target: "Array",
          proto: !0
        }, {
          flatMap: function (e) {
            var t,
              n = a(this),
              r = s(n);
            return i(e), (t = l(n, 0)).length = o(t, n, n, r, 0, 1, e, arguments.length > 1 ? arguments[1] : void 0), t;
          }
        });
      },
      84944: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(6790),
          i = n(47908),
          a = n(26244),
          s = n(19303),
          l = n(65417);
        r({
          target: "Array",
          proto: !0
        }, {
          flat: function () {
            var e = arguments.length ? arguments[0] : void 0,
              t = i(this),
              n = a(t),
              r = l(t, 0);
            return r.length = o(r, t, t, n, 0, void 0 === e ? 1 : s(e)), r;
          }
        });
      },
      66992: (e, t, n) => {
        "use strict";

        var r = n(45656),
          o = n(51223),
          i = n(97497),
          a = n(29909),
          s = n(3070).f,
          l = n(51656),
          u = n(76178),
          c = n(31913),
          d = n(19781),
          p = "Array Iterator",
          h = a.set,
          f = a.getterFor(p);
        e.exports = l(Array, "Array", function (e, t) {
          h(this, {
            type: p,
            target: r(e),
            index: 0,
            kind: t
          });
        }, function () {
          var e = f(this),
            t = e.target,
            n = e.kind,
            r = e.index++;
          return !t || r >= t.length ? (e.target = void 0, u(void 0, !0)) : u("keys" == n ? r : "values" == n ? t[r] : [r, t[r]], !1);
        }, "values");
        var m = i.Arguments = i.Array;
        if (o("keys"), o("values"), o("entries"), !c && d && "values" !== m.name) try {
          s(m, "name", {
            value: "values"
          });
        } catch (e) {}
      },
      2707: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(1702),
          i = n(19662),
          a = n(47908),
          s = n(26244),
          l = n(85117),
          u = n(41340),
          c = n(47293),
          d = n(94362),
          p = n(9341),
          h = n(68886),
          f = n(30256),
          m = n(7392),
          g = n(98008),
          v = [],
          y = o(v.sort),
          b = o(v.push),
          w = c(function () {
            v.sort(void 0);
          }),
          x = c(function () {
            v.sort(null);
          }),
          D = p("sort"),
          C = !c(function () {
            if (m) return m < 70;
            if (!(h && h > 3)) {
              if (f) return !0;
              if (g) return g < 603;
              var e,
                t,
                n,
                r,
                o = "";
              for (e = 65; e < 76; e++) {
                switch (t = String.fromCharCode(e), e) {
                  case 66:
                  case 69:
                  case 70:
                  case 72:
                    n = 3;
                    break;
                  case 68:
                  case 71:
                    n = 4;
                    break;
                  default:
                    n = 2;
                }
                for (r = 0; r < 47; r++) v.push({
                  k: t + r,
                  v: n
                });
              }
              for (v.sort(function (e, t) {
                return t.v - e.v;
              }), r = 0; r < v.length; r++) t = v[r].k.charAt(0), o.charAt(o.length - 1) !== t && (o += t);
              return "DGBEFHACIJK" !== o;
            }
          });
        r({
          target: "Array",
          proto: !0,
          forced: w || !x || !D || !C
        }, {
          sort: function (e) {
            void 0 !== e && i(e);
            var t = a(this);
            if (C) return void 0 === e ? y(t) : y(t, e);
            var n,
              r,
              o = [],
              c = s(t);
            for (r = 0; r < c; r++) r in t && b(o, t[r]);
            for (d(o, function (e) {
              return function (t, n) {
                return void 0 === n ? -1 : void 0 === t ? 1 : void 0 !== e ? +e(t, n) || 0 : u(t) > u(n) ? 1 : -1;
              };
            }(e)), n = s(o), r = 0; r < n;) t[r] = o[r++];
            for (; r < c;) l(t, r++);
            return t;
          }
        });
      },
      99244: (e, t, n) => {
        n(51223)("flatMap");
      },
      33792: (e, t, n) => {
        n(51223)("flat");
      },
      61874: (e, t, n) => {
        var r = n(82109),
          o = n(2814);
        r({
          target: "Number",
          stat: !0,
          forced: Number.parseFloat != o
        }, {
          parseFloat: o
        });
      },
      9494: (e, t, n) => {
        var r = n(82109),
          o = n(83009);
        r({
          target: "Number",
          stat: !0,
          forced: Number.parseInt != o
        }, {
          parseInt: o
        });
      },
      56977: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(1702),
          i = n(19303),
          a = n(50863),
          s = n(38415),
          l = n(47293),
          u = RangeError,
          c = String,
          d = Math.floor,
          p = o(s),
          h = o("".slice),
          f = o(1..toFixed),
          m = function (e, t, n) {
            return 0 === t ? n : t % 2 == 1 ? m(e, t - 1, n * e) : m(e * e, t / 2, n);
          },
          g = function (e, t, n) {
            for (var r = -1, o = n; ++r < 6;) o += t * e[r], e[r] = o % 1e7, o = d(o / 1e7);
          },
          v = function (e, t) {
            for (var n = 6, r = 0; --n >= 0;) r += e[n], e[n] = d(r / t), r = r % t * 1e7;
          },
          y = function (e) {
            for (var t = 6, n = ""; --t >= 0;) if ("" !== n || 0 === t || 0 !== e[t]) {
              var r = c(e[t]);
              n = "" === n ? r : n + p("0", 7 - r.length) + r;
            }
            return n;
          };
        r({
          target: "Number",
          proto: !0,
          forced: l(function () {
            return "0.000" !== f(8e-5, 3) || "1" !== f(.9, 0) || "1.25" !== f(1.255, 2) || "1000000000000000128" !== f(0xde0b6b3a7640080, 0);
          }) || !l(function () {
            f({});
          })
        }, {
          toFixed: function (e) {
            var t,
              n,
              r,
              o,
              s = a(this),
              l = i(e),
              d = [0, 0, 0, 0, 0, 0],
              f = "",
              b = "0";
            if (l < 0 || l > 20) throw u("Incorrect fraction digits");
            if (s != s) return "NaN";
            if (s <= -1e21 || s >= 1e21) return c(s);
            if (s < 0 && (f = "-", s = -s), s > 1e-21) if (n = (t = function (e) {
              for (var t = 0, n = e; n >= 4096;) t += 12, n /= 4096;
              for (; n >= 2;) t += 1, n /= 2;
              return t;
            }(s * m(2, 69, 1)) - 69) < 0 ? s * m(2, -t, 1) : s / m(2, t, 1), n *= 4503599627370496, (t = 52 - t) > 0) {
              for (g(d, 0, n), r = l; r >= 7;) g(d, 1e7, 0), r -= 7;
              for (g(d, m(10, r, 1), 0), r = t - 1; r >= 23;) v(d, 1 << 23), r -= 23;
              v(d, 1 << r), g(d, 1, 1), v(d, 2), b = y(d);
            } else g(d, 0, n), g(d, 1 << -t, 0), b = y(d) + p("0", l);
            return b = l > 0 ? f + ((o = b.length) <= l ? "0." + p("0", l - o) + b : h(b, 0, o - l) + "." + h(b, o - l)) : f + b;
          }
        });
      },
      19601: (e, t, n) => {
        var r = n(82109),
          o = n(21574);
        r({
          target: "Object",
          stat: !0,
          arity: 2,
          forced: Object.assign !== o
        }, {
          assign: o
        });
      },
      38559: (e, t, n) => {
        var r = n(82109),
          o = n(20408),
          i = n(86135);
        r({
          target: "Object",
          stat: !0
        }, {
          fromEntries: function (e) {
            var t = {};
            return o(e, function (e, n) {
              i(t, e, n);
            }, {
              AS_ENTRIES: !0
            }), t;
          }
        });
      },
      54678: (e, t, n) => {
        var r = n(82109),
          o = n(2814);
        r({
          global: !0,
          forced: parseFloat != o
        }, {
          parseFloat: o
        });
      },
      91058: (e, t, n) => {
        var r = n(82109),
          o = n(83009);
        r({
          global: !0,
          forced: parseInt != o
        }, {
          parseInt: o
        });
      },
      70821: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(46916),
          i = n(19662),
          a = n(78523),
          s = n(12534),
          l = n(20408);
        r({
          target: "Promise",
          stat: !0,
          forced: n(80612)
        }, {
          all: function (e) {
            var t = this,
              n = a.f(t),
              r = n.resolve,
              u = n.reject,
              c = s(function () {
                var n = i(t.resolve),
                  a = [],
                  s = 0,
                  c = 1;
                l(e, function (e) {
                  var i = s++,
                    l = !1;
                  c++, o(n, t, e).then(function (e) {
                    l || (l = !0, a[i] = e, --c || r(a));
                  }, u);
                }), --c || r(a);
              });
            return c.error && u(c.value), n.promise;
          }
        });
      },
      94164: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(31913),
          i = n(63702).CONSTRUCTOR,
          a = n(2492),
          s = n(35005),
          l = n(60614),
          u = n(98052),
          c = a && a.prototype;
        if (r({
          target: "Promise",
          proto: !0,
          forced: i,
          real: !0
        }, {
          catch: function (e) {
            return this.then(void 0, e);
          }
        }), !o && l(a)) {
          var d = s("Promise").prototype.catch;
          c.catch !== d && u(c, "catch", d, {
            unsafe: !0
          });
        }
      },
      43401: (e, t, n) => {
        "use strict";

        var r,
          o,
          i,
          a = n(82109),
          s = n(31913),
          l = n(35268),
          u = n(17854),
          c = n(46916),
          d = n(98052),
          p = n(27674),
          h = n(58003),
          f = n(96340),
          m = n(19662),
          g = n(60614),
          v = n(70111),
          y = n(25787),
          b = n(36707),
          w = n(20261).set,
          x = n(95948),
          D = n(842),
          C = n(12534),
          S = n(18572),
          E = n(29909),
          _ = n(2492),
          P = n(63702),
          k = n(78523),
          A = "Promise",
          z = P.CONSTRUCTOR,
          T = P.REJECTION_EVENT,
          O = P.SUBCLASSING,
          I = E.getterFor(A),
          F = E.set,
          M = _ && _.prototype,
          R = _,
          j = M,
          B = u.TypeError,
          N = u.document,
          L = u.process,
          V = k.f,
          K = V,
          q = !!(N && N.createEvent && u.dispatchEvent),
          H = "unhandledrejection",
          U = function (e) {
            var t;
            return !(!v(e) || !g(t = e.then)) && t;
          },
          Z = function (e, t) {
            var n,
              r,
              o,
              i = t.value,
              a = 1 == t.state,
              s = a ? e.ok : e.fail,
              l = e.resolve,
              u = e.reject,
              d = e.domain;
            try {
              s ? (a || (2 === t.rejection && X(t), t.rejection = 1), !0 === s ? n = i : (d && d.enter(), n = s(i), d && (d.exit(), o = !0)), n === e.promise ? u(B("Promise-chain cycle")) : (r = U(n)) ? c(r, n, l, u) : l(n)) : u(i);
            } catch (e) {
              d && !o && d.exit(), u(e);
            }
          },
          $ = function (e, t) {
            e.notified || (e.notified = !0, x(function () {
              for (var n, r = e.reactions; n = r.get();) Z(n, e);
              e.notified = !1, t && !e.rejection && W(e);
            }));
          },
          G = function (e, t, n) {
            var r, o;
            q ? ((r = N.createEvent("Event")).promise = t, r.reason = n, r.initEvent(e, !1, !0), u.dispatchEvent(r)) : r = {
              promise: t,
              reason: n
            }, !T && (o = u["on" + e]) ? o(r) : e === H && D("Unhandled promise rejection", n);
          },
          W = function (e) {
            c(w, u, function () {
              var t,
                n = e.facade,
                r = e.value;
              if (Y(e) && (t = C(function () {
                l ? L.emit("unhandledRejection", r, n) : G(H, n, r);
              }), e.rejection = l || Y(e) ? 2 : 1, t.error)) throw t.value;
            });
          },
          Y = function (e) {
            return 1 !== e.rejection && !e.parent;
          },
          X = function (e) {
            c(w, u, function () {
              var t = e.facade;
              l ? L.emit("rejectionHandled", t) : G("rejectionhandled", t, e.value);
            });
          },
          Q = function (e, t, n) {
            return function (r) {
              e(t, r, n);
            };
          },
          J = function (e, t, n) {
            e.done || (e.done = !0, n && (e = n), e.value = t, e.state = 2, $(e, !0));
          },
          ee = function (e, t, n) {
            if (!e.done) {
              e.done = !0, n && (e = n);
              try {
                if (e.facade === t) throw B("Promise can't be resolved itself");
                var r = U(t);
                r ? x(function () {
                  var n = {
                    done: !1
                  };
                  try {
                    c(r, t, Q(ee, n, e), Q(J, n, e));
                  } catch (t) {
                    J(n, t, e);
                  }
                }) : (e.value = t, e.state = 1, $(e, !1));
              } catch (t) {
                J({
                  done: !1
                }, t, e);
              }
            }
          };
        if (z && (j = (R = function (e) {
          y(this, j), m(e), c(r, this);
          var t = I(this);
          try {
            e(Q(ee, t), Q(J, t));
          } catch (e) {
            J(t, e);
          }
        }).prototype, (r = function (e) {
          F(this, {
            type: A,
            done: !1,
            notified: !1,
            parent: !1,
            reactions: new S(),
            rejection: !1,
            state: 0,
            value: void 0
          });
        }).prototype = d(j, "then", function (e, t) {
          var n = I(this),
            r = V(b(this, R));
          return n.parent = !0, r.ok = !g(e) || e, r.fail = g(t) && t, r.domain = l ? L.domain : void 0, 0 == n.state ? n.reactions.add(r) : x(function () {
            Z(r, n);
          }), r.promise;
        }), o = function () {
          var e = new r(),
            t = I(e);
          this.promise = e, this.resolve = Q(ee, t), this.reject = Q(J, t);
        }, k.f = V = function (e) {
          return e === R || undefined === e ? new o(e) : K(e);
        }, !s && g(_) && M !== Object.prototype)) {
          i = M.then, O || d(M, "then", function (e, t) {
            var n = this;
            return new R(function (e, t) {
              c(i, n, e, t);
            }).then(e, t);
          }, {
            unsafe: !0
          });
          try {
            delete M.constructor;
          } catch (e) {}
          p && p(M, j);
        }
        a({
          global: !0,
          constructor: !0,
          wrap: !0,
          forced: z
        }, {
          Promise: R
        }), h(R, A, !1, !0), f(A);
      },
      17727: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(31913),
          i = n(2492),
          a = n(47293),
          s = n(35005),
          l = n(60614),
          u = n(36707),
          c = n(69478),
          d = n(98052),
          p = i && i.prototype;
        if (r({
          target: "Promise",
          proto: !0,
          real: !0,
          forced: !!i && a(function () {
            p.finally.call({
              then: function () {}
            }, function () {});
          })
        }, {
          finally: function (e) {
            var t = u(this, s("Promise")),
              n = l(e);
            return this.then(n ? function (n) {
              return c(t, e()).then(function () {
                return n;
              });
            } : e, n ? function (n) {
              return c(t, e()).then(function () {
                throw n;
              });
            } : e);
          }
        }), !o && l(i)) {
          var h = s("Promise").prototype.finally;
          p.finally !== h && d(p, "finally", h, {
            unsafe: !0
          });
        }
      },
      88674: (e, t, n) => {
        n(43401), n(70821), n(94164), n(6027), n(60683), n(96294);
      },
      6027: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(46916),
          i = n(19662),
          a = n(78523),
          s = n(12534),
          l = n(20408);
        r({
          target: "Promise",
          stat: !0,
          forced: n(80612)
        }, {
          race: function (e) {
            var t = this,
              n = a.f(t),
              r = n.reject,
              u = s(function () {
                var a = i(t.resolve);
                l(e, function (e) {
                  o(a, t, e).then(n.resolve, r);
                });
              });
            return u.error && r(u.value), n.promise;
          }
        });
      },
      60683: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(46916),
          i = n(78523);
        r({
          target: "Promise",
          stat: !0,
          forced: n(63702).CONSTRUCTOR
        }, {
          reject: function (e) {
            var t = i.f(this);
            return o(t.reject, void 0, e), t.promise;
          }
        });
      },
      96294: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(35005),
          i = n(31913),
          a = n(2492),
          s = n(63702).CONSTRUCTOR,
          l = n(69478),
          u = o("Promise"),
          c = i && !s;
        r({
          target: "Promise",
          stat: !0,
          forced: i || s
        }, {
          resolve: function (e) {
            return l(c && this === u ? a : this, e);
          }
        });
      },
      83593: (e, t, n) => {
        var r = n(82109),
          o = n(46916),
          i = n(19670),
          a = n(70111),
          s = n(45032),
          l = n(47293),
          u = n(3070),
          c = n(31236),
          d = n(79518),
          p = n(79114);
        r({
          target: "Reflect",
          stat: !0,
          forced: l(function () {
            var e = function () {},
              t = u.f(new e(), "a", {
                configurable: !0
              });
            return !1 !== Reflect.set(e.prototype, "a", 1, t);
          })
        }, {
          set: function e(t, n, r) {
            var l,
              h,
              f,
              m = arguments.length < 4 ? t : arguments[3],
              g = c.f(i(t), n);
            if (!g) {
              if (a(h = d(t))) return e(h, n, r, m);
              g = p(0);
            }
            if (s(g)) {
              if (!1 === g.writable || !a(m)) return !1;
              if (l = c.f(m, n)) {
                if (l.get || l.set || !1 === l.writable) return !1;
                l.value = r, u.f(m, n, l);
              } else u.f(m, n, p(0, r));
            } else {
              if (void 0 === (f = g.set)) return !1;
              o(f, m, r);
            }
            return !0;
          }
        });
      },
      24603: (e, t, n) => {
        var r = n(19781),
          o = n(17854),
          i = n(1702),
          a = n(54705),
          s = n(79587),
          l = n(68880),
          u = n(8006).f,
          c = n(47976),
          d = n(47850),
          p = n(41340),
          h = n(34706),
          f = n(52999),
          m = n(2626),
          g = n(98052),
          v = n(47293),
          y = n(92597),
          b = n(29909).enforce,
          w = n(96340),
          x = n(5112),
          D = n(9441),
          C = n(38173),
          S = x("match"),
          E = o.RegExp,
          _ = E.prototype,
          P = o.SyntaxError,
          k = i(_.exec),
          A = i("".charAt),
          z = i("".replace),
          T = i("".indexOf),
          O = i("".slice),
          I = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/,
          F = /a/g,
          M = /a/g,
          R = new E(F) !== F,
          j = f.MISSED_STICKY,
          B = f.UNSUPPORTED_Y,
          N = r && (!R || j || D || C || v(function () {
            return M[S] = !1, E(F) != F || E(M) == M || "/a/i" != E(F, "i");
          }));
        if (a("RegExp", N)) {
          for (var L = function (e, t) {
              var n,
                r,
                o,
                i,
                a,
                u,
                f = c(_, this),
                m = d(e),
                g = void 0 === t,
                v = [],
                w = e;
              if (!f && m && g && e.constructor === L) return e;
              if ((m || c(_, e)) && (e = e.source, g && (t = h(w))), e = void 0 === e ? "" : p(e), t = void 0 === t ? "" : p(t), w = e, D && "dotAll" in F && (r = !!t && T(t, "s") > -1) && (t = z(t, /s/g, "")), n = t, j && "sticky" in F && (o = !!t && T(t, "y") > -1) && B && (t = z(t, /y/g, "")), C && (i = function (e) {
                for (var t, n = e.length, r = 0, o = "", i = [], a = {}, s = !1, l = !1, u = 0, c = ""; r <= n; r++) {
                  if ("\\" === (t = A(e, r))) t += A(e, ++r);else if ("]" === t) s = !1;else if (!s) switch (!0) {
                    case "[" === t:
                      s = !0;
                      break;
                    case "(" === t:
                      k(I, O(e, r + 1)) && (r += 2, l = !0), o += t, u++;
                      continue;
                    case ">" === t && l:
                      if ("" === c || y(a, c)) throw new P("Invalid capture group name");
                      a[c] = !0, i[i.length] = [c, u], l = !1, c = "";
                      continue;
                  }
                  l ? c += t : o += t;
                }
                return [o, i];
              }(e), e = i[0], v = i[1]), a = s(E(e, t), f ? this : _, L), (r || o || v.length) && (u = b(a), r && (u.dotAll = !0, u.raw = L(function (e) {
                for (var t, n = e.length, r = 0, o = "", i = !1; r <= n; r++) "\\" !== (t = A(e, r)) ? i || "." !== t ? ("[" === t ? i = !0 : "]" === t && (i = !1), o += t) : o += "[\\s\\S]" : o += t + A(e, ++r);
                return o;
              }(e), n)), o && (u.sticky = !0), v.length && (u.groups = v)), e !== w) try {
                l(a, "source", "" === w ? "(?:)" : w);
              } catch (e) {}
              return a;
            }, V = u(E), K = 0; V.length > K;) m(L, E, V[K++]);
          _.constructor = L, L.prototype = _, g(o, "RegExp", L, {
            constructor: !0
          });
        }
        w("RegExp");
      },
      74916: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(22261);
        r({
          target: "RegExp",
          proto: !0,
          forced: /./.exec !== o
        }, {
          exec: o
        });
      },
      92087: (e, t, n) => {
        var r = n(17854),
          o = n(19781),
          i = n(47045),
          a = n(67066),
          s = n(47293),
          l = r.RegExp,
          u = l.prototype;
        o && s(function () {
          var e = !0;
          try {
            l(".", "d");
          } catch (t) {
            e = !1;
          }
          var t = {},
            n = "",
            r = e ? "dgimsy" : "gimsy",
            o = function (e, r) {
              Object.defineProperty(t, e, {
                get: function () {
                  return n += r, !0;
                }
              });
            },
            i = {
              dotAll: "s",
              global: "g",
              ignoreCase: "i",
              multiline: "m",
              sticky: "y"
            };
          for (var a in e && (i.hasIndices = "d"), i) o(a, i[a]);
          return Object.getOwnPropertyDescriptor(u, "flags").get.call(t) !== r || n !== r;
        }) && i(u, "flags", {
          configurable: !0,
          get: a
        });
      },
      39714: (e, t, n) => {
        "use strict";

        var r = n(76530).PROPER,
          o = n(98052),
          i = n(19670),
          a = n(41340),
          s = n(47293),
          l = n(34706),
          u = "toString",
          c = RegExp.prototype.toString,
          d = s(function () {
            return "/a/b" != c.call({
              source: "a",
              flags: "b"
            });
          }),
          p = r && c.name != u;
        (d || p) && o(RegExp.prototype, u, function () {
          var e = i(this);
          return "/" + a(e.source) + "/" + a(l(e));
        }, {
          unsafe: !0
        });
      },
      27852: (e, t, n) => {
        "use strict";

        var r,
          o = n(82109),
          i = n(21470),
          a = n(31236).f,
          s = n(17466),
          l = n(41340),
          u = n(3929),
          c = n(84488),
          d = n(84964),
          p = n(31913),
          h = i("".endsWith),
          f = i("".slice),
          m = Math.min,
          g = d("endsWith");
        o({
          target: "String",
          proto: !0,
          forced: !!(p || g || (r = a(String.prototype, "endsWith"), !r || r.writable)) && !g
        }, {
          endsWith: function (e) {
            var t = l(c(this));
            u(e);
            var n = arguments.length > 1 ? arguments[1] : void 0,
              r = t.length,
              o = void 0 === n ? r : m(s(n), r),
              i = l(e);
            return h ? h(t, i, o) : f(t, o - i.length, o) === i;
          }
        });
      },
      32023: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(1702),
          i = n(3929),
          a = n(84488),
          s = n(41340),
          l = n(84964),
          u = o("".indexOf);
        r({
          target: "String",
          proto: !0,
          forced: !l("includes")
        }, {
          includes: function (e) {
            return !!~u(s(a(this)), s(i(e)), arguments.length > 1 ? arguments[1] : void 0);
          }
        });
      },
      78783: (e, t, n) => {
        "use strict";

        var r = n(28710).charAt,
          o = n(41340),
          i = n(29909),
          a = n(51656),
          s = n(76178),
          l = "String Iterator",
          u = i.set,
          c = i.getterFor(l);
        a(String, "String", function (e) {
          u(this, {
            type: l,
            string: o(e),
            index: 0
          });
        }, function () {
          var e,
            t = c(this),
            n = t.string,
            o = t.index;
          return o >= n.length ? s(void 0, !0) : (e = r(n, o), t.index += e.length, s(e, !1));
        });
      },
      4723: (e, t, n) => {
        "use strict";

        var r = n(46916),
          o = n(27007),
          i = n(19670),
          a = n(68554),
          s = n(17466),
          l = n(41340),
          u = n(84488),
          c = n(58173),
          d = n(31530),
          p = n(97651);
        o("match", function (e, t, n) {
          return [function (t) {
            var n = u(this),
              o = a(t) ? void 0 : c(t, e);
            return o ? r(o, t, n) : new RegExp(t)[e](l(n));
          }, function (e) {
            var r = i(this),
              o = l(e),
              a = n(t, r, o);
            if (a.done) return a.value;
            if (!r.global) return p(r, o);
            var u = r.unicode;
            r.lastIndex = 0;
            for (var c, h = [], f = 0; null !== (c = p(r, o));) {
              var m = l(c[0]);
              h[f] = m, "" === m && (r.lastIndex = d(o, s(r.lastIndex), u)), f++;
            }
            return 0 === f ? null : h;
          }];
        });
      },
      15306: (e, t, n) => {
        "use strict";

        var r = n(22104),
          o = n(46916),
          i = n(1702),
          a = n(27007),
          s = n(47293),
          l = n(19670),
          u = n(60614),
          c = n(68554),
          d = n(19303),
          p = n(17466),
          h = n(41340),
          f = n(84488),
          m = n(31530),
          g = n(58173),
          v = n(10647),
          y = n(97651),
          b = n(5112)("replace"),
          w = Math.max,
          x = Math.min,
          D = i([].concat),
          C = i([].push),
          S = i("".indexOf),
          E = i("".slice),
          _ = "$0" === "a".replace(/./, "$0"),
          P = !!/./[b] && "" === /./[b]("a", "$0");
        a("replace", function (e, t, n) {
          var i = P ? "$" : "$0";
          return [function (e, n) {
            var r = f(this),
              i = c(e) ? void 0 : g(e, b);
            return i ? o(i, e, r, n) : o(t, h(r), e, n);
          }, function (e, o) {
            var a = l(this),
              s = h(e);
            if ("string" == typeof o && -1 === S(o, i) && -1 === S(o, "$<")) {
              var c = n(t, a, s, o);
              if (c.done) return c.value;
            }
            var f = u(o);
            f || (o = h(o));
            var g = a.global;
            if (g) {
              var b = a.unicode;
              a.lastIndex = 0;
            }
            for (var _ = [];;) {
              var P = y(a, s);
              if (null === P) break;
              if (C(_, P), !g) break;
              "" === h(P[0]) && (a.lastIndex = m(s, p(a.lastIndex), b));
            }
            for (var k, A = "", z = 0, T = 0; T < _.length; T++) {
              for (var O = h((P = _[T])[0]), I = w(x(d(P.index), s.length), 0), F = [], M = 1; M < P.length; M++) C(F, void 0 === (k = P[M]) ? k : String(k));
              var R = P.groups;
              if (f) {
                var j = D([O], F, I, s);
                void 0 !== R && C(j, R);
                var B = h(r(o, void 0, j));
              } else B = v(O, s, I, F, R, o);
              I >= z && (A += E(s, z, I) + B, z = I + O.length);
            }
            return A + E(s, z);
          }];
        }, !!s(function () {
          var e = /./;
          return e.exec = function () {
            var e = [];
            return e.groups = {
              a: "7"
            }, e;
          }, "7" !== "".replace(e, "$<a>");
        }) || !_ || P);
      },
      64765: (e, t, n) => {
        "use strict";

        var r = n(46916),
          o = n(27007),
          i = n(19670),
          a = n(68554),
          s = n(84488),
          l = n(81150),
          u = n(41340),
          c = n(58173),
          d = n(97651);
        o("search", function (e, t, n) {
          return [function (t) {
            var n = s(this),
              o = a(t) ? void 0 : c(t, e);
            return o ? r(o, t, n) : new RegExp(t)[e](u(n));
          }, function (e) {
            var r = i(this),
              o = u(e),
              a = n(t, r, o);
            if (a.done) return a.value;
            var s = r.lastIndex;
            l(s, 0) || (r.lastIndex = 0);
            var c = d(r, o);
            return l(r.lastIndex, s) || (r.lastIndex = s), null === c ? -1 : c.index;
          }];
        });
      },
      23123: (e, t, n) => {
        "use strict";

        var r = n(22104),
          o = n(46916),
          i = n(1702),
          a = n(27007),
          s = n(19670),
          l = n(68554),
          u = n(47850),
          c = n(84488),
          d = n(36707),
          p = n(31530),
          h = n(17466),
          f = n(41340),
          m = n(58173),
          g = n(41589),
          v = n(97651),
          y = n(22261),
          b = n(52999),
          w = n(47293),
          x = b.UNSUPPORTED_Y,
          D = 4294967295,
          C = Math.min,
          S = [].push,
          E = i(/./.exec),
          _ = i(S),
          P = i("".slice);
        a("split", function (e, t, n) {
          var i;
          return i = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (e, n) {
            var i = f(c(this)),
              a = void 0 === n ? D : n >>> 0;
            if (0 === a) return [];
            if (void 0 === e) return [i];
            if (!u(e)) return o(t, i, e, a);
            for (var s, l, d, p = [], h = (e.ignoreCase ? "i" : "") + (e.multiline ? "m" : "") + (e.unicode ? "u" : "") + (e.sticky ? "y" : ""), m = 0, v = new RegExp(e.source, h + "g"); (s = o(y, v, i)) && !((l = v.lastIndex) > m && (_(p, P(i, m, s.index)), s.length > 1 && s.index < i.length && r(S, p, g(s, 1)), d = s[0].length, m = l, p.length >= a));) v.lastIndex === s.index && v.lastIndex++;
            return m === i.length ? !d && E(v, "") || _(p, "") : _(p, P(i, m)), p.length > a ? g(p, 0, a) : p;
          } : "0".split(void 0, 0).length ? function (e, n) {
            return void 0 === e && 0 === n ? [] : o(t, this, e, n);
          } : t, [function (t, n) {
            var r = c(this),
              a = l(t) ? void 0 : m(t, e);
            return a ? o(a, t, r, n) : o(i, f(r), t, n);
          }, function (e, r) {
            var o = s(this),
              a = f(e),
              l = n(i, o, a, r, i !== t);
            if (l.done) return l.value;
            var u = d(o, RegExp),
              c = o.unicode,
              m = (o.ignoreCase ? "i" : "") + (o.multiline ? "m" : "") + (o.unicode ? "u" : "") + (x ? "g" : "y"),
              g = new u(x ? "^(?:" + o.source + ")" : o, m),
              y = void 0 === r ? D : r >>> 0;
            if (0 === y) return [];
            if (0 === a.length) return null === v(g, a) ? [a] : [];
            for (var b = 0, w = 0, S = []; w < a.length;) {
              g.lastIndex = x ? 0 : w;
              var E,
                k = v(g, x ? P(a, w) : a);
              if (null === k || (E = C(h(g.lastIndex + (x ? w : 0)), a.length)) === b) w = p(a, w, c);else {
                if (_(S, P(a, b, w)), S.length === y) return S;
                for (var A = 1; A <= k.length - 1; A++) if (_(S, k[A]), S.length === y) return S;
                w = b = E;
              }
            }
            return _(S, P(a, b)), S;
          }];
        }, !!w(function () {
          var e = /(?:)/,
            t = e.exec;
          e.exec = function () {
            return t.apply(this, arguments);
          };
          var n = "ab".split(e);
          return 2 !== n.length || "a" !== n[0] || "b" !== n[1];
        }), x);
      },
      23157: (e, t, n) => {
        "use strict";

        var r,
          o = n(82109),
          i = n(21470),
          a = n(31236).f,
          s = n(17466),
          l = n(41340),
          u = n(3929),
          c = n(84488),
          d = n(84964),
          p = n(31913),
          h = i("".startsWith),
          f = i("".slice),
          m = Math.min,
          g = d("startsWith");
        o({
          target: "String",
          proto: !0,
          forced: !!(p || g || (r = a(String.prototype, "startsWith"), !r || r.writable)) && !g
        }, {
          startsWith: function (e) {
            var t = l(c(this));
            u(e);
            var n = s(m(arguments.length > 1 ? arguments[1] : void 0, t.length)),
              r = l(e);
            return h ? h(t, r, n) : f(t, n, n + r.length) === r;
          }
        });
      },
      48702: (e, t, n) => {
        n(83462);
        var r = n(82109),
          o = n(10365);
        r({
          target: "String",
          proto: !0,
          name: "trimEnd",
          forced: "".trimEnd !== o
        }, {
          trimEnd: o
        });
      },
      99967: (e, t, n) => {
        var r = n(82109),
          o = n(33217);
        r({
          target: "String",
          proto: !0,
          name: "trimStart",
          forced: "".trimLeft !== o
        }, {
          trimLeft: o
        });
      },
      83462: (e, t, n) => {
        var r = n(82109),
          o = n(10365);
        r({
          target: "String",
          proto: !0,
          name: "trimEnd",
          forced: "".trimRight !== o
        }, {
          trimRight: o
        });
      },
      55674: (e, t, n) => {
        n(99967);
        var r = n(82109),
          o = n(33217);
        r({
          target: "String",
          proto: !0,
          name: "trimStart",
          forced: "".trimStart !== o
        }, {
          trimStart: o
        });
      },
      72443: (e, t, n) => {
        n(26800)("asyncIterator");
      },
      41817: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(19781),
          i = n(17854),
          a = n(1702),
          s = n(92597),
          l = n(60614),
          u = n(47976),
          c = n(41340),
          d = n(3070).f,
          p = n(99920),
          h = i.Symbol,
          f = h && h.prototype;
        if (o && l(h) && (!("description" in f) || void 0 !== h().description)) {
          var m = {},
            g = function () {
              var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : c(arguments[0]),
                t = u(f, this) ? new h(e) : void 0 === e ? h() : h(e);
              return "" === e && (m[t] = !0), t;
            };
          p(g, h), g.prototype = f, f.constructor = g;
          var v = "Symbol(test)" == String(h("test")),
            y = a(f.valueOf),
            b = a(f.toString),
            w = /^Symbol\((.*)\)[^)]+$/,
            x = a("".replace),
            D = a("".slice);
          d(f, "description", {
            configurable: !0,
            get: function () {
              var e = y(this);
              if (s(m, e)) return "";
              var t = b(e),
                n = v ? D(t, 7, -1) : x(t, w, "$1");
              return "" === n ? void 0 : n;
            }
          }), r({
            global: !0,
            constructor: !0,
            forced: !0
          }, {
            Symbol: g
          });
        }
      },
      69007: (e, t, n) => {
        n(26800)("match");
      },
      83510: (e, t, n) => {
        n(26800)("replace");
      },
      41840: (e, t, n) => {
        n(26800)("search");
      },
      32159: (e, t, n) => {
        n(26800)("split");
      },
      33105: (e, t, n) => {
        "use strict";

        var r = n(90260),
          o = n(21285),
          i = n(64599),
          a = n(70648),
          s = n(46916),
          l = n(1702),
          u = n(47293),
          c = r.aTypedArray,
          d = r.exportTypedArrayMethod,
          p = l("".slice);
        d("fill", function (e) {
          var t = arguments.length;
          c(this);
          var n = "Big" === p(a(this), 0, 3) ? i(e) : +e;
          return s(o, this, n, t > 1 ? arguments[1] : void 0, t > 2 ? arguments[2] : void 0);
        }, u(function () {
          var e = 0;
          return new Int8Array(2).fill({
            valueOf: function () {
              return e++;
            }
          }), 1 !== e;
        }));
      },
      3462: (e, t, n) => {
        "use strict";

        var r = n(17854),
          o = n(46916),
          i = n(90260),
          a = n(26244),
          s = n(84590),
          l = n(47908),
          u = n(47293),
          c = r.RangeError,
          d = r.Int8Array,
          p = d && d.prototype,
          h = p && p.set,
          f = i.aTypedArray,
          m = i.exportTypedArrayMethod,
          g = !u(function () {
            var e = new Uint8ClampedArray(2);
            return o(h, e, {
              length: 1,
              0: 3
            }, 1), 3 !== e[1];
          }),
          v = g && i.NATIVE_ARRAY_BUFFER_VIEWS && u(function () {
            var e = new d(2);
            return e.set(1), e.set("2", 1), 0 !== e[0] || 2 !== e[1];
          });
        m("set", function (e) {
          f(this);
          var t = s(arguments.length > 1 ? arguments[1] : void 0, 1),
            n = l(e);
          if (g) return o(h, this, n, t);
          var r = this.length,
            i = a(n),
            u = 0;
          if (i + t > r) throw c("Wrong length");
          for (; u < i;) this[t + u] = n[u++];
        }, !g || v);
      },
      33824: (e, t, n) => {
        "use strict";

        var r = n(17854),
          o = n(21470),
          i = n(47293),
          a = n(19662),
          s = n(94362),
          l = n(90260),
          u = n(68886),
          c = n(30256),
          d = n(7392),
          p = n(98008),
          h = l.aTypedArray,
          f = l.exportTypedArrayMethod,
          m = r.Uint16Array,
          g = m && o(m.prototype.sort),
          v = !(!g || i(function () {
            g(new m(2), null);
          }) && i(function () {
            g(new m(2), {});
          })),
          y = !!g && !i(function () {
            if (d) return d < 74;
            if (u) return u < 67;
            if (c) return !0;
            if (p) return p < 602;
            var e,
              t,
              n = new m(516),
              r = Array(516);
            for (e = 0; e < 516; e++) t = e % 4, n[e] = 515 - e, r[e] = e - 2 * t + 3;
            for (g(n, function (e, t) {
              return (e / 4 | 0) - (t / 4 | 0);
            }), e = 0; e < 516; e++) if (n[e] !== r[e]) return !0;
          });
        f("sort", function (e) {
          return void 0 !== e && a(e), y ? g(this, e) : s(h(this), function (e) {
            return function (t, n) {
              return void 0 !== e ? +e(t, n) || 0 : n != n ? -1 : t != t ? 1 : 0 === t && 0 === n ? 1 / t > 0 && 1 / n < 0 ? 1 : -1 : t > n;
            };
          }(e));
        }, !y || v);
      },
      12974: (e, t, n) => {
        "use strict";

        var r = n(17854),
          o = n(22104),
          i = n(90260),
          a = n(47293),
          s = n(50206),
          l = r.Int8Array,
          u = i.aTypedArray,
          c = i.exportTypedArrayMethod,
          d = [].toLocaleString,
          p = !!l && a(function () {
            d.call(new l(1));
          });
        c("toLocaleString", function () {
          return o(d, p ? s(u(this)) : u(this), s(arguments));
        }, a(function () {
          return [1, 2].toLocaleString() != new l([1, 2]).toLocaleString();
        }) || !a(function () {
          l.prototype.toLocaleString.call([1, 2]);
        }));
      },
      41202: (e, t, n) => {
        "use strict";

        var r,
          o = n(76677),
          i = n(17854),
          a = n(1702),
          s = n(89190),
          l = n(62423),
          u = n(77710),
          c = n(29320),
          d = n(70111),
          p = n(29909).enforce,
          h = n(47293),
          f = n(94811),
          m = Object,
          g = Array.isArray,
          v = m.isExtensible,
          y = m.isFrozen,
          b = m.isSealed,
          w = m.freeze,
          x = m.seal,
          D = {},
          C = {},
          S = !i.ActiveXObject && "ActiveXObject" in i,
          E = function (e) {
            return function () {
              return e(this, arguments.length ? arguments[0] : void 0);
            };
          },
          _ = u("WeakMap", E, c),
          P = _.prototype,
          k = a(P.set);
        if (f) if (S) {
          r = c.getConstructor(E, "WeakMap", !0), l.enable();
          var A = a(P.delete),
            z = a(P.has),
            T = a(P.get);
          s(P, {
            delete: function (e) {
              if (d(e) && !v(e)) {
                var t = p(this);
                return t.frozen || (t.frozen = new r()), A(this, e) || t.frozen.delete(e);
              }
              return A(this, e);
            },
            has: function (e) {
              if (d(e) && !v(e)) {
                var t = p(this);
                return t.frozen || (t.frozen = new r()), z(this, e) || t.frozen.has(e);
              }
              return z(this, e);
            },
            get: function (e) {
              if (d(e) && !v(e)) {
                var t = p(this);
                return t.frozen || (t.frozen = new r()), z(this, e) ? T(this, e) : t.frozen.get(e);
              }
              return T(this, e);
            },
            set: function (e, t) {
              if (d(e) && !v(e)) {
                var n = p(this);
                n.frozen || (n.frozen = new r()), z(this, e) ? k(this, e, t) : n.frozen.set(e, t);
              } else k(this, e, t);
              return this;
            }
          });
        } else o && h(function () {
          var e = w([]);
          return k(new _(), e, 1), !y(e);
        }) && s(P, {
          set: function (e, t) {
            var n;
            return g(e) && (y(e) ? n = D : b(e) && (n = C)), k(this, e, t), n == D && w(e), n == C && x(e), this;
          }
        });
      },
      4129: (e, t, n) => {
        n(41202);
      },
      11091: (e, t, n) => {
        var r = n(82109),
          o = n(17854),
          i = n(20261).clear;
        r({
          global: !0,
          bind: !0,
          enumerable: !0,
          forced: o.clearImmediate !== i
        }, {
          clearImmediate: i
        });
      },
      33948: (e, t, n) => {
        var r = n(17854),
          o = n(48324),
          i = n(98509),
          a = n(66992),
          s = n(68880),
          l = n(5112),
          u = l("iterator"),
          c = l("toStringTag"),
          d = a.values,
          p = function (e, t) {
            if (e) {
              if (e[u] !== d) try {
                s(e, u, d);
              } catch (t) {
                e[u] = d;
              }
              if (e[c] || s(e, c, t), o[t]) for (var n in a) if (e[n] !== a[n]) try {
                s(e, n, a[n]);
              } catch (t) {
                e[n] = a[n];
              }
            }
          };
        for (var h in o) p(r[h] && r[h].prototype, h);
        p(i, "DOMTokenList");
      },
      84633: (e, t, n) => {
        n(11091), n(12986);
      },
      85844: (e, t, n) => {
        var r = n(82109),
          o = n(17854),
          i = n(95948),
          a = n(19662),
          s = n(48053),
          l = n(35268),
          u = o.process;
        r({
          global: !0,
          enumerable: !0,
          dontCallGetSet: !0
        }, {
          queueMicrotask: function (e) {
            s(arguments.length, 1), a(e);
            var t = l && u.domain;
            i(t ? t.bind(e) : e);
          }
        });
      },
      12986: (e, t, n) => {
        var r = n(82109),
          o = n(17854),
          i = n(20261).set,
          a = n(17152),
          s = o.setImmediate ? a(i, !1) : i;
        r({
          global: !0,
          bind: !0,
          enumerable: !0,
          forced: o.setImmediate !== s
        }, {
          setImmediate: s
        });
      },
      65556: (e, t, n) => {
        "use strict";

        n(66992);
        var r = n(82109),
          o = n(17854),
          i = n(46916),
          a = n(1702),
          s = n(19781),
          l = n(85143),
          u = n(98052),
          c = n(89190),
          d = n(58003),
          p = n(63061),
          h = n(29909),
          f = n(25787),
          m = n(60614),
          g = n(92597),
          v = n(49974),
          y = n(70648),
          b = n(19670),
          w = n(70111),
          x = n(41340),
          D = n(70030),
          C = n(79114),
          S = n(18554),
          E = n(71246),
          _ = n(48053),
          P = n(5112),
          k = n(94362),
          A = P("iterator"),
          z = "URLSearchParams",
          T = "URLSearchParamsIterator",
          O = h.set,
          I = h.getterFor(z),
          F = h.getterFor(T),
          M = Object.getOwnPropertyDescriptor,
          R = function (e) {
            if (!s) return o[e];
            var t = M(o, e);
            return t && t.value;
          },
          j = R("fetch"),
          B = R("Request"),
          N = R("Headers"),
          L = B && B.prototype,
          V = N && N.prototype,
          K = o.RegExp,
          q = o.TypeError,
          H = o.decodeURIComponent,
          U = o.encodeURIComponent,
          Z = a("".charAt),
          $ = a([].join),
          G = a([].push),
          W = a("".replace),
          Y = a([].shift),
          X = a([].splice),
          Q = a("".split),
          J = a("".slice),
          ee = /\+/g,
          te = Array(4),
          ne = function (e) {
            return te[e - 1] || (te[e - 1] = K("((?:%[\\da-f]{2}){" + e + "})", "gi"));
          },
          re = function (e) {
            try {
              return H(e);
            } catch (t) {
              return e;
            }
          },
          oe = function (e) {
            var t = W(e, ee, " "),
              n = 4;
            try {
              return H(t);
            } catch (e) {
              for (; n;) t = W(t, ne(n--), re);
              return t;
            }
          },
          ie = /[!'()~]|%20/g,
          ae = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+"
          },
          se = function (e) {
            return ae[e];
          },
          le = function (e) {
            return W(U(e), ie, se);
          },
          ue = p(function (e, t) {
            O(this, {
              type: T,
              iterator: S(I(e).entries),
              kind: t
            });
          }, "Iterator", function () {
            var e = F(this),
              t = e.kind,
              n = e.iterator.next(),
              r = n.value;
            return n.done || (n.value = "keys" === t ? r.key : "values" === t ? r.value : [r.key, r.value]), n;
          }, !0),
          ce = function (e) {
            this.entries = [], this.url = null, void 0 !== e && (w(e) ? this.parseObject(e) : this.parseQuery("string" == typeof e ? "?" === Z(e, 0) ? J(e, 1) : e : x(e)));
          };
        ce.prototype = {
          type: z,
          bindURL: function (e) {
            this.url = e, this.update();
          },
          parseObject: function (e) {
            var t,
              n,
              r,
              o,
              a,
              s,
              l,
              u = E(e);
            if (u) for (n = (t = S(e, u)).next; !(r = i(n, t)).done;) {
              if (a = (o = S(b(r.value))).next, (s = i(a, o)).done || (l = i(a, o)).done || !i(a, o).done) throw q("Expected sequence with length 2");
              G(this.entries, {
                key: x(s.value),
                value: x(l.value)
              });
            } else for (var c in e) g(e, c) && G(this.entries, {
              key: c,
              value: x(e[c])
            });
          },
          parseQuery: function (e) {
            if (e) for (var t, n, r = Q(e, "&"), o = 0; o < r.length;) (t = r[o++]).length && (n = Q(t, "="), G(this.entries, {
              key: oe(Y(n)),
              value: oe($(n, "="))
            }));
          },
          serialize: function () {
            for (var e, t = this.entries, n = [], r = 0; r < t.length;) e = t[r++], G(n, le(e.key) + "=" + le(e.value));
            return $(n, "&");
          },
          update: function () {
            this.entries.length = 0, this.parseQuery(this.url.query);
          },
          updateURL: function () {
            this.url && this.url.update();
          }
        };
        var de = function () {
            f(this, pe);
            var e = arguments.length > 0 ? arguments[0] : void 0;
            O(this, new ce(e));
          },
          pe = de.prototype;
        if (c(pe, {
          append: function (e, t) {
            _(arguments.length, 2);
            var n = I(this);
            G(n.entries, {
              key: x(e),
              value: x(t)
            }), n.updateURL();
          },
          delete: function (e) {
            _(arguments.length, 1);
            for (var t = I(this), n = t.entries, r = x(e), o = 0; o < n.length;) n[o].key === r ? X(n, o, 1) : o++;
            t.updateURL();
          },
          get: function (e) {
            _(arguments.length, 1);
            for (var t = I(this).entries, n = x(e), r = 0; r < t.length; r++) if (t[r].key === n) return t[r].value;
            return null;
          },
          getAll: function (e) {
            _(arguments.length, 1);
            for (var t = I(this).entries, n = x(e), r = [], o = 0; o < t.length; o++) t[o].key === n && G(r, t[o].value);
            return r;
          },
          has: function (e) {
            _(arguments.length, 1);
            for (var t = I(this).entries, n = x(e), r = 0; r < t.length;) if (t[r++].key === n) return !0;
            return !1;
          },
          set: function (e, t) {
            _(arguments.length, 1);
            for (var n, r = I(this), o = r.entries, i = !1, a = x(e), s = x(t), l = 0; l < o.length; l++) (n = o[l]).key === a && (i ? X(o, l--, 1) : (i = !0, n.value = s));
            i || G(o, {
              key: a,
              value: s
            }), r.updateURL();
          },
          sort: function () {
            var e = I(this);
            k(e.entries, function (e, t) {
              return e.key > t.key ? 1 : -1;
            }), e.updateURL();
          },
          forEach: function (e) {
            for (var t, n = I(this).entries, r = v(e, arguments.length > 1 ? arguments[1] : void 0), o = 0; o < n.length;) r((t = n[o++]).value, t.key, this);
          },
          keys: function () {
            return new ue(this, "keys");
          },
          values: function () {
            return new ue(this, "values");
          },
          entries: function () {
            return new ue(this, "entries");
          }
        }, {
          enumerable: !0
        }), u(pe, A, pe.entries, {
          name: "entries"
        }), u(pe, "toString", function () {
          return I(this).serialize();
        }, {
          enumerable: !0
        }), d(de, z), r({
          global: !0,
          constructor: !0,
          forced: !l
        }, {
          URLSearchParams: de
        }), !l && m(N)) {
          var he = a(V.has),
            fe = a(V.set),
            me = function (e) {
              if (w(e)) {
                var t,
                  n = e.body;
                if (y(n) === z) return t = e.headers ? new N(e.headers) : new N(), he(t, "content-type") || fe(t, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), D(e, {
                  body: C(0, x(n)),
                  headers: C(0, t)
                });
              }
              return e;
            };
          if (m(j) && r({
            global: !0,
            enumerable: !0,
            dontCallGetSet: !0,
            forced: !0
          }, {
            fetch: function (e) {
              return j(e, arguments.length > 1 ? me(arguments[1]) : {});
            }
          }), m(B)) {
            var ge = function (e) {
              return f(this, L), new B(e, arguments.length > 1 ? me(arguments[1]) : {});
            };
            L.constructor = ge, ge.prototype = L, r({
              global: !0,
              constructor: !0,
              dontCallGetSet: !0,
              forced: !0
            }, {
              Request: ge
            });
          }
        }
        e.exports = {
          URLSearchParams: de,
          getState: I
        };
      },
      41637: (e, t, n) => {
        n(65556);
      },
      68789: (e, t, n) => {
        "use strict";

        n(78783);
        var r,
          o = n(82109),
          i = n(19781),
          a = n(85143),
          s = n(17854),
          l = n(49974),
          u = n(1702),
          c = n(98052),
          d = n(47045),
          p = n(25787),
          h = n(92597),
          f = n(21574),
          m = n(48457),
          g = n(41589),
          v = n(28710).codeAt,
          y = n(33197),
          b = n(41340),
          w = n(58003),
          x = n(48053),
          D = n(65556),
          C = n(29909),
          S = C.set,
          E = C.getterFor("URL"),
          _ = D.URLSearchParams,
          P = D.getState,
          k = s.URL,
          A = s.TypeError,
          z = s.parseInt,
          T = Math.floor,
          O = Math.pow,
          I = u("".charAt),
          F = u(/./.exec),
          M = u([].join),
          R = u(1..toString),
          j = u([].pop),
          B = u([].push),
          N = u("".replace),
          L = u([].shift),
          V = u("".split),
          K = u("".slice),
          q = u("".toLowerCase),
          H = u([].unshift),
          U = "Invalid scheme",
          Z = "Invalid host",
          $ = "Invalid port",
          G = /[a-z]/i,
          W = /[\d+-.a-z]/i,
          Y = /\d/,
          X = /^0x/i,
          Q = /^[0-7]+$/,
          J = /^\d+$/,
          ee = /^[\da-f]+$/i,
          te = /[\0\t\n\r #%/:<>?@[\\\]^|]/,
          ne = /[\0\t\n\r #/:<>?@[\\\]^|]/,
          re = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g,
          oe = /[\t\n\r]/g,
          ie = function (e) {
            var t, n, r, o;
            if ("number" == typeof e) {
              for (t = [], n = 0; n < 4; n++) H(t, e % 256), e = T(e / 256);
              return M(t, ".");
            }
            if ("object" == typeof e) {
              for (t = "", r = function (e) {
                for (var t = null, n = 1, r = null, o = 0, i = 0; i < 8; i++) 0 !== e[i] ? (o > n && (t = r, n = o), r = null, o = 0) : (null === r && (r = i), ++o);
                return o > n && (t = r, n = o), t;
              }(e), n = 0; n < 8; n++) o && 0 === e[n] || (o && (o = !1), r === n ? (t += n ? ":" : "::", o = !0) : (t += R(e[n], 16), n < 7 && (t += ":")));
              return "[" + t + "]";
            }
            return e;
          },
          ae = {},
          se = f({}, ae, {
            " ": 1,
            '"': 1,
            "<": 1,
            ">": 1,
            "`": 1
          }),
          le = f({}, se, {
            "#": 1,
            "?": 1,
            "{": 1,
            "}": 1
          }),
          ue = f({}, le, {
            "/": 1,
            ":": 1,
            ";": 1,
            "=": 1,
            "@": 1,
            "[": 1,
            "\\": 1,
            "]": 1,
            "^": 1,
            "|": 1
          }),
          ce = function (e, t) {
            var n = v(e, 0);
            return n > 32 && n < 127 && !h(t, e) ? e : encodeURIComponent(e);
          },
          de = {
            ftp: 21,
            file: null,
            http: 80,
            https: 443,
            ws: 80,
            wss: 443
          },
          pe = function (e, t) {
            var n;
            return 2 == e.length && F(G, I(e, 0)) && (":" == (n = I(e, 1)) || !t && "|" == n);
          },
          he = function (e) {
            var t;
            return e.length > 1 && pe(K(e, 0, 2)) && (2 == e.length || "/" === (t = I(e, 2)) || "\\" === t || "?" === t || "#" === t);
          },
          fe = function (e) {
            return "." === e || "%2e" === q(e);
          },
          me = {},
          ge = {},
          ve = {},
          ye = {},
          be = {},
          we = {},
          xe = {},
          De = {},
          Ce = {},
          Se = {},
          Ee = {},
          _e = {},
          Pe = {},
          ke = {},
          Ae = {},
          ze = {},
          Te = {},
          Oe = {},
          Ie = {},
          Fe = {},
          Me = {},
          Re = function (e, t, n) {
            var r,
              o,
              i,
              a = b(e);
            if (t) {
              if (o = this.parse(a)) throw A(o);
              this.searchParams = null;
            } else {
              if (void 0 !== n && (r = new Re(n, !0)), o = this.parse(a, null, r)) throw A(o);
              (i = P(new _())).bindURL(this), this.searchParams = i;
            }
          };
        Re.prototype = {
          type: "URL",
          parse: function (e, t, n) {
            var o,
              i,
              a,
              s,
              l,
              u = this,
              c = t || me,
              d = 0,
              p = "",
              f = !1,
              v = !1,
              y = !1;
            for (e = b(e), t || (u.scheme = "", u.username = "", u.password = "", u.host = null, u.port = null, u.path = [], u.query = null, u.fragment = null, u.cannotBeABaseURL = !1, e = N(e, re, "")), e = N(e, oe, ""), o = m(e); d <= o.length;) {
              switch (i = o[d], c) {
                case me:
                  if (!i || !F(G, i)) {
                    if (t) return U;
                    c = ve;
                    continue;
                  }
                  p += q(i), c = ge;
                  break;
                case ge:
                  if (i && (F(W, i) || "+" == i || "-" == i || "." == i)) p += q(i);else {
                    if (":" != i) {
                      if (t) return U;
                      p = "", c = ve, d = 0;
                      continue;
                    }
                    if (t && (u.isSpecial() != h(de, p) || "file" == p && (u.includesCredentials() || null !== u.port) || "file" == u.scheme && !u.host)) return;
                    if (u.scheme = p, t) return void (u.isSpecial() && de[u.scheme] == u.port && (u.port = null));
                    p = "", "file" == u.scheme ? c = ke : u.isSpecial() && n && n.scheme == u.scheme ? c = ye : u.isSpecial() ? c = De : "/" == o[d + 1] ? (c = be, d++) : (u.cannotBeABaseURL = !0, B(u.path, ""), c = Ie);
                  }
                  break;
                case ve:
                  if (!n || n.cannotBeABaseURL && "#" != i) return U;
                  if (n.cannotBeABaseURL && "#" == i) {
                    u.scheme = n.scheme, u.path = g(n.path), u.query = n.query, u.fragment = "", u.cannotBeABaseURL = !0, c = Me;
                    break;
                  }
                  c = "file" == n.scheme ? ke : we;
                  continue;
                case ye:
                  if ("/" != i || "/" != o[d + 1]) {
                    c = we;
                    continue;
                  }
                  c = Ce, d++;
                  break;
                case be:
                  if ("/" == i) {
                    c = Se;
                    break;
                  }
                  c = Oe;
                  continue;
                case we:
                  if (u.scheme = n.scheme, i == r) u.username = n.username, u.password = n.password, u.host = n.host, u.port = n.port, u.path = g(n.path), u.query = n.query;else if ("/" == i || "\\" == i && u.isSpecial()) c = xe;else if ("?" == i) u.username = n.username, u.password = n.password, u.host = n.host, u.port = n.port, u.path = g(n.path), u.query = "", c = Fe;else {
                    if ("#" != i) {
                      u.username = n.username, u.password = n.password, u.host = n.host, u.port = n.port, u.path = g(n.path), u.path.length--, c = Oe;
                      continue;
                    }
                    u.username = n.username, u.password = n.password, u.host = n.host, u.port = n.port, u.path = g(n.path), u.query = n.query, u.fragment = "", c = Me;
                  }
                  break;
                case xe:
                  if (!u.isSpecial() || "/" != i && "\\" != i) {
                    if ("/" != i) {
                      u.username = n.username, u.password = n.password, u.host = n.host, u.port = n.port, c = Oe;
                      continue;
                    }
                    c = Se;
                  } else c = Ce;
                  break;
                case De:
                  if (c = Ce, "/" != i || "/" != I(p, d + 1)) continue;
                  d++;
                  break;
                case Ce:
                  if ("/" != i && "\\" != i) {
                    c = Se;
                    continue;
                  }
                  break;
                case Se:
                  if ("@" == i) {
                    f && (p = "%40" + p), f = !0, a = m(p);
                    for (var w = 0; w < a.length; w++) {
                      var x = a[w];
                      if (":" != x || y) {
                        var D = ce(x, ue);
                        y ? u.password += D : u.username += D;
                      } else y = !0;
                    }
                    p = "";
                  } else if (i == r || "/" == i || "?" == i || "#" == i || "\\" == i && u.isSpecial()) {
                    if (f && "" == p) return "Invalid authority";
                    d -= m(p).length + 1, p = "", c = Ee;
                  } else p += i;
                  break;
                case Ee:
                case _e:
                  if (t && "file" == u.scheme) {
                    c = ze;
                    continue;
                  }
                  if (":" != i || v) {
                    if (i == r || "/" == i || "?" == i || "#" == i || "\\" == i && u.isSpecial()) {
                      if (u.isSpecial() && "" == p) return Z;
                      if (t && "" == p && (u.includesCredentials() || null !== u.port)) return;
                      if (s = u.parseHost(p)) return s;
                      if (p = "", c = Te, t) return;
                      continue;
                    }
                    "[" == i ? v = !0 : "]" == i && (v = !1), p += i;
                  } else {
                    if ("" == p) return Z;
                    if (s = u.parseHost(p)) return s;
                    if (p = "", c = Pe, t == _e) return;
                  }
                  break;
                case Pe:
                  if (!F(Y, i)) {
                    if (i == r || "/" == i || "?" == i || "#" == i || "\\" == i && u.isSpecial() || t) {
                      if ("" != p) {
                        var C = z(p, 10);
                        if (C > 65535) return $;
                        u.port = u.isSpecial() && C === de[u.scheme] ? null : C, p = "";
                      }
                      if (t) return;
                      c = Te;
                      continue;
                    }
                    return $;
                  }
                  p += i;
                  break;
                case ke:
                  if (u.scheme = "file", "/" == i || "\\" == i) c = Ae;else {
                    if (!n || "file" != n.scheme) {
                      c = Oe;
                      continue;
                    }
                    if (i == r) u.host = n.host, u.path = g(n.path), u.query = n.query;else if ("?" == i) u.host = n.host, u.path = g(n.path), u.query = "", c = Fe;else {
                      if ("#" != i) {
                        he(M(g(o, d), "")) || (u.host = n.host, u.path = g(n.path), u.shortenPath()), c = Oe;
                        continue;
                      }
                      u.host = n.host, u.path = g(n.path), u.query = n.query, u.fragment = "", c = Me;
                    }
                  }
                  break;
                case Ae:
                  if ("/" == i || "\\" == i) {
                    c = ze;
                    break;
                  }
                  n && "file" == n.scheme && !he(M(g(o, d), "")) && (pe(n.path[0], !0) ? B(u.path, n.path[0]) : u.host = n.host), c = Oe;
                  continue;
                case ze:
                  if (i == r || "/" == i || "\\" == i || "?" == i || "#" == i) {
                    if (!t && pe(p)) c = Oe;else if ("" == p) {
                      if (u.host = "", t) return;
                      c = Te;
                    } else {
                      if (s = u.parseHost(p)) return s;
                      if ("localhost" == u.host && (u.host = ""), t) return;
                      p = "", c = Te;
                    }
                    continue;
                  }
                  p += i;
                  break;
                case Te:
                  if (u.isSpecial()) {
                    if (c = Oe, "/" != i && "\\" != i) continue;
                  } else if (t || "?" != i) {
                    if (t || "#" != i) {
                      if (i != r && (c = Oe, "/" != i)) continue;
                    } else u.fragment = "", c = Me;
                  } else u.query = "", c = Fe;
                  break;
                case Oe:
                  if (i == r || "/" == i || "\\" == i && u.isSpecial() || !t && ("?" == i || "#" == i)) {
                    if (".." === (l = q(l = p)) || "%2e." === l || ".%2e" === l || "%2e%2e" === l ? (u.shortenPath(), "/" == i || "\\" == i && u.isSpecial() || B(u.path, "")) : fe(p) ? "/" == i || "\\" == i && u.isSpecial() || B(u.path, "") : ("file" == u.scheme && !u.path.length && pe(p) && (u.host && (u.host = ""), p = I(p, 0) + ":"), B(u.path, p)), p = "", "file" == u.scheme && (i == r || "?" == i || "#" == i)) for (; u.path.length > 1 && "" === u.path[0];) L(u.path);
                    "?" == i ? (u.query = "", c = Fe) : "#" == i && (u.fragment = "", c = Me);
                  } else p += ce(i, le);
                  break;
                case Ie:
                  "?" == i ? (u.query = "", c = Fe) : "#" == i ? (u.fragment = "", c = Me) : i != r && (u.path[0] += ce(i, ae));
                  break;
                case Fe:
                  t || "#" != i ? i != r && ("'" == i && u.isSpecial() ? u.query += "%27" : u.query += "#" == i ? "%23" : ce(i, ae)) : (u.fragment = "", c = Me);
                  break;
                case Me:
                  i != r && (u.fragment += ce(i, se));
              }
              d++;
            }
          },
          parseHost: function (e) {
            var t, n, r;
            if ("[" == I(e, 0)) {
              if ("]" != I(e, e.length - 1)) return Z;
              if (t = function (e) {
                var t,
                  n,
                  r,
                  o,
                  i,
                  a,
                  s,
                  l = [0, 0, 0, 0, 0, 0, 0, 0],
                  u = 0,
                  c = null,
                  d = 0,
                  p = function () {
                    return I(e, d);
                  };
                if (":" == p()) {
                  if (":" != I(e, 1)) return;
                  d += 2, c = ++u;
                }
                for (; p();) {
                  if (8 == u) return;
                  if (":" != p()) {
                    for (t = n = 0; n < 4 && F(ee, p());) t = 16 * t + z(p(), 16), d++, n++;
                    if ("." == p()) {
                      if (0 == n) return;
                      if (d -= n, u > 6) return;
                      for (r = 0; p();) {
                        if (o = null, r > 0) {
                          if (!("." == p() && r < 4)) return;
                          d++;
                        }
                        if (!F(Y, p())) return;
                        for (; F(Y, p());) {
                          if (i = z(p(), 10), null === o) o = i;else {
                            if (0 == o) return;
                            o = 10 * o + i;
                          }
                          if (o > 255) return;
                          d++;
                        }
                        l[u] = 256 * l[u] + o, 2 != ++r && 4 != r || u++;
                      }
                      if (4 != r) return;
                      break;
                    }
                    if (":" == p()) {
                      if (d++, !p()) return;
                    } else if (p()) return;
                    l[u++] = t;
                  } else {
                    if (null !== c) return;
                    d++, c = ++u;
                  }
                }
                if (null !== c) for (a = u - c, u = 7; 0 != u && a > 0;) s = l[u], l[u--] = l[c + a - 1], l[c + --a] = s;else if (8 != u) return;
                return l;
              }(K(e, 1, -1)), !t) return Z;
              this.host = t;
            } else if (this.isSpecial()) {
              if (e = y(e), F(te, e)) return Z;
              if (t = function (e) {
                var t,
                  n,
                  r,
                  o,
                  i,
                  a,
                  s,
                  l = V(e, ".");
                if (l.length && "" == l[l.length - 1] && l.length--, (t = l.length) > 4) return e;
                for (n = [], r = 0; r < t; r++) {
                  if ("" == (o = l[r])) return e;
                  if (i = 10, o.length > 1 && "0" == I(o, 0) && (i = F(X, o) ? 16 : 8, o = K(o, 8 == i ? 1 : 2)), "" === o) a = 0;else {
                    if (!F(10 == i ? J : 8 == i ? Q : ee, o)) return e;
                    a = z(o, i);
                  }
                  B(n, a);
                }
                for (r = 0; r < t; r++) if (a = n[r], r == t - 1) {
                  if (a >= O(256, 5 - t)) return null;
                } else if (a > 255) return null;
                for (s = j(n), r = 0; r < n.length; r++) s += n[r] * O(256, 3 - r);
                return s;
              }(e), null === t) return Z;
              this.host = t;
            } else {
              if (F(ne, e)) return Z;
              for (t = "", n = m(e), r = 0; r < n.length; r++) t += ce(n[r], ae);
              this.host = t;
            }
          },
          cannotHaveUsernamePasswordPort: function () {
            return !this.host || this.cannotBeABaseURL || "file" == this.scheme;
          },
          includesCredentials: function () {
            return "" != this.username || "" != this.password;
          },
          isSpecial: function () {
            return h(de, this.scheme);
          },
          shortenPath: function () {
            var e = this.path,
              t = e.length;
            !t || "file" == this.scheme && 1 == t && pe(e[0], !0) || e.length--;
          },
          serialize: function () {
            var e = this,
              t = e.scheme,
              n = e.username,
              r = e.password,
              o = e.host,
              i = e.port,
              a = e.path,
              s = e.query,
              l = e.fragment,
              u = t + ":";
            return null !== o ? (u += "//", e.includesCredentials() && (u += n + (r ? ":" + r : "") + "@"), u += ie(o), null !== i && (u += ":" + i)) : "file" == t && (u += "//"), u += e.cannotBeABaseURL ? a[0] : a.length ? "/" + M(a, "/") : "", null !== s && (u += "?" + s), null !== l && (u += "#" + l), u;
          },
          setHref: function (e) {
            var t = this.parse(e);
            if (t) throw A(t);
            this.searchParams.update();
          },
          getOrigin: function () {
            var e = this.scheme,
              t = this.port;
            if ("blob" == e) try {
              return new je(e.path[0]).origin;
            } catch (e) {
              return "null";
            }
            return "file" != e && this.isSpecial() ? e + "://" + ie(this.host) + (null !== t ? ":" + t : "") : "null";
          },
          getProtocol: function () {
            return this.scheme + ":";
          },
          setProtocol: function (e) {
            this.parse(b(e) + ":", me);
          },
          getUsername: function () {
            return this.username;
          },
          setUsername: function (e) {
            var t = m(b(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
              this.username = "";
              for (var n = 0; n < t.length; n++) this.username += ce(t[n], ue);
            }
          },
          getPassword: function () {
            return this.password;
          },
          setPassword: function (e) {
            var t = m(b(e));
            if (!this.cannotHaveUsernamePasswordPort()) {
              this.password = "";
              for (var n = 0; n < t.length; n++) this.password += ce(t[n], ue);
            }
          },
          getHost: function () {
            var e = this.host,
              t = this.port;
            return null === e ? "" : null === t ? ie(e) : ie(e) + ":" + t;
          },
          setHost: function (e) {
            this.cannotBeABaseURL || this.parse(e, Ee);
          },
          getHostname: function () {
            var e = this.host;
            return null === e ? "" : ie(e);
          },
          setHostname: function (e) {
            this.cannotBeABaseURL || this.parse(e, _e);
          },
          getPort: function () {
            var e = this.port;
            return null === e ? "" : b(e);
          },
          setPort: function (e) {
            this.cannotHaveUsernamePasswordPort() || ("" == (e = b(e)) ? this.port = null : this.parse(e, Pe));
          },
          getPathname: function () {
            var e = this.path;
            return this.cannotBeABaseURL ? e[0] : e.length ? "/" + M(e, "/") : "";
          },
          setPathname: function (e) {
            this.cannotBeABaseURL || (this.path = [], this.parse(e, Te));
          },
          getSearch: function () {
            var e = this.query;
            return e ? "?" + e : "";
          },
          setSearch: function (e) {
            "" == (e = b(e)) ? this.query = null : ("?" == I(e, 0) && (e = K(e, 1)), this.query = "", this.parse(e, Fe)), this.searchParams.update();
          },
          getSearchParams: function () {
            return this.searchParams.facade;
          },
          getHash: function () {
            var e = this.fragment;
            return e ? "#" + e : "";
          },
          setHash: function (e) {
            "" != (e = b(e)) ? ("#" == I(e, 0) && (e = K(e, 1)), this.fragment = "", this.parse(e, Me)) : this.fragment = null;
          },
          update: function () {
            this.query = this.searchParams.serialize() || null;
          }
        };
        var je = function (e) {
            var t = p(this, Be),
              n = x(arguments.length, 1) > 1 ? arguments[1] : void 0,
              r = S(t, new Re(e, !1, n));
            i || (t.href = r.serialize(), t.origin = r.getOrigin(), t.protocol = r.getProtocol(), t.username = r.getUsername(), t.password = r.getPassword(), t.host = r.getHost(), t.hostname = r.getHostname(), t.port = r.getPort(), t.pathname = r.getPathname(), t.search = r.getSearch(), t.searchParams = r.getSearchParams(), t.hash = r.getHash());
          },
          Be = je.prototype,
          Ne = function (e, t) {
            return {
              get: function () {
                return E(this)[e]();
              },
              set: t && function (e) {
                return E(this)[t](e);
              },
              configurable: !0,
              enumerable: !0
            };
          };
        if (i && (d(Be, "href", Ne("serialize", "setHref")), d(Be, "origin", Ne("getOrigin")), d(Be, "protocol", Ne("getProtocol", "setProtocol")), d(Be, "username", Ne("getUsername", "setUsername")), d(Be, "password", Ne("getPassword", "setPassword")), d(Be, "host", Ne("getHost", "setHost")), d(Be, "hostname", Ne("getHostname", "setHostname")), d(Be, "port", Ne("getPort", "setPort")), d(Be, "pathname", Ne("getPathname", "setPathname")), d(Be, "search", Ne("getSearch", "setSearch")), d(Be, "searchParams", Ne("getSearchParams")), d(Be, "hash", Ne("getHash", "setHash"))), c(Be, "toJSON", function () {
          return E(this).serialize();
        }, {
          enumerable: !0
        }), c(Be, "toString", function () {
          return E(this).serialize();
        }, {
          enumerable: !0
        }), k) {
          var Le = k.createObjectURL,
            Ve = k.revokeObjectURL;
          Le && c(je, "createObjectURL", l(Le, k)), Ve && c(je, "revokeObjectURL", l(Ve, k));
        }
        w(je, "URL"), o({
          global: !0,
          constructor: !0,
          forced: !a,
          sham: !i
        }, {
          URL: je
        });
      },
      60285: (e, t, n) => {
        n(68789);
      },
      83753: (e, t, n) => {
        "use strict";

        var r = n(82109),
          o = n(46916);
        r({
          target: "URL",
          proto: !0,
          enumerable: !0
        }, {
          toJSON: function () {
            return o(URL.prototype.toString, this);
          }
        });
      },
      72572: (e, t, n) => {
        "use strict";

        var r = n(67294);
        t.createSubscription = function (e) {
          var t = e.getCurrentValue,
            n = e.subscribe;
          return function (e) {
            function r() {
              for (var n = arguments.length, r = Array(n), o = 0; o < n; o++) r[o] = arguments[o];
              return (n = e.call.apply(e, [this].concat(r)) || this).state = {
                source: n.props.source,
                value: null != n.props.source ? t(n.props.source) : void 0
              }, n._hasUnmounted = !1, n._unsubscribe = null, n;
            }
            !function (e, t) {
              e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
            }(r, e), r.getDerivedStateFromProps = function (e, n) {
              return e.source !== n.source ? {
                source: e.source,
                value: null != e.source ? t(e.source) : void 0
              } : null;
            };
            var o = r.prototype;
            return o.componentDidMount = function () {
              this.subscribe();
            }, o.componentDidUpdate = function (e, t) {
              this.state.source !== t.source && (this.unsubscribe(), this.subscribe());
            }, o.componentWillUnmount = function () {
              this.unsubscribe(), this._hasUnmounted = !0;
            }, o.render = function () {
              return this.props.children(this.state.value);
            }, o.subscribe = function () {
              var e = this,
                r = this.state.source;
              if (null != r) {
                var o = n(r, function (t) {
                  e._hasUnmounted || e.setState(function (e) {
                    return t === e.value || r !== e.source ? null : {
                      value: t
                    };
                  });
                });
                if ("function" != typeof o) throw Error(function (e) {
                  for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
                  return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
                }(266));
                this._unsubscribe = o, (o = t(this.props.source)) !== this.state.value && this.setState({
                  value: o
                });
              }
            }, o.unsubscribe = function () {
              "function" == typeof this._unsubscribe && this._unsubscribe(), this._unsubscribe = null;
            }, r;
          }(r.Component);
        };
      },
      74792: (e, t, n) => {
        "use strict";

        e.exports = n(72572);
      },
      57763: (e, t, n) => {
        "use strict";

        var r;
        n.r(t), n.d(t, {
          AttributeAction: () => i,
          IgnoreCaseMode: () => o,
          SelectorType: () => r,
          isTraversal: () => c,
          parse: () => g,
          stringify: () => C
        }), function (e) {
          e.Attribute = "attribute", e.Pseudo = "pseudo", e.PseudoElement = "pseudo-element", e.Tag = "tag", e.Universal = "universal", e.Adjacent = "adjacent", e.Child = "child", e.Descendant = "descendant", e.Parent = "parent", e.Sibling = "sibling", e.ColumnCombinator = "column-combinator";
        }(r || (r = {}));
        const o = {
          Unknown: null,
          QuirksMode: "quirks",
          IgnoreCase: !0,
          CaseSensitive: !1
        };
        var i;
        !function (e) {
          e.Any = "any", e.Element = "element", e.End = "end", e.Equals = "equals", e.Exists = "exists", e.Hyphen = "hyphen", e.Not = "not", e.Start = "start";
        }(i || (i = {}));
        const a = /^[^\\#]?(?:\\(?:[\da-f]{1,6}\s?|.)|[\w\-\u00b0-\uFFFF])+/,
          s = /\\([\da-f]{1,6}\s?|(\s)|.)/gi,
          l = new Map([[126, i.Element], [94, i.Start], [36, i.End], [42, i.Any], [33, i.Not], [124, i.Hyphen]]),
          u = new Set(["has", "not", "matches", "is", "where", "host", "host-context"]);
        function c(e) {
          switch (e.type) {
            case r.Adjacent:
            case r.Child:
            case r.Descendant:
            case r.Parent:
            case r.Sibling:
            case r.ColumnCombinator:
              return !0;
            default:
              return !1;
          }
        }
        const d = new Set(["contains", "icontains"]);
        function p(e, t, n) {
          const r = parseInt(t, 16) - 65536;
          return r != r || n ? t : r < 0 ? String.fromCharCode(r + 65536) : String.fromCharCode(r >> 10 | 55296, 1023 & r | 56320);
        }
        function h(e) {
          return e.replace(s, p);
        }
        function f(e) {
          return 39 === e || 34 === e;
        }
        function m(e) {
          return 32 === e || 9 === e || 10 === e || 12 === e || 13 === e;
        }
        function g(e) {
          const t = [],
            n = v(t, `${e}`, 0);
          if (n < e.length) throw new Error(`Unmatched selector: ${e.slice(n)}`);
          return t;
        }
        function v(e, t, n) {
          let o = [];
          function s(e) {
            const r = t.slice(n + e).match(a);
            if (!r) throw new Error(`Expected name, found ${t.slice(n)}`);
            const [o] = r;
            return n += e + o.length, h(o);
          }
          function p(e) {
            for (n += e; n < t.length && m(t.charCodeAt(n));) n++;
          }
          function g() {
            const e = n += 1;
            let r = 1;
            for (; r > 0 && n < t.length; n++) 40 !== t.charCodeAt(n) || y(n) ? 41 !== t.charCodeAt(n) || y(n) || r-- : r++;
            if (r) throw new Error("Parenthesis not matched");
            return h(t.slice(e, n - 1));
          }
          function y(e) {
            let n = 0;
            for (; 92 === t.charCodeAt(--e);) n++;
            return 1 == (1 & n);
          }
          function b() {
            if (o.length > 0 && c(o[o.length - 1])) throw new Error("Did not expect successive traversals.");
          }
          function w(e) {
            o.length > 0 && o[o.length - 1].type === r.Descendant ? o[o.length - 1].type = e : (b(), o.push({
              type: e
            }));
          }
          function x(e, t) {
            o.push({
              type: r.Attribute,
              name: e,
              action: t,
              value: s(1),
              namespace: null,
              ignoreCase: "quirks"
            });
          }
          function D() {
            if (o.length && o[o.length - 1].type === r.Descendant && o.pop(), 0 === o.length) throw new Error("Empty sub-selector");
            e.push(o);
          }
          if (p(0), t.length === n) return n;
          e: for (; n < t.length;) {
            const e = t.charCodeAt(n);
            switch (e) {
              case 32:
              case 9:
              case 10:
              case 12:
              case 13:
                0 !== o.length && o[0].type === r.Descendant || (b(), o.push({
                  type: r.Descendant
                })), p(1);
                break;
              case 62:
                w(r.Child), p(1);
                break;
              case 60:
                w(r.Parent), p(1);
                break;
              case 126:
                w(r.Sibling), p(1);
                break;
              case 43:
                w(r.Adjacent), p(1);
                break;
              case 46:
                x("class", i.Element);
                break;
              case 35:
                x("id", i.Equals);
                break;
              case 91:
                {
                  let e;
                  p(1);
                  let a = null;
                  124 === t.charCodeAt(n) ? e = s(1) : t.startsWith("*|", n) ? (a = "*", e = s(2)) : (e = s(0), 124 === t.charCodeAt(n) && 61 !== t.charCodeAt(n + 1) && (a = e, e = s(1))), p(0);
                  let u = i.Exists;
                  const c = l.get(t.charCodeAt(n));
                  if (c) {
                    if (u = c, 61 !== t.charCodeAt(n + 1)) throw new Error("Expected `=`");
                    p(2);
                  } else 61 === t.charCodeAt(n) && (u = i.Equals, p(1));
                  let d = "",
                    g = null;
                  if ("exists" !== u) {
                    if (f(t.charCodeAt(n))) {
                      const e = t.charCodeAt(n);
                      let r = n + 1;
                      for (; r < t.length && (t.charCodeAt(r) !== e || y(r));) r += 1;
                      if (t.charCodeAt(r) !== e) throw new Error("Attribute value didn't end");
                      d = h(t.slice(n + 1, r)), n = r + 1;
                    } else {
                      const e = n;
                      for (; n < t.length && (!m(t.charCodeAt(n)) && 93 !== t.charCodeAt(n) || y(n));) n += 1;
                      d = h(t.slice(e, n));
                    }
                    p(0);
                    const e = 32 | t.charCodeAt(n);
                    115 === e ? (g = !1, p(1)) : 105 === e && (g = !0, p(1));
                  }
                  if (93 !== t.charCodeAt(n)) throw new Error("Attribute selector didn't terminate");
                  n += 1;
                  const v = {
                    type: r.Attribute,
                    name: e,
                    action: u,
                    value: d,
                    namespace: a,
                    ignoreCase: g
                  };
                  o.push(v);
                  break;
                }
              case 58:
                {
                  if (58 === t.charCodeAt(n + 1)) {
                    o.push({
                      type: r.PseudoElement,
                      name: s(2).toLowerCase(),
                      data: 40 === t.charCodeAt(n) ? g() : null
                    });
                    continue;
                  }
                  const e = s(1).toLowerCase();
                  let i = null;
                  if (40 === t.charCodeAt(n)) if (u.has(e)) {
                    if (f(t.charCodeAt(n + 1))) throw new Error(`Pseudo-selector ${e} cannot be quoted`);
                    if (i = [], n = v(i, t, n + 1), 41 !== t.charCodeAt(n)) throw new Error(`Missing closing parenthesis in :${e} (${t})`);
                    n += 1;
                  } else {
                    if (i = g(), d.has(e)) {
                      const e = i.charCodeAt(0);
                      e === i.charCodeAt(i.length - 1) && f(e) && (i = i.slice(1, -1));
                    }
                    i = h(i);
                  }
                  o.push({
                    type: r.Pseudo,
                    name: e,
                    data: i
                  });
                  break;
                }
              case 44:
                D(), o = [], p(1);
                break;
              default:
                {
                  if (t.startsWith("/*", n)) {
                    const e = t.indexOf("*/", n + 2);
                    if (e < 0) throw new Error("Comment was not terminated");
                    n = e + 2, 0 === o.length && p(0);
                    break;
                  }
                  let i,
                    l = null;
                  if (42 === e) n += 1, i = "*";else if (124 === e) {
                    if (i = "", 124 === t.charCodeAt(n + 1)) {
                      w(r.ColumnCombinator), p(2);
                      break;
                    }
                  } else {
                    if (!a.test(t.slice(n))) break e;
                    i = s(0);
                  }
                  124 === t.charCodeAt(n) && 124 !== t.charCodeAt(n + 1) && (l = i, 42 === t.charCodeAt(n + 1) ? (i = "*", n += 2) : i = s(1)), o.push("*" === i ? {
                    type: r.Universal,
                    namespace: l
                  } : {
                    type: r.Tag,
                    name: i,
                    namespace: l
                  });
                }
            }
          }
          return D(), n;
        }
        const y = ["\\", '"'],
          b = [...y, "(", ")"],
          w = new Set(y.map(e => e.charCodeAt(0))),
          x = new Set(b.map(e => e.charCodeAt(0))),
          D = new Set([...b, "~", "^", "$", "*", "+", "!", "|", ":", "[", "]", " ", "."].map(e => e.charCodeAt(0)));
        function C(e) {
          return e.map(e => e.map(S).join("")).join(", ");
        }
        function S(e, t, n) {
          switch (e.type) {
            case r.Child:
              return 0 === t ? "> " : " > ";
            case r.Parent:
              return 0 === t ? "< " : " < ";
            case r.Sibling:
              return 0 === t ? "~ " : " ~ ";
            case r.Adjacent:
              return 0 === t ? "+ " : " + ";
            case r.Descendant:
              return " ";
            case r.ColumnCombinator:
              return 0 === t ? "|| " : " || ";
            case r.Universal:
              return "*" === e.namespace && t + 1 < n.length && "name" in n[t + 1] ? "" : `${_(e.namespace)}*`;
            case r.Tag:
              return E(e);
            case r.PseudoElement:
              return `::${P(e.name, D)}${null === e.data ? "" : `(${P(e.data, x)})`}`;
            case r.Pseudo:
              return `:${P(e.name, D)}${null === e.data ? "" : `(${"string" == typeof e.data ? P(e.data, x) : C(e.data)})`}`;
            case r.Attribute:
              {
                if ("id" === e.name && e.action === i.Equals && "quirks" === e.ignoreCase && !e.namespace) return `#${P(e.value, D)}`;
                if ("class" === e.name && e.action === i.Element && "quirks" === e.ignoreCase && !e.namespace) return `.${P(e.value, D)}`;
                const t = E(e);
                return e.action === i.Exists ? `[${t}]` : `[${t}${function (e) {
                  switch (e) {
                    case i.Equals:
                      return "";
                    case i.Element:
                      return "~";
                    case i.Start:
                      return "^";
                    case i.End:
                      return "$";
                    case i.Any:
                      return "*";
                    case i.Not:
                      return "!";
                    case i.Hyphen:
                      return "|";
                    case i.Exists:
                      throw new Error("Shouldn't be here");
                  }
                }(e.action)}="${P(e.value, w)}"${null === e.ignoreCase ? "" : e.ignoreCase ? " i" : " s"}]`;
              }
          }
        }
        function E(e) {
          return `${_(e.namespace)}${P(e.name, D)}`;
        }
        function _(e) {
          return null !== e ? `${"*" === e ? "*" : P(e, D)}|` : "";
        }
        function P(e, t) {
          let n = 0,
            r = "";
          for (let o = 0; o < e.length; o++) t.has(e.charCodeAt(o)) && (r += `${e.slice(n, o)}\\${e.charAt(o)}`, n = o + 1);
          return r.length > 0 ? r + e.slice(n) : e;
        }
      },
      6907: e => {
        "use strict";

        e.exports = function (e) {
          if (e = String(e || ""), r.test(e)) return "rtl";
          if (o.test(e)) return "ltr";
          return "neutral";
        };
        var t = "֑-߿יִ-﷽ﹰ-ﻼ",
          n = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿",
          r = new RegExp("^[^" + n + "]*[" + t + "]"),
          o = new RegExp("^[^" + t + "]*[" + n + "]");
      },
      17837: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.attributeNames = t.elementNames = void 0, t.elementNames = new Map(["altGlyph", "altGlyphDef", "altGlyphItem", "animateColor", "animateMotion", "animateTransform", "clipPath", "feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "foreignObject", "glyphRef", "linearGradient", "radialGradient", "textPath"].map(function (e) {
          return [e.toLowerCase(), e];
        })), t.attributeNames = new Map(["definitionURL", "attributeName", "attributeType", "baseFrequency", "baseProfile", "calcMode", "clipPathUnits", "diffuseConstant", "edgeMode", "filterUnits", "glyphRef", "gradientTransform", "gradientUnits", "kernelMatrix", "kernelUnitLength", "keyPoints", "keySplines", "keyTimes", "lengthAdjust", "limitingConeAngle", "markerHeight", "markerUnits", "markerWidth", "maskContentUnits", "maskUnits", "numOctaves", "pathLength", "patternContentUnits", "patternTransform", "patternUnits", "pointsAtX", "pointsAtY", "pointsAtZ", "preserveAlpha", "preserveAspectRatio", "primitiveUnits", "refX", "refY", "repeatCount", "repeatDur", "requiredExtensions", "requiredFeatures", "specularConstant", "specularExponent", "spreadMethod", "startOffset", "stdDeviation", "stitchTiles", "surfaceScale", "systemLanguage", "tableValues", "targetX", "targetY", "textLength", "viewBox", "viewTarget", "xChannelSelector", "yChannelSelector", "zoomAndPan"].map(function (e) {
          return [e.toLowerCase(), e];
        }));
      },
      97220: function (e, t, n) {
        "use strict";

        var r = this && this.__assign || function () {
            return r = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, r.apply(this, arguments);
          },
          o = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          i = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          a = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
            return i(t, e), t;
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.render = void 0;
        var s = a(n(53850)),
          l = n(33661),
          u = n(17837),
          c = new Set(["style", "script", "xmp", "iframe", "noembed", "noframes", "plaintext", "noscript"]);
        function d(e) {
          return e.replace(/"/g, "&quot;");
        }
        var p = new Set(["area", "base", "basefont", "br", "col", "command", "embed", "frame", "hr", "img", "input", "isindex", "keygen", "link", "meta", "param", "source", "track", "wbr"]);
        function h(e, t) {
          void 0 === t && (t = {});
          for (var n = ("length" in e) ? e : [e], r = "", o = 0; o < n.length; o++) r += f(n[o], t);
          return r;
        }
        function f(e, t) {
          switch (e.type) {
            case s.Root:
              return h(e.children, t);
            case s.Doctype:
            case s.Directive:
              return "<".concat(e.data, ">");
            case s.Comment:
              return function (e) {
                return "\x3c!--".concat(e.data, "--\x3e");
              }(e);
            case s.CDATA:
              return function (e) {
                return "<![CDATA[".concat(e.children[0].data, "]]>");
              }(e);
            case s.Script:
            case s.Style:
            case s.Tag:
              return function (e, t) {
                var n;
                "foreign" === t.xmlMode && (e.name = null !== (n = u.elementNames.get(e.name)) && void 0 !== n ? n : e.name, e.parent && m.has(e.parent.name) && (t = r(r({}, t), {
                  xmlMode: !1
                })));
                !t.xmlMode && g.has(e.name) && (t = r(r({}, t), {
                  xmlMode: "foreign"
                }));
                var o = "<".concat(e.name),
                  i = function (e, t) {
                    var n;
                    if (e) {
                      var r = !1 === (null !== (n = t.encodeEntities) && void 0 !== n ? n : t.decodeEntities) ? d : t.xmlMode || "utf8" !== t.encodeEntities ? l.encodeXML : l.escapeAttribute;
                      return Object.keys(e).map(function (n) {
                        var o,
                          i,
                          a = null !== (o = e[n]) && void 0 !== o ? o : "";
                        return "foreign" === t.xmlMode && (n = null !== (i = u.attributeNames.get(n)) && void 0 !== i ? i : n), t.emptyAttrs || t.xmlMode || "" !== a ? "".concat(n, '="').concat(r(a), '"') : n;
                      }).join(" ");
                    }
                  }(e.attribs, t);
                i && (o += " ".concat(i));
                0 === e.children.length && (t.xmlMode ? !1 !== t.selfClosingTags : t.selfClosingTags && p.has(e.name)) ? (t.xmlMode || (o += " "), o += "/>") : (o += ">", e.children.length > 0 && (o += h(e.children, t)), !t.xmlMode && p.has(e.name) || (o += "</".concat(e.name, ">")));
                return o;
              }(e, t);
            case s.Text:
              return function (e, t) {
                var n,
                  r = e.data || "";
                !1 === (null !== (n = t.encodeEntities) && void 0 !== n ? n : t.decodeEntities) || !t.xmlMode && e.parent && c.has(e.parent.name) || (r = t.xmlMode || "utf8" !== t.encodeEntities ? (0, l.encodeXML)(r) : (0, l.escapeText)(r));
                return r;
              }(e, t);
          }
        }
        t.render = h, t.default = h;
        var m = new Set(["mi", "mo", "mn", "ms", "mtext", "annotation-xml", "foreignObject", "desc", "title"]),
          g = new Set(["svg", "math"]);
      },
      53850: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(n = t.ElementType || (t.ElementType = {})), t.isTag = function (e) {
          return e.type === n.Tag || e.type === n.Script || e.type === n.Style;
        }, t.Root = n.Root, t.Text = n.Text, t.Directive = n.Directive, t.Comment = n.Comment, t.Script = n.Script, t.Style = n.Style, t.Tag = n.Tag, t.CDATA = n.CDATA, t.Doctype = n.Doctype;
      },
      10901: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__setModuleDefault || (Object.create ? function (e, t) {
            Object.defineProperty(e, "default", {
              enumerable: !0,
              value: t
            });
          } : function (e, t) {
            e.default = t;
          }),
          i = this && this.__importStar || function (e) {
            if (e && e.__esModule) return e;
            var t = {};
            if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && r(t, e, n);
            return o(t, e), t;
          },
          a = this && this.__importDefault || function (e) {
            return e && e.__esModule ? e : {
              default: e
            };
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXML = t.decodeHTMLStrict = t.decodeHTMLAttribute = t.decodeHTML = t.determineBranch = t.EntityDecoder = t.DecodingMode = t.BinTrieFlags = t.fromCodePoint = t.replaceCodePoint = t.decodeCodePoint = t.xmlDecodeTree = t.htmlDecodeTree = void 0;
        var s = a(n(93588));
        t.htmlDecodeTree = s.default;
        var l = a(n(61279));
        t.xmlDecodeTree = l.default;
        var u = i(n(66312));
        t.decodeCodePoint = u.default;
        var c,
          d = n(66312);
        Object.defineProperty(t, "replaceCodePoint", {
          enumerable: !0,
          get: function () {
            return d.replaceCodePoint;
          }
        }), Object.defineProperty(t, "fromCodePoint", {
          enumerable: !0,
          get: function () {
            return d.fromCodePoint;
          }
        }), function (e) {
          e[e.NUM = 35] = "NUM", e[e.SEMI = 59] = "SEMI", e[e.EQUALS = 61] = "EQUALS", e[e.ZERO = 48] = "ZERO", e[e.NINE = 57] = "NINE", e[e.LOWER_A = 97] = "LOWER_A", e[e.LOWER_F = 102] = "LOWER_F", e[e.LOWER_X = 120] = "LOWER_X", e[e.LOWER_Z = 122] = "LOWER_Z", e[e.UPPER_A = 65] = "UPPER_A", e[e.UPPER_F = 70] = "UPPER_F", e[e.UPPER_Z = 90] = "UPPER_Z";
        }(c || (c = {}));
        var p, h, f;
        function m(e) {
          return e >= c.ZERO && e <= c.NINE;
        }
        function g(e) {
          return e === c.EQUALS || function (e) {
            return e >= c.UPPER_A && e <= c.UPPER_Z || e >= c.LOWER_A && e <= c.LOWER_Z || m(e);
          }(e);
        }
        !function (e) {
          e[e.VALUE_LENGTH = 49152] = "VALUE_LENGTH", e[e.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", e[e.JUMP_TABLE = 127] = "JUMP_TABLE";
        }(p = t.BinTrieFlags || (t.BinTrieFlags = {})), function (e) {
          e[e.EntityStart = 0] = "EntityStart", e[e.NumericStart = 1] = "NumericStart", e[e.NumericDecimal = 2] = "NumericDecimal", e[e.NumericHex = 3] = "NumericHex", e[e.NamedEntity = 4] = "NamedEntity";
        }(h || (h = {})), function (e) {
          e[e.Legacy = 0] = "Legacy", e[e.Strict = 1] = "Strict", e[e.Attribute = 2] = "Attribute";
        }(f = t.DecodingMode || (t.DecodingMode = {}));
        var v = function () {
          function e(e, t, n) {
            this.decodeTree = e, this.emitCodePoint = t, this.errors = n, this.state = h.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = f.Strict;
          }
          return e.prototype.startEntity = function (e) {
            this.decodeMode = e, this.state = h.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
          }, e.prototype.write = function (e, t) {
            switch (this.state) {
              case h.EntityStart:
                return e.charCodeAt(t) === c.NUM ? (this.state = h.NumericStart, this.consumed += 1, this.stateNumericStart(e, t + 1)) : (this.state = h.NamedEntity, this.stateNamedEntity(e, t));
              case h.NumericStart:
                return this.stateNumericStart(e, t);
              case h.NumericDecimal:
                return this.stateNumericDecimal(e, t);
              case h.NumericHex:
                return this.stateNumericHex(e, t);
              case h.NamedEntity:
                return this.stateNamedEntity(e, t);
            }
          }, e.prototype.stateNumericStart = function (e, t) {
            return t >= e.length ? -1 : (32 | e.charCodeAt(t)) === c.LOWER_X ? (this.state = h.NumericHex, this.consumed += 1, this.stateNumericHex(e, t + 1)) : (this.state = h.NumericDecimal, this.stateNumericDecimal(e, t));
          }, e.prototype.addToNumericResult = function (e, t, n, r) {
            if (t !== n) {
              var o = n - t;
              this.result = this.result * Math.pow(r, o) + parseInt(e.substr(t, o), r), this.consumed += o;
            }
          }, e.prototype.stateNumericHex = function (e, t) {
            for (var n, r = t; t < e.length;) {
              var o = e.charCodeAt(t);
              if (!(m(o) || (n = o, n >= c.UPPER_A && n <= c.UPPER_F || n >= c.LOWER_A && n <= c.LOWER_F))) return this.addToNumericResult(e, r, t, 16), this.emitNumericEntity(o, 3);
              t += 1;
            }
            return this.addToNumericResult(e, r, t, 16), -1;
          }, e.prototype.stateNumericDecimal = function (e, t) {
            for (var n = t; t < e.length;) {
              var r = e.charCodeAt(t);
              if (!m(r)) return this.addToNumericResult(e, n, t, 10), this.emitNumericEntity(r, 2);
              t += 1;
            }
            return this.addToNumericResult(e, n, t, 10), -1;
          }, e.prototype.emitNumericEntity = function (e, t) {
            var n;
            if (this.consumed <= t) return null === (n = this.errors) || void 0 === n || n.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
            if (e === c.SEMI) this.consumed += 1;else if (this.decodeMode === f.Strict) return 0;
            return this.emitCodePoint((0, u.replaceCodePoint)(this.result), this.consumed), this.errors && (e !== c.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
          }, e.prototype.stateNamedEntity = function (e, t) {
            for (var n = this.decodeTree, r = n[this.treeIndex], o = (r & p.VALUE_LENGTH) >> 14; t < e.length; t++, this.excess++) {
              var i = e.charCodeAt(t);
              if (this.treeIndex = b(n, r, this.treeIndex + Math.max(1, o), i), this.treeIndex < 0) return 0 === this.result || this.decodeMode === f.Attribute && (0 === o || g(i)) ? 0 : this.emitNotTerminatedNamedEntity();
              if (0 !== (o = ((r = n[this.treeIndex]) & p.VALUE_LENGTH) >> 14)) {
                if (i === c.SEMI) return this.emitNamedEntityData(this.treeIndex, o, this.consumed + this.excess);
                this.decodeMode !== f.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
              }
            }
            return -1;
          }, e.prototype.emitNotTerminatedNamedEntity = function () {
            var e,
              t = this.result,
              n = (this.decodeTree[t] & p.VALUE_LENGTH) >> 14;
            return this.emitNamedEntityData(t, n, this.consumed), null === (e = this.errors) || void 0 === e || e.missingSemicolonAfterCharacterReference(), this.consumed;
          }, e.prototype.emitNamedEntityData = function (e, t, n) {
            var r = this.decodeTree;
            return this.emitCodePoint(1 === t ? r[e] & ~p.VALUE_LENGTH : r[e + 1], n), 3 === t && this.emitCodePoint(r[e + 2], n), n;
          }, e.prototype.end = function () {
            var e;
            switch (this.state) {
              case h.NamedEntity:
                return 0 === this.result || this.decodeMode === f.Attribute && this.result !== this.treeIndex ? 0 : this.emitNotTerminatedNamedEntity();
              case h.NumericDecimal:
                return this.emitNumericEntity(0, 2);
              case h.NumericHex:
                return this.emitNumericEntity(0, 3);
              case h.NumericStart:
                return null === (e = this.errors) || void 0 === e || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
              case h.EntityStart:
                return 0;
            }
          }, e;
        }();
        function y(e) {
          var t = "",
            n = new v(e, function (e) {
              return t += (0, u.fromCodePoint)(e);
            });
          return function (e, r) {
            for (var o = 0, i = 0; (i = e.indexOf("&", i)) >= 0;) {
              t += e.slice(o, i), n.startEntity(r);
              var a = n.write(e, i + 1);
              if (a < 0) {
                o = i + n.end();
                break;
              }
              o = i + a, i = 0 === a ? o + 1 : o;
            }
            var s = t + e.slice(o);
            return t = "", s;
          };
        }
        function b(e, t, n, r) {
          var o = (t & p.BRANCH_LENGTH) >> 7,
            i = t & p.JUMP_TABLE;
          if (0 === o) return 0 !== i && r === i ? n : -1;
          if (i) {
            var a = r - i;
            return a < 0 || a >= o ? -1 : e[n + a] - 1;
          }
          for (var s = n, l = s + o - 1; s <= l;) {
            var u = s + l >>> 1,
              c = e[u];
            if (c < r) s = u + 1;else {
              if (!(c > r)) return e[u + o];
              l = u - 1;
            }
          }
          return -1;
        }
        t.EntityDecoder = v, t.determineBranch = b;
        var w = y(s.default),
          x = y(l.default);
        t.decodeHTML = function (e, t) {
          return void 0 === t && (t = f.Legacy), w(e, t);
        }, t.decodeHTMLAttribute = function (e) {
          return w(e, f.Attribute);
        }, t.decodeHTMLStrict = function (e) {
          return w(e, f.Strict);
        }, t.decodeXML = function (e) {
          return x(e, f.Strict);
        };
      },
      66312: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.replaceCodePoint = t.fromCodePoint = void 0;
        var r = new Map([[0, 65533], [128, 8364], [130, 8218], [131, 402], [132, 8222], [133, 8230], [134, 8224], [135, 8225], [136, 710], [137, 8240], [138, 352], [139, 8249], [140, 338], [142, 381], [145, 8216], [146, 8217], [147, 8220], [148, 8221], [149, 8226], [150, 8211], [151, 8212], [152, 732], [153, 8482], [154, 353], [155, 8250], [156, 339], [158, 382], [159, 376]]);
        function o(e) {
          var t;
          return e >= 55296 && e <= 57343 || e > 1114111 ? 65533 : null !== (t = r.get(e)) && void 0 !== t ? t : e;
        }
        t.fromCodePoint = null !== (n = String.fromCodePoint) && void 0 !== n ? n : function (e) {
          var t = "";
          return e > 65535 && (e -= 65536, t += String.fromCharCode(e >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), t += String.fromCharCode(e);
        }, t.replaceCodePoint = o, t.default = function (e) {
          return (0, t.fromCodePoint)(o(e));
        };
      },
      35278: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.encodeNonAsciiHTML = t.encodeHTML = void 0;
        var o = r(n(84086)),
          i = n(98881),
          a = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
        function s(e, t) {
          for (var n, r = "", a = 0; null !== (n = e.exec(t));) {
            var s = n.index;
            r += t.substring(a, s);
            var l = t.charCodeAt(s),
              u = o.default.get(l);
            if ("object" == typeof u) {
              if (s + 1 < t.length) {
                var c = t.charCodeAt(s + 1),
                  d = "number" == typeof u.n ? u.n === c ? u.o : void 0 : u.n.get(c);
                if (void 0 !== d) {
                  r += d, a = e.lastIndex += 1;
                  continue;
                }
              }
              u = u.v;
            }
            if (void 0 !== u) r += u, a = s + 1;else {
              var p = (0, i.getCodePoint)(t, s);
              r += "&#x".concat(p.toString(16), ";"), a = e.lastIndex += Number(p !== l);
            }
          }
          return r + t.substr(a);
        }
        t.encodeHTML = function (e) {
          return s(a, e);
        }, t.encodeNonAsciiHTML = function (e) {
          return s(i.xmlReplacer, e);
        };
      },
      98881: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.getCodePoint = t.xmlReplacer = void 0, t.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
        var n = new Map([[34, "&quot;"], [38, "&amp;"], [39, "&apos;"], [60, "&lt;"], [62, "&gt;"]]);
        function r(e) {
          for (var r, o = "", i = 0; null !== (r = t.xmlReplacer.exec(e));) {
            var a = r.index,
              s = e.charCodeAt(a),
              l = n.get(s);
            void 0 !== l ? (o += e.substring(i, a) + l, i = a + 1) : (o += "".concat(e.substring(i, a), "&#x").concat((0, t.getCodePoint)(e, a).toString(16), ";"), i = t.xmlReplacer.lastIndex += Number(55296 == (64512 & s)));
          }
          return o + e.substr(i);
        }
        function o(e, t) {
          return function (n) {
            for (var r, o = 0, i = ""; r = e.exec(n);) o !== r.index && (i += n.substring(o, r.index)), i += t.get(r[0].charCodeAt(0)), o = r.index + 1;
            return i + n.substring(o);
          };
        }
        t.getCodePoint = null != String.prototype.codePointAt ? function (e, t) {
          return e.codePointAt(t);
        } : function (e, t) {
          return 55296 == (64512 & e.charCodeAt(t)) ? 1024 * (e.charCodeAt(t) - 55296) + e.charCodeAt(t + 1) - 56320 + 65536 : e.charCodeAt(t);
        }, t.encodeXML = r, t.escape = r, t.escapeUTF8 = o(/[&<>'"]/g, n), t.escapeAttribute = o(/["&\u00A0]/g, new Map([[34, "&quot;"], [38, "&amp;"], [160, "&nbsp;"]])), t.escapeText = o(/[&<>\u00A0]/g, new Map([[38, "&amp;"], [60, "&lt;"], [62, "&gt;"], [160, "&nbsp;"]]));
      },
      93588: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array('ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map(function (e) {
          return e.charCodeAt(0);
        }));
      },
      61279: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Uint16Array("Ȁaglq\tɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map(function (e) {
          return e.charCodeAt(0);
        }));
      },
      84086: (e, t) => {
        "use strict";

        function n(e) {
          for (var t = 1; t < e.length; t++) e[t][0] += e[t - 1][0] + 1;
          return e;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = new Map(n([[9, "&Tab;"], [0, "&NewLine;"], [22, "&excl;"], [0, "&quot;"], [0, "&num;"], [0, "&dollar;"], [0, "&percnt;"], [0, "&amp;"], [0, "&apos;"], [0, "&lpar;"], [0, "&rpar;"], [0, "&ast;"], [0, "&plus;"], [0, "&comma;"], [1, "&period;"], [0, "&sol;"], [10, "&colon;"], [0, "&semi;"], [0, {
          v: "&lt;",
          n: 8402,
          o: "&nvlt;"
        }], [0, {
          v: "&equals;",
          n: 8421,
          o: "&bne;"
        }], [0, {
          v: "&gt;",
          n: 8402,
          o: "&nvgt;"
        }], [0, "&quest;"], [0, "&commat;"], [26, "&lbrack;"], [0, "&bsol;"], [0, "&rbrack;"], [0, "&Hat;"], [0, "&lowbar;"], [0, "&DiacriticalGrave;"], [5, {
          n: 106,
          o: "&fjlig;"
        }], [20, "&lbrace;"], [0, "&verbar;"], [0, "&rbrace;"], [34, "&nbsp;"], [0, "&iexcl;"], [0, "&cent;"], [0, "&pound;"], [0, "&curren;"], [0, "&yen;"], [0, "&brvbar;"], [0, "&sect;"], [0, "&die;"], [0, "&copy;"], [0, "&ordf;"], [0, "&laquo;"], [0, "&not;"], [0, "&shy;"], [0, "&circledR;"], [0, "&macr;"], [0, "&deg;"], [0, "&PlusMinus;"], [0, "&sup2;"], [0, "&sup3;"], [0, "&acute;"], [0, "&micro;"], [0, "&para;"], [0, "&centerdot;"], [0, "&cedil;"], [0, "&sup1;"], [0, "&ordm;"], [0, "&raquo;"], [0, "&frac14;"], [0, "&frac12;"], [0, "&frac34;"], [0, "&iquest;"], [0, "&Agrave;"], [0, "&Aacute;"], [0, "&Acirc;"], [0, "&Atilde;"], [0, "&Auml;"], [0, "&angst;"], [0, "&AElig;"], [0, "&Ccedil;"], [0, "&Egrave;"], [0, "&Eacute;"], [0, "&Ecirc;"], [0, "&Euml;"], [0, "&Igrave;"], [0, "&Iacute;"], [0, "&Icirc;"], [0, "&Iuml;"], [0, "&ETH;"], [0, "&Ntilde;"], [0, "&Ograve;"], [0, "&Oacute;"], [0, "&Ocirc;"], [0, "&Otilde;"], [0, "&Ouml;"], [0, "&times;"], [0, "&Oslash;"], [0, "&Ugrave;"], [0, "&Uacute;"], [0, "&Ucirc;"], [0, "&Uuml;"], [0, "&Yacute;"], [0, "&THORN;"], [0, "&szlig;"], [0, "&agrave;"], [0, "&aacute;"], [0, "&acirc;"], [0, "&atilde;"], [0, "&auml;"], [0, "&aring;"], [0, "&aelig;"], [0, "&ccedil;"], [0, "&egrave;"], [0, "&eacute;"], [0, "&ecirc;"], [0, "&euml;"], [0, "&igrave;"], [0, "&iacute;"], [0, "&icirc;"], [0, "&iuml;"], [0, "&eth;"], [0, "&ntilde;"], [0, "&ograve;"], [0, "&oacute;"], [0, "&ocirc;"], [0, "&otilde;"], [0, "&ouml;"], [0, "&div;"], [0, "&oslash;"], [0, "&ugrave;"], [0, "&uacute;"], [0, "&ucirc;"], [0, "&uuml;"], [0, "&yacute;"], [0, "&thorn;"], [0, "&yuml;"], [0, "&Amacr;"], [0, "&amacr;"], [0, "&Abreve;"], [0, "&abreve;"], [0, "&Aogon;"], [0, "&aogon;"], [0, "&Cacute;"], [0, "&cacute;"], [0, "&Ccirc;"], [0, "&ccirc;"], [0, "&Cdot;"], [0, "&cdot;"], [0, "&Ccaron;"], [0, "&ccaron;"], [0, "&Dcaron;"], [0, "&dcaron;"], [0, "&Dstrok;"], [0, "&dstrok;"], [0, "&Emacr;"], [0, "&emacr;"], [2, "&Edot;"], [0, "&edot;"], [0, "&Eogon;"], [0, "&eogon;"], [0, "&Ecaron;"], [0, "&ecaron;"], [0, "&Gcirc;"], [0, "&gcirc;"], [0, "&Gbreve;"], [0, "&gbreve;"], [0, "&Gdot;"], [0, "&gdot;"], [0, "&Gcedil;"], [1, "&Hcirc;"], [0, "&hcirc;"], [0, "&Hstrok;"], [0, "&hstrok;"], [0, "&Itilde;"], [0, "&itilde;"], [0, "&Imacr;"], [0, "&imacr;"], [2, "&Iogon;"], [0, "&iogon;"], [0, "&Idot;"], [0, "&imath;"], [0, "&IJlig;"], [0, "&ijlig;"], [0, "&Jcirc;"], [0, "&jcirc;"], [0, "&Kcedil;"], [0, "&kcedil;"], [0, "&kgreen;"], [0, "&Lacute;"], [0, "&lacute;"], [0, "&Lcedil;"], [0, "&lcedil;"], [0, "&Lcaron;"], [0, "&lcaron;"], [0, "&Lmidot;"], [0, "&lmidot;"], [0, "&Lstrok;"], [0, "&lstrok;"], [0, "&Nacute;"], [0, "&nacute;"], [0, "&Ncedil;"], [0, "&ncedil;"], [0, "&Ncaron;"], [0, "&ncaron;"], [0, "&napos;"], [0, "&ENG;"], [0, "&eng;"], [0, "&Omacr;"], [0, "&omacr;"], [2, "&Odblac;"], [0, "&odblac;"], [0, "&OElig;"], [0, "&oelig;"], [0, "&Racute;"], [0, "&racute;"], [0, "&Rcedil;"], [0, "&rcedil;"], [0, "&Rcaron;"], [0, "&rcaron;"], [0, "&Sacute;"], [0, "&sacute;"], [0, "&Scirc;"], [0, "&scirc;"], [0, "&Scedil;"], [0, "&scedil;"], [0, "&Scaron;"], [0, "&scaron;"], [0, "&Tcedil;"], [0, "&tcedil;"], [0, "&Tcaron;"], [0, "&tcaron;"], [0, "&Tstrok;"], [0, "&tstrok;"], [0, "&Utilde;"], [0, "&utilde;"], [0, "&Umacr;"], [0, "&umacr;"], [0, "&Ubreve;"], [0, "&ubreve;"], [0, "&Uring;"], [0, "&uring;"], [0, "&Udblac;"], [0, "&udblac;"], [0, "&Uogon;"], [0, "&uogon;"], [0, "&Wcirc;"], [0, "&wcirc;"], [0, "&Ycirc;"], [0, "&ycirc;"], [0, "&Yuml;"], [0, "&Zacute;"], [0, "&zacute;"], [0, "&Zdot;"], [0, "&zdot;"], [0, "&Zcaron;"], [0, "&zcaron;"], [19, "&fnof;"], [34, "&imped;"], [63, "&gacute;"], [65, "&jmath;"], [142, "&circ;"], [0, "&caron;"], [16, "&breve;"], [0, "&DiacriticalDot;"], [0, "&ring;"], [0, "&ogon;"], [0, "&DiacriticalTilde;"], [0, "&dblac;"], [51, "&DownBreve;"], [127, "&Alpha;"], [0, "&Beta;"], [0, "&Gamma;"], [0, "&Delta;"], [0, "&Epsilon;"], [0, "&Zeta;"], [0, "&Eta;"], [0, "&Theta;"], [0, "&Iota;"], [0, "&Kappa;"], [0, "&Lambda;"], [0, "&Mu;"], [0, "&Nu;"], [0, "&Xi;"], [0, "&Omicron;"], [0, "&Pi;"], [0, "&Rho;"], [1, "&Sigma;"], [0, "&Tau;"], [0, "&Upsilon;"], [0, "&Phi;"], [0, "&Chi;"], [0, "&Psi;"], [0, "&ohm;"], [7, "&alpha;"], [0, "&beta;"], [0, "&gamma;"], [0, "&delta;"], [0, "&epsi;"], [0, "&zeta;"], [0, "&eta;"], [0, "&theta;"], [0, "&iota;"], [0, "&kappa;"], [0, "&lambda;"], [0, "&mu;"], [0, "&nu;"], [0, "&xi;"], [0, "&omicron;"], [0, "&pi;"], [0, "&rho;"], [0, "&sigmaf;"], [0, "&sigma;"], [0, "&tau;"], [0, "&upsi;"], [0, "&phi;"], [0, "&chi;"], [0, "&psi;"], [0, "&omega;"], [7, "&thetasym;"], [0, "&Upsi;"], [2, "&phiv;"], [0, "&piv;"], [5, "&Gammad;"], [0, "&digamma;"], [18, "&kappav;"], [0, "&rhov;"], [3, "&epsiv;"], [0, "&backepsilon;"], [10, "&IOcy;"], [0, "&DJcy;"], [0, "&GJcy;"], [0, "&Jukcy;"], [0, "&DScy;"], [0, "&Iukcy;"], [0, "&YIcy;"], [0, "&Jsercy;"], [0, "&LJcy;"], [0, "&NJcy;"], [0, "&TSHcy;"], [0, "&KJcy;"], [1, "&Ubrcy;"], [0, "&DZcy;"], [0, "&Acy;"], [0, "&Bcy;"], [0, "&Vcy;"], [0, "&Gcy;"], [0, "&Dcy;"], [0, "&IEcy;"], [0, "&ZHcy;"], [0, "&Zcy;"], [0, "&Icy;"], [0, "&Jcy;"], [0, "&Kcy;"], [0, "&Lcy;"], [0, "&Mcy;"], [0, "&Ncy;"], [0, "&Ocy;"], [0, "&Pcy;"], [0, "&Rcy;"], [0, "&Scy;"], [0, "&Tcy;"], [0, "&Ucy;"], [0, "&Fcy;"], [0, "&KHcy;"], [0, "&TScy;"], [0, "&CHcy;"], [0, "&SHcy;"], [0, "&SHCHcy;"], [0, "&HARDcy;"], [0, "&Ycy;"], [0, "&SOFTcy;"], [0, "&Ecy;"], [0, "&YUcy;"], [0, "&YAcy;"], [0, "&acy;"], [0, "&bcy;"], [0, "&vcy;"], [0, "&gcy;"], [0, "&dcy;"], [0, "&iecy;"], [0, "&zhcy;"], [0, "&zcy;"], [0, "&icy;"], [0, "&jcy;"], [0, "&kcy;"], [0, "&lcy;"], [0, "&mcy;"], [0, "&ncy;"], [0, "&ocy;"], [0, "&pcy;"], [0, "&rcy;"], [0, "&scy;"], [0, "&tcy;"], [0, "&ucy;"], [0, "&fcy;"], [0, "&khcy;"], [0, "&tscy;"], [0, "&chcy;"], [0, "&shcy;"], [0, "&shchcy;"], [0, "&hardcy;"], [0, "&ycy;"], [0, "&softcy;"], [0, "&ecy;"], [0, "&yucy;"], [0, "&yacy;"], [1, "&iocy;"], [0, "&djcy;"], [0, "&gjcy;"], [0, "&jukcy;"], [0, "&dscy;"], [0, "&iukcy;"], [0, "&yicy;"], [0, "&jsercy;"], [0, "&ljcy;"], [0, "&njcy;"], [0, "&tshcy;"], [0, "&kjcy;"], [1, "&ubrcy;"], [0, "&dzcy;"], [7074, "&ensp;"], [0, "&emsp;"], [0, "&emsp13;"], [0, "&emsp14;"], [1, "&numsp;"], [0, "&puncsp;"], [0, "&ThinSpace;"], [0, "&hairsp;"], [0, "&NegativeMediumSpace;"], [0, "&zwnj;"], [0, "&zwj;"], [0, "&lrm;"], [0, "&rlm;"], [0, "&dash;"], [2, "&ndash;"], [0, "&mdash;"], [0, "&horbar;"], [0, "&Verbar;"], [1, "&lsquo;"], [0, "&CloseCurlyQuote;"], [0, "&lsquor;"], [1, "&ldquo;"], [0, "&CloseCurlyDoubleQuote;"], [0, "&bdquo;"], [1, "&dagger;"], [0, "&Dagger;"], [0, "&bull;"], [2, "&nldr;"], [0, "&hellip;"], [9, "&permil;"], [0, "&pertenk;"], [0, "&prime;"], [0, "&Prime;"], [0, "&tprime;"], [0, "&backprime;"], [3, "&lsaquo;"], [0, "&rsaquo;"], [3, "&oline;"], [2, "&caret;"], [1, "&hybull;"], [0, "&frasl;"], [10, "&bsemi;"], [7, "&qprime;"], [7, {
          v: "&MediumSpace;",
          n: 8202,
          o: "&ThickSpace;"
        }], [0, "&NoBreak;"], [0, "&af;"], [0, "&InvisibleTimes;"], [0, "&ic;"], [72, "&euro;"], [46, "&tdot;"], [0, "&DotDot;"], [37, "&complexes;"], [2, "&incare;"], [4, "&gscr;"], [0, "&hamilt;"], [0, "&Hfr;"], [0, "&Hopf;"], [0, "&planckh;"], [0, "&hbar;"], [0, "&imagline;"], [0, "&Ifr;"], [0, "&lagran;"], [0, "&ell;"], [1, "&naturals;"], [0, "&numero;"], [0, "&copysr;"], [0, "&weierp;"], [0, "&Popf;"], [0, "&Qopf;"], [0, "&realine;"], [0, "&real;"], [0, "&reals;"], [0, "&rx;"], [3, "&trade;"], [1, "&integers;"], [2, "&mho;"], [0, "&zeetrf;"], [0, "&iiota;"], [2, "&bernou;"], [0, "&Cayleys;"], [1, "&escr;"], [0, "&Escr;"], [0, "&Fouriertrf;"], [1, "&Mellintrf;"], [0, "&order;"], [0, "&alefsym;"], [0, "&beth;"], [0, "&gimel;"], [0, "&daleth;"], [12, "&CapitalDifferentialD;"], [0, "&dd;"], [0, "&ee;"], [0, "&ii;"], [10, "&frac13;"], [0, "&frac23;"], [0, "&frac15;"], [0, "&frac25;"], [0, "&frac35;"], [0, "&frac45;"], [0, "&frac16;"], [0, "&frac56;"], [0, "&frac18;"], [0, "&frac38;"], [0, "&frac58;"], [0, "&frac78;"], [49, "&larr;"], [0, "&ShortUpArrow;"], [0, "&rarr;"], [0, "&darr;"], [0, "&harr;"], [0, "&updownarrow;"], [0, "&nwarr;"], [0, "&nearr;"], [0, "&LowerRightArrow;"], [0, "&LowerLeftArrow;"], [0, "&nlarr;"], [0, "&nrarr;"], [1, {
          v: "&rarrw;",
          n: 824,
          o: "&nrarrw;"
        }], [0, "&Larr;"], [0, "&Uarr;"], [0, "&Rarr;"], [0, "&Darr;"], [0, "&larrtl;"], [0, "&rarrtl;"], [0, "&LeftTeeArrow;"], [0, "&mapstoup;"], [0, "&map;"], [0, "&DownTeeArrow;"], [1, "&hookleftarrow;"], [0, "&hookrightarrow;"], [0, "&larrlp;"], [0, "&looparrowright;"], [0, "&harrw;"], [0, "&nharr;"], [1, "&lsh;"], [0, "&rsh;"], [0, "&ldsh;"], [0, "&rdsh;"], [1, "&crarr;"], [0, "&cularr;"], [0, "&curarr;"], [2, "&circlearrowleft;"], [0, "&circlearrowright;"], [0, "&leftharpoonup;"], [0, "&DownLeftVector;"], [0, "&RightUpVector;"], [0, "&LeftUpVector;"], [0, "&rharu;"], [0, "&DownRightVector;"], [0, "&dharr;"], [0, "&dharl;"], [0, "&RightArrowLeftArrow;"], [0, "&udarr;"], [0, "&LeftArrowRightArrow;"], [0, "&leftleftarrows;"], [0, "&upuparrows;"], [0, "&rightrightarrows;"], [0, "&ddarr;"], [0, "&leftrightharpoons;"], [0, "&Equilibrium;"], [0, "&nlArr;"], [0, "&nhArr;"], [0, "&nrArr;"], [0, "&DoubleLeftArrow;"], [0, "&DoubleUpArrow;"], [0, "&DoubleRightArrow;"], [0, "&dArr;"], [0, "&DoubleLeftRightArrow;"], [0, "&DoubleUpDownArrow;"], [0, "&nwArr;"], [0, "&neArr;"], [0, "&seArr;"], [0, "&swArr;"], [0, "&lAarr;"], [0, "&rAarr;"], [1, "&zigrarr;"], [6, "&larrb;"], [0, "&rarrb;"], [15, "&DownArrowUpArrow;"], [7, "&loarr;"], [0, "&roarr;"], [0, "&hoarr;"], [0, "&forall;"], [0, "&comp;"], [0, {
          v: "&part;",
          n: 824,
          o: "&npart;"
        }], [0, "&exist;"], [0, "&nexist;"], [0, "&empty;"], [1, "&Del;"], [0, "&Element;"], [0, "&NotElement;"], [1, "&ni;"], [0, "&notni;"], [2, "&prod;"], [0, "&coprod;"], [0, "&sum;"], [0, "&minus;"], [0, "&MinusPlus;"], [0, "&dotplus;"], [1, "&Backslash;"], [0, "&lowast;"], [0, "&compfn;"], [1, "&radic;"], [2, "&prop;"], [0, "&infin;"], [0, "&angrt;"], [0, {
          v: "&ang;",
          n: 8402,
          o: "&nang;"
        }], [0, "&angmsd;"], [0, "&angsph;"], [0, "&mid;"], [0, "&nmid;"], [0, "&DoubleVerticalBar;"], [0, "&NotDoubleVerticalBar;"], [0, "&and;"], [0, "&or;"], [0, {
          v: "&cap;",
          n: 65024,
          o: "&caps;"
        }], [0, {
          v: "&cup;",
          n: 65024,
          o: "&cups;"
        }], [0, "&int;"], [0, "&Int;"], [0, "&iiint;"], [0, "&conint;"], [0, "&Conint;"], [0, "&Cconint;"], [0, "&cwint;"], [0, "&ClockwiseContourIntegral;"], [0, "&awconint;"], [0, "&there4;"], [0, "&becaus;"], [0, "&ratio;"], [0, "&Colon;"], [0, "&dotminus;"], [1, "&mDDot;"], [0, "&homtht;"], [0, {
          v: "&sim;",
          n: 8402,
          o: "&nvsim;"
        }], [0, {
          v: "&backsim;",
          n: 817,
          o: "&race;"
        }], [0, {
          v: "&ac;",
          n: 819,
          o: "&acE;"
        }], [0, "&acd;"], [0, "&VerticalTilde;"], [0, "&NotTilde;"], [0, {
          v: "&eqsim;",
          n: 824,
          o: "&nesim;"
        }], [0, "&sime;"], [0, "&NotTildeEqual;"], [0, "&cong;"], [0, "&simne;"], [0, "&ncong;"], [0, "&ap;"], [0, "&nap;"], [0, "&ape;"], [0, {
          v: "&apid;",
          n: 824,
          o: "&napid;"
        }], [0, "&backcong;"], [0, {
          v: "&asympeq;",
          n: 8402,
          o: "&nvap;"
        }], [0, {
          v: "&bump;",
          n: 824,
          o: "&nbump;"
        }], [0, {
          v: "&bumpe;",
          n: 824,
          o: "&nbumpe;"
        }], [0, {
          v: "&doteq;",
          n: 824,
          o: "&nedot;"
        }], [0, "&doteqdot;"], [0, "&efDot;"], [0, "&erDot;"], [0, "&Assign;"], [0, "&ecolon;"], [0, "&ecir;"], [0, "&circeq;"], [1, "&wedgeq;"], [0, "&veeeq;"], [1, "&triangleq;"], [2, "&equest;"], [0, "&ne;"], [0, {
          v: "&Congruent;",
          n: 8421,
          o: "&bnequiv;"
        }], [0, "&nequiv;"], [1, {
          v: "&le;",
          n: 8402,
          o: "&nvle;"
        }], [0, {
          v: "&ge;",
          n: 8402,
          o: "&nvge;"
        }], [0, {
          v: "&lE;",
          n: 824,
          o: "&nlE;"
        }], [0, {
          v: "&gE;",
          n: 824,
          o: "&ngE;"
        }], [0, {
          v: "&lnE;",
          n: 65024,
          o: "&lvertneqq;"
        }], [0, {
          v: "&gnE;",
          n: 65024,
          o: "&gvertneqq;"
        }], [0, {
          v: "&ll;",
          n: new Map(n([[824, "&nLtv;"], [7577, "&nLt;"]]))
        }], [0, {
          v: "&gg;",
          n: new Map(n([[824, "&nGtv;"], [7577, "&nGt;"]]))
        }], [0, "&between;"], [0, "&NotCupCap;"], [0, "&nless;"], [0, "&ngt;"], [0, "&nle;"], [0, "&nge;"], [0, "&lesssim;"], [0, "&GreaterTilde;"], [0, "&nlsim;"], [0, "&ngsim;"], [0, "&LessGreater;"], [0, "&gl;"], [0, "&NotLessGreater;"], [0, "&NotGreaterLess;"], [0, "&pr;"], [0, "&sc;"], [0, "&prcue;"], [0, "&sccue;"], [0, "&PrecedesTilde;"], [0, {
          v: "&scsim;",
          n: 824,
          o: "&NotSucceedsTilde;"
        }], [0, "&NotPrecedes;"], [0, "&NotSucceeds;"], [0, {
          v: "&sub;",
          n: 8402,
          o: "&NotSubset;"
        }], [0, {
          v: "&sup;",
          n: 8402,
          o: "&NotSuperset;"
        }], [0, "&nsub;"], [0, "&nsup;"], [0, "&sube;"], [0, "&supe;"], [0, "&NotSubsetEqual;"], [0, "&NotSupersetEqual;"], [0, {
          v: "&subne;",
          n: 65024,
          o: "&varsubsetneq;"
        }], [0, {
          v: "&supne;",
          n: 65024,
          o: "&varsupsetneq;"
        }], [1, "&cupdot;"], [0, "&UnionPlus;"], [0, {
          v: "&sqsub;",
          n: 824,
          o: "&NotSquareSubset;"
        }], [0, {
          v: "&sqsup;",
          n: 824,
          o: "&NotSquareSuperset;"
        }], [0, "&sqsube;"], [0, "&sqsupe;"], [0, {
          v: "&sqcap;",
          n: 65024,
          o: "&sqcaps;"
        }], [0, {
          v: "&sqcup;",
          n: 65024,
          o: "&sqcups;"
        }], [0, "&CirclePlus;"], [0, "&CircleMinus;"], [0, "&CircleTimes;"], [0, "&osol;"], [0, "&CircleDot;"], [0, "&circledcirc;"], [0, "&circledast;"], [1, "&circleddash;"], [0, "&boxplus;"], [0, "&boxminus;"], [0, "&boxtimes;"], [0, "&dotsquare;"], [0, "&RightTee;"], [0, "&dashv;"], [0, "&DownTee;"], [0, "&bot;"], [1, "&models;"], [0, "&DoubleRightTee;"], [0, "&Vdash;"], [0, "&Vvdash;"], [0, "&VDash;"], [0, "&nvdash;"], [0, "&nvDash;"], [0, "&nVdash;"], [0, "&nVDash;"], [0, "&prurel;"], [1, "&LeftTriangle;"], [0, "&RightTriangle;"], [0, {
          v: "&LeftTriangleEqual;",
          n: 8402,
          o: "&nvltrie;"
        }], [0, {
          v: "&RightTriangleEqual;",
          n: 8402,
          o: "&nvrtrie;"
        }], [0, "&origof;"], [0, "&imof;"], [0, "&multimap;"], [0, "&hercon;"], [0, "&intcal;"], [0, "&veebar;"], [1, "&barvee;"], [0, "&angrtvb;"], [0, "&lrtri;"], [0, "&bigwedge;"], [0, "&bigvee;"], [0, "&bigcap;"], [0, "&bigcup;"], [0, "&diam;"], [0, "&sdot;"], [0, "&sstarf;"], [0, "&divideontimes;"], [0, "&bowtie;"], [0, "&ltimes;"], [0, "&rtimes;"], [0, "&leftthreetimes;"], [0, "&rightthreetimes;"], [0, "&backsimeq;"], [0, "&curlyvee;"], [0, "&curlywedge;"], [0, "&Sub;"], [0, "&Sup;"], [0, "&Cap;"], [0, "&Cup;"], [0, "&fork;"], [0, "&epar;"], [0, "&lessdot;"], [0, "&gtdot;"], [0, {
          v: "&Ll;",
          n: 824,
          o: "&nLl;"
        }], [0, {
          v: "&Gg;",
          n: 824,
          o: "&nGg;"
        }], [0, {
          v: "&leg;",
          n: 65024,
          o: "&lesg;"
        }], [0, {
          v: "&gel;",
          n: 65024,
          o: "&gesl;"
        }], [2, "&cuepr;"], [0, "&cuesc;"], [0, "&NotPrecedesSlantEqual;"], [0, "&NotSucceedsSlantEqual;"], [0, "&NotSquareSubsetEqual;"], [0, "&NotSquareSupersetEqual;"], [2, "&lnsim;"], [0, "&gnsim;"], [0, "&precnsim;"], [0, "&scnsim;"], [0, "&nltri;"], [0, "&NotRightTriangle;"], [0, "&nltrie;"], [0, "&NotRightTriangleEqual;"], [0, "&vellip;"], [0, "&ctdot;"], [0, "&utdot;"], [0, "&dtdot;"], [0, "&disin;"], [0, "&isinsv;"], [0, "&isins;"], [0, {
          v: "&isindot;",
          n: 824,
          o: "&notindot;"
        }], [0, "&notinvc;"], [0, "&notinvb;"], [1, {
          v: "&isinE;",
          n: 824,
          o: "&notinE;"
        }], [0, "&nisd;"], [0, "&xnis;"], [0, "&nis;"], [0, "&notnivc;"], [0, "&notnivb;"], [6, "&barwed;"], [0, "&Barwed;"], [1, "&lceil;"], [0, "&rceil;"], [0, "&LeftFloor;"], [0, "&rfloor;"], [0, "&drcrop;"], [0, "&dlcrop;"], [0, "&urcrop;"], [0, "&ulcrop;"], [0, "&bnot;"], [1, "&profline;"], [0, "&profsurf;"], [1, "&telrec;"], [0, "&target;"], [5, "&ulcorn;"], [0, "&urcorn;"], [0, "&dlcorn;"], [0, "&drcorn;"], [2, "&frown;"], [0, "&smile;"], [9, "&cylcty;"], [0, "&profalar;"], [7, "&topbot;"], [6, "&ovbar;"], [1, "&solbar;"], [60, "&angzarr;"], [51, "&lmoustache;"], [0, "&rmoustache;"], [2, "&OverBracket;"], [0, "&bbrk;"], [0, "&bbrktbrk;"], [37, "&OverParenthesis;"], [0, "&UnderParenthesis;"], [0, "&OverBrace;"], [0, "&UnderBrace;"], [2, "&trpezium;"], [4, "&elinters;"], [59, "&blank;"], [164, "&circledS;"], [55, "&boxh;"], [1, "&boxv;"], [9, "&boxdr;"], [3, "&boxdl;"], [3, "&boxur;"], [3, "&boxul;"], [3, "&boxvr;"], [7, "&boxvl;"], [7, "&boxhd;"], [7, "&boxhu;"], [7, "&boxvh;"], [19, "&boxH;"], [0, "&boxV;"], [0, "&boxdR;"], [0, "&boxDr;"], [0, "&boxDR;"], [0, "&boxdL;"], [0, "&boxDl;"], [0, "&boxDL;"], [0, "&boxuR;"], [0, "&boxUr;"], [0, "&boxUR;"], [0, "&boxuL;"], [0, "&boxUl;"], [0, "&boxUL;"], [0, "&boxvR;"], [0, "&boxVr;"], [0, "&boxVR;"], [0, "&boxvL;"], [0, "&boxVl;"], [0, "&boxVL;"], [0, "&boxHd;"], [0, "&boxhD;"], [0, "&boxHD;"], [0, "&boxHu;"], [0, "&boxhU;"], [0, "&boxHU;"], [0, "&boxvH;"], [0, "&boxVh;"], [0, "&boxVH;"], [19, "&uhblk;"], [3, "&lhblk;"], [3, "&block;"], [8, "&blk14;"], [0, "&blk12;"], [0, "&blk34;"], [13, "&square;"], [8, "&blacksquare;"], [0, "&EmptyVerySmallSquare;"], [1, "&rect;"], [0, "&marker;"], [2, "&fltns;"], [1, "&bigtriangleup;"], [0, "&blacktriangle;"], [0, "&triangle;"], [2, "&blacktriangleright;"], [0, "&rtri;"], [3, "&bigtriangledown;"], [0, "&blacktriangledown;"], [0, "&dtri;"], [2, "&blacktriangleleft;"], [0, "&ltri;"], [6, "&loz;"], [0, "&cir;"], [32, "&tridot;"], [2, "&bigcirc;"], [8, "&ultri;"], [0, "&urtri;"], [0, "&lltri;"], [0, "&EmptySmallSquare;"], [0, "&FilledSmallSquare;"], [8, "&bigstar;"], [0, "&star;"], [7, "&phone;"], [49, "&female;"], [1, "&male;"], [29, "&spades;"], [2, "&clubs;"], [1, "&hearts;"], [0, "&diamondsuit;"], [3, "&sung;"], [2, "&flat;"], [0, "&natural;"], [0, "&sharp;"], [163, "&check;"], [3, "&cross;"], [8, "&malt;"], [21, "&sext;"], [33, "&VerticalSeparator;"], [25, "&lbbrk;"], [0, "&rbbrk;"], [84, "&bsolhsub;"], [0, "&suphsol;"], [28, "&LeftDoubleBracket;"], [0, "&RightDoubleBracket;"], [0, "&lang;"], [0, "&rang;"], [0, "&Lang;"], [0, "&Rang;"], [0, "&loang;"], [0, "&roang;"], [7, "&longleftarrow;"], [0, "&longrightarrow;"], [0, "&longleftrightarrow;"], [0, "&DoubleLongLeftArrow;"], [0, "&DoubleLongRightArrow;"], [0, "&DoubleLongLeftRightArrow;"], [1, "&longmapsto;"], [2, "&dzigrarr;"], [258, "&nvlArr;"], [0, "&nvrArr;"], [0, "&nvHarr;"], [0, "&Map;"], [6, "&lbarr;"], [0, "&bkarow;"], [0, "&lBarr;"], [0, "&dbkarow;"], [0, "&drbkarow;"], [0, "&DDotrahd;"], [0, "&UpArrowBar;"], [0, "&DownArrowBar;"], [2, "&Rarrtl;"], [2, "&latail;"], [0, "&ratail;"], [0, "&lAtail;"], [0, "&rAtail;"], [0, "&larrfs;"], [0, "&rarrfs;"], [0, "&larrbfs;"], [0, "&rarrbfs;"], [2, "&nwarhk;"], [0, "&nearhk;"], [0, "&hksearow;"], [0, "&hkswarow;"], [0, "&nwnear;"], [0, "&nesear;"], [0, "&seswar;"], [0, "&swnwar;"], [8, {
          v: "&rarrc;",
          n: 824,
          o: "&nrarrc;"
        }], [1, "&cudarrr;"], [0, "&ldca;"], [0, "&rdca;"], [0, "&cudarrl;"], [0, "&larrpl;"], [2, "&curarrm;"], [0, "&cularrp;"], [7, "&rarrpl;"], [2, "&harrcir;"], [0, "&Uarrocir;"], [0, "&lurdshar;"], [0, "&ldrushar;"], [2, "&LeftRightVector;"], [0, "&RightUpDownVector;"], [0, "&DownLeftRightVector;"], [0, "&LeftUpDownVector;"], [0, "&LeftVectorBar;"], [0, "&RightVectorBar;"], [0, "&RightUpVectorBar;"], [0, "&RightDownVectorBar;"], [0, "&DownLeftVectorBar;"], [0, "&DownRightVectorBar;"], [0, "&LeftUpVectorBar;"], [0, "&LeftDownVectorBar;"], [0, "&LeftTeeVector;"], [0, "&RightTeeVector;"], [0, "&RightUpTeeVector;"], [0, "&RightDownTeeVector;"], [0, "&DownLeftTeeVector;"], [0, "&DownRightTeeVector;"], [0, "&LeftUpTeeVector;"], [0, "&LeftDownTeeVector;"], [0, "&lHar;"], [0, "&uHar;"], [0, "&rHar;"], [0, "&dHar;"], [0, "&luruhar;"], [0, "&ldrdhar;"], [0, "&ruluhar;"], [0, "&rdldhar;"], [0, "&lharul;"], [0, "&llhard;"], [0, "&rharul;"], [0, "&lrhard;"], [0, "&udhar;"], [0, "&duhar;"], [0, "&RoundImplies;"], [0, "&erarr;"], [0, "&simrarr;"], [0, "&larrsim;"], [0, "&rarrsim;"], [0, "&rarrap;"], [0, "&ltlarr;"], [1, "&gtrarr;"], [0, "&subrarr;"], [1, "&suplarr;"], [0, "&lfisht;"], [0, "&rfisht;"], [0, "&ufisht;"], [0, "&dfisht;"], [5, "&lopar;"], [0, "&ropar;"], [4, "&lbrke;"], [0, "&rbrke;"], [0, "&lbrkslu;"], [0, "&rbrksld;"], [0, "&lbrksld;"], [0, "&rbrkslu;"], [0, "&langd;"], [0, "&rangd;"], [0, "&lparlt;"], [0, "&rpargt;"], [0, "&gtlPar;"], [0, "&ltrPar;"], [3, "&vzigzag;"], [1, "&vangrt;"], [0, "&angrtvbd;"], [6, "&ange;"], [0, "&range;"], [0, "&dwangle;"], [0, "&uwangle;"], [0, "&angmsdaa;"], [0, "&angmsdab;"], [0, "&angmsdac;"], [0, "&angmsdad;"], [0, "&angmsdae;"], [0, "&angmsdaf;"], [0, "&angmsdag;"], [0, "&angmsdah;"], [0, "&bemptyv;"], [0, "&demptyv;"], [0, "&cemptyv;"], [0, "&raemptyv;"], [0, "&laemptyv;"], [0, "&ohbar;"], [0, "&omid;"], [0, "&opar;"], [1, "&operp;"], [1, "&olcross;"], [0, "&odsold;"], [1, "&olcir;"], [0, "&ofcir;"], [0, "&olt;"], [0, "&ogt;"], [0, "&cirscir;"], [0, "&cirE;"], [0, "&solb;"], [0, "&bsolb;"], [3, "&boxbox;"], [3, "&trisb;"], [0, "&rtriltri;"], [0, {
          v: "&LeftTriangleBar;",
          n: 824,
          o: "&NotLeftTriangleBar;"
        }], [0, {
          v: "&RightTriangleBar;",
          n: 824,
          o: "&NotRightTriangleBar;"
        }], [11, "&iinfin;"], [0, "&infintie;"], [0, "&nvinfin;"], [4, "&eparsl;"], [0, "&smeparsl;"], [0, "&eqvparsl;"], [5, "&blacklozenge;"], [8, "&RuleDelayed;"], [1, "&dsol;"], [9, "&bigodot;"], [0, "&bigoplus;"], [0, "&bigotimes;"], [1, "&biguplus;"], [1, "&bigsqcup;"], [5, "&iiiint;"], [0, "&fpartint;"], [2, "&cirfnint;"], [0, "&awint;"], [0, "&rppolint;"], [0, "&scpolint;"], [0, "&npolint;"], [0, "&pointint;"], [0, "&quatint;"], [0, "&intlarhk;"], [10, "&pluscir;"], [0, "&plusacir;"], [0, "&simplus;"], [0, "&plusdu;"], [0, "&plussim;"], [0, "&plustwo;"], [1, "&mcomma;"], [0, "&minusdu;"], [2, "&loplus;"], [0, "&roplus;"], [0, "&Cross;"], [0, "&timesd;"], [0, "&timesbar;"], [1, "&smashp;"], [0, "&lotimes;"], [0, "&rotimes;"], [0, "&otimesas;"], [0, "&Otimes;"], [0, "&odiv;"], [0, "&triplus;"], [0, "&triminus;"], [0, "&tritime;"], [0, "&intprod;"], [2, "&amalg;"], [0, "&capdot;"], [1, "&ncup;"], [0, "&ncap;"], [0, "&capand;"], [0, "&cupor;"], [0, "&cupcap;"], [0, "&capcup;"], [0, "&cupbrcap;"], [0, "&capbrcup;"], [0, "&cupcup;"], [0, "&capcap;"], [0, "&ccups;"], [0, "&ccaps;"], [2, "&ccupssm;"], [2, "&And;"], [0, "&Or;"], [0, "&andand;"], [0, "&oror;"], [0, "&orslope;"], [0, "&andslope;"], [1, "&andv;"], [0, "&orv;"], [0, "&andd;"], [0, "&ord;"], [1, "&wedbar;"], [6, "&sdote;"], [3, "&simdot;"], [2, {
          v: "&congdot;",
          n: 824,
          o: "&ncongdot;"
        }], [0, "&easter;"], [0, "&apacir;"], [0, {
          v: "&apE;",
          n: 824,
          o: "&napE;"
        }], [0, "&eplus;"], [0, "&pluse;"], [0, "&Esim;"], [0, "&Colone;"], [0, "&Equal;"], [1, "&ddotseq;"], [0, "&equivDD;"], [0, "&ltcir;"], [0, "&gtcir;"], [0, "&ltquest;"], [0, "&gtquest;"], [0, {
          v: "&leqslant;",
          n: 824,
          o: "&nleqslant;"
        }], [0, {
          v: "&geqslant;",
          n: 824,
          o: "&ngeqslant;"
        }], [0, "&lesdot;"], [0, "&gesdot;"], [0, "&lesdoto;"], [0, "&gesdoto;"], [0, "&lesdotor;"], [0, "&gesdotol;"], [0, "&lap;"], [0, "&gap;"], [0, "&lne;"], [0, "&gne;"], [0, "&lnap;"], [0, "&gnap;"], [0, "&lEg;"], [0, "&gEl;"], [0, "&lsime;"], [0, "&gsime;"], [0, "&lsimg;"], [0, "&gsiml;"], [0, "&lgE;"], [0, "&glE;"], [0, "&lesges;"], [0, "&gesles;"], [0, "&els;"], [0, "&egs;"], [0, "&elsdot;"], [0, "&egsdot;"], [0, "&el;"], [0, "&eg;"], [2, "&siml;"], [0, "&simg;"], [0, "&simlE;"], [0, "&simgE;"], [0, {
          v: "&LessLess;",
          n: 824,
          o: "&NotNestedLessLess;"
        }], [0, {
          v: "&GreaterGreater;",
          n: 824,
          o: "&NotNestedGreaterGreater;"
        }], [1, "&glj;"], [0, "&gla;"], [0, "&ltcc;"], [0, "&gtcc;"], [0, "&lescc;"], [0, "&gescc;"], [0, "&smt;"], [0, "&lat;"], [0, {
          v: "&smte;",
          n: 65024,
          o: "&smtes;"
        }], [0, {
          v: "&late;",
          n: 65024,
          o: "&lates;"
        }], [0, "&bumpE;"], [0, {
          v: "&PrecedesEqual;",
          n: 824,
          o: "&NotPrecedesEqual;"
        }], [0, {
          v: "&sce;",
          n: 824,
          o: "&NotSucceedsEqual;"
        }], [2, "&prE;"], [0, "&scE;"], [0, "&precneqq;"], [0, "&scnE;"], [0, "&prap;"], [0, "&scap;"], [0, "&precnapprox;"], [0, "&scnap;"], [0, "&Pr;"], [0, "&Sc;"], [0, "&subdot;"], [0, "&supdot;"], [0, "&subplus;"], [0, "&supplus;"], [0, "&submult;"], [0, "&supmult;"], [0, "&subedot;"], [0, "&supedot;"], [0, {
          v: "&subE;",
          n: 824,
          o: "&nsubE;"
        }], [0, {
          v: "&supE;",
          n: 824,
          o: "&nsupE;"
        }], [0, "&subsim;"], [0, "&supsim;"], [2, {
          v: "&subnE;",
          n: 65024,
          o: "&varsubsetneqq;"
        }], [0, {
          v: "&supnE;",
          n: 65024,
          o: "&varsupsetneqq;"
        }], [2, "&csub;"], [0, "&csup;"], [0, "&csube;"], [0, "&csupe;"], [0, "&subsup;"], [0, "&supsub;"], [0, "&subsub;"], [0, "&supsup;"], [0, "&suphsub;"], [0, "&supdsub;"], [0, "&forkv;"], [0, "&topfork;"], [0, "&mlcp;"], [8, "&Dashv;"], [1, "&Vdashl;"], [0, "&Barv;"], [0, "&vBar;"], [0, "&vBarv;"], [1, "&Vbar;"], [0, "&Not;"], [0, "&bNot;"], [0, "&rnmid;"], [0, "&cirmid;"], [0, "&midcir;"], [0, "&topcir;"], [0, "&nhpar;"], [0, "&parsim;"], [9, {
          v: "&parsl;",
          n: 8421,
          o: "&nparsl;"
        }], [44343, {
          n: new Map(n([[56476, "&Ascr;"], [1, "&Cscr;"], [0, "&Dscr;"], [2, "&Gscr;"], [2, "&Jscr;"], [0, "&Kscr;"], [2, "&Nscr;"], [0, "&Oscr;"], [0, "&Pscr;"], [0, "&Qscr;"], [1, "&Sscr;"], [0, "&Tscr;"], [0, "&Uscr;"], [0, "&Vscr;"], [0, "&Wscr;"], [0, "&Xscr;"], [0, "&Yscr;"], [0, "&Zscr;"], [0, "&ascr;"], [0, "&bscr;"], [0, "&cscr;"], [0, "&dscr;"], [1, "&fscr;"], [1, "&hscr;"], [0, "&iscr;"], [0, "&jscr;"], [0, "&kscr;"], [0, "&lscr;"], [0, "&mscr;"], [0, "&nscr;"], [1, "&pscr;"], [0, "&qscr;"], [0, "&rscr;"], [0, "&sscr;"], [0, "&tscr;"], [0, "&uscr;"], [0, "&vscr;"], [0, "&wscr;"], [0, "&xscr;"], [0, "&yscr;"], [0, "&zscr;"], [52, "&Afr;"], [0, "&Bfr;"], [1, "&Dfr;"], [0, "&Efr;"], [0, "&Ffr;"], [0, "&Gfr;"], [2, "&Jfr;"], [0, "&Kfr;"], [0, "&Lfr;"], [0, "&Mfr;"], [0, "&Nfr;"], [0, "&Ofr;"], [0, "&Pfr;"], [0, "&Qfr;"], [1, "&Sfr;"], [0, "&Tfr;"], [0, "&Ufr;"], [0, "&Vfr;"], [0, "&Wfr;"], [0, "&Xfr;"], [0, "&Yfr;"], [1, "&afr;"], [0, "&bfr;"], [0, "&cfr;"], [0, "&dfr;"], [0, "&efr;"], [0, "&ffr;"], [0, "&gfr;"], [0, "&hfr;"], [0, "&ifr;"], [0, "&jfr;"], [0, "&kfr;"], [0, "&lfr;"], [0, "&mfr;"], [0, "&nfr;"], [0, "&ofr;"], [0, "&pfr;"], [0, "&qfr;"], [0, "&rfr;"], [0, "&sfr;"], [0, "&tfr;"], [0, "&ufr;"], [0, "&vfr;"], [0, "&wfr;"], [0, "&xfr;"], [0, "&yfr;"], [0, "&zfr;"], [0, "&Aopf;"], [0, "&Bopf;"], [1, "&Dopf;"], [0, "&Eopf;"], [0, "&Fopf;"], [0, "&Gopf;"], [1, "&Iopf;"], [0, "&Jopf;"], [0, "&Kopf;"], [0, "&Lopf;"], [0, "&Mopf;"], [1, "&Oopf;"], [3, "&Sopf;"], [0, "&Topf;"], [0, "&Uopf;"], [0, "&Vopf;"], [0, "&Wopf;"], [0, "&Xopf;"], [0, "&Yopf;"], [1, "&aopf;"], [0, "&bopf;"], [0, "&copf;"], [0, "&dopf;"], [0, "&eopf;"], [0, "&fopf;"], [0, "&gopf;"], [0, "&hopf;"], [0, "&iopf;"], [0, "&jopf;"], [0, "&kopf;"], [0, "&lopf;"], [0, "&mopf;"], [0, "&nopf;"], [0, "&oopf;"], [0, "&popf;"], [0, "&qopf;"], [0, "&ropf;"], [0, "&sopf;"], [0, "&topf;"], [0, "&uopf;"], [0, "&vopf;"], [0, "&wopf;"], [0, "&xopf;"], [0, "&yopf;"], [0, "&zopf;"]]))
        }], [8906, "&fflig;"], [0, "&filig;"], [0, "&fllig;"], [0, "&ffilig;"], [0, "&ffllig;"]]));
      },
      33661: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.decodeXMLStrict = t.decodeHTML5Strict = t.decodeHTML4Strict = t.decodeHTML5 = t.decodeHTML4 = t.decodeHTMLAttribute = t.decodeHTMLStrict = t.decodeHTML = t.decodeXML = t.DecodingMode = t.EntityDecoder = t.encodeHTML5 = t.encodeHTML4 = t.encodeNonAsciiHTML = t.encodeHTML = t.escapeText = t.escapeAttribute = t.escapeUTF8 = t.escape = t.encodeXML = t.encode = t.decodeStrict = t.decode = t.EncodingMode = t.EntityLevel = void 0;
        var r,
          o,
          i = n(10901),
          a = n(35278),
          s = n(98881);
        function l(e, t) {
          if (void 0 === t && (t = r.XML), ("number" == typeof t ? t : t.level) === r.HTML) {
            var n = "object" == typeof t ? t.mode : void 0;
            return (0, i.decodeHTML)(e, n);
          }
          return (0, i.decodeXML)(e);
        }
        !function (e) {
          e[e.XML = 0] = "XML", e[e.HTML = 1] = "HTML";
        }(r = t.EntityLevel || (t.EntityLevel = {})), function (e) {
          e[e.UTF8 = 0] = "UTF8", e[e.ASCII = 1] = "ASCII", e[e.Extensive = 2] = "Extensive", e[e.Attribute = 3] = "Attribute", e[e.Text = 4] = "Text";
        }(o = t.EncodingMode || (t.EncodingMode = {})), t.decode = l, t.decodeStrict = function (e, t) {
          var n;
          void 0 === t && (t = r.XML);
          var o = "number" == typeof t ? {
            level: t
          } : t;
          return null !== (n = o.mode) && void 0 !== n || (o.mode = i.DecodingMode.Strict), l(e, o);
        }, t.encode = function (e, t) {
          void 0 === t && (t = r.XML);
          var n = "number" == typeof t ? {
            level: t
          } : t;
          return n.mode === o.UTF8 ? (0, s.escapeUTF8)(e) : n.mode === o.Attribute ? (0, s.escapeAttribute)(e) : n.mode === o.Text ? (0, s.escapeText)(e) : n.level === r.HTML ? n.mode === o.ASCII ? (0, a.encodeNonAsciiHTML)(e) : (0, a.encodeHTML)(e) : (0, s.encodeXML)(e);
        };
        var u = n(98881);
        Object.defineProperty(t, "encodeXML", {
          enumerable: !0,
          get: function () {
            return u.encodeXML;
          }
        }), Object.defineProperty(t, "escape", {
          enumerable: !0,
          get: function () {
            return u.escape;
          }
        }), Object.defineProperty(t, "escapeUTF8", {
          enumerable: !0,
          get: function () {
            return u.escapeUTF8;
          }
        }), Object.defineProperty(t, "escapeAttribute", {
          enumerable: !0,
          get: function () {
            return u.escapeAttribute;
          }
        }), Object.defineProperty(t, "escapeText", {
          enumerable: !0,
          get: function () {
            return u.escapeText;
          }
        });
        var c = n(35278);
        Object.defineProperty(t, "encodeHTML", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeNonAsciiHTML", {
          enumerable: !0,
          get: function () {
            return c.encodeNonAsciiHTML;
          }
        }), Object.defineProperty(t, "encodeHTML4", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        }), Object.defineProperty(t, "encodeHTML5", {
          enumerable: !0,
          get: function () {
            return c.encodeHTML;
          }
        });
        var d = n(10901);
        Object.defineProperty(t, "EntityDecoder", {
          enumerable: !0,
          get: function () {
            return d.EntityDecoder;
          }
        }), Object.defineProperty(t, "DecodingMode", {
          enumerable: !0,
          get: function () {
            return d.DecodingMode;
          }
        }), Object.defineProperty(t, "decodeXML", {
          enumerable: !0,
          get: function () {
            return d.decodeXML;
          }
        }), Object.defineProperty(t, "decodeHTML", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTMLStrict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTMLAttribute", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLAttribute;
          }
        }), Object.defineProperty(t, "decodeHTML4", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML5", {
          enumerable: !0,
          get: function () {
            return d.decodeHTML;
          }
        }), Object.defineProperty(t, "decodeHTML4Strict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeHTML5Strict", {
          enumerable: !0,
          get: function () {
            return d.decodeHTMLStrict;
          }
        }), Object.defineProperty(t, "decodeXMLStrict", {
          enumerable: !0,
          get: function () {
            return d.decodeXML;
          }
        });
      },
      99960: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(n = t.ElementType || (t.ElementType = {})), t.isTag = function (e) {
          return e.type === n.Tag || e.type === n.Script || e.type === n.Style;
        }, t.Root = n.Root, t.Text = n.Text, t.Directive = n.Directive, t.Comment = n.Comment, t.Script = n.Script, t.Style = n.Style, t.Tag = n.Tag, t.CDATA = n.CDATA, t.Doctype = n.Doctype;
      },
      47915: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DomHandler = void 0;
        var i = n(590),
          a = n(97790);
        o(n(97790), t);
        var s = {
            withStartIndices: !1,
            withEndIndices: !1,
            xmlMode: !1
          },
          l = function () {
            function e(e, t, n) {
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, "function" == typeof t && (n = t, t = s), "object" == typeof e && (t = e, e = void 0), this.callback = null != e ? e : null, this.options = null != t ? t : s, this.elementCB = null != n ? n : null;
            }
            return e.prototype.onparserinit = function (e) {
              this.parser = e;
            }, e.prototype.onreset = function () {
              this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
            }, e.prototype.onend = function () {
              this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
            }, e.prototype.onerror = function (e) {
              this.handleCallback(e);
            }, e.prototype.onclosetag = function () {
              this.lastNode = null;
              var e = this.tagStack.pop();
              this.options.withEndIndices && (e.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(e);
            }, e.prototype.onopentag = function (e, t) {
              var n = this.options.xmlMode ? i.ElementType.Tag : void 0,
                r = new a.Element(e, t, void 0, n);
              this.addNode(r), this.tagStack.push(r);
            }, e.prototype.ontext = function (e) {
              var t = this.lastNode;
              if (t && t.type === i.ElementType.Text) t.data += e, this.options.withEndIndices && (t.endIndex = this.parser.endIndex);else {
                var n = new a.Text(e);
                this.addNode(n), this.lastNode = n;
              }
            }, e.prototype.oncomment = function (e) {
              if (this.lastNode && this.lastNode.type === i.ElementType.Comment) this.lastNode.data += e;else {
                var t = new a.Comment(e);
                this.addNode(t), this.lastNode = t;
              }
            }, e.prototype.oncommentend = function () {
              this.lastNode = null;
            }, e.prototype.oncdatastart = function () {
              var e = new a.Text(""),
                t = new a.CDATA([e]);
              this.addNode(t), e.parent = t, this.lastNode = e;
            }, e.prototype.oncdataend = function () {
              this.lastNode = null;
            }, e.prototype.onprocessinginstruction = function (e, t) {
              var n = new a.ProcessingInstruction(e, t);
              this.addNode(n);
            }, e.prototype.handleCallback = function (e) {
              if ("function" == typeof this.callback) this.callback(e, this.dom);else if (e) throw e;
            }, e.prototype.addNode = function (e) {
              var t = this.tagStack[this.tagStack.length - 1],
                n = t.children[t.children.length - 1];
              this.options.withStartIndices && (e.startIndex = this.parser.startIndex), this.options.withEndIndices && (e.endIndex = this.parser.endIndex), t.children.push(e), n && (e.prev = n, n.next = e), e.parent = t, this.lastNode = null;
            }, e;
          }();
        t.DomHandler = l, t.default = l;
      },
      97790: function (e, t, n) {
        "use strict";

        var r,
          o = this && this.__extends || (r = function (e, t) {
            return r = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
            }, r(e, t);
          }, function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
            function n() {
              this.constructor = e;
            }
            r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
          }),
          i = this && this.__assign || function () {
            return i = Object.assign || function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }, i.apply(this, arguments);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.cloneNode = t.hasChildren = t.isDocument = t.isDirective = t.isComment = t.isText = t.isCDATA = t.isTag = t.Element = t.Document = t.CDATA = t.NodeWithChildren = t.ProcessingInstruction = t.Comment = t.Text = t.DataNode = t.Node = void 0;
        var a = n(590),
          s = function () {
            function e() {
              this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
            }
            return Object.defineProperty(e.prototype, "parentNode", {
              get: function () {
                return this.parent;
              },
              set: function (e) {
                this.parent = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "previousSibling", {
              get: function () {
                return this.prev;
              },
              set: function (e) {
                this.prev = e;
              },
              enumerable: !1,
              configurable: !0
            }), Object.defineProperty(e.prototype, "nextSibling", {
              get: function () {
                return this.next;
              },
              set: function (e) {
                this.next = e;
              },
              enumerable: !1,
              configurable: !0
            }), e.prototype.cloneNode = function (e) {
              return void 0 === e && (e = !1), D(this, e);
            }, e;
          }();
        t.Node = s;
        var l = function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return n.data = t, n;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeValue", {
            get: function () {
              return this.data;
            },
            set: function (e) {
              this.data = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(s);
        t.DataNode = l;
        var u = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = a.ElementType.Text, t;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 3;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.Text = u;
        var c = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = a.ElementType.Comment, t;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 8;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.Comment = c;
        var d = function (e) {
          function t(t, n) {
            var r = e.call(this, n) || this;
            return r.name = t, r.type = a.ElementType.Directive, r;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(l);
        t.ProcessingInstruction = d;
        var p = function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return n.children = t, n;
          }
          return o(t, e), Object.defineProperty(t.prototype, "firstChild", {
            get: function () {
              var e;
              return null !== (e = this.children[0]) && void 0 !== e ? e : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "lastChild", {
            get: function () {
              return this.children.length > 0 ? this.children[this.children.length - 1] : null;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "childNodes", {
            get: function () {
              return this.children;
            },
            set: function (e) {
              this.children = e;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(s);
        t.NodeWithChildren = p;
        var h = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = a.ElementType.CDATA, t;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 4;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(p);
        t.CDATA = h;
        var f = function (e) {
          function t() {
            var t = null !== e && e.apply(this, arguments) || this;
            return t.type = a.ElementType.Root, t;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 9;
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(p);
        t.Document = f;
        var m = function (e) {
          function t(t, n, r, o) {
            void 0 === r && (r = []), void 0 === o && (o = "script" === t ? a.ElementType.Script : "style" === t ? a.ElementType.Style : a.ElementType.Tag);
            var i = e.call(this, r) || this;
            return i.name = t, i.attribs = n, i.type = o, i;
          }
          return o(t, e), Object.defineProperty(t.prototype, "nodeType", {
            get: function () {
              return 1;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "tagName", {
            get: function () {
              return this.name;
            },
            set: function (e) {
              this.name = e;
            },
            enumerable: !1,
            configurable: !0
          }), Object.defineProperty(t.prototype, "attributes", {
            get: function () {
              var e = this;
              return Object.keys(this.attribs).map(function (t) {
                var n, r;
                return {
                  name: t,
                  value: e.attribs[t],
                  namespace: null === (n = e["x-attribsNamespace"]) || void 0 === n ? void 0 : n[t],
                  prefix: null === (r = e["x-attribsPrefix"]) || void 0 === r ? void 0 : r[t]
                };
              });
            },
            enumerable: !1,
            configurable: !0
          }), t;
        }(p);
        function g(e) {
          return (0, a.isTag)(e);
        }
        function v(e) {
          return e.type === a.ElementType.CDATA;
        }
        function y(e) {
          return e.type === a.ElementType.Text;
        }
        function b(e) {
          return e.type === a.ElementType.Comment;
        }
        function w(e) {
          return e.type === a.ElementType.Directive;
        }
        function x(e) {
          return e.type === a.ElementType.Root;
        }
        function D(e, t) {
          var n;
          if (void 0 === t && (t = !1), y(e)) n = new u(e.data);else if (b(e)) n = new c(e.data);else if (g(e)) {
            var r = t ? C(e.children) : [],
              o = new m(e.name, i({}, e.attribs), r);
            r.forEach(function (e) {
              return e.parent = o;
            }), null != e.namespace && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = i({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = i({}, e["x-attribsPrefix"])), n = o;
          } else if (v(e)) {
            r = t ? C(e.children) : [];
            var a = new h(r);
            r.forEach(function (e) {
              return e.parent = a;
            }), n = a;
          } else if (x(e)) {
            r = t ? C(e.children) : [];
            var s = new f(r);
            r.forEach(function (e) {
              return e.parent = s;
            }), e["x-mode"] && (s["x-mode"] = e["x-mode"]), n = s;
          } else {
            if (!w(e)) throw new Error("Not implemented yet: ".concat(e.type));
            var l = new d(e.name, e.data);
            null != e["x-name"] && (l["x-name"] = e["x-name"], l["x-publicId"] = e["x-publicId"], l["x-systemId"] = e["x-systemId"]), n = l;
          }
          return n.startIndex = e.startIndex, n.endIndex = e.endIndex, null != e.sourceCodeLocation && (n.sourceCodeLocation = e.sourceCodeLocation), n;
        }
        function C(e) {
          for (var t = e.map(function (e) {
              return D(e, !0);
            }), n = 1; n < t.length; n++) t[n].prev = t[n - 1], t[n - 1].next = t[n];
          return t;
        }
        t.Element = m, t.isTag = g, t.isCDATA = v, t.isText = y, t.isComment = b, t.isDirective = w, t.isDocument = x, t.hasChildren = function (e) {
          return Object.prototype.hasOwnProperty.call(e, "children");
        }, t.cloneNode = D;
      },
      590: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(n = t.ElementType || (t.ElementType = {})), t.isTag = function (e) {
          return e.type === n.Tag || e.type === n.Script || e.type === n.Style;
        }, t.Root = n.Root, t.Text = n.Text, t.Directive = n.Directive, t.Comment = n.Comment, t.Script = n.Script, t.Style = n.Style, t.Tag = n.Tag, t.CDATA = n.CDATA, t.Doctype = n.Doctype;
      },
      27856: function (e) {
        e.exports = function () {
          "use strict";

          const {
            entries: e,
            setPrototypeOf: t,
            isFrozen: n,
            getPrototypeOf: r,
            getOwnPropertyDescriptor: o
          } = Object;
          let {
              freeze: i,
              seal: a,
              create: s
            } = Object,
            {
              apply: l,
              construct: u
            } = "undefined" != typeof Reflect && Reflect;
          l || (l = function (e, t, n) {
            return e.apply(t, n);
          }), i || (i = function (e) {
            return e;
          }), a || (a = function (e) {
            return e;
          }), u || (u = function (e, t) {
            return new e(...t);
          });
          const c = x(Array.prototype.forEach),
            d = x(Array.prototype.pop),
            p = x(Array.prototype.push),
            h = x(String.prototype.toLowerCase),
            f = x(String.prototype.toString),
            m = x(String.prototype.match),
            g = x(String.prototype.replace),
            v = x(String.prototype.indexOf),
            y = x(String.prototype.trim),
            b = x(RegExp.prototype.test),
            w = D(TypeError);
          function x(e) {
            return function (t) {
              for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
              return l(e, t, r);
            };
          }
          function D(e) {
            return function () {
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return u(e, n);
            };
          }
          function C(e, r, o) {
            var i;
            o = null !== (i = o) && void 0 !== i ? i : h, t && t(e, null);
            let a = r.length;
            for (; a--;) {
              let t = r[a];
              if ("string" == typeof t) {
                const e = o(t);
                e !== t && (n(r) || (r[a] = e), t = e);
              }
              e[t] = !0;
            }
            return e;
          }
          function S(t) {
            const n = s(null);
            for (const [r, o] of e(t)) n[r] = o;
            return n;
          }
          function E(e, t) {
            for (; null !== e;) {
              const n = o(e, t);
              if (n) {
                if (n.get) return x(n.get);
                if ("function" == typeof n.value) return x(n.value);
              }
              e = r(e);
            }
            function n(e) {
              return console.warn("fallback value for", e), null;
            }
            return n;
          }
          const _ = i(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
            P = i(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
            k = i(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
            A = i(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
            z = i(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
            T = i(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
            O = i(["#text"]),
            I = i(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
            F = i(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
            M = i(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
            R = i(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
            j = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            B = a(/<%[\w\W]*|[\w\W]*%>/gm),
            N = a(/\${[\w\W]*}/gm),
            L = a(/^data-[\-\w.\u00B7-\uFFFF]/),
            V = a(/^aria-[\-\w]+$/),
            K = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            q = a(/^(?:\w+script|data):/i),
            H = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            U = a(/^html$/i);
          var Z = Object.freeze({
            __proto__: null,
            MUSTACHE_EXPR: j,
            ERB_EXPR: B,
            TMPLIT_EXPR: N,
            DATA_ATTR: L,
            ARIA_ATTR: V,
            IS_ALLOWED_URI: K,
            IS_SCRIPT_OR_DATA: q,
            ATTR_WHITESPACE: H,
            DOCTYPE_NAME: U
          });
          const $ = () => "undefined" == typeof window ? null : window,
            G = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let n = null;
              const r = "data-tt-policy-suffix";
              t && t.hasAttribute(r) && (n = t.getAttribute(r));
              const o = "dompurify" + (n ? "#" + n : "");
              try {
                return e.createPolicy(o, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + o + " could not be created."), null;
              }
            };
          function W() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $();
            const n = e => W(e);
            if (n.version = "3.0.5", n.removed = [], !t || !t.document || 9 !== t.document.nodeType) return n.isSupported = !1, n;
            const r = t.document,
              o = r.currentScript;
            let {
              document: a
            } = t;
            const {
                DocumentFragment: s,
                HTMLTemplateElement: l,
                Node: u,
                Element: x,
                NodeFilter: D,
                NamedNodeMap: j = t.NamedNodeMap || t.MozNamedAttrMap,
                HTMLFormElement: B,
                DOMParser: N,
                trustedTypes: L
              } = t,
              V = x.prototype,
              q = E(V, "cloneNode"),
              H = E(V, "nextSibling"),
              Y = E(V, "childNodes"),
              X = E(V, "parentNode");
            if ("function" == typeof l) {
              const e = a.createElement("template");
              e.content && e.content.ownerDocument && (a = e.content.ownerDocument);
            }
            let Q,
              J = "";
            const {
                implementation: ee,
                createNodeIterator: te,
                createDocumentFragment: ne,
                getElementsByTagName: re
              } = a,
              {
                importNode: oe
              } = r;
            let ie = {};
            n.isSupported = "function" == typeof e && "function" == typeof X && ee && void 0 !== ee.createHTMLDocument;
            const {
              MUSTACHE_EXPR: ae,
              ERB_EXPR: se,
              TMPLIT_EXPR: le,
              DATA_ATTR: ue,
              ARIA_ATTR: ce,
              IS_SCRIPT_OR_DATA: de,
              ATTR_WHITESPACE: pe
            } = Z;
            let {
                IS_ALLOWED_URI: he
              } = Z,
              fe = null;
            const me = C({}, [..._, ...P, ...k, ...z, ...O]);
            let ge = null;
            const ve = C({}, [...I, ...F, ...M, ...R]);
            let ye = Object.seal(Object.create(null, {
                tagNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                attributeNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: !1
                }
              })),
              be = null,
              we = null,
              xe = !0,
              De = !0,
              Ce = !1,
              Se = !0,
              Ee = !1,
              _e = !1,
              Pe = !1,
              ke = !1,
              Ae = !1,
              ze = !1,
              Te = !1,
              Oe = !0,
              Ie = !1;
            const Fe = "user-content-";
            let Me = !0,
              Re = !1,
              je = {},
              Be = null;
            const Ne = C({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
            let Le = null;
            const Ve = C({}, ["audio", "video", "img", "source", "image", "track"]);
            let Ke = null;
            const qe = C({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
              He = "http://www.w3.org/1998/Math/MathML",
              Ue = "http://www.w3.org/2000/svg",
              Ze = "http://www.w3.org/1999/xhtml";
            let $e = Ze,
              Ge = !1,
              We = null;
            const Ye = C({}, [He, Ue, Ze], f);
            let Xe;
            const Qe = ["application/xhtml+xml", "text/html"],
              Je = "text/html";
            let et,
              tt = null;
            const nt = a.createElement("form"),
              rt = function (e) {
                return e instanceof RegExp || e instanceof Function;
              },
              ot = function (e) {
                if (!tt || tt !== e) {
                  if (e && "object" == typeof e || (e = {}), e = S(e), Xe = Xe = -1 === Qe.indexOf(e.PARSER_MEDIA_TYPE) ? Je : e.PARSER_MEDIA_TYPE, et = "application/xhtml+xml" === Xe ? f : h, fe = "ALLOWED_TAGS" in e ? C({}, e.ALLOWED_TAGS, et) : me, ge = "ALLOWED_ATTR" in e ? C({}, e.ALLOWED_ATTR, et) : ve, We = "ALLOWED_NAMESPACES" in e ? C({}, e.ALLOWED_NAMESPACES, f) : Ye, Ke = "ADD_URI_SAFE_ATTR" in e ? C(S(qe), e.ADD_URI_SAFE_ATTR, et) : qe, Le = "ADD_DATA_URI_TAGS" in e ? C(S(Ve), e.ADD_DATA_URI_TAGS, et) : Ve, Be = "FORBID_CONTENTS" in e ? C({}, e.FORBID_CONTENTS, et) : Ne, be = "FORBID_TAGS" in e ? C({}, e.FORBID_TAGS, et) : {}, we = "FORBID_ATTR" in e ? C({}, e.FORBID_ATTR, et) : {}, je = "USE_PROFILES" in e && e.USE_PROFILES, xe = !1 !== e.ALLOW_ARIA_ATTR, De = !1 !== e.ALLOW_DATA_ATTR, Ce = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Se = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Ee = e.SAFE_FOR_TEMPLATES || !1, _e = e.WHOLE_DOCUMENT || !1, Ae = e.RETURN_DOM || !1, ze = e.RETURN_DOM_FRAGMENT || !1, Te = e.RETURN_TRUSTED_TYPE || !1, ke = e.FORCE_BODY || !1, Oe = !1 !== e.SANITIZE_DOM, Ie = e.SANITIZE_NAMED_PROPS || !1, Me = !1 !== e.KEEP_CONTENT, Re = e.IN_PLACE || !1, he = e.ALLOWED_URI_REGEXP || K, $e = e.NAMESPACE || Ze, ye = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && rt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ye.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && rt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ye.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (ye.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Ee && (De = !1), ze && (Ae = !0), je && (fe = C({}, [...O]), ge = [], !0 === je.html && (C(fe, _), C(ge, I)), !0 === je.svg && (C(fe, P), C(ge, F), C(ge, R)), !0 === je.svgFilters && (C(fe, k), C(ge, F), C(ge, R)), !0 === je.mathMl && (C(fe, z), C(ge, M), C(ge, R))), e.ADD_TAGS && (fe === me && (fe = S(fe)), C(fe, e.ADD_TAGS, et)), e.ADD_ATTR && (ge === ve && (ge = S(ge)), C(ge, e.ADD_ATTR, et)), e.ADD_URI_SAFE_ATTR && C(Ke, e.ADD_URI_SAFE_ATTR, et), e.FORBID_CONTENTS && (Be === Ne && (Be = S(Be)), C(Be, e.FORBID_CONTENTS, et)), Me && (fe["#text"] = !0), _e && C(fe, ["html", "head", "body"]), fe.table && (C(fe, ["tbody"]), delete be.tbody), e.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw w('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw w('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    Q = e.TRUSTED_TYPES_POLICY, J = Q.createHTML("");
                  } else void 0 === Q && (Q = G(L, o)), null !== Q && "string" == typeof J && (J = Q.createHTML(""));
                  i && i(e), tt = e;
                }
              },
              it = C({}, ["mi", "mo", "mn", "ms", "mtext"]),
              at = C({}, ["foreignobject", "desc", "title", "annotation-xml"]),
              st = C({}, ["title", "style", "font", "a", "script"]),
              lt = C({}, P);
            C(lt, k), C(lt, A);
            const ut = C({}, z);
            C(ut, T);
            const ct = function (e) {
                let t = X(e);
                t && t.tagName || (t = {
                  namespaceURI: $e,
                  tagName: "template"
                });
                const n = h(e.tagName),
                  r = h(t.tagName);
                return !!We[e.namespaceURI] && (e.namespaceURI === Ue ? t.namespaceURI === Ze ? "svg" === n : t.namespaceURI === He ? "svg" === n && ("annotation-xml" === r || it[r]) : Boolean(lt[n]) : e.namespaceURI === He ? t.namespaceURI === Ze ? "math" === n : t.namespaceURI === Ue ? "math" === n && at[r] : Boolean(ut[n]) : e.namespaceURI === Ze ? !(t.namespaceURI === Ue && !at[r]) && !(t.namespaceURI === He && !it[r]) && !ut[n] && (st[n] || !lt[n]) : !("application/xhtml+xml" !== Xe || !We[e.namespaceURI]));
              },
              dt = function (e) {
                p(n.removed, {
                  element: e
                });
                try {
                  e.parentNode.removeChild(e);
                } catch (t) {
                  e.remove();
                }
              },
              pt = function (e, t) {
                try {
                  p(n.removed, {
                    attribute: t.getAttributeNode(e),
                    from: t
                  });
                } catch (e) {
                  p(n.removed, {
                    attribute: null,
                    from: t
                  });
                }
                if (t.removeAttribute(e), "is" === e && !ge[e]) if (Ae || ze) try {
                  dt(t);
                } catch (e) {} else try {
                  t.setAttribute(e, "");
                } catch (e) {}
              },
              ht = function (e) {
                let t, n;
                if (ke) e = "<remove></remove>" + e;else {
                  const t = m(e, /^[\r\n\t ]+/);
                  n = t && t[0];
                }
                "application/xhtml+xml" === Xe && $e === Ze && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                const r = Q ? Q.createHTML(e) : e;
                if ($e === Ze) try {
                  t = new N().parseFromString(r, Xe);
                } catch (e) {}
                if (!t || !t.documentElement) {
                  t = ee.createDocument($e, "template", null);
                  try {
                    t.documentElement.innerHTML = Ge ? J : r;
                  } catch (e) {}
                }
                const o = t.body || t.documentElement;
                return e && n && o.insertBefore(a.createTextNode(n), o.childNodes[0] || null), $e === Ze ? re.call(t, _e ? "html" : "body")[0] : _e ? t.documentElement : o;
              },
              ft = function (e) {
                return te.call(e.ownerDocument || e, e, D.SHOW_ELEMENT | D.SHOW_COMMENT | D.SHOW_TEXT, null, !1);
              },
              mt = function (e) {
                return e instanceof B && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof j) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
              },
              gt = function (e) {
                return "object" == typeof u ? e instanceof u : e && "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
              },
              vt = function (e, t, r) {
                ie[e] && c(ie[e], e => {
                  e.call(n, t, r, tt);
                });
              },
              yt = function (e) {
                let t;
                if (vt("beforeSanitizeElements", e, null), mt(e)) return dt(e), !0;
                const r = et(e.nodeName);
                if (vt("uponSanitizeElement", e, {
                  tagName: r,
                  allowedTags: fe
                }), e.hasChildNodes() && !gt(e.firstElementChild) && (!gt(e.content) || !gt(e.content.firstElementChild)) && b(/<[/\w]/g, e.innerHTML) && b(/<[/\w]/g, e.textContent)) return dt(e), !0;
                if (!fe[r] || be[r]) {
                  if (!be[r] && wt(r)) {
                    if (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, r)) return !1;
                    if (ye.tagNameCheck instanceof Function && ye.tagNameCheck(r)) return !1;
                  }
                  if (Me && !Be[r]) {
                    const t = X(e) || e.parentNode,
                      n = Y(e) || e.childNodes;
                    if (n && t) for (let r = n.length - 1; r >= 0; --r) t.insertBefore(q(n[r], !0), H(e));
                  }
                  return dt(e), !0;
                }
                return e instanceof x && !ct(e) ? (dt(e), !0) : "noscript" !== r && "noembed" !== r && "noframes" !== r || !b(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Ee && 3 === e.nodeType && (t = e.textContent, t = g(t, ae, " "), t = g(t, se, " "), t = g(t, le, " "), e.textContent !== t && (p(n.removed, {
                  element: e.cloneNode()
                }), e.textContent = t)), vt("afterSanitizeElements", e, null), !1) : (dt(e), !0);
              },
              bt = function (e, t, n) {
                if (Oe && ("id" === t || "name" === t) && (n in a || n in nt)) return !1;
                if (De && !we[t] && b(ue, t)) ;else if (xe && b(ce, t)) ;else if (!ge[t] || we[t]) {
                  if (!(wt(e) && (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, e) || ye.tagNameCheck instanceof Function && ye.tagNameCheck(e)) && (ye.attributeNameCheck instanceof RegExp && b(ye.attributeNameCheck, t) || ye.attributeNameCheck instanceof Function && ye.attributeNameCheck(t)) || "is" === t && ye.allowCustomizedBuiltInElements && (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, n) || ye.tagNameCheck instanceof Function && ye.tagNameCheck(n)))) return !1;
                } else if (Ke[t]) ;else if (b(he, g(n, pe, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(n, "data:") || !Le[e]) if (Ce && !b(de, g(n, pe, ""))) ;else if (n) return !1;
                return !0;
              },
              wt = function (e) {
                return e.indexOf("-") > 0;
              },
              xt = function (e) {
                let t, r, o, i;
                vt("beforeSanitizeAttributes", e, null);
                const {
                  attributes: a
                } = e;
                if (!a) return;
                const s = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: ge
                };
                for (i = a.length; i--;) {
                  t = a[i];
                  const {
                    name: l,
                    namespaceURI: u
                  } = t;
                  if (r = "value" === l ? t.value : y(t.value), o = et(l), s.attrName = o, s.attrValue = r, s.keepAttr = !0, s.forceKeepAttr = void 0, vt("uponSanitizeAttribute", e, s), r = s.attrValue, s.forceKeepAttr) continue;
                  if (pt(l, e), !s.keepAttr) continue;
                  if (!Se && b(/\/>/i, r)) {
                    pt(l, e);
                    continue;
                  }
                  Ee && (r = g(r, ae, " "), r = g(r, se, " "), r = g(r, le, " "));
                  const c = et(e.nodeName);
                  if (bt(c, o, r)) {
                    if (!Ie || "id" !== o && "name" !== o || (pt(l, e), r = Fe + r), Q && "object" == typeof L && "function" == typeof L.getAttributeType) if (u) ;else switch (L.getAttributeType(c, o)) {
                      case "TrustedHTML":
                        r = Q.createHTML(r);
                        break;
                      case "TrustedScriptURL":
                        r = Q.createScriptURL(r);
                    }
                    try {
                      u ? e.setAttributeNS(u, l, r) : e.setAttribute(l, r), d(n.removed);
                    } catch (e) {}
                  }
                }
                vt("afterSanitizeAttributes", e, null);
              },
              Dt = function e(t) {
                let n;
                const r = ft(t);
                for (vt("beforeSanitizeShadowDOM", t, null); n = r.nextNode();) vt("uponSanitizeShadowNode", n, null), yt(n) || (n.content instanceof s && e(n.content), xt(n));
                vt("afterSanitizeShadowDOM", t, null);
              };
            return n.sanitize = function (e) {
              let t,
                o,
                i,
                a,
                l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (Ge = !e, Ge && (e = "\x3c!--\x3e"), "string" != typeof e && !gt(e)) {
                if ("function" != typeof e.toString) throw w("toString is not a function");
                if ("string" != typeof (e = e.toString())) throw w("dirty is not a string, aborting");
              }
              if (!n.isSupported) return e;
              if (Pe || ot(l), n.removed = [], "string" == typeof e && (Re = !1), Re) {
                if (e.nodeName) {
                  const t = et(e.nodeName);
                  if (!fe[t] || be[t]) throw w("root node is forbidden and cannot be sanitized in-place");
                }
              } else if (e instanceof u) t = ht("\x3c!----\x3e"), o = t.ownerDocument.importNode(e, !0), 1 === o.nodeType && "BODY" === o.nodeName || "HTML" === o.nodeName ? t = o : t.appendChild(o);else {
                if (!Ae && !Ee && !_e && -1 === e.indexOf("<")) return Q && Te ? Q.createHTML(e) : e;
                if (t = ht(e), !t) return Ae ? null : Te ? J : "";
              }
              t && ke && dt(t.firstChild);
              const c = ft(Re ? e : t);
              for (; i = c.nextNode();) yt(i) || (i.content instanceof s && Dt(i.content), xt(i));
              if (Re) return e;
              if (Ae) {
                if (ze) for (a = ne.call(t.ownerDocument); t.firstChild;) a.appendChild(t.firstChild);else a = t;
                return (ge.shadowroot || ge.shadowrootmode) && (a = oe.call(r, a, !0)), a;
              }
              let d = _e ? t.outerHTML : t.innerHTML;
              return _e && fe["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && b(U, t.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + t.ownerDocument.doctype.name + ">\n" + d), Ee && (d = g(d, ae, " "), d = g(d, se, " "), d = g(d, le, " ")), Q && Te ? Q.createHTML(d) : d;
            }, n.setConfig = function (e) {
              ot(e), Pe = !0;
            }, n.clearConfig = function () {
              tt = null, Pe = !1;
            }, n.isValidAttribute = function (e, t, n) {
              tt || ot({});
              const r = et(e),
                o = et(t);
              return bt(r, o, n);
            }, n.addHook = function (e, t) {
              "function" == typeof t && (ie[e] = ie[e] || [], p(ie[e], t));
            }, n.removeHook = function (e) {
              if (ie[e]) return d(ie[e]);
            }, n.removeHooks = function (e) {
              ie[e] && (ie[e] = []);
            }, n.removeAllHooks = function () {
              ie = {};
            }, n;
          }
          return W();
        }();
      },
      16996: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFeed = void 0;
        var r = n(43346),
          o = n(23905);
        t.getFeed = function (e) {
          var t = l(d, e);
          return t ? "feed" === t.name ? function (e) {
            var t,
              n = e.children,
              r = {
                type: "atom",
                items: (0, o.getElementsByTagName)("entry", n).map(function (e) {
                  var t,
                    n = e.children,
                    r = {
                      media: s(n)
                    };
                  c(r, "id", "id", n), c(r, "title", "title", n);
                  var o = null === (t = l("link", n)) || void 0 === t ? void 0 : t.attribs.href;
                  o && (r.link = o);
                  var i = u("summary", n) || u("content", n);
                  i && (r.description = i);
                  var a = u("updated", n);
                  return a && (r.pubDate = new Date(a)), r;
                })
              };
            c(r, "id", "id", n), c(r, "title", "title", n);
            var i = null === (t = l("link", n)) || void 0 === t ? void 0 : t.attribs.href;
            i && (r.link = i);
            c(r, "description", "subtitle", n);
            var a = u("updated", n);
            a && (r.updated = new Date(a));
            return c(r, "author", "email", n, !0), r;
          }(t) : function (e) {
            var t,
              n,
              r = null !== (n = null === (t = l("channel", e.children)) || void 0 === t ? void 0 : t.children) && void 0 !== n ? n : [],
              i = {
                type: e.name.substr(0, 3),
                id: "",
                items: (0, o.getElementsByTagName)("item", e.children).map(function (e) {
                  var t = e.children,
                    n = {
                      media: s(t)
                    };
                  c(n, "id", "guid", t), c(n, "title", "title", t), c(n, "link", "link", t), c(n, "description", "description", t);
                  var r = u("pubDate", t) || u("dc:date", t);
                  return r && (n.pubDate = new Date(r)), n;
                })
              };
            c(i, "title", "title", r), c(i, "link", "link", r), c(i, "description", "description", r);
            var a = u("lastBuildDate", r);
            a && (i.updated = new Date(a));
            return c(i, "author", "managingEditor", r, !0), i;
          }(t) : null;
        };
        var i = ["url", "type", "lang"],
          a = ["fileSize", "bitrate", "framerate", "samplingrate", "channels", "duration", "height", "width"];
        function s(e) {
          return (0, o.getElementsByTagName)("media:content", e).map(function (e) {
            for (var t = e.attribs, n = {
                medium: t.medium,
                isDefault: !!t.isDefault
              }, r = 0, o = i; r < o.length; r++) {
              t[u = o[r]] && (n[u] = t[u]);
            }
            for (var s = 0, l = a; s < l.length; s++) {
              var u;
              t[u = l[s]] && (n[u] = parseInt(t[u], 10));
            }
            return t.expression && (n.expression = t.expression), n;
          });
        }
        function l(e, t) {
          return (0, o.getElementsByTagName)(e, t, !0, 1)[0];
        }
        function u(e, t, n) {
          return void 0 === n && (n = !1), (0, r.textContent)((0, o.getElementsByTagName)(e, t, n, 1)).trim();
        }
        function c(e, t, n, r, o) {
          void 0 === o && (o = !1);
          var i = u(n, r, o);
          i && (e[t] = i);
        }
        function d(e) {
          return "rss" === e || "feed" === e || "rdf:RDF" === e;
        }
      },
      74975: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.uniqueSort = t.compareDocumentPosition = t.DocumentPosition = t.removeSubsets = void 0;
        var r,
          o = n(47915);
        function i(e, t) {
          var n = [],
            i = [];
          if (e === t) return 0;
          for (var a = (0, o.hasChildren)(e) ? e : e.parent; a;) n.unshift(a), a = a.parent;
          for (a = (0, o.hasChildren)(t) ? t : t.parent; a;) i.unshift(a), a = a.parent;
          for (var s = Math.min(n.length, i.length), l = 0; l < s && n[l] === i[l];) l++;
          if (0 === l) return r.DISCONNECTED;
          var u = n[l - 1],
            c = u.children,
            d = n[l],
            p = i[l];
          return c.indexOf(d) > c.indexOf(p) ? u === t ? r.FOLLOWING | r.CONTAINED_BY : r.FOLLOWING : u === e ? r.PRECEDING | r.CONTAINS : r.PRECEDING;
        }
        t.removeSubsets = function (e) {
          for (var t = e.length; --t >= 0;) {
            var n = e[t];
            if (t > 0 && e.lastIndexOf(n, t - 1) >= 0) e.splice(t, 1);else for (var r = n.parent; r; r = r.parent) if (e.includes(r)) {
              e.splice(t, 1);
              break;
            }
          }
          return e;
        }, function (e) {
          e[e.DISCONNECTED = 1] = "DISCONNECTED", e[e.PRECEDING = 2] = "PRECEDING", e[e.FOLLOWING = 4] = "FOLLOWING", e[e.CONTAINS = 8] = "CONTAINS", e[e.CONTAINED_BY = 16] = "CONTAINED_BY";
        }(r = t.DocumentPosition || (t.DocumentPosition = {})), t.compareDocumentPosition = i, t.uniqueSort = function (e) {
          return (e = e.filter(function (e, t, n) {
            return !n.includes(e, t + 1);
          })).sort(function (e, t) {
            var n = i(e, t);
            return n & r.PRECEDING ? -1 : n & r.FOLLOWING ? 1 : 0;
          }), e;
        };
      },
      89432: function (e, t, n) {
        "use strict";

        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
            void 0 === r && (r = n);
            var o = Object.getOwnPropertyDescriptor(t, n);
            o && !("get" in o ? !t.__esModule : o.writable || o.configurable) || (o = {
              enumerable: !0,
              get: function () {
                return t[n];
              }
            }), Object.defineProperty(e, r, o);
          } : function (e, t, n, r) {
            void 0 === r && (r = n), e[r] = t[n];
          }),
          o = this && this.__exportStar || function (e, t) {
            for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasChildren = t.isDocument = t.isComment = t.isText = t.isCDATA = t.isTag = void 0, o(n(43346), t), o(n(20975), t), o(n(26765), t), o(n(98043), t), o(n(23905), t), o(n(74975), t), o(n(16996), t);
        var i = n(47915);
        Object.defineProperty(t, "isTag", {
          enumerable: !0,
          get: function () {
            return i.isTag;
          }
        }), Object.defineProperty(t, "isCDATA", {
          enumerable: !0,
          get: function () {
            return i.isCDATA;
          }
        }), Object.defineProperty(t, "isText", {
          enumerable: !0,
          get: function () {
            return i.isText;
          }
        }), Object.defineProperty(t, "isComment", {
          enumerable: !0,
          get: function () {
            return i.isComment;
          }
        }), Object.defineProperty(t, "isDocument", {
          enumerable: !0,
          get: function () {
            return i.isDocument;
          }
        }), Object.defineProperty(t, "hasChildren", {
          enumerable: !0,
          get: function () {
            return i.hasChildren;
          }
        });
      },
      23905: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getElementsByTagType = t.getElementsByTagName = t.getElementById = t.getElements = t.testElement = void 0;
        var r = n(47915),
          o = n(98043),
          i = {
            tag_name: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, r.isTag)(t) && e(t.name);
              } : "*" === e ? r.isTag : function (t) {
                return (0, r.isTag)(t) && t.name === e;
              };
            },
            tag_type: function (e) {
              return "function" == typeof e ? function (t) {
                return e(t.type);
              } : function (t) {
                return t.type === e;
              };
            },
            tag_contains: function (e) {
              return "function" == typeof e ? function (t) {
                return (0, r.isText)(t) && e(t.data);
              } : function (t) {
                return (0, r.isText)(t) && t.data === e;
              };
            }
          };
        function a(e, t) {
          return "function" == typeof t ? function (n) {
            return (0, r.isTag)(n) && t(n.attribs[e]);
          } : function (n) {
            return (0, r.isTag)(n) && n.attribs[e] === t;
          };
        }
        function s(e, t) {
          return function (n) {
            return e(n) || t(n);
          };
        }
        function l(e) {
          var t = Object.keys(e).map(function (t) {
            var n = e[t];
            return Object.prototype.hasOwnProperty.call(i, t) ? i[t](n) : a(t, n);
          });
          return 0 === t.length ? null : t.reduce(s);
        }
        t.testElement = function (e, t) {
          var n = l(e);
          return !n || n(t);
        }, t.getElements = function (e, t, n, r) {
          void 0 === r && (r = 1 / 0);
          var i = l(e);
          return i ? (0, o.filter)(i, t, n, r) : [];
        }, t.getElementById = function (e, t, n) {
          return void 0 === n && (n = !0), Array.isArray(t) || (t = [t]), (0, o.findOne)(a("id", e), t, n);
        }, t.getElementsByTagName = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), (0, o.filter)(i.tag_name(e), t, n, r);
        }, t.getElementsByTagType = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), (0, o.filter)(i.tag_type(e), t, n, r);
        };
      },
      26765: (e, t) => {
        "use strict";

        function n(e) {
          if (e.prev && (e.prev.next = e.next), e.next && (e.next.prev = e.prev), e.parent) {
            var t = e.parent.children,
              n = t.lastIndexOf(e);
            n >= 0 && t.splice(n, 1);
          }
          e.next = null, e.prev = null, e.parent = null;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prepend = t.prependChild = t.append = t.appendChild = t.replaceElement = t.removeElement = void 0, t.removeElement = n, t.replaceElement = function (e, t) {
          var n = t.prev = e.prev;
          n && (n.next = t);
          var r = t.next = e.next;
          r && (r.prev = t);
          var o = t.parent = e.parent;
          if (o) {
            var i = o.children;
            i[i.lastIndexOf(e)] = t, e.parent = null;
          }
        }, t.appendChild = function (e, t) {
          if (n(t), t.next = null, t.parent = e, e.children.push(t) > 1) {
            var r = e.children[e.children.length - 2];
            r.next = t, t.prev = r;
          } else t.prev = null;
        }, t.append = function (e, t) {
          n(t);
          var r = e.parent,
            o = e.next;
          if (t.next = o, t.prev = e, e.next = t, t.parent = r, o) {
            if (o.prev = t, r) {
              var i = r.children;
              i.splice(i.lastIndexOf(o), 0, t);
            }
          } else r && r.children.push(t);
        }, t.prependChild = function (e, t) {
          if (n(t), t.parent = e, t.prev = null, 1 !== e.children.unshift(t)) {
            var r = e.children[1];
            r.prev = t, t.next = r;
          } else t.next = null;
        }, t.prepend = function (e, t) {
          n(t);
          var r = e.parent;
          if (r) {
            var o = r.children;
            o.splice(o.indexOf(e), 0, t);
          }
          e.prev && (e.prev.next = t), t.parent = r, t.prev = e.prev, t.next = e, e.prev = t;
        };
      },
      98043: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.findAll = t.existsOne = t.findOne = t.findOneChild = t.find = t.filter = void 0;
        var r = n(47915);
        function o(e, t, n, o) {
          for (var i = [], a = [t], s = [0];;) if (s[0] >= a[0].length) {
            if (1 === s.length) return i;
            a.shift(), s.shift();
          } else {
            var l = a[0][s[0]++];
            if (e(l) && (i.push(l), --o <= 0)) return i;
            n && (0, r.hasChildren)(l) && l.children.length > 0 && (s.unshift(0), a.unshift(l.children));
          }
        }
        t.filter = function (e, t, n, r) {
          return void 0 === n && (n = !0), void 0 === r && (r = 1 / 0), o(e, Array.isArray(t) ? t : [t], n, r);
        }, t.find = o, t.findOneChild = function (e, t) {
          return t.find(e);
        }, t.findOne = function e(t, n, o) {
          void 0 === o && (o = !0);
          for (var i = null, a = 0; a < n.length && !i; a++) {
            var s = n[a];
            (0, r.isTag)(s) && (t(s) ? i = s : o && s.children.length > 0 && (i = e(t, s.children, !0)));
          }
          return i;
        }, t.existsOne = function e(t, n) {
          return n.some(function (n) {
            return (0, r.isTag)(n) && (t(n) || e(t, n.children));
          });
        }, t.findAll = function (e, t) {
          for (var n = [], o = [t], i = [0];;) if (i[0] >= o[0].length) {
            if (1 === o.length) return n;
            o.shift(), i.shift();
          } else {
            var a = o[0][i[0]++];
            (0, r.isTag)(a) && (e(a) && n.push(a), a.children.length > 0 && (i.unshift(0), o.unshift(a.children)));
          }
        };
      },
      43346: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.innerText = t.textContent = t.getText = t.getInnerHTML = t.getOuterHTML = void 0;
        var o = n(47915),
          i = r(n(97220)),
          a = n(32089);
        function s(e, t) {
          return (0, i.default)(e, t);
        }
        t.getOuterHTML = s, t.getInnerHTML = function (e, t) {
          return (0, o.hasChildren)(e) ? e.children.map(function (e) {
            return s(e, t);
          }).join("") : "";
        }, t.getText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.isTag)(t) ? "br" === t.name ? "\n" : e(t.children) : (0, o.isCDATA)(t) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        }, t.textContent = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.hasChildren)(t) && !(0, o.isComment)(t) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        }, t.innerText = function e(t) {
          return Array.isArray(t) ? t.map(e).join("") : (0, o.hasChildren)(t) && (t.type === a.ElementType.Tag || (0, o.isCDATA)(t)) ? e(t.children) : (0, o.isText)(t) ? t.data : "";
        };
      },
      20975: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.prevElementSibling = t.nextElementSibling = t.getName = t.hasAttrib = t.getAttributeValue = t.getSiblings = t.getParent = t.getChildren = void 0;
        var r = n(47915);
        function o(e) {
          return (0, r.hasChildren)(e) ? e.children : [];
        }
        function i(e) {
          return e.parent || null;
        }
        t.getChildren = o, t.getParent = i, t.getSiblings = function (e) {
          var t = i(e);
          if (null != t) return o(t);
          for (var n = [e], r = e.prev, a = e.next; null != r;) n.unshift(r), r = r.prev;
          for (; null != a;) n.push(a), a = a.next;
          return n;
        }, t.getAttributeValue = function (e, t) {
          var n;
          return null === (n = e.attribs) || void 0 === n ? void 0 : n[t];
        }, t.hasAttrib = function (e, t) {
          return null != e.attribs && Object.prototype.hasOwnProperty.call(e.attribs, t) && null != e.attribs[t];
        }, t.getName = function (e) {
          return e.name;
        }, t.nextElementSibling = function (e) {
          for (var t = e.next; null !== t && !(0, r.isTag)(t);) t = t.next;
          return t;
        }, t.prevElementSibling = function (e) {
          for (var t = e.prev; null !== t && !(0, r.isTag)(t);) t = t.prev;
          return t;
        };
      },
      32089: (e, t) => {
        "use strict";

        var n;
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.Doctype = t.CDATA = t.Tag = t.Style = t.Script = t.Comment = t.Directive = t.Text = t.Root = t.isTag = t.ElementType = void 0, function (e) {
          e.Root = "root", e.Text = "text", e.Directive = "directive", e.Comment = "comment", e.Script = "script", e.Style = "style", e.Tag = "tag", e.CDATA = "cdata", e.Doctype = "doctype";
        }(n = t.ElementType || (t.ElementType = {})), t.isTag = function (e) {
          return e.type === n.Tag || e.type === n.Script || e.type === n.Style;
        }, t.Root = n.Root, t.Text = n.Text, t.Directive = n.Directive, t.Comment = n.Comment, t.Script = n.Script, t.Style = n.Style, t.Tag = n.Tag, t.CDATA = n.CDATA, t.Doctype = n.Doctype;
      },
      41756: (e, t, n) => {
        "use strict";

        function r(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            i = Object.keys(e);
          for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }
        function o() {
          return o = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, o.apply(this, arguments);
        }
        function i(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function a(e, t) {
          return a = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, a(e, t);
        }
        n.d(t, {
          ZP: () => Z,
          L7: () => Se
        });
        var s = n(45697),
          l = n.n(s),
          u = n(67294);
        n(59864);
        function c(e) {
          return "object" == typeof e && null != e && 1 === e.nodeType;
        }
        function d(e, t) {
          return (!t || "hidden" !== e) && "visible" !== e && "clip" !== e;
        }
        function p(e, t) {
          if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
            var n = getComputedStyle(e, null);
            return d(n.overflowY, t) || d(n.overflowX, t) || function (e) {
              var t = function (e) {
                if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
                try {
                  return e.ownerDocument.defaultView.frameElement;
                } catch (e) {
                  return null;
                }
              }(e);
              return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
            }(e);
          }
          return !1;
        }
        function h(e, t, n, r, o, i, a, s) {
          return i < e && a > t || i > e && a < t ? 0 : i <= e && s <= n || a >= t && s >= n ? i - e - r : a > t && s < n || i < e && s > n ? a - t + o : 0;
        }
        var f = function () {
          return f = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, f.apply(this, arguments);
        };
        Object.create;
        Object.create;
        var m = 0;
        function g(e) {
          return "function" == typeof e ? e : v;
        }
        function v() {}
        function y(e, t) {
          if (e) {
            var n = function (e, t) {
              var n = window,
                r = t.scrollMode,
                o = t.block,
                i = t.inline,
                a = t.boundary,
                s = t.skipOverflowHiddenElements,
                l = "function" == typeof a ? a : function (e) {
                  return e !== a;
                };
              if (!c(e)) throw new TypeError("Invalid target");
              for (var u = document.scrollingElement || document.documentElement, d = [], f = e; c(f) && l(f);) {
                if ((f = f.parentElement) === u) {
                  d.push(f);
                  break;
                }
                null != f && f === document.body && p(f) && !p(document.documentElement) || null != f && p(f, s) && d.push(f);
              }
              for (var m = n.visualViewport ? n.visualViewport.width : innerWidth, g = n.visualViewport ? n.visualViewport.height : innerHeight, v = window.scrollX || pageXOffset, y = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), w = b.height, x = b.width, D = b.top, C = b.right, S = b.bottom, E = b.left, _ = "start" === o || "nearest" === o ? D : "end" === o ? S : D + w / 2, P = "center" === i ? E + x / 2 : "end" === i ? C : E, k = [], A = 0; A < d.length; A++) {
                var z = d[A],
                  T = z.getBoundingClientRect(),
                  O = T.height,
                  I = T.width,
                  F = T.top,
                  M = T.right,
                  R = T.bottom,
                  j = T.left;
                if ("if-needed" === r && D >= 0 && E >= 0 && S <= g && C <= m && D >= F && S <= R && E >= j && C <= M) return k;
                var B = getComputedStyle(z),
                  N = parseInt(B.borderLeftWidth, 10),
                  L = parseInt(B.borderTopWidth, 10),
                  V = parseInt(B.borderRightWidth, 10),
                  K = parseInt(B.borderBottomWidth, 10),
                  q = 0,
                  H = 0,
                  U = "offsetWidth" in z ? z.offsetWidth - z.clientWidth - N - V : 0,
                  Z = "offsetHeight" in z ? z.offsetHeight - z.clientHeight - L - K : 0;
                if (u === z) q = "start" === o ? _ : "end" === o ? _ - g : "nearest" === o ? h(y, y + g, g, L, K, y + _, y + _ + w, w) : _ - g / 2, H = "start" === i ? P : "center" === i ? P - m / 2 : "end" === i ? P - m : h(v, v + m, m, N, V, v + P, v + P + x, x), q = Math.max(0, q + y), H = Math.max(0, H + v);else {
                  q = "start" === o ? _ - F - L : "end" === o ? _ - R + K + Z : "nearest" === o ? h(F, R, O, L, K + Z, _, _ + w, w) : _ - (F + O / 2) + Z / 2, H = "start" === i ? P - j - N : "center" === i ? P - (j + I / 2) + U / 2 : "end" === i ? P - M + V + U : h(j, M, I, N, V + U, P, P + x, x);
                  var $ = z.scrollLeft,
                    G = z.scrollTop;
                  _ += G - (q = Math.max(0, Math.min(G + q, z.scrollHeight - O + Z))), P += $ - (H = Math.max(0, Math.min($ + H, z.scrollWidth - I + U)));
                }
                k.push({
                  el: z,
                  top: q,
                  left: H
                });
              }
              return k;
            }(e, {
              boundary: t,
              block: "nearest",
              scrollMode: "if-needed"
            });
            n.forEach(function (e) {
              var t = e.el,
                n = e.top,
                r = e.left;
              t.scrollTop = n, t.scrollLeft = r;
            });
          }
        }
        function b(e, t, n) {
          return e === t || t instanceof n.Node && e.contains && e.contains(t);
        }
        function w(e, t) {
          var n;
          function r() {
            n && clearTimeout(n);
          }
          function o() {
            for (var o = arguments.length, i = new Array(o), a = 0; a < o; a++) i[a] = arguments[a];
            r(), n = setTimeout(function () {
              n = null, e.apply(void 0, i);
            }, t);
          }
          return o.cancel = r, o;
        }
        function x() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return function (e) {
            for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
            return t.some(function (t) {
              return t && t.apply(void 0, [e].concat(r)), e.preventDownshiftDefault || e.hasOwnProperty("nativeEvent") && e.nativeEvent.preventDownshiftDefault;
            });
          };
        }
        function D() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return function (e) {
            t.forEach(function (t) {
              "function" == typeof t ? t(e) : t && (t.current = e);
            });
          };
        }
        function C() {
          return String(m++);
        }
        function S(e) {
          var t = e.isOpen,
            n = e.resultCount,
            r = e.previousResultCount;
          return t ? n ? n !== r ? n + " result" + (1 === n ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
        }
        function E(e, t) {
          return !(e = Array.isArray(e) ? e[0] : e) && t ? t : e;
        }
        function _(e) {
          return "string" == typeof e.type;
        }
        function P(e) {
          return e.props;
        }
        var k = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
        function A(e) {
          void 0 === e && (e = {});
          var t = {};
          return k.forEach(function (n) {
            e.hasOwnProperty(n) && (t[n] = e[n]);
          }), t;
        }
        function z(e, t) {
          return Object.keys(e).reduce(function (n, r) {
            return n[r] = T(t, r) ? t[r] : e[r], n;
          }, {});
        }
        function T(e, t) {
          return void 0 !== e[t];
        }
        function O(e) {
          var t = e.key,
            n = e.keyCode;
          return n >= 37 && n <= 40 && 0 !== t.indexOf("Arrow") ? "Arrow" + t : t;
        }
        function I(e, t, n, r, o) {
          if (void 0 === o && (o = !0), 0 === n) return -1;
          var i = n - 1;
          ("number" != typeof t || t < 0 || t >= n) && (t = e > 0 ? -1 : i + 1);
          var a = t + e;
          a < 0 ? a = o ? i : 0 : a > i && (a = o ? 0 : i);
          var s = F(e, a, n, r, o);
          return -1 === s ? t >= n ? -1 : t : s;
        }
        function F(e, t, n, r, o) {
          var i = r(t);
          if (!i || !i.hasAttribute("disabled")) return t;
          if (e > 0) {
            for (var a = t + 1; a < n; a++) if (!r(a).hasAttribute("disabled")) return a;
          } else for (var s = t - 1; s >= 0; s--) if (!r(s).hasAttribute("disabled")) return s;
          return o ? e > 0 ? F(1, 0, n, r, !1) : F(-1, n - 1, n, r, !1) : -1;
        }
        function M(e, t, n, r) {
          return void 0 === r && (r = !0), t.some(function (t) {
            return t && (b(t, e, n) || r && b(t, n.document.activeElement, n));
          });
        }
        var R = w(function (e) {
          B(e).textContent = "";
        }, 500);
        function j(e, t) {
          var n = B(t);
          e && (n.textContent = e, R(t));
        }
        function B(e) {
          void 0 === e && (e = document);
          var t = e.getElementById("a11y-status-message");
          return t || ((t = e.createElement("div")).setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
            border: "0",
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: "0",
            position: "absolute",
            width: "1px"
          }), e.body.appendChild(t), t);
        }
        var N = Object.freeze({
            __proto__: null,
            unknown: 0,
            mouseUp: 1,
            itemMouseEnter: 2,
            keyDownArrowUp: 3,
            keyDownArrowDown: 4,
            keyDownEscape: 5,
            keyDownEnter: 6,
            keyDownHome: 7,
            keyDownEnd: 8,
            clickItem: 9,
            blurInput: 10,
            changeInput: 11,
            keyDownSpaceButton: 12,
            clickButton: 13,
            blurButton: 14,
            controlledPropUpdatedSelectedItem: 15,
            touchEnd: 16
          }),
          L = ["refKey", "ref"],
          V = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"],
          K = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"],
          q = ["refKey", "ref"],
          H = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"],
          U = function () {
            var e = function (e) {
              var t, n;
              function s(t) {
                var n;
                (n = e.call(this, t) || this).id = n.props.id || "downshift-" + C(), n.menuId = n.props.menuId || n.id + "-menu", n.labelId = n.props.labelId || n.id + "-label", n.inputId = n.props.inputId || n.id + "-input", n.getItemId = n.props.getItemId || function (e) {
                  return n.id + "-item-" + e;
                }, n.input = null, n.items = [], n.itemCount = null, n.previousResultCount = 0, n.timeoutIds = [], n.internalSetTimeout = function (e, t) {
                  var r = setTimeout(function () {
                    n.timeoutIds = n.timeoutIds.filter(function (e) {
                      return e !== r;
                    }), e();
                  }, t);
                  n.timeoutIds.push(r);
                }, n.setItemCount = function (e) {
                  n.itemCount = e;
                }, n.unsetItemCount = function () {
                  n.itemCount = null;
                }, n.setHighlightedIndex = function (e, t) {
                  void 0 === e && (e = n.props.defaultHighlightedIndex), void 0 === t && (t = {}), t = A(t), n.internalSetState(o({
                    highlightedIndex: e
                  }, t));
                }, n.clearSelection = function (e) {
                  n.internalSetState({
                    selectedItem: null,
                    inputValue: "",
                    highlightedIndex: n.props.defaultHighlightedIndex,
                    isOpen: n.props.defaultIsOpen
                  }, e);
                }, n.selectItem = function (e, t, r) {
                  t = A(t), n.internalSetState(o({
                    isOpen: n.props.defaultIsOpen,
                    highlightedIndex: n.props.defaultHighlightedIndex,
                    selectedItem: e,
                    inputValue: n.props.itemToString(e)
                  }, t), r);
                }, n.selectItemAtIndex = function (e, t, r) {
                  var o = n.items[e];
                  null != o && n.selectItem(o, t, r);
                }, n.selectHighlightedItem = function (e, t) {
                  return n.selectItemAtIndex(n.getState().highlightedIndex, e, t);
                }, n.internalSetState = function (e, t) {
                  var r,
                    i,
                    a = {},
                    s = "function" == typeof e;
                  return !s && e.hasOwnProperty("inputValue") && n.props.onInputValueChange(e.inputValue, o({}, n.getStateAndHelpers(), e)), n.setState(function (t) {
                    t = n.getState(t);
                    var l = s ? e(t) : e;
                    l = n.props.stateReducer(t, l), r = l.hasOwnProperty("selectedItem");
                    var u = {},
                      c = {};
                    return r && l.selectedItem !== t.selectedItem && (i = l.selectedItem), l.type = l.type || 0, Object.keys(l).forEach(function (e) {
                      t[e] !== l[e] && (a[e] = l[e]), "type" !== e && (c[e] = l[e], T(n.props, e) || (u[e] = l[e]));
                    }), s && l.hasOwnProperty("inputValue") && n.props.onInputValueChange(l.inputValue, o({}, n.getStateAndHelpers(), l)), u;
                  }, function () {
                    g(t)(), Object.keys(a).length > 1 && n.props.onStateChange(a, n.getStateAndHelpers()), r && n.props.onSelect(e.selectedItem, n.getStateAndHelpers()), void 0 !== i && n.props.onChange(i, n.getStateAndHelpers()), n.props.onUserAction(a, n.getStateAndHelpers());
                  });
                }, n.rootRef = function (e) {
                  return n._rootNode = e;
                }, n.getRootProps = function (e, t) {
                  var i,
                    a = void 0 === e ? {} : e,
                    s = a.refKey,
                    l = void 0 === s ? "ref" : s,
                    u = a.ref,
                    c = r(a, L),
                    d = (void 0 === t ? {} : t).suppressRefError,
                    p = void 0 !== d && d;
                  n.getRootProps.called = !0, n.getRootProps.refKey = l, n.getRootProps.suppressRefError = p;
                  var h = n.getState().isOpen;
                  return o(((i = {})[l] = D(u, n.rootRef), i.role = "combobox", i["aria-expanded"] = h, i["aria-haspopup"] = "listbox", i["aria-owns"] = h ? n.menuId : null, i["aria-labelledby"] = n.labelId, i), c);
                }, n.keyDownHandlers = {
                  ArrowDown: function (e) {
                    var t = this;
                    if (e.preventDefault(), this.getState().isOpen) {
                      var n = e.shiftKey ? 5 : 1;
                      this.moveHighlightedIndex(n, {
                        type: 4
                      });
                    } else this.internalSetState({
                      isOpen: !0,
                      type: 4
                    }, function () {
                      var e = t.getItemCount();
                      if (e > 0) {
                        var n = I(1, t.getState().highlightedIndex, e, function (e) {
                          return t.getItemNodeFromIndex(e);
                        });
                        t.setHighlightedIndex(n, {
                          type: 4
                        });
                      }
                    });
                  },
                  ArrowUp: function (e) {
                    var t = this;
                    if (e.preventDefault(), this.getState().isOpen) {
                      var n = e.shiftKey ? -5 : -1;
                      this.moveHighlightedIndex(n, {
                        type: 3
                      });
                    } else this.internalSetState({
                      isOpen: !0,
                      type: 3
                    }, function () {
                      var e = t.getItemCount();
                      if (e > 0) {
                        var n = I(-1, t.getState().highlightedIndex, e, function (e) {
                          return t.getItemNodeFromIndex(e);
                        });
                        t.setHighlightedIndex(n, {
                          type: 3
                        });
                      }
                    });
                  },
                  Enter: function (e) {
                    if (229 !== e.which) {
                      var t = this.getState(),
                        n = t.isOpen,
                        r = t.highlightedIndex;
                      if (n && null != r) {
                        e.preventDefault();
                        var o = this.items[r],
                          i = this.getItemNodeFromIndex(r);
                        if (null == o || i && i.hasAttribute("disabled")) return;
                        this.selectHighlightedItem({
                          type: 6
                        });
                      }
                    }
                  },
                  Escape: function (e) {
                    e.preventDefault(), this.reset(o({
                      type: 5
                    }, !this.state.isOpen && {
                      selectedItem: null,
                      inputValue: ""
                    }));
                  }
                }, n.buttonKeyDownHandlers = o({}, n.keyDownHandlers, {
                  " ": function (e) {
                    e.preventDefault(), this.toggleMenu({
                      type: 12
                    });
                  }
                }), n.inputKeyDownHandlers = o({}, n.keyDownHandlers, {
                  Home: function (e) {
                    var t = this,
                      n = this.getState().isOpen;
                    if (n) {
                      e.preventDefault();
                      var r = this.getItemCount();
                      if (!(r <= 0) && n) {
                        var o = F(1, 0, r, function (e) {
                          return t.getItemNodeFromIndex(e);
                        }, !1);
                        this.setHighlightedIndex(o, {
                          type: 7
                        });
                      }
                    }
                  },
                  End: function (e) {
                    var t = this,
                      n = this.getState().isOpen;
                    if (n) {
                      e.preventDefault();
                      var r = this.getItemCount();
                      if (!(r <= 0) && n) {
                        var o = F(-1, r - 1, r, function (e) {
                          return t.getItemNodeFromIndex(e);
                        }, !1);
                        this.setHighlightedIndex(o, {
                          type: 8
                        });
                      }
                    }
                  }
                }), n.getToggleButtonProps = function (e) {
                  var t = void 0 === e ? {} : e,
                    i = t.onClick;
                  t.onPress;
                  var a = t.onKeyDown,
                    s = t.onKeyUp,
                    l = t.onBlur,
                    u = r(t, V),
                    c = n.getState().isOpen,
                    d = {
                      onClick: x(i, n.buttonHandleClick),
                      onKeyDown: x(a, n.buttonHandleKeyDown),
                      onKeyUp: x(s, n.buttonHandleKeyUp),
                      onBlur: x(l, n.buttonHandleBlur)
                    };
                  return o({
                    type: "button",
                    role: "button",
                    "aria-label": c ? "close menu" : "open menu",
                    "aria-haspopup": !0,
                    "data-toggle": !0
                  }, u.disabled ? {} : d, u);
                }, n.buttonHandleKeyUp = function (e) {
                  e.preventDefault();
                }, n.buttonHandleKeyDown = function (e) {
                  var t = O(e);
                  n.buttonKeyDownHandlers[t] && n.buttonKeyDownHandlers[t].call(i(n), e);
                }, n.buttonHandleClick = function (e) {
                  e.preventDefault(), n.props.environment.document.activeElement === n.props.environment.document.body && e.target.focus(), n.internalSetTimeout(function () {
                    return n.toggleMenu({
                      type: 13
                    });
                  });
                }, n.buttonHandleBlur = function (e) {
                  var t = e.target;
                  n.internalSetTimeout(function () {
                    n.isMouseDown || null != n.props.environment.document.activeElement && n.props.environment.document.activeElement.id === n.inputId || n.props.environment.document.activeElement === t || n.reset({
                      type: 14
                    });
                  });
                }, n.getLabelProps = function (e) {
                  return o({
                    htmlFor: n.inputId,
                    id: n.labelId
                  }, e);
                }, n.getInputProps = function (e) {
                  var t = void 0 === e ? {} : e,
                    i = t.onKeyDown,
                    a = t.onBlur,
                    s = t.onChange,
                    l = t.onInput;
                  t.onChangeText;
                  var u = r(t, K),
                    c = {};
                  var d,
                    p = n.getState(),
                    h = p.inputValue,
                    f = p.isOpen,
                    m = p.highlightedIndex;
                  u.disabled || ((d = {}).onChange = x(s, l, n.inputHandleChange), d.onKeyDown = x(i, n.inputHandleKeyDown), d.onBlur = x(a, n.inputHandleBlur), c = d);
                  return o({
                    "aria-autocomplete": "list",
                    "aria-activedescendant": f && "number" == typeof m && m >= 0 ? n.getItemId(m) : null,
                    "aria-controls": f ? n.menuId : null,
                    "aria-labelledby": n.labelId,
                    autoComplete: "off",
                    value: h,
                    id: n.inputId
                  }, c, u);
                }, n.inputHandleKeyDown = function (e) {
                  var t = O(e);
                  t && n.inputKeyDownHandlers[t] && n.inputKeyDownHandlers[t].call(i(n), e);
                }, n.inputHandleChange = function (e) {
                  n.internalSetState({
                    type: 11,
                    isOpen: !0,
                    inputValue: e.target.value,
                    highlightedIndex: n.props.defaultHighlightedIndex
                  });
                }, n.inputHandleBlur = function () {
                  n.internalSetTimeout(function () {
                    var e = n.props.environment.document && !!n.props.environment.document.activeElement && !!n.props.environment.document.activeElement.dataset && n.props.environment.document.activeElement.dataset.toggle && n._rootNode && n._rootNode.contains(n.props.environment.document.activeElement);
                    n.isMouseDown || e || n.reset({
                      type: 10
                    });
                  });
                }, n.menuRef = function (e) {
                  n._menuNode = e;
                }, n.getMenuProps = function (e, t) {
                  var i,
                    a = void 0 === e ? {} : e,
                    s = a.refKey,
                    l = void 0 === s ? "ref" : s,
                    u = a.ref,
                    c = r(a, q),
                    d = (void 0 === t ? {} : t).suppressRefError,
                    p = void 0 !== d && d;
                  return n.getMenuProps.called = !0, n.getMenuProps.refKey = l, n.getMenuProps.suppressRefError = p, o(((i = {})[l] = D(u, n.menuRef), i.role = "listbox", i["aria-labelledby"] = c && c["aria-label"] ? null : n.labelId, i.id = n.menuId, i), c);
                }, n.getItemProps = function (e) {
                  var t,
                    i = void 0 === e ? {} : e,
                    a = i.onMouseMove,
                    s = i.onMouseDown,
                    l = i.onClick;
                  i.onPress;
                  var u = i.index,
                    c = i.item,
                    d = void 0 === c ? void 0 : c,
                    p = r(i, H);
                  void 0 === u ? (n.items.push(d), u = n.items.indexOf(d)) : n.items[u] = d;
                  var h = l,
                    f = ((t = {
                      onMouseMove: x(a, function () {
                        u !== n.getState().highlightedIndex && (n.setHighlightedIndex(u, {
                          type: 2
                        }), n.avoidScrolling = !0, n.internalSetTimeout(function () {
                          return n.avoidScrolling = !1;
                        }, 250));
                      }),
                      onMouseDown: x(s, function (e) {
                        e.preventDefault();
                      })
                    }).onClick = x(h, function () {
                      n.selectItemAtIndex(u, {
                        type: 9
                      });
                    }), t),
                    m = p.disabled ? {
                      onMouseDown: f.onMouseDown
                    } : f;
                  return o({
                    id: n.getItemId(u),
                    role: "option",
                    "aria-selected": n.getState().highlightedIndex === u
                  }, m, p);
                }, n.clearItems = function () {
                  n.items = [];
                }, n.reset = function (e, t) {
                  void 0 === e && (e = {}), e = A(e), n.internalSetState(function (t) {
                    var r = t.selectedItem;
                    return o({
                      isOpen: n.props.defaultIsOpen,
                      highlightedIndex: n.props.defaultHighlightedIndex,
                      inputValue: n.props.itemToString(r)
                    }, e);
                  }, t);
                }, n.toggleMenu = function (e, t) {
                  void 0 === e && (e = {}), e = A(e), n.internalSetState(function (t) {
                    var r = t.isOpen;
                    return o({
                      isOpen: !r
                    }, r && {
                      highlightedIndex: n.props.defaultHighlightedIndex
                    }, e);
                  }, function () {
                    var r = n.getState(),
                      o = r.isOpen,
                      i = r.highlightedIndex;
                    o && n.getItemCount() > 0 && "number" == typeof i && n.setHighlightedIndex(i, e), g(t)();
                  });
                }, n.openMenu = function (e) {
                  n.internalSetState({
                    isOpen: !0
                  }, e);
                }, n.closeMenu = function (e) {
                  n.internalSetState({
                    isOpen: !1
                  }, e);
                }, n.updateStatus = w(function () {
                  var e = n.getState(),
                    t = n.items[e.highlightedIndex],
                    r = n.getItemCount(),
                    i = n.props.getA11yStatusMessage(o({
                      itemToString: n.props.itemToString,
                      previousResultCount: n.previousResultCount,
                      resultCount: r,
                      highlightedItem: t
                    }, e));
                  n.previousResultCount = r, j(i, n.props.environment.document);
                }, 200);
                var a = n.props,
                  s = a.defaultHighlightedIndex,
                  l = a.initialHighlightedIndex,
                  u = void 0 === l ? s : l,
                  c = a.defaultIsOpen,
                  d = a.initialIsOpen,
                  p = void 0 === d ? c : d,
                  h = a.initialInputValue,
                  f = void 0 === h ? "" : h,
                  m = a.initialSelectedItem,
                  v = void 0 === m ? null : m,
                  y = n.getState({
                    highlightedIndex: u,
                    isOpen: p,
                    inputValue: f,
                    selectedItem: v
                  });
                return null != y.selectedItem && void 0 === n.props.initialInputValue && (y.inputValue = n.props.itemToString(y.selectedItem)), n.state = y, n;
              }
              n = e, (t = s).prototype = Object.create(n.prototype), t.prototype.constructor = t, a(t, n);
              var l = s.prototype;
              return l.internalClearTimeouts = function () {
                this.timeoutIds.forEach(function (e) {
                  clearTimeout(e);
                }), this.timeoutIds = [];
              }, l.getState = function (e) {
                return void 0 === e && (e = this.state), z(e, this.props);
              }, l.getItemCount = function () {
                var e = this.items.length;
                return null != this.itemCount ? e = this.itemCount : void 0 !== this.props.itemCount && (e = this.props.itemCount), e;
              }, l.getItemNodeFromIndex = function (e) {
                return this.props.environment.document.getElementById(this.getItemId(e));
              }, l.scrollHighlightedItemIntoView = function () {
                var e = this.getItemNodeFromIndex(this.getState().highlightedIndex);
                this.props.scrollIntoView(e, this._menuNode);
              }, l.moveHighlightedIndex = function (e, t) {
                var n = this,
                  r = this.getItemCount(),
                  o = this.getState().highlightedIndex;
                if (r > 0) {
                  var i = I(e, o, r, function (e) {
                    return n.getItemNodeFromIndex(e);
                  });
                  this.setHighlightedIndex(i, t);
                }
              }, l.getStateAndHelpers = function () {
                var e = this.getState(),
                  t = e.highlightedIndex,
                  n = e.inputValue,
                  r = e.selectedItem,
                  o = e.isOpen,
                  i = this.props.itemToString,
                  a = this.id,
                  s = this.getRootProps,
                  l = this.getToggleButtonProps,
                  u = this.getLabelProps,
                  c = this.getMenuProps,
                  d = this.getInputProps,
                  p = this.getItemProps,
                  h = this.openMenu,
                  f = this.closeMenu,
                  m = this.toggleMenu,
                  g = this.selectItem,
                  v = this.selectItemAtIndex,
                  y = this.selectHighlightedItem,
                  b = this.setHighlightedIndex,
                  w = this.clearSelection,
                  x = this.clearItems;
                return {
                  getRootProps: s,
                  getToggleButtonProps: l,
                  getLabelProps: u,
                  getMenuProps: c,
                  getInputProps: d,
                  getItemProps: p,
                  reset: this.reset,
                  openMenu: h,
                  closeMenu: f,
                  toggleMenu: m,
                  selectItem: g,
                  selectItemAtIndex: v,
                  selectHighlightedItem: y,
                  setHighlightedIndex: b,
                  clearSelection: w,
                  clearItems: x,
                  setItemCount: this.setItemCount,
                  unsetItemCount: this.unsetItemCount,
                  setState: this.internalSetState,
                  itemToString: i,
                  id: a,
                  highlightedIndex: t,
                  inputValue: n,
                  isOpen: o,
                  selectedItem: r
                };
              }, l.componentDidMount = function () {
                var e = this;
                var t = function () {
                    e.isMouseDown = !0;
                  },
                  n = function (t) {
                    e.isMouseDown = !1, !M(t.target, [e._rootNode, e._menuNode], e.props.environment) && e.getState().isOpen && e.reset({
                      type: 1
                    }, function () {
                      return e.props.onOuterClick(e.getStateAndHelpers());
                    });
                  },
                  r = function () {
                    e.isTouchMove = !1;
                  },
                  o = function () {
                    e.isTouchMove = !0;
                  },
                  i = function (t) {
                    var n = M(t.target, [e._rootNode, e._menuNode], e.props.environment, !1);
                    e.isTouchMove || n || !e.getState().isOpen || e.reset({
                      type: 16
                    }, function () {
                      return e.props.onOuterClick(e.getStateAndHelpers());
                    });
                  },
                  a = this.props.environment;
                a.addEventListener("mousedown", t), a.addEventListener("mouseup", n), a.addEventListener("touchstart", r), a.addEventListener("touchmove", o), a.addEventListener("touchend", i), this.cleanup = function () {
                  e.internalClearTimeouts(), e.updateStatus.cancel(), a.removeEventListener("mousedown", t), a.removeEventListener("mouseup", n), a.removeEventListener("touchstart", r), a.removeEventListener("touchmove", o), a.removeEventListener("touchend", i);
                };
              }, l.shouldScroll = function (e, t) {
                var n = (void 0 === this.props.highlightedIndex ? this.getState() : this.props).highlightedIndex,
                  r = (void 0 === t.highlightedIndex ? e : t).highlightedIndex;
                return n && this.getState().isOpen && !e.isOpen || n !== r;
              }, l.componentDidUpdate = function (e, t) {
                T(this.props, "selectedItem") && this.props.selectedItemChanged(e.selectedItem, this.props.selectedItem) && this.internalSetState({
                  type: 15,
                  inputValue: this.props.itemToString(this.props.selectedItem)
                }), !this.avoidScrolling && this.shouldScroll(t, e) && this.scrollHighlightedItemIntoView(), this.updateStatus();
              }, l.componentWillUnmount = function () {
                this.cleanup();
              }, l.render = function () {
                var e = E(this.props.children, v);
                this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
                var t = E(e(this.getStateAndHelpers()));
                return t ? this.getRootProps.called || this.props.suppressRefError ? t : _(t) ? (0, u.cloneElement)(t, this.getRootProps(P(t))) : void 0 : null;
              }, s;
            }(u.Component);
            return e.defaultProps = {
              defaultHighlightedIndex: null,
              defaultIsOpen: !1,
              getA11yStatusMessage: S,
              itemToString: function (e) {
                return null == e ? "" : String(e);
              },
              onStateChange: v,
              onInputValueChange: v,
              onUserAction: v,
              onChange: v,
              onSelect: v,
              onOuterClick: v,
              selectedItemChanged: function (e, t) {
                return e !== t;
              },
              environment: "undefined" == typeof window ? {} : window,
              stateReducer: function (e, t) {
                return t;
              },
              suppressRefError: !1,
              scrollIntoView: y
            }, e.stateChangeTypes = N, e;
          }(),
          Z = U;
        var $ = ["isInitialMount", "highlightedIndex", "items", "environment"],
          G = {
            highlightedIndex: -1,
            isOpen: !1,
            selectedItem: null,
            inputValue: ""
          };
        function W(e, t, n) {
          var r = e.props,
            i = e.type,
            a = {};
          Object.keys(t).forEach(function (r) {
            !function (e, t, n, r) {
              var i = t.props,
                a = t.type,
                s = "on" + te(e) + "Change";
              i[s] && void 0 !== r[e] && r[e] !== n[e] && i[s](o({
                type: a
              }, r));
            }(r, e, t, n), n[r] !== t[r] && (a[r] = n[r]);
          }), r.onStateChange && Object.keys(a).length && r.onStateChange(o({
            type: i
          }, a));
        }
        var Y = w(function (e, t) {
            j(e(), t);
          }, 200),
          X = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement ? u.useLayoutEffect : u.useEffect;
        function Q(e) {
          var t = e.id,
            n = void 0 === t ? "downshift-" + C() : t,
            r = e.labelId,
            o = e.menuId,
            i = e.getItemId,
            a = e.toggleButtonId,
            s = e.inputId;
          return (0, u.useRef)({
            labelId: r || n + "-label",
            menuId: o || n + "-menu",
            getItemId: i || function (e) {
              return n + "-item-" + e;
            },
            toggleButtonId: a || n + "-toggle-button",
            inputId: s || n + "-input"
          }).current;
        }
        function J(e, t, n) {
          return void 0 !== e ? e : 0 === n.length ? -1 : n.indexOf(t);
        }
        function ee(e) {
          return /^\S{1}$/.test(e);
        }
        function te(e) {
          return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
        }
        function ne(e) {
          var t = (0, u.useRef)(e);
          return t.current = e, t;
        }
        function re(e, t, n) {
          var r = (0, u.useRef)(),
            i = (0, u.useRef)(),
            a = (0, u.useCallback)(function (t, n) {
              i.current = n, t = z(t, n.props);
              var r = e(t, n);
              return n.props.stateReducer(t, o({}, n, {
                changes: r
              }));
            }, [e]),
            s = (0, u.useReducer)(a, t),
            l = s[0],
            c = s[1],
            d = ne(n),
            p = (0, u.useCallback)(function (e) {
              return c(o({
                props: d.current
              }, e));
            }, [d]),
            h = i.current;
          return (0, u.useEffect)(function () {
            h && r.current && r.current !== l && W(h, z(r.current, h.props), l), r.current = l;
          }, [l, n, h]), [l, p];
        }
        function oe(e, t, n) {
          var r = re(e, t, n),
            o = r[0],
            i = r[1];
          return [z(o, n), i];
        }
        var ie = {
          itemToString: function (e) {
            return e ? String(e) : "";
          },
          stateReducer: function (e, t) {
            return t.changes;
          },
          getA11ySelectionMessage: function (e) {
            var t = e.selectedItem,
              n = e.itemToString;
            return t ? n(t) + " has been selected." : "";
          },
          scrollIntoView: y,
          circularNavigation: !1,
          environment: "undefined" == typeof window ? {} : window
        };
        function ae(e, t, n) {
          void 0 === n && (n = G);
          var r = "default" + te(t);
          return r in e ? e[r] : n[t];
        }
        function se(e, t, n) {
          if (void 0 === n && (n = G), t in e) return e[t];
          var r = "initial" + te(t);
          return r in e ? e[r] : ae(e, t, n);
        }
        function le(e) {
          var t = se(e, "selectedItem"),
            n = se(e, "isOpen"),
            r = se(e, "highlightedIndex"),
            o = se(e, "inputValue");
          return {
            highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
            isOpen: n,
            selectedItem: t,
            inputValue: o
          };
        }
        function ue(e, t, n, r) {
          var o = e.items,
            i = e.initialHighlightedIndex,
            a = e.defaultHighlightedIndex,
            s = t.selectedItem,
            l = t.highlightedIndex;
          return 0 === o.length ? -1 : void 0 !== i && l === i ? i : void 0 !== a ? a : s ? 0 === n ? o.indexOf(s) : I(n, o.indexOf(s), o.length, r, !1) : 0 === n ? -1 : n < 0 ? o.length - 1 : 0;
        }
        function ce(e, t, n, r) {
          var o = (0, u.useRef)({
            isMouseDown: !1,
            isTouchMove: !1
          });
          return (0, u.useEffect)(function () {
            var i = function () {
                o.current.isMouseDown = !0;
              },
              a = function (i) {
                o.current.isMouseDown = !1, e && !M(i.target, t.map(function (e) {
                  return e.current;
                }), n) && r();
              },
              s = function () {
                o.current.isTouchMove = !1;
              },
              l = function () {
                o.current.isTouchMove = !0;
              },
              u = function (i) {
                !e || o.current.isTouchMove || M(i.target, t.map(function (e) {
                  return e.current;
                }), n, !1) || r();
              };
            return n.addEventListener("mousedown", i), n.addEventListener("mouseup", a), n.addEventListener("touchstart", s), n.addEventListener("touchmove", l), n.addEventListener("touchend", u), function () {
              n.removeEventListener("mousedown", i), n.removeEventListener("mouseup", a), n.removeEventListener("touchstart", s), n.removeEventListener("touchmove", l), n.removeEventListener("touchend", u);
            };
          }, [e, n]), o;
        }
        var de = function () {
          return v;
        };
        function pe(e, t, n) {
          var i = n.isInitialMount,
            a = n.highlightedIndex,
            s = n.items,
            l = n.environment,
            c = r(n, $);
          (0, u.useEffect)(function () {
            i || Y(function () {
              return e(o({
                highlightedIndex: a,
                highlightedItem: s[a],
                resultCount: s.length
              }, c));
            }, l.document);
          }, t);
        }
        function he(e) {
          var t = e.highlightedIndex,
            n = e.isOpen,
            r = e.itemRefs,
            o = e.getItemNodeFromIndex,
            i = e.menuElement,
            a = e.scrollIntoView,
            s = (0, u.useRef)(!0);
          return X(function () {
            t < 0 || !n || !Object.keys(r.current).length || (!1 === s.current ? s.current = !0 : a(o(t), i));
          }, [t]), s;
        }
        var fe = v;
        function me(e, t, n) {
          var r,
            i = t.type,
            a = t.props;
          switch (i) {
            case n.ItemMouseMove:
              r = {
                highlightedIndex: t.index
              };
              break;
            case n.MenuMouseLeave:
              r = {
                highlightedIndex: -1
              };
              break;
            case n.ToggleButtonClick:
            case n.FunctionToggleMenu:
              r = {
                isOpen: !e.isOpen,
                highlightedIndex: e.isOpen ? -1 : ue(a, e, 0)
              };
              break;
            case n.FunctionOpenMenu:
              r = {
                isOpen: !0,
                highlightedIndex: ue(a, e, 0)
              };
              break;
            case n.FunctionCloseMenu:
              r = {
                isOpen: !1
              };
              break;
            case n.FunctionSetHighlightedIndex:
              r = {
                highlightedIndex: t.highlightedIndex
              };
              break;
            case n.FunctionSetInputValue:
              r = {
                inputValue: t.inputValue
              };
              break;
            case n.FunctionReset:
              r = {
                highlightedIndex: ae(a, "highlightedIndex"),
                isOpen: ae(a, "isOpen"),
                selectedItem: ae(a, "selectedItem"),
                inputValue: ae(a, "inputValue")
              };
              break;
            default:
              throw new Error("Reducer called without proper action type.");
          }
          return o({}, e, r);
        }
        function ge(e) {
          for (var t = e.keysSoFar, n = e.highlightedIndex, r = e.items, o = e.itemToString, i = e.getItemNodeFromIndex, a = t.toLowerCase(), s = 0; s < r.length; s++) {
            var l = (s + n + 1) % r.length,
              u = r[l];
            if (void 0 !== u && o(u).toLowerCase().startsWith(a)) {
              var c = i(l);
              if (!(null == c ? void 0 : c.hasAttribute("disabled"))) return l;
            }
          }
          return n;
        }
        l().array.isRequired, l().func, l().func, l().func, l().bool, l().number, l().number, l().number, l().bool, l().bool, l().bool, l().any, l().any, l().any, l().string, l().string, l().string, l().func, l().string, l().func, l().func, l().func, l().func, l().func, l().shape({
          addEventListener: l().func,
          removeEventListener: l().func,
          document: l().shape({
            getElementById: l().func,
            activeElement: l().any,
            body: l().any
          })
        });
        var ve = f(f({}, ie), {
            getA11yStatusMessage: function (e) {
              var t = e.isOpen,
                n = e.resultCount,
                r = e.previousResultCount;
              return t ? n ? n !== r ? n + " result" + (1 === n ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select." : "" : "No results are available." : "";
            }
          }),
          ye = v;
        var be = Object.freeze({
          __proto__: null,
          MenuKeyDownArrowDown: 0,
          MenuKeyDownArrowUp: 1,
          MenuKeyDownEscape: 2,
          MenuKeyDownHome: 3,
          MenuKeyDownEnd: 4,
          MenuKeyDownEnter: 5,
          MenuKeyDownSpaceButton: 6,
          MenuKeyDownCharacter: 7,
          MenuBlur: 8,
          MenuMouseLeave: 9,
          ItemMouseMove: 10,
          ItemClick: 11,
          ToggleButtonClick: 12,
          ToggleButtonKeyDownArrowDown: 13,
          ToggleButtonKeyDownArrowUp: 14,
          ToggleButtonKeyDownCharacter: 15,
          FunctionToggleMenu: 16,
          FunctionOpenMenu: 17,
          FunctionCloseMenu: 18,
          FunctionSetHighlightedIndex: 19,
          FunctionSelectItem: 20,
          FunctionSetInputValue: 21,
          FunctionReset: 22
        });
        function we(e, t) {
          var n,
            r = t.type,
            i = t.props,
            a = t.shiftKey;
          switch (r) {
            case 11:
              n = {
                isOpen: ae(i, "isOpen"),
                highlightedIndex: ae(i, "highlightedIndex"),
                selectedItem: i.items[t.index]
              };
              break;
            case 15:
              var s = t.key,
                l = "" + e.inputValue + s,
                u = ge({
                  keysSoFar: l,
                  highlightedIndex: e.selectedItem ? i.items.indexOf(e.selectedItem) : -1,
                  items: i.items,
                  itemToString: i.itemToString,
                  getItemNodeFromIndex: t.getItemNodeFromIndex
                });
              n = o({
                inputValue: l
              }, u >= 0 && {
                selectedItem: i.items[u]
              });
              break;
            case 13:
              n = {
                highlightedIndex: ue(i, e, 1, t.getItemNodeFromIndex),
                isOpen: !0
              };
              break;
            case 14:
              n = {
                highlightedIndex: ue(i, e, -1, t.getItemNodeFromIndex),
                isOpen: !0
              };
              break;
            case 5:
            case 6:
              n = o({
                isOpen: ae(i, "isOpen"),
                highlightedIndex: ae(i, "highlightedIndex")
              }, e.highlightedIndex >= 0 && {
                selectedItem: i.items[e.highlightedIndex]
              });
              break;
            case 3:
              n = {
                highlightedIndex: F(1, 0, i.items.length, t.getItemNodeFromIndex, !1)
              };
              break;
            case 4:
              n = {
                highlightedIndex: F(-1, i.items.length - 1, i.items.length, t.getItemNodeFromIndex, !1)
              };
              break;
            case 2:
            case 8:
              n = {
                isOpen: !1,
                highlightedIndex: -1
              };
              break;
            case 7:
              var c = t.key,
                d = "" + e.inputValue + c,
                p = ge({
                  keysSoFar: d,
                  highlightedIndex: e.highlightedIndex,
                  items: i.items,
                  itemToString: i.itemToString,
                  getItemNodeFromIndex: t.getItemNodeFromIndex
                });
              n = o({
                inputValue: d
              }, p >= 0 && {
                highlightedIndex: p
              });
              break;
            case 0:
              n = {
                highlightedIndex: I(a ? 5 : 1, e.highlightedIndex, i.items.length, t.getItemNodeFromIndex, i.circularNavigation)
              };
              break;
            case 1:
              n = {
                highlightedIndex: I(a ? -5 : -1, e.highlightedIndex, i.items.length, t.getItemNodeFromIndex, i.circularNavigation)
              };
              break;
            case 20:
              n = {
                selectedItem: t.selectedItem
              };
              break;
            default:
              return me(e, t, be);
          }
          return o({}, e, n);
        }
        var xe = ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"],
          De = ["onClick", "onKeyDown", "refKey", "ref"],
          Ce = ["item", "index", "onMouseMove", "onClick", "refKey", "ref"];
        function Se(e) {
          void 0 === e && (e = {}), ye(e, Se);
          var t = o({}, ve, e),
            n = t.items,
            i = t.scrollIntoView,
            a = t.environment,
            s = t.initialIsOpen,
            l = t.defaultIsOpen,
            c = t.itemToString,
            d = t.getA11ySelectionMessage,
            p = t.getA11yStatusMessage,
            h = oe(we, le(t), t),
            f = h[0],
            m = h[1],
            g = f.isOpen,
            v = f.highlightedIndex,
            y = f.selectedItem,
            b = f.inputValue,
            C = (0, u.useRef)(null),
            S = (0, u.useRef)(null),
            E = (0, u.useRef)({}),
            _ = (0, u.useRef)(!0),
            P = (0, u.useRef)(null),
            k = Q(t),
            A = (0, u.useRef)(),
            z = (0, u.useRef)(!0),
            T = ne({
              state: f,
              props: t
            }),
            I = (0, u.useCallback)(function (e) {
              return E.current[k.getItemId(e)];
            }, [k]);
          pe(p, [g, v, b, n], o({
            isInitialMount: z.current,
            previousResultCount: A.current,
            items: n,
            environment: a,
            itemToString: c
          }, f)), pe(d, [y], o({
            isInitialMount: z.current,
            previousResultCount: A.current,
            items: n,
            environment: a,
            itemToString: c
          }, f));
          var F = he({
            menuElement: S.current,
            highlightedIndex: v,
            isOpen: g,
            itemRefs: E,
            scrollIntoView: i,
            getItemNodeFromIndex: I
          });
          (0, u.useEffect)(function () {
            return P.current = w(function (e) {
              e({
                type: 21,
                inputValue: ""
              });
            }, 500), function () {
              P.current.cancel();
            };
          }, []), (0, u.useEffect)(function () {
            b && P.current(m);
          }, [m, b]), fe({
            isInitialMount: z.current,
            props: t,
            state: f
          }), (0, u.useEffect)(function () {
            z.current ? (s || l || g) && S.current && S.current.focus() : g ? S.current && S.current.focus() : a.document.activeElement === S.current && C.current && (_.current = !1, C.current.focus());
          }, [g]), (0, u.useEffect)(function () {
            z.current || (A.current = n.length);
          });
          var M = ce(g, [S, C], a, function () {
              m({
                type: 8
              });
            }),
            R = de();
          (0, u.useEffect)(function () {
            z.current = !1;
          }, []), (0, u.useEffect)(function () {
            g || (E.current = {});
          }, [g]);
          var j = (0, u.useMemo)(function () {
              return {
                ArrowDown: function (e) {
                  e.preventDefault(), m({
                    type: 13,
                    getItemNodeFromIndex: I,
                    shiftKey: e.shiftKey
                  });
                },
                ArrowUp: function (e) {
                  e.preventDefault(), m({
                    type: 14,
                    getItemNodeFromIndex: I,
                    shiftKey: e.shiftKey
                  });
                }
              };
            }, [m, I]),
            B = (0, u.useMemo)(function () {
              return {
                ArrowDown: function (e) {
                  e.preventDefault(), m({
                    type: 0,
                    getItemNodeFromIndex: I,
                    shiftKey: e.shiftKey
                  });
                },
                ArrowUp: function (e) {
                  e.preventDefault(), m({
                    type: 1,
                    getItemNodeFromIndex: I,
                    shiftKey: e.shiftKey
                  });
                },
                Home: function (e) {
                  e.preventDefault(), m({
                    type: 3,
                    getItemNodeFromIndex: I
                  });
                },
                End: function (e) {
                  e.preventDefault(), m({
                    type: 4,
                    getItemNodeFromIndex: I
                  });
                },
                Escape: function () {
                  m({
                    type: 2
                  });
                },
                Enter: function (e) {
                  e.preventDefault(), m({
                    type: 5
                  });
                },
                " ": function (e) {
                  e.preventDefault(), m({
                    type: 6
                  });
                }
              };
            }, [m, I]),
            N = (0, u.useCallback)(function () {
              m({
                type: 16
              });
            }, [m]),
            L = (0, u.useCallback)(function () {
              m({
                type: 18
              });
            }, [m]),
            V = (0, u.useCallback)(function () {
              m({
                type: 17
              });
            }, [m]),
            K = (0, u.useCallback)(function (e) {
              m({
                type: 19,
                highlightedIndex: e
              });
            }, [m]),
            q = (0, u.useCallback)(function (e) {
              m({
                type: 20,
                selectedItem: e
              });
            }, [m]),
            H = (0, u.useCallback)(function () {
              m({
                type: 22
              });
            }, [m]),
            U = (0, u.useCallback)(function (e) {
              m({
                type: 21,
                inputValue: e
              });
            }, [m]),
            Z = (0, u.useCallback)(function (e) {
              return o({
                id: k.labelId,
                htmlFor: k.toggleButtonId
              }, e);
            }, [k]),
            $ = (0, u.useCallback)(function (e, t) {
              var n,
                i = void 0 === e ? {} : e,
                a = i.onMouseLeave,
                s = i.refKey,
                l = void 0 === s ? "ref" : s,
                u = i.onKeyDown,
                c = i.onBlur,
                d = i.ref,
                p = r(i, xe),
                h = (void 0 === t ? {} : t).suppressRefError,
                f = void 0 !== h && h,
                g = T.current.state;
              return R("getMenuProps", f, l, S), o(((n = {})[l] = D(d, function (e) {
                S.current = e;
              }), n.id = k.menuId, n.role = "listbox", n["aria-labelledby"] = k.labelId, n.tabIndex = -1, n), g.isOpen && g.highlightedIndex > -1 && {
                "aria-activedescendant": k.getItemId(g.highlightedIndex)
              }, {
                onMouseLeave: x(a, function () {
                  m({
                    type: 9
                  });
                }),
                onKeyDown: x(u, function (e) {
                  var t = O(e);
                  t && B[t] ? B[t](e) : ee(t) && m({
                    type: 7,
                    key: t,
                    getItemNodeFromIndex: I
                  });
                }),
                onBlur: x(c, function () {
                  !1 !== _.current ? !M.current.isMouseDown && m({
                    type: 8
                  }) : _.current = !0;
                })
              }, p);
            }, [m, T, B, M, R, k, I]);
          return {
            getToggleButtonProps: (0, u.useCallback)(function (e, t) {
              var n,
                i = void 0 === e ? {} : e,
                a = i.onClick,
                s = i.onKeyDown,
                l = i.refKey,
                u = void 0 === l ? "ref" : l,
                c = i.ref,
                d = r(i, De),
                p = (void 0 === t ? {} : t).suppressRefError,
                h = void 0 !== p && p,
                f = o(((n = {})[u] = D(c, function (e) {
                  C.current = e;
                }), n.id = k.toggleButtonId, n["aria-haspopup"] = "listbox", n["aria-expanded"] = T.current.state.isOpen, n["aria-labelledby"] = k.labelId + " " + k.toggleButtonId, n), d);
              return d.disabled || (f.onClick = x(a, function () {
                m({
                  type: 12
                });
              }), f.onKeyDown = x(s, function (e) {
                var t = O(e);
                t && j[t] ? j[t](e) : ee(t) && m({
                  type: 15,
                  key: t,
                  getItemNodeFromIndex: I
                });
              })), R("getToggleButtonProps", h, u, C), f;
            }, [m, T, j, R, k, I]),
            getLabelProps: Z,
            getMenuProps: $,
            getItemProps: (0, u.useCallback)(function (e) {
              var t,
                n = void 0 === e ? {} : e,
                i = n.item,
                a = n.index,
                s = n.onMouseMove,
                l = n.onClick,
                u = n.refKey,
                c = void 0 === u ? "ref" : u,
                d = n.ref,
                p = r(n, Ce),
                h = T.current,
                f = h.state,
                g = h.props,
                v = J(a, i, g.items);
              if (v < 0) throw new Error("Pass either item or item index in getItemProps!");
              var y = o(((t = {
                role: "option",
                "aria-selected": "" + (v === f.highlightedIndex),
                id: k.getItemId(v)
              })[c] = D(d, function (e) {
                e && (E.current[k.getItemId(v)] = e);
              }), t), p);
              return p.disabled || (y.onMouseMove = x(s, function () {
                a !== f.highlightedIndex && (F.current = !1, m({
                  type: 10,
                  index: a
                }));
              }), y.onClick = x(l, function () {
                m({
                  type: 11,
                  index: a
                });
              })), y;
            }, [m, T, F, k]),
            toggleMenu: N,
            openMenu: V,
            closeMenu: L,
            setHighlightedIndex: K,
            selectItem: q,
            reset: H,
            setInputValue: U,
            highlightedIndex: v,
            isOpen: g,
            selectedItem: y,
            inputValue: b
          };
        }
        Se.stateChangeTypes = be;
        l().array.isRequired, l().func, l().func, l().func, l().bool, l().number, l().number, l().number, l().bool, l().bool, l().bool, l().any, l().any, l().any, l().string, l().string, l().string, l().string, l().string, l().string, l().func, l().string, l().string, l().func, l().func, l().func, l().func, l().func, l().func, l().shape({
          addEventListener: l().func,
          removeEventListener: l().func,
          document: l().shape({
            getElementById: l().func,
            activeElement: l().any,
            body: l().any
          })
        });
        o({}, ie, {
          getA11yStatusMessage: S,
          circularNavigation: !0
        });
        l().array, l().array, l().array, l().func, l().func, l().func, l().number, l().number, l().number, l().func, l().func, l().string, l().string, l().shape({
          addEventListener: l().func,
          removeEventListener: l().func,
          document: l().shape({
            getElementById: l().func,
            activeElement: l().any,
            body: l().any
          })
        });
      },
      64063: e => {
        "use strict";

        e.exports = function e(t, n) {
          if (t === n) return !0;
          if (t && n && "object" == typeof t && "object" == typeof n) {
            if (t.constructor !== n.constructor) return !1;
            var r, o, i;
            if (Array.isArray(t)) {
              if ((r = t.length) != n.length) return !1;
              for (o = r; 0 != o--;) if (!e(t[o], n[o])) return !1;
              return !0;
            }
            if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
            if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
            if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
            if ((r = (i = Object.keys(t)).length) !== Object.keys(n).length) return !1;
            for (o = r; 0 != o--;) if (!Object.prototype.hasOwnProperty.call(n, i[o])) return !1;
            for (o = r; 0 != o--;) {
              var a = i[o];
              if (!e(t[a], n[a])) return !1;
            }
            return !0;
          }
          return t != t && n != n;
        };
      },
      37529: e => {
        var t = -1;
        function n(e, s, l, u) {
          if (e === s) return e ? [[0, e]] : [];
          if (null != l) {
            var c = function (e, t, n) {
              var r = "number" == typeof n ? {
                  index: n,
                  length: 0
                } : n.oldRange,
                o = "number" == typeof n ? null : n.newRange,
                i = e.length,
                a = t.length;
              if (0 === r.length && (null === o || 0 === o.length)) {
                var s = r.index,
                  l = e.slice(0, s),
                  u = e.slice(s),
                  c = o ? o.index : null,
                  p = s + a - i;
                if ((null === c || c === p) && !(p < 0 || p > a)) {
                  var h = t.slice(0, p);
                  if ((g = t.slice(p)) === u) {
                    var f = Math.min(s, p);
                    if ((y = l.slice(0, f)) === (w = h.slice(0, f))) return d(y, l.slice(f), h.slice(f), u);
                  }
                }
                if (null === c || c === s) {
                  var m = s,
                    g = (h = t.slice(0, m), t.slice(m));
                  if (h === l) {
                    var v = Math.min(i - m, a - m);
                    if ((b = u.slice(u.length - v)) === (x = g.slice(g.length - v))) return d(l, u.slice(0, u.length - v), g.slice(0, g.length - v), b);
                  }
                }
              }
              if (r.length > 0 && o && 0 === o.length) {
                var y = e.slice(0, r.index),
                  b = e.slice(r.index + r.length);
                if (!(a < (f = y.length) + (v = b.length))) {
                  var w = t.slice(0, f),
                    x = t.slice(a - v);
                  if (y === w && b === x) return d(y, e.slice(f, i - v), t.slice(f, a - v), b);
                }
              }
              return null;
            }(e, s, l);
            if (c) return c;
          }
          var p = o(e, s),
            h = e.substring(0, p);
          p = i(e = e.substring(p), s = s.substring(p));
          var f = e.substring(e.length - p),
            m = function (e, a) {
              var s;
              if (!e) return [[1, a]];
              if (!a) return [[t, e]];
              var l = e.length > a.length ? e : a,
                u = e.length > a.length ? a : e,
                c = l.indexOf(u);
              if (-1 !== c) return s = [[1, l.substring(0, c)], [0, u], [1, l.substring(c + u.length)]], e.length > a.length && (s[0][0] = s[2][0] = t), s;
              if (1 === u.length) return [[t, e], [1, a]];
              var d = function (e, t) {
                var n = e.length > t.length ? e : t,
                  r = e.length > t.length ? t : e;
                if (n.length < 4 || 2 * r.length < n.length) return null;
                function a(e, t, n) {
                  for (var r, a, s, l, u = e.substring(n, n + Math.floor(e.length / 4)), c = -1, d = ""; -1 !== (c = t.indexOf(u, c + 1));) {
                    var p = o(e.substring(n), t.substring(c)),
                      h = i(e.substring(0, n), t.substring(0, c));
                    d.length < h + p && (d = t.substring(c - h, c) + t.substring(c, c + p), r = e.substring(0, n - h), a = e.substring(n + p), s = t.substring(0, c - h), l = t.substring(c + p));
                  }
                  return 2 * d.length >= e.length ? [r, a, s, l, d] : null;
                }
                var s,
                  l,
                  u,
                  c,
                  d,
                  p = a(n, r, Math.ceil(n.length / 4)),
                  h = a(n, r, Math.ceil(n.length / 2));
                if (!p && !h) return null;
                s = h ? p && p[4].length > h[4].length ? p : h : p;
                e.length > t.length ? (l = s[0], u = s[1], c = s[2], d = s[3]) : (c = s[0], d = s[1], l = s[2], u = s[3]);
                var f = s[4];
                return [l, u, c, d, f];
              }(e, a);
              if (d) {
                var p = d[0],
                  h = d[1],
                  f = d[2],
                  m = d[3],
                  g = d[4],
                  v = n(p, f),
                  y = n(h, m);
                return v.concat([[0, g]], y);
              }
              return function (e, n) {
                for (var o = e.length, i = n.length, a = Math.ceil((o + i) / 2), s = a, l = 2 * a, u = new Array(l), c = new Array(l), d = 0; d < l; d++) u[d] = -1, c[d] = -1;
                u[s + 1] = 0, c[s + 1] = 0;
                for (var p = o - i, h = p % 2 != 0, f = 0, m = 0, g = 0, v = 0, y = 0; y < a; y++) {
                  for (var b = -y + f; b <= y - m; b += 2) {
                    for (var w = s + b, x = (_ = b === -y || b !== y && u[w - 1] < u[w + 1] ? u[w + 1] : u[w - 1] + 1) - b; _ < o && x < i && e.charAt(_) === n.charAt(x);) _++, x++;
                    if (u[w] = _, _ > o) m += 2;else if (x > i) f += 2;else if (h) {
                      if ((S = s + p - b) >= 0 && S < l && -1 !== c[S]) if (_ >= (C = o - c[S])) return r(e, n, _, x);
                    }
                  }
                  for (var D = -y + g; D <= y - v; D += 2) {
                    for (var C, S = s + D, E = (C = D === -y || D !== y && c[S - 1] < c[S + 1] ? c[S + 1] : c[S - 1] + 1) - D; C < o && E < i && e.charAt(o - C - 1) === n.charAt(i - E - 1);) C++, E++;
                    if (c[S] = C, C > o) v += 2;else if (E > i) g += 2;else if (!h) {
                      if ((w = s + p - D) >= 0 && w < l && -1 !== u[w]) {
                        var _;
                        x = s + (_ = u[w]) - w;
                        if (_ >= (C = o - C)) return r(e, n, _, x);
                      }
                    }
                  }
                }
                return [[t, e], [1, n]];
              }(e, a);
            }(e = e.substring(0, e.length - p), s = s.substring(0, s.length - p));
          return h && m.unshift([0, h]), f && m.push([0, f]), a(m, u), m;
        }
        function r(e, t, r, o) {
          var i = e.substring(0, r),
            a = t.substring(0, o),
            s = e.substring(r),
            l = t.substring(o),
            u = n(i, a),
            c = n(s, l);
          return u.concat(c);
        }
        function o(e, t) {
          if (!e || !t || e.charAt(0) !== t.charAt(0)) return 0;
          for (var n = 0, r = Math.min(e.length, t.length), o = r, i = 0; n < o;) e.substring(i, o) == t.substring(i, o) ? i = n = o : r = o, o = Math.floor((r - n) / 2 + n);
          return s(e.charCodeAt(o - 1)) && o--, o;
        }
        function i(e, t) {
          if (!e || !t || e.slice(-1) !== t.slice(-1)) return 0;
          for (var n = 0, r = Math.min(e.length, t.length), o = r, i = 0; n < o;) e.substring(e.length - o, e.length - i) == t.substring(t.length - o, t.length - i) ? i = n = o : r = o, o = Math.floor((r - n) / 2 + n);
          return l(e.charCodeAt(e.length - o)) && o--, o;
        }
        function a(e, n) {
          e.push([0, ""]);
          for (var r, s = 0, l = 0, d = 0, p = "", h = ""; s < e.length;) if (s < e.length - 1 && !e[s][1]) e.splice(s, 1);else switch (e[s][0]) {
            case 1:
              d++, h += e[s][1], s++;
              break;
            case t:
              l++, p += e[s][1], s++;
              break;
            case 0:
              var f = s - d - l - 1;
              if (n) {
                if (f >= 0 && c(e[f][1])) {
                  var m = e[f][1].slice(-1);
                  if (e[f][1] = e[f][1].slice(0, -1), p = m + p, h = m + h, !e[f][1]) {
                    e.splice(f, 1), s--;
                    var g = f - 1;
                    e[g] && 1 === e[g][0] && (d++, h = e[g][1] + h, g--), e[g] && e[g][0] === t && (l++, p = e[g][1] + p, g--), f = g;
                  }
                }
                if (u(e[s][1])) {
                  m = e[s][1].charAt(0);
                  e[s][1] = e[s][1].slice(1), p += m, h += m;
                }
              }
              if (s < e.length - 1 && !e[s][1]) {
                e.splice(s, 1);
                break;
              }
              if (p.length > 0 || h.length > 0) {
                p.length > 0 && h.length > 0 && (0 !== (r = o(h, p)) && (f >= 0 ? e[f][1] += h.substring(0, r) : (e.splice(0, 0, [0, h.substring(0, r)]), s++), h = h.substring(r), p = p.substring(r)), 0 !== (r = i(h, p)) && (e[s][1] = h.substring(h.length - r) + e[s][1], h = h.substring(0, h.length - r), p = p.substring(0, p.length - r)));
                var v = d + l;
                0 === p.length && 0 === h.length ? (e.splice(s - v, v), s -= v) : 0 === p.length ? (e.splice(s - v, v, [1, h]), s = s - v + 1) : 0 === h.length ? (e.splice(s - v, v, [t, p]), s = s - v + 1) : (e.splice(s - v, v, [t, p], [1, h]), s = s - v + 2);
              }
              0 !== s && 0 === e[s - 1][0] ? (e[s - 1][1] += e[s][1], e.splice(s, 1)) : s++, d = 0, l = 0, p = "", h = "";
          }
          "" === e[e.length - 1][1] && e.pop();
          var y = !1;
          for (s = 1; s < e.length - 1;) 0 === e[s - 1][0] && 0 === e[s + 1][0] && (e[s][1].substring(e[s][1].length - e[s - 1][1].length) === e[s - 1][1] ? (e[s][1] = e[s - 1][1] + e[s][1].substring(0, e[s][1].length - e[s - 1][1].length), e[s + 1][1] = e[s - 1][1] + e[s + 1][1], e.splice(s - 1, 1), y = !0) : e[s][1].substring(0, e[s + 1][1].length) == e[s + 1][1] && (e[s - 1][1] += e[s + 1][1], e[s][1] = e[s][1].substring(e[s + 1][1].length) + e[s + 1][1], e.splice(s + 1, 1), y = !0)), s++;
          y && a(e, n);
        }
        function s(e) {
          return e >= 55296 && e <= 56319;
        }
        function l(e) {
          return e >= 56320 && e <= 57343;
        }
        function u(e) {
          return l(e.charCodeAt(0));
        }
        function c(e) {
          return s(e.charCodeAt(e.length - 1));
        }
        function d(e, n, r, o) {
          return c(e) || u(o) ? null : function (e) {
            for (var t = [], n = 0; n < e.length; n++) e[n][1].length > 0 && t.push(e[n]);
            return t;
          }([[0, e], [t, n], [1, r], [0, o]]);
        }
        function p(e, t, r) {
          return n(e, t, r, !0);
        }
        p.INSERT = 1, p.DELETE = t, p.EQUAL = 0, e.exports = p;
      },
      53316: e => {
        function t(e, t, n, r) {
          var o,
            i = null == (o = r) || "number" == typeof o || "boolean" == typeof o ? r : n(r),
            a = t.get(i);
          return void 0 === a && (a = e.call(this, r), t.set(i, a)), a;
        }
        function n(e, t, n) {
          var r = Array.prototype.slice.call(arguments, 3),
            o = n(r),
            i = t.get(o);
          return void 0 === i && (i = e.apply(this, r), t.set(o, i)), i;
        }
        function r(e, t, n, r, o) {
          return n.bind(t, e, r, o);
        }
        function o(e, o) {
          return r(e, this, 1 === e.length ? t : n, o.cache.create(), o.serializer);
        }
        function i() {
          return JSON.stringify(arguments);
        }
        function a() {
          this.cache = Object.create(null);
        }
        a.prototype.has = function (e) {
          return e in this.cache;
        }, a.prototype.get = function (e) {
          return this.cache[e];
        }, a.prototype.set = function (e, t) {
          this.cache[e] = t;
        };
        var s = {
          create: function () {
            return new a();
          }
        };
        e.exports = function (e, t) {
          var n = t && t.cache ? t.cache : s,
            r = t && t.serializer ? t.serializer : i;
          return (t && t.strategy ? t.strategy : o)(e, {
            cache: n,
            serializer: r
          });
        }, e.exports.strategies = {
          variadic: function (e, t) {
            return r(e, this, n, t.cache.create(), t.serializer);
          },
          monadic: function (e, n) {
            return r(e, this, t, n.cache.create(), n.serializer);
          }
        };
      },
      93162: function (e, t, n) {
        var r, o, i;
        o = [], r = function () {
          "use strict";

          function t(e, t) {
            return void 0 === t ? t = {
              autoBom: !1
            } : "object" != typeof t && (console.warn("Deprecated: Expected third argument to be a object"), t = {
              autoBom: !t
            }), t.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type) ? new Blob(["\ufeff", e], {
              type: e.type
            }) : e;
          }
          function r(e, t, n) {
            var r = new XMLHttpRequest();
            r.open("GET", e), r.responseType = "blob", r.onload = function () {
              l(r.response, t, n);
            }, r.onerror = function () {
              console.error("could not download file");
            }, r.send();
          }
          function o(e) {
            var t = new XMLHttpRequest();
            t.open("HEAD", e, !1);
            try {
              t.send();
            } catch (e) {}
            return 200 <= t.status && 299 >= t.status;
          }
          function i(e) {
            try {
              e.dispatchEvent(new MouseEvent("click"));
            } catch (n) {
              var t = document.createEvent("MouseEvents");
              t.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), e.dispatchEvent(t);
            }
          }
          var a = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof n.g && n.g.global === n.g ? n.g : void 0,
            s = a.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent),
            l = a.saveAs || ("object" != typeof window || window !== a ? function () {} : "download" in HTMLAnchorElement.prototype && !s ? function (e, t, n) {
              var s = a.URL || a.webkitURL,
                l = document.createElement("a");
              t = t || e.name || "download", l.download = t, l.rel = "noopener", "string" == typeof e ? (l.href = e, l.origin === location.origin ? i(l) : o(l.href) ? r(e, t, n) : i(l, l.target = "_blank")) : (l.href = s.createObjectURL(e), setTimeout(function () {
                s.revokeObjectURL(l.href);
              }, 4e4), setTimeout(function () {
                i(l);
              }, 0));
            } : "msSaveOrOpenBlob" in navigator ? function (e, n, a) {
              if (n = n || e.name || "download", "string" != typeof e) navigator.msSaveOrOpenBlob(t(e, a), n);else if (o(e)) r(e, n, a);else {
                var s = document.createElement("a");
                s.href = e, s.target = "_blank", setTimeout(function () {
                  i(s);
                });
              }
            } : function (e, t, n, o) {
              if ((o = o || open("", "_blank")) && (o.document.title = o.document.body.innerText = "downloading..."), "string" == typeof e) return r(e, t, n);
              var i = "application/octet-stream" === e.type,
                l = /constructor/i.test(a.HTMLElement) || a.safari,
                u = /CriOS\/[\d]+/.test(navigator.userAgent);
              if ((u || i && l || s) && "undefined" != typeof FileReader) {
                var c = new FileReader();
                c.onloadend = function () {
                  var e = c.result;
                  e = u ? e : e.replace(/^data:[^;]*;/, "data:attachment/file;"), o ? o.location.href = e : location = e, o = null;
                }, c.readAsDataURL(e);
              } else {
                var d = a.URL || a.webkitURL,
                  p = d.createObjectURL(e);
                o ? o.location = p : location.href = p, o = null, setTimeout(function () {
                  d.revokeObjectURL(p);
                }, 4e4);
              }
            });
          a.saveAs = l.saveAs = l, e.exports = l;
        }, void 0 === (i = "function" == typeof r ? r.apply(t, o) : r) || (e.exports = i);
      },
      85628: function (e, t) {
        var n;
        !function (r) {
          "use strict";

          var o = {
            s: 1,
            n: 0,
            d: 1
          };
          function i(e, t) {
            if (isNaN(e = parseInt(e, 10))) throw c.InvalidParameter;
            return e * t;
          }
          function a(e, t) {
            if (0 === t) throw c.DivisionByZero;
            var n = Object.create(c.prototype);
            n.s = e < 0 ? -1 : 1;
            var r = u(e = e < 0 ? -e : e, t);
            return n.n = e / r, n.d = t / r, n;
          }
          function s(e) {
            for (var t = {}, n = e, r = 2, o = 4; o <= n;) {
              for (; n % r == 0;) n /= r, t[r] = (t[r] || 0) + 1;
              o += 1 + 2 * r++;
            }
            return n !== e ? n > 1 && (t[n] = (t[n] || 0) + 1) : t[e] = (t[e] || 0) + 1, t;
          }
          var l = function (e, t) {
            var n,
              r = 0,
              a = 1,
              s = 1,
              l = 0,
              u = 0,
              d = 0,
              p = 1,
              h = 1,
              f = 0,
              m = 1,
              g = 1,
              v = 1,
              y = 1e7;
            if (null == e) ;else if (void 0 !== t) {
              if (s = (r = e) * (a = t), r % 1 != 0 || a % 1 != 0) throw c.NonIntegerParameter;
            } else switch (typeof e) {
              case "object":
                if ("d" in e && "n" in e) r = e.n, a = e.d, "s" in e && (r *= e.s);else {
                  if (!(0 in e)) throw c.InvalidParameter;
                  r = e[0], 1 in e && (a = e[1]);
                }
                s = r * a;
                break;
              case "number":
                if (e < 0 && (s = e, e = -e), e % 1 == 0) r = e;else if (e > 0) {
                  for (e >= 1 && (e /= h = Math.pow(10, Math.floor(1 + Math.log(e) / Math.LN10))); m <= y && v <= y;) {
                    if (e === (n = (f + g) / (m + v))) {
                      m + v <= y ? (r = f + g, a = m + v) : v > m ? (r = g, a = v) : (r = f, a = m);
                      break;
                    }
                    e > n ? (f += g, m += v) : (g += f, v += m), m > y ? (r = g, a = v) : (r = f, a = m);
                  }
                  r *= h;
                } else (isNaN(e) || isNaN(t)) && (a = r = NaN);
                break;
              case "string":
                if (null === (m = e.match(/\d+|./g))) throw c.InvalidParameter;
                if ("-" === m[f] ? (s = -1, f++) : "+" === m[f] && f++, m.length === f + 1 ? u = i(m[f++], s) : "." === m[f + 1] || "." === m[f] ? ("." !== m[f] && (l = i(m[f++], s)), (++f + 1 === m.length || "(" === m[f + 1] && ")" === m[f + 3] || "'" === m[f + 1] && "'" === m[f + 3]) && (u = i(m[f], s), p = Math.pow(10, m[f].length), f++), ("(" === m[f] && ")" === m[f + 2] || "'" === m[f] && "'" === m[f + 2]) && (d = i(m[f + 1], s), h = Math.pow(10, m[f + 1].length) - 1, f += 3)) : "/" === m[f + 1] || ":" === m[f + 1] ? (u = i(m[f], s), p = i(m[f + 2], 1), f += 3) : "/" === m[f + 3] && " " === m[f + 1] && (l = i(m[f], s), u = i(m[f + 2], s), p = i(m[f + 4], 1), f += 5), m.length <= f) {
                  s = r = d + (a = p * h) * l + h * u;
                  break;
                }
              default:
                throw c.InvalidParameter;
            }
            if (0 === a) throw c.DivisionByZero;
            o.s = s < 0 ? -1 : 1, o.n = Math.abs(r), o.d = Math.abs(a);
          };
          function u(e, t) {
            if (!e) return t;
            if (!t) return e;
            for (;;) {
              if (!(e %= t)) return t;
              if (!(t %= e)) return e;
            }
          }
          function c(e, t) {
            if (l(e, t), !(this instanceof c)) return a(o.s * o.n, o.d);
            e = u(o.d, o.n), this.s = o.s, this.n = o.n / e, this.d = o.d / e;
          }
          c.DivisionByZero = new Error("Division by Zero"), c.InvalidParameter = new Error("Invalid argument"), c.NonIntegerParameter = new Error("Parameters must be integer"), c.prototype = {
            s: 1,
            n: 0,
            d: 1,
            abs: function () {
              return a(this.n, this.d);
            },
            neg: function () {
              return a(-this.s * this.n, this.d);
            },
            add: function (e, t) {
              return l(e, t), a(this.s * this.n * o.d + o.s * this.d * o.n, this.d * o.d);
            },
            sub: function (e, t) {
              return l(e, t), a(this.s * this.n * o.d - o.s * this.d * o.n, this.d * o.d);
            },
            mul: function (e, t) {
              return l(e, t), a(this.s * o.s * this.n * o.n, this.d * o.d);
            },
            div: function (e, t) {
              return l(e, t), a(this.s * o.s * this.n * o.d, this.d * o.n);
            },
            clone: function () {
              return a(this.s * this.n, this.d);
            },
            mod: function (e, t) {
              if (isNaN(this.n) || isNaN(this.d)) return new c(NaN);
              if (void 0 === e) return a(this.s * this.n % this.d, 1);
              if (l(e, t), 0 === o.n && 0 === this.d) throw c.DivisionByZero;
              return a(this.s * (o.d * this.n) % (o.n * this.d), o.d * this.d);
            },
            gcd: function (e, t) {
              return l(e, t), a(u(o.n, this.n) * u(o.d, this.d), o.d * this.d);
            },
            lcm: function (e, t) {
              return l(e, t), 0 === o.n && 0 === this.n ? a(0, 1) : a(o.n * this.n, u(o.n, this.n) * u(o.d, this.d));
            },
            ceil: function (e) {
              return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new c(NaN) : a(Math.ceil(e * this.s * this.n / this.d), e);
            },
            floor: function (e) {
              return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new c(NaN) : a(Math.floor(e * this.s * this.n / this.d), e);
            },
            round: function (e) {
              return e = Math.pow(10, e || 0), isNaN(this.n) || isNaN(this.d) ? new c(NaN) : a(Math.round(e * this.s * this.n / this.d), e);
            },
            inverse: function () {
              return a(this.s * this.d, this.n);
            },
            pow: function (e, t) {
              if (l(e, t), 1 === o.d) return o.s < 0 ? a(Math.pow(this.s * this.d, o.n), Math.pow(this.n, o.n)) : a(Math.pow(this.s * this.n, o.n), Math.pow(this.d, o.n));
              if (this.s < 0) return null;
              var n = s(this.n),
                r = s(this.d),
                i = 1,
                u = 1;
              for (var c in n) if ("1" !== c) {
                if ("0" === c) {
                  i = 0;
                  break;
                }
                if (n[c] *= o.n, n[c] % o.d != 0) return null;
                n[c] /= o.d, i *= Math.pow(c, n[c]);
              }
              for (var c in r) if ("1" !== c) {
                if (r[c] *= o.n, r[c] % o.d != 0) return null;
                r[c] /= o.d, u *= Math.pow(c, r[c]);
              }
              return o.s < 0 ? a(u, i) : a(i, u);
            },
            equals: function (e, t) {
              return l(e, t), this.s * this.n * o.d == o.s * o.n * this.d;
            },
            compare: function (e, t) {
              l(e, t);
              var n = this.s * this.n * o.d - o.s * o.n * this.d;
              return (0 < n) - (n < 0);
            },
            simplify: function (e) {
              if (isNaN(this.n) || isNaN(this.d)) return this;
              e = e || .001;
              for (var t = this.abs(), n = t.toContinued(), r = 1; r < n.length; r++) {
                for (var o = a(n[r - 1], 1), i = r - 2; i >= 0; i--) o = o.inverse().add(n[i]);
                if (o.sub(t).abs().valueOf() < e) return o.mul(this.s);
              }
              return this;
            },
            divisible: function (e, t) {
              return l(e, t), !(!(o.n * this.d) || this.n * o.d % (o.n * this.d));
            },
            valueOf: function () {
              return this.s * this.n / this.d;
            },
            toFraction: function (e) {
              var t,
                n = "",
                r = this.n,
                o = this.d;
              return this.s < 0 && (n += "-"), 1 === o ? n += r : (e && (t = Math.floor(r / o)) > 0 && (n += t, n += " ", r %= o), n += r, n += "/", n += o), n;
            },
            toLatex: function (e) {
              var t,
                n = "",
                r = this.n,
                o = this.d;
              return this.s < 0 && (n += "-"), 1 === o ? n += r : (e && (t = Math.floor(r / o)) > 0 && (n += t, r %= o), n += "\\frac{", n += r, n += "}{", n += o, n += "}"), n;
            },
            toContinued: function () {
              var e,
                t = this.n,
                n = this.d,
                r = [];
              if (isNaN(t) || isNaN(n)) return r;
              do {
                r.push(Math.floor(t / n)), e = t % n, t = n, n = e;
              } while (1 !== t);
              return r;
            },
            toString: function (e) {
              var t = this.n,
                n = this.d;
              if (isNaN(t) || isNaN(n)) return "NaN";
              e = e || 15;
              var r = function (e, t) {
                  for (; t % 2 == 0; t /= 2);
                  for (; t % 5 == 0; t /= 5);
                  if (1 === t) return 0;
                  for (var n = 10 % t, r = 1; 1 !== n; r++) if (n = 10 * n % t, r > 2e3) return 0;
                  return r;
                }(0, n),
                o = function (e, t, n) {
                  for (var r = 1, o = function (e, t, n) {
                      for (var r = 1; t > 0; e = e * e % n, t >>= 1) 1 & t && (r = r * e % n);
                      return r;
                    }(10, n, t), i = 0; i < 300; i++) {
                    if (r === o) return i;
                    r = 10 * r % t, o = 10 * o % t;
                  }
                  return 0;
                }(0, n, r),
                i = this.s < 0 ? "-" : "";
              if (i += t / n | 0, t %= n, (t *= 10) && (i += "."), r) {
                for (var a = o; a--;) i += t / n | 0, t %= n, t *= 10;
                i += "(";
                for (a = r; a--;) i += t / n | 0, t %= n, t *= 10;
                i += ")";
              } else for (a = e; t && a--;) i += t / n | 0, t %= n, t *= 10;
              return i;
            }
          }, void 0 === (n = function () {
            return c;
          }.apply(t, [])) || (e.exports = n);
        }();
      },
      3513: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const o = n(67294),
          i = r(n(83057));
        t.default = (e, t, n) => (0, i.default)(o.useCallback, e, t, n);
      },
      7167: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const o = n(67294),
          i = r(n(83057));
        t.default = (e, t, n) => (0, i.default)(o.useEffect, e, t, n);
      },
      83057: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const r = n(67294);
        t.default = (e, t, n, o) => {
          const i = (0, r.useRef)();
          return i.current && n.every((e, t) => Object.is(e, i.current[t])) || (i.current = [...n, ...o]), e(t, i.current);
        };
      },
      33063: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const o = n(67294),
          i = r(n(83057));
        t.default = (e, t, n) => (0, i.default)(o.useLayoutEffect, e, t, n);
      },
      63346: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        const o = n(67294),
          i = r(n(83057));
        t.default = (e, t, n) => (0, i.default)(o.useMemo, e, t, n);
      },
      45071: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.useGranularMemo = t.useGranularLayoutEffect = t.useGranularHook = t.useGranularEffect = t.useGranularCallback = void 0;
        var o = n(3513);
        Object.defineProperty(t, "useGranularCallback", {
          enumerable: !0,
          get: function () {
            return r(o).default;
          }
        });
        var i = n(7167);
        Object.defineProperty(t, "useGranularEffect", {
          enumerable: !0,
          get: function () {
            return r(i).default;
          }
        });
        var a = n(83057);
        Object.defineProperty(t, "useGranularHook", {
          enumerable: !0,
          get: function () {
            return r(a).default;
          }
        });
        var s = n(33063);
        Object.defineProperty(t, "useGranularLayoutEffect", {
          enumerable: !0,
          get: function () {
            return r(s).default;
          }
        });
        var l = n(63346);
        Object.defineProperty(t, "useGranularMemo", {
          enumerable: !0,
          get: function () {
            return r(l).default;
          }
        });
      },
      8679: (e, t, n) => {
        "use strict";

        var r = n(21296),
          o = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
          },
          i = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0
          },
          a = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0
          },
          s = {};
        function l(e) {
          return r.isMemo(e) ? a : s[e.$$typeof] || o;
        }
        s[r.ForwardRef] = {
          $$typeof: !0,
          render: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0
        }, s[r.Memo] = a;
        var u = Object.defineProperty,
          c = Object.getOwnPropertyNames,
          d = Object.getOwnPropertySymbols,
          p = Object.getOwnPropertyDescriptor,
          h = Object.getPrototypeOf,
          f = Object.prototype;
        e.exports = function e(t, n, r) {
          if ("string" != typeof n) {
            if (f) {
              var o = h(n);
              o && o !== f && e(t, o, r);
            }
            var a = c(n);
            d && (a = a.concat(d(n)));
            for (var s = l(t), m = l(n), g = 0; g < a.length; ++g) {
              var v = a[g];
              if (!(i[v] || r && r[v] || m && m[v] || s && s[v])) {
                var y = p(n, v);
                try {
                  u(t, v, y);
                } catch (e) {}
              }
            }
          }
          return t;
        };
      },
      96103: (e, t) => {
        "use strict";

        var n = "function" == typeof Symbol && Symbol.for,
          r = n ? Symbol.for("react.element") : 60103,
          o = n ? Symbol.for("react.portal") : 60106,
          i = n ? Symbol.for("react.fragment") : 60107,
          a = n ? Symbol.for("react.strict_mode") : 60108,
          s = n ? Symbol.for("react.profiler") : 60114,
          l = n ? Symbol.for("react.provider") : 60109,
          u = n ? Symbol.for("react.context") : 60110,
          c = n ? Symbol.for("react.async_mode") : 60111,
          d = n ? Symbol.for("react.concurrent_mode") : 60111,
          p = n ? Symbol.for("react.forward_ref") : 60112,
          h = n ? Symbol.for("react.suspense") : 60113,
          f = n ? Symbol.for("react.suspense_list") : 60120,
          m = n ? Symbol.for("react.memo") : 60115,
          g = n ? Symbol.for("react.lazy") : 60116,
          v = n ? Symbol.for("react.block") : 60121,
          y = n ? Symbol.for("react.fundamental") : 60117,
          b = n ? Symbol.for("react.responder") : 60118,
          w = n ? Symbol.for("react.scope") : 60119;
        function x(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case r:
                switch (e = e.type) {
                  case c:
                  case d:
                  case i:
                  case s:
                  case a:
                  case h:
                    return e;
                  default:
                    switch (e = e && e.$$typeof) {
                      case u:
                      case p:
                      case g:
                      case m:
                      case l:
                        return e;
                      default:
                        return t;
                    }
                }
              case o:
                return t;
            }
          }
        }
        function D(e) {
          return x(e) === d;
        }
        t.AsyncMode = c, t.ConcurrentMode = d, t.ContextConsumer = u, t.ContextProvider = l, t.Element = r, t.ForwardRef = p, t.Fragment = i, t.Lazy = g, t.Memo = m, t.Portal = o, t.Profiler = s, t.StrictMode = a, t.Suspense = h, t.isAsyncMode = function (e) {
          return D(e) || x(e) === c;
        }, t.isConcurrentMode = D, t.isContextConsumer = function (e) {
          return x(e) === u;
        }, t.isContextProvider = function (e) {
          return x(e) === l;
        }, t.isElement = function (e) {
          return "object" == typeof e && null !== e && e.$$typeof === r;
        }, t.isForwardRef = function (e) {
          return x(e) === p;
        }, t.isFragment = function (e) {
          return x(e) === i;
        }, t.isLazy = function (e) {
          return x(e) === g;
        }, t.isMemo = function (e) {
          return x(e) === m;
        }, t.isPortal = function (e) {
          return x(e) === o;
        }, t.isProfiler = function (e) {
          return x(e) === s;
        }, t.isStrictMode = function (e) {
          return x(e) === a;
        }, t.isSuspense = function (e) {
          return x(e) === h;
        }, t.isValidElementType = function (e) {
          return "string" == typeof e || "function" == typeof e || e === i || e === d || e === s || e === a || e === h || e === f || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === m || e.$$typeof === l || e.$$typeof === u || e.$$typeof === p || e.$$typeof === y || e.$$typeof === b || e.$$typeof === w || e.$$typeof === v);
        }, t.typeOf = x;
      },
      21296: (e, t, n) => {
        "use strict";

        e.exports = n(96103);
      },
      28623: (e, t, n) => {
        "use strict";

        n.d(t, {
          P2: () => $,
          Uy: () => Z,
          Vk: () => q,
          _x: () => G,
          mv: () => l,
          o$: () => u
        });
        var r = Symbol.for("immer-nothing"),
          o = Symbol.for("immer-draftable"),
          i = Symbol.for("immer-state");
        function a(e, ...t) {
          throw new Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`);
        }
        var s = Object.getPrototypeOf;
        function l(e) {
          return !!e && !!e[i];
        }
        function u(e) {
          return !!e && (d(e) || Array.isArray(e) || !!e[o] || !!e.constructor?.[o] || g(e) || v(e));
        }
        var c = Object.prototype.constructor.toString();
        function d(e) {
          if (!e || "object" != typeof e) return !1;
          const t = s(e);
          if (null === t) return !0;
          const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
          return n === Object || "function" == typeof n && Function.toString.call(n) === c;
        }
        function p(e, t) {
          0 === h(e) ? Object.entries(e).forEach(([n, r]) => {
            t(n, r, e);
          }) : e.forEach((n, r) => t(r, n, e));
        }
        function h(e) {
          const t = e[i];
          return t ? t.type_ : Array.isArray(e) ? 1 : g(e) ? 2 : v(e) ? 3 : 0;
        }
        function f(e, t) {
          return 2 === h(e) ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
        }
        function m(e, t, n) {
          const r = h(e);
          2 === r ? e.set(t, n) : 3 === r ? e.add(n) : e[t] = n;
        }
        function g(e) {
          return e instanceof Map;
        }
        function v(e) {
          return e instanceof Set;
        }
        function y(e) {
          return e.copy_ || e.base_;
        }
        function b(e, t) {
          if (g(e)) return new Map(e);
          if (v(e)) return new Set(e);
          if (Array.isArray(e)) return Array.prototype.slice.call(e);
          if (!t && d(e)) {
            if (!s(e)) {
              const t = Object.create(null);
              return Object.assign(t, e);
            }
            return {
              ...e
            };
          }
          const n = Object.getOwnPropertyDescriptors(e);
          delete n[i];
          let r = Reflect.ownKeys(n);
          for (let t = 0; t < r.length; t++) {
            const o = r[t],
              i = n[o];
            !1 === i.writable && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (n[o] = {
              configurable: !0,
              writable: !0,
              enumerable: i.enumerable,
              value: e[o]
            });
          }
          return Object.create(s(e), n);
        }
        function w(e, t = !1) {
          return D(e) || l(e) || !u(e) || (h(e) > 1 && (e.set = e.add = e.clear = e.delete = x), Object.freeze(e), t && p(e, (e, t) => w(t, !0))), e;
        }
        function x() {
          a(2);
        }
        function D(e) {
          return Object.isFrozen(e);
        }
        var C,
          S = {};
        function E(e) {
          const t = S[e];
          return t || a(0), t;
        }
        function _() {
          return C;
        }
        function P(e, t) {
          t && (E("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
        }
        function k(e) {
          A(e), e.drafts_.forEach(T), e.drafts_ = null;
        }
        function A(e) {
          e === C && (C = e.parent_);
        }
        function z(e) {
          return C = {
            drafts_: [],
            parent_: C,
            immer_: e,
            canAutoFreeze_: !0,
            unfinalizedDrafts_: 0
          };
        }
        function T(e) {
          const t = e[i];
          0 === t.type_ || 1 === t.type_ ? t.revoke_() : t.revoked_ = !0;
        }
        function O(e, t) {
          t.unfinalizedDrafts_ = t.drafts_.length;
          const n = t.drafts_[0];
          return void 0 !== e && e !== n ? (n[i].modified_ && (k(t), a(4)), u(e) && (e = I(t, e), t.parent_ || M(t, e)), t.patches_ && E("Patches").generateReplacementPatches_(n[i].base_, e, t.patches_, t.inversePatches_)) : e = I(t, n, []), k(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== r ? e : void 0;
        }
        function I(e, t, n) {
          if (D(t)) return t;
          const r = t[i];
          if (!r) return p(t, (o, i) => F(e, r, t, o, i, n)), t;
          if (r.scope_ !== e) return t;
          if (!r.modified_) return M(e, r.base_, !0), r.base_;
          if (!r.finalized_) {
            r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
            const t = r.copy_;
            let o = t,
              i = !1;
            3 === r.type_ && (o = new Set(t), t.clear(), i = !0), p(o, (o, a) => F(e, r, t, o, a, n, i)), M(e, t, !1), n && e.patches_ && E("Patches").generatePatches_(r, n, e.patches_, e.inversePatches_);
          }
          return r.copy_;
        }
        function F(e, t, n, r, o, i, a) {
          if (l(o)) {
            const a = I(e, o, i && t && 3 !== t.type_ && !f(t.assigned_, r) ? i.concat(r) : void 0);
            if (m(n, r, a), !l(a)) return;
            e.canAutoFreeze_ = !1;
          } else a && n.add(o);
          if (u(o) && !D(o)) {
            if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1) return;
            I(e, o), t && t.scope_.parent_ || M(e, o);
          }
        }
        function M(e, t, n = !1) {
          !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && w(t, n);
        }
        var R = {
            get(e, t) {
              if (t === i) return e;
              const n = y(e);
              if (!f(n, t)) return function (e, t, n) {
                const r = N(t, n);
                return r ? "value" in r ? r.value : r.get?.call(e.draft_) : void 0;
              }(e, n, t);
              const r = n[t];
              return e.finalized_ || !u(r) ? r : r === B(e.base_, t) ? (V(e), e.copy_[t] = K(r, e)) : r;
            },
            has: (e, t) => t in y(e),
            ownKeys: e => Reflect.ownKeys(y(e)),
            set(e, t, n) {
              const r = N(y(e), t);
              if (r?.set) return r.set.call(e.draft_, n), !0;
              if (!e.modified_) {
                const r = B(y(e), t),
                  s = r?.[i];
                if (s && s.base_ === n) return e.copy_[t] = n, e.assigned_[t] = !1, !0;
                if (((o = n) === (a = r) ? 0 !== o || 1 / o == 1 / a : o != o && a != a) && (void 0 !== n || f(e.base_, t))) return !0;
                V(e), L(e);
              }
              var o, a;
              return e.copy_[t] === n && (void 0 !== n || t in e.copy_) || Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
            },
            deleteProperty: (e, t) => (void 0 !== B(e.base_, t) || t in e.base_ ? (e.assigned_[t] = !1, V(e), L(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0),
            getOwnPropertyDescriptor(e, t) {
              const n = y(e),
                r = Reflect.getOwnPropertyDescriptor(n, t);
              return r ? {
                writable: !0,
                configurable: 1 !== e.type_ || "length" !== t,
                enumerable: r.enumerable,
                value: n[t]
              } : r;
            },
            defineProperty() {
              a(11);
            },
            getPrototypeOf: e => s(e.base_),
            setPrototypeOf() {
              a(12);
            }
          },
          j = {};
        function B(e, t) {
          const n = e[i];
          return (n ? y(n) : e)[t];
        }
        function N(e, t) {
          if (!(t in e)) return;
          let n = s(e);
          for (; n;) {
            const e = Object.getOwnPropertyDescriptor(n, t);
            if (e) return e;
            n = s(n);
          }
        }
        function L(e) {
          e.modified_ || (e.modified_ = !0, e.parent_ && L(e.parent_));
        }
        function V(e) {
          e.copy_ || (e.copy_ = b(e.base_, e.scope_.immer_.useStrictShallowCopy_));
        }
        p(R, (e, t) => {
          j[e] = function () {
            return arguments[0] = arguments[0][0], t.apply(this, arguments);
          };
        }), j.deleteProperty = function (e, t) {
          return j.set.call(this, e, t, void 0);
        }, j.set = function (e, t, n) {
          return R.set.call(this, e[0], t, n, e[0]);
        };
        function K(e, t) {
          const n = g(e) ? E("MapSet").proxyMap_(e, t) : v(e) ? E("MapSet").proxySet_(e, t) : function (e, t) {
            const n = Array.isArray(e),
              r = {
                type_: n ? 1 : 0,
                scope_: t ? t.scope_ : _(),
                modified_: !1,
                finalized_: !1,
                assigned_: {},
                parent_: t,
                base_: e,
                draft_: null,
                copy_: null,
                revoke_: null,
                isManual_: !1
              };
            let o = r,
              i = R;
            n && (o = [r], i = j);
            const {
              revoke: a,
              proxy: s
            } = Proxy.revocable(o, i);
            return r.draft_ = s, r.revoke_ = a, s;
          }(e, t);
          return (t ? t.scope_ : _()).drafts_.push(n), n;
        }
        function q(e) {
          return l(e) || a(10), H(e);
        }
        function H(e) {
          if (!u(e) || D(e)) return e;
          const t = e[i];
          let n;
          if (t) {
            if (!t.modified_) return t.base_;
            t.finalized_ = !0, n = b(e, t.scope_.immer_.useStrictShallowCopy_);
          } else n = b(e, !0);
          return p(n, (e, t) => {
            m(n, e, H(t));
          }), t && (t.finalized_ = !1), n;
        }
        var U = new class {
            constructor(e) {
              this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (e, t, n) => {
                if ("function" == typeof e && "function" != typeof t) {
                  const n = t;
                  t = e;
                  const r = this;
                  return function (e = n, ...o) {
                    return r.produce(e, e => t.call(this, e, ...o));
                  };
                }
                let o;
                if ("function" != typeof t && a(6), void 0 !== n && "function" != typeof n && a(7), u(e)) {
                  const r = z(this),
                    i = K(e, void 0);
                  let a = !0;
                  try {
                    o = t(i), a = !1;
                  } finally {
                    a ? k(r) : A(r);
                  }
                  return P(r, n), O(o, r);
                }
                if (!e || "object" != typeof e) {
                  if (o = t(e), void 0 === o && (o = e), o === r && (o = void 0), this.autoFreeze_ && w(o, !0), n) {
                    const t = [],
                      r = [];
                    E("Patches").generateReplacementPatches_(e, o, t, r), n(t, r);
                  }
                  return o;
                }
                a(1);
              }, this.produceWithPatches = (e, t) => {
                if ("function" == typeof e) return (t, ...n) => this.produceWithPatches(t, t => e(t, ...n));
                let n, r;
                return [this.produce(e, t, (e, t) => {
                  n = e, r = t;
                }), n, r];
              }, "boolean" == typeof e?.autoFreeze && this.setAutoFreeze(e.autoFreeze), "boolean" == typeof e?.useStrictShallowCopy && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
            }
            createDraft(e) {
              u(e) || a(8), l(e) && (e = q(e));
              const t = z(this),
                n = K(e, void 0);
              return n[i].isManual_ = !0, A(t), n;
            }
            finishDraft(e, t) {
              const n = e && e[i];
              n && n.isManual_ || a(9);
              const {
                scope_: r
              } = n;
              return P(r, t), O(void 0, r);
            }
            setAutoFreeze(e) {
              this.autoFreeze_ = e;
            }
            setUseStrictShallowCopy(e) {
              this.useStrictShallowCopy_ = e;
            }
            applyPatches(e, t) {
              let n;
              for (n = t.length - 1; n >= 0; n--) {
                const r = t[n];
                if (0 === r.path.length && "replace" === r.op) {
                  e = r.value;
                  break;
                }
              }
              n > -1 && (t = t.slice(n + 1));
              const r = E("Patches").applyPatches_;
              return l(e) ? r(e, t) : this.produce(e, e => r(e, t));
            }
          }(),
          Z = U.produce,
          $ = (U.produceWithPatches.bind(U), U.setAutoFreeze.bind(U), U.setUseStrictShallowCopy.bind(U), U.applyPatches.bind(U), U.createDraft.bind(U)),
          G = U.finishDraft.bind(U);
      },
      35369: (e, t, n) => {
        "use strict";

        n.d(t, {
          D5: () => Et,
          WV: () => tr,
          aV: () => Wt,
          d0: () => lr,
          dM: () => Z,
          hU: () => Yn,
          is: () => le,
          l4: () => Pn,
          t8: () => nt,
          zN: () => cn
        });
        var r = 32,
          o = 31,
          i = {};
        function a(e) {
          e && (e.value = !0);
        }
        function s() {}
        function l(e) {
          return void 0 === e.size && (e.size = e.__iterate(c)), e.size;
        }
        function u(e, t) {
          if ("number" != typeof t) {
            var n = t >>> 0;
            if ("" + n !== t || 4294967295 === n) return NaN;
            t = n;
          }
          return t < 0 ? l(e) + t : t;
        }
        function c() {
          return !0;
        }
        function d(e, t, n) {
          return (0 === e && !m(e) || void 0 !== n && e <= -n) && (void 0 === t || void 0 !== n && t >= n);
        }
        function p(e, t) {
          return f(e, t, 0);
        }
        function h(e, t) {
          return f(e, t, t);
        }
        function f(e, t, n) {
          return void 0 === e ? n : m(e) ? t === 1 / 0 ? t : 0 | Math.max(0, t + e) : void 0 === t || t === e ? e : 0 | Math.min(t, e);
        }
        function m(e) {
          return e < 0 || 0 === e && 1 / e == -1 / 0;
        }
        var g = "@@__IMMUTABLE_ITERABLE__@@";
        function v(e) {
          return Boolean(e && e[g]);
        }
        var y = "@@__IMMUTABLE_KEYED__@@";
        function b(e) {
          return Boolean(e && e[y]);
        }
        var w = "@@__IMMUTABLE_INDEXED__@@";
        function x(e) {
          return Boolean(e && e[w]);
        }
        function D(e) {
          return b(e) || x(e);
        }
        var C = function (e) {
            return v(e) ? e : Z(e);
          },
          S = function (e) {
            function t(e) {
              return b(e) ? e : $(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
          }(C),
          E = function (e) {
            function t(e) {
              return x(e) ? e : G(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
          }(C),
          _ = function (e) {
            function t(e) {
              return v(e) && !D(e) ? e : W(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t;
          }(C);
        C.Keyed = S, C.Indexed = E, C.Set = _;
        var P = "@@__IMMUTABLE_SEQ__@@";
        function k(e) {
          return Boolean(e && e[P]);
        }
        var A = "@@__IMMUTABLE_RECORD__@@";
        function z(e) {
          return Boolean(e && e[A]);
        }
        function T(e) {
          return v(e) || z(e);
        }
        var O = "@@__IMMUTABLE_ORDERED__@@";
        function I(e) {
          return Boolean(e && e[O]);
        }
        var F = "function" == typeof Symbol && Symbol.iterator,
          M = "@@iterator",
          R = F || M,
          j = function (e) {
            this.next = e;
          };
        function B(e, t, n, r) {
          var o = 0 === e ? t : 1 === e ? n : [t, n];
          return r ? r.value = o : r = {
            value: o,
            done: !1
          }, r;
        }
        function N() {
          return {
            value: void 0,
            done: !0
          };
        }
        function L(e) {
          return !!q(e);
        }
        function V(e) {
          return e && "function" == typeof e.next;
        }
        function K(e) {
          var t = q(e);
          return t && t.call(e);
        }
        function q(e) {
          var t = e && (F && e[F] || e["@@iterator"]);
          if ("function" == typeof t) return t;
        }
        j.prototype.toString = function () {
          return "[Iterator]";
        }, j.KEYS = 0, j.VALUES = 1, j.ENTRIES = 2, j.prototype.inspect = j.prototype.toSource = function () {
          return this.toString();
        }, j.prototype[R] = function () {
          return this;
        };
        var H = Object.prototype.hasOwnProperty;
        function U(e) {
          return !(!Array.isArray(e) && "string" != typeof e) || e && "object" == typeof e && Number.isInteger(e.length) && e.length >= 0 && (0 === e.length ? 1 === Object.keys(e).length : e.hasOwnProperty(e.length - 1));
        }
        var Z = function (e) {
            function t(e) {
              return null == e ? ee() : T(e) ? e.toSeq() : function (e) {
                var t = re(e);
                if (t) return t;
                if ("object" == typeof e) return new X(e);
                throw new TypeError("Expected Array or collection object of values, or keyed object: " + e);
              }(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toSeq = function () {
              return this;
            }, t.prototype.toString = function () {
              return this.__toString("Seq {", "}");
            }, t.prototype.cacheResult = function () {
              return !this._cache && this.__iterateUncached && (this._cache = this.entrySeq().toArray(), this.size = this._cache.length), this;
            }, t.prototype.__iterate = function (e, t) {
              var n = this._cache;
              if (n) {
                for (var r = n.length, o = 0; o !== r;) {
                  var i = n[t ? r - ++o : o++];
                  if (!1 === e(i[1], i[0], this)) break;
                }
                return o;
              }
              return this.__iterateUncached(e, t);
            }, t.prototype.__iterator = function (e, t) {
              var n = this._cache;
              if (n) {
                var r = n.length,
                  o = 0;
                return new j(function () {
                  if (o === r) return {
                    value: void 0,
                    done: !0
                  };
                  var i = n[t ? r - ++o : o++];
                  return B(e, i[0], i[1]);
                });
              }
              return this.__iteratorUncached(e, t);
            }, t;
          }(C),
          $ = function (e) {
            function t(e) {
              return null == e ? ee().toKeyedSeq() : v(e) ? b(e) ? e.toSeq() : e.fromEntrySeq() : z(e) ? e.toSeq() : te(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toKeyedSeq = function () {
              return this;
            }, t;
          }(Z),
          G = function (e) {
            function t(e) {
              return null == e ? ee() : v(e) ? b(e) ? e.entrySeq() : e.toIndexedSeq() : z(e) ? e.toSeq().entrySeq() : ne(e);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
              return t(arguments);
            }, t.prototype.toIndexedSeq = function () {
              return this;
            }, t.prototype.toString = function () {
              return this.__toString("Seq [", "]");
            }, t;
          }(Z),
          W = function (e) {
            function t(e) {
              return (v(e) && !D(e) ? e : G(e)).toSetSeq();
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
              return t(arguments);
            }, t.prototype.toSetSeq = function () {
              return this;
            }, t;
          }(Z);
        Z.isSeq = k, Z.Keyed = $, Z.Set = W, Z.Indexed = G, Z.prototype[P] = !0;
        var Y = function (e) {
            function t(e) {
              this._array = e, this.size = e.length;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function (e, t) {
              return this.has(e) ? this._array[u(this, e)] : t;
            }, t.prototype.__iterate = function (e, t) {
              for (var n = this._array, r = n.length, o = 0; o !== r;) {
                var i = t ? r - ++o : o++;
                if (!1 === e(n[i], i, this)) break;
              }
              return o;
            }, t.prototype.__iterator = function (e, t) {
              var n = this._array,
                r = n.length,
                o = 0;
              return new j(function () {
                if (o === r) return {
                  value: void 0,
                  done: !0
                };
                var i = t ? r - ++o : o++;
                return B(e, i, n[i]);
              });
            }, t;
          }(G),
          X = function (e) {
            function t(e) {
              var t = Object.keys(e);
              this._object = e, this._keys = t, this.size = t.length;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function (e, t) {
              return void 0 === t || this.has(e) ? this._object[e] : t;
            }, t.prototype.has = function (e) {
              return H.call(this._object, e);
            }, t.prototype.__iterate = function (e, t) {
              for (var n = this._object, r = this._keys, o = r.length, i = 0; i !== o;) {
                var a = r[t ? o - ++i : i++];
                if (!1 === e(n[a], a, this)) break;
              }
              return i;
            }, t.prototype.__iterator = function (e, t) {
              var n = this._object,
                r = this._keys,
                o = r.length,
                i = 0;
              return new j(function () {
                if (i === o) return {
                  value: void 0,
                  done: !0
                };
                var a = r[t ? o - ++i : i++];
                return B(e, a, n[a]);
              });
            }, t;
          }($);
        X.prototype[O] = !0;
        var Q,
          J = function (e) {
            function t(e) {
              this._collection = e, this.size = e.length || e.size;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.__iterateUncached = function (e, t) {
              if (t) return this.cacheResult().__iterate(e, t);
              var n = K(this._collection),
                r = 0;
              if (V(n)) for (var o; !(o = n.next()).done && !1 !== e(o.value, r++, this););
              return r;
            }, t.prototype.__iteratorUncached = function (e, t) {
              if (t) return this.cacheResult().__iterator(e, t);
              var n = K(this._collection);
              if (!V(n)) return new j(N);
              var r = 0;
              return new j(function () {
                var t = n.next();
                return t.done ? t : B(e, r++, t.value);
              });
            }, t;
          }(G);
        function ee() {
          return Q || (Q = new Y([]));
        }
        function te(e) {
          var t = Array.isArray(e) ? new Y(e) : L(e) ? new J(e) : void 0;
          if (t) return t.fromEntrySeq();
          if ("object" == typeof e) return new X(e);
          throw new TypeError("Expected Array or collection object of [k, v] entries, or keyed object: " + e);
        }
        function ne(e) {
          var t = re(e);
          if (t) return t;
          throw new TypeError("Expected Array or collection object of values: " + e);
        }
        function re(e) {
          return U(e) ? new Y(e) : L(e) ? new J(e) : void 0;
        }
        var oe = "@@__IMMUTABLE_MAP__@@";
        function ie(e) {
          return Boolean(e && e[oe]);
        }
        function ae(e) {
          return ie(e) && I(e);
        }
        function se(e) {
          return Boolean(e && "function" == typeof e.equals && "function" == typeof e.hashCode);
        }
        function le(e, t) {
          if (e === t || e != e && t != t) return !0;
          if (!e || !t) return !1;
          if ("function" == typeof e.valueOf && "function" == typeof t.valueOf) {
            if ((e = e.valueOf()) === (t = t.valueOf()) || e != e && t != t) return !0;
            if (!e || !t) return !1;
          }
          return !!(se(e) && se(t) && e.equals(t));
        }
        var ue = "function" == typeof Math.imul && -2 === Math.imul(4294967295, 2) ? Math.imul : function (e, t) {
          var n = 65535 & (e |= 0),
            r = 65535 & (t |= 0);
          return n * r + ((e >>> 16) * r + n * (t >>> 16) << 16 >>> 0) | 0;
        };
        function ce(e) {
          return e >>> 1 & 1073741824 | 3221225471 & e;
        }
        function de(e) {
          if (!1 === e || null == e) return 0;
          if ("function" == typeof e.valueOf && (!1 === (e = e.valueOf()) || null == e)) return 0;
          if (!0 === e) return 1;
          var t = typeof e;
          if ("number" === t) {
            if (e != e || e === 1 / 0) return 0;
            var n = 0 | e;
            for (n !== e && (n ^= 4294967295 * e); e > 4294967295;) n ^= e /= 4294967295;
            return ce(n);
          }
          if ("string" === t) return e.length > be ? function (e) {
            var t = De[e];
            void 0 === t && (t = pe(e), xe === we && (xe = 0, De = {}), xe++, De[e] = t);
            return t;
          }(e) : pe(e);
          if ("function" == typeof e.hashCode) return ce(e.hashCode());
          if ("object" === t || "function" === t) return function (e) {
            var t;
            if (ge && void 0 !== (t = me.get(e))) return t;
            if (void 0 !== (t = e[ye])) return t;
            if (!fe) {
              if (void 0 !== (t = e.propertyIsEnumerable && e.propertyIsEnumerable[ye])) return t;
              if (void 0 !== (t = function (e) {
                if (e && e.nodeType > 0) switch (e.nodeType) {
                  case 1:
                    return e.uniqueID;
                  case 9:
                    return e.documentElement && e.documentElement.uniqueID;
                }
              }(e))) return t;
            }
            t = ++ve, 1073741824 & ve && (ve = 0);
            if (ge) me.set(e, t);else {
              if (void 0 !== he && !1 === he(e)) throw new Error("Non-extensible objects are not allowed as keys.");
              if (fe) Object.defineProperty(e, ye, {
                enumerable: !1,
                configurable: !1,
                writable: !1,
                value: t
              });else if (void 0 !== e.propertyIsEnumerable && e.propertyIsEnumerable === e.constructor.prototype.propertyIsEnumerable) e.propertyIsEnumerable = function () {
                return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
              }, e.propertyIsEnumerable[ye] = t;else {
                if (void 0 === e.nodeType) throw new Error("Unable to set a non-enumerable property on object.");
                e[ye] = t;
              }
            }
            return t;
          }(e);
          if ("function" == typeof e.toString) return pe(e.toString());
          throw new Error("Value type " + t + " cannot be hashed.");
        }
        function pe(e) {
          for (var t = 0, n = 0; n < e.length; n++) t = 31 * t + e.charCodeAt(n) | 0;
          return ce(t);
        }
        var he = Object.isExtensible,
          fe = function () {
            try {
              return Object.defineProperty({}, "@", {}), !0;
            } catch (e) {
              return !1;
            }
          }();
        var me,
          ge = "function" == typeof WeakMap;
        ge && (me = new WeakMap());
        var ve = 0,
          ye = "__immutablehash__";
        "function" == typeof Symbol && (ye = Symbol(ye));
        var be = 16,
          we = 255,
          xe = 0,
          De = {},
          Ce = function (e) {
            function t(e, t) {
              this._iter = e, this._useKeys = t, this.size = e.size;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.get = function (e, t) {
              return this._iter.get(e, t);
            }, t.prototype.has = function (e) {
              return this._iter.has(e);
            }, t.prototype.valueSeq = function () {
              return this._iter.valueSeq();
            }, t.prototype.reverse = function () {
              var e = this,
                t = Ae(this, !0);
              return this._useKeys || (t.valueSeq = function () {
                return e._iter.toSeq().reverse();
              }), t;
            }, t.prototype.map = function (e, t) {
              var n = this,
                r = ke(this, e, t);
              return this._useKeys || (r.valueSeq = function () {
                return n._iter.toSeq().map(e, t);
              }), r;
            }, t.prototype.__iterate = function (e, t) {
              var n = this;
              return this._iter.__iterate(function (t, r) {
                return e(t, r, n);
              }, t);
            }, t.prototype.__iterator = function (e, t) {
              return this._iter.__iterator(e, t);
            }, t;
          }($);
        Ce.prototype[O] = !0;
        var Se = function (e) {
            function t(e) {
              this._iter = e, this.size = e.size;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.includes = function (e) {
              return this._iter.includes(e);
            }, t.prototype.__iterate = function (e, t) {
              var n = this,
                r = 0;
              return t && l(this), this._iter.__iterate(function (o) {
                return e(o, t ? n.size - ++r : r++, n);
              }, t);
            }, t.prototype.__iterator = function (e, t) {
              var n = this,
                r = this._iter.__iterator(1, t),
                o = 0;
              return t && l(this), new j(function () {
                var i = r.next();
                return i.done ? i : B(e, t ? n.size - ++o : o++, i.value, i);
              });
            }, t;
          }(G),
          Ee = function (e) {
            function t(e) {
              this._iter = e, this.size = e.size;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.has = function (e) {
              return this._iter.includes(e);
            }, t.prototype.__iterate = function (e, t) {
              var n = this;
              return this._iter.__iterate(function (t) {
                return e(t, t, n);
              }, t);
            }, t.prototype.__iterator = function (e, t) {
              var n = this._iter.__iterator(1, t);
              return new j(function () {
                var t = n.next();
                return t.done ? t : B(e, t.value, t.value, t);
              });
            }, t;
          }(W),
          _e = function (e) {
            function t(e) {
              this._iter = e, this.size = e.size;
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.entrySeq = function () {
              return this._iter.toSeq();
            }, t.prototype.__iterate = function (e, t) {
              var n = this;
              return this._iter.__iterate(function (t) {
                if (t) {
                  Le(t);
                  var r = v(t);
                  return e(r ? t.get(1) : t[1], r ? t.get(0) : t[0], n);
                }
              }, t);
            }, t.prototype.__iterator = function (e, t) {
              var n = this._iter.__iterator(1, t);
              return new j(function () {
                for (;;) {
                  var t = n.next();
                  if (t.done) return t;
                  var r = t.value;
                  if (r) {
                    Le(r);
                    var o = v(r);
                    return B(e, o ? r.get(0) : r[0], o ? r.get(1) : r[1], t);
                  }
                }
              });
            }, t;
          }($);
        function Pe(e) {
          var t = Ke(e);
          return t._iter = e, t.size = e.size, t.flip = function () {
            return e;
          }, t.reverse = function () {
            var t = e.reverse.apply(this);
            return t.flip = function () {
              return e.reverse();
            }, t;
          }, t.has = function (t) {
            return e.includes(t);
          }, t.includes = function (t) {
            return e.has(t);
          }, t.cacheResult = qe, t.__iterateUncached = function (t, n) {
            var r = this;
            return e.__iterate(function (e, n) {
              return !1 !== t(n, e, r);
            }, n);
          }, t.__iteratorUncached = function (t, n) {
            if (2 === t) {
              var r = e.__iterator(t, n);
              return new j(function () {
                var e = r.next();
                if (!e.done) {
                  var t = e.value[0];
                  e.value[0] = e.value[1], e.value[1] = t;
                }
                return e;
              });
            }
            return e.__iterator(1 === t ? 0 : 1, n);
          }, t;
        }
        function ke(e, t, n) {
          var r = Ke(e);
          return r.size = e.size, r.has = function (t) {
            return e.has(t);
          }, r.get = function (r, o) {
            var a = e.get(r, i);
            return a === i ? o : t.call(n, a, r, e);
          }, r.__iterateUncached = function (r, o) {
            var i = this;
            return e.__iterate(function (e, o, a) {
              return !1 !== r(t.call(n, e, o, a), o, i);
            }, o);
          }, r.__iteratorUncached = function (r, o) {
            var i = e.__iterator(2, o);
            return new j(function () {
              var o = i.next();
              if (o.done) return o;
              var a = o.value,
                s = a[0];
              return B(r, s, t.call(n, a[1], s, e), o);
            });
          }, r;
        }
        function Ae(e, t) {
          var n = this,
            r = Ke(e);
          return r._iter = e, r.size = e.size, r.reverse = function () {
            return e;
          }, e.flip && (r.flip = function () {
            var t = Pe(e);
            return t.reverse = function () {
              return e.flip();
            }, t;
          }), r.get = function (n, r) {
            return e.get(t ? n : -1 - n, r);
          }, r.has = function (n) {
            return e.has(t ? n : -1 - n);
          }, r.includes = function (t) {
            return e.includes(t);
          }, r.cacheResult = qe, r.__iterate = function (n, r) {
            var o = this,
              i = 0;
            return r && l(e), e.__iterate(function (e, a) {
              return n(e, t ? a : r ? o.size - ++i : i++, o);
            }, !r);
          }, r.__iterator = function (r, o) {
            var i = 0;
            o && l(e);
            var a = e.__iterator(2, !o);
            return new j(function () {
              var e = a.next();
              if (e.done) return e;
              var s = e.value;
              return B(r, t ? s[0] : o ? n.size - ++i : i++, s[1], e);
            });
          }, r;
        }
        function ze(e, t, n, r) {
          var o = Ke(e);
          return r && (o.has = function (r) {
            var o = e.get(r, i);
            return o !== i && !!t.call(n, o, r, e);
          }, o.get = function (r, o) {
            var a = e.get(r, i);
            return a !== i && t.call(n, a, r, e) ? a : o;
          }), o.__iterateUncached = function (o, i) {
            var a = this,
              s = 0;
            return e.__iterate(function (e, i, l) {
              if (t.call(n, e, i, l)) return s++, o(e, r ? i : s - 1, a);
            }, i), s;
          }, o.__iteratorUncached = function (o, i) {
            var a = e.__iterator(2, i),
              s = 0;
            return new j(function () {
              for (;;) {
                var i = a.next();
                if (i.done) return i;
                var l = i.value,
                  u = l[0],
                  c = l[1];
                if (t.call(n, c, u, e)) return B(o, r ? u : s++, c, i);
              }
            });
          }, o;
        }
        function Te(e, t, n, r) {
          var o = e.size;
          if (d(t, n, o)) return e;
          var i = p(t, o),
            a = h(n, o);
          if (i != i || a != a) return Te(e.toSeq().cacheResult(), t, n, r);
          var s,
            l = a - i;
          l == l && (s = l < 0 ? 0 : l);
          var c = Ke(e);
          return c.size = 0 === s ? s : e.size && s || void 0, !r && k(e) && s >= 0 && (c.get = function (t, n) {
            return (t = u(this, t)) >= 0 && t < s ? e.get(t + i, n) : n;
          }), c.__iterateUncached = function (t, n) {
            var o = this;
            if (0 === s) return 0;
            if (n) return this.cacheResult().__iterate(t, n);
            var a = 0,
              l = !0,
              u = 0;
            return e.__iterate(function (e, n) {
              if (!l || !(l = a++ < i)) return u++, !1 !== t(e, r ? n : u - 1, o) && u !== s;
            }), u;
          }, c.__iteratorUncached = function (t, n) {
            if (0 !== s && n) return this.cacheResult().__iterator(t, n);
            if (0 === s) return new j(N);
            var o = e.__iterator(t, n),
              a = 0,
              l = 0;
            return new j(function () {
              for (; a++ < i;) o.next();
              if (++l > s) return {
                value: void 0,
                done: !0
              };
              var e = o.next();
              return r || 1 === t || e.done ? e : B(t, l - 1, 0 === t ? void 0 : e.value[1], e);
            });
          }, c;
        }
        function Oe(e, t, n, r) {
          var o = Ke(e);
          return o.__iterateUncached = function (o, i) {
            var a = this;
            if (i) return this.cacheResult().__iterate(o, i);
            var s = !0,
              l = 0;
            return e.__iterate(function (e, i, u) {
              if (!s || !(s = t.call(n, e, i, u))) return l++, o(e, r ? i : l - 1, a);
            }), l;
          }, o.__iteratorUncached = function (o, i) {
            var a = this;
            if (i) return this.cacheResult().__iterator(o, i);
            var s = e.__iterator(2, i),
              l = !0,
              u = 0;
            return new j(function () {
              var e, i, c;
              do {
                if ((e = s.next()).done) return r || 1 === o ? e : B(o, u++, 0 === o ? void 0 : e.value[1], e);
                var d = e.value;
                i = d[0], c = d[1], l && (l = t.call(n, c, i, a));
              } while (l);
              return 2 === o ? e : B(o, i, c, e);
            });
          }, o;
        }
        function Ie(e, t) {
          var n = b(e),
            r = [e].concat(t).map(function (e) {
              return v(e) ? n && (e = S(e)) : e = n ? te(e) : ne(Array.isArray(e) ? e : [e]), e;
            }).filter(function (e) {
              return 0 !== e.size;
            });
          if (0 === r.length) return e;
          if (1 === r.length) {
            var o = r[0];
            if (o === e || n && b(o) || x(e) && x(o)) return o;
          }
          var i = new Y(r);
          return n ? i = i.toKeyedSeq() : x(e) || (i = i.toSetSeq()), (i = i.flatten(!0)).size = r.reduce(function (e, t) {
            if (void 0 !== e) {
              var n = t.size;
              if (void 0 !== n) return e + n;
            }
          }, 0), i;
        }
        function Fe(e, t, n) {
          var r = Ke(e);
          return r.__iterateUncached = function (o, i) {
            if (i) return this.cacheResult().__iterate(o, i);
            var a = 0,
              s = !1;
            return function e(l, u) {
              l.__iterate(function (i, l) {
                return (!t || u < t) && v(i) ? e(i, u + 1) : (a++, !1 === o(i, n ? l : a - 1, r) && (s = !0)), !s;
              }, i);
            }(e, 0), a;
          }, r.__iteratorUncached = function (r, o) {
            if (o) return this.cacheResult().__iterator(r, o);
            var i = e.__iterator(r, o),
              a = [],
              s = 0;
            return new j(function () {
              for (; i;) {
                var e = i.next();
                if (!1 === e.done) {
                  var l = e.value;
                  if (2 === r && (l = l[1]), t && !(a.length < t) || !v(l)) return n ? e : B(r, s++, l, e);
                  a.push(i), i = l.__iterator(r, o);
                } else i = a.pop();
              }
              return {
                value: void 0,
                done: !0
              };
            });
          }, r;
        }
        function Me(e, t, n) {
          t || (t = He);
          var r = b(e),
            o = 0,
            i = e.toSeq().map(function (t, r) {
              return [r, t, o++, n ? n(t, r, e) : t];
            }).valueSeq().toArray();
          return i.sort(function (e, n) {
            return t(e[3], n[3]) || e[2] - n[2];
          }).forEach(r ? function (e, t) {
            i[t].length = 2;
          } : function (e, t) {
            i[t] = e[1];
          }), r ? $(i) : x(e) ? G(i) : W(i);
        }
        function Re(e, t, n) {
          if (t || (t = He), n) {
            var r = e.toSeq().map(function (t, r) {
              return [t, n(t, r, e)];
            }).reduce(function (e, n) {
              return je(t, e[1], n[1]) ? n : e;
            });
            return r && r[0];
          }
          return e.reduce(function (e, n) {
            return je(t, e, n) ? n : e;
          });
        }
        function je(e, t, n) {
          var r = e(n, t);
          return 0 === r && n !== t && (null == n || n != n) || r > 0;
        }
        function Be(e, t, n, r) {
          var o = Ke(e),
            i = new Y(n).map(function (e) {
              return e.size;
            });
          return o.size = r ? i.max() : i.min(), o.__iterate = function (e, t) {
            for (var n, r = this.__iterator(1, t), o = 0; !(n = r.next()).done && !1 !== e(n.value, o++, this););
            return o;
          }, o.__iteratorUncached = function (e, o) {
            var i = n.map(function (e) {
                return e = C(e), K(o ? e.reverse() : e);
              }),
              a = 0,
              s = !1;
            return new j(function () {
              var n;
              return s || (n = i.map(function (e) {
                return e.next();
              }), s = r ? n.every(function (e) {
                return e.done;
              }) : n.some(function (e) {
                return e.done;
              })), s ? {
                value: void 0,
                done: !0
              } : B(e, a++, t.apply(null, n.map(function (e) {
                return e.value;
              })));
            });
          }, o;
        }
        function Ne(e, t) {
          return e === t ? e : k(e) ? t : e.constructor(t);
        }
        function Le(e) {
          if (e !== Object(e)) throw new TypeError("Expected [K, V] tuple: " + e);
        }
        function Ve(e) {
          return b(e) ? S : x(e) ? E : _;
        }
        function Ke(e) {
          return Object.create((b(e) ? $ : x(e) ? G : W).prototype);
        }
        function qe() {
          return this._iter.cacheResult ? (this._iter.cacheResult(), this.size = this._iter.size, this) : Z.prototype.cacheResult.call(this);
        }
        function He(e, t) {
          return void 0 === e && void 0 === t ? 0 : void 0 === e ? 1 : void 0 === t ? -1 : e > t ? 1 : e < t ? -1 : 0;
        }
        function Ue(e, t) {
          t = t || 0;
          for (var n = Math.max(0, e.length - t), r = new Array(n), o = 0; o < n; o++) r[o] = e[o + t];
          return r;
        }
        function Ze(e, t) {
          if (!e) throw new Error(t);
        }
        function $e(e) {
          Ze(e !== 1 / 0, "Cannot perform this action with an infinite size.");
        }
        function Ge(e) {
          if (U(e) && "string" != typeof e) return e;
          if (I(e)) return e.toArray();
          throw new TypeError("Invalid keyPath: expected Ordered Collection or Array: " + e);
        }
        function We(e) {
          return e && (e.constructor && "Object" === e.constructor.name || void 0 === e.constructor);
        }
        function Ye(e) {
          return "object" == typeof e && (T(e) || Array.isArray(e) || We(e));
        }
        function Xe(e) {
          try {
            return "string" == typeof e ? JSON.stringify(e) : String(e);
          } catch (t) {
            return JSON.stringify(e);
          }
        }
        function Qe(e, t) {
          return T(e) ? e.has(t) : Ye(e) && H.call(e, t);
        }
        function Je(e, t, n) {
          return T(e) ? e.get(t, n) : Qe(e, t) ? "function" == typeof e.get ? e.get(t) : e[t] : n;
        }
        function et(e) {
          if (Array.isArray(e)) return Ue(e);
          var t = {};
          for (var n in e) H.call(e, n) && (t[n] = e[n]);
          return t;
        }
        function tt(e, t) {
          if (!Ye(e)) throw new TypeError("Cannot update non-data-structure value: " + e);
          if (T(e)) {
            if (!e.remove) throw new TypeError("Cannot update immutable value without .remove() method: " + e);
            return e.remove(t);
          }
          if (!H.call(e, t)) return e;
          var n = et(e);
          return Array.isArray(n) ? n.splice(t, 1) : delete n[t], n;
        }
        function nt(e, t, n) {
          if (!Ye(e)) throw new TypeError("Cannot update non-data-structure value: " + e);
          if (T(e)) {
            if (!e.set) throw new TypeError("Cannot update immutable value without .set() method: " + e);
            return e.set(t, n);
          }
          if (H.call(e, t) && n === e[t]) return e;
          var r = et(e);
          return r[t] = n, r;
        }
        function rt(e, t, n, r) {
          r || (r = n, n = void 0);
          var o = ot(T(e), e, Ge(t), 0, n, r);
          return o === i ? n : o;
        }
        function ot(e, t, n, r, o, a) {
          var s = t === i;
          if (r === n.length) {
            var l = s ? o : t,
              u = a(l);
            return u === l ? t : u;
          }
          if (!s && !Ye(t)) throw new TypeError("Cannot update within non-data-structure value in path [" + n.slice(0, r).map(Xe) + "]: " + t);
          var c = n[r],
            d = s ? i : Je(t, c, i),
            p = ot(d === i ? e : T(d), d, n, r + 1, o, a);
          return p === d ? t : p === i ? tt(t, c) : nt(s ? e ? jt() : {} : t, c, p);
        }
        function it(e, t, n) {
          return rt(e, t, i, function () {
            return n;
          });
        }
        function at(e, t) {
          return it(this, e, t);
        }
        function st(e, t) {
          return rt(e, t, function () {
            return i;
          });
        }
        function lt(e) {
          return st(this, e);
        }
        function ut(e, t, n, r) {
          return rt(e, [t], n, r);
        }
        function ct(e, t, n) {
          return 1 === arguments.length ? e(this) : ut(this, e, t, n);
        }
        function dt(e, t, n) {
          return rt(this, e, t, n);
        }
        function pt() {
          for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
          return ft(this, e);
        }
        function ht(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) t[n] = arguments[n + 1];
          if ("function" != typeof e) throw new TypeError("Invalid merger function: " + e);
          return ft(this, t, e);
        }
        function ft(e, t, n) {
          for (var r = [], o = 0; o < t.length; o++) {
            var a = S(t[o]);
            0 !== a.size && r.push(a);
          }
          return 0 === r.length ? e : 0 !== e.toSeq().size || e.__ownerID || 1 !== r.length ? e.withMutations(function (e) {
            for (var t = n ? function (t, r) {
                ut(e, r, i, function (e) {
                  return e === i ? t : n(e, t, r);
                });
              } : function (t, n) {
                e.set(n, t);
              }, o = 0; o < r.length; o++) r[o].forEach(t);
          }) : e.constructor(r[0]);
        }
        function mt(e, t, n) {
          return gt(e, t, function (e) {
            function t(n, r, o) {
              return Ye(n) && Ye(r) ? gt(n, [r], t) : e ? e(n, r, o) : r;
            }
            return t;
          }(n));
        }
        function gt(e, t, n) {
          if (!Ye(e)) throw new TypeError("Cannot merge into non-data-structure value: " + e);
          if (T(e)) return "function" == typeof n && e.mergeWith ? e.mergeWith.apply(e, [n].concat(t)) : e.merge ? e.merge.apply(e, t) : e.concat.apply(e, t);
          for (var r = Array.isArray(e), o = e, i = r ? E : S, a = r ? function (t) {
              o === e && (o = et(o)), o.push(t);
            } : function (t, r) {
              var i = H.call(o, r),
                a = i && n ? n(o[r], t, r) : t;
              i && a === o[r] || (o === e && (o = et(o)), o[r] = a);
            }, s = 0; s < t.length; s++) i(t[s]).forEach(a);
          return o;
        }
        function vt() {
          for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
          return mt(this, e);
        }
        function yt(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) t[n] = arguments[n + 1];
          return mt(this, t, e);
        }
        function bt(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) t[n] = arguments[n + 1];
          return rt(this, e, jt(), function (e) {
            return gt(e, t);
          });
        }
        function wt(e) {
          for (var t = [], n = arguments.length - 1; n-- > 0;) t[n] = arguments[n + 1];
          return rt(this, e, jt(), function (e) {
            return mt(e, t);
          });
        }
        function xt(e) {
          var t = this.asMutable();
          return e(t), t.wasAltered() ? t.__ensureOwner(this.__ownerID) : this;
        }
        function Dt() {
          return this.__ownerID ? this : this.__ensureOwner(new s());
        }
        function Ct() {
          return this.__ensureOwner();
        }
        function St() {
          return this.__altered;
        }
        Se.prototype.cacheResult = Ce.prototype.cacheResult = Ee.prototype.cacheResult = _e.prototype.cacheResult = qe;
        var Et = function (e) {
          function t(t) {
            return null == t ? jt() : ie(t) && !I(t) ? t : jt().withMutations(function (n) {
              var r = e(t);
              $e(r.size), r.forEach(function (e, t) {
                return n.set(t, e);
              });
            });
          }
          return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            return jt().withMutations(function (t) {
              for (var n = 0; n < e.length; n += 2) {
                if (n + 1 >= e.length) throw new Error("Missing value for key: " + e[n]);
                t.set(e[n], e[n + 1]);
              }
            });
          }, t.prototype.toString = function () {
            return this.__toString("Map {", "}");
          }, t.prototype.get = function (e, t) {
            return this._root ? this._root.get(0, void 0, e, t) : t;
          }, t.prototype.set = function (e, t) {
            return Bt(this, e, t);
          }, t.prototype.remove = function (e) {
            return Bt(this, e, i);
          }, t.prototype.deleteAll = function (e) {
            var t = C(e);
            return 0 === t.size ? this : this.withMutations(function (e) {
              t.forEach(function (t) {
                return e.remove(t);
              });
            });
          }, t.prototype.clear = function () {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._root = null, this.__hash = void 0, this.__altered = !0, this) : jt();
          }, t.prototype.sort = function (e) {
            return cn(Me(this, e));
          }, t.prototype.sortBy = function (e, t) {
            return cn(Me(this, t, e));
          }, t.prototype.map = function (e, t) {
            return this.withMutations(function (n) {
              n.forEach(function (r, o) {
                n.set(o, e.call(t, r, o, n));
              });
            });
          }, t.prototype.__iterator = function (e, t) {
            return new It(this, e, t);
          }, t.prototype.__iterate = function (e, t) {
            var n = this,
              r = 0;
            return this._root && this._root.iterate(function (t) {
              return r++, e(t[1], t[0], n);
            }, t), r;
          }, t.prototype.__ensureOwner = function (e) {
            return e === this.__ownerID ? this : e ? Rt(this.size, this._root, e, this.__hash) : 0 === this.size ? jt() : (this.__ownerID = e, this.__altered = !1, this);
          }, t;
        }(S);
        Et.isMap = ie;
        var _t = Et.prototype;
        _t[oe] = !0, _t.delete = _t.remove, _t.removeAll = _t.deleteAll, _t.setIn = at, _t.removeIn = _t.deleteIn = lt, _t.update = ct, _t.updateIn = dt, _t.merge = _t.concat = pt, _t.mergeWith = ht, _t.mergeDeep = vt, _t.mergeDeepWith = yt, _t.mergeIn = bt, _t.mergeDeepIn = wt, _t.withMutations = xt, _t.wasAltered = St, _t.asImmutable = Ct, _t["@@transducer/init"] = _t.asMutable = Dt, _t["@@transducer/step"] = function (e, t) {
          return e.set(t[0], t[1]);
        }, _t["@@transducer/result"] = function (e) {
          return e.asImmutable();
        };
        var Pt = function (e, t) {
          this.ownerID = e, this.entries = t;
        };
        Pt.prototype.get = function (e, t, n, r) {
          for (var o = this.entries, i = 0, a = o.length; i < a; i++) if (le(n, o[i][0])) return o[i][1];
          return r;
        }, Pt.prototype.update = function (e, t, n, r, o, l, u) {
          for (var c = o === i, d = this.entries, p = 0, h = d.length; p < h && !le(r, d[p][0]); p++);
          var f = p < h;
          if (f ? d[p][1] === o : c) return this;
          if (a(u), (c || !f) && a(l), !c || 1 !== d.length) {
            if (!f && !c && d.length >= Ht) return function (e, t, n, r) {
              e || (e = new s());
              for (var o = new Tt(e, de(n), [n, r]), i = 0; i < t.length; i++) {
                var a = t[i];
                o = o.update(e, 0, void 0, a[0], a[1]);
              }
              return o;
            }(e, d, r, o);
            var m = e && e === this.ownerID,
              g = m ? d : Ue(d);
            return f ? c ? p === h - 1 ? g.pop() : g[p] = g.pop() : g[p] = [r, o] : g.push([r, o]), m ? (this.entries = g, this) : new Pt(e, g);
          }
        };
        var kt = function (e, t, n) {
          this.ownerID = e, this.bitmap = t, this.nodes = n;
        };
        kt.prototype.get = function (e, t, n, r) {
          void 0 === t && (t = de(n));
          var i = 1 << ((0 === e ? t : t >>> e) & o),
            a = this.bitmap;
          return 0 == (a & i) ? r : this.nodes[Kt(a & i - 1)].get(e + 5, t, n, r);
        }, kt.prototype.update = function (e, t, n, a, s, l, u) {
          void 0 === n && (n = de(a));
          var c = (0 === t ? n : n >>> t) & o,
            d = 1 << c,
            p = this.bitmap,
            h = 0 != (p & d);
          if (!h && s === i) return this;
          var f = Kt(p & d - 1),
            m = this.nodes,
            g = h ? m[f] : void 0,
            v = Nt(g, e, t + 5, n, a, s, l, u);
          if (v === g) return this;
          if (!h && v && m.length >= Ut) return function (e, t, n, o, i) {
            for (var a = 0, s = new Array(r), l = 0; 0 !== n; l++, n >>>= 1) s[l] = 1 & n ? t[a++] : void 0;
            return s[o] = i, new At(e, a + 1, s);
          }(e, m, p, c, v);
          if (h && !v && 2 === m.length && Lt(m[1 ^ f])) return m[1 ^ f];
          if (h && v && 1 === m.length && Lt(v)) return v;
          var y = e && e === this.ownerID,
            b = h ? v ? p : p ^ d : p | d,
            w = h ? v ? qt(m, f, v, y) : function (e, t, n) {
              var r = e.length - 1;
              if (n && t === r) return e.pop(), e;
              for (var o = new Array(r), i = 0, a = 0; a < r; a++) a === t && (i = 1), o[a] = e[a + i];
              return o;
            }(m, f, y) : function (e, t, n, r) {
              var o = e.length + 1;
              if (r && t + 1 === o) return e[t] = n, e;
              for (var i = new Array(o), a = 0, s = 0; s < o; s++) s === t ? (i[s] = n, a = -1) : i[s] = e[s + a];
              return i;
            }(m, f, v, y);
          return y ? (this.bitmap = b, this.nodes = w, this) : new kt(e, b, w);
        };
        var At = function (e, t, n) {
          this.ownerID = e, this.count = t, this.nodes = n;
        };
        At.prototype.get = function (e, t, n, r) {
          void 0 === t && (t = de(n));
          var i = (0 === e ? t : t >>> e) & o,
            a = this.nodes[i];
          return a ? a.get(e + 5, t, n, r) : r;
        }, At.prototype.update = function (e, t, n, r, a, s, l) {
          void 0 === n && (n = de(r));
          var u = (0 === t ? n : n >>> t) & o,
            c = a === i,
            d = this.nodes,
            p = d[u];
          if (c && !p) return this;
          var h = Nt(p, e, t + 5, n, r, a, s, l);
          if (h === p) return this;
          var f = this.count;
          if (p) {
            if (!h && --f < Zt) return function (e, t, n, r) {
              for (var o = 0, i = 0, a = new Array(n), s = 0, l = 1, u = t.length; s < u; s++, l <<= 1) {
                var c = t[s];
                void 0 !== c && s !== r && (o |= l, a[i++] = c);
              }
              return new kt(e, o, a);
            }(e, d, f, u);
          } else f++;
          var m = e && e === this.ownerID,
            g = qt(d, u, h, m);
          return m ? (this.count = f, this.nodes = g, this) : new At(e, f, g);
        };
        var zt = function (e, t, n) {
          this.ownerID = e, this.keyHash = t, this.entries = n;
        };
        zt.prototype.get = function (e, t, n, r) {
          for (var o = this.entries, i = 0, a = o.length; i < a; i++) if (le(n, o[i][0])) return o[i][1];
          return r;
        }, zt.prototype.update = function (e, t, n, r, o, s, l) {
          void 0 === n && (n = de(r));
          var u = o === i;
          if (n !== this.keyHash) return u ? this : (a(l), a(s), Vt(this, e, t, n, [r, o]));
          for (var c = this.entries, d = 0, p = c.length; d < p && !le(r, c[d][0]); d++);
          var h = d < p;
          if (h ? c[d][1] === o : u) return this;
          if (a(l), (u || !h) && a(s), u && 2 === p) return new Tt(e, this.keyHash, c[1 ^ d]);
          var f = e && e === this.ownerID,
            m = f ? c : Ue(c);
          return h ? u ? d === p - 1 ? m.pop() : m[d] = m.pop() : m[d] = [r, o] : m.push([r, o]), f ? (this.entries = m, this) : new zt(e, this.keyHash, m);
        };
        var Tt = function (e, t, n) {
          this.ownerID = e, this.keyHash = t, this.entry = n;
        };
        Tt.prototype.get = function (e, t, n, r) {
          return le(n, this.entry[0]) ? this.entry[1] : r;
        }, Tt.prototype.update = function (e, t, n, r, o, s, l) {
          var u = o === i,
            c = le(r, this.entry[0]);
          return (c ? o === this.entry[1] : u) ? this : (a(l), u ? void a(s) : c ? e && e === this.ownerID ? (this.entry[1] = o, this) : new Tt(e, this.keyHash, [r, o]) : (a(s), Vt(this, e, t, de(r), [r, o])));
        }, Pt.prototype.iterate = zt.prototype.iterate = function (e, t) {
          for (var n = this.entries, r = 0, o = n.length - 1; r <= o; r++) if (!1 === e(n[t ? o - r : r])) return !1;
        }, kt.prototype.iterate = At.prototype.iterate = function (e, t) {
          for (var n = this.nodes, r = 0, o = n.length - 1; r <= o; r++) {
            var i = n[t ? o - r : r];
            if (i && !1 === i.iterate(e, t)) return !1;
          }
        }, Tt.prototype.iterate = function (e, t) {
          return e(this.entry);
        };
        var Ot,
          It = function (e) {
            function t(e, t, n) {
              this._type = t, this._reverse = n, this._stack = e._root && Mt(e._root);
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.next = function () {
              for (var e = this, t = this._type, n = this._stack; n;) {
                var r = n.node,
                  o = n.index++,
                  i = void 0;
                if (r.entry) {
                  if (0 === o) return Ft(t, r.entry);
                } else if (r.entries) {
                  if (o <= (i = r.entries.length - 1)) return Ft(t, r.entries[e._reverse ? i - o : o]);
                } else if (o <= (i = r.nodes.length - 1)) {
                  var a = r.nodes[e._reverse ? i - o : o];
                  if (a) {
                    if (a.entry) return Ft(t, a.entry);
                    n = e._stack = Mt(a, n);
                  }
                  continue;
                }
                n = e._stack = e._stack.__prev;
              }
              return {
                value: void 0,
                done: !0
              };
            }, t;
          }(j);
        function Ft(e, t) {
          return B(e, t[0], t[1]);
        }
        function Mt(e, t) {
          return {
            node: e,
            index: 0,
            __prev: t
          };
        }
        function Rt(e, t, n, r) {
          var o = Object.create(_t);
          return o.size = e, o._root = t, o.__ownerID = n, o.__hash = r, o.__altered = !1, o;
        }
        function jt() {
          return Ot || (Ot = Rt(0));
        }
        function Bt(e, t, n) {
          var r, o;
          if (e._root) {
            var a = {
                value: !1
              },
              s = {
                value: !1
              };
            if (r = Nt(e._root, e.__ownerID, 0, void 0, t, n, a, s), !s.value) return e;
            o = e.size + (a.value ? n === i ? -1 : 1 : 0);
          } else {
            if (n === i) return e;
            o = 1, r = new Pt(e.__ownerID, [[t, n]]);
          }
          return e.__ownerID ? (e.size = o, e._root = r, e.__hash = void 0, e.__altered = !0, e) : r ? Rt(o, r) : jt();
        }
        function Nt(e, t, n, r, o, s, l, u) {
          return e ? e.update(t, n, r, o, s, l, u) : s === i ? e : (a(u), a(l), new Tt(t, r, [o, s]));
        }
        function Lt(e) {
          return e.constructor === Tt || e.constructor === zt;
        }
        function Vt(e, t, n, r, i) {
          if (e.keyHash === r) return new zt(t, r, [e.entry, i]);
          var a,
            s = (0 === n ? e.keyHash : e.keyHash >>> n) & o,
            l = (0 === n ? r : r >>> n) & o,
            u = s === l ? [Vt(e, t, n + 5, r, i)] : (a = new Tt(t, r, i), s < l ? [e, a] : [a, e]);
          return new kt(t, 1 << s | 1 << l, u);
        }
        function Kt(e) {
          return e = (e = (858993459 & (e -= e >> 1 & 1431655765)) + (e >> 2 & 858993459)) + (e >> 4) & 252645135, e += e >> 8, 127 & (e += e >> 16);
        }
        function qt(e, t, n, r) {
          var o = r ? e : Ue(e);
          return o[t] = n, o;
        }
        var Ht = 8,
          Ut = 16,
          Zt = 8,
          $t = "@@__IMMUTABLE_LIST__@@";
        function Gt(e) {
          return Boolean(e && e[$t]);
        }
        var Wt = function (e) {
          function t(t) {
            var n = nn();
            if (null == t) return n;
            if (Gt(t)) return t;
            var o = e(t),
              i = o.size;
            return 0 === i ? n : ($e(i), i > 0 && i < r ? tn(0, i, 5, null, new Xt(o.toArray())) : n.withMutations(function (e) {
              e.setSize(i), o.forEach(function (t, n) {
                return e.set(n, t);
              });
            }));
          }
          return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
            return this(arguments);
          }, t.prototype.toString = function () {
            return this.__toString("List [", "]");
          }, t.prototype.get = function (e, t) {
            if ((e = u(this, e)) >= 0 && e < this.size) {
              var n = an(this, e += this._origin);
              return n && n.array[e & o];
            }
            return t;
          }, t.prototype.set = function (e, t) {
            return function (e, t, n) {
              if ((t = u(e, t)) != t) return e;
              if (t >= e.size || t < 0) return e.withMutations(function (e) {
                t < 0 ? sn(e, t).set(0, n) : sn(e, 0, t + 1).set(t, n);
              });
              t += e._origin;
              var r = e._tail,
                o = e._root,
                i = {
                  value: !1
                };
              t >= ln(e._capacity) ? r = rn(r, e.__ownerID, 0, t, n, i) : o = rn(o, e.__ownerID, e._level, t, n, i);
              if (!i.value) return e;
              if (e.__ownerID) return e._root = o, e._tail = r, e.__hash = void 0, e.__altered = !0, e;
              return tn(e._origin, e._capacity, e._level, o, r);
            }(this, e, t);
          }, t.prototype.remove = function (e) {
            return this.has(e) ? 0 === e ? this.shift() : e === this.size - 1 ? this.pop() : this.splice(e, 1) : this;
          }, t.prototype.insert = function (e, t) {
            return this.splice(e, 0, t);
          }, t.prototype.clear = function () {
            return 0 === this.size ? this : this.__ownerID ? (this.size = this._origin = this._capacity = 0, this._level = 5, this._root = this._tail = null, this.__hash = void 0, this.__altered = !0, this) : nn();
          }, t.prototype.push = function () {
            var e = arguments,
              t = this.size;
            return this.withMutations(function (n) {
              sn(n, 0, t + e.length);
              for (var r = 0; r < e.length; r++) n.set(t + r, e[r]);
            });
          }, t.prototype.pop = function () {
            return sn(this, 0, -1);
          }, t.prototype.unshift = function () {
            var e = arguments;
            return this.withMutations(function (t) {
              sn(t, -e.length);
              for (var n = 0; n < e.length; n++) t.set(n, e[n]);
            });
          }, t.prototype.shift = function () {
            return sn(this, 1);
          }, t.prototype.concat = function () {
            for (var t = arguments, n = [], r = 0; r < arguments.length; r++) {
              var o = t[r],
                i = e("string" != typeof o && L(o) ? o : [o]);
              0 !== i.size && n.push(i);
            }
            return 0 === n.length ? this : 0 !== this.size || this.__ownerID || 1 !== n.length ? this.withMutations(function (e) {
              n.forEach(function (t) {
                return t.forEach(function (t) {
                  return e.push(t);
                });
              });
            }) : this.constructor(n[0]);
          }, t.prototype.setSize = function (e) {
            return sn(this, 0, e);
          }, t.prototype.map = function (e, t) {
            var n = this;
            return this.withMutations(function (r) {
              for (var o = 0; o < n.size; o++) r.set(o, e.call(t, r.get(o), o, r));
            });
          }, t.prototype.slice = function (e, t) {
            var n = this.size;
            return d(e, t, n) ? this : sn(this, p(e, n), h(t, n));
          }, t.prototype.__iterator = function (e, t) {
            var n = t ? this.size : 0,
              r = en(this, t);
            return new j(function () {
              var o = r();
              return o === Jt ? {
                value: void 0,
                done: !0
              } : B(e, t ? --n : n++, o);
            });
          }, t.prototype.__iterate = function (e, t) {
            for (var n, r = t ? this.size : 0, o = en(this, t); (n = o()) !== Jt && !1 !== e(n, t ? --r : r++, this););
            return r;
          }, t.prototype.__ensureOwner = function (e) {
            return e === this.__ownerID ? this : e ? tn(this._origin, this._capacity, this._level, this._root, this._tail, e, this.__hash) : 0 === this.size ? nn() : (this.__ownerID = e, this.__altered = !1, this);
          }, t;
        }(E);
        Wt.isList = Gt;
        var Yt = Wt.prototype;
        Yt[$t] = !0, Yt.delete = Yt.remove, Yt.merge = Yt.concat, Yt.setIn = at, Yt.deleteIn = Yt.removeIn = lt, Yt.update = ct, Yt.updateIn = dt, Yt.mergeIn = bt, Yt.mergeDeepIn = wt, Yt.withMutations = xt, Yt.wasAltered = St, Yt.asImmutable = Ct, Yt["@@transducer/init"] = Yt.asMutable = Dt, Yt["@@transducer/step"] = function (e, t) {
          return e.push(t);
        }, Yt["@@transducer/result"] = function (e) {
          return e.asImmutable();
        };
        var Xt = function (e, t) {
          this.array = e, this.ownerID = t;
        };
        Xt.prototype.removeBefore = function (e, t, n) {
          if (n === t ? 1 << t : 0 === this.array.length) return this;
          var r = n >>> t & o;
          if (r >= this.array.length) return new Xt([], e);
          var i,
            a = 0 === r;
          if (t > 0) {
            var s = this.array[r];
            if ((i = s && s.removeBefore(e, t - 5, n)) === s && a) return this;
          }
          if (a && !i) return this;
          var l = on(this, e);
          if (!a) for (var u = 0; u < r; u++) l.array[u] = void 0;
          return i && (l.array[r] = i), l;
        }, Xt.prototype.removeAfter = function (e, t, n) {
          if (n === (t ? 1 << t : 0) || 0 === this.array.length) return this;
          var r,
            i = n - 1 >>> t & o;
          if (i >= this.array.length) return this;
          if (t > 0) {
            var a = this.array[i];
            if ((r = a && a.removeAfter(e, t - 5, n)) === a && i === this.array.length - 1) return this;
          }
          var s = on(this, e);
          return s.array.splice(i + 1), r && (s.array[i] = r), s;
        };
        var Qt,
          Jt = {};
        function en(e, t) {
          var n = e._origin,
            o = e._capacity,
            i = ln(o),
            a = e._tail;
          return s(e._root, e._level, 0);
          function s(e, l, u) {
            return 0 === l ? function (e, s) {
              var l = s === i ? a && a.array : e && e.array,
                u = s > n ? 0 : n - s,
                c = o - s;
              c > r && (c = r);
              return function () {
                if (u === c) return Jt;
                var e = t ? --c : u++;
                return l && l[e];
              };
            }(e, u) : function (e, i, a) {
              var l,
                u = e && e.array,
                c = a > n ? 0 : n - a >> i,
                d = 1 + (o - a >> i);
              d > r && (d = r);
              return function () {
                for (;;) {
                  if (l) {
                    var e = l();
                    if (e !== Jt) return e;
                    l = null;
                  }
                  if (c === d) return Jt;
                  var n = t ? --d : c++;
                  l = s(u && u[n], i - 5, a + (n << i));
                }
              };
            }(e, l, u);
          }
        }
        function tn(e, t, n, r, o, i, a) {
          var s = Object.create(Yt);
          return s.size = t - e, s._origin = e, s._capacity = t, s._level = n, s._root = r, s._tail = o, s.__ownerID = i, s.__hash = a, s.__altered = !1, s;
        }
        function nn() {
          return Qt || (Qt = tn(0, 0, 5));
        }
        function rn(e, t, n, r, i, s) {
          var l,
            u = r >>> n & o,
            c = e && u < e.array.length;
          if (!c && void 0 === i) return e;
          if (n > 0) {
            var d = e && e.array[u],
              p = rn(d, t, n - 5, r, i, s);
            return p === d ? e : ((l = on(e, t)).array[u] = p, l);
          }
          return c && e.array[u] === i ? e : (s && a(s), l = on(e, t), void 0 === i && u === l.array.length - 1 ? l.array.pop() : l.array[u] = i, l);
        }
        function on(e, t) {
          return t && e && t === e.ownerID ? e : new Xt(e ? e.array.slice() : [], t);
        }
        function an(e, t) {
          if (t >= ln(e._capacity)) return e._tail;
          if (t < 1 << e._level + 5) {
            for (var n = e._root, r = e._level; n && r > 0;) n = n.array[t >>> r & o], r -= 5;
            return n;
          }
        }
        function sn(e, t, n) {
          void 0 !== t && (t |= 0), void 0 !== n && (n |= 0);
          var r = e.__ownerID || new s(),
            i = e._origin,
            a = e._capacity,
            l = i + t,
            u = void 0 === n ? a : n < 0 ? a + n : i + n;
          if (l === i && u === a) return e;
          if (l >= u) return e.clear();
          for (var c = e._level, d = e._root, p = 0; l + p < 0;) d = new Xt(d && d.array.length ? [void 0, d] : [], r), p += 1 << (c += 5);
          p && (l += p, i += p, u += p, a += p);
          for (var h = ln(a), f = ln(u); f >= 1 << c + 5;) d = new Xt(d && d.array.length ? [d] : [], r), c += 5;
          var m = e._tail,
            g = f < h ? an(e, u - 1) : f > h ? new Xt([], r) : m;
          if (m && f > h && l < a && m.array.length) {
            for (var v = d = on(d, r), y = c; y > 5; y -= 5) {
              var b = h >>> y & o;
              v = v.array[b] = on(v.array[b], r);
            }
            v.array[h >>> 5 & o] = m;
          }
          if (u < a && (g = g && g.removeAfter(r, 0, u)), l >= f) l -= f, u -= f, c = 5, d = null, g = g && g.removeBefore(r, 0, l);else if (l > i || f < h) {
            for (p = 0; d;) {
              var w = l >>> c & o;
              if (w !== f >>> c & o) break;
              w && (p += (1 << c) * w), c -= 5, d = d.array[w];
            }
            d && l > i && (d = d.removeBefore(r, c, l - p)), d && f < h && (d = d.removeAfter(r, c, f - p)), p && (l -= p, u -= p);
          }
          return e.__ownerID ? (e.size = u - l, e._origin = l, e._capacity = u, e._level = c, e._root = d, e._tail = g, e.__hash = void 0, e.__altered = !0, e) : tn(l, u, c, d, g);
        }
        function ln(e) {
          return e < r ? 0 : e - 1 >>> 5 << 5;
        }
        var un,
          cn = function (e) {
            function t(e) {
              return null == e ? pn() : ae(e) ? e : pn().withMutations(function (t) {
                var n = S(e);
                $e(n.size), n.forEach(function (e, n) {
                  return t.set(n, e);
                });
              });
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
              return this(arguments);
            }, t.prototype.toString = function () {
              return this.__toString("OrderedMap {", "}");
            }, t.prototype.get = function (e, t) {
              var n = this._map.get(e);
              return void 0 !== n ? this._list.get(n)[1] : t;
            }, t.prototype.clear = function () {
              return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._map.clear(), this._list.clear(), this) : pn();
            }, t.prototype.set = function (e, t) {
              return hn(this, e, t);
            }, t.prototype.remove = function (e) {
              return hn(this, e, i);
            }, t.prototype.wasAltered = function () {
              return this._map.wasAltered() || this._list.wasAltered();
            }, t.prototype.__iterate = function (e, t) {
              var n = this;
              return this._list.__iterate(function (t) {
                return t && e(t[1], t[0], n);
              }, t);
            }, t.prototype.__iterator = function (e, t) {
              return this._list.fromEntrySeq().__iterator(e, t);
            }, t.prototype.__ensureOwner = function (e) {
              if (e === this.__ownerID) return this;
              var t = this._map.__ensureOwner(e),
                n = this._list.__ensureOwner(e);
              return e ? dn(t, n, e, this.__hash) : 0 === this.size ? pn() : (this.__ownerID = e, this._map = t, this._list = n, this);
            }, t;
          }(Et);
        function dn(e, t, n, r) {
          var o = Object.create(cn.prototype);
          return o.size = e ? e.size : 0, o._map = e, o._list = t, o.__ownerID = n, o.__hash = r, o;
        }
        function pn() {
          return un || (un = dn(jt(), nn()));
        }
        function hn(e, t, n) {
          var o,
            a,
            s = e._map,
            l = e._list,
            u = s.get(t),
            c = void 0 !== u;
          if (n === i) {
            if (!c) return e;
            l.size >= r && l.size >= 2 * s.size ? (o = (a = l.filter(function (e, t) {
              return void 0 !== e && u !== t;
            })).toKeyedSeq().map(function (e) {
              return e[0];
            }).flip().toMap(), e.__ownerID && (o.__ownerID = a.__ownerID = e.__ownerID)) : (o = s.remove(t), a = u === l.size - 1 ? l.pop() : l.set(u, void 0));
          } else if (c) {
            if (n === l.get(u)[1]) return e;
            o = s, a = l.set(u, [t, n]);
          } else o = s.set(t, l.size), a = l.set(l.size, [t, n]);
          return e.__ownerID ? (e.size = o.size, e._map = o, e._list = a, e.__hash = void 0, e) : dn(o, a);
        }
        cn.isOrderedMap = ae, cn.prototype[O] = !0, cn.prototype.delete = cn.prototype.remove;
        var fn = "@@__IMMUTABLE_STACK__@@";
        function mn(e) {
          return Boolean(e && e[fn]);
        }
        var gn = function (e) {
          function t(e) {
            return null == e ? wn() : mn(e) ? e : wn().pushAll(e);
          }
          return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
            return this(arguments);
          }, t.prototype.toString = function () {
            return this.__toString("Stack [", "]");
          }, t.prototype.get = function (e, t) {
            var n = this._head;
            for (e = u(this, e); n && e--;) n = n.next;
            return n ? n.value : t;
          }, t.prototype.peek = function () {
            return this._head && this._head.value;
          }, t.prototype.push = function () {
            var e = arguments;
            if (0 === arguments.length) return this;
            for (var t = this.size + arguments.length, n = this._head, r = arguments.length - 1; r >= 0; r--) n = {
              value: e[r],
              next: n
            };
            return this.__ownerID ? (this.size = t, this._head = n, this.__hash = void 0, this.__altered = !0, this) : bn(t, n);
          }, t.prototype.pushAll = function (t) {
            if (0 === (t = e(t)).size) return this;
            if (0 === this.size && mn(t)) return t;
            $e(t.size);
            var n = this.size,
              r = this._head;
            return t.__iterate(function (e) {
              n++, r = {
                value: e,
                next: r
              };
            }, !0), this.__ownerID ? (this.size = n, this._head = r, this.__hash = void 0, this.__altered = !0, this) : bn(n, r);
          }, t.prototype.pop = function () {
            return this.slice(1);
          }, t.prototype.clear = function () {
            return 0 === this.size ? this : this.__ownerID ? (this.size = 0, this._head = void 0, this.__hash = void 0, this.__altered = !0, this) : wn();
          }, t.prototype.slice = function (t, n) {
            if (d(t, n, this.size)) return this;
            var r = p(t, this.size);
            if (h(n, this.size) !== this.size) return e.prototype.slice.call(this, t, n);
            for (var o = this.size - r, i = this._head; r--;) i = i.next;
            return this.__ownerID ? (this.size = o, this._head = i, this.__hash = void 0, this.__altered = !0, this) : bn(o, i);
          }, t.prototype.__ensureOwner = function (e) {
            return e === this.__ownerID ? this : e ? bn(this.size, this._head, e, this.__hash) : 0 === this.size ? wn() : (this.__ownerID = e, this.__altered = !1, this);
          }, t.prototype.__iterate = function (e, t) {
            var n = this;
            if (t) return new Y(this.toArray()).__iterate(function (t, r) {
              return e(t, r, n);
            }, t);
            for (var r = 0, o = this._head; o && !1 !== e(o.value, r++, n);) o = o.next;
            return r;
          }, t.prototype.__iterator = function (e, t) {
            if (t) return new Y(this.toArray()).__iterator(e, t);
            var n = 0,
              r = this._head;
            return new j(function () {
              if (r) {
                var t = r.value;
                return r = r.next, B(e, n++, t);
              }
              return {
                value: void 0,
                done: !0
              };
            });
          }, t;
        }(E);
        gn.isStack = mn;
        var vn,
          yn = gn.prototype;
        function bn(e, t, n, r) {
          var o = Object.create(yn);
          return o.size = e, o._head = t, o.__ownerID = n, o.__hash = r, o.__altered = !1, o;
        }
        function wn() {
          return vn || (vn = bn(0));
        }
        yn[fn] = !0, yn.shift = yn.pop, yn.unshift = yn.push, yn.unshiftAll = yn.pushAll, yn.withMutations = xt, yn.wasAltered = St, yn.asImmutable = Ct, yn["@@transducer/init"] = yn.asMutable = Dt, yn["@@transducer/step"] = function (e, t) {
          return e.unshift(t);
        }, yn["@@transducer/result"] = function (e) {
          return e.asImmutable();
        };
        var xn = "@@__IMMUTABLE_SET__@@";
        function Dn(e) {
          return Boolean(e && e[xn]);
        }
        function Cn(e) {
          return Dn(e) && I(e);
        }
        function Sn(e, t) {
          if (e === t) return !0;
          if (!v(t) || void 0 !== e.size && void 0 !== t.size && e.size !== t.size || void 0 !== e.__hash && void 0 !== t.__hash && e.__hash !== t.__hash || b(e) !== b(t) || x(e) !== x(t) || I(e) !== I(t)) return !1;
          if (0 === e.size && 0 === t.size) return !0;
          var n = !D(e);
          if (I(e)) {
            var r = e.entries();
            return t.every(function (e, t) {
              var o = r.next().value;
              return o && le(o[1], e) && (n || le(o[0], t));
            }) && r.next().done;
          }
          var o = !1;
          if (void 0 === e.size) if (void 0 === t.size) "function" == typeof e.cacheResult && e.cacheResult();else {
            o = !0;
            var a = e;
            e = t, t = a;
          }
          var s = !0,
            l = t.__iterate(function (t, r) {
              if (n ? !e.has(t) : o ? !le(t, e.get(r, i)) : !le(e.get(r, i), t)) return s = !1, !1;
            });
          return s && e.size === l;
        }
        function En(e, t) {
          var n = function (n) {
            e.prototype[n] = t[n];
          };
          return Object.keys(t).forEach(n), Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(t).forEach(n), e;
        }
        function _n(e) {
          if (!e || "object" != typeof e) return e;
          if (!v(e)) {
            if (!Ye(e)) return e;
            e = Z(e);
          }
          if (b(e)) {
            var t = {};
            return e.__iterate(function (e, n) {
              t[n] = _n(e);
            }), t;
          }
          var n = [];
          return e.__iterate(function (e) {
            n.push(_n(e));
          }), n;
        }
        var Pn = function (e) {
          function t(t) {
            return null == t ? On() : Dn(t) && !I(t) ? t : On().withMutations(function (n) {
              var r = e(t);
              $e(r.size), r.forEach(function (e) {
                return n.add(e);
              });
            });
          }
          return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
            return this(arguments);
          }, t.fromKeys = function (e) {
            return this(S(e).keySeq());
          }, t.intersect = function (e) {
            return (e = C(e).toArray()).length ? An.intersect.apply(t(e.pop()), e) : On();
          }, t.union = function (e) {
            return (e = C(e).toArray()).length ? An.union.apply(t(e.pop()), e) : On();
          }, t.prototype.toString = function () {
            return this.__toString("Set {", "}");
          }, t.prototype.has = function (e) {
            return this._map.has(e);
          }, t.prototype.add = function (e) {
            return zn(this, this._map.set(e, e));
          }, t.prototype.remove = function (e) {
            return zn(this, this._map.remove(e));
          }, t.prototype.clear = function () {
            return zn(this, this._map.clear());
          }, t.prototype.map = function (e, t) {
            var n = this;
            return zn(this, this._map.map(function (t) {
              return e(t, t, n);
            }, t));
          }, t.prototype.union = function () {
            for (var t = [], n = arguments.length; n--;) t[n] = arguments[n];
            return 0 === (t = t.filter(function (e) {
              return 0 !== e.size;
            })).length ? this : 0 !== this.size || this.__ownerID || 1 !== t.length ? this.withMutations(function (n) {
              for (var r = 0; r < t.length; r++) e(t[r]).forEach(function (e) {
                return n.add(e);
              });
            }) : this.constructor(t[0]);
          }, t.prototype.intersect = function () {
            for (var t = [], n = arguments.length; n--;) t[n] = arguments[n];
            if (0 === t.length) return this;
            t = t.map(function (t) {
              return e(t);
            });
            var r = [];
            return this.forEach(function (e) {
              t.every(function (t) {
                return t.includes(e);
              }) || r.push(e);
            }), this.withMutations(function (e) {
              r.forEach(function (t) {
                e.remove(t);
              });
            });
          }, t.prototype.subtract = function () {
            for (var t = [], n = arguments.length; n--;) t[n] = arguments[n];
            if (0 === t.length) return this;
            t = t.map(function (t) {
              return e(t);
            });
            var r = [];
            return this.forEach(function (e) {
              t.some(function (t) {
                return t.includes(e);
              }) && r.push(e);
            }), this.withMutations(function (e) {
              r.forEach(function (t) {
                e.remove(t);
              });
            });
          }, t.prototype.sort = function (e) {
            return Yn(Me(this, e));
          }, t.prototype.sortBy = function (e, t) {
            return Yn(Me(this, t, e));
          }, t.prototype.wasAltered = function () {
            return this._map.wasAltered();
          }, t.prototype.__iterate = function (e, t) {
            var n = this;
            return this._map.__iterate(function (t) {
              return e(t, t, n);
            }, t);
          }, t.prototype.__iterator = function (e, t) {
            return this._map.__iterator(e, t);
          }, t.prototype.__ensureOwner = function (e) {
            if (e === this.__ownerID) return this;
            var t = this._map.__ensureOwner(e);
            return e ? this.__make(t, e) : 0 === this.size ? this.__empty() : (this.__ownerID = e, this._map = t, this);
          }, t;
        }(_);
        Pn.isSet = Dn;
        var kn,
          An = Pn.prototype;
        function zn(e, t) {
          return e.__ownerID ? (e.size = t.size, e._map = t, e) : t === e._map ? e : 0 === t.size ? e.__empty() : e.__make(t);
        }
        function Tn(e, t) {
          var n = Object.create(An);
          return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
        }
        function On() {
          return kn || (kn = Tn(jt()));
        }
        An[xn] = !0, An.delete = An.remove, An.merge = An.concat = An.union, An.withMutations = xt, An.asImmutable = Ct, An["@@transducer/init"] = An.asMutable = Dt, An["@@transducer/step"] = function (e, t) {
          return e.add(t);
        }, An["@@transducer/result"] = function (e) {
          return e.asImmutable();
        }, An.__empty = On, An.__make = Tn;
        var In,
          Fn = function (e) {
            function t(e, n, r) {
              if (!(this instanceof t)) return new t(e, n, r);
              if (Ze(0 !== r, "Cannot step a Range by 0"), e = e || 0, void 0 === n && (n = 1 / 0), r = void 0 === r ? 1 : Math.abs(r), n < e && (r = -r), this._start = e, this._end = n, this._step = r, this.size = Math.max(0, Math.ceil((n - e) / r - 1) + 1), 0 === this.size) {
                if (In) return In;
                In = this;
              }
            }
            return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function () {
              return 0 === this.size ? "Range []" : "Range [ " + this._start + "..." + this._end + (1 !== this._step ? " by " + this._step : "") + " ]";
            }, t.prototype.get = function (e, t) {
              return this.has(e) ? this._start + u(this, e) * this._step : t;
            }, t.prototype.includes = function (e) {
              var t = (e - this._start) / this._step;
              return t >= 0 && t < this.size && t === Math.floor(t);
            }, t.prototype.slice = function (e, n) {
              return d(e, n, this.size) ? this : (e = p(e, this.size), (n = h(n, this.size)) <= e ? new t(0, 0) : new t(this.get(e, this._end), this.get(n, this._end), this._step));
            }, t.prototype.indexOf = function (e) {
              var t = e - this._start;
              if (t % this._step == 0) {
                var n = t / this._step;
                if (n >= 0 && n < this.size) return n;
              }
              return -1;
            }, t.prototype.lastIndexOf = function (e) {
              return this.indexOf(e);
            }, t.prototype.__iterate = function (e, t) {
              for (var n = this.size, r = this._step, o = t ? this._start + (n - 1) * r : this._start, i = 0; i !== n && !1 !== e(o, t ? n - ++i : i++, this);) o += t ? -r : r;
              return i;
            }, t.prototype.__iterator = function (e, t) {
              var n = this.size,
                r = this._step,
                o = t ? this._start + (n - 1) * r : this._start,
                i = 0;
              return new j(function () {
                if (i === n) return {
                  value: void 0,
                  done: !0
                };
                var a = o;
                return o += t ? -r : r, B(e, t ? n - ++i : i++, a);
              });
            }, t.prototype.equals = function (e) {
              return e instanceof t ? this._start === e._start && this._end === e._end && this._step === e._step : Sn(this, e);
            }, t;
          }(G);
        function Mn(e, t, n) {
          for (var r = Ge(t), o = 0; o !== r.length;) if ((e = Je(e, r[o++], i)) === i) return n;
          return e;
        }
        function Rn(e, t) {
          return Mn(this, e, t);
        }
        function jn(e, t) {
          return Mn(e, t, i) !== i;
        }
        function Bn() {
          $e(this.size);
          var e = {};
          return this.__iterate(function (t, n) {
            e[n] = t;
          }), e;
        }
        C.isIterable = v, C.isKeyed = b, C.isIndexed = x, C.isAssociative = D, C.isOrdered = I, C.Iterator = j, En(C, {
          toArray: function () {
            $e(this.size);
            var e = new Array(this.size || 0),
              t = b(this),
              n = 0;
            return this.__iterate(function (r, o) {
              e[n++] = t ? [o, r] : r;
            }), e;
          },
          toIndexedSeq: function () {
            return new Se(this);
          },
          toJS: function () {
            return _n(this);
          },
          toKeyedSeq: function () {
            return new Ce(this, !0);
          },
          toMap: function () {
            return Et(this.toKeyedSeq());
          },
          toObject: Bn,
          toOrderedMap: function () {
            return cn(this.toKeyedSeq());
          },
          toOrderedSet: function () {
            return Yn(b(this) ? this.valueSeq() : this);
          },
          toSet: function () {
            return Pn(b(this) ? this.valueSeq() : this);
          },
          toSetSeq: function () {
            return new Ee(this);
          },
          toSeq: function () {
            return x(this) ? this.toIndexedSeq() : b(this) ? this.toKeyedSeq() : this.toSetSeq();
          },
          toStack: function () {
            return gn(b(this) ? this.valueSeq() : this);
          },
          toList: function () {
            return Wt(b(this) ? this.valueSeq() : this);
          },
          toString: function () {
            return "[Collection]";
          },
          __toString: function (e, t) {
            return 0 === this.size ? e + t : e + " " + this.toSeq().map(this.__toStringMapper).join(", ") + " " + t;
          },
          concat: function () {
            for (var e = [], t = arguments.length; t--;) e[t] = arguments[t];
            return Ne(this, Ie(this, e));
          },
          includes: function (e) {
            return this.some(function (t) {
              return le(t, e);
            });
          },
          entries: function () {
            return this.__iterator(2);
          },
          every: function (e, t) {
            $e(this.size);
            var n = !0;
            return this.__iterate(function (r, o, i) {
              if (!e.call(t, r, o, i)) return n = !1, !1;
            }), n;
          },
          filter: function (e, t) {
            return Ne(this, ze(this, e, t, !0));
          },
          find: function (e, t, n) {
            var r = this.findEntry(e, t);
            return r ? r[1] : n;
          },
          forEach: function (e, t) {
            return $e(this.size), this.__iterate(t ? e.bind(t) : e);
          },
          join: function (e) {
            $e(this.size), e = void 0 !== e ? "" + e : ",";
            var t = "",
              n = !0;
            return this.__iterate(function (r) {
              n ? n = !1 : t += e, t += null != r ? r.toString() : "";
            }), t;
          },
          keys: function () {
            return this.__iterator(0);
          },
          map: function (e, t) {
            return Ne(this, ke(this, e, t));
          },
          reduce: function (e, t, n) {
            return Kn(this, e, t, n, arguments.length < 2, !1);
          },
          reduceRight: function (e, t, n) {
            return Kn(this, e, t, n, arguments.length < 2, !0);
          },
          reverse: function () {
            return Ne(this, Ae(this, !0));
          },
          slice: function (e, t) {
            return Ne(this, Te(this, e, t, !0));
          },
          some: function (e, t) {
            return !this.every(Un(e), t);
          },
          sort: function (e) {
            return Ne(this, Me(this, e));
          },
          values: function () {
            return this.__iterator(1);
          },
          butLast: function () {
            return this.slice(0, -1);
          },
          isEmpty: function () {
            return void 0 !== this.size ? 0 === this.size : !this.some(function () {
              return !0;
            });
          },
          count: function (e, t) {
            return l(e ? this.toSeq().filter(e, t) : this);
          },
          countBy: function (e, t) {
            return function (e, t, n) {
              var r = Et().asMutable();
              return e.__iterate(function (o, i) {
                r.update(t.call(n, o, i, e), 0, function (e) {
                  return e + 1;
                });
              }), r.asImmutable();
            }(this, e, t);
          },
          equals: function (e) {
            return Sn(this, e);
          },
          entrySeq: function () {
            var e = this;
            if (e._cache) return new Y(e._cache);
            var t = e.toSeq().map(Hn).toIndexedSeq();
            return t.fromEntrySeq = function () {
              return e.toSeq();
            }, t;
          },
          filterNot: function (e, t) {
            return this.filter(Un(e), t);
          },
          findEntry: function (e, t, n) {
            var r = n;
            return this.__iterate(function (n, o, i) {
              if (e.call(t, n, o, i)) return r = [o, n], !1;
            }), r;
          },
          findKey: function (e, t) {
            var n = this.findEntry(e, t);
            return n && n[0];
          },
          findLast: function (e, t, n) {
            return this.toKeyedSeq().reverse().find(e, t, n);
          },
          findLastEntry: function (e, t, n) {
            return this.toKeyedSeq().reverse().findEntry(e, t, n);
          },
          findLastKey: function (e, t) {
            return this.toKeyedSeq().reverse().findKey(e, t);
          },
          first: function (e) {
            return this.find(c, null, e);
          },
          flatMap: function (e, t) {
            return Ne(this, function (e, t, n) {
              var r = Ve(e);
              return e.toSeq().map(function (o, i) {
                return r(t.call(n, o, i, e));
              }).flatten(!0);
            }(this, e, t));
          },
          flatten: function (e) {
            return Ne(this, Fe(this, e, !0));
          },
          fromEntrySeq: function () {
            return new _e(this);
          },
          get: function (e, t) {
            return this.find(function (t, n) {
              return le(n, e);
            }, void 0, t);
          },
          getIn: Rn,
          groupBy: function (e, t) {
            return function (e, t, n) {
              var r = b(e),
                o = (I(e) ? cn() : Et()).asMutable();
              e.__iterate(function (i, a) {
                o.update(t.call(n, i, a, e), function (e) {
                  return (e = e || []).push(r ? [a, i] : i), e;
                });
              });
              var i = Ve(e);
              return o.map(function (t) {
                return Ne(e, i(t));
              }).asImmutable();
            }(this, e, t);
          },
          has: function (e) {
            return this.get(e, i) !== i;
          },
          hasIn: function (e) {
            return jn(this, e);
          },
          isSubset: function (e) {
            return e = "function" == typeof e.includes ? e : C(e), this.every(function (t) {
              return e.includes(t);
            });
          },
          isSuperset: function (e) {
            return (e = "function" == typeof e.isSubset ? e : C(e)).isSubset(this);
          },
          keyOf: function (e) {
            return this.findKey(function (t) {
              return le(t, e);
            });
          },
          keySeq: function () {
            return this.toSeq().map(qn).toIndexedSeq();
          },
          last: function (e) {
            return this.toSeq().reverse().first(e);
          },
          lastKeyOf: function (e) {
            return this.toKeyedSeq().reverse().keyOf(e);
          },
          max: function (e) {
            return Re(this, e);
          },
          maxBy: function (e, t) {
            return Re(this, t, e);
          },
          min: function (e) {
            return Re(this, e ? Zn(e) : Gn);
          },
          minBy: function (e, t) {
            return Re(this, t ? Zn(t) : Gn, e);
          },
          rest: function () {
            return this.slice(1);
          },
          skip: function (e) {
            return 0 === e ? this : this.slice(Math.max(0, e));
          },
          skipLast: function (e) {
            return 0 === e ? this : this.slice(0, -Math.max(0, e));
          },
          skipWhile: function (e, t) {
            return Ne(this, Oe(this, e, t, !0));
          },
          skipUntil: function (e, t) {
            return this.skipWhile(Un(e), t);
          },
          sortBy: function (e, t) {
            return Ne(this, Me(this, t, e));
          },
          take: function (e) {
            return this.slice(0, Math.max(0, e));
          },
          takeLast: function (e) {
            return this.slice(-Math.max(0, e));
          },
          takeWhile: function (e, t) {
            return Ne(this, function (e, t, n) {
              var r = Ke(e);
              return r.__iterateUncached = function (r, o) {
                var i = this;
                if (o) return this.cacheResult().__iterate(r, o);
                var a = 0;
                return e.__iterate(function (e, o, s) {
                  return t.call(n, e, o, s) && ++a && r(e, o, i);
                }), a;
              }, r.__iteratorUncached = function (r, o) {
                var i = this;
                if (o) return this.cacheResult().__iterator(r, o);
                var a = e.__iterator(2, o),
                  s = !0;
                return new j(function () {
                  if (!s) return {
                    value: void 0,
                    done: !0
                  };
                  var e = a.next();
                  if (e.done) return e;
                  var o = e.value,
                    l = o[0],
                    u = o[1];
                  return t.call(n, u, l, i) ? 2 === r ? e : B(r, l, u, e) : (s = !1, {
                    value: void 0,
                    done: !0
                  });
                });
              }, r;
            }(this, e, t));
          },
          takeUntil: function (e, t) {
            return this.takeWhile(Un(e), t);
          },
          update: function (e) {
            return e(this);
          },
          valueSeq: function () {
            return this.toIndexedSeq();
          },
          hashCode: function () {
            return this.__hash || (this.__hash = function (e) {
              if (e.size === 1 / 0) return 0;
              var t = I(e),
                n = b(e),
                r = t ? 1 : 0;
              return function (e, t) {
                return t = ue(t, 3432918353), t = ue(t << 15 | t >>> -15, 461845907), t = ue(t << 13 | t >>> -13, 5), t = ue((t = (t + 3864292196 | 0) ^ e) ^ t >>> 16, 2246822507), t = ce((t = ue(t ^ t >>> 13, 3266489909)) ^ t >>> 16);
              }(e.__iterate(n ? t ? function (e, t) {
                r = 31 * r + Wn(de(e), de(t)) | 0;
              } : function (e, t) {
                r = r + Wn(de(e), de(t)) | 0;
              } : t ? function (e) {
                r = 31 * r + de(e) | 0;
              } : function (e) {
                r = r + de(e) | 0;
              }), r);
            }(this));
          }
        });
        var Nn = C.prototype;
        Nn[g] = !0, Nn[R] = Nn.values, Nn.toJSON = Nn.toArray, Nn.__toStringMapper = Xe, Nn.inspect = Nn.toSource = function () {
          return this.toString();
        }, Nn.chain = Nn.flatMap, Nn.contains = Nn.includes, En(S, {
          flip: function () {
            return Ne(this, Pe(this));
          },
          mapEntries: function (e, t) {
            var n = this,
              r = 0;
            return Ne(this, this.toSeq().map(function (o, i) {
              return e.call(t, [i, o], r++, n);
            }).fromEntrySeq());
          },
          mapKeys: function (e, t) {
            var n = this;
            return Ne(this, this.toSeq().flip().map(function (r, o) {
              return e.call(t, r, o, n);
            }).flip());
          }
        });
        var Ln = S.prototype;
        Ln[y] = !0, Ln[R] = Nn.entries, Ln.toJSON = Bn, Ln.__toStringMapper = function (e, t) {
          return Xe(t) + ": " + Xe(e);
        }, En(E, {
          toKeyedSeq: function () {
            return new Ce(this, !1);
          },
          filter: function (e, t) {
            return Ne(this, ze(this, e, t, !1));
          },
          findIndex: function (e, t) {
            var n = this.findEntry(e, t);
            return n ? n[0] : -1;
          },
          indexOf: function (e) {
            var t = this.keyOf(e);
            return void 0 === t ? -1 : t;
          },
          lastIndexOf: function (e) {
            var t = this.lastKeyOf(e);
            return void 0 === t ? -1 : t;
          },
          reverse: function () {
            return Ne(this, Ae(this, !1));
          },
          slice: function (e, t) {
            return Ne(this, Te(this, e, t, !1));
          },
          splice: function (e, t) {
            var n = arguments.length;
            if (t = Math.max(t || 0, 0), 0 === n || 2 === n && !t) return this;
            e = p(e, e < 0 ? this.count() : this.size);
            var r = this.slice(0, e);
            return Ne(this, 1 === n ? r : r.concat(Ue(arguments, 2), this.slice(e + t)));
          },
          findLastIndex: function (e, t) {
            var n = this.findLastEntry(e, t);
            return n ? n[0] : -1;
          },
          first: function (e) {
            return this.get(0, e);
          },
          flatten: function (e) {
            return Ne(this, Fe(this, e, !1));
          },
          get: function (e, t) {
            return (e = u(this, e)) < 0 || this.size === 1 / 0 || void 0 !== this.size && e > this.size ? t : this.find(function (t, n) {
              return n === e;
            }, void 0, t);
          },
          has: function (e) {
            return (e = u(this, e)) >= 0 && (void 0 !== this.size ? this.size === 1 / 0 || e < this.size : -1 !== this.indexOf(e));
          },
          interpose: function (e) {
            return Ne(this, function (e, t) {
              var n = Ke(e);
              return n.size = e.size && 2 * e.size - 1, n.__iterateUncached = function (n, r) {
                var o = this,
                  i = 0;
                return e.__iterate(function (e) {
                  return (!i || !1 !== n(t, i++, o)) && !1 !== n(e, i++, o);
                }, r), i;
              }, n.__iteratorUncached = function (n, r) {
                var o,
                  i = e.__iterator(1, r),
                  a = 0;
                return new j(function () {
                  return (!o || a % 2) && (o = i.next()).done ? o : a % 2 ? B(n, a++, t) : B(n, a++, o.value, o);
                });
              }, n;
            }(this, e));
          },
          interleave: function () {
            var e = [this].concat(Ue(arguments)),
              t = Be(this.toSeq(), G.of, e),
              n = t.flatten(!0);
            return t.size && (n.size = t.size * e.length), Ne(this, n);
          },
          keySeq: function () {
            return Fn(0, this.size);
          },
          last: function (e) {
            return this.get(-1, e);
          },
          skipWhile: function (e, t) {
            return Ne(this, Oe(this, e, t, !1));
          },
          zip: function () {
            var e = [this].concat(Ue(arguments));
            return Ne(this, Be(this, $n, e));
          },
          zipAll: function () {
            var e = [this].concat(Ue(arguments));
            return Ne(this, Be(this, $n, e, !0));
          },
          zipWith: function (e) {
            var t = Ue(arguments);
            return t[0] = this, Ne(this, Be(this, e, t));
          }
        });
        var Vn = E.prototype;
        function Kn(e, t, n, r, o, i) {
          return $e(e.size), e.__iterate(function (e, i, a) {
            o ? (o = !1, n = e) : n = t.call(r, n, e, i, a);
          }, i), n;
        }
        function qn(e, t) {
          return t;
        }
        function Hn(e, t) {
          return [t, e];
        }
        function Un(e) {
          return function () {
            return !e.apply(this, arguments);
          };
        }
        function Zn(e) {
          return function () {
            return -e.apply(this, arguments);
          };
        }
        function $n() {
          return Ue(arguments);
        }
        function Gn(e, t) {
          return e < t ? 1 : e > t ? -1 : 0;
        }
        function Wn(e, t) {
          return e ^ t + 2654435769 + (e << 6) + (e >> 2) | 0;
        }
        Vn[w] = !0, Vn[O] = !0, En(_, {
          get: function (e, t) {
            return this.has(e) ? e : t;
          },
          includes: function (e) {
            return this.has(e);
          },
          keySeq: function () {
            return this.valueSeq();
          }
        }), _.prototype.has = Nn.includes, _.prototype.contains = _.prototype.includes, En($, S.prototype), En(G, E.prototype), En(W, _.prototype);
        var Yn = function (e) {
          function t(e) {
            return null == e ? er() : Cn(e) ? e : er().withMutations(function (t) {
              var n = _(e);
              $e(n.size), n.forEach(function (e) {
                return t.add(e);
              });
            });
          }
          return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.of = function () {
            return this(arguments);
          }, t.fromKeys = function (e) {
            return this(S(e).keySeq());
          }, t.prototype.toString = function () {
            return this.__toString("OrderedSet {", "}");
          }, t;
        }(Pn);
        Yn.isOrderedSet = Cn;
        var Xn,
          Qn = Yn.prototype;
        function Jn(e, t) {
          var n = Object.create(Qn);
          return n.size = e ? e.size : 0, n._map = e, n.__ownerID = t, n;
        }
        function er() {
          return Xn || (Xn = Jn(pn()));
        }
        Qn[O] = !0, Qn.zip = Vn.zip, Qn.zipWith = Vn.zipWith, Qn.__empty = er, Qn.__make = Jn;
        var tr = function (e, t) {
          var n,
            r = function (i) {
              var a = this;
              if (i instanceof r) return i;
              if (!(this instanceof r)) return new r(i);
              if (!n) {
                n = !0;
                var s = Object.keys(e),
                  l = o._indices = {};
                o._name = t, o._keys = s, o._defaultValues = e;
                for (var u = 0; u < s.length; u++) {
                  var c = s[u];
                  l[c] = u, o[c] ? "object" == typeof console && console.warn && console.warn("Cannot define " + or(a) + ' with property "' + c + '" since that property name is part of the Record API.') : ar(o, c);
                }
              }
              this.__ownerID = void 0, this._values = Wt().withMutations(function (e) {
                e.setSize(a._keys.length), S(i).forEach(function (t, n) {
                  e.set(a._indices[n], t === a._defaultValues[n] ? void 0 : t);
                });
              });
            },
            o = r.prototype = Object.create(nr);
          return o.constructor = r, r;
        };
        tr.prototype.toString = function () {
          for (var e, t = or(this) + " { ", n = this._keys, r = 0, o = n.length; r !== o; r++) t += (r ? ", " : "") + (e = n[r]) + ": " + Xe(this.get(e));
          return t + " }";
        }, tr.prototype.equals = function (e) {
          return this === e || e && this._keys === e._keys && ir(this).equals(ir(e));
        }, tr.prototype.hashCode = function () {
          return ir(this).hashCode();
        }, tr.prototype.has = function (e) {
          return this._indices.hasOwnProperty(e);
        }, tr.prototype.get = function (e, t) {
          if (!this.has(e)) return t;
          var n = this._indices[e],
            r = this._values.get(n);
          return void 0 === r ? this._defaultValues[e] : r;
        }, tr.prototype.set = function (e, t) {
          if (this.has(e)) {
            var n = this._values.set(this._indices[e], t === this._defaultValues[e] ? void 0 : t);
            if (n !== this._values && !this.__ownerID) return rr(this, n);
          }
          return this;
        }, tr.prototype.remove = function (e) {
          return this.set(e);
        }, tr.prototype.clear = function () {
          var e = this._values.clear().setSize(this._keys.length);
          return this.__ownerID ? this : rr(this, e);
        }, tr.prototype.wasAltered = function () {
          return this._values.wasAltered();
        }, tr.prototype.toSeq = function () {
          return ir(this);
        }, tr.prototype.toJS = function () {
          return _n(this);
        }, tr.prototype.entries = function () {
          return this.__iterator(2);
        }, tr.prototype.__iterator = function (e, t) {
          return ir(this).__iterator(e, t);
        }, tr.prototype.__iterate = function (e, t) {
          return ir(this).__iterate(e, t);
        }, tr.prototype.__ensureOwner = function (e) {
          if (e === this.__ownerID) return this;
          var t = this._values.__ensureOwner(e);
          return e ? rr(this, t, e) : (this.__ownerID = e, this._values = t, this);
        }, tr.isRecord = z, tr.getDescriptiveName = or;
        var nr = tr.prototype;
        function rr(e, t, n) {
          var r = Object.create(Object.getPrototypeOf(e));
          return r._values = t, r.__ownerID = n, r;
        }
        function or(e) {
          return e._name || e.constructor.name || "Record";
        }
        function ir(e) {
          return te(e._keys.map(function (t) {
            return [t, e.get(t)];
          }));
        }
        function ar(e, t) {
          try {
            Object.defineProperty(e, t, {
              get: function () {
                return this.get(t);
              },
              set: function (e) {
                Ze(this.__ownerID, "Cannot set on an immutable record."), this.set(t, e);
              }
            });
          } catch (e) {}
        }
        nr[A] = !0, nr.delete = nr.remove, nr.deleteIn = nr.removeIn = lt, nr.getIn = Rn, nr.hasIn = Nn.hasIn, nr.merge = pt, nr.mergeWith = ht, nr.mergeIn = bt, nr.mergeDeep = vt, nr.mergeDeepWith = yt, nr.mergeDeepIn = wt, nr.setIn = at, nr.update = ct, nr.updateIn = dt, nr.withMutations = xt, nr.asMutable = Dt, nr.asImmutable = Ct, nr[R] = nr.entries, nr.toJSON = nr.toObject = Nn.toObject, nr.inspect = nr.toSource = function () {
          return this.toString();
        };
        var sr;
        !function (e) {
          function t(e, n) {
            if (!(this instanceof t)) return new t(e, n);
            if (this._value = e, this.size = void 0 === n ? 1 / 0 : Math.max(0, n), 0 === this.size) {
              if (sr) return sr;
              sr = this;
            }
          }
          e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.toString = function () {
            return 0 === this.size ? "Repeat []" : "Repeat [ " + this._value + " " + this.size + " times ]";
          }, t.prototype.get = function (e, t) {
            return this.has(e) ? this._value : t;
          }, t.prototype.includes = function (e) {
            return le(this._value, e);
          }, t.prototype.slice = function (e, n) {
            var r = this.size;
            return d(e, n, r) ? this : new t(this._value, h(n, r) - p(e, r));
          }, t.prototype.reverse = function () {
            return this;
          }, t.prototype.indexOf = function (e) {
            return le(this._value, e) ? 0 : -1;
          }, t.prototype.lastIndexOf = function (e) {
            return le(this._value, e) ? this.size : -1;
          }, t.prototype.__iterate = function (e, t) {
            for (var n = this.size, r = 0; r !== n && !1 !== e(this._value, t ? n - ++r : r++, this););
            return r;
          }, t.prototype.__iterator = function (e, t) {
            var n = this,
              r = this.size,
              o = 0;
            return new j(function () {
              return o === r ? {
                value: void 0,
                done: !0
              } : B(e, t ? r - ++o : o++, n._value);
            });
          }, t.prototype.equals = function (e) {
            return e instanceof t ? le(this._value, e._value) : Sn(e);
          };
        }(G);
        function lr(e, t) {
          return ur([], t || cr, e, "", t && t.length > 2 ? [] : void 0, {
            "": e
          });
        }
        function ur(e, t, n, r, o, i) {
          var a = Array.isArray(n) ? G : We(n) ? $ : null;
          if (a) {
            if (~e.indexOf(n)) throw new TypeError("Cannot convert circular structure to Immutable");
            e.push(n), o && "" !== r && o.push(r);
            var s = t.call(i, r, a(n).map(function (r, i) {
              return ur(e, t, r, i, o, n);
            }), o && o.slice());
            return e.pop(), o && o.pop(), s;
          }
          return n;
        }
        function cr(e, t) {
          return b(t) ? t.toMap() : t.toList();
        }
      },
      18156: (e, t) => {
        "use strict";

        for (var n = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), r = {
            alt: "altKey",
            control: "ctrlKey",
            meta: "metaKey",
            shift: "shiftKey"
          }, o = {
            add: "+",
            break: "pause",
            cmd: "meta",
            command: "meta",
            ctl: "control",
            ctrl: "control",
            del: "delete",
            down: "arrowdown",
            esc: "escape",
            ins: "insert",
            left: "arrowleft",
            mod: n ? "meta" : "control",
            opt: "alt",
            option: "alt",
            return: "enter",
            right: "arrowright",
            space: " ",
            spacebar: " ",
            up: "arrowup",
            win: "meta",
            windows: "meta"
          }, i = {
            backspace: 8,
            tab: 9,
            enter: 13,
            shift: 16,
            control: 17,
            alt: 18,
            pause: 19,
            capslock: 20,
            escape: 27,
            " ": 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36,
            arrowleft: 37,
            arrowup: 38,
            arrowright: 39,
            arrowdown: 40,
            insert: 45,
            delete: 46,
            meta: 91,
            numlock: 144,
            scrolllock: 145,
            ";": 186,
            "=": 187,
            ",": 188,
            "-": 189,
            ".": 190,
            "/": 191,
            "`": 192,
            "[": 219,
            "\\": 220,
            "]": 221,
            "'": 222
          }, a = 1; a < 20; a++) i["f" + a] = 111 + a;
        function s(e, t, n) {
          t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
          var r = e.map(function (e) {
              return l(e, t);
            }),
            o = function (e) {
              return r.some(function (t) {
                return u(t, e);
              });
            };
          return null == n ? o : o(n);
        }
        function l(e, t) {
          var n = t && t.byKey,
            o = {},
            i = (e = e.replace("++", "+add")).split("+"),
            a = i.length;
          for (var s in r) o[r[s]] = !1;
          var l = !0,
            u = !1,
            p = void 0;
          try {
            for (var h, f = i[Symbol.iterator](); !(l = (h = f.next()).done); l = !0) {
              var m = h.value,
                g = m.endsWith("?") && m.length > 1;
              g && (m = m.slice(0, -1));
              var v = d(m),
                y = r[v];
              1 !== a && y || (n ? o.key = v : o.which = c(m)), y && (o[y] = !g || null);
            }
          } catch (e) {
            u = !0, p = e;
          } finally {
            try {
              !l && f.return && f.return();
            } finally {
              if (u) throw p;
            }
          }
          return o;
        }
        function u(e, t) {
          for (var n in e) {
            var r = e[n],
              o = void 0;
            if (null != r && (null != (o = "key" === n && null != t.key ? t.key.toLowerCase() : "which" === n ? 91 === r && 93 === t.which ? 91 : t.which : t[n]) || !1 !== r) && o !== r) return !1;
          }
          return !0;
        }
        function c(e) {
          return e = d(e), i[e] || e.toUpperCase().charCodeAt(0);
        }
        function d(e) {
          return e = e.toLowerCase(), e = o[e] || e;
        }
        t.TB = function (e, t) {
          return s(e, {
            byKey: !0
          }, t);
        };
      },
      35583: (e, t, n) => {
        "use strict";

        function r(e) {
          return "[object Object]" === Object.prototype.toString.call(e);
        }
        function o(e) {
          var t, n;
          return !1 !== r(e) && (void 0 === (t = e.constructor) || !1 !== r(n = t.prototype) && !1 !== n.hasOwnProperty("isPrototypeOf"));
        }
        n.d(t, {
          P: () => o
        });
      },
      19575: function (e, t, n) {
        var r, o;
        o = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : this, e.exports = function (n) {
          "use strict";

          var o,
            i = (n = n || {}).Base64,
            a = "2.6.4",
            s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
            l = function (e) {
              for (var t = {}, n = 0, r = e.length; n < r; n++) t[e.charAt(n)] = n;
              return t;
            }(s),
            u = String.fromCharCode,
            c = function (e) {
              if (e.length < 2) return (t = e.charCodeAt(0)) < 128 ? e : t < 2048 ? u(192 | t >>> 6) + u(128 | 63 & t) : u(224 | t >>> 12 & 15) + u(128 | t >>> 6 & 63) + u(128 | 63 & t);
              var t = 65536 + 1024 * (e.charCodeAt(0) - 55296) + (e.charCodeAt(1) - 56320);
              return u(240 | t >>> 18 & 7) + u(128 | t >>> 12 & 63) + u(128 | t >>> 6 & 63) + u(128 | 63 & t);
            },
            d = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g,
            p = function (e) {
              return e.replace(d, c);
            },
            h = function (e) {
              var t = [0, 2, 1][e.length % 3],
                n = e.charCodeAt(0) << 16 | (e.length > 1 ? e.charCodeAt(1) : 0) << 8 | (e.length > 2 ? e.charCodeAt(2) : 0);
              return [s.charAt(n >>> 18), s.charAt(n >>> 12 & 63), t >= 2 ? "=" : s.charAt(n >>> 6 & 63), t >= 1 ? "=" : s.charAt(63 & n)].join("");
            },
            f = n.btoa && "function" == typeof n.btoa ? function (e) {
              return n.btoa(e);
            } : function (e) {
              if (e.match(/[^\x00-\xFF]/)) throw new RangeError("The string contains invalid characters.");
              return e.replace(/[\s\S]{1,3}/g, h);
            },
            m = function (e) {
              return f(p(String(e)));
            },
            g = function (e) {
              return e.replace(/[+\/]/g, function (e) {
                return "+" == e ? "-" : "_";
              }).replace(/=/g, "");
            },
            v = function (e, t) {
              return t ? g(m(e)) : m(e);
            },
            y = function (e) {
              return v(e, !0);
            };
          n.Uint8Array && (o = function (e, t) {
            for (var n = "", r = 0, o = e.length; r < o; r += 3) {
              var i = e[r],
                a = e[r + 1],
                l = e[r + 2],
                u = i << 16 | a << 8 | l;
              n += s.charAt(u >>> 18) + s.charAt(u >>> 12 & 63) + (void 0 !== a ? s.charAt(u >>> 6 & 63) : "=") + (void 0 !== l ? s.charAt(63 & u) : "=");
            }
            return t ? g(n) : n;
          });
          var b,
            w = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g,
            x = function (e) {
              switch (e.length) {
                case 4:
                  var t = ((7 & e.charCodeAt(0)) << 18 | (63 & e.charCodeAt(1)) << 12 | (63 & e.charCodeAt(2)) << 6 | 63 & e.charCodeAt(3)) - 65536;
                  return u(55296 + (t >>> 10)) + u(56320 + (1023 & t));
                case 3:
                  return u((15 & e.charCodeAt(0)) << 12 | (63 & e.charCodeAt(1)) << 6 | 63 & e.charCodeAt(2));
                default:
                  return u((31 & e.charCodeAt(0)) << 6 | 63 & e.charCodeAt(1));
              }
            },
            D = function (e) {
              return e.replace(w, x);
            },
            C = function (e) {
              var t = e.length,
                n = t % 4,
                r = (t > 0 ? l[e.charAt(0)] << 18 : 0) | (t > 1 ? l[e.charAt(1)] << 12 : 0) | (t > 2 ? l[e.charAt(2)] << 6 : 0) | (t > 3 ? l[e.charAt(3)] : 0),
                o = [u(r >>> 16), u(r >>> 8 & 255), u(255 & r)];
              return o.length -= [0, 0, 2, 1][n], o.join("");
            },
            S = n.atob && "function" == typeof n.atob ? function (e) {
              return n.atob(e);
            } : function (e) {
              return e.replace(/\S{1,4}/g, C);
            },
            E = function (e) {
              return S(String(e).replace(/[^A-Za-z0-9\+\/]/g, ""));
            },
            _ = function (e) {
              return D(S(e));
            },
            P = function (e) {
              return String(e).replace(/[-_]/g, function (e) {
                return "-" == e ? "+" : "/";
              }).replace(/[^A-Za-z0-9\+\/]/g, "");
            },
            k = function (e) {
              return _(P(e));
            };
          n.Uint8Array && (b = function (e) {
            return Uint8Array.from(E(P(e)), function (e) {
              return e.charCodeAt(0);
            });
          });
          var A = function () {
            var e = n.Base64;
            return n.Base64 = i, e;
          };
          if (n.Base64 = {
            VERSION: a,
            atob: E,
            btoa: f,
            fromBase64: k,
            toBase64: v,
            utob: p,
            encode: v,
            encodeURI: y,
            btou: D,
            decode: k,
            noConflict: A,
            fromUint8Array: o,
            toUint8Array: b
          }, "function" == typeof Object.defineProperty) {
            var z = function (e) {
              return {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              };
            };
            n.Base64.extendString = function () {
              Object.defineProperty(String.prototype, "fromBase64", z(function () {
                return k(this);
              })), Object.defineProperty(String.prototype, "toBase64", z(function (e) {
                return v(this, e);
              })), Object.defineProperty(String.prototype, "toBase64URI", z(function () {
                return v(this, !0);
              }));
            };
          }
          return n.Meteor && (Base64 = n.Base64), e.exports ? e.exports.Base64 = n.Base64 : void 0 === (r = function () {
            return n.Base64;
          }.apply(t, [])) || (e.exports = r), {
            Base64: n.Base64
          };
        }(o);
      },
      91296: (e, t, n) => {
        var r = /^\s+|\s+$/g,
          o = /^[-+]0x[0-9a-f]+$/i,
          i = /^0b[01]+$/i,
          a = /^0o[0-7]+$/i,
          s = parseInt,
          l = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
          u = "object" == typeof self && self && self.Object === Object && self,
          c = l || u || Function("return this")(),
          d = Object.prototype.toString,
          p = Math.max,
          h = Math.min,
          f = function () {
            return c.Date.now();
          };
        function m(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function g(e) {
          if ("number" == typeof e) return e;
          if (function (e) {
            return "symbol" == typeof e || function (e) {
              return !!e && "object" == typeof e;
            }(e) && "[object Symbol]" == d.call(e);
          }(e)) return NaN;
          if (m(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = m(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(r, "");
          var n = i.test(e);
          return n || a.test(e) ? s(e.slice(2), n ? 2 : 8) : o.test(e) ? NaN : +e;
        }
        e.exports = function (e, t, n) {
          var r,
            o,
            i,
            a,
            s,
            l,
            u = 0,
            c = !1,
            d = !1,
            v = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          function y(t) {
            var n = r,
              i = o;
            return r = o = void 0, u = t, a = e.apply(i, n);
          }
          function b(e) {
            return u = e, s = setTimeout(x, t), c ? y(e) : a;
          }
          function w(e) {
            var n = e - l;
            return void 0 === l || n >= t || n < 0 || d && e - u >= i;
          }
          function x() {
            var e = f();
            if (w(e)) return D(e);
            s = setTimeout(x, function (e) {
              var n = t - (e - l);
              return d ? h(n, i - (e - u)) : n;
            }(e));
          }
          function D(e) {
            return s = void 0, v && r ? y(e) : (r = o = void 0, a);
          }
          function C() {
            var e = f(),
              n = w(e);
            if (r = arguments, o = this, l = e, n) {
              if (void 0 === s) return b(l);
              if (d) return s = setTimeout(x, t), y(l);
            }
            return void 0 === s && (s = setTimeout(x, t)), a;
          }
          return t = g(t) || 0, m(n) && (c = !!n.leading, i = (d = "maxWait" in n) ? p(g(n.maxWait) || 0, t) : i, v = "trailing" in n ? !!n.trailing : v), C.cancel = function () {
            void 0 !== s && clearTimeout(s), u = 0, r = l = o = s = void 0;
          }, C.flush = function () {
            return void 0 === s ? a : D(f());
          }, C;
        };
      },
      18552: (e, t, n) => {
        var r = n(10852)(n(55639), "DataView");
        e.exports = r;
      },
      57071: (e, t, n) => {
        var r = n(10852)(n(55639), "Map");
        e.exports = r;
      },
      53818: (e, t, n) => {
        var r = n(10852)(n(55639), "Promise");
        e.exports = r;
      },
      58525: (e, t, n) => {
        var r = n(10852)(n(55639), "Set");
        e.exports = r;
      },
      62705: (e, t, n) => {
        var r = n(55639).Symbol;
        e.exports = r;
      },
      70577: (e, t, n) => {
        var r = n(10852)(n(55639), "WeakMap");
        e.exports = r;
      },
      44239: (e, t, n) => {
        var r = n(62705),
          o = n(89607),
          i = n(2333),
          a = r ? r.toStringTag : void 0;
        e.exports = function (e) {
          return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : a && a in Object(e) ? o(e) : i(e);
        };
      },
      9454: (e, t, n) => {
        var r = n(44239),
          o = n(37005);
        e.exports = function (e) {
          return o(e) && "[object Arguments]" == r(e);
        };
      },
      28458: (e, t, n) => {
        var r = n(23560),
          o = n(15346),
          i = n(13218),
          a = n(80346),
          s = /^\[object .+?Constructor\]$/,
          l = Function.prototype,
          u = Object.prototype,
          c = l.toString,
          d = u.hasOwnProperty,
          p = RegExp("^" + c.call(d).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        e.exports = function (e) {
          return !(!i(e) || o(e)) && (r(e) ? p : s).test(a(e));
        };
      },
      38749: (e, t, n) => {
        var r = n(44239),
          o = n(41780),
          i = n(37005),
          a = {};
        a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
          return i(e) && o(e.length) && !!a[r(e)];
        };
      },
      280: (e, t, n) => {
        var r = n(25726),
          o = n(86916),
          i = Object.prototype.hasOwnProperty;
        e.exports = function (e) {
          if (!r(e)) return o(e);
          var t = [];
          for (var n in Object(e)) i.call(e, n) && "constructor" != n && t.push(n);
          return t;
        };
      },
      27561: (e, t, n) => {
        var r = n(67990),
          o = /^\s+/;
        e.exports = function (e) {
          return e ? e.slice(0, r(e) + 1).replace(o, "") : e;
        };
      },
      7518: e => {
        e.exports = function (e) {
          return function (t) {
            return e(t);
          };
        };
      },
      14429: (e, t, n) => {
        var r = n(55639)["__core-js_shared__"];
        e.exports = r;
      },
      31957: (e, t, n) => {
        var r = "object" == typeof n.g && n.g && n.g.Object === Object && n.g;
        e.exports = r;
      },
      10852: (e, t, n) => {
        var r = n(28458),
          o = n(47801);
        e.exports = function (e, t) {
          var n = o(e, t);
          return r(n) ? n : void 0;
        };
      },
      89607: (e, t, n) => {
        var r = n(62705),
          o = Object.prototype,
          i = o.hasOwnProperty,
          a = o.toString,
          s = r ? r.toStringTag : void 0;
        e.exports = function (e) {
          var t = i.call(e, s),
            n = e[s];
          try {
            e[s] = void 0;
            var r = !0;
          } catch (e) {}
          var o = a.call(e);
          return r && (t ? e[s] = n : delete e[s]), o;
        };
      },
      64160: (e, t, n) => {
        var r = n(18552),
          o = n(57071),
          i = n(53818),
          a = n(58525),
          s = n(70577),
          l = n(44239),
          u = n(80346),
          c = "[object Map]",
          d = "[object Promise]",
          p = "[object Set]",
          h = "[object WeakMap]",
          f = "[object DataView]",
          m = u(r),
          g = u(o),
          v = u(i),
          y = u(a),
          b = u(s),
          w = l;
        (r && w(new r(new ArrayBuffer(1))) != f || o && w(new o()) != c || i && w(i.resolve()) != d || a && w(new a()) != p || s && w(new s()) != h) && (w = function (e) {
          var t = l(e),
            n = "[object Object]" == t ? e.constructor : void 0,
            r = n ? u(n) : "";
          if (r) switch (r) {
            case m:
              return f;
            case g:
              return c;
            case v:
              return d;
            case y:
              return p;
            case b:
              return h;
          }
          return t;
        }), e.exports = w;
      },
      47801: e => {
        e.exports = function (e, t) {
          return null == e ? void 0 : e[t];
        };
      },
      15346: (e, t, n) => {
        var r,
          o = n(14429),
          i = (r = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + r : "";
        e.exports = function (e) {
          return !!i && i in e;
        };
      },
      25726: e => {
        var t = Object.prototype;
        e.exports = function (e) {
          var n = e && e.constructor;
          return e === ("function" == typeof n && n.prototype || t);
        };
      },
      86916: (e, t, n) => {
        var r = n(5569)(Object.keys, Object);
        e.exports = r;
      },
      31167: (e, t, n) => {
        e = n.nmd(e);
        var r = n(31957),
          o = t && !t.nodeType && t,
          i = o && e && !e.nodeType && e,
          a = i && i.exports === o && r.process,
          s = function () {
            try {
              var e = i && i.require && i.require("util").types;
              return e || a && a.binding && a.binding("util");
            } catch (e) {}
          }();
        e.exports = s;
      },
      2333: e => {
        var t = Object.prototype.toString;
        e.exports = function (e) {
          return t.call(e);
        };
      },
      5569: e => {
        e.exports = function (e, t) {
          return function (n) {
            return e(t(n));
          };
        };
      },
      55639: (e, t, n) => {
        var r = n(31957),
          o = "object" == typeof self && self && self.Object === Object && self,
          i = r || o || Function("return this")();
        e.exports = i;
      },
      80346: e => {
        var t = Function.prototype.toString;
        e.exports = function (e) {
          if (null != e) {
            try {
              return t.call(e);
            } catch (e) {}
            try {
              return e + "";
            } catch (e) {}
          }
          return "";
        };
      },
      67990: e => {
        var t = /\s/;
        e.exports = function (e) {
          for (var n = e.length; n-- && t.test(e.charAt(n)););
          return n;
        };
      },
      23279: (e, t, n) => {
        var r = n(13218),
          o = n(7771),
          i = n(14841),
          a = Math.max,
          s = Math.min;
        e.exports = function (e, t, n) {
          var l,
            u,
            c,
            d,
            p,
            h,
            f = 0,
            m = !1,
            g = !1,
            v = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          function y(t) {
            var n = l,
              r = u;
            return l = u = void 0, f = t, d = e.apply(r, n);
          }
          function b(e) {
            return f = e, p = setTimeout(x, t), m ? y(e) : d;
          }
          function w(e) {
            var n = e - h;
            return void 0 === h || n >= t || n < 0 || g && e - f >= c;
          }
          function x() {
            var e = o();
            if (w(e)) return D(e);
            p = setTimeout(x, function (e) {
              var n = t - (e - h);
              return g ? s(n, c - (e - f)) : n;
            }(e));
          }
          function D(e) {
            return p = void 0, v && l ? y(e) : (l = u = void 0, d);
          }
          function C() {
            var e = o(),
              n = w(e);
            if (l = arguments, u = this, h = e, n) {
              if (void 0 === p) return b(h);
              if (g) return clearTimeout(p), p = setTimeout(x, t), y(h);
            }
            return void 0 === p && (p = setTimeout(x, t)), d;
          }
          return t = i(t) || 0, r(n) && (m = !!n.leading, c = (g = "maxWait" in n) ? a(i(n.maxWait) || 0, t) : c, v = "trailing" in n ? !!n.trailing : v), C.cancel = function () {
            void 0 !== p && clearTimeout(p), f = 0, l = h = u = p = void 0;
          }, C.flush = function () {
            return void 0 === p ? d : D(o());
          }, C;
        };
      },
      35694: (e, t, n) => {
        var r = n(9454),
          o = n(37005),
          i = Object.prototype,
          a = i.hasOwnProperty,
          s = i.propertyIsEnumerable,
          l = r(function () {
            return arguments;
          }()) ? r : function (e) {
            return o(e) && a.call(e, "callee") && !s.call(e, "callee");
          };
        e.exports = l;
      },
      1469: e => {
        var t = Array.isArray;
        e.exports = t;
      },
      98612: (e, t, n) => {
        var r = n(23560),
          o = n(41780);
        e.exports = function (e) {
          return null != e && o(e.length) && !r(e);
        };
      },
      44144: (e, t, n) => {
        e = n.nmd(e);
        var r = n(55639),
          o = n(95062),
          i = t && !t.nodeType && t,
          a = i && e && !e.nodeType && e,
          s = a && a.exports === i ? r.Buffer : void 0,
          l = (s ? s.isBuffer : void 0) || o;
        e.exports = l;
      },
      41609: (e, t, n) => {
        var r = n(280),
          o = n(64160),
          i = n(35694),
          a = n(1469),
          s = n(98612),
          l = n(44144),
          u = n(25726),
          c = n(36719),
          d = Object.prototype.hasOwnProperty;
        e.exports = function (e) {
          if (null == e) return !0;
          if (s(e) && (a(e) || "string" == typeof e || "function" == typeof e.splice || l(e) || c(e) || i(e))) return !e.length;
          var t = o(e);
          if ("[object Map]" == t || "[object Set]" == t) return !e.size;
          if (u(e)) return !r(e).length;
          for (var n in e) if (d.call(e, n)) return !1;
          return !0;
        };
      },
      23560: (e, t, n) => {
        var r = n(44239),
          o = n(13218);
        e.exports = function (e) {
          if (!o(e)) return !1;
          var t = r(e);
          return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
        };
      },
      41780: e => {
        e.exports = function (e) {
          return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
        };
      },
      13218: e => {
        e.exports = function (e) {
          var t = typeof e;
          return null != e && ("object" == t || "function" == t);
        };
      },
      37005: e => {
        e.exports = function (e) {
          return null != e && "object" == typeof e;
        };
      },
      33448: (e, t, n) => {
        var r = n(44239),
          o = n(37005);
        e.exports = function (e) {
          return "symbol" == typeof e || o(e) && "[object Symbol]" == r(e);
        };
      },
      36719: (e, t, n) => {
        var r = n(38749),
          o = n(7518),
          i = n(31167),
          a = i && i.isTypedArray,
          s = a ? o(a) : r;
        e.exports = s;
      },
      96486: function (e, t, n) {
        var r;
        e = n.nmd(e), function () {
          var o,
            i = "Expected a function",
            a = "__lodash_hash_undefined__",
            s = "__lodash_placeholder__",
            l = 16,
            u = 32,
            c = 64,
            d = 128,
            p = 256,
            h = 1 / 0,
            f = 9007199254740991,
            m = NaN,
            g = 4294967295,
            v = [["ary", d], ["bind", 1], ["bindKey", 2], ["curry", 8], ["curryRight", l], ["flip", 512], ["partial", u], ["partialRight", c], ["rearg", p]],
            y = "[object Arguments]",
            b = "[object Array]",
            w = "[object Boolean]",
            x = "[object Date]",
            D = "[object Error]",
            C = "[object Function]",
            S = "[object GeneratorFunction]",
            E = "[object Map]",
            _ = "[object Number]",
            P = "[object Object]",
            k = "[object Promise]",
            A = "[object RegExp]",
            z = "[object Set]",
            T = "[object String]",
            O = "[object Symbol]",
            I = "[object WeakMap]",
            F = "[object ArrayBuffer]",
            M = "[object DataView]",
            R = "[object Float32Array]",
            j = "[object Float64Array]",
            B = "[object Int8Array]",
            N = "[object Int16Array]",
            L = "[object Int32Array]",
            V = "[object Uint8Array]",
            K = "[object Uint8ClampedArray]",
            q = "[object Uint16Array]",
            H = "[object Uint32Array]",
            U = /\b__p \+= '';/g,
            Z = /\b(__p \+=) '' \+/g,
            $ = /(__e\(.*?\)|\b__t\)) \+\n'';/g,
            G = /&(?:amp|lt|gt|quot|#39);/g,
            W = /[&<>"']/g,
            Y = RegExp(G.source),
            X = RegExp(W.source),
            Q = /<%-([\s\S]+?)%>/g,
            J = /<%([\s\S]+?)%>/g,
            ee = /<%=([\s\S]+?)%>/g,
            te = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
            ne = /^\w*$/,
            re = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,
            oe = /[\\^$.*+?()[\]{}|]/g,
            ie = RegExp(oe.source),
            ae = /^\s+/,
            se = /\s/,
            le = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
            ue = /\{\n\/\* \[wrapped with (.+)\] \*/,
            ce = /,? & /,
            de = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g,
            pe = /[()=,{}\[\]\/\s]/,
            he = /\\(\\)?/g,
            fe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g,
            me = /\w*$/,
            ge = /^[-+]0x[0-9a-f]+$/i,
            ve = /^0b[01]+$/i,
            ye = /^\[object .+?Constructor\]$/,
            be = /^0o[0-7]+$/i,
            we = /^(?:0|[1-9]\d*)$/,
            xe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
            De = /($^)/,
            Ce = /['\n\r\u2028\u2029\\]/g,
            Se = "\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff",
            Ee = "\\u2700-\\u27bf",
            _e = "a-z\\xdf-\\xf6\\xf8-\\xff",
            Pe = "A-Z\\xc0-\\xd6\\xd8-\\xde",
            ke = "\\ufe0e\\ufe0f",
            Ae = "\\xac\\xb1\\xd7\\xf7\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf\\u2000-\\u206f \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
            ze = "['’]",
            Te = "[\\ud800-\\udfff]",
            Oe = "[" + Ae + "]",
            Ie = "[" + Se + "]",
            Fe = "\\d+",
            Me = "[\\u2700-\\u27bf]",
            Re = "[" + _e + "]",
            je = "[^\\ud800-\\udfff" + Ae + Fe + Ee + _e + Pe + "]",
            Be = "\\ud83c[\\udffb-\\udfff]",
            Ne = "[^\\ud800-\\udfff]",
            Le = "(?:\\ud83c[\\udde6-\\uddff]){2}",
            Ve = "[\\ud800-\\udbff][\\udc00-\\udfff]",
            Ke = "[" + Pe + "]",
            qe = "(?:" + Re + "|" + je + ")",
            He = "(?:" + Ke + "|" + je + ")",
            Ue = "(?:['’](?:d|ll|m|re|s|t|ve))?",
            Ze = "(?:['’](?:D|LL|M|RE|S|T|VE))?",
            $e = "(?:" + Ie + "|" + Be + ")" + "?",
            Ge = "[\\ufe0e\\ufe0f]?",
            We = Ge + $e + ("(?:\\u200d(?:" + [Ne, Le, Ve].join("|") + ")" + Ge + $e + ")*"),
            Ye = "(?:" + [Me, Le, Ve].join("|") + ")" + We,
            Xe = "(?:" + [Ne + Ie + "?", Ie, Le, Ve, Te].join("|") + ")",
            Qe = RegExp(ze, "g"),
            Je = RegExp(Ie, "g"),
            et = RegExp(Be + "(?=" + Be + ")|" + Xe + We, "g"),
            tt = RegExp([Ke + "?" + Re + "+" + Ue + "(?=" + [Oe, Ke, "$"].join("|") + ")", He + "+" + Ze + "(?=" + [Oe, Ke + qe, "$"].join("|") + ")", Ke + "?" + qe + "+" + Ue, Ke + "+" + Ze, "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Fe, Ye].join("|"), "g"),
            nt = RegExp("[\\u200d\\ud800-\\udfff" + Se + ke + "]"),
            rt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/,
            ot = ["Array", "Buffer", "DataView", "Date", "Error", "Float32Array", "Float64Array", "Function", "Int8Array", "Int16Array", "Int32Array", "Map", "Math", "Object", "Promise", "RegExp", "Set", "String", "Symbol", "TypeError", "Uint8Array", "Uint8ClampedArray", "Uint16Array", "Uint32Array", "WeakMap", "_", "clearTimeout", "isFinite", "parseInt", "setTimeout"],
            it = -1,
            at = {};
          at[R] = at[j] = at[B] = at[N] = at[L] = at[V] = at[K] = at[q] = at[H] = !0, at[y] = at[b] = at[F] = at[w] = at[M] = at[x] = at[D] = at[C] = at[E] = at[_] = at[P] = at[A] = at[z] = at[T] = at[I] = !1;
          var st = {};
          st[y] = st[b] = st[F] = st[M] = st[w] = st[x] = st[R] = st[j] = st[B] = st[N] = st[L] = st[E] = st[_] = st[P] = st[A] = st[z] = st[T] = st[O] = st[V] = st[K] = st[q] = st[H] = !0, st[D] = st[C] = st[I] = !1;
          var lt = {
              "\\": "\\",
              "'": "'",
              "\n": "n",
              "\r": "r",
              "\u2028": "u2028",
              "\u2029": "u2029"
            },
            ut = parseFloat,
            ct = parseInt,
            dt = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
            pt = "object" == typeof self && self && self.Object === Object && self,
            ht = dt || pt || Function("return this")(),
            ft = t && !t.nodeType && t,
            mt = ft && e && !e.nodeType && e,
            gt = mt && mt.exports === ft,
            vt = gt && dt.process,
            yt = function () {
              try {
                var e = mt && mt.require && mt.require("util").types;
                return e || vt && vt.binding && vt.binding("util");
              } catch (e) {}
            }(),
            bt = yt && yt.isArrayBuffer,
            wt = yt && yt.isDate,
            xt = yt && yt.isMap,
            Dt = yt && yt.isRegExp,
            Ct = yt && yt.isSet,
            St = yt && yt.isTypedArray;
          function Et(e, t, n) {
            switch (n.length) {
              case 0:
                return e.call(t);
              case 1:
                return e.call(t, n[0]);
              case 2:
                return e.call(t, n[0], n[1]);
              case 3:
                return e.call(t, n[0], n[1], n[2]);
            }
            return e.apply(t, n);
          }
          function _t(e, t, n, r) {
            for (var o = -1, i = null == e ? 0 : e.length; ++o < i;) {
              var a = e[o];
              t(r, a, n(a), e);
            }
            return r;
          }
          function Pt(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r && !1 !== t(e[n], n, e););
            return e;
          }
          function kt(e, t) {
            for (var n = null == e ? 0 : e.length; n-- && !1 !== t(e[n], n, e););
            return e;
          }
          function At(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (!t(e[n], n, e)) return !1;
            return !0;
          }
          function zt(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length, o = 0, i = []; ++n < r;) {
              var a = e[n];
              t(a, n, e) && (i[o++] = a);
            }
            return i;
          }
          function Tt(e, t) {
            return !!(null == e ? 0 : e.length) && Vt(e, t, 0) > -1;
          }
          function Ot(e, t, n) {
            for (var r = -1, o = null == e ? 0 : e.length; ++r < o;) if (n(t, e[r])) return !0;
            return !1;
          }
          function It(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length, o = Array(r); ++n < r;) o[n] = t(e[n], n, e);
            return o;
          }
          function Ft(e, t) {
            for (var n = -1, r = t.length, o = e.length; ++n < r;) e[o + n] = t[n];
            return e;
          }
          function Mt(e, t, n, r) {
            var o = -1,
              i = null == e ? 0 : e.length;
            for (r && i && (n = e[++o]); ++o < i;) n = t(n, e[o], o, e);
            return n;
          }
          function Rt(e, t, n, r) {
            var o = null == e ? 0 : e.length;
            for (r && o && (n = e[--o]); o--;) n = t(n, e[o], o, e);
            return n;
          }
          function jt(e, t) {
            for (var n = -1, r = null == e ? 0 : e.length; ++n < r;) if (t(e[n], n, e)) return !0;
            return !1;
          }
          var Bt = Ut("length");
          function Nt(e, t, n) {
            var r;
            return n(e, function (e, n, o) {
              if (t(e, n, o)) return r = n, !1;
            }), r;
          }
          function Lt(e, t, n, r) {
            for (var o = e.length, i = n + (r ? 1 : -1); r ? i-- : ++i < o;) if (t(e[i], i, e)) return i;
            return -1;
          }
          function Vt(e, t, n) {
            return t == t ? function (e, t, n) {
              var r = n - 1,
                o = e.length;
              for (; ++r < o;) if (e[r] === t) return r;
              return -1;
            }(e, t, n) : Lt(e, qt, n);
          }
          function Kt(e, t, n, r) {
            for (var o = n - 1, i = e.length; ++o < i;) if (r(e[o], t)) return o;
            return -1;
          }
          function qt(e) {
            return e != e;
          }
          function Ht(e, t) {
            var n = null == e ? 0 : e.length;
            return n ? Gt(e, t) / n : m;
          }
          function Ut(e) {
            return function (t) {
              return null == t ? o : t[e];
            };
          }
          function Zt(e) {
            return function (t) {
              return null == e ? o : e[t];
            };
          }
          function $t(e, t, n, r, o) {
            return o(e, function (e, o, i) {
              n = r ? (r = !1, e) : t(n, e, o, i);
            }), n;
          }
          function Gt(e, t) {
            for (var n, r = -1, i = e.length; ++r < i;) {
              var a = t(e[r]);
              a !== o && (n = n === o ? a : n + a);
            }
            return n;
          }
          function Wt(e, t) {
            for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
            return r;
          }
          function Yt(e) {
            return e ? e.slice(0, mn(e) + 1).replace(ae, "") : e;
          }
          function Xt(e) {
            return function (t) {
              return e(t);
            };
          }
          function Qt(e, t) {
            return It(t, function (t) {
              return e[t];
            });
          }
          function Jt(e, t) {
            return e.has(t);
          }
          function en(e, t) {
            for (var n = -1, r = e.length; ++n < r && Vt(t, e[n], 0) > -1;);
            return n;
          }
          function tn(e, t) {
            for (var n = e.length; n-- && Vt(t, e[n], 0) > -1;);
            return n;
          }
          function nn(e, t) {
            for (var n = e.length, r = 0; n--;) e[n] === t && ++r;
            return r;
          }
          var rn = Zt({
              À: "A",
              Á: "A",
              Â: "A",
              Ã: "A",
              Ä: "A",
              Å: "A",
              à: "a",
              á: "a",
              â: "a",
              ã: "a",
              ä: "a",
              å: "a",
              Ç: "C",
              ç: "c",
              Ð: "D",
              ð: "d",
              È: "E",
              É: "E",
              Ê: "E",
              Ë: "E",
              è: "e",
              é: "e",
              ê: "e",
              ë: "e",
              Ì: "I",
              Í: "I",
              Î: "I",
              Ï: "I",
              ì: "i",
              í: "i",
              î: "i",
              ï: "i",
              Ñ: "N",
              ñ: "n",
              Ò: "O",
              Ó: "O",
              Ô: "O",
              Õ: "O",
              Ö: "O",
              Ø: "O",
              ò: "o",
              ó: "o",
              ô: "o",
              õ: "o",
              ö: "o",
              ø: "o",
              Ù: "U",
              Ú: "U",
              Û: "U",
              Ü: "U",
              ù: "u",
              ú: "u",
              û: "u",
              ü: "u",
              Ý: "Y",
              ý: "y",
              ÿ: "y",
              Æ: "Ae",
              æ: "ae",
              Þ: "Th",
              þ: "th",
              ß: "ss",
              Ā: "A",
              Ă: "A",
              Ą: "A",
              ā: "a",
              ă: "a",
              ą: "a",
              Ć: "C",
              Ĉ: "C",
              Ċ: "C",
              Č: "C",
              ć: "c",
              ĉ: "c",
              ċ: "c",
              č: "c",
              Ď: "D",
              Đ: "D",
              ď: "d",
              đ: "d",
              Ē: "E",
              Ĕ: "E",
              Ė: "E",
              Ę: "E",
              Ě: "E",
              ē: "e",
              ĕ: "e",
              ė: "e",
              ę: "e",
              ě: "e",
              Ĝ: "G",
              Ğ: "G",
              Ġ: "G",
              Ģ: "G",
              ĝ: "g",
              ğ: "g",
              ġ: "g",
              ģ: "g",
              Ĥ: "H",
              Ħ: "H",
              ĥ: "h",
              ħ: "h",
              Ĩ: "I",
              Ī: "I",
              Ĭ: "I",
              Į: "I",
              İ: "I",
              ĩ: "i",
              ī: "i",
              ĭ: "i",
              į: "i",
              ı: "i",
              Ĵ: "J",
              ĵ: "j",
              Ķ: "K",
              ķ: "k",
              ĸ: "k",
              Ĺ: "L",
              Ļ: "L",
              Ľ: "L",
              Ŀ: "L",
              Ł: "L",
              ĺ: "l",
              ļ: "l",
              ľ: "l",
              ŀ: "l",
              ł: "l",
              Ń: "N",
              Ņ: "N",
              Ň: "N",
              Ŋ: "N",
              ń: "n",
              ņ: "n",
              ň: "n",
              ŋ: "n",
              Ō: "O",
              Ŏ: "O",
              Ő: "O",
              ō: "o",
              ŏ: "o",
              ő: "o",
              Ŕ: "R",
              Ŗ: "R",
              Ř: "R",
              ŕ: "r",
              ŗ: "r",
              ř: "r",
              Ś: "S",
              Ŝ: "S",
              Ş: "S",
              Š: "S",
              ś: "s",
              ŝ: "s",
              ş: "s",
              š: "s",
              Ţ: "T",
              Ť: "T",
              Ŧ: "T",
              ţ: "t",
              ť: "t",
              ŧ: "t",
              Ũ: "U",
              Ū: "U",
              Ŭ: "U",
              Ů: "U",
              Ű: "U",
              Ų: "U",
              ũ: "u",
              ū: "u",
              ŭ: "u",
              ů: "u",
              ű: "u",
              ų: "u",
              Ŵ: "W",
              ŵ: "w",
              Ŷ: "Y",
              ŷ: "y",
              Ÿ: "Y",
              Ź: "Z",
              Ż: "Z",
              Ž: "Z",
              ź: "z",
              ż: "z",
              ž: "z",
              Ĳ: "IJ",
              ĳ: "ij",
              Œ: "Oe",
              œ: "oe",
              ŉ: "'n",
              ſ: "s"
            }),
            on = Zt({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;"
            });
          function an(e) {
            return "\\" + lt[e];
          }
          function sn(e) {
            return nt.test(e);
          }
          function ln(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e, r) {
              n[++t] = [r, e];
            }), n;
          }
          function un(e, t) {
            return function (n) {
              return e(t(n));
            };
          }
          function cn(e, t) {
            for (var n = -1, r = e.length, o = 0, i = []; ++n < r;) {
              var a = e[n];
              a !== t && a !== s || (e[n] = s, i[o++] = n);
            }
            return i;
          }
          function dn(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e) {
              n[++t] = e;
            }), n;
          }
          function pn(e) {
            var t = -1,
              n = Array(e.size);
            return e.forEach(function (e) {
              n[++t] = [e, e];
            }), n;
          }
          function hn(e) {
            return sn(e) ? function (e) {
              var t = et.lastIndex = 0;
              for (; et.test(e);) ++t;
              return t;
            }(e) : Bt(e);
          }
          function fn(e) {
            return sn(e) ? function (e) {
              return e.match(et) || [];
            }(e) : function (e) {
              return e.split("");
            }(e);
          }
          function mn(e) {
            for (var t = e.length; t-- && se.test(e.charAt(t)););
            return t;
          }
          var gn = Zt({
            "&amp;": "&",
            "&lt;": "<",
            "&gt;": ">",
            "&quot;": '"',
            "&#39;": "'"
          });
          var vn = function e(t) {
            var n,
              r = (t = null == t ? ht : vn.defaults(ht.Object(), t, vn.pick(ht, ot))).Array,
              se = t.Date,
              Se = t.Error,
              Ee = t.Function,
              _e = t.Math,
              Pe = t.Object,
              ke = t.RegExp,
              Ae = t.String,
              ze = t.TypeError,
              Te = r.prototype,
              Oe = Ee.prototype,
              Ie = Pe.prototype,
              Fe = t["__core-js_shared__"],
              Me = Oe.toString,
              Re = Ie.hasOwnProperty,
              je = 0,
              Be = (n = /[^.]+$/.exec(Fe && Fe.keys && Fe.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "",
              Ne = Ie.toString,
              Le = Me.call(Pe),
              Ve = ht._,
              Ke = ke("^" + Me.call(Re).replace(oe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"),
              qe = gt ? t.Buffer : o,
              He = t.Symbol,
              Ue = t.Uint8Array,
              Ze = qe ? qe.allocUnsafe : o,
              $e = un(Pe.getPrototypeOf, Pe),
              Ge = Pe.create,
              We = Ie.propertyIsEnumerable,
              Ye = Te.splice,
              Xe = He ? He.isConcatSpreadable : o,
              et = He ? He.iterator : o,
              nt = He ? He.toStringTag : o,
              lt = function () {
                try {
                  var e = fi(Pe, "defineProperty");
                  return e({}, "", {}), e;
                } catch (e) {}
              }(),
              dt = t.clearTimeout !== ht.clearTimeout && t.clearTimeout,
              pt = se && se.now !== ht.Date.now && se.now,
              ft = t.setTimeout !== ht.setTimeout && t.setTimeout,
              mt = _e.ceil,
              vt = _e.floor,
              yt = Pe.getOwnPropertySymbols,
              Bt = qe ? qe.isBuffer : o,
              Zt = t.isFinite,
              yn = Te.join,
              bn = un(Pe.keys, Pe),
              wn = _e.max,
              xn = _e.min,
              Dn = se.now,
              Cn = t.parseInt,
              Sn = _e.random,
              En = Te.reverse,
              _n = fi(t, "DataView"),
              Pn = fi(t, "Map"),
              kn = fi(t, "Promise"),
              An = fi(t, "Set"),
              zn = fi(t, "WeakMap"),
              Tn = fi(Pe, "create"),
              On = zn && new zn(),
              In = {},
              Fn = Vi(_n),
              Mn = Vi(Pn),
              Rn = Vi(kn),
              jn = Vi(An),
              Bn = Vi(zn),
              Nn = He ? He.prototype : o,
              Ln = Nn ? Nn.valueOf : o,
              Vn = Nn ? Nn.toString : o;
            function Kn(e) {
              if (os(e) && !$a(e) && !(e instanceof Zn)) {
                if (e instanceof Un) return e;
                if (Re.call(e, "__wrapped__")) return Ki(e);
              }
              return new Un(e);
            }
            var qn = function () {
              function e() {}
              return function (t) {
                if (!rs(t)) return {};
                if (Ge) return Ge(t);
                e.prototype = t;
                var n = new e();
                return e.prototype = o, n;
              };
            }();
            function Hn() {}
            function Un(e, t) {
              this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = o;
            }
            function Zn(e) {
              this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = g, this.__views__ = [];
            }
            function $n(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function Gn(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function Wn(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.clear(); ++t < n;) {
                var r = e[t];
                this.set(r[0], r[1]);
              }
            }
            function Yn(e) {
              var t = -1,
                n = null == e ? 0 : e.length;
              for (this.__data__ = new Wn(); ++t < n;) this.add(e[t]);
            }
            function Xn(e) {
              var t = this.__data__ = new Gn(e);
              this.size = t.size;
            }
            function Qn(e, t) {
              var n = $a(e),
                r = !n && Za(e),
                o = !n && !r && Xa(e),
                i = !n && !r && !o && ps(e),
                a = n || r || o || i,
                s = a ? Wt(e.length, Ae) : [],
                l = s.length;
              for (var u in e) !t && !Re.call(e, u) || a && ("length" == u || o && ("offset" == u || "parent" == u) || i && ("buffer" == u || "byteLength" == u || "byteOffset" == u) || xi(u, l)) || s.push(u);
              return s;
            }
            function Jn(e) {
              var t = e.length;
              return t ? e[Yr(0, t - 1)] : o;
            }
            function er(e, t) {
              return Bi(Oo(e), ur(t, 0, e.length));
            }
            function tr(e) {
              return Bi(Oo(e));
            }
            function nr(e, t, n) {
              (n !== o && !qa(e[t], n) || n === o && !(t in e)) && sr(e, t, n);
            }
            function rr(e, t, n) {
              var r = e[t];
              Re.call(e, t) && qa(r, n) && (n !== o || t in e) || sr(e, t, n);
            }
            function or(e, t) {
              for (var n = e.length; n--;) if (qa(e[n][0], t)) return n;
              return -1;
            }
            function ir(e, t, n, r) {
              return fr(e, function (e, o, i) {
                t(r, e, n(e), i);
              }), r;
            }
            function ar(e, t) {
              return e && Io(t, Fs(t), e);
            }
            function sr(e, t, n) {
              "__proto__" == t && lt ? lt(e, t, {
                configurable: !0,
                enumerable: !0,
                value: n,
                writable: !0
              }) : e[t] = n;
            }
            function lr(e, t) {
              for (var n = -1, i = t.length, a = r(i), s = null == e; ++n < i;) a[n] = s ? o : As(e, t[n]);
              return a;
            }
            function ur(e, t, n) {
              return e == e && (n !== o && (e = e <= n ? e : n), t !== o && (e = e >= t ? e : t)), e;
            }
            function cr(e, t, n, r, i, a) {
              var s,
                l = 1 & t,
                u = 2 & t,
                c = 4 & t;
              if (n && (s = i ? n(e, r, i, a) : n(e)), s !== o) return s;
              if (!rs(e)) return e;
              var d = $a(e);
              if (d) {
                if (s = function (e) {
                  var t = e.length,
                    n = new e.constructor(t);
                  t && "string" == typeof e[0] && Re.call(e, "index") && (n.index = e.index, n.input = e.input);
                  return n;
                }(e), !l) return Oo(e, s);
              } else {
                var p = vi(e),
                  h = p == C || p == S;
                if (Xa(e)) return _o(e, l);
                if (p == P || p == y || h && !i) {
                  if (s = u || h ? {} : bi(e), !l) return u ? function (e, t) {
                    return Io(e, gi(e), t);
                  }(e, function (e, t) {
                    return e && Io(t, Ms(t), e);
                  }(s, e)) : function (e, t) {
                    return Io(e, mi(e), t);
                  }(e, ar(s, e));
                } else {
                  if (!st[p]) return i ? e : {};
                  s = function (e, t, n) {
                    var r = e.constructor;
                    switch (t) {
                      case F:
                        return Po(e);
                      case w:
                      case x:
                        return new r(+e);
                      case M:
                        return function (e, t) {
                          var n = t ? Po(e.buffer) : e.buffer;
                          return new e.constructor(n, e.byteOffset, e.byteLength);
                        }(e, n);
                      case R:
                      case j:
                      case B:
                      case N:
                      case L:
                      case V:
                      case K:
                      case q:
                      case H:
                        return ko(e, n);
                      case E:
                        return new r();
                      case _:
                      case T:
                        return new r(e);
                      case A:
                        return function (e) {
                          var t = new e.constructor(e.source, me.exec(e));
                          return t.lastIndex = e.lastIndex, t;
                        }(e);
                      case z:
                        return new r();
                      case O:
                        return o = e, Ln ? Pe(Ln.call(o)) : {};
                    }
                    var o;
                  }(e, p, l);
                }
              }
              a || (a = new Xn());
              var f = a.get(e);
              if (f) return f;
              a.set(e, s), us(e) ? e.forEach(function (r) {
                s.add(cr(r, t, n, r, e, a));
              }) : is(e) && e.forEach(function (r, o) {
                s.set(o, cr(r, t, n, o, e, a));
              });
              var m = d ? o : (c ? u ? si : ai : u ? Ms : Fs)(e);
              return Pt(m || e, function (r, o) {
                m && (r = e[o = r]), rr(s, o, cr(r, t, n, o, e, a));
              }), s;
            }
            function dr(e, t, n) {
              var r = n.length;
              if (null == e) return !r;
              for (e = Pe(e); r--;) {
                var i = n[r],
                  a = t[i],
                  s = e[i];
                if (s === o && !(i in e) || !a(s)) return !1;
              }
              return !0;
            }
            function pr(e, t, n) {
              if ("function" != typeof e) throw new ze(i);
              return Fi(function () {
                e.apply(o, n);
              }, t);
            }
            function hr(e, t, n, r) {
              var o = -1,
                i = Tt,
                a = !0,
                s = e.length,
                l = [],
                u = t.length;
              if (!s) return l;
              n && (t = It(t, Xt(n))), r ? (i = Ot, a = !1) : t.length >= 200 && (i = Jt, a = !1, t = new Yn(t));
              e: for (; ++o < s;) {
                var c = e[o],
                  d = null == n ? c : n(c);
                if (c = r || 0 !== c ? c : 0, a && d == d) {
                  for (var p = u; p--;) if (t[p] === d) continue e;
                  l.push(c);
                } else i(t, d, r) || l.push(c);
              }
              return l;
            }
            Kn.templateSettings = {
              escape: Q,
              evaluate: J,
              interpolate: ee,
              variable: "",
              imports: {
                _: Kn
              }
            }, Kn.prototype = Hn.prototype, Kn.prototype.constructor = Kn, Un.prototype = qn(Hn.prototype), Un.prototype.constructor = Un, Zn.prototype = qn(Hn.prototype), Zn.prototype.constructor = Zn, $n.prototype.clear = function () {
              this.__data__ = Tn ? Tn(null) : {}, this.size = 0;
            }, $n.prototype.delete = function (e) {
              var t = this.has(e) && delete this.__data__[e];
              return this.size -= t ? 1 : 0, t;
            }, $n.prototype.get = function (e) {
              var t = this.__data__;
              if (Tn) {
                var n = t[e];
                return n === a ? o : n;
              }
              return Re.call(t, e) ? t[e] : o;
            }, $n.prototype.has = function (e) {
              var t = this.__data__;
              return Tn ? t[e] !== o : Re.call(t, e);
            }, $n.prototype.set = function (e, t) {
              var n = this.__data__;
              return this.size += this.has(e) ? 0 : 1, n[e] = Tn && t === o ? a : t, this;
            }, Gn.prototype.clear = function () {
              this.__data__ = [], this.size = 0;
            }, Gn.prototype.delete = function (e) {
              var t = this.__data__,
                n = or(t, e);
              return !(n < 0) && (n == t.length - 1 ? t.pop() : Ye.call(t, n, 1), --this.size, !0);
            }, Gn.prototype.get = function (e) {
              var t = this.__data__,
                n = or(t, e);
              return n < 0 ? o : t[n][1];
            }, Gn.prototype.has = function (e) {
              return or(this.__data__, e) > -1;
            }, Gn.prototype.set = function (e, t) {
              var n = this.__data__,
                r = or(n, e);
              return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
            }, Wn.prototype.clear = function () {
              this.size = 0, this.__data__ = {
                hash: new $n(),
                map: new (Pn || Gn)(),
                string: new $n()
              };
            }, Wn.prototype.delete = function (e) {
              var t = pi(this, e).delete(e);
              return this.size -= t ? 1 : 0, t;
            }, Wn.prototype.get = function (e) {
              return pi(this, e).get(e);
            }, Wn.prototype.has = function (e) {
              return pi(this, e).has(e);
            }, Wn.prototype.set = function (e, t) {
              var n = pi(this, e),
                r = n.size;
              return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
            }, Yn.prototype.add = Yn.prototype.push = function (e) {
              return this.__data__.set(e, a), this;
            }, Yn.prototype.has = function (e) {
              return this.__data__.has(e);
            }, Xn.prototype.clear = function () {
              this.__data__ = new Gn(), this.size = 0;
            }, Xn.prototype.delete = function (e) {
              var t = this.__data__,
                n = t.delete(e);
              return this.size = t.size, n;
            }, Xn.prototype.get = function (e) {
              return this.__data__.get(e);
            }, Xn.prototype.has = function (e) {
              return this.__data__.has(e);
            }, Xn.prototype.set = function (e, t) {
              var n = this.__data__;
              if (n instanceof Gn) {
                var r = n.__data__;
                if (!Pn || r.length < 199) return r.push([e, t]), this.size = ++n.size, this;
                n = this.__data__ = new Wn(r);
              }
              return n.set(e, t), this.size = n.size, this;
            };
            var fr = Ro(Dr),
              mr = Ro(Cr, !0);
            function gr(e, t) {
              var n = !0;
              return fr(e, function (e, r, o) {
                return n = !!t(e, r, o);
              }), n;
            }
            function vr(e, t, n) {
              for (var r = -1, i = e.length; ++r < i;) {
                var a = e[r],
                  s = t(a);
                if (null != s && (l === o ? s == s && !ds(s) : n(s, l))) var l = s,
                  u = a;
              }
              return u;
            }
            function yr(e, t) {
              var n = [];
              return fr(e, function (e, r, o) {
                t(e, r, o) && n.push(e);
              }), n;
            }
            function br(e, t, n, r, o) {
              var i = -1,
                a = e.length;
              for (n || (n = wi), o || (o = []); ++i < a;) {
                var s = e[i];
                t > 0 && n(s) ? t > 1 ? br(s, t - 1, n, r, o) : Ft(o, s) : r || (o[o.length] = s);
              }
              return o;
            }
            var wr = jo(),
              xr = jo(!0);
            function Dr(e, t) {
              return e && wr(e, t, Fs);
            }
            function Cr(e, t) {
              return e && xr(e, t, Fs);
            }
            function Sr(e, t) {
              return zt(t, function (t) {
                return es(e[t]);
              });
            }
            function Er(e, t) {
              for (var n = 0, r = (t = Do(t, e)).length; null != e && n < r;) e = e[Li(t[n++])];
              return n && n == r ? e : o;
            }
            function _r(e, t, n) {
              var r = t(e);
              return $a(e) ? r : Ft(r, n(e));
            }
            function Pr(e) {
              return null == e ? e === o ? "[object Undefined]" : "[object Null]" : nt && nt in Pe(e) ? function (e) {
                var t = Re.call(e, nt),
                  n = e[nt];
                try {
                  e[nt] = o;
                  var r = !0;
                } catch (e) {}
                var i = Ne.call(e);
                r && (t ? e[nt] = n : delete e[nt]);
                return i;
              }(e) : function (e) {
                return Ne.call(e);
              }(e);
            }
            function kr(e, t) {
              return e > t;
            }
            function Ar(e, t) {
              return null != e && Re.call(e, t);
            }
            function zr(e, t) {
              return null != e && t in Pe(e);
            }
            function Tr(e, t, n) {
              for (var i = n ? Ot : Tt, a = e[0].length, s = e.length, l = s, u = r(s), c = 1 / 0, d = []; l--;) {
                var p = e[l];
                l && t && (p = It(p, Xt(t))), c = xn(p.length, c), u[l] = !n && (t || a >= 120 && p.length >= 120) ? new Yn(l && p) : o;
              }
              p = e[0];
              var h = -1,
                f = u[0];
              e: for (; ++h < a && d.length < c;) {
                var m = p[h],
                  g = t ? t(m) : m;
                if (m = n || 0 !== m ? m : 0, !(f ? Jt(f, g) : i(d, g, n))) {
                  for (l = s; --l;) {
                    var v = u[l];
                    if (!(v ? Jt(v, g) : i(e[l], g, n))) continue e;
                  }
                  f && f.push(g), d.push(m);
                }
              }
              return d;
            }
            function Or(e, t, n) {
              var r = null == (e = zi(e, t = Do(t, e))) ? e : e[Li(Ji(t))];
              return null == r ? o : Et(r, e, n);
            }
            function Ir(e) {
              return os(e) && Pr(e) == y;
            }
            function Fr(e, t, n, r, i) {
              return e === t || (null == e || null == t || !os(e) && !os(t) ? e != e && t != t : function (e, t, n, r, i, a) {
                var s = $a(e),
                  l = $a(t),
                  u = s ? b : vi(e),
                  c = l ? b : vi(t),
                  d = (u = u == y ? P : u) == P,
                  p = (c = c == y ? P : c) == P,
                  h = u == c;
                if (h && Xa(e)) {
                  if (!Xa(t)) return !1;
                  s = !0, d = !1;
                }
                if (h && !d) return a || (a = new Xn()), s || ps(e) ? oi(e, t, n, r, i, a) : function (e, t, n, r, o, i, a) {
                  switch (n) {
                    case M:
                      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                      e = e.buffer, t = t.buffer;
                    case F:
                      return !(e.byteLength != t.byteLength || !i(new Ue(e), new Ue(t)));
                    case w:
                    case x:
                    case _:
                      return qa(+e, +t);
                    case D:
                      return e.name == t.name && e.message == t.message;
                    case A:
                    case T:
                      return e == t + "";
                    case E:
                      var s = ln;
                    case z:
                      var l = 1 & r;
                      if (s || (s = dn), e.size != t.size && !l) return !1;
                      var u = a.get(e);
                      if (u) return u == t;
                      r |= 2, a.set(e, t);
                      var c = oi(s(e), s(t), r, o, i, a);
                      return a.delete(e), c;
                    case O:
                      if (Ln) return Ln.call(e) == Ln.call(t);
                  }
                  return !1;
                }(e, t, u, n, r, i, a);
                if (!(1 & n)) {
                  var f = d && Re.call(e, "__wrapped__"),
                    m = p && Re.call(t, "__wrapped__");
                  if (f || m) {
                    var g = f ? e.value() : e,
                      v = m ? t.value() : t;
                    return a || (a = new Xn()), i(g, v, n, r, a);
                  }
                }
                if (!h) return !1;
                return a || (a = new Xn()), function (e, t, n, r, i, a) {
                  var s = 1 & n,
                    l = ai(e),
                    u = l.length,
                    c = ai(t).length;
                  if (u != c && !s) return !1;
                  var d = u;
                  for (; d--;) {
                    var p = l[d];
                    if (!(s ? p in t : Re.call(t, p))) return !1;
                  }
                  var h = a.get(e),
                    f = a.get(t);
                  if (h && f) return h == t && f == e;
                  var m = !0;
                  a.set(e, t), a.set(t, e);
                  var g = s;
                  for (; ++d < u;) {
                    var v = e[p = l[d]],
                      y = t[p];
                    if (r) var b = s ? r(y, v, p, t, e, a) : r(v, y, p, e, t, a);
                    if (!(b === o ? v === y || i(v, y, n, r, a) : b)) {
                      m = !1;
                      break;
                    }
                    g || (g = "constructor" == p);
                  }
                  if (m && !g) {
                    var w = e.constructor,
                      x = t.constructor;
                    w == x || !("constructor" in e) || !("constructor" in t) || "function" == typeof w && w instanceof w && "function" == typeof x && x instanceof x || (m = !1);
                  }
                  return a.delete(e), a.delete(t), m;
                }(e, t, n, r, i, a);
              }(e, t, n, r, Fr, i));
            }
            function Mr(e, t, n, r) {
              var i = n.length,
                a = i,
                s = !r;
              if (null == e) return !a;
              for (e = Pe(e); i--;) {
                var l = n[i];
                if (s && l[2] ? l[1] !== e[l[0]] : !(l[0] in e)) return !1;
              }
              for (; ++i < a;) {
                var u = (l = n[i])[0],
                  c = e[u],
                  d = l[1];
                if (s && l[2]) {
                  if (c === o && !(u in e)) return !1;
                } else {
                  var p = new Xn();
                  if (r) var h = r(c, d, u, e, t, p);
                  if (!(h === o ? Fr(d, c, 3, r, p) : h)) return !1;
                }
              }
              return !0;
            }
            function Rr(e) {
              return !(!rs(e) || (t = e, Be && Be in t)) && (es(e) ? Ke : ye).test(Vi(e));
              var t;
            }
            function jr(e) {
              return "function" == typeof e ? e : null == e ? al : "object" == typeof e ? $a(e) ? qr(e[0], e[1]) : Kr(e) : ml(e);
            }
            function Br(e) {
              if (!_i(e)) return bn(e);
              var t = [];
              for (var n in Pe(e)) Re.call(e, n) && "constructor" != n && t.push(n);
              return t;
            }
            function Nr(e) {
              if (!rs(e)) return function (e) {
                var t = [];
                if (null != e) for (var n in Pe(e)) t.push(n);
                return t;
              }(e);
              var t = _i(e),
                n = [];
              for (var r in e) ("constructor" != r || !t && Re.call(e, r)) && n.push(r);
              return n;
            }
            function Lr(e, t) {
              return e < t;
            }
            function Vr(e, t) {
              var n = -1,
                o = Wa(e) ? r(e.length) : [];
              return fr(e, function (e, r, i) {
                o[++n] = t(e, r, i);
              }), o;
            }
            function Kr(e) {
              var t = hi(e);
              return 1 == t.length && t[0][2] ? ki(t[0][0], t[0][1]) : function (n) {
                return n === e || Mr(n, e, t);
              };
            }
            function qr(e, t) {
              return Ci(e) && Pi(t) ? ki(Li(e), t) : function (n) {
                var r = As(n, e);
                return r === o && r === t ? zs(n, e) : Fr(t, r, 3);
              };
            }
            function Hr(e, t, n, r, i) {
              e !== t && wr(t, function (a, s) {
                if (i || (i = new Xn()), rs(a)) !function (e, t, n, r, i, a, s) {
                  var l = Oi(e, n),
                    u = Oi(t, n),
                    c = s.get(u);
                  if (c) return void nr(e, n, c);
                  var d = a ? a(l, u, n + "", e, t, s) : o,
                    p = d === o;
                  if (p) {
                    var h = $a(u),
                      f = !h && Xa(u),
                      m = !h && !f && ps(u);
                    d = u, h || f || m ? $a(l) ? d = l : Ya(l) ? d = Oo(l) : f ? (p = !1, d = _o(u, !0)) : m ? (p = !1, d = ko(u, !0)) : d = [] : ss(u) || Za(u) ? (d = l, Za(l) ? d = ws(l) : rs(l) && !es(l) || (d = bi(u))) : p = !1;
                  }
                  p && (s.set(u, d), i(d, u, r, a, s), s.delete(u));
                  nr(e, n, d);
                }(e, t, s, n, Hr, r, i);else {
                  var l = r ? r(Oi(e, s), a, s + "", e, t, i) : o;
                  l === o && (l = a), nr(e, s, l);
                }
              }, Ms);
            }
            function Ur(e, t) {
              var n = e.length;
              if (n) return xi(t += t < 0 ? n : 0, n) ? e[t] : o;
            }
            function Zr(e, t, n) {
              t = t.length ? It(t, function (e) {
                return $a(e) ? function (t) {
                  return Er(t, 1 === e.length ? e[0] : e);
                } : e;
              }) : [al];
              var r = -1;
              t = It(t, Xt(di()));
              var o = Vr(e, function (e, n, o) {
                var i = It(t, function (t) {
                  return t(e);
                });
                return {
                  criteria: i,
                  index: ++r,
                  value: e
                };
              });
              return function (e, t) {
                var n = e.length;
                for (e.sort(t); n--;) e[n] = e[n].value;
                return e;
              }(o, function (e, t) {
                return function (e, t, n) {
                  var r = -1,
                    o = e.criteria,
                    i = t.criteria,
                    a = o.length,
                    s = n.length;
                  for (; ++r < a;) {
                    var l = Ao(o[r], i[r]);
                    if (l) return r >= s ? l : l * ("desc" == n[r] ? -1 : 1);
                  }
                  return e.index - t.index;
                }(e, t, n);
              });
            }
            function $r(e, t, n) {
              for (var r = -1, o = t.length, i = {}; ++r < o;) {
                var a = t[r],
                  s = Er(e, a);
                n(s, a) && to(i, Do(a, e), s);
              }
              return i;
            }
            function Gr(e, t, n, r) {
              var o = r ? Kt : Vt,
                i = -1,
                a = t.length,
                s = e;
              for (e === t && (t = Oo(t)), n && (s = It(e, Xt(n))); ++i < a;) for (var l = 0, u = t[i], c = n ? n(u) : u; (l = o(s, c, l, r)) > -1;) s !== e && Ye.call(s, l, 1), Ye.call(e, l, 1);
              return e;
            }
            function Wr(e, t) {
              for (var n = e ? t.length : 0, r = n - 1; n--;) {
                var o = t[n];
                if (n == r || o !== i) {
                  var i = o;
                  xi(o) ? Ye.call(e, o, 1) : fo(e, o);
                }
              }
              return e;
            }
            function Yr(e, t) {
              return e + vt(Sn() * (t - e + 1));
            }
            function Xr(e, t) {
              var n = "";
              if (!e || t < 1 || t > f) return n;
              do {
                t % 2 && (n += e), (t = vt(t / 2)) && (e += e);
              } while (t);
              return n;
            }
            function Qr(e, t) {
              return Mi(Ai(e, t, al), e + "");
            }
            function Jr(e) {
              return Jn(qs(e));
            }
            function eo(e, t) {
              var n = qs(e);
              return Bi(n, ur(t, 0, n.length));
            }
            function to(e, t, n, r) {
              if (!rs(e)) return e;
              for (var i = -1, a = (t = Do(t, e)).length, s = a - 1, l = e; null != l && ++i < a;) {
                var u = Li(t[i]),
                  c = n;
                if ("__proto__" === u || "constructor" === u || "prototype" === u) return e;
                if (i != s) {
                  var d = l[u];
                  (c = r ? r(d, u, l) : o) === o && (c = rs(d) ? d : xi(t[i + 1]) ? [] : {});
                }
                rr(l, u, c), l = l[u];
              }
              return e;
            }
            var no = On ? function (e, t) {
                return On.set(e, t), e;
              } : al,
              ro = lt ? function (e, t) {
                return lt(e, "toString", {
                  configurable: !0,
                  enumerable: !1,
                  value: rl(t),
                  writable: !0
                });
              } : al;
            function oo(e) {
              return Bi(qs(e));
            }
            function io(e, t, n) {
              var o = -1,
                i = e.length;
              t < 0 && (t = -t > i ? 0 : i + t), (n = n > i ? i : n) < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
              for (var a = r(i); ++o < i;) a[o] = e[o + t];
              return a;
            }
            function ao(e, t) {
              var n;
              return fr(e, function (e, r, o) {
                return !(n = t(e, r, o));
              }), !!n;
            }
            function so(e, t, n) {
              var r = 0,
                o = null == e ? r : e.length;
              if ("number" == typeof t && t == t && o <= 2147483647) {
                for (; r < o;) {
                  var i = r + o >>> 1,
                    a = e[i];
                  null !== a && !ds(a) && (n ? a <= t : a < t) ? r = i + 1 : o = i;
                }
                return o;
              }
              return lo(e, t, al, n);
            }
            function lo(e, t, n, r) {
              var i = 0,
                a = null == e ? 0 : e.length;
              if (0 === a) return 0;
              for (var s = (t = n(t)) != t, l = null === t, u = ds(t), c = t === o; i < a;) {
                var d = vt((i + a) / 2),
                  p = n(e[d]),
                  h = p !== o,
                  f = null === p,
                  m = p == p,
                  g = ds(p);
                if (s) var v = r || m;else v = c ? m && (r || h) : l ? m && h && (r || !f) : u ? m && h && !f && (r || !g) : !f && !g && (r ? p <= t : p < t);
                v ? i = d + 1 : a = d;
              }
              return xn(a, 4294967294);
            }
            function uo(e, t) {
              for (var n = -1, r = e.length, o = 0, i = []; ++n < r;) {
                var a = e[n],
                  s = t ? t(a) : a;
                if (!n || !qa(s, l)) {
                  var l = s;
                  i[o++] = 0 === a ? 0 : a;
                }
              }
              return i;
            }
            function co(e) {
              return "number" == typeof e ? e : ds(e) ? m : +e;
            }
            function po(e) {
              if ("string" == typeof e) return e;
              if ($a(e)) return It(e, po) + "";
              if (ds(e)) return Vn ? Vn.call(e) : "";
              var t = e + "";
              return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function ho(e, t, n) {
              var r = -1,
                o = Tt,
                i = e.length,
                a = !0,
                s = [],
                l = s;
              if (n) a = !1, o = Ot;else if (i >= 200) {
                var u = t ? null : Qo(e);
                if (u) return dn(u);
                a = !1, o = Jt, l = new Yn();
              } else l = t ? [] : s;
              e: for (; ++r < i;) {
                var c = e[r],
                  d = t ? t(c) : c;
                if (c = n || 0 !== c ? c : 0, a && d == d) {
                  for (var p = l.length; p--;) if (l[p] === d) continue e;
                  t && l.push(d), s.push(c);
                } else o(l, d, n) || (l !== s && l.push(d), s.push(c));
              }
              return s;
            }
            function fo(e, t) {
              return null == (e = zi(e, t = Do(t, e))) || delete e[Li(Ji(t))];
            }
            function mo(e, t, n, r) {
              return to(e, t, n(Er(e, t)), r);
            }
            function go(e, t, n, r) {
              for (var o = e.length, i = r ? o : -1; (r ? i-- : ++i < o) && t(e[i], i, e););
              return n ? io(e, r ? 0 : i, r ? i + 1 : o) : io(e, r ? i + 1 : 0, r ? o : i);
            }
            function vo(e, t) {
              var n = e;
              return n instanceof Zn && (n = n.value()), Mt(t, function (e, t) {
                return t.func.apply(t.thisArg, Ft([e], t.args));
              }, n);
            }
            function yo(e, t, n) {
              var o = e.length;
              if (o < 2) return o ? ho(e[0]) : [];
              for (var i = -1, a = r(o); ++i < o;) for (var s = e[i], l = -1; ++l < o;) l != i && (a[i] = hr(a[i] || s, e[l], t, n));
              return ho(br(a, 1), t, n);
            }
            function bo(e, t, n) {
              for (var r = -1, i = e.length, a = t.length, s = {}; ++r < i;) {
                var l = r < a ? t[r] : o;
                n(s, e[r], l);
              }
              return s;
            }
            function wo(e) {
              return Ya(e) ? e : [];
            }
            function xo(e) {
              return "function" == typeof e ? e : al;
            }
            function Do(e, t) {
              return $a(e) ? e : Ci(e, t) ? [e] : Ni(xs(e));
            }
            var Co = Qr;
            function So(e, t, n) {
              var r = e.length;
              return n = n === o ? r : n, !t && n >= r ? e : io(e, t, n);
            }
            var Eo = dt || function (e) {
              return ht.clearTimeout(e);
            };
            function _o(e, t) {
              if (t) return e.slice();
              var n = e.length,
                r = Ze ? Ze(n) : new e.constructor(n);
              return e.copy(r), r;
            }
            function Po(e) {
              var t = new e.constructor(e.byteLength);
              return new Ue(t).set(new Ue(e)), t;
            }
            function ko(e, t) {
              var n = t ? Po(e.buffer) : e.buffer;
              return new e.constructor(n, e.byteOffset, e.length);
            }
            function Ao(e, t) {
              if (e !== t) {
                var n = e !== o,
                  r = null === e,
                  i = e == e,
                  a = ds(e),
                  s = t !== o,
                  l = null === t,
                  u = t == t,
                  c = ds(t);
                if (!l && !c && !a && e > t || a && s && u && !l && !c || r && s && u || !n && u || !i) return 1;
                if (!r && !a && !c && e < t || c && n && i && !r && !a || l && n && i || !s && i || !u) return -1;
              }
              return 0;
            }
            function zo(e, t, n, o) {
              for (var i = -1, a = e.length, s = n.length, l = -1, u = t.length, c = wn(a - s, 0), d = r(u + c), p = !o; ++l < u;) d[l] = t[l];
              for (; ++i < s;) (p || i < a) && (d[n[i]] = e[i]);
              for (; c--;) d[l++] = e[i++];
              return d;
            }
            function To(e, t, n, o) {
              for (var i = -1, a = e.length, s = -1, l = n.length, u = -1, c = t.length, d = wn(a - l, 0), p = r(d + c), h = !o; ++i < d;) p[i] = e[i];
              for (var f = i; ++u < c;) p[f + u] = t[u];
              for (; ++s < l;) (h || i < a) && (p[f + n[s]] = e[i++]);
              return p;
            }
            function Oo(e, t) {
              var n = -1,
                o = e.length;
              for (t || (t = r(o)); ++n < o;) t[n] = e[n];
              return t;
            }
            function Io(e, t, n, r) {
              var i = !n;
              n || (n = {});
              for (var a = -1, s = t.length; ++a < s;) {
                var l = t[a],
                  u = r ? r(n[l], e[l], l, n, e) : o;
                u === o && (u = e[l]), i ? sr(n, l, u) : rr(n, l, u);
              }
              return n;
            }
            function Fo(e, t) {
              return function (n, r) {
                var o = $a(n) ? _t : ir,
                  i = t ? t() : {};
                return o(n, e, di(r, 2), i);
              };
            }
            function Mo(e) {
              return Qr(function (t, n) {
                var r = -1,
                  i = n.length,
                  a = i > 1 ? n[i - 1] : o,
                  s = i > 2 ? n[2] : o;
                for (a = e.length > 3 && "function" == typeof a ? (i--, a) : o, s && Di(n[0], n[1], s) && (a = i < 3 ? o : a, i = 1), t = Pe(t); ++r < i;) {
                  var l = n[r];
                  l && e(t, l, r, a);
                }
                return t;
              });
            }
            function Ro(e, t) {
              return function (n, r) {
                if (null == n) return n;
                if (!Wa(n)) return e(n, r);
                for (var o = n.length, i = t ? o : -1, a = Pe(n); (t ? i-- : ++i < o) && !1 !== r(a[i], i, a););
                return n;
              };
            }
            function jo(e) {
              return function (t, n, r) {
                for (var o = -1, i = Pe(t), a = r(t), s = a.length; s--;) {
                  var l = a[e ? s : ++o];
                  if (!1 === n(i[l], l, i)) break;
                }
                return t;
              };
            }
            function Bo(e) {
              return function (t) {
                var n = sn(t = xs(t)) ? fn(t) : o,
                  r = n ? n[0] : t.charAt(0),
                  i = n ? So(n, 1).join("") : t.slice(1);
                return r[e]() + i;
              };
            }
            function No(e) {
              return function (t) {
                return Mt(el(Zs(t).replace(Qe, "")), e, "");
              };
            }
            function Lo(e) {
              return function () {
                var t = arguments;
                switch (t.length) {
                  case 0:
                    return new e();
                  case 1:
                    return new e(t[0]);
                  case 2:
                    return new e(t[0], t[1]);
                  case 3:
                    return new e(t[0], t[1], t[2]);
                  case 4:
                    return new e(t[0], t[1], t[2], t[3]);
                  case 5:
                    return new e(t[0], t[1], t[2], t[3], t[4]);
                  case 6:
                    return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
                  case 7:
                    return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
                }
                var n = qn(e.prototype),
                  r = e.apply(n, t);
                return rs(r) ? r : n;
              };
            }
            function Vo(e) {
              return function (t, n, r) {
                var i = Pe(t);
                if (!Wa(t)) {
                  var a = di(n, 3);
                  t = Fs(t), n = function (e) {
                    return a(i[e], e, i);
                  };
                }
                var s = e(t, n, r);
                return s > -1 ? i[a ? t[s] : s] : o;
              };
            }
            function Ko(e) {
              return ii(function (t) {
                var n = t.length,
                  r = n,
                  a = Un.prototype.thru;
                for (e && t.reverse(); r--;) {
                  var s = t[r];
                  if ("function" != typeof s) throw new ze(i);
                  if (a && !l && "wrapper" == ui(s)) var l = new Un([], !0);
                }
                for (r = l ? r : n; ++r < n;) {
                  var u = ui(s = t[r]),
                    c = "wrapper" == u ? li(s) : o;
                  l = c && Si(c[0]) && 424 == c[1] && !c[4].length && 1 == c[9] ? l[ui(c[0])].apply(l, c[3]) : 1 == s.length && Si(s) ? l[u]() : l.thru(s);
                }
                return function () {
                  var e = arguments,
                    r = e[0];
                  if (l && 1 == e.length && $a(r)) return l.plant(r).value();
                  for (var o = 0, i = n ? t[o].apply(this, e) : r; ++o < n;) i = t[o].call(this, i);
                  return i;
                };
              });
            }
            function qo(e, t, n, i, a, s, l, u, c, p) {
              var h = t & d,
                f = 1 & t,
                m = 2 & t,
                g = 24 & t,
                v = 512 & t,
                y = m ? o : Lo(e);
              return function o() {
                for (var d = arguments.length, b = r(d), w = d; w--;) b[w] = arguments[w];
                if (g) var x = ci(o),
                  D = nn(b, x);
                if (i && (b = zo(b, i, a, g)), s && (b = To(b, s, l, g)), d -= D, g && d < p) {
                  var C = cn(b, x);
                  return Yo(e, t, qo, o.placeholder, n, b, C, u, c, p - d);
                }
                var S = f ? n : this,
                  E = m ? S[e] : e;
                return d = b.length, u ? b = Ti(b, u) : v && d > 1 && b.reverse(), h && c < d && (b.length = c), this && this !== ht && this instanceof o && (E = y || Lo(E)), E.apply(S, b);
              };
            }
            function Ho(e, t) {
              return function (n, r) {
                return function (e, t, n, r) {
                  return Dr(e, function (e, o, i) {
                    t(r, n(e), o, i);
                  }), r;
                }(n, e, t(r), {});
              };
            }
            function Uo(e, t) {
              return function (n, r) {
                var i;
                if (n === o && r === o) return t;
                if (n !== o && (i = n), r !== o) {
                  if (i === o) return r;
                  "string" == typeof n || "string" == typeof r ? (n = po(n), r = po(r)) : (n = co(n), r = co(r)), i = e(n, r);
                }
                return i;
              };
            }
            function Zo(e) {
              return ii(function (t) {
                return t = It(t, Xt(di())), Qr(function (n) {
                  var r = this;
                  return e(t, function (e) {
                    return Et(e, r, n);
                  });
                });
              });
            }
            function $o(e, t) {
              var n = (t = t === o ? " " : po(t)).length;
              if (n < 2) return n ? Xr(t, e) : t;
              var r = Xr(t, mt(e / hn(t)));
              return sn(t) ? So(fn(r), 0, e).join("") : r.slice(0, e);
            }
            function Go(e) {
              return function (t, n, i) {
                return i && "number" != typeof i && Di(t, n, i) && (n = i = o), t = gs(t), n === o ? (n = t, t = 0) : n = gs(n), function (e, t, n, o) {
                  for (var i = -1, a = wn(mt((t - e) / (n || 1)), 0), s = r(a); a--;) s[o ? a : ++i] = e, e += n;
                  return s;
                }(t, n, i = i === o ? t < n ? 1 : -1 : gs(i), e);
              };
            }
            function Wo(e) {
              return function (t, n) {
                return "string" == typeof t && "string" == typeof n || (t = bs(t), n = bs(n)), e(t, n);
              };
            }
            function Yo(e, t, n, r, i, a, s, l, d, p) {
              var h = 8 & t;
              t |= h ? u : c, 4 & (t &= ~(h ? c : u)) || (t &= -4);
              var f = [e, t, i, h ? a : o, h ? s : o, h ? o : a, h ? o : s, l, d, p],
                m = n.apply(o, f);
              return Si(e) && Ii(m, f), m.placeholder = r, Ri(m, e, t);
            }
            function Xo(e) {
              var t = _e[e];
              return function (e, n) {
                if (e = bs(e), (n = null == n ? 0 : xn(vs(n), 292)) && Zt(e)) {
                  var r = (xs(e) + "e").split("e");
                  return +((r = (xs(t(r[0] + "e" + (+r[1] + n))) + "e").split("e"))[0] + "e" + (+r[1] - n));
                }
                return t(e);
              };
            }
            var Qo = An && 1 / dn(new An([, -0]))[1] == h ? function (e) {
              return new An(e);
            } : dl;
            function Jo(e) {
              return function (t) {
                var n = vi(t);
                return n == E ? ln(t) : n == z ? pn(t) : function (e, t) {
                  return It(t, function (t) {
                    return [t, e[t]];
                  });
                }(t, e(t));
              };
            }
            function ei(e, t, n, a, h, f, m, g) {
              var v = 2 & t;
              if (!v && "function" != typeof e) throw new ze(i);
              var y = a ? a.length : 0;
              if (y || (t &= -97, a = h = o), m = m === o ? m : wn(vs(m), 0), g = g === o ? g : vs(g), y -= h ? h.length : 0, t & c) {
                var b = a,
                  w = h;
                a = h = o;
              }
              var x = v ? o : li(e),
                D = [e, t, n, a, h, b, w, f, m, g];
              if (x && function (e, t) {
                var n = e[1],
                  r = t[1],
                  o = n | r,
                  i = o < 131,
                  a = r == d && 8 == n || r == d && n == p && e[7].length <= t[8] || 384 == r && t[7].length <= t[8] && 8 == n;
                if (!i && !a) return e;
                1 & r && (e[2] = t[2], o |= 1 & n ? 0 : 4);
                var l = t[3];
                if (l) {
                  var u = e[3];
                  e[3] = u ? zo(u, l, t[4]) : l, e[4] = u ? cn(e[3], s) : t[4];
                }
                (l = t[5]) && (u = e[5], e[5] = u ? To(u, l, t[6]) : l, e[6] = u ? cn(e[5], s) : t[6]);
                (l = t[7]) && (e[7] = l);
                r & d && (e[8] = null == e[8] ? t[8] : xn(e[8], t[8]));
                null == e[9] && (e[9] = t[9]);
                e[0] = t[0], e[1] = o;
              }(D, x), e = D[0], t = D[1], n = D[2], a = D[3], h = D[4], !(g = D[9] = D[9] === o ? v ? 0 : e.length : wn(D[9] - y, 0)) && 24 & t && (t &= -25), t && 1 != t) C = 8 == t || t == l ? function (e, t, n) {
                var i = Lo(e);
                return function a() {
                  for (var s = arguments.length, l = r(s), u = s, c = ci(a); u--;) l[u] = arguments[u];
                  var d = s < 3 && l[0] !== c && l[s - 1] !== c ? [] : cn(l, c);
                  return (s -= d.length) < n ? Yo(e, t, qo, a.placeholder, o, l, d, o, o, n - s) : Et(this && this !== ht && this instanceof a ? i : e, this, l);
                };
              }(e, t, g) : t != u && 33 != t || h.length ? qo.apply(o, D) : function (e, t, n, o) {
                var i = 1 & t,
                  a = Lo(e);
                return function t() {
                  for (var s = -1, l = arguments.length, u = -1, c = o.length, d = r(c + l), p = this && this !== ht && this instanceof t ? a : e; ++u < c;) d[u] = o[u];
                  for (; l--;) d[u++] = arguments[++s];
                  return Et(p, i ? n : this, d);
                };
              }(e, t, n, a);else var C = function (e, t, n) {
                var r = 1 & t,
                  o = Lo(e);
                return function t() {
                  return (this && this !== ht && this instanceof t ? o : e).apply(r ? n : this, arguments);
                };
              }(e, t, n);
              return Ri((x ? no : Ii)(C, D), e, t);
            }
            function ti(e, t, n, r) {
              return e === o || qa(e, Ie[n]) && !Re.call(r, n) ? t : e;
            }
            function ni(e, t, n, r, i, a) {
              return rs(e) && rs(t) && (a.set(t, e), Hr(e, t, o, ni, a), a.delete(t)), e;
            }
            function ri(e) {
              return ss(e) ? o : e;
            }
            function oi(e, t, n, r, i, a) {
              var s = 1 & n,
                l = e.length,
                u = t.length;
              if (l != u && !(s && u > l)) return !1;
              var c = a.get(e),
                d = a.get(t);
              if (c && d) return c == t && d == e;
              var p = -1,
                h = !0,
                f = 2 & n ? new Yn() : o;
              for (a.set(e, t), a.set(t, e); ++p < l;) {
                var m = e[p],
                  g = t[p];
                if (r) var v = s ? r(g, m, p, t, e, a) : r(m, g, p, e, t, a);
                if (v !== o) {
                  if (v) continue;
                  h = !1;
                  break;
                }
                if (f) {
                  if (!jt(t, function (e, t) {
                    if (!Jt(f, t) && (m === e || i(m, e, n, r, a))) return f.push(t);
                  })) {
                    h = !1;
                    break;
                  }
                } else if (m !== g && !i(m, g, n, r, a)) {
                  h = !1;
                  break;
                }
              }
              return a.delete(e), a.delete(t), h;
            }
            function ii(e) {
              return Mi(Ai(e, o, Gi), e + "");
            }
            function ai(e) {
              return _r(e, Fs, mi);
            }
            function si(e) {
              return _r(e, Ms, gi);
            }
            var li = On ? function (e) {
              return On.get(e);
            } : dl;
            function ui(e) {
              for (var t = e.name + "", n = In[t], r = Re.call(In, t) ? n.length : 0; r--;) {
                var o = n[r],
                  i = o.func;
                if (null == i || i == e) return o.name;
              }
              return t;
            }
            function ci(e) {
              return (Re.call(Kn, "placeholder") ? Kn : e).placeholder;
            }
            function di() {
              var e = Kn.iteratee || sl;
              return e = e === sl ? jr : e, arguments.length ? e(arguments[0], arguments[1]) : e;
            }
            function pi(e, t) {
              var n,
                r,
                o = e.__data__;
              return ("string" == (r = typeof (n = t)) || "number" == r || "symbol" == r || "boolean" == r ? "__proto__" !== n : null === n) ? o["string" == typeof t ? "string" : "hash"] : o.map;
            }
            function hi(e) {
              for (var t = Fs(e), n = t.length; n--;) {
                var r = t[n],
                  o = e[r];
                t[n] = [r, o, Pi(o)];
              }
              return t;
            }
            function fi(e, t) {
              var n = function (e, t) {
                return null == e ? o : e[t];
              }(e, t);
              return Rr(n) ? n : o;
            }
            var mi = yt ? function (e) {
                return null == e ? [] : (e = Pe(e), zt(yt(e), function (t) {
                  return We.call(e, t);
                }));
              } : yl,
              gi = yt ? function (e) {
                for (var t = []; e;) Ft(t, mi(e)), e = $e(e);
                return t;
              } : yl,
              vi = Pr;
            function yi(e, t, n) {
              for (var r = -1, o = (t = Do(t, e)).length, i = !1; ++r < o;) {
                var a = Li(t[r]);
                if (!(i = null != e && n(e, a))) break;
                e = e[a];
              }
              return i || ++r != o ? i : !!(o = null == e ? 0 : e.length) && ns(o) && xi(a, o) && ($a(e) || Za(e));
            }
            function bi(e) {
              return "function" != typeof e.constructor || _i(e) ? {} : qn($e(e));
            }
            function wi(e) {
              return $a(e) || Za(e) || !!(Xe && e && e[Xe]);
            }
            function xi(e, t) {
              var n = typeof e;
              return !!(t = null == t ? f : t) && ("number" == n || "symbol" != n && we.test(e)) && e > -1 && e % 1 == 0 && e < t;
            }
            function Di(e, t, n) {
              if (!rs(n)) return !1;
              var r = typeof t;
              return !!("number" == r ? Wa(n) && xi(t, n.length) : "string" == r && t in n) && qa(n[t], e);
            }
            function Ci(e, t) {
              if ($a(e)) return !1;
              var n = typeof e;
              return !("number" != n && "symbol" != n && "boolean" != n && null != e && !ds(e)) || ne.test(e) || !te.test(e) || null != t && e in Pe(t);
            }
            function Si(e) {
              var t = ui(e),
                n = Kn[t];
              if ("function" != typeof n || !(t in Zn.prototype)) return !1;
              if (e === n) return !0;
              var r = li(n);
              return !!r && e === r[0];
            }
            (_n && vi(new _n(new ArrayBuffer(1))) != M || Pn && vi(new Pn()) != E || kn && vi(kn.resolve()) != k || An && vi(new An()) != z || zn && vi(new zn()) != I) && (vi = function (e) {
              var t = Pr(e),
                n = t == P ? e.constructor : o,
                r = n ? Vi(n) : "";
              if (r) switch (r) {
                case Fn:
                  return M;
                case Mn:
                  return E;
                case Rn:
                  return k;
                case jn:
                  return z;
                case Bn:
                  return I;
              }
              return t;
            });
            var Ei = Fe ? es : bl;
            function _i(e) {
              var t = e && e.constructor;
              return e === ("function" == typeof t && t.prototype || Ie);
            }
            function Pi(e) {
              return e == e && !rs(e);
            }
            function ki(e, t) {
              return function (n) {
                return null != n && n[e] === t && (t !== o || e in Pe(n));
              };
            }
            function Ai(e, t, n) {
              return t = wn(t === o ? e.length - 1 : t, 0), function () {
                for (var o = arguments, i = -1, a = wn(o.length - t, 0), s = r(a); ++i < a;) s[i] = o[t + i];
                i = -1;
                for (var l = r(t + 1); ++i < t;) l[i] = o[i];
                return l[t] = n(s), Et(e, this, l);
              };
            }
            function zi(e, t) {
              return t.length < 2 ? e : Er(e, io(t, 0, -1));
            }
            function Ti(e, t) {
              for (var n = e.length, r = xn(t.length, n), i = Oo(e); r--;) {
                var a = t[r];
                e[r] = xi(a, n) ? i[a] : o;
              }
              return e;
            }
            function Oi(e, t) {
              if (("constructor" !== t || "function" != typeof e[t]) && "__proto__" != t) return e[t];
            }
            var Ii = ji(no),
              Fi = ft || function (e, t) {
                return ht.setTimeout(e, t);
              },
              Mi = ji(ro);
            function Ri(e, t, n) {
              var r = t + "";
              return Mi(e, function (e, t) {
                var n = t.length;
                if (!n) return e;
                var r = n - 1;
                return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(le, "{\n/* [wrapped with " + t + "] */\n");
              }(r, function (e, t) {
                return Pt(v, function (n) {
                  var r = "_." + n[0];
                  t & n[1] && !Tt(e, r) && e.push(r);
                }), e.sort();
              }(function (e) {
                var t = e.match(ue);
                return t ? t[1].split(ce) : [];
              }(r), n)));
            }
            function ji(e) {
              var t = 0,
                n = 0;
              return function () {
                var r = Dn(),
                  i = 16 - (r - n);
                if (n = r, i > 0) {
                  if (++t >= 800) return arguments[0];
                } else t = 0;
                return e.apply(o, arguments);
              };
            }
            function Bi(e, t) {
              var n = -1,
                r = e.length,
                i = r - 1;
              for (t = t === o ? r : t; ++n < t;) {
                var a = Yr(n, i),
                  s = e[a];
                e[a] = e[n], e[n] = s;
              }
              return e.length = t, e;
            }
            var Ni = function (e) {
              var t = ja(e, function (e) {
                  return 500 === n.size && n.clear(), e;
                }),
                n = t.cache;
              return t;
            }(function (e) {
              var t = [];
              return 46 === e.charCodeAt(0) && t.push(""), e.replace(re, function (e, n, r, o) {
                t.push(r ? o.replace(he, "$1") : n || e);
              }), t;
            });
            function Li(e) {
              if ("string" == typeof e || ds(e)) return e;
              var t = e + "";
              return "0" == t && 1 / e == -1 / 0 ? "-0" : t;
            }
            function Vi(e) {
              if (null != e) {
                try {
                  return Me.call(e);
                } catch (e) {}
                try {
                  return e + "";
                } catch (e) {}
              }
              return "";
            }
            function Ki(e) {
              if (e instanceof Zn) return e.clone();
              var t = new Un(e.__wrapped__, e.__chain__);
              return t.__actions__ = Oo(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
            }
            var qi = Qr(function (e, t) {
                return Ya(e) ? hr(e, br(t, 1, Ya, !0)) : [];
              }),
              Hi = Qr(function (e, t) {
                var n = Ji(t);
                return Ya(n) && (n = o), Ya(e) ? hr(e, br(t, 1, Ya, !0), di(n, 2)) : [];
              }),
              Ui = Qr(function (e, t) {
                var n = Ji(t);
                return Ya(n) && (n = o), Ya(e) ? hr(e, br(t, 1, Ya, !0), o, n) : [];
              });
            function Zi(e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var o = null == n ? 0 : vs(n);
              return o < 0 && (o = wn(r + o, 0)), Lt(e, di(t, 3), o);
            }
            function $i(e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = r - 1;
              return n !== o && (i = vs(n), i = n < 0 ? wn(r + i, 0) : xn(i, r - 1)), Lt(e, di(t, 3), i, !0);
            }
            function Gi(e) {
              return (null == e ? 0 : e.length) ? br(e, 1) : [];
            }
            function Wi(e) {
              return e && e.length ? e[0] : o;
            }
            var Yi = Qr(function (e) {
                var t = It(e, wo);
                return t.length && t[0] === e[0] ? Tr(t) : [];
              }),
              Xi = Qr(function (e) {
                var t = Ji(e),
                  n = It(e, wo);
                return t === Ji(n) ? t = o : n.pop(), n.length && n[0] === e[0] ? Tr(n, di(t, 2)) : [];
              }),
              Qi = Qr(function (e) {
                var t = Ji(e),
                  n = It(e, wo);
                return (t = "function" == typeof t ? t : o) && n.pop(), n.length && n[0] === e[0] ? Tr(n, o, t) : [];
              });
            function Ji(e) {
              var t = null == e ? 0 : e.length;
              return t ? e[t - 1] : o;
            }
            var ea = Qr(ta);
            function ta(e, t) {
              return e && e.length && t && t.length ? Gr(e, t) : e;
            }
            var na = ii(function (e, t) {
              var n = null == e ? 0 : e.length,
                r = lr(e, t);
              return Wr(e, It(t, function (e) {
                return xi(e, n) ? +e : e;
              }).sort(Ao)), r;
            });
            function ra(e) {
              return null == e ? e : En.call(e);
            }
            var oa = Qr(function (e) {
                return ho(br(e, 1, Ya, !0));
              }),
              ia = Qr(function (e) {
                var t = Ji(e);
                return Ya(t) && (t = o), ho(br(e, 1, Ya, !0), di(t, 2));
              }),
              aa = Qr(function (e) {
                var t = Ji(e);
                return t = "function" == typeof t ? t : o, ho(br(e, 1, Ya, !0), o, t);
              });
            function sa(e) {
              if (!e || !e.length) return [];
              var t = 0;
              return e = zt(e, function (e) {
                if (Ya(e)) return t = wn(e.length, t), !0;
              }), Wt(t, function (t) {
                return It(e, Ut(t));
              });
            }
            function la(e, t) {
              if (!e || !e.length) return [];
              var n = sa(e);
              return null == t ? n : It(n, function (e) {
                return Et(t, o, e);
              });
            }
            var ua = Qr(function (e, t) {
                return Ya(e) ? hr(e, t) : [];
              }),
              ca = Qr(function (e) {
                return yo(zt(e, Ya));
              }),
              da = Qr(function (e) {
                var t = Ji(e);
                return Ya(t) && (t = o), yo(zt(e, Ya), di(t, 2));
              }),
              pa = Qr(function (e) {
                var t = Ji(e);
                return t = "function" == typeof t ? t : o, yo(zt(e, Ya), o, t);
              }),
              ha = Qr(sa);
            var fa = Qr(function (e) {
              var t = e.length,
                n = t > 1 ? e[t - 1] : o;
              return n = "function" == typeof n ? (e.pop(), n) : o, la(e, n);
            });
            function ma(e) {
              var t = Kn(e);
              return t.__chain__ = !0, t;
            }
            function ga(e, t) {
              return t(e);
            }
            var va = ii(function (e) {
              var t = e.length,
                n = t ? e[0] : 0,
                r = this.__wrapped__,
                i = function (t) {
                  return lr(t, e);
                };
              return !(t > 1 || this.__actions__.length) && r instanceof Zn && xi(n) ? ((r = r.slice(n, +n + (t ? 1 : 0))).__actions__.push({
                func: ga,
                args: [i],
                thisArg: o
              }), new Un(r, this.__chain__).thru(function (e) {
                return t && !e.length && e.push(o), e;
              })) : this.thru(i);
            });
            var ya = Fo(function (e, t, n) {
              Re.call(e, n) ? ++e[n] : sr(e, n, 1);
            });
            var ba = Vo(Zi),
              wa = Vo($i);
            function xa(e, t) {
              return ($a(e) ? Pt : fr)(e, di(t, 3));
            }
            function Da(e, t) {
              return ($a(e) ? kt : mr)(e, di(t, 3));
            }
            var Ca = Fo(function (e, t, n) {
              Re.call(e, n) ? e[n].push(t) : sr(e, n, [t]);
            });
            var Sa = Qr(function (e, t, n) {
                var o = -1,
                  i = "function" == typeof t,
                  a = Wa(e) ? r(e.length) : [];
                return fr(e, function (e) {
                  a[++o] = i ? Et(t, e, n) : Or(e, t, n);
                }), a;
              }),
              Ea = Fo(function (e, t, n) {
                sr(e, n, t);
              });
            function _a(e, t) {
              return ($a(e) ? It : Vr)(e, di(t, 3));
            }
            var Pa = Fo(function (e, t, n) {
              e[n ? 0 : 1].push(t);
            }, function () {
              return [[], []];
            });
            var ka = Qr(function (e, t) {
                if (null == e) return [];
                var n = t.length;
                return n > 1 && Di(e, t[0], t[1]) ? t = [] : n > 2 && Di(t[0], t[1], t[2]) && (t = [t[0]]), Zr(e, br(t, 1), []);
              }),
              Aa = pt || function () {
                return ht.Date.now();
              };
            function za(e, t, n) {
              return t = n ? o : t, t = e && null == t ? e.length : t, ei(e, d, o, o, o, o, t);
            }
            function Ta(e, t) {
              var n;
              if ("function" != typeof t) throw new ze(i);
              return e = vs(e), function () {
                return --e > 0 && (n = t.apply(this, arguments)), e <= 1 && (t = o), n;
              };
            }
            var Oa = Qr(function (e, t, n) {
                var r = 1;
                if (n.length) {
                  var o = cn(n, ci(Oa));
                  r |= u;
                }
                return ei(e, r, t, n, o);
              }),
              Ia = Qr(function (e, t, n) {
                var r = 3;
                if (n.length) {
                  var o = cn(n, ci(Ia));
                  r |= u;
                }
                return ei(t, r, e, n, o);
              });
            function Fa(e, t, n) {
              var r,
                a,
                s,
                l,
                u,
                c,
                d = 0,
                p = !1,
                h = !1,
                f = !0;
              if ("function" != typeof e) throw new ze(i);
              function m(t) {
                var n = r,
                  i = a;
                return r = a = o, d = t, l = e.apply(i, n);
              }
              function g(e) {
                return d = e, u = Fi(y, t), p ? m(e) : l;
              }
              function v(e) {
                var n = e - c;
                return c === o || n >= t || n < 0 || h && e - d >= s;
              }
              function y() {
                var e = Aa();
                if (v(e)) return b(e);
                u = Fi(y, function (e) {
                  var n = t - (e - c);
                  return h ? xn(n, s - (e - d)) : n;
                }(e));
              }
              function b(e) {
                return u = o, f && r ? m(e) : (r = a = o, l);
              }
              function w() {
                var e = Aa(),
                  n = v(e);
                if (r = arguments, a = this, c = e, n) {
                  if (u === o) return g(c);
                  if (h) return Eo(u), u = Fi(y, t), m(c);
                }
                return u === o && (u = Fi(y, t)), l;
              }
              return t = bs(t) || 0, rs(n) && (p = !!n.leading, s = (h = "maxWait" in n) ? wn(bs(n.maxWait) || 0, t) : s, f = "trailing" in n ? !!n.trailing : f), w.cancel = function () {
                u !== o && Eo(u), d = 0, r = c = a = u = o;
              }, w.flush = function () {
                return u === o ? l : b(Aa());
              }, w;
            }
            var Ma = Qr(function (e, t) {
                return pr(e, 1, t);
              }),
              Ra = Qr(function (e, t, n) {
                return pr(e, bs(t) || 0, n);
              });
            function ja(e, t) {
              if ("function" != typeof e || null != t && "function" != typeof t) throw new ze(i);
              var n = function () {
                var r = arguments,
                  o = t ? t.apply(this, r) : r[0],
                  i = n.cache;
                if (i.has(o)) return i.get(o);
                var a = e.apply(this, r);
                return n.cache = i.set(o, a) || i, a;
              };
              return n.cache = new (ja.Cache || Wn)(), n;
            }
            function Ba(e) {
              if ("function" != typeof e) throw new ze(i);
              return function () {
                var t = arguments;
                switch (t.length) {
                  case 0:
                    return !e.call(this);
                  case 1:
                    return !e.call(this, t[0]);
                  case 2:
                    return !e.call(this, t[0], t[1]);
                  case 3:
                    return !e.call(this, t[0], t[1], t[2]);
                }
                return !e.apply(this, t);
              };
            }
            ja.Cache = Wn;
            var Na = Co(function (e, t) {
                var n = (t = 1 == t.length && $a(t[0]) ? It(t[0], Xt(di())) : It(br(t, 1), Xt(di()))).length;
                return Qr(function (r) {
                  for (var o = -1, i = xn(r.length, n); ++o < i;) r[o] = t[o].call(this, r[o]);
                  return Et(e, this, r);
                });
              }),
              La = Qr(function (e, t) {
                var n = cn(t, ci(La));
                return ei(e, u, o, t, n);
              }),
              Va = Qr(function (e, t) {
                var n = cn(t, ci(Va));
                return ei(e, c, o, t, n);
              }),
              Ka = ii(function (e, t) {
                return ei(e, p, o, o, o, t);
              });
            function qa(e, t) {
              return e === t || e != e && t != t;
            }
            var Ha = Wo(kr),
              Ua = Wo(function (e, t) {
                return e >= t;
              }),
              Za = Ir(function () {
                return arguments;
              }()) ? Ir : function (e) {
                return os(e) && Re.call(e, "callee") && !We.call(e, "callee");
              },
              $a = r.isArray,
              Ga = bt ? Xt(bt) : function (e) {
                return os(e) && Pr(e) == F;
              };
            function Wa(e) {
              return null != e && ns(e.length) && !es(e);
            }
            function Ya(e) {
              return os(e) && Wa(e);
            }
            var Xa = Bt || bl,
              Qa = wt ? Xt(wt) : function (e) {
                return os(e) && Pr(e) == x;
              };
            function Ja(e) {
              if (!os(e)) return !1;
              var t = Pr(e);
              return t == D || "[object DOMException]" == t || "string" == typeof e.message && "string" == typeof e.name && !ss(e);
            }
            function es(e) {
              if (!rs(e)) return !1;
              var t = Pr(e);
              return t == C || t == S || "[object AsyncFunction]" == t || "[object Proxy]" == t;
            }
            function ts(e) {
              return "number" == typeof e && e == vs(e);
            }
            function ns(e) {
              return "number" == typeof e && e > -1 && e % 1 == 0 && e <= f;
            }
            function rs(e) {
              var t = typeof e;
              return null != e && ("object" == t || "function" == t);
            }
            function os(e) {
              return null != e && "object" == typeof e;
            }
            var is = xt ? Xt(xt) : function (e) {
              return os(e) && vi(e) == E;
            };
            function as(e) {
              return "number" == typeof e || os(e) && Pr(e) == _;
            }
            function ss(e) {
              if (!os(e) || Pr(e) != P) return !1;
              var t = $e(e);
              if (null === t) return !0;
              var n = Re.call(t, "constructor") && t.constructor;
              return "function" == typeof n && n instanceof n && Me.call(n) == Le;
            }
            var ls = Dt ? Xt(Dt) : function (e) {
              return os(e) && Pr(e) == A;
            };
            var us = Ct ? Xt(Ct) : function (e) {
              return os(e) && vi(e) == z;
            };
            function cs(e) {
              return "string" == typeof e || !$a(e) && os(e) && Pr(e) == T;
            }
            function ds(e) {
              return "symbol" == typeof e || os(e) && Pr(e) == O;
            }
            var ps = St ? Xt(St) : function (e) {
              return os(e) && ns(e.length) && !!at[Pr(e)];
            };
            var hs = Wo(Lr),
              fs = Wo(function (e, t) {
                return e <= t;
              });
            function ms(e) {
              if (!e) return [];
              if (Wa(e)) return cs(e) ? fn(e) : Oo(e);
              if (et && e[et]) return function (e) {
                for (var t, n = []; !(t = e.next()).done;) n.push(t.value);
                return n;
              }(e[et]());
              var t = vi(e);
              return (t == E ? ln : t == z ? dn : qs)(e);
            }
            function gs(e) {
              return e ? (e = bs(e)) === h || e === -1 / 0 ? 17976931348623157e292 * (e < 0 ? -1 : 1) : e == e ? e : 0 : 0 === e ? e : 0;
            }
            function vs(e) {
              var t = gs(e),
                n = t % 1;
              return t == t ? n ? t - n : t : 0;
            }
            function ys(e) {
              return e ? ur(vs(e), 0, g) : 0;
            }
            function bs(e) {
              if ("number" == typeof e) return e;
              if (ds(e)) return m;
              if (rs(e)) {
                var t = "function" == typeof e.valueOf ? e.valueOf() : e;
                e = rs(t) ? t + "" : t;
              }
              if ("string" != typeof e) return 0 === e ? e : +e;
              e = Yt(e);
              var n = ve.test(e);
              return n || be.test(e) ? ct(e.slice(2), n ? 2 : 8) : ge.test(e) ? m : +e;
            }
            function ws(e) {
              return Io(e, Ms(e));
            }
            function xs(e) {
              return null == e ? "" : po(e);
            }
            var Ds = Mo(function (e, t) {
                if (_i(t) || Wa(t)) Io(t, Fs(t), e);else for (var n in t) Re.call(t, n) && rr(e, n, t[n]);
              }),
              Cs = Mo(function (e, t) {
                Io(t, Ms(t), e);
              }),
              Ss = Mo(function (e, t, n, r) {
                Io(t, Ms(t), e, r);
              }),
              Es = Mo(function (e, t, n, r) {
                Io(t, Fs(t), e, r);
              }),
              _s = ii(lr);
            var Ps = Qr(function (e, t) {
                e = Pe(e);
                var n = -1,
                  r = t.length,
                  i = r > 2 ? t[2] : o;
                for (i && Di(t[0], t[1], i) && (r = 1); ++n < r;) for (var a = t[n], s = Ms(a), l = -1, u = s.length; ++l < u;) {
                  var c = s[l],
                    d = e[c];
                  (d === o || qa(d, Ie[c]) && !Re.call(e, c)) && (e[c] = a[c]);
                }
                return e;
              }),
              ks = Qr(function (e) {
                return e.push(o, ni), Et(js, o, e);
              });
            function As(e, t, n) {
              var r = null == e ? o : Er(e, t);
              return r === o ? n : r;
            }
            function zs(e, t) {
              return null != e && yi(e, t, zr);
            }
            var Ts = Ho(function (e, t, n) {
                null != t && "function" != typeof t.toString && (t = Ne.call(t)), e[t] = n;
              }, rl(al)),
              Os = Ho(function (e, t, n) {
                null != t && "function" != typeof t.toString && (t = Ne.call(t)), Re.call(e, t) ? e[t].push(n) : e[t] = [n];
              }, di),
              Is = Qr(Or);
            function Fs(e) {
              return Wa(e) ? Qn(e) : Br(e);
            }
            function Ms(e) {
              return Wa(e) ? Qn(e, !0) : Nr(e);
            }
            var Rs = Mo(function (e, t, n) {
                Hr(e, t, n);
              }),
              js = Mo(function (e, t, n, r) {
                Hr(e, t, n, r);
              }),
              Bs = ii(function (e, t) {
                var n = {};
                if (null == e) return n;
                var r = !1;
                t = It(t, function (t) {
                  return t = Do(t, e), r || (r = t.length > 1), t;
                }), Io(e, si(e), n), r && (n = cr(n, 7, ri));
                for (var o = t.length; o--;) fo(n, t[o]);
                return n;
              });
            var Ns = ii(function (e, t) {
              return null == e ? {} : function (e, t) {
                return $r(e, t, function (t, n) {
                  return zs(e, n);
                });
              }(e, t);
            });
            function Ls(e, t) {
              if (null == e) return {};
              var n = It(si(e), function (e) {
                return [e];
              });
              return t = di(t), $r(e, n, function (e, n) {
                return t(e, n[0]);
              });
            }
            var Vs = Jo(Fs),
              Ks = Jo(Ms);
            function qs(e) {
              return null == e ? [] : Qt(e, Fs(e));
            }
            var Hs = No(function (e, t, n) {
              return t = t.toLowerCase(), e + (n ? Us(t) : t);
            });
            function Us(e) {
              return Js(xs(e).toLowerCase());
            }
            function Zs(e) {
              return (e = xs(e)) && e.replace(xe, rn).replace(Je, "");
            }
            var $s = No(function (e, t, n) {
                return e + (n ? "-" : "") + t.toLowerCase();
              }),
              Gs = No(function (e, t, n) {
                return e + (n ? " " : "") + t.toLowerCase();
              }),
              Ws = Bo("toLowerCase");
            var Ys = No(function (e, t, n) {
              return e + (n ? "_" : "") + t.toLowerCase();
            });
            var Xs = No(function (e, t, n) {
              return e + (n ? " " : "") + Js(t);
            });
            var Qs = No(function (e, t, n) {
                return e + (n ? " " : "") + t.toUpperCase();
              }),
              Js = Bo("toUpperCase");
            function el(e, t, n) {
              return e = xs(e), (t = n ? o : t) === o ? function (e) {
                return rt.test(e);
              }(e) ? function (e) {
                return e.match(tt) || [];
              }(e) : function (e) {
                return e.match(de) || [];
              }(e) : e.match(t) || [];
            }
            var tl = Qr(function (e, t) {
                try {
                  return Et(e, o, t);
                } catch (e) {
                  return Ja(e) ? e : new Se(e);
                }
              }),
              nl = ii(function (e, t) {
                return Pt(t, function (t) {
                  t = Li(t), sr(e, t, Oa(e[t], e));
                }), e;
              });
            function rl(e) {
              return function () {
                return e;
              };
            }
            var ol = Ko(),
              il = Ko(!0);
            function al(e) {
              return e;
            }
            function sl(e) {
              return jr("function" == typeof e ? e : cr(e, 1));
            }
            var ll = Qr(function (e, t) {
                return function (n) {
                  return Or(n, e, t);
                };
              }),
              ul = Qr(function (e, t) {
                return function (n) {
                  return Or(e, n, t);
                };
              });
            function cl(e, t, n) {
              var r = Fs(t),
                o = Sr(t, r);
              null != n || rs(t) && (o.length || !r.length) || (n = t, t = e, e = this, o = Sr(t, Fs(t)));
              var i = !(rs(n) && "chain" in n && !n.chain),
                a = es(e);
              return Pt(o, function (n) {
                var r = t[n];
                e[n] = r, a && (e.prototype[n] = function () {
                  var t = this.__chain__;
                  if (i || t) {
                    var n = e(this.__wrapped__),
                      o = n.__actions__ = Oo(this.__actions__);
                    return o.push({
                      func: r,
                      args: arguments,
                      thisArg: e
                    }), n.__chain__ = t, n;
                  }
                  return r.apply(e, Ft([this.value()], arguments));
                });
              }), e;
            }
            function dl() {}
            var pl = Zo(It),
              hl = Zo(At),
              fl = Zo(jt);
            function ml(e) {
              return Ci(e) ? Ut(Li(e)) : function (e) {
                return function (t) {
                  return Er(t, e);
                };
              }(e);
            }
            var gl = Go(),
              vl = Go(!0);
            function yl() {
              return [];
            }
            function bl() {
              return !1;
            }
            var wl = Uo(function (e, t) {
                return e + t;
              }, 0),
              xl = Xo("ceil"),
              Dl = Uo(function (e, t) {
                return e / t;
              }, 1),
              Cl = Xo("floor");
            var Sl,
              El = Uo(function (e, t) {
                return e * t;
              }, 1),
              _l = Xo("round"),
              Pl = Uo(function (e, t) {
                return e - t;
              }, 0);
            return Kn.after = function (e, t) {
              if ("function" != typeof t) throw new ze(i);
              return e = vs(e), function () {
                if (--e < 1) return t.apply(this, arguments);
              };
            }, Kn.ary = za, Kn.assign = Ds, Kn.assignIn = Cs, Kn.assignInWith = Ss, Kn.assignWith = Es, Kn.at = _s, Kn.before = Ta, Kn.bind = Oa, Kn.bindAll = nl, Kn.bindKey = Ia, Kn.castArray = function () {
              if (!arguments.length) return [];
              var e = arguments[0];
              return $a(e) ? e : [e];
            }, Kn.chain = ma, Kn.chunk = function (e, t, n) {
              t = (n ? Di(e, t, n) : t === o) ? 1 : wn(vs(t), 0);
              var i = null == e ? 0 : e.length;
              if (!i || t < 1) return [];
              for (var a = 0, s = 0, l = r(mt(i / t)); a < i;) l[s++] = io(e, a, a += t);
              return l;
            }, Kn.compact = function (e) {
              for (var t = -1, n = null == e ? 0 : e.length, r = 0, o = []; ++t < n;) {
                var i = e[t];
                i && (o[r++] = i);
              }
              return o;
            }, Kn.concat = function () {
              var e = arguments.length;
              if (!e) return [];
              for (var t = r(e - 1), n = arguments[0], o = e; o--;) t[o - 1] = arguments[o];
              return Ft($a(n) ? Oo(n) : [n], br(t, 1));
            }, Kn.cond = function (e) {
              var t = null == e ? 0 : e.length,
                n = di();
              return e = t ? It(e, function (e) {
                if ("function" != typeof e[1]) throw new ze(i);
                return [n(e[0]), e[1]];
              }) : [], Qr(function (n) {
                for (var r = -1; ++r < t;) {
                  var o = e[r];
                  if (Et(o[0], this, n)) return Et(o[1], this, n);
                }
              });
            }, Kn.conforms = function (e) {
              return function (e) {
                var t = Fs(e);
                return function (n) {
                  return dr(n, e, t);
                };
              }(cr(e, 1));
            }, Kn.constant = rl, Kn.countBy = ya, Kn.create = function (e, t) {
              var n = qn(e);
              return null == t ? n : ar(n, t);
            }, Kn.curry = function e(t, n, r) {
              var i = ei(t, 8, o, o, o, o, o, n = r ? o : n);
              return i.placeholder = e.placeholder, i;
            }, Kn.curryRight = function e(t, n, r) {
              var i = ei(t, l, o, o, o, o, o, n = r ? o : n);
              return i.placeholder = e.placeholder, i;
            }, Kn.debounce = Fa, Kn.defaults = Ps, Kn.defaultsDeep = ks, Kn.defer = Ma, Kn.delay = Ra, Kn.difference = qi, Kn.differenceBy = Hi, Kn.differenceWith = Ui, Kn.drop = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? io(e, (t = n || t === o ? 1 : vs(t)) < 0 ? 0 : t, r) : [];
            }, Kn.dropRight = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? io(e, 0, (t = r - (t = n || t === o ? 1 : vs(t))) < 0 ? 0 : t) : [];
            }, Kn.dropRightWhile = function (e, t) {
              return e && e.length ? go(e, di(t, 3), !0, !0) : [];
            }, Kn.dropWhile = function (e, t) {
              return e && e.length ? go(e, di(t, 3), !0) : [];
            }, Kn.fill = function (e, t, n, r) {
              var i = null == e ? 0 : e.length;
              return i ? (n && "number" != typeof n && Di(e, t, n) && (n = 0, r = i), function (e, t, n, r) {
                var i = e.length;
                for ((n = vs(n)) < 0 && (n = -n > i ? 0 : i + n), (r = r === o || r > i ? i : vs(r)) < 0 && (r += i), r = n > r ? 0 : ys(r); n < r;) e[n++] = t;
                return e;
              }(e, t, n, r)) : [];
            }, Kn.filter = function (e, t) {
              return ($a(e) ? zt : yr)(e, di(t, 3));
            }, Kn.flatMap = function (e, t) {
              return br(_a(e, t), 1);
            }, Kn.flatMapDeep = function (e, t) {
              return br(_a(e, t), h);
            }, Kn.flatMapDepth = function (e, t, n) {
              return n = n === o ? 1 : vs(n), br(_a(e, t), n);
            }, Kn.flatten = Gi, Kn.flattenDeep = function (e) {
              return (null == e ? 0 : e.length) ? br(e, h) : [];
            }, Kn.flattenDepth = function (e, t) {
              return (null == e ? 0 : e.length) ? br(e, t = t === o ? 1 : vs(t)) : [];
            }, Kn.flip = function (e) {
              return ei(e, 512);
            }, Kn.flow = ol, Kn.flowRight = il, Kn.fromPairs = function (e) {
              for (var t = -1, n = null == e ? 0 : e.length, r = {}; ++t < n;) {
                var o = e[t];
                r[o[0]] = o[1];
              }
              return r;
            }, Kn.functions = function (e) {
              return null == e ? [] : Sr(e, Fs(e));
            }, Kn.functionsIn = function (e) {
              return null == e ? [] : Sr(e, Ms(e));
            }, Kn.groupBy = Ca, Kn.initial = function (e) {
              return (null == e ? 0 : e.length) ? io(e, 0, -1) : [];
            }, Kn.intersection = Yi, Kn.intersectionBy = Xi, Kn.intersectionWith = Qi, Kn.invert = Ts, Kn.invertBy = Os, Kn.invokeMap = Sa, Kn.iteratee = sl, Kn.keyBy = Ea, Kn.keys = Fs, Kn.keysIn = Ms, Kn.map = _a, Kn.mapKeys = function (e, t) {
              var n = {};
              return t = di(t, 3), Dr(e, function (e, r, o) {
                sr(n, t(e, r, o), e);
              }), n;
            }, Kn.mapValues = function (e, t) {
              var n = {};
              return t = di(t, 3), Dr(e, function (e, r, o) {
                sr(n, r, t(e, r, o));
              }), n;
            }, Kn.matches = function (e) {
              return Kr(cr(e, 1));
            }, Kn.matchesProperty = function (e, t) {
              return qr(e, cr(t, 1));
            }, Kn.memoize = ja, Kn.merge = Rs, Kn.mergeWith = js, Kn.method = ll, Kn.methodOf = ul, Kn.mixin = cl, Kn.negate = Ba, Kn.nthArg = function (e) {
              return e = vs(e), Qr(function (t) {
                return Ur(t, e);
              });
            }, Kn.omit = Bs, Kn.omitBy = function (e, t) {
              return Ls(e, Ba(di(t)));
            }, Kn.once = function (e) {
              return Ta(2, e);
            }, Kn.orderBy = function (e, t, n, r) {
              return null == e ? [] : ($a(t) || (t = null == t ? [] : [t]), $a(n = r ? o : n) || (n = null == n ? [] : [n]), Zr(e, t, n));
            }, Kn.over = pl, Kn.overArgs = Na, Kn.overEvery = hl, Kn.overSome = fl, Kn.partial = La, Kn.partialRight = Va, Kn.partition = Pa, Kn.pick = Ns, Kn.pickBy = Ls, Kn.property = ml, Kn.propertyOf = function (e) {
              return function (t) {
                return null == e ? o : Er(e, t);
              };
            }, Kn.pull = ea, Kn.pullAll = ta, Kn.pullAllBy = function (e, t, n) {
              return e && e.length && t && t.length ? Gr(e, t, di(n, 2)) : e;
            }, Kn.pullAllWith = function (e, t, n) {
              return e && e.length && t && t.length ? Gr(e, t, o, n) : e;
            }, Kn.pullAt = na, Kn.range = gl, Kn.rangeRight = vl, Kn.rearg = Ka, Kn.reject = function (e, t) {
              return ($a(e) ? zt : yr)(e, Ba(di(t, 3)));
            }, Kn.remove = function (e, t) {
              var n = [];
              if (!e || !e.length) return n;
              var r = -1,
                o = [],
                i = e.length;
              for (t = di(t, 3); ++r < i;) {
                var a = e[r];
                t(a, r, e) && (n.push(a), o.push(r));
              }
              return Wr(e, o), n;
            }, Kn.rest = function (e, t) {
              if ("function" != typeof e) throw new ze(i);
              return Qr(e, t = t === o ? t : vs(t));
            }, Kn.reverse = ra, Kn.sampleSize = function (e, t, n) {
              return t = (n ? Di(e, t, n) : t === o) ? 1 : vs(t), ($a(e) ? er : eo)(e, t);
            }, Kn.set = function (e, t, n) {
              return null == e ? e : to(e, t, n);
            }, Kn.setWith = function (e, t, n, r) {
              return r = "function" == typeof r ? r : o, null == e ? e : to(e, t, n, r);
            }, Kn.shuffle = function (e) {
              return ($a(e) ? tr : oo)(e);
            }, Kn.slice = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? (n && "number" != typeof n && Di(e, t, n) ? (t = 0, n = r) : (t = null == t ? 0 : vs(t), n = n === o ? r : vs(n)), io(e, t, n)) : [];
            }, Kn.sortBy = ka, Kn.sortedUniq = function (e) {
              return e && e.length ? uo(e) : [];
            }, Kn.sortedUniqBy = function (e, t) {
              return e && e.length ? uo(e, di(t, 2)) : [];
            }, Kn.split = function (e, t, n) {
              return n && "number" != typeof n && Di(e, t, n) && (t = n = o), (n = n === o ? g : n >>> 0) ? (e = xs(e)) && ("string" == typeof t || null != t && !ls(t)) && !(t = po(t)) && sn(e) ? So(fn(e), 0, n) : e.split(t, n) : [];
            }, Kn.spread = function (e, t) {
              if ("function" != typeof e) throw new ze(i);
              return t = null == t ? 0 : wn(vs(t), 0), Qr(function (n) {
                var r = n[t],
                  o = So(n, 0, t);
                return r && Ft(o, r), Et(e, this, o);
              });
            }, Kn.tail = function (e) {
              var t = null == e ? 0 : e.length;
              return t ? io(e, 1, t) : [];
            }, Kn.take = function (e, t, n) {
              return e && e.length ? io(e, 0, (t = n || t === o ? 1 : vs(t)) < 0 ? 0 : t) : [];
            }, Kn.takeRight = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              return r ? io(e, (t = r - (t = n || t === o ? 1 : vs(t))) < 0 ? 0 : t, r) : [];
            }, Kn.takeRightWhile = function (e, t) {
              return e && e.length ? go(e, di(t, 3), !1, !0) : [];
            }, Kn.takeWhile = function (e, t) {
              return e && e.length ? go(e, di(t, 3)) : [];
            }, Kn.tap = function (e, t) {
              return t(e), e;
            }, Kn.throttle = function (e, t, n) {
              var r = !0,
                o = !0;
              if ("function" != typeof e) throw new ze(i);
              return rs(n) && (r = "leading" in n ? !!n.leading : r, o = "trailing" in n ? !!n.trailing : o), Fa(e, t, {
                leading: r,
                maxWait: t,
                trailing: o
              });
            }, Kn.thru = ga, Kn.toArray = ms, Kn.toPairs = Vs, Kn.toPairsIn = Ks, Kn.toPath = function (e) {
              return $a(e) ? It(e, Li) : ds(e) ? [e] : Oo(Ni(xs(e)));
            }, Kn.toPlainObject = ws, Kn.transform = function (e, t, n) {
              var r = $a(e),
                o = r || Xa(e) || ps(e);
              if (t = di(t, 4), null == n) {
                var i = e && e.constructor;
                n = o ? r ? new i() : [] : rs(e) && es(i) ? qn($e(e)) : {};
              }
              return (o ? Pt : Dr)(e, function (e, r, o) {
                return t(n, e, r, o);
              }), n;
            }, Kn.unary = function (e) {
              return za(e, 1);
            }, Kn.union = oa, Kn.unionBy = ia, Kn.unionWith = aa, Kn.uniq = function (e) {
              return e && e.length ? ho(e) : [];
            }, Kn.uniqBy = function (e, t) {
              return e && e.length ? ho(e, di(t, 2)) : [];
            }, Kn.uniqWith = function (e, t) {
              return t = "function" == typeof t ? t : o, e && e.length ? ho(e, o, t) : [];
            }, Kn.unset = function (e, t) {
              return null == e || fo(e, t);
            }, Kn.unzip = sa, Kn.unzipWith = la, Kn.update = function (e, t, n) {
              return null == e ? e : mo(e, t, xo(n));
            }, Kn.updateWith = function (e, t, n, r) {
              return r = "function" == typeof r ? r : o, null == e ? e : mo(e, t, xo(n), r);
            }, Kn.values = qs, Kn.valuesIn = function (e) {
              return null == e ? [] : Qt(e, Ms(e));
            }, Kn.without = ua, Kn.words = el, Kn.wrap = function (e, t) {
              return La(xo(t), e);
            }, Kn.xor = ca, Kn.xorBy = da, Kn.xorWith = pa, Kn.zip = ha, Kn.zipObject = function (e, t) {
              return bo(e || [], t || [], rr);
            }, Kn.zipObjectDeep = function (e, t) {
              return bo(e || [], t || [], to);
            }, Kn.zipWith = fa, Kn.entries = Vs, Kn.entriesIn = Ks, Kn.extend = Cs, Kn.extendWith = Ss, cl(Kn, Kn), Kn.add = wl, Kn.attempt = tl, Kn.camelCase = Hs, Kn.capitalize = Us, Kn.ceil = xl, Kn.clamp = function (e, t, n) {
              return n === o && (n = t, t = o), n !== o && (n = (n = bs(n)) == n ? n : 0), t !== o && (t = (t = bs(t)) == t ? t : 0), ur(bs(e), t, n);
            }, Kn.clone = function (e) {
              return cr(e, 4);
            }, Kn.cloneDeep = function (e) {
              return cr(e, 5);
            }, Kn.cloneDeepWith = function (e, t) {
              return cr(e, 5, t = "function" == typeof t ? t : o);
            }, Kn.cloneWith = function (e, t) {
              return cr(e, 4, t = "function" == typeof t ? t : o);
            }, Kn.conformsTo = function (e, t) {
              return null == t || dr(e, t, Fs(t));
            }, Kn.deburr = Zs, Kn.defaultTo = function (e, t) {
              return null == e || e != e ? t : e;
            }, Kn.divide = Dl, Kn.endsWith = function (e, t, n) {
              e = xs(e), t = po(t);
              var r = e.length,
                i = n = n === o ? r : ur(vs(n), 0, r);
              return (n -= t.length) >= 0 && e.slice(n, i) == t;
            }, Kn.eq = qa, Kn.escape = function (e) {
              return (e = xs(e)) && X.test(e) ? e.replace(W, on) : e;
            }, Kn.escapeRegExp = function (e) {
              return (e = xs(e)) && ie.test(e) ? e.replace(oe, "\\$&") : e;
            }, Kn.every = function (e, t, n) {
              var r = $a(e) ? At : gr;
              return n && Di(e, t, n) && (t = o), r(e, di(t, 3));
            }, Kn.find = ba, Kn.findIndex = Zi, Kn.findKey = function (e, t) {
              return Nt(e, di(t, 3), Dr);
            }, Kn.findLast = wa, Kn.findLastIndex = $i, Kn.findLastKey = function (e, t) {
              return Nt(e, di(t, 3), Cr);
            }, Kn.floor = Cl, Kn.forEach = xa, Kn.forEachRight = Da, Kn.forIn = function (e, t) {
              return null == e ? e : wr(e, di(t, 3), Ms);
            }, Kn.forInRight = function (e, t) {
              return null == e ? e : xr(e, di(t, 3), Ms);
            }, Kn.forOwn = function (e, t) {
              return e && Dr(e, di(t, 3));
            }, Kn.forOwnRight = function (e, t) {
              return e && Cr(e, di(t, 3));
            }, Kn.get = As, Kn.gt = Ha, Kn.gte = Ua, Kn.has = function (e, t) {
              return null != e && yi(e, t, Ar);
            }, Kn.hasIn = zs, Kn.head = Wi, Kn.identity = al, Kn.includes = function (e, t, n, r) {
              e = Wa(e) ? e : qs(e), n = n && !r ? vs(n) : 0;
              var o = e.length;
              return n < 0 && (n = wn(o + n, 0)), cs(e) ? n <= o && e.indexOf(t, n) > -1 : !!o && Vt(e, t, n) > -1;
            }, Kn.indexOf = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var o = null == n ? 0 : vs(n);
              return o < 0 && (o = wn(r + o, 0)), Vt(e, t, o);
            }, Kn.inRange = function (e, t, n) {
              return t = gs(t), n === o ? (n = t, t = 0) : n = gs(n), function (e, t, n) {
                return e >= xn(t, n) && e < wn(t, n);
              }(e = bs(e), t, n);
            }, Kn.invoke = Is, Kn.isArguments = Za, Kn.isArray = $a, Kn.isArrayBuffer = Ga, Kn.isArrayLike = Wa, Kn.isArrayLikeObject = Ya, Kn.isBoolean = function (e) {
              return !0 === e || !1 === e || os(e) && Pr(e) == w;
            }, Kn.isBuffer = Xa, Kn.isDate = Qa, Kn.isElement = function (e) {
              return os(e) && 1 === e.nodeType && !ss(e);
            }, Kn.isEmpty = function (e) {
              if (null == e) return !0;
              if (Wa(e) && ($a(e) || "string" == typeof e || "function" == typeof e.splice || Xa(e) || ps(e) || Za(e))) return !e.length;
              var t = vi(e);
              if (t == E || t == z) return !e.size;
              if (_i(e)) return !Br(e).length;
              for (var n in e) if (Re.call(e, n)) return !1;
              return !0;
            }, Kn.isEqual = function (e, t) {
              return Fr(e, t);
            }, Kn.isEqualWith = function (e, t, n) {
              var r = (n = "function" == typeof n ? n : o) ? n(e, t) : o;
              return r === o ? Fr(e, t, o, n) : !!r;
            }, Kn.isError = Ja, Kn.isFinite = function (e) {
              return "number" == typeof e && Zt(e);
            }, Kn.isFunction = es, Kn.isInteger = ts, Kn.isLength = ns, Kn.isMap = is, Kn.isMatch = function (e, t) {
              return e === t || Mr(e, t, hi(t));
            }, Kn.isMatchWith = function (e, t, n) {
              return n = "function" == typeof n ? n : o, Mr(e, t, hi(t), n);
            }, Kn.isNaN = function (e) {
              return as(e) && e != +e;
            }, Kn.isNative = function (e) {
              if (Ei(e)) throw new Se("Unsupported core-js use. Try https://npms.io/search?q=ponyfill.");
              return Rr(e);
            }, Kn.isNil = function (e) {
              return null == e;
            }, Kn.isNull = function (e) {
              return null === e;
            }, Kn.isNumber = as, Kn.isObject = rs, Kn.isObjectLike = os, Kn.isPlainObject = ss, Kn.isRegExp = ls, Kn.isSafeInteger = function (e) {
              return ts(e) && e >= -9007199254740991 && e <= f;
            }, Kn.isSet = us, Kn.isString = cs, Kn.isSymbol = ds, Kn.isTypedArray = ps, Kn.isUndefined = function (e) {
              return e === o;
            }, Kn.isWeakMap = function (e) {
              return os(e) && vi(e) == I;
            }, Kn.isWeakSet = function (e) {
              return os(e) && "[object WeakSet]" == Pr(e);
            }, Kn.join = function (e, t) {
              return null == e ? "" : yn.call(e, t);
            }, Kn.kebabCase = $s, Kn.last = Ji, Kn.lastIndexOf = function (e, t, n) {
              var r = null == e ? 0 : e.length;
              if (!r) return -1;
              var i = r;
              return n !== o && (i = (i = vs(n)) < 0 ? wn(r + i, 0) : xn(i, r - 1)), t == t ? function (e, t, n) {
                for (var r = n + 1; r--;) if (e[r] === t) return r;
                return r;
              }(e, t, i) : Lt(e, qt, i, !0);
            }, Kn.lowerCase = Gs, Kn.lowerFirst = Ws, Kn.lt = hs, Kn.lte = fs, Kn.max = function (e) {
              return e && e.length ? vr(e, al, kr) : o;
            }, Kn.maxBy = function (e, t) {
              return e && e.length ? vr(e, di(t, 2), kr) : o;
            }, Kn.mean = function (e) {
              return Ht(e, al);
            }, Kn.meanBy = function (e, t) {
              return Ht(e, di(t, 2));
            }, Kn.min = function (e) {
              return e && e.length ? vr(e, al, Lr) : o;
            }, Kn.minBy = function (e, t) {
              return e && e.length ? vr(e, di(t, 2), Lr) : o;
            }, Kn.stubArray = yl, Kn.stubFalse = bl, Kn.stubObject = function () {
              return {};
            }, Kn.stubString = function () {
              return "";
            }, Kn.stubTrue = function () {
              return !0;
            }, Kn.multiply = El, Kn.nth = function (e, t) {
              return e && e.length ? Ur(e, vs(t)) : o;
            }, Kn.noConflict = function () {
              return ht._ === this && (ht._ = Ve), this;
            }, Kn.noop = dl, Kn.now = Aa, Kn.pad = function (e, t, n) {
              e = xs(e);
              var r = (t = vs(t)) ? hn(e) : 0;
              if (!t || r >= t) return e;
              var o = (t - r) / 2;
              return $o(vt(o), n) + e + $o(mt(o), n);
            }, Kn.padEnd = function (e, t, n) {
              e = xs(e);
              var r = (t = vs(t)) ? hn(e) : 0;
              return t && r < t ? e + $o(t - r, n) : e;
            }, Kn.padStart = function (e, t, n) {
              e = xs(e);
              var r = (t = vs(t)) ? hn(e) : 0;
              return t && r < t ? $o(t - r, n) + e : e;
            }, Kn.parseInt = function (e, t, n) {
              return n || null == t ? t = 0 : t && (t = +t), Cn(xs(e).replace(ae, ""), t || 0);
            }, Kn.random = function (e, t, n) {
              if (n && "boolean" != typeof n && Di(e, t, n) && (t = n = o), n === o && ("boolean" == typeof t ? (n = t, t = o) : "boolean" == typeof e && (n = e, e = o)), e === o && t === o ? (e = 0, t = 1) : (e = gs(e), t === o ? (t = e, e = 0) : t = gs(t)), e > t) {
                var r = e;
                e = t, t = r;
              }
              if (n || e % 1 || t % 1) {
                var i = Sn();
                return xn(e + i * (t - e + ut("1e-" + ((i + "").length - 1))), t);
              }
              return Yr(e, t);
            }, Kn.reduce = function (e, t, n) {
              var r = $a(e) ? Mt : $t,
                o = arguments.length < 3;
              return r(e, di(t, 4), n, o, fr);
            }, Kn.reduceRight = function (e, t, n) {
              var r = $a(e) ? Rt : $t,
                o = arguments.length < 3;
              return r(e, di(t, 4), n, o, mr);
            }, Kn.repeat = function (e, t, n) {
              return t = (n ? Di(e, t, n) : t === o) ? 1 : vs(t), Xr(xs(e), t);
            }, Kn.replace = function () {
              var e = arguments,
                t = xs(e[0]);
              return e.length < 3 ? t : t.replace(e[1], e[2]);
            }, Kn.result = function (e, t, n) {
              var r = -1,
                i = (t = Do(t, e)).length;
              for (i || (i = 1, e = o); ++r < i;) {
                var a = null == e ? o : e[Li(t[r])];
                a === o && (r = i, a = n), e = es(a) ? a.call(e) : a;
              }
              return e;
            }, Kn.round = _l, Kn.runInContext = e, Kn.sample = function (e) {
              return ($a(e) ? Jn : Jr)(e);
            }, Kn.size = function (e) {
              if (null == e) return 0;
              if (Wa(e)) return cs(e) ? hn(e) : e.length;
              var t = vi(e);
              return t == E || t == z ? e.size : Br(e).length;
            }, Kn.snakeCase = Ys, Kn.some = function (e, t, n) {
              var r = $a(e) ? jt : ao;
              return n && Di(e, t, n) && (t = o), r(e, di(t, 3));
            }, Kn.sortedIndex = function (e, t) {
              return so(e, t);
            }, Kn.sortedIndexBy = function (e, t, n) {
              return lo(e, t, di(n, 2));
            }, Kn.sortedIndexOf = function (e, t) {
              var n = null == e ? 0 : e.length;
              if (n) {
                var r = so(e, t);
                if (r < n && qa(e[r], t)) return r;
              }
              return -1;
            }, Kn.sortedLastIndex = function (e, t) {
              return so(e, t, !0);
            }, Kn.sortedLastIndexBy = function (e, t, n) {
              return lo(e, t, di(n, 2), !0);
            }, Kn.sortedLastIndexOf = function (e, t) {
              if (null == e ? 0 : e.length) {
                var n = so(e, t, !0) - 1;
                if (qa(e[n], t)) return n;
              }
              return -1;
            }, Kn.startCase = Xs, Kn.startsWith = function (e, t, n) {
              return e = xs(e), n = null == n ? 0 : ur(vs(n), 0, e.length), t = po(t), e.slice(n, n + t.length) == t;
            }, Kn.subtract = Pl, Kn.sum = function (e) {
              return e && e.length ? Gt(e, al) : 0;
            }, Kn.sumBy = function (e, t) {
              return e && e.length ? Gt(e, di(t, 2)) : 0;
            }, Kn.template = function (e, t, n) {
              var r = Kn.templateSettings;
              n && Di(e, t, n) && (t = o), e = xs(e), t = Ss({}, t, r, ti);
              var i,
                a,
                s = Ss({}, t.imports, r.imports, ti),
                l = Fs(s),
                u = Qt(s, l),
                c = 0,
                d = t.interpolate || De,
                p = "__p += '",
                h = ke((t.escape || De).source + "|" + d.source + "|" + (d === ee ? fe : De).source + "|" + (t.evaluate || De).source + "|$", "g"),
                f = "//# sourceURL=" + (Re.call(t, "sourceURL") ? (t.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++it + "]") + "\n";
              e.replace(h, function (t, n, r, o, s, l) {
                return r || (r = o), p += e.slice(c, l).replace(Ce, an), n && (i = !0, p += "' +\n__e(" + n + ") +\n'"), s && (a = !0, p += "';\n" + s + ";\n__p += '"), r && (p += "' +\n((__t = (" + r + ")) == null ? '' : __t) +\n'"), c = l + t.length, t;
              }), p += "';\n";
              var m = Re.call(t, "variable") && t.variable;
              if (m) {
                if (pe.test(m)) throw new Se("Invalid `variable` option passed into `_.template`");
              } else p = "with (obj) {\n" + p + "\n}\n";
              p = (a ? p.replace(U, "") : p).replace(Z, "$1").replace($, "$1;"), p = "function(" + (m || "obj") + ") {\n" + (m ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (i ? ", __e = _.escape" : "") + (a ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + p + "return __p\n}";
              var g = tl(function () {
                return Ee(l, f + "return " + p).apply(o, u);
              });
              if (g.source = p, Ja(g)) throw g;
              return g;
            }, Kn.times = function (e, t) {
              if ((e = vs(e)) < 1 || e > f) return [];
              var n = g,
                r = xn(e, g);
              t = di(t), e -= g;
              for (var o = Wt(r, t); ++n < e;) t(n);
              return o;
            }, Kn.toFinite = gs, Kn.toInteger = vs, Kn.toLength = ys, Kn.toLower = function (e) {
              return xs(e).toLowerCase();
            }, Kn.toNumber = bs, Kn.toSafeInteger = function (e) {
              return e ? ur(vs(e), -9007199254740991, f) : 0 === e ? e : 0;
            }, Kn.toString = xs, Kn.toUpper = function (e) {
              return xs(e).toUpperCase();
            }, Kn.trim = function (e, t, n) {
              if ((e = xs(e)) && (n || t === o)) return Yt(e);
              if (!e || !(t = po(t))) return e;
              var r = fn(e),
                i = fn(t);
              return So(r, en(r, i), tn(r, i) + 1).join("");
            }, Kn.trimEnd = function (e, t, n) {
              if ((e = xs(e)) && (n || t === o)) return e.slice(0, mn(e) + 1);
              if (!e || !(t = po(t))) return e;
              var r = fn(e);
              return So(r, 0, tn(r, fn(t)) + 1).join("");
            }, Kn.trimStart = function (e, t, n) {
              if ((e = xs(e)) && (n || t === o)) return e.replace(ae, "");
              if (!e || !(t = po(t))) return e;
              var r = fn(e);
              return So(r, en(r, fn(t))).join("");
            }, Kn.truncate = function (e, t) {
              var n = 30,
                r = "...";
              if (rs(t)) {
                var i = "separator" in t ? t.separator : i;
                n = "length" in t ? vs(t.length) : n, r = "omission" in t ? po(t.omission) : r;
              }
              var a = (e = xs(e)).length;
              if (sn(e)) {
                var s = fn(e);
                a = s.length;
              }
              if (n >= a) return e;
              var l = n - hn(r);
              if (l < 1) return r;
              var u = s ? So(s, 0, l).join("") : e.slice(0, l);
              if (i === o) return u + r;
              if (s && (l += u.length - l), ls(i)) {
                if (e.slice(l).search(i)) {
                  var c,
                    d = u;
                  for (i.global || (i = ke(i.source, xs(me.exec(i)) + "g")), i.lastIndex = 0; c = i.exec(d);) var p = c.index;
                  u = u.slice(0, p === o ? l : p);
                }
              } else if (e.indexOf(po(i), l) != l) {
                var h = u.lastIndexOf(i);
                h > -1 && (u = u.slice(0, h));
              }
              return u + r;
            }, Kn.unescape = function (e) {
              return (e = xs(e)) && Y.test(e) ? e.replace(G, gn) : e;
            }, Kn.uniqueId = function (e) {
              var t = ++je;
              return xs(e) + t;
            }, Kn.upperCase = Qs, Kn.upperFirst = Js, Kn.each = xa, Kn.eachRight = Da, Kn.first = Wi, cl(Kn, (Sl = {}, Dr(Kn, function (e, t) {
              Re.call(Kn.prototype, t) || (Sl[t] = e);
            }), Sl), {
              chain: !1
            }), Kn.VERSION = "4.17.21", Pt(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function (e) {
              Kn[e].placeholder = Kn;
            }), Pt(["drop", "take"], function (e, t) {
              Zn.prototype[e] = function (n) {
                n = n === o ? 1 : wn(vs(n), 0);
                var r = this.__filtered__ && !t ? new Zn(this) : this.clone();
                return r.__filtered__ ? r.__takeCount__ = xn(n, r.__takeCount__) : r.__views__.push({
                  size: xn(n, g),
                  type: e + (r.__dir__ < 0 ? "Right" : "")
                }), r;
              }, Zn.prototype[e + "Right"] = function (t) {
                return this.reverse()[e](t).reverse();
              };
            }), Pt(["filter", "map", "takeWhile"], function (e, t) {
              var n = t + 1,
                r = 1 == n || 3 == n;
              Zn.prototype[e] = function (e) {
                var t = this.clone();
                return t.__iteratees__.push({
                  iteratee: di(e, 3),
                  type: n
                }), t.__filtered__ = t.__filtered__ || r, t;
              };
            }), Pt(["head", "last"], function (e, t) {
              var n = "take" + (t ? "Right" : "");
              Zn.prototype[e] = function () {
                return this[n](1).value()[0];
              };
            }), Pt(["initial", "tail"], function (e, t) {
              var n = "drop" + (t ? "" : "Right");
              Zn.prototype[e] = function () {
                return this.__filtered__ ? new Zn(this) : this[n](1);
              };
            }), Zn.prototype.compact = function () {
              return this.filter(al);
            }, Zn.prototype.find = function (e) {
              return this.filter(e).head();
            }, Zn.prototype.findLast = function (e) {
              return this.reverse().find(e);
            }, Zn.prototype.invokeMap = Qr(function (e, t) {
              return "function" == typeof e ? new Zn(this) : this.map(function (n) {
                return Or(n, e, t);
              });
            }), Zn.prototype.reject = function (e) {
              return this.filter(Ba(di(e)));
            }, Zn.prototype.slice = function (e, t) {
              e = vs(e);
              var n = this;
              return n.__filtered__ && (e > 0 || t < 0) ? new Zn(n) : (e < 0 ? n = n.takeRight(-e) : e && (n = n.drop(e)), t !== o && (n = (t = vs(t)) < 0 ? n.dropRight(-t) : n.take(t - e)), n);
            }, Zn.prototype.takeRightWhile = function (e) {
              return this.reverse().takeWhile(e).reverse();
            }, Zn.prototype.toArray = function () {
              return this.take(g);
            }, Dr(Zn.prototype, function (e, t) {
              var n = /^(?:filter|find|map|reject)|While$/.test(t),
                r = /^(?:head|last)$/.test(t),
                i = Kn[r ? "take" + ("last" == t ? "Right" : "") : t],
                a = r || /^find/.test(t);
              i && (Kn.prototype[t] = function () {
                var t = this.__wrapped__,
                  s = r ? [1] : arguments,
                  l = t instanceof Zn,
                  u = s[0],
                  c = l || $a(t),
                  d = function (e) {
                    var t = i.apply(Kn, Ft([e], s));
                    return r && p ? t[0] : t;
                  };
                c && n && "function" == typeof u && 1 != u.length && (l = c = !1);
                var p = this.__chain__,
                  h = !!this.__actions__.length,
                  f = a && !p,
                  m = l && !h;
                if (!a && c) {
                  t = m ? t : new Zn(this);
                  var g = e.apply(t, s);
                  return g.__actions__.push({
                    func: ga,
                    args: [d],
                    thisArg: o
                  }), new Un(g, p);
                }
                return f && m ? e.apply(this, s) : (g = this.thru(d), f ? r ? g.value()[0] : g.value() : g);
              });
            }), Pt(["pop", "push", "shift", "sort", "splice", "unshift"], function (e) {
              var t = Te[e],
                n = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru",
                r = /^(?:pop|shift)$/.test(e);
              Kn.prototype[e] = function () {
                var e = arguments;
                if (r && !this.__chain__) {
                  var o = this.value();
                  return t.apply($a(o) ? o : [], e);
                }
                return this[n](function (n) {
                  return t.apply($a(n) ? n : [], e);
                });
              };
            }), Dr(Zn.prototype, function (e, t) {
              var n = Kn[t];
              if (n) {
                var r = n.name + "";
                Re.call(In, r) || (In[r] = []), In[r].push({
                  name: t,
                  func: n
                });
              }
            }), In[qo(o, 2).name] = [{
              name: "wrapper",
              func: o
            }], Zn.prototype.clone = function () {
              var e = new Zn(this.__wrapped__);
              return e.__actions__ = Oo(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = Oo(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = Oo(this.__views__), e;
            }, Zn.prototype.reverse = function () {
              if (this.__filtered__) {
                var e = new Zn(this);
                e.__dir__ = -1, e.__filtered__ = !0;
              } else (e = this.clone()).__dir__ *= -1;
              return e;
            }, Zn.prototype.value = function () {
              var e = this.__wrapped__.value(),
                t = this.__dir__,
                n = $a(e),
                r = t < 0,
                o = n ? e.length : 0,
                i = function (e, t, n) {
                  var r = -1,
                    o = n.length;
                  for (; ++r < o;) {
                    var i = n[r],
                      a = i.size;
                    switch (i.type) {
                      case "drop":
                        e += a;
                        break;
                      case "dropRight":
                        t -= a;
                        break;
                      case "take":
                        t = xn(t, e + a);
                        break;
                      case "takeRight":
                        e = wn(e, t - a);
                    }
                  }
                  return {
                    start: e,
                    end: t
                  };
                }(0, o, this.__views__),
                a = i.start,
                s = i.end,
                l = s - a,
                u = r ? s : a - 1,
                c = this.__iteratees__,
                d = c.length,
                p = 0,
                h = xn(l, this.__takeCount__);
              if (!n || !r && o == l && h == l) return vo(e, this.__actions__);
              var f = [];
              e: for (; l-- && p < h;) {
                for (var m = -1, g = e[u += t]; ++m < d;) {
                  var v = c[m],
                    y = v.iteratee,
                    b = v.type,
                    w = y(g);
                  if (2 == b) g = w;else if (!w) {
                    if (1 == b) continue e;
                    break e;
                  }
                }
                f[p++] = g;
              }
              return f;
            }, Kn.prototype.at = va, Kn.prototype.chain = function () {
              return ma(this);
            }, Kn.prototype.commit = function () {
              return new Un(this.value(), this.__chain__);
            }, Kn.prototype.next = function () {
              this.__values__ === o && (this.__values__ = ms(this.value()));
              var e = this.__index__ >= this.__values__.length;
              return {
                done: e,
                value: e ? o : this.__values__[this.__index__++]
              };
            }, Kn.prototype.plant = function (e) {
              for (var t, n = this; n instanceof Hn;) {
                var r = Ki(n);
                r.__index__ = 0, r.__values__ = o, t ? i.__wrapped__ = r : t = r;
                var i = r;
                n = n.__wrapped__;
              }
              return i.__wrapped__ = e, t;
            }, Kn.prototype.reverse = function () {
              var e = this.__wrapped__;
              if (e instanceof Zn) {
                var t = e;
                return this.__actions__.length && (t = new Zn(this)), (t = t.reverse()).__actions__.push({
                  func: ga,
                  args: [ra],
                  thisArg: o
                }), new Un(t, this.__chain__);
              }
              return this.thru(ra);
            }, Kn.prototype.toJSON = Kn.prototype.valueOf = Kn.prototype.value = function () {
              return vo(this.__wrapped__, this.__actions__);
            }, Kn.prototype.first = Kn.prototype.head, et && (Kn.prototype[et] = function () {
              return this;
            }), Kn;
          }();
          ht._ = vn, (r = function () {
            return vn;
          }.call(t, n, t, e)) === o || (e.exports = r);
        }.call(this);
      },
      7771: (e, t, n) => {
        var r = n(55639);
        e.exports = function () {
          return r.Date.now();
        };
      },
      95062: e => {
        e.exports = function () {
          return !1;
        };
      },
      23493: (e, t, n) => {
        var r = n(23279),
          o = n(13218);
        e.exports = function (e, t, n) {
          var i = !0,
            a = !0;
          if ("function" != typeof e) throw new TypeError("Expected a function");
          return o(n) && (i = "leading" in n ? !!n.leading : i, a = "trailing" in n ? !!n.trailing : a), r(e, t, {
            leading: i,
            maxWait: t,
            trailing: a
          });
        };
      },
      14841: (e, t, n) => {
        var r = n(27561),
          o = n(13218),
          i = n(33448),
          a = /^[-+]0x[0-9a-f]+$/i,
          s = /^0b[01]+$/i,
          l = /^0o[0-7]+$/i,
          u = parseInt;
        e.exports = function (e) {
          if ("number" == typeof e) return e;
          if (i(e)) return NaN;
          if (o(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = o(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = r(e);
          var n = s.test(e);
          return n || l.test(e) ? u(e.slice(2), n ? 2 : 8) : a.test(e) ? NaN : +e;
        };
      },
      30845: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => i
        });
        var r = Number.isNaN || function (e) {
          return "number" == typeof e && e != e;
        };
        function o(e, t) {
          if (e.length !== t.length) return !1;
          for (var n = 0; n < e.length; n++) if (o = e[n], i = t[n], !(o === i || r(o) && r(i))) return !1;
          var o, i;
          return !0;
        }
        function i(e, t) {
          void 0 === t && (t = o);
          var n = null;
          function r() {
            for (var r = [], o = 0; o < arguments.length; o++) r[o] = arguments[o];
            if (n && n.lastThis === this && t(r, n.lastArgs)) return n.lastResult;
            var i = e.apply(this, r);
            return n = {
              lastResult: i,
              lastArgs: r,
              lastThis: this
            }, i;
          }
          return r.clear = function () {
            n = null;
          }, r;
        }
      },
      37672: e => {
        e.exports = {
          general: "PSPDFKit-au2y6ump4kfh59dxhzebebxuk",
          default: "PSPDFKit-rnby3kbjng3wxrprufma34mec",
          primary: "PSPDFKit-2pntgtgpg8fsv3qg8w5fqacy4h",
          disabled: "PSPDFKit-8gpjtx5az7b1eem7nk5gvydakg",
          inverted: "PSPDFKit-268tqp6xe3scp42vzy5s2eg3gw",
          danger: "PSPDFKit-948yzas5m1v89qgwznr168uzt",
          group: "PSPDFKit-3k3q1afeauc3dkyydsfhd7rcnf",
          groupAlignStart: "PSPDFKit-5rgcz4b9h8c8cna578xznnvwj9",
          groupAlignEnd: "PSPDFKit-7hx4xwaavengsmnusu1bgqjqxm",
          groupSpacer: "PSPDFKit-5s4by7ab9qyy27f25vvhggw9a1"
        };
      },
      7232: e => {
        e.exports = {
          controlButton: "PSPDFKit-2vhjpczqartzetc7h7a1xe2swv",
          contentHidden: "PSPDFKit-2nr4hbrfacpy6asgcy579kavvy",
          wrapper: "PSPDFKit-54fzg7z8tvnck7852u5y8tje7y",
          pickerWidget: "PSPDFKit-6e5m92eu677mvmp8771tt8vjp4",
          picker: "PSPDFKit-4z6z5fvcvgzmwxqzw9312q7pbd",
          firefoxDatePicker: "PSPDFKit-ggstmpcjv8fc924cxp4hqu6cx"
        };
      },
      19290: e => {
        e.exports = {
          center: "PSPDFKit-38tjaczw7mwm22y3raq5wmyy1j"
        };
      },
      5612: e => {
        e.exports = {
          label: "PSPDFKit-4x5dznaux2fnhttuhjv8qpnrxj",
          root: "PSPDFKit-79691ssynn76fuqcjks69dk3ms",
          input: "PSPDFKit-7sgqtcguswky89v7b7fn8q2nc4"
        };
      },
      81454: e => {
        e.exports = {
          container: "PSPDFKit-8gjpn8p7xvprbe81bs4qegz9b5",
          dragPreview: "PSPDFKit-49jnx4hscrumgdkjrg64zuk14q",
          item: "PSPDFKit-7ax9upudu4ydm6jd89kdj7c6yp",
          content: "PSPDFKit-2x9bkxefr59ns3waswhn3y72cg"
        };
      },
      78599: e => {
        e.exports = {};
      },
      58729: e => {
        e.exports = {
          wrapper: "PSPDFKit-65g4dzzwf1baxctk21rdyms5mr",
          trigger: "PSPDFKit-8argm94ptuprgj7y3vhw6dr8au",
          triggerNative: "PSPDFKit-8bsn2442emy52wh8sckmyyq3b6",
          triggerIcon: "PSPDFKit-4e1fn8va5ecagrevznyumqpt8k",
          content: "PSPDFKit-5mvfn68qgpc7atqubnfuc3f4b4",
          contentNative: "PSPDFKit-8bk7wp33b8n1aehgs8mmv32j4t",
          item: "PSPDFKit-399auf99f4y73aujcw9743yw3g",
          checkboxItem: "PSPDFKit-59ey17e4mhkgymzb2eu552tv9e",
          itemCheckmark: "PSPDFKit-6pvqs8xmu549e8xwas52rsdn3a",
          separatorItem: "PSPDFKit-23nsg5e8wvhgwkuwtf7s7yajjk",
          itemNative: "PSPDFKit-7hgwsfrfptbsjff1w8wp3vs3fh",
          itemHelperText: "PSPDFKit-8319n6q61cgvbywqraddyzzq4g"
        };
      },
      23629: e => {
        e.exports = {
          richTextEditor: "PSPDFKit-5dmn7sg6ek1rhdxkvkqcbqh9k",
          wrapper: "PSPDFKit-5uzk3qfr7fcvb4g9gra8chacg8"
        };
      },
      7764: e => {
        e.exports = {
          controlButton: "PSPDFKit-4nwgurkrevp1yuf43kw3pw6n4x",
          contentHidden: "PSPDFKit-617nrrn3mfmnddnq1twgtfg8r6"
        };
      },
      90315: e => {
        e.exports = {
          wrapper: "PSPDFKit-2sdtmn12dteusjwrjqrdg811d9"
        };
      },
      35840: e => {
        e.exports = {
          dialog: "PSPDFKit-72w9tuwnjsamr2knxvc63vmsar",
          squareCorners: "PSPDFKit-4xwm59bykq6v7gwcyxwek1ydrn",
          backdropContainer: "PSPDFKit-3284fys8g583pzu3bk5ga8zefu",
          backdropFixed: "PSPDFKit-6hden7azu9tyt1ymku7cdkfkat",
          section: "PSPDFKit-7765ngjsv6cemmhcayzhemjc2z",
          divider: "PSPDFKit-3mw4zj9p2e4tyy78h5yqq4qax7",
          dividerSpaced: "PSPDFKit-47ev9d7dyk4ccum2tcjz3a3r35",
          sectionSpaced: "PSPDFKit-z6uw3esrcxb9v43jgpz5fvnmt",
          shaking: "PSPDFKit-38d49zqp894x7hvhpr4zu4cbhn",
          shake: "PSPDFKit-73sp85tuvq7xtryqz19u273z9z"
        };
      },
      64550: e => {
        e.exports = {
          progress: "PSPDFKit-7ed17gy5t5hdnc4rekhbhwue9z",
          appear: "PSPDFKit-28ac9mfnscmu7fw7gy316sv7bn",
          progressBar: "PSPDFKit-35yq8vgyqdkq1cwb6v94z64det",
          progressFill: "PSPDFKit-4dwvz8ana6tddzhfs85f6mnnp8",
          progressText: "PSPDFKit-c8eg9u7nftba2p6d1jj8d8kzb",
          loader: "PSPDFKit-7ndmeze8gd8de3z4btdkfg1dtd",
          loaderDot: "PSPDFKit-3kawgqfqrbzkay9qu26fpcdsef",
          loading: "PSPDFKit-58k69thdd3ken25z2cjaqd7zx3"
        };
      },
      47963: e => {
        e.exports = {
          radioGroup: "PSPDFKit-f9rncje5vypsb5267rnrdcs85",
          iconLabel: "PSPDFKit-3uur2bmk3hqenhtsm6vtpkds4a",
          iconLabelIsActive: "PSPDFKit-6xcnmm7jxc3re1cmuv5z4j6sk7",
          icon: "PSPDFKit-8c6mhtrbbsa2js16uaq25bwfa1",
          selectedLabel: "PSPDFKit-7xbq3geyeftt96vccbps1yn6n7",
          radioGroupLabel: "PSPDFKit-6d1dypxk3mwh24wj647gqjdppa",
          fullWidthRadio: "PSPDFKit-4psvp5qh3p6sm4qkr5q2ax9kw5",
          radioGroupIcon: "PSPDFKit-57yjxnefe1fy6tdx3g76jf6qzv"
        };
      },
      24470: e => {
        e.exports = {
          default: "PSPDFKit-38cjpvxsadupm25h2qyxa7n5gd",
          error: "PSPDFKit-6x4yhy9ph7pfrk6h8kw9utwu6",
          success: "PSPDFKit-2ymexjhtn4dy2ktzjafxvn4mcm"
        };
      },
      8134: e => {
        e.exports = {
          h1: "PSPDFKit-8t7e487v5yhvt5nw4msux95yx4",
          p: "PSPDFKit-4u8kmkyf5hdjhe4qvnt5a975a7"
        };
      },
      70118: e => {
        e.exports = {};
      },
      92619: e => {
        e.exports = {
          treeView: "PSPDFKit-ydd8cegvmd6regsgpmcgpjavb",
          textWithOverflowEllipsis: "PSPDFKit-5ut2mzy5pm9dnbz7ja1zst4yn2",
          title: "PSPDFKit-2rfzkq6tdmadkygrfktbk5dv6h",
          treeItemContainer: "PSPDFKit-4fvzv33kkp5365eup7k2z8g2uv",
          treeItem: "PSPDFKit-54acf21hdpzkaxsw4swhxn23be",
          notLocked: "PSPDFKit-2n4dy8ne2zanmq1sp3a24av7j1",
          selected: "PSPDFKit-4674xx3wq5atu14x3amc4taev3",
          childRoot: "PSPDFKit-41pkx32asvdjt6wkzw79g1wrxz",
          "icon-eye-open": "PSPDFKit-6uas11jy8s88sc3e3ya6z8ud3d",
          hiddenChildRoot: "PSPDFKit-8f8u5sdz1zn1xx15x5czq3f5rq",
          list: "PSPDFKit-6928zz3253n8zmwwxzbfm4gnar",
          visibilityIcon: "PSPDFKit-86gcd8xxhutnfcqpteyvv1y3e",
          itemContainer: "PSPDFKit-bxggf97x1sqaeqjt8fdxsymen",
          icon: "PSPDFKit-4m2n36dgsyk38wswut9tppx4cd",
          arrowIcon: "PSPDFKit-37j14254rfgde16q2ndmgytjqd",
          hidden: "PSPDFKit-55tte6ysse2zym23stes4hx5u7",
          iconContainer: "PSPDFKit-7r73uu3zuph6p89dbz5hjwb15k",
          itemContainerWithChildren: "PSPDFKit-kqc5fs14zg179hps3hqywya7s",
          noOcgId: "PSPDFKit-7gya8mn8mystvwa3qb5te8k64b",
          visibilityIconLocked: "PSPDFKit-8j6zbad6ngwwmbuncnzs1pnhp6"
        };
      },
      42164: e => {
        e.exports = {
          visuallyHidden: "PSPDFKit-8aptmp24g12z3cd4gbhkz59kk"
        };
      },
      11147: e => {
        e.exports = {
          container: "PSPDFKit-37y8jyguj8pacvfe5xhztdrrvh",
          hoverContainer: "PSPDFKit-5wkfpeyned7c4yt1mthjm2byaz",
          innerHoverContainer: "PSPDFKit-273bhz15uvme1jcsnfahrnpqhm",
          innerContainer: "PSPDFKit-6c7xfncwch6xyvu2c9ht4628jr",
          title: "PSPDFKit-7pv18yphuz8xnmy775ru1vhcxe",
          label: "PSPDFKit-35atxysv8qfd3f8r6vuxhqfqdg",
          content: "PSPDFKit-3771qspwv8ehjtp2dy2fzju48j",
          contentRow: "PSPDFKit-2yrnzfc2gx8w1fwmkqaw1avw1e",
          radioGroupWrapper: "PSPDFKit-88mdrcgzvp2729thzbev99hpvr"
        };
      },
      66780: e => {
        e.exports = {
          wrapper: "PSPDFKit-3g9zhcucr422ntc7f1j5r7d642",
          handles: "PSPDFKit-5jju3cq115q7jyhsr5tbbc9k5v",
          handleBottom: "PSPDFKit-7crnzth1tunbc1y11dsmm25d3d",
          handleTop: "PSPDFKit-6jhwapspg9juffwvb74ngnheyk",
          vertical: "PSPDFKit-72wh5syb1qx2wkvnqjh2ts7ghz",
          handleLeft: "PSPDFKit-3532cjnqew5bhzac79j6tsgba9",
          handleRight: "PSPDFKit-2mzfwjn4a49rq62m884wpsqvwe",
          horizontal: "PSPDFKit-4xstjgjt6yzwy52577u1uxmq58",
          handleTopLeft: "PSPDFKit-75mze7fkqv4saep8aun4y1qf7n",
          handleTopRight: "PSPDFKit-q2hk1mcaqqvf11djfan91yrhz",
          handleBottomLeft: "PSPDFKit-7w3jyr3yvfr7hpbmmha8uc2wr7",
          handleBottomRight: "PSPDFKit-3n3x1jyrwpd789w22qhc6nrscf",
          cropBox: "PSPDFKit-7mmux7swq1uq9t5m59se9qu3u4"
        };
      },
      74268: e => {
        e.exports = {
          wrapper: "PSPDFKit-5eynqxckhbqrz8a4f77yujbh2k",
          tooltipFont: "PSPDFKit-42pbth2eu2zrmgpae4jhg6h8en",
          arrow: "PSPDFKit-6nx2uf6vhf6v33bnb1j4ganvvd"
        };
      },
      89306: e => {
        e.exports = {
          textBlock: "PSPDFKit-nxtuykwdsyjh6y7z8brn21b7",
          activeTextBlock: "PSPDFKit-7qanggak6kh1whzh64vrkx4krz",
          focusIn: "PSPDFKit-6jc5m1b3ck8fqehqqd9b7th6gt",
          movingTextBlock: "PSPDFKit-7mzzrbnpvegtq3qm6jswkervc3",
          selectedTextBlock: "PSPDFKit-f7jcky6yaxh4m5617uaekk3cj",
          tooltipButton: "PSPDFKit-3mngkstqybyrr7k8f5kgqf5ksn",
          tooltipSVG: "PSPDFKit-7eywttjpush5dwpejjm2b1edg3",
          blinkingCaret: "PSPDFKit-4tgb9n39czt6qk8ajacqjv5xdj",
          blinkEffect: "PSPDFKit-7kwgpn262dubfp6s5nxvyrt295",
          resizeHandle: "PSPDFKit-7mpkqw7nbbw6tju4s46mm141sc",
          resizeHandleCircle: "PSPDFKit-3wksyn2d8kqsw1kg6b3vqztpfr",
          resizeHandleRight: "PSPDFKit-2dv6u2bf1w5g4e17qeenc78qhu",
          resizeHandleLeft: "PSPDFKit-4fvhxnqd5sg3bad4pr5gsqshv2"
        };
      },
      50439: e => {
        e.exports = {
          label: "PSPDFKit-5w3r6933jce2abq346fpwgue51",
          input: "PSPDFKit-45ug7rn2wuu9n7de4t3y1vuqwa"
        };
      },
      86378: e => {
        e.exports = {
          wrapper: "PSPDFKit-9kt28ket9qkhevfbz7cbbw1hb",
          controlContent: "PSPDFKit-4qbtrs7uku7m1vc5hra33bpuyg",
          icon: "PSPDFKit-3wag8ffkyv8h2tybvhe7amk9nm",
          content: "PSPDFKit-5sx5qx4udha76yjmqjkh932ffg"
        };
      },
      17777: e => {
        e.exports = {
          wrapper: "PSPDFKit-5ndr2a8v593wmzbkugj7mhpkx6",
          title: "PSPDFKit-8a1r68duucnwazuve1yp3nbng9",
          option: "PSPDFKit-4wma8z492shc4ep1hmy6t4vqut",
          icon: "PSPDFKit-4tmeja8e4gtumrdf83gvhyrcc4",
          button: "PSPDFKit-2ajb1c5391tmr11mqhaytx273m",
          optionContent: "PSPDFKit-42c2zme6zggmdzdxcpyafgegx3",
          deleteButton: "PSPDFKit-4muygv9es2v72qv85d9qdw6e96",
          deleteIcon: "PSPDFKit-7qr7fr949c5zy3chtgst1aqgnh",
          addOptionButton: "PSPDFKit-2ds9qudjp9zf1adda74rdu1zrf",
          addOptionInputWrapper: "PSPDFKit-4h68nb316qa6qx4sztcx3gjhnt",
          addOptionInput: "PSPDFKit-7squ9wp4ashk5qmgwbchusb3aq",
          hamburger: "PSPDFKit-62ry3uufpzt87bj49pdg2g3nbm",
          preview: "PSPDFKit-35d4wvwwd43nxvufv3g9vaexbe",
          invalidOptionInput: "PSPDFKit-2qjmywkp4vpcrjshnshk8bang7",
          addOptionInputWrapperInvalid: "PSPDFKit-2jz3pq39c872g9k317nqj88ts4"
        };
      },
      30549: e => {
        e.exports = {
          item: "PSPDFKit-6zammky19ps21racepzhy8rr4j",
          itemIcon: "PSPDFKit-2973scygnut2d1y23dq3gdzwkg",
          itemLabel: "PSPDFKit-257gq35az6dtxxmtvu6h8s17rt",
          advancedItemLabel: "PSPDFKit-4jkuv1k2kb5b4d6b929psybced",
          colorDropdown: "PSPDFKit-5n1c5d9upb23g6mdj3vrzdqj7c",
          colorDropdownMenu: "PSPDFKit-78jtbtb2j2q11tpjx4jn1wvwvk",
          sliderDropdown: "PSPDFKit-6s5q3xcggvrp6jet4dfsc14pgv",
          colorSvg: "PSPDFKit-6gk4p1adjfr1kg7hjpk3dgvtwc",
          colorItem: "PSPDFKit-4eqdajsqgt941vw7crd9u82kmt",
          nativeDropdown: "PSPDFKit-837ytb7vykc59sv5yrbgvzw1yp",
          dropdownGroupComponent: "PSPDFKit-6u23tbh3mu8cm8awxqyzn1zyru",
          dropdownGroupMenu: "PSPDFKit-5rw15mhzf9ycre4r1g7q2ptv9h",
          selectBox: "PSPDFKit-3691qqtsdq1317y5z7k3ak5jgk",
          advancedItem: "PSPDFKit-68nrp97epj74ah3dwvjg79nfmr",
          advancedItemValue: "PSPDFKit-5fqyghhu3ajdj6t464j4ufdk6q",
          radioButtonWarning: "PSPDFKit-7qt3uxz4r5wpssw2bbe778ga4g",
          radioButtonWarningIcon: "PSPDFKit-edsr1ac3tdhjwcufzhwq9jz98",
          radioButtonWarningLabel: "PSPDFKit-8fdb8fsm3rux9gpz8ggdyhhsyb",
          formFieldNameReadOnly: "PSPDFKit-71h65asx9k85mdns4n8j2kt3ag",
          inputReadOnly: "PSPDFKit-8drrc5pnvxucen4e82mywhscj3",
          lastInputField: "PSPDFKit-6eg6h7jnq9b1wjwv6kf3eqsd7b",
          footerButton: "PSPDFKit-7kqbgjh4u33aw27zwkrtu57p2e",
          deleteButton: "PSPDFKit-68w1xn1tjp178f46bwdhvjg7f1",
          doneButton: "PSPDFKit-8jb23wpy76fvg2x2vsvwy4rwvx"
        };
      },
      8643: e => {
        e.exports = {
          wrapper: "PSPDFKit-4q6rf47rhqhrpm9gdfefxt7qxa",
          label: "PSPDFKit-nt12adttbyb52awsgj2pvucxy",
          dateSelect: "PSPDFKit-3wx3w3pvjj3upy6569x74y56pt",
          formatSelect: "PSPDFKit-gcyutzqwxqe8x4u9j7mbfz1ub",
          input: "PSPDFKit-3yju2u277834cy3gahr2r5pxwa",
          inputError: "PSPDFKit-42bq6cs954sqg5h9qybewg7j71",
          errorLabel: "PSPDFKit-m39r8ehbhmf2d2t2fhn5emy6h",
          formatSelectWrapper: "PSPDFKit-ef4eqctrqnwdwaphd17x3zhbd",
          disabled: "PSPDFKit-u8tjzsmapgm69zq2qzyaxhxkn"
        };
      },
      96213: e => {
        e.exports = {
          wrapper: "PSPDFKit-21tdya9vwjkb9467d89dpj3dz5",
          guide: "PSPDFKit-6hysu1r6uydnrqrhfk1pps1pr8",
          hGuide: "PSPDFKit-7dhdpumpuhp8jg295a51ffsd9j",
          vGuide: "PSPDFKit-8csd1vhppnqgu7uyk8b5mf7czf",
          buttonWidget: "PSPDFKit-68un8hbc6qvj9x9s9g5q6t21ve",
          checkboxWidget: "PSPDFKit-5ah6dzjmznmmkdumesdneq7wz7",
          comboBoxWidget: "PSPDFKit-6fnpakckpk47tsnm8uz3m17u6y",
          dateWidget: "PSPDFKit-4yuxudxn8gpqg5ask3mtg2zakk",
          listBoxWidget: "PSPDFKit-51yew4ehdjn7cbsyfq5njb69ma",
          radioWidget: "PSPDFKit-41fvab9cypgzqfakdc8v95dcb3",
          signWidget: "PSPDFKit-7w2dawdet2j2kdxg5sat88d5bq",
          textWidget: "PSPDFKit-ecnxn5u4wzb7hzydwhayukxj",
          widgets: "PSPDFKit-737nkwy7w9s6vc4dtbb23bs54a"
        };
      },
      11568: e => {
        e.exports = {
          hintLineSvg: "PSPDFKit-34rw6dd52chrrk7xv2jr6zquew",
          line: "PSPDFKit-3eg3ptc58eu1dbczvddeqqmn75"
        };
      },
      37253: e => {
        e.exports = {
          root: "PSPDFKit-6eekmx2r3rzpn49557vdt2e5tj"
        };
      },
      44380: e => {
        e.exports = {
          colorDeleteButton: "PSPDFKit-996xvngvf7q6px5aesbyjcvt5",
          colorItemContainer: "PSPDFKit-43z4uam4dc2twts8dzzjr863sc"
        };
      },
      8087: e => {
        e.exports = {
          root: "PSPDFKit-8yyas95udks18p394fepzz4n9c",
          expanded: "PSPDFKit-4a4w8vxdz3qm2pcgsdreydv72t",
          content: "PSPDFKit-4xrf431ss37nqh76k5db3ja96w",
          left: "PSPDFKit-7s5tce8pp2hsk5huzfuxez1gr9",
          right: "PSPDFKit-53fgdvrhz6gw1hw6bdctgq1t9y",
          mobileTextMarkup: "PSPDFKit-5cjsnmyjcke6b1v12yfgbz41gg",
          stickToBottom: "PSPDFKit-6kfdt35ea6cx8yeepx58n36vmj",
          fixedHeight: "PSPDFKit-5f5bztx4e8cyvfqegfp7b8wthw",
          control: "PSPDFKit-443h9wb93vz3ncxwx1m5fdwczf",
          selectBox: "PSPDFKit-7m8dfjh7avxk6eweakkjyh6xyd",
          textFormatControls: "PSPDFKit-713qj5u5gbp169rww4vvs3uac",
          controlWrapper: "PSPDFKit-4h4nb13c68hupg148pgyvzqd9f",
          controlWrapperAutoWidth: "PSPDFKit-6xaanvujukmusu5r1tv594b12u",
          separator: "PSPDFKit-3vb4yamdnmg7g9xnhd6yk22phr",
          form: "PSPDFKit-4cdb93w5e9ug2gjhtp66ummy9y",
          formGroup: "PSPDFKit-5wuw8bj8khzgeg84fnwh7kh6sn",
          button: "PSPDFKit-nwjc4czbh63dp4kvymek1fa3e",
          rotateButton: "PSPDFKit-sja59fxys18kkmu18xy6hph1s",
          measurementToolbarButton: "PSPDFKit-c3779mg2s6295w7bzec9269ub",
          iconOnlyMobile: "PSPDFKit-3xypkvwg7p8nvzw3r5s1buz9ej",
          blendModeSelect: "PSPDFKit-7gmgduz1enf1gxbhyfgf6e75hf",
          fontFamilySelect: "PSPDFKit-5r3wt2zcuevj4sv3duqd61jwmv",
          fontSizeSelect: "PSPDFKit-6wmznmmpnx14v21nf84mdrgcjn",
          colorSelect: "PSPDFKit-s6seujr5t4rukk7rxf3xkz55e",
          endLineCapSelect: "PSPDFKit-3g7scgbk9uy7r46ajp7k1jjfbv",
          startLineCapSelect: "PSPDFKit-4h8xfhv4hcmbz7pprrj5g8dddv",
          strokeDashArraySelect: "PSPDFKit-c55swym84na3uj8cbws3nfkvk",
          colorSelectButton: "PSPDFKit-7eqxqzsm46bunvt6wn6a96cph7",
          controlIsDisabled: "PSPDFKit-54dwj7qcngkpxsybb6fqkr7y51",
          textAnnotationOpacitySlider: "PSPDFKit-2mcx41qn64buedadzqmun4x439",
          annotationNoteButton: "PSPDFKit-8ax4j3a47u9hsgjmxfqh4s4b59",
          deleteButton: "PSPDFKit-64vjbtpmt1hrduq893ygvk8vse",
          buttonNoBorder: "PSPDFKit-v8tqx1qvfp1vbwuttpp622dr3",
          noteIconLabel: "PSPDFKit-4cag238pz8y3y7dh5jbngjmrzs",
          applyRedactionsButton: "PSPDFKit-2hdx47smz78g3s16p3r4j4dgty",
          formDesignerButton: "PSPDFKit-2annhwtak67ncv4t85ctg2y3mz",
          isActive: "PSPDFKit-2vn1euub4mwbphwqwgfs1891h9",
          disableEditing: "PSPDFKit-p1au3zb7x12z2rhdhxt23urrf",
          disabledButton: "PSPDFKit-3jfra6hbvv4uav6ycenbqaya53",
          icon: "PSPDFKit-4qyrxjw4v89xuqdkqa4k8ztzzu",
          focusRing: "PSPDFKit-21r1nktvgb352rd4c4yy57pz9g",
          fontFamily: "PSPDFKit-7gzw1kmadbfq1tnmw7d1w7zxd1",
          dropdownMenu: "PSPDFKit-3ytv364gpnrm7x19bnbmeyg8f8",
          warningButton: "PSPDFKit-46sarmfrc8jg6s66bqgfefbjjh",
          warningButtonIcon: "PSPDFKit-4zhmsmuwkhtpwtruurtrcn2q8j",
          radioButtonWarningLabel: "PSPDFKit-54kg6hjakpubj7vt368nk674tz",
          colorPickerDropdownMenu: "PSPDFKit-2nazf4z9xd7xjtyhnbhe7rqgep",
          colorItem: "PSPDFKit-2kf3vca84fgs4vq9s7zs1gpcmp",
          deleteButtonIsVisibleInTouchDevices: "PSPDFKit-8gqc3tnvh9jka9muq4a9t5ahej",
          colorSvg: "PSPDFKit-5c7qnuw3hacprzg2xwyca31kpu",
          lineCapsDashArrayMenu: "PSPDFKit-46k4525rumt3dyxruh7yn6ftbe",
          strokeDashArrayMenu: "PSPDFKit-2ujy7afe1awfhuh9ymbm6bme7t",
          nativeDropdown: "PSPDFKit-4prbc6dhxp9ma6y7x5bw6vwpyu",
          fontFamilyNativeFlexbox: "PSPDFKit-2kq3mk8tfsg87ukm5zvcxchay3",
          fontSizeNativeFlexbox: "PSPDFKit-77brcq5bxx44kv6p84cffgnrfh",
          fontColorControl: "PSPDFKit-5frf4ykayzzn33hp3c5h7em7an",
          overlayTextInput: "PSPDFKit-2skb7mhe9t63pg2ukxcsw49xsr",
          overlayTextMargin: "PSPDFKit-3rsn1zkbd3dgwrjegb8g9hvhhg",
          groupWrapper: "PSPDFKit-2jq33zcqjvm19mjme567rvfrrm",
          groupDescription: "PSPDFKit-3xk6qkbjafwv7228ck9bx347w6",
          overlayInput: "PSPDFKit-7jwg5rgcerucffvtbsmxvfb7zk",
          radioInput: "PSPDFKit-4e75mg661j3ax96qwbdmpzpsb4",
          applyRedactionsWrapper: "PSPDFKit-2u9q2pe1ftds2f7qj2g4w622vw",
          customIconSvg: "PSPDFKit-6jesjcs8hzf3yy3bqdg9kv3hk7",
          snappingCheckbox: "PSPDFKit-7bm2dwvsr17e373y82u42rsemg",
          radioGroupWrapper: "PSPDFKit-2x6urux4z76dkhv9azjrwtw1r6",
          reverseRow: "PSPDFKit-41f3k1r3a4wcjyvwb632qbpsar",
          measurementToolbar: "PSPDFKit-8an6xzj8dczndqf5kkqj5bmdbb",
          measurementBackButton: "PSPDFKit-5zh4b5sq7ky7hj92aqd24n3cec",
          pointSnappingToggleButtonWrapper: "PSPDFKit-5y5uj8j53b14ftvfmra5n2fyyy",
          pointSnappingToggleButton: "PSPDFKit-6rhfuqge1pjsww21nyns7uzwz3",
          textInput: "PSPDFKit-28p9qe5v9wa12h9abqanj7759r",
          textInputField: "PSPDFKit-2dbzger7c772nf61kqx2yj1snn",
          inputDisabled: "PSPDFKit-37jqdeb6j87paw3ang9yrcet45",
          wrapper: "PSPDFKit-6pxk5ky2kj8jh4j1mw616vg41d",
          arrowDropdownBtn: "PSPDFKit-pynbrvdg7hats6u5gzc58czkp",
          fontSizeDropdownBtn: "PSPDFKit-8uffc57cupxw72ujvccyd5u75q",
          item: "PSPDFKit-4v7qu3gbmmmxc2v2hdycthse1t"
        };
      },
      89107: e => {
        e.exports = {
          calibration: "PSPDFKit-2s9j7gu6ht55v3fyhb7xkheuuq",
          item: "PSPDFKit-fn2f5n9d9n8sgj4djs9y86gau",
          scale: "PSPDFKit-3jgnu7ag1ffzarpqmuquune258",
          itemIcon: "PSPDFKit-nmsane1s7x9rp49pa42tzpgya",
          itemLabel: "PSPDFKit-2r48s2je9bp19zqfbs8mgk7184",
          advancedItemLabel: "PSPDFKit-24yucwgnrz6dxz6nmkt9jremkb",
          areaLabel: "PSPDFKit-4cuxks564t1dxgzbv7nvjy4yuc",
          colorDropdown: "PSPDFKit-9rhw3adf6wbfa7qrq615fjqaf",
          colorDropdownMenu: "PSPDFKit-6e6bk97ea2ucn9vbtxktfajm2p",
          sliderDropdown: "PSPDFKit-82a458mhumnurhq39us7zu6hyz",
          colorSvg: "PSPDFKit-5nmcjw7r4p1h2nd2mexfegg2rt",
          colorItem: "PSPDFKit-3cbxsq6nmh9r4f5756r6c95c7m",
          nativeDropdown: "PSPDFKit-86jxsd27b1jv4t4ubqhrx633pn",
          dropdownGroupComponent: "PSPDFKit-6ts2t8acharjbuq54t5wy2eb74",
          dropdownGroupMenu: "PSPDFKit-u1vpgqn2y5rje53z63f7mq5er",
          selectBox: "PSPDFKit-51c4fjecxrh9h4tcuygx1te5q8",
          advancedItem: "PSPDFKit-ncuqwmdusv2msxq73z6fzb24z",
          advancedItemValue: "PSPDFKit-4ua7xnacac2pm8hhds1kq2me5u",
          radioButtonWarning: "PSPDFKit-2abxjf7c5m54s1fbpjybj51p2m",
          radioButtonWarningIcon: "PSPDFKit-4enmf2wc85hnr4743bkg1tyeer",
          radioButtonWarningLabel: "PSPDFKit-6z22nmct2crec69qf41ena61ub",
          formFieldNameReadOnly: "PSPDFKit-4nrcak3ru32krpendekckcwwv8",
          inputReadOnly: "PSPDFKit-5x7gnppfkuuynrhwnep13pak49",
          lastInputField: "PSPDFKit-8zzdqsxn1q94q3wn44vjes6g2r",
          footerButton: "PSPDFKit-71vy88q3wndydgre2e58gj53rd",
          deleteButton: "PSPDFKit-5np2yc2xrsd6y7kt22abt9hb6d",
          doneButton: "PSPDFKit-4n879bzvk8q7g195cmz6yr433b",
          calibrationTop: "PSPDFKit-6ckerwnts2h4dqbxrjurcef6dc",
          scaleTop: "PSPDFKit-4fbe83fym7dgut61w2nf74r473",
          calibrationBottom: "PSPDFKit-7j9yftqvyfsbxszyryvg4tugmg",
          scaleBottom: "PSPDFKit-5naa93y6vbhdeeygcvssv2w99g",
          calibrateRight: "PSPDFKit-83b7zxjm332wqcc4s5gvrxfucj",
          nativeButton: "PSPDFKit-5xp4qfj9u68z92e75mcf5nqkcg",
          scaleDropdownContainer: "PSPDFKit-3bdhuh7gr82rtyrxt33vmpj2hk",
          itemHeader: "PSPDFKit-76y3uq9zy9ugrnh25fwthbtxdy",
          spacer: "PSPDFKit-4kxzb9uytx6jnhjtkwnzccwcb1",
          icon: "PSPDFKit-29u9ktdbpp3nysqgxn6naha4m8"
        };
      },
      87301: e => {
        e.exports = {
          modal: "PSPDFKit-52vp1wxnkrwaqvutwh9kdyma98",
          contentRow: "PSPDFKit-5rsrw7ak9xvqnc7bwahsasngx9",
          spaceBetweenRow: "PSPDFKit-6zjmyma75e4rfma6ujstg3d11u",
          scaleRow: "PSPDFKit-2ybdx86p6v4nqn1zrarhep8fhd",
          scaleRowContent: "PSPDFKit-6xaquyhkgnnz83eh3tcntmwpqp",
          addNewScale: "PSPDFKit-7zz1pa7xv6wgt2y9szvhke9935",
          rowSeparator: "PSPDFKit-4smtt8g7weze8w3e3n9ht93ak4",
          scaleMiddleSection: "PSPDFKit-37dv4qsruvxu93evjeh9gtqdna",
          scaleContent: "PSPDFKit-3766zw48tmq7b2dbzcgstgzxpt",
          footer: "PSPDFKit-43ubpyc1q299xrwh4k5xrxtk4m",
          header: "PSPDFKit-32yn21p1rhkx6139tfee43rskf",
          sectionTitle: "PSPDFKit-88em62dff33bjz4dpcz217kgw1",
          title: "PSPDFKit-5dpchy3cupj5bxucqn5nt8anr5",
          scale: "PSPDFKit-8cfu1mwm1ccfxda8tyh14s93v5",
          signatureValidationCloseIcon: "PSPDFKit-7ypv327ggsprw7wtqh3ggzwtt5",
          closeButton: "PSPDFKit-6t3gx31kbfuvg7pvvv3m4y2ud6",
          isActive: "PSPDFKit-7u52vd8vcqhwm46mqm3f6x3u4n",
          error: "PSPDFKit-4mb9ffzr14xj4f7cmnqkgcrcmq",
          scalesDropdownItem: "PSPDFKit-65q27ak2bn51hh1r3q8bw6pvrm",
          calibrationSuccessModal: "PSPDFKit-27a27t78xjc4pkkn8fs1enm4up",
          calibrationSuccessModalContainer: "PSPDFKit-6g6xvejv8dd1pf35kx6ba8gp5e",
          calibrationSuccessRow: "PSPDFKit-41haxjcx7ed6crwc23x62ewb7t",
          calibrationSuccessTitle: "PSPDFKit-68duutqz7ut9qftzm7ns95kbsg",
          nativeDropdown: "PSPDFKit-6zd1ytwjwxzumcawqamehzyaqs",
          dropdownGroupComponent: "PSPDFKit-49whdesn68fq294wzdzda443yx",
          dropdownGroupMenu: "PSPDFKit-3xxzytnemnzg22awfk9rymr2m7",
          scaleError: "PSPDFKit-75ga4kp46pkcv4peqbsu45nk79",
          icon: "PSPDFKit-5d5cb99rrfftnfraj6ve1wxtcw",
          activeScaleRadio: "PSPDFKit-5ypdmxk3tukb91thbuegtp28ry"
        };
      },
      29538: e => {
        e.exports = {
          container: "PSPDFKit-7d2gpuvu6pf58ndvvr6gvsje7q",
          warningIcon: "PSPDFKit-89fc7eud4xcjy12ca7j2haddwk",
          modalRoot: "PSPDFKit-47ced6qn4nruzv5vuz287qtd7z",
          heading: "PSPDFKit-2cqd842dczj7tmreu8ur1v9s39",
          description: "PSPDFKit-yuc41qrmjjetqv8krhsnx78k4",
          closeButton: "PSPDFKit-6xed4xk58tjqt3b2cq9x86gehh",
          closeIcon: "PSPDFKit-5zfc76hv99gw27ybkmbk7ebzep",
          buttonsGroupSection: "PSPDFKit-5wvh17kef4x55jrrzkh3hkaga3",
          buttonsGroup: "PSPDFKit-4qu4e2qh9g4wt4vaj7wc7rek98",
          button: "PSPDFKit-8etcg5412u6jyxe6wcw49n4eev",
          dropdownSection: "PSPDFKit-3hxqujdr5scngtpmjesahhytzq",
          mainSection: "PSPDFKit-3nd9gpwyygjwssm1a6vvyp2m5n",
          mobileWrapper: "PSPDFKit-8p7rfubnucmdpxjpsw31xbf5mm",
          formWrapper: "PSPDFKit-v7ryn5whw1cfrp237m7h2y2mz"
        };
      },
      98891: e => {
        e.exports = {
          wrapper: "PSPDFKit-6zm9nnbwvmtst5hnt9v1yhtmta",
          selectionBox: "PSPDFKit-4rqhxj4gybrps8vxa7fy7a3ssd"
        };
      },
      39270: e => {
        e.exports = {
          root: "PSPDFKit-8ffg9gawq78kbmz1r4tzjvvqc9",
          button: "PSPDFKit-8xy9jsj7mkgjmn242vthsdvebm"
        };
      },
      43165: e => {
        e.exports = {
          root: "PSPDFKit-8ehcbhz241z1tfyhjztbe12ube",
          isDisabled: "PSPDFKit-86bf3wbtmfc5xa3yfd4fazea9y",
          withLabel: "PSPDFKit-5734rhbbfgd613g81qs13md49y",
          disabledWrapper: "PSPDFKit-2n6h3jcy1kke81pjgewmpnqa34"
        };
      },
      13099: e => {
        e.exports = {
          root: "PSPDFKit-7kgnbhpp26m2rect3yjw1u1693",
          disabled: "PSPDFKit-314s1es5hfe28mgs9tnhkzb1de",
          annotationToolbar: "PSPDFKit-812ak3qykd2u5n22qxdy661rhr"
        };
      },
      99879: e => {
        e.exports = {
          root: "PSPDFKit-32xak74au7weyz9ycbwytr2c3f",
          item: "PSPDFKit-5j1459s9zq1zket63h26xjmr1j"
        };
      },
      59003: e => {
        e.exports = {
          container: "PSPDFKit-8cswfxve74abt7a5ua2r512q67",
          empty: "PSPDFKit-7ukwuhzxh3rd8yp7euuxw4jn9b",
          annotationCounter: "PSPDFKit-4qgb7hxxn2r4g3fdet5bn1pzv8",
          pageNumber: "PSPDFKit-7pcrw4sjytqdrvwzpes48axkkj",
          annotations: "PSPDFKit-4uh3zdrahzskzstfsa5v48m76w",
          icon: "PSPDFKit-65qjuaube253zzcqdz1q4ku4y9",
          layout: "PSPDFKit-6dxjd7dzqt7trrg39dqjupckv3",
          layoutNavigationDisabled: "PSPDFKit-6ek4wb89x2x5x1vhr1s1xdux9n",
          layoutContent: "PSPDFKit-7uyteqpmrzbvazvysj6dcy32h8",
          footer: "PSPDFKit-5c6ug4g42fqed2454e7qctd4sn",
          delete: "PSPDFKit-3jftjfjas9mc5fnfn3nvfw9rbs",
          lock: "PSPDFKit-52gz8466br5ea9fb7c841e2syj",
          flagsContainer: "PSPDFKit-8wr83uqbdd33rfwu128mj5gnh2",
          flagWrapper: "PSPDFKit-8d9gtv8zjahaxqn3hdsa2t7tea",
          label: "PSPDFKit-6qg835argr8knewku8zy5hfyqv"
        };
      },
      72313: e => {
        e.exports = {
          root: "PSPDFKit-3g5zqud1wjmcd71kwst6gjbcds",
          main: "PSPDFKit-6qc6bjvev7sffhewvpkas9njsf",
          mainContent: "PSPDFKit-2f9xn5bkkrt3h6fsmstdexegkk",
          mainContentResizing: "PSPDFKit-61bk1385h5ss7vmr9n4d26y7wj",
          viewportContent: "PSPDFKit-ejvfc31fwjv43pf6dxbymn8xw",
          overscrollDisabled: "PSPDFKit-gec7bey8wdz7abca1kbpqjncb",
          progressSpinner: "PSPDFKit-677uxd34863fgw6v55c3187a5v"
        };
      },
      25217: e => {
        e.exports = {
          container: "PSPDFKit-3794mza67b1yg72kafrt5hb5ne",
          wrapper: "PSPDFKit-82vfq7tmnvc7msfc9e69vvteqg",
          fullWidth: "PSPDFKit-74mdazdfzvch29s6gw4fvdanw9",
          layoutSmallWidth: "PSPDFKit-3fv5zkg97n3mu687rszsbq2vap",
          layoutWidth: "PSPDFKit-6n1ufy9m7k6kddjekzx8ra9equ",
          loading: "PSPDFKit-8ar7rzebgg8hmscpa7e7zunr9c",
          heading: "PSPDFKit-425nu4nkcgh6mxxdgbc94tfnnh",
          pageNumber: "PSPDFKit-7q4jhntpw5ww3s7967h4fxawb9",
          nameEllipsis: "PSPDFKit-25cnnvzt1zat453758mcudxsca",
          buttonContainer: "PSPDFKit-39x22bdb75a1huszgc6wehk4n2",
          name: "PSPDFKit-8qwj35jvzfa59ztz98a439e6uy",
          layout: "PSPDFKit-8xc3qwhsubkavwu93mg3mhacd1",
          selected: "PSPDFKit-3xvextg3pac89n7ybnha6syffx",
          edit: "PSPDFKit-2msvy6g19deemzxgx9xvgw7c57",
          editVisible: "PSPDFKit-3gpkhfqvs5pqtr4r9ry6e3jwjq",
          editor: "PSPDFKit-5j54uxjtt11g68z45aykeapv6x",
          editorControls: "PSPDFKit-5zwbu9g714rrbrfqc66ep7t3cs",
          editorEditButtons: "PSPDFKit-2b313c5ajnt3v97v7xqyj8k9ag",
          bookmarkDeleteButton: "PSPDFKit-426mdzb7nn1fr9xdajcg4c1cqv",
          bookmarkSaveCancelButtonsContainer: "PSPDFKit-2bfgwcaxtth9w1jg88tzb46hy7"
        };
      },
      69462: e => {
        e.exports = {
          loader: "PSPDFKit-7386u3hksvwqrk1txdsf6yjwh7"
        };
      },
      87161: e => {
        e.exports = {
          root: "PSPDFKit-rmf34nztrfgm2bcf7ccec8zhz",
          header: "PSPDFKit-3xkskd39bk5c2rsxpw7jwbmnn6",
          textarea: "PSPDFKit-8m2ghddxnzm27ad3jnnphw522j"
        };
      },
      22945: e => {
        e.exports = {
          root: "PSPDFKit-59dey26v49qmxgx7zfh1ehxqag",
          message: "PSPDFKit-4dct27k6q3q9d4c4atrzr75u79",
          icon: "PSPDFKit-6pphz7vq2cfumupsmn27tmjjzb"
        };
      },
      93952: e => {
        e.exports = {
          container: "PSPDFKit-5wp751jqbxpbbwkus9rbbddxgu",
          empty: "PSPDFKit-38m3bpj83kumpugydqecgvfb87",
          content: "PSPDFKit-6thyvskwj8bhtjt43bjv7r2tv3",
          controlContainer: "PSPDFKit-2wc1eg8pv5bz8rp1599q8cfpf",
          controlContainerNavigationDisabled: "PSPDFKit-8q6pak6zvt1x45sh6b8f91pb5g",
          controlContainerNoIcon: "PSPDFKit-8ea69n5pavewcwdnwuxcsvwz4",
          control: "PSPDFKit-83geqxjybeyf3vmtnwsfwrkpk1",
          icon: "PSPDFKit-8hs25mq46u5e54udrwp52hzqxc",
          iconExpanded: "PSPDFKit-6dv6mkjhdzxrbje2fu49pke6cy"
        };
      },
      84691: e => {
        e.exports = {
          root: "PSPDFKit-61pwj551swb751vsvtncfs97hr",
          hiddenMenu: "PSPDFKit-3txgs1brv6djswfx9c7deps2u2",
          hiddenMenuEdge: "PSPDFKit-8f8f78v7f3wp5n55qwjfz6qd98",
          item: "PSPDFKit-33kurg23vuastg415g558n9d74",
          selectBox: "PSPDFKit-4dvm3x8wyss7tgunnpgjqt7f8r",
          dropdownIcon: "PSPDFKit-2npkau1bttsh6zan1r4gdrzpzd",
          disabled: "PSPDFKit-2dk2qm9asz7my783w1r6n44gcq",
          isSelected: "PSPDFKit-5nr9hus8pqrwezzkgpd829srq5",
          isOpen: "PSPDFKit-5qky4ks8vy64a1wucbs25k86sv",
          measurementDropdownText: "PSPDFKit-7e9vp9ptc17dn5jtjsppjv8j8d"
        };
      },
      46632: e => {
        e.exports = {
          root: "PSPDFKit-5y28nfkmugyqqwevkxsjrpvq3c",
          box: "PSPDFKit-3gr2ksq6zccy3zdrbnfy8nh55j",
          error: "PSPDFKit-6eb3kcqgd5y9q8r7d8xtqz4649",
          errorMessage: "PSPDFKit-scv92vgvrnxnyc284zcn6hjk3",
          icon: "PSPDFKit-4wf98g1ha47f4tw6p5xpr51nn7"
        };
      },
      84008: e => {
        e.exports = {
          root: "PSPDFKit-6wak7k5y4nxmyh4g8xnd4zxf8d"
        };
      },
      16989: e => {
        e.exports = {
          row: "PSPDFKit-69gywaa9k96ge1hvked74ez5n1",
          column: "PSPDFKit-83vux4k1ev4t7s9g2qxwew634a",
          columnPreview: "PSPDFKit-42kn3f7jwfc8upuf4bdwgdyxcg",
          moveCursor: "PSPDFKit-7x2bqjhgdt551w3v3y37gv3yub",
          moveCursorDisabled: "PSPDFKit-78m832wbg6e9vmp1jz7knc9yk2",
          moveCursorPreview: "PSPDFKit-6bd8y61brzkav8gpvce127azsv",
          moveCursorPreviewEnd: "PSPDFKit-7b8eq949hpzkc8q3qh9tv8nxbp",
          thumbnail: "PSPDFKit-8vr6stqqbzz9z9n2w721sczcmz",
          thumbnailClickDisabled: "PSPDFKit-213q4dhe5s5dzr5zeyuf11xun6",
          thumbnailSelected: "PSPDFKit-4vvz95aegtycng8362mk8x2u2f",
          thumbnailBeingDragged: "PSPDFKit-7w3scq2qsd5h5g3fxuj2wccn4t",
          label: "PSPDFKit-2y5u2mcg8a7zhnfwfbbcfhnxcx",
          labelSelected: "PSPDFKit-3q3ydy7h9pcgtbpzqngpf8cet1",
          "engine-blink": "PSPDFKit-38dx8eye5za2p9zfprek3a6fmu"
        };
      },
      80054: e => {
        e.exports = {
          layer: "PSPDFKit-2z5hjphww7fvh1z69wxptsw1b9",
          cursorPointer: "PSPDFKit-3hfxfy9zqj8jprbtu9vf3epp17",
          cursorText: "PSPDFKit-3p9u592y96exhe2r2ntk5vbyxu"
        };
      },
      16522: e => {
        e.exports = {
          imageAnnotation: "PSPDFKit-5jn8feeuubm369vnx3evcba1rp",
          stampAnnotation: "PSPDFKit-5b8wstcs14vckqa7tw77vr685r",
          "imageAnnotation-error": "PSPDFKit-6anvx47kar5w253fz6rqg9hxcr",
          "imageAnnotation-loading": "PSPDFKit-rfgw2ucjvptvmzh7zu271n4x2",
          wrapper: "PSPDFKit-4jv7s61cvh1pcgqnvbxqubx8xv",
          errorIcon: "PSPDFKit-3z5svj219typgks4atm97b4y6h",
          notContainedImg: "PSPDFKit-7kevtqukx2j121vwemdz3hztp6",
          containedImg: "PSPDFKit-56vfsb9q6rq86j9dwdwt9edsp5",
          wideImg: "PSPDFKit-7yuetahtedwdfmawkggfhnmc8",
          highImg: "PSPDFKit-4bu7pjnhzjnq6m5wh7z589mw3t",
          placeHolder: "PSPDFKit-4dw6z4dcs45pn73rp3uakt52q2"
        };
      },
      47460: e => {
        e.exports = {
          layer: "PSPDFKit-26jegsvp6ufypbu8pxdv7fr1zz",
          deadCenter: "PSPDFKit-2wjxpeaermrgg7maxgnqmz9nc3",
          selectable: "PSPDFKit-3g43gj4at3dwbty7y7kctavd8b",
          withLayers: "PSPDFKit-85dfpszurcp74kqrua8y455s3x",
          relativeContainer: "PSPDFKit-247rksk7kd3gvyvzwg1npvhbdy"
        };
      },
      44032: e => {
        e.exports = {
          loader: "PSPDFKit-xe2ftya3wdjvwwhx6d5stmz59",
          loaderDot: "PSPDFKit-6wzqbae66q9h6nya7ye8mvy8kt",
          loaderShown: "PSPDFKit-64xwysuhvuuphryhjd9kj5nvy3",
          loading: "PSPDFKit-3u75qfne74tt2wqf8tq6zfy48n"
        };
      },
      2998: e => {
        e.exports = {
          canvas: "PSPDFKit-3tr6q51qastpckz1pg3zrtz3rw",
          svg: "PSPDFKit-2t63tjx7ps8wa34htwyhg1avhr",
          rect: "PSPDFKit-zxyvguvek2ym1z7dekdnq5v1z",
          rectStrokeBetween: "PSPDFKit-brx4byv7qnas5ky1tfgt6ba6x"
        };
      },
      14578: e => {
        e.exports = {
          OCGsContainer: "PSPDFKit-7w1nxb8aashzh6vn7hwaahzr8r",
          title: "PSPDFKit-5q31p223rz3j4rbvjs1pf1t3p5"
        };
      },
      98861: e => {
        e.exports = {
          layer: "PSPDFKit-4vgck46zhyuscqkznsp8pabh68",
          isPanning: "PSPDFKit-4cbfb2m7vt4aq7g21z3gxtzzde"
        };
      },
      16085: e => {
        e.exports = {
          root: "PSPDFKit-6m9gupd1vyy1fr4bpfheg6wwdk",
          progress: "PSPDFKit-8nwc6qm7s426c5g16sqaykh38n",
          progressBar: "PSPDFKit-3mu82vxhmw13y36qrsu6ya81cc",
          progressText: "PSPDFKit-489xz3n1mhssjcqb9fqcbey276"
        };
      },
      57193: e => {
        e.exports = {
          root: "PSPDFKit-5w2de1uyy445puycu46qkgmvar",
          message: "PSPDFKit-6w84556468p7ssdr8cqmyn8mjr",
          icon: "PSPDFKit-75vqhz2zk4qrae8pgcsegd1jf9"
        };
      },
      58288: e => {
        e.exports = {
          root: "PSPDFKit-6mny4jk3t426w24d83deht33rn"
        };
      },
      89939: e => {
        e.exports = {
          selectionRect: "PSPDFKit-41x845wgwdrzef1yhewvdke7jq",
          isDragging: "PSPDFKit-4xr8ttj6ez7ht327cw29e7egf4",
          draggingRect: "PSPDFKit-3zx2hhrb4ywt7dnp33xe4gkwb3",
          resizeAnchor: "PSPDFKit-dhbnhykfyudwqtjr6bkvb411g",
          rotateAnchor: "PSPDFKit-m9u6yjwr7kv5hrxj2edskfkgq",
          nwseCursor: "PSPDFKit-39325679hnnu7x4wvxu6tbzens",
          neswCursor: "PSPDFKit-4d596dtje8pvaa57j35a6jumtj",
          ewCursor: "PSPDFKit-24ebukh9y4t3vv23sz65xrazp3",
          nsCursor: "PSPDFKit-3vgs6mrf1dabs2kb4pj7s49g45",
          rotationLine: "PSPDFKit-h4n5vrr4a9j6mcbt75ygqk7hf",
          svg: "PSPDFKit-8edbp12fj3btvvzys6786f1fgj",
          rotationHandleSvg: "PSPDFKit-cb345hgmyvpuvgnewsbd7dmq6"
        };
      },
      97838: e => {
        e.exports = {
          container: "PSPDFKit-62axfp2anyb8xpk75p9y1ex6p9",
          empty: "PSPDFKit-7jkmh5d31sfmdb3qmnnkp6a7fa",
          header: "PSPDFKit-3zs2wgyxgxdfjh9gpg7wspausy",
          itemList: "PSPDFKit-2crjcengr1ceqrunvecud8qq94",
          item: "PSPDFKit-7wa9h3ptey4wt56e8y9w94736m",
          title: "PSPDFKit-35h6ezfp489wdhvnnpt5mhpkw9",
          icon: "PSPDFKit-8vqyb7s2ww33zaax9tzz18gfwb",
          iconUnsigned: "PSPDFKit-7mkxxp5qgadfweavgqfx3f87tv",
          iconSigned: "PSPDFKit-87hht5q4ypqsrmw4k7stqxv4w1",
          iconValid: "PSPDFKit-2xxan7ne4sertfng4p9e9m9wu9",
          iconWarning: "PSPDFKit-86zqb11dkjaszvm3c7cdnwkcgh",
          iconError: "PSPDFKit-47uqz9mnbhc3j74nzn3bhbq28m"
        };
      },
      5017: e => {
        e.exports = {
          root: "PSPDFKit-7dzbfgjr5hhbb3rc1z1j74nw53",
          signatureInfoContainer: "PSPDFKit-67qcupwvpz7h59x97s5hu3w8y9",
          signatureValidationStatusIconContainer: "PSPDFKit-5hnd1py888z6q6dqpr2kp2cq2e",
          signatureValidationStatusIcon: "PSPDFKit-6ee193drjzesd61tu19hcvekb6",
          signatureValidationCloseButton: "PSPDFKit-67meud5692v5j5a61jw2681xzk",
          signatureValidationCloseIcon: "PSPDFKit-6u1j5sk8ayvj3gvkxqkswrcet2",
          "status-valid": "PSPDFKit-44csr6tj4teuj9fhfz8ee71tfx",
          "status-valid-icon": "PSPDFKit-2e9udw15t4gp8scnfddhxz9hsd",
          "status-warning": "PSPDFKit-4ppb4buhu7rwnjufcn6ajpkskn",
          "status-warning-icon": "PSPDFKit-86f3yc46j85tr3gsnftm482dk",
          "status-error": "PSPDFKit-2c4pxuv49a7x173nj5nzfauxbt",
          "status-error-icon": "PSPDFKit-8zs1teqnye2ksnaxmemgknn6pv"
        };
      },
      27895: e => {
        e.exports = {
          root: "PSPDFKit-6rzkyc987bqyetscyfvr4nf3f2",
          stickToBottom: "PSPDFKit-2fwepfwm4jpbvv9evy3bh2cmsu"
        };
      },
      53328: e => {
        e.exports = {
          slideDownEnter: "PSPDFKit-7q656qfg6merpmvr8kzt9szzpm",
          slideDownEnterActive: "PSPDFKit-2uctbmt9nj99yrpxdk24951hsm",
          slideDownExit: "PSPDFKit-5v5jfhfemf1mxc5ret8j9wh9sh",
          slideDownExitActive: "PSPDFKit-3a46uu7aytzncpnz4ppsu1ucnd",
          slideUpEnter: "PSPDFKit-7yg9b82v4xahqj93wys6tpbu1f",
          slideUpEnterActive: "PSPDFKit-44rpp3fvbs9mj6uu6g6my1392",
          slideUpExit: "PSPDFKit-4pjqt364whvu7b81yv22fwa1ve",
          slideUpExitActive: "PSPDFKit-4sea6h8efz1kfffbq87vcmq3qu",
          moveDownSignatureBarEnter: "PSPDFKit-6hdgn11y1ecgvxga69t6p78b9a",
          moveDownSignatureBarEnterActive: "PSPDFKit-2b6tmwyq1x3rcswb7k71f8vurh",
          moveDownSignatureBarExit: "PSPDFKit-7hwkgbqv2uvce8qyhqnq7n9vdp",
          moveDownSignatureBarExitActive: "PSPDFKit-4b3k2aksgt8h7qfz8vz5nbnvfz",
          moveUpSignatureBarEnter: "PSPDFKit-6rtd66rsbcpdy21mbkethcajk1",
          moveUpSignatureBarEnterActive: "PSPDFKit-6jy41y1rpnd5deemk7hqpbq4m1",
          moveUpSignatureBarExit: "PSPDFKit-21nc3yzh856bkm3mw7smrrzb5w",
          moveUpSignatureBarExitActive: "PSPDFKit-4zmvpm3c2adfnu8qnuw79cjh3s",
          fadeEnter: "PSPDFKit-79rm2zddjaxgzdkx4w8mqnqa8c",
          fadeEnterActive: "PSPDFKit-7trwsc5j1bg69wa1vf9qt5e2ve",
          fadeExit: "PSPDFKit-8t2qrt9phw91wb7a8wwmgdce7p",
          fadeExitActive: "PSPDFKit-7e9n9mfhw378wrt55c2j4gpdxm",
          scaleInEnter: "PSPDFKit-67d6x1qnthds5d58mamrx9qpu3",
          scaleInEnterTop: "PSPDFKit-3dfszxf6jpx5tm2y1gn1ehxgtw",
          scaleInEnterBottom: "PSPDFKit-8kb8kruw3xcx17v1486van1ttq",
          scaleInEnterActive: "PSPDFKit-3c4mxzjgy4m6n8r275v2uyp4we",
          scaleInExit: "PSPDFKit-3uce8apgqwt65tqd63cq5zuvpm",
          scaleInExitTop: "PSPDFKit-3hsvwu5hjq1a44vcrtkv5fhpnr",
          scaleInExitBottom: "PSPDFKit-5r2r1t3f6q5zqjq84zbr69ejuk",
          scaleInExitActive: "PSPDFKit-35xj9c4azp7m511gxuzzvr1k5d",
          scaleInExitActiveTop: "PSPDFKit-t8mvndx8cr8ydw9bm2vyh2wgw",
          scaleInExitActiveBottom: "PSPDFKit-378kvahbp4zr42u1gb4cqyxsad"
        };
      },
      5871: e => {
        e.exports = {
          container: "PSPDFKit-5b8n6ax7uyfq7q2zt9n9en17ab",
          wrapper: "PSPDFKit-2jffvae4wwchr5476dpvz5z5ch",
          header: "PSPDFKit-2ehyk369yxm1zk369m6mttkt22",
          hideButton: "PSPDFKit-7agv7htc7d2j2xf6ugmwrw1ppu",
          hint: "PSPDFKit-6qzybrgcrc8sfgmwkc749exk9n",
          icon: "PSPDFKit-32x2pcstxyeubux789j773s9rc"
        };
      },
      98416: e => {
        e.exports = {
          root: "PSPDFKit-8jp8nm1hj7szh4vv5aurdvd5j9"
        };
      },
      11471: e => {
        e.exports = {
          placeholder: "PSPDFKit-611629rcz14kzt4fxq9cun8r55",
          stampAnnotation: "PSPDFKit-291h7cpg24qsc3uyjkzbr88w1y",
          widgetAnnotation: "PSPDFKit-3k8pvf98ypg7cfxdw2h4s9hks8",
          error: "PSPDFKit-6kn9fwrhmcn5ws8thfmrbawkps",
          loading: "PSPDFKit-4668kvbgmy9yr757xzersy788h",
          wrapper: "PSPDFKit-3gs4z9rtc1a83dstvmn7mamwfd",
          errorIcon: "PSPDFKit-4vsf7ppa6vgpu72s69w4p6cheb",
          APStreamParent: "PSPDFKit-6gjytkd24fh19g96hp4rxaukmu",
          focusWithinOutline: "PSPDFKit-7duaya572p1aupn3x6vrce4kb8"
        };
      },
      93408: e => {
        e.exports = {
          annotation: "PSPDFKit-6nx1rtuadk913zxen95pax5hz5",
          icon: "PSPDFKit-8qpben4cgdt355xztxuqcrcxvg",
          iconActive: "PSPDFKit-5ty8mmke3as9vprwxv67knqxcc",
          noteIndicator: "PSPDFKit-4cgbq7rdg2pm33fadjsppnpuux",
          noteIndicatorActive: "PSPDFKit-2aywxsct3x3wxc4d46re3nssxu"
        };
      },
      2928: e => {
        e.exports = {
          btn: "PSPDFKit-7ynwexufv1hs2a9qe2gqaegb69",
          btnFormDesigner: "PSPDFKit-4cfxcba5wt87u69f2dw7v6xter"
        };
      },
      36401: e => {
        e.exports = {
          checkradio: "PSPDFKit-24sm6mv9bd2n715byv1c75x3p1",
          input: "PSPDFKit-8zz118e9x2cbq64jj7xe4juhtg",
          checked: "PSPDFKit-5d2c15vj7t3amwwn2yqea1bcas",
          inputRadio: "PSPDFKit-yun3fvwa7cmcs36wxdpy8barj",
          check: "PSPDFKit-5kxx5vfzwztr2mwa4mzj18jqrq"
        };
      },
      68850: e => {
        e.exports = {
          layer: "PSPDFKit-5pebxrpmqgkrf7vcxe4371geyh",
          comboBox: "PSPDFKit-7fyvzesvuhuugesmttmj91m4nm",
          expanded: "PSPDFKit-2a2g4zggqmewex1vm5v4zpgb56",
          comboBoxTop: "PSPDFKit-6s31a1f931synspdjrnvzxnfgc",
          valueBtn: "PSPDFKit-4bd1e6vbjnuczspgvgas5tb4us",
          arrowBtn: "PSPDFKit-3hahgu1xkd2v4363x5d3e6rryn",
          menu: "PSPDFKit-3vaw2awbbx1p5zjtdh9v5dhtts",
          comboBoxInput: "PSPDFKit-89gzhtz3mw6xunsgtyr2eum9s6",
          comboBoxList: "PSPDFKit-88t5fcsjadwffxkef3gfkzaksk",
          comboBoxListItem: "PSPDFKit-844vbxfxwv5rq9arab8e8gd5de",
          comboBoxListItemSelected: "PSPDFKit-rrhtfqn9ehag1af8v4xkdd8au",
          comboBoxListItemActive: "PSPDFKit-49532ws826dtcr1m8n5e4dcjzu",
          empty: "PSPDFKit-57p3ubjwqmm7d4cs2pftzys4tx",
          listContainer: "PSPDFKit-s2y6sy6212w5uexa3d23a5asn",
          list: "PSPDFKit-2waaja9crmechfes91ghkmsmbj"
        };
      },
      97008: e => {
        e.exports = {
          annotation: "PSPDFKit-6mcjw1j7tzm5hepajxw83pzakp",
          icon: "PSPDFKit-5cbbkpsrtp7h1aheyyz5jh553f",
          iconActive: "PSPDFKit-gfh2n7ye6agxztvft95yj26j6"
        };
      },
      51491: e => {
        e.exports = {
          layer: "PSPDFKit-334y8gbu8r2jjjn87nzvuevc59"
        };
      },
      89407: e => {
        e.exports = {
          canvas: "PSPDFKit-3w2n2qdrr23cmdk4q8whx3tsxf",
          container: "PSPDFKit-2gh7qt7mp38bkn5x9qf3y99zu3",
          path: "PSPDFKit-39tt5mrp55ku7xxg9u7mh41a33",
          selectable: "PSPDFKit-6wrq4aekz4kq4fgt2pvnb9w6a3",
          rect: "PSPDFKit-57qn9qb3ug1rpk9v33hd5cxd1d",
          svg: "PSPDFKit-5q9h4djx3kcxba1qj815pdz3fs",
          cursorNotAllowed: "PSPDFKit-252bad36x484xaffc25n3h9thg"
        };
      },
      18661: e => {
        e.exports = {
          layer: "PSPDFKit-3ncb69xb2ve1sqjjdtyc6cd8g4",
          annotationRect: "PSPDFKit-5mur5qgg6vwc2wpggzustr83j9"
        };
      },
      55338: e => {
        e.exports = {
          listBoxRotated: "PSPDFKit-4epuuwuap9pk3ntjcv5zf9djsb",
          listBox: "PSPDFKit-7xq92qy48k696v9kfs77d7f216"
        };
      },
      64131: e => {
        e.exports = {
          layer: "PSPDFKit-2wu94uj3duvdnqa6qcf42ezs6d",
          annotation: "PSPDFKit-54pg5n9qt6pj2u219my1yv9v14",
          wrapper: "PSPDFKit-4ywhmukc4gwqac7ntzy2uz9x6h",
          content: "PSPDFKit-8tznpz6dg1zmer4mxt1kj4d367",
          fullScreen: "PSPDFKit-77mpcyuxmy88vcuvt1qbfqn1bg",
          button: "PSPDFKit-4sup5zkzxcndck1xbaquyw5tat",
          hidden: "PSPDFKit-3zbd56btxsp72du8mq44gc68pf",
          header: "PSPDFKit-7t4t5t39c8gj689nypcn8sy1n4",
          title: "PSPDFKit-8jdq4qfwqhh5yzunhf1nvu3sxs",
          tools: "PSPDFKit-5ns5z6cwaq7uvb37ejfqcck6cj",
          tool: "PSPDFKit-28m2z472nqzne4jhz5hvqkzp78",
          footer: "PSPDFKit-53wjfdyupu3zpctpt74eumsq2b",
          label: "PSPDFKit-39sru8fstgk9ukw59vdxw6fxkm",
          icon: "PSPDFKit-2rbb4rpjnbmgu1bj6enchp1549",
          noteIconInPage: "PSPDFKit-6zth72zst4nvzumuemnjxzum5p"
        };
      },
      29211: e => {
        e.exports = {
          container: "PSPDFKit-87g1wera6smataxregkeucdz7u",
          wrapper: "PSPDFKit-7nzf5ygyxf3ft1vwqded1vys1c",
          canvas: "PSPDFKit-7ckwm8p8x63jumkemns7vefj6u",
          rectContainer: "PSPDFKit-8629afaazd1efzub8c3z1qfnae",
          active: "PSPDFKit-4vzt6kbkqqcu93437rphdgn7xj",
          selectable: "PSPDFKit-8qst6ht79xb7qug95szm7j35vv",
          textContainer: "PSPDFKit-86f9zgw71s8n95n7rxd3uqn3c",
          textSpan: "PSPDFKit-82f4yxbm2u7ssyqxr8sztm7qzb",
          svg: "PSPDFKit-7vkn9dyk6rhen2hjabdgskypgp"
        };
      },
      99721: e => {
        e.exports = {
          canvas: "PSPDFKit-86u6qqcu5qd2p78j3sasqcq3r4",
          container: "PSPDFKit-6euxnwumsrs547zhsd467cw4p9",
          visible: "PSPDFKit-2gqt93vqwz7akw64wyn6tk2eqn",
          cloudy: "PSPDFKit-67t1bptsfdkkkbpn6jgsm9ktd9",
          selectable: "PSPDFKit-xydzth3k7ns3nahap4gpxayej",
          strokeDashArray: "PSPDFKit-3zmy52u71trzxmdvbycck28tg7",
          svg: "PSPDFKit-68femat6jd47qrav117uen51r",
          cursorNotAllowed: "PSPDFKit-btun3r6cqwxytpv1u8kdyngqc"
        };
      },
      70101: e => {
        e.exports = {
          sign: "PSPDFKit-6b7je6w7pq8q3htgsu22kkv6jy",
          signReadOnly: "PSPDFKit-7181s3qkmmn7fdexydqff3quq3",
          modal: "PSPDFKit-4kv9rhr6nzpkdjsr5xsjyfaqju",
          editorCanvasContainer: "PSPDFKit-3nvj481sp2nd9z1gjhvh4xnak2",
          signaturePickerContainer: "PSPDFKit-3v4b4f9nkt7wjjd26afq8763k5",
          viewRoot: "PSPDFKit-2g5n99kjfbnxh1che778jg7tjb",
          viewSignaturePicker: "PSPDFKit-6qtbckagb6bfbdepc3443v6ywj",
          header: "PSPDFKit-4su78ec7s1c5mkz65pjuq22xsv",
          footer: "PSPDFKit-5ru14aj6muejw948tvdz1gb3ks",
          colorPicker: "PSPDFKit-3bexu72w84xp6s2e361sj7711b",
          title: "PSPDFKit-5r5vdeqd1th8znbb9ygk279qt7",
          button: "PSPDFKit-8c4vuvw13bebs9s1s79remb5de",
          group: "PSPDFKit-4kzbv64jk7wgnrp27w38k26bj3",
          editorCanvas: "PSPDFKit-5ngq82qgx5cxz4uz5mzjkchjr4",
          signHere: "PSPDFKit-2ju133936zwp42hg96a2f41uec",
          signHereHidden: "PSPDFKit-2ttca3yjnqndu3nqu48x21jqwz",
          checkbox: "PSPDFKit-6uvk92p73etnn6mk5qcbqwj9yx",
          checkboxLabel: "PSPDFKit-642395esq5512gt252k1kx6gg2",
          signaturePickerList: "PSPDFKit-6p71pj5wv5hqqjxncy9s2zhp6z",
          signaturePickerListItem: "PSPDFKit-4yhszj3k6pkfr9qjx6zw41fd3g",
          selectSignatureButton: "PSPDFKit-4nbyd35stvtu3bz3kk4yr18ed3",
          imageAnnotation: "PSPDFKit-353zxjn4cwq7f5trcamndrkw3j",
          deleteSignatureButton: "PSPDFKit-7urkar9j36rp4ztzeaqz3jjm6x"
        };
      },
      74038: e => {
        e.exports = {
          readOnlyOutline: "PSPDFKit-4rfp7ee9191kd8ynnn3bq8u33p"
        };
      },
      50647: e => {
        e.exports = {
          layer: "PSPDFKit-4dwy35ce5zzs8fcuzm4z5qyj9j",
          annotation: "PSPDFKit-4rhmvvkqbbeztw9z4seq55hdh4",
          editorWrapper: "PSPDFKit-5sgjnpxkms74d5uhcrs1xnpjkh",
          editor: "PSPDFKit-c8up8r9n155axqjtb8dat8e5t",
          richEditor: "PSPDFKit-3g965ce6b38z92kn57ymc33d93",
          readOnlyOutline: "PSPDFKit-4f28b7qs5h6nk9v4ngh8xr9zsb"
        };
      },
      90255: e => {
        e.exports = {
          annotationRect: "PSPDFKit-8py43zrk8tdwczbp1rgu5zkpcc",
          activeTextMarkup: "PSPDFKit-4111jnwhknt7c61pjq82hshdjm",
          highlight: "PSPDFKit-68rke3v2mwfersk9s87pby4xqz",
          active: "PSPDFKit-2wyzkwftushgxqvheqv9gc1qz7",
          markup: "PSPDFKit-6jx1pd841ynqrzk4be2rtgtwnc",
          strikeout: "PSPDFKit-4hm8gjadpcvqnu18qte7mqnfey",
          underline: "PSPDFKit-8hws43jkrgjxj8tajvc3qfhyfr",
          squiggle: "PSPDFKit-78vd6wa19gxf1ecyped1w9etsw"
        };
      },
      39213: e => {
        e.exports = {
          layer: "PSPDFKit-73459dse4nv5d9mqecpwp57s3d",
          annotation: "PSPDFKit-8wsgnacdwb75d488xzar24jqkq"
        };
      },
      561: e => {
        e.exports = {
          widget: "PSPDFKit-7fx816mm5dnp6e45vtkbeu7u6h",
          readOnly: "PSPDFKit-53uhn3hvzxffzgk8gjs3fbkn19",
          focusedWidget: "PSPDFKit-2j44z8y92gejua2pwvgm8sjhm4",
          onFocus: "PSPDFKit-2kwn8pyc4wfu8r2pfah6fq7qfx",
          combNoPaddingLeftOnFocus: "PSPDFKit-x9z86ubc4peun53ye7m7udhyp",
          flexText: "PSPDFKit-cr6q4n8xfg6vtzd5q658psukz"
        };
      },
      80389: e => {
        e.exports = {
          docComparison: "PSPDFKit-6xbbtf8p2qcsg9fyy1cuyj7gw5",
          source: "PSPDFKit-5vy62kz7ms89nk2k2k3swztwdt",
          sourceTouch: "PSPDFKit-2bqfqmutsr41ycmfq7rs53uqxa",
          referencePoint: "PSPDFKit-3r5sb26jgasuxhwabq3dunx45u",
          crosshair: "PSPDFKit-83td1duhyv22mhv3yff4qtza4s",
          selectPoint: "PSPDFKit-4fgfk59wcke21gwwxhuq8mm7n7",
          hidden: "PSPDFKit-3dkk2vqpcthpdtrchghtj4ssn4",
          comparisonPin: "PSPDFKit-7kr3xjykvj7fr643ccby96g62n",
          page: "PSPDFKit-76gy17tgphy3rkqc839s5j1pzc",
          "deg-0": "PSPDFKit-5pzb826nhfhqp1g5p1ks17fq77",
          "deg-90": "PSPDFKit-427zszzm3g9rt685w6err79657",
          "deg-180": "PSPDFKit-2ymsd6xds9g7m3tn384wexbs7d",
          "deg-270": "PSPDFKit-36rheuktx5sb8ecxck9vutfh9y",
          magnifierContainer: "PSPDFKit-4y67gffktarr3dzsdm3be4tkxg",
          magnifier: "PSPDFKit-5dnneume1xfsb52nce5gmkwws3",
          magnifierGridContainer: "PSPDFKit-5vm17u78a9y73z4fns92w8pcmh",
          magnifierGridStroke: "PSPDFKit-5r343876m2a2k85cus2jjxh8fw",
          magnifierCenterOutlineStroke: "PSPDFKit-54zz8rzg9jq31dvzq91d2qkgg5",
          magnifierCenterStroke: "PSPDFKit-5ct94rndvza9jt8fdk5kj434wf",
          magnifierZoomValueBackground: "PSPDFKit-jyeb8qr8rp75utm5jpsrrw1xb",
          magnifierZoomValueText: "PSPDFKit-41ur68urabv2z38jg19c3pcx39",
          documentComparisonPageLoading: "PSPDFKit-4kmrm9dhgkuczunfzmxs26b83p",
          pointerLayer: "PSPDFKit-4t23dm96wzfwsfr5116ky9f96y"
        };
      },
      36572: e => {
        e.exports = {
          docEditor: "PSPDFKit-5jknctefe1bdrcw8ckp4c84xxz",
          moveButtonContainer: "PSPDFKit-4pkhpangb13n8mmvw8ukdfhw4n",
          moveDialog: "PSPDFKit-8am6zresjtqzubaax3ncbdkk65",
          moveToolbarButton: "PSPDFKit-4m35g8jgpcwck6gzgr9fx9sj37",
          moveDialogDetached: "PSPDFKit-7wm68x153yxrzfku2ccv6bng6w",
          moveDialogShown: "PSPDFKit-78jn9e1vjnny6e5w7kbswqahdm",
          moveDialogForm: "PSPDFKit-8h6fy8n1ae1b2jzvx2bx945q5p",
          moveDialogFormLabel: "PSPDFKit-2q7tsdrjbypfd7mwu6hbfdnmqn",
          moveDialogFormInput: "PSPDFKit-7ja4pzq1aasqwczs6cw41n68nw",
          moveDialogMoveButton: "PSPDFKit-86an2z1e8c3rstpug6xhqbrz92",
          moveDialogHint: "PSPDFKit-7nbf67rhjsg7k4gsdmg33muhjb",
          moveDialogHintText: "PSPDFKit-2mh89kckyg3qpesbhuwrcrw9rd",
          pagesView: "PSPDFKit-4qc12j3k5rawv8wqf56u3q8k4b",
          pagesTitle: "PSPDFKit-87xjjuqyeg5kxzvrh4nak5jkrs",
          tileContainer: "PSPDFKit-832dwy6tmpr3u59345n392d5kp",
          newPage: "PSPDFKit-ufnr5vdahbxdpe2583xyak7wk",
          importedDocument: "PSPDFKit-36mc2jhmhw8s6j455stsmh6k7t",
          importedDocumentIconCircle: "PSPDFKit-7mtmexx6nf2jzpxs9vv5ukyjhk",
          importedDocumentMovePreview: "PSPDFKit-bx6vky4fzf7e375qv4fgmyffe",
          importedDocumentInfo: "PSPDFKit-3hs8zjffpgsz41nr4dp7ybdkt5",
          pagesGridLargeThumbnails: "PSPDFKit-5yvxb7rnpjz9pacz8czkc32f8y",
          pagesGridLargeThumbnailsIconCircle: "PSPDFKit-491vbmcbxhae4fwryx7hsht2wh",
          pagesGridLargeThumbnailsInfo: "PSPDFKit-2q199y39wutn5mwnfxjd4juxqq",
          pageEntrySelected: "PSPDFKit-8cajckh5v3zfxfj9hpdytffrv9",
          page: "PSPDFKit-5nnn6safhgnqp45k1gnacbs5b9",
          pageLabel: "PSPDFKit-7hskkg7c42g4u1gxydpvnhrare",
          pagesSelectedIndicator: "PSPDFKit-267ekkrqhchqasjegw4gdy4gr3",
          pagesSelectedIndicatorShown: "PSPDFKit-7dep96m3dt6f6m6ggtsdvejn1b",
          pagesSelectedIcon: "PSPDFKit-czbss4f5tejzb3s7rydnxdc6g",
          bottomBar: "PSPDFKit-8rq6e51mxrxdrszuexbb2cnxhy",
          spacer: "PSPDFKit-397h62jvayz1wt2xp2cz2ekmmw",
          toolbarRoot: "PSPDFKit-7egcdrn8t9zxr4h4f3tqd6a6q9",
          toolbarContainer: "PSPDFKit-5mgaebuj6tj1kbvvkf42rphvab",
          movePreview: "PSPDFKit-7mbngz46jn2pabmnth6t7hsds1",
          movePreviewPages: "PSPDFKit-7bbxybqv7gn2ruj7drnnj7fqgj",
          movePreviewCount: "PSPDFKit-339r3xtmjz8gs5vpsy5ncb75nb"
        };
      },
      65575: e => {
        e.exports = {
          modal: "PSPDFKit-3jpjxq56vk2un8ub8pje71u85a",
          withIframe: "PSPDFKit-5dqa12x5zkbqjvjdekehdmb32n",
          fallback: "PSPDFKit-68rzfs8a4kxm2sv4wxbhvjjsk4",
          fallbackPagesView: "PSPDFKit-8a6esc3kchamvphrc23c4bjcxn"
        };
      },
      45639: e => {
        e.exports = {
          root: "PSPDFKit-er87znp11z8wa56gmt1nr1adc"
        };
      },
      68938: e => {
        e.exports = {
          root: "PSPDFKit-8ytejk69dm72arac6kecrv7jgs",
          input: "PSPDFKit-4mck9x4g933qtvsqa6g63nq21j",
          focusRing: "PSPDFKit-5z85yf9u7uzqx732cjqehyhd3s",
          swatch: "PSPDFKit-7899cbm2djcuh9uzvh8y9mhq12",
          inputIsActive: "PSPDFKit-7m6c5mvk9zc3ccp4w9ckt76p5q",
          swatchIsTransparent: "PSPDFKit-6ge99vaebv8tjqjjwz2pg1qzd6",
          swatchIsWhite: "PSPDFKit-3eaf5m5zxe8hsj1wptbbs2ru3r"
        };
      },
      74076: e => {
        e.exports = {
          nativeColorInputWrapper: "PSPDFKit-3rtr4tx6y919hj63k8j6veyfvu",
          nativeColorInput: "PSPDFKit-2f2ahvz6xw42cz6ppqg7qrnv5w"
        };
      },
      60210: e => {
        e.exports = {
          root: "PSPDFKit-4knn6qcs6mfzubc11j3jn3kdh9",
          label: "PSPDFKit-5sa85wwcx2g58bvnwu3e9vxux8",
          input: "PSPDFKit-27139754tezpaj4xtjvqyqphqa",
          value: "PSPDFKit-6b7xgm3nqzh79vcp4knygzskc2"
        };
      },
      65927: e => {
        e.exports = {
          root: "PSPDFKit-877ty5wd8zf2uk8mwxy3vm7ra1",
          slider: "PSPDFKit-8mewb5unfae7pfb8a3vhx2pfe4",
          label: "PSPDFKit-7s1evqenghjbnmpkjx46g7aj7a",
          value: "PSPDFKit-4tsachwba3d2gug8ut8n2k7kw2",
          dropdownItems: "PSPDFKit-339qy9bx9b7sqbvd31hpseqnhm",
          dropDownItemsUp: "PSPDFKit-86g1a3rfhteap5bxhyrt2js27u",
          button: "PSPDFKit-7dtmrym3urvgecwht2mvnd78yn",
          toggle: "PSPDFKit-4ukn6hggdcjm9mj167e7f6hqx1",
          flexContainer: "PSPDFKit-7bepqp75z28r5jat89hqdhcjva",
          show: "PSPDFKit-9f949cfpq924euep2ae47njjm",
          dropdownItem: "PSPDFKit-5zut7thxsf86fddq8rgtbtrenu",
          isFocused: "PSPDFKit-5bqkg9v7er35bgbtaqq2vnq3z8",
          selected: "PSPDFKit-y9nzknrtb2kq52c2xfb4715p7",
          disabled: "PSPDFKit-6baefa9vw8uyyrsvfez7h3ewrq",
          dropdown: "PSPDFKit-4xjmg49gjvk5zp5p42ms81uw4h",
          srLabel: "PSPDFKit-2cuzr66tz354vn9dgkzb1pwq4b"
        };
      },
      16165: e => {
        e.exports = {
          root: "PSPDFKit-6pk75qzdg2ukj6fscjncywz97r",
          input: "PSPDFKit-5nhvbbak97n275vs6wmzzmeuwc"
        };
      },
      37922: e => {
        e.exports = {
          magnifierContainer: "PSPDFKit-5u5zg1p821mpfkbnn2k5uwyj5f",
          magnifierContainerMobile: "PSPDFKit-8wd7v7mnz2rcxvt87ua26mzc6b",
          magnifier: "PSPDFKit-5nkfqsjv5yud4v1dqua4t23fay",
          magnifierGridContainer: "PSPDFKit-4ucp3vtq371cyq6rjfnyr48ke9",
          magnifierGridStroke: "PSPDFKit-2mrwgj2fjj6868616ds613yrym",
          magnifierCenterOutlineStroke: "PSPDFKit-7sk5hhk6ycrf96cdxc48xy41us",
          magnifierCenterStroke: "PSPDFKit-4cc9nv4wau5sr77yxnn4p9c6vn",
          magnifierLabelBackground: "PSPDFKit-61a71yusrshwesstskqk1ts821",
          magnifierLabelText: "PSPDFKit-zd3q5csyfkc4sst1n5gwd6ynd"
        };
      },
      91414: e => {
        e.exports = {
          confirmGroup: "PSPDFKit-6sv7sqb53n124u6fj1tms89hna",
          content: "PSPDFKit-654mqarkz9bpasgehzef4652nz",
          button: "PSPDFKit-3db8msn3nmbe95zjws8yr4m8q6"
        };
      },
      25534: e => {
        e.exports = {
          noLicenseTimeoutModal: "PSPDFKit-4uccwfpffynm27eb199wcvgfa6",
          content: "PSPDFKit-6duc25m5r8gy5rgntee7kp4489",
          header: "PSPDFKit-3fuuhwa21xs9tcx2tz4png1tpx",
          text: "PSPDFKit-3176nt5ytqfasruqx2cb7426zk",
          link: "PSPDFKit-321y6pgcakckhny2k21wpdad3b",
          button: "PSPDFKit-4ujhjvq5wfhu2712d8utd4h7kb",
          icon: "PSPDFKit-4rbfyr87rf5tqtuqbp52tvzdkj",
          modalSeparator: "PSPDFKit-5g75rf83wkybmsqshvx3hx9gf9",
          topSection: "PSPDFKit-k2d9eapy94sjetk94kep995vs",
          bottomSection: "PSPDFKit-8727zt9sqkbkpmkyjv42frxabg",
          signUpButton: "PSPDFKit-77ehu16zxj84xk3794yaypyfn"
        };
      },
      83181: e => {
        e.exports = {
          container: "PSPDFKit-87k1yb2m56xugj11pvrn2epwmr",
          icon: "PSPDFKit-3s4vm3fcksqsg2getabuj9bha4",
          "icon-regular": "PSPDFKit-g3g187c7zezz65j88wexd218w",
          "icon-error": "PSPDFKit-568kqv9a573y6cm3j1y6xs5v62",
          "icon-success": "PSPDFKit-287v657mcme5ewwt57t23w5qyh",
          iconBox: "PSPDFKit-3m2rqse7rv63dfkwgvcjy19997",
          alert: "PSPDFKit-3eq8gr4w2wkxz8kcemn3feckgz",
          dialogButtons: "PSPDFKit-7qjt9yezkrce9kdkn11wwk7ntz",
          unlockEnter: "PSPDFKit-5r5qzyzhnat22bqdytrnu5ageu",
          unlockEnterActive: "PSPDFKit-678vkyyxar4zfmqvz19pk1gg7c",
          unlockExit: "PSPDFKit-g25477hjsg4skgtpfrw93sj7u",
          unlockExitActive: "PSPDFKit-3vp9fnny3e7hxta8yxd6jaxea4"
        };
      },
      1079: e => {
        e.exports = {
          blockContainer: "PSPDFKit-8am3xt8zzjm64r49rez8ukprpf"
        };
      },
      40573: e => {
        e.exports = {
          element: "PSPDFKit-5adgrb7yvngqk7tujcpr5rc3aj"
        };
      },
      40193: e => {
        e.exports = {
          root: "PSPDFKit-5e6tnwkxw9ka415svsdkkptcvx",
          "deg-0": "PSPDFKit-5scxecvmyvz7wahnvpvhqf1u6n",
          "deg-90": "PSPDFKit-4f127napxmw48wj78u1h4t24d5",
          "deg-180": "PSPDFKit-6ncgj8zzkc4v2az5nh5414n95b",
          "deg-270": "PSPDFKit-2a2y9pvb8su899gfj1wsz2ta6n",
          image: "PSPDFKit-863nmkfmtuh7z8chsq5cfw6y9h",
          textHighlighterMode: "PSPDFKit-q7ejbjhybhuyqgmj1yb6a4f56",
          focusPage: "PSPDFKit-8hbgq8hdkhtfm5abztpkrkdp87",
          hideCursor: "PSPDFKit-87pd6mukheqbugejr1g1n3es7w"
        };
      },
      26564: e => {
        e.exports = {
          layer: "PSPDFKit-7v6us4bgaesz3ux74pvm4adq66",
          overlay: "PSPDFKit-3p1jq2xuq7kt61btvzbmcvfsdg",
          linePadding: "PSPDFKit-4sqvdfhz56pzjs657n5gmfjv4t",
          preventUserSelect: "PSPDFKit-7mqrwx6ruetyxx1crt7g8tj53b",
          lineSelection: "PSPDFKit-87rsspmjgdj1nr79j5xt1zpxef",
          line: "PSPDFKit-8ayy4hjz5h5sb5mqfjxzpc42zw",
          chromeSelectionWorkaround: "PSPDFKit-55tte6u6fczpks4kxqrywvkhcv",
          lineTextCursor: "PSPDFKit-3npj2ht4kppfp95hepqhfjb49x",
          vertical: "PSPDFKit-68wd7m2jrz9c462vgy6yvba62f",
          enableTextSelection: "PSPDFKit-2tg9p1utsyyke5vpebq5gc3413",
          debug: "PSPDFKit-3a9hp6ezp9vyzwpeksepg43552",
          selectableText: "PSPDFKit-6fq5ysqkmc2gc1fek9b659qfh8"
        };
      },
      15743: e => {
        e.exports = {
          tile: "PSPDFKit-2ef7r6efsekvzma2acw68z2wsd",
          tileChrome: "PSPDFKit-74yvexyjr8t4ns42jhvu6euzjz",
          crispTile: "PSPDFKit-8qymj2kknqsa216hrbd9qhuh5b",
          tileSafari: "PSPDFKit-8yevkzm64ywt19z5trdgvvvu8n",
          tileFirefox: "PSPDFKit-43q2x5xuukayeyf9pnsf3s8vxv",
          tilePlaceholder: "PSPDFKit-4uahg5akq9ua7h3n6r45t9pnv1"
        };
      },
      89359: e => {
        e.exports = {
          tooltip: "PSPDFKit-818uepd2971vwf3fmcn6tbacgg",
          arrow: "PSPDFKit-5zd14p1pfpmy1ny1f8skcknw3j"
        };
      },
      66645: e => {
        e.exports = {
          popover: "PSPDFKit-538wj3bujswdrqewakmmxa9fyf",
          popoverHidden: "PSPDFKit-8ahxg2rbtxn2ubnutukzs28dqn",
          container: "PSPDFKit-4jrgdk842q6nrzgfag4cvz7hsa",
          innerContainer: "PSPDFKit-7bx43nrztecej9c1j8qw9tshdy",
          title: "PSPDFKit-7w1dhbtytq2jfdb48gs1ywe8jm",
          content: "PSPDFKit-7dajp2vmg4zxw9ambet64n9umu",
          footer: "PSPDFKit-2wtzexryxvzwm2ffu1e1vh391u",
          footerButton: "PSPDFKit-239sjtxdzvwfjbe3ass6aqfp77",
          shakeEffect: "PSPDFKit-41mt66hwvjgy4qa89c1mtspd1a",
          shake: "PSPDFKit-7y3ggnb1s18b42w9z9msgq8hr6",
          centeredTitle: "PSPDFKit-79jfh5ner7hhtyf4y5s4u8az38"
        };
      },
      54146: e => {
        e.exports = {
          root: "PSPDFKit-8djq2v9hms33ptxdax4spyth66",
          arrow: "PSPDFKit-3msp5htb4zsdjjpxv5m6zezhpm",
          arrowTop: "PSPDFKit-6b9stttuxax9qewr2yxczpv3yz",
          arrowBottom: "PSPDFKit-6zjksunaugtab91x5bucrc5pa6",
          arrowLeft: "PSPDFKit-6bfp163dnjfdkd9f9m84znw1uj",
          arrowRight: "PSPDFKit-7es6pryn4pwz64rxf4payggfh1"
        };
      },
      23514: e => {
        e.exports = {
          root: "PSPDFKit-twmttjfcv6j7rzbc8ybn7jhdf",
          inner: "PSPDFKit-6stgnz1576bk1x1pc2nvf8mswa",
          separator: "PSPDFKit-47apua2t9uqk8xayrhg2x6bxwp",
          button: "PSPDFKit-dcqzrnymm6bk9dm2mrhum7xwe"
        };
      },
      14883: e => {
        e.exports = {
          root: "PSPDFKit-m8vcznd3skqsshg6rhqg119mc"
        };
      },
      48731: e => {
        e.exports = {
          root: "PSPDFKit-5m6rrz61wj3npfybbf6bf7n132",
          noToolbar: "PSPDFKit-kygm1cgnwkp9bv59ggpqfyv9j",
          searchBox: "PSPDFKit-3zeygmv635dt4bunbqaw9pc4vc",
          input: "PSPDFKit-882tgx1vetesc36x9va6ha65fk",
          results: "PSPDFKit-8eacsmz4utrfkj8dhzhdh842ct",
          resultsDisabled: "PSPDFKit-4ysp4ac7wzfr8k1j96hrpb6232",
          button: "PSPDFKit-3mm3z68vbg9jrrv8ctujsff2j",
          control: "PSPDFKit-6jsphwggasn3qhq6cpukr87kyp",
          next: "PSPDFKit-the91ha3x5196stsyerdyzwb2",
          previous: "PSPDFKit-8sbnka5652yjkubedgurz66zwq",
          icon: "PSPDFKit-6p53nwyvjc1gsacy8fr4fac4q4",
          iconLeft: "PSPDFKit-5q7decz5hdban3tfadcauvj14t",
          iconRight: "PSPDFKit-7uhhgqhkvcnxbwk9kfhjy9v9yt"
        };
      },
      99135: e => {
        e.exports = {
          loader: "PSPDFKit-5e2eu5vu2edrbusdw9chj1k5ya",
          searchPosition: "PSPDFKit-qrb6rv4vd7m34wj2w85zjxjfu"
        };
      },
      63124: e => {
        e.exports = {
          layer: "PSPDFKit-4hndx219v53cj6xkbemwdxxfbp",
          highlight: "PSPDFKit-6q1j1fe91dp7b7uxu21ghbjvam",
          focused: "PSPDFKit-2m3zj91uw1smew17zjaj1g3xfx"
        };
      },
      78055: e => {
        e.exports = {
          sidebar: "PSPDFKit-wqnk7x3sp9sp2zkcvbfawsb6r",
          sidebarHeader: "PSPDFKit-6zdf5v5224wp5vu92pkacn6sx3",
          dragger: "PSPDFKit-4bvu69j78qa67c4wqqxaxrqbs5",
          draggerHandle: "PSPDFKit-6dtj44vm5qz5vw1njqxgaem7na",
          container: "PSPDFKit-2x4gzue77m9rd4f4ax5y9e5wj1"
        };
      },
      44170: e => {
        e.exports = {
          root: "PSPDFKit-6r17fy6uh5kqy3cfjb73vq9v1v",
          expanded: "PSPDFKit-2uhz161knhrkpzrb5mn5na3aqr",
          content: "PSPDFKit-6jgwts4kv8dr7cftse42cxk2z3",
          left: "PSPDFKit-4hphv7cb89h1ffw9ptvmg9xjt8",
          right: "PSPDFKit-86nhzcde1runqybnpjzcykq7ex",
          mobileTextMarkup: "PSPDFKit-2qbav5sard6dxefsy6p5gufajq",
          stickToBottom: "PSPDFKit-318vz1kpftbtjp8eccy824g4m6",
          fixedHeight: "PSPDFKit-78mpt2swt4apfep3ag7quqq6me",
          control: "PSPDFKit-2uws3ww83fja6b3syxj88szuvh",
          selectBox: "PSPDFKit-532n3mbvmujvwmv3zweh7u59u7",
          textFormatControls: "PSPDFKit-8b7caq86m7x4bkzf3ecjwqesrz",
          controlWrapper: "PSPDFKit-xmyz8vgna6pqfkw4wx1twayf1",
          controlWrapperAutoWidth: "PSPDFKit-559g7qqwsyx86ydrj6d8x6kwqz",
          separator: "PSPDFKit-4cjwhud83czuezgnpqtt8t1g4y",
          form: "PSPDFKit-6x3mktvp3y8yqny5uh5ph6t27s",
          formGroup: "PSPDFKit-6f2cfyrxss9tgjemae8n6d2v6x",
          button: "PSPDFKit-5qha63wcjhyk977pmb11w183gf",
          rotateButton: "PSPDFKit-3zswrctphfm56abme3mhe89x7j",
          measurementToolbarButton: "PSPDFKit-5d6y6gzx57mzvk4ghwgz8bysng",
          iconOnlyMobile: "PSPDFKit-56zcn74uwt3jmwt9eqt4nkmm3w",
          blendModeSelect: "PSPDFKit-7tafq9cxvp7fp9488nkv4gt1q2",
          fontFamilySelect: "PSPDFKit-6panjxae2rqax33e2x13v8zhd7",
          fontSizeSelect: "PSPDFKit-4aap34xg2exyha2wvgep2kbrsr",
          colorSelect: "PSPDFKit-63mkqz864gr762bjh37u3z33ks",
          endLineCapSelect: "PSPDFKit-7ahby6faw9zgpdmzru1qdud52z",
          startLineCapSelect: "PSPDFKit-7bb9twn4c2xfchvdyv1arjd4y1",
          strokeDashArraySelect: "PSPDFKit-64yekz19k5s2s3kk34sutarr9w",
          colorSelectButton: "PSPDFKit-6e37e5hxgedzhdzpj3bgcfw8wg",
          controlIsDisabled: "PSPDFKit-4b2dydfrvtffvsbyz6hjmmskx3",
          textAnnotationOpacitySlider: "PSPDFKit-xjmpbe2ndu31ngzn7k6thcce2",
          annotationNoteButton: "PSPDFKit-8b5wugfkhy83qz3mrt12xxee7b",
          deleteButton: "PSPDFKit-3pw5d71zmdn7g2d7f7cezqab2k",
          buttonNoBorder: "PSPDFKit-7hhujt42dfa3wavves9fezeqju",
          noteIconLabel: "PSPDFKit-6kwwztxzkww77985knzv4yj25t",
          applyRedactionsButton: "PSPDFKit-dh9zgevasabjjq92gftvq7d1s",
          formDesignerButton: "PSPDFKit-6hwd5kb669g2rktq8z7tch8zey",
          isActive: "PSPDFKit-7hajh57r86sbfab9agdabjpdus",
          disableEditing: "PSPDFKit-qq4v7j3ztmbsu7sszn7n6eedz",
          disabledButton: "PSPDFKit-53qj5y7xwpxf385e5qupnueez4",
          icon: "PSPDFKit-67g1s4jvmu1dwuq693983pavtq",
          focusRing: "PSPDFKit-p3fhayknwfc2wy838mm6uf6ts",
          fontFamily: "PSPDFKit-7pxe4xgby27sg3gch3hgymc65k",
          dropdownMenu: "PSPDFKit-3fr3j3qzhb8zms4ha22gf8ap4w",
          warningButton: "PSPDFKit-7vux3363c2h5bhhue8x2tgc2d8",
          warningButtonIcon: "PSPDFKit-55tsnvt1cbusd6n1b314embzfj",
          radioButtonWarningLabel: "PSPDFKit-ve8hjm9h24pnag6snsj5hqyba",
          colorPickerDropdownMenu: "PSPDFKit-364rxkqcrexqk43jvg479qt5us",
          colorItem: "PSPDFKit-7fb12eurd4ysp5ys7tc9wgnuqm",
          deleteButtonIsVisibleInTouchDevices: "PSPDFKit-5rx1gxu9ku1pmjedwxt4bb8tcs",
          colorSvg: "PSPDFKit-2v57cb7nenh6qvs2r55dm7ftbf",
          lineCapsDashArrayMenu: "PSPDFKit-42uwtdws1bb24aernmbsz8ndnc",
          strokeDashArrayMenu: "PSPDFKit-8497hrdu98kjamf5s4gjf2bqmd",
          nativeDropdown: "PSPDFKit-3c6frtkm4xmn7hkv9bmpghx53j",
          fontFamilyNativeFlexbox: "PSPDFKit-3smmwjpf56cyb4zkshtg21jz2s",
          fontSizeNativeFlexbox: "PSPDFKit-7bwhutmv5jg6hggz6hp8kfcaxy",
          fontColorControl: "PSPDFKit-2zvhj3he31vtfrqjkjpsjb1694",
          overlayTextInput: "PSPDFKit-823r5gtrunhm37br45pwje8e5c",
          overlayTextMargin: "PSPDFKit-65ynqjj3xqcettebe26255q3ky",
          groupWrapper: "PSPDFKit-j3u5td7da5d2g12j3qb8kpqeq",
          groupDescription: "PSPDFKit-74acavk6n23dwq957gtnmbyyrf",
          overlayInput: "PSPDFKit-6dqybwsyjvqprdkfh1d5t3w2yj",
          radioInput: "PSPDFKit-87t3tq755fdm56p5111u2h5a4g",
          applyRedactionsWrapper: "PSPDFKit-4ssbr6rxv19yz6yh7bjp4pfgeq",
          customIconSvg: "PSPDFKit-p9ftrww9ym9pd2eqpps4xf6fp",
          snappingCheckbox: "PSPDFKit-68jg3chhe27v2qnds97q2btw4c",
          radioGroupWrapper: "PSPDFKit-3hf9zjqgg3t2aehba45fzmw9nc",
          reverseRow: "PSPDFKit-4g9caken58dfxv7snyka36rppq",
          measurementToolbar: "PSPDFKit-4pfvumqbpr5cct3yusfvsb8cza",
          measurementBackButton: "PSPDFKit-5mpcapg77fbdwa2sj3mz1x79hy",
          pointSnappingToggleButtonWrapper: "PSPDFKit-8bdhrea5ynkgph4wjuf7eenccs",
          pointSnappingToggleButton: "PSPDFKit-3jwjxf3q3tc2mjebw5qwnndfvn"
        };
      },
      17448: e => {
        e.exports = {
          root: "PSPDFKit-369qag2kn88x7fd7hzmy37u7jj",
          expanded: "PSPDFKit-s88hmm2u6mr4p6a34q6p5x97j",
          content: "PSPDFKit-2xkt2dmssjrt1zt3392unparpj",
          left: "PSPDFKit-22vuhdxbyg68mzx1mpbw51te8s",
          right: "PSPDFKit-8yz513hepw5dtea8yuyyc36z3g",
          mobileTextMarkup: "PSPDFKit-7p5sgv4my75nm8c7s61pavhw9k",
          stickToBottom: "PSPDFKit-4s922kjq16ky2tuz2stu8cmevf",
          fixedHeight: "PSPDFKit-3yctv5gp7m63pzzfqmcn2vwzsu",
          control: "PSPDFKit-5c3edpftcxt25778bnf8dge8wm",
          selectBox: "PSPDFKit-2td3u6fzb1juvzark5t2sx4q2k",
          textFormatControls: "PSPDFKit-5aqdkx2cvj2jkgvavhn63b9ng2",
          controlWrapper: "PSPDFKit-56wa92tpx7h9ndndf4p4ntj594",
          controlWrapperAutoWidth: "PSPDFKit-7yq1g1auatabjgr9redkv9mw4z",
          separator: "PSPDFKit-4dbdwzw5vf7q7u9tzye7tg1nrb",
          form: "PSPDFKit-6k49n5ndgcc66dsatpj5sjmvzv",
          formGroup: "PSPDFKit-6daq73jrkrpvw8as2bjg158s14",
          button: "PSPDFKit-fcgb4uy1g1393vcttkd834zya",
          rotateButton: "PSPDFKit-6yuyamdwf1rrwnzc2w8fqr4pjd",
          measurementToolbarButton: "PSPDFKit-29bp4qx2ar9g3bkzyq9mtha47h",
          iconOnlyMobile: "PSPDFKit-57jstkypwesnde2vkmqgh9jdhc",
          blendModeSelect: "PSPDFKit-8925upm91judwppvv9p55bukww",
          fontFamilySelect: "PSPDFKit-6j8484gf6zuru867h7zbjhwpsr",
          fontSizeSelect: "PSPDFKit-47dkg274amuhtuvgmphaa3qbp8",
          colorSelect: "PSPDFKit-6kf14wyby256uusycuansuqden",
          endLineCapSelect: "PSPDFKit-496rvwdezqxaryf6ba6wew6ysj",
          startLineCapSelect: "PSPDFKit-628jqdm82emd3wd8ywct68fvp2",
          strokeDashArraySelect: "PSPDFKit-6fdkgc1bgv67zv1wegm6hsq355",
          colorSelectButton: "PSPDFKit-58854re4pgbwg56mdaznmjjscz",
          controlIsDisabled: "PSPDFKit-5z4at4466ca8t6dkug1bqpq81",
          textAnnotationOpacitySlider: "PSPDFKit-8uywmag1h1x3ypdz5b98crr775",
          annotationNoteButton: "PSPDFKit-8tn5aruncqkpg83c6e9e6yv53r",
          deleteButton: "PSPDFKit-59bjkj2c9dfb828xaun8u4uq5q",
          buttonNoBorder: "PSPDFKit-5gsachaj1r6ar3h4ru679tq718",
          noteIconLabel: "PSPDFKit-4bkwv3nn67k2hqt55w19s4dvs4",
          applyRedactionsButton: "PSPDFKit-4bdfdwv6dxjwygm9tw1zmjrta9",
          formDesignerButton: "PSPDFKit-3pymza1pztyu17t83dfx3cmmsm",
          isActive: "PSPDFKit-382u1rdjb1tf6tnk2q2g7kgvgp",
          disableEditing: "PSPDFKit-48d85wg1rgb1utxa2a4fvw2vth",
          disabledButton: "PSPDFKit-cmgrqrz9uxy4sb9vg43t341c1",
          icon: "PSPDFKit-8xb3dqw6xuht2n573uhuknfp2k",
          focusRing: "PSPDFKit-52c5dtm21r4933mu2fkpjpe6uk",
          fontFamily: "PSPDFKit-5kgz7sh1trs8k2a4xw51qvusej",
          dropdownMenu: "PSPDFKit-psd9e4tcte8ac4k6jmkt1wfeu",
          warningButton: "PSPDFKit-8zkbczvhbtdyv5utgdt42896wt",
          warningButtonIcon: "PSPDFKit-2bmrfq7hm8z4thd49fdtpzxewe",
          radioButtonWarningLabel: "PSPDFKit-6q2rpnx5br9xmymy4hxdvc9atg",
          colorPickerDropdownMenu: "PSPDFKit-mjt1a3qgrvvxan7b2eet56kkt",
          colorItem: "PSPDFKit-3radjttaddx7fe6dnnreugbam2",
          deleteButtonIsVisibleInTouchDevices: "PSPDFKit-7uud28jq3crfqs4f4edufdekkf",
          colorSvg: "PSPDFKit-5jpt4x4a9kj7rf7d24shsfp48k",
          lineCapsDashArrayMenu: "PSPDFKit-3fweswjpkq7dt55fw6t438rgun",
          strokeDashArrayMenu: "PSPDFKit-3hmu51e1ur6hrmfyzz2cru1c48",
          nativeDropdown: "PSPDFKit-5fwcr59aaugp5fp73hthrqwxw9",
          fontFamilyNativeFlexbox: "PSPDFKit-5p5hpd3y1t7kjkjpn6cyqaqptj",
          fontSizeNativeFlexbox: "PSPDFKit-3v6m9ae9v1gsx87x46mg6kjmzf",
          fontColorControl: "PSPDFKit-67wu3hjpwubg5cqg8c94vydj5a",
          overlayTextInput: "PSPDFKit-41gfyk1yj6dkqvg8px6c7j3sec",
          overlayTextMargin: "PSPDFKit-43q9sy7pzu933w9kdbph2ahftx",
          groupWrapper: "PSPDFKit-77hntfhrv9fmz6c5684u5bkz7s",
          groupDescription: "PSPDFKit-7kmmurpd341ujzyvezu9ecj88h",
          overlayInput: "PSPDFKit-3fu4z9m4y47mmezmqbsmsg6u6f",
          radioInput: "PSPDFKit-8pbq1nn2qbdp1czxjuu7bjw2ks",
          applyRedactionsWrapper: "PSPDFKit-6w6h956ezp7gtq4cmy2r5mkyhu",
          customIconSvg: "PSPDFKit-6ep9xddvqffd53nu5e72pbdbgj",
          snappingCheckbox: "PSPDFKit-717y4rg4qa1pc652h8cg793m4d",
          radioGroupWrapper: "PSPDFKit-4xdm97phakaezcxf6wpdxn2tjm",
          reverseRow: "PSPDFKit-62hyggwkdx954k8f821btn7zeh",
          measurementToolbar: "PSPDFKit-2wv2dfhgdk3dpbha4mv9u16vs",
          measurementBackButton: "PSPDFKit-6dpm8fme3awumu6c44rktfucs2",
          pointSnappingToggleButtonWrapper: "PSPDFKit-4y4mzezsayhjmmtm9qqkgywcsh",
          pointSnappingToggleButton: "PSPDFKit-8grpnn6cc1r855m2st438et1tg",
          container: "PSPDFKit-zmwf99thxv6fcrc5fedznzzbf",
          buttonContainer: "PSPDFKit-5xkwu35z1pdufxyge2fpn149wt",
          contentEditorButton: "PSPDFKit-8p5cvevhmuv7u5wjndvwnbnu5w",
          saveButton: "PSPDFKit-2aekynqmf5d2unsgpe2a63pqe7",
          fontStyleBtn: "PSPDFKit-tb2p4fkm5haam7ptsvqb6c982",
          fontStyleBtnBorderless: "PSPDFKit-5hv5vgzkpzspks749ufhhvfz1k",
          activeFontStyleBtn: "PSPDFKit-3y1g2avp88swge652xu9nj312z",
          iconButton: "PSPDFKit-792vfa9s6t83dgghq4y7ghk2fj"
        };
      },
      17223: e => {
        e.exports = {
          root: "PSPDFKit-6wj1ne12vnarkud1xme1m8q59e",
          expanded: "PSPDFKit-8dvj6jpqdurcexw9s38nyrdusm",
          content: "PSPDFKit-ng2p7yzx55dk3e8yd33ucyq3w",
          left: "PSPDFKit-2nxj8qm7t143fbftj5wc5fkpmh",
          right: "PSPDFKit-8hmxpj5ufr2dmugsrzsfj5w24w",
          mobileTextMarkup: "PSPDFKit-5whgpdfnjnj445bw24d7d2eepu",
          stickToBottom: "PSPDFKit-qg3hbxzy2wa7d7kn2kyb5hfg6",
          fixedHeight: "PSPDFKit-fw1d4hymsqsunxnj7htn2vejg",
          control: "PSPDFKit-cvx8h4gvhqzqc8bb9wcmvaxnc",
          selectBox: "PSPDFKit-8p1jwd1vdxc1uu5kv9x8p6kgp5",
          textFormatControls: "PSPDFKit-4tf1hj3ua2348x3vfjq2ckjdzj",
          controlWrapper: "PSPDFKit-698j5mv28ddfb1zzrmuuvu4bgt",
          controlWrapperAutoWidth: "PSPDFKit-8rw1bsyhe4kbrshjzkbxn2pxt9",
          separator: "PSPDFKit-2p1w8qyfeab7u2r61e5xm9basn",
          form: "PSPDFKit-7x5nveetga7f3u3eyhc2y9z693",
          formGroup: "PSPDFKit-4m86pvrmtk7xh9sv3z47hqfan",
          button: "PSPDFKit-8sgpeb7apq77q6pg14srm485gf",
          rotateButton: "PSPDFKit-67pvyt6s62cm85bnpjx6pbnnxh",
          cancelButton: "PSPDFKit-8cc6ksf43ant6wkp5gxwmyn376",
          measurementToolbarButton: "PSPDFKit-5pby2mjv6be8mvvy41rpp7dkwn",
          iconOnlyMobile: "PSPDFKit-2rtyr394stgbvv5j9jd2mrzx4w",
          blendModeSelect: "PSPDFKit-56zf8cu97f7wx6varc1jbjbc1t",
          fontFamilySelect: "PSPDFKit-322qz987bpbdyu82atqpttzvvy",
          fontSizeSelect: "PSPDFKit-3spwsrcuq4a58mafezc2hew2hm",
          colorSelect: "PSPDFKit-4evwmwkh2v68zx97dy8htnw1he",
          endLineCapSelect: "PSPDFKit-5g195rx1hwggkduwfaghaguwp8",
          startLineCapSelect: "PSPDFKit-4h81esfk99wjjw1j1e4evv86k6",
          strokeDashArraySelect: "PSPDFKit-8vcucy3gdsu18nrccy3sfz6e8e",
          colorSelectButton: "PSPDFKit-47tvrbutrws584y86zkht7ugrh",
          controlIsDisabled: "PSPDFKit-3z6z4mnx2mybf2dduwbnu4ghbx",
          textAnnotationOpacitySlider: "PSPDFKit-7dcpygp7ucqsxtt8jqu8wqaek8",
          annotationNoteButton: "PSPDFKit-2ztmuxhn7vkbcnujg5fjs2nxk6",
          deleteButton: "PSPDFKit-74uqksjtt33kw457gbgm6cjhar",
          buttonNoBorder: "PSPDFKit-wnrcu53f16qwbavnhtrcsrvtt",
          noteIconLabel: "PSPDFKit-3j7ttk21fapf4hjzymwfaax2pp",
          applyRedactionsButton: "PSPDFKit-4jweuxb68jk1sdm8kfuh5e2v3b",
          formDesignerButton: "PSPDFKit-26sazeqcf3gq4uzpnpv7rxy5tc",
          isActive: "PSPDFKit-36xa88kvhztmqf3w9bw4r5ux2b",
          disableEditing: "PSPDFKit-7ksmq2q9vqb2a84h6pknr59vq",
          disabledButton: "PSPDFKit-4frspfy8ydaf2dspz1w2fe24sm",
          icon: "PSPDFKit-6a17y1zq5nmhnd7rsvvnnp3u82",
          focusRing: "PSPDFKit-2kd6b54vbgtjvjpw1vfjnz3gxa",
          fontFamily: "PSPDFKit-5ju67k328yc7tj3jx5vxn2tn9q",
          dropdownMenu: "PSPDFKit-4rm6x2vr78j36rwf82x8zcfxaf",
          warningButton: "PSPDFKit-2jdyb25hw79fahb16kjd7nuauu",
          warningButtonIcon: "PSPDFKit-6gnk29arwa3bmx79suwfyneh29",
          radioButtonWarningLabel: "PSPDFKit-76w7jmjqqnsz53a6hk7gjuqjfv",
          colorPickerDropdownMenu: "PSPDFKit-7xact8a8nm7egrfqd6jm8dexja",
          colorItem: "PSPDFKit-5swkhzjuhg7a1yzus1srcazf4",
          deleteButtonIsVisibleInTouchDevices: "PSPDFKit-6j136ndjfdbtgth4w1223r3b8v",
          colorSvg: "PSPDFKit-53pmrz6mhqkv25rduwt3r74tdf",
          lineCapsDashArrayMenu: "PSPDFKit-6kht9xjauanscqhyehtvh2m7kf",
          strokeDashArrayMenu: "PSPDFKit-64qwd21qw14a1hs2qywq9dktfv",
          nativeDropdown: "PSPDFKit-51ppvqecyde7wtftnkhpvreywa",
          fontFamilyNativeFlexbox: "PSPDFKit-47ujkffabzpr19w6jed6s7rn8s",
          fontSizeNativeFlexbox: "PSPDFKit-79wa34vt8h1dey55mwshznckvh",
          fontColorControl: "PSPDFKit-59kfug1yak6p54pbhwzyzp8nqv",
          overlayTextInput: "PSPDFKit-2bv4uu555xwcfzm4cbz9xw1575",
          overlayTextMargin: "PSPDFKit-7y73pgnyhcbyab2r86s5wpf3tq",
          groupWrapper: "PSPDFKit-3n3jywv8np58aypaxcq1dxaka4",
          groupDescription: "PSPDFKit-7h2nqj8dz99huxsdvz85vzqtkv",
          overlayInput: "PSPDFKit-3sskmdn9q2pttd7gnbgtfx1svm",
          radioInput: "PSPDFKit-5161whx8v77nvzdxwn92nren7h",
          applyRedactionsWrapper: "PSPDFKit-35zv6qfn2dk55st59jvbvkebe4",
          customIconSvg: "PSPDFKit-6zcvxqm7p1fu6peaqcvy1ggxur",
          snappingCheckbox: "PSPDFKit-87rtaenbkbsa4vh76fdk49yn3",
          radioGroupWrapper: "PSPDFKit-7n79z1dfc6drdkd4q859desfw4",
          reverseRow: "PSPDFKit-7h73prxvatb9v6feg135wrgpnu",
          measurementToolbar: "PSPDFKit-7ftvxz7pwnjfrf9p9bvx4kdaem",
          measurementBackButton: "PSPDFKit-5zxmaq2rs3z7z1ycb76vnfp8s7",
          pointSnappingToggleButtonWrapper: "PSPDFKit-54tjnzkmwp6xxxj9x2w181zxyx",
          pointSnappingToggleButton: "PSPDFKit-4jxexvux8xqt39asa2n5j1bhaz",
          container: "PSPDFKit-2zcrcumxc9rs6exf4ygg6wxhud",
          buttonContainer: "PSPDFKit-4su7z3fj53danm9m8sfmsun6mh",
          cropButton: "PSPDFKit-3fqbszrmhfm53fj9m672rspbb9",
          cropButtonDisabled: "PSPDFKit-3yfe86869dr14nnq3hdqmpstt3",
          cancelDesktop: "PSPDFKit-5q4w3drt2wva22st2m2zv3jdy9",
          cancelMobile: "PSPDFKit-46c99tbpsdnq21yere2qsvz9cs",
          desktopButtonText: "PSPDFKit-5uhy32eduhqeagjxsx8v1dsupn",
          mobileButtonText: "PSPDFKit-89hzg3dmpqdp1bb33by963n2me"
        };
      },
      92294: e => {
        e.exports = {
          toolbarReferencePoints: "PSPDFKit-3j4jdq7qz2dwxa1279k9vazwef",
          documentTabActive: "PSPDFKit-69m56fu4j9n82gdbujywja2gvt",
          toolbarReferencePointsSet: "PSPDFKit-8eej8fpcv5wjeexf54uv82ajge",
          referencePointParent: "PSPDFKit-5ryk8gx2yq84us8ukyczpsxy3m",
          documentText: "PSPDFKit-8rqw29ppj2w4yuvy43x1xrr11j",
          mobileText: "PSPDFKit-2we2fxduv62wzemn8q1msf1mgz",
          documentTabActiveText: "PSPDFKit-4dxpfmdzs1ahjnhcn4j2824q7j",
          separator: "PSPDFKit-xy1ab3hf7etfk3xyw2jg4queq",
          toolbarReferencePoint: "PSPDFKit-3wymx3u415ps1255jfa43bguba",
          documentTab: "PSPDFKit-4a9v7b75g9brahh3mp79eahacf",
          toolbarReferencePointMobile: "PSPDFKit-4negp1qnzp2hght5fzzkb948bq",
          second: "PSPDFKit-4aha149mn5fr2qf7nm9vv3s1e8",
          checkMarkSvg: "PSPDFKit-8vq8197jb1dah7zkt2cj4puza6",
          checkMark: "PSPDFKit-5vyjan5cx19u6zqmpkyk5y6n4m",
          documentCheckMark: "PSPDFKit-8y45regm71axdj29fvpdnyyqw9",
          referencePoint: "PSPDFKit-8kjh85hafnnbaywytk891yszzy",
          referencePointSet: "PSPDFKit-5u4fqe6u9h9335r2untkufbfcj",
          autoCompareTab: "PSPDFKit-3a6ss6w8kz4a9bg1ppdxs9wfjn",
          mobileTab: "PSPDFKit-4ws5865r8ddf7waw5w994xbgka",
          resultTab: "PSPDFKit-63wgvxgkew5y5nngyepzsvu4me",
          root: "PSPDFKit-5g2uumfazey6jk28fuu62t1ku1",
          content: "PSPDFKit-49apg3ban7f6z5tha93nkbxpj4",
          left: "PSPDFKit-46dnp15jxsmbmfb4w9u1ffee2p",
          right: "PSPDFKit-3bsbcmmu6v14v6bf89hvv51u6r",
          mobileTextMarkup: "PSPDFKit-54wvq7waj941tcr6uq8dg63zsm",
          stickToBottom: "PSPDFKit-84kxsxx785v52177eqww89wnfu",
          controlButtonContainer: "PSPDFKit-7vccbh9nhre14pssj1cjg5ykph",
          tabsContainer: "PSPDFKit-6q2z53f1kt5u3frhayfupey174",
          buttonAlignDocuments: "PSPDFKit-6qd7xqnwwt5spedkqzrq2xxd1y",
          buttonExport: "PSPDFKit-v7w7h5tnf2m47yzqtd84h1drm",
          buttonReset: "PSPDFKit-kfexhdzwencygrragmhzwd8v3",
          mobileButton: "PSPDFKit-67ced71xr6v9qcqegyjdb8f9h2",
          buttonAlignDocumentsActive: "PSPDFKit-2wue8e3wfu7w9cxehmz4e88ktt",
          buttonExportActive: "PSPDFKit-5p1uejfqckjn5s61nuatmaqbme",
          buttonResetActive: "PSPDFKit-5jfgm1cjfd1sp4z1fkd6a1hcc7",
          form: "PSPDFKit-6s9dcaafj7ab6mc6ktq5xn5tw6"
        };
      },
      40775: e => {
        e.exports = {
          root: "PSPDFKit-8mw7cgx9nrd1yg35kkhqyhksqy",
          expanded: "PSPDFKit-3e1ymauppttrz41jzw3mzc2t65",
          content: "PSPDFKit-2eu14kmrb8nn2j13et7k8kxgy2",
          left: "PSPDFKit-768zuvadpfp2s99ztcwnaee5jp",
          right: "PSPDFKit-263brxaxc464ym7sfe4phds8ah",
          mobileTextMarkup: "PSPDFKit-39d47rs5fq7kcjer959hp5rx8d",
          stickToBottom: "PSPDFKit-8y6ce6n5884k7zrpr3uqnz7htb",
          fixedHeight: "PSPDFKit-pqz79rmnz1jk37ra4q9jr8t33",
          control: "PSPDFKit-628h193kd9qu5d9hhsg3cdnuza",
          selectBox: "PSPDFKit-6nbc7qagvqu9yd6yet13hb6rhj",
          textFormatControls: "PSPDFKit-48x8nkebmfpqss6a3u7rs8g9q5",
          controlWrapper: "PSPDFKit-5m1cnawh6718mpdfvfzbb11abd",
          controlWrapperAutoWidth: "PSPDFKit-7ntyew6gjjyyu8e3azuddfrhnp",
          separator: "PSPDFKit-6c1mz88rtks35wu1xhbrekd71a",
          form: "PSPDFKit-t6r39wvb2q9vjm8wcyu4ean8",
          formGroup: "PSPDFKit-5nvf2c6yp9b7ynxetxyjq8ejcn",
          button: "PSPDFKit-39fu85k99jh2maw1gkthhh4pas",
          rotateButton: "PSPDFKit-6usxmcuq89wy8smur4v8ryhswg",
          cancelButton: "PSPDFKit-3dr4ygvb5bf362jg5fmzym38e3",
          formDesignerButton: "PSPDFKit-6y1y58bqs19k64pa2axe4rgkgj",
          measurementToolbarButton: "PSPDFKit-8tz941rhqxq9a7km8terwandnm",
          iconOnlyMobile: "PSPDFKit-21jwyumejben4aqq13bksg3xh8",
          blendModeSelect: "PSPDFKit-75ttad8xww9mpzzprak2aac974",
          fontFamilySelect: "PSPDFKit-6ft5xhbubs9uamqn8s4zfnq4b4",
          fontSizeSelect: "PSPDFKit-w47nwqgy1154yrmztu2mnwzpm",
          colorSelect: "PSPDFKit-2bnqvejyfcr2xpnvmzxrzqhapp",
          endLineCapSelect: "PSPDFKit-zxa6uqty5r8s91cyrkfmxkc93",
          startLineCapSelect: "PSPDFKit-275wshr5dpqatccw8ux11qqk9s",
          strokeDashArraySelect: "PSPDFKit-3hxmaadpfcejwvjvjd3srb4nq4",
          colorSelectButton: "PSPDFKit-7ub6g8tsdw1g86bt2kvn83wa7p",
          controlIsDisabled: "PSPDFKit-48byv3uppm1nzjqfybkzwnzjf",
          textAnnotationOpacitySlider: "PSPDFKit-8j3bg3d3dbcpkjba4qpgt6mtwx",
          annotationNoteButton: "PSPDFKit-7ryrry1x131tjsax7f4kwd8zfz",
          deleteButton: "PSPDFKit-4fg19pph8cyagbqvnfr8fms11",
          buttonNoBorder: "PSPDFKit-769hazgdc7wc335k78212j8emp",
          noteIconLabel: "PSPDFKit-73qv358utjtrzr85ky96uevmtg",
          applyRedactionsButton: "PSPDFKit-5uud5zxk4ybq2mv2nt3caxrq3g",
          isActive: "PSPDFKit-3z1atvkwb5ng185njjj5rz7xbz",
          disableEditing: "PSPDFKit-fts7hzse3qdkgfmxd89z1sxgg",
          disabledButton: "PSPDFKit-4q6ah6p4esufmffveqzpjh47b",
          icon: "PSPDFKit-2s797jk128ay8vfscex2bv7kfe",
          focusRing: "PSPDFKit-4nuygfwr1ru425pyg3yjydvr61",
          fontFamily: "PSPDFKit-3fzefd39fwgk1qdbxv6jdjs8f7",
          dropdownMenu: "PSPDFKit-5cn9vbp8wrnrmnk914jdmynjve",
          warningButton: "PSPDFKit-88kdpafyrs8h3rj4zjbrrted2p",
          warningButtonIcon: "PSPDFKit-6yj82gkzhm3npm9qtbttnwhvqs",
          radioButtonWarningLabel: "PSPDFKit-5kx5x5nrf9ffzpw127n7tdvrqw",
          colorPickerDropdownMenu: "PSPDFKit-6m8awubd892h2q7bxq6ucu9yx5",
          colorItem: "PSPDFKit-5z24bvabee7axqkv39se95kj79",
          deleteButtonIsVisibleInTouchDevices: "PSPDFKit-5uu5r98quqvpyqqvmhf7eqx6n8",
          colorSvg: "PSPDFKit-7sx7anuampjzrt9mnvv7zccdny",
          lineCapsDashArrayMenu: "PSPDFKit-84hychtak5eqe99svt8mp3g7gq",
          strokeDashArrayMenu: "PSPDFKit-3wpt6233mxj93ajtgz97kkfp95",
          nativeDropdown: "PSPDFKit-75syshz3pwrn5szey2w1zrbwhq",
          fontFamilyNativeFlexbox: "PSPDFKit-5wjc8qvxn2shc717ghes4hwe4r",
          fontSizeNativeFlexbox: "PSPDFKit-4axb3jsn3p35zcvz2qkf1627s1",
          fontColorControl: "PSPDFKit-3gbc7z42ncvpe6ecjsfvekn6bf",
          overlayTextInput: "PSPDFKit-25fpzkeppwbvrayjgduw8retb5",
          overlayTextMargin: "PSPDFKit-8q8cpk21u1e4cgjxkuetq25ac5",
          groupWrapper: "PSPDFKit-2syhxbxpfgp19jpz3z5x49q224",
          groupDescription: "PSPDFKit-7eua9n76z6wh9hyqtrgxabwhyp",
          overlayInput: "PSPDFKit-8san6jac5e16c3cmp3udzsyzq9",
          radioInput: "PSPDFKit-2bhr7dx4y8a6z7s598sms29ggb",
          applyRedactionsWrapper: "PSPDFKit-uqsh2mfe72fsz9emybm4vb6u9",
          customIconSvg: "PSPDFKit-6s24914j26xzdhgmaqjbdae7a8",
          snappingCheckbox: "PSPDFKit-7kdp2eku1rven1vm3eug4x6su9",
          radioGroupWrapper: "PSPDFKit-5mud2pd31puwn1df9zjr639yy4",
          reverseRow: "PSPDFKit-84kcnetmpfg2e64pd3wmwkkbud",
          measurementToolbar: "PSPDFKit-2f6g3rm6gpedqtnwpk94cu5b6q",
          measurementBackButton: "PSPDFKit-2q1r39e1v2u5ekry3v7vbc9yr7",
          pointSnappingToggleButtonWrapper: "PSPDFKit-4g2ngud8r3s5zduhf5fa58c69y",
          pointSnappingToggleButton: "PSPDFKit-7bbcwaht73ggqqhpqdhb435dan",
          container: "PSPDFKit-48mktwcp2g29yu9eg22p2pbvmh",
          formDesignerContainer: "PSPDFKit-8dznuywttgafn2v7zy61c6ctg4",
          buttonContainer: "PSPDFKit-5t9fk8ex9uwch2qhza7wa1pacw",
          cropButton: "PSPDFKit-2x4tn85f3krgk9xb8r993atjue",
          cropButtonDisabled: "PSPDFKit-6uhymu5y17pjr47gp9zdvgf3bd",
          cancelDesktop: "PSPDFKit-4wcvaawwq3jw743mwnp8vtf9df",
          cancelMobile: "PSPDFKit-7tretxh1ue798paef14ryrb6q6",
          desktopButtonText: "PSPDFKit-649k7389pwcsgmvwdt2yuhu7n3",
          mobileButtonText: "PSPDFKit-3uxhzwe7ph1xrpb89482k7hrd",
          formDesignerButtonActive: "PSPDFKit-7dgtuxjugwv9wr6k94pfvchgzt",
          spacer: "PSPDFKit-3nf3mgqa1mk6xs968ztk8n1ped",
          measurementValue: "PSPDFKit-7kz6k3947em3q3sp47s5cd3u3m"
        };
      },
      37103: e => {
        e.exports = {
          dropdownMenu: "PSPDFKit-2nvh838hnrmj6tjpctafyh5x7m",
          dropdownMenuUp: "PSPDFKit-5xzg6bg1qbsb5nyd5qtnxyygh4",
          arrow: "PSPDFKit-7m14b5a6nxx7rywstpkcac66jh",
          arrowFill: "PSPDFKit-3m2a5gvruf8k4he7qc4zjkr6ph",
          arrowFillUp: "PSPDFKit-8eerxut5n95np3tqrj71w5e222",
          arrowUp: "PSPDFKit-5b9jgmbtab9q2nsf1et2wzayps",
          table: "PSPDFKit-6nefwc9ww2a6bdsknb6pf9xqyf",
          button: "PSPDFKit-441mq6m2ewd76vee95v9fr7my2",
          icon: "PSPDFKit-6f7sarp7tsa7umn4f92wvj1bfv",
          activeIcon: "PSPDFKit-36mkhhuvsv1c4uvf7vtkhpvmrp",
          highlightedIcon: "PSPDFKit-h975nt1b2sjwtx24fkebaskvu"
        };
      },
      61533: e => {
        e.exports = {
          root: "PSPDFKit-ueuej8dv753zvbk6mp828mzsr",
          desktop: "PSPDFKit-5k4sr6w4zxhd2hs9mbp6s6pzny",
          mobile: "PSPDFKit-4mcfrdfta1gqurpt3wsxjc97a",
          label: "PSPDFKit-bc9txuev7gse3pp84ajq62vmt",
          control: "PSPDFKit-7tngmuaurbw9evq3vhsmqhb79y",
          input: "PSPDFKit-6akg5tb3pdjbrjepp4y44p6w6w",
          next: "PSPDFKit-8eqdrxrxh6w15npezgfrhr5xaw",
          prev: "PSPDFKit-218fbh46vhgjukxda9q16dva61",
          icon: "PSPDFKit-4k74zzdsrvasvyyh48kjpdwb69",
          inputLabel: "PSPDFKit-6fnzgpjer6z7ca9jecfhk8hdsy"
        };
      },
      13608: e => {
        e.exports = {
          root: "PSPDFKit-7y27utzt66zv3mqf62v5b93bkj",
          left: "PSPDFKit-39uutbqvjcmpw86wegd169emzw",
          right: "PSPDFKit-7kw269a3q1nnm4e8q7ph8skd1y",
          toolbarButton: "PSPDFKit-yzpfzw9bfd9ejp1k7kgdacu7d",
          separator: "PSPDFKit-4z9qs61q4s33nvuwafvrr69p27",
          buttonGroup: "PSPDFKit-2znbjv3uzcg3sd8kby58ara78y",
          dropdownButton: "PSPDFKit-6uq6r7dsfrgrfk6e7j9247tmjh",
          dropdownButtonSelected: "PSPDFKit-4w5v8zc35y6mjqvgzm7h29yxjz",
          dropdownButtonDisabled: "PSPDFKit-3esgz77hvs295449651j22wfqe",
          dropdownButtonFocused: "PSPDFKit-7afsq6jcreh7h5cqqjrdd1xq87"
        };
      },
      17722: e => {
        e.exports = {
          dropdown: "PSPDFKit-2h6u1uvepb29aceyswrhabn442",
          root: "PSPDFKit-5hqvpgcgpf1769cn35dvtg4ktz",
          withDropdown: "PSPDFKit-59hpcfye46ptznzj6qnfjzxmw5",
          icon: "PSPDFKit-3dcfza4a2zm1e2eg4echhrm6g5",
          isDisabled: "PSPDFKit-43cceb3p2mywgnc9ah1q5apjh4",
          withDropdownDisabled: "PSPDFKit-5wps7sscy34hpgrmzwbrb2k8h8",
          wrapper: "PSPDFKit-8nyvpcm5qq23nzqvwdfzqayryh",
          disabledWrapper: "PSPDFKit-8mq4c412r44dvy4qtvyfp64p1k",
          discreteDropdown: "PSPDFKit-32j2tkxs7yf83d9vrqs2np1xja",
          dropdownIcon: "PSPDFKit-6511p928m8fcbcd7nb8arydjxe",
          withDropdownIcon: "PSPDFKit-7t6uf3numwbvg2qg3x9sx7rkjx",
          withDropdownIdle: "PSPDFKit-6s8pjz7ybfkbm9j34ce4qsz32w",
          withLabel: "PSPDFKit-67e5xx7a8j97ze41fv1th56sbu",
          isActive: "PSPDFKit-yyu2s7s1tuqk1ww7hvgfnef81",
          disabledDropdownIcon: "PSPDFKit-7mpjdpbxyc5gttymwetaz47j3q"
        };
      },
      13524: e => {
        e.exports = {
          responsiveGroup: "PSPDFKit-7s54nnph7yayfgqvb7rcy9q2r9",
          primary: "PSPDFKit-6zy881tctu9r8st5vfwvpcfxja",
          stickToBottom: "PSPDFKit-2sm51vztwj4mjbhd5pehvnauwk",
          secondary: "PSPDFKit-272tn91arpsx8j7fngtk874eyz",
          button: "PSPDFKit-8tf4984hks13xr145qxkvqh5x2",
          animatedArrow: "PSPDFKit-3skkbnpn3gm9d5fp6b75tc96pe",
          isActive: "PSPDFKit-3jvcxjeemxp6228839um72qy4t",
          items: "PSPDFKit-2n3akw6g2m6zcpdwrxfqcdm28q",
          "arrow-left": "PSPDFKit-6t665x89dpp83cptuahpm823v9",
          "arrow-bottom": "PSPDFKit-3ta9x8afg61d6nxtq9yhdeq5k2",
          slideRightEnter: "PSPDFKit-5g7enmsbf45swnff2zwyxdwmd8",
          slideRightEnterActive: "PSPDFKit-h2x5j64f4qrks9ntdqzgenamu",
          slideRightExit: "PSPDFKit-4hcst5bakcb11gphagzdemmaj2",
          slideRightExitActive: "PSPDFKit-2f4rg8arx4myttw4gnp6m4cj6f",
          slideRightEnterDone: "PSPDFKit-3zhxpze9bhbrk5wqq7cnx6rrcz"
        };
      },
      94683: e => {
        e.exports = {
          focusVisible: "PSPDFKit-224gyk59mnmuy1j6u58s8bcf2p",
          focusedFocusVisible: "PSPDFKit-3mxmx3p3whct5a2qk5bsb3v7rg"
        };
      },
      36394: e => {
        e.exports = {
          nanoid: (e = 21) => {
            let t = "",
              n = e;
            for (; n--;) t += "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict"[64 * Math.random() | 0];
            return t;
          },
          customAlphabet: (e, t = 21) => (n = t) => {
            let r = "",
              o = n;
            for (; o--;) r += e[Math.random() * e.length | 0];
            return r;
          }
        };
      },
      69769: function (e, t, n) {
        "use strict";

        var r = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.generate = t.compile = void 0;
        var o = r(n(11073));
        t.compile = function (e) {
          var t = e[0],
            n = e[1] - 1;
          if (n < 0 && t <= 0) return o.default.falseFunc;
          if (-1 === t) return function (e) {
            return e <= n;
          };
          if (0 === t) return function (e) {
            return e === n;
          };
          if (1 === t) return n < 0 ? o.default.trueFunc : function (e) {
            return e >= n;
          };
          var r = Math.abs(t),
            i = (n % r + r) % r;
          return t > 1 ? function (e) {
            return e >= n && e % r === i;
          } : function (e) {
            return e <= n && e % r === i;
          };
        }, t.generate = function (e) {
          var t = e[0],
            n = e[1] - 1,
            r = 0;
          if (t < 0) {
            var o = -t,
              i = (n % o + o) % o;
            return function () {
              var e = i + o * r++;
              return e > n ? null : e;
            };
          }
          return 0 === t ? n < 0 ? function () {
            return null;
          } : function () {
            return 0 == r++ ? n : null;
          } : (n < 0 && (n += t * Math.ceil(-n / t)), function () {
            return t * r++ + n;
          });
        };
      },
      97540: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.sequence = t.generate = t.compile = t.parse = void 0;
        var r = n(7766);
        Object.defineProperty(t, "parse", {
          enumerable: !0,
          get: function () {
            return r.parse;
          }
        });
        var o = n(69769);
        Object.defineProperty(t, "compile", {
          enumerable: !0,
          get: function () {
            return o.compile;
          }
        }), Object.defineProperty(t, "generate", {
          enumerable: !0,
          get: function () {
            return o.generate;
          }
        }), t.default = function (e) {
          return (0, o.compile)((0, r.parse)(e));
        }, t.sequence = function (e) {
          return (0, o.generate)((0, r.parse)(e));
        };
      },
      7766: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.parse = void 0;
        var n = new Set([9, 10, 12, 13, 32]),
          r = "0".charCodeAt(0),
          o = "9".charCodeAt(0);
        t.parse = function (e) {
          if ("even" === (e = e.trim().toLowerCase())) return [2, 0];
          if ("odd" === e) return [2, 1];
          var t = 0,
            i = 0,
            a = l(),
            s = u();
          if (t < e.length && "n" === e.charAt(t) && (t++, i = a * (null != s ? s : 1), c(), t < e.length ? (a = l(), c(), s = u()) : a = s = 0), null === s || t < e.length) throw new Error("n-th rule couldn't be parsed ('".concat(e, "')"));
          return [i, a * s];
          function l() {
            return "-" === e.charAt(t) ? (t++, -1) : ("+" === e.charAt(t) && t++, 1);
          }
          function u() {
            for (var n = t, i = 0; t < e.length && e.charCodeAt(t) >= r && e.charCodeAt(t) <= o;) i = 10 * i + (e.charCodeAt(t) - r), t++;
            return t === n ? null : i;
          }
          function c() {
            for (; t < e.length && n.has(e.charCodeAt(t));) t++;
          }
        };
      },
      52923: () => {},
      27418: e => {
        "use strict";

        var t = Object.getOwnPropertySymbols,
          n = Object.prototype.hasOwnProperty,
          r = Object.prototype.propertyIsEnumerable;
        function o(e) {
          if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
          return Object(e);
        }
        e.exports = function () {
          try {
            if (!Object.assign) return !1;
            var e = new String("abc");
            if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
            for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
            if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
              return t[e];
            }).join("")) return !1;
            var r = {};
            return "abcdefghijklmnopqrst".split("").forEach(function (e) {
              r[e] = e;
            }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
          } catch (e) {
            return !1;
          }
        }() ? Object.assign : function (e, i) {
          for (var a, s, l = o(e), u = 1; u < arguments.length; u++) {
            for (var c in a = Object(arguments[u])) n.call(a, c) && (l[c] = a[c]);
            if (t) {
              s = t(a);
              for (var d = 0; d < s.length; d++) r.call(a, s[d]) && (l[s[d]] = a[s[d]]);
            }
          }
          return l;
        };
      },
      74241: e => {
        var t = String,
          n = function () {
            return {
              isColorSupported: !1,
              reset: t,
              bold: t,
              dim: t,
              italic: t,
              underline: t,
              inverse: t,
              hidden: t,
              strikethrough: t,
              black: t,
              red: t,
              green: t,
              yellow: t,
              blue: t,
              magenta: t,
              cyan: t,
              white: t,
              gray: t,
              bgBlack: t,
              bgRed: t,
              bgGreen: t,
              bgYellow: t,
              bgBlue: t,
              bgMagenta: t,
              bgCyan: t,
              bgWhite: t
            };
          };
        e.exports = n(), e.exports.createColors = n;
      },
      92703: (e, t, n) => {
        "use strict";

        var r = n(50414);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function () {
          function e(e, t, n, o, i, a) {
            if (a !== r) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var n = {
            array: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: i,
            resetWarningCache: o
          };
          return n.PropTypes = n, n;
        };
      },
      45697: (e, t, n) => {
        e.exports = n(92703)();
      },
      50414: e => {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      70799: (e, t, n) => {
        "use strict";

        n.d(t, {
          U4: () => Tn,
          vI: () => Ki,
          MT: () => B.MT,
          MG: () => Ga,
          bd: () => V.bd,
          hO: () => qi,
          dp: () => $n,
          aV: () => jn,
          TX: () => $t.T,
          dG: () => j.dG,
          UW: () => K,
          O: () => ze,
          VP: () => Li,
          Xe: () => V.Xe,
          E_: () => dr,
          aQ: () => V.aQ,
          Rh: () => $r,
          Xu: () => ji,
          J4: () => Ri,
          LW: () => Ei,
          Dr: () => Fi,
          zw: () => Oi,
          U$: () => Ae.U,
          L0: () => V.L0,
          bO: () => B.bO,
          Fx: () => B.Fx,
          L_: () => N.L_,
          XI: () => N.XI,
          Me: () => j.Me,
          Fc: () => N.Fc,
          v5: () => N.v5,
          NP: () => Ae.N,
          nB: () => L,
          co: () => Qn,
          TV: () => er,
          bU: () => V.bU,
          H9: () => ir,
          iX: () => ar,
          x7: () => sr,
          u4: () => rr,
          hX: () => V.hX,
          NE: () => Nn,
          r_: () => N.r_,
          IL: () => Na,
          Ux: () => V.Ux,
          Fv: () => Jn,
          tN: () => gn,
          IB: () => wn,
          Sv: () => Mn,
          r7: () => N.r7,
          D6: () => Ra,
          xL: () => Va,
          ar: () => Ka,
          tJ: () => Ua,
          L7: () => $a,
          zA: () => Wa,
          oN: () => Ya.o,
          pS: () => Ya.p,
          h9: () => Xa,
          xD: () => Fs,
          HJ: () => js,
          WE: () => Ms,
          E6: () => Dl,
          Hb: () => wl,
          hR: () => lr.E,
          kI: () => q,
          lL: () => Cl,
          QM: () => Sl
        });
        var r;
        r = {
          breadcrumbs: "عناصر الواجهة"
        };
        var o;
        o = {
          breadcrumbs: "Трохи хляб"
        };
        var i;
        i = {
          breadcrumbs: "Popis cesty"
        };
        var a;
        a = {
          breadcrumbs: "Brødkrummer"
        };
        var s;
        s = {
          breadcrumbs: "Breadcrumbs"
        };
        var l;
        l = {
          breadcrumbs: "Πλοηγήσεις breadcrumb"
        };
        var u;
        u = {
          breadcrumbs: "Breadcrumbs"
        };
        var c;
        c = {
          breadcrumbs: "Migas de pan"
        };
        var d;
        d = {
          breadcrumbs: "Lingiread"
        };
        var p;
        p = {
          breadcrumbs: "Navigointilinkit"
        };
        var h;
        h = {
          breadcrumbs: "Chemin de navigation"
        };
        var f;
        f = {
          breadcrumbs: "שבילי ניווט"
        };
        var m;
        m = {
          breadcrumbs: "Navigacijski putovi"
        };
        var g;
        g = {
          breadcrumbs: "Morzsamenü"
        };
        var v;
        v = {
          breadcrumbs: "Breadcrumb"
        };
        var y;
        y = {
          breadcrumbs: "パンくずリスト"
        };
        var b;
        b = {
          breadcrumbs: "탐색 표시"
        };
        var w;
        w = {
          breadcrumbs: "Naršymo kelias"
        };
        var x;
        x = {
          breadcrumbs: "Atpakaļceļi"
        };
        var D;
        D = {
          breadcrumbs: "Navigasjonsstier"
        };
        var C;
        C = {
          breadcrumbs: "Broodkruimels"
        };
        var S;
        S = {
          breadcrumbs: "Struktura nawigacyjna"
        };
        var E;
        E = {
          breadcrumbs: "Caminho detalhado"
        };
        var _;
        _ = {
          breadcrumbs: "Categorias"
        };
        var P;
        P = {
          breadcrumbs: "Miez de pâine"
        };
        var k;
        k = {
          breadcrumbs: "Навигация"
        };
        var A;
        A = {
          breadcrumbs: "Navigačné prvky Breadcrumbs"
        };
        var z;
        z = {
          breadcrumbs: "Drobtine"
        };
        var T;
        T = {
          breadcrumbs: "Putanje navigacije"
        };
        var O;
        O = {
          breadcrumbs: "Sökvägar"
        };
        var I;
        I = {
          breadcrumbs: "İçerik haritaları"
        };
        var F;
        F = {
          breadcrumbs: "Навігаційна стежка"
        };
        var M;
        M = {
          breadcrumbs: "导航栏"
        };
        var R;
        R = {
          breadcrumbs: "導覽列"
        };
        var j = n(20770),
          B = n(88786),
          N = n(49987);
        function L(e, t) {
          let {
              elementType: n = "a",
              onPress: r,
              onPressStart: o,
              onPressEnd: i,
              onClick: a,
              isDisabled: s,
              ...l
            } = e,
            u = {};
          "a" !== n && (u = {
            role: "link",
            tabIndex: s ? void 0 : 0
          });
          let {
              focusableProps: c
            } = (0, B.kc)(e, t),
            {
              pressProps: d,
              isPressed: p
            } = (0, N.r7)({
              onPress: r,
              onPressStart: o,
              onPressEnd: i,
              isDisabled: s,
              ref: t
            }),
            h = (0, j.zL)(l, {
              labelable: !0,
              isLink: "a" === n
            }),
            f = (0, j.dG)(c, d),
            m = (0, j.tv)();
          return {
            isPressed: p,
            linkProps: (0, j.dG)(h, {
              ...f,
              ...u,
              "aria-disabled": s || void 0,
              "aria-current": e["aria-current"],
              onClick: e => {
                var t;
                null === (t = d.onClick) || void 0 === t || t.call(d, e), a && (a(e), console.warn("onClick is deprecated, please use onPress")), !m.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && !e.isDefaultPrevented() && (0, j.b0)(e.currentTarget, e) && (e.preventDefault(), m.open(e.currentTarget, e));
              }
            })
          };
        }
        var V = n(18383);
        function K(e, t) {
          let n,
            {
              elementType: r = "button",
              isDisabled: o,
              onPress: i,
              onPressStart: a,
              onPressEnd: s,
              onPressUp: l,
              onPressChange: u,
              preventFocusOnPress: c,
              allowFocusWhenDisabled: d,
              onClick: p,
              href: h,
              target: f,
              rel: m,
              type: g = "button"
            } = e;
          n = "button" === r ? {
            type: g,
            disabled: o
          } : {
            role: "button",
            tabIndex: o ? void 0 : 0,
            href: "a" === r && o ? void 0 : h,
            target: "a" === r ? f : void 0,
            type: "input" === r ? g : void 0,
            disabled: "input" === r ? o : void 0,
            "aria-disabled": o && "input" !== r ? o : void 0,
            rel: "a" === r ? m : void 0
          };
          let {
              pressProps: v,
              isPressed: y
            } = (0, N.r7)({
              onPressStart: a,
              onPressEnd: s,
              onPressChange: u,
              onPress: i,
              onPressUp: l,
              isDisabled: o,
              preventFocusOnPress: c,
              ref: t
            }),
            {
              focusableProps: b
            } = (0, B.kc)(e, t);
          d && (b.tabIndex = o ? -1 : b.tabIndex);
          let w = (0, j.dG)(b, v, (0, j.zL)(e, {
            labelable: !0
          }));
          return {
            isPressed: y,
            buttonProps: (0, j.dG)(n, w, {
              "aria-haspopup": e["aria-haspopup"],
              "aria-expanded": e["aria-expanded"],
              "aria-controls": e["aria-controls"],
              "aria-pressed": e["aria-pressed"],
              onClick: e => {
                p && (p(e), console.warn("onClick is deprecated, please use onPress"));
              }
            })
          };
        }
        function q(e, t, n) {
          const {
              isSelected: r
            } = t,
            {
              isPressed: o,
              buttonProps: i
            } = K({
              ...e,
              onPress: (0, j.tS)(t.toggle, e.onPress)
            }, n);
          return {
            isPressed: o,
            buttonProps: (0, j.dG)(i, {
              "aria-pressed": r
            })
          };
        }
        var H;
        H = {
          dateRange: e => `${e.startDate} إلى ${e.endDate}`,
          dateSelected: e => `${e.date} المحدد`,
          finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
          maximumDate: "آخر تاريخ متاح",
          minimumDate: "أول تاريخ متاح",
          next: "التالي",
          previous: "السابق",
          selectedDateDescription: e => `تاريخ محدد: ${e.date}`,
          selectedRangeDescription: e => `المدى الزمني المحدد: ${e.dateRange}`,
          startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
          todayDate: e => `اليوم، ${e.date}`,
          todayDateSelected: e => `اليوم، ${e.date} محدد`
        };
        var U;
        U = {
          dateRange: e => `${e.startDate} до ${e.endDate}`,
          dateSelected: e => `Избрано е ${e.date}`,
          finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
          maximumDate: "Последна налична дата",
          minimumDate: "Първа налична дата",
          next: "Напред",
          previous: "Назад",
          selectedDateDescription: e => `Избрана дата: ${e.date}`,
          selectedRangeDescription: e => `Избран диапазон: ${e.dateRange}`,
          startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
          todayDate: e => `Днес, ${e.date}`,
          todayDateSelected: e => `Днес, ${e.date} са избрани`
        };
        var Z;
        Z = {
          dateRange: e => `${e.startDate} až ${e.endDate}`,
          dateSelected: e => `Vybráno ${e.date}`,
          finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
          maximumDate: "Poslední dostupné datum",
          minimumDate: "První dostupné datum",
          next: "Další",
          previous: "Předchozí",
          selectedDateDescription: e => `Vybrané datum: ${e.date}`,
          selectedRangeDescription: e => `Vybrané období: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
          todayDate: e => `Dnes, ${e.date}`,
          todayDateSelected: e => `Dnes, vybráno ${e.date}`
        };
        var $;
        $ = {
          dateRange: e => `${e.startDate} til ${e.endDate}`,
          dateSelected: e => `${e.date} valgt`,
          finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
          maximumDate: "Sidste ledige dato",
          minimumDate: "Første ledige dato",
          next: "Næste",
          previous: "Forrige",
          selectedDateDescription: e => `Valgt dato: ${e.date}`,
          selectedRangeDescription: e => `Valgt interval: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
          todayDate: e => `I dag, ${e.date}`,
          todayDateSelected: e => `I dag, ${e.date} valgt`
        };
        var G;
        G = {
          dateRange: e => `${e.startDate} bis ${e.endDate}`,
          dateSelected: e => `${e.date} ausgewählt`,
          finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
          maximumDate: "Letztes verfügbares Datum",
          minimumDate: "Erstes verfügbares Datum",
          next: "Weiter",
          previous: "Zurück",
          selectedDateDescription: e => `Ausgewähltes Datum: ${e.date}`,
          selectedRangeDescription: e => `Ausgewählter Bereich: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
          todayDate: e => `Heute, ${e.date}`,
          todayDateSelected: e => `Heute, ${e.date} ausgewählt`
        };
        var W;
        W = {
          dateRange: e => `${e.startDate} έως ${e.endDate}`,
          dateSelected: e => `Επιλέχθηκε ${e.date}`,
          finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
          maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
          minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
          next: "Επόμενο",
          previous: "Προηγούμενο",
          selectedDateDescription: e => `Επιλεγμένη ημερομηνία: ${e.date}`,
          selectedRangeDescription: e => `Επιλεγμένο εύρος: ${e.dateRange}`,
          startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
          todayDate: e => `Σήμερα, ${e.date}`,
          todayDateSelected: e => `Σήμερα, επιλέχτηκε ${e.date}`
        };
        var Y;
        Y = {
          previous: "Previous",
          next: "Next",
          selectedDateDescription: e => `Selected Date: ${e.date}`,
          selectedRangeDescription: e => `Selected Range: ${e.dateRange}`,
          todayDate: e => `Today, ${e.date}`,
          todayDateSelected: e => `Today, ${e.date} selected`,
          dateSelected: e => `${e.date} selected`,
          startRangeSelectionPrompt: "Click to start selecting date range",
          finishRangeSelectionPrompt: "Click to finish selecting date range",
          minimumDate: "First available date",
          maximumDate: "Last available date",
          dateRange: e => `${e.startDate} to ${e.endDate}`
        };
        var X;
        X = {
          dateRange: e => `${e.startDate} a ${e.endDate}`,
          dateSelected: e => `${e.date} seleccionado`,
          finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
          maximumDate: "Última fecha disponible",
          minimumDate: "Primera fecha disponible",
          next: "Siguiente",
          previous: "Anterior",
          selectedDateDescription: e => `Fecha seleccionada: ${e.date}`,
          selectedRangeDescription: e => `Intervalo seleccionado: ${e.dateRange}`,
          startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
          todayDate: e => `Hoy, ${e.date}`,
          todayDateSelected: e => `Hoy, ${e.date} seleccionado`
        };
        var Q;
        Q = {
          dateRange: e => `${e.startDate} kuni ${e.endDate}`,
          dateSelected: e => `${e.date} valitud`,
          finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
          maximumDate: "Viimane saadaolev kuupäev",
          minimumDate: "Esimene saadaolev kuupäev",
          next: "Järgmine",
          previous: "Eelmine",
          selectedDateDescription: e => `Valitud kuupäev: ${e.date}`,
          selectedRangeDescription: e => `Valitud vahemik: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
          todayDate: e => `Täna, ${e.date}`,
          todayDateSelected: e => `Täna, ${e.date} valitud`
        };
        var J;
        J = {
          dateRange: e => `${e.startDate} – ${e.endDate}`,
          dateSelected: e => `${e.date} valittu`,
          finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
          maximumDate: "Viimeinen varattavissa oleva päivämäärä",
          minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
          next: "Seuraava",
          previous: "Edellinen",
          selectedDateDescription: e => `Valittu päivämäärä: ${e.date}`,
          selectedRangeDescription: e => `Valittu aikaväli: ${e.dateRange}`,
          startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
          todayDate: e => `Tänään, ${e.date}`,
          todayDateSelected: e => `Tänään, ${e.date} valittu`
        };
        var ee;
        ee = {
          dateRange: e => `${e.startDate} à ${e.endDate}`,
          dateSelected: e => `${e.date} sélectionné`,
          finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
          maximumDate: "Dernière date disponible",
          minimumDate: "Première date disponible",
          next: "Suivant",
          previous: "Précédent",
          selectedDateDescription: e => `Date sélectionnée : ${e.date}`,
          selectedRangeDescription: e => `Plage sélectionnée : ${e.dateRange}`,
          startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
          todayDate: e => `Aujourd'hui, ${e.date}`,
          todayDateSelected: e => `Aujourd’hui, ${e.date} sélectionné`
        };
        var te;
        te = {
          dateRange: e => `${e.startDate} עד ${e.endDate}`,
          dateSelected: e => `${e.date} נבחר`,
          finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
          maximumDate: "תאריך פנוי אחרון",
          minimumDate: "תאריך פנוי ראשון",
          next: "הבא",
          previous: "הקודם",
          selectedDateDescription: e => `תאריך נבחר: ${e.date}`,
          selectedRangeDescription: e => `טווח נבחר: ${e.dateRange}`,
          startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
          todayDate: e => `היום, ${e.date}`,
          todayDateSelected: e => `היום, ${e.date} נבחר`
        };
        var ne;
        ne = {
          dateRange: e => `${e.startDate} do ${e.endDate}`,
          dateSelected: e => `${e.date} odabran`,
          finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
          maximumDate: "Posljednji raspoloživi datum",
          minimumDate: "Prvi raspoloživi datum",
          next: "Sljedeći",
          previous: "Prethodni",
          selectedDateDescription: e => `Odabrani datum: ${e.date}`,
          selectedRangeDescription: e => `Odabrani raspon: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
          todayDate: e => `Danas, ${e.date}`,
          todayDateSelected: e => `Danas, odabran ${e.date}`
        };
        var re;
        re = {
          dateRange: e => `${e.startDate}–${e.endDate}`,
          dateSelected: e => `${e.date} kiválasztva`,
          finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
          maximumDate: "Utolsó elérhető dátum",
          minimumDate: "Az első elérhető dátum",
          next: "Következő",
          previous: "Előző",
          selectedDateDescription: e => `Kijelölt dátum: ${e.date}`,
          selectedRangeDescription: e => `Kijelölt tartomány: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
          todayDate: e => `Ma, ${e.date}`,
          todayDateSelected: e => `Ma, ${e.date} kijelölve`
        };
        var oe;
        oe = {
          dateRange: e => `Da ${e.startDate} a ${e.endDate}`,
          dateSelected: e => `${e.date} selezionata`,
          finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
          maximumDate: "Ultima data disponibile",
          minimumDate: "Prima data disponibile",
          next: "Successivo",
          previous: "Precedente",
          selectedDateDescription: e => `Data selezionata: ${e.date}`,
          selectedRangeDescription: e => `Intervallo selezionato: ${e.dateRange}`,
          startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
          todayDate: e => `Oggi, ${e.date}`,
          todayDateSelected: e => `Oggi, ${e.date} selezionata`
        };
        var ie;
        ie = {
          dateRange: e => `${e.startDate} から ${e.endDate}`,
          dateSelected: e => `${e.date} を選択`,
          finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
          maximumDate: "最終利用可能日",
          minimumDate: "最初の利用可能日",
          next: "次へ",
          previous: "前へ",
          selectedDateDescription: e => `選択した日付 : ${e.date}`,
          selectedRangeDescription: e => `選択範囲 : ${e.dateRange}`,
          startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
          todayDate: e => `本日、${e.date}`,
          todayDateSelected: e => `本日、${e.date} を選択`
        };
        var ae;
        ae = {
          dateRange: e => `${e.startDate} ~ ${e.endDate}`,
          dateSelected: e => `${e.date} 선택됨`,
          finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
          maximumDate: "마지막으로 사용 가능한 일자",
          minimumDate: "처음으로 사용 가능한 일자",
          next: "다음",
          previous: "이전",
          selectedDateDescription: e => `선택 일자: ${e.date}`,
          selectedRangeDescription: e => `선택 범위: ${e.dateRange}`,
          startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
          todayDate: e => `오늘, ${e.date}`,
          todayDateSelected: e => `오늘, ${e.date} 선택됨`
        };
        var se;
        se = {
          dateRange: e => `Nuo ${e.startDate} iki ${e.endDate}`,
          dateSelected: e => `Pasirinkta ${e.date}`,
          finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
          maximumDate: "Paskutinė galima data",
          minimumDate: "Pirmoji galima data",
          next: "Paskesnis",
          previous: "Ankstesnis",
          selectedDateDescription: e => `Pasirinkta data: ${e.date}`,
          selectedRangeDescription: e => `Pasirinktas intervalas: ${e.dateRange}`,
          startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
          todayDate: e => `Šiandien, ${e.date}`,
          todayDateSelected: e => `Šiandien, pasirinkta ${e.date}`
        };
        var le;
        le = {
          dateRange: e => `No ${e.startDate} līdz ${e.endDate}`,
          dateSelected: e => `Atlasīts: ${e.date}`,
          finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
          maximumDate: "Pēdējais pieejamais datums",
          minimumDate: "Pirmais pieejamais datums",
          next: "Tālāk",
          previous: "Atpakaļ",
          selectedDateDescription: e => `Atlasītais datums: ${e.date}`,
          selectedRangeDescription: e => `Atlasītais diapazons: ${e.dateRange}`,
          startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
          todayDate: e => `Šodien, ${e.date}`,
          todayDateSelected: e => `Atlasīta šodiena, ${e.date}`
        };
        var ue;
        ue = {
          dateRange: e => `${e.startDate} til ${e.endDate}`,
          dateSelected: e => `${e.date} valgt`,
          finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
          maximumDate: "Siste tilgjengelige dato",
          minimumDate: "Første tilgjengelige dato",
          next: "Neste",
          previous: "Forrige",
          selectedDateDescription: e => `Valgt dato: ${e.date}`,
          selectedRangeDescription: e => `Valgt område: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
          todayDate: e => `I dag, ${e.date}`,
          todayDateSelected: e => `I dag, ${e.date} valgt`
        };
        var ce;
        ce = {
          dateRange: e => `${e.startDate} tot ${e.endDate}`,
          dateSelected: e => `${e.date} geselecteerd`,
          finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
          maximumDate: "Laatste beschikbare datum",
          minimumDate: "Eerste beschikbare datum",
          next: "Volgende",
          previous: "Vorige",
          selectedDateDescription: e => `Geselecteerde datum: ${e.date}`,
          selectedRangeDescription: e => `Geselecteerd bereik: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
          todayDate: e => `Vandaag, ${e.date}`,
          todayDateSelected: e => `Vandaag, ${e.date} geselecteerd`
        };
        var de;
        de = {
          dateRange: e => `${e.startDate} do ${e.endDate}`,
          dateSelected: e => `Wybrano ${e.date}`,
          finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
          maximumDate: "Ostatnia dostępna data",
          minimumDate: "Pierwsza dostępna data",
          next: "Dalej",
          previous: "Wstecz",
          selectedDateDescription: e => `Wybrana data: ${e.date}`,
          selectedRangeDescription: e => `Wybrany zakres: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
          todayDate: e => `Dzisiaj, ${e.date}`,
          todayDateSelected: e => `Dzisiaj wybrano ${e.date}`
        };
        var pe;
        pe = {
          dateRange: e => `${e.startDate} a ${e.endDate}`,
          dateSelected: e => `${e.date} selecionado`,
          finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
          maximumDate: "Última data disponível",
          minimumDate: "Primeira data disponível",
          next: "Próximo",
          previous: "Anterior",
          selectedDateDescription: e => `Data selecionada: ${e.date}`,
          selectedRangeDescription: e => `Intervalo selecionado: ${e.dateRange}`,
          startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
          todayDate: e => `Hoje, ${e.date}`,
          todayDateSelected: e => `Hoje, ${e.date} selecionado`
        };
        var he;
        he = {
          dateRange: e => `${e.startDate} a ${e.endDate}`,
          dateSelected: e => `${e.date} selecionado`,
          finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
          maximumDate: "Última data disponível",
          minimumDate: "Primeira data disponível",
          next: "Próximo",
          previous: "Anterior",
          selectedDateDescription: e => `Data selecionada: ${e.date}`,
          selectedRangeDescription: e => `Intervalo selecionado: ${e.dateRange}`,
          startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
          todayDate: e => `Hoje, ${e.date}`,
          todayDateSelected: e => `Hoje, ${e.date} selecionado`
        };
        var fe;
        fe = {
          dateRange: e => `De la ${e.startDate} până la ${e.endDate}`,
          dateSelected: e => `${e.date} selectată`,
          finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
          maximumDate: "Ultima dată disponibilă",
          minimumDate: "Prima dată disponibilă",
          next: "Următorul",
          previous: "Înainte",
          selectedDateDescription: e => `Dată selectată: ${e.date}`,
          selectedRangeDescription: e => `Interval selectat: ${e.dateRange}`,
          startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
          todayDate: e => `Astăzi, ${e.date}`,
          todayDateSelected: e => `Azi, ${e.date} selectată`
        };
        var me;
        me = {
          dateRange: e => `С ${e.startDate} по ${e.endDate}`,
          dateSelected: e => `Выбрано ${e.date}`,
          finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
          maximumDate: "Последняя доступная дата",
          minimumDate: "Первая доступная дата",
          next: "Далее",
          previous: "Назад",
          selectedDateDescription: e => `Выбранная дата: ${e.date}`,
          selectedRangeDescription: e => `Выбранный диапазон: ${e.dateRange}`,
          startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
          todayDate: e => `Сегодня, ${e.date}`,
          todayDateSelected: e => `Сегодня, выбрано ${e.date}`
        };
        var ge;
        ge = {
          dateRange: e => `Od ${e.startDate} do ${e.endDate}`,
          dateSelected: e => `Vybratý dátum ${e.date}`,
          finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
          maximumDate: "Posledný dostupný dátum",
          minimumDate: "Prvý dostupný dátum",
          next: "Nasledujúce",
          previous: "Predchádzajúce",
          selectedDateDescription: e => `Vybratý dátum: ${e.date}`,
          selectedRangeDescription: e => `Vybratý rozsah: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
          todayDate: e => `Dnes ${e.date}`,
          todayDateSelected: e => `Vybratý dnešný dátum ${e.date}`
        };
        var ve;
        ve = {
          dateRange: e => `${e.startDate} do ${e.endDate}`,
          dateSelected: e => `${e.date} izbrano`,
          finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
          maximumDate: "Zadnji razpoložljivi datum",
          minimumDate: "Prvi razpoložljivi datum",
          next: "Naprej",
          previous: "Nazaj",
          selectedDateDescription: e => `Izbrani datum: ${e.date}`,
          selectedRangeDescription: e => `Izbrano območje: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
          todayDate: e => `Danes, ${e.date}`,
          todayDateSelected: e => `Danes, ${e.date} izbrano`
        };
        var ye;
        ye = {
          dateRange: e => `${e.startDate} do ${e.endDate}`,
          dateSelected: e => `${e.date} izabran`,
          finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
          maximumDate: "Zadnji raspoloživi datum",
          minimumDate: "Prvi raspoloživi datum",
          next: "Sledeći",
          previous: "Prethodni",
          selectedDateDescription: e => `Izabrani datum: ${e.date}`,
          selectedRangeDescription: e => `Izabrani period: ${e.dateRange}`,
          startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
          todayDate: e => `Danas, ${e.date}`,
          todayDateSelected: e => `Danas, izabran ${e.date}`
        };
        var be;
        be = {
          dateRange: e => `${e.startDate} till ${e.endDate}`,
          dateSelected: e => `${e.date} har valts`,
          finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
          maximumDate: "Sista tillgängliga datum",
          minimumDate: "Första tillgängliga datum",
          next: "Nästa",
          previous: "Föregående",
          selectedDateDescription: e => `Valt datum: ${e.date}`,
          selectedRangeDescription: e => `Valt intervall: ${e.dateRange}`,
          startRangeSelectionPrompt: "Klicka för att välja datumintervall",
          todayDate: e => `Idag, ${e.date}`,
          todayDateSelected: e => `Idag, ${e.date} har valts`
        };
        var we;
        we = {
          dateRange: e => `${e.startDate} - ${e.endDate}`,
          dateSelected: e => `${e.date} seçildi`,
          finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
          maximumDate: "Son müsait tarih",
          minimumDate: "İlk müsait tarih",
          next: "Sonraki",
          previous: "Önceki",
          selectedDateDescription: e => `Seçilen Tarih: ${e.date}`,
          selectedRangeDescription: e => `Seçilen Aralık: ${e.dateRange}`,
          startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
          todayDate: e => `Bugün, ${e.date}`,
          todayDateSelected: e => `Bugün, ${e.date} seçildi`
        };
        var xe;
        xe = {
          dateRange: e => `${e.startDate} — ${e.endDate}`,
          dateSelected: e => `Вибрано ${e.date}`,
          finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
          maximumDate: "Остання доступна дата",
          minimumDate: "Перша доступна дата",
          next: "Наступний",
          previous: "Попередній",
          selectedDateDescription: e => `Вибрана дата: ${e.date}`,
          selectedRangeDescription: e => `Вибраний діапазон: ${e.dateRange}`,
          startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
          todayDate: e => `Сьогодні, ${e.date}`,
          todayDateSelected: e => `Сьогодні, вибрано ${e.date}`
        };
        var De;
        De = {
          dateRange: e => `${e.startDate} 至 ${e.endDate}`,
          dateSelected: e => `已选择 ${e.date}`,
          finishRangeSelectionPrompt: "单击以完成选择日期范围",
          maximumDate: "最后一个可用日期",
          minimumDate: "第一个可用日期",
          next: "下一页",
          previous: "上一页",
          selectedDateDescription: e => `选定的日期：${e.date}`,
          selectedRangeDescription: e => `选定的范围：${e.dateRange}`,
          startRangeSelectionPrompt: "单击以开始选择日期范围",
          todayDate: e => `今天，即 ${e.date}`,
          todayDateSelected: e => `已选择今天，即 ${e.date}`
        };
        var Ce;
        Ce = {
          dateRange: e => `${e.startDate} 至 ${e.endDate}`,
          dateSelected: e => `已選取 ${e.date}`,
          finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
          maximumDate: "最後一個可用日期",
          minimumDate: "第一個可用日期",
          next: "下一頁",
          previous: "上一頁",
          selectedDateDescription: e => `選定的日期：${e.date}`,
          selectedRangeDescription: e => `選定的範圍：${e.dateRange}`,
          startRangeSelectionPrompt: "按一下以開始選取日期範圍",
          todayDate: e => `今天，${e.date}`,
          todayDateSelected: e => `已選取今天，${e.date}`
        };
        var Se = n(80602),
          Ee = n(67294);
        n(41473);
        new WeakMap();
        var _e = n(86838),
          Pe = n(38947);
        function ke(e, t, n) {
          let {
            isDisabled: r = !1,
            isReadOnly: o = !1,
            value: i,
            name: a,
            children: s,
            "aria-label": l,
            "aria-labelledby": u,
            validationState: c = "valid",
            isInvalid: d
          } = e;
          null != s || null != l || null != u || console.warn("If you do not provide children, you must specify an aria-label for accessibility");
          let {
              pressProps: p,
              isPressed: h
            } = (0, N.r7)({
              isDisabled: r
            }),
            {
              pressProps: f,
              isPressed: m
            } = (0, N.r7)({
              isDisabled: r || o,
              onPress() {
                t.toggle();
              }
            }),
            {
              focusableProps: g
            } = (0, B.kc)(e, n),
            v = (0, j.dG)(p, g),
            y = (0, j.zL)(e, {
              labelable: !0
            });
          return (0, j.y$)(n, t.isSelected, t.setSelected), {
            labelProps: (0, j.dG)(f, {
              onClick: e => e.preventDefault()
            }),
            inputProps: (0, j.dG)(y, {
              "aria-invalid": d || "invalid" === c || void 0,
              "aria-errormessage": e["aria-errormessage"],
              "aria-controls": e["aria-controls"],
              "aria-readonly": o || void 0,
              onChange: e => {
                e.stopPropagation(), t.setSelected(e.target.checked);
              },
              disabled: r,
              ...(null == i ? {} : {
                value: i
              }),
              name: a,
              type: "checkbox",
              ...v
            }),
            isSelected: t.isSelected,
            isPressed: h || m,
            isDisabled: r,
            isReadOnly: o,
            isInvalid: d || "invalid" === c
          };
        }
        var Ae = n(41217);
        n(21946);
        function ze(e, t, n) {
          let r = (0, Pe.Q3)({
              ...e,
              value: t.isSelected
            }),
            {
              isInvalid: o,
              validationErrors: i,
              validationDetails: a
            } = r.displayValidation,
            {
              labelProps: s,
              inputProps: l,
              isSelected: u,
              isPressed: c,
              isDisabled: d,
              isReadOnly: p
            } = ke({
              ...e,
              isInvalid: o
            }, t, n);
          (0, _e.Q)(e, r, n);
          let {
            isIndeterminate: h,
            isRequired: f,
            validationBehavior: m = "aria"
          } = e;
          return (0, Ee.useEffect)(() => {
            n.current && (n.current.indeterminate = !!h);
          }), {
            labelProps: s,
            inputProps: {
              ...l,
              checked: u,
              "aria-required": f && "aria" === m || void 0,
              required: f && "native" === m
            },
            isSelected: u,
            isPressed: c,
            isDisabled: d,
            isReadOnly: p,
            isInvalid: o,
            validationErrors: i,
            validationDetails: a
          };
        }
        new WeakMap();
        var Te;
        Te = {
          buttonLabel: "عرض المقترحات",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} خيار`,
            other: () => `${t.number(e.optionCount)} خيارات`
          })} متاحة.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `المجموعة المدخلة ${e.groupTitle}, مع ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} خيار`,
              other: () => `${t.number(e.groupCount)} خيارات`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", محدد",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "مقترحات",
          selectedAnnouncement: e => `${e.optionText}، محدد`
        };
        var Oe;
        Oe = {
          buttonLabel: "Покажи предложения",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} опция`,
            other: () => `${t.number(e.optionCount)} опции`
          })} на разположение.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Въведена група ${e.groupTitle}, с ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} опция`,
              other: () => `${t.number(e.groupCount)} опции`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", избрани",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Предложения",
          selectedAnnouncement: e => `${e.optionText}, избрани`
        };
        var Ie;
        Ie = {
          buttonLabel: "Zobrazit doporučení",
          countAnnouncement: (e, t) => `K dispozici ${t.plural(e.optionCount, {
            one: () => `je ${t.number(e.optionCount)} možnost`,
            other: () => `jsou/je ${t.number(e.optionCount)} možnosti/-í`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Zadaná skupina „${e.groupTitle}“ ${t.plural(e.groupCount, {
              one: () => `s ${t.number(e.groupCount)} možností`,
              other: () => `se ${t.number(e.groupCount)} možnostmi`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: " (vybráno)",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Návrhy",
          selectedAnnouncement: e => `${e.optionText}, vybráno`
        };
        var Fe;
        Fe = {
          buttonLabel: "Vis forslag",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} mulighed tilgængelig`,
            other: () => `${t.number(e.optionCount)} muligheder tilgængelige`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Angivet gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} mulighed`,
              other: () => `${t.number(e.groupCount)} muligheder`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", valgt",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Forslag",
          selectedAnnouncement: e => `${e.optionText}, valgt`
        };
        var Me;
        Me = {
          buttonLabel: "Empfehlungen anzeigen",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} Option`,
            other: () => `${t.number(e.optionCount)} Optionen`
          })} verfügbar.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Eingetretene Gruppe ${e.groupTitle}, mit ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} Option`,
              other: () => `${t.number(e.groupCount)} Optionen`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", ausgewählt",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Empfehlungen",
          selectedAnnouncement: e => `${e.optionText}, ausgewählt`
        };
        var Re;
        Re = {
          buttonLabel: "Προβολή προτάσεων",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} επιλογή`,
            other: () => `${t.number(e.optionCount)} επιλογές `
          })} διαθέσιμες.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Εισαγμένη ομάδα ${e.groupTitle}, με ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} επιλογή`,
              other: () => `${t.number(e.groupCount)} επιλογές`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", επιλεγμένο",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Προτάσεις",
          selectedAnnouncement: e => `${e.optionText}, επιλέχθηκε`
        };
        var je;
        je = {
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Entered group ${e.groupTitle}, with ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} option`,
              other: () => `${t.number(e.groupCount)} options`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", selected",
            other: ""
          }, e.isSelected)}`,
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} option`,
            other: () => `${t.number(e.optionCount)} options`
          })} available.`,
          selectedAnnouncement: e => `${e.optionText}, selected`,
          buttonLabel: "Show suggestions",
          listboxLabel: "Suggestions"
        };
        var Be;
        Be = {
          buttonLabel: "Mostrar sugerencias",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opción`,
            other: () => `${t.number(e.optionCount)} opciones`
          })} disponible(s).`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Se ha unido al grupo ${e.groupTitle}, con ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opción`,
              other: () => `${t.number(e.groupCount)} opciones`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", seleccionado",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Sugerencias",
          selectedAnnouncement: e => `${e.optionText}, seleccionado`
        };
        var Ne;
        Ne = {
          buttonLabel: "Kuva soovitused",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} valik`,
            other: () => `${t.number(e.optionCount)} valikud`
          })} saadaval.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Sisestatud rühm ${e.groupTitle}, valikuga ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} valik`,
              other: () => `${t.number(e.groupCount)} valikud`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", valitud",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Soovitused",
          selectedAnnouncement: e => `${e.optionText}, valitud`
        };
        var Le;
        Le = {
          buttonLabel: "Näytä ehdotukset",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} vaihtoehto`,
            other: () => `${t.number(e.optionCount)} vaihtoehdot`
          })} saatavilla.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Mentiin ryhmään ${e.groupTitle}, ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} vaihtoehdon`,
              other: () => `${t.number(e.groupCount)} vaihtoehdon`
            })} kanssa.`,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", valittu",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Ehdotukset",
          selectedAnnouncement: e => `${e.optionText}, valittu`
        };
        var Ve;
        Ve = {
          buttonLabel: "Afficher les suggestions",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} option`,
            other: () => `${t.number(e.optionCount)} options`
          })} disponible(s).`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Groupe ${e.groupTitle} rejoint, avec ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} option`,
              other: () => `${t.number(e.groupCount)} options`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", sélectionné(s)",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Suggestions",
          selectedAnnouncement: e => `${e.optionText}, sélectionné`
        };
        var Ke;
        Ke = {
          buttonLabel: "הצג הצעות",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `אפשרות ${t.number(e.optionCount)}`,
            other: () => `${t.number(e.optionCount)} אפשרויות`
          })} במצב זמין.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `נכנס לקבוצה ${e.groupTitle}, עם ${t.plural(e.groupCount, {
              one: () => `אפשרות ${t.number(e.groupCount)}`,
              other: () => `${t.number(e.groupCount)} אפשרויות`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", נבחר",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "הצעות",
          selectedAnnouncement: e => `${e.optionText}, נבחר`
        };
        var qe;
        qe = {
          buttonLabel: "Prikaži prijedloge",
          countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opcija`,
            other: () => `${t.number(e.optionCount)} opcije/a`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Unesena skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opcijom`,
              other: () => `${t.number(e.groupCount)} opcije/a`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", odabranih",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Prijedlozi",
          selectedAnnouncement: e => `${e.optionText}, odabrano`
        };
        var He;
        He = {
          buttonLabel: "Javaslatok megjelenítése",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} lehetőség`,
            other: () => `${t.number(e.optionCount)} lehetőség`
          })} áll rendelkezésre.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Belépett a(z) ${e.groupTitle} csoportba, amely ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} lehetőséget`,
              other: () => `${t.number(e.groupCount)} lehetőséget`
            })} tartalmaz. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", kijelölve",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Javaslatok",
          selectedAnnouncement: e => `${e.optionText}, kijelölve`
        };
        var Ue;
        Ue = {
          buttonLabel: "Mostra suggerimenti",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opzione disponibile`,
            other: () => `${t.number(e.optionCount)} opzioni disponibili`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Ingresso nel gruppo ${e.groupTitle}, con ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opzione`,
              other: () => `${t.number(e.groupCount)} opzioni`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", selezionato",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Suggerimenti",
          selectedAnnouncement: e => `${e.optionText}, selezionato`
        };
        var Ze;
        Ze = {
          buttonLabel: "候補を表示",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} 個のオプション`,
            other: () => `${t.number(e.optionCount)} 個のオプション`
          })}を利用できます。`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `入力されたグループ ${e.groupTitle}、${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} 個のオプション`,
              other: () => `${t.number(e.groupCount)} 個のオプション`
            })}を含む。`,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: "、選択済み",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "候補",
          selectedAnnouncement: e => `${e.optionText}、選択済み`
        };
        var $e;
        $e = {
          buttonLabel: "제안 사항 표시",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)}개 옵션`,
            other: () => `${t.number(e.optionCount)}개 옵션`
          })}을 사용할 수 있습니다.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `입력한 그룹 ${e.groupTitle}, ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)}개 옵션`,
              other: () => `${t.number(e.groupCount)}개 옵션`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", 선택됨",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "제안",
          selectedAnnouncement: e => `${e.optionText}, 선택됨`
        };
        var Ge;
        Ge = {
          buttonLabel: "Rodyti pasiūlymus",
          countAnnouncement: (e, t) => `Yra ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} parinktis`,
            other: () => `${t.number(e.optionCount)} parinktys (-ių)`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Įvesta grupė ${e.groupTitle}, su ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} parinktimi`,
              other: () => `${t.number(e.groupCount)} parinktimis (-ių)`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", pasirinkta",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Pasiūlymai",
          selectedAnnouncement: e => `${e.optionText}, pasirinkta`
        };
        var We;
        We = {
          buttonLabel: "Rādīt ieteikumus",
          countAnnouncement: (e, t) => `Pieejamo opciju skaits: ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opcija`,
            other: () => `${t.number(e.optionCount)} opcijas`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Ievadīta grupa ${e.groupTitle}, ar ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opciju`,
              other: () => `${t.number(e.groupCount)} opcijām`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", atlasīta",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Ieteikumi",
          selectedAnnouncement: e => `${e.optionText}, atlasīta`
        };
        var Ye;
        Ye = {
          buttonLabel: "Vis forslag",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} alternativ`,
            other: () => `${t.number(e.optionCount)} alternativer`
          })} finnes.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Angitt gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} alternativ`,
              other: () => `${t.number(e.groupCount)} alternativer`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", valgt",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Forslag",
          selectedAnnouncement: e => `${e.optionText}, valgt`
        };
        var Xe;
        Xe = {
          buttonLabel: "Suggesties weergeven",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} optie`,
            other: () => `${t.number(e.optionCount)} opties`
          })} beschikbaar.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Groep ${e.groupTitle} ingevoerd met ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} optie`,
              other: () => `${t.number(e.groupCount)} opties`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", geselecteerd",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Suggesties",
          selectedAnnouncement: e => `${e.optionText}, geselecteerd`
        };
        var Qe;
        Qe = {
          buttonLabel: "Wyświetlaj sugestie",
          countAnnouncement: (e, t) => `dostępna/dostępne(-nych) ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opcja`,
            other: () => `${t.number(e.optionCount)} opcje(-i)`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Dołączono do grupy ${e.groupTitle}, z ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opcją`,
              other: () => `${t.number(e.groupCount)} opcjami`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", wybrano",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Sugestie",
          selectedAnnouncement: e => `${e.optionText}, wybrano`
        };
        var Je;
        Je = {
          buttonLabel: "Mostrar sugestões",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opção`,
            other: () => `${t.number(e.optionCount)} opções`
          })} disponível.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Grupo inserido ${e.groupTitle}, com ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opção`,
              other: () => `${t.number(e.groupCount)} opções`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", selecionado",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Sugestões",
          selectedAnnouncement: e => `${e.optionText}, selecionado`
        };
        var et;
        et = {
          buttonLabel: "Apresentar sugestões",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opção`,
            other: () => `${t.number(e.optionCount)} opções`
          })} disponível.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Grupo introduzido ${e.groupTitle}, com ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opção`,
              other: () => `${t.number(e.groupCount)} opções`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", selecionado",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Sugestões",
          selectedAnnouncement: e => `${e.optionText}, selecionado`
        };
        var tt;
        tt = {
          buttonLabel: "Afișare sugestii",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opțiune`,
            other: () => `${t.number(e.optionCount)} opțiuni`
          })} disponibile.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Grup ${e.groupTitle} introdus, cu ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opțiune`,
              other: () => `${t.number(e.groupCount)} opțiuni`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", selectat",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Sugestii",
          selectedAnnouncement: e => `${e.optionText}, selectat`
        };
        var nt;
        nt = {
          buttonLabel: "Показать предложения",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} параметр`,
            other: () => `${t.number(e.optionCount)} параметров`
          })} доступно.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Введенная группа ${e.groupTitle}, с ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} параметром`,
              other: () => `${t.number(e.groupCount)} параметрами`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", выбранными",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Предложения",
          selectedAnnouncement: e => `${e.optionText}, выбрано`
        };
        var rt;
        rt = {
          buttonLabel: "Zobraziť návrhy",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} možnosť`,
            other: () => `${t.number(e.optionCount)} možnosti/-í`
          })} k dispozícii.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Zadaná skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} možnosťou`,
              other: () => `${t.number(e.groupCount)} možnosťami`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", vybraté",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Návrhy",
          selectedAnnouncement: e => `${e.optionText}, vybraté`
        };
        var ot;
        ot = {
          buttonLabel: "Prikaži predloge",
          countAnnouncement: (e, t) => `Na voljo je ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opcija`,
            other: () => `${t.number(e.optionCount)} opcije`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Vnesena skupina ${e.groupTitle}, z ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opcija`,
              other: () => `${t.number(e.groupCount)} opcije`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", izbrano",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Predlogi",
          selectedAnnouncement: e => `${e.optionText}, izbrano`
        };
        var it;
        it = {
          buttonLabel: "Prikaži predloge",
          countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} opcija`,
            other: () => `${t.number(e.optionCount)} opcije/a`
          })}.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Unesena grupa ${e.groupTitle}, s ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} opcijom`,
              other: () => `${t.number(e.groupCount)} optione/a`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", izabranih",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Predlozi",
          selectedAnnouncement: e => `${e.optionText}, izabrano`
        };
        var at;
        at = {
          buttonLabel: "Visa förslag",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} alternativ`,
            other: () => `${t.number(e.optionCount)} alternativ`
          })} tillgängliga.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Ingick i gruppen ${e.groupTitle} med ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} alternativ`,
              other: () => `${t.number(e.groupCount)} alternativ`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", valda",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Förslag",
          selectedAnnouncement: e => `${e.optionText}, valda`
        };
        var st;
        st = {
          buttonLabel: "Önerileri göster",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} seçenek`,
            other: () => `${t.number(e.optionCount)} seçenekler`
          })} kullanılabilir.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Girilen grup ${e.groupTitle}, ile ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} seçenek`,
              other: () => `${t.number(e.groupCount)} seçenekler`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", seçildi",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Öneriler",
          selectedAnnouncement: e => `${e.optionText}, seçildi`
        };
        var lt;
        lt = {
          buttonLabel: "Показати пропозиції",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} параметр`,
            other: () => `${t.number(e.optionCount)} параметри(-ів)`
          })} доступно.`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `Введена група ${e.groupTitle}, з ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} параметр`,
              other: () => `${t.number(e.groupCount)} параметри(-ів)`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", вибрано",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "Пропозиції",
          selectedAnnouncement: e => `${e.optionText}, вибрано`
        };
        var ut;
        ut = {
          buttonLabel: "显示建议",
          countAnnouncement: (e, t) => `有 ${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} 个选项`,
            other: () => `${t.number(e.optionCount)} 个选项`
          })}可用。`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `进入了 ${e.groupTitle} 组，其中有 ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} 个选项`,
              other: () => `${t.number(e.groupCount)} 个选项`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", 已选择",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "建议",
          selectedAnnouncement: e => `${e.optionText}, 已选择`
        };
        var ct;
        ct = {
          buttonLabel: "顯示建議",
          countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
            one: () => `${t.number(e.optionCount)} 選項`,
            other: () => `${t.number(e.optionCount)} 選項`
          })} 可用。`,
          focusAnnouncement: (e, t) => `${t.select({
            true: () => `輸入的群組 ${e.groupTitle}, 有 ${t.plural(e.groupCount, {
              one: () => `${t.number(e.groupCount)} 選項`,
              other: () => `${t.number(e.groupCount)} 選項`
            })}. `,
            other: ""
          }, e.isGroupChange)}${e.optionText}${t.select({
            true: ", 已選取",
            other: ""
          }, e.isSelected)}`,
          listboxLabel: "建議",
          selectedAnnouncement: e => `${e.optionText}, 已選取`
        };
        var dt;
        dt = {
          dismiss: "تجاهل"
        };
        var pt;
        pt = {
          dismiss: "Отхвърляне"
        };
        var ht;
        ht = {
          dismiss: "Odstranit"
        };
        var ft;
        ft = {
          dismiss: "Luk"
        };
        var mt;
        mt = {
          dismiss: "Schließen"
        };
        var gt;
        gt = {
          dismiss: "Απόρριψη"
        };
        var vt;
        vt = {
          dismiss: "Dismiss"
        };
        var yt;
        yt = {
          dismiss: "Descartar"
        };
        var bt;
        bt = {
          dismiss: "Lõpeta"
        };
        var wt;
        wt = {
          dismiss: "Hylkää"
        };
        var xt;
        xt = {
          dismiss: "Rejeter"
        };
        var Dt;
        Dt = {
          dismiss: "התעלם"
        };
        var Ct;
        Ct = {
          dismiss: "Odbaci"
        };
        var St;
        St = {
          dismiss: "Elutasítás"
        };
        var Et;
        Et = {
          dismiss: "Ignora"
        };
        var _t;
        _t = {
          dismiss: "閉じる"
        };
        var Pt;
        Pt = {
          dismiss: "무시"
        };
        var kt;
        kt = {
          dismiss: "Atmesti"
        };
        var At;
        At = {
          dismiss: "Nerādīt"
        };
        var zt;
        zt = {
          dismiss: "Lukk"
        };
        var Tt;
        Tt = {
          dismiss: "Negeren"
        };
        var Ot;
        Ot = {
          dismiss: "Zignoruj"
        };
        var It;
        It = {
          dismiss: "Descartar"
        };
        var Ft;
        Ft = {
          dismiss: "Dispensar"
        };
        var Mt;
        Mt = {
          dismiss: "Revocare"
        };
        var Rt;
        Rt = {
          dismiss: "Пропустить"
        };
        var jt;
        jt = {
          dismiss: "Zrušiť"
        };
        var Bt;
        Bt = {
          dismiss: "Opusti"
        };
        var Nt;
        Nt = {
          dismiss: "Odbaci"
        };
        var Lt;
        Lt = {
          dismiss: "Avvisa"
        };
        var Vt;
        Vt = {
          dismiss: "Kapat"
        };
        var Kt;
        Kt = {
          dismiss: "Скасувати"
        };
        var qt;
        qt = {
          dismiss: "取消"
        };
        var Ht;
        Ht = {
          dismiss: "關閉"
        };
        var Ut = n(73935),
          Zt = n(16021),
          $t = n(55387);
        function Gt(e) {
          return e && e.__esModule ? e.default : e;
        }
        const Wt = {
            top: "top",
            bottom: "top",
            left: "left",
            right: "left"
          },
          Yt = {
            top: "bottom",
            bottom: "top",
            left: "right",
            right: "left"
          },
          Xt = {
            top: "left",
            left: "top"
          },
          Qt = {
            top: "height",
            left: "width"
          },
          Jt = {
            width: "totalWidth",
            height: "totalHeight"
          },
          en = {};
        let tn = "undefined" != typeof document && window.visualViewport;
        function nn(e) {
          let t = 0,
            n = 0,
            r = 0,
            o = 0,
            i = 0,
            a = 0,
            s = {},
            l = (null == tn ? void 0 : tn.scale) > 1;
          if ("BODY" === e.tagName) {
            let l = document.documentElement;
            var u, c;
            r = l.clientWidth, o = l.clientHeight, t = null !== (u = null == tn ? void 0 : tn.width) && void 0 !== u ? u : r, n = null !== (c = null == tn ? void 0 : tn.height) && void 0 !== c ? c : o, s.top = l.scrollTop || e.scrollTop, s.left = l.scrollLeft || e.scrollLeft, tn && (i = tn.offsetTop, a = tn.offsetLeft);
          } else ({
            width: t,
            height: n,
            top: i,
            left: a
          } = cn(e)), s.top = e.scrollTop, s.left = e.scrollLeft, r = t, o = n;
          return (0, j.Pf)() && ("BODY" === e.tagName || "HTML" === e.tagName) && l && (s.top = 0, s.left = 0, i = tn.pageTop, a = tn.pageLeft), {
            width: t,
            height: n,
            totalWidth: r,
            totalHeight: o,
            scroll: s,
            top: i,
            left: a
          };
        }
        function rn(e, t, n, r, o, i, a) {
          let s = o.scroll[e],
            l = r[Qt[e]],
            u = r.scroll[Wt[e]] + i,
            c = l + r.scroll[Wt[e]] - i,
            d = t - s + a[e] - r[Wt[e]],
            p = t - s + n + a[e] - r[Wt[e]];
          return d < u ? u - d : p > c ? Math.max(c - p, u - d) : 0;
        }
        function on(e) {
          if (en[e]) return en[e];
          let [t, n] = e.split(" "),
            r = Wt[t] || "right",
            o = Xt[r];
          Wt[n] || (n = "center");
          let i = Qt[r],
            a = Qt[o];
          return en[e] = {
            placement: t,
            crossPlacement: n,
            axis: r,
            crossAxis: o,
            size: i,
            crossSize: a
          }, en[e];
        }
        function an(e, t, n, r, o, i, a, s, l, u) {
          let {
              placement: c,
              crossPlacement: d,
              axis: p,
              crossAxis: h,
              size: f,
              crossSize: m
            } = r,
            g = {};
          g[h] = e[h], "center" === d ? g[h] += (e[m] - n[m]) / 2 : d !== h && (g[h] += e[m] - n[m]), g[h] += i;
          const v = e[h] - n[m] + l + u,
            y = e[h] + e[m] - l - u;
          if (g[h] = (0, j.uZ)(g[h], v, y), c === p) {
            const n = s ? a[f] : t[Jt[f]];
            g[Yt[p]] = Math.floor(n - e[p] + o);
          } else g[p] = Math.floor(e[p] + e[f] + o);
          return g;
        }
        function sn(e, t, n, r, o, i) {
          let {
            placement: a,
            axis: s,
            size: l
          } = i;
          return a === s ? Math.max(0, n[s] - e[s] - e.scroll[s] + t[s] - r[s] - r[Yt[s]] - o) : Math.max(0, e[l] + e[s] + e.scroll[s] - t[s] - n[s] - n[l] - r[s] - r[Yt[s]] - o);
        }
        function ln(e, t, n, r, o, i, a, s, l, u, c, d, p, h, f, m) {
          let g = on(e),
            {
              size: v,
              crossAxis: y,
              crossSize: b,
              placement: w,
              crossPlacement: x
            } = g,
            D = an(t, s, n, g, c, d, u, p, f, m),
            C = c,
            S = sn(s, u, t, o, i + c, g);
          if (a && r[v] > S) {
            let e = on(`${Yt[w]} ${x}`),
              r = an(t, s, n, e, c, d, u, p, f, m);
            sn(s, u, t, o, i + c, e) > S && (g = e, D = r, C = c);
          }
          let E = "bottom";
          "top" === g.axis ? "top" === g.placement ? E = "top" : "bottom" === g.placement && (E = "bottom") : "top" === g.crossAxis && ("top" === g.crossPlacement ? E = "bottom" : "bottom" === g.crossPlacement && (E = "top"));
          let _ = rn(y, D[y], n[b], s, l, i, u);
          D[y] += _;
          let P = function (e, t, n, r, o, i, a, s) {
            const l = r ? n.height : t[Jt.height];
            let u = null != e.top ? n.top + e.top : n.top + (l - e.bottom - a),
              c = "top" !== s ? Math.max(0, t.height + t.top + t.scroll.top - u - (o.top + o.bottom + i)) : Math.max(0, u + a - (t.top + t.scroll.top) - (o.top + o.bottom + i));
            return Math.min(t.height - 2 * i, c);
          }(D, s, u, p, o, i, n.height, E);
          h && h < P && (P = h), n.height = Math.min(n.height, P), D = an(t, s, n, g, C, d, u, p, f, m), _ = rn(y, D[y], n[b], s, l, i, u), D[y] += _;
          let k = {},
            A = t[y] + .5 * t[b] - n[y];
          const z = f / 2 + m,
            T = n[b] - f / 2 - m,
            O = t[y] - n[y] + f / 2,
            I = t[y] + t[b] - n[y] - f / 2,
            F = (0, j.uZ)(A, O, I);
          return k[y] = (0, j.uZ)(F, z, T), {
            position: D,
            maxHeight: P,
            arrowOffsetLeft: k.left,
            arrowOffsetTop: k.top,
            placement: g.placement
          };
        }
        function un(e) {
          let {
              placement: t,
              targetNode: n,
              overlayNode: r,
              scrollNode: o,
              padding: i,
              shouldFlip: a,
              boundaryElement: s,
              offset: l,
              crossOffset: u,
              maxHeight: c,
              arrowSize: d = 0,
              arrowBoundaryOffset: p = 0
            } = e,
            h = r instanceof HTMLElement ? function (e) {
              let t = e.offsetParent;
              t && t === document.body && "static" === window.getComputedStyle(t).position && !pn(t) && (t = document.documentElement);
              if (null == t) for (t = e.parentElement; t && !pn(t);) t = t.parentElement;
              return t || document.documentElement;
            }(r) : document.documentElement,
            f = h === document.documentElement;
          const m = window.getComputedStyle(h).position;
          let g = !!m && "static" !== m,
            v = f ? cn(n) : dn(n, h);
          if (!f) {
            let {
              marginTop: e,
              marginLeft: t
            } = window.getComputedStyle(n);
            v.top += parseInt(e, 10) || 0, v.left += parseInt(t, 10) || 0;
          }
          let y = cn(r),
            b = function (e) {
              let t = window.getComputedStyle(e);
              return {
                top: parseInt(t.marginTop, 10) || 0,
                bottom: parseInt(t.marginBottom, 10) || 0,
                left: parseInt(t.marginLeft, 10) || 0,
                right: parseInt(t.marginRight, 10) || 0
              };
            }(r);
          y.width += b.left + b.right, y.height += b.top + b.bottom;
          let w = {
            top: (x = o).scrollTop,
            left: x.scrollLeft,
            width: x.scrollWidth,
            height: x.scrollHeight
          };
          var x;
          let D = nn(s),
            C = nn(h),
            S = "BODY" === s.tagName ? cn(h) : dn(h, s);
          return "HTML" === h.tagName && "BODY" === s.tagName && (C.scroll.top = 0, C.scroll.left = 0), ln(t, v, y, w, b, i, a, D, C, S, l, u, g, c, d, p);
        }
        function cn(e) {
          let {
              top: t,
              left: n,
              width: r,
              height: o
            } = e.getBoundingClientRect(),
            {
              scrollTop: i,
              scrollLeft: a,
              clientTop: s,
              clientLeft: l
            } = document.documentElement;
          return {
            top: t + i - s,
            left: n + a - l,
            width: r,
            height: o
          };
        }
        function dn(e, t) {
          let n,
            r = window.getComputedStyle(e);
          if ("fixed" === r.position) {
            let {
              top: t,
              left: r,
              width: o,
              height: i
            } = e.getBoundingClientRect();
            n = {
              top: t,
              left: r,
              width: o,
              height: i
            };
          } else {
            n = cn(e);
            let r = cn(t),
              o = window.getComputedStyle(t);
            r.top += (parseInt(o.borderTopWidth, 10) || 0) - t.scrollTop, r.left += (parseInt(o.borderLeftWidth, 10) || 0) - t.scrollLeft, n.top -= r.top, n.left -= r.left;
          }
          return n.top -= parseInt(r.marginTop, 10) || 0, n.left -= parseInt(r.marginLeft, 10) || 0, n;
        }
        function pn(e) {
          let t = window.getComputedStyle(e);
          return "none" !== t.transform || /transform|perspective/.test(t.willChange) || "none" !== t.filter || "paint" === t.contain || "backdropFilter" in t && "none" !== t.backdropFilter || "WebkitBackdropFilter" in t && "none" !== t.WebkitBackdropFilter;
        }
        const hn = new WeakMap();
        function fn(e) {
          let {
            triggerRef: t,
            isOpen: n,
            onClose: r
          } = e;
          (0, Ee.useEffect)(() => {
            if (!n || null === r) return;
            let e = e => {
              let n = e.target;
              if (!t.current || n instanceof Node && !n.contains(t.current)) return;
              let o = r || hn.get(t.current);
              o && o();
            };
            return window.addEventListener("scroll", e, !0), () => {
              window.removeEventListener("scroll", e, !0);
            };
          }, [n, r, t]);
        }
        let mn = "undefined" != typeof document && window.visualViewport;
        function gn(e) {
          let {
              direction: t
            } = (0, V.bU)(),
            {
              arrowSize: n = 0,
              targetRef: r,
              overlayRef: o,
              scrollRef: i = o,
              placement: a = "bottom",
              containerPadding: s = 12,
              shouldFlip: l = !0,
              boundaryElement: u = "undefined" != typeof document ? document.body : null,
              offset: c = 0,
              crossOffset: d = 0,
              shouldUpdatePosition: p = !0,
              isOpen: h = !0,
              onClose: f,
              maxHeight: m,
              arrowBoundaryOffset: g = 0
            } = e,
            [v, y] = (0, Ee.useState)({
              position: {},
              arrowOffsetLeft: void 0,
              arrowOffsetTop: void 0,
              maxHeight: void 0,
              placement: void 0
            }),
            b = [p, a, o.current, r.current, i.current, s, l, u, c, d, h, t, m, g, n],
            w = (0, Ee.useRef)(null == mn ? void 0 : mn.scale);
          (0, Ee.useEffect)(() => {
            h && (w.current = null == mn ? void 0 : mn.scale);
          }, [h]);
          let x = (0, Ee.useCallback)(() => {
            if (!(!1 !== p && h && o.current && r.current && i.current && u)) return;
            if ((null == mn ? void 0 : mn.scale) !== w.current) return;
            !m && o.current && (o.current.style.maxHeight = "none");
            let e = un({
              placement: vn(a, t),
              overlayNode: o.current,
              targetNode: r.current,
              scrollNode: i.current,
              padding: s,
              shouldFlip: l,
              boundaryElement: u,
              offset: c,
              crossOffset: d,
              maxHeight: m,
              arrowSize: n,
              arrowBoundaryOffset: g
            });
            Object.keys(e.position).forEach(t => o.current.style[t] = e.position[t] + "px"), o.current.style.maxHeight = null != e.maxHeight ? e.maxHeight + "px" : void 0, y(e);
          }, b);
          (0, j.bt)(x, b), function (e) {
            (0, j.bt)(() => (window.addEventListener("resize", e, !1), () => {
              window.removeEventListener("resize", e, !1);
            }), [e]);
          }(x), (0, j.yU)({
            ref: o,
            onResize: x
          });
          let D = (0, Ee.useRef)(!1);
          (0, j.bt)(() => {
            let e,
              t = () => {
                D.current = !0, clearTimeout(e), e = setTimeout(() => {
                  D.current = !1;
                }, 500), x();
              },
              n = () => {
                D.current && t();
              };
            return null == mn || mn.addEventListener("resize", t), null == mn || mn.addEventListener("scroll", n), () => {
              null == mn || mn.removeEventListener("resize", t), null == mn || mn.removeEventListener("scroll", n);
            };
          }, [x]);
          let C = (0, Ee.useCallback)(() => {
            D.current || f();
          }, [f, D]);
          return fn({
            triggerRef: r,
            isOpen: h,
            onClose: f && C
          }), {
            overlayProps: {
              style: {
                position: "absolute",
                zIndex: 1e5,
                ...v.position,
                maxHeight: v.maxHeight
              }
            },
            placement: v.placement,
            arrowProps: {
              "aria-hidden": "true",
              role: "presentation",
              style: {
                left: v.arrowOffsetLeft,
                top: v.arrowOffsetTop
              }
            },
            updatePosition: x
          };
        }
        function vn(e, t) {
          return "rtl" === t ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
        }
        const yn = [];
        function bn(e, t) {
          let {
            onClose: n,
            shouldCloseOnBlur: r,
            isOpen: o,
            isDismissable: i = !1,
            isKeyboardDismissDisabled: a = !1,
            shouldCloseOnInteractOutside: s
          } = e;
          (0, Ee.useEffect)(() => (o && yn.push(t), () => {
            let e = yn.indexOf(t);
            e >= 0 && yn.splice(e, 1);
          }), [o, t]);
          let l = () => {
            yn[yn.length - 1] === t && n && n();
          };
          (0, N.Fc)({
            ref: t,
            onInteractOutside: i && o ? e => {
              s && !s(e.target) || (yn[yn.length - 1] === t && (e.stopPropagation(), e.preventDefault()), l());
            } : null,
            onInteractOutsideStart: e => {
              s && !s(e.target) || yn[yn.length - 1] === t && (e.stopPropagation(), e.preventDefault());
            }
          });
          let {
            focusWithinProps: u
          } = (0, N.L_)({
            isDisabled: !r,
            onBlurWithin: e => {
              e.relatedTarget && !(0, B.cW)(e.relatedTarget) && (s && !s(e.relatedTarget) || n());
            }
          });
          return {
            overlayProps: {
              onKeyDown: e => {
                "Escape" !== e.key || a || e.nativeEvent.isComposing || (e.stopPropagation(), e.preventDefault(), l());
              },
              ...u
            },
            underlayProps: {
              onPointerDown: e => {
                e.target === e.currentTarget && e.preventDefault();
              }
            }
          };
        }
        function wn(e, t, n) {
          let r,
            {
              type: o
            } = e,
            {
              isOpen: i
            } = t;
          (0, Ee.useEffect)(() => {
            n && n.current && hn.set(n.current, t.close);
          }), "menu" === o ? r = !0 : "listbox" === o && (r = "listbox");
          let a = (0, j.Me)();
          return {
            triggerProps: {
              "aria-haspopup": r,
              "aria-expanded": i,
              "aria-controls": i ? a : null,
              onPress: t.toggle
            },
            overlayProps: {
              id: a
            }
          };
        }
        const xn = "undefined" != typeof document && window.visualViewport,
          Dn = new Set(["checkbox", "radio", "range", "color", "file", "image", "button", "submit", "reset"]);
        let Cn,
          Sn = 0;
        function En(e = {}) {
          let {
            isDisabled: t
          } = e;
          (0, j.bt)(() => {
            if (!t) return Sn++, 1 === Sn && (Cn = (0, j.gn)() ? function () {
              let e,
                t,
                n = n => {
                  const r = n.composedPath()[0];
                  e = (0, j.rP)(r, !0), e === document.documentElement && e === document.body || e instanceof HTMLElement && "auto" === window.getComputedStyle(e).overscrollBehavior && (t = _n(e, "overscrollBehavior", "contain"));
                },
                r = t => {
                  e && e !== document.documentElement && e !== document.body ? e.scrollHeight === e.clientHeight && e.scrollWidth === e.clientWidth && t.preventDefault() : t.preventDefault();
                },
                o = e => {
                  const n = e.composedPath()[0],
                    r = null == n ? void 0 : n.getRootNode();
                  An(n) && n !== (r instanceof ShadowRoot ? r.activeElement : document.activeElement) && (e.preventDefault(), s(), n.style.transform = "translateY(-2000px)", n.focus(), requestAnimationFrame(() => {
                    n.style.transform = "";
                  })), t && t();
                },
                i = e => {
                  let t = e.target;
                  An(t) && (s(), t.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
                    t.style.transform = "", xn && (xn.height < window.innerHeight ? requestAnimationFrame(() => {
                      kn(t);
                    }) : xn.addEventListener("resize", () => kn(t), {
                      once: !0
                    }));
                  }));
                },
                a = null,
                s = () => {
                  if (a) return;
                  let e = () => {
                      window.scrollTo(0, 0);
                    },
                    t = window.pageXOffset,
                    n = window.pageYOffset;
                  a = (0, j.tS)(Pn(window, "scroll", e), _n(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"), _n(document.documentElement, "overflow", "hidden"), _n(document.body, "marginTop", `-${n}px`), () => {
                    window.scrollTo(t, n);
                  }), window.scrollTo(0, 0);
                },
                l = (0, j.tS)(Pn(document, "touchstart", n, {
                  passive: !1,
                  capture: !0
                }), Pn(document, "touchmove", r, {
                  passive: !1,
                  capture: !0
                }), Pn(document, "touchend", o, {
                  passive: !1,
                  capture: !0
                }), Pn(document, "focus", i, !0));
              return () => {
                null == t || t(), null == a || a(), l();
              };
            }() : (0, j.tS)(_n(document.documentElement, "paddingRight", window.innerWidth - document.documentElement.clientWidth + "px"), _n(document.documentElement, "overflow", "hidden"))), () => {
              Sn--, 0 === Sn && Cn();
            };
          }, [t]);
        }
        function _n(e, t, n) {
          let r = e.style[t];
          return e.style[t] = n, () => {
            e.style[t] = r;
          };
        }
        function Pn(e, t, n, r) {
          return e.addEventListener(t, n, r), () => {
            e.removeEventListener(t, n, r);
          };
        }
        function kn(e) {
          let t = document.scrollingElement || document.documentElement;
          for (; e && e !== t;) {
            let t = (0, j.rP)(e);
            if (t !== document.documentElement && t !== document.body && t !== e) {
              let n = t.getBoundingClientRect().top,
                r = e.getBoundingClientRect().top;
              r > n + e.clientHeight && (t.scrollTop += r - n);
            }
            e = t.parentElement;
          }
        }
        function An(e) {
          return e instanceof HTMLInputElement && !Dn.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
        }
        var zn;
        function Tn(e) {
          let {
              onDismiss: t,
              ...n
            } = e,
            r = (0, V.qb)(Gt(zn), "@react-aria/overlays"),
            o = (0, j.bE)(n, r.format("dismiss"));
          return Ee.createElement($t.T, null, Ee.createElement("button", {
            ...o,
            tabIndex: -1,
            onClick: () => {
              t && t();
            },
            style: {
              width: 1,
              height: 1
            }
          }));
        }
        zn = {
          "ar-AE": dt,
          "bg-BG": pt,
          "cs-CZ": ht,
          "da-DK": ft,
          "de-DE": mt,
          "el-GR": gt,
          "en-US": vt,
          "es-ES": yt,
          "et-EE": bt,
          "fi-FI": wt,
          "fr-FR": xt,
          "he-IL": Dt,
          "hr-HR": Ct,
          "hu-HU": St,
          "it-IT": Et,
          "ja-JP": _t,
          "ko-KR": Pt,
          "lt-LT": kt,
          "lv-LV": At,
          "nb-NO": zt,
          "nl-NL": Tt,
          "pl-PL": Ot,
          "pt-BR": It,
          "pt-PT": Ft,
          "ro-RO": Mt,
          "ru-RU": Rt,
          "sk-SK": jt,
          "sl-SI": Bt,
          "sr-SP": Nt,
          "sv-SE": Lt,
          "tr-TR": Vt,
          "uk-UA": Kt,
          "zh-CN": qt,
          "zh-TW": Ht
        };
        let On = [];
        function In(e) {
          var t;
          return null === (t = e.filter(e => e.getRootNode() instanceof ShadowRoot)) || void 0 === t ? void 0 : t.map(e => e.getRootNode());
        }
        function Fn(e, t = document.body) {
          let n = new Set(e),
            r = new Set(),
            o = new WeakMap();
          const i = In(e);
          i.length > 0 && e.forEach(e => {
            let t = e;
            for (; t && t !== document.body;) n.add(t), t = t.getRootNode() instanceof ShadowRoot ? t.getRootNode().host : t.parentNode;
          });
          let a = e => {
              for (let t of e.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) n.add(t);
              let t = e => {
                  if (n.has(e) || r.has(e.parentElement) && "row" !== e.parentElement.getAttribute("role")) return NodeFilter.FILTER_REJECT;
                  for (let t of n) if (e.contains(t)) return NodeFilter.FILTER_SKIP;
                  return NodeFilter.FILTER_ACCEPT;
                },
                o = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
                  acceptNode: t
                }),
                i = t(e);
              if (i === NodeFilter.FILTER_ACCEPT && s(e), i !== NodeFilter.FILTER_REJECT) {
                let e = o.nextNode();
                for (; null != e;) s(e), e = o.nextNode();
              }
            },
            s = e => {
              var t;
              let n = null !== (t = o.get(e)) && void 0 !== t ? t : 0;
              e instanceof Element && ("true" === e.getAttribute("aria-hidden") && 0 === n || (0 === n && e.setAttribute("aria-hidden", "true"), r.add(e), o.set(e, n + 1)));
            };
          const l = e => {
            let t = e.parentNode;
            t && t.childNodes.forEach(t => {
              t === e || n.has(t) || r.has(t) || s(t);
            });
          };
          i.length > 0 && e.forEach(e => {
            let t = e;
            for (; t && t !== document.body;) l(t), t = t.parentNode instanceof ShadowRoot ? t.parentNode.host : t.parentNode;
          }), On.length && On[On.length - 1].disconnect(), a(t);
          let u = new MutationObserver(e => {
            for (let t of e) if ("childList" === t.type && 0 !== t.addedNodes.length && ![...n, ...r].some(e => e.contains(t.target))) {
              for (let e of t.removedNodes) e instanceof Element && (n.delete(e), r.delete(e));
              for (let e of t.addedNodes) !(e instanceof HTMLElement || e instanceof SVGElement) || "true" !== e.dataset.liveAnnouncer && "true" !== e.dataset.reactAriaTopLayer ? e instanceof Element && a(e) : n.add(e);
            }
          });
          i.length > 0 && i.forEach(e => {
            u.observe(e, {
              childList: !0,
              subtree: !0
            });
          }), u.observe(t, {
            childList: !0,
            subtree: !0
          });
          let c = {
            observe() {
              u.observe(t, {
                childList: !0,
                subtree: !0
              });
            },
            disconnect() {
              u.disconnect();
            }
          };
          return On.push(c), () => {
            u.disconnect(), i.length > 0 && i.forEach(() => {
              u.disconnect();
            });
            for (let e of r) {
              let t = o.get(e);
              1 === t ? (e.removeAttribute("aria-hidden"), o.delete(e)) : o.set(e, t - 1);
            }
            c === On[On.length - 1] ? (On.pop(), On.length && On[On.length - 1].observe()) : On.splice(On.indexOf(c), 1);
          };
        }
        function Mn(e, t) {
          let {
              triggerRef: n,
              popoverRef: r,
              isNonModal: o,
              isKeyboardDismissDisabled: i,
              shouldCloseOnInteractOutside: a,
              ...s
            } = e,
            {
              overlayProps: l,
              underlayProps: u
            } = bn({
              isOpen: t.isOpen,
              onClose: t.close,
              shouldCloseOnBlur: !0,
              isDismissable: !o,
              isKeyboardDismissDisabled: i,
              shouldCloseOnInteractOutside: a
            }, r),
            {
              overlayProps: c,
              arrowProps: d,
              placement: p
            } = gn({
              ...s,
              targetRef: n,
              overlayRef: r,
              isOpen: t.isOpen,
              onClose: o ? t.close : null
            });
          return En({
            isDisabled: o || !t.isOpen
          }), (0, j.bt)(() => {
            if (t.isOpen && !o && r.current) return Fn([r.current]);
          }, [o, t.isOpen, r]), {
            popoverProps: (0, j.dG)(l, c),
            arrowProps: d,
            underlayProps: u,
            placement: p
          };
        }
        const Rn = Ee.createContext(null);
        function jn(e) {
          let t = (0, Zt.Av)(),
            {
              portalContainer: n = t ? null : document.body,
              isExiting: r
            } = e,
            [o, i] = (0, Ee.useState)(!1),
            a = (0, Ee.useMemo)(() => ({
              contain: o,
              setContain: i
            }), [o, i]);
          if (!n) return null;
          let s = e.children;
          return e.disableFocusManagement || (s = Ee.createElement(B.MT, {
            restoreFocus: !0,
            contain: o && !r
          }, s)), s = Ee.createElement(Rn.Provider, {
            value: a
          }, Ee.createElement(N.mk, null, s)), Ut.createPortal(s, n);
        }
        function Bn() {
          let e = (0, Ee.useContext)(Rn),
            t = null == e ? void 0 : e.setContain;
          (0, j.bt)(() => {
            null == t || t(!0);
          }, [t]);
        }
        function Nn(e, t, n) {
          let {
            overlayProps: r,
            underlayProps: o
          } = bn({
            ...e,
            isOpen: t.isOpen,
            onClose: t.close
          }, n);
          return En({
            isDisabled: !t.isOpen
          }), Bn(), (0, Ee.useEffect)(() => {
            if (t.isOpen) return Fn([n.current]);
          }, [t.isOpen, n]), {
            modalProps: (0, j.dG)(r),
            underlayProps: o
          };
        }
        function Ln(e) {
          return (0, j.ad)() ? e.altKey : e.ctrlKey;
        }
        function Vn(e) {
          return (0, j.V5)() ? e.metaKey : e.ctrlKey;
        }
        function Kn(e) {
          let {
              keyboardDelegate: t,
              selectionManager: n,
              onTypeSelect: r
            } = e,
            o = (0, Ee.useRef)({
              search: "",
              timeout: null
            }).current;
          return {
            typeSelectProps: {
              onKeyDownCapture: t.getKeyForSearch ? e => {
                let i = function (e) {
                  return 1 !== e.length && /^[A-Z]/i.test(e) ? "" : e;
                }(e.key);
                if (!i || e.ctrlKey || e.metaKey || !e.currentTarget.contains(e.target)) return;
                " " === i && o.search.trim().length > 0 && (e.preventDefault(), "continuePropagation" in e || e.stopPropagation()), o.search += i;
                let a = t.getKeyForSearch(o.search, n.focusedKey);
                null == a && (a = t.getKeyForSearch(o.search)), null != a && (n.setFocusedKey(a), r && r(a)), clearTimeout(o.timeout), o.timeout = setTimeout(() => {
                  o.search = "";
                }, 1e3);
              } : null
            }
          };
        }
        function qn(e) {
          let {
              selectionManager: t,
              keyboardDelegate: n,
              ref: r,
              autoFocus: o = !1,
              shouldFocusWrap: i = !1,
              disallowEmptySelection: a = !1,
              disallowSelectAll: s = !1,
              selectOnFocus: l = "replace" === t.selectionBehavior,
              disallowTypeAhead: u = !1,
              shouldUseVirtualFocus: c,
              allowsTabNavigation: d = !1,
              isVirtualized: p,
              scrollRef: h = r,
              linkBehavior: f = "action"
            } = e,
            {
              direction: m
            } = (0, V.bU)(),
            g = (0, j.tv)(),
            v = (0, Ee.useRef)({
              top: 0,
              left: 0
            });
          (0, j.zX)(h, "scroll", p ? null : () => {
            v.current = {
              top: h.current.scrollTop,
              left: h.current.scrollLeft
            };
          });
          const y = (0, Ee.useRef)(o);
          (0, Ee.useEffect)(() => {
            if (y.current) {
              let e = null;
              "first" === o && (e = n.getFirstKey()), "last" === o && (e = n.getLastKey());
              let i = t.selectedKeys;
              if (i.size) for (let n of i) if (t.canSelectItem(n)) {
                e = n;
                break;
              }
              t.setFocused(!0), t.setFocusedKey(e), null != e || c || (0, B.ex)(r.current);
            }
          }, []);
          let b = (0, Ee.useRef)(t.focusedKey);
          (0, Ee.useEffect)(() => {
            let e = (0, N.Jz)();
            if (t.isFocused && null != t.focusedKey && (null == h ? void 0 : h.current)) {
              let n = h.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
              n && ("keyboard" === e || y.current) && (p || (0, j.zT)(h.current, n), "virtual" !== e && (0, j.Gt)(n, {
                containingElement: r.current
              }));
            }
            t.isFocused && null == t.focusedKey && null != b.current && (0, B.ex)(r.current), b.current = t.focusedKey, y.current = !1;
          }, [p, h, t.focusedKey, t.isFocused, r]);
          let w,
            x = {
              onKeyDown: e => {
                if (e.altKey && "Tab" === e.key && e.preventDefault(), !r.current.contains(e.target)) return;
                const o = (n, r) => {
                  if (null != n) {
                    if (t.isLink(n) && "selection" === f && l && !Ln(e)) {
                      (0, Ut.flushSync)(() => {
                        t.setFocusedKey(n, r);
                      });
                      let o = h.current.querySelector(`[data-key="${CSS.escape(n.toString())}"]`);
                      return void g.open(o, e);
                    }
                    if (t.setFocusedKey(n, r), t.isLink(n) && "override" === f) return;
                    e.shiftKey && "multiple" === t.selectionMode ? t.extendSelection(n) : l && !Ln(e) && t.replaceSelection(n);
                  }
                };
                switch (e.key) {
                  case "ArrowDown":
                    if (n.getKeyBelow) {
                      var u, c;
                      e.preventDefault();
                      let r = null != t.focusedKey ? n.getKeyBelow(t.focusedKey) : null === (u = n.getFirstKey) || void 0 === u ? void 0 : u.call(n);
                      null == r && i && (r = null === (c = n.getFirstKey) || void 0 === c ? void 0 : c.call(n, t.focusedKey)), o(r);
                    }
                    break;
                  case "ArrowUp":
                    if (n.getKeyAbove) {
                      var p, v;
                      e.preventDefault();
                      let r = null != t.focusedKey ? n.getKeyAbove(t.focusedKey) : null === (p = n.getLastKey) || void 0 === p ? void 0 : p.call(n);
                      null == r && i && (r = null === (v = n.getLastKey) || void 0 === v ? void 0 : v.call(n, t.focusedKey)), o(r);
                    }
                    break;
                  case "ArrowLeft":
                    if (n.getKeyLeftOf) {
                      var y, b;
                      e.preventDefault();
                      let r = n.getKeyLeftOf(t.focusedKey);
                      null == r && i && (r = "rtl" === m ? null === (y = n.getFirstKey) || void 0 === y ? void 0 : y.call(n, t.focusedKey) : null === (b = n.getLastKey) || void 0 === b ? void 0 : b.call(n, t.focusedKey)), o(r, "rtl" === m ? "first" : "last");
                    }
                    break;
                  case "ArrowRight":
                    if (n.getKeyRightOf) {
                      var w, x;
                      e.preventDefault();
                      let r = n.getKeyRightOf(t.focusedKey);
                      null == r && i && (r = "rtl" === m ? null === (w = n.getLastKey) || void 0 === w ? void 0 : w.call(n, t.focusedKey) : null === (x = n.getFirstKey) || void 0 === x ? void 0 : x.call(n, t.focusedKey)), o(r, "rtl" === m ? "last" : "first");
                    }
                    break;
                  case "Home":
                    if (n.getFirstKey) {
                      e.preventDefault();
                      let r = n.getFirstKey(t.focusedKey, Vn(e));
                      t.setFocusedKey(r), Vn(e) && e.shiftKey && "multiple" === t.selectionMode ? t.extendSelection(r) : l && t.replaceSelection(r);
                    }
                    break;
                  case "End":
                    if (n.getLastKey) {
                      e.preventDefault();
                      let r = n.getLastKey(t.focusedKey, Vn(e));
                      t.setFocusedKey(r), Vn(e) && e.shiftKey && "multiple" === t.selectionMode ? t.extendSelection(r) : l && t.replaceSelection(r);
                    }
                    break;
                  case "PageDown":
                    if (n.getKeyPageBelow) {
                      e.preventDefault(), o(n.getKeyPageBelow(t.focusedKey));
                    }
                    break;
                  case "PageUp":
                    if (n.getKeyPageAbove) {
                      e.preventDefault(), o(n.getKeyPageAbove(t.focusedKey));
                    }
                    break;
                  case "a":
                    Vn(e) && "multiple" === t.selectionMode && !0 !== s && (e.preventDefault(), t.selectAll());
                    break;
                  case "Escape":
                    e.preventDefault(), a || t.clearSelection();
                    break;
                  case "Tab":
                    if (!d) {
                      if (e.shiftKey) r.current.focus();else {
                        let e,
                          t,
                          n = (0, B.QL)(r.current, {
                            tabbable: !0
                          });
                        do {
                          t = n.lastChild(), t && (e = t);
                        } while (t);
                        e && !e.contains(document.activeElement) && (0, j.Ao)(e);
                      }
                      break;
                    }
                }
              },
              onFocus: e => {
                if (t.isFocused) e.currentTarget.contains(e.target) || t.setFocused(!1);else if (e.currentTarget.contains(e.target)) {
                  if (t.setFocused(!0), null == t.focusedKey) {
                    let r = e => {
                        null != e && (t.setFocusedKey(e), l && t.replaceSelection(e));
                      },
                      a = e.relatedTarget;
                    var o, i;
                    a && e.currentTarget.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_FOLLOWING ? r(null !== (o = t.lastSelectedKey) && void 0 !== o ? o : n.getLastKey()) : r(null !== (i = t.firstSelectedKey) && void 0 !== i ? i : n.getFirstKey());
                  } else p || (h.current.scrollTop = v.current.top, h.current.scrollLeft = v.current.left);
                  if (!p && null != t.focusedKey) {
                    let e = h.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
                    if (e) {
                      e.contains(document.activeElement) || (0, j.Ao)(e), "keyboard" === (0, N.Jz)() && (0, j.Gt)(e, {
                        containingElement: r.current
                      });
                    }
                  }
                }
              },
              onBlur: e => {
                e.currentTarget.contains(e.relatedTarget) || t.setFocused(!1);
              },
              onMouseDown(e) {
                h.current === e.target && e.preventDefault();
              }
            },
            {
              typeSelectProps: D
            } = Kn({
              keyboardDelegate: n,
              selectionManager: t
            });
          return u || (x = (0, j.dG)(D, x)), c || (w = null == t.focusedKey ? 0 : -1), {
            collectionProps: {
              ...x,
              tabIndex: w
            }
          };
        }
        function Hn(e) {
          let {
              selectionManager: t,
              key: n,
              ref: r,
              shouldSelectOnPressUp: o,
              shouldUseVirtualFocus: i,
              focus: a,
              isDisabled: s,
              onAction: l,
              allowsDifferentPressOrigin: u,
              linkBehavior: c = "action"
            } = e,
            d = (0, j.tv)(),
            p = e => {
              if ("keyboard" === e.pointerType && Ln(e)) t.toggleSelection(n);else {
                if ("none" === t.selectionMode) return;
                if (t.isLink(n)) {
                  if ("selection" === c) return d.open(r.current, e), void t.setSelectedKeys(t.selectedKeys);
                  if ("override" === c || "none" === c) return;
                }
                "single" === t.selectionMode ? t.isSelected(n) && !t.disallowEmptySelection ? t.toggleSelection(n) : t.replaceSelection(n) : e && e.shiftKey ? t.extendSelection(n) : "toggle" === t.selectionBehavior || e && (Vn(e) || "touch" === e.pointerType || "virtual" === e.pointerType) ? t.toggleSelection(n) : t.replaceSelection(n);
              }
            };
          (0, Ee.useEffect)(() => {
            n === t.focusedKey && t.isFocused && !i && (a ? a() : document.activeElement !== r.current && (0, B.ex)(r.current));
          }, [r, n, t.focusedKey, t.childFocusStrategy, t.isFocused, i]), s = s || t.isDisabled(n);
          let h = {};
          i || s ? s && (h.onMouseDown = e => {
            e.preventDefault();
          }) : h = {
            tabIndex: n === t.focusedKey ? 0 : -1,
            onFocus(e) {
              e.target === r.current && t.setFocusedKey(n);
            }
          };
          let f = t.isLink(n) && "override" === c,
            m = t.isLink(n) && "selection" !== c && "none" !== c,
            g = !s && t.canSelectItem(n) && !f,
            v = (l || m) && !s,
            y = v && ("replace" === t.selectionBehavior ? !g : !g || t.isEmpty),
            b = v && g && "replace" === t.selectionBehavior,
            w = y || b,
            x = (0, Ee.useRef)(null),
            D = w && g,
            C = (0, Ee.useRef)(!1),
            S = (0, Ee.useRef)(!1),
            E = e => {
              l && l(), m && d.open(r.current, e);
            },
            _ = {};
          o ? (_.onPressStart = e => {
            x.current = e.pointerType, C.current = D, "keyboard" !== e.pointerType || w && !Zn() || p(e);
          }, u ? (_.onPressUp = y ? null : e => {
            "keyboard" !== e.pointerType && g && p(e);
          }, _.onPress = y ? E : null) : _.onPress = e => {
            if (y || b && "mouse" !== e.pointerType) {
              if ("keyboard" === e.pointerType && !Un()) return;
              E(e);
            } else "keyboard" !== e.pointerType && g && p(e);
          }) : (_.onPressStart = e => {
            x.current = e.pointerType, C.current = D, S.current = y, g && ("mouse" === e.pointerType && !y || "keyboard" === e.pointerType && (!v || Zn())) && p(e);
          }, _.onPress = e => {
            ("touch" === e.pointerType || "pen" === e.pointerType || "virtual" === e.pointerType || "keyboard" === e.pointerType && w && Un() || "mouse" === e.pointerType && S.current) && (w ? E(e) : g && p(e));
          }), h["data-key"] = n, _.preventFocusOnPress = i;
          let {
              pressProps: P,
              isPressed: k
            } = (0, N.r7)(_),
            A = b ? e => {
              "mouse" === x.current && (e.stopPropagation(), e.preventDefault(), E(e));
            } : void 0,
            {
              longPressProps: z
            } = (0, N.TA)({
              isDisabled: !D,
              onLongPress(e) {
                "touch" === e.pointerType && (p(e), t.setSelectionBehavior("toggle"));
              }
            }),
            T = t.isLink(n) ? e => {
              j.nG.isOpening || e.preventDefault();
            } : void 0;
          return {
            itemProps: (0, j.dG)(h, g || y ? P : {}, D ? z : {}, {
              onDoubleClick: A,
              onDragStartCapture: e => {
                "touch" === x.current && C.current && e.preventDefault();
              },
              onClick: T
            }),
            isPressed: k,
            isSelected: t.isSelected(n),
            isFocused: t.isFocused && t.focusedKey === n,
            isDisabled: s,
            allowsSelection: g,
            hasAction: w
          };
        }
        function Un() {
          let e = window.event;
          return "Enter" === (null == e ? void 0 : e.key);
        }
        function Zn() {
          let e = window.event;
          return " " === (null == e ? void 0 : e.key) || "Space" === (null == e ? void 0 : e.code);
        }
        class $n {
          getNextKey(e) {
            for (e = this.collection.getKeyAfter(e); null != e;) {
              if ("item" === this.collection.getItem(e).type && !this.disabledKeys.has(e)) return e;
              e = this.collection.getKeyAfter(e);
            }
            return null;
          }
          getPreviousKey(e) {
            for (e = this.collection.getKeyBefore(e); null != e;) {
              if ("item" === this.collection.getItem(e).type && !this.disabledKeys.has(e)) return e;
              e = this.collection.getKeyBefore(e);
            }
            return null;
          }
          findKey(e, t, n) {
            let r = this.getItem(e);
            if (!r) return null;
            let o = r.getBoundingClientRect();
            do {
              e = t(e), r = this.getItem(e);
            } while (r && n(o, r.getBoundingClientRect()));
            return e;
          }
          isSameRow(e, t) {
            return e.top === t.top || e.left !== t.left;
          }
          isSameColumn(e, t) {
            return e.left === t.left || e.top !== t.top;
          }
          getKeyBelow(e) {
            return "grid" === this.layout && "vertical" === this.orientation ? this.findKey(e, e => this.getNextKey(e), this.isSameRow) : this.getNextKey(e);
          }
          getKeyAbove(e) {
            return "grid" === this.layout && "vertical" === this.orientation ? this.findKey(e, e => this.getPreviousKey(e), this.isSameRow) : this.getPreviousKey(e);
          }
          getNextColumn(e, t) {
            return t ? this.getPreviousKey(e) : this.getNextKey(e);
          }
          getKeyRightOf(e) {
            return "grid" === this.layout ? "vertical" === this.orientation ? this.getNextColumn(e, "rtl" === this.direction) : this.findKey(e, e => this.getNextColumn(e, "rtl" === this.direction), this.isSameColumn) : "horizontal" === this.orientation ? this.getNextColumn(e, "rtl" === this.direction) : null;
          }
          getKeyLeftOf(e) {
            return "grid" === this.layout ? "vertical" === this.orientation ? this.getNextColumn(e, "ltr" === this.direction) : this.findKey(e, e => this.getNextColumn(e, "ltr" === this.direction), this.isSameColumn) : "horizontal" === this.orientation ? this.getNextColumn(e, "ltr" === this.direction) : null;
          }
          getFirstKey() {
            let e = this.collection.getFirstKey();
            for (; null != e;) {
              let t = this.collection.getItem(e);
              if ("item" === (null == t ? void 0 : t.type) && !this.disabledKeys.has(e)) return e;
              e = this.collection.getKeyAfter(e);
            }
            return null;
          }
          getLastKey() {
            let e = this.collection.getLastKey();
            for (; null != e;) {
              if ("item" === this.collection.getItem(e).type && !this.disabledKeys.has(e)) return e;
              e = this.collection.getKeyBefore(e);
            }
            return null;
          }
          getItem(e) {
            return this.ref.current.querySelector(`[data-key="${CSS.escape(e.toString())}"]`);
          }
          getKeyPageAbove(e) {
            let t = this.ref.current,
              n = this.getItem(e);
            if (!n) return null;
            if (!(0, j.a9)(t)) return this.getFirstKey();
            let r = t.getBoundingClientRect(),
              o = n.getBoundingClientRect();
            if ("horizontal" === this.orientation) {
              let i = r.x - t.scrollLeft,
                a = Math.max(0, o.x - i + o.width - r.width);
              for (; n && o.x - i > a;) n = null == (e = this.getKeyAbove(e)) ? null : this.getItem(e), o = null == n ? void 0 : n.getBoundingClientRect();
            } else {
              let i = r.y - t.scrollTop,
                a = Math.max(0, o.y - i + o.height - r.height);
              for (; n && o.y - i > a;) n = null == (e = this.getKeyAbove(e)) ? null : this.getItem(e), o = null == n ? void 0 : n.getBoundingClientRect();
            }
            return null != e ? e : this.getFirstKey();
          }
          getKeyPageBelow(e) {
            let t = this.ref.current,
              n = this.getItem(e);
            if (!n) return null;
            if (!(0, j.a9)(t)) return this.getLastKey();
            let r = t.getBoundingClientRect(),
              o = n.getBoundingClientRect();
            if ("horizontal" === this.orientation) {
              let i = r.x - t.scrollLeft,
                a = Math.min(t.scrollWidth, o.x - i - o.width + r.width);
              for (; n && o.x - i < a;) n = null == (e = this.getKeyBelow(e)) ? null : this.getItem(e), o = null == n ? void 0 : n.getBoundingClientRect();
            } else {
              let i = r.y - t.scrollTop,
                a = Math.min(t.scrollHeight, o.y - i - o.height + r.height);
              for (; n && o.y - i < a;) n = null == (e = this.getKeyBelow(e)) ? null : this.getItem(e), o = null == n ? void 0 : n.getBoundingClientRect();
            }
            return null != e ? e : this.getLastKey();
          }
          getKeyForSearch(e, t) {
            if (!this.collator) return null;
            let n = this.collection,
              r = t || this.getFirstKey();
            for (; null != r;) {
              let t = n.getItem(r),
                o = t.textValue.slice(0, e.length);
              if (t.textValue && 0 === this.collator.compare(o, e)) return r;
              r = this.getKeyBelow(r);
            }
            return null;
          }
          constructor(...e) {
            if (1 === e.length) {
              let t = e[0];
              this.collection = t.collection, this.ref = t.ref, this.collator = t.collator, this.disabledKeys = t.disabledKeys || new Set(), this.orientation = t.orientation, this.direction = t.direction, this.layout = t.layout || "stack";
            } else this.collection = e[0], this.disabledKeys = e[1], this.ref = e[2], this.collator = e[3], this.layout = "stack", this.orientation = "vertical";
            "stack" === this.layout && "vertical" === this.orientation && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
          }
        }
        function Gn(e) {
          let {
              selectionManager: t,
              collection: n,
              disabledKeys: r,
              ref: o,
              keyboardDelegate: i
            } = e,
            a = (0, V.Xe)({
              usage: "search",
              sensitivity: "base"
            }),
            s = t.disabledBehavior,
            l = (0, Ee.useMemo)(() => i || new $n(n, "selection" === s ? new Set() : r, o, a), [i, n, r, o, a, s]),
            {
              collectionProps: u
            } = qn({
              ...e,
              ref: o,
              selectionManager: t,
              keyboardDelegate: l
            });
          return {
            listProps: u
          };
        }
        var Wn = n(45861);
        const Yn = new WeakMap();
        function Xn(e, t) {
          let n = Yn.get(e);
          if (!n) throw new Error("Unknown list");
          return `${n.id}-option-${r = t, "string" == typeof r ? r.replace(/\s*/g, "") : "" + r}`;
          var r;
        }
        function Qn(e, t, n) {
          let r = (0, j.zL)(e, {
              labelable: !0
            }),
            o = e.selectionBehavior || "toggle",
            i = e.linkBehavior || ("replace" === o ? "action" : "override");
          "toggle" === o && "action" === i && (i = "override");
          let {
              listProps: a
            } = Gn({
              ...e,
              ref: n,
              selectionManager: t.selectionManager,
              collection: t.collection,
              disabledKeys: t.disabledKeys,
              linkBehavior: i
            }),
            {
              focusWithinProps: s
            } = (0, N.L_)({
              onFocusWithin: e.onFocus,
              onBlurWithin: e.onBlur,
              onFocusWithinChange: e.onFocusChange
            }),
            l = (0, j.Me)(e.id);
          Yn.set(t, {
            id: l,
            shouldUseVirtualFocus: e.shouldUseVirtualFocus,
            shouldSelectOnPressUp: e.shouldSelectOnPressUp,
            shouldFocusOnHover: e.shouldFocusOnHover,
            isVirtualized: e.isVirtualized,
            onAction: e.onAction,
            linkBehavior: i
          });
          let {
            labelProps: u,
            fieldProps: c
          } = (0, Ae.N)({
            ...e,
            id: l,
            labelElementType: "span"
          });
          return {
            labelProps: u,
            listBoxProps: (0, j.dG)(r, s, "multiple" === t.selectionManager.selectionMode ? {
              "aria-multiselectable": "true"
            } : {}, {
              role: "listbox",
              ...(0, j.dG)(c, a)
            })
          };
        }
        function Jn(e, t, n) {
          var r;
          let {
              key: o
            } = e,
            i = Yn.get(t);
          var a;
          let s = null !== (a = e.isDisabled) && void 0 !== a ? a : t.disabledKeys.has(o);
          var l;
          let u = null !== (l = e.isSelected) && void 0 !== l ? l : t.selectionManager.isSelected(o);
          var c;
          let d = null !== (c = e.shouldSelectOnPressUp) && void 0 !== c ? c : null == i ? void 0 : i.shouldSelectOnPressUp;
          var p;
          let h = null !== (p = e.shouldFocusOnHover) && void 0 !== p ? p : null == i ? void 0 : i.shouldFocusOnHover;
          var f;
          let m = null !== (f = e.shouldUseVirtualFocus) && void 0 !== f ? f : null == i ? void 0 : i.shouldUseVirtualFocus;
          var g;
          let v = null !== (g = e.isVirtualized) && void 0 !== g ? g : null == i ? void 0 : i.isVirtualized,
            y = (0, j.mp)(),
            b = (0, j.mp)(),
            w = {
              role: "option",
              "aria-disabled": s || void 0,
              "aria-selected": "none" !== t.selectionManager.selectionMode ? u : void 0
            };
          (0, j.V5)() && (0, j.Pf)() || (w["aria-label"] = e["aria-label"], w["aria-labelledby"] = y, w["aria-describedby"] = b);
          let x = t.collection.getItem(o);
          if (v) {
            let e = Number(null == x ? void 0 : x.index);
            w["aria-posinset"] = Number.isNaN(e) ? void 0 : e + 1, w["aria-setsize"] = (0, Wn.is)(t.collection);
          }
          let {
              itemProps: D,
              isPressed: C,
              isFocused: S,
              hasAction: E,
              allowsSelection: _
            } = Hn({
              selectionManager: t.selectionManager,
              key: o,
              ref: n,
              shouldSelectOnPressUp: d,
              allowsDifferentPressOrigin: d && h,
              isVirtualized: v,
              shouldUseVirtualFocus: m,
              isDisabled: s,
              onAction: (null == i ? void 0 : i.onAction) ? () => {
                var e;
                return null == i || null === (e = i.onAction) || void 0 === e ? void 0 : e.call(i, o);
              } : void 0,
              linkBehavior: null == i ? void 0 : i.linkBehavior
            }),
            {
              hoverProps: P
            } = (0, N.XI)({
              isDisabled: s || !h,
              onHoverStart() {
                (0, N.E)() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(o));
              }
            }),
            k = (0, j.zL)(null == x ? void 0 : x.props, {
              isLink: !!(null == x || null === (r = x.props) || void 0 === r ? void 0 : r.href)
            });
          return delete k.id, {
            optionProps: {
              ...w,
              ...(0, j.dG)(k, D, P),
              id: Xn(t, o)
            },
            labelProps: {
              id: y
            },
            descriptionProps: {
              id: b
            },
            isFocused: S,
            isFocusVisible: S && (0, N.E)(),
            isSelected: u,
            isDisabled: s,
            isPressed: C,
            allowsSelection: _,
            hasAction: E
          };
        }
        function er(e) {
          let {
              heading: t,
              "aria-label": n
            } = e,
            r = (0, j.Me)();
          return {
            itemProps: {
              role: "presentation"
            },
            headingProps: t ? {
              id: r,
              role: "presentation"
            } : {},
            groupProps: {
              role: "group",
              "aria-label": n,
              "aria-labelledby": t ? r : void 0
            }
          };
        }
        function tr(e) {
          return e && e.__esModule ? e.default : e;
        }
        var nr;
        function rr(e, t, n) {
          let {
              type: r = "menu",
              isDisabled: o,
              trigger: i = "press"
            } = e,
            a = (0, j.Me)(),
            {
              triggerProps: s,
              overlayProps: l
            } = wn({
              type: r
            }, t, n),
            u = (0, V.qb)(tr(nr), "@react-aria/menu"),
            {
              longPressProps: c
            } = (0, N.TA)({
              isDisabled: o || "longPress" !== i,
              accessibilityDescription: u.format("longPressMessage"),
              onLongPressStart() {
                t.close();
              },
              onLongPress() {
                t.open("first");
              }
            }),
            d = {
              onPressStart(e) {
                "touch" === e.pointerType || "keyboard" === e.pointerType || o || t.toggle("virtual" === e.pointerType ? "first" : null);
              },
              onPress(e) {
                "touch" !== e.pointerType || o || t.toggle();
              }
            };
          return delete s.onPress, {
            menuTriggerProps: {
              ...s,
              ...("press" === i ? d : c),
              id: a,
              onKeyDown: e => {
                if (!o && ("longPress" !== i || e.altKey) && n && n.current) switch (e.key) {
                  case "Enter":
                  case " ":
                    if ("longPress" === i) return;
                  case "ArrowDown":
                    "continuePropagation" in e || e.stopPropagation(), e.preventDefault(), t.toggle("first");
                    break;
                  case "ArrowUp":
                    "continuePropagation" in e || e.stopPropagation(), e.preventDefault(), t.toggle("last");
                    break;
                  default:
                    "continuePropagation" in e && e.continuePropagation();
                }
              }
            },
            menuProps: {
              ...l,
              "aria-labelledby": a,
              autoFocus: t.focusStrategy || !0,
              onClose: t.close
            }
          };
        }
        nr = {
          "ar-AE": {
            longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
          },
          "bg-BG": {
            longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
          },
          "cs-CZ": {
            longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
          },
          "da-DK": {
            longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
          },
          "de-DE": {
            longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
          },
          "el-GR": {
            longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
          },
          "en-US": {
            longPressMessage: "Long press or press Alt + ArrowDown to open menu"
          },
          "es-ES": {
            longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
          },
          "et-EE": {
            longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
          },
          "fi-FI": {
            longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
          },
          "fr-FR": {
            longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
          },
          "he-IL": {
            longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
          },
          "hr-HR": {
            longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
          },
          "hu-HU": {
            longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
          },
          "it-IT": {
            longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
          },
          "ja-JP": {
            longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
          },
          "ko-KR": {
            longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
          },
          "lt-LT": {
            longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
          },
          "lv-LV": {
            longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
          },
          "nb-NO": {
            longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
          },
          "nl-NL": {
            longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
          },
          "pl-PL": {
            longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
          },
          "pt-BR": {
            longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
          },
          "pt-PT": {
            longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
          },
          "ro-RO": {
            longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
          },
          "ru-RU": {
            longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
          },
          "sk-SK": {
            longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
          },
          "sl-SI": {
            longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
          },
          "sr-SP": {
            longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
          },
          "sv-SE": {
            longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
          },
          "tr-TR": {
            longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
          },
          "uk-UA": {
            longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
          },
          "zh-CN": {
            longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
          },
          "zh-TW": {
            longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
          }
        };
        const or = new WeakMap();
        function ir(e, t, n) {
          let {
            shouldFocusWrap: r = !0,
            onKeyDown: o,
            onKeyUp: i,
            ...a
          } = e;
          e["aria-label"] || e["aria-labelledby"] || console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
          let s = (0, j.zL)(e, {
              labelable: !0
            }),
            {
              listProps: l
            } = Gn({
              ...a,
              ref: n,
              selectionManager: t.selectionManager,
              collection: t.collection,
              disabledKeys: t.disabledKeys,
              shouldFocusWrap: r,
              linkBehavior: "override"
            });
          return or.set(t, {
            onClose: e.onClose,
            onAction: e.onAction
          }), {
            menuProps: (0, j.dG)(s, {
              onKeyDown: o,
              onKeyUp: i
            }, {
              role: "menu",
              ...l,
              onKeyDown: e => {
                "Escape" !== e.key && l.onKeyDown(e);
              }
            })
          };
        }
        function ar(e, t, n) {
          var r;
          let {
              key: o,
              closeOnSelect: i,
              isVirtualized: a,
              "aria-haspopup": s,
              onPressStart: l,
              onPressUp: u,
              onPress: c,
              onPressChange: d,
              onPressEnd: p,
              onHoverStart: h,
              onHoverChange: f,
              onHoverEnd: m,
              onKeyDown: g,
              onKeyUp: v,
              onFocus: y,
              onFocusChange: b,
              onBlur: w
            } = e,
            x = !!s;
          var D;
          let C = null !== (D = e.isDisabled) && void 0 !== D ? D : t.disabledKeys.has(o);
          var S;
          let E = null !== (S = e.isSelected) && void 0 !== S ? S : t.selectionManager.isSelected(o),
            _ = or.get(t),
            P = e.onClose || _.onClose,
            k = x ? () => {} : e.onAction || _.onAction,
            A = (0, j.tv)(),
            z = e => {
              k && k(o), e.target instanceof HTMLAnchorElement && A.open(e.target, e);
            },
            T = "menuitem";
          x || ("single" === t.selectionManager.selectionMode ? T = "menuitemradio" : "multiple" === t.selectionManager.selectionMode && (T = "menuitemcheckbox"));
          let O = (0, j.mp)(),
            I = (0, j.mp)(),
            F = (0, j.mp)(),
            M = {
              "aria-disabled": C || void 0,
              role: T,
              "aria-label": e["aria-label"],
              "aria-labelledby": O,
              "aria-describedby": [I, F].filter(Boolean).join(" ") || void 0,
              "aria-controls": e["aria-controls"],
              "aria-haspopup": s,
              "aria-expanded": e["aria-expanded"]
            };
          "none" === t.selectionManager.selectionMode || x || (M["aria-checked"] = E);
          let R = t.collection.getItem(o);
          a && (M["aria-posinset"] = null == R ? void 0 : R.index, M["aria-setsize"] = (0, Wn.is)(t.collection));
          let {
              itemProps: B,
              isFocused: L
            } = Hn({
              selectionManager: t.selectionManager,
              key: o,
              ref: n,
              shouldSelectOnPressUp: !0,
              allowsDifferentPressOrigin: !0,
              linkBehavior: "none"
            }),
            {
              pressProps: V,
              isPressed: K
            } = (0, N.r7)({
              onPressStart: e => {
                "keyboard" === e.pointerType && z(e), null == l || l(e);
              },
              onPress: c,
              onPressUp: e => {
                "keyboard" !== e.pointerType && (z(e), !x && P && (null != i ? i : "multiple" !== t.selectionManager.selectionMode || t.selectionManager.isLink(o)) && P()), null == u || u(e);
              },
              onPressChange: d,
              onPressEnd: p,
              isDisabled: C
            }),
            {
              hoverProps: q
            } = (0, N.XI)({
              isDisabled: C,
              onHoverStart(e) {
                (0, N.E)() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(o)), null == h || h(e);
              },
              onHoverChange: f,
              onHoverEnd: m
            }),
            {
              keyboardProps: H
            } = (0, N.v5)({
              onKeyDown: e => {
                if (e.repeat) e.continuePropagation();else switch (e.key) {
                  case " ":
                    C || "none" !== t.selectionManager.selectionMode || x || !1 === i || !P || P();
                    break;
                  case "Enter":
                    C || !1 === i || x || !P || P();
                    break;
                  default:
                    x || e.continuePropagation(), null == g || g(e);
                }
              },
              onKeyUp: v
            }),
            {
              focusProps: U
            } = (0, N.KK)({
              onBlur: w,
              onFocus: y,
              onFocusChange: b
            }),
            Z = (0, j.zL)(R.props, {
              isLink: !!(null == R || null === (r = R.props) || void 0 === r ? void 0 : r.href)
            });
          return delete Z.id, {
            menuItemProps: {
              ...M,
              ...(0, j.dG)(Z, x ? {
                onFocus: B.onFocus
              } : B, V, q, H, U),
              tabIndex: null != B.tabIndex ? -1 : void 0
            },
            labelProps: {
              id: O
            },
            descriptionProps: {
              id: I
            },
            keyboardShortcutProps: {
              id: F
            },
            isFocused: L,
            isSelected: E,
            isPressed: K,
            isDisabled: C
          };
        }
        function sr(e) {
          let {
              heading: t,
              "aria-label": n
            } = e,
            r = (0, j.Me)();
          return {
            itemProps: {
              role: "presentation"
            },
            headingProps: t ? {
              id: r,
              role: "presentation"
            } : {},
            groupProps: {
              role: "group",
              "aria-label": n,
              "aria-labelledby": t ? r : void 0
            }
          };
        }
        Math.PI;
        var lr = n(91788);
        function ur(e) {
          return e && e.__esModule ? e.default : e;
        }
        var cr;
        function dr(e, t) {
          let {
              buttonRef: n,
              popoverRef: r,
              inputRef: o,
              listBoxRef: i,
              keyboardDelegate: a,
              shouldFocusWrap: s,
              isReadOnly: l,
              isDisabled: u
            } = e,
            c = (0, V.qb)(ur(cr), "@react-aria/combobox"),
            {
              menuTriggerProps: d,
              menuProps: p
            } = rr({
              type: "listbox",
              isDisabled: u || l
            }, t, n);
          Yn.set(t, {
            id: p.id
          });
          let h = (0, Ee.useMemo)(() => a || new $n(t.collection, t.disabledKeys, i), [a, t.collection, t.disabledKeys, i]),
            {
              collectionProps: f
            } = qn({
              selectionManager: t.selectionManager,
              keyboardDelegate: h,
              disallowTypeAhead: !0,
              disallowEmptySelection: !0,
              shouldFocusWrap: s,
              ref: o,
              isVirtualized: !0
            }),
            m = (0, j.tv)(),
            {
              isInvalid: g,
              validationErrors: v,
              validationDetails: y
            } = t.displayValidation,
            {
              labelProps: b,
              inputProps: w,
              descriptionProps: x,
              errorMessageProps: D
            } = (0, lr.E)({
              ...e,
              onChange: t.setInputValue,
              onKeyDown: l ? e.onKeyDown : (0, j.tS)(t.isOpen && f.onKeyDown, n => {
                switch (n.key) {
                  case "Enter":
                  case "Tab":
                    if (t.isOpen && "Enter" === n.key && n.preventDefault(), t.isOpen && null != t.selectionManager.focusedKey && t.selectionManager.isLink(t.selectionManager.focusedKey)) {
                      if ("Enter" === n.key) {
                        let e = i.current.querySelector(`[data-key="${CSS.escape(t.selectionManager.focusedKey.toString())}"]`);
                        e instanceof HTMLAnchorElement && m.open(e, n);
                      }
                      t.close();
                    } else t.commit();
                    break;
                  case "Escape":
                    (null !== t.selectedKey || "" === t.inputValue || e.allowsCustomValue) && n.continuePropagation(), t.revert();
                    break;
                  case "ArrowDown":
                    t.open("first", "manual");
                    break;
                  case "ArrowUp":
                    t.open("last", "manual");
                    break;
                  case "ArrowLeft":
                  case "ArrowRight":
                    t.selectionManager.setFocusedKey(null);
                }
              }, e.onKeyDown),
              onBlur: o => {
                var i;
                o.relatedTarget === (null == n ? void 0 : n.current) || (null === (i = r.current) || void 0 === i ? void 0 : i.contains(o.relatedTarget)) || (e.onBlur && e.onBlur(o), t.setFocused(!1));
              },
              value: t.inputValue,
              onFocus: n => {
                t.isFocused || (e.onFocus && e.onFocus(n), t.setFocused(!0));
              },
              autoComplete: "off",
              validate: void 0,
              [Pe.tL]: t
            }, o),
            C = (0, j.bE)({
              id: d.id,
              "aria-label": c.format("buttonLabel"),
              "aria-labelledby": e["aria-labelledby"] || b.id
            }),
            S = (0, j.bE)({
              id: p.id,
              "aria-label": c.format("listboxLabel"),
              "aria-labelledby": e["aria-labelledby"] || b.id
            }),
            E = (0, Ee.useRef)(0),
            _ = null != t.selectionManager.focusedKey && t.isOpen ? t.collection.getItem(t.selectionManager.focusedKey) : void 0;
          var P;
          let k = null !== (P = null == _ ? void 0 : _.parentKey) && void 0 !== P ? P : null;
          var A;
          let z = null !== (A = t.selectionManager.focusedKey) && void 0 !== A ? A : null,
            T = (0, Ee.useRef)(k),
            O = (0, Ee.useRef)(z);
          (0, Ee.useEffect)(() => {
            if ((0, j.ad)() && null != _ && z !== O.current) {
              let e = t.selectionManager.isSelected(z),
                n = null != k ? t.collection.getItem(k) : null,
                r = (null == n ? void 0 : n["aria-label"]) || ("string" == typeof (null == n ? void 0 : n.rendered) ? n.rendered : "") || "",
                o = c.format("focusAnnouncement", {
                  isGroupChange: n && k !== T.current,
                  groupTitle: r,
                  groupCount: n ? [...(0, Wn._P)(n, t.collection)].length : 0,
                  optionText: _["aria-label"] || _.textValue || "",
                  isSelected: e
                });
              (0, Se.xQ)(o);
            }
            T.current = k, O.current = z;
          });
          let I = (0, Wn.is)(t.collection),
            F = (0, Ee.useRef)(I),
            M = (0, Ee.useRef)(t.isOpen);
          (0, Ee.useEffect)(() => {
            let e = t.isOpen !== M.current && (null == t.selectionManager.focusedKey || (0, j.ad)());
            if (t.isOpen && (e || I !== F.current)) {
              let e = c.format("countAnnouncement", {
                optionCount: I
              });
              (0, Se.xQ)(e);
            }
            F.current = I, M.current = t.isOpen;
          });
          let R = (0, Ee.useRef)(t.selectedKey);
          return (0, Ee.useEffect)(() => {
            if ((0, j.ad)() && t.isFocused && t.selectedItem && t.selectedKey !== R.current) {
              let e = t.selectedItem["aria-label"] || t.selectedItem.textValue || "",
                n = c.format("selectedAnnouncement", {
                  optionText: e
                });
              (0, Se.xQ)(n);
            }
            R.current = t.selectedKey;
          }), (0, Ee.useEffect)(() => {
            if (t.isOpen) return Fn([o.current, r.current]);
          }, [t.isOpen, o, r]), {
            labelProps: b,
            buttonProps: {
              ...d,
              ...C,
              excludeFromTabOrder: !0,
              onPress: e => {
                "touch" === e.pointerType && (o.current.focus(), t.toggle(null, "manual"));
              },
              onPressStart: e => {
                "touch" !== e.pointerType && (o.current.focus(), t.toggle("keyboard" === e.pointerType || "virtual" === e.pointerType ? "first" : null, "manual"));
              },
              isDisabled: u || l
            },
            inputProps: (0, j.dG)(w, {
              role: "combobox",
              "aria-expanded": d["aria-expanded"],
              "aria-controls": t.isOpen ? p.id : void 0,
              "aria-autocomplete": "list",
              "aria-activedescendant": _ ? Xn(t, _.key) : void 0,
              onTouchEnd: e => {
                if (u || l) return;
                if (e.timeStamp - E.current < 500) return e.preventDefault(), void o.current.focus();
                let n = e.target.getBoundingClientRect(),
                  r = e.changedTouches[0],
                  i = Math.ceil(n.left + .5 * n.width),
                  a = Math.ceil(n.top + .5 * n.height);
                r.clientX === i && r.clientY === a && (e.preventDefault(), o.current.focus(), t.toggle(null, "manual"), E.current = e.timeStamp);
              },
              autoCorrect: "off",
              spellCheck: "false"
            }),
            listBoxProps: (0, j.dG)(p, S, {
              autoFocus: t.focusStrategy,
              shouldUseVirtualFocus: !0,
              shouldSelectOnPressUp: !0,
              shouldFocusOnHover: !0,
              linkBehavior: "selection"
            }),
            descriptionProps: x,
            errorMessageProps: D,
            isInvalid: g,
            validationErrors: v,
            validationDetails: y
          };
        }
        cr = {
          "ar-AE": Te,
          "bg-BG": Oe,
          "cs-CZ": Ie,
          "da-DK": Fe,
          "de-DE": Me,
          "el-GR": Re,
          "en-US": je,
          "es-ES": Be,
          "et-EE": Ne,
          "fi-FI": Le,
          "fr-FR": Ve,
          "he-IL": Ke,
          "hr-HR": qe,
          "hu-HU": He,
          "it-IT": Ue,
          "ja-JP": Ze,
          "ko-KR": $e,
          "lt-LT": Ge,
          "lv-LV": We,
          "nb-NO": Ye,
          "nl-NL": Xe,
          "pl-PL": Qe,
          "pt-BR": Je,
          "pt-PT": et,
          "ro-RO": tt,
          "ru-RU": nt,
          "sk-SK": rt,
          "sl-SI": ot,
          "sr-SP": it,
          "sv-SE": at,
          "tr-TR": st,
          "uk-UA": lt,
          "zh-CN": ut,
          "zh-TW": ct
        };
        var pr;
        pr = {
          calendar: "التقويم",
          day: "يوم",
          dayPeriod: "ص/م",
          endDate: "تاريخ الانتهاء",
          era: "العصر",
          hour: "الساعات",
          minute: "الدقائق",
          month: "الشهر",
          second: "الثواني",
          selectedDateDescription: e => `تاريخ محدد: ${e.date}`,
          selectedRangeDescription: e => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
          selectedTimeDescription: e => `الوقت المحدد: ${e.time}`,
          startDate: "تاريخ البدء",
          timeZoneName: "التوقيت",
          weekday: "اليوم",
          year: "السنة"
        };
        var hr;
        hr = {
          calendar: "Календар",
          day: "ден",
          dayPeriod: "пр.об./сл.об.",
          endDate: "Крайна дата",
          era: "ера",
          hour: "час",
          minute: "минута",
          month: "месец",
          second: "секунда",
          selectedDateDescription: e => `Избрана дата: ${e.date}`,
          selectedRangeDescription: e => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
          selectedTimeDescription: e => `Избрано време: ${e.time}`,
          startDate: "Начална дата",
          timeZoneName: "часова зона",
          weekday: "ден от седмицата",
          year: "година"
        };
        var fr;
        fr = {
          calendar: "Kalendář",
          day: "den",
          dayPeriod: "část dne",
          endDate: "Konečné datum",
          era: "letopočet",
          hour: "hodina",
          minute: "minuta",
          month: "měsíc",
          second: "sekunda",
          selectedDateDescription: e => `Vybrané datum: ${e.date}`,
          selectedRangeDescription: e => `Vybrané období: ${e.startDate} až ${e.endDate}`,
          selectedTimeDescription: e => `Vybraný čas: ${e.time}`,
          startDate: "Počáteční datum",
          timeZoneName: "časové pásmo",
          weekday: "den v týdnu",
          year: "rok"
        };
        var mr;
        mr = {
          calendar: "Kalender",
          day: "dag",
          dayPeriod: "AM/PM",
          endDate: "Slutdato",
          era: "æra",
          hour: "time",
          minute: "minut",
          month: "måned",
          second: "sekund",
          selectedDateDescription: e => `Valgt dato: ${e.date}`,
          selectedRangeDescription: e => `Valgt interval: ${e.startDate} til ${e.endDate}`,
          selectedTimeDescription: e => `Valgt tidspunkt: ${e.time}`,
          startDate: "Startdato",
          timeZoneName: "tidszone",
          weekday: "ugedag",
          year: "år"
        };
        var gr;
        gr = {
          calendar: "Kalender",
          day: "Tag",
          dayPeriod: "Tageshälfte",
          endDate: "Enddatum",
          era: "Epoche",
          hour: "Stunde",
          minute: "Minute",
          month: "Monat",
          second: "Sekunde",
          selectedDateDescription: e => `Ausgewähltes Datum: ${e.date}`,
          selectedRangeDescription: e => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
          selectedTimeDescription: e => `Ausgewählte Zeit: ${e.time}`,
          startDate: "Anfangsdatum",
          timeZoneName: "Zeitzone",
          weekday: "Wochentag",
          year: "Jahr"
        };
        var vr;
        vr = {
          calendar: "Ημερολόγιο",
          day: "ημέρα",
          dayPeriod: "π.μ./μ.μ.",
          endDate: "Ημερομηνία λήξης",
          era: "περίοδος",
          hour: "ώρα",
          minute: "λεπτό",
          month: "μήνας",
          second: "δευτερόλεπτο",
          selectedDateDescription: e => `Επιλεγμένη ημερομηνία: ${e.date}`,
          selectedRangeDescription: e => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
          selectedTimeDescription: e => `Επιλεγμένη ώρα: ${e.time}`,
          startDate: "Ημερομηνία έναρξης",
          timeZoneName: "ζώνη ώρας",
          weekday: "καθημερινή",
          year: "έτος"
        };
        var yr;
        yr = {
          era: "era",
          year: "year",
          month: "month",
          day: "day",
          hour: "hour",
          minute: "minute",
          second: "second",
          dayPeriod: "AM/PM",
          calendar: "Calendar",
          startDate: "Start Date",
          endDate: "End Date",
          weekday: "day of the week",
          timeZoneName: "time zone",
          selectedDateDescription: e => `Selected Date: ${e.date}`,
          selectedRangeDescription: e => `Selected Range: ${e.startDate} to ${e.endDate}`,
          selectedTimeDescription: e => `Selected Time: ${e.time}`
        };
        var br;
        br = {
          calendar: "Calendario",
          day: "día",
          dayPeriod: "a. m./p. m.",
          endDate: "Fecha final",
          era: "era",
          hour: "hora",
          minute: "minuto",
          month: "mes",
          second: "segundo",
          selectedDateDescription: e => `Fecha seleccionada: ${e.date}`,
          selectedRangeDescription: e => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
          selectedTimeDescription: e => `Hora seleccionada: ${e.time}`,
          startDate: "Fecha de inicio",
          timeZoneName: "zona horaria",
          weekday: "día de la semana",
          year: "año"
        };
        var wr;
        wr = {
          calendar: "Kalender",
          day: "päev",
          dayPeriod: "enne/pärast lõunat",
          endDate: "Lõppkuupäev",
          era: "ajastu",
          hour: "tund",
          minute: "minut",
          month: "kuu",
          second: "sekund",
          selectedDateDescription: e => `Valitud kuupäev: ${e.date}`,
          selectedRangeDescription: e => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
          selectedTimeDescription: e => `Valitud aeg: ${e.time}`,
          startDate: "Alguskuupäev",
          timeZoneName: "ajavöönd",
          weekday: "nädalapäev",
          year: "aasta"
        };
        var xr;
        xr = {
          calendar: "Kalenteri",
          day: "päivä",
          dayPeriod: "vuorokaudenaika",
          endDate: "Päättymispäivä",
          era: "aikakausi",
          hour: "tunti",
          minute: "minuutti",
          month: "kuukausi",
          second: "sekunti",
          selectedDateDescription: e => `Valittu päivämäärä: ${e.date}`,
          selectedRangeDescription: e => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
          selectedTimeDescription: e => `Valittu aika: ${e.time}`,
          startDate: "Alkamispäivä",
          timeZoneName: "aikavyöhyke",
          weekday: "viikonpäivä",
          year: "vuosi"
        };
        var Dr;
        Dr = {
          calendar: "Calendrier",
          day: "jour",
          dayPeriod: "cadran",
          endDate: "Date de fin",
          era: "ère",
          hour: "heure",
          minute: "minute",
          month: "mois",
          second: "seconde",
          selectedDateDescription: e => `Date sélectionnée : ${e.date}`,
          selectedRangeDescription: e => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
          selectedTimeDescription: e => `Heure choisie : ${e.time}`,
          startDate: "Date de début",
          timeZoneName: "fuseau horaire",
          weekday: "jour de la semaine",
          year: "année"
        };
        var Cr;
        Cr = {
          calendar: "לוח שנה",
          day: "יום",
          dayPeriod: "לפנה״צ/אחה״צ",
          endDate: "תאריך סיום",
          era: "תקופה",
          hour: "שעה",
          minute: "דקה",
          month: "חודש",
          second: "שנייה",
          selectedDateDescription: e => `תאריך נבחר: ${e.date}`,
          selectedRangeDescription: e => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
          selectedTimeDescription: e => `זמן נבחר: ${e.time}`,
          startDate: "תאריך התחלה",
          timeZoneName: "אזור זמן",
          weekday: "יום בשבוע",
          year: "שנה"
        };
        var Sr;
        Sr = {
          calendar: "Kalendar",
          day: "dan",
          dayPeriod: "AM/PM",
          endDate: "Datum završetka",
          era: "era",
          hour: "sat",
          minute: "minuta",
          month: "mjesec",
          second: "sekunda",
          selectedDateDescription: e => `Odabrani datum: ${e.date}`,
          selectedRangeDescription: e => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
          selectedTimeDescription: e => `Odabrano vrijeme: ${e.time}`,
          startDate: "Datum početka",
          timeZoneName: "vremenska zona",
          weekday: "dan u tjednu",
          year: "godina"
        };
        var Er;
        Er = {
          calendar: "Naptár",
          day: "nap",
          dayPeriod: "napszak",
          endDate: "Befejező dátum",
          era: "éra",
          hour: "óra",
          minute: "perc",
          month: "hónap",
          second: "másodperc",
          selectedDateDescription: e => `Kijelölt dátum: ${e.date}`,
          selectedRangeDescription: e => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
          selectedTimeDescription: e => `Kijelölt idő: ${e.time}`,
          startDate: "Kezdő dátum",
          timeZoneName: "időzóna",
          weekday: "hét napja",
          year: "év"
        };
        var _r;
        _r = {
          calendar: "Calendario",
          day: "giorno",
          dayPeriod: "AM/PM",
          endDate: "Data finale",
          era: "era",
          hour: "ora",
          minute: "minuto",
          month: "mese",
          second: "secondo",
          selectedDateDescription: e => `Data selezionata: ${e.date}`,
          selectedRangeDescription: e => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
          selectedTimeDescription: e => `Ora selezionata: ${e.time}`,
          startDate: "Data iniziale",
          timeZoneName: "fuso orario",
          weekday: "giorno della settimana",
          year: "anno"
        };
        var Pr;
        Pr = {
          calendar: "カレンダー",
          day: "日",
          dayPeriod: "午前/午後",
          endDate: "終了日",
          era: "時代",
          hour: "時",
          minute: "分",
          month: "月",
          second: "秒",
          selectedDateDescription: e => `選択した日付 : ${e.date}`,
          selectedRangeDescription: e => `選択範囲 : ${e.startDate} から ${e.endDate}`,
          selectedTimeDescription: e => `選択した時間 : ${e.time}`,
          startDate: "開始日",
          timeZoneName: "タイムゾーン",
          weekday: "曜日",
          year: "年"
        };
        var kr;
        kr = {
          calendar: "달력",
          day: "일",
          dayPeriod: "오전/오후",
          endDate: "종료일",
          era: "연호",
          hour: "시",
          minute: "분",
          month: "월",
          second: "초",
          selectedDateDescription: e => `선택 일자: ${e.date}`,
          selectedRangeDescription: e => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
          selectedTimeDescription: e => `선택 시간: ${e.time}`,
          startDate: "시작일",
          timeZoneName: "시간대",
          weekday: "요일",
          year: "년"
        };
        var Ar;
        Ar = {
          calendar: "Kalendorius",
          day: "diena",
          dayPeriod: "iki pietų / po pietų",
          endDate: "Pabaigos data",
          era: "era",
          hour: "valanda",
          minute: "minutė",
          month: "mėnuo",
          second: "sekundė",
          selectedDateDescription: e => `Pasirinkta data: ${e.date}`,
          selectedRangeDescription: e => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
          selectedTimeDescription: e => `Pasirinktas laikas: ${e.time}`,
          startDate: "Pradžios data",
          timeZoneName: "laiko juosta",
          weekday: "savaitės diena",
          year: "metai"
        };
        var zr;
        zr = {
          calendar: "Kalendārs",
          day: "diena",
          dayPeriod: "priekšpusdienā/pēcpusdienā",
          endDate: "Beigu datums",
          era: "ēra",
          hour: "stundas",
          minute: "minūtes",
          month: "mēnesis",
          second: "sekundes",
          selectedDateDescription: e => `Atlasītais datums: ${e.date}`,
          selectedRangeDescription: e => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
          selectedTimeDescription: e => `Atlasītais laiks: ${e.time}`,
          startDate: "Sākuma datums",
          timeZoneName: "laika josla",
          weekday: "nedēļas diena",
          year: "gads"
        };
        var Tr;
        Tr = {
          calendar: "Kalender",
          day: "dag",
          dayPeriod: "a.m./p.m.",
          endDate: "Sluttdato",
          era: "tidsalder",
          hour: "time",
          minute: "minutt",
          month: "måned",
          second: "sekund",
          selectedDateDescription: e => `Valgt dato: ${e.date}`,
          selectedRangeDescription: e => `Valgt område: ${e.startDate} til ${e.endDate}`,
          selectedTimeDescription: e => `Valgt tid: ${e.time}`,
          startDate: "Startdato",
          timeZoneName: "tidssone",
          weekday: "ukedag",
          year: "år"
        };
        var Or;
        Or = {
          calendar: "Kalender",
          day: "dag",
          dayPeriod: "a.m./p.m.",
          endDate: "Einddatum",
          era: "tijdperk",
          hour: "uur",
          minute: "minuut",
          month: "maand",
          second: "seconde",
          selectedDateDescription: e => `Geselecteerde datum: ${e.date}`,
          selectedRangeDescription: e => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
          selectedTimeDescription: e => `Geselecteerde tijd: ${e.time}`,
          startDate: "Startdatum",
          timeZoneName: "tijdzone",
          weekday: "dag van de week",
          year: "jaar"
        };
        var Ir;
        Ir = {
          calendar: "Kalendarz",
          day: "dzień",
          dayPeriod: "rano / po południu / wieczorem",
          endDate: "Data końcowa",
          era: "era",
          hour: "godzina",
          minute: "minuta",
          month: "miesiąc",
          second: "sekunda",
          selectedDateDescription: e => `Wybrana data: ${e.date}`,
          selectedRangeDescription: e => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
          selectedTimeDescription: e => `Wybrany czas: ${e.time}`,
          startDate: "Data początkowa",
          timeZoneName: "strefa czasowa",
          weekday: "dzień tygodnia",
          year: "rok"
        };
        var Fr;
        Fr = {
          calendar: "Calendário",
          day: "dia",
          dayPeriod: "AM/PM",
          endDate: "Data final",
          era: "era",
          hour: "hora",
          minute: "minuto",
          month: "mês",
          second: "segundo",
          selectedDateDescription: e => `Data selecionada: ${e.date}`,
          selectedRangeDescription: e => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
          selectedTimeDescription: e => `Hora selecionada: ${e.time}`,
          startDate: "Data inicial",
          timeZoneName: "fuso horário",
          weekday: "dia da semana",
          year: "ano"
        };
        var Mr;
        Mr = {
          calendar: "Calendário",
          day: "dia",
          dayPeriod: "am/pm",
          endDate: "Data de Término",
          era: "era",
          hour: "hora",
          minute: "minuto",
          month: "mês",
          second: "segundo",
          selectedDateDescription: e => `Data selecionada: ${e.date}`,
          selectedRangeDescription: e => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
          selectedTimeDescription: e => `Hora selecionada: ${e.time}`,
          startDate: "Data de Início",
          timeZoneName: "fuso horário",
          weekday: "dia da semana",
          year: "ano"
        };
        var Rr;
        Rr = {
          calendar: "Calendar",
          day: "zi",
          dayPeriod: "a.m/p.m.",
          endDate: "Dată final",
          era: "eră",
          hour: "oră",
          minute: "minut",
          month: "lună",
          second: "secundă",
          selectedDateDescription: e => `Dată selectată: ${e.date}`,
          selectedRangeDescription: e => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
          selectedTimeDescription: e => `Ora selectată: ${e.time}`,
          startDate: "Dată început",
          timeZoneName: "fus orar",
          weekday: "ziua din săptămână",
          year: "an"
        };
        var jr;
        jr = {
          calendar: "Календарь",
          day: "день",
          dayPeriod: "AM/PM",
          endDate: "Дата окончания",
          era: "эра",
          hour: "час",
          minute: "минута",
          month: "месяц",
          second: "секунда",
          selectedDateDescription: e => `Выбранная дата: ${e.date}`,
          selectedRangeDescription: e => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
          selectedTimeDescription: e => `Выбранное время: ${e.time}`,
          startDate: "Дата начала",
          timeZoneName: "часовой пояс",
          weekday: "день недели",
          year: "год"
        };
        var Br;
        Br = {
          calendar: "Kalendár",
          day: "deň",
          dayPeriod: "AM/PM",
          endDate: "Dátum ukončenia",
          era: "letopočet",
          hour: "hodina",
          minute: "minúta",
          month: "mesiac",
          second: "sekunda",
          selectedDateDescription: e => `Vybratý dátum: ${e.date}`,
          selectedRangeDescription: e => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
          selectedTimeDescription: e => `Vybratý čas: ${e.time}`,
          startDate: "Dátum začatia",
          timeZoneName: "časové pásmo",
          weekday: "deň týždňa",
          year: "rok"
        };
        var Nr;
        Nr = {
          calendar: "Koledar",
          day: "dan",
          dayPeriod: "dop/pop",
          endDate: "Datum konca",
          era: "doba",
          hour: "ura",
          minute: "minuta",
          month: "mesec",
          second: "sekunda",
          selectedDateDescription: e => `Izbrani datum: ${e.date}`,
          selectedRangeDescription: e => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
          selectedTimeDescription: e => `Izbrani čas: ${e.time}`,
          startDate: "Datum začetka",
          timeZoneName: "časovni pas",
          weekday: "dan v tednu",
          year: "leto"
        };
        var Lr;
        Lr = {
          calendar: "Kalendar",
          day: "дан",
          dayPeriod: "пре подне/по подне",
          endDate: "Datum završetka",
          era: "ера",
          hour: "сат",
          minute: "минут",
          month: "месец",
          second: "секунд",
          selectedDateDescription: e => `Izabrani datum: ${e.date}`,
          selectedRangeDescription: e => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
          selectedTimeDescription: e => `Izabrano vreme: ${e.time}`,
          startDate: "Datum početka",
          timeZoneName: "временска зона",
          weekday: "дан у недељи",
          year: "година"
        };
        var Vr;
        Vr = {
          calendar: "Kalender",
          day: "dag",
          dayPeriod: "fm/em",
          endDate: "Slutdatum",
          era: "era",
          hour: "timme",
          minute: "minut",
          month: "månad",
          second: "sekund",
          selectedDateDescription: e => `Valt datum: ${e.date}`,
          selectedRangeDescription: e => `Valt intervall: ${e.startDate} till ${e.endDate}`,
          selectedTimeDescription: e => `Vald tid: ${e.time}`,
          startDate: "Startdatum",
          timeZoneName: "tidszon",
          weekday: "veckodag",
          year: "år"
        };
        var Kr;
        Kr = {
          calendar: "Takvim",
          day: "gün",
          dayPeriod: "ÖÖ/ÖS",
          endDate: "Bitiş Tarihi",
          era: "çağ",
          hour: "saat",
          minute: "dakika",
          month: "ay",
          second: "saniye",
          selectedDateDescription: e => `Seçilen Tarih: ${e.date}`,
          selectedRangeDescription: e => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
          selectedTimeDescription: e => `Seçilen Zaman: ${e.time}`,
          startDate: "Başlangıç Tarihi",
          timeZoneName: "saat dilimi",
          weekday: "haftanın günü",
          year: "yıl"
        };
        var qr;
        qr = {
          calendar: "Календар",
          day: "день",
          dayPeriod: "дп/пп",
          endDate: "Дата завершення",
          era: "ера",
          hour: "година",
          minute: "хвилина",
          month: "місяць",
          second: "секунда",
          selectedDateDescription: e => `Вибрана дата: ${e.date}`,
          selectedRangeDescription: e => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
          selectedTimeDescription: e => `Вибраний час: ${e.time}`,
          startDate: "Дата початку",
          timeZoneName: "часовий пояс",
          weekday: "день тижня",
          year: "рік"
        };
        var Hr;
        Hr = {
          calendar: "日历",
          day: "日",
          dayPeriod: "上午/下午",
          endDate: "结束日期",
          era: "纪元",
          hour: "小时",
          minute: "分钟",
          month: "月",
          second: "秒",
          selectedDateDescription: e => `选定的日期：${e.date}`,
          selectedRangeDescription: e => `选定的范围：${e.startDate} 至 ${e.endDate}`,
          selectedTimeDescription: e => `选定的时间：${e.time}`,
          startDate: "开始日期",
          timeZoneName: "时区",
          weekday: "工作日",
          year: "年"
        };
        var Ur;
        Ur = {
          calendar: "日曆",
          day: "日",
          dayPeriod: "上午/下午",
          endDate: "結束日期",
          era: "纪元",
          hour: "小时",
          minute: "分钟",
          month: "月",
          second: "秒",
          selectedDateDescription: e => `選定的日期：${e.date}`,
          selectedRangeDescription: e => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
          selectedTimeDescription: e => `選定的時間：${e.time}`,
          startDate: "開始日期",
          timeZoneName: "时区",
          weekday: "工作日",
          year: "年"
        };
        n(96041);
        var Zr = n(59292);
        new WeakMap(), Date.now(), Date.now();
        function $r(e, t) {
          let {
              role: n = "dialog"
            } = e,
            r = (0, j.mp)();
          r = e["aria-label"] ? void 0 : r;
          let o = (0, Ee.useRef)(!1);
          return (0, Ee.useEffect)(() => {
            if (t.current && !t.current.contains(document.activeElement)) {
              (0, B.ex)(t.current);
              let e = setTimeout(() => {
                document.activeElement === t.current && (o.current = !0, t.current && (t.current.blur(), (0, B.ex)(t.current)), o.current = !1);
              }, 500);
              return () => {
                clearTimeout(e);
              };
            }
          }, [t]), Bn(), {
            dialogProps: {
              ...(0, j.zL)(e, {
                labelable: !0
              }),
              role: n,
              tabIndex: -1,
              "aria-labelledby": e["aria-labelledby"] || r,
              onBlur: e => {
                o.current && e.stopPropagation();
              }
            },
            titleProps: {
              id: r
            }
          };
        }
        var Gr;
        Gr = {
          dragDescriptionKeyboard: "اضغط Enter لبدء السحب.",
          dragDescriptionKeyboardAlt: "اضغط على Alt + Enter لبدء السحب.",
          dragDescriptionLongPress: "اضغط باستمرار لبدء السحب.",
          dragDescriptionTouch: "اضغط مرتين لبدء السحب.",
          dragDescriptionVirtual: "انقر لبدء السحب.",
          dragItem: e => `اسحب ${e.itemText}`,
          dragSelectedItems: (e, t) => `اسحب ${t.plural(e.count, {
            one: () => `${t.number(e.count)} عنصر محدد`,
            other: () => `${t.number(e.count)} عناصر محددة`
          })}`,
          dragSelectedKeyboard: (e, t) => `اضغط على Enter للسحب ${t.plural(e.count, {
            one: "عدد العناصر المختارة",
            other: "عدد العناصر المختارة"
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `اضغط على مفتاحي Alt + Enter للسحب ${t.plural(e.count, {
            one: "عدد العناصر المختارة",
            other: "عدد العناصر المختارة"
          })}.`,
          dragSelectedLongPress: (e, t) => `اضغط باستمرار للسحب ${t.plural(e.count, {
            one: "عدد العناصر المختارة",
            other: "عدد العناصر المختارة"
          })}.`,
          dragStartedKeyboard: "بدأ السحب. اضغط Tab للانتقال إلى موضع الإفلات، ثم اضغط Enter للإفلات، أو اضغط Escape للإلغاء.",
          dragStartedTouch: "بدأ السحب. انتقل إلى موضع الإفلات، ثم اضغط مرتين للإفلات.",
          dragStartedVirtual: "بدأ السحب. انتقل إلى مكان الإفلات، ثم انقر أو اضغط Enter للإفلات.",
          dropCanceled: "تم إلغاء الإفلات.",
          dropComplete: "اكتمل الإفلات.",
          dropDescriptionKeyboard: "اضغط Enter للإفلات. اضغط Escape لإلغاء السحب.",
          dropDescriptionTouch: "اضغط مرتين للإفلات.",
          dropDescriptionVirtual: "انقر للإفلات.",
          dropIndicator: "مؤشر الإفلات",
          dropOnItem: e => `إفلات ${e.itemText}`,
          dropOnRoot: "الإفلات",
          endDragKeyboard: "السحب. اضغط Enter لإلغاء السحب.",
          endDragTouch: "السحب. اضغط مرتين لإلغاء السحب.",
          endDragVirtual: "السحب. انقر لإلغاء السحب.",
          insertAfter: e => `أدخل بعد ${e.itemText}`,
          insertBefore: e => `أدخل قبل ${e.itemText}`,
          insertBetween: e => `أدخل بين ${e.beforeItemText} و ${e.afterItemText}`
        };
        var Wr;
        Wr = {
          dragDescriptionKeyboard: "Натиснете „Enter“, за да започнете да плъзгате.",
          dragDescriptionKeyboardAlt: "Натиснете Alt + Enter, за да започнете да плъзгате.",
          dragDescriptionLongPress: "Натиснете продължително, за да започнете да плъзгате.",
          dragDescriptionTouch: "Натиснете двукратно, за да започнете да плъзгате.",
          dragDescriptionVirtual: "Щракнете, за да започнете да плъзгате.",
          dragItem: e => `Плъзни ${e.itemText}`,
          dragSelectedItems: (e, t) => `Плъзни ${t.plural(e.count, {
            one: () => `${t.number(e.count)} избран елемент`,
            other: () => `${t.number(e.count)} избрани елемента`
          })}`,
          dragSelectedKeyboard: (e, t) => `Натиснете Enter, за да плъзнете ${t.plural(e.count, {
            one: () => `${t.number(e.count)} избран елемент`,
            other: () => `${t.number(e.count)} избрани елементи`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Натиснете Alt и Enter, за да плъзнете ${t.plural(e.count, {
            one: () => `${t.number(e.count)} избран елемент`,
            other: () => `${t.number(e.count)} избрани елементи`
          })}.`,
          dragSelectedLongPress: (e, t) => `Натиснете продължително, за да плъзнете ${t.plural(e.count, {
            one: () => `${t.number(e.count)} избран елемент`,
            other: () => `${t.number(e.count)} избрани елементи`
          })}.`,
          dragStartedKeyboard: "Започна плъзгане. Натиснете „Tab“, за да се придвижите до целта, след което натиснете „Enter“ за пускане или натиснете „Escape“ за отмяна.",
          dragStartedTouch: "Започна плъзгане. Придвижете се до целта, след което натиснете двукратно, за да пуснете.",
          dragStartedVirtual: "Започна плъзгане. Придвижете се до целта, след което щракнете или натиснете „Enter“ за пускане.",
          dropCanceled: "Пускането е отменено.",
          dropComplete: "Пускането е завършено.",
          dropDescriptionKeyboard: "Натиснете „Enter“ за пускане. Натиснете „Escape“ за отмяна на плъзгането.",
          dropDescriptionTouch: "Натиснете двукратно за пускане.",
          dropDescriptionVirtual: "Щракнете за пускане.",
          dropIndicator: "индикатор за пускане",
          dropOnItem: e => `Пусни върху ${e.itemText}`,
          dropOnRoot: "Пусни върху",
          endDragKeyboard: "Плъзгане. Натиснете „Enter“ за отмяна на плъзгането.",
          endDragTouch: "Плъзгане. Натиснете двукратно за отмяна на плъзгането.",
          endDragVirtual: "Плъзгане. Щракнете за отмяна.",
          insertAfter: e => `Вмъкни след ${e.itemText}`,
          insertBefore: e => `Вмъкни преди ${e.itemText}`,
          insertBetween: e => `Вмъкни между ${e.beforeItemText} и ${e.afterItemText}`
        };
        var Yr;
        Yr = {
          dragDescriptionKeyboard: "Stisknutím klávesy Enter začnete s přetahováním.",
          dragDescriptionKeyboardAlt: "Stisknutím Alt + Enter zahájíte přetahování.",
          dragDescriptionLongPress: "Dlouhým stisknutím zahájíte přetahování.",
          dragDescriptionTouch: "Poklepáním začnete s přetahováním.",
          dragDescriptionVirtual: "Kliknutím začnete s přetahováním.",
          dragItem: e => `Přetáhnout ${e.itemText}`,
          dragSelectedItems: (e, t) => `Přetáhnout ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybranou položku`,
            few: () => `${t.number(e.count)} vybrané položky`,
            other: () => `${t.number(e.count)} vybraných položek`
          })}`,
          dragSelectedKeyboard: (e, t) => `Stisknutím klávesy Enter přetáhněte ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybranou položku`,
            other: () => `${t.number(e.count)} vybrané položky`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Stisknutím Alt + Enter přetáhněte ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybranou položku`,
            other: () => `${t.number(e.count)} vybrané položky`
          })}.`,
          dragSelectedLongPress: (e, t) => `Dlouhým stisknutím přetáhnete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybranou položku`,
            other: () => `${t.number(e.count)} vybrané položky`
          })}.`,
          dragStartedKeyboard: "Začněte s přetahováním. Po stisknutí klávesy Tab najděte požadovaný cíl a stisknutím klávesy Enter přetažení dokončete nebo stisknutím klávesy Esc akci zrušte.",
          dragStartedTouch: "Začněte s přetahováním. Najděte požadovaný cíl a poklepáním přetažení dokončete.",
          dragStartedVirtual: "Začněte s přetahováním. Najděte požadovaný cíl a kliknutím nebo stisknutím klávesy Enter přetažení dokončete.",
          dropCanceled: "Přetažení bylo zrušeno.",
          dropComplete: "Přetažení bylo dokončeno.",
          dropDescriptionKeyboard: "Stisknutím klávesy Enter přetažení dokončete nebo stisknutím klávesy Esc akci zrušte.",
          dropDescriptionTouch: "Poklepáním přetažení dokončete.",
          dropDescriptionVirtual: "Kliknutím objekt přetáhněte.",
          dropIndicator: "indikátor přetažení",
          dropOnItem: e => `Přetáhnout na ${e.itemText}`,
          dropOnRoot: "Přetáhnout na",
          endDragKeyboard: "Probíhá přetahování. Stisknutím klávesy Enter přetažení zrušíte.",
          endDragTouch: "Probíhá přetahování. Poklepáním přetažení zrušíte.",
          endDragVirtual: "Probíhá přetahování. Kliknutím přetažení zrušíte.",
          insertAfter: e => `Vložit za ${e.itemText}`,
          insertBefore: e => `Vložit před ${e.itemText}`,
          insertBetween: e => `Vložit mezi ${e.beforeItemText} a ${e.afterItemText}`
        };
        var Xr;
        Xr = {
          dragDescriptionKeyboard: "Tryk på Enter for at starte med at trække.",
          dragDescriptionKeyboardAlt: "Tryk på Alt + Enter for at starte med at trække.",
          dragDescriptionLongPress: "Tryk længe for at starte med at trække.",
          dragDescriptionTouch: "Dobbelttryk for at starte med at trække.",
          dragDescriptionVirtual: "Klik for at starte med at trække.",
          dragItem: e => `Træk ${e.itemText}`,
          dragSelectedItems: (e, t) => `Træk ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgt element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}`,
          dragSelectedKeyboard: (e, t) => `Tryk på Enter for at trække ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgte element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Tryk på Alt + Enter for at trække ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgte element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragSelectedLongPress: (e, t) => `Tryk længe for at trække ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgte element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragStartedKeyboard: "Startet med at trække. Tryk på Tab for at gå til et slip-mål, tryk derefter på Enter for at slippe, eller tryk på Escape for at annullere.",
          dragStartedTouch: "Startet med at trække. Gå til et slip-mål, og dobbelttryk derefter for at slippe.",
          dragStartedVirtual: "Startet med at trække. Gå til et slip-mål, og klik eller tryk derefter på enter for at slippe.",
          dropCanceled: "Slip annulleret.",
          dropComplete: "Slip fuldført.",
          dropDescriptionKeyboard: "Tryk på Enter for at slippe. Tryk på Escape for at annullere trækning.",
          dropDescriptionTouch: "Dobbelttryk for at slippe.",
          dropDescriptionVirtual: "Klik for at slippe.",
          dropIndicator: "slip-indikator",
          dropOnItem: e => `Slip på ${e.itemText}`,
          dropOnRoot: "Slip på",
          endDragKeyboard: "Trækning. Tryk på enter for at annullere træk.",
          endDragTouch: "Trækning. Dobbelttryk for at annullere træk.",
          endDragVirtual: "Trækning. Klik for at annullere trækning.",
          insertAfter: e => `Indsæt efter ${e.itemText}`,
          insertBefore: e => `Indsæt før ${e.itemText}`,
          insertBetween: e => `Indsæt mellem ${e.beforeItemText} og ${e.afterItemText}`
        };
        var Qr;
        Qr = {
          dragDescriptionKeyboard: "Drücken Sie die Eingabetaste, um den Ziehvorgang zu starten.",
          dragDescriptionKeyboardAlt: "Alt + Eingabe drücken, um den Ziehvorgang zu starten.",
          dragDescriptionLongPress: "Lang drücken, um mit dem Ziehen zu beginnen.",
          dragDescriptionTouch: "Tippen Sie doppelt, um den Ziehvorgang zu starten.",
          dragDescriptionVirtual: "Zum Starten des Ziehvorgangs klicken.",
          dragItem: e => `${e.itemText} ziehen`,
          dragSelectedItems: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} ausgewähltes Objekt`,
            other: () => `${t.number(e.count)} ausgewählte Objekte`
          })} ziehen`,
          dragSelectedKeyboard: (e, t) => `Eingabetaste drücken, um ${t.plural(e.count, {
            one: () => `${t.number(e.count)} ausgewähltes Element`,
            other: () => `${t.number(e.count)} ausgewählte Elemente`
          })} zu ziehen.`,
          dragSelectedKeyboardAlt: (e, t) => `Alt + Eingabetaste drücken, um ${t.plural(e.count, {
            one: () => `${t.number(e.count)} ausgewähltes Element`,
            other: () => `${t.number(e.count)} ausgewählte Elemente`
          })} zu ziehen.`,
          dragSelectedLongPress: (e, t) => `Lang drücken, um ${t.plural(e.count, {
            one: () => `${t.number(e.count)} ausgewähltes Element`,
            other: () => `${t.number(e.count)} ausgewählte Elemente`
          })} zu ziehen.`,
          dragStartedKeyboard: "Ziehvorgang gestartet. Drücken Sie die Tabulatortaste, um zu einem Ablegeziel zu navigieren und drücken Sie dann die Eingabetaste, um das Objekt abzulegen, oder Escape, um den Vorgang abzubrechen.",
          dragStartedTouch: "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und tippen Sie doppelt, um das Objekt abzulegen.",
          dragStartedVirtual: "Ziehvorgang gestartet. Navigieren Sie zu einem Ablegeziel und klicken Sie oder drücken Sie die Eingabetaste, um das Objekt abzulegen.",
          dropCanceled: "Ablegen abgebrochen.",
          dropComplete: "Ablegen abgeschlossen.",
          dropDescriptionKeyboard: "Drücken Sie die Eingabetaste, um das Objekt abzulegen. Drücken Sie Escape, um den Vorgang abzubrechen.",
          dropDescriptionTouch: "Tippen Sie doppelt, um das Objekt abzulegen.",
          dropDescriptionVirtual: "Zum Ablegen klicken.",
          dropIndicator: "Ablegeanzeiger",
          dropOnItem: e => `Auf ${e.itemText} ablegen`,
          dropOnRoot: "Ablegen auf",
          endDragKeyboard: "Ziehvorgang läuft. Drücken Sie die Eingabetaste, um den Vorgang abzubrechen.",
          endDragTouch: "Ziehvorgang läuft. Tippen Sie doppelt, um den Vorgang abzubrechen.",
          endDragVirtual: "Ziehvorgang läuft. Klicken Sie, um den Vorgang abzubrechen.",
          insertAfter: e => `Nach ${e.itemText} einfügen`,
          insertBefore: e => `Vor ${e.itemText} einfügen`,
          insertBetween: e => `Zwischen ${e.beforeItemText} und ${e.afterItemText} einfügen`
        };
        var Jr;
        Jr = {
          dragDescriptionKeyboard: "Πατήστε Enter για έναρξη της μεταφοράς.",
          dragDescriptionKeyboardAlt: "Πατήστε Alt + Enter για έναρξη της μεταφοράς.",
          dragDescriptionLongPress: "Πατήστε παρατεταμένα για να ξεκινήσετε τη μεταφορά.",
          dragDescriptionTouch: "Πατήστε δύο φορές για έναρξη της μεταφοράς.",
          dragDescriptionVirtual: "Κάντε κλικ για να ξεκινήσετε τη μεταφορά.",
          dragItem: e => `Μεταφορά ${e.itemText}`,
          dragSelectedItems: (e, t) => `Μεταφορά σε ${t.plural(e.count, {
            one: () => `${t.number(e.count)} επιλεγμένο στοιχείο`,
            other: () => `${t.number(e.count)} επιλεγμένα στοιχεία`
          })}`,
          dragSelectedKeyboard: (e, t) => `Πατήστε Enter για να σύρετε ${t.plural(e.count, {
            one: () => `${t.number(e.count)} επιλεγμένο στοιχείο`,
            other: () => `${t.number(e.count)} επιλεγμένα στοιχεία`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Πατήστε Alt + Enter για να σύρετε ${t.plural(e.count, {
            one: () => `${t.number(e.count)} επιλεγμένο στοιχείο`,
            other: () => `${t.number(e.count)} επιλεγμένα στοιχεία`
          })}.`,
          dragSelectedLongPress: (e, t) => `Πατήστε παρατεταμένα για να σύρετε ${t.plural(e.count, {
            one: () => `${t.number(e.count)} επιλεγμένο στοιχείο`,
            other: () => `${t.number(e.count)} επιλεγμένα στοιχεία`
          })}.`,
          dragStartedKeyboard: "Η μεταφορά ξεκίνησε. Πατήστε το πλήκτρο Tab για να μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, πατήστε Enter για απόθεση ή πατήστε Escape για ακύρωση.",
          dragStartedTouch: "Η μεταφορά ξεκίνησε. Μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, πατήστε δύο φορές για απόθεση.",
          dragStartedVirtual: "Η μεταφορά ξεκίνησε. Μεταβείτε σε έναν προορισμό απόθεσης και, στη συνέχεια, κάντε κλικ ή πατήστε Enter για απόθεση.",
          dropCanceled: "Η απόθεση ακυρώθηκε.",
          dropComplete: "Η απόθεση ολοκληρώθηκε.",
          dropDescriptionKeyboard: "Πατήστε Enter για απόθεση. Πατήστε Escape για ακύρωση της μεταφοράς.",
          dropDescriptionTouch: "Πατήστε δύο φορές για απόθεση.",
          dropDescriptionVirtual: "Κάντε κλικ για απόθεση.",
          dropIndicator: "δείκτης απόθεσης",
          dropOnItem: e => `Απόθεση σε ${e.itemText}`,
          dropOnRoot: "Απόθεση σε",
          endDragKeyboard: "Μεταφορά σε εξέλιξη. Πατήστε Enter για ακύρωση της μεταφοράς.",
          endDragTouch: "Μεταφορά σε εξέλιξη. Πατήστε δύο φορές για ακύρωση της μεταφοράς.",
          endDragVirtual: "Μεταφορά σε εξέλιξη. Κάντε κλικ για ακύρωση της μεταφοράς.",
          insertAfter: e => `Εισαγωγή μετά από ${e.itemText}`,
          insertBefore: e => `Εισαγωγή πριν από ${e.itemText}`,
          insertBetween: e => `Εισαγωγή μεταξύ ${e.beforeItemText} και ${e.afterItemText}`
        };
        var eo;
        eo = {
          dragItem: e => `Drag ${e.itemText}`,
          dragSelectedItems: (e, t) => `Drag ${t.plural(e.count, {
            one: () => `${t.number(e.count)} selected item`,
            other: () => `${t.number(e.count)} selected items`
          })}`,
          dragDescriptionKeyboard: "Press Enter to start dragging.",
          dragDescriptionKeyboardAlt: "Press Alt + Enter to start dragging.",
          dragDescriptionTouch: "Double tap to start dragging.",
          dragDescriptionVirtual: "Click to start dragging.",
          dragDescriptionLongPress: "Long press to start dragging.",
          dragSelectedKeyboard: (e, t) => `Press Enter to drag ${t.plural(e.count, {
            one: () => `${t.number(e.count)} selected item`,
            other: () => `${t.number(e.count)} selected items`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Press Alt + Enter to drag ${t.plural(e.count, {
            one: () => `${t.number(e.count)} selected item`,
            other: () => `${t.number(e.count)} selected items`
          })}.`,
          dragSelectedLongPress: (e, t) => `Long press to drag ${t.plural(e.count, {
            one: () => `${t.number(e.count)} selected item`,
            other: () => `${t.number(e.count)} selected items`
          })}.`,
          dragStartedKeyboard: "Started dragging. Press Tab to navigate to a drop target, then press Enter to drop, or press Escape to cancel.",
          dragStartedTouch: "Started dragging. Navigate to a drop target, then double tap to drop.",
          dragStartedVirtual: "Started dragging. Navigate to a drop target, then click or press Enter to drop.",
          endDragKeyboard: "Dragging. Press Enter to cancel drag.",
          endDragTouch: "Dragging. Double tap to cancel drag.",
          endDragVirtual: "Dragging. Click to cancel drag.",
          dropDescriptionKeyboard: "Press Enter to drop. Press Escape to cancel drag.",
          dropDescriptionTouch: "Double tap to drop.",
          dropDescriptionVirtual: "Click to drop.",
          dropCanceled: "Drop canceled.",
          dropComplete: "Drop complete.",
          dropIndicator: "drop indicator",
          dropOnRoot: "Drop on",
          dropOnItem: e => `Drop on ${e.itemText}`,
          insertBefore: e => `Insert before ${e.itemText}`,
          insertBetween: e => `Insert between ${e.beforeItemText} and ${e.afterItemText}`,
          insertAfter: e => `Insert after ${e.itemText}`
        };
        var to;
        to = {
          dragDescriptionKeyboard: "Pulse Intro para empezar a arrastrar.",
          dragDescriptionKeyboardAlt: "Pulse Intro para empezar a arrastrar.",
          dragDescriptionLongPress: "Mantenga pulsado para comenzar a arrastrar.",
          dragDescriptionTouch: "Pulse dos veces para iniciar el arrastre.",
          dragDescriptionVirtual: "Haga clic para iniciar el arrastre.",
          dragItem: e => `Arrastrar ${e.itemText}`,
          dragSelectedItems: (e, t) => `Arrastrar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento seleccionado`,
            other: () => `${t.number(e.count)} elementos seleccionados`
          })}`,
          dragSelectedKeyboard: (e, t) => `Pulse Intro para arrastrar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento seleccionado`,
            other: () => `${t.number(e.count)} elementos seleccionados`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Pulse Alt + Intro para arrastrar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento seleccionado`,
            other: () => `${t.number(e.count)} elementos seleccionados`
          })}.`,
          dragSelectedLongPress: (e, t) => `Mantenga pulsado para arrastrar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento seleccionado`,
            other: () => `${t.number(e.count)} elementos seleccionados`
          })}.`,
          dragStartedKeyboard: "Se ha empezado a arrastrar. Pulse el tabulador para ir al público destinatario donde se vaya a colocar y, a continuación, pulse Intro para soltar, o pulse Escape para cancelar.",
          dragStartedTouch: "Se ha empezado a arrastrar. Vaya al público destinatario donde se vaya a colocar y, a continuación, pulse dos veces para soltar.",
          dragStartedVirtual: "Se ha empezado a arrastrar. Vaya al público destinatario donde se vaya a colocar y, a continuación, haga clic o pulse Intro para soltar.",
          dropCanceled: "Se ha cancelado la colocación.",
          dropComplete: "Colocación finalizada.",
          dropDescriptionKeyboard: "Pulse Intro para soltar. Pulse Escape para cancelar el arrastre.",
          dropDescriptionTouch: "Pulse dos veces para soltar.",
          dropDescriptionVirtual: "Haga clic para soltar.",
          dropIndicator: "indicador de colocación",
          dropOnItem: e => `Soltar en ${e.itemText}`,
          dropOnRoot: "Soltar en",
          endDragKeyboard: "Arrastrando. Pulse Intro para cancelar el arrastre.",
          endDragTouch: "Arrastrando. Pulse dos veces para cancelar el arrastre.",
          endDragVirtual: "Arrastrando. Haga clic para cancelar el arrastre.",
          insertAfter: e => `Insertar después de ${e.itemText}`,
          insertBefore: e => `Insertar antes de ${e.itemText}`,
          insertBetween: e => `Insertar entre ${e.beforeItemText} y ${e.afterItemText}`
        };
        var no;
        no = {
          dragDescriptionKeyboard: "Lohistamise alustamiseks vajutage klahvi Enter.",
          dragDescriptionKeyboardAlt: "Lohistamise alustamiseks vajutage klahvikombinatsiooni Alt + Enter.",
          dragDescriptionLongPress: "Vajutage pikalt lohistamise alustamiseks.",
          dragDescriptionTouch: "Topeltpuudutage lohistamise alustamiseks.",
          dragDescriptionVirtual: "Klõpsake lohistamise alustamiseks.",
          dragItem: e => `Lohista ${e.itemText}`,
          dragSelectedItems: (e, t) => `Lohista ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valitud üksust`,
            other: () => `${t.number(e.count)} valitud üksust`
          })}`,
          dragSelectedKeyboard: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} valitud üksuse`,
            other: () => `${t.number(e.count)} valitud üksuse`
          })} lohistamiseks vajutage sisestusklahvi Enter.`,
          dragSelectedKeyboardAlt: (e, t) => `Lohistamiseks vajutage klahvikombinatsiooni Alt + Enter ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valitud üksuse`,
            other: () => `${t.number(e.count)} valitud üksuse`
          })} jaoks.`,
          dragSelectedLongPress: (e, t) => `Pikk vajutus ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valitud üksuse`,
            other: () => `${t.number(e.count)} valitud üksuse`
          })} lohistamiseks.`,
          dragStartedKeyboard: "Alustati lohistamist. Kukutamise sihtmärgi juurde navigeerimiseks vajutage klahvi Tab, seejärel vajutage kukutamiseks klahvi Enter või loobumiseks klahvi Escape.",
          dragStartedTouch: "Alustati lohistamist. Navigeerige kukutamise sihtmärgi juurde ja topeltpuudutage kukutamiseks.",
          dragStartedVirtual: "Alustati lohistamist. Navigeerige kukutamise sihtmärgi juurde ja kukutamiseks klõpsake või vajutage klahvi Enter.",
          dropCanceled: "Lohistamisest loobuti.",
          dropComplete: "Lohistamine on tehtud.",
          dropDescriptionKeyboard: "Kukutamiseks vajutage klahvi Enter. Lohistamisest loobumiseks vajutage klahvi Escape.",
          dropDescriptionTouch: "Kukutamiseks topeltpuudutage.",
          dropDescriptionVirtual: "Kukutamiseks klõpsake.",
          dropIndicator: "lohistamise indikaator",
          dropOnItem: e => `Kukuta asukohta ${e.itemText}`,
          dropOnRoot: "Kukuta asukohta",
          endDragKeyboard: "Lohistamine. Lohistamisest loobumiseks vajutage klahvi Enter.",
          endDragTouch: "Lohistamine. Lohistamisest loobumiseks topeltpuudutage.",
          endDragVirtual: "Lohistamine. Lohistamisest loobumiseks klõpsake.",
          insertAfter: e => `Sisesta ${e.itemText} järele`,
          insertBefore: e => `Sisesta ${e.itemText} ette`,
          insertBetween: e => `Sisesta ${e.beforeItemText} ja ${e.afterItemText} vahele`
        };
        var ro;
        ro = {
          dragDescriptionKeyboard: "Aloita vetäminen painamalla Enter-näppäintä.",
          dragDescriptionKeyboardAlt: "Aloita vetäminen painamalla Alt + Enter -näppäinyhdistelmää.",
          dragDescriptionLongPress: "Aloita vetäminen pitämällä painettuna.",
          dragDescriptionTouch: "Aloita vetäminen kaksoisnapauttamalla.",
          dragDescriptionVirtual: "Aloita vetäminen napsauttamalla.",
          dragItem: e => `Vedä kohdetta ${e.itemText}`,
          dragSelectedItems: (e, t) => `Vedä ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valittua kohdetta`,
            other: () => `${t.number(e.count)} valittua kohdetta`
          })}`,
          dragSelectedKeyboard: (e, t) => `Vedä painamalla Enter ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valittu kohde`,
            other: () => `${t.number(e.count)} valittua kohdetta`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Vedä painamalla Alt + Enter ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valittu kohde`,
            other: () => `${t.number(e.count)} valittua kohdetta`
          })}.`,
          dragSelectedLongPress: (e, t) => `Vedä pitämällä painettuna ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valittu kohde`,
            other: () => `${t.number(e.count)} valittua kohdetta`
          })}.`,
          dragStartedKeyboard: "Vetäminen aloitettu. Siirry pudotuskohteeseen painamalla sarkainnäppäintä ja sitten pudota painamalla Enter-näppäintä tai peruuta painamalla Escape-näppäintä.",
          dragStartedTouch: "Vetäminen aloitettu. Siirry pudotuskohteeseen ja pudota kaksoisnapauttamalla.",
          dragStartedVirtual: "Vetäminen aloitettu. Siirry pudotuskohteeseen ja pudota napsauttamalla tai painamalla Enter-näppäintä.",
          dropCanceled: "Pudotus peruutettu.",
          dropComplete: "Pudotus suoritettu.",
          dropDescriptionKeyboard: "Pudota painamalla Enter-näppäintä. Peruuta vetäminen painamalla Escape-näppäintä.",
          dropDescriptionTouch: "Pudota kaksoisnapauttamalla.",
          dropDescriptionVirtual: "Pudota napsauttamalla.",
          dropIndicator: "pudotuksen ilmaisin",
          dropOnItem: e => `Pudota kohteeseen ${e.itemText}`,
          dropOnRoot: "Pudota kohteeseen",
          endDragKeyboard: "Vedetään. Peruuta vetäminen painamalla Enter-näppäintä.",
          endDragTouch: "Vedetään. Peruuta vetäminen kaksoisnapauttamalla.",
          endDragVirtual: "Vedetään. Peruuta vetäminen napsauttamalla.",
          insertAfter: e => `Lisää kohteen ${e.itemText} jälkeen`,
          insertBefore: e => `Lisää ennen kohdetta ${e.itemText}`,
          insertBetween: e => `Lisää kohteiden ${e.beforeItemText} ja ${e.afterItemText} väliin`
        };
        var oo;
        oo = {
          dragDescriptionKeyboard: "Appuyez sur Entrée pour commencer le déplacement.",
          dragDescriptionKeyboardAlt: "Appuyez sur Alt + Entrée pour commencer à faire glisser.",
          dragDescriptionLongPress: "Appuyez de manière prolongée pour commencer à faire glisser.",
          dragDescriptionTouch: "Touchez deux fois pour commencer le déplacement.",
          dragDescriptionVirtual: "Cliquez pour commencer le déplacement.",
          dragItem: e => `Déplacer ${e.itemText}`,
          dragSelectedItems: (e, t) => `Déplacer ${t.plural(e.count, {
            one: () => `${t.number(e.count)} élément sélectionné`,
            other: () => `${t.number(e.count)} éléments sélectionnés`
          })}`,
          dragSelectedKeyboard: (e, t) => `Appuyez sur Entrée pour faire glisser ${t.plural(e.count, {
            one: () => `${t.number(e.count)} élément sélectionné`,
            other: () => `${t.number(e.count)} éléments sélectionnés`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Appuyez sur Alt + Entrée pour faire glisser ${t.plural(e.count, {
            one: () => `${t.number(e.count)} élément sélectionné`,
            other: () => `${t.number(e.count)} éléments sélectionnés`
          })}.`,
          dragSelectedLongPress: (e, t) => `Appuyez de manière prolongée pour faire glisser ${t.plural(e.count, {
            one: () => `${t.number(e.count)} élément sélectionné`,
            other: () => `${t.number(e.count)} éléments sélectionnés`
          })}.`,
          dragStartedKeyboard: "Déplacement commencé. Appuyez sur Tabulation pour accéder à une cible de dépôt, puis appuyez sur Entrée pour déposer, ou appuyez sur Échap pour annuler.",
          dragStartedTouch: "Déplacement commencé. Accédez à une cible de dépôt, puis touchez deux fois pour déposer.",
          dragStartedVirtual: "Déplacement commencé. Accédez à une cible de dépôt, puis cliquez ou appuyez sur Entrée pour déposer.",
          dropCanceled: "Dépôt annulé.",
          dropComplete: "Dépôt terminé.",
          dropDescriptionKeyboard: "Appuyez sur Entrée pour déposer. Appuyez sur Échap pour annuler le déplacement.",
          dropDescriptionTouch: "Touchez deux fois pour déposer.",
          dropDescriptionVirtual: "Cliquez pour déposer.",
          dropIndicator: "indicateur de dépôt",
          dropOnItem: e => `Déposer sur ${e.itemText}`,
          dropOnRoot: "Déposer sur",
          endDragKeyboard: "Déplacement. Appuyez sur Entrée pour annuler le déplacement.",
          endDragTouch: "Déplacement. Touchez deux fois pour annuler le déplacement.",
          endDragVirtual: "Déplacement. Cliquez pour annuler le déplacement.",
          insertAfter: e => `Insérer après ${e.itemText}`,
          insertBefore: e => `Insérer avant ${e.itemText}`,
          insertBetween: e => `Insérer entre ${e.beforeItemText} et ${e.afterItemText}`
        };
        var io;
        io = {
          dragDescriptionKeyboard: "הקש על Enter כדי להתחיל לגרור.",
          dragDescriptionKeyboardAlt: "הקש Alt + Enter כדי להתחיל לגרור.",
          dragDescriptionLongPress: "לחץ לחיצה ארוכה כדי להתחיל לגרור.",
          dragDescriptionTouch: "הקש פעמיים כדי להתחיל בגרירה.",
          dragDescriptionVirtual: "לחץ כדי להתחיל לגרור.",
          dragItem: e => `גרור את ${e.itemText}`,
          dragSelectedItems: (e, t) => `גרור ${t.plural(e.count, {
            one: () => `פריט נבחר ${t.number(e.count)}`,
            other: () => `${t.number(e.count)} פריטים שנבחרו`
          })}`,
          dragSelectedKeyboard: (e, t) => `הקש על Enter כדי לגרור ${t.plural(e.count, {
            one: () => `${t.number(e.count)} פריט שנבחר`,
            other: () => `${t.number(e.count)} פריטים שנבחרו`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `הקש Alt + Enter כדי לגרור ${t.plural(e.count, {
            one: () => `${t.number(e.count)} פריט שנבחר`,
            other: () => `${t.number(e.count)} פריטים שנבחרו`
          })}.`,
          dragSelectedLongPress: (e, t) => `לחץ לחיצה ארוכה כדי לגרור ${t.plural(e.count, {
            one: () => `${t.number(e.count)} פריט שנבחר`,
            other: () => `${t.number(e.count)} פריטים שנבחרו`
          })}.`,
          dragStartedKeyboard: "התחלת לגרור. הקש על Tab כדי לנווט לנקודת הגרירה ולאחר מכן הקש על Enter כדי לשחרר או על Escape כדי לבטל.",
          dragStartedTouch: "התחלת לגרור. נווט לנקודת השחרור ולאחר מכן הקש פעמיים כדי לשחרר.",
          dragStartedVirtual: "התחלת לגרור. נווט לנקודת השחרור ולאחר מכן לחץ או הקש על Enter כדי לשחרר.",
          dropCanceled: "השחרור בוטל.",
          dropComplete: "השחרור הושלם.",
          dropDescriptionKeyboard: "הקש על Enter כדי לשחרר. הקש על Escape כדי לבטל את הגרירה.",
          dropDescriptionTouch: "הקש פעמיים כדי לשחרר.",
          dropDescriptionVirtual: "לחץ כדי לשחרר.",
          dropIndicator: "מחוון שחרור",
          dropOnItem: e => `שחרר על ${e.itemText}`,
          dropOnRoot: "שחרר על",
          endDragKeyboard: "גורר. הקש על Enter כדי לבטל את הגרירה.",
          endDragTouch: "גורר. הקש פעמיים כדי לבטל את הגרירה.",
          endDragVirtual: "גורר. לחץ כדי לבטל את הגרירה.",
          insertAfter: e => `הוסף אחרי ${e.itemText}`,
          insertBefore: e => `הוסף לפני ${e.itemText}`,
          insertBetween: e => `הוסף בין ${e.beforeItemText} לבין ${e.afterItemText}`
        };
        var ao;
        ao = {
          dragDescriptionKeyboard: "Pritisnite Enter da biste počeli povlačiti.",
          dragDescriptionKeyboardAlt: "Pritisnite Alt + Enter za početak povlačenja.",
          dragDescriptionLongPress: "Dugo pritisnite za početak povlačenja.",
          dragDescriptionTouch: "Dvaput dodirnite da biste počeli povlačiti.",
          dragDescriptionVirtual: "Kliknite da biste počeli povlačiti.",
          dragItem: e => `Povucite stavku ${e.itemText}`,
          dragSelectedItems: (e, t) => `Povucite ${t.plural(e.count, {
            one: () => `${t.number(e.count)} odabranu stavku`,
            other: () => `ovoliko odabranih stavki: ${t.number(e.count)}`
          })}`,
          dragSelectedKeyboard: (e, t) => `Pritisnite Enter za povlačenje ${t.plural(e.count, {
            one: () => `${t.number(e.count)} odabrana stavka`,
            other: () => `${t.number(e.count)} odabrane stavke`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Pritisnite Alt + Enter za povlačenje ${t.plural(e.count, {
            one: () => `${t.number(e.count)} odabrana stavka`,
            other: () => `${t.number(e.count)} odabrane stavke`
          })}.`,
          dragSelectedLongPress: (e, t) => `Dugo pritisnite za povlačenje ${t.plural(e.count, {
            one: () => `${t.number(e.count)} odabrana stavka`,
            other: () => `${t.number(e.count)} odabrane stavke`
          })}.`,
          dragStartedKeyboard: "Počeli ste povlačiti. Pritisnite tipku tabulatora da biste došli do cilja ispuštanja, a zatim Enter da biste ispustili stavku ili Escape da biste prekinuli povlačenje.",
          dragStartedTouch: "Počeli ste povlačiti. Dođite do cilja ispuštanja, a zatim dvaput dodirnite da biste ispustili stavku.",
          dragStartedVirtual: "Počeli ste povlačiti. Dođite do cilja ispuštanja, a zatim kliknite ili pritisnite Enter da biste ispustili stavku.",
          dropCanceled: "Povlačenje je prekinuto.",
          dropComplete: "Ispuštanje je dovršeno.",
          dropDescriptionKeyboard: "Pritisnite Enter da biste ispustili stavku. Pritisnite Escape da biste prekinuli povlačenje.",
          dropDescriptionTouch: "Dvaput dodirnite da biste ispustili stavku.",
          dropDescriptionVirtual: "Kliknite da biste ispustili stavku.",
          dropIndicator: "pokazatelj ispuštanja",
          dropOnItem: e => `Ispustite na stavku ${e.itemText}`,
          dropOnRoot: "Ispustite na",
          endDragKeyboard: "Povlačenje. Pritisnite Enter da biste prekinuli povlačenje.",
          endDragTouch: "Povlačenje. Dvaput dodirnite da biste prekinuli povlačenje.",
          endDragVirtual: "Povlačenje. Kliknite da biste prekinuli povlačenje.",
          insertAfter: e => `Umetnite iza stavke ${e.itemText}`,
          insertBefore: e => `Ispustite ispred stavke ${e.itemText}`,
          insertBetween: e => `Umetnite između stavki ${e.beforeItemText} i ${e.afterItemText}`
        };
        var so;
        so = {
          dragDescriptionKeyboard: "Nyomja le az Enter billentyűt a húzás megkezdéséhez.",
          dragDescriptionKeyboardAlt: "Nyomja le az Alt + Enter billentyűket a húzás megkezdéséhez.",
          dragDescriptionLongPress: "Hosszan nyomja meg a húzás elindításához.",
          dragDescriptionTouch: "Koppintson duplán a húzás megkezdéséhez.",
          dragDescriptionVirtual: "Kattintson a húzás megkezdéséhez.",
          dragItem: e => `${e.itemText} húzása`,
          dragSelectedItems: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} kijelölt elem`,
            other: () => `${t.number(e.count)} kijelölt elem`
          })} húzása`,
          dragSelectedKeyboard: (e, t) => `Nyomja meg az Entert ${t.plural(e.count, {
            one: () => `${t.number(e.count)} kijelölt elem`,
            other: () => `${t.number(e.count)} kijelölt elem`
          })} húzásához.`,
          dragSelectedKeyboardAlt: (e, t) => `Nyomja meg az Alt + Enter billentyűket ${t.plural(e.count, {
            one: () => `${t.number(e.count)} kijelölt elem`,
            other: () => `${t.number(e.count)} kijelölt elem`
          })} húzásához.`,
          dragSelectedLongPress: (e, t) => `Tartsa lenyomva hosszan ${t.plural(e.count, {
            one: () => `${t.number(e.count)} kijelölt elem`,
            other: () => `${t.number(e.count)} kijelölt elem`
          })} húzásához.`,
          dragStartedKeyboard: "Húzás megkezdve. Nyomja le a Tab billentyűt az elengedési célhoz navigálásához, majd nyomja le az Enter billentyűt az elengedéshez, vagy nyomja le az Escape billentyűt a megszakításhoz.",
          dragStartedTouch: "Húzás megkezdve. Navigáljon egy elengedési célhoz, majd koppintson duplán az elengedéshez.",
          dragStartedVirtual: "Húzás megkezdve. Navigáljon egy elengedési célhoz, majd kattintson vagy nyomja le az Enter billentyűt az elengedéshez.",
          dropCanceled: "Elengedés megszakítva.",
          dropComplete: "Elengedés teljesítve.",
          dropDescriptionKeyboard: "Nyomja le az Enter billentyűt az elengedéshez. Nyomja le az Escape billentyűt a húzás megszakításához.",
          dropDescriptionTouch: "Koppintson duplán az elengedéshez.",
          dropDescriptionVirtual: "Kattintson az elengedéshez.",
          dropIndicator: "elengedésjelző",
          dropOnItem: e => `Elengedés erre: ${e.itemText}`,
          dropOnRoot: "Elengedés erre:",
          endDragKeyboard: "Húzás folyamatban. Nyomja le az Enter billentyűt a húzás megszakításához.",
          endDragTouch: "Húzás folyamatban. Koppintson duplán a húzás megszakításához.",
          endDragVirtual: "Húzás folyamatban. Kattintson a húzás megszakításához.",
          insertAfter: e => `Beszúrás ${e.itemText} után`,
          insertBefore: e => `Beszúrás ${e.itemText} elé`,
          insertBetween: e => `Beszúrás ${e.beforeItemText} és ${e.afterItemText} közé`
        };
        var lo;
        lo = {
          dragDescriptionKeyboard: "Premi Invio per iniziare a trascinare.",
          dragDescriptionKeyboardAlt: "Premi Alt + Invio per iniziare a trascinare.",
          dragDescriptionLongPress: "Premi a lungo per iniziare a trascinare.",
          dragDescriptionTouch: "Tocca due volte per iniziare a trascinare.",
          dragDescriptionVirtual: "Fai clic per iniziare a trascinare.",
          dragItem: e => `Trascina ${e.itemText}`,
          dragSelectedItems: (e, t) => `Trascina ${t.plural(e.count, {
            one: () => `${t.number(e.count)} altro elemento selezionato`,
            other: () => `${t.number(e.count)} altri elementi selezionati`
          })}`,
          dragSelectedKeyboard: (e, t) => `Premi Invio per trascinare ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento selezionato`,
            other: () => `${t.number(e.count)} elementi selezionati`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Premi Alt + Invio per trascinare ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento selezionato`,
            other: () => `${t.number(e.count)} elementi selezionati`
          })}.`,
          dragSelectedLongPress: (e, t) => `Premi a lungo per trascinare ${t.plural(e.count, {
            one: () => `${t.number(e.count)} elemento selezionato`,
            other: () => `${t.number(e.count)} elementi selezionati`
          })}.`,
          dragStartedKeyboard: "Hai iniziato a trascinare. Premi Tab per arrivare sull’area di destinazione, quindi premi Invio per rilasciare o Esc per annullare.",
          dragStartedTouch: "Hai iniziato a trascinare. Arriva sull’area di destinazione, quindi tocca due volte per rilasciare.",
          dragStartedVirtual: "Hai iniziato a trascinare. Arriva sull’area di destinazione, quindi fai clic o premi Invio per rilasciare.",
          dropCanceled: "Rilascio annullato.",
          dropComplete: "Rilascio completato.",
          dropDescriptionKeyboard: "Premi Invio per rilasciare. Premi Esc per annullare.",
          dropDescriptionTouch: "Tocca due volte per rilasciare.",
          dropDescriptionVirtual: "Fai clic per rilasciare.",
          dropIndicator: "indicatore di rilascio",
          dropOnItem: e => `Rilascia su ${e.itemText}`,
          dropOnRoot: "Rilascia su",
          endDragKeyboard: "Trascinamento. Premi Invio per annullare.",
          endDragTouch: "Trascinamento. Tocca due volte per annullare.",
          endDragVirtual: "Trascinamento. Fai clic per annullare.",
          insertAfter: e => `Inserisci dopo ${e.itemText}`,
          insertBefore: e => `Inserisci prima di ${e.itemText}`,
          insertBetween: e => `Inserisci tra ${e.beforeItemText} e ${e.afterItemText}`
        };
        var uo;
        uo = {
          dragDescriptionKeyboard: "Enter キーを押してドラッグを開始してください。",
          dragDescriptionKeyboardAlt: "Alt+Enter キーを押してドラッグを開始します。",
          dragDescriptionLongPress: "長押ししてドラッグを開始します。",
          dragDescriptionTouch: "ダブルタップしてドラッグを開始します。",
          dragDescriptionVirtual: "クリックしてドラッグを開始します。",
          dragItem: e => `${e.itemText} をドラッグ`,
          dragSelectedItems: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} 個の選択項目`,
            other: () => `${t.number(e.count)} 個の選択項目`
          })} をドラッグ`,
          dragSelectedKeyboard: (e, t) => `Enter キーを押して、${t.plural(e.count, {
            one: () => `${t.number(e.count)} 選択した項目`,
            other: () => `${t.number(e.count)} 選択した項目`
          })}をドラッグします。`,
          dragSelectedKeyboardAlt: (e, t) => `Alt+Enter キーを押して、${t.plural(e.count, {
            one: () => `${t.number(e.count)} 選択した項目`,
            other: () => `${t.number(e.count)} 選択した項目`
          })}をドラッグします。`,
          dragSelectedLongPress: (e, t) => `長押しして、${t.plural(e.count, {
            one: () => `${t.number(e.count)} 選択した項目`,
            other: () => `${t.number(e.count)} 選択した項目`
          })}をドラッグします。`,
          dragStartedKeyboard: "ドラッグを開始します。Tab キーを押してドロップターゲットにいどうし、Enter キーを押してドロップするか、Esc キーを押してキャンセルします。",
          dragStartedTouch: "ドラッグを開始しました。ドロップのターゲットに移動し、ダブルタップしてドロップします。",
          dragStartedVirtual: "ドラッグを開始しました。ドロップのターゲットに移動し、クリックまたは Enter キーを押してドロップします。",
          dropCanceled: "ドロップがキャンセルされました。",
          dropComplete: "ドロップが完了しました。",
          dropDescriptionKeyboard: "Enter キーを押してドロップします。Esc キーを押してドラッグをキャンセルします。",
          dropDescriptionTouch: "ダブルタップしてドロップします。",
          dropDescriptionVirtual: "クリックしてドロップします。",
          dropIndicator: "ドロップインジケーター",
          dropOnItem: e => `${e.itemText} にドロップ`,
          dropOnRoot: "ドロップ場所",
          endDragKeyboard: "ドラッグしています。Enter キーを押してドラッグをキャンセルします。",
          endDragTouch: "ドラッグしています。ダブルタップしてドラッグをキャンセルします。",
          endDragVirtual: "ドラッグしています。クリックしてドラッグをキャンセルします。",
          insertAfter: e => `${e.itemText} の後に挿入`,
          insertBefore: e => `${e.itemText} の前に挿入`,
          insertBetween: e => `${e.beforeItemText} と ${e.afterItemText} の間に挿入`
        };
        var co;
        co = {
          dragDescriptionKeyboard: "드래그를 시작하려면 Enter를 누르세요.",
          dragDescriptionKeyboardAlt: "드래그를 시작하려면 Alt + Enter를 누르십시오.",
          dragDescriptionLongPress: "드래그를 시작하려면 길게 누르십시오.",
          dragDescriptionTouch: "드래그를 시작하려면 더블 탭하세요.",
          dragDescriptionVirtual: "드래그를 시작하려면 클릭하세요.",
          dragItem: e => `${e.itemText} 드래그`,
          dragSelectedItems: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)}개 선택 항목`,
            other: () => `${t.number(e.count)}개 선택 항목`
          })} 드래그`,
          dragSelectedKeyboard: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)}개 선택 항목`,
            other: () => `${t.number(e.count)}개 선택 항목`
          })}을 드래그하려면 Enter를 누르십시오.`,
          dragSelectedKeyboardAlt: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)}개 선택 항목`,
            other: () => `${t.number(e.count)}개 선택 항목`
          })}을 드래그하려면 Alt + Enter를 누르십시오.`,
          dragSelectedLongPress: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)}개 선택 항목`,
            other: () => `${t.number(e.count)}개 선택 항목`
          })}을 드래그하려면 길게 누르십시오.`,
          dragStartedKeyboard: "드래그가 시작되었습니다. Tab을 눌러 드롭 대상으로 이동한 다음 Enter를 눌러 드롭하거나 Esc를 눌러 취소하세요.",
          dragStartedTouch: "드래그가 시작되었습니다. 드롭 대상으로 이동한 다음 더블 탭하여 드롭하세요.",
          dragStartedVirtual: "드래그가 시작되었습니다. 드롭 대상으로 이동한 다음 클릭하거나 Enter를 눌러 드롭하세요.",
          dropCanceled: "드롭이 취소되었습니다.",
          dropComplete: "드롭이 완료되었습니다.",
          dropDescriptionKeyboard: "드롭하려면 Enter를 누르세요. 드래그를 취소하려면 Esc를 누르세요.",
          dropDescriptionTouch: "더블 탭하여 드롭하세요.",
          dropDescriptionVirtual: "드롭하려면 클릭하세요.",
          dropIndicator: "드롭 표시기",
          dropOnItem: e => `${e.itemText}에 드롭`,
          dropOnRoot: "드롭 대상",
          endDragKeyboard: "드래그 중입니다. 드래그를 취소하려면 Enter를 누르세요.",
          endDragTouch: "드래그 중입니다. 드래그를 취소하려면 더블 탭하세요.",
          endDragVirtual: "드래그 중입니다. 드래그를 취소하려면 클릭하세요.",
          insertAfter: e => `${e.itemText} 이후에 삽입`,
          insertBefore: e => `${e.itemText} 이전에 삽입`,
          insertBetween: e => `${e.beforeItemText} 및 ${e.afterItemText} 사이에 삽입`
        };
        var po;
        po = {
          dragDescriptionKeyboard: "Paspauskite „Enter“, kad pradėtumėte vilkti.",
          dragDescriptionKeyboardAlt: "Paspauskite „Alt + Enter“, kad pradėtumėte vilkti.",
          dragDescriptionLongPress: "Palaikykite nuspaudę, kad pradėtumėte vilkti.",
          dragDescriptionTouch: "Palieskite dukart, kad pradėtumėte vilkti.",
          dragDescriptionVirtual: "Spustelėkite, kad pradėtumėte vilkti.",
          dragItem: e => `Vilkti ${e.itemText}`,
          dragSelectedItems: (e, t) => `Vilkti ${t.plural(e.count, {
            one: () => `${t.number(e.count)} pasirinktą elementą`,
            other: () => `${t.number(e.count)} pasirinktus elementus`
          })}`,
          dragSelectedKeyboard: (e, t) => `Paspauskite „Enter“, jei norite nuvilkti ${t.plural(e.count, {
            one: () => `${t.number(e.count)} pasirinktą elementą`,
            other: () => `${t.number(e.count)} pasirinktus elementus`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Paspauskite „Alt + Enter“, kad nuvilktumėte ${t.plural(e.count, {
            one: () => `${t.number(e.count)} pasirinktą elementą`,
            other: () => `${t.number(e.count)} pasirinktus elementus`
          })}.`,
          dragSelectedLongPress: (e, t) => `Nuspaudę palaikykite, kad nuvilktumėte ${t.plural(e.count, {
            one: () => `${t.number(e.count)} pasirinktą elementą`,
            other: () => `${t.number(e.count)} pasirinktus elementus`
          })}.`,
          dragStartedKeyboard: "Pradėta vilkti. Paspauskite „Tab“, kad pereitumėte į tiesioginę paskirties vietą, tada paspauskite „Enter“, kad numestumėte, arba „Escape“, kad atšauktumėte.",
          dragStartedTouch: "Pradėta vilkti. Eikite į tiesioginę paskirties vietą, tada palieskite dukart, kad numestumėte.",
          dragStartedVirtual: "Pradėta vilkti. Eikite į tiesioginę paskirties vietą ir spustelėkite arba paspauskite „Enter“, kad numestumėte.",
          dropCanceled: "Numetimas atšauktas.",
          dropComplete: "Numesta.",
          dropDescriptionKeyboard: "Paspauskite „Enter“, kad numestumėte. Paspauskite „Escape“, kad atšauktumėte vilkimą.",
          dropDescriptionTouch: "Palieskite dukart, kad numestumėte.",
          dropDescriptionVirtual: "Spustelėkite, kad numestumėte.",
          dropIndicator: "numetimo indikatorius",
          dropOnItem: e => `Numesti ant ${e.itemText}`,
          dropOnRoot: "Numesti ant",
          endDragKeyboard: "Velkama. Paspauskite „Enter“, kad atšauktumėte vilkimą.",
          endDragTouch: "Velkama. Spustelėkite dukart, kad atšauktumėte vilkimą.",
          endDragVirtual: "Velkama. Spustelėkite, kad atšauktumėte vilkimą.",
          insertAfter: e => `Įterpti po ${e.itemText}`,
          insertBefore: e => `Įterpti prieš ${e.itemText}`,
          insertBetween: e => `Įterpti tarp ${e.beforeItemText} ir ${e.afterItemText}`
        };
        var ho;
        ho = {
          dragDescriptionKeyboard: "Nospiediet Enter, lai sāktu vilkšanu.",
          dragDescriptionKeyboardAlt: "Nospiediet taustiņu kombināciju Alt+Enter, lai sāktu vilkšanu.",
          dragDescriptionLongPress: "Turiet nospiestu, lai sāktu vilkšanu.",
          dragDescriptionTouch: "Veiciet dubultskārienu, lai sāktu vilkšanu.",
          dragDescriptionVirtual: "Noklikšķiniet, lai sāktu vilkšanu.",
          dragItem: e => `Velciet ${e.itemText}`,
          dragSelectedItems: (e, t) => `Velciet ${t.plural(e.count, {
            one: () => `${t.number(e.count)} atlasīto vienumu`,
            other: () => `${t.number(e.count)} atlasītos vienumus`
          })}`,
          dragSelectedKeyboard: (e, t) => `Nospiediet taustiņu Enter, lai vilktu ${t.plural(e.count, {
            one: () => `${t.number(e.count)} atlasīto vienumu`,
            other: () => `${t.number(e.count)} atlasītos vienumus`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Nospiediet taustiņu kombināciju Alt+Enter, lai vilktu ${t.plural(e.count, {
            one: () => `${t.number(e.count)} atlasīto vienumu`,
            other: () => `${t.number(e.count)} atlasītos vienumus`
          })}.`,
          dragSelectedLongPress: (e, t) => `Turiet nospiestu, lai vilktu ${t.plural(e.count, {
            one: () => `${t.number(e.count)} atlasīto vienumu`,
            other: () => `${t.number(e.count)} atlasītos vienumus`
          })}.`,
          dragStartedKeyboard: "Uzsākta vilkšana. Nospiediet taustiņu Tab, lai pārietu uz nomešanas mērķi, pēc tam nospiediet Enter, lai nomestu, vai nospiediet Escape, lai atceltu.",
          dragStartedTouch: "Uzsākta vilkšana. Pārejiet uz nomešanas mērķi, pēc tam veiciet dubultskārienu, lai nomestu.",
          dragStartedVirtual: "Uzsākta vilkšana. Pārejiet uz nomešanas mērķi, pēc tam nospiediet Enter, lai nomestu.",
          dropCanceled: "Nomešana atcelta.",
          dropComplete: "Nomešana pabeigta.",
          dropDescriptionKeyboard: "Nospiediet Enter, lai nomestu. Nospiediet Escape, lai atceltu vilkšanu.",
          dropDescriptionTouch: "Veiciet dubultskārienu, lai nomestu.",
          dropDescriptionVirtual: "Noklikšķiniet, lai nomestu.",
          dropIndicator: "nomešanas indikators",
          dropOnItem: e => `Nometiet uz ${e.itemText}`,
          dropOnRoot: "Nometiet uz",
          endDragKeyboard: "Notiek vilkšana. Nospiediet Enter, lai atceltu vilkšanu.",
          endDragTouch: "Notiek vilkšana. Veiciet dubultskārienu, lai atceltu vilkšanu.",
          endDragVirtual: "Notiek vilkšana. Noklikšķiniet, lai atceltu vilkšanu.",
          insertAfter: e => `Ievietojiet pēc ${e.itemText}`,
          insertBefore: e => `Ievietojiet pirms ${e.itemText}`,
          insertBetween: e => `Ievietojiet starp ${e.beforeItemText} un ${e.afterItemText}`
        };
        var fo;
        fo = {
          dragDescriptionKeyboard: "Trykk på Enter for å begynne å dra.",
          dragDescriptionKeyboardAlt: "Trykk på Alt + Enter for å begynne å dra.",
          dragDescriptionLongPress: "Trykk lenge for å begynne å dra.",
          dragDescriptionTouch: "Dobbelttrykk for å begynne å dra.",
          dragDescriptionVirtual: "Klikk for å begynne å dra.",
          dragItem: e => `Dra ${e.itemText}`,
          dragSelectedItems: (e, t) => `Dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} merket element`,
            other: () => `${t.number(e.count)} merkede elementer`
          })}`,
          dragSelectedKeyboard: (e, t) => `Trykk Enter for å dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgt element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Trykk på Alt + Enter for å dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgt element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragSelectedLongPress: (e, t) => `Trykk lenge for å dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valgt element`,
            other: () => `${t.number(e.count)} valgte elementer`
          })}.`,
          dragStartedKeyboard: "Begynte å dra. Trykk på Tab for å navigere til et mål, og trykk deretter på Enter for å slippe eller på Esc for å avbryte.",
          dragStartedTouch: "Begynte å dra. Naviger til et mål, og dobbelttrykk for å slippe.",
          dragStartedVirtual: "Begynte å dra. Naviger til et mål, og klikk eller trykk på Enter for å slippe.",
          dropCanceled: "Avbrøt slipping.",
          dropComplete: "Slippingen er fullført.",
          dropDescriptionKeyboard: "Trykk på Enter for å slippe. Trykk på Esc hvis du vil avbryte draingen.",
          dropDescriptionTouch: "Dobbelttrykk for å slippe.",
          dropDescriptionVirtual: "Klikk for å slippe.",
          dropIndicator: "slippeindikator",
          dropOnItem: e => `Slipp på ${e.itemText}`,
          dropOnRoot: "Slipp på",
          endDragKeyboard: "Drar. Trykk på Enter hvis du vil avbryte.",
          endDragTouch: "Drar. Dobbelttrykk hvis du vil avbryte.",
          endDragVirtual: "Drar. Klikk hvis du vil avbryte.",
          insertAfter: e => `Sett inn etter ${e.itemText}`,
          insertBefore: e => `Sett inn før ${e.itemText}`,
          insertBetween: e => `Sett inn mellom ${e.beforeItemText} og ${e.afterItemText}`
        };
        var mo;
        mo = {
          dragDescriptionKeyboard: "Druk op Enter om te slepen.",
          dragDescriptionKeyboardAlt: "Druk op Alt + Enter om te slepen.",
          dragDescriptionLongPress: "Houd lang ingedrukt om te slepen.",
          dragDescriptionTouch: "Dubbeltik om te slepen.",
          dragDescriptionVirtual: "Klik om met slepen te starten.",
          dragItem: e => `${e.itemText} slepen`,
          dragSelectedItems: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} geselecteerd item`,
            other: () => `${t.number(e.count)} geselecteerde items`
          })} slepen`,
          dragSelectedKeyboard: (e, t) => `Druk op Enter om ${t.plural(e.count, {
            one: () => `${t.number(e.count)} geselecteerd item`,
            other: () => `${t.number(e.count)} geselecteerde items`
          })} te slepen.`,
          dragSelectedKeyboardAlt: (e, t) => `Druk op Alt + Enter om ${t.plural(e.count, {
            one: () => `${t.number(e.count)} geselecteerd item`,
            other: () => `${t.number(e.count)} geselecteerde items`
          })} te slepen.`,
          dragSelectedLongPress: (e, t) => `Houd lang ingedrukt om ${t.plural(e.count, {
            one: () => `${t.number(e.count)} geselecteerd item`,
            other: () => `${t.number(e.count)} geselecteerde items`
          })} te slepen.`,
          dragStartedKeyboard: "Begonnen met slepen. Druk op Tab om naar een locatie te gaan. Druk dan op Enter om neer te zetten, of op Esc om te annuleren.",
          dragStartedTouch: "Begonnen met slepen. Ga naar de gewenste locatie en dubbeltik om neer te zetten.",
          dragStartedVirtual: "Begonnen met slepen. Ga naar de gewenste locatie en klik of druk op Enter om neer te zetten.",
          dropCanceled: "Neerzetten geannuleerd.",
          dropComplete: "Neerzetten voltooid.",
          dropDescriptionKeyboard: "Druk op Enter om neer te zetten. Druk op Esc om het slepen te annuleren.",
          dropDescriptionTouch: "Dubbeltik om neer te zetten.",
          dropDescriptionVirtual: "Klik om neer te zetten.",
          dropIndicator: "aanwijzer voor neerzetten",
          dropOnItem: e => `Neerzetten op ${e.itemText}`,
          dropOnRoot: "Neerzetten op",
          endDragKeyboard: "Bezig met slepen. Druk op Enter om te annuleren.",
          endDragTouch: "Bezig met slepen. Dubbeltik om te annuleren.",
          endDragVirtual: "Bezig met slepen. Klik om te annuleren.",
          insertAfter: e => `Plaatsen na ${e.itemText}`,
          insertBefore: e => `Plaatsen vóór ${e.itemText}`,
          insertBetween: e => `Plaatsen tussen ${e.beforeItemText} en ${e.afterItemText}`
        };
        var go;
        go = {
          dragDescriptionKeyboard: "Naciśnij Enter, aby rozpocząć przeciąganie.",
          dragDescriptionKeyboardAlt: "Naciśnij Alt + Enter, aby rozpocząć przeciąganie.",
          dragDescriptionLongPress: "Naciśnij i przytrzymaj, aby rozpocząć przeciąganie.",
          dragDescriptionTouch: "Dotknij dwukrotnie, aby rozpocząć przeciąganie.",
          dragDescriptionVirtual: "Kliknij, aby rozpocząć przeciąganie.",
          dragItem: e => `Przeciągnij ${e.itemText}`,
          dragSelectedItems: (e, t) => `Przeciągnij ${t.plural(e.count, {
            one: () => `${t.number(e.count)} wybrany element`,
            other: () => `${t.number(e.count)} wybranych elementów`
          })}`,
          dragSelectedKeyboard: (e, t) => `Naciśnij Enter, aby przeciągnąć ${t.plural(e.count, {
            one: () => `${t.number(e.count)} wybrany element`,
            other: () => `${t.number(e.count)} wybrane(-ych) elementy(-ów)`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Naciśnij Alt + Enter, aby przeciągnąć ${t.plural(e.count, {
            one: () => `${t.number(e.count)} wybrany element`,
            other: () => `${t.number(e.count)} wybrane(-ych) elementy(-ów)`
          })}.`,
          dragSelectedLongPress: (e, t) => `Naciśnij i przytrzymaj, aby przeciągnąć ${t.plural(e.count, {
            one: () => `${t.number(e.count)} wybrany element`,
            other: () => `${t.number(e.count)} wybrane(-ych) elementy(-ów)`
          })}.`,
          dragStartedKeyboard: "Rozpoczęto przeciąganie. Naciśnij Tab, aby wybrać miejsce docelowe, a następnie naciśnij Enter, aby upuścić, lub Escape, aby anulować.",
          dragStartedTouch: "Rozpoczęto przeciąganie. Wybierz miejsce, w którym chcesz upuścić element, a następnie dotknij dwukrotnie, aby upuścić.F",
          dragStartedVirtual: "Rozpoczęto przeciąganie. Wybierz miejsce, w którym chcesz upuścić element, a następnie kliknij lub naciśnij Enter, aby upuścić.",
          dropCanceled: "Anulowano upuszczenie.",
          dropComplete: "Zakończono upuszczanie.",
          dropDescriptionKeyboard: "Naciśnij Enter, aby upuścić. Naciśnij Escape, aby anulować przeciągnięcie.",
          dropDescriptionTouch: "Dotknij dwukrotnie, aby upuścić.",
          dropDescriptionVirtual: "Kliknij, aby upuścić.",
          dropIndicator: "wskaźnik upuszczenia",
          dropOnItem: e => `Upuść na ${e.itemText}`,
          dropOnRoot: "Upuść",
          endDragKeyboard: "Przeciąganie. Naciśnij Enter, aby anulować przeciągnięcie.",
          endDragTouch: "Przeciąganie. Kliknij dwukrotnie, aby anulować przeciągnięcie.",
          endDragVirtual: "Przeciąganie. Kliknij, aby anulować przeciąganie.",
          insertAfter: e => `Umieść za ${e.itemText}`,
          insertBefore: e => `Umieść przed ${e.itemText}`,
          insertBetween: e => `Umieść między ${e.beforeItemText} i ${e.afterItemText}`
        };
        var vo;
        vo = {
          dragDescriptionKeyboard: "Pressione Enter para começar a arrastar.",
          dragDescriptionKeyboardAlt: "Pressione Alt + Enter para começar a arrastar.",
          dragDescriptionLongPress: "Pressione e segure para começar a arrastar.",
          dragDescriptionTouch: "Toque duas vezes para começar a arrastar.",
          dragDescriptionVirtual: "Clique para começar a arrastar.",
          dragItem: e => `Arrastar ${e.itemText}`,
          dragSelectedItems: (e, t) => `Arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} item selecionado`,
            other: () => `${t.number(e.count)} itens selecionados`
          })}`,
          dragSelectedKeyboard: (e, t) => `Pressione Enter para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Pressione Alt + Enter para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragSelectedLongPress: (e, t) => `Pressione e segure para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragStartedKeyboard: "Comece a arrastar. Pressione Tab para navegar até um alvo e, em seguida, pressione Enter para soltar ou pressione Escape para cancelar.",
          dragStartedTouch: "Comece a arrastar. Navegue até um alvo e toque duas vezes para soltar.",
          dragStartedVirtual: "Comece a arrastar. Navegue até um alvo e clique ou pressione Enter para soltar.",
          dropCanceled: "Liberação cancelada.",
          dropComplete: "Liberação concluída.",
          dropDescriptionKeyboard: "Pressione Enter para soltar. Pressione Escape para cancelar.",
          dropDescriptionTouch: "Toque duas vezes para soltar.",
          dropDescriptionVirtual: "Clique para soltar.",
          dropIndicator: "indicador de liberação",
          dropOnItem: e => `Soltar em ${e.itemText}`,
          dropOnRoot: "Soltar",
          endDragKeyboard: "Arrastando. Pressione Enter para cancelar.",
          endDragTouch: "Arrastando. Toque duas vezes para cancelar.",
          endDragVirtual: "Arrastando. Clique para cancelar.",
          insertAfter: e => `Inserir após ${e.itemText}`,
          insertBefore: e => `Inserir antes de ${e.itemText}`,
          insertBetween: e => `Inserir entre ${e.beforeItemText} e ${e.afterItemText}`
        };
        var yo;
        yo = {
          dragDescriptionKeyboard: "Prima Enter para iniciar o arrasto.",
          dragDescriptionKeyboardAlt: "Prima Alt + Enter para iniciar o arrasto.",
          dragDescriptionLongPress: "Prima longamente para começar a arrastar.",
          dragDescriptionTouch: "Faça duplo toque para começar a arrastar.",
          dragDescriptionVirtual: "Clique para iniciar o arrasto.",
          dragItem: e => `Arrastar ${e.itemText}`,
          dragSelectedItems: (e, t) => `Arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} item selecionado`,
            other: () => `${t.number(e.count)} itens selecionados`
          })}`,
          dragSelectedKeyboard: (e, t) => `Prima Enter para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Prima Alt + Enter para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragSelectedLongPress: (e, t) => `Prima longamente para arrastar ${t.plural(e.count, {
            one: () => `${t.number(e.count)} o item selecionado`,
            other: () => `${t.number(e.count)} os itens selecionados`
          })}.`,
          dragStartedKeyboard: "Arrasto iniciado. Prima a tecla de tabulação para navegar para um destino para largar, e em seguida prima Enter para largar ou prima Escape para cancelar.",
          dragStartedTouch: "Arrasto iniciado. Navegue para um destino para largar, e em seguida faça duplo toque para largar.",
          dragStartedVirtual: "Arrasto iniciado. Navegue para um destino para largar, e em seguida clique ou prima Enter para largar.",
          dropCanceled: "Largar cancelado.",
          dropComplete: "Largar completo.",
          dropDescriptionKeyboard: "Prima Enter para largar. Prima Escape para cancelar o arrasto.",
          dropDescriptionTouch: "Faça duplo toque para largar.",
          dropDescriptionVirtual: "Clique para largar.",
          dropIndicator: "Indicador de largar",
          dropOnItem: e => `Largar em ${e.itemText}`,
          dropOnRoot: "Largar em",
          endDragKeyboard: "A arrastar. Prima Enter para cancelar o arrasto.",
          endDragTouch: "A arrastar. Faça duplo toque para cancelar o arrasto.",
          endDragVirtual: "A arrastar. Clique para cancelar o arrasto.",
          insertAfter: e => `Inserir depois de ${e.itemText}`,
          insertBefore: e => `Inserir antes de ${e.itemText}`,
          insertBetween: e => `Inserir entre ${e.beforeItemText} e ${e.afterItemText}`
        };
        var bo;
        bo = {
          dragDescriptionKeyboard: "Apăsați pe Enter pentru a începe glisarea.",
          dragDescriptionKeyboardAlt: "Apăsați pe Alt + Enter pentru a începe glisarea.",
          dragDescriptionLongPress: "Apăsați lung pentru a începe glisarea.",
          dragDescriptionTouch: "Atingeți de două ori pentru a începe să glisați.",
          dragDescriptionVirtual: "Faceți clic pentru a începe glisarea.",
          dragItem: e => `Glisați ${e.itemText}`,
          dragSelectedItems: (e, t) => `Glisați ${t.plural(e.count, {
            one: () => `${t.number(e.count)} element selectat`,
            other: () => `${t.number(e.count)} elemente selectate`
          })}`,
          dragSelectedKeyboard: (e, t) => `Apăsați pe Enter pentru a glisa ${t.plural(e.count, {
            one: () => `${t.number(e.count)} element selectat`,
            other: () => `${t.number(e.count)} elemente selectate`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Apăsați pe Alt + Enter pentru a glisa ${t.plural(e.count, {
            one: () => `${t.number(e.count)} element selectat`,
            other: () => `${t.number(e.count)} elemente selectate`
          })}.`,
          dragSelectedLongPress: (e, t) => `Apăsați lung pentru a glisa ${t.plural(e.count, {
            one: () => `${t.number(e.count)} element selectat`,
            other: () => `${t.number(e.count)} elemente selectate`
          })}.`,
          dragStartedKeyboard: "A început glisarea. Apăsați pe Tab pentru a naviga la o țintă de fixare, apoi apăsați pe Enter pentru a fixa sau apăsați pe Escape pentru a anula glisarea.",
          dragStartedTouch: "A început glisarea. Navigați la o țintă de fixare, apoi atingeți de două ori pentru a fixa.",
          dragStartedVirtual: "A început glisarea. Navigați la o țintă de fixare, apoi faceți clic sau apăsați pe Enter pentru a fixa.",
          dropCanceled: "Fixare anulată.",
          dropComplete: "Fixare finalizată.",
          dropDescriptionKeyboard: "Apăsați pe Enter pentru a fixa. Apăsați pe Escape pentru a anula glisarea.",
          dropDescriptionTouch: "Atingeți de două ori pentru a fixa.",
          dropDescriptionVirtual: "Faceți clic pentru a fixa.",
          dropIndicator: "indicator de fixare",
          dropOnItem: e => `Fixați pe ${e.itemText}`,
          dropOnRoot: "Fixare pe",
          endDragKeyboard: "Se glisează. Apăsați pe Enter pentru a anula glisarea.",
          endDragTouch: "Se glisează. Atingeți de două ori pentru a anula glisarea.",
          endDragVirtual: "Se glisează. Faceți clic pentru a anula glisarea.",
          insertAfter: e => `Inserați după ${e.itemText}`,
          insertBefore: e => `Inserați înainte de ${e.itemText}`,
          insertBetween: e => `Inserați între ${e.beforeItemText} și ${e.afterItemText}`
        };
        var wo;
        wo = {
          dragDescriptionKeyboard: "Нажмите клавишу Enter для начала перетаскивания.",
          dragDescriptionKeyboardAlt: "Нажмите Alt + Enter, чтобы начать перетаскивать.",
          dragDescriptionLongPress: "Нажмите и удерживайте, чтобы начать перетаскивать.",
          dragDescriptionTouch: "Дважды нажмите для начала перетаскивания.",
          dragDescriptionVirtual: "Щелкните для начала перетаскивания.",
          dragItem: e => `Перетащить ${e.itemText}`,
          dragSelectedItems: (e, t) => `Перетащить ${t.plural(e.count, {
            one: () => `${t.number(e.count)} выбранный элемент`,
            other: () => `${t.number(e.count)} выбранных элем`
          })}`,
          dragSelectedKeyboard: (e, t) => `Нажмите Enter для перетаскивания ${t.plural(e.count, {
            one: () => `${t.number(e.count)} выбранного элемента`,
            other: () => `${t.number(e.count)} выбранных элементов`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Нажмите Alt + Enter для перетаскивания ${t.plural(e.count, {
            one: () => `${t.number(e.count)} выбранного элемента`,
            other: () => `${t.number(e.count)} выбранных элементов`
          })}.`,
          dragSelectedLongPress: (e, t) => `Нажмите и удерживайте для перетаскивания ${t.plural(e.count, {
            one: () => `${t.number(e.count)} выбранного элемента`,
            other: () => `${t.number(e.count)} выбранных элементов`
          })}.`,
          dragStartedKeyboard: "Начато перетаскивание. Нажмите клавишу Tab для выбора цели, затем нажмите клавишу Enter, чтобы применить перетаскивание, или клавишу Escape для отмены действия.",
          dragStartedTouch: "Начато перетаскивание. Выберите цель, затем дважды нажмите, чтобы применить перетаскивание.",
          dragStartedVirtual: "Начато перетаскивание. Нажмите клавишу Tab для выбора цели, затем нажмите клавишу Enter, чтобы применить перетаскивание.",
          dropCanceled: "Перетаскивание отменено.",
          dropComplete: "Перетаскивание завершено.",
          dropDescriptionKeyboard: "Нажмите клавишу Enter, чтобы применить перетаскивание. Нажмите клавишу Escape для отмены.",
          dropDescriptionTouch: "Дважды нажмите, чтобы применить перетаскивание.",
          dropDescriptionVirtual: "Щелкните, чтобы применить перетаскивание.",
          dropIndicator: "индикатор перетаскивания",
          dropOnItem: e => `Перетащить на ${e.itemText}`,
          dropOnRoot: "Перетащить на",
          endDragKeyboard: "Перетаскивание. Нажмите клавишу Enter для отмены.",
          endDragTouch: "Перетаскивание. Дважды нажмите для отмены.",
          endDragVirtual: "Перетаскивание. Щелкните для отмены.",
          insertAfter: e => `Вставить после ${e.itemText}`,
          insertBefore: e => `Вставить перед ${e.itemText}`,
          insertBetween: e => `Вставить между ${e.beforeItemText} и ${e.afterItemText}`
        };
        var xo;
        xo = {
          dragDescriptionKeyboard: "Stlačením klávesu Enter začnete presúvanie.",
          dragDescriptionKeyboardAlt: "Stlačením klávesov Alt + Enter začnete presúvanie.",
          dragDescriptionLongPress: "Dlhým stlačením začnete presúvanie.",
          dragDescriptionTouch: "Dvojitým kliknutím začnete presúvanie.",
          dragDescriptionVirtual: "Kliknutím začnete presúvanie.",
          dragItem: e => `Presunúť položku ${e.itemText}`,
          dragSelectedItems: (e, t) => `Presunúť ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybratú položku`,
            other: () => `${t.number(e.count)} vybraté položky`
          })}`,
          dragSelectedKeyboard: (e, t) => `Stlačením klávesu Enter presuniete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybratú položku`,
            other: () => `${t.number(e.count)} vybratých položiek`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Stlačením klávesov Alt + Enter presuniete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybratú položku`,
            other: () => `${t.number(e.count)} vybratých položiek`
          })}.`,
          dragSelectedLongPress: (e, t) => `Dlhým stlačením presuniete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} vybratú položku`,
            other: () => `${t.number(e.count)} vybratých položiek`
          })}.`,
          dragStartedKeyboard: "Presúvanie sa začalo. Do cieľového umiestnenia prejdete stlačením klávesu Tab. Ak chcete položku umiestniť, stlačte kláves Enter alebo stlačte kláves Esc, ak chcete presúvanie zrušiť.",
          dragStartedTouch: "Presúvanie sa začalo. Prejdite na cieľové umiestnenie a dvojitým kliknutím umiestnite položku.",
          dragStartedVirtual: "Presúvanie sa začalo. Prejdite na cieľové umiestnenie a kliknutím alebo stlačením klávesu Enter umiestnite položku.",
          dropCanceled: "Umiestnenie zrušené.",
          dropComplete: "Umiestnenie dokončené.",
          dropDescriptionKeyboard: "Stlačením klávesu Enter umiestnite položku. Stlačením klávesu Esc zrušíte presúvanie.",
          dropDescriptionTouch: "Dvojitým kliknutím umiestnite položku.",
          dropDescriptionVirtual: "Kliknutím umiestnite položku.",
          dropIndicator: "indikátor umiestnenia",
          dropOnItem: e => `Umiestniť na položku ${e.itemText}`,
          dropOnRoot: "Umiestniť na",
          endDragKeyboard: "Prebieha presúvanie. Ak ho chcete zrušiť, stlačte kláves Enter.",
          endDragTouch: "Prebieha presúvanie. Dvojitým kliknutím ho môžete zrušiť.",
          endDragVirtual: "Prebieha presúvanie.",
          insertAfter: e => `Vložiť za položku ${e.itemText}`,
          insertBefore: e => `Vložiť pred položku ${e.itemText}`,
          insertBetween: e => `Vložiť medzi položky ${e.beforeItemText} a ${e.afterItemText}`
        };
        var Do;
        Do = {
          dragDescriptionKeyboard: "Pritisnite tipko Enter za začetek vlečenja.",
          dragDescriptionKeyboardAlt: "Pritisnite tipki Alt + Enter za začetek vlečenja.",
          dragDescriptionLongPress: "Pritisnite in zadržite za začetek vlečenja.",
          dragDescriptionTouch: "Dvotapnite za začetek vlečenja.",
          dragDescriptionVirtual: "Kliknite za začetek vlečenja.",
          dragItem: e => `Povleci ${e.itemText}`,
          dragSelectedItems: (e, t) => `Povlecite ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izbran element`,
            other: () => `izbrane elemente (${t.number(e.count)})`
          })}`,
          dragSelectedKeyboard: (e, t) => `Pritisnite tipko Enter, da povlečete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izbrani element`,
            other: () => `${t.number(e.count)} izbranih elementov`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Pritisnite tipki Alt + Enter, da povlečete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izbrani element`,
            other: () => `${t.number(e.count)} izbranih elementov`
          })}.`,
          dragSelectedLongPress: (e, t) => `Pritisnite in zadržite, da povlečete ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izbrani element`,
            other: () => `${t.number(e.count)} izbranih elementov`
          })}.`,
          dragStartedKeyboard: "Vlečenje se je začelo. Pritisnite tipko Tab za pomik na mesto, kamor želite spustiti elemente, in pritisnite tipko Enter, da jih spustite, ali tipko Escape, da prekličete postopek.",
          dragStartedTouch: "Vlečenje se je začelo. Pomaknite se na mesto, kamor želite spustiti elemente, in dvotapnite, da jih spustite.",
          dragStartedVirtual: "Vlečenje se je začelo. Pomaknite se na mesto, kamor želite spustiti elemente, in kliknite ali pritisnite tipko Enter, da jih spustite.",
          dropCanceled: "Spust je preklican.",
          dropComplete: "Spust je končan.",
          dropDescriptionKeyboard: "Pritisnite tipko Enter, da spustite. Pritisnite tipko Escape, da prekličete vlečenje.",
          dropDescriptionTouch: "Dvotapnite, da spustite.",
          dropDescriptionVirtual: "Kliknite, da spustite.",
          dropIndicator: "indikator spusta",
          dropOnItem: e => `Spusti na mesto ${e.itemText}`,
          dropOnRoot: "Spusti na mesto",
          endDragKeyboard: "Vlečenje. Pritisnite tipko Enter za preklic vlečenja.",
          endDragTouch: "Vlečenje. Dvotapnite za preklic vlečenja.",
          endDragVirtual: "Vlečenje. Kliknite, da prekličete vlečenje.",
          insertAfter: e => `Vstavi za ${e.itemText}`,
          insertBefore: e => `Vstavi pred ${e.itemText}`,
          insertBetween: e => `Vstavi med ${e.beforeItemText} in ${e.afterItemText}`
        };
        var Co;
        Co = {
          dragDescriptionKeyboard: "Pritisnite Enter da biste započeli prevlačenje.",
          dragDescriptionKeyboardAlt: "Pritisnite Alt + Enter da biste započeli prevlačenje.",
          dragDescriptionLongPress: "Pritisnite dugo da biste započeli prevlačenje.",
          dragDescriptionTouch: "Dvaput dodirnite da biste započeli prevlačenje.",
          dragDescriptionVirtual: "Kliknite da biste započeli prevlačenje.",
          dragItem: e => `Prevucite ${e.itemText}`,
          dragSelectedItems: (e, t) => `Prevucite ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izabranu stavku`,
            other: () => `${t.number(e.count)} izabrane stavke`
          })}`,
          dragSelectedKeyboard: (e, t) => `Pritisnite Enter da biste prevukli ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izabranu stavku`,
            other: () => `${t.number(e.count)} izabranih stavki`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Pritisnite Alt + Enter da biste prevukli ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izabranu stavku`,
            other: () => `${t.number(e.count)} izabranih stavki`
          })}.`,
          dragSelectedLongPress: (e, t) => `Pritisnite dugo da biste prevukli ${t.plural(e.count, {
            one: () => `${t.number(e.count)} izabranu stavku`,
            other: () => `${t.number(e.count)} izabranih stavki`
          })}.`,
          dragStartedKeyboard: "Prevlačenje je započeto. Pritisnite Tab da biste otišli do cilja za otpuštanje, zatim pritisnite Enter za ispuštanje ili pritisnite Escape za otkazivanje.",
          dragStartedTouch: "Prevlačenje je započeto. Idite do cilja za otpuštanje, a zatim dvaput dodirnite za otpuštanje.",
          dragStartedVirtual: "Prevlačenje je započeto. Idite do cilja za otpuštanje, a zatim kliknite ili pritinite Enter za otpuštanje.",
          dropCanceled: "Otpuštanje je otkazano.",
          dropComplete: "Prevlačenje je završeno.",
          dropDescriptionKeyboard: "Pritisnite Enter da biste otpustili. Pritisnite Escape da biste otkazali prevlačenje.",
          dropDescriptionTouch: "Dvaput dodirnite za otpuštanje.",
          dropDescriptionVirtual: "Kliknite za otpuštanje.",
          dropIndicator: "Indikator otpuštanja",
          dropOnItem: e => `Otpusti na ${e.itemText}`,
          dropOnRoot: "Otpusti na",
          endDragKeyboard: "Prevlačenje u toku. Pritisnite Enter da biste otkazali prevlačenje.",
          endDragTouch: "Prevlačenje u toku. Dvaput dodirnite da biste otkazali prevlačenje.",
          endDragVirtual: "Prevlačenje u toku. Kliknite da biste otkazali prevlačenje.",
          insertAfter: e => `Umetnite posle ${e.itemText}`,
          insertBefore: e => `Umetnite ispred ${e.itemText}`,
          insertBetween: e => `Umetnite između ${e.beforeItemText} i ${e.afterItemText}`
        };
        var So;
        So = {
          dragDescriptionKeyboard: "Tryck på enter för att börja dra.",
          dragDescriptionKeyboardAlt: "Tryck på Alt + Retur för att börja dra.",
          dragDescriptionLongPress: "Tryck länge för att börja dra.",
          dragDescriptionTouch: "Dubbeltryck för att börja dra.",
          dragDescriptionVirtual: "Klicka för att börja dra.",
          dragItem: e => `Dra ${e.itemText}`,
          dragSelectedItems: (e, t) => `Dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} valt objekt`,
            other: () => `${t.number(e.count)} valda objekt`
          })}`,
          dragSelectedKeyboard: (e, t) => `Tryck på Retur för att dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} markerat objekt`,
            other: () => `${t.number(e.count)} markerade objekt`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Tryck på Alt + Retur för att dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} markerat objekt`,
            other: () => `${t.number(e.count)} markerade objekt`
          })}.`,
          dragSelectedLongPress: (e, t) => `Tryck länge för att dra ${t.plural(e.count, {
            one: () => `${t.number(e.count)} markerat objekt`,
            other: () => `${t.number(e.count)} markerade objekt`
          })}.`,
          dragStartedKeyboard: "Börja dra. Tryck på tabb för att navigera till målet, tryck på enter för att släppa eller på escape för att avbryta.",
          dragStartedTouch: "Börja dra. Navigera till ett mål och dubbeltryck för att släppa.",
          dragStartedVirtual: "Börja dra. Navigera till ett mål och klicka eller tryck på enter för att släppa.",
          dropCanceled: "Släppåtgärd avbröts.",
          dropComplete: "Släppåtgärd klar.",
          dropDescriptionKeyboard: "Tryck på enter för att släppa. Tryck på escape för att avbryta dragåtgärd.",
          dropDescriptionTouch: "Dubbeltryck för att släppa.",
          dropDescriptionVirtual: "Klicka för att släppa.",
          dropIndicator: "släppindikator",
          dropOnItem: e => `Släpp på ${e.itemText}`,
          dropOnRoot: "Släpp på",
          endDragKeyboard: "Drar. Tryck på enter för att avbryta dragåtgärd.",
          endDragTouch: "Drar. Dubbeltryck för att avbryta dragåtgärd.",
          endDragVirtual: "Drar. Klicka för att avbryta dragåtgärd.",
          insertAfter: e => `Infoga efter ${e.itemText}`,
          insertBefore: e => `Infoga före ${e.itemText}`,
          insertBetween: e => `Infoga mellan ${e.beforeItemText} och ${e.afterItemText}`
        };
        var Eo;
        Eo = {
          dragDescriptionKeyboard: "Sürüklemeyi başlatmak için Enter'a basın.",
          dragDescriptionKeyboardAlt: "Sürüklemeyi başlatmak için Alt + Enter'a basın.",
          dragDescriptionLongPress: "Sürüklemeye başlamak için uzun basın.",
          dragDescriptionTouch: "Sürüklemeyi başlatmak için çift tıklayın.",
          dragDescriptionVirtual: "Sürüklemeyi başlatmak için tıklayın.",
          dragItem: e => `${e.itemText}’i sürükle`,
          dragSelectedItems: (e, t) => `Sürükle ${t.plural(e.count, {
            one: () => `${t.number(e.count)} seçili öge`,
            other: () => `${t.number(e.count)} seçili öge`
          })}`,
          dragSelectedKeyboard: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} seçilmiş öğe`,
            other: () => `${t.number(e.count)} seçilmiş öğe`
          })} öğesini sürüklemek için Enter'a basın.`,
          dragSelectedKeyboardAlt: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} seçilmiş öğe`,
            other: () => `${t.number(e.count)} seçilmiş öğe`
          })} öğesini sürüklemek için Alt + Enter tuşuna basın.`,
          dragSelectedLongPress: (e, t) => `${t.plural(e.count, {
            one: () => `${t.number(e.count)} seçilmiş öğe`,
            other: () => `${t.number(e.count)} seçilmiş öğe`
          })} öğesini sürüklemek için uzun basın.`,
          dragStartedKeyboard: "Sürükleme başlatıldı. Bir bırakma hedefine gitmek için Tab’a basın, ardından bırakmak için Enter’a basın veya iptal etmek için Escape’e basın.",
          dragStartedTouch: "Sürükleme başlatıldı. Bir bırakma hedefine gidin, ardından bırakmak için çift tıklayın.",
          dragStartedVirtual: "Sürükleme başlatıldı. Bir bırakma hedefine gidin, ardından bırakmak için Enter’a tıklayın veya basın.",
          dropCanceled: "Bırakma iptal edildi.",
          dropComplete: "Bırakma tamamlandı.",
          dropDescriptionKeyboard: "Bırakmak için Enter'a basın. Sürüklemeyi iptal etmek için Escape'e basın.",
          dropDescriptionTouch: "Bırakmak için çift tıklayın.",
          dropDescriptionVirtual: "Bırakmak için tıklayın.",
          dropIndicator: "bırakma göstergesi",
          dropOnItem: e => `${e.itemText} üzerine bırak`,
          dropOnRoot: "Bırakın",
          endDragKeyboard: "Sürükleme. Sürüklemeyi iptal etmek için Enter'a basın.",
          endDragTouch: "Sürükleme. Sürüklemeyi iptal etmek için çift tıklayın.",
          endDragVirtual: "Sürükleme. Sürüklemeyi iptal etmek için tıklayın.",
          insertAfter: e => `${e.itemText}’den sonra gir`,
          insertBefore: e => `${e.itemText}’den önce gir`,
          insertBetween: e => `${e.beforeItemText} ve ${e.afterItemText} arasına gir`
        };
        var _o;
        _o = {
          dragDescriptionKeyboard: "Натисніть Enter, щоб почати перетягування.",
          dragDescriptionKeyboardAlt: "Натисніть Alt + Enter, щоб почати перетягування.",
          dragDescriptionLongPress: "Натисніть і утримуйте, щоб почати перетягування.",
          dragDescriptionTouch: "Натисніть двічі, щоб почати перетягування.",
          dragDescriptionVirtual: "Натисніть, щоб почати перетягування.",
          dragItem: e => `Перетягнути ${e.itemText}`,
          dragSelectedItems: (e, t) => `Перетягніть ${t.plural(e.count, {
            one: () => `${t.number(e.count)} вибраний елемент`,
            other: () => `${t.number(e.count)} вибраних елем`
          })}`,
          dragSelectedKeyboard: (e, t) => `Натисніть Enter, щоб перетягнути ${t.plural(e.count, {
            one: () => `${t.number(e.count)} вибраний елемент`,
            other: () => `${t.number(e.count)} вибраних елементи(-ів)`
          })}.`,
          dragSelectedKeyboardAlt: (e, t) => `Натисніть Alt + Enter, щоб перетягнути ${t.plural(e.count, {
            one: () => `${t.number(e.count)} вибраний елемент`,
            other: () => `${t.number(e.count)} вибраних елементи(-ів)`
          })}.`,
          dragSelectedLongPress: (e, t) => `Утримуйте, щоб перетягнути ${t.plural(e.count, {
            one: () => `${t.number(e.count)} вибраний елемент`,
            other: () => `${t.number(e.count)} вибраних елементи(-ів)`
          })}.`,
          dragStartedKeyboard: "Перетягування почалося. Натисніть Tab, щоб перейти до цілі перетягування, потім натисніть Enter, щоб перетягнути, або Escape, щоб скасувати.",
          dragStartedTouch: "Перетягування почалося. Перейдіть до цілі перетягування, потім натисніть двічі, щоб перетягнути.",
          dragStartedVirtual: "Перетягування почалося. Перейдіть до цілі перетягування, потім натисніть Enter, щоб перетягнути.",
          dropCanceled: "Перетягування скасовано.",
          dropComplete: "Перетягування завершено.",
          dropDescriptionKeyboard: "Натисніть Enter, щоб перетягнути. Натисніть Escape, щоб скасувати перетягування.",
          dropDescriptionTouch: "Натисніть двічі, щоб перетягнути.",
          dropDescriptionVirtual: "Натисніть, щоб перетягнути.",
          dropIndicator: "індикатор перетягування",
          dropOnItem: e => `Перетягнути на ${e.itemText}`,
          dropOnRoot: "Перетягнути на",
          endDragKeyboard: "Триває перетягування. Натисніть Enter, щоб скасувати перетягування.",
          endDragTouch: "Триває перетягування. Натисніть двічі, щоб скасувати перетягування.",
          endDragVirtual: "Триває перетягування. Натисніть, щоб скасувати перетягування.",
          insertAfter: e => `Вставити після ${e.itemText}`,
          insertBefore: e => `Вставити перед ${e.itemText}`,
          insertBetween: e => `Вставити між ${e.beforeItemText} і ${e.afterItemText}`
        };
        var Po;
        Po = {
          dragDescriptionKeyboard: "按 Enter 开始拖动。",
          dragDescriptionKeyboardAlt: "按 Alt + Enter 开始拖动。",
          dragDescriptionLongPress: "长按以开始拖动。",
          dragDescriptionTouch: "双击开始拖动。",
          dragDescriptionVirtual: "单击开始拖动。",
          dragItem: e => `拖动 ${e.itemText}`,
          dragSelectedItems: (e, t) => `拖动 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 选中项目`,
            other: () => `${t.number(e.count)} 选中项目`
          })}`,
          dragSelectedKeyboard: (e, t) => `按 Enter 以拖动 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 个选定项`,
            other: () => `${t.number(e.count)} 个选定项`
          })}。`,
          dragSelectedKeyboardAlt: (e, t) => `按 Alt + Enter 以拖动 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 个选定项`,
            other: () => `${t.number(e.count)} 个选定项`
          })}。`,
          dragSelectedLongPress: (e, t) => `长按以拖动 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 个选定项`,
            other: () => `${t.number(e.count)} 个选定项`
          })}。`,
          dragStartedKeyboard: "已开始拖动。按 Tab 导航到放置目标，然后按 Enter 放置或按 Escape 取消。",
          dragStartedTouch: "已开始拖动。导航到放置目标，然后双击放置。",
          dragStartedVirtual: "已开始拖动。导航到放置目标，然后单击或按 Enter 放置。",
          dropCanceled: "放置已取消。",
          dropComplete: "放置已完成。",
          dropDescriptionKeyboard: "按 Enter 放置。按 Escape 取消拖动。",
          dropDescriptionTouch: "双击放置。",
          dropDescriptionVirtual: "单击放置。",
          dropIndicator: "放置标记",
          dropOnItem: e => `放置于 ${e.itemText}`,
          dropOnRoot: "放置于",
          endDragKeyboard: "正在拖动。按 Enter 取消拖动。",
          endDragTouch: "正在拖动。双击取消拖动。",
          endDragVirtual: "正在拖动。单击取消拖动。",
          insertAfter: e => `插入到 ${e.itemText} 之后`,
          insertBefore: e => `插入到 ${e.itemText} 之前`,
          insertBetween: e => `插入到 ${e.beforeItemText} 和 ${e.afterItemText} 之间`
        };
        var ko, Ao, zo;
        function To(e) {
          return e && e.__esModule ? e.default : e;
        }
        ko = {
          dragDescriptionKeyboard: "按 Enter 鍵以開始拖曳。",
          dragDescriptionKeyboardAlt: "按 Alt+Enter 鍵以開始拖曳。",
          dragDescriptionLongPress: "長按以開始拖曳。",
          dragDescriptionTouch: "輕點兩下以開始拖曳。",
          dragDescriptionVirtual: "按一下滑鼠以開始拖曳。",
          dragItem: e => `拖曳「${e.itemText}」`,
          dragSelectedItems: (e, t) => `拖曳 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 個選定項目`,
            other: () => `${t.number(e.count)} 個選定項目`
          })}`,
          dragSelectedKeyboard: (e, t) => `按 Enter 鍵以拖曳 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 個選定項目`,
            other: () => `${t.number(e.count)} 個選定項目`
          })}。`,
          dragSelectedKeyboardAlt: (e, t) => `按 Alt+Enter 鍵以拖曳 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 個選定項目`,
            other: () => `${t.number(e.count)} 個選定項目`
          })}。`,
          dragSelectedLongPress: (e, t) => `長按以拖曳 ${t.plural(e.count, {
            one: () => `${t.number(e.count)} 個選定項目`,
            other: () => `${t.number(e.count)} 個選定項目`
          })}。`,
          dragStartedKeyboard: "已開始拖曳。按 Tab 鍵以瀏覽至放置目標，然後按 Enter 鍵以放置，或按 Escape 鍵以取消。",
          dragStartedTouch: "已開始拖曳。瀏覽至放置目標，然後輕點兩下以放置。",
          dragStartedVirtual: "已開始拖曳。瀏覽至放置目標，然後按一下滑鼠或按 Enter 鍵以放置。",
          dropCanceled: "放置已取消。",
          dropComplete: "放置已完成。",
          dropDescriptionKeyboard: "按 Enter 鍵以放置。按 Escape 鍵以取消拖曳。",
          dropDescriptionTouch: "輕點兩下以放置。",
          dropDescriptionVirtual: "按一下滑鼠以放置。",
          dropIndicator: "放置指示器",
          dropOnItem: e => `放置在「${e.itemText}」上`,
          dropOnRoot: "放置在",
          endDragKeyboard: "拖曳中。按 Enter 鍵以取消拖曳。",
          endDragTouch: "拖曳中。輕點兩下以取消拖曳。",
          endDragVirtual: "拖曳中。按一下滑鼠以取消拖曳。",
          insertAfter: e => `插入至「${e.itemText}」之後`,
          insertBefore: e => `插入至「${e.itemText}」之前`,
          insertBetween: e => `插入至「${e.beforeItemText}」和「${e.afterItemText}」之間`
        }, (zo = Ao || (Ao = {}))[zo.none = 0] = "none", zo[zo.cancel = 0] = "cancel", zo[zo.move = 1] = "move", zo[zo.copy = 2] = "copy", zo[zo.link = 4] = "link", zo[zo.all = 7] = "all";
        const Oo = {
            ...Ao,
            copyMove: 3,
            copyLink: 6,
            linkMove: 5,
            all: 7,
            uninitialized: 7
          },
          Io = Ro(Oo);
        Io[7] = "all";
        Ro(Ao);
        const Fo = {
            none: "cancel",
            link: "link",
            copy: "copy",
            move: "move"
          },
          Mo = Ro(Fo);
        function Ro(e) {
          let t = {};
          for (let n in e) t[e[n]] = n;
          return t;
        }
        const jo = new Set(["text/plain", "text/uri-list", "text/html"]),
          Bo = "application/vnd.react-aria.items+json",
          No = "application/octet-stream",
          Lo = new WeakMap(),
          Vo = Symbol();
        function Ko(e) {
          let {
            id: t
          } = Lo.get(e);
          if (!t) throw new Error("Droppable item outside a droppable collection");
          return t;
        }
        function qo(e) {
          let {
            ref: t
          } = Lo.get(e);
          if (!t) throw new Error("Droppable item outside a droppable collection");
          return t;
        }
        function Ho(e) {
          let t = new Set();
          for (let n of e) for (let e of Object.keys(n)) t.add(e);
          return t;
        }
        function Uo(e) {
          return e || (e = "virtual"), "pointer" === e && (e = "virtual"), "virtual" === e && "undefined" != typeof window && "ontouchstart" in window && (e = "touch"), e;
        }
        function Zo() {
          return Uo((0, N.Kf)());
        }
        function $o() {
          return Uo((0, N.Jz)());
        }
        function Go(e, t) {
          let n = new Map(),
            r = !1,
            o = [];
          for (let e of t) {
            let t = Object.keys(e);
            t.length > 1 && (r = !0);
            let i = {};
            for (let o of t) {
              let t = n.get(o);
              t ? r = !0 : (t = [], n.set(o, t));
              let a = e[o];
              i[o] = a, t.push(a);
            }
            o.push(i);
          }
          for (let [t, r] of n) if (jo.has(t)) {
            let n = r.join("\n");
            e.items.add(n, t);
          } else e.items.add(r[0], t);
          if (r) {
            let t = JSON.stringify(o);
            e.items.add(t, Bo);
          }
        }
        class Wo {
          has(e) {
            return !!(this.includesUnknownTypes || e === Vo && this.types.has(No)) || "string" == typeof e && this.types.has(e);
          }
          constructor(e) {
            this.types = new Set();
            let t = !1;
            for (let n of e.items) n.type !== Bo && ("file" === n.kind && (t = !0), n.type ? this.types.add(n.type) : this.types.add(No));
            this.includesUnknownTypes = !t && e.types.includes("Files");
          }
        }
        function Yo(e) {
          let t = [],
            n = !1;
          if (e.types.includes(Bo)) try {
            let r = e.getData(Bo),
              o = JSON.parse(r);
            for (let e of o) t.push({
              kind: "text",
              types: new Set(Object.keys(e)),
              getText: t => Promise.resolve(e[t])
            });
            n = !0;
          } catch (e) {}
          if (!n) {
            let n = new Map();
            for (let r of e.items) if ("string" === r.kind) n.set(r.type || No, e.getData(r.type));else if ("file" === r.kind) if ("function" == typeof r.webkitGetAsEntry) {
              let e = r.webkitGetAsEntry();
              if (!e) continue;
              e.isFile ? t.push(Xo(r.getAsFile())) : e.isDirectory && t.push(Qo(e));
            } else t.push(Xo(r.getAsFile()));
            n.size > 0 && t.push({
              kind: "text",
              types: new Set(n.keys()),
              getText: e => Promise.resolve(n.get(e))
            });
          }
          return t;
        }
        function Xo(e) {
          return {
            kind: "file",
            type: e.type || No,
            name: e.name,
            getText: () => {
              return "function" == typeof (t = e).text ? t.text() : new Promise((e, n) => {
                let r = new FileReader();
                r.onload = () => {
                  e(r.result);
                }, r.onerror = n, r.readAsText(t);
              });
              var t;
            },
            getFile: () => Promise.resolve(e)
          };
        }
        function Qo(e) {
          return {
            kind: "directory",
            name: e.name,
            getEntries: () => async function* (e) {
              let t,
                n = e.createReader();
              do {
                t = await new Promise((e, t) => {
                  n.readEntries(e, t);
                });
                for (let e of t) if (e.isFile) {
                  let t = await Jo(e);
                  yield Xo(t);
                } else e.isDirectory && (yield Qo(e));
              } while (t.length > 0);
            }(e)
          };
        }
        function Jo(e) {
          return new Promise((t, n) => e.file(t, n));
        }
        let ei,
          ti = {
            draggingKeys: new Set()
          };
        function ni(e) {
          ti.draggingCollectionRef = e;
        }
        function ri(e) {
          ti.dropCollectionRef = e;
        }
        function oi() {
          ti = {
            draggingKeys: new Set()
          };
        }
        function ii(e) {
          ti = e;
        }
        function ai(e) {
          let {
            draggingCollectionRef: t,
            dropCollectionRef: n
          } = ti;
          return null != (null == t ? void 0 : t.current) && t.current === ((null == e ? void 0 : e.current) || (null == n ? void 0 : n.current));
        }
        function si(e) {
          ei = e;
        }
        let li = Ao.none;
        function ui(e) {
          li = e;
        }
        let ci = new Map(),
          di = new Map(),
          pi = null,
          hi = new Set();
        function fi(e) {
          return ci.set(e.element, e), null == pi || pi.updateValidDropTargets(), () => {
            ci.delete(e.element), null == pi || pi.updateValidDropTargets();
          };
        }
        function mi() {
          let [e, t] = (0, Ee.useState)(pi);
          return (0, Ee.useEffect)(() => {
            let e = () => t(pi);
            return hi.add(e), () => {
              hi.delete(e);
            };
          }, []), e;
        }
        const gi = ["pointerdown", "pointermove", "pointerenter", "pointerleave", "pointerover", "pointerout", "pointerup", "mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "touchstart", "touchmove", "touchend", "focusin", "focusout"],
          vi = ["pointerup", "mouseup", "touchend"],
          yi = {
            keyboard: "dragStartedKeyboard",
            touch: "dragStartedTouch",
            virtual: "dragStartedVirtual"
          };
        class bi {
          setup() {
            document.addEventListener("keydown", this.onKeyDown, !0), document.addEventListener("keyup", this.onKeyUp, !0), window.addEventListener("focus", this.onFocus, !0), window.addEventListener("blur", this.onBlur, !0), document.addEventListener("click", this.onClick, !0), document.addEventListener("pointerdown", this.onPointerDown, !0);
            for (let e of gi) document.addEventListener(e, this.cancelEvent, !0);
            this.mutationObserver = new MutationObserver(() => this.updateValidDropTargets()), this.updateValidDropTargets(), (0, Se.xQ)(this.stringFormatter.format(yi[$o()]));
          }
          teardown() {
            document.removeEventListener("keydown", this.onKeyDown, !0), document.removeEventListener("keyup", this.onKeyUp, !0), window.removeEventListener("focus", this.onFocus, !0), window.removeEventListener("blur", this.onBlur, !0), document.removeEventListener("click", this.onClick, !0), document.removeEventListener("pointerdown", this.onPointerDown, !0);
            for (let e of gi) document.removeEventListener(e, this.cancelEvent, !0);
            this.mutationObserver.disconnect(), this.restoreAriaHidden();
          }
          onKeyDown(e) {
            var t;
            this.cancelEvent(e), "Escape" !== e.key ? ("Tab" !== e.key || e.metaKey || e.altKey || e.ctrlKey || (e.shiftKey ? this.previous() : this.next()), "function" == typeof (null === (t = this.currentDropTarget) || void 0 === t ? void 0 : t.onKeyDown) && this.currentDropTarget.onKeyDown(e, this.dragTarget)) : this.cancel();
          }
          onKeyUp(e) {
            this.cancelEvent(e), "Enter" === e.key && (e.altKey ? this.activate() : this.drop());
          }
          onFocus(e) {
            if (e.target !== this.dragTarget.element && this.cancelEvent(e), !(e.target instanceof HTMLElement) || e.target === this.dragTarget.element) return;
            let t = this.validDropTargets.find(t => t.element === e.target) || this.validDropTargets.find(t => t.element.contains(e.target));
            if (!t) return void (this.currentDropTarget ? this.currentDropTarget.element.focus() : this.dragTarget.element.focus());
            let n = di.get(e.target);
            this.setCurrentDropTarget(t, n);
          }
          onBlur(e) {
            e.target !== this.dragTarget.element && this.cancelEvent(e), e.relatedTarget && e.relatedTarget instanceof HTMLElement || (this.currentDropTarget ? this.currentDropTarget.element.focus() : this.dragTarget.element.focus());
          }
          onClick(e) {
            if (this.cancelEvent(e), (0, j.Zj)(e) || this.isVirtualClick) {
              if (e.target === this.dragTarget.element) return void this.cancel();
              let t = this.validDropTargets.find(t => t.element.contains(e.target));
              if (t) {
                let n = di.get(e.target);
                this.setCurrentDropTarget(t, n), this.drop(n);
              }
            }
          }
          onPointerDown(e) {
            this.cancelEvent(e), this.isVirtualClick = (0, j.cr)(e);
          }
          cancelEvent(e) {
            var t;
            ("focusin" !== e.type && "focusout" !== e.type || e.target !== (null === (t = this.dragTarget) || void 0 === t ? void 0 : t.element)) && (vi.includes(e.type) || e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation());
          }
          updateValidDropTargets() {
            if (!this.mutationObserver) return;
            if (this.mutationObserver.disconnect(), this.restoreAriaHidden && this.restoreAriaHidden(), this.validDropTargets = function (e) {
              let t = Ho(e.items);
              return [...ci.values()].filter(n => !n.element.closest('[aria-hidden="true"]') && ("function" != typeof n.getDropOperation || "cancel" !== n.getDropOperation(t, e.allowedDropOperations)));
            }(this.dragTarget), this.validDropTargets.length > 0) {
              let e = this.findNearestDropTarget();
              this.validDropTargets = [...this.validDropTargets.slice(e), ...this.validDropTargets.slice(0, e)];
            }
            this.currentDropTarget && !this.validDropTargets.includes(this.currentDropTarget) && this.setCurrentDropTarget(this.validDropTargets[0]);
            let e = Ho(this.dragTarget.items),
              t = [...di.values()].filter(t => "function" != typeof t.getDropOperation || "cancel" !== t.getDropOperation(e, this.dragTarget.allowedDropOperations)),
              n = this.validDropTargets.filter(e => !t.some(t => e.element.contains(t.element)));
            this.restoreAriaHidden = Fn([this.dragTarget.element, ...t.map(e => e.element), ...n.map(e => e.element)]), this.mutationObserver.observe(document.body, {
              subtree: !0,
              attributes: !0,
              attributeFilter: ["aria-hidden"]
            });
          }
          next() {
            if (!this.currentDropTarget) return void this.setCurrentDropTarget(this.validDropTargets[0]);
            let e = this.validDropTargets.indexOf(this.currentDropTarget);
            e < 0 ? this.setCurrentDropTarget(this.validDropTargets[0]) : e === this.validDropTargets.length - 1 ? this.dragTarget.element.closest('[aria-hidden="true"]') ? this.setCurrentDropTarget(this.validDropTargets[0]) : (this.setCurrentDropTarget(null), this.dragTarget.element.focus()) : this.setCurrentDropTarget(this.validDropTargets[e + 1]);
          }
          previous() {
            if (!this.currentDropTarget) return void this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]);
            let e = this.validDropTargets.indexOf(this.currentDropTarget);
            e < 0 ? this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]) : 0 === e ? this.dragTarget.element.closest('[aria-hidden="true"]') ? this.setCurrentDropTarget(this.validDropTargets[this.validDropTargets.length - 1]) : (this.setCurrentDropTarget(null), this.dragTarget.element.focus()) : this.setCurrentDropTarget(this.validDropTargets[e - 1]);
          }
          findNearestDropTarget() {
            let e = this.dragTarget.element.getBoundingClientRect(),
              t = 1 / 0,
              n = -1;
            for (let r = 0; r < this.validDropTargets.length; r++) {
              let o = this.validDropTargets[r].element.getBoundingClientRect(),
                i = o.left - e.left,
                a = o.top - e.top,
                s = i * i + a * a;
              s < t && (t = s, n = r);
            }
            return n;
          }
          setCurrentDropTarget(e, t) {
            if (e !== this.currentDropTarget) {
              if (this.currentDropTarget && "function" == typeof this.currentDropTarget.onDropExit) {
                let e = this.currentDropTarget.element.getBoundingClientRect();
                this.currentDropTarget.onDropExit({
                  type: "dropexit",
                  x: e.left + e.width / 2,
                  y: e.top + e.height / 2
                });
              }
              if (this.currentDropTarget = e, e) {
                if ("function" == typeof e.onDropEnter) {
                  let t = e.element.getBoundingClientRect();
                  e.onDropEnter({
                    type: "dropenter",
                    x: t.left + t.width / 2,
                    y: t.top + t.height / 2
                  }, this.dragTarget);
                }
                t || null == e || e.element.focus();
              }
            }
            t !== this.currentDropItem && (t && "function" == typeof this.currentDropTarget.onDropTargetEnter && this.currentDropTarget.onDropTargetEnter(null == t ? void 0 : t.target), null == t || t.element.focus(), this.currentDropItem = t, this.initialFocused || ((0, Se.xQ)(null == t ? void 0 : t.element.getAttribute("aria-label"), "polite"), this.initialFocused = !0));
          }
          end() {
            if (this.teardown(), function () {
              pi = null;
              for (let e of hi) e();
            }(), "function" == typeof this.dragTarget.onDragEnd) {
              let e = (this.currentDropTarget && "cancel" !== this.dropOperation ? this.currentDropTarget : this.dragTarget).element.getBoundingClientRect();
              this.dragTarget.onDragEnd({
                type: "dragend",
                x: e.x + e.width / 2,
                y: e.y + e.height / 2,
                dropOperation: this.dropOperation || "cancel"
              });
            }
            this.currentDropTarget && (this.dragTarget.element.contains(this.currentDropTarget.element) || (this.dragTarget.element.dispatchEvent(new FocusEvent("blur")), this.dragTarget.element.dispatchEvent(new FocusEvent("focusout", {
              bubbles: !0
            }))), (0, Ut.flushSync)(() => {
              this.currentDropTarget.element.blur();
            }), this.currentDropTarget.element.focus()), this.setCurrentDropTarget(null);
          }
          cancel() {
            this.setCurrentDropTarget(null), this.end(), this.dragTarget.element.closest('[aria-hidden="true"]') || this.dragTarget.element.focus(), (0, Se.xQ)(this.stringFormatter.format("dropCanceled"));
          }
          drop(e) {
            if (this.currentDropTarget) {
              if ("function" == typeof (null == e ? void 0 : e.getDropOperation)) {
                let t = Ho(this.dragTarget.items);
                this.dropOperation = e.getDropOperation(t, this.dragTarget.allowedDropOperations);
              } else if ("function" == typeof this.currentDropTarget.getDropOperation) {
                let e = Ho(this.dragTarget.items);
                this.dropOperation = this.currentDropTarget.getDropOperation(e, this.dragTarget.allowedDropOperations);
              } else this.dropOperation = this.dragTarget.allowedDropOperations[0];
              if ("function" == typeof this.currentDropTarget.onDrop) {
                let t = this.dragTarget.items.map(e => ({
                    kind: "text",
                    types: new Set(Object.keys(e)),
                    getText: t => Promise.resolve(e[t])
                  })),
                  n = this.currentDropTarget.element.getBoundingClientRect();
                this.currentDropTarget.onDrop({
                  type: "drop",
                  x: n.left + n.width / 2,
                  y: n.top + n.height / 2,
                  items: t,
                  dropOperation: this.dropOperation
                }, null == e ? void 0 : e.target);
              }
              this.end(), (0, Se.xQ)(this.stringFormatter.format("dropComplete"));
            } else this.cancel();
          }
          activate() {
            if (this.currentDropTarget && "function" == typeof this.currentDropTarget.onDropActivate) {
              let e = this.currentDropTarget.element.getBoundingClientRect();
              this.currentDropTarget.onDropActivate({
                type: "dropactivate",
                x: e.left + e.width / 2,
                y: e.top + e.height / 2
              });
            }
          }
          constructor(e, t) {
            this.dragTarget = e, this.stringFormatter = t, this.onKeyDown = this.onKeyDown.bind(this), this.onKeyUp = this.onKeyUp.bind(this), this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this), this.onClick = this.onClick.bind(this), this.onPointerDown = this.onPointerDown.bind(this), this.cancelEvent = this.cancelEvent.bind(this), this.initialFocused = !1;
          }
        }
        var wi;
        wi = {
          "ar-AE": Gr,
          "bg-BG": Wr,
          "cs-CZ": Yr,
          "da-DK": Xr,
          "de-DE": Qr,
          "el-GR": Jr,
          "en-US": eo,
          "es-ES": to,
          "et-EE": no,
          "fi-FI": ro,
          "fr-FR": oo,
          "he-IL": io,
          "hr-HR": ao,
          "hu-HU": so,
          "it-IT": lo,
          "ja-JP": uo,
          "ko-KR": co,
          "lt-LT": po,
          "lv-LV": ho,
          "nb-NO": fo,
          "nl-NL": mo,
          "pl-PL": go,
          "pt-BR": vo,
          "pt-PT": yo,
          "ro-RO": bo,
          "ru-RU": wo,
          "sk-SK": xo,
          "sl-SI": Do,
          "sr-SP": Co,
          "sv-SE": So,
          "tr-TR": Eo,
          "uk-UA": _o,
          "zh-CN": Po,
          "zh-TW": ko
        };
        const xi = {
          keyboard: {
            start: "dragDescriptionKeyboard",
            end: "endDragKeyboard"
          },
          touch: {
            start: "dragDescriptionTouch",
            end: "endDragTouch"
          },
          virtual: {
            start: "dragDescriptionVirtual",
            end: "endDragVirtual"
          }
        };
        function Di(e) {
          let {
              hasDragButton: t
            } = e,
            n = (0, V.qb)(To(wi), "@react-aria/dnd"),
            r = (0, Ee.useRef)({
              options: e,
              x: 0,
              y: 0
            }).current;
          r.options = e;
          let o = (0, Ee.useRef)(!1),
            [i, a] = (0, Ee.useState)(!1),
            s = e => {
              o.current = e, a(e);
            },
            {
              addGlobalListener: l,
              removeAllGlobalListeners: u
            } = (0, j.xi)(),
            c = (0, Ee.useRef)(null);
          (0, j.bt)(() => () => {
            if (o.current) {
              if ("function" == typeof r.options.onDragEnd) {
                let e = {
                  type: "dragend",
                  x: 0,
                  y: 0,
                  dropOperation: Fo[ei || "none"]
                };
                r.options.onDragEnd(e);
              }
              s(!1), ui(Ao.none), si(void 0);
            }
          }, [r]);
          let d,
            p = e => {
              if ("function" == typeof r.options.onDragStart) {
                let t = e.getBoundingClientRect();
                r.options.onDragStart({
                  type: "dragstart",
                  x: t.x + t.width / 2,
                  y: t.y + t.height / 2
                });
              }
              !function (e, t) {
                if (pi) throw new Error("Cannot begin dragging while already dragging");
                pi = new bi(e, t), requestAnimationFrame(() => {
                  pi.setup(), "keyboard" === $o() && pi.next();
                });
                for (let e of hi) e();
              }({
                element: e,
                items: r.options.getItems(),
                allowedDropOperations: "function" == typeof r.options.getAllowedDropOperations ? r.options.getAllowedDropOperations() : ["move", "copy", "link"],
                onDragEnd(e) {
                  s(!1), "function" == typeof r.options.onDragEnd && r.options.onDragEnd(e);
                }
              }, n), s(!0);
            },
            h = Zo(),
            f = i ? xi[h].end : xi[h].start,
            m = (0, j.PK)(n.format(f));
          return t || (d = {
            ...m,
            onPointerDown(e) {
              if (c.current = (0, j.cr)(e.nativeEvent) ? "virtual" : e.pointerType, e.width < 1 && e.height < 1) c.current = "virtual";else {
                let t = e.currentTarget.getBoundingClientRect(),
                  n = e.clientX - t.x,
                  r = e.clientY - t.y,
                  o = t.width / 2,
                  i = t.height / 2;
                Math.abs(n - o) <= .5 && Math.abs(r - i) <= .5 ? c.current = "virtual" : c.current = e.pointerType;
              }
            },
            onKeyDownCapture(e) {
              e.target === e.currentTarget && "Enter" === e.key && (e.preventDefault(), e.stopPropagation());
            },
            onKeyUpCapture(e) {
              e.target === e.currentTarget && "Enter" === e.key && (e.preventDefault(), e.stopPropagation(), p(e.target));
            },
            onClick(e) {
              ((0, j.Zj)(e.nativeEvent) || "virtual" === c.current) && (e.preventDefault(), e.stopPropagation(), p(e.target));
            }
          }), {
            dragProps: {
              ...d,
              draggable: "true",
              onDragStart: t => {
                var n;
                if (t.defaultPrevented) return;
                if (t.stopPropagation(), "virtual" === c.current) return t.preventDefault(), p(t.target), void (c.current = null);
                "function" == typeof e.onDragStart && e.onDragStart({
                  type: "dragstart",
                  x: t.clientX,
                  y: t.clientY
                });
                let o = e.getItems();
                Go(t.dataTransfer, o);
                let i = Ao.all;
                if ("function" == typeof e.getAllowedDropOperations) {
                  let t = e.getAllowedDropOperations();
                  i = Ao.none;
                  for (let e of t) i |= Ao[e] || Ao.none;
                }
                ui(i), t.dataTransfer.effectAllowed = Io[i] || "none", "function" == typeof (null === (n = e.preview) || void 0 === n ? void 0 : n.current) && e.preview.current(o, e => {
                  let n = e.getBoundingClientRect(),
                    r = t.currentTarget.getBoundingClientRect(),
                    o = t.clientX - r.x,
                    i = t.clientY - r.y;
                  (o > n.width || i > n.height) && (o = n.width / 2, i = n.height / 2);
                  let a = 2 * Math.round(n.height / 2);
                  e.style.height = `${a}px`, t.dataTransfer.setDragImage(e, o, i);
                }), l(window, "drop", e => {
                  e.preventDefault(), e.stopPropagation(), console.warn("Drags initiated from the React Aria useDrag hook may only be dropped on a target created with useDrop. This ensures that a keyboard and screen reader accessible alternative is available.");
                }, {
                  once: !0
                }), r.x = t.clientX, r.y = t.clientY, requestAnimationFrame(() => {
                  s(!0);
                });
              },
              onDrag: t => {
                t.stopPropagation(), t.clientX === r.x && t.clientY === r.y || ("function" == typeof e.onDragMove && e.onDragMove({
                  type: "dragmove",
                  x: t.clientX,
                  y: t.clientY
                }), r.x = t.clientX, r.y = t.clientY);
              },
              onDragEnd: t => {
                if (t.stopPropagation(), "function" == typeof e.onDragEnd) {
                  let n = {
                    type: "dragend",
                    x: t.clientX,
                    y: t.clientY,
                    dropOperation: Fo[t.dataTransfer.dropEffect]
                  };
                  ei && (n.dropOperation = Fo[ei]), e.onDragEnd(n);
                }
                s(!1), u(), ui(Ao.none), si(void 0);
              }
            },
            dragButtonProps: {
              ...m,
              onPress: e => {
                "keyboard" !== e.pointerType && "virtual" !== e.pointerType || p(e.target);
              }
            },
            isDragging: i
          };
        }
        const Ci = {
          keyboard: "dropDescriptionKeyboard",
          touch: "dropDescriptionTouch",
          virtual: "dropDescriptionVirtual"
        };
        function Si() {
          let e = (0, V.qb)(To(wi), "@react-aria/dnd"),
            t = Zo(),
            n = mi();
          return {
            dropProps: {
              ...(0, j.PK)(n ? e.format(Ci[t]) : ""),
              onClick: () => {}
            }
          };
        }
        function Ei(e) {
          let {
              hasDropButton: t
            } = e,
            [n, r] = (0, Ee.useState)(!1),
            o = (0, Ee.useRef)({
              x: 0,
              y: 0,
              dragOverElements: new Set(),
              dropEffect: "none",
              allowedOperations: Ao.all,
              dropActivateTimer: null
            }).current,
            i = t => {
              if (r(!0), "function" == typeof e.onDropEnter) {
                let n = t.currentTarget.getBoundingClientRect();
                e.onDropEnter({
                  type: "dropenter",
                  x: t.clientX - n.x,
                  y: t.clientY - n.y
                });
              }
            },
            a = t => {
              if (r(!1), "function" == typeof e.onDropExit) {
                let n = t.currentTarget.getBoundingClientRect();
                e.onDropExit({
                  type: "dropexit",
                  x: t.clientX - n.x,
                  y: t.clientY - n.y
                });
              }
            },
            s = (0, j.iW)(t => {
              "function" == typeof e.onDropEnter && e.onDropEnter(t);
            }),
            l = (0, j.iW)(t => {
              "function" == typeof e.onDropExit && e.onDropExit(t);
            }),
            u = (0, j.iW)(t => {
              "function" == typeof e.onDropActivate && e.onDropActivate(t);
            }),
            c = (0, j.iW)(t => {
              "function" == typeof e.onDrop && e.onDrop(t);
            }),
            d = (0, j.iW)((t, n) => e.getDropOperation ? e.getDropOperation(t, n) : n[0]),
            {
              ref: p
            } = e;
          (0, j.bt)(() => fi({
            element: p.current,
            getDropOperation: d,
            onDropEnter(e) {
              r(!0), s(e);
            },
            onDropExit(e) {
              r(!1), l(e);
            },
            onDrop: c,
            onDropActivate: u
          }), [p, d, s, l, c, u]);
          let {
            dropProps: h
          } = Si();
          return {
            dropProps: {
              ...(!t && h),
              onDragEnter: t => {
                if (t.preventDefault(), t.stopPropagation(), o.dragOverElements.add(t.target), o.dragOverElements.size > 1) return;
                let n = _i(t),
                  r = Pi(n),
                  a = r[0];
                if ("function" == typeof e.getDropOperation) {
                  let o = new Wo(t.dataTransfer);
                  a = ki(n, e.getDropOperation(o, r));
                }
                if ("function" == typeof e.getDropOperationForPoint) {
                  let o = new Wo(t.dataTransfer),
                    i = t.currentTarget.getBoundingClientRect();
                  a = ki(n, e.getDropOperationForPoint(o, r, t.clientX - i.x, t.clientY - i.y));
                }
                o.x = t.clientX, o.y = t.clientY, o.allowedOperations = n, o.dropEffect = Mo[a] || "none", t.dataTransfer.dropEffect = o.dropEffect, "cancel" !== a && i(t);
              },
              onDragOver: t => {
                t.preventDefault(), t.stopPropagation();
                let n = _i(t);
                if (t.clientX === o.x && t.clientY === o.y && n === o.allowedOperations) return void (t.dataTransfer.dropEffect = o.dropEffect);
                o.x = t.clientX, o.y = t.clientY;
                let r = o.dropEffect;
                if (n !== o.allowedOperations) {
                  let r = Pi(n),
                    i = r[0];
                  if ("function" == typeof e.getDropOperation) {
                    let o = new Wo(t.dataTransfer);
                    i = ki(n, e.getDropOperation(o, r));
                  }
                  o.dropEffect = Mo[i] || "none";
                }
                if ("function" == typeof e.getDropOperationForPoint) {
                  let r = new Wo(t.dataTransfer),
                    i = t.currentTarget.getBoundingClientRect(),
                    a = ki(n, e.getDropOperationForPoint(r, Pi(n), o.x - i.x, o.y - i.y));
                  o.dropEffect = Mo[a] || "none";
                }
                if (o.allowedOperations = n, t.dataTransfer.dropEffect = o.dropEffect, "none" === o.dropEffect && "none" !== r ? a(t) : "none" !== o.dropEffect && "none" === r && i(t), "function" == typeof e.onDropMove && "none" !== o.dropEffect) {
                  let n = t.currentTarget.getBoundingClientRect();
                  e.onDropMove({
                    type: "dropmove",
                    x: o.x - n.x,
                    y: o.y - n.y
                  });
                }
                if (clearTimeout(o.dropActivateTimer), "function" == typeof e.onDropActivate && "none" !== o.dropEffect) {
                  let n = t.currentTarget.getBoundingClientRect();
                  o.dropActivateTimer = setTimeout(() => {
                    e.onDropActivate({
                      type: "dropactivate",
                      x: o.x - n.x,
                      y: o.y - n.y
                    });
                  }, 800);
                }
              },
              onDragLeave: e => {
                e.preventDefault(), e.stopPropagation(), o.dragOverElements.delete(e.target);
                for (let t of o.dragOverElements) e.currentTarget.contains(t) || o.dragOverElements.delete(t);
                o.dragOverElements.size > 0 || ("none" !== o.dropEffect && a(e), clearTimeout(o.dropActivateTimer));
              },
              onDrop: t => {
                if (t.preventDefault(), t.stopPropagation(), si(o.dropEffect), "function" == typeof e.onDrop) {
                  let n = Fo[o.dropEffect],
                    r = Yo(t.dataTransfer),
                    i = t.currentTarget.getBoundingClientRect(),
                    a = {
                      type: "drop",
                      x: t.clientX - i.x,
                      y: t.clientY - i.y,
                      items: r,
                      dropOperation: n
                    };
                  e.onDrop(a);
                }
                let n = {
                  ...ti
                };
                o.dragOverElements.clear(), a(t), clearTimeout(o.dropActivateTimer), null == n.draggingCollectionRef ? si(void 0) : ii(n);
              }
            },
            dropButtonProps: {
              ...(t && h)
            },
            isDropTarget: n
          };
        }
        function _i(e) {
          let t = Oo[e.dataTransfer.effectAllowed];
          li && (t &= li);
          let n = Ao.none;
          return (0, j.V5)() ? (e.altKey && (n |= Ao.copy), e.ctrlKey && !(0, j.zc)() && (n |= Ao.link), e.metaKey && (n |= Ao.move)) : (e.altKey && (n |= Ao.link), e.shiftKey && (n |= Ao.move), e.ctrlKey && (n |= Ao.copy)), n ? t & n : t;
        }
        function Pi(e) {
          let t = [];
          return e & Ao.move && t.push("move"), e & Ao.copy && t.push("copy"), e & Ao.link && t.push("link"), t;
        }
        function ki(e, t) {
          return e & Ao[t] ? t : "cancel";
        }
        function Ai(e) {
          let t = (0, Ee.useRef)(null),
            n = (0, Ee.useRef)(!0),
            r = (0, Ee.useRef)(!0);
          (0, Ee.useEffect)(() => {
            if (e.current) {
              t.current = (0, j.a9)(e.current) ? e.current : (0, j.rP)(e.current);
              let o = window.getComputedStyle(t.current);
              n.current = /(auto|scroll)/.test(o.overflowX), r.current = /(auto|scroll)/.test(o.overflowY);
            }
          }, [e]);
          let o = (0, Ee.useRef)({
            timer: null,
            dx: 0,
            dy: 0
          }).current;
          (0, Ee.useEffect)(() => () => {
            o.timer && (cancelAnimationFrame(o.timer), o.timer = null);
          }, [o]);
          let i = (0, Ee.useCallback)(() => {
            n.current && (t.current.scrollLeft += o.dx), r.current && (t.current.scrollTop += o.dy), o.timer && (o.timer = requestAnimationFrame(i));
          }, [t, o]);
          return {
            move(e, n) {
              if (!(0, j.Pf)() || (0, j.gn)() || !t.current) return;
              let r = t.current.getBoundingClientRect(),
                a = r.height - 20,
                s = r.width - 20;
              e < 20 || e > s || n < 20 || n > a ? (e < 20 ? o.dx = e - 20 : e > s && (o.dx = e - s), n < 20 ? o.dy = n - 20 : n > a && (o.dy = n - a), o.timer || (o.timer = requestAnimationFrame(i))) : this.stop();
            },
            stop() {
              o.timer && (cancelAnimationFrame(o.timer), o.timer = null);
            }
          };
        }
        const zi = ["before", "on", "after"],
          Ti = ["after", "on", "before"];
        function Oi(e, t, n) {
          let r = (0, Ee.useRef)({
            props: e,
            state: t,
            nextTarget: null,
            dropOperation: null
          }).current;
          r.props = e, r.state = t;
          let o = (0, Ee.useCallback)(async e => {
              let {
                  onInsert: t,
                  onRootDrop: o,
                  onItemDrop: i,
                  onReorder: a,
                  acceptedDragTypes: s = "all",
                  shouldAcceptItemDrop: l
                } = r.props,
                {
                  draggingKeys: u
                } = ti,
                c = ai(n),
                {
                  target: d,
                  dropOperation: p,
                  items: h
                } = e,
                f = h;
              ("all" !== s || l) && (f = h.filter(e => {
                let t;
                return t = "directory" === e.kind ? new Set([Vo]) : "file" === e.kind ? new Set([e.type]) : e.types, !("all" !== s && !s.some(e => t.has(e))) && ("item" !== d.type || "on" !== d.dropPosition || !l || l(d, t));
              })), f.length > 0 && ("root" === d.type && o && (await o({
                items: f,
                dropOperation: p
              })), "item" === d.type && ("on" === d.dropPosition && i && (await i({
                items: f,
                dropOperation: p,
                isInternal: c,
                target: d
              })), "on" !== d.dropPosition && (!c && t && (await t({
                items: f,
                dropOperation: p,
                target: d
              })), c && a && (await a({
                keys: u,
                dropOperation: p,
                target: d
              })))));
            }, [r, n]),
            i = Ai(n),
            {
              dropProps: a
            } = Ei({
              ref: n,
              onDropEnter() {
                t.setTarget(r.nextTarget);
              },
              onDropMove(e) {
                t.setTarget(r.nextTarget), i.move(e.x, e.y);
              },
              getDropOperationForPoint(o, i, a, s) {
                let {
                    draggingKeys: l,
                    dropCollectionRef: u
                  } = ti,
                  c = ai(n),
                  d = e.dropTargetDelegate.getDropTargetFromPoint(a, s, e => "cancel" !== t.getDropOperation({
                    target: e,
                    types: o,
                    allowedOperations: i,
                    isInternal: c,
                    draggingKeys: l
                  }));
                if (!d) return r.dropOperation = "cancel", r.nextTarget = null, "cancel";
                if (r.dropOperation = t.getDropOperation({
                  target: d,
                  types: o,
                  allowedOperations: i,
                  isInternal: c,
                  draggingKeys: l
                }), "cancel" === r.dropOperation) {
                  let e = {
                      type: "root"
                    },
                    n = t.getDropOperation({
                      target: e,
                      types: o,
                      allowedOperations: i,
                      isInternal: c,
                      draggingKeys: l
                    });
                  "cancel" !== n && (d = e, r.dropOperation = n);
                }
                return d && "cancel" !== r.dropOperation && (null == n ? void 0 : n.current) !== (null == u ? void 0 : u.current) && ri(n), r.nextTarget = "cancel" === r.dropOperation ? null : d, r.dropOperation;
              },
              onDropExit() {
                ri(void 0), t.setTarget(null), i.stop();
              },
              onDropActivate(n) {
                var r, o;
                "item" === (null === (r = t.target) || void 0 === r ? void 0 : r.type) && "on" === (null === (o = t.target) || void 0 === o ? void 0 : o.dropPosition) && "function" == typeof e.onDropActivate && e.onDropActivate({
                  type: "dropactivate",
                  x: n.x,
                  y: n.y,
                  target: t.target
                });
              },
              onDrop(e) {
                ri(n), t.target && l(e, t.target);
                let {
                  draggingCollectionRef: r
                } = ti;
                null == r && oi();
              }
            }),
            s = (0, Ee.useRef)(null),
            l = (0, Ee.useCallback)((e, t) => {
              var n;
              let {
                state: i
              } = r;
              i.selectionManager.setFocused(!0);
              let a = i.selectionManager.focusedKey;
              ti.draggingKeys.has(null === (n = i.collection.getItem(a)) || void 0 === n ? void 0 : n.parentKey) && (a = i.collection.getItem(a).parentKey, i.selectionManager.setFocusedKey(a)), s.current = {
                timeout: null,
                focusedKey: a,
                collection: i.collection,
                selectedKeys: i.selectionManager.selectedKeys
              }, (r.props.onDrop || o)({
                type: "drop",
                x: e.x,
                y: e.y,
                target: t,
                items: e.items,
                dropOperation: e.dropOperation
              }), s.current.timeout = setTimeout(() => {
                let {
                  state: e
                } = r;
                "item" === t.type && "on" === t.dropPosition && null != e.collection.getItem(t.key) ? (e.selectionManager.setFocusedKey(t.key), e.selectionManager.setFocused(!0), (0, N._w)("keyboard")) : e.selectionManager.isSelected(a) || (0, N._w)("keyboard"), s.current = null;
              }, 50);
            }, [r, o]);
          (0, Ee.useEffect)(() => () => {
            s.current && clearTimeout(s.current.timeout);
          }, []), (0, j.bt)(() => {
            if (s.current && t.selectionManager.isFocused && t.collection.size > s.current.collection.size && t.selectionManager.isSelectionEqual(s.current.selectedKeys)) {
              let e = new Set();
              for (let n of t.collection.getKeys()) s.current.collection.getItem(n) || e.add(n);
              if (t.selectionManager.setSelectedKeys(e), t.selectionManager.focusedKey === s.current.focusedKey) {
                let n = e.keys().next().value,
                  r = t.collection.getItem(n);
                "cell" === (null == r ? void 0 : r.type) && (n = r.parentKey), t.selectionManager.setFocusedKey(n), "none" === t.selectionManager.selectionMode && (0, N._w)("keyboard");
              }
              s.current = null;
            }
          });
          let {
            direction: u
          } = (0, V.bU)();
          (0, Ee.useEffect)(() => {
            let e = (e, t = !0, n = !1) => {
                if (!e) return {
                  type: "root"
                };
                let o,
                  {
                    keyboardDelegate: i
                  } = r.props;
                o = "item" === (null == e ? void 0 : e.type) ? n ? i.getKeyRightOf(e.key) : i.getKeyBelow(e.key) : n && "rtl" === u ? i.getLastKey() : i.getFirstKey();
                let a = n && "rtl" === u ? Ti : zi,
                  s = a[0];
                if ("item" === e.type) {
                  let t = n && "rtl" === u ? r.state.collection.getKeyBefore(e.key) : r.state.collection.getKeyAfter(e.key);
                  if (null == o || o === t) {
                    let t = a.indexOf(e.dropPosition),
                      n = a[t + 1];
                    if (t < a.length - 1 && (n !== a[2] || null == o)) return {
                      type: "item",
                      key: e.key,
                      dropPosition: n
                    };
                    e.dropPosition === a[2] && (s = "on");
                  } else s = e.dropPosition;
                }
                return null == o ? t ? {
                  type: "root"
                } : null : {
                  type: "item",
                  key: o,
                  dropPosition: s
                };
              },
              t = (e, t = !0, n = !1) => {
                let o,
                  {
                    keyboardDelegate: i
                  } = r.props;
                o = "item" === (null == e ? void 0 : e.type) ? n ? i.getKeyLeftOf(e.key) : i.getKeyAbove(e.key) : n && "rtl" === u ? i.getFirstKey() : i.getLastKey();
                let a = n && "rtl" === u ? Ti : zi,
                  s = e && "root" !== e.type ? "on" : a[2];
                if ("item" === (null == e ? void 0 : e.type)) {
                  let t = n && "rtl" === u ? r.state.collection.getKeyAfter(e.key) : r.state.collection.getKeyBefore(e.key);
                  if (null == o || o === t) {
                    let t = a.indexOf(e.dropPosition),
                      n = a[t - 1];
                    if (t > 0 && n !== a[2]) return {
                      type: "item",
                      key: e.key,
                      dropPosition: n
                    };
                    e.dropPosition === a[0] && (s = "on");
                  } else s = e.dropPosition;
                }
                return null == o ? t ? {
                  type: "root"
                } : null : {
                  type: "item",
                  key: o,
                  dropPosition: s
                };
              },
              o = (e, t, o, i, a = !0) => {
                let s,
                  l = 0,
                  {
                    draggingKeys: u
                  } = ti,
                  c = ai(n);
                do {
                  let n = i(e, a);
                  if (!n) return null;
                  e = n, s = r.state.getDropOperation({
                    target: n,
                    types: t,
                    allowedOperations: o,
                    isInternal: c,
                    draggingKeys: u
                  }), "root" === e.type && l++;
                } while ("cancel" === s && !r.state.isDropTarget(e) && l < 2);
                return "cancel" === s ? null : e;
              };
            return fi({
              element: n.current,
              getDropOperation(t, i) {
                if (r.state.target) {
                  let {
                      draggingKeys: e
                    } = ti,
                    o = ai(n);
                  return r.state.getDropOperation({
                    target: r.state.target,
                    types: t,
                    allowedOperations: i,
                    isInternal: o,
                    draggingKeys: e
                  });
                }
                return o(null, t, i, e) ? "move" : "cancel";
              },
              onDropEnter(i, a) {
                let s,
                  l = Ho(a.items),
                  u = r.state.selectionManager;
                ri(n);
                let c = u.focusedKey,
                  d = "after",
                  p = r.state.collection.getItem(c);
                if ("cell" === (null == p ? void 0 : p.type) && (c = p.parentKey), u.isSelected(c) && (u.selectedKeys.size > 1 && u.firstSelectedKey === c ? d = "before" : c = u.lastSelectedKey), null != c) {
                  s = {
                    type: "item",
                    key: c,
                    dropPosition: d
                  };
                  let {
                      draggingKeys: i
                    } = ti,
                    u = ai(n);
                  var h;
                  "cancel" === r.state.getDropOperation({
                    target: s,
                    types: l,
                    allowedOperations: a.allowedDropOperations,
                    isInternal: u,
                    draggingKeys: i
                  }) && (s = null !== (h = o(s, l, a.allowedDropOperations, e, !1)) && void 0 !== h ? h : o(s, l, a.allowedDropOperations, t, !1));
                }
                s || (s = o(null, l, a.allowedDropOperations, e)), r.state.setTarget(s);
              },
              onDropExit() {
                ri(void 0), r.state.setTarget(null);
              },
              onDropTargetEnter(e) {
                r.state.setTarget(e);
              },
              onDropActivate(e) {
                var t, n;
                "item" === (null === (t = r.state.target) || void 0 === t ? void 0 : t.type) && "on" === (null === (n = r.state.target) || void 0 === n ? void 0 : n.dropPosition) && "function" == typeof r.props.onDropActivate && r.props.onDropActivate({
                  type: "dropactivate",
                  x: e.x,
                  y: e.y,
                  target: r.state.target
                });
              },
              onDrop(e, t) {
                ri(n), r.state.target && l(e, t || r.state.target);
              },
              onKeyDown(i, a) {
                let {
                    keyboardDelegate: s
                  } = r.props,
                  l = Ho(a.items);
                switch (i.key) {
                  case "ArrowDown":
                    if (s.getKeyBelow) {
                      let t = o(r.state.target, l, a.allowedDropOperations, e);
                      r.state.setTarget(t);
                    }
                    break;
                  case "ArrowUp":
                    if (s.getKeyAbove) {
                      let e = o(r.state.target, l, a.allowedDropOperations, t);
                      r.state.setTarget(e);
                    }
                    break;
                  case "ArrowLeft":
                    if (s.getKeyLeftOf) {
                      let e = o(r.state.target, l, a.allowedDropOperations, (e, n) => t(e, n, !0));
                      r.state.setTarget(e);
                    }
                    break;
                  case "ArrowRight":
                    if (s.getKeyRightOf) {
                      let t = o(r.state.target, l, a.allowedDropOperations, (t, n) => e(t, n, !0));
                      r.state.setTarget(t);
                    }
                    break;
                  case "Home":
                    if (s.getFirstKey) {
                      let t = o(null, l, a.allowedDropOperations, e);
                      r.state.setTarget(t);
                    }
                    break;
                  case "End":
                    if (s.getLastKey) {
                      let e = o(null, l, a.allowedDropOperations, t);
                      r.state.setTarget(e);
                    }
                    break;
                  case "PageDown":
                    if (s.getKeyPageBelow) {
                      let i = r.state.target;
                      if (i) {
                        let c = s.getKeyPageBelow("item" === i.type ? i.key : s.getFirstKey()),
                          d = "item" === i.type ? i.dropPosition : "after";
                        (null == c || "item" === i.type && i.key === s.getLastKey()) && (c = s.getLastKey(), d = "after"), i = {
                          type: "item",
                          key: c,
                          dropPosition: d
                        };
                        let {
                            draggingCollectionRef: p,
                            draggingKeys: h
                          } = ti,
                          f = (null == p ? void 0 : p.current) === (null == n ? void 0 : n.current);
                        var u;
                        "cancel" === r.state.getDropOperation({
                          target: i,
                          types: l,
                          allowedOperations: a.allowedDropOperations,
                          isInternal: f,
                          draggingKeys: h
                        }) && (i = null !== (u = o(i, l, a.allowedDropOperations, e, !1)) && void 0 !== u ? u : o(i, l, a.allowedDropOperations, t, !1));
                      } else i = o(null, l, a.allowedDropOperations, e);
                      r.state.setTarget(null != i ? i : r.state.target);
                    }
                    break;
                  case "PageUp":
                    {
                      if (!s.getKeyPageAbove) break;
                      let i = r.state.target;
                      if (i) {
                        if ("item" === i.type) {
                          if (i.key === s.getFirstKey()) i = {
                            type: "root"
                          };else {
                            let e = s.getKeyPageAbove(i.key),
                              t = i.dropPosition;
                            null == e && (e = s.getFirstKey(), t = "before"), i = {
                              type: "item",
                              key: e,
                              dropPosition: t
                            };
                          }
                          let {
                              draggingKeys: u
                            } = ti,
                            d = ai(n);
                          var c;
                          "cancel" === r.state.getDropOperation({
                            target: i,
                            types: l,
                            allowedOperations: a.allowedDropOperations,
                            isInternal: d,
                            draggingKeys: u
                          }) && (i = null !== (c = o(i, l, a.allowedDropOperations, t, !1)) && void 0 !== c ? c : o(i, l, a.allowedDropOperations, e, !1));
                        }
                      } else i = o(null, l, a.allowedDropOperations, t);
                      r.state.setTarget(null != i ? i : r.state.target);
                      break;
                    }
                }
              }
            });
          }, [r, n, l, u]);
          let c = (0, j.Me)();
          return Lo.set(t, {
            id: c,
            ref: n
          }), {
            collectionProps: (0, j.dG)(a, {
              id: c,
              "aria-describedby": null
            })
          };
        }
        function Ii(e, t, n) {
          let {
              dropProps: r
            } = Si(),
            o = qo(t);
          (0, Ee.useEffect)(() => {
            if (n.current) return r = {
              element: n.current,
              target: e.target,
              getDropOperation(n, r) {
                let {
                    draggingKeys: i
                  } = ti,
                  a = ai(o);
                return t.getDropOperation({
                  target: e.target,
                  types: n,
                  allowedOperations: r,
                  isInternal: a,
                  draggingKeys: i
                });
              }
            }, di.set(r.element, r), () => {
              di.delete(r.element);
            };
            var r;
          }, [n, e.target, t, o]);
          let i = mi(),
            {
              draggingKeys: a
            } = ti,
            s = ai(o),
            l = i && "cancel" !== t.getDropOperation({
              target: e.target,
              types: Ho(i.dragTarget.items),
              allowedOperations: i.dragTarget.allowedDropOperations,
              isInternal: s,
              draggingKeys: a
            }),
            u = t.isDropTarget(e.target);
          return (0, Ee.useEffect)(() => {
            i && u && n.current && n.current.focus();
          }, [u, i, n]), {
            dropProps: {
              ...r,
              "aria-hidden": !i || l ? void 0 : "true"
            },
            isDropTarget: u
          };
        }
        function Fi(e, t, n) {
          let r,
            {
              target: o
            } = e,
            {
              collection: i
            } = t,
            a = (0, V.qb)(To(wi), "@react-aria/dnd"),
            s = mi(),
            {
              dropProps: l
            } = Ii(e, t, n),
            u = (0, j.Me)(),
            c = e => {
              var t, n, r;
              return null !== (r = null === (t = i.getTextValue) || void 0 === t ? void 0 : t.call(i, e)) && void 0 !== r ? r : null === (n = i.getItem(e)) || void 0 === n ? void 0 : n.textValue;
            },
            d = "";
          if ("root" === o.type) d = a.format("dropOnRoot"), r = `${u} ${Ko(t)}`;else if ("on" === o.dropPosition) d = a.format("dropOnItem", {
            itemText: c(o.key)
          });else {
            let e, t;
            e = i.getFirstKey() === o.key && "before" === o.dropPosition ? null : "before" === o.dropPosition ? i.getKeyBefore(o.key) : o.key, t = i.getLastKey() === o.key && "after" === o.dropPosition ? null : "after" === o.dropPosition ? i.getKeyAfter(o.key) : o.key, e && t ? d = a.format("insertBetween", {
              beforeItemText: c(e),
              afterItemText: c(t)
            }) : e ? d = a.format("insertAfter", {
              itemText: c(e)
            }) : t && (d = a.format("insertBefore", {
              itemText: c(t)
            }));
          }
          let p = t.isDropTarget(o),
            h = s ? l["aria-hidden"] : "true";
          return {
            dropIndicatorProps: {
              ...l,
              id: u,
              "aria-roledescription": a.format("dropIndicator"),
              "aria-label": d,
              "aria-labelledby": r,
              "aria-hidden": h,
              tabIndex: -1
            },
            isDropTarget: p,
            isHidden: !p && !!h
          };
        }
        const Mi = {
          keyboard: {
            selected: "dragSelectedKeyboard",
            notSelected: "dragDescriptionKeyboard"
          },
          touch: {
            selected: "dragSelectedLongPress",
            notSelected: "dragDescriptionLongPress"
          },
          virtual: {
            selected: "dragDescriptionVirtual",
            notSelected: "dragDescriptionVirtual"
          }
        };
        function Ri(e, t) {
          let n,
            r,
            o = (0, V.qb)(To(wi), "@react-aria/dnd"),
            i = t.selectionManager.isDisabled(e.key),
            {
              dragProps: a,
              dragButtonProps: s
            } = Di({
              getItems: () => t.getItems(e.key),
              preview: t.preview,
              getAllowedDropOperations: t.getAllowedDropOperations,
              hasDragButton: e.hasDragButton,
              onDragStart(n) {
                var r;
                t.startDrag(e.key, n), r = t.draggingKeys, ti.draggingKeys = r;
              },
              onDragMove(e) {
                t.moveDrag(e);
              },
              onDragEnd(e) {
                let {
                    dropOperation: n
                  } = e,
                  r = "cancel" !== n && ai();
                t.endDrag({
                  ...e,
                  keys: t.draggingKeys,
                  isInternal: r
                }), oi();
              }
            }),
            l = t.collection.getItem(e.key),
            u = t.getKeysForDrag(e.key).size,
            c = u > 1 && t.selectionManager.isSelected(e.key),
            d = Zo();
          if (e.hasDragButton || "none" === t.selectionManager.selectionMode) {
            if (c) n = o.format("dragSelectedItems", {
              count: u
            });else {
              var p, h, f, m;
              let r = null !== (m = null !== (f = null === (p = (h = t.collection).getTextValue) || void 0 === p ? void 0 : p.call(h, e.key)) && void 0 !== f ? f : null == l ? void 0 : l.textValue) && void 0 !== m ? m : "";
              n = o.format("dragItem", {
                itemText: r
              });
            }
          } else {
            let t = Mi[d][c ? "selected" : "notSelected"];
            e.hasAction && "keyboard" === d && (t += "Alt"), r = c ? o.format(t, {
              count: u
            }) : o.format(t), delete a.onClick;
          }
          let g = (0, j.PK)(r);
          if (r && Object.assign(a, g), !e.hasDragButton && e.hasAction) {
            let {
              onKeyDownCapture: e,
              onKeyUpCapture: t
            } = a;
            "touch" === d && delete a["aria-describedby"], a.onKeyDownCapture = t => {
              t.altKey && e(t);
            }, a.onKeyUpCapture = e => {
              e.altKey && t(e);
            };
          }
          return {
            dragProps: i ? {} : a,
            dragButtonProps: {
              ...s,
              isDisabled: i,
              "aria-label": n
            }
          };
        }
        function ji(e, t, n) {
          let {
            draggingCollectionRef: r
          } = ti;
          t.draggingKeys.size > 0 && (null == r ? void 0 : r.current) !== n.current && ni(n);
        }
        const Bi = new Map();
        function Ni(e, t) {
          let n = Bi.get(e);
          if (!n) {
            let t = new Set(),
              r = e => {
                for (let n of t) n(e);
              };
            n = {
              listener: r,
              handlers: t
            }, Bi.set(e, n), document.addEventListener(e, r);
          }
          return n.handlers.add(t), () => {
            n.handlers.delete(t), 0 === n.handlers.size && (document.removeEventListener(e, n.listener), Bi.delete(e));
          };
        }
        function Li(e) {
          let t = (0, Ee.useRef)(!1),
            {
              focusProps: n
            } = (0, N.KK)({
              onFocusChange: e => {
                t.current = e;
              }
            }),
            r = (0, j.iW)(n => {
              t.current && e.getItems && n.preventDefault();
            }),
            o = (0, j.iW)(n => {
              var r;
              t.current && e.getItems && (n.preventDefault(), Go(n.clipboardData, e.getItems()), null === (r = e.onCopy) || void 0 === r || r.call(e));
            }),
            i = (0, j.iW)(n => {
              t.current && e.onCut && e.getItems && n.preventDefault();
            }),
            a = (0, j.iW)(n => {
              t.current && e.onCut && e.getItems && (n.preventDefault(), Go(n.clipboardData, e.getItems()), e.onCut());
            }),
            s = (0, j.iW)(n => {
              t.current && e.onPaste && n.preventDefault();
            }),
            l = (0, j.iW)(n => {
              if (!t.current || !e.onPaste) return;
              n.preventDefault();
              let r = Yo(n.clipboardData);
              e.onPaste(r);
            });
          return (0, Ee.useEffect)(() => (0, j.tS)(Ni("beforecopy", r), Ni("copy", o), Ni("beforecut", i), Ni("cut", a), Ni("beforepaste", s), Ni("paste", l)), [r, o, i, a, s, l]), {
            clipboardProps: n
          };
        }
        function Vi(e, t) {
          let n = e.children,
            [r, o] = (0, Ee.useState)(null),
            i = (0, Ee.useRef)(null);
          return (0, Ee.useImperativeHandle)(t, () => (e, t) => {
            (0, Ut.flushSync)(() => {
              o(n(e));
            }), t(i.current), requestAnimationFrame(() => {
              o(null);
            });
          }, [n]), r ? Ee.createElement("div", {
            style: {
              zIndex: -100,
              position: "absolute",
              top: 0,
              left: -1e5
            },
            ref: i
          }, r) : null;
        }
        let Ki = Ee.forwardRef(Vi);
        class qi {
          getPrimaryStart(e) {
            return "horizontal" === this.orientation ? e.left : e.top;
          }
          getPrimaryEnd(e) {
            return "horizontal" === this.orientation ? e.right : e.bottom;
          }
          getSecondaryStart(e) {
            return "horizontal" === this.orientation ? e.top : e.left;
          }
          getSecondaryEnd(e) {
            return "horizontal" === this.orientation ? e.bottom : e.right;
          }
          getFlowStart(e) {
            return "stack" === this.layout ? this.getPrimaryStart(e) : this.getSecondaryStart(e);
          }
          getFlowEnd(e) {
            return "stack" === this.layout ? this.getPrimaryEnd(e) : this.getSecondaryEnd(e);
          }
          getFlowSize(e) {
            return this.getFlowEnd(e) - this.getFlowStart(e);
          }
          getDropTargetFromPoint(e, t, n) {
            if (0 === this.collection.size) return {
              type: "root"
            };
            let r = this.ref.current.getBoundingClientRect(),
              o = "horizontal" === this.orientation ? e : t,
              i = "horizontal" === this.orientation ? t : e;
            o += this.getPrimaryStart(r), i += this.getSecondaryStart(r);
            let a = "stack" === this.layout ? o : i,
              s = "horizontal" === this.orientation && "rtl" === this.direction,
              l = "grid" === this.layout && "vertical" === this.orientation && "rtl" === this.direction,
              u = "stack" === this.layout ? s : l,
              c = this.ref.current.querySelectorAll("[data-key]"),
              d = new Map();
            for (let e of c) e instanceof HTMLElement && d.set(e.dataset.key, e);
            let p = [...this.collection],
              h = 0,
              f = p.length;
            for (; h < f;) {
              let e = Math.floor((h + f) / 2),
                t = p[e],
                r = d.get(String(t.key)).getBoundingClientRect(),
                c = t => {
                  t ? h = e + 1 : f = e;
                };
              if (o < this.getPrimaryStart(r)) c(s);else if (o > this.getPrimaryEnd(r)) c(!s);else if (i < this.getSecondaryStart(r)) c(l);else {
                if (!(i > this.getSecondaryEnd(r))) {
                  let e = {
                    type: "item",
                    key: t.key,
                    dropPosition: "on"
                  };
                  if (n(e)) a <= this.getFlowStart(r) + 5 && n({
                    ...e,
                    dropPosition: "before"
                  }) ? e.dropPosition = u ? "after" : "before" : a >= this.getFlowEnd(r) - 5 && n({
                    ...e,
                    dropPosition: "after"
                  }) && (e.dropPosition = u ? "before" : "after");else {
                    let t = this.getFlowStart(r) + this.getFlowSize(r) / 2;
                    a <= t && n({
                      ...e,
                      dropPosition: "before"
                    }) ? e.dropPosition = u ? "after" : "before" : a >= t && n({
                      ...e,
                      dropPosition: "after"
                    }) && (e.dropPosition = u ? "before" : "after");
                  }
                  return e;
                }
                c(!l);
              }
            }
            let m = p[Math.min(h, p.length - 1)];
            return r = d.get(String(m.key)).getBoundingClientRect(), o < this.getPrimaryStart(r) || Math.abs(a - this.getFlowStart(r)) < Math.abs(a - this.getFlowEnd(r)) ? {
              type: "item",
              key: m.key,
              dropPosition: u ? "after" : "before"
            } : {
              type: "item",
              key: m.key,
              dropPosition: u ? "before" : "after"
            };
          }
          constructor(e, t, n) {
            this.collection = e, this.ref = t, this.layout = (null == n ? void 0 : n.layout) || "stack", this.orientation = (null == n ? void 0 : n.orientation) || "vertical", this.direction = (null == n ? void 0 : n.direction) || "ltr";
          }
        }
        var Hi;
        Hi = {
          deselectedItem: e => `${e.item} غير المحدد`,
          longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
          select: "تحديد",
          selectedAll: "جميع العناصر المحددة.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "لم يتم تحديد عناصر",
            one: () => `${t.number(e.count)} عنصر محدد`,
            other: () => `${t.number(e.count)} عنصر محدد`
          })}.`,
          selectedItem: e => `${e.item} المحدد`
        };
        var Ui;
        Ui = {
          deselectedItem: e => `${e.item} не е избран.`,
          longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
          select: "Изберете",
          selectedAll: "Всички елементи са избрани.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Няма избрани елементи",
            one: () => `${t.number(e.count)} избран елемент`,
            other: () => `${t.number(e.count)} избрани елементи`
          })}.`,
          selectedItem: e => `${e.item} избран.`
        };
        var Zi;
        Zi = {
          deselectedItem: e => `Položka ${e.item} není vybrána.`,
          longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
          select: "Vybrat",
          selectedAll: "Vybrány všechny položky.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nevybrány žádné položky",
            one: () => `Vybrána ${t.number(e.count)} položka`,
            other: () => `Vybráno ${t.number(e.count)} položek`
          })}.`,
          selectedItem: e => `Vybrána položka ${e.item}.`
        };
        var $i;
        $i = {
          deselectedItem: e => `${e.item} ikke valgt.`,
          longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
          select: "Vælg",
          selectedAll: "Alle elementer valgt.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Ingen elementer valgt",
            one: () => `${t.number(e.count)} element valgt`,
            other: () => `${t.number(e.count)} elementer valgt`
          })}.`,
          selectedItem: e => `${e.item} valgt.`
        };
        var Gi;
        Gi = {
          deselectedItem: e => `${e.item} nicht ausgewählt.`,
          longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
          select: "Auswählen",
          selectedAll: "Alle Elemente ausgewählt.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Keine Elemente ausgewählt",
            one: () => `${t.number(e.count)} Element ausgewählt`,
            other: () => `${t.number(e.count)} Elemente ausgewählt`
          })}.`,
          selectedItem: e => `${e.item} ausgewählt.`
        };
        var Wi;
        Wi = {
          deselectedItem: e => `Δεν επιλέχθηκε το στοιχείο ${e.item}.`,
          longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
          select: "Επιλογή",
          selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Δεν επιλέχθηκαν στοιχεία",
            one: () => `Επιλέχθηκε ${t.number(e.count)} στοιχείο`,
            other: () => `Επιλέχθηκαν ${t.number(e.count)} στοιχεία`
          })}.`,
          selectedItem: e => `Επιλέχθηκε το στοιχείο ${e.item}.`
        };
        var Yi;
        Yi = {
          deselectedItem: e => `${e.item} not selected.`,
          select: "Select",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "No items selected",
            one: () => `${t.number(e.count)} item selected`,
            other: () => `${t.number(e.count)} items selected`
          })}.`,
          selectedAll: "All items selected.",
          selectedItem: e => `${e.item} selected.`,
          longPressToSelect: "Long press to enter selection mode."
        };
        var Xi;
        Xi = {
          deselectedItem: e => `${e.item} no seleccionado.`,
          longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
          select: "Seleccionar",
          selectedAll: "Todos los elementos seleccionados.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Ningún elemento seleccionado",
            one: () => `${t.number(e.count)} elemento seleccionado`,
            other: () => `${t.number(e.count)} elementos seleccionados`
          })}.`,
          selectedItem: e => `${e.item} seleccionado.`
        };
        var Qi;
        Qi = {
          deselectedItem: e => `${e.item} pole valitud.`,
          longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
          select: "Vali",
          selectedAll: "Kõik üksused valitud.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Üksusi pole valitud",
            one: () => `${t.number(e.count)} üksus valitud`,
            other: () => `${t.number(e.count)} üksust valitud`
          })}.`,
          selectedItem: e => `${e.item} valitud.`
        };
        var Ji;
        Ji = {
          deselectedItem: e => `Kohdetta ${e.item} ei valittu.`,
          longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
          select: "Valitse",
          selectedAll: "Kaikki kohteet valittu.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Ei yhtään kohdetta valittu",
            one: () => `${t.number(e.count)} kohde valittu`,
            other: () => `${t.number(e.count)} kohdetta valittu`
          })}.`,
          selectedItem: e => `${e.item} valittu.`
        };
        var ea;
        ea = {
          deselectedItem: e => `${e.item} non sélectionné.`,
          longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
          select: "Sélectionner",
          selectedAll: "Tous les éléments sélectionnés.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Aucun élément sélectionné",
            one: () => `${t.number(e.count)} élément sélectionné`,
            other: () => `${t.number(e.count)} éléments sélectionnés`
          })}.`,
          selectedItem: e => `${e.item} sélectionné.`
        };
        var ta;
        ta = {
          deselectedItem: e => `${e.item} לא נבחר.`,
          longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
          select: "בחר",
          selectedAll: "כל הפריטים נבחרו.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "לא נבחרו פריטים",
            one: () => `פריט ${t.number(e.count)} נבחר`,
            other: () => `${t.number(e.count)} פריטים נבחרו`
          })}.`,
          selectedItem: e => `${e.item} נבחר.`
        };
        var na;
        na = {
          deselectedItem: e => `Stavka ${e.item} nije odabrana.`,
          longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
          select: "Odaberite",
          selectedAll: "Odabrane su sve stavke.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nije odabrana nijedna stavka",
            one: () => `Odabrana je ${t.number(e.count)} stavka`,
            other: () => `Odabrano je ${t.number(e.count)} stavki`
          })}.`,
          selectedItem: e => `Stavka ${e.item} je odabrana.`
        };
        var ra;
        ra = {
          deselectedItem: e => `${e.item} nincs kijelölve.`,
          longPressToSelect: "Nyomja hosszan a kijelöléshez.",
          select: "Kijelölés",
          selectedAll: "Az összes elem kijelölve.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Egy elem sincs kijelölve",
            one: () => `${t.number(e.count)} elem kijelölve`,
            other: () => `${t.number(e.count)} elem kijelölve`
          })}.`,
          selectedItem: e => `${e.item} kijelölve.`
        };
        var oa;
        oa = {
          deselectedItem: e => `${e.item} non selezionato.`,
          longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
          select: "Seleziona",
          selectedAll: "Tutti gli elementi selezionati.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nessun elemento selezionato",
            one: () => `${t.number(e.count)} elemento selezionato`,
            other: () => `${t.number(e.count)} elementi selezionati`
          })}.`,
          selectedItem: e => `${e.item} selezionato.`
        };
        var ia;
        ia = {
          deselectedItem: e => `${e.item} が選択されていません。`,
          longPressToSelect: "長押しして選択モードを開きます。",
          select: "選択",
          selectedAll: "すべての項目を選択しました。",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "項目が選択されていません",
            one: () => `${t.number(e.count)} 項目を選択しました`,
            other: () => `${t.number(e.count)} 項目を選択しました`
          })}。`,
          selectedItem: e => `${e.item} を選択しました。`
        };
        var aa;
        aa = {
          deselectedItem: e => `${e.item}이(가) 선택되지 않았습니다.`,
          longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
          select: "선택",
          selectedAll: "모든 항목이 선택되었습니다.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "선택된 항목이 없습니다",
            one: () => `${t.number(e.count)}개 항목이 선택되었습니다`,
            other: () => `${t.number(e.count)}개 항목이 선택되었습니다`
          })}.`,
          selectedItem: e => `${e.item}이(가) 선택되었습니다.`
        };
        var sa;
        sa = {
          deselectedItem: e => `${e.item} nepasirinkta.`,
          longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
          select: "Pasirinkti",
          selectedAll: "Pasirinkti visi elementai.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nepasirinktas nė vienas elementas",
            one: () => `Pasirinktas ${t.number(e.count)} elementas`,
            other: () => `Pasirinkta elementų: ${t.number(e.count)}`
          })}.`,
          selectedItem: e => `Pasirinkta: ${e.item}.`
        };
        var la;
        la = {
          deselectedItem: e => `Vienums ${e.item} nav atlasīts.`,
          longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
          select: "Atlasīt",
          selectedAll: "Atlasīti visi vienumi.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nav atlasīts neviens vienums",
            one: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`,
            other: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`
          })}.`,
          selectedItem: e => `Atlasīts vienums ${e.item}.`
        };
        var ua;
        ua = {
          deselectedItem: e => `${e.item} er ikke valgt.`,
          longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
          select: "Velg",
          selectedAll: "Alle elementer er valgt.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Ingen elementer er valgt",
            one: () => `${t.number(e.count)} element er valgt`,
            other: () => `${t.number(e.count)} elementer er valgt`
          })}.`,
          selectedItem: e => `${e.item} er valgt.`
        };
        var ca;
        ca = {
          deselectedItem: e => `${e.item} niet geselecteerd.`,
          longPressToSelect: "Druk lang om de selectiemodus te openen.",
          select: "Selecteren",
          selectedAll: "Alle items geselecteerd.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Geen items geselecteerd",
            one: () => `${t.number(e.count)} item geselecteerd`,
            other: () => `${t.number(e.count)} items geselecteerd`
          })}.`,
          selectedItem: e => `${e.item} geselecteerd.`
        };
        var da;
        da = {
          deselectedItem: e => `Nie zaznaczono ${e.item}.`,
          longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
          select: "Zaznacz",
          selectedAll: "Wszystkie zaznaczone elementy.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nie zaznaczono żadnych elementów",
            one: () => `${t.number(e.count)} zaznaczony element`,
            other: () => `${t.number(e.count)} zaznaczonych elementów`
          })}.`,
          selectedItem: e => `Zaznaczono ${e.item}.`
        };
        var pa;
        pa = {
          deselectedItem: e => `${e.item} não selecionado.`,
          longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
          select: "Selecionar",
          selectedAll: "Todos os itens selecionados.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nenhum item selecionado",
            one: () => `${t.number(e.count)} item selecionado`,
            other: () => `${t.number(e.count)} itens selecionados`
          })}.`,
          selectedItem: e => `${e.item} selecionado.`
        };
        var ha;
        ha = {
          deselectedItem: e => `${e.item} não selecionado.`,
          longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
          select: "Selecionar",
          selectedAll: "Todos os itens selecionados.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nenhum item selecionado",
            one: () => `${t.number(e.count)} item selecionado`,
            other: () => `${t.number(e.count)} itens selecionados`
          })}.`,
          selectedItem: e => `${e.item} selecionado.`
        };
        var fa;
        fa = {
          deselectedItem: e => `${e.item} neselectat.`,
          longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
          select: "Selectare",
          selectedAll: "Toate elementele selectate.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Niciun element selectat",
            one: () => `${t.number(e.count)} element selectat`,
            other: () => `${t.number(e.count)} elemente selectate`
          })}.`,
          selectedItem: e => `${e.item} selectat.`
        };
        var ma;
        ma = {
          deselectedItem: e => `${e.item} не выбрано.`,
          longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
          select: "Выбрать",
          selectedAll: "Выбраны все элементы.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Нет выбранных элементов",
            one: () => `${t.number(e.count)} элемент выбран`,
            other: () => `${t.number(e.count)} элементов выбрано`
          })}.`,
          selectedItem: e => `${e.item} выбрано.`
        };
        var ga;
        ga = {
          deselectedItem: e => `Nevybraté položky: ${e.item}.`,
          longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
          select: "Vybrať",
          selectedAll: "Všetky vybraté položky.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Žiadne vybraté položky",
            one: () => `${t.number(e.count)} vybratá položka`,
            other: () => `Počet vybratých položiek:${t.number(e.count)}`
          })}.`,
          selectedItem: e => `Vybraté položky: ${e.item}.`
        };
        var va;
        va = {
          deselectedItem: e => `Element ${e.item} ni izbran.`,
          longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
          select: "Izberite",
          selectedAll: "Vsi elementi so izbrani.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Noben element ni izbran",
            one: () => `${t.number(e.count)} element je izbran`,
            other: () => `${t.number(e.count)} elementov je izbranih`
          })}.`,
          selectedItem: e => `Element ${e.item} je izbran.`
        };
        var ya;
        ya = {
          deselectedItem: e => `${e.item} nije izabrano.`,
          longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
          select: "Izaberite",
          selectedAll: "Izabrane su sve stavke.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Nije izabrana nijedna stavka",
            one: () => `Izabrana je ${t.number(e.count)} stavka`,
            other: () => `Izabrano je ${t.number(e.count)} stavki`
          })}.`,
          selectedItem: e => `${e.item} je izabrano.`
        };
        var ba;
        ba = {
          deselectedItem: e => `${e.item} ej markerat.`,
          longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
          select: "Markera",
          selectedAll: "Alla markerade objekt.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Inga markerade objekt",
            one: () => `${t.number(e.count)} markerat objekt`,
            other: () => `${t.number(e.count)} markerade objekt`
          })}.`,
          selectedItem: e => `${e.item} markerat.`
        };
        var wa;
        wa = {
          deselectedItem: e => `${e.item} seçilmedi.`,
          longPressToSelect: "Seçim moduna girmek için uzun basın.",
          select: "Seç",
          selectedAll: "Tüm ögeler seçildi.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Hiçbir öge seçilmedi",
            one: () => `${t.number(e.count)} öge seçildi`,
            other: () => `${t.number(e.count)} öge seçildi`
          })}.`,
          selectedItem: e => `${e.item} seçildi.`
        };
        var xa;
        xa = {
          deselectedItem: e => `${e.item} не вибрано.`,
          longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
          select: "Вибрати",
          selectedAll: "Усі елементи вибрано.",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "Жодних елементів не вибрано",
            one: () => `${t.number(e.count)} елемент вибрано`,
            other: () => `Вибрано елементів: ${t.number(e.count)}`
          })}.`,
          selectedItem: e => `${e.item} вибрано.`
        };
        var Da;
        Da = {
          deselectedItem: e => `未选择 ${e.item}。`,
          longPressToSelect: "长按以进入选择模式。",
          select: "选择",
          selectedAll: "已选择所有项目。",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "未选择项目",
            one: () => `已选择 ${t.number(e.count)} 个项目`,
            other: () => `已选择 ${t.number(e.count)} 个项目`
          })}。`,
          selectedItem: e => `已选择 ${e.item}。`
        };
        var Ca;
        Ca = {
          deselectedItem: e => `未選取「${e.item}」。`,
          longPressToSelect: "長按以進入選擇模式。",
          select: "選取",
          selectedAll: "已選取所有項目。",
          selectedCount: (e, t) => `${t.plural(e.count, {
            "=0": "未選取任何項目",
            one: () => `已選取 ${t.number(e.count)} 個項目`,
            other: () => `已選取 ${t.number(e.count)} 個項目`
          })}。`,
          selectedItem: e => `已選取「${e.item}」。`
        };
        let Sa = "undefined" != typeof window ? window.performance : null,
          Ea = Sa && (Sa.now || Sa.webkitNow || Sa.msNow || Sa.mozNow);
        Ea && Ea.bind(Sa);
        function _a(e) {
          return e && e.__esModule ? e.default : e;
        }
        new WeakMap();
        var Pa;
        function ka(e, t) {
          let {
              getRowText: n = e => {
                var n, r, o, i;
                return null !== (i = null === (n = (r = t.collection).getTextValue) || void 0 === n ? void 0 : n.call(r, e)) && void 0 !== i ? i : null === (o = t.collection.getItem(e)) || void 0 === o ? void 0 : o.textValue;
              }
            } = e,
            r = (0, V.qb)(_a(Pa), "@react-aria/grid"),
            o = t.selectionManager.rawSelection,
            i = (0, Ee.useRef)(o);
          (0, j.rf)(() => {
            var e;
            if (!t.selectionManager.isFocused) return void (i.current = o);
            let a = Aa(o, i.current),
              s = Aa(i.current, o),
              l = "replace" === t.selectionManager.selectionBehavior,
              u = [];
            if (1 === t.selectionManager.selectedKeys.size && l) {
              if (t.collection.getItem(t.selectionManager.selectedKeys.keys().next().value)) {
                let e = n(t.selectionManager.selectedKeys.keys().next().value);
                e && u.push(r.format("selectedItem", {
                  item: e
                }));
              }
            } else if (1 === a.size && 0 === s.size) {
              let e = n(a.keys().next().value);
              e && u.push(r.format("selectedItem", {
                item: e
              }));
            } else if (1 === s.size && 0 === a.size && t.collection.getItem(s.keys().next().value)) {
              let e = n(s.keys().next().value);
              e && u.push(r.format("deselectedItem", {
                item: e
              }));
            }
            "multiple" === t.selectionManager.selectionMode && (0 === u.length || "all" === o || o.size > 1 || "all" === i.current || (null === (e = i.current) || void 0 === e ? void 0 : e.size) > 1) && u.push("all" === o ? r.format("selectedAll") : r.format("selectedCount", {
              count: o.size
            })), u.length > 0 && (0, Se.xQ)(u.join(" ")), i.current = o;
          }, [o]);
        }
        function Aa(e, t) {
          let n = new Set();
          if ("all" === e || "all" === t) return n;
          for (let r of e.keys()) t.has(r) || n.add(r);
          return n;
        }
        function za(e) {
          let t = (0, V.qb)(_a(Pa), "@react-aria/grid"),
            n = (0, N.Kf)(),
            r = ("pointer" === n || "virtual" === n || null == n) && "undefined" != typeof window && "ontouchstart" in window,
            o = (0, Ee.useMemo)(() => {
              let n,
                o = e.selectionManager.selectionMode,
                i = e.selectionManager.selectionBehavior;
              return r && (n = t.format("longPressToSelect")), "replace" === i && "none" !== o && e.hasItemActions ? n : void 0;
            }, [e.selectionManager.selectionMode, e.selectionManager.selectionBehavior, e.hasItemActions, t, r]);
          return (0, j.PK)(o);
        }
        Pa = {
          "ar-AE": Hi,
          "bg-BG": Ui,
          "cs-CZ": Zi,
          "da-DK": $i,
          "de-DE": Gi,
          "el-GR": Wi,
          "en-US": Yi,
          "es-ES": Xi,
          "et-EE": Qi,
          "fi-FI": Ji,
          "fr-FR": ea,
          "he-IL": ta,
          "hr-HR": na,
          "hu-HU": ra,
          "it-IT": oa,
          "ja-JP": ia,
          "ko-KR": aa,
          "lt-LT": sa,
          "lv-LV": la,
          "nb-NO": ua,
          "nl-NL": ca,
          "pl-PL": da,
          "pt-BR": pa,
          "pt-PT": ha,
          "ro-RO": fa,
          "ru-RU": ma,
          "sk-SK": ga,
          "sl-SI": va,
          "sr-SP": ya,
          "sv-SE": ba,
          "tr-TR": wa,
          "uk-UA": xa,
          "zh-CN": Da,
          "zh-TW": Ca
        };
        const Ta = new WeakMap();
        function Oa(e, t) {
          let {
            id: n
          } = Ta.get(e);
          if (!n) throw new Error("Unknown list");
          return `${n}-${function (e) {
            return "string" == typeof e ? e.replace(/\s*/g, "") : "" + e;
          }(t)}`;
        }
        function Ia(e, t, n) {
          let {
            isVirtualized: r,
            keyboardDelegate: o,
            onAction: i,
            linkBehavior: a = "action"
          } = e;
          e["aria-label"] || e["aria-labelledby"] || console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
          let {
              listProps: s
            } = Gn({
              selectionManager: t.selectionManager,
              collection: t.collection,
              disabledKeys: t.disabledKeys,
              ref: n,
              keyboardDelegate: o,
              isVirtualized: r,
              selectOnFocus: "replace" === t.selectionManager.selectionBehavior,
              shouldFocusWrap: e.shouldFocusWrap,
              linkBehavior: a
            }),
            l = (0, j.Me)(e.id);
          Ta.set(t, {
            id: l,
            onAction: i,
            linkBehavior: a
          });
          let u = za({
              selectionManager: t.selectionManager,
              hasItemActions: !!i
            }),
            c = (0, B.pu)(n, {
              isDisabled: 0 !== t.collection.size
            }),
            d = (0, j.zL)(e, {
              labelable: !0
            }),
            p = (0, j.dG)(d, {
              role: "grid",
              id: l,
              "aria-multiselectable": "multiple" === t.selectionManager.selectionMode ? "true" : void 0
            }, 0 === t.collection.size ? {
              tabIndex: c ? -1 : 0
            } : s, u);
          return r && (p["aria-rowcount"] = t.collection.size, p["aria-colcount"] = 1), ka({}, t), {
            gridProps: p
          };
        }
        function Fa(e, t, n) {
          let {
              node: r,
              isVirtualized: o,
              shouldSelectOnPressUp: i
            } = e,
            {
              direction: a
            } = (0, V.bU)(),
            {
              onAction: s,
              linkBehavior: l
            } = Ta.get(t),
            u = (0, j.mp)(),
            c = (0, Ee.useRef)(null),
            {
              itemProps: d,
              ...p
            } = Hn({
              selectionManager: t.selectionManager,
              key: r.key,
              ref: n,
              isVirtualized: o,
              shouldSelectOnPressUp: i,
              onAction: s ? () => s(r.key) : void 0,
              focus: () => {
                (null != c.current && r.key !== c.current || !n.current.contains(document.activeElement)) && (0, B.ex)(n.current);
              },
              linkBehavior: l
            }),
            h = p.hasAction ? (0, j.ib)(r.props) : {},
            f = (0, j.dG)(d, h, {
              role: "row",
              onKeyDownCapture: e => {
                if (!e.currentTarget.contains(e.target)) return;
                let t = (0, B.QL)(n.current);
                switch (t.currentNode = document.activeElement, e.key) {
                  case "ArrowLeft":
                    {
                      let r = "rtl" === a ? t.nextNode() : t.previousNode();
                      if (r) e.preventDefault(), e.stopPropagation(), (0, B.ex)(r), (0, j.Gt)(r, {
                        containingElement: (0, j.rP)(n.current)
                      });else if (e.preventDefault(), e.stopPropagation(), "rtl" === a) (0, B.ex)(n.current), (0, j.Gt)(n.current, {
                        containingElement: (0, j.rP)(n.current)
                      });else {
                        t.currentNode = n.current;
                        let e = Ma(t);
                        e && ((0, B.ex)(e), (0, j.Gt)(e, {
                          containingElement: (0, j.rP)(n.current)
                        }));
                      }
                      break;
                    }
                  case "ArrowRight":
                    {
                      let r = "rtl" === a ? t.previousNode() : t.nextNode();
                      if (r) e.preventDefault(), e.stopPropagation(), (0, B.ex)(r), (0, j.Gt)(r, {
                        containingElement: (0, j.rP)(n.current)
                      });else if (e.preventDefault(), e.stopPropagation(), "ltr" === a) (0, B.ex)(n.current), (0, j.Gt)(n.current, {
                        containingElement: (0, j.rP)(n.current)
                      });else {
                        t.currentNode = n.current;
                        let e = Ma(t);
                        e && ((0, B.ex)(e), (0, j.Gt)(e, {
                          containingElement: (0, j.rP)(n.current)
                        }));
                      }
                      break;
                    }
                  case "ArrowUp":
                  case "ArrowDown":
                    !e.altKey && n.current.contains(e.target) && (e.stopPropagation(), e.preventDefault(), n.current.parentElement.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent)));
                }
              },
              onFocus: e => {
                c.current = r.key, e.target === n.current || (0, N.E)() || t.selectionManager.setFocusedKey(r.key);
              },
              "aria-label": r.textValue || void 0,
              "aria-selected": t.selectionManager.canSelectItem(r.key) ? t.selectionManager.isSelected(r.key) : void 0,
              "aria-disabled": t.selectionManager.isDisabled(r.key) || void 0,
              "aria-labelledby": u && r.textValue ? `${Oa(t, r.key)} ${u}` : void 0,
              id: Oa(t, r.key)
            });
          o && (f["aria-rowindex"] = r.index + 1);
          return {
            rowProps: f,
            gridCellProps: {
              role: "gridcell",
              "aria-colindex": 1
            },
            descriptionProps: {
              id: u
            },
            ...p
          };
        }
        function Ma(e) {
          let t, n;
          do {
            n = e.lastChild(), n && (t = n);
          } while (n);
          return t;
        }
        function Ra(e) {
          let {
              value: t = 0,
              minValue: n = 0,
              maxValue: r = 100,
              valueLabel: o,
              isIndeterminate: i,
              formatOptions: a = {
                style: "percent"
              }
            } = e,
            s = (0, j.zL)(e, {
              labelable: !0
            }),
            {
              labelProps: l,
              fieldProps: u
            } = (0, Ae.N)({
              ...e,
              labelElementType: "span"
            });
          t = (0, j.uZ)(t, n, r);
          let c = (t - n) / (r - n),
            d = (0, V.Ux)(a);
          if (!i && !o) {
            let e = "percent" === a.style ? c : t;
            o = d.format(e);
          }
          return {
            progressBarProps: (0, j.dG)(s, {
              ...u,
              "aria-valuenow": i ? void 0 : t,
              "aria-valuemin": n,
              "aria-valuemax": r,
              "aria-valuetext": i ? void 0 : o,
              role: "progressbar"
            }),
            labelProps: l
          };
        }
        function ja(e) {
          return e && e.__esModule ? e.default : e;
        }
        var Ba;
        function Na(e, t, n) {
          let {
              id: r,
              decrementAriaLabel: o,
              incrementAriaLabel: i,
              isDisabled: a,
              isReadOnly: s,
              isRequired: l,
              minValue: u,
              maxValue: c,
              autoFocus: d,
              label: p,
              formatOptions: h,
              onBlur: f = () => {},
              onFocus: m,
              onFocusChange: g,
              onKeyDown: v,
              onKeyUp: y,
              description: b,
              errorMessage: w,
              isWheelDisabled: x,
              ...D
            } = e,
            {
              increment: C,
              incrementToMax: S,
              decrement: E,
              decrementToMin: _,
              numberValue: P,
              inputValue: k,
              commit: A,
              commitValidation: z
            } = t;
          const T = (0, V.qb)(ja(Ba), "@react-aria/numberfield");
          let O = (0, j.Me)(r),
            {
              focusProps: I
            } = (0, N.KK)({
              onBlur() {
                A();
              }
            }),
            F = (0, V.Ux)(h),
            M = (0, Ee.useMemo)(() => F.resolvedOptions(), [F]),
            R = (0, V.Ux)({
              ...h,
              currencySign: void 0
            }),
            B = (0, Ee.useMemo)(() => isNaN(P) ? "" : R.format(P), [R, P]),
            {
              spinButtonProps: L,
              incrementButtonProps: K,
              decrementButtonProps: q
            } = (0, Zr.G)({
              isDisabled: a,
              isReadOnly: s,
              isRequired: l,
              maxValue: c,
              minValue: u,
              onIncrement: C,
              onIncrementToMax: S,
              onDecrement: E,
              onDecrementToMin: _,
              value: P,
              textValue: B
            }),
            [H, U] = (0, Ee.useState)(!1),
            {
              focusWithinProps: Z
            } = (0, N.L_)({
              isDisabled: a,
              onFocusWithinChange: U
            }),
            $ = (0, Ee.useCallback)(e => {
              Math.abs(e.deltaY) <= Math.abs(e.deltaX) || (e.deltaY > 0 ? C() : e.deltaY < 0 && E());
            }, [E, C]),
            G = x || a || s || !H;
          (0, N.y0)({
            onScroll: $,
            isDisabled: G
          }, n);
          let W = M.maximumFractionDigits > 0,
            Y = void 0 === t.minValue || isNaN(t.minValue) || t.minValue < 0,
            X = "numeric";
          (0, j.IN)() ? Y ? X = "text" : W && (X = "decimal") : (0, j.Dt)() && (Y ? X = "numeric" : W && (X = "decimal"));
          let Q = (0, j.zL)(e),
            J = (0, Ee.useCallback)(e => {
              "Enter" === e.key ? (A(), z()) : e.continuePropagation();
            }, [A, z]),
            {
              isInvalid: ee,
              validationErrors: te,
              validationDetails: ne
            } = t.displayValidation,
            {
              labelProps: re,
              inputProps: oe,
              descriptionProps: ie,
              errorMessageProps: ae
            } = (0, lr.h)({
              ...D,
              ...Q,
              name: void 0,
              label: p,
              autoFocus: d,
              isDisabled: a,
              isReadOnly: s,
              isRequired: l,
              validate: void 0,
              [Pe.tL]: t,
              value: k,
              defaultValue: void 0,
              autoComplete: "off",
              "aria-label": e["aria-label"] || void 0,
              "aria-labelledby": e["aria-labelledby"] || void 0,
              id: O,
              type: "text",
              inputMode: X,
              onChange: e => {
                t.validate(e) && t.setInputValue(e);
              },
              onBlur: f,
              onFocus: m,
              onFocusChange: g,
              onKeyDown: (0, Ee.useMemo)(() => (0, j.tS)(J, v), [J, v]),
              onKeyUp: y,
              description: b,
              errorMessage: w
            }, t, n);
          (0, j.y$)(n, t.numberValue, t.setNumberValue);
          let se = (0, j.dG)(L, I, oe, {
            role: null,
            "aria-roledescription": (0, j.gn)() ? null : T.format("numberField"),
            "aria-valuemax": null,
            "aria-valuemin": null,
            "aria-valuenow": null,
            "aria-valuetext": null,
            autoCorrect: "off",
            spellCheck: "false"
          });
          "native" === e.validationBehavior && (se["aria-required"] = void 0);
          let le,
            ue = e => {
              var t;
              document.activeElement !== n.current && ("mouse" === e.pointerType ? null === (t = n.current) || void 0 === t || t.focus() : e.target.focus());
            },
            ce = e["aria-label"] || ("string" == typeof e.label ? e.label : "");
          ce || (le = null != e.label ? re.id : e["aria-labelledby"]);
          let de = (0, j.Me)(),
            pe = (0, j.Me)();
          return {
            groupProps: {
              ...Z,
              role: "group",
              "aria-disabled": a,
              "aria-invalid": ee ? "true" : void 0
            },
            labelProps: re,
            inputProps: se,
            incrementButtonProps: (0, j.dG)(K, {
              "aria-label": i || T.format("increase", {
                fieldLabel: ce
              }).trim(),
              id: le && !i ? de : null,
              "aria-labelledby": le && !i ? `${de} ${le}` : null,
              "aria-controls": O,
              excludeFromTabOrder: !0,
              preventFocusOnPress: !0,
              allowFocusWhenDisabled: !0,
              isDisabled: !t.canIncrement,
              onPressStart: ue
            }),
            decrementButtonProps: (0, j.dG)(q, {
              "aria-label": o || T.format("decrease", {
                fieldLabel: ce
              }).trim(),
              id: le && !o ? pe : null,
              "aria-labelledby": le && !o ? `${pe} ${le}` : null,
              "aria-controls": O,
              excludeFromTabOrder: !0,
              preventFocusOnPress: !0,
              allowFocusWhenDisabled: !0,
              isDisabled: !t.canDecrement,
              onPressStart: ue
            }),
            errorMessageProps: ae,
            descriptionProps: ie,
            isInvalid: ee,
            validationErrors: te,
            validationDetails: ne
          };
        }
        Ba = {
          "ar-AE": {
            decrease: e => `خفض ${e.fieldLabel}`,
            increase: e => `زيادة ${e.fieldLabel}`,
            numberField: "حقل رقمي"
          },
          "bg-BG": {
            decrease: e => `Намаляване ${e.fieldLabel}`,
            increase: e => `Усилване ${e.fieldLabel}`,
            numberField: "Номер на полето"
          },
          "cs-CZ": {
            decrease: e => `Snížit ${e.fieldLabel}`,
            increase: e => `Zvýšit ${e.fieldLabel}`,
            numberField: "Číselné pole"
          },
          "da-DK": {
            decrease: e => `Reducer ${e.fieldLabel}`,
            increase: e => `Øg ${e.fieldLabel}`,
            numberField: "Talfelt"
          },
          "de-DE": {
            decrease: e => `${e.fieldLabel} verringern`,
            increase: e => `${e.fieldLabel} erhöhen`,
            numberField: "Nummernfeld"
          },
          "el-GR": {
            decrease: e => `Μείωση ${e.fieldLabel}`,
            increase: e => `Αύξηση ${e.fieldLabel}`,
            numberField: "Πεδίο αριθμού"
          },
          "en-US": {
            decrease: e => `Decrease ${e.fieldLabel}`,
            increase: e => `Increase ${e.fieldLabel}`,
            numberField: "Number field"
          },
          "es-ES": {
            decrease: e => `Reducir ${e.fieldLabel}`,
            increase: e => `Aumentar ${e.fieldLabel}`,
            numberField: "Campo de número"
          },
          "et-EE": {
            decrease: e => `Vähenda ${e.fieldLabel}`,
            increase: e => `Suurenda ${e.fieldLabel}`,
            numberField: "Numbri väli"
          },
          "fi-FI": {
            decrease: e => `Vähennä ${e.fieldLabel}`,
            increase: e => `Lisää ${e.fieldLabel}`,
            numberField: "Numerokenttä"
          },
          "fr-FR": {
            decrease: e => `Diminuer ${e.fieldLabel}`,
            increase: e => `Augmenter ${e.fieldLabel}`,
            numberField: "Champ de nombre"
          },
          "he-IL": {
            decrease: e => `הקטן ${e.fieldLabel}`,
            increase: e => `הגדל ${e.fieldLabel}`,
            numberField: "שדה מספר"
          },
          "hr-HR": {
            decrease: e => `Smanji ${e.fieldLabel}`,
            increase: e => `Povećaj ${e.fieldLabel}`,
            numberField: "Polje broja"
          },
          "hu-HU": {
            decrease: e => `${e.fieldLabel} csökkentése`,
            increase: e => `${e.fieldLabel} növelése`,
            numberField: "Számmező"
          },
          "it-IT": {
            decrease: e => `Riduci ${e.fieldLabel}`,
            increase: e => `Aumenta ${e.fieldLabel}`,
            numberField: "Campo numero"
          },
          "ja-JP": {
            decrease: e => `${e.fieldLabel}を縮小`,
            increase: e => `${e.fieldLabel}を拡大`,
            numberField: "数値フィールド"
          },
          "ko-KR": {
            decrease: e => `${e.fieldLabel} 감소`,
            increase: e => `${e.fieldLabel} 증가`,
            numberField: "번호 필드"
          },
          "lt-LT": {
            decrease: e => `Sumažinti ${e.fieldLabel}`,
            increase: e => `Padidinti ${e.fieldLabel}`,
            numberField: "Numerio laukas"
          },
          "lv-LV": {
            decrease: e => `Samazināšana ${e.fieldLabel}`,
            increase: e => `Palielināšana ${e.fieldLabel}`,
            numberField: "Skaitļu lauks"
          },
          "nb-NO": {
            decrease: e => `Reduser ${e.fieldLabel}`,
            increase: e => `Øk ${e.fieldLabel}`,
            numberField: "Tallfelt"
          },
          "nl-NL": {
            decrease: e => `${e.fieldLabel} verlagen`,
            increase: e => `${e.fieldLabel} verhogen`,
            numberField: "Getalveld"
          },
          "pl-PL": {
            decrease: e => `Zmniejsz ${e.fieldLabel}`,
            increase: e => `Zwiększ ${e.fieldLabel}`,
            numberField: "Pole numeru"
          },
          "pt-BR": {
            decrease: e => `Diminuir ${e.fieldLabel}`,
            increase: e => `Aumentar ${e.fieldLabel}`,
            numberField: "Campo de número"
          },
          "pt-PT": {
            decrease: e => `Diminuir ${e.fieldLabel}`,
            increase: e => `Aumentar ${e.fieldLabel}`,
            numberField: "Campo numérico"
          },
          "ro-RO": {
            decrease: e => `Scădere ${e.fieldLabel}`,
            increase: e => `Creștere ${e.fieldLabel}`,
            numberField: "Câmp numeric"
          },
          "ru-RU": {
            decrease: e => `Уменьшение ${e.fieldLabel}`,
            increase: e => `Увеличение ${e.fieldLabel}`,
            numberField: "Числовое поле"
          },
          "sk-SK": {
            decrease: e => `Znížiť ${e.fieldLabel}`,
            increase: e => `Zvýšiť ${e.fieldLabel}`,
            numberField: "Číselné pole"
          },
          "sl-SI": {
            decrease: e => `Upadati ${e.fieldLabel}`,
            increase: e => `Povečajte ${e.fieldLabel}`,
            numberField: "Številčno polje"
          },
          "sr-SP": {
            decrease: e => `Smanji ${e.fieldLabel}`,
            increase: e => `Povećaj ${e.fieldLabel}`,
            numberField: "Polje broja"
          },
          "sv-SE": {
            decrease: e => `Minska ${e.fieldLabel}`,
            increase: e => `Öka ${e.fieldLabel}`,
            numberField: "Nummerfält"
          },
          "tr-TR": {
            decrease: e => `${e.fieldLabel} azalt`,
            increase: e => `${e.fieldLabel} arttır`,
            numberField: "Sayı alanı"
          },
          "uk-UA": {
            decrease: e => `Зменшити ${e.fieldLabel}`,
            increase: e => `Збільшити ${e.fieldLabel}`,
            numberField: "Поле номера"
          },
          "zh-CN": {
            decrease: e => `降低 ${e.fieldLabel}`,
            increase: e => `提高 ${e.fieldLabel}`,
            numberField: "数字字段"
          },
          "zh-TW": {
            decrease: e => `縮小 ${e.fieldLabel}`,
            increase: e => `放大 ${e.fieldLabel}`,
            numberField: "數字欄位"
          }
        };
        const La = new WeakMap();
        function Va(e, t, n) {
          let {
            value: r,
            children: o,
            "aria-label": i,
            "aria-labelledby": a
          } = e;
          const s = e.isDisabled || t.isDisabled;
          null != o || null != i || null != a || console.warn("If you do not provide children, you must specify an aria-label for accessibility");
          let l = t.selectedValue === r,
            {
              pressProps: u,
              isPressed: c
            } = (0, N.r7)({
              isDisabled: s
            }),
            {
              pressProps: d,
              isPressed: p
            } = (0, N.r7)({
              isDisabled: s,
              onPress() {
                t.setSelectedValue(r);
              }
            }),
            {
              focusableProps: h
            } = (0, B.kc)((0, j.dG)(e, {
              onFocus: () => t.setLastFocusedValue(r)
            }), n),
            f = (0, j.dG)(u, h),
            m = (0, j.zL)(e, {
              labelable: !0
            }),
            g = -1;
          null != t.selectedValue ? t.selectedValue === r && (g = 0) : t.lastFocusedValue !== r && null != t.lastFocusedValue || (g = 0), s && (g = void 0);
          let {
            name: v,
            descriptionId: y,
            errorMessageId: b,
            validationBehavior: w
          } = La.get(t);
          return (0, j.y$)(n, t.selectedValue, t.setSelectedValue), (0, _e.Q)({
            validationBehavior: w
          }, t, n), {
            labelProps: (0, j.dG)(d, {
              onClick: e => e.preventDefault()
            }),
            inputProps: (0, j.dG)(m, {
              ...f,
              type: "radio",
              name: v,
              tabIndex: g,
              disabled: s,
              required: t.isRequired && "native" === w,
              checked: l,
              value: r,
              onChange: e => {
                e.stopPropagation(), t.setSelectedValue(r);
              },
              "aria-describedby": [e["aria-describedby"], t.isInvalid ? b : null, y].filter(Boolean).join(" ") || void 0
            }),
            isDisabled: s,
            isSelected: l,
            isPressed: c || p
          };
        }
        function Ka(e, t) {
          let {
              name: n,
              isReadOnly: r,
              isRequired: o,
              isDisabled: i,
              orientation: a = "vertical",
              validationBehavior: s = "aria"
            } = e,
            {
              direction: l
            } = (0, V.bU)(),
            {
              isInvalid: u,
              validationErrors: c,
              validationDetails: d
            } = t.displayValidation,
            {
              labelProps: p,
              fieldProps: h,
              descriptionProps: f,
              errorMessageProps: m
            } = (0, Ae.U)({
              ...e,
              labelElementType: "span",
              isInvalid: t.isInvalid,
              errorMessage: e.errorMessage || c
            }),
            g = (0, j.zL)(e, {
              labelable: !0
            }),
            {
              focusWithinProps: v
            } = (0, N.L_)({
              onBlurWithin(n) {
                var r;
                null === (r = e.onBlur) || void 0 === r || r.call(e, n), t.selectedValue || t.setLastFocusedValue(null);
              },
              onFocusWithin: e.onFocus,
              onFocusWithinChange: e.onFocusChange
            }),
            y = (0, j.Me)(n);
          return La.set(t, {
            name: y,
            descriptionId: f.id,
            errorMessageId: m.id,
            validationBehavior: s
          }), {
            radioGroupProps: (0, j.dG)(g, {
              role: "radiogroup",
              onKeyDown: e => {
                let n;
                switch (e.key) {
                  case "ArrowRight":
                    n = "rtl" === l && "vertical" !== a ? "prev" : "next";
                    break;
                  case "ArrowLeft":
                    n = "rtl" === l && "vertical" !== a ? "next" : "prev";
                    break;
                  case "ArrowDown":
                    n = "next";
                    break;
                  case "ArrowUp":
                    n = "prev";
                    break;
                  default:
                    return;
                }
                e.preventDefault();
                let r,
                  o = (0, B.QL)(e.currentTarget, {
                    from: e.target
                  });
                "next" === n ? (r = o.nextNode(), r || (o.currentNode = e.currentTarget, r = o.firstChild())) : (r = o.previousNode(), r || (o.currentNode = e.currentTarget, r = o.lastChild())), r && (r.focus(), t.setSelectedValue(r.value));
              },
              "aria-invalid": t.isInvalid || void 0,
              "aria-errormessage": e["aria-errormessage"],
              "aria-readonly": r || void 0,
              "aria-required": o || void 0,
              "aria-disabled": i || void 0,
              "aria-orientation": a,
              ...h,
              ...v
            }),
            labelProps: p,
            descriptionProps: f,
            errorMessageProps: m,
            isInvalid: u,
            validationErrors: c,
            validationDetails: d
          };
        }
        function qa(e) {
          return e && e.__esModule ? e.default : e;
        }
        var Ha;
        function Ua(e, t, n) {
          let r = (0, V.qb)(qa(Ha), "@react-aria/searchfield"),
            {
              isDisabled: o,
              isReadOnly: i,
              onSubmit: a = () => {},
              onClear: s,
              type: l = "search"
            } = e,
            {
              labelProps: u,
              inputProps: c,
              descriptionProps: d,
              errorMessageProps: p,
              ...h
            } = (0, lr.E)({
              ...e,
              value: t.value,
              onChange: t.setValue,
              onKeyDown: i ? e.onKeyDown : (0, j.tS)(e => {
                const n = e.key;
                "Enter" === n && e.preventDefault(), o || i || ("Enter" === n && a(t.value), "Escape" === n && ("" === t.value ? e.continuePropagation() : (t.setValue(""), s && s())));
              }, e.onKeyDown),
              type: l
            }, n);
          return {
            labelProps: u,
            inputProps: {
              ...c,
              defaultValue: void 0
            },
            clearButtonProps: {
              "aria-label": r.format("Clear search"),
              excludeFromTabOrder: !0,
              preventFocusOnPress: !0,
              isDisabled: o || i,
              onPress: () => {
                t.setValue(""), s && s();
              },
              onPressStart: () => {
                var e;
                null === (e = n.current) || void 0 === e || e.focus();
              }
            },
            descriptionProps: d,
            errorMessageProps: p,
            ...h
          };
        }
        Ha = {
          "ar-AE": {
            "Clear search": "مسح البحث"
          },
          "bg-BG": {
            "Clear search": "Изчистване на търсене"
          },
          "cs-CZ": {
            "Clear search": "Vymazat hledání"
          },
          "da-DK": {
            "Clear search": "Ryd søgning"
          },
          "de-DE": {
            "Clear search": "Suche zurücksetzen"
          },
          "el-GR": {
            "Clear search": "Απαλοιφή αναζήτησης"
          },
          "en-US": {
            "Clear search": "Clear search"
          },
          "es-ES": {
            "Clear search": "Borrar búsqueda"
          },
          "et-EE": {
            "Clear search": "Tühjenda otsing"
          },
          "fi-FI": {
            "Clear search": "Tyhjennä haku"
          },
          "fr-FR": {
            "Clear search": "Effacer la recherche"
          },
          "he-IL": {
            "Clear search": "נקה חיפוש"
          },
          "hr-HR": {
            "Clear search": "Obriši pretragu"
          },
          "hu-HU": {
            "Clear search": "Keresés törlése"
          },
          "it-IT": {
            "Clear search": "Cancella ricerca"
          },
          "ja-JP": {
            "Clear search": "検索をクリア"
          },
          "ko-KR": {
            "Clear search": "검색 지우기"
          },
          "lt-LT": {
            "Clear search": "Išvalyti iešką"
          },
          "lv-LV": {
            "Clear search": "Notīrīt meklēšanu"
          },
          "nb-NO": {
            "Clear search": "Tøm søk"
          },
          "nl-NL": {
            "Clear search": "Zoekactie wissen"
          },
          "pl-PL": {
            "Clear search": "Wyczyść zawartość wyszukiwania"
          },
          "pt-BR": {
            "Clear search": "Limpar pesquisa"
          },
          "pt-PT": {
            "Clear search": "Limpar pesquisa"
          },
          "ro-RO": {
            "Clear search": "Ştergeţi căutarea"
          },
          "ru-RU": {
            "Clear search": "Очистить поиск"
          },
          "sk-SK": {
            "Clear search": "Vymazať vyhľadávanie"
          },
          "sl-SI": {
            "Clear search": "Počisti iskanje"
          },
          "sr-SP": {
            "Clear search": "Obriši pretragu"
          },
          "sv-SE": {
            "Clear search": "Rensa sökning"
          },
          "tr-TR": {
            "Clear search": "Aramayı temizle"
          },
          "uk-UA": {
            "Clear search": "Очистити пошук"
          },
          "zh-CN": {
            "Clear search": "清除搜索"
          },
          "zh-TW": {
            "Clear search": "清除搜尋條件"
          }
        };
        const Za = new WeakMap();
        function $a(e, t, n) {
          let {
              keyboardDelegate: r,
              isDisabled: o,
              isRequired: i,
              name: a,
              validationBehavior: s = "aria"
            } = e,
            l = (0, V.Xe)({
              usage: "search",
              sensitivity: "base"
            }),
            u = (0, Ee.useMemo)(() => r || new $n(t.collection, t.disabledKeys, null, l), [r, t.collection, t.disabledKeys, l]),
            {
              menuTriggerProps: c,
              menuProps: d
            } = rr({
              isDisabled: o,
              type: "listbox"
            }, t, n),
            {
              typeSelectProps: p
            } = Kn({
              keyboardDelegate: u,
              selectionManager: t.selectionManager,
              onTypeSelect(e) {
                t.setSelectedKey(e);
              }
            }),
            {
              isInvalid: h,
              validationErrors: f,
              validationDetails: m
            } = t.displayValidation,
            {
              labelProps: g,
              fieldProps: v,
              descriptionProps: y,
              errorMessageProps: b
            } = (0, Ae.U)({
              ...e,
              labelElementType: "span",
              isInvalid: h,
              errorMessage: e.errorMessage || f
            });
          p.onKeyDown = p.onKeyDownCapture, delete p.onKeyDownCapture;
          let w = (0, j.zL)(e, {
              labelable: !0
            }),
            x = (0, j.dG)(p, c, v),
            D = (0, j.Me)();
          return Za.set(t, {
            isDisabled: o,
            isRequired: i,
            name: a,
            validationBehavior: s
          }), {
            labelProps: {
              ...g,
              onClick: () => {
                e.isDisabled || (n.current.focus(), (0, N._w)("keyboard"));
              }
            },
            triggerProps: (0, j.dG)(w, {
              ...x,
              isDisabled: o,
              onKeyDown: (0, j.tS)(x.onKeyDown, e => {
                switch (e.key) {
                  case "ArrowLeft":
                    {
                      e.preventDefault();
                      let n = null != t.selectedKey ? u.getKeyAbove(t.selectedKey) : u.getFirstKey();
                      n && t.setSelectedKey(n);
                      break;
                    }
                  case "ArrowRight":
                    {
                      e.preventDefault();
                      let n = null != t.selectedKey ? u.getKeyBelow(t.selectedKey) : u.getFirstKey();
                      n && t.setSelectedKey(n);
                      break;
                    }
                }
              }, e.onKeyDown),
              onKeyUp: e.onKeyUp,
              "aria-labelledby": [D, x["aria-labelledby"], x["aria-label"] && !x["aria-labelledby"] ? x.id : null].filter(Boolean).join(" "),
              onFocus(n) {
                t.isFocused || (e.onFocus && e.onFocus(n), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
              },
              onBlur(n) {
                t.isOpen || (e.onBlur && e.onBlur(n), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
              }
            }),
            valueProps: {
              id: D
            },
            menuProps: {
              ...d,
              autoFocus: t.focusStrategy || !0,
              shouldSelectOnPressUp: !0,
              shouldFocusOnHover: !0,
              disallowEmptySelection: !0,
              linkBehavior: "selection",
              onBlur: n => {
                n.currentTarget.contains(n.relatedTarget) || (e.onBlur && e.onBlur(n), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
              },
              "aria-labelledby": [v["aria-labelledby"], x["aria-label"] && !v["aria-labelledby"] ? x.id : null].filter(Boolean).join(" ")
            },
            descriptionProps: y,
            errorMessageProps: b,
            isInvalid: h,
            validationErrors: f,
            validationDetails: m
          };
        }
        function Ga(e) {
          let {
              state: t,
              triggerRef: n,
              label: r,
              name: o,
              isDisabled: i
            } = e,
            a = (0, Ee.useRef)(null),
            {
              containerProps: s,
              inputProps: l,
              selectProps: u
            } = function (e, t, n) {
              let r = Za.get(t) || {},
                {
                  autoComplete: o,
                  name: i = r.name,
                  isDisabled: a = r.isDisabled
                } = e,
                {
                  validationBehavior: s,
                  isRequired: l
                } = r,
                u = (0, N.Kf)(),
                {
                  visuallyHiddenProps: c
                } = (0, $t.S)();
              var d;
              return (0, j.y$)(e.selectRef, t.selectedKey, t.setSelectedKey), (0, _e.Q)({
                validationBehavior: s,
                focus: () => n.current.focus()
              }, t, e.selectRef), {
                containerProps: {
                  ...c,
                  "aria-hidden": !0,
                  "data-a11y-ignore": "aria-hidden-focus"
                },
                inputProps: {
                  type: "text",
                  tabIndex: null == u || t.isFocused || t.isOpen ? -1 : 0,
                  style: {
                    fontSize: 16
                  },
                  onFocus: () => n.current.focus(),
                  disabled: a
                },
                selectProps: {
                  tabIndex: -1,
                  autoComplete: o,
                  disabled: a,
                  required: "native" === s && l,
                  name: i,
                  value: null !== (d = t.selectedKey) && void 0 !== d ? d : "",
                  onChange: e => t.setSelectedKey(e.target.value)
                }
              };
            }({
              ...e,
              selectRef: a
            }, t, n);
          var c;
          return t.collection.size <= 300 ? Ee.createElement("div", {
            ...s,
            "data-testid": "hidden-select-container"
          }, Ee.createElement("input", l), Ee.createElement("label", null, r, Ee.createElement("select", {
            ...u,
            ref: a
          }, Ee.createElement("option", null), [...t.collection.getKeys()].map(e => {
            let n = t.collection.getItem(e);
            if ("item" === n.type) return Ee.createElement("option", {
              key: n.key,
              value: n.key
            }, n.textValue);
          })))) : o ? Ee.createElement("input", {
            type: "hidden",
            autoComplete: u.autoComplete,
            name: o,
            disabled: i,
            value: null !== (c = t.selectedKey) && void 0 !== c ? c : ""
          }) : null;
        }
        function Wa(e) {
          let t,
            n = (0, j.zL)(e, {
              labelable: !0
            });
          return "vertical" === e.orientation && (t = "vertical"), "hr" !== e.elementType ? {
            separatorProps: {
              ...n,
              role: "separator",
              "aria-orientation": t
            }
          } : {
            separatorProps: n
          };
        }
        var Ya = n(13607);
        function Xa(e, t, n) {
          let {
            labelProps: r,
            inputProps: o,
            isSelected: i,
            isPressed: a,
            isDisabled: s,
            isReadOnly: l
          } = ke(e, t, n);
          return {
            labelProps: r,
            inputProps: {
              ...o,
              role: "switch",
              checked: i
            },
            isSelected: i,
            isPressed: a,
            isDisabled: s,
            isReadOnly: l
          };
        }
        var Qa;
        Qa = {
          ascending: "تصاعدي",
          ascendingSort: e => `ترتيب حسب العمود ${e.columnName} بترتيب تصاعدي`,
          columnSize: e => `${e.value} بالبكسل`,
          descending: "تنازلي",
          descendingSort: e => `ترتيب حسب العمود ${e.columnName} بترتيب تنازلي`,
          resizerDescription: "اضغط على مفتاح Enter لبدء تغيير الحجم",
          select: "تحديد",
          selectAll: "تحديد الكل",
          sortable: "عمود قابل للترتيب"
        };
        var Ja;
        Ja = {
          ascending: "възходящ",
          ascendingSort: e => `сортирано по колона ${e.columnName} във възходящ ред`,
          columnSize: e => `${e.value} пиксела`,
          descending: "низходящ",
          descendingSort: e => `сортирано по колона ${e.columnName} в низходящ ред`,
          resizerDescription: "Натиснете „Enter“, за да започнете да преоразмерявате",
          select: "Изберете",
          selectAll: "Изберете всичко",
          sortable: "сортираща колона"
        };
        var es;
        es = {
          ascending: "vzestupně",
          ascendingSort: e => `řazeno vzestupně podle sloupce ${e.columnName}`,
          columnSize: e => `${e.value} pixelů`,
          descending: "sestupně",
          descendingSort: e => `řazeno sestupně podle sloupce ${e.columnName}`,
          resizerDescription: "Stisknutím klávesy Enter začnete měnit velikost",
          select: "Vybrat",
          selectAll: "Vybrat vše",
          sortable: "sloupec s možností řazení"
        };
        var ts;
        ts = {
          ascending: "stigende",
          ascendingSort: e => `sorteret efter kolonne ${e.columnName} i stigende rækkefølge`,
          columnSize: e => `${e.value} pixels`,
          descending: "faldende",
          descendingSort: e => `sorteret efter kolonne ${e.columnName} i faldende rækkefølge`,
          resizerDescription: "Tryk på Enter for at ændre størrelse",
          select: "Vælg",
          selectAll: "Vælg alle",
          sortable: "sorterbar kolonne"
        };
        var ns;
        ns = {
          ascending: "aufsteigend",
          ascendingSort: e => `sortiert nach Spalte ${e.columnName} in aufsteigender Reihenfolge`,
          columnSize: e => `${e.value} Pixel`,
          descending: "absteigend",
          descendingSort: e => `sortiert nach Spalte ${e.columnName} in absteigender Reihenfolge`,
          resizerDescription: "Eingabetaste zum Starten der Größenänderung drücken",
          select: "Auswählen",
          selectAll: "Alles auswählen",
          sortable: "sortierbare Spalte"
        };
        var rs;
        rs = {
          ascending: "αύξουσα",
          ascendingSort: e => `διαλογή ανά στήλη ${e.columnName} σε αύξουσα σειρά`,
          columnSize: e => `${e.value} pixel`,
          descending: "φθίνουσα",
          descendingSort: e => `διαλογή ανά στήλη ${e.columnName} σε φθίνουσα σειρά`,
          resizerDescription: "Πατήστε Enter για έναρξη της αλλαγής μεγέθους",
          select: "Επιλογή",
          selectAll: "Επιλογή όλων",
          sortable: "Στήλη διαλογής"
        };
        var os;
        os = {
          select: "Select",
          selectAll: "Select All",
          sortable: "sortable column",
          ascending: "ascending",
          descending: "descending",
          ascendingSort: e => `sorted by column ${e.columnName} in ascending order`,
          descendingSort: e => `sorted by column ${e.columnName} in descending order`,
          columnSize: e => `${e.value} pixels`,
          resizerDescription: "Press Enter to start resizing"
        };
        var is;
        is = {
          ascending: "de subida",
          ascendingSort: e => `ordenado por columna ${e.columnName} en orden de subida`,
          columnSize: e => `${e.value} píxeles`,
          descending: "de bajada",
          descendingSort: e => `ordenado por columna ${e.columnName} en orden de bajada`,
          resizerDescription: "Pulse Intro para empezar a redimensionar",
          select: "Seleccionar",
          selectAll: "Seleccionar todos",
          sortable: "columna ordenable"
        };
        var as;
        as = {
          ascending: "tõusev järjestus",
          ascendingSort: e => `sorditud veeru järgi ${e.columnName} tõusvas järjestuses`,
          columnSize: e => `${e.value} pikslit`,
          descending: "laskuv järjestus",
          descendingSort: e => `sorditud veeru järgi ${e.columnName} laskuvas järjestuses`,
          resizerDescription: "Suuruse muutmise alustamiseks vajutage klahvi Enter",
          select: "Vali",
          selectAll: "Vali kõik",
          sortable: "sorditav veerg"
        };
        var ss;
        ss = {
          ascending: "nouseva",
          ascendingSort: e => `lajiteltu sarakkeen ${e.columnName} mukaan nousevassa järjestyksessä`,
          columnSize: e => `${e.value} pikseliä`,
          descending: "laskeva",
          descendingSort: e => `lajiteltu sarakkeen ${e.columnName} mukaan laskevassa järjestyksessä`,
          resizerDescription: "Aloita koon muutos painamalla Enter-näppäintä",
          select: "Valitse",
          selectAll: "Valitse kaikki",
          sortable: "lajiteltava sarake"
        };
        var ls;
        ls = {
          ascending: "croissant",
          ascendingSort: e => `trié en fonction de la colonne ${e.columnName} par ordre croissant`,
          columnSize: e => `${e.value} pixels`,
          descending: "décroissant",
          descendingSort: e => `trié en fonction de la colonne ${e.columnName} par ordre décroissant`,
          resizerDescription: "Appuyez sur Entrée pour commencer le redimensionnement.",
          select: "Sélectionner",
          selectAll: "Sélectionner tout",
          sortable: "colonne triable"
        };
        var us;
        us = {
          ascending: "עולה",
          ascendingSort: e => `מוין לפי עמודה ${e.columnName} בסדר עולה`,
          columnSize: e => `${e.value} פיקסלים`,
          descending: "יורד",
          descendingSort: e => `מוין לפי עמודה ${e.columnName} בסדר יורד`,
          resizerDescription: "הקש Enter כדי לשנות את הגודל",
          select: "בחר",
          selectAll: "בחר הכול",
          sortable: "עמודה שניתן למיין"
        };
        var cs;
        cs = {
          ascending: "rastući",
          ascendingSort: e => `razvrstano po stupcima ${e.columnName} rastućem redoslijedom`,
          columnSize: e => `${e.value} piksela`,
          descending: "padajući",
          descendingSort: e => `razvrstano po stupcima ${e.columnName} padajućim redoslijedom`,
          resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
          select: "Odaberite",
          selectAll: "Odaberite sve",
          sortable: "stupac koji se može razvrstati"
        };
        var ds;
        ds = {
          ascending: "növekvő",
          ascendingSort: e => `rendezve a(z) ${e.columnName} oszlop szerint, növekvő sorrendben`,
          columnSize: e => `${e.value} képpont`,
          descending: "csökkenő",
          descendingSort: e => `rendezve a(z) ${e.columnName} oszlop szerint, csökkenő sorrendben`,
          resizerDescription: "Nyomja le az Enter billentyűt az átméretezés megkezdéséhez",
          select: "Kijelölés",
          selectAll: "Összes kijelölése",
          sortable: "rendezendő oszlop"
        };
        var ps;
        ps = {
          ascending: "crescente",
          ascendingSort: e => `in ordine crescente in base alla colonna ${e.columnName}`,
          columnSize: e => `${e.value} pixel`,
          descending: "decrescente",
          descendingSort: e => `in ordine decrescente in base alla colonna ${e.columnName}`,
          resizerDescription: "Premi Invio per iniziare a ridimensionare",
          select: "Seleziona",
          selectAll: "Seleziona tutto",
          sortable: "colonna ordinabile"
        };
        var hs;
        hs = {
          ascending: "昇順",
          ascendingSort: e => `列 ${e.columnName} を昇順で並べ替え`,
          columnSize: e => `${e.value} ピクセル`,
          descending: "降順",
          descendingSort: e => `列 ${e.columnName} を降順で並べ替え`,
          resizerDescription: "Enter キーを押してサイズ変更を開始",
          select: "選択",
          selectAll: "すべて選択",
          sortable: "並べ替え可能な列"
        };
        var fs;
        fs = {
          ascending: "오름차순",
          ascendingSort: e => `${e.columnName} 열을 기준으로 오름차순으로 정렬됨`,
          columnSize: e => `${e.value} 픽셀`,
          descending: "내림차순",
          descendingSort: e => `${e.columnName} 열을 기준으로 내림차순으로 정렬됨`,
          resizerDescription: "크기 조정을 시작하려면 Enter를 누르세요.",
          select: "선택",
          selectAll: "모두 선택",
          sortable: "정렬 가능한 열"
        };
        var ms;
        ms = {
          ascending: "didėjančia tvarka",
          ascendingSort: e => `surikiuota pagal stulpelį ${e.columnName} didėjančia tvarka`,
          columnSize: e => `${e.value} piks.`,
          descending: "mažėjančia tvarka",
          descendingSort: e => `surikiuota pagal stulpelį ${e.columnName} mažėjančia tvarka`,
          resizerDescription: "Paspauskite „Enter“, kad pradėtumėte keisti dydį",
          select: "Pasirinkti",
          selectAll: "Pasirinkti viską",
          sortable: "rikiuojamas stulpelis"
        };
        var gs;
        gs = {
          ascending: "augošā secībā",
          ascendingSort: e => `kārtots pēc kolonnas ${e.columnName} augošā secībā`,
          columnSize: e => `${e.value} pikseļi`,
          descending: "dilstošā secībā",
          descendingSort: e => `kārtots pēc kolonnas ${e.columnName} dilstošā secībā`,
          resizerDescription: "Nospiediet Enter, lai sāktu izmēru mainīšanu",
          select: "Atlasīt",
          selectAll: "Atlasīt visu",
          sortable: "kārtojamā kolonna"
        };
        var vs;
        vs = {
          ascending: "stigende",
          ascendingSort: e => `sortert etter kolonne ${e.columnName} i stigende rekkefølge`,
          columnSize: e => `${e.value} piksler`,
          descending: "synkende",
          descendingSort: e => `sortert etter kolonne ${e.columnName} i synkende rekkefølge`,
          resizerDescription: "Trykk på Enter for å starte størrelsesendring",
          select: "Velg",
          selectAll: "Velg alle",
          sortable: "kolonne som kan sorteres"
        };
        var ys;
        ys = {
          ascending: "oplopend",
          ascendingSort: e => `gesorteerd in oplopende volgorde in kolom ${e.columnName}`,
          columnSize: e => `${e.value} pixels`,
          descending: "aflopend",
          descendingSort: e => `gesorteerd in aflopende volgorde in kolom ${e.columnName}`,
          resizerDescription: "Druk op Enter om het formaat te wijzigen",
          select: "Selecteren",
          selectAll: "Alles selecteren",
          sortable: "sorteerbare kolom"
        };
        var bs;
        bs = {
          ascending: "rosnąco",
          ascendingSort: e => `posortowano według kolumny ${e.columnName} w porządku rosnącym`,
          columnSize: e => `Liczba pikseli: ${e.value}`,
          descending: "malejąco",
          descendingSort: e => `posortowano według kolumny ${e.columnName} w porządku malejącym`,
          resizerDescription: "Naciśnij Enter, aby rozpocząć zmienianie rozmiaru",
          select: "Zaznacz",
          selectAll: "Zaznacz wszystko",
          sortable: "kolumna z możliwością sortowania"
        };
        var ws;
        ws = {
          ascending: "crescente",
          ascendingSort: e => `classificado pela coluna ${e.columnName} em ordem crescente`,
          columnSize: e => `${e.value} pixels`,
          descending: "decrescente",
          descendingSort: e => `classificado pela coluna ${e.columnName} em ordem decrescente`,
          resizerDescription: "Pressione Enter para começar a redimensionar",
          select: "Selecionar",
          selectAll: "Selecionar tudo",
          sortable: "coluna classificável"
        };
        var xs;
        xs = {
          ascending: "ascendente",
          ascendingSort: e => `Ordenar por coluna ${e.columnName} em ordem ascendente`,
          columnSize: e => `${e.value} pixels`,
          descending: "descendente",
          descendingSort: e => `Ordenar por coluna ${e.columnName} em ordem descendente`,
          resizerDescription: "Prima Enter para iniciar o redimensionamento",
          select: "Selecionar",
          selectAll: "Selecionar tudo",
          sortable: "Coluna ordenável"
        };
        var Ds;
        Ds = {
          ascending: "crescătoare",
          ascendingSort: e => `sortate după coloana ${e.columnName} în ordine crescătoare`,
          columnSize: e => `${e.value} pixeli`,
          descending: "descrescătoare",
          descendingSort: e => `sortate după coloana ${e.columnName} în ordine descrescătoare`,
          resizerDescription: "Apăsați pe Enter pentru a începe redimensionarea",
          select: "Selectare",
          selectAll: "Selectare totală",
          sortable: "coloană sortabilă"
        };
        var Cs;
        Cs = {
          ascending: "возрастание",
          ascendingSort: e => `сортировать столбец ${e.columnName} в порядке возрастания`,
          columnSize: e => `${e.value} пикс.`,
          descending: "убывание",
          descendingSort: e => `сортировать столбец ${e.columnName} в порядке убывания`,
          resizerDescription: "Нажмите клавишу Enter для начала изменения размеров",
          select: "Выбрать",
          selectAll: "Выбрать все",
          sortable: "сортируемый столбец"
        };
        var Ss;
        Ss = {
          ascending: "vzostupne",
          ascendingSort: e => `zoradené zostupne podľa stĺpca ${e.columnName}`,
          columnSize: e => `Počet pixelov: ${e.value}`,
          descending: "zostupne",
          descendingSort: e => `zoradené zostupne podľa stĺpca ${e.columnName}`,
          resizerDescription: "Stlačením klávesu Enter začnete zmenu veľkosti",
          select: "Vybrať",
          selectAll: "Vybrať všetko",
          sortable: "zoraditeľný stĺpec"
        };
        var Es;
        Es = {
          ascending: "naraščajoče",
          ascendingSort: e => `razvrščeno po stolpcu ${e.columnName} v naraščajočem vrstnem redu`,
          columnSize: e => `${e.value} slikovnih pik`,
          descending: "padajoče",
          descendingSort: e => `razvrščeno po stolpcu ${e.columnName} v padajočem vrstnem redu`,
          resizerDescription: "Pritisnite tipko Enter da začnete spreminjati velikost",
          select: "Izberite",
          selectAll: "Izberite vse",
          sortable: "razvrstljivi stolpec"
        };
        var _s;
        _s = {
          ascending: "rastući",
          ascendingSort: e => `sortirano po kolonama ${e.columnName} rastućim redosledom`,
          columnSize: e => `${e.value} piksela`,
          descending: "padajući",
          descendingSort: e => `sortirano po kolonama ${e.columnName} padajućim redosledom`,
          resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
          select: "Izaberite",
          selectAll: "Izaberite sve",
          sortable: "kolona koja se može sortirati"
        };
        var Ps;
        Ps = {
          ascending: "stigande",
          ascendingSort: e => `sorterat på kolumn ${e.columnName} i stigande ordning`,
          columnSize: e => `${e.value} pixlar`,
          descending: "fallande",
          descendingSort: e => `sorterat på kolumn ${e.columnName} i fallande ordning`,
          resizerDescription: "Tryck på Retur för att börja ändra storlek",
          select: "Markera",
          selectAll: "Markera allt",
          sortable: "sorterbar kolumn"
        };
        var ks;
        ks = {
          ascending: "artan sırada",
          ascendingSort: e => `${e.columnName} sütuna göre artan düzende sırala`,
          columnSize: e => `${e.value} piksel`,
          descending: "azalan sırada",
          descendingSort: e => `${e.columnName} sütuna göre azalan düzende sırala`,
          resizerDescription: "Yeniden boyutlandırmak için Enter'a basın",
          select: "Seç",
          selectAll: "Tümünü Seç",
          sortable: "Sıralanabilir sütun"
        };
        var As;
        As = {
          ascending: "висхідний",
          ascendingSort: e => `відсортовано за стовпцем ${e.columnName} у висхідному порядку`,
          columnSize: e => `${e.value} пікс.`,
          descending: "низхідний",
          descendingSort: e => `відсортовано за стовпцем ${e.columnName} у низхідному порядку`,
          resizerDescription: "Натисніть Enter, щоб почати зміну розміру",
          select: "Вибрати",
          selectAll: "Вибрати все",
          sortable: "сортувальний стовпець"
        };
        var zs;
        zs = {
          ascending: "升序",
          ascendingSort: e => `按列 ${e.columnName} 升序排序`,
          columnSize: e => `${e.value} 像素`,
          descending: "降序",
          descendingSort: e => `按列 ${e.columnName} 降序排序`,
          resizerDescription: "按“输入”键开始调整大小。",
          select: "选择",
          selectAll: "全选",
          sortable: "可排序的列"
        };
        var Ts;
        Ts = {
          ascending: "遞增",
          ascendingSort: e => `已依據「${e.columnName}」欄遞增排序`,
          columnSize: e => `${e.value} 像素`,
          descending: "遞減",
          descendingSort: e => `已依據「${e.columnName}」欄遞減排序`,
          resizerDescription: "按 Enter 鍵以開始調整大小",
          select: "選取",
          selectAll: "全選",
          sortable: "可排序的欄"
        };
        n(62651);
        new WeakMap();
        const Os = new WeakMap();
        function Is(e, t, n) {
          return "string" == typeof t && (t = t.replace(/\s+/g, "")), `${Os.get(e)}-${n}-${t}`;
        }
        function Fs(e, t, n) {
          var r;
          let {
              key: o,
              isDisabled: i,
              shouldSelectOnPressUp: a
            } = e,
            {
              selectionManager: s,
              selectedKey: l
            } = t,
            u = o === l,
            c = i || t.isDisabled || t.disabledKeys.has(o),
            {
              itemProps: d,
              isPressed: p
            } = Hn({
              selectionManager: s,
              key: o,
              ref: n,
              isDisabled: c,
              shouldSelectOnPressUp: a,
              linkBehavior: "selection"
            }),
            h = Is(t, o, "tab"),
            f = Is(t, o, "tabpanel"),
            {
              tabIndex: m
            } = d,
            g = t.collection.getItem(o),
            v = (0, j.zL)(null == g ? void 0 : g.props, {
              isLink: !!(null == g || null === (r = g.props) || void 0 === r ? void 0 : r.href),
              labelable: !0
            });
          return delete v.id, {
            tabProps: (0, j.dG)(v, d, {
              id: h,
              "aria-selected": u,
              "aria-disabled": c || void 0,
              "aria-controls": u ? f : void 0,
              tabIndex: c ? void 0 : m,
              role: "tab"
            }),
            isSelected: u,
            isDisabled: c,
            isPressed: p
          };
        }
        function Ms(e, t, n) {
          let r = (0, B.pu)(n) ? void 0 : 0;
          var o;
          const i = Is(t, null !== (o = e.id) && void 0 !== o ? o : null == t ? void 0 : t.selectedKey, "tabpanel"),
            a = (0, j.bE)({
              ...e,
              id: i,
              "aria-labelledby": Is(t, null == t ? void 0 : t.selectedKey, "tab")
            });
          return {
            tabPanelProps: (0, j.dG)(a, {
              tabIndex: r,
              role: "tabpanel",
              "aria-describedby": e["aria-describedby"],
              "aria-details": e["aria-details"]
            })
          };
        }
        class Rs {
          getKeyLeftOf(e) {
            return this.flipDirection ? this.getNextKey(e) : this.getPreviousKey(e);
          }
          getKeyRightOf(e) {
            return this.flipDirection ? this.getPreviousKey(e) : this.getNextKey(e);
          }
          getKeyAbove(e) {
            return this.getPreviousKey(e);
          }
          getKeyBelow(e) {
            return this.getNextKey(e);
          }
          getFirstKey() {
            let e = this.collection.getFirstKey();
            return null != e && this.disabledKeys.has(e) && (e = this.getNextKey(e)), e;
          }
          getLastKey() {
            let e = this.collection.getLastKey();
            return null != e && this.disabledKeys.has(e) && (e = this.getPreviousKey(e)), e;
          }
          getNextKey(e) {
            do {
              null == (e = this.collection.getKeyAfter(e)) && (e = this.collection.getFirstKey());
            } while (this.disabledKeys.has(e));
            return e;
          }
          getPreviousKey(e) {
            do {
              null == (e = this.collection.getKeyBefore(e)) && (e = this.collection.getLastKey());
            } while (this.disabledKeys.has(e));
            return e;
          }
          constructor(e, t, n, r = new Set()) {
            this.collection = e, this.flipDirection = "rtl" === t && "horizontal" === n, this.disabledKeys = r;
          }
        }
        function js(e, t, n) {
          let {
              orientation: r = "horizontal",
              keyboardActivation: o = "automatic"
            } = e,
            {
              collection: i,
              selectionManager: a,
              disabledKeys: s
            } = t,
            {
              direction: l
            } = (0, V.bU)(),
            u = (0, Ee.useMemo)(() => new Rs(i, l, r, s), [i, s, r, l]),
            {
              collectionProps: c
            } = qn({
              ref: n,
              selectionManager: a,
              keyboardDelegate: u,
              selectOnFocus: "automatic" === o,
              disallowEmptySelection: !0,
              scrollRef: n,
              linkBehavior: "selection"
            }),
            d = (0, j.Me)();
          Os.set(t, d);
          let p = (0, j.bE)({
            ...e,
            id: d
          });
          return {
            tabListProps: {
              ...(0, j.dG)(c, p),
              role: "tablist",
              "aria-orientation": r,
              tabIndex: void 0
            }
          };
        }
        var Bs;
        Bs = {
          removeButtonLabel: "إزالة",
          removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
        };
        var Ns;
        Ns = {
          removeButtonLabel: "Премахване",
          removeDescription: "Натиснете Delete, за да премахнете маркера."
        };
        var Ls;
        Ls = {
          removeButtonLabel: "Odebrat",
          removeDescription: "Stisknutím klávesy Delete odeberete značku."
        };
        var Vs;
        Vs = {
          removeButtonLabel: "Fjern",
          removeDescription: "Tryk på Slet for at fjerne tag."
        };
        var Ks;
        Ks = {
          removeButtonLabel: "Entfernen",
          removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
        };
        var qs;
        qs = {
          removeButtonLabel: "Κατάργηση",
          removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
        };
        var Hs;
        Hs = {
          removeDescription: "Press Delete to remove tag.",
          removeButtonLabel: "Remove"
        };
        var Us;
        Us = {
          removeButtonLabel: "Quitar",
          removeDescription: "Pulse Eliminar para quitar la etiqueta."
        };
        var Zs;
        Zs = {
          removeButtonLabel: "Eemalda",
          removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
        };
        var $s;
        $s = {
          removeButtonLabel: "Poista",
          removeDescription: "Poista tunniste painamalla Poista-painiketta."
        };
        var Gs;
        Gs = {
          removeButtonLabel: "Supprimer",
          removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
        };
        var Ws;
        Ws = {
          removeButtonLabel: "הסר",
          removeDescription: "לחץ על מחק כדי להסיר תג."
        };
        var Ys;
        Ys = {
          removeButtonLabel: "Ukloni",
          removeDescription: "Pritisnite Delete za uklanjanje oznake."
        };
        var Xs;
        Xs = {
          removeButtonLabel: "Eltávolítás",
          removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
        };
        var Qs;
        Qs = {
          removeButtonLabel: "Rimuovi",
          removeDescription: "Premi Elimina per rimuovere il tag."
        };
        var Js;
        Js = {
          removeButtonLabel: "削除",
          removeDescription: "タグを削除するには、Delete キーを押します。"
        };
        var el;
        el = {
          removeButtonLabel: "제거",
          removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
        };
        var tl;
        tl = {
          removeButtonLabel: "Pašalinti",
          removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
        };
        var nl;
        nl = {
          removeButtonLabel: "Noņemt",
          removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
        };
        var rl;
        rl = {
          removeButtonLabel: "Fjern",
          removeDescription: "Trykk på Slett for å fjerne taggen."
        };
        var ol;
        ol = {
          removeButtonLabel: "Verwijderen",
          removeDescription: "Druk op Verwijderen om de tag te verwijderen."
        };
        var il;
        il = {
          removeButtonLabel: "Usuń",
          removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
        };
        var al;
        al = {
          removeButtonLabel: "Remover",
          removeDescription: "Pressione Delete para remover a tag."
        };
        var sl;
        sl = {
          removeButtonLabel: "Eliminar",
          removeDescription: "Prima Delete para eliminar a tag."
        };
        var ll;
        ll = {
          removeButtonLabel: "Îndepărtaţi",
          removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
        };
        var ul;
        ul = {
          removeButtonLabel: "Удалить",
          removeDescription: "Нажмите DELETE, чтобы удалить тег."
        };
        var cl;
        cl = {
          removeButtonLabel: "Odstrániť",
          removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
        };
        var dl;
        dl = {
          removeButtonLabel: "Odstrani",
          removeDescription: "Pritisnite Delete, da odstranite oznako."
        };
        var pl;
        pl = {
          removeButtonLabel: "Ukloni",
          removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
        };
        var hl;
        hl = {
          removeButtonLabel: "Ta bort",
          removeDescription: "Tryck på Radera för att ta bort taggen."
        };
        var fl;
        fl = {
          removeButtonLabel: "Kaldır",
          removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
        };
        var ml;
        ml = {
          removeButtonLabel: "Вилучити",
          removeDescription: "Натисніть Delete, щоб вилучити тег."
        };
        var gl;
        gl = {
          removeButtonLabel: "删除",
          removeDescription: "按下“删除”以删除标记。"
        };
        var vl;
        function yl(e) {
          return e && e.__esModule ? e.default : e;
        }
        vl = {
          removeButtonLabel: "移除",
          removeDescription: "按 Delete 鍵以移除標記。"
        };
        const bl = new WeakMap();
        function wl(e, t, n) {
          let {
              direction: r
            } = (0, V.bU)(),
            o = e.keyboardDelegate || new $n({
              collection: t.collection,
              ref: n,
              orientation: "horizontal",
              direction: r,
              disabledKeys: t.disabledKeys
            }),
            {
              labelProps: i,
              fieldProps: a,
              descriptionProps: s,
              errorMessageProps: l
            } = (0, Ae.U)({
              ...e,
              labelElementType: "span"
            }),
            {
              gridProps: u
            } = Ia({
              ...e,
              ...a,
              keyboardDelegate: o,
              shouldFocusWrap: !0,
              linkBehavior: "override"
            }, t, n),
            [c, d] = (0, Ee.useState)(!1),
            {
              focusWithinProps: p
            } = (0, N.L_)({
              onFocusWithinChange: d
            }),
            h = (0, j.zL)(e),
            f = (0, Ee.useRef)(t.collection.size);
          return (0, Ee.useEffect)(() => {
            n.current && f.current > 0 && 0 === t.collection.size && c && n.current.focus(), f.current = t.collection.size;
          }, [t.collection.size, c, n]), bl.set(t, {
            onRemove: e.onRemove
          }), {
            gridProps: (0, j.dG)(u, h, {
              role: t.collection.size ? "grid" : null,
              "aria-atomic": !1,
              "aria-relevant": "additions",
              "aria-live": c ? "polite" : "off",
              ...p,
              ...a
            }),
            labelProps: i,
            descriptionProps: s,
            errorMessageProps: l
          };
        }
        var xl;
        function Dl(e, t, n) {
          let {
              item: r
            } = e,
            o = (0, V.qb)(yl(xl), "@react-aria/tag"),
            i = (0, j.Me)(),
            {
              onRemove: a
            } = bl.get(t) || {},
            {
              rowProps: s,
              gridCellProps: l,
              ...u
            } = Fa({
              node: r
            }, t, n);
          delete s.onKeyDownCapture;
          let {
              descriptionProps: c,
              ...d
            } = u,
            p = (0, N.Kf)();
          "virtual" === p && "undefined" != typeof window && "ontouchstart" in window && (p = "pointer");
          let h = !a || "keyboard" !== p && "virtual" !== p ? "" : o.format("removeDescription"),
            f = (0, j.PK)(h),
            m = r.key === t.selectionManager.focusedKey,
            g = (0, j.zL)(r.props),
            v = (0, j.ib)(r.props);
          return {
            removeButtonProps: {
              "aria-label": o.format("removeButtonLabel"),
              "aria-labelledby": `${i} ${s.id}`,
              id: i,
              onPress: () => a ? a(new Set([r.key])) : null,
              excludeFromTabOrder: !0
            },
            rowProps: (0, j.dG)(s, g, v, {
              tabIndex: m || null == t.selectionManager.focusedKey ? 0 : -1,
              onKeyDown: a ? e => {
                "Delete" !== e.key && "Backspace" !== e.key || (e.preventDefault(), t.selectionManager.isSelected(r.key) ? null == a || a(new Set(t.selectionManager.selectedKeys)) : null == a || a(new Set([r.key])));
              } : void 0,
              "aria-describedby": f["aria-describedby"]
            }),
            gridCellProps: (0, j.dG)(l, {
              "aria-errormessage": e["aria-errormessage"],
              "aria-label": e["aria-label"]
            }),
            ...d,
            allowsRemoving: !!a
          };
        }
        function Cl(e, t) {
          let n = (0, j.zL)(e, {
              labelable: !0
            }),
            {
              hoverProps: r
            } = (0, N.XI)({
              onHoverStart: () => null == t ? void 0 : t.open(!0),
              onHoverEnd: () => null == t ? void 0 : t.close()
            });
          return {
            tooltipProps: (0, j.dG)(n, r, {
              role: "tooltip"
            })
          };
        }
        function Sl(e, t, n) {
          let {
              isDisabled: r,
              trigger: o
            } = e,
            i = (0, j.Me)(),
            a = (0, Ee.useRef)(!1),
            s = (0, Ee.useRef)(!1),
            l = () => {
              (a.current || s.current) && t.open(s.current);
            },
            u = e => {
              a.current || s.current || t.close(e);
            };
          (0, Ee.useEffect)(() => {
            let e = e => {
              n && n.current && "Escape" === e.key && (e.stopPropagation(), t.close(!0));
            };
            if (t.isOpen) return document.addEventListener("keydown", e, !0), () => {
              document.removeEventListener("keydown", e, !0);
            };
          }, [n, t]);
          let c = () => {
              s.current = !1, a.current = !1, u(!0);
            },
            {
              hoverProps: d
            } = (0, N.XI)({
              isDisabled: r,
              onHoverStart: () => {
                "focus" !== o && ("pointer" === (0, N.Jz)() ? a.current = !0 : a.current = !1, l());
              },
              onHoverEnd: () => {
                "focus" !== o && (s.current = !1, a.current = !1, u());
              }
            }),
            {
              focusableProps: p
            } = (0, B.kc)({
              isDisabled: r,
              onFocus: () => {
                (0, N.E)() && (s.current = !0, l());
              },
              onBlur: () => {
                s.current = !1, a.current = !1, u(!0);
              }
            }, n);
          return {
            triggerProps: {
              "aria-describedby": t.isOpen ? i : void 0,
              ...(0, j.dG)(p, d, {
                onPointerDown: c,
                onKeyDown: c
              })
            },
            tooltipProps: {
              id: i
            }
          };
        }
        xl = {
          "ar-AE": Bs,
          "bg-BG": Ns,
          "cs-CZ": Ls,
          "da-DK": Vs,
          "de-DE": Ks,
          "el-GR": qs,
          "en-US": Hs,
          "es-ES": Us,
          "et-EE": Zs,
          "fi-FI": $s,
          "fr-FR": Gs,
          "he-IL": Ws,
          "hr-HR": Ys,
          "hu-HU": Xs,
          "it-IT": Qs,
          "ja-JP": Js,
          "ko-KR": el,
          "lt-LT": tl,
          "lv-LV": nl,
          "nb-NO": rl,
          "nl-NL": ol,
          "pl-PL": il,
          "pt-BR": al,
          "pt-PT": sl,
          "ro-RO": ll,
          "ru-RU": ul,
          "sk-SK": cl,
          "sl-SI": dl,
          "sr-SP": pl,
          "sv-SE": hl,
          "tr-TR": fl,
          "uk-UA": ml,
          "zh-CN": gl,
          "zh-TW": vl
        };
      },
      53441: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.DebounceInput = void 0;
        var r = i(n(67294)),
          o = i(n(91296));
        function i(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function a(e) {
          return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, a(e);
        }
        function s(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        function l(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function u(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? l(Object(n), !0).forEach(function (t) {
              g(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function c(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        function d(e, t) {
          return d = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, d(e, t);
        }
        function p(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = m(e);
            if (t) {
              var o = m(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return h(this, n);
          };
        }
        function h(e, t) {
          return !t || "object" !== a(t) && "function" != typeof t ? f(e) : t;
        }
        function f(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function m(e) {
          return m = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, m(e);
        }
        function g(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var v = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && d(e, t);
          }(l, e);
          var t,
            n,
            i,
            a = p(l);
          function l(e) {
            var t;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, l), g(f(t = a.call(this, e)), "onChange", function (e) {
              e.persist();
              var n = t.state.value,
                r = t.props.minLength;
              t.setState({
                value: e.target.value
              }, function () {
                var o = t.state.value;
                o.length >= r ? t.notify(e) : n.length > o.length && t.notify(u(u({}, e), {}, {
                  target: u(u({}, e.target), {}, {
                    value: ""
                  })
                }));
              });
            }), g(f(t), "onKeyDown", function (e) {
              "Enter" === e.key && t.forceNotify(e);
              var n = t.props.onKeyDown;
              n && (e.persist(), n(e));
            }), g(f(t), "onBlur", function (e) {
              t.forceNotify(e);
              var n = t.props.onBlur;
              n && (e.persist(), n(e));
            }), g(f(t), "createNotifier", function (e) {
              if (e < 0) t.notify = function () {
                return null;
              };else if (0 === e) t.notify = t.doNotify;else {
                var n = (0, o.default)(function (e) {
                  t.isDebouncing = !1, t.doNotify(e);
                }, e);
                t.notify = function (e) {
                  t.isDebouncing = !0, n(e);
                }, t.flush = function () {
                  return n.flush();
                }, t.cancel = function () {
                  t.isDebouncing = !1, n.cancel();
                };
              }
            }), g(f(t), "doNotify", function () {
              var e = t.props.onChange;
              e.apply(void 0, arguments);
            }), g(f(t), "forceNotify", function (e) {
              var n = t.props.debounceTimeout;
              if (t.isDebouncing || !(n > 0)) {
                t.cancel && t.cancel();
                var r = t.state.value,
                  o = t.props.minLength;
                r.length >= o ? t.doNotify(e) : t.doNotify(u(u({}, e), {}, {
                  target: u(u({}, e.target), {}, {
                    value: r
                  })
                }));
              }
            }), t.isDebouncing = !1, t.state = {
              value: void 0 === e.value || null === e.value ? "" : e.value
            };
            var n = t.props.debounceTimeout;
            return t.createNotifier(n), t;
          }
          return t = l, (n = [{
            key: "componentDidUpdate",
            value: function (e) {
              if (!this.isDebouncing) {
                var t = this.props,
                  n = t.value,
                  r = t.debounceTimeout,
                  o = e.debounceTimeout,
                  i = e.value,
                  a = this.state.value;
                void 0 !== n && i !== n && a !== n && this.setState({
                  value: n
                }), r !== o && this.createNotifier(r);
              }
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              this.flush && this.flush();
            }
          }, {
            key: "render",
            value: function () {
              var e,
                t,
                n = this.props,
                o = n.element,
                i = (n.onChange, n.value, n.minLength, n.debounceTimeout, n.forceNotifyByEnter),
                a = n.forceNotifyOnBlur,
                l = n.onKeyDown,
                c = n.onBlur,
                d = n.inputRef,
                p = s(n, ["element", "onChange", "value", "minLength", "debounceTimeout", "forceNotifyByEnter", "forceNotifyOnBlur", "onKeyDown", "onBlur", "inputRef"]),
                h = this.state.value;
              e = i ? {
                onKeyDown: this.onKeyDown
              } : l ? {
                onKeyDown: l
              } : {}, t = a ? {
                onBlur: this.onBlur
              } : c ? {
                onBlur: c
              } : {};
              var f = d ? {
                ref: d
              } : {};
              return r.default.createElement(o, u(u(u(u({}, p), {}, {
                onChange: this.onChange,
                value: h
              }, e), t), f));
            }
          }]) && c(t.prototype, n), i && c(t, i), l;
        }(r.default.PureComponent);
        t.DebounceInput = v, g(v, "defaultProps", {
          element: "input",
          type: "text",
          onKeyDown: void 0,
          onBlur: void 0,
          value: void 0,
          minLength: 0,
          debounceTimeout: 100,
          forceNotifyByEnter: !0,
          forceNotifyOnBlur: !0,
          inputRef: void 0
        });
      },
      775: (e, t, n) => {
        "use strict";

        var r = n(53441).DebounceInput;
        r.DebounceInput = r, e.exports = r;
      },
      2245: (e, t, n) => {
        "use strict";

        n.d(t, {
          WG: () => ve,
          c0: () => Ke,
          f$: () => $e,
          LW: () => Ze
        });
        var r = n(67294);
        const o = (0, r.createContext)({
          dragDropManager: void 0
        });
        var i,
          a = n(85893);
        function s(e, t, ...n) {
          if ("undefined" != typeof process && void 0 === t) throw new Error("invariant requires an error message argument");
          if (!e) {
            let e;
            if (void 0 === t) e = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
              let r = 0;
              e = new Error(t.replace(/%s/g, function () {
                return n[r++];
              })), e.name = "Invariant Violation";
            }
            throw e.framesToPop = 1, e;
          }
        }
        !function (e) {
          e.SOURCE = "SOURCE", e.TARGET = "TARGET";
        }(i || (i = {}));
        const l = "dnd-core/INIT_COORDS",
          u = "dnd-core/BEGIN_DRAG",
          c = "dnd-core/PUBLISH_DRAG_SOURCE",
          d = "dnd-core/HOVER",
          p = "dnd-core/DROP",
          h = "dnd-core/END_DRAG";
        function f(e, t) {
          return {
            type: l,
            payload: {
              sourceClientOffset: t || null,
              clientOffset: e || null
            }
          };
        }
        function m(e) {
          return "object" == typeof e;
        }
        const g = {
          type: l,
          payload: {
            clientOffset: null,
            sourceClientOffset: null
          }
        };
        function v(e) {
          return function (t = [], n = {
            publishSource: !0
          }) {
            const {
                publishSource: r = !0,
                clientOffset: o,
                getSourceClientOffset: i
              } = n,
              a = e.getMonitor(),
              l = e.getRegistry();
            e.dispatch(f(o)), function (e, t, n) {
              s(!t.isDragging(), "Cannot call beginDrag while dragging."), e.forEach(function (e) {
                s(n.getSource(e), "Expected sourceIds to be registered.");
              });
            }(t, a, l);
            const c = function (e, t) {
              let n = null;
              for (let r = e.length - 1; r >= 0; r--) if (t.canDragSource(e[r])) {
                n = e[r];
                break;
              }
              return n;
            }(t, a);
            if (null == c) return void e.dispatch(g);
            let d = null;
            if (o) {
              if (!i) throw new Error("getSourceClientOffset must be defined");
              !function (e) {
                s("function" == typeof e, "When clientOffset is provided, getSourceClientOffset must be a function.");
              }(i), d = i(c);
            }
            e.dispatch(f(o, d));
            const p = l.getSource(c).beginDrag(a, c);
            if (null == p) return;
            !function (e) {
              s(m(e), "Item must be an object.");
            }(p), l.pinSource(c);
            const h = l.getSourceType(c);
            return {
              type: u,
              payload: {
                itemType: h,
                item: p,
                sourceId: c,
                clientOffset: o || null,
                sourceClientOffset: d || null,
                isSourcePublic: !!r
              }
            };
          };
        }
        function y(e) {
          return function () {
            if (e.getMonitor().isDragging()) return {
              type: c
            };
          };
        }
        function b(e, t) {
          return null === t ? null === e : Array.isArray(e) ? e.some(e => e === t) : e === t;
        }
        function w(e) {
          return function (t, {
            clientOffset: n
          } = {}) {
            !function (e) {
              s(Array.isArray(e), "Expected targetIds to be an array.");
            }(t);
            const r = t.slice(0),
              o = e.getMonitor(),
              i = e.getRegistry();
            !function (e, t, n) {
              s(t.isDragging(), "Cannot call hover while not dragging."), s(!t.didDrop(), "Cannot call hover after drop.");
              for (let t = 0; t < e.length; t++) {
                const r = e[t];
                s(e.lastIndexOf(r) === t, "Expected targetIds to be unique in the passed array.");
                s(n.getTarget(r), "Expected targetIds to be registered.");
              }
            }(r, o, i);
            return function (e, t, n) {
              for (let r = e.length - 1; r >= 0; r--) {
                const o = e[r];
                b(t.getTargetType(o), n) || e.splice(r, 1);
              }
            }(r, i, o.getItemType()), function (e, t, n) {
              e.forEach(function (e) {
                n.getTarget(e).hover(t, e);
              });
            }(r, o, i), {
              type: d,
              payload: {
                targetIds: r,
                clientOffset: n || null
              }
            };
          };
        }
        function x(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function D(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), r.forEach(function (t) {
              x(e, t, n[t]);
            });
          }
          return e;
        }
        function C(e) {
          return function (t = {}) {
            const n = e.getMonitor(),
              r = e.getRegistry();
            !function (e) {
              s(e.isDragging(), "Cannot call drop while not dragging."), s(!e.didDrop(), "Cannot call drop twice during one drag operation.");
            }(n);
            const o = function (e) {
              const t = e.getTargetIds().filter(e.canDropOnTarget, e);
              return t.reverse(), t;
            }(n);
            o.forEach((o, i) => {
              const a = function (e, t, n, r) {
                  const o = n.getTarget(e);
                  let i = o ? o.drop(r, e) : void 0;
                  (function (e) {
                    s(void 0 === e || m(e), "Drop result must either be an object or undefined.");
                  })(i), void 0 === i && (i = 0 === t ? {} : r.getDropResult());
                  return i;
                }(o, i, r, n),
                l = {
                  type: p,
                  payload: {
                    dropResult: D({}, t, a)
                  }
                };
              e.dispatch(l);
            });
          };
        }
        function S(e) {
          return function () {
            const t = e.getMonitor(),
              n = e.getRegistry();
            !function (e) {
              s(e.isDragging(), "Cannot call endDrag while not dragging.");
            }(t);
            const r = t.getSourceId();
            if (null != r) {
              n.getSource(r, !0).endDrag(t, r), n.unpinSource();
            }
            return {
              type: h
            };
          };
        }
        class E {
          receiveBackend(e) {
            this.backend = e;
          }
          getMonitor() {
            return this.monitor;
          }
          getBackend() {
            return this.backend;
          }
          getRegistry() {
            return this.monitor.registry;
          }
          getActions() {
            const e = this,
              {
                dispatch: t
              } = this.store;
            const n = function (e) {
              return {
                beginDrag: v(e),
                publishDragSource: y(e),
                hover: w(e),
                drop: C(e),
                endDrag: S(e)
              };
            }(this);
            return Object.keys(n).reduce((r, o) => {
              const i = n[o];
              var a;
              return r[o] = (a = i, (...n) => {
                const r = a.apply(e, n);
                void 0 !== r && t(r);
              }), r;
            }, {});
          }
          dispatch(e) {
            this.store.dispatch(e);
          }
          constructor(e, t) {
            this.isSetUp = !1, this.handleRefCountChange = () => {
              const e = this.store.getState().refCount > 0;
              this.backend && (e && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !e && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
            }, this.store = e, this.monitor = t, e.subscribe(this.handleRefCountChange);
          }
        }
        function _(e) {
          return "Minified Redux error #" + e + "; visit https://redux.js.org/Errors?code=" + e + " for the full message or use the non-minified dev environment for full errors. ";
        }
        var P = "function" == typeof Symbol && Symbol.observable || "@@observable",
          k = function () {
            return Math.random().toString(36).substring(7).split("").join(".");
          },
          A = {
            INIT: "@@redux/INIT" + k(),
            REPLACE: "@@redux/REPLACE" + k(),
            PROBE_UNKNOWN_ACTION: function () {
              return "@@redux/PROBE_UNKNOWN_ACTION" + k();
            }
          };
        function z(e) {
          if ("object" != typeof e || null === e) return !1;
          for (var t = e; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
          return Object.getPrototypeOf(e) === t;
        }
        function T(e, t, n) {
          var r;
          if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error(_(0));
          if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
            if ("function" != typeof n) throw new Error(_(1));
            return n(T)(e, t);
          }
          if ("function" != typeof e) throw new Error(_(2));
          var o = e,
            i = t,
            a = [],
            s = a,
            l = !1;
          function u() {
            s === a && (s = a.slice());
          }
          function c() {
            if (l) throw new Error(_(3));
            return i;
          }
          function d(e) {
            if ("function" != typeof e) throw new Error(_(4));
            if (l) throw new Error(_(5));
            var t = !0;
            return u(), s.push(e), function () {
              if (t) {
                if (l) throw new Error(_(6));
                t = !1, u();
                var n = s.indexOf(e);
                s.splice(n, 1), a = null;
              }
            };
          }
          function p(e) {
            if (!z(e)) throw new Error(_(7));
            if (void 0 === e.type) throw new Error(_(8));
            if (l) throw new Error(_(9));
            try {
              l = !0, i = o(i, e);
            } finally {
              l = !1;
            }
            for (var t = a = s, n = 0; n < t.length; n++) {
              (0, t[n])();
            }
            return e;
          }
          return p({
            type: A.INIT
          }), (r = {
            dispatch: p,
            subscribe: d,
            getState: c,
            replaceReducer: function (e) {
              if ("function" != typeof e) throw new Error(_(10));
              o = e, p({
                type: A.REPLACE
              });
            }
          })[P] = function () {
            var e,
              t = d;
            return (e = {
              subscribe: function (e) {
                if ("object" != typeof e || null === e) throw new Error(_(11));
                function n() {
                  e.next && e.next(c());
                }
                return n(), {
                  unsubscribe: t(n)
                };
              }
            })[P] = function () {
              return this;
            }, e;
          }, r;
        }
        const O = (e, t) => e === t;
        function I(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        const F = {
          initialSourceClientOffset: null,
          initialClientOffset: null,
          clientOffset: null
        };
        function M(e = F, t) {
          const {
            payload: n
          } = t;
          switch (t.type) {
            case l:
            case u:
              return {
                initialSourceClientOffset: n.sourceClientOffset,
                initialClientOffset: n.clientOffset,
                clientOffset: n.clientOffset
              };
            case d:
              return r = e.clientOffset, o = n.clientOffset, !r && !o || r && o && r.x === o.x && r.y === o.y ? e : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {},
                    r = Object.keys(n);
                  "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
                    return Object.getOwnPropertyDescriptor(n, e).enumerable;
                  }))), r.forEach(function (t) {
                    I(e, t, n[t]);
                  });
                }
                return e;
              }({}, e, {
                clientOffset: n.clientOffset
              });
            case h:
            case p:
              return F;
            default:
              return e;
          }
          var r, o;
        }
        const R = "dnd-core/ADD_SOURCE",
          j = "dnd-core/ADD_TARGET",
          B = "dnd-core/REMOVE_SOURCE",
          N = "dnd-core/REMOVE_TARGET";
        function L(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function V(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), r.forEach(function (t) {
              L(e, t, n[t]);
            });
          }
          return e;
        }
        const K = {
          itemType: null,
          item: null,
          sourceId: null,
          targetIds: [],
          dropResult: null,
          didDrop: !1,
          isSourcePublic: null
        };
        function q(e = K, t) {
          const {
            payload: n
          } = t;
          switch (t.type) {
            case u:
              return V({}, e, {
                itemType: n.itemType,
                item: n.item,
                sourceId: n.sourceId,
                isSourcePublic: n.isSourcePublic,
                dropResult: null,
                didDrop: !1
              });
            case c:
              return V({}, e, {
                isSourcePublic: !0
              });
            case d:
              return V({}, e, {
                targetIds: n.targetIds
              });
            case N:
              return -1 === e.targetIds.indexOf(n.targetId) ? e : V({}, e, {
                targetIds: (r = e.targetIds, o = n.targetId, r.filter(e => e !== o))
              });
            case p:
              return V({}, e, {
                dropResult: n.dropResult,
                didDrop: !0,
                targetIds: []
              });
            case h:
              return V({}, e, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: !1,
                isSourcePublic: null,
                targetIds: []
              });
            default:
              return e;
          }
          var r, o;
        }
        function H(e = 0, t) {
          switch (t.type) {
            case R:
            case j:
              return e + 1;
            case B:
            case N:
              return e - 1;
            default:
              return e;
          }
        }
        const U = [],
          Z = [];
        function $(e = U, t) {
          switch (t.type) {
            case d:
              break;
            case R:
            case j:
            case N:
            case B:
              return U;
            default:
              return Z;
          }
          const {
              targetIds: n = [],
              prevTargetIds: r = []
            } = t.payload,
            o = function (e, t) {
              const n = new Map(),
                r = e => {
                  n.set(e, n.has(e) ? n.get(e) + 1 : 1);
                };
              e.forEach(r), t.forEach(r);
              const o = [];
              return n.forEach((e, t) => {
                1 === e && o.push(t);
              }), o;
            }(n, r);
          if (!(o.length > 0 || !function (e, t, n = O) {
            if (e.length !== t.length) return !1;
            for (let r = 0; r < e.length; ++r) if (!n(e[r], t[r])) return !1;
            return !0;
          }(n, r))) return U;
          const i = r[r.length - 1],
            a = n[n.length - 1];
          return i !== a && (i && o.push(i), a && o.push(a)), o;
        }
        function G(e = 0) {
          return e + 1;
        }
        function W(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function Y(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), r.forEach(function (t) {
              W(e, t, n[t]);
            });
          }
          return e;
        }
        function X(e = {}, t) {
          return {
            dirtyHandlerIds: $(e.dirtyHandlerIds, {
              type: t.type,
              payload: Y({}, t.payload, {
                prevTargetIds: (n = e, r = "dragOperation.targetIds", o = [], r.split(".").reduce((e, t) => e && e[t] ? e[t] : o || null, n))
              })
            }),
            dragOffset: M(e.dragOffset, t),
            refCount: H(e.refCount, t),
            dragOperation: q(e.dragOperation, t),
            stateId: G(e.stateId)
          };
          var n, r, o;
        }
        function Q(e, t) {
          return {
            x: e.x - t.x,
            y: e.y - t.y
          };
        }
        U.__IS_NONE__ = !0, Z.__IS_ALL__ = !0;
        class J {
          subscribeToStateChange(e, t = {}) {
            const {
              handlerIds: n
            } = t;
            s("function" == typeof e, "listener must be a function."), s(void 0 === n || Array.isArray(n), "handlerIds, when specified, must be an array of strings.");
            let r = this.store.getState().stateId;
            return this.store.subscribe(() => {
              const t = this.store.getState(),
                o = t.stateId;
              try {
                const i = o === r || o === r + 1 && !function (e, t) {
                  return e !== U && (e === Z || void 0 === t || (n = e, t.filter(e => n.indexOf(e) > -1)).length > 0);
                  var n;
                }(t.dirtyHandlerIds, n);
                i || e();
              } finally {
                r = o;
              }
            });
          }
          subscribeToOffsetChange(e) {
            s("function" == typeof e, "listener must be a function.");
            let t = this.store.getState().dragOffset;
            return this.store.subscribe(() => {
              const n = this.store.getState().dragOffset;
              n !== t && (t = n, e());
            });
          }
          canDragSource(e) {
            if (!e) return !1;
            const t = this.registry.getSource(e);
            return s(t, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() && t.canDrag(this, e);
          }
          canDropOnTarget(e) {
            if (!e) return !1;
            const t = this.registry.getTarget(e);
            if (s(t, `Expected to find a valid target. targetId=${e}`), !this.isDragging() || this.didDrop()) return !1;
            return b(this.registry.getTargetType(e), this.getItemType()) && t.canDrop(this, e);
          }
          isDragging() {
            return Boolean(this.getItemType());
          }
          isDraggingSource(e) {
            if (!e) return !1;
            const t = this.registry.getSource(e, !0);
            if (s(t, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() || !this.isSourcePublic()) return !1;
            return this.registry.getSourceType(e) === this.getItemType() && t.isDragging(this, e);
          }
          isOverTarget(e, t = {
            shallow: !1
          }) {
            if (!e) return !1;
            const {
              shallow: n
            } = t;
            if (!this.isDragging()) return !1;
            const r = this.registry.getTargetType(e),
              o = this.getItemType();
            if (o && !b(r, o)) return !1;
            const i = this.getTargetIds();
            if (!i.length) return !1;
            const a = i.indexOf(e);
            return n ? a === i.length - 1 : a > -1;
          }
          getItemType() {
            return this.store.getState().dragOperation.itemType;
          }
          getItem() {
            return this.store.getState().dragOperation.item;
          }
          getSourceId() {
            return this.store.getState().dragOperation.sourceId;
          }
          getTargetIds() {
            return this.store.getState().dragOperation.targetIds;
          }
          getDropResult() {
            return this.store.getState().dragOperation.dropResult;
          }
          didDrop() {
            return this.store.getState().dragOperation.didDrop;
          }
          isSourcePublic() {
            return Boolean(this.store.getState().dragOperation.isSourcePublic);
          }
          getInitialClientOffset() {
            return this.store.getState().dragOffset.initialClientOffset;
          }
          getInitialSourceClientOffset() {
            return this.store.getState().dragOffset.initialSourceClientOffset;
          }
          getClientOffset() {
            return this.store.getState().dragOffset.clientOffset;
          }
          getSourceClientOffset() {
            return function (e) {
              const {
                clientOffset: t,
                initialClientOffset: n,
                initialSourceClientOffset: r
              } = e;
              return t && n && r ? Q((i = r, {
                x: (o = t).x + i.x,
                y: o.y + i.y
              }), n) : null;
              var o, i;
            }(this.store.getState().dragOffset);
          }
          getDifferenceFromInitialOffset() {
            return function (e) {
              const {
                clientOffset: t,
                initialClientOffset: n
              } = e;
              return t && n ? Q(t, n) : null;
            }(this.store.getState().dragOffset);
          }
          constructor(e, t) {
            this.store = e, this.registry = t;
          }
        }
        let ee = 0;
        function te(e, t) {
          t && Array.isArray(e) ? e.forEach(e => te(e, !1)) : s("string" == typeof e || "symbol" == typeof e, t ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
        }
        const ne = void 0 !== n.g ? n.g : self,
          re = ne.MutationObserver || ne.WebKitMutationObserver;
        function oe(e) {
          return function () {
            const t = setTimeout(r, 0),
              n = setInterval(r, 50);
            function r() {
              clearTimeout(t), clearInterval(n), e();
            }
          };
        }
        const ie = "function" == typeof re ? function (e) {
          let t = 1;
          const n = new re(e),
            r = document.createTextNode("");
          return n.observe(r, {
            characterData: !0
          }), function () {
            t = -t, r.data = t;
          };
        } : oe;
        class ae {
          call() {
            try {
              this.task && this.task();
            } catch (e) {
              this.onError(e);
            } finally {
              this.task = null, this.release(this);
            }
          }
          constructor(e, t) {
            this.onError = e, this.release = t, this.task = null;
          }
        }
        const se = new class {
            enqueueTask(e) {
              const {
                queue: t,
                requestFlush: n
              } = this;
              t.length || (n(), this.flushing = !0), t[t.length] = e;
            }
            constructor() {
              this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
                const {
                  queue: e
                } = this;
                for (; this.index < e.length;) {
                  const t = this.index;
                  if (this.index++, e[t].call(), this.index > this.capacity) {
                    for (let t = 0, n = e.length - this.index; t < n; t++) e[t] = e[t + this.index];
                    e.length -= this.index, this.index = 0;
                  }
                }
                e.length = 0, this.index = 0, this.flushing = !1;
              }, this.registerPendingError = e => {
                this.pendingErrors.push(e), this.requestErrorThrow();
              }, this.requestFlush = ie(this.flush), this.requestErrorThrow = oe(() => {
                if (this.pendingErrors.length) throw this.pendingErrors.shift();
              });
            }
          }(),
          le = new class {
            create(e) {
              const t = this.freeTasks,
                n = t.length ? t.pop() : new ae(this.onError, e => t[t.length] = e);
              return n.task = e, n;
            }
            constructor(e) {
              this.onError = e, this.freeTasks = [];
            }
          }(se.registerPendingError);
        function ue(e) {
          const t = (ee++).toString();
          switch (e) {
            case i.SOURCE:
              return `S${t}`;
            case i.TARGET:
              return `T${t}`;
            default:
              throw new Error(`Unknown Handler Role: ${e}`);
          }
        }
        function ce(e) {
          switch (e[0]) {
            case "S":
              return i.SOURCE;
            case "T":
              return i.TARGET;
            default:
              throw new Error(`Cannot parse handler ID: ${e}`);
          }
        }
        function de(e, t) {
          const n = e.entries();
          let r = !1;
          do {
            const {
              done: e,
              value: [, o]
            } = n.next();
            if (o === t) return !0;
            r = !!e;
          } while (!r);
          return !1;
        }
        class pe {
          addSource(e, t) {
            te(e), function (e) {
              s("function" == typeof e.canDrag, "Expected canDrag to be a function."), s("function" == typeof e.beginDrag, "Expected beginDrag to be a function."), s("function" == typeof e.endDrag, "Expected endDrag to be a function.");
            }(t);
            const n = this.addHandler(i.SOURCE, e, t);
            return this.store.dispatch(function (e) {
              return {
                type: R,
                payload: {
                  sourceId: e
                }
              };
            }(n)), n;
          }
          addTarget(e, t) {
            te(e, !0), function (e) {
              s("function" == typeof e.canDrop, "Expected canDrop to be a function."), s("function" == typeof e.hover, "Expected hover to be a function."), s("function" == typeof e.drop, "Expected beginDrag to be a function.");
            }(t);
            const n = this.addHandler(i.TARGET, e, t);
            return this.store.dispatch(function (e) {
              return {
                type: j,
                payload: {
                  targetId: e
                }
              };
            }(n)), n;
          }
          containsHandler(e) {
            return de(this.dragSources, e) || de(this.dropTargets, e);
          }
          getSource(e, t = !1) {
            s(this.isSourceId(e), "Expected a valid source ID.");
            return t && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
          }
          getTarget(e) {
            return s(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
          }
          getSourceType(e) {
            return s(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
          }
          getTargetType(e) {
            return s(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
          }
          isSourceId(e) {
            return ce(e) === i.SOURCE;
          }
          isTargetId(e) {
            return ce(e) === i.TARGET;
          }
          removeSource(e) {
            var t;
            s(this.getSource(e), "Expected an existing source."), this.store.dispatch(function (e) {
              return {
                type: B,
                payload: {
                  sourceId: e
                }
              };
            }(e)), t = () => {
              this.dragSources.delete(e), this.types.delete(e);
            }, se.enqueueTask(le.create(t));
          }
          removeTarget(e) {
            s(this.getTarget(e), "Expected an existing target."), this.store.dispatch(function (e) {
              return {
                type: N,
                payload: {
                  targetId: e
                }
              };
            }(e)), this.dropTargets.delete(e), this.types.delete(e);
          }
          pinSource(e) {
            const t = this.getSource(e);
            s(t, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = t;
          }
          unpinSource() {
            s(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
          }
          addHandler(e, t, n) {
            const r = ue(e);
            return this.types.set(r, t), e === i.SOURCE ? this.dragSources.set(r, n) : e === i.TARGET && this.dropTargets.set(r, n), r;
          }
          constructor(e) {
            this.types = new Map(), this.dragSources = new Map(), this.dropTargets = new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
          }
        }
        function he(e, t, n = {}, r = !1) {
          const o = function (e) {
              const t = "undefined" != typeof window && window.__REDUX_DEVTOOLS_EXTENSION__;
              return T(X, e && t && t({
                name: "dnd-core",
                instanceId: "dnd-core"
              }));
            }(r),
            i = new J(o, new pe(o)),
            a = new E(o, i),
            s = e(a, t, n);
          return a.receiveBackend(s), a;
        }
        function fe(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        let me = 0;
        const ge = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
        var ve = (0, r.memo)(function (e) {
          var {
              children: t
            } = e,
            n = fe(e, ["children"]);
          const [i, s] = function (e) {
            if ("manager" in e) {
              return [{
                dragDropManager: e.manager
              }, !1];
            }
            const t = function (e, t = ye(), n, r) {
                const o = t;
                o[ge] || (o[ge] = {
                  dragDropManager: he(e, t, n, r)
                });
                return o[ge];
              }(e.backend, e.context, e.options, e.debugMode),
              n = !e.context;
            return [t, n];
          }(n);
          return (0, r.useEffect)(() => {
            if (s) {
              const e = ye();
              return ++me, () => {
                0 == --me && (e[ge] = null);
              };
            }
          }, []), (0, a.jsx)(o.Provider, {
            value: i,
            children: t
          });
        });
        function ye() {
          return void 0 !== n.g ? n.g : window;
        }
        (0, r.memo)(function ({
          connect: e,
          src: t
        }) {
          return (0, r.useEffect)(() => {
            if ("undefined" == typeof Image) return;
            let n = !1;
            const r = new Image();
            return r.src = t, r.onload = () => {
              e(r), n = !0;
            }, () => {
              n && e(null);
            };
          }), null;
        });
        let be = !1,
          we = !1;
        class xe {
          receiveHandlerId(e) {
            this.sourceId = e;
          }
          getHandlerId() {
            return this.sourceId;
          }
          canDrag() {
            s(!be, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
            try {
              return be = !0, this.internalMonitor.canDragSource(this.sourceId);
            } finally {
              be = !1;
            }
          }
          isDragging() {
            if (!this.sourceId) return !1;
            s(!we, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
            try {
              return we = !0, this.internalMonitor.isDraggingSource(this.sourceId);
            } finally {
              we = !1;
            }
          }
          subscribeToStateChange(e, t) {
            return this.internalMonitor.subscribeToStateChange(e, t);
          }
          isDraggingSource(e) {
            return this.internalMonitor.isDraggingSource(e);
          }
          isOverTarget(e, t) {
            return this.internalMonitor.isOverTarget(e, t);
          }
          getTargetIds() {
            return this.internalMonitor.getTargetIds();
          }
          isSourcePublic() {
            return this.internalMonitor.isSourcePublic();
          }
          getSourceId() {
            return this.internalMonitor.getSourceId();
          }
          subscribeToOffsetChange(e) {
            return this.internalMonitor.subscribeToOffsetChange(e);
          }
          canDragSource(e) {
            return this.internalMonitor.canDragSource(e);
          }
          canDropOnTarget(e) {
            return this.internalMonitor.canDropOnTarget(e);
          }
          getItemType() {
            return this.internalMonitor.getItemType();
          }
          getItem() {
            return this.internalMonitor.getItem();
          }
          getDropResult() {
            return this.internalMonitor.getDropResult();
          }
          didDrop() {
            return this.internalMonitor.didDrop();
          }
          getInitialClientOffset() {
            return this.internalMonitor.getInitialClientOffset();
          }
          getInitialSourceClientOffset() {
            return this.internalMonitor.getInitialSourceClientOffset();
          }
          getSourceClientOffset() {
            return this.internalMonitor.getSourceClientOffset();
          }
          getClientOffset() {
            return this.internalMonitor.getClientOffset();
          }
          getDifferenceFromInitialOffset() {
            return this.internalMonitor.getDifferenceFromInitialOffset();
          }
          constructor(e) {
            this.sourceId = null, this.internalMonitor = e.getMonitor();
          }
        }
        let De = !1;
        class Ce {
          receiveHandlerId(e) {
            this.targetId = e;
          }
          getHandlerId() {
            return this.targetId;
          }
          subscribeToStateChange(e, t) {
            return this.internalMonitor.subscribeToStateChange(e, t);
          }
          canDrop() {
            if (!this.targetId) return !1;
            s(!De, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
            try {
              return De = !0, this.internalMonitor.canDropOnTarget(this.targetId);
            } finally {
              De = !1;
            }
          }
          isOver(e) {
            return !!this.targetId && this.internalMonitor.isOverTarget(this.targetId, e);
          }
          getItemType() {
            return this.internalMonitor.getItemType();
          }
          getItem() {
            return this.internalMonitor.getItem();
          }
          getDropResult() {
            return this.internalMonitor.getDropResult();
          }
          didDrop() {
            return this.internalMonitor.didDrop();
          }
          getInitialClientOffset() {
            return this.internalMonitor.getInitialClientOffset();
          }
          getInitialSourceClientOffset() {
            return this.internalMonitor.getInitialSourceClientOffset();
          }
          getSourceClientOffset() {
            return this.internalMonitor.getSourceClientOffset();
          }
          getClientOffset() {
            return this.internalMonitor.getClientOffset();
          }
          getDifferenceFromInitialOffset() {
            return this.internalMonitor.getDifferenceFromInitialOffset();
          }
          constructor(e) {
            this.targetId = null, this.internalMonitor = e.getMonitor();
          }
        }
        function Se(e) {
          return (t = null, n = null) => {
            if (!(0, r.isValidElement)(t)) {
              const r = t;
              return e(r, n), r;
            }
            const o = t;
            !function (e) {
              if ("string" == typeof e.type) return;
              const t = e.type.displayName || e.type.name || "the component";
              throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${t} into a <div>, or turn it into a drag source or a drop target itself.`);
            }(o);
            return function (e, t) {
              const n = e.ref;
              return s("string" != typeof n, "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), n ? (0, r.cloneElement)(e, {
                ref: e => {
                  _e(n, e), _e(t, e);
                }
              }) : (0, r.cloneElement)(e, {
                ref: t
              });
            }(o, n ? t => e(t, n) : e);
          };
        }
        function Ee(e) {
          const t = {};
          return Object.keys(e).forEach(n => {
            const r = e[n];
            if (n.endsWith("Ref")) t[n] = e[n];else {
              const e = Se(r);
              t[n] = () => e;
            }
          }), t;
        }
        function _e(e, t) {
          "function" == typeof e ? e(t) : e.current = t;
        }
        function Pe(e) {
          return null !== e && "object" == typeof e && Object.prototype.hasOwnProperty.call(e, "current");
        }
        function ke(e, t, n, r) {
          let o = n ? n.call(r, e, t) : void 0;
          if (void 0 !== o) return !!o;
          if (e === t) return !0;
          if ("object" != typeof e || !e || "object" != typeof t || !t) return !1;
          const i = Object.keys(e),
            a = Object.keys(t);
          if (i.length !== a.length) return !1;
          const s = Object.prototype.hasOwnProperty.bind(t);
          for (let a = 0; a < i.length; a++) {
            const l = i[a];
            if (!s(l)) return !1;
            const u = e[l],
              c = t[l];
            if (o = n ? n.call(r, u, c, l) : void 0, !1 === o || void 0 === o && u !== c) return !1;
          }
          return !0;
        }
        class Ae {
          receiveHandlerId(e) {
            this.handlerId !== e && (this.handlerId = e, this.reconnect());
          }
          get connectTarget() {
            return this.dragSource;
          }
          get dragSourceOptions() {
            return this.dragSourceOptionsInternal;
          }
          set dragSourceOptions(e) {
            this.dragSourceOptionsInternal = e;
          }
          get dragPreviewOptions() {
            return this.dragPreviewOptionsInternal;
          }
          set dragPreviewOptions(e) {
            this.dragPreviewOptionsInternal = e;
          }
          reconnect() {
            const e = this.reconnectDragSource();
            this.reconnectDragPreview(e);
          }
          reconnectDragSource() {
            const e = this.dragSource,
              t = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
            return t && this.disconnectDragSource(), this.handlerId ? e ? (t && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)), t) : (this.lastConnectedDragSource = e, t) : t;
          }
          reconnectDragPreview(e = !1) {
            const t = this.dragPreview,
              n = e || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
            n && this.disconnectDragPreview(), this.handlerId && (t ? n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = t, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, t, this.dragPreviewOptions)) : this.lastConnectedDragPreview = t);
          }
          didHandlerIdChange() {
            return this.lastConnectedHandlerId !== this.handlerId;
          }
          didConnectedDragSourceChange() {
            return this.lastConnectedDragSource !== this.dragSource;
          }
          didConnectedDragPreviewChange() {
            return this.lastConnectedDragPreview !== this.dragPreview;
          }
          didDragSourceOptionsChange() {
            return !ke(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
          }
          didDragPreviewOptionsChange() {
            return !ke(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
          }
          disconnectDragSource() {
            this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
          }
          disconnectDragPreview() {
            this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
          }
          get dragSource() {
            return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
          }
          get dragPreview() {
            return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
          }
          clearDragSource() {
            this.dragSourceNode = null, this.dragSourceRef = null;
          }
          clearDragPreview() {
            this.dragPreviewNode = null, this.dragPreviewRef = null;
          }
          constructor(e) {
            this.hooks = Ee({
              dragSource: (e, t) => {
                this.clearDragSource(), this.dragSourceOptions = t || null, Pe(e) ? this.dragSourceRef = e : this.dragSourceNode = e, this.reconnectDragSource();
              },
              dragPreview: (e, t) => {
                this.clearDragPreview(), this.dragPreviewOptions = t || null, Pe(e) ? this.dragPreviewRef = e : this.dragPreviewNode = e, this.reconnectDragPreview();
              }
            }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
          }
        }
        class ze {
          get connectTarget() {
            return this.dropTarget;
          }
          reconnect() {
            const e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
            e && this.disconnectDropTarget();
            const t = this.dropTarget;
            this.handlerId && (t ? e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = t, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, t, this.dropTargetOptions)) : this.lastConnectedDropTarget = t);
          }
          receiveHandlerId(e) {
            e !== this.handlerId && (this.handlerId = e, this.reconnect());
          }
          get dropTargetOptions() {
            return this.dropTargetOptionsInternal;
          }
          set dropTargetOptions(e) {
            this.dropTargetOptionsInternal = e;
          }
          didHandlerIdChange() {
            return this.lastConnectedHandlerId !== this.handlerId;
          }
          didDropTargetChange() {
            return this.lastConnectedDropTarget !== this.dropTarget;
          }
          didOptionsChange() {
            return !ke(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
          }
          disconnectDropTarget() {
            this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
          }
          get dropTarget() {
            return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
          }
          clearDropTarget() {
            this.dropTargetRef = null, this.dropTargetNode = null;
          }
          constructor(e) {
            this.hooks = Ee({
              dropTarget: (e, t) => {
                this.clearDropTarget(), this.dropTargetOptions = t, Pe(e) ? this.dropTargetRef = e : this.dropTargetNode = e, this.reconnect();
              }
            }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
          }
        }
        const Te = "undefined" != typeof window ? r.useLayoutEffect : r.useEffect;
        class Oe {
          beginDrag() {
            const e = this.spec,
              t = this.monitor;
            let n = null;
            return n = "object" == typeof e.item ? e.item : "function" == typeof e.item ? e.item(t) : {}, null != n ? n : null;
          }
          canDrag() {
            const e = this.spec,
              t = this.monitor;
            return "boolean" == typeof e.canDrag ? e.canDrag : "function" != typeof e.canDrag || e.canDrag(t);
          }
          isDragging(e, t) {
            const n = this.spec,
              r = this.monitor,
              {
                isDragging: o
              } = n;
            return o ? o(r) : t === e.getSourceId();
          }
          endDrag() {
            const e = this.spec,
              t = this.monitor,
              n = this.connector,
              {
                end: r
              } = e;
            r && r(t.getItem(), t), n.reconnect();
          }
          constructor(e, t, n) {
            this.spec = e, this.monitor = t, this.connector = n;
          }
        }
        function Ie() {
          const {
            dragDropManager: e
          } = (0, r.useContext)(o);
          return s(null != e, "Expected drag drop context"), e;
        }
        function Fe(e, t, n) {
          const o = Ie(),
            i = function (e, t, n) {
              const o = (0, r.useMemo)(() => new Oe(e, t, n), [t, n]);
              return (0, r.useEffect)(() => {
                o.spec = e;
              }, [e]), o;
            }(e, t, n),
            a = function (e) {
              return (0, r.useMemo)(() => {
                const t = e.type;
                return s(null != t, "spec.type must be defined"), t;
              }, [e]);
            }(e);
          Te(function () {
            if (null != a) {
              const [e, r] = function (e, t, n) {
                const r = n.getRegistry(),
                  o = r.addSource(e, t);
                return [o, () => r.removeSource(o)];
              }(a, i, o);
              return t.receiveHandlerId(e), n.receiveHandlerId(e), r;
            }
          }, [o, t, n, i, a]);
        }
        function Me(e, t) {
          const n = [...(t || [])];
          return null == t && "function" != typeof e && n.push(e), (0, r.useMemo)(() => "function" == typeof e ? e() : e, n);
        }
        var Re = n(64063),
          je = n.n(Re);
        function Be(e, t, n) {
          const [o, i] = (0, r.useState)(() => t(e)),
            a = (0, r.useCallback)(() => {
              const r = t(e);
              je()(o, r) || (i(r), n && n());
            }, [o, e, n]);
          return Te(a), [o, a];
        }
        function Ne(e, t, n) {
          return function (e, t, n) {
            const [r, o] = Be(e, t, n);
            return Te(function () {
              const t = e.getHandlerId();
              if (null != t) return e.subscribeToStateChange(o, {
                handlerIds: [t]
              });
            }, [e, o]), r;
          }(t, e || (() => ({})), () => n.reconnect());
        }
        function Le(e) {
          return (0, r.useMemo)(() => e.hooks.dragSource(), [e]);
        }
        function Ve(e) {
          return (0, r.useMemo)(() => e.hooks.dragPreview(), [e]);
        }
        function Ke(e, t) {
          const n = Me(e, t);
          s(!n.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
          const o = function () {
              const e = Ie();
              return (0, r.useMemo)(() => new xe(e), [e]);
            }(),
            i = function (e, t) {
              const n = Ie(),
                o = (0, r.useMemo)(() => new Ae(n.getBackend()), [n]);
              return Te(() => (o.dragSourceOptions = e || null, o.reconnect(), () => o.disconnectDragSource()), [o, e]), Te(() => (o.dragPreviewOptions = t || null, o.reconnect(), () => o.disconnectDragPreview()), [o, t]), o;
            }(n.options, n.previewOptions);
          return Fe(n, o, i), [Ne(n.collect, o, i), Le(i), Ve(i)];
        }
        class qe {
          canDrop() {
            const e = this.spec,
              t = this.monitor;
            return !e.canDrop || e.canDrop(t.getItem(), t);
          }
          hover() {
            const e = this.spec,
              t = this.monitor;
            e.hover && e.hover(t.getItem(), t);
          }
          drop() {
            const e = this.spec,
              t = this.monitor;
            if (e.drop) return e.drop(t.getItem(), t);
          }
          constructor(e, t) {
            this.spec = e, this.monitor = t;
          }
        }
        function He(e, t, n) {
          const o = Ie(),
            i = function (e, t) {
              const n = (0, r.useMemo)(() => new qe(e, t), [t]);
              return (0, r.useEffect)(() => {
                n.spec = e;
              }, [e]), n;
            }(e, t),
            a = function (e) {
              const {
                accept: t
              } = e;
              return (0, r.useMemo)(() => (s(null != e.accept, "accept must be defined"), Array.isArray(t) ? t : [t]), [t]);
            }(e);
          Te(function () {
            const [e, r] = function (e, t, n) {
              const r = n.getRegistry(),
                o = r.addTarget(e, t);
              return [o, () => r.removeTarget(o)];
            }(a, i, o);
            return t.receiveHandlerId(e), n.receiveHandlerId(e), r;
          }, [o, t, i, n, a.map(e => e.toString()).join("|")]);
        }
        function Ue(e) {
          return (0, r.useMemo)(() => e.hooks.dropTarget(), [e]);
        }
        function Ze(e, t) {
          const n = Me(e, t),
            o = function () {
              const e = Ie();
              return (0, r.useMemo)(() => new Ce(e), [e]);
            }(),
            i = function (e) {
              const t = Ie(),
                n = (0, r.useMemo)(() => new ze(t.getBackend()), [t]);
              return Te(() => (n.dropTargetOptions = e || null, n.reconnect(), () => n.disconnectDropTarget()), [e]), n;
            }(n.options);
          return He(n, o, i), [Ne(n.collect, o, i), Ue(i)];
        }
        function $e(e) {
          const t = Ie().getMonitor(),
            [n, o] = Be(t, e);
          return (0, r.useEffect)(() => t.subscribeToOffsetChange(o)), (0, r.useEffect)(() => t.subscribeToStateChange(o)), n;
        }
      },
      64448: (e, t, n) => {
        "use strict";

        var r = n(67294),
          o = n(27418),
          i = n(54142);
        function a(e) {
          for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
          return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        if (!r) throw Error(a(227));
        var s = new Set(),
          l = {};
        function u(e, t) {
          c(e, t), c(e + "Capture", t);
        }
        function c(e, t) {
          for (l[e] = t, e = 0; e < t.length; e++) s.add(t[e]);
        }
        var d = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
          p = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          h = Object.prototype.hasOwnProperty,
          f = {},
          m = {};
        function g(e, t, n, r, o, i, a) {
          this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = r, this.attributeNamespace = o, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = a;
        }
        var v = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
          v[e] = new g(e, 0, !1, e, null, !1, !1);
        }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
          var t = e[0];
          v[t] = new g(t, 1, !1, e[1], null, !1, !1);
        }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
          v[e] = new g(e, 2, !1, e.toLowerCase(), null, !1, !1);
        }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
          v[e] = new g(e, 2, !1, e, null, !1, !1);
        }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
          v[e] = new g(e, 3, !1, e.toLowerCase(), null, !1, !1);
        }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
          v[e] = new g(e, 3, !0, e, null, !1, !1);
        }), ["capture", "download"].forEach(function (e) {
          v[e] = new g(e, 4, !1, e, null, !1, !1);
        }), ["cols", "rows", "size", "span"].forEach(function (e) {
          v[e] = new g(e, 6, !1, e, null, !1, !1);
        }), ["rowSpan", "start"].forEach(function (e) {
          v[e] = new g(e, 5, !1, e.toLowerCase(), null, !1, !1);
        });
        var y = /[\-:]([a-z])/g;
        function b(e) {
          return e[1].toUpperCase();
        }
        function w(e, t, n, r) {
          var o = v.hasOwnProperty(t) ? v[t] : null;
          (null !== o ? 0 === o.type : !r && 2 < t.length && ("o" === t[0] || "O" === t[0]) && ("n" === t[1] || "N" === t[1])) || (function (e, t, n, r) {
            if (null == t || function (e, t, n, r) {
              if (null !== n && 0 === n.type) return !1;
              switch (typeof t) {
                case "function":
                case "symbol":
                  return !0;
                case "boolean":
                  return !r && (null !== n ? !n.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
                default:
                  return !1;
              }
            }(e, t, n, r)) return !0;
            if (r) return !1;
            if (null !== n) switch (n.type) {
              case 3:
                return !t;
              case 4:
                return !1 === t;
              case 5:
                return isNaN(t);
              case 6:
                return isNaN(t) || 1 > t;
            }
            return !1;
          }(t, n, o, r) && (n = null), r || null === o ? function (e) {
            return !!h.call(m, e) || !h.call(f, e) && (p.test(e) ? m[e] = !0 : (f[e] = !0, !1));
          }(t) && (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n)) : o.mustUseProperty ? e[o.propertyName] = null === n ? 3 !== o.type && "" : n : (t = o.attributeName, r = o.attributeNamespace, null === n ? e.removeAttribute(t) : (n = 3 === (o = o.type) || 4 === o && !0 === n ? "" : "" + n, r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
          var t = e.replace(y, b);
          v[t] = new g(t, 1, !1, e, null, !1, !1);
        }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
          var t = e.replace(y, b);
          v[t] = new g(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
        }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
          var t = e.replace(y, b);
          v[t] = new g(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1, !1);
        }), ["tabIndex", "crossOrigin"].forEach(function (e) {
          v[e] = new g(e, 1, !1, e.toLowerCase(), null, !1, !1);
        }), v.xlinkHref = new g("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function (e) {
          v[e] = new g(e, 1, !1, e.toLowerCase(), null, !0, !0);
        });
        var x = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          D = 60103,
          C = 60106,
          S = 60107,
          E = 60108,
          _ = 60114,
          P = 60109,
          k = 60110,
          A = 60112,
          z = 60113,
          T = 60120,
          O = 60115,
          I = 60116,
          F = 60121,
          M = 60128,
          R = 60129,
          j = 60130,
          B = 60131;
        if ("function" == typeof Symbol && Symbol.for) {
          var N = Symbol.for;
          D = N("react.element"), C = N("react.portal"), S = N("react.fragment"), E = N("react.strict_mode"), _ = N("react.profiler"), P = N("react.provider"), k = N("react.context"), A = N("react.forward_ref"), z = N("react.suspense"), T = N("react.suspense_list"), O = N("react.memo"), I = N("react.lazy"), F = N("react.block"), N("react.scope"), M = N("react.opaque.id"), R = N("react.debug_trace_mode"), j = N("react.offscreen"), B = N("react.legacy_hidden");
        }
        var L,
          V = "function" == typeof Symbol && Symbol.iterator;
        function K(e) {
          return null === e || "object" != typeof e ? null : "function" == typeof (e = V && e[V] || e["@@iterator"]) ? e : null;
        }
        function q(e) {
          if (void 0 === L) try {
            throw Error();
          } catch (e) {
            var t = e.stack.trim().match(/\n( *(at )?)/);
            L = t && t[1] || "";
          }
          return "\n" + L + e;
        }
        var H = !1;
        function U(e, t) {
          if (!e || H) return "";
          H = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t) {
              if (t = function () {
                throw Error();
              }, Object.defineProperty(t.prototype, "props", {
                set: function () {
                  throw Error();
                }
              }), "object" == typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(t, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (e) {
                  r = e;
                }
                e.call(t.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              e();
            }
          } catch (e) {
            if (e && r && "string" == typeof e.stack) {
              for (var o = e.stack.split("\n"), i = r.stack.split("\n"), a = o.length - 1, s = i.length - 1; 1 <= a && 0 <= s && o[a] !== i[s];) s--;
              for (; 1 <= a && 0 <= s; a--, s--) if (o[a] !== i[s]) {
                if (1 !== a || 1 !== s) do {
                  if (a--, 0 > --s || o[a] !== i[s]) return "\n" + o[a].replace(" at new ", " at ");
                } while (1 <= a && 0 <= s);
                break;
              }
            }
          } finally {
            H = !1, Error.prepareStackTrace = n;
          }
          return (e = e ? e.displayName || e.name : "") ? q(e) : "";
        }
        function Z(e) {
          switch (e.tag) {
            case 5:
              return q(e.type);
            case 16:
              return q("Lazy");
            case 13:
              return q("Suspense");
            case 19:
              return q("SuspenseList");
            case 0:
            case 2:
            case 15:
              return e = U(e.type, !1);
            case 11:
              return e = U(e.type.render, !1);
            case 22:
              return e = U(e.type._render, !1);
            case 1:
              return e = U(e.type, !0);
            default:
              return "";
          }
        }
        function $(e) {
          if (null == e) return null;
          if ("function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case S:
              return "Fragment";
            case C:
              return "Portal";
            case _:
              return "Profiler";
            case E:
              return "StrictMode";
            case z:
              return "Suspense";
            case T:
              return "SuspenseList";
          }
          if ("object" == typeof e) switch (e.$$typeof) {
            case k:
              return (e.displayName || "Context") + ".Consumer";
            case P:
              return (e._context.displayName || "Context") + ".Provider";
            case A:
              var t = e.render;
              return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
            case O:
              return $(e.type);
            case F:
              return $(e._render);
            case I:
              t = e._payload, e = e._init;
              try {
                return $(e(t));
              } catch (e) {}
          }
          return null;
        }
        function G(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "object":
            case "string":
            case "undefined":
              return e;
            default:
              return "";
          }
        }
        function W(e) {
          var t = e.type;
          return (e = e.nodeName) && "input" === e.toLowerCase() && ("checkbox" === t || "radio" === t);
        }
        function Y(e) {
          e._valueTracker || (e._valueTracker = function (e) {
            var t = W(e) ? "checked" : "value",
              n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
              r = "" + e[t];
            if (!e.hasOwnProperty(t) && void 0 !== n && "function" == typeof n.get && "function" == typeof n.set) {
              var o = n.get,
                i = n.set;
              return Object.defineProperty(e, t, {
                configurable: !0,
                get: function () {
                  return o.call(this);
                },
                set: function (e) {
                  r = "" + e, i.call(this, e);
                }
              }), Object.defineProperty(e, t, {
                enumerable: n.enumerable
              }), {
                getValue: function () {
                  return r;
                },
                setValue: function (e) {
                  r = "" + e;
                },
                stopTracking: function () {
                  e._valueTracker = null, delete e[t];
                }
              };
            }
          }(e));
        }
        function X(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return e && (r = W(e) ? e.checked ? "true" : "false" : e.value), (e = r) !== n && (t.setValue(e), !0);
        }
        function Q(e) {
          if (void 0 === (e = e || ("undefined" != typeof document ? document : void 0))) return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function J(e, t) {
          var n = t.checked;
          return o({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked
          });
        }
        function ee(e, t) {
          var n = null == t.defaultValue ? "" : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          n = G(null != t.value ? t.value : n), e._wrapperState = {
            initialChecked: r,
            initialValue: n,
            controlled: "checkbox" === t.type || "radio" === t.type ? null != t.checked : null != t.value
          };
        }
        function te(e, t) {
          null != (t = t.checked) && w(e, "checked", t, !1);
        }
        function ne(e, t) {
          te(e, t);
          var n = G(t.value),
            r = t.type;
          if (null != n) "number" === r ? (0 === n && "" === e.value || e.value != n) && (e.value = "" + n) : e.value !== "" + n && (e.value = "" + n);else if ("submit" === r || "reset" === r) return void e.removeAttribute("value");
          t.hasOwnProperty("value") ? oe(e, t.type, n) : t.hasOwnProperty("defaultValue") && oe(e, t.type, G(t.defaultValue)), null == t.checked && null != t.defaultChecked && (e.defaultChecked = !!t.defaultChecked);
        }
        function re(e, t, n) {
          if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
            var r = t.type;
            if (!("submit" !== r && "reset" !== r || void 0 !== t.value && null !== t.value)) return;
            t = "" + e._wrapperState.initialValue, n || t === e.value || (e.value = t), e.defaultValue = t;
          }
          "" !== (n = e.name) && (e.name = ""), e.defaultChecked = !!e._wrapperState.initialChecked, "" !== n && (e.name = n);
        }
        function oe(e, t, n) {
          "number" === t && Q(e.ownerDocument) === e || (null == n ? e.defaultValue = "" + e._wrapperState.initialValue : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
        }
        function ie(e, t) {
          return e = o({
            children: void 0
          }, t), (t = function (e) {
            var t = "";
            return r.Children.forEach(e, function (e) {
              null != e && (t += e);
            }), t;
          }(t.children)) && (e.children = t), e;
        }
        function ae(e, t, n, r) {
          if (e = e.options, t) {
            t = {};
            for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
            for (n = 0; n < e.length; n++) o = t.hasOwnProperty("$" + e[n].value), e[n].selected !== o && (e[n].selected = o), o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + G(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n) return e[o].selected = !0, void (r && (e[o].defaultSelected = !0));
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function se(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
          return o({}, t, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue
          });
        }
        function le(e, t) {
          var n = t.value;
          if (null == n) {
            if (n = t.children, t = t.defaultValue, null != n) {
              if (null != t) throw Error(a(92));
              if (Array.isArray(n)) {
                if (!(1 >= n.length)) throw Error(a(93));
                n = n[0];
              }
              t = n;
            }
            null == t && (t = ""), n = t;
          }
          e._wrapperState = {
            initialValue: G(n)
          };
        }
        function ue(e, t) {
          var n = G(t.value),
            r = G(t.defaultValue);
          null != n && ((n = "" + n) !== e.value && (e.value = n), null == t.defaultValue && e.defaultValue !== n && (e.defaultValue = n)), null != r && (e.defaultValue = "" + r);
        }
        function ce(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue && "" !== t && null !== t && (e.value = t);
        }
        var de = "http://www.w3.org/1999/xhtml",
          pe = "http://www.w3.org/2000/svg";
        function he(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function fe(e, t) {
          return null == e || "http://www.w3.org/1999/xhtml" === e ? he(t) : "http://www.w3.org/2000/svg" === e && "foreignObject" === t ? "http://www.w3.org/1999/xhtml" : e;
        }
        var me,
          ge,
          ve = (ge = function (e, t) {
            if (e.namespaceURI !== pe || "innerHTML" in e) e.innerHTML = t;else {
              for ((me = me || document.createElement("div")).innerHTML = "<svg>" + t.valueOf().toString() + "</svg>", t = me.firstChild; e.firstChild;) e.removeChild(e.firstChild);
              for (; t.firstChild;) e.appendChild(t.firstChild);
            }
          }, "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction ? function (e, t, n, r) {
            MSApp.execUnsafeLocalFunction(function () {
              return ge(e, t);
            });
          } : ge);
        function ye(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType) return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var be = {
            animationIterationCount: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0
          },
          we = ["Webkit", "ms", "Moz", "O"];
        function xe(e, t, n) {
          return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || be.hasOwnProperty(e) && be[e] ? ("" + t).trim() : t + "px";
        }
        function De(e, t) {
          for (var n in e = e.style, t) if (t.hasOwnProperty(n)) {
            var r = 0 === n.indexOf("--"),
              o = xe(n, t[n], r);
            "float" === n && (n = "cssFloat"), r ? e.setProperty(n, o) : e[n] = o;
          }
        }
        Object.keys(be).forEach(function (e) {
          we.forEach(function (t) {
            t = t + e.charAt(0).toUpperCase() + e.substring(1), be[t] = be[e];
          });
        });
        var Ce = o({
          menuitem: !0
        }, {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0
        });
        function Se(e, t) {
          if (t) {
            if (Ce[e] && (null != t.children || null != t.dangerouslySetInnerHTML)) throw Error(a(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(a(60));
              if ("object" != typeof t.dangerouslySetInnerHTML || !("__html" in t.dangerouslySetInnerHTML)) throw Error(a(61));
            }
            if (null != t.style && "object" != typeof t.style) throw Error(a(62));
          }
        }
        function Ee(e, t) {
          if (-1 === e.indexOf("-")) return "string" == typeof t.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        function _e(e) {
          return (e = e.target || e.srcElement || window).correspondingUseElement && (e = e.correspondingUseElement), 3 === e.nodeType ? e.parentNode : e;
        }
        var Pe = null,
          ke = null,
          Ae = null;
        function ze(e) {
          if (e = ro(e)) {
            if ("function" != typeof Pe) throw Error(a(280));
            var t = e.stateNode;
            t && (t = io(t), Pe(e.stateNode, e.type, t));
          }
        }
        function Te(e) {
          ke ? Ae ? Ae.push(e) : Ae = [e] : ke = e;
        }
        function Oe() {
          if (ke) {
            var e = ke,
              t = Ae;
            if (Ae = ke = null, ze(e), t) for (e = 0; e < t.length; e++) ze(t[e]);
          }
        }
        function Ie(e, t) {
          return e(t);
        }
        function Fe(e, t, n, r, o) {
          return e(t, n, r, o);
        }
        function Me() {}
        var Re = Ie,
          je = !1,
          Be = !1;
        function Ne() {
          null === ke && null === Ae || (Me(), Oe());
        }
        function Le(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = io(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) || (r = !("button" === (e = e.type) || "input" === e || "select" === e || "textarea" === e)), e = !r;
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" != typeof n) throw Error(a(231, t, typeof n));
          return n;
        }
        var Ve = !1;
        if (d) try {
          var Ke = {};
          Object.defineProperty(Ke, "passive", {
            get: function () {
              Ve = !0;
            }
          }), window.addEventListener("test", Ke, Ke), window.removeEventListener("test", Ke, Ke);
        } catch (ge) {
          Ve = !1;
        }
        function qe(e, t, n, r, o, i, a, s, l) {
          var u = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, u);
          } catch (e) {
            this.onError(e);
          }
        }
        var He = !1,
          Ue = null,
          Ze = !1,
          $e = null,
          Ge = {
            onError: function (e) {
              He = !0, Ue = e;
            }
          };
        function We(e, t, n, r, o, i, a, s, l) {
          He = !1, Ue = null, qe.apply(Ge, arguments);
        }
        function Ye(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return;) t = t.return;else {
            e = t;
            do {
              0 != (1026 & (t = e).flags) && (n = t.return), e = t.return;
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function Xe(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (null === t && null !== (e = e.alternate) && (t = e.memoizedState), null !== t) return t.dehydrated;
          }
          return null;
        }
        function Qe(e) {
          if (Ye(e) !== e) throw Error(a(188));
        }
        function Je(e) {
          if (e = function (e) {
            var t = e.alternate;
            if (!t) {
              if (null === (t = Ye(e))) throw Error(a(188));
              return t !== e ? null : e;
            }
            for (var n = e, r = t;;) {
              var o = n.return;
              if (null === o) break;
              var i = o.alternate;
              if (null === i) {
                if (null !== (r = o.return)) {
                  n = r;
                  continue;
                }
                break;
              }
              if (o.child === i.child) {
                for (i = o.child; i;) {
                  if (i === n) return Qe(o), e;
                  if (i === r) return Qe(o), t;
                  i = i.sibling;
                }
                throw Error(a(188));
              }
              if (n.return !== r.return) n = o, r = i;else {
                for (var s = !1, l = o.child; l;) {
                  if (l === n) {
                    s = !0, n = o, r = i;
                    break;
                  }
                  if (l === r) {
                    s = !0, r = o, n = i;
                    break;
                  }
                  l = l.sibling;
                }
                if (!s) {
                  for (l = i.child; l;) {
                    if (l === n) {
                      s = !0, n = i, r = o;
                      break;
                    }
                    if (l === r) {
                      s = !0, r = i, n = o;
                      break;
                    }
                    l = l.sibling;
                  }
                  if (!s) throw Error(a(189));
                }
              }
              if (n.alternate !== r) throw Error(a(190));
            }
            if (3 !== n.tag) throw Error(a(188));
            return n.stateNode.current === n ? e : t;
          }(e), !e) return null;
          for (var t = e;;) {
            if (5 === t.tag || 6 === t.tag) return t;
            if (t.child) t.child.return = t, t = t.child;else {
              if (t === e) break;
              for (; !t.sibling;) {
                if (!t.return || t.return === e) return null;
                t = t.return;
              }
              t.sibling.return = t.return, t = t.sibling;
            }
          }
          return null;
        }
        function et(e, t) {
          for (var n = e.alternate; null !== t;) {
            if (t === e || t === n) return !0;
            t = t.return;
          }
          return !1;
        }
        var tt,
          nt,
          rt,
          ot,
          it = !1,
          at = [],
          st = null,
          lt = null,
          ut = null,
          ct = new Map(),
          dt = new Map(),
          pt = [],
          ht = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
        function ft(e, t, n, r, o) {
          return {
            blockedOn: e,
            domEventName: t,
            eventSystemFlags: 16 | n,
            nativeEvent: o,
            targetContainers: [r]
          };
        }
        function mt(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              st = null;
              break;
            case "dragenter":
            case "dragleave":
              lt = null;
              break;
            case "mouseover":
            case "mouseout":
              ut = null;
              break;
            case "pointerover":
            case "pointerout":
              ct.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              dt.delete(t.pointerId);
          }
        }
        function gt(e, t, n, r, o, i) {
          return null === e || e.nativeEvent !== i ? (e = ft(t, n, r, o, i), null !== t && null !== (t = ro(t)) && nt(t), e) : (e.eventSystemFlags |= r, t = e.targetContainers, null !== o && -1 === t.indexOf(o) && t.push(o), e);
        }
        function vt(e) {
          var t = no(e.target);
          if (null !== t) {
            var n = Ye(t);
            if (null !== n) if (13 === (t = n.tag)) {
              if (null !== (t = Xe(n))) return e.blockedOn = t, void ot(e.lanePriority, function () {
                i.unstable_runWithPriority(e.priority, function () {
                  rt(n);
                });
              });
            } else if (3 === t && n.stateNode.hydrate) return void (e.blockedOn = 3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function yt(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length;) {
            var n = Jt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n) return null !== (t = ro(n)) && nt(t), e.blockedOn = n, !1;
            t.shift();
          }
          return !0;
        }
        function bt(e, t, n) {
          yt(e) && n.delete(t);
        }
        function wt() {
          for (it = !1; 0 < at.length;) {
            var e = at[0];
            if (null !== e.blockedOn) {
              null !== (e = ro(e.blockedOn)) && tt(e);
              break;
            }
            for (var t = e.targetContainers; 0 < t.length;) {
              var n = Jt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
              if (null !== n) {
                e.blockedOn = n;
                break;
              }
              t.shift();
            }
            null === e.blockedOn && at.shift();
          }
          null !== st && yt(st) && (st = null), null !== lt && yt(lt) && (lt = null), null !== ut && yt(ut) && (ut = null), ct.forEach(bt), dt.forEach(bt);
        }
        function xt(e, t) {
          e.blockedOn === t && (e.blockedOn = null, it || (it = !0, i.unstable_scheduleCallback(i.unstable_NormalPriority, wt)));
        }
        function Dt(e) {
          function t(t) {
            return xt(t, e);
          }
          if (0 < at.length) {
            xt(at[0], e);
            for (var n = 1; n < at.length; n++) {
              var r = at[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (null !== st && xt(st, e), null !== lt && xt(lt, e), null !== ut && xt(ut, e), ct.forEach(t), dt.forEach(t), n = 0; n < pt.length; n++) (r = pt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < pt.length && null === (n = pt[0]).blockedOn;) vt(n), null === n.blockedOn && pt.shift();
        }
        function Ct(e, t) {
          var n = {};
          return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
        }
        var St = {
            animationend: Ct("Animation", "AnimationEnd"),
            animationiteration: Ct("Animation", "AnimationIteration"),
            animationstart: Ct("Animation", "AnimationStart"),
            transitionend: Ct("Transition", "TransitionEnd")
          },
          Et = {},
          _t = {};
        function Pt(e) {
          if (Et[e]) return Et[e];
          if (!St[e]) return e;
          var t,
            n = St[e];
          for (t in n) if (n.hasOwnProperty(t) && t in _t) return Et[e] = n[t];
          return e;
        }
        d && (_t = document.createElement("div").style, "AnimationEvent" in window || (delete St.animationend.animation, delete St.animationiteration.animation, delete St.animationstart.animation), "TransitionEvent" in window || delete St.transitionend.transition);
        var kt = Pt("animationend"),
          At = Pt("animationiteration"),
          zt = Pt("animationstart"),
          Tt = Pt("transitionend"),
          Ot = new Map(),
          It = new Map(),
          Ft = ["abort", "abort", kt, "animationEnd", At, "animationIteration", zt, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Tt, "transitionEnd", "waiting", "waiting"];
        function Mt(e, t) {
          for (var n = 0; n < e.length; n += 2) {
            var r = e[n],
              o = e[n + 1];
            o = "on" + (o[0].toUpperCase() + o.slice(1)), It.set(r, t), Ot.set(r, o), u(o, [r]);
          }
        }
        (0, i.unstable_now)();
        var Rt = 8;
        function jt(e) {
          if (0 != (1 & e)) return Rt = 15, 1;
          if (0 != (2 & e)) return Rt = 14, 2;
          if (0 != (4 & e)) return Rt = 13, 4;
          var t = 24 & e;
          return 0 !== t ? (Rt = 12, t) : 0 != (32 & e) ? (Rt = 11, 32) : 0 !== (t = 192 & e) ? (Rt = 10, t) : 0 != (256 & e) ? (Rt = 9, 256) : 0 !== (t = 3584 & e) ? (Rt = 8, t) : 0 != (4096 & e) ? (Rt = 7, 4096) : 0 !== (t = 4186112 & e) ? (Rt = 6, t) : 0 !== (t = 62914560 & e) ? (Rt = 5, t) : 67108864 & e ? (Rt = 4, 67108864) : 0 != (134217728 & e) ? (Rt = 3, 134217728) : 0 !== (t = 805306368 & e) ? (Rt = 2, t) : 0 != (1073741824 & e) ? (Rt = 1, 1073741824) : (Rt = 8, e);
        }
        function Bt(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return Rt = 0;
          var r = 0,
            o = 0,
            i = e.expiredLanes,
            a = e.suspendedLanes,
            s = e.pingedLanes;
          if (0 !== i) r = i, o = Rt = 15;else if (0 !== (i = 134217727 & n)) {
            var l = i & ~a;
            0 !== l ? (r = jt(l), o = Rt) : 0 !== (s &= i) && (r = jt(s), o = Rt);
          } else 0 !== (i = n & ~a) ? (r = jt(i), o = Rt) : 0 !== s && (r = jt(s), o = Rt);
          if (0 === r) return 0;
          if (r = n & ((0 > (r = 31 - Ht(r)) ? 0 : 1 << r) << 1) - 1, 0 !== t && t !== r && 0 == (t & a)) {
            if (jt(t), o <= Rt) return t;
            Rt = o;
          }
          if (0 !== (t = e.entangledLanes)) for (e = e.entanglements, t &= r; 0 < t;) o = 1 << (n = 31 - Ht(t)), r |= e[n], t &= ~o;
          return r;
        }
        function Nt(e) {
          return 0 !== (e = -1073741825 & e.pendingLanes) ? e : 1073741824 & e ? 1073741824 : 0;
        }
        function Lt(e, t) {
          switch (e) {
            case 15:
              return 1;
            case 14:
              return 2;
            case 12:
              return 0 === (e = Vt(24 & ~t)) ? Lt(10, t) : e;
            case 10:
              return 0 === (e = Vt(192 & ~t)) ? Lt(8, t) : e;
            case 8:
              return 0 === (e = Vt(3584 & ~t)) && 0 === (e = Vt(4186112 & ~t)) && (e = 512), e;
            case 2:
              return 0 === (t = Vt(805306368 & ~t)) && (t = 268435456), t;
          }
          throw Error(a(358, e));
        }
        function Vt(e) {
          return e & -e;
        }
        function Kt(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function qt(e, t, n) {
          e.pendingLanes |= t;
          var r = t - 1;
          e.suspendedLanes &= r, e.pingedLanes &= r, (e = e.eventTimes)[t = 31 - Ht(t)] = n;
        }
        var Ht = Math.clz32 ? Math.clz32 : function (e) {
            return 0 === e ? 32 : 31 - (Ut(e) / Zt | 0) | 0;
          },
          Ut = Math.log,
          Zt = Math.LN2;
        var $t = i.unstable_UserBlockingPriority,
          Gt = i.unstable_runWithPriority,
          Wt = !0;
        function Yt(e, t, n, r) {
          je || Me();
          var o = Qt,
            i = je;
          je = !0;
          try {
            Fe(o, e, t, n, r);
          } finally {
            (je = i) || Ne();
          }
        }
        function Xt(e, t, n, r) {
          Gt($t, Qt.bind(null, e, t, n, r));
        }
        function Qt(e, t, n, r) {
          var o;
          if (Wt) if ((o = 0 == (4 & t)) && 0 < at.length && -1 < ht.indexOf(e)) e = ft(null, e, t, n, r), at.push(e);else {
            var i = Jt(e, t, n, r);
            if (null === i) o && mt(e, r);else {
              if (o) {
                if (-1 < ht.indexOf(e)) return e = ft(i, e, t, n, r), void at.push(e);
                if (function (e, t, n, r, o) {
                  switch (t) {
                    case "focusin":
                      return st = gt(st, e, t, n, r, o), !0;
                    case "dragenter":
                      return lt = gt(lt, e, t, n, r, o), !0;
                    case "mouseover":
                      return ut = gt(ut, e, t, n, r, o), !0;
                    case "pointerover":
                      var i = o.pointerId;
                      return ct.set(i, gt(ct.get(i) || null, e, t, n, r, o)), !0;
                    case "gotpointercapture":
                      return i = o.pointerId, dt.set(i, gt(dt.get(i) || null, e, t, n, r, o)), !0;
                  }
                  return !1;
                }(i, e, t, n, r)) return;
                mt(e, r);
              }
              Mr(e, t, r, null, n);
            }
          }
        }
        function Jt(e, t, n, r) {
          var o = _e(r);
          if (null !== (o = no(o))) {
            var i = Ye(o);
            if (null === i) o = null;else {
              var a = i.tag;
              if (13 === a) {
                if (null !== (o = Xe(i))) return o;
                o = null;
              } else if (3 === a) {
                if (i.stateNode.hydrate) return 3 === i.tag ? i.stateNode.containerInfo : null;
                o = null;
              } else i !== o && (o = null);
            }
          }
          return Mr(e, t, r, o, n), null;
        }
        var en = null,
          tn = null,
          nn = null;
        function rn() {
          if (nn) return nn;
          var e,
            t,
            n = tn,
            r = n.length,
            o = "value" in en ? en.value : en.textContent,
            i = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var a = r - e;
          for (t = 1; t <= a && n[r - t] === o[i - t]; t++);
          return nn = o.slice(e, 1 < t ? 1 - t : void 0);
        }
        function on(e) {
          var t = e.keyCode;
          return "charCode" in e ? 0 === (e = e.charCode) && 13 === t && (e = 13) : e = t, 10 === e && (e = 13), 32 <= e || 13 === e ? e : 0;
        }
        function an() {
          return !0;
        }
        function sn() {
          return !1;
        }
        function ln(e) {
          function t(t, n, r, o, i) {
            for (var a in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = o, this.target = i, this.currentTarget = null, e) e.hasOwnProperty(a) && (t = e[a], this[a] = t ? t(o) : o[a]);
            return this.isDefaultPrevented = (null != o.defaultPrevented ? o.defaultPrevented : !1 === o.returnValue) ? an : sn, this.isPropagationStopped = sn, this;
          }
          return o(t.prototype, {
            preventDefault: function () {
              this.defaultPrevented = !0;
              var e = this.nativeEvent;
              e && (e.preventDefault ? e.preventDefault() : "unknown" != typeof e.returnValue && (e.returnValue = !1), this.isDefaultPrevented = an);
            },
            stopPropagation: function () {
              var e = this.nativeEvent;
              e && (e.stopPropagation ? e.stopPropagation() : "unknown" != typeof e.cancelBubble && (e.cancelBubble = !0), this.isPropagationStopped = an);
            },
            persist: function () {},
            isPersistent: an
          }), t;
        }
        var un,
          cn,
          dn,
          pn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0
          },
          hn = ln(pn),
          fn = o({}, pn, {
            view: 0,
            detail: 0
          }),
          mn = ln(fn),
          gn = o({}, fn, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: kn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e ? e.movementX : (e !== dn && (dn && "mousemove" === e.type ? (un = e.screenX - dn.screenX, cn = e.screenY - dn.screenY) : cn = un = 0, dn = e), un);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : cn;
            }
          }),
          vn = ln(gn),
          yn = ln(o({}, gn, {
            dataTransfer: 0
          })),
          bn = ln(o({}, fn, {
            relatedTarget: 0
          })),
          wn = ln(o({}, pn, {
            animationName: 0,
            elapsedTime: 0,
            pseudoElement: 0
          })),
          xn = o({}, pn, {
            clipboardData: function (e) {
              return "clipboardData" in e ? e.clipboardData : window.clipboardData;
            }
          }),
          Dn = ln(xn),
          Cn = ln(o({}, pn, {
            data: 0
          })),
          Sn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified"
          },
          En = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta"
          },
          _n = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey"
          };
        function Pn(e) {
          var t = this.nativeEvent;
          return t.getModifierState ? t.getModifierState(e) : !!(e = _n[e]) && !!t[e];
        }
        function kn() {
          return Pn;
        }
        var An = o({}, fn, {
            key: function (e) {
              if (e.key) {
                var t = Sn[e.key] || e.key;
                if ("Unidentified" !== t) return t;
              }
              return "keypress" === e.type ? 13 === (e = on(e)) ? "Enter" : String.fromCharCode(e) : "keydown" === e.type || "keyup" === e.type ? En[e.keyCode] || "Unidentified" : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: kn,
            charCode: function (e) {
              return "keypress" === e.type ? on(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type ? on(e) : "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            }
          }),
          zn = ln(An),
          Tn = ln(o({}, gn, {
            pointerId: 0,
            width: 0,
            height: 0,
            pressure: 0,
            tangentialPressure: 0,
            tiltX: 0,
            tiltY: 0,
            twist: 0,
            pointerType: 0,
            isPrimary: 0
          })),
          On = ln(o({}, fn, {
            touches: 0,
            targetTouches: 0,
            changedTouches: 0,
            altKey: 0,
            metaKey: 0,
            ctrlKey: 0,
            shiftKey: 0,
            getModifierState: kn
          })),
          In = ln(o({}, pn, {
            propertyName: 0,
            elapsedTime: 0,
            pseudoElement: 0
          })),
          Fn = o({}, gn, {
            deltaX: function (e) {
              return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
            },
            deltaZ: 0,
            deltaMode: 0
          }),
          Mn = ln(Fn),
          Rn = [9, 13, 27, 32],
          jn = d && "CompositionEvent" in window,
          Bn = null;
        d && "documentMode" in document && (Bn = document.documentMode);
        var Nn = d && "TextEvent" in window && !Bn,
          Ln = d && (!jn || Bn && 8 < Bn && 11 >= Bn),
          Vn = String.fromCharCode(32),
          Kn = !1;
        function qn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== Rn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Hn(e) {
          return "object" == typeof (e = e.detail) && "data" in e ? e.data : null;
        }
        var Un = !1;
        var Zn = {
          color: !0,
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0
        };
        function $n(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Zn[e.type] : "textarea" === t;
        }
        function Gn(e, t, n, r) {
          Te(r), 0 < (t = jr(t, "onChange")).length && (n = new hn("onChange", "change", null, n, r), e.push({
            event: n,
            listeners: t
          }));
        }
        var Wn = null,
          Yn = null;
        function Xn(e) {
          Ar(e, 0);
        }
        function Qn(e) {
          if (X(oo(e))) return e;
        }
        function Jn(e, t) {
          if ("change" === e) return t;
        }
        var er = !1;
        if (d) {
          var tr;
          if (d) {
            var nr = "oninput" in document;
            if (!nr) {
              var rr = document.createElement("div");
              rr.setAttribute("oninput", "return;"), nr = "function" == typeof rr.oninput;
            }
            tr = nr;
          } else tr = !1;
          er = tr && (!document.documentMode || 9 < document.documentMode);
        }
        function or() {
          Wn && (Wn.detachEvent("onpropertychange", ir), Yn = Wn = null);
        }
        function ir(e) {
          if ("value" === e.propertyName && Qn(Yn)) {
            var t = [];
            if (Gn(t, Yn, e, _e(e)), e = Xn, je) e(t);else {
              je = !0;
              try {
                Ie(e, t);
              } finally {
                je = !1, Ne();
              }
            }
          }
        }
        function ar(e, t, n) {
          "focusin" === e ? (or(), Yn = n, (Wn = t).attachEvent("onpropertychange", ir)) : "focusout" === e && or();
        }
        function sr(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e) return Qn(Yn);
        }
        function lr(e, t) {
          if ("click" === e) return Qn(t);
        }
        function ur(e, t) {
          if ("input" === e || "change" === e) return Qn(t);
        }
        var cr = "function" == typeof Object.is ? Object.is : function (e, t) {
            return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
          },
          dr = Object.prototype.hasOwnProperty;
        function pr(e, t) {
          if (cr(e, t)) return !0;
          if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) if (!dr.call(t, n[r]) || !cr(e[n[r]], t[n[r]])) return !1;
          return !0;
        }
        function hr(e) {
          for (; e && e.firstChild;) e = e.firstChild;
          return e;
        }
        function fr(e, t) {
          var n,
            r = hr(e);
          for (e = 0; r;) {
            if (3 === r.nodeType) {
              if (n = e + r.textContent.length, e <= t && n >= t) return {
                node: r,
                offset: t - e
              };
              e = n;
            }
            e: {
              for (; r;) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = hr(r);
          }
        }
        function mr(e, t) {
          return !(!e || !t) && (e === t || (!e || 3 !== e.nodeType) && (t && 3 === t.nodeType ? mr(e, t.parentNode) : "contains" in e ? e.contains(t) : !!e.compareDocumentPosition && !!(16 & e.compareDocumentPosition(t))));
        }
        function gr() {
          for (var e = window, t = Q(); t instanceof e.HTMLIFrameElement;) {
            try {
              var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
              n = !1;
            }
            if (!n) break;
            t = Q((e = t.contentWindow).document);
          }
          return t;
        }
        function vr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return t && ("input" === t && ("text" === e.type || "search" === e.type || "tel" === e.type || "url" === e.type || "password" === e.type) || "textarea" === t || "true" === e.contentEditable);
        }
        var yr = d && "documentMode" in document && 11 >= document.documentMode,
          br = null,
          wr = null,
          xr = null,
          Dr = !1;
        function Cr(e, t, n) {
          var r = n.window === n ? n.document : 9 === n.nodeType ? n : n.ownerDocument;
          Dr || null == br || br !== Q(r) || ("selectionStart" in (r = br) && vr(r) ? r = {
            start: r.selectionStart,
            end: r.selectionEnd
          } : r = {
            anchorNode: (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection()).anchorNode,
            anchorOffset: r.anchorOffset,
            focusNode: r.focusNode,
            focusOffset: r.focusOffset
          }, xr && pr(xr, r) || (xr = r, 0 < (r = jr(wr, "onSelect")).length && (t = new hn("onSelect", "select", null, t, n), e.push({
            event: t,
            listeners: r
          }), t.target = br)));
        }
        Mt("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0), Mt("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1), Mt(Ft, 2);
        for (var Sr = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), Er = 0; Er < Sr.length; Er++) It.set(Sr[Er], 0);
        c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), u("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), u("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), u("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), u("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), u("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), u("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
        var _r = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
          Pr = new Set("cancel close invalid load scroll toggle".split(" ").concat(_r));
        function kr(e, t, n) {
          var r = e.type || "unknown-event";
          e.currentTarget = n, function (e, t, n, r, o, i, s, l, u) {
            if (We.apply(this, arguments), He) {
              if (!He) throw Error(a(198));
              var c = Ue;
              He = !1, Ue = null, Ze || (Ze = !0, $e = c);
            }
          }(r, t, void 0, e), e.currentTarget = null;
        }
        function Ar(e, t) {
          t = 0 != (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var i = void 0;
              if (t) for (var a = r.length - 1; 0 <= a; a--) {
                var s = r[a],
                  l = s.instance,
                  u = s.currentTarget;
                if (s = s.listener, l !== i && o.isPropagationStopped()) break e;
                kr(o, s, u), i = l;
              } else for (a = 0; a < r.length; a++) {
                if (l = (s = r[a]).instance, u = s.currentTarget, s = s.listener, l !== i && o.isPropagationStopped()) break e;
                kr(o, s, u), i = l;
              }
            }
          }
          if (Ze) throw e = $e, Ze = !1, $e = null, e;
        }
        function zr(e, t) {
          var n = ao(t),
            r = e + "__bubble";
          n.has(r) || (Fr(t, e, 2, !1), n.add(r));
        }
        var Tr = "_reactListening" + Math.random().toString(36).slice(2);
        function Or(e) {
          e[Tr] || (e[Tr] = !0, s.forEach(function (t) {
            Pr.has(t) || Ir(t, !1, e, null), Ir(t, !0, e, null);
          }));
        }
        function Ir(e, t, n, r) {
          var o = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
            i = n;
          if ("selectionchange" === e && 9 !== n.nodeType && (i = n.ownerDocument), null !== r && !t && Pr.has(e)) {
            if ("scroll" !== e) return;
            o |= 2, i = r;
          }
          var a = ao(i),
            s = e + "__" + (t ? "capture" : "bubble");
          a.has(s) || (t && (o |= 4), Fr(i, e, o, t), a.add(s));
        }
        function Fr(e, t, n, r) {
          var o = It.get(t);
          switch (void 0 === o ? 2 : o) {
            case 0:
              o = Yt;
              break;
            case 1:
              o = Xt;
              break;
            default:
              o = Qt;
          }
          n = o.bind(null, t, n, e), o = void 0, !Ve || "touchstart" !== t && "touchmove" !== t && "wheel" !== t || (o = !0), r ? void 0 !== o ? e.addEventListener(t, n, {
            capture: !0,
            passive: o
          }) : e.addEventListener(t, n, !0) : void 0 !== o ? e.addEventListener(t, n, {
            passive: o
          }) : e.addEventListener(t, n, !1);
        }
        function Mr(e, t, n, r, o) {
          var i = r;
          if (0 == (1 & t) && 0 == (2 & t) && null !== r) e: for (;;) {
            if (null === r) return;
            var a = r.tag;
            if (3 === a || 4 === a) {
              var s = r.stateNode.containerInfo;
              if (s === o || 8 === s.nodeType && s.parentNode === o) break;
              if (4 === a) for (a = r.return; null !== a;) {
                var l = a.tag;
                if ((3 === l || 4 === l) && ((l = a.stateNode.containerInfo) === o || 8 === l.nodeType && l.parentNode === o)) return;
                a = a.return;
              }
              for (; null !== s;) {
                if (null === (a = no(s))) return;
                if (5 === (l = a.tag) || 6 === l) {
                  r = i = a;
                  continue e;
                }
                s = s.parentNode;
              }
            }
            r = r.return;
          }
          !function (e, t, n) {
            if (Be) return e(t, n);
            Be = !0;
            try {
              Re(e, t, n);
            } finally {
              Be = !1, Ne();
            }
          }(function () {
            var r = i,
              o = _e(n),
              a = [];
            e: {
              var s = Ot.get(e);
              if (void 0 !== s) {
                var l = hn,
                  u = e;
                switch (e) {
                  case "keypress":
                    if (0 === on(n)) break e;
                  case "keydown":
                  case "keyup":
                    l = zn;
                    break;
                  case "focusin":
                    u = "focus", l = bn;
                    break;
                  case "focusout":
                    u = "blur", l = bn;
                    break;
                  case "beforeblur":
                  case "afterblur":
                    l = bn;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    l = vn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    l = yn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    l = On;
                    break;
                  case kt:
                  case At:
                  case zt:
                    l = wn;
                    break;
                  case Tt:
                    l = In;
                    break;
                  case "scroll":
                    l = mn;
                    break;
                  case "wheel":
                    l = Mn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    l = Dn;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    l = Tn;
                }
                var c = 0 != (4 & t),
                  d = !c && "scroll" === e,
                  p = c ? null !== s ? s + "Capture" : null : s;
                c = [];
                for (var h, f = r; null !== f;) {
                  var m = (h = f).stateNode;
                  if (5 === h.tag && null !== m && (h = m, null !== p && null != (m = Le(f, p)) && c.push(Rr(f, m, h))), d) break;
                  f = f.return;
                }
                0 < c.length && (s = new l(s, u, null, n, o), a.push({
                  event: s,
                  listeners: c
                }));
              }
            }
            if (0 == (7 & t)) {
              if (l = "mouseout" === e || "pointerout" === e, (!(s = "mouseover" === e || "pointerover" === e) || 0 != (16 & t) || !(u = n.relatedTarget || n.fromElement) || !no(u) && !u[eo]) && (l || s) && (s = o.window === o ? o : (s = o.ownerDocument) ? s.defaultView || s.parentWindow : window, l ? (l = r, null !== (u = (u = n.relatedTarget || n.toElement) ? no(u) : null) && (u !== (d = Ye(u)) || 5 !== u.tag && 6 !== u.tag) && (u = null)) : (l = null, u = r), l !== u)) {
                if (c = vn, m = "onMouseLeave", p = "onMouseEnter", f = "mouse", "pointerout" !== e && "pointerover" !== e || (c = Tn, m = "onPointerLeave", p = "onPointerEnter", f = "pointer"), d = null == l ? s : oo(l), h = null == u ? s : oo(u), (s = new c(m, f + "leave", l, n, o)).target = d, s.relatedTarget = h, m = null, no(o) === r && ((c = new c(p, f + "enter", u, n, o)).target = h, c.relatedTarget = d, m = c), d = m, l && u) e: {
                  for (p = u, f = 0, h = c = l; h; h = Br(h)) f++;
                  for (h = 0, m = p; m; m = Br(m)) h++;
                  for (; 0 < f - h;) c = Br(c), f--;
                  for (; 0 < h - f;) p = Br(p), h--;
                  for (; f--;) {
                    if (c === p || null !== p && c === p.alternate) break e;
                    c = Br(c), p = Br(p);
                  }
                  c = null;
                } else c = null;
                null !== l && Nr(a, s, l, c, !1), null !== u && null !== d && Nr(a, d, u, c, !0);
              }
              if ("select" === (l = (s = r ? oo(r) : window).nodeName && s.nodeName.toLowerCase()) || "input" === l && "file" === s.type) var g = Jn;else if ($n(s)) {
                if (er) g = ur;else {
                  g = sr;
                  var v = ar;
                }
              } else (l = s.nodeName) && "input" === l.toLowerCase() && ("checkbox" === s.type || "radio" === s.type) && (g = lr);
              switch (g && (g = g(e, r)) ? Gn(a, g, n, o) : (v && v(e, s, r), "focusout" === e && (v = s._wrapperState) && v.controlled && "number" === s.type && oe(s, "number", s.value)), v = r ? oo(r) : window, e) {
                case "focusin":
                  ($n(v) || "true" === v.contentEditable) && (br = v, wr = r, xr = null);
                  break;
                case "focusout":
                  xr = wr = br = null;
                  break;
                case "mousedown":
                  Dr = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  Dr = !1, Cr(a, n, o);
                  break;
                case "selectionchange":
                  if (yr) break;
                case "keydown":
                case "keyup":
                  Cr(a, n, o);
              }
              var y;
              if (jn) e: {
                switch (e) {
                  case "compositionstart":
                    var b = "onCompositionStart";
                    break e;
                  case "compositionend":
                    b = "onCompositionEnd";
                    break e;
                  case "compositionupdate":
                    b = "onCompositionUpdate";
                    break e;
                }
                b = void 0;
              } else Un ? qn(e, n) && (b = "onCompositionEnd") : "keydown" === e && 229 === n.keyCode && (b = "onCompositionStart");
              b && (Ln && "ko" !== n.locale && (Un || "onCompositionStart" !== b ? "onCompositionEnd" === b && Un && (y = rn()) : (tn = "value" in (en = o) ? en.value : en.textContent, Un = !0)), 0 < (v = jr(r, b)).length && (b = new Cn(b, e, null, n, o), a.push({
                event: b,
                listeners: v
              }), y ? b.data = y : null !== (y = Hn(n)) && (b.data = y))), (y = Nn ? function (e, t) {
                switch (e) {
                  case "compositionend":
                    return Hn(t);
                  case "keypress":
                    return 32 !== t.which ? null : (Kn = !0, Vn);
                  case "textInput":
                    return (e = t.data) === Vn && Kn ? null : e;
                  default:
                    return null;
                }
              }(e, n) : function (e, t) {
                if (Un) return "compositionend" === e || !jn && qn(e, t) ? (e = rn(), nn = tn = en = null, Un = !1, e) : null;
                switch (e) {
                  case "paste":
                  default:
                    return null;
                  case "keypress":
                    if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
                      if (t.char && 1 < t.char.length) return t.char;
                      if (t.which) return String.fromCharCode(t.which);
                    }
                    return null;
                  case "compositionend":
                    return Ln && "ko" !== t.locale ? null : t.data;
                }
              }(e, n)) && 0 < (r = jr(r, "onBeforeInput")).length && (o = new Cn("onBeforeInput", "beforeinput", null, n, o), a.push({
                event: o,
                listeners: r
              }), o.data = y);
            }
            Ar(a, t);
          });
        }
        function Rr(e, t, n) {
          return {
            instance: e,
            listener: t,
            currentTarget: n
          };
        }
        function jr(e, t) {
          for (var n = t + "Capture", r = []; null !== e;) {
            var o = e,
              i = o.stateNode;
            5 === o.tag && null !== i && (o = i, null != (i = Le(e, n)) && r.unshift(Rr(e, i, o)), null != (i = Le(e, t)) && r.push(Rr(e, i, o))), e = e.return;
          }
          return r;
        }
        function Br(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Nr(e, t, n, r, o) {
          for (var i = t._reactName, a = []; null !== n && n !== r;) {
            var s = n,
              l = s.alternate,
              u = s.stateNode;
            if (null !== l && l === r) break;
            5 === s.tag && null !== u && (s = u, o ? null != (l = Le(n, i)) && a.unshift(Rr(n, l, s)) : o || null != (l = Le(n, i)) && a.push(Rr(n, l, s))), n = n.return;
          }
          0 !== a.length && e.push({
            event: t,
            listeners: a
          });
        }
        function Lr() {}
        var Vr = null,
          Kr = null;
        function qr(e, t) {
          switch (e) {
            case "button":
            case "input":
            case "select":
            case "textarea":
              return !!t.autoFocus;
          }
          return !1;
        }
        function Hr(e, t) {
          return "textarea" === e || "option" === e || "noscript" === e || "string" == typeof t.children || "number" == typeof t.children || "object" == typeof t.dangerouslySetInnerHTML && null !== t.dangerouslySetInnerHTML && null != t.dangerouslySetInnerHTML.__html;
        }
        var Ur = "function" == typeof setTimeout ? setTimeout : void 0,
          Zr = "function" == typeof clearTimeout ? clearTimeout : void 0;
        function $r(e) {
          1 === e.nodeType ? e.textContent = "" : 9 === e.nodeType && null != (e = e.body) && (e.textContent = "");
        }
        function Gr(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
          }
          return e;
        }
        function Wr(e) {
          e = e.previousSibling;
          for (var t = 0; e;) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var Yr = 0;
        var Xr = Math.random().toString(36).slice(2),
          Qr = "__reactFiber$" + Xr,
          Jr = "__reactProps$" + Xr,
          eo = "__reactContainer$" + Xr,
          to = "__reactEvents$" + Xr;
        function no(e) {
          var t = e[Qr];
          if (t) return t;
          for (var n = e.parentNode; n;) {
            if (t = n[eo] || n[Qr]) {
              if (n = t.alternate, null !== t.child || null !== n && null !== n.child) for (e = Wr(e); null !== e;) {
                if (n = e[Qr]) return n;
                e = Wr(e);
              }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function ro(e) {
          return !(e = e[Qr] || e[eo]) || 5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag ? null : e;
        }
        function oo(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(a(33));
        }
        function io(e) {
          return e[Jr] || null;
        }
        function ao(e) {
          var t = e[to];
          return void 0 === t && (t = e[to] = new Set()), t;
        }
        var so = [],
          lo = -1;
        function uo(e) {
          return {
            current: e
          };
        }
        function co(e) {
          0 > lo || (e.current = so[lo], so[lo] = null, lo--);
        }
        function po(e, t) {
          lo++, so[lo] = e.current, e.current = t;
        }
        var ho = {},
          fo = uo(ho),
          mo = uo(!1),
          go = ho;
        function vo(e, t) {
          var n = e.type.contextTypes;
          if (!n) return ho;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t) return r.__reactInternalMemoizedMaskedChildContext;
          var o,
            i = {};
          for (o in n) i[o] = t[o];
          return r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = t, e.__reactInternalMemoizedMaskedChildContext = i), i;
        }
        function yo(e) {
          return null != (e = e.childContextTypes);
        }
        function bo() {
          co(mo), co(fo);
        }
        function wo(e, t, n) {
          if (fo.current !== ho) throw Error(a(168));
          po(fo, t), po(mo, n);
        }
        function xo(e, t, n) {
          var r = e.stateNode;
          if (e = t.childContextTypes, "function" != typeof r.getChildContext) return n;
          for (var i in r = r.getChildContext()) if (!(i in e)) throw Error(a(108, $(t) || "Unknown", i));
          return o({}, n, r);
        }
        function Do(e) {
          return e = (e = e.stateNode) && e.__reactInternalMemoizedMergedChildContext || ho, go = fo.current, po(fo, e), po(mo, mo.current), !0;
        }
        function Co(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(a(169));
          n ? (e = xo(e, t, go), r.__reactInternalMemoizedMergedChildContext = e, co(mo), co(fo), po(fo, e)) : co(mo), po(mo, n);
        }
        var So = null,
          Eo = null,
          _o = i.unstable_runWithPriority,
          Po = i.unstable_scheduleCallback,
          ko = i.unstable_cancelCallback,
          Ao = i.unstable_shouldYield,
          zo = i.unstable_requestPaint,
          To = i.unstable_now,
          Oo = i.unstable_getCurrentPriorityLevel,
          Io = i.unstable_ImmediatePriority,
          Fo = i.unstable_UserBlockingPriority,
          Mo = i.unstable_NormalPriority,
          Ro = i.unstable_LowPriority,
          jo = i.unstable_IdlePriority,
          Bo = {},
          No = void 0 !== zo ? zo : function () {},
          Lo = null,
          Vo = null,
          Ko = !1,
          qo = To(),
          Ho = 1e4 > qo ? To : function () {
            return To() - qo;
          };
        function Uo() {
          switch (Oo()) {
            case Io:
              return 99;
            case Fo:
              return 98;
            case Mo:
              return 97;
            case Ro:
              return 96;
            case jo:
              return 95;
            default:
              throw Error(a(332));
          }
        }
        function Zo(e) {
          switch (e) {
            case 99:
              return Io;
            case 98:
              return Fo;
            case 97:
              return Mo;
            case 96:
              return Ro;
            case 95:
              return jo;
            default:
              throw Error(a(332));
          }
        }
        function $o(e, t) {
          return e = Zo(e), _o(e, t);
        }
        function Go(e, t, n) {
          return e = Zo(e), Po(e, t, n);
        }
        function Wo() {
          if (null !== Vo) {
            var e = Vo;
            Vo = null, ko(e);
          }
          Yo();
        }
        function Yo() {
          if (!Ko && null !== Lo) {
            Ko = !0;
            var e = 0;
            try {
              var t = Lo;
              $o(99, function () {
                for (; e < t.length; e++) {
                  var n = t[e];
                  do {
                    n = n(!0);
                  } while (null !== n);
                }
              }), Lo = null;
            } catch (t) {
              throw null !== Lo && (Lo = Lo.slice(e + 1)), Po(Io, Wo), t;
            } finally {
              Ko = !1;
            }
          }
        }
        var Xo = x.ReactCurrentBatchConfig;
        function Qo(e, t) {
          if (e && e.defaultProps) {
            for (var n in t = o({}, t), e = e.defaultProps) void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        var Jo = uo(null),
          ei = null,
          ti = null,
          ni = null;
        function ri() {
          ni = ti = ei = null;
        }
        function oi(e) {
          var t = Jo.current;
          co(Jo), e.type._context._currentValue = t;
        }
        function ii(e, t) {
          for (; null !== e;) {
            var n = e.alternate;
            if ((e.childLanes & t) === t) {
              if (null === n || (n.childLanes & t) === t) break;
              n.childLanes |= t;
            } else e.childLanes |= t, null !== n && (n.childLanes |= t);
            e = e.return;
          }
        }
        function ai(e, t) {
          ei = e, ni = ti = null, null !== (e = e.dependencies) && null !== e.firstContext && (0 != (e.lanes & t) && (ja = !0), e.firstContext = null);
        }
        function si(e, t) {
          if (ni !== e && !1 !== t && 0 !== t) if ("number" == typeof t && 1073741823 !== t || (ni = e, t = 1073741823), t = {
            context: e,
            observedBits: t,
            next: null
          }, null === ti) {
            if (null === ei) throw Error(a(308));
            ti = t, ei.dependencies = {
              lanes: 0,
              firstContext: t,
              responders: null
            };
          } else ti = ti.next = t;
          return e._currentValue;
        }
        var li = !1;
        function ui(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
              pending: null
            },
            effects: null
          };
        }
        function ci(e, t) {
          e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
            baseState: e.baseState,
            firstBaseUpdate: e.firstBaseUpdate,
            lastBaseUpdate: e.lastBaseUpdate,
            shared: e.shared,
            effects: e.effects
          });
        }
        function di(e, t) {
          return {
            eventTime: e,
            lane: t,
            tag: 0,
            payload: null,
            callback: null,
            next: null
          };
        }
        function pi(e, t) {
          if (null !== (e = e.updateQueue)) {
            var n = (e = e.shared).pending;
            null === n ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
          }
        }
        function hi(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              i = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var a = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null
                };
                null === i ? o = i = a : i = i.next = a, n = n.next;
              } while (null !== n);
              null === i ? o = i = t : i = i.next = t;
            } else o = i = t;
            return n = {
              baseState: r.baseState,
              firstBaseUpdate: o,
              lastBaseUpdate: i,
              shared: r.shared,
              effects: r.effects
            }, void (e.updateQueue = n);
          }
          null === (e = n.lastBaseUpdate) ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
        }
        function fi(e, t, n, r) {
          var i = e.updateQueue;
          li = !1;
          var a = i.firstBaseUpdate,
            s = i.lastBaseUpdate,
            l = i.shared.pending;
          if (null !== l) {
            i.shared.pending = null;
            var u = l,
              c = u.next;
            u.next = null, null === s ? a = c : s.next = c, s = u;
            var d = e.alternate;
            if (null !== d) {
              var p = (d = d.updateQueue).lastBaseUpdate;
              p !== s && (null === p ? d.firstBaseUpdate = c : p.next = c, d.lastBaseUpdate = u);
            }
          }
          if (null !== a) {
            for (p = i.baseState, s = 0, d = c = u = null;;) {
              l = a.lane;
              var h = a.eventTime;
              if ((r & l) === l) {
                null !== d && (d = d.next = {
                  eventTime: h,
                  lane: 0,
                  tag: a.tag,
                  payload: a.payload,
                  callback: a.callback,
                  next: null
                });
                e: {
                  var f = e,
                    m = a;
                  switch (l = t, h = n, m.tag) {
                    case 1:
                      if ("function" == typeof (f = m.payload)) {
                        p = f.call(h, p, l);
                        break e;
                      }
                      p = f;
                      break e;
                    case 3:
                      f.flags = -4097 & f.flags | 64;
                    case 0:
                      if (null == (l = "function" == typeof (f = m.payload) ? f.call(h, p, l) : f)) break e;
                      p = o({}, p, l);
                      break e;
                    case 2:
                      li = !0;
                  }
                }
                null !== a.callback && (e.flags |= 32, null === (l = i.effects) ? i.effects = [a] : l.push(a));
              } else h = {
                eventTime: h,
                lane: l,
                tag: a.tag,
                payload: a.payload,
                callback: a.callback,
                next: null
              }, null === d ? (c = d = h, u = p) : d = d.next = h, s |= l;
              if (null === (a = a.next)) {
                if (null === (l = i.shared.pending)) break;
                a = l.next, l.next = null, i.lastBaseUpdate = l, i.shared.pending = null;
              }
            }
            null === d && (u = p), i.baseState = u, i.firstBaseUpdate = c, i.lastBaseUpdate = d, Vs |= s, e.lanes = s, e.memoizedState = p;
          }
        }
        function mi(e, t, n) {
          if (e = t.effects, t.effects = null, null !== e) for (t = 0; t < e.length; t++) {
            var r = e[t],
              o = r.callback;
            if (null !== o) {
              if (r.callback = null, r = n, "function" != typeof o) throw Error(a(191, o));
              o.call(r);
            }
          }
        }
        var gi = new r.Component().refs;
        function vi(e, t, n, r) {
          n = null == (n = n(r, t = e.memoizedState)) ? t : o({}, t, n), e.memoizedState = n, 0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var yi = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && Ye(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = pl(),
              o = hl(e),
              i = di(r, o);
            i.payload = t, null != n && (i.callback = n), pi(e, i), fl(e, o, r);
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = pl(),
              o = hl(e),
              i = di(r, o);
            i.tag = 1, i.payload = t, null != n && (i.callback = n), pi(e, i), fl(e, o, r);
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = pl(),
              r = hl(e),
              o = di(n, r);
            o.tag = 2, null != t && (o.callback = t), pi(e, o), fl(e, r, n);
          }
        };
        function bi(e, t, n, r, o, i, a) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate ? e.shouldComponentUpdate(r, i, a) : !t.prototype || !t.prototype.isPureReactComponent || !pr(n, r) || !pr(o, i);
        }
        function wi(e, t, n) {
          var r = !1,
            o = ho,
            i = t.contextType;
          return "object" == typeof i && null !== i ? i = si(i) : (o = yo(t) ? go : fo.current, i = (r = null != (r = t.contextTypes)) ? vo(e, o) : ho), t = new t(n, i), e.memoizedState = null !== t.state && void 0 !== t.state ? t.state : null, t.updater = yi, e.stateNode = t, t._reactInternals = e, r && ((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext = o, e.__reactInternalMemoizedMaskedChildContext = i), t;
        }
        function xi(e, t, n, r) {
          e = t.state, "function" == typeof t.componentWillReceiveProps && t.componentWillReceiveProps(n, r), "function" == typeof t.UNSAFE_componentWillReceiveProps && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && yi.enqueueReplaceState(t, t.state, null);
        }
        function Di(e, t, n, r) {
          var o = e.stateNode;
          o.props = n, o.state = e.memoizedState, o.refs = gi, ui(e);
          var i = t.contextType;
          "object" == typeof i && null !== i ? o.context = si(i) : (i = yo(t) ? go : fo.current, o.context = vo(e, i)), fi(e, n, o, r), o.state = e.memoizedState, "function" == typeof (i = t.getDerivedStateFromProps) && (vi(e, t, i, n), o.state = e.memoizedState), "function" == typeof t.getDerivedStateFromProps || "function" == typeof o.getSnapshotBeforeUpdate || "function" != typeof o.UNSAFE_componentWillMount && "function" != typeof o.componentWillMount || (t = o.state, "function" == typeof o.componentWillMount && o.componentWillMount(), "function" == typeof o.UNSAFE_componentWillMount && o.UNSAFE_componentWillMount(), t !== o.state && yi.enqueueReplaceState(o, o.state, null), fi(e, n, o, r), o.state = e.memoizedState), "function" == typeof o.componentDidMount && (e.flags |= 4);
        }
        var Ci = Array.isArray;
        function Si(e, t, n) {
          if (null !== (e = n.ref) && "function" != typeof e && "object" != typeof e) {
            if (n._owner) {
              if (n = n._owner) {
                if (1 !== n.tag) throw Error(a(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(a(147, e));
              var o = "" + e;
              return null !== t && null !== t.ref && "function" == typeof t.ref && t.ref._stringRef === o ? t.ref : (t = function (e) {
                var t = r.refs;
                t === gi && (t = r.refs = {}), null === e ? delete t[o] : t[o] = e;
              }, t._stringRef = o, t);
            }
            if ("string" != typeof e) throw Error(a(284));
            if (!n._owner) throw Error(a(290, e));
          }
          return e;
        }
        function Ei(e, t) {
          if ("textarea" !== e.type) throw Error(a(31, "[object Object]" === Object.prototype.toString.call(t) ? "object with keys {" + Object.keys(t).join(", ") + "}" : t));
        }
        function _i(e) {
          function t(t, n) {
            if (e) {
              var r = t.lastEffect;
              null !== r ? (r.nextEffect = n, t.lastEffect = n) : t.firstEffect = t.lastEffect = n, n.nextEffect = null, n.flags = 8;
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r;) t(n, r), r = r.sibling;
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t;) null !== t.key ? e.set(t.key, t) : e.set(t.index, t), t = t.sibling;
            return e;
          }
          function o(e, t) {
            return (e = Zl(e, t)).index = 0, e.sibling = null, e;
          }
          function i(t, n, r) {
            return t.index = r, e ? null !== (r = t.alternate) ? (r = r.index) < n ? (t.flags = 2, n) : r : (t.flags = 2, n) : n;
          }
          function s(t) {
            return e && null === t.alternate && (t.flags = 2), t;
          }
          function l(e, t, n, r) {
            return null === t || 6 !== t.tag ? ((t = Yl(n, e.mode, r)).return = e, t) : ((t = o(t, n)).return = e, t);
          }
          function u(e, t, n, r) {
            return null !== t && t.elementType === n.type ? ((r = o(t, n.props)).ref = Si(e, t, n), r.return = e, r) : ((r = $l(n.type, n.key, n.props, null, e.mode, r)).ref = Si(e, t, n), r.return = e, r);
          }
          function c(e, t, n, r) {
            return null === t || 4 !== t.tag || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? ((t = Xl(n, e.mode, r)).return = e, t) : ((t = o(t, n.children || [])).return = e, t);
          }
          function d(e, t, n, r, i) {
            return null === t || 7 !== t.tag ? ((t = Gl(n, e.mode, r, i)).return = e, t) : ((t = o(t, n)).return = e, t);
          }
          function p(e, t, n) {
            if ("string" == typeof t || "number" == typeof t) return (t = Yl("" + t, e.mode, n)).return = e, t;
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case D:
                  return (n = $l(t.type, t.key, t.props, null, e.mode, n)).ref = Si(e, null, t), n.return = e, n;
                case C:
                  return (t = Xl(t, e.mode, n)).return = e, t;
              }
              if (Ci(t) || K(t)) return (t = Gl(t, e.mode, n, null)).return = e, t;
              Ei(e, t);
            }
            return null;
          }
          function h(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if ("string" == typeof n || "number" == typeof n) return null !== o ? null : l(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case D:
                  return n.key === o ? n.type === S ? d(e, t, n.props.children, r, o) : u(e, t, n, r) : null;
                case C:
                  return n.key === o ? c(e, t, n, r) : null;
              }
              if (Ci(n) || K(n)) return null !== o ? null : d(e, t, n, r, null);
              Ei(e, n);
            }
            return null;
          }
          function f(e, t, n, r, o) {
            if ("string" == typeof r || "number" == typeof r) return l(t, e = e.get(n) || null, "" + r, o);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case D:
                  return e = e.get(null === r.key ? n : r.key) || null, r.type === S ? d(t, e, r.props.children, o, r.key) : u(t, e, r, o);
                case C:
                  return c(t, e = e.get(null === r.key ? n : r.key) || null, r, o);
              }
              if (Ci(r) || K(r)) return d(t, e = e.get(n) || null, r, o, null);
              Ei(t, r);
            }
            return null;
          }
          function m(o, a, s, l) {
            for (var u = null, c = null, d = a, m = a = 0, g = null; null !== d && m < s.length; m++) {
              d.index > m ? (g = d, d = null) : g = d.sibling;
              var v = h(o, d, s[m], l);
              if (null === v) {
                null === d && (d = g);
                break;
              }
              e && d && null === v.alternate && t(o, d), a = i(v, a, m), null === c ? u = v : c.sibling = v, c = v, d = g;
            }
            if (m === s.length) return n(o, d), u;
            if (null === d) {
              for (; m < s.length; m++) null !== (d = p(o, s[m], l)) && (a = i(d, a, m), null === c ? u = d : c.sibling = d, c = d);
              return u;
            }
            for (d = r(o, d); m < s.length; m++) null !== (g = f(d, o, m, s[m], l)) && (e && null !== g.alternate && d.delete(null === g.key ? m : g.key), a = i(g, a, m), null === c ? u = g : c.sibling = g, c = g);
            return e && d.forEach(function (e) {
              return t(o, e);
            }), u;
          }
          function g(o, s, l, u) {
            var c = K(l);
            if ("function" != typeof c) throw Error(a(150));
            if (null == (l = c.call(l))) throw Error(a(151));
            for (var d = c = null, m = s, g = s = 0, v = null, y = l.next(); null !== m && !y.done; g++, y = l.next()) {
              m.index > g ? (v = m, m = null) : v = m.sibling;
              var b = h(o, m, y.value, u);
              if (null === b) {
                null === m && (m = v);
                break;
              }
              e && m && null === b.alternate && t(o, m), s = i(b, s, g), null === d ? c = b : d.sibling = b, d = b, m = v;
            }
            if (y.done) return n(o, m), c;
            if (null === m) {
              for (; !y.done; g++, y = l.next()) null !== (y = p(o, y.value, u)) && (s = i(y, s, g), null === d ? c = y : d.sibling = y, d = y);
              return c;
            }
            for (m = r(o, m); !y.done; g++, y = l.next()) null !== (y = f(m, o, g, y.value, u)) && (e && null !== y.alternate && m.delete(null === y.key ? g : y.key), s = i(y, s, g), null === d ? c = y : d.sibling = y, d = y);
            return e && m.forEach(function (e) {
              return t(o, e);
            }), c;
          }
          return function (e, r, i, l) {
            var u = "object" == typeof i && null !== i && i.type === S && null === i.key;
            u && (i = i.props.children);
            var c = "object" == typeof i && null !== i;
            if (c) switch (i.$$typeof) {
              case D:
                e: {
                  for (c = i.key, u = r; null !== u;) {
                    if (u.key === c) {
                      if (7 === u.tag) {
                        if (i.type === S) {
                          n(e, u.sibling), (r = o(u, i.props.children)).return = e, e = r;
                          break e;
                        }
                      } else if (u.elementType === i.type) {
                        n(e, u.sibling), (r = o(u, i.props)).ref = Si(e, u, i), r.return = e, e = r;
                        break e;
                      }
                      n(e, u);
                      break;
                    }
                    t(e, u), u = u.sibling;
                  }
                  i.type === S ? ((r = Gl(i.props.children, e.mode, l, i.key)).return = e, e = r) : ((l = $l(i.type, i.key, i.props, null, e.mode, l)).ref = Si(e, r, i), l.return = e, e = l);
                }
                return s(e);
              case C:
                e: {
                  for (u = i.key; null !== r;) {
                    if (r.key === u) {
                      if (4 === r.tag && r.stateNode.containerInfo === i.containerInfo && r.stateNode.implementation === i.implementation) {
                        n(e, r.sibling), (r = o(r, i.children || [])).return = e, e = r;
                        break e;
                      }
                      n(e, r);
                      break;
                    }
                    t(e, r), r = r.sibling;
                  }
                  (r = Xl(i, e.mode, l)).return = e, e = r;
                }
                return s(e);
            }
            if ("string" == typeof i || "number" == typeof i) return i = "" + i, null !== r && 6 === r.tag ? (n(e, r.sibling), (r = o(r, i)).return = e, e = r) : (n(e, r), (r = Yl(i, e.mode, l)).return = e, e = r), s(e);
            if (Ci(i)) return m(e, r, i, l);
            if (K(i)) return g(e, r, i, l);
            if (c && Ei(e, i), void 0 === i && !u) switch (e.tag) {
              case 1:
              case 22:
              case 0:
              case 11:
              case 15:
                throw Error(a(152, $(e.type) || "Component"));
            }
            return n(e, r);
          };
        }
        var Pi = _i(!0),
          ki = _i(!1),
          Ai = {},
          zi = uo(Ai),
          Ti = uo(Ai),
          Oi = uo(Ai);
        function Ii(e) {
          if (e === Ai) throw Error(a(174));
          return e;
        }
        function Fi(e, t) {
          switch (po(Oi, t), po(Ti, e), po(zi, Ai), e = t.nodeType) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : fe(null, "");
              break;
            default:
              t = fe(t = (e = 8 === e ? t.parentNode : t).namespaceURI || null, e = e.tagName);
          }
          co(zi), po(zi, t);
        }
        function Mi() {
          co(zi), co(Ti), co(Oi);
        }
        function Ri(e) {
          Ii(Oi.current);
          var t = Ii(zi.current),
            n = fe(t, e.type);
          t !== n && (po(Ti, e), po(zi, n));
        }
        function ji(e) {
          Ti.current === e && (co(zi), co(Ti));
        }
        var Bi = uo(0);
        function Ni(e) {
          for (var t = e; null !== t;) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (null !== n && (null === (n = n.dehydrated) || "$?" === n.data || "$!" === n.data)) return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 != (64 & t.flags)) return t;
            } else if (null !== t.child) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling;) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            t.sibling.return = t.return, t = t.sibling;
          }
          return null;
        }
        var Li = null,
          Vi = null,
          Ki = !1;
        function qi(e, t) {
          var n = Hl(5, null, null, 0);
          n.elementType = "DELETED", n.type = "DELETED", n.stateNode = t, n.return = e, n.flags = 8, null !== e.lastEffect ? (e.lastEffect.nextEffect = n, e.lastEffect = n) : e.firstEffect = e.lastEffect = n;
        }
        function Hi(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return null !== (t = 1 !== t.nodeType || n.toLowerCase() !== t.nodeName.toLowerCase() ? null : t) && (e.stateNode = t, !0);
            case 6:
              return null !== (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) && (e.stateNode = t, !0);
            default:
              return !1;
          }
        }
        function Ui(e) {
          if (Ki) {
            var t = Vi;
            if (t) {
              var n = t;
              if (!Hi(e, t)) {
                if (!(t = Gr(n.nextSibling)) || !Hi(e, t)) return e.flags = -1025 & e.flags | 2, Ki = !1, void (Li = e);
                qi(Li, n);
              }
              Li = e, Vi = Gr(t.firstChild);
            } else e.flags = -1025 & e.flags | 2, Ki = !1, Li = e;
          }
        }
        function Zi(e) {
          for (e = e.return; null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;) e = e.return;
          Li = e;
        }
        function $i(e) {
          if (e !== Li) return !1;
          if (!Ki) return Zi(e), Ki = !0, !1;
          var t = e.type;
          if (5 !== e.tag || "head" !== t && "body" !== t && !Hr(t, e.memoizedProps)) for (t = Vi; t;) qi(e, t), t = Gr(t.nextSibling);
          if (Zi(e), 13 === e.tag) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null)) throw Error(a(317));
            e: {
              for (e = e.nextSibling, t = 0; e;) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ("/$" === n) {
                    if (0 === t) {
                      Vi = Gr(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else "$" !== n && "$!" !== n && "$?" !== n || t++;
                }
                e = e.nextSibling;
              }
              Vi = null;
            }
          } else Vi = Li ? Gr(e.stateNode.nextSibling) : null;
          return !0;
        }
        function Gi() {
          Vi = Li = null, Ki = !1;
        }
        var Wi = [];
        function Yi() {
          for (var e = 0; e < Wi.length; e++) Wi[e]._workInProgressVersionPrimary = null;
          Wi.length = 0;
        }
        var Xi = x.ReactCurrentDispatcher,
          Qi = x.ReactCurrentBatchConfig,
          Ji = 0,
          ea = null,
          ta = null,
          na = null,
          ra = !1,
          oa = !1;
        function ia() {
          throw Error(a(321));
        }
        function aa(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++) if (!cr(e[n], t[n])) return !1;
          return !0;
        }
        function sa(e, t, n, r, o, i) {
          if (Ji = i, ea = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, Xi.current = null === e || null === e.memoizedState ? Ia : Fa, e = n(r, o), oa) {
            i = 0;
            do {
              if (oa = !1, !(25 > i)) throw Error(a(301));
              i += 1, na = ta = null, t.updateQueue = null, Xi.current = Ma, e = n(r, o);
            } while (oa);
          }
          if (Xi.current = Oa, t = null !== ta && null !== ta.next, Ji = 0, na = ta = ea = null, ra = !1, t) throw Error(a(300));
          return e;
        }
        function la() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
          };
          return null === na ? ea.memoizedState = na = e : na = na.next = e, na;
        }
        function ua() {
          if (null === ta) {
            var e = ea.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = ta.next;
          var t = null === na ? ea.memoizedState : na.next;
          if (null !== t) na = t, ta = e;else {
            if (null === e) throw Error(a(310));
            e = {
              memoizedState: (ta = e).memoizedState,
              baseState: ta.baseState,
              baseQueue: ta.baseQueue,
              queue: ta.queue,
              next: null
            }, null === na ? ea.memoizedState = na = e : na = na.next = e;
          }
          return na;
        }
        function ca(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
        function da(e) {
          var t = ua(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = ta,
            o = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== o) {
              var s = o.next;
              o.next = i.next, i.next = s;
            }
            r.baseQueue = o = i, n.pending = null;
          }
          if (null !== o) {
            o = o.next, r = r.baseState;
            var l = s = i = null,
              u = o;
            do {
              var c = u.lane;
              if ((Ji & c) === c) null !== l && (l = l.next = {
                lane: 0,
                action: u.action,
                eagerReducer: u.eagerReducer,
                eagerState: u.eagerState,
                next: null
              }), r = u.eagerReducer === e ? u.eagerState : e(r, u.action);else {
                var d = {
                  lane: c,
                  action: u.action,
                  eagerReducer: u.eagerReducer,
                  eagerState: u.eagerState,
                  next: null
                };
                null === l ? (s = l = d, i = r) : l = l.next = d, ea.lanes |= c, Vs |= c;
              }
              u = u.next;
            } while (null !== u && u !== o);
            null === l ? i = r : l.next = s, cr(r, t.memoizedState) || (ja = !0), t.memoizedState = r, t.baseState = i, t.baseQueue = l, n.lastRenderedState = r;
          }
          return [t.memoizedState, n.dispatch];
        }
        function pa(e) {
          var t = ua(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            i = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var s = o = o.next;
            do {
              i = e(i, s.action), s = s.next;
            } while (s !== o);
            cr(i, t.memoizedState) || (ja = !0), t.memoizedState = i, null === t.baseQueue && (t.baseState = i), n.lastRenderedState = i;
          }
          return [i, r];
        }
        function ha(e, t, n) {
          var r = t._getVersion;
          r = r(t._source);
          var o = t._workInProgressVersionPrimary;
          if (null !== o ? e = o === r : (e = e.mutableReadLanes, (e = (Ji & e) === e) && (t._workInProgressVersionPrimary = r, Wi.push(t))), e) return n(t._source);
          throw Wi.push(t), Error(a(350));
        }
        function fa(e, t, n, r) {
          var o = Is;
          if (null === o) throw Error(a(349));
          var i = t._getVersion,
            s = i(t._source),
            l = Xi.current,
            u = l.useState(function () {
              return ha(o, t, n);
            }),
            c = u[1],
            d = u[0];
          u = na;
          var p = e.memoizedState,
            h = p.refs,
            f = h.getSnapshot,
            m = p.source;
          p = p.subscribe;
          var g = ea;
          return e.memoizedState = {
            refs: h,
            source: t,
            subscribe: r
          }, l.useEffect(function () {
            h.getSnapshot = n, h.setSnapshot = c;
            var e = i(t._source);
            if (!cr(s, e)) {
              e = n(t._source), cr(d, e) || (c(e), e = hl(g), o.mutableReadLanes |= e & o.pendingLanes), e = o.mutableReadLanes, o.entangledLanes |= e;
              for (var r = o.entanglements, a = e; 0 < a;) {
                var l = 31 - Ht(a),
                  u = 1 << l;
                r[l] |= e, a &= ~u;
              }
            }
          }, [n, t, r]), l.useEffect(function () {
            return r(t._source, function () {
              var e = h.getSnapshot,
                n = h.setSnapshot;
              try {
                n(e(t._source));
                var r = hl(g);
                o.mutableReadLanes |= r & o.pendingLanes;
              } catch (e) {
                n(function () {
                  throw e;
                });
              }
            });
          }, [t, r]), cr(f, n) && cr(m, t) && cr(p, r) || ((e = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: ca,
            lastRenderedState: d
          }).dispatch = c = Ta.bind(null, ea, e), u.queue = e, u.baseQueue = null, d = ha(o, t, n), u.memoizedState = u.baseState = d), d;
        }
        function ma(e, t, n) {
          return fa(ua(), e, t, n);
        }
        function ga(e) {
          var t = la();
          return "function" == typeof e && (e = e()), t.memoizedState = t.baseState = e, e = (e = t.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: ca,
            lastRenderedState: e
          }).dispatch = Ta.bind(null, ea, e), [t.memoizedState, e];
        }
        function va(e, t, n, r) {
          return e = {
            tag: e,
            create: t,
            destroy: n,
            deps: r,
            next: null
          }, null === (t = ea.updateQueue) ? (t = {
            lastEffect: null
          }, ea.updateQueue = t, t.lastEffect = e.next = e) : null === (n = t.lastEffect) ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
        }
        function ya(e) {
          return e = {
            current: e
          }, la().memoizedState = e;
        }
        function ba() {
          return ua().memoizedState;
        }
        function wa(e, t, n, r) {
          var o = la();
          ea.flags |= e, o.memoizedState = va(1 | t, n, void 0, void 0 === r ? null : r);
        }
        function xa(e, t, n, r) {
          var o = ua();
          r = void 0 === r ? null : r;
          var i = void 0;
          if (null !== ta) {
            var a = ta.memoizedState;
            if (i = a.destroy, null !== r && aa(r, a.deps)) return void va(t, n, i, r);
          }
          ea.flags |= e, o.memoizedState = va(1 | t, n, i, r);
        }
        function Da(e, t) {
          return wa(516, 4, e, t);
        }
        function Ca(e, t) {
          return xa(516, 4, e, t);
        }
        function Sa(e, t) {
          return xa(4, 2, e, t);
        }
        function Ea(e, t) {
          return "function" == typeof t ? (e = e(), t(e), function () {
            t(null);
          }) : null != t ? (e = e(), t.current = e, function () {
            t.current = null;
          }) : void 0;
        }
        function _a(e, t, n) {
          return n = null != n ? n.concat([e]) : null, xa(4, 2, Ea.bind(null, t, e), n);
        }
        function Pa() {}
        function ka(e, t) {
          var n = ua();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && aa(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
        }
        function Aa(e, t) {
          var n = ua();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && aa(t, r[1]) ? r[0] : (e = e(), n.memoizedState = [e, t], e);
        }
        function za(e, t) {
          var n = Uo();
          $o(98 > n ? 98 : n, function () {
            e(!0);
          }), $o(97 < n ? 97 : n, function () {
            var n = Qi.transition;
            Qi.transition = 1;
            try {
              e(!1), t();
            } finally {
              Qi.transition = n;
            }
          });
        }
        function Ta(e, t, n) {
          var r = pl(),
            o = hl(e),
            i = {
              lane: o,
              action: n,
              eagerReducer: null,
              eagerState: null,
              next: null
            },
            a = t.pending;
          if (null === a ? i.next = i : (i.next = a.next, a.next = i), t.pending = i, a = e.alternate, e === ea || null !== a && a === ea) oa = ra = !0;else {
            if (0 === e.lanes && (null === a || 0 === a.lanes) && null !== (a = t.lastRenderedReducer)) try {
              var s = t.lastRenderedState,
                l = a(s, n);
              if (i.eagerReducer = a, i.eagerState = l, cr(l, s)) return;
            } catch (e) {}
            fl(e, o, r);
          }
        }
        var Oa = {
            readContext: si,
            useCallback: ia,
            useContext: ia,
            useEffect: ia,
            useImperativeHandle: ia,
            useLayoutEffect: ia,
            useMemo: ia,
            useReducer: ia,
            useRef: ia,
            useState: ia,
            useDebugValue: ia,
            useDeferredValue: ia,
            useTransition: ia,
            useMutableSource: ia,
            useOpaqueIdentifier: ia,
            unstable_isNewReconciler: !1
          },
          Ia = {
            readContext: si,
            useCallback: function (e, t) {
              return la().memoizedState = [e, void 0 === t ? null : t], e;
            },
            useContext: si,
            useEffect: Da,
            useImperativeHandle: function (e, t, n) {
              return n = null != n ? n.concat([e]) : null, wa(4, 2, Ea.bind(null, t, e), n);
            },
            useLayoutEffect: function (e, t) {
              return wa(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = la();
              return t = void 0 === t ? null : t, e = e(), n.memoizedState = [e, t], e;
            },
            useReducer: function (e, t, n) {
              var r = la();
              return t = void 0 !== n ? n(t) : t, r.memoizedState = r.baseState = t, e = (e = r.queue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: e,
                lastRenderedState: t
              }).dispatch = Ta.bind(null, ea, e), [r.memoizedState, e];
            },
            useRef: ya,
            useState: ga,
            useDebugValue: Pa,
            useDeferredValue: function (e) {
              var t = ga(e),
                n = t[0],
                r = t[1];
              return Da(function () {
                var t = Qi.transition;
                Qi.transition = 1;
                try {
                  r(e);
                } finally {
                  Qi.transition = t;
                }
              }, [e]), n;
            },
            useTransition: function () {
              var e = ga(!1),
                t = e[0];
              return ya(e = za.bind(null, e[1])), [e, t];
            },
            useMutableSource: function (e, t, n) {
              var r = la();
              return r.memoizedState = {
                refs: {
                  getSnapshot: t,
                  setSnapshot: null
                },
                source: e,
                subscribe: n
              }, fa(r, e, t, n);
            },
            useOpaqueIdentifier: function () {
              if (Ki) {
                var e = !1,
                  t = function (e) {
                    return {
                      $$typeof: M,
                      toString: e,
                      valueOf: e
                    };
                  }(function () {
                    throw e || (e = !0, n("r:" + (Yr++).toString(36))), Error(a(355));
                  }),
                  n = ga(t)[1];
                return 0 == (2 & ea.mode) && (ea.flags |= 516, va(5, function () {
                  n("r:" + (Yr++).toString(36));
                }, void 0, null)), t;
              }
              return ga(t = "r:" + (Yr++).toString(36)), t;
            },
            unstable_isNewReconciler: !1
          },
          Fa = {
            readContext: si,
            useCallback: ka,
            useContext: si,
            useEffect: Ca,
            useImperativeHandle: _a,
            useLayoutEffect: Sa,
            useMemo: Aa,
            useReducer: da,
            useRef: ba,
            useState: function () {
              return da(ca);
            },
            useDebugValue: Pa,
            useDeferredValue: function (e) {
              var t = da(ca),
                n = t[0],
                r = t[1];
              return Ca(function () {
                var t = Qi.transition;
                Qi.transition = 1;
                try {
                  r(e);
                } finally {
                  Qi.transition = t;
                }
              }, [e]), n;
            },
            useTransition: function () {
              var e = da(ca)[0];
              return [ba().current, e];
            },
            useMutableSource: ma,
            useOpaqueIdentifier: function () {
              return da(ca)[0];
            },
            unstable_isNewReconciler: !1
          },
          Ma = {
            readContext: si,
            useCallback: ka,
            useContext: si,
            useEffect: Ca,
            useImperativeHandle: _a,
            useLayoutEffect: Sa,
            useMemo: Aa,
            useReducer: pa,
            useRef: ba,
            useState: function () {
              return pa(ca);
            },
            useDebugValue: Pa,
            useDeferredValue: function (e) {
              var t = pa(ca),
                n = t[0],
                r = t[1];
              return Ca(function () {
                var t = Qi.transition;
                Qi.transition = 1;
                try {
                  r(e);
                } finally {
                  Qi.transition = t;
                }
              }, [e]), n;
            },
            useTransition: function () {
              var e = pa(ca)[0];
              return [ba().current, e];
            },
            useMutableSource: ma,
            useOpaqueIdentifier: function () {
              return pa(ca)[0];
            },
            unstable_isNewReconciler: !1
          },
          Ra = x.ReactCurrentOwner,
          ja = !1;
        function Ba(e, t, n, r) {
          t.child = null === e ? ki(t, null, n, r) : Pi(t, e.child, n, r);
        }
        function Na(e, t, n, r, o) {
          n = n.render;
          var i = t.ref;
          return ai(t, o), r = sa(e, t, n, r, i, o), null === e || ja ? (t.flags |= 1, Ba(e, t, r, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -517, e.lanes &= ~o, is(e, t, o));
        }
        function La(e, t, n, r, o, i) {
          if (null === e) {
            var a = n.type;
            return "function" != typeof a || Ul(a) || void 0 !== a.defaultProps || null !== n.compare || void 0 !== n.defaultProps ? ((e = $l(n.type, null, r, t, t.mode, i)).ref = t.ref, e.return = t, t.child = e) : (t.tag = 15, t.type = a, Va(e, t, a, r, o, i));
          }
          return a = e.child, 0 == (o & i) && (o = a.memoizedProps, (n = null !== (n = n.compare) ? n : pr)(o, r) && e.ref === t.ref) ? is(e, t, i) : (t.flags |= 1, (e = Zl(a, r)).ref = t.ref, e.return = t, t.child = e);
        }
        function Va(e, t, n, r, o, i) {
          if (null !== e && pr(e.memoizedProps, r) && e.ref === t.ref) {
            if (ja = !1, 0 == (i & o)) return t.lanes = e.lanes, is(e, t, i);
            0 != (16384 & e.flags) && (ja = !0);
          }
          return Ha(e, t, n, r, i);
        }
        function Ka(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            i = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode || "unstable-defer-without-hiding" === r.mode) {
            if (0 == (4 & t.mode)) t.memoizedState = {
              baseLanes: 0
            }, Dl(t, n);else {
              if (0 == (1073741824 & n)) return e = null !== i ? i.baseLanes | n : n, t.lanes = t.childLanes = 1073741824, t.memoizedState = {
                baseLanes: e
              }, Dl(t, e), null;
              t.memoizedState = {
                baseLanes: 0
              }, Dl(t, null !== i ? i.baseLanes : n);
            }
          } else null !== i ? (r = i.baseLanes | n, t.memoizedState = null) : r = n, Dl(t, r);
          return Ba(e, t, o, n), t.child;
        }
        function qa(e, t) {
          var n = t.ref;
          (null === e && null !== n || null !== e && e.ref !== n) && (t.flags |= 128);
        }
        function Ha(e, t, n, r, o) {
          var i = yo(n) ? go : fo.current;
          return i = vo(t, i), ai(t, o), n = sa(e, t, n, r, i, o), null === e || ja ? (t.flags |= 1, Ba(e, t, n, o), t.child) : (t.updateQueue = e.updateQueue, t.flags &= -517, e.lanes &= ~o, is(e, t, o));
        }
        function Ua(e, t, n, r, o) {
          if (yo(n)) {
            var i = !0;
            Do(t);
          } else i = !1;
          if (ai(t, o), null === t.stateNode) null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), wi(t, n, r), Di(t, n, r, o), r = !0;else if (null === e) {
            var a = t.stateNode,
              s = t.memoizedProps;
            a.props = s;
            var l = a.context,
              u = n.contextType;
            "object" == typeof u && null !== u ? u = si(u) : u = vo(t, u = yo(n) ? go : fo.current);
            var c = n.getDerivedStateFromProps,
              d = "function" == typeof c || "function" == typeof a.getSnapshotBeforeUpdate;
            d || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== r || l !== u) && xi(t, a, r, u), li = !1;
            var p = t.memoizedState;
            a.state = p, fi(t, r, a, o), l = t.memoizedState, s !== r || p !== l || mo.current || li ? ("function" == typeof c && (vi(t, n, c, r), l = t.memoizedState), (s = li || bi(t, n, s, r, p, l, u)) ? (d || "function" != typeof a.UNSAFE_componentWillMount && "function" != typeof a.componentWillMount || ("function" == typeof a.componentWillMount && a.componentWillMount(), "function" == typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount()), "function" == typeof a.componentDidMount && (t.flags |= 4)) : ("function" == typeof a.componentDidMount && (t.flags |= 4), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = u, r = s) : ("function" == typeof a.componentDidMount && (t.flags |= 4), r = !1);
          } else {
            a = t.stateNode, ci(e, t), s = t.memoizedProps, u = t.type === t.elementType ? s : Qo(t.type, s), a.props = u, d = t.pendingProps, p = a.context, "object" == typeof (l = n.contextType) && null !== l ? l = si(l) : l = vo(t, l = yo(n) ? go : fo.current);
            var h = n.getDerivedStateFromProps;
            (c = "function" == typeof h || "function" == typeof a.getSnapshotBeforeUpdate) || "function" != typeof a.UNSAFE_componentWillReceiveProps && "function" != typeof a.componentWillReceiveProps || (s !== d || p !== l) && xi(t, a, r, l), li = !1, p = t.memoizedState, a.state = p, fi(t, r, a, o);
            var f = t.memoizedState;
            s !== d || p !== f || mo.current || li ? ("function" == typeof h && (vi(t, n, h, r), f = t.memoizedState), (u = li || bi(t, n, u, r, p, f, l)) ? (c || "function" != typeof a.UNSAFE_componentWillUpdate && "function" != typeof a.componentWillUpdate || ("function" == typeof a.componentWillUpdate && a.componentWillUpdate(r, f, l), "function" == typeof a.UNSAFE_componentWillUpdate && a.UNSAFE_componentWillUpdate(r, f, l)), "function" == typeof a.componentDidUpdate && (t.flags |= 4), "function" == typeof a.getSnapshotBeforeUpdate && (t.flags |= 256)) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 256), t.memoizedProps = r, t.memoizedState = f), a.props = r, a.state = f, a.context = l, r = u) : ("function" != typeof a.componentDidUpdate || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 4), "function" != typeof a.getSnapshotBeforeUpdate || s === e.memoizedProps && p === e.memoizedState || (t.flags |= 256), r = !1);
          }
          return Za(e, t, n, r, i, o);
        }
        function Za(e, t, n, r, o, i) {
          qa(e, t);
          var a = 0 != (64 & t.flags);
          if (!r && !a) return o && Co(t, n, !1), is(e, t, i);
          r = t.stateNode, Ra.current = t;
          var s = a && "function" != typeof n.getDerivedStateFromError ? null : r.render();
          return t.flags |= 1, null !== e && a ? (t.child = Pi(t, e.child, null, i), t.child = Pi(t, null, s, i)) : Ba(e, t, s, i), t.memoizedState = r.state, o && Co(t, n, !0), t.child;
        }
        function $a(e) {
          var t = e.stateNode;
          t.pendingContext ? wo(0, t.pendingContext, t.pendingContext !== t.context) : t.context && wo(0, t.context, !1), Fi(e, t.containerInfo);
        }
        var Ga,
          Wa,
          Ya,
          Xa = {
            dehydrated: null,
            retryLane: 0
          };
        function Qa(e, t, n) {
          var r,
            o = t.pendingProps,
            i = Bi.current,
            a = !1;
          return (r = 0 != (64 & t.flags)) || (r = (null === e || null !== e.memoizedState) && 0 != (2 & i)), r ? (a = !0, t.flags &= -65) : null !== e && null === e.memoizedState || void 0 === o.fallback || !0 === o.unstable_avoidThisFallback || (i |= 1), po(Bi, 1 & i), null === e ? (void 0 !== o.fallback && Ui(t), e = o.children, i = o.fallback, a ? (e = Ja(t, e, i, n), t.child.memoizedState = {
            baseLanes: n
          }, t.memoizedState = Xa, e) : "number" == typeof o.unstable_expectedLoadTime ? (e = Ja(t, e, i, n), t.child.memoizedState = {
            baseLanes: n
          }, t.memoizedState = Xa, t.lanes = 33554432, e) : ((n = Wl({
            mode: "visible",
            children: e
          }, t.mode, n, null)).return = t, t.child = n)) : (e.memoizedState, a ? (o = ts(e, t, o.children, o.fallback, n), a = t.child, i = e.child.memoizedState, a.memoizedState = null === i ? {
            baseLanes: n
          } : {
            baseLanes: i.baseLanes | n
          }, a.childLanes = e.childLanes & ~n, t.memoizedState = Xa, o) : (n = es(e, t, o.children, n), t.memoizedState = null, n));
        }
        function Ja(e, t, n, r) {
          var o = e.mode,
            i = e.child;
          return t = {
            mode: "hidden",
            children: t
          }, 0 == (2 & o) && null !== i ? (i.childLanes = 0, i.pendingProps = t) : i = Wl(t, o, 0, null), n = Gl(n, o, r, null), i.return = e, n.return = e, i.sibling = n, e.child = i, n;
        }
        function es(e, t, n, r) {
          var o = e.child;
          return e = o.sibling, n = Zl(o, {
            mode: "visible",
            children: n
          }), 0 == (2 & t.mode) && (n.lanes = r), n.return = t, n.sibling = null, null !== e && (e.nextEffect = null, e.flags = 8, t.firstEffect = t.lastEffect = e), t.child = n;
        }
        function ts(e, t, n, r, o) {
          var i = t.mode,
            a = e.child;
          e = a.sibling;
          var s = {
            mode: "hidden",
            children: n
          };
          return 0 == (2 & i) && t.child !== a ? ((n = t.child).childLanes = 0, n.pendingProps = s, null !== (a = n.lastEffect) ? (t.firstEffect = n.firstEffect, t.lastEffect = a, a.nextEffect = null) : t.firstEffect = t.lastEffect = null) : n = Zl(a, s), null !== e ? r = Zl(e, r) : (r = Gl(r, i, o, null)).flags |= 2, r.return = t, n.return = t, n.sibling = r, t.child = n, r;
        }
        function ns(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          null !== n && (n.lanes |= t), ii(e.return, t);
        }
        function rs(e, t, n, r, o, i) {
          var a = e.memoizedState;
          null === a ? e.memoizedState = {
            isBackwards: t,
            rendering: null,
            renderingStartTime: 0,
            last: r,
            tail: n,
            tailMode: o,
            lastEffect: i
          } : (a.isBackwards = t, a.rendering = null, a.renderingStartTime = 0, a.last = r, a.tail = n, a.tailMode = o, a.lastEffect = i);
        }
        function os(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            i = r.tail;
          if (Ba(e, t, r.children, n), 0 != (2 & (r = Bi.current))) r = 1 & r | 2, t.flags |= 64;else {
            if (null !== e && 0 != (64 & e.flags)) e: for (e = t.child; null !== e;) {
              if (13 === e.tag) null !== e.memoizedState && ns(e, n);else if (19 === e.tag) ns(e, n);else if (null !== e.child) {
                e.child.return = e, e = e.child;
                continue;
              }
              if (e === t) break e;
              for (; null === e.sibling;) {
                if (null === e.return || e.return === t) break e;
                e = e.return;
              }
              e.sibling.return = e.return, e = e.sibling;
            }
            r &= 1;
          }
          if (po(Bi, r), 0 == (2 & t.mode)) t.memoizedState = null;else switch (o) {
            case "forwards":
              for (n = t.child, o = null; null !== n;) null !== (e = n.alternate) && null === Ni(e) && (o = n), n = n.sibling;
              null === (n = o) ? (o = t.child, t.child = null) : (o = n.sibling, n.sibling = null), rs(t, !1, o, n, i, t.lastEffect);
              break;
            case "backwards":
              for (n = null, o = t.child, t.child = null; null !== o;) {
                if (null !== (e = o.alternate) && null === Ni(e)) {
                  t.child = o;
                  break;
                }
                e = o.sibling, o.sibling = n, n = o, o = e;
              }
              rs(t, !0, n, null, i, t.lastEffect);
              break;
            case "together":
              rs(t, !1, null, null, void 0, t.lastEffect);
              break;
            default:
              t.memoizedState = null;
          }
          return t.child;
        }
        function is(e, t, n) {
          if (null !== e && (t.dependencies = e.dependencies), Vs |= t.lanes, 0 != (n & t.childLanes)) {
            if (null !== e && t.child !== e.child) throw Error(a(153));
            if (null !== t.child) {
              for (n = Zl(e = t.child, e.pendingProps), t.child = n, n.return = t; null !== e.sibling;) e = e.sibling, (n = n.sibling = Zl(e, e.pendingProps)).return = t;
              n.sibling = null;
            }
            return t.child;
          }
          return null;
        }
        function as(e, t) {
          if (!Ki) switch (e.tailMode) {
            case "hidden":
              t = e.tail;
              for (var n = null; null !== t;) null !== t.alternate && (n = t), t = t.sibling;
              null === n ? e.tail = null : n.sibling = null;
              break;
            case "collapsed":
              n = e.tail;
              for (var r = null; null !== n;) null !== n.alternate && (r = n), n = n.sibling;
              null === r ? t || null === e.tail ? e.tail = null : e.tail.sibling = null : r.sibling = null;
          }
        }
        function ss(e, t, n) {
          var r = t.pendingProps;
          switch (t.tag) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return null;
            case 1:
            case 17:
              return yo(t.type) && bo(), null;
            case 3:
              return Mi(), co(mo), co(fo), Yi(), (r = t.stateNode).pendingContext && (r.context = r.pendingContext, r.pendingContext = null), null !== e && null !== e.child || ($i(t) ? t.flags |= 4 : r.hydrate || (t.flags |= 256)), null;
            case 5:
              ji(t);
              var i = Ii(Oi.current);
              if (n = t.type, null !== e && null != t.stateNode) Wa(e, t, n, r), e.ref !== t.ref && (t.flags |= 128);else {
                if (!r) {
                  if (null === t.stateNode) throw Error(a(166));
                  return null;
                }
                if (e = Ii(zi.current), $i(t)) {
                  r = t.stateNode, n = t.type;
                  var s = t.memoizedProps;
                  switch (r[Qr] = t, r[Jr] = s, n) {
                    case "dialog":
                      zr("cancel", r), zr("close", r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      zr("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (e = 0; e < _r.length; e++) zr(_r[e], r);
                      break;
                    case "source":
                      zr("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      zr("error", r), zr("load", r);
                      break;
                    case "details":
                      zr("toggle", r);
                      break;
                    case "input":
                      ee(r, s), zr("invalid", r);
                      break;
                    case "select":
                      r._wrapperState = {
                        wasMultiple: !!s.multiple
                      }, zr("invalid", r);
                      break;
                    case "textarea":
                      le(r, s), zr("invalid", r);
                  }
                  for (var u in Se(n, s), e = null, s) s.hasOwnProperty(u) && (i = s[u], "children" === u ? "string" == typeof i ? r.textContent !== i && (e = ["children", i]) : "number" == typeof i && r.textContent !== "" + i && (e = ["children", "" + i]) : l.hasOwnProperty(u) && null != i && "onScroll" === u && zr("scroll", r));
                  switch (n) {
                    case "input":
                      Y(r), re(r, s, !0);
                      break;
                    case "textarea":
                      Y(r), ce(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof s.onClick && (r.onclick = Lr);
                  }
                  r = e, t.updateQueue = r, null !== r && (t.flags |= 4);
                } else {
                  switch (u = 9 === i.nodeType ? i : i.ownerDocument, e === de && (e = he(n)), e === de ? "script" === n ? ((e = u.createElement("div")).innerHTML = "<script><\/script>", e = e.removeChild(e.firstChild)) : "string" == typeof r.is ? e = u.createElement(n, {
                    is: r.is
                  }) : (e = u.createElement(n), "select" === n && (u = e, r.multiple ? u.multiple = !0 : r.size && (u.size = r.size))) : e = u.createElementNS(e, n), e[Qr] = t, e[Jr] = r, Ga(e, t), t.stateNode = e, u = Ee(n, r), n) {
                    case "dialog":
                      zr("cancel", e), zr("close", e), i = r;
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      zr("load", e), i = r;
                      break;
                    case "video":
                    case "audio":
                      for (i = 0; i < _r.length; i++) zr(_r[i], e);
                      i = r;
                      break;
                    case "source":
                      zr("error", e), i = r;
                      break;
                    case "img":
                    case "image":
                    case "link":
                      zr("error", e), zr("load", e), i = r;
                      break;
                    case "details":
                      zr("toggle", e), i = r;
                      break;
                    case "input":
                      ee(e, r), i = J(e, r), zr("invalid", e);
                      break;
                    case "option":
                      i = ie(e, r);
                      break;
                    case "select":
                      e._wrapperState = {
                        wasMultiple: !!r.multiple
                      }, i = o({}, r, {
                        value: void 0
                      }), zr("invalid", e);
                      break;
                    case "textarea":
                      le(e, r), i = se(e, r), zr("invalid", e);
                      break;
                    default:
                      i = r;
                  }
                  Se(n, i);
                  var c = i;
                  for (s in c) if (c.hasOwnProperty(s)) {
                    var d = c[s];
                    "style" === s ? De(e, d) : "dangerouslySetInnerHTML" === s ? null != (d = d ? d.__html : void 0) && ve(e, d) : "children" === s ? "string" == typeof d ? ("textarea" !== n || "" !== d) && ye(e, d) : "number" == typeof d && ye(e, "" + d) : "suppressContentEditableWarning" !== s && "suppressHydrationWarning" !== s && "autoFocus" !== s && (l.hasOwnProperty(s) ? null != d && "onScroll" === s && zr("scroll", e) : null != d && w(e, s, d, u));
                  }
                  switch (n) {
                    case "input":
                      Y(e), re(e, r, !1);
                      break;
                    case "textarea":
                      Y(e), ce(e);
                      break;
                    case "option":
                      null != r.value && e.setAttribute("value", "" + G(r.value));
                      break;
                    case "select":
                      e.multiple = !!r.multiple, null != (s = r.value) ? ae(e, !!r.multiple, s, !1) : null != r.defaultValue && ae(e, !!r.multiple, r.defaultValue, !0);
                      break;
                    default:
                      "function" == typeof i.onClick && (e.onclick = Lr);
                  }
                  qr(n, r) && (t.flags |= 4);
                }
                null !== t.ref && (t.flags |= 128);
              }
              return null;
            case 6:
              if (e && null != t.stateNode) Ya(0, t, e.memoizedProps, r);else {
                if ("string" != typeof r && null === t.stateNode) throw Error(a(166));
                n = Ii(Oi.current), Ii(zi.current), $i(t) ? (r = t.stateNode, n = t.memoizedProps, r[Qr] = t, r.nodeValue !== n && (t.flags |= 4)) : ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(r))[Qr] = t, t.stateNode = r);
              }
              return null;
            case 13:
              return co(Bi), r = t.memoizedState, 0 != (64 & t.flags) ? (t.lanes = n, t) : (r = null !== r, n = !1, null === e ? void 0 !== t.memoizedProps.fallback && $i(t) : n = null !== e.memoizedState, r && !n && 0 != (2 & t.mode) && (null === e && !0 !== t.memoizedProps.unstable_avoidThisFallback || 0 != (1 & Bi.current) ? 0 === Bs && (Bs = 3) : (0 !== Bs && 3 !== Bs || (Bs = 4), null === Is || 0 == (134217727 & Vs) && 0 == (134217727 & Ks) || yl(Is, Ms))), (r || n) && (t.flags |= 4), null);
            case 4:
              return Mi(), null === e && Or(t.stateNode.containerInfo), null;
            case 10:
              return oi(t), null;
            case 19:
              if (co(Bi), null === (r = t.memoizedState)) return null;
              if (s = 0 != (64 & t.flags), null === (u = r.rendering)) {
                if (s) as(r, !1);else {
                  if (0 !== Bs || null !== e && 0 != (64 & e.flags)) for (e = t.child; null !== e;) {
                    if (null !== (u = Ni(e))) {
                      for (t.flags |= 64, as(r, !1), null !== (s = u.updateQueue) && (t.updateQueue = s, t.flags |= 4), null === r.lastEffect && (t.firstEffect = null), t.lastEffect = r.lastEffect, r = n, n = t.child; null !== n;) e = r, (s = n).flags &= 2, s.nextEffect = null, s.firstEffect = null, s.lastEffect = null, null === (u = s.alternate) ? (s.childLanes = 0, s.lanes = e, s.child = null, s.memoizedProps = null, s.memoizedState = null, s.updateQueue = null, s.dependencies = null, s.stateNode = null) : (s.childLanes = u.childLanes, s.lanes = u.lanes, s.child = u.child, s.memoizedProps = u.memoizedProps, s.memoizedState = u.memoizedState, s.updateQueue = u.updateQueue, s.type = u.type, e = u.dependencies, s.dependencies = null === e ? null : {
                        lanes: e.lanes,
                        firstContext: e.firstContext
                      }), n = n.sibling;
                      return po(Bi, 1 & Bi.current | 2), t.child;
                    }
                    e = e.sibling;
                  }
                  null !== r.tail && Ho() > Zs && (t.flags |= 64, s = !0, as(r, !1), t.lanes = 33554432);
                }
              } else {
                if (!s) if (null !== (e = Ni(u))) {
                  if (t.flags |= 64, s = !0, null !== (n = e.updateQueue) && (t.updateQueue = n, t.flags |= 4), as(r, !0), null === r.tail && "hidden" === r.tailMode && !u.alternate && !Ki) return null !== (t = t.lastEffect = r.lastEffect) && (t.nextEffect = null), null;
                } else 2 * Ho() - r.renderingStartTime > Zs && 1073741824 !== n && (t.flags |= 64, s = !0, as(r, !1), t.lanes = 33554432);
                r.isBackwards ? (u.sibling = t.child, t.child = u) : (null !== (n = r.last) ? n.sibling = u : t.child = u, r.last = u);
              }
              return null !== r.tail ? (n = r.tail, r.rendering = n, r.tail = n.sibling, r.lastEffect = t.lastEffect, r.renderingStartTime = Ho(), n.sibling = null, t = Bi.current, po(Bi, s ? 1 & t | 2 : 1 & t), n) : null;
            case 23:
            case 24:
              return Cl(), null !== e && null !== e.memoizedState != (null !== t.memoizedState) && "unstable-defer-without-hiding" !== r.mode && (t.flags |= 4), null;
          }
          throw Error(a(156, t.tag));
        }
        function ls(e) {
          switch (e.tag) {
            case 1:
              yo(e.type) && bo();
              var t = e.flags;
              return 4096 & t ? (e.flags = -4097 & t | 64, e) : null;
            case 3:
              if (Mi(), co(mo), co(fo), Yi(), 0 != (64 & (t = e.flags))) throw Error(a(285));
              return e.flags = -4097 & t | 64, e;
            case 5:
              return ji(e), null;
            case 13:
              return co(Bi), 4096 & (t = e.flags) ? (e.flags = -4097 & t | 64, e) : null;
            case 19:
              return co(Bi), null;
            case 4:
              return Mi(), null;
            case 10:
              return oi(e), null;
            case 23:
            case 24:
              return Cl(), null;
            default:
              return null;
          }
        }
        function us(e, t) {
          try {
            var n = "",
              r = t;
            do {
              n += Z(r), r = r.return;
            } while (r);
            var o = n;
          } catch (e) {
            o = "\nError generating stack: " + e.message + "\n" + e.stack;
          }
          return {
            value: e,
            source: t,
            stack: o
          };
        }
        function cs(e, t) {
          try {
            console.error(t.value);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        Ga = function (e, t) {
          for (var n = t.child; null !== n;) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);else if (4 !== n.tag && null !== n.child) {
              n.child.return = n, n = n.child;
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling;) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            n.sibling.return = n.return, n = n.sibling;
          }
        }, Wa = function (e, t, n, r) {
          var i = e.memoizedProps;
          if (i !== r) {
            e = t.stateNode, Ii(zi.current);
            var a,
              s = null;
            switch (n) {
              case "input":
                i = J(e, i), r = J(e, r), s = [];
                break;
              case "option":
                i = ie(e, i), r = ie(e, r), s = [];
                break;
              case "select":
                i = o({}, i, {
                  value: void 0
                }), r = o({}, r, {
                  value: void 0
                }), s = [];
                break;
              case "textarea":
                i = se(e, i), r = se(e, r), s = [];
                break;
              default:
                "function" != typeof i.onClick && "function" == typeof r.onClick && (e.onclick = Lr);
            }
            for (d in Se(n, r), n = null, i) if (!r.hasOwnProperty(d) && i.hasOwnProperty(d) && null != i[d]) if ("style" === d) {
              var u = i[d];
              for (a in u) u.hasOwnProperty(a) && (n || (n = {}), n[a] = "");
            } else "dangerouslySetInnerHTML" !== d && "children" !== d && "suppressContentEditableWarning" !== d && "suppressHydrationWarning" !== d && "autoFocus" !== d && (l.hasOwnProperty(d) ? s || (s = []) : (s = s || []).push(d, null));
            for (d in r) {
              var c = r[d];
              if (u = null != i ? i[d] : void 0, r.hasOwnProperty(d) && c !== u && (null != c || null != u)) if ("style" === d) {
                if (u) {
                  for (a in u) !u.hasOwnProperty(a) || c && c.hasOwnProperty(a) || (n || (n = {}), n[a] = "");
                  for (a in c) c.hasOwnProperty(a) && u[a] !== c[a] && (n || (n = {}), n[a] = c[a]);
                } else n || (s || (s = []), s.push(d, n)), n = c;
              } else "dangerouslySetInnerHTML" === d ? (c = c ? c.__html : void 0, u = u ? u.__html : void 0, null != c && u !== c && (s = s || []).push(d, c)) : "children" === d ? "string" != typeof c && "number" != typeof c || (s = s || []).push(d, "" + c) : "suppressContentEditableWarning" !== d && "suppressHydrationWarning" !== d && (l.hasOwnProperty(d) ? (null != c && "onScroll" === d && zr("scroll", e), s || u === c || (s = [])) : "object" == typeof c && null !== c && c.$$typeof === M ? c.toString() : (s = s || []).push(d, c));
            }
            n && (s = s || []).push("style", n);
            var d = s;
            (t.updateQueue = d) && (t.flags |= 4);
          }
        }, Ya = function (e, t, n, r) {
          n !== r && (t.flags |= 4);
        };
        var ds = "function" == typeof WeakMap ? WeakMap : Map;
        function ps(e, t, n) {
          (n = di(-1, n)).tag = 3, n.payload = {
            element: null
          };
          var r = t.value;
          return n.callback = function () {
            Ys || (Ys = !0, Xs = r), cs(0, t);
          }, n;
        }
        function hs(e, t, n) {
          (n = di(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" == typeof r) {
            var o = t.value;
            n.payload = function () {
              return cs(0, t), r(o);
            };
          }
          var i = e.stateNode;
          return null !== i && "function" == typeof i.componentDidCatch && (n.callback = function () {
            "function" != typeof r && (null === Qs ? Qs = new Set([this]) : Qs.add(this), cs(0, t));
            var e = t.stack;
            this.componentDidCatch(t.value, {
              componentStack: null !== e ? e : ""
            });
          }), n;
        }
        var fs = "function" == typeof WeakSet ? WeakSet : Set;
        function ms(e) {
          var t = e.ref;
          if (null !== t) if ("function" == typeof t) try {
            t(null);
          } catch (t) {
            Ll(e, t);
          } else t.current = null;
        }
        function gs(e, t) {
          switch (t.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
            case 5:
            case 6:
            case 4:
            case 17:
              return;
            case 1:
              if (256 & t.flags && null !== e) {
                var n = e.memoizedProps,
                  r = e.memoizedState;
                t = (e = t.stateNode).getSnapshotBeforeUpdate(t.elementType === t.type ? n : Qo(t.type, n), r), e.__reactInternalSnapshotBeforeUpdate = t;
              }
              return;
            case 3:
              return void (256 & t.flags && $r(t.stateNode.containerInfo));
          }
          throw Error(a(163));
        }
        function vs(e, t, n) {
          switch (n.tag) {
            case 0:
            case 11:
            case 15:
            case 22:
              if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                e = t = t.next;
                do {
                  if (3 == (3 & e.tag)) {
                    var r = e.create;
                    e.destroy = r();
                  }
                  e = e.next;
                } while (e !== t);
              }
              if (null !== (t = null !== (t = n.updateQueue) ? t.lastEffect : null)) {
                e = t = t.next;
                do {
                  var o = e;
                  r = o.next, 0 != (4 & (o = o.tag)) && 0 != (1 & o) && (jl(n, e), Rl(n, e)), e = r;
                } while (e !== t);
              }
              return;
            case 1:
              return e = n.stateNode, 4 & n.flags && (null === t ? e.componentDidMount() : (r = n.elementType === n.type ? t.memoizedProps : Qo(n.type, t.memoizedProps), e.componentDidUpdate(r, t.memoizedState, e.__reactInternalSnapshotBeforeUpdate))), void (null !== (t = n.updateQueue) && mi(n, t, e));
            case 3:
              if (null !== (t = n.updateQueue)) {
                if (e = null, null !== n.child) switch (n.child.tag) {
                  case 5:
                  case 1:
                    e = n.child.stateNode;
                }
                mi(n, t, e);
              }
              return;
            case 5:
              return e = n.stateNode, void (null === t && 4 & n.flags && qr(n.type, n.memoizedProps) && e.focus());
            case 6:
            case 4:
            case 12:
            case 19:
            case 17:
            case 20:
            case 21:
            case 23:
            case 24:
              return;
            case 13:
              return void (null === n.memoizedState && (n = n.alternate, null !== n && (n = n.memoizedState, null !== n && (n = n.dehydrated, null !== n && Dt(n)))));
          }
          throw Error(a(163));
        }
        function ys(e, t) {
          for (var n = e;;) {
            if (5 === n.tag) {
              var r = n.stateNode;
              if (t) "function" == typeof (r = r.style).setProperty ? r.setProperty("display", "none", "important") : r.display = "none";else {
                r = n.stateNode;
                var o = n.memoizedProps.style;
                o = null != o && o.hasOwnProperty("display") ? o.display : null, r.style.display = xe("display", o);
              }
            } else if (6 === n.tag) n.stateNode.nodeValue = t ? "" : n.memoizedProps;else if ((23 !== n.tag && 24 !== n.tag || null === n.memoizedState || n === e) && null !== n.child) {
              n.child.return = n, n = n.child;
              continue;
            }
            if (n === e) break;
            for (; null === n.sibling;) {
              if (null === n.return || n.return === e) return;
              n = n.return;
            }
            n.sibling.return = n.return, n = n.sibling;
          }
        }
        function bs(e, t) {
          if (Eo && "function" == typeof Eo.onCommitFiberUnmount) try {
            Eo.onCommitFiberUnmount(So, t);
          } catch (e) {}
          switch (t.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
              if (null !== (e = t.updateQueue) && null !== (e = e.lastEffect)) {
                var n = e = e.next;
                do {
                  var r = n,
                    o = r.destroy;
                  if (r = r.tag, void 0 !== o) if (0 != (4 & r)) jl(t, n);else {
                    r = t;
                    try {
                      o();
                    } catch (e) {
                      Ll(r, e);
                    }
                  }
                  n = n.next;
                } while (n !== e);
              }
              break;
            case 1:
              if (ms(t), "function" == typeof (e = t.stateNode).componentWillUnmount) try {
                e.props = t.memoizedProps, e.state = t.memoizedState, e.componentWillUnmount();
              } catch (e) {
                Ll(t, e);
              }
              break;
            case 5:
              ms(t);
              break;
            case 4:
              Es(e, t);
          }
        }
        function ws(e) {
          e.alternate = null, e.child = null, e.dependencies = null, e.firstEffect = null, e.lastEffect = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.return = null, e.updateQueue = null;
        }
        function xs(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function Ds(e) {
          e: {
            for (var t = e.return; null !== t;) {
              if (xs(t)) break e;
              t = t.return;
            }
            throw Error(a(160));
          }
          var n = t;
          switch (t = n.stateNode, n.tag) {
            case 5:
              var r = !1;
              break;
            case 3:
            case 4:
              t = t.containerInfo, r = !0;
              break;
            default:
              throw Error(a(161));
          }
          16 & n.flags && (ye(t, ""), n.flags &= -17);
          e: t: for (n = e;;) {
            for (; null === n.sibling;) {
              if (null === n.return || xs(n.return)) {
                n = null;
                break e;
              }
              n = n.return;
            }
            for (n.sibling.return = n.return, n = n.sibling; 5 !== n.tag && 6 !== n.tag && 18 !== n.tag;) {
              if (2 & n.flags) continue t;
              if (null === n.child || 4 === n.tag) continue t;
              n.child.return = n, n = n.child;
            }
            if (!(2 & n.flags)) {
              n = n.stateNode;
              break e;
            }
          }
          r ? Cs(e, n, t) : Ss(e, n, t);
        }
        function Cs(e, t, n) {
          var r = e.tag,
            o = 5 === r || 6 === r;
          if (o) e = o ? e.stateNode : e.stateNode.instance, t ? 8 === n.nodeType ? n.parentNode.insertBefore(e, t) : n.insertBefore(e, t) : (8 === n.nodeType ? (t = n.parentNode).insertBefore(e, n) : (t = n).appendChild(e), null != (n = n._reactRootContainer) || null !== t.onclick || (t.onclick = Lr));else if (4 !== r && null !== (e = e.child)) for (Cs(e, t, n), e = e.sibling; null !== e;) Cs(e, t, n), e = e.sibling;
        }
        function Ss(e, t, n) {
          var r = e.tag,
            o = 5 === r || 6 === r;
          if (o) e = o ? e.stateNode : e.stateNode.instance, t ? n.insertBefore(e, t) : n.appendChild(e);else if (4 !== r && null !== (e = e.child)) for (Ss(e, t, n), e = e.sibling; null !== e;) Ss(e, t, n), e = e.sibling;
        }
        function Es(e, t) {
          for (var n, r, o = t, i = !1;;) {
            if (!i) {
              i = o.return;
              e: for (;;) {
                if (null === i) throw Error(a(160));
                switch (n = i.stateNode, i.tag) {
                  case 5:
                    r = !1;
                    break e;
                  case 3:
                  case 4:
                    n = n.containerInfo, r = !0;
                    break e;
                }
                i = i.return;
              }
              i = !0;
            }
            if (5 === o.tag || 6 === o.tag) {
              e: for (var s = e, l = o, u = l;;) if (bs(s, u), null !== u.child && 4 !== u.tag) u.child.return = u, u = u.child;else {
                if (u === l) break e;
                for (; null === u.sibling;) {
                  if (null === u.return || u.return === l) break e;
                  u = u.return;
                }
                u.sibling.return = u.return, u = u.sibling;
              }
              r ? (s = n, l = o.stateNode, 8 === s.nodeType ? s.parentNode.removeChild(l) : s.removeChild(l)) : n.removeChild(o.stateNode);
            } else if (4 === o.tag) {
              if (null !== o.child) {
                n = o.stateNode.containerInfo, r = !0, o.child.return = o, o = o.child;
                continue;
              }
            } else if (bs(e, o), null !== o.child) {
              o.child.return = o, o = o.child;
              continue;
            }
            if (o === t) break;
            for (; null === o.sibling;) {
              if (null === o.return || o.return === t) return;
              4 === (o = o.return).tag && (i = !1);
            }
            o.sibling.return = o.return, o = o.sibling;
          }
        }
        function _s(e, t) {
          switch (t.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
            case 22:
              var n = t.updateQueue;
              if (null !== (n = null !== n ? n.lastEffect : null)) {
                var r = n = n.next;
                do {
                  3 == (3 & r.tag) && (e = r.destroy, r.destroy = void 0, void 0 !== e && e()), r = r.next;
                } while (r !== n);
              }
              return;
            case 1:
            case 12:
            case 17:
              return;
            case 5:
              if (null != (n = t.stateNode)) {
                r = t.memoizedProps;
                var o = null !== e ? e.memoizedProps : r;
                e = t.type;
                var i = t.updateQueue;
                if (t.updateQueue = null, null !== i) {
                  for (n[Jr] = r, "input" === e && "radio" === r.type && null != r.name && te(n, r), Ee(e, o), t = Ee(e, r), o = 0; o < i.length; o += 2) {
                    var s = i[o],
                      l = i[o + 1];
                    "style" === s ? De(n, l) : "dangerouslySetInnerHTML" === s ? ve(n, l) : "children" === s ? ye(n, l) : w(n, s, l, t);
                  }
                  switch (e) {
                    case "input":
                      ne(n, r);
                      break;
                    case "textarea":
                      ue(n, r);
                      break;
                    case "select":
                      e = n._wrapperState.wasMultiple, n._wrapperState.wasMultiple = !!r.multiple, null != (i = r.value) ? ae(n, !!r.multiple, i, !1) : e !== !!r.multiple && (null != r.defaultValue ? ae(n, !!r.multiple, r.defaultValue, !0) : ae(n, !!r.multiple, r.multiple ? [] : "", !1));
                  }
                }
              }
              return;
            case 6:
              if (null === t.stateNode) throw Error(a(162));
              return void (t.stateNode.nodeValue = t.memoizedProps);
            case 3:
              return void ((n = t.stateNode).hydrate && (n.hydrate = !1, Dt(n.containerInfo)));
            case 13:
              return null !== t.memoizedState && (Us = Ho(), ys(t.child, !0)), void Ps(t);
            case 19:
              return void Ps(t);
            case 23:
            case 24:
              return void ys(t, null !== t.memoizedState);
          }
          throw Error(a(163));
        }
        function Ps(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            null === n && (n = e.stateNode = new fs()), t.forEach(function (t) {
              var r = Kl.bind(null, e, t);
              n.has(t) || (n.add(t), t.then(r, r));
            });
          }
        }
        function ks(e, t) {
          return null !== e && (null === (e = e.memoizedState) || null !== e.dehydrated) && null !== (t = t.memoizedState) && null === t.dehydrated;
        }
        var As = Math.ceil,
          zs = x.ReactCurrentDispatcher,
          Ts = x.ReactCurrentOwner,
          Os = 0,
          Is = null,
          Fs = null,
          Ms = 0,
          Rs = 0,
          js = uo(0),
          Bs = 0,
          Ns = null,
          Ls = 0,
          Vs = 0,
          Ks = 0,
          qs = 0,
          Hs = null,
          Us = 0,
          Zs = 1 / 0;
        function $s() {
          Zs = Ho() + 500;
        }
        var Gs,
          Ws = null,
          Ys = !1,
          Xs = null,
          Qs = null,
          Js = !1,
          el = null,
          tl = 90,
          nl = [],
          rl = [],
          ol = null,
          il = 0,
          al = null,
          sl = -1,
          ll = 0,
          ul = 0,
          cl = null,
          dl = !1;
        function pl() {
          return 0 != (48 & Os) ? Ho() : -1 !== sl ? sl : sl = Ho();
        }
        function hl(e) {
          if (0 == (2 & (e = e.mode))) return 1;
          if (0 == (4 & e)) return 99 === Uo() ? 1 : 2;
          if (0 === ll && (ll = Ls), 0 !== Xo.transition) {
            0 !== ul && (ul = null !== Hs ? Hs.pendingLanes : 0), e = ll;
            var t = 4186112 & ~ul;
            return 0 === (t &= -t) && 0 === (t = (e = 4186112 & ~e) & -e) && (t = 8192), t;
          }
          return e = Uo(), 0 != (4 & Os) && 98 === e ? e = Lt(12, ll) : e = Lt(e = function (e) {
            switch (e) {
              case 99:
                return 15;
              case 98:
                return 10;
              case 97:
              case 96:
                return 8;
              case 95:
                return 2;
              default:
                return 0;
            }
          }(e), ll), e;
        }
        function fl(e, t, n) {
          if (50 < il) throw il = 0, al = null, Error(a(185));
          if (null === (e = ml(e, t))) return null;
          qt(e, t, n), e === Is && (Ks |= t, 4 === Bs && yl(e, Ms));
          var r = Uo();
          1 === t ? 0 != (8 & Os) && 0 == (48 & Os) ? bl(e) : (gl(e, n), 0 === Os && ($s(), Wo())) : (0 == (4 & Os) || 98 !== r && 99 !== r || (null === ol ? ol = new Set([e]) : ol.add(e)), gl(e, n)), Hs = e;
        }
        function ml(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e;) e.childLanes |= t, null !== (n = e.alternate) && (n.childLanes |= t), n = e, e = e.return;
          return 3 === n.tag ? n.stateNode : null;
        }
        function gl(e, t) {
          for (var n = e.callbackNode, r = e.suspendedLanes, o = e.pingedLanes, i = e.expirationTimes, s = e.pendingLanes; 0 < s;) {
            var l = 31 - Ht(s),
              u = 1 << l,
              c = i[l];
            if (-1 === c) {
              if (0 == (u & r) || 0 != (u & o)) {
                c = t, jt(u);
                var d = Rt;
                i[l] = 10 <= d ? c + 250 : 6 <= d ? c + 5e3 : -1;
              }
            } else c <= t && (e.expiredLanes |= u);
            s &= ~u;
          }
          if (r = Bt(e, e === Is ? Ms : 0), t = Rt, 0 === r) null !== n && (n !== Bo && ko(n), e.callbackNode = null, e.callbackPriority = 0);else {
            if (null !== n) {
              if (e.callbackPriority === t) return;
              n !== Bo && ko(n);
            }
            15 === t ? (n = bl.bind(null, e), null === Lo ? (Lo = [n], Vo = Po(Io, Yo)) : Lo.push(n), n = Bo) : 14 === t ? n = Go(99, bl.bind(null, e)) : (n = function (e) {
              switch (e) {
                case 15:
                case 14:
                  return 99;
                case 13:
                case 12:
                case 11:
                case 10:
                  return 98;
                case 9:
                case 8:
                case 7:
                case 6:
                case 4:
                case 5:
                  return 97;
                case 3:
                case 2:
                case 1:
                  return 95;
                case 0:
                  return 90;
                default:
                  throw Error(a(358, e));
              }
            }(t), n = Go(n, vl.bind(null, e))), e.callbackPriority = t, e.callbackNode = n;
          }
        }
        function vl(e) {
          if (sl = -1, ul = ll = 0, 0 != (48 & Os)) throw Error(a(327));
          var t = e.callbackNode;
          if (Ml() && e.callbackNode !== t) return null;
          var n = Bt(e, e === Is ? Ms : 0);
          if (0 === n) return null;
          var r = n,
            o = Os;
          Os |= 16;
          var i = _l();
          for (Is === e && Ms === r || ($s(), Sl(e, r));;) try {
            Al();
            break;
          } catch (t) {
            El(e, t);
          }
          if (ri(), zs.current = i, Os = o, null !== Fs ? r = 0 : (Is = null, Ms = 0, r = Bs), 0 != (Ls & Ks)) Sl(e, 0);else if (0 !== r) {
            if (2 === r && (Os |= 64, e.hydrate && (e.hydrate = !1, $r(e.containerInfo)), 0 !== (n = Nt(e)) && (r = Pl(e, n))), 1 === r) throw t = Ns, Sl(e, 0), yl(e, n), gl(e, Ho()), t;
            switch (e.finishedWork = e.current.alternate, e.finishedLanes = n, r) {
              case 0:
              case 1:
                throw Error(a(345));
              case 2:
              case 5:
                Ol(e);
                break;
              case 3:
                if (yl(e, n), (62914560 & n) === n && 10 < (r = Us + 500 - Ho())) {
                  if (0 !== Bt(e, 0)) break;
                  if (((o = e.suspendedLanes) & n) !== n) {
                    pl(), e.pingedLanes |= e.suspendedLanes & o;
                    break;
                  }
                  e.timeoutHandle = Ur(Ol.bind(null, e), r);
                  break;
                }
                Ol(e);
                break;
              case 4:
                if (yl(e, n), (4186112 & n) === n) break;
                for (r = e.eventTimes, o = -1; 0 < n;) {
                  var s = 31 - Ht(n);
                  i = 1 << s, (s = r[s]) > o && (o = s), n &= ~i;
                }
                if (n = o, 10 < (n = (120 > (n = Ho() - n) ? 120 : 480 > n ? 480 : 1080 > n ? 1080 : 1920 > n ? 1920 : 3e3 > n ? 3e3 : 4320 > n ? 4320 : 1960 * As(n / 1960)) - n)) {
                  e.timeoutHandle = Ur(Ol.bind(null, e), n);
                  break;
                }
                Ol(e);
                break;
              default:
                throw Error(a(329));
            }
          }
          return gl(e, Ho()), e.callbackNode === t ? vl.bind(null, e) : null;
        }
        function yl(e, t) {
          for (t &= ~qs, t &= ~Ks, e.suspendedLanes |= t, e.pingedLanes &= ~t, e = e.expirationTimes; 0 < t;) {
            var n = 31 - Ht(t),
              r = 1 << n;
            e[n] = -1, t &= ~r;
          }
        }
        function bl(e) {
          if (0 != (48 & Os)) throw Error(a(327));
          if (Ml(), e === Is && 0 != (e.expiredLanes & Ms)) {
            var t = Ms,
              n = Pl(e, t);
            0 != (Ls & Ks) && (n = Pl(e, t = Bt(e, t)));
          } else n = Pl(e, t = Bt(e, 0));
          if (0 !== e.tag && 2 === n && (Os |= 64, e.hydrate && (e.hydrate = !1, $r(e.containerInfo)), 0 !== (t = Nt(e)) && (n = Pl(e, t))), 1 === n) throw n = Ns, Sl(e, 0), yl(e, t), gl(e, Ho()), n;
          return e.finishedWork = e.current.alternate, e.finishedLanes = t, Ol(e), gl(e, Ho()), null;
        }
        function wl(e, t) {
          var n = Os;
          Os |= 1;
          try {
            return e(t);
          } finally {
            0 === (Os = n) && ($s(), Wo());
          }
        }
        function xl(e, t) {
          var n = Os;
          Os &= -2, Os |= 8;
          try {
            return e(t);
          } finally {
            0 === (Os = n) && ($s(), Wo());
          }
        }
        function Dl(e, t) {
          po(js, Rs), Rs |= t, Ls |= t;
        }
        function Cl() {
          Rs = js.current, co(js);
        }
        function Sl(e, t) {
          e.finishedWork = null, e.finishedLanes = 0;
          var n = e.timeoutHandle;
          if (-1 !== n && (e.timeoutHandle = -1, Zr(n)), null !== Fs) for (n = Fs.return; null !== n;) {
            var r = n;
            switch (r.tag) {
              case 1:
                null != (r = r.type.childContextTypes) && bo();
                break;
              case 3:
                Mi(), co(mo), co(fo), Yi();
                break;
              case 5:
                ji(r);
                break;
              case 4:
                Mi();
                break;
              case 13:
              case 19:
                co(Bi);
                break;
              case 10:
                oi(r);
                break;
              case 23:
              case 24:
                Cl();
            }
            n = n.return;
          }
          Is = e, Fs = Zl(e.current, null), Ms = Rs = Ls = t, Bs = 0, Ns = null, qs = Ks = Vs = 0;
        }
        function El(e, t) {
          for (;;) {
            var n = Fs;
            try {
              if (ri(), Xi.current = Oa, ra) {
                for (var r = ea.memoizedState; null !== r;) {
                  var o = r.queue;
                  null !== o && (o.pending = null), r = r.next;
                }
                ra = !1;
              }
              if (Ji = 0, na = ta = ea = null, oa = !1, Ts.current = null, null === n || null === n.return) {
                Bs = 1, Ns = t, Fs = null;
                break;
              }
              e: {
                var i = e,
                  a = n.return,
                  s = n,
                  l = t;
                if (t = Ms, s.flags |= 2048, s.firstEffect = s.lastEffect = null, null !== l && "object" == typeof l && "function" == typeof l.then) {
                  var u = l;
                  if (0 == (2 & s.mode)) {
                    var c = s.alternate;
                    c ? (s.updateQueue = c.updateQueue, s.memoizedState = c.memoizedState, s.lanes = c.lanes) : (s.updateQueue = null, s.memoizedState = null);
                  }
                  var d = 0 != (1 & Bi.current),
                    p = a;
                  do {
                    var h;
                    if (h = 13 === p.tag) {
                      var f = p.memoizedState;
                      if (null !== f) h = null !== f.dehydrated;else {
                        var m = p.memoizedProps;
                        h = void 0 !== m.fallback && (!0 !== m.unstable_avoidThisFallback || !d);
                      }
                    }
                    if (h) {
                      var g = p.updateQueue;
                      if (null === g) {
                        var v = new Set();
                        v.add(u), p.updateQueue = v;
                      } else g.add(u);
                      if (0 == (2 & p.mode)) {
                        if (p.flags |= 64, s.flags |= 16384, s.flags &= -2981, 1 === s.tag) if (null === s.alternate) s.tag = 17;else {
                          var y = di(-1, 1);
                          y.tag = 2, pi(s, y);
                        }
                        s.lanes |= 1;
                        break e;
                      }
                      l = void 0, s = t;
                      var b = i.pingCache;
                      if (null === b ? (b = i.pingCache = new ds(), l = new Set(), b.set(u, l)) : void 0 === (l = b.get(u)) && (l = new Set(), b.set(u, l)), !l.has(s)) {
                        l.add(s);
                        var w = Vl.bind(null, i, u, s);
                        u.then(w, w);
                      }
                      p.flags |= 4096, p.lanes = t;
                      break e;
                    }
                    p = p.return;
                  } while (null !== p);
                  l = Error(($(s.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== Bs && (Bs = 2), l = us(l, s), p = a;
                do {
                  switch (p.tag) {
                    case 3:
                      i = l, p.flags |= 4096, t &= -t, p.lanes |= t, hi(p, ps(0, i, t));
                      break e;
                    case 1:
                      i = l;
                      var x = p.type,
                        D = p.stateNode;
                      if (0 == (64 & p.flags) && ("function" == typeof x.getDerivedStateFromError || null !== D && "function" == typeof D.componentDidCatch && (null === Qs || !Qs.has(D)))) {
                        p.flags |= 4096, t &= -t, p.lanes |= t, hi(p, hs(p, i, t));
                        break e;
                      }
                  }
                  p = p.return;
                } while (null !== p);
              }
              Tl(n);
            } catch (e) {
              t = e, Fs === n && null !== n && (Fs = n = n.return);
              continue;
            }
            break;
          }
        }
        function _l() {
          var e = zs.current;
          return zs.current = Oa, null === e ? Oa : e;
        }
        function Pl(e, t) {
          var n = Os;
          Os |= 16;
          var r = _l();
          for (Is === e && Ms === t || Sl(e, t);;) try {
            kl();
            break;
          } catch (t) {
            El(e, t);
          }
          if (ri(), Os = n, zs.current = r, null !== Fs) throw Error(a(261));
          return Is = null, Ms = 0, Bs;
        }
        function kl() {
          for (; null !== Fs;) zl(Fs);
        }
        function Al() {
          for (; null !== Fs && !Ao();) zl(Fs);
        }
        function zl(e) {
          var t = Gs(e.alternate, e, Rs);
          e.memoizedProps = e.pendingProps, null === t ? Tl(e) : Fs = t, Ts.current = null;
        }
        function Tl(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (e = t.return, 0 == (2048 & t.flags)) {
              if (null !== (n = ss(n, t, Rs))) return void (Fs = n);
              if (24 !== (n = t).tag && 23 !== n.tag || null === n.memoizedState || 0 != (1073741824 & Rs) || 0 == (4 & n.mode)) {
                for (var r = 0, o = n.child; null !== o;) r |= o.lanes | o.childLanes, o = o.sibling;
                n.childLanes = r;
              }
              null !== e && 0 == (2048 & e.flags) && (null === e.firstEffect && (e.firstEffect = t.firstEffect), null !== t.lastEffect && (null !== e.lastEffect && (e.lastEffect.nextEffect = t.firstEffect), e.lastEffect = t.lastEffect), 1 < t.flags && (null !== e.lastEffect ? e.lastEffect.nextEffect = t : e.firstEffect = t, e.lastEffect = t));
            } else {
              if (null !== (n = ls(t))) return n.flags &= 2047, void (Fs = n);
              null !== e && (e.firstEffect = e.lastEffect = null, e.flags |= 2048);
            }
            if (null !== (t = t.sibling)) return void (Fs = t);
            Fs = t = e;
          } while (null !== t);
          0 === Bs && (Bs = 5);
        }
        function Ol(e) {
          var t = Uo();
          return $o(99, Il.bind(null, e, t)), null;
        }
        function Il(e, t) {
          do {
            Ml();
          } while (null !== el);
          if (0 != (48 & Os)) throw Error(a(327));
          var n = e.finishedWork;
          if (null === n) return null;
          if (e.finishedWork = null, e.finishedLanes = 0, n === e.current) throw Error(a(177));
          e.callbackNode = null;
          var r = n.lanes | n.childLanes,
            o = r,
            i = e.pendingLanes & ~o;
          e.pendingLanes = o, e.suspendedLanes = 0, e.pingedLanes = 0, e.expiredLanes &= o, e.mutableReadLanes &= o, e.entangledLanes &= o, o = e.entanglements;
          for (var s = e.eventTimes, l = e.expirationTimes; 0 < i;) {
            var u = 31 - Ht(i),
              c = 1 << u;
            o[u] = 0, s[u] = -1, l[u] = -1, i &= ~c;
          }
          if (null !== ol && 0 == (24 & r) && ol.has(e) && ol.delete(e), e === Is && (Fs = Is = null, Ms = 0), 1 < n.flags ? null !== n.lastEffect ? (n.lastEffect.nextEffect = n, r = n.firstEffect) : r = n : r = n.firstEffect, null !== r) {
            if (o = Os, Os |= 32, Ts.current = null, Vr = Wt, vr(s = gr())) {
              if ("selectionStart" in s) l = {
                start: s.selectionStart,
                end: s.selectionEnd
              };else e: if (l = (l = s.ownerDocument) && l.defaultView || window, (c = l.getSelection && l.getSelection()) && 0 !== c.rangeCount) {
                l = c.anchorNode, i = c.anchorOffset, u = c.focusNode, c = c.focusOffset;
                try {
                  l.nodeType, u.nodeType;
                } catch (e) {
                  l = null;
                  break e;
                }
                var d = 0,
                  p = -1,
                  h = -1,
                  f = 0,
                  m = 0,
                  g = s,
                  v = null;
                t: for (;;) {
                  for (var y; g !== l || 0 !== i && 3 !== g.nodeType || (p = d + i), g !== u || 0 !== c && 3 !== g.nodeType || (h = d + c), 3 === g.nodeType && (d += g.nodeValue.length), null !== (y = g.firstChild);) v = g, g = y;
                  for (;;) {
                    if (g === s) break t;
                    if (v === l && ++f === i && (p = d), v === u && ++m === c && (h = d), null !== (y = g.nextSibling)) break;
                    v = (g = v).parentNode;
                  }
                  g = y;
                }
                l = -1 === p || -1 === h ? null : {
                  start: p,
                  end: h
                };
              } else l = null;
              l = l || {
                start: 0,
                end: 0
              };
            } else l = null;
            Kr = {
              focusedElem: s,
              selectionRange: l
            }, Wt = !1, cl = null, dl = !1, Ws = r;
            do {
              try {
                Fl();
              } catch (e) {
                if (null === Ws) throw Error(a(330));
                Ll(Ws, e), Ws = Ws.nextEffect;
              }
            } while (null !== Ws);
            cl = null, Ws = r;
            do {
              try {
                for (s = e; null !== Ws;) {
                  var b = Ws.flags;
                  if (16 & b && ye(Ws.stateNode, ""), 128 & b) {
                    var w = Ws.alternate;
                    if (null !== w) {
                      var x = w.ref;
                      null !== x && ("function" == typeof x ? x(null) : x.current = null);
                    }
                  }
                  switch (1038 & b) {
                    case 2:
                      Ds(Ws), Ws.flags &= -3;
                      break;
                    case 6:
                      Ds(Ws), Ws.flags &= -3, _s(Ws.alternate, Ws);
                      break;
                    case 1024:
                      Ws.flags &= -1025;
                      break;
                    case 1028:
                      Ws.flags &= -1025, _s(Ws.alternate, Ws);
                      break;
                    case 4:
                      _s(Ws.alternate, Ws);
                      break;
                    case 8:
                      Es(s, l = Ws);
                      var D = l.alternate;
                      ws(l), null !== D && ws(D);
                  }
                  Ws = Ws.nextEffect;
                }
              } catch (e) {
                if (null === Ws) throw Error(a(330));
                Ll(Ws, e), Ws = Ws.nextEffect;
              }
            } while (null !== Ws);
            if (x = Kr, w = gr(), b = x.focusedElem, s = x.selectionRange, w !== b && b && b.ownerDocument && mr(b.ownerDocument.documentElement, b)) {
              null !== s && vr(b) && (w = s.start, void 0 === (x = s.end) && (x = w), "selectionStart" in b ? (b.selectionStart = w, b.selectionEnd = Math.min(x, b.value.length)) : (x = (w = b.ownerDocument || document) && w.defaultView || window).getSelection && (x = x.getSelection(), l = b.textContent.length, D = Math.min(s.start, l), s = void 0 === s.end ? D : Math.min(s.end, l), !x.extend && D > s && (l = s, s = D, D = l), l = fr(b, D), i = fr(b, s), l && i && (1 !== x.rangeCount || x.anchorNode !== l.node || x.anchorOffset !== l.offset || x.focusNode !== i.node || x.focusOffset !== i.offset) && ((w = w.createRange()).setStart(l.node, l.offset), x.removeAllRanges(), D > s ? (x.addRange(w), x.extend(i.node, i.offset)) : (w.setEnd(i.node, i.offset), x.addRange(w))))), w = [];
              for (x = b; x = x.parentNode;) 1 === x.nodeType && w.push({
                element: x,
                left: x.scrollLeft,
                top: x.scrollTop
              });
              for ("function" == typeof b.focus && b.focus(), b = 0; b < w.length; b++) (x = w[b]).element.scrollLeft = x.left, x.element.scrollTop = x.top;
            }
            Wt = !!Vr, Kr = Vr = null, e.current = n, Ws = r;
            do {
              try {
                for (b = e; null !== Ws;) {
                  var C = Ws.flags;
                  if (36 & C && vs(b, Ws.alternate, Ws), 128 & C) {
                    w = void 0;
                    var S = Ws.ref;
                    if (null !== S) {
                      var E = Ws.stateNode;
                      Ws.tag, w = E, "function" == typeof S ? S(w) : S.current = w;
                    }
                  }
                  Ws = Ws.nextEffect;
                }
              } catch (e) {
                if (null === Ws) throw Error(a(330));
                Ll(Ws, e), Ws = Ws.nextEffect;
              }
            } while (null !== Ws);
            Ws = null, No(), Os = o;
          } else e.current = n;
          if (Js) Js = !1, el = e, tl = t;else for (Ws = r; null !== Ws;) t = Ws.nextEffect, Ws.nextEffect = null, 8 & Ws.flags && ((C = Ws).sibling = null, C.stateNode = null), Ws = t;
          if (0 === (r = e.pendingLanes) && (Qs = null), 1 === r ? e === al ? il++ : (il = 0, al = e) : il = 0, n = n.stateNode, Eo && "function" == typeof Eo.onCommitFiberRoot) try {
            Eo.onCommitFiberRoot(So, n, void 0, 64 == (64 & n.current.flags));
          } catch (e) {}
          if (gl(e, Ho()), Ys) throw Ys = !1, e = Xs, Xs = null, e;
          return 0 != (8 & Os) || Wo(), null;
        }
        function Fl() {
          for (; null !== Ws;) {
            var e = Ws.alternate;
            dl || null === cl || (0 != (8 & Ws.flags) ? et(Ws, cl) && (dl = !0) : 13 === Ws.tag && ks(e, Ws) && et(Ws, cl) && (dl = !0));
            var t = Ws.flags;
            0 != (256 & t) && gs(e, Ws), 0 == (512 & t) || Js || (Js = !0, Go(97, function () {
              return Ml(), null;
            })), Ws = Ws.nextEffect;
          }
        }
        function Ml() {
          if (90 !== tl) {
            var e = 97 < tl ? 97 : tl;
            return tl = 90, $o(e, Bl);
          }
          return !1;
        }
        function Rl(e, t) {
          nl.push(t, e), Js || (Js = !0, Go(97, function () {
            return Ml(), null;
          }));
        }
        function jl(e, t) {
          rl.push(t, e), Js || (Js = !0, Go(97, function () {
            return Ml(), null;
          }));
        }
        function Bl() {
          if (null === el) return !1;
          var e = el;
          if (el = null, 0 != (48 & Os)) throw Error(a(331));
          var t = Os;
          Os |= 32;
          var n = rl;
          rl = [];
          for (var r = 0; r < n.length; r += 2) {
            var o = n[r],
              i = n[r + 1],
              s = o.destroy;
            if (o.destroy = void 0, "function" == typeof s) try {
              s();
            } catch (e) {
              if (null === i) throw Error(a(330));
              Ll(i, e);
            }
          }
          for (n = nl, nl = [], r = 0; r < n.length; r += 2) {
            o = n[r], i = n[r + 1];
            try {
              var l = o.create;
              o.destroy = l();
            } catch (e) {
              if (null === i) throw Error(a(330));
              Ll(i, e);
            }
          }
          for (l = e.current.firstEffect; null !== l;) e = l.nextEffect, l.nextEffect = null, 8 & l.flags && (l.sibling = null, l.stateNode = null), l = e;
          return Os = t, Wo(), !0;
        }
        function Nl(e, t, n) {
          pi(e, t = ps(0, t = us(n, t), 1)), t = pl(), null !== (e = ml(e, 1)) && (qt(e, 1, t), gl(e, t));
        }
        function Ll(e, t) {
          if (3 === e.tag) Nl(e, e, t);else for (var n = e.return; null !== n;) {
            if (3 === n.tag) {
              Nl(n, e, t);
              break;
            }
            if (1 === n.tag) {
              var r = n.stateNode;
              if ("function" == typeof n.type.getDerivedStateFromError || "function" == typeof r.componentDidCatch && (null === Qs || !Qs.has(r))) {
                var o = hs(n, e = us(t, e), 1);
                if (pi(n, o), o = pl(), null !== (n = ml(n, 1))) qt(n, 1, o), gl(n, o);else if ("function" == typeof r.componentDidCatch && (null === Qs || !Qs.has(r))) try {
                  r.componentDidCatch(t, e);
                } catch (e) {}
                break;
              }
            }
            n = n.return;
          }
        }
        function Vl(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t), t = pl(), e.pingedLanes |= e.suspendedLanes & n, Is === e && (Ms & n) === n && (4 === Bs || 3 === Bs && (62914560 & Ms) === Ms && 500 > Ho() - Us ? Sl(e, 0) : qs |= n), gl(e, t);
        }
        function Kl(e, t) {
          var n = e.stateNode;
          null !== n && n.delete(t), 0 === (t = 0) && (0 == (2 & (t = e.mode)) ? t = 1 : 0 == (4 & t) ? t = 99 === Uo() ? 1 : 2 : (0 === ll && (ll = Ls), 0 === (t = Vt(62914560 & ~ll)) && (t = 4194304))), n = pl(), null !== (e = ml(e, t)) && (qt(e, t, n), gl(e, n));
        }
        function ql(e, t, n, r) {
          this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.flags = 0, this.lastEffect = this.firstEffect = this.nextEffect = null, this.childLanes = this.lanes = 0, this.alternate = null;
        }
        function Hl(e, t, n, r) {
          return new ql(e, t, n, r);
        }
        function Ul(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Zl(e, t) {
          var n = e.alternate;
          return null === n ? ((n = Hl(e.tag, t, e.key, e.mode)).elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.nextEffect = null, n.firstEffect = null, n.lastEffect = null), n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = null === t ? null : {
            lanes: t.lanes,
            firstContext: t.firstContext
          }, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n;
        }
        function $l(e, t, n, r, o, i) {
          var s = 2;
          if (r = e, "function" == typeof e) Ul(e) && (s = 1);else if ("string" == typeof e) s = 5;else e: switch (e) {
            case S:
              return Gl(n.children, o, i, t);
            case R:
              s = 8, o |= 16;
              break;
            case E:
              s = 8, o |= 1;
              break;
            case _:
              return (e = Hl(12, n, t, 8 | o)).elementType = _, e.type = _, e.lanes = i, e;
            case z:
              return (e = Hl(13, n, t, o)).type = z, e.elementType = z, e.lanes = i, e;
            case T:
              return (e = Hl(19, n, t, o)).elementType = T, e.lanes = i, e;
            case j:
              return Wl(n, o, i, t);
            case B:
              return (e = Hl(24, n, t, o)).elementType = B, e.lanes = i, e;
            default:
              if ("object" == typeof e && null !== e) switch (e.$$typeof) {
                case P:
                  s = 10;
                  break e;
                case k:
                  s = 9;
                  break e;
                case A:
                  s = 11;
                  break e;
                case O:
                  s = 14;
                  break e;
                case I:
                  s = 16, r = null;
                  break e;
                case F:
                  s = 22;
                  break e;
              }
              throw Error(a(130, null == e ? e : typeof e, ""));
          }
          return (t = Hl(s, n, t, o)).elementType = e, t.type = r, t.lanes = i, t;
        }
        function Gl(e, t, n, r) {
          return (e = Hl(7, e, r, t)).lanes = n, e;
        }
        function Wl(e, t, n, r) {
          return (e = Hl(23, e, r, t)).elementType = j, e.lanes = n, e;
        }
        function Yl(e, t, n) {
          return (e = Hl(6, e, null, t)).lanes = n, e;
        }
        function Xl(e, t, n) {
          return (t = Hl(4, null !== e.children ? e.children : [], e.key, t)).lanes = n, t.stateNode = {
            containerInfo: e.containerInfo,
            pendingChildren: null,
            implementation: e.implementation
          }, t;
        }
        function Ql(e, t, n) {
          this.tag = t, this.containerInfo = e, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.pendingContext = this.context = null, this.hydrate = n, this.callbackNode = null, this.callbackPriority = 0, this.eventTimes = Kt(0), this.expirationTimes = Kt(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Kt(0), this.mutableSourceEagerHydrationData = null;
        }
        function Jl(e, t, n) {
          var r = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
          return {
            $$typeof: C,
            key: null == r ? null : "" + r,
            children: e,
            containerInfo: t,
            implementation: n
          };
        }
        function eu(e, t, n, r) {
          var o = t.current,
            i = pl(),
            s = hl(o);
          e: if (n) {
            t: {
              if (Ye(n = n._reactInternals) !== n || 1 !== n.tag) throw Error(a(170));
              var l = n;
              do {
                switch (l.tag) {
                  case 3:
                    l = l.stateNode.context;
                    break t;
                  case 1:
                    if (yo(l.type)) {
                      l = l.stateNode.__reactInternalMemoizedMergedChildContext;
                      break t;
                    }
                }
                l = l.return;
              } while (null !== l);
              throw Error(a(171));
            }
            if (1 === n.tag) {
              var u = n.type;
              if (yo(u)) {
                n = xo(n, u, l);
                break e;
              }
            }
            n = l;
          } else n = ho;
          return null === t.context ? t.context = n : t.pendingContext = n, (t = di(i, s)).payload = {
            element: e
          }, null !== (r = void 0 === r ? null : r) && (t.callback = r), pi(o, t), fl(o, s, i), s;
        }
        function tu(e) {
          return (e = e.current).child ? (e.child.tag, e.child.stateNode) : null;
        }
        function nu(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function ru(e, t) {
          nu(e, t), (e = e.alternate) && nu(e, t);
        }
        function ou(e, t, n) {
          var r = null != n && null != n.hydrationOptions && n.hydrationOptions.mutableSources || null;
          if (n = new Ql(e, t, null != n && !0 === n.hydrate), t = Hl(3, null, null, 2 === t ? 7 : 1 === t ? 3 : 0), n.current = t, t.stateNode = n, ui(t), e[eo] = n.current, Or(8 === e.nodeType ? e.parentNode : e), r) for (e = 0; e < r.length; e++) {
            var o = (t = r[e])._getVersion;
            o = o(t._source), null == n.mutableSourceEagerHydrationData ? n.mutableSourceEagerHydrationData = [t, o] : n.mutableSourceEagerHydrationData.push(t, o);
          }
          this._internalRoot = n;
        }
        function iu(e) {
          return !(!e || 1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType && (8 !== e.nodeType || " react-mount-point-unstable " !== e.nodeValue));
        }
        function au(e, t, n, r, o) {
          var i = n._reactRootContainer;
          if (i) {
            var a = i._internalRoot;
            if ("function" == typeof o) {
              var s = o;
              o = function () {
                var e = tu(a);
                s.call(e);
              };
            }
            eu(t, a, e, o);
          } else {
            if (i = n._reactRootContainer = function (e, t) {
              if (t || (t = !(!(t = e ? 9 === e.nodeType ? e.documentElement : e.firstChild : null) || 1 !== t.nodeType || !t.hasAttribute("data-reactroot"))), !t) for (var n; n = e.lastChild;) e.removeChild(n);
              return new ou(e, 0, t ? {
                hydrate: !0
              } : void 0);
            }(n, r), a = i._internalRoot, "function" == typeof o) {
              var l = o;
              o = function () {
                var e = tu(a);
                l.call(e);
              };
            }
            xl(function () {
              eu(t, a, e, o);
            });
          }
          return tu(a);
        }
        function su(e, t) {
          var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
          if (!iu(t)) throw Error(a(200));
          return Jl(e, t, null, n);
        }
        Gs = function (e, t, n) {
          var r = t.lanes;
          if (null !== e) {
            if (e.memoizedProps !== t.pendingProps || mo.current) ja = !0;else {
              if (0 == (n & r)) {
                switch (ja = !1, t.tag) {
                  case 3:
                    $a(t), Gi();
                    break;
                  case 5:
                    Ri(t);
                    break;
                  case 1:
                    yo(t.type) && Do(t);
                    break;
                  case 4:
                    Fi(t, t.stateNode.containerInfo);
                    break;
                  case 10:
                    r = t.memoizedProps.value;
                    var o = t.type._context;
                    po(Jo, o._currentValue), o._currentValue = r;
                    break;
                  case 13:
                    if (null !== t.memoizedState) return 0 != (n & t.child.childLanes) ? Qa(e, t, n) : (po(Bi, 1 & Bi.current), null !== (t = is(e, t, n)) ? t.sibling : null);
                    po(Bi, 1 & Bi.current);
                    break;
                  case 19:
                    if (r = 0 != (n & t.childLanes), 0 != (64 & e.flags)) {
                      if (r) return os(e, t, n);
                      t.flags |= 64;
                    }
                    if (null !== (o = t.memoizedState) && (o.rendering = null, o.tail = null, o.lastEffect = null), po(Bi, Bi.current), r) break;
                    return null;
                  case 23:
                  case 24:
                    return t.lanes = 0, Ka(e, t, n);
                }
                return is(e, t, n);
              }
              ja = 0 != (16384 & e.flags);
            }
          } else ja = !1;
          switch (t.lanes = 0, t.tag) {
            case 2:
              if (r = t.type, null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), e = t.pendingProps, o = vo(t, fo.current), ai(t, n), o = sa(null, t, r, e, o, n), t.flags |= 1, "object" == typeof o && null !== o && "function" == typeof o.render && void 0 === o.$$typeof) {
                if (t.tag = 1, t.memoizedState = null, t.updateQueue = null, yo(r)) {
                  var i = !0;
                  Do(t);
                } else i = !1;
                t.memoizedState = null !== o.state && void 0 !== o.state ? o.state : null, ui(t);
                var s = r.getDerivedStateFromProps;
                "function" == typeof s && vi(t, r, s, e), o.updater = yi, t.stateNode = o, o._reactInternals = t, Di(t, r, e, n), t = Za(null, t, r, !0, i, n);
              } else t.tag = 0, Ba(null, t, o, n), t = t.child;
              return t;
            case 16:
              o = t.elementType;
              e: {
                switch (null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), e = t.pendingProps, o = (i = o._init)(o._payload), t.type = o, i = t.tag = function (e) {
                  if ("function" == typeof e) return Ul(e) ? 1 : 0;
                  if (null != e) {
                    if ((e = e.$$typeof) === A) return 11;
                    if (e === O) return 14;
                  }
                  return 2;
                }(o), e = Qo(o, e), i) {
                  case 0:
                    t = Ha(null, t, o, e, n);
                    break e;
                  case 1:
                    t = Ua(null, t, o, e, n);
                    break e;
                  case 11:
                    t = Na(null, t, o, e, n);
                    break e;
                  case 14:
                    t = La(null, t, o, Qo(o.type, e), r, n);
                    break e;
                }
                throw Error(a(306, o, ""));
              }
              return t;
            case 0:
              return r = t.type, o = t.pendingProps, Ha(e, t, r, o = t.elementType === r ? o : Qo(r, o), n);
            case 1:
              return r = t.type, o = t.pendingProps, Ua(e, t, r, o = t.elementType === r ? o : Qo(r, o), n);
            case 3:
              if ($a(t), r = t.updateQueue, null === e || null === r) throw Error(a(282));
              if (r = t.pendingProps, o = null !== (o = t.memoizedState) ? o.element : null, ci(e, t), fi(t, r, null, n), (r = t.memoizedState.element) === o) Gi(), t = is(e, t, n);else {
                if ((i = (o = t.stateNode).hydrate) && (Vi = Gr(t.stateNode.containerInfo.firstChild), Li = t, i = Ki = !0), i) {
                  if (null != (e = o.mutableSourceEagerHydrationData)) for (o = 0; o < e.length; o += 2) (i = e[o])._workInProgressVersionPrimary = e[o + 1], Wi.push(i);
                  for (n = ki(t, null, r, n), t.child = n; n;) n.flags = -3 & n.flags | 1024, n = n.sibling;
                } else Ba(e, t, r, n), Gi();
                t = t.child;
              }
              return t;
            case 5:
              return Ri(t), null === e && Ui(t), r = t.type, o = t.pendingProps, i = null !== e ? e.memoizedProps : null, s = o.children, Hr(r, o) ? s = null : null !== i && Hr(r, i) && (t.flags |= 16), qa(e, t), Ba(e, t, s, n), t.child;
            case 6:
              return null === e && Ui(t), null;
            case 13:
              return Qa(e, t, n);
            case 4:
              return Fi(t, t.stateNode.containerInfo), r = t.pendingProps, null === e ? t.child = Pi(t, null, r, n) : Ba(e, t, r, n), t.child;
            case 11:
              return r = t.type, o = t.pendingProps, Na(e, t, r, o = t.elementType === r ? o : Qo(r, o), n);
            case 7:
              return Ba(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return Ba(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                r = t.type._context, o = t.pendingProps, s = t.memoizedProps, i = o.value;
                var l = t.type._context;
                if (po(Jo, l._currentValue), l._currentValue = i, null !== s) if (l = s.value, 0 === (i = cr(l, i) ? 0 : 0 | ("function" == typeof r._calculateChangedBits ? r._calculateChangedBits(l, i) : 1073741823))) {
                  if (s.children === o.children && !mo.current) {
                    t = is(e, t, n);
                    break e;
                  }
                } else for (null !== (l = t.child) && (l.return = t); null !== l;) {
                  var u = l.dependencies;
                  if (null !== u) {
                    s = l.child;
                    for (var c = u.firstContext; null !== c;) {
                      if (c.context === r && 0 != (c.observedBits & i)) {
                        1 === l.tag && ((c = di(-1, n & -n)).tag = 2, pi(l, c)), l.lanes |= n, null !== (c = l.alternate) && (c.lanes |= n), ii(l.return, n), u.lanes |= n;
                        break;
                      }
                      c = c.next;
                    }
                  } else s = 10 === l.tag && l.type === t.type ? null : l.child;
                  if (null !== s) s.return = l;else for (s = l; null !== s;) {
                    if (s === t) {
                      s = null;
                      break;
                    }
                    if (null !== (l = s.sibling)) {
                      l.return = s.return, s = l;
                      break;
                    }
                    s = s.return;
                  }
                  l = s;
                }
                Ba(e, t, o.children, n), t = t.child;
              }
              return t;
            case 9:
              return o = t.type, r = (i = t.pendingProps).children, ai(t, n), r = r(o = si(o, i.unstable_observedBits)), t.flags |= 1, Ba(e, t, r, n), t.child;
            case 14:
              return i = Qo(o = t.type, t.pendingProps), La(e, t, o, i = Qo(o.type, i), r, n);
            case 15:
              return Va(e, t, t.type, t.pendingProps, r, n);
            case 17:
              return r = t.type, o = t.pendingProps, o = t.elementType === r ? o : Qo(r, o), null !== e && (e.alternate = null, t.alternate = null, t.flags |= 2), t.tag = 1, yo(r) ? (e = !0, Do(t)) : e = !1, ai(t, n), wi(t, r, o), Di(t, r, o, n), Za(null, t, r, !0, e, n);
            case 19:
              return os(e, t, n);
            case 23:
            case 24:
              return Ka(e, t, n);
          }
          throw Error(a(156, t.tag));
        }, ou.prototype.render = function (e) {
          eu(e, this._internalRoot, null, null);
        }, ou.prototype.unmount = function () {
          var e = this._internalRoot,
            t = e.containerInfo;
          eu(null, e, null, function () {
            t[eo] = null;
          });
        }, tt = function (e) {
          13 === e.tag && (fl(e, 4, pl()), ru(e, 4));
        }, nt = function (e) {
          13 === e.tag && (fl(e, 67108864, pl()), ru(e, 67108864));
        }, rt = function (e) {
          if (13 === e.tag) {
            var t = pl(),
              n = hl(e);
            fl(e, n, t), ru(e, n);
          }
        }, ot = function (e, t) {
          return t();
        }, Pe = function (e, t, n) {
          switch (t) {
            case "input":
              if (ne(e, n), t = n.name, "radio" === n.type && null != t) {
                for (n = e; n.parentNode;) n = n.parentNode;
                for (n = n.querySelectorAll("input[name=" + JSON.stringify("" + t) + '][type="radio"]'), t = 0; t < n.length; t++) {
                  var r = n[t];
                  if (r !== e && r.form === e.form) {
                    var o = io(r);
                    if (!o) throw Error(a(90));
                    X(r), ne(r, o);
                  }
                }
              }
              break;
            case "textarea":
              ue(e, n);
              break;
            case "select":
              null != (t = n.value) && ae(e, !!n.multiple, t, !1);
          }
        }, Ie = wl, Fe = function (e, t, n, r, o) {
          var i = Os;
          Os |= 4;
          try {
            return $o(98, e.bind(null, t, n, r, o));
          } finally {
            0 === (Os = i) && ($s(), Wo());
          }
        }, Me = function () {
          0 == (49 & Os) && (function () {
            if (null !== ol) {
              var e = ol;
              ol = null, e.forEach(function (e) {
                e.expiredLanes |= 24 & e.pendingLanes, gl(e, Ho());
              });
            }
            Wo();
          }(), Ml());
        }, Re = function (e, t) {
          var n = Os;
          Os |= 2;
          try {
            return e(t);
          } finally {
            0 === (Os = n) && ($s(), Wo());
          }
        };
        var lu = {
            Events: [ro, oo, io, Te, Oe, Ml, {
              current: !1
            }]
          },
          uu = {
            findFiberByHostInstance: no,
            bundleType: 0,
            version: "17.0.2",
            rendererPackageName: "react-dom"
          },
          cu = {
            bundleType: uu.bundleType,
            version: uu.version,
            rendererPackageName: uu.rendererPackageName,
            rendererConfig: uu.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: x.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = Je(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance: uu.findFiberByHostInstance || function () {
              return null;
            },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null
          };
        if (void 0 !== {
          isDisabled: !0
        }) {
          var du = {
            isDisabled: !0
          };
          if (!du.isDisabled && du.supportsFiber) try {
            So = du.inject(cu), Eo = du;
          } catch (ge) {}
        }
        t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lu, t.createPortal = su, t.findDOMNode = function (e) {
          if (null == e) return null;
          if (1 === e.nodeType) return e;
          var t = e._reactInternals;
          if (void 0 === t) {
            if ("function" == typeof e.render) throw Error(a(188));
            throw Error(a(268, Object.keys(e)));
          }
          return e = null === (e = Je(t)) ? null : e.stateNode;
        }, t.flushSync = function (e, t) {
          var n = Os;
          if (0 != (48 & n)) return e(t);
          Os |= 1;
          try {
            if (e) return $o(99, e.bind(null, t));
          } finally {
            Os = n, Wo();
          }
        }, t.hydrate = function (e, t, n) {
          if (!iu(t)) throw Error(a(200));
          return au(null, e, t, !0, n);
        }, t.render = function (e, t, n) {
          if (!iu(t)) throw Error(a(200));
          return au(null, e, t, !1, n);
        }, t.unmountComponentAtNode = function (e) {
          if (!iu(e)) throw Error(a(40));
          return !!e._reactRootContainer && (xl(function () {
            au(null, null, e, !1, function () {
              e._reactRootContainer = null, e[eo] = null;
            });
          }), !0);
        }, t.unstable_batchedUpdates = wl, t.unstable_createPortal = function (e, t) {
          return su(e, t, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
        }, t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
          if (!iu(n)) throw Error(a(200));
          if (null == e || void 0 === e._reactInternals) throw Error(a(38));
          return au(e, t, n, !1, r);
        }, t.version = "17.0.2";
      },
      73935: (e, t, n) => {
        "use strict";

        !function e() {
          if (void 0 !== {
            isDisabled: !0
          } && "function" == typeof {
            isDisabled: !0
          }.checkDCE) try {
            ({
              isDisabled: !0
            }).checkDCE(e);
          } catch (e) {
            console.error(e);
          }
        }(), e.exports = n(64448);
      },
      54203: (e, t) => {
        "use strict";

        var n, r, o, i;
        if ("object" == typeof performance && "function" == typeof performance.now) {
          var a = performance;
          t.unstable_now = function () {
            return a.now();
          };
        } else {
          var s = Date,
            l = s.now();
          t.unstable_now = function () {
            return s.now() - l;
          };
        }
        if ("undefined" == typeof window || "function" != typeof MessageChannel) {
          var u = null,
            c = null,
            d = function () {
              if (null !== u) try {
                var e = t.unstable_now();
                u(!0, e), u = null;
              } catch (e) {
                throw setTimeout(d, 0), e;
              }
            };
          n = function (e) {
            null !== u ? setTimeout(n, 0, e) : (u = e, setTimeout(d, 0));
          }, r = function (e, t) {
            c = setTimeout(e, t);
          }, o = function () {
            clearTimeout(c);
          }, t.unstable_shouldYield = function () {
            return !1;
          }, i = t.unstable_forceFrameRate = function () {};
        } else {
          var p = window.setTimeout,
            h = window.clearTimeout;
          if ("undefined" != typeof console) {
            var f = window.cancelAnimationFrame;
            "function" != typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), "function" != typeof f && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
          }
          var m = !1,
            g = null,
            v = -1,
            y = 5,
            b = 0;
          t.unstable_shouldYield = function () {
            return t.unstable_now() >= b;
          }, i = function () {}, t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : y = 0 < e ? Math.floor(1e3 / e) : 5;
          };
          var w = new MessageChannel(),
            x = w.port2;
          w.port1.onmessage = function () {
            if (null !== g) {
              var e = t.unstable_now();
              b = e + y;
              try {
                g(!0, e) ? x.postMessage(null) : (m = !1, g = null);
              } catch (e) {
                throw x.postMessage(null), e;
              }
            } else m = !1;
          }, n = function (e) {
            g = e, m || (m = !0, x.postMessage(null));
          }, r = function (e, n) {
            v = p(function () {
              e(t.unstable_now());
            }, n);
          }, o = function () {
            h(v), v = -1;
          };
        }
        function D(e, t) {
          var n = e.length;
          e.push(t);
          e: for (;;) {
            var r = n - 1 >>> 1,
              o = e[r];
            if (!(void 0 !== o && 0 < E(o, t))) break e;
            e[r] = t, e[n] = o, n = r;
          }
        }
        function C(e) {
          return void 0 === (e = e[0]) ? null : e;
        }
        function S(e) {
          var t = e[0];
          if (void 0 !== t) {
            var n = e.pop();
            if (n !== t) {
              e[0] = n;
              e: for (var r = 0, o = e.length; r < o;) {
                var i = 2 * (r + 1) - 1,
                  a = e[i],
                  s = i + 1,
                  l = e[s];
                if (void 0 !== a && 0 > E(a, n)) void 0 !== l && 0 > E(l, a) ? (e[r] = l, e[s] = n, r = s) : (e[r] = a, e[i] = n, r = i);else {
                  if (!(void 0 !== l && 0 > E(l, n))) break e;
                  e[r] = l, e[s] = n, r = s;
                }
              }
            }
            return t;
          }
          return null;
        }
        function E(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        var _ = [],
          P = [],
          k = 1,
          A = null,
          z = 3,
          T = !1,
          O = !1,
          I = !1;
        function F(e) {
          for (var t = C(P); null !== t;) {
            if (null === t.callback) S(P);else {
              if (!(t.startTime <= e)) break;
              S(P), t.sortIndex = t.expirationTime, D(_, t);
            }
            t = C(P);
          }
        }
        function M(e) {
          if (I = !1, F(e), !O) if (null !== C(_)) O = !0, n(R);else {
            var t = C(P);
            null !== t && r(M, t.startTime - e);
          }
        }
        function R(e, n) {
          O = !1, I && (I = !1, o()), T = !0;
          var i = z;
          try {
            for (F(n), A = C(_); null !== A && (!(A.expirationTime > n) || e && !t.unstable_shouldYield());) {
              var a = A.callback;
              if ("function" == typeof a) {
                A.callback = null, z = A.priorityLevel;
                var s = a(A.expirationTime <= n);
                n = t.unstable_now(), "function" == typeof s ? A.callback = s : A === C(_) && S(_), F(n);
              } else S(_);
              A = C(_);
            }
            if (null !== A) var l = !0;else {
              var u = C(P);
              null !== u && r(M, u.startTime - n), l = !1;
            }
            return l;
          } finally {
            A = null, z = i, T = !1;
          }
        }
        var j = i;
        t.unstable_IdlePriority = 5, t.unstable_ImmediatePriority = 1, t.unstable_LowPriority = 4, t.unstable_NormalPriority = 3, t.unstable_Profiling = null, t.unstable_UserBlockingPriority = 2, t.unstable_cancelCallback = function (e) {
          e.callback = null;
        }, t.unstable_continueExecution = function () {
          O || T || (O = !0, n(R));
        }, t.unstable_getCurrentPriorityLevel = function () {
          return z;
        }, t.unstable_getFirstCallbackNode = function () {
          return C(_);
        }, t.unstable_next = function (e) {
          switch (z) {
            case 1:
            case 2:
            case 3:
              var t = 3;
              break;
            default:
              t = z;
          }
          var n = z;
          z = t;
          try {
            return e();
          } finally {
            z = n;
          }
        }, t.unstable_pauseExecution = function () {}, t.unstable_requestPaint = j, t.unstable_runWithPriority = function (e, t) {
          switch (e) {
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
              break;
            default:
              e = 3;
          }
          var n = z;
          z = e;
          try {
            return t();
          } finally {
            z = n;
          }
        }, t.unstable_scheduleCallback = function (e, i, a) {
          var s = t.unstable_now();
          switch ("object" == typeof a && null !== a ? a = "number" == typeof (a = a.delay) && 0 < a ? s + a : s : a = s, e) {
            case 1:
              var l = -1;
              break;
            case 2:
              l = 250;
              break;
            case 5:
              l = 1073741823;
              break;
            case 4:
              l = 1e4;
              break;
            default:
              l = 5e3;
          }
          return e = {
            id: k++,
            callback: i,
            priorityLevel: e,
            startTime: a,
            expirationTime: l = a + l,
            sortIndex: -1
          }, a > s ? (e.sortIndex = a, D(P, e), null === C(_) && e === C(P) && (I ? o() : I = !0, r(M, a - s))) : (e.sortIndex = l, D(_, e), O || T || (O = !0, n(R))), e;
        }, t.unstable_wrapCallback = function (e) {
          var t = z;
          return function () {
            var n = z;
            z = t;
            try {
              return e.apply(this, arguments);
            } finally {
              z = n;
            }
          };
        };
      },
      54142: (e, t, n) => {
        "use strict";

        e.exports = n(54203);
      },
      75668: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), Object.defineProperty(t, "DraggableCore", {
          enumerable: !0,
          get: function () {
            return c.default;
          }
        }), t.default = void 0;
        var r = function (e) {
            if (e && e.__esModule) return e;
            if (null === e || "object" !== f(e) && "function" != typeof e) return {
              default: e
            };
            var t = h();
            if (t && t.has(e)) return t.get(e);
            var n = {},
              r = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
              var i = r ? Object.getOwnPropertyDescriptor(e, o) : null;
              i && (i.get || i.set) ? Object.defineProperty(n, o, i) : n[o] = e[o];
            }
            n.default = e, t && t.set(e, n);
            return n;
          }(n(67294)),
          o = p(n(45697)),
          i = p(n(73935)),
          a = p(n(47980)),
          s = n(81825),
          l = n(2849),
          u = n(9280),
          c = p(n(80783)),
          d = p(n(55904));
        function p(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function h() {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap();
          return h = function () {
            return e;
          }, e;
        }
        function f(e) {
          return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, f(e);
        }
        function m() {
          return m = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, m.apply(this, arguments);
        }
        function g(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        function v(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                r || null == s.return || s.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }(e, t) || function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return y(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return y(e, t);
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function y(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function b(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function w(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function (t) {
              k(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function x(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        function D(e, t, n) {
          return t && x(e.prototype, t), n && x(e, n), e;
        }
        function C(e, t) {
          return C = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, C(e, t);
        }
        function S(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = P(e);
            if (t) {
              var o = P(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return E(this, n);
          };
        }
        function E(e, t) {
          return !t || "object" !== f(t) && "function" != typeof t ? _(e) : t;
        }
        function _(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function P(e) {
          return P = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, P(e);
        }
        function k(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var A = function (e) {
          !function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), t && C(e, t);
          }(n, e);
          var t = S(n);
          function n(e) {
            var r;
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, n), k(_(r = t.call(this, e)), "onDragStart", function (e, t) {
              if ((0, d.default)("Draggable: onDragStart: %j", t), !1 === r.props.onStart(e, (0, l.createDraggableData)(_(r), t))) return !1;
              r.setState({
                dragging: !0,
                dragged: !0
              });
            }), k(_(r), "onDrag", function (e, t) {
              if (!r.state.dragging) return !1;
              (0, d.default)("Draggable: onDrag: %j", t);
              var n = (0, l.createDraggableData)(_(r), t),
                o = {
                  x: n.x,
                  y: n.y
                };
              if (r.props.bounds) {
                var i = o.x,
                  a = o.y;
                o.x += r.state.slackX, o.y += r.state.slackY;
                var s = v((0, l.getBoundPosition)(_(r), o.x, o.y), 2),
                  u = s[0],
                  c = s[1];
                o.x = u, o.y = c, o.slackX = r.state.slackX + (i - o.x), o.slackY = r.state.slackY + (a - o.y), n.x = o.x, n.y = o.y, n.deltaX = o.x - r.state.x, n.deltaY = o.y - r.state.y;
              }
              if (!1 === r.props.onDrag(e, n)) return !1;
              r.setState(o);
            }), k(_(r), "onDragStop", function (e, t) {
              if (!r.state.dragging) return !1;
              if (!1 === r.props.onStop(e, (0, l.createDraggableData)(_(r), t))) return !1;
              (0, d.default)("Draggable: onDragStop: %j", t);
              var n = {
                dragging: !1,
                slackX: 0,
                slackY: 0
              };
              if (Boolean(r.props.position)) {
                var o = r.props.position,
                  i = o.x,
                  a = o.y;
                n.x = i, n.y = a;
              }
              r.setState(n);
            }), r.state = {
              dragging: !1,
              dragged: !1,
              x: e.position ? e.position.x : e.defaultPosition.x,
              y: e.position ? e.position.y : e.defaultPosition.y,
              prevPropsPosition: w({}, e.position),
              slackX: 0,
              slackY: 0,
              isElementSVG: !1
            }, !e.position || e.onDrag || e.onStop || console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element."), r;
          }
          return D(n, null, [{
            key: "getDerivedStateFromProps",
            value: function (e, t) {
              var n = e.position,
                r = t.prevPropsPosition;
              return !n || r && n.x === r.x && n.y === r.y ? null : ((0, d.default)("Draggable: getDerivedStateFromProps %j", {
                position: n,
                prevPropsPosition: r
              }), {
                x: n.x,
                y: n.y,
                prevPropsPosition: w({}, n)
              });
            }
          }]), D(n, [{
            key: "componentDidMount",
            value: function () {
              void 0 !== window.SVGElement && this.findDOMNode() instanceof window.SVGElement && this.setState({
                isElementSVG: !0
              });
            }
          }, {
            key: "componentWillUnmount",
            value: function () {
              this.setState({
                dragging: !1
              });
            }
          }, {
            key: "findDOMNode",
            value: function () {
              return this.props.nodeRef ? this.props.nodeRef.current : i.default.findDOMNode(this);
            }
          }, {
            key: "render",
            value: function () {
              var e,
                t = this.props,
                n = (t.axis, t.bounds, t.children),
                o = t.defaultPosition,
                i = t.defaultClassName,
                u = t.defaultClassNameDragging,
                d = t.defaultClassNameDragged,
                p = t.position,
                h = t.positionOffset,
                f = (t.scale, g(t, ["axis", "bounds", "children", "defaultPosition", "defaultClassName", "defaultClassNameDragging", "defaultClassNameDragged", "position", "positionOffset", "scale"])),
                v = {},
                y = null,
                b = !Boolean(p) || this.state.dragging,
                x = p || o,
                D = {
                  x: (0, l.canDragX)(this) && b ? this.state.x : x.x,
                  y: (0, l.canDragY)(this) && b ? this.state.y : x.y
                };
              this.state.isElementSVG ? y = (0, s.createSVGTransform)(D, h) : v = (0, s.createCSSTransform)(D, h);
              var C = (0, a.default)(n.props.className || "", i, (k(e = {}, u, this.state.dragging), k(e, d, this.state.dragged), e));
              return r.createElement(c.default, m({}, f, {
                onStart: this.onDragStart,
                onDrag: this.onDrag,
                onStop: this.onDragStop
              }), r.cloneElement(r.Children.only(n), {
                className: C,
                style: w(w({}, n.props.style), v),
                transform: y
              }));
            }
          }]), n;
        }(r.Component);
        t.default = A, k(A, "displayName", "Draggable"), k(A, "propTypes", w(w({}, c.default.propTypes), {}, {
          axis: o.default.oneOf(["both", "x", "y", "none"]),
          bounds: o.default.oneOfType([o.default.shape({
            left: o.default.number,
            right: o.default.number,
            top: o.default.number,
            bottom: o.default.number
          }), o.default.string, o.default.oneOf([!1])]),
          defaultClassName: o.default.string,
          defaultClassNameDragging: o.default.string,
          defaultClassNameDragged: o.default.string,
          defaultPosition: o.default.shape({
            x: o.default.number,
            y: o.default.number
          }),
          positionOffset: o.default.shape({
            x: o.default.oneOfType([o.default.number, o.default.string]),
            y: o.default.oneOfType([o.default.number, o.default.string])
          }),
          position: o.default.shape({
            x: o.default.number,
            y: o.default.number
          }),
          className: u.dontSetMe,
          style: u.dontSetMe,
          transform: u.dontSetMe
        })), k(A, "defaultProps", w(w({}, c.default.defaultProps), {}, {
          axis: "both",
          bounds: !1,
          defaultClassName: "react-draggable",
          defaultClassNameDragging: "react-draggable-dragging",
          defaultClassNameDragged: "react-draggable-dragged",
          defaultPosition: {
            x: 0,
            y: 0
          },
          position: null,
          scale: 1
        }));
      },
      80783: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = void 0;
        var r = function (e) {
            if (e && e.__esModule) return e;
            if (null === e || "object" !== p(e) && "function" != typeof e) return {
              default: e
            };
            var t = d();
            if (t && t.has(e)) return t.get(e);
            var n = {},
              r = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var o in e) if (Object.prototype.hasOwnProperty.call(e, o)) {
              var i = r ? Object.getOwnPropertyDescriptor(e, o) : null;
              i && (i.get || i.set) ? Object.defineProperty(n, o, i) : n[o] = e[o];
            }
            n.default = e, t && t.set(e, n);
            return n;
          }(n(67294)),
          o = c(n(45697)),
          i = c(n(73935)),
          a = n(81825),
          s = n(2849),
          l = n(9280),
          u = c(n(55904));
        function c(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }
        function d() {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap();
          return d = function () {
            return e;
          }, e;
        }
        function p(e) {
          return p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, p(e);
        }
        function h(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
            var n = [],
              r = !0,
              o = !1,
              i = void 0;
            try {
              for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
            } catch (e) {
              o = !0, i = e;
            } finally {
              try {
                r || null == s.return || s.return();
              } finally {
                if (o) throw i;
              }
            }
            return n;
          }(e, t) || function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return f(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return f(e, t);
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function f(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function m(e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function g(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        function v(e, t) {
          return v = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, v(e, t);
        }
        function y(e) {
          var t = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }();
          return function () {
            var n,
              r = x(e);
            if (t) {
              var o = x(this).constructor;
              n = Reflect.construct(r, arguments, o);
            } else n = r.apply(this, arguments);
            return b(this, n);
          };
        }
        function b(e, t) {
          return !t || "object" !== p(t) && "function" != typeof t ? w(e) : t;
        }
        function w(e) {
          if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return e;
        }
        function x(e) {
          return x = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
            return e.__proto__ || Object.getPrototypeOf(e);
          }, x(e);
        }
        function D(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var C = {
            start: "touchstart",
            move: "touchmove",
            stop: "touchend"
          },
          S = {
            start: "mousedown",
            move: "mousemove",
            stop: "mouseup"
          },
          E = S,
          _ = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), t && v(e, t);
            }(c, e);
            var t,
              n,
              o,
              l = y(c);
            function c() {
              var e;
              m(this, c);
              for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
              return D(w(e = l.call.apply(l, [this].concat(n))), "state", {
                dragging: !1,
                lastX: NaN,
                lastY: NaN,
                touchIdentifier: null
              }), D(w(e), "mounted", !1), D(w(e), "handleDragStart", function (t) {
                if (e.props.onMouseDown(t), !e.props.allowAnyClick && "number" == typeof t.button && 0 !== t.button) return !1;
                var n = e.findDOMNode();
                if (!n || !n.ownerDocument || !n.ownerDocument.body) throw new Error("<DraggableCore> not mounted on DragStart!");
                var r = n.ownerDocument;
                if (!(e.props.disabled || !(t.target instanceof r.defaultView.Node) || e.props.handle && !(0, a.matchesSelectorAndParentsTo)(t.target, e.props.handle, n) || e.props.cancel && (0, a.matchesSelectorAndParentsTo)(t.target, e.props.cancel, n))) {
                  "touchstart" === t.type && t.preventDefault();
                  var o = (0, a.getTouchIdentifier)(t);
                  e.setState({
                    touchIdentifier: o
                  });
                  var i = (0, s.getControlPosition)(t, o, w(e));
                  if (null != i) {
                    var l = i.x,
                      c = i.y,
                      d = (0, s.createCoreData)(w(e), l, c);
                    (0, u.default)("DraggableCore: handleDragStart: %j", d), (0, u.default)("calling", e.props.onStart), !1 !== e.props.onStart(t, d) && !1 !== e.mounted && (e.props.enableUserSelectHack && (0, a.addUserSelectStyles)(r), e.setState({
                      dragging: !0,
                      lastX: l,
                      lastY: c
                    }), (0, a.addEvent)(r, E.move, e.handleDrag), (0, a.addEvent)(r, E.stop, e.handleDragStop));
                  }
                }
              }), D(w(e), "handleDrag", function (t) {
                var n = (0, s.getControlPosition)(t, e.state.touchIdentifier, w(e));
                if (null != n) {
                  var r = n.x,
                    o = n.y;
                  if (Array.isArray(e.props.grid)) {
                    var i = r - e.state.lastX,
                      a = o - e.state.lastY,
                      l = h((0, s.snapToGrid)(e.props.grid, i, a), 2);
                    if (i = l[0], a = l[1], !i && !a) return;
                    r = e.state.lastX + i, o = e.state.lastY + a;
                  }
                  var c = (0, s.createCoreData)(w(e), r, o);
                  if ((0, u.default)("DraggableCore: handleDrag: %j", c), !1 !== e.props.onDrag(t, c) && !1 !== e.mounted) e.setState({
                    lastX: r,
                    lastY: o
                  });else try {
                    e.handleDragStop(new MouseEvent("mouseup"));
                  } catch (t) {
                    var d = document.createEvent("MouseEvents");
                    d.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), e.handleDragStop(d);
                  }
                }
              }), D(w(e), "handleDragStop", function (t) {
                if (e.state.dragging) {
                  var n = (0, s.getControlPosition)(t, e.state.touchIdentifier, w(e));
                  if (null != n) {
                    var r = n.x,
                      o = n.y,
                      i = (0, s.createCoreData)(w(e), r, o);
                    if (!1 === e.props.onStop(t, i) || !1 === e.mounted) return !1;
                    var l = e.findDOMNode();
                    l && e.props.enableUserSelectHack && (0, a.removeUserSelectStyles)(l.ownerDocument), (0, u.default)("DraggableCore: handleDragStop: %j", i), e.setState({
                      dragging: !1,
                      lastX: NaN,
                      lastY: NaN
                    }), l && ((0, u.default)("DraggableCore: Removing handlers"), (0, a.removeEvent)(l.ownerDocument, E.move, e.handleDrag), (0, a.removeEvent)(l.ownerDocument, E.stop, e.handleDragStop));
                  }
                }
              }), D(w(e), "onMouseDown", function (t) {
                return E = S, e.handleDragStart(t);
              }), D(w(e), "onMouseUp", function (t) {
                return E = S, e.handleDragStop(t);
              }), D(w(e), "onTouchStart", function (t) {
                return E = C, e.handleDragStart(t);
              }), D(w(e), "onTouchEnd", function (t) {
                return E = C, e.handleDragStop(t);
              }), e;
            }
            return t = c, (n = [{
              key: "componentDidMount",
              value: function () {
                this.mounted = !0;
                var e = this.findDOMNode();
                e && (0, a.addEvent)(e, C.start, this.onTouchStart, {
                  passive: !1
                });
              }
            }, {
              key: "componentWillUnmount",
              value: function () {
                this.mounted = !1;
                var e = this.findDOMNode();
                if (e) {
                  var t = e.ownerDocument;
                  (0, a.removeEvent)(t, S.move, this.handleDrag), (0, a.removeEvent)(t, C.move, this.handleDrag), (0, a.removeEvent)(t, S.stop, this.handleDragStop), (0, a.removeEvent)(t, C.stop, this.handleDragStop), (0, a.removeEvent)(e, C.start, this.onTouchStart, {
                    passive: !1
                  }), this.props.enableUserSelectHack && (0, a.removeUserSelectStyles)(t);
                }
              }
            }, {
              key: "findDOMNode",
              value: function () {
                return this.props.nodeRef ? this.props.nodeRef.current : i.default.findDOMNode(this);
              }
            }, {
              key: "render",
              value: function () {
                return r.cloneElement(r.Children.only(this.props.children), {
                  onMouseDown: this.onMouseDown,
                  onMouseUp: this.onMouseUp,
                  onTouchEnd: this.onTouchEnd
                });
              }
            }]) && g(t.prototype, n), o && g(t, o), c;
          }(r.Component);
        t.default = _, D(_, "displayName", "DraggableCore"), D(_, "propTypes", {
          allowAnyClick: o.default.bool,
          disabled: o.default.bool,
          enableUserSelectHack: o.default.bool,
          offsetParent: function (e, t) {
            if (e[t] && 1 !== e[t].nodeType) throw new Error("Draggable's offsetParent must be a DOM Node.");
          },
          grid: o.default.arrayOf(o.default.number),
          handle: o.default.string,
          cancel: o.default.string,
          nodeRef: o.default.object,
          onStart: o.default.func,
          onDrag: o.default.func,
          onStop: o.default.func,
          onMouseDown: o.default.func,
          scale: o.default.number,
          className: l.dontSetMe,
          style: l.dontSetMe,
          transform: l.dontSetMe
        }), D(_, "defaultProps", {
          allowAnyClick: !1,
          cancel: null,
          disabled: !1,
          enableUserSelectHack: !0,
          offsetParent: null,
          handle: null,
          grid: null,
          transform: null,
          onStart: function () {},
          onDrag: function () {},
          onStop: function () {},
          onMouseDown: function () {},
          scale: 1
        });
      },
      61193: (e, t, n) => {
        "use strict";

        var r = n(75668),
          o = r.default,
          i = r.DraggableCore;
        e.exports = o, e.exports.default = o, e.exports.DraggableCore = i;
      },
      81825: (e, t, n) => {
        "use strict";

        function r(e) {
          return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, r(e);
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.matchesSelector = d, t.matchesSelectorAndParentsTo = function (e, t, n) {
          var r = e;
          do {
            if (d(r, t)) return !0;
            if (r === n) return !1;
            r = r.parentNode;
          } while (r);
          return !1;
        }, t.addEvent = function (e, t, n, r) {
          if (!e) return;
          var o = l({
            capture: !0
          }, r);
          e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
        }, t.removeEvent = function (e, t, n, r) {
          if (!e) return;
          var o = l({
            capture: !0
          }, r);
          e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
        }, t.outerHeight = function (e) {
          var t = e.clientHeight,
            n = e.ownerDocument.defaultView.getComputedStyle(e);
          return t += (0, o.int)(n.borderTopWidth), t += (0, o.int)(n.borderBottomWidth);
        }, t.outerWidth = function (e) {
          var t = e.clientWidth,
            n = e.ownerDocument.defaultView.getComputedStyle(e);
          return t += (0, o.int)(n.borderLeftWidth), t += (0, o.int)(n.borderRightWidth);
        }, t.innerHeight = function (e) {
          var t = e.clientHeight,
            n = e.ownerDocument.defaultView.getComputedStyle(e);
          return t -= (0, o.int)(n.paddingTop), t -= (0, o.int)(n.paddingBottom);
        }, t.innerWidth = function (e) {
          var t = e.clientWidth,
            n = e.ownerDocument.defaultView.getComputedStyle(e);
          return t -= (0, o.int)(n.paddingLeft), t -= (0, o.int)(n.paddingRight);
        }, t.offsetXYFromParent = function (e, t, n) {
          var r = t === t.ownerDocument.body ? {
              left: 0,
              top: 0
            } : t.getBoundingClientRect(),
            o = (e.clientX + t.scrollLeft - r.left) / n,
            i = (e.clientY + t.scrollTop - r.top) / n;
          return {
            x: o,
            y: i
          };
        }, t.createCSSTransform = function (e, t) {
          var n = p(e, t, "px");
          return u({}, (0, i.browserPrefixToKey)("transform", i.default), n);
        }, t.createSVGTransform = function (e, t) {
          return p(e, t, "");
        }, t.getTranslation = p, t.getTouch = function (e, t) {
          return e.targetTouches && (0, o.findInArray)(e.targetTouches, function (e) {
            return t === e.identifier;
          }) || e.changedTouches && (0, o.findInArray)(e.changedTouches, function (e) {
            return t === e.identifier;
          });
        }, t.getTouchIdentifier = function (e) {
          if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
          if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
        }, t.addUserSelectStyles = function (e) {
          if (!e) return;
          var t = e.getElementById("react-draggable-style-el");
          t || ((t = e.createElement("style")).type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = ".react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n", t.innerHTML += ".react-draggable-transparent-selection *::selection {all: inherit;}\n", e.getElementsByTagName("head")[0].appendChild(t));
          e.body && h(e.body, "react-draggable-transparent-selection");
        }, t.removeUserSelectStyles = function (e) {
          if (!e) return;
          try {
            if (e.body && f(e.body, "react-draggable-transparent-selection"), e.selection) e.selection.empty();else {
              var t = (e.defaultView || window).getSelection();
              t && "Caret" !== t.type && t.removeAllRanges();
            }
          } catch (e) {}
        }, t.addClassName = h, t.removeClassName = f;
        var o = n(9280),
          i = function (e) {
            if (e && e.__esModule) return e;
            if (null === e || "object" !== r(e) && "function" != typeof e) return {
              default: e
            };
            var t = a();
            if (t && t.has(e)) return t.get(e);
            var n = {},
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in e) if (Object.prototype.hasOwnProperty.call(e, i)) {
              var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
              s && (s.get || s.set) ? Object.defineProperty(n, i, s) : n[i] = e[i];
            }
            n.default = e, t && t.set(e, n);
            return n;
          }(n(38650));
        function a() {
          if ("function" != typeof WeakMap) return null;
          var e = new WeakMap();
          return a = function () {
            return e;
          }, e;
        }
        function s(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function l(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function (t) {
              u(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function u(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        var c = "";
        function d(e, t) {
          return c || (c = (0, o.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function (t) {
            return (0, o.isFunction)(e[t]);
          })), !!(0, o.isFunction)(e[c]) && e[c](t);
        }
        function p(e, t, n) {
          var r = e.x,
            o = e.y,
            i = "translate(".concat(r).concat(n, ",").concat(o).concat(n, ")");
          if (t) {
            var a = "".concat("string" == typeof t.x ? t.x : t.x + n),
              s = "".concat("string" == typeof t.y ? t.y : t.y + n);
            i = "translate(".concat(a, ", ").concat(s, ")") + i;
          }
          return i;
        }
        function h(e, t) {
          e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
        }
        function f(e, t) {
          e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
        }
      },
      38650: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getPrefix = r, t.browserPrefixToKey = o, t.browserPrefixToStyle = function (e, t) {
          return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
        }, t.default = void 0;
        var n = ["Moz", "Webkit", "O", "ms"];
        function r() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "transform";
          if ("undefined" == typeof window || void 0 === window.document) return "";
          var t = window.document.documentElement.style;
          if (e in t) return "";
          for (var r = 0; r < n.length; r++) if (o(e, n[r]) in t) return n[r];
          return "";
        }
        function o(e, t) {
          return t ? "".concat(t).concat(function (e) {
            for (var t = "", n = !0, r = 0; r < e.length; r++) n ? (t += e[r].toUpperCase(), n = !1) : "-" === e[r] ? n = !0 : t += e[r];
            return t;
          }(e)) : e;
        }
        var i = r();
        t.default = i;
      },
      55904: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.default = function () {
          0;
        };
      },
      2849: (e, t, n) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getBoundPosition = function (e, t, n) {
          if (!e.props.bounds) return [t, n];
          var a = e.props.bounds;
          a = "string" == typeof a ? a : function (e) {
            return {
              left: e.left,
              top: e.top,
              right: e.right,
              bottom: e.bottom
            };
          }(a);
          var s = i(e);
          if ("string" == typeof a) {
            var l,
              u = s.ownerDocument,
              c = u.defaultView;
            if (!((l = "parent" === a ? s.parentNode : u.querySelector(a)) instanceof c.HTMLElement)) throw new Error('Bounds selector "' + a + '" could not find an element.');
            var d = c.getComputedStyle(s),
              p = c.getComputedStyle(l);
            a = {
              left: -s.offsetLeft + (0, r.int)(p.paddingLeft) + (0, r.int)(d.marginLeft),
              top: -s.offsetTop + (0, r.int)(p.paddingTop) + (0, r.int)(d.marginTop),
              right: (0, o.innerWidth)(l) - (0, o.outerWidth)(s) - s.offsetLeft + (0, r.int)(p.paddingRight) - (0, r.int)(d.marginRight),
              bottom: (0, o.innerHeight)(l) - (0, o.outerHeight)(s) - s.offsetTop + (0, r.int)(p.paddingBottom) - (0, r.int)(d.marginBottom)
            };
          }
          (0, r.isNum)(a.right) && (t = Math.min(t, a.right));
          (0, r.isNum)(a.bottom) && (n = Math.min(n, a.bottom));
          (0, r.isNum)(a.left) && (t = Math.max(t, a.left));
          (0, r.isNum)(a.top) && (n = Math.max(n, a.top));
          return [t, n];
        }, t.snapToGrid = function (e, t, n) {
          var r = Math.round(t / e[0]) * e[0],
            o = Math.round(n / e[1]) * e[1];
          return [r, o];
        }, t.canDragX = function (e) {
          return "both" === e.props.axis || "x" === e.props.axis;
        }, t.canDragY = function (e) {
          return "both" === e.props.axis || "y" === e.props.axis;
        }, t.getControlPosition = function (e, t, n) {
          var r = "number" == typeof t ? (0, o.getTouch)(e, t) : null;
          if ("number" == typeof t && !r) return null;
          var a = i(n),
            s = n.props.offsetParent || a.offsetParent || a.ownerDocument.body;
          return (0, o.offsetXYFromParent)(r || e, s, n.props.scale);
        }, t.createCoreData = function (e, t, n) {
          var o = e.state,
            a = !(0, r.isNum)(o.lastX),
            s = i(e);
          return a ? {
            node: s,
            deltaX: 0,
            deltaY: 0,
            lastX: t,
            lastY: n,
            x: t,
            y: n
          } : {
            node: s,
            deltaX: t - o.lastX,
            deltaY: n - o.lastY,
            lastX: o.lastX,
            lastY: o.lastY,
            x: t,
            y: n
          };
        }, t.createDraggableData = function (e, t) {
          var n = e.props.scale;
          return {
            node: t.node,
            x: e.state.x + t.deltaX / n,
            y: e.state.y + t.deltaY / n,
            deltaX: t.deltaX / n,
            deltaY: t.deltaY / n,
            lastX: e.state.x,
            lastY: e.state.y
          };
        };
        var r = n(9280),
          o = n(81825);
        function i(e) {
          var t = e.findDOMNode();
          if (!t) throw new Error("<DraggableCore>: Unmounted during event!");
          return t;
        }
      },
      9280: (e, t) => {
        "use strict";

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.findInArray = function (e, t) {
          for (var n = 0, r = e.length; n < r; n++) if (t.apply(t, [e[n], n, e])) return e[n];
        }, t.isFunction = function (e) {
          return "function" == typeof e || "[object Function]" === Object.prototype.toString.call(e);
        }, t.isNum = function (e) {
          return "number" == typeof e && !isNaN(e);
        }, t.int = function (e) {
          return parseInt(e, 10);
        }, t.dontSetMe = function (e, t, n) {
          if (e[t]) return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
        };
      },
      47980: (e, t) => {
        var n;
        !function () {
          "use strict";

          var r = {}.hasOwnProperty;
          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var n = arguments[t];
              if (n) {
                var i = typeof n;
                if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
                  if (n.length) {
                    var a = o.apply(null, n);
                    a && e.push(a);
                  }
                } else if ("object" === i) if (n.toString === Object.prototype.toString) for (var s in n) r.call(n, s) && n[s] && e.push(s);else e.push(n.toString());
              }
            }
            return e.join(" ");
          }
          e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
            return o;
          }.apply(t, [])) || (e.exports = n);
        }();
      },
      69921: (e, t) => {
        "use strict";

        var n = 60103,
          r = 60106,
          o = 60107,
          i = 60108,
          a = 60114,
          s = 60109,
          l = 60110,
          u = 60112,
          c = 60113,
          d = 60120,
          p = 60115,
          h = 60116,
          f = 60121,
          m = 60122,
          g = 60117,
          v = 60129,
          y = 60131;
        if ("function" == typeof Symbol && Symbol.for) {
          var b = Symbol.for;
          n = b("react.element"), r = b("react.portal"), o = b("react.fragment"), i = b("react.strict_mode"), a = b("react.profiler"), s = b("react.provider"), l = b("react.context"), u = b("react.forward_ref"), c = b("react.suspense"), d = b("react.suspense_list"), p = b("react.memo"), h = b("react.lazy"), f = b("react.block"), m = b("react.server.block"), g = b("react.fundamental"), v = b("react.debug_trace_mode"), y = b("react.legacy_hidden");
        }
        function w(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case n:
                switch (e.type) {
                  case o:
                  case a:
                  case i:
                  case c:
                  case d:
                    return e;
                  default:
                    switch (e && e.$$typeof) {
                      case l:
                      case u:
                      case h:
                      case p:
                      case s:
                        return e;
                      default:
                        return t;
                    }
                }
              case r:
                return t;
            }
          }
        }
      },
      59864: (e, t, n) => {
        "use strict";

        n(69921);
      },
      67665: (e, t, n) => {
        "use strict";

        n.d(t, {
          P: () => h,
          m: () => f
        });
        var r = n(67294),
          o = n(73935),
          i = (0, r.createContext)(),
          a = i.Provider,
          s = i.Consumer,
          l = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          },
          u = function () {
            function e(e, t) {
              for (var n = 0; n < t.length; n++) {
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
              }
            }
            return function (t, n, r) {
              return n && e(t.prototype, n), r && e(t, r), t;
            };
          }(),
          c = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
          d = function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          },
          p = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          },
          h = function (e) {
            function t() {
              var e, n, o;
              l(this, t);
              for (var i = arguments.length, a = Array(i), s = 0; s < i; s++) a[s] = arguments[s];
              return n = o = p(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(a))), o.root = r.createRef(), o.host = r.createRef(), o.state = {
                root: o.root.current,
                host: o.host.current
              }, p(o, n);
            }
            return d(t, e), u(t, [{
              key: "componentDidMount",
              value: function () {
                this.setState({
                  root: this.root.current,
                  host: this.host.current
                });
              }
            }, {
              key: "render",
              value: function () {
                return r.createElement(a, {
                  value: this.state
                }, r.createElement("div", {
                  ref: this.root,
                  style: {
                    opacity: .9999999
                  }
                }, this.props.children), r.createElement("div", {
                  ref: this.host,
                  style: {
                    opacity: .9999999
                  }
                }));
              }
            }]), t;
          }(r.Component),
          f = function (e) {
            return r.createElement(s, null, function (t) {
              var n = t.host,
                o = t.root;
              return n && o && r.createElement(m, c({}, e, {
                host: n,
                root: o
              }));
            });
          },
          m = function (e) {
            function t() {
              var e, n, r;
              l(this, t);
              for (var o = arguments.length, i = Array(o), a = 0; a < o; a++) i[a] = arguments[a];
              return n = r = p(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(i))), r.state = {
                container: null
              }, p(r, n);
            }
            return d(t, e), u(t, [{
              key: "componentDidMount",
              value: function () {
                var e = this.props,
                  t = e.host,
                  n = e.index,
                  r = e.onMount,
                  o = e.root,
                  i = t.ownerDocument.createElement("div"),
                  a = "number" == typeof n && t.children[n];
                a ? t.insertBefore(i, a) : t.appendChild(i), this.setState({
                  container: i
                }, function () {
                  o && r && r(o);
                });
              }
            }, {
              key: "componentWillUnmount",
              value: function () {
                var e = this.state.container,
                  t = this.props,
                  n = t.root,
                  r = t.host,
                  o = t.onUnmount;
                n && o && o(n), r && e && r.removeChild(e);
              }
            }, {
              key: "render",
              value: function () {
                var e = this.state.container;
                return e && (0, o.createPortal)(this.props.children, e);
              }
            }]), t;
          }(r.Component);
      },
      67366: (e, t, n) => {
        "use strict";

        n.d(t, {
          zt: () => q,
          dC: () => i.unstable_batchedUpdates,
          $j: () => K,
          wU: () => R,
          I0: () => $,
          v9: () => b
        });
        var r = n(61688),
          o = n(52798),
          i = n(73935);
        let a = function (e) {
          e();
        };
        const s = () => a;
        var l = n(67294);
        const u = Symbol.for("react-redux-context"),
          c = "undefined" != typeof globalThis ? globalThis : {};
        function d() {
          var e;
          if (!l.createContext) return {};
          const t = null != (e = c[u]) ? e : c[u] = new Map();
          let n = t.get(l.createContext);
          return n || (n = l.createContext(null), t.set(l.createContext, n)), n;
        }
        const p = d();
        function h(e = p) {
          return function () {
            return (0, l.useContext)(e);
          };
        }
        const f = h(),
          m = () => {
            throw new Error("uSES not initialized!");
          };
        let g = m;
        const v = (e, t) => e === t;
        function y(e = p) {
          const t = e === p ? f : h(e);
          return function (e, n = {}) {
            const {
              equalityFn: r = v,
              stabilityCheck: o,
              noopCheck: i
            } = "function" == typeof n ? {
              equalityFn: n
            } : n;
            const {
                store: a,
                subscription: s,
                getServerState: u,
                stabilityCheck: c,
                noopCheck: d
              } = t(),
              p = ((0, l.useRef)(!0), (0, l.useCallback)({
                [e.name]: t => e(t)
              }[e.name], [e, c, o])),
              h = g(s.addNestedSub, a.getState, u || a.getState, p, r);
            return (0, l.useDebugValue)(h), h;
          };
        }
        const b = y();
        function w() {
          return w = Object.assign ? Object.assign.bind() : function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, w.apply(this, arguments);
        }
        function x(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            i = Object.keys(e);
          for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }
        var D = n(8679),
          C = n.n(D),
          S = n(72973);
        const E = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
        function _(e, t, n, r, {
          areStatesEqual: o,
          areOwnPropsEqual: i,
          areStatePropsEqual: a
        }) {
          let s,
            l,
            u,
            c,
            d,
            p = !1;
          function h(p, h) {
            const f = !i(h, l),
              m = !o(p, s, h, l);
            return s = p, l = h, f && m ? (u = e(s, l), t.dependsOnOwnProps && (c = t(r, l)), d = n(u, c, l), d) : f ? (e.dependsOnOwnProps && (u = e(s, l)), t.dependsOnOwnProps && (c = t(r, l)), d = n(u, c, l), d) : m ? function () {
              const t = e(s, l),
                r = !a(t, u);
              return u = t, r && (d = n(u, c, l)), d;
            }() : d;
          }
          return function (o, i) {
            return p ? h(o, i) : (s = o, l = i, u = e(s, l), c = t(r, l), d = n(u, c, l), p = !0, d);
          };
        }
        function P(e) {
          return function (t) {
            const n = e(t);
            function r() {
              return n;
            }
            return r.dependsOnOwnProps = !1, r;
          };
        }
        function k(e) {
          return e.dependsOnOwnProps ? Boolean(e.dependsOnOwnProps) : 1 !== e.length;
        }
        function A(e, t) {
          return function (t, {
            displayName: n
          }) {
            const r = function (e, t) {
              return r.dependsOnOwnProps ? r.mapToProps(e, t) : r.mapToProps(e, void 0);
            };
            return r.dependsOnOwnProps = !0, r.mapToProps = function (t, n) {
              r.mapToProps = e, r.dependsOnOwnProps = k(e);
              let o = r(t, n);
              return "function" == typeof o && (r.mapToProps = o, r.dependsOnOwnProps = k(o), o = r(t, n)), o;
            }, r;
          };
        }
        function z(e, t) {
          return (n, r) => {
            throw new Error(`Invalid value of type ${typeof e} for ${t} argument when connecting component ${r.wrappedComponentName}.`);
          };
        }
        function T(e, t, n) {
          return w({}, n, e, t);
        }
        const O = {
          notify() {},
          get: () => []
        };
        function I(e, t) {
          let n,
            r = O,
            o = 0,
            i = !1;
          function a() {
            c.onStateChange && c.onStateChange();
          }
          function l() {
            o++, n || (n = t ? t.addNestedSub(a) : e.subscribe(a), r = function () {
              const e = s();
              let t = null,
                n = null;
              return {
                clear() {
                  t = null, n = null;
                },
                notify() {
                  e(() => {
                    let e = t;
                    for (; e;) e.callback(), e = e.next;
                  });
                },
                get() {
                  let e = [],
                    n = t;
                  for (; n;) e.push(n), n = n.next;
                  return e;
                },
                subscribe(e) {
                  let r = !0,
                    o = n = {
                      callback: e,
                      next: null,
                      prev: n
                    };
                  return o.prev ? o.prev.next = o : t = o, function () {
                    r && null !== t && (r = !1, o.next ? o.next.prev = o.prev : n = o.prev, o.prev ? o.prev.next = o.next : t = o.next);
                  };
                }
              };
            }());
          }
          function u() {
            o--, n && 0 === o && (n(), n = void 0, r.clear(), r = O);
          }
          const c = {
            addNestedSub: function (e) {
              l();
              const t = r.subscribe(e);
              let n = !1;
              return () => {
                n || (n = !0, t(), u());
              };
            },
            notifyNestedSubs: function () {
              r.notify();
            },
            handleChangeWrapper: a,
            isSubscribed: function () {
              return i;
            },
            trySubscribe: function () {
              i || (i = !0, l());
            },
            tryUnsubscribe: function () {
              i && (i = !1, u());
            },
            getListeners: () => r
          };
          return c;
        }
        const F = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement) ? l.useLayoutEffect : l.useEffect;
        function M(e, t) {
          return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
        }
        function R(e, t) {
          if (M(e, t)) return !0;
          if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
          const n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (let r = 0; r < n.length; r++) if (!Object.prototype.hasOwnProperty.call(t, n[r]) || !M(e[n[r]], t[n[r]])) return !1;
          return !0;
        }
        const j = ["reactReduxForwardedRef"];
        let B = m;
        const N = [null, null];
        function L(e, t, n, r, o, i) {
          e.current = r, n.current = !1, o.current && (o.current = null, i());
        }
        function V(e, t) {
          return e === t;
        }
        const K = function (e, t, n, {
          pure: r,
          areStatesEqual: o = V,
          areOwnPropsEqual: i = R,
          areStatePropsEqual: a = R,
          areMergedPropsEqual: s = R,
          forwardRef: u = !1,
          context: c = p
        } = {}) {
          const d = c,
            h = function (e) {
              return e ? "function" == typeof e ? A(e) : z(e, "mapStateToProps") : P(() => ({}));
            }(e),
            f = function (e) {
              return e && "object" == typeof e ? P(t => function (e, t) {
                const n = {};
                for (const r in e) {
                  const o = e[r];
                  "function" == typeof o && (n[r] = (...e) => t(o(...e)));
                }
                return n;
              }(e, t)) : e ? "function" == typeof e ? A(e) : z(e, "mapDispatchToProps") : P(e => ({
                dispatch: e
              }));
            }(t),
            m = function (e) {
              return e ? "function" == typeof e ? function (e) {
                return function (t, {
                  displayName: n,
                  areMergedPropsEqual: r
                }) {
                  let o,
                    i = !1;
                  return function (t, n, a) {
                    const s = e(t, n, a);
                    return i ? r(s, o) || (o = s) : (i = !0, o = s), o;
                  };
                };
              }(e) : z(e, "mergeProps") : () => T;
            }(n),
            g = Boolean(e);
          return e => {
            const t = e.displayName || e.name || "Component",
              n = `Connect(${t})`,
              r = {
                shouldHandleStateChanges: g,
                displayName: n,
                wrappedComponentName: t,
                WrappedComponent: e,
                initMapStateToProps: h,
                initMapDispatchToProps: f,
                initMergeProps: m,
                areStatesEqual: o,
                areStatePropsEqual: a,
                areOwnPropsEqual: i,
                areMergedPropsEqual: s
              };
            function c(t) {
              const [n, o, i] = l.useMemo(() => {
                  const {
                      reactReduxForwardedRef: e
                    } = t,
                    n = x(t, j);
                  return [t.context, e, n];
                }, [t]),
                a = l.useMemo(() => n && n.Consumer && (0, S.isContextConsumer)(l.createElement(n.Consumer, null)) ? n : d, [n, d]),
                s = l.useContext(a),
                u = Boolean(t.store) && Boolean(t.store.getState) && Boolean(t.store.dispatch),
                c = Boolean(s) && Boolean(s.store);
              const p = u ? t.store : s.store,
                h = c ? s.getServerState : p.getState,
                f = l.useMemo(() => function (e, t) {
                  let {
                      initMapStateToProps: n,
                      initMapDispatchToProps: r,
                      initMergeProps: o
                    } = t,
                    i = x(t, E);
                  return _(n(e, i), r(e, i), o(e, i), e, i);
                }(p.dispatch, r), [p]),
                [m, v] = l.useMemo(() => {
                  if (!g) return N;
                  const e = I(p, u ? void 0 : s.subscription),
                    t = e.notifyNestedSubs.bind(e);
                  return [e, t];
                }, [p, u, s]),
                y = l.useMemo(() => u ? s : w({}, s, {
                  subscription: m
                }), [u, s, m]),
                b = l.useRef(),
                D = l.useRef(i),
                C = l.useRef(),
                P = l.useRef(!1),
                k = (l.useRef(!1), l.useRef(!1)),
                A = l.useRef();
              F(() => (k.current = !0, () => {
                k.current = !1;
              }), []);
              const z = l.useMemo(() => () => C.current && i === D.current ? C.current : f(p.getState(), i), [p, i]),
                T = l.useMemo(() => e => m ? function (e, t, n, r, o, i, a, s, l, u, c) {
                  if (!e) return () => {};
                  let d = !1,
                    p = null;
                  const h = () => {
                    if (d || !s.current) return;
                    const e = t.getState();
                    let n, h;
                    try {
                      n = r(e, o.current);
                    } catch (e) {
                      h = e, p = e;
                    }
                    h || (p = null), n === i.current ? a.current || u() : (i.current = n, l.current = n, a.current = !0, c());
                  };
                  return n.onStateChange = h, n.trySubscribe(), h(), () => {
                    if (d = !0, n.tryUnsubscribe(), n.onStateChange = null, p) throw p;
                  };
                }(g, p, m, f, D, b, P, k, C, v, e) : () => {}, [m]);
              var O, M, R;
              let V;
              O = L, M = [D, b, P, i, C, v], F(() => O(...M), R);
              try {
                V = B(T, z, h ? () => f(h(), i) : z);
              } catch (e) {
                throw A.current && (e.message += `\nThe error may be correlated with this previous error:\n${A.current.stack}\n\n`), e;
              }
              F(() => {
                A.current = void 0, C.current = void 0, b.current = V;
              });
              const K = l.useMemo(() => l.createElement(e, w({}, V, {
                ref: o
              })), [o, e, V]);
              return l.useMemo(() => g ? l.createElement(a.Provider, {
                value: y
              }, K) : K, [a, K, y]);
            }
            const p = l.memo(c);
            if (p.WrappedComponent = e, p.displayName = c.displayName = n, u) {
              const t = l.forwardRef(function (e, t) {
                return l.createElement(p, w({}, e, {
                  reactReduxForwardedRef: t
                }));
              });
              return t.displayName = n, t.WrappedComponent = e, C()(t, e);
            }
            return C()(p, e);
          };
        };
        const q = function ({
          store: e,
          context: t,
          children: n,
          serverState: r,
          stabilityCheck: o = "once",
          noopCheck: i = "once"
        }) {
          const a = l.useMemo(() => {
              const t = I(e);
              return {
                store: e,
                subscription: t,
                getServerState: r ? () => r : void 0,
                stabilityCheck: o,
                noopCheck: i
              };
            }, [e, r, o, i]),
            s = l.useMemo(() => e.getState(), [e]);
          F(() => {
            const {
              subscription: t
            } = a;
            return t.onStateChange = t.notifyNestedSubs, t.trySubscribe(), s !== e.getState() && t.notifyNestedSubs(), () => {
              t.tryUnsubscribe(), t.onStateChange = void 0;
            };
          }, [a, s]);
          const u = t || p;
          return l.createElement(u.Provider, {
            value: a
          }, n);
        };
        function H(e = p) {
          const t = e === p ? f : h(e);
          return function () {
            const {
              store: e
            } = t();
            return e;
          };
        }
        const U = H();
        function Z(e = p) {
          const t = e === p ? U : H(e);
          return function () {
            return t().dispatch;
          };
        }
        const $ = Z();
        var G, W;
        G = o.useSyncExternalStoreWithSelector, g = G, (e => {
          B = e;
        })(r.useSyncExternalStore), W = i.unstable_batchedUpdates, a = W;
      },
      88359: (e, t) => {
        "use strict";

        var n,
          r = Symbol.for("react.element"),
          o = Symbol.for("react.portal"),
          i = Symbol.for("react.fragment"),
          a = Symbol.for("react.strict_mode"),
          s = Symbol.for("react.profiler"),
          l = Symbol.for("react.provider"),
          u = Symbol.for("react.context"),
          c = Symbol.for("react.server_context"),
          d = Symbol.for("react.forward_ref"),
          p = Symbol.for("react.suspense"),
          h = Symbol.for("react.suspense_list"),
          f = Symbol.for("react.memo"),
          m = Symbol.for("react.lazy"),
          g = Symbol.for("react.offscreen");
        function v(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case r:
                switch (e = e.type) {
                  case i:
                  case s:
                  case a:
                  case p:
                  case h:
                    return e;
                  default:
                    switch (e = e && e.$$typeof) {
                      case c:
                      case u:
                      case d:
                      case m:
                      case f:
                      case l:
                        return e;
                      default:
                        return t;
                    }
                }
              case o:
                return t;
            }
          }
        }
        n = Symbol.for("react.module.reference"), t.isContextConsumer = function (e) {
          return v(e) === u;
        };
      },
      72973: (e, t, n) => {
        "use strict";

        e.exports = n(88359);
      },
      26353: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => x
        });
        var r = n(54337),
          o = n(73949),
          i = n(6531);
        n(45697);
        function a(e, t) {
          return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
        }
        var s = n(67294),
          l = n(73935);
        const u = !1;
        var c = n(220),
          d = "unmounted",
          p = "exited",
          h = "entering",
          f = "entered",
          m = "exiting",
          g = function (e) {
            function t(t, n) {
              var r;
              r = e.call(this, t, n) || this;
              var o,
                i = n && !n.isMounting ? t.enter : t.appear;
              return r.appearStatus = null, t.in ? i ? (o = p, r.appearStatus = h) : o = f : o = t.unmountOnExit || t.mountOnEnter ? d : p, r.state = {
                status: o
              }, r.nextCallback = null, r;
            }
            (0, i.Z)(t, e), t.getDerivedStateFromProps = function (e, t) {
              return e.in && t.status === d ? {
                status: p
              } : null;
            };
            var n = t.prototype;
            return n.componentDidMount = function () {
              this.updateStatus(!0, this.appearStatus);
            }, n.componentDidUpdate = function (e) {
              var t = null;
              if (e !== this.props) {
                var n = this.state.status;
                this.props.in ? n !== h && n !== f && (t = h) : n !== h && n !== f || (t = m);
              }
              this.updateStatus(!1, t);
            }, n.componentWillUnmount = function () {
              this.cancelNextCallback();
            }, n.getTimeouts = function () {
              var e,
                t,
                n,
                r = this.props.timeout;
              return e = t = n = r, null != r && "number" != typeof r && (e = r.exit, t = r.enter, n = void 0 !== r.appear ? r.appear : t), {
                exit: e,
                enter: t,
                appear: n
              };
            }, n.updateStatus = function (e, t) {
              void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), t === h ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && this.state.status === p && this.setState({
                status: d
              });
            }, n.performEnter = function (e) {
              var t = this,
                n = this.props.enter,
                r = this.context ? this.context.isMounting : e,
                o = this.props.nodeRef ? [r] : [l.findDOMNode(this), r],
                i = o[0],
                a = o[1],
                s = this.getTimeouts(),
                c = r ? s.appear : s.enter;
              !e && !n || u ? this.safeSetState({
                status: f
              }, function () {
                t.props.onEntered(i);
              }) : (this.props.onEnter(i, a), this.safeSetState({
                status: h
              }, function () {
                t.props.onEntering(i, a), t.onTransitionEnd(c, function () {
                  t.safeSetState({
                    status: f
                  }, function () {
                    t.props.onEntered(i, a);
                  });
                });
              }));
            }, n.performExit = function () {
              var e = this,
                t = this.props.exit,
                n = this.getTimeouts(),
                r = this.props.nodeRef ? void 0 : l.findDOMNode(this);
              t && !u ? (this.props.onExit(r), this.safeSetState({
                status: m
              }, function () {
                e.props.onExiting(r), e.onTransitionEnd(n.exit, function () {
                  e.safeSetState({
                    status: p
                  }, function () {
                    e.props.onExited(r);
                  });
                });
              })) : this.safeSetState({
                status: p
              }, function () {
                e.props.onExited(r);
              });
            }, n.cancelNextCallback = function () {
              null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
            }, n.safeSetState = function (e, t) {
              t = this.setNextCallback(t), this.setState(e, t);
            }, n.setNextCallback = function (e) {
              var t = this,
                n = !0;
              return this.nextCallback = function (r) {
                n && (n = !1, t.nextCallback = null, e(r));
              }, this.nextCallback.cancel = function () {
                n = !1;
              }, this.nextCallback;
            }, n.onTransitionEnd = function (e, t) {
              this.setNextCallback(t);
              var n = this.props.nodeRef ? this.props.nodeRef.current : l.findDOMNode(this),
                r = null == e && !this.props.addEndListener;
              if (n && !r) {
                if (this.props.addEndListener) {
                  var o = this.props.nodeRef ? [this.nextCallback] : [n, this.nextCallback],
                    i = o[0],
                    a = o[1];
                  this.props.addEndListener(i, a);
                }
                null != e && setTimeout(this.nextCallback, e);
              } else setTimeout(this.nextCallback, 0);
            }, n.render = function () {
              var e = this.state.status;
              if (e === d) return null;
              var t = this.props,
                n = t.children,
                r = (t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef, (0, o.Z)(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
              return s.createElement(c.Z.Provider, {
                value: null
              }, "function" == typeof n ? n(e, r) : s.cloneElement(s.Children.only(n), r));
            }, t;
          }(s.Component);
        function v() {}
        g.contextType = c.Z, g.propTypes = {}, g.defaultProps = {
          in: !1,
          mountOnEnter: !1,
          unmountOnExit: !1,
          appear: !1,
          enter: !0,
          exit: !0,
          onEnter: v,
          onEntering: v,
          onEntered: v,
          onExit: v,
          onExiting: v,
          onExited: v
        }, g.UNMOUNTED = d, g.EXITED = p, g.ENTERING = h, g.ENTERED = f, g.EXITING = m;
        const y = g;
        var b = function (e, t) {
            return e && t && t.split(" ").forEach(function (t) {
              return r = t, void ((n = e).classList ? n.classList.remove(r) : "string" == typeof n.className ? n.className = a(n.className, r) : n.setAttribute("class", a(n.className && n.className.baseVal || "", r)));
              var n, r;
            });
          },
          w = function (e) {
            function t() {
              for (var t, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
              return (t = e.call.apply(e, [this].concat(r)) || this).appliedClasses = {
                appear: {},
                enter: {},
                exit: {}
              }, t.onEnter = function (e, n) {
                var r = t.resolveArguments(e, n),
                  o = r[0],
                  i = r[1];
                t.removeClasses(o, "exit"), t.addClass(o, i ? "appear" : "enter", "base"), t.props.onEnter && t.props.onEnter(e, n);
              }, t.onEntering = function (e, n) {
                var r = t.resolveArguments(e, n),
                  o = r[0],
                  i = r[1] ? "appear" : "enter";
                t.addClass(o, i, "active"), t.props.onEntering && t.props.onEntering(e, n);
              }, t.onEntered = function (e, n) {
                var r = t.resolveArguments(e, n),
                  o = r[0],
                  i = r[1] ? "appear" : "enter";
                t.removeClasses(o, i), t.addClass(o, i, "done"), t.props.onEntered && t.props.onEntered(e, n);
              }, t.onExit = function (e) {
                var n = t.resolveArguments(e)[0];
                t.removeClasses(n, "appear"), t.removeClasses(n, "enter"), t.addClass(n, "exit", "base"), t.props.onExit && t.props.onExit(e);
              }, t.onExiting = function (e) {
                var n = t.resolveArguments(e)[0];
                t.addClass(n, "exit", "active"), t.props.onExiting && t.props.onExiting(e);
              }, t.onExited = function (e) {
                var n = t.resolveArguments(e)[0];
                t.removeClasses(n, "exit"), t.addClass(n, "exit", "done"), t.props.onExited && t.props.onExited(e);
              }, t.resolveArguments = function (e, n) {
                return t.props.nodeRef ? [t.props.nodeRef.current, e] : [e, n];
              }, t.getClassNames = function (e) {
                var n = t.props.classNames,
                  r = "string" == typeof n,
                  o = r ? "" + (r && n ? n + "-" : "") + e : n[e];
                return {
                  baseClassName: o,
                  activeClassName: r ? o + "-active" : n[e + "Active"],
                  doneClassName: r ? o + "-done" : n[e + "Done"]
                };
              }, t;
            }
            (0, i.Z)(t, e);
            var n = t.prototype;
            return n.addClass = function (e, t, n) {
              var r = this.getClassNames(t)[n + "ClassName"],
                o = this.getClassNames("enter").doneClassName;
              "appear" === t && "done" === n && o && (r += " " + o), "active" === n && e && e.scrollTop, r && (this.appliedClasses[t][n] = r, function (e, t) {
                e && t && t.split(" ").forEach(function (t) {
                  return r = t, void ((n = e).classList ? n.classList.add(r) : function (e, t) {
                    return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
                  }(n, r) || ("string" == typeof n.className ? n.className = n.className + " " + r : n.setAttribute("class", (n.className && n.className.baseVal || "") + " " + r)));
                  var n, r;
                });
              }(e, r));
            }, n.removeClasses = function (e, t) {
              var n = this.appliedClasses[t],
                r = n.base,
                o = n.active,
                i = n.done;
              this.appliedClasses[t] = {}, r && b(e, r), o && b(e, o), i && b(e, i);
            }, n.render = function () {
              var e = this.props,
                t = (e.classNames, (0, o.Z)(e, ["classNames"]));
              return s.createElement(y, (0, r.Z)({}, t, {
                onEnter: this.onEnter,
                onEntered: this.onEntered,
                onEntering: this.onEntering,
                onExit: this.onExit,
                onExiting: this.onExiting,
                onExited: this.onExited
              }));
            }, t;
          }(s.Component);
        w.defaultProps = {
          classNames: ""
        }, w.propTypes = {};
        const x = w;
      },
      84013: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => h
        });
        var r = n(73949),
          o = n(54337);
        var i = n(6531),
          a = (n(45697), n(67294)),
          s = n(220);
        function l(e, t) {
          var n = Object.create(null);
          return e && a.Children.map(e, function (e) {
            return e;
          }).forEach(function (e) {
            n[e.key] = function (e) {
              return t && (0, a.isValidElement)(e) ? t(e) : e;
            }(e);
          }), n;
        }
        function u(e, t, n) {
          return null != n[t] ? n[t] : e.props[t];
        }
        function c(e, t, n) {
          var r = l(e.children),
            o = function (e, t) {
              function n(n) {
                return n in t ? t[n] : e[n];
              }
              e = e || {}, t = t || {};
              var r,
                o = Object.create(null),
                i = [];
              for (var a in e) a in t ? i.length && (o[a] = i, i = []) : i.push(a);
              var s = {};
              for (var l in t) {
                if (o[l]) for (r = 0; r < o[l].length; r++) {
                  var u = o[l][r];
                  s[o[l][r]] = n(u);
                }
                s[l] = n(l);
              }
              for (r = 0; r < i.length; r++) s[i[r]] = n(i[r]);
              return s;
            }(t, r);
          return Object.keys(o).forEach(function (i) {
            var s = o[i];
            if ((0, a.isValidElement)(s)) {
              var l = i in t,
                c = i in r,
                d = t[i],
                p = (0, a.isValidElement)(d) && !d.props.in;
              !c || l && !p ? c || !l || p ? c && l && (0, a.isValidElement)(d) && (o[i] = (0, a.cloneElement)(s, {
                onExited: n.bind(null, s),
                in: d.props.in,
                exit: u(s, "exit", e),
                enter: u(s, "enter", e)
              })) : o[i] = (0, a.cloneElement)(s, {
                in: !1
              }) : o[i] = (0, a.cloneElement)(s, {
                onExited: n.bind(null, s),
                in: !0,
                exit: u(s, "exit", e),
                enter: u(s, "enter", e)
              });
            }
          }), o;
        }
        var d = Object.values || function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
          p = function (e) {
            function t(t, n) {
              var r,
                o = (r = e.call(this, t, n) || this).handleExited.bind(function (e) {
                  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                  return e;
                }(r));
              return r.state = {
                contextValue: {
                  isMounting: !0
                },
                handleExited: o,
                firstRender: !0
              }, r;
            }
            (0, i.Z)(t, e);
            var n = t.prototype;
            return n.componentDidMount = function () {
              this.mounted = !0, this.setState({
                contextValue: {
                  isMounting: !1
                }
              });
            }, n.componentWillUnmount = function () {
              this.mounted = !1;
            }, t.getDerivedStateFromProps = function (e, t) {
              var n,
                r,
                o = t.children,
                i = t.handleExited;
              return {
                children: t.firstRender ? (n = e, r = i, l(n.children, function (e) {
                  return (0, a.cloneElement)(e, {
                    onExited: r.bind(null, e),
                    in: !0,
                    appear: u(e, "appear", n),
                    enter: u(e, "enter", n),
                    exit: u(e, "exit", n)
                  });
                })) : c(e, o, i),
                firstRender: !1
              };
            }, n.handleExited = function (e, t) {
              var n = l(this.props.children);
              e.key in n || (e.props.onExited && e.props.onExited(t), this.mounted && this.setState(function (t) {
                var n = (0, o.Z)({}, t.children);
                return delete n[e.key], {
                  children: n
                };
              }));
            }, n.render = function () {
              var e = this.props,
                t = e.component,
                n = e.childFactory,
                o = (0, r.Z)(e, ["component", "childFactory"]),
                i = this.state.contextValue,
                l = d(this.state.children).map(n);
              return delete o.appear, delete o.enter, delete o.exit, null === t ? a.createElement(s.Z.Provider, {
                value: i
              }, l) : a.createElement(s.Z.Provider, {
                value: i
              }, a.createElement(t, o, l));
            }, t;
          }(a.Component);
        p.propTypes = {}, p.defaultProps = {
          component: "div",
          childFactory: function (e) {
            return e;
          }
        };
        const h = p;
      },
      220: (e, t, n) => {
        "use strict";

        n.d(t, {
          Z: () => r
        });
        const r = n(67294).createContext(null);
      },
      54337: (e, t, n) => {
        "use strict";

        function r() {
          return r = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          }, r.apply(this, arguments);
        }
        n.d(t, {
          Z: () => r
        });
      },
      6531: (e, t, n) => {
        "use strict";

        function r(e, t) {
          return r = Object.setPrototypeOf || function (e, t) {
            return e.__proto__ = t, e;
          }, r(e, t);
        }
        function o(e, t) {
          e.prototype = Object.create(t.prototype), e.prototype.constructor = e, r(e, t);
        }
        n.d(t, {
          Z: () => o
        });
      },
      73949: (e, t, n) => {
        "use strict";

        function r(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = {},
            i = Object.keys(e);
          for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          return o;
        }
        n.d(t, {
          Z: () => r
        });
      },
      75251: (e, t, n) => {
        "use strict";

        n(27418);
        var r = n(67294),
          o = 60103;
        if (t.Fragment = 60107, "function" == typeof Symbol && Symbol.for) {
          var i = Symbol.for;
          o = i("react.element"), t.Fragment = i("react.fragment");
        }
        var a = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
          s = Object.prototype.hasOwnProperty,
          l = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function u(e, t, n) {
          var r,
            i = {},
            u = null,
            c = null;
          for (r in void 0 !== n && (u = "" + n), void 0 !== t.key && (u = "" + t.key), void 0 !== t.ref && (c = t.ref), t) s.call(t, r) && !l.hasOwnProperty(r) && (i[r] = t[r]);
          if (e && e.defaultProps) for (r in t = e.defaultProps) void 0 === i[r] && (i[r] = t[r]);
          return {
            $$typeof: o,
            type: e,
            key: u,
            ref: c,
            props: i,
            _owner: a.current
          };
        }
        t.jsx = u, t.jsxs = u;
      },
      72408: (e, t, n) => {
        "use strict";

        var r = n(27418),
          o = 60103,
          i = 60106;
        t.Fragment = 60107, t.StrictMode = 60108, t.Profiler = 60114;
        var a = 60109,
          s = 60110,
          l = 60112;
        t.Suspense = 60113;
        var u = 60115,
          c = 60116;
        if ("function" == typeof Symbol && Symbol.for) {
          var d = Symbol.for;
          o = d("react.element"), i = d("react.portal"), t.Fragment = d("react.fragment"), t.StrictMode = d("react.strict_mode"), t.Profiler = d("react.profiler"), a = d("react.provider"), s = d("react.context"), l = d("react.forward_ref"), t.Suspense = d("react.suspense"), u = d("react.memo"), c = d("react.lazy");
        }
        var p = "function" == typeof Symbol && Symbol.iterator;
        function h(e) {
          for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, n = 1; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
          return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
        }
        var f = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {}
          },
          m = {};
        function g(e, t, n) {
          this.props = e, this.context = t, this.refs = m, this.updater = n || f;
        }
        function v() {}
        function y(e, t, n) {
          this.props = e, this.context = t, this.refs = m, this.updater = n || f;
        }
        g.prototype.isReactComponent = {}, g.prototype.setState = function (e, t) {
          if ("object" != typeof e && "function" != typeof e && null != e) throw Error(h(85));
          this.updater.enqueueSetState(this, e, t, "setState");
        }, g.prototype.forceUpdate = function (e) {
          this.updater.enqueueForceUpdate(this, e, "forceUpdate");
        }, v.prototype = g.prototype;
        var b = y.prototype = new v();
        b.constructor = y, r(b, g.prototype), b.isPureReactComponent = !0;
        var w = {
            current: null
          },
          x = Object.prototype.hasOwnProperty,
          D = {
            key: !0,
            ref: !0,
            __self: !0,
            __source: !0
          };
        function C(e, t, n) {
          var r,
            i = {},
            a = null,
            s = null;
          if (null != t) for (r in void 0 !== t.ref && (s = t.ref), void 0 !== t.key && (a = "" + t.key), t) x.call(t, r) && !D.hasOwnProperty(r) && (i[r] = t[r]);
          var l = arguments.length - 2;
          if (1 === l) i.children = n;else if (1 < l) {
            for (var u = Array(l), c = 0; c < l; c++) u[c] = arguments[c + 2];
            i.children = u;
          }
          if (e && e.defaultProps) for (r in l = e.defaultProps) void 0 === i[r] && (i[r] = l[r]);
          return {
            $$typeof: o,
            type: e,
            key: a,
            ref: s,
            props: i,
            _owner: w.current
          };
        }
        function S(e) {
          return "object" == typeof e && null !== e && e.$$typeof === o;
        }
        var E = /\/+/g;
        function _(e, t) {
          return "object" == typeof e && null !== e && null != e.key ? function (e) {
            var t = {
              "=": "=0",
              ":": "=2"
            };
            return "$" + e.replace(/[=:]/g, function (e) {
              return t[e];
            });
          }("" + e.key) : t.toString(36);
        }
        function P(e, t, n, r, a) {
          var s = typeof e;
          "undefined" !== s && "boolean" !== s || (e = null);
          var l = !1;
          if (null === e) l = !0;else switch (s) {
            case "string":
            case "number":
              l = !0;
              break;
            case "object":
              switch (e.$$typeof) {
                case o:
                case i:
                  l = !0;
              }
          }
          if (l) return a = a(l = e), e = "" === r ? "." + _(l, 0) : r, Array.isArray(a) ? (n = "", null != e && (n = e.replace(E, "$&/") + "/"), P(a, t, n, "", function (e) {
            return e;
          })) : null != a && (S(a) && (a = function (e, t) {
            return {
              $$typeof: o,
              type: e.type,
              key: t,
              ref: e.ref,
              props: e.props,
              _owner: e._owner
            };
          }(a, n + (!a.key || l && l.key === a.key ? "" : ("" + a.key).replace(E, "$&/") + "/") + e)), t.push(a)), 1;
          if (l = 0, r = "" === r ? "." : r + ":", Array.isArray(e)) for (var u = 0; u < e.length; u++) {
            var c = r + _(s = e[u], u);
            l += P(s, t, n, c, a);
          } else if (c = function (e) {
            return null === e || "object" != typeof e ? null : "function" == typeof (e = p && e[p] || e["@@iterator"]) ? e : null;
          }(e), "function" == typeof c) for (e = c.call(e), u = 0; !(s = e.next()).done;) l += P(s = s.value, t, n, c = r + _(s, u++), a);else if ("object" === s) throw t = "" + e, Error(h(31, "[object Object]" === t ? "object with keys {" + Object.keys(e).join(", ") + "}" : t));
          return l;
        }
        function k(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return P(e, r, "", "", function (e) {
            return t.call(n, e, o++);
          }), r;
        }
        function A(e) {
          if (-1 === e._status) {
            var t = e._result;
            t = t(), e._status = 0, e._result = t, t.then(function (t) {
              0 === e._status && (t = t.default, e._status = 1, e._result = t);
            }, function (t) {
              0 === e._status && (e._status = 2, e._result = t);
            });
          }
          if (1 === e._status) return e._result;
          throw e._result;
        }
        var z = {
          current: null
        };
        function T() {
          var e = z.current;
          if (null === e) throw Error(h(321));
          return e;
        }
        var O = {
          ReactCurrentDispatcher: z,
          ReactCurrentBatchConfig: {
            transition: 0
          },
          ReactCurrentOwner: w,
          IsSomeRendererActing: {
            current: !1
          },
          assign: r
        };
        t.Children = {
          map: k,
          forEach: function (e, t, n) {
            k(e, function () {
              t.apply(this, arguments);
            }, n);
          },
          count: function (e) {
            var t = 0;
            return k(e, function () {
              t++;
            }), t;
          },
          toArray: function (e) {
            return k(e, function (e) {
              return e;
            }) || [];
          },
          only: function (e) {
            if (!S(e)) throw Error(h(143));
            return e;
          }
        }, t.Component = g, t.PureComponent = y, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = O, t.cloneElement = function (e, t, n) {
          if (null == e) throw Error(h(267, e));
          var i = r({}, e.props),
            a = e.key,
            s = e.ref,
            l = e._owner;
          if (null != t) {
            if (void 0 !== t.ref && (s = t.ref, l = w.current), void 0 !== t.key && (a = "" + t.key), e.type && e.type.defaultProps) var u = e.type.defaultProps;
            for (c in t) x.call(t, c) && !D.hasOwnProperty(c) && (i[c] = void 0 === t[c] && void 0 !== u ? u[c] : t[c]);
          }
          var c = arguments.length - 2;
          if (1 === c) i.children = n;else if (1 < c) {
            u = Array(c);
            for (var d = 0; d < c; d++) u[d] = arguments[d + 2];
            i.children = u;
          }
          return {
            $$typeof: o,
            type: e.type,
            key: a,
            ref: s,
            props: i,
            _owner: l
          };
        }, t.createContext = function (e, t) {
          return void 0 === t && (t = null), (e = {
            $$typeof: s,
            _calculateChangedBits: t,
            _currentValue: e,
            _currentValue2: e,
            _threadCount: 0,
            Provider: null,
            Consumer: null
          }).Provider = {
            $$typeof: a,
            _context: e
          }, e.Consumer = e;
        }, t.createElement = C, t.createFactory = function (e) {
          var t = C.bind(null, e);
          return t.type = e, t;
        }, t.createRef = function () {
          return {
            current: null
          };
        }, t.forwardRef = function (e) {
          return {
            $$typeof: l,
            render: e
          };
        }, t.isValidElement = S, t.lazy = function (e) {
          return {
            $$typeof: c,
            _payload: {
              _status: -1,
              _result: e
            },
            _init: A
          };
        }, t.memo = function (e, t) {
          return {
            $$typeof: u,
            type: e,
            compare: void 0 === t ? null : t
          };
        }, t.useCallback = function (e, t) {
          return T().useCallback(e, t);
        }, t.useContext = function (e, t) {
          return T().useContext(e, t);
        }, t.useDebugValue = function () {}, t.useEffect = function (e, t) {
          return T().useEffect(e, t);
        }, t.useImperativeHandle = function (e, t, n) {
          return T().useImperativeHandle(e, t, n);
        }, t.useLayoutEffect = function (e, t) {
          return T().useLayoutEffect(e, t);
        }, t.useMemo = function (e, t) {
          return T().useMemo(e, t);
        }, t.useReducer = function (e, t, n) {
          return T().useReducer(e, t, n);
        }, t.useRef = function (e) {
          return T().useRef(e);
        }, t.useState = function (e) {
          return T().useState(e);
        }, t.version = "17.0.2";
      },
      67294: (e, t, n) => {
        "use strict";

        e.exports = n(72408);
      },
      85893: (e, t, n) => {
        "use strict";

        e.exports = n(75251);
      },
      76438: (e, t, n) => {
        "use strict";

        function r(e) {
          return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
        }
        n.d(t, {
          DE: () => d,
          LG: () => f,
          MT: () => l,
          PO: () => s,
          UY: () => u,
          md: () => h,
          qC: () => p
        });
        var o = (() => "function" == typeof Symbol && Symbol.observable || "@@observable")(),
          i = () => Math.random().toString(36).substring(7).split("").join("."),
          a = {
            INIT: `@@redux/INIT${i()}`,
            REPLACE: `@@redux/REPLACE${i()}`,
            PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${i()}`
          };
        function s(e) {
          if ("object" != typeof e || null === e) return !1;
          let t = e;
          for (; null !== Object.getPrototypeOf(t);) t = Object.getPrototypeOf(t);
          return Object.getPrototypeOf(e) === t || null === Object.getPrototypeOf(e);
        }
        function l(e, t, n) {
          if ("function" != typeof e) throw new Error(r(2));
          if ("function" == typeof t && "function" == typeof n || "function" == typeof n && "function" == typeof arguments[3]) throw new Error(r(0));
          if ("function" == typeof t && void 0 === n && (n = t, t = void 0), void 0 !== n) {
            if ("function" != typeof n) throw new Error(r(1));
            return n(l)(e, t);
          }
          let i = e,
            u = t,
            c = new Map(),
            d = c,
            p = 0,
            h = !1;
          function f() {
            d === c && (d = new Map(), c.forEach((e, t) => {
              d.set(t, e);
            }));
          }
          function m() {
            if (h) throw new Error(r(3));
            return u;
          }
          function g(e) {
            if ("function" != typeof e) throw new Error(r(4));
            if (h) throw new Error(r(5));
            let t = !0;
            f();
            const n = p++;
            return d.set(n, e), function () {
              if (t) {
                if (h) throw new Error(r(6));
                t = !1, f(), d.delete(n), c = null;
              }
            };
          }
          function v(e) {
            if (!s(e)) throw new Error(r(7));
            if (void 0 === e.type) throw new Error(r(8));
            if ("string" != typeof e.type) throw new Error(r(17));
            if (h) throw new Error(r(9));
            try {
              h = !0, u = i(u, e);
            } finally {
              h = !1;
            }
            return (c = d).forEach(e => {
              e();
            }), e;
          }
          function y(e) {
            if ("function" != typeof e) throw new Error(r(10));
            i = e, v({
              type: a.REPLACE
            });
          }
          function b() {
            const e = g;
            return {
              subscribe(t) {
                if ("object" != typeof t || null === t) throw new Error(r(11));
                function n() {
                  const e = t;
                  e.next && e.next(m());
                }
                n();
                return {
                  unsubscribe: e(n)
                };
              },
              [o]() {
                return this;
              }
            };
          }
          v({
            type: a.INIT
          });
          const w = {
            dispatch: v,
            subscribe: g,
            getState: m,
            replaceReducer: y,
            [o]: b
          };
          return w;
        }
        function u(e) {
          const t = Object.keys(e),
            n = {};
          for (let r = 0; r < t.length; r++) {
            const o = t[r];
            0, "function" == typeof e[o] && (n[o] = e[o]);
          }
          const o = Object.keys(n);
          let i;
          try {
            !function (e) {
              Object.keys(e).forEach(t => {
                const n = e[t];
                if (void 0 === n(void 0, {
                  type: a.INIT
                })) throw new Error(r(12));
                if (void 0 === n(void 0, {
                  type: a.PROBE_UNKNOWN_ACTION()
                })) throw new Error(r(13));
              });
            }(n);
          } catch (e) {
            i = e;
          }
          return function (e = {}, t) {
            if (i) throw i;
            let a = !1;
            const s = {};
            for (let i = 0; i < o.length; i++) {
              const l = o[i],
                u = n[l],
                c = e[l],
                d = u(c, t);
              if (void 0 === d) {
                t && t.type;
                throw new Error(r(14));
              }
              s[l] = d, a = a || d !== c;
            }
            return a = a || o.length !== Object.keys(e).length, a ? s : e;
          };
        }
        function c(e, t) {
          return function (...n) {
            return t(e.apply(this, n));
          };
        }
        function d(e, t) {
          if ("function" == typeof e) return c(e, t);
          if ("object" != typeof e || null === e) throw new Error(r(16));
          const n = {};
          for (const r in e) {
            const o = e[r];
            "function" == typeof o && (n[r] = c(o, t));
          }
          return n;
        }
        function p(...e) {
          return 0 === e.length ? e => e : 1 === e.length ? e[0] : e.reduce((e, t) => (...n) => e(t(...n)));
        }
        function h(...e) {
          return t => (n, o) => {
            const i = t(n, o);
            let a = () => {
              throw new Error(r(15));
            };
            const s = {
                getState: i.getState,
                dispatch: (e, ...t) => a(e, ...t)
              },
              l = e.map(e => e(s));
            return a = p(...l)(i.dispatch), {
              ...i,
              dispatch: a
            };
          };
        }
        function f(e) {
          return s(e) && "type" in e && "string" == typeof e.type;
        }
      },
      4345: (e, t, n) => {
        "use strict";

        n.d(t, {
          CX: () => St,
          F3: () => we,
          mH: () => It,
          BU: () => Nt
        });
        var r = n(6907),
          o = n.n(r),
          i = n(23279),
          a = n.n(i),
          s = n(23493),
          l = n.n(s),
          u = n(67294);
        function c(e) {
          return "object" == typeof e && null != e && 1 === e.nodeType;
        }
        function d(e, t) {
          return (!t || "hidden" !== e) && "visible" !== e && "clip" !== e;
        }
        function p(e, t) {
          if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
            var n = getComputedStyle(e, null);
            return d(n.overflowY, t) || d(n.overflowX, t) || function (e) {
              var t = function (e) {
                if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
                try {
                  return e.ownerDocument.defaultView.frameElement;
                } catch (e) {
                  return null;
                }
              }(e);
              return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
            }(e);
          }
          return !1;
        }
        function h(e, t, n, r, o, i, a, s) {
          return i < e && a > t || i > e && a < t ? 0 : i <= e && s <= n || a >= t && s >= n ? i - e - r : a > t && s < n || i < e && s > n ? a - t + o : 0;
        }
        var f = function (e, t) {
          var n = window,
            r = t.scrollMode,
            o = t.block,
            i = t.inline,
            a = t.boundary,
            s = t.skipOverflowHiddenElements,
            l = "function" == typeof a ? a : function (e) {
              return e !== a;
            };
          if (!c(e)) throw new TypeError("Invalid target");
          for (var u, d, f = document.scrollingElement || document.documentElement, m = [], g = e; c(g) && l(g);) {
            if ((g = null == (d = (u = g).parentElement) ? u.getRootNode().host || null : d) === f) {
              m.push(g);
              break;
            }
            null != g && g === document.body && p(g) && !p(document.documentElement) || null != g && p(g, s) && m.push(g);
          }
          for (var v = n.visualViewport ? n.visualViewport.width : innerWidth, y = n.visualViewport ? n.visualViewport.height : innerHeight, b = window.scrollX || pageXOffset, w = window.scrollY || pageYOffset, x = e.getBoundingClientRect(), D = x.height, C = x.width, S = x.top, E = x.right, _ = x.bottom, P = x.left, k = "start" === o || "nearest" === o ? S : "end" === o ? _ : S + D / 2, A = "center" === i ? P + C / 2 : "end" === i ? E : P, z = [], T = 0; T < m.length; T++) {
            var O = m[T],
              I = O.getBoundingClientRect(),
              F = I.height,
              M = I.width,
              R = I.top,
              j = I.right,
              B = I.bottom,
              N = I.left;
            if ("if-needed" === r && S >= 0 && P >= 0 && _ <= y && E <= v && S >= R && _ <= B && P >= N && E <= j) return z;
            var L = getComputedStyle(O),
              V = parseInt(L.borderLeftWidth, 10),
              K = parseInt(L.borderTopWidth, 10),
              q = parseInt(L.borderRightWidth, 10),
              H = parseInt(L.borderBottomWidth, 10),
              U = 0,
              Z = 0,
              $ = "offsetWidth" in O ? O.offsetWidth - O.clientWidth - V - q : 0,
              G = "offsetHeight" in O ? O.offsetHeight - O.clientHeight - K - H : 0,
              W = "offsetWidth" in O ? 0 === O.offsetWidth ? 0 : M / O.offsetWidth : 0,
              Y = "offsetHeight" in O ? 0 === O.offsetHeight ? 0 : F / O.offsetHeight : 0;
            if (f === O) U = "start" === o ? k : "end" === o ? k - y : "nearest" === o ? h(w, w + y, y, K, H, w + k, w + k + D, D) : k - y / 2, Z = "start" === i ? A : "center" === i ? A - v / 2 : "end" === i ? A - v : h(b, b + v, v, V, q, b + A, b + A + C, C), U = Math.max(0, U + w), Z = Math.max(0, Z + b);else {
              U = "start" === o ? k - R - K : "end" === o ? k - B + H + G : "nearest" === o ? h(R, B, F, K, H + G, k, k + D, D) : k - (R + F / 2) + G / 2, Z = "start" === i ? A - N - V : "center" === i ? A - (N + M / 2) + $ / 2 : "end" === i ? A - j + q + $ : h(N, j, M, V, q + $, A, A + C, C);
              var X = O.scrollLeft,
                Q = O.scrollTop;
              k += Q - (U = Math.max(0, Math.min(Q + U / Y, O.scrollHeight - F / Y + G))), A += X - (Z = Math.max(0, Math.min(X + Z / W, O.scrollWidth - M / W + $)));
            }
            z.push({
              el: O,
              top: U,
              left: Z
            });
          }
          return z;
        };
        function m(e) {
          return e === Object(e) && 0 !== Object.keys(e).length;
        }
        const g = function (e, t) {
          var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
          if (m(t) && "function" == typeof t.behavior) return t.behavior(n ? f(e, t) : []);
          if (n) {
            var r = function (e) {
              return !1 === e ? {
                block: "end",
                inline: "nearest"
              } : m(e) ? e : {
                block: "start",
                inline: "nearest"
              };
            }(t);
            return function (e, t) {
              void 0 === t && (t = "auto");
              var n = "scrollBehavior" in document.body.style;
              e.forEach(function (e) {
                var r = e.el,
                  o = e.top,
                  i = e.left;
                r.scroll && n ? r.scroll({
                  top: o,
                  left: i,
                  behavior: t
                }) : (r.scrollTop = o, r.scrollLeft = i);
              });
            }(f(e, r), r.behavior);
          }
        };
        var v = n(77493),
          y = n(86254),
          b = n(18156),
          w = n(73935);
        function x(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function D(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        var C = 0;
        class S {
          constructor() {
            x(this, "id", void 0), this.id = "".concat(C++);
          }
        }
        var E = new WeakMap(),
          _ = new WeakMap(),
          P = new WeakMap(),
          k = new WeakMap(),
          A = new WeakMap(),
          z = new WeakMap(),
          T = new WeakMap(),
          O = new WeakMap(),
          I = new WeakMap(),
          F = new WeakMap(),
          M = new WeakMap(),
          R = new WeakMap(),
          j = new WeakMap(),
          B = new WeakMap(),
          N = new WeakMap(),
          L = new WeakMap(),
          V = new WeakMap(),
          K = new WeakMap(),
          q = new WeakMap(),
          H = new WeakMap(),
          U = new WeakMap(),
          Z = Symbol("placeholder"),
          $ = Symbol("mark-placeholder"),
          G = globalThis.Text,
          W = e => e && e.ownerDocument && e.ownerDocument.defaultView || null,
          Y = e => X(e) && 1 === e.nodeType,
          X = e => {
            var t = W(e);
            return !!t && e instanceof t.Node;
          },
          Q = e => !!(e && e.anchorNode && W(e.anchorNode)),
          J = e => X(e) && 3 === e.nodeType,
          ee = (e, t, n) => {
            for (var r, {
                childNodes: o
              } = e, i = o[t], a = t, s = !1, l = !1; (X(r = i) && 8 === r.nodeType || Y(i) && 0 === i.childNodes.length || Y(i) && "false" === i.getAttribute("contenteditable")) && (!s || !l);) a >= o.length ? (s = !0, a = t - 1, n = "backward") : a < 0 ? (l = !0, a = t + 1, n = "forward") : (i = o[a], t = a, a += "forward" === n ? 1 : -1);
            return [i, t];
          },
          te = (e, t, n) => {
            var [r] = ee(e, t, n);
            return r;
          },
          ne = e => {
            var t = "";
            if (J(e) && e.nodeValue) return e.nodeValue;
            if (Y(e)) {
              for (var n of Array.from(e.childNodes)) t += ne(n);
              var r = getComputedStyle(e).getPropertyValue("display");
              "block" !== r && "list" !== r && "BR" !== e.tagName || (t += "\n");
            }
            return t;
          },
          re = /data-slate-fragment="(.+?)"/m,
          oe = e => {
            var t = e.getData("text/html"),
              [, n] = t.match(re) || [];
            return n;
          },
          ie = (e, t, n) => {
            var {
              target: r
            } = t;
            if (Y(r) && r.matches('[contentEditable="false"]')) return !1;
            var {
              document: o
            } = we.getWindow(e);
            if (o.contains(r)) return we.hasDOMNode(e, r, {
              editable: !0
            });
            var i = n.find(e => {
              var {
                addedNodes: t,
                removedNodes: n
              } = e;
              for (var o of t) if (o === r || o.contains(r)) return !0;
              for (var i of n) if (i === r || i.contains(r)) return !0;
            });
            return !(!i || i === t) && ie(e, i, n);
          };
        var ae = parseInt(u.version.split(".")[0], 10) >= 17,
          se = "undefined" != typeof navigator && "undefined" != typeof window && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
          le = "undefined" != typeof navigator && /Mac OS X/.test(navigator.userAgent),
          ue = "undefined" != typeof navigator && /Android/.test(navigator.userAgent),
          ce = "undefined" != typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent),
          de = "undefined" != typeof navigator && /Version\/[\d\.]+.*Safari/.test(navigator.userAgent),
          pe = "undefined" != typeof navigator && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent),
          he = "undefined" != typeof navigator && /Chrome/i.test(navigator.userAgent),
          fe = "undefined" != typeof navigator && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent),
          me = "undefined" != typeof navigator && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent),
          ge = "undefined" != typeof navigator && /.*UCBrowser/.test(navigator.userAgent),
          ve = "undefined" != typeof navigator && /.*Wechat/.test(navigator.userAgent),
          ye = !("undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement),
          be = !fe && !pe && "undefined" != typeof globalThis && globalThis.InputEvent && "function" == typeof globalThis.InputEvent.prototype.getTargetRanges,
          we = {
            isComposing: e => !!R.get(e),
            getWindow(e) {
              var t = P.get(e);
              if (!t) throw new Error("Unable to find a host window element for this editor");
              return t;
            },
            findKey(e, t) {
              var n = O.get(t);
              return n || (n = new S(), O.set(t, n)), n;
            },
            findPath(e, t) {
              for (var n = [], r = t;;) {
                var o = _.get(r);
                if (null == o) {
                  if (v.ML.isEditor(r)) return n;
                  break;
                }
                var i = E.get(r);
                if (null == i) break;
                n.unshift(i), r = o;
              }
              throw new Error("Unable to find the path for Slate node: ".concat(v.o4.stringify(t)));
            },
            findDocumentOrShadowRoot(e) {
              var t = we.toDOMNode(e, e),
                n = t.getRootNode();
              return (n instanceof Document || n instanceof ShadowRoot) && null != n.getSelection ? n : t.ownerDocument;
            },
            isFocused: e => !!M.get(e),
            isReadOnly: e => !!F.get(e),
            blur(e) {
              var t = we.toDOMNode(e, e),
                n = we.findDocumentOrShadowRoot(e);
              M.set(e, !1), n.activeElement === t && t.blur();
            },
            focus(e) {
              var t = we.toDOMNode(e, e),
                n = we.findDocumentOrShadowRoot(e);
              M.set(e, !0), n.activeElement !== t && t.focus({
                preventScroll: !0
              });
            },
            deselect(e) {
              var {
                  selection: t
                } = e,
                n = we.findDocumentOrShadowRoot(e).getSelection();
              n && n.rangeCount > 0 && n.removeAllRanges(), t && v.YR.deselect(e);
            },
            hasDOMNode(e, t) {
              var n,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                {
                  editable: o = !1
                } = r,
                i = we.toDOMNode(e, e);
              try {
                n = Y(t) ? t : t.parentElement;
              } catch (e) {
                if (!e.message.includes('Permission denied to access property "nodeType"')) throw e;
              }
              return !!n && !(n.closest("[data-slate-editor]") !== i || o && !n.isContentEditable && ("boolean" != typeof n.isContentEditable || n.closest('[contenteditable="false"]') !== i) && !n.getAttribute("data-slate-zero-width"));
            },
            insertData(e, t) {
              e.insertData(t);
            },
            insertFragmentData: (e, t) => e.insertFragmentData(t),
            insertTextData: (e, t) => e.insertTextData(t),
            setFragmentData(e, t, n) {
              e.setFragmentData(t, n);
            },
            toDOMNode(e, t) {
              var n = I.get(e),
                r = v.ML.isEditor(t) ? k.get(e) : null == n ? void 0 : n.get(we.findKey(e, t));
              if (!r) throw new Error("Cannot resolve a DOM node from Slate node: ".concat(v.o4.stringify(t)));
              return r;
            },
            toDOMPoint(e, t) {
              var n,
                [r] = v.ML.node(e, t.path),
                o = we.toDOMNode(e, r);
              v.ML.void(e, {
                at: t
              }) && (t = {
                path: t.path,
                offset: 0
              });
              for (var i = Array.from(o.querySelectorAll("[data-slate-string], [data-slate-zero-width]")), a = 0, s = 0; s < i.length; s++) {
                var l = i[s],
                  u = l.childNodes[0];
                if (null != u && null != u.textContent) {
                  var {
                      length: c
                    } = u.textContent,
                    d = l.getAttribute("data-slate-length"),
                    p = a + (null == d ? c : parseInt(d, 10)),
                    h = i[s + 1];
                  if (t.offset === p && null != h && h.hasAttribute("data-slate-mark-placeholder")) {
                    var f,
                      m = h.childNodes[0];
                    n = [m instanceof G ? m : h, null !== (f = h.textContent) && void 0 !== f && f.startsWith("\ufeff") ? 1 : 0];
                    break;
                  }
                  if (t.offset <= p) {
                    n = [u, Math.min(c, Math.max(0, t.offset - a))];
                    break;
                  }
                  a = p;
                }
              }
              if (!n) throw new Error("Cannot resolve a DOM point from Slate point: ".concat(v.o4.stringify(t)));
              return n;
            },
            toDOMRange(e, t) {
              var {
                  anchor: n,
                  focus: r
                } = t,
                o = v.e6.isBackward(t),
                i = we.toDOMPoint(e, n),
                a = v.e6.isCollapsed(t) ? i : we.toDOMPoint(e, r),
                s = we.getWindow(e).document.createRange(),
                [l, u] = o ? a : i,
                [c, d] = o ? i : a,
                p = !!(Y(l) ? l : l.parentElement).getAttribute("data-slate-zero-width"),
                h = !!(Y(c) ? c : c.parentElement).getAttribute("data-slate-zero-width");
              return s.setStart(l, p ? 1 : u), s.setEnd(c, h ? 1 : d), s;
            },
            toSlateNode(e, t) {
              var n = Y(t) ? t : t.parentElement;
              n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
              var r = n ? z.get(n) : null;
              if (!r) throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
              return r;
            },
            findEventRange(e, t) {
              "nativeEvent" in t && (t = t.nativeEvent);
              var {
                clientX: n,
                clientY: r,
                target: o
              } = t;
              if (null == n || null == r) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
              var i,
                a = we.toSlateNode(e, t.target),
                s = we.findPath(e, a);
              if (v.W_.isElement(a) && v.ML.isVoid(e, a)) {
                var l = o.getBoundingClientRect(),
                  u = e.isInline(a) ? n - l.left < l.left + l.width - n : r - l.top < l.top + l.height - r,
                  c = v.ML.point(e, s, {
                    edge: u ? "start" : "end"
                  }),
                  d = u ? v.ML.before(e, c) : v.ML.after(e, c);
                if (d) return v.ML.range(e, d);
              }
              var {
                document: p
              } = we.getWindow(e);
              if (p.caretRangeFromPoint) i = p.caretRangeFromPoint(n, r);else {
                var h = p.caretPositionFromPoint(n, r);
                h && ((i = p.createRange()).setStart(h.offsetNode, h.offset), i.setEnd(h.offsetNode, h.offset));
              }
              if (!i) throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
              return we.toSlateRange(e, i, {
                exactMatch: !1,
                suppressThrow: !1
              });
            },
            toSlatePoint(e, t, n) {
              var {
                  exactMatch: r,
                  suppressThrow: o
                } = n,
                [i, a] = r ? t : (e => {
                  var [t, n] = e;
                  if (Y(t) && t.childNodes.length) {
                    var r = n === t.childNodes.length,
                      o = r ? n - 1 : n;
                    for ([t, o] = ee(t, o, r ? "backward" : "forward"), r = o < n; Y(t) && t.childNodes.length;) {
                      var i = r ? t.childNodes.length - 1 : 0;
                      t = te(t, i, r ? "backward" : "forward");
                    }
                    n = r && null != t.textContent ? t.textContent.length : 0;
                  }
                  return [t, n];
                })(t),
                s = i.parentNode,
                l = null,
                u = 0;
              if (s) {
                var c,
                  d,
                  p = we.toDOMNode(e, e),
                  h = s.closest('[data-slate-void="true"]'),
                  f = h && p.contains(h) ? h : null,
                  m = s.closest("[data-slate-leaf]"),
                  g = null;
                if (m) {
                  if (l = m.closest('[data-slate-node="text"]')) {
                    var y = we.getWindow(e).document.createRange();
                    y.setStart(l, 0), y.setEnd(i, a);
                    var b = y.cloneContents();
                    [...Array.prototype.slice.call(b.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(b.querySelectorAll("[contenteditable=false]"))].forEach(e => {
                      ue && !r && e.hasAttribute("data-slate-zero-width") && e.textContent.length > 0 && "\ufeff" !== e.textContext ? e.textContent.startsWith("\ufeff") && (e.textContent = e.textContent.slice(1)) : e.parentNode.removeChild(e);
                    }), u = b.textContent.length, g = l;
                  }
                } else if (f) {
                  for (var w = f.querySelectorAll("[data-slate-leaf]"), x = 0; x < w.length; x++) {
                    var D = w[x];
                    if (we.hasDOMNode(e, D)) {
                      m = D;
                      break;
                    }
                  }
                  m ? (l = m.closest('[data-slate-node="text"]'), u = (g = m).textContent.length, g.querySelectorAll("[data-slate-zero-width]").forEach(e => {
                    u -= e.textContent.length;
                  })) : u = 1;
                }
                g && u === g.textContent.length && ue && "z" === g.getAttribute("data-slate-zero-width") && null !== (c = g.textContent) && void 0 !== c && c.startsWith("\ufeff") && (s.hasAttribute("data-slate-zero-width") || ce && null !== (d = g.textContent) && void 0 !== d && d.endsWith("\n\n")) && u--;
              }
              if (ue && !l && !r) {
                var C = s.hasAttribute("data-slate-node") ? s : s.closest("[data-slate-node]");
                if (C && we.hasDOMNode(e, C, {
                  editable: !0
                })) {
                  var S = we.toSlateNode(e, C),
                    {
                      path: E,
                      offset: _
                    } = v.ML.start(e, we.findPath(e, S));
                  return C.querySelector("[data-slate-leaf]") || (_ = a), {
                    path: E,
                    offset: _
                  };
                }
              }
              if (!l) {
                if (o) return null;
                throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
              }
              var P = we.toSlateNode(e, l);
              return {
                path: we.findPath(e, P),
                offset: u
              };
            },
            toSlateRange(e, t, n) {
              var r,
                o,
                i,
                a,
                s,
                {
                  exactMatch: l,
                  suppressThrow: u
                } = n;
              if ((Q(t) ? t.anchorNode : t.startContainer) && (Q(t) ? (r = t.anchorNode, o = t.anchorOffset, i = t.focusNode, a = t.focusOffset, s = he && (e => {
                for (var t = e && e.parentNode; t;) {
                  if ("[object ShadowRoot]" === t.toString()) return !0;
                  t = t.parentNode;
                }
                return !1;
              })(r) ? t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : t.isCollapsed) : (r = t.startContainer, o = t.startOffset, i = t.endContainer, a = t.endOffset, s = t.collapsed)), null == r || null == i || null == o || null == a) throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
              var c = we.toSlatePoint(e, [r, o], {
                exactMatch: l,
                suppressThrow: u
              });
              if (!c) return null;
              var d = s ? c : we.toSlatePoint(e, [i, a], {
                exactMatch: l,
                suppressThrow: u
              });
              if (!d) return null;
              if (ce && !s && r !== i) {
                var p = v.ML.isEnd(e, c, c.path),
                  h = v.ML.isStart(e, d, d.path);
                if (p) c = v.ML.after(e, c) || c;
                if (h) d = v.ML.before(e, d) || d;
              }
              var f = {
                anchor: c,
                focus: d
              };
              return v.e6.isExpanded(f) && v.e6.isForward(f) && Y(i) && v.ML.void(e, {
                at: f.focus,
                mode: "highest"
              }) && (f = v.ML.unhangRange(e, f, {
                voids: !0
              })), f;
            },
            hasRange(e, t) {
              var {
                anchor: n,
                focus: r
              } = t;
              return v.ML.hasPath(e, n.path) && v.ML.hasPath(e, r.path);
            },
            hasTarget: (e, t) => X(t) && we.hasDOMNode(e, t),
            hasEditableTarget: (e, t) => X(t) && we.hasDOMNode(e, t, {
              editable: !0
            }),
            hasSelectableTarget: (e, t) => we.hasEditableTarget(e, t) || we.isTargetInsideNonReadonlyVoid(e, t),
            isTargetInsideNonReadonlyVoid(e, t) {
              if (F.get(e)) return !1;
              var n = we.hasTarget(e, t) && we.toSlateNode(e, t);
              return v.W_.isElement(n) && v.ML.isVoid(e, n);
            },
            androidScheduleFlush(e) {
              var t;
              null === (t = N.get(e)) || void 0 === t || t();
            },
            androidPendingDiffs: e => K.get(e)
          },
          xe = ye ? u.useLayoutEffect : u.useEffect,
          De = ["anchor", "focus"],
          Ce = ["anchor", "focus"],
          Se = (e, t) => {
            var n,
              r,
              o = D(e, De),
              i = D(t, Ce);
            return e[Z] === t[Z] && (n = o, r = i, Object.keys(n).length === Object.keys(r).length && Object.keys(n).every(e => r.hasOwnProperty(e) && n[e] === r[e]));
          };
        function Ee(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var _e = e => {
            var {
                isLast: t,
                leaf: n,
                parent: r,
                text: o
              } = e,
              i = ze(),
              a = we.findPath(i, o),
              s = v.y$.parent(a),
              l = !0 === n[$];
            return i.isVoid(r) ? u.createElement(ke, {
              length: v.NB.string(r).length
            }) : "" !== n.text || r.children[r.children.length - 1] !== o || i.isInline(r) || "" !== v.ML.string(i, s) ? "" === n.text ? u.createElement(ke, {
              isMarkPlaceholder: l
            }) : t && "\n" === n.text.slice(-1) ? u.createElement(Pe, {
              isTrailing: !0,
              text: n.text
            }) : u.createElement(Pe, {
              text: n.text
            }) : u.createElement(ke, {
              isLineBreak: !0,
              isMarkPlaceholder: l
            });
          },
          Pe = e => {
            var {
                text: t,
                isTrailing: n = !1
              } = e,
              r = (0, u.useRef)(null),
              o = () => "".concat(null != t ? t : "").concat(n ? "\n" : "");
            return xe(() => {
              var e = o();
              r.current && r.current.textContent !== e && (r.current.textContent = e);
            }), r.current ? u.createElement("span", {
              "data-slate-string": !0,
              ref: r
            }) : u.createElement("span", {
              "data-slate-string": !0,
              ref: r
            }, o());
          },
          ke = e => {
            var {
                length: t = 0,
                isLineBreak: n = !1,
                isMarkPlaceholder: r = !1
              } = e,
              o = {
                "data-slate-zero-width": n ? "n" : "z",
                "data-slate-length": t
              };
            return r && (o["data-slate-mark-placeholder"] = !0), u.createElement("span", function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? Ee(Object(n), !0).forEach(function (t) {
                  x(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ee(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({}, o), ue && n ? null : "\ufeff", n ? u.createElement("br", null) : null);
          },
          Ae = (0, u.createContext)(null),
          ze = () => {
            var e = (0, u.useContext)(Ae);
            if (!e) throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
            return e;
          };
        function Te(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Oe(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Te(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Te(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ie = e => {
            var {
                leaf: t,
                isLast: n,
                text: r,
                parent: o,
                renderPlaceholder: i,
                renderLeaf: a = e => u.createElement(Me, Oe({}, e))
              } = e,
              s = (0, u.useRef)(null),
              l = (0, u.useRef)(null),
              c = ze(),
              d = (0, u.useRef)(null);
            (0, u.useEffect)(() => () => {
              d.current && d.current.disconnect();
            }, []), (0, u.useEffect)(() => {
              var e = null == l ? void 0 : l.current;
              if (e ? A.set(c, e) : A.delete(c), d.current) d.current.disconnect(), e && d.current.observe(e);else if (e) {
                var t = window.ResizeObserver || y.do;
                d.current = new t(() => {
                  var e = U.get(c);
                  null == e || e();
                }), d.current.observe(e);
              }
              if (!e && s.current) {
                var n = U.get(c);
                null == n || n();
              }
              return s.current = l.current, () => {
                A.delete(c);
              };
            }, [l, t]);
            var p = u.createElement(_e, {
              isLast: n,
              leaf: t,
              parent: o,
              text: r
            });
            if (t[Z]) {
              var h = {
                children: t.placeholder,
                attributes: {
                  "data-slate-placeholder": !0,
                  style: {
                    position: "absolute",
                    pointerEvents: "none",
                    width: "100%",
                    maxWidth: "100%",
                    display: "block",
                    opacity: "0.333",
                    userSelect: "none",
                    textDecoration: "none"
                  },
                  contentEditable: !1,
                  ref: l
                }
              };
              p = u.createElement(u.Fragment, null, i(h), p);
            }
            return a({
              attributes: {
                "data-slate-leaf": !0
              },
              children: p,
              leaf: t,
              text: r
            });
          },
          Fe = u.memo(Ie, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && v.xv.equals(t.leaf, e.leaf) && t.leaf[Z] === e.leaf[Z]),
          Me = e => {
            var {
              attributes: t,
              children: n
            } = e;
            return u.createElement("span", Oe({}, t), n);
          },
          Re = e => {
            for (var {
                decorations: t,
                isLast: n,
                parent: r,
                renderPlaceholder: o,
                renderLeaf: i,
                text: a
              } = e, s = ze(), l = (0, u.useRef)(null), c = v.xv.decorations(a, t), d = we.findKey(s, a), p = [], h = 0; h < c.length; h++) {
              var f = c[h];
              p.push(u.createElement(Fe, {
                isLast: n && h === c.length - 1,
                key: "".concat(d.id, "-").concat(h),
                renderPlaceholder: o,
                leaf: f,
                text: a,
                parent: r,
                renderLeaf: i
              }));
            }
            return xe(() => {
              var e = I.get(s);
              l.current ? (null == e || e.set(d, l.current), T.set(a, l.current), z.set(l.current, a)) : (null == e || e.delete(d), T.delete(a));
            }), u.createElement("span", {
              "data-slate-node": "text",
              ref: l
            }, p);
          },
          je = u.memo(Re, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.text === e.text && ((e, t) => {
            if (e.length !== t.length) return !1;
            for (var n = 0; n < e.length; n++) {
              var r = e[n],
                o = t[n];
              if (r.anchor.offset !== o.anchor.offset || r.focus.offset !== o.focus.offset || !Se(r, o)) return !1;
            }
            return !0;
          })(t.decorations, e.decorations));
        function Be(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ne(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Be(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Be(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Le = e => {
            var {
                decorations: t,
                element: n,
                renderElement: r = e => u.createElement(Ke, Ne({}, e)),
                renderPlaceholder: i,
                renderLeaf: a,
                selection: s
              } = e,
              l = ze(),
              c = $e(),
              d = l.isInline(n),
              p = we.findKey(l, n),
              h = (0, u.useCallback)(e => {
                var t = I.get(l);
                e ? (null == t || t.set(p, e), T.set(n, e), z.set(e, n)) : (null == t || t.delete(p), T.delete(n));
              }, [l, p, n]),
              f = Ue({
                decorations: t,
                node: n,
                renderElement: r,
                renderPlaceholder: i,
                renderLeaf: a,
                selection: s
              }),
              m = {
                "data-slate-node": "element",
                ref: h
              };
            if (d && (m["data-slate-inline"] = !0), !d && v.ML.hasInlines(l, n)) {
              var g = v.NB.string(n),
                y = o()(g);
              "rtl" === y && (m.dir = y);
            }
            if (v.ML.isVoid(l, n)) {
              m["data-slate-void"] = !0, !c && d && (m.contentEditable = !1);
              var b = d ? "span" : "div",
                [[w]] = v.NB.texts(n);
              f = u.createElement(b, {
                "data-slate-spacer": !0,
                style: {
                  height: "0",
                  color: "transparent",
                  outline: "none",
                  position: "absolute"
                }
              }, u.createElement(je, {
                renderPlaceholder: i,
                decorations: [],
                isLast: !1,
                parent: n,
                text: w
              })), E.set(w, 0), _.set(w, n);
            }
            return r({
              attributes: m,
              children: f,
              element: n
            });
          },
          Ve = u.memo(Le, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && ((e, t) => {
            if (e.length !== t.length) return !1;
            for (var n = 0; n < e.length; n++) {
              var r = e[n],
                o = t[n];
              if (!v.e6.equals(r, o) || !Se(r, o)) return !1;
            }
            return !0;
          })(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && v.e6.equals(e.selection, t.selection))),
          Ke = e => {
            var {
                attributes: t,
                children: n,
                element: r
              } = e,
              o = ze().isInline(r) ? "span" : "div";
            return u.createElement(o, Ne(Ne({}, t), {}, {
              style: {
                position: "relative"
              }
            }), n);
          },
          qe = (0, u.createContext)(() => []),
          He = (0, u.createContext)(!1),
          Ue = e => {
            for (var {
                decorations: t,
                node: n,
                renderElement: r,
                renderPlaceholder: o,
                renderLeaf: i,
                selection: a
              } = e, s = (0, u.useContext)(qe), l = ze(), c = we.findPath(l, n), d = [], p = v.W_.isElement(n) && !l.isInline(n) && v.ML.hasInlines(l, n), h = 0; h < n.children.length; h++) {
              var f = c.concat(h),
                m = n.children[h],
                g = we.findKey(l, m),
                y = v.ML.range(l, f),
                b = a && v.e6.intersection(y, a),
                w = s([m, f]);
              for (var x of t) {
                var D = v.e6.intersection(x, y);
                D && w.push(D);
              }
              v.W_.isElement(m) ? d.push(u.createElement(He.Provider, {
                key: "provider-".concat(g.id),
                value: !!b
              }, u.createElement(Ve, {
                decorations: w,
                element: m,
                key: g.id,
                renderElement: r,
                renderPlaceholder: o,
                renderLeaf: i,
                selection: b
              }))) : d.push(u.createElement(je, {
                decorations: w,
                key: g.id,
                isLast: p && h === n.children.length - 1,
                parent: n,
                renderPlaceholder: o,
                renderLeaf: i,
                text: m
              })), E.set(m, h), _.set(m, n);
            }
            return d;
          },
          Ze = (0, u.createContext)(!1),
          $e = () => (0, u.useContext)(Ze),
          Ge = (0, u.createContext)(null),
          We = {
            bold: "mod+b",
            compose: ["down", "left", "right", "up", "backspace", "enter"],
            moveBackward: "left",
            moveForward: "right",
            moveWordBackward: "ctrl+left",
            moveWordForward: "ctrl+right",
            deleteBackward: "shift?+backspace",
            deleteForward: "shift?+delete",
            extendBackward: "shift+left",
            extendForward: "shift+right",
            extendWordBackward: "opt+shift+left",
            italic: "mod+i",
            insertSoftBreak: "shift+enter",
            splitBlock: "enter",
            undo: "mod+z"
          },
          Ye = {
            moveLineBackward: "opt+up",
            moveLineForward: "opt+down",
            moveWordBackward: "opt+left",
            moveWordForward: "opt+right",
            deleteBackward: ["ctrl+backspace", "ctrl+h"],
            deleteForward: ["ctrl+delete", "ctrl+d"],
            deleteLineBackward: "cmd+shift?+backspace",
            deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
            deleteWordBackward: "opt+shift?+backspace",
            deleteWordForward: "opt+shift?+delete",
            extendLineBackward: "opt+shift+up",
            extendLineForward: "opt+shift+down",
            extendWordBackward: "opt+shift+left",
            redo: "cmd+shift+z",
            transposeCharacter: "ctrl+t"
          },
          Xe = {
            deleteWordBackward: "ctrl+shift?+backspace",
            deleteWordForward: "ctrl+shift?+delete",
            redo: ["ctrl+y", "ctrl+shift+z"]
          },
          Qe = e => {
            var t = We[e],
              n = Ye[e],
              r = Xe[e],
              o = t && (0, b.TB)(t),
              i = n && (0, b.TB)(n),
              a = r && (0, b.TB)(r);
            return e => !(!o || !o(e)) || !!(le && i && i(e)) || !(le || !a || !a(e));
          },
          Je = {
            isBold: Qe("bold"),
            isCompose: Qe("compose"),
            isMoveBackward: Qe("moveBackward"),
            isMoveForward: Qe("moveForward"),
            isDeleteBackward: Qe("deleteBackward"),
            isDeleteForward: Qe("deleteForward"),
            isDeleteLineBackward: Qe("deleteLineBackward"),
            isDeleteLineForward: Qe("deleteLineForward"),
            isDeleteWordBackward: Qe("deleteWordBackward"),
            isDeleteWordForward: Qe("deleteWordForward"),
            isExtendBackward: Qe("extendBackward"),
            isExtendForward: Qe("extendForward"),
            isExtendLineBackward: Qe("extendLineBackward"),
            isExtendLineForward: Qe("extendLineForward"),
            isExtendWordBackward: Qe("extendWordBackward"),
            isItalic: Qe("italic"),
            isMoveLineBackward: Qe("moveLineBackward"),
            isMoveLineForward: Qe("moveLineForward"),
            isMoveWordBackward: Qe("moveWordBackward"),
            isMoveWordForward: Qe("moveWordForward"),
            isRedo: Qe("redo"),
            isSoftBreak: Qe("insertSoftBreak"),
            isSplitBlock: Qe("splitBlock"),
            isTransposeCharacter: Qe("transposeCharacter"),
            isUndo: Qe("undo")
          },
          et = {
            subtree: !0,
            childList: !0,
            characterData: !0,
            characterDataOldValue: !0
          };
        class tt extends u.Component {
          constructor() {
            super(...arguments), x(this, "context", null), x(this, "manager", null), x(this, "mutationObserver", null);
          }
          observe() {
            var e,
              {
                node: t
              } = this.props;
            if (!t.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
            null === (e = this.mutationObserver) || void 0 === e || e.observe(t.current, et);
          }
          componentDidMount() {
            var {
                receivedUserInput: e
              } = this.props,
              t = this.context;
            this.manager = ((e, t) => {
              var n = [],
                r = () => {
                  n = [];
                };
              return {
                registerMutations: r => {
                  if (t.current) {
                    var o = r.filter(t => ie(e, t, r));
                    n.push(...o);
                  }
                },
                restoreDOM: function () {
                  n.reverse().forEach(e => {
                    "characterData" !== e.type ? (e.removedNodes.forEach(t => {
                      e.target.insertBefore(t, e.nextSibling);
                    }), e.addedNodes.forEach(t => {
                      e.target.removeChild(t);
                    })) : e.target.textContent = e.oldValue;
                  }), r();
                },
                clear: r
              };
            })(t, e), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
          }
          getSnapshotBeforeUpdate() {
            var e,
              t,
              n,
              r,
              o = null === (e = this.mutationObserver) || void 0 === e ? void 0 : e.takeRecords();
            null != o && o.length && (null === (r = this.manager) || void 0 === r || r.registerMutations(o));
            return null === (t = this.mutationObserver) || void 0 === t || t.disconnect(), null === (n = this.manager) || void 0 === n || n.restoreDOM(), null;
          }
          componentDidUpdate() {
            var e;
            null === (e = this.manager) || void 0 === e || e.clear(), this.observe();
          }
          componentWillUnmount() {
            var e;
            null === (e = this.mutationObserver) || void 0 === e || e.disconnect();
          }
          render() {
            return this.props.children;
          }
        }
        x(tt, "contextType", Ae);
        var nt = ue ? tt : e => {
          var {
            children: t
          } = e;
          return u.createElement(u.Fragment, null, t);
        };
        function rt(e, t) {
          var {
            path: n,
            diff: r
          } = t;
          if (!v.ML.hasPath(e, n)) return !1;
          var o = v.NB.get(e, n);
          if (!v.xv.isText(o)) return !1;
          if (r.start !== o.text.length || 0 === r.text.length) return o.text.slice(r.start, r.start + r.text.length) === r.text;
          var i = v.y$.next(n);
          if (!v.ML.hasPath(e, i)) return !1;
          var a = v.NB.get(e, i);
          return v.xv.isText(a) && a.text.startsWith(r.text);
        }
        function ot(e, t) {
          var {
              start: n,
              end: r,
              text: o
            } = t,
            i = e.slice(n, r),
            a = function (e, t) {
              for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) if (e.charAt(r) !== t.charAt(r)) return r;
              return n;
            }(i, o),
            s = function (e, t, n) {
              for (var r = Math.min(e.length, t.length, n), o = 0; o < r; o++) if (e.charAt(e.length - o - 1) !== t.charAt(t.length - o - 1)) return o;
              return r;
            }(i, o, Math.min(i.length - a, o.length - a)),
            l = {
              start: n + a,
              end: r - s,
              text: o.slice(a, o.length - s)
            };
          return l.start === l.end && 0 === l.text.length ? null : l;
        }
        function it(e, t, n) {
          var r = Math.min(t.start, n.start),
            o = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start),
            i = function (e) {
              for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
              return n.reduce((e, t) => e.slice(0, t.start) + t.text + e.slice(t.end), e);
            }(e, t, n),
            a = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - o),
            s = i.slice(r, a);
          return ot(e, {
            start: r,
            end: Math.max(t.end, n.end - t.text.length + (t.end - t.start)),
            text: s
          });
        }
        function at(e) {
          var {
            path: t,
            diff: n
          } = e;
          return {
            anchor: {
              path: t,
              offset: n.start
            },
            focus: {
              path: t,
              offset: n.end
            }
          };
        }
        function st(e, t) {
          var {
            path: n,
            offset: r
          } = t;
          if (!v.ML.hasPath(e, n)) return null;
          var o = v.NB.get(e, n);
          if (!v.xv.isText(o)) return null;
          var i = v.ML.above(e, {
            match: t => v.W_.isElement(t) && v.ML.isBlock(e, t),
            at: n
          });
          if (!i) return null;
          for (; r > o.text.length;) {
            var a = v.ML.next(e, {
              at: n,
              match: v.xv.isText
            });
            if (!a || !v.y$.isDescendant(a[1], i[1])) return null;
            r -= o.text.length, o = a[0], n = a[1];
          }
          return {
            path: n,
            offset: r
          };
        }
        function lt(e, t) {
          var n = st(e, t.anchor);
          if (!n) return null;
          if (v.e6.isCollapsed(t)) return {
            anchor: n,
            focus: n
          };
          var r = st(e, t.focus);
          return r ? {
            anchor: n,
            focus: r
          } : null;
        }
        function ut(e, t, n) {
          var r = K.get(e),
            o = null == r ? void 0 : r.find(e => {
              var {
                path: n
              } = e;
              return v.y$.equals(n, t.path);
            });
          if (!o || t.offset <= o.diff.start) return v.E9.transform(t, n, {
            affinity: "backward"
          });
          var {
            diff: i
          } = o;
          if (t.offset <= i.start + i.text.length) {
            var a = {
                path: t.path,
                offset: i.start
              },
              s = v.E9.transform(a, n, {
                affinity: "backward"
              });
            return s ? {
              path: s.path,
              offset: s.offset + t.offset - i.start
            } : null;
          }
          var l = {
              path: t.path,
              offset: t.offset - i.text.length + i.end - i.start
            },
            u = v.E9.transform(l, n, {
              affinity: "backward"
            });
          return u ? "split_node" === n.type && v.y$.equals(n.path, t.path) && l.offset < n.position && i.start < n.position ? u : {
            path: u.path,
            offset: u.offset + i.text.length - i.end + i.start
          } : null;
        }
        function ct(e, t, n) {
          var r = ut(e, t.anchor, n);
          if (!r) return null;
          if (v.e6.isCollapsed(t)) return {
            anchor: r,
            focus: r
          };
          var o = ut(e, t.focus, n);
          return o ? {
            anchor: r,
            focus: o
          } : null;
        }
        function dt(e, t) {
          var {
            path: n,
            diff: r,
            id: o
          } = e;
          switch (t.type) {
            case "insert_text":
              return !v.y$.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
                diff: {
                  start: t.text.length + r.start,
                  end: t.text.length + r.end,
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start,
                  end: r.end + t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              };
            case "remove_text":
              return !v.y$.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
                diff: {
                  start: r.start - t.text.length,
                  end: r.end - t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start,
                  end: r.end - t.text.length,
                  text: r.text
                },
                id: o,
                path: n
              };
            case "split_node":
              return !v.y$.equals(t.path, n) || t.position >= r.end ? {
                diff: r,
                id: o,
                path: v.y$.transform(n, t, {
                  affinity: "backward"
                })
              } : t.position > r.start ? {
                diff: {
                  start: r.start,
                  end: Math.min(t.position, r.end),
                  text: r.text
                },
                id: o,
                path: n
              } : {
                diff: {
                  start: r.start - t.position,
                  end: r.end - t.position,
                  text: r.text
                },
                id: o,
                path: v.y$.transform(n, t, {
                  affinity: "forward"
                })
              };
            case "merge_node":
              return v.y$.equals(t.path, n) ? {
                diff: {
                  start: r.start + t.position,
                  end: r.end + t.position,
                  text: r.text
                },
                id: o,
                path: v.y$.transform(n, t)
              } : {
                diff: r,
                id: o,
                path: v.y$.transform(n, t)
              };
          }
          var i = v.y$.transform(n, t);
          return i ? {
            diff: r,
            path: i,
            id: o
          } : null;
        }
        function pt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ht(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? pt(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        function ft(e) {
          var {
              editor: t,
              scheduleOnDOMSelectionChange: n,
              onDOMSelectionChange: r
            } = e,
            o = !1,
            i = null,
            a = null,
            s = null,
            l = 0,
            u = !1,
            c = () => {
              var e = H.get(t);
              if (H.delete(t), e) {
                var {
                    selection: n
                  } = t,
                  r = lt(t, e);
                !r || n && v.e6.equals(r, n) || v.YR.select(t, r);
              }
            },
            d = () => {
              var e;
              if (a && (clearTimeout(a), a = null), s && (clearTimeout(s), s = null), g() || m()) {
                o || (o = !0, setTimeout(() => o = !1)), m() && (o = "action");
                var i = t.selection && v.ML.rangeRef(t, t.selection, {
                  affinity: "forward"
                });
                V.set(t, t.marks), q.get(t), K.get(t);
                for (var l, d = !(null === (e = K.get(t)) || void 0 === e || !e.length); l = null === (p = K.get(t)) || void 0 === p ? void 0 : p[0];) {
                  var p,
                    h,
                    f = L.get(t);
                  void 0 !== f && (L.delete(t), t.marks = f), f && !1 === u && (u = null);
                  var y = at(l);
                  t.selection && v.e6.equals(t.selection, y) || v.YR.select(t, y), l.diff.text ? v.ML.insertText(t, l.diff.text) : v.ML.deleteFragment(t), K.set(t, null === (h = K.get(t)) || void 0 === h ? void 0 : h.filter(e => {
                    var {
                      id: t
                    } = e;
                    return t !== l.id;
                  })), rt(t, l) || (d = !1, q.delete(t), V.delete(t), o = "action", H.delete(t), n.cancel(), r.cancel(), null == i || i.unref());
                }
                var b = null == i ? void 0 : i.unref();
                if (!b || H.get(t) || t.selection && v.e6.equals(b, t.selection) || v.YR.select(t, b), m()) (() => {
                  var e = q.get(t);
                  if (q.delete(t), e) {
                    if (e.at) {
                      var n = v.E9.isPoint(e.at) ? st(t, e.at) : lt(t, e.at);
                      if (!n) return;
                      var r = v.ML.range(t, n);
                      t.selection && v.e6.equals(t.selection, r) || v.YR.select(t, n);
                    }
                    e.run();
                  }
                })();else {
                  d && n(), n.flush(), r.flush(), c();
                  var w = V.get(t);
                  V.delete(t), void 0 !== w && (t.marks = w, t.onChange());
                }
              } else c();
            },
            p = function () {
              var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                n = A.get(t);
              n && (g() || e ? n.style.display = "none" : n.style.removeProperty("display"));
            },
            h = (e, n) => {
              var r,
                o = null !== (r = K.get(t)) && void 0 !== r ? r : [];
              K.set(t, o);
              var i = v.NB.leaf(t, e),
                a = o.findIndex(t => v.y$.equals(t.path, e));
              if (a < 0) return ot(i.text, n) && o.push({
                path: e,
                diff: n,
                id: l++
              }), void p();
              var s = it(i.text, o[a].diff, n);
              if (!s) return o.splice(a, 1), void p();
              o[a] = ht(ht({}, o[a]), {}, {
                diff: s
              });
            },
            f = function (e) {
              var {
                at: o
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              u = !1, H.delete(t), n.cancel(), r.cancel(), m() && d(), q.set(t, {
                at: o,
                run: e
              }), s = setTimeout(d);
            },
            m = () => !!q.get(t),
            g = () => {
              var e;
              return !(null === (e = K.get(t)) || void 0 === e || !e.length);
            },
            y = e => {
              H.set(t, e), a && (clearTimeout(a), a = null);
              var {
                selection: n
              } = t;
              if (e) {
                var r = !n || !v.y$.equals(n.anchor.path, e.anchor.path),
                  o = !n || !v.y$.equals(n.anchor.path.slice(0, -1), e.anchor.path.slice(0, -1));
                (r && u || o) && (u = !1), !r && g() || (a = setTimeout(d, 200));
              }
            },
            b = () => {
              m() || (s = setTimeout(d));
            };
          return {
            flush: d,
            scheduleFlush: b,
            hasPendingDiffs: g,
            hasPendingAction: m,
            hasPendingChanges: () => m() || g(),
            isFlushing: () => o,
            handleUserSelect: y,
            handleCompositionEnd: e => {
              i && clearTimeout(i), i = setTimeout(() => {
                R.set(t, !1), d();
              }, 25);
            },
            handleCompositionStart: e => {
              R.set(t, !0), i && (clearTimeout(i), i = null);
            },
            handleDOMBeforeInput: e => {
              var n;
              a && (clearTimeout(a), a = null);
              var {
                  inputType: r
                } = e,
                o = null,
                i = e.dataTransfer || e.data || void 0;
              !1 !== u && "insertText" !== r && "insertCompositionText" !== r && (u = !1);
              var [s] = e.getTargetRanges();
              s && (o = we.toSlateRange(t, s, {
                exactMatch: !1,
                suppressThrow: !0
              }));
              var l = we.getWindow(t).getSelection();
              if (!o && l && (s = l, o = we.toSlateRange(t, l, {
                exactMatch: !1,
                suppressThrow: !0
              })), o = null !== (n = o) && void 0 !== n ? n : t.selection) {
                if (v.e6.isExpanded(o) && r.startsWith("delete")) {
                  var [c, d] = v.e6.edges(o);
                  if (v.NB.leaf(t, c.path).text.length === c.offset && 0 === d.offset) {
                    var p = v.ML.next(t, {
                      at: c.path,
                      match: v.xv.isText
                    });
                    p && v.y$.equals(p[1], d.path) && (o = {
                      anchor: d,
                      focus: d
                    });
                  }
                }
                if (v.e6.isExpanded(o) && r.startsWith("delete")) {
                  if (v.y$.equals(o.anchor.path, o.focus.path)) {
                    var [m, g] = v.e6.edges(o),
                      w = {
                        path: o.anchor.path,
                        offset: m.offset
                      },
                      x = v.ML.range(t, w, w);
                    return y(x), h(o.anchor.path, {
                      text: "",
                      end: g.offset,
                      start: m.offset
                    });
                  }
                  var D = r.endsWith("Backward") ? "backward" : "forward";
                  return f(() => v.ML.deleteFragment(t, {
                    direction: D
                  }), {
                    at: o
                  });
                }
                switch (r) {
                  case "deleteByComposition":
                  case "deleteByCut":
                  case "deleteByDrag":
                    return f(() => v.ML.deleteFragment(t), {
                      at: o
                    });
                  case "deleteContent":
                  case "deleteContentForward":
                    var {
                      anchor: C
                    } = o;
                    if (v.e6.isCollapsed(o)) {
                      var S = v.NB.leaf(t, C.path);
                      if (C.offset < S.text.length) return h(C.path, {
                        text: "",
                        start: C.offset,
                        end: C.offset + 1
                      });
                    }
                    return f(() => v.ML.deleteForward(t), {
                      at: o
                    });
                  case "deleteContentBackward":
                    var E,
                      {
                        anchor: _
                      } = o;
                    return (Q(s) ? s.isCollapsed : !(null === (E = s) || void 0 === E || !E.collapsed)) && v.e6.isCollapsed(o) && _.offset > 0 ? h(_.path, {
                      text: "",
                      start: _.offset - 1,
                      end: _.offset
                    }) : f(() => v.ML.deleteBackward(t), {
                      at: o
                    });
                  case "deleteEntireSoftLine":
                    return f(() => {
                      v.ML.deleteBackward(t, {
                        unit: "line"
                      }), v.ML.deleteForward(t, {
                        unit: "line"
                      });
                    }, {
                      at: o
                    });
                  case "deleteHardLineBackward":
                    return f(() => v.ML.deleteBackward(t, {
                      unit: "block"
                    }), {
                      at: o
                    });
                  case "deleteSoftLineBackward":
                    return f(() => v.ML.deleteBackward(t, {
                      unit: "line"
                    }), {
                      at: o
                    });
                  case "deleteHardLineForward":
                    return f(() => v.ML.deleteForward(t, {
                      unit: "block"
                    }), {
                      at: o
                    });
                  case "deleteSoftLineForward":
                    return f(() => v.ML.deleteForward(t, {
                      unit: "line"
                    }), {
                      at: o
                    });
                  case "deleteWordBackward":
                    return f(() => v.ML.deleteBackward(t, {
                      unit: "word"
                    }), {
                      at: o
                    });
                  case "deleteWordForward":
                    return f(() => v.ML.deleteForward(t, {
                      unit: "word"
                    }), {
                      at: o
                    });
                  case "insertLineBreak":
                    return f(() => v.ML.insertSoftBreak(t), {
                      at: o
                    });
                  case "insertParagraph":
                    return f(() => v.ML.insertBreak(t), {
                      at: o
                    });
                  case "insertCompositionText":
                  case "deleteCompositionText":
                  case "insertFromComposition":
                  case "insertFromDrop":
                  case "insertFromPaste":
                  case "insertFromYank":
                  case "insertReplacementText":
                  case "insertText":
                    if ("DataTransfer" === (null == i ? void 0 : i.constructor.name)) return f(() => we.insertData(t, i), {
                      at: o
                    });
                    if ("string" == typeof i && i.includes("\n")) return f(() => v.ML.insertSoftBreak(t), {
                      at: v.e6.end(o)
                    });
                    var P = null != i ? i : "";
                    if (L.get(t) && (P = P.replace("\ufeff", "")), v.y$.equals(o.anchor.path, o.focus.path)) {
                      var [k, A] = v.e6.edges(o),
                        z = {
                          start: k.offset,
                          end: A.offset,
                          text: P
                        };
                      if (P && u && "insertCompositionText" === r) {
                        var T = u.start + u.text.search(/\S|$/);
                        z.start + z.text.search(/\S|$/) === T + 1 && z.end === u.start + u.text.length ? (z.start -= 1, u = null, b()) : u = !1;
                      } else u = "insertText" === r && (null === u ? z : !(!u || !v.e6.isCollapsed(o) || u.end + u.text.length !== k.offset) && ht(ht({}, u), {}, {
                        text: u.text + P
                      }));
                      return void h(k.path, z);
                    }
                    return f(() => v.ML.insertText(t, P), {
                      at: o
                    });
                }
              }
            },
            handleKeyDown: e => {
              g() || (p(!0), setTimeout(p));
            },
            handleDomMutations: e => {
              var n;
              g() || m() || e.some(n => ie(t, n, e)) && (null === (n = U.get(t)) || void 0 === n || n());
            },
            handleInput: () => {
              !m() && g() || d();
            }
          };
        }
        var mt = ["node"];
        function gt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var vt = {
          subtree: !0,
          childList: !0,
          characterData: !0
        };
        function yt(e) {
          var {
              node: t
            } = e,
            n = D(e, mt);
          if (!ue) return null;
          var r,
            o = ze(),
            i = (r = (0, u.useRef)(!1), (0, u.useEffect)(() => (r.current = !0, () => {
              r.current = !1;
            }), []), r.current),
            [a] = (0, u.useState)(() => ft(function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? gt(Object(n), !0).forEach(function (t) {
                  x(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gt(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }
              return e;
            }({
              editor: o
            }, n)));
          return function (e, t, n) {
            var [r] = (0, u.useState)(() => new MutationObserver(t));
            xe(() => {
              r.takeRecords();
            }), (0, u.useEffect)(() => {
              if (!e.current) throw new Error("Failed to attach MutationObserver, `node` is undefined");
              return r.observe(e.current, n), () => r.disconnect();
            }, []);
          }(t, a.handleDomMutations, vt), N.set(o, a.scheduleFlush), i && a.flush(), a;
        }
        var bt = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"],
          wt = ["text"];
        function xt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Dt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? xt(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : xt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ct = e => u.createElement(u.Fragment, null, Ue(e)),
          St = e => {
            var t,
              n,
              {
                autoFocus: r,
                decorate: i = _t,
                onDOMBeforeInput: s,
                placeholder: c,
                readOnly: d = !1,
                renderElement: p,
                renderLeaf: h,
                renderPlaceholder: f = e => u.createElement(Et, Dt({}, e)),
                scrollSelectionIntoView: m = Pt,
                style: g = {},
                as: y = "div",
                disableDefaultStyles: b = !1
              } = e,
              w = D(e, bt),
              x = (() => {
                var e = (0, u.useContext)(Ge);
                if (!e) throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
                var {
                  editor: t
                } = e;
                return t;
              })(),
              [C, S] = (0, u.useState)(!1),
              E = (0, u.useRef)(null),
              _ = (0, u.useRef)([]),
              O = (0, u.useRef)(!1),
              {
                onUserInput: I,
                receivedUserInput: B
              } = function () {
                var e = ze(),
                  t = (0, u.useRef)(!1),
                  n = (0, u.useRef)(0),
                  r = (0, u.useCallback)(() => {
                    if (!t.current) {
                      t.current = !0;
                      var r = we.getWindow(e);
                      r.cancelAnimationFrame(n.current), n.current = r.requestAnimationFrame(() => {
                        t.current = !1;
                      });
                    }
                  }, []);
                return (0, u.useEffect)(() => () => cancelAnimationFrame(n.current), []), {
                  receivedUserInput: t,
                  onUserInput: r
                };
              }(),
              [, N] = (0, u.useReducer)(e => e + 1, 0);
            U.set(x, N), F.set(x, d);
            var K = (0, u.useMemo)(() => ({
              isDraggingInternally: !1,
              isUpdatingSelection: !1,
              latestElement: null,
              hasMarkPlaceholder: !1
            }), []);
            (0, u.useEffect)(() => {
              E.current && r && E.current.focus();
            }, [r]);
            var q = (0, u.useCallback)(l()(() => {
                var e = we.findDocumentOrShadowRoot(x),
                  t = navigator.userAgent.match(/Version\/(\d+\.\d+)/),
                  n = de && t && parseFloat(t[1]) < 17;
                if (!O.current && de && e instanceof ShadowRoot && n) return O.current = !0, function () {
                  for (var e = document.activeElement; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
                  return e;
                }() ? document.execCommand("indent") : v.YR.deselect(x), void (O.current = !1);
                if ((ue || !we.isComposing(x)) && (!K.isUpdatingSelection || null != G && G.isFlushing()) && !K.isDraggingInternally) {
                  var r = we.findDocumentOrShadowRoot(x),
                    {
                      activeElement: o
                    } = r,
                    i = we.toDOMNode(x, x),
                    a = r.getSelection();
                  if (o === i ? (K.latestElement = o, M.set(x, !0)) : M.delete(x), !a) return v.YR.deselect(x);
                  var {
                      anchorNode: s,
                      focusNode: l
                    } = a,
                    u = we.hasEditableTarget(x, s) || we.isTargetInsideNonReadonlyVoid(x, s),
                    c = we.hasEditableTarget(x, l) || we.isTargetInsideNonReadonlyVoid(x, l);
                  if (u && c) {
                    var p = we.toSlateRange(x, a, {
                      exactMatch: !1,
                      suppressThrow: !0
                    });
                    p && (we.isComposing(x) || null != G && G.hasPendingChanges() || null != G && G.isFlushing() ? null == G || G.handleUserSelect(p) : v.YR.select(x, p));
                  }
                  !d || u && c || v.YR.deselect(x);
                }
              }, 100), [d]),
              H = (0, u.useMemo)(() => a()(q, 0), [q]),
              G = yt({
                node: E,
                onDOMSelectionChange: q,
                scheduleOnDOMSelectionChange: H
              });
            xe(() => {
              var e;
              E.current && (e = W(E.current)) ? (P.set(x, e), k.set(x, E.current), T.set(x, E.current), z.set(E.current, x)) : T.delete(x);
              var {
                  selection: t
                } = x,
                n = we.findDocumentOrShadowRoot(x).getSelection();
              if (n && we.isFocused(x) && (null == G || !G.hasPendingAction())) {
                var r = e => {
                    var r = "None" !== n.type;
                    if (t || r) {
                      var o = k.get(x),
                        i = !1;
                      if (o.contains(n.anchorNode) && o.contains(n.focusNode) && (i = !0), r && i && t && !e) {
                        var a = we.toSlateRange(x, n, {
                          exactMatch: !0,
                          suppressThrow: !0
                        });
                        if (a && v.e6.equals(a, t)) {
                          var s;
                          if (!K.hasMarkPlaceholder) return;
                          var {
                            anchorNode: l
                          } = n;
                          if (null != l && null !== (s = l.parentElement) && void 0 !== s && s.hasAttribute("data-slate-mark-placeholder")) return;
                        }
                      }
                      if (!t || we.hasRange(x, t)) {
                        K.isUpdatingSelection = !0;
                        var u = t && we.toDOMRange(x, t);
                        return u ? (v.e6.isBackward(t) ? n.setBaseAndExtent(u.endContainer, u.endOffset, u.startContainer, u.startOffset) : n.setBaseAndExtent(u.startContainer, u.startOffset, u.endContainer, u.endOffset), m(x, u)) : n.removeAllRanges(), u;
                      }
                      x.selection = we.toSlateRange(x, n, {
                        exactMatch: !1,
                        suppressThrow: !0
                      });
                    }
                  },
                  o = r(),
                  i = "action" === (null == G ? void 0 : G.isFlushing());
                if (ue && i) {
                  var a = null,
                    s = requestAnimationFrame(() => {
                      if (i) {
                        var e = e => {
                          try {
                            we.toDOMNode(x, x).focus(), r(e);
                          } catch (e) {}
                        };
                        e(), a = setTimeout(() => {
                          e(!0), K.isUpdatingSelection = !1;
                        });
                      }
                    });
                  return () => {
                    cancelAnimationFrame(s), a && clearTimeout(a);
                  };
                }
                setTimeout(() => {
                  o && ce && we.toDOMNode(x, x).focus();
                  K.isUpdatingSelection = !1;
                });
              }
            });
            var Q = (0, u.useCallback)(e => {
              var t = we.findDocumentOrShadowRoot(x),
                n = navigator.userAgent.match(/Version\/(\d+\.\d+)/),
                r = de && n && parseFloat(n[1]) < 17;
              if (null != O && O.current && de && t instanceof ShadowRoot && r) {
                var o = e.getTargetRanges()[0],
                  i = new window.Range();
                i.setStart(o.startContainer, o.startOffset), i.setEnd(o.endContainer, o.endOffset);
                var a = we.toSlateRange(x, i, {
                  exactMatch: !1,
                  suppressThrow: !1
                });
                return v.YR.select(x, a), e.preventDefault(), void e.stopImmediatePropagation();
              }
              if (I(), !d && we.hasEditableTarget(x, e.target) && !At(e, s)) {
                var l;
                if (G) return G.handleDOMBeforeInput(e);
                H.flush(), q.flush();
                var {
                    selection: u
                  } = x,
                  {
                    inputType: c
                  } = e,
                  p = e.dataTransfer || e.data || void 0,
                  h = "insertCompositionText" === c || "deleteCompositionText" === c;
                if (h && we.isComposing(x)) return;
                var f = !1;
                if ("insertText" === c && u && v.e6.isCollapsed(u) && e.data && 1 === e.data.length && /[a-z ]/i.test(e.data) && 0 !== u.anchor.offset) {
                  var m, g;
                  f = !0, x.marks && (f = !1);
                  var {
                      anchor: y
                    } = u,
                    [b, w] = we.toDOMPoint(x, y),
                    D = null === (m = b.parentElement) || void 0 === m ? void 0 : m.closest("a"),
                    C = we.getWindow(x);
                  if (f && D && we.hasDOMNode(x, D)) {
                    var E,
                      P = null == C ? void 0 : C.document.createTreeWalker(D, NodeFilter.SHOW_TEXT).lastChild();
                    P === b && (null === (E = P.textContent) || void 0 === E ? void 0 : E.length) === w && (f = !1);
                  }
                  if (f && b.parentElement && "pre" === (null == C || null === (g = C.getComputedStyle(b.parentElement)) || void 0 === g ? void 0 : g.whiteSpace)) {
                    var k = v.ML.above(x, {
                      at: y.path,
                      match: e => v.W_.isElement(e) && v.ML.isBlock(x, e)
                    });
                    k && v.NB.string(k[0]).includes("\t") && (f = !1);
                  }
                }
                if (!c.startsWith("delete") || c.startsWith("deleteBy")) {
                  var [A] = e.getTargetRanges();
                  if (A) {
                    var z = we.toSlateRange(x, A, {
                      exactMatch: !1,
                      suppressThrow: !1
                    });
                    if (!u || !v.e6.equals(u, z)) {
                      f = !1;
                      var T = !h && x.selection && v.ML.rangeRef(x, x.selection);
                      v.YR.select(x, z), T && j.set(x, T);
                    }
                  }
                }
                if (h) return;
                if (f || e.preventDefault(), u && v.e6.isExpanded(u) && c.startsWith("delete")) {
                  var F = c.endsWith("Backward") ? "backward" : "forward";
                  return void v.ML.deleteFragment(x, {
                    direction: F
                  });
                }
                switch (c) {
                  case "deleteByComposition":
                  case "deleteByCut":
                  case "deleteByDrag":
                    v.ML.deleteFragment(x);
                    break;
                  case "deleteContent":
                  case "deleteContentForward":
                    v.ML.deleteForward(x);
                    break;
                  case "deleteContentBackward":
                    v.ML.deleteBackward(x);
                    break;
                  case "deleteEntireSoftLine":
                    v.ML.deleteBackward(x, {
                      unit: "line"
                    }), v.ML.deleteForward(x, {
                      unit: "line"
                    });
                    break;
                  case "deleteHardLineBackward":
                    v.ML.deleteBackward(x, {
                      unit: "block"
                    });
                    break;
                  case "deleteSoftLineBackward":
                    v.ML.deleteBackward(x, {
                      unit: "line"
                    });
                    break;
                  case "deleteHardLineForward":
                    v.ML.deleteForward(x, {
                      unit: "block"
                    });
                    break;
                  case "deleteSoftLineForward":
                    v.ML.deleteForward(x, {
                      unit: "line"
                    });
                    break;
                  case "deleteWordBackward":
                    v.ML.deleteBackward(x, {
                      unit: "word"
                    });
                    break;
                  case "deleteWordForward":
                    v.ML.deleteForward(x, {
                      unit: "word"
                    });
                    break;
                  case "insertLineBreak":
                    v.ML.insertSoftBreak(x);
                    break;
                  case "insertParagraph":
                    v.ML.insertBreak(x);
                    break;
                  case "insertFromComposition":
                  case "insertFromDrop":
                  case "insertFromPaste":
                  case "insertFromYank":
                  case "insertReplacementText":
                  case "insertText":
                    "insertFromComposition" === c && we.isComposing(x) && (S(!1), R.set(x, !1)), "DataTransfer" === (null == p ? void 0 : p.constructor.name) ? we.insertData(x, p) : "string" == typeof p && (f ? _.current.push(() => v.ML.insertText(x, p)) : v.ML.insertText(x, p));
                }
                var M = null === (l = j.get(x)) || void 0 === l ? void 0 : l.unref();
                j.delete(x), !M || x.selection && v.e6.equals(x.selection, M) || v.YR.select(x, M);
              }
            }, [d, s]);
            xe(() => (E.current && be && E.current.addEventListener("beforeinput", Q), () => {
              E.current && be && E.current.removeEventListener("beforeinput", Q);
            }), [Q]), xe(() => {
              var e = we.getWindow(x);
              return e.document.addEventListener("selectionchange", H), () => {
                e.document.removeEventListener("selectionchange", H);
              };
            }, [H]);
            var J = i([x, []]);
            if (c && 1 === x.children.length && 1 === Array.from(v.NB.texts(x)).length && "" === v.NB.string(x) && !C) {
              var ee = v.ML.start(x, []);
              J.push({
                [Z]: !0,
                placeholder: c,
                anchor: ee,
                focus: ee
              });
            }
            var {
              marks: te
            } = x;
            if (K.hasMarkPlaceholder = !1, x.selection && v.e6.isCollapsed(x.selection) && te) {
              var {
                  anchor: ne
                } = x.selection,
                re = v.NB.leaf(x, ne.path),
                oe = D(re, wt);
              if (!v.xv.equals(re, te, {
                loose: !0
              })) {
                K.hasMarkPlaceholder = !0;
                var ie = Object.fromEntries(Object.keys(oe).map(e => [e, null]));
                J.push(Dt(Dt(Dt({
                  [$]: !0
                }, ie), te), {}, {
                  anchor: ne,
                  focus: ne
                }));
              }
            }
            (0, u.useEffect)(() => {
              setTimeout(() => {
                var {
                  selection: e
                } = x;
                if (e) {
                  var {
                      anchor: t
                    } = e,
                    n = v.NB.leaf(x, t.path);
                  if (te && !v.xv.equals(n, te, {
                    loose: !0
                  })) return void L.set(x, te);
                }
                L.delete(x);
              });
            });
            var ae = null === (t = A.get(x)) || void 0 === t || null === (n = t.getBoundingClientRect()) || void 0 === n ? void 0 : n.height;
            return u.createElement(Ze.Provider, {
              value: d
            }, u.createElement(qe.Provider, {
              value: i
            }, u.createElement(nt, {
              node: E,
              receivedUserInput: B
            }, u.createElement(y, Dt(Dt({
              role: d ? void 0 : "textbox",
              "aria-multiline": !d || void 0
            }, w), {}, {
              spellCheck: !(!be && ye) && w.spellCheck,
              autoCorrect: be || !ye ? w.autoCorrect : "false",
              autoCapitalize: be || !ye ? w.autoCapitalize : "false",
              "data-slate-editor": !0,
              "data-slate-node": "value",
              contentEditable: !d,
              zindex: -1,
              suppressContentEditableWarning: !0,
              ref: E,
              style: Dt(Dt({}, b ? {} : Dt({
                position: "relative",
                outline: "none",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word"
              }, ae ? {
                minHeight: ae
              } : {})), g),
              onBeforeInput: (0, u.useCallback)(e => {
                if (!be && !d && !kt(e, w.onBeforeInput) && we.hasSelectableTarget(x, e.target) && (e.preventDefault(), !we.isComposing(x))) {
                  var t = e.data;
                  v.ML.insertText(x, t);
                }
              }, [d]),
              onInput: (0, u.useCallback)(e => {
                if (G) G.handleInput();else {
                  for (var t of _.current) t();
                  _.current = [];
                }
              }, []),
              onBlur: (0, u.useCallback)(e => {
                if (!d && !K.isUpdatingSelection && we.hasSelectableTarget(x, e.target) && !kt(e, w.onBlur)) {
                  var t = we.findDocumentOrShadowRoot(x);
                  if (K.latestElement !== t.activeElement) {
                    var {
                      relatedTarget: n
                    } = e;
                    if (!(n === we.toDOMNode(x, x) || Y(n) && n.hasAttribute("data-slate-spacer"))) {
                      if (null != n && X(n) && we.hasDOMNode(x, n)) {
                        var r = we.toSlateNode(x, n);
                        if (v.W_.isElement(r) && !x.isVoid(r)) return;
                      }
                      if (de) {
                        var o = t.getSelection();
                        null == o || o.removeAllRanges();
                      }
                      M.delete(x);
                    }
                  }
                }
              }, [d, w.onBlur]),
              onClick: (0, u.useCallback)(e => {
                if (we.hasTarget(x, e.target) && !kt(e, w.onClick) && X(e.target)) {
                  var t = we.toSlateNode(x, e.target),
                    n = we.findPath(x, t);
                  if (!v.ML.hasPath(x, n) || v.NB.get(x, n) !== t) return;
                  if (3 === e.detail && n.length >= 1) {
                    var r = n;
                    if (!v.W_.isElement(t) || !v.ML.isBlock(x, t)) {
                      var o,
                        i = v.ML.above(x, {
                          match: e => v.W_.isElement(e) && v.ML.isBlock(x, e),
                          at: n
                        });
                      r = null !== (o = null == i ? void 0 : i[1]) && void 0 !== o ? o : n.slice(0, 1);
                    }
                    var a = v.ML.range(x, r);
                    return void v.YR.select(x, a);
                  }
                  if (d) return;
                  var s = v.ML.start(x, n),
                    l = v.ML.end(x, n),
                    u = v.ML.void(x, {
                      at: s
                    }),
                    c = v.ML.void(x, {
                      at: l
                    });
                  if (u && c && v.y$.equals(u[1], c[1])) {
                    var p = v.ML.range(x, s);
                    v.YR.select(x, p);
                  }
                }
              }, [d, w.onClick]),
              onCompositionEnd: (0, u.useCallback)(e => {
                if (we.hasSelectableTarget(x, e.target)) {
                  if (we.isComposing(x) && (S(!1), R.set(x, !1)), null == G || G.handleCompositionEnd(e), kt(e, w.onCompositionEnd) || ue) return;
                  if (!de && !me && !se && !ve && !ge && e.data) {
                    var t = L.get(x);
                    L.delete(x), void 0 !== t && (V.set(x, x.marks), x.marks = t), v.ML.insertText(x, e.data);
                    var n = V.get(x);
                    V.delete(x), void 0 !== n && (x.marks = n);
                  }
                }
              }, [w.onCompositionEnd]),
              onCompositionUpdate: (0, u.useCallback)(e => {
                we.hasSelectableTarget(x, e.target) && !kt(e, w.onCompositionUpdate) && (we.isComposing(x) || (S(!0), R.set(x, !0)));
              }, [w.onCompositionUpdate]),
              onCompositionStart: (0, u.useCallback)(e => {
                if (we.hasSelectableTarget(x, e.target)) {
                  if (null == G || G.handleCompositionStart(e), kt(e, w.onCompositionStart) || ue) return;
                  S(!0);
                  var {
                    selection: t
                  } = x;
                  if (t) {
                    if (v.e6.isExpanded(t)) return void v.ML.deleteFragment(x);
                    var n = v.ML.above(x, {
                      match: e => v.W_.isElement(e) && v.ML.isInline(x, e),
                      mode: "highest"
                    });
                    if (n) {
                      var [, r] = n;
                      if (v.ML.isEnd(x, t.anchor, r)) {
                        var o = v.ML.after(x, r);
                        v.YR.setSelection(x, {
                          anchor: o,
                          focus: o
                        });
                      }
                    }
                  }
                }
              }, [w.onCompositionStart]),
              onCopy: (0, u.useCallback)(e => {
                we.hasSelectableTarget(x, e.target) && !kt(e, w.onCopy) && (e.preventDefault(), we.setFragmentData(x, e.clipboardData, "copy"));
              }, [w.onCopy]),
              onCut: (0, u.useCallback)(e => {
                if (!d && we.hasSelectableTarget(x, e.target) && !kt(e, w.onCut)) {
                  e.preventDefault(), we.setFragmentData(x, e.clipboardData, "cut");
                  var {
                    selection: t
                  } = x;
                  if (t) if (v.e6.isExpanded(t)) v.ML.deleteFragment(x);else {
                    var n = v.NB.parent(x, t.anchor.path);
                    v.ML.isVoid(x, n) && v.YR.delete(x);
                  }
                }
              }, [d, w.onCut]),
              onDragOver: (0, u.useCallback)(e => {
                if (we.hasTarget(x, e.target) && !kt(e, w.onDragOver)) {
                  var t = we.toSlateNode(x, e.target);
                  v.W_.isElement(t) && v.ML.isVoid(x, t) && e.preventDefault();
                }
              }, [w.onDragOver]),
              onDragStart: (0, u.useCallback)(e => {
                if (!d && we.hasTarget(x, e.target) && !kt(e, w.onDragStart)) {
                  var t = we.toSlateNode(x, e.target),
                    n = we.findPath(x, t);
                  if (v.W_.isElement(t) && v.ML.isVoid(x, t) || v.ML.void(x, {
                    at: n,
                    voids: !0
                  })) {
                    var r = v.ML.range(x, n);
                    v.YR.select(x, r);
                  }
                  K.isDraggingInternally = !0, we.setFragmentData(x, e.dataTransfer, "drag");
                }
              }, [d, w.onDragStart]),
              onDrop: (0, u.useCallback)(e => {
                if (!d && we.hasTarget(x, e.target) && !kt(e, w.onDrop)) {
                  e.preventDefault();
                  var t = x.selection,
                    n = we.findEventRange(x, e),
                    r = e.dataTransfer;
                  v.YR.select(x, n), K.isDraggingInternally && (!t || v.e6.equals(t, n) || v.ML.void(x, {
                    at: n,
                    voids: !0
                  }) || v.YR.delete(x, {
                    at: t
                  })), we.insertData(x, r), we.isFocused(x) || we.focus(x);
                }
                K.isDraggingInternally = !1;
              }, [d, w.onDrop]),
              onDragEnd: (0, u.useCallback)(e => {
                !d && K.isDraggingInternally && w.onDragEnd && we.hasTarget(x, e.target) && w.onDragEnd(e), K.isDraggingInternally = !1;
              }, [d, w.onDragEnd]),
              onFocus: (0, u.useCallback)(e => {
                if (!d && !K.isUpdatingSelection && we.hasEditableTarget(x, e.target) && !kt(e, w.onFocus)) {
                  var t = we.toDOMNode(x, x),
                    n = we.findDocumentOrShadowRoot(x);
                  if (K.latestElement = n.activeElement, ce && e.target !== t) return void t.focus();
                  M.set(x, !0);
                }
              }, [d, w.onFocus]),
              onKeyDown: (0, u.useCallback)(e => {
                if (!d && we.hasEditableTarget(x, e.target)) {
                  null == G || G.handleKeyDown(e);
                  var {
                    nativeEvent: t
                  } = e;
                  if (we.isComposing(x) && !1 === t.isComposing && (R.set(x, !1), S(!1)), kt(e, w.onKeyDown) || we.isComposing(x)) return;
                  var {
                      selection: n
                    } = x,
                    r = x.children[null !== n ? n.focus.path[0] : 0],
                    i = "rtl" === o()(v.NB.string(r));
                  if (Je.isRedo(t)) {
                    e.preventDefault();
                    var a = x;
                    return void ("function" == typeof a.redo && a.redo());
                  }
                  if (Je.isUndo(t)) {
                    e.preventDefault();
                    var s = x;
                    return void ("function" == typeof s.undo && s.undo());
                  }
                  if (Je.isMoveLineBackward(t)) return e.preventDefault(), void v.YR.move(x, {
                    unit: "line",
                    reverse: !0
                  });
                  if (Je.isMoveLineForward(t)) return e.preventDefault(), void v.YR.move(x, {
                    unit: "line"
                  });
                  if (Je.isExtendLineBackward(t)) return e.preventDefault(), void v.YR.move(x, {
                    unit: "line",
                    edge: "focus",
                    reverse: !0
                  });
                  if (Je.isExtendLineForward(t)) return e.preventDefault(), void v.YR.move(x, {
                    unit: "line",
                    edge: "focus"
                  });
                  if (Je.isMoveBackward(t)) return e.preventDefault(), void (n && v.e6.isCollapsed(n) ? v.YR.move(x, {
                    reverse: !i
                  }) : v.YR.collapse(x, {
                    edge: "start"
                  }));
                  if (Je.isMoveForward(t)) return e.preventDefault(), void (n && v.e6.isCollapsed(n) ? v.YR.move(x, {
                    reverse: i
                  }) : v.YR.collapse(x, {
                    edge: "end"
                  }));
                  if (Je.isMoveWordBackward(t)) return e.preventDefault(), n && v.e6.isExpanded(n) && v.YR.collapse(x, {
                    edge: "focus"
                  }), void v.YR.move(x, {
                    unit: "word",
                    reverse: !i
                  });
                  if (Je.isMoveWordForward(t)) return e.preventDefault(), n && v.e6.isExpanded(n) && v.YR.collapse(x, {
                    edge: "focus"
                  }), void v.YR.move(x, {
                    unit: "word",
                    reverse: i
                  });
                  if (be) {
                    if ((he || de) && n && (Je.isDeleteBackward(t) || Je.isDeleteForward(t)) && v.e6.isCollapsed(n)) {
                      var l = v.NB.parent(x, n.anchor.path);
                      if (v.W_.isElement(l) && v.ML.isVoid(x, l) && (v.ML.isInline(x, l) || v.ML.isBlock(x, l))) return e.preventDefault(), void v.ML.deleteBackward(x, {
                        unit: "block"
                      });
                    }
                  } else {
                    if (Je.isBold(t) || Je.isItalic(t) || Je.isTransposeCharacter(t)) return void e.preventDefault();
                    if (Je.isSoftBreak(t)) return e.preventDefault(), void v.ML.insertSoftBreak(x);
                    if (Je.isSplitBlock(t)) return e.preventDefault(), void v.ML.insertBreak(x);
                    if (Je.isDeleteBackward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "backward"
                    }) : v.ML.deleteBackward(x));
                    if (Je.isDeleteForward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "forward"
                    }) : v.ML.deleteForward(x));
                    if (Je.isDeleteLineBackward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "backward"
                    }) : v.ML.deleteBackward(x, {
                      unit: "line"
                    }));
                    if (Je.isDeleteLineForward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "forward"
                    }) : v.ML.deleteForward(x, {
                      unit: "line"
                    }));
                    if (Je.isDeleteWordBackward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "backward"
                    }) : v.ML.deleteBackward(x, {
                      unit: "word"
                    }));
                    if (Je.isDeleteWordForward(t)) return e.preventDefault(), void (n && v.e6.isExpanded(n) ? v.ML.deleteFragment(x, {
                      direction: "forward"
                    }) : v.ML.deleteForward(x, {
                      unit: "word"
                    }));
                  }
                }
              }, [d, w.onKeyDown]),
              onPaste: (0, u.useCallback)(e => {
                d || !we.hasSelectableTarget(x, e.target) || kt(e, w.onPaste) || be && !(e => e.clipboardData && "" !== e.clipboardData.getData("text/plain") && 1 === e.clipboardData.types.length)(e.nativeEvent) || (e.preventDefault(), we.insertData(x, e.clipboardData));
              }, [d, w.onPaste])
            }), u.createElement(Ct, {
              decorations: J,
              node: x,
              renderElement: p,
              renderPlaceholder: f,
              renderLeaf: h,
              selection: x.selection
            })))));
          },
          Et = e => {
            var {
              attributes: t,
              children: n
            } = e;
            return u.createElement("span", Dt({}, t), n, ue && u.createElement("br", null));
          },
          _t = () => [],
          Pt = (e, t) => {
            if (t.getBoundingClientRect && (!e.selection || e.selection && v.e6.isCollapsed(e.selection))) {
              var n = t.startContainer.parentElement;
              n.getBoundingClientRect = t.getBoundingClientRect.bind(t), g(n, {
                scrollMode: "if-needed"
              }), delete n.getBoundingClientRect;
            }
          },
          kt = (e, t) => {
            if (!t) return !1;
            var n = t(e);
            return null != n ? n : e.isDefaultPrevented() || e.isPropagationStopped();
          },
          At = (e, t) => {
            if (!t) return !1;
            var n = t(e);
            return null != n ? n : e.defaultPrevented;
          },
          zt = (0, u.createContext)(!1);
        var Tt = (0, u.createContext)({});
        var Ot = ["editor", "children", "onChange", "value"],
          It = e => {
            var {
                editor: t,
                children: n,
                onChange: r,
                value: o
              } = e,
              i = D(e, Ot),
              a = (0, u.useRef)(!1),
              [s, l] = u.useState(() => {
                if (!v.NB.isNodeList(o)) throw new Error("[Slate] value is invalid! Expected a list of elements but got: ".concat(v.o4.stringify(o)));
                if (!v.ML.isEditor(t)) throw new Error("[Slate] editor is invalid! You passed: ".concat(v.o4.stringify(t)));
                return t.children = o, Object.assign(t, i), {
                  v: 0,
                  editor: t
                };
              }),
              {
                selectorContext: c,
                onChange: d
              } = function (e) {
                var t = (0, u.useRef)([]).current,
                  n = (0, u.useRef)({
                    editor: e
                  }).current,
                  r = (0, u.useCallback)(e => {
                    n.editor = e, t.forEach(t => t(e));
                  }, []);
                return {
                  selectorContext: (0, u.useMemo)(() => ({
                    getSlate: () => n.editor,
                    addEventListener: e => (t.push(e), () => {
                      t.splice(t.indexOf(e), 1);
                    })
                  }), [t, n]),
                  onChange: r
                };
              }(t),
              p = (0, u.useCallback)(() => {
                r && r(t.children), l(e => ({
                  v: e.v + 1,
                  editor: t
                })), d(t);
              }, [r]);
            (0, u.useEffect)(() => (B.set(t, p), () => {
              B.set(t, () => {}), a.current = !0;
            }), []);
            var [h, f] = (0, u.useState)(we.isFocused(t));
            return (0, u.useEffect)(() => {
              f(we.isFocused(t));
            }), xe(() => {
              var e = () => f(we.isFocused(t));
              return ae ? (document.addEventListener("focusin", e), document.addEventListener("focusout", e), () => {
                document.removeEventListener("focusin", e), document.removeEventListener("focusout", e);
              }) : (document.addEventListener("focus", e, !0), document.addEventListener("blur", e, !0), () => {
                document.removeEventListener("focus", e, !0), document.removeEventListener("blur", e, !0);
              });
            }, []), u.createElement(Tt.Provider, {
              value: c
            }, u.createElement(Ge.Provider, {
              value: s
            }, u.createElement(Ae.Provider, {
              value: s.editor
            }, u.createElement(zt.Provider, {
              value: h
            }, n))));
          },
          Ft = (e, t) => {
            var n = (t.top + t.bottom) / 2;
            return e.top <= n && e.bottom >= n;
          },
          Mt = (e, t, n) => {
            var r = we.toDOMRange(e, t).getBoundingClientRect(),
              o = we.toDOMRange(e, n).getBoundingClientRect();
            return Ft(r, o) && Ft(o, r);
          },
          Rt = (e, t) => {
            var n = v.ML.range(e, v.e6.end(t)),
              r = Array.from(v.ML.positions(e, {
                at: t
              })),
              o = 0,
              i = r.length,
              a = Math.floor(i / 2);
            if (Mt(e, v.ML.range(e, r[o]), n)) return v.ML.range(e, r[o], n);
            if (r.length < 2) return v.ML.range(e, r[r.length - 1], n);
            for (; a !== r.length && a !== o;) Mt(e, v.ML.range(e, r[a]), n) ? i = a : o = a, a = Math.floor((o + i) / 2);
            return v.ML.range(e, r[i], n);
          };
        function jt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Bt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? jt(Object(n), !0).forEach(function (t) {
              x(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Nt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x-slate-fragment",
              n = e,
              {
                apply: r,
                onChange: o,
                deleteBackward: i,
                addMark: a,
                removeMark: s
              } = n;
            return I.set(n, new WeakMap()), n.addMark = (e, t) => {
              var r, o;
              null === (r = N.get(n)) || void 0 === r || r(), !L.get(n) && null !== (o = K.get(n)) && void 0 !== o && o.length && L.set(n, null), V.delete(n), a(e, t);
            }, n.removeMark = e => {
              var t;
              !L.get(n) && null !== (t = K.get(n)) && void 0 !== t && t.length && L.set(n, null), V.delete(n), s(e);
            }, n.deleteBackward = e => {
              if ("line" !== e) return i(e);
              if (n.selection && v.e6.isCollapsed(n.selection)) {
                var t = v.ML.above(n, {
                  match: e => v.W_.isElement(e) && v.ML.isBlock(n, e),
                  at: n.selection
                });
                if (t) {
                  var [, r] = t,
                    o = v.ML.range(n, r, n.selection.anchor),
                    a = Rt(n, o);
                  v.e6.isCollapsed(a) || v.YR.delete(n, {
                    at: a
                  });
                }
              }
            }, n.apply = e => {
              var t = [],
                o = K.get(n);
              if (null != o && o.length) {
                var i = o.map(t => dt(t, e)).filter(Boolean);
                K.set(n, i);
              }
              var a = H.get(n);
              a && H.set(n, ct(n, a, e));
              var s = q.get(n);
              if (null != s && s.at) {
                var l = v.E9.isPoint(null == s ? void 0 : s.at) ? ut(n, s.at, e) : ct(n, s.at, e);
                q.set(n, l ? Bt(Bt({}, s), {}, {
                  at: l
                }) : null);
              }
              switch (e.type) {
                case "insert_text":
                case "remove_text":
                case "set_node":
                case "split_node":
                  t.push(...Lt(n, e.path));
                  break;
                case "set_selection":
                  var u;
                  null === (u = j.get(n)) || void 0 === u || u.unref(), j.delete(n);
                  break;
                case "insert_node":
                case "remove_node":
                  t.push(...Lt(n, v.y$.parent(e.path)));
                  break;
                case "merge_node":
                  var c = v.y$.previous(e.path);
                  t.push(...Lt(n, c));
                  break;
                case "move_node":
                  var d = v.y$.common(v.y$.parent(e.path), v.y$.parent(e.newPath));
                  t.push(...Lt(n, d));
              }
              for (var [p, h] of (r(e), t)) {
                var [f] = v.ML.node(n, p);
                O.set(f, h);
              }
            }, n.setFragmentData = e => {
              var {
                selection: r
              } = n;
              if (r) {
                var [o, i] = v.e6.edges(r),
                  a = v.ML.void(n, {
                    at: o.path
                  }),
                  s = v.ML.void(n, {
                    at: i.path
                  });
                if (!v.e6.isCollapsed(r) || a) {
                  var l = we.toDOMRange(n, r),
                    u = l.cloneContents(),
                    c = u.childNodes[0];
                  if (u.childNodes.forEach(e => {
                    e.textContent && "" !== e.textContent.trim() && (c = e);
                  }), s) {
                    var [d] = s,
                      p = l.cloneRange(),
                      h = we.toDOMNode(n, d);
                    p.setEndAfter(h), u = p.cloneContents();
                  }
                  if (a && (c = u.querySelector("[data-slate-spacer]")), Array.from(u.querySelectorAll("[data-slate-zero-width]")).forEach(e => {
                    var t = "n" === e.getAttribute("data-slate-zero-width");
                    e.textContent = t ? "\n" : "";
                  }), J(c)) {
                    var f = c.ownerDocument.createElement("span");
                    f.style.whiteSpace = "pre", f.appendChild(c), u.appendChild(f), c = f;
                  }
                  var m = n.getFragment(),
                    g = JSON.stringify(m),
                    y = window.btoa(encodeURIComponent(g));
                  c.setAttribute("data-slate-fragment", y), e.setData("application/".concat(t), y);
                  var b = u.ownerDocument.createElement("div");
                  return b.appendChild(u), b.setAttribute("hidden", "true"), u.ownerDocument.body.appendChild(b), e.setData("text/html", b.innerHTML), e.setData("text/plain", ne(b)), u.ownerDocument.body.removeChild(b), e;
                }
              }
            }, n.insertData = e => {
              n.insertFragmentData(e) || n.insertTextData(e);
            }, n.insertFragmentData = e => {
              var r = e.getData("application/".concat(t)) || oe(e);
              if (r) {
                var o = decodeURIComponent(window.atob(r)),
                  i = JSON.parse(o);
                return n.insertFragment(i), !0;
              }
              return !1;
            }, n.insertTextData = e => {
              var t = e.getData("text/plain");
              if (t) {
                var r = t.split(/\r\n|\r|\n/),
                  o = !1;
                for (var i of r) o && v.YR.splitNodes(n, {
                  always: !0
                }), n.insertText(i), o = !0;
                return !0;
              }
              return !1;
            }, n.onChange = () => {
              w.unstable_batchedUpdates(() => {
                var e = B.get(n);
                e && e(), o();
              });
            }, n;
          },
          Lt = (e, t) => {
            var n = [];
            for (var [r, o] of v.ML.levels(e, {
              at: t
            })) {
              var i = we.findKey(e, r);
              n.push([o, i]);
            }
            return n;
          };
      },
      57645: (e, t, n) => {
        "use strict";

        n.d(t, {
          VC: () => u
        });
        var r = n(35583),
          o = n(77493),
          i = {
            isHistory: e => (0, r.P)(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (0 === e.redos.length || o.OX.isOperationList(e.redos[0].operations)) && (0 === e.undos.length || o.OX.isOperationList(e.undos[0].operations))
          },
          a = (new WeakMap(), new WeakMap()),
          s = new WeakMap(),
          l = {
            isHistoryEditor: e => i.isHistory(e.history) && o.ML.isEditor(e),
            isMerging: e => s.get(e),
            isSaving: e => a.get(e),
            redo(e) {
              e.redo();
            },
            undo(e) {
              e.undo();
            },
            withoutMerging(e, t) {
              var n = l.isMerging(e);
              s.set(e, !1), t(), s.set(e, n);
            },
            withoutSaving(e, t) {
              var n = l.isSaving(e);
              a.set(e, !1), t(), a.set(e, n);
            }
          },
          u = e => {
            var t = e,
              {
                apply: n
              } = t;
            return t.history = {
              undos: [],
              redos: []
            }, t.redo = () => {
              var {
                  history: e
                } = t,
                {
                  redos: n
                } = e;
              if (n.length > 0) {
                var r = n[n.length - 1];
                r.selectionBefore && o.YR.setSelection(t, r.selectionBefore), l.withoutSaving(t, () => {
                  o.ML.withoutNormalizing(t, () => {
                    for (var e of r.operations) t.apply(e);
                  });
                }), e.redos.pop(), t.writeHistory("undos", r);
              }
            }, t.undo = () => {
              var {
                  history: e
                } = t,
                {
                  undos: n
                } = e;
              if (n.length > 0) {
                var r = n[n.length - 1];
                l.withoutSaving(t, () => {
                  o.ML.withoutNormalizing(t, () => {
                    var e = r.operations.map(o.OX.inverse).reverse();
                    for (var n of e) t.apply(n);
                    r.selectionBefore && o.YR.setSelection(t, r.selectionBefore);
                  });
                }), t.writeHistory("redos", r), e.undos.pop();
              }
            }, t.apply = e => {
              var {
                  operations: r,
                  history: o
                } = t,
                {
                  undos: i
                } = o,
                a = i[i.length - 1],
                s = a && a.operations[a.operations.length - 1],
                u = l.isSaving(t),
                p = l.isMerging(t);
              if (null == u && (u = d(e)), u) {
                if (null == p && (p = null != a && (0 !== r.length || c(e, s))), a && p) a.operations.push(e);else {
                  var h = {
                    operations: [e],
                    selectionBefore: t.selection
                  };
                  t.writeHistory("undos", h);
                }
                for (; i.length > 100;) i.shift();
                o.redos = [];
              }
              n(e);
            }, t.writeHistory = (e, n) => {
              t.history[e].push(n);
            }, t;
          },
          c = (e, t) => !(!t || "insert_text" !== e.type || "insert_text" !== t.type || e.offset !== t.offset + t.text.length || !o.y$.equals(e.path, t.path)) || !(!t || "remove_text" !== e.type || "remove_text" !== t.type || e.offset + e.text.length !== t.offset || !o.y$.equals(e.path, t.path)),
          d = (e, t) => "set_selection" !== e.type;
      },
      59619: (e, t) => {
        "use strict";

        for (var n = "undefined" != typeof window && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), r = {
            alt: "altKey",
            control: "ctrlKey",
            meta: "metaKey",
            shift: "shiftKey"
          }, o = {
            add: "+",
            break: "pause",
            cmd: "meta",
            command: "meta",
            ctl: "control",
            ctrl: "control",
            del: "delete",
            down: "arrowdown",
            esc: "escape",
            ins: "insert",
            left: "arrowleft",
            mod: n ? "meta" : "control",
            opt: "alt",
            option: "alt",
            return: "enter",
            right: "arrowright",
            space: " ",
            spacebar: " ",
            up: "arrowup",
            win: "meta",
            windows: "meta"
          }, i = {
            backspace: 8,
            tab: 9,
            enter: 13,
            shift: 16,
            control: 17,
            alt: 18,
            pause: 19,
            capslock: 20,
            escape: 27,
            " ": 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36,
            arrowleft: 37,
            arrowup: 38,
            arrowright: 39,
            arrowdown: 40,
            insert: 45,
            delete: 46,
            meta: 91,
            numlock: 144,
            scrolllock: 145,
            ";": 186,
            "=": 187,
            ",": 188,
            "-": 189,
            ".": 190,
            "/": 191,
            "`": 192,
            "[": 219,
            "\\": 220,
            "]": 221,
            "'": 222
          }, a = 1; a < 20; a++) i["f" + a] = 111 + a;
        function s(e, t, n) {
          t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
          var r = e.map(function (e) {
              return l(e, t);
            }),
            o = function (e) {
              return r.some(function (t) {
                return u(t, e);
              });
            };
          return null == n ? o : o(n);
        }
        function l(e, t) {
          var n = t && t.byKey,
            a = {},
            s = (e = e.replace("++", "+add")).split("+"),
            l = s.length;
          for (var u in r) a[r[u]] = !1;
          var p = !0,
            h = !1,
            f = void 0;
          try {
            for (var m, g = s[Symbol.iterator](); !(p = (m = g.next()).done); p = !0) {
              var v = m.value,
                y = v.endsWith("?") && v.length > 1;
              y && (v = v.slice(0, -1));
              var b = d(v),
                w = r[b];
              if (v.length > 1 && !w && !o[v] && !i[b]) throw new TypeError('Unknown modifier: "' + v + '"');
              1 !== l && w || (n ? a.key = b : a.which = c(v)), w && (a[w] = !y || null);
            }
          } catch (e) {
            h = !0, f = e;
          } finally {
            try {
              !p && g.return && g.return();
            } finally {
              if (h) throw f;
            }
          }
          return a;
        }
        function u(e, t) {
          for (var n in e) {
            var r = e[n],
              o = void 0;
            if (null != r && (null != (o = "key" === n && null != t.key ? t.key.toLowerCase() : "which" === n ? 91 === r && 93 === t.which ? 91 : t.which : t[n]) || !1 !== r) && o !== r) return !1;
          }
          return !0;
        }
        function c(e) {
          return e = d(e), i[e] || e.toUpperCase().charCodeAt(0);
        }
        function d(e) {
          return e = e.toLowerCase(), e = o[e] || e;
        }
        t.P6 = s;
      },
      77493: (e, t, n) => {
        "use strict";

        n.d(t, {
          E9: () => q,
          Jh: () => Pn,
          ML: () => N,
          NB: () => F,
          OX: () => j,
          W_: () => z,
          YR: () => ze,
          e6: () => k,
          o4: () => U,
          xv: () => X,
          y$: () => m
        });
        var r = n(35583),
          o = n(28623),
          i = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = m.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          a = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = q.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          s = {
            transform(e, t) {
              var {
                current: n,
                affinity: r
              } = e;
              if (null != n) {
                var o = k.transform(n, t, {
                  affinity: r
                });
                e.current = o, null == o && e.unref();
              }
            }
          },
          l = new WeakMap(),
          u = new WeakMap(),
          c = new WeakMap(),
          d = new WeakMap(),
          p = new WeakMap(),
          h = new WeakMap(),
          f = new WeakMap(),
          m = {
            ancestors(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                r = m.levels(e, t);
              return r = n ? r.slice(1) : r.slice(0, -1);
            },
            common(e, t) {
              for (var n = [], r = 0; r < e.length && r < t.length; r++) {
                var o = e[r];
                if (o !== t[r]) break;
                n.push(o);
              }
              return n;
            },
            compare(e, t) {
              for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
                if (e[r] < t[r]) return -1;
                if (e[r] > t[r]) return 1;
              }
              return 0;
            },
            endsAfter(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return m.equals(r, o) && i > a;
            },
            endsAt(e, t) {
              var n = e.length,
                r = e.slice(0, n),
                o = t.slice(0, n);
              return m.equals(r, o);
            },
            endsBefore(e, t) {
              var n = e.length - 1,
                r = e.slice(0, n),
                o = t.slice(0, n),
                i = e[n],
                a = t[n];
              return m.equals(r, o) && i < a;
            },
            equals: (e, t) => e.length === t.length && e.every((e, n) => e === t[n]),
            hasPrevious: e => e[e.length - 1] > 0,
            isAfter: (e, t) => 1 === m.compare(e, t),
            isAncestor: (e, t) => e.length < t.length && 0 === m.compare(e, t),
            isBefore: (e, t) => -1 === m.compare(e, t),
            isChild: (e, t) => e.length === t.length + 1 && 0 === m.compare(e, t),
            isCommon: (e, t) => e.length <= t.length && 0 === m.compare(e, t),
            isDescendant: (e, t) => e.length > t.length && 0 === m.compare(e, t),
            isParent: (e, t) => e.length + 1 === t.length && 0 === m.compare(e, t),
            isPath: e => Array.isArray(e) && (0 === e.length || "number" == typeof e[0]),
            isSibling(e, t) {
              if (e.length !== t.length) return !1;
              var n = e.slice(0, -1),
                r = t.slice(0, -1);
              return e[e.length - 1] !== t[t.length - 1] && m.equals(n, r);
            },
            levels(e) {
              for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, {
                  reverse: n = !1
                } = t, r = [], o = 0; o <= e.length; o++) r.push(e.slice(0, o));
              return n && r.reverse(), r;
            },
            next(e) {
              if (0 === e.length) throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
              var t = e[e.length - 1];
              return e.slice(0, -1).concat(t + 1);
            },
            operationCanTransformPath(e) {
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                case "merge_node":
                case "split_node":
                case "move_node":
                  return !0;
                default:
                  return !1;
              }
            },
            parent(e) {
              if (0 === e.length) throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
              return e.slice(0, -1);
            },
            previous(e) {
              if (0 === e.length) throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
              var t = e[e.length - 1];
              if (t <= 0) throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
              return e.slice(0, -1).concat(t - 1);
            },
            relative(e, t) {
              if (!m.isAncestor(t, e) && !m.equals(e, t)) throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
              return e.slice(t.length);
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              if (!e) return null;
              var r = [...e],
                {
                  affinity: o = "forward"
                } = n;
              if (0 === e.length) return r;
              switch (t.type) {
                case "insert_node":
                  var {
                    path: i
                  } = t;
                  (m.equals(i, r) || m.endsBefore(i, r) || m.isAncestor(i, r)) && (r[i.length - 1] += 1);
                  break;
                case "remove_node":
                  var {
                    path: a
                  } = t;
                  if (m.equals(a, r) || m.isAncestor(a, r)) return null;
                  m.endsBefore(a, r) && (r[a.length - 1] -= 1);
                  break;
                case "merge_node":
                  var {
                    path: s,
                    position: l
                  } = t;
                  m.equals(s, r) || m.endsBefore(s, r) ? r[s.length - 1] -= 1 : m.isAncestor(s, r) && (r[s.length - 1] -= 1, r[s.length] += l);
                  break;
                case "split_node":
                  var {
                    path: u,
                    position: c
                  } = t;
                  if (m.equals(u, r)) {
                    if ("forward" === o) r[r.length - 1] += 1;else if ("backward" !== o) return null;
                  } else m.endsBefore(u, r) ? r[u.length - 1] += 1 : m.isAncestor(u, r) && e[u.length] >= c && (r[u.length - 1] += 1, r[u.length] -= c);
                  break;
                case "move_node":
                  var {
                    path: d,
                    newPath: p
                  } = t;
                  if (m.equals(d, p)) return r;
                  if (m.isAncestor(d, r) || m.equals(d, r)) {
                    var h = p.slice();
                    return m.endsBefore(d, p) && d.length < p.length && (h[d.length - 1] -= 1), h.concat(r.slice(d.length));
                  }
                  m.isSibling(d, p) && (m.isAncestor(p, r) || m.equals(p, r)) ? m.endsBefore(d, r) ? r[d.length - 1] -= 1 : r[d.length - 1] += 1 : m.endsBefore(p, r) || m.equals(p, r) || m.isAncestor(p, r) ? (m.endsBefore(d, r) && (r[d.length - 1] -= 1), r[p.length - 1] += 1) : m.endsBefore(d, r) && (m.equals(p, r) && (r[p.length - 1] += 1), r[d.length - 1] -= 1);
              }
              return r;
            }
          };
        function g(e) {
          return g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, g(e);
        }
        function v(e) {
          var t = function (e, t) {
            if ("object" !== g(e) || null === e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
              var r = n.call(e, t || "default");
              if ("object" !== g(r)) return r;
              throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
          }(e, "string");
          return "symbol" === g(t) ? t : String(t);
        }
        function y(e, t, n) {
          return (t = v(t)) in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }
        function b(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function w(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? b(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var x = {
            transform(e, t) {
              e.children = (0, o.P2)(e.children);
              var n = e.selection && (0, o.P2)(e.selection);
              try {
                n = ((e, t, n) => {
                  switch (n.type) {
                    case "insert_node":
                      var {
                          path: r,
                          node: o
                        } = n,
                        i = F.parent(e, r),
                        a = r[r.length - 1];
                      if (a > i.children.length) throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
                      if (i.children.splice(a, 0, o), t) for (var [s, l] of k.points(t)) t[l] = q.transform(s, n);
                      break;
                    case "insert_text":
                      var {
                        path: u,
                        offset: c,
                        text: d
                      } = n;
                      if (0 === d.length) break;
                      var p = F.leaf(e, u),
                        h = p.text.slice(0, c),
                        f = p.text.slice(c);
                      if (p.text = h + d + f, t) for (var [g, v] of k.points(t)) t[v] = q.transform(g, n);
                      break;
                    case "merge_node":
                      var {
                          path: y
                        } = n,
                        b = F.get(e, y),
                        x = m.previous(y),
                        D = F.get(e, x),
                        C = F.parent(e, y),
                        S = y[y.length - 1];
                      if (X.isText(b) && X.isText(D)) D.text += b.text;else {
                        if (X.isText(b) || X.isText(D)) throw new Error('Cannot apply a "merge_node" operation at path ['.concat(y, "] to nodes of different interfaces: ").concat(U.stringify(b), " ").concat(U.stringify(D)));
                        D.children.push(...b.children);
                      }
                      if (C.children.splice(S, 1), t) for (var [E, _] of k.points(t)) t[_] = q.transform(E, n);
                      break;
                    case "move_node":
                      var {
                        path: P,
                        newPath: A
                      } = n;
                      if (m.isAncestor(P, A)) throw new Error("Cannot move a path [".concat(P, "] to new path [").concat(A, "] because the destination is inside itself."));
                      var z = F.get(e, P),
                        T = F.parent(e, P),
                        O = P[P.length - 1];
                      T.children.splice(O, 1);
                      var I = m.transform(P, n),
                        M = F.get(e, m.parent(I)),
                        R = I[I.length - 1];
                      if (M.children.splice(R, 0, z), t) for (var [j, B] of k.points(t)) t[B] = q.transform(j, n);
                      break;
                    case "remove_node":
                      var {
                          path: N
                        } = n,
                        L = N[N.length - 1];
                      if (F.parent(e, N).children.splice(L, 1), t) for (var [V, K] of k.points(t)) {
                        var H = q.transform(V, n);
                        if (null != t && null != H) t[K] = H;else {
                          var Z = void 0,
                            $ = void 0;
                          for (var [G, W] of F.texts(e)) {
                            if (-1 !== m.compare(W, N)) {
                              $ = [G, W];
                              break;
                            }
                            Z = [G, W];
                          }
                          var Y = !1;
                          Z && $ && (Y = m.equals($[1], N) ? !m.hasPrevious($[1]) : m.common(Z[1], N).length < m.common($[1], N).length), Z && !Y ? (V.path = Z[1], V.offset = Z[0].text.length) : $ ? (V.path = $[1], V.offset = 0) : t = null;
                        }
                      }
                      break;
                    case "remove_text":
                      var {
                        path: Q,
                        offset: J,
                        text: ee
                      } = n;
                      if (0 === ee.length) break;
                      var te = F.leaf(e, Q),
                        ne = te.text.slice(0, J),
                        re = te.text.slice(J + ee.length);
                      if (te.text = ne + re, t) for (var [oe, ie] of k.points(t)) t[ie] = q.transform(oe, n);
                      break;
                    case "set_node":
                      var {
                        path: ae,
                        properties: se,
                        newProperties: le
                      } = n;
                      if (0 === ae.length) throw new Error("Cannot set properties on the root node!");
                      var ue = F.get(e, ae);
                      for (var ce in le) {
                        if ("children" === ce || "text" === ce) throw new Error('Cannot set the "'.concat(ce, '" property of nodes!'));
                        var de = le[ce];
                        null == de ? delete ue[ce] : ue[ce] = de;
                      }
                      for (var pe in se) le.hasOwnProperty(pe) || delete ue[pe];
                      break;
                    case "set_selection":
                      var {
                        newProperties: he
                      } = n;
                      if (null == he) t = he;else {
                        if (null == t) {
                          if (!k.isRange(he)) throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(U.stringify(he), " when there is no current selection."));
                          t = w({}, he);
                        }
                        for (var fe in he) {
                          var me = he[fe];
                          if (null == me) {
                            if ("anchor" === fe || "focus" === fe) throw new Error('Cannot remove the "'.concat(fe, '" selection property'));
                            delete t[fe];
                          } else t[fe] = me;
                        }
                      }
                      break;
                    case "split_node":
                      var {
                        path: ge,
                        position: ve,
                        properties: ye
                      } = n;
                      if (0 === ge.length) throw new Error('Cannot apply a "split_node" operation at path ['.concat(ge, "] because the root node cannot be split."));
                      var be,
                        we = F.get(e, ge),
                        xe = F.parent(e, ge),
                        De = ge[ge.length - 1];
                      if (X.isText(we)) {
                        var Ce = we.text.slice(0, ve),
                          Se = we.text.slice(ve);
                        we.text = Ce, be = w(w({}, ye), {}, {
                          text: Se
                        });
                      } else {
                        var Ee = we.children.slice(0, ve),
                          _e = we.children.slice(ve);
                        we.children = Ee, be = w(w({}, ye), {}, {
                          children: _e
                        });
                      }
                      if (xe.children.splice(De + 1, 0, be), t) for (var [Pe, ke] of k.points(t)) t[ke] = q.transform(Pe, n);
                  }
                  return t;
                })(e, n, t);
              } finally {
                e.children = (0, o._x)(e.children), e.selection = n ? (0, o.mv)(n) ? (0, o._x)(n) : n : null;
              }
            }
          },
          D = {
            insertNodes(e, t, n) {
              e.insertNodes(t, n);
            },
            liftNodes(e, t) {
              e.liftNodes(t);
            },
            mergeNodes(e, t) {
              e.mergeNodes(t);
            },
            moveNodes(e, t) {
              e.moveNodes(t);
            },
            removeNodes(e, t) {
              e.removeNodes(t);
            },
            setNodes(e, t, n) {
              e.setNodes(t, n);
            },
            splitNodes(e, t) {
              e.splitNodes(t);
            },
            unsetNodes(e, t, n) {
              e.unsetNodes(t, n);
            },
            unwrapNodes(e, t) {
              e.unwrapNodes(t);
            },
            wrapNodes(e, t, n) {
              e.wrapNodes(t, n);
            }
          },
          C = {
            collapse(e, t) {
              e.collapse(t);
            },
            deselect(e) {
              e.deselect();
            },
            move(e, t) {
              e.move(t);
            },
            select(e, t) {
              e.select(t);
            },
            setPoint(e, t, n) {
              e.setPoint(t, n);
            },
            setSelection(e, t) {
              e.setSelection(t);
            }
          },
          S = (e, t) => {
            for (var n in e) {
              var o = e[n],
                i = t[n];
              if ((0, r.P)(o) && (0, r.P)(i)) {
                if (!S(o, i)) return !1;
              } else if (Array.isArray(o) && Array.isArray(i)) {
                if (o.length !== i.length) return !1;
                for (var a = 0; a < o.length; a++) if (o[a] !== i[a]) return !1;
              } else if (o !== i) return !1;
            }
            for (var s in t) if (void 0 === e[s] && void 0 !== t[s]) return !1;
            return !0;
          };
        function E(e, t) {
          if (null == e) return {};
          var n,
            r,
            o = function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                i = Object.keys(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            }(e, t);
          if (Object.getOwnPropertySymbols) {
            var i = Object.getOwnPropertySymbols(e);
            for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
          return o;
        }
        var _ = ["anchor", "focus"];
        function P(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var k = {
            edges(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  reverse: n = !1
                } = t,
                {
                  anchor: r,
                  focus: o
                } = e;
              return k.isBackward(e) === n ? [r, o] : [o, r];
            },
            end(e) {
              var [, t] = k.edges(e);
              return t;
            },
            equals: (e, t) => q.equals(e.anchor, t.anchor) && q.equals(e.focus, t.focus),
            includes(e, t) {
              if (k.isRange(t)) {
                if (k.includes(e, t.anchor) || k.includes(e, t.focus)) return !0;
                var [n, r] = k.edges(e),
                  [o, i] = k.edges(t);
                return q.isBefore(n, o) && q.isAfter(r, i);
              }
              var [a, s] = k.edges(e),
                l = !1,
                u = !1;
              return q.isPoint(t) ? (l = q.compare(t, a) >= 0, u = q.compare(t, s) <= 0) : (l = m.compare(t, a.path) >= 0, u = m.compare(t, s.path) <= 0), l && u;
            },
            intersection(e, t) {
              var n = E(e, _),
                [r, o] = k.edges(e),
                [i, a] = k.edges(t),
                s = q.isBefore(r, i) ? i : r,
                l = q.isBefore(o, a) ? o : a;
              return q.isBefore(l, s) ? null : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = null != arguments[t] ? arguments[t] : {};
                  t % 2 ? P(Object(n), !0).forEach(function (t) {
                    y(e, t, n[t]);
                  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : P(Object(n)).forEach(function (t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                  });
                }
                return e;
              }({
                anchor: s,
                focus: l
              }, n);
            },
            isBackward(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return q.isAfter(t, n);
            },
            isCollapsed(e) {
              var {
                anchor: t,
                focus: n
              } = e;
              return q.equals(t, n);
            },
            isExpanded: e => !k.isCollapsed(e),
            isForward: e => !k.isBackward(e),
            isRange: e => (0, r.P)(e) && q.isPoint(e.anchor) && q.isPoint(e.focus),
            *points(e) {
              yield [e.anchor, "anchor"], yield [e.focus, "focus"];
            },
            start(e) {
              var [t] = k.edges(e);
              return t;
            },
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return (0, o.Uy)(e, e => {
                if (null === e) return null;
                var r,
                  o,
                  {
                    affinity: i = "inward"
                  } = n;
                if ("inward" === i) {
                  var a = k.isCollapsed(e);
                  k.isForward(e) ? (r = "forward", o = a ? r : "backward") : (r = "backward", o = a ? r : "forward");
                } else "outward" === i ? k.isForward(e) ? (r = "backward", o = "forward") : (r = "forward", o = "backward") : (r = i, o = i);
                var s = q.transform(e.anchor, t, {
                    affinity: r
                  }),
                  l = q.transform(e.focus, t, {
                    affinity: o
                  });
                if (!s || !l) return null;
                e.anchor = s, e.focus = l;
              });
            }
          },
          A = e => (0, r.P)(e) && F.isNodeList(e.children) && !N.isEditor(e),
          z = {
            isAncestor: e => (0, r.P)(e) && F.isNodeList(e.children),
            isElement: A,
            isElementList: e => Array.isArray(e) && e.every(e => z.isElement(e)),
            isElementProps: e => void 0 !== e.children,
            isElementType: function (e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "type";
              return A(e) && e[n] === t;
            },
            matches(e, t) {
              for (var n in t) if ("children" !== n && e[n] !== t[n]) return !1;
              return !0;
            }
          },
          T = ["children"],
          O = ["text"],
          I = new WeakMap(),
          F = {
            ancestor(e, t) {
              var n = F.get(e, t);
              if (X.isText(n)) throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(U.stringify(n)));
              return n;
            },
            ancestors(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return function* () {
                for (var r of m.ancestors(t, n)) {
                  var o = [F.ancestor(e, r), r];
                  yield o;
                }
              }();
            },
            child(e, t) {
              if (X.isText(e)) throw new Error("Cannot get the child of a text node: ".concat(U.stringify(e)));
              var n = e.children[t];
              if (null == n) throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(U.stringify(e)));
              return n;
            },
            children(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return function* () {
                for (var {
                    reverse: r = !1
                  } = n, o = F.ancestor(e, t), {
                    children: i
                  } = o, a = r ? i.length - 1 : 0; r ? a >= 0 : a < i.length;) {
                  var s = F.child(o, a),
                    l = t.concat(a);
                  yield [s, l], a = r ? a - 1 : a + 1;
                }
              }();
            },
            common(e, t, n) {
              var r = m.common(t, n);
              return [F.get(e, r), r];
            },
            descendant(e, t) {
              var n = F.get(e, t);
              if (N.isEditor(n)) throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(U.stringify(n)));
              return n;
            },
            descendants(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return function* () {
                for (var [n, r] of F.nodes(e, t)) 0 !== r.length && (yield [n, r]);
              }();
            },
            elements(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return function* () {
                for (var [n, r] of F.nodes(e, t)) z.isElement(n) && (yield [n, r]);
              }();
            },
            extractProps: e => z.isAncestor(e) ? E(e, T) : E(e, O),
            first(e, t) {
              for (var n = t.slice(), r = F.get(e, n); r && !X.isText(r) && 0 !== r.children.length;) r = r.children[0], n.push(0);
              return [r, n];
            },
            fragment(e, t) {
              if (X.isText(e)) throw new Error("Cannot get a fragment starting from a root text node: ".concat(U.stringify(e)));
              var n = (0, o.Uy)({
                children: e.children
              }, e => {
                var [n, r] = k.edges(t),
                  o = F.nodes(e, {
                    reverse: !0,
                    pass: e => {
                      var [, n] = e;
                      return !k.includes(t, n);
                    }
                  });
                for (var [, i] of o) {
                  if (!k.includes(t, i)) {
                    var a = F.parent(e, i),
                      s = i[i.length - 1];
                    a.children.splice(s, 1);
                  }
                  if (m.equals(i, r.path)) {
                    var l = F.leaf(e, i);
                    l.text = l.text.slice(0, r.offset);
                  }
                  if (m.equals(i, n.path)) {
                    var u = F.leaf(e, i);
                    u.text = u.text.slice(n.offset);
                  }
                }
                N.isEditor(e) && (e.selection = null);
              });
              return n.children;
            },
            get(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (X.isText(n) || !n.children[o]) throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(U.stringify(e)));
                n = n.children[o];
              }
              return n;
            },
            has(e, t) {
              for (var n = e, r = 0; r < t.length; r++) {
                var o = t[r];
                if (X.isText(n) || !n.children[o]) return !1;
                n = n.children[o];
              }
              return !0;
            },
            isNode: e => X.isText(e) || z.isElement(e) || N.isEditor(e),
            isNodeList(e) {
              if (!Array.isArray(e)) return !1;
              var t = I.get(e);
              if (void 0 !== t) return t;
              var n = e.every(e => F.isNode(e));
              return I.set(e, n), n;
            },
            last(e, t) {
              for (var n = t.slice(), r = F.get(e, n); r && !X.isText(r) && 0 !== r.children.length;) {
                var o = r.children.length - 1;
                r = r.children[o], n.push(o);
              }
              return [r, n];
            },
            leaf(e, t) {
              var n = F.get(e, t);
              if (!X.isText(n)) throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(U.stringify(n)));
              return n;
            },
            levels(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return function* () {
                for (var r of m.levels(t, n)) {
                  var o = F.get(e, r);
                  yield [o, r];
                }
              }();
            },
            matches: (e, t) => z.isElement(e) && z.isElementProps(t) && z.matches(e, t) || X.isText(e) && X.isTextProps(t) && X.matches(e, t),
            nodes(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return function* () {
                for (var {
                    pass: n,
                    reverse: r = !1
                  } = t, {
                    from: o = [],
                    to: i
                  } = t, a = new Set(), s = [], l = e; !i || !(r ? m.isBefore(s, i) : m.isAfter(s, i));) if (a.has(l) || (yield [l, s]), a.has(l) || X.isText(l) || 0 === l.children.length || null != n && !1 !== n([l, s])) {
                  if (0 === s.length) break;
                  if (!r) {
                    var u = m.next(s);
                    if (F.has(e, u)) {
                      s = u, l = F.get(e, s);
                      continue;
                    }
                  }
                  if (r && 0 !== s[s.length - 1]) s = m.previous(s), l = F.get(e, s);else s = m.parent(s), l = F.get(e, s), a.add(l);
                } else {
                  a.add(l);
                  var c = r ? l.children.length - 1 : 0;
                  m.isAncestor(s, o) && (c = o[s.length]), s = s.concat(c), l = F.get(e, s);
                }
              }();
            },
            parent(e, t) {
              var n = m.parent(t),
                r = F.get(e, n);
              if (X.isText(r)) throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
              return r;
            },
            string: e => X.isText(e) ? e.text : e.children.map(F.string).join(""),
            texts(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return function* () {
                for (var [n, r] of F.nodes(e, t)) X.isText(n) && (yield [n, r]);
              }();
            }
          };
        function M(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function R(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? M(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : M(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var j = {
            isNodeOperation: e => j.isOperation(e) && e.type.endsWith("_node"),
            isOperation(e) {
              if (!(0, r.P)(e)) return !1;
              switch (e.type) {
                case "insert_node":
                case "remove_node":
                  return m.isPath(e.path) && F.isNode(e.node);
                case "insert_text":
                case "remove_text":
                  return "number" == typeof e.offset && "string" == typeof e.text && m.isPath(e.path);
                case "merge_node":
                  return "number" == typeof e.position && m.isPath(e.path) && (0, r.P)(e.properties);
                case "move_node":
                  return m.isPath(e.path) && m.isPath(e.newPath);
                case "set_node":
                  return m.isPath(e.path) && (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "set_selection":
                  return null === e.properties && k.isRange(e.newProperties) || null === e.newProperties && k.isRange(e.properties) || (0, r.P)(e.properties) && (0, r.P)(e.newProperties);
                case "split_node":
                  return m.isPath(e.path) && "number" == typeof e.position && (0, r.P)(e.properties);
                default:
                  return !1;
              }
            },
            isOperationList: e => Array.isArray(e) && e.every(e => j.isOperation(e)),
            isSelectionOperation: e => j.isOperation(e) && e.type.endsWith("_selection"),
            isTextOperation: e => j.isOperation(e) && e.type.endsWith("_text"),
            inverse(e) {
              switch (e.type) {
                case "insert_node":
                  return R(R({}, e), {}, {
                    type: "remove_node"
                  });
                case "insert_text":
                  return R(R({}, e), {}, {
                    type: "remove_text"
                  });
                case "merge_node":
                  return R(R({}, e), {}, {
                    type: "split_node",
                    path: m.previous(e.path)
                  });
                case "move_node":
                  var {
                    newPath: t,
                    path: n
                  } = e;
                  if (m.equals(t, n)) return e;
                  if (m.isSibling(n, t)) return R(R({}, e), {}, {
                    path: t,
                    newPath: n
                  });
                  var r = m.transform(n, e),
                    o = m.transform(m.next(n), e);
                  return R(R({}, e), {}, {
                    path: r,
                    newPath: o
                  });
                case "remove_node":
                  return R(R({}, e), {}, {
                    type: "insert_node"
                  });
                case "remove_text":
                  return R(R({}, e), {}, {
                    type: "insert_text"
                  });
                case "set_node":
                  var {
                    properties: i,
                    newProperties: a
                  } = e;
                  return R(R({}, e), {}, {
                    properties: a,
                    newProperties: i
                  });
                case "set_selection":
                  var {
                    properties: s,
                    newProperties: l
                  } = e;
                  return R(R({}, e), {}, null == s ? {
                    properties: l,
                    newProperties: null
                  } : null == l ? {
                    properties: null,
                    newProperties: s
                  } : {
                    properties: l,
                    newProperties: s
                  });
                case "split_node":
                  return R(R({}, e), {}, {
                    type: "merge_node",
                    path: m.next(e.path)
                  });
              }
            }
          },
          B = new WeakMap(),
          N = {
            above: (e, t) => e.above(t),
            addMark(e, t, n) {
              e.addMark(t, n);
            },
            after: (e, t, n) => e.after(t, n),
            before: (e, t, n) => e.before(t, n),
            deleteBackward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteBackward(n);
            },
            deleteForward(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                {
                  unit: n = "character"
                } = t;
              e.deleteForward(n);
            },
            deleteFragment(e, t) {
              e.deleteFragment(t);
            },
            edges: (e, t) => e.edges(t),
            elementReadOnly(e) {
              var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return e.elementReadOnly(t);
            },
            end: (e, t) => e.end(t),
            first: (e, t) => e.first(t),
            fragment: (e, t) => e.fragment(t),
            hasBlocks: (e, t) => e.hasBlocks(t),
            hasInlines: (e, t) => e.hasInlines(t),
            hasPath: (e, t) => e.hasPath(t),
            hasTexts: (e, t) => e.hasTexts(t),
            insertBreak(e) {
              e.insertBreak();
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertNode(e, t) {
              e.insertNode(t);
            },
            insertSoftBreak(e) {
              e.insertSoftBreak();
            },
            insertText(e, t) {
              e.insertText(t);
            },
            isBlock: (e, t) => e.isBlock(t),
            isEdge: (e, t, n) => e.isEdge(t, n),
            isEditor: e => (e => {
              var t = B.get(e);
              if (void 0 !== t) return t;
              if (!(0, r.P)(e)) return !1;
              var n = "function" == typeof e.addMark && "function" == typeof e.apply && "function" == typeof e.deleteFragment && "function" == typeof e.insertBreak && "function" == typeof e.insertSoftBreak && "function" == typeof e.insertFragment && "function" == typeof e.insertNode && "function" == typeof e.insertText && "function" == typeof e.isElementReadOnly && "function" == typeof e.isInline && "function" == typeof e.isSelectable && "function" == typeof e.isVoid && "function" == typeof e.normalizeNode && "function" == typeof e.onChange && "function" == typeof e.removeMark && "function" == typeof e.getDirtyPaths && (null === e.marks || (0, r.P)(e.marks)) && (null === e.selection || k.isRange(e.selection)) && F.isNodeList(e.children) && j.isOperationList(e.operations);
              return B.set(e, n), n;
            })(e),
            isElementReadOnly: (e, t) => e.isElementReadOnly(t),
            isEmpty: (e, t) => e.isEmpty(t),
            isEnd: (e, t, n) => e.isEnd(t, n),
            isInline: (e, t) => e.isInline(t),
            isNormalizing: e => e.isNormalizing(),
            isSelectable: (e, t) => e.isSelectable(t),
            isStart: (e, t, n) => e.isStart(t, n),
            isVoid: (e, t) => e.isVoid(t),
            last: (e, t) => e.last(t),
            leaf: (e, t, n) => e.leaf(t, n),
            levels: (e, t) => e.levels(t),
            marks: e => e.getMarks(),
            next: (e, t) => e.next(t),
            node: (e, t, n) => e.node(t, n),
            nodes: (e, t) => e.nodes(t),
            normalize(e, t) {
              e.normalize(t);
            },
            parent: (e, t, n) => e.parent(t, n),
            path: (e, t, n) => e.path(t, n),
            pathRef: (e, t, n) => e.pathRef(t, n),
            pathRefs: e => e.pathRefs(),
            point: (e, t, n) => e.point(t, n),
            pointRef: (e, t, n) => e.pointRef(t, n),
            pointRefs: e => e.pointRefs(),
            positions: (e, t) => e.positions(t),
            previous: (e, t) => e.previous(t),
            range: (e, t, n) => e.range(t, n),
            rangeRef: (e, t, n) => e.rangeRef(t, n),
            rangeRefs: e => e.rangeRefs(),
            removeMark(e, t) {
              e.removeMark(t);
            },
            setNormalizing(e, t) {
              e.setNormalizing(t);
            },
            start: (e, t) => e.start(t),
            string: (e, t, n) => e.string(t, n),
            unhangRange: (e, t, n) => e.unhangRange(t, n),
            void: (e, t) => e.void(t),
            withoutNormalizing(e, t) {
              e.withoutNormalizing(t);
            },
            shouldMergeNodesRemovePrevNode: (e, t, n) => e.shouldMergeNodesRemovePrevNode(t, n)
          },
          L = {
            isSpan: e => Array.isArray(e) && 2 === e.length && e.every(m.isPath)
          };
        function V(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function K(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? V(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : V(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var q = {
            compare(e, t) {
              var n = m.compare(e.path, t.path);
              return 0 === n ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
            },
            isAfter: (e, t) => 1 === q.compare(e, t),
            isBefore: (e, t) => -1 === q.compare(e, t),
            equals: (e, t) => e.offset === t.offset && m.equals(e.path, t.path),
            isPoint: e => (0, r.P)(e) && "number" == typeof e.offset && m.isPath(e.path),
            transform(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return (0, o.Uy)(e, e => {
                if (null === e) return null;
                var {
                    affinity: r = "forward"
                  } = n,
                  {
                    path: o,
                    offset: i
                  } = e;
                switch (t.type) {
                  case "insert_node":
                  case "move_node":
                    e.path = m.transform(o, t, n);
                    break;
                  case "insert_text":
                    m.equals(t.path, o) && (t.offset < i || t.offset === i && "forward" === r) && (e.offset += t.text.length);
                    break;
                  case "merge_node":
                    m.equals(t.path, o) && (e.offset += t.position), e.path = m.transform(o, t, n);
                    break;
                  case "remove_text":
                    m.equals(t.path, o) && t.offset <= i && (e.offset -= Math.min(i - t.offset, t.text.length));
                    break;
                  case "remove_node":
                    if (m.equals(t.path, o) || m.isAncestor(t.path, o)) return null;
                    e.path = m.transform(o, t, n);
                    break;
                  case "split_node":
                    if (m.equals(t.path, o)) {
                      if (t.position === i && null == r) return null;
                      (t.position < i || t.position === i && "forward" === r) && (e.offset -= t.position, e.path = m.transform(o, t, K(K({}, n), {}, {
                        affinity: "forward"
                      })));
                    } else e.path = m.transform(o, t, n);
                }
              });
            }
          },
          H = void 0,
          U = {
            setScrubber(e) {
              H = e;
            },
            stringify: e => JSON.stringify(e, H)
          },
          Z = ["text"],
          $ = ["anchor", "focus"];
        function G(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function W(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? G(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : G(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Y,
          X = {
            equals(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                {
                  loose: r = !1
                } = n;
              function o(e) {
                return E(e, Z);
              }
              return S(r ? o(e) : e, r ? o(t) : t);
            },
            isText: e => (0, r.P)(e) && "string" == typeof e.text,
            isTextList: e => Array.isArray(e) && e.every(e => X.isText(e)),
            isTextProps: e => void 0 !== e.text,
            matches(e, t) {
              for (var n in t) if ("text" !== n && (!e.hasOwnProperty(n) || e[n] !== t[n])) return !1;
              return !0;
            },
            decorations(e, t) {
              var n = [W({}, e)];
              for (var r of t) {
                var o = E(r, $),
                  [i, a] = k.edges(r),
                  s = [],
                  l = 0,
                  u = i.offset,
                  c = a.offset;
                for (var d of n) {
                  var {
                      length: p
                    } = d.text,
                    h = l;
                  if (l += p, u <= h && l <= c) Object.assign(d, o), s.push(d);else if (u !== c && (u === l || c === h) || u > l || c < h || c === h && 0 !== h) s.push(d);else {
                    var f = d,
                      m = void 0,
                      g = void 0;
                    if (c < l) {
                      var v = c - h;
                      g = W(W({}, f), {}, {
                        text: f.text.slice(v)
                      }), f = W(W({}, f), {}, {
                        text: f.text.slice(0, v)
                      });
                    }
                    if (u > h) {
                      var y = u - h;
                      m = W(W({}, f), {}, {
                        text: f.text.slice(0, y)
                      }), f = W(W({}, f), {}, {
                        text: f.text.slice(y)
                      });
                    }
                    Object.assign(f, o), m && s.push(m), s.push(f), g && s.push(g);
                  }
                }
                n = s;
              }
              return n;
            }
          },
          Q = e => e.selection ? e.selection : e.children.length > 0 ? N.end(e, []) : [0],
          J = (e, t) => {
            var [n] = N.node(e, t);
            return e => e === n;
          },
          ee = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
              n = !t,
              r = t ? se(e) : e,
              o = Y.None,
              i = Y.None,
              a = 0,
              s = null;
            for (var l of r) {
              var u = l.codePointAt(0);
              if (!u) break;
              var c = be(l, u);
              if ([o, i] = n ? [i, c] : [c, o], we(o, Y.ZWJ) && we(i, Y.ExtPict) && !Se(n ? e.substring(0, a) : e.substring(0, e.length - a))) break;
              if (we(o, Y.RI) && we(i, Y.RI) && !(s = null !== s ? !s : !!n || _e(e.substring(0, e.length - a)))) break;
              if (o !== Y.None && i !== Y.None && De(o, i)) break;
              a += l.length;
            }
            return a || 1;
          },
          te = /\s/,
          ne = /[\u002B\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/,
          re = /['\u2018\u2019]/,
          oe = function (e) {
            for (var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], n = 0, r = !1; e.length > 0;) {
              var o = ee(e, t),
                [i, a] = ie(e, o, t);
              if (ae(i, a, t)) r = !0, n += o;else {
                if (r) break;
                n += o;
              }
              e = a;
            }
            return n;
          },
          ie = (e, t, n) => {
            if (n) {
              var r = e.length - t;
              return [e.slice(r, e.length), e.slice(0, r)];
            }
            return [e.slice(0, t), e.slice(t)];
          },
          ae = function e(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
            if (te.test(t)) return !1;
            if (re.test(t)) {
              var o = ee(n, r),
                [i, a] = ie(n, o, r);
              if (e(i, a, r)) return !0;
            }
            return !ne.test(t);
          },
          se = function* (e) {
            for (var t = e.length - 1, n = 0; n < e.length; n++) {
              var r = e.charAt(t - n);
              if (ue(r.charCodeAt(0))) {
                var o = e.charAt(t - n - 1);
                if (le(o.charCodeAt(0))) {
                  yield o + r, n++;
                  continue;
                }
              }
              yield r;
            }
          },
          le = e => e >= 55296 && e <= 56319,
          ue = e => e >= 56320 && e <= 57343;
        !function (e) {
          e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
        }(Y || (Y = {}));
        var ce = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/,
          de = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/,
          pe = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/,
          he = /^[\u1100-\u115F\uA960-\uA97C]$/,
          fe = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/,
          me = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/,
          ge = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/,
          ve = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/,
          ye = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/,
          be = (e, t) => {
            var n = Y.Any;
            return -1 !== e.search(ce) && (n |= Y.Extend), 8205 === t && (n |= Y.ZWJ), t >= 127462 && t <= 127487 && (n |= Y.RI), -1 !== e.search(de) && (n |= Y.Prepend), -1 !== e.search(pe) && (n |= Y.SpacingMark), -1 !== e.search(he) && (n |= Y.L), -1 !== e.search(fe) && (n |= Y.V), -1 !== e.search(me) && (n |= Y.T), -1 !== e.search(ge) && (n |= Y.LV), -1 !== e.search(ve) && (n |= Y.LVT), -1 !== e.search(ye) && (n |= Y.ExtPict), n;
          };
        function we(e, t) {
          return 0 != (e & t);
        }
        var xe = [[Y.L, Y.L | Y.V | Y.LV | Y.LVT], [Y.LV | Y.V, Y.V | Y.T], [Y.LVT | Y.T, Y.T], [Y.Any, Y.Extend | Y.ZWJ], [Y.Any, Y.SpacingMark], [Y.Prepend, Y.Any], [Y.ZWJ, Y.ExtPict], [Y.RI, Y.RI]];
        function De(e, t) {
          return -1 === xe.findIndex(n => we(e, n[0]) && we(t, n[1]));
        }
        var Ce = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u0898-\u089F\u08CA-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3C\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECE\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732\u1733\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u180F\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ACE\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDEFD-\uDEFF\uDF46-\uDF50\uDF82-\uDF85]|\uD804[\uDC01\uDC38-\uDC46\uDC70\uDC73\uDC74\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDCC2\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDE41\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4\uDF00\uDF01\uDF36-\uDF3A\uDF40\uDF42]|\uD80D[\uDC40\uDC47-\uDC55]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD833[\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC8F\uDD30-\uDD36\uDEAE\uDEEC-\uDEEF]|\uD839[\uDCEC-\uDCEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/,
          Se = e => -1 !== e.search(Ce),
          Ee = /(?:\uD83C[\uDDE6-\uDDFF])+$/g,
          _e = e => {
            var t = e.match(Ee);
            return null !== t && t[0].length / 2 % 2 == 1;
          },
          Pe = {
            delete(e, t) {
              e.delete(t);
            },
            insertFragment(e, t, n) {
              e.insertFragment(t, n);
            },
            insertText(e, t) {
              var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              N.withoutNormalizing(e, () => {
                var {
                    voids: r = !1
                  } = n,
                  {
                    at: o = Q(e)
                  } = n;
                if (m.isPath(o) && (o = N.range(e, o)), k.isRange(o)) if (k.isCollapsed(o)) o = o.anchor;else {
                  var i = k.end(o);
                  if (!r && N.void(e, {
                    at: i
                  })) return;
                  var a = k.start(o),
                    s = N.pointRef(e, a),
                    l = N.pointRef(e, i);
                  ze.delete(e, {
                    at: o,
                    voids: r
                  });
                  var u = s.unref(),
                    c = l.unref();
                  o = u || c, ze.setSelection(e, {
                    anchor: o,
                    focus: o
                  });
                }
                if (!(!r && N.void(e, {
                  at: o
                }) || N.elementReadOnly(e, {
                  at: o
                }))) {
                  var {
                    path: d,
                    offset: p
                  } = o;
                  t.length > 0 && e.apply({
                    type: "insert_text",
                    path: d,
                    offset: p,
                    text: t
                  });
                }
              });
            }
          };
        function ke(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ae(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ke(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ke(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var ze = Ae(Ae(Ae(Ae({}, x), D), C), Pe),
          Te = new WeakMap(),
          Oe = (e, t, n) => {
            var r = Te.get(e) || !1;
            Te.set(e, !0);
            try {
              t(), n();
            } finally {
              Te.set(e, r);
            }
          };
        function Ie(e, t, n) {
          var r,
            o,
            i = l.get(e) || [],
            a = u.get(e) || new Set(),
            s = e => {
              if (e) {
                var t = e.join(",");
                o.has(t) || (o.add(t), r.push(e));
              }
            };
          if (n) for (var c of (r = [], o = new Set(), i)) {
            s(n(c));
          } else r = i, o = a;
          for (var d of t) s(d);
          l.set(e, r), u.set(e, o);
        }
        var Fe = (e, t) => {
            for (var n of N.pathRefs(e)) i.transform(n, t);
            for (var r of N.pointRefs(e)) a.transform(r, t);
            for (var o of N.rangeRefs(e)) s.transform(o, t);
            if (!(e => Te.get(e) || !1)(e)) {
              var l = m.operationCanTransformPath(t) ? e => m.transform(e, t) : void 0;
              Ie(e, e.getDirtyPaths(t), l);
            }
            ze.transform(e, t), e.operations.push(t), N.normalize(e, {
              operation: t
            }), "set_selection" === t.type && (e.marks = null), c.get(e) || (c.set(e, !0), Promise.resolve().then(() => {
              c.set(e, !1), e.onChange({
                operation: t
              }), e.operations = [];
            }));
          },
          Me = (e, t) => {
            switch (t.type) {
              case "insert_text":
              case "remove_text":
              case "set_node":
                var {
                  path: n
                } = t;
                return m.levels(n);
              case "insert_node":
                var {
                    node: r,
                    path: o
                  } = t,
                  i = m.levels(o),
                  a = X.isText(r) ? [] : Array.from(F.nodes(r), e => {
                    var [, t] = e;
                    return o.concat(t);
                  });
                return [...i, ...a];
              case "merge_node":
                var {
                  path: s
                } = t;
                return [...m.ancestors(s), m.previous(s)];
              case "move_node":
                var {
                  path: l,
                  newPath: u
                } = t;
                if (m.equals(l, u)) return [];
                var c = [],
                  d = [];
                for (var p of m.ancestors(l)) {
                  var h = m.transform(p, t);
                  c.push(h);
                }
                for (var f of m.ancestors(u)) {
                  var g = m.transform(f, t);
                  d.push(g);
                }
                var v = d[d.length - 1],
                  y = u[u.length - 1],
                  b = v.concat(y);
                return [...c, ...d, b];
              case "remove_node":
                var {
                  path: w
                } = t;
                return [...m.ancestors(w)];
              case "split_node":
                var {
                  path: x
                } = t;
                return [...m.levels(x), m.next(x)];
              default:
                return [];
            }
          },
          Re = e => {
            var {
              selection: t
            } = e;
            return t ? F.fragment(e, t) : [];
          },
          je = (e, t) => {
            var [n, r] = t;
            if (!X.isText(n)) if (z.isElement(n) && 0 === n.children.length) {
              ze.insertNodes(e, {
                text: ""
              }, {
                at: r.concat(0),
                voids: !0
              });
            } else for (var o = !N.isEditor(n) && z.isElement(n) && (e.isInline(n) || 0 === n.children.length || X.isText(n.children[0]) || e.isInline(n.children[0])), i = 0, a = 0; a < n.children.length; a++, i++) {
              var s = F.get(e, r);
              if (!X.isText(s)) {
                var l = s.children[i],
                  u = s.children[i - 1],
                  c = a === n.children.length - 1;
                if ((X.isText(l) || z.isElement(l) && e.isInline(l)) !== o) ze.removeNodes(e, {
                  at: r.concat(i),
                  voids: !0
                }), i--;else if (z.isElement(l)) {
                  if (e.isInline(l)) if (null != u && X.isText(u)) {
                    if (c) {
                      ze.insertNodes(e, {
                        text: ""
                      }, {
                        at: r.concat(i + 1),
                        voids: !0
                      }), i++;
                    }
                  } else {
                    ze.insertNodes(e, {
                      text: ""
                    }, {
                      at: r.concat(i),
                      voids: !0
                    }), i++;
                  }
                } else {
                  if (!X.isText(l) && !("children" in l)) l.children = [];
                  null != u && X.isText(u) && (X.equals(l, u, {
                    loose: !0
                  }) ? (ze.mergeNodes(e, {
                    at: r.concat(i),
                    voids: !0
                  }), i--) : "" === u.text ? (ze.removeNodes(e, {
                    at: r.concat(i - 1),
                    voids: !0
                  }), i--) : "" === l.text && (ze.removeNodes(e, {
                    at: r.concat(i),
                    voids: !0
                  }), i--));
                }
              }
            }
          },
          Be = (e, t) => {
            var {
                iteration: n,
                initialDirtyPathsLength: r
              } = t,
              o = 42 * r;
            if (n > o) throw new Error("Could not completely normalize the editor after ".concat(o, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
            return !0;
          },
          Ne = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                voids: n = !1,
                mode: r = "lowest",
                at: o = e.selection,
                match: i
              } = t;
            if (o) {
              var a = N.path(e, o),
                s = "lowest" === r;
              for (var [l, u] of N.levels(e, {
                at: a,
                voids: n,
                match: i,
                reverse: s
              })) if (!X.isText(l)) if (k.isRange(o)) {
                if (m.isAncestor(u, o.anchor.path) && m.isAncestor(u, o.focus.path)) return [l, u];
              } else if (!m.equals(a, u)) return [l, u];
            }
          };
        function Le(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function Ve(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Le(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Le(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ke = (e, t, n) => {
          var {
            selection: r
          } = e;
          if (r) {
            var o = (t, n) => {
                if (!X.isText(t)) return !1;
                var [r, o] = N.parent(e, n);
                return !e.isVoid(r) || e.markableVoid(r);
              },
              i = k.isExpanded(r),
              a = !1;
            if (!i) {
              var [s, l] = N.node(e, r);
              if (s && o(s, l)) {
                var [u] = N.parent(e, l);
                a = u && e.markableVoid(u);
              }
            }
            if (i || a) ze.setNodes(e, {
              [t]: n
            }, {
              match: o,
              split: !0,
              voids: !0
            });else {
              var d = Ve(Ve({}, N.marks(e) || {}), {}, {
                [t]: n
              });
              e.marks = d, c.get(e) || e.onChange();
            }
          }
        };
        function qe(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function He(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? qe(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qe(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ue = function (e, t) {
          var n,
            r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = N.point(e, t, {
              edge: "end"
            }),
            i = N.end(e, []),
            a = {
              anchor: o,
              focus: i
            },
            {
              distance: s = 1
            } = r,
            l = 0;
          for (var u of N.positions(e, He(He({}, r), {}, {
            at: a
          }))) {
            if (l > s) break;
            0 !== l && (n = u), l++;
          }
          return n;
        };
        function Ze(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function $e(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Ze(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ze(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var Ge = function (e, t) {
            var n,
              r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              o = N.start(e, []),
              i = N.point(e, t, {
                edge: "start"
              }),
              a = {
                anchor: o,
                focus: i
              },
              {
                distance: s = 1
              } = r,
              l = 0;
            for (var u of N.positions(e, $e($e({}, r), {}, {
              at: a,
              reverse: !0
            }))) {
              if (l > s) break;
              0 !== l && (n = u), l++;
            }
            return n;
          },
          We = (e, t) => {
            var {
              selection: n
            } = e;
            n && k.isCollapsed(n) && ze.delete(e, {
              unit: t,
              reverse: !0
            });
          },
          Ye = (e, t) => {
            var {
              selection: n
            } = e;
            n && k.isCollapsed(n) && ze.delete(e, {
              unit: t
            });
          },
          Xe = function (e) {
            var {
                direction: t = "forward"
              } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e;
            n && k.isExpanded(n) && ze.delete(e, {
              reverse: "backward" === t
            });
          },
          Qe = (e, t) => [N.start(e, t), N.end(e, t)];
        function Je(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function et(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Je(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Je(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var tt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return N.above(e, et(et({}, t), {}, {
              match: t => z.isElement(t) && N.isElementReadOnly(e, t)
            }));
          },
          nt = (e, t) => N.point(e, t, {
            edge: "end"
          }),
          rt = (e, t) => {
            var n = N.path(e, t, {
              edge: "start"
            });
            return N.node(e, n);
          },
          ot = (e, t) => {
            var n = N.range(e, t);
            return F.fragment(e, n);
          };
        function it(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function at(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? it(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : it(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var st = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return N.above(e, at(at({}, t), {}, {
              match: t => z.isElement(t) && N.isVoid(e, t)
            }));
          },
          lt = (e, t) => t.children.some(t => z.isElement(t) && N.isBlock(e, t)),
          ut = (e, t) => t.children.some(t => X.isText(t) || N.isInline(e, t)),
          ct = (e, t) => F.has(e, t),
          dt = (e, t) => t.children.every(e => X.isText(e)),
          pt = e => {
            ze.splitNodes(e, {
              always: !0
            });
          },
          ht = (e, t, n) => {
            ze.insertNodes(e, t, n);
          },
          ft = e => {
            ze.splitNodes(e, {
              always: !0
            });
          };
        function mt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function gt(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? mt(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mt(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var vt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r,
                marks: o
              } = e;
            if (r) {
              if (o) {
                var i = gt({
                  text: t
                }, o);
                ze.insertNodes(e, i, {
                  at: n.at,
                  voids: n.voids
                });
              } else ze.insertText(e, t, n);
              e.marks = null;
            }
          },
          yt = (e, t) => !e.isInline(t),
          bt = (e, t, n) => N.isStart(e, t, n) || N.isEnd(e, t, n),
          wt = (e, t) => {
            var {
                children: n
              } = t,
              [r] = n;
            return 0 === n.length || 1 === n.length && X.isText(r) && "" === r.text && !e.isVoid(t);
          },
          xt = (e, t, n) => {
            var r = N.end(e, n);
            return q.equals(t, r);
          },
          Dt = e => {
            var t = d.get(e);
            return void 0 === t || t;
          },
          Ct = (e, t, n) => {
            if (0 !== t.offset) return !1;
            var r = N.start(e, n);
            return q.equals(t, r);
          },
          St = (e, t) => {
            var n = N.path(e, t, {
              edge: "end"
            });
            return N.node(e, n);
          },
          Et = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = N.path(e, t, n),
              o = F.leaf(e, r);
            return [o, r];
          };
        function _t(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return function* () {
            var {
                at: n = e.selection,
                reverse: r = !1,
                voids: o = !1
              } = t,
              {
                match: i
              } = t;
            if (null == i && (i = () => !0), n) {
              var a = [],
                s = N.path(e, n);
              for (var [l, u] of F.levels(e, s)) if (i(l, u) && (a.push([l, u]), !o && z.isElement(l) && N.isVoid(e, l))) break;
              r && a.reverse(), yield* a;
            }
          }();
        }
        var Pt = ["text"],
          kt = ["text"],
          At = function (e) {
            var {
              marks: t,
              selection: n
            } = e;
            if (!n) return null;
            var {
              anchor: r,
              focus: o
            } = n;
            if (t) return t;
            if (k.isExpanded(n)) {
              if (N.isEnd(e, r, r.path)) {
                var i = N.after(e, r);
                i && (r = i);
              }
              var [a] = N.nodes(e, {
                match: X.isText,
                at: {
                  anchor: r,
                  focus: o
                }
              });
              if (a) {
                var [s] = a;
                return E(s, Pt);
              }
              return {};
            }
            var {
                path: l
              } = r,
              [u] = N.leaf(e, l);
            if (0 === r.offset) {
              var c = N.previous(e, {
                at: l,
                match: X.isText
              });
              if (!N.above(e, {
                match: t => z.isElement(t) && N.isVoid(e, t) && e.markableVoid(t)
              })) {
                var d = N.above(e, {
                  match: t => z.isElement(t) && N.isBlock(e, t)
                });
                if (c && d) {
                  var [p, h] = c,
                    [, f] = d;
                  m.isAncestor(f, h) && (u = p);
                }
              }
            }
            return E(u, kt);
          },
          zt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = N.after(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = N.last(e, []),
                  l = [a.path, s];
                if (m.isPath(i) && 0 === i.length) throw new Error("Cannot get the next node from the root node!");
                if (null == o) if (m.isPath(i)) {
                  var [u] = N.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = N.nodes(e, {
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          Tt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = N.path(e, t, n),
              o = F.get(e, r);
            return [o, r];
          };
        function Ot(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return function* () {
            var {
                at: n = e.selection,
                mode: r = "all",
                universal: o = !1,
                reverse: i = !1,
                voids: a = !1,
                ignoreNonSelectable: s = !1
              } = t,
              {
                match: l
              } = t;
            if (l || (l = () => !0), n) {
              var u, c;
              if (L.isSpan(n)) u = n[0], c = n[1];else {
                var d = N.path(e, n, {
                    edge: "start"
                  }),
                  p = N.path(e, n, {
                    edge: "end"
                  });
                u = i ? p : d, c = i ? d : p;
              }
              var h,
                f = F.nodes(e, {
                  reverse: i,
                  from: u,
                  to: c,
                  pass: t => {
                    var [n] = t;
                    return !!z.isElement(n) && (!(a || !N.isVoid(e, n) && !N.isElementReadOnly(e, n)) || !(!s || N.isSelectable(e, n)));
                  }
                }),
                g = [];
              for (var [v, y] of f) if (!s || !z.isElement(v) || N.isSelectable(e, v)) {
                var b = h && 0 === m.compare(y, h[1]);
                if ("highest" !== r || !b) if (l(v, y)) {
                  if ("lowest" === r && b) h = [v, y];else {
                    var w = "lowest" === r ? h : [v, y];
                    w && (o ? g.push(w) : yield w), h = [v, y];
                  }
                } else if (o && !b && X.isText(v)) return;
              }
              "lowest" === r && h && (o ? g.push(h) : yield h), o && (yield* g);
            }
          }();
        }
        var It = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                force: n = !1,
                operation: r
              } = t,
              o = e => l.get(e) || [],
              i = e => u.get(e) || new Set(),
              a = e => {
                var t = o(e).pop(),
                  n = t.join(",");
                return i(e).delete(n), t;
              };
            if (N.isNormalizing(e)) {
              if (n) {
                var s = Array.from(F.nodes(e), e => {
                    var [, t] = e;
                    return t;
                  }),
                  c = new Set(s.map(e => e.join(",")));
                l.set(e, s), u.set(e, c);
              }
              0 !== o(e).length && N.withoutNormalizing(e, () => {
                for (var t of o(e)) if (F.has(e, t)) {
                  var n = N.node(e, t),
                    [i, s] = n;
                  z.isElement(i) && 0 === i.children.length && e.normalizeNode(n, {
                    operation: r
                  });
                }
                for (var l = o(e), u = l.length, c = 0; 0 !== l.length;) {
                  if (!e.shouldNormalize({
                    dirtyPaths: l,
                    iteration: c,
                    initialDirtyPathsLength: u,
                    operation: r
                  })) return;
                  var d = a(e);
                  if (F.has(e, d)) {
                    var p = N.node(e, d);
                    e.normalizeNode(p, {
                      operation: r
                    });
                  }
                  c++, l = o(e);
                }
              });
            }
          },
          Ft = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = N.path(e, t, n),
              o = m.parent(r),
              i = N.node(e, o);
            return i;
          },
          Mt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return N.pathRefs(e).delete(o), o.current = null, t;
                }
              },
              i = N.pathRefs(e);
            return i.add(o), o;
          },
          Rt = e => {
            var t = p.get(e);
            return t || (t = new Set(), p.set(e, t)), t;
          },
          jt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                depth: r,
                edge: o
              } = n;
            if (m.isPath(t)) if ("start" === o) {
              var [, i] = F.first(e, t);
              t = i;
            } else if ("end" === o) {
              var [, a] = F.last(e, t);
              t = a;
            }
            return k.isRange(t) && (t = "start" === o ? k.start(t) : "end" === o ? k.end(t) : m.common(t.anchor.path, t.focus.path)), q.isPoint(t) && (t = t.path), null != r && (t = t.slice(0, r)), t;
          },
          Bt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return N.pointRefs(e).delete(o), o.current = null, t;
                }
              },
              i = N.pointRefs(e);
            return i.add(o), o;
          },
          Nt = e => {
            var t = h.get(e);
            return t || (t = new Set(), h.set(e, t)), t;
          },
          Lt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                edge: r = "start"
              } = n;
            if (m.isPath(t)) {
              var o;
              if ("end" === r) {
                var [, i] = F.last(e, t);
                o = i;
              } else {
                var [, a] = F.first(e, t);
                o = a;
              }
              var s = F.get(e, o);
              if (!X.isText(s)) throw new Error("Cannot get the ".concat(r, " point in the node at path [").concat(t, "] because it has no ").concat(r, " text node."));
              return {
                path: o,
                offset: "end" === r ? s.text.length : 0
              };
            }
            if (k.isRange(t)) {
              var [l, u] = k.edges(t);
              return "start" === r ? l : u;
            }
            return t;
          };
        function Vt(e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return function* () {
            var {
              at: n = e.selection,
              unit: r = "offset",
              reverse: o = !1,
              voids: i = !1,
              ignoreNonSelectable: a = !1
            } = t;
            if (n) {
              var s = N.range(e, n),
                [l, u] = k.edges(s),
                c = o ? u : l,
                d = !1,
                p = "",
                h = 0,
                f = 0,
                g = 0;
              for (var [v, y] of N.nodes(e, {
                at: n,
                reverse: o,
                voids: i,
                ignoreNonSelectable: a
              })) {
                if (z.isElement(v)) {
                  if (!i && (e.isVoid(v) || e.isElementReadOnly(v))) {
                    yield N.start(e, y);
                    continue;
                  }
                  if (e.isInline(v)) continue;
                  if (N.hasInlines(e, v)) {
                    var b = m.isAncestor(y, u.path) ? u : N.end(e, y),
                      w = m.isAncestor(y, l.path) ? l : N.start(e, y);
                    p = N.string(e, {
                      anchor: w,
                      focus: b
                    }, {
                      voids: i
                    }), d = !0;
                  }
                }
                if (X.isText(v)) {
                  var x = m.equals(y, c.path);
                  for (x ? (f = o ? c.offset : v.text.length - c.offset, g = c.offset) : (f = v.text.length, g = o ? f : 0), (x || d || "offset" === r) && (yield {
                    path: y,
                    offset: g
                  }, d = !1);;) {
                    if (0 === h) {
                      if ("" === p) break;
                      h = D(p, r, o), p = ie(p, h, o)[1];
                    }
                    if (g = o ? g - h : g + h, (f -= h) < 0) {
                      h = -f;
                      break;
                    }
                    h = 0, yield {
                      path: y,
                      offset: g
                    };
                  }
                }
              }
            }
            function D(e, t, n) {
              return "character" === t ? ee(e, n) : "word" === t ? oe(e, n) : "line" === t || "block" === t ? e.length : 1;
            }
          }();
        }
        var Kt = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                mode: n = "lowest",
                voids: r = !1
              } = t,
              {
                match: o,
                at: i = e.selection
              } = t;
            if (i) {
              var a = N.before(e, i, {
                voids: r
              });
              if (a) {
                var [, s] = N.first(e, []),
                  l = [a.path, s];
                if (m.isPath(i) && 0 === i.length) throw new Error("Cannot get the previous node from the root node!");
                if (null == o) if (m.isPath(i)) {
                  var [u] = N.parent(e, i);
                  o = e => u.children.includes(e);
                } else o = () => !0;
                var [c] = N.nodes(e, {
                  reverse: !0,
                  at: l,
                  match: o,
                  mode: n,
                  voids: r
                });
                return c;
              }
            }
          },
          qt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                affinity: r = "forward"
              } = n,
              o = {
                current: t,
                affinity: r,
                unref() {
                  var {
                    current: t
                  } = o;
                  return N.rangeRefs(e).delete(o), o.current = null, t;
                }
              },
              i = N.rangeRefs(e);
            return i.add(o), o;
          },
          Ht = e => {
            var t = f.get(e);
            return t || (t = new Set(), f.set(e, t)), t;
          },
          Ut = (e, t, n) => k.isRange(t) && !n ? t : {
            anchor: N.start(e, t),
            focus: N.end(e, n || t)
          };
        function Zt(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        var $t = (e, t) => {
            var {
              selection: n
            } = e;
            if (n) {
              var r = (t, n) => {
                  if (!X.isText(t)) return !1;
                  var [r, o] = N.parent(e, n);
                  return !e.isVoid(r) || e.markableVoid(r);
                },
                o = k.isExpanded(n),
                i = !1;
              if (!o) {
                var [a, s] = N.node(e, n);
                if (a && r(a, s)) {
                  var [l] = N.parent(e, s);
                  i = l && e.markableVoid(l);
                }
              }
              if (o || i) ze.unsetNodes(e, t, {
                match: r,
                split: !0,
                voids: !0
              });else {
                var u = function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? Zt(Object(n), !0).forEach(function (t) {
                      y(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zt(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                  }
                  return e;
                }({}, N.marks(e) || {});
                delete u[t], e.marks = u, c.get(e) || e.onChange();
              }
            }
          },
          Gt = (e, t) => {
            d.set(e, t);
          },
          Wt = (e, t) => N.point(e, t, {
            edge: "start"
          }),
          Yt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              o = N.range(e, t),
              [i, a] = k.edges(o),
              s = "";
            for (var [l, u] of N.nodes(e, {
              at: o,
              match: X.isText,
              voids: r
            })) {
              var c = l.text;
              m.equals(u, a.path) && (c = c.slice(0, a.offset)), m.equals(u, i.path) && (c = c.slice(i.offset)), s += c;
            }
            return s;
          },
          Xt = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                voids: r = !1
              } = n,
              [o, i] = k.edges(t);
            if (0 !== o.offset || 0 !== i.offset || k.isCollapsed(t) || m.hasPrevious(i.path)) return t;
            var a = N.above(e, {
                at: i,
                match: t => z.isElement(t) && N.isBlock(e, t),
                voids: r
              }),
              s = a ? a[1] : [],
              l = N.start(e, o),
              u = {
                anchor: l,
                focus: i
              },
              c = !0;
            for (var [d, p] of N.nodes(e, {
              at: u,
              match: X.isText,
              reverse: !0,
              voids: r
            })) if (c) c = !1;else if ("" !== d.text || m.isBefore(p, s)) {
              i = {
                path: p,
                offset: d.text.length
              };
              break;
            }
            return {
              anchor: o,
              focus: i
            };
          },
          Qt = (e, t) => {
            var n = N.isNormalizing(e);
            N.setNormalizing(e, !1);
            try {
              t();
            } finally {
              N.setNormalizing(e, n);
            }
            N.normalize(e);
          },
          Jt = (e, t, n) => {
            var [r, o] = t;
            return z.isElement(r) && N.isEmpty(e, r) || X.isText(r) && "" === r.text && 0 !== o[o.length - 1];
          },
          en = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var n,
                r,
                {
                  reverse: o = !1,
                  unit: i = "character",
                  distance: a = 1,
                  voids: s = !1
                } = t,
                {
                  at: l = e.selection,
                  hanging: u = !1
                } = t;
              if (l) {
                var c = !1;
                if (k.isRange(l) && k.isCollapsed(l) && (c = !0, l = l.anchor), q.isPoint(l)) {
                  var d = N.void(e, {
                    at: l,
                    mode: "highest"
                  });
                  if (!s && d) {
                    var [, p] = d;
                    l = p;
                  } else {
                    var h = {
                      unit: i,
                      distance: a
                    };
                    l = {
                      anchor: l,
                      focus: o ? N.before(e, l, h) || N.start(e, []) : N.after(e, l, h) || N.end(e, [])
                    }, u = !0;
                  }
                }
                if (m.isPath(l)) ze.removeNodes(e, {
                  at: l,
                  voids: s
                });else if (!k.isCollapsed(l)) {
                  if (!u) {
                    var [, f] = k.edges(l),
                      g = N.end(e, []);
                    q.equals(f, g) || (l = N.unhangRange(e, l, {
                      voids: s
                    }));
                  }
                  var [v, y] = k.edges(l),
                    b = N.above(e, {
                      match: t => z.isElement(t) && N.isBlock(e, t),
                      at: v,
                      voids: s
                    }),
                    w = N.above(e, {
                      match: t => z.isElement(t) && N.isBlock(e, t),
                      at: y,
                      voids: s
                    }),
                    x = b && w && !m.equals(b[1], w[1]),
                    D = m.equals(v.path, y.path),
                    C = s ? null : null !== (n = N.void(e, {
                      at: v,
                      mode: "highest"
                    })) && void 0 !== n ? n : N.elementReadOnly(e, {
                      at: v,
                      mode: "highest"
                    }),
                    S = s ? null : null !== (r = N.void(e, {
                      at: y,
                      mode: "highest"
                    })) && void 0 !== r ? r : N.elementReadOnly(e, {
                      at: y,
                      mode: "highest"
                    });
                  if (C) {
                    var E = N.before(e, v);
                    E && b && m.isAncestor(b[1], E.path) && (v = E);
                  }
                  if (S) {
                    var _ = N.after(e, y);
                    _ && w && m.isAncestor(w[1], _.path) && (y = _);
                  }
                  var P,
                    A = [];
                  for (var T of N.nodes(e, {
                    at: l,
                    voids: s
                  })) {
                    var [O, I] = T;
                    P && 0 === m.compare(I, P) || (!s && z.isElement(O) && (N.isVoid(e, O) || N.isElementReadOnly(e, O)) || !m.isCommon(I, v.path) && !m.isCommon(I, y.path)) && (A.push(T), P = I);
                  }
                  var F = Array.from(A, t => {
                      var [, n] = t;
                      return N.pathRef(e, n);
                    }),
                    M = N.pointRef(e, v),
                    R = N.pointRef(e, y),
                    j = "";
                  if (!D && !C) {
                    var B = M.current,
                      [L] = N.leaf(e, B),
                      {
                        path: V
                      } = B,
                      {
                        offset: K
                      } = v,
                      H = L.text.slice(K);
                    H.length > 0 && (e.apply({
                      type: "remove_text",
                      path: V,
                      offset: K,
                      text: H
                    }), j = H);
                  }
                  if (F.reverse().map(e => e.unref()).filter(e => null !== e).forEach(t => ze.removeNodes(e, {
                    at: t,
                    voids: s
                  })), !S) {
                    var U = R.current,
                      [Z] = N.leaf(e, U),
                      {
                        path: $
                      } = U,
                      G = D ? v.offset : 0,
                      W = Z.text.slice(G, y.offset);
                    W.length > 0 && (e.apply({
                      type: "remove_text",
                      path: $,
                      offset: G,
                      text: W
                    }), j = W);
                  }
                  !D && x && R.current && M.current && ze.mergeNodes(e, {
                    at: R.current,
                    hanging: !0,
                    voids: s
                  }), c && o && "character" === i && j.length > 1 && j.match(/[\u0E00-\u0E7F]+/) && ze.insertText(e, j.slice(0, j.length - a));
                  var Y = M.unref(),
                    X = R.unref(),
                    Q = o ? Y || X : X || Y;
                  null == t.at && Q && ze.select(e, Q);
                }
              }
            });
          },
          tn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            N.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1
                } = n,
                {
                  at: i = Q(e),
                  batchDirty: a = !0
                } = n;
              if (t.length) {
                if (k.isRange(i)) {
                  if (r || (i = N.unhangRange(e, i, {
                    voids: o
                  })), k.isCollapsed(i)) i = i.anchor;else {
                    var [, s] = k.edges(i);
                    if (!o && N.void(e, {
                      at: s
                    })) return;
                    var l = N.pointRef(e, s);
                    ze.delete(e, {
                      at: i
                    }), i = l.unref();
                  }
                } else m.isPath(i) && (i = N.start(e, i));
                if (o || !N.void(e, {
                  at: i
                })) {
                  var u = N.above(e, {
                    at: i,
                    match: t => z.isElement(t) && N.isInline(e, t),
                    mode: "highest",
                    voids: o
                  });
                  if (u) {
                    var [, c] = u;
                    if (N.isEnd(e, i, c)) i = N.after(e, c);else if (N.isStart(e, i, c)) {
                      i = N.before(e, c);
                    }
                  }
                  var d = N.above(e, {
                      match: t => z.isElement(t) && N.isBlock(e, t),
                      at: i,
                      voids: o
                    }),
                    [, p] = d,
                    h = N.isStart(e, i, p),
                    f = N.isEnd(e, i, p),
                    g = h && f,
                    v = !h || h && f,
                    y = !f,
                    [, b] = F.first({
                      children: t
                    }, []),
                    [, w] = F.last({
                      children: t
                    }, []),
                    x = [],
                    D = t => {
                      var [n, r] = t;
                      return !(0 === r.length) && (!!g || !(v && m.isAncestor(r, b) && z.isElement(n) && !e.isVoid(n) && !e.isInline(n)) && !(y && m.isAncestor(r, w) && z.isElement(n) && !e.isVoid(n) && !e.isInline(n)));
                    };
                  for (var C of F.nodes({
                    children: t
                  }, {
                    pass: D
                  })) D(C) && x.push(C);
                  var S = [],
                    E = [],
                    _ = [],
                    P = !0,
                    A = !1;
                  for (var [T] of x) z.isElement(T) && !e.isInline(T) ? (P = !1, A = !0, E.push(T)) : P ? S.push(T) : _.push(T);
                  var [O] = N.nodes(e, {
                      at: i,
                      match: t => X.isText(t) || N.isInline(e, t),
                      mode: "highest",
                      voids: o
                    }),
                    [, I] = O,
                    M = N.isStart(e, i, I),
                    R = N.isEnd(e, i, I),
                    j = N.pathRef(e, f && !_.length ? m.next(p) : p),
                    B = N.pathRef(e, R ? m.next(I) : I);
                  ze.splitNodes(e, {
                    at: i,
                    match: t => A ? z.isElement(t) && N.isBlock(e, t) : X.isText(t) || N.isInline(e, t),
                    mode: A ? "lowest" : "highest",
                    always: A && (!h || S.length > 0) && (!f || _.length > 0),
                    voids: o
                  });
                  var L,
                    V = N.pathRef(e, !M || M && R ? m.next(I) : I);
                  if (ze.insertNodes(e, S, {
                    at: V.current,
                    match: t => X.isText(t) || N.isInline(e, t),
                    mode: "highest",
                    voids: o,
                    batchDirty: a
                  }), g && !S.length && E.length && !_.length && ze.delete(e, {
                    at: p,
                    voids: o
                  }), ze.insertNodes(e, E, {
                    at: j.current,
                    match: t => z.isElement(t) && N.isBlock(e, t),
                    mode: "lowest",
                    voids: o,
                    batchDirty: a
                  }), ze.insertNodes(e, _, {
                    at: B.current,
                    match: t => X.isText(t) || N.isInline(e, t),
                    mode: "highest",
                    voids: o,
                    batchDirty: a
                  }), !n.at) if (_.length > 0 && B.current ? L = m.previous(B.current) : E.length > 0 && j.current ? L = m.previous(j.current) : V.current && (L = m.previous(V.current)), L) {
                    var K = N.end(e, L);
                    ze.select(e, K);
                  }
                  V.unref(), j.unref(), B.unref();
                }
              }
            });
          },
          nn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                edge: n = "anchor"
              } = t,
              {
                selection: r
              } = e;
            if (r) if ("anchor" === n) ze.select(e, r.anchor);else if ("focus" === n) ze.select(e, r.focus);else if ("start" === n) {
              var [o] = k.edges(r);
              ze.select(e, o);
            } else if ("end" === n) {
              var [, i] = k.edges(r);
              ze.select(e, i);
            }
          },
          rn = e => {
            var {
              selection: t
            } = e;
            t && e.apply({
              type: "set_selection",
              properties: t,
              newProperties: null
            });
          },
          on = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              {
                selection: n
              } = e,
              {
                distance: r = 1,
                unit: o = "character",
                reverse: i = !1
              } = t,
              {
                edge: a = null
              } = t;
            if (n) {
              "start" === a && (a = k.isBackward(n) ? "focus" : "anchor"), "end" === a && (a = k.isBackward(n) ? "anchor" : "focus");
              var {
                  anchor: s,
                  focus: l
                } = n,
                u = {
                  distance: r,
                  unit: o,
                  ignoreNonSelectable: !0
                },
                c = {};
              if (null == a || "anchor" === a) {
                var d = i ? N.before(e, s, u) : N.after(e, s, u);
                d && (c.anchor = d);
              }
              if (null == a || "focus" === a) {
                var p = i ? N.before(e, l, u) : N.after(e, l, u);
                p && (c.focus = p);
              }
              ze.setSelection(e, c);
            }
          },
          an = (e, t) => {
            var {
              selection: n
            } = e;
            if (t = N.range(e, t), n) ze.setSelection(e, t);else {
              if (!k.isRange(t)) throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(U.stringify(t)));
              e.apply({
                type: "set_selection",
                properties: n,
                newProperties: t
              });
            }
          };
        function sn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function ln(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? sn(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : sn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var un = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              {
                selection: r
              } = e,
              {
                edge: o = "both"
              } = n;
            if (r) {
              "start" === o && (o = k.isBackward(r) ? "focus" : "anchor"), "end" === o && (o = k.isBackward(r) ? "anchor" : "focus");
              var {
                  anchor: i,
                  focus: a
                } = r,
                s = "anchor" === o ? i : a;
              ze.setSelection(e, {
                ["anchor" === o ? "anchor" : "focus"]: ln(ln({}, s), t)
              });
            }
          },
          cn = (e, t) => {
            var {
                selection: n
              } = e,
              r = {},
              o = {};
            if (n) {
              for (var i in t) ("anchor" === i && null != t.anchor && !q.equals(t.anchor, n.anchor) || "focus" === i && null != t.focus && !q.equals(t.focus, n.focus) || "anchor" !== i && "focus" !== i && t[i] !== n[i]) && (r[i] = n[i], o[i] = t[i]);
              Object.keys(r).length > 0 && e.apply({
                type: "set_selection",
                properties: r,
                newProperties: o
              });
            }
          },
          dn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            N.withoutNormalizing(e, () => {
              var {
                  hanging: r = !1,
                  voids: o = !1,
                  mode: i = "lowest",
                  batchDirty: a = !0
                } = n,
                {
                  at: s,
                  match: l,
                  select: u
                } = n;
              if (F.isNode(t) && (t = [t]), 0 !== t.length) {
                var [c] = t;
                if (s || (s = Q(e), !1 !== u && (u = !0)), null == u && (u = !1), k.isRange(s)) if (r || (s = N.unhangRange(e, s, {
                  voids: o
                })), k.isCollapsed(s)) s = s.anchor;else {
                  var [, d] = k.edges(s),
                    p = N.pointRef(e, d);
                  ze.delete(e, {
                    at: s
                  }), s = p.unref();
                }
                if (q.isPoint(s)) {
                  null == l && (l = X.isText(c) ? e => X.isText(e) : e.isInline(c) ? t => X.isText(t) || N.isInline(e, t) : t => z.isElement(t) && N.isBlock(e, t));
                  var [h] = N.nodes(e, {
                    at: s.path,
                    match: l,
                    mode: i,
                    voids: o
                  });
                  if (!h) return;
                  var [, f] = h,
                    g = N.pathRef(e, f),
                    v = N.isEnd(e, s, f);
                  ze.splitNodes(e, {
                    at: s,
                    match: l,
                    mode: i,
                    voids: o
                  });
                  var y = g.unref();
                  s = v ? m.next(y) : y;
                }
                var b = m.parent(s),
                  w = s[s.length - 1];
                if (o || !N.void(e, {
                  at: b
                })) {
                  if (a) {
                    var x = [],
                      D = m.levels(b);
                    Oe(e, () => {
                      var n = function () {
                        var t = b.concat(w);
                        w++;
                        var n = {
                          type: "insert_node",
                          path: t,
                          node: r
                        };
                        e.apply(n), s = m.next(s), x.push(n), X.isText ? D.push(...Array.from(F.nodes(r), e => {
                          var [, n] = e;
                          return t.concat(n);
                        })) : D.push(t);
                      };
                      for (var r of t) n();
                    }, () => {
                      Ie(e, D, e => {
                        var t = e;
                        for (var n of x) if (m.operationCanTransformPath(n) && !(t = m.transform(t, n))) return null;
                        return t;
                      });
                    });
                  } else for (var C of t) {
                    var S = b.concat(w);
                    w++, e.apply({
                      type: "insert_node",
                      path: S,
                      node: C
                    }), s = m.next(s);
                  }
                  if (s = m.previous(s), u) {
                    var E = N.end(e, s);
                    E && ze.select(e, E);
                  }
                }
              }
            });
          },
          pn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var {
                  at: n = e.selection,
                  mode: r = "lowest",
                  voids: o = !1
                } = t,
                {
                  match: i
                } = t;
              if (null == i && (i = m.isPath(n) ? J(e, n) : t => z.isElement(t) && N.isBlock(e, t)), n) {
                var a = N.nodes(e, {
                    at: n,
                    match: i,
                    mode: r,
                    voids: o
                  }),
                  s = Array.from(a, t => {
                    var [, n] = t;
                    return N.pathRef(e, n);
                  });
                for (var l of s) {
                  var u = l.unref();
                  if (u.length < 2) throw new Error("Cannot lift node at a path [".concat(u, "] because it has a depth of less than `2`."));
                  var c = N.node(e, m.parent(u)),
                    [d, p] = c,
                    h = u[u.length - 1],
                    {
                      length: f
                    } = d.children;
                  if (1 === f) {
                    var g = m.next(p);
                    ze.moveNodes(e, {
                      at: u,
                      to: g,
                      voids: o
                    }), ze.removeNodes(e, {
                      at: p,
                      voids: o
                    });
                  } else if (0 === h) ze.moveNodes(e, {
                    at: u,
                    to: p,
                    voids: o
                  });else if (h === f - 1) {
                    var v = m.next(p);
                    ze.moveNodes(e, {
                      at: u,
                      to: v,
                      voids: o
                    });
                  } else {
                    var y = m.next(u),
                      b = m.next(p);
                    ze.splitNodes(e, {
                      at: y,
                      voids: o
                    }), ze.moveNodes(e, {
                      at: u,
                      to: b,
                      voids: o
                    });
                  }
                }
              }
            });
          },
          hn = ["text"],
          fn = ["children"],
          mn = (e, t) => {
            if (z.isElement(t)) {
              var n = t;
              return !!N.isVoid(e, t) || 1 === n.children.length && mn(e, n.children[0]);
            }
            return !N.isEditor(t);
          },
          gn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var {
                  match: n,
                  at: r = e.selection
                } = t,
                {
                  hanging: o = !1,
                  voids: i = !1,
                  mode: a = "lowest"
                } = t;
              if (r) {
                if (null == n) if (m.isPath(r)) {
                  var [s] = N.parent(e, r);
                  n = e => s.children.includes(e);
                } else n = t => z.isElement(t) && N.isBlock(e, t);
                if (!o && k.isRange(r) && (r = N.unhangRange(e, r, {
                  voids: i
                })), k.isRange(r)) if (k.isCollapsed(r)) r = r.anchor;else {
                  var [, l] = k.edges(r),
                    u = N.pointRef(e, l);
                  ze.delete(e, {
                    at: r
                  }), r = u.unref(), null == t.at && ze.select(e, r);
                }
                var [c] = N.nodes(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  }),
                  d = N.previous(e, {
                    at: r,
                    match: n,
                    voids: i,
                    mode: a
                  });
                if (c && d) {
                  var [p, h] = c,
                    [f, g] = d;
                  if (0 !== h.length && 0 !== g.length) {
                    var v,
                      y,
                      b = m.next(g),
                      w = m.common(h, g),
                      x = m.isSibling(h, g),
                      D = Array.from(N.levels(e, {
                        at: h
                      }), e => {
                        var [t] = e;
                        return t;
                      }).slice(w.length).slice(0, -1),
                      C = N.above(e, {
                        at: h,
                        mode: "highest",
                        match: t => D.includes(t) && mn(e, t)
                      }),
                      S = C && N.pathRef(e, C[1]);
                    if (X.isText(p) && X.isText(f)) {
                      var _ = E(p, hn);
                      y = f.text.length, v = _;
                    } else {
                      if (!z.isElement(p) || !z.isElement(f)) throw new Error("Cannot merge the node at path [".concat(h, "] with the previous sibling because it is not the same kind: ").concat(U.stringify(p), " ").concat(U.stringify(f)));
                      _ = E(p, fn);
                      y = f.children.length, v = _;
                    }
                    x || ze.moveNodes(e, {
                      at: h,
                      to: b,
                      voids: i
                    }), S && ze.removeNodes(e, {
                      at: S.current,
                      voids: i
                    }), N.shouldMergeNodesRemovePrevNode(e, d, c) ? ze.removeNodes(e, {
                      at: g,
                      voids: i
                    }) : e.apply({
                      type: "merge_node",
                      path: b,
                      position: y,
                      properties: v
                    }), S && S.unref();
                  }
                }
              }
            });
          },
          vn = (e, t) => {
            N.withoutNormalizing(e, () => {
              var {
                  to: n,
                  at: r = e.selection,
                  mode: o = "lowest",
                  voids: i = !1
                } = t,
                {
                  match: a
                } = t;
              if (r) {
                null == a && (a = m.isPath(r) ? J(e, r) : t => z.isElement(t) && N.isBlock(e, t));
                var s = N.pathRef(e, n),
                  l = N.nodes(e, {
                    at: r,
                    match: a,
                    mode: o,
                    voids: i
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return N.pathRef(e, n);
                  });
                for (var c of u) {
                  var d = c.unref(),
                    p = s.current;
                  0 !== d.length && e.apply({
                    type: "move_node",
                    path: d,
                    newPath: p
                  }), s.current && m.isSibling(p, d) && m.isAfter(p, d) && (s.current = m.next(s.current));
                }
                s.unref();
              }
            });
          },
          yn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var {
                  hanging: n = !1,
                  voids: r = !1,
                  mode: o = "lowest"
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = m.isPath(i) ? J(e, i) : t => z.isElement(t) && N.isBlock(e, t)), !n && k.isRange(i) && (i = N.unhangRange(e, i, {
                  voids: r
                }));
                var s = N.nodes(e, {
                    at: i,
                    match: a,
                    mode: o,
                    voids: r
                  }),
                  l = Array.from(s, t => {
                    var [, n] = t;
                    return N.pathRef(e, n);
                  });
                for (var u of l) {
                  var c = u.unref();
                  if (c) {
                    var [d] = N.node(e, c);
                    e.apply({
                      type: "remove_node",
                      path: c,
                      node: d
                    });
                  }
                }
              }
            });
          },
          bn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            N.withoutNormalizing(e, () => {
              var {
                  match: r,
                  at: o = e.selection,
                  compare: i,
                  merge: a
                } = n,
                {
                  hanging: s = !1,
                  mode: l = "lowest",
                  split: u = !1,
                  voids: c = !1
                } = n;
              if (o) {
                if (null == r && (r = m.isPath(o) ? J(e, o) : t => z.isElement(t) && N.isBlock(e, t)), !s && k.isRange(o) && (o = N.unhangRange(e, o, {
                  voids: c
                })), u && k.isRange(o)) {
                  if (k.isCollapsed(o) && N.leaf(e, o.anchor)[0].text.length > 0) return;
                  var d = N.rangeRef(e, o, {
                      affinity: "inward"
                    }),
                    [p, h] = k.edges(o),
                    f = "lowest" === l ? "lowest" : "highest",
                    g = N.isEnd(e, h, h.path);
                  ze.splitNodes(e, {
                    at: h,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !g
                  });
                  var v = N.isStart(e, p, p.path);
                  ze.splitNodes(e, {
                    at: p,
                    match: r,
                    mode: f,
                    voids: c,
                    always: !v
                  }), o = d.unref(), null == n.at && ze.select(e, o);
                }
                for (var [y, b] of (i || (i = (e, t) => e !== t), N.nodes(e, {
                  at: o,
                  match: r,
                  mode: l,
                  voids: c
                }))) {
                  var w = {},
                    x = {};
                  if (0 !== b.length) {
                    var D = !1;
                    for (var C in t) "children" !== C && "text" !== C && i(t[C], y[C]) && (D = !0, y.hasOwnProperty(C) && (w[C] = y[C]), a ? null != t[C] && (x[C] = a(y[C], t[C])) : null != t[C] && (x[C] = t[C]));
                    D && e.apply({
                      type: "set_node",
                      path: b,
                      properties: w,
                      newProperties: x
                    });
                  }
                }
              }
            });
          },
          wn = (e, t) => {
            if (k.isCollapsed(t)) return t.anchor;
            var [, n] = k.edges(t),
              r = N.pointRef(e, n);
            return ze.delete(e, {
              at: t
            }), r.unref();
          },
          xn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  voids: r = !1
                } = t,
                {
                  match: o,
                  at: i = e.selection,
                  height: a = 0,
                  always: s = !1
                } = t;
              if (null == o && (o = t => z.isElement(t) && N.isBlock(e, t)), k.isRange(i) && (i = wn(e, i)), m.isPath(i)) {
                var l = i,
                  u = N.point(e, l),
                  [c] = N.parent(e, l);
                o = e => e === c, a = u.path.length - l.length + 1, i = u, s = !0;
              }
              if (i) {
                var d,
                  p = N.pointRef(e, i, {
                    affinity: "backward"
                  });
                try {
                  var [h] = N.nodes(e, {
                    at: i,
                    match: o,
                    mode: n,
                    voids: r
                  });
                  if (!h) return;
                  var f = N.void(e, {
                    at: i,
                    mode: "highest"
                  });
                  if (!r && f) {
                    var [g, v] = f;
                    if (z.isElement(g) && e.isInline(g)) {
                      var y = N.after(e, v);
                      if (!y) {
                        var b = m.next(v);
                        ze.insertNodes(e, {
                          text: ""
                        }, {
                          at: b,
                          voids: r
                        }), y = N.point(e, b);
                      }
                      i = y, s = !0;
                    }
                    a = i.path.length - v.length + 1, s = !0;
                  }
                  d = N.pointRef(e, i);
                  var w = i.path.length - a,
                    [, x] = h,
                    D = i.path.slice(0, w),
                    C = 0 === a ? i.offset : i.path[w] + 0;
                  for (var [S, E] of N.levels(e, {
                    at: D,
                    reverse: !0,
                    voids: r
                  })) {
                    var _ = !1;
                    if (E.length < x.length || 0 === E.length || !r && z.isElement(S) && N.isVoid(e, S)) break;
                    var P = p.current,
                      A = N.isEnd(e, P, E);
                    if (s || !p || !N.isEdge(e, P, E)) {
                      _ = !0;
                      var T = F.extractProps(S);
                      e.apply({
                        type: "split_node",
                        path: E,
                        position: C,
                        properties: T
                      });
                    }
                    C = E[E.length - 1] + (_ || A ? 1 : 0);
                  }
                  if (null == t.at) {
                    var O = d.current || N.end(e, []);
                    ze.select(e, O);
                  }
                } finally {
                  var I;
                  p.unref(), null === (I = d) || void 0 === I || I.unref();
                }
              }
            });
          },
          Dn = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            Array.isArray(t) || (t = [t]);
            var r = {};
            for (var o of t) r[o] = null;
            ze.setNodes(e, r, n);
          },
          Cn = function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            N.withoutNormalizing(e, () => {
              var {
                  mode: n = "lowest",
                  split: r = !1,
                  voids: o = !1
                } = t,
                {
                  at: i = e.selection,
                  match: a
                } = t;
              if (i) {
                null == a && (a = m.isPath(i) ? J(e, i) : t => z.isElement(t) && N.isBlock(e, t)), m.isPath(i) && (i = N.range(e, i));
                var s = k.isRange(i) ? N.rangeRef(e, i) : null,
                  l = N.nodes(e, {
                    at: i,
                    match: a,
                    mode: n,
                    voids: o
                  }),
                  u = Array.from(l, t => {
                    var [, n] = t;
                    return N.pathRef(e, n);
                  }).reverse(),
                  c = function () {
                    var t = d.unref(),
                      [n] = N.node(e, t),
                      i = N.range(e, t);
                    r && s && (i = k.intersection(s.current, i)), ze.liftNodes(e, {
                      at: i,
                      match: e => z.isAncestor(n) && n.children.includes(e),
                      voids: o
                    });
                  };
                for (var d of u) c();
                s && s.unref();
              }
            });
          };
        function Sn(e, t) {
          var n = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }
          return n;
        }
        function En(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? Sn(Object(n), !0).forEach(function (t) {
              y(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sn(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }
        var _n = function (e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
            N.withoutNormalizing(e, () => {
              var {
                  mode: r = "lowest",
                  split: o = !1,
                  voids: i = !1
                } = n,
                {
                  match: a,
                  at: s = e.selection
                } = n;
              if (s) {
                if (null == a && (a = m.isPath(s) ? J(e, s) : e.isInline(t) ? t => z.isElement(t) && N.isInline(e, t) || X.isText(t) : t => z.isElement(t) && N.isBlock(e, t)), o && k.isRange(s)) {
                  var [l, u] = k.edges(s),
                    c = N.rangeRef(e, s, {
                      affinity: "inward"
                    });
                  ze.splitNodes(e, {
                    at: u,
                    match: a,
                    voids: i
                  }), ze.splitNodes(e, {
                    at: l,
                    match: a,
                    voids: i
                  }), s = c.unref(), null == n.at && ze.select(e, s);
                }
                var d = Array.from(N.nodes(e, {
                    at: s,
                    match: e.isInline(t) ? t => z.isElement(t) && N.isBlock(e, t) : e => N.isEditor(e),
                    mode: "lowest",
                    voids: i
                  })),
                  p = function () {
                    var n = k.isRange(s) ? k.intersection(s, N.range(e, h)) : s;
                    if (!n) return 0;
                    var o = Array.from(N.nodes(e, {
                      at: n,
                      match: a,
                      mode: r,
                      voids: i
                    }));
                    if (o.length > 0) {
                      var [l] = o,
                        u = o[o.length - 1],
                        [, c] = l,
                        [, d] = u;
                      if (0 === c.length && 0 === d.length) return 0;
                      var p = m.equals(c, d) ? m.parent(c) : m.common(c, d),
                        f = N.range(e, c, d),
                        g = N.node(e, p),
                        [v] = g,
                        y = p.length + 1,
                        b = m.next(d.slice(0, y)),
                        w = En(En({}, t), {}, {
                          children: []
                        });
                      ze.insertNodes(e, w, {
                        at: b,
                        voids: i
                      }), ze.moveNodes(e, {
                        at: f,
                        match: e => z.isAncestor(v) && v.children.includes(e),
                        to: b.concat(0),
                        voids: i
                      });
                    }
                  };
                for (var [, h] of d) p();
              }
            });
          },
          Pn = () => {
            var e = {
              children: [],
              operations: [],
              selection: null,
              marks: null,
              isElementReadOnly: () => !1,
              isInline: () => !1,
              isSelectable: () => !0,
              isVoid: () => !1,
              markableVoid: () => !1,
              onChange: () => {},
              apply: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Fe(e, ...n);
              },
              addMark: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ke(e, ...n);
              },
              deleteBackward: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return We(e, ...n);
              },
              deleteForward: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ye(e, ...n);
              },
              deleteFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Xe(e, ...n);
              },
              getFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Re(e, ...n);
              },
              insertBreak: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return pt(e, ...n);
              },
              insertSoftBreak: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ft(e, ...n);
              },
              insertFragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return tn(e, ...n);
              },
              insertNode: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ht(e, ...n);
              },
              insertText: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return vt(e, ...n);
              },
              normalizeNode: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return je(e, ...n);
              },
              removeMark: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return $t(e, ...n);
              },
              getDirtyPaths: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Me(e, ...n);
              },
              shouldNormalize: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Be(e, ...n);
              },
              above: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ne(e, ...n);
              },
              after: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ue(e, ...n);
              },
              before: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ge(e, ...n);
              },
              collapse: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return nn(e, ...n);
              },
              delete: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return en(e, ...n);
              },
              deselect: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return rn(e, ...n);
              },
              edges: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Qe(e, ...n);
              },
              elementReadOnly: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return tt(e, ...n);
              },
              end: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return nt(e, ...n);
              },
              first: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return rt(e, ...n);
              },
              fragment: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ot(e, ...n);
              },
              getMarks: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return At(e, ...n);
              },
              hasBlocks: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return lt(e, ...n);
              },
              hasInlines: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ut(e, ...n);
              },
              hasPath: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return ct(e, ...n);
              },
              hasTexts: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return dt(e, ...n);
              },
              insertNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return dn(e, ...n);
              },
              isBlock: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return yt(e, ...n);
              },
              isEdge: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return bt(e, ...n);
              },
              isEmpty: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return wt(e, ...n);
              },
              isEnd: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return xt(e, ...n);
              },
              isNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Dt(e, ...n);
              },
              isStart: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ct(e, ...n);
              },
              last: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return St(e, ...n);
              },
              leaf: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Et(e, ...n);
              },
              levels: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return _t(e, ...n);
              },
              liftNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return pn(e, ...n);
              },
              mergeNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return gn(e, ...n);
              },
              move: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return on(e, ...n);
              },
              moveNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return vn(e, ...n);
              },
              next: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return zt(e, ...n);
              },
              node: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Tt(e, ...n);
              },
              nodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ot(e, ...n);
              },
              normalize: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return It(e, ...n);
              },
              parent: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ft(e, ...n);
              },
              path: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return jt(e, ...n);
              },
              pathRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Mt(e, ...n);
              },
              pathRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Rt(e, ...n);
              },
              point: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Lt(e, ...n);
              },
              pointRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Bt(e, ...n);
              },
              pointRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Nt(e, ...n);
              },
              positions: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Vt(e, ...n);
              },
              previous: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Kt(e, ...n);
              },
              range: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ut(e, ...n);
              },
              rangeRef: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return qt(e, ...n);
              },
              rangeRefs: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Ht(e, ...n);
              },
              removeNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return yn(e, ...n);
              },
              select: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return an(e, ...n);
              },
              setNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return bn(e, ...n);
              },
              setNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Gt(e, ...n);
              },
              setPoint: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return un(e, ...n);
              },
              setSelection: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return cn(e, ...n);
              },
              splitNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return xn(e, ...n);
              },
              start: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Wt(e, ...n);
              },
              string: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Yt(e, ...n);
              },
              unhangRange: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Xt(e, ...n);
              },
              unsetNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Dn(e, ...n);
              },
              unwrapNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Cn(e, ...n);
              },
              void: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return st(e, ...n);
              },
              withoutNormalizing: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Qt(e, ...n);
              },
              wrapNodes: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return _n(e, ...n);
              },
              shouldMergeNodesRemovePrevNode: function () {
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return Jt(e, ...n);
              }
            };
            return e;
          };
      },
      95189: e => {
        e.exports = '<svg viewBox="0 0 16 5" fill="black" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="2" r="1.5" transform="rotate(-180 8 2)"></circle><circle cx="14.5" cy="2" r="1.5" transform="rotate(-180 14.5 2)"></circle><circle cx="1.5" cy="2" r="1.5" transform="rotate(-180 1.5 2)"></circle></svg>';
      },
      33150: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M4 4.25c-.41 0-.75.34-.75.75v2.73c0 .41.34.75.75.75s.75-.34.75-.75V5.75h5.5v13.5H8.2c-.41 0-.75.34-.75.75s.34.75.75.75h5.6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.05V5.75h5.5v1.98c0 .41.34.75.75.75s.75-.34.75-.75V5c0-.41-.34-.75-.75-.75H4ZM20.75 17c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.25H17c-.41 0-.75.34-.75.75s.34.75.75.75h2.25V23c0 .41.34.75.75.75s.75-.34.75-.75v-2.25H23c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V17Z"></path></svg>';
      },
      84768: e => {
        e.exports = '<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M20 12.043v17.204m8.602-8.602H11.398" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"></path><circle cx="20" cy="20" r="19" stroke="currentColor" stroke-width="2"></circle></svg>';
      },
      41725: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="-6 -6 37 37" fill="currentColor"><path fill-rule="evenodd" d="M10.5 2c0-.83.67-1.5 1.5-1.5h6c.4 0 .78.16 1.06.44l4 4c.28.28.44.66.44 1.06v10c0 .83-.67 1.5-1.5 1.5H12c-.83 0-1.5-.67-1.5-1.5V2ZM12 16V2h6v3c0 .55.45 1 1 1h3v10H12ZM7 3.5h2V5H7v14h11.5c0 .83-.67 1.5-1.5 1.5H7c-.83 0-1.5-.67-1.5-1.5V5c0-.83.67-1.5 1.5-1.5Zm-5 3h2V8H2v14h11.5c0 .83-.67 1.5-1.5 1.5H2c-.83 0-1.5-.67-1.5-1.5V8c0-.83.67-1.5 1.5-1.5Z" clip-rule="evenodd"></path></svg>';
      },
      58817: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="4" fill="currentColor" fill-opacity="0.5"></circle></svg>';
      },
      87779: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="8" cy="8" r="4" fill="currentColor" fill-opacity="0.5"></circle></svg>';
      },
      83104: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m20.12 5.063-.68-.68a2.746 2.746 0 0 0-3.88 0l-12.8 12.8c-.33.32-.51.77-.51 1.23v3.34h4.34c.46 0 .91-.18 1.23-.51l12.3-12.3a2.746 2.746 0 0 0 0-3.88ZM6.76 20.183s-.11.07-.17.07H3.75v-1.84c0-.06.03-.13.07-.17L14 8.063l2.44 2.44-9.68 9.68Zm12.3-12.3-1.56 1.56-2.44-2.44 1.56-1.56c.48-.48 1.28-.48 1.76 0l.68.68c.48.48.48 1.28 0 1.76ZM23 21.753H9.43l1.5-1.5H23c.41 0 .75.34.75.75s-.34.75-.75.75Z" clip-rule="evenodd"></path></svg>';
      },
      33751: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M14.12 1.101c1.65-1.16 3.95-.48 4.72 1.38l2.11 5.11h1.56c.5 0 .9.4.9.9s-.4.9-.9.9H1.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h1.56l2.11-5.11c.76-1.86 3.06-2.53 4.71-1.38l1.17.82c.57.4 1.32.4 1.89 0l1.17-.82h.01Zm3.33 1.96 1.87 4.54H4.68l1.87-4.54c.4-.98 1.61-1.33 2.47-.72l1.17.82c1.08.76 2.53.76 3.61 0l1.17-.82c.87-.61 2.07-.25 2.47.72h.01Zm-13.7 7.69h16.5v1c0 2.21-1.79 4-4 4-2.04 0-3.72-1.53-3.97-3.5h-.56a4.007 4.007 0 0 1-3.97 3.5c-2.21 0-4-1.79-4-4v-1Zm1.55 1.5a2.5 2.5 0 0 0 4.9 0H5.3Zm8.5 0a2.5 2.5 0 0 0 4.9 0h-4.9Zm-11.8 5a.76.76 0 0 0-.67.41c-.13.25-.11.55.06.78l2.03 2.84-1.8 1.08c-.36.21-.47.67-.26 1.03.21.36.67.47 1.03.26l2.5-1.5c.18-.11.31-.29.35-.49.04-.2 0-.42-.12-.59l-1.65-2.31h7.79v4.25c0 .41.34.75.75.75s.75-.34.75-.75v-4.25h7.79l-1.65 2.31c-.12.17-.17.38-.12.59.04.2.17.38.35.49l2.5 1.5c.36.21.82.1 1.03-.26.21-.36.1-.82-.26-1.03l-1.8-1.08 2.03-2.84c.16-.23.19-.53.06-.78a.76.76 0 0 0-.67-.41H2Z" clip-rule="evenodd"></path></svg>';
      },
      497: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10.97 3.97a.75.75 0 0 1 1.06 0L20.06 12l-8.03 8.03a.75.75 0 1 1-1.06-1.06l6.22-6.22H4a.75.75 0 0 1 0-1.5h13.19l-6.22-6.22a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd"></path></svg>';
      },
      96421: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.47 12.53a.75.75 0 0 0 1.06 0l6.22-6.22V19.5a.75.75 0 0 0 1.5 0V6.31l6.22 6.22a.75.75 0 1 0 1.06-1.06L11.5 3.44l-8.03 8.03a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd"></path></svg>';
      },
      1291: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M15.25 2a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0V3.81L2.53 22.53a.75.75 0 0 1-1.06-1.06L20.19 2.75H16a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd"></path></svg>';
      },
      1126: e => {
        e.exports = '<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Vector 527" d="M1 1L7 7L1 13" stroke="currentColor" stroke-width="2"></path></svg>';
      },
      39127: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.5 3.5v12H7V8a1 1 0 0 1 1-1h7.5V3.5h-12ZM3 17h4v4a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1Zm17.5-8.5H17V16a1 1 0 0 1-1 1H8.5v3.5h12v-12Zm-5 1.94V8.5h-1.94l1.94 1.94Zm0 2.06-.03.03-4-4 .03-.03H9.56l5.94 5.94V12.5Zm-1.06 3L8.5 9.56v1.94l.03-.03 4 4-.03.03h1.94Zm-4 0L8.5 13.56v1.94h1.94Z" clip-rule="evenodd"></path></svg>';
      },
      6274: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6 18.74c0 .696.564 1.26 1.26 1.26h5.79c3.321 0 5.357-1.586 5.357-4.221 0-1.8-1.028-3.172-2.871-3.579 1.543-.579 2.293-1.693 2.293-3.321C17.829 6.543 16.093 5 13.22 5H7.26A1.26 1.26 0 0 0 6 6.26v12.48Zm3.6-7.89V8h2.807c1.136 0 1.757.557 1.757 1.393 0 .921-.685 1.457-1.693 1.457H9.6Zm0 6.15v-3.15h3.171c1.286 0 1.993.6 1.993 1.564 0 1.029-.793 1.586-1.928 1.586H9.6Z"></path></svg>';
      },
      79439: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M9 1.25A2.75 2.75 0 0 0 6.25 4v18a.75.75 0 0 0 1.296.515L12 17.793l4.454 4.722A.75.75 0 0 0 17.75 22V4A2.75 2.75 0 0 0 15 1.25H9Z"></path></svg>';
      },
      57462: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.5 14.5v-11h11v11h-11ZM2 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Zm13 14.5a2.5 2.5 0 0 0 2.5-2.5V8H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3.5h7Z" clip-rule="evenodd"></path></svg>';
      },
      64772: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M2 5.25a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V6A.75.75 0 0 1 2 5.25Zm8 0a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Zm8.75.75a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0V6ZM6 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4A.75.75 0 0 1 6 9.25Zm8.75.75a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4ZM22 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM15.584 21H8.416a.2.2 0 0 1-.156-.325l3.584-4.48a.2.2 0 0 1 .312 0l3.584 4.48a.2.2 0 0 1-.156.325Z" clip-rule="evenodd"></path></svg>';
      },
      14623: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11 4.24c-.41 0-.75.34-.75.75s.34.75.75.75h2.25v5.25c0 .41.34.75.75.75s.75-.34.75-.75V5.74H17c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6Zm8-4H9c-2.62 0-4.75 2.13-4.75 4.75v6c0 2.62 2.13 4.75 4.75 4.75h10c2.62 0 4.75-2.13 4.75-4.75v-6c0-2.62-2.13-4.75-4.75-4.75Zm3.25 10.75c0 1.79-1.46 3.25-3.25 3.25H9c-1.79 0-3.25-1.46-3.25-3.25v-6C5.75 3.2 7.21 1.74 9 1.74h10c1.79 0 3.25 1.46 3.25 3.25v6Zm-9 6h1.5v3c0 .37-.27.68-.63.74l-10.17 1.7c-.2.9-1 1.57-1.95 1.57-1.1 0-2-.9-2-2s.9-2 2-2c.72 0 1.35.38 1.71.96l9.54-1.59v-2.38Z"></path></svg>';
      },
      42451: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 17l9-9H3z" fill="currentColor"></path></svg>';
      },
      52904: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12"><path fill-rule="evenodd" d="M9.53 3.97a.75.75 0 0 0-1.06 0L6 6.44 3.53 3.97a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0 0-1.06Z" clip-rule="evenodd"></path></svg>';
      },
      10190: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12"><path fill-rule="evenodd" d="M8.03 9.53a.75.75 0 0 0 0-1.06L5.56 6l2.47-2.47a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      92122: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12"><path fill-rule="evenodd" d="M3.97 2.47a.75.75 0 0 0 0 1.06L6.44 6 3.97 8.47a.75.75 0 0 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3a.75.75 0 0 0-1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      19201: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 12 12"><path fill-rule="evenodd" d="M2.47 8.03a.75.75 0 0 0 1.06 0L6 5.56l2.47 2.47a.75.75 0 0 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 0 0 0 1.06Z" clip-rule="evenodd"></path></svg>';
      },
      74777: e => {
        e.exports = '<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8l4 4m0 0l-4 4m4-4H7" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"></path></svg>';
      },
      97468: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm5.07-13.512a.75.75 0 0 0-1.14-.976l-5.422 6.326-1.932-2.318a.75.75 0 0 0-1.152.96l2.374 2.849a.917.917 0 0 0 1.4.01l5.872-6.85Z" clip-rule="evenodd"></path></svg>';
      },
      46154: e => {
        e.exports = '<svg width="12" height="12" viewBox="0 0 10 10" style="fill: none;" xmlns="http://www.w3.org/2000/svg"><path d="M1 5L3.5 8.5C3.5 8.5 5.5 5.5 9 1.5" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
      },
      94556: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle><circle cx="8" cy="8" r="4" fill="currentColor"></circle></svg>';
      },
      79579: e => {
        e.exports = '<svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 5L3.5 8L9.5 2" stroke="currentColor" stroke-width="1.25"></path></svg>';
      },
      49612: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none"><path d="M0 1L8 1L4 7L0 1Z" fill="currentColor"></path></svg>';
      },
      67018: e => {
        e.exports = '<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="icon" d="M1 8L1 0L7 4L1 8Z" fill="currentColor"></path></svg>';
      },
      35077: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11.006 2.564a.75.75 0 0 1 .988-1.128l4 3.5a.75.75 0 0 1 0 1.128l-4 3.5a.75.75 0 0 1-.988-1.128l2.558-2.239a6.25 6.25 0 1 0 4.686 6.053.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.397-7.632l-2.347-2.054Z"></path></svg>';
      },
      2256: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM9.03 7.97a.75.75 0 0 0-1.06 1.06L10.94 12l-2.97 2.97a.75.75 0 1 0 1.06 1.06L12 13.06l2.97 2.97a.75.75 0 1 0 1.06-1.06L13.06 12l2.97-2.97a.75.75 0 0 0-1.06-1.06L12 10.94 9.03 7.97Z" clip-rule="evenodd"></path></svg>';
      },
      66361: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M5.105 18.894a.75.75 0 0 1 0-1.06L10.94 12 5.105 6.166a.75.75 0 0 1 1.061-1.06L12 10.939l5.833-5.833a.75.75 0 0 1 1.061 1.06L13.06 12l5.834 5.834a.75.75 0 1 1-1.06 1.06L12 13.061l-5.834 5.833a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      80224: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.5 9.75a2.75 2.75 0 0 0-2.75 2.75.75.75 0 0 1-1.5 0 4.25 4.25 0 0 1 7-3.24A4.235 4.235 0 0 1 12 8.25a4.23 4.23 0 0 1 2.75 1.01 4.25 4.25 0 0 1 5.724 6.276.75.75 0 1 1-1.05-1.072 2.75 2.75 0 0 0-3.72-4.048 4.23 4.23 0 0 1 .546 2.084 4.24 4.24 0 0 1-1.275 3.036.75.75 0 1 1-1.05-1.072c.51-.5.825-1.194.825-1.964 0-.612-.2-1.177-.538-1.634a.75.75 0 0 1-.104-.132A2.744 2.744 0 0 0 12 9.75c-.686 0-1.313.25-1.795.666a4.23 4.23 0 0 1 .545 2.084 4.24 4.24 0 0 1-1.276 3.036.75.75 0 1 1-1.05-1.072c.51-.5.826-1.194.826-1.964 0-.572-.175-1.103-.474-1.543l-.005-.004a.747.747 0 0 1-.229-.294A2.743 2.743 0 0 0 6.5 9.75Z"></path></svg>';
      },
      10669: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" viewBox="0 0 26 26"><path fill-rule="evenodd" d="M10.021 2.148a3.576 3.576 0 0 1 1.487-1.136 3.56 3.56 0 0 1 1.38-.262 3.45 3.45 0 0 1 2.846 1.414 3.607 3.607 0 0 1 2.585-.146 3.61 3.61 0 0 1 2.486 3.05 3.669 3.669 0 0 1 2.663 1.713 3.49 3.49 0 0 1 .173 3.19 3.561 3.561 0 0 1 1.2 1.537c.178.438.266.908.26 1.381a3.45 3.45 0 0 1-1.479 2.886 3.62 3.62 0 0 1-2.835 4.99 3.62 3.62 0 0 1-4.982 2.926 3.562 3.562 0 0 1-1.504 1.145 3.55 3.55 0 0 1-1.39.254 3.62 3.62 0 0 1-2.89-1.463 3.67 3.67 0 0 1-3.179-.203l-.003-.002a3.61 3.61 0 0 1-1.787-2.64 3.62 3.62 0 0 1-2.894-4.976 3.578 3.578 0 0 1-1.149-1.503A3.56 3.56 0 0 1 .75 12.92a3.46 3.46 0 0 1 1.453-2.87 3.667 3.667 0 0 1 .182-3.206l.004-.005a3.61 3.61 0 0 1 2.68-1.793l.012-.085a3.62 3.62 0 0 1 4.94-2.813Zm2.885.102a1.95 1.95 0 0 1 1.618.8 3.61 3.61 0 0 0-.445.619.75.75 0 1 0 1.303.742c.12-.21.273-.395.453-.551a.745.745 0 0 0 .166-.13 2.11 2.11 0 0 1 3.308 1.458 3.67 3.67 0 0 0-.754.317.75.75 0 1 0 .732 1.31 2.17 2.17 0 0 1 2.892.733 1.99 1.99 0 0 1 .09 1.815 3.55 3.55 0 0 0-.795-.073.75.75 0 0 0 .032 1.5 2.05 2.05 0 0 1 2.095 2.115 1.95 1.95 0 0 1-.835 1.639 3.621 3.621 0 0 0-.595-.454.75.75 0 1 0-.781 1.28 2.12 2.12 0 0 1-.743 3.9 3.613 3.613 0 0 0-.316-.723.75.75 0 1 0-1.3.746c.134.235.222.492.26.757 0 .048.005.095.014.141a2.123 2.123 0 0 1-1.946 2.27 2.12 2.12 0 0 1-.917-.13c.064-.28.094-.566.089-.854a.75.75 0 0 0-1.5.027 2.05 2.05 0 0 1-2.094 2.086h-.014a2.12 2.12 0 0 1-1.654-.801 3.66 3.66 0 0 0 .488-.622.75.75 0 0 0-1.273-.794 2.17 2.17 0 0 1-2.903.744 2.11 2.11 0 0 1-1.03-1.462c.26-.078.513-.187.752-.324a.75.75 0 0 0-.746-1.302 2.118 2.118 0 0 1-.648.242.746.746 0 0 0-.398.04 2.125 2.125 0 0 1-1.56-.676 2.12 2.12 0 0 1-.432-2.193c.28.063.567.093.855.088a.75.75 0 0 0-.027-1.5 2.06 2.06 0 0 1-2.097-2.124 1.96 1.96 0 0 1 .803-1.619c.179.172.376.325.59.459a.75.75 0 1 0 .795-1.272 2.17 2.17 0 0 1-.745-2.895 2.11 2.11 0 0 1 1.5-1.036c.079.263.188.519.327.76a.75.75 0 1 0 1.3-.746A2.12 2.12 0 0 1 9.382 3.51a3.56 3.56 0 0 0-.09.865.75.75 0 1 0 1.5-.027 2.058 2.058 0 0 1 2.115-2.097Z" clip-rule="evenodd"></path></svg>';
      },
      13830: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M21.79 11.552c-.08-.77-.42-1.51-.95-2.08-.53-.56-1.24-.95-2-1.08-.45-.08-.92-.06-1.36.03-.09-.27-.22-.54-.38-.78-.32-.5-.75-.91-1.25-1.19-.51-.3-1.08-.47-1.67-.49-.28-.01-.55.01-.82.06-.09-.26-.2-.52-.34-.76-.32-.48-.75-.9-1.26-1.19-.51-.29-1.08-.46-1.67-.49-.3-.02-.6.01-.9.07a3.54 3.54 0 0 0-1.9-2.06c-.62-.3-1.3-.4-1.97-.31-.66.09-1.29.36-1.81.78-.53.43-.92.99-1.14 1.63-.21.64-.25 1.33-.1 1.98.13.57.4 1.09.81 1.57-.17.2-.32.43-.45.66-.26.52-.4 1.1-.4 1.68 0 .58.14 1.16.42 1.71.14.24.3.47.49.67-.19.21-.36.44-.5.7-.26.52-.4 1.1-.4 1.68 0 .58.14 1.16.41 1.7.14.25.3.48.5.69-.22.24-.41.51-.56.81-.3.61-.43 1.29-.36 1.98.07.67.32 1.3.73 1.84s.97.96 1.6 1.2c.41.16.84.23 1.28.23.24 0 .48-.02.72-.07.65-.14 1.26-.45 1.75-.9.45-.42.78-.95.98-1.55.23.05.47.08.71.08h.17c.58-.03 1.15-.2 1.67-.5.51-.31.94-.74 1.24-1.24.14-.22.25-.46.34-.71.22.04.44.07.66.07h.16c.59-.03 1.16-.2 1.67-.49a3.715 3.715 0 0 0 1.62-1.96c.23.04.45.07.68.07.31 0 .63-.04.94-.12.84-.23 1.56-.75 2.05-1.47.49-.72.7-1.59.61-2.44l-.02-.01Zm-1.85 1.6c-.29.42-.72.73-1.2.86-.44.12-.9.09-1.33-.08-.43-.17-.78-.46-1.03-.84a.747.747 0 0 0-1.04-.22c-.35.22-.45.69-.22 1.04.26.41.6.75 1 1.02-.06.2-.13.39-.25.56-.19.29-.44.53-.74.71-.3.17-.64.27-.98.29-.27.01-.54-.04-.8-.13-.03-.03-.06-.06-.1-.08 0 0-.02-.01-.03-.02-.38-.21-.71-.51-.93-.88a.748.748 0 0 0-1.29.76c.26.46.62.86 1.04 1.16-.06.19-.14.37-.25.55-.19.3-.45.56-.73.74-.3.17-.64.27-.98.29-.34.01-.68-.05-.99-.2-.25-.14-.48-.32-.67-.53a.746.746 0 0 0-1.06-.06c-.31.27-.34.75-.06 1.06.18.21.39.39.61.56v.04c-.11.39-.32.73-.61 1s-.66.46-1.04.54c-.39.08-.79.04-1.17-.1-.37-.14-.7-.38-.94-.7-.24-.32-.39-.7-.43-1.09-.04-.4.04-.8.21-1.15.18-.36.46-.65.8-.86.34-.21.73-.32 1.13-.32.41 0 .75-.34.75-.75 0-.02-.01-.04-.01-.06v-.02c0-.41-.33-.74-.74-.75-.53 0-1.06.1-1.54.32-.13-.13-.24-.28-.33-.44-.16-.31-.24-.66-.24-1 0-.35.08-.69.22-.97.17-.3.4-.56.68-.75.05-.04.08-.08.12-.13.34-.18.7-.29 1.09-.3.41 0 .74-.35.73-.76 0-.41-.34-.74-.75-.74-.53 0-1.05.11-1.53.33-.13-.14-.25-.28-.33-.44a2.21 2.21 0 0 1-.24-1.01c0-.35.08-.69.24-.99.15-.29.37-.54.63-.74.25-.14.52-.25.8-.29a.76.76 0 0 0 .62-.86.76.76 0 0 0-.86-.62c-.31.05-.61.14-.89.26-.26-.28-.45-.62-.53-1-.09-.39-.07-.79.06-1.16.13-.37.36-.7.66-.95a2.14 2.14 0 0 1 2.22-.29c.36.16.66.42.89.76.22.32.34.7.35 1.11 0 .19-.01.37-.06.55-.02.09-.06.17-.09.25-.04.1-.07.21-.13.31a.752.752 0 1 0 1.3.76l.03-.06s.01 0 .01-.02c.02-.04.04-.09.06-.13.06-.12.11-.23.16-.35.13-.32.23-.65.26-1 .19-.04.38-.06.57-.05.35.02.69.12.99.29.3.18.56.42.73.69.17.29.27.62.29.95 0 .44-.1.87-.31 1.25-.2.36-.07.81.29 1.01.36.2.81.08 1.02-.28.26-.46.43-.96.48-1.48.19-.05.4-.07.6-.06.34.01.68.11.98.29.3.17.55.41.74.7.18.29.29.61.33.95 0 .3-.05.59-.13.87a.75.75 0 0 0 .72.97c.32 0 .62-.21.72-.53.08-.25.12-.5.16-.76.31-.09.63-.14.95-.08.45.08.86.31 1.17.63.31.33.5.76.55 1.21a2.1 2.1 0 0 1-.36 1.44h-.02Z"></path></svg>';
      },
      64874: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M19.143 1.25a3.74 3.74 0 0 0-2.381.86 3.739 3.739 0 0 0-2.38-.86c-.854 0-1.726.306-2.382.86a3.739 3.739 0 0 0-2.38-.86c-.854 0-1.726.306-2.382.86a3.739 3.739 0 0 0-2.38-.86c-2.034 0-3.608 1.574-3.608 3.607 0 .853.306 1.726.86 2.381a3.739 3.739 0 0 0-.86 2.381c0 .853.306 1.725.86 2.381a3.739 3.739 0 0 0-.86 2.38c0 .854.306 1.726.86 2.382a3.739 3.739 0 0 0-.86 2.38c0 2.034 1.574 3.608 3.607 3.608.853 0 1.726-.306 2.381-.86.656.554 1.528.86 2.381.86.853 0 1.726-.306 2.381-.86.656.554 1.528.86 2.381.86.853 0 1.725-.306 2.38-.86.657.554 1.529.86 2.382.86 2.033 0 3.607-1.574 3.607-3.607a3.74 3.74 0 0 0-.861-2.381c.555-.656.86-1.528.86-2.381 0-.853-.305-1.725-.86-2.381.555-.656.86-1.528.86-2.38 0-.854-.305-1.726-.86-2.382.555-.655.86-1.528.86-2.38 0-2.034-1.573-3.608-3.606-3.608Zm-3.024 2.375c-.323-.508-1.013-.875-1.738-.875-.572 0-1.121.228-1.486.573.2.436.331.924.331 1.534a.75.75 0 0 1-1.5 0c0-.41-.139-.85-.368-1.232-.324-.508-1.013-.875-1.739-.875a2.21 2.21 0 0 0-1.486.573c.2.436.332.924.332 1.534a.75.75 0 1 1-1.5 0c0-.405-.136-.839-.36-1.218l-.003-.003c-.32-.514-1.015-.886-1.745-.886-1.205 0-2.107.902-2.107 2.107 0 .572.228 1.121.573 1.487.436-.2.924-.332 1.534-.332a.75.75 0 1 1 0 1.5c-.408 0-.845.138-1.227.366-.51.322-.88 1.013-.88 1.741 0 .572.228 1.121.573 1.487.436-.2.924-.332 1.534-.332a.75.75 0 0 1 0 1.5c-.408 0-.845.138-1.227.366-.51.322-.88 1.013-.88 1.74 0 .573.228 1.122.573 1.487.436-.2.924-.331 1.534-.331a.75.75 0 0 1 0 1.5c-.408 0-.845.138-1.227.365-.51.323-.88 1.014-.88 1.742 0 1.205.902 2.107 2.107 2.107a2.21 2.21 0 0 0 1.487-.573 3.558 3.558 0 0 1-.332-1.534.75.75 0 0 1 1.5 0c0 .405.136.839.36 1.219l.002.002c.321.514 1.015.886 1.745.886a2.21 2.21 0 0 0 1.487-.573 3.558 3.558 0 0 1-.332-1.534.75.75 0 1 1 1.5 0c0 .41.14.85.369 1.232.323.508 1.013.875 1.738.875a2.21 2.21 0 0 0 1.487-.573 3.556 3.556 0 0 1-.332-1.534.75.75 0 1 1 1.5 0c0 .41.14.85.369 1.232.323.508 1.012.875 1.738.875 1.205 0 2.107-.902 2.107-2.107 0-.572-.228-1.121-.574-1.487-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.407 0 .842-.137 1.223-.363.512-.322.884-1.015.884-1.744 0-.572-.228-1.121-.574-1.487-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.408 0 .845-.138 1.227-.366.51-.322.88-1.013.88-1.74 0-.573-.228-1.122-.574-1.488-.435.2-.923.332-1.533.332a.75.75 0 0 1 0-1.5c.41 0 .848-.138 1.23-.367.509-.324.877-1.014.877-1.74 0-1.205-.902-2.107-2.107-2.107a2.21 2.21 0 0 0-1.487.573c.2.436.332.924.332 1.534a.75.75 0 0 1-1.5 0c0-.41-.14-.85-.369-1.232Z" clip-rule="evenodd"></path></svg>';
      },
      23944: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v10A2.75 2.75 0 0 0 5 18.75h1.25V22a.75.75 0 0 0 1.248.56l4.287-3.81H19A2.75 2.75 0 0 0 21.75 16V6A2.75 2.75 0 0 0 19 3.25H5ZM3.75 6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-7.5a.75.75 0 0 0-.498.19L7.75 20.33V18a.75.75 0 0 0-.75-.75H5c-.69 0-1.25-.56-1.25-1.25V6ZM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd"></path></svg>';
      },
      80259: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_8282_94801)"><g filter="url(#filter0_d_8282_94801)"><path d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V16C21 17.1046 20.1046 18 19 18H11.5L7 22V18H5C3.89543 18 3 17.1046 3 16V6Z" fill="#FFEB84"></path><path d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V16C21 17.1046 20.1046 18 19 18H11.5L7 22V18H5C3.89543 18 3 17.1046 3 16V6Z" stroke="#E8B500" stroke-width="1.5" stroke-linejoin="round"></path></g><circle cx="8" cy="11" r="1" fill="black"></circle><circle cx="16" cy="11" r="1" fill="black"></circle><circle cx="12" cy="11" r="1" fill="black"></circle></g><defs><filter id="filter0_d_8282_94801" x="1.25" y="3.25" width="21.5" height="21.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation="0.5"></feGaussianBlur><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8282_94801"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_8282_94801" result="shape"></feBlend></filter><clipPath id="clip0_8282_94801"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>';
      },
      53063: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M5 3.25A2.75 2.75 0 0 0 2.25 6v10A2.75 2.75 0 0 0 5 18.75h1.25V22a.75.75 0 0 0 1.248.56l4.287-3.81H19A2.75 2.75 0 0 0 21.75 16V6A2.75 2.75 0 0 0 19 3.25H5ZM3.75 6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10c0 .69-.56 1.25-1.25 1.25h-7.5a.75.75 0 0 0-.498.19L7.75 20.33V18a.75.75 0 0 0-.75-.75H5c-.69 0-1.25-.56-1.25-1.25V6ZM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd"></path></svg>';
      },
      28735: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7 2.25a.75.75 0 0 0-.75.75v.558a2.75 2.75 0 0 0 1.88 2.61l.789.262a.25.25 0 0 1 .165.288l-.752 3.615A6.745 6.745 0 0 0 5.25 16c0 .414.336.75.75.75h5.25V22l.75 1.75.75-1.75v-5.25H18a.75.75 0 0 0 .75-.75 6.745 6.745 0 0 0-3.082-5.667l-.752-3.615a.25.25 0 0 1 .165-.288l.789-.263a2.75 2.75 0 0 0 1.88-2.609V3a.75.75 0 0 0-.75-.75H7Zm10.197 13a5.253 5.253 0 0 0-7.821-3.798 5.253 5.253 0 0 0-2.573 3.798h10.394ZM12 9.25a6.75 6.75 0 0 0-1.972.293l.525-2.519a1.75 1.75 0 0 0-1.16-2.017l-.788-.263a1.25 1.25 0 0 1-.84-.994h8.47a1.25 1.25 0 0 1-.84.994l-.788.263a1.75 1.75 0 0 0-1.16 2.017l.525 2.519A6.75 6.75 0 0 0 12 9.25Z" clip-rule="evenodd"></path></svg>';
      },
      23874: e => {
        e.exports = '<svg width="84" height="84" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M40 42H0M84 42H44M42 84V44M42 40V0M3 12V0M81 72v12M72 3h11M12 81H1M12 3H1M72 81h11M81 12V0M3 72v12" stroke="#fff" stroke-width="6"></path><path d="M40 42H1M83 42H44M42 83V44M42 40V1M3 11V1M81 73v10M73 3h10M11 81H1M11 3H1M73 81h10M81 11V1M3 73v10" stroke="#000" stroke-width="4"></path></svg>';
      },
      10346: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3.5 6H2V2h4v1.5H3.5V6Zm2.75 2c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H7c-.41 0-.75-.34-.75-.75Zm0 4c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H7c-.41 0-.75-.34-.75-.75ZM7 15.25c-.41 0-.75.34-.75.75s.34.75.75.75h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H7ZM18 2v1.5h2.5V6H22V2h-4ZM3.5 18H2v4h4v-1.5H3.5V18ZM18 22v-1.5h2.5V18H22v4h-4Zm-9 0v-1.5h6V22H9ZM9 2v1.5h6V2H9ZM2 9h1.5v6H2V9Zm20 0h-1.5v6H22V9Z"></path></svg>';
      },
      84539: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.994 2.564a.75.75 0 0 0-.988-1.128l-4 3.5a.75.75 0 0 0 0 1.128l4 3.5a.75.75 0 0 0 .988-1.128l-2.558-2.239A6.25 6.25 0 1 1 5.75 12.25a.75.75 0 0 0-1.5 0 7.75 7.75 0 1 0 6.397-7.632l2.347-2.054Z"></path></svg>';
      },
      95482: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m21.878 13.565-1.482-.233a8.583 8.583 0 0 0 0-2.664l1.482-.233a10.079 10.079 0 0 1 0 3.13Zm-.54-5.15-1.4.538a8.489 8.489 0 0 0-1.331-2.302l1.165-.944a9.991 9.991 0 0 1 1.566 2.708Zm-3.045-4.187-.944 1.165a8.49 8.49 0 0 0-2.302-1.331l.538-1.4a10 10 0 0 1 2.708 1.566Zm-4.728-2.106-.233 1.482a8.575 8.575 0 0 0-2.664 0l-.233-1.482a10.075 10.075 0 0 1 3.13 0Zm-5.15.54.538 1.4a8.49 8.49 0 0 0-2.302 1.331l-.944-1.165a9.99 9.99 0 0 1 2.708-1.566ZM4.228 5.707l1.165.944a8.49 8.49 0 0 0-1.331 2.302l-1.4-.538a9.99 9.99 0 0 1 1.566-2.708Zm-2.106 4.728a10.075 10.075 0 0 0 0 3.13l1.482-.233a8.575 8.575 0 0 1 0-2.664l-1.482-.233Zm.54 5.15 1.4-.538a8.49 8.49 0 0 0 1.331 2.302l-1.165.944a9.99 9.99 0 0 1-1.566-2.708Zm3.045 4.187.944-1.165a8.49 8.49 0 0 0 2.302 1.331l-.538 1.4a9.991 9.991 0 0 1-2.708-1.566Zm4.728 2.106.233-1.482a8.583 8.583 0 0 0 2.664 0l.233 1.482a10.079 10.079 0 0 1-3.13 0Zm5.15-.54-.538-1.4a8.49 8.49 0 0 0 2.302-1.331l.944 1.165a9.992 9.992 0 0 1-2.708 1.566Zm4.187-3.045-1.165-.944a8.49 8.49 0 0 0 1.331-2.302l1.4.538a10 10 0 0 1-1.566 2.708Z" clip-rule="evenodd"></path></svg>';
      },
      10801: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="m6.72 4.594.73-1.3-2.71-1.53c-1-.56-2.24.16-2.24 1.31v2.99H4v-3l2.72 1.53Zm4.35 2.45-2.61-1.47.74-1.31 2.61 1.47-.74 1.31Zm9.68 3.72c1.02.57 1.02 2.04 0 2.61l-2.84 1.6-.73-1.31 2.84-1.59-2.84-1.6.73-1.31 2.84 1.59v.01Zm-4.58 5.2-2.61 1.47-.74-1.31 2.61-1.47.74 1.31Zm-6.97 3.92 2.61-1.47-.74-1.31-2.61 1.47.74 1.31Zm-1.75.98-2.71 1.53c-1 .56-2.24-.16-2.24-1.31v-3.02H4v3.02l2.72-1.53.73 1.31Zm5.37-12.83 2.61 1.47.74-1.31-2.61-1.47-.74 1.31ZM4 16.064v-3H2.5v3H4Zm0-8v3H2.5v-3H4Z"></path></svg>';
      },
      43472: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M21 6h-1.5V4.5H18V3h2c.55 0 1 .45 1 1v2ZM3 18h1.5v1.5H6V21H4c-.55 0-1-.45-1-1v-2ZM4.5 6H3V4c0-.55.45-1 1-1h2v1.5H4.5V6ZM21 18h-1.5v1.5H18V21h2c.55 0 1-.45 1-1v-2ZM8 4.5V3h3v1.5H8Zm0 15V21h3v-1.5H8ZM3 8h1.5v3H3V8Zm18 0h-1.5v3H21V8Zm-8-3.5V3h3v1.5h-3Zm0 15V21h3v-1.5h-3ZM3 13h1.5v3H3v-3Zm18 0h-1.5v3H21v-3Z"></path></svg>';
      },
      41828: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M15.03 11.8c-.47-.18-.78-.64-.78-1.15V6.41c0-.64-.52-1.16-1.16-1.16h-.34v-1h.75a1.25 1.25 0 0 0 0-2.5h-.75V1.5c0-.69-.56-1.25-1.25-1.25h-3c-.69 0-1.25.56-1.25 1.25v3.75h-.34c-.64 0-1.16.52-1.16 1.16v4.24c0 .51-.31.97-.78 1.15a2.75 2.75 0 0 0-1.72 2.55v5.24c0 2.3 1.86 4.16 4.16 4.16h5.18c2.3 0 4.16-1.86 4.16-4.16v-5.24c0-1.12-.68-2.13-1.72-2.55ZM8.75 1.75h2.5v3.5h-2.5v-3.5Zm6.5 17.84c0 1.47-1.19 2.66-2.66 2.66H7.41c-1.47 0-2.66-1.19-2.66-2.66v-5.24c0-.51.31-.97.78-1.15a2.75 2.75 0 0 0 1.72-2.55v-3.9h5.5v3.9c0 1.12.68 2.13 1.72 2.55.47.18.78.64.78 1.15v5.24Zm1.72-15.62c.29-.29.77-.29 1.06 0l.5.5c.26.26.68.26.94 0 .85-.85 2.22-.85 3.06 0l.5.5c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0l-.5-.5a.664.664 0 0 0-.94 0c-.85.85-2.22.85-3.06 0l-.5-.5a.754.754 0 0 1 0-1.06Zm1.06-3a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l.5.5c.85.85 2.22.85 3.06 0 .26-.26.68-.26.94 0l.5.5c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-.5-.5c-.85-.85-2.22-.85-3.06 0-.26.26-.68.26-.94 0l-.5-.5Z" clip-rule="evenodd"></path></svg>';
      },
      63949: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9.75 4a2.25 2.25 0 0 1 4.5 0v.25h-4.5V4Zm6 0a3.75 3.75 0 1 0-7.5 0v.25H3a.75.75 0 0 0 0 1.5h1.25V20A2.75 2.75 0 0 0 7 22.75h10A2.75 2.75 0 0 0 19.75 20V5.75H21a.75.75 0 0 0 0-1.5h-5.25V4Zm-10 16V5.75h12.5V20c0 .69-.56 1.25-1.25 1.25H7c-.69 0-1.25-.56-1.25-1.25Zm7-11a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0V9ZM8.5 8.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm7.75.75a.75.75 0 0 0-1.5 0v9a.75.75 0 0 0 1.5 0V9Z" clip-rule="evenodd"></path></svg>';
      },
      40825: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm4.03-13.97a.75.75 0 0 0-1.06-1.06l-7 7a.75.75 0 1 0 1.06 1.06l7-7Z" clip-rule="evenodd"></path></svg>';
      },
      3572: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm5.07-13.512a.75.75 0 0 0-1.14-.976l-5.422 6.326-1.932-2.318a.75.75 0 0 0-1.152.96l2.374 2.849a.917.917 0 0 0 1.4.01l5.872-6.85Z" clip-rule="evenodd"></path></svg>';
      },
      13864: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.75 5.25A.75.75 0 0 1 1.5 6v5.996l4.466-4.523a.75.75 0 1 1 1.068 1.054l-2.69 2.723h15.311l-2.689-2.723a.75.75 0 1 1 1.068-1.054l4.466 4.523V6A.75.75 0 0 1 24 6v12a.75.75 0 0 1-1.5 0v-5.996l-4.466 4.523a.75.75 0 0 1-1.067-1.054l2.689-2.723H4.345l2.689 2.723a.75.75 0 0 1-1.068 1.054L1.5 12.004V18A.75.75 0 0 1 0 18V6a.75.75 0 0 1 .75-.75Z"></path></svg>';
      },
      65829: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M23 11.25C17.34 11.25 12.75 6.66 12.75 1C12.75 0.59 12.41 0.25 12 0.25C11.59 0.25 11.25 0.59 11.25 1C11.25 6.66 6.66 11.25 1 11.25C0.59 11.25 0.25 11.59 0.25 12C0.25 12.41 0.59 12.75 1 12.75C6.66 12.75 11.25 17.34 11.25 23C11.25 23.41 11.59 23.75 12 23.75C12.41 23.75 12.75 23.41 12.75 23C12.75 17.34 17.34 12.75 23 12.75C23.41 12.75 23.75 12.41 23.75 12C23.75 11.59 23.41 11.25 23 11.25ZM12 18.86C10.81 15.7 8.3 13.19 5.14 12C8.3 10.81 10.81 8.3 12 5.14C13.19 8.3 15.7 10.81 18.86 12C15.7 13.19 13.19 15.7 12 18.86Z" fill="currentColor"></path></svg>';
      },
      66308: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9.5 19.75A1.75 1.75 0 0 0 11.25 18v-3h-1.5v3a.25.25 0 0 1-.25.25H2a.25.25 0 0 1-.25-.25V6A.25.25 0 0 1 2 5.75h7.5a.25.25 0 0 1 .25.25v3h1.5V6A1.75 1.75 0 0 0 9.5 4.25H2A1.75 1.75 0 0 0 .25 6v12c0 .966.784 1.75 1.75 1.75h7.5ZM12.75 6c0-.966.784-1.75 1.75-1.75H22c.966 0 1.75.784 1.75 1.75v12A1.75 1.75 0 0 1 22 19.75h-7.5A1.75 1.75 0 0 1 12.75 18v-3h1.5v3c0 .138.112.25.25.25H22a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-7.5a.25.25 0 0 0-.25.25v3h-1.5V6ZM7.53 8.47a.75.75 0 0 1 0 1.06l-1.72 1.72h12.38l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H5.81l1.72 1.72a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      58645: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7 3a.75.75 0 0 0-1.5 0v13.5c0 .966.784 1.75 1.75 1.75H16v-1.5H7.25A.25.25 0 0 1 7 16.5V3Zm10.5 17.5a.75.75 0 0 0 1.5 0V7a1.75 1.75 0 0 0-1.75-1.75H8.5v1.5h8.75a.25.25 0 0 1 .25.25v13.5Zm5.5-2.25h-2.5v-1.5H23a.75.75 0 0 1 0 1.5Zm-19-13H1a.75.75 0 0 0 0 1.5h3v-1.5Z" clip-rule="evenodd"></path></svg>';
      },
      20574: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M2.5 2A1.5 1.5 0 0 1 4 .5h8a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 17.5 6v.366a4.024 4.024 0 0 0-.293.266L16 7.84V6h-3a1 1 0 0 1-1-1V2H4v16h2.093c-.22.463-.325.979-.298 1.5H4A1.5 1.5 0 0 1 2.5 18V2Zm20.363 6.782a2.48 2.48 0 0 1 0 3.507L12.32 22.833a1.615 1.615 0 0 1-1.142.473H7.25V19.38c0-.428.17-.839.473-1.142L18.267 7.693a2.48 2.48 0 0 1 3.507 0l1.09 1.09Zm-1.06 2.446a.98.98 0 0 0 0-1.385l-1.09-1.09a.98.98 0 0 0-1.385 0l-1.075 1.075 2.475 2.475 1.075-1.075Zm-2.136 2.136-2.475-2.475-8.408 8.409a.115.115 0 0 0-.034.081v2.427h2.427a.12.12 0 0 0 .082-.033l8.408-8.409Z" clip-rule="evenodd"></path></svg>';
      },
      48947: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="28.5" cy="28.5" r="3" fill="black" stroke="white"></circle><circle cx="5.99992" cy="5.99992" r="4.99992" fill="white"></circle><circle cx="5.99992" cy="5.99992" r="4.24992" stroke="#4537DE" stroke-width="1.5"></circle><g filter="url(#filter0_d_9235_307392)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.0852 19.2713C23.2183 17.0319 22.8204 14.35 20.8917 12.4213C18.9965 10.5262 16.6054 9.96035 14.0173 9.34793C11.4553 8.74167 8.70028 8.08975 6.04248 6.05731C8.07492 8.71512 8.72683 11.4702 9.33307 14.0322C9.94547 16.6203 10.5113 19.0115 12.4064 20.9066C14.3352 22.8354 17.0173 23.2332 19.2568 22.0999L21.5991 24.4421L24.4276 21.6137L22.0852 19.2713Z" fill="white"></path><path d="M22.0852 19.2713L21.4903 18.9704L21.2723 19.4013L21.6138 19.7427L22.0852 19.2713ZM14.0173 9.34793L14.1709 8.69918L14.0173 9.34793ZM6.04248 6.05731L6.44745 5.52774L5.51291 6.46228L6.04248 6.05731ZM9.33307 14.0322L9.98182 13.8787L9.33307 14.0322ZM19.2568 22.0999L19.7283 21.6285L19.3868 21.2869L18.9558 21.505L19.2568 22.0999ZM21.5991 24.4421L21.1277 24.9135L21.5991 25.3849L22.0705 24.9135L21.5991 24.4421ZM24.4276 21.6137L24.899 22.0851L25.3704 21.6137L24.899 21.1423L24.4276 21.6137ZM20.4203 12.8927C22.1507 14.6231 22.4899 16.9948 21.4903 18.9704L22.6801 19.5723C23.9466 17.0691 23.4901 14.077 21.3631 11.9499L20.4203 12.8927ZM13.8638 9.99668C16.4809 10.616 18.6795 11.1519 20.4203 12.8927L21.3631 11.9499C19.3136 9.90044 16.7299 9.30474 14.1709 8.69918L13.8638 9.99668ZM5.63751 6.58688C8.42122 8.7156 11.3074 9.39175 13.8638 9.99668L14.1709 8.69918C11.6032 8.0916 8.97935 7.4639 6.44745 5.52774L5.63751 6.58688ZM9.98182 13.8787C9.3769 11.3223 8.70077 8.43605 6.57205 5.65235L5.51291 6.46228C7.44907 8.99419 8.07675 11.6181 8.68432 14.1857L9.98182 13.8787ZM12.8778 20.4352C11.137 18.6944 10.6011 16.4958 9.98182 13.8787L8.68432 14.1857C9.28986 16.7448 9.88554 19.3285 11.935 21.378L12.8778 20.4352ZM18.9558 21.505C16.9802 22.5048 14.6083 22.1657 12.8778 20.4352L11.935 21.378C14.0622 23.5052 17.0545 23.9615 19.5579 22.6947L18.9558 21.505ZM22.0705 23.9707L19.7283 21.6285L18.7854 22.5713L21.1277 24.9135L22.0705 23.9707ZM23.9562 21.1423L21.1277 23.9707L22.0705 24.9135L24.899 22.0851L23.9562 21.1423ZM21.6138 19.7427L23.9562 22.0851L24.899 21.1423L22.5566 18.7999L21.6138 19.7427Z" fill="black"></path><path d="M6.74951 6.7644L15.9419 15.9568" stroke="black" stroke-width="1.33333"></path><circle cx="16.6492" cy="16.6639" r="2" transform="rotate(-45 16.6492 16.6639)" fill="black"></circle></g><defs><filter id="filter0_d_9235_307392" x="2.84603" y="4.63882" width="25.1912" height="25.1906" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1.77778"></feOffset><feGaussianBlur stdDeviation="1.33333"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9235_307392"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9235_307392" result="shape"></feBlend></filter></defs></svg>';
      },
      37390: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="5.99992" cy="5.99992" r="4.99992" fill="white"></circle><circle cx="5.99992" cy="5.99992" r="4.24992" stroke="#4537DE" stroke-width="1.5"></circle><g filter="url(#filter0_d_9235_307392)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22.0852 19.2713C23.2183 17.0319 22.8204 14.35 20.8917 12.4213C18.9965 10.5262 16.6054 9.96035 14.0173 9.34793C11.4553 8.74167 8.70028 8.08975 6.04248 6.05731C8.07492 8.71512 8.72683 11.4702 9.33307 14.0322C9.94547 16.6203 10.5113 19.0115 12.4064 20.9066C14.3352 22.8354 17.0173 23.2332 19.2568 22.0999L21.5991 24.4421L24.4276 21.6137L22.0852 19.2713Z" fill="white"></path><path d="M22.0852 19.2713L21.4903 18.9704L21.2723 19.4013L21.6138 19.7427L22.0852 19.2713ZM14.0173 9.34793L14.1709 8.69918L14.0173 9.34793ZM6.04248 6.05731L6.44745 5.52774L5.51291 6.46228L6.04248 6.05731ZM9.33307 14.0322L9.98182 13.8787L9.33307 14.0322ZM19.2568 22.0999L19.7283 21.6285L19.3868 21.2869L18.9558 21.505L19.2568 22.0999ZM21.5991 24.4421L21.1277 24.9135L21.5991 25.3849L22.0705 24.9135L21.5991 24.4421ZM24.4276 21.6137L24.899 22.0851L25.3704 21.6137L24.899 21.1423L24.4276 21.6137ZM20.4203 12.8927C22.1507 14.6231 22.4899 16.9948 21.4903 18.9704L22.6801 19.5723C23.9466 17.0691 23.4901 14.077 21.3631 11.9499L20.4203 12.8927ZM13.8638 9.99668C16.4809 10.616 18.6795 11.1519 20.4203 12.8927L21.3631 11.9499C19.3136 9.90044 16.7299 9.30474 14.1709 8.69918L13.8638 9.99668ZM5.63751 6.58688C8.42122 8.7156 11.3074 9.39175 13.8638 9.99668L14.1709 8.69918C11.6032 8.0916 8.97935 7.4639 6.44745 5.52774L5.63751 6.58688ZM9.98182 13.8787C9.3769 11.3223 8.70077 8.43605 6.57205 5.65235L5.51291 6.46228C7.44907 8.99419 8.07675 11.6181 8.68432 14.1857L9.98182 13.8787ZM12.8778 20.4352C11.137 18.6944 10.6011 16.4958 9.98182 13.8787L8.68432 14.1857C9.28986 16.7448 9.88554 19.3285 11.935 21.378L12.8778 20.4352ZM18.9558 21.505C16.9802 22.5048 14.6083 22.1657 12.8778 20.4352L11.935 21.378C14.0622 23.5052 17.0545 23.9615 19.5579 22.6947L18.9558 21.505ZM22.0705 23.9707L19.7283 21.6285L18.7854 22.5713L21.1277 24.9135L22.0705 23.9707ZM23.9562 21.1423L21.1277 23.9707L22.0705 24.9135L24.899 22.0851L23.9562 21.1423ZM21.6138 19.7427L23.9562 22.0851L24.899 21.1423L22.5566 18.7999L21.6138 19.7427Z" fill="black"></path><path d="M6.74951 6.7644L15.9419 15.9568" stroke="black" stroke-width="1.33333"></path><circle cx="16.6492" cy="16.6639" r="2" transform="rotate(-45 16.6492 16.6639)" fill="black"></circle></g><defs><filter id="filter0_d_9235_307392" x="2.84603" y="4.63882" width="25.1912" height="25.1906" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1.77778"></feOffset><feGaussianBlur stdDeviation="1.33333"></feGaussianBlur><feComposite in2="hardAlpha" operator="out"></feComposite><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"></feColorMatrix><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9235_307392"></feBlend><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9235_307392" result="shape"></feBlend></filter></defs></svg>';
      },
      61802: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M15.556 3.384a2.75 2.75 0 0 1 3.889 0l1.171 1.171a2.75 2.75 0 0 1 0 3.89L7.823 21.236a1.75 1.75 0 0 1-1.237.513H2.25v-4.336c0-.464.184-.91.513-1.237L15.556 3.384Zm2.828 1.06a1.25 1.25 0 0 0-1.768 0L15.061 6 18 8.94l1.555-1.556a1.25 1.25 0 0 0 0-1.768l-1.171-1.172ZM16.939 10 14 7.06 3.823 17.238a.25.25 0 0 0-.073.177v2.836h2.836a.25.25 0 0 0 .177-.073L16.939 10Z" clip-rule="evenodd"></path></svg>';
      },
      69558: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.75 12c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.25H9c-.41 0-.75.34-.75.75s.34.75.75.75h2.25V18c0 .41.34.75.75.75s.75-.34.75-.75v-2.25H15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V12Zm7.78-6.03-5.5-5.5a.75.75 0 0 0-.53-.22H5c-.97 0-1.75.78-1.75 1.75v20c0 .97.78 1.75 1.75 1.75h14c.97 0 1.75-.78 1.75-1.75V6.5c0-.2-.08-.39-.22-.53ZM19.25 22c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25V2c0-.14.11-.25.25-.25h8.75V6.5c0 .41.34.75.75.75h4.75V22Z"></path></svg>';
      },
      24388: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M10 .5c-.83 0-1.5.67-1.5 1.5v1H10V2h8v3c0 .55.45 1 1 1h3v12h-3v1.5h3c.83 0 1.5-.67 1.5-1.5V6c0-.4-.16-.78-.44-1.06l-4-4C18.78.66 18.4.5 18 .5h-8Zm.75 12.5c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.25H7c-.41 0-.75.34-.75.75s.34.75.75.75h2.25V19c0 .41.34.75.75.75s.75-.34.75-.75v-2.25H13c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V13Zm6.31-4.06-4-4c-.28-.28-.66-.44-1.06-.44H4c-.83 0-1.5.67-1.5 1.5v16c0 .83.67 1.5 1.5 1.5h12c.83 0 1.5-.67 1.5-1.5V10c0-.4-.16-.78-.44-1.06ZM16 22H4V6h8v3c0 .55.45 1 1 1h3v12Z"></path></svg>';
      },
      88105: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.25 13.06c0 .41.34.75.75.75s.75-.34.75-.75v-2c0-.69.56-1.25 1.25-1.25h18c.69 0 1.25.56 1.25 1.25v2c0 .41.34.75.75.75s.75-.34.75-.75v-2c0-1.52-1.23-2.75-2.75-2.75h-8.25V2.87l1.72 1.72c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06L12 0 8.47 3.53c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l1.72-1.72v5.44H3C1.48 8.31.25 9.54.25 11.06v2ZM2 23.81c-.97 0-1.75-.78-1.75-1.75v-5c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v5c0 .97-.78 1.75-1.75 1.75H2Zm-.25-1.75c0 .14.11.25.25.25h3c.14 0 .25-.11.25-.25v-5c0-.14-.11-.25-.25-.25H2c-.14 0-.25.11-.25.25v5Zm7 0c0 .97.78 1.75 1.75 1.75h3c.97 0 1.75-.78 1.75-1.75v-5c0-.97-.78-1.75-1.75-1.75h-3c-.97 0-1.75.78-1.75 1.75v5Zm1.75.25c-.14 0-.25-.11-.25-.25v-5c0-.14.11-.25.25-.25h3c.14 0 .25.11.25.25v5c0 .14-.11.25-.25.25h-3Zm8.5 1.5c-.97 0-1.75-.78-1.75-1.75v-5c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v5c0 .97-.78 1.75-1.75 1.75h-3Zm-.25-1.75c0 .14.11.25.25.25h3c.14 0 .25-.11.25-.25v-5c0-.14-.11-.25-.25-.25h-3c-.14 0-.25.11-.25.25v5Z"></path></svg>';
      },
      9451: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Zm0 1.5c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm1.25-5.75a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM9.75 9a2.25 2.25 0 1 1 2.986 2.127c-.678.235-1.486.87-1.486 1.873v.5a.75.75 0 0 0 1.5 0V13c0-.056.02-.13.102-.219a.92.92 0 0 1 .375-.237A3.751 3.751 0 0 0 12 5.25 3.75 3.75 0 0 0 8.25 9a.75.75 0 0 0 1.5 0Z" clip-rule="evenodd"></path></svg>';
      },
      48982: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.25 10.94c0-.41.34-.75.75-.75s.75.34.75.75v2c0 .69.56 1.25 1.25 1.25h18c.69 0 1.25-.56 1.25-1.25v-2c0-.41.34-.75.75-.75s.75.34.75.75v2c0 1.52-1.23 2.75-2.75 2.75h-8.25v5.44l1.72-1.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L12 24l-3.53-3.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.72 1.72v-5.44H3c-1.52 0-2.75-1.23-2.75-2.75v-2ZM2 .19C1.03.19.25.97.25 1.94v5c0 .97.78 1.75 1.75 1.75h3c.97 0 1.75-.78 1.75-1.75v-5C6.75.97 5.97.19 5 .19H2Zm-.25 1.75c0-.14.11-.25.25-.25h3c.14 0 .25.11.25.25v5c0 .14-.11.25-.25.25H2c-.14 0-.25-.11-.25-.25v-5Zm7 0c0-.97.78-1.75 1.75-1.75h3c.97 0 1.75.78 1.75 1.75v5c0 .97-.78 1.75-1.75 1.75h-3c-.97 0-1.75-.78-1.75-1.75v-5Zm1.75-.25c-.14 0-.25.11-.25.25v5c0 .14.11.25.25.25h3c.14 0 .25-.11.25-.25v-5c0-.14-.11-.25-.25-.25h-3ZM19 .19c-.97 0-1.75.78-1.75 1.75v5c0 .97.78 1.75 1.75 1.75h3c.97 0 1.75-.78 1.75-1.75v-5c0-.97-.78-1.75-1.75-1.75h-3Zm-.25 1.75c0-.14.11-.25.25-.25h3c.14 0 .25.11.25.25v5c0 .14-.11.25-.25.25h-3c-.14 0-.25-.11-.25-.25v-5Z"></path></svg>';
      },
      6058: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M18.53 7.47a.75.75 0 1 0-1.06 1.06l2.72 2.72H3.81l2.72-2.72a.75.75 0 1 0-1.06-1.06L.94 12l4.53 4.53a.75.75 0 0 0 1.06-1.06l-2.72-2.72h16.38l-2.72 2.72a.75.75 0 1 0 1.06 1.06L23.06 12l-4.53-4.53Z"></path></svg>';
      },
      91288: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9.5 4A1.5 1.5 0 0 1 11 2.5h7a1.5 1.5 0 0 1 1.06.44l4 4A1.5 1.5 0 0 1 23.5 8v12a1.5 1.5 0 0 1-1.5 1.5H11A1.5 1.5 0 0 1 9.5 20v-2H11v2h11V8h-4V4h-7v6H9.5V4ZM5.591 9.47a.75.75 0 0 0-1.06 0L0 14l4.53 4.53a.75.75 0 0 0 1.061-1.06l-2.72-2.72H16a.75.75 0 0 0 0-1.5H2.871l2.72-2.72a.75.75 0 0 0 0-1.06Z" clip-rule="evenodd"></path></svg>';
      },
      46018: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.5 4c0-.83.67-1.5 1.5-1.5h7c.4 0 .78.16 1.06.44l4 4c.28.28.44.66.44 1.06v2H13V8H9V4H2v16h11v-2h1.5v2c0 .83-.67 1.5-1.5 1.5H2c-.83 0-1.5-.67-1.5-1.5V4Zm17.91 5.47c.29-.29.77-.29 1.06 0L24 14l-4.53 4.53c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l2.72-2.72H8c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h13.13l-2.72-2.72a.754.754 0 0 1 0-1.06Z"></path></svg>';
      },
      13006: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10.5 2c0-.83.67-1.5 1.5-1.5h6c.4 0 .78.16 1.06.44l4 4c.28.28.44.66.44 1.06v10c0 .83-.67 1.5-1.5 1.5H12c-.83 0-1.5-.67-1.5-1.5V2ZM12 16V2h6v3c0 .55.45 1 1 1h3v10H12ZM7 3.5h2V5H7v14h11.5c0 .83-.67 1.5-1.5 1.5H7c-.83 0-1.5-.67-1.5-1.5V5c0-.83.67-1.5 1.5-1.5Zm-5 3h2V8H2v14h11.5c0 .83-.67 1.5-1.5 1.5H2c-.83 0-1.5-.67-1.5-1.5V8c0-.83.67-1.5 1.5-1.5Z" clip-rule="evenodd"></path></svg>';
      },
      52449: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M15.47 3.47a.75.75 0 0 0 0 1.06l2.72 2.72H10a6.75 6.75 0 0 0 0 13.5h2a.75.75 0 0 0 0-1.5h-2a5.25 5.25 0 1 1 0-10.5h8.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06L21.06 8l-4.53-4.53a.75.75 0 0 0-1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      1562: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M8.25 15c0-.41.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H9c-.41 0-.75-.34-.75-.75Zm12.28-9.03-5.5-5.5a.75.75 0 0 0-.53-.22H5c-.97 0-1.75.78-1.75 1.75v20c0 .97.78 1.75 1.75 1.75h14c.97 0 1.75-.78 1.75-1.75V6.5c0-.2-.08-.39-.22-.53ZM19.25 22c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25V2c0-.14.11-.25.25-.25h8.75V6.5c0 .41.34.75.75.75h4.75V22Z"></path></svg>';
      },
      52684: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.994 2.564a.75.75 0 0 0-.988-1.128l-4 3.5a.75.75 0 0 0 0 1.128l4 3.5a.75.75 0 0 0 .988-1.128l-2.558-2.239A6.25 6.25 0 1 1 5.75 12.25a.75.75 0 0 0-1.5 0 7.75 7.75 0 1 0 6.397-7.632l2.347-2.054Z"></path></svg>';
      },
      58287: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11.006 2.564a.75.75 0 0 1 .988-1.128l4 3.5a.75.75 0 0 1 0 1.128l-4 3.5a.75.75 0 0 1-.988-1.128l2.558-2.239a6.25 6.25 0 1 0 4.686 6.053.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.397-7.632l-2.347-2.054Z"></path></svg>';
      },
      57208: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.5 4H2V2h2V.5H2C1.17.5.5 1.17.5 2v2Zm23 0H22V2h-2V.5h2c.83 0 1.5.67 1.5 1.5v2Zm0 3H22v3.5h1.5V7Zm0 6.5H22V17h1.5v-3.5Zm0 6.5H22v2h-2v1.5h2c.83 0 1.5-.67 1.5-1.5v-2ZM.5 7H2v3.5H.5V7Zm0 6.5H2V17H.5v-3.5Zm0 6.5H2v2h2v1.5H2c-.83 0-1.5-.67-1.5-1.5v-2ZM7 23.5V22h3.5v1.5H7Zm6.5 0V22H17v1.5h-3.5ZM17 .5V2h-3.5V.5H17Zm-6.5 0V2H7V.5h3.5ZM4 5.5C4 4.67 4.67 4 5.5 4h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4C4.67 11 4 10.33 4 9.5v-4Zm1.5 0v4h4v-4h-4Zm-1.5 9c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4c-.83 0-1.5-.67-1.5-1.5v-4Zm1.5 0v4h4v-4h-4Zm9-10.5c-.83 0-1.5.67-1.5 1.5v4c0 .83.67 1.5 1.5 1.5h4c.83 0 1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5h-4Zm0 5.5v-4h4v4h-4Zm-1.5 5c0-.83.67-1.5 1.5-1.5h4c.83 0 1.5.67 1.5 1.5v4c0 .83-.67 1.5-1.5 1.5h-4c-.83 0-1.5-.67-1.5-1.5v-4Zm1.5 0v4h4v-4h-4Z"></path></svg>';
      },
      95119: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.5 4H2V2h2V.5H2C1.17.5.5 1.17.5 2v2Zm23 0H22V2h-2V.5h2c.83 0 1.5.67 1.5 1.5v2Zm0 3H22v3.5h1.5V7Zm0 6.5H22V17h1.5v-3.5Zm0 6.5H22v2h-2v1.5h2c.83 0 1.5-.67 1.5-1.5v-2ZM.5 7H2v3.5H.5V7Zm0 6.5H2V17H.5v-3.5Zm0 6.5H2v2h2v1.5H2c-.83 0-1.5-.67-1.5-1.5v-2ZM7 23.5V22h3.5v1.5H7Zm6.5 0V22H17v1.5h-3.5ZM17 .5V2h-3.5V.5H17Zm-6.5 0V2H7V.5h3.5Zm6.03 8.03c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-8 8c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l8-8Z"></path></svg>';
      },
      32428: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.53 3.47a.75.75 0 0 1 0 1.06L5.81 7.25H14a6.75 6.75 0 0 1 0 13.5h-2a.75.75 0 0 1 0-1.5h2a5.25 5.25 0 1 0 0-10.5H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06L2.94 8l4.53-4.53a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      62475: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10ZM10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm.75-10a.75.75 0 0 0-1.5 0v2.25H7a.75.75 0 0 0 0 1.5h2.25V13a.75.75 0 0 0 1.5 0v-2.25H13a.75.75 0 0 0 0-1.5h-2.25V7Z" clip-rule="evenodd"></path></svg>';
      },
      75480: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10ZM10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM7 9.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7Z" clip-rule="evenodd"></path></svg>';
      },
      5111: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2.003 2.889a8.503 8.503 0 0 1-9.492 5.48l9.492-5.48Zm.367-1.367-11.23 6.483a8.497 8.497 0 0 1-2.92-1.778l14.073-8.125a8.526 8.526 0 0 1 .077 3.42Zm-.366-4.408L5.504 17.482a8.49 8.49 0 0 1-1.502-2.597l14.494-8.368a8.492 8.492 0 0 1 1.502 2.597Zm-2.212-3.341L3.713 13.898a8.527 8.527 0 0 1-.077-3.42l11.229-6.483a8.499 8.499 0 0 1 2.92 1.778ZM13.495 3.63a8.503 8.503 0 0 0-9.491 5.48l9.49-5.48Z" clip-rule="evenodd"></path></svg>';
      },
      58439: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 20.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Zm0 1.5c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z" clip-rule="evenodd"></path></svg>';
      },
      5461: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 2.25a.75.75 0 0 1 .75.75v13.19l2.72-2.72a.75.75 0 1 1 1.06 1.06L12 19.06l-4.53-4.53a.75.75 0 1 1 1.06-1.06l2.72 2.72V3a.75.75 0 0 1 .75-.75Zm-9 14a.75.75 0 0 1 .75.75v3c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-3a.75.75 0 0 1 1.5 0v3A2.75 2.75 0 0 1 19 22.75H5A2.75 2.75 0 0 1 2.25 20v-3a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd"></path></svg>';
      },
      1925: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M15.61 8.44001C15.85 8.11001 15.78 7.64001 15.45 7.39001C15.11 7.14001 14.65 7.22001 14.4 7.55001C14.37 7.59001 11.65 11.24 8.01002 11.24C4.37002 11.24 1.63002 7.59001 1.61002 7.56001C1.37002 7.23001 0.90002 7.15001 0.56002 7.40001C0.23002 7.64001 0.15002 8.11001 0.40002 8.45001C0.46002 8.54001 1.23002 9.57001 2.52002 10.61L1.17002 12.54C0.930019 12.88 1.01002 13.35 1.35002 13.58C1.48002 13.67 1.63002 13.72 1.78002 13.72C2.02002 13.72 2.25002 13.61 2.39002 13.4L3.74002 11.48C4.74002 12.09 5.92002 12.58 7.25002 12.72V15.01C7.25002 15.42 7.59002 15.76 8.00002 15.76C8.41002 15.76 8.75002 15.42 8.75002 15.01V12.72C10.08 12.58 11.26 12.08 12.26 11.48L13.61 13.4C13.76 13.61 13.99 13.72 14.23 13.72C14.38 13.72 14.53 13.68 14.66 13.58C15 13.34 15.08 12.87 14.84 12.54L13.49 10.61C14.78 9.58001 15.55 8.54001 15.61 8.45001V8.44001Z" fill="currentColor"></path></svg>';
      },
      16074: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.03899 8.16712C2.99322 8.10774 2.9511 8.05183 2.91276 8C2.9511 7.94817 2.99322 7.89226 3.03899 7.83288C3.31051 7.48064 3.70596 7.01225 4.20119 6.54615C5.21159 5.59519 6.5337 4.75 7.99967 4.75C9.46564 4.75 10.7878 5.59519 11.7981 6.54615C12.2934 7.01225 12.6888 7.48064 12.9604 7.83288C13.0061 7.89226 13.0482 7.94816 13.0866 8C13.0482 8.05183 13.0061 8.10774 12.9604 8.16712C12.6888 8.51936 12.2934 8.98775 11.7981 9.45385C10.7878 10.4048 9.46564 11.25 7.99967 11.25C6.5337 11.25 5.21159 10.4048 4.20119 9.45385C3.70596 8.98775 3.31051 8.51936 3.03899 8.16712ZM13.9997 8C14.6357 7.6025 14.6355 7.60229 14.6354 7.60206L13.9997 8ZM14.6354 7.60206L14.8841 8L14.6357 8.3975L13.9997 8C14.6357 8.3975 14.6352 8.39824 14.6351 8.39847L14.6342 8.3998L14.6319 8.40356L14.6243 8.41537L14.5984 8.4555C14.5762 8.48935 14.5445 8.5371 14.5034 8.59677C14.4214 8.71604 14.3021 8.88341 14.1484 9.08288C13.8418 9.48064 13.3935 10.0123 12.8262 10.5462C11.7116 11.5952 10.0337 12.75 7.99967 12.75C5.96564 12.75 4.28775 11.5952 3.17315 10.5462C2.60588 10.0123 2.15758 9.48064 1.85097 9.08288C1.69721 8.88341 1.57789 8.71604 1.4959 8.59677C1.45487 8.5371 1.42311 8.48935 1.40097 8.4555L1.37499 8.41537L1.36748 8.40356L1.36511 8.3998L1.36367 8.3975L1.99934 8.00021C1.36765 8.39501 1.36356 8.39726 1.36367 8.3975L1.11523 8L1.36367 7.6025L1.99934 8.00021C1.36334 7.60271 1.36413 7.60176 1.36428 7.60153L1.36511 7.6002L1.36748 7.59644L1.37499 7.58463L1.40097 7.5445C1.42311 7.51066 1.45487 7.4629 1.4959 7.40323C1.57789 7.28396 1.69721 7.11659 1.85097 6.91712C2.15758 6.51936 2.60588 5.98775 3.17315 5.45385C4.28775 4.40481 5.96564 3.25 7.99967 3.25C10.0337 3.25 11.7116 4.40481 12.8262 5.45385C13.3935 5.98775 13.8418 6.51936 14.1484 6.91712C14.3021 7.11659 14.4214 7.28396 14.5034 7.40323C14.5445 7.4629 14.5762 7.51066 14.5984 7.5445L14.6243 7.58463L14.6319 7.59644L14.6342 7.6002L14.6354 7.60206ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z" fill="currentColor"></path></svg>';
      },
      92742: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3Zm5 19v-3.5h1.5v3h11v-11h-3V8H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1Z" clip-rule="evenodd"></path></svg>';
      },
      44882: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M21 5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h18Zm-4 1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4V6ZM7 18H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h4v12ZM8.5 6.5h7v11h-7v-11Z" clip-rule="evenodd"></path></svg>';
      },
      85449: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6Zm20.75-1H22a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-1.25V5Zm-1.5 0H4.75v14h14.5V5Zm-16 14V5H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.25Z" clip-rule="evenodd"></path></svg>';
      },
      14379: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m23.691 19.7-6-14a.758.758 0 0 0-.69-.45c-.3 0-.57.18-.69.45l-6 14c-.16.39.01.83.39.99.39.16.83-.01.99-.39l2.38-5.55h5.86l2.38 5.55c.16.38.6.55.99.39.38-.16.55-.6.39-.99Zm-8.98-6.45 2.29-5.35 2.29 5.35h-4.58Zm-6.01 6.48-3.5-9a.748.748 0 0 0-.7-.48c-.31 0-.59.19-.7.48l-3.5 9a.75.75 0 1 0 1.4.54l.79-2.02h4.02l.79 2.02a.75.75 0 1 0 1.4-.54Zm-5.63-2.98 1.43-3.68 1.43 3.68h-2.86Z" clip-rule="evenodd"></path></svg>';
      },
      81741: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M1 3.25c-.41 0-.75.34-.75.75s.34.75.75.75h5.25V15c0 .41.34.75.75.75s.75-.34.75-.75V4.75H13c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H1Zm21.75 7h-11.5V14c0 .41.34.75.75.75s.75-.34.75-.75v-2.25h3.5v8.5H14.5c-.41 0-.75.34-.75.75s.34.75.75.75h5c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.75v-8.5h3.5V14c0 .41.34.75.75.75s.75-.34.75-.75v-3.75Z"></path></svg>';
      },
      90686: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22 5H2C.9 5 0 5.9 0 7v10c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm.5 12c0 .28-.22.5-.5.5H2c-.28 0-.5-.22-.5-.5V7c0-.28.22-.5.5-.5h20c.28 0 .5.22.5.5v10ZM8.27 9.29c-1.68 0-2.84 1.3-2.84 2.91s1.16 2.91 2.84 2.91 2.84-1.3 2.84-2.91-1.16-2.91-2.84-2.91Zm0 4.62c-.97 0-1.46-.89-1.46-1.71s.49-1.71 1.46-1.71 1.47.89 1.47 1.71-.49 1.71-1.47 1.71ZM12.75 15V9.4h1.38v2.14l2.05-2.14h1.66l-2.06 2.18L17.92 15h-1.59l-1.53-2.48-.67.72V15h-1.38Z" clip-rule="evenodd"></path></svg>';
      },
      63357: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M16.53 10.03c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0L11 13.44l-1.97-1.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l2.38 2.38c.36.36.94.36 1.3 0l4.88-4.88ZM18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm.5 14c0 .28-.22.5-.5.5H6c-.28 0-.5-.22-.5-.5V6c0-.28.22-.5.5-.5h12c.28 0 .5.22.5.5v12Z"></path></svg>';
      },
      97245: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M5 8.25c.41 0 .75.34.75.75v6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-.41.34-.75.75-.75Zm9.21 2.25h5.59c.45 0 .67.54.35.85l-2.79 2.79c-.2.2-.51.2-.71 0l-2.79-2.79c-.32-.31-.09-.85.35-.85ZM22 5H2C.9 5 0 5.9 0 7v10c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm.5 12c0 .28-.22.5-.5.5H2c-.28 0-.5-.22-.5-.5V7c0-.28.22-.5.5-.5h20c.28 0 .5.22.5.5v10Z"></path></svg>';
      },
      17035: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9 6C7.34 6 6 7.34 6 9s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3Zm0 4.5c-.83 0-1.5-.67-1.5-1.5S8.17 7.5 9 7.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5Zm7 3.5H8c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2Zm.5 4c0 .28-.22.5-.5.5H8c-.28 0-.5-.22-.5-.5v-2c0-.28.22-.5.5-.5h8c.28 0 .5.22.5.5v2Zm4.03-12.03-5.5-5.5a.75.75 0 0 0-.53-.22H5c-.97 0-1.75.78-1.75 1.75v20c0 .97.78 1.75 1.75 1.75h14c.97 0 1.75-.78 1.75-1.75V6.5c0-.2-.08-.39-.22-.53ZM19.25 22c0 .14-.11.25-.25.25H5c-.14 0-.25-.11-.25-.25V2c0-.14.11-.25.25-.25h8.75V6.5c0 .41.34.75.75.75h4.75V22Z" clip-rule="evenodd"></path></svg>';
      },
      48358: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19 17.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5Zm0-5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5Zm-5.5 5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5Zm0-5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5Zm-5.5 5c0 .83-.67 1.5-1.5 1.5S5 18.33 5 17.5 5.67 16 6.5 16s1.5.67 1.5 1.5Zm12-15h-1.75V1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5h-9.5V1c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.5H4C2.07 2.5.5 4.07.5 6v13c0 1.93 1.57 3.5 3.5 3.5h16c1.93 0 3.5-1.57 3.5-3.5V6c0-1.93-1.57-3.5-3.5-3.5ZM22 19c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9.25h20V19Zm0-11.25H2V6c0-1.1.9-2 2-2h1.75v2c0 .41.34.75.75.75s.75-.34.75-.75V4h9.5v2c0 .41.34.75.75.75s.75-.34.75-.75V4H20c1.1 0 2 .9 2 2v1.75Z"></path></svg>';
      },
      92070: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19.75 7c0 .41-.34.75-.75.75h-9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75ZM19 17.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-9c-.41 0-.75.34-.75.75s.34.75.75.75h9Zm.75-5.75c0 .41-.34.75-.75.75h-9c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h9c.41 0 .75.34.75.75ZM5.5 8.5C6.33 8.5 7 7.83 7 7s-.67-1.5-1.5-1.5S4 6.17 4 7s.67 1.5 1.5 1.5ZM7 17c0 .83-.67 1.5-1.5 1.5S4 17.83 4 17s.67-1.5 1.5-1.5S7 16.17 7 17Zm-1.5-3.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S4 11.17 4 12s.67 1.5 1.5 1.5ZM22 2H2C.9 2 0 2.9 0 4v16c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm.5 18c0 .28-.22.5-.5.5H2c-.28 0-.5-.22-.5-.5V4c0-.28.22-.5.5-.5h20c.28 0 .5.22.5.5v16Z"></path></svg>';
      },
      60571: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12 15c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3Zm0-11c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 14.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13Z"></path></svg>';
      },
      50121: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7.337 19H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.351c-.2.698-.42 1.353-.655 1.936-.293.73-.624 1.386-.993 1.872-.341.45-.856.942-1.546.942-.816 0-1.29-.637-1.536-1.145-.264-.545-.419-1.235-.503-1.905a11.182 11.182 0 0 1-.079-1.7ZM2 6.5h20a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5h-8.964a35.02 35.02 0 0 0 .378-1.872c.164-.947.288-1.902.361-2.806a12.627 12.627 0 0 1 1.573-.884l.056.143.128.325c.114.284.264.63.454.911.161.24.517.683 1.105.683 1.035 0 1.89-.59 2.49-1.386.6-.797 1.003-1.862 1.162-3.011a.75.75 0 1 0-1.486-.206c-.132.95-.457 1.76-.874 2.314-.37.49-.768.73-1.145.78l-.008-.011a3.71 3.71 0 0 1-.307-.636l-.098-.248a11.933 11.933 0 0 0-.228-.557 2.162 2.162 0 0 0-.224-.392c-.062-.083-.304-.397-.737-.397a.75.75 0 0 0-.27.05 11.9 11.9 0 0 0-1.517.723c-.002-.251-.01-.493-.023-.724-.044-.734-.155-1.422-.382-1.95-.223-.52-.667-1.099-1.444-1.099-.52 0-1.215.217-1.9.486-.718.282-1.539.67-2.358 1.1-1.623.853-3.322 1.917-4.239 2.727a.75.75 0 1 0 .994 1.124c.78-.69 2.353-1.688 3.943-2.523a23.18 23.18 0 0 1 2.21-1.032c.646-.255 1.088-.368 1.31-.38a.69.69 0 0 1 .106.188c.125.292.222.776.262 1.449.03.48.027 1.023-.002 1.609-.524.377-1.03.785-1.506 1.207-1.358 1.207-2.527 2.596-3.131 3.843a2.563 2.563 0 0 0-.163.452H2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5ZM11.084 19c-.152.496-.314.96-.482 1.377-.27.675-.543 1.192-.796 1.526-.183.24-.299.315-.343.337-.035-.027-.104-.102-.194-.288-.162-.335-.29-.842-.364-1.439A9.678 9.678 0 0 1 8.838 19h2.246Zm.41-1.5H9.142c.518-.964 1.48-2.113 2.675-3.174.105-.094.212-.186.32-.278a32.415 32.415 0 0 1-.643 3.452Zm.442-8.77s.006.002.016.012c-.011-.005-.016-.01-.016-.011ZM9.488 22.257s-.003 0-.008-.003c.006.001.008.002.008.003Zm7.811-9.69-.01-.01.01.01Z" clip-rule="evenodd"></path></svg>';
      },
      29890: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.25 2A.75.75 0 0 1 9 1.25c1.227 0 2.316.589 3 1.5a3.744 3.744 0 0 1 3-1.5.75.75 0 0 1 0 1.5A2.25 2.25 0 0 0 12.75 5H22a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.25v.002A2.25 2.25 0 0 0 15 21.25a.75.75 0 0 1 0 1.5 3.744 3.744 0 0 1-3-1.5 3.744 3.744 0 0 1-3 1.5.75.75 0 0 1 0-1.5A2.25 2.25 0 0 0 11.25 19H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h9.25A2.25 2.25 0 0 0 9 2.75.75.75 0 0 1 8.25 2ZM2 6.5h9.25v4.75h-1.5a.75.75 0 0 0 0 1.5h1.5v4.75H2a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5Zm10.75 6.25v4.75H22a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5h-9.25v4.75h1.5a.75.75 0 0 1 0 1.5h-1.5Z" clip-rule="evenodd"></path></svg>';
      },
      66962: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.255 5.002c0-.41.34-.75.75-.75h7.003c.41 0 .75.34.75.75v7.003c0 .41-.34.75-.75.75h-6.253v6.253c0 .41-.34.75-.75.75H5.002c-.41 0-.75-.34-.75-.75v-7.003c0-.41.34-.75.75-.75h6.253V5.002Zm1.5.75v5.503h5.503V5.752h-5.503Zm-7.003 7.003v5.503h5.503v-5.503H5.752ZM1.251 3.852A2.012 2.012 0 0 1 0 2C0 .9.9 0 2 0c.841 0 1.561.52 1.852 1.25h16.296C20.448.52 21.168 0 22 0c1.1 0 2 .9 2 2 0 .841-.52 1.561-1.25 1.852v16.296c.73.3 1.25 1.02 1.25 1.851C24 23.1 23.1 24 22 24c-.841 0-1.561-.52-1.852-1.25H3.852C3.552 23.48 2.832 24 2 24c-1.1 0-2-.9-2-2 0-.841.52-1.561 1.25-1.852V3.852Zm20.008 16.306c-.5.2-.9.6-1.1 1.1H3.851c-.2-.5-.6-.9-1.1-1.1V3.852c.5-.2.9-.6 1.1-1.1h16.296c.2.5.6.9 1.1 1.1v16.296l.01.01Z" clip-rule="evenodd"></path></svg>';
      },
      60967: e => {
        e.exports = '<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0.75" y1="1.44214" x2="15.25" y2="1.44214" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></line><line x1="0.75" y1="7.44214" x2="15.25" y2="7.44214" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></line><line x1="0.75" y1="13.4421" x2="15.25" y2="13.4421" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></line></svg>';
      },
      99319: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4 2.5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-13a3 3 0 0 0-3-3H4Zm3 3.75a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H17a.75.75 0 0 0 0-1.5H7Z" clip-rule="evenodd"></path></svg>';
      },
      939: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M14.75 3.5a.75.75 0 0 0-1.085-.67l-4 2a.75.75 0 0 0-.415.67v2.75H9a.75.75 0 0 0-.75.75v2a7.25 7.25 0 0 1-2.9 5.8l-.8.6a.75.75 0 0 0-.3.6v4a.75.75 0 1 0 1.5 0v-3.625l.5-.375a8.75 8.75 0 0 0 3.5-7V9.75h4.5V11a8.75 8.75 0 0 0 3.5 7l.5.375V22a.75.75 0 1 0 1.5 0v-4a.75.75 0 0 0-.3-.6l-.8-.6a7.25 7.25 0 0 1-2.9-5.8V9a.75.75 0 0 0-.75-.75h-.25V3.5Z"></path></svg>';
      },
      71865: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.5 10C7.33 10 8 9.33 8 8.5S7.33 7 6.5 7 5 7.67 5 8.5 5.67 10 6.5 10ZM23 15.94V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-2l.03-.03-.03-.03ZM21.5 18c0 .28-.22.5-.5.5H3c-.12 0-.23-.04-.32-.12l3.82-3.82 2.47 2.47a.75.75 0 0 0 1.06 0L16 11.06l5.5 5.5V18Zm0-3.56-4.97-4.97a.75.75 0 0 0-1.06 0L9.5 15.44l-2.47-2.47a.754.754 0 0 0-1.06 0L2.5 16.44V6c0-.28.22-.5.5-.5h18c.28 0 .5.22.5.5v8.44Z"></path></svg>';
      },
      69241: e => {
        e.exports = '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 8.99997C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 8.99997C1.5 4.85783 4.85786 1.49997 9 1.49997C13.1421 1.49997 16.5 4.85783 16.5 8.99997ZM9.92328 11.947V7.82272H6.96415V8.87572H8.38278V11.947H6.9154V13H11.2395V11.947H9.92328ZM9.6454 5.36084C9.4764 5.19509 9.25865 5.11222 8.99215 5.11222C8.7224 5.11222 8.5014 5.19509 8.32915 5.36084C8.16015 5.52659 8.07565 5.73297 8.07565 5.97997C8.07565 6.22697 8.16015 6.43497 8.32915 6.60397C8.5014 6.76972 8.7224 6.85259 8.99215 6.85259C9.25865 6.85259 9.4764 6.76972 9.6454 6.60397C9.8144 6.43497 9.8989 6.22697 9.8989 5.97997C9.8989 5.73297 9.8144 5.52659 9.6454 5.36084Z" fill="currentColor"></path></svg>';
      },
      94814: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m21.758 8.562-6.36-6.36c-.39-.39-1.02-.39-1.42 0l-12.02 12.02a3 3 0 0 0 0 4.24l3.54 3.54h4.24l12.02-12.02c.39-.39.39-1.02 0-1.42Zm-12.64 11.94h-3l-3.1-3.1c-.58-.58-.58-1.53 0-2.12l2.3-2.3 5.66 5.66-1.86 1.86Zm2.92-2.92-5.66-5.66 8.31-8.3 5.66 5.65-8.31 8.31Zm-.18 4.42 1.5-1.5h4.64c.41 0 .75.34.75.75s-.34.75-.75.75h-6.14Zm8.39-.75c0-.41.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75h-2c-.41 0-.75-.34-.75-.75Z" clip-rule="evenodd"></path></svg>';
      },
      79363: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M13 4a1 1 0 1 0-2 0v2.25h-1a.75.75 0 0 0-.75.75v2.671c0 1.357-.957 2.577-2.157 3.8A6.393 6.393 0 0 0 5.25 18v3a.75.75 0 0 0 1.5 0v-3c0-1.386.536-2.586 1.413-3.479 1.175-1.196 2.587-2.816 2.587-4.85V7.75h2.5v1.921c0 2.035 1.412 3.654 2.587 4.85A4.893 4.893 0 0 1 17.25 18v3a.75.75 0 0 0 1.5 0v-3a6.39 6.39 0 0 0-1.843-4.53c-1.2-1.222-2.157-2.442-2.157-3.799V7a.75.75 0 0 0-.75-.75h-1V4Z"></path></svg>';
      },
      22606: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M2.85 8l1.27-1.32L6.74 9.3l5.15-5.13 1.26 1.27-6.41 6.39z" fill="currentColor"></path></svg>';
      },
      66311: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M9.75 7a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-1.901l-2.16 9.5H13a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1 0-1.5h1.901l2.16-9.5H10.5A.75.75 0 0 1 9.75 7Z"></path></svg>';
      },
      91998: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M16.01 12c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4Zm-1.5 0a2.5 2.5 0 0 1-5 0 2.5 2.5 0 0 1 5 0ZM11.33 1.25c-.83 0-1.55.59-1.72 1.41l-.4 2c-.01.05-.06.13-.17.18-.11.05-.2.03-.24 0L7.1 3.71c-.69-.46-1.62-.37-2.21.22l-.96.96c-.59.59-.68 1.51-.22 2.21l1.13 1.7s.05.13 0 .24c-.05.11-.13.16-.18.17l-2 .4c-.82.16-1.41.88-1.41 1.72v1.36c0 .83.59 1.55 1.41 1.72l2 .4c.05.01.13.06.18.17.05.11.03.2 0 .24l-1.13 1.7c-.46.69-.37 1.62.22 2.21l.96.96c.59.59 1.51.68 2.21.22l1.7-1.13s.13-.05.24 0c.11.05.16.13.17.18l.4 2c.16.82.88 1.41 1.72 1.41h1.36c.83 0 1.55-.59 1.72-1.41l.4-2c.01-.05.06-.13.17-.18.11-.05.2-.03.24 0l1.7 1.13c.69.46 1.62.37 2.21-.22l.96-.96c.59-.59.68-1.51.22-2.21l-1.13-1.7s-.05-.13 0-.24c.05-.11.13-.16.18-.17l2-.4c.82-.16 1.41-.88 1.41-1.72v-1.36c0-.83-.59-1.55-1.41-1.72l-2-.4c-.05-.01-.13-.06-.18-.17-.05-.11-.03-.2 0-.24l1.13-1.7c.46-.69.37-1.62-.22-2.21l-.96-.96c-.59-.59-1.51-.68-2.21-.22l-1.7 1.13s-.13.05-.24 0c-.11-.05-.16-.13-.17-.18l-.4-2c-.16-.82-.88-1.41-1.72-1.41h-1.36Zm-.25 1.7c.02-.12.13-.2.25-.2h1.36c.12 0 .22.08.25.2l.4 2c.12.61.56 1.06 1.07 1.27.51.21 1.14.2 1.65-.14l1.7-1.13c.1-.07.23-.05.32.03l.96.96c.08.08.1.22.03.32l-1.13 1.7c-.34.51-.36 1.14-.14 1.65.21.51.66.95 1.27 1.07l2 .4c.12.02.2.13.2.25v1.36c0 .12-.08.22-.2.25l-2 .4c-.61.12-1.06.56-1.27 1.07-.21.51-.2 1.14.14 1.65l1.13 1.7c.07.1.05.23-.03.32l-.96.96c-.08.08-.22.1-.32.03l-1.7-1.13c-.51-.34-1.14-.36-1.65-.14-.51.21-.95.66-1.07 1.27l-.4 2c-.02.12-.13.2-.25.2h-1.36c-.12 0-.22-.08-.25-.2l-.4-2c-.12-.61-.56-1.06-1.07-1.27-.51-.21-1.14-.2-1.65.14l-1.7 1.13c-.1.07-.23.05-.32-.03l-.96-.96a.256.256 0 0 1-.03-.32l1.13-1.7c.34-.51.36-1.14.14-1.65-.21-.51-.66-.95-1.27-1.07l-2-.4a.248.248 0 0 1-.2-.25v-1.36c0-.12.08-.22.2-.25l2-.4c.61-.12 1.06-.56 1.27-1.07.21-.51.2-1.14-.14-1.65l-1.13-1.7c-.07-.1-.05-.23.03-.32l.96-.96c.08-.08.22-.1.32-.03l1.7 1.13c.51.34 1.14.36 1.65.14.51-.21.95-.66 1.07-1.27l.4-2Z" clip-rule="evenodd"></path></svg>';
      },
      46318: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.69 1.31c-.11-.8-1.27-.8-1.39 0l-.25 1.74-1.74.25c-.8.11-.8 1.27 0 1.39l1.74.25.25 1.74c.11.8 1.27.8 1.39 0l.25-1.74 1.74-.25c.8-.11.8-1.27 0-1.39l-1.74-.25-.25-1.74Zm-7 10c-.11-.8-1.27-.8-1.39 0l-.25 1.74-1.74.25c-.8.11-.8 1.27 0 1.39l1.74.25.25 1.74c.11.8 1.27.8 1.39 0l.25-1.74 1.74-.25c.8-.11.8-1.27 0-1.39l-1.74-.25-.25-1.74Zm14 5c-.11-.8-1.27-.8-1.39 0l-.25 1.74-1.74.25c-.8.11-.8 1.27 0 1.39l1.74.25.25 1.74c.11.8 1.27.8 1.39 0l.25-1.74 1.74-.25c.8-.11.8-1.27 0-1.39l-1.74-.25-.25-1.74ZM20 8.99c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1Zm-8 5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Zm-8-8c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1Zm5 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1Z"></path></svg>';
      },
      1409: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M5.75 4V0h-1.5v4c0 .97.78 1.75 1.75 1.75h12c.97 0 1.75-.78 1.75-1.75V0h-1.5v4c0 .14-.11.25-.25.25H6c-.14 0-.25-.11-.25-.25Zm0 5c0-.14.11-.25.25-.25h12c.14 0 .25.11.25.25v15h1.5V9c0-.97-.78-1.75-1.75-1.75H6c-.97 0-1.75.78-1.75 1.75v15h1.5V9Z"></path></svg>';
      },
      63113: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M2 20.75A1.75 1.75 0 0 1 .25 19V5c0-.966.784-1.75 1.75-1.75h20c.966 0 1.75.784 1.75 1.75v14A1.75 1.75 0 0 1 22 20.75H2ZM1.75 5A.25.25 0 0 1 2 4.75h9.25v14.5H2a.25.25 0 0 1-.25-.25V5Zm11-.25v14.5H22a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25h-9.25Z" clip-rule="evenodd"></path></svg>';
      },
      65558: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M5 1.75a.25.25 0 0 0-.25.25v20c0 .138.112.25.25.25h14a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25H5ZM3.25 2c0-.966.784-1.75 1.75-1.75h14c.966 0 1.75.784 1.75 1.75v20A1.75 1.75 0 0 1 19 23.75H5A1.75 1.75 0 0 1 3.25 22V2Z" clip-rule="evenodd"></path></svg>';
      },
      58417: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.994 2.564a.75.75 0 0 0-.988-1.128l-4 3.5a.75.75 0 0 0 0 1.128l4 3.5a.75.75 0 0 0 .988-1.128l-2.558-2.239A6.25 6.25 0 1 1 5.75 12.25a.75.75 0 0 0-1.5 0 7.75 7.75 0 1 0 6.397-7.632l2.347-2.054Z"></path></svg>';
      },
      54669: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11.006 2.564a.75.75 0 0 1 .988-1.128l4 3.5a.75.75 0 0 1 0 1.128l-4 3.5a.75.75 0 0 1-.988-1.128l2.558-2.239a6.25 6.25 0 1 0 4.686 6.053.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.397-7.632l-2.347-2.054Z"></path></svg>';
      },
      20113: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M2 5.75h1.579v-1.5H2v1.5Zm3.684 0h1.58v-1.5h-1.58v1.5Zm3.684 0h1.58v-1.5h-1.58v1.5Zm3.685 0h1.579v-1.5h-1.58v1.5Zm3.684 0h1.579v-1.5h-1.58v1.5Zm3.684 0H22v-1.5h-1.579v1.5Zm-1.421 7h3v-1.5h-3v1.5Zm-17 7h20v-1.5H2v1.5Zm15-7h-4v-1.5h4v1.5Zm-10 0h4v-1.5H7v1.5Zm-2 0H2v-1.5h3v1.5Z" clip-rule="evenodd"></path></svg>';
      },
      41869: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22 5.5H2v-1h20v1Zm0 6.5H2v-2h20v2ZM2 19.5h20v-3H2v3Z" clip-rule="evenodd"></path></svg>';
      },
      66294: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22.53 1.47a.75.75 0 0 1 0 1.06l-20 20a.75.75 0 0 1-1.06-1.06l20-20a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      83553: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M2.25 2a.75.75 0 0 1 1.5 0v4.25H21a.75.75 0 0 1 0 1.5H3.75V12a.75.75 0 0 1-1.5 0V2Zm14.28 9.47a.75.75 0 1 0-1.06 1.06l3.72 3.72H3a.75.75 0 0 0 0 1.5h16.19l-3.72 3.72a.75.75 0 1 0 1.06 1.06L22.06 17l-5.53-5.53Z" clip-rule="evenodd"></path></svg>';
      },
      61682: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5.75H3.57895V4.25H2V5.75ZM5.68421 5.75H7.26316V4.25H5.68421V5.75ZM9.36842 5.75H10.9474V4.25H9.36842V5.75ZM13.0526 5.75H14.6316V4.25H13.0526V5.75ZM16.7368 5.75H18.3158V4.25H16.7368V5.75ZM20.4211 5.75H22V4.25H20.4211V5.75ZM19 12.75H22V11.25H19V12.75ZM2 19.75H22V18.25H2V19.75ZM17 12.75H13V11.25H17V12.75ZM7 12.75H11V11.25H7V12.75ZM5 12.75H2V11.25H5V12.75Z" fill="currentColor"></path></svg>';
      },
      22243: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M17.834 11.677a.75.75 0 0 1-1.06-1.06l2.12-2.122a2.25 2.25 0 0 0 0-3.182l-.706-.707a2.25 2.25 0 0 0-3.182 0l-4.243 4.242a2.25 2.25 0 0 0 0 3.182l.354.354a.75.75 0 0 1-1.061 1.06l-.354-.353a3.75 3.75 0 0 1 0-5.303l4.243-4.243a3.75 3.75 0 0 1 5.303 0l.707.707a3.75 3.75 0 0 1 0 5.304l-2.121 2.12Zm-11.667-.354a.75.75 0 0 1 1.06 1.061l-2.12 2.121a2.25 2.25 0 0 0 0 3.182l.706.707a2.25 2.25 0 0 0 3.182 0l4.243-4.242a2.25 2.25 0 0 0 0-3.182l-.354-.354a.75.75 0 0 1 1.061-1.06l.354.353a3.75 3.75 0 0 1 0 5.303l-4.243 4.243a3.75 3.75 0 0 1-5.303 0l-.707-.707a3.75 3.75 0 0 1 0-5.303l2.12-2.122Z" clip-rule="evenodd"></path></svg>';
      },
      50308: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.75 15.8c.45-.26.75-.74.75-1.3 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .56.3 1.04.75 1.3V18c0 .41.34.75.75.75s.75-.34.75-.75v-2.2ZM18 9h-1.25V6c0-2.62-2.13-4.75-4.75-4.75S7.25 3.38 7.25 6v3H6c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-8c0-1.66-1.34-3-3-3ZM8.75 6c0-1.79 1.46-3.25 3.25-3.25S15.25 4.21 15.25 6v3h-6.5V6ZM19.5 20c0 .83-.67 1.5-1.5 1.5H6c-.83 0-1.5-.67-1.5-1.5v-8c0-.83.67-1.5 1.5-1.5h12c.83 0 1.5.67 1.5 1.5v8Z"></path></svg>';
      },
      35231: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M.5 4H2V2h2V.5H2C1.17.5.5 1.17.5 2v2Zm23 0H22V2h-2V.5h2c.83 0 1.5.67 1.5 1.5v2Zm0 3H22v3.5h1.5V7Zm0 6.5H22V17h1.5v-3.5ZM.5 7H2v3.5H.5V7Zm0 6.5H2V17H.5v-3.5Zm0 6.5H2v2h2v1.5H2c-.83 0-1.5-.67-1.5-1.5v-2ZM7 23.5V22h3.5v1.5H7Zm6.5 0V22H17v1.5h-3.5ZM17 .5V2h-3.5V.5H17Zm-6.5 0V2H7V.5h3.5ZM12 8.75c.41 0 .75.34.75.75v1.75h1.75c.41 0 .75.34.75.75s-.34.75-.75.75h-1.75v1.75c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.75H9.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1.75V9.5c0-.41.34-.75.75-.75Zm10.53 12.72-4.72-4.72A7.482 7.482 0 0 0 19.5 12c0-4.14-3.36-7.5-7.5-7.5-4.14 0-7.5 3.36-7.5 7.5 0 4.14 3.36 7.5 7.5 7.5 1.8 0 3.45-.63 4.75-1.69l4.72 4.72c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06ZM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Z"></path></svg>';
      },
      45606: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M23 6H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1ZM1.5 16.5v-9h3.75V11a.75.75 0 0 0 1.5 0V7.5h1.5V13a.75.75 0 0 0 1.5 0V7.5h1.5V11a.75.75 0 0 0 1.5 0V7.5h1.5V13a.75.75 0 0 0 1.5 0V7.5h1.5V11a.75.75 0 0 0 1.5 0V7.5h3.75v9h-21Z" clip-rule="evenodd"></path></svg>';
      },
      64701: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M15.25 12.43c.33-.19.33-.67 0-.87l-4.5-2.6a.502.502 0 0 0-.75.43v5.2c0 .38.42.63.75.43l4.5-2.6v.01ZM21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm.5 14c0 .28-.22.5-.5.5H3c-.28 0-.5-.22-.5-.5V6c0-.28.22-.5.5-.5h18c.28 0 .5.22.5.5v12Z"></path></svg>';
      },
      10017: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 .45C5.62.45.45 5.62.45 12c0 6.38 5.17 11.55 11.55 11.55h6c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-6c-5.55 0-10.05-4.5-10.05-10.05C1.95 6.45 6.45 1.95 12 1.95h1.64a8.41 8.41 0 0 1 8.41 8.41v3.74c0 1.41-1.14 2.55-2.55 2.55s-2.55-1.14-2.55-2.55V6c0-.41-.34-.75-.75-.75s-.75.34-.75.75v1.43a5.25 5.25 0 0 0-9 3.67v1.8a5.25 5.25 0 0 0 9.48 3.11 4.057 4.057 0 0 0 3.57 2.14c2.24 0 4.05-1.81 4.05-4.05v-3.74c0-5.47-4.44-9.91-9.91-9.91H12Zm3.45 12.45v-1.8c0-2.07-1.68-3.75-3.75-3.75-2.07 0-3.75 1.68-3.75 3.75v1.8c0 2.07 1.68 3.75 3.75 3.75 2.07 0 3.75-1.68 3.75-3.75Z" clip-rule="evenodd"></path></svg>';
      },
      87394: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M17 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-6.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" clip-rule="evenodd"></path></svg>';
      },
      56034: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M21 6h-1.5V4.5H18V3h2c.55 0 1 .45 1 1v2ZM3 18h1.5v1.5H6V21H4c-.55 0-1-.45-1-1v-2ZM4.5 6H3V4c0-.55.45-1 1-1h2v1.5H4.5V6ZM21 18h-1.5v1.5H18V21h2c.55 0 1-.45 1-1v-2ZM8 4.5V3h3v1.5H8Zm0 15V21h3v-1.5H8ZM3 8h1.5v3H3V8Zm18 0h-1.5v3H21V8Zm-8-3.5V3h3v1.5h-3Zm0 15V21h3v-1.5h-3ZM3 13h1.5v3H3v-3Zm18 0h-1.5v3H21v-3Z"></path></svg>';
      },
      55079: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m21.28 20.218-18-18a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l6.47 6.47-6.18 6.18c-.33.32-.51.77-.51 1.23v4.34h4.34c.46 0 .91-.18 1.23-.51l6.18-6.18 6.47 6.47c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06Zm-14.77-.29s-.11.07-.17.07H3.5v-2.84c0-.06.03-.13.07-.17l6.18-6.18 2.94 2.94-6.18 6.18Zm13.86-15.62-1.18-1.18a2.746 2.746 0 0 0-3.88 0l-4.59 4.59 1.06 1.06 1.97-1.97 2.94 2.94-1.97 1.97 1.06 1.06 4.59-4.59a2.746 2.746 0 0 0 0-3.88Zm-1.06 2.82-1.56 1.56-2.94-2.94 1.56-1.56c.48-.48 1.28-.48 1.76 0l1.18 1.18c.48.48.48 1.28 0 1.76Z" clip-rule="evenodd"></path></svg>';
      },
      28772: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12.75 8c0-.41-.34-.75-.75-.75s-.75.34-.75.75v2.25H9c-.41 0-.75.34-.75.75s.34.75.75.75h2.25V14c0 .41.34.75.75.75s.75-.34.75-.75v-2.25H15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-2.25V8ZM19 3.25H5C3.48 3.25 2.25 4.48 2.25 6v10c0 1.52 1.23 2.75 2.75 2.75h3.47c.4 0 .78.19 1.02.52l1.16 1.63c.66.92 2.01.98 2.75.12l1.57-1.83c.24-.28.59-.44.95-.44H19c1.52 0 2.75-1.23 2.75-2.75V6c0-1.52-1.23-2.75-2.75-2.75ZM20.25 16c0 .69-.56 1.25-1.25 1.25h-3.08c-.8 0-1.57.35-2.09.96l-1.57 1.83c-.1.13-.3.12-.39 0l-1.16-1.63a2.762 2.762 0 0 0-2.24-1.15H5c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10Z"></path></svg>';
      },
      16302: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.25 9c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.41 0-.75-.34-.75-.75ZM8 12.25c-.41 0-.75.34-.75.75s.34.75.75.75h8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8Zm11-9H5C3.48 3.25 2.25 4.48 2.25 6v10c0 1.52 1.23 2.75 2.75 2.75h3.47c.4 0 .78.19 1.02.52l1.16 1.63c.66.92 2.01.98 2.75.12l1.57-1.83c.24-.28.59-.44.95-.44H19c1.52 0 2.75-1.23 2.75-2.75V6c0-1.52-1.23-2.75-2.75-2.75ZM20.25 16c0 .69-.56 1.25-1.25 1.25h-3.08c-.8 0-1.57.35-2.09.96l-1.57 1.83c-.1.13-.3.12-.39 0l-1.16-1.63a2.762 2.762 0 0 0-2.24-1.15H5c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10Z"></path></svg>';
      },
      11248: e => {
        e.exports = '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0)"><g filter="url(#filter0_dd)"><path d="M5.5 1A1.5 1.5 0 004 2.5v12A1.5 1.5 0 005.5 16H9l3 4 3-4h3.5a1.5 1.5 0 001.5-1.5v-12A1.5 1.5 0 0018.5 1h-13z" fill="#FEE668"></path></g><path d="M7 11.25a.25.25 0 01.25-.25h6.375a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25H7.25a.25.25 0 01-.25-.25v-.5zm0-2A.25.25 0 017.25 9h9.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25h-9.5A.25.25 0 017 9.75v-.5zm0-2A.25.25 0 017.25 7h9.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25h-9.5A.25.25 0 017 7.75v-.5zm0-2A.25.25 0 017.25 5h9.5a.25.25 0 01.25.25v.5a.25.25 0 01-.25.25h-9.5A.25.25 0 017 5.75v-.5z" fill="#000"></path></g><defs><clipPath id="clip0"><path fill="#fff" d="M0 0h24v24H0z"></path></clipPath><filter id="filter0_dd" x="0" y="-1" width="24" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.166759 0 0 0 0 0.195057 0 0 0 0 0.231441 0 0 0 0.33 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"></feBlend><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"></feColorMatrix><feOffset dy="2"></feOffset><feGaussianBlur stdDeviation="2"></feGaussianBlur><feColorMatrix values="0 0 0 0 0.168627 0 0 0 0 0.196078 0 0 0 0 0.231373 0 0 0 0.33 0"></feColorMatrix><feBlend in2="effect1_dropShadow" result="effect2_dropShadow"></feBlend><feBlend in="SourceGraphic" in2="effect2_dropShadow" result="shape"></feBlend></filter></defs></svg>';
      },
      9937: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M7.25 9c0-.41.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.41 0-.75-.34-.75-.75ZM8 12.25c-.41 0-.75.34-.75.75s.34.75.75.75h8c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H8Zm11-9H5C3.48 3.25 2.25 4.48 2.25 6v10c0 1.52 1.23 2.75 2.75 2.75h3.47c.4 0 .78.19 1.02.52l1.16 1.63c.66.92 2.01.98 2.75.12l1.57-1.83c.24-.28.59-.44.95-.44H19c1.52 0 2.75-1.23 2.75-2.75V6c0-1.52-1.23-2.75-2.75-2.75ZM20.25 16c0 .69-.56 1.25-1.25 1.25h-3.08c-.8 0-1.57.35-2.09.96l-1.57 1.83c-.1.13-.3.12-.39 0l-1.16-1.63a2.762 2.762 0 0 0-2.24-1.15H5c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h14c.69 0 1.25.56 1.25 1.25v10Z"></path></svg>';
      },
      91884: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M19 4.29a1 1 0 0 0-1.41 0l-8.1 8.14-2.95-3a1 1 0 0 0-1.42 0L2.29 12.3A1.05 1.05 0 0 0 2 13a1 1 0 0 0 .29.71l6.49 6.49a1.001 1.001 0 0 0 .71.3 1 1 0 0 0 .7-.3L21.86 8.54a1 1 0 0 0 0-1.42L19 4.29Z" clip-rule="evenodd"></path></svg>';
      },
      55108: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 14a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z" clip-rule="evenodd"></path></svg>';
      },
      56610: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22 5v10a2 2 0 0 1-2 2H8.35l-4.73 3.78A1 1 0 0 1 2 20V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2Z" clip-rule="evenodd"></path></svg>';
      },
      64767: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m22.04 6.04-5.88 5.87 5.88 5.88a.998.998 0 0 1 0 1.42l-2.83 2.83a.997.997 0 0 1-1.095.219.998.998 0 0 1-.325-.22l-5.88-5.88-5.87 5.88a.998.998 0 0 1-1.42 0l-2.83-2.83a.999.999 0 0 1 0-1.42l5.88-5.88-5.88-5.87a1 1 0 0 1-.29-.71 1 1 0 0 1 .29-.71l2.83-2.83a1 1 0 0 1 .71-.29c.265.005.518.108.71.29l5.87 5.88 5.88-5.88a1 1 0 0 1 1.42 0l2.83 2.83a.998.998 0 0 1 0 1.42Z" clip-rule="evenodd"></path></svg>';
      },
      63359: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M10 8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1 8 8 0 1 1 11.12 7.37l-.12.06v.07a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V15a5.82 5.82 0 0 1 3.78-5.16A2 2 0 1 0 10 8Zm2 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs></svg>';
      },
      81740: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.293 1.179a1 1 0 0 1 1.414 0l7.864 7.864a1 1 0 0 1 0 1.414l-2.475 2.475a1 1 0 0 1-1.414 0L14.75 11v1.5c0 1.458.53 2.472 1.592 3.227 1.068.758 2.872 1.381 5.658 1.502.551.024 1 .469 1 1.021v3.5a.974.974 0 0 1-1 .983c-3.542-.123-6.576-.913-8.842-2.522A9.817 9.817 0 0 1 12 19.25a9.817 9.817 0 0 1-1.158.96c-2.265 1.61-5.3 2.4-8.842 2.523-.552.02-1-.43-1-.983v-3.5c0-.552.449-.997 1-1.021 2.786-.12 4.59-.744 5.658-1.502 1.062-.755 1.592-1.77 1.592-3.227V11l-1.932 1.932a1 1 0 0 1-1.414 0L3.43 10.457a1 1 0 0 1 0-1.414l7.864-7.864Z" clip-rule="evenodd"></path></svg>';
      },
      89559: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M20.07 3.55a7 7 0 0 0-11.39 7.7.3.3 0 0 1 0 .12l-6.8 6.83a2 2 0 0 0-.53.93l-.29 1.17a2 2 0 0 0 2.16 2.47l1.06-.12A2 2 0 0 0 6 21.15l.47-1.89.26-.25 2.88-.26a2 2 0 0 0 1.71-1.36l.78-2.34.12-.12a.303.303 0 0 1 .12 0 7 7 0 0 0 7.7-11.39l.03.01ZM18 7.79a1.5 1.5 0 1 1-2.122-2.12A1.5 1.5 0 0 1 18 7.79Z" clip-rule="evenodd"></path></svg>';
      },
      50371: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><g clip-path="url(#a)"><path fill-rule="evenodd" d="M12 0a1 1 0 0 1 .87.5l8 14A1 1 0 0 1 20 16H4a1 1 0 0 1-.86-1.5l8-14A1 1 0 0 1 12 0ZM4.48 17.42a.77.77 0 0 0-.8-.1.75.75 0 0 0-.43.68v5a.76.76 0 0 0 .75.75.76.76 0 0 0 .75-.75v-3.4l4.77 4a.77.77 0 0 0 .8.1.75.75 0 0 0 .43-.7v-5a.75.75 0 1 0-1.5 0v3.4l-4.77-3.98Zm9.52-.17h4.5a2.25 2.25 0 1 1 0 4.5h-3.75V23a.75.75 0 1 1-1.5 0v-5a.76.76 0 0 1 .75-.75Zm.75 3v-1.5h3.75a.75.75 0 1 1 0 1.5h-3.75Z" clip-rule="evenodd"></path></g><defs><clipPath id="a"><path d="M0 0h24v24H0z"></path></clipPath></defs></svg>';
      },
      58728: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M21.94 13.06 15 20v-7h7l-.06.06ZM22 11h-7a2 2 0 0 0-2 2v7H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5Z" clip-rule="evenodd"></path></svg>';
      },
      44542: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8 16h1v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V21a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V6.5a.5.5 0 0 1 .5-.5H22a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8a7 7 0 0 0 0 14Z" clip-rule="evenodd"></path></svg>';
      },
      98671: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M14.71 2.296a1 1 0 0 0-1.42 0l-2.83 2.83a1 1 0 0 0-.29.71c.004.265.107.518.29.71l2.3 2.29H2a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h10.76l-2.3 2.29a1.002 1.002 0 0 0 0 1.42l2.83 2.82a1.002 1.002 0 0 0 1.42 0l8.83-8.82a1.05 1.05 0 0 0 .29-.71 1 1 0 0 0-.29-.71l-8.83-8.83Z" clip-rule="evenodd"></path></svg>';
      },
      44741: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M20.858 10.159 4.985 2.226a2.06 2.06 0 0 0-2.738 2.799L5.943 12l-3.696 6.965a2.057 2.057 0 0 0 2.738 2.809l15.873-7.932a2.059 2.059 0 0 0 0-3.684Z" clip-rule="evenodd"></path></svg>';
      },
      99471: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m21.73 10.2-4.63 3.36L18.87 19a1.5 1.5 0 0 1-2.31 1.68l-4.63-3.37-4.64 3.38A1.5 1.5 0 0 1 4.99 19l1.77-5.45-4.64-3.35A1.5 1.5 0 0 1 3 7.48h5.73L10.5 2a1.5 1.5 0 0 1 2.85 0l1.77 5.44h5.73a1.5 1.5 0 0 1 .88 2.76Z" clip-rule="evenodd"></path></svg>';
      },
      24808: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 8.75C8.41421 8.75 8.75 9.08579 8.75 9.5V11.5C8.75 11.9142 8.41421 12.25 8 12.25C7.58579 12.25 7.25 11.9142 7.25 11.5V9.5C7.25 9.08579 7.58579 8.75 8 8.75Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M4.75 5.75V4C4.75 2.20507 6.20507 0.75 8 0.75C9.79493 0.75 11.25 2.20507 11.25 4V5.75H12C12.9665 5.75 13.75 6.5335 13.75 7.5V13.5C13.75 14.4665 12.9665 15.25 12 15.25H4C3.0335 15.25 2.25 14.4665 2.25 13.5V7.5C2.25 6.5335 3.0335 5.75 4 5.75H4.75ZM6.25 4C6.25 3.0335 7.0335 2.25 8 2.25C8.9665 2.25 9.75 3.0335 9.75 4V5.75H6.25V4ZM12 7.25C12.1381 7.25 12.25 7.36193 12.25 7.5V13.5C12.25 13.6381 12.1381 13.75 12 13.75H4C3.86193 13.75 3.75 13.6381 3.75 13.5V7.5C3.75 7.36193 3.86193 7.25 4 7.25H12Z" fill="currentColor"></path></svg>';
      },
      83569: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 8.75C7.91421 8.75 8.25 9.08579 8.25 9.5V11.5C8.25 11.9142 7.91421 12.25 7.5 12.25C7.08579 12.25 6.75 11.9142 6.75 11.5V9.5C6.75 9.08579 7.08579 8.75 7.5 8.75Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M10.75 4C10.75 3.0335 11.5335 2.25 12.5 2.25C13.4665 2.25 14.25 3.0335 14.25 4V5C14.25 5.41421 14.5858 5.75 15 5.75C15.4142 5.75 15.75 5.41421 15.75 5V4C15.75 2.20507 14.2949 0.75 12.5 0.75C10.7051 0.75 9.25 2.20507 9.25 4V5.75H3.5C2.5335 5.75 1.75 6.5335 1.75 7.5V13.5C1.75 14.4665 2.5335 15.25 3.5 15.25H11.5C12.4665 15.25 13.25 14.4665 13.25 13.5V7.5C13.25 6.5335 12.4665 5.75 11.5 5.75H10.75V4ZM3.5 7.25C3.36193 7.25 3.25 7.36193 3.25 7.5V13.5C3.25 13.6381 3.36193 13.75 3.5 13.75H11.5C11.6381 13.75 11.75 13.6381 11.75 13.5V7.5C11.75 7.36193 11.6381 7.25 11.5 7.25H3.5Z" fill="currentColor"></path></svg>';
      },
      22636: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M1.5 12c0 5.799 4.701 10.5 10.5 10.5S22.5 17.799 22.5 12 17.799 1.5 12 1.5 1.5 6.201 1.5 12ZM3 12a9 9 0 0 1 9-9h.005v18h.019H12a9 9 0 0 1-9-9Zm10.505 8.875a8.932 8.932 0 0 0 1.49-.385V3.51a8.937 8.937 0 0 0-1.49-.385v17.75ZM16.495 4.2v15.598a9.031 9.031 0 0 0 1.5-1.086V5.287a9.028 9.028 0 0 0-1.5-1.086Zm3 2.814v9.97A8.958 8.958 0 0 0 21 12a8.958 8.958 0 0 0-1.505-4.985Z" clip-rule="evenodd"></path></svg>';
      },
      29489: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9.75 3.5a2.25 2.25 0 0 1 4.256-1.02A2.25 2.25 0 0 1 17.25 4.5v.878a2.25 2.25 0 0 1 3 2.122V16a6.75 6.75 0 0 1-6.75 6.75h-1.115a6.75 6.75 0 0 1-4.634-1.843l-5.92-5.59a2.55 2.55 0 0 1 3.43-3.773l1.489 1.303V6a2.25 2.25 0 0 1 3-2.122V3.5Zm1.5 7.5a.75.75 0 0 1-1.5 0V6a.75.75 0 0 0-1.5 0v7.735c0 .942-1.11 1.446-1.82.825l-2.157-1.887a1.05 1.05 0 0 0-1.412 1.553l5.92 5.59a5.25 5.25 0 0 0 3.604 1.434H13.5c2.9 0 5.25-2.35 5.25-5.25V7.5a.75.75 0 0 0-1.5 0V11a.75.75 0 0 1-1.5 0V4.5a.75.75 0 0 0-1.5 0V11a.75.75 0 0 1-1.5 0V3.5a.75.75 0 0 0-1.5 0V11Z" clip-rule="evenodd"></path></svg>';
      },
      60231: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M4.735 1.693A1.5 1.5 0 0 0 2.5 3v5.5H.75a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5H4V3l16 9-16 9v-6.33l1.002.89a.75.75 0 0 0 .996-1.12L3.25 11.995.502 14.44a.75.75 0 0 0 .996 1.122l1.002-.89V21a1.5 1.5 0 0 0 2.235 1.307l16-9a1.5 1.5 0 0 0 0-2.614l-16-9Z"></path></svg>';
      },
      45632: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12 4.25a.75.75 0 0 1 .75.75v6.25H19a.75.75 0 0 1 0 1.5h-6.25V19a.75.75 0 0 1-1.5 0v-6.25H5a.75.75 0 0 1 0-1.5h6.25V5a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd"></path></svg>';
      },
      91291: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4.735 1.693A1.5 1.5 0 0 0 2.5 3v18a1.5 1.5 0 0 0 2.235 1.307l16-9a1.5 1.5 0 0 0 0-2.614l-16-9ZM20 12 4 21v-3.34l12.861-7.426L20 12Zm-4.152-2.335L4 16.505v-3.464l8.81-5.086 3.038 1.71Zm-4.052-2.28L4 11.887V8.423l4.757-2.747 3.04 1.71ZM4 7.268l3.744-2.162L4 3v4.268Z" clip-rule="evenodd"></path></svg>';
      },
      72780: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.243 1.705a1.5 1.5 0 0 1 1.492-.012l16 9a1.5 1.5 0 0 1 0 2.614l-16 9A1.5 1.5 0 0 1 2.5 21V3a1.5 1.5 0 0 1 .743-1.295ZM4 21l16-9L4 3v18Z" clip-rule="evenodd"></path></svg>';
      },
      82748: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22.427 3.384a.75.75 0 0 1 .19 1.043l-7.62 11a.75.75 0 0 1-1.16.09l-4.126-4.333-7.094 10.243a.75.75 0 1 1-1.233-.854l7.619-11a.75.75 0 0 1 1.16-.09l4.126 4.333 7.095-10.243a.75.75 0 0 1 1.043-.19Z" clip-rule="evenodd"></path></svg>';
      },
      45989: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M12.75 1a.75.75 0 0 0-1.5 0v.777a10.252 10.252 0 0 0-9.473 9.473H1a.75.75 0 0 0 0 1.5h.777a10.252 10.252 0 0 0 9.473 9.473V23a.75.75 0 0 0 1.5 0v-.777a10.252 10.252 0 0 0 9.473-9.473H23a.75.75 0 0 0 0-1.5h-.777a10.252 10.252 0 0 0-9.473-9.473V1Zm-1.5 2.282V4a.75.75 0 0 0 1.5 0v-.718a8.752 8.752 0 0 1 7.968 7.968H20a.75.75 0 0 0 0 1.5h.718a8.752 8.752 0 0 1-7.968 7.968V20a.75.75 0 0 0-1.5 0v.718a8.752 8.752 0 0 1-7.968-7.968H4a.75.75 0 0 0 0-1.5h-.718a8.752 8.752 0 0 1 7.968-7.968ZM12 8.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd"></path></svg>';
      },
      738: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M17.5 9c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1ZM10 15.25c-.41 0-.75.34-.75.75s.34.75.75.75h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4Zm0 3c-.41 0-.75.34-.75.75s.34.75.75.75h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4Zm11-13h-2.25V3.5c0-.97-.78-1.75-1.75-1.75H7c-.97 0-1.75.78-1.75 1.75v1.75H3C1.48 5.25.25 6.48.25 8v8c0 1.52 1.23 2.75 2.75 2.75h2.25V22c0 .97.78 1.75 1.75 1.75h10c.97 0 1.75-.78 1.75-1.75v-3.25H21c1.52 0 2.75-1.23 2.75-2.75V8c0-1.52-1.23-2.75-2.75-2.75ZM6.75 3.5c0-.14.11-.25.25-.25h10c.14 0 .25.11.25.25v1.75H6.75V3.5ZM17.25 22c0 .14-.11.25-.25.25H7c-.14 0-.25-.11-.25-.25v-9c0-.14.11-.25.25-.25h10c.14 0 .25.11.25.25v9Zm5-6c0 .69-.56 1.25-1.25 1.25h-2.25V13c0-.97-.78-1.75-1.75-1.75H7c-.97 0-1.75.78-1.75 1.75v4.25H3c-.69 0-1.25-.56-1.25-1.25V8c0-.69.56-1.25 1.25-1.25h18c.69 0 1.25.56 1.25 1.25v8Z"></path></svg>';
      },
      96816: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4Zm1.5 3.554V4.5h5.553L4.5 7.554Zm0 1.141v2.86L17.326 4.5h-5.198L4.5 8.695ZM19.4 4.5 4.5 12.695v2.86l15-8.25V4.5h-.1Zm.1 3.945-15 8.25V19.5h.099L19.5 11.304V8.445Zm0 4L6.674 19.5h5.197l7.629-4.196v-2.858Zm0 4L13.946 19.5H19.5v-3.055Z" clip-rule="evenodd"></path></svg>';
      },
      7799: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4.5 4.5v15h15v-15h-15ZM4 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H4Z" clip-rule="evenodd"></path></svg>';
      },
      42741: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10.75 1.25h-9.5v9.5h9.5v-9.5Zm-8 8v-6.5h6.5v6.5h-6.5Zm18.352-5.78a.75.75 0 0 1 0 1.06l-8.486 8.486a1.75 1.75 0 0 0 2.468 2.482l4.957-4.957a.75.75 0 0 1 1.06 1.06l-7.778 7.779a.75.75 0 0 1-.324.19L3.1 22.4a.75.75 0 0 1-.736-1.252L20.041 3.47a.75.75 0 0 1 1.06 0ZM5.47 20.16l5.209-5.209c.128.586.42 1.144.876 1.6a3.235 3.235 0 0 0 1.598.875l-.754.755-6.93 1.98Z" clip-rule="evenodd"></path></svg>';
      },
      11088: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10.75 1.25h-9.5V4a.75.75 0 0 0 1.5 0V2.75h2.5v6.5H4.5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-.75v-6.5h2.5V4a.75.75 0 0 0 1.5 0V1.25Zm10.352 2.22a.75.75 0 0 1 0 1.06l-8.486 8.486a1.75 1.75 0 0 0 2.468 2.482l4.957-4.957a.75.75 0 0 1 1.06 1.06l-4.95 4.95-.01.01-2.818 2.819a.75.75 0 0 1-.324.19L3.1 22.4a.75.75 0 0 1-.736-1.252L20.041 3.47a.75.75 0 0 1 1.06 0ZM5.47 20.16l5.209-5.209c.128.586.42 1.144.876 1.6a3.235 3.235 0 0 0 1.598.875l-.754.755-6.93 1.98Z" clip-rule="evenodd"></path></svg>';
      },
      97248: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V4ZM1 14a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-6Zm11.496-9.74h-1.222L9.01 10h1.205l.46-1.263h2.418L13.545 10h1.206l-2.255-5.74Zm-.615 1.132.852 2.337h-1.697l.845-2.337Zm6.845-1.132h-1.222L15.241 10h1.205l.46-1.263h2.418L19.775 10h1.206l-2.255-5.74Zm-.615 1.132.853 2.337h-1.698l.845-2.337Zm-.492 8.868h1.222L21.096 20H19.89l-.45-1.263h-2.42L16.561 20h-1.205l2.263-5.74Zm1.46 3.469-.853-2.337-.845 2.337h1.697ZM12.61 14.26h-1.222L9.126 20h1.205l.46-1.263h2.418L13.66 20h1.206l-2.255-5.74Zm-.615 1.132.852 2.337H11.15l.845-2.337ZM5.159 14.26H6.38L8.636 20H7.43l-.45-1.263H4.56L4.1 20H2.897l2.263-5.74Zm1.46 3.469-.853-2.337-.845 2.337h1.697Z" clip-rule="evenodd"></path></svg>';
      },
      80953: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8 3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H8Zm10.726 1.26h-1.222L15.241 10h1.205l.46-1.263h2.418L19.775 10h1.206l-2.255-5.74Zm-.615 1.132.853 2.337h-1.698l.845-2.337ZM11.274 4.26h1.222L14.75 10h-1.206l-.45-1.263h-2.42L10.216 10H9.011l2.263-5.74Zm1.46 3.469-.853-2.337-.845 2.337h1.697ZM2 13a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H2Z" clip-rule="evenodd"></path></svg>';
      },
      20377: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M3.528 1.468a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l1.97 1.97-1.97 1.97c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0l1.97-1.97 1.97 1.97c.29.29.77.29 1.06 0 .29-.29.29-.77 0-1.06l-1.97-1.97 1.97-1.97c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.97 1.97-1.97-1.97Zm16.51 9.07-4.96 4.96c-.68.67-1.78.67-2.46-.01-.69-.68-.69-1.79 0-2.47l8.48-8.49c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-17.68 17.68a.74.74 0 0 0-.11.91c.17.29.52.43.85.34l9.9-2.83c.12-.03.23-.1.32-.19l7.78-7.78c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0Zm-7.64 7.64-6.93 1.98 5.21-5.21c.13.59.42 1.15.88 1.6.45.46 1.01.75 1.59.88l-.75.75Z"></path></svg>';
      },
      90194: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M15.47 3.47a.75.75 0 0 0 0 1.06l2.72 2.72H10a6.75 6.75 0 0 0 0 13.5h2a.75.75 0 0 0 0-1.5h-2a5.25 5.25 0 1 1 0-10.5h8.19l-2.72 2.72a.75.75 0 1 0 1.06 1.06L21.06 8l-4.53-4.53a.75.75 0 0 0-1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      50331: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M8.00002 14.3333C11.4978 14.3333 14.3334 11.4978 14.3334 7.99996C14.3334 4.50216 11.4978 1.66663 8.00002 1.66663C4.50222 1.66663 1.66669 4.50216 1.66669 7.99996C1.66669 11.4978 4.50222 14.3333 8.00002 14.3333Z" fill="#D63960"></path><path d="M5.88 5.88L10.12 10.12M10.12 5.88L5.88 10.12" stroke="#D63960" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round"></path></svg>';
      },
      72938: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11.006 2.564a.75.75 0 0 1 .988-1.128l4 3.5a.75.75 0 0 1 0 1.128l-4 3.5a.75.75 0 0 1-.988-1.128l2.558-2.239a6.25 6.25 0 1 0 4.686 6.053.75.75 0 0 1 1.5 0 7.75 7.75 0 1 1-6.397-7.632l-2.347-2.054Z"></path></svg>';
      },
      45983: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M7.25 1c0-.41.34-.75.75-.75h15c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75h-7.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6.75V1.75H8.75V9c0 .41-.34.75-.75.75s-.75-.34-.75-.75V1Zm-7 12c0-.41.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H1.75v8.5h8.5V18c0-.41.34-.75.75-.75s.75.34.75.75v5c0 .41-.34.75-.75.75H1c-.41 0-.75-.34-.75-.75V13ZM12.5 4.75c-.41 0-.75.34-.75.75s.34.75.75.75h4.19L4.47 18.47c-.29.29-.29.77 0 1.06.29.29.77.29 1.06 0L17.75 7.31v4.19c0 .41.34.75.75.75s.75-.34.75-.75V4.75H12.5Z" clip-rule="evenodd"></path></svg>';
      },
      98589: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.75 10.5a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0Zm6.75-8.25a8.25 8.25 0 1 0 5.28 14.59l4.69 4.69a.75.75 0 0 0 1.06-1.06l-4.69-4.69A8.25 8.25 0 0 0 10.5 2.25Z" clip-rule="evenodd"></path></svg>';
      },
      62949: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="m20.12 5.063-.68-.68a2.746 2.746 0 0 0-3.88 0l-12.8 12.8c-.33.32-.51.77-.51 1.23v3.34h4.34c.46 0 .91-.18 1.23-.51l12.3-12.3a2.746 2.746 0 0 0 0-3.88ZM6.76 20.183s-.11.07-.17.07H3.75v-1.84c0-.06.03-.13.07-.17L14 8.063l2.44 2.44-9.68 9.68Zm12.3-12.3-1.56 1.56-2.44-2.44 1.56-1.56c.48-.48 1.28-.48 1.76 0l.68.68c.48.48.48 1.28 0 1.76ZM23 21.753H9.43l1.5-1.5H23c.41 0 .75.34.75.75s-.34.75-.75.75Z" clip-rule="evenodd"></path></svg>';
      },
      59620: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M9 2.75c-.69 0-1.25.56-1.25 1.25v16.112l3.704-3.927a.75.75 0 0 1 1.091 0l3.705 3.927V4c0-.69-.56-1.25-1.25-1.25H9ZM6.25 4A2.75 2.75 0 0 1 9 1.25h6A2.75 2.75 0 0 1 17.75 4v18a.75.75 0 0 1-1.296.515L12 17.793l-4.454 4.722A.75.75 0 0 1 6.25 22V4Z" clip-rule="evenodd"></path></svg>';
      },
      47082: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M4.5 6.5C5.33 6.5 6 5.83 6 5s-.67-1.5-1.5-1.5S3 4.17 3 5s.67 1.5 1.5 1.5Zm5-2.25c-.41 0-.75.34-.75.75s.34.75.75.75h11c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11Zm0 7c-.41 0-.75.34-.75.75s.34.75.75.75h11c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-11ZM8.75 19c0-.41.34-.75.75-.75h11c.41 0 .75.34.75.75s-.34.75-.75.75h-11c-.41 0-.75-.34-.75-.75ZM6 12c0 .83-.67 1.5-1.5 1.5S3 12.83 3 12s.67-1.5 1.5-1.5S6 11.17 6 12Zm-1.5 8.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S3 18.17 3 19s.67 1.5 1.5 1.5Z"></path></svg>';
      },
      80163: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.2478 3.29211C12.0874 3.23596 11.9126 3.23596 11.7522 3.29211L1.75224 6.79211C1.45142 6.89739 1.25 7.18129 1.25 7.5C1.25 7.81871 1.45142 8.10261 1.75224 8.20789L6.87365 10.0004L1.75224 11.7929C1.45144 11.8982 1.25002 12.182 1.25 12.5007C1.24998 12.8194 1.45136 13.1033 1.75215 13.2086L6.86938 15.0004L1.75215 16.7921C1.45136 16.8975 1.24998 17.1814 1.25 17.5C1.25002 17.8187 1.45144 18.1026 1.75224 18.2079L11.7522 21.7079C11.9126 21.764 12.0874 21.764 12.2478 21.7079L22.2478 18.2079C22.5486 18.1026 22.75 17.8187 22.75 17.5C22.75 17.1814 22.5486 16.8975 22.2479 16.7921L17.1296 15L22.2479 13.2086C22.5486 13.1033 22.75 12.8194 22.75 12.5007C22.75 12.182 22.5486 11.8982 22.2478 11.7929L17.1263 10.0004L22.2478 8.20789C22.5486 8.10261 22.75 7.81871 22.75 7.5C22.75 7.18129 22.5486 6.89739 22.2478 6.79211L12.2478 3.29211ZM14.856 10.795L12.2478 11.7079C12.0874 11.764 11.9126 11.764 11.7522 11.7079L9.14397 10.795L4.26991 12.5009L9.35626 14.2819C9.36674 14.285 9.37717 14.2884 9.38754 14.292L12 15.2055L19.7301 12.5009L14.856 10.795ZM12 10.2054L4.27032 7.5L12 4.79461L19.7297 7.5L12 10.2054ZM11.7525 16.7088L9.13906 15.795L4.26991 17.4999L12 20.2054L19.7301 17.4999L14.8598 15.7946L12.2475 16.7088C12.0873 16.7648 11.9127 16.7648 11.7525 16.7088Z" fill="currentColor"></path></svg>';
      },
      12778: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22.5 15.75h-8.64c.31-1.16.59-2.39.81-3.62.22-1.24.39-2.48.49-3.66.64-.38 1.29-.72 1.95-1 .04.21.08.45.13.72.02.16.05.33.08.5.1.54.22 1.13.38 1.63.09.25.19.51.33.74.13.21.34.46.63.61.32.16.69.08.92-.19.87-1.05 2.74-3.88 3.16-6.87a.747.747 0 0 0-.63-.85.747.747 0 0 0-.85.63c-.29 2.02-1.36 4.02-2.19 5.26-.11-.35-.19-.77-.27-1.22-.02-.14-.05-.29-.07-.44-.07-.37-.13-.73-.19-1.02-.05-.2-.11-.42-.19-.61a1.25 1.25 0 0 0-.22-.33.85.85 0 0 0-.63-.28c-.09 0-.18.02-.26.05-.67.25-1.33.55-1.98.89.01-.57 0-1.11-.03-1.61-.06-.97-.21-1.86-.51-2.52-.29-.67-.83-1.31-1.72-1.31-.65 0-1.56.27-2.5.63-.98.37-2.1.88-3.22 1.45-2.22 1.14-4.53 2.54-5.77 3.6-.31.27-.35.74-.08 1.06.27.31.74.35 1.06.08 1.1-.94 3.28-2.28 5.48-3.4 1.08-.56 2.15-1.04 3.06-1.39.95-.36 1.62-.53 1.97-.53.03 0 .17 0 .35.41.19.43.33 1.11.38 2.01.05.72.04 1.54-.01 2.42-.85.54-1.65 1.14-2.39 1.78-1.74 1.48-3.19 3.18-4 4.79-.2.41-.33.98-.4 1.59H2c-.41 0-.75.34-.75.75s.34.75.75.75h4.86c.01.54.05 1.11.12 1.66.11.88.32 1.77.67 2.46.33.67.91 1.38 1.85 1.38.8 0 1.43-.56 1.9-1.15.48-.62.93-1.47 1.33-2.44.24-.58.47-1.23.69-1.91h9.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm-11.16 2.84c-.37.91-.76 1.62-1.13 2.09-.39.5-.63.57-.71.57-.06 0-.26-.04-.51-.55-.24-.48-.42-1.18-.53-1.99-.06-.48-.09-.98-.1-1.46h3.48c-.16.47-.33.92-.5 1.34Zm1.85-6.72c-.24 1.33-.54 2.66-.88 3.88H8.45c.06-.44.14-.75.22-.91.69-1.39 1.99-2.94 3.63-4.33.4-.34.81-.67 1.24-.98-.09.76-.21 1.55-.35 2.34ZM1.97 9.97c.29-.29.77-.29 1.06 0l.97.97.97-.97c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.97.97.97.97c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L4 13.06l-.97.97c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l.97-.97-.97-.97a.754.754 0 0 1 0-1.06Z" clip-rule="evenodd"></path></svg>';
      },
      9643: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M10 4.25H5c-.41 0-.75.34-.75.75v5c0 .41.34.75.75.75h5c.41 0 .75-.34.75-.75V5c0-.41-.34-.75-.75-.75Zm-.75 5h-3.5v-3.5h3.5v3.5Zm.75 4H5c-.41 0-.75.34-.75.75v5c0 .41.34.75.75.75h5c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75Zm-.75 5h-3.5v-3.5h3.5v3.5Zm9.75-5h-5c-.41 0-.75.34-.75.75v5c0 .41.34.75.75.75h5c.41 0 .75-.34.75-.75v-5c0-.41-.34-.75-.75-.75Zm-.75 5h-3.5v-3.5h3.5v3.5Zm.75-14h-5c-.41 0-.75.34-.75.75v5c0 .41.34.75.75.75h5c.41 0 .75-.34.75-.75V5c0-.41-.34-.75-.75-.75Zm-.75 5h-3.5v-3.5h3.5v3.5Z" clip-rule="evenodd"></path></svg>';
      },
      25899: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.50011C5.33333 6.50011 12 2.99989 14 3C17.6401 3.0002 14 22.9999 10.5 22.9999C8.5 22.9999 8.25462 16.9906 9 15.4999C10.5 12.5 14.5 8.9999 18.5 7.4999C19 7.5 19 11.5 20 11.9999C20.8333 10.9999 22.6 8.29989 23 5.49989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.5 14.5L5 13M6.5 11.5L5 13M5 13L3.5 11.5M5 13L6.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 17.5H23.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><g clip-path="url(#clip0_9189_304632)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 32C27.5228 32 32 27.5228 32 22C32 16.4772 27.5228 12 22 12C16.4772 12 12 16.4772 12 22C12 27.5228 16.4772 32 22 32ZM25.5303 19.5303C25.8232 19.2374 25.8232 18.7626 25.5303 18.4697C25.2374 18.1768 24.7626 18.1768 24.4697 18.4697L18.4697 24.4697C18.1768 24.7626 18.1768 25.2374 18.4697 25.5303C18.7626 25.8232 19.2374 25.8232 19.5303 25.5303L25.5303 19.5303Z" fill="currentColor"></path></g><defs><clipPath id="clip0_9189_304632"><rect width="20" height="20" fill="white" transform="translate(12 12)"></rect></clipPath></defs></svg>';
      },
      24089: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.50011C5.33333 6.50011 12 2.99989 14 3C17.6401 3.0002 14 22.9999 10.5 22.9999C8.5 22.9999 8.25462 16.9906 9 15.4999C10.5 12.5 14.5 8.9999 18.5 7.4999C19 7.5 19 11.5 20 11.9999C20.8333 10.9999 22.6 8.29989 23 5.49989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.5 14.5L5 13M6.5 11.5L5 13M5 13L3.5 11.5M5 13L6.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 17.5H23.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><g clip-path="url(#clip0_9187_304481)"><path fill-rule="evenodd" clip-rule="evenodd" d="M22 32C27.5228 32 32 27.5228 32 22C32 16.4772 27.5228 12 22 12C16.4772 12 12 16.4772 12 22C12 27.5228 16.4772 32 22 32ZM26.5301 20.0302C26.823 19.7373 26.823 19.2624 26.5301 18.9695C26.2372 18.6766 25.7623 18.6766 25.4694 18.9695L20.9997 23.4392L19.0302 21.4699C18.7373 21.177 18.2624 21.177 17.9695 21.4699C17.6766 21.7628 17.6767 22.2377 17.9696 22.5306L20.9998 25.5605L26.5301 20.0302Z" fill="currentColor"></path></g><defs><clipPath id="clip0_9187_304481"><rect width="20" height="20" fill="white" transform="translate(12 12)"></rect></clipPath></defs></svg>';
      },
      47630: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.50011C5.33333 6.50011 12 2.99989 14 3C17.6401 3.0002 14 22.9999 10.5 22.9999C8.5 22.9999 8.25462 16.9906 9 15.4999C10.5 12.5 14.5 8.9999 18.5 7.4999C19 7.5 19 11.5 20 11.9999C20.8333 10.9999 22.6 8.29989 23 5.49989" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3.5 14.5L5 13M6.5 11.5L5 13M5 13L3.5 11.5M5 13L6.5 14.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M3 17.5H23.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><g><path fill-rule="evenodd" clip-rule="evenodd" d="M31.5289 26.9662L24.0011 14.4193L23.0694 14.9783L24.0011 14.4193C23.0949 12.9088 20.9058 12.9087 19.9995 14.4192L12.4709 26.9661C11.5377 28.5213 12.658 30.5 14.4717 30.5H29.528C31.3417 30.5 32.462 28.5214 31.5289 26.9662ZM22 18.25C22.4142 18.25 22.75 18.5858 22.75 19V23C22.75 23.4142 22.4142 23.75 22 23.75C21.5858 23.75 21.25 23.4142 21.25 23V19C21.25 18.5858 21.5858 18.25 22 18.25ZM22 27.5C22.6904 27.5 23.25 26.9404 23.25 26.25C23.25 25.5596 22.6904 25 22 25C21.3096 25 20.75 25.5596 20.75 26.25C20.75 26.9404 21.3096 27.5 22 27.5Z" fill="currentColor"></path></g></svg>';
      },
      65936: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M22.5 15.75h-8.64c.31-1.16.59-2.39.81-3.62.22-1.24.39-2.48.49-3.66.64-.38 1.29-.72 1.95-1 .04.21.08.45.13.72.02.16.05.33.08.5.1.54.22 1.13.38 1.63.09.25.19.51.33.74.13.21.34.46.63.61.32.16.69.08.92-.19.87-1.05 2.74-3.88 3.16-6.87a.747.747 0 0 0-.63-.85.747.747 0 0 0-.85.63c-.29 2.02-1.36 4.02-2.19 5.26-.11-.35-.19-.77-.27-1.22-.02-.14-.05-.29-.07-.44-.07-.37-.13-.73-.19-1.02-.05-.2-.11-.42-.19-.61a1.25 1.25 0 0 0-.22-.33.85.85 0 0 0-.63-.28c-.09 0-.18.02-.26.05-.67.25-1.33.55-1.98.89.01-.57 0-1.11-.03-1.61-.06-.97-.21-1.86-.51-2.52-.29-.67-.83-1.31-1.72-1.31-.65 0-1.56.27-2.5.63-.98.37-2.1.88-3.22 1.45-2.22 1.14-4.53 2.54-5.77 3.6-.31.27-.35.74-.08 1.06.27.31.74.35 1.06.08 1.1-.94 3.28-2.28 5.48-3.4 1.08-.56 2.15-1.04 3.06-1.39.95-.36 1.62-.53 1.97-.53.03 0 .17 0 .35.41.19.43.33 1.11.38 2.01.05.72.04 1.54-.01 2.42-.85.54-1.65 1.14-2.39 1.78-1.74 1.48-3.19 3.18-4 4.79-.2.41-.33.98-.4 1.59H2c-.41 0-.75.34-.75.75s.34.75.75.75h4.86c.01.54.05 1.11.12 1.66.11.88.32 1.77.67 2.46.33.67.91 1.38 1.85 1.38.8 0 1.43-.56 1.9-1.15.48-.62.93-1.47 1.33-2.44.24-.58.47-1.23.69-1.91h9.08c.41 0 .75-.34.75-.75s-.34-.75-.75-.75Zm-11.16 2.84c-.37.91-.76 1.62-1.13 2.09-.39.5-.63.57-.71.57-.06 0-.26-.04-.51-.55-.24-.48-.42-1.18-.53-1.99-.06-.48-.09-.98-.1-1.46h3.48c-.16.47-.33.92-.5 1.34Zm1.85-6.72c-.24 1.33-.54 2.66-.88 3.88H8.45c.06-.44.14-.75.22-.91.69-1.39 1.99-2.94 3.63-4.33.4-.34.81-.67 1.24-.98-.09.76-.21 1.55-.35 2.34ZM1.97 9.97c.29-.29.77-.29 1.06 0l.97.97.97-.97c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-.97.97.97.97c.29.29.29.77 0 1.06-.29.29-.77.29-1.06 0L4 13.06l-.97.97c-.29.29-.77.29-1.06 0a.754.754 0 0 1 0-1.06l.97-.97-.97-.97a.754.754 0 0 1 0-1.06Z" clip-rule="evenodd"></path></svg>';
      },
      23717: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="-6 -6 37 37" fill="currentColor"><path fill-rule="evenodd" d="M5 .25A1.75 1.75 0 0 0 3.25 2v20c0 .966.784 1.75 1.75 1.75h14A1.75 1.75 0 0 0 20.75 22V6.5a.75.75 0 0 0-.22-.53l-5.5-5.5a.75.75 0 0 0-.53-.22H5ZM4.75 2A.25.25 0 0 1 5 1.75h8.75V6.5c0 .414.336.75.75.75h4.75V22a.25.25 0 0 1-.25.25H5a.25.25 0 0 1-.25-.25V2Z" clip-rule="evenodd"></path></svg>';
      },
      10737: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.993 6.25c-.41 0-.75.34-.75.75s.34.75.75.75h4.25V18c0 .41.34.75.75.75s.75-.34.75-.75V7.75h4.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-10Zm1.09 15.22c.46-.61 1.37-.61 1.81-.02 1.05 1.4 3.15 1.4 4.2 0 .44-.59 1.35-.59 1.81.02 1.03 1.38 3.12 1.45 4.21.08l.46-.58c.26-.32.21-.8-.12-1.05a.738.738 0 0 0-1.05.12l-.46.58c-.46.58-1.38.57-1.84-.04-1.04-1.39-3.16-1.43-4.21-.02-.45.6-1.35.6-1.8 0-1.06-1.41-3.17-1.37-4.21.02-.46.61-1.37.63-1.84.04l-.46-.58a.748.748 0 0 0-1.17.93l.46.58c1.09 1.36 3.18 1.3 4.21-.08Z"></path></svg>';
      },
      54897: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.75 15H14.5V9.62c1.21-.86 2-2.27 2-3.87C16.5 3.13 14.37 1 11.75 1S7 3.13 7 5.75c0 1.6.79 3.01 2 3.87V15H4.77c-1.5 0-2.73 1.2-2.75 2.7L2 18.74a.748.748 0 0 0 .75.76h18c.41 0 .75-.34.75-.75v-1c0-1.52-1.23-2.75-2.75-2.75ZM20 18H3.51v-.27c.02-.68.57-1.23 1.26-1.23h4.98c.41 0 .75-.34.75-.75V9.21c0-.27-.14-.52-.38-.65A3.24 3.24 0 0 1 8.5 5.75c0-1.8 1.45-3.25 3.25-3.25S15 3.95 15 5.75c0 1.2-.65 2.25-1.62 2.81-.24.13-.38.38-.38.65v6.54c0 .41.34.75.75.75h5c.69 0 1.25.56 1.25 1.25V18ZM2.75 21c-.41 0-.75.34-.75.75s.34.75.75.75h18c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-18Z" clip-rule="evenodd"></path></svg>';
      },
      13214: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Vector" opacity="0.15" d="M18.5 4H5.5C4.67157 4 4 4.67157 4 5.5V18.5C4 19.3284 4.67157 20 5.5 20H18.5C19.3284 20 20 19.3284 20 18.5V5.5C20 4.67157 19.3284 4 18.5 4Z" fill="currentColor"></path><path id="Vector_2" d="M10.94 16L7.81998 13.14C7.7228 13.0507 7.64417 12.9431 7.58856 12.8234C7.53295 12.7038 7.50146 12.5743 7.49589 12.4424C7.49032 12.3106 7.51077 12.1789 7.55609 12.055C7.6014 11.931 7.67068 11.8172 7.75998 11.72C7.94033 11.5237 8.19126 11.4072 8.45756 11.3959C8.58942 11.3903 8.72108 11.4108 8.84504 11.4561C8.96899 11.5014 9.0828 11.5707 9.17998 11.66L10.81 13.16L14.76 8.76C14.8425 8.6471 14.9477 8.55276 15.069 8.48306C15.1902 8.41336 15.3247 8.36986 15.4637 8.35536C15.6028 8.34087 15.7434 8.3557 15.8764 8.3989C16.0094 8.44211 16.1318 8.51272 16.2358 8.60618C16.3398 8.69965 16.4231 8.81388 16.4802 8.94151C16.5373 9.06915 16.567 9.20734 16.5674 9.34717C16.5678 9.487 16.5389 9.62535 16.4825 9.7533C16.4261 9.88126 16.3435 9.99596 16.24 10.09L10.94 16Z" fill="currentColor"></path></svg>';
      },
      60276: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M6.24 7c0-.41.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75h-4.25v2h-1.5v-2H6.99c-.41 0-.75-.34-.75-.75Zm5 11v-3.75h1.5V18c0 .41-.34.75-.75.75s-.75-.34-.75-.75Zm-6.25-6.75c-.41 0-.75.34-.75.75s.34.75.75.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-14Z"></path></svg>';
      },
      25615: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.5 14.5v-11h11v11h-11ZM2 3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Zm13 14.5a2.5 2.5 0 0 0 2.5-2.5V8H21a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3.5h7Z" clip-rule="evenodd"></path></svg>';
      },
      47952: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.57889 18.881C6.18889 18.491 5.55889 18.491 5.16889 18.881C4.77889 19.271 4.77889 19.901 5.16889 20.291C5.55889 20.681 6.18889 20.681 6.57889 20.291C6.96889 19.901 6.96889 19.271 6.57889 18.881ZM21.6089 8.09103L20.5589 7.05103C20.5589 7.05103 20.5489 7.04103 20.5489 7.03103L19.1289 5.62103C19.1289 5.62103 19.1189 5.61103 19.1089 5.60103L14.1789 0.671026C13.9889 0.481026 13.7089 0.401026 13.4389 0.481026C13.1789 0.551026 12.9789 0.761026 12.9189 1.03103V1.07103C12.9189 1.07103 12.8889 1.15103 12.8689 1.21103C12.8389 1.33103 12.7889 1.52103 12.7189 1.74103C12.5889 2.20103 12.3689 2.84103 12.0689 3.57103C11.5489 4.84103 10.7789 6.33103 9.72889 7.56103C9.03889 7.06103 8.07889 7.12103 7.45889 7.74103L6.39889 8.80103C5.71889 9.48103 5.71889 10.591 6.39889 11.281L8.36889 13.241C8.47889 13.351 8.45889 13.541 8.32889 13.631L3.76889 16.661C1.86889 17.931 1.60889 20.621 3.21889 22.241C4.83889 23.851 7.52889 23.581 8.78889 21.681L11.8289 17.131C11.9189 16.991 12.1089 16.981 12.2189 17.091L14.1789 19.051C14.8689 19.741 15.9689 19.741 16.6589 19.051L17.7189 17.991C18.3389 17.371 18.3989 16.391 17.8789 15.711L21.6089 11.981C22.6789 10.911 22.6789 9.17103 21.6089 8.09103ZM16.6589 16.931L15.5989 17.991C15.4989 18.091 15.3389 18.091 15.2389 17.991L13.2789 16.031C12.4989 15.251 11.1989 15.371 10.5789 16.291L7.53889 20.851C6.79889 21.961 5.22889 22.121 4.27889 21.171C3.33889 20.231 3.48889 18.651 4.60889 17.911L9.15889 14.871C10.0789 14.261 10.2089 12.961 9.42889 12.181L7.45889 10.211C7.36889 10.121 7.36889 9.96103 7.45889 9.86103L8.52889 8.80103C8.61889 8.70103 8.77889 8.70103 8.87889 8.80103L9.20889 9.13103C9.20889 9.13103 9.20889 9.15103 9.22889 9.15103L16.2989 16.231C16.2989 16.231 16.3189 16.241 16.3289 16.251L16.6589 16.581C16.7489 16.681 16.7489 16.831 16.6589 16.931ZM20.5489 10.921L16.8289 14.631L10.7989 8.60103C12.0389 7.19103 12.8989 5.50103 13.4589 4.14103C13.6889 3.57103 13.8789 3.06103 14.0189 2.63103L17.9089 6.52103C17.9089 6.52103 17.9189 6.57103 17.9189 6.61103C17.9389 6.80103 17.9489 7.08103 17.9089 7.42103C17.8189 8.09103 17.5289 8.98103 16.6589 9.86103C16.3589 10.151 16.3589 10.631 16.6589 10.921C16.9489 11.211 17.4189 11.211 17.7189 10.921L20.0089 8.62103L20.5489 9.15103C21.0289 9.64103 21.0289 10.431 20.5489 10.921Z" fill="currentColor"></path></svg>';
      },
      60562: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5H3Zm3 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H6ZM2.25 14.5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM6 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H6Z" clip-rule="evenodd"></path></svg>';
      },
      9984: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5H3Zm0 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H3Zm-.75 5.75a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM3 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H3Z" clip-rule="evenodd"></path></svg>';
      },
      7919: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3 3.75a.75.75 0 0 0 0 1.5h18a.75.75 0 0 0 0-1.5H3Zm6 5a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H9ZM2.25 14.5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75ZM9 18.75a.75.75 0 0 0 0 1.5h12a.75.75 0 0 0 0-1.5H9Z" clip-rule="evenodd"></path></svg>';
      },
      95155: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M11.25 4a.75.75 0 0 1 1.5 0v10.156l1.713-1.757a.75.75 0 1 1 1.074 1.048L12 17.074l-3.537-3.627A.75.75 0 0 1 9.537 12.4l1.713 1.756V4Zm9.25 16.25a.75.75 0 0 0 0-1.5h-17a.75.75 0 0 0 0 1.5h17Z" clip-rule="evenodd"></path></svg>';
      },
      10070: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.97 5.47a.75.75 0 0 1 1.06 0l1.22 1.22V2a.75.75 0 0 1 1.5 0v4.69l1.22-1.22a.75.75 0 1 1 1.06 1.06L12 9.56 8.97 6.53a.75.75 0 0 1 0-1.06ZM2.75 12a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1-.75-.75Zm7.28 6.53a.75.75 0 1 1-1.06-1.06L12 14.44l3.03 3.03a.75.75 0 1 1-1.06 1.06l-1.22-1.22V22a.75.75 0 0 1-1.5 0v-4.69l-1.22 1.22Z" clip-rule="evenodd"></path></svg>';
      },
      68715: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.5 3.75a.75.75 0 0 0 0 1.5h17a.75.75 0 0 0 0-1.5h-17ZM12.75 20a.75.75 0 0 1-1.5 0V9.844L9.537 11.6a.75.75 0 1 1-1.074-1.048L12 6.926l3.537 3.627a.75.75 0 1 1-1.074 1.047L12.75 9.845V20Z" clip-rule="evenodd"></path></svg>';
      },
      34057: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4 3.25a.75.75 0 0 0 0 1.5h4.25V15a.75.75 0 0 0 1.5 0V4.75H14a.75.75 0 0 0 0-1.5H4ZM8 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-9.75v7A2.25 2.25 0 0 1 8 17.016V21Z" clip-rule="evenodd"></path></svg>';
      },
      86294: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4 2.5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-13a3 3 0 0 0-3-3H4Zm3 3.75a.75.75 0 0 0 0 1.5h4.25V18a.75.75 0 0 0 1.5 0V7.75H17a.75.75 0 0 0 0-1.5H7Z" clip-rule="evenodd"></path></svg>';
      },
      63308: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19.75 3c0-.41-.34-.75-.75-.75s-.75.34-.75.75v18c0 .41.34.75.75.75s.75-.34.75-.75V3ZM5 6.25c-.41 0-.75.34-.75.75s.34.75.75.75h4.25V18c0 .41.34.75.75.75s.75-.34.75-.75V7.75H15c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5Z"></path></svg>';
      },
      3680: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="4" fill="currentColor" fill-opacity="0.5"></circle></svg>';
      },
      53159: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7.5" stroke="currentColor"></circle></svg>';
      },
      1438: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M8.75 7c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7c0 2.62 2.13 4.75 4.75 4.75s4.75-2.13 4.75-4.75V7c0-.41-.34-.75-.75-.75s-.75.34-.75.75v7c0 1.79-1.46 3.25-3.25 3.25S8.75 15.79 8.75 14V7ZM5 20.25c-.41 0-.75.34-.75.75s.34.75.75.75h14c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H5Z"></path></svg>';
      },
      21257: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.53 3.47a.75.75 0 0 1 0 1.06L5.81 7.25H14a6.75 6.75 0 0 1 0 13.5h-2a.75.75 0 0 1 0-1.5h2a5.25 5.25 0 1 0 0-10.5H5.81l2.72 2.72a.75.75 0 1 1-1.06 1.06L2.94 8l4.53-4.53a.75.75 0 0 1 1.06 0Z" clip-rule="evenodd"></path></svg>';
      },
      9990: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M13 3.25c-.41 0-.75.34-.75.75v7c0 .41.34.75.75.75h7c.41 0 .75-.34.75-.75V4c0-.41-.34-.75-.75-.75h-7Zm.75 7v-5.5h5.5v5.5h-5.5Zm-9.75 2c-.41 0-.75.34-.75.75v7c0 .41.34.75.75.75h7c.41 0 .75-.34.75-.75v-7c0-.41-.34-.75-.75-.75H4Zm.75 7v-5.5h5.5v5.5h-5.5Z" clip-rule="evenodd"></path></svg>';
      },
      80790: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M12.75 15.8c.45-.26.75-.74.75-1.3 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .56.3 1.04.75 1.3V18c0 .41.34.75.75.75s.75-.34.75-.75v-2.2ZM18 9h-1.25V5c0-2.62-2.13-4.75-4.75-4.75S7.25 2.38 7.25 5v.5c0 .41.34.75.75.75s.75-.34.75-.75V5c0-1.79 1.46-3.25 3.25-3.25S15.25 3.21 15.25 5v4H6c-1.66 0-3 1.34-3 3v8c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3v-8c0-1.66-1.34-3-3-3Zm1.5 11c0 .83-.67 1.5-1.5 1.5H6c-.83 0-1.5-.67-1.5-1.5v-8c0-.83.67-1.5 1.5-1.5h12c.83 0 1.5.67 1.5 1.5v8Z"></path></svg>';
      },
      52835: e => {
        e.exports = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 11C4 10.4477 4.44772 10 5 10L23.3204 10C23.5777 10 23.8252 10.0992 24.0113 10.277L29.2435 15.277C29.6556 15.6709 29.6556 16.3291 29.2435 16.723L24.0113 21.723C23.8252 21.9008 23.5777 22 23.3204 22H5C4.44771 22 4 21.5523 4 21V11Z" fill="currentColor"></path></svg>';
      },
      33413: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M13.5 3.043a1.75 1.75 0 0 0-3 0L.266 20.1c-.7 1.166.14 2.65 1.5 2.65h20.468c1.36 0 2.2-1.484 1.5-2.65L13.502 3.043ZM12.75 9a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0V9Zm.5 8.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" clip-rule="evenodd"></path></svg>';
      },
      24544: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M8.25 8.5a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm6.78 4.289a5.25 5.25 0 1 0-6.058 0A8.754 8.754 0 0 0 3.249 21a.75.75 0 0 0 1.5 0 7.25 7.25 0 1 1 14.5 0 .75.75 0 0 0 1.5 0 8.754 8.754 0 0 0-5.72-8.211Z" clip-rule="evenodd"></path></svg>';
      },
      94072: e => {
        e.exports = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.206 3.057a1.5 1.5 0 00-2.55.007L.406 19.714A1.5 1.5 0 001.685 22h20.614a1.5 1.5 0 001.273-2.293L13.206 3.057zm-2.38 6.241h2.353l-.28 6.132H11.12l-.294-6.132zm-.083 8.666c0-.686.56-1.26 1.26-1.26.714 0 1.26.574 1.26 1.26 0 .7-.546 1.274-1.26 1.274-.7 0-1.26-.574-1.26-1.274z" fill="currentColor"></path></svg>';
      },
      42744: e => {
        e.exports = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="warning-2"><path id="Vector 324" d="M7.42834 2.28608L0.605798 13.657C0.339189 14.1013 0.659264 14.6666 1.17746 14.6666H14.8225C15.3407 14.6666 15.6608 14.1013 15.3942 13.657L8.57166 2.28608C8.31273 1.85452 7.68727 1.85452 7.42834 2.28608Z" stroke="black" stroke-linecap="round"></path><path id="Vector 325" d="M8 6V9.33333" stroke="black" stroke-linecap="round"></path><circle id="Ellipse 1085" cx="7.99999" cy="11.6666" r="0.833333" fill="currentColor"></circle></g></svg>';
      },
      59783: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M13.5 3.043a1.75 1.75 0 0 0-3 0L.266 20.1c-.7 1.166.14 2.65 1.5 2.65h20.468c1.36 0 2.2-1.484 1.5-2.65L13.502 3.043ZM12.75 9a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0V9Zm.5 8.5a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z" clip-rule="evenodd"></path></svg>';
      },
      99939: e => {
        e.exports = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_11043_393)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2062 3.05706C12.6174 2.11127 11.2394 2.1148 10.6554 3.0636L0.407199 19.7137C-0.207936 20.7131 0.511081 22 1.68462 22H22.2991C23.4761 22 24.1946 20.7064 23.5725 19.7072L13.2062 3.05706ZM12.8987 15.43L13.1787 9.298H10.8267L11.1137 15.43H12.8987ZM12.8987 17.082C12.6561 16.83 12.3574 16.704 12.0027 16.704C11.6574 16.704 11.3587 16.83 11.1067 17.082C10.8594 17.3293 10.7357 17.6257 10.7357 17.971C10.7357 18.3163 10.8594 18.615 11.1067 18.867C11.3587 19.1143 11.6574 19.238 12.0027 19.238C12.3574 19.238 12.6561 19.1143 12.8987 18.867C13.1461 18.615 13.2697 18.3163 13.2697 17.971C13.2697 17.6257 13.1461 17.3293 12.8987 17.082Z" fill="currentColor"></path></g><defs><clipPath id="clip0_11043_393"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>';
      },
      21619: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M11.992 8.247c.41 0 .75.34.75.75v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-5c0-.41.34-.75.75-.75Zm0 10.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Zm11.73 1.35-10.23-17.06a1.751 1.751 0 0 0-3 0L.262 20.097c-.7 1.17.14 2.65 1.5 2.65h20.46c1.36 0 2.2-1.48 1.5-2.65Zm-1.5 1.15H1.762c-.2 0-.32-.21-.22-.38l10.24-17.05c.09-.17.33-.17.42 0l10.24 17.05c.1.17-.02.38-.22.38Z"></path></svg>';
      },
      38256: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M4.747 9c0-2.35 1.9-4.25 4.25-4.25h4c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-4c-3.18 0-5.75 2.57-5.75 5.75v3.19l-1.72-1.72a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l3.53 3.53 3.53-3.53c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-1.72 1.72V9Zm15.25.25h-9c-.97 0-1.75.78-1.75 1.75v9c0 .97.78 1.75 1.75 1.75h9c.97 0 1.75-.78 1.75-1.75v-9c0-.97-.78-1.75-1.75-1.75Zm-9 1.5h9c.14 0 .25.11.25.25v9c0 .14-.11.25-.25.25h-9c-.14 0-.25-.11-.25-.25v-9c0-.14.11-.25.25-.25Z"></path></svg>';
      },
      3315: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19.25 9c0-2.35-1.9-4.25-4.25-4.25h-4c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c3.18 0 5.75 2.57 5.75 5.75v3.19l1.72-1.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06L20 15.06l-3.53-3.53a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.72 1.72V9ZM4 9.25h9c.97 0 1.75.78 1.75 1.75v9c0 .97-.78 1.75-1.75 1.75H4c-.97 0-1.75-.78-1.75-1.75v-9c0-.97.78-1.75 1.75-1.75Zm9 1.5H4c-.14 0-.25.11-.25.25v9c0 .14.11.25.25.25h9c.14 0 .25-.11.25-.25v-9c0-.14-.11-.25-.25-.25Z"></path></svg>';
      },
      37961: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10ZM10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm.75-10a.75.75 0 0 0-1.5 0v2.25H7a.75.75 0 0 0 0 1.5h2.25V13a.75.75 0 0 0 1.5 0v-2.25H13a.75.75 0 0 0 0-1.5h-2.25V7Z" clip-rule="evenodd"></path></svg>';
      },
      85737: e => {
        e.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M18.5 10c0 2.077-.745 3.98-1.983 5.457l.013.013 5 5a.75.75 0 0 1-1.06 1.06l-5-5-.013-.013A8.5 8.5 0 1 1 18.5 10ZM10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM7 9.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H7Z" clip-rule="evenodd"></path></svg>';
      },
      54670: (e, t, n) => {
        "use strict";

        e.exports = n(60385);
      },
      60385: (e, t) => {
        "use strict";

        function n(e, t) {
          if (void 0 === t && (t = ""), !e) throw Error(t);
        }
        var r = Object.keys(TextMetrics.prototype),
          o = r.includes("actualBoundingBoxAscent") && r.includes("actualBoundingBoxDescent");
        function i(e, t, n) {
          for (var r = 0; r < t; ++r) if (0 !== e.data[n * t * 4 + 4 * r + 3]) return !1;
          return !0;
        }
        t.default = function (e) {
          var t = this;
          if (void 0 === e && (e = ""), this.calculateBoundingBox = function (e) {
            n(t.ctx), t.ctx.fillText(e, 0, 0);
            for (var r = t.ctx.canvas, o = r.width, a = t.ctx.getImageData(0, 0, o, r.height), s = 0, l = a.height; s < l && i(a, o, s);) ++s;
            for (; l - 1 > s && i(a, o, l - 1);) --l;
            return l - s;
          }, this.measureText = function (e, r) {
            void 0 === r && (r = t.font), n(t.ctx), t.ctx.font = r;
            var i = t.ctx.measureText(e),
              a = i.width,
              s = o ? i.actualBoundingBoxAscent + i.actualBoundingBoxDescent : t.calculateBoundingBox(e);
            return {
              width: Math.round(a),
              height: Math.round(s)
            };
          }, this.clean = function () {
            t.canvasElem && document.body.removeChild(t.canvasElem);
          }, "OffscreenCanvas" in window && "function" == typeof OffscreenCanvas) {
            var r = new OffscreenCanvas(1e3, 100);
            this.ctx = r.getContext("2d");
          } else this.canvasElem = document.createElement("canvas"), document.body.appendChild(this.canvasElem), this.ctx = this.canvasElem.getContext("2d"), n(this.ctx), this.ctx.canvas.width = 1e3, this.ctx.canvas.height = 1e3;
          this.font = e, n(this.ctx), this.ctx.font = e;
        };
      },
      70655: (e, t, n) => {
        "use strict";

        n.d(t, {
          ZT: () => o,
          _T: () => a,
          ev: () => s,
          pi: () => i
        });
        var r = function (e, t) {
          return r = Object.setPrototypeOf || {
            __proto__: []
          } instanceof Array && function (e, t) {
            e.__proto__ = t;
          } || function (e, t) {
            for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
          }, r(e, t);
        };
        function o(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
          function n() {
            this.constructor = e;
          }
          r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
        }
        var i = function () {
          return i = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e;
          }, i.apply(this, arguments);
        };
        function a(e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
          }
          return n;
        }
        Object.create;
        function s(e, t, n) {
          if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
          return e.concat(r || t);
        }
        Object.create;
      },
      34997: (e, t, n) => {
        "use strict";

        function r(e) {
          var t = new Error(e);
          return t.source = "ulid", t;
        }
        n.d(t, {
          SK: () => p
        });
        var o = "0123456789ABCDEFGHJKMNPQRSTVWXYZ",
          i = o.length,
          a = Math.pow(2, 48) - 1;
        function s(e) {
          var t = Math.floor(e() * i);
          return t === i && (t = i - 1), o.charAt(t);
        }
        function l(e, t) {
          if (isNaN(e)) throw new Error(e + " must be a number");
          if (e > a) throw r("cannot encode time greater than " + a);
          if (e < 0) throw r("time must be positive");
          if (!1 === Number.isInteger(e)) throw r("time must be an integer");
          for (var n = void 0, s = ""; t > 0; t--) s = o.charAt(n = e % i) + s, e = (e - n) / i;
          return s;
        }
        function u(e, t) {
          for (var n = ""; e > 0; e--) n = s(t) + n;
          return n;
        }
        function c() {
          var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
            t = arguments[1];
          t || (t = "undefined" != typeof window ? window : null);
          var o = t && (t.crypto || t.msCrypto);
          if (o) return function () {
            var e = new Uint8Array(1);
            return o.getRandomValues(e), e[0] / 255;
          };
          try {
            var i = n(94788);
            return function () {
              return i.randomBytes(1).readUInt8() / 255;
            };
          } catch (e) {}
          if (e) {
            try {
              console.error("secure crypto unusable, falling back to insecure Math.random()!");
            } catch (e) {}
            return function () {
              return Math.random();
            };
          }
          throw r("secure crypto unusable, insecure Math.random not allowed");
        }
        var d,
          p = (d || (d = c()), function (e) {
            return isNaN(e) && (e = Date.now()), l(e, 10) + u(16, d);
          });
      },
      94788: () => {},
      53250: (e, t, n) => {
        "use strict";

        var r = n(67294);
        var o = "function" == typeof Object.is ? Object.is : function (e, t) {
            return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
          },
          i = r.useState,
          a = r.useEffect,
          s = r.useLayoutEffect,
          l = r.useDebugValue;
        function u(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !o(e, n);
          } catch (e) {
            return !0;
          }
        }
        var c = "undefined" == typeof window || void 0 === window.document || void 0 === window.document.createElement ? function (e, t) {
          return t();
        } : function (e, t) {
          var n = t(),
            r = i({
              inst: {
                value: n,
                getSnapshot: t
              }
            }),
            o = r[0].inst,
            c = r[1];
          return s(function () {
            o.value = n, o.getSnapshot = t, u(o) && c({
              inst: o
            });
          }, [e, n, t]), a(function () {
            return u(o) && c({
              inst: o
            }), e(function () {
              u(o) && c({
                inst: o
              });
            });
          }, [e]), l(n), n;
        };
        t.useSyncExternalStore = void 0 !== r.useSyncExternalStore ? r.useSyncExternalStore : c;
      },
      50139: (e, t, n) => {
        "use strict";

        var r = n(67294),
          o = n(61688);
        var i = "function" == typeof Object.is ? Object.is : function (e, t) {
            return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
          },
          a = o.useSyncExternalStore,
          s = r.useRef,
          l = r.useEffect,
          u = r.useMemo,
          c = r.useDebugValue;
        t.useSyncExternalStoreWithSelector = function (e, t, n, r, o) {
          var d = s(null);
          if (null === d.current) {
            var p = {
              hasValue: !1,
              value: null
            };
            d.current = p;
          } else p = d.current;
          d = u(function () {
            function e(e) {
              if (!l) {
                if (l = !0, a = e, e = r(e), void 0 !== o && p.hasValue) {
                  var t = p.value;
                  if (o(t, e)) return s = t;
                }
                return s = e;
              }
              if (t = s, i(a, e)) return t;
              var n = r(e);
              return void 0 !== o && o(t, n) ? t : (a = e, s = n);
            }
            var a,
              s,
              l = !1,
              u = void 0 === n ? null : n;
            return [function () {
              return e(t());
            }, null === u ? void 0 : function () {
              return e(u());
            }];
          }, [t, n, r, o]);
          var h = a(e, d[0], d[1]);
          return l(function () {
            p.hasValue = !0, p.value = h;
          }, [h]), c(h), h;
        };
      },
      61688: (e, t, n) => {
        "use strict";

        e.exports = n(53250);
      },
      52798: (e, t, n) => {
        "use strict";

        e.exports = n(50139);
      },
      77017: (e, t, n) => {
        "use strict";

        let r;
        n.d(t, {
          v4: () => w
        });
        const o = new Uint8Array(16);
        function i() {
          if (!r && (r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !r)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
          return r(o);
        }
        const a = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
        const s = function (e) {
            return "string" == typeof e && a.test(e);
          },
          l = [];
        for (let e = 0; e < 256; ++e) l.push((e + 256).toString(16).slice(1));
        function u(e, t = 0) {
          return l[e[t + 0]] + l[e[t + 1]] + l[e[t + 2]] + l[e[t + 3]] + "-" + l[e[t + 4]] + l[e[t + 5]] + "-" + l[e[t + 6]] + l[e[t + 7]] + "-" + l[e[t + 8]] + l[e[t + 9]] + "-" + l[e[t + 10]] + l[e[t + 11]] + l[e[t + 12]] + l[e[t + 13]] + l[e[t + 14]] + l[e[t + 15]];
        }
        const c = function (e) {
          if (!s(e)) throw TypeError("Invalid UUID");
          let t;
          const n = new Uint8Array(16);
          return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
        };
        function d(e, t, n) {
          function r(e, r, o, i) {
            var a;
            if ("string" == typeof e && (e = function (e) {
              e = unescape(encodeURIComponent(e));
              const t = [];
              for (let n = 0; n < e.length; ++n) t.push(e.charCodeAt(n));
              return t;
            }(e)), "string" == typeof r && (r = c(r)), 16 !== (null === (a = r) || void 0 === a ? void 0 : a.length)) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
            let s = new Uint8Array(16 + e.length);
            if (s.set(r), s.set(e, r.length), s = n(s), s[6] = 15 & s[6] | t, s[8] = 63 & s[8] | 128, o) {
              i = i || 0;
              for (let e = 0; e < 16; ++e) o[i + e] = s[e];
              return o;
            }
            return u(s);
          }
          try {
            r.name = e;
          } catch (e) {}
          return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
        }
        function p(e) {
          return 14 + (e + 64 >>> 9 << 4) + 1;
        }
        function h(e, t) {
          const n = (65535 & e) + (65535 & t);
          return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
        }
        function f(e, t, n, r, o, i) {
          return h((a = h(h(t, e), h(r, i))) << (s = o) | a >>> 32 - s, n);
          var a, s;
        }
        function m(e, t, n, r, o, i, a) {
          return f(t & n | ~t & r, e, t, o, i, a);
        }
        function g(e, t, n, r, o, i, a) {
          return f(t & r | n & ~r, e, t, o, i, a);
        }
        function v(e, t, n, r, o, i, a) {
          return f(t ^ n ^ r, e, t, o, i, a);
        }
        function y(e, t, n, r, o, i, a) {
          return f(n ^ (t | ~r), e, t, o, i, a);
        }
        d("v3", 48, function (e) {
          if ("string" == typeof e) {
            const t = unescape(encodeURIComponent(e));
            e = new Uint8Array(t.length);
            for (let n = 0; n < t.length; ++n) e[n] = t.charCodeAt(n);
          }
          return function (e) {
            const t = [],
              n = 32 * e.length,
              r = "0123456789abcdef";
            for (let o = 0; o < n; o += 8) {
              const n = e[o >> 5] >>> o % 32 & 255,
                i = parseInt(r.charAt(n >>> 4 & 15) + r.charAt(15 & n), 16);
              t.push(i);
            }
            return t;
          }(function (e, t) {
            e[t >> 5] |= 128 << t % 32, e[p(t) - 1] = t;
            let n = 1732584193,
              r = -271733879,
              o = -1732584194,
              i = 271733878;
            for (let t = 0; t < e.length; t += 16) {
              const a = n,
                s = r,
                l = o,
                u = i;
              n = m(n, r, o, i, e[t], 7, -680876936), i = m(i, n, r, o, e[t + 1], 12, -389564586), o = m(o, i, n, r, e[t + 2], 17, 606105819), r = m(r, o, i, n, e[t + 3], 22, -1044525330), n = m(n, r, o, i, e[t + 4], 7, -176418897), i = m(i, n, r, o, e[t + 5], 12, 1200080426), o = m(o, i, n, r, e[t + 6], 17, -1473231341), r = m(r, o, i, n, e[t + 7], 22, -45705983), n = m(n, r, o, i, e[t + 8], 7, 1770035416), i = m(i, n, r, o, e[t + 9], 12, -1958414417), o = m(o, i, n, r, e[t + 10], 17, -42063), r = m(r, o, i, n, e[t + 11], 22, -1990404162), n = m(n, r, o, i, e[t + 12], 7, 1804603682), i = m(i, n, r, o, e[t + 13], 12, -40341101), o = m(o, i, n, r, e[t + 14], 17, -1502002290), r = m(r, o, i, n, e[t + 15], 22, 1236535329), n = g(n, r, o, i, e[t + 1], 5, -165796510), i = g(i, n, r, o, e[t + 6], 9, -1069501632), o = g(o, i, n, r, e[t + 11], 14, 643717713), r = g(r, o, i, n, e[t], 20, -373897302), n = g(n, r, o, i, e[t + 5], 5, -701558691), i = g(i, n, r, o, e[t + 10], 9, 38016083), o = g(o, i, n, r, e[t + 15], 14, -660478335), r = g(r, o, i, n, e[t + 4], 20, -405537848), n = g(n, r, o, i, e[t + 9], 5, 568446438), i = g(i, n, r, o, e[t + 14], 9, -1019803690), o = g(o, i, n, r, e[t + 3], 14, -187363961), r = g(r, o, i, n, e[t + 8], 20, 1163531501), n = g(n, r, o, i, e[t + 13], 5, -1444681467), i = g(i, n, r, o, e[t + 2], 9, -51403784), o = g(o, i, n, r, e[t + 7], 14, 1735328473), r = g(r, o, i, n, e[t + 12], 20, -1926607734), n = v(n, r, o, i, e[t + 5], 4, -378558), i = v(i, n, r, o, e[t + 8], 11, -2022574463), o = v(o, i, n, r, e[t + 11], 16, 1839030562), r = v(r, o, i, n, e[t + 14], 23, -35309556), n = v(n, r, o, i, e[t + 1], 4, -1530992060), i = v(i, n, r, o, e[t + 4], 11, 1272893353), o = v(o, i, n, r, e[t + 7], 16, -155497632), r = v(r, o, i, n, e[t + 10], 23, -1094730640), n = v(n, r, o, i, e[t + 13], 4, 681279174), i = v(i, n, r, o, e[t], 11, -358537222), o = v(o, i, n, r, e[t + 3], 16, -722521979), r = v(r, o, i, n, e[t + 6], 23, 76029189), n = v(n, r, o, i, e[t + 9], 4, -640364487), i = v(i, n, r, o, e[t + 12], 11, -421815835), o = v(o, i, n, r, e[t + 15], 16, 530742520), r = v(r, o, i, n, e[t + 2], 23, -995338651), n = y(n, r, o, i, e[t], 6, -198630844), i = y(i, n, r, o, e[t + 7], 10, 1126891415), o = y(o, i, n, r, e[t + 14], 15, -1416354905), r = y(r, o, i, n, e[t + 5], 21, -57434055), n = y(n, r, o, i, e[t + 12], 6, 1700485571), i = y(i, n, r, o, e[t + 3], 10, -1894986606), o = y(o, i, n, r, e[t + 10], 15, -1051523), r = y(r, o, i, n, e[t + 1], 21, -2054922799), n = y(n, r, o, i, e[t + 8], 6, 1873313359), i = y(i, n, r, o, e[t + 15], 10, -30611744), o = y(o, i, n, r, e[t + 6], 15, -1560198380), r = y(r, o, i, n, e[t + 13], 21, 1309151649), n = y(n, r, o, i, e[t + 4], 6, -145523070), i = y(i, n, r, o, e[t + 11], 10, -1120210379), o = y(o, i, n, r, e[t + 2], 15, 718787259), r = y(r, o, i, n, e[t + 9], 21, -343485551), n = h(n, a), r = h(r, s), o = h(o, l), i = h(i, u);
            }
            return [n, r, o, i];
          }(function (e) {
            if (0 === e.length) return [];
            const t = 8 * e.length,
              n = new Uint32Array(p(t));
            for (let r = 0; r < t; r += 8) n[r >> 5] |= (255 & e[r / 8]) << r % 32;
            return n;
          }(e), 8 * e.length));
        });
        const b = {
          randomUUID: "undefined" != typeof crypto && crypto.randomUUID && crypto.randomUUID.bind(crypto)
        };
        const w = function (e, t, n) {
          if (b.randomUUID && !t && !e) return b.randomUUID();
          const r = (e = e || {}).random || (e.rng || i)();
          if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
            n = n || 0;
            for (let e = 0; e < 16; ++e) t[n + e] = r[e];
            return t;
          }
          return u(r);
        };
        function x(e, t, n, r) {
          switch (e) {
            case 0:
              return t & n ^ ~t & r;
            case 1:
            case 3:
              return t ^ n ^ r;
            case 2:
              return t & n ^ t & r ^ n & r;
          }
        }
        function D(e, t) {
          return e << t | e >>> 32 - t;
        }
        d("v5", 80, function (e) {
          const t = [1518500249, 1859775393, 2400959708, 3395469782],
            n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
          if ("string" == typeof e) {
            const t = unescape(encodeURIComponent(e));
            e = [];
            for (let n = 0; n < t.length; ++n) e.push(t.charCodeAt(n));
          } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
          e.push(128);
          const r = e.length / 4 + 2,
            o = Math.ceil(r / 16),
            i = new Array(o);
          for (let t = 0; t < o; ++t) {
            const n = new Uint32Array(16);
            for (let r = 0; r < 16; ++r) n[r] = e[64 * t + 4 * r] << 24 | e[64 * t + 4 * r + 1] << 16 | e[64 * t + 4 * r + 2] << 8 | e[64 * t + 4 * r + 3];
            i[t] = n;
          }
          i[o - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), i[o - 1][14] = Math.floor(i[o - 1][14]), i[o - 1][15] = 8 * (e.length - 1) & 4294967295;
          for (let e = 0; e < o; ++e) {
            const r = new Uint32Array(80);
            for (let t = 0; t < 16; ++t) r[t] = i[e][t];
            for (let e = 16; e < 80; ++e) r[e] = D(r[e - 3] ^ r[e - 8] ^ r[e - 14] ^ r[e - 16], 1);
            let o = n[0],
              a = n[1],
              s = n[2],
              l = n[3],
              u = n[4];
            for (let e = 0; e < 80; ++e) {
              const n = Math.floor(e / 20),
                i = D(o, 5) + x(n, a, s, l) + u + t[n] + r[e] >>> 0;
              u = l, l = s, s = D(a, 30) >>> 0, a = o, o = i;
            }
            n[0] = n[0] + o >>> 0, n[1] = n[1] + a >>> 0, n[2] = n[2] + s >>> 0, n[3] = n[3] + l >>> 0, n[4] = n[4] + u >>> 0;
          }
          return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
        });
      },
      87153: e => {
        e.exports = "428ce41756cbb3ca";
      },
      91117: e => {
        e.exports = "b0a426cca3226cb0";
      },
      35349: e => {
        e.exports = "bc4b5af9be9bbefa";
      },
      9327: (e, t) => {
        var n;
        !function () {
          "use strict";

          var r = {}.hasOwnProperty;
          function o() {
            for (var e = [], t = 0; t < arguments.length; t++) {
              var n = arguments[t];
              if (n) {
                var i = typeof n;
                if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
                  if (n.length) {
                    var a = o.apply(null, n);
                    a && e.push(a);
                  }
                } else if ("object" === i) if (n.toString === Object.prototype.toString) for (var s in n) r.call(n, s) && n[s] && e.push(s);else e.push(n.toString());
              }
            }
            return e.join(" ");
          }
          e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
            return o;
          }.apply(t, [])) || (e.exports = n);
        }();
      },
      36403: (e, t, n) => {
        var r = {
          "./check.svg": 91884,
          "./circle.svg": 55108,
          "./comment.svg": 56610,
          "./cross.svg": 64767,
          "./help.svg": 63359,
          "./insert.svg": 81740,
          "./key.svg": 89559,
          "./newParagraph.svg": 50371,
          "./note.svg": 58728,
          "./paragraph.svg": 44542,
          "./rightArrow.svg": 98671,
          "./rightPointer.svg": 44741,
          "./star.svg": 99471
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 36403;
      },
      79230: (e, t, n) => {
        var r = {
          "./add-text-box.svg": 33150,
          "./add.svg": 84768,
          "./all-pages.svg": 41725,
          "./ancestor-hidden.svg": 58817,
          "./ancestor-locked.svg": 87779,
          "./annotate.svg": 83104,
          "./anonymous.svg": 33751,
          "./arrow-right.svg": 497,
          "./arrow-up.svg": 96421,
          "./arrow.svg": 1291,
          "./back.svg": 1126,
          "./blend-mode.svg": 39127,
          "./bold.svg": 6274,
          "./bookmark-active.svg": 79439,
          "./border-color.svg": 57462,
          "./calibrate.svg": 64772,
          "./callout.svg": 14623,
          "./caret-down-variant.svg": 42451,
          "./caret-down.svg": 52904,
          "./caret-left.svg": 10190,
          "./caret-right.svg": 92122,
          "./caret-up.svg": 19201,
          "./caret.svg": 74777,
          "./check-circle.svg": 97468,
          "./check.svg": 46154,
          "./checked-radio-group.svg": 94556,
          "./checkmark.svg": 79579,
          "./chevron-down-filled.svg": 49612,
          "./chevron-right-filled.svg": 67018,
          "./clockwise.svg": 35077,
          "./close-button.svg": 2256,
          "./close.svg": 66361,
          "./cloudy-border.svg": 80224,
          "./cloudy-ellipse.svg": 10669,
          "./cloudy-polygon.svg": 13830,
          "./cloudy-rectangle.svg": 64874,
          "./comment-filled.svg": 23944,
          "./comment-indicator.svg": 80259,
          "./comment.svg": 53063,
          "./compare-pin-drop-cursor.svg": 28735,
          "./compare-select-point-indicator-black.svg": 23874,
          "./content-editor.svg": 10346,
          "./counterclockwise.svg": 84539,
          "./dashed-ellipse.svg": 95482,
          "./dashed-polygon.svg": 10801,
          "./dashed-rectangle.svg": 43472,
          "./debug.svg": 41828,
          "./delete.svg": 63949,
          "./digital-signatures/signature-error.svg": 40825,
          "./digital-signatures/signature-valid.svg": 3572,
          "./distance.svg": 13864,
          "./document-assistant.svg": 65829,
          "./document-comparison.svg": 66308,
          "./document-crop.svg": 58645,
          "./document-editor.svg": 20574,
          "./drawing-closing-cursor.svg": 48947,
          "./drawing-cursor.svg": 37390,
          "./edit.svg": 61802,
          "./editor/add.svg": 69558,
          "./editor/duplicate.svg": 24388,
          "./editor/extractPages.svg": 88105,
          "./editor/help.svg": 9451,
          "./editor/importDocument.svg": 48982,
          "./editor/move.svg": 6058,
          "./editor/moveLeft.svg": 91288,
          "./editor/moveRight.svg": 46018,
          "./editor/multiplePages.svg": 13006,
          "./editor/redo.svg": 52449,
          "./editor/remove.svg": 1562,
          "./editor/rotateLeft.svg": 52684,
          "./editor/rotateRight.svg": 58287,
          "./editor/selectAll.svg": 57208,
          "./editor/selectNone.svg": 95119,
          "./editor/undo.svg": 32428,
          "./editor/zoomIn.svg": 62475,
          "./editor/zoomOut.svg": 75480,
          "./ellipse-area.svg": 5111,
          "./ellipse.svg": 58439,
          "./export-pdf.svg": 5461,
          "./eye-close.svg": 1925,
          "./eye-open.svg": 16074,
          "./fill-color.svg": 92742,
          "./fit-page.svg": 44882,
          "./fit-width.svg": 85449,
          "./font-size.svg": 14379,
          "./font.svg": 81741,
          "./form-button.svg": 90686,
          "./form-checkbox.svg": 63357,
          "./form-combobox.svg": 97245,
          "./form-creator.svg": 17035,
          "./form-date.svg": 48358,
          "./form-listbox.svg": 92070,
          "./form-radio.svg": 60571,
          "./form-signature.svg": 50121,
          "./form-text.svg": 29890,
          "./group.svg": 66962,
          "./hamburger.svg": 60967,
          "./highlight.svg": 99319,
          "./highlighter.svg": 939,
          "./image.svg": 71865,
          "./info.svg": 69241,
          "./ink-eraser.svg": 94814,
          "./ink.svg": 79363,
          "./inpage-check-icon.svg": 22606,
          "./italic.svg": 66311,
          "./layout-config.svg": 91998,
          "./layout-config/auto.svg": 46318,
          "./layout-config/continuous.svg": 1409,
          "./layout-config/double.svg": 63113,
          "./layout-config/single.svg": 65558,
          "./layout-config/view_rotate_left.svg": 58417,
          "./layout-config/view_rotate_right.svg": 54669,
          "./line-style.svg": 20113,
          "./line-width.svg": 41869,
          "./line.svg": 66294,
          "./linecaps-dasharray.svg": 83553,
          "./linestyle.svg": 61682,
          "./link.svg": 22243,
          "./lock.svg": 50308,
          "./marquee-zoom.svg": 35231,
          "./measure.svg": 45606,
          "./media.svg": 64701,
          "./mention.svg": 10017,
          "./more.svg": 87394,
          "./multi-annotations-selection.svg": 56034,
          "./not-editable.svg": 55079,
          "./note-add.svg": 28772,
          "./note-icon.svg": 16302,
          "./note-indicator.svg": 11248,
          "./note.svg": 9937,
          "./note/check.svg": 91884,
          "./note/circle.svg": 55108,
          "./note/comment.svg": 56610,
          "./note/cross.svg": 64767,
          "./note/help.svg": 63359,
          "./note/insert.svg": 81740,
          "./note/key.svg": 89559,
          "./note/newParagraph.svg": 50371,
          "./note/note.svg": 58728,
          "./note/paragraph.svg": 44542,
          "./note/rightArrow.svg": 98671,
          "./note/rightPointer.svg": 44741,
          "./note/star.svg": 99471,
          "./ocg-lock.svg": 24808,
          "./ocg-unlock.svg": 83569,
          "./opacity.svg": 22636,
          "./pan.svg": 29489,
          "./perimeter.svg": 60231,
          "./plus.svg": 45632,
          "./polygon-area.svg": 91291,
          "./polygon.svg": 72780,
          "./polyline.svg": 82748,
          "./precision.svg": 45989,
          "./print.svg": 738,
          "./rectangle-area.svg": 96816,
          "./rectangle.svg": 7799,
          "./redact-rectangle.svg": 42741,
          "./redact-text-highlighter.svg": 11088,
          "./redaction-text-repeating.svg": 97248,
          "./redaction-text-single.svg": 80953,
          "./redaction.svg": 20377,
          "./redo.svg": 90194,
          "./remove-circled.svg": 50331,
          "./rotate.svg": 72938,
          "./scale.svg": 45983,
          "./search.svg": 98589,
          "./sidebar-annotations.svg": 62949,
          "./sidebar-bookmarks.svg": 59620,
          "./sidebar-document-outline.svg": 47082,
          "./sidebar-layers.svg": 80163,
          "./sidebar-signatures.svg": 12778,
          "./sidebar-thumbnails.svg": 9643,
          "./signature-error.svg": 25899,
          "./signature-valid.svg": 24089,
          "./signature-warning.svg": 47630,
          "./signature.svg": 65936,
          "./single-page.svg": 23717,
          "./squiggle.svg": 10737,
          "./stamp.svg": 54897,
          "./status-completed.svg": 13214,
          "./strikeout.svg": 60276,
          "./stroke-color.svg": 25615,
          "./style.svg": 47952,
          "./text-align-horizontal-center.svg": 60562,
          "./text-align-horizontal-left.svg": 9984,
          "./text-align-horizontal-right.svg": 7919,
          "./text-align-vertical-bottom.svg": 95155,
          "./text-align-vertical-center.svg": 10070,
          "./text-align-vertical-top.svg": 68715,
          "./text-color.svg": 34057,
          "./text-highlighter.svg": 86294,
          "./text.svg": 63308,
          "./toggle-arrow.svg": 3680,
          "./unchecked-radio-group.svg": 53159,
          "./underline.svg": 1438,
          "./undo.svg": 21257,
          "./ungroup.svg": 9990,
          "./unlock.svg": 80790,
          "./unsigned-signature-field.svg": 52835,
          "./user-hint.svg": 33413,
          "./user.svg": 24544,
          "./warning-2.svg": 94072,
          "./warning-3.svg": 42744,
          "./warning-filled.svg": 59783,
          "./warning-triangle-full.svg": 99939,
          "./warning.svg": 21619,
          "./widget_ccw.svg": 38256,
          "./widget_cw.svg": 3315,
          "./zoom-in.svg": 37961,
          "./zoom-out.svg": 85737
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 79230;
      },
      89457: (e, t, n) => {
        var r = {
          "./add-text-box.svg": 33150,
          "./add.svg": 84768,
          "./all-pages.svg": 41725,
          "./ancestor-hidden.svg": 58817,
          "./ancestor-locked.svg": 87779,
          "./annotate.svg": 83104,
          "./anonymous.svg": 33751,
          "./arrow-right.svg": 497,
          "./arrow-up.svg": 96421,
          "./arrow.svg": 1291,
          "./back.svg": 1126,
          "./blend-mode.svg": 39127,
          "./bold.svg": 6274,
          "./bookmark-active.svg": 79439,
          "./border-color.svg": 57462,
          "./calibrate.svg": 64772,
          "./callout.svg": 14623,
          "./caret-down-variant.svg": 42451,
          "./caret-down.svg": 52904,
          "./caret-left.svg": 10190,
          "./caret-right.svg": 92122,
          "./caret-up.svg": 19201,
          "./caret.svg": 74777,
          "./check-circle.svg": 97468,
          "./check.svg": 46154,
          "./checked-radio-group.svg": 94556,
          "./checkmark.svg": 79579,
          "./chevron-down-filled.svg": 49612,
          "./chevron-right-filled.svg": 67018,
          "./clockwise.svg": 35077,
          "./close-button.svg": 2256,
          "./close.svg": 66361,
          "./cloudy-border.svg": 80224,
          "./cloudy-ellipse.svg": 10669,
          "./cloudy-polygon.svg": 13830,
          "./cloudy-rectangle.svg": 64874,
          "./comment-filled.svg": 23944,
          "./comment-indicator.svg": 80259,
          "./comment.svg": 53063,
          "./compare-pin-drop-cursor.svg": 28735,
          "./compare-select-point-indicator-black.svg": 23874,
          "./content-editor.svg": 10346,
          "./counterclockwise.svg": 84539,
          "./dashed-ellipse.svg": 95482,
          "./dashed-polygon.svg": 10801,
          "./dashed-rectangle.svg": 43472,
          "./debug.svg": 41828,
          "./delete.svg": 63949,
          "./digital-signatures/signature-error.svg": 40825,
          "./digital-signatures/signature-valid.svg": 3572,
          "./distance.svg": 13864,
          "./document-assistant.svg": 65829,
          "./document-comparison.svg": 66308,
          "./document-crop.svg": 58645,
          "./document-editor.svg": 20574,
          "./drawing-closing-cursor.svg": 48947,
          "./drawing-cursor.svg": 37390,
          "./edit.svg": 61802,
          "./editor/add.svg": 69558,
          "./editor/duplicate.svg": 24388,
          "./editor/extractPages.svg": 88105,
          "./editor/help.svg": 9451,
          "./editor/importDocument.svg": 48982,
          "./editor/move.svg": 6058,
          "./editor/moveLeft.svg": 91288,
          "./editor/moveRight.svg": 46018,
          "./editor/multiplePages.svg": 13006,
          "./editor/redo.svg": 52449,
          "./editor/remove.svg": 1562,
          "./editor/rotateLeft.svg": 52684,
          "./editor/rotateRight.svg": 58287,
          "./editor/selectAll.svg": 57208,
          "./editor/selectNone.svg": 95119,
          "./editor/undo.svg": 32428,
          "./editor/zoomIn.svg": 62475,
          "./editor/zoomOut.svg": 75480,
          "./ellipse-area.svg": 5111,
          "./ellipse.svg": 58439,
          "./export-pdf.svg": 5461,
          "./eye-close.svg": 1925,
          "./eye-open.svg": 16074,
          "./fill-color.svg": 92742,
          "./fit-page.svg": 44882,
          "./fit-width.svg": 85449,
          "./font-size.svg": 14379,
          "./font.svg": 81741,
          "./form-button.svg": 90686,
          "./form-checkbox.svg": 63357,
          "./form-combobox.svg": 97245,
          "./form-creator.svg": 17035,
          "./form-date.svg": 48358,
          "./form-listbox.svg": 92070,
          "./form-radio.svg": 60571,
          "./form-signature.svg": 50121,
          "./form-text.svg": 29890,
          "./group.svg": 66962,
          "./hamburger.svg": 60967,
          "./highlight.svg": 99319,
          "./highlighter.svg": 939,
          "./image.svg": 71865,
          "./info.svg": 69241,
          "./ink-eraser.svg": 94814,
          "./ink.svg": 79363,
          "./inpage-check-icon.svg": 22606,
          "./italic.svg": 66311,
          "./layout-config.svg": 91998,
          "./layout-config/auto.svg": 46318,
          "./layout-config/continuous.svg": 1409,
          "./layout-config/double.svg": 63113,
          "./layout-config/single.svg": 65558,
          "./layout-config/view_rotate_left.svg": 58417,
          "./layout-config/view_rotate_right.svg": 54669,
          "./line-style.svg": 20113,
          "./line-width.svg": 41869,
          "./line.svg": 66294,
          "./linecaps-dasharray.svg": 83553,
          "./linestyle.svg": 61682,
          "./link.svg": 22243,
          "./lock.svg": 50308,
          "./marquee-zoom.svg": 35231,
          "./measure.svg": 45606,
          "./media.svg": 64701,
          "./mention.svg": 10017,
          "./more.svg": 87394,
          "./multi-annotations-selection.svg": 56034,
          "./not-editable.svg": 55079,
          "./note-add.svg": 28772,
          "./note-icon.svg": 16302,
          "./note-indicator.svg": 11248,
          "./note.svg": 9937,
          "./note/check.svg": 91884,
          "./note/circle.svg": 55108,
          "./note/comment.svg": 56610,
          "./note/cross.svg": 64767,
          "./note/help.svg": 63359,
          "./note/insert.svg": 81740,
          "./note/key.svg": 89559,
          "./note/newParagraph.svg": 50371,
          "./note/note.svg": 58728,
          "./note/paragraph.svg": 44542,
          "./note/rightArrow.svg": 98671,
          "./note/rightPointer.svg": 44741,
          "./note/star.svg": 99471,
          "./ocg-lock.svg": 24808,
          "./ocg-unlock.svg": 83569,
          "./opacity.svg": 22636,
          "./pan.svg": 29489,
          "./perimeter.svg": 60231,
          "./plus.svg": 45632,
          "./polygon-area.svg": 91291,
          "./polygon.svg": 72780,
          "./polyline.svg": 82748,
          "./precision.svg": 45989,
          "./print.svg": 738,
          "./rectangle-area.svg": 96816,
          "./rectangle.svg": 7799,
          "./redact-rectangle.svg": 42741,
          "./redact-text-highlighter.svg": 11088,
          "./redaction-text-repeating.svg": 97248,
          "./redaction-text-single.svg": 80953,
          "./redaction.svg": 20377,
          "./redo.svg": 90194,
          "./remove-circled.svg": 50331,
          "./rotate.svg": 72938,
          "./scale.svg": 45983,
          "./search.svg": 98589,
          "./sidebar-annotations.svg": 62949,
          "./sidebar-bookmarks.svg": 59620,
          "./sidebar-document-outline.svg": 47082,
          "./sidebar-layers.svg": 80163,
          "./sidebar-signatures.svg": 12778,
          "./sidebar-thumbnails.svg": 9643,
          "./signature-error.svg": 25899,
          "./signature-valid.svg": 24089,
          "./signature-warning.svg": 47630,
          "./signature.svg": 65936,
          "./single-page.svg": 23717,
          "./squiggle.svg": 10737,
          "./stamp.svg": 54897,
          "./status-completed.svg": 13214,
          "./strikeout.svg": 60276,
          "./stroke-color.svg": 25615,
          "./style.svg": 47952,
          "./text-align-horizontal-center.svg": 60562,
          "./text-align-horizontal-left.svg": 9984,
          "./text-align-horizontal-right.svg": 7919,
          "./text-align-vertical-bottom.svg": 95155,
          "./text-align-vertical-center.svg": 10070,
          "./text-align-vertical-top.svg": 68715,
          "./text-color.svg": 34057,
          "./text-highlighter.svg": 86294,
          "./text.svg": 63308,
          "./toggle-arrow.svg": 3680,
          "./unchecked-radio-group.svg": 53159,
          "./underline.svg": 1438,
          "./undo.svg": 21257,
          "./ungroup.svg": 9990,
          "./unlock.svg": 80790,
          "./unsigned-signature-field.svg": 52835,
          "./user-hint.svg": 33413,
          "./user.svg": 24544,
          "./warning-2.svg": 94072,
          "./warning-3.svg": 42744,
          "./warning-filled.svg": 59783,
          "./warning-triangle-full.svg": 99939,
          "./warning.svg": 21619,
          "./widget_ccw.svg": 38256,
          "./widget_cw.svg": 3315,
          "./zoom-in.svg": 37961,
          "./zoom-out.svg": 85737
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 89457;
      },
      35982: (e, t, n) => {
        var r = {
          "./caret-down-variant.svg": 42451,
          "./caret-down.svg": 52904,
          "./caret-left.svg": 10190,
          "./caret-right.svg": 92122,
          "./caret-up.svg": 19201
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 35982;
      },
      58758: (e, t, n) => {
        var r = {
          "./text-align-horizontal-center.svg": 60562,
          "./text-align-horizontal-left.svg": 9984,
          "./text-align-horizontal-right.svg": 7919
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 58758;
      },
      29712: (e, t, n) => {
        var r = {
          "./text-align-vertical-bottom.svg": 95155,
          "./text-align-vertical-center.svg": 10070,
          "./text-align-vertical-top.svg": 68715
        };
        function o(e) {
          var t = i(e);
          return n(t);
        }
        function i(e) {
          if (!n.o(r, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw t.code = "MODULE_NOT_FOUND", t;
          }
          return r[e];
        }
        o.keys = function () {
          return Object.keys(r);
        }, o.resolve = i, e.exports = o, o.id = 29712;
      },
      34988: (e, t, n) => {
        var r;
        !function (o, i, a, s) {
          "use strict";

          var l,
            u = ["", "webkit", "Moz", "MS", "ms", "o"],
            c = i.createElement("div"),
            d = Math.round,
            p = Math.abs,
            h = Date.now;
          function f(e, t, n) {
            return setTimeout(x(e, n), t);
          }
          function m(e, t, n) {
            return !!Array.isArray(e) && (g(e, n[t], n), !0);
          }
          function g(e, t, n) {
            var r;
            if (e) if (e.forEach) e.forEach(t, n);else if (e.length !== s) for (r = 0; r < e.length;) t.call(n, e[r], r, e), r++;else for (r in e) e.hasOwnProperty(r) && t.call(n, e[r], r, e);
          }
          function v(e, t, n) {
            var r = "DEPRECATED METHOD: " + t + "\n" + n + " AT \n";
            return function () {
              var t = new Error("get-stack-trace"),
                n = t && t.stack ? t.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace",
                i = o.console && (o.console.warn || o.console.log);
              return i && i.call(o.console, r, n), e.apply(this, arguments);
            };
          }
          l = "function" != typeof Object.assign ? function (e) {
            if (e === s || null === e) throw new TypeError("Cannot convert undefined or null to object");
            for (var t = Object(e), n = 1; n < arguments.length; n++) {
              var r = arguments[n];
              if (r !== s && null !== r) for (var o in r) r.hasOwnProperty(o) && (t[o] = r[o]);
            }
            return t;
          } : Object.assign;
          var y = v(function (e, t, n) {
              for (var r = Object.keys(t), o = 0; o < r.length;) (!n || n && e[r[o]] === s) && (e[r[o]] = t[r[o]]), o++;
              return e;
            }, "extend", "Use `assign`."),
            b = v(function (e, t) {
              return y(e, t, !0);
            }, "merge", "Use `assign`.");
          function w(e, t, n) {
            var r,
              o = t.prototype;
            (r = e.prototype = Object.create(o)).constructor = e, r._super = o, n && l(r, n);
          }
          function x(e, t) {
            return function () {
              return e.apply(t, arguments);
            };
          }
          function D(e, t) {
            return "function" == typeof e ? e.apply(t && t[0] || s, t) : e;
          }
          function C(e, t) {
            return e === s ? t : e;
          }
          function S(e, t, n) {
            g(k(t), function (t) {
              e.addEventListener(t, n, !1);
            });
          }
          function E(e, t, n) {
            g(k(t), function (t) {
              e.removeEventListener(t, n, !1);
            });
          }
          function _(e, t) {
            for (; e;) {
              if (e == t) return !0;
              e = e.parentNode;
            }
            return !1;
          }
          function P(e, t) {
            return e.indexOf(t) > -1;
          }
          function k(e) {
            return e.trim().split(/\s+/g);
          }
          function A(e, t, n) {
            if (e.indexOf && !n) return e.indexOf(t);
            for (var r = 0; r < e.length;) {
              if (n && e[r][n] == t || !n && e[r] === t) return r;
              r++;
            }
            return -1;
          }
          function z(e) {
            return Array.prototype.slice.call(e, 0);
          }
          function T(e, t, n) {
            for (var r = [], o = [], i = 0; i < e.length;) {
              var a = t ? e[i][t] : e[i];
              A(o, a) < 0 && r.push(e[i]), o[i] = a, i++;
            }
            return n && (r = t ? r.sort(function (e, n) {
              return e[t] > n[t];
            }) : r.sort()), r;
          }
          function O(e, t) {
            for (var n, r, o = t[0].toUpperCase() + t.slice(1), i = 0; i < u.length;) {
              if ((r = (n = u[i]) ? n + o : t) in e) return r;
              i++;
            }
            return s;
          }
          var I = 1;
          function F(e) {
            var t = e.ownerDocument || e;
            return t.defaultView || t.parentWindow || o;
          }
          var M = "ontouchstart" in o,
            R = O(o, "PointerEvent") !== s,
            j = M && /mobile|tablet|ip(ad|hone|od)|android/i.test(navigator.userAgent),
            B = "touch",
            N = "mouse",
            L = 24,
            V = ["x", "y"],
            K = ["clientX", "clientY"];
          function q(e, t) {
            var n = this;
            this.manager = e, this.callback = t, this.element = e.element, this.target = e.options.inputTarget, this.domHandler = function (t) {
              D(e.options.enable, [e]) && n.handler(t);
            }, this.init();
          }
          function H(e, t, n) {
            var r = n.pointers.length,
              o = n.changedPointers.length,
              i = 1 & t && r - o == 0,
              a = 12 & t && r - o == 0;
            n.isFirst = !!i, n.isFinal = !!a, i && (e.session = {}), n.eventType = t, function (e, t) {
              var n = e.session,
                r = t.pointers,
                o = r.length;
              n.firstInput || (n.firstInput = U(t));
              o > 1 && !n.firstMultiple ? n.firstMultiple = U(t) : 1 === o && (n.firstMultiple = !1);
              var i = n.firstInput,
                a = n.firstMultiple,
                l = a ? a.center : i.center,
                u = t.center = Z(r);
              t.timeStamp = h(), t.deltaTime = t.timeStamp - i.timeStamp, t.angle = Y(l, u), t.distance = W(l, u), function (e, t) {
                var n = t.center,
                  r = e.offsetDelta || {},
                  o = e.prevDelta || {},
                  i = e.prevInput || {};
                1 !== t.eventType && 4 !== i.eventType || (o = e.prevDelta = {
                  x: i.deltaX || 0,
                  y: i.deltaY || 0
                }, r = e.offsetDelta = {
                  x: n.x,
                  y: n.y
                });
                t.deltaX = o.x + (n.x - r.x), t.deltaY = o.y + (n.y - r.y);
              }(n, t), t.offsetDirection = G(t.deltaX, t.deltaY);
              var c = $(t.deltaTime, t.deltaX, t.deltaY);
              t.overallVelocityX = c.x, t.overallVelocityY = c.y, t.overallVelocity = p(c.x) > p(c.y) ? c.x : c.y, t.scale = a ? (d = a.pointers, f = r, W(f[0], f[1], K) / W(d[0], d[1], K)) : 1, t.rotation = a ? function (e, t) {
                return Y(t[1], t[0], K) + Y(e[1], e[0], K);
              }(a.pointers, r) : 0, t.maxPointers = n.prevInput ? t.pointers.length > n.prevInput.maxPointers ? t.pointers.length : n.prevInput.maxPointers : t.pointers.length, function (e, t) {
                var n,
                  r,
                  o,
                  i,
                  a = e.lastInterval || t,
                  l = t.timeStamp - a.timeStamp;
                if (8 != t.eventType && (l > 25 || a.velocity === s)) {
                  var u = t.deltaX - a.deltaX,
                    c = t.deltaY - a.deltaY,
                    d = $(l, u, c);
                  r = d.x, o = d.y, n = p(d.x) > p(d.y) ? d.x : d.y, i = G(u, c), e.lastInterval = t;
                } else n = a.velocity, r = a.velocityX, o = a.velocityY, i = a.direction;
                t.velocity = n, t.velocityX = r, t.velocityY = o, t.direction = i;
              }(n, t);
              var d, f;
              var m = e.element;
              _(t.srcEvent.target, m) && (m = t.srcEvent.target);
              t.target = m;
            }(e, n), e.emit("hammer.input", n), e.recognize(n), e.session.prevInput = n;
          }
          function U(e) {
            for (var t = [], n = 0; n < e.pointers.length;) t[n] = {
              clientX: d(e.pointers[n].clientX),
              clientY: d(e.pointers[n].clientY)
            }, n++;
            return {
              timeStamp: h(),
              pointers: t,
              center: Z(t),
              deltaX: e.deltaX,
              deltaY: e.deltaY
            };
          }
          function Z(e) {
            var t = e.length;
            if (1 === t) return {
              x: d(e[0].clientX),
              y: d(e[0].clientY)
            };
            for (var n = 0, r = 0, o = 0; o < t;) n += e[o].clientX, r += e[o].clientY, o++;
            return {
              x: d(n / t),
              y: d(r / t)
            };
          }
          function $(e, t, n) {
            return {
              x: t / e || 0,
              y: n / e || 0
            };
          }
          function G(e, t) {
            return e === t ? 1 : p(e) >= p(t) ? e < 0 ? 2 : 4 : t < 0 ? 8 : 16;
          }
          function W(e, t, n) {
            n || (n = V);
            var r = t[n[0]] - e[n[0]],
              o = t[n[1]] - e[n[1]];
            return Math.sqrt(r * r + o * o);
          }
          function Y(e, t, n) {
            n || (n = V);
            var r = t[n[0]] - e[n[0]],
              o = t[n[1]] - e[n[1]];
            return 180 * Math.atan2(o, r) / Math.PI;
          }
          q.prototype = {
            handler: function () {},
            init: function () {
              this.evEl && S(this.element, this.evEl, this.domHandler), this.evTarget && S(this.target, this.evTarget, this.domHandler), this.evWin && S(F(this.element), this.evWin, this.domHandler);
            },
            destroy: function () {
              this.evEl && E(this.element, this.evEl, this.domHandler), this.evTarget && E(this.target, this.evTarget, this.domHandler), this.evWin && E(F(this.element), this.evWin, this.domHandler);
            }
          };
          var X = {
              mousedown: 1,
              mousemove: 2,
              mouseup: 4
            },
            Q = "mousedown",
            J = "mousemove mouseup";
          function ee() {
            this.evEl = Q, this.evWin = J, this.pressed = !1, q.apply(this, arguments);
          }
          w(ee, q, {
            handler: function (e) {
              var t = X[e.type];
              1 & t && 0 === e.button && (this.pressed = !0), 2 & t && 1 !== e.which && (t = 4), this.pressed && (4 & t && (this.pressed = !1), this.callback(this.manager, t, {
                pointers: [e],
                changedPointers: [e],
                pointerType: N,
                srcEvent: e
              }));
            }
          });
          var te = {
              pointerdown: 1,
              pointermove: 2,
              pointerup: 4,
              pointercancel: 8,
              pointerout: 8
            },
            ne = {
              2: B,
              3: "pen",
              4: N,
              5: "kinect"
            },
            re = "pointerdown",
            oe = "pointermove pointerup pointercancel";
          function ie() {
            this.evEl = re, this.evWin = oe, q.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
          }
          o.MSPointerEvent && !o.PointerEvent && (re = "MSPointerDown", oe = "MSPointerMove MSPointerUp MSPointerCancel"), w(ie, q, {
            handler: function (e) {
              var t = this.store,
                n = !1,
                r = e.type.toLowerCase().replace("ms", ""),
                o = te[r],
                i = ne[e.pointerType] || e.pointerType,
                a = i == B,
                s = A(t, e.pointerId, "pointerId");
              1 & o && (0 === e.button || a) ? (e.isPrimary && t.length > 0 && (this.store = this.manager.session.pointerEvents = []), s < 0 && (t.push(e), s = t.length - 1)) : 12 & o && (n = !0), s < 0 || (t[s] = e, this.callback(this.manager, o, {
                pointers: t,
                changedPointers: [e],
                pointerType: i,
                srcEvent: e
              }), n && t.splice(s, 1));
            }
          });
          var ae = {
              touchstart: 1,
              touchmove: 2,
              touchend: 4,
              touchcancel: 8
            },
            se = "touchstart",
            le = "touchstart touchmove touchend touchcancel";
          function ue() {
            this.evTarget = se, this.evWin = le, this.started = !1, q.apply(this, arguments);
          }
          function ce(e, t) {
            var n = z(e.touches),
              r = z(e.changedTouches);
            return 12 & t && (n = T(n.concat(r), "identifier", !0)), [n, r];
          }
          w(ue, q, {
            handler: function (e) {
              var t = ae[e.type];
              if (1 === t && (this.started = !0), this.started) {
                var n = ce.call(this, e, t);
                12 & t && n[0].length - n[1].length == 0 && (this.started = !1), this.callback(this.manager, t, {
                  pointers: n[0],
                  changedPointers: n[1],
                  pointerType: B,
                  srcEvent: e
                });
              }
            }
          });
          var de = {
              touchstart: 1,
              touchmove: 2,
              touchend: 4,
              touchcancel: 8
            },
            pe = "touchstart touchmove touchend touchcancel";
          function he() {
            this.evTarget = pe, this.targetIds = {}, q.apply(this, arguments);
          }
          function fe(e, t) {
            var n = z(e.touches),
              r = this.targetIds;
            if (3 & t && 1 === n.length) return r[n[0].identifier] = !0, [n, n];
            var o,
              i,
              a = z(e.changedTouches),
              s = [],
              l = this.target;
            if (i = n.filter(function (e) {
              return _(e.target, l);
            }), 1 === t) for (o = 0; o < i.length;) r[i[o].identifier] = !0, o++;
            for (o = 0; o < a.length;) r[a[o].identifier] && s.push(a[o]), 12 & t && delete r[a[o].identifier], o++;
            return s.length ? [T(i.concat(s), "identifier", !0), s] : void 0;
          }
          w(he, q, {
            handler: function (e) {
              var t = de[e.type],
                n = fe.call(this, e, t);
              n && this.callback(this.manager, t, {
                pointers: n[0],
                changedPointers: n[1],
                pointerType: B,
                srcEvent: e
              });
            }
          });
          function me() {
            q.apply(this, arguments);
            var e = x(this.handler, this);
            this.touch = new he(this.manager, e), this.mouse = new ee(this.manager, e), this.primaryTouch = null, this.lastTouches = [];
          }
          function ge(e, t) {
            1 & e ? (this.primaryTouch = t.changedPointers[0].identifier, ve.call(this, t)) : 12 & e && ve.call(this, t);
          }
          function ve(e) {
            var t = e.changedPointers[0];
            if (t.identifier === this.primaryTouch) {
              var n = {
                x: t.clientX,
                y: t.clientY
              };
              this.lastTouches.push(n);
              var r = this.lastTouches;
              setTimeout(function () {
                var e = r.indexOf(n);
                e > -1 && r.splice(e, 1);
              }, 2500);
            }
          }
          function ye(e) {
            for (var t = e.srcEvent.clientX, n = e.srcEvent.clientY, r = 0; r < this.lastTouches.length; r++) {
              var o = this.lastTouches[r],
                i = Math.abs(t - o.x),
                a = Math.abs(n - o.y);
              if (i <= 25 && a <= 25) return !0;
            }
            return !1;
          }
          w(me, q, {
            handler: function (e, t, n) {
              var r = n.pointerType == B,
                o = n.pointerType == N;
              if (!(o && n.sourceCapabilities && n.sourceCapabilities.firesTouchEvents)) {
                if (r) ge.call(this, t, n);else if (o && ye.call(this, n)) return;
                this.callback(e, t, n);
              }
            },
            destroy: function () {
              this.touch.destroy(), this.mouse.destroy();
            }
          });
          var be = O(c.style, "touchAction"),
            we = be !== s,
            xe = "compute",
            De = "auto",
            Ce = "manipulation",
            Se = "none",
            Ee = "pan-x",
            _e = "pan-y",
            Pe = function () {
              if (!we) return !1;
              var e = {},
                t = o.CSS && o.CSS.supports;
              return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function (n) {
                e[n] = !t || o.CSS.supports("touch-action", n);
              }), e;
            }();
          function ke(e, t) {
            this.manager = e, this.set(t);
          }
          ke.prototype = {
            set: function (e) {
              e == xe && (e = this.compute()), we && this.manager.element.style && Pe[e] && (this.manager.element.style[be] = e), this.actions = e.toLowerCase().trim();
            },
            update: function () {
              this.set(this.manager.options.touchAction);
            },
            compute: function () {
              var e = [];
              return g(this.manager.recognizers, function (t) {
                D(t.options.enable, [t]) && (e = e.concat(t.getTouchAction()));
              }), function (e) {
                if (P(e, Se)) return Se;
                var t = P(e, Ee),
                  n = P(e, _e);
                if (t && n) return Se;
                if (t || n) return t ? Ee : _e;
                if (P(e, Ce)) return Ce;
                return De;
              }(e.join(" "));
            },
            preventDefaults: function (e) {
              var t = e.srcEvent,
                n = e.offsetDirection;
              if (this.manager.session.prevented) t.preventDefault();else {
                var r = this.actions,
                  o = P(r, Se) && !Pe.none,
                  i = P(r, _e) && !Pe["pan-y"],
                  a = P(r, Ee) && !Pe["pan-x"];
                if (o) {
                  var s = 1 === e.pointers.length,
                    l = e.distance < 2,
                    u = e.deltaTime < 250;
                  if (s && l && u) return;
                }
                if (!a || !i) return o || i && 6 & n || a && n & L ? this.preventSrc(t) : void 0;
              }
            },
            preventSrc: function (e) {
              this.manager.session.prevented = !0, e.preventDefault();
            }
          };
          var Ae = 32;
          function ze(e) {
            this.options = l({}, this.defaults, e || {}), this.id = I++, this.manager = null, this.options.enable = C(this.options.enable, !0), this.state = 1, this.simultaneous = {}, this.requireFail = [];
          }
          function Te(e) {
            return 16 & e ? "cancel" : 8 & e ? "end" : 4 & e ? "move" : 2 & e ? "start" : "";
          }
          function Oe(e) {
            return 16 == e ? "down" : 8 == e ? "up" : 2 == e ? "left" : 4 == e ? "right" : "";
          }
          function Ie(e, t) {
            var n = t.manager;
            return n ? n.get(e) : e;
          }
          function Fe() {
            ze.apply(this, arguments);
          }
          function Me() {
            Fe.apply(this, arguments), this.pX = null, this.pY = null;
          }
          function Re() {
            Fe.apply(this, arguments);
          }
          function je() {
            ze.apply(this, arguments), this._timer = null, this._input = null;
          }
          function Be() {
            Fe.apply(this, arguments);
          }
          function Ne() {
            Fe.apply(this, arguments);
          }
          function Le() {
            ze.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
          }
          function Ve(e, t) {
            return (t = t || {}).recognizers = C(t.recognizers, Ve.defaults.preset), new Ke(e, t);
          }
          ze.prototype = {
            defaults: {},
            set: function (e) {
              return l(this.options, e), this.manager && this.manager.touchAction.update(), this;
            },
            recognizeWith: function (e) {
              if (m(e, "recognizeWith", this)) return this;
              var t = this.simultaneous;
              return t[(e = Ie(e, this)).id] || (t[e.id] = e, e.recognizeWith(this)), this;
            },
            dropRecognizeWith: function (e) {
              return m(e, "dropRecognizeWith", this) || (e = Ie(e, this), delete this.simultaneous[e.id]), this;
            },
            requireFailure: function (e) {
              if (m(e, "requireFailure", this)) return this;
              var t = this.requireFail;
              return -1 === A(t, e = Ie(e, this)) && (t.push(e), e.requireFailure(this)), this;
            },
            dropRequireFailure: function (e) {
              if (m(e, "dropRequireFailure", this)) return this;
              e = Ie(e, this);
              var t = A(this.requireFail, e);
              return t > -1 && this.requireFail.splice(t, 1), this;
            },
            hasRequireFailures: function () {
              return this.requireFail.length > 0;
            },
            canRecognizeWith: function (e) {
              return !!this.simultaneous[e.id];
            },
            emit: function (e) {
              var t = this,
                n = this.state;
              function r(n) {
                t.manager.emit(n, e);
              }
              n < 8 && r(t.options.event + Te(n)), r(t.options.event), e.additionalEvent && r(e.additionalEvent), n >= 8 && r(t.options.event + Te(n));
            },
            tryEmit: function (e) {
              if (this.canEmit()) return this.emit(e);
              this.state = Ae;
            },
            canEmit: function () {
              for (var e = 0; e < this.requireFail.length;) {
                if (!(33 & this.requireFail[e].state)) return !1;
                e++;
              }
              return !0;
            },
            recognize: function (e) {
              var t = l({}, e);
              if (!D(this.options.enable, [this, t])) return this.reset(), void (this.state = Ae);
              56 & this.state && (this.state = 1), this.state = this.process(t), 30 & this.state && this.tryEmit(t);
            },
            process: function (e) {},
            getTouchAction: function () {},
            reset: function () {}
          }, w(Fe, ze, {
            defaults: {
              pointers: 1
            },
            attrTest: function (e) {
              var t = this.options.pointers;
              return 0 === t || e.pointers.length === t;
            },
            process: function (e) {
              var t = this.state,
                n = e.eventType,
                r = 6 & t,
                o = this.attrTest(e);
              return r && (8 & n || !o) ? 16 | t : r || o ? 4 & n ? 8 | t : 2 & t ? 4 | t : 2 : Ae;
            }
          }), w(Me, Fe, {
            defaults: {
              event: "pan",
              threshold: 10,
              pointers: 1,
              direction: 30
            },
            getTouchAction: function () {
              var e = this.options.direction,
                t = [];
              return 6 & e && t.push(_e), e & L && t.push(Ee), t;
            },
            directionTest: function (e) {
              var t = this.options,
                n = !0,
                r = e.distance,
                o = e.direction,
                i = e.deltaX,
                a = e.deltaY;
              return o & t.direction || (6 & t.direction ? (o = 0 === i ? 1 : i < 0 ? 2 : 4, n = i != this.pX, r = Math.abs(e.deltaX)) : (o = 0 === a ? 1 : a < 0 ? 8 : 16, n = a != this.pY, r = Math.abs(e.deltaY))), e.direction = o, n && r > t.threshold && o & t.direction;
            },
            attrTest: function (e) {
              return Fe.prototype.attrTest.call(this, e) && (2 & this.state || !(2 & this.state) && this.directionTest(e));
            },
            emit: function (e) {
              this.pX = e.deltaX, this.pY = e.deltaY;
              var t = Oe(e.direction);
              t && (e.additionalEvent = this.options.event + t), this._super.emit.call(this, e);
            }
          }), w(Re, Fe, {
            defaults: {
              event: "pinch",
              threshold: 0,
              pointers: 2
            },
            getTouchAction: function () {
              return [Se];
            },
            attrTest: function (e) {
              return this._super.attrTest.call(this, e) && (Math.abs(e.scale - 1) > this.options.threshold || 2 & this.state);
            },
            emit: function (e) {
              if (1 !== e.scale) {
                var t = e.scale < 1 ? "in" : "out";
                e.additionalEvent = this.options.event + t;
              }
              this._super.emit.call(this, e);
            }
          }), w(je, ze, {
            defaults: {
              event: "press",
              pointers: 1,
              time: 251,
              threshold: 9
            },
            getTouchAction: function () {
              return [De];
            },
            process: function (e) {
              var t = this.options,
                n = e.pointers.length === t.pointers,
                r = e.distance < t.threshold,
                o = e.deltaTime > t.time;
              if (this._input = e, !r || !n || 12 & e.eventType && !o) this.reset();else if (1 & e.eventType) this.reset(), this._timer = f(function () {
                this.state = 8, this.tryEmit();
              }, t.time, this);else if (4 & e.eventType) return 8;
              return Ae;
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function (e) {
              8 === this.state && (e && 4 & e.eventType ? this.manager.emit(this.options.event + "up", e) : (this._input.timeStamp = h(), this.manager.emit(this.options.event, this._input)));
            }
          }), w(Be, Fe, {
            defaults: {
              event: "rotate",
              threshold: 0,
              pointers: 2
            },
            getTouchAction: function () {
              return [Se];
            },
            attrTest: function (e) {
              return this._super.attrTest.call(this, e) && (Math.abs(e.rotation) > this.options.threshold || 2 & this.state);
            }
          }), w(Ne, Fe, {
            defaults: {
              event: "swipe",
              threshold: 10,
              velocity: .3,
              direction: 30,
              pointers: 1
            },
            getTouchAction: function () {
              return Me.prototype.getTouchAction.call(this);
            },
            attrTest: function (e) {
              var t,
                n = this.options.direction;
              return 30 & n ? t = e.overallVelocity : 6 & n ? t = e.overallVelocityX : n & L && (t = e.overallVelocityY), this._super.attrTest.call(this, e) && n & e.offsetDirection && e.distance > this.options.threshold && e.maxPointers == this.options.pointers && p(t) > this.options.velocity && 4 & e.eventType;
            },
            emit: function (e) {
              var t = Oe(e.offsetDirection);
              t && this.manager.emit(this.options.event + t, e), this.manager.emit(this.options.event, e);
            }
          }), w(Le, ze, {
            defaults: {
              event: "tap",
              pointers: 1,
              taps: 1,
              interval: 300,
              time: 250,
              threshold: 9,
              posThreshold: 10
            },
            getTouchAction: function () {
              return [Ce];
            },
            process: function (e) {
              var t = this.options,
                n = e.pointers.length === t.pointers,
                r = e.distance < t.threshold,
                o = e.deltaTime < t.time;
              if (this.reset(), 1 & e.eventType && 0 === this.count) return this.failTimeout();
              if (r && o && n) {
                if (4 != e.eventType) return this.failTimeout();
                var i = !this.pTime || e.timeStamp - this.pTime < t.interval,
                  a = !this.pCenter || W(this.pCenter, e.center) < t.posThreshold;
                if (this.pTime = e.timeStamp, this.pCenter = e.center, a && i ? this.count += 1 : this.count = 1, this._input = e, 0 === this.count % t.taps) return this.hasRequireFailures() ? (this._timer = f(function () {
                  this.state = 8, this.tryEmit();
                }, t.interval, this), 2) : 8;
              }
              return Ae;
            },
            failTimeout: function () {
              return this._timer = f(function () {
                this.state = Ae;
              }, this.options.interval, this), Ae;
            },
            reset: function () {
              clearTimeout(this._timer);
            },
            emit: function () {
              8 == this.state && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
            }
          }), Ve.VERSION = "2.0.7", Ve.defaults = {
            domEvents: !1,
            touchAction: xe,
            enable: !0,
            inputTarget: null,
            inputClass: null,
            preset: [[Be, {
              enable: !1
            }], [Re, {
              enable: !1
            }, ["rotate"]], [Ne, {
              direction: 6
            }], [Me, {
              direction: 6
            }, ["swipe"]], [Le], [Le, {
              event: "doubletap",
              taps: 2
            }, ["tap"]], [je]],
            cssProps: {
              userSelect: "none",
              touchSelect: "none",
              touchCallout: "none",
              contentZooming: "none",
              userDrag: "none",
              tapHighlightColor: "rgba(0,0,0,0)"
            }
          };
          function Ke(e, t) {
            var n;
            this.options = l({}, Ve.defaults, t || {}), this.options.inputTarget = this.options.inputTarget || e, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = e, this.input = new ((n = this).options.inputClass || (R ? ie : j ? he : M ? me : ee))(n, H), this.touchAction = new ke(this, this.options.touchAction), qe(this, !0), g(this.options.recognizers, function (e) {
              var t = this.add(new e[0](e[1]));
              e[2] && t.recognizeWith(e[2]), e[3] && t.requireFailure(e[3]);
            }, this);
          }
          function qe(e, t) {
            var n,
              r = e.element;
            r.style && (g(e.options.cssProps, function (o, i) {
              n = O(r.style, i), t ? (e.oldCssProps[n] = r.style[n], r.style[n] = o) : r.style[n] = e.oldCssProps[n] || "";
            }), t || (e.oldCssProps = {}));
          }
          Ke.prototype = {
            set: function (e) {
              return l(this.options, e), e.touchAction && this.touchAction.update(), e.inputTarget && (this.input.destroy(), this.input.target = e.inputTarget, this.input.init()), this;
            },
            stop: function (e) {
              this.session.stopped = e ? 2 : 1;
            },
            recognize: function (e) {
              var t = this.session;
              if (!t.stopped) {
                var n;
                this.touchAction.preventDefaults(e);
                var r = this.recognizers,
                  o = t.curRecognizer;
                (!o || o && 8 & o.state) && (o = t.curRecognizer = null);
                for (var i = 0; i < r.length;) n = r[i], 2 === t.stopped || o && n != o && !n.canRecognizeWith(o) ? n.reset() : n.recognize(e), !o && 14 & n.state && (o = t.curRecognizer = n), i++;
              }
            },
            get: function (e) {
              if (e instanceof ze) return e;
              for (var t = this.recognizers, n = 0; n < t.length; n++) if (t[n].options.event == e) return t[n];
              return null;
            },
            add: function (e) {
              if (m(e, "add", this)) return this;
              var t = this.get(e.options.event);
              return t && this.remove(t), this.recognizers.push(e), e.manager = this, this.touchAction.update(), e;
            },
            remove: function (e) {
              if (m(e, "remove", this)) return this;
              if (e = this.get(e)) {
                var t = this.recognizers,
                  n = A(t, e);
                -1 !== n && (t.splice(n, 1), this.touchAction.update());
              }
              return this;
            },
            on: function (e, t) {
              if (e !== s && t !== s) {
                var n = this.handlers;
                return g(k(e), function (e) {
                  n[e] = n[e] || [], n[e].push(t);
                }), this;
              }
            },
            off: function (e, t) {
              if (e !== s) {
                var n = this.handlers;
                return g(k(e), function (e) {
                  t ? n[e] && n[e].splice(A(n[e], t), 1) : delete n[e];
                }), this;
              }
            },
            emit: function (e, t) {
              this.options.domEvents && function (e, t) {
                var n = i.createEvent("Event");
                n.initEvent(e, !0, !0), n.gesture = t, t.target.dispatchEvent(n);
              }(e, t);
              var n = this.handlers[e] && this.handlers[e].slice();
              if (n && n.length) {
                t.type = e, t.preventDefault = function () {
                  t.srcEvent.preventDefault();
                };
                for (var r = 0; r < n.length;) n[r](t), r++;
              }
            },
            destroy: function () {
              this.element && qe(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
            }
          }, l(Ve, {
            INPUT_START: 1,
            INPUT_MOVE: 2,
            INPUT_END: 4,
            INPUT_CANCEL: 8,
            STATE_POSSIBLE: 1,
            STATE_BEGAN: 2,
            STATE_CHANGED: 4,
            STATE_ENDED: 8,
            STATE_RECOGNIZED: 8,
            STATE_CANCELLED: 16,
            STATE_FAILED: Ae,
            DIRECTION_NONE: 1,
            DIRECTION_LEFT: 2,
            DIRECTION_RIGHT: 4,
            DIRECTION_UP: 8,
            DIRECTION_DOWN: 16,
            DIRECTION_HORIZONTAL: 6,
            DIRECTION_VERTICAL: L,
            DIRECTION_ALL: 30,
            Manager: Ke,
            Input: q,
            TouchAction: ke,
            TouchInput: he,
            MouseInput: ee,
            PointerEventInput: ie,
            TouchMouseInput: me,
            SingleTouchInput: ue,
            Recognizer: ze,
            AttrRecognizer: Fe,
            Tap: Le,
            Pan: Me,
            Swipe: Ne,
            Pinch: Re,
            Rotate: Be,
            Press: je,
            on: S,
            off: E,
            each: g,
            merge: b,
            extend: y,
            assign: l,
            inherit: w,
            bindFn: x,
            prefixed: O
          }), (void 0 !== o ? o : "undefined" != typeof self ? self : {}).Hammer = Ve, (r = function () {
            return Ve;
          }.call(t, n, t, e)) === s || (e.exports = r);
        }(window, document);
      },
      75866: () => {},
      66972: () => {},
      32368: () => {},
      24456: () => {},
      36216: () => {},
      32823: e => {
        "use strict";

        e.exports = JSON.parse('{"0":65533,"128":8364,"130":8218,"131":402,"132":8222,"133":8230,"134":8224,"135":8225,"136":710,"137":8240,"138":352,"139":8249,"140":338,"142":381,"145":8216,"146":8217,"147":8220,"148":8221,"149":8226,"150":8211,"151":8212,"152":732,"153":8482,"154":353,"155":8250,"156":339,"158":382,"159":376}');
      },
      88295: e => {
        "use strict";

        e.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"\'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\\"","QUOT":"\\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}');
      },
      12221: e => {
        "use strict";

        e.exports = JSON.parse('{"Aacute":"Á","aacute":"á","Acirc":"Â","acirc":"â","acute":"´","AElig":"Æ","aelig":"æ","Agrave":"À","agrave":"à","amp":"&","AMP":"&","Aring":"Å","aring":"å","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","brvbar":"¦","Ccedil":"Ç","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","COPY":"©","curren":"¤","deg":"°","divide":"÷","Eacute":"É","eacute":"é","Ecirc":"Ê","ecirc":"ê","Egrave":"È","egrave":"è","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","GT":">","Iacute":"Í","iacute":"í","Icirc":"Î","icirc":"î","iexcl":"¡","Igrave":"Ì","igrave":"ì","iquest":"¿","Iuml":"Ï","iuml":"ï","laquo":"«","lt":"<","LT":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","Ntilde":"Ñ","ntilde":"ñ","Oacute":"Ó","oacute":"ó","Ocirc":"Ô","ocirc":"ô","Ograve":"Ò","ograve":"ò","ordf":"ª","ordm":"º","Oslash":"Ø","oslash":"ø","Otilde":"Õ","otilde":"õ","Ouml":"Ö","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","QUOT":"\\"","raquo":"»","reg":"®","REG":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","THORN":"Þ","thorn":"þ","times":"×","Uacute":"Ú","uacute":"ú","Ucirc":"Û","ucirc":"û","Ugrave":"Ù","ugrave":"ù","uml":"¨","Uuml":"Ü","uuml":"ü","Yacute":"Ý","yacute":"ý","yen":"¥","yuml":"ÿ"}');
      },
      88016: e => {
        "use strict";

        e.exports = JSON.parse('{"amp":"&","apos":"\'","gt":">","lt":"<","quot":"\\""}');
      }
    },
    i = {};
  function a(e) {
    var t = i[e];
    if (void 0 !== t) return t.exports;
    var n = i[e] = {
      id: e,
      loaded: !1,
      exports: {}
    };
    return o[e].call(n.exports, n, n.exports, a), n.loaded = !0, n.exports;
  }
  return a.m = o, a.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return a.d(t, {
      a: t
    }), t;
  }, t = Object.getPrototypeOf ? e => Object.getPrototypeOf(e) : e => e.__proto__, a.t = function (n, r) {
    if (1 & r && (n = this(n)), 8 & r) return n;
    if ("object" == typeof n && n) {
      if (4 & r && n.__esModule) return n;
      if (16 & r && "function" == typeof n.then) return n;
    }
    var o = Object.create(null);
    a.r(o);
    var i = {};
    e = e || [null, t({}), t([]), t(t)];
    for (var s = 2 & r && n; "object" == typeof s && !~e.indexOf(s); s = t(s)) Object.getOwnPropertyNames(s).forEach(e => i[e] = () => n[e]);
    return i.default = () => n, a.d(o, i), o;
  }, a.d = (e, t) => {
    for (var n in t) a.o(t, n) && !a.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, a.f = {}, a.e = e => Promise.all(Object.keys(a.f).reduce((t, n) => (a.f[n](e, t), t), [])), a.u = e => 4098 === e ? "pspdfkit-lib/core-worker.js" : 2999 === e ? "pspdfkit-lib/gdpicture-worker.js" : "pspdfkit-lib/chunk-" + {
    157: "locale-hr",
    407: "locale-tr",
    473: "locale-es",
    517: "locale-pt",
    752: "localedata-da",
    1009: "locale-de",
    1063: "localedata-th",
    1077: "localedata-sk",
    1089: "localedata-ko",
    1139: "locale-da",
    1145: "localedata-fr",
    1168: "locale-ko",
    1252: "localedata-es",
    1277: "localedata-sl",
    1305: "gdpicture",
    1323: "locale-el",
    1385: "localedata-ru",
    1391: "locale-ms",
    1517: "lazy-sha",
    1518: "localedata-ms",
    1843: "localedata-uk",
    1874: "locale-en",
    1882: "localedata-el",
    1945: "gdpicture-worker",
    2279: "localedata-nb",
    2333: "server-instant",
    2727: "localedata-sv",
    2916: "locale-fr-CA",
    3005: "localedata-cs",
    3095: "locale-uk",
    3360: "locale-fr",
    3424: "localedata-it",
    3463: "locale-ja",
    3579: "locale-cs",
    3610: "standalone",
    4072: "localedata-zh",
    4099: "server-rest",
    4132: "core-worker",
    4267: "standalone-server",
    4572: "lazy-de",
    4728: "localedata-ja",
    4899: "locale-pl",
    4932: "localedata-pt",
    4966: "locale-nb-NO",
    5014: "localedata-en",
    5192: "localedata-id",
    5431: "locale-pt-PT",
    5528: "localedata-fi",
    5595: "locale-sl",
    5666: "locale-th",
    5677: "locale-nl",
    6045: "locale-en-GB",
    6377: "server",
    6523: "localedata-pl",
    6530: "locale-sv",
    6678: "locale-zh-Hans",
    7050: "localedata-cy",
    7578: "locale-cy",
    7579: "locale-zh-Hant",
    8057: "locale-ru",
    8839: "locale-it",
    8869: "localedata-de",
    9384: "localedata-tr",
    9390: "locale-fi",
    9486: "localedata-nl",
    9677: "localedata-hr",
    9726: "locale-id",
    9971: "locale-sk"
  }[e] + "-" + {
    157: "e44681c91c0fea8a",
    407: "e1c93a77f6076a64",
    473: "913e7c17793cfe2b",
    517: "92928a8c700ecd6c",
    752: "e7f9f75ee73a3ed2",
    1009: "c16889559cca08a1",
    1063: "956ed7f41848c3e0",
    1077: "9549a3dc2d967c66",
    1089: "e9dcad32d6bed720",
    1139: "e49c28f774c0e044",
    1145: "c02333d16934713c",
    1168: "29ec1a12efde7087",
    1252: "9e89c4f00ed22dac",
    1277: "feeac4d5c42dcf84",
    1305: "d508ab1863164d38",
    1323: "691c16b8be393215",
    1385: "9b5119b59b7e8098",
    1391: "5a03a4e9cf552733",
    1517: "d1ad8b784993fc0c",
    1518: "1e1fe86f02598bfe",
    1843: "063d7b7c4aa1248f",
    1874: "9dbbe420f4da8bc1",
    1882: "3581cb11cc5187f8",
    1945: "ff7c818c4297f916",
    2279: "55073be780a0c629",
    2333: "7962957e35878ddb",
    2727: "972ba9b12b1079cf",
    2916: "5593bf38b8dd0677",
    3005: "53d52aa487324264",
    3095: "c9e49e31d2c9b801",
    3360: "b2f08fe26b269f03",
    3424: "136ed1f40eacc2c2",
    3463: "830b2d542c65a897",
    3579: "c625fe2328cd5270",
    3610: "eb86593e63798bbb",
    4072: "06a49d1ed7434b28",
    4099: "95f65c2d0360d302",
    4132: "5fd24cef6a6c37cc",
    4267: "393df36bb04223ad",
    4572: "052c3f11833fc704",
    4728: "8d7775eb707567ca",
    4899: "57a58bb03126d3f2",
    4932: "8e73840e749425df",
    4966: "64349a3f2c091819",
    5014: "4ba3960aece8983a",
    5192: "0e19632bc514b802",
    5431: "12561a6bd079ae7d",
    5528: "ff3a26c2e1e7c3e6",
    5595: "5f80a4e345b5238b",
    5666: "06c5dae111f4de55",
    5677: "f8f88a1135026156",
    6045: "670cb2a7d3d1f7af",
    6377: "8acba6eca7436b99",
    6523: "9aa2405f7fd07c5b",
    6530: "8a786406392a540d",
    6678: "916824a7b2b61923",
    7050: "e9d0802a6f93d6f3",
    7578: "e4528c998297ac26",
    7579: "1e4c79be84ee3431",
    8057: "d62f5d1ae4b97ae7",
    8839: "dfa6f08e21a05809",
    8869: "994e4f218bd09ce7",
    9384: "8f86fdccce0e1512",
    9390: "2891924076eccf6c",
    9486: "3d45e547ed17b610",
    9677: "9f2b978051bb7fee",
    9726: "ffd307a8aadea4fd",
    9971: "de9a5329a4184156"
  }[e] + ".js", a.miniCssF = e => {}, a.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), a.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n = {}, r = "PSPDFKit:", a.l = (e, t, o, i) => {
    if (n[e]) n[e].push(t);else {
      var s, l;
      if (void 0 !== o) for (var u = document.getElementsByTagName("script"), c = 0; c < u.length; c++) {
        var d = u[c];
        if (d.getAttribute("src") == e || d.getAttribute("data-webpack") == r + o) {
          s = d;
          break;
        }
      }
      s || (l = !0, (s = document.createElement("script")).charset = "utf-8", s.timeout = 120, a.nc && s.setAttribute("nonce", a.nc), s.setAttribute("data-webpack", r + o), s.src = e), n[e] = [t];
      var p = (t, r) => {
          s.onerror = s.onload = null, clearTimeout(h);
          var o = n[e];
          if (delete n[e], s.parentNode && s.parentNode.removeChild(s), o && o.forEach(e => e(r)), t) return t(r);
        },
        h = setTimeout(p.bind(null, void 0, {
          type: "timeout",
          target: s
        }), 12e4);
      s.onerror = p.bind(null, s.onerror), s.onload = p.bind(null, s.onload), l && document.head.appendChild(s);
    }
  }, a.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, a.nmd = e => (e.paths = [], e.children || (e.children = []), e), a.p = "", (() => {
    a.b = document.baseURI || self.location.href;
    var e = {
      1026: 0
    };
    a.f.j = (t, n) => {
      var r = a.o(e, t) ? e[t] : void 0;
      if (0 !== r) if (r) n.push(r[2]);else {
        var o = new Promise((n, o) => r = e[t] = [n, o]);
        n.push(r[2] = o);
        var i = a.p + a.u(t),
          s = new Error();
        a.l(i, n => {
          if (a.o(e, t) && (0 !== (r = e[t]) && (e[t] = void 0), r)) {
            var o = n && ("load" === n.type ? "missing" : n.type),
              i = n && n.target && n.target.src;
            s.message = "Loading chunk " + t + " failed.\n(" + o + ": " + i + ")", s.name = "ChunkLoadError", s.type = o, s.request = i, r[1](s);
          }
        }, "chunk-" + t, t);
      }
    };
    var t = (t, n) => {
        var r,
          o,
          [i, s, l] = n,
          u = 0;
        if (i.some(t => 0 !== e[t])) {
          for (r in s) a.o(s, r) && (a.m[r] = s[r]);
          if (l) l(a);
        }
        for (t && t(n); u < i.length; u++) o = i[u], a.o(e, o) && e[o] && e[o][0](), e[o] = 0;
      },
      n = self.webpackChunkPSPDFKit = self.webpackChunkPSPDFKit || [];
    n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n));
  })(), a.nc = void 0, a(88221);
})());